(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9af"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9af"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("feAbh", function(module, exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

});

var $dc57b31f1b066f38$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $dc57b31f1b066f38$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $dc57b31f1b066f38$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $dc57b31f1b066f38$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


/**
 * A logger. Should be used as a singleton
 */ class $e3a50e4e91516a58$export$efa9a398d6368992 {
    /**
     *
     * @param debug {boolean} If false, this logger will not log debug messages
     */ constructor(debug){
        this.setDebug(debug);
    }
    /**
     *
     * @param debug {boolean} If false, this logger will not log debug messages
     */ setDebug(debug) {
        this.onDebug = debug;
    }
    /**
     * Is this logger on debug?
     * @returns {boolean}
     */ isOnDebug() {
        return this.onDebug;
    }
    /**
     * Log a debug message
     * @param msg {string} The message to log
     * @param obj {*} An object to log. Will not be converted to string, so the browser will pretty print it
     */ logDebug(msg, obj) {
        if (this.onDebug) this._log("DEBUG", msg, obj);
    }
    /**
     * Log an info message
     * @param msg {string} The message to log
     * @param obj {*} An object to log. Will not be converted to string, so the browser will pretty print it
     */ logInfo(msg, obj) {
        this._log("INFO", msg, obj);
    }
    /**
     * Log an error message
     * @param msg {string} The message to log
     * @param obj {*} An object to log. Will not be converted to string, so the browser will pretty print it
     */ logError(msg, obj) {
        if (this.onDebug) this._log("ERROR", msg, obj);
        else this._log("ERROR", msg);
    }
    _log(level, msg, obj) {
        const d = new Date();
        const dateString = d.getFullYear() + "-" + (d.getMonth() + 1).pad(2) + "-" + d.getDate().pad(2) + " " + d.getHours().pad(2) + ":" + d.getMinutes().pad(2) + ":" + d.getSeconds().pad(2) + '.' + d.getMilliseconds();
        const logStr = '[' + dateString + ']\t[' + level + ']\t';
        if (obj) console.log(logStr + '------------------------------------');
        if (msg) console.log(logStr + msg);
        if (obj) {
            console.log(obj);
            console.log(logStr + '------------------------------------');
        }
    }
}





const $8d2aed6d010d8d10$export$1cd1943b3a73bbe8 = -1;
const $8d2aed6d010d8d10$export$a44b4f3d5b73db95 = 0;
const $8d2aed6d010d8d10$export$b119f07080a207ba = 1;
const $8d2aed6d010d8d10$export$8b8a958a7f6f130c = 2;
const $8d2aed6d010d8d10$export$501a7fac1df67a49 = 3;
const $8d2aed6d010d8d10$export$cd2b220b1ea851b2 = 4;
const $8d2aed6d010d8d10$export$ce970371e0e850bc = 5;
const $8d2aed6d010d8d10$export$5e8f180ef0142226 = 6;
const $8d2aed6d010d8d10$export$103bedf43ba882db = 7;
const $8d2aed6d010d8d10$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


const $1749f57610258cc2$var$env = typeof self === 'object' ? self : globalThis;
const $1749f57610258cc2$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $8d2aed6d010d8d10$export$a44b4f3d5b73db95:
            case 0, $8d2aed6d010d8d10$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $8d2aed6d010d8d10$export$b119f07080a207ba:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $8d2aed6d010d8d10$export$8b8a958a7f6f130c:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $8d2aed6d010d8d10$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $8d2aed6d010d8d10$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $8d2aed6d010d8d10$export$ce970371e0e850bc:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $8d2aed6d010d8d10$export$5e8f180ef0142226:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $8d2aed6d010d8d10$export$103bedf43ba882db:
                {
                    const { name: name, message: message } = value;
                    return as(new $1749f57610258cc2$var$env[name](message), index);
                }
            case 0, $8d2aed6d010d8d10$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case 'BigInt':
                return as(Object(BigInt(value)), index);
            case 'ArrayBuffer':
                return as(new Uint8Array(value).buffer, value);
            case 'DataView':
                {
                    const { buffer: buffer } = new Uint8Array(value);
                    return as(new DataView(buffer), value);
                }
        }
        return as(new $1749f57610258cc2$var$env[type](value), index);
    };
    return unpair;
};
const $1749f57610258cc2$export$efcd34ab6248d3cd = (serialized)=>$1749f57610258cc2$var$deserializer(new Map, serialized)(0);



const $62e98443bb5b02c3$var$EMPTY = '';
const { toString: $62e98443bb5b02c3$var$toString } = {};
const { keys: $62e98443bb5b02c3$var$keys } = Object;
const $62e98443bb5b02c3$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== 'object' || !value) return [
        (0, $8d2aed6d010d8d10$export$a44b4f3d5b73db95),
        type
    ];
    const asString = $62e98443bb5b02c3$var$toString.call(value).slice(8, -1);
    switch(asString){
        case 'Array':
            return [
                (0, $8d2aed6d010d8d10$export$b119f07080a207ba),
                $62e98443bb5b02c3$var$EMPTY
            ];
        case 'Object':
            return [
                (0, $8d2aed6d010d8d10$export$8b8a958a7f6f130c),
                $62e98443bb5b02c3$var$EMPTY
            ];
        case 'Date':
            return [
                (0, $8d2aed6d010d8d10$export$501a7fac1df67a49),
                $62e98443bb5b02c3$var$EMPTY
            ];
        case 'RegExp':
            return [
                (0, $8d2aed6d010d8d10$export$cd2b220b1ea851b2),
                $62e98443bb5b02c3$var$EMPTY
            ];
        case 'Map':
            return [
                (0, $8d2aed6d010d8d10$export$ce970371e0e850bc),
                $62e98443bb5b02c3$var$EMPTY
            ];
        case 'Set':
            return [
                (0, $8d2aed6d010d8d10$export$5e8f180ef0142226),
                $62e98443bb5b02c3$var$EMPTY
            ];
        case 'DataView':
            return [
                (0, $8d2aed6d010d8d10$export$b119f07080a207ba),
                asString
            ];
    }
    if (asString.includes('Array')) return [
        (0, $8d2aed6d010d8d10$export$b119f07080a207ba),
        asString
    ];
    if (asString.includes('Error')) return [
        (0, $8d2aed6d010d8d10$export$103bedf43ba882db),
        asString
    ];
    return [
        (0, $8d2aed6d010d8d10$export$8b8a958a7f6f130c),
        asString
    ];
};
const $62e98443bb5b02c3$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $8d2aed6d010d8d10$export$a44b4f3d5b73db95) && (type === 'function' || type === 'symbol');
const $62e98443bb5b02c3$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $62e98443bb5b02c3$var$typeOf(value);
        switch(TYPE){
            case 0, $8d2aed6d010d8d10$export$a44b4f3d5b73db95:
                {
                    let entry = value;
                    switch(type){
                        case 'bigint':
                            TYPE = (0, $8d2aed6d010d8d10$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case 'function':
                        case 'symbol':
                            if (strict) throw new TypeError('unable to serialize ' + type);
                            entry = null;
                            break;
                        case 'undefined':
                            return as([
                                (0, $8d2aed6d010d8d10$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $8d2aed6d010d8d10$export$b119f07080a207ba:
                {
                    if (type) {
                        let spread = value;
                        if (type === 'DataView') spread = new Uint8Array(value.buffer);
                        else if (type === 'ArrayBuffer') spread = new Uint8Array(value);
                        return as([
                            type,
                            [
                                ...spread
                            ]
                        ], value);
                    }
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $8d2aed6d010d8d10$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case 'BigInt':
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case 'Boolean':
                        case 'Number':
                        case 'String':
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && 'toJSON' in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $62e98443bb5b02c3$var$keys(value))if (strict || !$62e98443bb5b02c3$var$shouldSkip($62e98443bb5b02c3$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $8d2aed6d010d8d10$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    value.toISOString()
                ], value);
            case 0, $8d2aed6d010d8d10$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $8d2aed6d010d8d10$export$ce970371e0e850bc:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($62e98443bb5b02c3$var$shouldSkip($62e98443bb5b02c3$var$typeOf(key)) || $62e98443bb5b02c3$var$shouldSkip($62e98443bb5b02c3$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $8d2aed6d010d8d10$export$5e8f180ef0142226:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$62e98443bb5b02c3$var$shouldSkip($62e98443bb5b02c3$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $62e98443bb5b02c3$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $62e98443bb5b02c3$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $ffdf5dc8ec6dded2$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ('json' in options || 'lossy' in options) ? (0, $1749f57610258cc2$export$efcd34ab6248d3cd)((0, $62e98443bb5b02c3$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any) : (any, options)=>(0, $1749f57610258cc2$export$efcd34ab6248d3cd)((0, $62e98443bb5b02c3$export$dfdc1655ccc5b9cb)(any, options));



Number.prototype.pad = function(size) {
    let s = String(this);
    while(s.length < (size || 2))s = "0" + s;
    return s;
};
/**
 * Is the given value a string?
 * @param obj {*} The given value
 * @return {boolean} true if it is
 */ function $2536f84a954bf107$export$844ec244b1367d54(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
}
/**
 * Is the given value a function?
 * @param obj {*} The given value
 * @return {boolean}
 */ function $2536f84a954bf107$export$f6e2535fb5126e54(obj) {
    return Object.prototype.toString.call(obj) === '[object Function]';
}
/**
 * Validate an email address with a regular expression
 * @param email {string}
 * @return {boolean}
 */ function $2536f84a954bf107$export$18148d12c805c5b0(email) {
    return !!String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
}
/**
 * Given a URL return the same without the last directory
 * @param url {string}
 * @param includeParams {boolean}
 * @return {string}
 */ function $2536f84a954bf107$export$c4f4b3edcd35a2ed(url, includeParams = false) {
    const split = url.split('?');
    const hasParams = split.length > 1;
    const dirPart = split[0];
    const arr = dirPart.split('/');
    if (dirPart.endsWith('/')) arr.pop();
    arr.pop();
    return arr.join('/') + (includeParams ? '?' + (hasParams ? split[1] : '') : '');
}
/**
 * Remove tags form a string
 * @param txt {string}
 * @return {string}
 */ function $2536f84a954bf107$export$1fbf6f199c05a66(txt) {
    if (!txt || txt.length === 0) return txt;
    return $dc57b31f1b066f38$exports("<div><div/>").html(txt).text();
}
function $2536f84a954bf107$export$289ff81b113b8d91(message) {
    message = $2536f84a954bf107$export$51c197c9b00a6c1c(message);
    if (!message) return;
    const urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return message.replace(urlRegex, function(url) {
        let hyperlink = url;
        if (!hyperlink.match('^https?:\/\/')) hyperlink = 'http://' + hyperlink;
        return '<a href="' + hyperlink + '" target="_blank">' + url + '</a>';
    });
}
String.prototype.includesIgnoringSpecial = function(what) {
    const trimmedWat = $2536f84a954bf107$export$51c197c9b00a6c1c(what);
    if (!trimmedWat) return false;
    const normalize = (toNormalize)=>toNormalize.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    const normalized = normalize(String(this).toLowerCase());
    const normalizedWhat = normalize(trimmedWat.toLowerCase());
    return normalized.includes(normalizedWhat);
};
function $2536f84a954bf107$export$51c197c9b00a6c1c(obj, orElse) {
    const trimmed = obj !== undefined && obj !== null ? obj.toString().trim() : undefined;
    return trimmed && trimmed.length > 0 ? trimmed : orElse !== undefined && orElse !== null ? $2536f84a954bf107$export$f6e2535fb5126e54(orElse) ? orElse() : orElse : orElse;
}
String.prototype.crop = function(size) {
    return (this.length <= size ? this : this.substring(0, size - 3) + '...').toString();
};
String.prototype.format = function() {
    const args = arguments;
    return this.replace(/\{(\d+)\}/g, function(a) {
        return args[0][parseInt(a.match(/(\d+)/g))];
    });
};
Number.prototype.round = function(decimals = 0) {
    decimals = Math.round(decimals);
    const upDown = Math.pow(10, decimals);
    return Math.round((this + Number.EPSILON) * upDown) / upDown;
};
/**
 * Format a number
 * @param number {number} The number to format
 * @param decimals {number} integer, the nr of decimals
 * @param unit {string} The unit to append to the formatted nr (can be undefined)
 * @return {string} The formatted nr
 */ function $2536f84a954bf107$export$f5dd818bff069720(number, decimals = 0, unit) {
    return $2536f84a954bf107$export$7e4aa119212bc614(number) ? number.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }) + (unit ? ' ' + unit : '') : '--';
}
/**
 * String to number
 * @param str {string}
 * @return {number|*}
 */ function $2536f84a954bf107$export$a0a81dc3380ce7d3(str) {
    return $2536f84a954bf107$export$7e4aa119212bc614(str) ? str : str !== null && str !== undefined ? Number(str) : str;
}
/**
 * Is the given value a number?
 * @param value {*} The given value
 * @return {boolean} true if it is
 */ function $2536f84a954bf107$export$7e4aa119212bc614(value) {
    return value !== null && value !== undefined && typeof value === 'number' && isFinite(value);
}
/**
 * Is the given value a boolean?
 * @param value {*} The given value
 * @return {boolean|undefined|null} true if it is, false if isn't, undefined if undefined, null if null
 */ function $2536f84a954bf107$export$f9ce7b637dfbe238(value) {
    if (value === undefined || value === null) return value;
    return value === true || value === false;
}
/**
 * get a random nr from the given interval
 * @param min {number}
 * @param max {number}
 * @return {number}
 */ function $2536f84a954bf107$export$eab19c48dcb6310d(min, max) {
    return Math.random() * (max - min) + min;
}
/**
 * get a random integer from the given interval
 * @param min {number} (integer)
 * @param max {number} (integer)
 * @return {number} (integer)
 */ function $2536f84a954bf107$export$a0151d75660c2768(min, max) {
    return Math.round(Math.random() * (max - min) + min);
}
/**
 * get a random string from the given array
 * @param strings {Array<string>}
 * @return {string}
 */ function $2536f84a954bf107$export$54fc09822f327121(strings) {
    return strings[$2536f84a954bf107$export$a0151d75660c2768(0, strings.length - 1)];
}
/**
 * Clone an object or array
 * @param obj {any}
 * @return {any}
 */ function $2536f84a954bf107$export$9cd59f9826255e47(obj) {
    return (0, $ffdf5dc8ec6dded2$export$2e2bcd8739ae039)(obj);
}
/**
 * Prefix a URL if needed
 * @param prefix {string}
 * @param url {string}
 */ function $2536f84a954bf107$export$730687a846e4e808(url, prefix = tumbo.serviceUrlPrefix) {
    prefix = $2536f84a954bf107$export$51c197c9b00a6c1c(prefix);
    url = $2536f84a954bf107$export$51c197c9b00a6c1c(url);
    if (!prefix || !url) return url;
    const fixedPrefix = (prefix.indexOf("http") === 0 ? '' : '//') + prefix;
    return (url.indexOf('//') === 0 || url.indexOf('http://') === 0 || url.indexOf('https://') === 0 ? url : fixedPrefix + (url && url.indexOf("/") === 0 ? '' : '/') + url).replace('////', '//');
}
/**
 * Download from a URL, without window navigation
 * @param url {string} The URL to download from
 * @param newTab {boolean} if true, a new tab is opened for the download
 * @param name {string} The name of the file to prefill the download dialog
 */ function $2536f84a954bf107$export$70d8d65744cc52bb(url, newTab = false, name) {
    const a = document.createElement('A');
    a.style = 'display:none;';
    a.href = url;
    if (newTab) a.target = '_blank';
    if (name) a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
/**
 * Download an image from a URL, without window navigation
 * @param url {string} The URL to download from
 * @param name {string} The name of the file to prefill the download dialog
 */ async function $2536f84a954bf107$export$bc7d78b5435c51d4(url, name) {
    const image = await fetch(url);
    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const a = document.createElement('A');
    a.style = 'display:none;';
    a.href = imageURL;
    if (name) a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}
/**
 * Given a sorted array of numbers, calculate a given quantile
 * @param sortedArray {Array<number>} The sorted asc array
 * @param q {number} The quantile to calculate [0..1]
 * @return {number}
 */ function $2536f84a954bf107$export$651fb4afdb6caa4b(sortedArray, q) {
    const pos = (sortedArray.length - 1) * q;
    const base = Math.floor(pos);
    const rest = pos - base;
    if (sortedArray[base + 1] !== undefined) return sortedArray[base] + rest * (sortedArray[base + 1] - sortedArray[base]);
    else return sortedArray[base];
}
/**
 * Calculate the mean of an array of numbers
 * @param array {Array<number>}
 * @return {number}
 */ function $2536f84a954bf107$export$1ce691f85baaa52(array) {
    return array.reduce((sum, current)=>sum + current) / array.length;
}
/**
 * The variance of an array of numbers
 * @param values {Array<number>}
 * @return {number}
 */ function $2536f84a954bf107$export$9b77da0927470c3d(values) {
    const average = $2536f84a954bf107$export$1ce691f85baaa52(values);
    const squareDiffs = values.map((value)=>Math.pow(value - average, 2));
    return $2536f84a954bf107$export$1ce691f85baaa52(squareDiffs);
}
/**
 * The standard deviation of an array of numbers
 * @param values {Array<number>}
 * @return {number}
 */ function $2536f84a954bf107$export$1cb78577db373fdf(values) {
    return Math.sqrt($2536f84a954bf107$export$9b77da0927470c3d(values));
}
function $2536f84a954bf107$export$dda5fc2d183b5cbd(from, to) {
    return [
        ...Array(to - from + 1).keys()
    ].map((v)=>v + from);
}
function $2536f84a954bf107$export$ce275da88d3dcc54(arr) {
    return arr ? arr[arr.length - 1] : undefined;
}


/**
 * Any enum
 */ class $815c91046e476159$export$deb82508dd66d288 {
    /**
     *
     * @param code {Number|String} A unique code that identifies the enum value
     */ constructor(code){
        this.code = code;
    }
    getCode() {
        return this.code;
    }
    static _getForCode(enumClass, code) {
        code = (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(code);
        if (!code) return undefined;
        const entries = Object.entries(enumClass);
        for(let e in entries){
            let entry = entries[e];
            if ((0, $2536f84a954bf107$export$51c197c9b00a6c1c)(entry[1].code) === code) return entry[1];
        }
        return undefined;
    }
    static _exists(enumClass, code) {
        return this._getForCode(enumClass, code) !== undefined;
    }
    static _getPossibleCodes(enumClass) {
        let res = [];
        const possible = this._getPossibleValues(enumClass);
        for(let p in possible)res.push(possible[p].getCode());
        return res;
    }
    static _getPossibleValues(enumClass) {
        let res = [];
        const entries = Object.entries(enumClass);
        for(let e in entries){
            let entry = entries[e];
            res.push(entry[1]);
        }
        return res;
    }
}
/**
 * An enum with a localized name
 * @extends Enum
 */ class $815c91046e476159$export$8274ff96982f5711 extends $815c91046e476159$export$deb82508dd66d288 {
    /**
     * @param code {Number|String} A unique code that identifies the enum value
     * @param localizationKey {string} the key for the localized name of the enum value
     */ constructor(code, localizationKey){
        super(code);
        this.localizationKey = localizationKey;
    }
    getLocalizedName(translator) {
        return translator.translate(this.localizationKey);
    }
    getLocalizationKey() {
        return this.localizationKey;
    }
}
/**
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$9ae7e512bcbacef8 extends $815c91046e476159$export$deb82508dd66d288 {
    /**
     * Classifiers hold children that can be layers or other classifiers
     * @type {LayerGroupTypeEnum}
     */ static CLASSIFIER = new $815c91046e476159$export$9ae7e512bcbacef8('CLASSIFIER');
    /**
     * Layers do not hold children and are leafs in the tree
     * @type {LayerGroupTypeEnum}
     */ static LAYER = new $815c91046e476159$export$9ae7e512bcbacef8('LAYER');
    static getForCode(code) {
        return $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$9ae7e512bcbacef8, code);
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$9ae7e512bcbacef8, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$9ae7e512bcbacef8);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$9ae7e512bcbacef8);
    }
}
/**
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$76bf88ec17fef043 extends $815c91046e476159$export$deb82508dd66d288 {
    /**
     * Layer based on raster (imagery) data
     * @type {LayerTypeEnum}
     */ static RASTER = new $815c91046e476159$export$76bf88ec17fef043('RASTER');
    /**
     * Layer based on vector (geometry plus metadata) data
     * @type {LayerTypeEnum}
     */ static VECTOR = new $815c91046e476159$export$76bf88ec17fef043('VECTOR');
    static getForCode(code) {
        const forCode = $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$76bf88ec17fef043, code);
        return forCode || this.RASTER;
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$76bf88ec17fef043, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$76bf88ec17fef043);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$76bf88ec17fef043);
    }
}
/**
 * Layer data retrieval protocol
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$fb21469bf9823c9b extends $815c91046e476159$export$deb82508dd66d288 {
    /**
     *
     * @type {ProtocolEnum}
     */ static WMS = new $815c91046e476159$export$fb21469bf9823c9b('WMS');
    /**
     *
     * @type {ProtocolEnum}
     */ static WMS_SINGLE_IMAGE = new $815c91046e476159$export$fb21469bf9823c9b('WMS_SINGLE_IMAGE');
    /**
     *
     * @type {ProtocolEnum}
     */ static WFS = new $815c91046e476159$export$fb21469bf9823c9b('WFS');
    static getForCode(code) {
        return $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$fb21469bf9823c9b, code);
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$fb21469bf9823c9b, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$fb21469bf9823c9b);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$fb21469bf9823c9b);
    }
}
/**
 * Possible periodicities for indicator layers
 * @extends LocalizedEnum
 * @hideconstructor
 */ class $815c91046e476159$export$45470b399d15bbcb extends $815c91046e476159$export$8274ff96982f5711 {
    /**
     *
     * @type {PeriodicityEnum}
     */ static LATEST = new $815c91046e476159$export$45470b399d15bbcb('l', 'enum.periodicity.l');
    /**
     *
     * @type {PeriodicityEnum}
     */ static YEARLY = new $815c91046e476159$export$45470b399d15bbcb('y', 'enum.periodicity.y');
    /**
     *
     * @type {PeriodicityEnum}
     */ static MONTHLY = new $815c91046e476159$export$45470b399d15bbcb('m', 'enum.periodicity.m');
    /**
     *
     * @type {PeriodicityEnum}
     */ static MONTHLY_FORECAST = new $815c91046e476159$export$45470b399d15bbcb('f', 'enum.periodicity.f');
    /**
     *
     * @type {PeriodicityEnum}
     */ static MONTHLY_UPDATED_TEN_DAILY = new $815c91046e476159$export$45470b399d15bbcb('n', 'enum.periodicity.n');
    /**
     *
     * @type {PeriodicityEnum}
     */ static TEN_DAILY = new $815c91046e476159$export$45470b399d15bbcb('t', 'enum.periodicity.t');
    /**
     *
     * @type {PeriodicityEnum}
     */ static TEN_DAILY_YEARLESS = new $815c91046e476159$export$45470b399d15bbcb('u', 'enum.periodicity.tny');
    /**
     *
     * @type {PeriodicityEnum}
     */ static TEN_DAILY_YEARLESS_30DAY = new $815c91046e476159$export$45470b399d15bbcb('o', 'enum.periodicity.tny30day');
    /**
     *
     * @type {PeriodicityEnum}
     */ static DAILY_YEARLESS = new $815c91046e476159$export$45470b399d15bbcb('e', 'enum.periodicity.dy');
    /**
     *
     * @type {PeriodicityEnum}
     */ static WEEKLY = new $815c91046e476159$export$45470b399d15bbcb('w', 'enum.periodicity.w');
    /**
     *
     * @type {PeriodicityEnum}
     */ static ISO_WEEKLY = new $815c91046e476159$export$45470b399d15bbcb('i', 'enum.periodicity.i');
    /**
     *
     * @type {PeriodicityEnum}
     */ static DAILY = new $815c91046e476159$export$45470b399d15bbcb('d', 'enum.periodicity.d');
    /**
     *
     * @type {PeriodicityEnum}
     */ static CUSTOM = new $815c91046e476159$export$45470b399d15bbcb('c', 'enum.periodicity.c');
    static getForCode(code) {
        return $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$45470b399d15bbcb, code);
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$45470b399d15bbcb, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$45470b399d15bbcb);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$45470b399d15bbcb);
    }
}
/**
 * @extends LocalizedEnum
 * @hideconstructor
 */ class $815c91046e476159$export$d08fec65c77806fd extends $815c91046e476159$export$8274ff96982f5711 {
    /**
     * 1 month
     * @type {TimeScaleEnum}
     */ static _1 = new $815c91046e476159$export$d08fec65c77806fd('01', 'enum.timescale.01');
    /**
     * 3 months
     * @type {TimeScaleEnum}
     */ static _3 = new $815c91046e476159$export$d08fec65c77806fd('03', 'enum.timescale.03');
    /**
     * 6 months
     * @type {TimeScaleEnum}
     */ static _6 = new $815c91046e476159$export$d08fec65c77806fd('06', 'enum.timescale.06');
    /**
     * 9 months
     * @type {TimeScaleEnum}
     */ static _9 = new $815c91046e476159$export$d08fec65c77806fd('09', 'enum.timescale.09');
    /**
     * 12 months
     * @type {TimeScaleEnum}
     */ static _12 = new $815c91046e476159$export$d08fec65c77806fd('12', 'enum.timescale.12');
    /**
     * 24 months
     * @type {TimeScaleEnum}
     */ static _24 = new $815c91046e476159$export$d08fec65c77806fd('24', 'enum.timescale.24');
    /**
     * 48 months
     * @type {TimeScaleEnum}
     */ static _48 = new $815c91046e476159$export$d08fec65c77806fd('48', 'enum.timescale.48');
    static getForCode(code) {
        const forCode = $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$d08fec65c77806fd, code);
        return forCode || this._3;
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$d08fec65c77806fd, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$d08fec65c77806fd);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$d08fec65c77806fd);
    }
}
/**
 * Type of device on which a layer/tool should be visible
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$54c4fd5984b65e0b extends $815c91046e476159$export$deb82508dd66d288 {
    /**
     *
     * @type {DeviceVisibilityEnum}
     */ static DESKTOP = new $815c91046e476159$export$54c4fd5984b65e0b('DESKTOP');
    /**
     *
     * @type {DeviceVisibilityEnum}
     */ static MOBILE = new $815c91046e476159$export$54c4fd5984b65e0b('MOBILE');
    /**
     *
     * @type {DeviceVisibilityEnum}
     */ static BOTH = new $815c91046e476159$export$54c4fd5984b65e0b('BOTH');
    static getForCode(code) {
        const forCode = $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$54c4fd5984b65e0b, code);
        return forCode || this.BOTH;
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$54c4fd5984b65e0b, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$54c4fd5984b65e0b);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$54c4fd5984b65e0b);
    }
}
/**
 * Types of geometries
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$427161d533086393 extends $815c91046e476159$export$deb82508dd66d288 {
    /**
     *
     * @type {GeometryTypeEnum}
     */ static POINT = new $815c91046e476159$export$427161d533086393('POINT');
    /**
     *
     * @type {GeometryTypeEnum}
     */ static LINE = new $815c91046e476159$export$427161d533086393('LINE');
    /**
     *
     * @type {GeometryTypeEnum}
     */ static POLYGON = new $815c91046e476159$export$427161d533086393('POLYGON');
    static getForCode(code) {
        return $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$427161d533086393, code);
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$427161d533086393, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$427161d533086393);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$427161d533086393);
    }
}
/**
 * Possible fill types
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$a94ab4528edf2788 extends $815c91046e476159$export$deb82508dd66d288 {
    /**
     *
     * @type {FillPatternTypeEnum}
     */ static HORIZONTAL = new $815c91046e476159$export$a94ab4528edf2788('HORIZONTAL');
    /**
     *
     * @type {FillPatternTypeEnum}
     */ static VERTICAL = new $815c91046e476159$export$a94ab4528edf2788('VERTICAL');
    /**
     *
     * @type {FillPatternTypeEnum}
     */ static CROSS = new $815c91046e476159$export$a94ab4528edf2788('CROSS');
    /**
     *
     * @type {FillPatternTypeEnum}
     */ static DIAGONAL = new $815c91046e476159$export$a94ab4528edf2788('DIAGONAL');
    /**
     *
     * @type {FillPatternTypeEnum}
     */ static ANTI_DIAGONAL = new $815c91046e476159$export$a94ab4528edf2788('ANTI_DIAGONAL');
    /**
     *
     * @type {FillPatternTypeEnum}
     */ static DIAGONAL_CROSS = new $815c91046e476159$export$a94ab4528edf2788('DIAGONAL_CROSS');
    /**
     *
     * @type {FillPatternTypeEnum}
     */ static DOTTED = new $815c91046e476159$export$a94ab4528edf2788('DOTTED');
    static getForCode(code) {
        return $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$a94ab4528edf2788, code);
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$a94ab4528edf2788, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$a94ab4528edf2788);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$a94ab4528edf2788);
    }
}
/**
 * Possible line types
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$6b4efad1d1b9c97e extends $815c91046e476159$export$deb82508dd66d288 {
    /**
     *
     * @type {LinePatternTypeEnum}
     */ static DOTTED = new $815c91046e476159$export$6b4efad1d1b9c97e('DOTTED');
    /**
     *
     * @type {LinePatternTypeEnum}
     */ static DASHED = new $815c91046e476159$export$6b4efad1d1b9c97e('DASHED');
    static getForCode(code) {
        return $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$6b4efad1d1b9c97e, code);
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$6b4efad1d1b9c97e, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$6b4efad1d1b9c97e);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$6b4efad1d1b9c97e);
    }
}
/**
 * Possible style rule types
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$23989178094d68d extends $815c91046e476159$export$deb82508dd66d288 {
    /**
     * Discrete styles expect a value attribute and will paint with a color by matching the value in a bucket defined with min/max values and a color
     * @type {StyleRuleTypeEnum}
     */ static DISCRETE = new $815c91046e476159$export$23989178094d68d('DISCRETE');
    /**
     * Continuous styles expect a value attribute and will paint with a color in a continuum between min and max values/colors
     * @type {StyleRuleTypeEnum}
     */ static CONTINUOUS = new $815c91046e476159$export$23989178094d68d('CONTINUOUS');
    /**
     * Classified styles expect an attribute that classifies features
     * @type {StyleRuleTypeEnum}
     */ static CLASSIFIED = new $815c91046e476159$export$23989178094d68d('CLASSIFIED');
    /**
     * A simple style (color fill, stroke, etc.)
     * @type {StyleRuleTypeEnum}
     */ static SIMPLE = new $815c91046e476159$export$23989178094d68d('SIMPLE');
    /**
     * A simple style (color fill, stroke, etc.), for features that don't have data
     * @type {StyleRuleTypeEnum}
     */ static NODATA = new $815c91046e476159$export$23989178094d68d('NODATA');
    /**
     * A simple style (color fill, stroke, etc.), for clustered features
     * @type {StyleRuleTypeEnum}
     */ static CLUSTER = new $815c91046e476159$export$23989178094d68d('CLUSTER');
    /**
     * Load an image as legend (only for legends)
     * @type {StyleRuleTypeEnum}
     */ static EXTERNAL_IMAGE = new $815c91046e476159$export$23989178094d68d('EXTERNAL_IMAGE');
    /**
     * Load an image as legend, depending on the map extent (only for legends)
     * @type {StyleRuleTypeEnum}
     */ static EXTERNAL_DYNAMIC_IMAGE = new $815c91046e476159$export$23989178094d68d('EXTERNAL_DYNAMIC_IMAGE');
    static getForCode(code) {
        return $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$23989178094d68d, code);
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$23989178094d68d, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$23989178094d68d);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$23989178094d68d);
    }
}
/**
 * Describe the preferred position of the labels in the legend
 * Applicable to StyleRuleTypeEnum.DISCRETE, StyleRuleTypeEnum.CLASSIFIED
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$b0626c1c2473a01e extends $815c91046e476159$export$deb82508dd66d288 {
    static TOP = new $815c91046e476159$export$b0626c1c2473a01e('TOP');
    static BOTTOM = new $815c91046e476159$export$b0626c1c2473a01e('BOTTOM');
    static ALTERNATE = new $815c91046e476159$export$b0626c1c2473a01e('ALTERNATE');
    static getForCode(code) {
        return $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$b0626c1c2473a01e, code);
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$b0626c1c2473a01e, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$b0626c1c2473a01e);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$b0626c1c2473a01e);
    }
}
/**
 * Describe the preferred orientation of the legend elements
 * Applicable to StyleRuleTypeEnum.CLASSIFIED
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$ab3075f671a20a10 extends $815c91046e476159$export$deb82508dd66d288 {
    static VERTICAL = new $815c91046e476159$export$b0626c1c2473a01e('VERTICAL');
    static HOIZONTAL = new $815c91046e476159$export$b0626c1c2473a01e('HOIZONTAL');
    static getForCode(code) {
        return $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$ab3075f671a20a10, code);
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$ab3075f671a20a10, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$ab3075f671a20a10);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$ab3075f671a20a10);
    }
}
/**
 * Describe the type of chart for a layer
 * @extends Enum
 * @hideconstructor
 */ class $815c91046e476159$export$39c0195897d703ce extends $815c91046e476159$export$deb82508dd66d288 {
    static BARS = new $815c91046e476159$export$39c0195897d703ce('BARS');
    static BARS_WITH_LINE = new $815c91046e476159$export$39c0195897d703ce('BARS_WITH_LINE');
    static BARS_WITH_LINE_AND_ACCUMULATION = new $815c91046e476159$export$39c0195897d703ce('BARS_WITH_LINE_AND_ACCUMULATION');
    static STACKED_BARS = new $815c91046e476159$export$39c0195897d703ce('STACKED_BARS');
    static getForCode(code) {
        return $815c91046e476159$export$deb82508dd66d288._getForCode($815c91046e476159$export$39c0195897d703ce, code);
    }
    static exists(code) {
        return $815c91046e476159$export$deb82508dd66d288._exists($815c91046e476159$export$39c0195897d703ce, code);
    }
    static getPossibleCodes() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleCodes($815c91046e476159$export$39c0195897d703ce);
    }
    static getPossibleValues() {
        return $815c91046e476159$export$deb82508dd66d288._getPossibleValues($815c91046e476159$export$39c0195897d703ce);
    }
}



var $feAbh = parcelRequire("feAbh");



/**
 * Mother of all classes of Tumbo
 * @abstract
 */ class $c804408d7d980f44$export$ef88aa0d34c34520 {
    constructor(){
        this.properties = {};
    }
    /**
     * Set a property
     * Has no semantics but can be useful from the outside
     * @param code {string} The id of the property
     * @param value {*} The value of the property
     * @return {Base} This UI element
     */ set(code, value) {
        this.properties[code] = value;
        return this;
    }
    /**
     * Get a property value
     * Has no semantics but can be useful from the outside
     * @param code {string} The id of the property
     * @return {*}
     */ get(code) {
        return this.properties[code];
    }
    getClassName() {
        return "Base";
    }
    /**
     * This object's class name
     * @return {string}
     */ getClass() {
        return this.__proto__.constructor.name;
    }
    /**
     * Log a debug message identified with this object
     * @param msg {string} The message to log
     * @param obj {*|undefined} An object to log
     */ logDebug(msg, obj) {
        tumbo.LOGGER.logDebug(msg ? "[" + this.getLogId() + "]\t" + msg : "[" + this.getLogId() + "]", obj);
    }
    /**
     * Log an info message identified with this object
     * @param msg {string} The message to log
     * @param obj {*|undefined} An object to log
     */ logInfo(msg, obj) {
        tumbo.LOGGER.logInfo(msg ? "[" + this.getLogId() + "]\t" + msg : "[" + this.getLogId() + "]", obj);
    }
    /**
     * Log an error message identified with this object
     * @param msg {string} The message to log
     * @param obj {*|undefined} An object to log
     */ logError(msg, obj) {
        tumbo.LOGGER.logError(msg ? "[" + this.getLogId() + "]\t" + msg : "[" + this.getLogId() + "]", obj);
    }
    /**
     * An ID token to use for logging
     * @return {string}
     */ getLogId() {
        return (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.getClassName(), this.getClass());
    }
}


const $aeedcab592f41cce$var$YEARLESS_YEAR = 2001;
/**
 * A calculator for dates
 * @extends Base
 */ class $aeedcab592f41cce$export$41dea944c75fcd24 extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     *
     * @param periodicity {PeriodicityEnum} The periodicity of the layer
     * @param from {string|Date} Min date in format YYYY-MM-DD
     * @param until {string|Date} Max date in format YYYY-MM-DD
     * @param translator {Translator} The translator
     */ constructor(periodicity, from, until, translator){
        super();
        this.periodicity = periodicity ? periodicity : (0, $815c91046e476159$export$45470b399d15bbcb).CUSTOM;
        this.from = from ? this.fixDate($aeedcab592f41cce$export$6bc008c5ec740e9d(from)) : undefined;
        this.until = until ? this.fixUnboundedDateUntil($aeedcab592f41cce$export$6bc008c5ec740e9d(until)) : undefined;
        if (this.isYearless()) {
            this.from = this.from ? $aeedcab592f41cce$export$2b6cf20b1d58ec45($aeedcab592f41cce$var$YEARLESS_YEAR, this.getMonthFromDate(this.from), this.getDayFromDate(this.from)) : undefined;
            this.until = this.until ? $aeedcab592f41cce$export$2b6cf20b1d58ec45($aeedcab592f41cce$var$YEARLESS_YEAR, this.getMonthFromDate(this.until), this.getDayFromDate(this.until)) : undefined;
        }
        this.translator = translator;
    }
    getClassName() {
        return "TimeCalculator";
    }
    /**
     * Ther periodicity
     * @return {PeriodicityEnum}
     */ getPeriodicity() {
        return this.periodicity;
    }
    /**
     * The min date
     * @return {Date}
     */ getFrom() {
        return this.from;
    }
    /**
     * The max date
     * @return {Date}
     */ getUntil() {
        return this.until;
    }
    /**
     * Is this a yearly circular periodicity?
     * @return {boolean} true if it is
     */ isYearless() {
        return this.isTenDailyYearless() || this.isDailyYearless() || this.isTenDailyYearless30Day();
    }
    isTimeless() {
        return this.isLatest();
    }
    hasNoDate() {
        return !this.periodicity || this.isUnknown();
    }
    /**
     *
     * @return {boolean}
     */ isLatest() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).LATEST;
    }
    /**
     *
     * @return {boolean}
     */ isYearly() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).YEARLY;
    }
    /**
     *
     * @return {boolean}
     */ isMonthly() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY;
    }
    /**
     *
     * @return {boolean}
     */ isMonthlyForecast() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_FORECAST;
    }
    /**
     *
     * @return {boolean}
     */ isMonthlyUpdatedTenDaily() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_UPDATED_TEN_DAILY;
    }
    /**
     *
     * @return {boolean}
     */ isTenDaily() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY;
    }
    /**
     *
     * @return {boolean}
     */ isTenDailyYearless() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS;
    }
    /**
     *
     * @return {boolean}
     */ isTenDailyYearless30Day() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS_30DAY;
    }
    /**
     *
     * @return {boolean}
     */ isDailyYearless() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).DAILY_YEARLESS;
    }
    /**
     *
     * @return {boolean}
     */ isWeekly() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).WEEKLY;
    }
    /**
     *
     * @return {boolean}
     */ isISOWeekly() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).ISO_WEEKLY;
    }
    /**
     *
     * @return {boolean}
     */ isDaily() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).DAILY;
    }
    /**
     *
     * @return {boolean}
     */ isUnknown() {
        return this.periodicity === (0, $815c91046e476159$export$45470b399d15bbcb).CUSTOM;
    }
    /**
     * Get all the years of available data
     * @return {Array<Number>} (integer)
     */ getYears() {
        const years = [];
        const untilYear = this.getYearFromDate(this.until);
        for(let y = this.getYearFromDate(this.from); y <= untilYear; y++)years.push(y);
        return years;
    }
    /**
     * Is the given time code valid?
     * @param timeCode {string} YYYY-MM-DD
     * @return {boolean}
     */ isValid(timeCode) {
        const year = this.parseYear(timeCode);
        if (!$aeedcab592f41cce$export$5f691ceae06458b4(timeCode) || !this.isYearless() && year < 1900 || year > 3000) return false;
        if (this.from && $aeedcab592f41cce$export$6bc008c5ec740e9d(timeCode).getTime() < this.from.getTime()) return false;
        if (this.until && $aeedcab592f41cce$export$6bc008c5ec740e9d(timeCode).getTime() > this.until.getTime()) return false;
        if (this.isYearly()) try {
            const month = this.parseMonth(timeCode);
            const day = this.parseDay(timeCode);
            return month === 1 && day === 1;
        } catch (e) {
            return false;
        }
        else if (this.isMonthly()) try {
            return this.parseDay(timeCode) === 1;
        } catch (e) {
            return false;
        }
        else if (this.isMonthlyForecast()) try {
            return this.parseDay(timeCode) === 1;
        } catch (e) {
            return false;
        }
        else if (this.isTenDaily() || this.isMonthlyUpdatedTenDaily() || this.isTenDailyYearless() || this.isTenDailyYearless30Day()) try {
            const tenDays = this.parseTenDays(timeCode);
            return tenDays >= 1 && tenDays <= 3;
        } catch (e) {
            return false;
        }
        else if (this.isWeekly()) try {
            const year = this.parseYear(timeCode);
            const week = this.parseWeek(timeCode);
            const date = $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeWeekly(year, week));
            const firstDayOfFirstWeek = this.getFirstDayOfFirstWeek(year);
            return this.getDifferenceInDays(date, firstDayOfFirstWeek) % 7 === 0;
        } catch (e) {
            return false;
        }
        else if (this.isISOWeekly()) try {
            const year = this.parseYear(timeCode);
            const week = this.parseISOWeek(timeCode);
            const date = $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeISOWeekly(year, week));
            const firstDayOfFirstWeek = this.getFirstDayOfFirstISOWeek(year);
            return this.getDifferenceInDays(date, firstDayOfFirstWeek) % 7 === 0;
        } catch (e) {
            return false;
        }
        return true;
    }
    /**
     * Parse the year of the given time code
     * @param timeCode {string}
     * @return {undefined|number}
     */ parseYear(timeCode) {
        if (this.isYearless()) {
            const split = timeCode.split('-');
            return split.length === 3 ? Number(split[0]) : 0;
        }
        return this.isUnknown() ? undefined : Number(timeCode.split('-')[0]);
    }
    /**
     * Parse the month of the given time code
     * @param timeCode {string}
     * @return {undefined|number} [1 .. 12]
     */ parseMonth(timeCode) {
        return this.isUnknown() || this.isYearly() ? undefined : Number(timeCode.split('-')[1]);
    }
    /**
     * Parse the ten day period of the given time code
     * @param timeCode {string}
     * @return {undefined|number} [1 .. 3]
     */ parseTenDays(timeCode) {
        if (!this.isTenDaily() && !this.isMonthlyUpdatedTenDaily() && !this.isTenDailyYearless() && !this.isTenDailyYearless30Day()) return undefined;
        const split = timeCode.split('-');
        const day = split.length === 3 ? Number(split[2]) : Number(split[1]);
        switch(day){
            case 1:
                return 1;
            case 11:
                return 2;
            case 21:
                return 3;
            default:
                return -1;
        }
    }
    /**
     * Parse the week of the given time code
     * @param timeCode {string}
     * @return {undefined|number} [1 .. 53]
     */ parseWeek(timeCode) {
        if (!this.isWeekly()) return undefined;
        return this.getWeekFromDate($aeedcab592f41cce$export$6bc008c5ec740e9d(timeCode));
    }
    /**
     * Parse the ISO week of the given time code
     * @param timeCode {string}
     * @return {undefined|number} [1 .. 53]
     */ parseISOWeek(timeCode) {
        if (!this.isISOWeekly()) return undefined;
        return this.getISOWeekFromDate($aeedcab592f41cce$export$6bc008c5ec740e9d(timeCode));
    }
    /**
     * Parse the day of the given time code
     * @param timeCode {string}
     * @return {number} [1 .. 31]
     */ parseDay(timeCode) {
        return Number(timeCode.split('-')[2]);
    }
    /**
     * Write a yearly time code
     * @param year {number} The year (integer)
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {string}
     */ writeYearly(year, bound = false) {
        year = !bound ? year : Math.max(Math.min(year, this.until ? this.getMaxYear() : year), this.from ? this.getMinYear() : year);
        return year + '-01-01';
    }
    /**
     * Write a monthly time code
     * @param year {number} The year (integer)
     * @param month {number} The month (integer)
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {string}
     */ writeMonthly(year, month, bound = false) {
        year = !bound ? year : Math.max(Math.min(year, this.until ? this.getMaxYear() : year), this.from ? this.getMinYear() : year);
        month = !bound ? month : Math.max(Math.min(month, this.until ? this.getMaxMonthForYear(year) : month), this.from ? this.getMinMonthForYear(year) : month);
        return year + '-' + month.pad(2) + '-01';
    }
    /**
     * Write a monthly forecast time code
     * @param year {number} The year (integer)
     * @param month {number} The month (integer)
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {string}
     */ writeMonthlyForecast(year, month, bound = false) {
        return this.writeMonthly(year, month, bound);
    }
    /**
     * Write a monthly updated ten daily time code
     * @param year {number} The year (integer)
     * @param month {number} The month (integer)
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {string}
     */ writeMonthlyUpdatedTenDaily(year, month, bound = false) {
        return this.writeMonthly(year, month, bound);
    }
    /**
     * Write yearless ten daily (with a 30-day scope) time code
     * @param month {number} The month (integer)
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {string}
     */ writeTenDailyYearless30Days(month, bound = false) {
        return this.writeMonthly(0, month, bound);
    }
    /**
     * Write a ten daily time code
     * @param year {number} The year (integer)
     * @param month {number} The month (integer)
     * @param tenDays {number} The ten day period (integer)
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {string}
     */ writeTenDaily(year = 0, month, tenDays, bound = false) {
        year = !bound ? year : Math.max(Math.min(year, this.until ? this.getMaxYear() : year), this.from ? this.getMinYear() : year);
        month = !bound ? month : Math.max(Math.min(month, this.until ? this.getMaxMonthForYear(year) : month), this.from ? this.getMinMonthForYear(year) : month);
        tenDays = !bound ? tenDays : Math.max(Math.min(tenDays, this.until ? this.getMaxTenDaysForYearMonth(year, month) : tenDays), this.from ? this.getMinTenDaysForYearMonth(year, month) : tenDays);
        let day;
        switch(tenDays){
            case 1:
                day = 1;
                break;
            case 2:
                day = 11;
                break;
            case 3:
                day = 21;
                break;
            default:
                day = -1;
                break;
        }
        return year.pad(4) + '-' + month.pad(2) + '-' + day.pad(2);
    }
    /**
     * Write a weekly time code
     * @param year {number} The month (integer)
     * @param week {number} The week (integer)
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {string}
     */ writeWeekly(year, week, bound = false) {
        year = !bound ? year : Math.max(Math.min(year, this.until ? this.getMaxYear() : year), this.from ? this.getMinYear() : year);
        const firstDayOfFirstWeek = this.getFirstDayOfFirstWeek(year);
        const date = this.addDays(firstDayOfFirstWeek, (week - 1) * 7); //minus 1, because we aim at the beginning of the week. If we want week 1, we should add zero days
        return this.getYearFromDate(date) + '-' + this.getMonthFromDate(date).pad(2) + '-' + this.getDayFromDate(date).pad(2);
    }
    /**
     * Write an ISO weekly time code
     * @param year {number} The month (integer)
     * @param week {number} The week (integer)
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {string}
     */ writeISOWeekly(year, week, bound = false) {
        const firstDayOfFirstWeek = this.getFirstDayOfFirstISOWeek(year);
        const date = this.addDays(firstDayOfFirstWeek, (week - 1) * 7); //minus 1, because we aim at the beginning of the week. If we want week 1, we should add zero days
        return this.getYearFromDate(date) + '-' + this.getMonthFromDate(date).pad(2) + '-' + this.getDayFromDate(date).pad(2);
    }
    /**
     * Write a daily time code
     * @param year {number} The year (integer)
     * @param month {number} The month (integer)
     * @param day {number} The day (integer)
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {string}
     */ writeDaily(year, month, day, bound = false) {
        year = !bound ? year : Math.max(Math.min(year, this.until ? this.getMaxYear() : year), this.from ? this.getMinYear() : year);
        month = !bound ? month : Math.max(Math.min(month, this.until ? this.getMaxMonthForYear(year) : month), this.from ? this.getMinMonthForYear(year) : month);
        return year + '-' + month.pad(2) + '-' + Math.min(day, this.getMaxDayForYearMonth(year, month)).pad(2);
    }
    writeUnknown() {
        return '--';
    }
    /**
     * Given a date, write a time code
     * @param date {Date} The date
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {string}
     */ writeTimeCodeFromDate(date, bound = false) {
        if (!date) return undefined;
        date = $aeedcab592f41cce$export$6bc008c5ec740e9d(date);
        if (this.isYearly()) return this.writeYearly(this.getYearFromDate(date), bound);
        if (this.isWeekly()) return this.writeWeekly(this.getYearFromDate(date), this.getWeekFromDate(date), bound);
        if (this.isISOWeekly()) return this.writeISOWeekly(this.getYearFromDate(date), this.getISOWeekFromDate(date), bound);
        if (this.isMonthly()) return this.writeMonthly(this.getYearFromDate(date), this.getMonthFromDate(date), bound);
        if (this.isMonthlyForecast()) return this.writeMonthlyForecast(this.getYearFromDate(date), this.getMonthFromDate(date), bound);
        if (this.isTenDaily() || this.isMonthlyUpdatedTenDaily() || this.isTenDailyYearless() || this.isTenDailyYearless30Day()) return this.writeTenDaily(this.getYearFromDate(date), this.getMonthFromDate(date), this.getTenDaysFromDate(date), bound);
        if (this.isDaily() || this.isDailyYearless() || this.isLatest()) return this.writeDaily(this.getYearFromDate(date), this.getMonthFromDate(date), this.getDayFromDate(date), bound);
        return this.writeUnknown();
    }
    /**
     * Given a month a year, how many days are in the month?
     * @param month {number} The month (integer [1 .. 12])
     * @param year {number} The year (integer)
     * @return {number} (integer [1 .. 31])
     */ daysInMonth(month, year) {
        return $aeedcab592f41cce$export$2b6cf20b1d58ec45(year, month + 1, 0).getDate();
    }
    /**
     * The last day of the month
     * @param year {number} (integer)
     * @param month {number} (integer)
     * @return {Date}
     */ getLastDayOfMonth(year, month) {
        return $aeedcab592f41cce$export$2b6cf20b1d58ec45(year, month, this.daysInMonth(month, year));
    }
    /**
     * The last day of the month
     * @param date {Date}
     * @return {Date}
     */ getLastDayOfMonthFromDate(date) {
        return this.getLastDayOfMonth(this.getYearFromDate(date), this.getMonthFromDate(date));
    }
    /**
     * Given a date, get the year
     * @param date {Date} The date
     * @return {number} (integer)
     */ getYearFromDate(date) {
        return date.getFullYear();
    }
    /**
     * What is the min possible year?
     * @return {number|undefined}
     */ getMinYear() {
        return this.from ? this.getYearFromDate(this.from) : undefined;
    }
    /**
     * What is the max possible year?
     * @return {number|undefined}
     */ getMaxYear() {
        return this.until ? this.getYearFromDate(this.until) : undefined;
    }
    /**
     * Given a date, get the month
     * @param date {Date} The date
     * @return {number} (integer [1 .. 12])
     */ getMonthFromDate(date) {
        return date.getMonth() + 1;
    }
    /**
     * What is the minimum month for the given year
     * @param year {number} the year (integer)
     * @return {number} (integer [1 .. 12])
     */ getMinMonthForYear(year) {
        if (!this.from) return 1;
        if (this.isYearless()) year = $aeedcab592f41cce$var$YEARLESS_YEAR;
        const fromYear = this.getYearFromDate(this.from);
        if (year === fromYear) return this.getMonthFromDate(this.from);
        return 1;
    }
    /**
     * What is the maximum month for the given year
     * @param year {number} the year (integer)
     * @return {number} (integer [1 .. 12])
     */ getMaxMonthForYear(year) {
        if (!this.until) return 12;
        if (this.isYearless()) year = $aeedcab592f41cce$var$YEARLESS_YEAR;
        const untilYear = this.getYearFromDate(this.until);
        if (year === untilYear) return this.getMonthFromDate(this.until);
        return 12;
    }
    /**
     * Given a date, get the day
     * @param date {Date} The date
     * @return {number} (integer [1 .. 31])
     */ getDayFromDate(date) {
        return date.getDate();
    }
    /**
     * What is the minimum day for the given year and month
     * @param year {number} the year (integer)
     * @param month {number} the month (integer)
     * @return {number} (integer [1 .. 31])
     */ getMinDayForYearMonth(year, month) {
        if (!this.from) return 1;
        if (this.isYearless()) year = $aeedcab592f41cce$var$YEARLESS_YEAR;
        const fromYear = this.getYearFromDate(this.from);
        const fromMonth = this.getMonthFromDate(this.from);
        if (year === fromYear && month === fromMonth) return this.getDayFromDate(this.from);
        return 1;
    }
    /**
     * What is the maximum day for the given year and month
     * @param year {number} the year (integer)
     * @param month {number} the month (integer)
     * @return {number} (integer [1 .. 31])
     */ getMaxDayForYearMonth(year, month) {
        if (this.isYearless()) year = $aeedcab592f41cce$var$YEARLESS_YEAR;
        if (!this.until) return this.daysInMonth(month, year);
        const untilYear = this.getYearFromDate(this.until);
        const untilMonth = this.getMonthFromDate(this.until);
        if (year === untilYear && month === untilMonth) return this.getDayFromDate(this.until);
        return this.daysInMonth(month, year);
    }
    /**
     * What is the maximum day for the given year and month, without observing the max date of this time calculator
     * @param year {number} the year (integer)
     * @param month {number} the month (integer)
     * @return {number} (integer [1 .. 31])
     */ getUnboundedMaxDayForYearMonth(year, month) {
        return this.daysInMonth(month, year);
    }
    /**
     * Given a date, get the ten day period
     * @param date {Date} The date
     * @return {number} (integer [1 .. 3])
     */ getTenDaysFromDate(date) {
        const day = this.getDayFromDate(date);
        if (day < 11) return 1;
        if (day < 21) return 2;
        return 3;
    }
    /**
     * What is the minimum ten day period for the given year, month and min date
     * @param year {number} the year (integer)
     * @param month {number} the month (integer)
     * @return {number} (integer [1 .. 3])
     */ getMinTenDaysForYearMonth(year, month) {
        if (!this.from) return 1;
        const fromYear = this.getYearFromDate(this.from);
        const fromMonth = this.getMonthFromDate(this.from);
        if (year === fromYear && month === fromMonth) return this.getTenDaysFromDate(this.from);
        return 1;
    }
    /**
     * What is the maximum ten day period for the given year and month
     * @param year {number} the year (integer)
     * @param month {number} the month (integer)
     * @return {number} (integer [1 .. 3])
     */ getMaxTenDaysForYearMonth(year, month) {
        if (!this.until) return 3;
        const untilYear = this.getYearFromDate(this.until);
        const untilMonth = this.getMonthFromDate(this.until);
        if (year === untilYear && month === untilMonth) return this.getTenDaysFromDate(this.until);
        return 3;
    }
    /**
     * Given a date, get the week
     * @param date {Date} The date
     * @return {number} (integer [1 .. 53])
     */ getWeekFromDate(date) {
        const firstDayOfFirstWeek = this.getFirstDayOfFirstWeek(this.getYearFromDate(date));
        const differenceInDays = this.getDifferenceInDays(date, firstDayOfFirstWeek) + (date.getDay() + 1); //plus day of week
        return Math.ceil(differenceInDays / 7);
    }
    /**
     * Given a date, get the ISO week
     * @param date {Date} The date
     * @return {number} (integer [1 .. 53])
     */ getISOWeekFromDate(date) {
        const firstDayOfFirstWeek = this.getFirstDayOfFirstISOWeek(this.getYearFromDate(date));
        const differenceInDays = this.getDifferenceInDays(date, firstDayOfFirstWeek) + (date.getDay() + 1); //plus day of week
        return Math.ceil(differenceInDays / 7);
    }
    /**
     * What is the minimum week for the given year
     * @param year {number} the year (integer)
     * @return {number} (integer [1 .. 53])
     */ getMinWeekForYear(year) {
        if (!this.from) return 1;
        const fromYear = this.getYearFromDate(this.from);
        if (year === fromYear) return this.getWeekFromDate(this.from);
        return 1;
    }
    /**
     * What is the minimum ISO week for the given year
     * @param year {number} the year (integer)
     * @return {number} (integer [1 .. 53])
     */ getMinISOWeekForYear(year) {
        if (!this.from) return 1;
        const fromYear = this.getYearFromDate(this.from);
        if (year === fromYear) return this.getISOWeekFromDate(this.from);
        return 1;
    }
    /**
     * What is the maximum week for the given year
     * @param year {number} the year (integer)
     * @return {number} (integer [1 .. 53])
     */ getMaxWeekForYear(year) {
        const firstDayOfFirstWeek = this.getFirstDayOfFirstWeek(year);
        const lastDayOfLastWeek = this.min(this.until, this.addDays(this.getFirstDayOfLastWeek(year), 6));
        return Math.ceil(this.getDifferenceInDays(firstDayOfFirstWeek, lastDayOfLastWeek) / 7);
    }
    /**
     * What is the maximum ISO week for the given year
     * @param year {number} the year (integer)
     * @return {number} (integer [1 .. 53])
     */ getMaxISOWeekForYear(year) {
        const firstDayOfFirstWeek = this.getFirstDayOfFirstISOWeek(year);
        const lastDayOfLastWeek = this.min(this.until, this.addDays(this.getFirstDayOfLastISOWeek(year), 6));
        return Math.ceil(this.getDifferenceInDays(firstDayOfFirstWeek, lastDayOfLastWeek) / 7);
    }
    /**
     * Add days to the given date
     * @param date {Date} The given date
     * @param days {number} the nr of days (integer)
     * @return {Date}
     */ addDays(date, days) {
        return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(date), this.getMonthFromDate(date), this.getDayFromDate(date) + days);
    }
    /**
     * Add months to the given date
     * @param date {Date} The given date
     * @param months {number} the nr of months (integer)
     * @return {Date}
     */ addMonths(date, months) {
        return new Date(date.setMonth(date.getMonth() + months));
    }
    /**
     * Add years to the given date
     * @param date {Date} The given date
     * @param years {number} the nr of years (integer)
     * @return {Date}
     */ addYears(date, years) {
        return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(date) + years, this.getMonthFromDate(date), this.getDayFromDate(date));
    }
    /**
     * Maximum of 2 dates
     * @param date1 {Date}
     * @param date2 {Date}
     * @return {Date}
     */ max(date1, date2) {
        if (!date1) return date2;
        if (!date2) return date1;
        return date1.getTime() > date2.getTime() ? date1 : date2;
    }
    /**
     * Minimum of 2 dates
     * @param date1 {Date}
     * @param date2 {Date}
     * @return {Date}
     */ min(date1, date2) {
        if (!date1) return date2;
        if (!date2) return date1;
        return date1.getTime() < date2.getTime() ? date1 : date2;
    }
    /**
     * Nr of days between 2 dates
     * @param date1 {Date}
     * @param date2 {Date}
     * @return {number} (integer)
     */ getDifferenceInDays(date1, date2) {
        const diffTime = Math.abs(date2 - date1);
        return Math.ceil(diffTime / 86400000);
    }
    /**
     * The first day of the first week of the given year
     * @param year {number} (integer)
     * @return {Date}
     */ getFirstDayOfFirstWeek(year) {
        //Javascript weekdays are zero-based and start on a sunday
        //Our weeks start on mondays. We want the one that contains the first sunday of the year
        const firstDayOfYear = $aeedcab592f41cce$export$2b6cf20b1d58ec45(year, 1, 1);
        let firstDayOfFirstWeek;
        if (firstDayOfYear.getDay() === 1) firstDayOfFirstWeek = firstDayOfYear;
        else firstDayOfFirstWeek = this.addDays(firstDayOfYear, -this.addDays(firstDayOfYear, -1).getDay());
        return firstDayOfFirstWeek;
    }
    /**
     * The first day of the first ISO week of the given year
     * @param year {number} (integer)
     * @return {Date}
     */ getFirstDayOfFirstISOWeek(year) {
        //let's find the monday right before the 4th of january
        const _4thOfJanuary = $aeedcab592f41cce$export$2b6cf20b1d58ec45(year, 1, 4);
        return this.addDays(_4thOfJanuary, 1 - _4thOfJanuary.getDay());
    }
    /**
     * The first day of the last week of the given year
     * @param year {number} (integer)
     * @return {Date}
     */ getFirstDayOfLastWeek(year) {
        const firstDayOfFirstWeek = this.getFirstDayOfFirstWeek(year + 1);
        return this.addDays(firstDayOfFirstWeek, -7);
    }
    /**
     * The first day of the last ISO week of the given year
     * @param year {number} (integer)
     * @return {Date}
     */ getFirstDayOfLastISOWeek(year) {
        const firstDayOfFirstWeek = this.getFirstDayOfFirstISOWeek(year + 1);
        return this.addDays(firstDayOfFirstWeek, -7);
    }
    /**
     * Get a human-readable string given a time code
     * @param timeCode {string} the time code
     * @return {string|undefined}
     */ timeCodeToString(timeCode) {
        if (this.isUnknown()) return undefined;
        if (this.isDaily() || this.isLatest()) return $aeedcab592f41cce$export$3ae94a2503e890a1(timeCode);
        if (this.isDailyYearless()) return $aeedcab592f41cce$export$5b1892dca93afeb0(timeCode);
        const startDate = $aeedcab592f41cce$export$6bc008c5ec740e9d(timeCode);
        let endDate = this.getEndDateOfPeriod(startDate);
        if (this.isMonthlyForecast()) return this.translator.translate('layer.timeStrMonthlyForecast', [
            $aeedcab592f41cce$export$3ae94a2503e890a1(startDate)
        ]);
        if (this.isMonthlyUpdatedTenDaily()) return this.translator.translate('layer.timeStrMonthlyUpdatedTenDaily', [
            $aeedcab592f41cce$export$3ae94a2503e890a1(this.getStartDateOfPeriod(startDate)),
            $aeedcab592f41cce$export$3ae94a2503e890a1(this.getEndDateOfPeriod(startDate))
        ]);
        if (this.isWeekly()) return this.translator.translate('layer.timeStrWeekly', [
            this.getWeekFromDate(startDate),
            $aeedcab592f41cce$export$3ae94a2503e890a1(startDate),
            $aeedcab592f41cce$export$3ae94a2503e890a1(endDate)
        ]);
        if (this.isISOWeekly()) return this.translator.translate('layer.timeStrISOWeekly', [
            this.getISOWeekFromDate(startDate),
            $aeedcab592f41cce$export$3ae94a2503e890a1(startDate),
            $aeedcab592f41cce$export$3ae94a2503e890a1(endDate)
        ]);
        if (this.isTenDailyYearless() || this.isTenDailyYearless30Day()) return this.translator.translate('layer.timeStr', [
            $aeedcab592f41cce$export$5e9f8dc88b5627ef(startDate),
            $aeedcab592f41cce$export$5e9f8dc88b5627ef(endDate)
        ]);
        return this.translator.translate('layer.timeStr', [
            $aeedcab592f41cce$export$3ae94a2503e890a1(startDate),
            $aeedcab592f41cce$export$3ae94a2503e890a1(endDate)
        ]);
    }
    getStartDateOfPeriod(startDate) {
        if (!startDate || this.isUnknown()) return undefined;
        startDate = $aeedcab592f41cce$export$6bc008c5ec740e9d(startDate);
        if (this.isDaily() || this.isDailyYearless() || this.isLatest()) return startDate;
        if (this.isYearly()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.getYearFromDate(startDate) + '-01-01');
        if (this.isMonthly() || this.isMonthlyForecast()) return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(startDate), this.getMonthFromDate(startDate), 1);
        if (this.isTenDaily() || this.isMonthlyUpdatedTenDaily() || this.isTenDailyYearless() || this.isTenDailyYearless30Day()) {
            const getStartDateForTenDaily = (d)=>{
                const day = this.getDayFromDate(d);
                if (day < 11) return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(d), this.getMonthFromDate(d), 1);
                else if (day < 21) return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(d), this.getMonthFromDate(d), 11);
                else return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(d), this.getMonthFromDate(d), 21);
            };
            if (this.isMonthlyUpdatedTenDaily() || this.isTenDailyYearless30Day()) {
                const publishDate = getStartDateForTenDaily(startDate);
                return this.getPreviousDate(this.getPreviousDate(publishDate));
            }
            return getStartDateForTenDaily(startDate);
        }
        if (this.isWeekly()) {
            const weekFromDate = this.getWeekFromDate(startDate);
            return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeWeekly(this.getYearFromDate(startDate), weekFromDate));
        }
        if (this.isISOWeekly()) {
            const weekFromDate = this.getISOWeekFromDate(startDate);
            return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeISOWeekly(this.getYearFromDate(startDate), weekFromDate));
        }
    }
    getEndDateOfPeriod(startDate) {
        if (!startDate || this.isUnknown()) return undefined;
        startDate = $aeedcab592f41cce$export$6bc008c5ec740e9d(startDate);
        if (this.isMonthlyUpdatedTenDaily() || this.isTenDailyYearless30Day()) return this.addDays(this.getNextDate(startDate), -1);
        startDate = this.getStartDateOfPeriod(startDate);
        if (this.isDaily() || this.isDailyYearless() || this.isLatest()) return startDate;
        if (this.isYearly()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.getYearFromDate(startDate) + '-12-31');
        if (this.isMonthly() || this.isMonthlyForecast()) return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(startDate), this.getMonthFromDate(startDate), this.daysInMonth(this.getMonthFromDate(startDate), this.getYearFromDate(startDate)));
        if (this.isTenDaily() || this.isTenDailyYearless()) {
            const tenDays = this.parseTenDays($aeedcab592f41cce$export$3ae94a2503e890a1(startDate));
            switch(tenDays){
                case 3:
                    return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(startDate), this.getMonthFromDate(startDate), this.daysInMonth(this.getMonthFromDate(startDate), this.getYearFromDate(startDate)));
                case 2:
                    return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(startDate), this.getMonthFromDate(startDate), 20);
                case 1:
                    return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(startDate), this.getMonthFromDate(startDate), 10);
            }
        }
        if (this.isWeekly() || this.isISOWeekly()) return this.addDays(startDate, 6);
        return undefined;
    }
    getMiddleDateOfPeriod(startDate) {
        if (!startDate || this.isUnknown()) return undefined;
        startDate = $aeedcab592f41cce$export$6bc008c5ec740e9d(startDate);
        if (this.isMonthlyUpdatedTenDaily() || this.isTenDailyYearless30Day()) return this.addDays(this.getEndDateOfPeriod(startDate), -15);
        startDate = this.getStartDateOfPeriod(startDate);
        if (this.isDaily() || this.isDailyYearless() || this.isLatest()) return startDate;
        if (this.isYearly()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.getYearFromDate(startDate) + '-06-30');
        if (this.isMonthly() || this.isMonthlyForecast()) return $aeedcab592f41cce$export$2b6cf20b1d58ec45(this.getYearFromDate(startDate), this.getMonthFromDate(startDate), 15);
        if (this.isTenDaily() || this.isTenDailyYearless()) return this.addDays(this.getEndDateOfPeriod(startDate), -5);
        if (this.isWeekly() || this.isISOWeekly()) return this.addDays(this.getEndDateOfPeriod(startDate), -3);
        return undefined;
    }
    /**
     * Fix a time code
     * @param timeCode {string} The time code (YYYY-MM-DD)
     * @return {string} (YYYY-MM-DD)
     */ fixTimeCode(timeCode) {
        if (!(0, $2536f84a954bf107$export$51c197c9b00a6c1c)(timeCode)) return undefined;
        return $aeedcab592f41cce$export$3ae94a2503e890a1(this.fixDate($aeedcab592f41cce$export$6bc008c5ec740e9d(timeCode)));
    }
    /**
     * Fix a time code
     * @param date {Date}
     * @return {Date}
     */ fixDate(date) {
        if (!date) return date;
        let fixedDate = date;
        fixedDate.setHours(0);
        fixedDate.setMinutes(0);
        fixedDate.setSeconds(0);
        if (this.isLatest()) return fixedDate;
        if (this.isYearless()) {
            let res = this.isDailyYearless() ? $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeDaily($aeedcab592f41cce$var$YEARLESS_YEAR, this.getMonthFromDate(fixedDate), this.getDayFromDate(fixedDate))) : this.isTenDailyYearless() || this.isTenDailyYearless30Day() ? $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeTenDaily($aeedcab592f41cce$var$YEARLESS_YEAR, this.getMonthFromDate(fixedDate), this.getTenDaysFromDate(fixedDate))) : fixedDate;
            if (this.from) res = this.max(this.from, res);
            if (this.until) res = this.min(this.until, res);
            return res;
        }
        if (this.from) fixedDate = this.max(this.from, fixedDate);
        if (this.until) fixedDate = this.min(this.until, fixedDate);
        if (this.isDaily()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeDaily(this.getYearFromDate(fixedDate), this.getMonthFromDate(fixedDate), this.getDayFromDate(fixedDate)));
        if (this.isWeekly()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeWeekly(this.getYearFromDate(fixedDate), this.getWeekFromDate(fixedDate)));
        if (this.isISOWeekly()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeISOWeekly(this.getYearFromDate(fixedDate), this.getISOWeekFromDate(fixedDate)));
        if (this.isTenDaily() || this.isMonthlyUpdatedTenDaily()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeTenDaily(this.getYearFromDate(fixedDate), this.getMonthFromDate(fixedDate), this.getTenDaysFromDate(fixedDate)));
        if (this.isMonthly() || this.isMonthlyForecast()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeMonthly(this.getYearFromDate(fixedDate), this.getMonthFromDate(fixedDate)));
        if (this.isYearly()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeYearly(this.getYearFromDate(fixedDate)));
        return undefined;
    }
    /**
     * Fix the end of a time frame
     * @param until {Date} The end of the time frame
     * @return {Date}
     */ fixDateUntil(until) {
        const from = this.fixDate(until);
        if (!from || this.isLatest() || this.isDaily() || this.isDailyYearless()) return from;
        const yearFromDate = this.getYearFromDate(from);
        const monthFromDate = this.getMonthFromDate(from);
        if (this.isWeekly() || this.isISOWeekly()) return this.min($aeedcab592f41cce$export$2b6cf20b1d58ec45(yearFromDate, monthFromDate, this.getMaxDayForYearMonth(yearFromDate, monthFromDate)), this.addDays(from, 6));
        if (this.isTenDaily() || this.isMonthlyUpdatedTenDaily() || this.isTenDailyYearless() || this.isTenDailyYearless30Day()) {
            const tenDays = this.parseTenDays($aeedcab592f41cce$export$3ae94a2503e890a1(from));
            switch(tenDays){
                case 3:
                    return $aeedcab592f41cce$export$2b6cf20b1d58ec45(yearFromDate, monthFromDate, this.daysInMonth(monthFromDate, yearFromDate));
                default:
                    return this.addDays(from, 9);
            }
        }
        if (this.isMonthly() || this.isMonthlyForecast()) return $aeedcab592f41cce$export$2b6cf20b1d58ec45(yearFromDate, monthFromDate, this.getMaxDayForYearMonth(yearFromDate, monthFromDate));
        if (this.isYearly()) return $aeedcab592f41cce$export$2b6cf20b1d58ec45(yearFromDate, 12, this.getMaxDayForYearMonth(yearFromDate, 12));
        return undefined;
    }
    /**
     * Fix the end of a time frame, without observing the max date of this time calculator
     * @param until {Date} The end of the time frame
     * @return {Date}
     */ fixUnboundedDateUntil(until) {
        const from = this.fixDate(until);
        if (!from || this.isLatest() || this.isDaily() || this.isDailyYearless()) return from;
        if (this.isWeekly() || this.isISOWeekly()) return this.addDays(from, 6);
        const yearFromDate = this.getYearFromDate(from);
        if (this.isYearly()) return $aeedcab592f41cce$export$2b6cf20b1d58ec45(yearFromDate, 12, 31);
        const monthFromDate = this.getMonthFromDate(from);
        if (this.isTenDaily() || this.isMonthlyUpdatedTenDaily() || this.isTenDailyYearless() || this.isTenDailyYearless30Day()) return this.min($aeedcab592f41cce$export$2b6cf20b1d58ec45(yearFromDate, monthFromDate, this.getUnboundedMaxDayForYearMonth(yearFromDate, monthFromDate)), this.addDays(from, 9));
        if (this.isMonthly() || this.isMonthlyForecast()) return $aeedcab592f41cce$export$2b6cf20b1d58ec45(yearFromDate, monthFromDate, this.getUnboundedMaxDayForYearMonth(yearFromDate, monthFromDate));
        return undefined;
    }
    /**
     * Get an array of dates for a time series
     * @param from {Date}
     * @param until {Date}
     * @param unbounded {boolean} should the result be not bounded by this calculators date bounds?
     * @return {Array<Date>}
     */ getTimeSeries(from, until, unbounded = false) {
        const dates = [
            from
        ];
        const fixedUntilMillis = this.fixDate(until).getTime();
        while((0, $2536f84a954bf107$export$ce275da88d3dcc54)(dates).getTime() < fixedUntilMillis)dates.push(this.getNextDate((0, $2536f84a954bf107$export$ce275da88d3dcc54)(dates), !unbounded));
        return dates;
    }
    /**
     * Get sample data (ramdom), given time bounds
     * @param from {Date}
     * @param until {Date}
     * @param range {Array<number>|Array<string>} Array of 2 numbers or array of n strings
     * @return {Array<number>|Array<string>}
     */ getSampleData(from, until, range) {
        const data = [];
        if (from && until) this.getTimeSeries(this.fixDate(from), this.fixDateUntil(until)).forEach((date)=>{
            if (!range) data.push((Math.random() * 10 + 1) * (Math.random() > 0.5 ? 1 : -1));
            else if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(range[0])) data.push((0, $2536f84a954bf107$export$eab19c48dcb6310d)(range[0], range[1]));
            else if ((0, $2536f84a954bf107$export$844ec244b1367d54)(range[0])) data.push((0, $2536f84a954bf107$export$54fc09822f327121)(range));
        });
        return data;
    }
    /**
     * Given a date, get the previous date (beginning of period)
     * @param date {Date}
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {Date}
     */ getPreviousDate(date, bound = false) {
        if (this.isDaily() || this.isDailyYearless()) {
            date = this.addDays(date, -1);
            return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeDaily(this.getYearFromDate(date), this.getMonthFromDate(date), this.getDayFromDate(date), bound));
        }
        if (this.isWeekly()) {
            date = this.addDays(this.getStartDateOfPeriod(date), -7);
            return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeWeekly(this.getYearFromDate(date), this.getWeekFromDate(date), bound));
        }
        if (this.isISOWeekly()) {
            date = this.addDays(this.getStartDateOfPeriod(date), -7);
            return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeISOWeekly(this.getYearFromDate(date), this.getISOWeekFromDate(date), bound));
        }
        date = this.fixDate(date);
        const yearFromDate = this.getYearFromDate(date);
        if (this.isYearly()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeYearly(yearFromDate - 1));
        const monthFromDate = this.getMonthFromDate(date);
        if (this.isTenDaily() || this.isMonthlyUpdatedTenDaily() || this.isTenDailyYearless() || this.isTenDailyYearless30Day()) {
            const tenDays = this.parseTenDays($aeedcab592f41cce$export$3ae94a2503e890a1(date));
            if (tenDays > 1) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeTenDaily(yearFromDate, monthFromDate, tenDays - 1, bound));
            if (monthFromDate > 1) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeTenDaily(yearFromDate, monthFromDate - 1, 3, bound));
            else return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeTenDaily(yearFromDate - 1, 12, 3, bound));
        }
        if (this.isMonthly() || this.isMonthlyForecast()) {
            if (monthFromDate > 1) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeMonthly(yearFromDate, monthFromDate - 1, bound));
            else return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeMonthly(yearFromDate - 1, 12, bound));
        }
    }
    /**
     * Given a date, get the next date (beginning of period)
     * @param date {Date}
     * @param bound {boolean} if true, the result will be inside this calculator's bounds (from, until)
     * @return {Date}
     */ getNextDate(date, bound = false) {
        if (this.isDaily() || this.isDailyYearless()) {
            date = this.addDays(date, 1);
            return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeDaily(this.getYearFromDate(date), this.getMonthFromDate(date), this.getDayFromDate(date), bound));
        }
        if (this.isWeekly()) {
            date = this.addDays(this.getStartDateOfPeriod(date), 7);
            return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeWeekly(this.getYearFromDate(date), this.getWeekFromDate(date), bound));
        }
        if (this.isISOWeekly()) {
            date = this.addDays(this.getStartDateOfPeriod(date), 7);
            return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeISOWeekly(this.getYearFromDate(date), this.getISOWeekFromDate(date), bound));
        }
        date = this.fixDate(date);
        const yearFromDate = this.getYearFromDate(date);
        if (this.isYearly()) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeYearly(yearFromDate + 1, bound));
        const monthFromDate = this.getMonthFromDate(date);
        if (this.isTenDaily() || this.isMonthlyUpdatedTenDaily() || this.isTenDailyYearless() || this.isTenDailyYearless30Day()) {
            const tenDays = this.parseTenDays($aeedcab592f41cce$export$3ae94a2503e890a1(date));
            if (tenDays < 3) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeTenDaily(yearFromDate, monthFromDate, tenDays + 1, bound));
            if (monthFromDate < 12) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeTenDaily(yearFromDate, monthFromDate + 1, 1, bound));
            else return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeTenDaily(yearFromDate + 1, 1, 1, bound));
        }
        if (this.isMonthly() || this.isMonthlyForecast()) {
            if (monthFromDate < 12) return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeMonthly(yearFromDate, monthFromDate + 1, bound));
            else return $aeedcab592f41cce$export$6bc008c5ec740e9d(this.writeMonthly(yearFromDate + 1, 1, bound));
        }
    }
    getLatestDate(bound = false) {
        if (this.isYearless()) {
            const now = new Date();
            const day = this.getDayFromDate(now);
            const month = this.getMonthFromDate(now);
            return this.writeTimeCodeFromDate(this.fixDate($aeedcab592f41cce$export$2b6cf20b1d58ec45($aeedcab592f41cce$var$YEARLESS_YEAR, month, day)), bound);
        }
        return this.writeTimeCodeFromDate(this.getUntil(), bound);
    }
}
/**
 *
 * @param ts {Date}
 * @param includeSeconds {boolean}
 * @return {string}
 */ function $aeedcab592f41cce$export$bfe4ac50319c1d9b(ts, includeSeconds = false) {
    if (!ts) return undefined;
    if ((0, $2536f84a954bf107$export$844ec244b1367d54)(ts)) ts = $aeedcab592f41cce$export$6bc008c5ec740e9d(ts);
    const datePart = $aeedcab592f41cce$export$3ae94a2503e890a1(ts);
    if (!datePart) return datePart;
    return datePart + ' ' + ts.getHours().pad(2) + ':' + ts.getMinutes().pad(2) + (includeSeconds ? ':' + ts.getSeconds().pad(2) : '');
}
/**
 *
 * @param date {Date}
 * @return {string}
 */ function $aeedcab592f41cce$export$3ae94a2503e890a1(date) {
    if (!date) return undefined;
    if ((0, $2536f84a954bf107$export$844ec244b1367d54)(date)) date = $aeedcab592f41cce$export$6bc008c5ec740e9d(date);
    if (!(date instanceof Date)) return date;
    return (date.getFullYear() === 0 ? [
        (date.getMonth() + 1).pad(2),
        date.getDate().pad(2)
    ] : [
        date.getFullYear(),
        (date.getMonth() + 1).pad(2),
        date.getDate().pad(2)
    ]).join('-');
}
/**
 *
 * @param date {Date}
 * @return {string}
 */ function $aeedcab592f41cce$export$e3f281b772f1ba25(date) {
    if (!date) return undefined;
    if ((0, $2536f84a954bf107$export$844ec244b1367d54)(date)) date = $aeedcab592f41cce$export$6bc008c5ec740e9d(date);
    if (!(date instanceof Date)) return date;
    return [
        date.getFullYear(),
        (date.getMonth() + 1).pad(2)
    ].join('-');
}
/**
 *
 * @param date {Date}
 * @return {string}
 */ function $aeedcab592f41cce$export$5e9f8dc88b5627ef(date) {
    return $aeedcab592f41cce$export$5b1892dca93afeb0(date);
}
/**
 *
 * @param date {Date}
 * @return {string}
 */ function $aeedcab592f41cce$export$5b1892dca93afeb0(date) {
    if (!date) return undefined;
    if ((0, $2536f84a954bf107$export$844ec244b1367d54)(date)) date = $aeedcab592f41cce$export$6bc008c5ec740e9d(date);
    if (!(date instanceof Date)) return date;
    return [
        (date.getMonth() + 1).pad(2),
        date.getDate().pad(2)
    ].join('-');
}
/**
 * Verify if a date is valid
 * @param str A string in ISO form: yyyy-mm-dd
 * @returns {boolean} true if valid
 */ function $aeedcab592f41cce$export$5f691ceae06458b4(str) {
    try {
        Date.parse($aeedcab592f41cce$export$6bc008c5ec740e9d(str).toISOString());
        return true;
    } catch (error) {
        return false;
    }
}
/**
 * Parse a date from a string
 * @param str {string} The given string
 * @return {Date}
 */ function $aeedcab592f41cce$export$6bc008c5ec740e9d(str) {
    str = (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(str);
    if (!str) return str;
    if (str instanceof Date) return str;
    if (!(0, $2536f84a954bf107$export$844ec244b1367d54)(str)) return undefined;
    if (str.indexOf('T') > 0 || str.indexOf(' ') > 0) return new Date(str);
    const split = str.split('-');
    let year, month, day;
    if (split.length === 1) {
        year = Number(split[0]);
        month = 1;
        day = 1;
    } else if (split.length === 2) {
        const firstComponent = Number(split[0]);
        const isYearless = firstComponent > 0 && firstComponent <= 12;
        year = isYearless ? $aeedcab592f41cce$var$YEARLESS_YEAR : firstComponent;
        month = isYearless ? firstComponent : Number(split[1]);
        day = isYearless ? Number(split[1]) : 1;
    } else if (split.length === 3) {
        year = Number(split[0]);
        month = Number(split[1]);
        day = Number(split[2]);
    }
    return new Date([
        year,
        month.pad(2),
        day.pad(2)
    ].join('-') + ' 00:00:00.00');
}
/**
 *
 * @param year {number} (integer)
 * @param month {number} (integer [1 .. 12])
 * @param day  {number} (integer [1 .. 31])
 * @return {Date}
 */ function $aeedcab592f41cce$export$2b6cf20b1d58ec45(year = 0, month = 1, day = 1) {
    const date = new Date(year, month - 1, day);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return new Date(Date.parse(date.toUTCString()));
}




const $9bc5df2b24a7fcf6$export$b894c1ef12f59ce7 = '(c) European Union, {0}, CC BY 4.0';
const $9bc5df2b24a7fcf6$export$bad5ada7a204507f = "EPSG:900913";
const $9bc5df2b24a7fcf6$export$6dd85527b263c26d = "EPSG:4326";
/**
 * The list of resolutions has the possible resolutions for every possible projection
 * @type {Object<string,Array<number>>}
 */ const $9bc5df2b24a7fcf6$export$6ca86169e9c2a79e = {};
$9bc5df2b24a7fcf6$export$6ca86169e9c2a79e[$9bc5df2b24a7fcf6$export$6dd85527b263c26d] = [
    5.625,
    2.8125,
    1.40625,
    0.703125,
    0.3515625,
    0.17578125,
    0.087890625,
    0.0439453125,
    0.02197265625,
    0.010986328125,
    0.0054931640625,
    0.00274658203125,
    0.001373291015625,
    0.0006866455078125,
    0.0003433227539062,
    0.0001716613769531,
    0.0000858306884766,
    0.0000429153442383,
    0.0000214576721191,
    0.0000107288360596,
    0.0000053644180298
];
$9bc5df2b24a7fcf6$export$6ca86169e9c2a79e[$9bc5df2b24a7fcf6$export$bad5ada7a204507f] = [
    626172.135625,
    313086.0678125,
    156543.03390625,
    78271.516953125,
    39135.7584765625,
    19567.87923828125,
    9783.939619140625,
    4891.9698095703125,
    2445.9849047851562,
    1222.9924523925781,
    611.4962261962891,
    305.74811309814453,
    152.87405654907226,
    76.43702827453613,
    38.218514137268066,
    19.109257068634033,
    9.554628534317017,
    4.777314267158508,
    2.388657133579254,
    1.194328566789627,
    0.5971642833948135
];
$9bc5df2b24a7fcf6$export$6ca86169e9c2a79e["EPSG:3035"] = [
    626172.135625,
    313086.0678125,
    156543.03390625,
    78271.516953125,
    39135.7584765625,
    19567.87923828125,
    9783.939619140625,
    4891.9698095703125,
    2445.9849047851562,
    1222.9924523925781,
    611.4962261962891,
    305.74811309814453,
    152.87405654907226,
    76.43702827453613,
    38.218514137268066,
    19.109257068634033,
    9.554628534317017,
    4.777314267158508,
    2.388657133579254,
    1.194328566789627,
    0.5971642833948135
];
const $9bc5df2b24a7fcf6$export$5ba11896679e32dc = 1024;
const $9bc5df2b24a7fcf6$export$7f8c3bc50a5da30a = 512;
const $9bc5df2b24a7fcf6$export$8e5cee14bb214560 = 680;
const $9bc5df2b24a7fcf6$export$20b4de146c2df434 = 950;
const $9bc5df2b24a7fcf6$export$831eae6fa0f4beec = 'Ai7d83ncnmP99Uiy5RxVZwXUPmoypR3N-6QWv5FK1hB5DrKquIBJ0JvMhnVi3Ld_';
/**
 * Verify coordinates
 * @param coordinate {Array<number>} The coordinate to check
 * @param allowLonWrap If true allows lon values <-180 and >180
 * @param bbox {Array<number>} the bounding box. If present checks that the coordinate is inside it
 * @return {boolean} true if valid
 */ function $9bc5df2b24a7fcf6$export$861ac51a64fd27a8(coordinate, bbox, allowLonWrap = false) {
    let lon = coordinate[0];
    if (!allowLonWrap && (lon < -180 || lon > 180)) return false;
    let lat = coordinate[1];
    if (lat < -90 || lat > 90) return false;
    if (bbox) {
        if (lon < bbox[0] || lon > bbox[2]) return false;
        if (lat < bbox[1] || lat > bbox[3]) return false;
    }
    return true;
}
/**
 * Verify a bounding box
 * @param extent {Array<number>} the bounding box
 * @param allowLonWrap If true allows lon values <-180 and >180
 * @return {boolean} true if valid
 */ function $9bc5df2b24a7fcf6$export$867fb2209883d6bf(extent, allowLonWrap = false) {
    let lonMin = extent[0];
    let latMin = extent[1];
    let lonMax = extent[2];
    let latMax = extent[3];
    return lonMax > lonMin && latMax > latMin && $9bc5df2b24a7fcf6$export$861ac51a64fd27a8([
        lonMin,
        latMin
    ], undefined, allowLonWrap) && $9bc5df2b24a7fcf6$export$861ac51a64fd27a8([
        lonMax,
        latMax
    ], undefined, allowLonWrap);
}
/**
 * Verify a url
 * @param url string the url
 * @return {boolean} true if valid
 */ function $9bc5df2b24a7fcf6$export$cf70820c5d4688d8(url) {
    url = url.trim();
    return url.indexOf("http://") === 0 || url.indexOf("https://") === 0 || url.indexOf("//") === 0;
}
/**
 * Any configuration
 */ class $9bc5df2b24a7fcf6$export$29cd7b75162a9425 extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     *
     * @param config {Object} The config object
     */ constructor(config){
        super();
        this.config = config;
    }
    /**
     * Override this config
     * @param runtimeConfig {RuntimeConfig} The configuration override
     */ override(runtimeConfig) {}
    /**
     * Verify this configuration and return a list of errors
     * @return {Array<string>}
     */ verify() {
        return [];
    }
    /**
     * Get this config object
     * @return {Object}
     */ getConfig() {
        return this.config;
    }
    clone() {
        return new this.__proto__.constructor((0, $2536f84a954bf107$export$9cd59f9826255e47)(this.config));
    }
}
/**
 * A configuration that has a code
 * @extends Config
 * @hideconstructor
 */ class $9bc5df2b24a7fcf6$export$e8c716be77a99153 extends $9bc5df2b24a7fcf6$export$29cd7b75162a9425 {
    static _CODES_BY_CLASS = {};
    constructor(config){
        super(config);
        if (!$9bc5df2b24a7fcf6$export$e8c716be77a99153._CODES_BY_CLASS[this.getClass()]) $9bc5df2b24a7fcf6$export$e8c716be77a99153._CODES_BY_CLASS[this.getClass()] = {};
        $9bc5df2b24a7fcf6$export$e8c716be77a99153._CODES_BY_CLASS[this.getClass()][config.code] = $9bc5df2b24a7fcf6$export$e8c716be77a99153._CODES_BY_CLASS[this.getClass()][config.code] ? $9bc5df2b24a7fcf6$export$e8c716be77a99153._CODES_BY_CLASS[this.getClass()][config.code] + 1 : 1;
    }
    /**
     * Config code
     * @return {string}
     */ getCode() {
        return this.config.code;
    }
    getLogId() {
        return (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.getClassName(), this.getClass()) + " [" + this.getCode() + "]";
    }
    verify() {
        let errors = super.verify();
        if (!this.getCode() || this.getCode().length === 0) errors.push(this.getLogId() + ": code is mandatory");
        else if ($9bc5df2b24a7fcf6$export$e8c716be77a99153._CODES_BY_CLASS[this.getClass()][this.getCode()] > 1) errors.push(this.getLogId() + ": duplicated code");
        return errors;
    }
}
/**
 * A configuration that has a unique code (for the same type) and a name
 * @extends CodeConfig
 * @hideconstructor
 */ class $9bc5df2b24a7fcf6$export$950e37063b95ab70 extends $9bc5df2b24a7fcf6$export$e8c716be77a99153 {
    /**
     * The name of this config
     * @return {string}
     */ getName() {
        return this.config.name;
    }
    verify() {
        let errors = super.verify(this);
        const nameError = this.verifyName(this.getName());
        if (nameError) errors.push(this.getLogId() + ": " + nameError);
        return errors;
    }
    verifyName(name) {
        if (!(0, $2536f84a954bf107$export$51c197c9b00a6c1c)(name)) return "name is mandatory";
    }
}
/**
 * A configuration that has a unique code (for the same type), a name and an info description
 * @extends CodeNameConfig
 * @hideconstructor
 */ class $9bc5df2b24a7fcf6$export$d3fd516c17034308 extends $9bc5df2b24a7fcf6$export$950e37063b95ab70 {
    /**
     *
     * @return {string}
     */ getInfo() {
        return this.config.info;
    }
}
/**
 * A configuration that has a unique code
 * @extends Config
 * @hideconstructor
 */ class $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1 extends $9bc5df2b24a7fcf6$export$29cd7b75162a9425 {
    static _ALL_CODES = {};
    constructor(config){
        super(config);
        $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1._ALL_CODES[config.code] = $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1._ALL_CODES[config.code] ? $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1._ALL_CODES[config.code] + 1 : 1;
    }
    /**
     * Config code
     * @return {string}
     */ getCode() {
        return this.config.code;
    }
    getLogId() {
        return (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.getClassName(), this.getClass()) + " [" + this.getCode() + "]";
    }
    verify() {
        let errors = super.verify();
        if (!this.getCode() || this.getCode().length === 0) errors.push(this.getLogId() + ": code is mandatory");
        else if ($9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1._ALL_CODES[this.getCode()] > 1) errors.push(this.getLogId() + ": duplicated code");
        return errors;
    }
}
/**
 * A configuration that has a unique code and a name
 * @extends CodeUniqueConfig
 * @hideconstructor
 */ class $9bc5df2b24a7fcf6$export$adfff1815d321ad9 extends $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1 {
    /**
     * The name of this config
     * @return {string}
     */ getName() {
        return this.config.name;
    }
    verify() {
        let errors = super.verify(this);
        if (!this.getName() || this.getName().length === 0) errors.push(this.getLogId() + ": name is mandatory");
        return errors;
    }
}
/**
 * A configuration that has a unique code, a name and an info description
 * @extends CodeUniqueNameConfig
 * @hideconstructor
 */ class $9bc5df2b24a7fcf6$export$6066b86ada1a6d13 extends $9bc5df2b24a7fcf6$export$adfff1815d321ad9 {
    /**
     *
     * @return {string}
     */ getInfo() {
        return this.config.info;
    }
}




var $5f14bb65263850e1$exports = {};
!function(e, r) {
    $5f14bb65263850e1$exports = r();
}($5f14bb65263850e1$exports, function() {
    "use strict";
    var e = {
        aliceblue: [
            240,
            248,
            255
        ],
        antiquewhite: [
            250,
            235,
            215
        ],
        aqua: [
            0,
            255,
            255
        ],
        aquamarine: [
            127,
            255,
            212
        ],
        azure: [
            240,
            255,
            255
        ],
        beige: [
            245,
            245,
            220
        ],
        bisque: [
            255,
            228,
            196
        ],
        black: [
            0,
            0,
            0
        ],
        blanchedalmond: [
            255,
            235,
            205
        ],
        blue: [
            0,
            0,
            255
        ],
        blueviolet: [
            138,
            43,
            226
        ],
        brown: [
            165,
            42,
            42
        ],
        burlywood: [
            222,
            184,
            135
        ],
        cadetblue: [
            95,
            158,
            160
        ],
        chartreuse: [
            127,
            255,
            0
        ],
        chocolate: [
            210,
            105,
            30
        ],
        coral: [
            255,
            127,
            80
        ],
        cornflowerblue: [
            100,
            149,
            237
        ],
        cornsilk: [
            255,
            248,
            220
        ],
        crimson: [
            220,
            20,
            60
        ],
        cyan: [
            0,
            255,
            255
        ],
        darkblue: [
            0,
            0,
            139
        ],
        darkcyan: [
            0,
            139,
            139
        ],
        darkgoldenrod: [
            184,
            134,
            11
        ],
        darkgray: [
            169,
            169,
            169
        ],
        darkgreen: [
            0,
            100,
            0
        ],
        darkgrey: [
            169,
            169,
            169
        ],
        darkkhaki: [
            189,
            183,
            107
        ],
        darkmagenta: [
            139,
            0,
            139
        ],
        darkolivegreen: [
            85,
            107,
            47
        ],
        darkorange: [
            255,
            140,
            0
        ],
        darkorchid: [
            153,
            50,
            204
        ],
        darkred: [
            139,
            0,
            0
        ],
        darksalmon: [
            233,
            150,
            122
        ],
        darkseagreen: [
            143,
            188,
            143
        ],
        darkslateblue: [
            72,
            61,
            139
        ],
        darkslategray: [
            47,
            79,
            79
        ],
        darkslategrey: [
            47,
            79,
            79
        ],
        darkturquoise: [
            0,
            206,
            209
        ],
        darkviolet: [
            148,
            0,
            211
        ],
        deeppink: [
            255,
            20,
            147
        ],
        deepskyblue: [
            0,
            191,
            255
        ],
        dimgray: [
            105,
            105,
            105
        ],
        dimgrey: [
            105,
            105,
            105
        ],
        dodgerblue: [
            30,
            144,
            255
        ],
        firebrick: [
            178,
            34,
            34
        ],
        floralwhite: [
            255,
            250,
            240
        ],
        forestgreen: [
            34,
            139,
            34
        ],
        fuchsia: [
            255,
            0,
            255
        ],
        gainsboro: [
            220,
            220,
            220
        ],
        ghostwhite: [
            248,
            248,
            255
        ],
        gold: [
            255,
            215,
            0
        ],
        goldenrod: [
            218,
            165,
            32
        ],
        gray: [
            128,
            128,
            128
        ],
        green: [
            0,
            128,
            0
        ],
        greenyellow: [
            173,
            255,
            47
        ],
        grey: [
            128,
            128,
            128
        ],
        honeydew: [
            240,
            255,
            240
        ],
        hotpink: [
            255,
            105,
            180
        ],
        indianred: [
            205,
            92,
            92
        ],
        indigo: [
            75,
            0,
            130
        ],
        ivory: [
            255,
            255,
            240
        ],
        khaki: [
            240,
            230,
            140
        ],
        lavender: [
            230,
            230,
            250
        ],
        lavenderblush: [
            255,
            240,
            245
        ],
        lawngreen: [
            124,
            252,
            0
        ],
        lemonchiffon: [
            255,
            250,
            205
        ],
        lightblue: [
            173,
            216,
            230
        ],
        lightcoral: [
            240,
            128,
            128
        ],
        lightcyan: [
            224,
            255,
            255
        ],
        lightgoldenrodyellow: [
            250,
            250,
            210
        ],
        lightgray: [
            211,
            211,
            211
        ],
        lightgreen: [
            144,
            238,
            144
        ],
        lightgrey: [
            211,
            211,
            211
        ],
        lightpink: [
            255,
            182,
            193
        ],
        lightsalmon: [
            255,
            160,
            122
        ],
        lightseagreen: [
            32,
            178,
            170
        ],
        lightskyblue: [
            135,
            206,
            250
        ],
        lightslategray: [
            119,
            136,
            153
        ],
        lightslategrey: [
            119,
            136,
            153
        ],
        lightsteelblue: [
            176,
            196,
            222
        ],
        lightyellow: [
            255,
            255,
            224
        ],
        lime: [
            0,
            255,
            0
        ],
        limegreen: [
            50,
            205,
            50
        ],
        linen: [
            250,
            240,
            230
        ],
        magenta: [
            255,
            0,
            255
        ],
        maroon: [
            128,
            0,
            0
        ],
        mediumaquamarine: [
            102,
            205,
            170
        ],
        mediumblue: [
            0,
            0,
            205
        ],
        mediumorchid: [
            186,
            85,
            211
        ],
        mediumpurple: [
            147,
            112,
            219
        ],
        mediumseagreen: [
            60,
            179,
            113
        ],
        mediumslateblue: [
            123,
            104,
            238
        ],
        mediumspringgreen: [
            0,
            250,
            154
        ],
        mediumturquoise: [
            72,
            209,
            204
        ],
        mediumvioletred: [
            199,
            21,
            133
        ],
        midnightblue: [
            25,
            25,
            112
        ],
        mintcream: [
            245,
            255,
            250
        ],
        mistyrose: [
            255,
            228,
            225
        ],
        moccasin: [
            255,
            228,
            181
        ],
        navajowhite: [
            255,
            222,
            173
        ],
        navy: [
            0,
            0,
            128
        ],
        oldlace: [
            253,
            245,
            230
        ],
        olive: [
            128,
            128,
            0
        ],
        olivedrab: [
            107,
            142,
            35
        ],
        orange: [
            255,
            165,
            0
        ],
        orangered: [
            255,
            69,
            0
        ],
        orchid: [
            218,
            112,
            214
        ],
        palegoldenrod: [
            238,
            232,
            170
        ],
        palegreen: [
            152,
            251,
            152
        ],
        paleturquoise: [
            175,
            238,
            238
        ],
        palevioletred: [
            219,
            112,
            147
        ],
        papayawhip: [
            255,
            239,
            213
        ],
        peachpuff: [
            255,
            218,
            185
        ],
        peru: [
            205,
            133,
            63
        ],
        pink: [
            255,
            192,
            203
        ],
        plum: [
            221,
            160,
            221
        ],
        powderblue: [
            176,
            224,
            230
        ],
        purple: [
            128,
            0,
            128
        ],
        rebeccapurple: [
            102,
            51,
            153
        ],
        red: [
            255,
            0,
            0
        ],
        rosybrown: [
            188,
            143,
            143
        ],
        royalblue: [
            65,
            105,
            225
        ],
        saddlebrown: [
            139,
            69,
            19
        ],
        salmon: [
            250,
            128,
            114
        ],
        sandybrown: [
            244,
            164,
            96
        ],
        seagreen: [
            46,
            139,
            87
        ],
        seashell: [
            255,
            245,
            238
        ],
        sienna: [
            160,
            82,
            45
        ],
        silver: [
            192,
            192,
            192
        ],
        skyblue: [
            135,
            206,
            235
        ],
        slateblue: [
            106,
            90,
            205
        ],
        slategray: [
            112,
            128,
            144
        ],
        slategrey: [
            112,
            128,
            144
        ],
        snow: [
            255,
            250,
            250
        ],
        springgreen: [
            0,
            255,
            127
        ],
        steelblue: [
            70,
            130,
            180
        ],
        tan: [
            210,
            180,
            140
        ],
        teal: [
            0,
            128,
            128
        ],
        thistle: [
            216,
            191,
            216
        ],
        tomato: [
            255,
            99,
            71
        ],
        turquoise: [
            64,
            224,
            208
        ],
        violet: [
            238,
            130,
            238
        ],
        wheat: [
            245,
            222,
            179
        ],
        white: [
            255,
            255,
            255
        ],
        whitesmoke: [
            245,
            245,
            245
        ],
        yellow: [
            255,
            255,
            0
        ],
        yellowgreen: [
            154,
            205,
            50
        ]
    }, r = new RegExp(/^#([a-f0-9]{3,4}|[a-f0-9]{4}(?:[a-f0-9]{2}){1,2})\b$/, "i"), n = "-?\\d*(?:\\.\\d+)", a = "(" + n + "?)", l = "(" + n + "?%)", t = ("^\n  hsla?\\(\n    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*,\n    \\s*" + l + "\\s*,\n    \\s*" + l + "\\s*\n    (?:,\\s*" + "(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n  $\n").replace(/\n|\s/g, ""), s = new RegExp(t), i = ("^\n  hsla?\\(\n    \\s*(-?\\d*(?:\\.\\d+)?(?:deg|rad|turn)?)\\s*\n    \\s+" + l + "\n    \\s+" + l + "\n    \\s*(?:\\s*\\/\\s*" + "(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n  $\n").replace(/\n|\s/g, ""), o = new RegExp(i), d = ("^\n  rgba?\\(\n    \\s*" + a + "\\s*,\n    \\s*" + a + "\\s*,\n    \\s*" + a + "\\s*\n    (?:,\\s*" + "(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n  $\n").replace(/\n|\s/g, ""), u = new RegExp(d), g = ("^\n  rgba?\\(\n    \\s*" + l + "\\s*,\n    \\s*" + l + "\\s*,\n    \\s*" + l + "\\s*\n    (?:,\\s*" + "(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n  $\n").replace(/\n|\s/g, ""), p = new RegExp(g), h = ("^\n  rgba?\\(\n    \\s*" + a + "\n    \\s+" + a + "\n    \\s+" + a + "\n    \\s*(?:\\s*\\/\\s*" + "(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n$\n").replace(/\n|\s/g, ""), c = new RegExp(h), m = ("^\n  rgba?\\(\n    \\s*" + l + "\n    \\s+" + l + "\n    \\s+" + l + "\n    \\s*(?:\\s*\\/\\s*" + "(-?\\d*(?:\\.\\d+)?%?)\\s*)?\n  \\)\n$\n").replace(/\n|\s/g, ""), f = new RegExp(m), b = new RegExp(/^transparent$/, "i"), y = new RegExp("[^#a-f\\d]", "gi"), w = new RegExp("^#?[a-f\\d]{3}[a-f\\d]?$|^#?[a-f\\d]{6}([a-f\\d]{2})?$", "i"), k = function(e, r, n) {
        return Math.min(Math.max(r, e), n);
    }, v = function(e) {
        var r = e;
        return "number" != typeof r && (r = r.endsWith("%") ? 255 * parseFloat(r) / 100 : parseFloat(r)), k(Math.round(r), 0, 255);
    }, x = function(e) {
        return k(parseFloat(e), 0, 100);
    };
    function E(e) {
        var r = e;
        return "number" != typeof r && (r = r.endsWith("%") ? parseFloat(r) / 100 : parseFloat(r)), k(r, 0, 1);
    }
    function R(e) {
        var r = function(e, r) {
            if (void 0 === r && (r = {}), "string" != typeof e || y.test(e) || !w.test(e)) throw new TypeError("Expected a valid hex string");
            var n = 1;
            8 === (e = e.replace(/^#/, "")).length && (n = Number.parseInt(e.slice(6, 8), 16) / 255, e = e.slice(0, 6)), 4 === e.length && (n = Number.parseInt(e.slice(3, 4).repeat(2), 16) / 255, e = e.slice(0, 3)), 3 === e.length && (e = e[0] + e[0] + e[1] + e[1] + e[2] + e[2]);
            var a = Number.parseInt(e, 16), l = a >> 16, t = a >> 8 & 255, s = 255 & a, i = "number" == typeof r.alpha ? r.alpha : n;
            return "array" === r.format ? [
                l,
                t,
                s,
                i
            ] : "css" === r.format ? "rgb(" + l + " " + t + " " + s + (1 === i ? "" : " / " + Number((100 * i).toFixed(2)) + "%") + ")" : {
                red: l,
                green: t,
                blue: s,
                alpha: i
            };
        }(e, {
            format: "array"
        });
        return $([
            null,
            r[0],
            r[1],
            r[2],
            r[3]
        ]);
    }
    function $(e) {
        var r = e[1], n = e[2], a = e[3], l = e[4];
        return void 0 === l && (l = 1), {
            type: "rgb",
            values: [
                r,
                n,
                a
            ].map(v),
            alpha: E(null === l ? 1 : l)
        };
    }
    /**
	 * parse-css-color
	 * @version v0.2.1
	 * @link http://github.com/noeldelgado/parse-css-color/
	 * @license MIT
	 */ return function(n) {
        if ("string" != typeof n) return null;
        var a = r.exec(n);
        if (a) return R(a[0]);
        var l = o.exec(n) || s.exec(n);
        if (l) return function(e) {
            var r = e[1], n = e[2], a = e[3], l = e[4];
            void 0 === l && (l = 1);
            var t = r;
            return {
                type: "hsl",
                values: [
                    t = t.endsWith("turn") ? 360 * parseFloat(t) / 1 : t.endsWith("rad") ? Math.round(180 * parseFloat(t) / Math.PI) : parseFloat(t),
                    x(n),
                    x(a)
                ],
                alpha: E(null === l ? 1 : l)
            };
        }(l);
        var t = c.exec(n) || f.exec(n) || u.exec(n) || p.exec(n);
        if (t) return $(t);
        if (b.exec(n)) return $([
            null,
            0,
            0,
            0,
            0
        ]);
        var i = e[n.toLowerCase()];
        return i ? $([
            null,
            i[0],
            i[1],
            i[2],
            1
        ]) : null;
    };
});




/**
 * Verify if the string representation of a CSS color is valid
 * @param colorStr {string} ex: 'black', 'rgb(0,0,0)', rgba(223,111,222,0.4)
 * @return {boolean} true if valid
 */ function $3d11af3e54370855$var$verifyColor(colorStr) {
    try {
        const parsedColor = (0, (/*@__PURE__*/$parcel$interopDefault($5f14bb65263850e1$exports)))(colorStr);
        return !!parsedColor;
    } catch (e) {
        return false;
    }
}
/**
 * A layer style. Can be applied to render vector layers and to render legends for any layer
 * @extends CodeUniqueConfig
 * @hideconstructor
 */ class $3d11af3e54370855$export$d9e45bc13d335801 extends (0, $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1) {
    getClassName() {
        return "Style";
    }
    /**
     * This style geometry type
     * @return {GeometryTypeEnum}
     */ getGeometryType() {
        return (0, $815c91046e476159$export$427161d533086393).getForCode(this.config.geometryType);
    }
    /**
     * The attribute of this style (ex: the value it will look for to paint the correct color in a discrete style)
     * @return {string}
     */ getAttribute() {
        return this.config.attribute;
    }
    /**
     * Get the legend config for this style
     * @return {Legend}
     */ getLegend() {
        if (this.config.legend) return new $3d11af3e54370855$var$Legend(this.config.legend);
    }
    /**
     * Get the rules of this style
     * @return {Array<StyleRule>}
     */ getRules() {
        let styleRules = [];
        if (this.config.styleRules) for(let sr in this.config.styleRules)styleRules.push(new $3d11af3e54370855$var$StyleRule(this.config.styleRules[sr]));
        return styleRules;
    }
    verify() {
        let errors = super.verify();
        if (!this.config.geometryType || this.config.geometryType.length === 0) errors.push(this.getLogId() + ": geometryType is mandatory");
        else if (!(0, $815c91046e476159$export$427161d533086393).exists(this.config.geometryType)) errors.push(this.getLogId() + ": invalid geometryType. Possible values: " + (0, $815c91046e476159$export$427161d533086393).getPossibleCodes());
        const legend = this.getLegend();
        if (legend) errors = errors.concat(legend.verify());
        const rules = this.getRules();
        if (rules.length === 0) errors.push(this.getLogId() + ": styleRules is mandatory");
        else for(let r in rules)errors = errors.concat(rules[r].verify());
        return errors;
    }
}
/**
 * Legend config
 * @extends Config
 * @hideconstructor
 */ class $3d11af3e54370855$var$Legend extends (0, $9bc5df2b24a7fcf6$export$29cd7b75162a9425) {
    getClassName() {
        return "Legend";
    }
    /**
     * A text description for the legend (can be formatted)
     * @return {string}
     */ getLegendDescription() {
        return (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.config.description);
    }
    /**
     * Labels positioning config
     * @return {LabelsPositionEnum}
     */ getLabelsPosition() {
        return (0, $815c91046e476159$export$b0626c1c2473a01e).getForCode(this.config.labelsPosition);
    }
    /**
     * Legend orientation config
     * @return {LegendOrientationEnum}
     */ getLegendOrientation() {
        const orientation = (0, $815c91046e476159$export$ab3075f671a20a10).getForCode(this.config.orientation);
        return orientation ? orientation : (0, $815c91046e476159$export$ab3075f671a20a10).HOIZONTAL;
    }
    verify() {
        const errors = super.verify();
        if (this.config.labelsPosition && this.config.labelsPosition.trim().length > 0 && !(0, $815c91046e476159$export$b0626c1c2473a01e).exists(this.config.labelsPosition)) errors.push(this.getLogId() + ": invalid labels position. Possible values: " + (0, $815c91046e476159$export$b0626c1c2473a01e).getPossibleCodes());
        if (this.config.orientation && this.config.orientation.trim().length > 0 && !(0, $815c91046e476159$export$ab3075f671a20a10).exists(this.config.orientation)) errors.push(this.getLogId() + ": invalid orientation. Possible values: " + (0, $815c91046e476159$export$ab3075f671a20a10).getPossibleCodes());
        return errors;
    }
}
/**
 * Style rule
 * @extends CodeUniqueConfig
 * @hideconstructor
 */ class $3d11af3e54370855$var$StyleRule extends (0, $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1) {
    getClassName() {
        return "StyleRule";
    }
    isNoData() {}
    /**
     * Text label for this rule (translation key). Only for legend
     * @return {string}
     */ getLabel() {
        return (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.config.label);
    }
    /**
     * Type of this rule
     * @return {StyleRuleTypeEnum}
     */ getStyleRuleType() {
        return (0, $815c91046e476159$export$23989178094d68d).getForCode(this.config.type);
    }
    /**
     * This rule's buckets (only if type is DISCRETE)
     * @return {Array<Bucket>}
     */ getBuckets() {
        let buckets = [];
        if (this.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).DISCRETE && this.config.buckets) for(let b in this.config.buckets)buckets.push(new $3d11af3e54370855$var$Bucket(this.config.buckets[b]));
        return buckets;
    }
    /**
     * This rule's ranges (only if type is CONTINUOUS)
     * @return {Array<Range>}
     */ getRanges() {
        let ranges = [];
        if (this.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).CONTINUOUS && this.config.ranges) for(let r in this.config.ranges)ranges.push(new $3d11af3e54370855$var$Range(this.config.ranges[r]));
        return ranges;
    }
    /**
     * This rule's classes (only if type is CLASSIFIED)
     * @return {Array<Clazz>}
     */ getClasses() {
        let classes = [];
        if (this.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).CLASSIFIED && this.config.classes) for(let c in this.config.classes)classes.push(new $3d11af3e54370855$var$Clazz(this.config.classes[c]));
        return classes;
    }
    /**
     * A css color for the background. Only for SIMPLE, NODATA and CLUSTER rule types
     * @return {string}
     */ getBackgroundColor() {
        const styleRuleType = this.getStyleRuleType();
        if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).NODATA || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CLUSTER || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).SIMPLE) return this.config.backgroundColor;
    }
    /**
     * A css color for the border. Only for SIMPLE and NODATA rule types
     * @return {string}
     */ getBorderColor() {
        const styleRuleType = this.getStyleRuleType();
        if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).NODATA || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CLUSTER || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).SIMPLE) return this.config.borderColor;
    }
    /**
     * A border width. Only for SIMPLE and NODATA rule types
     * @return {number}
     */ getBorderWidth() {
        const styleRuleType = this.getStyleRuleType();
        if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).NODATA || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CLUSTER || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).SIMPLE) return this.config.borderWidth;
    }
    /**
     * A radius for points. Only for SIMPLE and NODATA rule types on styles with geometry type POINT
     * @return {number}
     */ getRadius() {
        const styleRuleType = this.getStyleRuleType();
        if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).NODATA || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).SIMPLE) return this.config.radius === undefined ? undefined : Math.min(50, Math.max(2, this.config.radius));
    }
    /**
     * A width for line. Only for SIMPLE and NODATA rule types on styles with geometry type LINE
     * @return {number}
     */ getWidth() {
        const styleRuleType = this.getStyleRuleType();
        if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).NODATA || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).SIMPLE) return this.config.width === undefined ? undefined : Math.min(20, Math.max(1, this.config.width));
    }
    /**
     * A fill pattern. Only for SIMPLE, NODATA rule types
     * @return {FillPattern}
     */ getFillPattern() {
        const styleRuleType = this.getStyleRuleType();
        if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).NODATA || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).SIMPLE || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CLASSIFIED) return this.config.fill === undefined ? undefined : new $3d11af3e54370855$var$FillPattern(this.config.fill);
    }
    /**
     * A line pattern. Only for SIMPLE, NODATA
     * Applicable to lines and polygons
     * @return {LinePattern}
     */ getLinePattern() {
        const styleRuleType = this.getStyleRuleType();
        if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).NODATA || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).SIMPLE) return this.config.linePattern === undefined ? undefined : new $3d11af3e54370855$var$LinePattern(this.config.linePattern);
    }
    /**
     * An image url. Only for SIMPLE and NODATA rule types
     * @return {string}
     */ getImageUrl() {
        return this.config.imageUrl;
    }
    verify() {
        let errors = super.verify();
        if (!this.config.type || this.config.type.length === 0) errors.push(this.getLogId() + ": type is mandatory");
        else if (!(0, $815c91046e476159$export$23989178094d68d).exists(this.config.type)) errors.push(this.getLogId() + ": invalid type. Possible values: " + (0, $815c91046e476159$export$23989178094d68d).getPossibleCodes());
        const styleRuleType = this.getStyleRuleType();
        if (styleRuleType) {
            if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).NODATA || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CLUSTER || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).SIMPLE) {
                if (this.getBackgroundColor() && !$3d11af3e54370855$var$verifyColor(this.getBackgroundColor())) errors.push(this.getLogId() + ': invalid backgroundColor -> ' + this.getBackgroundColor());
                if (this.getBorderColor() && !$3d11af3e54370855$var$verifyColor(this.getBorderColor())) errors.push(this.getLogId() + ': invalid borderColor -> ' + this.getBorderColor());
                if (this.getBorderWidth() != null && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getBorderWidth() || this.getBorderWidth() < 0)) errors.push(this.getLogId() + ': invalid borderWidth -> ' + this.getBorderWidth());
                if (this.getWidth() !== undefined && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getWidth() || this.getWidth() < 0)) errors.push(this.getLogId() + ': invalid width -> ' + this.getWidth());
                if (this.getRadius() !== undefined && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getRadius() || this.getRadius() < 0)) errors.push(this.getLogId() + ': invalid radius -> ' + this.getRadius());
                const fill = this.getFillPattern();
                if (fill) {
                    const fillErrors = fill.verify();
                    for(let fe in fillErrors)errors.push(this.getLogId() + fillErrors[fe]);
                }
            }
            if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CLASSIFIED) {
                const classes = this.getClasses();
                if (classes.length === 0) errors.push(this.getLogId() + ": classes must not be empty");
                else {
                    let values = {};
                    for(let c in classes){
                        errors = errors.concat(classes[c].verify());
                        if (values[classes[c].getValue()] === 'exists') errors.push(this.getLogId() + ': Value ' + classes[c].getValue() + ' repeated on ' + classes[c].getLogId());
                    }
                }
            }
            if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).DISCRETE) {
                const buckets = this.getBuckets();
                if (buckets.length === 0) errors.push(this.getLogId() + ": buckets must not be empty");
                else for(let b in buckets){
                    const bucket = buckets[b];
                    errors = errors.concat(bucket.verify());
                    const overlapsWith = (bucket2Test, index)=>{
                        const res = [];
                        const overlap = (b1, b2)=>{
                            if (b1.verify().length === 0 && b2.verify().length === 0) {
                                const b1Max = b1.getMaxValue() !== undefined ? b1.getMaxValue() : Number.MAX_VALUE;
                                const b1Min = b1.getMinValue() !== undefined ? b1.getMinValue() : Number.MAX_VALUE * -1;
                                const b2Max = b2.getMaxValue() !== undefined ? b2.getMaxValue() : Number.MAX_VALUE;
                                const b2Min = b2.getMinValue() !== undefined ? b2.getMinValue() : Number.MAX_VALUE * -1;
                                if (b1Min > b2Min && b1Min < b2Max || b2Min > b1Min && b2Min < b1Max) debugger;
                                return b1Min > b2Min && b1Min < b2Max || b2Min > b1Min && b2Min < b1Max;
                            }
                        };
                        for(let b in buckets)if (b !== index && overlap(bucket2Test, buckets[b])) res.push(b);
                        return res;
                    };
                    const overlappedIndexes = overlapsWith(bucket, b);
                    if (overlappedIndexes.length > 0) errors.push(this.getLogId() + ': Bucket ' + b + ' overlaps with buckets at positions ' + JSON.stringify(overlappedIndexes));
                }
            }
            if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CONTINUOUS) {
                const ranges = this.getRanges();
                if (ranges.length === 0) errors.push(this.getLogId() + ": ranges must not be empty");
                else for(let r in ranges){
                    errors = errors.concat(ranges[r].verify());
                    const rangeIndex = Number(r);
                    if (ranges.length > 1) {
                        if (rangeIndex > 0 && ranges[rangeIndex].getMinValue() !== undefined && ranges[rangeIndex - 1].getMaxValue() !== undefined && ranges[rangeIndex].getMinValue() < ranges[rangeIndex - 1].getMaxValue()) errors.push(this.getLogId() + ': Ranges overlap at positions ' + (rangeIndex - 1) + ' and ' + rangeIndex);
                    }
                }
            }
            if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).SIMPLE) {
                if (this.getImageUrl() !== undefined && this.getImageUrl().length === 0) errors.push(this.getLogId() + ': invalid imageUrl -> ' + this.getImageUrl());
            }
            if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).EXTERNAL_DYNAMIC_IMAGE || styleRuleType === (0, $815c91046e476159$export$23989178094d68d).EXTERNAL_IMAGE) {
                if (!this.getImageUrl() || this.getImageUrl().length === 0) errors.push(this.getLogId() + ': imageUrl is mandatory.');
                else if (this.getImageUrl().length === 0) errors.push(this.getLogId() + ': invalid imageUrl -> ' + this.getImageUrl());
            }
        }
        return errors;
    }
}
/**
 * Any rule entry
 * @extends Config
 * @hideconstructor
 */ class $3d11af3e54370855$var$AbstractRuleEntry extends (0, $9bc5df2b24a7fcf6$export$29cd7b75162a9425) {
    getClassName() {
        return "AbstractRuleEntry";
    }
    /**
     * A CSS color for the border
     * @return {string}
     */ getBorderColor() {
        return this.config.borderColor;
    }
    /**
     * The width of the border in pixels
     * @return {number}
     */ getBorderWidth() {
        return this.config.borderWidth;
    }
    /**
     * The radius for point geometries
     * @return {undefined|number}
     */ getRadius() {
        return this.config.radius === undefined ? undefined : Math.min(50, Math.max(2, this.config.radius));
    }
    /**
     * The width for line geometries
     * @return {undefined|number}
     */ getWidth() {
        return this.config.width === undefined ? undefined : Math.min(20, Math.max(1, this.config.width));
    }
    verify() {
        const errors = super.verify();
        if (this.getBorderColor() && !$3d11af3e54370855$var$verifyColor(this.getBorderColor())) errors.push(this.getLogId() + ': invalid borderColor -> ' + this.getBorderColor());
        if (this.getBorderWidth() != null && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getBorderWidth() || this.getBorderWidth() < 0)) errors.push(this.getLogId() + ': invalid borderWidth -> ' + this.getBorderWidth());
        if (this.getWidth() !== undefined && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getWidth() || this.getWidth() < 0)) errors.push(this.getLogId() + ': invalid width -> ' + this.getWidth());
        if (this.getRadius() !== undefined && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getRadius() || this.getRadius() < 0)) errors.push(this.getLogId() + ': invalid radius -> ' + this.getRadius());
        return errors;
    }
}
/**
 * A fill pattern
 * @extends Config
 * @hideconstructor
 */ class $3d11af3e54370855$var$FillPattern extends (0, $9bc5df2b24a7fcf6$export$29cd7b75162a9425) {
    getClassName() {
        return "FillPattern";
    }
    /**
     * The pattern type
     * @return {FillPatternTypeEnum}
     */ getFillPatternType() {
        return (0, $815c91046e476159$export$a94ab4528edf2788).getForCode(this.config.type);
    }
    /**
     * The width of the lines in pixels
     * @return {undefined|number}
     */ getWidth() {
        return this.config.width === undefined ? undefined : Math.min(5, Math.max(1, this.config.width));
    }
    /**
     * The radius of the dots in pixels
     * @return {undefined|number}
     */ getRadius() {
        return this.config.radius === undefined ? undefined : Math.min(10, Math.max(2, this.config.radius));
    }
    /**
     * The CSS color of the dots/lines
     * @return {string}
     */ getColor() {
        return this.config.color;
    }
    verify() {
        const errors = super.verify();
        if (this.config.type && this.config.type.length > 0 && !(0, $815c91046e476159$export$a94ab4528edf2788).exists(this.config.type)) errors.push(this.getLogId() + ': invalid type. Possible values: ' + (0, $815c91046e476159$export$a94ab4528edf2788).getPossibleCodes());
        if (this.getColor() && !$3d11af3e54370855$var$verifyColor(this.getColor())) errors.push(this.getLogId() + ': invalid color -> ' + this.getColor());
        if (this.getWidth() != null && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getWidth() || this.getWidth() < 0)) errors.push(this.getLogId() + ': invalid width -> ' + this.getWidth());
        if (this.getWidth() !== undefined && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getWidth() || this.getWidth() < 0)) errors.push(this.getLogId() + ': invalid width -> ' + this.getWidth());
        if (this.getRadius() !== undefined && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getRadius() || this.getRadius() < 0)) errors.push(this.getLogId() + ': invalid radius -> ' + this.getRadius());
        return errors;
    }
}
/**
 * A line pattern
 * @extends Config
 * @hideconstructor
 */ class $3d11af3e54370855$var$LinePattern extends (0, $9bc5df2b24a7fcf6$export$29cd7b75162a9425) {
    getClassName() {
        return "LinePattern";
    }
    /**
     * The pattern type
     * @return {LinePatternTypeEnum}
     */ getLinePatternType() {
        return (0, $815c91046e476159$export$6b4efad1d1b9c97e).getForCode(this.config.type);
    }
    /**
     * The width of the line in pixels
     * @return {undefined|number}
     */ getWidth() {
        return this.config.width === undefined ? undefined : Math.min(5, Math.max(1, this.config.width));
    }
    /**
     * The CSS color of the dots/lines
     * @return {string}
     */ getColor() {
        return this.config.color;
    }
    verify() {
        const errors = super.verify();
        if (this.config.type && this.config.type.length > 0 && !(0, $815c91046e476159$export$6b4efad1d1b9c97e).exists(this.config.type)) errors.push(this.getLogId() + ': invalid type. Possible values: ' + (0, $815c91046e476159$export$6b4efad1d1b9c97e).getPossibleCodes());
        if (this.getColor() && !$3d11af3e54370855$var$verifyColor(this.getColor())) errors.push(this.getLogId() + ': invalid color -> ' + this.getColor());
        if (this.getWidth() != null && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getWidth() || this.getWidth() < 0)) errors.push(this.getLogId() + ': invalid width -> ' + this.getWidth());
        if (this.getWidth() !== undefined && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getWidth() || this.getWidth() < 0)) errors.push(this.getLogId() + ': invalid width -> ' + this.getWidth());
        return errors;
    }
}
/**
 * Any min/max rule entry
 * @extends AbstractRuleEntry
 * @hideconstructor
 */ class $3d11af3e54370855$var$AbstractMinMaxRuleEntry extends $3d11af3e54370855$var$AbstractRuleEntry {
    /**
     * The min value
     * @return {number}
     */ getMinValue() {
        return this.config.minValue;
    }
    /**
     * The max value
     * @return {number}
     */ getMaxValue() {
        return this.config.maxValue;
    }
    verify() {
        const errors = super.verify();
        if (this.getMinValue() === undefined && this.getMaxValue() === undefined) errors.push(this.getLogId() + ': one of minValue and maxValue is mandatory');
        if (this.getMinValue() !== undefined && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getMinValue())) errors.push(this.getLogId() + ': invalid minValue -> ' + this.getMinValue());
        if (this.getMaxValue() !== undefined && !(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getMaxValue())) errors.push(this.getLogId() + ': invalid maxValue -> ' + this.getMaxValue());
        if (this.getMinValue() !== undefined && this.getMaxValue() !== undefined) {
            if (this.getMinValue() > this.getMaxValue()) errors.push(this.getLogId() + ': invalid minValue/maxValue -> (min <> max) ' + this.getMinValue() + ' <> ' + this.getMaxValue());
        }
        return errors;
    }
}
/**
 * A bucket for DISCRETE rules
 * @extends AbstractMinMaxRuleEntry
 * @hideconstructor
 */ class $3d11af3e54370855$var$Bucket extends $3d11af3e54370855$var$AbstractMinMaxRuleEntry {
    getClassName() {
        return "Bucket";
    }
    /**
     * A CSS color for the bucket's background
     * @return {string}
     */ getBackgroundColor() {
        return this.config.backgroundColor;
    }
    /**
     * A translatable key for the bucket label
     * @return {string}
     */ getLabel() {
        return this.config.label;
    }
    /**
     * A translatable key for the bucket minimum label
     * @return {string}
     */ getMinLabel() {
        return this.config.minLabel;
    }
    /**
     * A translatable key for the bucket maximum label
     * @return {string}
     */ getMaxLabel() {
        return this.config.maxLabel;
    }
    /**
     * A translatable key for the bucket group label
     * @return {string}
     */ getGroupLabel() {
        return this.config.groupLabel;
    }
    verify() {
        const errors = super.verify();
        const noMinValue = this.getMinValue() === undefined;
        const noMaxValue = this.getMaxValue() === undefined;
        if (noMinValue && noMaxValue) errors.push(this.getLogId() + ': one of minValue and maxValue is mandatory');
        if (this.getBackgroundColor() && !$3d11af3e54370855$var$verifyColor(this.getBackgroundColor())) errors.push(this.getLogId() + ': invalid backgroundColor -> ' + this.getBackgroundColor());
        return errors;
    }
}
/**
 * A range for CONTINUOUS rules
 * @extends AbstractMinMaxRuleEntry
 * @hideconstructor
 */ class $3d11af3e54370855$var$Range extends $3d11af3e54370855$var$AbstractMinMaxRuleEntry {
    getClassName() {
        return "Range";
    }
    /**
     * The minimum CSS color for the range's background
     * @return {string}
     */ getMinBackgroundColor() {
        return this.config.minBackgroundColor;
    }
    /**
     * The maximum CSS color for the range's background
     * @return {string}
     */ getMaxBackgroundColor() {
        return this.config.maxBackgroundColor;
    }
    /**
     * A translatable key for the range minimum label
     * @return {string}
     */ getMinLabel() {
        return this.config.minLabel;
    }
    /**
     * A translatable key for the range maximum label
     * @return {string}
     */ getMaxLabel() {
        return this.config.maxLabel;
    }
    /**
     * A translatable key for the range group label
     * @return {string}
     */ getGroupLabel() {
        return this.config.groupLabel;
    }
    verify() {
        const errors = super.verify();
        const noMinValue = this.getMinValue() === undefined;
        const noMaxValue = this.getMaxValue() === undefined;
        if (noMinValue || noMaxValue) errors.push(this.getLogId() + ': both of minValue and maxValue are mandatory');
        if (!this.getMinBackgroundColor()) errors.push(this.getLogId() + ': minBackgroundColor is mandatory');
        else if (!$3d11af3e54370855$var$verifyColor(this.getMinBackgroundColor())) errors.push(this.getLogId() + ': invalid minBackgroundColor -> ' + this.getMinBackgroundColor());
        if (!this.getMaxBackgroundColor()) errors.push(this.getLogId() + ': maxBackgroundColor is mandatory');
        else if (!$3d11af3e54370855$var$verifyColor(this.getMaxBackgroundColor())) errors.push(this.getLogId() + ': invalid maxBackgroundColor -> ' + this.getMaxBackgroundColor());
        return errors;
    }
}
/**
 * A class for CLASSIFIED rules
 * @extends AbstractRuleEntry
 * @hideconstructor
 */ class $3d11af3e54370855$var$Clazz extends $3d11af3e54370855$var$AbstractRuleEntry {
    getClassName() {
        return "Clazz";
    }
    /**
     * A CSS color for the class's background
     * @return {string}
     */ getBackgroundColor() {
        return this.config.backgroundColor;
    }
    /**
     * A translatable key for the class label
     * @return {string}
     */ getLabel() {
        return this.config.label;
    }
    /**
     * A translatable key for the class group label
     * @return {string}
     */ getGroupLabel() {
        return this.config.groupLabel;
    }
    /**
     * This class's value
     * @return {string}
     */ getValue() {
        return this.config.value !== undefined && this.config.value !== null ? '' + this.config.value : undefined;
    }
    getFillPattern() {
        return this.config.fill === undefined ? undefined : new $3d11af3e54370855$var$FillPattern(this.config.fill);
    }
    getLinePattern() {
        return this.config.linePattern === undefined ? undefined : new $3d11af3e54370855$var$LinePattern(this.config.linePattern);
    }
    verify() {
        let errors = super.verify();
        if (this.getBackgroundColor() && !$3d11af3e54370855$var$verifyColor(this.getBackgroundColor())) errors.push(this.getLogId() + ': invalid backgroundColor -> ' + this.getBackgroundColor());
        if (this.getLinePattern()) errors = errors.concat(this.getLinePattern().verify());
        if (this.getFillPattern()) errors = errors.concat(this.getFillPattern().verify());
        return errors;
    }
}



var $feAbh = parcelRequire("feAbh");





/**
 * Configuration of a Tumbo application
 * @abstract
 * @extends Base
 */ class $2a1bdf5b8bad2f9b$export$f6e3e72c68493c4c extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     *
     * @param config {Object} The config object
     */ constructor(config){
        super();
        this._initialConfig = config;
        this.reset();
    }
    getClassName() {
        return "MainConfig";
    }
    _clone(obj) {
        return JSON.parse(JSON.stringify(obj));
    }
    /**
     * Reset this config to its original state from the original config object
     */ reset() {
        (0, $9bc5df2b24a7fcf6$export$e8c716be77a99153)._CODES_BY_CLASS = {};
        this.config = this._clone(this._initialConfig);
        this._loadAllServiceWarningMessages();
        this._loadAllStyles();
        this._loadAllLayerServices();
        this._loadAllProducts();
    }
    _loadAllServiceWarningMessages() {
        this.allServiceWarningMessages = {};
        this.getAllServiceWarningMessages().forEach((wm)=>{
            if (!this.allServiceWarningMessages[wm.getServiceCode()]) this.allServiceWarningMessages[wm.getServiceCode()] = [];
            this.allServiceWarningMessages[wm.getServiceCode()].push(wm);
        });
    }
    /**
     * All the available styles
     * @return {Object<string,Style>}
     */ _loadAllStyles() {
        this.allStyles = {};
        if (this.config.styles) for(let s in this.config.styles){
            const style = new (0, $3d11af3e54370855$export$d9e45bc13d335801)(this.config.styles[s]);
            this.allStyles[style.getCode()] = style;
        }
    }
    _loadAllLayerServices() {
        this.allLayerServices = {};
        if (this.config.services) for(let d in this.config.services){
            const layerService = new $2a1bdf5b8bad2f9b$export$e195ecca6214af99(this.config.services[d], this.allServiceWarningMessages);
            this.allLayerServices[layerService.getCode()] = layerService;
        }
    }
    _loadAllProducts() {
        this.allProducts = {};
        if (this.config.products) for(let p in this.config.products){
            const product = new $2a1bdf5b8bad2f9b$export$b84bcfe50479da8(this.config.products[p], this.getScaleId());
            this.allProducts[product.getCode()] = product;
        }
    }
    /**
     * The name
     * @return {string}
     */ getName() {}
    /**
     * The scale id param to pass to the download indicator service
     * @return {string}
     */ getScaleId() {
        return this.getCode().split('_')[0];
    }
    /**
     * The code. Should be unique among deployments
     * @return {string}
     */ getCode() {}
    /**
     * Stats post URL
     * @return {string}
     */ getStatsPostUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this._getStatsPostUrlProperty());
    }
    /**
     * Contact post URL
     * @return {string}
     */ getContactPostUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this._getContactPostUrlProperty());
    }
    /**
     * Should be overridden to return the stats post URL
     * @private
     */ _getStatsPostUrlProperty() {}
    /**
     * Should be overridden to return the contact post URL
     * @private
     */ _getContactPostUrlProperty() {}
    /**
     * Get all general warning messages
     * @return {Array<WarningMessageConfig>}
     */ getGeneralWarningMessages() {
        if (this.config.warningMessages && this.config.warningMessages.general) return this.config.warningMessages.general.map((g)=>new $2a1bdf5b8bad2f9b$var$WarningMessageConfig(g));
        return [];
    }
    /**
     * Get all service warning messages
     * @return {Array<ServiceWarningMessageConfig>}
     */ getAllServiceWarningMessages() {
        if (this.config.warningMessages && this.config.warningMessages.service) return this.config.warningMessages.service.map((g)=>new $2a1bdf5b8bad2f9b$var$ServiceWarningMessageConfig(g, this.allLayerServices));
        return [];
    }
    /**
     * Verify this configuration and return a list of errors
     * @return {Array<string>}
     */ verify() {
        (0, $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1)._ALL_CODES = {};
        let errors = [];
        if (!this.getName() || this.getName().length === 0) errors.push(this.getClass() + ': name is mandatory');
        if (!this.getCode() || this.getCode().length === 0) errors.push(this.getClass() + ': code is mandatory');
        if (this.getStatsPostUrl() && this.getStatsPostUrl().length > 0) {
            if (!(0, $9bc5df2b24a7fcf6$export$cf70820c5d4688d8)(this.getStatsPostUrl())) errors.push(this.getClass() + ': Invalid url on statsPostUrl');
        }
        this.getGeneralWarningMessages().forEach((w)=>errors = errors.concat(w.verify()));
        this.getAllServiceWarningMessages().forEach((w)=>errors = errors.concat(w.verify()));
        return errors;
    }
    /**
     * Override this config
     * @param runtimeConfig {RuntimeConfig} The configuration override
     */ override(runtimeConfig) {}
}
/**
 * Runtime configuration of a Tumbo application
 * Stores data that override the initial config
 * @abstract
 * @extends Base
 */ class $2a1bdf5b8bad2f9b$export$ec56e2f5cfeae5ef extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     * @param code {string} Unique identifier for this runtime config
     * @param config {Object} The config object
     */ constructor(code, config){
        super();
        this.code = code;
        this.config = config;
        if (!this.config) this.clean();
    }
    getClassName() {
        return "RuntimeConfig";
    }
    /**
     * Unique identifier for this runtime config
     * @return {string}
     */ getCode() {
        return this.code;
    }
    /**
     * Clean this runtime config
     */ clean() {}
    /**
     * Get the configuration object suitable to override MainConfig
     * @return {Object}
     */ getConfigOverrideObject() {
        return this.config;
    }
    /**
     * Get the serialized version of this runtime config, suitable to store
     * @return {string}
     */ getSerializedConfig() {
        // return (JSON.stringify(this.getConfigOverrideObject()));
        return $feAbh.compressToBase64(JSON.stringify(this.getConfigOverrideObject()));
    }
    /**
     * Get the serialized version of this runtime config, suitable to use in an URL
     * @return {string}
     */ getSharableSerializedConfig() {
        const config2Share = JSON.parse(JSON.stringify(this.getConfigOverrideObject()));
        if (config2Share.t && config2Share.t["comparator"]) delete config2Share.t["comparator"];
        return $feAbh.compressToBase64(JSON.stringify(config2Share));
    }
    /**
     * set a value for a property of a tool
     * @param toolCode {string} The tool code
     * @param propCode {string} the property code
     * @param value {*} the value of the property
     */ setToolProperty(toolCode, propCode, value) {
        this.config.t[toolCode] = this.config.t[toolCode] || {};
        this.config.t[toolCode][propCode] = value;
    }
    /**
     * get the value for a property of a tool
     * @param toolCode {string} The tool code
     * @param propCode {string} the property code
     * @return {*} the value of the property
     */ getToolProperty(toolCode, propCode) {
        return this.config.t && this.config.t[toolCode] ? this.config.t[toolCode][propCode] : undefined;
    }
    /**
     * Set a property value that lasts for this session (ends on close tab)
     * @param uiElemCode {string} the unique id of this UI element
     * @param prop {string} A property key
     * @param value {*} any value
     */ setUIElementSessionProp(uiElemCode, prop, value) {
        sessionStorage.setItem(this.code + "_" + uiElemCode + "_" + prop, JSON.stringify({
            value: value
        }));
    }
    /**
     * Remove a property
     * @param uiElemCode {string} the unique id of this UI element
     * @param prop {string} A property key
     */ removeUIElementSessionProp(uiElemCode, prop) {
        sessionStorage.removeItem(this.code + "_" + uiElemCode + "_" + prop);
    }
    /**
     * Is there a value for a property key?
     * @param uiElemCode {string} the unique id of this UI element
     * @param prop {string} A property key
     * @return {boolean}
     */ hasUIElementSessionProp(uiElemCode, prop) {
        for(let i = 0; i < sessionStorage.length; i++){
            if (sessionStorage.key(i) === this.code + "_" + uiElemCode + "_" + prop) return true;
        }
        return false;
    }
    /**
     * Get a value by property key
     * @param uiElemCode {string} the unique id of this UI element
     * @param prop {string} A property key
     * @return {*}
     */ getUIElementSessionProp(uiElemCode, prop) {
        const serialized = sessionStorage.getItem(this.code + "_" + uiElemCode + "_" + prop);
        if (serialized) try {
            return JSON.parse(serialized).value;
        } catch (e) {
            this.logError("Error deserializing prop " + prop + ", of UI element " + uiElemCode, e);
        }
    }
}
/**
 * A configuration part that overrides configuration properties
 */ class $2a1bdf5b8bad2f9b$var$ConfigOverride extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    getClassName() {
        return "ConfigOverride";
    }
    /**
     *
     * @param config {Array<Object>} The overrides. Each element must have "start" and "end" properties (format: "MM-DD") that indicate the time validity of the override. \
     * The remaining properties are the actual overrides and property names must match the overridden properties
     * @param overridableProps {Array<String>} All the properties that are overridable (any other property will be ignored in the config)
     */ constructor(config, overridableProps){
        super();
        this.config = config;
        this.overridableProps = overridableProps ? overridableProps : [];
    }
    /**
     * All the overridable properties
     * @return {[]|Array<String>}
     */ getOverridableProps() {
        return this.overridableProps;
    }
    /**
     * Does it override a property in the given date
     * @param propName {string} The property name
     * @param date {Date} The date
     * @return {boolean}
     */ overridesProperty(propName, date) {
        if (!this.config || !date || !(0, $2536f84a954bf107$export$51c197c9b00a6c1c)(propName) || this.overridableProps.length > 0 && this.overridableProps.indexOf(propName) < 0) return false;
        const overrideElements = this.config.filter((c)=>this._isIn(c, date) && Object.keys(c).indexOf(propName) >= 0);
        return overrideElements.length > 0;
    }
    /**
     * Get the overridden value for a property in a given date. Returns defaultValue if the property is not overridden for the given date
     * @param propName {string} The property name
     * @param date {Date} The date
     * @param defaultValue {*} The value to return of the property if not overridden
     * @return {*}
     */ getValueForProperty(propName, date, defaultValue) {
        if (!date || !this.overridesProperty(propName, date)) return defaultValue;
        const overrideElements = this.config.filter((c)=>this._isIn(c, date) && Object.keys(c).indexOf(propName) >= 0);
        return overrideElements[0][propName];
    }
    /**
     * Is the given property overridden, despite the date?
     * @param propName {string} The property name
     * @return {boolean}
     */ overridesPropertyAnyDate(propName) {
        if (!this.config || !(0, $2536f84a954bf107$export$51c197c9b00a6c1c)(propName) || this.overridableProps.length > 0 && this.overridableProps.indexOf(propName) < 0) return false;
        const overrideElements = this.config.filter((c)=>Object.keys(c).indexOf(propName) >= 0);
        return overrideElements.length > 0;
    }
    /**
     * Get all the overriding values for a property, despite the date
     * @param propName {string} The property name
     * @return {Array<*>}
     */ getAllValuesForProperty(propName) {
        if (!this.overridesPropertyAnyDate(propName)) return [];
        return this.config.filter((c)=>Object.keys(c).indexOf(propName) >= 0).map((c)=>c[propName]);
    }
    _isIn(overrideElement, date) {
        const year = date.getFullYear();
        const startSplit = overrideElement.start.split('-');
        const startMonth = Number(startSplit[0].trim());
        const startDay = Number(startSplit[1].trim());
        const endSplit = overrideElement.end.split('-');
        const endMonth = Number(endSplit[0].trim());
        const endDay = Number(endSplit[1].trim());
        const startDate = (0, $aeedcab592f41cce$export$2b6cf20b1d58ec45)(year, startMonth, startDay);
        const endDate = (0, $aeedcab592f41cce$export$2b6cf20b1d58ec45)(year, endMonth, endDay);
        const isInside = (intervalMin, intervalMax, instant)=>instant >= intervalMin && instant < intervalMax;
        if (startDate > endDate) return !isInside(endDate, startDate, date);
        else return isInside(startDate, endDate, date);
    }
    /**
     * Verify this configuration and return a list of errors
     * @return {Array<string>}
     */ verify() {
        const errors = [];
        if (this.config) {
            const vefifyDate = (index, overrideElement, datePropName)=>{
                if (!(0, $2536f84a954bf107$export$51c197c9b00a6c1c)(overrideElement[datePropName])) errors.push("override [" + index + "]: " + datePropName + " is mandatory");
                else if (!(0, $aeedcab592f41cce$export$5f691ceae06458b4)(new Date().getFullYear() + '-' + (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(overrideElement[datePropName]))) errors.push("override [" + index + "]: " + datePropName + " is invalid. format must be: MM-DD");
            };
            for(let i = 0; i < this.config.length; i++){
                vefifyDate(i, this.config[i], 'start');
                vefifyDate(i, this.config[i], 'end');
            }
        }
        return errors;
    }
}
/**
 * A general warning message for the user
 * @extends CodeUniqueConfig
 * @hideconstructor
 */ class $2a1bdf5b8bad2f9b$var$WarningMessageConfig extends (0, $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1) {
    getClassName() {
        return "WarningMessageConfig";
    }
    getMessage() {
        return this.config.message;
    }
    verify() {
        const errors = super.verify();
        if (!this.config.message || this.config.message.trim().length === 0) errors.push(this.getLogId() + ": message is mandatory");
        else if (this.getMessage().length > 600) errors.push(this.getLogId() + ": message cannot have more than 600 chars (has " + this.getMessage().length + ")");
        if (this.getStart() && this.getEnd() && this.getStart() > this.getEnd()) errors.push(this.getLogId() + ": invalid dates");
        return errors;
    }
    getStart() {
        return this.config.start && this.config.start.trim().length > 0 ? (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.config.start) : undefined;
    }
    getEnd() {
        return this.config.end && this.config.end.trim().length > 0 ? (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.config.end) : undefined;
    }
    /**
     * Should this message be shown now?
     * @return {boolean}
     */ shouldBeShown() {
        const now = new Date();
        if (this.getStart() && this.getStart() > now) return false;
        if (this.getEnd() && this.getEnd() < now) return false;
        return true;
    }
}
/**
 * A warning message related to a certain service
 * @extends WarningMessageConfig
 * @hideconstructor
 */ class $2a1bdf5b8bad2f9b$var$ServiceWarningMessageConfig extends $2a1bdf5b8bad2f9b$var$WarningMessageConfig {
    getClassName() {
        return "ServiceWarningMessageConfig";
    }
    getServiceCode() {
        return this.config.srvCode;
    }
    verify() {
        const errors = super.verify();
        if (!this.config.srvCode || this.config.srvCode.trim().length === 0) errors.push(this.getLogId() + ": srvCode is mandatory");
        return errors;
    }
}
/**
 * The config of an element of the layer tree
 * @extends CodeUniqueNameInfoConfig
 * @hideconstructor
 */ class $2a1bdf5b8bad2f9b$export$c050f652724ec965 extends (0, $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1) {
    getClassName() {
        return "LayerTreeElementConfig";
    }
    /**
     * The type of the element
     * @return {LayerGroupTypeEnum}
     */ getType() {
        return (0, $815c91046e476159$export$9ae7e512bcbacef8).getForCode(this.config.type);
    }
    /**
     * Is this element visible?
     * @return {boolean}
     */ isVisible() {
        return this.config.visible === true;
    }
    /**
     * Device visibility of this element
     * @return {DeviceVisibilityEnum}
     */ getDeviceVisibility() {
        return (0, $815c91046e476159$export$54c4fd5984b65e0b).getForCode(this.config.deviceVisibility);
    }
    /**
     * Opacity of this element
     * @return {number} [0 .. 1]
     */ getOpacity() {
        return this.config.opacity !== undefined && this.config.opacity !== null ? this.config.opacity : 1;
    }
    /**
     * The render ordinal. If defined, overrides the layer tree ordinal
     * @return {number|undefined}
     */ getRenderOrdinal() {
        return (0, $2536f84a954bf107$export$a0a81dc3380ce7d3)(this.config.renderOrdinal);
    }
    /**
     * This element's children
     * @param includeDisabled {Boolean} if true, includes disabled children
     * @return {Array<LayerTreeElementConfig>}
     */ getChildren(includeDisabled = false) {
        return [];
    }
    /**
     * Is tree element disabled?
     * @return {*}
     */ isDisabled() {
        return this.config.disabled;
    }
    verify() {
        let errors = super.verify(this);
        if (!this.config.type || this.config.type.length === 0) errors.push(this.getLogId() + ": type is mandatory");
        else if (!(0, $815c91046e476159$export$9ae7e512bcbacef8).exists(this.config.type)) errors.push(this.getLogId() + ": invalid type. Possible values: " + (0, $815c91046e476159$export$9ae7e512bcbacef8).getPossibleCodes());
        if (this.config.deviceVisibility && this.config.deviceVisibility.length > 0 && !(0, $815c91046e476159$export$54c4fd5984b65e0b).exists(this.config.deviceVisibility)) errors.push(this.getLogId() + ": invalid deviceVisibility. Possible values: " + (0, $815c91046e476159$export$54c4fd5984b65e0b).getPossibleCodes());
        if (this.getOpacity() !== undefined && (this.getOpacity() < 0 || this.getOpacity() > 1)) errors.push(this.getLogId() + ': opacity must be a value between 0 and 1');
        if (this.config.renderOrdinal !== null && this.config.renderOrdinal !== undefined) {
            const number = (0, $2536f84a954bf107$export$a0a81dc3380ce7d3)(this.config.renderOrdinal);
            if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(number)) {
                if (number < 0) errors.push(this.getLogId() + ": renderOrdinal must be >= 0");
            } else errors.push(this.getLogId() + ": renderOrdinal must be a number");
        }
        if (this.config.disabled !== null && this.config.disabled !== undefined) {
            if (!(0, $2536f84a954bf107$export$f9ce7b637dfbe238)(this.config.disabled)) errors.push(this.getLogId() + ": disabled must be a boolean");
        }
        return errors;
    }
}
/**
 * The config of a layer, which is a tree leaf
 * @extends LayerTreeElementConfig
 */ class $2a1bdf5b8bad2f9b$export$1e0909f3e93883c6 extends $2a1bdf5b8bad2f9b$export$c050f652724ec965 {
    static PRODUCT_DATES = {};
    /**
     *
     * @param config {Object} The config object
     * @param allServices {Object<String,LayerServiceConfig>} All the available layer services
     * @param allProducts {Object<String,ProductConfig>} All the available products
     * @param allStyles {Object<String,Style>} All the available styles
     */ constructor(config, allServices, allProducts, allStyles){
        super(config);
        this.service = allServices[this.config.srvCode];
        this.allStyles = allStyles;
        this.allServices = allServices;
        this.allProducts = allProducts;
        (this.service.getTimeScales() && this.service.getTimeScales().length > 0 ? this.service.getTimeScales() : [
            null
        ]).forEach((ts)=>{
            const prod = this.getProduct(ts);
            if (!$2a1bdf5b8bad2f9b$export$1e0909f3e93883c6.PRODUCT_DATES[prod.getCode()]) $2a1bdf5b8bad2f9b$export$1e0909f3e93883c6.PRODUCT_DATES[prod.getCode()] = {
                startDay: (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(prod.getDataFrom()),
                endDay: (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(prod.getDataUntil()),
                frequency: prod.getPeriodicity() ? prod.getPeriodicity().getCode() : undefined
            };
        });
    }
    getClassName() {
        return "LayerConfig";
    }
    clone() {
        return new this.__proto__.constructor(JSON.parse(JSON.stringify(this.config)), this.allServices, this.allProducts, this.allStyles);
    }
    /**
     *
     * @return {LayerServiceConfig}
     */ getService() {
        return this.service;
    }
    /**
     *
     * @param timeScale {TimeScaleEnum}
     * @return {ProductConfig}
     */ getProduct(timeScale) {
        return this.config.prodCode ? timeScale ? this.allProducts[this.config.prodCode.format([
            timeScale.getCode()
        ])] : this.allProducts[this.config.prodCode] : undefined;
    }
    /**
     * This layer's min zoom level
     * @return {number} (integer)
     */ getMinZoomLevel() {
        return this.config.minZoomLevel;
    }
    /**
     * This layer's max zoom level
     * @return {number} (integer)
     */ getMaxZoomLevel() {
        return this.config.maxZoomLevel;
    }
    /**
     * Get the cluster size in meters. If present, vector layer features will be clustered if they are closer than this distance
     * @return {*} (integer)
     */ getClusterSizePixels() {
        return this.config.clusterSizePixels;
    }
    /**
     * This layer's styles
     * @return {Array<string>}
     */ getStyleCodes() {
        return this.config.styles;
    }
    /**
     * This layer's style for the accumulated chart
     * @return {string}
     */ getAccumulatedStyleCode() {
        return this.config.accumulatedStyle;
    }
    /**
     * This layer's styles
     * @return {Array<Style>}
     */ getStyles() {
        const styles = [];
        if (this.config.styles) for(let s in this.config.styles){
            const style = this.allStyles[this.config.styles[s]];
            if (style) styles.push(style);
        }
        return styles;
    }
    /**
     * This layer's style for the accumulated chart
     * @return {Style}
     */ getAccumulatedStyle() {
        if (this.getAccumulatedStyleCode()) {
            const style = this.allStyles[this.getAccumulatedStyleCode()];
            if (style) return style;
        }
    }
    /**
     * This layer's current time code
     * @return {string} (YYYY-MM-DD)
     */ getTimeCode() {
        return this.config.timeCode;
    }
    /**
     * This layer's time group tag
     * Used for grouping layers (independent of classifiers) that will be time synchronous
     * @return {string}
     */ getTimeTag() {
        return (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.config.timeTag);
    }
    /**
     * This layer's current time scale
     * @return {TimeScaleEnum}
     */ getTimeScale() {
        return (0, $815c91046e476159$export$d08fec65c77806fd).getForCode(this.config.timeScale);
    }
    /**
     * This layer's chart type
     * @return {IndicatorChartTypeEnum}
     */ getChartType() {
        return (0, $815c91046e476159$export$39c0195897d703ce).getForCode(this.config.chartType);
    }
    /**
     * If true, this layer is available for the identify tool
     * @return {boolean}
     */ isIdentifiable() {
        return this.config.identifiable === true;
    }
    /**
     * If true, the indicator of this layer is "playable"
     * @return {boolean}
     */ isPlayable() {
        return this.config.playable === true;
    }
    /**
     * The services driven by this layer. These services may or may not be added as independent layers in the layer tree
     * @return {Array<DrivenServiceConfig>}
     */ getDrivenServices() {
        if (!this.drivenServices) this.drivenServices = (this.config.drivenServices ? this.config.drivenServices : []).map((ds)=>new $2a1bdf5b8bad2f9b$var$DrivenServiceConfig(ds, this.allServices, this.allStyles));
        return this.drivenServices;
    }
    /**
     * Number of decimal places to round to when showing values to the user
     * @return {Number} (integer)
     */ getNrOfDecimals() {
        return this.config.nrOfDecimals;
    }
    override(runtimeConfig) {
        super.override(runtimeConfig);
        const layerTimeCode = runtimeConfig.getLayerTimeCode(this.getCode());
        if (layerTimeCode !== undefined) {
            const timeStamp = (0, $2536f84a954bf107$export$844ec244b1367d54)(layerTimeCode.ts) ? new Date(layerTimeCode.ts) : layerTimeCode.ts;
            if (new Date() - timeStamp < 28800000) this.config.timeCode = layerTimeCode.tc;
        }
        if (runtimeConfig.getLayerTimeScale(this.getCode()) !== undefined) this.config.timeScale = runtimeConfig.getLayerTimeScale(this.getCode());
        if (runtimeConfig.getLayerVisibility(this.getCode()) !== undefined) this.config.visible = runtimeConfig.getLayerVisibility(this.getCode());
        if (runtimeConfig.getLayerOpacity(this.getCode()) !== undefined) this.config.opacity = runtimeConfig.getLayerOpacity(this.getCode());
    }
    verify() {
        let errors = super.verify(this);
        if (this.config.deviceVisibility && this.config.deviceVisibility.length > 0 && !(0, $815c91046e476159$export$54c4fd5984b65e0b).exists(this.config.deviceVisibility)) errors.push(this.getLogId() + ": invalid deviceVisibility. Possible values: " + (0, $815c91046e476159$export$54c4fd5984b65e0b).getPossibleCodes());
        if (this.config.chartType && this.config.chartType.length > 0 && !(0, $815c91046e476159$export$39c0195897d703ce).exists(this.config.chartType)) errors.push(this.getLogId() + ": invalid chartType. Possible values: " + (0, $815c91046e476159$export$39c0195897d703ce).getPossibleCodes());
        if (this.config.nrOfDecimals !== undefined && this.config.nrOfDecimals !== null && (!Number.isInteger(this.config.nrOfDecimals) || this.config.nrOfDecimals < 0 || this.config.nrOfDecimals > 10)) errors.push(this.getLogId() + ': No nrOfDecimals should be an integer between 0 and 10');
        const noProdCode = !this.config.prodCode || this.config.prodCode.length === 0;
        if (noProdCode) errors.push(this.getLogId() + ': No product for layer');
        const service = this.getService();
        if (!service) errors.push(this.getLogId() + ': No service for layer ' + this.config.srvCode);
        else {
            if (this.config.timeScale && this.config.timeScale.length > 0 && service.getTimeScales().map((ts)=>ts.getCode()).indexOf(this.config.timeScale) < 0) errors.push(this.getLogId() + ": invalid timeScale " + this.config.timeScale + ". Possible values: " + service.getTimeScales().map((ts)=>ts.getCode()));
            else if (!noProdCode) {
                const timeScales = this.service.getTimeScales();
                if (timeScales.length === 0) {
                    if (!this.getProduct()) errors.push(this.getLogId() + ": No product for code " + this.config.prodCode);
                } else errors = errors.concat(timeScales.filter((ts)=>!this.getProduct(ts)).map((ts)=>"No product for code " + this.config.prodCode.format([
                        ts.getCode()
                    ])));
            }
        }
        if (this.getMinZoomLevel() && this.getMaxZoomLevel() && this.getMaxZoomLevel() < this.getMinZoomLevel()) errors.push(this.getLogId() + ": invalid min/max zoom levels");
        if (this.getClusterSizePixels() && (!(0, $2536f84a954bf107$export$7e4aa119212bc614)(this.getClusterSizePixels()) || this.getClusterSizePixels() < 10 || this.getClusterSizePixels() > 200)) errors.push(this.getLogId() + ": invalid clusterSizePixels. Should be >10 and <200");
        const styleCodes = this.getStyleCodes();
        for(let s in styleCodes)if (!this.allStyles[styleCodes[s]]) errors.push(this.getLogId() + ': no style for code "' + styleCodes[s] + '"');
        const accumulatedStyleCode = this.getAccumulatedStyleCode();
        if (accumulatedStyleCode && !this.allStyles[accumulatedStyleCode]) errors.push(this.getLogId() + ': no style for code (accumulated) "' + accumulatedStyleCode + '"');
        const drivenServices = this.getDrivenServices();
        for(let ds in drivenServices){
            const drivenServiceErrors = drivenServices[ds].verify();
            for(let e in drivenServiceErrors)errors.push(this.getLogId() + ": " + drivenServiceErrors[e]);
        }
        return errors;
    }
}
/**
 * A service driven by another layer
 * @extends CodeConfig
 */ class $2a1bdf5b8bad2f9b$var$DrivenServiceConfig extends (0, $9bc5df2b24a7fcf6$export$29cd7b75162a9425) {
    /**
     *
     * @param config {Object} The config object
     * @param allServices {Object<String,LayerServiceConfig>} All the available layer services
     * @param allStyles {Object<String,Style>} All the available styles
     */ constructor(config, allServices, allStyles){
        super(config);
        this.service = allServices[this.getSrvCode()];
        this.allStyles = allStyles;
    }
    getClassName() {
        return "DrivenServiceConfig";
    }
    getSrvCode() {
        return this.config.srvCode;
    }
    _getStyleCode() {
        return this.config.styleCode;
    }
    /**
     * The style for the driven service
     * @return {Style|undefined}
     */ getStyle() {
        return this.config.styleCode ? this.allStyles[this.config.styleCode] : undefined;
    }
    /**
     * The drive service
     * @return {LayerServiceConfig}
     */ getService() {
        return this.service;
    }
    verify() {
        const errors = super.verify();
        if (!this.service) errors.push(this.getLogId() + ': service "' + this.getSrvCode() + '" not found.');
        if (this._getStyleCode()) {
            if (!this.getStyle()) errors.push(this.getLogId() + ': style "' + this._getStyleCode() + '" not found.');
        }
        return errors;
    }
}
/**
 * Product information
 * @extends CodeNameInfoConfig
 * @hideconstructor
 */ class $2a1bdf5b8bad2f9b$export$b84bcfe50479da8 extends (0, $9bc5df2b24a7fcf6$export$d3fd516c17034308) {
    /**
     *
     * @param config {Object} The config object
     * @param scaleId {string} The scale id param for indicator download
     */ constructor(config, scaleId){
        super(config);
        this.scaleId = scaleId;
        this.overrider = new $2a1bdf5b8bad2f9b$var$ConfigOverride(config.overrides, [
            'name',
            'info',
            'citationStatement',
            'publication',
            'organisation',
            'license',
            'dataCatalogueUrl',
            'factsheetUrl'
        ]);
    }
    getClassName() {
        return "ProductConfig";
    }
    /**
     * The scale id param value to pass to the download data service
     * @return {string}
     */ getScaleId() {
        return this.scaleId;
    }
    /**
     * This layer's start date
     * @return {string} (YYYY-MM-DD)
     */ getDataFrom() {
        const periodicityEnum = this.getPeriodicity();
        if (periodicityEnum) {
            const startDayDate = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(!(0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.config.startDay) ? this.config.endDay : this.config.startDay);
            const timeCalculator = new (0, $aeedcab592f41cce$export$41dea944c75fcd24)(periodicityEnum);
            return timeCalculator.writeTimeCodeFromDate(startDayDate);
        }
    }
    /**
     * This layer's end date
     * @return {string} (YYYY-MM-DD)
     */ getDataUntil() {
        if (!(0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.config.endDay)) return undefined;
        const periodicityEnum = this.getPeriodicity();
        if (periodicityEnum) {
            const timeCalculator = new (0, $aeedcab592f41cce$export$41dea944c75fcd24)(periodicityEnum);
            return timeCalculator.writeTimeCodeFromDate(this.config.endDay);
        }
    }
    getName(date) {
        return this.overrider.getValueForProperty('name', date, super.getName());
    }
    /**
     *
     * @return {string}
     */ getInfo(date) {
        return this.overrider.getValueForProperty('info', date, super.getInfo());
    }
    /**
     * This layer's data catalogue URL
     * @return {object}
     */ getDataCatalogueUrl(date) {
        return this.overrider.getValueForProperty('dataCatalogueUrl', date, this.config.dataCatalogueUrl);
    }
    /**
     *
     * @return {string}
     */ getLicense(date) {
        return this.overrider.getValueForProperty('license', date, this.config.license);
    }
    /**
     *
     * @return {string}
     */ getCitationStatement(date) {
        return this.overrider.getValueForProperty('citationStatement', date, this.config.citationStatement);
    }
    /**
     *
     * @return {string}
     */ getOrganisation(date) {
        return this.overrider.getValueForProperty('organisation', date, this.config.organisation);
    }
    /**
     *
     * @return {string}
     */ getOrganisationName(date) {
        const organisation = this.getOrganisation(date);
        return organisation ? organisation.name : undefined;
    }
    /**
     *
     * @return {string}
     */ getContactPerson(date) {
        const organisation = this.getOrganisation(date);
        return organisation ? organisation.contact : undefined;
    }
    /**
     *
     * @return {string}
     */ getEmail(date) {
        const organisation = this.getOrganisation(date);
        return organisation ? organisation.email : undefined;
    }
    /**
     *
     * @return {string}
     */ getRefPublication(date) {
        return this.overrider.getValueForProperty('refPublication', date, this.config.refPublication);
    }
    getPublicationTitle(date) {
        const publication = this.getPublication(date);
        return publication ? publication.title : undefined;
    }
    getPublicationAuthors(date) {
        const publication = this.getPublication(date);
        return publication ? publication.authors : undefined;
    }
    getPublicationPublisher(date) {
        const publication = this.getPublication(date);
        return publication ? publication.publisher : undefined;
    }
    getPublicationYear(date) {
        const publication = this.getPublication(date);
        return publication ? publication.year : undefined;
    }
    getPublicationUrl(date) {
        const publication = this.getPublication(date);
        return publication ? publication.href : undefined;
    }
    getPublication(date) {
        return this.overrider.getValueForProperty('publication', date, this.config.publication);
    }
    getFactSheetUrl(date) {
        return this.overrider.getValueForProperty('factsheetUrl', date, this.config.factsheetUrl);
    }
    getDownloadPageUrl() {
        return this.config.downloadPageUrl;
    }
    /**
     * This layer's units
     * @return {string}
     */ getUnits() {
        return this.config.units;
    }
    /**
     * This layer's periodicity (monthly, yearly, etc.)
     * @return {PeriodicityEnum}
     */ getPeriodicity() {
        return this.config.frequency ? (0, $815c91046e476159$export$45470b399d15bbcb).getForCode(this.config.frequency) : undefined;
    }
    verify() {
        const errors = super.verify();
        this.overrider.verify().forEach((e)=>errors.push(this.getLogId() + ': ' + e));
        const nameOverrides = this.overrider.getAllValuesForProperty('name');
        for(let i = 0; i < nameOverrides.length; i++){
            const nameError = this.verifyName(nameOverrides[i]);
            if (nameError) errors.push(this.getLogId() + ': override[' + i + ']: ' + nameError);
        }
        const verifyDataCatalogueUrl = (dataCatalogueUrl, overrideIndex)=>{
            if (dataCatalogueUrl) {
                const logId = overrideIndex !== undefined ? this.getLogId() + ': override[' + overrideIndex + ']: ' : this.getLogId() + ': ';
                if (!dataCatalogueUrl.name || dataCatalogueUrl.name.length === 0) errors.push(logId + "dataCatalogueUrl.name is mandatory");
                if (!dataCatalogueUrl.url || dataCatalogueUrl.url.length === 0) errors.push(logId + "dataCatalogueUrl.url is mandatory");
                else if (!(0, $9bc5df2b24a7fcf6$export$cf70820c5d4688d8)(dataCatalogueUrl.url)) errors.push(logId + "dataCatalogueUrl.url is invalid");
            }
        };
        verifyDataCatalogueUrl(this.getDataCatalogueUrl());
        const dataCatalogueOverrides = this.overrider.getAllValuesForProperty('dataCatalogueUrl');
        for(let i = 0; i < dataCatalogueOverrides.length; i++)verifyDataCatalogueUrl(dataCatalogueOverrides[i], i);
        const verifyPublication = (publication, overrideIndex)=>{
            if (publication) {
                const logId = overrideIndex !== undefined ? this.getLogId() + ': override[' + overrideIndex + ']: ' : this.getLogId() + ': ';
                if (!(0, $2536f84a954bf107$export$51c197c9b00a6c1c)(publication.title)) errors.push(logId + "publication.title is mandatory");
                if ((0, $2536f84a954bf107$export$51c197c9b00a6c1c)(publication.href) && !(0, $9bc5df2b24a7fcf6$export$cf70820c5d4688d8)(publication.href)) errors.push(logId + "publication.href is invalid");
            }
        };
        verifyPublication(this.getPublication());
        const publicationOverrides = this.overrider.getAllValuesForProperty('publication');
        for(let i = 0; i < publicationOverrides.length; i++)verifyPublication(publicationOverrides[i], i);
        if ((0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.config.frequency) && !(0, $815c91046e476159$export$45470b399d15bbcb).exists(this.config.frequency)) errors.push(this.getLogId() + ": invalid frequency. Possible values: " + (0, $815c91046e476159$export$45470b399d15bbcb).getPossibleCodes());
        const periodicity = this.getPeriodicity();
        if (periodicity) {
            if (periodicity !== (0, $815c91046e476159$export$45470b399d15bbcb).LATEST && !this.getDataFrom()) errors.push(this.getLogId() + ": startDay is mandatory");
            if (this.getDataFrom() && !(0, $aeedcab592f41cce$export$5f691ceae06458b4)(this.getDataFrom())) errors.push(this.getLogId() + ": invalid startDay (" + this.getDataFrom() + ")");
            else if (this.getDataUntil() && !(0, $aeedcab592f41cce$export$5f691ceae06458b4)(this.getDataUntil())) errors.push(this.getLogId() + ": invalid endDay (" + this.getDataUntil() + ")");
            if (this.getDataFrom() && this.getDataUntil()) {
                let dataUntil = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.getDataUntil());
                let dataFrom = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.getDataFrom());
                if (dataUntil.getTime() < dataFrom.getTime()) errors.push(this.getLogId() + ": endDay must be later than startDay");
            }
        }
        return errors;
    }
}
/**
 * The service for any layers
 * @extends CodeConfig
 */ class $2a1bdf5b8bad2f9b$export$e195ecca6214af99 extends (0, $9bc5df2b24a7fcf6$export$e8c716be77a99153) {
    /**
     *
     * @param config
     * @param allServiceWarningMessages {Object<String,Array<ServiceWarningMessageConfig>>} All the service warning messages by service code
     */ constructor(config, allServiceWarningMessages){
        super(config);
        this.warningMessages = allServiceWarningMessages[this.getCode()] ? allServiceWarningMessages[this.getCode()] : [];
        this.overrider = new $2a1bdf5b8bad2f9b$var$ConfigOverride(config.overrides, [
            'url',
            'tileSize'
        ]);
    }
    getClassName() {
        return "LayerServiceConfig";
    }
    /**
     *
     * @return {Array<ServiceWarningMessageConfig>}
     */ getWarningMessages() {
        return this.warningMessages;
    }
    /**
     * This layer's extent
     * @return {Array<number>}
     */ getExtentWgs84() {
        return this.config.extent;
    }
    /**
     * This layer's protocol (WMS, WFS, etc)
     * @return {ProtocolEnum}
     */ getProtocol() {
        return (0, $815c91046e476159$export$fb21469bf9823c9b).getForCode(this.config.protocol);
    }
    /**
     * This layer's URL
     * @return {string}
     */ getUrl(date) {
        const service = this.overrider.getValueForProperty('service', date, this.config.service);
        if (service && service.uri && service.uri.authority && service.args && service.args.fix && service.args.fix['LAYERS']) {
            let url = tumbo.serviceUrlPrefix ? (tumbo.serviceUrlPrefix.indexOf("http") === 0 ? '' : '//') + tumbo.serviceUrlPrefix : (service.uri.scheme ? service.uri.scheme + '://' : '') + service.uri.authority.host;
            url += '/' + service.uri.path + '?';
            if (service.args.fix.map) url += 'map=' + service.args.fix.map;
            url += '&LAYERS=' + service.args.fix['LAYERS'];
            return url;
        } else {
            const url = this.overrider.getValueForProperty('url', date, this.config.url);
            if (url) return (0, $2536f84a954bf107$export$730687a846e4e808)(url);
        }
    }
    /**
     * The size of the tiles to retrieve from the service.
     * If this is not a WMS raster layer, this will be ignored.
     * @return {number} (integer)
     */ getTileSize(date) {
        return this.overrider.getValueForProperty('tileSize', date, this.config.tileSize);
    }
    /**
     * Is this layer clickable? Only applies to vector layers
     * @return {boolean}
     */ isClickable() {
        return !!this.config.clickable;
    }
    /**
     * This layer's type (vector, raster)
     * @return {LayerTypeEnum}
     */ getLayerType() {
        return (0, $815c91046e476159$export$76bf88ec17fef043).getForCode(this.config.layerType);
    }
    /**
     * The original CRS of the data that comes from the server.
     * Ignored if layerType!=="VECTOR"
     * @return {string|undefined}
     */ getOriginalCRS() {
        return this.config.originalCRS;
    }
    /**
     * This layer's time param name.
     * If set, the GIS request will use this param name to send the time code
     * If not set, the GIS request will use the SELECTED_* (year, month, day, week) to send the time
     * @return {string}
     */ getTimeSelector() {
        return this.config.timeSelector;
    }
    /**
     * This layer's available time scales
     * @return {Array<TimeScaleEnum>}
     */ getTimeScales() {
        let res = [];
        const timeScales = this.config.timeScales;
        if (timeScales) for(let ts in timeScales)res.push((0, $815c91046e476159$export$d08fec65c77806fd).getForCode(timeScales[ts]));
        return res;
    }
    verify() {
        let errors = super.verify(this);
        if (this.getExtentWgs84()) {
            if (!(0, $9bc5df2b24a7fcf6$export$867fb2209883d6bf)(this.getExtentWgs84())) errors.push(this.getLogId() + ': invalid extent. Should be [minLon, minLat, maxLon, maxLat] in WGS84');
        }
        this._verifyProtocol(errors);
        const url = this.getUrl();
        if (!url || url.length === 0) errors.push(this.getLogId() + ": url is mandatory");
        this._verifyLayerType(errors);
        if (this.config.timeScales && this.config.timeScales.length > 0) {
            for(let ts in this.config.timeScales)if (!(0, $815c91046e476159$export$d08fec65c77806fd).exists(this.config.timeScales[ts])) errors.push(this.getLogId() + ": invalid timeScale: " + this.config.timeScales[ts] + '. Possible values: ' + (0, $815c91046e476159$export$d08fec65c77806fd).getPossibleCodes());
        }
        return errors;
    }
    _verifyProtocol(errors) {
        if (!(0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.config.protocol)) errors.push(this.getLogId() + ": protocol is mandatory");
        else if (!(0, $815c91046e476159$export$fb21469bf9823c9b).exists(this.config.protocol)) errors.push(this.getLogId() + ": invalid protocol. Possible values: " + (0, $815c91046e476159$export$fb21469bf9823c9b).getPossibleCodes());
    }
    _verifyLayerType(errors) {
        if (!(0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.config.layerType)) errors.push(this.getLogId() + ": layerType is mandatory");
        else if (!(0, $815c91046e476159$export$76bf88ec17fef043).exists(this.config.layerType)) errors.push(this.getLogId() + ": invalid layerType. Possible values: " + (0, $815c91046e476159$export$76bf88ec17fef043).getPossibleCodes());
    }
}
/**
 * The config of an element of the layer list
 * @extends CodeUniqueNameInfoConfig
 * @hideconstructor
 */ class $2a1bdf5b8bad2f9b$export$9c228ca1dafbb77 extends (0, $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1) {
    /**
     * The type of the element
     * @return {LayerGroupTypeEnum}
     */ getType() {
        return (0, $815c91046e476159$export$9ae7e512bcbacef8).getForCode(this.config.type);
    }
    /**
     * Device visibility of this element
     * @return {DeviceVisibilityEnum}
     */ getDeviceVisibility() {
        return (0, $815c91046e476159$export$54c4fd5984b65e0b).getForCode(this.config.deviceVisibility);
    }
    /**
     * This element's children (layers, only. base or context)
     * @param includeDisabled {Boolean} if true, includes disabled children
     * @return {Array<LayerListElementConfig>}
     */ getChildren(includeDisabled = false) {
        return [];
    }
    /**
     * Is tree element disabled?
     * @return {*}
     */ isDisabled() {
        return this.config.disabled;
    }
    verify() {
        let errors = super.verify(this);
        if (!this.config.type || this.config.type.length === 0) errors.push(this.getLogId() + ": type is mandatory");
        else if (!(0, $815c91046e476159$export$9ae7e512bcbacef8).exists(this.config.type)) errors.push(this.getLogId() + ": invalid type. Possible values: " + (0, $815c91046e476159$export$9ae7e512bcbacef8).getPossibleCodes());
        if (this.config.deviceVisibility && this.config.deviceVisibility.length > 0 && !(0, $815c91046e476159$export$54c4fd5984b65e0b).exists(this.config.deviceVisibility)) errors.push(this.getLogId() + ": invalid deviceVisibility. Possible values: " + (0, $815c91046e476159$export$54c4fd5984b65e0b).getPossibleCodes());
        if (this.config.disabled !== null && this.config.disabled !== undefined) {
            if (!(0, $2536f84a954bf107$export$f9ce7b637dfbe238)(this.config.disabled)) errors.push(this.getLogId() + ": disabled must be a boolean");
        }
        return errors;
    }
}
/**
 * A base layer configuration
 * @extends LayerListElementConfig
 */ class $2a1bdf5b8bad2f9b$export$c222b966508fa8e1 extends $2a1bdf5b8bad2f9b$export$9c228ca1dafbb77 {
    /**
     *
     * @param config {Object} The config object
     * @param service {LayerServiceConfig} The layer service
     * @param product {ProductConfig} The products
     * @param allStyles {Object<String,Style>} All the available styles
     */ constructor(config, service, product, allStyles){
        super(config);
        this.service = service;
        this.product = product;
        this.allStyles = allStyles;
    }
    getClassName() {
        return "BaseLayerConfig";
    }
    clone() {
        return new this.__proto__.constructor((0, $2536f84a954bf107$export$9cd59f9826255e47)(this.config), this.service, this.product, this.allStyles);
    }
    /**
     * The map background color to set when this layer is visible
     * @return {string|undefined}
     */ getMapBackgroundColor() {
        return (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.config.mapBackgroundColor) ? (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.config.mapBackgroundColor) : '#FFFFFF';
    }
    /**
     *
     * @return {LayerServiceConfig}
     */ getService() {
        return this.service;
    }
    /**
     *
     * @return {ProductConfig}
     */ getProduct() {
        return this.product;
    }
    /**
     * Is this layer visible?
     * @return {boolean}
     */ isVisible() {
        return this.config.visible === true;
    }
    /**
     * This layer's min zoom level
     * @return {number} (integer)
     */ getMinZoomLevel() {
        return this.config.minZoomLevel;
    }
    /**
     * This layer's max zoom level
     * @return {number} (integer)
     */ getMaxZoomLevel() {
        return this.config.maxZoomLevel;
    }
    /**
     * This layer's styles
     * @return {Array<string>}
     */ getStyleCodes() {
        return this.config.styles;
    }
    /**
     * This layer's styles
     * @return {Array<Style>}
     */ getStyles() {
        const styles = [];
        if (this.config.styles) for(let s in this.config.styles){
            const style = this.allStyles[this.config.styles[s]];
            if (style) styles.push(style);
        }
        return styles;
    }
    /**
     * If true, this layer is available for the identify tool
     * @return {boolean}
     */ isIdentifiable() {
        return this.config.identifiable === true;
    }
    /**
     * The render ordinal. If defined, overrides the layer tree ordinal
     * @return {number|undefined}
     */ getRenderOrdinal() {
        return (0, $2536f84a954bf107$export$a0a81dc3380ce7d3)(this.config.renderOrdinal);
    }
    override(runtimeConfig) {
        if (runtimeConfig.getBaseLayerVisibility(this.getCode()) !== undefined) this.config.visible = runtimeConfig.getBaseLayerVisibility(this.getCode());
    }
    verify() {
        let errors = super.verify();
        if (!this.getService()) errors.push(this.getLogId() + ': No service for code ' + this.config.srvCode);
        if (!this.config.prodCode || this.config.prodCode.length === 0) errors.push(this.getLogId() + ': No product for layer');
        else if (!this.product) errors.push(this.getLogId() + ': No product for code ' + this.config.prodCode);
        if (this.config.deviceVisibility && this.config.deviceVisibility.length > 0 && !(0, $815c91046e476159$export$54c4fd5984b65e0b).exists(this.config.deviceVisibility)) errors.push(this.getLogId() + ": invalid deviceVisibility. Possible values: " + (0, $815c91046e476159$export$54c4fd5984b65e0b).getPossibleCodes());
        if (this.getMinZoomLevel() && this.getMaxZoomLevel() && this.getMaxZoomLevel() < this.getMinZoomLevel()) errors.push(this.getLogId() + ": invalid min/max zoom levels");
        if (this.getMapBackgroundColor()) try {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($5f14bb65263850e1$exports)))(this.getMapBackgroundColor())) errors.push(this.getLogId() + ": invalid mapBackgroundColor");
        } catch (e) {
            errors.push(this.getLogId() + ": invalid mapBackgroundColor (" + e + ")");
        }
        const styleCodes = this.getStyleCodes();
        for(let s in styleCodes)if (!this.allStyles[styleCodes[s]]) errors.push(this.getLogId() + ': no style for code "' + styleCodes[s] + '"');
        if (this.config.disabled !== null && this.config.disabled !== undefined) {
            if (!(0, $2536f84a954bf107$export$f9ce7b637dfbe238)(this.config.disabled)) errors.push(this.getLogId() + ": disabled must be a boolean");
        }
        return errors;
    }
}
/**
 * A context layer configuration
 * @extends BaseLayerConfig
 * @hideconstructor
 */ class $2a1bdf5b8bad2f9b$export$c8433908084f1689 extends $2a1bdf5b8bad2f9b$export$c222b966508fa8e1 {
    override(runtimeConfig) {
        if (runtimeConfig.getContextLayerVisibility(this.getCode()) !== undefined) this.config.visible = runtimeConfig.getContextLayerVisibility(this.getCode());
    }
    getClassName() {
        return "ContextLayerConfig";
    }
}
/**
 * A projection. Its code should be the EPSG code
 * @extends CodeConfig
 * @hideconstructor
 */ class $2a1bdf5b8bad2f9b$export$dfa3a012bb2ef2e1 extends (0, $9bc5df2b24a7fcf6$export$ce4e47771dcf2cf1) {
    static MERCATOR_PROJECTION = new $2a1bdf5b8bad2f9b$export$dfa3a012bb2ef2e1({
        code: (0, $9bc5df2b24a7fcf6$export$bad5ada7a204507f),
        name: 'Mercator',
        decimals: 4,
        unit: "\xba"
    });
    static WGS84_PROJECTION = new $2a1bdf5b8bad2f9b$export$dfa3a012bb2ef2e1({
        code: (0, $9bc5df2b24a7fcf6$export$6dd85527b263c26d),
        name: 'WGS84',
        decimals: 0,
        unit: 'm'
    });
    getClassName() {
        return "Projection";
    }
    /**
     * The nr of decimals to round to. Precision
     * @return {number}
     */ getDecimals() {
        return this.config.decimals !== undefined ? this.config.decimals : 0;
    }
    /**
     * Units of the projection
     * @return {string}
     */ getUnit() {
        return this.config.unit ? this.config.unit : 'm';
    }
    /**
     * Name of the projection
     * @return {string}
     */ getName() {
        return this.config.name;
    }
    /**
     * proj4js definition of the projection. not needed for WGS84 and Mercator
     * @return {string}
     */ getDefinition() {
        return this.config.definition;
    }
    /**
     * extent of the projection in WGS84. not needed for WGS84
     * tip: take it from epsg.io
     * @return {Array<number>}
     */ getExtent() {
        return this.config.extent ? this.config.extent : [
            -180,
            -90,
            180,
            90
        ];
    }
    verify() {
        const errors = super.verify();
        if (!this.getName() || this.getName().length === 0) errors.push(this.getLogId() + ": name is mandatory");
        if (this.getExtent() && !(0, $9bc5df2b24a7fcf6$export$867fb2209883d6bf)(this.getExtent())) errors.push(this.getLogId() + ": invalid WGS84 extent");
        return errors;
    }
}
/**
 * The zoom levels available in the map
 * @extends Config
 * @hideconstructor
 */ class $2a1bdf5b8bad2f9b$export$dca8ec0f6805469d extends (0, $9bc5df2b24a7fcf6$export$29cd7b75162a9425) {
    getClassName() {
        return "ZoomLevels";
    }
    static getDefaultZoomLevelsForWgs84() {
        return new $2a1bdf5b8bad2f9b$export$dca8ec0f6805469d({
            "minResolutionMercator": 78271.516953125,
            "levels": 14
        });
    }
    /**
     * Min resolution in the Mercator array of resolutions
     * @return {number}
     */ getMinResolutionMercator() {
        return this.config.minResolutionMercator;
    }
    /**
     * The nr of zoom levels
     * @return {number} (integer)
     */ getLevels() {
        return this.config.levels;
    }
    /**
     * The index of the max resolution available in the map, from the array of possible resolutions
     * @return {number} (integer)
     */ getMaxResolutionIndex() {
        return this.getMinResolutionIndex() + this.getLevels() - 1;
    }
    /**
     * The index of the min resolution available in the map, from the array of possible resolutions
     * @return {number} (integer)
     */ getMinResolutionIndex() {
        return (0, $9bc5df2b24a7fcf6$export$6ca86169e9c2a79e)[0, $9bc5df2b24a7fcf6$export$bad5ada7a204507f].map((r)=>Math.round(r)).indexOf(Math.round(this.getMinResolutionMercator()));
    }
    /**
     * Given a projection code, get the list of resolutions
     * @param projection {string} The projection code
     * @return {Array<number>}
     */ getResolutionsForProjection(projection) {
        return (0, $9bc5df2b24a7fcf6$export$6ca86169e9c2a79e)[projection];
    }
    /**
     * Given a projection code, get the list of resolutions available for display
     * @param projection {string} The projection code
     * @return {Array<number>}
     */ getAvailableResolutionsForProjection(projection) {
        return this.getResolutionsForProjection(projection).slice(this.getMinResolutionIndex(), this.getMaxResolutionIndex() + 1);
    }
    /**
     * Given a projection code, get the resolution for a zoom level
     * @param projection {string} The projection code
     * @param zoomLevel {number} (integer)
     * @return {number}
     */ getResolutionForZoomLevel(projection, zoomLevel) {
        return this.getAvailableResolutionsForProjection(projection)[zoomLevel];
    }
    /**
     * Given a projection code, get the zoom level for a resolution
     * @param projection {string} The projection code
     * @param resolution {number}
     * @return {number} (integer)
     */ getZoomLevelForResolution(projection, resolution) {
        const zLevels = this.getAvailableResolutionsForProjection(projection);
        let resolutionIndex = 0;
        for(let i = 0; i < zLevels.length && zLevels[i] >= resolution; i++)resolutionIndex = i;
        return resolutionIndex;
    }
    /**
     * Is the given resolution a known resolution?
     * @param projection {string} The projection code
     * @param resolution {number}
     * @return {boolean}
     */ isKnownResolution(projection, resolution) {
        return this.getResolutionIndex(projection, resolution) >= 0;
    }
    /**
     * Given a projection code, get the index of a resolution in the list of resolutions
     * @param projection {string} The projection code
     * @param resolution {number}
     * @return {number} (integer)
     */ getResolutionIndex(projection, resolution) {
        return this.getAvailableResolutionsForProjection(projection).indexOf(resolution);
    }
    verify() {
        const errors = super.verify();
        const minResolutionMercator = this.getMinResolutionMercator();
        if (minResolutionMercator) {
            if ((0, $9bc5df2b24a7fcf6$export$6ca86169e9c2a79e)[0, $9bc5df2b24a7fcf6$export$bad5ada7a204507f].map((r)=>Math.round(r)).indexOf(Math.round(minResolutionMercator)) < 0) errors.push(this.getLogId() + ": minResolutionMercator is invalid");
        } else errors.push(this.getLogId() + ": minResolutionMercator is mandatory");
        const levels = this.getLevels();
        if (!levels) errors.push(this.getLogId() + ": levels is mandatory");
        if (minResolutionMercator !== undefined && levels > 0) {
            const expectedZoomLevels = this.getMaxResolutionIndex() - this.getMinResolutionIndex() + 1;
            if (expectedZoomLevels !== levels) errors.push(this.getLogId() + ": There should be (" + expectedZoomLevels + ") zoom levels");
        }
        return errors;
    }
}



/**
 * A runtime config for this extended report.
 * UI elements will change this runtime config, which will afterward override TimeComparisonConfig
 * @extends RuntimeConfig
 * @hideconstructor
 */ class $662e172f961e3abf$export$98212a8602ec303c extends (0, $2a1bdf5b8bad2f9b$export$ec56e2f5cfeae5ef) {
    getClassName() {
        return "ExtendedReportRuntimeConfig";
    }
    /**
     * Create a ExtendedReportRuntimeConfig from a serialized object
     * @param code {string} Unique identifier for the runtime config
     * @param runtimeConfigSerialization {string} serialization
     * @return {ExtendedReportRuntimeConfig}
     */ static createFromSerialized(code, runtimeConfigSerialization) {
        let parsedConfig;
        try {
            parsedConfig = runtimeConfigSerialization ? JSON.parse($feAbh.decompressFromBase64(runtimeConfigSerialization)) : undefined;
        // tumbo.LOGGER.logDebug("Deserialized config: ", parsedConfig);
        } catch (e) {
            tumbo.LOGGER.logError('Error deserializing config', e);
        }
        return new $662e172f961e3abf$export$98212a8602ec303c(code, parsedConfig);
    }
    /**
     * Clean this runtime config
     */ clean() {
        this.config = {
            i: {},
            r: {},
            t: {}
        };
    }
    /**
     * set an indicator time scale
     * @param indCode {string}
     * @param timeScale {string}
     */ setIndicatorTimeScale(indCode, timeScale) {
        if (!this.config.i) this.config.i = {};
        if (!this.config.i[indCode]) this.config.i[indCode] = {};
        this.config.i[indCode].ts = timeScale;
    }
    /**
     * get an indicator time scale
     * @param indCode {string}
     * @return {string}
     */ getIndicatorTimeScale(indCode) {
        return this.config.i && this.config.i[indCode] ? this.config.i[indCode].ts : undefined;
    }
}
/**
 * The configuration of the extended report
 * @extends MainConfig
 * @hideconstructor
 */ class $662e172f961e3abf$export$5c062187495ca4f3 extends (0, $2a1bdf5b8bad2f9b$export$f6e3e72c68493c4c) {
    getClassName() {
        return "ExtendedReportConfig";
    }
    getName() {
        return this.config.report.name;
    }
    getCode() {
        return this.config.report.code;
    }
    /**
     * Current report coordinate in WGS84
     * @return {Array<number>}
     */ getCoordLonLatWgs84() {
        return this.config.report.coordLonLatWgs84;
    }
    _getStatsPostUrlProperty() {
        return this.config.report.statsPostUrl;
    }
    _getContactPostUrlProperty() {
        return this.config.report.contactPostUrl;
    }
    getGDORDRIAValuesUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this.config.report.URL_GDORDRIA_VALUES);
    }
    getRegionalClassGDORDRIAStatsUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this.config.report.URL_REGIONAL_CLASSIFICATION_IN_GDORDIA_STATS);
    }
    getStatsDescUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this.config.report.URL_STATS_DESC);
    }
    getTownAroundPointUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this.config.report.URL_TOWN_ARROUND_POINT);
    }
    getCountryStatsUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this.config.report.URL_COUNTRY_STATS);
    }
    getBasicStatsUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this.config.report.URL_BASIC_STATS);
    }
    getMapImagesUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this.config.report.URL_MAP_IMAGES);
    }
    getOtherIndicatorsValuesUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this.config.report.URL_OTHER_INDICATORS_VALUES);
    }
    getPrecipitationIndicatorsValuesUrl() {
        return (0, $2536f84a954bf107$export$730687a846e4e808)(this.config.report.URL_PRECIPITATION_INDICATORS_VALUES);
    }
    /**
     * Get the indicator configurations
     * @return {Array<IndicatorConfig>}
     */ getIndicatorConfigs() {
        const indicatorConfigs = [];
        for(const lt in this.config.report.indicators){
            const conf = this.config.report.indicators[lt];
            indicatorConfigs.push(new $662e172f961e3abf$var$IndicatorConfig(conf, this.allLayerServices, this.allProducts, this.allStyles));
        }
        return indicatorConfigs;
    }
    /**
     * Override this config
     * @param runtimeConfig {ExtendedReportRuntimeConfig} The configuration override
     */ override(runtimeConfig) {
        this.getIndicatorConfigs().forEach((element)=>element.override(runtimeConfig));
    }
    verify() {
        let errors = super.verify();
        if (this.getCoordLonLatWgs84()) {
            if (!(0, $9bc5df2b24a7fcf6$export$861ac51a64fd27a8)(this.getCoordLonLatWgs84())) errors.push('ExtendedReportConfig: invalid coordLonLatWgs84. Should be [lon, lat]');
        }
        if (Object.keys(this.allProducts).length === 0) errors.push('ExtendedReportConfig: products is mandatory');
        else for(let p in this.allProducts)errors = errors.concat(this.allProducts[p].verify());
        if (Object.keys(this.allLayerServices).length === 0) errors.push('ExtendedReportConfig: services is mandatory');
        else for(let p in this.allLayerServices)errors = errors.concat(this.allLayerServices[p].verify());
        if (Object.keys(this.allStyles).length === 0) errors.push('ExtendedReportConfig: styles is mandatory');
        else for(let p in this.allStyles)errors = errors.concat(this.allStyles[p].verify());
        const indicatorConfigs = this.getIndicatorConfigs();
        for(const ic in indicatorConfigs)errors = errors.concat(indicatorConfigs[ic].verify());
        if (!this.getGDORDRIAValuesUrl()) errors.push('ExtendedReportConfig: URL_GDORDRIA_VALUES is mandatory');
        if (!this.getRegionalClassGDORDRIAStatsUrl()) errors.push('ExtendedReportConfig: URL_REGIONAL_CLASSIFICATION_IN_GDORDIA_STATS is mandatory');
        if (!this.getStatsDescUrl()) errors.push('ExtendedReportConfig: URL_STATS_DESC is mandatory');
        if (!this.getTownAroundPointUrl()) errors.push('ExtendedReportConfig: URL_TOWN_ARROUND_POINT is mandatory');
        if (!this.getCountryStatsUrl()) errors.push('ExtendedReportConfig: URL_COUNTRY_STATS is mandatory');
        if (!this.getBasicStatsUrl()) errors.push('ExtendedReportConfig: URL_BASIC_STATS is mandatory');
        if (!this.getMapImagesUrl()) errors.push('ExtendedReportConfig: URL_MAP_IMAGES is mandatory');
        if (!this.getOtherIndicatorsValuesUrl()) errors.push('ExtendedReportConfig: URL_OTHER_INDICATORS_VALUES is mandatory');
        if (!this.getPrecipitationIndicatorsValuesUrl()) errors.push('ExtendedReportConfig: URL_PRECIPITATION_INDICATORS_VALUES is mandatory');
        return errors;
    }
}
/**
 * Layer config for the extended report
 * @extends LayerConfig
 * @hideconstructor
 */ class $662e172f961e3abf$var$IndicatorConfig extends (0, $2a1bdf5b8bad2f9b$export$1e0909f3e93883c6) {
    getClassName() {
        return "IndicatorConfig";
    }
    getType() {
        return (0, $815c91046e476159$export$9ae7e512bcbacef8).LAYER;
    }
    /**
     * This layer's chart type
     * @return {IndicatorChartTypeEnum}
     */ getChartType() {
        return (0, $815c91046e476159$export$39c0195897d703ce).getForCode(this.config.chartType);
    }
    verify() {
        let errors = [];
        if (this.config.timeScale && this.config.timeScale.length > 0 && !(0, $815c91046e476159$export$d08fec65c77806fd).exists(this.config.timeScale)) errors.push(this.getLogId() + ": invalid timeScale. Possible values: " + (0, $815c91046e476159$export$d08fec65c77806fd).getPossibleCodes());
        if (this.config.chartType && this.config.chartType.length > 0 && !(0, $815c91046e476159$export$39c0195897d703ce).exists(this.config.chartType)) errors.push(this.getLogId() + ": invalid chartType. Possible values: " + (0, $815c91046e476159$export$39c0195897d703ce).getPossibleCodes());
        if (!this.config.prodCode || this.config.prodCode.length === 0) errors.push(this.getLogId() + ': No product for indicator');
        const service = this.getService();
        if (!service) errors.push(this.getLogId() + ': No service for code ' + this.config.srvCode);
        const styleCodes = this.getStyleCodes();
        for(let s in styleCodes)if (!this.allStyles[styleCodes[s]]) errors.push(this.getLogId() + ': no style for code "' + styleCodes[s] + '"');
        return errors;
    }
    override(runtimeConfig) {
        if (runtimeConfig.getIndicatorTimeScale(this.getCode()) !== undefined) this.config.timeScale = runtimeConfig.getIndicatorTimeScale(this.getCode());
    }
}






class $9a87c76e274c7738$export$f03163d7279986d4 extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    static openUIElements = [];
    static escKeyInitialized = false;
    static allUIElements = [];
    /**
     * @param id {string} Unique id of this UI element
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */ constructor(id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig){
        super();
        this.translator = translator;
        this.isMobileDevice = isMobileDevice;
        this.runtimeConfig = runtimeConfig;
        this.onChangeRuntimeConfig = onChangeRuntimeConfig;
        this.id = id;
        if (!$9a87c76e274c7738$export$f03163d7279986d4.escKeyInitialized) {
            $dc57b31f1b066f38$exports('body').keyup(function(e) {
                if (e.key === "Escape" && $9a87c76e274c7738$export$f03163d7279986d4.openUIElements.length > 0) (0, $2536f84a954bf107$export$ce275da88d3dcc54)($9a87c76e274c7738$export$f03163d7279986d4.openUIElements).close();
            });
            $9a87c76e274c7738$export$f03163d7279986d4.escKeyInitialized = true;
        }
        $9a87c76e274c7738$export$f03163d7279986d4.allUIElements.push(this);
    }
    /**
     * UI element code
     * @returns {string}
     */ getCode() {
        return this.id ? this.id : 'NOCODE';
    }
    getCodeHtmlClass() {
        return this.getCode().replaceAll(".", "_").replaceAll("#", "_");
    }
    /**
     * The element to be added to DOM
     * @return {jQuery}
     */ getUIElement() {}
    /**
     * When the given element is focus-visible, detect space or enter key up and run given callback
     * A second call to this method will add a new callback to the given elem
     * @param callback {function}
     * @param elem {jQuery|undefined} The element to detect focus-visible on. if undefined, uses this.getUIElement()
     */ onFocusedEnterOrSpace(callback, elem) {
        elem = elem ? elem : this.getUIElement();
        elem.on('keyup', (event)=>{
            if (elem.is(":focus-visible")) {
                let keycode = event.keyCode ? event.keyCode : event.which;
                if (keycode === 13 || keycode === 32) callback();
            }
        });
    }
    /**
     * An ID token to use for logging
     * @return {string}
     */ getLogId() {
        return (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.getClassName(), this.getClass()) + " [" + this.getCode() + "]";
    }
    /**
     * log stat entry for this UIElement
     * @param action {string}
     * @param store {boolean} if true, stores immediately
     */ logStat(action, store = false) {
        if (tumbo && tumbo.STATS) tumbo.STATS.log(this, action, store);
    }
    /**
     * This function sets values related to the UI size and position
     * @param isSmallContainerWidth {boolean} Is this a small width application container?
     * @param isSmallContainerHeight {boolean} Is this a small height application container?
     * @param width {number} The with of the container in pixels (integer)
     * @param height {number} The height of the container in pixels (integer)
     * @param containerAbsolutePosition {Object} the absolute position of the container {top:, left:}
     */ setContainerSizeAndPosition(isSmallContainerWidth, isSmallContainerHeight, width, height, containerAbsolutePosition) {
        const changed = this.isSmallContainerWidth !== isSmallContainerWidth || this.isSmallContainerHeight !== isSmallContainerHeight;
        this.isSmallContainerWidth = isSmallContainerWidth;
        this.isSmallContainerHeight = isSmallContainerHeight;
        this.containerWidth = width;
        this.containerHeight = height;
        this.containerAbsolutePosition = containerAbsolutePosition;
        if (changed) this.onSmallContainer();
    }
    /**
     * This function is called whenever the container size changes enough to be considered small or not small
     * Should be redefined by subclasses to react to the change
     */ onSmallContainer() {}
    /**
     * Is a value defined for the given key
     * @param prop {string} A property key
     * @return {*}
     */ hasSessionProp(prop) {
        return this.runtimeConfig.hasUIElementSessionProp(this.id, prop);
    }
    /**
     * Get a value by property key
     * @param prop {string} A property key
     * @param defValue {*}
     * @return {*}
     */ getSessionProp(prop, defValue) {
        const val = this.runtimeConfig.getUIElementSessionProp(this.id, prop);
        return val !== undefined && val !== null ? val : defValue;
    }
    /**
     * Set a property value that lasts for this session (ends on close tab)
     * @param prop {string} A property key
     * @param value {*} any value
     * @return {UIElement} This UIElement
     */ setSessionProp(prop, value) {
        this.runtimeConfig.setUIElementSessionProp(this.id, prop, value);
        return this;
    }
    /**
     * Remove a property
     * @param prop {string} A property key
     * @return {UIElement} This UIElement
     */ removeSessionProp(prop) {
        this.runtimeConfig.removeUIElementSessionProp(this.id, prop);
        return this;
    }
    /**
     * Close this UI element
     * Override when necessary
     */ close() {}
}





/**
 * A modal window
 * @extends UIElement
 */ class $c51f63cd05d438f7$var$Modal extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    static openModals = [];
    static escKeyInitialized = false;
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param target {jQuery} The target element to append the modal to
     * @param id {string} Panel id
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param expandable {boolean} should this modal be expandable to full?
     * @param hasFooter {boolean} should a footer be rendered for this modal?
     */ constructor(translator, isMobileDevice, target, id, runtimeConfig, onChangeRuntimeConfig, expandable, hasFooter = false){
        super(id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.target = target;
        this.id = id;
        this.showCallbacks = [];
        this.hideCallbacks = [];
        this.expandCallbacks = [];
        this.expandable = expandable;
        this.footer = hasFooter;
    }
    getUIElement() {
        if (!this.uiElement) {
            const expanded = this.isExpanded();
            const expanderButtonStr = this.expandable ? '<button class="modal-expander ' + (expanded ? 'collapse' : 'expand') + '"   type="button" title="' + this.translator.translate('modal.expander.name') + '"></button>' : '';
            this.uiElement = $dc57b31f1b066f38$exports('<div id="' + this.id + '" class="modal-outer' + (expanded ? ' expanded' : '') + (this.hasFooter() ? ' has-footer' : '') + '">' + '   <div class="modal-inner" role="dialog" aria-modal="true" aria-labelledby="' + this.id + '_title">' + '       <div class="modal-header">' + '           <div class="modal-title" id="' + this.id + '_title">' + '           </div>' + '           <div class="modal-buttons-container">' + expanderButtonStr + '               <button class="modal-closer" type="button" title="' + this.translator.translate('modal.closer.name') + '"></button>' + '           </div>' + '       </div>' + '       <div class="modal-content"></div>' + (this.hasFooter() ? '       <div class="modal-footer"></div>' : '') + '   </div>' + '</div>');
            $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-buttons-container button.modal-closer', this.uiElement)[0]).click(()=>{
                this.hide();
                this.logStat("HIDE");
            });
            if (this.expandable) $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-buttons-container button.modal-expander', this.uiElement)[0]).click(()=>{
                if (this.isExpanded()) {
                    this.collapse();
                    this.logStat("COLLAPSE");
                } else {
                    this.expand();
                    this.logStat("EXPAND");
                }
            });
            this.uiElement.addClass(this.getModalClasses());
            this.target.append(this.uiElement);
            this.visible = false;
        }
        return this.uiElement;
    }
    /**
     * Is this modal expanded?
     * @return {boolean}
     */ isExpanded() {
        return this.expandable && this.getSessionProp("expanded");
    }
    /**
     * Expand this modal
     * @return {Modal} this modal
     */ expand() {
        if (this.expandable) {
            this.setSessionProp("expanded", true);
            $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-buttons-container button.modal-expander', this.uiElement)[0]).addClass('collapse').removeClass('expand');
            this.uiElement.addClass('expanded');
            this.expandCallbacks.forEach((c)=>c());
        }
        return this;
    }
    /**
     * Collapse this modal
     * @return {Modal} this modal
     */ collapse() {
        if (this.expandable) {
            this.setSessionProp("expanded", false);
            $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-buttons-container button.modal-expander', this.uiElement)[0]).addClass('expand').removeClass('collapse');
            this.uiElement.removeClass('expanded');
            this.expandCallbacks.forEach((c)=>c());
        }
        return this;
    }
    /**
     * Add a callback for when this modal hides
     * @param callback
     * @return {Modal} this modal
     */ onHide(callback) {
        this.hideCallbacks.push(callback);
        return this;
    }
    /**
     * Add a callback for when this modal shows
     * @param callback
     * @return {Modal} this modal
     */ onShow(callback) {
        this.showCallbacks.push(callback);
        return this;
    }
    /**
     * Add a callback for when this modal expands/collapses (if it is expandable)
     * @param callback
     * @return {Modal} this modal
     */ onExpandCollapse(callback) {
        if (this.expandable) this.expandCallbacks.push(callback);
        return this;
    }
    /**
     * Override to define HTML classes for this modal
     * @return {string}
     */ getModalClasses() {
        return '';
    }
    /**
     * Show this modal
     * @return {Modal} this modal
     */ show() {
        if (!this.visible) {
            $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-inner', this.getUIElement().addClass('visible').removeAttr('hidden'))[0]).attr('tabIndex', "1");
            this.visible = true;
            this.showCallbacks.forEach((c)=>c());
            (0, $9a87c76e274c7738$export$f03163d7279986d4).openUIElements.push(this);
        }
        return this;
    }
    /**
     * Hide this modal
     * @return {Modal} this modal
     */ hide() {
        if (this.visible) {
            $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-inner', this.getUIElement().removeClass('visible').attr('hidden', ''))[0]).attr('tabIndex', "-1");
            this.visible = false;
            this.hideCallbacks.forEach((c)=>c());
            (0, $9a87c76e274c7738$export$f03163d7279986d4).openUIElements.pop();
        }
        return this;
    }
    /**
     * Is this modal visible
     * @return {boolean}
     */ isVisible() {
        return !!this.visible;
    }
    hasFooter() {
        return !!this.footer;
    }
    /**
     * Set the title for this modal
     * @param titleText {string}
     * @return {Modal} this modal
     */ setTitle(titleText) {
        $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-title', this.getUIElement())[0]).html(titleText);
        return this;
    }
    /**
     * Set the content for this modal
     * @param elements {jQuery}
     * @return {Modal} this modal
     */ setContent(elements) {
        $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-content', this.getUIElement())[0]).empty().append(elements);
        return this;
    }
    /**
     * Set the content for this modal's footer
     * @param elements {jQuery}
     * @return {Modal} this modal
     */ setFooterContent(elements) {
        $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-footer', this.getUIElement())[0]).empty().append(elements);
        return this;
    }
    /**
     * Get the content of this modal
     * @return {jQuery}
     */ getContent() {
        return $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-content', this.getUIElement())[0]);
    }
    getCode() {
        return this.id;
    }
    close() {
        this.hide();
    }
    getContentWidth() {
        return $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-content', this.getUIElement())[0]).width();
    }
    isSmallContentWidth() {
        return this.getContentWidth() < (0, $9bc5df2b24a7fcf6$export$20b4de146c2df434);
    }
    getContentHeight() {
        return $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-content', this.getUIElement())[0]).height();
    }
    isSmallContentHeight() {
        return this.getContentHeight() < (0, $9bc5df2b24a7fcf6$export$8e5cee14bb214560);
    }
    getContentAbsolutePosition() {
        return $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.modal-content', this.getUIElement())[0]).offset();
    }
}
/**
 * A modal window that fills the whole application (some margin is left out)
 * @extends Modal
 */ class $c51f63cd05d438f7$export$3005c47b670e0a7f extends $c51f63cd05d438f7$var$Modal {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param target {jQuery} The target element to append the modal to
     * @param id {string} Panel id
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */ constructor(translator, isMobileDevice, target, id, runtimeConfig, onChangeRuntimeConfig){
        super(translator, isMobileDevice, target, id, runtimeConfig, onChangeRuntimeConfig, false);
    }
    getClassName() {
        return "ModalFull";
    }
    getModalClasses() {
        return 'full';
    }
}
/**
 * A modal window that fills the whole application with no margins
 * @extends Modal
 */ class $c51f63cd05d438f7$export$3420363e3bd73023 extends $c51f63cd05d438f7$var$Modal {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param target {jQuery} The target element to append the modal to
     * @param id {string} Panel id
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param hasFooter {boolean} should a footer be rendered for this modal?
     */ constructor(translator, isMobileDevice, target, id, runtimeConfig, onChangeRuntimeConfig, hasFooter = false){
        super(translator, isMobileDevice, target, id, runtimeConfig, onChangeRuntimeConfig, false, hasFooter);
    }
    getClassName() {
        return "ModalFullNoMargin";
    }
    getModalClasses() {
        return 'full-no-margin';
    }
}
/**
 * A modal window that fills half of the application
 */ class $c51f63cd05d438f7$export$35f3383e73608ac2 extends $c51f63cd05d438f7$var$Modal {
    getClassName() {
        return "ModalHalf";
    }
    smallScreenClasses = 'two-thirds';
    largeScreenClasses = 'half';
    onSmallContainer() {
        super.onSmallContainer();
        this.getUIElement().removeClass(this.smallScreenClasses).removeClass(this.largeScreenClasses).addClass(this.getModalClasses());
    }
    getModalClasses() {
        return this.isSmallContainerWidth || this.isSmallContainerHeight ? this.smallScreenClasses : this.largeScreenClasses;
    }
}
/**
 * A modal window that fills half of the application with no deactivation of content
 */ class $c51f63cd05d438f7$export$29c5a562b5978ae5 extends $c51f63cd05d438f7$var$Modal {
    getClassName() {
        return "ModalHalfNoDeactivation";
    }
    getModalClasses() {
        return 'half-no-deactivation';
    }
}
/**
 * A modal window that fills a third of the application
 * @extends Modal
 */ class $c51f63cd05d438f7$export$c673ce797b3897f8 extends $c51f63cd05d438f7$var$Modal {
    getClassName() {
        return "Modal1Third";
    }
    smallScreenClasses = 'two-thirds';
    largeScreenClasses = 'one-third';
    onSmallContainer() {
        super.onSmallContainer();
        this.getUIElement().removeClass(this.smallScreenClasses).removeClass(this.largeScreenClasses).addClass(this.getModalClasses());
    }
    getModalClasses() {
        return this.isSmallContainerWidth || this.isSmallContainerHeight ? this.smallScreenClasses : this.largeScreenClasses;
    }
}
/**
 * A modal window that fills 2 thirds of the application
 * @extends Modal
 */ class $c51f63cd05d438f7$export$f99cb66c19a01512 extends $c51f63cd05d438f7$var$Modal {
    getClassName() {
        return "Modal2Thirds";
    }
    smallScreenClasses = 'full';
    largeScreenClasses = 'two-thirds';
    onSmallContainer() {
        super.onSmallContainer();
        this.getUIElement().removeClass(this.smallScreenClasses).removeClass(this.largeScreenClasses).addClass(this.getModalClasses());
    }
    getModalClasses() {
        return this.isSmallContainerWidth || this.isSmallContainerHeight ? this.smallScreenClasses : this.largeScreenClasses;
    }
}






/**
 * @module ol/layer/Image
 */ /**
 * @module ol/renderer/canvas/ImageLayer
 */ /**
 * @module ol/ImageState
 */ /**
 * @enum {number}
 */ var $23fb176c76153f22$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4
};


/**
 * @module ol/ViewHint
 */ /**
 * @enum {number}
 */ var $1c808e01929bd7f1$export$2e2bcd8739ae039 = {
    ANIMATING: 0,
    INTERACTING: 1
};


/**
 * @module ol/extent
 */ /**
 * @module ol/extent/Relationship
 */ /**
 * Relationship to an extent.
 * @enum {number}
 */ var $68b6ebc493ff6e57$export$2e2bcd8739ae039 = {
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16
};


function $7e819822b33b3d32$export$8aceca7c77505534(coordinates) {
    const extent = $7e819822b33b3d32$export$fe201bb3bbe031e9();
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$7e819822b33b3d32$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [dest] Destination extent.
 * @private
 * @return {Extent} Extent.
 */ function $7e819822b33b3d32$var$_boundingExtentXYs(xs, ys, dest) {
    const minX = Math.min.apply(null, xs);
    const minY = Math.min.apply(null, ys);
    const maxX = Math.max.apply(null, xs);
    const maxY = Math.max.apply(null, ys);
    return $7e819822b33b3d32$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest);
}
function $7e819822b33b3d32$export$ab1029bcae9ddb4a(extent, value, dest) {
    if (dest) {
        dest[0] = extent[0] - value;
        dest[1] = extent[1] - value;
        dest[2] = extent[2] + value;
        dest[3] = extent[3] + value;
        return dest;
    }
    return [
        extent[0] - value,
        extent[1] - value,
        extent[2] + value,
        extent[3] + value
    ];
}
function $7e819822b33b3d32$export$9cd59f9826255e47(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent.slice();
}
function $7e819822b33b3d32$export$cbe64c389534206f(extent, x, y) {
    let dx, dy;
    if (x < extent[0]) dx = extent[0] - x;
    else if (extent[2] < x) dx = x - extent[2];
    else dx = 0;
    if (y < extent[1]) dy = extent[1] - y;
    else if (extent[3] < y) dy = y - extent[3];
    else dy = 0;
    return dx * dx + dy * dy;
}
function $7e819822b33b3d32$export$ac68c24d37ca240f(extent, coordinate) {
    return $7e819822b33b3d32$export$805bdfd6d6690e97(extent, coordinate[0], coordinate[1]);
}
function $7e819822b33b3d32$export$be866b1e0809b17e(extent1, extent2) {
    return extent1[0] <= extent2[0] && extent2[2] <= extent1[2] && extent1[1] <= extent2[1] && extent2[3] <= extent1[3];
}
function $7e819822b33b3d32$export$805bdfd6d6690e97(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
function $7e819822b33b3d32$export$f97905ead28c61a8(extent, coordinate) {
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const x = coordinate[0];
    const y = coordinate[1];
    let relationship = (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).UNKNOWN;
    if (x < minX) relationship = relationship | (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).LEFT;
    else if (x > maxX) relationship = relationship | (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).RIGHT;
    if (y < minY) relationship = relationship | (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).BELOW;
    else if (y > maxY) relationship = relationship | (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).ABOVE;
    if (relationship === (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).UNKNOWN) relationship = (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).INTERSECTING;
    return relationship;
}
function $7e819822b33b3d32$export$fe201bb3bbe031e9() {
    return [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
}
function $7e819822b33b3d32$export$958e3e1a02eac4b6(minX, minY, maxX, maxY, dest) {
    if (dest) {
        dest[0] = minX;
        dest[1] = minY;
        dest[2] = maxX;
        dest[3] = maxY;
        return dest;
    }
    return [
        minX,
        minY,
        maxX,
        maxY
    ];
}
function $7e819822b33b3d32$export$3e2152b047719fa1(dest) {
    return $7e819822b33b3d32$export$958e3e1a02eac4b6(Infinity, Infinity, -Infinity, -Infinity, dest);
}
function $7e819822b33b3d32$export$4838bf78d04a9440(coordinate, dest) {
    const x = coordinate[0];
    const y = coordinate[1];
    return $7e819822b33b3d32$export$958e3e1a02eac4b6(x, y, x, y, dest);
}
function $7e819822b33b3d32$export$29e3ad4dbd0cb863(coordinates, dest) {
    const extent = $7e819822b33b3d32$export$3e2152b047719fa1(dest);
    return $7e819822b33b3d32$export$795cd48be4d5f252(extent, coordinates);
}
function $7e819822b33b3d32$export$be0ab0bf96ca59ca(flatCoordinates, offset, end, stride, dest) {
    const extent = $7e819822b33b3d32$export$3e2152b047719fa1(dest);
    return $7e819822b33b3d32$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride);
}
function $7e819822b33b3d32$export$73b4897e93bc5c83(rings, dest) {
    const extent = $7e819822b33b3d32$export$3e2152b047719fa1(dest);
    return $7e819822b33b3d32$export$9b319549574402d7(extent, rings);
}
function $7e819822b33b3d32$export$e9bab7fafb253603(extent1, extent2) {
    return extent1[0] == extent2[0] && extent1[2] == extent2[2] && extent1[1] == extent2[1] && extent1[3] == extent2[3];
}
function $7e819822b33b3d32$export$998afeab28643bd6(extent1, extent2, tolerance) {
    return Math.abs(extent1[0] - extent2[0]) < tolerance && Math.abs(extent1[2] - extent2[2]) < tolerance && Math.abs(extent1[1] - extent2[1]) < tolerance && Math.abs(extent1[3] - extent2[3]) < tolerance;
}
function $7e819822b33b3d32$export$8b58be045bf06082(extent1, extent2) {
    if (extent2[0] < extent1[0]) extent1[0] = extent2[0];
    if (extent2[2] > extent1[2]) extent1[2] = extent2[2];
    if (extent2[1] < extent1[1]) extent1[1] = extent2[1];
    if (extent2[3] > extent1[3]) extent1[3] = extent2[3];
    return extent1;
}
function $7e819822b33b3d32$export$1f820e3920fa5715(extent, coordinate) {
    if (coordinate[0] < extent[0]) extent[0] = coordinate[0];
    if (coordinate[0] > extent[2]) extent[2] = coordinate[0];
    if (coordinate[1] < extent[1]) extent[1] = coordinate[1];
    if (coordinate[1] > extent[3]) extent[3] = coordinate[1];
}
function $7e819822b33b3d32$export$795cd48be4d5f252(extent, coordinates) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i)$7e819822b33b3d32$export$1f820e3920fa5715(extent, coordinates[i]);
    return extent;
}
function $7e819822b33b3d32$export$30570204156ffd18(extent, flatCoordinates, offset, end, stride) {
    for(; offset < end; offset += stride)$7e819822b33b3d32$export$f1dab130b92b85a9(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    return extent;
}
function $7e819822b33b3d32$export$9b319549574402d7(extent, rings) {
    for(let i = 0, ii = rings.length; i < ii; ++i)$7e819822b33b3d32$export$795cd48be4d5f252(extent, rings[i]);
    return extent;
}
function $7e819822b33b3d32$export$f1dab130b92b85a9(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
function $7e819822b33b3d32$export$f9ed8a3d123a08e2(extent, callback) {
    let val;
    val = callback($7e819822b33b3d32$export$8d09f5e2e1bf560d(extent));
    if (val) return val;
    val = callback($7e819822b33b3d32$export$e77c1cf70445e168(extent));
    if (val) return val;
    val = callback($7e819822b33b3d32$export$b84fa077c8b05295(extent));
    if (val) return val;
    val = callback($7e819822b33b3d32$export$cb1538b07e6964ff(extent));
    if (val) return val;
    return false;
}
function $7e819822b33b3d32$export$520c40045967cb15(extent) {
    let area = 0;
    if (!$7e819822b33b3d32$export$dd1bc94b04021eeb(extent)) area = $7e819822b33b3d32$export$3c49c185de0c2bfc(extent) * $7e819822b33b3d32$export$c08559766941f856(extent);
    return area;
}
function $7e819822b33b3d32$export$8d09f5e2e1bf560d(extent) {
    return [
        extent[0],
        extent[1]
    ];
}
function $7e819822b33b3d32$export$e77c1cf70445e168(extent) {
    return [
        extent[2],
        extent[1]
    ];
}
function $7e819822b33b3d32$export$c91255cadecfe081(extent) {
    return [
        (extent[0] + extent[2]) / 2,
        (extent[1] + extent[3]) / 2
    ];
}
function $7e819822b33b3d32$export$a1cfd206661d0801(extent, corner) {
    let coordinate;
    if (corner === 'bottom-left') coordinate = $7e819822b33b3d32$export$8d09f5e2e1bf560d(extent);
    else if (corner === 'bottom-right') coordinate = $7e819822b33b3d32$export$e77c1cf70445e168(extent);
    else if (corner === 'top-left') coordinate = $7e819822b33b3d32$export$cb1538b07e6964ff(extent);
    else if (corner === 'top-right') coordinate = $7e819822b33b3d32$export$b84fa077c8b05295(extent);
    else throw new Error('Invalid corner');
    return coordinate;
}
function $7e819822b33b3d32$export$7d6fa884b32a3751(extent1, extent2) {
    const minX = Math.min(extent1[0], extent2[0]);
    const minY = Math.min(extent1[1], extent2[1]);
    const maxX = Math.max(extent1[2], extent2[2]);
    const maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
function $7e819822b33b3d32$export$13ba650faf8308(center, resolution, rotation, size, dest) {
    const [x0, y0, x1, y1, x2, y2, x3, y3] = $7e819822b33b3d32$export$4b7a6fb4002cd6ac(center, resolution, rotation, size);
    return $7e819822b33b3d32$export$958e3e1a02eac4b6(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), dest);
}
function $7e819822b33b3d32$export$4b7a6fb4002cd6ac(center, resolution, rotation, size) {
    const dx = resolution * size[0] / 2;
    const dy = resolution * size[1] / 2;
    const cosRotation = Math.cos(rotation);
    const sinRotation = Math.sin(rotation);
    const xCos = dx * cosRotation;
    const xSin = dx * sinRotation;
    const yCos = dy * cosRotation;
    const ySin = dy * sinRotation;
    const x = center[0];
    const y = center[1];
    return [
        x - xCos + ySin,
        y - xSin - yCos,
        x - xCos - ySin,
        y - xSin + yCos,
        x + xCos - ySin,
        y + xSin + yCos,
        x + xCos + ySin,
        y + xSin - yCos,
        x - xCos + ySin,
        y - xSin - yCos
    ];
}
function $7e819822b33b3d32$export$c08559766941f856(extent) {
    return extent[3] - extent[1];
}
function $7e819822b33b3d32$export$f3fe0e9a60cde324(extent1, extent2) {
    const intersection = $7e819822b33b3d32$export$72209efa88586d42(extent1, extent2);
    return $7e819822b33b3d32$export$520c40045967cb15(intersection);
}
function $7e819822b33b3d32$export$72209efa88586d42(extent1, extent2, dest) {
    const intersection = dest ? dest : $7e819822b33b3d32$export$fe201bb3bbe031e9();
    if ($7e819822b33b3d32$export$7b0a31e10bbff018(extent1, extent2)) {
        if (extent1[0] > extent2[0]) intersection[0] = extent1[0];
        else intersection[0] = extent2[0];
        if (extent1[1] > extent2[1]) intersection[1] = extent1[1];
        else intersection[1] = extent2[1];
        if (extent1[2] < extent2[2]) intersection[2] = extent1[2];
        else intersection[2] = extent2[2];
        if (extent1[3] < extent2[3]) intersection[3] = extent1[3];
        else intersection[3] = extent2[3];
    } else $7e819822b33b3d32$export$3e2152b047719fa1(intersection);
    return intersection;
}
function $7e819822b33b3d32$export$1bc603050bd777b1(extent) {
    return $7e819822b33b3d32$export$3c49c185de0c2bfc(extent) + $7e819822b33b3d32$export$c08559766941f856(extent);
}
function $7e819822b33b3d32$export$31b21d0167753bb4(extent) {
    return [
        extent[2] - extent[0],
        extent[3] - extent[1]
    ];
}
function $7e819822b33b3d32$export$cb1538b07e6964ff(extent) {
    return [
        extent[0],
        extent[3]
    ];
}
function $7e819822b33b3d32$export$b84fa077c8b05295(extent) {
    return [
        extent[2],
        extent[3]
    ];
}
function $7e819822b33b3d32$export$3c49c185de0c2bfc(extent) {
    return extent[2] - extent[0];
}
function $7e819822b33b3d32$export$7b0a31e10bbff018(extent1, extent2) {
    return extent1[0] <= extent2[2] && extent1[2] >= extent2[0] && extent1[1] <= extent2[3] && extent1[3] >= extent2[1];
}
function $7e819822b33b3d32$export$dd1bc94b04021eeb(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
function $7e819822b33b3d32$export$6a4fe494c558c238(extent, dest) {
    if (dest) {
        dest[0] = extent[0];
        dest[1] = extent[1];
        dest[2] = extent[2];
        dest[3] = extent[3];
        return dest;
    }
    return extent;
}
function $7e819822b33b3d32$export$80cbab86674143b6(extent, value) {
    const deltaX = (extent[2] - extent[0]) / 2 * (value - 1);
    const deltaY = (extent[3] - extent[1]) / 2 * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
function $7e819822b33b3d32$export$a6a5a7a461419425(extent, start, end) {
    let intersects = false;
    const startRel = $7e819822b33b3d32$export$f97905ead28c61a8(extent, start);
    const endRel = $7e819822b33b3d32$export$f97905ead28c61a8(extent, end);
    if (startRel === (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).INTERSECTING || endRel === (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).INTERSECTING) intersects = true;
    else {
        const minX = extent[0];
        const minY = extent[1];
        const maxX = extent[2];
        const maxY = extent[3];
        const startX = start[0];
        const startY = start[1];
        const endX = end[0];
        const endY = end[1];
        const slope = (endY - startY) / (endX - startX);
        let x, y;
        if (!!(endRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).ABOVE) && !(startRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).RIGHT) && !(startRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects && !!(endRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).BELOW) && !(startRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects && !!(endRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).LEFT) && !(startRel & (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
function $7e819822b33b3d32$export$9f9dcb98c894b623(extent, transformFn, dest, stops) {
    if ($7e819822b33b3d32$export$dd1bc94b04021eeb(extent)) return $7e819822b33b3d32$export$3e2152b047719fa1(dest);
    let coordinates = [];
    if (stops > 1) {
        const width = extent[2] - extent[0];
        const height = extent[3] - extent[1];
        for(let i = 0; i < stops; ++i)coordinates.push(extent[0] + width * i / stops, extent[1], extent[2], extent[1] + height * i / stops, extent[2] - width * i / stops, extent[3], extent[0], extent[3] - height * i / stops);
    } else coordinates = [
        extent[0],
        extent[1],
        extent[2],
        extent[1],
        extent[2],
        extent[3],
        extent[0],
        extent[3]
    ];
    transformFn(coordinates, coordinates, 2);
    const xs = [];
    const ys = [];
    for(let i = 0, l = coordinates.length; i < l; i += 2){
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return $7e819822b33b3d32$var$_boundingExtentXYs(xs, ys, dest);
}
function $7e819822b33b3d32$export$39a9ce3624977b84(extent, projection) {
    const projectionExtent = projection.getExtent();
    const center = $7e819822b33b3d32$export$c91255cadecfe081(extent);
    if (projection.canWrapX() && (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        const worldWidth = $7e819822b33b3d32$export$3c49c185de0c2bfc(projectionExtent);
        const worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        const offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
function $7e819822b33b3d32$export$9031237f01de0947(extent, projection, multiWorld) {
    if (projection.canWrapX()) {
        const projectionExtent = projection.getExtent();
        if (!isFinite(extent[0]) || !isFinite(extent[2])) return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        $7e819822b33b3d32$export$39a9ce3624977b84(extent, projection);
        const worldWidth = $7e819822b33b3d32$export$3c49c185de0c2bfc(projectionExtent);
        if ($7e819822b33b3d32$export$3c49c185de0c2bfc(extent) > worldWidth && !multiWorld) // the extent wraps around on itself
        return [
            [
                projectionExtent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ]
        ];
        if (extent[0] < projectionExtent[0]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0] + worldWidth,
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2],
                extent[3]
            ]
        ];
        if (extent[2] > projectionExtent[2]) // the extent crosses the anti meridian, so it needs to be sliced
        return [
            [
                extent[0],
                extent[1],
                projectionExtent[2],
                extent[3]
            ],
            [
                projectionExtent[0],
                extent[1],
                extent[2] - worldWidth,
                extent[3]
            ]
        ];
    }
    return [
        extent
    ];
}


/**
 * @module ol/proj
 */ /**
 * The ol/proj module stores:
 * a list of {@link module:ol/proj/Projection~Projection}
 * objects, one for each projection supported by the application
 * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection~Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection~Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */ /**
 * @module ol/console
 */ /**
 * @typedef {'info'|'warn'|'error'|'none'} Level
 */ /**
 * @type {Object<Level, number>}
 */ const $7ebf1be11d834723$var$levels = {
    info: 1,
    warn: 2,
    error: 3,
    none: 4
};
/**
 * @type {number}
 */ let $7ebf1be11d834723$var$level = $7ebf1be11d834723$var$levels.info;
function $7ebf1be11d834723$export$2c97a59140dbf245(l) {
    $7ebf1be11d834723$var$level = $7ebf1be11d834723$var$levels[l];
}
function $7ebf1be11d834723$export$bef1f36f5486a6a3(...args) {
    if ($7ebf1be11d834723$var$level > $7ebf1be11d834723$var$levels.info) return;
    console.log(...args); // eslint-disable-line no-console
}
function $7ebf1be11d834723$export$c106dd0671a0fc2d(...args) {
    if ($7ebf1be11d834723$var$level > $7ebf1be11d834723$var$levels.warn) return;
    console.warn(...args); // eslint-disable-line no-console
}
function $7ebf1be11d834723$export$a3bc9b8ed74fc(...args) {
    if ($7ebf1be11d834723$var$level > $7ebf1be11d834723$var$levels.error) return;
    console.error(...args); // eslint-disable-line no-console
}


/**
 * @module ol/coordinate
 */ 
/**
 * @module ol/math
 */ /**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */ function $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
function $d4e56cfc37d8b1f9$export$251bb0a9cef172e6(x, y, x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        } else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538(x, y, x1, y1);
}
function $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538(x1, y1, x2, y2) {
    const dx = x2 - x1;
    const dy = y2 - y1;
    return dx * dx + dy * dy;
}
function $d4e56cfc37d8b1f9$export$8240f01c446270e6(mat) {
    const n = mat.length;
    for(let i = 0; i < n; i++){
        // Find max in the i-th column (ignoring i - 1 first rows)
        let maxRow = i;
        let maxEl = Math.abs(mat[i][i]);
        for(let r = i + 1; r < n; r++){
            const absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) return null; // matrix is singular
        // Swap max row with i-th (current) row
        const tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for(let j = i + 1; j < n; j++){
            const coef = -mat[j][i] / mat[i][i];
            for(let k = i; k < n + 1; k++)if (i == k) mat[j][k] = 0;
            else mat[j][k] += coef * mat[i][k];
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    const x = new Array(n);
    for(let l = n - 1; l >= 0; l--){
        x[l] = mat[l][n] / mat[l][l];
        for(let m = l - 1; m >= 0; m--)mat[m][n] -= mat[m][l] * x[l];
    }
    return x;
}
function $d4e56cfc37d8b1f9$export$56cb859c01fa134d(angleInRadians) {
    return angleInRadians * 180 / Math.PI;
}
function $d4e56cfc37d8b1f9$export$cba01ba138429a1d(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}
function $d4e56cfc37d8b1f9$export$ba467bec01d66def(a, b) {
    const r = a % b;
    return r * b < 0 ? r + b : r;
}
function $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f(a, b, x) {
    return a + x * (b - a);
}
function $d4e56cfc37d8b1f9$export$a81f732198733497(n, decimals) {
    const factor = Math.pow(10, decimals);
    return Math.round(n * factor) / factor;
}
function $d4e56cfc37d8b1f9$export$2077e0241d6afd3c(n, decimals) {
    return Math.round($d4e56cfc37d8b1f9$export$a81f732198733497(n, decimals));
}
function $d4e56cfc37d8b1f9$export$a3fe094919f356fd(n, decimals) {
    return Math.floor($d4e56cfc37d8b1f9$export$a81f732198733497(n, decimals));
}
function $d4e56cfc37d8b1f9$export$803ce6b71a0a94b2(n, decimals) {
    return Math.ceil($d4e56cfc37d8b1f9$export$a81f732198733497(n, decimals));
}
function $d4e56cfc37d8b1f9$export$4997ffc0176396a6(n, min, max) {
    if (n >= min && n < max) return n;
    const range = max - min;
    return ((n - min) % range + range) % range + min;
}


/**
 * @module ol/string
 */ /**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */ function $812f370f71eebcf4$export$24be126cb0a7bbeb(number, width, precision) {
    const numberString = precision !== undefined ? number.toFixed(precision) : '' + number;
    let decimal = numberString.indexOf('.');
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width ? numberString : new Array(1 + width - decimal).join('0') + numberString;
}
function $812f370f71eebcf4$export$66e1c0999abad646(v1, v2) {
    const s1 = ('' + v1).split('.');
    const s2 = ('' + v2).split('.');
    for(let i = 0; i < Math.max(s1.length, s2.length); i++){
        const n1 = parseInt(s1[i] || '0', 10);
        const n2 = parseInt(s2[i] || '0', 10);
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
    }
    return 0;
}


function $8b28786758450fff$export$e16d8520af44a096(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
function $8b28786758450fff$export$cbe80a3fcd2b99b7(coordinate, circle) {
    const r = circle.getRadius();
    const center = circle.getCenter();
    const x0 = center[0];
    const y0 = center[1];
    const x1 = coordinate[0];
    const y1 = coordinate[1];
    let dx = x1 - x0;
    const dy = y1 - y0;
    if (dx === 0 && dy === 0) dx = 1;
    const d = Math.sqrt(dx * dx + dy * dy);
    const x = x0 + r * dx / d;
    const y = y0 + r * dy / d;
    return [
        x,
        y
    ];
}
function $8b28786758450fff$export$18cdd31d17f97131(coordinate, segment) {
    const x0 = coordinate[0];
    const y0 = coordinate[1];
    const start = segment[0];
    const end = segment[1];
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    const along = dx === 0 && dy === 0 ? 0 : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    let x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    } else if (along >= 1) {
        x = x2;
        y = y2;
    } else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [
        x,
        y
    ];
}
function $8b28786758450fff$export$35ad6765fe262b6(fractionDigits) {
    return(/**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */ function(coordinate) {
        return $8b28786758450fff$export$9ff8f16060979e0a(coordinate, fractionDigits);
    });
}
function $8b28786758450fff$export$6eb0ac5f024d8590(hemispheres, degrees, fractionDigits) {
    const normalizedDegrees = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(degrees + 180, 360) - 180;
    const x = Math.abs(3600 * normalizedDegrees);
    const decimals = fractionDigits || 0;
    let deg = Math.floor(x / 3600);
    let min = Math.floor((x - deg * 3600) / 60);
    let sec = (0, $d4e56cfc37d8b1f9$export$a81f732198733497)(x - deg * 3600 - min * 60, decimals);
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    let hdms = deg + '\u00b0';
    if (min !== 0 || sec !== 0) hdms += ' ' + (0, $812f370f71eebcf4$export$24be126cb0a7bbeb)(min, 2) + '\u2032';
    if (sec !== 0) hdms += ' ' + (0, $812f370f71eebcf4$export$24be126cb0a7bbeb)(sec, 2, decimals) + '\u2033';
    if (normalizedDegrees !== 0) hdms += ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0);
    return hdms;
}
function $8b28786758450fff$export$d9468344d3651243(coordinate, template, fractionDigits) {
    if (coordinate) return template.replace('{x}', coordinate[0].toFixed(fractionDigits)).replace('{y}', coordinate[1].toFixed(fractionDigits));
    return '';
}
function $8b28786758450fff$export$e9bab7fafb253603(coordinate1, coordinate2) {
    let equals = true;
    for(let i = coordinate1.length - 1; i >= 0; --i)if (coordinate1[i] != coordinate2[i]) {
        equals = false;
        break;
    }
    return equals;
}
function $8b28786758450fff$export$bb628a54ab399bc9(coordinate, angle) {
    const cosAngle = Math.cos(angle);
    const sinAngle = Math.sin(angle);
    const x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    const y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
function $8b28786758450fff$export$dcdf75081b88279d(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
function $8b28786758450fff$export$88e6ebb4fe54f538(coord1, coord2) {
    const dx = coord1[0] - coord2[0];
    const dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
function $8b28786758450fff$export$9f17032d917177de(coord1, coord2) {
    return Math.sqrt($8b28786758450fff$export$88e6ebb4fe54f538(coord1, coord2));
}
function $8b28786758450fff$export$6985570514055196(coordinate, segment) {
    return $8b28786758450fff$export$88e6ebb4fe54f538(coordinate, $8b28786758450fff$export$18cdd31d17f97131(coordinate, segment));
}
function $8b28786758450fff$export$c883fd238161f841(coordinate, fractionDigits) {
    if (coordinate) return $8b28786758450fff$export$6eb0ac5f024d8590('NS', coordinate[1], fractionDigits) + ' ' + $8b28786758450fff$export$6eb0ac5f024d8590('EW', coordinate[0], fractionDigits);
    return '';
}
function $8b28786758450fff$export$9ff8f16060979e0a(coordinate, fractionDigits) {
    return $8b28786758450fff$export$d9468344d3651243(coordinate, '{x}, {y}', fractionDigits);
}
function $8b28786758450fff$export$39a9ce3624977b84(coordinate, projection) {
    if (projection.canWrapX()) {
        const worldWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projection.getExtent());
        const worldsAway = $8b28786758450fff$export$24e2b27d1ff0c1d5(coordinate, projection, worldWidth);
        if (worldsAway) coordinate[0] -= worldsAway * worldWidth;
    }
    return coordinate;
}
function $8b28786758450fff$export$24e2b27d1ff0c1d5(coordinate, projection, sourceExtentWidth) {
    const projectionExtent = projection.getExtent();
    let worldsAway = 0;
    if (projection.canWrapX() && (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        sourceExtentWidth = sourceExtentWidth || (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}





/**
 * @module ol/proj/Units
 */ /**
 * @typedef {'radians' | 'degrees' | 'ft' | 'm' | 'pixels' | 'tile-pixels' | 'us-ft'} Units
 * Projection units.
 */ /**
 * See http://duff.ess.washington.edu/data/raster/drg/docs/geotiff.txt
 * @type {Object<number, Units>}
 */ const $fb72d58bc9104528$var$unitByCode = {
    '9001': 'm',
    '9002': 'ft',
    '9003': 'us-ft',
    '9101': 'radians',
    '9102': 'degrees'
};
function $fb72d58bc9104528$export$7f58726df3255edc(code) {
    return $fb72d58bc9104528$var$unitByCode[code];
}
const $fb72d58bc9104528$export$1482081eec883108 = {
    // use the radius of the Normal sphere
    'radians': 6370997 / (2 * Math.PI),
    'degrees': 2 * Math.PI * 6370997 / 360,
    'ft': 0.3048,
    'm': 1,
    'us-ft': 1200 / 3937
};


/**
 * @module ol/proj/epsg3857
 */ /**
 * @module ol/proj/Projection
 */ 
/**
 * The function is called with a `number` view resolution and a
 * {@link module:ol/coordinate~Coordinate} as arguments, and returns the `number` resolution
 * in projection units at the passed coordinate.
 * @typedef {function(number, import("../coordinate.js").Coordinate):number} GetPointResolution
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").Units} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {GetPointResolution} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution} function will be used.
 */ /**
 * @classdesc
 * In most cases, you should not need to create instances of this class.
 * Instead, where projection information is required, you can use a string
 * projection code or identifier (e.g. `EPSG:4326`) instead of a projection
 * instance.
 *
 * The library includes support for transforming coordinates between the following
 * projections:
 *
 *  WGS 84 / Geographic - Using codes `EPSG:4326`, `CRS:84`, `urn:ogc:def:crs:EPSG:6.6:4326`,
 *    `urn:ogc:def:crs:OGC:1.3:CRS84`, `urn:ogc:def:crs:OGC:2:84`, `http://www.opengis.net/gml/srs/epsg.xml#4326`,
 *    or `urn:x-ogc:def:crs:EPSG:4326`
 *  WGS 84 / Spherical Mercator - Using codes `EPSG:3857`, `EPSG:102100`, `EPSG:102113`, `EPSG:900913`,
 *    `urn:ogc:def:crs:EPSG:6.18:3:3857`, or `http://www.opengis.net/gml/srs/epsg.xml#3857`
 *  WGS 84 / UTM zones - Using codes `EPSG:32601` through `EPSG:32660` for northern zones
 *    and `EPSG:32701` through `EPSG:32760` for southern zones. Note that the built-in UTM transforms
 *    are lower accuracy (with errors on the order of 0.1 m) than those that you might get in a
 *    library like [proj4js](https://github.com/proj4js/proj4js).
 *
 * For additional projection support, or to use higher accuracy transforms than the built-in ones, you can use
 * the [proj4js](https://github.com/proj4js/proj4js) library. With `proj4js`, after adding any new projection
 * definitions, call the {@link module:ol/proj/proj4.register} function.
 *
 * You can use the {@link module:ol/proj.get} function to retrieve a projection instance
 * for one of the registered projections.
 *
 * @api
 */ class $8fe6435c5dc78f3e$var$Projection {
    /**
   * @param {Options} options Projection options.
   */ constructor(options){
        /**
     * @private
     * @type {string}
     */ this.code_ = options.code;
        /**
     * Units of projected coordinates. When set to `TILE_PIXELS`, a
     * `this.extent_` and `this.worldExtent_` must be configured properly for each
     * tile.
     * @private
     * @type {import("./Units.js").Units}
     */ this.units_ = /** @type {import("./Units.js").Units} */ options.units;
        /**
     * Validity extent of the projection in projected coordinates. For projections
     * with `TILE_PIXELS` units, this is the extent of the tile in
     * tile pixel space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
     * Extent of the world in EPSG:4326. For projections with
     * `TILE_PIXELS` units, this is the extent of the tile in
     * projected coordinate space.
     * @private
     * @type {import("../extent.js").Extent}
     */ this.worldExtent_ = options.worldExtent !== undefined ? options.worldExtent : null;
        /**
     * @private
     * @type {string}
     */ this.axisOrientation_ = options.axisOrientation !== undefined ? options.axisOrientation : 'enu';
        /**
     * @private
     * @type {boolean}
     */ this.global_ = options.global !== undefined ? options.global : false;
        /**
     * @private
     * @type {boolean}
     */ this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
     * @private
     * @type {GetPointResolution|undefined}
     */ this.getPointResolutionFunc_ = options.getPointResolution;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.defaultTileGrid_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
   * @return {boolean} The projection is suitable for wrapping the x-axis
   */ canWrapX() {
        return this.canWrapX_;
    }
    /**
   * Get the code for this projection, e.g. 'EPSG:4326'.
   * @return {string} Code.
   * @api
   */ getCode() {
        return this.code_;
    }
    /**
   * Get the validity extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the units of this projection.
   * @return {import("./Units.js").Units} Units.
   * @api
   */ getUnits() {
        return this.units_;
    }
    /**
   * Get the amount of meters per unit of this projection.  If the projection is
   * not configured with `metersPerUnit` or a units identifier, the return is
   * `undefined`.
   * @return {number|undefined} Meters.
   * @api
   */ getMetersPerUnit() {
        return this.metersPerUnit_ || (0, $fb72d58bc9104528$export$1482081eec883108)[this.units_];
    }
    /**
   * Get the world extent for this projection.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getWorldExtent() {
        return this.worldExtent_;
    }
    /**
   * Get the axis orientation of this projection.
   * Example values are:
   * enu - the default easting, northing, elevation.
   * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
   *     or south orientated transverse mercator.
   * wnu - westing, northing, up - some planetary coordinate systems have
   *     "west positive" coordinate systems
   * @return {string} Axis orientation.
   * @api
   */ getAxisOrientation() {
        return this.axisOrientation_;
    }
    /**
   * Is this projection a global projection which spans the whole world?
   * @return {boolean} Whether the projection is global.
   * @api
   */ isGlobal() {
        return this.global_;
    }
    /**
   * Set if the projection is a global projection which spans the whole world
   * @param {boolean} global Whether the projection is global.
   * @api
   */ setGlobal(global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    }
    /**
   * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
   */ getDefaultTileGrid() {
        return this.defaultTileGrid_;
    }
    /**
   * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
   */ setDefaultTileGrid(tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    }
    /**
   * Set the validity extent for this projection.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ setExtent(extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    }
    /**
   * Set the world extent for this projection.
   * @param {import("../extent.js").Extent} worldExtent World extent
   *     [minlon, minlat, maxlon, maxlat].
   * @api
   */ setWorldExtent(worldExtent) {
        this.worldExtent_ = worldExtent;
    }
    /**
   * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
   * for this projection.
   * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
   * @api
   */ setGetPointResolution(func) {
        this.getPointResolutionFunc_ = func;
    }
    /**
   * Get the custom point resolution function for this projection (if set).
   * @return {GetPointResolution|undefined} The custom point
   * resolution function (if set).
   */ getPointResolutionFunc() {
        return this.getPointResolutionFunc_;
    }
}
var $8fe6435c5dc78f3e$export$2e2bcd8739ae039 = $8fe6435c5dc78f3e$var$Projection;


const $830637c92019e485$export$2d2c9be8b5b863f = 6378137;
const $830637c92019e485$export$f3928063e5e96d35 = Math.PI * $830637c92019e485$export$2d2c9be8b5b863f;
const $830637c92019e485$export$21e6da8a7375dfe8 = [
    -$830637c92019e485$export$f3928063e5e96d35,
    -$830637c92019e485$export$f3928063e5e96d35,
    $830637c92019e485$export$f3928063e5e96d35,
    $830637c92019e485$export$f3928063e5e96d35
];
const $830637c92019e485$export$ae9d6ed80df710e5 = [
    -180,
    -85,
    180,
    85
];
const $830637c92019e485$export$d26945d1ad52feeb = $830637c92019e485$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */ class $830637c92019e485$var$EPSG3857Projection extends (0, $8fe6435c5dc78f3e$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   */ constructor(code){
        super({
            code: code,
            units: 'm',
            extent: $830637c92019e485$export$21e6da8a7375dfe8,
            global: true,
            worldExtent: $830637c92019e485$export$ae9d6ed80df710e5,
            getPointResolution: function(resolution, point) {
                return resolution / Math.cosh(point[1] / $830637c92019e485$export$2d2c9be8b5b863f);
            }
        });
    }
}
const $830637c92019e485$export$b508d7ad9a891c1b = [
    new $830637c92019e485$var$EPSG3857Projection('EPSG:3857'),
    new $830637c92019e485$var$EPSG3857Projection('EPSG:102100'),
    new $830637c92019e485$var$EPSG3857Projection('EPSG:102113'),
    new $830637c92019e485$var$EPSG3857Projection('EPSG:900913'),
    new $830637c92019e485$var$EPSG3857Projection('http://www.opengis.net/def/crs/EPSG/0/3857'),
    new $830637c92019e485$var$EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857')
];
function $830637c92019e485$export$1ff8bb36c0983070(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = $830637c92019e485$export$f3928063e5e96d35 * input[i] / 180;
        let y = $830637c92019e485$export$2d2c9be8b5b863f * Math.log(Math.tan(Math.PI * (+input[i + 1] + 90) / 360));
        if (y > $830637c92019e485$export$d26945d1ad52feeb) y = $830637c92019e485$export$d26945d1ad52feeb;
        else if (y < -$830637c92019e485$export$d26945d1ad52feeb) y = -$830637c92019e485$export$d26945d1ad52feeb;
        output[i + 1] = y;
    }
    return output;
}
function $830637c92019e485$export$8c71322ec28ed6b4(input, output, dimension, stride) {
    const length = input.length;
    dimension = dimension > 1 ? dimension : 2;
    stride = stride ?? dimension;
    if (output === undefined) {
        if (dimension > 2) // preserve values beyond second dimension
        output = input.slice();
        else output = new Array(length);
    }
    for(let i = 0; i < length; i += stride){
        output[i] = 180 * input[i] / $830637c92019e485$export$f3928063e5e96d35;
        output[i + 1] = 360 * Math.atan(Math.exp(input[i + 1] / $830637c92019e485$export$2d2c9be8b5b863f)) / Math.PI - 90;
    }
    return output;
}


/**
 * @module ol/proj/epsg4326
 */ 
const $4cc5940fd2dc7816$export$2d2c9be8b5b863f = 6378137;
const $4cc5940fd2dc7816$export$21e6da8a7375dfe8 = [
    -180,
    -90,
    180,
    90
];
const $4cc5940fd2dc7816$export$1482081eec883108 = Math.PI * $4cc5940fd2dc7816$export$2d2c9be8b5b863f / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */ class $4cc5940fd2dc7816$var$EPSG4326Projection extends (0, $8fe6435c5dc78f3e$export$2e2bcd8739ae039) {
    /**
   * @param {string} code Code.
   * @param {string} [axisOrientation] Axis orientation.
   */ constructor(code, axisOrientation){
        super({
            code: code,
            units: 'degrees',
            extent: $4cc5940fd2dc7816$export$21e6da8a7375dfe8,
            axisOrientation: axisOrientation,
            global: true,
            metersPerUnit: $4cc5940fd2dc7816$export$1482081eec883108,
            worldExtent: $4cc5940fd2dc7816$export$21e6da8a7375dfe8
        });
    }
}
const $4cc5940fd2dc7816$export$b508d7ad9a891c1b = [
    new $4cc5940fd2dc7816$var$EPSG4326Projection('CRS:84'),
    new $4cc5940fd2dc7816$var$EPSG4326Projection('EPSG:4326', 'neu'),
    new $4cc5940fd2dc7816$var$EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
    new $4cc5940fd2dc7816$var$EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
    new $4cc5940fd2dc7816$var$EPSG4326Projection('http://www.opengis.net/def/crs/OGC/1.3/CRS84'),
    new $4cc5940fd2dc7816$var$EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'),
    new $4cc5940fd2dc7816$var$EPSG4326Projection('http://www.opengis.net/def/crs/EPSG/0/4326', 'neu')
];


/**
 * @module ol/proj/projections
 */ /**
 * @type {Object<string, import("./Projection.js").default>}
 */ let $1c99841673e46c67$var$cache = {};
function $1c99841673e46c67$export$42ffd38884aecdac() {
    $1c99841673e46c67$var$cache = {};
}
function $1c99841673e46c67$export$3988ae62b71be9a3(code) {
    return $1c99841673e46c67$var$cache[code] || $1c99841673e46c67$var$cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] || null;
}
function $1c99841673e46c67$export$e16d8520af44a096(code, projection) {
    $1c99841673e46c67$var$cache[code] = projection;
}


/**
 * @module ol/proj/transforms
 */ /**
 * @module ol/obj
 */ /**
 * Removes all properties from an object.
 * @param {Object<string, unknown>} object The object to clear.
 */ function $8c1e0b75b65663dc$export$42ffd38884aecdac(object) {
    for(const property in object)delete object[property];
}
function $8c1e0b75b65663dc$export$dd1bc94b04021eeb(object) {
    let property;
    for(property in object)return false;
    return !property;
}


/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */ let $5311269cd01b387a$var$transforms = {};
function $5311269cd01b387a$export$42ffd38884aecdac() {
    $5311269cd01b387a$var$transforms = {};
}
function $5311269cd01b387a$export$e16d8520af44a096(source, destination, transformFn) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    if (!(sourceCode in $5311269cd01b387a$var$transforms)) $5311269cd01b387a$var$transforms[sourceCode] = {};
    $5311269cd01b387a$var$transforms[sourceCode][destinationCode] = transformFn;
}
function $5311269cd01b387a$export$cd7f480d6b8286c3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    const transform = $5311269cd01b387a$var$transforms[sourceCode][destinationCode];
    delete $5311269cd01b387a$var$transforms[sourceCode][destinationCode];
    if ((0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)($5311269cd01b387a$var$transforms[sourceCode])) delete $5311269cd01b387a$var$transforms[sourceCode];
    return transform;
}
function $5311269cd01b387a$export$3988ae62b71be9a3(sourceCode, destinationCode) {
    if (sourceCode in $5311269cd01b387a$var$transforms && destinationCode in $5311269cd01b387a$var$transforms[sourceCode]) return $5311269cd01b387a$var$transforms[sourceCode][destinationCode];
    return null;
}


/**
 * @module ol/proj/utm
 */ /**
 * Adapted from https://github.com/Turbo87/utm
 * Copyright (c) 2012-2017 Tobias Bieniek
 *
 * The functions here provide approximate transforms to and from UTM.
 * They are not appropriate for use beyond the validity extend of a UTM
 * zone, and the accuracy of the transform decreases toward the zone
 * edges.
 */ 

/**
 * @typedef {Object} UTMZone
 * @property {number} number The zone number (1 - 60).
 * @property {boolean} north The northern hemisphere.
 */ const $43272f1b2b7cca4e$var$K0 = 0.9996;
const $43272f1b2b7cca4e$var$E = 0.00669438;
const $43272f1b2b7cca4e$var$E2 = $43272f1b2b7cca4e$var$E * $43272f1b2b7cca4e$var$E;
const $43272f1b2b7cca4e$var$E3 = $43272f1b2b7cca4e$var$E2 * $43272f1b2b7cca4e$var$E;
const $43272f1b2b7cca4e$var$E_P2 = $43272f1b2b7cca4e$var$E / (1 - $43272f1b2b7cca4e$var$E);
const $43272f1b2b7cca4e$var$SQRT_E = Math.sqrt(1 - $43272f1b2b7cca4e$var$E);
const $43272f1b2b7cca4e$var$_E = (1 - $43272f1b2b7cca4e$var$SQRT_E) / (1 + $43272f1b2b7cca4e$var$SQRT_E);
const $43272f1b2b7cca4e$var$_E2 = $43272f1b2b7cca4e$var$_E * $43272f1b2b7cca4e$var$_E;
const $43272f1b2b7cca4e$var$_E3 = $43272f1b2b7cca4e$var$_E2 * $43272f1b2b7cca4e$var$_E;
const $43272f1b2b7cca4e$var$_E4 = $43272f1b2b7cca4e$var$_E3 * $43272f1b2b7cca4e$var$_E;
const $43272f1b2b7cca4e$var$_E5 = $43272f1b2b7cca4e$var$_E4 * $43272f1b2b7cca4e$var$_E;
const $43272f1b2b7cca4e$var$M1 = 1 - $43272f1b2b7cca4e$var$E / 4 - 3 * $43272f1b2b7cca4e$var$E2 / 64 - 5 * $43272f1b2b7cca4e$var$E3 / 256;
const $43272f1b2b7cca4e$var$M2 = 3 * $43272f1b2b7cca4e$var$E / 8 + 3 * $43272f1b2b7cca4e$var$E2 / 32 + 45 * $43272f1b2b7cca4e$var$E3 / 1024;
const $43272f1b2b7cca4e$var$M3 = 15 * $43272f1b2b7cca4e$var$E2 / 256 + 45 * $43272f1b2b7cca4e$var$E3 / 1024;
const $43272f1b2b7cca4e$var$M4 = 35 * $43272f1b2b7cca4e$var$E3 / 3072;
const $43272f1b2b7cca4e$var$P2 = 1.5 * $43272f1b2b7cca4e$var$_E - 27 / 32 * $43272f1b2b7cca4e$var$_E3 + 269 / 512 * $43272f1b2b7cca4e$var$_E5;
const $43272f1b2b7cca4e$var$P3 = 21 / 16 * $43272f1b2b7cca4e$var$_E2 - 55 / 32 * $43272f1b2b7cca4e$var$_E4;
const $43272f1b2b7cca4e$var$P4 = 151 / 96 * $43272f1b2b7cca4e$var$_E3 - 417 / 128 * $43272f1b2b7cca4e$var$_E5;
const $43272f1b2b7cca4e$var$P5 = 1097 / 512 * $43272f1b2b7cca4e$var$_E4;
const $43272f1b2b7cca4e$var$R = 6378137;
/**
 * @param {number} easting Easting value of coordinate.
 * @param {number} northing Northing value of coordinate.
 * @param {UTMZone} zone The UTM zone.
 * @return {import("../coordinate.js").Coordinate} The transformed coordinate.
 */ function $43272f1b2b7cca4e$var$toLonLat(easting, northing, zone) {
    const x = easting - 500000;
    const y = zone.north ? northing : northing - 10000000;
    const m = y / $43272f1b2b7cca4e$var$K0;
    const mu = m / ($43272f1b2b7cca4e$var$R * $43272f1b2b7cca4e$var$M1);
    const pRad = mu + $43272f1b2b7cca4e$var$P2 * Math.sin(2 * mu) + $43272f1b2b7cca4e$var$P3 * Math.sin(4 * mu) + $43272f1b2b7cca4e$var$P4 * Math.sin(6 * mu) + $43272f1b2b7cca4e$var$P5 * Math.sin(8 * mu);
    const pSin = Math.sin(pRad);
    const pSin2 = pSin * pSin;
    const pCos = Math.cos(pRad);
    const pTan = pSin / pCos;
    const pTan2 = pTan * pTan;
    const pTan4 = pTan2 * pTan2;
    const epSin = 1 - $43272f1b2b7cca4e$var$E * pSin2;
    const epSinSqrt = Math.sqrt(1 - $43272f1b2b7cca4e$var$E * pSin2);
    const n = $43272f1b2b7cca4e$var$R / epSinSqrt;
    const r = (1 - $43272f1b2b7cca4e$var$E) / epSin;
    const c = $43272f1b2b7cca4e$var$E_P2 * pCos ** 2;
    const c2 = c * c;
    const d = x / (n * $43272f1b2b7cca4e$var$K0);
    const d2 = d * d;
    const d3 = d2 * d;
    const d4 = d3 * d;
    const d5 = d4 * d;
    const d6 = d5 * d;
    const latitude = pRad - pTan / r * (d2 / 2 - d4 / 24 * (5 + 3 * pTan2 + 10 * c - 4 * c2 - 9 * $43272f1b2b7cca4e$var$E_P2)) + d6 / 720 * (61 + 90 * pTan2 + 298 * c + 45 * pTan4 - 252 * $43272f1b2b7cca4e$var$E_P2 - 3 * c2);
    let longitude = (d - d3 / 6 * (1 + 2 * pTan2 + c) + d5 / 120 * (5 - 2 * c + 28 * pTan2 - 3 * c2 + 8 * $43272f1b2b7cca4e$var$E_P2 + 24 * pTan4)) / pCos;
    longitude = (0, $d4e56cfc37d8b1f9$export$4997ffc0176396a6)(longitude + (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)($43272f1b2b7cca4e$var$zoneToCentralLongitude(zone.number)), -Math.PI, Math.PI);
    return [
        (0, $d4e56cfc37d8b1f9$export$56cb859c01fa134d)(longitude),
        (0, $d4e56cfc37d8b1f9$export$56cb859c01fa134d)(latitude)
    ];
}
const $43272f1b2b7cca4e$var$MIN_LATITUDE = -80;
const $43272f1b2b7cca4e$var$MAX_LATITUDE = 84;
const $43272f1b2b7cca4e$var$MIN_LONGITUDE = -180;
const $43272f1b2b7cca4e$var$MAX_LONGITUDE = 180;
/**
 * @param {number} longitude The longitude.
 * @param {number} latitude The latitude.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../coordinate.js').Coordinate} The UTM coordinate.
 */ function $43272f1b2b7cca4e$var$fromLonLat(longitude, latitude, zone) {
    longitude = (0, $d4e56cfc37d8b1f9$export$4997ffc0176396a6)(longitude, $43272f1b2b7cca4e$var$MIN_LONGITUDE, $43272f1b2b7cca4e$var$MAX_LONGITUDE);
    if (latitude < $43272f1b2b7cca4e$var$MIN_LATITUDE) latitude = $43272f1b2b7cca4e$var$MIN_LATITUDE;
    else if (latitude > $43272f1b2b7cca4e$var$MAX_LATITUDE) latitude = $43272f1b2b7cca4e$var$MAX_LATITUDE;
    const latRad = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(latitude);
    const latSin = Math.sin(latRad);
    const latCos = Math.cos(latRad);
    const latTan = latSin / latCos;
    const latTan2 = latTan * latTan;
    const latTan4 = latTan2 * latTan2;
    const lonRad = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(longitude);
    const centralLon = $43272f1b2b7cca4e$var$zoneToCentralLongitude(zone.number);
    const centralLonRad = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(centralLon);
    const n = $43272f1b2b7cca4e$var$R / Math.sqrt(1 - $43272f1b2b7cca4e$var$E * latSin ** 2);
    const c = $43272f1b2b7cca4e$var$E_P2 * latCos ** 2;
    const a = latCos * (0, $d4e56cfc37d8b1f9$export$4997ffc0176396a6)(lonRad - centralLonRad, -Math.PI, Math.PI);
    const a2 = a * a;
    const a3 = a2 * a;
    const a4 = a3 * a;
    const a5 = a4 * a;
    const a6 = a5 * a;
    const m = $43272f1b2b7cca4e$var$R * ($43272f1b2b7cca4e$var$M1 * latRad - $43272f1b2b7cca4e$var$M2 * Math.sin(2 * latRad) + $43272f1b2b7cca4e$var$M3 * Math.sin(4 * latRad) - $43272f1b2b7cca4e$var$M4 * Math.sin(6 * latRad));
    const easting = $43272f1b2b7cca4e$var$K0 * n * (a + a3 / 6 * (1 - latTan2 + c) + a5 / 120 * (5 - 18 * latTan2 + latTan4 + 72 * c - 58 * $43272f1b2b7cca4e$var$E_P2)) + 500000;
    let northing = $43272f1b2b7cca4e$var$K0 * (m + n * latTan * (a2 / 2 + a4 / 24 * (5 - latTan2 + 9 * c + 4 * c ** 2) + a6 / 720 * (61 - 58 * latTan2 + latTan4 + 600 * c - 330 * $43272f1b2b7cca4e$var$E_P2)));
    if (!zone.north) northing += 10000000;
    return [
        easting,
        northing
    ];
}
/**
 * @param {number} zone The zone number.
 * @return {number} The central longitude in degrees.
 */ function $43272f1b2b7cca4e$var$zoneToCentralLongitude(zone) {
    return (zone - 1) * 6 - 180 + 3;
}
/**
 * @type {Array<RegExp>}
 */ const $43272f1b2b7cca4e$var$epsgRegExes = [
    /^EPSG:(\d+)$/,
    /^urn:ogc:def:crs:EPSG::(\d+)$/,
    /^http:\/\/www\.opengis\.net\/def\/crs\/EPSG\/0\/(\d+)$/
];
function $43272f1b2b7cca4e$export$bb54dc52a08ed170(code) {
    let epsgId = 0;
    for (const re of $43272f1b2b7cca4e$var$epsgRegExes){
        const match = code.match(re);
        if (match) {
            epsgId = parseInt(match[1]);
            break;
        }
    }
    if (!epsgId) return null;
    let number = 0;
    let north = false;
    if (epsgId > 32700 && epsgId < 32761) number = epsgId - 32700;
    else if (epsgId > 32600 && epsgId < 32661) {
        north = true;
        number = epsgId - 32600;
    }
    if (!number) return null;
    return {
        number: number,
        north: north
    };
}
/**
 * @param {function(number, number, UTMZone): import('../coordinate.js').Coordinate} transformer The transformer.
 * @param {UTMZone} zone The UTM zone.
 * @return {import('../proj.js').TransformFunction} The transform function.
 */ function $43272f1b2b7cca4e$var$makeTransformFunction(transformer, zone) {
    return function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension > 1 ? dimension : 2;
        stride = stride ?? dimension;
        if (!output) {
            if (dimension > 2) output = input.slice();
            else output = new Array(length);
        }
        for(let i = 0; i < length; i += stride){
            const x = input[i];
            const y = input[i + 1];
            const coord = transformer(x, y, zone);
            output[i] = coord[0];
            output[i + 1] = coord[1];
        }
        return output;
    };
}
function $43272f1b2b7cca4e$export$3277980d225b59be(code) {
    const zone = $43272f1b2b7cca4e$export$bb54dc52a08ed170(code);
    if (!zone) return null;
    return new (0, $8fe6435c5dc78f3e$export$2e2bcd8739ae039)({
        code: code,
        units: 'm'
    });
}
function $43272f1b2b7cca4e$export$f94509e55523febf(projection) {
    const zone = $43272f1b2b7cca4e$export$bb54dc52a08ed170(projection.getCode());
    if (!zone) return null;
    return {
        forward: $43272f1b2b7cca4e$var$makeTransformFunction($43272f1b2b7cca4e$var$fromLonLat, zone),
        inverse: $43272f1b2b7cca4e$var$makeTransformFunction($43272f1b2b7cca4e$var$toLonLat, zone)
    };
}


/**
 * @module ol/sphere
 */ 
const $0e7893c26680b018$export$63f2df7bd7371262 = 6371008.8;
function $0e7893c26680b018$export$79376507b09a66f(c1, c2, radius) {
    radius = radius || $0e7893c26680b018$export$63f2df7bd7371262;
    const lat1 = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(c1[1]);
    const lat2 = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(c2[1]);
    const deltaLatBy2 = (lat2 - lat1) / 2;
    const deltaLonBy2 = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(c2[0] - c1[0]) / 2;
    const a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) + Math.sin(deltaLonBy2) * Math.sin(deltaLonBy2) * Math.cos(lat1) * Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */ function $0e7893c26680b018$var$getLengthInternal(coordinates, radius) {
    let length = 0;
    for(let i = 0, ii = coordinates.length; i < ii - 1; ++i)length += $0e7893c26680b018$export$79376507b09a66f(coordinates[i], coordinates[i + 1], radius);
    return length;
}
function $0e7893c26680b018$export$f0d11c074a923179(geometry, options) {
    options = options || {};
    const radius = options.radius || $0e7893c26680b018$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let length = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
            break;
        case 'LineString':
        case 'LinearRing':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            length = $0e7893c26680b018$var$getLengthInternal(coordinates, radius);
            break;
        case 'MultiLineString':
        case 'Polygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i)length += $0e7893c26680b018$var$getLengthInternal(coordinates[i], radius);
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                for(j = 0, jj = coords.length; j < jj; ++j)length += $0e7893c26680b018$var$getLengthInternal(coords[j], radius);
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)length += $0e7893c26680b018$export$f0d11c074a923179(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */ function $0e7893c26680b018$var$getAreaInternal(coordinates, radius) {
    let area = 0;
    const len = coordinates.length;
    let x1 = coordinates[len - 1][0];
    let y1 = coordinates[len - 1][1];
    for(let i = 0; i < len; i++){
        const x2 = coordinates[i][0];
        const y2 = coordinates[i][1];
        area += (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(x2 - x1) * (2 + Math.sin((0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(y1)) + Math.sin((0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(y2)));
        x1 = x2;
        y1 = y2;
    }
    return area * radius * radius / 2.0;
}
function $0e7893c26680b018$export$520c40045967cb15(geometry, options) {
    options = options || {};
    const radius = options.radius || $0e7893c26680b018$export$63f2df7bd7371262;
    const projection = options.projection || 'EPSG:3857';
    const type = geometry.getType();
    if (type !== 'GeometryCollection') geometry = geometry.clone().transform(projection, 'EPSG:4326');
    let area = 0;
    let coordinates, coords, i, ii, j, jj;
    switch(type){
        case 'Point':
        case 'MultiPoint':
        case 'LineString':
        case 'MultiLineString':
        case 'LinearRing':
            break;
        case 'Polygon':
            coordinates = /** @type {import("./geom/Polygon.js").default} */ geometry.getCoordinates();
            area = Math.abs($0e7893c26680b018$var$getAreaInternal(coordinates[0], radius));
            for(i = 1, ii = coordinates.length; i < ii; ++i)area -= Math.abs($0e7893c26680b018$var$getAreaInternal(coordinates[i], radius));
            break;
        case 'MultiPolygon':
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ geometry.getCoordinates();
            for(i = 0, ii = coordinates.length; i < ii; ++i){
                coords = coordinates[i];
                area += Math.abs($0e7893c26680b018$var$getAreaInternal(coords[0], radius));
                for(j = 1, jj = coords.length; j < jj; ++j)area -= Math.abs($0e7893c26680b018$var$getAreaInternal(coords[j], radius));
            }
            break;
        case 'GeometryCollection':
            {
                const geometries = /** @type {import("./geom/GeometryCollection.js").default} */ geometry.getGeometries();
                for(i = 0, ii = geometries.length; i < ii; ++i)area += $0e7893c26680b018$export$520c40045967cb15(geometries[i], options);
                break;
            }
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return area;
}
function $0e7893c26680b018$export$cc800923e997bb8(c1, distance, bearing, radius) {
    radius = radius || $0e7893c26680b018$export$63f2df7bd7371262;
    const lat1 = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(c1[1]);
    const lon1 = (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(c1[0]);
    const dByR = distance / radius;
    const lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) + Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    const lon = lon1 + Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [
        (0, $d4e56cfc37d8b1f9$export$56cb859c01fa134d)(lon),
        (0, $d4e56cfc37d8b1f9$export$56cb859c01fa134d)(lat)
    ];
}


/**
 * A projection as {@link module:ol/proj/Projection~Projection}, SRS identifier
 * string or undefined.
 * @typedef {Projection|string|undefined} ProjectionLike
 * @api
 */ /**
 * @typedef {Object} Transforms
 * @property {TransformFunction} forward The forward transform (from geographic).
 * @property {TransformFunction} inverse The inverse transform (to geographic).
 */ /**
 * @type {Array<function(Projection): Transforms|null>}
 */ const $92f1443438429e81$var$transformFactories = [
    (0, $43272f1b2b7cca4e$export$f94509e55523febf)
];
/**
 * @type {Array<function(string): Projection|null>}
 */ const $92f1443438429e81$var$projectionFactories = [
    (0, $43272f1b2b7cca4e$export$3277980d225b59be)
];
let $92f1443438429e81$var$showCoordinateWarning = true;
function $92f1443438429e81$export$ed949affbc7c4223(disable) {
    const hide = disable === undefined ? true : disable;
    $92f1443438429e81$var$showCoordinateWarning = !hide;
}
function $92f1443438429e81$export$dd516654c5f598fb(input, output) {
    if (output !== undefined) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        output;
    } else output = input.slice();
    return output;
}
function $92f1443438429e81$export$83e8ab53904f8022(input, output) {
    if (output !== undefined && input !== output) {
        for(let i = 0, ii = input.length; i < ii; ++i)output[i] = input[i];
        input = output;
    }
    return input;
}
function $92f1443438429e81$export$59ae956cd3e343f7(projection) {
    (0, $1c99841673e46c67$export$e16d8520af44a096)(projection.getCode(), projection);
    (0, $5311269cd01b387a$export$e16d8520af44a096)(projection, projection, $92f1443438429e81$export$dd516654c5f598fb);
}
function $92f1443438429e81$export$638ad73f7aafb913(projections) {
    projections.forEach($92f1443438429e81$export$59ae956cd3e343f7);
}
function $92f1443438429e81$export$3988ae62b71be9a3(projectionLike) {
    if (!(typeof projectionLike === 'string')) return projectionLike;
    const projection = (0, $1c99841673e46c67$export$3988ae62b71be9a3)(projectionLike);
    if (projection) return projection;
    for (const makeProjection of $92f1443438429e81$var$projectionFactories){
        const projection = makeProjection(projectionLike);
        if (projection) return projection;
    }
    return null;
}
function $92f1443438429e81$export$2d8f7b4eec383d44(projection, resolution, point, units) {
    projection = $92f1443438429e81$export$3988ae62b71be9a3(projection);
    let pointResolution;
    const getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (units && units !== projection.getUnits()) {
            const metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) pointResolution = pointResolution * metersPerUnit / (0, $fb72d58bc9104528$export$1482081eec883108)[units];
        }
    } else {
        const projUnits = projection.getUnits();
        if (projUnits == 'degrees' && !units || units == 'degrees') pointResolution = resolution;
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            const toEPSG4326 = $92f1443438429e81$export$e3c4995a701c26a3(projection, $92f1443438429e81$export$3988ae62b71be9a3('EPSG:4326'));
            if (!toEPSG4326 && projUnits !== 'degrees') // no transform is available
            pointResolution = resolution * projection.getMetersPerUnit();
            else {
                let vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2
                ];
                vertices = toEPSG4326(vertices, vertices, 2);
                const width = (0, $0e7893c26680b018$export$79376507b09a66f)(vertices.slice(0, 2), vertices.slice(2, 4));
                const height = (0, $0e7893c26680b018$export$79376507b09a66f)(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            const metersPerUnit = units ? (0, $fb72d58bc9104528$export$1482081eec883108)[units] : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) pointResolution /= metersPerUnit;
        }
    }
    return pointResolution;
}
function $92f1443438429e81$export$eeb8392580a05a37(projections) {
    $92f1443438429e81$export$638ad73f7aafb913(projections);
    projections.forEach(function(source) {
        projections.forEach(function(destination) {
            if (source !== destination) (0, $5311269cd01b387a$export$e16d8520af44a096)(source, destination, $92f1443438429e81$export$dd516654c5f598fb);
        });
    });
}
function $92f1443438429e81$export$4856f21c2f184f24(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function(projection1) {
        projections2.forEach(function(projection2) {
            (0, $5311269cd01b387a$export$e16d8520af44a096)(projection1, projection2, forwardTransform);
            (0, $5311269cd01b387a$export$e16d8520af44a096)(projection2, projection1, inverseTransform);
        });
    });
}
function $92f1443438429e81$export$4860237d10380594() {
    (0, $1c99841673e46c67$export$42ffd38884aecdac)();
    (0, $5311269cd01b387a$export$42ffd38884aecdac)();
}
function $92f1443438429e81$export$549167224996a0fb(projection, defaultCode) {
    if (!projection) return $92f1443438429e81$export$3988ae62b71be9a3(defaultCode);
    if (typeof projection === 'string') return $92f1443438429e81$export$3988ae62b71be9a3(projection);
    return /** @type {Projection} */ projection;
}
function $92f1443438429e81$export$6b4aafd331159e0d(coordTransform) {
    return(/**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [output] Output.
     * @param {number} [dimension] Dimensions that should be transformed.
     * @param {number} [stride] Stride.
     * @return {Array<number>} Output.
     */ function(input, output, dimension, stride) {
        const length = input.length;
        dimension = dimension !== undefined ? dimension : 2;
        stride = stride ?? dimension;
        output = output !== undefined ? output : new Array(length);
        for(let i = 0; i < length; i += stride){
            const point = coordTransform(input.slice(i, i + dimension));
            const pointLength = point.length;
            for(let j = 0, jj = stride; j < jj; ++j)output[i + j] = j >= pointLength ? input[i + j] : point[j];
        }
        return output;
    });
}
function $92f1443438429e81$export$6b1c2e6623f4f49d(source, destination, forward, inverse) {
    const sourceProj = $92f1443438429e81$export$3988ae62b71be9a3(source);
    const destProj = $92f1443438429e81$export$3988ae62b71be9a3(destination);
    (0, $5311269cd01b387a$export$e16d8520af44a096)(sourceProj, destProj, $92f1443438429e81$export$6b4aafd331159e0d(forward));
    (0, $5311269cd01b387a$export$e16d8520af44a096)(destProj, sourceProj, $92f1443438429e81$export$6b4aafd331159e0d(inverse));
}
function $92f1443438429e81$export$b15d9668511529b9(coordinate, projection) {
    $92f1443438429e81$export$ed949affbc7c4223();
    return $92f1443438429e81$export$51186ad6e864892a(coordinate, 'EPSG:4326', projection !== undefined ? projection : 'EPSG:3857');
}
function $92f1443438429e81$export$3fb495868742d370(coordinate, projection) {
    const lonLat = $92f1443438429e81$export$51186ad6e864892a(coordinate, projection !== undefined ? projection : 'EPSG:3857', 'EPSG:4326');
    const lon = lonLat[0];
    if (lon < -180 || lon > 180) lonLat[0] = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(lon + 180, 360) - 180;
    return lonLat;
}
function $92f1443438429e81$export$fe091d73a555748b(projection1, projection2) {
    if (projection1 === projection2) return true;
    const equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) return equalUnits;
    const transformFunc = $92f1443438429e81$export$e3c4995a701c26a3(projection1, projection2);
    return transformFunc === $92f1443438429e81$export$dd516654c5f598fb && equalUnits;
}
function $92f1443438429e81$export$e3c4995a701c26a3(source, destination) {
    const sourceCode = source.getCode();
    const destinationCode = destination.getCode();
    let transformFunc = (0, $5311269cd01b387a$export$3988ae62b71be9a3)(sourceCode, destinationCode);
    if (transformFunc) return transformFunc;
    /**
   * @type {Transforms|null}
   */ let sourceTransforms = null;
    /**
   * @type {Transforms|null}
   */ let destinationTransforms = null;
    // lazily add projections if we have supported transforms
    for (const makeTransforms of $92f1443438429e81$var$transformFactories){
        if (!sourceTransforms) sourceTransforms = makeTransforms(source);
        if (!destinationTransforms) destinationTransforms = makeTransforms(destination);
    }
    if (!sourceTransforms && !destinationTransforms) return null;
    const intermediateCode = 'EPSG:4326';
    if (!destinationTransforms) {
        const toDestination = (0, $5311269cd01b387a$export$3988ae62b71be9a3)(intermediateCode, destinationCode);
        if (toDestination) transformFunc = $92f1443438429e81$var$composeTransformFuncs(sourceTransforms.inverse, toDestination);
    } else if (!sourceTransforms) {
        const fromSource = (0, $5311269cd01b387a$export$3988ae62b71be9a3)(sourceCode, intermediateCode);
        if (fromSource) transformFunc = $92f1443438429e81$var$composeTransformFuncs(fromSource, destinationTransforms.forward);
    } else transformFunc = $92f1443438429e81$var$composeTransformFuncs(sourceTransforms.inverse, destinationTransforms.forward);
    if (transformFunc) {
        $92f1443438429e81$export$59ae956cd3e343f7(source);
        $92f1443438429e81$export$59ae956cd3e343f7(destination);
        (0, $5311269cd01b387a$export$e16d8520af44a096)(source, destination, transformFunc);
    }
    return transformFunc;
}
/**
 * @param {TransformFunction} t1 The first transform function.
 * @param {TransformFunction} t2 The second transform function.
 * @return {TransformFunction} The composed transform function.
 */ function $92f1443438429e81$var$composeTransformFuncs(t1, t2) {
    return function(input, output, dimensions, stride) {
        output = t1(input, output, dimensions, stride);
        return t2(output, output, dimensions, stride);
    };
}
function $92f1443438429e81$export$fce0c6cfca85ed96(source, destination) {
    const sourceProjection = $92f1443438429e81$export$3988ae62b71be9a3(source);
    const destinationProjection = $92f1443438429e81$export$3988ae62b71be9a3(destination);
    return $92f1443438429e81$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
}
function $92f1443438429e81$export$51186ad6e864892a(coordinate, source, destination) {
    const transformFunc = $92f1443438429e81$export$fce0c6cfca85ed96(source, destination);
    if (!transformFunc) {
        const sourceCode = $92f1443438429e81$export$3988ae62b71be9a3(source).getCode();
        const destinationCode = $92f1443438429e81$export$3988ae62b71be9a3(destination).getCode();
        throw new Error(`No transform available between ${sourceCode} and ${destinationCode}`);
    }
    return transformFunc(coordinate, undefined, coordinate.length);
}
function $92f1443438429e81$export$751c68e0e0efff79(extent, source, destination, stops) {
    const transformFunc = $92f1443438429e81$export$fce0c6cfca85ed96(source, destination);
    return (0, $7e819822b33b3d32$export$9f9dcb98c894b623)(extent, transformFunc, undefined, stops);
}
function $92f1443438429e81$export$affbde93b1db73f8(point, sourceProjection, destinationProjection) {
    const transformFunc = $92f1443438429e81$export$e3c4995a701c26a3(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {Projection|null}
 */ let $92f1443438429e81$var$userProjection = null;
function $92f1443438429e81$export$d0aeadbeac54116e(projection) {
    $92f1443438429e81$var$userProjection = $92f1443438429e81$export$3988ae62b71be9a3(projection);
}
function $92f1443438429e81$export$1ae11279759d4e8f() {
    $92f1443438429e81$var$userProjection = null;
}
function $92f1443438429e81$export$3973b77d5f6f2790() {
    return $92f1443438429e81$var$userProjection;
}
function $92f1443438429e81$export$aa7494edfbe36197() {
    $92f1443438429e81$export$d0aeadbeac54116e('EPSG:4326');
}
function $92f1443438429e81$export$698f563af1ba02a5(coordinate, sourceProjection) {
    if (!$92f1443438429e81$var$userProjection) return coordinate;
    return $92f1443438429e81$export$51186ad6e864892a(coordinate, sourceProjection, $92f1443438429e81$var$userProjection);
}
function $92f1443438429e81$export$d4b8ec0b96db1ee2(coordinate, destProjection) {
    if (!$92f1443438429e81$var$userProjection) {
        if ($92f1443438429e81$var$showCoordinateWarning && !(0, $8b28786758450fff$export$e9bab7fafb253603)(coordinate, [
            0,
            0
        ]) && coordinate[0] >= -180 && coordinate[0] <= 180 && coordinate[1] >= -90 && coordinate[1] <= 90) {
            $92f1443438429e81$var$showCoordinateWarning = false;
            (0, $7ebf1be11d834723$export$c106dd0671a0fc2d)('Call useGeographic() from ol/proj once to work with [longitude, latitude] coordinates.');
        }
        return coordinate;
    }
    return $92f1443438429e81$export$51186ad6e864892a(coordinate, $92f1443438429e81$var$userProjection, destProjection);
}
function $92f1443438429e81$export$96bfd09e2cffb006(extent, sourceProjection) {
    if (!$92f1443438429e81$var$userProjection) return extent;
    return $92f1443438429e81$export$751c68e0e0efff79(extent, sourceProjection, $92f1443438429e81$var$userProjection);
}
function $92f1443438429e81$export$494be3a3a25689ca(extent, destProjection) {
    if (!$92f1443438429e81$var$userProjection) return extent;
    return $92f1443438429e81$export$751c68e0e0efff79(extent, $92f1443438429e81$var$userProjection, destProjection);
}
function $92f1443438429e81$export$b56bb8ad8b3a00e9(resolution, sourceProjection) {
    if (!$92f1443438429e81$var$userProjection) return resolution;
    const sourceMetersPerUnit = $92f1443438429e81$export$3988ae62b71be9a3(sourceProjection).getMetersPerUnit();
    const userMetersPerUnit = $92f1443438429e81$var$userProjection.getMetersPerUnit();
    return sourceMetersPerUnit && userMetersPerUnit ? resolution * sourceMetersPerUnit / userMetersPerUnit : resolution;
}
function $92f1443438429e81$export$bd1cd3b88140b906(resolution, destProjection) {
    if (!$92f1443438429e81$var$userProjection) return resolution;
    const destMetersPerUnit = $92f1443438429e81$export$3988ae62b71be9a3(destProjection).getMetersPerUnit();
    const userMetersPerUnit = $92f1443438429e81$var$userProjection.getMetersPerUnit();
    return destMetersPerUnit && userMetersPerUnit ? resolution * userMetersPerUnit / destMetersPerUnit : resolution;
}
function $92f1443438429e81$export$1873f9cfeb8bd1d6(sourceProj, destProj, transform) {
    return function(coord) {
        let transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            const sourceExtent = sourceProj.getExtent();
            const sourceExtentWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(sourceExtent);
            coord = coord.slice(0);
            worldsAway = (0, $8b28786758450fff$export$24e2b27d1ff0c1d5)(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) // Move x to the real world
            coord[0] = coord[0] - worldsAway * sourceExtentWidth;
            coord[0] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(coord[0], sourceExtent[0], sourceExtent[2]);
            coord[1] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(coord[1], sourceExtent[1], sourceExtent[3]);
            transformed = transform(coord);
        } else transformed = transform(coord);
        if (worldsAway && destProj.canWrapX()) // Move transformed coordinate back to the offset world
        transformed[0] += worldsAway * (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(destProj.getExtent());
        return transformed;
    };
}
function $92f1443438429e81$export$86eed449eb2dcac4() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    $92f1443438429e81$export$eeb8392580a05a37((0, $830637c92019e485$export$b508d7ad9a891c1b));
    $92f1443438429e81$export$eeb8392580a05a37((0, $4cc5940fd2dc7816$export$b508d7ad9a891c1b));
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    $92f1443438429e81$export$4856f21c2f184f24((0, $4cc5940fd2dc7816$export$b508d7ad9a891c1b), (0, $830637c92019e485$export$b508d7ad9a891c1b), (0, $830637c92019e485$export$1ff8bb36c0983070), (0, $830637c92019e485$export$8c71322ec28ed6b4));
}
$92f1443438429e81$export$86eed449eb2dcac4();


/**
 * @module ol/transform
 */ /**
 * @module ol/asserts
 */ /**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {string} errorMessage Error message.
 */ function $b6052fc13e9a3991$export$a7a9523472993e97(assertion, errorMessage) {
    if (!assertion) throw new Error(errorMessage);
}


/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */ /**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */ /**
 * @private
 * @type {Transform}
 */ const $2567d97ab31c5663$var$tmp_ = new Array(6);
function $2567d97ab31c5663$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $2567d97ab31c5663$export$aad8462122ac592b(transform) {
    return $2567d97ab31c5663$export$adaa4cf7ef1b65be(transform, 1, 0, 0, 1, 0, 0);
}
function $2567d97ab31c5663$export$2060d2db72cce88f(transform1, transform2) {
    const a1 = transform1[0];
    const b1 = transform1[1];
    const c1 = transform1[2];
    const d1 = transform1[3];
    const e1 = transform1[4];
    const f1 = transform1[5];
    const a2 = transform2[0];
    const b2 = transform2[1];
    const c2 = transform2[2];
    const d2 = transform2[3];
    const e2 = transform2[4];
    const f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
function $2567d97ab31c5663$export$adaa4cf7ef1b65be(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
function $2567d97ab31c5663$export$42b4187a82d80ed0(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
function $2567d97ab31c5663$export$5635d7ef4b8fee1c(transform, coordinate) {
    const x = coordinate[0];
    const y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
function $2567d97ab31c5663$export$bb628a54ab399bc9(transform, angle) {
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    return $2567d97ab31c5663$export$2060d2db72cce88f(transform, $2567d97ab31c5663$export$adaa4cf7ef1b65be($2567d97ab31c5663$var$tmp_, cos, sin, -sin, cos, 0, 0));
}
function $2567d97ab31c5663$export$dcdf75081b88279d(transform, x, y) {
    return $2567d97ab31c5663$export$2060d2db72cce88f(transform, $2567d97ab31c5663$export$adaa4cf7ef1b65be($2567d97ab31c5663$var$tmp_, x, 0, 0, y, 0, 0));
}
function $2567d97ab31c5663$export$3e4e33ea14aeb531(target, x, y) {
    return $2567d97ab31c5663$export$adaa4cf7ef1b65be(target, x, 0, 0, y, 0, 0);
}
function $2567d97ab31c5663$export$d73ee8ef04f5226a(transform, dx, dy) {
    return $2567d97ab31c5663$export$2060d2db72cce88f(transform, $2567d97ab31c5663$export$adaa4cf7ef1b65be($2567d97ab31c5663$var$tmp_, 1, 0, 0, 1, dx, dy));
}
function $2567d97ab31c5663$export$f672e0b6f7222cd7(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
function $2567d97ab31c5663$export$12a96a1aaf5558e3(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return $2567d97ab31c5663$export$f84e8e69fd4488a5($2567d97ab31c5663$export$f672e0b6f7222cd7($2567d97ab31c5663$export$185802fd694ee1f5(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
function $2567d97ab31c5663$export$6897c284b6f9f4dc(source) {
    return $2567d97ab31c5663$export$bd70ea2a93c0fa4(source, source);
}
function $2567d97ab31c5663$export$bd70ea2a93c0fa4(target, source) {
    const det = $2567d97ab31c5663$export$a04698f914c55ed9(source);
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(det !== 0, 'Transformation matrix cannot be inverted');
    const a = source[0];
    const b = source[1];
    const c = source[2];
    const d = source[3];
    const e = source[4];
    const f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
function $2567d97ab31c5663$export$a04698f914c55ed9(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {Array}
 */ const $2567d97ab31c5663$var$matrixPrecision = [
    1e6,
    1e6,
    1e6,
    1e6,
    2,
    2
];
function $2567d97ab31c5663$export$f84e8e69fd4488a5(mat) {
    const transformString = 'matrix(' + mat.map((value, i)=>Math.round(value * $2567d97ab31c5663$var$matrixPrecision[i]) / $2567d97ab31c5663$var$matrixPrecision[i]).join(', ') + ')';
    return transformString;
}


/**
 * @module ol/renderer/canvas/Layer
 */ /**
 * @module ol/array
 */ /**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */ function $830d23b8323fc080$export$2e0ae67339d5f1ac(haystack, needle, comparator) {
    let mid, cmp;
    comparator = comparator || $830d23b8323fc080$export$fcb633242ef15540;
    let low = 0;
    let high = haystack.length;
    let found = false;
    while(low < high){
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */ mid = low + (high - low >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) /* Too low. */ low = mid + 1;
        else {
            /* Key found or too high */ high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */ return found ? low : ~low;
}
function $830d23b8323fc080$export$fcb633242ef15540(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
function $830d23b8323fc080$export$4fa3190a997c3d8f(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function $830d23b8323fc080$export$8a3786cc03fdb777(arr, target, direction) {
    if (arr[0] <= target) return 0;
    const n = arr.length;
    if (target <= arr[n - 1]) return n - 1;
    if (typeof direction === 'function') {
        for(let i = 1; i < n; ++i){
            const candidate = arr[i];
            if (candidate === target) return i;
            if (candidate < target) {
                if (direction(target, arr[i - 1], candidate) > 0) return i - 1;
                return i;
            }
        }
        return n - 1;
    }
    if (direction > 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] < target) return i - 1;
        }
        return n - 1;
    }
    if (direction < 0) {
        for(let i = 1; i < n; ++i){
            if (arr[i] <= target) return i;
        }
        return n - 1;
    }
    for(let i = 1; i < n; ++i){
        if (arr[i] == target) return i;
        if (arr[i] < target) {
            if (arr[i - 1] - target < target - arr[i]) return i - 1;
            return i;
        }
    }
    return n - 1;
}
function $830d23b8323fc080$export$292cfa960964f0e0(arr, begin, end) {
    while(begin < end){
        const tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
function $830d23b8323fc080$export$8b58be045bf06082(arr, data) {
    const extension = Array.isArray(data) ? data : [
        data
    ];
    const length = extension.length;
    for(let i = 0; i < length; i++)arr[arr.length] = extension[i];
}
function $830d23b8323fc080$export$cd7f480d6b8286c3(arr, obj) {
    const i = arr.indexOf(obj);
    const found = i > -1;
    if (found) arr.splice(i, 1);
    return found;
}
function $830d23b8323fc080$export$e9bab7fafb253603(arr1, arr2) {
    const len1 = arr1.length;
    if (len1 !== arr2.length) return false;
    for(let i = 0; i < len1; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $830d23b8323fc080$export$c7d3d1f96a700512(arr, compareFnc) {
    const length = arr.length;
    const tmp = Array(arr.length);
    let i;
    for(i = 0; i < length; i++)tmp[i] = {
        index: i,
        value: arr[i]
    };
    tmp.sort(function(a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for(i = 0; i < arr.length; i++)arr[i] = tmp[i].value;
}
function $830d23b8323fc080$export$efa610630f9e181(arr, func, strict) {
    const compare = func || $830d23b8323fc080$export$fcb633242ef15540;
    return arr.every(function(currentVal, index) {
        if (index === 0) return true;
        const res = compare(arr[index - 1], currentVal);
        return !(res > 0 || strict && res === 0);
    });
}


/**
 * @module ol/color
 */ /** @module  color-rgba */ /**
 * @module color-parse
 */ var $c1456cdea41b9f89$export$2e2bcd8739ae039 = {
    aliceblue: [
        240,
        248,
        255
    ],
    antiquewhite: [
        250,
        235,
        215
    ],
    aqua: [
        0,
        255,
        255
    ],
    aquamarine: [
        127,
        255,
        212
    ],
    azure: [
        240,
        255,
        255
    ],
    beige: [
        245,
        245,
        220
    ],
    bisque: [
        255,
        228,
        196
    ],
    black: [
        0,
        0,
        0
    ],
    blanchedalmond: [
        255,
        235,
        205
    ],
    blue: [
        0,
        0,
        255
    ],
    blueviolet: [
        138,
        43,
        226
    ],
    brown: [
        165,
        42,
        42
    ],
    burlywood: [
        222,
        184,
        135
    ],
    cadetblue: [
        95,
        158,
        160
    ],
    chartreuse: [
        127,
        255,
        0
    ],
    chocolate: [
        210,
        105,
        30
    ],
    coral: [
        255,
        127,
        80
    ],
    cornflowerblue: [
        100,
        149,
        237
    ],
    cornsilk: [
        255,
        248,
        220
    ],
    crimson: [
        220,
        20,
        60
    ],
    cyan: [
        0,
        255,
        255
    ],
    darkblue: [
        0,
        0,
        139
    ],
    darkcyan: [
        0,
        139,
        139
    ],
    darkgoldenrod: [
        184,
        134,
        11
    ],
    darkgray: [
        169,
        169,
        169
    ],
    darkgreen: [
        0,
        100,
        0
    ],
    darkgrey: [
        169,
        169,
        169
    ],
    darkkhaki: [
        189,
        183,
        107
    ],
    darkmagenta: [
        139,
        0,
        139
    ],
    darkolivegreen: [
        85,
        107,
        47
    ],
    darkorange: [
        255,
        140,
        0
    ],
    darkorchid: [
        153,
        50,
        204
    ],
    darkred: [
        139,
        0,
        0
    ],
    darksalmon: [
        233,
        150,
        122
    ],
    darkseagreen: [
        143,
        188,
        143
    ],
    darkslateblue: [
        72,
        61,
        139
    ],
    darkslategray: [
        47,
        79,
        79
    ],
    darkslategrey: [
        47,
        79,
        79
    ],
    darkturquoise: [
        0,
        206,
        209
    ],
    darkviolet: [
        148,
        0,
        211
    ],
    deeppink: [
        255,
        20,
        147
    ],
    deepskyblue: [
        0,
        191,
        255
    ],
    dimgray: [
        105,
        105,
        105
    ],
    dimgrey: [
        105,
        105,
        105
    ],
    dodgerblue: [
        30,
        144,
        255
    ],
    firebrick: [
        178,
        34,
        34
    ],
    floralwhite: [
        255,
        250,
        240
    ],
    forestgreen: [
        34,
        139,
        34
    ],
    fuchsia: [
        255,
        0,
        255
    ],
    gainsboro: [
        220,
        220,
        220
    ],
    ghostwhite: [
        248,
        248,
        255
    ],
    gold: [
        255,
        215,
        0
    ],
    goldenrod: [
        218,
        165,
        32
    ],
    gray: [
        128,
        128,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    greenyellow: [
        173,
        255,
        47
    ],
    grey: [
        128,
        128,
        128
    ],
    honeydew: [
        240,
        255,
        240
    ],
    hotpink: [
        255,
        105,
        180
    ],
    indianred: [
        205,
        92,
        92
    ],
    indigo: [
        75,
        0,
        130
    ],
    ivory: [
        255,
        255,
        240
    ],
    khaki: [
        240,
        230,
        140
    ],
    lavender: [
        230,
        230,
        250
    ],
    lavenderblush: [
        255,
        240,
        245
    ],
    lawngreen: [
        124,
        252,
        0
    ],
    lemonchiffon: [
        255,
        250,
        205
    ],
    lightblue: [
        173,
        216,
        230
    ],
    lightcoral: [
        240,
        128,
        128
    ],
    lightcyan: [
        224,
        255,
        255
    ],
    lightgoldenrodyellow: [
        250,
        250,
        210
    ],
    lightgray: [
        211,
        211,
        211
    ],
    lightgreen: [
        144,
        238,
        144
    ],
    lightgrey: [
        211,
        211,
        211
    ],
    lightpink: [
        255,
        182,
        193
    ],
    lightsalmon: [
        255,
        160,
        122
    ],
    lightseagreen: [
        32,
        178,
        170
    ],
    lightskyblue: [
        135,
        206,
        250
    ],
    lightslategray: [
        119,
        136,
        153
    ],
    lightslategrey: [
        119,
        136,
        153
    ],
    lightsteelblue: [
        176,
        196,
        222
    ],
    lightyellow: [
        255,
        255,
        224
    ],
    lime: [
        0,
        255,
        0
    ],
    limegreen: [
        50,
        205,
        50
    ],
    linen: [
        250,
        240,
        230
    ],
    magenta: [
        255,
        0,
        255
    ],
    maroon: [
        128,
        0,
        0
    ],
    mediumaquamarine: [
        102,
        205,
        170
    ],
    mediumblue: [
        0,
        0,
        205
    ],
    mediumorchid: [
        186,
        85,
        211
    ],
    mediumpurple: [
        147,
        112,
        219
    ],
    mediumseagreen: [
        60,
        179,
        113
    ],
    mediumslateblue: [
        123,
        104,
        238
    ],
    mediumspringgreen: [
        0,
        250,
        154
    ],
    mediumturquoise: [
        72,
        209,
        204
    ],
    mediumvioletred: [
        199,
        21,
        133
    ],
    midnightblue: [
        25,
        25,
        112
    ],
    mintcream: [
        245,
        255,
        250
    ],
    mistyrose: [
        255,
        228,
        225
    ],
    moccasin: [
        255,
        228,
        181
    ],
    navajowhite: [
        255,
        222,
        173
    ],
    navy: [
        0,
        0,
        128
    ],
    oldlace: [
        253,
        245,
        230
    ],
    olive: [
        128,
        128,
        0
    ],
    olivedrab: [
        107,
        142,
        35
    ],
    orange: [
        255,
        165,
        0
    ],
    orangered: [
        255,
        69,
        0
    ],
    orchid: [
        218,
        112,
        214
    ],
    palegoldenrod: [
        238,
        232,
        170
    ],
    palegreen: [
        152,
        251,
        152
    ],
    paleturquoise: [
        175,
        238,
        238
    ],
    palevioletred: [
        219,
        112,
        147
    ],
    papayawhip: [
        255,
        239,
        213
    ],
    peachpuff: [
        255,
        218,
        185
    ],
    peru: [
        205,
        133,
        63
    ],
    pink: [
        255,
        192,
        203
    ],
    plum: [
        221,
        160,
        221
    ],
    powderblue: [
        176,
        224,
        230
    ],
    purple: [
        128,
        0,
        128
    ],
    rebeccapurple: [
        102,
        51,
        153
    ],
    red: [
        255,
        0,
        0
    ],
    rosybrown: [
        188,
        143,
        143
    ],
    royalblue: [
        65,
        105,
        225
    ],
    saddlebrown: [
        139,
        69,
        19
    ],
    salmon: [
        250,
        128,
        114
    ],
    sandybrown: [
        244,
        164,
        96
    ],
    seagreen: [
        46,
        139,
        87
    ],
    seashell: [
        255,
        245,
        238
    ],
    sienna: [
        160,
        82,
        45
    ],
    silver: [
        192,
        192,
        192
    ],
    skyblue: [
        135,
        206,
        235
    ],
    slateblue: [
        106,
        90,
        205
    ],
    slategray: [
        112,
        128,
        144
    ],
    slategrey: [
        112,
        128,
        144
    ],
    snow: [
        255,
        250,
        250
    ],
    springgreen: [
        0,
        255,
        127
    ],
    steelblue: [
        70,
        130,
        180
    ],
    tan: [
        210,
        180,
        140
    ],
    teal: [
        0,
        128,
        128
    ],
    thistle: [
        216,
        191,
        216
    ],
    tomato: [
        255,
        99,
        71
    ],
    turquoise: [
        64,
        224,
        208
    ],
    violet: [
        238,
        130,
        238
    ],
    wheat: [
        245,
        222,
        179
    ],
    white: [
        255,
        255,
        255
    ],
    whitesmoke: [
        245,
        245,
        245
    ],
    yellow: [
        255,
        255,
        0
    ],
    yellowgreen: [
        154,
        205,
        50
    ]
};


var $7709f00c9a7c855e$export$2e2bcd8739ae039 = $7709f00c9a7c855e$var$parse;
/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */ //FIXME: use external hue detector
var $7709f00c9a7c855e$var$baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */ function $7709f00c9a7c855e$var$parse(cstr) {
    var m, parts = [], alpha = 1, space;
    //numeric case
    if (typeof cstr === 'number') return {
        space: 'rgb',
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    if (typeof cstr === 'number') return {
        space: 'rgb',
        values: [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ],
        alpha: 1
    };
    cstr = String(cstr).toLowerCase();
    //keyword
    if ((0, $c1456cdea41b9f89$export$2e2bcd8739ae039)[cstr]) {
        parts = (0, $c1456cdea41b9f89$export$2e2bcd8739ae039)[cstr].slice();
        space = 'rgb';
    } else if (cstr === 'transparent') {
        alpha = 0;
        space = 'rgb';
        parts = [
            0,
            0,
            0
        ];
    } else if (cstr[0] === '#') {
        var base = cstr.slice(1);
        var size = base.length;
        var isShort = size <= 4;
        alpha = 1;
        if (isShort) {
            parts = [
                parseInt(base[0] + base[0], 16),
                parseInt(base[1] + base[1], 16),
                parseInt(base[2] + base[2], 16)
            ];
            if (size === 4) alpha = parseInt(base[3] + base[3], 16) / 255;
        } else {
            parts = [
                parseInt(base[0] + base[1], 16),
                parseInt(base[2] + base[3], 16),
                parseInt(base[4] + base[5], 16)
            ];
            if (size === 8) alpha = parseInt(base[6] + base[7], 16) / 255;
        }
        if (!parts[0]) parts[0] = 0;
        if (!parts[1]) parts[1] = 0;
        if (!parts[2]) parts[2] = 0;
        space = 'rgb';
    } else if (m = /^((?:rgba?|hs[lvb]a?|hwba?|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms|oklch|oklab|color))\s*\(([^\)]*)\)/.exec(cstr)) {
        var name = m[1];
        space = name.replace(/a$/, '');
        var dims = space === 'cmyk' ? 4 : space === 'gray' ? 1 : 3;
        parts = m[2].trim().split(/\s*[,\/]\s*|\s+/);
        // color(srgb-linear x x x) -> srgb-linear(x x x)
        if (space === 'color') space = parts.shift();
        parts = parts.map(function(x, i) {
            //<percentage>
            if (x[x.length - 1] === '%') {
                x = parseFloat(x) / 100;
                // alpha -> 0..1
                if (i === 3) return x;
                // rgb -> 0..255
                if (space === 'rgb') return x * 255;
                // hsl, hwb H -> 0..100
                if (space[0] === 'h') return x * 100;
                // lch, lab L -> 0..100
                if (space[0] === 'l' && !i) return x * 100;
                // lab A B -> -125..125
                if (space === 'lab') return x * 125;
                // lch C -> 0..150, H -> 0..360
                if (space === 'lch') return i < 2 ? x * 150 : x * 360;
                // oklch/oklab L -> 0..1
                if (space[0] === 'o' && !i) return x;
                // oklab A B -> -0.4..0.4
                if (space === 'oklab') return x * 0.4;
                // oklch C -> 0..0.4, H -> 0..360
                if (space === 'oklch') return i < 2 ? x * 0.4 : x * 360;
                // color(xxx) -> 0..1
                return x;
            }
            //hue
            if (space[i] === 'h' || i === 2 && space[space.length - 1] === 'h') {
                //<base-hue>
                if ($7709f00c9a7c855e$var$baseHues[x] !== undefined) return $7709f00c9a7c855e$var$baseHues[x];
                //<deg>
                if (x.endsWith('deg')) return parseFloat(x);
                //<turn>
                if (x.endsWith('turn')) return parseFloat(x) * 360;
                if (x.endsWith('grad')) return parseFloat(x) * 360 / 400;
                if (x.endsWith('rad')) return parseFloat(x) * 180 / Math.PI;
            }
            if (x === 'none') return 0;
            return parseFloat(x);
        });
        alpha = parts.length > dims ? parts.pop() : 1;
    } else if (/[0-9](?:\s|\/|,)/.test(cstr)) {
        parts = cstr.match(/([0-9]+)/g).map(function(value) {
            return parseFloat(value);
        });
        space = cstr.match(/([a-z])/ig)?.join('')?.toLowerCase() || 'rgb';
    }
    return {
        space: space,
        values: parts,
        alpha: alpha
    };
}


/**
 * RGB space.
 *
 * @module  color-space/rgb
 */ var $89d549ff8cdff9bb$export$2e2bcd8739ae039 = {
    name: 'rgb',
    min: [
        0,
        0,
        0
    ],
    max: [
        255,
        255,
        255
    ],
    channel: [
        'red',
        'green',
        'blue'
    ],
    alias: [
        'RGB'
    ]
};


/**
 * @module color-space/hsl
 */ 
var $6afc2297d0ae935a$export$2e2bcd8739ae039 = {
    name: 'hsl',
    min: [
        0,
        0,
        0
    ],
    max: [
        360,
        100,
        100
    ],
    channel: [
        'hue',
        'saturation',
        'lightness'
    ],
    alias: [
        'HSL'
    ],
    rgb: function(hsl) {
        var h = hsl[0] / 360, s = hsl[1] / 100, l = hsl[2] / 100, t1, t2, t3, rgb, val, i = 0;
        if (s === 0) return val = l * 255, [
            val,
            val,
            val
        ];
        t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
        t1 = 2 * l - t2;
        rgb = [
            0,
            0,
            0
        ];
        for(; i < 3;){
            t3 = h + 1 / 3 * -(i - 1);
            t3 < 0 ? t3++ : t3 > 1 && t3--;
            val = 6 * t3 < 1 ? t1 + (t2 - t1) * 6 * t3 : 2 * t3 < 1 ? t2 : 3 * t3 < 2 ? t1 + (t2 - t1) * (2 / 3 - t3) * 6 : t1;
            rgb[i++] = val * 255;
        }
        return rgb;
    }
};
//extend rgb
(0, $89d549ff8cdff9bb$export$2e2bcd8739ae039).hsl = function(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), delta = max - min, h, s, l;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};


function $04627eea939c61f7$export$2e2bcd8739ae039(color) {
    // template literals
    if (Array.isArray(color) && color.raw) color = String.raw(...arguments);
    if (color instanceof Number) color = +color;
    var values, i, l;
    //attempt to parse non-array arguments
    var parsed = (0, $7709f00c9a7c855e$export$2e2bcd8739ae039)(color);
    if (!parsed.space) return [];
    const min = parsed.space[0] === 'h' ? (0, $6afc2297d0ae935a$export$2e2bcd8739ae039).min : (0, $89d549ff8cdff9bb$export$2e2bcd8739ae039).min;
    const max = parsed.space[0] === 'h' ? (0, $6afc2297d0ae935a$export$2e2bcd8739ae039).max : (0, $89d549ff8cdff9bb$export$2e2bcd8739ae039).max;
    values = Array(3);
    values[0] = Math.min(Math.max(parsed.values[0], min[0]), max[0]);
    values[1] = Math.min(Math.max(parsed.values[1], min[1]), max[1]);
    values[2] = Math.min(Math.max(parsed.values[2], min[2]), max[2]);
    if (parsed.space[0] === 'h') values = (0, $6afc2297d0ae935a$export$2e2bcd8739ae039).rgb(values);
    values.push(Math.min(Math.max(parsed.alpha, 0), 1));
    return values;
}


/**
 * Cylindrical CIE LUV
 *
 * @module color-space/lchuv
 */ /**
 * CIE LUV (C'est la vie)
 *
 * @module color-space/luv
 */ /**
 * CIE XYZ
 *
 * @module  color-space/xyz
 */ 
var $09b584694b605fcf$var$xyz = {
    name: 'xyz',
    min: [
        0,
        0,
        0
    ],
    channel: [
        'X',
        'Y',
        'Z'
    ],
    alias: [
        'XYZ',
        'ciexyz',
        'cie1931'
    ]
};
/**
 * Whitepoint reference values with observer/illuminant
 *
 * http://en.wikipedia.org/wiki/Standard_illuminant
 */ $09b584694b605fcf$var$xyz.whitepoint = {
    //1931 2°
    2: {
        //incadescent
        A: [
            109.85,
            100,
            35.585
        ],
        // B:[],
        C: [
            98.074,
            100,
            118.232
        ],
        D50: [
            96.422,
            100,
            82.521
        ],
        D55: [
            95.682,
            100,
            92.149
        ],
        //daylight
        D65: [
            95.045592705167,
            100,
            108.9057750759878
        ],
        D75: [
            94.972,
            100,
            122.638
        ],
        //flourescent
        // F1: [],
        F2: [
            99.187,
            100,
            67.395
        ],
        // F3: [],
        // F4: [],
        // F5: [],
        // F6:[],
        F7: [
            95.044,
            100,
            108.755
        ],
        // F8: [],
        // F9: [],
        // F10: [],
        F11: [
            100.966,
            100,
            64.370
        ],
        // F12: [],
        E: [
            100,
            100,
            100
        ]
    },
    //1964  10°
    10: {
        //incadescent
        A: [
            111.144,
            100,
            35.200
        ],
        C: [
            97.285,
            100,
            116.145
        ],
        D50: [
            96.720,
            100,
            81.427
        ],
        D55: [
            95.799,
            100,
            90.926
        ],
        //daylight
        D65: [
            94.811,
            100,
            107.304
        ],
        D75: [
            94.416,
            100,
            120.641
        ],
        //flourescent
        F2: [
            103.280,
            100,
            69.026
        ],
        F7: [
            95.792,
            100,
            107.687
        ],
        F11: [
            103.866,
            100,
            65.627
        ],
        E: [
            100,
            100,
            100
        ]
    }
};
/**
 * Top values are the whitepoint’s top values, default are D65
 */ $09b584694b605fcf$var$xyz.max = $09b584694b605fcf$var$xyz.whitepoint[2].D65;
/**
 * Transform xyz to rgb
 *
 * @param {Array} xyz Array of xyz values
 *
 * @return {Array} RGB values
 */ $09b584694b605fcf$var$xyz.rgb = function(_xyz, white) {
    //FIXME: make sure we have to divide like this. Probably we have to replace matrix as well then
    white = white || $09b584694b605fcf$var$xyz.whitepoint[2].E;
    var x = _xyz[0] / white[0], y = _xyz[1] / white[1], z = _xyz[2] / white[2], r, g, b;
    // assume sRGB
    // http://www.brucelindbloom.com/index.html?Eqn_RGB_XYZ_Matrix.html
    r = x * 3.240969941904521 + y * -1.537383177570093 + z * -0.498610760293;
    g = x * -0.96924363628087 + y * 1.87596750150772 + z * 0.041555057407175;
    b = x * 0.055630079696993 + y * -0.20397695888897 + z * 1.056971514242878;
    r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r = r * 12.92;
    g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g = g * 12.92;
    b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b = b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
/**
 * RGB to XYZ
 *
 * @param {Array} rgb RGB channels
 *
 * @return {Array} XYZ channels
 */ (0, $89d549ff8cdff9bb$export$2e2bcd8739ae039).xyz = function(rgb, white) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255;
    // assume sRGB
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    var x = r * 0.41239079926595 + g * 0.35758433938387 + b * 0.18048078840183;
    var y = r * 0.21263900587151 + g * 0.71516867876775 + b * 0.072192315360733;
    var z = r * 0.019330818715591 + g * 0.11919477979462 + b * 0.95053215224966;
    white = white || $09b584694b605fcf$var$xyz.whitepoint[2].E;
    return [
        x * white[0],
        y * white[1],
        z * white[2]
    ];
};
var $09b584694b605fcf$export$2e2bcd8739ae039 = $09b584694b605fcf$var$xyz;


var $6ac06470d33b795d$export$2e2bcd8739ae039 = {
    name: 'luv',
    //NOTE: luv has no rigidly defined limits
    //easyrgb fails to get proper coords
    //boronine states no rigid limits
    //colorMine refers this ones:
    min: [
        0,
        -134,
        -140
    ],
    max: [
        100,
        224,
        122
    ],
    channel: [
        'lightness',
        'u',
        'v'
    ],
    alias: [
        'LUV',
        'cieluv',
        'cie1976'
    ],
    xyz: function(arg, i, o) {
        var _u, _v, l, u, v, x, y, z, xn, yn, zn, un, vn;
        l = arg[0], u = arg[1], v = arg[2];
        if (l === 0) return [
            0,
            0,
            0
        ];
        //get constants
        //var e = 0.008856451679035631; //(6/29)^3
        var k = 0.0011070564598794539; //(3/29)^3
        //get illuminant/observer
        i = i || 'D65';
        o = o || 2;
        xn = (0, $09b584694b605fcf$export$2e2bcd8739ae039).whitepoint[o][i][0];
        yn = (0, $09b584694b605fcf$export$2e2bcd8739ae039).whitepoint[o][i][1];
        zn = (0, $09b584694b605fcf$export$2e2bcd8739ae039).whitepoint[o][i][2];
        un = 4 * xn / (xn + 15 * yn + 3 * zn);
        vn = 9 * yn / (xn + 15 * yn + 3 * zn);
        // un = 0.19783000664283;
        // vn = 0.46831999493879;
        _u = u / (13 * l) + un || 0;
        _v = v / (13 * l) + vn || 0;
        y = l > 8 ? yn * Math.pow((l + 16) / 116, 3) : yn * l * k;
        //wikipedia method
        x = y * 9 * _u / (4 * _v) || 0;
        z = y * (12 - 3 * _u - 20 * _v) / (4 * _v) || 0;
        //boronine method
        //https://github.com/boronine/husl/blob/master/husl.coffee#L201
        // x = 0 - (9 * y * _u) / ((_u - 4) * _v - _u * _v);
        // z = (9 * y - (15 * _v * y) - (_v * x)) / (3 * _v);
        return [
            x,
            y,
            z
        ];
    }
};
// http://www.brucelindbloom.com/index.html?Equations.html
// https://github.com/boronine/husl/blob/master/husl.coffee
//i - illuminant
//o - observer
(0, $09b584694b605fcf$export$2e2bcd8739ae039).luv = function(arg, i, o) {
    var _u, _v, l, u, v, x, y, z, xn, yn, zn, un, vn;
    //get constants
    var e = 0.008856451679035631; //(6/29)^3
    var k = 903.2962962962961; //(29/3)^3
    //get illuminant/observer coords
    i = i || 'D65';
    o = o || 2;
    xn = (0, $09b584694b605fcf$export$2e2bcd8739ae039).whitepoint[o][i][0];
    yn = (0, $09b584694b605fcf$export$2e2bcd8739ae039).whitepoint[o][i][1];
    zn = (0, $09b584694b605fcf$export$2e2bcd8739ae039).whitepoint[o][i][2];
    un = 4 * xn / (xn + 15 * yn + 3 * zn);
    vn = 9 * yn / (xn + 15 * yn + 3 * zn);
    x = arg[0], y = arg[1], z = arg[2];
    _u = 4 * x / (x + 15 * y + 3 * z) || 0;
    _v = 9 * y / (x + 15 * y + 3 * z) || 0;
    var yr = y / yn;
    l = yr <= e ? k * yr : 116 * Math.pow(yr, 1 / 3) - 16;
    u = 13 * l * (_u - un);
    v = 13 * l * (_v - vn);
    return [
        l,
        u,
        v
    ];
};



//cylindrical luv
var $cd5a584fab0e26ce$var$lchuv = {
    name: 'lchuv',
    channel: [
        'lightness',
        'chroma',
        'hue'
    ],
    alias: [
        'LCHuv',
        'cielchuv'
    ],
    min: [
        0,
        0,
        0
    ],
    max: [
        100,
        100,
        360
    ],
    luv: function(luv) {
        var l = luv[0], c = luv[1], h = luv[2], u, v, hr;
        hr = h / 360 * 2 * Math.PI;
        u = c * Math.cos(hr);
        v = c * Math.sin(hr);
        return [
            l,
            u,
            v
        ];
    },
    xyz: function(arg) {
        return (0, $6ac06470d33b795d$export$2e2bcd8739ae039).xyz($cd5a584fab0e26ce$var$lchuv.luv(arg));
    }
};
var $cd5a584fab0e26ce$export$2e2bcd8739ae039 = $cd5a584fab0e26ce$var$lchuv;
(0, $6ac06470d33b795d$export$2e2bcd8739ae039).lchuv = function(luv) {
    var l = luv[0], u = luv[1], v = luv[2];
    var c = Math.sqrt(u * u + v * v);
    var hr = Math.atan2(v, u);
    var h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    return [
        l,
        c,
        h
    ];
};
(0, $09b584694b605fcf$export$2e2bcd8739ae039).lchuv = function(arg) {
    return (0, $6ac06470d33b795d$export$2e2bcd8739ae039).lchuv((0, $09b584694b605fcf$export$2e2bcd8739ae039).luv(arg));
};





const $2c17bfc916c8f689$export$6c844c64a5efe1ee = [
    NaN,
    NaN,
    NaN,
    0
];
function $2c17bfc916c8f689$export$590567be997858b6(color) {
    if (typeof color === 'string') return color;
    return $2c17bfc916c8f689$export$f84e8e69fd4488a5(color);
}
/**
 * @type {number}
 */ const $2c17bfc916c8f689$var$MAX_CACHE_SIZE = 1024;
/**
 * We maintain a small cache of parsed strings.  Whenever the cache grows too large,
 * we delete an arbitrary set of the entries.
 *
 * @type {Object<string, Color>}
 */ const $2c17bfc916c8f689$var$cache = {};
/**
 * @type {number}
 */ let $2c17bfc916c8f689$var$cacheSize = 0;
function $2c17bfc916c8f689$export$138c09bdd6bd797c(color) {
    if (color.length === 4) return color;
    const output = color.slice();
    output[3] = 1;
    return output;
}
function $2c17bfc916c8f689$export$44fb54fa2e0c0d4(color) {
    const output = (0, $09b584694b605fcf$export$2e2bcd8739ae039).lchuv((0, $89d549ff8cdff9bb$export$2e2bcd8739ae039).xyz(color));
    output[3] = color[3];
    return output;
}
function $2c17bfc916c8f689$export$27cc94530c050f00(color) {
    const output = (0, $09b584694b605fcf$export$2e2bcd8739ae039).rgb((0, $cd5a584fab0e26ce$export$2e2bcd8739ae039).xyz(color));
    output[3] = color[3];
    return output;
}
function $2c17bfc916c8f689$export$3004f64547af360e(s) {
    if (s === 'none') return $2c17bfc916c8f689$export$6c844c64a5efe1ee;
    if ($2c17bfc916c8f689$var$cache.hasOwnProperty(s)) return $2c17bfc916c8f689$var$cache[s];
    if ($2c17bfc916c8f689$var$cacheSize >= $2c17bfc916c8f689$var$MAX_CACHE_SIZE) {
        let i = 0;
        for(const key in $2c17bfc916c8f689$var$cache)if ((i++ & 3) === 0) {
            delete $2c17bfc916c8f689$var$cache[key];
            --$2c17bfc916c8f689$var$cacheSize;
        }
    }
    const color = (0, $04627eea939c61f7$export$2e2bcd8739ae039)(s);
    if (color.length !== 4) throw new Error('failed to parse "' + s + '" as color');
    for (const c of color){
        if (isNaN(c)) throw new Error('failed to parse "' + s + '" as color');
    }
    $2c17bfc916c8f689$export$a3295358bff77e(color);
    $2c17bfc916c8f689$var$cache[s] = color;
    ++$2c17bfc916c8f689$var$cacheSize;
    return color;
}
function $2c17bfc916c8f689$export$75093a47a9fa838d(color) {
    if (Array.isArray(color)) return color;
    return $2c17bfc916c8f689$export$3004f64547af360e(color);
}
function $2c17bfc916c8f689$export$a3295358bff77e(color) {
    color[0] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(color[0] + 0.5 | 0, 0, 255);
    color[1] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(color[1] + 0.5 | 0, 0, 255);
    color[2] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(color[2] + 0.5 | 0, 0, 255);
    color[3] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(color[3], 0, 1);
    return color;
}
function $2c17bfc916c8f689$export$f84e8e69fd4488a5(color) {
    let r = color[0];
    if (r != (r | 0)) r = r + 0.5 | 0;
    let g = color[1];
    if (g != (g | 0)) g = g + 0.5 | 0;
    let b = color[2];
    if (b != (b | 0)) b = b + 0.5 | 0;
    const a = color[3] === undefined ? 1 : Math.round(color[3] * 1000) / 1000;
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}
function $2c17bfc916c8f689$export$40dd713d7775a0b1(s) {
    try {
        $2c17bfc916c8f689$export$3004f64547af360e(s);
        return true;
    } catch  {
        return false;
    }
}


/**
 * @module ol/has
 */ const $89969764a1196844$var$ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
const $89969764a1196844$export$8442bdfd18b7b8a6 = $89969764a1196844$var$ua.includes('firefox');
const $89969764a1196844$export$3227bfbdaa9275de = $89969764a1196844$var$ua.includes('safari') && !$89969764a1196844$var$ua.includes('chrom');
const $89969764a1196844$export$b23eed0e325a206a = $89969764a1196844$export$3227bfbdaa9275de && ($89969764a1196844$var$ua.includes('version/15.4') || /cpu (os|iphone os) 15_4 like mac os x/.test($89969764a1196844$var$ua));
const $89969764a1196844$export$39dfd62a25e0fe93 = $89969764a1196844$var$ua.includes('webkit') && !$89969764a1196844$var$ua.includes('edge');
const $89969764a1196844$export$76c0a3b101d93136 = $89969764a1196844$var$ua.includes('macintosh');
const $89969764a1196844$export$6b83a0446fc26f94 = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
const $89969764a1196844$export$98fcef3dc9973292 = typeof WorkerGlobalScope !== 'undefined' && typeof OffscreenCanvas !== 'undefined' && self instanceof WorkerGlobalScope; //eslint-disable-line
const $89969764a1196844$export$716f8695eedb9bad = typeof Image !== 'undefined' && Image.prototype.decode;
const $89969764a1196844$export$7478563940788376 = typeof createImageBitmap === 'function';
const $89969764a1196844$export$f751ce96c6c4e4fc = function() {
    let passive = false;
    try {
        const options = Object.defineProperty({}, 'passive', {
            get: function() {
                passive = true;
            }
        });
        // @ts-ignore Ignore invalid event type '_'
        window.addEventListener('_', null, options);
        // @ts-ignore Ignore invalid event type '_'
        window.removeEventListener('_', null, options);
    } catch  {
    // passive not supported
    }
    return passive;
}();


function $755a3001f896bcf1$export$9e05d10eae75c464(width, height, canvasPool, settings) {
    /** @type {HTMLCanvasElement|OffscreenCanvas} */ let canvas;
    if (canvasPool && canvasPool.length) canvas = /** @type {HTMLCanvasElement} */ canvasPool.shift();
    else if (0, $89969764a1196844$export$98fcef3dc9973292) canvas = new OffscreenCanvas(width || 300, height || 300);
    else canvas = document.createElement('canvas');
    if (width) canvas.width = width;
    if (height) canvas.height = height;
    //FIXME Allow OffscreenCanvasRenderingContext2D as return type
    return /** @type {CanvasRenderingContext2D} */ canvas.getContext('2d', settings);
}
/** @type {CanvasRenderingContext2D} */ let $755a3001f896bcf1$var$sharedCanvasContext;
function $755a3001f896bcf1$export$fcb72ce088a6632c() {
    if (!$755a3001f896bcf1$var$sharedCanvasContext) $755a3001f896bcf1$var$sharedCanvasContext = $755a3001f896bcf1$export$9e05d10eae75c464(1, 1);
    return $755a3001f896bcf1$var$sharedCanvasContext;
}
function $755a3001f896bcf1$export$e918ac6a1026a12a(context) {
    const canvas = context.canvas;
    canvas.width = 1;
    canvas.height = 1;
    context.clearRect(0, 0, 1, 1);
}
function $755a3001f896bcf1$export$e823f88e4111159a(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
function $755a3001f896bcf1$export$fc5b8aac72846d1e(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
function $755a3001f896bcf1$export$5542201de9311ab2(newNode, oldNode) {
    const parent = oldNode.parentNode;
    if (parent) parent.replaceChild(newNode, oldNode);
}
function $755a3001f896bcf1$export$1e1c9bf5a4ffe0d1(node) {
    while(node.lastChild)node.lastChild.remove();
}
function $755a3001f896bcf1$export$caeacfe04f52533a(node, children) {
    const oldChildren = node.childNodes;
    for(let i = 0;; ++i){
        const oldChild = oldChildren[i];
        const newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) break;
        // check if children match
        if (oldChild === newChild) continue;
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}



/**
 * @module ol/render/Event
 */ /**
 * @module ol/events/Event
 */ /**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */ class $0327f54963b35733$var$BaseEvent {
    /**
   * @param {string} type Type.
   */ constructor(type){
        /**
     * @type {boolean}
     */ this.propagationStopped;
        /**
     * @type {boolean}
     */ this.defaultPrevented;
        /**
     * The event type.
     * @type {string}
     * @api
     */ this.type = type;
        /**
     * The event target.
     * @type {Object}
     * @api
     */ this.target = null;
    }
    /**
   * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
   * will be fired.
   * @api
   */ preventDefault() {
        this.defaultPrevented = true;
    }
    /**
   * Stop event propagation.
   * @api
   */ stopPropagation() {
        this.propagationStopped = true;
    }
}
function $0327f54963b35733$export$51134cce184326b9(evt) {
    evt.stopPropagation();
}
function $0327f54963b35733$export$fa3b29edae795ef4(evt) {
    evt.preventDefault();
}
var $0327f54963b35733$export$2e2bcd8739ae039 = $0327f54963b35733$var$BaseEvent;


class $802ec85cbdf20290$var$RenderEvent extends (0, $0327f54963b35733$export$2e2bcd8739ae039) {
    /**
   * @param {import("./EventType.js").default} type Type.
   * @param {import("../transform.js").Transform} [inversePixelTransform] Transform for
   *     CSS pixels to rendered pixels.
   * @param {import("../Map.js").FrameState} [frameState] Frame state.
   * @param {?(CanvasRenderingContext2D|WebGLRenderingContext)} [context] Context.
   */ constructor(type, inversePixelTransform, frameState, context){
        super(type);
        /**
     * Transform from CSS pixels (relative to the top-left corner of the map viewport)
     * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
     * @type {import("../transform.js").Transform|undefined}
     * @api
     */ this.inversePixelTransform = inversePixelTransform;
        /**
     * An object representing the current render frame state.
     * @type {import("../Map.js").FrameState|undefined}
     * @api
     */ this.frameState = frameState;
        /**
     * Canvas context. Not available when the event is dispatched by the map. For Canvas 2D layers,
     * the context will be the 2D rendering context.  For WebGL layers, the context will be the WebGL
     * context.
     * @type {CanvasRenderingContext2D|WebGLRenderingContext|undefined}
     * @api
     */ this.context = context;
    }
}
var $802ec85cbdf20290$export$2e2bcd8739ae039 = $802ec85cbdf20290$var$RenderEvent;


/**
 * @module ol/render/EventType
 */ /**
 * @enum {string}
 */ var $847c6e8c21904781$export$2e2bcd8739ae039 /**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */  /**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */  = {
    /**
   * Triggered before a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#prerender
   * @api
   */ PRERENDER: 'prerender',
    /**
   * Triggered after a layer is rendered.
   * @event module:ol/render/Event~RenderEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered before layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#precompose
   * @api
   */ PRECOMPOSE: 'precompose',
    /**
   * Triggered after layers are composed.  When dispatched by the map, the event object will not have
   * a `context` set.  When dispatched by a layer, the event object will have a `context` set.  Only
   * WebGL layers currently dispatch this event.
   * @event module:ol/render/Event~RenderEvent#postcompose
   * @api
   */ POSTCOMPOSE: 'postcompose',
    /**
   * Triggered when rendering is complete, i.e. all sources and tiles have
   * finished loading for the current viewport, and all tiles are faded in.
   * The event object will not have a `context` set.
   * @event module:ol/render/Event~RenderEvent#rendercomplete
   * @api
   */ RENDERCOMPLETE: 'rendercomplete'
};


/**
 * @module ol/render/canvas/ZIndexContext
 */ 
/** @typedef {CanvasRenderingContext2D & {globalAlpha: any}} ZIndexContextProxy */ /**
 * @extends {CanvasRenderingContext2D}
 */ class $effff0602ddf7360$var$ZIndexContext {
    constructor(){
        /**
     * @private
     * @type {Array<Array<*>>}
     */ this.instructions_ = [];
        /**
     * @type {number}
     */ this.zIndex = 0;
        /**
     * @private
     * @type {number}
     */ this.offset_ = 0;
        /**
     * @private
     * @type {ZIndexContextProxy}
     */ this.context_ = /** @type {ZIndexContextProxy} */ new Proxy((0, $755a3001f896bcf1$export$fcb72ce088a6632c)(), {
            get: (target, property)=>{
                if (typeof /** @type {*} */ (0, $755a3001f896bcf1$export$fcb72ce088a6632c)()[property] !== 'function') // we only accept calling functions on the proxy, not accessing properties
                return undefined;
                if (!this.instructions_[this.zIndex + this.offset_]) this.instructions_[this.zIndex + this.offset_] = [];
                this.instructions_[this.zIndex + this.offset_].push(property);
                return this.pushMethodArgs_;
            },
            set: (target, property, value)=>{
                if (!this.instructions_[this.zIndex + this.offset_]) this.instructions_[this.zIndex + this.offset_] = [];
                this.instructions_[this.zIndex + this.offset_].push(property, value);
                return true;
            }
        });
    }
    /**
   * @private
   * @param {...*} args Args.
   * @return {ZIndexContext} This.
   */ pushMethodArgs_ = (...args)=>{
        this.instructions_[this.zIndex + this.offset_].push(args);
        return this;
    };
    /**
   * Push a function that renders to the context directly.
   * @param {function(CanvasRenderingContext2D): void} render Function.
   */ pushFunction(render) {
        this.instructions_[this.zIndex + this.offset_].push(render);
    }
    /**
   * Get a proxy for CanvasRenderingContext2D which does not support getting state
   * (e.g. `context.globalAlpha`, which will return `undefined`). To set state, if it relies on a
   * previous state (e.g. `context.globalAlpha = context.globalAlpha / 2`), set a function,
   * e.g. `context.globalAlpha = (context) => context.globalAlpha / 2`.
   * @return {ZIndexContextProxy} Context.
   */ getContext() {
        return this.context_;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   */ draw(context) {
        this.instructions_.forEach((instructionsAtIndex)=>{
            for(let i = 0, ii = instructionsAtIndex.length; i < ii; ++i){
                const property = instructionsAtIndex[i];
                if (typeof property === 'function') {
                    property(context);
                    continue;
                }
                const instructionAtIndex = instructionsAtIndex[++i];
                if (typeof /** @type {*} */ context[property] === 'function') /** @type {*} */ context[property](...instructionAtIndex);
                else {
                    if (typeof instructionAtIndex === 'function') {
                        /** @type {*} */ context[property] = instructionAtIndex(context);
                        continue;
                    }
                    /** @type {*} */ context[property] = instructionAtIndex;
                }
            }
        });
    }
    clear() {
        this.instructions_.length = 0;
        this.zIndex = 0;
        this.offset_ = 0;
    }
    /**
   * Offsets the zIndex by the highest current zIndex. Useful for rendering multiple worlds or tiles, to
   * avoid conflicting context.clip() or context.save()/restore() calls.
   */ offset() {
        this.offset_ = this.instructions_.length;
        this.zIndex = 0;
    }
}
var $effff0602ddf7360$export$2e2bcd8739ae039 = $effff0602ddf7360$var$ZIndexContext;



/**
 * @module ol/renderer/Layer
 */ 
/**
 * @module ol/Observable
 */ /**
 * @module ol/events/EventType
 */ /**
 * @enum {string}
 * @const
 */ var $6a4d89c0e1a6605f$export$2e2bcd8739ae039 = {
    /**
   * Generic change event. Triggered when the revision counter is increased.
   * @event module:ol/events/Event~BaseEvent#change
   * @api
   */ CHANGE: 'change',
    /**
   * Generic error event. Triggered when an error occurs.
   * @event module:ol/events/Event~BaseEvent#error
   * @api
   */ ERROR: 'error',
    BLUR: 'blur',
    CLEAR: 'clear',
    CONTEXTMENU: 'contextmenu',
    CLICK: 'click',
    DBLCLICK: 'dblclick',
    DRAGENTER: 'dragenter',
    DRAGOVER: 'dragover',
    DROP: 'drop',
    FOCUS: 'focus',
    KEYDOWN: 'keydown',
    KEYPRESS: 'keypress',
    LOAD: 'load',
    RESIZE: 'resize',
    TOUCHMOVE: 'touchmove',
    WHEEL: 'wheel'
};


/**
 * @module ol/events/Target
 */ /**
 * @module ol/Disposable
 */ /**
 * @classdesc
 * Objects that need to clean up after themselves.
 */ class $17f88068b11f58ac$var$Disposable {
    constructor(){
        /**
     * The object has already been disposed.
     * @type {boolean}
     * @protected
     */ this.disposed = false;
    }
    /**
   * Clean up.
   */ dispose() {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    }
    /**
   * Extension point for disposable objects.
   * @protected
   */ disposeInternal() {}
}
var $17f88068b11f58ac$export$2e2bcd8739ae039 = $17f88068b11f58ac$var$Disposable;


/**
 * @module ol/functions
 */ 
function $de1052d9f293b73a$export$22e23a2304399231() {
    return true;
}
function $de1052d9f293b73a$export$8f11cee4bdc7e668() {
    return false;
}
function $de1052d9f293b73a$export$1cd1943b3a73bbe8() {}
function $de1052d9f293b73a$export$ff83df6f9971435f(fn) {
    /** @type {ReturnType} */ let lastResult;
    /** @type {Array<any>|undefined} */ let lastArgs;
    let lastThis;
    /**
   * @this {*} Only need to know if `this` changed, don't care what type
   * @return {ReturnType} Memoized value
   */ return function() {
        const nextArgs = Array.prototype.slice.call(arguments);
        if (!lastArgs || this !== lastThis || !(0, $830d23b8323fc080$export$e9bab7fafb253603)(nextArgs, lastArgs)) {
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
function $de1052d9f293b73a$export$4dbaaf6c79705e6c(getter) {
    function promiseGetter() {
        let value;
        try {
            value = getter();
        } catch (err) {
            return Promise.reject(err);
        }
        if (value instanceof Promise) return value;
        return Promise.resolve(value);
    }
    return promiseGetter();
}




/**
 * @typedef {EventTarget|Target} EventTargetLike
 */ /**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */ class $dd029d816e3b4259$var$Target extends (0, $17f88068b11f58ac$export$2e2bcd8739ae039) {
    /**
   * @param {*} [target] Default event target for dispatched events.
   */ constructor(target){
        super();
        /**
     * @private
     * @type {*}
     */ this.eventTarget_ = target;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.pendingRemovals_ = null;
        /**
     * @private
     * @type {Object<string, number>|null}
     */ this.dispatching_ = null;
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").Listener>>|null}
     */ this.listeners_ = null;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ addEventListener(type, listener) {
        if (!type || !listener) return;
        const listeners = this.listeners_ || (this.listeners_ = {});
        const listenersForType = listeners[type] || (listeners[type] = []);
        if (!listenersForType.includes(listener)) listenersForType.push(listener);
    }
    /**
   * Dispatches an event and calls all listeners listening for events
   * of this type. The event parameter can either be a string or an
   * Object with a `type` property.
   *
   * @param {import("./Event.js").default|string} event Event object.
   * @return {boolean|undefined} `false` if anyone called preventDefault on the
   *     event object or if any of the listeners returned false.
   * @api
   */ dispatchEvent(event) {
        const isString = typeof event === 'string';
        const type = isString ? event : event.type;
        const listeners = this.listeners_ && this.listeners_[type];
        if (!listeners) return;
        const evt = isString ? new (0, $0327f54963b35733$export$2e2bcd8739ae039)(event) : /** @type {Event} */ event;
        if (!evt.target) evt.target = this.eventTarget_ || this;
        const dispatching = this.dispatching_ || (this.dispatching_ = {});
        const pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
        if (!(type in dispatching)) {
            dispatching[type] = 0;
            pendingRemovals[type] = 0;
        }
        ++dispatching[type];
        let propagate;
        for(let i = 0, ii = listeners.length; i < ii; ++i){
            if ('handleEvent' in listeners[i]) propagate = /** @type {import("../events.js").ListenerObject} */ listeners[i].handleEvent(evt);
            else propagate = /** @type {import("../events.js").ListenerFunction} */ listeners[i].call(this, evt);
            if (propagate === false || evt.propagationStopped) {
                propagate = false;
                break;
            }
        }
        if (--dispatching[type] === 0) {
            let pr = pendingRemovals[type];
            delete pendingRemovals[type];
            while(pr--)this.removeEventListener(type, (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8));
            delete dispatching[type];
        }
        return propagate;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.listeners_ && (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)(this.listeners_);
    }
    /**
   * Get the listeners for a specified event type. Listeners are returned in the
   * order that they will be called in.
   *
   * @param {string} type Type.
   * @return {Array<import("../events.js").Listener>|undefined} Listeners.
   */ getListeners(type) {
        return this.listeners_ && this.listeners_[type] || undefined;
    }
    /**
   * @param {string} [type] Type. If not provided,
   *     `true` will be returned if this event target has any listeners.
   * @return {boolean} Has listeners.
   */ hasListener(type) {
        if (!this.listeners_) return false;
        return type ? type in this.listeners_ : Object.keys(this.listeners_).length > 0;
    }
    /**
   * @param {string} type Type.
   * @param {import("../events.js").Listener} listener Listener.
   */ removeEventListener(type, listener) {
        if (!this.listeners_) return;
        const listeners = this.listeners_[type];
        if (!listeners) return;
        const index = listeners.indexOf(listener);
        if (index !== -1) {
            if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                // make listener a no-op, and remove later in #dispatchEvent()
                listeners[index] = (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8);
                ++this.pendingRemovals_[type];
            } else {
                listeners.splice(index, 1);
                if (listeners.length === 0) delete this.listeners_[type];
            }
        }
    }
}
var $dd029d816e3b4259$export$2e2bcd8739ae039 = $dd029d816e3b4259$var$Target;


/**
 * @module ol/events
 */ 
function $37a5c0af9052e360$export$63174c828edd6ff8(target, type, listener, thisArg, once) {
    if (once) {
        const originalListener = listener;
        /**
     * @param {Event|import('./events/Event.js').default} event The event
     * @return {void|boolean} When the function returns `false`, event propagation will stop.
     * @this {typeof target}
     */ listener = function(event) {
            target.removeEventListener(type, listener);
            return originalListener.call(thisArg ?? this, event);
        };
    } else if (thisArg && thisArg !== target) listener = listener.bind(thisArg);
    const eventsKey = {
        target: target,
        type: type,
        listener: listener
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
function $37a5c0af9052e360$export$8d2a95bc11b44725(target, type, listener, thisArg) {
    return $37a5c0af9052e360$export$63174c828edd6ff8(target, type, listener, thisArg, true);
}
function $37a5c0af9052e360$export$b0a21c8b3c1c921(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)(key);
    }
}


/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type, listener: (event: EventClass) => ?) => Return} OnSignature
 */ /***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => ?) => Return extends void ? void : Return[]} CombinedOnSignature
 */ /**
 * @typedef {'change'|'error'} EventTypes
 */ /***
 * @template Return
 * @typedef {OnSignature<EventTypes, import("./events/Event.js").default, Return> & CombinedOnSignature<EventTypes, Return>} ObservableOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */ class $5cf0b3202980c59c$var$Observable extends (0, $dd029d816e3b4259$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.on = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onInternal;
        this.once = /** @type {ObservableOnSignature<import("./events").EventsKey>} */ this.onceInternal;
        this.un = /** @type {ObservableOnSignature<void>} */ this.unInternal;
        /**
     * @private
     * @type {number}
     */ this.revision_ = 0;
    }
    /**
   * Increases the revision counter and dispatches a 'change' event.
   * @api
   */ changed() {
        ++this.revision_;
        this.dispatchEvent((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Get the version number for this object.  Each time the object is modified,
   * its version number will be incremented.
   * @return {number} Revision.
   * @api
   */ getRevision() {
        return this.revision_;
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onInternal(type, listener) {
        if (Array.isArray(type)) {
            const len = type.length;
            const keys = new Array(len);
            for(let i = 0; i < len; ++i)keys[i] = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, type[i], listener);
            return keys;
        }
        return (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, /** @type {string} */ type, listener);
    }
    /**
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
   * @protected
   */ onceInternal(type, listener) {
        let key;
        if (Array.isArray(type)) {
            const len = type.length;
            key = new Array(len);
            for(let i = 0; i < len; ++i)key[i] = (0, $37a5c0af9052e360$export$8d2a95bc11b44725)(this, type[i], listener);
        } else key = (0, $37a5c0af9052e360$export$8d2a95bc11b44725)(this, /** @type {string} */ type, listener);
        /** @type {Object} */ listener.ol_key = key;
        return key;
    }
    /**
   * Unlisten for a certain type of event.
   * @param {string|Array<string>} type Type.
   * @param {function((Event|import("./events/Event").default)): ?} listener Listener.
   * @protected
   */ unInternal(type, listener) {
        const key = /** @type {Object} */ listener.ol_key;
        if (key) $5cf0b3202980c59c$export$b7ef3f8527533384(key);
        else if (Array.isArray(type)) for(let i = 0, ii = type.length; i < ii; ++i)this.removeEventListener(type[i], listener);
        else this.removeEventListener(type, listener);
    }
}
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $5cf0b3202980c59c$var$Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */ $5cf0b3202980c59c$var$Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): ?} listener The listener function.
 * @api
 */ $5cf0b3202980c59c$var$Observable.prototype.un;
function $5cf0b3202980c59c$export$b7ef3f8527533384(key) {
    if (Array.isArray(key)) for(let i = 0, ii = key.length; i < ii; ++i)(0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(key[i]);
    else (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(/** @type {import("./events.js").EventsKey} */ key);
}
var $5cf0b3202980c59c$export$2e2bcd8739ae039 = $5cf0b3202980c59c$var$Observable;



/**
 * @module ol/util
 */ /**
 * @return {never} Any return.
 */ function $34772e91e89a736f$export$817eb92a8194bab0() {
    throw new Error('Unimplemented abstract method.');
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */ let $34772e91e89a736f$var$uidCounter_ = 0;
function $34772e91e89a736f$export$5e82334337e0f204(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++$34772e91e89a736f$var$uidCounter_));
}
const $34772e91e89a736f$export$a4ad2735b021c132 = '10.4.0';


const $2151efd61380bcce$var$maxStaleKeys = 5;
/**
 * @template {import("../layer/Layer.js").default} LayerType
 */ class $2151efd61380bcce$var$LayerRenderer extends (0, $5cf0b3202980c59c$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super();
        /**
     * The renderer is initialized and ready to render.
     * @type {boolean}
     */ this.ready = true;
        /** @private */ this.boundHandleImageChange_ = this.handleImageChange_.bind(this);
        /**
     * @private
     * @type {LayerType}
     */ this.layer_ = layer;
        /**
     * @type {Array<string>}
     * @private
     */ this.staleKeys_ = new Array();
        /**
     * @type {number}
     * @protected
     */ this.maxStaleKeys = $2151efd61380bcce$var$maxStaleKeys;
    }
    /**
   * @return {Array<string>} Get the list of stale keys.
   */ getStaleKeys() {
        return this.staleKeys_;
    }
    /**
   * @param {string} key The new stale key.
   */ prependStaleKey(key) {
        this.staleKeys_.unshift(key);
        if (this.staleKeys_.length > this.maxStaleKeys) this.staleKeys_.length = this.maxStaleKeys;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        return null;
    }
    /**
   * Determine whether render should be called.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   */ prepareFrame(frameState) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Render the layer.
   * @abstract
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   */ renderFrame(frameState, target) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    }
    /**
   * @return {LayerType} Layer.
   */ getLayer() {
        return this.layer_;
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @abstract
   */ handleFontsChanged() {}
    /**
   * Handle changes in image state.
   * @param {import("../events/Event.js").default} event Image change event.
   * @private
   */ handleImageChange_(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        if (image.getState() === (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED || image.getState() === (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR) this.renderIfReadyAndVisible();
    }
    /**
   * Load the image if not already loaded, and register the image change
   * listener if needed.
   * @param {import("../Image.js").default} image Image.
   * @return {boolean} `true` if the image is already loaded, `false` otherwise.
   * @protected
   */ loadImage(image) {
        let imageState = image.getState();
        if (imageState != (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED && imageState != (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR) image.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.boundHandleImageChange_);
        if (imageState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
    }
    /**
   * @protected
   */ renderIfReadyAndVisible() {
        const layer = this.getLayer();
        if (layer && layer.getVisible() && layer.getSourceState() === 'ready') layer.changed();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ renderDeferred(frameState) {}
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.layer_;
        super.disposeInternal();
    }
}
var $2151efd61380bcce$export$2e2bcd8739ae039 = $2151efd61380bcce$var$LayerRenderer;


const $22aba15f167ce2ee$export$a166f0857c555517 = [];
/**
 * @type {CanvasRenderingContext2D}
 */ let $22aba15f167ce2ee$var$pixelContext = null;
function $22aba15f167ce2ee$var$createPixelContext() {
    $22aba15f167ce2ee$var$pixelContext = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(1, 1, undefined, {
        willReadFrequently: true
    });
}
/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 * @extends {LayerRenderer<LayerType>}
 */ class $22aba15f167ce2ee$var$CanvasLayerRenderer extends (0, $2151efd61380bcce$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} layer Layer.
   */ constructor(layer){
        super(layer);
        /**
     * @protected
     * @type {HTMLElement}
     */ this.container = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedResolution;
        /**
     * A temporary transform.  The values in this transform should only be used in a
     * function that sets the values.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.tempTransform = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * The transform for rendered pixels to viewport CSS pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.pixelTransform = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * The transform for viewport CSS pixels to rendered pixels.  This transform must
     * be set when rendering a frame and may be used by other functions after rendering.
     * @protected
     * @type {import("../../transform.js").Transform}
     */ this.inversePixelTransform = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @type {CanvasRenderingContext2D}
     */ this.context = null;
        /**
     * @private
     * @type {ZIndexContext}
     */ this.deferredContext_ = null;
        /**
     * @type {boolean}
     */ this.containerReused = false;
        /**
     * @protected
     * @type {import("../../Map.js").FrameState|null}
     */ this.frameState = null;
    }
    /**
   * @param {import('../../DataTile.js').ImageLike} image Image.
   * @param {number} col The column index.
   * @param {number} row The row index.
   * @return {Uint8ClampedArray|null} The image data.
   */ getImageData(image, col, row) {
        if (!$22aba15f167ce2ee$var$pixelContext) $22aba15f167ce2ee$var$createPixelContext();
        $22aba15f167ce2ee$var$pixelContext.clearRect(0, 0, 1, 1);
        let data;
        try {
            $22aba15f167ce2ee$var$pixelContext.drawImage(image, col, row, 1, 1, 0, 0, 1, 1);
            data = $22aba15f167ce2ee$var$pixelContext.getImageData(0, 0, 1, 1).data;
        } catch  {
            $22aba15f167ce2ee$var$pixelContext = null;
            return null;
        }
        return data;
    }
    /**
   * @param {import('../../Map.js').FrameState} frameState Frame state.
   * @return {string} Background color.
   */ getBackground(frameState) {
        const layer = this.getLayer();
        let background = layer.getBackground();
        if (typeof background === 'function') background = background(frameState.viewState.resolution);
        return background || undefined;
    }
    /**
   * Get a rendering container from an existing target, if compatible.
   * @param {HTMLElement} target Potential render target.
   * @param {string} transform CSS Transform.
   * @param {string} [backgroundColor] Background color.
   */ useContainer(target, transform, backgroundColor) {
        const layerClassName = this.getLayer().getClassName();
        let container, context;
        if (target && target.className === layerClassName && (!backgroundColor || target && target.style.backgroundColor && (0, $830d23b8323fc080$export$e9bab7fafb253603)((0, $2c17bfc916c8f689$export$75093a47a9fa838d)(target.style.backgroundColor), (0, $2c17bfc916c8f689$export$75093a47a9fa838d)(backgroundColor)))) {
            const canvas = target.firstElementChild;
            if (canvas instanceof HTMLCanvasElement) context = canvas.getContext('2d');
        }
        if (context && context.canvas.style.transform === transform) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        } else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        } else if (this.container) this.container.style.backgroundColor = null;
        if (!this.container) {
            container = document.createElement('div');
            container.className = layerClassName;
            let style = container.style;
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
            context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)();
            const canvas = context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = 'absolute';
            style.left = '0';
            style.transformOrigin = 'top left';
            this.container = container;
            this.context = context;
        }
        if (!this.containerReused && backgroundColor && !this.container.style.backgroundColor) this.container.style.backgroundColor = backgroundColor;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent Clip extent.
   * @protected
   */ clipUnrotated(context, frameState, extent) {
        const topLeft = (0, $7e819822b33b3d32$export$cb1538b07e6964ff)(extent);
        const topRight = (0, $7e819822b33b3d32$export$b84fa077c8b05295)(extent);
        const bottomRight = (0, $7e819822b33b3d32$export$e77c1cf70445e168)(extent);
        const bottomLeft = (0, $7e819822b33b3d32$export$8d09f5e2e1bf560d)(extent);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topLeft);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, topRight);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomRight);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, bottomLeft);
        const inverted = this.inversePixelTransform;
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(inverted, topLeft);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(inverted, topRight);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(inverted, bottomRight);
        (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @protected
   */ prepareContainer(frameState, target) {
        const extent = frameState.extent;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const pixelRatio = frameState.pixelRatio;
        const width = Math.round((0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $7e819822b33b3d32$export$c08559766941f856)(extent) / resolution * pixelRatio);
        // set forward and inverse pixel transforms
        (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        (0, $2567d97ab31c5663$export$bd70ea2a93c0fa4)(this.inversePixelTransform, this.pixelTransform);
        const canvasTransform = (0, $2567d97ab31c5663$export$f84e8e69fd4488a5)(this.pixelTransform);
        this.useContainer(target, canvasTransform, this.getBackground(frameState));
        if (!this.containerReused) {
            const canvas = this.context.canvas;
            if (canvas.width != width || canvas.height != height) {
                canvas.width = width;
                canvas.height = height;
            } else this.context.clearRect(0, 0, width, height);
            if (canvasTransform !== canvas.style.transform) canvas.style.transform = canvasTransform;
        }
    }
    /**
   * @param {import("../../render/EventType.js").default} type Event type.
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @private
   */ dispatchRenderEvent_(type, context, frameState) {
        const layer = this.getLayer();
        if (layer.hasListener(type)) {
            const event = new (0, $802ec85cbdf20290$export$2e2bcd8739ae039)(type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event);
        }
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ preRender(context, frameState) {
        this.frameState = frameState;
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $847c6e8c21904781$export$2e2bcd8739ae039).PRERENDER, context, frameState);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @protected
   */ postRender(context, frameState) {
        if (frameState.declutter) return;
        this.dispatchRenderEvent_((0, $847c6e8c21904781$export$2e2bcd8739ae039).POSTRENDER, context, frameState);
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeferredInternal(frameState) {}
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import('../../render/canvas/ZIndexContext.js').ZIndexContextProxy} Context.
   */ getRenderContext(frameState) {
        if (frameState.declutter && !this.deferredContext_) this.deferredContext_ = new (0, $effff0602ddf7360$export$2e2bcd8739ae039)();
        return frameState.declutter ? this.deferredContext_.getContext() : this.context;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferred(frameState) {
        if (!frameState.declutter) return;
        this.dispatchRenderEvent_((0, $847c6e8c21904781$export$2e2bcd8739ae039).PRERENDER, this.context, frameState);
        if (frameState.declutter && this.deferredContext_) {
            this.deferredContext_.draw(this.context);
            this.deferredContext_.clear();
        }
        this.renderDeferredInternal(frameState);
        this.dispatchRenderEvent_((0, $847c6e8c21904781$export$2e2bcd8739ae039).POSTRENDER, this.context, frameState);
    }
    /**
   * Creates a transform for rendering to an element that will be rotated after rendering.
   * @param {import("../../coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} width Width of the rendered element (in pixels).
   * @param {number} height Height of the rendered element (in pixels).
   * @param {number} offsetX Offset on the x-axis in view coordinates.
   * @protected
   * @return {!import("../../transform.js").Transform} Transform.
   */ getRenderTransform(center, resolution, rotation, pixelRatio, width, height, offsetX) {
        const dx1 = width / 2;
        const dy1 = height / 2;
        const sx = pixelRatio / resolution;
        const sy = -sx;
        const dx2 = -center[0] + offsetX;
        const dy2 = -center[1];
        return (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        delete this.frameState;
        super.disposeInternal();
    }
}
var $22aba15f167ce2ee$export$2e2bcd8739ae039 = $22aba15f167ce2ee$var$CanvasLayerRenderer;


/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 */ class $2a67941380f9882b$var$CanvasImageLayerRenderer extends (0, $22aba15f167ce2ee$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/Image.js").default} imageLayer Image layer.
   */ constructor(imageLayer){
        super(imageLayer);
        /**
     * @protected
     * @type {?import("../../Image.js").default}
     */ this.image = null;
    }
    /**
   * @return {import('../../DataTile.js').ImageLike} Image.
   */ getImage() {
        return !this.image ? null : this.image.getImage();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewResolution = viewState.resolution;
        const imageSource = this.getLayer().getSource();
        const hints = frameState.viewHints;
        let renderedExtent = frameState.extent;
        if (layerState.extent !== undefined) renderedExtent = (0, $7e819822b33b3d32$export$72209efa88586d42)(renderedExtent, (0, $92f1443438429e81$export$494be3a3a25689ca)(layerState.extent, viewState.projection));
        if (!hints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] && !hints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING] && !(0, $7e819822b33b3d32$export$dd1bc94b04021eeb)(renderedExtent)) {
            if (imageSource) {
                const projection = viewState.projection;
                const image = imageSource.getImage(renderedExtent, viewResolution, pixelRatio, projection);
                if (image) {
                    if (this.loadImage(image)) this.image = image;
                    else if (image.getState() === (0, $23fb176c76153f22$export$2e2bcd8739ae039).EMPTY) this.image = null;
                }
            } else this.image = null;
        }
        return !!this.image;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $7e819822b33b3d32$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const imageExtent = this.image.getExtent();
        const img = this.image.getImage();
        const imageMapWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(imageExtent);
        const col = Math.floor(img.width * ((coordinate[0] - imageExtent[0]) / imageMapWidth));
        if (col < 0 || col >= img.width) return null;
        const imageMapHeight = (0, $7e819822b33b3d32$export$c08559766941f856)(imageExtent);
        const row = Math.floor(img.height * ((imageExtent[3] - coordinate[1]) / imageMapHeight));
        if (row < 0 || row >= img.height) return null;
        return this.getImageData(img, col, row);
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const image = this.image;
        const imageExtent = image.getExtent();
        const imageResolution = image.getResolution();
        const [imageResolutionX, imageResolutionY] = Array.isArray(imageResolution) ? imageResolution : [
            imageResolution,
            imageResolution
        ];
        const imagePixelRatio = image.getPixelRatio();
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const pixelRatio = frameState.pixelRatio;
        const viewState = frameState.viewState;
        const viewCenter = viewState.center;
        const viewResolution = viewState.resolution;
        const scaleX = pixelRatio * imageResolutionX / (viewResolution * imagePixelRatio);
        const scaleY = pixelRatio * imageResolutionY / (viewResolution * imagePixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const context = this.getRenderContext(frameState);
        // clipped rendering if layer extent is set
        let clipped = false;
        let render = true;
        if (layerState.extent) {
            const layerExtent = (0, $92f1443438429e81$export$494be3a3a25689ca)(layerState.extent, viewState.projection);
            render = (0, $7e819822b33b3d32$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            clipped = render && !(0, $7e819822b33b3d32$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (clipped) this.clipUnrotated(context, frameState, layerExtent);
        }
        const img = image.getImage();
        const transform = (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, scaleX, scaleY, 0, imagePixelRatio * (imageExtent[0] - viewCenter[0]) / imageResolutionX, imagePixelRatio * (viewCenter[1] - imageExtent[3]) / imageResolutionY);
        this.renderedResolution = imageResolutionY * pixelRatio / imagePixelRatio;
        const dw = img.width * transform[0];
        const dh = img.height * transform[3];
        if (!this.getLayer().getSource().getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        if (render && dw >= 0.5 && dh >= 0.5) {
            const dx = transform[4];
            const dy = transform[5];
            const opacity = layerState.opacity;
            if (opacity !== 1) {
                context.save();
                context.globalAlpha = opacity;
            }
            context.drawImage(img, 0, 0, +img.width, +img.height, dx, dy, dw, dh);
            if (opacity !== 1) context.restore();
        }
        this.postRender(this.context, frameState);
        if (clipped) context.restore();
        context.imageSmoothingEnabled = true;
        return this.container;
    }
}
var $2a67941380f9882b$export$2e2bcd8739ae039 = $2a67941380f9882b$var$CanvasImageLayerRenderer;


/**
 * @module ol/layer/BaseImage
 */ /**
 * @module ol/layer/Layer
 */ /**
 * @module ol/View
 */ /**
 * @module ol/Object
 */ /**
 * @module ol/ObjectEventType
 */ /**
 * @enum {string}
 */ var $19100aa5be43a728$export$2e2bcd8739ae039 /**
 * @typedef {'propertychange'} Types
 */  = {
    /**
   * Triggered when a property is changed.
   * @event module:ol/Object.ObjectEvent#propertychange
   * @api
   */ PROPERTYCHANGE: 'propertychange'
};






class $d575b598d09f57d3$export$cf395d7c4a2d5a17 extends (0, $0327f54963b35733$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {string} key The property name.
   * @param {*} oldValue The old value for `key`.
   */ constructor(type, key, oldValue){
        super(type);
        /**
     * The name of the property whose value is changing.
     * @type {string}
     * @api
     */ this.key = key;
        /**
     * The old value. To get the new value use `e.target.get(e.key)` where
     * `e` is the event object.
     * @type {*}
     * @api
     */ this.oldValue = oldValue;
    }
}
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable~Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */ class $d575b598d09f57d3$var$BaseObject extends (0, $5cf0b3202980c59c$export$2e2bcd8739ae039) {
    /**
   * @param {Object<string, *>} [values] An object with key-value pairs.
   */ constructor(values){
        super();
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ObjectOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ObjectOnSignature<void>}
     */ this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        (0, $34772e91e89a736f$export$5e82334337e0f204)(this);
        /**
     * @private
     * @type {Object<string, *>|null}
     */ this.values_ = null;
        if (values !== undefined) this.setProperties(values);
    }
    /**
   * Gets a value.
   * @param {string} key Key name.
   * @return {*} Value.
   * @api
   */ get(key) {
        let value;
        if (this.values_ && this.values_.hasOwnProperty(key)) value = this.values_[key];
        return value;
    }
    /**
   * Get a list of object property names.
   * @return {Array<string>} List of property names.
   * @api
   */ getKeys() {
        return this.values_ && Object.keys(this.values_) || [];
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>} Object.
   * @api
   */ getProperties() {
        return this.values_ && Object.assign({}, this.values_) || {};
    }
    /**
   * Get an object of all property names and values.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.values_;
    }
    /**
   * @return {boolean} The object has properties.
   */ hasProperties() {
        return !!this.values_;
    }
    /**
   * @param {string} key Key name.
   * @param {*} oldValue Old value.
   */ notify(key, oldValue) {
        let eventType;
        eventType = `change:${key}`;
        if (this.hasListener(eventType)) this.dispatchEvent(new $d575b598d09f57d3$export$cf395d7c4a2d5a17(eventType, key, oldValue));
        eventType = (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE;
        if (this.hasListener(eventType)) this.dispatchEvent(new $d575b598d09f57d3$export$cf395d7c4a2d5a17(eventType, key, oldValue));
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ addChangeListener(key, listener) {
        this.addEventListener(`change:${key}`, listener);
    }
    /**
   * @param {string} key Key name.
   * @param {import("./events.js").Listener} listener Listener.
   */ removeChangeListener(key, listener) {
        this.removeEventListener(`change:${key}`, listener);
    }
    /**
   * Sets a value.
   * @param {string} key Key name.
   * @param {*} value Value.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ set(key, value, silent) {
        const values = this.values_ || (this.values_ = {});
        if (silent) values[key] = value;
        else {
            const oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) this.notify(key, oldValue);
        }
    }
    /**
   * Sets a collection of key-value pairs.  Note that this changes any existing
   * properties and adds new ones (it does not remove any existing properties).
   * @param {Object<string, *>} values Values.
   * @param {boolean} [silent] Update without triggering an event.
   * @api
   */ setProperties(values, silent) {
        for(const key in values)this.set(key, values[key], silent);
    }
    /**
   * Apply any properties from another object without triggering events.
   * @param {BaseObject} source The source object.
   * @protected
   */ applyProperties(source) {
        if (!source.values_) return;
        Object.assign(this.values_ || (this.values_ = {}), source.values_);
    }
    /**
   * Unsets a property.
   * @param {string} key Key name.
   * @param {boolean} [silent] Unset without triggering an event.
   * @api
   */ unset(key, silent) {
        if (this.values_ && key in this.values_) {
            const oldValue = this.values_[key];
            delete this.values_[key];
            if ((0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(this.values_)) this.values_ = null;
            if (!silent) this.notify(key, oldValue);
        }
    }
}
var $d575b598d09f57d3$export$2e2bcd8739ae039 = $d575b598d09f57d3$var$BaseObject;



/**
 * @module ol/ViewProperty
 */ /**
 * @enum {string}
 */ var $5f86c3d53c01e8fe$export$2e2bcd8739ae039 = {
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation'
};




/**
 * @module ol/centerconstraint
 */ 
function $6a005ced57043b5f$export$c2f0af2c946f6897(extent, onlyCenter, smooth) {
    return(/**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number|undefined} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */ function(center, resolution, size, isMoving, centerShift) {
        if (!center) return undefined;
        if (!resolution && !onlyCenter) return center;
        const viewWidth = onlyCenter ? 0 : size[0] * resolution;
        const viewHeight = onlyCenter ? 0 : size[1] * resolution;
        const shiftX = centerShift ? centerShift[0] : 0;
        const shiftY = centerShift ? centerShift[1] : 0;
        let minX = extent[0] + viewWidth / 2 + shiftX;
        let maxX = extent[2] - viewWidth / 2 + shiftX;
        let minY = extent[1] + viewHeight / 2 + shiftY;
        let maxY = extent[3] - viewHeight / 2 + shiftY;
        // note: when zooming out of bounds, min and max values for x and y may
        // end up inverted (min > max); this has to be accounted for
        if (minX > maxX) {
            minX = (maxX + minX) / 2;
            maxX = minX;
        }
        if (minY > maxY) {
            minY = (maxY + minY) / 2;
            maxY = minY;
        }
        let x = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(center[0], minX, maxX);
        let y = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(center[1], minY, maxY);
        // during an interaction, allow some overscroll
        if (isMoving && smooth && resolution) {
            const ratio = 30 * resolution;
            x += -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) + ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
            y += -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) + ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
        }
        return [
            x,
            y
        ];
    });
}
function $6a005ced57043b5f$export$f883a24d5edde77c(center) {
    return center;
}



/**
 * @module ol/easing
 */ /**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */ function $0164a93fcf6e65ad$export$929e5a82286172a6(t) {
    return Math.pow(t, 3);
}
function $0164a93fcf6e65ad$export$57636bb43b1ccbb0(t) {
    return 1 - $0164a93fcf6e65ad$export$929e5a82286172a6(1 - t);
}
function $0164a93fcf6e65ad$export$9b47139b511b56e4(t) {
    return 3 * t * t - 2 * t * t * t;
}
function $0164a93fcf6e65ad$export$45db2fc2f15997e7(t) {
    return t;
}
function $0164a93fcf6e65ad$export$7f4472f6708afaf3(t) {
    if (t < 0.5) return $0164a93fcf6e65ad$export$9b47139b511b56e4(2 * t);
    return 1 - $0164a93fcf6e65ad$export$9b47139b511b56e4(2 * (t - 0.5));
}




/**
 * @module ol/geom/Polygon
 */ 



/**
 * @module ol/geom/LinearRing
 */ 
/**
 * @module ol/geom/SimpleGeometry
 */ 

/**
 * @module ol/geom/Geometry
 */ 





/**
 * @module ol/geom/flat/transform
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [dest] Destination.
 * @param {number} [destinationStride] Stride of destination coordinates; if unspecified, assumed to be 2.
 * @return {Array<number>} Transformed coordinates.
 */ function $24a54079104c80a7$export$b92b2dedcfff79de(flatCoordinates, offset, end, stride, transform, dest, destinationStride) {
    dest = dest ? dest : [];
    destinationStride = destinationStride ? destinationStride : 2;
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const x = flatCoordinates[j];
        const y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
        for(let k = 2; k < destinationStride; k++)dest[i++] = flatCoordinates[j + k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $24a54079104c80a7$export$bb628a54ab399bc9(flatCoordinates, offset, end, stride, angle, anchor, dest) {
    dest = dest ? dest : [];
    const cos = Math.cos(angle);
    const sin = Math.sin(angle);
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $24a54079104c80a7$export$dcdf75081b88279d(flatCoordinates, offset, end, stride, sx, sy, anchor, dest) {
    dest = dest ? dest : [];
    const anchorX = anchor[0];
    const anchorY = anchor[1];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        const deltaX = flatCoordinates[j] - anchorX;
        const deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}
function $24a54079104c80a7$export$d73ee8ef04f5226a(flatCoordinates, offset, end, stride, deltaX, deltaY, dest) {
    dest = dest ? dest : [];
    let i = 0;
    for(let j = offset; j < end; j += stride){
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for(let k = j + 2; k < j + stride; ++k)dest[i++] = flatCoordinates[k];
    }
    if (dest && dest.length != i) dest.length = i;
    return dest;
}


/**
 * @typedef {'XY' | 'XYZ' | 'XYM' | 'XYZM'} GeometryLayout
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available.
 */ /**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString' | 'MultiPolygon' | 'GeometryCollection' | 'Circle'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, or `'Circle'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $e9ce7123fdd10994$var$tmpTransform = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
/** @type {import('../coordinate.js').Coordinate} */ const $e9ce7123fdd10994$var$tmpPoint = [
    NaN,
    NaN
];
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */ class $e9ce7123fdd10994$var$Geometry extends (0, $d575b598d09f57d3$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.extentRevision_ = -1;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
     * @protected
     * @type {number}
     */ this.simplifiedGeometryRevision = 0;
        /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} revision The geometry revision.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */ this.simplifyTransformedInternal = (0, $de1052d9f293b73a$export$ff83df6f9971435f)((revision, squaredTolerance, transform)=>{
            if (!transform) return this.getSimplifiedGeometry(squaredTolerance);
            const clone = this.clone();
            clone.applyTransform(transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {Geometry} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, transform);
    }
    /**
   * Make a complete copy of the geometry.
   * @abstract
   * @return {!Geometry} Clone.
   */ clone() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        return this.closestPointXY(x, y, $e9ce7123fdd10994$var$tmpPoint, Number.MIN_VALUE) === 0;
    }
    /**
   * Return the closest point of the geometry to the passed point as
   * {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} point Point.
   * @param {import("../coordinate.js").Coordinate} [closestPoint] Closest point.
   * @return {import("../coordinate.js").Coordinate} Closest point.
   * @api
   */ getClosestPoint(point, closestPoint) {
        closestPoint = closestPoint ? closestPoint : [
            NaN,
            NaN
        ];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    }
    /**
   * Returns true if this geometry includes the specified coordinate. If the
   * coordinate is on the boundary of the geometry, returns false.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {boolean} Contains coordinate.
   * @api
   */ intersectsCoordinate(coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Get the extent of the geometry.
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} extent Extent.
   * @api
   */ getExtent(extent) {
        if (this.extentRevision_ != this.getRevision()) {
            const extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) (0, $7e819822b33b3d32$export$3e2152b047719fa1)(extent);
            this.extentRevision_ = this.getRevision();
        }
        return (0, $7e819822b33b3d32$export$6a4fe494c558c238)(this.extent_, extent);
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   */ scale(sx, sy, anchor) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Create a simplified version of this geometry.  For linestrings, this uses
   * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
   * algorithm.  For polygons, a quantization-based
   * simplification is used to preserve topology.
   * @param {number} tolerance The tolerance distance for simplification.
   * @return {Geometry} A new, simplified version of the original geometry.
   * @api
   */ simplify(tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker
   * algorithm.
   * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
   * @abstract
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Geometry} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Get the type of this geometry.
   * @abstract
   * @return {Type} Geometry type.
   */ getType() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @abstract
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   */ applyTransform(transformFn) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   */ intersectsExtent(extent) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @abstract
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   */ translate(deltaX, deltaY) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Transform each coordinate of the geometry from one coordinate reference
   * system to another. The geometry is modified in place.
   * For example, a line will be transformed to a line and a circle to a circle.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   *
   * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
   *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
   * @return {this} This geometry.  Note that original geometry is
   *     modified in place.
   * @api
   */ transform(source, destination) {
        /** @type {import("../proj/Projection.js").default} */ const sourceProj = (0, $92f1443438429e81$export$3988ae62b71be9a3)(source);
        const transformFn = sourceProj.getUnits() == 'tile-pixels' ? function(inCoordinates, outCoordinates, stride) {
            const pixelExtent = sourceProj.getExtent();
            const projectedExtent = sourceProj.getWorldExtent();
            const scale = (0, $7e819822b33b3d32$export$c08559766941f856)(projectedExtent) / (0, $7e819822b33b3d32$export$c08559766941f856)(pixelExtent);
            (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)($e9ce7123fdd10994$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            const transformed = (0, $24a54079104c80a7$export$b92b2dedcfff79de)(inCoordinates, 0, inCoordinates.length, stride, $e9ce7123fdd10994$var$tmpTransform, outCoordinates);
            const projTransform = (0, $92f1443438429e81$export$fce0c6cfca85ed96)(sourceProj, destination);
            if (projTransform) return projTransform(transformed, transformed, stride);
            return transformed;
        } : (0, $92f1443438429e81$export$fce0c6cfca85ed96)(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    }
}
var $e9ce7123fdd10994$export$2e2bcd8739ae039 = $e9ce7123fdd10994$var$Geometry;



/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */ class $ce25558341ea2841$var$SimpleGeometry extends (0, $e9ce7123fdd10994$export$2e2bcd8739ae039) {
    constructor(){
        super();
        /**
     * @protected
     * @type {import("./Geometry.js").GeometryLayout}
     */ this.layout = 'XY';
        /**
     * @protected
     * @type {number}
     */ this.stride = 2;
        /**
     * @protected
     * @type {Array<number>}
     */ this.flatCoordinates;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $7e819822b33b3d32$export$be0ab0bf96ca59ca)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    }
    /**
   * @abstract
   * @return {Array<*> | null} Coordinates.
   */ getCoordinates() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Return the first coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} First coordinate.
   * @api
   */ getFirstCoordinate() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getFlatCoordinates() {
        return this.flatCoordinates;
    }
    /**
   * Return the last coordinate of the geometry.
   * @return {import("../coordinate.js").Coordinate} Last point.
   * @api
   */ getLastCoordinate() {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    }
    /**
   * Return the {@link import("./Geometry.js").GeometryLayout layout} of the geometry.
   * @return {import("./Geometry.js").GeometryLayout} Layout.
   * @api
   */ getLayout() {
        return this.layout;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        const simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) return simplifiedGeometry;
        // Simplification did not actually remove any coordinates.  We now know
        // that any calls to getSimplifiedGeometry with a squaredTolerance less
        // than or equal to the current squaredTolerance will also not have any
        // effect.  This allows us to short circuit simplification (saving CPU
        // cycles) and prevents the cache of simplified geometries from filling
        // up with useless identical copies of this geometry (saving memory).
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {SimpleGeometry} Simplified geometry.
   * @protected
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        return this;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride;
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout} layout Layout.
   * @param {Array<number>} flatCoordinates Flat coordinates.
   */ setFlatCoordinates(layout, flatCoordinates) {
        this.stride = $ce25558341ea2841$export$6af0c1b4a8549a43(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    }
    /**
   * @abstract
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ setCoordinates(coordinates, layout) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("./Geometry.js").GeometryLayout|undefined} layout Layout.
   * @param {Array<*>} coordinates Coordinates.
   * @param {number} nesting Nesting.
   * @protected
   */ setLayout(layout, coordinates, nesting) {
        let stride;
        if (layout) stride = $ce25558341ea2841$export$6af0c1b4a8549a43(layout);
        else {
            for(let i = 0; i < nesting; ++i){
                if (coordinates.length === 0) {
                    this.layout = 'XY';
                    this.stride = 2;
                    return;
                }
                coordinates = /** @type {Array<unknown>} */ coordinates[0];
            }
            stride = coordinates.length;
            layout = $ce25558341ea2841$export$61bb6938093db2c8(stride);
        }
        this.layout = layout;
        this.stride = stride;
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.layout.startsWith('XYZ') ? 3 : 2, this.stride);
            this.changed();
        }
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $24a54079104c80a7$export$bb628a54ab399bc9)(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (sy === undefined) sy = sx;
        if (!anchor) anchor = (0, $7e819822b33b3d32$export$c91255cadecfe081)(this.getExtent());
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $24a54079104c80a7$export$dcdf75081b88279d)(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            const stride = this.getStride();
            (0, $24a54079104c80a7$export$d73ee8ef04f5226a)(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    }
}
function $ce25558341ea2841$export$61bb6938093db2c8(stride) {
    let layout;
    if (stride == 2) layout = 'XY';
    else if (stride == 3) layout = 'XYZ';
    else if (stride == 4) layout = 'XYZM';
    return /** @type {import("./Geometry.js").GeometryLayout} */ layout;
}
function $ce25558341ea2841$export$6af0c1b4a8549a43(layout) {
    let stride;
    if (layout == 'XY') stride = 2;
    else if (layout == 'XYZ' || layout == 'XYM') stride = 3;
    else if (layout == 'XYZM') stride = 4;
    return /** @type {number} */ stride;
}
function $ce25558341ea2841$export$a3767472617c7861(simpleGeometry, transform, dest) {
    const flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) return null;
    const stride = simpleGeometry.getStride();
    return (0, $24a54079104c80a7$export$b92b2dedcfff79de)(flatCoordinates, 0, flatCoordinates.length, stride, transform, dest);
}
var $ce25558341ea2841$export$2e2bcd8739ae039 = $ce25558341ea2841$var$SimpleGeometry;


/**
 * @module ol/geom/flat/area
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */ function $b024f94ecb74bc8b$export$3c5e1905f889266e(flatCoordinates, offset, end, stride) {
    let twiceArea = 0;
    const x0 = flatCoordinates[end - stride];
    const y0 = flatCoordinates[end - stride + 1];
    let dx1 = 0;
    let dy1 = 0;
    for(; offset < end; offset += stride){
        const dx2 = flatCoordinates[offset] - x0;
        const dy2 = flatCoordinates[offset + 1] - y0;
        twiceArea += dy1 * dx2 - dx1 * dy2;
        dx1 = dx2;
        dy1 = dy2;
    }
    return twiceArea / 2;
}
function $b024f94ecb74bc8b$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride) {
    let area = 0;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        area += $b024f94ecb74bc8b$export$3c5e1905f889266e(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
function $b024f94ecb74bc8b$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    let area = 0;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        area += $b024f94ecb74bc8b$export$7a8ee541dfdf2ed5(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}


/**
 * @module ol/geom/flat/closest
 */ 
/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */ function $bf52e23c2de7bae9$var$assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    const x1 = flatCoordinates[offset1];
    const y1 = flatCoordinates[offset1 + 1];
    const dx = flatCoordinates[offset2] - x1;
    const dy = flatCoordinates[offset2 + 1] - y1;
    let offset;
    if (dx === 0 && dy === 0) offset = offset1;
    else {
        const t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) offset = offset2;
        else if (t > 0) {
            for(let i = 0; i < stride; ++i)closestPoint[i] = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            closestPoint.length = stride;
            return;
        } else offset = offset1;
    }
    for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
    closestPoint.length = stride;
}
function $bf52e23c2de7bae9$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    for(offset += stride; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        const squaredDelta = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x1, y1, x2, y2);
        if (squaredDelta > max) max = squaredDelta;
        x1 = x2;
        y1 = y2;
    }
    return max;
}
function $bf52e23c2de7bae9$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        max = $bf52e23c2de7bae9$export$bc2eb611ddf80103(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
function $bf52e23c2de7bae9$export$37c18e6e7d50501a(flatCoordinates, offset, endss, stride, max) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        max = $bf52e23c2de7bae9$export$fbf31c8f2668ed5a(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
function $bf52e23c2de7bae9$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    if (offset == end) return minSquaredDistance;
    let i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for(i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[offset + i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    let index = offset + stride;
    while(index < end){
        $bf52e23c2de7bae9$var$assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
            index += stride;
        } else // Skip ahead multiple points, because we know that all the skipped
        // points cannot be any closer than the closest point we have found so
        // far.  We know this because we know how close the current point is, how
        // close the closest point we have found so far is, and the maximum
        // distance between consecutive points.  For example, if we're currently
        // at distance 10, the best we've found so far is 3, and that the maximum
        // distance between consecutive points is 2, then we'll need to skip at
        // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
        // finding a closer point.  We use Math.max(..., 1) to ensure that we
        // always advance at least one point, to avoid an infinite loop.
        index += stride * Math.max((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) / maxDelta | 0, 1);
    }
    if (isRing) {
        // Check the closing segment.
        $bf52e23c2de7bae9$var$assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for(i = 0; i < stride; ++i)closestPoint[i] = tmpPoint[i];
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
function $bf52e23c2de7bae9$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        minSquaredDistance = $bf52e23c2de7bae9$export$4adc8e5135fb44c(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
function $bf52e23c2de7bae9$export$60e067685eb8f9c4(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint) {
    tmpPoint = tmpPoint ? tmpPoint : [
        NaN,
        NaN
    ];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        minSquaredDistance = $bf52e23c2de7bae9$export$5a48a0eefcf14992(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}


/**
 * @module ol/geom/flat/deflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */ function $4ae92c9bec373de6$export$60815ead40ec79ab(flatCoordinates, offset, coordinate, stride) {
    for(let i = 0, ii = coordinate.length; i < ii; ++i)flatCoordinates[offset++] = coordinate[i];
    return offset;
}
function $4ae92c9bec373de6$export$5c4daf67e03c190f(flatCoordinates, offset, coordinates, stride) {
    for(let i = 0, ii = coordinates.length; i < ii; ++i){
        const coordinate = coordinates[i];
        for(let j = 0; j < stride; ++j)flatCoordinates[offset++] = coordinate[j];
    }
    return offset;
}
function $4ae92c9bec373de6$export$47c3746a74384d45(flatCoordinates, offset, coordinatess, stride, ends) {
    ends = ends ? ends : [];
    let i = 0;
    for(let j = 0, jj = coordinatess.length; j < jj; ++j){
        const end = $4ae92c9bec373de6$export$5c4daf67e03c190f(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
function $4ae92c9bec373de6$export$f9f2bb59da4accd3(flatCoordinates, offset, coordinatesss, stride, endss) {
    endss = endss ? endss : [];
    let i = 0;
    for(let j = 0, jj = coordinatesss.length; j < jj; ++j){
        const ends = $4ae92c9bec373de6$export$47c3746a74384d45(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        if (ends.length === 0) ends[0] = offset;
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}


/**
 * @module ol/geom/flat/inflate
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */ function $76a969a6125a5a4a$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinates) {
    coordinates = coordinates !== undefined ? coordinates : [];
    let i = 0;
    for(let j = offset; j < end; j += stride)coordinates[i++] = flatCoordinates.slice(j, j + stride);
    coordinates.length = i;
    return coordinates;
}
function $76a969a6125a5a4a$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatess) {
    coordinatess = coordinatess !== undefined ? coordinatess : [];
    let i = 0;
    for(let j = 0, jj = ends.length; j < jj; ++j){
        const end = ends[j];
        coordinatess[i++] = $76a969a6125a5a4a$export$9c0934e4e9c3f61e(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
function $76a969a6125a5a4a$export$915c7058aeb4dfeb(flatCoordinates, offset, endss, stride, coordinatesss) {
    coordinatesss = coordinatesss !== undefined ? coordinatesss : [];
    let i = 0;
    for(let j = 0, jj = endss.length; j < jj; ++j){
        const ends = endss[j];
        coordinatesss[i++] = ends.length === 1 && ends[0] === offset ? [] : $76a969a6125a5a4a$export$cbb9596fc0f40db2(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}


/**
 * @module ol/geom/flat/simplify
 */ // Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

function $ab8844daaf207c08$export$2cbbcce9030b8734(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, simplifiedFlatCoordinates) {
    simplifiedFlatCoordinates = simplifiedFlatCoordinates !== undefined ? simplifiedFlatCoordinates : [];
    if (!highQuality) {
        end = $ab8844daaf207c08$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = $ab8844daaf207c08$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
function $ab8844daaf207c08$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    const n = (end - offset) / stride;
    if (n < 3) {
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */ const markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */ const stack = [
        offset,
        end - stride
    ];
    let index = 0;
    while(stack.length > 0){
        const last = stack.pop();
        const first = stack.pop();
        let maxSquaredDistance = 0;
        const x1 = flatCoordinates[first];
        const y1 = flatCoordinates[first + 1];
        const x2 = flatCoordinates[last];
        const y2 = flatCoordinates[last + 1];
        for(let i = first + stride; i < last; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            const squaredDistance = (0, $d4e56cfc37d8b1f9$export$251bb0a9cef172e6)(x, y, x1, y1, x2, y2);
            if (squaredDistance > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) stack.push(first, index);
            if (index + stride < last) stack.push(index, last);
        }
    }
    for(let i = 0; i < n; ++i)if (markers[i]) {
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride];
        simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + i * stride + 1];
    }
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $ab8844daaf207c08$export$ef693d1572e64fb8(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$5d74fb54bb752ea0(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $ab8844daaf207c08$export$cedb9900c0b225c2(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$46dba205a0107e9e(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for(; offset < end; offset += stride){
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    let x2 = x1;
    let y2 = y1;
    for(offset += stride; offset < end; offset += stride){
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if ((0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$51a0620f7a28532b(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
function $ab8844daaf207c08$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) return simplifiedOffset;
    // snap the first coordinate (P1)
    let x1 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
    let y1 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    let x2, y2;
    do {
        x2 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        y2 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    }while (x2 == x1 && y2 == y1);
    while(offset < end){
        // snap the next coordinate (P3)
        const x3 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset], tolerance);
        const y3 = $ab8844daaf207c08$export$51a0620f7a28532b(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) continue;
        // calculate the delta between P1 and P2
        const dx1 = x2 - x1;
        const dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        const dx2 = x3 - x1;
        const dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 && (dx1 < 0 && dx2 < dx1 || dx1 == dx2 || dx1 > 0 && dx2 > dx1) && (dy1 < 0 && dy2 < dy1 || dy1 == dy2 || dy1 > 0 && dy2 > dy1)) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        simplifiedOffset = $ab8844daaf207c08$export$b84e8d2c4920a0c6(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
function $ab8844daaf207c08$export$b9acf67ef05cd17c(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedOffset = $ab8844daaf207c08$export$60a9904b67f8d51b(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}


/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */ class $d4b07f96c637c824$var$LinearRing extends (0, $ce25558341ea2841$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LinearRing} Clone.
   * @api
   * @override
   */ clone() {
        return new $d4b07f96c637c824$var$LinearRing(this.flatCoordinates.slice(), this.layout);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf52e23c2de7bae9$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf52e23c2de7bae9$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Return the area of the linear ring on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $b024f94ecb74bc8b$export$3c5e1905f889266e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinates of the linear ring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LinearRing} Simplified LinearRing.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $d4b07f96c637c824$var$LinearRing(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LinearRing';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return false;
    }
    /**
   * Set the coordinates of the linear ring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $4ae92c9bec373de6$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $d4b07f96c637c824$export$2e2bcd8739ae039 = $d4b07f96c637c824$var$LinearRing;


/**
 * @module ol/geom/Point
 */ 



/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */ class $f7e297e9f8b90024$var$Point extends (0, $ce25558341ea2841$export$2e2bcd8739ae039) {
    /**
   * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        this.setCoordinates(coordinates, layout);
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Point} Clone.
   * @api
   * @override
   */ clone() {
        const point = new $f7e297e9f8b90024$var$Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const squaredDistance = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            const stride = this.stride;
            for(let i = 0; i < stride; ++i)closestPoint[i] = flatCoordinates[i];
            closestPoint.length = stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinate of the point.
   * @return {import("../coordinate.js").Coordinate} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return this.flatCoordinates.slice();
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        return (0, $7e819822b33b3d32$export$4838bf78d04a9440)(this.flatCoordinates, extent);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Point';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $7e819822b33b3d32$export$805bdfd6d6690e97)(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    }
    /**
   * @param {!Array<*>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $4ae92c9bec373de6$export$60815ead40ec79ab)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $f7e297e9f8b90024$export$2e2bcd8739ae039 = $f7e297e9f8b90024$var$Point;





/**
 * @module ol/geom/flat/contains
 */ 
function $a614d7cd6ef0f487$export$cedabedc7ac0e138(flatCoordinates, offset, end, stride, extent) {
    const outside = (0, $7e819822b33b3d32$export$f9ed8a3d123a08e2)(extent, /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */ function(coordinate) {
        return !$a614d7cd6ef0f487$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
function $a614d7cd6ef0f487$export$949a7a3a4b6f34fa(flatCoordinates, offset, end, stride, x, y) {
    // https://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    let wn = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) wn++;
        } else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) wn--;
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
function $a614d7cd6ef0f487$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) return false;
    if (!$a614d7cd6ef0f487$export$949a7a3a4b6f34fa(flatCoordinates, offset, ends[0], stride, x, y)) return false;
    for(let i = 1, ii = ends.length; i < ii; ++i){
        if ($a614d7cd6ef0f487$export$949a7a3a4b6f34fa(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) return false;
    }
    return true;
}
function $a614d7cd6ef0f487$export$c760d9d16cf92043(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) return false;
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($a614d7cd6ef0f487$export$ae868c0f6acc3355(flatCoordinates, offset, ends, stride, x, y)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}




/**
 * @module ol/geom/flat/interiorpoint
 */ 

function $197384c2130f50ad$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, dest) {
    let i, ii, x, x1, x2, y1, y2;
    const y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */ const intersections = [];
    // Calculate intersections with the horizontal line
    for(let r = 0, rr = ends.length; r < rr; ++r){
        const end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for(i = offset; i < end; i += stride){
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if (y <= y1 && y2 <= y || y1 <= y && y <= y2) {
                x = (y - y1) / (y2 - y1) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    let pointX = NaN;
    let maxSegmentLength = -Infinity;
    intersections.sort((0, $830d23b8323fc080$export$fcb633242ef15540));
    x1 = intersections[0];
    for(i = 1, ii = intersections.length; i < ii; ++i){
        x2 = intersections[i];
        const segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if ((0, $a614d7cd6ef0f487$export$ae868c0f6acc3355)(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) // There is no horizontal line that has its center point inside the linear
    // ring.  Use the center of the the linear ring's extent.
    pointX = flatCenters[flatCentersOffset];
    if (dest) {
        dest.push(pointX, y, maxSegmentLength);
        return dest;
    }
    return [
        pointX,
        y,
        maxSegmentLength
    ];
}
function $197384c2130f50ad$export$11463803eda8a372(flatCoordinates, offset, endss, stride, flatCenters) {
    /** @type {Array<number>} */ let interiorPoints = [];
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        interiorPoints = $197384c2130f50ad$export$50e3b25928a5e892(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}


/**
 * @module ol/geom/flat/intersectsextent
 */ 

/**
 * @module ol/geom/flat/segments
 */ /**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */ function $d3093947f1b30e1e$export$4b80e395e36b5a56(flatCoordinates, offset, end, stride, callback) {
    let ret;
    offset += stride;
    for(; offset < end; offset += stride){
        ret = callback(flatCoordinates.slice(offset - stride, offset), flatCoordinates.slice(offset, offset + stride));
        if (ret) return ret;
    }
    return false;
}


function $96949d2e503054c4$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent, coordinatesExtent) {
    coordinatesExtent = coordinatesExtent ?? (0, $7e819822b33b3d32$export$30570204156ffd18)((0, $7e819822b33b3d32$export$fe201bb3bbe031e9)(), flatCoordinates, offset, end, stride);
    if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(extent, coordinatesExtent)) return false;
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2] || coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) return true;
    return (0, $d3093947f1b30e1e$export$4b80e395e36b5a56)(flatCoordinates, offset, end, stride, /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */ function(point1, point2) {
        return (0, $7e819822b33b3d32$export$a6a5a7a461419425)(extent, point1, point2);
    });
}
function $96949d2e503054c4$export$fdb1d8e850bf7937(flatCoordinates, offset, ends, stride, extent) {
    for(let i = 0, ii = ends.length; i < ii; ++i){
        if ($96949d2e503054c4$export$40d8d71841a3d779(flatCoordinates, offset, ends[i], stride, extent)) return true;
        offset = ends[i];
    }
    return false;
}
function $96949d2e503054c4$export$830a0dafbb2ef1c5(flatCoordinates, offset, end, stride, extent) {
    if ($96949d2e503054c4$export$40d8d71841a3d779(flatCoordinates, offset, end, stride, extent)) return true;
    if ((0, $a614d7cd6ef0f487$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[1])) return true;
    if ((0, $a614d7cd6ef0f487$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[0], extent[3])) return true;
    if ((0, $a614d7cd6ef0f487$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[1])) return true;
    if ((0, $a614d7cd6ef0f487$export$949a7a3a4b6f34fa)(flatCoordinates, offset, end, stride, extent[2], extent[3])) return true;
    return false;
}
function $96949d2e503054c4$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent) {
    if (!$96949d2e503054c4$export$830a0dafbb2ef1c5(flatCoordinates, offset, ends[0], stride, extent)) return false;
    if (ends.length === 1) return true;
    for(let i = 1, ii = ends.length; i < ii; ++i)if ((0, $a614d7cd6ef0f487$export$cedabedc7ac0e138)(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
        if (!$96949d2e503054c4$export$40d8d71841a3d779(flatCoordinates, ends[i - 1], ends[i], stride, extent)) return false;
    }
    return true;
}
function $96949d2e503054c4$export$77b72fa3792f5bf0(flatCoordinates, offset, endss, stride, extent) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if ($96949d2e503054c4$export$76dcd8f8f83b6ddb(flatCoordinates, offset, ends, stride, extent)) return true;
        offset = ends[ends.length - 1];
    }
    return false;
}


/**
 * @module ol/geom/flat/orient
 */ /**
 * @module ol/geom/flat/reverse
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */ function $3f20011cf27b19b1$export$741858880c96b18c(flatCoordinates, offset, end, stride) {
    while(offset < end - stride){
        for(let i = 0; i < stride; ++i){
            const tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}


function $c8291834a008fd82$export$318f2842ed17e094(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    let edge = 0;
    let x1 = flatCoordinates[end - stride];
    let y1 = flatCoordinates[end - stride + 1];
    for(; offset < end; offset += stride){
        const x2 = flatCoordinates[offset];
        const y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
function $c8291834a008fd82$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $c8291834a008fd82$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if (right && isClockwise || !right && !isClockwise) return false;
        } else {
            if (right && !isClockwise || !right && isClockwise) return false;
        }
        offset = end;
    }
    return true;
}
function $c8291834a008fd82$export$a1d138f4bd85f4b4(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        if (!$c8291834a008fd82$export$f27cd06e85f4ba28(flatCoordinates, offset, ends, stride, right)) return false;
        if (ends.length) offset = ends[ends.length - 1];
    }
    return true;
}
function $c8291834a008fd82$export$b71b604ddfc778c7(flatCoordinates, offset, ends, stride, right) {
    right = right !== undefined ? right : false;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        const isClockwise = $c8291834a008fd82$export$318f2842ed17e094(flatCoordinates, offset, end, stride);
        const reverse = i === 0 ? right && isClockwise || !right && !isClockwise : right && !isClockwise || !right && isClockwise;
        if (reverse) (0, $3f20011cf27b19b1$export$741858880c96b18c)(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return offset;
}
function $c8291834a008fd82$export$ea9ed55fc2a85010(flatCoordinates, offset, endss, stride, right) {
    for(let i = 0, ii = endss.length; i < ii; ++i)offset = $c8291834a008fd82$export$b71b604ddfc778c7(flatCoordinates, offset, endss[i], stride, right);
    return offset;
}
function $c8291834a008fd82$export$cb72ae403d6e78e6(flatCoordinates, ends) {
    const endss = [];
    let offset = 0;
    let prevEndIndex = 0;
    let startOrientation;
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        // classifies an array of rings into polygons with outer rings and holes
        const orientation = $c8291834a008fd82$export$318f2842ed17e094(flatCoordinates, offset, end, 2);
        if (startOrientation === undefined) startOrientation = orientation;
        if (orientation === startOrientation) endss.push(ends.slice(prevEndIndex, i + 1));
        else {
            if (endss.length === 0) continue;
            endss[endss.length - 1].push(ends[prevEndIndex]);
        }
        prevEndIndex = i + 1;
        offset = end;
    }
    return endss;
}



/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */ class $46a66e0f2fc72479$var$Polygon extends (0, $ce25558341ea2841$export$2e2bcd8739ae039) {
    /**
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
   *     Array of linear rings that define the polygon. The first linear ring of the
   *     array defines the outer-boundary or surface of the polygon. Each subsequent
   *     linear ring defines a hole in the surface of the polygon. A linear ring is
   *     an array of vertices' coordinates where the first coordinate and the last are
   *     equivalent. (For internal use, flat coordinates in combination with
   *     `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Ends (for internal use with flat coordinates).
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointRevision_ = -1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatInteriorPoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
    }
    /**
   * Append the passed linear ring to this polygon.
   * @param {LinearRing} linearRing Linear ring.
   * @api
   */ appendLinearRing(linearRing) {
        if (!this.flatCoordinates) this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        else (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatCoordinates, linearRing.getFlatCoordinates());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Polygon} Clone.
   * @api
   * @override
   */ clone() {
        const polygon = new $46a66e0f2fc72479$var$Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf52e23c2de7bae9$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf52e23c2de7bae9$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $a614d7cd6ef0f487$export$ae868c0f6acc3355)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    }
    /**
   * Return the area of the polygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $b024f94ecb74bc8b$export$7a8ee541dfdf2ed5)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $c8291834a008fd82$export$b71b604ddfc778c7)(flatCoordinates, 0, this.ends_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $76a969a6125a5a4a$export$cbb9596fc0f40db2)(flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * @return {Array<number>} Interior point.
   */ getFlatInteriorPoint() {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            const flatCenter = (0, $7e819822b33b3d32$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoint_ = (0, $197384c2130f50ad$export$50e3b25928a5e892)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return /** @type {import("../coordinate.js").Coordinate} */ this.flatInteriorPoint_;
    }
    /**
   * Return an interior point of the polygon.
   * @return {Point} Interior point as XYM coordinate, where M is the
   * length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoint() {
        return new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)(this.getFlatInteriorPoint(), 'XYM');
    }
    /**
   * Return the number of rings of the polygon,  this includes the exterior
   * ring and any interior rings.
   *
   * @return {number} Number of rings.
   * @api
   */ getLinearRingCount() {
        return this.ends_.length;
    }
    /**
   * Return the Nth linear ring of the polygon geometry. Return `null` if the
   * given index is out of range.
   * The exterior linear ring is available at index `0` and the interior rings
   * at index `1` and beyond.
   *
   * @param {number} index Index.
   * @return {LinearRing|null} Linear ring.
   * @api
   */ getLinearRing(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $d4b07f96c637c824$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linear rings of the polygon.
   * @return {Array<LinearRing>} Linear rings.
   * @api
   */ getLinearRings() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const linearRings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const linearRing = new (0, $d4b07f96c637c824$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $c8291834a008fd82$export$f27cd06e85f4ba28)(flatCoordinates, 0, this.ends_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $c8291834a008fd82$export$b71b604ddfc778c7)(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {Polygon} Simplified Polygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$60a9904b67f8d51b)(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $46a66e0f2fc72479$var$Polygon(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Polygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $96949d2e503054c4$export$76dcd8f8f83b6ddb)(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the polygon.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $4ae92c9bec373de6$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $46a66e0f2fc72479$export$2e2bcd8739ae039 = $46a66e0f2fc72479$var$Polygon;
function $46a66e0f2fc72479$export$f99d756c6d81ae3f(center, radius, n, sphereRadius) {
    n = n ? n : 32;
    /** @type {Array<number>} */ const flatCoordinates = [];
    for(let i = 0; i < n; ++i)(0, $830d23b8323fc080$export$8b58be045bf06082)(flatCoordinates, (0, $0e7893c26680b018$export$cc800923e997bb8)(center, radius, 2 * Math.PI * i / n, sphereRadius));
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new $46a66e0f2fc72479$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $46a66e0f2fc72479$export$c16b671815801c75(extent) {
    if ((0, $7e819822b33b3d32$export$dd1bc94b04021eeb)(extent)) throw new Error('Cannot create polygon from empty extent');
    const minX = extent[0];
    const minY = extent[1];
    const maxX = extent[2];
    const maxY = extent[3];
    const flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY
    ];
    return new $46a66e0f2fc72479$var$Polygon(flatCoordinates, 'XY', [
        flatCoordinates.length
    ]);
}
function $46a66e0f2fc72479$export$2451009d645fb8c2(circle, sides, angle) {
    sides = sides ? sides : 32;
    const stride = circle.getStride();
    const layout = circle.getLayout();
    const center = circle.getCenter();
    const arrayLength = stride * (sides + 1);
    const flatCoordinates = new Array(arrayLength);
    for(let i = 0; i < arrayLength; i += stride){
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for(let j = 2; j < stride; j++)flatCoordinates[i + j] = center[j];
    }
    const ends = [
        flatCoordinates.length
    ];
    const polygon = new $46a66e0f2fc72479$var$Polygon(flatCoordinates, layout, ends);
    $46a66e0f2fc72479$export$87d6a1539a56e47f(polygon, center, circle.getRadius(), angle);
    return polygon;
}
function $46a66e0f2fc72479$export$87d6a1539a56e47f(polygon, center, radius, angle) {
    const flatCoordinates = polygon.getFlatCoordinates();
    const stride = polygon.getStride();
    const sides = flatCoordinates.length / stride - 1;
    const startAngle = angle ? angle : 0;
    for(let i = 0; i <= sides; ++i){
        const offset = i * stride;
        const angle = startAngle + (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(i, sides) * 2 * Math.PI / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}




/**
 * @module ol/resolutionconstraint
 */ 


/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */ /**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */ function $fc7552e588d344e0$var$getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    const xResolution = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(maxExtent) / viewportSize[0];
    const yResolution = (0, $7e819822b33b3d32$export$c08559766941f856)(maxExtent) / viewportSize[1];
    if (showFullExtent) return Math.min(resolution, Math.max(xResolution, yResolution));
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */ function $fc7552e588d344e0$var$getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    let result = Math.min(resolution, maxResolution);
    const ratio = 50;
    result *= Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio + 1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /= Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) / ratio + 1;
    }
    return (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(result, minResolution / 2, maxResolution * 2);
}
function $fc7552e588d344e0$export$d65a517690fc4385(resolutions, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const maxResolution = resolutions[0];
            const minResolution = resolutions[resolutions.length - 1];
            const cappedMaxRes = maxExtent ? $fc7552e588d344e0$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $fc7552e588d344e0$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const capped = Math.min(cappedMaxRes, resolution);
            const z = Math.floor((0, $830d23b8323fc080$export$8a3786cc03fdb777)(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) return resolutions[z + 1];
            return resolutions[z];
        }
        return undefined;
    });
}
function $fc7552e588d344e0$export$22ac0f6b219de91a(power, maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    minResolution = minResolution !== undefined ? minResolution : 0;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $fc7552e588d344e0$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            // during interacting or animating, allow intermediary values
            if (isMoving) {
                if (!smooth) return (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
                return $fc7552e588d344e0$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            const tolerance = 1e-9;
            const minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            const offset = -direction * (0.5 - tolerance) + 0.5;
            const capped = Math.min(cappedMaxRes, resolution);
            const cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            const zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            const newResolution = maxResolution / Math.pow(power, zoomLevel);
            return (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(newResolution, minResolution, cappedMaxRes);
        }
        return undefined;
    });
}
function $fc7552e588d344e0$export$1c4e6da9b4b066fe(maxResolution, minResolution, smooth, maxExtent, showFullExtent) {
    smooth = smooth !== undefined ? smooth : true;
    return(/**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */ function(resolution, direction, size, isMoving) {
        if (resolution !== undefined) {
            const cappedMaxRes = maxExtent ? $fc7552e588d344e0$var$getViewportClampedResolution(maxResolution, maxExtent, size, showFullExtent) : maxResolution;
            if (!smooth || !isMoving) return (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(resolution, minResolution, cappedMaxRes);
            return $fc7552e588d344e0$var$getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        return undefined;
    });
}


/**
 * @module ol/rotationconstraint
 */ 
function $ea3e0fdf428207b8$export$e20fbacbb41798b(rotation) {
    if (rotation !== undefined) return 0;
    return undefined;
}
function $ea3e0fdf428207b8$export$f883a24d5edde77c(rotation) {
    if (rotation !== undefined) return rotation;
    return undefined;
}
function $ea3e0fdf428207b8$export$9ba78806de831083(n) {
    const theta = 2 * Math.PI / n;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving) return rotation;
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        return undefined;
    });
}
function $ea3e0fdf428207b8$export$17a6e6f3448b17e8(tolerance) {
    const t = tolerance === undefined ? (0, $d4e56cfc37d8b1f9$export$cba01ba138429a1d)(5) : tolerance;
    return(/**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */ function(rotation, isMoving) {
        if (isMoving || rotation === undefined) return rotation;
        if (Math.abs(rotation) <= t) return 0;
        return rotation;
    });
}


/**
 * @module ol/tilegrid/common
 */ /**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */ const $9a8010a8337e7cef$export$e98a216cdcc847dc = 42;
const $9a8010a8337e7cef$export$6b8cb5cd370bd90c = 256;


/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */ /**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */ /**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to
 * fit the extent into. Defaults to the size of the map the view is associated with.
 * If no map or multiple maps are connected to the view, provide the desired box size
 * (e.g. `map.getSize()`).
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */ /**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */ /**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */ /**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center (in view projection coordinates).
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {import("./coordinate.js").Coordinate} [nextCenter] The next center during an animation series.
 * @property {number} [nextResolution] The next resolution during an animation series.
 * @property {number} [nextRotation] The next rotation during an animation series.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */ /**
 * Like {@link import("./Map.js").FrameState}, but just `viewState` and `extent`.
 * @typedef {Object} ViewStateLayerStateExtent
 * @property {State} viewState View state.
 * @property {import("./extent.js").Extent} extent Extent (in user projection coordinates).
 * @property {Array<import("./layer/Layer.js").State>} [layerStatesArray] Layer states.
 */ /**
 * Default min zoom level for the map view.
 * @type {number}
 */ const $3192ea72f934a3fd$var$DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */ /**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Web Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 */ class $3192ea72f934a3fd$var$View extends (0, $d575b598d09f57d3$export$2e2bcd8739ae039) {
    /**
   * @param {ViewOptions} [options] View options.
   */ constructor(options){
        super();
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {ViewOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {ViewOnSignature<void>}
     */ this.un;
        options = Object.assign({}, options);
        /**
     * @private
     * @type {Array<number>}
     */ this.hints_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {Array<Array<Animation>>}
     */ this.animations_ = [];
        /**
     * @private
     * @type {number|undefined}
     */ this.updateAnimationKey_;
        /**
     * @private
     * @const
     * @type {import("./proj/Projection.js").default}
     */ this.projection_ = (0, $92f1443438429e81$export$549167224996a0fb)(options.projection, 'EPSG:3857');
        /**
     * @private
     * @type {import("./size.js").Size}
     */ this.viewportSize_ = [
            100,
            100
        ];
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.targetCenter_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetResolution_;
        /**
     * @private
     * @type {number|undefined}
     */ this.targetRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate}
     */ this.nextCenter_ = null;
        /**
     * @private
     * @type {number}
     */ this.nextResolution_;
        /**
     * @private
     * @type {number}
     */ this.nextRotation_;
        /**
     * @private
     * @type {import("./coordinate.js").Coordinate|undefined}
     */ this.cancelAnchor_ = undefined;
        if (options.projection) (0, $92f1443438429e81$export$ed949affbc7c4223)();
        if (options.center) options.center = (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(options.center, this.projection_);
        if (options.extent) options.extent = (0, $92f1443438429e81$export$494be3a3a25689ca)(options.extent, this.projection_);
        this.applyOptions_(options);
    }
    /**
   * Set up the view with the given options.
   * @param {ViewOptions} options View options.
   */ applyOptions_(options) {
        const properties = Object.assign({}, options);
        for(const key in 0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039)delete properties[key];
        this.setProperties(properties, true);
        const resolutionConstraintInfo = $3192ea72f934a3fd$export$c68d65f9148da196(options);
        /**
     * @private
     * @type {number}
     */ this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
     * @private
     * @type {number}
     */ this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
     * @private
     * @type {number}
     */ this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
     * @private
     * @type {Array<number>|undefined}
     */ this.resolutions_ = options.resolutions;
        /**
     * @type {Array<number>|undefined}
     * @private
     */ this.padding_ = options.padding;
        /**
     * @private
     * @type {number}
     */ this.minZoom_ = resolutionConstraintInfo.minZoom;
        const centerConstraint = $3192ea72f934a3fd$export$964345001ee9ac52(options);
        const resolutionConstraint = resolutionConstraintInfo.constraint;
        const rotationConstraint = $3192ea72f934a3fd$export$4eeaa08dd550e3c0(options);
        /**
     * @private
     * @type {Constraints}
     */ this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) this.setResolution(options.resolution);
        else if (options.zoom !== undefined) this.setZoom(options.zoom);
    }
    /**
   * Padding (in css pixels).
   * If the map viewport is partially covered with other content (overlays) along
   * its edges, this setting allows to shift the center of the viewport away from that
   * content. The order of the values in the array is top, right, bottom, left.
   * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
   * @type {Array<number>|undefined}
   * @api
   */ get padding() {
        return this.padding_;
    }
    set padding(padding) {
        let oldPadding = this.padding_;
        this.padding_ = padding;
        const center = this.getCenterInternal();
        if (center) {
            const newPadding = padding || [
                0,
                0,
                0,
                0
            ];
            oldPadding = oldPadding || [
                0,
                0,
                0,
                0
            ];
            const resolution = this.getResolution();
            const offsetX = resolution / 2 * (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
            const offsetY = resolution / 2 * (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
            this.setCenterInternal([
                center[0] + offsetX,
                center[1] - offsetY
            ]);
        }
    }
    /**
   * Get an updated version of the view options used to construct the view.  The
   * current resolution (or zoom), center, and rotation are applied to any stored
   * options.  The provided options can be used to apply new min/max zoom or
   * resolution limits.
   * @param {ViewOptions} newOptions New options to be applied.
   * @return {ViewOptions} New options updated with the current view state.
   */ getUpdatedOptions_(newOptions) {
        const options = this.getProperties();
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) options.resolution = this.getResolution();
        else options.zoom = this.getZoom();
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object.assign({}, options, newOptions);
    }
    /**
   * Animate the view.  The view's center, zoom (or resolution), and rotation
   * can be animated for smooth transitions between view states.  For example,
   * to animate the view to a new zoom level:
   *
   *     view.animate({zoom: view.getZoom() + 1});
   *
   * By default, the animation lasts one second and uses in-and-out easing.  You
   * can customize this behavior by including `duration` (in milliseconds) and
   * `easing` options (see {@link module:ol/easing}).
   *
   * To chain together multiple animations, call the method with multiple
   * animation objects.  For example, to first zoom and then pan:
   *
   *     view.animate({zoom: 10}, {center: [0, 0]});
   *
   * If you provide a function as the last argument to the animate method, it
   * will get called at the end of an animation series.  The callback will be
   * called with `true` if the animation series completed on its own or `false`
   * if it was cancelled.
   *
   * Animations are cancelled by user interactions (e.g. dragging the map) or by
   * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
   * (or another method that calls one of these).
   *
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
   *     options.  Multiple animations can be run in series by passing multiple
   *     options objects.  To run multiple animations in parallel, call the method
   *     multiple times.  An optional callback can be provided as a final
   *     argument.  The callback will be called with a boolean indicating whether
   *     the animation completed without being cancelled.
   * @api
   */ animate(var_args) {
        if (this.isDef() && !this.getAnimating()) this.resolveConstraints(0);
        const args = new Array(arguments.length);
        for(let i = 0; i < args.length; ++i){
            let options = arguments[i];
            if (options.center) {
                options = Object.assign({}, options);
                options.center = (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object.assign({}, options);
                options.anchor = (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    }
    /**
   * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
   */ animateInternal(var_args) {
        let animationCount = arguments.length;
        let callback;
        if (animationCount > 1 && typeof arguments[animationCount - 1] === 'function') {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        let i = 0;
        for(; i < animationCount && !this.isDef(); ++i){
            // if view properties are not yet set, shortcut to the final state
            const state = arguments[i];
            if (state.center) this.setCenterInternal(state.center);
            if (state.zoom !== undefined) this.setZoom(state.zoom);
            else if (state.resolution) this.setResolution(state.resolution);
            if (state.rotation !== undefined) this.setRotation(state.rotation);
        }
        if (i === animationCount) {
            if (callback) $3192ea72f934a3fd$var$animationCallback(callback, true);
            return;
        }
        let start = Date.now();
        let center = this.targetCenter_.slice();
        let resolution = this.targetResolution_;
        let rotation = this.targetRotation_;
        const series = [];
        for(; i < animationCount; ++i){
            const options = /** @type {AnimationOptions} */ arguments[i];
            const animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || (0, $0164a93fcf6e65ad$export$9b47139b511b56e4),
                callback: callback
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            } else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                const delta = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if ($3192ea72f934a3fd$export$ee75376562060184(animation)) animation.complete = true;
            else start += animation.duration;
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING, 1);
        this.updateAnimations_();
    }
    /**
   * Determine if the view is being animated.
   * @return {boolean} The view is being animated.
   * @api
   */ getAnimating() {
        return this.hints_[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] > 0;
    }
    /**
   * Determine if the user is interacting with the view, such as panning or zooming.
   * @return {boolean} The view is being interacted with.
   * @api
   */ getInteracting() {
        return this.hints_[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING] > 0;
    }
    /**
   * Cancel any ongoing animations.
   * @api
   */ cancelAnimations() {
        this.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING, -this.hints_[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING]);
        let anchor;
        for(let i = 0, ii = this.animations_.length; i < ii; ++i){
            const series = this.animations_[i];
            if (series[0].callback) $3192ea72f934a3fd$var$animationCallback(series[0].callback, false);
            if (!anchor) for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (!animation.complete) {
                    anchor = animation.anchor;
                    break;
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
        this.nextCenter_ = null;
        this.nextResolution_ = NaN;
        this.nextRotation_ = NaN;
    }
    /**
   * Update all animations.
   */ updateAnimations_() {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) return;
        const now = Date.now();
        let more = false;
        for(let i = this.animations_.length - 1; i >= 0; --i){
            const series = this.animations_[i];
            let seriesComplete = true;
            for(let j = 0, jj = series.length; j < jj; ++j){
                const animation = series[j];
                if (animation.complete) continue;
                const elapsed = now - animation.start;
                let fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                } else seriesComplete = false;
                const progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    const x0 = animation.sourceCenter[0];
                    const y0 = animation.sourceCenter[1];
                    const x1 = animation.targetCenter[0];
                    const y1 = animation.targetCenter[1];
                    this.nextCenter_ = animation.targetCenter;
                    const x = x0 + progress * (x1 - x0);
                    const y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [
                        x,
                        y
                    ];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    const resolution = progress === 1 ? animation.targetResolution : animation.sourceResolution + progress * (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        const size = this.getViewportSize_(this.getRotation());
                        const constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.nextResolution_ = animation.targetResolution;
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined && animation.targetRotation !== undefined) {
                    const rotation = progress === 1 ? (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(animation.targetRotation + Math.PI, 2 * Math.PI) - Math.PI : animation.sourceRotation + progress * (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        const constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.nextRotation_ = animation.targetRotation;
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) break;
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING, -1);
                this.nextCenter_ = null;
                this.nextResolution_ = NaN;
                this.nextRotation_ = NaN;
                const callback = series[0].callback;
                if (callback) $3192ea72f934a3fd$var$animationCallback(callback, true);
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
    }
    /**
   * @param {number} rotation Target rotation.
   * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
   */ calculateCenterRotate(rotation, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [
                currentCenter[0] - anchor[0],
                currentCenter[1] - anchor[1]
            ];
            (0, $8b28786758450fff$export$bb628a54ab399bc9)(center, rotation - this.getRotation());
            (0, $8b28786758450fff$export$e16d8520af44a096)(center, anchor);
        }
        return center;
    }
    /**
   * @param {number} resolution Target resolution.
   * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
   * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
   */ calculateCenterZoom(resolution, anchor) {
        let center;
        const currentCenter = this.getCenterInternal();
        const currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            const x = anchor[0] - resolution * (anchor[0] - currentCenter[0]) / currentResolution;
            const y = anchor[1] - resolution * (anchor[1] - currentCenter[1]) / currentResolution;
            center = [
                x,
                y
            ];
        }
        return center;
    }
    /**
   * Returns the current viewport size.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
   */ getViewportSize_(rotation) {
        const size = this.viewportSize_;
        if (rotation) {
            const w = size[0];
            const h = size[1];
            return [
                Math.abs(w * Math.cos(rotation)) + Math.abs(h * Math.sin(rotation)),
                Math.abs(w * Math.sin(rotation)) + Math.abs(h * Math.cos(rotation))
            ];
        }
        return size;
    }
    /**
   * Stores the viewport size on the view. The viewport size is not read every time from the DOM
   * to avoid performance hit and layout reflow.
   * This should be done on map size change.
   * Note: the constraints are not resolved during an animation to avoid stopping it
   * @param {import("./size.js").Size} [size] Viewport size; if undefined, [100, 100] is assumed
   */ setViewportSize(size) {
        this.viewportSize_ = Array.isArray(size) ? size.slice() : [
            100,
            100
        ];
        if (!this.getAnimating()) this.resolveConstraints(0);
    }
    /**
   * Get the view center.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   * @observable
   * @api
   */ getCenter() {
        const center = this.getCenterInternal();
        if (!center) return center;
        return (0, $92f1443438429e81$export$698f563af1ba02a5)(center, this.getProjection());
    }
    /**
   * Get the view center without transforming to user projection.
   * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
   */ getCenterInternal() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).CENTER);
    }
    /**
   * @return {Constraints} Constraints.
   */ getConstraints() {
        return this.constraints_;
    }
    /**
   * @return {boolean} Resolution constraint is set
   */ getConstrainResolution() {
        return this.get('constrainResolution');
    }
    /**
   * @param {Array<number>} [hints] Destination array.
   * @return {Array<number>} Hint.
   */ getHints(hints) {
        if (hints !== undefined) {
            hints[0] = this.hints_[0];
            hints[1] = this.hints_[1];
            return hints;
        }
        return this.hints_.slice();
    }
    /**
   * Calculate the extent for the current view state and the passed box size.
   * @param {import("./size.js").Size} [size] The pixel dimensions of the box
   * into which the calculated extent should fit. Defaults to the size of the
   * map the view is associated with.
   * If no map or multiple maps are connected to the view, provide the desired
   * box size (e.g. `map.getSize()`).
   * @return {import("./extent.js").Extent} Extent.
   * @api
   */ calculateExtent(size) {
        const extent = this.calculateExtentInternal(size);
        return (0, $92f1443438429e81$export$96bfd09e2cffb006)(extent, this.getProjection());
    }
    /**
   * @param {import("./size.js").Size} [size] Box pixel size. If not provided,
   * the map's last known viewport size will be used.
   * @return {import("./extent.js").Extent} Extent.
   */ calculateExtentInternal(size) {
        size = size || this.getViewportSizeMinusPadding_();
        const center = /** @type {!import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(center, 'The view center is not defined');
        const resolution = /** @type {!number} */ this.getResolution();
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(resolution !== undefined, 'The view resolution is not defined');
        const rotation = /** @type {!number} */ this.getRotation();
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(rotation !== undefined, 'The view rotation is not defined');
        return (0, $7e819822b33b3d32$export$13ba650faf8308)(center, resolution, rotation, size);
    }
    /**
   * Get the maximum resolution of the view.
   * @return {number} The maximum resolution of the view.
   * @api
   */ getMaxResolution() {
        return this.maxResolution_;
    }
    /**
   * Get the minimum resolution of the view.
   * @return {number} The minimum resolution of the view.
   * @api
   */ getMinResolution() {
        return this.minResolution_;
    }
    /**
   * Get the maximum zoom level for the view.
   * @return {number} The maximum zoom level.
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.minResolution_);
    }
    /**
   * Set a new maximum zoom level for the view.
   * @param {number} zoom The maximum zoom level.
   * @api
   */ setMaxZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            maxZoom: zoom
        }));
    }
    /**
   * Get the minimum zoom level for the view.
   * @return {number} The minimum zoom level.
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.getZoomForResolution(this.maxResolution_);
    }
    /**
   * Set a new minimum zoom level for the view.
   * @param {number} zoom The minimum zoom level.
   * @api
   */ setMinZoom(zoom) {
        this.applyOptions_(this.getUpdatedOptions_({
            minZoom: zoom
        }));
    }
    /**
   * Set whether the view should allow intermediary zoom levels.
   * @param {boolean} enabled Whether the resolution is constrained.
   * @api
   */ setConstrainResolution(enabled) {
        this.applyOptions_(this.getUpdatedOptions_({
            constrainResolution: enabled
        }));
    }
    /**
   * Get the view projection.
   * @return {import("./proj/Projection.js").default} The projection of the view.
   * @api
   */ getProjection() {
        return this.projection_;
    }
    /**
   * Get the view resolution.
   * @return {number|undefined} The resolution of the view.
   * @observable
   * @api
   */ getResolution() {
        return /** @type {number|undefined} */ this.get((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).RESOLUTION);
    }
    /**
   * Get the resolutions for the view. This returns the array of resolutions
   * passed to the constructor of the View, or undefined if none were given.
   * @return {Array<number>|undefined} The resolutions of the view.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   * @api
   */ getResolutionForExtent(extent, size) {
        return this.getResolutionForExtentInternal((0, $92f1443438429e81$export$494be3a3a25689ca)(extent, this.getProjection()), size);
    }
    /**
   * Get the resolution for a provided extent (in map units) and size (in pixels).
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {import("./size.js").Size} [size] Box pixel size.
   * @return {number} The resolution at which the provided extent will render at
   *     the given size.
   */ getResolutionForExtentInternal(extent, size) {
        size = size || this.getViewportSizeMinusPadding_();
        const xResolution = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent) / size[0];
        const yResolution = (0, $7e819822b33b3d32$export$c08559766941f856)(extent) / size[1];
        return Math.max(xResolution, yResolution);
    }
    /**
   * Return a function that returns a value between 0 and 1 for a
   * resolution. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Resolution for value function.
   */ getResolutionForValueFunction(power) {
        power = power || 2;
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / Math.log(power);
        return(/**
       * @param {number} value Value.
       * @return {number} Resolution.
       */ function(value) {
            const resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    }
    /**
   * Get the view rotation.
   * @return {number} The rotation of the view in radians.
   * @observable
   * @api
   */ getRotation() {
        return /** @type {number} */ this.get((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).ROTATION);
    }
    /**
   * Return a function that returns a resolution for a value between
   * 0 and 1. Exponential scaling is assumed.
   * @param {number} [power] Power.
   * @return {function(number): number} Value for resolution function.
   */ getValueForResolutionFunction(power) {
        const logPower = Math.log(power || 2);
        const maxResolution = this.getConstrainedResolution(this.maxResolution_);
        const minResolution = this.minResolution_;
        const max = Math.log(maxResolution / minResolution) / logPower;
        return(/**
       * @param {number} resolution Resolution.
       * @return {number} Value.
       */ function(resolution) {
            const value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    }
    /**
   * Returns the size of the viewport minus padding.
   * @private
   * @param {number} [rotation] Take into account the rotation of the viewport when giving the size
   * @return {import("./size.js").Size} Viewport size reduced by the padding.
   */ getViewportSizeMinusPadding_(rotation) {
        let size = this.getViewportSize_(rotation);
        const padding = this.padding_;
        if (padding) size = [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ];
        return size;
    }
    /**
   * @return {State} View state.
   */ getState() {
        const projection = this.getProjection();
        const resolution = this.getResolution();
        const rotation = this.getRotation();
        let center = /** @type {import("./coordinate.js").Coordinate} */ this.getCenterInternal();
        const padding = this.padding_;
        if (padding) {
            const reducedSize = this.getViewportSizeMinusPadding_();
            center = $3192ea72f934a3fd$var$calculateCenterOn(center, this.getViewportSize_(), [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            nextCenter: this.nextCenter_,
            nextResolution: this.nextResolution_,
            nextRotation: this.nextRotation_,
            rotation: rotation,
            zoom: this.getZoom()
        };
    }
    /**
   * @return {ViewStateLayerStateExtent} Like `FrameState`, but just `viewState` and `extent`.
   */ getViewStateAndExtent() {
        return {
            viewState: this.getState(),
            extent: this.calculateExtent()
        };
    }
    /**
   * Get the current zoom level. This method may return non-integer zoom levels
   * if the view does not constrain the resolution, or if an interaction or
   * animation is underway.
   * @return {number|undefined} Zoom.
   * @api
   */ getZoom() {
        let zoom;
        const resolution = this.getResolution();
        if (resolution !== undefined) zoom = this.getZoomForResolution(resolution);
        return zoom;
    }
    /**
   * Get the zoom level for a resolution.
   * @param {number} resolution The resolution.
   * @return {number|undefined} The zoom level for the provided resolution.
   * @api
   */ getZoomForResolution(resolution) {
        let offset = this.minZoom_ || 0;
        let max, zoomFactor;
        if (this.resolutions_) {
            const nearest = (0, $830d23b8323fc080$export$8a3786cc03fdb777)(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) zoomFactor = 2;
            else zoomFactor = max / this.resolutions_[nearest + 1];
        } else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    }
    /**
   * Get the resolution for a zoom level.
   * @param {number} zoom Zoom level.
   * @return {number} The view resolution for the provided zoom level.
   * @api
   */ getResolutionForZoom(zoom) {
        if (this.resolutions_?.length) {
            if (this.resolutions_.length === 1) return this.resolutions_[0];
            const baseLevel = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(Math.floor(zoom), 0, this.resolutions_.length - 2);
            const zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return this.resolutions_[baseLevel] / Math.pow(zoomFactor, (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(zoom - baseLevel, 0, 1));
        }
        return this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_);
    }
    /**
   * Fit the given geometry or extent based on the given map size and border.
   * The size is pixel dimensions of the box to fit the extent into.
   * In most cases you will want to use the map size, that is `map.getSize()`.
   * Takes care of the map angle.
   * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
   *     extent to fit the view to.
   * @param {FitOptions} [options] Options.
   * @api
   */ fit(geometryOrExtent, options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */ let geometry;
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(Array.isArray(geometryOrExtent) || typeof /** @type {?} */ geometryOrExtent.getSimplifiedGeometry === 'function', 'Invalid extent or geometry provided as `geometry`');
        if (Array.isArray(geometryOrExtent)) {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!(0, $7e819822b33b3d32$export$dd1bc94b04021eeb)(geometryOrExtent), 'Cannot fit empty extent provided as `geometry`');
            const extent = (0, $92f1443438429e81$export$494be3a3a25689ca)(geometryOrExtent, this.getProjection());
            geometry = (0, $46a66e0f2fc72479$export$c16b671815801c75)(extent);
        } else if (geometryOrExtent.getType() === 'Circle') {
            const extent = (0, $92f1443438429e81$export$494be3a3a25689ca)(geometryOrExtent.getExtent(), this.getProjection());
            geometry = (0, $46a66e0f2fc72479$export$c16b671815801c75)(extent);
            geometry.rotate(this.getRotation(), (0, $7e819822b33b3d32$export$c91255cadecfe081)(extent));
        } else {
            const userProjection = (0, $92f1443438429e81$export$3973b77d5f6f2790)();
            if (userProjection) geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ geometryOrExtent.clone().transform(userProjection, this.getProjection());
            else geometry = geometryOrExtent;
        }
        this.fitInternal(geometry, options);
    }
    /**
   * Calculate rotated extent
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @return {import("./extent").Extent} The rotated extent for the geometry.
   */ rotatedExtentForGeometry(geometry) {
        const rotation = this.getRotation();
        const cosAngle = Math.cos(rotation);
        const sinAngle = Math.sin(-rotation);
        const coords = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        let minRotX = Infinity;
        let minRotY = Infinity;
        let maxRotX = -Infinity;
        let maxRotY = -Infinity;
        for(let i = 0, ii = coords.length; i < ii; i += stride){
            const rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            const rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [
            minRotX,
            minRotY,
            maxRotX,
            maxRotY
        ];
    }
    /**
   * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
   * @param {FitOptions} [options] Options.
   */ fitInternal(geometry, options) {
        options = options || {};
        let size = options.size;
        if (!size) size = this.getViewportSizeMinusPadding_();
        const padding = options.padding !== undefined ? options.padding : [
            0,
            0,
            0,
            0
        ];
        const nearest = options.nearest !== undefined ? options.nearest : false;
        let minResolution;
        if (options.minResolution !== undefined) minResolution = options.minResolution;
        else if (options.maxZoom !== undefined) minResolution = this.getResolutionForZoom(options.maxZoom);
        else minResolution = 0;
        const rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        let resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2]
        ]);
        resolution = isNaN(resolution) ? minResolution : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        const rotation = this.getRotation();
        const sinAngle = Math.sin(rotation);
        const cosAngle = Math.cos(rotation);
        const centerRot = (0, $7e819822b33b3d32$export$c91255cadecfe081)(rotatedExtent);
        centerRot[0] += (padding[1] - padding[3]) / 2 * resolution;
        centerRot[1] += (padding[0] - padding[2]) / 2 * resolution;
        const centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        const centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        const center = this.getConstrainedCenter([
            centerX,
            centerY
        ], resolution);
        const callback = options.callback ? options.callback : (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8);
        if (options.duration !== undefined) this.animateInternal({
            resolution: resolution,
            center: center,
            duration: options.duration,
            easing: options.easing
        }, callback);
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            $3192ea72f934a3fd$var$animationCallback(callback, true);
        }
    }
    /**
   * Center on coordinate and view position.
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   * @api
   */ centerOn(coordinate, size, position) {
        this.centerOnInternal((0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(coordinate, this.getProjection()), size, position);
    }
    /**
   * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("./size.js").Size} size Box pixel size.
   * @param {import("./pixel.js").Pixel} position Position on the view to center on.
   */ centerOnInternal(coordinate, size, position) {
        this.setCenterInternal($3192ea72f934a3fd$var$calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    }
    /**
   * Calculates the shift between map and viewport center.
   * @param {import("./coordinate.js").Coordinate} center Center.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {import("./size.js").Size} size Size.
   * @return {Array<number>|undefined} Center shift.
   */ calculateCenterShift(center, resolution, rotation, size) {
        let centerShift;
        const padding = this.padding_;
        if (padding && center) {
            const reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            const shiftedCenter = $3192ea72f934a3fd$var$calculateCenterOn(center, size, [
                reducedSize[0] / 2 + padding[3],
                reducedSize[1] / 2 + padding[0]
            ], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1]
            ];
        }
        return centerShift;
    }
    /**
   * @return {boolean} Is defined.
   */ isDef() {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   * @api
   */ adjustCenter(deltaCoordinates) {
        const center = (0, $92f1443438429e81$export$698f563af1ba02a5)(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Adds relative coordinates to the center of the view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
   */ adjustCenterInternal(deltaCoordinates) {
        const center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1]
        ]);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustResolution(ratio, anchor) {
        anchor = anchor && (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    }
    /**
   * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} ratio The ratio to apply on the view resolution.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ adjustResolutionInternal(ratio, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const size = this.getViewportSize_(this.getRotation());
        const newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterZoom(newResolution, anchor);
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    }
    /**
   * Adds a value to the view zoom level, optionally using an anchor. Any resolution
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom level.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ adjustZoom(delta, anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), anchor);
    }
    /**
   * Adds a value to the view rotation, optionally using an anchor. Any rotation
   * constraint will apply.
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   * @api
   */ adjustRotation(delta, anchor) {
        if (anchor) anchor = (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.adjustRotationInternal(delta, anchor);
    }
    /**
   * @param {number} delta Relative value to add to the zoom rotation, in radians.
   * @param {import("./coordinate.js").Coordinate} [anchor] The rotation center.
   */ adjustRotationInternal(delta, anchor) {
        const isMoving = this.getAnimating() || this.getInteracting();
        const newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (anchor) this.targetCenter_ = this.calculateCenterRotate(newRotation, anchor);
        this.targetRotation_ += delta;
        this.applyTargetState_();
    }
    /**
   * Set the center of the current view. Any extent constraint will apply.
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   * @observable
   * @api
   */ setCenter(center) {
        this.setCenterInternal(center ? (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(center, this.getProjection()) : center);
    }
    /**
   * Set the center using the view projection (not the user projection).
   * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
   */ setCenterInternal(center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    }
    /**
   * @param {import("./ViewHint.js").default} hint Hint.
   * @param {number} delta Delta.
   * @return {number} New value.
   */ setHint(hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    }
    /**
   * Set the resolution for this view. Any resolution constraint will apply.
   * @param {number|undefined} resolution The resolution of the view.
   * @observable
   * @api
   */ setResolution(resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    }
    /**
   * Set the rotation for this view. Any rotation constraint will apply.
   * @param {number} rotation The rotation of the view in radians.
   * @observable
   * @api
   */ setRotation(rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    }
    /**
   * Zoom to a specific zoom level. Any resolution constrain will apply.
   * @param {number} zoom Zoom level.
   * @api
   */ setZoom(zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    }
    /**
   * Recompute rotation/resolution/center based on target values.
   * Note: we have to compute rotation first, then resolution and center considering that
   * parameters can influence one another in case a view extent constraint is present.
   * @param {boolean} [doNotCancelAnims] Do not cancel animations.
   * @param {boolean} [forceMoving] Apply constraints as if the view is moving.
   * @private
   */ applyTargetState_(doNotCancelAnims, forceMoving) {
        const isMoving = this.getAnimating() || this.getInteracting() || forceMoving;
        // compute rotation
        const newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).ROTATION) !== newRotation) this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).ROTATION, newRotation);
        if (this.get((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).RESOLUTION) !== newResolution) {
            this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).RESOLUTION, newResolution);
            this.set('zoom', this.getZoom(), true);
        }
        if (!newCenter || !this.get((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).CENTER) || !(0, $8b28786758450fff$export$e9bab7fafb253603)(this.get((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).CENTER), newCenter)) this.set((0, $5f86c3d53c01e8fe$export$2e2bcd8739ae039).CENTER, newCenter);
        if (this.getAnimating() && !doNotCancelAnims) this.cancelAnimations();
        this.cancelAnchor_ = undefined;
    }
    /**
   * If any constraints need to be applied, an animation will be triggered.
   * This is typically done on interaction end.
   * Note: calling this with a duration of 0 will apply the constrained values straight away,
   * without animation.
   * @param {number} [duration] The animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ resolveConstraints(duration, resolutionDirection, anchor) {
        duration = duration !== undefined ? duration : 200;
        const direction = resolutionDirection || 0;
        const newRotation = this.constraints_.rotation(this.targetRotation_);
        const size = this.getViewportSize_(newRotation);
        const newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        const newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        anchor = anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution || this.getRotation() !== newRotation || !this.getCenterInternal() || !(0, $8b28786758450fff$export$e9bab7fafb253603)(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) this.cancelAnimations();
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0),
                anchor: anchor
            });
        }
    }
    /**
   * Notify the View that an interaction has started.
   * The view state will be resolved to a stable one if needed
   * (depending on its constraints).
   * @api
   */ beginInteraction() {
        this.resolveConstraints(0);
        this.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, 1);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   * @api
   */ endInteraction(duration, resolutionDirection, anchor) {
        anchor = anchor && (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(anchor, this.getProjection());
        this.endInteractionInternal(duration, resolutionDirection, anchor);
    }
    /**
   * Notify the View that an interaction has ended. The view state will be resolved
   * to a stable one if needed (depending on its constraints).
   * @param {number} [duration] Animation duration in ms.
   * @param {number} [resolutionDirection] Which direction to zoom.
   * @param {import("./coordinate.js").Coordinate} [anchor] The origin of the transformation.
   */ endInteractionInternal(duration, resolutionDirection, anchor) {
        if (!this.getInteracting()) return;
        this.setHint((0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING, -1);
        this.resolveConstraints(duration, resolutionDirection, anchor);
    }
    /**
   * Get a valid position for the view center according to the current constraints.
   * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
   * @param {number} [targetResolution] Target resolution. If not supplied, the current one will be used.
   * This is useful to guess a valid center position at a different zoom level.
   * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
   */ getConstrainedCenter(targetCenter, targetResolution) {
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, targetResolution || this.getResolution(), size);
    }
    /**
   * Get a valid zoom level according to the current view constraints.
   * @param {number|undefined} targetZoom Target zoom.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid zoom level.
   */ getConstrainedZoom(targetZoom, direction) {
        const targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, direction));
    }
    /**
   * Get a valid resolution according to the current view constraints.
   * @param {number|undefined} targetResolution Target resolution.
   * @param {number} [direction] Indicate which resolution should be used
   * by a renderer if the view resolution does not match any resolution of the tile source.
   * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
   * will be used. If -1, the nearest higher resolution will be used.
   * @return {number|undefined} Valid resolution.
   */ getConstrainedResolution(targetResolution, direction) {
        direction = direction || 0;
        const size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    }
}
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */ function $3192ea72f934a3fd$var$animationCallback(callback, returnValue) {
    setTimeout(function() {
        callback(returnValue);
    }, 0);
}
function $3192ea72f934a3fd$export$964345001ee9ac52(options) {
    if (options.extent !== undefined) {
        const smooth = options.smoothExtentConstraint !== undefined ? options.smoothExtentConstraint : true;
        return (0, $6a005ced57043b5f$export$c2f0af2c946f6897)(options.extent, options.constrainOnlyCenter, smooth);
    }
    const projection = (0, $92f1443438429e81$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    if (options.multiWorld !== true && projection.isGlobal()) {
        const extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return (0, $6a005ced57043b5f$export$c2f0af2c946f6897)(extent, false, false);
    }
    return 0, $6a005ced57043b5f$export$f883a24d5edde77c;
}
function $3192ea72f934a3fd$export$c68d65f9148da196(options) {
    let resolutionConstraint;
    let maxResolution;
    let minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    const defaultMaxZoom = 28;
    const defaultZoomFactor = 2;
    let minZoom = options.minZoom !== undefined ? options.minZoom : $3192ea72f934a3fd$var$DEFAULT_MIN_ZOOM;
    let maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    const zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    const multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    const smooth = options.smoothResolutionConstraint !== undefined ? options.smoothResolutionConstraint : true;
    const showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    const projection = (0, $92f1443438429e81$export$549167224996a0fb)(options.projection, 'EPSG:3857');
    const projExtent = projection.getExtent();
    let constrainOnlyCenter = options.constrainOnlyCenter;
    let extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        const resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution = resolutions[maxZoom] !== undefined ? resolutions[maxZoom] : resolutions[resolutions.length - 1];
        if (options.constrainResolution) resolutionConstraint = (0, $fc7552e588d344e0$export$d65a517690fc4385)(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $fc7552e588d344e0$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    } else {
        // calculate the default min and max resolution
        const size = !projExtent ? 360 * (0, $fb72d58bc9104528$export$1482081eec883108).degrees / projection.getMetersPerUnit() : Math.max((0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projExtent), (0, $7e819822b33b3d32$export$c08559766941f856)(projExtent));
        const defaultMaxResolution = size / (0, $9a8010a8337e7cef$export$6b8cb5cd370bd90c) / Math.pow(defaultZoomFactor, $3192ea72f934a3fd$var$DEFAULT_MIN_ZOOM);
        const defaultMinResolution = defaultMaxResolution / Math.pow(defaultZoomFactor, defaultMaxZoom - $3192ea72f934a3fd$var$DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) minZoom = 0;
        else maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                else minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
            } else minResolution = defaultMinResolution;
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom = minZoom + Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) resolutionConstraint = (0, $fc7552e588d344e0$export$22ac0f6b219de91a)(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        else resolutionConstraint = (0, $fc7552e588d344e0$export$1c4e6da9b4b066fe)(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor
    };
}
function $3192ea72f934a3fd$export$4eeaa08dd550e3c0(options) {
    const enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        const constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) return (0, $ea3e0fdf428207b8$export$17a6e6f3448b17e8)();
        if (constrainRotation === false) return 0, $ea3e0fdf428207b8$export$f883a24d5edde77c;
        if (typeof constrainRotation === 'number') return (0, $ea3e0fdf428207b8$export$9ba78806de831083)(constrainRotation);
        return 0, $ea3e0fdf428207b8$export$f883a24d5edde77c;
    }
    return 0, $ea3e0fdf428207b8$export$e20fbacbb41798b;
}
function $3192ea72f934a3fd$export$ee75376562060184(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!(0, $8b28786758450fff$export$e9bab7fafb253603)(animation.sourceCenter, animation.targetCenter)) return false;
    }
    if (animation.sourceResolution !== animation.targetResolution) return false;
    if (animation.sourceRotation !== animation.targetRotation) return false;
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */ function $3192ea72f934a3fd$var$calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    const cosAngle = Math.cos(-rotation);
    let sinAngle = Math.sin(-rotation);
    let rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    let rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    const centerX = rotX * cosAngle - rotY * sinAngle;
    const centerY = rotY * cosAngle + rotX * sinAngle;
    return [
        centerX,
        centerY
    ];
}
var $3192ea72f934a3fd$export$2e2bcd8739ae039 = $3192ea72f934a3fd$var$View;







/**
 * @module ol/layer/Base
 */ 



/**
 * @module ol/layer/Property
 */ /**
 * @enum {string}
 */ var $6cc5709edf8fe4ca$export$2e2bcd8739ae039 = {
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source',
    MAP: 'map'
};


/**
 * A css color, or a function called with a view resolution returning a css color.
 *
 * @typedef {string|function(number):string} BackgroundColor
 * @api
 */ /**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number | undefined} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base~BaseLayer} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object~BaseObject} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */ class $462b2201ee49de24$var$BaseLayer extends (0, $d575b598d09f57d3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Layer options.
   */ constructor(options){
        super();
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {BackgroundColor|false}
     * @private
     */ this.background_ = options.background;
        /**
     * @type {Object<string, *>}
     */ const properties = Object.assign({}, options);
        if (typeof options.properties === 'object') {
            delete properties.properties;
            Object.assign(properties, options.properties);
        }
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).OPACITY] = options.opacity !== undefined ? options.opacity : 1;
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).OPACITY] === 'number', 'Layer opacity must be a number');
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).VISIBLE] = options.visible !== undefined ? options.visible : true;
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).Z_INDEX] = options.zIndex;
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAX_RESOLUTION] = options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MIN_RESOLUTION] = options.minResolution !== undefined ? options.minResolution : 0;
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MIN_ZOOM] = options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[(0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAX_ZOOM] = options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
     * @type {string}
     * @private
     */ this.className_ = properties.className !== undefined ? properties.className : 'ol-layer';
        delete properties.className;
        this.setProperties(properties);
        /**
     * @type {import("./Layer.js").State}
     * @private
     */ this.state_ = null;
    }
    /**
   * Get the background for this layer.
   * @return {BackgroundColor|false} Layer background.
   */ getBackground() {
        return this.background_;
    }
    /**
   * @return {string} CSS class name.
   */ getClassName() {
        return this.className_;
    }
    /**
   * This method is not meant to be called by layers or layer renderers because the state
   * is incorrect if the layer is included in a layer group.
   *
   * @param {boolean} [managed] Layer is managed.
   * @return {import("./Layer.js").State} Layer state.
   */ getLayerState(managed) {
        /** @type {import("./Layer.js").State} */ const state = this.state_ || /** @type {?} */ {
            layer: this,
            managed: managed === undefined ? true : managed
        };
        const zIndex = this.getZIndex();
        state.opacity = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be
   *     modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   */ getLayersArray(array) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer
   *     states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   */ getLayerStatesArray(states) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
   * will be visible regardless of extent.
   * @return {import("../extent.js").Extent|undefined} The layer extent.
   * @observable
   * @api
   */ getExtent() {
        return /** @type {import("../extent.js").Extent|undefined} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).EXTENT);
    }
    /**
   * Return the maximum resolution of the layer. Returns Infinity if
   * the layer has no maximum resolution set.
   * @return {number} The maximum resolution of the layer.
   * @observable
   * @api
   */ getMaxResolution() {
        return /** @type {number} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAX_RESOLUTION);
    }
    /**
   * Return the minimum resolution of the layer. Returns 0 if
   * the layer has no minimum resolution set.
   * @return {number} The minimum resolution of the layer.
   * @observable
   * @api
   */ getMinResolution() {
        return /** @type {number} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MIN_RESOLUTION);
    }
    /**
   * Return the minimum zoom level of the layer. Returns -Infinity if
   * the layer has no minimum zoom set.
   * @return {number} The minimum zoom level of the layer.
   * @observable
   * @api
   */ getMinZoom() {
        return /** @type {number} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MIN_ZOOM);
    }
    /**
   * Return the maximum zoom level of the layer. Returns Infinity if
   * the layer has no maximum zoom set.
   * @return {number} The maximum zoom level of the layer.
   * @observable
   * @api
   */ getMaxZoom() {
        return /** @type {number} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAX_ZOOM);
    }
    /**
   * Return the opacity of the layer (between 0 and 1).
   * @return {number} The opacity of the layer.
   * @observable
   * @api
   */ getOpacity() {
        return /** @type {number} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).OPACITY);
    }
    /**
   * @abstract
   * @return {import("../source/Source.js").State} Source state.
   */ getSourceState() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Return the value of this layer's `visible` property. To find out whether the layer
   * is visible on a map, use `isVisible()` instead.
   * @return {boolean} The value of the `visible` property of the layer.
   * @observable
   * @api
   */ getVisible() {
        return /** @type {boolean} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).VISIBLE);
    }
    /**
   * Return the Z-index of the layer, which is used to order layers before
   * rendering. Returns undefined if the layer is unmanaged.
   * @return {number|undefined} The Z-index of the layer.
   * @observable
   * @api
   */ getZIndex() {
        return /** @type {number|undefined} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).Z_INDEX);
    }
    /**
   * Sets the background color.
   * @param {BackgroundColor} [background] Background color.
   */ setBackground(background) {
        this.background_ = background;
        this.changed();
    }
    /**
   * Set the extent at which the layer is visible.  If `undefined`, the layer
   * will be visible at all extents.
   * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
   * @observable
   * @api
   */ setExtent(extent) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).EXTENT, extent);
    }
    /**
   * Set the maximum resolution at which the layer is visible.
   * @param {number} maxResolution The maximum resolution of the layer.
   * @observable
   * @api
   */ setMaxResolution(maxResolution) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAX_RESOLUTION, maxResolution);
    }
    /**
   * Set the minimum resolution at which the layer is visible.
   * @param {number} minResolution The minimum resolution of the layer.
   * @observable
   * @api
   */ setMinResolution(minResolution) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MIN_RESOLUTION, minResolution);
    }
    /**
   * Set the maximum zoom (exclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} maxZoom The maximum zoom of the layer.
   * @observable
   * @api
   */ setMaxZoom(maxZoom) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAX_ZOOM, maxZoom);
    }
    /**
   * Set the minimum zoom (inclusive) at which the layer is visible.
   * Note that the zoom levels for layer visibility are based on the
   * view zoom level, which may be different from a tile source zoom level.
   * @param {number} minZoom The minimum zoom of the layer.
   * @observable
   * @api
   */ setMinZoom(minZoom) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MIN_ZOOM, minZoom);
    }
    /**
   * Set the opacity of the layer, allowed values range from 0 to 1.
   * @param {number} opacity The opacity of the layer.
   * @observable
   * @api
   */ setOpacity(opacity) {
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof opacity === 'number', 'Layer opacity must be a number');
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).OPACITY, opacity);
    }
    /**
   * Set the visibility of the layer (`true` or `false`).
   * @param {boolean} visible The visibility of the layer.
   * @observable
   * @api
   */ setVisible(visible) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).VISIBLE, visible);
    }
    /**
   * Set Z-index of the layer, which is used to order layers before rendering.
   * The default Z-index is 0.
   * @param {number} zindex The z-index of the layer.
   * @observable
   * @api
   */ setZIndex(zindex) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).Z_INDEX, zindex);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        super.disposeInternal();
    }
}
var $462b2201ee49de24$export$2e2bcd8739ae039 = $462b2201ee49de24$var$BaseLayer;



/**
 * @typedef {function(import("../Map.js").FrameState):HTMLElement} RenderFunction
 */ /**
 * @typedef {'sourceready'|'change:source'} LayerEventType
 */ /***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     LayerEventType, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|LayerEventType|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */ /**
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../Map.js").default|null} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */ /**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * Components like {@link module:ol/interaction/Draw~Draw} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * [layer.setMap()]{@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 * A `sourceready` event is fired when the layer's source is ready.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 * @fires import("../events/Event.js").BaseEvent#sourceready
 *
 * @template {import("../source/Source.js").default} [SourceType=import("../source/Source.js").default]
 * @template {import("../renderer/Layer.js").default} [RendererType=import("../renderer/Layer.js").default]
 * @api
 */ class $575253350abb8238$var$Layer extends (0, $462b2201ee49de24$export$2e2bcd8739ae039) {
    /**
   * @param {Options<SourceType>} options Layer options.
   */ constructor(options){
        const baseOptions = Object.assign({}, options);
        delete baseOptions.source;
        super(baseOptions);
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {LayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {LayerOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapPrecomposeKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.mapRenderKey_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceChangeKey_ = null;
        /**
     * @private
     * @type {RendererType}
     */ this.renderer_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.sourceReady_ = false;
        /**
     * @protected
     * @type {boolean}
     */ this.rendered = false;
        // Overwrite default render method with a custom one
        if (options.render) this.render = options.render;
        if (options.map) this.setMap(options.map);
        this.addChangeListener((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).SOURCE, this.handleSourcePropertyChange_);
        const source = options.source ? /** @type {SourceType} */ options.source : null;
        this.setSource(source);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array ? array : [];
        array.push(this);
        return array;
    }
    /**
   * @param {Array<import("./Layer.js").State>} [states] Optional list of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(states) {
        states = states ? states : [];
        states.push(this.getLayerState());
        return states;
    }
    /**
   * Get the layer source.
   * @return {SourceType|null} The layer source (or `null` if not yet set).
   * @observable
   * @api
   */ getSource() {
        return /** @type {SourceType} */ this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).SOURCE) || null;
    }
    /**
   * @return {SourceType|null} The source being rendered.
   */ getRenderSource() {
        return this.getSource();
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        const source = this.getSource();
        return !source ? 'undefined' : source.getState();
    }
    /**
   * @private
   */ handleSourceChange_() {
        this.changed();
        if (this.sourceReady_ || this.getSource().getState() !== 'ready') return;
        this.sourceReady_ = true;
        this.dispatchEvent('sourceready');
    }
    /**
   * @private
   */ handleSourcePropertyChange_() {
        if (this.sourceChangeKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        this.sourceReady_ = false;
        const source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(source, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleSourceChange_, this);
            if (source.getState() === 'ready') {
                this.sourceReady_ = true;
                setTimeout(()=>{
                    this.dispatchEvent('sourceready');
                }, 0);
            }
            this.clearRenderer();
        }
        this.changed();
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with
   * an array of features.
   */ getFeatures(pixel) {
        if (!this.renderer_) return Promise.resolve([]);
        return this.renderer_.getFeatures(pixel);
    }
    /**
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   */ getData(pixel) {
        if (!this.renderer_ || !this.rendered) return null;
        return this.renderer_.getData(pixel);
    }
    /**
   * The layer is visible on the map view, i.e. within its min/max resolution or zoom and
   * extent, not set to `visible: false`, and not inside a layer group that is set
   * to `visible: false`.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {boolean} The layer is visible in the map view.
   * @api
   */ isVisible(view) {
        let frameState;
        const map = this.getMapInternal();
        if (!view && map) view = map.getView();
        if (view instanceof (0, $3192ea72f934a3fd$export$2e2bcd8739ae039)) frameState = {
            viewState: view.getState(),
            extent: view.calculateExtent()
        };
        else frameState = view;
        if (!frameState.layerStatesArray && map) frameState.layerStatesArray = map.getLayerGroup().getLayerStatesArray();
        let layerState;
        if (frameState.layerStatesArray) {
            layerState = frameState.layerStatesArray.find((layerState)=>layerState.layer === this);
            if (!layerState) return false;
        } else layerState = this.getLayerState();
        const layerExtent = this.getExtent();
        return $575253350abb8238$export$acb1e9cb9ce4ca56(layerState, frameState.viewState) && (!layerExtent || (0, $7e819822b33b3d32$export$7b0a31e10bbff018)(layerExtent, frameState.extent));
    }
    /**
   * Get the attributions of the source of this layer for the given view.
   * @param {View|import("../View.js").ViewStateLayerStateExtent} [view] View or {@link import("../Map.js").FrameState}.
   * Only required when the layer is not added to a map.
   * @return {Array<string>} Attributions for this layer at the given view.
   * @api
   */ getAttributions(view) {
        if (!this.isVisible(view)) return [];
        const getAttributions = this.getSource()?.getAttributions();
        if (!getAttributions) return [];
        const frameState = view instanceof (0, $3192ea72f934a3fd$export$2e2bcd8739ae039) ? view.getViewStateAndExtent() : view;
        let attributions = getAttributions(frameState);
        if (!Array.isArray(attributions)) attributions = [
            attributions
        ];
        return attributions;
    }
    /**
   * In charge to manage the rendering of the layer. One layer type is
   * bounded with one layer renderer.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target which the renderer may (but need not) use
   * for rendering its content.
   * @return {HTMLElement|null} The rendered element.
   */ render(frameState, target) {
        const layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            this.rendered = true;
            return layerRenderer.renderFrame(frameState, target);
        }
        return null;
    }
    /**
   * Called when a layer is not visible during a map render.
   */ unrender() {
        this.rendered = false;
    }
    /** @return {string} Declutter */ getDeclutter() {
        return undefined;
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   */ renderDeclutter(frameState, layerState) {}
    /**
   * When the renderer follows a layout -> render approach, do the final rendering here.
   * @param {import('../Map.js').FrameState} frameState Frame state
   */ renderDeferred(frameState) {
        const layerRenderer = this.getRenderer();
        if (!layerRenderer) return;
        layerRenderer.renderDeferred(frameState);
    }
    /**
   * For use inside the library only.
   * @param {import("../Map.js").default|null} map Map.
   */ setMapInternal(map) {
        if (!map) this.unrender();
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAP, map);
    }
    /**
   * For use inside the library only.
   * @return {import("../Map.js").default|null} Map.
   */ getMapInternal() {
        return this.get((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).MAP);
    }
    /**
   * Sets the layer to be rendered on top of other layers on a map. The map will
   * not manage this layer in its layers collection. This
   * is useful for temporary layers. To remove an unmanaged layer from the map,
   * use `#setMap(null)`.
   *
   * To add the layer to a map and have it managed by the map, use
   * {@link module:ol/Map~Map#addLayer} instead.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.mapPrecomposeKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) this.changed();
        if (this.mapRenderKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(map, (0, $847c6e8c21904781$export$2e2bcd8739ae039).PRECOMPOSE, this.handlePrecompose_, this);
            this.mapRenderKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, map.render, map);
            this.changed();
        }
    }
    /**
   * @param {import("../events/Event.js").default} renderEvent Render event
   * @private
   */ handlePrecompose_(renderEvent) {
        const layerStatesArray = /** @type {import("../render/Event.js").default} */ renderEvent.frameState.layerStatesArray;
        const layerState = this.getLayerState(false);
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!layerStatesArray.some((arrayLayerState)=>arrayLayerState.layer === layerState.layer), 'A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.');
        layerStatesArray.push(layerState);
    }
    /**
   * Set the layer source.
   * @param {SourceType|null} source The layer source.
   * @observable
   * @api
   */ setSource(source) {
        this.set((0, $6cc5709edf8fe4ca$export$2e2bcd8739ae039).SOURCE, source);
    }
    /**
   * Get the renderer for this layer.
   * @return {RendererType|null} The layer renderer.
   */ getRenderer() {
        if (!this.renderer_) this.renderer_ = this.createRenderer();
        return this.renderer_;
    }
    /**
   * @return {boolean} The layer has a renderer.
   */ hasRenderer() {
        return !!this.renderer_;
    }
    /**
   * Create a renderer for this layer.
   * @return {RendererType} A layer renderer.
   * @protected
   */ createRenderer() {
        return null;
    }
    /**
   * This will clear the renderer so that a new one can be created next time it is needed
   */ clearRenderer() {
        if (this.renderer_) {
            this.renderer_.dispose();
            delete this.renderer_;
        }
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.clearRenderer();
        this.setSource(null);
        super.disposeInternal();
    }
}
function $575253350abb8238$export$acb1e9cb9ce4ca56(layerState, viewState) {
    if (!layerState.visible) return false;
    const resolution = viewState.resolution;
    if (resolution < layerState.minResolution || resolution >= layerState.maxResolution) return false;
    const zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
var $575253350abb8238$export$2e2bcd8739ae039 = $575253350abb8238$var$Layer;


/**
 * @template {import("../source/Image.js").default} ImageSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {ImageSourceType} [source] Source for this layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<ImageSourceType, RendererType>}
 * @api
 */ class $f499362e5a5df4c1$var$BaseImageLayer extends (0, $575253350abb8238$export$2e2bcd8739ae039) {
    /**
   * @param {Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        options = options ? options : {};
        super(options);
    }
}
var $f499362e5a5df4c1$export$2e2bcd8739ae039 = $f499362e5a5df4c1$var$BaseImageLayer;


/**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @extends {BaseImageLayer<ImageSourceType, CanvasImageLayerRenderer>}
 * @api
 */ class $7924e3219eb0471c$var$ImageLayer extends (0, $f499362e5a5df4c1$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseImage.js").Options<ImageSourceType>} [options] Layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $2a67941380f9882b$export$2e2bcd8739ae039)(this);
    }
    /**
   * Get data for a pixel location.  A four element RGBA array will be returned.  For requests outside the
   * layer extent, `null` will be returned.  Data for an image can only be retrieved if the
   * source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $7924e3219eb0471c$export$2e2bcd8739ae039 = $7924e3219eb0471c$var$ImageLayer;

/**
 * @module ol/layer/Tile
 */ /**
 * @module ol/renderer/canvas/TileLayer
 */ /**
 * @module ol/DataTile
 */ /**
 * @module ol/Tile
 */ /**
 * @module ol/TileState
 */ /**
 * @enum {number}
 */ var $2cb810f54791c0da$export$2e2bcd8739ae039 = {
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
   * Indicates that tile loading failed
   * @type {number}
   */ ERROR: 3,
    EMPTY: 4
};






/**
 * A function that takes a {@link module:ol/Tile~Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState.js';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   const xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     const data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */ /**
 * {@link module:ol/source/Tile~TileSource} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes a {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection~Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */ /**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @api
 */ /**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */ class $d91642aad273ae94$var$Tile extends (0, $dd029d816e3b4259$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {Options} [options] Tile options.
   */ constructor(tileCoord, state, options){
        super();
        options = options ? options : {};
        /**
     * @type {import("./tilecoord.js").TileCoord}
     */ this.tileCoord = tileCoord;
        /**
     * @protected
     * @type {import("./TileState.js").default}
     */ this.state = state;
        /**
     * A key assigned to the tile. This is used in conjunction with a source key
     * to determine if a cached version of this tile may be used by the renderer.
     * @type {string}
     */ this.key = '';
        /**
     * The duration for the opacity transition.
     * @private
     * @type {number}
     */ this.transition_ = options.transition === undefined ? 250 : options.transition;
        /**
     * Lookup of start times for rendering transitions.  If the start time is
     * equal to -1, the transition is complete.
     * @private
     * @type {Object<string, number>}
     */ this.transitionStarts_ = {};
        /**
     * @type {boolean}
     */ this.interpolate = !!options.interpolate;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * Called by the tile cache when the tile is removed from the cache due to expiry
   */ release() {
        // to remove the `change` listener on this tile in `ol/TileQueue#handleTileChange`
        this.setState((0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY);
    }
    /**
   * @return {string} Key.
   */ getKey() {
        return this.key + '/' + this.tileCoord;
    }
    /**
   * Get the tile coordinate for this tile.
   * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
   * @api
   */ getTileCoord() {
        return this.tileCoord;
    }
    /**
   * @return {import("./TileState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
   * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
   * when the tile cannot be loaded. Otherwise the tile cannot be removed from
   * the tile queue and will block other requests.
   * @param {import("./TileState.js").default} state State.
   * @api
   */ setState(state) {
        if (this.state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY) // no more state changes
        return;
        if (this.state !== (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR && this.state > state) throw new Error('Tile load sequence violation');
        this.state = state;
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   * @abstract
   * @api
   */ load() {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Get the alpha value for rendering.
   * @param {string} id An id for the renderer.
   * @param {number} time The render frame time.
   * @return {number} A number between 0 and 1.
   */ getAlpha(id, time) {
        if (!this.transition_) return 1;
        let start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        } else if (start === -1) return 1;
        const delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) return 1;
        return (0, $0164a93fcf6e65ad$export$929e5a82286172a6)(delta / this.transition_);
    }
    /**
   * Determine if a tile is in an alpha transition.  A tile is considered in
   * transition if tile.getAlpha() has not yet been called or has been called
   * and returned 1.
   * @param {string} id An id for the renderer.
   * @return {boolean} The tile is in transition.
   */ inTransition(id) {
        if (!this.transition_) return false;
        return this.transitionStarts_[id] !== -1;
    }
    /**
   * Mark a transition as complete.
   * @param {string} id An id for the renderer.
   */ endTransition(id) {
        if (this.transition_) this.transitionStarts_[id] = -1;
    }
    /**
   * @override
   */ disposeInternal() {
        this.release();
        super.disposeInternal();
    }
}
var $d91642aad273ae94$export$2e2bcd8739ae039 = $d91642aad273ae94$var$Tile;




function $151d694da6b9df5d$export$3a7c913cb40dcb7d(data) {
    return data instanceof Image || data instanceof HTMLCanvasElement || data instanceof HTMLVideoElement || data instanceof ImageBitmap ? data : null;
}
function $151d694da6b9df5d$export$7386cb0413f6b283(data) {
    return data instanceof Uint8Array || data instanceof Uint8ClampedArray || data instanceof Float32Array || data instanceof DataView ? data : null;
}
const $151d694da6b9df5d$export$df4c617b86128e3e = new Error('disposed');
/**
 * @type {CanvasRenderingContext2D|null}
 */ let $151d694da6b9df5d$var$sharedContext = null;
function $151d694da6b9df5d$export$45b10814cc054894(image) {
    if (!$151d694da6b9df5d$var$sharedContext) $151d694da6b9df5d$var$sharedContext = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(image.width, image.height, undefined, {
        willReadFrequently: true
    });
    const canvas = $151d694da6b9df5d$var$sharedContext.canvas;
    const width = image.width;
    if (canvas.width !== width) canvas.width = width;
    const height = image.height;
    if (canvas.height !== height) canvas.height = height;
    $151d694da6b9df5d$var$sharedContext.clearRect(0, 0, width, height);
    $151d694da6b9df5d$var$sharedContext.drawImage(image, 0, 0);
    return $151d694da6b9df5d$var$sharedContext.getImageData(0, 0, width, height).data;
}
/**
 * @type {import('./size.js').Size}
 */ const $151d694da6b9df5d$var$defaultSize = [
    256,
    256
];
/**
 * @typedef {Object} Options
 * @property {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @property {function(): Promise<Data>} loader Data loader.  For loaders that generate images,
 * the promise should not resolve until the image is loaded.
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 * @property {import('./size.js').Size} [size=[256, 256]] Tile size.
 * @property {AbortController} [controller] An abort controller.
 * @api
 */ class $151d694da6b9df5d$var$DataTile extends (0, $d91642aad273ae94$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Tile options.
   */ constructor(options){
        const state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE;
        super(options.tileCoord, state, {
            transition: options.transition,
            interpolate: options.interpolate
        });
        /**
     * @type {function(): Promise<Data>}
     * @private
     */ this.loader_ = options.loader;
        /**
     * @type {Data}
     * @private
     */ this.data_ = null;
        /**
     * @type {Error}
     * @private
     */ this.error_ = null;
        /**
     * @type {import('./size.js').Size|null}
     * @private
     */ this.size_ = options.size || null;
        /**
     * @type {AbortController|null}
     * @private
     */ this.controller_ = options.controller || null;
    }
    /**
   * Get the tile size.
   * @return {import('./size.js').Size} Tile size.
   */ getSize() {
        if (this.size_) return this.size_;
        const imageData = $151d694da6b9df5d$export$3a7c913cb40dcb7d(this.data_);
        if (imageData) return [
            imageData.width,
            imageData.height
        ];
        return $151d694da6b9df5d$var$defaultSize;
    }
    /**
   * Get the data for the tile.
   * @return {Data} Tile data.
   * @api
   */ getData() {
        return this.data_;
    }
    /**
   * Get any loading error.
   * @return {Error} Loading error.
   * @api
   */ getError() {
        return this.error_;
    }
    /**
   * Load the tile data.
   * @api
   * @override
   */ load() {
        if (this.state !== (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE && this.state !== (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR) return;
        this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING;
        this.changed();
        const self = this;
        this.loader_().then(function(data) {
            self.data_ = data;
            self.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED;
            self.changed();
        }).catch(function(error) {
            self.error_ = error;
            self.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR;
            self.changed();
        });
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.controller_) {
            this.controller_.abort($151d694da6b9df5d$export$df4c617b86128e3e);
            this.controller_ = null;
        }
        super.disposeInternal();
    }
}
var $151d694da6b9df5d$export$2e2bcd8739ae039 = $151d694da6b9df5d$var$DataTile;


/**
 * @module ol/ImageTile
 */ /**
 * @module ol/Image
 */ 





/**
 * A function that takes an {@link module:ol/Image~ImageWrapper} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~ImageWrapper#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(import("./Image.js").default, string): void} LoadFunction
 * @api
 */ /**
 * @typedef {Object} ImageObject
 * @property {import("./extent.js").Extent} [extent] Extent, if different from the requested one.
 * @property {import("./resolution.js").ResolutionLike} [resolution] Resolution, if different from the requested one.
 * When x and y resolution are different, use the array type (`[xResolution, yResolution]`).
 * @property {number} [pixelRatio] Pixel ratio, if different from the requested one.
 * @property {import('./DataTile.js').ImageLike} image Image.
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * For images that cover any extent and resolution (static images), the loader function should not accept
 * any arguments. The function returns an {@link import("./DataTile.js").ImageLike image}, an
 * {@link import("./Image.js").ImageObject image object}, or a promise for the same.
 * For loaders that generate images, the promise should not resolve until the image is loaded.
 * If the returned image does not match the extent, resolution or pixel ratio passed to the loader,
 * it has to return an {@link import("./Image.js").ImageObject image object} with the `image` and the
 * correct `extent`, `resolution` and `pixelRatio`.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): import("./DataTile.js").ImageLike|ImageObject|Promise<import("./DataTile.js").ImageLike|ImageObject>} Loader
 * @api
 */ /**
 * Loader function used for image sources. Receives extent, resolution and pixel ratio as arguments.
 * The function returns a promise for an  {@link import("./Image.js").ImageObject image object}.
 *
 * @typedef {function(import("./extent.js").Extent, number, number, (function(HTMLImageElement, string): void)=): Promise<import("./DataTile.js").ImageLike|ImageObject>} ImageObjectPromiseLoader
 */ class $e460a8a24b67695c$var$ImageWrapper extends (0, $dd029d816e3b4259$export$2e2bcd8739ae039) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number|Array<number>|undefined} resolution Resolution. If provided as array, x and y
   * resolution will be assumed.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("./ImageState.js").default|Loader} stateOrLoader State.
   */ constructor(extent, resolution, pixelRatio, stateOrLoader){
        super();
        /**
     * @protected
     * @type {import("./extent.js").Extent}
     */ this.extent = extent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @protected
     * @type {number|Array<number>|undefined}
     */ this.resolution = resolution;
        /**
     * @protected
     * @type {import("./ImageState.js").default}
     */ this.state = typeof stateOrLoader === 'function' ? (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE : stateOrLoader;
        /**
     * @private
     * @type {import('./DataTile.js').ImageLike|null}
     */ this.image_ = null;
        /**
     * @protected
     * @type {Loader|null}
     */ this.loader = typeof stateOrLoader === 'function' ? stateOrLoader : null;
    }
    /**
   * @protected
   */ changed() {
        this.dispatchEvent((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @return {import("./extent.js").Extent} Extent.
   */ getExtent() {
        return this.extent;
    }
    /**
   * @return {import('./DataTile.js').ImageLike} Image.
   */ getImage() {
        return this.image_;
    }
    /**
   * @return {number} PixelRatio.
   */ getPixelRatio() {
        return this.pixelRatio_;
    }
    /**
   * @return {number|Array<number>} Resolution.
   */ getResolution() {
        return /** @type {number} */ this.resolution;
    }
    /**
   * @return {import("./ImageState.js").default} State.
   */ getState() {
        return this.state;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.state == (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) {
            if (this.loader) {
                this.state = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING;
                this.changed();
                const resolution = this.getResolution();
                const requestResolution = Array.isArray(resolution) ? resolution[0] : resolution;
                (0, $de1052d9f293b73a$export$4dbaaf6c79705e6c)(()=>this.loader(this.getExtent(), requestResolution, this.getPixelRatio())).then((image)=>{
                    if ('image' in image) this.image_ = image.image;
                    if ('extent' in image) this.extent = image.extent;
                    if ('resolution' in image) this.resolution = image.resolution;
                    if ('pixelRatio' in image) this.pixelRatio_ = image.pixelRatio;
                    if (image instanceof HTMLImageElement || (0, $89969764a1196844$export$7478563940788376) && image instanceof ImageBitmap || image instanceof HTMLCanvasElement || image instanceof HTMLVideoElement) this.image_ = image;
                    this.state = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
                }).catch((error)=>{
                    this.state = (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR;
                    console.error(error); // eslint-disable-line no-console
                }).finally(()=>this.changed());
            }
        }
    }
    /**
   * @param {import('./DataTile.js').ImageLike} image The image.
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * @param {number|Array<number>} resolution Resolution.
   */ setResolution(resolution) {
        this.resolution = resolution;
    }
}
function $e460a8a24b67695c$export$bc96ecc7c2a50764(image, loadHandler, errorHandler) {
    const img = /** @type {HTMLImageElement} */ image;
    let listening = true;
    let decoding = false;
    let loaded = false;
    const listenerKeys = [
        (0, $37a5c0af9052e360$export$8d2a95bc11b44725)(img, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).LOAD, function() {
            loaded = true;
            if (!decoding) loadHandler();
        })
    ];
    if (img.src && (0, $89969764a1196844$export$716f8695eedb9bad)) {
        decoding = true;
        img.decode().then(function() {
            if (listening) loadHandler();
        }).catch(function(error) {
            if (listening) {
                if (loaded) loadHandler();
                else errorHandler();
            }
        });
    } else listenerKeys.push((0, $37a5c0af9052e360$export$8d2a95bc11b44725)(img, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).ERROR, errorHandler));
    return function unlisten() {
        listening = false;
        listenerKeys.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
    };
}
function $e460a8a24b67695c$export$11e63f7b0f3d9900(image, src) {
    return new Promise((resolve, reject)=>{
        function handleLoad() {
            unlisten();
            resolve(image);
        }
        function handleError() {
            unlisten();
            reject(new Error('Image load error'));
        }
        function unlisten() {
            image.removeEventListener('load', handleLoad);
            image.removeEventListener('error', handleError);
        }
        image.addEventListener('load', handleLoad);
        image.addEventListener('error', handleError);
        if (src) image.src = src;
    });
}
function $e460a8a24b67695c$export$a9e5af241c1bd389(image, src) {
    if (src) image.src = src;
    return image.src && (0, $89969764a1196844$export$716f8695eedb9bad) ? new Promise((resolve, reject)=>image.decode().then(()=>resolve(image)).catch((e)=>image.complete && image.width ? resolve(image) : reject(e))) : $e460a8a24b67695c$export$11e63f7b0f3d9900(image);
}
function $e460a8a24b67695c$export$2f872c0f2117be69(image, src) {
    if (src) image.src = src;
    return image.src && (0, $89969764a1196844$export$716f8695eedb9bad) && (0, $89969764a1196844$export$7478563940788376) ? image.decode().then(()=>createImageBitmap(image)).catch((e)=>{
        if (image.complete && image.width) return image;
        throw e;
    }) : $e460a8a24b67695c$export$a9e5af241c1bd389(image);
}
var $e460a8a24b67695c$export$2e2bcd8739ae039 = $e460a8a24b67695c$var$ImageWrapper;





class $50fe57b595b18ff9$var$ImageTile extends (0, $d91642aad273ae94$export$2e2bcd8739ae039) {
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("./TileState.js").default} state State.
   * @param {string} src Image source URI.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @param {import("./Tile.js").Options} [options] Tile options.
   */ constructor(tileCoord, state, src, crossOrigin, tileLoadFunction, options){
        super(tileCoord, state, options);
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * Image URI
     *
     * @private
     * @type {string}
     */ this.src_ = src;
        this.key = src;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement}
     */ this.image_ = new Image();
        if (crossOrigin !== null) this.image_.crossOrigin = crossOrigin;
        /**
     * @private
     * @type {?function():void}
     */ this.unlisten_ = null;
        /**
     * @private
     * @type {import("./Tile.js").LoadFunction}
     */ this.tileLoadFunction_ = tileLoadFunction;
    }
    /**
   * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
   * @param {HTMLCanvasElement|HTMLImageElement} element Element.
   */ setImage(element) {
        this.image_ = element;
        this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Tracks loading or read errors.
   *
   * @private
   */ handleImageError_() {
        this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR;
        this.unlistenImage_();
        this.image_ = $50fe57b595b18ff9$var$getBlankImage();
        this.changed();
    }
    /**
   * Tracks successful image load.
   *
   * @private
   */ handleImageLoad_() {
        const image = /** @type {HTMLImageElement} */ this.image_;
        if (image.naturalWidth && image.naturalHeight) this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED;
        else this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
        this.unlistenImage_();
        this.changed();
    }
    /**
   * Load the image or retry if loading previously failed.
   * Loading is taken care of by the tile queue, and calling this method is
   * only needed for preloading or for reloading in case of an error.
   *
   * To retry loading tiles on failed requests, use a custom `tileLoadFunction`
   * that checks for error status codes and reloads only when the status code is
   * 408, 429, 500, 502, 503 and 504, and only when not too many retries have been
   * made already:
   *
   * ```js
   * const retryCodes = [408, 429, 500, 502, 503, 504];
   * const retries = {};
   * source.setTileLoadFunction((tile, src) => {
   *   const image = tile.getImage();
   *   fetch(src)
   *     .then((response) => {
   *       if (retryCodes.includes(response.status)) {
   *         retries[src] = (retries[src] || 0) + 1;
   *         if (retries[src] <= 3) {
   *           setTimeout(() => tile.load(), retries[src] * 1000);
   *         }
   *         return Promise.reject();
   *       }
   *       return response.blob();
   *     })
   *     .then((blob) => {
   *       const imageUrl = URL.createObjectURL(blob);
   *       image.src = imageUrl;
   *       setTimeout(() => URL.revokeObjectURL(imageUrl), 5000);
   *     })
   *     .catch(() => tile.setState(3)); // error
   * });
   * ```
   * @api
   * @override
   */ load() {
        if (this.state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR) {
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
        }
        if (this.state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = (0, $e460a8a24b67695c$export$bc96ecc7c2a50764)(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    }
    /**
   * Discards event handlers which listen for load completion or errors.
   *
   * @private
   */ unlistenImage_() {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    }
    /**
   * @override
   */ disposeInternal() {
        this.unlistenImage_();
        this.image_ = null;
        super.disposeInternal();
    }
}
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */ function $50fe57b595b18ff9$var$getBlankImage() {
    const ctx = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
var $50fe57b595b18ff9$export$2e2bcd8739ae039 = $50fe57b595b18ff9$var$ImageTile;


/**
 * @module ol/TileRange
 */ /**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */ class $014fe51f68272f2c$var$TileRange {
    /**
   * @param {number} minX Minimum X.
   * @param {number} maxX Maximum X.
   * @param {number} minY Minimum Y.
   * @param {number} maxY Maximum Y.
   */ constructor(minX, maxX, minY, maxY){
        /**
     * @type {number}
     */ this.minX = minX;
        /**
     * @type {number}
     */ this.maxX = maxX;
        /**
     * @type {number}
     */ this.minY = minY;
        /**
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {boolean} Contains tile coordinate.
   */ contains(tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Contains.
   */ containsTileRange(tileRange) {
        return this.minX <= tileRange.minX && tileRange.maxX <= this.maxX && this.minY <= tileRange.minY && tileRange.maxY <= this.maxY;
    }
    /**
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @return {boolean} Contains coordinate.
   */ containsXY(x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Equals.
   */ equals(tileRange) {
        return this.minX == tileRange.minX && this.minY == tileRange.minY && this.maxX == tileRange.maxX && this.maxY == tileRange.maxY;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   */ extend(tileRange) {
        if (tileRange.minX < this.minX) this.minX = tileRange.minX;
        if (tileRange.maxX > this.maxX) this.maxX = tileRange.maxX;
        if (tileRange.minY < this.minY) this.minY = tileRange.minY;
        if (tileRange.maxY > this.maxY) this.maxY = tileRange.maxY;
    }
    /**
   * @return {number} Height.
   */ getHeight() {
        return this.maxY - this.minY + 1;
    }
    /**
   * @return {import("./size.js").Size} Size.
   */ getSize() {
        return [
            this.getWidth(),
            this.getHeight()
        ];
    }
    /**
   * @return {number} Width.
   */ getWidth() {
        return this.maxX - this.minX + 1;
    }
    /**
   * @param {TileRange} tileRange Tile range.
   * @return {boolean} Intersects.
   */ intersects(tileRange) {
        return this.minX <= tileRange.maxX && this.maxX >= tileRange.minX && this.minY <= tileRange.maxY && this.maxY >= tileRange.minY;
    }
}
function $014fe51f68272f2c$export$958e3e1a02eac4b6(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    return new $014fe51f68272f2c$var$TileRange(minX, maxX, minY, maxY);
}
var $014fe51f68272f2c$export$2e2bcd8739ae039 = $014fe51f68272f2c$var$TileRange;






/**
 * @module ol/reproj/Tile
 */ 






/**
 * @module ol/reproj
 */ 



let $5bc6f6a25c982e7a$var$brokenDiagonalRendering_;
const $5bc6f6a25c982e7a$export$a166f0857c555517 = [];
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */ function $5bc6f6a25c982e7a$var$drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */ function $5bc6f6a25c982e7a$var$verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return Math.abs(data[offset * 4] - 210) > 2 || Math.abs(data[offset * 4 + 3] - 191.25) > 2;
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */ function $5bc6f6a25c982e7a$var$isBrokenDiagonalRendering() {
    if ($5bc6f6a25c982e7a$var$brokenDiagonalRendering_ === undefined) {
        const ctx = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(6, 6, $5bc6f6a25c982e7a$export$a166f0857c555517);
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(210, 0, 0, 0.75)';
        $5bc6f6a25c982e7a$var$drawTestTriangle(ctx, 4, 5, 4, 0);
        $5bc6f6a25c982e7a$var$drawTestTriangle(ctx, 4, 5, 0, 5);
        const data = ctx.getImageData(0, 0, 3, 3).data;
        $5bc6f6a25c982e7a$var$brokenDiagonalRendering_ = $5bc6f6a25c982e7a$var$verifyBrokenDiagonalRendering(data, 0) || $5bc6f6a25c982e7a$var$verifyBrokenDiagonalRendering(data, 4) || $5bc6f6a25c982e7a$var$verifyBrokenDiagonalRendering(data, 8);
        (0, $755a3001f896bcf1$export$e918ac6a1026a12a)(ctx);
        $5bc6f6a25c982e7a$export$a166f0857c555517.push(ctx.canvas);
    }
    return $5bc6f6a25c982e7a$var$brokenDiagonalRendering_;
}
function $5bc6f6a25c982e7a$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution) {
    const sourceCenter = (0, $92f1443438429e81$export$51186ad6e864892a)(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    let sourceResolution = (0, $92f1443438429e81$export$2d8f7b4eec383d44)(targetProj, targetResolution, targetCenter);
    const targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) sourceResolution *= targetMetersPerUnit;
    const sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) sourceResolution /= sourceMetersPerUnit;
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    const sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || (0, $7e819822b33b3d32$export$ac68c24d37ca240f)(sourceExtent, sourceCenter)) {
        const compensationFactor = (0, $92f1443438429e81$export$2d8f7b4eec383d44)(sourceProj, sourceResolution, sourceCenter) / sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) sourceResolution /= compensationFactor;
    }
    return sourceResolution;
}
function $5bc6f6a25c982e7a$export$16d356211d01f1cc(sourceProj, targetProj, targetExtent, targetResolution) {
    const targetCenter = (0, $7e819822b33b3d32$export$c91255cadecfe081)(targetExtent);
    let sourceResolution = $5bc6f6a25c982e7a$export$5fbb958059b7e71f(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) (0, $7e819822b33b3d32$export$f9ed8a3d123a08e2)(targetExtent, function(corner) {
        sourceResolution = $5bc6f6a25c982e7a$export$5fbb958059b7e71f(sourceProj, targetProj, corner, targetResolution);
        return isFinite(sourceResolution) && sourceResolution > 0;
    });
    return sourceResolution;
}
function $5bc6f6a25c982e7a$export$b3890eb0ae9dca99(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, renderEdges, interpolate, drawSingle, clipExtent) {
    const context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(Math.round(pixelRatio * width), Math.round(pixelRatio * height), $5bc6f6a25c982e7a$export$a166f0857c555517);
    if (!interpolate) context.imageSmoothingEnabled = false;
    if (sources.length === 0) return context.canvas;
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = 'lighter';
    const sourceDataExtent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
    sources.forEach(function(src, i, arr) {
        (0, $7e819822b33b3d32$export$8b58be045bf06082)(sourceDataExtent, src.extent);
    });
    let stitchContext;
    const stitchScale = pixelRatio / sourceResolution;
    // Round up Float32 scale values to prevent interpolation in Firefox.
    const inverseScale = (interpolate ? 1 : 1 + Math.pow(2, -24)) / stitchScale;
    if (!drawSingle || sources.length !== 1 || gutter !== 0) {
        stitchContext = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(Math.round((0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(sourceDataExtent) * stitchScale), Math.round((0, $7e819822b33b3d32$export$c08559766941f856)(sourceDataExtent) * stitchScale), $5bc6f6a25c982e7a$export$a166f0857c555517);
        if (!interpolate) stitchContext.imageSmoothingEnabled = false;
        if (sourceExtent && clipExtent) {
            const xPos = (sourceExtent[0] - sourceDataExtent[0]) * stitchScale;
            const yPos = -(sourceExtent[3] - sourceDataExtent[3]) * stitchScale;
            const width = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(sourceExtent) * stitchScale;
            const height = (0, $7e819822b33b3d32$export$c08559766941f856)(sourceExtent) * stitchScale;
            stitchContext.rect(xPos, yPos, width, height);
            stitchContext.clip();
        }
        sources.forEach(function(src, i, arr) {
            // This test should never fail -- but it does. Need to find a fix the upstream condition
            if (src.image.width > 0 && src.image.height > 0) {
                if (src.clipExtent) {
                    stitchContext.save();
                    const xPos = (src.clipExtent[0] - sourceDataExtent[0]) * stitchScale;
                    const yPos = -(src.clipExtent[3] - sourceDataExtent[3]) * stitchScale;
                    const width = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(src.clipExtent) * stitchScale;
                    const height = (0, $7e819822b33b3d32$export$c08559766941f856)(src.clipExtent) * stitchScale;
                    stitchContext.rect(interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? width : Math.round(xPos + width) - Math.round(xPos), interpolate ? height : Math.round(yPos + height) - Math.round(yPos));
                    stitchContext.clip();
                }
                const xPos = (src.extent[0] - sourceDataExtent[0]) * stitchScale;
                const yPos = -(src.extent[3] - sourceDataExtent[3]) * stitchScale;
                const srcWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(src.extent) * stitchScale;
                const srcHeight = (0, $7e819822b33b3d32$export$c08559766941f856)(src.extent) * stitchScale;
                stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, interpolate ? xPos : Math.round(xPos), interpolate ? yPos : Math.round(yPos), interpolate ? srcWidth : Math.round(xPos + srcWidth) - Math.round(xPos), interpolate ? srcHeight : Math.round(yPos + srcHeight) - Math.round(yPos));
                if (src.clipExtent) stitchContext.restore();
            }
        });
    }
    const targetTopLeft = (0, $7e819822b33b3d32$export$cb1538b07e6964ff)(targetExtent);
    triangulation.getTriangles().forEach(function(triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
     * Resulting matrix can be used to transform coordinate
     * from `sourceProjection` to destination pixels.
     *
     * To optimize number of context calls and increase numerical stability,
     * we also do the following operations:
     * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
     * here before solving the linear system so [ui, vi] are pixel coordinates.
     *
     * Src points: xi, yi
     * Dst points: ui, vi
     * Affine coefficients: aij
     *
     * | x0 y0 1  0  0 0 |   |a00|   |u0|
     * | x1 y1 1  0  0 0 |   |a01|   |u1|
     * | x2 y2 1  0  0 0 | x |a02| = |u2|
     * |  0  0 0 x0 y0 1 |   |a10|   |v0|
     * |  0  0 0 x1 y1 1 |   |a11|   |v1|
     * |  0  0 0 x2 y2 1 |   |a12|   |v2|
     */ const source = triangle.source;
        const target = triangle.target;
        let x0 = source[0][0], y0 = source[0][1];
        let x1 = source[1][0], y1 = source[1][1];
        let x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        const u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        const v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        const u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        const v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        const u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        const v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        const sourceNumericalShiftX = x0;
        const sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        const augmentedMatrix = [
            [
                x1,
                y1,
                0,
                0,
                u1 - u0
            ],
            [
                x2,
                y2,
                0,
                0,
                u2 - u0
            ],
            [
                0,
                0,
                x1,
                y1,
                v1 - v0
            ],
            [
                0,
                0,
                x2,
                y2,
                v2 - v0
            ]
        ];
        const affineCoefs = (0, $d4e56cfc37d8b1f9$export$8240f01c446270e6)(augmentedMatrix);
        if (!affineCoefs) return;
        context.save();
        context.beginPath();
        if ($5bc6f6a25c982e7a$var$isBrokenDiagonalRendering() || !interpolate) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            const steps = 4;
            const ud = u0 - u1;
            const vd = v0 - v1;
            for(let step = 0; step < steps; step++){
                // Go horizontally
                context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound(step * vd / (steps - 1)));
                // Go vertically
                if (step != steps - 1) context.lineTo(u1 + pixelRound((step + 1) * ud / steps), v1 + pixelRound((step + 1) * vd / (steps - 1)));
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        } else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        let image;
        if (stitchContext) {
            image = stitchContext.canvas;
            context.scale(inverseScale, -inverseScale);
        } else {
            const source = sources[0];
            const extent = source.extent;
            image = source.image;
            context.scale((0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent) / image.width, -(0, $7e819822b33b3d32$export$c08559766941f856)(extent) / image.height);
        }
        context.drawImage(image, 0, 0);
        context.restore();
    });
    if (stitchContext) {
        (0, $755a3001f896bcf1$export$e918ac6a1026a12a)(stitchContext);
        $5bc6f6a25c982e7a$export$a166f0857c555517.push(stitchContext.canvas);
    }
    if (renderEdges) {
        context.save();
        context.globalCompositeOperation = 'source-over';
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function(triangle, i, arr) {
            const target = triangle.target;
            const u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            const v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            const u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            const v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            const u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            const v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}


/**
 * @module ol/reproj/Triangulation
 */ 



/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */ /**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */ const $72dfda612e83d57a$var$MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */ const $72dfda612e83d57a$var$MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */ class $72dfda612e83d57a$var$Triangulation {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
   * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
   * @param {number} errorThreshold Acceptable error (in source units).
   * @param {?number} destinationResolution The (optional) resolution of the destination.
   * @param {import("../transform.js").Transform} [sourceMatrix] Source transform matrix.
   */ constructor(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, destinationResolution, sourceMatrix){
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.sourceProj_ = sourceProj;
        /**
     * @type {import("../proj/Projection.js").default}
     * @private
     */ this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */ let transformInvCache = {};
        const transformInv = sourceMatrix ? (0, $92f1443438429e81$export$6b4aafd331159e0d)((input)=>(0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(sourceMatrix, (0, $92f1443438429e81$export$51186ad6e864892a)(input, this.targetProj_, this.sourceProj_))) : (0, $92f1443438429e81$export$fce0c6cfca85ed96)(this.targetProj_, this.sourceProj_);
        /**
     * @param {import("../coordinate.js").Coordinate} c A coordinate.
     * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
     * @private
     */ this.transformInv_ = function(c) {
            const key = c[0] + '/' + c[1];
            if (!transformInvCache[key]) transformInvCache[key] = transformInv(c);
            return transformInvCache[key];
        };
        /**
     * @type {import("../extent.js").Extent}
     * @private
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @type {number}
     * @private
     */ this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
     * @type {Array<Triangle>}
     * @private
     */ this.triangles_ = [];
        /**
     * Indicates that the triangulation crosses edge of the source projection.
     * @type {boolean}
     * @private
     */ this.wrapsXInSource_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.canWrapXInSource_ = this.sourceProj_.canWrapX() && !!maxSourceExtent && !!this.sourceProj_.getExtent() && (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(maxSourceExtent) >= (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent());
        /**
     * @type {?number}
     * @private
     */ this.sourceWorldWidth_ = this.sourceProj_.getExtent() ? (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(this.sourceProj_.getExtent()) : null;
        /**
     * @type {?number}
     * @private
     */ this.targetWorldWidth_ = this.targetProj_.getExtent() ? (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(this.targetProj_.getExtent()) : null;
        const destinationTopLeft = (0, $7e819822b33b3d32$export$cb1538b07e6964ff)(targetExtent);
        const destinationTopRight = (0, $7e819822b33b3d32$export$b84fa077c8b05295)(targetExtent);
        const destinationBottomRight = (0, $7e819822b33b3d32$export$e77c1cf70445e168)(targetExtent);
        const destinationBottomLeft = (0, $7e819822b33b3d32$export$8d09f5e2e1bf560d)(targetExtent);
        const sourceTopLeft = this.transformInv_(destinationTopLeft);
        const sourceTopRight = this.transformInv_(destinationTopRight);
        const sourceBottomRight = this.transformInv_(destinationBottomRight);
        const sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
     * The maxSubdivision controls how many splittings of the target area can
     * be done. The idea here is to do a linear mapping of the target areas
     * but the actual overall reprojection (can be) extremely non-linear. The
     * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
     * tile size. However this function is also called to remap canvas rendered
     * layers which can be much larger. This calculation increases the maxSubdivision
     * value by the right factor so that each 256x256 pixel area has
     * MAX_SUBDIVISION divisions.
     */ const maxSubdivision = $72dfda612e83d57a$var$MAX_SUBDIVISION + (destinationResolution ? Math.max(0, Math.ceil(Math.log2((0, $7e819822b33b3d32$export$520c40045967cb15)(targetExtent) / (destinationResolution * destinationResolution * 65536)))) : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            let leftBound = Infinity;
            this.triangles_.forEach(function(triangle, i, arr) {
                leftBound = Math.min(leftBound, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach((triangle)=>{
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) - leftBound > this.sourceWorldWidth_ / 2) {
                    const newTriangle = [
                        [
                            triangle.source[0][0],
                            triangle.source[0][1]
                        ],
                        [
                            triangle.source[1][0],
                            triangle.source[1][1]
                        ],
                        [
                            triangle.source[2][0],
                            triangle.source[2][1]
                        ]
                    ];
                    if (newTriangle[0][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[0][0] -= this.sourceWorldWidth_;
                    if (newTriangle[1][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[1][0] -= this.sourceWorldWidth_;
                    if (newTriangle[2][0] - leftBound > this.sourceWorldWidth_ / 2) newTriangle[2][0] -= this.sourceWorldWidth_;
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    const minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    const maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) triangle.source = newTriangle;
                }
            });
        }
        transformInvCache = {};
    }
    /**
   * Adds triangle to the triangulation.
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @private
   */ addTriangle_(a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [
                aSrc,
                bSrc,
                cSrc
            ],
            target: [
                a,
                b,
                c
            ]
        });
    }
    /**
   * Adds quad (points in clock-wise order) to the triangulation
   * (and reprojects the vertices) if valid.
   * Performs quad subdivision if needed to increase precision.
   *
   * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
   * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
   * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
   * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
   * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
   * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
   * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
   * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
   * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
   * @private
   */ addQuad_(a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        const sourceQuadExtent = (0, $7e819822b33b3d32$export$8aceca7c77505534)([
            aSrc,
            bSrc,
            cSrc,
            dSrc
        ]);
        const sourceCoverageX = this.sourceWorldWidth_ ? (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(sourceQuadExtent) / this.sourceWorldWidth_ : null;
        const sourceWorldWidth = /** @type {number} */ this.sourceWorldWidth_;
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        const wrapsX = this.sourceProj_.canWrapX() && sourceCoverageX > 0.5 && sourceCoverageX < 1;
        let needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                const targetQuadExtent = (0, $7e819822b33b3d32$export$8aceca7c77505534)([
                    a,
                    b,
                    c,
                    d
                ]);
                const targetCoverageX = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision = targetCoverageX > $72dfda612e83d57a$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) needsSubdivision = sourceCoverageX > $72dfda612e83d57a$var$MAX_TRIANGLE_WIDTH || needsSubdivision;
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) && isFinite(sourceQuadExtent[1]) && isFinite(sourceQuadExtent[2]) && isFinite(sourceQuadExtent[3])) {
                if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(sourceQuadExtent, this.maxSourceExtent_)) // whole quad outside source projection extent -> ignore
                return;
            }
        }
        let isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) || !isFinite(bSrc[0]) || !isFinite(bSrc[1]) || !isFinite(cSrc[0]) || !isFinite(cSrc[1]) || !isFinite(dSrc[0]) || !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) needsSubdivision = true;
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite = (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) + (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) + (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) + (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 && isNotFinite != 2 && isNotFinite != 4 && isNotFinite != 8) return;
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                const center = [
                    (a[0] + c[0]) / 2,
                    (a[1] + c[1]) / 2
                ];
                const centerSrc = this.transformInv_(center);
                let dx;
                if (wrapsX) {
                    const centerSrcEstimX = ((0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(aSrc[0], sourceWorldWidth) + (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(cSrc[0], sourceWorldWidth)) / 2;
                    dx = centerSrcEstimX - (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(centerSrc[0], sourceWorldWidth);
                } else dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                const dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                const centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    const bc = [
                        (b[0] + c[0]) / 2,
                        (b[1] + c[1]) / 2
                    ];
                    const bcSrc = this.transformInv_(bc);
                    const da = [
                        (d[0] + a[0]) / 2,
                        (d[1] + a[1]) / 2
                    ];
                    const daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                } else {
                    // split vertically (left & right)
                    const ab = [
                        (a[0] + b[0]) / 2,
                        (a[1] + b[1]) / 2
                    ];
                    const abSrc = this.transformInv_(ab);
                    const cd = [
                        (c[0] + d[0]) / 2,
                        (c[1] + d[1]) / 2
                    ];
                    const cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) return;
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        if ((isNotFinite & 0xe) == 0) this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            if ((isNotFinite & 0x7) == 0) this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
        }
    }
    /**
   * Calculates extent of the `source` coordinates from all the triangles.
   *
   * @return {import("../extent.js").Extent} Calculated extent.
   */ calculateSourceExtent() {
        const extent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        this.triangles_.forEach(function(triangle, i, arr) {
            const src = triangle.source;
            (0, $7e819822b33b3d32$export$1f820e3920fa5715)(extent, src[0]);
            (0, $7e819822b33b3d32$export$1f820e3920fa5715)(extent, src[1]);
            (0, $7e819822b33b3d32$export$1f820e3920fa5715)(extent, src[2]);
        });
        return extent;
    }
    /**
   * @return {Array<Triangle>} Array of the calculated triangles.
   */ getTriangles() {
        return this.triangles_;
    }
}
var $72dfda612e83d57a$export$2e2bcd8739ae039 = $72dfda612e83d57a$var$Triangulation;


/**
 * @module ol/reproj/common
 */ /**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */ const $7b3aa4a24649670e$export$3ecb4bcfa5aae855 = 0.5;


/**
 * @typedef {function(number, number, number, number) : (import("../ImageTile.js").default)} FunctionType
 */ /**
 * @typedef {Object} TileOffset
 * @property {import("../ImageTile.js").default} tile Tile.
 * @property {number} offset Offset.
 */ /**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */ class $c8ca3105da7720d1$var$ReprojTile extends (0, $d91642aad273ae94$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection.
   * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
   * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
   * @param {number} pixelRatio Pixel ratio.
   * @param {number} gutter Gutter of the source tiles.
   * @param {FunctionType} getTileFunction
   *     Function returning source tiles (z, x, y, pixelRatio).
   * @param {number} [errorThreshold] Acceptable reprojection error (in px).
   * @param {boolean} [renderEdges] Render reprojection edges.
   * @param {import("../Tile.js").Options} [options] Tile options.
   */ constructor(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, errorThreshold, renderEdges, options){
        super(tileCoord, (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE, options);
        /**
     * @private
     * @type {boolean}
     */ this.renderEdges_ = renderEdges !== undefined ? renderEdges : false;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.gutter_ = gutter;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.sourceTileGrid_ = sourceTileGrid;
        /**
     * @private
     * @type {import("../tilegrid/TileGrid.js").default}
     */ this.targetTileGrid_ = targetTileGrid;
        /**
     * @private
     * @type {import("../tilecoord.js").TileCoord}
     */ this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
     * @private
     * @type {!Array<TileOffset>}
     */ this.sourceTiles_ = [];
        /**
     * @private
     * @type {?Array<import("../events.js").EventsKey>}
     */ this.sourcesListenerKeys_ = null;
        /**
     * @private
     * @type {number}
     */ this.sourceZ_ = 0;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.clipExtent_ = sourceProj.canWrapX() ? sourceProj.getExtent() : undefined;
        const targetExtent = targetTileGrid.getTileCoordExtent(this.wrappedTileCoord_);
        const maxTargetExtent = this.targetTileGrid_.getExtent();
        let maxSourceExtent = this.sourceTileGrid_.getExtent();
        const limitedTargetExtent = maxTargetExtent ? (0, $7e819822b33b3d32$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        if ((0, $7e819822b33b3d32$export$520c40045967cb15)(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) maxSourceExtent = sourceProjExtent;
            else maxSourceExtent = (0, $7e819822b33b3d32$export$72209efa88586d42)(maxSourceExtent, sourceProjExtent);
        }
        const targetResolution = targetTileGrid.getResolution(this.wrappedTileCoord_[0]);
        const sourceResolution = (0, $5bc6f6a25c982e7a$export$16d356211d01f1cc)(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        const errorThresholdInPixels = errorThreshold !== undefined ? errorThreshold : (0, $7b3aa4a24649670e$export$3ecb4bcfa5aae855);
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = new (0, $72dfda612e83d57a$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
            return;
        }
        this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        let sourceExtent = this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            } else sourceExtent = (0, $7e819822b33b3d32$export$72209efa88586d42)(sourceExtent, maxSourceExtent);
        }
        if (!(0, $7e819822b33b3d32$export$520c40045967cb15)(sourceExtent)) this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
        else {
            let worldWidth = 0;
            let worldsAway = 0;
            if (sourceProj.canWrapX()) {
                worldWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(sourceProjExtent);
                worldsAway = Math.floor((sourceExtent[0] - sourceProjExtent[0]) / worldWidth);
            }
            const sourceExtents = (0, $7e819822b33b3d32$export$9031237f01de0947)(sourceExtent.slice(), sourceProj, true);
            sourceExtents.forEach((extent)=>{
                const sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(extent, this.sourceZ_);
                for(let srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++)for(let srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++){
                    const tile = getTileFunction(this.sourceZ_, srcX, srcY, pixelRatio);
                    if (tile) {
                        const offset = worldsAway * worldWidth;
                        this.sourceTiles_.push({
                            tile: tile,
                            offset: offset
                        });
                    }
                }
                ++worldsAway;
            });
            if (this.sourceTiles_.length === 0) this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY;
        }
    }
    /**
   * Get the HTML Canvas element for this tile.
   * @return {HTMLCanvasElement} Canvas.
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @private
   */ reproject_() {
        const sources = [];
        this.sourceTiles_.forEach((source)=>{
            const tile = source.tile;
            if (tile && tile.getState() == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) {
                const extent = this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord);
                extent[0] += source.offset;
                extent[2] += source.offset;
                const clipExtent = this.clipExtent_?.slice();
                if (clipExtent) {
                    clipExtent[0] += source.offset;
                    clipExtent[2] += source.offset;
                }
                sources.push({
                    extent: extent,
                    clipExtent: clipExtent,
                    image: tile.getImage()
                });
            }
        });
        this.sourceTiles_.length = 0;
        if (sources.length === 0) this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR;
        else {
            const z = this.wrappedTileCoord_[0];
            const size = this.targetTileGrid_.getTileSize(z);
            const width = typeof size === 'number' ? size : size[0];
            const height = typeof size === 'number' ? size : size[1];
            const targetResolution = this.targetTileGrid_.getResolution(z);
            const sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            const targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = (0, $5bc6f6a25c982e7a$export$b3890eb0ae9dca99)(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.interpolate);
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED;
        }
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING;
            this.changed();
            let leftToLoad = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(({ tile: tile })=>{
                const state = tile.getState();
                if (state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE || state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING) {
                    leftToLoad++;
                    const sourceListenKey = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(tile, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, (e)=>{
                        const state = tile.getState();
                        if (state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED || state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR || state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY) {
                            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(sourceListenKey);
                            leftToLoad--;
                            if (leftToLoad === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    });
                    this.sourcesListenerKeys_.push(sourceListenKey);
                }
            });
            if (leftToLoad === 0) setTimeout(this.reproject_.bind(this), 0);
            else this.sourceTiles_.forEach(function({ tile: tile }, i, arr) {
                const state = tile.getState();
                if (state == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) tile.load();
            });
        }
    }
    /**
   * @private
   */ unlistenSources_() {
        this.sourcesListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        this.sourcesListenerKeys_ = null;
    }
    /**
   * Remove from the cache due to expiry
   * @override
   */ release() {
        if (this.canvas_) {
            (0, $755a3001f896bcf1$export$e918ac6a1026a12a)(this.canvas_.getContext('2d'));
            (0, $5bc6f6a25c982e7a$export$a166f0857c555517).push(this.canvas_);
            this.canvas_ = null;
        }
        super.release();
    }
}
var $c8ca3105da7720d1$export$2e2bcd8739ae039 = $c8ca3105da7720d1$var$ReprojTile;


/**
 * @module ol/size
 */ /**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */ /**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [dest] Optional reusable size array.
 * @return {Size} The buffered size.
 */ function $f65ee5b9d8e75975$export$ab1029bcae9ddb4a(size, num, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] + 2 * num;
    dest[1] = size[1] + 2 * num;
    return dest;
}
function $f65ee5b9d8e75975$export$622c471beb1693c7(size) {
    return size[0] > 0 && size[1] > 0;
}
function $f65ee5b9d8e75975$export$dcdf75081b88279d(size, ratio, dest) {
    if (dest === undefined) dest = [
        0,
        0
    ];
    dest[0] = size[0] * ratio + 0.5 | 0;
    dest[1] = size[1] * ratio + 0.5 | 0;
    return dest;
}
function $f65ee5b9d8e75975$export$a71a825ff42fb8e1(size, dest) {
    if (Array.isArray(size)) return size;
    if (dest === undefined) dest = [
        size,
        size
    ];
    else {
        dest[0] = size;
        dest[1] = size;
    }
    return dest;
}


/**
 * @module ol/structs/LRUCache
 */ 

/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Entry|null} newer Newer.
 * @property {Entry|null} older Older.
 * @property {*} value_ Value.
 */ /**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */ class $24eec3dde9adb61e$var$LRUCache {
    /**
   * @param {number} [highWaterMark] High water mark.
   */ constructor(highWaterMark){
        /**
     * Desired max cache size after expireCache(). If set to 0, no cache entries
     * will be pruned at all.
     * @type {number}
     */ this.highWaterMark = highWaterMark !== undefined ? highWaterMark : 2048;
        /**
     * @private
     * @type {number}
     */ this.count_ = 0;
        /**
     * @private
     * @type {!Object<string, Entry>}
     */ this.entries_ = {};
        /**
     * @private
     * @type {?Entry}
     */ this.oldest_ = null;
        /**
     * @private
     * @type {?Entry}
     */ this.newest_ = null;
    }
    deleteOldest() {
        const entry = this.pop();
        if (entry instanceof (0, $17f88068b11f58ac$export$2e2bcd8739ae039)) entry.dispose();
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    }
    /**
   * Expire the cache. When the cache entry is a {@link module:ol/Disposable~Disposable},
   * the entry will be disposed.
   * @param {!Object<string, boolean>} [keep] Keys to keep. To be implemented by subclasses.
   */ expireCache(keep) {
        while(this.canExpireCache())this.deleteOldest();
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        while(this.oldest_)this.deleteOldest();
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Contains key.
   */ containsKey(key) {
        return this.entries_.hasOwnProperty(key);
    }
    /**
   * @param {function(T, string, LRUCache<T>): ?} f The function
   *     to call for every entry from the oldest to the newer. This function takes
   *     3 arguments (the entry value, the entry key and the LRUCache object).
   *     The return value is ignored.
   */ forEach(f) {
        let entry = this.oldest_;
        while(entry){
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    }
    /**
   * @param {string} key Key.
   * @param {*} [options] Options (reserved for subclasses).
   * @return {T} Value.
   */ get(key, options) {
        const entry = this.entries_[key];
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) return entry.value_;
        if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ this.oldest_.newer;
            this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    }
    /**
   * Remove an entry from the cache.
   * @param {string} key The entry key.
   * @return {T} The removed entry.
   */ remove(key) {
        const entry = this.entries_[key];
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(entry !== undefined, 'Tried to get a value for a key that does not exist in the cache');
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ entry.older;
            if (this.newest_) this.newest_.newer = null;
        } else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ entry.newer;
            if (this.oldest_) this.oldest_.older = null;
        } else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.count_;
    }
    /**
   * @return {Array<string>} Keys.
   */ getKeys() {
        const keys = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)keys[i++] = entry.key_;
        return keys;
    }
    /**
   * @return {Array<T>} Values.
   */ getValues() {
        const values = new Array(this.count_);
        let i = 0;
        let entry;
        for(entry = this.newest_; entry; entry = entry.older)values[i++] = entry.value_;
        return values;
    }
    /**
   * @return {T} Last value.
   */ peekLast() {
        return this.oldest_.value_;
    }
    /**
   * @return {string} Last key.
   */ peekLastKey() {
        return this.oldest_.key_;
    }
    /**
   * Get the key of the newest item in the cache.  Throws if the cache is empty.
   * @return {string} The newest key.
   */ peekFirstKey() {
        return this.newest_.key_;
    }
    /**
   * Return an entry without updating least recently used time.
   * @param {string} key Key.
   * @return {T|undefined} Value.
   */ peek(key) {
        return this.entries_[key]?.value_;
    }
    /**
   * @return {T} value Value.
   */ pop() {
        const entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) entry.newer.older = null;
        this.oldest_ = /** @type {Entry} */ entry.newer;
        if (!this.oldest_) this.newest_ = null;
        --this.count_;
        return entry.value_;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ replace(key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    }
    /**
   * @param {string} key Key.
   * @param {T} value Value.
   */ set(key, value) {
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!(key in this.entries_), 'Tried to set a value for a key that is used already');
        const entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value
        };
        if (!this.newest_) this.oldest_ = entry;
        else this.newest_.newer = entry;
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    }
    /**
   * Set a maximum number of entries for the cache.
   * @param {number} size Cache size.
   * @api
   */ setSize(size) {
        this.highWaterMark = size;
    }
}
var $24eec3dde9adb61e$export$2e2bcd8739ae039 = $24eec3dde9adb61e$var$LRUCache;


/**
 * @module ol/tilecoord
 */ /**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */ /**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */ function $321b949bcc451ffb$export$958e3e1a02eac4b6(z, x, y, tileCoord) {
    if (tileCoord !== undefined) {
        tileCoord[0] = z;
        tileCoord[1] = x;
        tileCoord[2] = y;
        return tileCoord;
    }
    return [
        z,
        x,
        y
    ];
}
function $321b949bcc451ffb$export$92d0df0f1d25c63c(z, x, y) {
    return z + '/' + x + '/' + y;
}
function $321b949bcc451ffb$export$a47fb462a08de82f(tileCoord) {
    return $321b949bcc451ffb$export$92d0df0f1d25c63c(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $321b949bcc451ffb$export$7f760414a8e3d2b5(tileKey) {
    const [z, x, y] = tileKey.substring(tileKey.lastIndexOf('/') + 1, tileKey.length).split(',').map(Number);
    return $321b949bcc451ffb$export$92d0df0f1d25c63c(z, x, y);
}
function $321b949bcc451ffb$export$a807b7874eb66454(key) {
    return key.split('/').map(Number);
}
function $321b949bcc451ffb$export$d6af199866bfb566(tileCoord) {
    return $321b949bcc451ffb$export$731f79419750ccf7(tileCoord[0], tileCoord[1], tileCoord[2]);
}
function $321b949bcc451ffb$export$731f79419750ccf7(z, x, y) {
    return (x << z) + y;
}
function $321b949bcc451ffb$export$60bedf8e3e3c3dbe(tileCoord, tileGrid) {
    const z = tileCoord[0];
    const x = tileCoord[1];
    const y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) return false;
    const tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) return true;
    return tileRange.containsXY(x, y);
}





/**
 * @param {string} sourceKey The source key.
 * @param {number} z The tile z level.
 * @param {number} x The tile x level.
 * @param {number} y The tile y level.
 * @return {string} The cache key.
 */ function $317841df0443139a$var$getCacheKey(sourceKey, z, x, y) {
    return `${sourceKey},${(0, $321b949bcc451ffb$export$92d0df0f1d25c63c)(z, x, y)}`;
}
/**
 * @typedef {Object<number, Set<import("../../Tile.js").default>>} TileLookup
 */ /**
 * Add a tile to the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was added to the lookup.
 */ function $317841df0443139a$var$addTileToLookup(tilesByZ, tile, z) {
    if (!(z in tilesByZ)) {
        tilesByZ[z] = new Set([
            tile
        ]);
        return true;
    }
    const set = tilesByZ[z];
    const existing = set.has(tile);
    if (!existing) set.add(tile);
    return !existing;
}
/**
 * Remove a tile from the lookup.
 * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
 * @param {import("../../Tile.js").default} tile A tile.
 * @param {number} z The zoom level.
 * @return {boolean} The tile was removed from the lookup.
 */ function $317841df0443139a$var$removeTileFromLookup(tilesByZ, tile, z) {
    const set = tilesByZ[z];
    if (set) return set.delete(tile);
    return false;
}
/**
 * @param {import("../../Map.js").FrameState} frameState Frame state.
 * @param {import("../../extent.js").Extent} extent The frame extent.
 * @return {import("../../extent.js").Extent} Frame extent intersected with layer extents.
 */ function $317841df0443139a$var$getRenderExtent(frameState, extent) {
    const layerState = frameState.layerStatesArray[frameState.layerIndex];
    if (layerState.extent) extent = (0, $7e819822b33b3d32$export$72209efa88586d42)(extent, (0, $92f1443438429e81$export$494be3a3a25689ca)(layerState.extent, frameState.viewState.projection));
    const source = /** @type {import("../../source/Tile.js").default} */ layerState.layer.getRenderSource();
    if (!source.getWrapX()) {
        const gridExtent = source.getTileGridForProjection(frameState.viewState.projection).getExtent();
        if (gridExtent) extent = (0, $7e819822b33b3d32$export$72209efa88586d42)(extent, gridExtent);
    }
    return extent;
}
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize=512] The cache size.
 */ /**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 * @template {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} [LayerType=import("../../layer/Tile.js").default<import("../../source/Tile.js").default>|import("../../layer/VectorTile.js").default]
 * @extends {CanvasLayerRenderer<LayerType>}
 */ class $317841df0443139a$var$CanvasTileLayerRenderer extends (0, $22aba15f167ce2ee$export$2e2bcd8739ae039) {
    /**
   * @param {LayerType} tileLayer Tile layer.
   * @param {Options} [options] Options.
   */ constructor(tileLayer, options){
        super(tileLayer);
        options = options || {};
        /**
     * Rendered extent has changed since the previous `renderFrame()` call
     * @type {boolean}
     */ this.extentChanged = true;
        /**
     * The last call to `renderFrame` was completed with all tiles loaded
     * @type {boolean}
     */ this.renderComplete = false;
        /**
     * @private
     * @type {?import("../../extent.js").Extent}
     */ this.renderedExtent_ = null;
        /**
     * @protected
     * @type {number}
     */ this.renderedPixelRatio;
        /**
     * @protected
     * @type {import("../../proj/Projection.js").default|null}
     */ this.renderedProjection = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_;
        /**
     * @protected
     * @type {!Array<import("../../Tile.js").default>}
     */ this.renderedTiles = [];
        /**
     * @private
     * @type {string}
     */ this.renderedSourceKey_;
        /**
     * @private
     * @type {number}
     */ this.renderedSourceRevision_;
        /**
     * @protected
     * @type {import("../../extent.js").Extent}
     */ this.tempExtent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../TileRange.js").default}
     */ this.tempTileRange_ = new (0, $014fe51f68272f2c$export$2e2bcd8739ae039)(0, 0, 0, 0);
        /**
     * @type {import("../../tilecoord.js").TileCoord}
     * @private
     */ this.tempTileCoord_ = (0, $321b949bcc451ffb$export$958e3e1a02eac4b6)(0, 0, 0);
        const cacheSize = options.cacheSize !== undefined ? options.cacheSize : 512;
        /**
     * @type {import("../../structs/LRUCache.js").default<import("../../Tile.js").default>}
     * @private
     */ this.tileCache_ = new (0, $24eec3dde9adb61e$export$2e2bcd8739ae039)(cacheSize);
        this.maxStaleKeys = cacheSize * 0.5;
    }
    /**
   * @return {LRUCache} Tile cache.
   */ getTileCache() {
        return this.tileCache_;
    }
    /**
   * Get a tile from the cache or create one if needed.
   *
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getOrCreateTile(z, x, y, frameState) {
        const tileCache = this.tileCache_;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const cacheKey = $317841df0443139a$var$getCacheKey(tileSource.getKey(), z, x, y);
        /** @type {import("../../Tile.js").default} */ let tile;
        if (tileCache.containsKey(cacheKey)) tile = tileCache.get(cacheKey);
        else {
            tile = tileSource.getTile(z, x, y, frameState.pixelRatio, frameState.viewState.projection);
            if (!tile) return null;
            tileCache.set(cacheKey, tile);
        }
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {import("../../Tile.js").default|null} Tile (or null if outside source extent).
   * @protected
   */ getTile(z, x, y, frameState) {
        const tile = this.getOrCreateTile(z, x, y, frameState);
        if (!tile) return null;
        return tile;
    }
    /**
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray} Data at the pixel location.
   * @override
   */ getData(pixel) {
        const frameState = this.frameState;
        if (!frameState) return null;
        const layer = this.getLayer();
        const coordinate = (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
        const layerExtent = layer.getExtent();
        if (layerExtent) {
            if (!(0, $7e819822b33b3d32$export$ac68c24d37ca240f)(layerExtent, coordinate)) return null;
        }
        const viewState = frameState.viewState;
        const source = layer.getRenderSource();
        const tileGrid = source.getTileGridForProjection(viewState.projection);
        const tilePixelRatio = source.getTilePixelRatio(frameState.pixelRatio);
        for(let z = tileGrid.getZForResolution(viewState.resolution); z >= tileGrid.getMinZoom(); --z){
            const tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            const tile = this.getTile(z, tileCoord[1], tileCoord[2], frameState);
            if (!tile || tile.getState() !== (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) continue;
            const tileOrigin = tileGrid.getOrigin(z);
            const tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z));
            const tileResolution = tileGrid.getResolution(z);
            /**
       * @type {import('../../DataTile.js').ImageLike}
       */ let image;
            if (tile instanceof (0, $50fe57b595b18ff9$export$2e2bcd8739ae039) || tile instanceof (0, $c8ca3105da7720d1$export$2e2bcd8739ae039)) image = tile.getImage();
            else if (tile instanceof (0, $151d694da6b9df5d$export$2e2bcd8739ae039)) {
                image = (0, $151d694da6b9df5d$export$3a7c913cb40dcb7d)(tile.getData());
                if (!image) continue;
            } else continue;
            const col = Math.floor(tilePixelRatio * ((coordinate[0] - tileOrigin[0]) / tileResolution - tileCoord[1] * tileSize[0]));
            const row = Math.floor(tilePixelRatio * ((tileOrigin[1] - coordinate[1]) / tileResolution - tileCoord[2] * tileSize[1]));
            const gutter = Math.round(tilePixelRatio * source.getGutterForProjection(viewState.projection));
            return this.getImageData(image, col + gutter, row + gutter);
        }
        return null;
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        if (!this.renderedProjection) this.renderedProjection = frameState.viewState.projection;
        else if (frameState.viewState.projection !== this.renderedProjection) {
            this.tileCache_.clear();
            this.renderedProjection = frameState.viewState.projection;
        }
        const source = this.getLayer().getSource();
        if (!source) return false;
        const sourceRevision = source.getRevision();
        if (!this.renderedRevision_) this.renderedRevision_ = sourceRevision;
        else if (this.renderedRevision_ !== sourceRevision) {
            this.renderedRevision_ = sourceRevision;
            if (this.renderedSourceKey_ === source.getKey()) this.tileCache_.clear();
        }
        return true;
    }
    /**
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {import("../../extent.js").Extent} extent The extent to be rendered.
   * @param {number} initialZ The zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @param {number} preload Number of additional levels to load.
   */ enqueueTiles(frameState, extent, initialZ, tilesByZ, preload) {
        const viewState = frameState.viewState;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getRenderSource();
        const tileGrid = tileSource.getTileGridForProjection(viewState.projection);
        const tileSourceKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) frameState.wantedTiles[tileSourceKey] = {};
        const wantedTiles = frameState.wantedTiles[tileSourceKey];
        const map = tileLayer.getMapInternal();
        const minZ = Math.max(initialZ - preload, tileGrid.getMinZoom(), tileGrid.getZForResolution(Math.min(tileLayer.getMaxResolution(), map ? map.getView().getResolutionForZoom(Math.max(tileLayer.getMinZoom(), 0)) : tileGrid.getResolution(0)), tileSource.zDirection));
        const rotation = viewState.rotation;
        const viewport = rotation ? (0, $7e819822b33b3d32$export$4b7a6fb4002cd6ac)(viewState.center, viewState.resolution, rotation, frameState.size) : undefined;
        for(let z = initialZ; z >= minZ; --z){
            const tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, this.tempTileRange_);
            const tileResolution = tileGrid.getResolution(z);
            for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
                if (rotation && !tileGrid.tileCoordIntersectsViewport([
                    z,
                    x,
                    y
                ], viewport)) continue;
                const tile = this.getTile(z, x, y, frameState);
                if (!tile) continue;
                const added = $317841df0443139a$var$addTileToLookup(tilesByZ, tile, z);
                if (!added) continue;
                const tileQueueKey = tile.getKey();
                wantedTiles[tileQueueKey] = true;
                if (tile.getState() === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) {
                    if (!frameState.tileQueue.isKeyQueued(tileQueueKey)) {
                        const tileCoord = (0, $321b949bcc451ffb$export$958e3e1a02eac4b6)(z, x, y, this.tempTileCoord_);
                        frameState.tileQueue.enqueue([
                            tile,
                            tileSourceKey,
                            tileGrid.getTileCoordCenter(tileCoord),
                            tileResolution
                        ]);
                    }
                }
            }
        }
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findStaleTile_(tileCoord, tilesByZ) {
        const tileCache = this.tileCache_;
        const z = tileCoord[0];
        const x = tileCoord[1];
        const y = tileCoord[2];
        const staleKeys = this.getStaleKeys();
        for(let i = 0; i < staleKeys.length; ++i){
            const cacheKey = $317841df0443139a$var$getCacheKey(staleKeys[i], z, x, y);
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) {
                    tile.endTransition((0, $34772e91e89a736f$export$5e82334337e0f204)(this));
                    $317841df0443139a$var$addTileToLookup(tilesByZ, tile, z);
                    return true;
                }
            }
        }
        return false;
    }
    /**
   * Look for tiles covering the provided tile coordinate at an alternate
   * zoom level.  Loaded tiles will be added to the provided tile texture lookup.
   * @param {import("../../tilegrid/TileGrid.js").default} tileGrid The tile grid.
   * @param {import("../../tilecoord.js").TileCoord} tileCoord The target tile coordinate.
   * @param {number} altZ The alternate zoom level.
   * @param {TileLookup} tilesByZ Lookup of tiles by zoom level.
   * @return {boolean} The tile coordinate is covered by loaded tiles at the alternate zoom level.
   * @private
   */ findAltTiles_(tileGrid, tileCoord, altZ, tilesByZ) {
        const tileRange = tileGrid.getTileRangeForTileCoordAndZ(tileCoord, altZ, this.tempTileRange_);
        if (!tileRange) return false;
        let covered = true;
        const tileCache = this.tileCache_;
        const source = this.getLayer().getRenderSource();
        const sourceKey = source.getKey();
        for(let x = tileRange.minX; x <= tileRange.maxX; ++x)for(let y = tileRange.minY; y <= tileRange.maxY; ++y){
            const cacheKey = $317841df0443139a$var$getCacheKey(sourceKey, altZ, x, y);
            let loaded = false;
            if (tileCache.containsKey(cacheKey)) {
                const tile = tileCache.peek(cacheKey);
                if (tile.getState() === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) {
                    $317841df0443139a$var$addTileToLookup(tilesByZ, tile, altZ);
                    loaded = true;
                }
            }
            if (!loaded) covered = false;
        }
        return covered;
    }
    /**
   * Render the layer.
   *
   * The frame rendering logic has three parts:
   *
   *  1. Enqueue tiles
   *  2. Find alt tiles for those that are not yet loaded
   *  3. Render loaded tiles
   *
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement} target Target that may be used to render content to.
   * @return {HTMLElement} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        let allTilesIdle = true;
        this.renderComplete = true;
        /**
     * TODO:
     *  maybe skip transition when not fully opaque
     *  decide if this.renderComplete is useful
     */ const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const viewResolution = viewState.resolution;
        const viewCenter = viewState.center;
        const pixelRatio = frameState.pixelRatio;
        const tileLayer = this.getLayer();
        const tileSource = tileLayer.getSource();
        const tileGrid = tileSource.getTileGridForProjection(projection);
        const z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const sourceKey = tileSource.getKey();
        if (!this.renderedSourceKey_) this.renderedSourceKey_ = sourceKey;
        else if (this.renderedSourceKey_ !== sourceKey) {
            this.prependStaleKey(this.renderedSourceKey_);
            this.renderedSourceKey_ = sourceKey;
        }
        let frameExtent = frameState.extent;
        const tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        this.prepareContainer(frameState, target);
        // desired dimensions of the canvas in pixels
        const width = this.context.canvas.width;
        const height = this.context.canvas.height;
        const layerExtent = layerState.extent && (0, $92f1443438429e81$export$494be3a3a25689ca)(layerState.extent, projection);
        if (layerExtent) frameExtent = (0, $7e819822b33b3d32$export$72209efa88586d42)(frameExtent, (0, $92f1443438429e81$export$494be3a3a25689ca)(layerState.extent, projection));
        const dx = tileResolution * width / 2 / tilePixelRatio;
        const dy = tileResolution * height / 2 / tilePixelRatio;
        const canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy
        ];
        /**
     * @type {TileLookup}
     */ const tilesByZ = {};
        this.renderedTiles.length = 0;
        /**
     * Part 1: Enqueue tiles
     */ const preload = tileLayer.getPreload();
        if (frameState.nextExtent) {
            const targetZ = tileGrid.getZForResolution(viewState.nextResolution, tileSource.zDirection);
            const nextExtent = $317841df0443139a$var$getRenderExtent(frameState, frameState.nextExtent);
            this.enqueueTiles(frameState, nextExtent, targetZ, tilesByZ, preload);
        }
        const renderExtent = $317841df0443139a$var$getRenderExtent(frameState, frameExtent);
        this.enqueueTiles(frameState, renderExtent, z, tilesByZ, 0);
        if (preload > 0) setTimeout(()=>{
            this.enqueueTiles(frameState, renderExtent, z - 1, tilesByZ, preload - 1);
        }, 0);
        if (!(z in tilesByZ)) return this.container;
        /**
     * Part 2: Find alt tiles for those that are not yet loaded
     */ const uid = (0, $34772e91e89a736f$export$5e82334337e0f204)(this);
        const time = frameState.time;
        // look for cached tiles to use if a target tile is not ready
        for (const tile of tilesByZ[z]){
            const tileState = tile.getState();
            if (tileState === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY) continue;
            const tileCoord = tile.tileCoord;
            if (tileState === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) {
                const alpha = tile.getAlpha(uid, time);
                if (alpha === 1) {
                    // no need to look for alt tiles
                    tile.endTransition(uid);
                    continue;
                }
            }
            if (tileState !== (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE) allTilesIdle = false;
            if (tileState !== (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR) this.renderComplete = false;
            const hasStaleTile = this.findStaleTile_(tileCoord, tilesByZ);
            if (hasStaleTile) {
                // use the stale tile before the new tile's transition has completed
                $317841df0443139a$var$removeTileFromLookup(tilesByZ, tile, z);
                frameState.animate = true;
                continue;
            }
            // first look for child tiles (at z + 1)
            const coveredByChildren = this.findAltTiles_(tileGrid, tileCoord, z + 1, tilesByZ);
            if (coveredByChildren) continue;
            // next look for parent tiles
            const minZoom = tileGrid.getMinZoom();
            for(let parentZ = z - 1; parentZ >= minZoom; --parentZ){
                const coveredByParent = this.findAltTiles_(tileGrid, tileCoord, parentZ, tilesByZ);
                if (coveredByParent) break;
            }
        }
        /**
     * Part 3: Render loaded tiles
     */ const canvasScale = tileResolution / viewResolution * pixelRatio / tilePixelRatio;
        const context = this.getRenderContext(frameState);
        // set scale transform for calculating tile positions on the canvas
        (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (layerState.extent) this.clipUnrotated(context, frameState, layerExtent);
        if (!tileSource.getInterpolate()) context.imageSmoothingEnabled = false;
        this.preRender(context, frameState);
        /** @type {Array<number>} */ const zs = Object.keys(tilesByZ).map(Number);
        zs.sort((0, $830d23b8323fc080$export$fcb633242ef15540));
        let currentClip;
        const clips = [];
        const clipZs = [];
        for(let i = zs.length - 1; i >= 0; --i){
            const currentZ = zs[i];
            const currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            const currentResolution = tileGrid.getResolution(currentZ);
            const currentScale = currentResolution / tileResolution;
            const dx = currentTilePixelSize[0] * currentScale * canvasScale;
            const dy = currentTilePixelSize[1] * currentScale * canvasScale;
            const originTileCoord = tileGrid.getTileCoordForCoordAndZ((0, $7e819822b33b3d32$export$cb1538b07e6964ff)(canvasExtent), currentZ);
            const originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            const origin = (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(this.tempTransform, [
                tilePixelRatio * (originTileExtent[0] - canvasExtent[0]) / tileResolution,
                tilePixelRatio * (canvasExtent[3] - originTileExtent[3]) / tileResolution
            ]);
            const tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            for (const tile of tilesByZ[currentZ]){
                if (tile.getState() !== (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED) continue;
                const tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                const xIndex = originTileCoord[1] - tileCoord[1];
                const nextX = Math.round(origin[0] - (xIndex - 1) * dx);
                const yIndex = originTileCoord[2] - tileCoord[2];
                const nextY = Math.round(origin[1] - (yIndex - 1) * dy);
                const x = Math.round(origin[0] - xIndex * dx);
                const y = Math.round(origin[1] - yIndex * dy);
                const w = nextX - x;
                const h = nextY - y;
                const transition = zs.length === 1;
                let contextSaved = false;
                // Clip mask for regions in this tile that already filled by a higher z tile
                currentClip = [
                    x,
                    y,
                    x + w,
                    y,
                    x + w,
                    y + h,
                    x,
                    y + h
                ];
                for(let i = 0, ii = clips.length; i < ii; ++i)if (!transition && currentZ < clipZs[i]) {
                    const clip = clips[i];
                    if ((0, $7e819822b33b3d32$export$7b0a31e10bbff018)([
                        x,
                        y,
                        x + w,
                        y + h
                    ], [
                        clip[0],
                        clip[3],
                        clip[4],
                        clip[7]
                    ])) {
                        if (!contextSaved) {
                            context.save();
                            contextSaved = true;
                        }
                        context.beginPath();
                        // counter-clockwise (outer ring) for current tile
                        context.moveTo(currentClip[0], currentClip[1]);
                        context.lineTo(currentClip[2], currentClip[3]);
                        context.lineTo(currentClip[4], currentClip[5]);
                        context.lineTo(currentClip[6], currentClip[7]);
                        // clockwise (inner ring) for higher z tile
                        context.moveTo(clip[6], clip[7]);
                        context.lineTo(clip[4], clip[5]);
                        context.lineTo(clip[2], clip[3]);
                        context.lineTo(clip[0], clip[1]);
                        context.clip();
                    }
                }
                clips.push(currentClip);
                clipZs.push(currentZ);
                this.drawTile(tile, frameState, x, y, w, h, tileGutter, transition);
                if (contextSaved) context.restore();
                this.renderedTiles.unshift(tile);
                // TODO: decide if this is necessary
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedResolution = tileResolution;
        this.extentChanged = !this.renderedExtent_ || !(0, $7e819822b33b3d32$export$e9bab7fafb253603)(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.postRender(this.context, frameState);
        if (layerState.extent) context.restore();
        context.imageSmoothingEnabled = true;
        if (this.renderComplete) {
            /**
       * @param {import("../../Map.js").default} map Map.
       * @param {import("../../Map.js").FrameState} frameState Frame state.
       */ const postRenderFunction = (map, frameState)=>{
                const tileSourceKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(tileSource);
                const wantedTiles = frameState.wantedTiles[tileSourceKey];
                const tilesCount = wantedTiles ? Object.keys(wantedTiles).length : 0;
                this.updateCacheSize(tilesCount);
                this.tileCache_.expireCache();
            };
            frameState.postRenderFunctions.push(postRenderFunction);
        }
        if (!this.renderComplete && !allTilesIdle) frameState.animate = true;
        return this.container;
    }
    /**
   * Increases the cache size if needed
   * @param {number} tileCount Minimum number of tiles needed.
   */ updateCacheSize(tileCount) {
        this.tileCache_.highWaterMark = Math.max(this.tileCache_.highWaterMark, tileCount * 2);
    }
    /**
   * @param {import("../../Tile.js").default} tile Tile.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} x Left of the tile.
   * @param {number} y Top of the tile.
   * @param {number} w Width of the tile.
   * @param {number} h Height of the tile.
   * @param {number} gutter Tile gutter.
   * @param {boolean} transition Apply an alpha transition.
   * @protected
   */ drawTile(tile, frameState, x, y, w, h, gutter, transition) {
        let image;
        if (tile instanceof (0, $151d694da6b9df5d$export$2e2bcd8739ae039)) {
            image = (0, $151d694da6b9df5d$export$3a7c913cb40dcb7d)(tile.getData());
            if (!image) throw new Error('Rendering array data is not yet supported');
        } else image = this.getTileImage(/** @type {import("../../ImageTile.js").default} */ tile);
        if (!image) return;
        const context = this.getRenderContext(frameState);
        const uid = (0, $34772e91e89a736f$export$5e82334337e0f204)(this);
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        const alpha = layerState.opacity * (transition ? tile.getAlpha(uid, frameState.time) : 1);
        const alphaChanged = alpha !== context.globalAlpha;
        if (alphaChanged) {
            context.save();
            context.globalAlpha = alpha;
        }
        context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) context.restore();
        if (alpha !== layerState.opacity) frameState.animate = true;
        else if (transition) tile.endTransition(uid);
    }
    /**
   * @return {HTMLCanvasElement} Image
   */ getImage() {
        const context = this.context;
        return context ? context.canvas : null;
    }
    /**
   * Get the image from a tile.
   * @param {import("../../ImageTile.js").default} tile Tile.
   * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
   * @protected
   */ getTileImage(tile) {
        return tile.getImage();
    }
    /**
   * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
   * @param {import("../../source/Tile.js").default} tileSource Tile source.
   * @param {import('../../Tile.js').default} tile Tile.
   * @protected
   */ updateUsedTiles(usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        const tileSourceKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(tileSource);
        if (!(tileSourceKey in usedTiles)) usedTiles[tileSourceKey] = {};
        usedTiles[tileSourceKey][tile.getKey()] = true;
    }
}
var $317841df0443139a$export$2e2bcd8739ae039 = $317841df0443139a$var$CanvasTileLayerRenderer;


/**
 * @module ol/layer/BaseTile
 */ 
/**
 * @module ol/layer/TileProperty
 */ /**
 * @enum {string}
 */ var $620372cf01773fbe$export$2e2bcd8739ae039 = {
    PRELOAD: 'preload',
    USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError'
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   import("./Layer.js").LayerEventType|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */ /**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../Map.js").default#addLayer map.addLayer()}.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [useInterimTilesOnError=true] Deprecated.  Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 * @property {number} [cacheSize=512] The internal tile cache size.  This needs to be large enough to render
 * two zoom levels worth of tiles.
 */ /**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @template {import("../renderer/Layer.js").default} RendererType
 * @extends {Layer<TileSourceType, RendererType>}
 * @api
 */ class $725ae659fa212697$var$BaseTileLayer extends (0, $575253350abb8238$export$2e2bcd8739ae039) {
    /**
   * @param {Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        const cacheSize = options.cacheSize;
        delete options.cacheSize;
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        super(baseOptions);
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {BaseTileLayerOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {BaseTileLayerOnSignature<void>}
     */ this.un;
        /**
     * @type {number|undefined}
     * @private
     */ this.cacheSize_ = cacheSize;
        this.setPreload(options.preload !== undefined ? options.preload : 0);
        this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined ? options.useInterimTilesOnError : true);
    }
    /**
   * @return {number|undefined} The suggested cache size
   * @protected
   */ getCacheSize() {
        return this.cacheSize_;
    }
    /**
   * Return the level as number to which we will preload tiles up to.
   * @return {number} The level to preload tiles up to.
   * @observable
   * @api
   */ getPreload() {
        return /** @type {number} */ this.get((0, $620372cf01773fbe$export$2e2bcd8739ae039).PRELOAD);
    }
    /**
   * Set the level as number to which we will preload tiles up to.
   * @param {number} preload The level to preload tiles up to.
   * @observable
   * @api
   */ setPreload(preload) {
        this.set((0, $620372cf01773fbe$export$2e2bcd8739ae039).PRELOAD, preload);
    }
    /**
   * Deprecated.  Whether we use interim tiles on error.
   * @return {boolean} Use interim tiles on error.
   * @observable
   * @api
   */ getUseInterimTilesOnError() {
        return /** @type {boolean} */ this.get((0, $620372cf01773fbe$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR);
    }
    /**
   * Deprecated.  Set whether we use interim tiles on error.
   * @param {boolean} useInterimTilesOnError Use interim tiles on error.
   * @observable
   * @api
   */ setUseInterimTilesOnError(useInterimTilesOnError) {
        this.set((0, $620372cf01773fbe$export$2e2bcd8739ae039).USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    }
    /**
   * Get data for a pixel location.  The return type depends on the source data.  For image tiles,
   * a four element RGBA array will be returned.  For data tiles, the array length will match the
   * number of bands in the dataset.  For requests outside the layer extent, `null` will be returned.
   * Data for a image tiles can only be retrieved if the source's `crossOrigin` property is set.
   *
   * ```js
   * // display layer data on every pointer move
   * map.on('pointermove', (event) => {
   *   console.log(layer.getData(event.pixel));
   * });
   * ```
   * @param {import("../pixel").Pixel} pixel Pixel.
   * @return {Uint8ClampedArray|Uint8Array|Float32Array|DataView|null} Pixel data.
   * @api
   * @override
   */ getData(pixel) {
        return super.getData(pixel);
    }
}
var $725ae659fa212697$export$2e2bcd8739ae039 = $725ae659fa212697$var$BaseTileLayer;


/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} [TileSourceType=import("../source/Tile.js").default]
 * @extends BaseTileLayer<TileSourceType, CanvasTileLayerRenderer>
 * @api
 */ class $0e25041945985074$var$TileLayer extends (0, $725ae659fa212697$export$2e2bcd8739ae039) {
    /**
   * @param {import("./BaseTile.js").Options<TileSourceType>} [options] Tile layer options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $317841df0443139a$export$2e2bcd8739ae039)(this, {
            cacheSize: this.getCacheSize()
        });
    }
}
var $0e25041945985074$export$2e2bcd8739ae039 = $0e25041945985074$var$TileLayer;



/**
 * @module ol/source/Cluster
 */ /**
 * @module ol/Feature
 */ 



/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */ /**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */ /***
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 * @typedef {Object<string, *> & { geometry?: Geometry }} ObjectWithGeometry
 */ /**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object~BaseObject} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature.js';
 * import Polygon from 'ol/geom/Polygon.js';
 * import Point from 'ol/geom/Point.js';
 *
 * const feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon',
 * });
 *
 * // get the polygon geometry
 * const poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * const point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} [Geometry=import("./geom/Geometry.js").default]
 */ class $1171fbd986f3130c$var$Feature extends (0, $d575b598d09f57d3$export$2e2bcd8739ae039) {
    /**
   * @param {Geometry|ObjectWithGeometry<Geometry>} [geometryOrProperties]
   *     You may pass a Geometry object directly, or an object literal containing
   *     properties. If you pass an object literal, you may include a Geometry
   *     associated with a `geometry` key.
   */ constructor(geometryOrProperties){
        super();
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {FeatureOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {FeatureOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = undefined;
        /**
     * @type {string}
     * @private
     */ this.geometryName_ = 'geometry';
        /**
     * User provided style.
     * @private
     * @type {import("./style/Style.js").StyleLike}
     */ this.style_ = null;
        /**
     * @private
     * @type {import("./style/Style.js").StyleFunction|undefined}
     */ this.styleFunction_ = undefined;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.geometryChangeKey_ = null;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        if (geometryOrProperties) {
            if (typeof /** @type {?} */ geometryOrProperties.getSimplifiedGeometry === 'function') {
                const geometry = /** @type {Geometry} */ geometryOrProperties;
                this.setGeometry(geometry);
            } else {
                /** @type {Object<string, *>} */ const properties = geometryOrProperties;
                this.setProperties(properties);
            }
        }
    }
    /**
   * Clone this feature. If the original feature has a geometry it
   * is also cloned. The feature id is not set in the clone.
   * @return {Feature<Geometry>} The clone.
   * @api
   */ clone() {
        const clone = /** @type {Feature<Geometry>} */ new $1171fbd986f3130c$var$Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        const geometry = this.getGeometry();
        if (geometry) clone.setGeometry(/** @type {Geometry} */ geometry.clone());
        const style = this.getStyle();
        if (style) clone.setStyle(style);
        return clone;
    }
    /**
   * Get the feature's default geometry.  A feature may have any number of named
   * geometries.  The "default" geometry (the one that is rendered by default) is
   * set when calling {@link module:ol/Feature~Feature#setGeometry}.
   * @return {Geometry|undefined} The default geometry for the feature.
   * @api
   * @observable
   */ getGeometry() {
        return /** @type {Geometry|undefined} */ this.get(this.geometryName_);
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is either set when reading data from a remote source or set explicitly by
   * calling {@link module:ol/Feature~Feature#setId}.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * Get the name of the feature's default geometry.  By default, the default
   * geometry is named `geometry`.
   * @return {string} Get the property name associated with the default geometry
   *     for this feature.
   * @api
   */ getGeometryName() {
        return this.geometryName_;
    }
    /**
   * Get the feature's style. Will return what was provided to the
   * {@link module:ol/Feature~Feature#setStyle} method.
   * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the feature's style function.
   * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
   * representing the current style of this feature.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @private
   */ handleGeometryChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleGeometryChanged_() {
        if (this.geometryChangeKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        const geometry = this.getGeometry();
        if (geometry) this.geometryChangeKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(geometry, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleGeometryChange_, this);
        this.changed();
    }
    /**
   * Set the default geometry for the feature.  This will update the property
   * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
   * @param {Geometry|undefined} geometry The new geometry.
   * @api
   * @observable
   */ setGeometry(geometry) {
        this.set(this.geometryName_, geometry);
    }
    /**
   * Set the style for the feature to override the layer style.  This can be a
   * single style object, an array of styles, or a function that takes a
   * resolution and returns an array of styles. To unset the feature style, call
   * `setStyle()` without arguments or a falsey value.
   * @param {import("./style/Style.js").StyleLike} [style] Style for this feature.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setStyle(style) {
        this.style_ = style;
        this.styleFunction_ = !style ? undefined : $1171fbd986f3130c$export$bb06ddfd5d66e02e(style);
        this.changed();
    }
    /**
   * Set the feature id.  The feature id is considered stable and may be used when
   * requesting features or comparing identifiers returned from a remote source.
   * The feature id can be used with the
   * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
   * @param {number|string|undefined} id The feature id.
   * @api
   * @fires module:ol/events/Event~BaseEvent#event:change
   */ setId(id) {
        this.id_ = id;
        this.changed();
    }
    /**
   * Set the property name to be used when getting the feature's default geometry.
   * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
   * this name will be returned.
   * @param {string} name The property name of the default geometry.
   * @api
   */ setGeometryName(name) {
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    }
}
function $1171fbd986f3130c$export$bb06ddfd5d66e02e(obj) {
    if (typeof obj === 'function') return obj;
    /**
   * @type {Array<import("./style/Style.js").default>}
   */ let styles;
    if (Array.isArray(obj)) styles = obj;
    else {
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `ol/style/Style` or an array of `ol/style/Style.js`');
        const style = /** @type {import("./style/Style.js").default} */ obj;
        styles = [
            style
        ];
    }
    return function() {
        return styles;
    };
}
var $1171fbd986f3130c$export$2e2bcd8739ae039 = $1171fbd986f3130c$var$Feature;








/**
 * @module ol/source/Vector
 */ /**
 * @module ol/Collection
 */ /**
 * @module ol/CollectionEventType
 */ /**
 * @enum {string}
 */ var $da68a68ae95b5159$export$2e2bcd8739ae039 = {
    /**
   * Triggered when an item is added to the collection.
   * @event module:ol/Collection.CollectionEvent#add
   * @api
   */ ADD: 'add',
    /**
   * Triggered when an item is removed from the collection.
   * @event module:ol/Collection.CollectionEvent#remove
   * @api
   */ REMOVE: 'remove'
};




/**
 * @enum {string}
 * @private
 */ const $7be3d63260860659$var$Property = {
    LENGTH: 'length'
};
class $7be3d63260860659$export$a87ae6eb2761ec6d extends (0, $0327f54963b35733$export$2e2bcd8739ae039) {
    /**
   * @param {import("./CollectionEventType.js").default} type Type.
   * @param {T} element Element.
   * @param {number} index The index of the added or removed element.
   */ constructor(type, element, index){
        super(type);
        /**
     * The element that is added to or removed from the collection.
     * @type {T}
     * @api
     */ this.element = element;
        /**
     * The index of the added or removed element.
     * @type {number}
     * @api
     */ this.index = index;
    }
}
/***
 * @template T
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent<T>, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */ /**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */ class $7be3d63260860659$var$Collection extends (0, $d575b598d09f57d3$export$2e2bcd8739ae039) {
    /**
   * @param {Array<T>} [array] Array.
   * @param {Options} [options] Collection options.
   */ constructor(array, options){
        super();
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {CollectionOnSignature<T, import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {CollectionOnSignature<T, void>}
     */ this.un;
        options = options || {};
        /**
     * @private
     * @type {boolean}
     */ this.unique_ = !!options.unique;
        /**
     * @private
     * @type {!Array<T>}
     */ this.array_ = array ? array : [];
        if (this.unique_) for(let i = 0, ii = this.array_.length; i < ii; ++i)this.assertUnique_(this.array_[i], i);
        this.updateLength_();
    }
    /**
   * Remove all elements from the collection.
   * @api
   */ clear() {
        while(this.getLength() > 0)this.pop();
    }
    /**
   * Add elements to the collection.  This pushes each item in the provided array
   * to the end of the collection.
   * @param {!Array<T>} arr Array.
   * @return {Collection<T>} This collection.
   * @api
   */ extend(arr) {
        for(let i = 0, ii = arr.length; i < ii; ++i)this.push(arr[i]);
        return this;
    }
    /**
   * Iterate over each element, calling the provided callback.
   * @param {function(T, number, Array<T>): *} f The function to call
   *     for every element. This function takes 3 arguments (the element, the
   *     index and the array). The return value is ignored.
   * @api
   */ forEach(f) {
        const array = this.array_;
        for(let i = 0, ii = array.length; i < ii; ++i)f(array[i], i, array);
    }
    /**
   * Get a reference to the underlying Array object. Warning: if the array
   * is mutated, no events will be dispatched by the collection, and the
   * collection's "length" property won't be in sync with the actual length
   * of the array.
   * @return {!Array<T>} Array.
   * @api
   */ getArray() {
        return this.array_;
    }
    /**
   * Get the element at the provided index.
   * @param {number} index Index.
   * @return {T} Element.
   * @api
   */ item(index) {
        return this.array_[index];
    }
    /**
   * Get the length of this collection.
   * @return {number} The length of the array.
   * @observable
   * @api
   */ getLength() {
        return this.get($7be3d63260860659$var$Property.LENGTH);
    }
    /**
   * Insert an element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ insertAt(index, elem) {
        if (index < 0 || index > this.getLength()) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem);
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new $7be3d63260860659$export$a87ae6eb2761ec6d((0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * Remove the last element of the collection and return it.
   * Return `undefined` if the collection is empty.
   * @return {T|undefined} Element.
   * @api
   */ pop() {
        return this.removeAt(this.getLength() - 1);
    }
    /**
   * Insert the provided element at the end of the collection.
   * @param {T} elem Element.
   * @return {number} New length of the collection.
   * @api
   */ push(elem) {
        if (this.unique_) this.assertUnique_(elem);
        const n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    }
    /**
   * Remove the first occurrence of an element from the collection.
   * @param {T} elem Element.
   * @return {T|undefined} The removed element or undefined if none found.
   * @api
   */ remove(elem) {
        const arr = this.array_;
        for(let i = 0, ii = arr.length; i < ii; ++i){
            if (arr[i] === elem) return this.removeAt(i);
        }
        return undefined;
    }
    /**
   * Remove the element at the provided index and return it.
   * Return `undefined` if the collection does not contain this index.
   * @param {number} index Index.
   * @return {T|undefined} Value.
   * @api
   */ removeAt(index) {
        if (index < 0 || index >= this.getLength()) return undefined;
        const prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $7be3d63260860659$export$a87ae6eb2761ec6d((0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, prev, index));
        return prev;
    }
    /**
   * Set the element at the provided index.
   * @param {number} index Index.
   * @param {T} elem Element.
   * @api
   */ setAt(index, elem) {
        const n = this.getLength();
        if (index >= n) {
            this.insertAt(index, elem);
            return;
        }
        if (index < 0) throw new Error('Index out of bounds: ' + index);
        if (this.unique_) this.assertUnique_(elem, index);
        const prev = this.array_[index];
        this.array_[index] = elem;
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $7be3d63260860659$export$a87ae6eb2761ec6d((0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, prev, index));
        this.dispatchEvent(/** @type {CollectionEvent<T>} */ new $7be3d63260860659$export$a87ae6eb2761ec6d((0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, elem, index));
    }
    /**
   * @private
   */ updateLength_() {
        this.set($7be3d63260860659$var$Property.LENGTH, this.array_.length);
    }
    /**
   * @private
   * @param {T} elem Element.
   * @param {number} [except] Optional index to ignore.
   */ assertUnique_(elem, except) {
        for(let i = 0, ii = this.array_.length; i < ii; ++i){
            if (this.array_[i] === elem && i !== except) throw new Error('Duplicate item added to a unique collection');
        }
    }
}
var $7be3d63260860659$export$2e2bcd8739ae039 = $7be3d63260860659$var$Collection;










/**
 * @module ol/featureloader
 */ 
/**
 *
 * @type {boolean}
 * @private
 */ let $34037dfe4c349357$var$withCredentials = false;
function $34037dfe4c349357$export$441d7b57adab24d0(url, format, extent, resolution, projection, success, failure) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', typeof url === 'function' ? url(extent, resolution, projection) : url, true);
    if (format.getType() == 'arraybuffer') xhr.responseType = 'arraybuffer';
    xhr.withCredentials = $34037dfe4c349357$var$withCredentials;
    /**
   * @param {Event} event Event.
   * @private
   */ xhr.onload = function(event) {
        // status will be 0 for file:// urls
        if (!xhr.status || xhr.status >= 200 && xhr.status < 300) {
            const type = format.getType();
            try {
                /** @type {Document|Node|Object|string|undefined} */ let source;
                if (type == 'text' || type == 'json') source = xhr.responseText;
                else if (type == 'xml') source = xhr.responseXML || xhr.responseText;
                else if (type == 'arraybuffer') source = /** @type {ArrayBuffer} */ xhr.response;
                if (source) success(/** @type {Array<FeatureType>} */ format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection
                }), format.readProjection(source));
                else failure();
            } catch  {
                failure();
            }
        } else failure();
    };
    /**
   * @private
   */ xhr.onerror = failure;
    xhr.send();
}
function $34037dfe4c349357$export$14cc81df70b6707e(url, format) {
    /**
   * @param {import("./extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("./proj/Projection.js").default} projection Projection.
   * @param {function(Array<FeatureType>): void} [success] Success
   *      Function called when loading succeeded.
   * @param {function(): void} [failure] Failure
   *      Function called when loading failed.
   * @this {import("./source/Vector.js").default<FeatureType>}
   */ return function(extent, resolution, projection, success, failure) {
        $34037dfe4c349357$export$441d7b57adab24d0(url, format, extent, resolution, projection, /**
       * @param {Array<FeatureType>} features The loaded features.
       * @param {import("./proj/Projection.js").default} dataProjection Data
       * projection.
       */ (features, dataProjection)=>{
            this.addFeatures(features);
            if (success !== undefined) success(features);
        }, /* FIXME handle error */ failure ? failure : (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8));
    };
}
function $34037dfe4c349357$export$36fa6977a6d0d8fe(xhrWithCredentials) {
    $34037dfe4c349357$var$withCredentials = xhrWithCredentials;
}



/**
 * @module ol/loadingstrategy
 */ 
function $d8ae32e631726bbf$export$84bf76cd7afc7469(extent, resolution) {
    return [
        [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ]
    ];
}
function $d8ae32e631726bbf$export$bf67010aacbe66fa(extent, resolution) {
    return [
        extent
    ];
}
function $d8ae32e631726bbf$export$3c17558da18e4d75(tileGrid) {
    return(/**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj.js").Projection} projection Projection.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */ function(extent, resolution, projection) {
        const z = tileGrid.getZForResolution((0, $92f1443438429e81$export$bd1cd3b88140b906)(resolution, projection));
        const tileRange = tileGrid.getTileRangeForExtentAndZ((0, $92f1443438429e81$export$494be3a3a25689ca)(extent, projection), z);
        /** @type {Array<import("./extent.js").Extent>} */ const extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */ const tileCoord = [
            z,
            0,
            0
        ];
        for(tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1])for(tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2])extents.push((0, $92f1443438429e81$export$96bfd09e2cffb006)(tileGrid.getTileCoordExtent(tileCoord), projection));
        return extents;
    });
}



/**
 * @module ol/render/Feature
 */ 



/**
 * @module ol/geom/flat/center
 */ 
function $33e50334e1a46b7a$export$78e139679ca7205(flatCoordinates, offset, endss, stride) {
    const flatCenters = [];
    let extent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
    for(let i = 0, ii = endss.length; i < ii; ++i){
        const ends = endss[i];
        extent = (0, $7e819822b33b3d32$export$be0ab0bf96ca59ca)(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}



/**
 * @module ol/geom/flat/interpolate
 */ 

function $9ed355ea392180de$export$687ff82efd78795b(flatCoordinates, offset, end, stride, fraction, dest, dimension) {
    let o, t;
    const n = (end - offset) / stride;
    if (n === 1) o = offset;
    else if (n === 2) {
        o = offset;
        t = fraction;
    } else if (n !== 0) {
        let x1 = flatCoordinates[offset];
        let y1 = flatCoordinates[offset + 1];
        let length = 0;
        const cumulativeLengths = [
            0
        ];
        for(let i = offset + stride; i < end; i += stride){
            const x2 = flatCoordinates[i];
            const y2 = flatCoordinates[i + 1];
            length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length);
            x1 = x2;
            y1 = y2;
        }
        const target = fraction * length;
        const index = (0, $830d23b8323fc080$export$2e0ae67339d5f1ac)(cumulativeLengths, target);
        if (index < 0) {
            t = (target - cumulativeLengths[-index - 2]) / (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        } else o = offset + index * stride;
    }
    dimension = dimension > 1 ? dimension : 2;
    dest = dest ? dest : new Array(dimension);
    for(let i = 0; i < dimension; ++i)dest[i] = o === undefined ? NaN : t === undefined ? flatCoordinates[o + i] : (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    return dest;
}
function $9ed355ea392180de$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) return null;
    let coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) return flatCoordinates.slice(offset, offset + stride);
    let lo = offset / stride;
    let hi = end / stride;
    while(lo < hi){
        const mid = lo + hi >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) hi = mid;
        else lo = mid + 1;
    }
    const m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    const m1 = flatCoordinates[(lo + 1) * stride - 1];
    const t = (m - m0) / (m1 - m0);
    coordinate = [];
    for(let i = 0; i < stride - 1; ++i)coordinate.push((0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    coordinate.push(m);
    return coordinate;
}
function $9ed355ea392180de$export$6a3300857e9ef453(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) return $9ed355ea392180de$export$8f44c3c220ef6f09(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    let coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        return null;
    }
    for(let i = 0, ii = ends.length; i < ii; ++i){
        const end = ends[i];
        if (offset == end) continue;
        if (m < flatCoordinates[offset + stride - 1]) return null;
        if (m <= flatCoordinates[end - 1]) return $9ed355ea392180de$export$8f44c3c220ef6f09(flatCoordinates, offset, end, stride, m, false);
        offset = end;
    }
    return null;
}





/**
 * @module ol/geom/LineString
 */ 







/**
 * @module ol/geom/flat/length
 */ /**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */ function $f01092ea270954d4$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride) {
    let x1 = flatCoordinates[offset];
    let y1 = flatCoordinates[offset + 1];
    let length = 0;
    for(let i = offset + stride; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
function $f01092ea270954d4$export$2bbb4f6f727a75c2(flatCoordinates, offset, end, stride) {
    let perimeter = $f01092ea270954d4$export$153f8c6b4d8caebc(flatCoordinates, offset, end, stride);
    const dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    const dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}




/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */ class $a2c21eb98d0bd63f$var$LineString extends (0, $ce25558341ea2841$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.flatMidpoint_ = null;
        /**
     * @private
     * @type {number}
     */ this.flatMidpointRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (layout !== undefined && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed coordinate to the coordinates of the linestring.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @api
   */ appendCoordinate(coordinate) {
        (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatCoordinates, coordinate);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!LineString} Clone.
   * @api
   * @override
   */ clone() {
        const lineString = new $a2c21eb98d0bd63f$var$LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf52e23c2de7bae9$export$bc2eb611ddf80103)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf52e23c2de7bae9$export$4adc8e5135fb44c)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Iterate over each segment, calling the provided callback.
   * If the callback returns a truthy value the function returns that
   * value immediately. Otherwise the function returns `false`.
   *
   * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
   *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
   * @return {T|boolean} Value.
   * @template T,S
   * @api
   */ forEachSegment(callback) {
        return (0, $d3093947f1b30e1e$export$4b80e395e36b5a56)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM') return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        return (0, $9ed355ea392180de$export$8f44c3c220ef6f09)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    }
    /**
   * Return the coordinates of the linestring.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the coordinate at the provided fraction along the linestring.
   * The `fraction` is a number between 0 and 1, where 0 is the start of the
   * linestring and 1 is the end.
   * @param {number} fraction Fraction.
   * @param {import("../coordinate.js").Coordinate} [dest] Optional coordinate whose values will
   *     be modified. If not provided, a new coordinate will be returned.
   * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
   * @api
   */ getCoordinateAt(fraction, dest) {
        return (0, $9ed355ea392180de$export$687ff82efd78795b)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, dest, this.stride);
    }
    /**
   * Return the length of the linestring on projected plane.
   * @return {number} Length (on projected plane).
   * @api
   */ getLength() {
        return (0, $f01092ea270954d4$export$153f8c6b4d8caebc)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_ ?? undefined);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatMidpoint_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {LineString} Simplified LineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$ef693d1572e64fb8)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new $a2c21eb98d0bd63f$var$LineString(simplifiedFlatCoordinates, 'XY');
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'LineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $96949d2e503054c4$export$40d8d71841a3d779)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent, this.getExtent());
    }
    /**
   * Set the coordinates of the linestring.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $4ae92c9bec373de6$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $a2c21eb98d0bd63f$export$2e2bcd8739ae039 = $a2c21eb98d0bd63f$var$LineString;

/**
 * @module ol/geom/MultiLineString
 */ 









/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */ class $977a2295e90f3a11$var$MultiLineString extends (0, $ce25558341ea2841$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
   *     Coordinates or LineString geometries. (For internal use, flat coordinates in
   *     combination with `layout` and `ends` are also accepted.)
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<number>} [ends] Flat coordinate ends for internal use.
   */ constructor(coordinates, layout, ends){
        super();
        /**
     * @type {Array<number>}
     * @private
     */ this.ends_ = [];
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) this.setCoordinates(/** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ coordinates, layout);
        else if (layout !== undefined && ends) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.ends_ = ends;
        } else {
            const lineStrings = /** @type {Array<LineString>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const ends = [];
            for(let i = 0, ii = lineStrings.length; i < ii; ++i){
                const lineString = lineStrings[i];
                (0, $830d23b8323fc080$export$8b58be045bf06082)(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            const layout = lineStrings.length === 0 ? this.getLayout() : lineStrings[0].getLayout();
            this.setFlatCoordinates(layout, flatCoordinates);
            this.ends_ = ends;
        }
    }
    /**
   * Append the passed linestring to the multilinestring.
   * @param {LineString} lineString LineString.
   * @api
   */ appendLineString(lineString) {
        (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiLineString} Clone.
   * @api
   * @override
   */ clone() {
        const multiLineString = new $977a2295e90f3a11$var$MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf52e23c2de7bae9$export$fbf31c8f2668ed5a)(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf52e23c2de7bae9$export$5a48a0eefcf14992)(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * Returns the coordinate at `m` using linear interpolation, or `null` if no
   * such coordinate exists.
   *
   * `extrapolate` controls extrapolation beyond the range of Ms in the
   * MultiLineString. If `extrapolate` is `true` then Ms less than the first
   * M will return the first coordinate and Ms greater than the last M will
   * return the last coordinate.
   *
   * `interpolate` controls interpolation between consecutive LineStrings
   * within the MultiLineString. If `interpolate` is `true` the coordinates
   * will be linearly interpolated between the last coordinate of one LineString
   * and the first coordinate of the next LineString.  If `interpolate` is
   * `false` then the function will return `null` for Ms falling between
   * LineStrings.
   *
   * @param {number} m M.
   * @param {boolean} [extrapolate] Extrapolate. Default is `false`.
   * @param {boolean} [interpolate] Interpolate. Default is `false`.
   * @return {import("../coordinate.js").Coordinate|null} Coordinate.
   * @api
   */ getCoordinateAtM(m, extrapolate, interpolate) {
        if (this.layout != 'XYM' && this.layout != 'XYZM' || this.flatCoordinates.length === 0) return null;
        extrapolate = extrapolate !== undefined ? extrapolate : false;
        interpolate = interpolate !== undefined ? interpolate : false;
        return (0, $9ed355ea392180de$export$6a3300857e9ef453)(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    }
    /**
   * Return the coordinates of the multilinestring.
   * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $76a969a6125a5a4a$export$cbb9596fc0f40db2)(this.flatCoordinates, 0, this.ends_, this.stride);
    }
    /**
   * @return {Array<number>} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Return the linestring at the specified index.
   * @param {number} index Index.
   * @return {LineString} LineString.
   * @api
   */ getLineString(index) {
        if (index < 0 || this.ends_.length <= index) return null;
        return new (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    }
    /**
   * Return the linestrings of this multilinestring.
   * @return {Array<LineString>} LineStrings.
   * @api
   */ getLineStrings() {
        const flatCoordinates = this.flatCoordinates;
        const ends = this.ends_;
        const layout = this.layout;
        /** @type {Array<LineString>} */ const lineStrings = [];
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const lineString = new (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        /** @type {Array<number>} */ const midpoints = [];
        const flatCoordinates = this.flatCoordinates;
        let offset = 0;
        const ends = this.ends_;
        const stride = this.stride;
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const midpoint = (0, $9ed355ea392180de$export$687ff82efd78795b)(flatCoordinates, offset, end, stride, 0.5);
            (0, $830d23b8323fc080$export$8b58be045bf06082)(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiLineString} Simplified MultiLineString.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<number>} */ const simplifiedEnds = [];
        simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$cedb9900c0b225c2)(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new $977a2295e90f3a11$var$MultiLineString(simplifiedFlatCoordinates, 'XY', simplifiedEnds);
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiLineString';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $96949d2e503054c4$export$fdb1d8e850bf7937)(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multilinestring.
   * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 2);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const ends = (0, $4ae92c9bec373de6$export$47c3746a74384d45)(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    }
}
var $977a2295e90f3a11$export$2e2bcd8739ae039 = $977a2295e90f3a11$var$MultiLineString;

/**
 * @module ol/geom/MultiPoint
 */ 






/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */ class $760306f0926782cd$var$MultiPoint extends (0, $ce25558341ea2841$export$2e2bcd8739ae039) {
    /**
   * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(coordinates, layout){
        super();
        if (layout && !Array.isArray(coordinates[0])) this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
        else this.setCoordinates(/** @type {Array<import("../coordinate.js").Coordinate>} */ coordinates, layout);
    }
    /**
   * Append the passed point to this multipoint.
   * @param {Point} point Point.
   * @api
   */ appendPoint(point) {
        (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatCoordinates, point.getFlatCoordinates());
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPoint} Clone.
   * @api
   * @override
   */ clone() {
        const multiPoint = new $760306f0926782cd$var$MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const squaredDistance = (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for(let j = 0; j < stride; ++j)closestPoint[j] = flatCoordinates[i + j];
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    }
    /**
   * Return the coordinates of the multipoint.
   * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
   * @api
   * @override
   */ getCoordinates() {
        return (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e)(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    }
    /**
   * Return the point at the specified index.
   * @param {number} index Index.
   * @return {Point} Point.
   * @api
   */ getPoint(index) {
        const n = this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) return null;
        return new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)(this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    }
    /**
   * Return the points of this multipoint.
   * @return {Array<Point>} Points.
   * @api
   */ getPoints() {
        const flatCoordinates = this.flatCoordinates;
        const layout = this.layout;
        const stride = this.stride;
        /** @type {Array<Point>} */ const points = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const point = new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)(flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPoint';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const stride = this.stride;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            const x = flatCoordinates[i];
            const y = flatCoordinates[i + 1];
            if ((0, $7e819822b33b3d32$export$805bdfd6d6690e97)(extent, x, y)) return true;
        }
        return false;
    }
    /**
   * Set the coordinates of the multipoint.
   * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 1);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        this.flatCoordinates.length = (0, $4ae92c9bec373de6$export$5c4daf67e03c190f)(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    }
}
var $760306f0926782cd$export$2e2bcd8739ae039 = $760306f0926782cd$var$MultiPoint;

/**
 * @module ol/geom/MultiPolygon
 */ 














/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */ class $181e07a3c0063616$var$MultiPolygon extends (0, $ce25558341ea2841$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
   *     For internal use, flat coordinates in combination with `layout` and `endss` are also accepted.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @param {Array<Array<number>>} [endss] Array of ends for internal use with flat coordinates.
   */ constructor(coordinates, layout, endss){
        super();
        /**
     * @type {Array<Array<number>>}
     * @private
     */ this.endss_ = [];
        /**
     * @private
     * @type {number}
     */ this.flatInteriorPointsRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = -1;
        /**
     * @private
     * @type {number}
     */ this.maxDeltaRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.orientedRevision_ = -1;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.orientedFlatCoordinates_ = null;
        if (!endss && !Array.isArray(coordinates[0])) {
            const polygons = /** @type {Array<Polygon>} */ coordinates;
            /** @type {Array<number>} */ const flatCoordinates = [];
            const thisEndss = [];
            for(let i = 0, ii = polygons.length; i < ii; ++i){
                const polygon = polygons[i];
                const offset = flatCoordinates.length;
                const ends = polygon.getEnds();
                for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] += offset;
                (0, $830d23b8323fc080$export$8b58be045bf06082)(flatCoordinates, polygon.getFlatCoordinates());
                thisEndss.push(ends);
            }
            layout = polygons.length === 0 ? this.getLayout() : polygons[0].getLayout();
            coordinates = flatCoordinates;
            endss = thisEndss;
        }
        if (layout !== undefined && endss) {
            this.setFlatCoordinates(layout, /** @type {Array<number>} */ coordinates);
            this.endss_ = endss;
        } else this.setCoordinates(/** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ coordinates, layout);
    }
    /**
   * Append the passed polygon to this multipolygon.
   * @param {Polygon} polygon Polygon.
   * @api
   */ appendPolygon(polygon) {
        /** @type {Array<number>} */ let ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        } else {
            const offset = this.flatCoordinates.length;
            (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] += offset;
        }
        this.endss_.push(ends);
        this.changed();
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!MultiPolygon} Clone.
   * @api
   * @override
   */ clone() {
        const len = this.endss_.length;
        const newEndss = new Array(len);
        for(let i = 0; i < len; ++i)newEndss[i] = this.endss_[i].slice();
        const multiPolygon = new $181e07a3c0063616$var$MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt((0, $bf52e23c2de7bae9$export$37c18e6e7d50501a)(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return (0, $bf52e23c2de7bae9$export$60e067685eb8f9c4)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        return (0, $a614d7cd6ef0f487$export$c760d9d16cf92043)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    }
    /**
   * Return the area of the multipolygon on projected plane.
   * @return {number} Area (on projected plane).
   * @api
   */ getArea() {
        return (0, $b024f94ecb74bc8b$export$78e139679ca7205)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    }
    /**
   * Get the coordinate array for this geometry.  This array has the structure
   * of a GeoJSON coordinate array for multi-polygons.
   *
   * @param {boolean} [right] Orient coordinates according to the right-hand
   *     rule (counter-clockwise for exterior and clockwise for interior rings).
   *     If `false`, coordinates will be oriented according to the left-hand rule
   *     (clockwise for exterior and counter-clockwise for interior rings).
   *     By default, coordinate orientation will depend on how the geometry was
   *     constructed.
   * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
   * @api
   * @override
   */ getCoordinates(right) {
        let flatCoordinates;
        if (right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            (0, $c8291834a008fd82$export$ea9ed55fc2a85010)(flatCoordinates, 0, this.endss_, this.stride, right);
        } else flatCoordinates = this.flatCoordinates;
        return (0, $76a969a6125a5a4a$export$915c7058aeb4dfeb)(flatCoordinates, 0, this.endss_, this.stride);
    }
    /**
   * @return {Array<Array<number>>} Endss.
   */ getEndss() {
        return this.endss_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            const flatCenters = (0, $33e50334e1a46b7a$export$78e139679ca7205)(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = (0, $197384c2130f50ad$export$11463803eda8a372)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.flatInteriorPoints_;
    }
    /**
   * Return the interior points as {@link module:ol/geom/MultiPoint~MultiPoint multipoint}.
   * @return {MultiPoint} Interior points as XYM coordinates, where M is
   * the length of the horizontal intersection that the point belongs to.
   * @api
   */ getInteriorPoints() {
        return new (0, $760306f0926782cd$export$2e2bcd8739ae039)(this.getFlatInteriorPoints().slice(), 'XYM');
    }
    /**
   * @return {Array<number>} Oriented flat coordinates.
   */ getOrientedFlatCoordinates() {
        if (this.orientedRevision_ != this.getRevision()) {
            const flatCoordinates = this.flatCoordinates;
            if ((0, $c8291834a008fd82$export$a1d138f4bd85f4b4)(flatCoordinates, 0, this.endss_, this.stride)) this.orientedFlatCoordinates_ = flatCoordinates;
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = (0, $c8291834a008fd82$export$ea9ed55fc2a85010)(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return /** @type {Array<number>} */ this.orientedFlatCoordinates_;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {MultiPolygon} Simplified MultiPolygon.
   * @protected
   * @override
   */ getSimplifiedGeometryInternal(squaredTolerance) {
        /** @type {Array<number>} */ const simplifiedFlatCoordinates = [];
        /** @type {Array<Array<number>>} */ const simplifiedEndss = [];
        simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$b9acf67ef05cd17c)(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new $181e07a3c0063616$var$MultiPolygon(simplifiedFlatCoordinates, 'XY', simplifiedEndss);
    }
    /**
   * Return the polygon at the specified index.
   * @param {number} index Index.
   * @return {Polygon} Polygon.
   * @api
   */ getPolygon(index) {
        if (index < 0 || this.endss_.length <= index) return null;
        let offset;
        if (index === 0) offset = 0;
        else {
            const prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        const ends = this.endss_[index].slice();
        const end = ends[ends.length - 1];
        if (offset !== 0) for(let i = 0, ii = ends.length; i < ii; ++i)ends[i] -= offset;
        return new (0, $46a66e0f2fc72479$export$2e2bcd8739ae039)(this.flatCoordinates.slice(offset, end), this.layout, ends);
    }
    /**
   * Return the polygons of this multipolygon.
   * @return {Array<Polygon>} Polygons.
   * @api
   */ getPolygons() {
        const layout = this.layout;
        const flatCoordinates = this.flatCoordinates;
        const endss = this.endss_;
        const polygons = [];
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i){
            const ends = endss[i].slice();
            const end = ends[ends.length - 1];
            if (offset !== 0) for(let j = 0, jj = ends.length; j < jj; ++j)ends[j] -= offset;
            const polygon = new (0, $46a66e0f2fc72479$export$2e2bcd8739ae039)(flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'MultiPolygon';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        return (0, $96949d2e503054c4$export$77b72fa3792f5bf0)(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    }
    /**
   * Set the coordinates of the multipolygon.
   * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   * @override
   */ setCoordinates(coordinates, layout) {
        this.setLayout(layout, coordinates, 3);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        const endss = (0, $4ae92c9bec373de6$export$f9f2bb59da4accd3)(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) this.flatCoordinates.length = 0;
        else {
            const lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length = lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    }
}
var $181e07a3c0063616$export$2e2bcd8739ae039 = $181e07a3c0063616$var$MultiPolygon;




/**
 * @typedef {'Point' | 'LineString' | 'LinearRing' | 'Polygon' | 'MultiPoint' | 'MultiLineString'} Type
 * The geometry type.  One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'` or 'MultiLineString'`.
 */ /**
 * @type {import("../transform.js").Transform}
 */ const $78328f7ea9ce528c$var$tmpTransform = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */ class $78328f7ea9ce528c$var$RenderFeature {
    /**
   * @param {Type} type Geometry type.
   * @param {Array<number>} flatCoordinates Flat coordinates. These always need
   *     to be right-handed for polygons.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Object<string, *>} properties Properties.
   * @param {number|string|undefined} id Feature id.
   */ constructor(type, flatCoordinates, ends, stride, properties, id){
        /**
     * @type {import("../style/Style.js").StyleFunction|undefined}
     */ this.styleFunction;
        /**
     * @private
     * @type {import("../extent.js").Extent|undefined}
     */ this.extent_;
        /**
     * @private
     * @type {number|string|undefined}
     */ this.id_ = id;
        /**
     * @private
     * @type {Type}
     */ this.type_ = type;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatCoordinates_ = flatCoordinates;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatInteriorPoints_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.flatMidpoints_ = null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.ends_ = ends || null;
        /**
     * @private
     * @type {Object<string, *>}
     */ this.properties_ = properties;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_;
        /**
     * @private
     * @type {number}
     */ this.stride_ = stride;
        /**
     * @private
     * @type {RenderFeature}
     */ this.simplifiedGeometry_;
    }
    /**
   * Get a feature property by its key.
   * @param {string} key Key
   * @return {*} Value for the requested key.
   * @api
   */ get(key) {
        return this.properties_[key];
    }
    /**
   * Get the extent of this feature's geometry.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        if (!this.extent_) this.extent_ = this.type_ === 'Point' ? (0, $7e819822b33b3d32$export$4838bf78d04a9440)(this.flatCoordinates_) : (0, $7e819822b33b3d32$export$be0ab0bf96ca59ca)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
        return this.extent_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoint() {
        if (!this.flatInteriorPoints_) {
            const flatCenter = (0, $7e819822b33b3d32$export$c91255cadecfe081)(this.getExtent());
            this.flatInteriorPoints_ = (0, $197384c2130f50ad$export$50e3b25928a5e892)(this.flatCoordinates_, 0, this.ends_, 2, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat interior points.
   */ getFlatInteriorPoints() {
        if (!this.flatInteriorPoints_) {
            const ends = (0, $c8291834a008fd82$export$cb72ae403d6e78e6)(this.flatCoordinates_, this.ends_);
            const flatCenters = (0, $33e50334e1a46b7a$export$78e139679ca7205)(this.flatCoordinates_, 0, ends, 2);
            this.flatInteriorPoints_ = (0, $197384c2130f50ad$export$11463803eda8a372)(this.flatCoordinates_, 0, ends, 2, flatCenters);
        }
        return this.flatInteriorPoints_;
    }
    /**
   * @return {Array<number>} Flat midpoint.
   */ getFlatMidpoint() {
        if (!this.flatMidpoints_) this.flatMidpoints_ = (0, $9ed355ea392180de$export$687ff82efd78795b)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
        return this.flatMidpoints_;
    }
    /**
   * @return {Array<number>} Flat midpoints.
   */ getFlatMidpoints() {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            const flatCoordinates = this.flatCoordinates_;
            let offset = 0;
            const ends = /** @type {Array<number>} */ this.ends_;
            for(let i = 0, ii = ends.length; i < ii; ++i){
                const end = ends[i];
                const midpoint = (0, $9ed355ea392180de$export$687ff82efd78795b)(flatCoordinates, offset, end, 2, 0.5);
                (0, $830d23b8323fc080$export$8b58be045bf06082)(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    }
    /**
   * Get the feature identifier.  This is a stable identifier for the feature and
   * is set when reading data from a remote source.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id_;
    }
    /**
   * @return {Array<number>} Flat coordinates.
   */ getOrientedFlatCoordinates() {
        return this.flatCoordinates_;
    }
    /**
   * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
   * determining the geometry type in style function (see {@link #getType}).
   * @return {RenderFeature} Feature.
   * @api
   */ getGeometry() {
        return this;
    }
    /**
   * @param {number} squaredTolerance Squared tolerance.
   * @return {RenderFeature} Simplified geometry.
   */ getSimplifiedGeometry(squaredTolerance) {
        return this;
    }
    /**
   * Get a transformed and simplified version of the geometry.
   * @param {number} squaredTolerance Squared tolerance.
   * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
   * @return {RenderFeature} Simplified geometry.
   */ simplifyTransformed(squaredTolerance, transform) {
        return this;
    }
    /**
   * Get the feature properties.
   * @return {Object<string, *>} Feature properties.
   * @api
   */ getProperties() {
        return this.properties_;
    }
    /**
   * Get an object of all property names and values.  This has the same behavior as getProperties,
   * but is here to conform with the {@link module:ol/Feature~Feature} interface.
   * @return {Object<string, *>?} Object.
   */ getPropertiesInternal() {
        return this.properties_;
    }
    /**
   * @return {number} Stride.
   */ getStride() {
        return this.stride_;
    }
    /**
   * @return {import('../style/Style.js').StyleFunction|undefined} Style
   */ getStyleFunction() {
        return this.styleFunction;
    }
    /**
   * Get the type of this feature's geometry.
   * @return {Type} Geometry type.
   * @api
   */ getType() {
        return this.type_;
    }
    /**
   * Transform geometry coordinates from tile pixel space to projected.
   *
   * @param {import("../proj.js").ProjectionLike} projection The data projection
   */ transform(projection) {
        projection = (0, $92f1443438429e81$export$3988ae62b71be9a3)(projection);
        const pixelExtent = projection.getExtent();
        const projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            const scale = (0, $7e819822b33b3d32$export$c08559766941f856)(projectedExtent) / (0, $7e819822b33b3d32$export$c08559766941f856)(pixelExtent);
            (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)($78328f7ea9ce528c$var$tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            (0, $24a54079104c80a7$export$b92b2dedcfff79de)(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, $78328f7ea9ce528c$var$tmpTransform, this.flatCoordinates_);
        }
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   */ applyTransform(transformFn) {
        transformFn(this.flatCoordinates_, this.flatCoordinates_, this.stride_);
    }
    /**
   * @return {RenderFeature} A cloned render feature.
   */ clone() {
        return new $78328f7ea9ce528c$var$RenderFeature(this.type_, this.flatCoordinates_.slice(), this.ends_?.slice(), this.stride_, Object.assign({}, this.properties_), this.id_);
    }
    /**
   * @return {Array<number>|null} Ends.
   */ getEnds() {
        return this.ends_;
    }
    /**
   * Add transform and resolution based geometry simplification to this instance.
   * @return {RenderFeature} This render feature.
   */ enableSimplifyTransformed() {
        this.simplifyTransformed = (0, $de1052d9f293b73a$export$ff83df6f9971435f)((squaredTolerance, transform)=>{
            if (squaredTolerance === this.squaredTolerance_) return this.simplifiedGeometry_;
            this.simplifiedGeometry_ = this.clone();
            if (transform) this.simplifiedGeometry_.applyTransform(transform);
            const simplifiedFlatCoordinates = this.simplifiedGeometry_.getFlatCoordinates();
            let simplifiedEnds;
            switch(this.type_){
                case 'LineString':
                    simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$ef693d1572e64fb8)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.flatCoordinates_.length, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0);
                    simplifiedEnds = [
                        simplifiedFlatCoordinates.length
                    ];
                    break;
                case 'MultiLineString':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$cedb9900c0b225c2)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                case 'Polygon':
                    simplifiedEnds = [];
                    simplifiedFlatCoordinates.length = (0, $ab8844daaf207c08$export$60a9904b67f8d51b)(simplifiedFlatCoordinates, 0, this.simplifiedGeometry_.ends_, this.simplifiedGeometry_.stride_, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
                    break;
                default:
            }
            if (simplifiedEnds) this.simplifiedGeometry_ = new $78328f7ea9ce528c$var$RenderFeature(this.type_, simplifiedFlatCoordinates, simplifiedEnds, 2, this.properties_, this.id_);
            this.squaredTolerance_ = squaredTolerance;
            return this.simplifiedGeometry_;
        });
        return this;
    }
}
/**
 * @return {Array<number>} Flat coordinates.
 */ $78328f7ea9ce528c$var$RenderFeature.prototype.getFlatCoordinates = $78328f7ea9ce528c$var$RenderFeature.prototype.getOrientedFlatCoordinates;
function $78328f7ea9ce528c$export$b89ab3d1d30dec84(renderFeature) {
    const geometryType = renderFeature.getType();
    switch(geometryType){
        case 'Point':
            return new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates());
        case 'MultiPoint':
            return new (0, $760306f0926782cd$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY');
        case 'LineString':
            return new (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY');
        case 'MultiLineString':
            return new (0, $977a2295e90f3a11$export$2e2bcd8739ae039)(renderFeature.getFlatCoordinates(), 'XY', /** @type {Array<number>} */ renderFeature.getEnds());
        case 'Polygon':
            const flatCoordinates = renderFeature.getFlatCoordinates();
            const ends = renderFeature.getEnds();
            const endss = (0, $c8291834a008fd82$export$cb72ae403d6e78e6)(flatCoordinates, ends);
            return endss.length > 1 ? new (0, $181e07a3c0063616$export$2e2bcd8739ae039)(flatCoordinates, 'XY', endss) : new (0, $46a66e0f2fc72479$export$2e2bcd8739ae039)(flatCoordinates, 'XY', ends);
        default:
            throw new Error('Invalid geometry type:' + geometryType);
    }
}
function $78328f7ea9ce528c$export$ab19ba60efd1c4b5(renderFeature, geometryName) {
    const id = renderFeature.getId();
    const geometry = $78328f7ea9ce528c$export$b89ab3d1d30dec84(renderFeature);
    const properties = renderFeature.getProperties();
    const feature = new (0, $1171fbd986f3130c$export$2e2bcd8739ae039)();
    if (geometryName !== undefined) feature.setGeometryName(geometryName);
    feature.setGeometry(geometry);
    if (id !== undefined) feature.setId(id);
    feature.setProperties(properties, true);
    return feature;
}
var $78328f7ea9ce528c$export$2e2bcd8739ae039 = $78328f7ea9ce528c$var$RenderFeature;


/**
 * @module ol/structs/RBush
 */ var $0766cff04a19fcfa$exports = {};
!function(t, i) {
    $0766cff04a19fcfa$exports = i();
}($0766cff04a19fcfa$exports, function() {
    "use strict";
    function t(e, h, r = 0, s = e.length - 1, a = n) {
        for(; s > r;){
            if (s - r > 600) {
                const i = s - r + 1, n = h - r + 1, o = Math.log(i), l = .5 * Math.exp(2 * o / 3), c = .5 * Math.sqrt(o * l * (i - l) / i) * (n - i / 2 < 0 ? -1 : 1);
                t(e, h, Math.max(r, Math.floor(h - n * l / i + c)), Math.min(s, Math.floor(h + (i - n) * l / i + c)), a);
            }
            const n = e[h];
            let o = r, l = s;
            for(i(e, r, h), a(e[s], n) > 0 && i(e, r, s); o < l;){
                for(i(e, o, l), o++, l--; a(e[o], n) < 0;)o++;
                for(; a(e[l], n) > 0;)l--;
            }
            0 === a(e[r], n) ? i(e, r, l) : (l++, i(e, l, s)), l <= h && (r = l + 1), h <= l && (s = l - 1);
        }
    }
    function i(t, i, n) {
        const e = t[i];
        t[i] = t[n], t[n] = e;
    }
    function n(t, i) {
        return t < i ? -1 : t > i ? 1 : 0;
    }
    function e(t, i, n) {
        if (!n) return i.indexOf(t);
        for(let e = 0; e < i.length; e++)if (n(t, i[e])) return e;
        return -1;
    }
    function h(t, i) {
        r(t, 0, t.children.length, i, t);
    }
    function r(t, i, n, e, h) {
        h || (h = d(null)), h.minX = 1 / 0, h.minY = 1 / 0, h.maxX = -1 / 0, h.maxY = -1 / 0;
        for(let r = i; r < n; r++){
            const i = t.children[r];
            s(h, t.leaf ? e(i) : i);
        }
        return h;
    }
    function s(t, i) {
        return t.minX = Math.min(t.minX, i.minX), t.minY = Math.min(t.minY, i.minY), t.maxX = Math.max(t.maxX, i.maxX), t.maxY = Math.max(t.maxY, i.maxY), t;
    }
    function a(t, i) {
        return t.minX - i.minX;
    }
    function o(t, i) {
        return t.minY - i.minY;
    }
    function l(t) {
        return (t.maxX - t.minX) * (t.maxY - t.minY);
    }
    function c(t) {
        return t.maxX - t.minX + (t.maxY - t.minY);
    }
    function m(t, i) {
        const n = Math.max(t.minX, i.minX), e = Math.max(t.minY, i.minY), h = Math.min(t.maxX, i.maxX), r = Math.min(t.maxY, i.maxY);
        return Math.max(0, h - n) * Math.max(0, r - e);
    }
    function f(t, i) {
        return t.minX <= i.minX && t.minY <= i.minY && i.maxX <= t.maxX && i.maxY <= t.maxY;
    }
    function u(t, i) {
        return i.minX <= t.maxX && i.minY <= t.maxY && i.maxX >= t.minX && i.maxY >= t.minY;
    }
    function d(t) {
        return {
            children: t,
            height: 1,
            leaf: !0,
            minX: 1 / 0,
            minY: 1 / 0,
            maxX: -1 / 0,
            maxY: -1 / 0
        };
    }
    function x(i, n, e, h, r) {
        const s = [
            n,
            e
        ];
        for(; s.length;){
            if ((e = s.pop()) - (n = s.pop()) <= h) continue;
            const a = n + Math.ceil((e - n) / h / 2) * h;
            t(i, a, n, e, r), s.push(n, a, a, e);
        }
    }
    return class {
        constructor(t = 9){
            this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(.4 * this._maxEntries)), this.clear();
        }
        all() {
            return this._all(this.data, []);
        }
        search(t) {
            let i = this.data;
            const n = [];
            if (!u(t, i)) return n;
            const e = this.toBBox, h = [];
            for(; i;){
                for(let r = 0; r < i.children.length; r++){
                    const s = i.children[r], a = i.leaf ? e(s) : s;
                    u(t, a) && (i.leaf ? n.push(s) : f(t, a) ? this._all(s, n) : h.push(s));
                }
                i = h.pop();
            }
            return n;
        }
        collides(t) {
            let i = this.data;
            if (!u(t, i)) return !1;
            const n = [];
            for(; i;){
                for(let e = 0; e < i.children.length; e++){
                    const h = i.children[e], r = i.leaf ? this.toBBox(h) : h;
                    if (u(t, r)) {
                        if (i.leaf || f(t, r)) return !0;
                        n.push(h);
                    }
                }
                i = n.pop();
            }
            return !1;
        }
        load(t) {
            if (!t || !t.length) return this;
            if (t.length < this._minEntries) {
                for(let i = 0; i < t.length; i++)this.insert(t[i]);
                return this;
            }
            let i = this._build(t.slice(), 0, t.length - 1, 0);
            if (this.data.children.length) {
                if (this.data.height === i.height) this._splitRoot(this.data, i);
                else {
                    if (this.data.height < i.height) {
                        const t = this.data;
                        this.data = i, i = t;
                    }
                    this._insert(i, this.data.height - i.height - 1, !0);
                }
            } else this.data = i;
            return this;
        }
        insert(t) {
            return t && this._insert(t, this.data.height - 1), this;
        }
        clear() {
            return this.data = d([]), this;
        }
        remove(t, i) {
            if (!t) return this;
            let n = this.data;
            const h = this.toBBox(t), r = [], s = [];
            let a, o, l;
            for(; n || r.length;){
                if (n || (n = r.pop(), o = r[r.length - 1], a = s.pop(), l = !0), n.leaf) {
                    const h = e(t, n.children, i);
                    if (-1 !== h) return n.children.splice(h, 1), r.push(n), this._condense(r), this;
                }
                l || n.leaf || !f(n, h) ? o ? (a++, n = o.children[a], l = !1) : n = null : (r.push(n), s.push(a), a = 0, o = n, n = n.children[0]);
            }
            return this;
        }
        toBBox(t) {
            return t;
        }
        compareMinX(t, i) {
            return t.minX - i.minX;
        }
        compareMinY(t, i) {
            return t.minY - i.minY;
        }
        toJSON() {
            return this.data;
        }
        fromJSON(t) {
            return this.data = t, this;
        }
        _all(t, i) {
            const n = [];
            for(; t;)t.leaf ? i.push(...t.children) : n.push(...t.children), t = n.pop();
            return i;
        }
        _build(t, i, n, e) {
            const r = n - i + 1;
            let s, a = this._maxEntries;
            if (r <= a) return s = d(t.slice(i, n + 1)), h(s, this.toBBox), s;
            e || (e = Math.ceil(Math.log(r) / Math.log(a)), a = Math.ceil(r / Math.pow(a, e - 1))), s = d([]), s.leaf = !1, s.height = e;
            const o = Math.ceil(r / a), l = o * Math.ceil(Math.sqrt(a));
            x(t, i, n, l, this.compareMinX);
            for(let h = i; h <= n; h += l){
                const i = Math.min(h + l - 1, n);
                x(t, h, i, o, this.compareMinY);
                for(let n = h; n <= i; n += o){
                    const h = Math.min(n + o - 1, i);
                    s.children.push(this._build(t, n, h, e - 1));
                }
            }
            return h(s, this.toBBox), s;
        }
        _chooseSubtree(t, i, n, e) {
            for(; e.push(i), !i.leaf && e.length - 1 !== n;){
                let n, e = 1 / 0, s = 1 / 0;
                for(let a = 0; a < i.children.length; a++){
                    const o = i.children[a], c = l(o), m = (h = t, r = o, (Math.max(r.maxX, h.maxX) - Math.min(r.minX, h.minX)) * (Math.max(r.maxY, h.maxY) - Math.min(r.minY, h.minY)) - c);
                    m < s ? (s = m, e = c < e ? c : e, n = o) : m === s && c < e && (e = c, n = o);
                }
                i = n || i.children[0];
            }
            var h, r;
            return i;
        }
        _insert(t, i, n) {
            const e = n ? t : this.toBBox(t), h = [], r = this._chooseSubtree(e, this.data, i, h);
            for(r.children.push(t), s(r, e); i >= 0 && h[i].children.length > this._maxEntries;)this._split(h, i), i--;
            this._adjustParentBBoxes(e, h, i);
        }
        _split(t, i) {
            const n = t[i], e = n.children.length, r = this._minEntries;
            this._chooseSplitAxis(n, r, e);
            const s = this._chooseSplitIndex(n, r, e), a = d(n.children.splice(s, n.children.length - s));
            a.height = n.height, a.leaf = n.leaf, h(n, this.toBBox), h(a, this.toBBox), i ? t[i - 1].children.push(a) : this._splitRoot(n, a);
        }
        _splitRoot(t, i) {
            this.data = d([
                t,
                i
            ]), this.data.height = t.height + 1, this.data.leaf = !1, h(this.data, this.toBBox);
        }
        _chooseSplitIndex(t, i, n) {
            let e, h = 1 / 0, s = 1 / 0;
            for(let a = i; a <= n - i; a++){
                const i = r(t, 0, a, this.toBBox), o = r(t, a, n, this.toBBox), c = m(i, o), f = l(i) + l(o);
                c < h ? (h = c, e = a, s = f < s ? f : s) : c === h && f < s && (s = f, e = a);
            }
            return e || n - i;
        }
        _chooseSplitAxis(t, i, n) {
            const e = t.leaf ? this.compareMinX : a, h = t.leaf ? this.compareMinY : o;
            this._allDistMargin(t, i, n, e) < this._allDistMargin(t, i, n, h) && t.children.sort(e);
        }
        _allDistMargin(t, i, n, e) {
            t.children.sort(e);
            const h = this.toBBox, a = r(t, 0, i, h), o = r(t, n - i, n, h);
            let l = c(a) + c(o);
            for(let e = i; e < n - i; e++){
                const i = t.children[e];
                s(a, t.leaf ? h(i) : i), l += c(a);
            }
            for(let e = n - i - 1; e >= i; e--){
                const i = t.children[e];
                s(o, t.leaf ? h(i) : i), l += c(o);
            }
            return l;
        }
        _adjustParentBBoxes(t, i, n) {
            for(let e = n; e >= 0; e--)s(i[e], t);
        }
        _condense(t) {
            for(let i, n = t.length - 1; n >= 0; n--)0 === t[n].children.length ? n > 0 ? (i = t[n - 1].children, i.splice(i.indexOf(t[n]), 1)) : this.clear() : h(t[n], this.toBBox);
        }
    };
});





/**
 * @typedef {import("rbush").BBox & {value: T}} Entry
 * @template T
 */ /**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template {Object} T
 */ class $02caaf5d0144620b$var$RBush {
    /**
   * @param {number} [maxEntries] Max entries.
   */ constructor(maxEntries){
        /**
     * @private
     * @type {RBush_<Entry<T>>}
     */ this.rbush_ = new (0, (/*@__PURE__*/$parcel$interopDefault($0766cff04a19fcfa$exports)))(maxEntries);
        /**
     * A mapping between the objects added to this rbush wrapper
     * and the objects that are actually added to the internal rbush.
     * @private
     * @type {Object<string, Entry<T>>}
     */ this.items_ = {};
    }
    /**
   * Insert a value into the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ insert(extent, value) {
        /** @type {Entry<T>} */ const item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value
        };
        this.rbush_.insert(item);
        this.items_[(0, $34772e91e89a736f$export$5e82334337e0f204)(value)] = item;
    }
    /**
   * Bulk-insert values into the RBush.
   * @param {Array<import("../extent.js").Extent>} extents Extents.
   * @param {Array<T>} values Values.
   */ load(extents, values) {
        const items = new Array(values.length);
        for(let i = 0, l = values.length; i < l; i++){
            const extent = extents[i];
            const value = values[i];
            /** @type {Entry<T>} */ const item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value
            };
            items[i] = item;
            this.items_[(0, $34772e91e89a736f$export$5e82334337e0f204)(value)] = item;
        }
        this.rbush_.load(items);
    }
    /**
   * Remove a value from the RBush.
   * @param {T} value Value.
   * @return {boolean} Removed.
   */ remove(value) {
        const uid = (0, $34772e91e89a736f$export$5e82334337e0f204)(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        const item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    }
    /**
   * Update the extent of a value in the RBush.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {T} value Value.
   */ update(extent, value) {
        const item = this.items_[(0, $34772e91e89a736f$export$5e82334337e0f204)(value)];
        const bbox = [
            item.minX,
            item.minY,
            item.maxX,
            item.maxY
        ];
        if (!(0, $7e819822b33b3d32$export$e9bab7fafb253603)(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    }
    /**
   * Return all values in the RBush.
   * @return {Array<T>} All.
   */ getAll() {
        const items = this.rbush_.all();
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Return all values in the given extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {Array<T>} All in extent.
   */ getInExtent(extent) {
        /** @type {import("rbush").BBox} */ const bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3]
        };
        const items = this.rbush_.search(bbox);
        return items.map(function(item) {
            return item.value;
        });
    }
    /**
   * Calls a callback function with each value in the tree.
   * If the callback returns a truthy value, this value is returned without
   * checking the rest of the tree.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEach(callback) {
        return this.forEach_(this.getAll(), callback);
    }
    /**
   * Calls a callback function with each value in the provided extent.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   */ forEachInExtent(extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    }
    /**
   * @param {Array<T>} values Values.
   * @param {function(T): R} callback Callback.
   * @return {R|undefined} Callback return value.
   * @template R
   * @private
   */ forEach_(values, callback) {
        let result;
        for(let i = 0, l = values.length; i < l; i++){
            result = callback(values[i]);
            if (result) return result;
        }
        return result;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(this.items_);
    }
    /**
   * Remove all values from the RBush.
   */ clear() {
        this.rbush_.clear();
        this.items_ = {};
    }
    /**
   * @param {import("../extent.js").Extent} [extent] Extent.
   * @return {import("../extent.js").Extent} Extent.
   */ getExtent(extent) {
        const data = this.rbush_.toJSON();
        return (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(data.minX, data.minY, data.maxX, data.maxY, extent);
    }
    /**
   * @param {RBush<T>} rbush R-Tree.
   */ concat(rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for(const i in rbush.items_)this.items_[i] = rbush.items_[i];
    }
}
var $02caaf5d0144620b$export$2e2bcd8739ae039 = $02caaf5d0144620b$var$RBush;



/**
 * @module ol/source/Source
 */ 

/**
 * @typedef {'undefined' | 'loading' | 'ready' | 'error'} State
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */ /**
 * A function that takes a {@link import("../View.js").ViewStateLayerStateExtent} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../View.js").ViewStateLayerStateExtent): (string|Array<string>)} Attribution
 */ /**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * a simple string (e.g. `'© Acme Inc.'`)
 * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */ /**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./Source.js").State} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */ class $dba8564f516aed29$var$Source extends (0, $d575b598d09f57d3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Source options.
   */ constructor(options){
        super();
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|null}
     */ this.projection = (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.projection);
        /**
     * @private
     * @type {?Attribution}
     */ this.attributions_ = $dba8564f516aed29$var$adaptAttributions(options.attributions);
        /**
     * @private
     * @type {boolean}
     */ this.attributionsCollapsible_ = options.attributionsCollapsible ?? true;
        /**
     * This source is currently loading data. Sources that defer loading to the
     * map's tile queue never set this to `true`.
     * @type {boolean}
     */ this.loading = false;
        /**
     * @private
     * @type {import("./Source.js").State}
     */ this.state_ = options.state !== undefined ? options.state : 'ready';
        /**
     * @private
     * @type {boolean}
     */ this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = !!options.interpolate;
        /**
     * @protected
     * @type {function(import("../View.js").ViewOptions):void}
     */ this.viewResolver = null;
        /**
     * @protected
     * @type {function(Error):void}
     */ this.viewRejector = null;
        const self = this;
        /**
     * @private
     * @type {Promise<import("../View.js").ViewOptions>}
     */ this.viewPromise_ = new Promise(function(resolve, reject) {
            self.viewResolver = resolve;
            self.viewRejector = reject;
        });
    }
    /**
   * Get the attribution function for the source.
   * @return {?Attribution} Attribution function.
   * @api
   */ getAttributions() {
        return this.attributions_;
    }
    /**
   * @return {boolean} Attributions are collapsible.
   * @api
   */ getAttributionsCollapsible() {
        return this.attributionsCollapsible_;
    }
    /**
   * Get the projection of the source.
   * @return {import("../proj/Projection.js").default|null} Projection.
   * @api
   */ getProjection() {
        return this.projection;
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   */ getResolutions(projection) {
        return null;
    }
    /**
   * @return {Promise<import("../View.js").ViewOptions>} A promise for view-related properties.
   */ getView() {
        return this.viewPromise_;
    }
    /**
   * Get the state of the source, see {@link import("./Source.js").State} for possible states.
   * @return {import("./Source.js").State} State.
   * @api
   */ getState() {
        return this.state_;
    }
    /**
   * @return {boolean|undefined} Wrap X.
   */ getWrapX() {
        return this.wrapX_;
    }
    /**
   * @return {boolean} Use linear interpolation when resampling.
   */ getInterpolate() {
        return this.interpolate_;
    }
    /**
   * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
   * @api
   */ refresh() {
        this.changed();
    }
    /**
   * Set the attributions of the source.
   * @param {AttributionLike|undefined} attributions Attributions.
   *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
   *     or `undefined`.
   * @api
   */ setAttributions(attributions) {
        this.attributions_ = $dba8564f516aed29$var$adaptAttributions(attributions);
        this.changed();
    }
    /**
   * Set the state of the source.
   * @param {import("./Source.js").State} state State.
   */ setState(state) {
        this.state_ = state;
        this.changed();
    }
}
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {Attribution|null} An attribution function (or null).
 */ function $dba8564f516aed29$var$adaptAttributions(attributionLike) {
    if (!attributionLike) return null;
    if (typeof attributionLike === 'function') return attributionLike;
    if (!Array.isArray(attributionLike)) attributionLike = [
        attributionLike
    ];
    return (frameState)=>attributionLike;
}
var $dba8564f516aed29$export$2e2bcd8739ae039 = $dba8564f516aed29$var$Source;


/**
 * @module ol/source/VectorEventType
 */ /**
 * @enum {string}
 */ var $06df2a0f10306cb8$export$2e2bcd8739ae039 /**
 * @typedef {'addfeature'|'changefeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */  = {
    /**
   * Triggered when a feature is added to the source.
   * @event module:ol/source/Vector.VectorSourceEvent#addfeature
   * @api
   */ ADDFEATURE: 'addfeature',
    /**
   * Triggered when a feature is updated.
   * @event module:ol/source/Vector.VectorSourceEvent#changefeature
   * @api
   */ CHANGEFEATURE: 'changefeature',
    /**
   * Triggered when the clear method is called on the source.
   * @event module:ol/source/Vector.VectorSourceEvent#clear
   * @api
   */ CLEAR: 'clear',
    /**
   * Triggered when a feature is removed from the source.
   * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
   * @event module:ol/source/Vector.VectorSourceEvent#removefeature
   * @api
   */ REMOVEFEATURE: 'removefeature',
    /**
   * Triggered when features starts loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
   * @api
   */ FEATURESLOADSTART: 'featuresloadstart',
    /**
   * Triggered when features finishes loading.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
   * @api
   */ FEATURESLOADEND: 'featuresloadend',
    /**
   * Triggered if feature loading results in an error.
   * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
   * @api
   */ FEATURESLOADERROR: 'featuresloaderror'
};


class $69f8886165740064$export$d402fd02dc2b661c extends (0, $0327f54963b35733$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {FeatureType} [feature] Feature.
   * @param {Array<FeatureType>} [features] Features.
   */ constructor(type, feature, features){
        super(type);
        /**
     * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
     * @type {FeatureType|undefined}
     * @api
     */ this.feature = feature;
        /**
     * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
     * @type {Array<FeatureType>|undefined}
     * @api
     */ this.features = features;
    }
}
/***
 * @template {import("../Feature.js").FeatureLike} [T=import("../Feature.js").default]
 * @typedef {T extends RenderFeature ? T|Array<T> : T} FeatureClassOrArrayOfRenderFeatures
 */ /***
 * @template Return
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent<FeatureType>, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<FeatureType>|Collection<FeatureType>} [features]
 * Features. If provided as {@link module:ol/Collection~Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default<FeatureType>} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader<FeatureType>} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import Vector from 'ol/source/Vector.js';
 * import GeoJSON from 'ol/format/GeoJSON.js';
 * import {bbox} from 'ol/loadingstrategy.js';
 *
 * const vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      const proj = projection.getCode();
 *      const url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      const xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      const onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          const features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox,
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection~Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */ /**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 */ class $69f8886165740064$var$VectorSource extends (0, $dba8564f516aed29$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Vector source options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            interpolate: true,
            projection: undefined,
            state: 'ready',
            wrapX: options.wrapX !== undefined ? options.wrapX : true
        });
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.on;
        /***
     * @type {VectorSourceOnSignature<import("../events").EventsKey, FeatureType>}
     */ this.once;
        /***
     * @type {VectorSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {import("../featureloader.js").FeatureLoader<import("../Feature.js").FeatureLike>}
     */ this.loader_ = (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8);
        /**
     * @private
     * @type {import("../format/Feature.js").default<FeatureType>|null}
     */ this.format_ = options.format || null;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
     * @private
     * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
     */ this.url_ = options.url;
        if (options.loader !== undefined) this.loader_ = options.loader;
        else if (this.url_ !== undefined) {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(this.format_, '`format` must be set when `url` is set');
            // create a XHR feature loader for "url" and "format"
            this.loader_ = (0, $34037dfe4c349357$export$14cc81df70b6707e)(this.url_, this.format_);
        }
        /**
     * @private
     * @type {LoadingStrategy}
     */ this.strategy_ = options.strategy !== undefined ? options.strategy : (0, $d8ae32e631726bbf$export$84bf76cd7afc7469);
        const useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
     * @private
     * @type {RBush<FeatureType>}
     */ this.featuresRtree_ = useSpatialIndex ? new (0, $02caaf5d0144620b$export$2e2bcd8739ae039)() : null;
        /**
     * @private
     * @type {RBush<{extent: import("../extent.js").Extent}>}
     */ this.loadedExtentsRtree_ = new (0, $02caaf5d0144620b$export$2e2bcd8739ae039)();
        /**
     * @type {number}
     * @private
     */ this.loadingExtentsCount_ = 0;
        /**
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.nullGeometryFeatures_ = {};
        /**
     * A lookup of features by id (the return from feature.getId()).
     * @private
     * @type {!Object<string, import('../Feature.js').FeatureLike|Array<import('../Feature.js').FeatureLike>>}
     */ this.idIndex_ = {};
        /**
     * A lookup of features by uid (using getUid(feature)).
     * @private
     * @type {!Object<string, FeatureType>}
     */ this.uidIndex_ = {};
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.featureChangeKeys_ = {};
        /**
     * @private
     * @type {Collection<FeatureType>|null}
     */ this.featuresCollection_ = null;
        /** @type {Collection<FeatureType>} */ let collection;
        /** @type {Array<FeatureType>} */ let features;
        if (Array.isArray(options.features)) features = options.features;
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) collection = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(features);
        if (features !== undefined) this.addFeaturesInternal(features);
        if (collection !== undefined) this.bindFeaturesCollection_(collection);
    }
    /**
   * Add a single feature to the source.  If you want to add a batch of features
   * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
   * instead. A feature will not be added to the source if feature with
   * the same id is already there. The reason for this behavior is to avoid
   * feature duplication when using bbox or tile loading strategies.
   * Note: this also applies if a {@link module:ol/Collection~Collection} is used for features,
   * meaning that if a feature with a duplicate id is added in the collection, it will
   * be removed from it right away.
   * @param {FeatureType} feature Feature to add.
   * @api
   */ addFeature(feature) {
        this.addFeatureInternal(feature);
        this.changed();
    }
    /**
   * Add a feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @protected
   */ addFeatureInternal(feature) {
        const featureKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) this.featuresCollection_.remove(feature);
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        const geometry = feature.getGeometry();
        if (geometry) {
            const extent = geometry.getExtent();
            if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
        } else this.nullGeometryFeatures_[featureKey] = feature;
        this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).ADDFEATURE, feature));
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @private
   */ setupChangeEvents_(featureKey, feature) {
        if (feature instanceof (0, $78328f7ea9ce528c$export$2e2bcd8739ae039)) return;
        this.featureChangeKeys_[featureKey] = [
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(feature, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleFeatureChange_, this),
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(feature, (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleFeatureChange_, this)
        ];
    }
    /**
   * @param {string} featureKey Unique identifier for the feature.
   * @param {FeatureType} feature The feature.
   * @return {boolean} The feature is "valid", in the sense that it is also a
   *     candidate for insertion into the Rtree.
   * @private
   */ addToIndex_(featureKey, feature) {
        let valid = true;
        if (feature.getId() !== undefined) {
            const id = String(feature.getId());
            if (!(id in this.idIndex_)) this.idIndex_[id] = feature;
            else if (feature instanceof (0, $78328f7ea9ce528c$export$2e2bcd8739ae039)) {
                const indexedFeature = this.idIndex_[id];
                if (!(indexedFeature instanceof (0, $78328f7ea9ce528c$export$2e2bcd8739ae039))) valid = false;
                else if (!Array.isArray(indexedFeature)) this.idIndex_[id] = [
                    indexedFeature,
                    feature
                ];
                else indexedFeature.push(feature);
            } else valid = false;
        }
        if (valid) {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!(featureKey in this.uidIndex_), 'The passed `feature` was already added to the source');
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    }
    /**
   * Add a batch of features to the source.
   * @param {Array<FeatureType>} features Features to add.
   * @api
   */ addFeatures(features) {
        this.addFeaturesInternal(features);
        this.changed();
    }
    /**
   * Add features without firing a `change` event.
   * @param {Array<FeatureType>} features Features.
   * @protected
   */ addFeaturesInternal(features) {
        const extents = [];
        /** @type {Array<FeatureType>} */ const newFeatures = [];
        /** @type {Array<FeatureType>} */ const geometryFeatures = [];
        for(let i = 0, length = features.length; i < length; i++){
            const feature = features[i];
            const featureKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
            if (this.addToIndex_(featureKey, feature)) newFeatures.push(feature);
        }
        for(let i = 0, length = newFeatures.length; i < length; i++){
            const feature = newFeatures[i];
            const featureKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
            this.setupChangeEvents_(featureKey, feature);
            const geometry = feature.getGeometry();
            if (geometry) {
                const extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            } else this.nullGeometryFeatures_[featureKey] = feature;
        }
        if (this.featuresRtree_) this.featuresRtree_.load(extents, geometryFeatures);
        if (this.hasListener((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).ADDFEATURE)) for(let i = 0, length = newFeatures.length; i < length; i++)this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).ADDFEATURE, newFeatures[i]));
    }
    /**
   * @param {!Collection<FeatureType>} collection Collection.
   * @private
   */ bindFeaturesCollection_(collection) {
        let modifyingCollection = false;
        this.addEventListener((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).ADDFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).REMOVEFEATURE, /**
       * @param {VectorSourceEvent<FeatureType>} evt The vector source event
       */ function(evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(evt.element);
                modifyingCollection = false;
            }
        });
        collection.addEventListener((0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("../Collection.js").CollectionEvent<FeatureType>} evt The collection event
       */ (evt)=>{
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(evt.element);
                modifyingCollection = false;
            }
        });
        this.featuresCollection_ = collection;
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature} events.
   * @api
   */ clear(fast) {
        if (fast) {
            for(const featureId in this.featureChangeKeys_){
                const keys = this.featureChangeKeys_[featureId];
                keys.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        } else if (this.featuresRtree_) {
            this.featuresRtree_.forEach((feature)=>{
                this.removeFeatureInternal(feature);
            });
            for(const id in this.nullGeometryFeatures_)this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
        }
        if (this.featuresCollection_) this.featuresCollection_.clear();
        if (this.featuresRtree_) this.featuresRtree_.clear();
        this.nullGeometryFeatures_ = {};
        const clearEvent = new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    }
    /**
   * Iterate through all features on the source, calling the provided callback
   * with each one.  If the callback returns any "truthy" value, iteration will
   * stop and the function will return the same value.
   * Note: this function only iterate through the feature that have a defined geometry.
   *
   * @param {function(FeatureType): T} callback Called with each feature
   *     on the source.  Return a truthy value to stop iteration.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeature(callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEach(callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometries contain the provided
   * coordinate, calling the callback with each feature.  If the callback returns
   * a "truthy" value, iteration will stop and the function will return the same
   * value.
   *
   * For {@link module:ol/render/Feature~RenderFeature} features, the callback will be
   * called for all features.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose goemetry contains the provided coordinate.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   */ forEachFeatureAtCoordinateDirect(coordinate, callback) {
        const extent = [
            coordinate[0],
            coordinate[1],
            coordinate[0],
            coordinate[1]
        ];
        return this.forEachFeatureInExtent(extent, function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $78328f7ea9ce528c$export$2e2bcd8739ae039) || geometry.intersectsCoordinate(coordinate)) return callback(feature);
            return undefined;
        });
    }
    /**
   * Iterate through all features whose bounding box intersects the provided
   * extent (note that the feature's geometry may not intersect the extent),
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you are interested in features whose geometry intersects an extent, call
   * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
   *
   * When `useSpatialIndex` is set to false, this method will loop through all
   * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose bounding box intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureInExtent(extent, callback) {
        if (this.featuresRtree_) return this.featuresRtree_.forEachInExtent(extent, callback);
        if (this.featuresCollection_) this.featuresCollection_.forEach(callback);
    }
    /**
   * Iterate through all features whose geometry intersects the provided extent,
   * calling the callback with each feature.  If the callback returns a "truthy"
   * value, iteration will stop and the function will return the same value.
   *
   * If you only want to test for bounding box intersection, call the
   * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {function(FeatureType): T} callback Called with each feature
   *     whose geometry intersects the provided extent.
   * @return {T|undefined} The return value from the last call to the callback.
   * @template T
   * @api
   */ forEachFeatureIntersectingExtent(extent, callback) {
        return this.forEachFeatureInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       * @return {T|undefined} The return value from the last call to the callback.
       */ function(feature) {
            const geometry = feature.getGeometry();
            if (geometry instanceof (0, $78328f7ea9ce528c$export$2e2bcd8739ae039) || geometry.intersectsExtent(extent)) {
                const result = callback(feature);
                if (result) return result;
            }
        });
    }
    /**
   * Get the features collection associated with this source. Will be `null`
   * unless the source was configured with `useSpatialIndex` set to `false`, or
   * with a {@link module:ol/Collection~Collection} as `features`.
   * @return {Collection<FeatureType>|null} The collection of features.
   * @api
   */ getFeaturesCollection() {
        return this.featuresCollection_;
    }
    /**
   * Get a snapshot of the features currently on the source in random order. The returned array
   * is a copy, the features are references to the features in the source.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeatures() {
        let features;
        if (this.featuresCollection_) features = this.featuresCollection_.getArray().slice(0);
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!(0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_)) (0, $830d23b8323fc080$export$8b58be045bf06082)(features, Object.values(this.nullGeometryFeatures_));
        }
        return features;
    }
    /**
   * Get all features whose geometry intersects the provided coordinate.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesAtCoordinate(coordinate) {
        /** @type {Array<FeatureType>} */ const features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function(feature) {
            features.push(feature);
        });
        return features;
    }
    /**
   * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
   * all features intersecting the given extent in random order (so it may include
   * features whose geometries do not intersect the extent).
   *
   * When `useSpatialIndex` is set to false, this method will return all
   * features.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {import("../proj/Projection.js").default} [projection] Include features
   * where `extent` exceeds the x-axis bounds of `projection` and wraps around the world.
   * @return {Array<FeatureType>} Features.
   * @api
   */ getFeaturesInExtent(extent, projection) {
        if (this.featuresRtree_) {
            const multiWorld = projection && projection.canWrapX() && this.getWrapX();
            if (!multiWorld) return this.featuresRtree_.getInExtent(extent);
            const extents = (0, $7e819822b33b3d32$export$9031237f01de0947)(extent, projection);
            return [].concat(...extents.map((anExtent)=>this.featuresRtree_.getInExtent(anExtent)));
        }
        if (this.featuresCollection_) return this.featuresCollection_.getArray().slice(0);
        return [];
    }
    /**
   * Get the closest feature to the provided coordinate.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false` and the features in this source are of type
   * {@link module:ol/Feature~Feature}.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {function(FeatureType):boolean} [filter] Feature filter function.
   *     The filter function will receive one argument, the {@link module:ol/Feature~Feature feature}
   *     and it should return a boolean value. By default, no filtering is made.
   * @return {FeatureType} Closest feature.
   * @api
   */ getClosestFeatureToCoordinate(coordinate, filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        const x = coordinate[0];
        const y = coordinate[1];
        let closestFeature = null;
        const closestPoint = [
            NaN,
            NaN
        ];
        let minSquaredDistance = Infinity;
        const extent = [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity
        ];
        filter = filter ? filter : (0, $de1052d9f293b73a$export$22e23a2304399231);
        this.featuresRtree_.forEachInExtent(extent, /**
       * @param {FeatureType} feature Feature.
       */ function(feature) {
            if (filter(feature)) {
                const geometry = feature.getGeometry();
                const previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry instanceof (0, $78328f7ea9ce528c$export$2e2bcd8739ae039) ? 0 : geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    const minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    }
    /**
   * Get the extent of the features currently in the source.
   *
   * This method is not available when the source is configured with
   * `useSpatialIndex` set to `false`.
   * @param {import("../extent.js").Extent} [extent] Destination extent. If provided, no new extent
   *     will be created. Instead, that extent's coordinates will be overwritten.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent(extent) {
        return this.featuresRtree_.getExtent(extent);
    }
    /**
   * Get a feature by its identifier (the value returned by feature.getId()). When `RenderFeature`s
   * are used, `getFeatureById()` can return an array of `RenderFeature`s. This allows for handling
   * of `GeometryCollection` geometries, where format readers create one `RenderFeature` per
   * `GeometryCollection` member.
   * Note that the index treats string and numeric identifiers as the same.  So
   * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
   *
   * @param {string|number} id Feature identifier.
   * @return {FeatureClassOrArrayOfRenderFeatures<FeatureType>|null} The feature (or `null` if not found).
   * @api
   */ getFeatureById(id) {
        const feature = this.idIndex_[id.toString()];
        return feature !== undefined ? /** @type {FeatureClassOrArrayOfRenderFeatures<FeatureType>} */ feature : null;
    }
    /**
   * Get a feature by its internal unique identifier (using `getUid`).
   *
   * @param {string} uid Feature identifier.
   * @return {FeatureType|null} The feature (or `null` if not found).
   */ getFeatureByUid(uid) {
        const feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    }
    /**
   * Get the format associated with this source.
   *
   * @return {import("../format/Feature.js").default<FeatureType>|null}} The feature format.
   * @api
   */ getFormat() {
        return this.format_;
    }
    /**
   * @return {boolean} The source can have overlapping geometries.
   */ getOverlaps() {
        return this.overlaps_;
    }
    /**
   * Get the url associated with this source.
   *
   * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * @param {Event} event Event.
   * @private
   */ handleFeatureChange_(event) {
        const feature = /** @type {FeatureType} */ event.target;
        const featureKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
        const geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) this.featuresRtree_.remove(feature);
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        } else {
            const extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) this.featuresRtree_.insert(extent, feature);
            } else if (this.featuresRtree_) this.featuresRtree_.update(extent, feature);
        }
        const id = feature.getId();
        if (id !== undefined) {
            const sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        } else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).CHANGEFEATURE, feature));
    }
    /**
   * Returns true if the feature is contained within the source.
   * @param {FeatureType} feature Feature.
   * @return {boolean} Has feature.
   * @api
   */ hasFeature(feature) {
        const id = feature.getId();
        if (id !== undefined) return id in this.idIndex_;
        return (0, $34772e91e89a736f$export$5e82334337e0f204)(feature) in this.uidIndex_;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        if (this.featuresRtree_) return this.featuresRtree_.isEmpty() && (0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(this.nullGeometryFeatures_);
        if (this.featuresCollection_) return this.featuresCollection_.getLength() === 0;
        return true;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   */ loadFeatures(extent, resolution, projection) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const extentsToLoad = this.strategy_(extent, resolution, projection);
        for(let i = 0, ii = extentsToLoad.length; i < ii; ++i){
            const extentToLoad = extentsToLoad[i];
            const alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, /**
         * @param {{extent: import("../extent.js").Extent}} object Object.
         * @return {boolean} Contains.
         */ function(object) {
                return (0, $7e819822b33b3d32$export$be866b1e0809b17e)(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                ++this.loadingExtentsCount_;
                this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).FEATURESLOADSTART));
                this.loader_.call(this, extentToLoad, resolution, projection, /**
           * @param {Array<FeatureType>} features Loaded features
           */ (features)=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).FEATURESLOADEND, undefined, features));
                }, ()=>{
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).FEATURESLOADERROR));
                });
                loadedExtentsRtree.insert(extentToLoad, {
                    extent: extentToLoad.slice()
                });
            }
        }
        this.loading = this.loader_.length < 4 ? false : this.loadingExtentsCount_ > 0;
    }
    /**
   * @override
   */ refresh() {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        super.refresh();
    }
    /**
   * Remove an extent from the list of loaded extents.
   * @param {import("../extent.js").Extent} extent Extent.
   * @api
   */ removeLoadedExtent(extent) {
        const loadedExtentsRtree = this.loadedExtentsRtree_;
        const obj = loadedExtentsRtree.forEachInExtent(extent, function(object) {
            if ((0, $7e819822b33b3d32$export$e9bab7fafb253603)(object.extent, extent)) return object;
        });
        if (obj) loadedExtentsRtree.remove(obj);
    }
    /**
   * Batch remove features from the source.  If you want to remove all features
   * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
   * instead.
   * @param {Array<FeatureType>} features Features to remove.
   * @api
   */ removeFeatures(features) {
        let removed = false;
        for(let i = 0, ii = features.length; i < ii; ++i)removed = this.removeFeatureInternal(features[i]) || removed;
        if (removed) this.changed();
    }
    /**
   * Remove a single feature from the source. If you want to batch remove
   * features, use the {@link module:ol/source/Vector~VectorSource#removeFeatures #removeFeatures()} method
   * instead.
   * @param {FeatureType} feature Feature to remove.
   * @api
   */ removeFeature(feature) {
        if (!feature) return;
        const removed = this.removeFeatureInternal(feature);
        if (removed) this.changed();
    }
    /**
   * Remove feature without firing a `change` event.
   * @param {FeatureType} feature Feature.
   * @return {boolean} True if the feature was removed, false if it was not found.
   * @protected
   */ removeFeatureInternal(feature) {
        const featureKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
        if (!(featureKey in this.uidIndex_)) return false;
        if (featureKey in this.nullGeometryFeatures_) delete this.nullGeometryFeatures_[featureKey];
        else if (this.featuresRtree_) this.featuresRtree_.remove(feature);
        const featureChangeKeys = this.featureChangeKeys_[featureKey];
        featureChangeKeys?.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        delete this.featureChangeKeys_[featureKey];
        const id = feature.getId();
        if (id !== undefined) {
            const idString = id.toString();
            const indexedFeature = this.idIndex_[idString];
            if (indexedFeature === feature) delete this.idIndex_[idString];
            else if (Array.isArray(indexedFeature)) {
                indexedFeature.splice(indexedFeature.indexOf(feature), 1);
                if (indexedFeature.length === 1) this.idIndex_[idString] = indexedFeature[0];
            }
        }
        delete this.uidIndex_[featureKey];
        if (this.hasListener((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).REMOVEFEATURE)) this.dispatchEvent(new $69f8886165740064$export$d402fd02dc2b661c((0, $06df2a0f10306cb8$export$2e2bcd8739ae039).REMOVEFEATURE, feature));
        return true;
    }
    /**
   * Remove a feature from the id index.  Called internally when the feature id
   * may have changed.
   * @param {FeatureType} feature The feature.
   * @private
   */ removeFromIdIndex_(feature) {
        for(const id in this.idIndex_)if (this.idIndex_[id] === feature) {
            delete this.idIndex_[id];
            break;
        }
    }
    /**
   * Set the new loader of the source. The next render cycle will use the
   * new loader.
   * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
   * @api
   */ setLoader(loader) {
        this.loader_ = loader;
    }
    /**
   * Points the source to a new url. The next render cycle will use the new url.
   * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
   * @api
   */ setUrl(url) {
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(this.format_, '`format` must be set when `url` is set');
        this.url_ = url;
        this.setLoader((0, $34037dfe4c349357$export$14cc81df70b6707e)(url, this.format_));
    }
    /**
   * @param {boolean} overlaps The source can have overlapping geometries.
   */ setOverlaps(overlaps) {
        this.overlaps_ = overlaps;
        this.changed();
    }
}
var $69f8886165740064$export$2e2bcd8739ae039 = $69f8886165740064$var$VectorSource;


/**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").FeatureLike]
 * @typedef {(feature: FeatureType) => (Point|null)} GeometryFunction
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [distance=20] Distance in pixels within which features will
 * be clustered together.
 * @property {number} [minDistance=0] Minimum distance in pixels between clusters.
 * Will be capped at the configured distance.
 * By default no minimum distance is guaranteed. This config can be used to avoid
 * overlapping icons. As a tradoff, the cluster feature's position will no longer be
 * the center of all its features.
 * @property {GeometryFunction<FeatureType>} [geometryFunction]
 * Function that takes a {@link module:ol/Feature~Feature} as argument and returns a
 * {@link module:ol/geom/Point~Point} as cluster calculation point for the feature. When a
 * feature should not be considered for clustering, the function should return
 * `null`. The default, which works when the underlying source contains point
 * features only, is
 * ```js
 * function(feature) {
 *   return feature.getGeometry();
 * }
 * ```
 * See {@link module:ol/geom/Polygon~Polygon#getInteriorPoint} for a way to get a cluster
 * calculation point for polygons.
 * @property {function(Point, Array<FeatureType>):Feature} [createCluster]
 * Function that takes the cluster's center {@link module:ol/geom/Point~Point} and an array
 * of {@link module:ol/Feature~Feature} included in this cluster. Must return a
 * {@link module:ol/Feature~Feature} that will be used to render. Default implementation is:
 * ```js
 * function(point, features) {
 *   return new Feature({
 *     geometry: point,
 *     features: features
 *   });
 * }
 * ```
 * @property {VectorSource<FeatureType>} [source=null] Source.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 */ /**
 * @classdesc
 * Layer source to cluster vector data. Works out of the box with point
 * geometries. For other geometry types, or if not all geometries should be
 * considered for clustering, a custom `geometryFunction` can be defined.
 *
 * If the instance is disposed without also disposing the underlying
 * source `setSource(null)` has to be called to remove the listener reference
 * from the wrapped source.
 * @api
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import('../Feature.js').default]
 * @extends {VectorSource<Feature<import("../geom/Geometry.js").default>>}
 */ class $49214548c17e511c$var$Cluster extends (0, $69f8886165740064$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Cluster options.
   */ constructor(options){
        options = options || {};
        super({
            attributions: options.attributions,
            wrapX: options.wrapX
        });
        /**
     * @type {number|undefined}
     * @protected
     */ this.resolution = undefined;
        /**
     * @type {number}
     * @protected
     */ this.distance = options.distance !== undefined ? options.distance : 20;
        /**
     * @type {number}
     * @protected
     */ this.minDistance = options.minDistance || 0;
        /**
     * @type {number}
     * @protected
     */ this.interpolationRatio = 0;
        /**
     * @type {Array<Feature>}
     * @protected
     */ this.features = [];
        /**
     * @type {GeometryFunction<import("../Feature.js").FeatureLike>}
     * @protected
     */ this.geometryFunction = options.geometryFunction || function(feature) {
            const geometry = /** @type {Point} */ feature.getGeometry();
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!geometry || geometry.getType() === 'Point', 'The default `geometryFunction` can only handle `Point` or null geometries');
            return geometry;
        };
        /**
     * @type {function(Point, Array<FeatureType>):Feature}
     * @private
     */ this.createCustomCluster_ = options.createCluster;
        /**
     * @type {VectorSource<FeatureType>|null}
     * @protected
     */ this.source = null;
        /**
     * @private
     */ this.boundRefresh_ = this.refresh.bind(this);
        this.updateDistance(this.distance, this.minDistance);
        this.setSource(options.source || null);
    }
    /**
   * Remove all features from the source.
   * @param {boolean} [fast] Skip dispatching of {@link module:ol/source/VectorEventType~VectorEventType#removefeature} events.
   * @api
   * @override
   */ clear(fast) {
        this.features.length = 0;
        super.clear(fast);
    }
    /**
   * Get the distance in pixels between clusters.
   * @return {number} Distance.
   * @api
   */ getDistance() {
        return this.distance;
    }
    /**
   * Get a reference to the wrapped source.
   * @return {VectorSource<FeatureType>|null} Source.
   * @api
   */ getSource() {
        return this.source;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @override
   */ loadFeatures(extent, resolution, projection) {
        this.source?.loadFeatures(extent, resolution, projection);
        if (resolution !== this.resolution) {
            this.resolution = resolution;
            this.refresh();
        }
    }
    /**
   * Set the distance within which features will be clusterd together.
   * @param {number} distance The distance in pixels.
   * @api
   */ setDistance(distance) {
        this.updateDistance(distance, this.minDistance);
    }
    /**
   * Set the minimum distance between clusters. Will be capped at the
   * configured distance.
   * @param {number} minDistance The minimum distance in pixels.
   * @api
   */ setMinDistance(minDistance) {
        this.updateDistance(this.distance, minDistance);
    }
    /**
   * The configured minimum distance between clusters.
   * @return {number} The minimum distance in pixels.
   * @api
   */ getMinDistance() {
        return this.minDistance;
    }
    /**
   * Replace the wrapped source.
   * @param {VectorSource<FeatureType>|null} source The new source for this instance.
   * @api
   */ setSource(source) {
        if (this.source) this.source.removeEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.boundRefresh_);
        this.source = source;
        if (source) source.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.boundRefresh_);
        this.refresh();
    }
    /**
   * Handle the source changing.
   * @override
   */ refresh() {
        this.clear();
        this.cluster();
        this.addFeatures(this.features);
    }
    /**
   * Update the distances and refresh the source if necessary.
   * @param {number} distance The new distance.
   * @param {number} minDistance The new minimum distance.
   */ updateDistance(distance, minDistance) {
        const ratio = distance === 0 ? 0 : Math.min(minDistance, distance) / distance;
        const changed = distance !== this.distance || this.interpolationRatio !== ratio;
        this.distance = distance;
        this.minDistance = minDistance;
        this.interpolationRatio = ratio;
        if (changed) this.refresh();
    }
    /**
   * @protected
   */ cluster() {
        if (this.resolution === undefined || !this.source) return;
        const extent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        const mapDistance = this.distance * this.resolution;
        const features = this.source.getFeatures();
        /** @type {Object<string, true>} */ const clustered = {};
        for(let i = 0, ii = features.length; i < ii; i++){
            const feature = features[i];
            if (!((0, $34772e91e89a736f$export$5e82334337e0f204)(feature) in clustered)) {
                const geometry = this.geometryFunction(feature);
                if (geometry) {
                    const coordinates = geometry.getCoordinates();
                    (0, $7e819822b33b3d32$export$4838bf78d04a9440)(coordinates, extent);
                    (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(extent, mapDistance, extent);
                    const neighbors = this.source.getFeaturesInExtent(extent).filter(function(neighbor) {
                        const uid = (0, $34772e91e89a736f$export$5e82334337e0f204)(neighbor);
                        if (uid in clustered) return false;
                        clustered[uid] = true;
                        return true;
                    });
                    this.features.push(this.createCluster(neighbors, extent));
                }
            }
        }
    }
    /**
   * @param {Array<FeatureType>} features Features
   * @param {import("../extent.js").Extent} extent The searched extent for these features.
   * @return {Feature} The cluster feature.
   * @protected
   */ createCluster(features, extent) {
        const centroid = [
            0,
            0
        ];
        for(let i = features.length - 1; i >= 0; --i){
            const geometry = this.geometryFunction(features[i]);
            if (geometry) (0, $8b28786758450fff$export$e16d8520af44a096)(centroid, geometry.getCoordinates());
            else features.splice(i, 1);
        }
        (0, $8b28786758450fff$export$dcdf75081b88279d)(centroid, 1 / features.length);
        const searchCenter = (0, $7e819822b33b3d32$export$c91255cadecfe081)(extent);
        const ratio = this.interpolationRatio;
        const geometry = new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)([
            centroid[0] * (1 - ratio) + searchCenter[0] * ratio,
            centroid[1] * (1 - ratio) + searchCenter[1] * ratio
        ]);
        if (this.createCustomCluster_) return this.createCustomCluster_(geometry, features);
        return new (0, $1171fbd986f3130c$export$2e2bcd8739ae039)({
            geometry: geometry,
            features: features
        });
    }
}
var $49214548c17e511c$export$2e2bcd8739ae039 = $49214548c17e511c$var$Cluster;

/**
 * @module ol/source/ImageWMS
 */ 


/**
 * @module ol/source/Image
 */ 







/**
 * @module ol/reproj/Image
 */ 





/**
 * @module ol/resolution
 */ /**
 * @typedef {number|Array<number>} ResolutionLike
 */ /**
 * @param {ResolutionLike} resolution Resolution.
 * @return {number} Resolution.
 */ function $05a919926772e460$export$bc4231bf34bfa9ad(resolution) {
    if (Array.isArray(resolution)) return Math.min(...resolution);
    return resolution;
}




/**
 * @typedef {function(import("../extent.js").Extent, number, number) : import("../Image.js").default} FunctionType
 */ /**
 * @classdesc
 * Class encapsulating single reprojected image.
 * See {@link module:ol/source/Image~ImageSource}.
 */ class $b2eec67ede17dd39$var$ReprojImage extends (0, $e460a8a24b67695c$export$2e2bcd8739ae039) {
    /**
   * @param {import("../proj/Projection.js").default} sourceProj Source projection (of the data).
   * @param {import("../proj/Projection.js").default} targetProj Target projection.
   * @param {import("../extent.js").Extent} targetExtent Target extent.
   * @param {number} targetResolution Target resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {FunctionType} getImageFunction
   *     Function returning source images (extent, resolution, pixelRatio).
   * @param {boolean} interpolate Use linear interpolation when resampling.
   */ constructor(sourceProj, targetProj, targetExtent, targetResolution, pixelRatio, getImageFunction, interpolate){
        let maxSourceExtent = sourceProj.getExtent();
        if (maxSourceExtent && sourceProj.canWrapX()) {
            maxSourceExtent = maxSourceExtent.slice();
            maxSourceExtent[0] = -Infinity;
            maxSourceExtent[2] = Infinity;
        }
        let maxTargetExtent = targetProj.getExtent();
        if (maxTargetExtent && targetProj.canWrapX()) {
            maxTargetExtent = maxTargetExtent.slice();
            maxTargetExtent[0] = -Infinity;
            maxTargetExtent[2] = Infinity;
        }
        const limitedTargetExtent = maxTargetExtent ? (0, $7e819822b33b3d32$export$72209efa88586d42)(targetExtent, maxTargetExtent) : targetExtent;
        const targetCenter = (0, $7e819822b33b3d32$export$c91255cadecfe081)(limitedTargetExtent);
        const sourceResolution = (0, $5bc6f6a25c982e7a$export$5fbb958059b7e71f)(sourceProj, targetProj, targetCenter, targetResolution);
        const errorThresholdInPixels = (0, $7b3aa4a24649670e$export$3ecb4bcfa5aae855);
        const triangulation = new (0, $72dfda612e83d57a$export$2e2bcd8739ae039)(sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        const sourceExtent = triangulation.calculateSourceExtent();
        const sourceImage = (0, $7e819822b33b3d32$export$dd1bc94b04021eeb)(sourceExtent) ? null : getImageFunction(sourceExtent, sourceResolution, pixelRatio);
        const state = sourceImage ? (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE : (0, $23fb176c76153f22$export$2e2bcd8739ae039).EMPTY;
        const sourcePixelRatio = sourceImage ? sourceImage.getPixelRatio() : 1;
        super(targetExtent, targetResolution, sourcePixelRatio, state);
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.targetProj_ = targetProj;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.maxSourceExtent_ = maxSourceExtent;
        /**
     * @private
     * @type {!import("./Triangulation.js").default}
     */ this.triangulation_ = triangulation;
        /**
     * @private
     * @type {number}
     */ this.targetResolution_ = targetResolution;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.targetExtent_ = targetExtent;
        /**
     * @private
     * @type {import("../Image.js").default}
     */ this.sourceImage_ = sourceImage;
        /**
     * @private
     * @type {number}
     */ this.sourcePixelRatio_ = sourcePixelRatio;
        /**
     * @private
     * @type {boolean}
     */ this.interpolate_ = interpolate;
        /**
     * @private
     * @type {HTMLCanvasElement}
     */ this.canvas_ = null;
        /**
     * @private
     * @type {?import("../events.js").EventsKey}
     */ this.sourceListenerKey_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.state == (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING) this.unlistenSource_();
        super.disposeInternal();
    }
    /**
   * @return {HTMLCanvasElement} Image.
   * @override
   */ getImage() {
        return this.canvas_;
    }
    /**
   * @return {import("../proj/Projection.js").default} Projection.
   */ getProjection() {
        return this.targetProj_;
    }
    /**
   * @private
   */ reproject_() {
        const sourceState = this.sourceImage_.getState();
        if (sourceState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) {
            const width = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(this.targetExtent_) / this.targetResolution_;
            const height = (0, $7e819822b33b3d32$export$c08559766941f856)(this.targetExtent_) / this.targetResolution_;
            this.canvas_ = (0, $5bc6f6a25c982e7a$export$b3890eb0ae9dca99)(width, height, this.sourcePixelRatio_, (0, $05a919926772e460$export$bc4231bf34bfa9ad)(this.sourceImage_.getResolution()), this.maxSourceExtent_, this.targetResolution_, this.targetExtent_, this.triangulation_, [
                {
                    extent: this.sourceImage_.getExtent(),
                    image: this.sourceImage_.getImage()
                }
            ], 0, undefined, this.interpolate_, true);
        }
        this.state = sourceState;
        this.changed();
    }
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {
        if (this.state == (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) {
            this.state = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING;
            this.changed();
            const sourceState = this.sourceImage_.getState();
            if (sourceState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED || sourceState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR) this.reproject_();
            else {
                this.sourceListenerKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.sourceImage_, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, (e)=>{
                    const sourceState = this.sourceImage_.getState();
                    if (sourceState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED || sourceState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR) {
                        this.unlistenSource_();
                        this.reproject_();
                    }
                });
                this.sourceImage_.load();
            }
        }
    }
    /**
   * @private
   */ unlistenSource_() {
        (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(/** @type {!import("../events.js").EventsKey} */ this.sourceListenerKey_);
        this.sourceListenerKey_ = null;
    }
}
var $b2eec67ede17dd39$export$2e2bcd8739ae039 = $b2eec67ede17dd39$var$ReprojImage;




/**
 * @module ol/source/common
 */ /**
 * Default WMS version.
 * @type {string}
 */ const $229df2c72aae3800$export$8c33e4eedb20eeb5 = '1.3.0';
const $229df2c72aae3800$export$48fbc15abf52505f = 4;


const $1320b090b1e36b1f$export$4e0f6da20e5dcc4f = {
    /**
   * Triggered when an image starts loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadstart
   * @api
   */ IMAGELOADSTART: 'imageloadstart',
    /**
   * Triggered when an image finishes loading.
   * @event module:ol/source/Image.ImageSourceEvent#imageloadend
   * @api
   */ IMAGELOADEND: 'imageloadend',
    /**
   * Triggered if image loading results in an error.
   * @event module:ol/source/Image.ImageSourceEvent#imageloaderror
   * @api
   */ IMAGELOADERROR: 'imageloaderror'
};
class $1320b090b1e36b1f$export$58d3276cd83daede extends (0, $0327f54963b35733$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Image.js").default} image The image.
   */ constructor(type, image){
        super(type);
        /**
     * The image related to the event.
     * @type {import("../Image.js").default}
     * @api
     */ this.image = image;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<ImageSourceEventTypes, ImageSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |ImageSourceEventTypes, Return>} ImageSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../Image.js").Loader} [loader] Loader. Can either be a custom loader, or one of the
 * loaders created with a `createLoader()` function ({@link module:ol/source/wms.createLoader wms},
 * {@link module:ol/source/arcgisRest.createLoader arcgisRest}, {@link module:ol/source/mapguide.createLoader mapguide},
 * {@link module:ol/source/static.createLoader static}).
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {Array<number>} [resolutions] Resolutions.
 * @property {import("./Source.js").State} [state] State.
 */ /**
 * @classdesc
 * Base class for sources providing a single image.
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class $1320b090b1e36b1f$var$ImageSource extends (0, $dba8564f516aed29$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Single image source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            projection: options.projection,
            state: options.state,
            interpolate: options.interpolate !== undefined ? options.interpolate : true
        });
        /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {ImageSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {ImageSourceOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {import("../Image.js").Loader}
     */ this.loader = options.loader || null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.resolutions_ = options.resolutions !== undefined ? options.resolutions : null;
        /**
     * @private
     * @type {import("../reproj/Image.js").default}
     */ this.reprojectedImage_ = null;
        /**
     * @private
     * @type {number}
     */ this.reprojectedRevision_ = 0;
        /**
     * @protected
     * @type {import("../Image.js").default}
     */ this.image = null;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.wantedExtent_;
        /**
     * @private
     * @type {number}
     */ this.wantedResolution_;
        /**
     * @private
     * @type {boolean}
     */ this.static_ = options.loader ? options.loader.length === 0 : false;
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.wantedProjection_ = null;
    }
    /**
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {Array<number>|null} resolutions Resolutions.
   */ setResolutions(resolutions) {
        this.resolutions_ = resolutions;
    }
    /**
   * @protected
   * @param {number} resolution Resolution.
   * @return {number} Resolution.
   */ findNearestResolution(resolution) {
        const resolutions = this.getResolutions();
        if (resolutions) {
            const idx = (0, $830d23b8323fc080$export$8a3786cc03fdb777)(resolutions, resolution, 0);
            resolution = resolutions[idx];
        }
        return resolution;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   */ getImage(extent, resolution, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $92f1443438429e81$export$fe091d73a555748b)(sourceProjection, projection)) {
            if (sourceProjection) projection = sourceProjection;
            return this.getImageInternal(extent, resolution, pixelRatio, projection);
        }
        if (this.reprojectedImage_) {
            if (this.reprojectedRevision_ == this.getRevision() && (0, $92f1443438429e81$export$fe091d73a555748b)(this.reprojectedImage_.getProjection(), projection) && this.reprojectedImage_.getResolution() == resolution && (0, $7e819822b33b3d32$export$e9bab7fafb253603)(this.reprojectedImage_.getExtent(), extent)) return this.reprojectedImage_;
            this.reprojectedImage_.dispose();
            this.reprojectedImage_ = null;
        }
        this.reprojectedImage_ = new (0, $b2eec67ede17dd39$export$2e2bcd8739ae039)(sourceProjection, projection, extent, resolution, pixelRatio, (extent, resolution, pixelRatio)=>this.getImageInternal(extent, resolution, pixelRatio, sourceProjection), this.getInterpolate());
        this.reprojectedRevision_ = this.getRevision();
        return this.reprojectedImage_;
    }
    /**
   * @abstract
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   * @protected
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.loader) {
            const requestExtent = $1320b090b1e36b1f$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, 1);
            const requestResolution = this.findNearestResolution(resolution);
            if (this.image && (this.static_ || this.wantedProjection_ === projection && (this.wantedExtent_ && (0, $7e819822b33b3d32$export$be866b1e0809b17e)(this.wantedExtent_, requestExtent) || (0, $7e819822b33b3d32$export$be866b1e0809b17e)(this.image.getExtent(), requestExtent)) && (this.wantedResolution_ && (0, $05a919926772e460$export$bc4231bf34bfa9ad)(this.wantedResolution_) === requestResolution || (0, $05a919926772e460$export$bc4231bf34bfa9ad)(this.image.getResolution()) === requestResolution))) return this.image;
            this.wantedProjection_ = projection;
            this.wantedExtent_ = requestExtent;
            this.wantedResolution_ = requestResolution;
            this.image = new (0, $e460a8a24b67695c$export$2e2bcd8739ae039)(requestExtent, requestResolution, pixelRatio, this.loader);
            this.image.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleImageChange.bind(this));
        }
        return this.image;
    }
    /**
   * Handle image change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleImageChange(event) {
        const image = /** @type {import("../Image.js").default} */ event.target;
        let type;
        switch(image.getState()){
            case (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING:
                this.loading = true;
                type = $1320b090b1e36b1f$export$4e0f6da20e5dcc4f.IMAGELOADSTART;
                break;
            case (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED:
                this.loading = false;
                type = $1320b090b1e36b1f$export$4e0f6da20e5dcc4f.IMAGELOADEND;
                break;
            case (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR:
                this.loading = false;
                type = $1320b090b1e36b1f$export$4e0f6da20e5dcc4f.IMAGELOADERROR;
                break;
            default:
                return;
        }
        if (this.hasListener(type)) this.dispatchEvent(new $1320b090b1e36b1f$export$58d3276cd83daede(type, image));
    }
}
function $1320b090b1e36b1f$export$584f102f75ff44b3(image, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ image.getImage().src = src;
}
function $1320b090b1e36b1f$export$2a9dcc8f63da1787(extent, resolution, pixelRatio, ratio) {
    const imageResolution = resolution / pixelRatio;
    const center = (0, $7e819822b33b3d32$export$c91255cadecfe081)(extent);
    const viewWidth = (0, $d4e56cfc37d8b1f9$export$803ce6b71a0a94b2)((0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent) / imageResolution, (0, $229df2c72aae3800$export$48fbc15abf52505f));
    const viewHeight = (0, $d4e56cfc37d8b1f9$export$803ce6b71a0a94b2)((0, $7e819822b33b3d32$export$c08559766941f856)(extent) / imageResolution, (0, $229df2c72aae3800$export$48fbc15abf52505f));
    const marginWidth = (0, $d4e56cfc37d8b1f9$export$803ce6b71a0a94b2)((ratio - 1) * viewWidth / 2, (0, $229df2c72aae3800$export$48fbc15abf52505f));
    const requestWidth = viewWidth + 2 * marginWidth;
    const marginHeight = (0, $d4e56cfc37d8b1f9$export$803ce6b71a0a94b2)((ratio - 1) * viewHeight / 2, (0, $229df2c72aae3800$export$48fbc15abf52505f));
    const requestHeight = viewHeight + 2 * marginHeight;
    return (0, $7e819822b33b3d32$export$13ba650faf8308)(center, imageResolution, 0, [
        requestWidth,
        requestHeight
    ]);
}
var $1320b090b1e36b1f$export$2e2bcd8739ae039 = $1320b090b1e36b1f$var$ImageSource;


/**
 * @module ol/source/wms
 */ 




/**
 * @module ol/uri
 */ 

function $e04dc6b4d00037d8$export$c202e3cb8db99a95(uri, params) {
    /** @type {Array<string>} */ const keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function(k) {
        if (params[k] !== null && params[k] !== undefined) keyParams.push(k + '=' + encodeURIComponent(params[k]));
    });
    const qs = keyParams.join('&');
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, '');
    // append ? or & depending on whether uri has existing parameters
    uri += uri.includes('?') ? '&' : '?';
    return uri + qs;
}
const $e04dc6b4d00037d8$var$zRegEx = /\{z\}/g;
const $e04dc6b4d00037d8$var$xRegEx = /\{x\}/g;
const $e04dc6b4d00037d8$var$yRegEx = /\{y\}/g;
const $e04dc6b4d00037d8$var$dashYRegEx = /\{-y\}/g;
function $e04dc6b4d00037d8$export$df1e52f1b5b1c86f(template, z, x, y, maxY) {
    return template.replace($e04dc6b4d00037d8$var$zRegEx, z.toString()).replace($e04dc6b4d00037d8$var$xRegEx, x.toString()).replace($e04dc6b4d00037d8$var$yRegEx, y.toString()).replace($e04dc6b4d00037d8$var$dashYRegEx, function() {
        if (maxY === undefined) throw new Error('If the URL template has a {-y} placeholder, the grid extent must be known');
        return (maxY - y).toString();
    });
}
function $e04dc6b4d00037d8$export$83e87e683240b2e8(urls, z, x, y) {
    const hash = (0, $321b949bcc451ffb$export$731f79419750ccf7)(z, x, y);
    const index = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(hash, urls.length);
    return urls[index];
}
function $e04dc6b4d00037d8$export$2a1fa079bfd73dde(url) {
    const urls = [];
    let match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        const startCharCode = match[1].charCodeAt(0);
        const stopCharCode = match[2].charCodeAt(0);
        let charCode;
        for(charCode = startCharCode; charCode <= stopCharCode; ++charCode)urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        const stop = parseInt(match[2], 10);
        for(let i = parseInt(match[1], 10); i <= stop; i++)urls.push(url.replace(match[0], i.toString()));
        return urls;
    }
    urls.push(url);
    return urls;
}




const $f6268beca71d7889$export$363ebe89e6e7aeef = '1.3.0';
/**
 * @const
 * @type {import("../size.js").Size}
 */ const $f6268beca71d7889$var$GETFEATUREINFO_IMAGE_SIZE = [
    101,
    101
];
function $f6268beca71d7889$export$14619c0eed01a470(baseUrl, extent, size, projection, params) {
    params['WIDTH'] = size[0];
    params['HEIGHT'] = size[1];
    const axisOrientation = projection.getAxisOrientation();
    const v13 = (0, $812f370f71eebcf4$export$66e1c0999abad646)(params['VERSION'], '1.3') >= 0;
    params[v13 ? 'CRS' : 'SRS'] = projection.getCode();
    const bbox = v13 && axisOrientation.startsWith('ne') ? [
        extent[1],
        extent[0],
        extent[3],
        extent[2]
    ] : extent;
    params['BBOX'] = bbox.join(',');
    return (0, $e04dc6b4d00037d8$export$c202e3cb8db99a95)(baseUrl, params);
}
function $f6268beca71d7889$export$ef1c8480e0b65584(extent, resolution, pixelRatio, projection, url, params, serverType) {
    params = Object.assign({
        REQUEST: 'GetMap'
    }, params);
    const imageResolution = resolution / pixelRatio;
    const imageSize = [
        (0, $d4e56cfc37d8b1f9$export$2077e0241d6afd3c)((0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent) / imageResolution, (0, $229df2c72aae3800$export$48fbc15abf52505f)),
        (0, $d4e56cfc37d8b1f9$export$2077e0241d6afd3c)((0, $7e819822b33b3d32$export$c08559766941f856)(extent) / imageResolution, (0, $229df2c72aae3800$export$48fbc15abf52505f))
    ];
    if (pixelRatio != 1) switch(serverType){
        case 'geoserver':
            const dpi = 90 * pixelRatio + 0.5 | 0;
            if ('FORMAT_OPTIONS' in params) params['FORMAT_OPTIONS'] += ';dpi:' + dpi;
            else params['FORMAT_OPTIONS'] = 'dpi:' + dpi;
            break;
        case 'mapserver':
            params['MAP_RESOLUTION'] = 90 * pixelRatio;
            break;
        case 'carmentaserver':
        case 'qgis':
            params['DPI'] = 90 * pixelRatio;
            break;
        default:
            throw new Error('Unknown `serverType` configured');
    }
    const src = $f6268beca71d7889$export$14619c0eed01a470(url, extent, imageSize, projection, params);
    return src;
}
function $f6268beca71d7889$export$a4c60e148c7af082(params, request) {
    return Object.assign({
        'REQUEST': request,
        'SERVICE': 'WMS',
        'VERSION': $f6268beca71d7889$export$363ebe89e6e7aeef,
        'FORMAT': 'image/png',
        'STYLES': '',
        'TRANSPARENT': 'TRUE'
    }, params);
}
function $f6268beca71d7889$export$8e84ca9bef6adc3a(options) {
    const hidpi = options.hidpi === undefined ? true : options.hidpi;
    const projection = (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.projection || 'EPSG:3857');
    const ratio = options.ratio || 1.5;
    const load = options.load || (0, $e460a8a24b67695c$export$2f872c0f2117be69);
    const crossOrigin = options.crossOrigin ?? null;
    return (extent, resolution, pixelRatio)=>{
        extent = (0, $1320b090b1e36b1f$export$2a9dcc8f63da1787)(extent, resolution, pixelRatio, ratio);
        if (pixelRatio != 1 && (!hidpi || options.serverType === undefined)) pixelRatio = 1;
        const src = $f6268beca71d7889$export$ef1c8480e0b65584(extent, resolution, pixelRatio, projection, options.url, $f6268beca71d7889$export$a4c60e148c7af082(options.params, 'GetMap'), options.serverType);
        const image = new Image();
        image.crossOrigin = crossOrigin;
        return load(image, src).then((image)=>({
                image: image,
                extent: extent,
                pixelRatio: pixelRatio
            }));
    };
}
function $f6268beca71d7889$export$6f3ec358b8c06c5b(options, coordinate, resolution) {
    if (options.url === undefined) return undefined;
    const projectionObj = (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.projection || 'EPSG:3857');
    const extent = (0, $7e819822b33b3d32$export$13ba650faf8308)(coordinate, resolution, 0, $f6268beca71d7889$var$GETFEATUREINFO_IMAGE_SIZE);
    const baseParams = {
        'QUERY_LAYERS': options.params['LAYERS'],
        'INFO_FORMAT': 'application/json'
    };
    Object.assign(baseParams, $f6268beca71d7889$export$a4c60e148c7af082(options.params, 'GetFeatureInfo'), options.params);
    const x = (0, $d4e56cfc37d8b1f9$export$a3fe094919f356fd)((coordinate[0] - extent[0]) / resolution, (0, $229df2c72aae3800$export$48fbc15abf52505f));
    const y = (0, $d4e56cfc37d8b1f9$export$a3fe094919f356fd)((extent[3] - coordinate[1]) / resolution, (0, $229df2c72aae3800$export$48fbc15abf52505f));
    const v13 = (0, $812f370f71eebcf4$export$66e1c0999abad646)(baseParams['VERSION'], '1.3') >= 0;
    baseParams[v13 ? 'I' : 'X'] = x;
    baseParams[v13 ? 'J' : 'Y'] = y;
    return $f6268beca71d7889$export$14619c0eed01a470(options.url, extent, $f6268beca71d7889$var$GETFEATUREINFO_IMAGE_SIZE, projectionObj, baseParams);
}
function $f6268beca71d7889$export$9ee42325bd9ccc93(options, resolution) {
    if (options.url === undefined) return undefined;
    const baseParams = {
        'SERVICE': 'WMS',
        'VERSION': $f6268beca71d7889$export$363ebe89e6e7aeef,
        'REQUEST': 'GetLegendGraphic',
        'FORMAT': 'image/png'
    };
    if (resolution !== undefined) {
        const mpu = (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.projection || 'EPSG:3857').getMetersPerUnit() || 1;
        const pixelSize = 0.00028;
        baseParams['SCALE'] = resolution * mpu / pixelSize;
    }
    Object.assign(baseParams, options.params);
    if (options.params !== undefined && baseParams['LAYER'] === undefined) {
        const layers = baseParams['LAYERS'];
        const isSingleLayer = !Array.isArray(layers) || layers.length !== 1;
        if (!isSingleLayer) return undefined;
        baseParams['LAYER'] = layers;
    }
    return (0, $e04dc6b4d00037d8$export$c202e3cb8db99a95)(options.url, baseParams);
}


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("./wms.js").ServerType} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver`, `carmentaserver`, or `qgis`.
 * Only needed if `hidpi` is `true`.
 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {Object<string,*>} [params] WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport, `2` means
 * twice the width and height of the map viewport, and so on. Must be `1` or higher.
 * @property {Array<number>} [resolutions] Resolutions.
 * If specified, requests will be made for these resolutions only.
 * @property {string} [url] WMS service URL.
 */ /**
 * @classdesc
 * Source for WMS servers providing single, untiled images.
 *
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */ class $7aea03074858c411$var$ImageWMS extends (0, $1320b090b1e36b1f$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] ImageWMS options.
   */ constructor(options){
        options = options ? options : {};
        super({
            attributions: options.attributions,
            interpolate: options.interpolate,
            projection: options.projection,
            resolutions: options.resolutions
        });
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.url_ = options.url;
        /**
     * @private
     * @type {import("../Image.js").LoadFunction}
     */ this.imageLoadFunction_ = options.imageLoadFunction !== undefined ? options.imageLoadFunction : (0, $1320b090b1e36b1f$export$584f102f75ff44b3);
        /**
     * @private
     * @type {!Object}
     */ this.params_ = Object.assign({}, options.params);
        /**
     * @private
     * @type {import("./wms.js").ServerType}
     */ this.serverType_ = options.serverType;
        /**
     * @private
     * @type {boolean}
     */ this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = 0;
        /**
     * @private
     * @type {number}
     */ this.ratio_ = options.ratio !== undefined ? options.ratio : 1.5;
        /**
     * @private
     * @type {import("../proj/Projection.js").default}
     */ this.loaderProjection_ = null;
    }
    /**
   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
   * constructed.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
   *     in the `LAYERS` parameter will be used. `VERSION` should not be
   *     specified here.
   * @return {string|undefined} GetFeatureInfo URL.
   * @api
   */ getFeatureInfoUrl(coordinate, resolution, projection, params) {
        const projectionObj = (0, $92f1443438429e81$export$3988ae62b71be9a3)(projection);
        const sourceProjectionObj = this.getProjection();
        if (sourceProjectionObj && sourceProjectionObj !== projectionObj) {
            resolution = (0, $5bc6f6a25c982e7a$export$5fbb958059b7e71f)(sourceProjectionObj, projectionObj, coordinate, resolution);
            coordinate = (0, $92f1443438429e81$export$51186ad6e864892a)(coordinate, projectionObj, sourceProjectionObj);
        }
        const options = {
            url: this.url_,
            params: {
                ...this.params_,
                ...params
            },
            projection: sourceProjectionObj || projectionObj
        };
        return (0, $f6268beca71d7889$export$6f3ec358b8c06c5b)(options, coordinate, resolution);
    }
    /**
   * Return the GetLegendGraphic URL, optionally optimized for the passed
   * resolution and possibly including any passed specific parameters. Returns
   * `undefined` if the GetLegendGraphic URL cannot be constructed.
   *
   * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
   *     will not be calculated and included in URL.
   * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
   *     request is generated for this wms layer, else it will try to use the
   *     configured wms layer. Default `FORMAT` is `image/png`.
   *     `VERSION` should not be specified here.
   * @return {string|undefined} GetLegendGraphic URL.
   * @api
   */ getLegendUrl(resolution, params) {
        return (0, $f6268beca71d7889$export$9ee42325bd9ccc93)({
            url: this.url_,
            params: {
                ...this.params_,
                ...params
            }
        }, resolution);
    }
    /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */ getParams() {
        return this.params_;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../Image.js").default} Single image.
   * @override
   */ getImageInternal(extent, resolution, pixelRatio, projection) {
        if (this.url_ === undefined) return null;
        if (!this.loader || this.loaderProjection_ !== projection) {
            // Lazily create loader to pick up the view projection and to allow `params` updates
            this.loaderProjection_ = projection;
            this.loader = (0, $f6268beca71d7889$export$8e84ca9bef6adc3a)({
                crossOrigin: this.crossOrigin_,
                params: this.params_,
                projection: projection,
                serverType: this.serverType_,
                hidpi: this.hidpi_,
                url: this.url_,
                ratio: this.ratio_,
                load: (image, src)=>{
                    this.image.setImage(image);
                    this.imageLoadFunction_(this.image, src);
                    return (0, $e460a8a24b67695c$export$2f872c0f2117be69)(image);
                }
            });
        }
        return super.getImageInternal(extent, resolution, pixelRatio, projection);
    }
    /**
   * Return the image load function of the source.
   * @return {import("../Image.js").LoadFunction} The image load function.
   * @api
   */ getImageLoadFunction() {
        return this.imageLoadFunction_;
    }
    /**
   * Return the URL used for this WMS source.
   * @return {string|undefined} URL.
   * @api
   */ getUrl() {
        return this.url_;
    }
    /**
   * Set the image load function of the source.
   * @param {import("../Image.js").LoadFunction} imageLoadFunction Image load function.
   * @api
   */ setImageLoadFunction(imageLoadFunction) {
        this.imageLoadFunction_ = imageLoadFunction;
        this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string|undefined} url URL.
   * @api
   */ setUrl(url) {
        if (url != this.url_) {
            this.url_ = url;
            this.loader = null;
            this.changed();
        }
    }
    /**
   * Update the user-provided params.
   * @param {Object} params Params.
   * @api
   */ updateParams(params) {
        Object.assign(this.params_, params);
        this.changed();
    }
    /**
   * @override
   */ changed() {
        this.image = null;
        super.changed();
    }
}
var $7aea03074858c411$export$2e2bcd8739ae039 = $7aea03074858c411$var$ImageWMS;

/**
 * @module ol/source/TileWMS
 */ 






/**
 * @module ol/source/TileImage
 */ 




/**
 * @module ol/tilegrid
 */ 


/**
 * @module ol/tilegrid/TileGrid
 */ 








/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */ const $b5cc936d16623cb8$var$tmpTileCoord = [
    0,
    0,
    0
];
/**
 * Number of decimal digits to consider in integer values when rounding.
 * @type {number}
 */ const $b5cc936d16623cb8$var$DECIMALS = 5;
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile~TileSource} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<number|import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */ /**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */ class $b5cc936d16623cb8$var$TileGrid {
    /**
   * @param {Options} options Tile grid options.
   */ constructor(options){
        /**
     * @protected
     * @type {number}
     */ this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
     * @private
     * @type {!Array<number>}
     */ this.resolutions_ = options.resolutions;
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)((0, $830d23b8323fc080$export$efa610630f9e181)(this.resolutions_, /**
         * @param {number} a First resolution
         * @param {number} b Second resolution
         * @return {number} Comparison result
         */ (a, b)=>b - a, true), '`resolutions` must be sorted in descending order');
        // check if we've got a consistent zoom factor and origin
        let zoomFactor;
        if (!options.origins) for(let i = 0, ii = this.resolutions_.length - 1; i < ii; ++i){
            if (!zoomFactor) zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
            else if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                zoomFactor = undefined;
                break;
            }
        }
        /**
     * @private
     * @type {number|undefined}
     */ this.zoomFactor_ = zoomFactor;
        /**
     * @protected
     * @type {number}
     */ this.maxZoom = this.resolutions_.length - 1;
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate|null}
     */ this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
     * @private
     * @type {Array<import("../coordinate.js").Coordinate>}
     */ this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(this.origins_.length == this.resolutions_.length, 'Number of `origins` and `resolutions` must be equal');
        }
        const extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) this.origin_ = (0, $7e819822b33b3d32$export$cb1538b07e6964ff)(extent);
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!this.origin_ && this.origins_ || this.origin_ && !this.origins_, 'Either `origin` or `origins` must be configured, never both');
        /**
     * @private
     * @type {Array<number|import("../size.js").Size>}
     */ this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(this.tileSizes_.length == this.resolutions_.length, 'Number of `tileSizes` and `resolutions` must be equal');
        }
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.tileSize_ = options.tileSize !== undefined ? options.tileSize : !this.tileSizes_ ? (0, $9a8010a8337e7cef$export$6b8cb5cd370bd90c) : null;
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!this.tileSize_ && this.tileSizes_ || this.tileSize_ && !this.tileSizes_, 'Either `tileSize` or `tileSizes` must be configured, never both');
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.extent_ = extent !== undefined ? extent : null;
        /**
     * @private
     * @type {Array<import("../TileRange.js").default>}
     */ this.fullTileRanges_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.tmpSize_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = [
            0,
            0,
            0,
            0
        ];
        if (options.sizes !== undefined) this.fullTileRanges_ = options.sizes.map((size, z)=>{
            const tileRange = new (0, $014fe51f68272f2c$export$2e2bcd8739ae039)(Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
            if (extent) {
                const restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
            }
            return tileRange;
        });
        else if (extent) this.calculateTileRanges_(extent);
    }
    /**
   * Call a function with each tile coordinate for a given extent and zoom level.
   *
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} zoom Integer zoom level.
   * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
   * @api
   */ forEachTileCoord(extent, zoom, callback) {
        const tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for(let i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i)for(let j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j)callback([
            zoom,
            i,
            j
        ]);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {boolean} Callback succeeded.
   */ forEachTileCoordParentTileRange(tileCoord, callback, tempTileRange, tempExtent) {
        let tileRange, x, y;
        let tileCoordExtent = null;
        let z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        } else tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent);
        while(z >= this.minZoom){
            if (x !== undefined && y !== undefined) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = (0, $014fe51f68272f2c$export$958e3e1a02eac4b6)(x, x, y, y, tempTileRange);
            } else tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
            if (callback(z, tileRange)) return true;
            --z;
        }
        return false;
    }
    /**
   * Get the extent for this tile grid, if it was configured.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getExtent() {
        return this.extent_;
    }
    /**
   * Get the maximum zoom level for the grid.
   * @return {number} Max zoom.
   * @api
   */ getMaxZoom() {
        return this.maxZoom;
    }
    /**
   * Get the minimum zoom level for the grid.
   * @return {number} Min zoom.
   * @api
   */ getMinZoom() {
        return this.minZoom;
    }
    /**
   * Get the origin for the grid at the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {import("../coordinate.js").Coordinate} Origin.
   * @api
   */ getOrigin(z) {
        if (this.origin_) return this.origin_;
        return this.origins_[z];
    }
    /**
   * Get the resolution for the given zoom level.
   * @param {number} z Integer zoom level.
   * @return {number} Resolution.
   * @api
   */ getResolution(z) {
        return this.resolutions_[z];
    }
    /**
   * Get the list of resolutions for the tile grid.
   * @return {Array<number>} Resolutions.
   * @api
   */ getResolutions() {
        return this.resolutions_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary import("../extent.js").Extent object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileCoordChildTileRange(tileCoord, tempTileRange, tempExtent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                const minX = tileCoord[1] * 2;
                const minY = tileCoord[2] * 2;
                return (0, $014fe51f68272f2c$export$958e3e1a02eac4b6)(minX, minX + 1, minY, minY + 1, tempTileRange);
            }
            const tileCoordExtent = this.getTileCoordExtent(tileCoord, tempExtent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, tempTileRange);
        }
        return null;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary import("../TileRange.js").default object.
   * @return {import("../TileRange.js").default|null} Tile range.
   */ getTileRangeForTileCoordAndZ(tileCoord, z, tempTileRange) {
        if (z > this.maxZoom || z < this.minZoom) return null;
        const tileCoordZ = tileCoord[0];
        const tileCoordX = tileCoord[1];
        const tileCoordY = tileCoord[2];
        if (z === tileCoordZ) return (0, $014fe51f68272f2c$export$958e3e1a02eac4b6)(tileCoordX, tileCoordY, tileCoordX, tileCoordY, tempTileRange);
        if (this.zoomFactor_) {
            const factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            const minX = Math.floor(tileCoordX * factor);
            const minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) return (0, $014fe51f68272f2c$export$958e3e1a02eac4b6)(minX, minX, minY, minY, tempTileRange);
            const maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            const maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return (0, $014fe51f68272f2c$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
        }
        const tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, tempTileRange);
    }
    /**
   * Get a tile range for the given extent and integer zoom level.
   * @param {import("../extent.js").Extent} extent Extent.
   * @param {number} z Integer zoom level.
   * @param {import("../TileRange.js").default} [tempTileRange] Temporary tile range object.
   * @return {import("../TileRange.js").default} Tile range.
   */ getTileRangeForExtentAndZ(extent, z, tempTileRange) {
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, $b5cc936d16623cb8$var$tmpTileCoord);
        const minX = $b5cc936d16623cb8$var$tmpTileCoord[1];
        const minY = $b5cc936d16623cb8$var$tmpTileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, $b5cc936d16623cb8$var$tmpTileCoord);
        const maxX = $b5cc936d16623cb8$var$tmpTileCoord[1];
        const maxY = $b5cc936d16623cb8$var$tmpTileCoord[2];
        return (0, $014fe51f68272f2c$export$958e3e1a02eac4b6)(minX, maxX, minY, maxY, tempTileRange);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {import("../coordinate.js").Coordinate} Tile center.
   */ getTileCoordCenter(tileCoord) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution
        ];
    }
    /**
   * Get the extent of a tile coordinate.
   *
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} [tempExtent] Temporary extent object.
   * @return {import("../extent.js").Extent} Extent.
   * @api
   */ getTileCoordExtent(tileCoord, tempExtent) {
        const origin = this.getOrigin(tileCoord[0]);
        const resolution = this.getResolution(tileCoord[0]);
        const tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(this.getTileSize(tileCoord[0]), this.tmpSize_);
        const minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        const minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        const maxX = minX + tileSize[0] * resolution;
        const maxY = minY + tileSize[1] * resolution;
        return (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(minX, minY, maxX, maxY, tempExtent);
    }
    /**
   * Get the tile coordinate for the given map coordinate and resolution.  This
   * method considers that coordinates that intersect tile boundaries should be
   * assigned the higher tile coordinate.
   *
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndResolution(coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    }
    /**
   * Note that this method should not be called for resolutions that correspond
   * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
   * @param {number} x X.
   * @param {number} y Y.
   * @param {number} resolution Resolution (for a non-integer zoom level).
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndResolution_(x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        const z = this.getZForResolution(resolution);
        const scale = resolution / this.getResolution(z);
        const origin = this.getOrigin(z);
        const tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = scale * (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = scale * (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $d4e56cfc37d8b1f9$export$803ce6b71a0a94b2)(tileCoordX, $b5cc936d16623cb8$var$DECIMALS) - 1;
            tileCoordY = (0, $d4e56cfc37d8b1f9$export$803ce6b71a0a94b2)(tileCoordY, $b5cc936d16623cb8$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $d4e56cfc37d8b1f9$export$a3fe094919f356fd)(tileCoordX, $b5cc936d16623cb8$var$DECIMALS);
            tileCoordY = (0, $d4e56cfc37d8b1f9$export$a3fe094919f356fd)(tileCoordY, $b5cc936d16623cb8$var$DECIMALS);
        }
        return (0, $321b949bcc451ffb$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
   * they should have separate implementations.  This method is for integer zoom
   * levels.  The other method should only be called for resolutions corresponding
   * to non-integer zoom levels.
   * @param {number} x Map x coordinate.
   * @param {number} y Map y coordinate.
   * @param {number} z Integer zoom level.
   * @param {boolean} reverseIntersectionPolicy Instead of letting edge
   *     intersections go to the higher tile coordinate, let edge intersections
   *     go to the lower tile coordinate.
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @private
   */ getTileCoordForXYAndZ_(x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        const origin = this.getOrigin(z);
        const resolution = this.getResolution(z);
        const tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(this.getTileSize(z), this.tmpSize_);
        let tileCoordX = (x - origin[0]) / resolution / tileSize[0];
        let tileCoordY = (origin[1] - y) / resolution / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = (0, $d4e56cfc37d8b1f9$export$803ce6b71a0a94b2)(tileCoordX, $b5cc936d16623cb8$var$DECIMALS) - 1;
            tileCoordY = (0, $d4e56cfc37d8b1f9$export$803ce6b71a0a94b2)(tileCoordY, $b5cc936d16623cb8$var$DECIMALS) - 1;
        } else {
            tileCoordX = (0, $d4e56cfc37d8b1f9$export$a3fe094919f356fd)(tileCoordX, $b5cc936d16623cb8$var$DECIMALS);
            tileCoordY = (0, $d4e56cfc37d8b1f9$export$a3fe094919f356fd)(tileCoordY, $b5cc936d16623cb8$var$DECIMALS);
        }
        return (0, $321b949bcc451ffb$export$958e3e1a02eac4b6)(z, tileCoordX, tileCoordY, opt_tileCoord);
    }
    /**
   * Get a tile coordinate given a map coordinate and zoom level.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} z Integer zoom level, e.g. the result of a `getZForResolution()` method call
   * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
   * @api
   */ getTileCoordForCoordAndZ(coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @return {number} Tile resolution.
   */ getTileCoordResolution(tileCoord) {
        return this.resolutions_[tileCoord[0]];
    }
    /**
   * Get the tile size for a zoom level. The type of the return value matches the
   * `tileSize` or `tileSizes` that the tile grid was configured with. To always
   * get an {@link import("../size.js").Size}, run the result through {@link module:ol/size.toSize}.
   * @param {number} z Z.
   * @return {number|import("../size.js").Size} Tile size.
   * @api
   */ getTileSize(z) {
        if (this.tileSize_) return this.tileSize_;
        return this.tileSizes_[z];
    }
    /**
   * @param {number} z Zoom level.
   * @return {import("../TileRange.js").default|null} Extent tile range for the specified zoom level.
   */ getFullTileRange(z) {
        if (!this.fullTileRanges_) return this.extent_ ? this.getTileRangeForExtentAndZ(this.extent_, z) : null;
        return this.fullTileRanges_[z];
    }
    /**
   * @param {number} resolution Resolution.
   * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
   *     If 0, the nearest resolution will be used.
   *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
   *     nearest lower resolution (higher Z) will be used. Default is 0.
   *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
   *
   * For example to change tile Z at the midpoint of zoom levels
   * ```js
   * function(value, high, low) {
   *   return value - low * Math.sqrt(high / low);
   * }
   * ```
   * @return {number} Z.
   * @api
   */ getZForResolution(resolution, opt_direction) {
        const z = (0, $830d23b8323fc080$export$8a3786cc03fdb777)(this.resolutions_, resolution, opt_direction || 0);
        return (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(z, this.minZoom, this.maxZoom);
    }
    /**
   * The tile with the provided tile coordinate intersects the given viewport.
   * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coordinate.
   * @param {Array<number>} viewport Viewport as returned from {@link module:ol/extent.getRotatedViewport}.
   * @return {boolean} The tile with the provided tile coordinate intersects the given viewport.
   */ tileCoordIntersectsViewport(tileCoord, viewport) {
        return (0, $96949d2e503054c4$export$830a0dafbb2ef1c5)(viewport, 0, viewport.length, 2, this.getTileCoordExtent(tileCoord));
    }
    /**
   * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
   * @private
   */ calculateTileRanges_(extent) {
        const length = this.resolutions_.length;
        const fullTileRanges = new Array(length);
        for(let z = this.minZoom; z < length; ++z)fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        this.fullTileRanges_ = fullTileRanges;
    }
}
var $b5cc936d16623cb8$export$2e2bcd8739ae039 = $b5cc936d16623cb8$var$TileGrid;




function $a46307816b1ae884$export$1f4812384df8a9c5(projection) {
    let tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = $a46307816b1ae884$export$a251b12f5601c16f(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
function $a46307816b1ae884$export$39a9ce3624977b84(tileGrid, tileCoord, projection) {
    const z = tileCoord[0];
    const center = tileGrid.getTileCoordCenter(tileCoord);
    const projectionExtent = $a46307816b1ae884$export$7b5b6ef8fd55fac4(projection);
    if (!(0, $7e819822b33b3d32$export$ac68c24d37ca240f)(projectionExtent, center)) {
        const worldWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projectionExtent);
        const worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    return tileCoord;
}
function $a46307816b1ae884$export$ce88871416242df8(extent, maxZoom, tileSize, corner) {
    corner = corner !== undefined ? corner : 'top-left';
    const resolutions = $a46307816b1ae884$var$resolutionsFromExtent(extent, maxZoom, tileSize);
    return new (0, $b5cc936d16623cb8$export$2e2bcd8739ae039)({
        extent: extent,
        origin: (0, $7e819822b33b3d32$export$a1cfd206661d0801)(extent, corner),
        resolutions: resolutions,
        tileSize: tileSize
    });
}
function $a46307816b1ae884$export$38500bbeccc864ff(options) {
    const xyzOptions = options || {};
    const extent = xyzOptions.extent || (0, $92f1443438429e81$export$3988ae62b71be9a3)('EPSG:3857').getExtent();
    const gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: $a46307816b1ae884$var$resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution)
    };
    return new (0, $b5cc936d16623cb8$export$2e2bcd8739ae039)(gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */ function $a46307816b1ae884$var$resolutionsFromExtent(extent, maxZoom, tileSize, maxResolution) {
    maxZoom = maxZoom !== undefined ? maxZoom : (0, $9a8010a8337e7cef$export$e98a216cdcc847dc);
    tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(tileSize !== undefined ? tileSize : (0, $9a8010a8337e7cef$export$6b8cb5cd370bd90c));
    const height = (0, $7e819822b33b3d32$export$c08559766941f856)(extent);
    const width = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent);
    maxResolution = maxResolution > 0 ? maxResolution : Math.max(width / tileSize[0], height / tileSize[1]);
    const length = maxZoom + 1;
    const resolutions = new Array(length);
    for(let z = 0; z < length; ++z)resolutions[z] = maxResolution / Math.pow(2, z);
    return resolutions;
}
function $a46307816b1ae884$export$a251b12f5601c16f(projection, maxZoom, tileSize, corner) {
    const extent = $a46307816b1ae884$export$7b5b6ef8fd55fac4(projection);
    return $a46307816b1ae884$export$ce88871416242df8(extent, maxZoom, tileSize, corner);
}
function $a46307816b1ae884$export$7b5b6ef8fd55fac4(projection) {
    projection = (0, $92f1443438429e81$export$3988ae62b71be9a3)(projection);
    let extent = projection.getExtent();
    if (!extent) {
        const half = 180 * (0, $fb72d58bc9104528$export$1482081eec883108).degrees / projection.getMetersPerUnit();
        extent = (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(-half, -half, half, half);
    }
    return extent;
}



/**
 * @module ol/source/UrlTile
 */ 
/**
 * @module ol/tileurlfunction
 */ 


function $847880a03aa9cac5$export$f0ecb46e90798741(template, tileGrid) {
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        let maxY;
        const z = tileCoord[0];
        if (tileGrid) {
            // The `{-y}` placeholder only works for sources that have a tile grid at construction
            const range = tileGrid.getFullTileRange(z);
            if (range) maxY = range.getHeight() - 1;
        }
        return (0, $e04dc6b4d00037d8$export$df1e52f1b5b1c86f)(template, z, tileCoord[1], tileCoord[2], maxY);
    });
}
function $847880a03aa9cac5$export$436f44dbcc31fea3(templates, tileGrid) {
    const len = templates.length;
    const tileUrlFunctions = new Array(len);
    for(let i = 0; i < len; ++i)tileUrlFunctions[i] = $847880a03aa9cac5$export$f0ecb46e90798741(templates[i], tileGrid);
    return $847880a03aa9cac5$export$4229b1d9af69b3be(tileUrlFunctions);
}
function $847880a03aa9cac5$export$4229b1d9af69b3be(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) return tileUrlFunctions[0];
    return(/**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */ function(tileCoord, pixelRatio, projection) {
        if (!tileCoord) return undefined;
        const h = (0, $321b949bcc451ffb$export$d6af199866bfb566)(tileCoord);
        const index = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)(h, tileUrlFunctions.length);
        return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
    });
}
function $847880a03aa9cac5$export$fab585f002f634a1(tileCoord, pixelRatio, projection) {
    return undefined;
}




/**
 * @module ol/source/Tile
 */ 





/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=false] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 *
 * @template {import("../Tile.js").default} [TileType=import("../Tile.js").default]
 * @abstract
 * @api
 */ class $5386d6ea3128b160$var$TileSource extends (0, $dba8564f516aed29$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options SourceTile source options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
            interpolate: options.interpolate
        });
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {TileSourceOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {TileSourceOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {number}
     */ this.tilePixelRatio_ = options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
     * @type {import("../tilegrid/TileGrid.js").default|null}
     * @protected
     */ this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        const tileSize = [
            256,
            256
        ];
        if (this.tileGrid) (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(this.tileGrid.getTileSize(this.tileGrid.getMinZoom()), tileSize);
        /**
     * @protected
     * @type {import("../size.js").Size}
     */ this.tmpSize = [
            0,
            0
        ];
        /**
     * @private
     * @type {string}
     */ this.key_ = options.key || (0, $34772e91e89a736f$export$5e82334337e0f204)(this);
        /**
     * @protected
     * @type {import("../Tile.js").Options}
     */ this.tileOptions = {
            transition: options.transition,
            interpolate: options.interpolate
        };
        /**
     * zDirection hint, read by the renderer. Indicates which resolution should be used
     * by a renderer if the views resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @type {number|import("../array.js").NearestDirectionFunction}
     */ this.zDirection = options.zDirection ? options.zDirection : 0;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   */ getGutterForProjection(projection) {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   */ getKey() {
        return this.key_;
    }
    /**
   * Set the value to be used as the key for all tiles in the source.
   * @param {string} key The key for tiles.
   * @protected
   */ setKey(key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    }
    /**
   * @param {import("../proj/Projection").default} [projection] Projection.
   * @return {Array<number>|null} Resolutions.
   * @override
   */ getResolutions(projection) {
        const tileGrid = projection ? this.getTileGridForProjection(projection) : this.tileGrid;
        if (!tileGrid) return null;
        return tileGrid.getResolutions();
    }
    /**
   * @abstract
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {TileType|null} Tile.
   */ getTile(z, x, y, pixelRatio, projection) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Return the tile grid of the tile source.
   * @return {import("../tilegrid/TileGrid.js").default|null} Tile grid.
   * @api
   */ getTileGrid() {
        return this.tileGrid;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   */ getTileGridForProjection(projection) {
        if (!this.tileGrid) return (0, $a46307816b1ae884$export$1f4812384df8a9c5)(projection);
        return this.tileGrid;
    }
    /**
   * Get the tile pixel ratio for this source. Subclasses may override this
   * method, which is meant to return a supported pixel ratio that matches the
   * provided `pixelRatio` as close as possible.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   */ getTilePixelRatio(pixelRatio) {
        return this.tilePixelRatio_;
    }
    /**
   * @param {number} z Z.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {import("../size.js").Size} Tile size.
   */ getTilePixelSize(z, pixelRatio, projection) {
        const tileGrid = this.getTileGridForProjection(projection);
        const tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        const tileSize = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) return tileSize;
        return (0, $f65ee5b9d8e75975$export$dcdf75081b88279d)(tileSize, tilePixelRatio, this.tmpSize);
    }
    /**
   * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
   * is outside the resolution and extent range of the tile grid, `null` will be
   * returned.
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../proj/Projection.js").default} [projection] Projection.
   * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
   *     null if no tile URL should be created for the passed `tileCoord`.
   */ getTileCoordForTileUrlFunction(tileCoord, projection) {
        const gridProjection = projection !== undefined ? projection : this.getProjection();
        const tileGrid = projection !== undefined ? this.getTileGridForProjection(gridProjection) : this.tileGrid || this.getTileGridForProjection(gridProjection);
        if (this.getWrapX() && gridProjection.isGlobal()) tileCoord = (0, $a46307816b1ae884$export$39a9ce3624977b84)(tileGrid, tileCoord, gridProjection);
        return (0, $321b949bcc451ffb$export$60bedf8e3e3c3dbe)(tileCoord, tileGrid) ? tileCoord : null;
    }
    /**
   * Remove all cached reprojected tiles from the source. The next render cycle will create new tiles.
   * @api
   */ clear() {}
    /**
   * @override
   */ refresh() {
        this.clear();
        super.refresh();
    }
}
class $5386d6ea3128b160$export$c571855c51e6c4b6 extends (0, $0327f54963b35733$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Type.
   * @param {import("../Tile.js").default} tile The tile.
   */ constructor(type, tile){
        super(type);
        /**
     * The tile related to the event.
     * @type {import("../Tile.js").default}
     * @api
     */ this.tile = tile;
    }
}
var $5386d6ea3128b160$export$2e2bcd8739ae039 = $5386d6ea3128b160$var$TileSource;


/**
 * @module ol/source/TileEventType
 */ /**
 * @enum {string}
 */ var $9a12283e10a2a947$export$2e2bcd8739ae039 /**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */  = {
    /**
   * Triggered when a tile starts loading.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
   * @api
   */ TILELOADSTART: 'tileloadstart',
    /**
   * Triggered when a tile finishes loading, either when its data is loaded,
   * or when loading was aborted because the tile is no longer needed.
   * @event module:ol/source/Tile.TileSourceEvent#tileloadend
   * @api
   */ TILELOADEND: 'tileloadend',
    /**
   * Triggered if tile loading results in an error. Note that this is not the
   * right place to re-fetch tiles. See {@link module:ol/ImageTile~ImageTile#load}
   * for details.
   * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
   * @api
   */ TILELOADERROR: 'tileloaderror'
};


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./Source.js").State} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 * @property {boolean} [interpolate=false] Use interpolated values when resampling.  By default,
 * the nearest neighbor is used when resampling.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */ class $717890273ec27e1e$var$UrlTile extends (0, $5386d6ea3128b160$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {boolean}
     */ this.generateTileUrlFunction_ = this.tileUrlFunction === $717890273ec27e1e$var$UrlTile.prototype.tileUrlFunction;
        /**
     * @protected
     * @type {import("../Tile.js").LoadFunction}
     */ this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) this.tileUrlFunction = options.tileUrlFunction;
        /**
     * @protected
     * @type {!Array<string>|null}
     */ this.urls = null;
        if (options.urls) this.setUrls(options.urls);
        else if (options.url) this.setUrl(options.url);
        /**
     * @private
     * @type {!Object<string, boolean>}
     */ this.tileLoadingKeys_ = {};
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile load function of the source.
   * @return {import("../Tile.js").LoadFunction} TileLoadFunction
   * @api
   */ getTileLoadFunction() {
        return this.tileLoadFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the tile URL function of the source.
   * @return {import("../Tile.js").UrlFunction} TileUrlFunction
   * @api
   */ getTileUrlFunction() {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction ? this.tileUrlFunction.bind(this) : this.tileUrlFunction;
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Return the URLs used for this source.
   * When a tileUrlFunction is used instead of url or urls,
   * null will be returned.
   * @return {!Array<string>|null} URLs.
   * @api
   */ getUrls() {
        return this.urls;
    }
    /**
   * Handle tile change events.
   * @param {import("../events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("../Tile.js").default} */ event.target;
        const uid = (0, $34772e91e89a736f$export$5e82334337e0f204)(tile);
        const tileState = tile.getState();
        let type;
        if (tileState == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = (0, $9a12283e10a2a947$export$2e2bcd8739ae039).TILELOADSTART;
        } else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type = tileState == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR ? (0, $9a12283e10a2a947$export$2e2bcd8739ae039).TILELOADERROR : tileState == (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED ? (0, $9a12283e10a2a947$export$2e2bcd8739ae039).TILELOADEND : undefined;
        }
        if (type != undefined) this.dispatchEvent(new (0, $5386d6ea3128b160$export$c571855c51e6c4b6)(type, tile));
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile load function of the source.
   * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
   * @api
   */ setTileLoadFunction(tileLoadFunction) {
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the tile URL function of the source.
   * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
   * @param {string} [key] Optional new tile key for the source.
   * @api
   */ setTileUrlFunction(tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        if (typeof key !== 'undefined') this.setKey(key);
        else this.changed();
    }
    /**
   * Set the URL to use for requests.
   * @param {string} url URL.
   * @api
   */ setUrl(url) {
        const urls = (0, $e04dc6b4d00037d8$export$2a1fa079bfd73dde)(url);
        this.urls = urls;
        this.setUrls(urls);
    }
    /**
   * Deprecated.  Use an ImageTile source instead.
   * Set the URLs to use for requests.
   * @param {Array<string>} urls URLs.
   * @api
   */ setUrls(urls) {
        this.urls = urls;
        const key = urls.join('\n');
        if (this.generateTileUrlFunction_) this.setTileUrlFunction((0, $847880a03aa9cac5$export$436f44dbcc31fea3)(urls, this.tileGrid), key);
        else this.setKey(key);
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {string|undefined} Tile URL.
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        return undefined;
    }
}
var $717890273ec27e1e$export$2e2bcd8739ae039 = $717890273ec27e1e$var$UrlTile;


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./Source.js").State} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @deprecated Use the ol/source/ImageTile.js instead.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */ class $1df042038de9d51b$var$TileImage extends (0, $717890273ec27e1e$export$2e2bcd8739ae039) {
    /**
   * @param {!Options} options Image tile options.
   */ constructor(options){
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction ? options.tileLoadFunction : $1df042038de9d51b$var$defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            interpolate: options.interpolate !== undefined ? options.interpolate : true,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @protected
     * @type {?string}
     */ this.crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
     * @protected
     * @type {typeof ImageTile}
     */ this.tileClass = options.tileClass !== undefined ? options.tileClass : (0, $50fe57b595b18ff9$export$2e2bcd8739ae039);
        /**
     * @protected
     * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
     */ this.tileGridForProjection = {};
        /**
     * @private
     * @type {number|undefined}
     */ this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
     * @private
     * @type {boolean}
     */ this.renderReprojectionEdges_ = false;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {number} Gutter.
   * @override
   */ getGutterForProjection(projection) {
        if (this.getProjection() && projection && !(0, $92f1443438429e81$export$fe091d73a555748b)(this.getProjection(), projection)) return 0;
        return this.getGutter();
    }
    /**
   * @return {number} Gutter.
   */ getGutter() {
        return 0;
    }
    /**
   * Return the key to be used for all tiles in the source.
   * @return {string} The key for all tiles.
   * @override
   */ getKey() {
        let key = super.getKey();
        if (!this.getInterpolate()) key += ':disable-interpolation';
        return key;
    }
    /**
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
   * @override
   */ getTileGridForProjection(projection) {
        const thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || (0, $92f1443438429e81$export$fe091d73a555748b)(thisProj, projection))) return this.tileGrid;
        const projKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(projection);
        if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = (0, $a46307816b1ae884$export$1f4812384df8a9c5)(projection);
        return this.tileGridForProjection[projKey];
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {string} key The key set on the tile.
   * @return {!ImageTile} Tile.
   * @private
   */ createTile_(z, x, y, pixelRatio, projection, key) {
        const tileCoord = [
            z,
            x,
            y
        ];
        const urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tileUrl = urlTileCoord ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection) : undefined;
        const tile = new this.tileClass(tileCoord, tileUrl !== undefined ? (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE : (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY, tileUrl !== undefined ? tileUrl : '', this.crossOrigin, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleTileChange.bind(this));
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @return {!(ImageTile|ReprojTile)} Tile.
   * @override
   */ getTile(z, x, y, pixelRatio, projection) {
        const sourceProjection = this.getProjection();
        if (!sourceProjection || !projection || (0, $92f1443438429e81$export$fe091d73a555748b)(sourceProjection, projection)) return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        const tileCoord = [
            z,
            x,
            y
        ];
        const key = this.getKey();
        const sourceTileGrid = this.getTileGridForProjection(sourceProjection);
        const targetTileGrid = this.getTileGridForProjection(projection);
        const wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        const tile = new (0, $c8ca3105da7720d1$export$2e2bcd8739ae039)(sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), (z, x, y, pixelRatio)=>this.getTileInternal(z, x, y, pixelRatio, sourceProjection), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.tileOptions);
        tile.key = key;
        return tile;
    }
    /**
   * @param {number} z Tile coordinate z.
   * @param {number} x Tile coordinate x.
   * @param {number} y Tile coordinate y.
   * @param {number} pixelRatio Pixel ratio.
   * @param {!import("../proj/Projection.js").default} projection Projection.
   * @return {!ImageTile} Tile.
   * @protected
   */ getTileInternal(z, x, y, pixelRatio, projection) {
        const key = this.getKey();
        return this.createTile_(z, x, y, pixelRatio, projection, key);
    }
    /**
   * Sets whether to render reprojection edges or not (usually for debugging).
   * @param {boolean} render Render the edges.
   * @api
   */ setRenderReprojectionEdges(render) {
        if (this.renderReprojectionEdges_ == render) return;
        this.renderReprojectionEdges_ = render;
        this.changed();
    }
    /**
   * Sets the tile grid to use when reprojecting the tiles to the given
   * projection instead of the default tile grid for the projection.
   *
   * This can be useful when the default tile grid cannot be created
   * (e.g. projection has no extent defined) or
   * for optimization reasons (custom tile size, resolutions, ...).
   *
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
   * @api
   */ setTileGridForProjection(projection, tilegrid) {
        const proj = (0, $92f1443438429e81$export$3988ae62b71be9a3)(projection);
        if (proj) {
            const projKey = (0, $34772e91e89a736f$export$5e82334337e0f204)(proj);
            if (!(projKey in this.tileGridForProjection)) this.tileGridForProjection[projKey] = tilegrid;
        }
    }
}
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */ function $1df042038de9d51b$var$defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ imageTile.getImage().src = src;
}
var $1df042038de9d51b$export$2e2bcd8739ae039 = $1df042038de9d51b$var$TileImage;



/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {Object<string,*>} params WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
 * @property {number} [gutter=0]
 * The size in pixels of the gutter around image tiles to ignore. By setting
 * this property to a non-zero value, images will be requested that are wider
 * and taller than the tile size by a value of `2 x gutter`.
 * Using a non-zero value allows artifacts of rendering at tile edges to be
 * ignored. If you control the WMS service it is recommended to address
 * "artifacts at tile edges" issues by properly configuring the WMS service. For
 * example, MapServer has a `tile_map_edge_buffer` configuration parameter for
 * this. See https://mapserver.org/output/tile_mode.html.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid. Base this on the resolutions,
 * tilesize and extent supported by the server.
 * If this is not defined, a default grid will be used: if there is a projection
 * extent, the grid will be based on that; if not, a grid based on a global
 * extent with origin at 0,0 will be used.
 * @property {import("./wms.js").ServerType} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver`, `carmentaserver`, or `qgis`.
 * Only needed if `hidpi` is `true`.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {string} [url] WMS service URL.
 * @property {Array<string>} [urls] WMS service urls.
 * Use this instead of `url` when the WMS supports multiple urls for GetMap requests.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * When set to `false`, only one world
 * will be rendered. When `true`, tiles will be requested for one world only,
 * but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data from WMS servers.
 * @api
 */ class $012114ccc3d7b503$var$TileWMS extends (0, $1df042038de9d51b$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Tile WMS options.
   */ constructor(options){
        options = options ? options : /** @type {Options} */ {};
        const params = Object.assign({}, options.params);
        super({
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileClass: options.tileClass,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
        /**
     * @private
     * @type {!Object}
     */ this.params_ = params;
        /**
     * @private
     * @type {boolean}
     */ this.v13_ = true;
        /**
     * @private
     * @type {import("./wms.js").ServerType}
     */ this.serverType_ = options.serverType;
        /**
     * @private
     * @type {boolean}
     */ this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
     * @private
     * @type {import("../extent.js").Extent}
     */ this.tmpExtent_ = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        this.updateV13_();
        this.setKey(this.getKeyForParams_());
    }
    /**
   * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
   * projection. Return `undefined` if the GetFeatureInfo URL cannot be
   * constructed.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {import("../proj.js").ProjectionLike} projection Projection.
   * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
   *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
   *     in the `LAYERS` parameter will be used. `VERSION` should not be
   *     specified here.
   * @return {string|undefined} GetFeatureInfo URL.
   * @api
   */ getFeatureInfoUrl(coordinate, resolution, projection, params) {
        const projectionObj = (0, $92f1443438429e81$export$3988ae62b71be9a3)(projection);
        const sourceProjectionObj = this.getProjection() || projectionObj;
        let tileGrid = this.getTileGrid();
        if (!tileGrid) tileGrid = this.getTileGridForProjection(sourceProjectionObj);
        const sourceProjCoord = (0, $92f1443438429e81$export$51186ad6e864892a)(coordinate, projectionObj, sourceProjectionObj);
        const sourceResolution = (0, $5bc6f6a25c982e7a$export$5fbb958059b7e71f)(sourceProjectionObj, projectionObj, coordinate, resolution);
        const z = tileGrid.getZForResolution(sourceResolution, this.zDirection);
        const tileResolution = tileGrid.getResolution(z);
        const tileCoord = tileGrid.getTileCoordForCoordAndZ(sourceProjCoord, z);
        if (tileGrid.getResolutions().length <= tileCoord[0]) return undefined;
        let tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        const gutter = this.gutter_;
        if (gutter !== 0) tileExtent = (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(tileExtent, tileResolution * gutter, tileExtent);
        const baseParams = {
            'QUERY_LAYERS': this.params_['LAYERS']
        };
        Object.assign(baseParams, (0, $f6268beca71d7889$export$a4c60e148c7af082)(this.params_, 'GetFeatureInfo'), params);
        const x = Math.floor((sourceProjCoord[0] - tileExtent[0]) / tileResolution);
        const y = Math.floor((tileExtent[3] - sourceProjCoord[1]) / tileResolution);
        baseParams[this.v13_ ? 'I' : 'X'] = x;
        baseParams[this.v13_ ? 'J' : 'Y'] = y;
        return this.getRequestUrl_(tileCoord, tileExtent, 1, sourceProjectionObj || projectionObj, baseParams);
    }
    /**
   * Return the GetLegendGraphic URL, optionally optimized for the passed
   * resolution and possibly including any passed specific parameters. Returns
   * `undefined` if the GetLegendGraphic URL cannot be constructed.
   *
   * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
   *     will not be calculated and included in URL.
   * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
   *     request is generated for this wms layer, else it will try to use the
   *     configured wms layer. Default `FORMAT` is `image/png`.
   *     `VERSION` should not be specified here.
   * @return {string|undefined} GetLegendGraphic URL.
   * @api
   */ getLegendUrl(resolution, params) {
        if (this.urls[0] === undefined) return undefined;
        const baseParams = {
            'SERVICE': 'WMS',
            'VERSION': (0, $f6268beca71d7889$export$363ebe89e6e7aeef),
            'REQUEST': 'GetLegendGraphic',
            'FORMAT': 'image/png'
        };
        if (params === undefined || params['LAYER'] === undefined) {
            const layers = this.params_.LAYERS;
            const isSingleLayer = !Array.isArray(layers) || layers.length === 1;
            if (!isSingleLayer) return undefined;
            baseParams['LAYER'] = layers;
        }
        if (resolution !== undefined) {
            const mpu = this.getProjection() ? this.getProjection().getMetersPerUnit() : 1;
            const pixelSize = 0.00028;
            baseParams['SCALE'] = resolution * mpu / pixelSize;
        }
        Object.assign(baseParams, params);
        return (0, $e04dc6b4d00037d8$export$c202e3cb8db99a95)(/** @type {string} */ this.urls[0], baseParams);
    }
    /**
   * @return {number} Gutter.
   * @override
   */ getGutter() {
        return this.gutter_;
    }
    /**
   * Get the user-provided params, i.e. those passed to the constructor through
   * the "params" option, and possibly updated using the updateParams method.
   * @return {Object} Params.
   * @api
   */ getParams() {
        return this.params_;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
   * @param {import("../extent.js").Extent} tileExtent Tile extent.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../proj/Projection.js").default} projection Projection.
   * @param {Object} params Params.
   * @return {string|undefined} Request URL.
   * @private
   */ getRequestUrl_(tileCoord, tileExtent, pixelRatio, projection, params) {
        const urls = this.urls;
        if (!urls) return undefined;
        let url;
        if (urls.length == 1) url = urls[0];
        else {
            const index = (0, $d4e56cfc37d8b1f9$export$ba467bec01d66def)((0, $321b949bcc451ffb$export$d6af199866bfb566)(tileCoord), urls.length);
            url = urls[index];
        }
        return (0, $f6268beca71d7889$export$ef1c8480e0b65584)(tileExtent, (this.tileGrid || this.getTileGridForProjection(projection)).getResolution(tileCoord[0]), pixelRatio, projection, url, params, this.serverType_);
    }
    /**
   * Get the tile pixel ratio for this source.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Tile pixel ratio.
   * @override
   */ getTilePixelRatio(pixelRatio) {
        return !this.hidpi_ || this.serverType_ === undefined ? 1 : pixelRatio;
    }
    /**
   * @private
   * @return {string} The key for the current params.
   */ getKeyForParams_() {
        let i = 0;
        const res = [];
        for(const key in this.params_)res[i++] = key + '-' + this.params_[key];
        return res.join('/');
    }
    /**
   * Update the user-provided params.
   * @param {Object} params Params.
   * @api
   */ updateParams(params) {
        Object.assign(this.params_, params);
        this.updateV13_();
        this.setKey(this.getKeyForParams_());
    }
    /**
   * @private
   */ updateV13_() {
        const version = this.params_['VERSION'] || (0, $f6268beca71d7889$export$363ebe89e6e7aeef);
        this.v13_ = (0, $812f370f71eebcf4$export$66e1c0999abad646)(version, '1.3') >= 0;
    }
    /**
   * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
   * @param {number} pixelRatio The pixel ratio
   * @param {import("../proj/Projection.js").default} projection The projection
   * @return {string|undefined} The tile URL
   * @override
   */ tileUrlFunction(tileCoord, pixelRatio, projection) {
        let tileGrid = this.getTileGrid();
        if (!tileGrid) tileGrid = this.getTileGridForProjection(projection);
        if (tileGrid.getResolutions().length <= tileCoord[0]) return undefined;
        if (pixelRatio != 1 && (!this.hidpi_ || this.serverType_ === undefined)) pixelRatio = 1;
        const tileResolution = tileGrid.getResolution(tileCoord[0]);
        let tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        const gutter = this.gutter_;
        if (gutter !== 0) tileExtent = (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(tileExtent, tileResolution * gutter, tileExtent);
        const baseParams = Object.assign({}, (0, $f6268beca71d7889$export$a4c60e148c7af082)(this.params_, 'GetMap'));
        return this.getRequestUrl_(tileCoord, tileExtent, pixelRatio, projection, baseParams);
    }
}
var $012114ccc3d7b503$export$2e2bcd8739ae039 = $012114ccc3d7b503$var$TileWMS;






/**
 * A slider to select numeric values
 * @extends UIElement
 */ class $c7406baad5d56380$export$472062a354075cee extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Slider id
     * @param min {number} The minimum value for the slider
     * @param max {number} The maximum value for the slider
     * @param value {number} The initial value
     * @param step {number} Step size. The precision of this slider
     * @param tickCount {number} How many ticks to show (integer). If undefined, no ticks are shown
     * @param labelFormatter {function} A function that takes a value and format's it to show the user. Can be undefined
     * @param legendFormatter {function} A function that takes a value and returns a legend to add to the slider
     * @param onChange {function} A callback to be called when the value changes
     * @param delayChange {boolean} Should the call to the onChange callback be slightly delayed?
     * @param isInteger {boolean} Should this slider only return integer values?
     * @param parentSlider {Slider} A parent slider. When this slider is in the min/max value and the user clicks next/previous, checks with the parent slider if there are next/previous values
     * @param getMaxForParentValue {function} If there is a parentSlider, this function is going to be called to get the next value for this slider when it is in the min value and the user clicks previous
     * @param getMinForParentValue {function} If there is a parentSlider, this function is going to be called to get the previous value for this slider when it is in the max value and the user clicks next
     */ constructor(translator, isMobileDevice, id, min, max, value, step, tickCount, labelFormatter, legendFormatter, onChange, delayChange, isInteger, parentSlider, getMaxForParentValue, getMinForParentValue){
        super(id, translator, isMobileDevice, undefined, undefined);
        this.min = min;
        this.max = max;
        this.value = value !== undefined ? value : min;
        if (min !== undefined) this.value = Math.max(this.min, this.value);
        if (max !== undefined && this.value !== undefined) this.value = Math.min(this.max, this.value);
        this.step = step;
        this.tickCount = tickCount === 0 ? 0 : Math.max(1, tickCount);
        this.labelFormatter = labelFormatter;
        this.legendFormatter = legendFormatter;
        this.isInteger = isInteger;
        this.parentSlider = parentSlider;
        this.onChangeCallbacks = new Set();
        this.onChange(onChange);
        this.delayChange = delayChange;
        this.changeImmediately = !this.delayChange;
        this.getMinForParentValue = getMinForParentValue;
        this.getMaxForParentValue = getMaxForParentValue;
        if (this.parentSlider) this.parentSlider.onChange((parent)=>{
            this._checkEnabledNextPrevious();
        });
        if (this.value < this.min) this.setValue(this.min);
        if (this.value > this.max) this.setValue(this.max);
    }
    getClassName() {
        return "Slider";
    }
    handleLabel(count, index, lastIndex, option, tick, formattedValue) {
        const midIndex = Math.floor((count + 1) / 2 - 1);
        const hasSecondMiddleTick = (index)=>count > 6 && count <= 13 && count % 2 === 0 && index === midIndex + 1;
        if (index === 0) {
            this.addLabel(option, tick, formattedValue);
            return true;
        }
        if (this.tickCount < 4) {
            this.addLabel(option, tick, formattedValue);
            return true;
        }
        if (this.tickCount > 4 && index === midIndex) {
            this.addLabel(option, tick, formattedValue, hasSecondMiddleTick(index + 1) && formattedValue.length > 2);
            return true;
        }
        if (hasSecondMiddleTick(index)) {
            this.addLabel(option, tick, formattedValue, formattedValue.length > 2);
            return true;
        }
        if (index === lastIndex) {
            this.addLabel(option, tick, formattedValue);
            return true;
        }
        return false;
    }
    addLabel(option, element, formattedValue, rotate = false) {
        option.attr('label', formattedValue);
        $dc57b31f1b066f38$exports('div.label', element).html(formattedValue).attr('title', formattedValue);
        if (rotate) $dc57b31f1b066f38$exports('div.label', element).addClass('rotated');
    }
    getUIElement() {
        if (!this.uiElement) {
            const labelFormatter = this._getLabelFormatter();
            this.uiElement = $dc57b31f1b066f38$exports('<div id="' + this.id + '" class="slider-input">' + '   <div class="slider-header">' + '       <div class="previous-value"><button title="' + this.translator.translate('slider.previous.button.name') + '" class="slider-previous-button"></button></div>' + '       <div class="value">' + this.formatSelectedValue(this.value) + '</div>' + '       <div class="next-value"><button title="' + this.translator.translate('slider.next.button.name') + '" class="slider-next-button"></button></div>' + '   </div>' + '   <input type="range" min="' + this.min + '" max="' + this.max + '" value="' + this.value + '" step="' + this.step + '" />' + '</div>');
            if (this.min === this.max) {
                this.uiElement.addClass('disabled');
                $dc57b31f1b066f38$exports('input[type=range]', this.uiElement).attr('disabled', 'disabled');
            }
            if (this.tickCount) {
                const tickMarksId = this.id + '_tickmarks';
                $dc57b31f1b066f38$exports('input[type=range]', this.uiElement).attr('list', tickMarksId);
                const dataList = $dc57b31f1b066f38$exports('<datalist id="' + tickMarksId + '"></datalist>');
                const tickMarks = $dc57b31f1b066f38$exports('<div class="slider-ticks"></div>');
                let increment = Number(((this.max - this.min) / (this.tickCount - 1)).toFixed(10));
                let count = this.tickCount;
                let lastIndex = count - 1;
                if (this.isInteger && this.min < this.max) {
                    increment = Math.floor(increment);
                    while((this.max - this.min) % increment !== 0){
                        increment++;
                        if (increment > (this.max - this.min) / 2) {
                            increment = 1;
                            break;
                        }
                    }
                    count = (this.max - this.min + 1) / increment;
                    lastIndex = count - 1;
                } else increment = Number(increment.toFixed(10)); //avoid floating point error
                let index = 0;
                this.markedValues = [];
                const self = this;
                if (this.min <= this.max) for(let value = this.min; value <= this.max; value = Number((value + increment).toFixed(10))){
                    const formattedValue = labelFormatter(Number(value));
                    this.markedValues.push(value);
                    const option = $dc57b31f1b066f38$exports('<option value="' + formattedValue + '"></option>');
                    dataList.append(option);
                    const tick = $dc57b31f1b066f38$exports('<div><div class="label"></div></div>');
                    tickMarks.append(tick);
                    if (!this.handleLabel(count, index, lastIndex, option, tick, formattedValue)) tick.attr('title', formattedValue);
                    tick.data('value', value);
                    tick.click(function() {
                        const rangeInput = $dc57b31f1b066f38$exports('input[type=range]', self.uiElement);
                        rangeInput.val($dc57b31f1b066f38$exports(this).data('value'));
                        self._onChangeSlider(false);
                        self.logStat("TICK {" + $dc57b31f1b066f38$exports(this).data('value') + "}");
                    });
                    index++;
                }
                if (index > 50) tickMarks.addClass('many-marks');
                if (index > 65) tickMarks.addClass('too-many-marks');
                this.uiElement.append(tickMarks);
                this.uiElement.append(dataList);
                $dc57b31f1b066f38$exports('.previous-value button', this.uiElement).click(()=>{
                    this.previous();
                    this.logStat("PREVIOUS {" + this.value + "}");
                });
                $dc57b31f1b066f38$exports('.next-value button', this.uiElement).click(()=>{
                    this.next();
                    this.logStat("NEXT {" + this.value + "}");
                });
                this._checkEnabledNextPrevious();
            } else {
                $dc57b31f1b066f38$exports('.previous-value', this.uiElement).hide();
                $dc57b31f1b066f38$exports('.next-value', this.uiElement).hide();
            }
            this.uiElement.append($dc57b31f1b066f38$exports('<div class="slider-legend"></div>'));
            this._updateLegend();
            $dc57b31f1b066f38$exports('input[type=range]', this.uiElement).change(()=>{
                this._onChangeSlider(true);
            }).on('input', function() {
                $dc57b31f1b066f38$exports(this).trigger('change');
            });
        }
        return this.uiElement;
    }
    _onChangeSlider(fromUser) {
        const value = Number($dc57b31f1b066f38$exports('input[type=range]', this.uiElement).val());
        if (fromUser && !this.changeImmediately) {
            if (this.changeTimeout) clearTimeout(this.changeTimeout);
            this.changeTimeout = setTimeout(()=>{
                this._executeOnChange(value);
            }, 500);
        } else this._executeOnChange(value);
        if (fromUser) this.logStat("CHANGE {" + value + "}");
    }
    _getLabelFormatter() {
        return this.labelFormatter ? this.labelFormatter : function(value) {
            return Number(value.toFixed(0)) + '';
        };
    }
    formatSelectedValue(value) {
        return this._getLabelFormatter()(value);
    }
    _executeOnChange(newValue) {
        this.value = newValue;
        $dc57b31f1b066f38$exports('div.value', this.getUIElement()).empty().html(this.formatSelectedValue(this.value));
        this.onChangeCallbacks.forEach((c)=>c(this));
        this._checkEnabledNextPrevious();
        this._updateLegend();
    }
    /**
     * Go to the next tick value
     */ next(fromUser = true) {
        this.changeImmediately = true;
        const rangeInput = $dc57b31f1b066f38$exports('input[type=range]', this.uiElement);
        if (this.value < this.max) {
            rangeInput.val(this.markedValues[this._getGreaterMarkedValueIndexFor(this.value)]);
            this._onChangeSlider(fromUser);
        } else if (this.parentSlider && this.parentSlider.hasNext()) {
            const val = this.getMinForParentValue.call(this, this.parentSlider._getNextValue());
            rangeInput.attr('min', val);
            rangeInput.val(val);
            this._onChangeSlider(false);
            this.parentSlider.next();
        }
        this.changeImmediately = !this.delayChange;
    }
    _getNextValue() {
        if (this.value < this.max) return this.markedValues[this._getGreaterMarkedValueIndexFor(this.value)];
        else if (this.parentSlider && this.parentSlider.hasNext()) return this.getMinForParentValue.call(this, this.parentSlider._getNextValue());
    }
    /**
     * Go to the previous tick value
     */ previous(fromUser = true) {
        this.changeImmediately = true;
        const rangeInput = $dc57b31f1b066f38$exports('input[type=range]', this.uiElement);
        if (this.value > this.min) {
            rangeInput.val(this.markedValues[this._getLesserMarkedValueIndexFor(this.value)]);
            this._onChangeSlider(fromUser);
        } else if (this.parentSlider && this.parentSlider.hasPrevious()) {
            this.value = this.getMaxForParentValue.call(this, this.parentSlider._getPreviousValue());
            this.max = this.value;
            rangeInput.attr('max', this.value).attr('value', this.value).val(this.value);
            this.parentSlider.previous();
            this._onChangeSlider(false);
        }
        this.changeImmediately = !this.delayChange;
    }
    _getPreviousValue() {
        if (this.value > this.min) return this.markedValues[this._getLesserMarkedValueIndexFor(this.value)];
        else if (this.parentSlider && this.parentSlider.hasPrevious()) return this.getMaxForParentValue.call(this, this.parentSlider._getPreviousValue());
    }
    _checkEnabledNextPrevious() {
        if (!this.hasNext()) $dc57b31f1b066f38$exports('.next-value button', this.uiElement).attr('disabled', 'disabled').addClass('disabled');
        else $dc57b31f1b066f38$exports('.next-value button', this.uiElement).removeAttr('disabled').removeClass('disabled');
        if (!this.hasPrevious()) $dc57b31f1b066f38$exports('.previous-value button', this.uiElement).attr('disabled', 'disabled').addClass('disabled');
        else $dc57b31f1b066f38$exports('.previous-value button', this.uiElement).removeAttr('disabled').removeClass('disabled');
    }
    _updateLegend() {
        if (this.legendFormatter !== undefined) $dc57b31f1b066f38$exports('.slider-legend', this.getUIElement()).empty().append(this.legendFormatter(this.getValue()));
    }
    /**
     * Add callback to execute on change
     * @param callback {function} A callback that takes this slider
     */ onChange(callback) {
        if (callback) this.onChangeCallbacks.add(callback);
        return this;
    }
    _getGreaterMarkedValueIndexFor(value) {
        for(let i = 0; i < this.markedValues.length; i++){
            if (this.markedValues[i] > value) return i;
        }
        return 0;
    }
    _getLesserMarkedValueIndexFor(value) {
        for(let i = this.markedValues.length - 1; i >= 0; i--){
            if (this.markedValues[i] < value) return i;
        }
        return this.markedValues.length - 1;
    }
    /**
     * Does this slider have a previous value?
     * @return {boolean}
     */ hasPrevious() {
        if (this.value > this.min) return true;
        if (this.parentSlider) return this.parentSlider.hasPrevious();
    }
    /**
     * Does this slider have a next value?
     * @return {boolean}
     */ hasNext() {
        if (this.value < this.max) return true;
        if (this.parentSlider) return this.parentSlider.hasNext();
    }
    getCode() {
        return this.id;
    }
    /**
     * This slider's current value
     * @return {number}
     */ getValue() {
        return this.value;
    }
    /**
     * Set this slider's value
     * @param value {number} The value
     */ setValue(value) {
        const rangeInput = $dc57b31f1b066f38$exports('input[type=range]', this.uiElement);
        rangeInput.val(value);
        this._onChangeSlider(false);
    }
}






/**
 * A dropdown element implemented with a select HTML element
 * @extends UIElement
 */ class $d0c219b43b862888$export$931cbfb6bfb85fc extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    getClassName() {
        return "Dropdown";
    }
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Dropdown id
     * @param dropDownOptions {Array<DropdownOption>} A list of options for this dropdown
     * @param initialValue {string} The initial value for this dropdown
     * @param mandatory {boolean} Is this dropdown mandatory?
     * @param emptyLabelKey {string} if not mandatory, this will be the label of the empty option
     * @param onChange {function} A callback to be called when the value changes
     * @param parentDropdown {Dropdown} If not undefined, only the options with the parentValue corresponding matching the current parentDropdown value will be available for the user to choose
     */ constructor(translator, isMobileDevice, id, dropDownOptions, initialValue, mandatory, emptyLabelKey, onChange, parentDropdown){
        super(id, translator, isMobileDevice, undefined, undefined);
        this.id = id;
        this.value = initialValue;
        this.dropDownOptions = dropDownOptions.slice();
        this.mandatory = mandatory;
        this.emptyLabelKey = emptyLabelKey;
        this.emptyValue = translator.translate(emptyLabelKey);
        this.parentDropdown = parentDropdown;
        if (this.parentDropdown) this.parentValue = this.parentDropdown.getValue();
        this.onChangeCallbacks = new Set();
        this.onChange(onChange);
        if (this.parentDropdown) this.parentDropdown.onChange((parent)=>{
            if (parent.getValue() !== this.parentValue) {
                this.parentValue = parent.getValue();
                this._setOptions(true);
            }
        });
    }
    disableUI() {
        if (this.uiElement) $dc57b31f1b066f38$exports('select', this.uiElement).addClass('disabled').attr('disabled', 'disabled');
    }
    enableUI() {
        if (this.uiElement) $dc57b31f1b066f38$exports('select', this.uiElement).removeClass('disabled').removeAttr('disabled');
    }
    getCode() {
        return this.id;
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div id="' + this.id + '" class="dropdown-input">' + '   <select id="' + this.id + '_select"></select><span></span>' + '</div>');
            this._setOptions();
            let self = this;
            $dc57b31f1b066f38$exports('select', this.uiElement).change(function() {
                self._setValue($dc57b31f1b066f38$exports(this).val(), true);
                self.logStat("CHANGE {" + $dc57b31f1b066f38$exports(this).val() + "}");
            });
            $dc57b31f1b066f38$exports('span', this.uiElement).click(function() {
                $dc57b31f1b066f38$exports('select', self.uiElement).show();
            });
        }
        return this.uiElement;
    }
    _setOptions(triggerOnChange = false) {
        const options = [];
        for(let o in this.dropDownOptions)if (!this.parentDropdown || !this.dropDownOptions[o]._getParentValue() || this.dropDownOptions[o]._getParentValue() === this.parentValue) options.push(this.dropDownOptions[o]);
        if (options.length === 0) this.disableUI();
        else this.enableUI();
        const selectedOption = options.filter((o)=>o.getValue() === this.value)[0];
        if (!this.mandatory) {
            const emptyOption = new $d0c219b43b862888$export$4f8de5f5e34dc41e(this.translator, this.isMobileDevice, this.emptyLabelKey, undefined);
            options.unshift(emptyOption);
            if (!selectedOption) {
                emptyOption._select();
                if (triggerOnChange) this._setValue(undefined, triggerOnChange);
            }
        }
        const select = $dc57b31f1b066f38$exports('select', this.uiElement).empty();
        options.map((o)=>o.getUIElement()).forEach((oElem)=>select.append(oElem));
        if (selectedOption) this._setValue(this.value, triggerOnChange);
        else if (this.mandatory && options.length > 0) this._setValue(options[0].getValue(), triggerOnChange);
    }
    /**
     * Get this dropdown options array
     * @return {Array<DropdownOption>}
     */ getOptions() {
        return this.dropDownOptions;
    }
    onChange(callback) {
        if (callback) this.onChangeCallbacks.add(callback);
        return this;
    }
    /**
     * Get this dropdown current value
     * @return {string}
     */ getValue() {
        return this.value;
    }
    /**
     * Set the value for this drop down
     * @param value {string}
     */ setValue(value) {
        this._setValue(value, true);
    }
    _setValue(value, triggerOnChange = false) {
        const select = $dc57b31f1b066f38$exports('select', this.uiElement);
        if (value === undefined || value === this.emptyValue) {
            if (this.mandatory) {
                const firstOption = this.dropDownOptions.filter((o)=>o._getParentValue() === undefined && this.parentValue === undefined || o._getParentValue() === this.parentValue)[0];
                if (firstOption) {
                    this.value = firstOption.getValue();
                    select.val(firstOption.getValue());
                }
            } else {
                select[0].selectedIndex = 0;
                this.value = undefined;
            }
        } else {
            const option = this.dropDownOptions.filter((o)=>(!this.parentValue || o._getParentValue() === this.parentValue) && o.getValue() === value)[0];
            if (option) {
                this.value = option.getValue();
                option._select();
            }
        }
        if (triggerOnChange) this.onChangeCallbacks.forEach((c)=>c(this));
    }
}
/**
 * A dropdown option
 * @extends UIElement
 */ class $d0c219b43b862888$export$4f8de5f5e34dc41e extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    getClassName() {
        return "DropdownOption";
    }
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param labelKey {string} A localization key for this option's label
     * @param value {string} The value
     * @param parentValue The parent value. If undefined, the option will show independently of the parent
     */ constructor(translator, isMobileDevice, labelKey, value, parentValue){
        super(labelKey, translator, isMobileDevice, undefined, undefined);
        this.translator = translator;
        this.labelKey = labelKey;
        this.value = value;
        this.parentValue = parentValue;
    }
    /**
     * update this option label
     * @param labelKey {string}
     */ setLabelKey(labelKey) {
        this.labelKey = labelKey;
        this.getUIElement().html(this.translator.translate(this.labelKey));
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<option>' + this.translator.translate(this.labelKey) + '</option>');
            if (this.value) this.uiElement.attr('value', this.value);
        }
        return this.uiElement;
    }
    _select() {
        $dc57b31f1b066f38$exports('option', $dc57b31f1b066f38$exports(this.getUIElement().parents('select')[0])).removeAttr('selected');
        this.getUIElement().attr('selected', '');
        $dc57b31f1b066f38$exports(this.getUIElement().parents('select')[0]).val(this.value);
    }
    _isSelected() {
        return !!this.getUIElement().attr('selected');
    }
    /**
     * This option's value
     * @return {string}
     */ getValue() {
        return this.value;
    }
    _getParentValue() {
        return this.parentValue;
    }
    disable() {
        this.getUIElement().attr('disabled', 'disabled');
    }
    enable() {
        this.getUIElement().removeAttr('disabled');
    }
}






/**
 * Draw horizontal lines in a drawing context
 * @param drawingContext {CanvasRenderingContext2D} where to draw to
 * @param color {string} CSS color for the lines
 * @param thickness {number} Thickness in pixels
 * @param width {number} Width in pixels of the drawing (integer)
 * @param height {number} Height in pixels of the drawing (integer)
 * @param lineCount {number} How many lines to draw (integer)
 */ function $af01f743644ebf1c$export$af293fdb3352a881(drawingContext, color, thickness, width, height, lineCount) {
    const space = height / lineCount;
    function drawHorizontalLine(iter) {
        drawingContext.beginPath();
        drawingContext.strokeStyle = color;
        drawingContext.lineWidth = thickness;
        drawingContext.lineCap = 'round';
        drawingContext.moveTo(0, (iter + thickness / 2) * space);
        drawingContext.lineTo(width, (iter + thickness / 2) * space);
        drawingContext.stroke();
    }
    for(let i = 0; i < lineCount; i++)drawHorizontalLine(i);
}
/**
 * Draw vertical lines in a drawing context
 * @param drawingContext {CanvasRenderingContext2D} where to draw to
 * @param color {string} CSS color for the lines
 * @param thickness {number} Thickness in pixels
 * @param width {number} Width in pixels of the drawing (integer)
 * @param height {number} Height in pixels of the drawing (integer)
 * @param lineCount {number} How many lines to draw (integer)
 */ function $af01f743644ebf1c$export$b1b6535abd1fa66a(drawingContext, color, thickness, width, height, lineCount) {
    const space = width / lineCount;
    function drawVerticalLine(iter) {
        drawingContext.beginPath();
        drawingContext.strokeStyle = color;
        drawingContext.lineWidth = thickness;
        drawingContext.lineCap = 'round';
        drawingContext.moveTo((iter + thickness / 2) * space, 0);
        drawingContext.lineTo((iter + thickness / 2) * space, height);
        drawingContext.stroke();
    }
    for(let i = 0; i < lineCount; i++)drawVerticalLine(i);
}
/**
 * Draw horizontal lines in a drawing context
 * @param drawingContext {CanvasRenderingContext2D} where to draw to
 * @param color {string} CSS color for the lines
 * @param thickness {number} Thickness in pixels
 * @param width {number} Width in pixels of the drawing (integer)
 * @param height {number} Height in pixels of the drawing (integer)
 * @param lineCount {number} How many lines to draw (integer)
 * @param anti {boolean} if true draws anti-diagonal lines
 */ function $af01f743644ebf1c$export$dc133b72d0ece32e(drawingContext, color, thickness, width, height, lineCount, anti) {
    const incX = width / (lineCount / 2 * thickness) * 2;
    const incY = height / (lineCount / 2 * thickness) * 2;
    function drawDiagonalLine(iter) {
        drawingContext.beginPath();
        drawingContext.strokeStyle = color;
        drawingContext.lineWidth = thickness;
        drawingContext.lineCap = 'round';
        drawingContext.moveTo(0, iter * incY);
        drawingContext.lineTo(width - iter * incX, height);
        drawingContext.stroke();
        if (iter > 0) {
            drawingContext.beginPath();
            drawingContext.strokeStyle = color;
            drawingContext.lineWidth = thickness;
            drawingContext.lineCap = 'round';
            drawingContext.moveTo(iter * incX, 0);
            drawingContext.lineTo(width, height - iter * incY);
            drawingContext.stroke();
        }
    }
    function drawAntiDiagonalLine(iter) {
        drawingContext.beginPath();
        drawingContext.strokeStyle = color;
        drawingContext.lineWidth = thickness;
        drawingContext.lineCap = 'round';
        drawingContext.moveTo(width, iter * incY);
        drawingContext.lineTo(iter * incX, height);
        drawingContext.stroke();
        if (iter > 0) {
            drawingContext.beginPath();
            drawingContext.strokeStyle = color;
            drawingContext.lineWidth = thickness;
            drawingContext.lineCap = 'round';
            drawingContext.moveTo(width - iter * incX, 0);
            drawingContext.lineTo(0, height - iter * incY);
            drawingContext.stroke();
        }
    }
    for(let i = 0; i < lineCount / 2; i++)if (anti) drawAntiDiagonalLine(i);
    else drawDiagonalLine(i);
}
/**
 * Draw dots in a drawing context
 * @param drawingContext {CanvasRenderingContext2D} where to draw to
 * @param color {string} CSS color for the dots
 * @param width {number} Width in pixels of the drawing (integer)
 * @param height {number} Height in pixels of the drawing (integer)
 * @param numRows {number} how many rows of dots (integer)
 * @param numCols {number} how many columns of dots (integer)
 * @param diameter {number} Dots diameter in pixels
 */ function $af01f743644ebf1c$export$6c43b2af4695d113(drawingContext, color, width, height, numRows, numCols, diameter) {
    const marginX = width / (numCols * diameter);
    const marginY = height / (numRows * diameter);
    for(let i = 0; i < numRows; i++)for(let j = 0; j < numCols; j++){
        let x = j * (diameter + marginX) + marginX / 2 + diameter / 2;
        let y = i * (diameter + marginY) + marginY / 2 + diameter / 2;
        drawDot(x, y, diameter / 2);
    }
    function drawDot(x, y, radius) {
        drawingContext.beginPath();
        drawingContext.arc(x, y, radius, 0, 2 * Math.PI, false);
        drawingContext.fillStyle = color;
        drawingContext.fill();
    }
}






/**
 * Is there low contrast between white and the given color?
 * @param color {string} A CSS color
 * @return {boolean} true if there is low contrast between white and the given color
 */ function $9d480b6dede89078$export$1b0fd8199ce5537b(color) {
    return $9d480b6dede89078$export$6614a8ed72cd7abf(color, 'white');
}
/**
 * Is there low contrast between the given colors?
 * @param color1 {string} A CSS color
 * @param color2 {string} A CSS color
 * @return {boolean} true if there is low contrast between the colors
 */ function $9d480b6dede89078$export$6614a8ed72cd7abf(color1, color2) {
    const parsedColor1 = (0, (/*@__PURE__*/$parcel$interopDefault($5f14bb65263850e1$exports)))(color1);
    const parsedColor2 = (0, (/*@__PURE__*/$parcel$interopDefault($5f14bb65263850e1$exports)))(color2);
    return $9d480b6dede89078$var$contrast(parsedColor1.values, parsedColor2.values) < 1.2;
}
//code "inspired" on https://github.com/LeaVerou/contrast-ratio/blob/d402291022c882c9ae5547b755afa9976460374c/color.js
//also this is important: https://stackoverflow.com/a/9733420
function $9d480b6dede89078$var$luminance(r, g, b) {
    const a = [
        r,
        g,
        b
    ].map(function(v) {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });
    return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}
function $9d480b6dede89078$var$contrast(rgb1, rgb2) {
    const lum1 = $9d480b6dede89078$var$luminance(rgb1[0], rgb1[1], rgb1[2]);
    const lum2 = $9d480b6dede89078$var$luminance(rgb2[0], rgb2[1], rgb2[2]);
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    const opacity1 = rgb1.length === 4 ? rgb1[3] : 255;
    const opacity2 = rgb2.length === 4 ? rgb2[3] : 255;
    return (brightest + 0.05) / (darkest + 0.05) * (opacity1 / 255) * (opacity2 / 255);
}



var $fca5527918e25f58$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $fca5527918e25f58$exports = factory();
})($fca5527918e25f58$exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});




class $b3069bed9c6337dc$export$3b0d6d7590275603 extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param id {string} loader id
     * @param isMobile {boolean} true if this is a mobile device. false otherwise
     * @param target {jQuery} The target element to append the loader to
     */ constructor(id, isMobile, target){
        super(id, undefined, isMobile, undefined, undefined);
        this.target = target;
        this.visible = false;
        if (target) this.getUIElement();
    }
    getClassName() {
        return "Loader";
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $('<div class="loader-container"><div class="loader"></div></div>');
            if (this.target) {
                this.target.append(this.uiElement);
                this.target.css('position', 'relative');
            }
        }
        return this.uiElement;
    }
    _innerShow() {
        this.uiElement.show();
        this.visible = true;
        this.spin();
    }
    _innerHide() {
        this.uiElement.hide();
        this.visible = false;
    }
    spin() {
        $('.loader', this.uiElement).addClass('spin');
    }
    stopSpin() {
        $('.loader', this.uiElement).removeClass('spin');
    }
    show(immediately) {
        if (!this.visible) {
            if (immediately) this._innerShow();
            else {
                if (this.timeoutId) return;
                this.timeoutId = setTimeout(()=>{
                    this._innerShow();
                    this.timeoutId = undefined;
                }, 500);
            }
        }
    }
    hide() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
            this._innerHide();
        } else if (this.visible) this._innerHide();
    }
}
class $b3069bed9c6337dc$export$c4254dbe42609785 extends $b3069bed9c6337dc$export$3b0d6d7590275603 {
    getClassName() {
        return "SmallLoader";
    }
    getUIElement() {
        return super.getUIElement().addClass('small');
    }
}
class $b3069bed9c6337dc$export$b98749e850e7c7d2 extends $b3069bed9c6337dc$export$3b0d6d7590275603 {
    getClassName() {
        return "ResponsiveWidthLoader";
    }
    getUIElement() {
        return super.getUIElement().addClass('responsive responsive-width');
    }
    _innerShow() {
        this.stopSpin();
        this.setWidth();
        super._innerShow();
        this.stopSpin();
        this.setWidth();
        this.spin();
    }
    setWidth() {
        const h = this.uiElement.height();
        $('.loader', this.uiElement).css('width', h + 'px');
    }
}
class $b3069bed9c6337dc$export$521cd377ef3ef826 extends $b3069bed9c6337dc$export$3b0d6d7590275603 {
    getClassName() {
        return "ResponsiveHeightLoader";
    }
    getUIElement() {
        return super.getUIElement().addClass('responsive responsive-height');
    }
    _innerShow() {
        this.stopSpin();
        this.setHeight();
        super._innerShow();
        this.stopSpin();
        this.setHeight();
        this.spin();
    }
    setHeight() {
        const w = this.uiElement.width();
        $('.loader', this.uiElement).css('height', w + 'px');
    }
}



/**
 * A layer legend
 * @extends Base
 */ class $594237181175c857$export$ed247974535929c7 extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param stylesConfig {Object} The styles configs for the layer
     */ constructor(isMobileDevice, translator, stylesConfig){
        super();
        this.isMobileDevice = isMobileDevice;
        this.translator = translator;
        this.stylesConfig = stylesConfig;
        this.onNavigationCallbacks = [];
        // let's create all the elements before the first invocation of onNavigation
        this.getSmallGraphic();
        this.getLargeGraphic();
    }
    getClassName() {
        return "Legend";
    }
    getDescription() {
        const legendConfig = this.stylesConfig[0].getLegend();
        return legendConfig ? legendConfig.getLegendDescription() : undefined;
    }
    _getGraphic(graphic, small, labelsPosition, removeNoData, forcePolygon) {
        graphic.empty();
        for(let s in this.stylesConfig){
            const styleConfig = this.stylesConfig[s];
            const rules = this.stylesConfig[s].getRules();
            const geometryType = forcePolygon ? (0, $815c91046e476159$export$427161d533086393).POLYGON : styleConfig.getGeometryType();
            const hasContinuous = rules.filter(function(r) {
                return r.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).CONTINUOUS;
            }).length > 0;
            const discreteCount = rules.filter(function(r) {
                return r.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).DISCRETE;
            }).length;
            const hasDiscrete = discreteCount > 0;
            const barElements = hasDiscrete || hasContinuous ? [] : undefined;
            const barContainer = $dc57b31f1b066f38$exports('<div class="bar-elements"></div>');
            if (barElements) {
                graphic.append(barContainer);
                if (hasDiscrete) barContainer.addClass('has-discrete');
                if (hasContinuous) barContainer.addClass('has-continuous');
            }
            let labelsPositionForStyle = labelsPosition ? labelsPosition : styleConfig.getLegend() ? styleConfig.getLegend().getLabelsPosition() : undefined;
            for(let r in rules){
                const rule = rules[r];
                const styleRuleType = rule.getStyleRuleType();
                if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CONTINUOUS) barElements.push(this._getContinuousElement(small, rule, geometryType, labelsPositionForStyle, hasDiscrete, Number(r) === 0));
                else if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).DISCRETE) {
                    const sizePerc = !hasContinuous ? 100 : discreteCount === 2 ? 25 : 50;
                    barElements.push(this._getDiscreteElement(small, rule, geometryType, labelsPositionForStyle, sizePerc, Number(r) === 0));
                } else if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CLASSIFIED) {
                    const classifiedElement = this._getClassifiedElement(small, rule, geometryType, labelsPositionForStyle, styleConfig.getLegend() ? styleConfig.getLegend().getLegendOrientation() : undefined);
                    graphic.append($dc57b31f1b066f38$exports('<div class="classified-element"></div>').append(classifiedElement));
                } else if (!removeNoData && styleRuleType === (0, $815c91046e476159$export$23989178094d68d).NODATA) {
                    let noDataElement = this._getNoDataElement(small, rule, geometryType);
                    graphic.append($dc57b31f1b066f38$exports('<div class="nodata-element"></div>').append(noDataElement));
                } else if (!removeNoData && styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CLUSTER) {
                    let clusterElement = this._getClusterElement(small, rule, geometryType);
                    graphic.append($dc57b31f1b066f38$exports('<div class="cluster-element"></div>').append(clusterElement));
                } else if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).SIMPLE) {
                    const simpleElement = this._getSimpleElement(small, rule, geometryType);
                    graphic.append($dc57b31f1b066f38$exports('<div class="simple-element"></div>').append(simpleElement));
                } else if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).EXTERNAL_IMAGE) {
                    const externalImageElement = this._getExternalImageElement(small, rule);
                    graphic.append($dc57b31f1b066f38$exports('<div class="external-image-element"></div>').append(externalImageElement));
                } else if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).EXTERNAL_DYNAMIC_IMAGE) {
                    const externalDynamicImageElement = this._getExternalDynamicImageElement(small, rule);
                    graphic.append($dc57b31f1b066f38$exports('<div class="external-image-element external-dynamic-image-element"></div>').append(externalDynamicImageElement));
                }
            }
            if (barElements && barElements.length > 0) {
                for(const be in barElements){
                    if (barElements[be].hasClass('top-label')) barContainer.addClass('top-label');
                    if (barElements[be].hasClass('bottom-label')) barContainer.addClass('bottom-label');
                    if (barElements[be].hasClass('has-groups')) barContainer.addClass('has-groups');
                    if (barElements[be].hasClass('has-rule-label')) barContainer.addClass('has-rule-label');
                    barContainer.append(barElements[be]);
                }
                if (barElements.length === 1 && geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) barElements[0].css('display', 'flex');
                barElements[0].addClass('first-bar-element');
                (0, $2536f84a954bf107$export$ce275da88d3dcc54)(barElements).addClass('last-bar-element');
            }
        }
    }
    /**
     * Get a small graphic of the legend (possibly simplified)
     * @return {jQuery}
     */ getSmallGraphic(exportButton) {
        if (!this.smallGraphic) this.smallGraphic = $dc57b31f1b066f38$exports('<div class="layer-legend-graphic-small"></div>');
        this._getGraphic(this.smallGraphic, true, undefined, false, false);
        this._handleExportButton(exportButton, this.smallGraphic);
        this._runOnNavigationCallbacks();
        return this.smallGraphic;
    }
    getChartGraphic(exportButton) {
        if (!this.chartGraphic) this.chartGraphic = $dc57b31f1b066f38$exports('<div class="layer-legend-graphic-small"></div>');
        this._getGraphic(this.chartGraphic, true, undefined, true, true);
        this._handleExportButton(exportButton, this.chartGraphic);
        return this.chartGraphic;
    }
    /**
     * Get the full legend graphic
     * @return {jQuery}
     */ getLargeGraphic(exportButton) {
        if (!this.largeGraphic) this.largeGraphic = $dc57b31f1b066f38$exports('<div class="layer-legend-graphic-large"></div>');
        this._getGraphic(this.largeGraphic, false, !this.isMobileDevice ? (0, $815c91046e476159$export$b0626c1c2473a01e).BOTTOM : undefined, false, false);
        this._handleExportButton(exportButton, this.largeGraphic, true);
        this._runOnNavigationCallbacks();
        return this.largeGraphic;
    }
    _handleExportButton(exportButton, graphic, large = false) {
        if (exportButton) exportButton.click(()=>{
            const loader = new (0, $b3069bed9c6337dc$export$3b0d6d7590275603)('export_legend_loader', this.isMobileDevice, $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('body .tumbo')[0]));
            loader.show();
            const element = $dc57b31f1b066f38$exports('<div></div>').addClass('indicator-legend').css('position', 'fixed').css('bottom', '-1000px').css('background', 'transparent').append(graphic.clone());
            $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('body .tumbo')[0]).append(element);
            if (!large) element.height(graphic.height() + 50).width(graphic.width() + 15).css('padding-top', '25px');
            else element.css('height', 'fit-content').css('width', 'fit-content').css('min-width', '600px').css('padding', '5px');
            (0, (/*@__PURE__*/$parcel$interopDefault($fca5527918e25f58$exports)))(element[0], {
                useCORS: true,
                allowTaint: true,
                backgroundColor: null,
                scale: 4,
                dpi: 500
            }).then((canvas)=>{
                try {
                    element.remove();
                    const link = document.createElement('a');
                    link.download = 'legend.png';
                    link.href = canvas.toDataURL('image/png');
                    link.click();
                } catch (e) {
                    this.logError("Error downloading legend image", e);
                    loader.hide();
                    alert(e);
                } finally{
                    loader.hide();
                }
            }, (error)=>{
                element.remove();
                this.logError("Error rendering image of legend", error);
                loader.hide();
                alert(error);
            });
        });
    }
    _isTopLabel(labelsPositionForStyle, vertical, small, ruleEntries, index) {
        let isTopLabel = false;
        if (!labelsPositionForStyle || small && ruleEntries.length > 8) isTopLabel = vertical ? false : ruleEntries.length > 3 && index % 2 !== 0;
        else if (labelsPositionForStyle === (0, $815c91046e476159$export$b0626c1c2473a01e).TOP) isTopLabel = true;
        else if (labelsPositionForStyle === (0, $815c91046e476159$export$b0626c1c2473a01e).BOTTOM) isTopLabel = false;
        else if (labelsPositionForStyle === (0, $815c91046e476159$export$b0626c1c2473a01e).ALTERNATE) isTopLabel = ruleEntries.length > 3 && index % 2 !== 0;
        return isTopLabel;
    }
    _getClassifiedElement(small, rule, geometryType, labelsPositionForStyle, legendOrientation) {
        const classes = rule.getClasses();
        const elementContainer = $dc57b31f1b066f38$exports('<div class="graphic-element-container"></div>');
        const element = $dc57b31f1b066f38$exports('<div class="legend-classified-element graphic-element"></div>');
        const vertical = legendOrientation === (0, $815c91046e476159$export$ab3075f671a20a10).VERTICAL || !small;
        if (vertical) element.addClass('vertical');
        const handleLabel = (clazz, index, clazzElement)=>{
            if (clazz.getLabel()) {
                const cropSize = vertical ? small ? 40 : 80 : !small ? classes.length > 10 ? 10 : 15 : classes.length > 8 ? 7 : classes.length > 5 ? 10 : 17;
                const label = $dc57b31f1b066f38$exports('<label>' + clazz.getLabel().crop(cropSize) + '</label>');
                const isTopLabel = this._isTopLabel(labelsPositionForStyle, vertical, small, classes, index);
                label.addClass(isTopLabel ? 'top' : 'bottom');
                label.attr('title', clazz.getGroupLabel() ? clazz.getGroupLabel() : clazz.getLabel());
                clazzElement.append(label);
                clazzElement.addClass(isTopLabel ? 'top-label' : 'bottom-label');
            }
            clazzElement.attr('title', clazz.getGroupLabel() ? clazz.getGroupLabel() : clazz.getLabel());
        };
        const createNonLinearElement = (clazz, index, fillPattern, linePattern, geometryType)=>{
            const clazzElement = $dc57b31f1b066f38$exports('<div class="clazz-element"></div>');
            if (fillPattern) {
                const GRAPHIC_WIDTH = small ? geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 50 : 15 : geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 50 : 25;
                const GRAPHIC_HEIGHT = small ? geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 20 : 15 : geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 30 : 25;
                const color = clazz.getBorderColor() ? clazz.getBorderColor() : fillPattern.getColor() ? fillPattern.getColor() : 'black';
                const width = fillPattern.getWidth() ? fillPattern.getWidth() : 1;
                this._drawFillElement(clazzElement, GRAPHIC_WIDTH - 2, GRAPHIC_HEIGHT - 2, color, width, fillPattern.getFillPatternType(), rule.getCode(), small, geometryType);
                if (clazz.getBorderWidth()) clazzElement.css('border', clazz.getBorderWidth() + 'px solid ' + color);
                clazzElement.css('width', GRAPHIC_WIDTH + 'px');
            } else {
                if (clazz.getBorderWidth()) {
                    const borderColor = clazz.getBorderColor() ? clazz.getBorderColor() : 'black';
                    clazzElement.css('border', clazz.getBorderWidth() + 'px solid ' + borderColor);
                } else if ((0, $9d480b6dede89078$export$1b0fd8199ce5537b)(clazz.getBackgroundColor())) clazzElement.css('border', '1px solid rgba(178, 178, 178, .35)');
                if (linePattern) {
                    if (linePattern.getLinePatternType() === (0, $815c91046e476159$export$6b4efad1d1b9c97e).DOTTED) clazzElement.css('border-style', 'dotted');
                    else if (linePattern.getLinePatternType() === (0, $815c91046e476159$export$6b4efad1d1b9c97e).DASHED) clazzElement.css('border-style', 'dashed');
                    if (linePattern.getWidth()) clazzElement.css('border-width', linePattern.getWidth() + 'px');
                    if (linePattern.getColor()) clazzElement.css('border-color', linePattern.getColor());
                }
                clazzElement.css('background-color', clazz.getBackgroundColor());
                if (vertical) clazzElement.css('width', '50px');
                else clazzElement.css('width', 'calc(' + 100.0 / classes.length + '% - 3px)');
                if (index > 0 && !vertical) clazzElement.css('margin-left', 3 * classes.length / (classes.length - 1) + 'px');
                if (geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) {
                    const radius = small ? 15 : 25;
                    clazzElement.css('width', radius + 'px').css('height', radius + 'px').css('border-radius', '50%');
                }
            }
            if (index > 0 && vertical) clazzElement.css('margin-top', '5px');
            handleLabel(clazz, index, clazzElement);
            return clazzElement;
        };
        function createLineElement(clazz, index, linePattern) {}
        if (rule.getLabel()) elementContainer.addClass('has-rule-label').append($dc57b31f1b066f38$exports('<div><label>' + this.translator.translate(rule.getLabel()) + '</label></div>'));
        for(let c in classes){
            const clazz = classes[c];
            const index = Number(c);
            const linePattern = clazz.getLinePattern();
            const fillPattern = clazz.getFillPattern() ? clazz.getFillPattern() : rule.getFillPattern();
            const clazzElement = geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? createNonLinearElement(clazz, index, fillPattern, linePattern, (0, $815c91046e476159$export$427161d533086393).POLYGON) : geometryType === (0, $815c91046e476159$export$427161d533086393).POINT ? createNonLinearElement(clazz, index, fillPattern, null, (0, $815c91046e476159$export$427161d533086393).POINT) : createLineElement(clazz, index, linePattern);
            element.append(clazzElement);
            if (clazzElement.hasClass('top-label')) element.addClass('top-label');
            if (clazzElement.hasClass('bottom-label')) element.addClass('bottom-label');
        }
        element.addClass(geometryType.getCode().toLowerCase());
        elementContainer.append(element);
        if (element.hasClass('top-label')) elementContainer.addClass('top-label');
        if (element.hasClass('bottom-label')) elementContainer.addClass('bottom-label');
        return elementContainer;
    }
    _getContinuousElement(small, rule, geometryType, labelsPositionForStyle, sharesBar, isFirstRule) {
        const ranges = rule.getRanges();
        const elementContainer = !sharesBar ? $dc57b31f1b066f38$exports('<div class="graphic-element-container"></div>') : undefined;
        const element = $dc57b31f1b066f38$exports('<div class="legend-continuous-element graphic-element"></div>');
        element.css('width', sharesBar ? '50%' : '100%');
        if (geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) {
            const size = small ? 15 : 25;
            element.css('height', size + 'px');
            if (sharesBar) {
                element.css('width', 'calc(50% - 5px)');
                if (isFirstRule) element.css('margin-right', '5px');
                else element.css('margin-left', '5px');
            }
        }
        if (elementContainer && rule.getLabel()) elementContainer.addClass('has-rule-label').append($dc57b31f1b066f38$exports('<div><label>' + this.translator.translate(rule.getLabel()) + '</label></div>'));
        for(let r in ranges){
            const range = ranges[r];
            const index = Number(r);
            const rangeElement = $dc57b31f1b066f38$exports('<div class="range-element bar-element"></div>');
            if (range.getBorderWidth()) {
                const color = range.getBorderColor() ? range.getBorderColor() : 'black';
                rangeElement.css('border', range.getBorderWidth() + 'px solid ' + color);
            }
            rangeElement.css('background-image', 'linear-gradient(to right, ' + range.getMinBackgroundColor() + ' , ' + range.getMaxBackgroundColor() + ')');
            rangeElement.css('width', 100.0 / ranges.length + '%');
            let pointSize = small ? 15 : 25;
            if (index === 0 && geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) {
                rangeElement.css('border-top-left-radius', pointSize + 'px');
                rangeElement.css('border-bottom-left-radius', pointSize + 'px');
            }
            if (index === ranges.length - 1 && geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) {
                rangeElement.css('border-top-right-radius', pointSize + 'px');
                rangeElement.css('border-bottom-right-radius', pointSize + 'px');
            }
            if (range.getMinLabel()) {
                const minLabel = $dc57b31f1b066f38$exports('<label class="min">' + this.translator.translate(range.getMinLabel()) + '</label>');
                if (index === 0 && geometryType === (0, $815c91046e476159$export$427161d533086393).POINT && sharesBar && !isFirstRule) minLabel.css('margin-left', '5px');
                rangeElement.append(minLabel);
            }
            if (range.getMaxLabel() !== undefined) {
                const maxLabel = $dc57b31f1b066f38$exports('<label class="max">' + this.translator.translate(range.getMaxLabel()) + '</label>');
                if (index === ranges.length - 1 && geometryType === (0, $815c91046e476159$export$427161d533086393).POINT && sharesBar && isFirstRule) maxLabel.css('margin-right', '5px');
                rangeElement.append(maxLabel);
            }
            element.append(rangeElement);
        }
        element.addClass(geometryType.getCode().toLowerCase());
        if (elementContainer) {
            elementContainer.append(element);
            return elementContainer;
        } else return element;
    }
    _getDiscreteElement(small, rule, geometryType, labelsPositionForStyle, sizePerc, isFirstRule) {
        const buckets = rule.getBuckets();
        const elementContainer = $dc57b31f1b066f38$exports('<div class="graphic-element-container"></div>');
        const element = $dc57b31f1b066f38$exports('<div class="legend-discrete-element graphic-element"></div>');
        elementContainer.css('width', sizePerc + '%');
        element.css('width', '100%');
        if (geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) {
            if (sizePerc < 100) {
                element.css('width', 'calc(' + sizePerc + '% - 5px)');
                if (isFirstRule) element.css('margin-right', '5px');
                else element.css('margin-left', '5px');
            }
        }
        let labelCount = 0;
        const handleBucketLabel = (bucket, bucketElement)=>{
            const createLabelElement = (text, cropSize)=>{
                const label = $dc57b31f1b066f38$exports('<label>' + text.crop(cropSize) + '</label>');
                if (!bucket.getGroupLabel()) {
                    label.attr('title', text);
                    bucketElement.attr('title', text);
                } else if (small) {
                    label.attr('title', bucket.getGroupLabel());
                    bucketElement.attr('title', bucket.getGroupLabel());
                }
                const isTopLabel = this._isTopLabel(labelsPositionForStyle, false, small, buckets, labelCount);
                label.addClass(isTopLabel ? 'top' : 'bottom');
                return label;
            };
            if (bucket.getMaxLabel() || bucket.getMinLabel()) {
                if (bucket.getMinLabel()) {
                    const minCropSize = small ? buckets.length >= 5 ? 6 : 14 : buckets.length >= 7 ? 12 : 20;
                    const leftLabel = createLabelElement(bucket.getMinLabel(), minCropSize);
                    leftLabel.addClass('min');
                    bucketElement.append(leftLabel);
                    labelCount++;
                }
                if (bucket.getMaxLabel()) {
                    const maxCropSize = small ? buckets.length >= 5 ? 6 : 14 : buckets.length >= 7 ? 12 : 20;
                    const rightLabel = createLabelElement(bucket.getMaxLabel(), maxCropSize);
                    rightLabel.addClass('max');
                    bucketElement.append(rightLabel);
                    labelCount++;
                }
            } else if (bucket.getLabel() !== undefined) {
                const cropSize = small ? buckets.length >= 5 ? 10 : 17 : buckets.length >= 7 ? 12 : 20;
                const centerLabel = createLabelElement(bucket.getLabel(), cropSize);
                bucketElement.append(centerLabel);
                labelCount++;
            }
        };
        const createPolygonElement = (bucket, index)=>{
            const bucketElement = $dc57b31f1b066f38$exports('<div class="bucket-element bar-element"></div>');
            if (bucket.getBorderWidth()) {
                const color = bucket.getBorderColor() ? bucket.getBorderColor() : 'black';
                bucketElement.css('border', bucket.getBorderWidth() + 'px solid ' + color);
            } else if ((0, $9d480b6dede89078$export$1b0fd8199ce5537b)(bucket.getBackgroundColor())) bucketElement.css('border', '1px solid rgba(178, 178, 178, .35)');
            bucketElement.css('background-color', bucket.getBackgroundColor()).css('width', 100.0 / buckets.length + '%');
            handleBucketLabel(bucket, bucketElement, index);
            return bucketElement;
        };
        const createPointElement = (bucket, index)=>{
            const radius = small ? 15 : 25;
            return createPolygonElement(bucket, index).css('width', radius + 'px').css('height', radius + 'px').css('border-radius', '50%');
        };
        const createLineElement = (bucket, index)=>{
            const bucketElement = $dc57b31f1b066f38$exports('<div class="bucket-element bar-element"><div class="line"></div></div>');
            const color = bucket.getBorderColor() ? bucket.getBorderColor() : 'black';
            if ((0, $9d480b6dede89078$export$1b0fd8199ce5537b)(color)) bucketElement.addClass('gray-background');
            bucketElement.css('width', 100.0 / buckets.length + '%');
            $dc57b31f1b066f38$exports('.line', bucketElement).css('border-top', bucket.getBorderWidth() * 2 + 'px solid ' + color);
            handleBucketLabel(bucket, bucketElement, index);
            return bucketElement;
        };
        if (rule.getLabel()) elementContainer.addClass('has-rule-label').append($dc57b31f1b066f38$exports('<div class="rule-label"><label>' + this.translator.translate(rule.getLabel()) + '</label></div>'));
        if (!small) {
            const groupElements = {};
            let groupLabel = undefined;
            let idOfFirstBucketInGroup = undefined;
            for(let b in buckets){
                const bucket = buckets[b];
                if (groupLabel !== bucket.getGroupLabel()) {
                    groupLabel = bucket.getGroupLabel();
                    idOfFirstBucketInGroup = b;
                }
                if (bucket.getGroupLabel()) {
                    if (groupElements[groupLabel + idOfFirstBucketInGroup] === undefined) groupElements[groupLabel + idOfFirstBucketInGroup] = {
                        count: 1,
                        groupLabel: bucket.getGroupLabel()
                    };
                    else groupElements[groupLabel + idOfFirstBucketInGroup].count++;
                }
            }
            if (Object.keys(groupElements).length > 0) {
                element.addClass('has-groups');
                elementContainer.append($dc57b31f1b066f38$exports('<div class="groups"></div>'));
                elementContainer.addClass('has-groups');
            }
            for(let g in groupElements){
                const groupElement = $dc57b31f1b066f38$exports('<div class="group"><label>' + this.translator.translate(groupElements[g].groupLabel) + '</label></div>');
                groupElement.css('width', groupElements[g].count / buckets.length * 100 + '%');
                $dc57b31f1b066f38$exports('.groups', elementContainer).append(groupElement);
            }
        }
        for(let b in buckets){
            const bucket = buckets[b];
            const index = Number(b);
            const bucketElement = geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? createPolygonElement(bucket, index) : geometryType === (0, $815c91046e476159$export$427161d533086393).POINT ? createPointElement(bucket, index) : createLineElement(bucket, index);
            element.append(bucketElement);
            if (bucketElement.hasClass('top-label')) element.addClass('top-label');
            if (bucketElement.hasClass('bottom-label')) element.addClass('bottom-label');
        }
        element.addClass(geometryType.getCode().toLowerCase());
        if (elementContainer) {
            elementContainer.append(element);
            if (element.hasClass('top-label')) elementContainer.addClass('top-label');
            if (element.hasClass('bottom-label')) elementContainer.addClass('bottom-label');
            if (element.hasClass('has-groups')) elementContainer.addClass('has-groups');
            return elementContainer;
        } else return element;
    }
    _getNoDataElement(small, rule, geometryType) {
        return this._getSimpleStyleElement(small, rule, geometryType, rule.getLabel() ? rule.getLabel() : 'layer.legend.nodata', 'nodata', true);
    }
    _getClusterElement(small, rule, geometryType) {
        return this._getSimpleStyleElement(small, rule, geometryType, rule.getLabel() ? rule.getLabel() : 'layer.legend.cluster', 'cluster');
    }
    _getSimpleElement(small, rule, geometryType) {
        return this._getSimpleStyleElement(small, rule, geometryType, rule.getLabel(), 'simple');
    }
    _getSimpleStyleElement(small, rule, geometryType, label, clazz, isNoData = false) {
        const element = $dc57b31f1b066f38$exports('<div class="legend-' + clazz + '-element graphic-element"></div>');
        const graphicElement = $dc57b31f1b066f38$exports('<div class="' + clazz + '-element-graphic"></div>');
        if (rule.getBorderWidth()) {
            const color = rule.getBorderColor() ? rule.getBorderColor() : 'black';
            graphicElement.css('border', rule.getBorderWidth() + 'px solid ' + color);
            if ((0, $9d480b6dede89078$export$1b0fd8199ce5537b)(color)) element.addClass('gray-background');
        }
        graphicElement.css('background-color', rule.getBackgroundColor());
        if (geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON) {
            graphicElement.css('width', 100.0 / rule.length + '%');
            const linePattern = rule.getLinePattern();
            if (linePattern) {
                if (linePattern.getLinePatternType() === (0, $815c91046e476159$export$6b4efad1d1b9c97e).DOTTED) graphicElement.css('border-style', 'dotted');
                else if (linePattern.getLinePatternType() === (0, $815c91046e476159$export$6b4efad1d1b9c97e).DASHED) graphicElement.css('border-style', 'dashed');
                if (linePattern.getWidth()) graphicElement.css('border-width', linePattern.getWidth() + 'px');
                if (linePattern.getColor()) graphicElement.css('border-color', linePattern.getColor());
            }
        } else if (geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) {
            const radius = small ? 15 : 25;
            graphicElement.css('width', radius + 'px');
            graphicElement.css('height', radius + 'px');
            graphicElement.css('border-radius', '50%');
        } else if (geometryType === (0, $815c91046e476159$export$427161d533086393).LINE) {
            graphicElement.css('width', 100.0 / rule.length + '%');
            graphicElement.css('border-left', '0');
            graphicElement.css('border-right', '0');
            graphicElement.css('border-bottom', '0');
            const linePattern = rule.getLinePattern();
            if (linePattern) {
                if (linePattern.getLinePatternType() === (0, $815c91046e476159$export$6b4efad1d1b9c97e).DOTTED) graphicElement.css('border-top-style', 'dotted');
                else if (linePattern.getLinePatternType() === (0, $815c91046e476159$export$6b4efad1d1b9c97e).DASHED) graphicElement.css('border-top-style', 'dashed');
            }
        }
        const fill = rule.getFillPattern();
        if (fill && (geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON || geometryType === (0, $815c91046e476159$export$427161d533086393).POINT)) {
            const width = small ? geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 50 : 15 : geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 80 : 25;
            const height = small ? geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 20 : 15 : geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 30 : 25;
            const color = fill.getColor() ? fill.getColor() : 'black';
            this._drawFillElement(graphicElement, width, height, color, fill.getWidth(), fill.getFillPatternType(), rule.getCode(), small, geometryType);
        }
        const imageUrl = rule.getImageUrl ? rule.getImageUrl() : undefined;
        if (imageUrl && imageUrl.length > 0 && geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) {
            graphicElement.append($dc57b31f1b066f38$exports('<img alt="point legend image" height="' + (small ? 20 : 30) + '" src="' + rule.getImageUrl() + '"/>'));
            graphicElement.addClass('image');
            graphicElement.css('width', 'unset');
            graphicElement.css('height', small ? '20px' : '30px');
            graphicElement.css('border-radius', '0');
        }
        element.append(graphicElement);
        if (label && label.trim().length > 0) element.append('<label>' + this.translator.translate(label) + '</label>');
        element.addClass(geometryType.getCode().toLowerCase());
        return element;
    }
    _drawFillElement(element, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, color, thickness, fillType, ruleCode, small, geometryType) {
        const canvas = $dc57b31f1b066f38$exports('<canvas id="' + fillType.getCode() + "_fill_" + ruleCode + '" width="' + GRAPHIC_WIDTH + '" height="' + GRAPHIC_HEIGHT + '"></canvas>')[0];
        const context = canvas.getContext("2d");
        switch(fillType){
            case (0, $815c91046e476159$export$a94ab4528edf2788).DIAGONAL_CROSS:
                (0, $af01f743644ebf1c$export$dc133b72d0ece32e)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, GRAPHIC_HEIGHT / 5, true);
                (0, $af01f743644ebf1c$export$dc133b72d0ece32e)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, GRAPHIC_HEIGHT / 5, false);
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).DIAGONAL:
                (0, $af01f743644ebf1c$export$dc133b72d0ece32e)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, GRAPHIC_HEIGHT / 5 + 1, false);
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).ANTI_DIAGONAL:
                (0, $af01f743644ebf1c$export$dc133b72d0ece32e)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, GRAPHIC_HEIGHT / 5 + 1, true);
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).HORIZONTAL:
                (0, $af01f743644ebf1c$export$af293fdb3352a881)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, Math.min(4, Math.ceil(8 / thickness)));
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).VERTICAL:
                (0, $af01f743644ebf1c$export$b1b6535abd1fa66a)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, Math.min(8, Math.ceil(16 / thickness)));
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).CROSS:
                (0, $af01f743644ebf1c$export$af293fdb3352a881)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, Math.min(4, Math.ceil(8 / thickness)));
                (0, $af01f743644ebf1c$export$b1b6535abd1fa66a)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, Math.min(8, Math.ceil(16 / thickness)));
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).DOTTED:
                const NUM_ROWS = small ? geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 5 : 6 : geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 7 : 7;
                const NUM_COLS = small ? geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 13 : 6 : geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON ? 19 : 7;
                (0, $af01f743644ebf1c$export$6c43b2af4695d113)(context, color, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, NUM_ROWS, NUM_COLS, 2);
                break;
            default:
                break;
        }
        element.append($dc57b31f1b066f38$exports(canvas));
    }
    _getExternalImageElement(small, rule) {
        const element = $dc57b31f1b066f38$exports('<div class="legend-external-image-element graphic-element"></div>');
        const graphicElement = $dc57b31f1b066f38$exports('<div class="external-image-element-graphic"></div>');
        graphicElement.append($dc57b31f1b066f38$exports('<img alt="legend image" src="' + rule.getImageUrl() + '"/>'));
        element.append(graphicElement);
        return element;
    }
    _getExternalDynamicImageElement(small, rule) {
        const element = $dc57b31f1b066f38$exports('<div class="legend-external-image-element graphic-element"></div>');
        const graphicElement = $dc57b31f1b066f38$exports('<div class="external-image-element-graphic"></div>').append($dc57b31f1b066f38$exports('<img alt="legend image" src=""/>'));
        element.append(graphicElement);
        this.onNavigationCallbacks.push((ignored1, ignored2, extentWgs84)=>{
            const imageUrl = rule.getImageUrl();
            const extent = extentWgs84 ? extentWgs84 : [
                -180,
                -90,
                180,
                90
            ];
            $dc57b31f1b066f38$exports('img', graphicElement).attr('src', imageUrl.replace('_EXTENT_', extent.join('+')));
        });
        return element;
    }
    /**
     * To be called by AbstractLayer when there is navigation on the map
     * It should not be called more than 1 time every 500ms
     * @param zoomLevel {number} The new zoom level (integer)
     * @param centerWgs84 {Array<number>} The new center coordinates (WGS84)
     * @param extentWgs84 {Array<number>} The new map extent (WGS84)
     */ onNavigation(zoomLevel, centerWgs84, extentWgs84) {
        this.zoomLevel = zoomLevel;
        this.centerWgs84 = centerWgs84;
        this.extentWgs84 = extentWgs84;
        this._runOnNavigationCallbacks();
    }
    _runOnNavigationCallbacks() {
        if (this.zoomLevel !== undefined && this.zoomLevel !== null && this.centerWgs84 && this.extentWgs84) for(let f in this.onNavigationCallbacks)this.onNavigationCallbacks[f](this.zoomLevel, this.centerWgs84, this.extentWgs84);
    }
}



/**
 * @module ol/format/GeoJSON
 */ 





/**
 * @module ol/format/Feature
 */ 

/**
 * @module ol/geom/GeometryCollection
 */ 



/**
 * @classdesc
 * An array of {@link module:ol/geom/Geometry~Geometry} objects.
 *
 * @api
 */ class $6ed77a6d2b45ebec$var$GeometryCollection extends (0, $e9ce7123fdd10994$export$2e2bcd8739ae039) {
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ constructor(geometries){
        super();
        /**
     * @private
     * @type {Array<Geometry>}
     */ this.geometries_ = geometries;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.changeEventsKeys_ = [];
        this.listenGeometriesChange_();
    }
    /**
   * @private
   */ unlistenGeometriesChange_() {
        this.changeEventsKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        this.changeEventsKeys_.length = 0;
    }
    /**
   * @private
   */ listenGeometriesChange_() {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.changeEventsKeys_.push((0, $37a5c0af9052e360$export$63174c828edd6ff8)(geometries[i], (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.changed, this));
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!GeometryCollection} Clone.
   * @api
   * @override
   */ clone() {
        const geometryCollection = new $6ed77a6d2b45ebec$var$GeometryCollection($6ed77a6d2b45ebec$var$cloneGeometries(this.geometries_));
        geometryCollection.applyProperties(this);
        return geometryCollection;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < (0, $7e819822b33b3d32$export$cbe64c389534206f)(this.getExtent(), x, y)) return minSquaredDistance;
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)minSquaredDistance = geometries[i].closestPointXY(x, y, closestPoint, minSquaredDistance);
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].containsXY(x, y)) return true;
        }
        return false;
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        (0, $7e819822b33b3d32$export$3e2152b047719fa1)(extent);
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)(0, $7e819822b33b3d32$export$8b58be045bf06082)(extent, geometries[i].getExtent());
        return extent;
    }
    /**
   * Return the geometries that make up this geometry collection.
   * @return {Array<Geometry>} Geometries.
   * @api
   */ getGeometries() {
        return $6ed77a6d2b45ebec$var$cloneGeometries(this.geometries_);
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArray() {
        return this.geometries_;
    }
    /**
   * @return {Array<Geometry>} Geometries.
   */ getGeometriesArrayRecursive() {
        /** @type {Array<Geometry>} */ let geometriesArray = [];
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)if (geometries[i].getType() === this.getType()) geometriesArray = geometriesArray.concat(/** @type {GeometryCollection} */ geometries[i].getGeometriesArrayRecursive());
        else geometriesArray.push(geometries[i]);
        return geometriesArray;
    }
    /**
   * Create a simplified version of this geometry using the Douglas Peucker algorithm.
   * @param {number} squaredTolerance Squared tolerance.
   * @return {GeometryCollection} Simplified GeometryCollection.
   * @override
   */ getSimplifiedGeometry(squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        if (squaredTolerance < 0 || this.simplifiedGeometryMaxMinSquaredTolerance !== 0 && squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance) return this;
        const simplifiedGeometries = [];
        const geometries = this.geometries_;
        let simplified = false;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            const geometry = geometries[i];
            const simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
            simplifiedGeometries.push(simplifiedGeometry);
            if (simplifiedGeometry !== geometry) simplified = true;
        }
        if (simplified) {
            const simplifiedGeometryCollection = new $6ed77a6d2b45ebec$var$GeometryCollection(simplifiedGeometries);
            return simplifiedGeometryCollection;
        }
        this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
        return this;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'GeometryCollection';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i){
            if (geometries[i].intersectsExtent(extent)) return true;
        }
        return false;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.geometries_.length === 0;
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].rotate(angle, anchor);
        this.changed();
    }
    /**
   * Scale the geometry (with an optional origin).  This modifies the geometry
   * coordinates in place.
   * @abstract
   * @param {number} sx The scaling factor in the x-direction.
   * @param {number} [sy] The scaling factor in the y-direction (defaults to sx).
   * @param {import("../coordinate.js").Coordinate} [anchor] The scale origin (defaults to the center
   *     of the geometry extent).
   * @api
   * @override
   */ scale(sx, sy, anchor) {
        if (!anchor) anchor = (0, $7e819822b33b3d32$export$c91255cadecfe081)(this.getExtent());
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].scale(sx, sy, anchor);
        this.changed();
    }
    /**
   * Set the geometries that make up this geometry collection.
   * @param {Array<Geometry>} geometries Geometries.
   * @api
   */ setGeometries(geometries) {
        this.setGeometriesArray($6ed77a6d2b45ebec$var$cloneGeometries(geometries));
    }
    /**
   * @param {Array<Geometry>} geometries Geometries.
   */ setGeometriesArray(geometries) {
        this.unlistenGeometriesChange_();
        this.geometries_ = geometries;
        this.listenGeometriesChange_();
        this.changed();
    }
    /**
   * Apply a transform function to the coordinates of the geometry.
   * The geometry is modified in place.
   * If you do not want the geometry modified in place, first `clone()` it and
   * then use this function on the clone.
   * @param {import("../proj.js").TransformFunction} transformFn Transform function.
   * Called with a flat array of geometry coordinates.
   * @api
   * @override
   */ applyTransform(transformFn) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].applyTransform(transformFn);
        this.changed();
    }
    /**
   * Translate the geometry.  This modifies the geometry coordinates in place.  If
   * instead you want a new geometry, first `clone()` this geometry.
   * @param {number} deltaX Delta X.
   * @param {number} deltaY Delta Y.
   * @api
   * @override
   */ translate(deltaX, deltaY) {
        const geometries = this.geometries_;
        for(let i = 0, ii = geometries.length; i < ii; ++i)geometries[i].translate(deltaX, deltaY);
        this.changed();
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.unlistenGeometriesChange_();
        super.disposeInternal();
    }
}
/**
 * @param {Array<Geometry>} geometries Geometries.
 * @return {Array<Geometry>} Cloned geometries.
 */ function $6ed77a6d2b45ebec$var$cloneGeometries(geometries) {
    return geometries.map((geometry)=>geometry.clone());
}
var $6ed77a6d2b45ebec$export$2e2bcd8739ae039 = $6ed77a6d2b45ebec$var$GeometryCollection;





/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */ /**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */ /**
 * @typedef {'arraybuffer' | 'json' | 'text' | 'xml'} Type
 */ /**
 * @typedef {Object} SimpleGeometryObject
 * @property {import('../geom/Geometry.js').Type} type Type.
 * @property {Array<number>} flatCoordinates Flat coordinates.
 * @property {Array<number>|Array<Array<number>>} [ends] Ends or endss.
 * @property {import('../geom/Geometry.js').GeometryLayout} [layout] Layout.
 */ /**
 * @typedef {Array<GeometryObject>} GeometryCollectionObject
 */ /**
 * @typedef {SimpleGeometryObject|GeometryCollectionObject} GeometryObject
 */ /**
 * @typedef {Object} FeatureObject
 * @property {string|number} [id] Id.
 * @property {GeometryObject} [geometry] Geometry.
 * @property {Object<string, *>} [properties] Properties.
 */ /***
 * @template {import('../Feature.js').FeatureLike} T
 * @typedef {T extends RenderFeature ? typeof RenderFeature : typeof Feature} FeatureToFeatureClass
 */ /***
 * @template {import("../Feature.js").FeatureClass} T
 * @typedef {T[keyof T] extends RenderFeature ? RenderFeature : Feature} FeatureClassToFeature
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @abstract
 * @api
 */ class $abc939f9f19ad8b0$var$FeatureFormat {
    constructor(){
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.dataProjection = undefined;
        /**
     * @protected
     * @type {import("../proj/Projection.js").default|undefined}
     */ this.defaultFeatureProjection = undefined;
        /**
     * @protected
     * @type {FeatureToFeatureClass<FeatureType>}
     */ this.featureClass = /** @type {FeatureToFeatureClass<FeatureType>} */ (0, $1171fbd986f3130c$export$2e2bcd8739ae039);
        /**
     * A list media types supported by the format in descending order of preference.
     * @type {Array<string>}
     */ this.supportedMediaTypes = null;
    }
    /**
   * Adds the data projection to the read options.
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Options.
   * @return {ReadOptions|undefined} Options.
   * @protected
   */ getReadOptions(source, options) {
        if (options) {
            let dataProjection = options.dataProjection ? (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.dataProjection) : this.readProjection(source);
            if (options.extent && dataProjection && dataProjection.getUnits() === 'tile-pixels') {
                dataProjection = (0, $92f1443438429e81$export$3988ae62b71be9a3)(dataProjection);
                dataProjection.setWorldExtent(options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: options.featureProjection
            };
        }
        return this.adaptOptions(options);
    }
    /**
   * Sets the `dataProjection` on the options, if no `dataProjection`
   * is set.
   * @param {WriteOptions|ReadOptions|undefined} options
   *     Options.
   * @protected
   * @return {WriteOptions|ReadOptions|undefined}
   *     Updated options.
   */ adaptOptions(options) {
        return Object.assign({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection,
            featureClass: this.featureClass
        }, options);
    }
    /**
   * @abstract
   * @return {Type} The format type.
   */ getType() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Read a single feature from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeature(source, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Read all features from a source.
   *
   * @abstract
   * @param {Document|Element|ArrayBuffer|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   */ readFeatures(source, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Read a single geometry from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @param {ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometry(source, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection from a source.
   *
   * @abstract
   * @param {Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default|undefined} Projection.
   */ readProjection(source) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature in this format.
   *
   * @abstract
   * @param {Feature} feature Feature.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeature(feature, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features in this format.
   *
   * @abstract
   * @param {Array<Feature>} features Features.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeFeatures(features, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Write a single geometry in this format.
   *
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {WriteOptions} [options] Write options.
   * @return {string|ArrayBuffer} Result.
   */ writeGeometry(geometry, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
}
var $abc939f9f19ad8b0$export$2e2bcd8739ae039 = $abc939f9f19ad8b0$var$FeatureFormat;
function $abc939f9f19ad8b0$export$7beeea566b560d4(geometry, write, options) {
    const featureProjection = options ? (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.dataProjection) : null;
    let transformed = geometry;
    if (featureProjection && dataProjection && !(0, $92f1443438429e81$export$fe091d73a555748b)(featureProjection, dataProjection)) {
        if (write) transformed = /** @type {T} */ geometry.clone();
        const fromProjection = write ? featureProjection : dataProjection;
        const toProjection = write ? dataProjection : featureProjection;
        if (fromProjection.getUnits() === 'tile-pixels') transformed.transform(fromProjection, toProjection);
        else transformed.applyTransform((0, $92f1443438429e81$export$fce0c6cfca85ed96)(fromProjection, toProjection));
    }
    if (write && options && /** @type {WriteOptions} */ options.decimals !== undefined) {
        const power = Math.pow(10, /** @type {WriteOptions} */ options.decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
     * @param {Array<number>} coordinates Coordinates.
     * @return {Array<number>} Transformed coordinates.
     */ const transform = function(coordinates) {
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = Math.round(coordinates[i] * power) / power;
            return coordinates;
        };
        if (transformed === geometry) transformed = /** @type {T} */ geometry.clone();
        transformed.applyTransform(transform);
    }
    return transformed;
}
function $abc939f9f19ad8b0$export$d3e9e4b1c7f2405c(extent, options) {
    const featureProjection = options ? (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.featureProjection) : null;
    const dataProjection = options ? (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.dataProjection) : null;
    if (featureProjection && dataProjection && !(0, $92f1443438429e81$export$fe091d73a555748b)(featureProjection, dataProjection)) return (0, $92f1443438429e81$export$751c68e0e0efff79)(extent, dataProjection, featureProjection);
    return extent;
}
const $abc939f9f19ad8b0$var$GeometryConstructor = {
    Point: (0, $f7e297e9f8b90024$export$2e2bcd8739ae039),
    LineString: (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039),
    Polygon: (0, $46a66e0f2fc72479$export$2e2bcd8739ae039),
    MultiPoint: (0, $760306f0926782cd$export$2e2bcd8739ae039),
    MultiLineString: (0, $977a2295e90f3a11$export$2e2bcd8739ae039),
    MultiPolygon: (0, $181e07a3c0063616$export$2e2bcd8739ae039)
};
function $abc939f9f19ad8b0$var$orientFlatCoordinates(flatCoordinates, ends, stride) {
    if (Array.isArray(ends[0])) {
        // MultiPolagon
        if (!(0, $c8291834a008fd82$export$a1d138f4bd85f4b4)(flatCoordinates, 0, ends, stride)) {
            flatCoordinates = flatCoordinates.slice();
            (0, $c8291834a008fd82$export$ea9ed55fc2a85010)(flatCoordinates, 0, ends, stride);
        }
        return flatCoordinates;
    }
    if (!(0, $c8291834a008fd82$export$f27cd06e85f4ba28)(flatCoordinates, 0, ends, stride)) {
        flatCoordinates = flatCoordinates.slice();
        (0, $c8291834a008fd82$export$b71b604ddfc778c7)(flatCoordinates, 0, ends, stride);
    }
    return flatCoordinates;
}
function $abc939f9f19ad8b0$export$f935e77582b330a(object, options) {
    const geometry = object.geometry;
    if (!geometry) return [];
    if (Array.isArray(geometry)) return geometry.map((geometry)=>$abc939f9f19ad8b0$export$f935e77582b330a({
            ...object,
            geometry: geometry
        })).flat();
    const geometryType = geometry.type === 'MultiPolygon' ? 'Polygon' : geometry.type;
    if (geometryType === 'GeometryCollection' || geometryType === 'Circle') throw new Error('Unsupported geometry type: ' + geometryType);
    const stride = geometry.layout.length;
    return $abc939f9f19ad8b0$export$7beeea566b560d4(new (0, $78328f7ea9ce528c$export$2e2bcd8739ae039)(geometryType, geometryType === 'Polygon' ? $abc939f9f19ad8b0$var$orientFlatCoordinates(geometry.flatCoordinates, geometry.ends, stride) : geometry.flatCoordinates, geometry.ends?.flat(), stride, object.properties || {}, object.id).enableSimplifyTransformed(), false, options);
}
function $abc939f9f19ad8b0$export$322c9678d8c47bf(object, options) {
    if (!object) return null;
    if (Array.isArray(object)) {
        const geometries = object.map((geometry)=>$abc939f9f19ad8b0$export$322c9678d8c47bf(geometry, options));
        return new (0, $6ed77a6d2b45ebec$export$2e2bcd8739ae039)(geometries);
    }
    const Geometry = $abc939f9f19ad8b0$var$GeometryConstructor[object.type];
    return $abc939f9f19ad8b0$export$7beeea566b560d4(new Geometry(object.flatCoordinates, object.layout || 'XY', object.ends), false, options);
}


/**
 * @module ol/format/JSONFeature
 */ 

/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {FeatureFormat<FeatureType>}
 * @abstract
 */ class $ee647177eb9b4503$var$JSONFeature extends (0, $abc939f9f19ad8b0$export$2e2bcd8739ae039) {
    constructor(){
        super();
    }
    /**
   * @return {import("./Feature.js").Type} Format.
   * @override
   */ getType() {
        return 'json';
    }
    /**
   * Read a feature.  Only works for a single feature. Use `readFeatures` to
   * read a feature collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @api
   * @override
   */ readFeature(source, options) {
        return this.readFeatureFromObject($ee647177eb9b4503$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * Read all features.  Works with both a single feature and a feature
   * collection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {Array<FeatureType>} Features.
   * @api
   * @override
   */ readFeatures(source, options) {
        return this.readFeaturesFromObject($ee647177eb9b4503$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   */ readFeatureFromObject(object, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   */ readFeaturesFromObject(object, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Read a geometry.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @api
   * @override
   */ readGeometry(source, options) {
        return this.readGeometryFromObject($ee647177eb9b4503$var$getObject(source), this.getReadOptions(source, options));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   */ readGeometryFromObject(object, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Read the projection.
   *
   * @param {ArrayBuffer|Document|Element|Object|string} source Source.
   * @return {import("../proj/Projection.js").default} Projection.
   * @api
   * @override
   */ readProjection(source) {
        return this.readProjectionFromObject($ee647177eb9b4503$var$getObject(source));
    }
    /**
   * @abstract
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   */ readProjectionFromObject(object) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Encode a feature as string.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded feature.
   * @api
   * @override
   */ writeFeature(feature, options) {
        return JSON.stringify(this.writeFeatureObject(feature, options));
    }
    /**
   * @abstract
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeatureObject(feature, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Encode an array of features as string.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded features.
   * @api
   * @override
   */ writeFeatures(features, options) {
        return JSON.stringify(this.writeFeaturesObject(features, options));
    }
    /**
   * @abstract
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeFeaturesObject(features, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Encode a geometry as string.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {string} Encoded geometry.
   * @api
   * @override
   */ writeGeometry(geometry, options) {
        return JSON.stringify(this.writeGeometryObject(geometry, options));
    }
    /**
   * @abstract
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {Object} Object.
   */ writeGeometryObject(geometry, options) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
}
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */ function $ee647177eb9b4503$var$getObject(source) {
    if (typeof source === 'string') {
        const object = JSON.parse(source);
        return object ? /** @type {Object} */ object : null;
    }
    if (source !== null) return source;
    return null;
}
var $ee647177eb9b4503$export$2e2bcd8739ae039 = $ee647177eb9b4503$var$JSONFeature;


/**
 * @typedef {import("geojson").GeoJSON} GeoJSONObject
 * @typedef {import("geojson").Feature} GeoJSONFeature
 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
 * @typedef {import("geojson").Geometry} GeoJSONGeometry
 * @typedef {import("geojson").Point} GeoJSONPoint
 * @typedef {import("geojson").LineString} GeoJSONLineString
 * @typedef {import("geojson").Polygon} GeoJSONPolygon
 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
 */ /**
 * @template {import("../Feature.js").FeatureLike} [FeatureType=import("../Feature.js").default]
 * @typedef {Object} Options
 *
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
 * written by the format.  Options passed to read or write methods will take precedence.
 * @property {string} [geometryName] Geometry name to use when creating features.
 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
 * will look for that field to set the geometry name. If both this field is set to `true`
 * and a `geometryName` is provided, the `geometryName` will take precedence.
 * @property {import('./Feature.js').FeatureToFeatureClass<FeatureType>} [featureClass] Feature class
 * to be used when reading features. The default is {@link module:ol/Feature~Feature}. If performance is
 * the primary concern, and features are not going to be modified or round-tripped through the format,
 * consider using {@link module:ol/render/Feature~RenderFeature}
 */ /**
 * @classdesc
 * Feature format for reading and writing data in the GeoJSON format.
 *
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("../Feature.js").default]
 * @extends {JSONFeature<FeatureType>}
 * @api
 */ class $69d9a08803fa6743$var$GeoJSON extends (0, $ee647177eb9b4503$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super();
        /**
     * @type {import("../proj/Projection.js").default}
     */ this.dataProjection = (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.dataProjection ? options.dataProjection : 'EPSG:4326');
        if (options.featureProjection) /**
       * @type {import("../proj/Projection.js").default}
       */ this.defaultFeatureProjection = (0, $92f1443438429e81$export$3988ae62b71be9a3)(options.featureProjection);
        if (options.featureClass) this.featureClass = options.featureClass;
        /**
     * Name of the geometry attribute for features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * Look for the `geometry_name` in the feature GeoJSON
     * @type {boolean|undefined}
     * @private
     */ this.extractGeometryName_ = options.extractGeometryName;
        this.supportedMediaTypes = [
            'application/geo+json',
            'application/vnd.geo+json'
        ];
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {FeatureType|Array<FeatureType>} Feature.
   * @override
   */ readFeatureFromObject(object, options) {
        /**
     * @type {GeoJSONFeature}
     */ let geoJSONFeature = null;
        if (object['type'] === 'Feature') geoJSONFeature = /** @type {GeoJSONFeature} */ object;
        else geoJSONFeature = {
            'type': 'Feature',
            'geometry': /** @type {GeoJSONGeometry} */ object,
            'properties': null
        };
        const geometry = $69d9a08803fa6743$var$readGeometryInternal(geoJSONFeature['geometry'], options);
        if (this.featureClass === (0, $78328f7ea9ce528c$export$2e2bcd8739ae039)) return /** @type {FeatureType|Array<FeatureType>} */ (0, $abc939f9f19ad8b0$export$f935e77582b330a)({
            geometry: geometry,
            id: geoJSONFeature['id'],
            properties: geoJSONFeature['properties']
        }, options);
        const feature = new (0, $1171fbd986f3130c$export$2e2bcd8739ae039)();
        if (this.geometryName_) feature.setGeometryName(this.geometryName_);
        else if (this.extractGeometryName_ && geoJSONFeature['geometry_name']) feature.setGeometryName(geoJSONFeature['geometry_name']);
        feature.setGeometry((0, $abc939f9f19ad8b0$export$322c9678d8c47bf)(geometry, options));
        if ('id' in geoJSONFeature) feature.setId(geoJSONFeature['id']);
        if (geoJSONFeature['properties']) feature.setProperties(geoJSONFeature['properties'], true);
        return /** @type {FeatureType|Array<FeatureType>} */ feature;
    }
    /**
   * @param {Object} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {Array<FeatureType>} Features.
   * @override
   */ readFeaturesFromObject(object, options) {
        const geoJSONObject = /** @type {GeoJSONObject} */ object;
        let features = null;
        if (geoJSONObject['type'] === 'FeatureCollection') {
            const geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ object;
            features = [];
            const geoJSONFeatures = geoJSONFeatureCollection['features'];
            for(let i = 0, ii = geoJSONFeatures.length; i < ii; ++i){
                const featureObject = this.readFeatureFromObject(geoJSONFeatures[i], options);
                if (!featureObject) continue;
                features.push(featureObject);
            }
        } else features = [
            this.readFeatureFromObject(object, options)
        ];
        return /** @type {Array<FeatureType>} */ features.flat();
    }
    /**
   * @param {GeoJSONGeometry} object Object.
   * @param {import("./Feature.js").ReadOptions} [options] Read options.
   * @protected
   * @return {import("../geom/Geometry.js").default} Geometry.
   * @override
   */ readGeometryFromObject(object, options) {
        return $69d9a08803fa6743$var$readGeometry(object, options);
    }
    /**
   * @param {Object} object Object.
   * @protected
   * @return {import("../proj/Projection.js").default} Projection.
   * @override
   */ readProjectionFromObject(object) {
        const crs = object['crs'];
        let projection;
        if (crs) {
            if (crs['type'] == 'name') projection = (0, $92f1443438429e81$export$3988ae62b71be9a3)(crs['properties']['name']);
            else if (crs['type'] === 'EPSG') projection = (0, $92f1443438429e81$export$3988ae62b71be9a3)('EPSG:' + crs['properties']['code']);
            else throw new Error('Unknown SRS type');
        } else projection = this.dataProjection;
        return /** @type {import("../proj/Projection.js").default} */ projection;
    }
    /**
   * Encode a feature as a GeoJSON Feature object.
   *
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeature} Object.
   * @api
   * @override
   */ writeFeatureObject(feature, options) {
        options = this.adaptOptions(options);
        /** @type {GeoJSONFeature} */ const object = {
            'type': 'Feature',
            geometry: null,
            properties: null
        };
        const id = feature.getId();
        if (id !== undefined) object.id = id;
        if (!feature.hasProperties()) return object;
        const properties = feature.getProperties();
        const geometry = feature.getGeometry();
        if (geometry) {
            object.geometry = $69d9a08803fa6743$var$writeGeometry(geometry, options);
            delete properties[feature.getGeometryName()];
        }
        if (!(0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(properties)) object.properties = properties;
        return object;
    }
    /**
   * Encode an array of features as a GeoJSON object.
   *
   * @param {Array<import("../Feature.js").default>} features Features.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONFeatureCollection} GeoJSON Object.
   * @api
   * @override
   */ writeFeaturesObject(features, options) {
        options = this.adaptOptions(options);
        const objects = [];
        for(let i = 0, ii = features.length; i < ii; ++i)objects.push(this.writeFeatureObject(features[i], options));
        return {
            type: 'FeatureCollection',
            features: objects
        };
    }
    /**
   * Encode a geometry as a GeoJSON object.
   *
   * @param {import("../geom/Geometry.js").default} geometry Geometry.
   * @param {import("./Feature.js").WriteOptions} [options] Write options.
   * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
   * @api
   * @override
   */ writeGeometryObject(geometry, options) {
        return $69d9a08803fa6743$var$writeGeometry(geometry, this.adaptOptions(options));
    }
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryObject} Geometry.
 */ function $69d9a08803fa6743$var$readGeometryInternal(object, options) {
    if (!object) return null;
    /** @type {import("./Feature.js").GeometryObject} */ let geometry;
    switch(object['type']){
        case 'Point':
            geometry = $69d9a08803fa6743$var$readPointGeometry(/** @type {GeoJSONPoint} */ object);
            break;
        case 'LineString':
            geometry = $69d9a08803fa6743$var$readLineStringGeometry(/** @type {GeoJSONLineString} */ object);
            break;
        case 'Polygon':
            geometry = $69d9a08803fa6743$var$readPolygonGeometry(/** @type {GeoJSONPolygon} */ object);
            break;
        case 'MultiPoint':
            geometry = $69d9a08803fa6743$var$readMultiPointGeometry(/** @type {GeoJSONMultiPoint} */ object);
            break;
        case 'MultiLineString':
            geometry = $69d9a08803fa6743$var$readMultiLineStringGeometry(/** @type {GeoJSONMultiLineString} */ object);
            break;
        case 'MultiPolygon':
            geometry = $69d9a08803fa6743$var$readMultiPolygonGeometry(/** @type {GeoJSONMultiPolygon} */ object);
            break;
        case 'GeometryCollection':
            geometry = $69d9a08803fa6743$var$readGeometryCollectionGeometry(/** @type {GeoJSONGeometryCollection} */ object);
            break;
        default:
            throw new Error('Unsupported GeoJSON type: ' + object['type']);
    }
    return geometry;
}
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */ function $69d9a08803fa6743$var$readGeometry(object, options) {
    const geometryObject = $69d9a08803fa6743$var$readGeometryInternal(object, options);
    return (0, $abc939f9f19ad8b0$export$322c9678d8c47bf)(geometryObject, options);
}
/**
 * @param {GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [options] Read options.
 * @return {import("./Feature.js").GeometryCollectionObject} Geometry collection.
 */ function $69d9a08803fa6743$var$readGeometryCollectionGeometry(object, options) {
    const geometries = object['geometries'].map(/**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("./Feature.js").GeometryObject} geometry Geometry.
     */ function(geometry) {
        return $69d9a08803fa6743$var$readGeometryInternal(geometry, options);
    });
    return geometries;
}
/**
 * @param {GeoJSONPoint} object Input object.
 * @return {import("./Feature.js").GeometryObject} Point geometry.
 */ function $69d9a08803fa6743$var$readPointGeometry(object) {
    const flatCoordinates = object['coordinates'];
    return {
        type: 'Point',
        flatCoordinates: flatCoordinates,
        layout: (0, $ce25558341ea2841$export$61bb6938093db2c8)(flatCoordinates.length)
    };
}
/**
 * @param {GeoJSONLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} LineString geometry.
 */ function $69d9a08803fa6743$var$readLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = coordinates.flat();
    return {
        type: 'LineString',
        flatCoordinates: flatCoordinates,
        ends: [
            flatCoordinates.length
        ],
        layout: (0, $ce25558341ea2841$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiLineString} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiLineString geometry.
 */ function $69d9a08803fa6743$var$readMultiLineStringGeometry(object) {
    const coordinates = object['coordinates'];
    const stride = coordinates[0]?.[0]?.length || 2;
    const flatCoordinates = [];
    const ends = (0, $4ae92c9bec373de6$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiLineString',
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $ce25558341ea2841$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONMultiPoint} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPoint geometry.
 */ function $69d9a08803fa6743$var$readMultiPointGeometry(object) {
    const coordinates = object['coordinates'];
    return {
        type: 'MultiPoint',
        flatCoordinates: coordinates.flat(),
        layout: (0, $ce25558341ea2841$export$61bb6938093db2c8)(coordinates[0]?.length || 2)
    };
}
/**
 * @param {GeoJSONMultiPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} MultiPolygon geometry.
 */ function $69d9a08803fa6743$var$readMultiPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.[0].length || 2;
    const endss = (0, $4ae92c9bec373de6$export$f9f2bb59da4accd3)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'MultiPolygon',
        flatCoordinates: flatCoordinates,
        ends: endss,
        layout: (0, $ce25558341ea2841$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {GeoJSONPolygon} object Object.
 * @return {import("./Feature.js").GeometryObject} Polygon.
 */ function $69d9a08803fa6743$var$readPolygonGeometry(object) {
    const coordinates = object['coordinates'];
    const flatCoordinates = [];
    const stride = coordinates[0]?.[0]?.length;
    const ends = (0, $4ae92c9bec373de6$export$47c3746a74384d45)(flatCoordinates, 0, coordinates, stride);
    return {
        type: 'Polygon',
        flatCoordinates: flatCoordinates,
        ends: ends,
        layout: (0, $ce25558341ea2841$export$61bb6938093db2c8)(stride)
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $69d9a08803fa6743$var$writeGeometry(geometry, options) {
    geometry = (0, $abc939f9f19ad8b0$export$7beeea566b560d4)(geometry, true, options);
    const type = geometry.getType();
    /** @type {GeoJSONGeometry} */ let geoJSON;
    switch(type){
        case 'Point':
            geoJSON = $69d9a08803fa6743$var$writePointGeometry(/** @type {import("../geom/Point.js").default} */ geometry, options);
            break;
        case 'LineString':
            geoJSON = $69d9a08803fa6743$var$writeLineStringGeometry(/** @type {import("../geom/LineString.js").default} */ geometry, options);
            break;
        case 'Polygon':
            geoJSON = $69d9a08803fa6743$var$writePolygonGeometry(/** @type {import("../geom/Polygon.js").default} */ geometry, options);
            break;
        case 'MultiPoint':
            geoJSON = $69d9a08803fa6743$var$writeMultiPointGeometry(/** @type {import("../geom/MultiPoint.js").default} */ geometry, options);
            break;
        case 'MultiLineString':
            geoJSON = $69d9a08803fa6743$var$writeMultiLineStringGeometry(/** @type {import("../geom/MultiLineString.js").default} */ geometry, options);
            break;
        case 'MultiPolygon':
            geoJSON = $69d9a08803fa6743$var$writeMultiPolygonGeometry(/** @type {import("../geom/MultiPolygon.js").default} */ geometry, options);
            break;
        case 'GeometryCollection':
            geoJSON = $69d9a08803fa6743$var$writeGeometryCollectionGeometry(/** @type {import("../geom/GeometryCollection.js").default} */ geometry, options);
            break;
        case 'Circle':
            geoJSON = {
                type: 'GeometryCollection',
                geometries: []
            };
            break;
        default:
            throw new Error('Unsupported geometry type: ' + type);
    }
    return geoJSON;
}
/**
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
 */ function $69d9a08803fa6743$var$writeGeometryCollectionGeometry(geometry, options) {
    options = Object.assign({}, options);
    delete options.featureProjection;
    const geometries = geometry.getGeometriesArray().map(function(geometry) {
        return $69d9a08803fa6743$var$writeGeometry(geometry, options);
    });
    return {
        type: 'GeometryCollection',
        geometries: geometries
    };
}
/**
 * @param {import("../geom/LineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $69d9a08803fa6743$var$writeLineStringGeometry(geometry, options) {
    return {
        type: 'LineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $69d9a08803fa6743$var$writeMultiLineStringGeometry(geometry, options) {
    return {
        type: 'MultiLineString',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $69d9a08803fa6743$var$writeMultiPointGeometry(geometry, options) {
    return {
        type: 'MultiPoint',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $69d9a08803fa6743$var$writeMultiPolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'MultiPolygon',
        coordinates: geometry.getCoordinates(right)
    };
}
/**
 * @param {import("../geom/Point.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $69d9a08803fa6743$var$writePointGeometry(geometry, options) {
    return {
        type: 'Point',
        coordinates: geometry.getCoordinates()
    };
}
/**
 * @param {import("../geom/Polygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */ function $69d9a08803fa6743$var$writePolygonGeometry(geometry, options) {
    let right;
    if (options) right = options.rightHanded;
    return {
        type: 'Polygon',
        coordinates: geometry.getCoordinates(right)
    };
}
var $69d9a08803fa6743$export$2e2bcd8739ae039 = $69d9a08803fa6743$var$GeoJSON;



/**
 * @module ol/layer/Vector
 */ /**
 * @module ol/renderer/canvas/VectorLayer
 */ 






/**
 * @module ol/render/canvas/BuilderGroup
 */ /**
 * @module ol/render/canvas/Builder
 */ 
/**
 * @module ol/colorlike
 */ 


/**
 * @module ol/style/IconImage
 */ 





/**
 * @module ol/style/IconImageCache
 */ 


/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache.shared}.
 */ class $20f070df2eea68ee$var$IconImageCache {
    constructor(){
        /**
     * @type {!Object<string, import("./IconImage.js").default>}
     * @private
     */ this.cache_ = {};
        /**
     * @type {!Object<string, CanvasPattern>}
     * @private
     */ this.patternCache_ = {};
        /**
     * @type {number}
     * @private
     */ this.cacheSize_ = 0;
        /**
     * @type {number}
     * @private
     */ this.maxCacheSize_ = 1024;
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.cache_ = {};
        this.patternCache_ = {};
        this.cacheSize_ = 0;
    }
    /**
   * @return {boolean} Can expire cache.
   */ canExpireCache() {
        return this.cacheSize_ > this.maxCacheSize_;
    }
    /**
   * FIXME empty description for jsdoc
   */ expire() {
        if (this.canExpireCache()) {
            let i = 0;
            for(const key in this.cache_){
                const iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    delete this.patternCache_[key];
                    --this.cacheSize_;
                }
            }
        }
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {import("./IconImage.js").default} Icon image.
   */ get(src, crossOrigin, color) {
        const key = $20f070df2eea68ee$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.cache_ ? this.cache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @return {CanvasPattern} Icon image.
   */ getPattern(src, crossOrigin, color) {
        const key = $20f070df2eea68ee$export$611736262b635f8d(src, crossOrigin, color);
        return key in this.patternCache_ ? this.patternCache_[key] : null;
    }
    /**
   * @param {string} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../color.js").Color|string|null} color Color.
   * @param {import("./IconImage.js").default|null} iconImage Icon image.
   * @param {boolean} [pattern] Also cache a `'repeat'` pattern with this `iconImage`.
   */ set(src, crossOrigin, color, iconImage, pattern) {
        const key = $20f070df2eea68ee$export$611736262b635f8d(src, crossOrigin, color);
        const update = key in this.cache_;
        this.cache_[key] = iconImage;
        if (pattern) {
            if (iconImage.getImageState() === (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) iconImage.load();
            if (iconImage.getImageState() === (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING) iconImage.ready().then(()=>{
                this.patternCache_[key] = (0, $755a3001f896bcf1$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), 'repeat');
            });
            else this.patternCache_[key] = (0, $755a3001f896bcf1$export$fcb72ce088a6632c)().createPattern(iconImage.getImage(1), 'repeat');
        }
        if (!update) ++this.cacheSize_;
    }
    /**
   * Set the cache size of the icon cache. Default is `1024`. Change this value when
   * your map uses more than 1024 different icon images and you are not caching icon
   * styles on the application level.
   * @param {number} maxCacheSize Cache max size.
   * @api
   */ setSize(maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    }
}
function $20f070df2eea68ee$export$611736262b635f8d(src, crossOrigin, color) {
    const colorString = color ? (0, $2c17bfc916c8f689$export$75093a47a9fa838d)(color) : 'null';
    return crossOrigin + ':' + src + ':' + colorString;
}
var $20f070df2eea68ee$export$2e2bcd8739ae039 = $20f070df2eea68ee$var$IconImageCache;
const $20f070df2eea68ee$export$747ccdf771a87ab8 = new $20f070df2eea68ee$var$IconImageCache();


/**
 * @type {CanvasRenderingContext2D}
 */ let $33bba60ac8fc0af6$var$taintedTestContext = null;
class $33bba60ac8fc0af6$var$IconImage extends (0, $dd029d816e3b4259$export$2e2bcd8739ae039) {
    /**
   * @param {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null} image Image.
   * @param {string|undefined} src Src.
   * @param {?string} crossOrigin Cross origin.
   * @param {import("../ImageState.js").default|undefined} imageState Image state.
   * @param {import("../color.js").Color|string|null} color Color.
   */ constructor(image, src, crossOrigin, imageState, color){
        super();
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {HTMLImageElement|HTMLCanvasElement|ImageBitmap|null}
     */ this.image_ = image;
        /**
     * @private
     * @type {string|null}
     */ this.crossOrigin_ = crossOrigin;
        /**
     * @private
     * @type {Object<number, HTMLCanvasElement>}
     */ this.canvas_ = {};
        /**
     * @private
     * @type {import("../color.js").Color|string|null}
     */ this.color_ = color;
        /**
     * @private
     * @type {import("../ImageState.js").default}
     */ this.imageState_ = imageState === undefined ? (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE : imageState;
        /**
     * @private
     * @type {import("../size.js").Size|null}
     */ this.size_ = image && image.width && image.height ? [
            image.width,
            image.height
        ] : null;
        /**
     * @private
     * @type {string|undefined}
     */ this.src_ = src;
        /**
     * @private
     */ this.tainted_;
        /**
     * @private
     * @type {Promise<void>|null}
     */ this.ready_ = null;
    }
    /**
   * @private
   */ initializeImage_() {
        this.image_ = new Image();
        if (this.crossOrigin_ !== null) this.image_.crossOrigin = this.crossOrigin_;
    }
    /**
   * @private
   * @return {boolean} The image canvas is tainted.
   */ isTainted_() {
        if (this.tainted_ === undefined && this.imageState_ === (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) {
            if (!$33bba60ac8fc0af6$var$taintedTestContext) $33bba60ac8fc0af6$var$taintedTestContext = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(1, 1, undefined, {
                willReadFrequently: true
            });
            $33bba60ac8fc0af6$var$taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                $33bba60ac8fc0af6$var$taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            } catch  {
                $33bba60ac8fc0af6$var$taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    }
    /**
   * @private
   */ dispatchChangeEvent_() {
        this.dispatchEvent((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE);
    }
    /**
   * @private
   */ handleImageError_() {
        this.imageState_ = (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR;
        this.dispatchChangeEvent_();
    }
    /**
   * @private
   */ handleImageLoad_() {
        this.imageState_ = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
        this.size_ = [
            this.image_.width,
            this.image_.height
        ];
        this.dispatchChangeEvent_();
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element or image bitmap.
   */ getImage(pixelRatio) {
        if (!this.image_) this.initializeImage_();
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Image or Canvas element.
   */ getPixelRatio(pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   */ getHitDetectionImage() {
        if (!this.image_) this.initializeImage_();
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                const width = this.size_[0];
                const height = this.size_[1];
                const context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            } else this.hitDetectionImage_ = this.image_;
        }
        return this.hitDetectionImage_;
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   */ getSize() {
        return this.size_;
    }
    /**
   * @return {string|undefined} Image src.
   */ getSrc() {
        return this.src_;
    }
    /**
   * Load not yet loaded URI.
   */ load() {
        if (this.imageState_ !== (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) return;
        if (!this.image_) this.initializeImage_();
        this.imageState_ = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING;
        try {
            if (this.src_ !== undefined) /** @type {HTMLImageElement} */ this.image_.src = this.src_;
        } catch  {
            this.handleImageError_();
        }
        if (this.image_ instanceof HTMLImageElement) (0, $e460a8a24b67695c$export$a9e5af241c1bd389)(this.image_, this.src_).then((image)=>{
            this.image_ = image;
            this.handleImageLoad_();
        }).catch(this.handleImageError_.bind(this));
    }
    /**
   * @param {number} pixelRatio Pixel ratio.
   * @private
   */ replaceColor_(pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio] || this.imageState_ !== (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) return;
        const image = this.image_;
        const ctx = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(Math.ceil(image.width * pixelRatio), Math.ceil(image.height * pixelRatio));
        const canvas = ctx.canvas;
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(image, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        ctx.fillStyle = (0, $2c17bfc916c8f689$export$590567be997858b6)(this.color_);
        ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(image, 0, 0);
        this.canvas_[pixelRatio] = canvas;
    }
    /**
   * @return {Promise<void>} Promise that resolves when the image is loaded.
   */ ready() {
        if (!this.ready_) this.ready_ = new Promise((resolve)=>{
            if (this.imageState_ === (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR) resolve();
            else {
                const onChange = ()=>{
                    if (this.imageState_ === (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED || this.imageState_ === (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR) {
                        this.removeEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, onChange);
                        resolve();
                    }
                };
                this.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, onChange);
            }
        });
        return this.ready_;
    }
}
function $33bba60ac8fc0af6$export$3988ae62b71be9a3(image, cacheKey, crossOrigin, imageState, color, pattern) {
    let iconImage = cacheKey === undefined ? undefined : (0, $20f070df2eea68ee$export$747ccdf771a87ab8).get(cacheKey, crossOrigin, color);
    if (!iconImage) {
        iconImage = new $33bba60ac8fc0af6$var$IconImage(image, image && 'src' in image ? image.src || undefined : cacheKey, crossOrigin, imageState, color);
        (0, $20f070df2eea68ee$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage, pattern);
    }
    if (pattern && iconImage && !(0, $20f070df2eea68ee$export$747ccdf771a87ab8).getPattern(cacheKey, crossOrigin, color)) (0, $20f070df2eea68ee$export$747ccdf771a87ab8).set(cacheKey, crossOrigin, color, iconImage, pattern);
    return iconImage;
}
var $33bba60ac8fc0af6$export$2e2bcd8739ae039 = $33bba60ac8fc0af6$var$IconImage;



function $51e4a33855e1d867$export$dc5b1400ac3a10a8(color) {
    if (!color) return null;
    if (Array.isArray(color)) return (0, $2c17bfc916c8f689$export$f84e8e69fd4488a5)(color);
    if (typeof color === 'object' && 'src' in color) return $51e4a33855e1d867$var$asCanvasPattern(color);
    return color;
}
/**
 * @param {PatternDescriptor} pattern Pattern descriptor.
 * @return {CanvasPattern|null} Canvas pattern or null if the pattern referenced in the
 * PatternDescriptor was not found in the icon image cache.
 */ function $51e4a33855e1d867$var$asCanvasPattern(pattern) {
    if (!pattern.offset || !pattern.size) return (0, $20f070df2eea68ee$export$747ccdf771a87ab8).getPattern(pattern.src, 'anonymous', pattern.color);
    const cacheKey = pattern.src + ':' + pattern.offset;
    const canvasPattern = (0, $20f070df2eea68ee$export$747ccdf771a87ab8).getPattern(cacheKey, undefined, pattern.color);
    if (canvasPattern) return canvasPattern;
    const iconImage = (0, $20f070df2eea68ee$export$747ccdf771a87ab8).get(pattern.src, 'anonymous', null);
    if (iconImage.getImageState() !== (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) return null;
    const patternCanvasContext = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(pattern.size[0], pattern.size[1]);
    patternCanvasContext.drawImage(iconImage.getImage(1), pattern.offset[0], pattern.offset[1], pattern.size[0], pattern.size[1], 0, 0, pattern.size[0], pattern.size[1]);
    (0, $33bba60ac8fc0af6$export$3988ae62b71be9a3)(patternCanvasContext.canvas, cacheKey, undefined, (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED, pattern.color, true);
    return (0, $20f070df2eea68ee$export$747ccdf771a87ab8).getPattern(cacheKey, undefined, pattern.color);
}





/**
 * @module ol/render/VectorContext
 */ /**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */ class $37298fa487b80ee5$var$VectorContext {
    /**
   * Render a geometry with a custom renderer.
   *
   * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {}
    /**
   * Render a geometry.
   *
   * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
   */ drawGeometry(geometry) {}
    /**
   * Set the rendering style.
   *
   * @param {import("../style/Style.js").default} style The rendering style.
   */ setStyle(style) {}
    /**
   * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawCircle(circleGeometry, feature, index) {}
    /**
   * @param {import("../Feature.js").default} feature Feature.
   * @param {import("../style/Style.js").default} style Style.
   * @param {number} [index] Render order index.
   */ drawFeature(feature, style, index) {}
    /**
   * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
   * @param {import("../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   */ drawGeometryCollection(geometryCollectionGeometry, feature, index) {}
    /**
   * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawLineString(lineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPoint(multiPointGeometry, feature, index) {}
    /**
   * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPoint(pointGeometry, feature, index) {}
    /**
   * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawPolygon(polygonGeometry, feature, index) {}
    /**
   * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
   * @param {import("../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   */ drawText(geometry, feature, index) {}
    /**
   * @param {import("../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
   */ setFillStrokeStyle(fillStyle, strokeStyle) {}
    /**
   * @param {import("../style/Image.js").default} imageStyle Image style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with a text style.
   */ setImageStyle(imageStyle, declutterImageWithText) {}
    /**
   * @param {import("../style/Text.js").default} textStyle Text style.
   * @param {import("../render/canvas.js").DeclutterImageWithText} [declutterImageWithText] Shared data for combined decluttering with an image style.
   */ setTextStyle(textStyle, declutterImageWithText) {}
}
var $37298fa487b80ee5$export$2e2bcd8739ae039 = $37298fa487b80ee5$var$VectorContext;


/**
 * @module ol/render/canvas
 */ 
/**
 * @module ol/css
 */ /**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */ /**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */ const $bbcb4c1977b6e9f0$export$981241db82723ce2 = 'ol-hidden';
const $bbcb4c1977b6e9f0$export$99b49471b0394319 = 'ol-selectable';
const $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29 = 'ol-unselectable';
const $bbcb4c1977b6e9f0$export$68eede0dd8c6c1da = 'ol-unsupported';
const $bbcb4c1977b6e9f0$export$4d4f8be70b656192 = 'ol-control';
const $bbcb4c1977b6e9f0$export$e16017ac68d14492 = 'ol-collapsed';
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */ const $bbcb4c1977b6e9f0$var$fontRegEx = new RegExp([
    '^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)',
    '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?',
    '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))',
    '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))',
    '?\\s*([-,\\"\\\'\\sa-z]+?)\\s*$'
].join(''), 'i');
/** @type {Array<'style'|'variant'|'weight'|'size'|'lineHeight'|'family'>} */ const $bbcb4c1977b6e9f0$var$fontRegExMatchIndex = [
    'style',
    'variant',
    'weight',
    'size',
    'lineHeight',
    'family'
];
const $bbcb4c1977b6e9f0$export$5abde8a6aec4a131 = function(fontSpec) {
    const match = fontSpec.match($bbcb4c1977b6e9f0$var$fontRegEx);
    if (!match) return null;
    const style = /** @type {FontParameters} */ {
        lineHeight: 'normal',
        size: '1.2em',
        style: 'normal',
        weight: 'normal',
        variant: 'normal'
    };
    for(let i = 0, ii = $bbcb4c1977b6e9f0$var$fontRegExMatchIndex.length; i < ii; ++i){
        const value = match[i + 1];
        if (value !== undefined) style[$bbcb4c1977b6e9f0$var$fontRegExMatchIndex[i]] = value;
    }
    style.families = style.family.split(/,\s?/);
    return style;
};





const $c8f894129d9fa0b9$export$3847dfea4f8d4dfa = '10px sans-serif';
const $c8f894129d9fa0b9$export$c495d52ee3fd74b2 = '#000';
const $c8f894129d9fa0b9$export$17bd0c38d6ae694e = 'round';
const $c8f894129d9fa0b9$export$e21b4112fdc612fc = [];
const $c8f894129d9fa0b9$export$e06efc2409049f76 = 0;
const $c8f894129d9fa0b9$export$365eb9648cf19bd0 = 'round';
const $c8f894129d9fa0b9$export$80c1c01844597b7b = 10;
const $c8f894129d9fa0b9$export$1eb2eaecacf2031e = '#000';
const $c8f894129d9fa0b9$export$94d53b95641b5766 = 'center';
const $c8f894129d9fa0b9$export$cf2279a1bff62eb = 'middle';
const $c8f894129d9fa0b9$export$40a9eeef55665a40 = [
    0,
    0,
    0,
    0
];
const $c8f894129d9fa0b9$export$79661f132c62010e = 1;
const $c8f894129d9fa0b9$export$1d36981fcadac93b = new (0, $d575b598d09f57d3$export$2e2bcd8739ae039)();
/**
 * @type {CanvasRenderingContext2D}
 */ let $c8f894129d9fa0b9$var$measureContext = null;
/**
 * @type {string}
 */ let $c8f894129d9fa0b9$var$measureFont;
const $c8f894129d9fa0b9$export$7fdcec604f0b1fa7 = {};
const $c8f894129d9fa0b9$export$a534074a28fa87ff = function() {
    const retries = 100;
    const size = '32px ';
    const referenceFonts = [
        'monospace',
        'serif'
    ];
    const len = referenceFonts.length;
    const text = 'wmytzilWMYTZIL@#/&?$%10\uF013';
    let interval, referenceWidth;
    /**
   * @param {string} fontStyle Css font-style
   * @param {string} fontWeight Css font-weight
   * @param {*} fontFamily Css font-family
   * @return {boolean} Font with style and weight is available
   */ function isAvailable(fontStyle, fontWeight, fontFamily) {
        let available = true;
        for(let i = 0; i < len; ++i){
            const referenceFont = referenceFonts[i];
            referenceWidth = $c8f894129d9fa0b9$export$4ea92329b673abd1(fontStyle + ' ' + fontWeight + ' ' + size + referenceFont, text);
            if (fontFamily != referenceFont) {
                const width = $c8f894129d9fa0b9$export$4ea92329b673abd1(fontStyle + ' ' + fontWeight + ' ' + size + fontFamily + ',' + referenceFont, text);
                // If width and referenceWidth are the same, then the fallback was used
                // instead of the font we wanted, so the font is not available.
                available = available && width != referenceWidth;
            }
        }
        if (available) return true;
        return false;
    }
    function check() {
        let done = true;
        const fonts = $c8f894129d9fa0b9$export$1d36981fcadac93b.getKeys();
        for(let i = 0, ii = fonts.length; i < ii; ++i){
            const font = fonts[i];
            if ($c8f894129d9fa0b9$export$1d36981fcadac93b.get(font) < retries) {
                const [style, weight, family] = font.split('\n');
                if (isAvailable(style, weight, family)) {
                    (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)($c8f894129d9fa0b9$export$7fdcec604f0b1fa7);
                    // Make sure that loaded fonts are picked up by Safari
                    $c8f894129d9fa0b9$var$measureContext = null;
                    $c8f894129d9fa0b9$var$measureFont = undefined;
                    $c8f894129d9fa0b9$export$1d36981fcadac93b.set(font, retries);
                } else {
                    $c8f894129d9fa0b9$export$1d36981fcadac93b.set(font, $c8f894129d9fa0b9$export$1d36981fcadac93b.get(font) + 1, true);
                    done = false;
                }
            }
        }
        if (done) {
            clearInterval(interval);
            interval = undefined;
        }
    }
    return function(fontSpec) {
        const font = (0, $bbcb4c1977b6e9f0$export$5abde8a6aec4a131)(fontSpec);
        if (!font) return;
        const families = font.families;
        for(let i = 0, ii = families.length; i < ii; ++i){
            const family = families[i];
            const key = font.style + '\n' + font.weight + '\n' + family;
            if ($c8f894129d9fa0b9$export$1d36981fcadac93b.get(key) === undefined) {
                $c8f894129d9fa0b9$export$1d36981fcadac93b.set(key, retries, true);
                if (!isAvailable(font.style, font.weight, family)) {
                    $c8f894129d9fa0b9$export$1d36981fcadac93b.set(key, 0, true);
                    if (interval === undefined) interval = setInterval(check, 32);
                }
            }
        }
    };
}();
const $c8f894129d9fa0b9$export$4feaf6852ff92513 = function() {
    /**
   * @type {HTMLDivElement}
   */ let measureElement;
    return function(fontSpec) {
        let height = $c8f894129d9fa0b9$export$7fdcec604f0b1fa7[fontSpec];
        if (height == undefined) {
            if (0, $89969764a1196844$export$98fcef3dc9973292) {
                const font = (0, $bbcb4c1977b6e9f0$export$5abde8a6aec4a131)(fontSpec);
                const metrics = $c8f894129d9fa0b9$var$measureText(fontSpec, "\u017Dg");
                const lineHeight = isNaN(Number(font.lineHeight)) ? 1.2 : Number(font.lineHeight);
                height = lineHeight * (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            } else {
                if (!measureElement) {
                    measureElement = document.createElement('div');
                    measureElement.innerHTML = 'M';
                    measureElement.style.minHeight = '0';
                    measureElement.style.maxHeight = 'none';
                    measureElement.style.height = 'auto';
                    measureElement.style.padding = '0';
                    measureElement.style.border = 'none';
                    measureElement.style.position = 'absolute';
                    measureElement.style.display = 'block';
                    measureElement.style.left = '-99999px';
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            $c8f894129d9fa0b9$export$7fdcec604f0b1fa7[fontSpec] = height;
        }
        return height;
    };
}();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */ function $c8f894129d9fa0b9$var$measureText(font, text) {
    if (!$c8f894129d9fa0b9$var$measureContext) $c8f894129d9fa0b9$var$measureContext = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(1, 1);
    if (font != $c8f894129d9fa0b9$var$measureFont) {
        $c8f894129d9fa0b9$var$measureContext.font = font;
        $c8f894129d9fa0b9$var$measureFont = $c8f894129d9fa0b9$var$measureContext.font;
    }
    return $c8f894129d9fa0b9$var$measureContext.measureText(text);
}
function $c8f894129d9fa0b9$export$4ea92329b673abd1(font, text) {
    return $c8f894129d9fa0b9$var$measureText(font, text).width;
}
function $c8f894129d9fa0b9$export$915c7ba51467308f(font, text, cache) {
    if (text in cache) return cache[text];
    const width = text.split('\n').reduce((prev, curr)=>Math.max(prev, $c8f894129d9fa0b9$export$4ea92329b673abd1(font, curr)), 0);
    cache[text] = width;
    return width;
}
function $c8f894129d9fa0b9$export$7d7c13020df1e791(baseStyle, chunks) {
    const widths = [];
    const heights = [];
    const lineWidths = [];
    let width = 0;
    let lineWidth = 0;
    let height = 0;
    let lineHeight = 0;
    for(let i = 0, ii = chunks.length; i <= ii; i += 2){
        const text = chunks[i];
        if (text === '\n' || i === ii) {
            width = Math.max(width, lineWidth);
            lineWidths.push(lineWidth);
            lineWidth = 0;
            height += lineHeight;
            lineHeight = 0;
            continue;
        }
        const font = chunks[i + 1] || baseStyle.font;
        const currentWidth = $c8f894129d9fa0b9$export$4ea92329b673abd1(font, text);
        widths.push(currentWidth);
        lineWidth += currentWidth;
        const currentHeight = $c8f894129d9fa0b9$export$4feaf6852ff92513(font);
        heights.push(currentHeight);
        lineHeight = Math.max(lineHeight, currentHeight);
    }
    return {
        width: width,
        height: height,
        widths: widths,
        heights: heights,
        lineWidths: lineWidths
    };
}
function $c8f894129d9fa0b9$export$8ac4d72be78047e6(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
function $c8f894129d9fa0b9$export$3cb6f3a6e49cc0ee(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        if (context.globalAlpha === undefined) context.globalAlpha = (context)=>context.globalAlpha *= opacity;
        else context.globalAlpha *= opacity;
    }
    if (transform) context.transform.apply(context, transform);
    if (/** @type {*} */ labelOrImage.contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        $c8f894129d9fa0b9$var$executeLabelInstructions(/** @type {Label} */ labelOrImage, context);
    } else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, 0, 0, w, h);
    } else // if image not flipped translate and scale can be avoided
    context.drawImage(/** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ labelOrImage, originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */ function $c8f894129d9fa0b9$var$executeLabelInstructions(label, context) {
    const contextInstructions = label.contextInstructions;
    for(let i = 0, ii = contextInstructions.length; i < ii; i += 2)if (Array.isArray(contextInstructions[i + 1])) context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
    else context[contextInstructions[i]] = contextInstructions[i + 1];
}


/**
 * @module ol/render/canvas/Instruction
 */ /**
 * @enum {number}
 */ const $3b9081ec7a886d58$var$Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12
};
const $3b9081ec7a886d58$export$f21891651e408226 = [
    $3b9081ec7a886d58$var$Instruction.FILL
];
const $3b9081ec7a886d58$export$7a98aa5364d62ba8 = [
    $3b9081ec7a886d58$var$Instruction.STROKE
];
const $3b9081ec7a886d58$export$9f746cc58a899a00 = [
    $3b9081ec7a886d58$var$Instruction.BEGIN_PATH
];
const $3b9081ec7a886d58$export$89b10f327e413e71 = [
    $3b9081ec7a886d58$var$Instruction.CLOSE_PATH
];
var $3b9081ec7a886d58$export$2e2bcd8739ae039 = $3b9081ec7a886d58$var$Instruction;


class $88475e4f65e96675$var$CanvasBuilder extends (0, $37298fa487b80ee5$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super();
        /**
     * @protected
     * @type {number}
     */ this.tolerance = tolerance;
        /**
     * @protected
     * @const
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent = maxExtent;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @type {number}
     */ this.maxLineWidth = 0;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction1_ = null;
        /**
     * @private
     * @type {Array<*>}
     */ this.beginGeometryInstruction2_ = null;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.bufferedMaxExtent_ = null;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = [];
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = [];
        /**
     * @private
     * @type {import("../../coordinate.js").Coordinate}
     */ this.tmpCoordinate_ = [];
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = [];
        /**
     * @protected
     * @type {import("../canvas.js").FillStrokeState}
     */ this.state = /** @type {import("../canvas.js").FillStrokeState} */ {};
    }
    /**
   * @protected
   * @param {Array<number>} dashArray Dash array.
   * @return {Array<number>} Dash array with pixel ratio applied
   */ applyPixelRatio(dashArray) {
        const pixelRatio = this.pixelRatio;
        return pixelRatio == 1 ? dashArray : dashArray.map(function(dash) {
            return dash * pixelRatio;
        });
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} stride Stride.
   * @protected
   * @return {number} My end
   */ appendFlatPointCoordinates(flatCoordinates, stride) {
        const extent = this.getBufferedMaxExtent();
        const tmpCoord = this.tmpCoordinate_;
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += stride){
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if ((0, $7e819822b33b3d32$export$ac68c24d37ca240f)(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} closed Last input coordinate equals first.
   * @param {boolean} skipFirst Skip first coordinate.
   * @protected
   * @return {number} My end.
   */ appendFlatLineCoordinates(flatCoordinates, offset, end, stride, closed, skipFirst) {
        const coordinates = this.coordinates;
        let myEnd = coordinates.length;
        const extent = this.getBufferedMaxExtent();
        if (skipFirst) offset += stride;
        let lastXCoord = flatCoordinates[offset];
        let lastYCoord = flatCoordinates[offset + 1];
        const nextCoord = this.tmpCoordinate_;
        let skipped = true;
        let i, lastRel, nextRel;
        for(i = offset + stride; i < end; i += stride){
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = (0, $7e819822b33b3d32$export$f97905ead28c61a8)(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            } else if (nextRel === (0, $68b6ebc493ff6e57$export$2e2bcd8739ae039).INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            } else skipped = true;
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if (closed && skipped || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @param {Array<number>} builderEnds Builder ends.
   * @return {number} Offset.
   */ drawCustomCoordinates_(flatCoordinates, offset, ends, stride, builderEnds) {
        for(let i = 0, ii = ends.length; i < ii; ++i){
            const end = ends[i];
            const builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {Function} renderer Renderer.
   * @param {Function} hitDetectionRenderer Renderer.
   * @param {number} [index] Render order index.
   * @override
   */ drawCustom(geometry, feature, renderer, hitDetectionRenderer, index) {
        this.beginGeometry(geometry, feature, index);
        const type = geometry.getType();
        const stride = geometry.getStride();
        const builderBegin = this.coordinates.length;
        let flatCoordinates, builderEnd, builderEnds, builderEndss;
        let offset;
        switch(type){
            case 'MultiPolygon':
                flatCoordinates = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getOrientedFlatCoordinates();
                builderEndss = [];
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                offset = 0;
                for(let i = 0, ii = endss.length; i < ii; ++i){
                    const myEnds = [];
                    offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                    builderEndss.push(myEnds);
                }
                this.instructions.push([
                    (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    renderer,
                    (0, $76a969a6125a5a4a$export$915c7058aeb4dfeb),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEndss,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $76a969a6125a5a4a$export$915c7058aeb4dfeb),
                    index
                ]);
                break;
            case 'Polygon':
            case 'MultiLineString':
                builderEnds = [];
                flatCoordinates = type == 'Polygon' ? /** @type {import("../../geom/Polygon.js").default} */ geometry.getOrientedFlatCoordinates() : geometry.getFlatCoordinates();
                offset = this.drawCustomCoordinates_(flatCoordinates, 0, /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ geometry.getEnds(), stride, builderEnds);
                this.instructions.push([
                    (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    renderer,
                    (0, $76a969a6125a5a4a$export$cbb9596fc0f40db2),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnds,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $76a969a6125a5a4a$export$cbb9596fc0f40db2),
                    index
                ]);
                break;
            case 'LineString':
            case 'Circle':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
                this.instructions.push([
                    (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e),
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e),
                    index
                ]);
                break;
            case 'MultiPoint':
                flatCoordinates = geometry.getFlatCoordinates();
                builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
                if (builderEnd > builderBegin) {
                    this.instructions.push([
                        (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        renderer,
                        (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e),
                        index
                    ]);
                    this.hitDetectionInstructions.push([
                        (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                        builderBegin,
                        builderEnd,
                        geometry,
                        hitDetectionRenderer || renderer,
                        (0, $76a969a6125a5a4a$export$9c0934e4e9c3f61e),
                        index
                    ]);
                }
                break;
            case 'Point':
                flatCoordinates = geometry.getFlatCoordinates();
                this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
                builderEnd = this.coordinates.length;
                this.instructions.push([
                    (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    undefined,
                    index
                ]);
                this.hitDetectionInstructions.push([
                    (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    hitDetectionRenderer || renderer,
                    undefined,
                    index
                ]);
                break;
            default:
        }
        this.endGeometry(feature);
    }
    /**
   * @protected
   * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} index Render order index
   */ beginGeometry(geometry, feature, index) {
        this.beginGeometryInstruction1_ = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
            index
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   */ finish() {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates
        };
    }
    /**
   * Reverse the hit detection instructions.
   */ reverseHitDetectionInstructions() {
        const hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        let i;
        const n = hitDetectionInstructions.length;
        let instruction;
        let type;
        let begin = -1;
        for(i = 0; i < n; ++i){
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ instruction[0];
            if (type == (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).END_GEOMETRY) begin = i;
            else if (type == (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).BEGIN_GEOMETRY) {
                instruction[2] = i;
                (0, $830d23b8323fc080$export$292cfa960964f0e0)(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import('../canvas.js').FillStrokeState} [state] State.
   * @return {import('../canvas.js').FillStrokeState} State.
   */ fillStyleToState(fillStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (fillStyle) {
            const fillStyleColor = fillStyle.getColor();
            state.fillPatternScale = fillStyleColor && typeof fillStyleColor === 'object' && 'src' in fillStyleColor ? this.pixelRatio : 1;
            state.fillStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2));
        } else state.fillStyle = undefined;
        return state;
    }
    /**
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {import("../canvas.js").FillStrokeState} State.
   */ strokeStyleToState(strokeStyle, state = /** @type {import('../canvas.js').FillStrokeState} */ {}) {
        if (strokeStyle) {
            const strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $c8f894129d9fa0b9$export$1eb2eaecacf2031e));
            const strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap = strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e);
            const strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash ? strokeStyleLineDash.slice() : (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc);
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $c8f894129d9fa0b9$export$e06efc2409049f76);
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin = strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0);
            const strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth = strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $c8f894129d9fa0b9$export$79661f132c62010e);
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit = strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $c8f894129d9fa0b9$export$80c1c01844597b7b);
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        } else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
        }
        return state;
    }
    /**
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        const state = this.state;
        this.fillStyleToState(fillStyle, state);
        this.strokeStyleToState(strokeStyle, state);
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Fill instruction.
   */ createFill(state) {
        const fillStyle = state.fillStyle;
        /** @type {Array<*>} */ const fillInstruction = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_FILL_STYLE,
            fillStyle
        ];
        if (typeof fillStyle !== 'string') // Fill is a pattern or gradient - align and scale it!
        fillInstruction.push(state.fillPatternScale);
        return fillInstruction;
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   */ applyStroke(state) {
        this.instructions.push(this.createStroke(state));
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @return {Array<*>} Stroke instruction.
   */ createStroke(state) {
        return [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash ? this.applyPixelRatio(state.lineDash) : null,
            state.lineDashOffset * this.pixelRatio
        ];
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
   */ updateFillStyle(state, createFill) {
        const fillStyle = state.fillStyle;
        if (typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
            if (fillStyle !== undefined) this.instructions.push(createFill.call(this, state));
            state.currentFillStyle = fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
   */ updateStrokeStyle(state, applyStroke) {
        const strokeStyle = state.strokeStyle;
        const lineCap = state.lineCap;
        const lineDash = state.lineDash;
        const lineDashOffset = state.lineDashOffset;
        const lineJoin = state.lineJoin;
        const lineWidth = state.lineWidth;
        const miterLimit = state.miterLimit;
        if (state.currentStrokeStyle != strokeStyle || state.currentLineCap != lineCap || lineDash != state.currentLineDash && !(0, $830d23b8323fc080$export$e9bab7fafb253603)(state.currentLineDash, lineDash) || state.currentLineDashOffset != lineDashOffset || state.currentLineJoin != lineJoin || state.currentLineWidth != lineWidth || state.currentMiterLimit != miterLimit) {
            if (strokeStyle !== undefined) applyStroke.call(this, state);
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
        }
    }
    /**
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   */ endGeometry(feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        const endGeometryInstruction = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).END_GEOMETRY,
            feature
        ];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    }
    /**
   * Get the buffered rendering extent.  Rendering will be clipped to the extent
   * provided to the constructor.  To account for symbolizers that may intersect
   * this extent, we calculate a buffered extent (e.g. based on stroke width).
   * @return {import("../../extent.js").Extent} The buffered rendering extent.
   * @protected
   */ getBufferedMaxExtent() {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = (0, $7e819822b33b3d32$export$9cd59f9826255e47)(this.maxExtent);
            if (this.maxLineWidth > 0) {
                const width = this.resolution * (this.maxLineWidth + 1) / 2;
                (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    }
}
var $88475e4f65e96675$export$2e2bcd8739ae039 = $88475e4f65e96675$var$CanvasBuilder;


/**
 * @module ol/render/canvas/ImageBuilder
 */ 


class $80668ba8a80e069a$var$CanvasImageBuilder extends (0, $88475e4f65e96675$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.hitDetectionImage_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.imagePixelRatio_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.anchorY_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.height_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.opacity_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originX_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.originY_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        /**
     * @private
     * @type {import("../../size.js").Size|undefined}
     */ this.scale_ = undefined;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = undefined;
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with a text builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPoint(pointGeometry, feature, index) {
        if (!this.image_ || this.maxExtent && !(0, $7e819822b33b3d32$export$ac68c24d37ca240f)(this.maxExtent, pointGeometry.getFlatCoordinates())) return;
        this.beginGeometry(pointGeometry, feature, index);
        const flatCoordinates = pointGeometry.getFlatCoordinates();
        const stride = pointGeometry.getStride();
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPoint(multiPointGeometry, feature, index) {
        if (!this.image_) return;
        this.beginGeometry(multiPointGeometry, feature, index);
        const flatCoordinates = multiPointGeometry.getFlatCoordinates();
        const filteredFlatCoordinates = [];
        for(let i = 0, ii = flatCoordinates.length; i < ii; i += multiPointGeometry.getStride())if (!this.maxExtent || (0, $7e819822b33b3d32$export$ac68c24d37ca240f)(this.maxExtent, flatCoordinates.slice(i, i + 2))) filteredFlatCoordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatPointCoordinates(filteredFlatCoordinates, 2);
        this.instructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_ * this.imagePixelRatio_,
            this.originY_ * this.imagePixelRatio_,
            this.rotateWithView_,
            this.rotation_,
            [
                this.scale_[0] * this.pixelRatio / this.imagePixelRatio_,
                this.scale_[1] * this.pixelRatio / this.imagePixelRatio_
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            1,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterMode_,
            this.declutterImageWithText_
        ]);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return super.finish();
    }
    /**
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setImageStyle(imageStyle, sharedData) {
        const anchor = imageStyle.getAnchor();
        const size = imageStyle.getSize();
        const origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = imageStyle.getHitDetectionImage();
        this.image_ = imageStyle.getImage(this.pixelRatio);
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterMode_ = imageStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $80668ba8a80e069a$export$2e2bcd8739ae039 = $80668ba8a80e069a$var$CanvasImageBuilder;


/**
 * @module ol/render/canvas/LineStringBuilder
 */ 


class $a80bf01a1cbdbeb1$var$CanvasLineStringBuilder extends (0, $88475e4f65e96675$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   * @return {number} end.
   */ drawFlatCoordinates_(flatCoordinates, offset, end, stride) {
        const myBegin = this.coordinates.length;
        const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        const moveToLineToInstruction = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
            myBegin,
            myEnd
        ];
        this.instructions.push(moveToLineToInstruction);
        this.hitDetectionInstructions.push(moveToLineToInstruction);
        return end;
    }
    /**
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawLineString(lineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc),
            (0, $c8f894129d9fa0b9$export$e06efc2409049f76)
        ], (0, $3b9081ec7a886d58$export$9f746cc58a899a00));
        const flatCoordinates = lineStringGeometry.getFlatCoordinates();
        const stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiLineString(multiLineStringGeometry, feature, index) {
        const state = this.state;
        const strokeStyle = state.strokeStyle;
        const lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) return;
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature, index);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc),
            (0, $c8f894129d9fa0b9$export$e06efc2409049f76)
        ], (0, $3b9081ec7a886d58$export$9f746cc58a899a00));
        const ends = multiLineStringGeometry.getEnds();
        const flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        const stride = multiLineStringGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.drawFlatCoordinates_(flatCoordinates, offset, /** @type {number} */ ends[i], stride);
        this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const state = this.state;
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) this.instructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
        this.reverseHitDetectionInstructions();
        this.state = null;
        return super.finish();
    }
    /**
   * @param {import("../canvas.js").FillStrokeState} state State.
   * @override
   */ applyStroke(state) {
        if (state.lastStroke != undefined && state.lastStroke != this.coordinates.length) {
            this.instructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        super.applyStroke(state);
        this.instructions.push((0, $3b9081ec7a886d58$export$9f746cc58a899a00));
    }
}
var $a80bf01a1cbdbeb1$export$2e2bcd8739ae039 = $a80bf01a1cbdbeb1$var$CanvasLineStringBuilder;


/**
 * @module ol/render/canvas/PolygonBuilder
 */ 



class $e1c184c6dfd1c1e2$var$CanvasPolygonBuilder extends (0, $88475e4f65e96675$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawFlatCoordinatess_(flatCoordinates, offset, ends, stride) {
        const state = this.state;
        const fill = state.fillStyle !== undefined;
        const stroke = state.strokeStyle !== undefined;
        const numEnds = ends.length;
        this.instructions.push((0, $3b9081ec7a886d58$export$9f746cc58a899a00));
        this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$9f746cc58a899a00));
        for(let i = 0; i < numEnds; ++i){
            const end = ends[i];
            const myBegin = this.coordinates.length;
            const myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            const moveToLineToInstruction = [
                (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).MOVE_TO_LINE_TO,
                myBegin,
                myEnd
            ];
            this.instructions.push(moveToLineToInstruction);
            this.hitDetectionInstructions.push(moveToLineToInstruction);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push((0, $3b9081ec7a886d58$export$89b10f327e413e71));
                this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$89b10f327e413e71));
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push((0, $3b9081ec7a886d58$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$f21891651e408226));
        }
        if (stroke) {
            this.instructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
        }
        return offset;
    }
    /**
   * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawCircle(circleGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc),
            (0, $c8f894129d9fa0b9$export$e06efc2409049f76)
        ]);
        const flatCoordinates = circleGeometry.getFlatCoordinates();
        const stride = circleGeometry.getStride();
        const myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        const circleInstruction = [
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CIRCLE,
            myBegin
        ];
        this.instructions.push((0, $3b9081ec7a886d58$export$9f746cc58a899a00), circleInstruction);
        this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$9f746cc58a899a00), circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push((0, $3b9081ec7a886d58$export$f21891651e408226));
            this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$f21891651e408226));
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
            this.hitDetectionInstructions.push((0, $3b9081ec7a886d58$export$7a98aa5364d62ba8));
        }
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawPolygon(polygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc),
            (0, $c8f894129d9fa0b9$export$e06efc2409049f76)
        ]);
        const ends = polygonGeometry.getEnds();
        const flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        const stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, /** @type {Array<number>} */ ends, stride);
        this.endGeometry(feature);
    }
    /**
   * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawMultiPolygon(multiPolygonGeometry, feature, index) {
        const state = this.state;
        const fillStyle = state.fillStyle;
        const strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) return;
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature, index);
        if (state.fillStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_FILL_STYLE,
            (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2)
        ]);
        if (state.strokeStyle !== undefined) this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc),
            (0, $c8f894129d9fa0b9$export$e06efc2409049f76)
        ]);
        const endss = multiPolygonGeometry.getEndss();
        const flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        const stride = multiPolygonGeometry.getStride();
        let offset = 0;
        for(let i = 0, ii = endss.length; i < ii; ++i)offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
        this.endGeometry(feature);
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        const tolerance = this.tolerance;
        if (tolerance !== 0) {
            const coordinates = this.coordinates;
            for(let i = 0, ii = coordinates.length; i < ii; ++i)coordinates[i] = (0, $ab8844daaf207c08$export$51a0620f7a28532b)(coordinates[i], tolerance);
        }
        return super.finish();
    }
    /**
   * @private
   */ setFillStrokeStyles_() {
        const state = this.state;
        const fillStyle = state.fillStyle;
        if (fillStyle !== undefined) this.updateFillStyle(state, this.createFill);
        if (state.strokeStyle !== undefined) this.updateStrokeStyle(state, this.applyStroke);
    }
}
var $e1c184c6dfd1c1e2$export$2e2bcd8739ae039 = $e1c184c6dfd1c1e2$var$CanvasPolygonBuilder;


/**
 * @module ol/render/canvas/TextBuilder
 */ 


function $3830185656f2cba1$export$f08272c6ff321e57(chunkLength, flatCoordinates, offset, end, stride) {
    const chunks = [];
    let cursor = offset;
    let chunkM = 0;
    let currentChunk = flatCoordinates.slice(offset, 2);
    while(chunkM < chunkLength && cursor + stride < end){
        const [x1, y1] = currentChunk.slice(-2);
        const x2 = flatCoordinates[cursor + stride];
        const y2 = flatCoordinates[cursor + stride + 1];
        const segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        chunkM += segmentLength;
        if (chunkM >= chunkLength) {
            const m = (chunkLength - chunkM + segmentLength) / segmentLength;
            const x = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(x1, x2, m);
            const y = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(y1, y2, m);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            if (chunkM == chunkLength) cursor += stride;
            chunkM = 0;
        } else if (chunkM < chunkLength) {
            currentChunk.push(flatCoordinates[cursor + stride], flatCoordinates[cursor + stride + 1]);
            cursor += stride;
        } else {
            const missing = segmentLength - chunkM;
            const x = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(x1, x2, missing / segmentLength);
            const y = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(y1, y2, missing / segmentLength);
            currentChunk.push(x, y);
            chunks.push(currentChunk);
            currentChunk = [
                x,
                y
            ];
            chunkM = 0;
            cursor += stride;
        }
    }
    if (chunkM > 0) chunks.push(currentChunk);
    return chunks;
}


/**
 * @module ol/geom/flat/straightchunk
 */ /**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */ function $5ec5eeea02e3e4f4$export$ed6c897eea07a254(maxAngle, flatCoordinates, offset, end, stride) {
    let chunkStart = offset;
    let chunkEnd = offset;
    let chunkM = 0;
    let m = 0;
    let start = offset;
    let acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for(i = offset; i < end; i += stride){
        const x2 = flatCoordinates[i];
        const y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [
        start,
        i
    ] : [
        chunkStart,
        chunkEnd
    ];
}






const $2c8ff05a23e2f532$export$91a016276e4aee96 = {
    'left': 0,
    'center': 0.5,
    'right': 1,
    'top': 0,
    'middle': 0.5,
    'hanging': 0.2,
    'alphabetic': 0.8,
    'ideographic': 0.8,
    'bottom': 1
};
class $2c8ff05a23e2f532$var$CanvasTextBuilder extends (0, $88475e4f65e96675$export$2e2bcd8739ae039) {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        super(tolerance, maxExtent, resolution, pixelRatio);
        /**
     * @private
     * @type {Array<HTMLCanvasElement>}
     */ this.labels_ = null;
        /**
     * @private
     * @type {string|Array<string>}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textRotateWithView_ = undefined;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.textKeepUpright_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = {};
        this.fillStates[0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2] = {
            fillStyle: (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2)
        };
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = {};
        /**
     * @private
     * @type {import("../canvas.js").TextState}
     */ this.textState_ = /** @type {import("../canvas.js").TextState} */ {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = {};
        /**
     * @private
     * @type {string}
     */ this.textKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.fillKey_ = '';
        /**
     * @private
     * @type {string}
     */ this.strokeKey_ = '';
        /**
     * @private
     * @type {import('../../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = undefined;
        /**
     * Data shared with an image builder for combined decluttering.
     * @private
     * @type {import("../canvas.js").DeclutterImageWithText}
     */ this.declutterImageWithText_ = undefined;
    }
    /**
   * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
   * @override
   */ finish() {
        const instructions = super.finish();
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    }
    /**
   * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @param {number} [index] Render order index.
   * @override
   */ drawText(geometry, feature, index) {
        const fillState = this.textFillState_;
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        if (this.text_ === '' || !textState || !fillState && !strokeState) return;
        const coordinates = this.coordinates;
        let begin = coordinates.length;
        const geometryType = geometry.getType();
        let flatCoordinates = null;
        let stride = geometry.getStride();
        if (textState.placement === 'line' && (geometryType == 'LineString' || geometryType == 'MultiLineString' || geometryType == 'Polygon' || geometryType == 'MultiPolygon')) {
            if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.maxExtent, geometry.getExtent())) return;
            let ends;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == 'LineString') ends = [
                flatCoordinates.length
            ];
            else if (geometryType == 'MultiLineString') ends = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getEnds();
            else if (geometryType == 'Polygon') ends = /** @type {import("../../geom/Polygon.js").default} */ geometry.getEnds().slice(0, 1);
            else if (geometryType == 'MultiPolygon') {
                const endss = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getEndss();
                ends = [];
                for(let i = 0, ii = endss.length; i < ii; ++i)ends.push(endss[i][0]);
            }
            this.beginGeometry(geometry, feature, index);
            const repeat = textState.repeat;
            const textAlign = repeat ? undefined : textState.textAlign;
            // No `justify` support for line placement.
            let flatOffset = 0;
            for(let o = 0, oo = ends.length; o < oo; ++o){
                let chunks;
                if (repeat) chunks = (0, $3830185656f2cba1$export$f08272c6ff321e57)(repeat * this.resolution, flatCoordinates, flatOffset, ends[o], stride);
                else chunks = [
                    flatCoordinates.slice(flatOffset, ends[o])
                ];
                for(let c = 0, cc = chunks.length; c < cc; ++c){
                    const chunk = chunks[c];
                    let chunkBegin = 0;
                    let chunkEnd = chunk.length;
                    if (textAlign == undefined) {
                        const range = (0, $5ec5eeea02e3e4f4$export$ed6c897eea07a254)(textState.maxAngle, chunk, 0, chunk.length, 2);
                        chunkBegin = range[0];
                        chunkEnd = range[1];
                    }
                    for(let i = chunkBegin; i < chunkEnd; i += stride)coordinates.push(chunk[i], chunk[i + 1]);
                    const end = coordinates.length;
                    flatOffset = ends[o];
                    this.drawChars_(begin, end);
                    begin = end;
                }
            }
            this.endGeometry(feature);
        } else {
            let geometryWidths = textState.overflow ? null : [];
            switch(geometryType){
                case 'Point':
                case 'MultiPoint':
                    flatCoordinates = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.getFlatCoordinates();
                    break;
                case 'LineString':
                    flatCoordinates = /** @type {import("../../geom/LineString.js").default} */ geometry.getFlatMidpoint();
                    break;
                case 'Circle':
                    flatCoordinates = /** @type {import("../../geom/Circle.js").default} */ geometry.getCenter();
                    break;
                case 'MultiLineString':
                    flatCoordinates = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.getFlatMidpoints();
                    stride = 2;
                    break;
                case 'Polygon':
                    flatCoordinates = /** @type {import("../../geom/Polygon.js").default} */ geometry.getFlatInteriorPoint();
                    if (!textState.overflow) geometryWidths.push(flatCoordinates[2] / this.resolution);
                    stride = 3;
                    break;
                case 'MultiPolygon':
                    const interiorPoints = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.getFlatInteriorPoints();
                    flatCoordinates = [];
                    for(let i = 0, ii = interiorPoints.length; i < ii; i += 3){
                        if (!textState.overflow) geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) return;
                    stride = 2;
                    break;
                default:
            }
            const end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) return;
            if (geometryWidths && (end - begin) / 2 !== flatCoordinates.length / stride) {
                let beg = begin / 2;
                geometryWidths = geometryWidths.filter((w, i)=>{
                    const keep = coordinates[(beg + i) * 2] === flatCoordinates[i * stride] && coordinates[(beg + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) --beg;
                    return keep;
                });
            }
            this.saveTextStates_();
            const backgroundFill = textState.backgroundFill ? this.createFill(this.fillStyleToState(textState.backgroundFill)) : null;
            const backgroundStroke = textState.backgroundStroke ? this.createStroke(this.strokeStyleToState(textState.backgroundStroke)) : null;
            this.beginGeometry(geometry, feature, index);
            // adjust padding for negative scale
            let padding = textState.padding;
            if (padding != (0, $c8f894129d9fa0b9$export$40a9eeef55665a40) && (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                let p0 = textState.padding[0];
                let p1 = textState.padding[1];
                let p2 = textState.padding[2];
                let p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [
                    p0,
                    p1,
                    p2,
                    p3
                ];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            const pixelRatio = this.pixelRatio;
            this.instructions.push([
                (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    1,
                    1
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding == (0, $c8f894129d9fa0b9$export$40a9eeef55665a40) ? (0, $c8f894129d9fa0b9$export$40a9eeef55665a40) : padding.map(function(p) {
                    return p * pixelRatio;
                }),
                backgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            const scale = 1 / pixelRatio;
            // Set default fill for hit detection background
            const hitDetectionBackgroundFill = backgroundFill ? backgroundFill.slice(0) : null;
            if (hitDetectionBackgroundFill) hitDetectionBackgroundFill[1] = (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2);
            this.hitDetectionInstructions.push([
                (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [
                    scale,
                    scale
                ],
                NaN,
                this.declutterMode_,
                this.declutterImageWithText_,
                padding,
                hitDetectionBackgroundFill,
                backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_ ? (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2) : this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths
            ]);
            this.endGeometry(feature);
        }
    }
    /**
   * @private
   */ saveTextStates_() {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const fillState = this.textFillState_;
        const strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) this.strokeStates[strokeKey] = {
                strokeStyle: strokeState.strokeStyle,
                lineCap: strokeState.lineCap,
                lineDashOffset: strokeState.lineDashOffset,
                lineWidth: strokeState.lineWidth,
                lineJoin: strokeState.lineJoin,
                miterLimit: strokeState.miterLimit,
                lineDash: strokeState.lineDash
            };
        }
        const textKey = this.textKey_;
        if (!(textKey in this.textStates)) this.textStates[textKey] = {
            font: textState.font,
            textAlign: textState.textAlign || (0, $c8f894129d9fa0b9$export$94d53b95641b5766),
            justify: textState.justify,
            textBaseline: textState.textBaseline || (0, $c8f894129d9fa0b9$export$cf2279a1bff62eb),
            scale: textState.scale
        };
        const fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) this.fillStates[fillKey] = {
                fillStyle: fillState.fillStyle
            };
        }
    }
    /**
   * @private
   * @param {number} begin Begin.
   * @param {number} end End.
   */ drawChars_(begin, end) {
        const strokeState = this.textStrokeState_;
        const textState = this.textState_;
        const strokeKey = this.strokeKey_;
        const textKey = this.textKey_;
        const fillKey = this.fillKey_;
        this.saveTextStates_();
        const pixelRatio = this.pixelRatio;
        const baseline = $2c8ff05a23e2f532$export$91a016276e4aee96[textState.textBaseline];
        const offsetY = this.textOffsetY_ * pixelRatio;
        const text = this.text_;
        const strokeWidth = strokeState ? strokeState.lineWidth * Math.abs(textState.scale[0]) / 2 : 0;
        this.instructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
        this.hitDetectionInstructions.push([
            (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey ? (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2) : fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1 / pixelRatio,
            this.declutterMode_,
            this.textKeepUpright_
        ]);
    }
    /**
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @param {Object} [sharedData] Shared data.
   * @override
   */ setTextStyle(textStyle, sharedData) {
        let textState, fillState, strokeState;
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            } else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ {};
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(textFillStyle.getColor() || (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2));
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            } else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ {};
                    this.textStrokeState_ = strokeState;
                }
                const lineDash = textStrokeStyle.getLineDash();
                const lineDashOffset = textStrokeStyle.getLineDashOffset();
                const lineWidth = textStrokeStyle.getWidth();
                const miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e);
                strokeState.lineDash = lineDash ? lineDash.slice() : (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc);
                strokeState.lineDashOffset = lineDashOffset === undefined ? (0, $c8f894129d9fa0b9$export$e06efc2409049f76) : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0);
                strokeState.lineWidth = lineWidth === undefined ? (0, $c8f894129d9fa0b9$export$79661f132c62010e) : lineWidth;
                strokeState.miterLimit = miterLimit === undefined ? (0, $c8f894129d9fa0b9$export$80c1c01844597b7b) : miterLimit;
                strokeState.strokeStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(textStrokeStyle.getColor() || (0, $c8f894129d9fa0b9$export$1eb2eaecacf2031e));
            }
            textState = this.textState_;
            const font = textStyle.getFont() || (0, $c8f894129d9fa0b9$export$3847dfea4f8d4dfa);
            (0, $c8f894129d9fa0b9$export$a534074a28fa87ff)(font);
            const textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.repeat = textStyle.getRepeat();
            textState.justify = textStyle.getJustify();
            textState.textBaseline = textStyle.getTextBaseline() || (0, $c8f894129d9fa0b9$export$cf2279a1bff62eb);
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || (0, $c8f894129d9fa0b9$export$40a9eeef55665a40);
            textState.scale = textScale === undefined ? [
                1,
                1
            ] : textScale;
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textKeepUpright = textStyle.getKeepUpright();
            const textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || '';
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ = textRotateWithView === undefined ? false : textRotateWithView;
            this.textKeepUpright_ = textKeepUpright === undefined ? true : textKeepUpright;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState ? (typeof strokeState.strokeStyle == 'string' ? strokeState.strokeStyle : (0, $34772e91e89a736f$export$5e82334337e0f204)(strokeState.strokeStyle)) + strokeState.lineCap + strokeState.lineDashOffset + '|' + strokeState.lineWidth + strokeState.lineJoin + strokeState.miterLimit + '[' + strokeState.lineDash.join() + ']' : '';
            this.textKey_ = textState.font + textState.scale + (textState.textAlign || '?') + (textState.repeat || '?') + (textState.justify || '?') + (textState.textBaseline || '?');
            this.fillKey_ = fillState && fillState.fillStyle ? typeof fillState.fillStyle == 'string' ? fillState.fillStyle : '|' + (0, $34772e91e89a736f$export$5e82334337e0f204)(fillState.fillStyle) : '';
        }
        this.declutterMode_ = textStyle.getDeclutterMode();
        this.declutterImageWithText_ = sharedData;
    }
}
var $2c8ff05a23e2f532$export$2e2bcd8739ae039 = $2c8ff05a23e2f532$var$CanvasTextBuilder;


/**
 * @type {Object<import("../canvas.js").BuilderType, typeof Builder>}
 */ const $4da051e4cbf4d3d3$var$BATCH_CONSTRUCTORS = {
    'Circle': (0, $e1c184c6dfd1c1e2$export$2e2bcd8739ae039),
    'Default': (0, $88475e4f65e96675$export$2e2bcd8739ae039),
    'Image': (0, $80668ba8a80e069a$export$2e2bcd8739ae039),
    'LineString': (0, $a80bf01a1cbdbeb1$export$2e2bcd8739ae039),
    'Polygon': (0, $e1c184c6dfd1c1e2$export$2e2bcd8739ae039),
    'Text': (0, $2c8ff05a23e2f532$export$2e2bcd8739ae039)
};
class $4da051e4cbf4d3d3$var$BuilderGroup {
    /**
   * @param {number} tolerance Tolerance.
   * @param {import("../../extent.js").Extent} maxExtent Max extent.
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   */ constructor(tolerance, maxExtent, resolution, pixelRatio){
        /**
     * @private
     * @type {number}
     */ this.tolerance_ = tolerance;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {!Object<string, !Object<import("../canvas.js").BuilderType, Builder>>}
     */ this.buildersByZIndex_ = {};
    }
    /**
   * @return {!Object<string, !Object<import("../canvas.js").BuilderType, import("./Builder.js").SerializableInstructions>>} The serializable instructions
   */ finish() {
        const builderInstructions = {};
        for(const zKey in this.buildersByZIndex_){
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            const builders = this.buildersByZIndex_[zKey];
            for(const builderKey in builders){
                const builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    }
    /**
   * @param {number|undefined} zIndex Z index.
   * @param {import("../canvas.js").BuilderType} builderType Replay type.
   * @return {import("../VectorContext.js").default} Replay.
   */ getBuilder(zIndex, builderType) {
        const zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
        let replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        let replay = replays[builderType];
        if (replay === undefined) {
            const Constructor = $4da051e4cbf4d3d3$var$BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    }
}
var $4da051e4cbf4d3d3$export$2e2bcd8739ae039 = $4da051e4cbf4d3d3$var$BuilderGroup;


/**
 * @module ol/render/canvas/ExecutorGroup
 */ 





/**
 * @module ol/render/canvas/Executor
 */ 


/**
 * @module ol/geom/flat/textpath
 */ 

function $d5f14337ff045de9$export$153a9a17ab3e949f(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation, keepUpright = true) {
    let x2 = flatCoordinates[offset];
    let y2 = flatCoordinates[offset + 1];
    let x1 = 0;
    let y1 = 0;
    let segmentLength = 0;
    let segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do advance();
    while (offset < end - stride && segmentM + segmentLength < startM);
    let interpolate = segmentLength === 0 ? 0 : (startM - segmentM) / segmentLength;
    const beginX = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const beginY = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    const startOffset = offset - stride;
    const startLength = segmentM;
    const endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while(offset < end - stride && segmentM + segmentLength < endM)advance();
    interpolate = segmentLength === 0 ? 0 : (endM - segmentM) / segmentLength;
    const endX = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
    const endY = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
    // Keep text upright if the option is selected
    let reverse = false;
    if (keepUpright) {
        if (rotation) {
            const flat = [
                beginX,
                beginY,
                endX,
                endY
            ];
            (0, $24a54079104c80a7$export$bb628a54ab399bc9)(flat, 0, 4, 2, rotation, flat, flat);
            reverse = flat[0] > flat[2];
        } else reverse = beginX > endX;
    }
    const PI = Math.PI;
    const result = [];
    const singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    let previousAngle;
    // All on the same segment
    if (singleSegment) {
        advance();
        previousAngle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) previousAngle += previousAngle > 0 ? -PI : PI;
        const x = (endX + beginX) / 2;
        const y = (endY + beginY) / 2;
        result[0] = [
            x,
            y,
            (endM - startM) / 2,
            previousAngle,
            text
        ];
        return result;
    }
    // rendering across line segments
    text = text.replace(/\n/g, ' '); // ensure rendering in single-line as all calculations below don't handle multi-lines
    for(let i = 0, ii = text.length; i < ii;){
        advance();
        let angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) angle += angle > 0 ? -PI : PI;
        if (previousAngle !== undefined) {
            let delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) return null;
        }
        previousAngle = angle;
        const iStart = i;
        let charLength = 0;
        for(; i < ii; ++i){
            const index = reverse ? ii - i - 1 : i;
            const len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end && segmentM + segmentLength < startM + charLength + len / 2) break;
            charLength += len;
        }
        if (i === iStart) continue;
        const chars = reverse ? text.substring(ii - iStart, ii - i) : text.substring(iStart, i);
        interpolate = segmentLength === 0 ? 0 : (startM + charLength / 2 - segmentM) / segmentLength;
        const x = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(x1, x2, interpolate);
        const y = (0, $d4e56cfc37d8b1f9$export$3a89f8d6f6bf6c9f)(y1, y2, interpolate);
        result.push([
            x,
            y,
            charLength / 2,
            angle,
            chars
        ]);
        startM += charLength;
    }
    return result;
}








/**
 * @typedef {import('../../structs/RBush.js').Entry<import('../../Feature.js').FeatureLike>} DeclutterEntry
 */ /**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {DeclutterEntry} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */ /**
 * @typedef {{0: CanvasRenderingContext2D, 1: import('../../size.js').Size, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */ /**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, import("../../style/Style.js").DeclutterMode): T} FeatureCallback
 */ /**
 * @type {import("../../extent.js").Extent}
 */ const $1ae203851315e6f3$var$tmpExtent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
/** @type {import("../../coordinate.js").Coordinate} */ const $1ae203851315e6f3$var$p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $1ae203851315e6f3$var$p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $1ae203851315e6f3$var$p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */ const $1ae203851315e6f3$var$p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {DeclutterEntry} Declutter rbush entry.
 */ function $1ae203851315e6f3$var$getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
const $1ae203851315e6f3$var$rtlRegEx = new RegExp(/* eslint-disable prettier/prettier */ '[' + String.fromCharCode(0x00591) + '-' + String.fromCharCode(0x008ff) + String.fromCharCode(0x0fb1d) + '-' + String.fromCharCode(0x0fdff) + String.fromCharCode(0x0fe70) + '-' + String.fromCharCode(0x0fefc) + String.fromCharCode(0x10800) + '-' + String.fromCharCode(0x10fff) + String.fromCharCode(0x1e800) + '-' + String.fromCharCode(0x1efff) + ']');
/**
 * @param {string} text Text.
 * @param {CanvasTextAlign} align Alignment.
 * @return {number} Text alignment.
 */ function $1ae203851315e6f3$var$horizontalTextAlign(text, align) {
    if (align === 'start') align = $1ae203851315e6f3$var$rtlRegEx.test(text) ? 'right' : 'left';
    else if (align === 'end') align = $1ae203851315e6f3$var$rtlRegEx.test(text) ? 'left' : 'right';
    return (0, $2c8ff05a23e2f532$export$91a016276e4aee96)[align];
}
/**
 * @param {Array<string>} acc Accumulator.
 * @param {string} line Line of text.
 * @param {number} i Index
 * @return {Array<string>} Accumulator.
 */ function $1ae203851315e6f3$var$createTextChunks(acc, line, i) {
    if (i > 0) acc.push('\n', '');
    acc.push(line, '');
    return acc;
}
class $1ae203851315e6f3$var$Executor {
    /**
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The replay can have overlapping geometries.
   * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions.
   * @param {boolean} [deferredRendering] Enable deferred rendering.
   */ constructor(resolution, pixelRatio, overlaps, instructions, deferredRendering){
        /**
     * @protected
     * @type {boolean}
     */ this.overlaps = overlaps;
        /**
     * @protected
     * @type {number}
     */ this.pixelRatio = pixelRatio;
        /**
     * @protected
     * @const
     * @type {number}
     */ this.resolution = resolution;
        /**
     * @private
     * @type {number}
     */ this.alignAndScaleFill_;
        /**
     * @protected
     * @type {Array<*>}
     */ this.instructions = instructions.instructions;
        /**
     * @protected
     * @type {Array<number>}
     */ this.coordinates = instructions.coordinates;
        /**
     * @private
     * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
     */ this.coordinateCache_ = {};
        /**
     * @private
     * @type {!import("../../transform.js").Transform}
     */ this.renderedTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @protected
     * @type {Array<*>}
     */ this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = null;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = 0;
        /**
     * @type {!Object<string, import("../canvas.js").FillState>}
     */ this.fillStates = instructions.fillStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").StrokeState>}
     */ this.strokeStates = instructions.strokeStates || {};
        /**
     * @type {!Object<string, import("../canvas.js").TextState>}
     */ this.textStates = instructions.textStates || {};
        /**
     * @private
     * @type {Object<string, Object<string, number>>}
     */ this.widths_ = {};
        /**
     * @private
     * @type {Object<string, import("../canvas.js").Label>}
     */ this.labels_ = {};
        /**
     * @private
     * @type {import("../canvas/ZIndexContext.js").default}
     */ this.zIndexContext_ = deferredRendering ? new (0, $effff0602ddf7360$export$2e2bcd8739ae039)() : null;
    }
    /**
   * @return {ZIndexContext} ZIndex context.
   */ getZIndexContext() {
        return this.zIndexContext_;
    }
    /**
   * @param {string|Array<string>} text Text.
   * @param {string} textKey Text style key.
   * @param {string} fillKey Fill style key.
   * @param {string} strokeKey Stroke style key.
   * @return {import("../canvas.js").Label} Label.
   */ createLabel(text, textKey, fillKey, strokeKey) {
        const key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) return this.labels_[key];
        const strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        const fillState = fillKey ? this.fillStates[fillKey] : null;
        const textState = this.textStates[textKey];
        const pixelRatio = this.pixelRatio;
        const scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio
        ];
        const align = textState.justify ? (0, $2c8ff05a23e2f532$export$91a016276e4aee96)[textState.justify] : $1ae203851315e6f3$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $c8f894129d9fa0b9$export$94d53b95641b5766));
        const strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        const chunks = Array.isArray(text) ? text : String(text).split('\n').reduce($1ae203851315e6f3$var$createTextChunks, []);
        const { width: width, height: height, widths: widths, heights: heights, lineWidths: lineWidths } = (0, $c8f894129d9fa0b9$export$7d7c13020df1e791)(textState, chunks);
        const renderWidth = width + strokeWidth;
        const contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        const w = (renderWidth + 2) * scale[0];
        const h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */ const label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions
        };
        if (scale[0] != 1 || scale[1] != 1) contextInstructions.push('scale', scale);
        if (strokeKey) {
            contextInstructions.push('strokeStyle', strokeState.strokeStyle);
            contextInstructions.push('lineWidth', strokeWidth);
            contextInstructions.push('lineCap', strokeState.lineCap);
            contextInstructions.push('lineJoin', strokeState.lineJoin);
            contextInstructions.push('miterLimit', strokeState.miterLimit);
            contextInstructions.push('setLineDash', [
                strokeState.lineDash
            ]);
            contextInstructions.push('lineDashOffset', strokeState.lineDashOffset);
        }
        if (fillKey) contextInstructions.push('fillStyle', fillState.fillStyle);
        contextInstructions.push('textBaseline', 'middle');
        contextInstructions.push('textAlign', 'center');
        const leftRight = 0.5 - align;
        let x = align * renderWidth + leftRight * strokeWidth;
        const strokeInstructions = [];
        const fillInstructions = [];
        let lineHeight = 0;
        let lineOffset = 0;
        let widthHeightIndex = 0;
        let lineWidthIndex = 0;
        let previousFont;
        for(let i = 0, ii = chunks.length; i < ii; i += 2){
            const text = chunks[i];
            if (text === '\n') {
                lineOffset += lineHeight;
                lineHeight = 0;
                x = align * renderWidth + leftRight * strokeWidth;
                ++lineWidthIndex;
                continue;
            }
            const font = chunks[i + 1] || textState.font;
            if (font !== previousFont) {
                if (strokeKey) strokeInstructions.push('font', font);
                if (fillKey) fillInstructions.push('font', font);
                previousFont = font;
            }
            lineHeight = Math.max(lineHeight, heights[widthHeightIndex]);
            const fillStrokeArgs = [
                text,
                x + leftRight * widths[widthHeightIndex] + align * (widths[widthHeightIndex] - lineWidths[lineWidthIndex]),
                0.5 * (strokeWidth + lineHeight) + lineOffset
            ];
            x += widths[widthHeightIndex];
            if (strokeKey) strokeInstructions.push('strokeText', fillStrokeArgs);
            if (fillKey) fillInstructions.push('fillText', fillStrokeArgs);
            ++widthHeightIndex;
        }
        Array.prototype.push.apply(contextInstructions, strokeInstructions);
        Array.prototype.push.apply(contextInstructions, fillInstructions);
        this.labels_[key] = label;
        return label;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
   * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   */ replayTextBackground_(context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignAndScaleFill_ = /** @type {number} */ fillInstruction[2];
            context.fillStyle = /** @type {string} */ fillInstruction[1];
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, /** @type {Array<*>} */ strokeInstruction);
            context.stroke();
        }
    }
    /**
   * @private
   * @param {number} sheetWidth Width of the sprite sheet.
   * @param {number} sheetHeight Height of the sprite sheet.
   * @param {number} centerX X.
   * @param {number} centerY Y.
   * @param {number} width Width.
   * @param {number} height Height.
   * @param {number} anchorX Anchor X.
   * @param {number} anchorY Anchor Y.
   * @param {number} originX Origin X.
   * @param {number} originY Origin Y.
   * @param {number} rotation Rotation.
   * @param {import("../../size.js").Size} scale Scale.
   * @param {boolean} snapToPixel Snap to pixel.
   * @param {Array<number>} padding Padding.
   * @param {boolean} fillStroke Background fill or stroke.
   * @param {import("../../Feature.js").FeatureLike} feature Feature.
   * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
   */ calculateImageOrLabelDimensions_(sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        let x = centerX - anchorX;
        let y = centerY - anchorY;
        const w = width + originX > sheetWidth ? sheetWidth - originX : width;
        const h = height + originY > sheetHeight ? sheetHeight - originY : height;
        const boxW = padding[3] + w * scale[0] + padding[1];
        const boxH = padding[0] + h * scale[1] + padding[2];
        const boxX = x - padding[3];
        const boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            $1ae203851315e6f3$var$p1[0] = boxX;
            $1ae203851315e6f3$var$p4[0] = boxX;
            $1ae203851315e6f3$var$p1[1] = boxY;
            $1ae203851315e6f3$var$p2[1] = boxY;
            $1ae203851315e6f3$var$p2[0] = boxX + boxW;
            $1ae203851315e6f3$var$p3[0] = $1ae203851315e6f3$var$p2[0];
            $1ae203851315e6f3$var$p3[1] = boxY + boxH;
            $1ae203851315e6f3$var$p4[1] = $1ae203851315e6f3$var$p3[1];
        }
        let transform;
        if (rotation !== 0) {
            transform = (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)((0, $2567d97ab31c5663$export$185802fd694ee1f5)(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(transform, $1ae203851315e6f3$var$p1);
            (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(transform, $1ae203851315e6f3$var$p2);
            (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(transform, $1ae203851315e6f3$var$p3);
            (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(transform, $1ae203851315e6f3$var$p4);
            (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(Math.min($1ae203851315e6f3$var$p1[0], $1ae203851315e6f3$var$p2[0], $1ae203851315e6f3$var$p3[0], $1ae203851315e6f3$var$p4[0]), Math.min($1ae203851315e6f3$var$p1[1], $1ae203851315e6f3$var$p2[1], $1ae203851315e6f3$var$p3[1], $1ae203851315e6f3$var$p4[1]), Math.max($1ae203851315e6f3$var$p1[0], $1ae203851315e6f3$var$p2[0], $1ae203851315e6f3$var$p3[0], $1ae203851315e6f3$var$p4[0]), Math.max($1ae203851315e6f3$var$p1[1], $1ae203851315e6f3$var$p2[1], $1ae203851315e6f3$var$p3[1], $1ae203851315e6f3$var$p4[1]), $1ae203851315e6f3$var$tmpExtent);
        } else (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), $1ae203851315e6f3$var$tmpExtent);
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: $1ae203851315e6f3$var$tmpExtent[0],
                minY: $1ae203851315e6f3$var$tmpExtent[1],
                maxX: $1ae203851315e6f3$var$tmpExtent[2],
                maxY: $1ae203851315e6f3$var$tmpExtent[3],
                value: feature
            },
            canvasTransform: transform,
            scale: scale
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
   * @param {ImageOrLabelDimensions} dimensions Dimensions.
   * @param {number} opacity Opacity.
   * @param {Array<*>} fillInstruction Fill instruction.
   * @param {Array<*>} strokeInstruction Stroke instruction.
   * @return {boolean} The image or label was rendered.
   */ replayImageOrLabel_(context, scaledCanvasSize, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        const fillStroke = !!(fillInstruction || strokeInstruction);
        const box = dimensions.declutterBox;
        const strokePadding = strokeInstruction ? strokeInstruction[2] * dimensions.scale[0] / 2 : 0;
        const intersects = box.minX - strokePadding <= scaledCanvasSize[0] && box.maxX + strokePadding >= 0 && box.minY - strokePadding <= scaledCanvasSize[1] && box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) this.replayTextBackground_(context, $1ae203851315e6f3$var$p1, $1ae203851315e6f3$var$p2, $1ae203851315e6f3$var$p3, $1ae203851315e6f3$var$p4, /** @type {Array<*>} */ fillInstruction, /** @type {Array<*>} */ strokeInstruction);
            (0, $c8f894129d9fa0b9$export$3cb6f3a6e49cc0ee)(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   */ fill_(context) {
        const alignAndScale = this.alignAndScaleFill_;
        if (alignAndScale) {
            const origin = (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(this.renderedTransform_, [
                0,
                0
            ]);
            const repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin[0] % repeatSize, origin[1] % repeatSize);
            if (alignAndScale !== 1) context.scale(alignAndScale, alignAndScale);
            context.rotate(this.viewRotation_);
        }
        context.fill();
        if (alignAndScale) context.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {Array<*>} instruction Instruction.
   */ setStrokeStyle_(context, instruction) {
        context.strokeStyle = /** @type {import("../../colorlike.js").ColorLike} */ instruction[1];
        context.lineWidth = /** @type {number} */ instruction[2];
        context.lineCap = /** @type {CanvasLineCap} */ instruction[3];
        context.lineJoin = /** @type {CanvasLineJoin} */ instruction[4];
        context.miterLimit = /** @type {number} */ instruction[5];
        context.lineDashOffset = /** @type {number} */ instruction[7];
        context.setLineDash(/** @type {Array<number>} */ instruction[6]);
    }
    /**
   * @private
   * @param {string|Array<string>} text The text to draw.
   * @param {string} textKey The key of the text state.
   * @param {string} strokeKey The key for the stroke state.
   * @param {string} fillKey The key for the fill state.
   * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
   */ drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey) {
        const textState = this.textStates[textKey];
        const label = this.createLabel(text, textKey, fillKey, strokeKey);
        const strokeState = this.strokeStates[strokeKey];
        const pixelRatio = this.pixelRatio;
        const align = $1ae203851315e6f3$var$horizontalTextAlign(Array.isArray(text) ? text[0] : text, textState.textAlign || (0, $c8f894129d9fa0b9$export$94d53b95641b5766));
        const baseline = (0, $2c8ff05a23e2f532$export$91a016276e4aee96)[textState.textBaseline || (0, $c8f894129d9fa0b9$export$cf2279a1bff62eb)];
        const strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        const width = label.width / pixelRatio - 2 * textState.scale[0];
        const anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        const anchorY = baseline * label.height / pixelRatio + 2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {Array<*>} instructions Instructions array.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   * @return {T|undefined} Callback result.
   * @template T
   */ execute_(context, scaledCanvasSize, transform, instructions, snapToPixel, featureCallback, hitExtent, declutterTree) {
        const zIndexContext = this.zIndexContext_;
        /** @type {Array<number>} */ let pixelCoordinates;
        if (this.pixelCoordinates_ && (0, $830d23b8323fc080$export$e9bab7fafb253603)(transform, this.renderedTransform_)) pixelCoordinates = this.pixelCoordinates_;
        else {
            if (!this.pixelCoordinates_) this.pixelCoordinates_ = [];
            pixelCoordinates = (0, $24a54079104c80a7$export$b92b2dedcfff79de)(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            (0, $2567d97ab31c5663$export$42b4187a82d80ed0)(this.renderedTransform_, transform);
        }
        let i = 0; // instruction index
        const ii = instructions.length; // end of instructions
        let d = 0; // data index
        let dd; // end of per-instruction data
        let anchorX, anchorY, /** @type {import('../../style/Style.js').DeclutterMode} */ declutterMode, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        let pendingFill = 0;
        let pendingStroke = 0;
        const coordinateCache = this.coordinateCache_;
        const viewRotation = this.viewRotation_;
        const viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        const state = /** @type {import("../../render.js").State} */ {
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation
        };
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        const batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        let /** @type {import("../../Feature.js").FeatureLike} */ feature;
        let x, y, currentGeometry;
        while(i < ii){
            const instruction = instructions[i];
            const type = /** @type {import("./Instruction.js").default} */ instruction[0];
            switch(type){
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) i = /** @type {number} */ instruction[2];
                    else if (hitExtent !== undefined && !(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(hitExtent, currentGeometry.getExtent())) i = /** @type {number} */ instruction[2] + 1;
                    else ++i;
                    if (zIndexContext) zIndexContext.zIndex = instruction[4];
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CIRCLE:
                    d = /** @type {number} */ instruction[1];
                    const x1 = pixelCoordinates[d];
                    const y1 = pixelCoordinates[d + 1];
                    const x2 = pixelCoordinates[d + 2];
                    const y2 = pixelCoordinates[d + 3];
                    const dx = x2 - x1;
                    const dy = y2 - y1;
                    const r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).CUSTOM:
                    d = /** @type {number} */ instruction[1];
                    dd = instruction[2];
                    const geometry = /** @type {import("../../geom/SimpleGeometry.js").default} */ instruction[3];
                    const renderer = instruction[4];
                    const fn = instruction[5];
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) coordinateCache[i] = [];
                    const coords = coordinateCache[i];
                    if (fn) fn(pixelCoordinates, d, dd, 2, coords);
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    if (zIndexContext) zIndexContext.zIndex = instruction[6];
                    renderer(coords, state);
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_IMAGE:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    image = /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ instruction[3];
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ instruction[4];
                    anchorY = /** @type {number} */ instruction[5];
                    let height = /** @type {number} */ instruction[6];
                    const opacity = /** @type {number} */ instruction[7];
                    const originX = /** @type {number} */ instruction[8];
                    const originY = /** @type {number} */ instruction[9];
                    const rotateWithView = /** @type {boolean} */ instruction[10];
                    let rotation = /** @type {number} */ instruction[11];
                    const scale = /** @type {import("../../size.js").Size} */ instruction[12];
                    let width = /** @type {number} */ instruction[13];
                    declutterMode = instruction[14] || 'declutter';
                    const declutterImageWithText = /** @type {{args: import("../canvas.js").DeclutterImageWithText, declutterMode: import('../../style/Style.js').DeclutterMode}} */ instruction[15];
                    if (!image && instruction.length >= 20) {
                        // create label images
                        text = /** @type {string} */ instruction[19];
                        textKey = /** @type {string} */ instruction[20];
                        strokeKey = /** @type {string} */ instruction[21];
                        fillKey = /** @type {string} */ instruction[22];
                        const labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        const textOffsetX = /** @type {number} */ instruction[23];
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        const textOffsetY = /** @type {number} */ instruction[24];
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    let geometryWidths;
                    if (instruction.length > 25) geometryWidths = /** @type {number} */ instruction[25];
                    let padding, backgroundFillInstruction, backgroundStrokeInstruction;
                    if (instruction.length > 17) {
                        padding = /** @type {Array<number>} */ instruction[16];
                        backgroundFillInstruction = /** @type {Array<*>} */ instruction[17];
                        backgroundStrokeInstruction = /** @type {Array<*>} */ instruction[18];
                    } else {
                        padding = (0, $c8f894129d9fa0b9$export$40a9eeef55665a40);
                        backgroundFillInstruction = null;
                        backgroundStrokeInstruction = null;
                    }
                    if (rotateWithView && viewRotationFromTransform) // Canvas is expected to be rotated to reverse view rotation.
                    rotation += viewRotation;
                    else if (!rotateWithView && !viewRotationFromTransform) // Canvas is not rotated, images need to be rotated back to be north-up.
                    rotation -= viewRotation;
                    let widthIndex = 0;
                    for(; d < dd; d += 2){
                        if (geometryWidths && geometryWidths[widthIndex++] < width / this.pixelRatio) continue;
                        const dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, !!backgroundFillInstruction || !!backgroundStrokeInstruction, feature);
                        /** @type {ReplayImageOrLabelArgs} */ const args = [
                            context,
                            scaledCanvasSize,
                            image,
                            dimensions,
                            opacity,
                            backgroundFillInstruction,
                            backgroundStrokeInstruction
                        ];
                        if (declutterTree) {
                            let imageArgs, imageDeclutterMode, imageDeclutterBox;
                            if (declutterImageWithText) {
                                const index = dd - d;
                                if (!declutterImageWithText[index]) {
                                    // We now have the image for an image+text combination.
                                    declutterImageWithText[index] = {
                                        args: args,
                                        declutterMode: declutterMode
                                    };
                                    continue;
                                }
                                const imageDeclutter = declutterImageWithText[index];
                                imageArgs = imageDeclutter.args;
                                imageDeclutterMode = imageDeclutter.declutterMode;
                                delete declutterImageWithText[index];
                                imageDeclutterBox = $1ae203851315e6f3$var$getDeclutterBox(imageArgs);
                            }
                            // We now have image and text for an image+text combination.
                            let renderImage, renderText;
                            if (imageArgs && (imageDeclutterMode !== 'declutter' || !declutterTree.collides(imageDeclutterBox))) renderImage = true;
                            if (declutterMode !== 'declutter' || !declutterTree.collides(dimensions.declutterBox)) renderText = true;
                            if (imageDeclutterMode === 'declutter' && declutterMode === 'declutter') {
                                const render = renderImage && renderText;
                                renderImage = render;
                                renderText = render;
                            }
                            if (renderImage) {
                                if (imageDeclutterMode !== 'none') declutterTree.insert(imageDeclutterBox);
                                this.replayImageOrLabel_.apply(this, imageArgs);
                            }
                            if (renderText) {
                                if (declutterMode !== 'none') declutterTree.insert(dimensions.declutterBox);
                                this.replayImageOrLabel_.apply(this, args);
                            }
                        } else this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).DRAW_CHARS:
                    const begin = /** @type {number} */ instruction[1];
                    const end = /** @type {number} */ instruction[2];
                    const baseline = /** @type {number} */ instruction[3];
                    const overflow = /** @type {number} */ instruction[4];
                    fillKey = /** @type {string} */ instruction[5];
                    const maxAngle = /** @type {number} */ instruction[6];
                    const measurePixelRatio = /** @type {number} */ instruction[7];
                    const offsetY = /** @type {number} */ instruction[8];
                    strokeKey = /** @type {string} */ instruction[9];
                    const strokeWidth = /** @type {number} */ instruction[10];
                    text = /** @type {string} */ instruction[11];
                    textKey = /** @type {string} */ instruction[12];
                    const pixelRatioScale = [
                        /** @type {number} */ instruction[13],
                        /** @type {number} */ instruction[13]
                    ];
                    declutterMode = instruction[14] || 'declutter';
                    const textKeepUpright = /** @type {boolean} */ instruction[15];
                    const textState = this.textStates[textKey];
                    const font = textState.font;
                    const textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio
                    ];
                    let cachedWidths;
                    if (font in this.widths_) cachedWidths = this.widths_[font];
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    const pathLength = (0, $f01092ea270954d4$export$153f8c6b4d8caebc)(pixelCoordinates, begin, end, 2);
                    const textLength = Math.abs(textScale[0]) * (0, $c8f894129d9fa0b9$export$915c7ba51467308f)(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        const textAlign = this.textStates[textKey].textAlign;
                        const startM = (pathLength - textLength) * $1ae203851315e6f3$var$horizontalTextAlign(text, textAlign);
                        const parts = (0, $d5f14337ff045de9$export$153a9a17ab3e949f)(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), (0, $c8f894129d9fa0b9$export$915c7ba51467308f), font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_, textKeepUpright);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */ const replayImageOrLabelArgs = [];
                            let c, cc, chars, label, part;
                            if (strokeKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, '', strokeKey);
                                anchorX = /** @type {number} */ part[2] + (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                anchorY = baseline * label.height + (0.5 - baseline) * 2 * strokeWidth * textScale[1] / textScale[0] - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $c8f894129d9fa0b9$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (fillKey) for(c = 0, cc = parts.length; c < cc; ++c){
                                part = parts[c]; // x, y, anchorX, rotation, chunk
                                chars = /** @type {string} */ part[4];
                                label = this.createLabel(chars, textKey, fillKey, '');
                                anchorX = /** @type {number} */ part[2];
                                anchorY = baseline * label.height - offsetY;
                                const dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, (0, $c8f894129d9fa0b9$export$40a9eeef55665a40), false, feature);
                                if (declutterTree && declutterMode === 'declutter' && declutterTree.collides(dimensions.declutterBox)) break drawChars;
                                replayImageOrLabelArgs.push([
                                    context,
                                    scaledCanvasSize,
                                    label,
                                    dimensions,
                                    1,
                                    null,
                                    null
                                ]);
                            }
                            if (declutterTree && declutterMode !== 'none') declutterTree.load(replayImageOrLabelArgs.map($1ae203851315e6f3$var$getDeclutterBox));
                            for(let i = 0, ii = replayImageOrLabelArgs.length; i < ii; ++i)this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i]);
                        }
                    }
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).END_GEOMETRY:
                    if (featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ instruction[1];
                        const result = featureCallback(feature, currentGeometry, declutterMode);
                        if (result) return result;
                    }
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).FILL:
                    if (batchSize) pendingFill++;
                    else this.fill_(context);
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).MOVE_TO_LINE_TO:
                    d = /** @type {number} */ instruction[1];
                    dd = /** @type {number} */ instruction[2];
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    context.moveTo(x, y);
                    prevX = x + 0.5 | 0;
                    prevY = y + 0.5 | 0;
                    for(d += 2; d < dd; d += 2){
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = x + 0.5 | 0;
                        roundY = y + 0.5 | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_FILL_STYLE:
                    this.alignAndScaleFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    /** @type {import("../../colorlike.js").ColorLike} */ context.fillStyle = instruction[1];
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).SET_STROKE_STYLE:
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ instruction);
                    ++i;
                    break;
                case (0, $3b9081ec7a886d58$export$2e2bcd8739ae039).STROKE:
                    if (batchSize) pendingStroke++;
                    else context.stroke();
                    ++i;
                    break;
                default:
                    ++i;
                    break;
            }
        }
        if (pendingFill) this.fill_(context);
        if (pendingStroke) context.stroke();
        return undefined;
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scaled canvas size.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
   * @param {import("rbush").default<DeclutterEntry>} [declutterTree] Declutter tree.
   */ execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, scaledCanvasSize, transform, this.instructions, snapToPixel, undefined, undefined, declutterTree);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {FeatureCallback<T>} [featureCallback] Feature callback.
   * @param {import("../../extent.js").Extent} [hitExtent] Only check
   *     features that intersect this extent.
   * @return {T|undefined} Callback result.
   * @template T
   */ executeHitDetection(context, transform, viewRotation, featureCallback, hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, [
            context.canvas.width,
            context.canvas.height
        ], transform, this.hitDetectionInstructions, true, featureCallback, hitExtent);
    }
}
var $1ae203851315e6f3$export$2e2bcd8739ae039 = $1ae203851315e6f3$var$Executor;


const $f979fbd3c953bca1$export$61b49a5ae59d663 = [
    'Polygon',
    'Circle',
    'LineString',
    'Image',
    'Text',
    'Default'
];
const $f979fbd3c953bca1$export$6195a93a6c97ce02 = [
    'Image',
    'Text'
];
const $f979fbd3c953bca1$export$d0fe61ccfaa1ca87 = $f979fbd3c953bca1$export$61b49a5ae59d663.filter((builderType)=>!$f979fbd3c953bca1$export$6195a93a6c97ce02.includes(builderType));
class $f979fbd3c953bca1$var$ExecutorGroup {
    /**
   * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
   * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
   * should be set here, unless the target context does not exceed that extent (which
   * can be the case when rendering to tiles).
   * @param {number} resolution Resolution.
   * @param {number} pixelRatio Pixel ratio.
   * @param {boolean} overlaps The executor group can have overlapping geometries.
   * @param {!Object<string, !Object<import("../canvas.js").BuilderType, import("../canvas.js").SerializableInstructions>>} allInstructions
   * The serializable instructions.
   * @param {number} [renderBuffer] Optional rendering buffer.
   * @param {boolean} [deferredRendering] Enable deferred rendering with renderDeferred().
   */ constructor(maxExtent, resolution, pixelRatio, overlaps, allInstructions, renderBuffer, deferredRendering){
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.maxExtent_ = maxExtent;
        /**
     * @private
     * @type {boolean}
     */ this.overlaps_ = overlaps;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {number}
     */ this.resolution_ = resolution;
        /**
     * @private
     * @type {number|undefined}
     */ this.renderBuffer_ = renderBuffer;
        /**
     * @private
     * @type {!Object<string, !Object<string, import("./Executor").default>>}
     */ this.executorsByZIndex_ = {};
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.hitDetectionContext_ = null;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.hitDetectionTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.renderedContext_ = null;
        /**
     * @private
     * @type {Object<number, Array<import("./ZIndexContext.js").default>>}
     */ this.deferredZIndexContexts_ = {};
        this.createExecutors_(allInstructions, deferredRendering);
    }
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {import("../../transform.js").Transform} transform Transform.
   */ clip(context, transform) {
        const flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    }
    /**
   * Create executors and populate them using the provided instructions.
   * @private
   * @param {!Object<string, !Object<string, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
   * @param {boolean} deferredRendering Enable deferred rendering.
   */ createExecutors_(allInstructions, deferredRendering) {
        for(const zIndex in allInstructions){
            let executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            const instructionByZindex = allInstructions[zIndex];
            for(const builderType in instructionByZindex){
                const instructions = instructionByZindex[builderType];
                executors[builderType] = new (0, $1ae203851315e6f3$export$2e2bcd8739ae039)(this.resolution_, this.pixelRatio_, this.overlaps_, instructions, deferredRendering);
            }
        }
    }
    /**
   * @param {Array<import("../canvas.js").BuilderType>} executors Executors.
   * @return {boolean} Has executors of the provided types.
   */ hasExecutors(executors) {
        for(const zIndex in this.executorsByZIndex_){
            const candidates = this.executorsByZIndex_[zIndex];
            for(let i = 0, ii = executors.length; i < ii; ++i){
                if (executors[i] in candidates) return true;
            }
        }
        return false;
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {number} resolution Resolution.
   * @param {number} rotation Rotation.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
   * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
   * @return {T|undefined} Callback result.
   * @template T
   */ forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        hitTolerance = Math.round(hitTolerance);
        const contextSize = hitTolerance * 2 + 1;
        const transform = (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        const newContext = !this.hitDetectionContext_;
        if (newContext) this.hitDetectionContext_ = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(contextSize, contextSize, undefined, {
            willReadFrequently: true
        });
        const context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize || context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        } else if (!newContext) context.clearRect(0, 0, contextSize, contextSize);
        /** @type {import("../../extent.js").Extent|undefined} */ let hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
            (0, $7e819822b33b3d32$export$1f820e3920fa5715)(hitExtent, coordinate);
            (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        const indexes = $f979fbd3c953bca1$export$96fc84ea21b8269f(hitTolerance);
        /** @type {import("../canvas.js").BuilderType} */ let builderType;
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import('../../style/Style.js').DeclutterMode} declutterMode Declutter mode.
     * @return {T|undefined} Callback result.
     */ function featureCallback(feature, geometry, declutterMode) {
            const imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for(let i = 0, ii = indexes.length; i < ii; i++)if (imageData[indexes[i]] > 0) {
                if (!declutteredFeatures || declutterMode === 'none' || builderType !== 'Image' && builderType !== 'Text' || declutteredFeatures.includes(feature)) {
                    const idx = (indexes[i] - 3) / 4;
                    const x = hitTolerance - idx % contextSize;
                    const y = hitTolerance - (idx / contextSize | 0);
                    const result = callback(feature, geometry, x * x + y * y);
                    if (result) return result;
                }
                context.clearRect(0, 0, contextSize, contextSize);
                break;
            }
            return undefined;
        }
        /** @type {Array<number>} */ const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort((0, $830d23b8323fc080$export$fcb633242ef15540));
        let i, j, executors, executor, result;
        for(i = zs.length - 1; i >= 0; --i){
            const zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for(j = $f979fbd3c953bca1$export$61b49a5ae59d663.length - 1; j >= 0; --j){
                builderType = $f979fbd3c953bca1$export$61b49a5ae59d663[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) return result;
                }
            }
        }
        return undefined;
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   * @return {Array<number>|null} Clip coordinates.
   */ getClipCoords(transform) {
        const maxExtent = this.maxExtent_;
        if (!maxExtent) return null;
        const minX = maxExtent[0];
        const minY = maxExtent[1];
        const maxX = maxExtent[2];
        const maxY = maxExtent[3];
        const flatClipCoords = [
            minX,
            minY,
            minX,
            maxY,
            maxX,
            maxY,
            maxX,
            minY
        ];
        (0, $24a54079104c80a7$export$b92b2dedcfff79de)(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return (0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(this.executorsByZIndex_);
    }
    /**
   * @param {CanvasRenderingContext2D} targetContext Context.
   * @param {import('../../size.js').Size} scaledCanvasSize Scale of the context.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
   * @param {Array<import("../canvas.js").BuilderType>} [builderTypes] Ordered replay types to replay.
   *     Default is {@link module:ol/render/replay~ALL}
   * @param {import("rbush").default<import('./Executor.js').DeclutterEntry>|null} [declutterTree] Declutter tree.
   *     When set to null, no decluttering is done, even when the executor group has a `ZIndexContext`.
   */ execute(targetContext, scaledCanvasSize, transform, viewRotation, snapToPixel, builderTypes, declutterTree) {
        const zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort(declutterTree ? (0, $830d23b8323fc080$export$4fa3190a997c3d8f) : (0, $830d23b8323fc080$export$fcb633242ef15540));
        builderTypes = builderTypes ? builderTypes : $f979fbd3c953bca1$export$61b49a5ae59d663;
        const maxBuilderTypes = $f979fbd3c953bca1$export$61b49a5ae59d663.length;
        for(let i = 0, ii = zs.length; i < ii; ++i){
            const zIndexKey = zs[i].toString();
            const replays = this.executorsByZIndex_[zIndexKey];
            for(let j = 0, jj = builderTypes.length; j < jj; ++j){
                const builderType = builderTypes[j];
                const replay = replays[builderType];
                if (replay !== undefined) {
                    const zIndexContext = declutterTree === null ? undefined : replay.getZIndexContext();
                    const context = zIndexContext ? zIndexContext.getContext() : targetContext;
                    const requireClip = this.maxExtent_ && builderType !== 'Image' && builderType !== 'Text';
                    if (requireClip) {
                        context.save();
                        // setup clipping so that the parts of over-simplified geometries are not
                        // visible outside the current extent when panning
                        this.clip(context, transform);
                    }
                    if (!zIndexContext || builderType === 'Text' || builderType === 'Image') replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree);
                    else zIndexContext.pushFunction((context)=>replay.execute(context, scaledCanvasSize, transform, viewRotation, snapToPixel, declutterTree));
                    if (requireClip) context.restore();
                    if (zIndexContext) {
                        zIndexContext.offset();
                        const index = zs[i] * maxBuilderTypes + j;
                        if (!this.deferredZIndexContexts_[index]) this.deferredZIndexContexts_[index] = [];
                        this.deferredZIndexContexts_[index].push(zIndexContext);
                    }
                }
            }
        }
        this.renderedContext_ = targetContext;
    }
    getDeferredZIndexContexts() {
        return this.deferredZIndexContexts_;
    }
    getRenderedContext() {
        return this.renderedContext_;
    }
    renderDeferred() {
        const deferredZIndexContexts = this.deferredZIndexContexts_;
        const zs = Object.keys(deferredZIndexContexts).map(Number).sort((0, $830d23b8323fc080$export$fcb633242ef15540));
        for(let i = 0, ii = zs.length; i < ii; ++i){
            deferredZIndexContexts[zs[i]].forEach((zIndexContext)=>{
                zIndexContext.draw(this.renderedContext_); // FIXME Pass clip to replay for temporarily enabling clip
                zIndexContext.clear();
            });
            deferredZIndexContexts[zs[i]].length = 0;
        }
    }
}
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */ const $f979fbd3c953bca1$var$circlePixelIndexArrayCache = {};
function $f979fbd3c953bca1$export$96fc84ea21b8269f(radius) {
    if ($f979fbd3c953bca1$var$circlePixelIndexArrayCache[radius] !== undefined) return $f979fbd3c953bca1$var$circlePixelIndexArrayCache[radius];
    const size = radius * 2 + 1;
    const maxDistanceSq = radius * radius;
    const distances = new Array(maxDistanceSq + 1);
    for(let i = 0; i <= radius; ++i)for(let j = 0; j <= radius; ++j){
        const distanceSq = i * i + j * j;
        if (distanceSq > maxDistanceSq) break;
        let distance = distances[distanceSq];
        if (!distance) {
            distance = [];
            distances[distanceSq] = distance;
        }
        distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
        if (i > 0) distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
        if (j > 0) {
            distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
            if (i > 0) distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
        }
    }
    const pixelIndex = [];
    for(let i = 0, ii = distances.length; i < ii; ++i)if (distances[i]) pixelIndex.push(...distances[i]);
    $f979fbd3c953bca1$var$circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
var $f979fbd3c953bca1$export$2e2bcd8739ae039 = $f979fbd3c953bca1$var$ExecutorGroup;


/**
 * @module ol/render/canvas/hitdetect
 */ 




/**
 * @module ol/style/Icon
 */ 





/**
 * @module ol/style/Image
 */ 

/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 * @property {import('../style/Style.js').DeclutterMode} declutterMode Declutter mode: `declutter`, `obstacle`, `none`.
 */ /**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */ class $982c1d3baf3da6dc$var$ImageStyle {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        /**
     * @private
     * @type {number}
     */ this.opacity_ = options.opacity;
        /**
     * @private
     * @type {boolean}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {number}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {number|import("../size.js").Size}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(options.scale);
        /**
     * @private
     * @type {Array<number>}
     */ this.displacement_ = options.displacement;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {ImageStyle} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $982c1d3baf3da6dc$var$ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the symbolizer opacity.
   * @return {number} Opacity.
   * @api
   */ getOpacity() {
        return this.opacity_;
    }
    /**
   * Determine whether the symbolizer rotates with the map.
   * @return {boolean} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Get the symoblizer rotation.
   * @return {number} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the symbolizer scale.
   * @return {number|import("../size.js").Size} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the displacement of the shape
   * @return {Array<number>} Shape's center displacement
   * @api
   */ getDisplacement() {
        return this.displacement_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @abstract
   * @return {Array<number>} Anchor.
   */ getAnchor() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Get the image element for the symbolizer.
   * @abstract
   * @param {number} pixelRatio Pixel ratio.
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getImage(pixelRatio) {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import('../DataTile.js').ImageLike} Image element.
   */ getHitDetectionImage() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   */ getPixelRatio(pixelRatio) {
        return 1;
    }
    /**
   * @abstract
   * @return {import("../ImageState.js").default} Image state.
   */ getImageState() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @return {import("../size.js").Size} Image size.
   */ getImageSize() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Get the origin of the symbolizer.
   * @abstract
   * @return {Array<number>} Origin.
   */ getOrigin() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @abstract
   * @return {import("../size.js").Size} Size.
   */ getSize() {
        return (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Set the displacement.
   *
   * @param {Array<number>} displacement Displacement.
   * @api
   */ setDisplacement(displacement) {
        this.displacement_ = displacement;
    }
    /**
   * Set the opacity.
   *
   * @param {number} opacity Opacity.
   * @api
   */ setOpacity(opacity) {
        this.opacity_ = opacity;
    }
    /**
   * Set whether to rotate the style with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set the rotation.
   *
   * @param {number} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(scale);
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ listenImageChange(listener) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * Load not yet loaded URI.
   * @abstract
   */ load() {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @abstract
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   */ unlistenImageChange(listener) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @return {Promise<void>} `false` or Promise that resolves when the style is ready to use.
   */ ready() {
        return Promise.resolve();
    }
}
var $982c1d3baf3da6dc$export$2e2bcd8739ae039 = $982c1d3baf3da6dc$var$ImageStyle;


/**
 * @typedef {'fraction' | 'pixels'} IconAnchorUnits
 * Anchor unit can be either a fraction of the icon size or in pixels.
 */ /**
 * @typedef {'bottom-left' | 'bottom-right' | 'top-left' | 'top-right'} IconOrigin
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 */ /**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {IconOrigin} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {IconAnchorUnits} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {IconAnchorUnits} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement|ImageBitmap} [img] Image object for the icon.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the icon in pixels.
 * Positive values will shift the icon right and up.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number} [width] The width of the icon in pixels. This can't be used together with `scale`.
 * @property {number} [height] The height of the icon in pixels. This can't be used together with `scale`.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {Array<number>} [offset=[0, 0]] Offset which, together with `size` and `offsetOrigin`, defines the
 * sub-rectangle to use from the original (sprite) image.
 * @property {IconOrigin} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("../size.js").Size} [size] Icon size in pixels. Used together with `offset` to define the
 * sub-rectangle to use from the original (sprite) image.
 * @property {string} [src] Image source URI.
 * @property {import("./Style.js").DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @param {number} width The width.
 * @param {number} height The height.
 * @param {number|undefined} wantedWidth The wanted width.
 * @param {number|undefined} wantedHeight The wanted height.
 * @return {number|Array<number>} The scale.
 */ function $44e8bfd96871175f$var$calculateScale(width, height, wantedWidth, wantedHeight) {
    if (wantedWidth !== undefined && wantedHeight !== undefined) return [
        wantedWidth / width,
        wantedHeight / height
    ];
    if (wantedWidth !== undefined) return wantedWidth / width;
    if (wantedHeight !== undefined) return wantedHeight / height;
    return 1;
}
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */ class $44e8bfd96871175f$var$Icon extends (0, $982c1d3baf3da6dc$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @type {number}
     */ const opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
     * @type {number}
     */ const rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
     * @type {number|import("../size.js").Size}
     */ const scale = options.scale !== undefined ? options.scale : 1;
        /**
     * @type {boolean}
     */ const rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        super({
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            rotateWithView: rotateWithView,
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {Array<number>}
     */ this.anchor_ = options.anchor !== undefined ? options.anchor : [
            0.5,
            0.5
        ];
        /**
     * @private
     * @type {Array<number>}
     */ this.normalizedAnchor_ = null;
        /**
     * @private
     * @type {IconOrigin}
     */ this.anchorOrigin_ = options.anchorOrigin !== undefined ? options.anchorOrigin : 'top-left';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorXUnits_ = options.anchorXUnits !== undefined ? options.anchorXUnits : 'fraction';
        /**
     * @private
     * @type {IconAnchorUnits}
     */ this.anchorYUnits_ = options.anchorYUnits !== undefined ? options.anchorYUnits : 'fraction';
        /**
     * @private
     * @type {?string}
     */ this.crossOrigin_ = options.crossOrigin !== undefined ? options.crossOrigin : null;
        const image = options.img !== undefined ? options.img : null;
        let cacheKey = options.src;
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!(cacheKey !== undefined && image), '`image` and `src` cannot be provided at the same time');
        if ((cacheKey === undefined || cacheKey.length === 0) && image) cacheKey = /** @type {HTMLImageElement} */ image.src || (0, $34772e91e89a736f$export$5e82334337e0f204)(image);
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(cacheKey !== undefined && cacheKey.length > 0, 'A defined and non-empty `src` or `image` must be provided');
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!((options.width !== undefined || options.height !== undefined) && options.scale !== undefined), '`width` or `height` cannot be provided together with `scale`');
        let imageState;
        if (options.src !== undefined) imageState = (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE;
        else if (image !== undefined) {
            if ('complete' in image) {
                if (image.complete) imageState = image.src ? (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED : (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE;
                else imageState = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING;
            } else imageState = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
        }
        /**
     * @private
     * @type {import("../color.js").Color}
     */ this.color_ = options.color !== undefined ? (0, $2c17bfc916c8f689$export$75093a47a9fa838d)(options.color) : null;
        /**
     * @private
     * @type {import("./IconImage.js").default}
     */ this.iconImage_ = (0, $33bba60ac8fc0af6$export$3988ae62b71be9a3)(image, /** @type {string} */ cacheKey, this.crossOrigin_, imageState, this.color_);
        /**
     * @private
     * @type {Array<number>}
     */ this.offset_ = options.offset !== undefined ? options.offset : [
            0,
            0
        ];
        /**
     * @private
     * @type {IconOrigin}
     */ this.offsetOrigin_ = options.offsetOrigin !== undefined ? options.offsetOrigin : 'top-left';
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_ = options.size !== undefined ? options.size : null;
        /**
     * @private
     */ this.initialOptions_;
        /**
     * Calculate the scale if width or height were given.
     */ if (options.width !== undefined || options.height !== undefined) {
            let width, height;
            if (options.size) [width, height] = options.size;
            else {
                const image = this.getImage(1);
                if (image.width && image.height) {
                    width = image.width;
                    height = image.height;
                } else if (image instanceof HTMLImageElement) {
                    this.initialOptions_ = options;
                    const onload = ()=>{
                        this.unlistenImageChange(onload);
                        if (!this.initialOptions_) return;
                        const imageSize = this.iconImage_.getSize();
                        this.setScale($44e8bfd96871175f$var$calculateScale(imageSize[0], imageSize[1], options.width, options.height));
                    };
                    this.listenImageChange(onload);
                    return;
                }
            }
            if (width !== undefined) this.setScale($44e8bfd96871175f$var$calculateScale(width, height, options.width, options.height));
        }
    }
    /**
   * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
   * @return {Icon} The cloned style.
   * @api
   * @override
   */ clone() {
        let scale, width, height;
        if (this.initialOptions_) {
            width = this.initialOptions_.width;
            height = this.initialOptions_.height;
        } else {
            scale = this.getScale();
            scale = Array.isArray(scale) ? scale.slice() : scale;
        }
        return new $44e8bfd96871175f$var$Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            color: this.color_ && this.color_.slice ? this.color_.slice() : this.color_ || undefined,
            crossOrigin: this.crossOrigin_,
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            opacity: this.getOpacity(),
            rotateWithView: this.getRotateWithView(),
            rotation: this.getRotation(),
            scale: scale,
            width: width,
            height: height,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            src: this.getSrc(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        let anchor = this.normalizedAnchor_;
        if (!anchor) {
            anchor = this.anchor_;
            const size = this.getSize();
            if (this.anchorXUnits_ == 'fraction' || this.anchorYUnits_ == 'fraction') {
                if (!size) return null;
                anchor = this.anchor_.slice();
                if (this.anchorXUnits_ == 'fraction') anchor[0] *= size[0];
                if (this.anchorYUnits_ == 'fraction') anchor[1] *= size[1];
            }
            if (this.anchorOrigin_ != 'top-left') {
                if (!size) return null;
                if (anchor === this.anchor_) anchor = this.anchor_.slice();
                if (this.anchorOrigin_ == 'top-right' || this.anchorOrigin_ == 'bottom-right') anchor[0] = -anchor[0] + size[0];
                if (this.anchorOrigin_ == 'bottom-left' || this.anchorOrigin_ == 'bottom-right') anchor[1] = -anchor[1] + size[1];
            }
            this.normalizedAnchor_ = anchor;
        }
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            anchor[0] - displacement[0] / scale[0],
            anchor[1] + displacement[1] / scale[1]
        ];
    }
    /**
   * Set the anchor point. The anchor determines the center point for the
   * symbolizer.
   *
   * @param {Array<number>} anchor Anchor.
   * @api
   */ setAnchor(anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    }
    /**
   * Get the icon color.
   * @return {import("../color.js").Color} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image or Canvas element. If the Icon
   * style was configured with `src` or with a not let loaded `img`, an `ImageBitmap` will be returned.
   * @api
   * @override
   */ getImage(pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    }
    /**
   * Get the pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} The pixel ratio of the image.
   * @api
   * @override
   */ getPixelRatio(pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.iconImage_.getSize();
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.iconImage_.getImageState();
    }
    /**
   * @return {HTMLImageElement|HTMLCanvasElement|ImageBitmap} Image element.
   * @override
   */ getHitDetectionImage() {
        return this.iconImage_.getHitDetectionImage();
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        if (this.origin_) return this.origin_;
        let offset = this.offset_;
        if (this.offsetOrigin_ != 'top-left') {
            const size = this.getSize();
            const iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) return null;
            offset = offset.slice();
            if (this.offsetOrigin_ == 'top-right' || this.offsetOrigin_ == 'bottom-right') offset[0] = iconImageSize[0] - size[0] - offset[0];
            if (this.offsetOrigin_ == 'bottom-left' || this.offsetOrigin_ == 'bottom-right') offset[1] = iconImageSize[1] - size[1] - offset[1];
        }
        this.origin_ = offset;
        return this.origin_;
    }
    /**
   * Get the image URL.
   * @return {string|undefined} Image src.
   * @api
   */ getSrc() {
        return this.iconImage_.getSrc();
    }
    /**
   * Get the size of the icon (in pixels).
   * @return {import("../size.js").Size} Image size.
   * @api
   * @override
   */ getSize() {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    }
    /**
   * Get the width of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon width (in pixels).
   * @api
   */ getWidth() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[0] * scale[0];
        if (this.iconImage_.getImageState() == (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[0] * scale[0];
        return undefined;
    }
    /**
   * Get the height of the icon (in pixels). Will return undefined when the icon image is not yet loaded.
   * @return {number} Icon height (in pixels).
   * @api
   */ getHeight() {
        const scale = this.getScaleArray();
        if (this.size_) return this.size_[1] * scale[1];
        if (this.iconImage_.getImageState() == (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) return this.iconImage_.getSize()[1] * scale[1];
        return undefined;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size} scale Scale.
   * @api
   * @override
   */ setScale(scale) {
        delete this.initialOptions_;
        super.setScale(scale);
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {
        this.iconImage_.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * Load not yet loaded URI.
   * When rendering a feature with an icon style, the vector renderer will
   * automatically call this method. However, you might want to call this
   * method yourself for preloading or other purposes.
   * @api
   * @override
   */ load() {
        this.iconImage_.load();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {
        this.iconImage_.removeEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, listener);
    }
    /**
   * @override
   */ ready() {
        return this.iconImage_.ready();
    }
}
var $44e8bfd96871175f$export$2e2bcd8739ae039 = $44e8bfd96871175f$var$Icon;


/**
 * @module ol/render/canvas/Immediate
 */ // FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?









/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext~VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */ class $38d7ec0eb2f8558c$var$CanvasImmediateRenderer extends (0, $37298fa487b80ee5$export$2e2bcd8739ae039) {
    /**
   * @param {CanvasRenderingContext2D} context Context.
   * @param {number} pixelRatio Pixel ratio.
   * @param {import("../../extent.js").Extent} extent Extent.
   * @param {import("../../transform.js").Transform} transform Transform.
   * @param {number} viewRotation View rotation.
   * @param {number} [squaredTolerance] Optional squared tolerance for simplification.
   * @param {import("../../proj.js").TransformFunction} [userTransform] Transform from user to view projection.
   */ constructor(context, pixelRatio, extent, transform, viewRotation, squaredTolerance, userTransform){
        super();
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.context_ = context;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = pixelRatio;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.extent_ = extent;
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.transform_ = transform;
        /**
     * @private
     * @type {number}
     */ this.transformRotation_ = transform ? (0, $d4e56cfc37d8b1f9$export$a81f732198733497)(Math.atan2(transform[1], transform[0]), 10) : 0;
        /**
     * @private
     * @type {number}
     */ this.viewRotation_ = viewRotation;
        /**
     * @private
     * @type {number}
     */ this.squaredTolerance_ = squaredTolerance;
        /**
     * @private
     * @type {import("../../proj.js").TransformFunction}
     */ this.userTransform_ = userTransform;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.contextFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.contextStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.contextTextState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.fillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.strokeState_ = null;
        /**
     * @private
     * @type {import('../../DataTile.js').ImageLike}
     */ this.image_ = null;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageAnchorY_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageHeight_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOpacity_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.imageOriginY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.imageRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.imageRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.imageScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.imageWidth_ = 0;
        /**
     * @private
     * @type {string}
     */ this.text_ = '';
        /**
     * @private
     * @type {number}
     */ this.textOffsetX_ = 0;
        /**
     * @private
     * @type {number}
     */ this.textOffsetY_ = 0;
        /**
     * @private
     * @type {boolean}
     */ this.textRotateWithView_ = false;
        /**
     * @private
     * @type {number}
     */ this.textRotation_ = 0;
        /**
     * @private
     * @type {import("../../size.js").Size}
     */ this.textScale_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {?import("../canvas.js").FillState}
     */ this.textFillState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").StrokeState}
     */ this.textStrokeState_ = null;
        /**
     * @private
     * @type {?import("../canvas.js").TextState}
     */ this.textState_ = null;
        /**
     * @private
     * @type {Array<number>}
     */ this.pixelCoordinates_ = [];
        /**
     * @private
     * @type {import("../../transform.js").Transform}
     */ this.tmpLocalTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawImages_(flatCoordinates, offset, end, stride) {
        if (!this.image_) return;
        const pixelCoordinates = (0, $24a54079104c80a7$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        const localTransform = this.tmpLocalTransform_;
        const alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha * this.imageOpacity_;
        let rotation = this.imageRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.imageRotateWithView_) rotation += this.viewRotation_;
        for(let i = 0, ii = pixelCoordinates.length; i < ii; i += 2){
            const x = pixelCoordinates[i] - this.imageAnchorX_;
            const y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 || this.imageScale_[0] != 1 || this.imageScale_[1] != 1) {
                const centerX = x + this.imageAnchorX_;
                const centerY = y + this.imageAnchorY_;
                (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.save();
                context.transform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.restore();
            } else context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
        }
        if (this.imageOpacity_ != 1) context.globalAlpha = alpha;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @private
   */ drawText_(flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === '') return;
        if (this.textFillState_) this.setContextFillState_(this.textFillState_);
        if (this.textStrokeState_) this.setContextStrokeState_(this.textStrokeState_);
        this.setContextTextState_(this.textState_);
        const pixelCoordinates = (0, $24a54079104c80a7$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        const context = this.context_;
        let rotation = this.textRotation_;
        if (this.transformRotation_ === 0) rotation -= this.viewRotation_;
        if (this.textRotateWithView_) rotation += this.viewRotation_;
        for(; offset < end; offset += stride){
            const x = pixelCoordinates[offset] + this.textOffsetX_;
            const y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 || this.textScale_[0] != 1 || this.textScale_[1] != 1) {
                context.save();
                context.translate(x - this.textOffsetX_, y - this.textOffsetY_);
                context.rotate(rotation);
                context.translate(this.textOffsetX_, this.textOffsetY_);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) context.strokeText(this.text_, 0, 0);
                if (this.textFillState_) context.fillText(this.text_, 0, 0);
                context.restore();
            } else {
                if (this.textStrokeState_) context.strokeText(this.text_, x, y);
                if (this.textFillState_) context.fillText(this.text_, x, y);
            }
        }
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {number} end End.
   * @param {number} stride Stride.
   * @param {boolean} close Close.
   * @private
   * @return {number} end End.
   */ moveToLineTo_(flatCoordinates, offset, end, stride, close) {
        const context = this.context_;
        const pixelCoordinates = (0, $24a54079104c80a7$export$b92b2dedcfff79de)(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        let length = pixelCoordinates.length;
        if (close) length -= 2;
        for(let i = 2; i < length; i += 2)context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        if (close) context.closePath();
        return end;
    }
    /**
   * @param {Array<number>} flatCoordinates Flat coordinates.
   * @param {number} offset Offset.
   * @param {Array<number>} ends Ends.
   * @param {number} stride Stride.
   * @private
   * @return {number} End.
   */ drawRings_(flatCoordinates, offset, ends, stride) {
        for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
        return offset;
    }
    /**
   * Render a circle geometry into the canvas.  Rendering is immediate and uses
   * the current fill and stroke styles.
   *
   * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
   * @api
   * @override
   */ drawCircle(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Circle.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const pixelCoordinates = (0, $ce25558341ea2841$export$a3767472617c7861)(geometry, this.transform_, this.pixelCoordinates_);
            const dx = pixelCoordinates[2] - pixelCoordinates[0];
            const dy = pixelCoordinates[3] - pixelCoordinates[1];
            const radius = Math.sqrt(dx * dx + dy * dy);
            const context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') this.drawText_(geometry.getCenter(), 0, 2, 2);
    }
    /**
   * Set the rendering style.  Note that since this is an immediate rendering API,
   * any `zIndex` on the provided style will be ignored.
   *
   * @param {import("../../style/Style.js").default} style The rendering style.
   * @api
   * @override
   */ setStyle(style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    }
    /**
   * @param {import("../../transform.js").Transform} transform Transform.
   */ setTransform(transform) {
        this.transform_ = transform;
    }
    /**
   * Render a geometry into the canvas.  Call
   * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
   *
   * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
   * @api
   * @override
   */ drawGeometry(geometry) {
        const type = geometry.getType();
        switch(type){
            case 'Point':
                this.drawPoint(/** @type {import("../../geom/Point.js").default} */ geometry);
                break;
            case 'LineString':
                this.drawLineString(/** @type {import("../../geom/LineString.js").default} */ geometry);
                break;
            case 'Polygon':
                this.drawPolygon(/** @type {import("../../geom/Polygon.js").default} */ geometry);
                break;
            case 'MultiPoint':
                this.drawMultiPoint(/** @type {import("../../geom/MultiPoint.js").default} */ geometry);
                break;
            case 'MultiLineString':
                this.drawMultiLineString(/** @type {import("../../geom/MultiLineString.js").default} */ geometry);
                break;
            case 'MultiPolygon':
                this.drawMultiPolygon(/** @type {import("../../geom/MultiPolygon.js").default} */ geometry);
                break;
            case 'GeometryCollection':
                this.drawGeometryCollection(/** @type {import("../../geom/GeometryCollection.js").default} */ geometry);
                break;
            case 'Circle':
                this.drawCircle(/** @type {import("../../geom/Circle.js").default} */ geometry);
                break;
            default:
        }
    }
    /**
   * Render a feature into the canvas.  Note that any `zIndex` on the provided
   * style will be ignored - features are rendered immediately in the order that
   * this method is called.  If you need `zIndex` support, you should be using an
   * {@link module:ol/layer/Vector~VectorLayer} instead.
   *
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {import("../../style/Style.js").default} style Style.
   * @api
   * @override
   */ drawFeature(feature, style) {
        const geometry = style.getGeometryFunction()(feature);
        if (!geometry) return;
        this.setStyle(style);
        this.drawGeometry(geometry);
    }
    /**
   * Render a GeometryCollection to the canvas.  Rendering is immediate and
   * uses the current styles appropriate for each geometry in the collection.
   *
   * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
   * @override
   */ drawGeometryCollection(geometry) {
        const geometries = geometry.getGeometriesArray();
        for(let i = 0, ii = geometries.length; i < ii; ++i)this.drawGeometry(geometries[i]);
    }
    /**
   * Render a Point geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
   * @override
   */ drawPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Point.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
   * uses the current style.
   *
   * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
   * @override
   */ drawMultiPoint(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPoint.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const flatCoordinates = geometry.getFlatCoordinates();
        const stride = geometry.getStride();
        if (this.image_) this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        if (this.text_ !== '') this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
    }
    /**
   * Render a LineString into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
   * @override
   */ drawLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/LineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    }
    /**
   * Render a MultiLineString geometry into the canvas.  Rendering is immediate
   * and uses the current style.
   *
   * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
   * @override
   */ drawMultiLineString(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiLineString.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        const geometryExtent = geometry.getExtent();
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometryExtent)) return;
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getFlatCoordinates();
            let offset = 0;
            const ends = /** @type {Array<number>} */ geometry.getEnds();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = ends.length; i < ii; ++i)offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
            context.stroke();
        }
        if (this.text_ !== '') {
            const flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    }
    /**
   * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
   * the current style.
   *
   * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
   * @override
   */ drawPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/Polygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, /** @type {Array<number>} */ geometry.getEnds(), geometry.getStride());
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    }
    /**
   * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
   * uses the current style.
   * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
   * @override
   */ drawMultiPolygon(geometry) {
        if (this.squaredTolerance_) geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_);
        if (!(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(this.extent_, geometry.getExtent())) return;
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) this.setContextFillState_(this.fillState_);
            if (this.strokeState_) this.setContextStrokeState_(this.strokeState_);
            const context = this.context_;
            const flatCoordinates = geometry.getOrientedFlatCoordinates();
            let offset = 0;
            const endss = geometry.getEndss();
            const stride = geometry.getStride();
            context.beginPath();
            for(let i = 0, ii = endss.length; i < ii; ++i){
                const ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride);
            }
            if (this.fillState_) context.fill();
            if (this.strokeState_) context.stroke();
        }
        if (this.text_ !== '') {
            const flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    }
    /**
   * @param {import("../canvas.js").FillState} fillState Fill state.
   * @private
   */ setContextFillState_(fillState) {
        const context = this.context_;
        const contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle
            };
        } else if (contextFillState.fillStyle != fillState.fillStyle) {
            contextFillState.fillStyle = fillState.fillStyle;
            context.fillStyle = fillState.fillStyle;
        }
    }
    /**
   * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
   * @private
   */ setContextStrokeState_(strokeState) {
        const context = this.context_;
        const contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            context.setLineDash(strokeState.lineDash);
            context.lineDashOffset = strokeState.lineDashOffset;
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle
            };
        } else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (!(0, $830d23b8323fc080$export$e9bab7fafb253603)(contextStrokeState.lineDash, strokeState.lineDash)) context.setLineDash(contextStrokeState.lineDash = strokeState.lineDash);
            if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    }
    /**
   * @param {import("../canvas.js").TextState} textState Text state.
   * @private
   */ setContextTextState_(textState) {
        const context = this.context_;
        const contextTextState = this.contextTextState_;
        const textAlign = textState.textAlign ? textState.textAlign : (0, $c8f894129d9fa0b9$export$94d53b95641b5766);
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = textAlign;
            context.textBaseline = textState.textBaseline;
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline
            };
        } else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = textAlign;
                context.textAlign = textAlign;
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = textState.textBaseline;
                context.textBaseline = textState.textBaseline;
            }
        }
    }
    /**
   * Set the fill and stroke style for subsequent draw operations.  To clear
   * either fill or stroke styles, pass null for the appropriate parameter.
   *
   * @param {import("../../style/Fill.js").default} fillStyle Fill style.
   * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
   * @override
   */ setFillStrokeStyle(fillStyle, strokeStyle) {
        if (!fillStyle) this.fillState_ = null;
        else {
            const fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(fillStyleColor ? fillStyleColor : (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2))
            };
        }
        if (!strokeStyle) this.strokeState_ = null;
        else {
            const strokeStyleColor = strokeStyle.getColor();
            const strokeStyleLineCap = strokeStyle.getLineCap();
            const strokeStyleLineDash = strokeStyle.getLineDash();
            const strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            const strokeStyleLineJoin = strokeStyle.getLineJoin();
            const strokeStyleWidth = strokeStyle.getWidth();
            const strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            const lineDash = strokeStyleLineDash ? strokeStyleLineDash : (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc);
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined ? strokeStyleLineCap : (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e),
                lineDash: this.pixelRatio_ === 1 ? lineDash : lineDash.map((n)=>n * this.pixelRatio_),
                lineDashOffset: (strokeStyleLineDashOffset ? strokeStyleLineDashOffset : (0, $c8f894129d9fa0b9$export$e06efc2409049f76)) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined ? strokeStyleLineJoin : (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0),
                lineWidth: (strokeStyleWidth !== undefined ? strokeStyleWidth : (0, $c8f894129d9fa0b9$export$79661f132c62010e)) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined ? strokeStyleMiterLimit : (0, $c8f894129d9fa0b9$export$80c1c01844597b7b),
                strokeStyle: (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(strokeStyleColor ? strokeStyleColor : (0, $c8f894129d9fa0b9$export$1eb2eaecacf2031e))
            };
        }
    }
    /**
   * Set the image style for subsequent draw operations.  Pass null to remove
   * the image style.
   *
   * @param {import("../../style/Image.js").default} imageStyle Image style.
   * @override
   */ setImageStyle(imageStyle) {
        let imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        const imagePixelRatio = imageStyle.getPixelRatio(this.pixelRatio_);
        const imageAnchor = imageStyle.getAnchor();
        const imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * imagePixelRatio;
        this.imageAnchorY_ = imageAnchor[1] * imagePixelRatio;
        this.imageHeight_ = imageSize[1] * imagePixelRatio;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        const imageScale = imageStyle.getScaleArray();
        this.imageScale_ = [
            imageScale[0] * this.pixelRatio_ / imagePixelRatio,
            imageScale[1] * this.pixelRatio_ / imagePixelRatio
        ];
        this.imageWidth_ = imageSize[0] * imagePixelRatio;
    }
    /**
   * Set the text style for subsequent draw operations.  Pass null to
   * remove the text style.
   *
   * @param {import("../../style/Text.js").default} textStyle Text style.
   * @override
   */ setTextStyle(textStyle) {
        if (!textStyle) this.text_ = '';
        else {
            const textFillStyle = textStyle.getFill();
            if (!textFillStyle) this.textFillState_ = null;
            else {
                const textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(textFillStyleColor ? textFillStyleColor : (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2))
                };
            }
            const textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) this.textStrokeState_ = null;
            else {
                const textStrokeStyleColor = textStrokeStyle.getColor();
                const textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                const textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                const textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                const textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                const textStrokeStyleWidth = textStrokeStyle.getWidth();
                const textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined ? textStrokeStyleLineCap : (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e),
                    lineDash: textStrokeStyleLineDash ? textStrokeStyleLineDash : (0, $c8f894129d9fa0b9$export$e21b4112fdc612fc),
                    lineDashOffset: textStrokeStyleLineDashOffset ? textStrokeStyleLineDashOffset : (0, $c8f894129d9fa0b9$export$e06efc2409049f76),
                    lineJoin: textStrokeStyleLineJoin !== undefined ? textStrokeStyleLineJoin : (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0),
                    lineWidth: textStrokeStyleWidth !== undefined ? textStrokeStyleWidth : (0, $c8f894129d9fa0b9$export$79661f132c62010e),
                    miterLimit: textStrokeStyleMiterLimit !== undefined ? textStrokeStyleMiterLimit : (0, $c8f894129d9fa0b9$export$80c1c01844597b7b),
                    strokeStyle: (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(textStrokeStyleColor ? textStrokeStyleColor : (0, $c8f894129d9fa0b9$export$1eb2eaecacf2031e))
                };
            }
            const textFont = textStyle.getFont();
            const textOffsetX = textStyle.getOffsetX();
            const textOffsetY = textStyle.getOffsetY();
            const textRotateWithView = textStyle.getRotateWithView();
            const textRotation = textStyle.getRotation();
            const textScale = textStyle.getScaleArray();
            const textText = textStyle.getText();
            const textTextAlign = textStyle.getTextAlign();
            const textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : (0, $c8f894129d9fa0b9$export$3847dfea4f8d4dfa),
                textAlign: textTextAlign !== undefined ? textTextAlign : (0, $c8f894129d9fa0b9$export$94d53b95641b5766),
                textBaseline: textTextBaseline !== undefined ? textTextBaseline : (0, $c8f894129d9fa0b9$export$cf2279a1bff62eb)
            };
            this.text_ = textText !== undefined ? Array.isArray(textText) ? textText.reduce((acc, t, i)=>acc += i % 2 ? ' ' : t, '') : textText : '';
            this.textOffsetX_ = textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ = textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ = textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1]
            ];
        }
    }
}
var $38d7ec0eb2f8558c$export$2e2bcd8739ae039 = $38d7ec0eb2f8558c$var$CanvasImmediateRenderer;


const $e863b28c0e268c8c$export$ab51038298418f25 = 0.5;
function $e863b28c0e268c8c$export$bd05e394339d469(size, transforms, features, styleFunction, extent, resolution, rotation, squaredTolerance, projection) {
    const userExtent = projection ? (0, $92f1443438429e81$export$96bfd09e2cffb006)(extent, projection) : extent;
    const width = size[0] * $e863b28c0e268c8c$export$ab51038298418f25;
    const height = size[1] * $e863b28c0e268c8c$export$ab51038298418f25;
    const context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(width, height);
    context.imageSmoothingEnabled = false;
    const canvas = context.canvas;
    const renderer = new (0, $38d7ec0eb2f8558c$export$2e2bcd8739ae039)(context, $e863b28c0e268c8c$export$ab51038298418f25, extent, null, rotation, squaredTolerance, projection ? (0, $92f1443438429e81$export$e3c4995a701c26a3)((0, $92f1443438429e81$export$3973b77d5f6f2790)(), projection) : null);
    const featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    const indexFactor = Math.floor(16777215 / featureCount);
    const featuresByZIndex = {};
    for(let i = 1; i <= featureCount; ++i){
        const feature = features[i - 1];
        const featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!featureStyleFunction) continue;
        let styles = featureStyleFunction(feature, resolution);
        if (!styles) continue;
        if (!Array.isArray(styles)) styles = [
            styles
        ];
        const index = i * indexFactor;
        const color = index.toString(16).padStart(7, '#00000');
        for(let j = 0, jj = styles.length; j < jj; ++j){
            const originalStyle = styles[j];
            const geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(userExtent, geometry.getExtent())) continue;
            const style = originalStyle.clone();
            const fill = style.getFill();
            if (fill) fill.setColor(color);
            const stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            const image = originalStyle.getImage();
            if (image) {
                const imgSize = image.getImageSize();
                if (!imgSize) continue;
                const imgContext = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(imgSize[0], imgSize[1], undefined, {
                    alpha: false
                });
                const img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new (0, $44e8bfd96871175f$export$2e2bcd8739ae039)({
                    img: img,
                    anchor: image.getAnchor(),
                    anchorXUnits: 'pixels',
                    anchorYUnits: 'pixels',
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView()
                }));
            }
            const zIndex = style.getZIndex() || 0;
            let byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType['Polygon'] = [];
                byGeometryType['Circle'] = [];
                byGeometryType['LineString'] = [];
                byGeometryType['Point'] = [];
            }
            const type = geometry.getType();
            if (type === 'GeometryCollection') {
                const geometries = /** @type {import("../../geom/GeometryCollection.js").default} */ geometry.getGeometriesArrayRecursive();
                for(let i = 0, ii = geometries.length; i < ii; ++i){
                    const geometry = geometries[i];
                    byGeometryType[geometry.getType().replace('Multi', '')].push(geometry, style);
                }
            } else byGeometryType[type.replace('Multi', '')].push(geometry, style);
        }
    }
    const zIndexKeys = Object.keys(featuresByZIndex).map(Number).sort((0, $830d23b8323fc080$export$fcb633242ef15540));
    for(let i = 0, ii = zIndexKeys.length; i < ii; ++i){
        const byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for(const type in byGeometryType){
            const geomAndStyle = byGeometryType[type];
            for(let j = 0, jj = geomAndStyle.length; j < jj; j += 2){
                renderer.setStyle(geomAndStyle[j + 1]);
                for(let k = 0, kk = transforms.length; k < kk; ++k){
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
function $e863b28c0e268c8c$export$6d4d555ddbfffa32(pixel, features, imageData) {
    /** @type {Array<F>} */ const resultFeatures = [];
    if (imageData) {
        const x = Math.floor(Math.round(pixel[0]) * $e863b28c0e268c8c$export$ab51038298418f25);
        const y = Math.floor(Math.round(pixel[1]) * $e863b28c0e268c8c$export$ab51038298418f25);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        const index = ((0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(x, 0, imageData.width - 1) + (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(y, 0, imageData.height - 1) * imageData.width) * 4;
        const r = imageData.data[index];
        const g = imageData.data[index + 1];
        const b = imageData.data[index + 2];
        const i = b + 256 * (g + 256 * r);
        const indexFactor = Math.floor(16777215 / features.length);
        if (i && i % indexFactor === 0) resultFeatures.push(features[i / indexFactor - 1]);
    }
    return resultFeatures;
}



/**
 * @module ol/renderer/vector
 */ 

/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature~Feature feature} or {@link module:ol/render/Feature~RenderFeature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry~SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default<import("../source/Source").default>, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */ /**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */ const $d9e0efcd90e741b9$var$SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/Geometry.js").Type,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */ const $d9e0efcd90e741b9$var$GEOMETRY_RENDERERS = {
    'Point': $d9e0efcd90e741b9$var$renderPointGeometry,
    'LineString': $d9e0efcd90e741b9$var$renderLineStringGeometry,
    'Polygon': $d9e0efcd90e741b9$var$renderPolygonGeometry,
    'MultiPoint': $d9e0efcd90e741b9$var$renderMultiPointGeometry,
    'MultiLineString': $d9e0efcd90e741b9$var$renderMultiLineStringGeometry,
    'MultiPolygon': $d9e0efcd90e741b9$var$renderMultiPolygonGeometry,
    'GeometryCollection': $d9e0efcd90e741b9$var$renderGeometryCollectionGeometry,
    'Circle': $d9e0efcd90e741b9$var$renderCircleGeometry
};
function $d9e0efcd90e741b9$export$531ddd8416d52dfc(feature1, feature2) {
    return parseInt((0, $34772e91e89a736f$export$5e82334337e0f204)(feature1), 10) - parseInt((0, $34772e91e89a736f$export$5e82334337e0f204)(feature2), 10);
}
function $d9e0efcd90e741b9$export$75084a70d324c1e6(resolution, pixelRatio) {
    const tolerance = $d9e0efcd90e741b9$export$bdacc5b475012edb(resolution, pixelRatio);
    return tolerance * tolerance;
}
function $d9e0efcd90e741b9$export$bdacc5b475012edb(resolution, pixelRatio) {
    return $d9e0efcd90e741b9$var$SIMPLIFY_TOLERANCE * resolution / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $d9e0efcd90e741b9$var$renderCircleGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const circleReplay = builderGroup.getBuilder(style.getZIndex(), 'Circle');
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
function $d9e0efcd90e741b9$export$36f470a33a42f413(replayGroup, feature, style, squaredTolerance, listener, transform, declutter, index) {
    const loadingPromises = [];
    const imageStyle = style.getImage();
    if (imageStyle) {
        let loading = true;
        const imageState = imageStyle.getImageState();
        if (imageState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED || imageState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).ERROR) loading = false;
        else if (imageState == (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) imageStyle.load();
        if (loading) loadingPromises.push(imageStyle.ready());
    }
    const fillStyle = style.getFill();
    if (fillStyle && fillStyle.loading()) loadingPromises.push(fillStyle.ready());
    const loading = loadingPromises.length > 0;
    if (loading) Promise.all(loadingPromises).then(()=>listener(null));
    $d9e0efcd90e741b9$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [transform] Optional transform function.
 * @param {boolean} [declutter] Enable decluttering.
 * @param {number} [index] Render order index..
 */ function $d9e0efcd90e741b9$var$renderFeatureInternal(replayGroup, feature, style, squaredTolerance, transform, declutter, index) {
    const geometry = style.getGeometryFunction()(feature);
    if (!geometry) return;
    const simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, transform);
    const renderer = style.getRenderer();
    if (renderer) $d9e0efcd90e741b9$var$renderGeometry(replayGroup, simplifiedGeometry, style, feature, index);
    else {
        const geometryRenderer = $d9e0efcd90e741b9$var$GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, index, declutter);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $d9e0efcd90e741b9$var$renderGeometry(replayGroup, geometry, style, feature, index) {
    if (geometry.getType() == 'GeometryCollection') {
        const geometries = /** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries();
        for(let i = 0, ii = geometries.length; i < ii; ++i)$d9e0efcd90e741b9$var$renderGeometry(replayGroup, geometries[i], style, feature, index);
        return;
    }
    const replay = replayGroup.getBuilder(style.getZIndex(), 'Default');
    replay.drawCustom(/** @type {import("../geom/SimpleGeometry.js").default} */ geometry, feature, style.getRenderer(), style.getHitDetectionRenderer(), index);
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [declutterBuilderGroup] Builder for decluttering.
 * @param {number} [index] Render order index.
 */ function $d9e0efcd90e741b9$var$renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, declutterBuilderGroup, index) {
    const geometries = geometry.getGeometriesArray();
    let i, ii;
    for(i = 0, ii = geometries.length; i < ii; ++i){
        const geometryRenderer = $d9e0efcd90e741b9$var$GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, declutterBuilderGroup, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $d9e0efcd90e741b9$var$renderLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $d9e0efcd90e741b9$var$renderMultiLineStringGeometry(builderGroup, geometry, style, feature, index) {
    const strokeStyle = style.getStroke();
    if (strokeStyle) {
        const lineStringReplay = builderGroup.getBuilder(style.getZIndex(), 'LineString');
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {number} [index] Render order index.
 */ function $d9e0efcd90e741b9$var$renderMultiPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $d9e0efcd90e741b9$var$renderPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && imageStyle && hasText ? {} : undefined;
    if (imageStyle) {
        if (imageStyle.getImageState() != (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 * @param {boolean} [declutter] Enable decluttering.
 */ function $d9e0efcd90e741b9$var$renderMultiPointGeometry(builderGroup, geometry, style, feature, index, declutter) {
    const imageStyle = style.getImage();
    const hasImage = imageStyle && imageStyle.getOpacity() !== 0;
    const textStyle = style.getText();
    const hasText = textStyle && textStyle.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */ const declutterImageWithText = declutter && hasImage && hasText ? {} : undefined;
    if (hasImage) {
        if (imageStyle.getImageState() != (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED) return;
        const imageReplay = builderGroup.getBuilder(style.getZIndex(), 'Image');
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature, index);
    }
    if (hasText) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature, index);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} [index] Render order index.
 */ function $d9e0efcd90e741b9$var$renderPolygonGeometry(builderGroup, geometry, style, feature, index) {
    const fillStyle = style.getFill();
    const strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        const polygonReplay = builderGroup.getBuilder(style.getZIndex(), 'Polygon');
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature, index);
    }
    const textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        const textReplay = builderGroup.getBuilder(style.getZIndex(), 'Text');
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature, index);
    }
}



/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */ class $b6f9cff97736b00f$var$CanvasVectorLayerRenderer extends (0, $22aba15f167ce2ee$export$2e2bcd8739ae039) {
    /**
   * @param {import("../../layer/BaseVector.js").default} vectorLayer Vector layer.
   */ constructor(vectorLayer){
        super(vectorLayer);
        /** @private */ this.boundHandleStyleImageChange_ = this.handleStyleImageChange_.bind(this);
        /**
     * @private
     * @type {boolean}
     */ this.animatingOrInteracting_;
        /**
     * @private
     * @type {ImageData|null}
     */ this.hitDetectionImageData_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.clipped_ = false;
        /**
     * @private
     * @type {Array<import("../../Feature.js").default>}
     */ this.renderedFeatures_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedRevision_ = -1;
        /**
     * @private
     * @type {number}
     */ this.renderedResolution_ = NaN;
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.renderedExtent_ = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {import("../../extent.js").Extent}
     */ this.wrappedRenderedExtent_ = (0, $7e819822b33b3d32$export$fe201bb3bbe031e9)();
        /**
     * @private
     * @type {number}
     */ this.renderedRotation_;
        /**
     * @private
     * @type {import("../../coordinate").Coordinate}
     */ this.renderedCenter_ = null;
        /**
     * @private
     * @type {import("../../proj/Projection").default}
     */ this.renderedProjection_ = null;
        /**
     * @private
     * @type {number}
     */ this.renderedPixelRatio_ = 1;
        /**
     * @private
     * @type {import("../../render.js").OrderFunction|null}
     */ this.renderedRenderOrder_ = null;
        /**
     * @private
     * @type {boolean}
     */ this.renderedFrameDeclutter_;
        /**
     * @private
     * @type {import("../../render/canvas/ExecutorGroup").default}
     */ this.replayGroup_ = null;
        /**
     * A new replay group had to be created by `prepareFrame()`
     * @type {boolean}
     */ this.replayGroupChanged = true;
        /**
     * Clipping to be performed by `renderFrame()`
     * @type {boolean}
     */ this.clipping = true;
        /**
     * @private
     * @type {CanvasRenderingContext2D}
     */ this.targetContext_ = null;
        /**
     * @private
     * @type {number}
     */ this.opacity_ = 1;
    }
    /**
   * @param {ExecutorGroup} executorGroup Executor group.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {boolean} [declutterable] `true` to only render declutterable items,
   *     `false` to only render non-declutterable items, `undefined` to render all.
   */ renderWorlds(executorGroup, frameState, declutterable) {
        const extent = frameState.extent;
        const viewState = frameState.viewState;
        const center = viewState.center;
        const resolution = viewState.resolution;
        const projection = viewState.projection;
        const rotation = viewState.rotation;
        const projectionExtent = projection.getExtent();
        const vectorSource = this.getLayer().getSource();
        const declutter = this.getLayer().getDeclutter();
        const pixelRatio = frameState.pixelRatio;
        const viewHints = frameState.viewHints;
        const snapToPixel = !(viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] || viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING]);
        const context = this.context;
        const width = Math.round((0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent) / resolution * pixelRatio);
        const height = Math.round((0, $7e819822b33b3d32$export$c08559766941f856)(extent) / resolution * pixelRatio);
        const multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        const worldWidth = multiWorld ? (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projectionExtent) : null;
        const endWorld = multiWorld ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1 : 1;
        let world = multiWorld ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth) : 0;
        do {
            let transform = this.getRenderTransform(center, resolution, 0, pixelRatio, width, height, world * worldWidth);
            if (frameState.declutter) transform = transform.slice(0);
            executorGroup.execute(context, [
                context.canvas.width,
                context.canvas.height
            ], transform, rotation, snapToPixel, declutterable === undefined ? (0, $f979fbd3c953bca1$export$61b49a5ae59d663) : declutterable ? (0, $f979fbd3c953bca1$export$6195a93a6c97ce02) : (0, $f979fbd3c953bca1$export$d0fe61ccfaa1ca87), declutterable ? declutter && frameState.declutter[declutter] : undefined);
        }while (++world < endWorld);
    }
    /**
   * @private
   */ setDrawContext_() {
        if (this.opacity_ !== 1) {
            this.targetContext_ = this.context;
            this.context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(this.context.canvas.width, this.context.canvas.height, (0, $22aba15f167ce2ee$export$a166f0857c555517));
        }
    }
    /**
   * @private
   */ resetDrawContext_() {
        if (this.opacity_ !== 1) {
            const alpha = this.targetContext_.globalAlpha;
            this.targetContext_.globalAlpha = this.opacity_;
            this.targetContext_.drawImage(this.context.canvas, 0, 0);
            this.targetContext_.globalAlpha = alpha;
            (0, $755a3001f896bcf1$export$e918ac6a1026a12a)(this.context);
            (0, $22aba15f167ce2ee$export$a166f0857c555517).push(this.context.canvas);
            this.context = this.targetContext_;
            this.targetContext_ = null;
        }
    }
    /**
   * Render declutter items for this layer
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   */ renderDeclutter(frameState) {
        if (!this.replayGroup_ || !this.getLayer().getDeclutter()) return;
        this.renderWorlds(this.replayGroup_, frameState, true);
    }
    /**
   * Render deferred instructions.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderDeferredInternal(frameState) {
        if (!this.replayGroup_) return;
        this.replayGroup_.renderDeferred();
        if (this.clipped_) this.context.restore();
        this.resetDrawContext_();
    }
    /**
   * Render the layer.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {HTMLElement|null} target Target that may be used to render content to.
   * @return {HTMLElement|null} The rendered element.
   * @override
   */ renderFrame(frameState, target) {
        const layerState = frameState.layerStatesArray[frameState.layerIndex];
        this.opacity_ = layerState.opacity;
        const viewState = frameState.viewState;
        this.prepareContainer(frameState, target);
        const context = this.context;
        const replayGroup = this.replayGroup_;
        let render = replayGroup && !replayGroup.isEmpty();
        if (!render) {
            const hasRenderListeners = this.getLayer().hasListener((0, $847c6e8c21904781$export$2e2bcd8739ae039).PRERENDER) || this.getLayer().hasListener((0, $847c6e8c21904781$export$2e2bcd8739ae039).POSTRENDER);
            if (!hasRenderListeners) return null;
        }
        this.setDrawContext_();
        this.preRender(context, frameState);
        const projection = viewState.projection;
        // clipped rendering if layer extent is set
        this.clipped_ = false;
        if (render && layerState.extent && this.clipping) {
            const layerExtent = (0, $92f1443438429e81$export$494be3a3a25689ca)(layerState.extent, projection);
            render = (0, $7e819822b33b3d32$export$7b0a31e10bbff018)(layerExtent, frameState.extent);
            this.clipped_ = render && !(0, $7e819822b33b3d32$export$be866b1e0809b17e)(layerExtent, frameState.extent);
            if (this.clipped_) this.clipUnrotated(context, frameState, layerExtent);
        }
        if (render) this.renderWorlds(replayGroup, frameState, this.getLayer().getDeclutter() ? false : undefined);
        if (!frameState.declutter && this.clipped_) context.restore();
        this.postRender(context, frameState);
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        if (!frameState.declutter) this.resetDrawContext_();
        return this.container;
    }
    /**
   * Asynchronous layer level hit detection.
   * @param {import("../../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../../Feature").default>>} Promise
   * that resolves with an array of features.
   * @override
   */ getFeatures(pixel) {
        return new Promise((resolve)=>{
            if (this.frameState && !this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                const size = this.frameState.size.slice();
                const center = this.renderedCenter_;
                const resolution = this.renderedResolution_;
                const rotation = this.renderedRotation_;
                const projection = this.renderedProjection_;
                const extent = this.wrappedRenderedExtent_;
                const layer = this.getLayer();
                const transforms = [];
                const width = size[0] * (0, $e863b28c0e268c8c$export$ab51038298418f25);
                const height = size[1] * (0, $e863b28c0e268c8c$export$ab51038298418f25);
                transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $e863b28c0e268c8c$export$ab51038298418f25), width, height, 0).slice());
                const source = layer.getSource();
                const projectionExtent = projection.getExtent();
                if (source.getWrapX() && projection.canWrapX() && !(0, $7e819822b33b3d32$export$be866b1e0809b17e)(projectionExtent, extent)) {
                    let startX = extent[0];
                    const worldWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projectionExtent);
                    let world = 0;
                    let offsetX;
                    while(startX < projectionExtent[0]){
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $e863b28c0e268c8c$export$ab51038298418f25), width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while(startX > projectionExtent[2]){
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, (0, $e863b28c0e268c8c$export$ab51038298418f25), width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                const userProjection = (0, $92f1443438429e81$export$3973b77d5f6f2790)();
                this.hitDetectionImageData_ = (0, $e863b28c0e268c8c$export$bd05e394339d469)(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation, (0, $d9e0efcd90e741b9$export$75084a70d324c1e6)(resolution, this.renderedPixelRatio_), userProjection ? projection : null);
            }
            resolve((0, $e863b28c0e268c8c$export$6d4d555ddbfffa32)(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        });
    }
    /**
   * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
   * @return {T|undefined} Callback result.
   * @template T
   * @override
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches) {
        if (!this.replayGroup_) return undefined;
        const resolution = frameState.viewState.resolution;
        const rotation = frameState.viewState.rotation;
        const layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */ const features = {};
        /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} distanceSq The squared distance to the click position
     * @return {T|undefined} Callback result.
     */ const featureCallback = function(feature, geometry, distanceSq) {
            const key = (0, $34772e91e89a736f$export$5e82334337e0f204)(feature);
            const match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push(features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback
                });
            } else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        const declutter = this.getLayer().getDeclutter();
        return this.replayGroup_.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutter ? frameState.declutter?.[declutter]?.all().map((item)=>item.value) : null);
    }
    /**
   * Perform action necessary to get the layer rendered after new fonts have loaded
   * @override
   */ handleFontsChanged() {
        const layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) layer.changed();
    }
    /**
   * Handle changes in image style state.
   * @param {import("../../events/Event.js").default} event Image style change event.
   * @private
   */ handleStyleImageChange_(event) {
        this.renderIfReadyAndVisible();
    }
    /**
   * Determine whether render should be called.
   * @param {import("../../Map.js").FrameState} frameState Frame state.
   * @return {boolean} Layer is ready to be rendered.
   * @override
   */ prepareFrame(frameState) {
        const vectorLayer = this.getLayer();
        const vectorSource = vectorLayer.getSource();
        if (!vectorSource) return false;
        const animating = frameState.viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING];
        const interacting = frameState.viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING];
        const updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        const updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if (this.ready && !updateWhileAnimating && animating || !updateWhileInteracting && interacting) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        const frameStateExtent = frameState.extent;
        const viewState = frameState.viewState;
        const projection = viewState.projection;
        const resolution = viewState.resolution;
        const pixelRatio = frameState.pixelRatio;
        const vectorLayerRevision = vectorLayer.getRevision();
        const vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        let vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) vectorLayerRenderOrder = (0, $d9e0efcd90e741b9$export$531ddd8416d52dfc);
        const center = viewState.center.slice();
        const extent = (0, $7e819822b33b3d32$export$ab1029bcae9ddb4a)(frameStateExtent, vectorLayerRenderBuffer * resolution);
        const renderedExtent = extent.slice();
        const loadExtents = [
            extent.slice()
        ];
        const projectionExtent = projection.getExtent();
        if (vectorSource.getWrapX() && projection.canWrapX() && !(0, $7e819822b33b3d32$export$be866b1e0809b17e)(projectionExtent, frameState.extent)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            const worldWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projectionExtent);
            const gutter = Math.max((0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(extent) / 2, worldWidth);
            extent[0] = projectionExtent[0] - gutter;
            extent[2] = projectionExtent[2] + gutter;
            (0, $8b28786758450fff$export$39a9ce3624977b84)(center, projection);
            const loadExtent = (0, $7e819822b33b3d32$export$39a9ce3624977b84)(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] && loadExtent[2] < projectionExtent[2]) loadExtents.push([
                loadExtent[0] + worldWidth,
                loadExtent[1],
                loadExtent[2] + worldWidth,
                loadExtent[3]
            ]);
            else if (loadExtent[0] > projectionExtent[0] && loadExtent[2] > projectionExtent[2]) loadExtents.push([
                loadExtent[0] - worldWidth,
                loadExtent[1],
                loadExtent[2] - worldWidth,
                loadExtent[3]
            ]);
        }
        if (this.ready && this.renderedResolution_ == resolution && this.renderedRevision_ == vectorLayerRevision && this.renderedRenderOrder_ == vectorLayerRenderOrder && this.renderedFrameDeclutter_ === !!frameState.declutter && (0, $7e819822b33b3d32$export$be866b1e0809b17e)(this.wrappedRenderedExtent_, extent)) {
            if (!(0, $830d23b8323fc080$export$e9bab7fafb253603)(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        const replayGroup = new (0, $4da051e4cbf4d3d3$export$2e2bcd8739ae039)((0, $d9e0efcd90e741b9$export$bdacc5b475012edb)(resolution, pixelRatio), extent, resolution, pixelRatio);
        const userProjection = (0, $92f1443438429e81$export$3973b77d5f6f2790)();
        let userTransform;
        if (userProjection) {
            for(let i = 0, ii = loadExtents.length; i < ii; ++i){
                const extent = loadExtents[i];
                const userExtent = (0, $92f1443438429e81$export$96bfd09e2cffb006)(extent, projection);
                vectorSource.loadFeatures(userExtent, (0, $92f1443438429e81$export$b56bb8ad8b3a00e9)(resolution, projection), userProjection);
            }
            userTransform = (0, $92f1443438429e81$export$e3c4995a701c26a3)(userProjection, projection);
        } else for(let i = 0, ii = loadExtents.length; i < ii; ++i)vectorSource.loadFeatures(loadExtents[i], resolution, projection);
        const squaredTolerance = (0, $d9e0efcd90e741b9$export$75084a70d324c1e6)(resolution, pixelRatio);
        let ready = true;
        const render = /**
       * @param {import("../../Feature.js").default} feature Feature.
       * @param {number} index Index.
       */ (feature, index)=>{
            let styles;
            const styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) styles = styleFunction(feature, resolution);
            if (styles) {
                const dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, this.getLayer().getDeclutter(), index);
                ready = ready && !dirty;
            }
        };
        const userExtent = (0, $92f1443438429e81$export$96bfd09e2cffb006)(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */ const features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) features.sort(vectorLayerRenderOrder);
        for(let i = 0, ii = features.length; i < ii; ++i)render(features[i], i);
        this.renderedFeatures_ = features;
        this.ready = ready;
        const replayGroupInstructions = replayGroup.finish();
        const executorGroup = new (0, $f979fbd3c953bca1$export$2e2bcd8739ae039)(extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer(), !!frameState.declutter);
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedFrameDeclutter_ = !!frameState.declutter;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.renderedPixelRatio_ = pixelRatio;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    }
    /**
   * @param {import("../../Feature.js").default} feature Feature.
   * @param {number} squaredTolerance Squared render tolerance.
   * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
   * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
   * @param {import("../../proj.js").TransformFunction} [transform] Transform from user to view projection.
   * @param {boolean} [declutter] Enable decluttering.
   * @param {number} [index] Render order index.
   * @return {boolean} `true` if an image is loading.
   */ renderFeature(feature, squaredTolerance, styles, builderGroup, transform, declutter, index) {
        if (!styles) return false;
        let loading = false;
        if (Array.isArray(styles)) for(let i = 0, ii = styles.length; i < ii; ++i)loading = (0, $d9e0efcd90e741b9$export$36f470a33a42f413)(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index) || loading;
        else loading = (0, $d9e0efcd90e741b9$export$36f470a33a42f413)(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, transform, declutter, index);
        return loading;
    }
}
var $b6f9cff97736b00f$export$2e2bcd8739ae039 = $b6f9cff97736b00f$var$CanvasVectorLayerRenderer;


/**
 * @module ol/layer/BaseVector
 */ 
/**
 * @module ol/render/canvas/style
 */ 
/**
 * @module ol/expr/cpu
 */ 
/**
 * @module ol/expr/expression
 */ 


/**
 * @fileoverview This module includes types and functions for parsing array encoded expressions.
 * The result of parsing an encoded expression is one of the specific expression classes.
 * During parsing, information is added to the parsing context about the data accessed by the
 * expression.
 */ /**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link import("./expression.js").ExpressionValue} arguments.
 *
 * See below for details on the available operators (with notes for those that are WebGL or Canvas only).
 *
 * Reading operators:
 *   `['band', bandIndex, xOffset, yOffset]` For tile layers only. Fetches pixel values from band
 *     `bandIndex` of the source's data. The first `bandIndex` of the source data is `1`. Fetched values
 *     are in the 0..1 range. {@link import("../source/TileImage.js").default} sources have 4 bands: red,
 *     green, blue and alpha. {@link import("../source/DataTile.js").default} sources can have any number
 *     of bands, depending on the underlying data source and
 *     {@link import("../source/GeoTIFF.js").Options configuration}. `xOffset` and `yOffset` are optional
 *     and allow specifying pixel offsets for x and y. This is used for sampling data from neighboring pixels (WebGL only).
 *   `['get', attributeName]` fetches a feature property value, similar to `feature.get('attributeName')`.
 *   `['get', attributeName, keyOrArrayIndex, ...]` (Canvas only) Access nested properties and array items of a
 *     feature property. The result is `undefined` when there is nothing at the specified key or index.
 *   `['geometry-type']` returns a feature's geometry type as string, either: 'LineString', 'Point' or 'Polygon'
 *     `Multi*` values are returned as their singular equivalent
 *     `Circle` geometries are returned as 'Polygon'
 *     `GeometryCollection` geometries are returned as the type of the first geometry found in the collection (WebGL only).
 *   `['resolution']` returns the current resolution
 *   `['time']` The time in seconds since the creation of the layer (WebGL only).
 *   `['var', 'varName']` fetches a value from the style variables; will throw an error if that variable is undefined
 *   `['zoom']` The current zoom level (WebGL only).
 *   `['line-metric']` returns the M component of the current point on a line (WebGL only); in case where the geometry layout of the line
 *      does not contain an M component (e.g. XY or XYZ), 0 is returned; 0 is also returned for geometries other than lines.
 *      Please note that the M component will be linearly interpolated between the two points composing a segment.
 *
 * Math operators:
 *   `['*', value1, value2, ...]` multiplies the values (either numbers or colors)
 *   `['/', value1, value2]` divides `value1` by `value2`
 *   `['+', value1, value2, ...]` adds the values
 *   `['-', value1, value2]` subtracts `value2` from `value1`
 *   `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *   `['abs', value1]` returns the absolute value of `value1`
 *   `['floor', value1]` returns the nearest integer less than or equal to `value1`
 *   * `['round', value1]` returns the nearest integer to `value1`
 *   * `['ceil', value1]` returns the nearest integer greater than or equal to `value1`
 *   * `['sin', value1]` returns the sine of `value1`
 *   * `['cos', value1]` returns the cosine of `value1`
 *   * `['atan', value1, value2]` returns `atan2(value1, value2)`. If `value2` is not provided, returns `atan(value1)`
 *   * `['sqrt', value1]` returns the square root of `value1`
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *   * `['string', value1, value2, ...]` returns the first value in the list that evaluates to a string.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 'default value']]`
 *     (Canvas only).
 *   * `['number', value1, value2, ...]` returns the first value in the list that evaluates to a number.
 *     An example would be to provide a default value for get: `['string', ['get', 'propertyname'], 42]]`
 *     (Canvas only).
 *   * `['coalesce', value1, value2, ...]` returns the first value in the list which is not null or undefined.
 *     An example would be to provide a default value for get: `['coalesce', ['get','propertyname'], 'default value']]`
 *     (Canvas only).
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['has', attributeName, keyOrArrayIndex, ...]` returns `true` if feature properties include the (nested) key `attributeName`,
 *     `false` otherwise.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *   * `['in', needle, haystack]` returns `true` if `needle` is found in `haystack`, and
 *     `false` otherwise.
 *     This operator has the following limitations:
 *     * `haystack` has to be an array of numbers or strings (searching for a substring in a string is not supported yet)
 *     * Only literal arrays are supported as `haystack` for now; this means that `haystack` cannot be the result of an
 *     expression. If `haystack` is an array of strings, use the `literal` operator to disambiguate from an expression:
 *     `['literal', ['abc', 'def', 'ghi']]`
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4 (WebGL only).
 *   * `['color', red, green, blue, alpha]` or `['color', shade, alpha]` creates a `color` value from `number` values;
 *     the `alpha` parameter is optional; if not specified, it will be set to 1 (WebGL only).
 *     Note: `red`, `green` and `blue` or `shade` components must be values between 0 and 255; `alpha` between 0 and 1.
 *   * `['palette', index, colors]` picks a `color` value from an array of colors using the given index; the `index`
 *     expression must evaluate to a number; the items in the `colors` array must be strings with hex colors
 *     (e.g. `'#86A136'`), colors using the rgba[a] functional notation (e.g. `'rgb(134, 161, 54)'` or `'rgba(134, 161, 54, 1)'`),
 *     named colors (e.g. `'red'`), or array literals with 3 ([r, g, b]) or 4 ([r, g, b, a]) values (with r, g, and b
 *     in the 0-255 range and a in the 0-1 range) (WebGL only).
 *   * `['to-string', value]` converts the input value to a string. If the input is a boolean, the result is "true" or "false".
 *     If the input is a number, it is converted to a string as specified by the "NumberToString" algorithm of the ECMAScript
 *     Language Specification. If the input is a color, it is converted to a string of the form "rgba(r,g,b,a)". (Canvas only)
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `number[]` (number arrays can only have a length of 2, 3 or 4)
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 * @api
 */ let $4bf85f096fb6de71$var$numTypes = 0;
const $4bf85f096fb6de71$export$267d7ad6fa96ffaf = 0;
const $4bf85f096fb6de71$export$240f7fffab1b25a0 = 1 << $4bf85f096fb6de71$var$numTypes++;
const $4bf85f096fb6de71$export$86a7aca748b1e260 = 1 << $4bf85f096fb6de71$var$numTypes++;
const $4bf85f096fb6de71$export$2b93044cbf134323 = 1 << $4bf85f096fb6de71$var$numTypes++;
const $4bf85f096fb6de71$export$2cd82751acc0e609 = 1 << $4bf85f096fb6de71$var$numTypes++;
const $4bf85f096fb6de71$export$d701d0e49f4bcb39 = 1 << $4bf85f096fb6de71$var$numTypes++;
const $4bf85f096fb6de71$export$52725c8a6d4c61d1 = 1 << $4bf85f096fb6de71$var$numTypes++;
const $4bf85f096fb6de71$export$ec4c9a150bae86cd = Math.pow(2, $4bf85f096fb6de71$var$numTypes) - 1;
const $4bf85f096fb6de71$var$typeNames = {
    [$4bf85f096fb6de71$export$240f7fffab1b25a0]: 'boolean',
    [$4bf85f096fb6de71$export$86a7aca748b1e260]: 'number',
    [$4bf85f096fb6de71$export$2b93044cbf134323]: 'string',
    [$4bf85f096fb6de71$export$2cd82751acc0e609]: 'color',
    [$4bf85f096fb6de71$export$d701d0e49f4bcb39]: 'number[]',
    [$4bf85f096fb6de71$export$52725c8a6d4c61d1]: 'size'
};
const $4bf85f096fb6de71$var$namedTypes = Object.keys($4bf85f096fb6de71$var$typeNames).map(Number).sort((0, $830d23b8323fc080$export$fcb633242ef15540));
/**
 * @param {number} type The type.
 * @return {boolean} The type is one of the specific types (not any or a union type).
 */ function $4bf85f096fb6de71$var$isSpecific(type) {
    return type in $4bf85f096fb6de71$var$typeNames;
}
function $4bf85f096fb6de71$export$b2afc7c96b2b4a45(type) {
    const names = [];
    for (const namedType of $4bf85f096fb6de71$var$namedTypes)if ($4bf85f096fb6de71$export$9fdcb8b441c4f2b4(type, namedType)) names.push($4bf85f096fb6de71$var$typeNames[namedType]);
    if (names.length === 0) return 'untyped';
    if (names.length < 3) return names.join(' or ');
    return names.slice(0, -1).join(', ') + ', or ' + names[names.length - 1];
}
function $4bf85f096fb6de71$export$9fdcb8b441c4f2b4(broad, specific) {
    return (broad & specific) === specific;
}
function $4bf85f096fb6de71$export$3252d368d784c970(oneType, otherType) {
    return !!(oneType & otherType);
}
function $4bf85f096fb6de71$export$26b9f946b448f23e(type, expected) {
    return type === expected;
}
class $4bf85f096fb6de71$export$eb63e96e0913dda4 {
    /**
   * @param {number} type The value type.
   * @param {LiteralValue} value The literal value.
   */ constructor(type, value){
        if (!$4bf85f096fb6de71$var$isSpecific(type)) throw new Error(`literal expressions must have a specific type, got ${$4bf85f096fb6de71$export$b2afc7c96b2b4a45(type)}`);
        this.type = type;
        this.value = value;
    }
}
class $4bf85f096fb6de71$export$6f3d80189eb72cd4 {
    /**
   * @param {number} type The return type.
   * @param {string} operator The operator.
   * @param {...Expression} args The arguments.
   */ constructor(type, operator, ...args){
        this.type = type;
        this.operator = operator;
        this.args = args;
    }
}
function $4bf85f096fb6de71$export$1c8b4c1584800354() {
    return {
        variables: new Set(),
        properties: new Set(),
        featureId: false,
        geometryType: false,
        mapState: false
    };
}
function $4bf85f096fb6de71$export$98e6a39c04603d36(encoded, expectedType, context) {
    switch(typeof encoded){
        case 'boolean':
            if ($4bf85f096fb6de71$export$26b9f946b448f23e(expectedType, $4bf85f096fb6de71$export$2b93044cbf134323)) return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$2b93044cbf134323, encoded ? 'true' : 'false');
            if (!$4bf85f096fb6de71$export$9fdcb8b441c4f2b4(expectedType, $4bf85f096fb6de71$export$240f7fffab1b25a0)) throw new Error(`got a boolean, but expected ${$4bf85f096fb6de71$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$240f7fffab1b25a0, encoded);
        case 'number':
            if ($4bf85f096fb6de71$export$26b9f946b448f23e(expectedType, $4bf85f096fb6de71$export$52725c8a6d4c61d1)) return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$52725c8a6d4c61d1, (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(encoded));
            if ($4bf85f096fb6de71$export$26b9f946b448f23e(expectedType, $4bf85f096fb6de71$export$240f7fffab1b25a0)) return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$240f7fffab1b25a0, !!encoded);
            if ($4bf85f096fb6de71$export$26b9f946b448f23e(expectedType, $4bf85f096fb6de71$export$2b93044cbf134323)) return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$2b93044cbf134323, encoded.toString());
            if (!$4bf85f096fb6de71$export$9fdcb8b441c4f2b4(expectedType, $4bf85f096fb6de71$export$86a7aca748b1e260)) throw new Error(`got a number, but expected ${$4bf85f096fb6de71$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$86a7aca748b1e260, encoded);
        case 'string':
            if ($4bf85f096fb6de71$export$26b9f946b448f23e(expectedType, $4bf85f096fb6de71$export$2cd82751acc0e609)) return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$2cd82751acc0e609, (0, $2c17bfc916c8f689$export$3004f64547af360e)(encoded));
            if ($4bf85f096fb6de71$export$26b9f946b448f23e(expectedType, $4bf85f096fb6de71$export$240f7fffab1b25a0)) return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$240f7fffab1b25a0, !!encoded);
            if (!$4bf85f096fb6de71$export$9fdcb8b441c4f2b4(expectedType, $4bf85f096fb6de71$export$2b93044cbf134323)) throw new Error(`got a string, but expected ${$4bf85f096fb6de71$export$b2afc7c96b2b4a45(expectedType)}`);
            return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$2b93044cbf134323, encoded);
        default:
    }
    if (!Array.isArray(encoded)) throw new Error('expression must be an array or a primitive value');
    if (encoded.length === 0) throw new Error('empty expression');
    if (typeof encoded[0] === 'string') return $4bf85f096fb6de71$var$parseCallExpression(encoded, expectedType, context);
    for (const item of encoded){
        if (typeof item !== 'number') throw new Error('expected an array of numbers');
    }
    if ($4bf85f096fb6de71$export$26b9f946b448f23e(expectedType, $4bf85f096fb6de71$export$52725c8a6d4c61d1)) {
        if (encoded.length !== 2) throw new Error(`expected an array of two values for a size, got ${encoded.length}`);
        return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$52725c8a6d4c61d1, encoded);
    }
    if ($4bf85f096fb6de71$export$26b9f946b448f23e(expectedType, $4bf85f096fb6de71$export$2cd82751acc0e609)) {
        if (encoded.length === 3) return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$2cd82751acc0e609, [
            ...encoded,
            1
        ]);
        if (encoded.length === 4) return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$2cd82751acc0e609, encoded);
        throw new Error(`expected an array of 3 or 4 values for a color, got ${encoded.length}`);
    }
    if (!$4bf85f096fb6de71$export$9fdcb8b441c4f2b4(expectedType, $4bf85f096fb6de71$export$d701d0e49f4bcb39)) throw new Error(`got an array of numbers, but expected ${$4bf85f096fb6de71$export$b2afc7c96b2b4a45(expectedType)}`);
    return new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$d701d0e49f4bcb39, encoded);
}
const $4bf85f096fb6de71$export$2655e45458bc48f3 = {
    Get: 'get',
    Var: 'var',
    Concat: 'concat',
    GeometryType: 'geometry-type',
    LineMetric: 'line-metric',
    Any: 'any',
    All: 'all',
    Not: '!',
    Resolution: 'resolution',
    Zoom: 'zoom',
    Time: 'time',
    Equal: '==',
    NotEqual: '!=',
    GreaterThan: '>',
    GreaterThanOrEqualTo: '>=',
    LessThan: '<',
    LessThanOrEqualTo: '<=',
    Multiply: '*',
    Divide: '/',
    Add: '+',
    Subtract: '-',
    Clamp: 'clamp',
    Mod: '%',
    Pow: '^',
    Abs: 'abs',
    Floor: 'floor',
    Ceil: 'ceil',
    Round: 'round',
    Sin: 'sin',
    Cos: 'cos',
    Atan: 'atan',
    Sqrt: 'sqrt',
    Match: 'match',
    Between: 'between',
    Interpolate: 'interpolate',
    Coalesce: 'coalesce',
    Case: 'case',
    In: 'in',
    Number: 'number',
    String: 'string',
    Array: 'array',
    Color: 'color',
    Id: 'id',
    Band: 'band',
    Palette: 'palette',
    ToString: 'to-string',
    Has: 'has'
};
/**
 * @typedef {function(Array, number, ParsingContext):Expression} Parser
 *
 * Second argument is the expected type.
 */ /**
 * @type {Object<string, Parser>}
 */ const $4bf85f096fb6de71$var$parsers = {
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Get]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, Infinity), $4bf85f096fb6de71$var$withGetArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Var]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 1), $4bf85f096fb6de71$var$withVarArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Has]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, Infinity), $4bf85f096fb6de71$var$withGetArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Id]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$usesFeatureId, $4bf85f096fb6de71$var$withNoArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Concat]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, Infinity), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$2b93044cbf134323)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.GeometryType]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$usesGeometryType, $4bf85f096fb6de71$var$withNoArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.LineMetric]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$withNoArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Resolution]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$usesMapState, $4bf85f096fb6de71$var$withNoArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Zoom]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$usesMapState, $4bf85f096fb6de71$var$withNoArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Time]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$usesMapState, $4bf85f096fb6de71$var$withNoArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Any]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, Infinity), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$240f7fffab1b25a0)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.All]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, Infinity), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$240f7fffab1b25a0)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Not]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 1), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$240f7fffab1b25a0)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Equal]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$ec4c9a150bae86cd)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.NotEqual]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$ec4c9a150bae86cd)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.GreaterThan]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.GreaterThanOrEqualTo]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.LessThan]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.LessThanOrEqualTo]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Multiply]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, Infinity), $4bf85f096fb6de71$var$withArgsOfReturnType),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Coalesce]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, Infinity), $4bf85f096fb6de71$var$withArgsOfReturnType),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Divide]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Add]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, Infinity), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Subtract]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Clamp]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(3, 3), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Mod]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Pow]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Abs]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 1), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Floor]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 1), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Ceil]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 1), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Round]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 1), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Sin]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 1), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Cos]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 1), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Atan]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 2), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Sqrt]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 1), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Match]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(4, Infinity), $4bf85f096fb6de71$var$hasEvenArgs, $4bf85f096fb6de71$var$withMatchArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Between]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(3, 3), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Interpolate]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(6, Infinity), $4bf85f096fb6de71$var$hasEvenArgs, $4bf85f096fb6de71$var$withInterpolateArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Case]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(3, Infinity), $4bf85f096fb6de71$var$hasOddArgs, $4bf85f096fb6de71$var$withCaseArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.In]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withInArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Number]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, Infinity), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$ec4c9a150bae86cd)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.String]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, Infinity), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$ec4c9a150bae86cd)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Array]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, Infinity), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Color]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 4), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Band]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 3), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$86a7aca748b1e260)),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.Palette]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(2, 2), $4bf85f096fb6de71$var$withPaletteArgs),
    [$4bf85f096fb6de71$export$2655e45458bc48f3.ToString]: $4bf85f096fb6de71$var$createCallExpressionParser($4bf85f096fb6de71$var$hasArgsCount(1, 1), $4bf85f096fb6de71$var$withArgsOfType($4bf85f096fb6de71$export$240f7fffab1b25a0 | $4bf85f096fb6de71$export$86a7aca748b1e260 | $4bf85f096fb6de71$export$2b93044cbf134323 | $4bf85f096fb6de71$export$2cd82751acc0e609))
};
/**
 * @typedef {function(Array<EncodedExpression>, number, ParsingContext):Array<Expression>|void} ArgValidator
 *
 * An argument validator applies various checks to an encoded expression arguments and
 * returns the parsed arguments if any.  The second argument is the return type of the call expression.
 */ /**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$withGetArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const args = new Array(argsCount);
    for(let i = 0; i < argsCount; ++i){
        const key = encoded[i + 1];
        switch(typeof key){
            case 'number':
                args[i] = new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$86a7aca748b1e260, key);
                break;
            case 'string':
                args[i] = new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$2b93044cbf134323, key);
                break;
            default:
                throw new Error(`expected a string key or numeric array index for a get operation, got ${key}`);
        }
        if (i === 0) context.properties.add(String(key));
    }
    return args;
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$withVarArgs(encoded, returnType, context) {
    const name = encoded[1];
    if (typeof name !== 'string') throw new Error('expected a string argument for var operation');
    context.variables.add(name);
    return [
        new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$2b93044cbf134323, name)
    ];
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$usesFeatureId(encoded, returnType, context) {
    context.featureId = true;
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$usesGeometryType(encoded, returnType, context) {
    context.geometryType = true;
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$usesMapState(encoded, returnType, context) {
    context.mapState = true;
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$withNoArgs(encoded, returnType, context) {
    const operation = encoded[0];
    if (encoded.length !== 1) throw new Error(`expected no arguments for ${operation} operation`);
    return [];
}
/**
 * @param {number} minArgs The minimum number of arguments.
 * @param {number} maxArgs The maximum number of arguments.
 * @return {ArgValidator} The argument validator
 */ function $4bf85f096fb6de71$var$hasArgsCount(minArgs, maxArgs) {
    return function(encoded, returnType, context) {
        const operation = encoded[0];
        const argCount = encoded.length - 1;
        if (minArgs === maxArgs) {
            if (argCount !== minArgs) {
                const plural = minArgs === 1 ? '' : 's';
                throw new Error(`expected ${minArgs} argument${plural} for ${operation}, got ${argCount}`);
            }
        } else if (argCount < minArgs || argCount > maxArgs) {
            const range = maxArgs === Infinity ? `${minArgs} or more` : `${minArgs} to ${maxArgs}`;
            throw new Error(`expected ${range} arguments for ${operation}, got ${argCount}`);
        }
    };
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$withArgsOfReturnType(encoded, returnType, context) {
    const argCount = encoded.length - 1;
    /**
   * @type {Array<Expression>}
   */ const args = new Array(argCount);
    for(let i = 0; i < argCount; ++i){
        const expression = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[i + 1], returnType, context);
        args[i] = expression;
    }
    return args;
}
/**
 * @param {number} argType The argument type.
 * @return {ArgValidator} The argument validator
 */ function $4bf85f096fb6de71$var$withArgsOfType(argType) {
    return function(encoded, returnType, context) {
        const argCount = encoded.length - 1;
        /**
     * @type {Array<Expression>}
     */ const args = new Array(argCount);
        for(let i = 0; i < argCount; ++i){
            const expression = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[i + 1], argType, context);
            args[i] = expression;
        }
        return args;
    };
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$hasOddArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 0) throw new Error(`expected an odd number of arguments for ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$hasEvenArgs(encoded, returnType, context) {
    const operation = encoded[0];
    const argCount = encoded.length - 1;
    if (argCount % 2 === 1) throw new Error(`expected an even number of arguments for operation ${operation}, got ${argCount} instead`);
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$withMatchArgs(encoded, returnType, context) {
    const argsCount = encoded.length - 1;
    const inputType = $4bf85f096fb6de71$export$2b93044cbf134323 | $4bf85f096fb6de71$export$86a7aca748b1e260 | $4bf85f096fb6de71$export$240f7fffab1b25a0;
    const input = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[1], inputType, context);
    const fallback = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(argsCount - 2);
    for(let i = 0; i < argsCount - 2; i += 2){
        try {
            const match = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[i + 2], input.type, context);
            args[i] = match;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of match expression: ${err.message}`);
        }
        try {
            const output = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[i + 3], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} of match expression: ${err.message}`);
        }
    }
    return [
        input,
        ...args,
        fallback
    ];
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$withInterpolateArgs(encoded, returnType, context) {
    const interpolationType = encoded[1];
    /**
   * @type {number}
   */ let base;
    switch(interpolationType[0]){
        case 'linear':
            base = 1;
            break;
        case 'exponential':
            const b = interpolationType[1];
            if (typeof b !== 'number' || b <= 0) throw new Error(`expected a number base for exponential interpolation` + `, got ${JSON.stringify(b)} instead`);
            base = b;
            break;
        default:
            throw new Error(`invalid interpolation type: ${JSON.stringify(interpolationType)}`);
    }
    const interpolation = new $4bf85f096fb6de71$export$eb63e96e0913dda4($4bf85f096fb6de71$export$86a7aca748b1e260, base);
    let input;
    try {
        input = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[2], $4bf85f096fb6de71$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse argument 1 in interpolate expression: ${err.message}`);
    }
    const args = new Array(encoded.length - 3);
    for(let i = 0; i < args.length; i += 2){
        try {
            const stop = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[i + 3], $4bf85f096fb6de71$export$86a7aca748b1e260, context);
            args[i] = stop;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 2} for interpolate expression: ${err.message}`);
        }
        try {
            const output = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[i + 4], returnType, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 3} for interpolate expression: ${err.message}`);
        }
    }
    return [
        interpolation,
        input,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$withCaseArgs(encoded, returnType, context) {
    const fallback = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[encoded.length - 1], returnType, context);
    const args = new Array(encoded.length - 1);
    for(let i = 0; i < args.length - 1; i += 2){
        try {
            const condition = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[i + 1], $4bf85f096fb6de71$export$240f7fffab1b25a0, context);
            args[i] = condition;
        } catch (err) {
            throw new Error(`failed to parse argument ${i} of case expression: ${err.message}`);
        }
        try {
            const output = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[i + 2], fallback.type, context);
            args[i + 1] = output;
        } catch (err) {
            throw new Error(`failed to parse argument ${i + 1} of case expression: ${err.message}`);
        }
    }
    args[args.length - 1] = fallback;
    return args;
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$withInArgs(encoded, returnType, context) {
    let haystack = encoded[2];
    if (!Array.isArray(haystack)) throw new Error(`the second argument for the "in" operator must be an array`);
    /**
   * @type {number}
   */ let needleType;
    if (typeof haystack[0] === 'string') {
        if (haystack[0] !== 'literal') throw new Error(`for the "in" operator, a string array should be wrapped in a "literal" operator to disambiguate from expressions`);
        if (!Array.isArray(haystack[1])) throw new Error(`failed to parse "in" expression: the literal operator must be followed by an array`);
        haystack = haystack[1];
        needleType = $4bf85f096fb6de71$export$2b93044cbf134323;
    } else needleType = $4bf85f096fb6de71$export$86a7aca748b1e260;
    const args = new Array(haystack.length);
    for(let i = 0; i < args.length; i++)try {
        const arg = $4bf85f096fb6de71$export$98e6a39c04603d36(haystack[i], needleType, context);
        args[i] = arg;
    } catch (err) {
        throw new Error(`failed to parse haystack item ${i} for "in" expression: ${err.message}`);
    }
    const needle = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[1], needleType, context);
    return [
        needle,
        ...args
    ];
}
/**
 * @type {ArgValidator}
 */ function $4bf85f096fb6de71$var$withPaletteArgs(encoded, returnType, context) {
    let index;
    try {
        index = $4bf85f096fb6de71$export$98e6a39c04603d36(encoded[1], $4bf85f096fb6de71$export$86a7aca748b1e260, context);
    } catch (err) {
        throw new Error(`failed to parse first argument in palette expression: ${err.message}`);
    }
    const colors = encoded[2];
    if (!Array.isArray(colors)) throw new Error('the second argument of palette must be an array');
    const parsedColors = new Array(colors.length);
    for(let i = 0; i < parsedColors.length; i++){
        let color;
        try {
            color = $4bf85f096fb6de71$export$98e6a39c04603d36(colors[i], $4bf85f096fb6de71$export$2cd82751acc0e609, context);
        } catch (err) {
            throw new Error(`failed to parse color at index ${i} in palette expression: ${err.message}`);
        }
        if (!(color instanceof $4bf85f096fb6de71$export$eb63e96e0913dda4)) throw new Error(`the palette color at index ${i} must be a literal value`);
        parsedColors[i] = color;
    }
    return [
        index,
        ...parsedColors
    ];
}
/**
 * @param {Array<ArgValidator>} validators A chain of argument validators.  The last validator is expected
 * to return the parsed arguments.
 * @return {Parser} The parser.
 */ function $4bf85f096fb6de71$var$createCallExpressionParser(...validators) {
    return function(encoded, returnType, context) {
        const operator = encoded[0];
        /**
     * @type {Array<Expression>}
     */ let args;
        for(let i = 0; i < validators.length; i++){
            const parsed = validators[i](encoded, returnType, context);
            if (i == validators.length - 1) {
                if (!parsed) throw new Error('expected last argument validator to return the parsed args');
                args = parsed;
            }
        }
        return new $4bf85f096fb6de71$export$6f3d80189eb72cd4(returnType, operator, ...args);
    };
}
/**
 * @param {Array} encoded The encoded expression.
 * @param {number} returnType The expected return type of the call expression.
 * @param {ParsingContext} context The parsing context.
 * @return {Expression} The parsed expression.
 */ function $4bf85f096fb6de71$var$parseCallExpression(encoded, returnType, context) {
    const operator = encoded[0];
    const parser = $4bf85f096fb6de71$var$parsers[operator];
    if (!parser) throw new Error(`unknown operator: ${operator}`);
    return parser(encoded, returnType, context);
}
function $4bf85f096fb6de71$export$8da88d86d10c1295(geometry) {
    if (!geometry) return '';
    const type = geometry.getType();
    switch(type){
        case 'Point':
        case 'LineString':
        case 'Polygon':
            return type;
        case 'MultiPoint':
        case 'MultiLineString':
        case 'MultiPolygon':
            return /** @type {'Point'|'LineString'|'Polygon'} */ type.substring(5);
        case 'Circle':
            return 'Polygon';
        case 'GeometryCollection':
            return $4bf85f096fb6de71$export$8da88d86d10c1295(/** @type {import("../geom/GeometryCollection.js").default} */ geometry.getGeometries()[0]);
        default:
            return '';
    }
}


function $4bcbbad0e5f222a3$export$c18f39f0e136c26() {
    return {
        variables: {},
        properties: {},
        resolution: NaN,
        featureId: null,
        geometryType: ''
    };
}
function $4bcbbad0e5f222a3$export$b5f535122a9211f0(encoded, type, context) {
    const expression = (0, $4bf85f096fb6de71$export$98e6a39c04603d36)(encoded, type, context);
    return $4bcbbad0e5f222a3$var$compileExpression(expression, context);
}
/**
 * @param {import("./expression.js").Expression} expression The expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $4bcbbad0e5f222a3$var$compileExpression(expression, context) {
    if (expression instanceof (0, $4bf85f096fb6de71$export$eb63e96e0913dda4)) {
        // convert colors to array if possible
        if (expression.type === (0, $4bf85f096fb6de71$export$2cd82751acc0e609) && typeof expression.value === 'string') {
            const colorValue = (0, $2c17bfc916c8f689$export$3004f64547af360e)(expression.value);
            return function() {
                return colorValue;
            };
        }
        return function() {
            return expression.value;
        };
    }
    const operator = expression.operator;
    switch(operator){
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Number:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).String:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Coalesce:
            return $4bcbbad0e5f222a3$var$compileAssertionExpression(expression, context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Get:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Var:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Has:
            return $4bcbbad0e5f222a3$var$compileAccessorExpression(expression, context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Id:
            return (context)=>context.featureId;
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).GeometryType:
            return (context)=>context.geometryType;
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Concat:
            {
                const args = expression.args.map((e)=>$4bcbbad0e5f222a3$var$compileExpression(e, context));
                return (context)=>''.concat(...args.map((arg)=>arg(context).toString()));
            }
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Resolution:
            return (context)=>context.resolution;
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Any:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).All:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Between:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).In:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Not:
            return $4bcbbad0e5f222a3$var$compileLogicalExpression(expression, context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Equal:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).NotEqual:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).LessThan:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).LessThanOrEqualTo:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).GreaterThan:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return $4bcbbad0e5f222a3$var$compileComparisonExpression(expression, context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Multiply:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Divide:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Add:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Subtract:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Clamp:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Mod:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Pow:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Abs:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Floor:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Ceil:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Round:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Sin:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Cos:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Atan:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Sqrt:
            return $4bcbbad0e5f222a3$var$compileNumericExpression(expression, context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Case:
            return $4bcbbad0e5f222a3$var$compileCaseExpression(expression, context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Match:
            return $4bcbbad0e5f222a3$var$compileMatchExpression(expression, context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Interpolate:
            return $4bcbbad0e5f222a3$var$compileInterpolateExpression(expression, context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).ToString:
            return $4bcbbad0e5f222a3$var$compileConvertExpression(expression, context);
        default:
            throw new Error(`Unsupported operator ${operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $4bcbbad0e5f222a3$var$compileAssertionExpression(expression, context) {
    const type = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $4bcbbad0e5f222a3$var$compileExpression(expression.args[i], context);
    switch(type){
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Coalesce:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value !== 'undefined' && value !== null) return value;
                }
                throw new Error('Expected one of the values to be non-null');
            };
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Number:
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).String:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    const value = args[i](context);
                    if (typeof value === type) return value;
                }
                throw new Error(`Expected one of the values to be a ${type}`);
            };
        default:
            throw new Error(`Unsupported assertion operator ${type}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $4bcbbad0e5f222a3$var$compileAccessorExpression(expression, context) {
    const nameExpression = /** @type {LiteralExpression} */ expression.args[0];
    const name = /** @type {string} */ nameExpression.value;
    switch(expression.operator){
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Get:
            return (context)=>{
                const args = expression.args;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    value = value[key];
                }
                return value;
            };
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Var:
            return (context)=>context.variables[name];
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Has:
            return (context)=>{
                const args = expression.args;
                if (!(name in context.properties)) return false;
                let value = context.properties[name];
                for(let i = 1, ii = args.length; i < ii; ++i){
                    const keyExpression = /** @type {LiteralExpression} */ args[i];
                    const key = /** @type {string|number} */ keyExpression.value;
                    if (!value || !Object.hasOwn(value, key)) return false;
                    value = value[key];
                }
                return true;
            };
        default:
            throw new Error(`Unsupported accessor operator ${expression.operator}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $4bcbbad0e5f222a3$var$compileComparisonExpression(expression, context) {
    const op = expression.operator;
    const left = $4bcbbad0e5f222a3$var$compileExpression(expression.args[0], context);
    const right = $4bcbbad0e5f222a3$var$compileExpression(expression.args[1], context);
    switch(op){
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Equal:
            return (context)=>left(context) === right(context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).NotEqual:
            return (context)=>left(context) !== right(context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).LessThan:
            return (context)=>left(context) < right(context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).LessThanOrEqualTo:
            return (context)=>left(context) <= right(context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).GreaterThan:
            return (context)=>left(context) > right(context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).GreaterThanOrEqualTo:
            return (context)=>left(context) >= right(context);
        default:
            throw new Error(`Unsupported comparison operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {BooleanEvaluator} The evaluator function.
 */ function $4bcbbad0e5f222a3$var$compileLogicalExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $4bcbbad0e5f222a3$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Any:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (args[i](context)) return true;
                }
                return false;
            };
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).All:
            return (context)=>{
                for(let i = 0; i < length; ++i){
                    if (!args[i](context)) return false;
                }
                return true;
            };
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Between:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                const max = args[2](context);
                return value >= min && value <= max;
            };
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).In:
            return (context)=>{
                const value = args[0](context);
                for(let i = 1; i < length; ++i){
                    if (value === args[i](context)) return true;
                }
                return false;
            };
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Not:
            return (context)=>!args[0](context);
        default:
            throw new Error(`Unsupported logical operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {NumberEvaluator} The evaluator function.
 */ function $4bcbbad0e5f222a3$var$compileNumericExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $4bcbbad0e5f222a3$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Multiply:
            return (context)=>{
                let value = 1;
                for(let i = 0; i < length; ++i)value *= args[i](context);
                return value;
            };
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Divide:
            return (context)=>args[0](context) / args[1](context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Add:
            return (context)=>{
                let value = 0;
                for(let i = 0; i < length; ++i)value += args[i](context);
                return value;
            };
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Subtract:
            return (context)=>args[0](context) - args[1](context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Clamp:
            return (context)=>{
                const value = args[0](context);
                const min = args[1](context);
                if (value < min) return min;
                const max = args[2](context);
                if (value > max) return max;
                return value;
            };
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Mod:
            return (context)=>args[0](context) % args[1](context);
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Pow:
            return (context)=>Math.pow(args[0](context), args[1](context));
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Abs:
            return (context)=>Math.abs(args[0](context));
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Floor:
            return (context)=>Math.floor(args[0](context));
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Ceil:
            return (context)=>Math.ceil(args[0](context));
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Round:
            return (context)=>Math.round(args[0](context));
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Sin:
            return (context)=>Math.sin(args[0](context));
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Cos:
            return (context)=>Math.cos(args[0](context));
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Atan:
            if (length === 2) return (context)=>Math.atan2(args[0](context), args[1](context));
            return (context)=>Math.atan(args[0](context));
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).Sqrt:
            return (context)=>Math.sqrt(args[0](context));
        default:
            throw new Error(`Unsupported numeric operator ${op}`);
    }
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $4bcbbad0e5f222a3$var$compileCaseExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $4bcbbad0e5f222a3$var$compileExpression(expression.args[i], context);
    return (context)=>{
        for(let i = 0; i < length - 1; i += 2){
            const condition = args[i](context);
            if (condition) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $4bcbbad0e5f222a3$var$compileMatchExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $4bcbbad0e5f222a3$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const value = args[0](context);
        for(let i = 1; i < length; i += 2){
            if (value === args[i](context)) return args[i + 1](context);
        }
        return args[length - 1](context);
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $4bcbbad0e5f222a3$var$compileInterpolateExpression(expression, context) {
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $4bcbbad0e5f222a3$var$compileExpression(expression.args[i], context);
    return (context)=>{
        const base = args[0](context);
        const value = args[1](context);
        let previousInput;
        let previousOutput;
        for(let i = 2; i < length; i += 2){
            const input = args[i](context);
            let output = args[i + 1](context);
            const isColor = Array.isArray(output);
            if (isColor) output = (0, $2c17bfc916c8f689$export$138c09bdd6bd797c)(output);
            if (input >= value) {
                if (i === 2) return output;
                if (isColor) return $4bcbbad0e5f222a3$var$interpolateColor(base, value, previousInput, previousOutput, input, output);
                return $4bcbbad0e5f222a3$var$interpolateNumber(base, value, previousInput, previousOutput, input, output);
            }
            previousInput = input;
            previousOutput = output;
        }
        return previousOutput;
    };
}
/**
 * @param {import('./expression.js').CallExpression} expression The call expression.
 * @param {import('./expression.js').ParsingContext} context The parsing context.
 * @return {ExpressionEvaluator} The evaluator function.
 */ function $4bcbbad0e5f222a3$var$compileConvertExpression(expression, context) {
    const op = expression.operator;
    const length = expression.args.length;
    const args = new Array(length);
    for(let i = 0; i < length; ++i)args[i] = $4bcbbad0e5f222a3$var$compileExpression(expression.args[i], context);
    switch(op){
        case (0, $4bf85f096fb6de71$export$2655e45458bc48f3).ToString:
            return (context)=>{
                const value = args[0](context);
                if (expression.args[0].type === (0, $4bf85f096fb6de71$export$2cd82751acc0e609)) return (0, $2c17bfc916c8f689$export$f84e8e69fd4488a5)(value);
                return value.toString();
            };
        default:
            throw new Error(`Unsupported convert operator ${op}`);
    }
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {number} output1 The first output value.
 * @param {number} input2 The second input value.
 * @param {number} output2 The second output value.
 * @return {number} The interpolated value.
 */ function $4bcbbad0e5f222a3$var$interpolateNumber(base, value, input1, output1, input2, output2) {
    const delta = input2 - input1;
    if (delta === 0) return output1;
    const along = value - input1;
    const factor = base === 1 ? along / delta : (Math.pow(base, along) - 1) / (Math.pow(base, delta) - 1);
    return output1 + factor * (output2 - output1);
}
/**
 * @param {number} base The base.
 * @param {number} value The value.
 * @param {number} input1 The first input value.
 * @param {import('../color.js').Color} rgba1 The first output value.
 * @param {number} input2 The second input value.
 * @param {import('../color.js').Color} rgba2 The second output value.
 * @return {import('../color.js').Color} The interpolated color.
 */ function $4bcbbad0e5f222a3$var$interpolateColor(base, value, input1, rgba1, input2, rgba2) {
    const delta = input2 - input1;
    if (delta === 0) return rgba1;
    const lcha1 = (0, $2c17bfc916c8f689$export$44fb54fa2e0c0d4)(rgba1);
    const lcha2 = (0, $2c17bfc916c8f689$export$44fb54fa2e0c0d4)(rgba2);
    let deltaHue = lcha2[2] - lcha1[2];
    if (deltaHue > 180) deltaHue -= 360;
    else if (deltaHue < -180) deltaHue += 360;
    const lcha = [
        $4bcbbad0e5f222a3$var$interpolateNumber(base, value, input1, lcha1[0], input2, lcha2[0]),
        $4bcbbad0e5f222a3$var$interpolateNumber(base, value, input1, lcha1[1], input2, lcha2[1]),
        lcha1[2] + $4bcbbad0e5f222a3$var$interpolateNumber(base, value, input1, 0, input2, deltaHue),
        $4bcbbad0e5f222a3$var$interpolateNumber(base, value, input1, rgba1[3], input2, rgba2[3])
    ];
    return (0, $2c17bfc916c8f689$export$a3295358bff77e)((0, $2c17bfc916c8f689$export$27cc94530c050f00)(lcha));
}





/**
 * @module ol/style/Circle
 */ /**
 * @module ol/style/RegularShape
 */ 







/**
 * Specify radius for regular polygons, or both radius and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} radius Radius of a regular polygon.
 * @property {number} [radius2] Second radius to make a star instead of a regular polygon.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's points facing up.
 * @property {Array<number>} [displacement=[0, 0]] Displacement of the shape in pixels.
 * Positive values will shift the shape right and up.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius` and `radius2`.
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode.
 */ /**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike|undefined} strokeStyle StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>|null} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */ /**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when both `radius` and
 * `radius2` are provided.
 * @api
 */ class $02d7f73313b743b3$var$RegularShape extends (0, $982c1d3baf3da6dc$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        super({
            opacity: 1,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
        /**
     * @private
     * @type {HTMLCanvasElement|null}
     */ this.hitDetectionCanvas_ = null;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {Array<number>}
     */ this.origin_ = [
            0,
            0
        ];
        /**
     * @private
     * @type {number}
     */ this.points_ = options.points;
        /**
     * @protected
     * @type {number}
     */ this.radius = options.radius;
        /**
     * @private
     * @type {number|undefined}
     */ this.radius2_ = options.radius2;
        /**
     * @private
     * @type {number}
     */ this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.size_;
        /**
     * @private
     * @type {RenderOptions}
     */ this.renderOptions_;
        /**
     * @private
     */ this.imageState_ = this.fill_ && this.fill_.loading() ? (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING : (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED;
        if (this.imageState_ === (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING) this.ready().then(()=>this.imageState_ = (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED);
        this.render();
    }
    /**
   * Clones the style.
   * @return {RegularShape} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $02d7f73313b743b3$var$RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Get the anchor point in pixels. The anchor determines the center point for the
   * symbolizer.
   * @return {Array<number>} Anchor.
   * @api
   * @override
   */ getAnchor() {
        const size = this.size_;
        const displacement = this.getDisplacement();
        const scale = this.getScaleArray();
        // anchor is scaled by renderer but displacement should not be scaled
        // so divide by scale here
        return [
            size[0] / 2 - displacement[0] / scale[0],
            size[1] / 2 + displacement[1] / scale[1]
        ];
    }
    /**
   * Get the angle used in generating the shape.
   * @return {number} Shape's rotation in radians.
   * @api
   */ getAngle() {
        return this.angle_;
    }
    /**
   * Get the fill style for the shape.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
        this.render();
    }
    /**
   * @return {HTMLCanvasElement} Image element.
   * @override
   */ getHitDetectionImage() {
        if (!this.hitDetectionCanvas_) this.hitDetectionCanvas_ = this.createHitDetectionCanvas_(this.renderOptions_);
        return this.hitDetectionCanvas_;
    }
    /**
   * Get the image icon.
   * @param {number} pixelRatio Pixel ratio.
   * @return {HTMLCanvasElement} Image or Canvas element.
   * @api
   * @override
   */ getImage(pixelRatio) {
        const fillKey = this.fill_?.getKey();
        const cacheKey = `${pixelRatio},${this.angle_},${this.radius},${this.radius2_},${this.points_},${fillKey}` + Object.values(this.renderOptions_).join(',');
        let image = /** @type {HTMLCanvasElement} */ (0, $20f070df2eea68ee$export$747ccdf771a87ab8).get(cacheKey, null, null)?.getImage(1);
        if (!image) {
            const renderOptions = this.renderOptions_;
            const size = Math.ceil(renderOptions.size * pixelRatio);
            const context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(size, size);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            (0, $20f070df2eea68ee$export$747ccdf771a87ab8).set(cacheKey, null, null, new (0, $33bba60ac8fc0af6$export$2e2bcd8739ae039)(image, undefined, null, (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADED, null));
        }
        return image;
    }
    /**
   * Get the image pixel ratio.
   * @param {number} pixelRatio Pixel ratio.
   * @return {number} Pixel ratio.
   * @override
   */ getPixelRatio(pixelRatio) {
        return pixelRatio;
    }
    /**
   * @return {import("../size.js").Size} Image size.
   * @override
   */ getImageSize() {
        return this.size_;
    }
    /**
   * @return {import("../ImageState.js").default} Image state.
   * @override
   */ getImageState() {
        return this.imageState_;
    }
    /**
   * Get the origin of the symbolizer.
   * @return {Array<number>} Origin.
   * @api
   * @override
   */ getOrigin() {
        return this.origin_;
    }
    /**
   * Get the number of points for generating the shape.
   * @return {number} Number of points for stars and regular polygons.
   * @api
   */ getPoints() {
        return this.points_;
    }
    /**
   * Get the (primary) radius for the shape.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return this.radius;
    }
    /**
   * Get the secondary radius for the shape.
   * @return {number|undefined} Radius2.
   * @api
   */ getRadius2() {
        return this.radius2_;
    }
    /**
   * Get the size of the symbolizer (in pixels).
   * @return {import("../size.js").Size} Size.
   * @api
   * @override
   */ getSize() {
        return this.size_;
    }
    /**
   * Get the stroke style for the shape.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
        this.render();
    }
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ listenImageChange(listener) {}
    /**
   * Load not yet loaded URI.
   * @override
   */ load() {}
    /**
   * @param {function(import("../events/Event.js").default): void} listener Listener function.
   * @override
   */ unlistenImageChange(listener) {}
    /**
   * Calculate additional canvas size needed for the miter.
   * @param {string} lineJoin Line join
   * @param {number} strokeWidth Stroke width
   * @param {number} miterLimit Miter limit
   * @return {number} Additional canvas size needed
   * @private
   */ calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 || this.points_ === Infinity || lineJoin !== 'bevel' && lineJoin !== 'miter') return strokeWidth;
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        let r1 = this.radius;
        let r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            const tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        const points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        const alpha = 2 * Math.PI / points;
        const a = r2 * Math.sin(alpha);
        const b = Math.sqrt(r2 * r2 - a * a);
        const d = r1 - b;
        const e = Math.sqrt(a * a + d * d);
        const miterRatio = e / a;
        if (lineJoin === 'miter' && miterRatio <= miterLimit) return miterRatio * strokeWidth;
        // Calculate the distance from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        const k = strokeWidth / 2 / miterRatio;
        const l = strokeWidth / 2 * (d / e);
        const maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        const bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === 'bevel') return bevelAdd * 2;
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        const aa = r1 * Math.sin(alpha);
        const bb = Math.sqrt(r1 * r1 - aa * aa);
        const dd = r2 - bb;
        const ee = Math.sqrt(aa * aa + dd * dd);
        const innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            const innerLength = innerMiterRatio * strokeWidth / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    }
    /**
   * @return {RenderOptions}  The render options
   * @protected
   */ createRenderOptions() {
        let lineCap = (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e);
        let lineJoin = (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0);
        let miterLimit = 0;
        let lineDash = null;
        let lineDashOffset = 0;
        let strokeStyle;
        let strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(this.stroke_.getColor() ?? (0, $c8f894129d9fa0b9$export$1eb2eaecacf2031e));
            strokeWidth = this.stroke_.getWidth() ?? (0, $c8f894129d9fa0b9$export$79661f132c62010e);
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset() ?? 0;
            lineJoin = this.stroke_.getLineJoin() ?? (0, $c8f894129d9fa0b9$export$365eb9648cf19bd0);
            lineCap = this.stroke_.getLineCap() ?? (0, $c8f894129d9fa0b9$export$17bd0c38d6ae694e);
            miterLimit = this.stroke_.getMiterLimit() ?? (0, $c8f894129d9fa0b9$export$80c1c01844597b7b);
        }
        const add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        const maxRadius = Math.max(this.radius, this.radius2_ || 0);
        const size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit
        };
    }
    /**
   * @protected
   */ render() {
        this.renderOptions_ = this.createRenderOptions();
        const size = this.renderOptions_.size;
        this.hitDetectionCanvas_ = null;
        this.size_ = [
            size,
            size
        ];
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The rendering context.
   * @param {number} pixelRatio The pixel ratio.
   */ draw_(renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            let color = this.fill_.getColor();
            if (color === null) color = (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2);
            context.fillStyle = (0, $51e4a33855e1d867$export$dc5b1400ac3a10a8)(color);
            context.fill();
        }
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @return {HTMLCanvasElement} Canvas containing the icon
   */ createHitDetectionCanvas_(renderOptions) {
        let context;
        if (this.fill_) {
            let color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            let opacity = 0;
            if (typeof color === 'string') color = (0, $2c17bfc916c8f689$export$75093a47a9fa838d)(color);
            if (color === null) opacity = 1;
            else if (Array.isArray(color)) opacity = color.length === 4 ? color[3] : 1;
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                context = (0, $755a3001f896bcf1$export$9e05d10eae75c464)(renderOptions.size, renderOptions.size);
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        return context ? context.canvas : this.getImage(1);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} context The context to draw in.
   */ createPath_(context) {
        let points = this.points_;
        const radius = this.radius;
        if (points === Infinity) context.arc(0, 0, radius, 0, 2 * Math.PI);
        else {
            const radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) points *= 2;
            const startAngle = this.angle_ - Math.PI / 2;
            const step = 2 * Math.PI / points;
            for(let i = 0; i < points; i++){
                const angle0 = startAngle + i * step;
                const radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    }
    /**
   * @private
   * @param {RenderOptions} renderOptions Render options.
   * @param {CanvasRenderingContext2D} context The context.
   */ drawHitDetectionCanvas_(renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = (0, $c8f894129d9fa0b9$export$c495d52ee3fd74b2);
        context.fill();
        if (renderOptions.strokeStyle) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    }
    /**
   * @override
   */ ready() {
        return this.fill_ ? this.fill_.ready() : Promise.resolve();
    }
}
var $02d7f73313b743b3$export$2e2bcd8739ae039 = $02d7f73313b743b3$var$RegularShape;


/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 * @property {import('./Style.js').DeclutterMode} [declutterMode] Declutter mode
 */ /**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */ class $e163d3c698de5692$var$CircleStyle extends (0, $02d7f73313b743b3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {
            radius: 5
        };
        super({
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [
                0,
                0
            ],
            declutterMode: options.declutterMode
        });
    }
    /**
   * Clones the style.
   * @return {CircleStyle} The cloned style.
   * @api
   * @override
   */ clone() {
        const scale = this.getScale();
        const style = new $e163d3c698de5692$var$CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
            declutterMode: this.getDeclutterMode()
        });
        style.setOpacity(this.getOpacity());
        return style;
    }
    /**
   * Set the circle radius.
   *
   * @param {number} radius Circle radius.
   * @api
   */ setRadius(radius) {
        this.radius = radius;
        this.render();
    }
}
var $e163d3c698de5692$export$2e2bcd8739ae039 = $e163d3c698de5692$var$CircleStyle;


/**
 * @module ol/style/Fill
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} [color=null] A color,
 * gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats. For polygon fills (not for {@link import("./RegularShape.js").default} fills),
 * a pattern can also be provided as {@link module:ol/colorlike~PatternDescriptor}.
 * Default null; if null, the Canvas/renderer default black will be used.
 */ /**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */ class $d6fd3e0b0360ea29$var$Fill {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("./IconImage.js").default|null}
     */ this.patternImage_ = null;
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null}
     */ this.color_ = null;
        if (options.color !== undefined) this.setColor(options.color);
    }
    /**
   * Clones the style. The color is not cloned if it is a {@link module:ol/colorlike~ColorLike}.
   * @return {Fill} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $d6fd3e0b0360ea29$var$Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined
        });
    }
    /**
   * Get the fill color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike|import('../colorlike.js').PatternDescriptor|null} color Color.
   * @api
   */ setColor(color) {
        if (color !== null && typeof color === 'object' && 'src' in color) {
            const patternImage = (0, $33bba60ac8fc0af6$export$3988ae62b71be9a3)(null, color.src, 'anonymous', undefined, color.offset ? null : color.color ? color.color : null, !(color.offset && color.size));
            patternImage.ready().then(()=>{
                this.patternImage_ = null;
            });
            if (patternImage.getImageState() === (0, $23fb176c76153f22$export$2e2bcd8739ae039).IDLE) patternImage.load();
            if (patternImage.getImageState() === (0, $23fb176c76153f22$export$2e2bcd8739ae039).LOADING) this.patternImage_ = patternImage;
        }
        this.color_ = color;
    }
    /**
   * @return {string} Key of the fill for cache lookup.
   */ getKey() {
        const fill = this.getColor();
        if (!fill) return '';
        return fill instanceof CanvasPattern || fill instanceof CanvasGradient ? (0, $34772e91e89a736f$export$5e82334337e0f204)(fill) : typeof fill === 'object' && 'src' in fill ? fill.src + ':' + fill.offset : (0, $2c17bfc916c8f689$export$75093a47a9fa838d)(fill).toString();
    }
    /**
   * @return {boolean} The fill style is loading an image pattern.
   */ loading() {
        return !!this.patternImage_;
    }
    /**
   * @return {Promise<void>} `false` or a promise that resolves when the style is ready to use.
   */ ready() {
        return this.patternImage_ ? this.patternImage_.ready() : Promise.resolve();
    }
}
var $d6fd3e0b0360ea29$export$2e2bcd8739ae039 = $d6fd3e0b0360ea29$var$Fill;




/**
 * @module ol/style/Stroke
 */ /**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */ /**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */ class $9ed46f4c9b041e5d$var$Stroke {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
     */ this.color_ = options.color !== undefined ? options.color : null;
        /**
     * @private
     * @type {CanvasLineCap|undefined}
     */ this.lineCap_ = options.lineCap;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lineDashOffset_ = options.lineDashOffset;
        /**
     * @private
     * @type {CanvasLineJoin|undefined}
     */ this.lineJoin_ = options.lineJoin;
        /**
     * @private
     * @type {number|undefined}
     */ this.miterLimit_ = options.miterLimit;
        /**
     * @private
     * @type {number|undefined}
     */ this.width_ = options.width;
    }
    /**
   * Clones the style.
   * @return {Stroke} The cloned style.
   * @api
   */ clone() {
        const color = this.getColor();
        return new $9ed46f4c9b041e5d$var$Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            width: this.getWidth()
        });
    }
    /**
   * Get the stroke color.
   * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
   * @api
   */ getColor() {
        return this.color_;
    }
    /**
   * Get the line cap type for the stroke.
   * @return {CanvasLineCap|undefined} Line cap.
   * @api
   */ getLineCap() {
        return this.lineCap_;
    }
    /**
   * Get the line dash style for the stroke.
   * @return {Array<number>|null} Line dash.
   * @api
   */ getLineDash() {
        return this.lineDash_;
    }
    /**
   * Get the line dash offset for the stroke.
   * @return {number|undefined} Line dash offset.
   * @api
   */ getLineDashOffset() {
        return this.lineDashOffset_;
    }
    /**
   * Get the line join type for the stroke.
   * @return {CanvasLineJoin|undefined} Line join.
   * @api
   */ getLineJoin() {
        return this.lineJoin_;
    }
    /**
   * Get the miter limit for the stroke.
   * @return {number|undefined} Miter limit.
   * @api
   */ getMiterLimit() {
        return this.miterLimit_;
    }
    /**
   * Get the stroke width.
   * @return {number|undefined} Width.
   * @api
   */ getWidth() {
        return this.width_;
    }
    /**
   * Set the color.
   *
   * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
   * @api
   */ setColor(color) {
        this.color_ = color;
    }
    /**
   * Set the line cap.
   *
   * @param {CanvasLineCap|undefined} lineCap Line cap.
   * @api
   */ setLineCap(lineCap) {
        this.lineCap_ = lineCap;
    }
    /**
   * Set the line dash.
   *
   * @param {Array<number>|null} lineDash Line dash.
   * @api
   */ setLineDash(lineDash) {
        this.lineDash_ = lineDash;
    }
    /**
   * Set the line dash offset.
   *
   * @param {number|undefined} lineDashOffset Line dash offset.
   * @api
   */ setLineDashOffset(lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    }
    /**
   * Set the line join.
   *
   * @param {CanvasLineJoin|undefined} lineJoin Line join.
   * @api
   */ setLineJoin(lineJoin) {
        this.lineJoin_ = lineJoin;
    }
    /**
   * Set the miter limit.
   *
   * @param {number|undefined} miterLimit Miter limit.
   * @api
   */ setMiterLimit(miterLimit) {
        this.miterLimit_ = miterLimit;
    }
    /**
   * Set the width.
   *
   * @param {number|undefined} width Width.
   * @api
   */ setWidth(width) {
        this.width_ = width;
    }
}
var $9ed46f4c9b041e5d$export$2e2bcd8739ae039 = $9ed46f4c9b041e5d$var$Stroke;


/**
 * @module ol/style/Style
 */ 



/**
 * Defines how symbols and text are decluttered on layers ith `declutter` set to `true`
 * **declutter**: Overlapping symbols and text are decluttered.
 * **obstacle**: Symbols and text are rendered, but serve as obstacle for subsequent attempts
 *   to place a symbol or text at the same location.
 * **none**: No decluttering is done.
 *
 * @typedef {"declutter"|"obstacle"|"none"} DeclutterMode
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style~Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */ /**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */ /**
 * A function that takes a {@link module:ol/Feature~Feature} as argument and returns an
 * {@link module:ol/geom/Geometry~Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */ /**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>|Array<Array<Array<import("../coordinate.js").Coordinate>>>),import("../render.js").State): void} RenderFunction
 */ /**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {RenderFunction} [hitDetectionRenderer] Custom renderer for hit detection. If provided will be used
 * in hit detection rendering.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */ /**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)',
 *  });
 *  const stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25,
 *  });
 *  const styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5,
 *      }),
 *      fill: fill,
 *      stroke: stroke,
 *    }),
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Circle, Fill, Stroke, Style} from 'ol/style.js';
 *
 *  const styles = {};
 *  const white = [255, 255, 255, 1];
 *  const blue = [0, 153, 255, 1];
 *  const width = 3;
 *  styles['Polygon'] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5],
 *      }),
 *    }),
 *  ];
 *  styles['MultiPolygon'] =
 *      styles['Polygon'];
 *  styles['LineString'] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2,
 *      }),
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width,
 *      }),
 *    }),
 *  ];
 *  styles['MultiLineString'] = styles['LineString'];
 *
 *  styles['Circle'] = styles['Polygon'].concat(
 *    styles['LineString']
 *  );
 *
 *  styles['Point'] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue,
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2,
 *        }),
 *      }),
 *      zIndex: Infinity,
 *    }),
 *  ];
 *  styles['MultiPoint'] =
 *      styles['Point'];
 *  styles['GeometryCollection'] =
 *      styles['Polygon'].concat(
 *          styles['LineString'],
 *          styles['Point']
 *      );
 * ```
 *
 * @api
 */ class $0f1ce378ea6946fc$var$Style {
    /**
   * @param {Options} [options] Style options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|import("../geom/Geometry.js").default|GeometryFunction|null}
     */ this.geometry_ = null;
        /**
     * @private
     * @type {!GeometryFunction}
     */ this.geometryFunction_ = $0f1ce378ea6946fc$var$defaultGeometryFunction;
        if (options.geometry !== undefined) this.setGeometry(options.geometry);
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
     * @private
     * @type {import("./Image.js").default|null}
     */ this.image_ = options.image !== undefined ? options.image : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
     * @private
     * @type {RenderFunction|null}
     */ this.hitDetectionRenderer_ = options.hitDetectionRenderer !== undefined ? options.hitDetectionRenderer : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {import("./Text.js").default|null}
     */ this.text_ = options.text !== undefined ? options.text : null;
        /**
     * @private
     * @type {number|undefined}
     */ this.zIndex_ = options.zIndex;
    }
    /**
   * Clones the style.
   * @return {Style} The cloned style.
   * @api
   */ clone() {
        let geometry = this.getGeometry();
        if (geometry && typeof geometry === 'object') geometry = /** @type {import("../geom/Geometry.js").default} */ geometry.clone();
        return new $0f1ce378ea6946fc$var$Style({
            geometry: geometry ?? undefined,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer() ?? undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex()
        });
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setRenderer} or the `renderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Sets a custom renderer function for this style. When set, `fill`, `stroke`
   * and `image` options of the style will be ignored.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setRenderer(renderer) {
        this.renderer_ = renderer;
    }
    /**
   * Sets a custom renderer function for this style used
   * in hit detection.
   * @param {RenderFunction|null} renderer Custom renderer function.
   * @api
   */ setHitDetectionRenderer(renderer) {
        this.hitDetectionRenderer_ = renderer;
    }
    /**
   * Get the custom renderer function that was configured with
   * {@link #setHitDetectionRenderer} or the `hitDetectionRenderer` constructor option.
   * @return {RenderFunction|null} Custom renderer function.
   * @api
   */ getHitDetectionRenderer() {
        return this.hitDetectionRenderer_;
    }
    /**
   * Get the geometry to be rendered.
   * @return {string|import("../geom/Geometry.js").default|GeometryFunction|null}
   * Feature property or geometry or function that returns the geometry that will
   * be rendered with this style.
   * @api
   */ getGeometry() {
        return this.geometry_;
    }
    /**
   * Get the function used to generate a geometry for rendering.
   * @return {!GeometryFunction} Function that is called with a feature
   * and returns the geometry to render instead of the feature's geometry.
   * @api
   */ getGeometryFunction() {
        return this.geometryFunction_;
    }
    /**
   * Get the fill style.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Set the fill style.
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Get the image style.
   * @return {import("./Image.js").default|null} Image style.
   * @api
   */ getImage() {
        return this.image_;
    }
    /**
   * Set the image style.
   * @param {import("./Image.js").default} image Image style.
   * @api
   */ setImage(image) {
        this.image_ = image;
    }
    /**
   * Get the stroke style.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Set the stroke style.
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Get the text style.
   * @return {import("./Text.js").default|null} Text style.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Set the text style.
   * @param {import("./Text.js").default} text Text style.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Get the z-index for the style.
   * @return {number|undefined} ZIndex.
   * @api
   */ getZIndex() {
        return this.zIndex_;
    }
    /**
   * Set a geometry that is rendered instead of the feature's geometry.
   *
   * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
   *     Feature property or geometry or function returning a geometry to render
   *     for this style.
   * @api
   */ setGeometry(geometry) {
        if (typeof geometry === 'function') this.geometryFunction_ = geometry;
        else if (typeof geometry === 'string') this.geometryFunction_ = function(feature) {
            return /** @type {import("../geom/Geometry.js").default} */ feature.get(geometry);
        };
        else if (!geometry) this.geometryFunction_ = $0f1ce378ea6946fc$var$defaultGeometryFunction;
        else if (geometry !== undefined) this.geometryFunction_ = function() {
            return /** @type {import("../geom/Geometry.js").default} */ geometry;
        };
        this.geometry_ = geometry;
    }
    /**
   * Set the z-index.
   *
   * @param {number|undefined} zIndex ZIndex.
   * @api
   */ setZIndex(zIndex) {
        this.zIndex_ = zIndex;
    }
}
function $0f1ce378ea6946fc$export$c314ea3f6b164147(obj) {
    let styleFunction;
    if (typeof obj === 'function') styleFunction = obj;
    else {
        /**
     * @type {Array<Style>}
     */ let styles;
        if (Array.isArray(obj)) styles = obj;
        else {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ obj.getZIndex === 'function', 'Expected an `Style` or an array of `Style`');
            const style = /** @type {Style} */ obj;
            styles = [
                style
            ];
        }
        styleFunction = function() {
            return styles;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>|null}
 */ let $0f1ce378ea6946fc$var$defaultStyles = null;
function $0f1ce378ea6946fc$export$6865c5ac2f5ce8b6(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!$0f1ce378ea6946fc$var$defaultStyles) {
        const fill = new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
            color: 'rgba(255,255,255,0.4)'
        });
        const stroke = new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
            color: '#3399CC',
            width: 1.25
        });
        $0f1ce378ea6946fc$var$defaultStyles = [
            new $0f1ce378ea6946fc$var$Style({
                image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)({
                    fill: fill,
                    stroke: stroke,
                    radius: 5
                }),
                fill: fill,
                stroke: stroke
            })
        ];
    }
    return $0f1ce378ea6946fc$var$defaultStyles;
}
function $0f1ce378ea6946fc$export$ed1eaede5d0e77ac() {
    /** @type {Object<import("../geom/Geometry.js").Type, Array<Style>>} */ const styles = {};
    const white = [
        255,
        255,
        255,
        1
    ];
    const blue = [
        0,
        153,
        255,
        1
    ];
    const width = 3;
    styles['Polygon'] = [
        new $0f1ce378ea6946fc$var$Style({
            fill: new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
                color: [
                    255,
                    255,
                    255,
                    0.5
                ]
            })
        })
    ];
    styles['MultiPolygon'] = styles['Polygon'];
    styles['LineString'] = [
        new $0f1ce378ea6946fc$var$Style({
            stroke: new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                color: white,
                width: width + 2
            })
        }),
        new $0f1ce378ea6946fc$var$Style({
            stroke: new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                color: blue,
                width: width
            })
        })
    ];
    styles['MultiLineString'] = styles['LineString'];
    styles['Circle'] = styles['Polygon'].concat(styles['LineString']);
    styles['Point'] = [
        new $0f1ce378ea6946fc$var$Style({
            image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)({
                radius: width * 2,
                fill: new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
                    color: blue
                }),
                stroke: new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                    color: white,
                    width: width / 2
                })
            }),
            zIndex: Infinity
        })
    ];
    styles['MultiPoint'] = styles['Point'];
    styles['GeometryCollection'] = styles['Polygon'].concat(styles['LineString'], styles['Point']);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */ function $0f1ce378ea6946fc$var$defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
var $0f1ce378ea6946fc$export$2e2bcd8739ae039 = $0f1ce378ea6946fc$var$Style;


/**
 * @module ol/style/Text
 */ 

/**
 * @typedef {'point' | 'line'} TextPlacement
 * Default text placement is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 */ /**
 * @typedef {'left' | 'center' | 'right'} TextJustify
 */ /**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */ const $bd3392336d293964$var$DEFAULT_FILL_COLOR = '#333';
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS `font` value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is `'10px sans-serif'`
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {TextPlacement} [placement='point'] Text placement.
 * @property {number} [repeat] Repeat interval. When set, the text will be repeated at this interval, which specifies
 * the distance between two text anchors in pixels. Only available when `placement` is set to `'line'`. Overrides 'textAlign'.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {boolean} [keepUpright=true] Whether the text can be rotated 180° to prevent being rendered upside down.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string|Array<string>} [text] Text content or rich text content. For plain text provide a string, which can
 * contain line breaks (`\n`). For rich text provide an array of text/font tuples. A tuple consists of the text to
 * render and the font to use (or `''` to use the text style's font). A line break has to be a separate tuple (i.e. `'\n', ''`).
 * **Example:** `['foo', 'bold 10px sans-serif', ' bar', 'italic 10px sans-serif', ' baz', '']` will yield "**foo** *bar* baz".
 * **Note:** Rich text is not supported for `placement: 'line'` or the immediate rendering API.
 * @property {CanvasTextAlign} [textAlign] Text alignment. Possible values: `'left'`, `'right'`, `'center'`, `'end'` or `'start'`.
 * Default is `'center'` for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {TextJustify} [justify] Text justification within the text box.
 * If not set, text is justified towards the `textAlign` anchor.
 * Otherwise, use options `'left'`, `'center'`, or `'right'` to justify the text within the text box.
 * **Note:** `justify` is ignored for immediate rendering and also for `placement: 'line'`.
 * @property {CanvasTextBaseline} [textBaseline='middle'] Text base line. Possible values: `'bottom'`, `'top'`, `'middle'`, `'alphabetic'`,
 * `'hanging'`, `'ideographic'`.
 * @property {import("./Fill.js").default|null} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333). Specify `null` for no fill.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 * @property {import('../style/Style.js').DeclutterMode} [declutterMode] Declutter mode: `declutter`, `obstacle`, `none`
 */ /**
 * @classdesc
 * Set text style for vector features.
 * @api
 */ class $bd3392336d293964$var$Text {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options || {};
        /**
     * @private
     * @type {string|undefined}
     */ this.font_ = options.font;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = options.rotation;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.rotateWithView_ = options.rotateWithView;
        /**
     * @private
     * @type {boolean|undefined}
     */ this.keepUpright_ = options.keepUpright;
        /**
     * @private
     * @type {number|import("../size.js").Size|undefined}
     */ this.scale_ = options.scale;
        /**
     * @private
     * @type {import("../size.js").Size}
     */ this.scaleArray_ = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(options.scale !== undefined ? options.scale : 1);
        /**
     * @private
     * @type {string|Array<string>|undefined}
     */ this.text_ = options.text;
        /**
     * @private
     * @type {CanvasTextAlign|undefined}
     */ this.textAlign_ = options.textAlign;
        /**
     * @private
     * @type {TextJustify|undefined}
     */ this.justify_ = options.justify;
        /**
     * @private
     * @type {number|undefined}
     */ this.repeat_ = options.repeat;
        /**
     * @private
     * @type {CanvasTextBaseline|undefined}
     */ this.textBaseline_ = options.textBaseline;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.fill_ = options.fill !== undefined ? options.fill : new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
            color: $bd3392336d293964$var$DEFAULT_FILL_COLOR
        });
        /**
     * @private
     * @type {number}
     */ this.maxAngle_ = options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
     * @private
     * @type {TextPlacement}
     */ this.placement_ = options.placement !== undefined ? options.placement : 'point';
        /**
     * @private
     * @type {boolean}
     */ this.overflow_ = !!options.overflow;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
     * @private
     * @type {number}
     */ this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
     * @private
     * @type {number}
     */ this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
     * @private
     * @type {import("./Fill.js").default|null}
     */ this.backgroundFill_ = options.backgroundFill ? options.backgroundFill : null;
        /**
     * @private
     * @type {import("./Stroke.js").default|null}
     */ this.backgroundStroke_ = options.backgroundStroke ? options.backgroundStroke : null;
        /**
     * @private
     * @type {Array<number>|null}
     */ this.padding_ = options.padding === undefined ? null : options.padding;
        /**
     * @private
     * @type {import('../style/Style.js').DeclutterMode}
     */ this.declutterMode_ = options.declutterMode;
    }
    /**
   * Clones the style.
   * @return {Text} The cloned style.
   * @api
   */ clone() {
        const scale = this.getScale();
        return new $bd3392336d293964$var$Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            repeat: this.getRepeat(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            keepUpright: this.getKeepUpright(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            justify: this.getJustify(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill() ? this.getBackgroundFill().clone() : undefined,
            backgroundStroke: this.getBackgroundStroke() ? this.getBackgroundStroke().clone() : undefined,
            padding: this.getPadding() || undefined,
            declutterMode: this.getDeclutterMode()
        });
    }
    /**
   * Get the `overflow` configuration.
   * @return {boolean} Let text overflow the length of the path they follow.
   * @api
   */ getOverflow() {
        return this.overflow_;
    }
    /**
   * Get the font name.
   * @return {string|undefined} Font.
   * @api
   */ getFont() {
        return this.font_;
    }
    /**
   * Get the maximum angle between adjacent characters.
   * @return {number} Angle in radians.
   * @api
   */ getMaxAngle() {
        return this.maxAngle_;
    }
    /**
   * Get the label placement.
   * @return {TextPlacement} Text placement.
   * @api
   */ getPlacement() {
        return this.placement_;
    }
    /**
   * Get the repeat interval of the text.
   * @return {number|undefined} Repeat interval in pixels.
   * @api
   */ getRepeat() {
        return this.repeat_;
    }
    /**
   * Get the x-offset for the text.
   * @return {number} Horizontal text offset.
   * @api
   */ getOffsetX() {
        return this.offsetX_;
    }
    /**
   * Get the y-offset for the text.
   * @return {number} Vertical text offset.
   * @api
   */ getOffsetY() {
        return this.offsetY_;
    }
    /**
   * Get the fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getFill() {
        return this.fill_;
    }
    /**
   * Determine whether the text rotates with the map.
   * @return {boolean|undefined} Rotate with map.
   * @api
   */ getRotateWithView() {
        return this.rotateWithView_;
    }
    /**
   * Determine whether the text can be rendered upside down.
   * @return {boolean|undefined} Keep text upright.
   * @api
   */ getKeepUpright() {
        return this.keepUpright_;
    }
    /**
   * Get the text rotation.
   * @return {number|undefined} Rotation.
   * @api
   */ getRotation() {
        return this.rotation_;
    }
    /**
   * Get the text scale.
   * @return {number|import("../size.js").Size|undefined} Scale.
   * @api
   */ getScale() {
        return this.scale_;
    }
    /**
   * Get the symbolizer scale array.
   * @return {import("../size.js").Size} Scale array.
   */ getScaleArray() {
        return this.scaleArray_;
    }
    /**
   * Get the stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getStroke() {
        return this.stroke_;
    }
    /**
   * Get the text to be rendered.
   * @return {string|Array<string>|undefined} Text.
   * @api
   */ getText() {
        return this.text_;
    }
    /**
   * Get the text alignment.
   * @return {CanvasTextAlign|undefined} Text align.
   * @api
   */ getTextAlign() {
        return this.textAlign_;
    }
    /**
   * Get the justification.
   * @return {TextJustify|undefined} Justification.
   * @api
   */ getJustify() {
        return this.justify_;
    }
    /**
   * Get the text baseline.
   * @return {CanvasTextBaseline|undefined} Text baseline.
   * @api
   */ getTextBaseline() {
        return this.textBaseline_;
    }
    /**
   * Get the background fill style for the text.
   * @return {import("./Fill.js").default|null} Fill style.
   * @api
   */ getBackgroundFill() {
        return this.backgroundFill_;
    }
    /**
   * Get the background stroke style for the text.
   * @return {import("./Stroke.js").default|null} Stroke style.
   * @api
   */ getBackgroundStroke() {
        return this.backgroundStroke_;
    }
    /**
   * Get the padding for the text.
   * @return {Array<number>|null} Padding.
   * @api
   */ getPadding() {
        return this.padding_;
    }
    /**
   * Get the declutter mode of the shape
   * @return {import("./Style.js").DeclutterMode} Shape's declutter mode
   * @api
   */ getDeclutterMode() {
        return this.declutterMode_;
    }
    /**
   * Set the `overflow` property.
   *
   * @param {boolean} overflow Let text overflow the path that it follows.
   * @api
   */ setOverflow(overflow) {
        this.overflow_ = overflow;
    }
    /**
   * Set the font.
   *
   * @param {string|undefined} font Font.
   * @api
   */ setFont(font) {
        this.font_ = font;
    }
    /**
   * Set the maximum angle between adjacent characters.
   *
   * @param {number} maxAngle Angle in radians.
   * @api
   */ setMaxAngle(maxAngle) {
        this.maxAngle_ = maxAngle;
    }
    /**
   * Set the x offset.
   *
   * @param {number} offsetX Horizontal text offset.
   * @api
   */ setOffsetX(offsetX) {
        this.offsetX_ = offsetX;
    }
    /**
   * Set the y offset.
   *
   * @param {number} offsetY Vertical text offset.
   * @api
   */ setOffsetY(offsetY) {
        this.offsetY_ = offsetY;
    }
    /**
   * Set the text placement.
   *
   * @param {TextPlacement} placement Placement.
   * @api
   */ setPlacement(placement) {
        this.placement_ = placement;
    }
    /**
   * Set the repeat interval of the text.
   * @param {number|undefined} [repeat] Repeat interval in pixels.
   * @api
   */ setRepeat(repeat) {
        this.repeat_ = repeat;
    }
    /**
   * Set whether to rotate the text with the view.
   *
   * @param {boolean} rotateWithView Rotate with map.
   * @api
   */ setRotateWithView(rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    }
    /**
   * Set whether the text can be rendered upside down.
   *
   * @param {boolean} keepUpright Keep text upright.
   * @api
   */ setKeepUpright(keepUpright) {
        this.keepUpright_ = keepUpright;
    }
    /**
   * Set the fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setFill(fill) {
        this.fill_ = fill;
    }
    /**
   * Set the rotation.
   *
   * @param {number|undefined} rotation Rotation.
   * @api
   */ setRotation(rotation) {
        this.rotation_ = rotation;
    }
    /**
   * Set the scale.
   *
   * @param {number|import("../size.js").Size|undefined} scale Scale.
   * @api
   */ setScale(scale) {
        this.scale_ = scale;
        this.scaleArray_ = (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(scale !== undefined ? scale : 1);
    }
    /**
   * Set the stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setStroke(stroke) {
        this.stroke_ = stroke;
    }
    /**
   * Set the text.
   *
   * @param {string|Array<string>|undefined} text Text.
   * @api
   */ setText(text) {
        this.text_ = text;
    }
    /**
   * Set the text alignment.
   *
   * @param {CanvasTextAlign|undefined} textAlign Text align.
   * @api
   */ setTextAlign(textAlign) {
        this.textAlign_ = textAlign;
    }
    /**
   * Set the justification.
   *
   * @param {TextJustify|undefined} justify Justification.
   * @api
   */ setJustify(justify) {
        this.justify_ = justify;
    }
    /**
   * Set the text baseline.
   *
   * @param {CanvasTextBaseline|undefined} textBaseline Text baseline.
   * @api
   */ setTextBaseline(textBaseline) {
        this.textBaseline_ = textBaseline;
    }
    /**
   * Set the background fill.
   *
   * @param {import("./Fill.js").default|null} fill Fill style.
   * @api
   */ setBackgroundFill(fill) {
        this.backgroundFill_ = fill;
    }
    /**
   * Set the background stroke.
   *
   * @param {import("./Stroke.js").default|null} stroke Stroke style.
   * @api
   */ setBackgroundStroke(stroke) {
        this.backgroundStroke_ = stroke;
    }
    /**
   * Set the padding (`[top, right, bottom, left]`).
   *
   * @param {Array<number>|null} padding Padding.
   * @api
   */ setPadding(padding) {
        this.padding_ = padding;
    }
}
var $bd3392336d293964$export$2e2bcd8739ae039 = $bd3392336d293964$var$Text;


/**
 * @fileoverview This module includes functions to build styles for the canvas renderer.  Building
 * is composed of two steps: parsing and compiling.  The parsing step takes an encoded expression
 * and returns an instance of one of the expression classes.  The compiling step takes the
 * expression instance and returns a function that can be evaluated to return a literal value.  The
 * evaluator function should do as little allocation and work as possible.
 */ /**
 * @typedef {import("../../style/flat.js").FlatStyle} FlatStyle
 */ /**
 * @typedef {import("../../expr/expression.js").EncodedExpression} EncodedExpression
 */ /**
 * @typedef {import("../../expr/expression.js").ParsingContext} ParsingContext
 */ /**
 * @typedef {import("../../expr/expression.js").CallExpression} CallExpression
 */ /**
 * @typedef {import("../../expr/cpu.js").EvaluationContext} EvaluationContext
 */ /**
 * @typedef {import("../../expr/cpu.js").ExpressionEvaluator} ExpressionEvaluator
 */ /**
 * @param {EvaluationContext} context The evaluation context.
 * @return {boolean} Always true.
 */ function $1249519aaada68b2$var$always(context) {
    return true;
}
function $1249519aaada68b2$export$fc6a94152b1b05a8(rules) {
    const parsingContext = (0, $4bf85f096fb6de71$export$1c8b4c1584800354)();
    const evaluator = $1249519aaada68b2$export$d6ae6a4799989976(rules, parsingContext);
    const evaluationContext = (0, $4bcbbad0e5f222a3$export$c18f39f0e136c26)();
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        if (parsingContext.geometryType) evaluationContext.geometryType = (0, $4bf85f096fb6de71$export$8da88d86d10c1295)(feature.getGeometry());
        return evaluator(evaluationContext);
    };
}
function $1249519aaada68b2$export$5a130bc4f0a0420b(flatStyles) {
    const parsingContext = (0, $4bf85f096fb6de71$export$1c8b4c1584800354)();
    const length = flatStyles.length;
    /**
   * @type {Array<StyleEvaluator>}
   */ const evaluators = new Array(length);
    for(let i = 0; i < length; ++i)evaluators[i] = $1249519aaada68b2$export$a6e5f510497b7388(flatStyles[i], parsingContext);
    const evaluationContext = (0, $4bcbbad0e5f222a3$export$c18f39f0e136c26)();
    /**
   * @type {Array<Style>}
   */ const styles = new Array(length);
    return function(feature, resolution) {
        evaluationContext.properties = feature.getPropertiesInternal();
        evaluationContext.resolution = resolution;
        if (parsingContext.featureId) {
            const id = feature.getId();
            if (id !== undefined) evaluationContext.featureId = id;
            else evaluationContext.featureId = null;
        }
        let nonNullCount = 0;
        for(let i = 0; i < length; ++i){
            const style = evaluators[i](evaluationContext);
            if (style) {
                styles[nonNullCount] = style;
                nonNullCount += 1;
            }
        }
        styles.length = nonNullCount;
        return styles;
    };
}
function $1249519aaada68b2$export$d6ae6a4799989976(rules, context) {
    const length = rules.length;
    /**
   * @type {Array<CompiledRule>}
   */ const compiledRules = new Array(length);
    for(let i = 0; i < length; ++i){
        const rule = rules[i];
        const filter = 'filter' in rule ? (0, $4bcbbad0e5f222a3$export$b5f535122a9211f0)(rule.filter, (0, $4bf85f096fb6de71$export$240f7fffab1b25a0), context) : $1249519aaada68b2$var$always;
        /**
     * @type {Array<StyleEvaluator>}
     */ let styles;
        if (Array.isArray(rule.style)) {
            const styleLength = rule.style.length;
            styles = new Array(styleLength);
            for(let j = 0; j < styleLength; ++j)styles[j] = $1249519aaada68b2$export$a6e5f510497b7388(rule.style[j], context);
        } else styles = [
            $1249519aaada68b2$export$a6e5f510497b7388(rule.style, context)
        ];
        compiledRules[i] = {
            filter: filter,
            styles: styles
        };
    }
    return function(context) {
        /**
     * @type {Array<Style>}
     */ const styles = [];
        let someMatched = false;
        for(let i = 0; i < length; ++i){
            const filterEvaluator = compiledRules[i].filter;
            if (!filterEvaluator(context)) continue;
            if (rules[i].else && someMatched) continue;
            someMatched = true;
            for (const styleEvaluator of compiledRules[i].styles){
                const style = styleEvaluator(context);
                if (!style) continue;
                styles.push(style);
            }
        }
        return styles;
    };
}
function $1249519aaada68b2$export$a6e5f510497b7388(flatStyle, context) {
    const evaluateFill = $1249519aaada68b2$var$buildFill(flatStyle, '', context);
    const evaluateStroke = $1249519aaada68b2$var$buildStroke(flatStyle, '', context);
    const evaluateText = $1249519aaada68b2$var$buildText(flatStyle, context);
    const evaluateImage = $1249519aaada68b2$var$buildImage(flatStyle, context);
    const evaluateZIndex = $1249519aaada68b2$var$numberEvaluator(flatStyle, 'z-index', context);
    if (!evaluateFill && !evaluateStroke && !evaluateText && !evaluateImage && !(0, $8c1e0b75b65663dc$export$dd1bc94b04021eeb)(flatStyle)) // assume this is a user error
    // would be nice to check the properties and suggest "did you mean..."
    throw new Error('No fill, stroke, point, or text symbolizer properties in style: ' + JSON.stringify(flatStyle));
    const style = new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)();
    return function(context) {
        let empty = true;
        if (evaluateFill) {
            const fill = evaluateFill(context);
            if (fill) empty = false;
            style.setFill(fill);
        }
        if (evaluateStroke) {
            const stroke = evaluateStroke(context);
            if (stroke) empty = false;
            style.setStroke(stroke);
        }
        if (evaluateText) {
            const text = evaluateText(context);
            if (text) empty = false;
            style.setText(text);
        }
        if (evaluateImage) {
            const image = evaluateImage(context);
            if (image) empty = false;
            style.setImage(image);
        }
        if (evaluateZIndex) style.setZIndex(evaluateZIndex(context));
        if (empty) return null;
        return style;
    };
}
/**
 * @typedef {function(EvaluationContext):Fill|null} FillEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {FillEvaluator?} A function that evaluates to a fill.
 */ function $1249519aaada68b2$var$buildFill(flatStyle, prefix, context) {
    let evaluateColor;
    if (prefix + 'fill-pattern-src' in flatStyle) evaluateColor = $1249519aaada68b2$var$patternEvaluator(flatStyle, prefix + 'fill-', context);
    else {
        if (flatStyle[prefix + 'fill-color'] === 'none') // avoids hit detection
        return (context)=>null;
        evaluateColor = $1249519aaada68b2$var$colorLikeEvaluator(flatStyle, prefix + 'fill-color', context);
    }
    if (!evaluateColor) return null;
    const fill = new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)();
    return function(context) {
        const color = evaluateColor(context);
        if (color === (0, $2c17bfc916c8f689$export$6c844c64a5efe1ee)) return null;
        fill.setColor(color);
        return fill;
    };
}
/**
 * @typedef {function(EvaluationContext):Stroke|null} StrokeEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} prefix The property prefix.
 * @param {ParsingContext} context The parsing context.
 * @return {StrokeEvaluator?} A function the evaluates to a stroke.
 */ function $1249519aaada68b2$var$buildStroke(flatStyle, prefix, context) {
    const evaluateWidth = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'stroke-width', context);
    const evaluateColor = $1249519aaada68b2$var$colorLikeEvaluator(flatStyle, prefix + 'stroke-color', context);
    if (!evaluateWidth && !evaluateColor) return null;
    const evaluateLineCap = $1249519aaada68b2$var$stringEvaluator(flatStyle, prefix + 'stroke-line-cap', context);
    const evaluateLineJoin = $1249519aaada68b2$var$stringEvaluator(flatStyle, prefix + 'stroke-line-join', context);
    const evaluateLineDash = $1249519aaada68b2$var$numberArrayEvaluator(flatStyle, prefix + 'stroke-line-dash', context);
    const evaluateLineDashOffset = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'stroke-line-dash-offset', context);
    const evaluateMiterLimit = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'stroke-miter-limit', context);
    const stroke = new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)();
    return function(context) {
        if (evaluateColor) {
            const color = evaluateColor(context);
            if (color === (0, $2c17bfc916c8f689$export$6c844c64a5efe1ee)) return null;
            stroke.setColor(color);
        }
        if (evaluateWidth) stroke.setWidth(evaluateWidth(context));
        if (evaluateLineCap) {
            const lineCap = evaluateLineCap(context);
            if (lineCap !== 'butt' && lineCap !== 'round' && lineCap !== 'square') throw new Error('Expected butt, round, or square line cap');
            stroke.setLineCap(lineCap);
        }
        if (evaluateLineJoin) {
            const lineJoin = evaluateLineJoin(context);
            if (lineJoin !== 'bevel' && lineJoin !== 'round' && lineJoin !== 'miter') throw new Error('Expected bevel, round, or miter line join');
            stroke.setLineJoin(lineJoin);
        }
        if (evaluateLineDash) stroke.setLineDash(evaluateLineDash(context));
        if (evaluateLineDashOffset) stroke.setLineDashOffset(evaluateLineDashOffset(context));
        if (evaluateMiterLimit) stroke.setMiterLimit(evaluateMiterLimit(context));
        return stroke;
    };
}
/**
 * @typedef {function(EvaluationContext):Text} TextEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {TextEvaluator?} A function that evaluates to a text symbolizer.
 */ function $1249519aaada68b2$var$buildText(flatStyle, context) {
    const prefix = 'text-';
    // Currently, an Array<string> may be used for rich text support.  This doesn't
    // work with our expression syntax where arrays of strings are interpreted as
    // call expressions.  To support rich text, we could add a 'strings' operator
    // where all the following arguments would be string values.
    const evaluateValue = $1249519aaada68b2$var$stringEvaluator(flatStyle, prefix + 'value', context);
    if (!evaluateValue) return null;
    const evaluateFill = $1249519aaada68b2$var$buildFill(flatStyle, prefix, context);
    const evaluateBackgroundFill = $1249519aaada68b2$var$buildFill(flatStyle, prefix + 'background-', context);
    const evaluateStroke = $1249519aaada68b2$var$buildStroke(flatStyle, prefix, context);
    const evaluateBackgroundStroke = $1249519aaada68b2$var$buildStroke(flatStyle, prefix + 'background-', context);
    const evaluateFont = $1249519aaada68b2$var$stringEvaluator(flatStyle, prefix + 'font', context);
    const evaluateMaxAngle = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'max-angle', context);
    const evaluateOffsetX = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'offset-x', context);
    const evaluateOffsetY = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'offset-y', context);
    const evaluateOverflow = $1249519aaada68b2$var$booleanEvaluator(flatStyle, prefix + 'overflow', context);
    const evaluatePlacement = $1249519aaada68b2$var$stringEvaluator(flatStyle, prefix + 'placement', context);
    const evaluateRepeat = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'repeat', context);
    const evaluateScale = $1249519aaada68b2$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateRotateWithView = $1249519aaada68b2$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    const evaluateRotation = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateAlign = $1249519aaada68b2$var$stringEvaluator(flatStyle, prefix + 'align', context);
    const evaluateJustify = $1249519aaada68b2$var$stringEvaluator(flatStyle, prefix + 'justify', context);
    const evaluateBaseline = $1249519aaada68b2$var$stringEvaluator(flatStyle, prefix + 'baseline', context);
    const evaluateKeepUpright = $1249519aaada68b2$var$booleanEvaluator(flatStyle, prefix + 'keep-upright', context);
    const evaluatePadding = $1249519aaada68b2$var$numberArrayEvaluator(flatStyle, prefix + 'padding', context);
    // The following properties are not currently settable
    const declutterMode = $1249519aaada68b2$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const text = new (0, $bd3392336d293964$export$2e2bcd8739ae039)({
        declutterMode: declutterMode
    });
    return function(context) {
        text.setText(evaluateValue(context));
        if (evaluateFill) text.setFill(evaluateFill(context));
        if (evaluateBackgroundFill) text.setBackgroundFill(evaluateBackgroundFill(context));
        if (evaluateStroke) text.setStroke(evaluateStroke(context));
        if (evaluateBackgroundStroke) text.setBackgroundStroke(evaluateBackgroundStroke(context));
        if (evaluateFont) text.setFont(evaluateFont(context));
        if (evaluateMaxAngle) text.setMaxAngle(evaluateMaxAngle(context));
        if (evaluateOffsetX) text.setOffsetX(evaluateOffsetX(context));
        if (evaluateOffsetY) text.setOffsetY(evaluateOffsetY(context));
        if (evaluateOverflow) text.setOverflow(evaluateOverflow(context));
        if (evaluatePlacement) {
            const placement = evaluatePlacement(context);
            if (placement !== 'point' && placement !== 'line') throw new Error('Expected point or line for text-placement');
            text.setPlacement(placement);
        }
        if (evaluateRepeat) text.setRepeat(evaluateRepeat(context));
        if (evaluateScale) text.setScale(evaluateScale(context));
        if (evaluateRotateWithView) text.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateRotation) text.setRotation(evaluateRotation(context));
        if (evaluateAlign) {
            const textAlign = evaluateAlign(context);
            if (textAlign !== 'left' && textAlign !== 'center' && textAlign !== 'right' && textAlign !== 'end' && textAlign !== 'start') throw new Error('Expected left, right, center, start, or end for text-align');
            text.setTextAlign(textAlign);
        }
        if (evaluateJustify) {
            const justify = evaluateJustify(context);
            if (justify !== 'left' && justify !== 'right' && justify !== 'center') throw new Error('Expected left, right, or center for text-justify');
            text.setJustify(justify);
        }
        if (evaluateBaseline) {
            const textBaseline = evaluateBaseline(context);
            if (textBaseline !== 'bottom' && textBaseline !== 'top' && textBaseline !== 'middle' && textBaseline !== 'alphabetic' && textBaseline !== 'hanging') throw new Error('Expected bottom, top, middle, alphabetic, or hanging for text-baseline');
            text.setTextBaseline(textBaseline);
        }
        if (evaluatePadding) text.setPadding(evaluatePadding(context));
        if (evaluateKeepUpright) text.setKeepUpright(evaluateKeepUpright(context));
        return text;
    };
}
/**
 * @typedef {function(EvaluationContext):import("../../style/Image.js").default} ImageEvaluator
 */ /**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator?} A function that evaluates to an image symbolizer.
 */ function $1249519aaada68b2$var$buildImage(flatStyle, context) {
    if ('icon-src' in flatStyle) return $1249519aaada68b2$var$buildIcon(flatStyle, context);
    if ('shape-points' in flatStyle) return $1249519aaada68b2$var$buildShape(flatStyle, context);
    if ('circle-radius' in flatStyle) return $1249519aaada68b2$var$buildCircle(flatStyle, context);
    return null;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an image symbolizer.
 */ function $1249519aaada68b2$var$buildIcon(flatStyle, context) {
    const prefix = 'icon-';
    // required property
    const srcName = prefix + 'src';
    const src = $1249519aaada68b2$var$requireString(flatStyle[srcName], srcName);
    // settable properties
    const evaluateAnchor = $1249519aaada68b2$var$coordinateEvaluator(flatStyle, prefix + 'anchor', context);
    const evaluateScale = $1249519aaada68b2$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateOpacity = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'opacity', context);
    const evaluateDisplacement = $1249519aaada68b2$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $1249519aaada68b2$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining symbolizer properties are not currently settable
    const anchorOrigin = $1249519aaada68b2$var$optionalIconOrigin(flatStyle, prefix + 'anchor-origin');
    const anchorXUnits = $1249519aaada68b2$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-x-units');
    const anchorYUnits = $1249519aaada68b2$var$optionalIconAnchorUnits(flatStyle, prefix + 'anchor-y-units');
    const color = $1249519aaada68b2$var$optionalColorLike(flatStyle, prefix + 'color');
    const crossOrigin = $1249519aaada68b2$var$optionalString(flatStyle, prefix + 'cross-origin');
    const offset = $1249519aaada68b2$var$optionalNumberArray(flatStyle, prefix + 'offset');
    const offsetOrigin = $1249519aaada68b2$var$optionalIconOrigin(flatStyle, prefix + 'offset-origin');
    const width = $1249519aaada68b2$var$optionalNumber(flatStyle, prefix + 'width');
    const height = $1249519aaada68b2$var$optionalNumber(flatStyle, prefix + 'height');
    const size = $1249519aaada68b2$var$optionalSize(flatStyle, prefix + 'size');
    const declutterMode = $1249519aaada68b2$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const icon = new (0, $44e8bfd96871175f$export$2e2bcd8739ae039)({
        src: src,
        anchorOrigin: anchorOrigin,
        anchorXUnits: anchorXUnits,
        anchorYUnits: anchorYUnits,
        color: color,
        crossOrigin: crossOrigin,
        offset: offset,
        offsetOrigin: offsetOrigin,
        height: height,
        width: width,
        size: size,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateOpacity) icon.setOpacity(evaluateOpacity(context));
        if (evaluateDisplacement) icon.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) icon.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) icon.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) icon.setScale(evaluateScale(context));
        if (evaluateAnchor) icon.setAnchor(evaluateAnchor(context));
        return icon;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to an icon symbolizer.
 */ function $1249519aaada68b2$var$buildShape(flatStyle, context) {
    const prefix = 'shape-';
    // required property
    const pointsName = prefix + 'points';
    const radiusName = prefix + 'radius';
    const points = $1249519aaada68b2$var$requireNumber(flatStyle[pointsName], pointsName);
    const radius = $1249519aaada68b2$var$requireNumber(flatStyle[radiusName], radiusName);
    // settable properties
    const evaluateFill = $1249519aaada68b2$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $1249519aaada68b2$var$buildStroke(flatStyle, prefix, context);
    const evaluateScale = $1249519aaada68b2$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $1249519aaada68b2$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $1249519aaada68b2$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const radius2 = $1249519aaada68b2$var$optionalNumber(flatStyle, prefix + 'radius2');
    const angle = $1249519aaada68b2$var$optionalNumber(flatStyle, prefix + 'angle');
    const declutterMode = $1249519aaada68b2$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const shape = new (0, $02d7f73313b743b3$export$2e2bcd8739ae039)({
        points: points,
        radius: radius,
        radius2: radius2,
        angle: angle,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateFill) shape.setFill(evaluateFill(context));
        if (evaluateStroke) shape.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) shape.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) shape.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) shape.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) shape.setScale(evaluateScale(context));
        return shape;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {ParsingContext} context The parsing context.
 * @return {ImageEvaluator} A function that evaluates to a circle symbolizer.
 */ function $1249519aaada68b2$var$buildCircle(flatStyle, context) {
    const prefix = 'circle-';
    // settable properties
    const evaluateFill = $1249519aaada68b2$var$buildFill(flatStyle, prefix, context);
    const evaluateStroke = $1249519aaada68b2$var$buildStroke(flatStyle, prefix, context);
    const evaluateRadius = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'radius', context);
    const evaluateScale = $1249519aaada68b2$var$sizeLikeEvaluator(flatStyle, prefix + 'scale', context);
    const evaluateDisplacement = $1249519aaada68b2$var$coordinateEvaluator(flatStyle, prefix + 'displacement', context);
    const evaluateRotation = $1249519aaada68b2$var$numberEvaluator(flatStyle, prefix + 'rotation', context);
    const evaluateRotateWithView = $1249519aaada68b2$var$booleanEvaluator(flatStyle, prefix + 'rotate-with-view', context);
    // the remaining properties are not currently settable
    const declutterMode = $1249519aaada68b2$var$optionalDeclutterMode(flatStyle, prefix + 'declutter-mode');
    const circle = new (0, $e163d3c698de5692$export$2e2bcd8739ae039)({
        radius: 5,
        declutterMode: declutterMode
    });
    return function(context) {
        if (evaluateRadius) circle.setRadius(evaluateRadius(context));
        if (evaluateFill) circle.setFill(evaluateFill(context));
        if (evaluateStroke) circle.setStroke(evaluateStroke(context));
        if (evaluateDisplacement) circle.setDisplacement(evaluateDisplacement(context));
        if (evaluateRotation) circle.setRotation(evaluateRotation(context));
        if (evaluateRotateWithView) circle.setRotateWithView(evaluateRotateWithView(context));
        if (evaluateScale) circle.setScale(evaluateScale(context));
        return circle;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberEvaluator|undefined} The expression evaluator or undefined.
 */ function $1249519aaada68b2$var$numberEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return undefined;
    const evaluator = (0, $4bcbbad0e5f222a3$export$b5f535122a9211f0)(flatStyle[name], (0, $4bf85f096fb6de71$export$86a7aca748b1e260), context);
    return function(context) {
        return $1249519aaada68b2$var$requireNumber(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').StringEvaluator?} The expression evaluator.
 */ function $1249519aaada68b2$var$stringEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $4bcbbad0e5f222a3$export$b5f535122a9211f0)(flatStyle[name], (0, $4bf85f096fb6de71$export$2b93044cbf134323), context);
    return function(context) {
        return $1249519aaada68b2$var$requireString(evaluator(context), name);
    };
}
function $1249519aaada68b2$var$patternEvaluator(flatStyle, prefix, context) {
    const srcEvaluator = $1249519aaada68b2$var$stringEvaluator(flatStyle, prefix + 'pattern-src', context);
    const offsetEvaluator = $1249519aaada68b2$var$sizeEvaluator(flatStyle, prefix + 'pattern-offset', context);
    const patternSizeEvaluator = $1249519aaada68b2$var$sizeEvaluator(flatStyle, prefix + 'pattern-size', context);
    const colorEvaluator = $1249519aaada68b2$var$colorLikeEvaluator(flatStyle, prefix + 'color', context);
    return function(context) {
        return {
            src: srcEvaluator(context),
            offset: offsetEvaluator && offsetEvaluator(context),
            size: patternSizeEvaluator && patternSizeEvaluator(context),
            color: colorEvaluator && colorEvaluator(context)
        };
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').BooleanEvaluator?} The expression evaluator.
 */ function $1249519aaada68b2$var$booleanEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $4bcbbad0e5f222a3$export$b5f535122a9211f0)(flatStyle[name], (0, $4bf85f096fb6de71$export$240f7fffab1b25a0), context);
    return function(context) {
        const value = evaluator(context);
        if (typeof value !== 'boolean') throw new Error(`Expected a boolean for ${name}`);
        return value;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').ColorLikeEvaluator?} The expression evaluator.
 */ function $1249519aaada68b2$var$colorLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $4bcbbad0e5f222a3$export$b5f535122a9211f0)(flatStyle[name], (0, $4bf85f096fb6de71$export$2cd82751acc0e609), context);
    return function(context) {
        return $1249519aaada68b2$var$requireColorLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').NumberArrayEvaluator?} The expression evaluator.
 */ function $1249519aaada68b2$var$numberArrayEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $4bcbbad0e5f222a3$export$b5f535122a9211f0)(flatStyle[name], (0, $4bf85f096fb6de71$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $1249519aaada68b2$var$requireNumberArray(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').CoordinateEvaluator?} The expression evaluator.
 */ function $1249519aaada68b2$var$coordinateEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $4bcbbad0e5f222a3$export$b5f535122a9211f0)(flatStyle[name], (0, $4bf85f096fb6de71$export$d701d0e49f4bcb39), context);
    return function(context) {
        const array = $1249519aaada68b2$var$requireNumberArray(evaluator(context), name);
        if (array.length !== 2) throw new Error(`Expected two numbers for ${name}`);
        return array;
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeEvaluator?} The expression evaluator.
 */ function $1249519aaada68b2$var$sizeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $4bcbbad0e5f222a3$export$b5f535122a9211f0)(flatStyle[name], (0, $4bf85f096fb6de71$export$d701d0e49f4bcb39), context);
    return function(context) {
        return $1249519aaada68b2$var$requireSize(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} name The property name.
 * @param {ParsingContext} context The parsing context.
 * @return {import('../../expr/cpu.js').SizeLikeEvaluator?} The expression evaluator.
 */ function $1249519aaada68b2$var$sizeLikeEvaluator(flatStyle, name, context) {
    if (!(name in flatStyle)) return null;
    const evaluator = (0, $4bcbbad0e5f222a3$export$b5f535122a9211f0)(flatStyle[name], (0, $4bf85f096fb6de71$export$d701d0e49f4bcb39) | (0, $4bf85f096fb6de71$export$86a7aca748b1e260), context);
    return function(context) {
        return $1249519aaada68b2$var$requireSizeLike(evaluator(context), name);
    };
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {number|undefined} A number or undefined.
 */ function $1249519aaada68b2$var$optionalNumber(flatStyle, property) {
    const value = flatStyle[property];
    if (value === undefined) return undefined;
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../size.js").Size|undefined} A size or undefined.
 */ function $1249519aaada68b2$var$optionalSize(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded === 'number') return (0, $f65ee5b9d8e75975$export$a71a825ff42fb8e1)(encoded);
    if (!Array.isArray(encoded)) throw new Error(`Expected a number or size array for ${property}`);
    if (encoded.length !== 2 || typeof encoded[0] !== 'number' || typeof encoded[1] !== 'number') throw new Error(`Expected a number or size array for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|undefined} A string or undefined.
 */ function $1249519aaada68b2$var$optionalString(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconOrigin|undefined} An icon origin or undefined.
 */ function $1249519aaada68b2$var$optionalIconOrigin(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'bottom-left' && encoded !== 'bottom-right' && encoded !== 'top-left' && encoded !== 'top-right') throw new Error(`Expected bottom-left, bottom-right, top-left, or top-right for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import("../../style/Icon.js").IconAnchorUnits|undefined} Icon anchor units or undefined.
 */ function $1249519aaada68b2$var$optionalIconAnchorUnits(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (encoded !== 'pixels' && encoded !== 'fraction') throw new Error(`Expected pixels or fraction for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {Array<number>|undefined} An array of numbers or undefined.
 */ function $1249519aaada68b2$var$optionalNumberArray(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $1249519aaada68b2$var$requireNumberArray(encoded, property);
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {import('../../style/Style.js').DeclutterMode} Icon declutter mode.
 */ function $1249519aaada68b2$var$optionalDeclutterMode(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    if (typeof encoded !== 'string') throw new Error(`Expected a string for ${property}`);
    if (encoded !== 'declutter' && encoded !== 'obstacle' && encoded !== 'none') throw new Error(`Expected declutter, obstacle, or none for ${property}`);
    return encoded;
}
/**
 * @param {FlatStyle} flatStyle The flat style.
 * @param {string} property The symbolizer property.
 * @return {string|Array<number>|undefined} A string or an array of color values or undefined.
 */ function $1249519aaada68b2$var$optionalColorLike(flatStyle, property) {
    const encoded = flatStyle[property];
    if (encoded === undefined) return undefined;
    return $1249519aaada68b2$var$requireColorLike(encoded, property);
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} An array of numbers.
 */ function $1249519aaada68b2$var$requireNumberArray(value, property) {
    if (!Array.isArray(value)) throw new Error(`Expected an array for ${property}`);
    const length = value.length;
    for(let i = 0; i < length; ++i){
        if (typeof value[i] !== 'number') throw new Error(`Expected an array of numbers for ${property}`);
    }
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {string} A string.
 */ function $1249519aaada68b2$var$requireString(value, property) {
    if (typeof value !== 'string') throw new Error(`Expected a string for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number} A number.
 */ function $1249519aaada68b2$var$requireNumber(value, property) {
    if (typeof value !== 'number') throw new Error(`Expected a number for ${property}`);
    return value;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>|string} A color.
 */ function $1249519aaada68b2$var$requireColorLike(value, property) {
    if (typeof value === 'string') return value;
    const array = $1249519aaada68b2$var$requireNumberArray(value, property);
    const length = array.length;
    if (length < 3 || length > 4) throw new Error(`Expected a color with 3 or 4 values for ${property}`);
    return array;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {Array<number>} A number or an array of two numbers.
 */ function $1249519aaada68b2$var$requireSize(value, property) {
    const size = $1249519aaada68b2$var$requireNumberArray(value, property);
    if (size.length !== 2) throw new Error(`Expected an array of two numbers for ${property}`);
    return size;
}
/**
 * @param {any} value The value.
 * @param {string} property The property.
 * @return {number|Array<number>} A number or an array of two numbers.
 */ function $1249519aaada68b2$var$requireSizeLike(value, property) {
    if (typeof value === 'number') return value;
    return $1249519aaada68b2$var$requireSize(value, property);
}




/***
 * @template T
 * @typedef {T extends import("../source/Vector.js").default<infer U extends import("../Feature.js").FeatureLike> ? U : never} ExtractedFeatureType
 */ /**
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $6e2aed29332675ea$var$Property = {
    RENDER_ORDER: 'renderOrder'
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import('../Feature').FeatureLike} FeatureType
 * @template {import("../source/Vector.js").default<FeatureType>|import("../source/VectorTile.js").default<FeatureType>} VectorSourceType<FeatureType>
 * @extends {Layer<VectorSourceType, RendererType>}
 * @template {import("../renderer/canvas/VectorLayer.js").default|import("../renderer/canvas/VectorTileLayer.js").default|import("../renderer/canvas/VectorImageLayer.js").default|import("../renderer/webgl/PointsLayer.js").default} RendererType
 * @api
 */ class $6e2aed29332675ea$var$BaseVectorLayer extends (0, $575253350abb8238$export$2e2bcd8739ae039) {
    /**
   * @param {Options<FeatureType, VectorSourceType>} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const baseOptions = Object.assign({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        super(baseOptions);
        /**
     * @private
     * @type {string}
     */ this.declutter_ = options.declutter ? String(options.declutter) : undefined;
        /**
     * @type {number}
     * @private
     */ this.renderBuffer_ = options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
     * User provided style.
     * @type {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike}
     * @private
     */ this.style_ = null;
        /**
     * Style function for use within the library.
     * @type {import("../style/Style.js").StyleFunction|undefined}
     * @private
     */ this.styleFunction_ = undefined;
        this.setStyle(options.style);
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileAnimating_ = options.updateWhileAnimating !== undefined ? options.updateWhileAnimating : false;
        /**
     * @type {boolean}
     * @private
     */ this.updateWhileInteracting_ = options.updateWhileInteracting !== undefined ? options.updateWhileInteracting : false;
    }
    /**
   * @return {string} Declutter group.
   * @override
   */ getDeclutter() {
        return this.declutter_;
    }
    /**
   * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
   * that resolves with an array of features. The array will either contain the topmost feature
   * when a hit was detected, or it will be empty.
   *
   * The hit detection algorithm used for this method is optimized for performance, but is less
   * accurate than the one used in [map.getFeaturesAtPixel()]{@link import("../Map.js").default#getFeaturesAtPixel}.
   * Text is not considered, and icons are only represented by their bounding box instead of the exact
   * image.
   *
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @return {Promise<Array<import("../Feature").FeatureLike>>} Promise that resolves with an array of features.
   * @api
   * @override
   */ getFeatures(pixel) {
        return super.getFeatures(pixel);
    }
    /**
   * @return {number|undefined} Render buffer.
   */ getRenderBuffer() {
        return this.renderBuffer_;
    }
    /**
   * @return {import("../render.js").OrderFunction|null|undefined} Render order.
   */ getRenderOrder() {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ this.get($6e2aed29332675ea$var$Property.RENDER_ORDER);
    }
    /**
   * Get the style for features.  This returns whatever was passed to the `style`
   * option at construction or to the `setStyle` method.
   * @return {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null|undefined} Layer style.
   * @api
   */ getStyle() {
        return this.style_;
    }
    /**
   * Get the style function.
   * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
   * @api
   */ getStyleFunction() {
        return this.styleFunction_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     animating.
   */ getUpdateWhileAnimating() {
        return this.updateWhileAnimating_;
    }
    /**
   * @return {boolean} Whether the rendered layer should be updated while
   *     interacting.
   */ getUpdateWhileInteracting() {
        return this.updateWhileInteracting_;
    }
    /**
   * Render declutter items for this layer
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {import("../layer/Layer.js").State} layerState Layer state.
   * @override
   */ renderDeclutter(frameState, layerState) {
        const declutterGroup = this.getDeclutter();
        if (declutterGroup in frameState.declutter === false) frameState.declutter[declutterGroup] = new (0, (/*@__PURE__*/$parcel$interopDefault($0766cff04a19fcfa$exports)))(9);
        this.getRenderer().renderDeclutter(frameState, layerState);
    }
    /**
   * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
   *     Render order.
   */ setRenderOrder(renderOrder) {
        this.set($6e2aed29332675ea$var$Property.RENDER_ORDER, renderOrder);
    }
    /**
   * Set the style for features.  This can be a single style object, an array
   * of styles, or a function that takes a feature and resolution and returns
   * an array of styles. If set to `null`, the layer has no style (a `null` style),
   * so only features that have their own styles will be rendered in the layer. Call
   * `setStyle()` without arguments to reset to the default style. See
   * [the ol/style/Style module]{@link module:ol/style/Style~Style} for information on the default style.
   *
   * If your layer has a static style, you can use [flat style]{@link module:ol/style/flat~FlatStyle} object
   * literals instead of using the `Style` and symbolizer constructors (`Fill`, `Stroke`, etc.):
   * ```js
   * vectorLayer.setStyle({
   *   "fill-color": "yellow",
   *   "stroke-color": "black",
   *   "stroke-width": 4
   * })
   * ```
   *
   * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
   * @api
   */ setStyle(style) {
        this.style_ = style === undefined ? (0, $0f1ce378ea6946fc$export$6865c5ac2f5ce8b6) : style;
        const styleLike = $6e2aed29332675ea$var$toStyleLike(style);
        this.styleFunction_ = style === null ? undefined : (0, $0f1ce378ea6946fc$export$c314ea3f6b164147)(styleLike);
        this.changed();
    }
    /**
   * @param {boolean|string|number} declutter Declutter images and text.
   * @api
   */ setDeclutter(declutter) {
        this.declutter_ = declutter ? String(declutter) : undefined;
        this.changed();
    }
}
/**
 * Coerce the allowed style types into a shorter list of types.  Flat styles, arrays of flat
 * styles, and arrays of rules are converted into style functions.
 *
 * @param {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style.
 * @return {import("../style/Style.js").StyleLike|null} The style.
 */ function $6e2aed29332675ea$var$toStyleLike(style) {
    if (style === undefined) return 0, $0f1ce378ea6946fc$export$6865c5ac2f5ce8b6;
    if (!style) return null;
    if (typeof style === 'function') return style;
    if (style instanceof (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)) return style;
    if (!Array.isArray(style)) return (0, $1249519aaada68b2$export$5a130bc4f0a0420b)([
        style
    ]);
    if (style.length === 0) return [];
    const length = style.length;
    const first = style[0];
    if (first instanceof (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)) {
        /**
     * @type {Array<Style>}
     */ const styles = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!(candidate instanceof (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039))) throw new Error('Expected a list of style instances');
            styles[i] = candidate;
        }
        return styles;
    }
    if ('style' in first) {
        /**
     * @type {Array<import("../style/flat.js").Rule>}
     */ const rules = new Array(length);
        for(let i = 0; i < length; ++i){
            const candidate = style[i];
            if (!('style' in candidate)) throw new Error('Expected a list of rules with a style property');
            rules[i] = candidate;
        }
        return (0, $1249519aaada68b2$export$fc6a94152b1b05a8)(rules);
    }
    const flatStyles = /** @type {Array<import("../style/flat.js").FlatStyle>} */ style;
    return (0, $1249519aaada68b2$export$5a130bc4f0a0420b)(flatStyles);
}
var $6e2aed29332675ea$export$2e2bcd8739ae039 = $6e2aed29332675ea$var$BaseVectorLayer;


/**
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../Map.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use [map.addLayer()]{@link import("../Map.js").default#addLayer}.
 * @property {boolean|string|number} [declutter=false] Declutter images and text. Any truthy value will enable
 * decluttering. Within a layer, a feature rendered before another has higher priority. All layers with the
 * same `declutter` value will be decluttered together. The priority is determined by the drawing order of the
 * layers with the same `declutter` value. Higher in the layer stack means higher priority. To declutter distinct
 * layers or groups of layers separately, use different truthy values for `declutter`.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style/Style~Style} for the default style
 * which will be used if this is not set.
 * @property {import("./Base.js").BackgroundColor} [background] Background color for the layer. If not specified, no background
 * will be rendered.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default<FeatureType>} [VectorSourceType=import("../source/Vector.js").default<*>]
 * @template {import('../Feature.js').FeatureLike} [FeatureType=import("./BaseVector.js").ExtractedFeatureType<VectorSourceType>]
 * @extends {BaseVectorLayer<FeatureType, VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */ class $09432eee05d1671f$var$VectorLayer extends (0, $6e2aed29332675ea$export$2e2bcd8739ae039) {
    /**
   * @param {Options<VectorSourceType, FeatureType>} [options] Options.
   */ constructor(options){
        super(options);
    }
    /**
   * @override
   */ createRenderer() {
        return new (0, $b6f9cff97736b00f$export$2e2bcd8739ae039)(this);
    }
}
var $09432eee05d1671f$export$2e2bcd8739ae039 = $09432eee05d1671f$var$VectorLayer;











/**
 * A styler. Given a style configuration, produces OpenLayers styles
 * @extends Base
 */ class $dbb7c37f8910e19f$export$28b227e8366a5b4a extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     *
     * @param styleConfig {Style} the style configuration
     */ constructor(styleConfig){
        super();
        this.styleConfig = styleConfig;
    }
    getClassName() {
        return "Styler";
    }
    getOLStyle() {
        return this._getOLStyle(false);
    }
    getOLHighlightStyle() {
        return this._getOLStyle(true);
    }
    getClusterImageStyle() {
        const clusterStyler = this.styleConfig.getRules().filter((r)=>r.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).CLUSTER).map((r)=>new $dbb7c37f8910e19f$var$SimpleStylerRule(r, this.styleConfig.getGeometryType()))[0];
        return clusterStyler ? clusterStyler.getOLStyle(false)()[0].getImage() : new (0, $e163d3c698de5692$export$2e2bcd8739ae039)({
            radius: 10,
            stroke: new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                color: 'white'
            }),
            fill: new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
                color: '#3399CC'
            })
        });
    }
    _getOLStyle(highlight) {
        const configRules = this.styleConfig.getRules();
        let noDataRuleConfig = configRules.filter(function(r) {
            return r.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).NODATA;
        });
        noDataRuleConfig = noDataRuleConfig.length > 0 ? noDataRuleConfig[0] : undefined;
        let stylerRules = [];
        for(let r in configRules){
            let configRule = configRules[r];
            switch(configRule.getStyleRuleType()){
                case (0, $815c91046e476159$export$23989178094d68d).CLASSIFIED:
                    stylerRules.push(new $dbb7c37f8910e19f$var$ClassifiedStylerRule(configRule, this.styleConfig.getGeometryType(), this.styleConfig.getAttribute()));
                    break;
                case (0, $815c91046e476159$export$23989178094d68d).CONTINUOUS:
                    stylerRules.push(new $dbb7c37f8910e19f$var$ContinuousStylerRule(configRule, this.styleConfig.getGeometryType(), this.styleConfig.getAttribute()));
                    break;
                case (0, $815c91046e476159$export$23989178094d68d).DISCRETE:
                    stylerRules.push(new $dbb7c37f8910e19f$var$DiscreteStylerRule(configRule, this.styleConfig.getGeometryType(), this.styleConfig.getAttribute()));
                    break;
                case (0, $815c91046e476159$export$23989178094d68d).SIMPLE:
                    stylerRules.push(new $dbb7c37f8910e19f$var$SimpleStylerRule(configRule, this.styleConfig.getGeometryType()));
                    break;
                default:
                    break;
            }
        }
        if (noDataRuleConfig) stylerRules.push(new $dbb7c37f8910e19f$var$SimpleStylerRule(noDataRuleConfig, this.styleConfig.getGeometryType()));
        let previous = undefined;
        for(let s in stylerRules){
            if (previous) previous.setNextStylerRule(stylerRules[s]);
            previous = stylerRules[s];
        }
        return stylerRules.length > 0 ? stylerRules[0].getOLStyle(highlight) : undefined;
    }
}
/**
 * A styler for charts
 * @extends Base
 */ class $dbb7c37f8910e19f$export$b82f4f1213831c77 extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     *
     * @param styleConfig {Style} the style configuration
     */ constructor(styleConfig){
        super();
        this.styleConfig = styleConfig;
    }
    getClassName() {
        return "ChartStyler";
    }
    getAttributeName() {
        return this.styleConfig.getAttribute();
    }
    getFirstRuleType() {
        const rules = this.styleConfig.getRules();
        return rules && rules.length > 0 ? rules[0].getStyleRuleType() : undefined;
    }
    getPlotlyColorscale() {
        const colorScale = [];
        if (this.styleConfig) this.styleConfig.getRules().forEach((rule)=>{
            const styleRuleType = rule.getStyleRuleType();
            if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CONTINUOUS) rule.getRanges().forEach((range)=>{
                colorScale.push([
                    range.getMinValue(),
                    range.getMinBackgroundColor()
                ]);
                colorScale.push([
                    range.getMaxValue(),
                    range.getMaxBackgroundColor()
                ]);
            });
            else if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).DISCRETE) rule.getBuckets().forEach((bucket)=>{
                colorScale.push([
                    bucket.getMinValue(),
                    bucket.getBackgroundColor()
                ]);
                colorScale.push([
                    bucket.getMaxValue(),
                    bucket.getBackgroundColor()
                ]);
            });
            else if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CLASSIFIED) rule.getClasses().forEach((clazz)=>{
                colorScale.push([
                    clazz.getValue(),
                    clazz.getBackgroundColor()
                ]);
            });
        });
        return colorScale;
    }
    getMinMaxColor() {
        let colors = [], minValue, maxValue;
        if (this.styleConfig) this.styleConfig.getRules().forEach((rule)=>{
            const styleRuleType = rule.getStyleRuleType();
            if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).CONTINUOUS) rule.getRanges().forEach((range)=>{
                if (range.getMinValue() === undefined || minValue === undefined || range.getMinValue() < minValue) {
                    minValue = range.getMinValue();
                    colors[0] = range.getMinBackgroundColor();
                }
                if (range.getMaxValue() === undefined || maxValue === undefined || range.getMaxValue() > maxValue) {
                    maxValue = range.getMaxValue();
                    colors[1] = range.getMaxBackgroundColor();
                }
            });
            else if (styleRuleType === (0, $815c91046e476159$export$23989178094d68d).DISCRETE) rule.getBuckets().forEach((bucket)=>{
                if (bucket.getMinValue() === undefined || minValue === undefined || bucket.getMinValue() < minValue) {
                    minValue = bucket.getMinValue();
                    colors[0] = bucket.getBackgroundColor();
                }
                if (bucket.getMaxValue() === undefined || maxValue === undefined || bucket.getMaxValue() > maxValue) {
                    maxValue = bucket.getMaxValue();
                    colors[1] = bucket.getBackgroundColor();
                }
            });
        });
        return colors;
    }
    getIsNoDataFunction() {
        const stylerRules = this._getStyleRules();
        return (value)=>{
            if (value === undefined || value === null) return true;
            return stylerRules.filter((sr)=>sr.getIsInScopeFunction()(value)).length === 0;
        };
    }
    getColorFunction() {
        const stylerRules = this._getStyleRules();
        return (value)=>{
            for(let f in stylerRules){
                const color = stylerRules[f].getColorFunction()(value);
                if (color) return color;
            }
            return undefined;
        };
    }
    getLabelFunction(noMinMax = false) {
        const stylerRules = this._getStyleRules();
        return (value)=>{
            for(let f in stylerRules){
                const label = stylerRules[f].getLabelFunction(noMinMax)(value);
                if (label) return label;
            }
            return undefined;
        };
    }
    getYAxisLabel() {
        const rules = this.styleConfig.getRules();
        return rules.length > 0 ? rules[0].getLabel() : undefined;
    }
    _getStyleRules() {
        const configRules = this.styleConfig.getRules();
        const noDataRuleConfig = configRules.filter(function(r) {
            return r.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).NODATA;
        })[0];
        const stylerRules = [];
        this.styleConfig.getRules().forEach((configRule)=>{
            switch(configRule.getStyleRuleType()){
                case (0, $815c91046e476159$export$23989178094d68d).CLASSIFIED:
                    stylerRules.push(new $dbb7c37f8910e19f$var$ClassifiedStylerRule(configRule, this.styleConfig.getGeometryType(), this.styleConfig.getAttribute()));
                    break;
                case (0, $815c91046e476159$export$23989178094d68d).CONTINUOUS:
                    stylerRules.push(new $dbb7c37f8910e19f$var$ContinuousStylerRule(configRule, this.styleConfig.getGeometryType(), this.styleConfig.getAttribute()));
                    break;
                case (0, $815c91046e476159$export$23989178094d68d).DISCRETE:
                    stylerRules.push(new $dbb7c37f8910e19f$var$DiscreteStylerRule(configRule, this.styleConfig.getGeometryType(), this.styleConfig.getAttribute()));
                    break;
                case (0, $815c91046e476159$export$23989178094d68d).SIMPLE:
                    stylerRules.push(new $dbb7c37f8910e19f$var$SimpleStylerRule(configRule, this.styleConfig.getGeometryType()));
                    break;
                default:
                    break;
            }
        });
        if (noDataRuleConfig) stylerRules.push(new $dbb7c37f8910e19f$var$SimpleStylerRule(noDataRuleConfig, this.styleConfig.getGeometryType()));
        let previous = undefined;
        stylerRules.forEach((stylerRule)=>{
            if (previous) previous.setNextStylerRule(stylerRule);
            previous = stylerRule;
        });
        return stylerRules;
    }
    isClassified() {
        return this.styleConfig.getRules().filter((r)=>r.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).CLASSIFIED).length > 0;
    }
    isDiscrete() {
        return this.styleConfig.getRules().filter((r)=>r.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).DISCRETE).length > 0;
    }
    isOnlyDiscrete() {
        const ruleCount = this.styleConfig.getRules().length;
        return ruleCount > 0 && this.styleConfig.getRules().filter((r)=>r.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).DISCRETE).length === ruleCount;
    }
    getValueLegendIndex(value) {
        if (value === 0 || value === undefined) return undefined;
        if (this._getStyleRules()[0].getType() === (0, $815c91046e476159$export$23989178094d68d).SIMPLE) return 0;
        if (this.isClassified()) {
            const classifiedStylerRule = this._getStyleRules()[0];
            const classes = classifiedStylerRule._getClasses();
            for(let i = 0; i < classes.length; i++)if (classes[i].getValue() === value) return i;
            return undefined;
        } else {
            let i = 0;
            for (let styleRule of this._getStyleRules()){
                if (styleRule.getType() === (0, $815c91046e476159$export$23989178094d68d).DISCRETE) for (let bucket of styleRule._getBuckets()){
                    i++;
                    if ((bucket.getMinValue() === undefined || bucket.getMinValue() <= value) && (bucket.getMaxValue() === undefined || bucket.getMaxValue() >= value)) return i;
                }
                else if (styleRule.getType() === (0, $815c91046e476159$export$23989178094d68d).CONTINUOUS) for (let range of styleRule._getRanges()){
                    i++;
                    if ((range.getMinValue() === undefined || range.getMinValue() <= value) && (range.getMaxValue() === undefined || range.getMaxValue() >= value)) return i;
                }
            }
        }
    }
}
/**
 * Any styler rule
 * @extends Base
 */ class $dbb7c37f8910e19f$var$StylerRule extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     *
     * @param styleRuleConfig {StyleRule} the style rule configuration
     * @param geometryType {GeometryTypeEnum} the type of the geometry
     */ constructor(styleRuleConfig, geometryType){
        super();
        this.styleRuleConfig = styleRuleConfig;
        this.geometryType = geometryType;
    }
    getClassName() {
        return "StylerRule";
    }
    getType() {
        return this.styleRuleConfig.getStyleRuleType();
    }
    /**
     * @param nextStylerRule {StylerRule} The next stylerRule to apply, if this one does not fit. Can be undefined
     */ setNextStylerRule(nextStylerRule) {
        this.nextStylerRule = nextStylerRule;
    }
    /**
     * Get an OpenLayers style suitable to render a vector layer
     * @param highlight {boolean} is this style meant to highlight features?
     * @return {function} function(Feature,Number)->Style
     */ getOLStyle(highlight) {}
    /**
     * A function that given value {string|number}, get a color, applying this style to the value
     * @return {function} that returns a CSS color
     */ getColorFunction() {}
    /**
     * A function that given value {string|number}, returns true if it is un scope of this rule
     * @return {function} true if value in scope of this rule
     */ getIsInScopeFunction() {
        return (value)=>true;
    }
    readValue(feature) {
        if (this.attribute) {
            if (this.attribute.indexOf('.') > 0) {
                const path = this.attribute.split('.');
                let val = feature.getProperties();
                if (val.features && val.features.length > 1) return undefined;
                if (val.features && val.features.length === 1) val = val.features[0].getProperties();
                path.forEach((p)=>{
                    val = val[p];
                });
                return val;
            } else return feature.get(this.attribute);
        }
    }
    /**
     * A function that given value {string|number}, get a label, applying this style to the value
     * @return {function} that returns string
     */ getLabelFunction() {}
    getCircleOLOptions(radius, fillColor, borderColor, borderWidth, highlight) {
        const res = {
            radius: radius,
            fill: new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
                color: fillColor
            })
        };
        if (borderColor) {
            if (highlight) {
                if ((0, $9d480b6dede89078$export$1b0fd8199ce5537b)(borderColor)) res.stroke = new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                    color: 'black',
                    width: 3
                });
                else res.stroke = new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                    color: 'white',
                    width: 3
                });
            } else res.stroke = new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                color: borderColor,
                width: borderWidth
            });
        } else if (highlight) res.stroke = new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
            color: 'white',
            width: 3
        });
        return res;
    }
    getLineOLStrokes(linePattern, borderColor, borderWidth, highlight) {
        const res = {
            width: borderWidth
        };
        const strokes = [];
        if (linePattern) {
            const transparentOptions = {};
            switch(linePattern){
                case (0, $815c91046e476159$export$6b4efad1d1b9c97e).DASHED:
                    res.lineDash = [
                        10,
                        8
                    ];
                    transparentOptions.lineDash = [
                        8,
                        10
                    ];
                    transparentOptions.lineDashOffset = 8;
                    break;
                case (0, $815c91046e476159$export$6b4efad1d1b9c97e).DOTTED:
                    res.lineDash = [
                        0.5,
                        8
                    ];
                    transparentOptions.lineDash = [
                        8,
                        0.5
                    ];
                    transparentOptions.lineDashOffset = 8;
                    break;
                default:
                    break;
            }
            transparentOptions.color = 'rgba(0,0,0,0)';
            transparentOptions.width = highlight ? 2 : borderWidth;
            strokes.push(new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)(transparentOptions));
        }
        if (highlight) {
            if ((0, $9d480b6dede89078$export$1b0fd8199ce5537b)(borderColor)) res.color = 'black';
            else res.color = 'white';
            res.width = 2;
        } else res.color = borderColor;
        strokes.push(new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)(res));
        return strokes;
    }
    getPolygonOLStyles(borderColor, borderWidth, backgroundColor, fillPattern, highlight) {
        return this.getPolygonWithBorderPatternOLStyles(borderColor, borderWidth, undefined, backgroundColor, fillPattern, highlight);
    }
    getPolygonWithBorderPatternOLStyles(borderColor, borderWidth = .5, borderPattern, backgroundColor, fillPattern, highlight) {
        const fill = new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)();
        if (fillPattern) {
            const patternCanvas = this._drawPolygonPattern(fillPattern.getColor(), fillPattern.getWidth(), fillPattern.getFillPatternType());
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const pattern = ctx.createPattern(patternCanvas, 'repeat');
            fill.setColor(pattern);
        } else fill.setColor(backgroundColor);
        const style = new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
            fill: fill
        });
        let stroke;
        if (borderColor) {
            stroke = new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                width: borderWidth
            });
            if (highlight) stroke.setColor((0, $9d480b6dede89078$export$1b0fd8199ce5537b)(borderColor) ? 'black' : 'white');
            else stroke.setColor(borderColor);
            style.setStroke(stroke);
        } else if (highlight) {
            stroke = new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                width: 2,
                color: (0, $9d480b6dede89078$export$1b0fd8199ce5537b)(backgroundColor) ? 'black' : 'white'
            });
            style.setStroke(stroke);
        }
        if (borderPattern && borderPattern === (0, $815c91046e476159$export$6b4efad1d1b9c97e).DOTTED) stroke.setLineDash([
            0.5,
            8
        ]);
        if (borderPattern && borderPattern === (0, $815c91046e476159$export$6b4efad1d1b9c97e).DASHED) stroke.setLineDash([
            10,
            8
        ]);
        return [
            style
        ];
    }
    _drawPolygonPattern(color, thickness, fillType) {
        const GRAPHIC_WIDTH = 50;
        const GRAPHIC_HEIGHT = 50;
        const canvas = $dc57b31f1b066f38$exports('<canvas width="' + GRAPHIC_WIDTH + '" height="' + GRAPHIC_HEIGHT + '"></canvas>')[0];
        const context = canvas.getContext("2d");
        switch(fillType){
            case (0, $815c91046e476159$export$a94ab4528edf2788).DIAGONAL_CROSS:
                (0, $af01f743644ebf1c$export$dc133b72d0ece32e)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, GRAPHIC_WIDTH / (thickness * (GRAPHIC_WIDTH / 12)), true);
                (0, $af01f743644ebf1c$export$dc133b72d0ece32e)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, GRAPHIC_WIDTH / (thickness * (GRAPHIC_WIDTH / 12)), false);
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).DIAGONAL:
                (0, $af01f743644ebf1c$export$dc133b72d0ece32e)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, GRAPHIC_WIDTH / (thickness * (GRAPHIC_WIDTH / 12)), false);
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).ANTI_DIAGONAL:
                (0, $af01f743644ebf1c$export$dc133b72d0ece32e)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, GRAPHIC_WIDTH / (thickness * (GRAPHIC_WIDTH / 12)), true);
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).HORIZONTAL:
                (0, $af01f743644ebf1c$export$af293fdb3352a881)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, 5);
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).VERTICAL:
                (0, $af01f743644ebf1c$export$b1b6535abd1fa66a)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, 5);
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).CROSS:
                (0, $af01f743644ebf1c$export$af293fdb3352a881)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, 5);
                (0, $af01f743644ebf1c$export$b1b6535abd1fa66a)(context, color, thickness, GRAPHIC_WIDTH, GRAPHIC_HEIGHT, 5);
                break;
            case (0, $815c91046e476159$export$a94ab4528edf2788).DOTTED:
                (0, $af01f743644ebf1c$export$6c43b2af4695d113)(context, color, GRAPHIC_WIDTH + 2, GRAPHIC_HEIGHT + 2, 12, 12, 2);
                break;
            default:
                break;
        }
        return canvas;
    }
}
/**
 * A Classified Style
 * @extends StylerRule
 */ class $dbb7c37f8910e19f$var$ClassifiedStylerRule extends $dbb7c37f8910e19f$var$StylerRule {
    /**
     *
     * @param styleRule {StyleRule} the style rule configuration
     * @param geometryType {GeometryTypeEnum} the type of the geometry
     * @param attribute {string} the name of the attribute where the classification is
     */ constructor(styleRule, geometryType, attribute){
        super(styleRule, geometryType);
        this.attribute = attribute;
    }
    getClassName() {
        return "ClassifiedStylerRule";
    }
    _getClasses() {
        return this.styleRuleConfig.getClasses();
    }
    getOLStyle(highlight) {
        const classes = this._getClasses();
        return (feature, resolution)=>{
            const originalValue = this.readValue(feature);
            const value = originalValue !== undefined ? '' + originalValue : undefined;
            let foundClass = false;
            for(let c in classes){
                const clazz = classes[c];
                const classValue = clazz.getValue();
                if (classValue === value || !foundClass && classValue === undefined) {
                    foundClass = true;
                    if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) return [
                        new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                            image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)(this.getCircleOLOptions(clazz.getRadius(), clazz.getBackgroundColor(), clazz.getBorderColor(), clazz.getBorderWidth(), highlight))
                        })
                    ];
                    if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).LINE) {
                        const linePattern = clazz.getLinePattern();
                        if (linePattern) {
                            const lineOLStrokes = this.getLineOLStrokes(linePattern.getLinePatternType(), linePattern.getColor(), linePattern.getWidth(), highlight);
                            return lineOLStrokes.map((s)=>new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                                    stroke: s
                                }));
                        }
                        const lineOLStrokes = this.getLineOLStrokes(undefined, clazz.getBorderColor(), clazz.getBorderWidth(), highlight);
                        return lineOLStrokes.map((s)=>new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                                stroke: s
                            }));
                    }
                    if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON) {
                        const linePattern = clazz.getLinePattern();
                        if (linePattern) return this.getPolygonWithBorderPatternOLStyles(linePattern.getColor(), linePattern.getWidth(), linePattern.getLinePatternType(), clazz.getBackgroundColor(), clazz.getFillPattern(), highlight);
                        return this.getPolygonOLStyles(clazz.getBorderColor(), clazz.getBorderWidth(), clazz.getBackgroundColor(), clazz.getFillPattern(), highlight);
                    }
                }
            }
            if (this.nextStylerRule) return this.nextStylerRule.getOLStyle(highlight)(feature, resolution);
        };
    }
    getColorFunction() {
        const classes = this._getClasses();
        return (value)=>{
            value = value !== undefined && value !== null ? value.toString() : value;
            const color = classes.filter((c)=>c.getValue() === value).map((c)=>c.getBackgroundColor())[0];
            if (color) return color;
            if (value) return "rgba(0,0,0,0)";
            if (this.nextStylerRule) return this.nextStylerRule.getColorFunction()(value);
        };
    }
    getIsInScopeFunction() {
        const classes = this._getClasses();
        return (value)=>{
            if (value === undefined || value === null) return false;
            value = value.toString();
            return classes.filter((c)=>c.getValue() === value).length > 0;
        };
    }
    getLabelFunction() {
        const classes = this._getClasses();
        return (value)=>{
            value = value !== undefined && value !== null ? value.toString() : value;
            const label = classes.filter((c)=>c.getValue() === value).map((c)=>c.getLabel())[0];
            if (label) return label;
            if (value) return "NO_DATA";
            if (this.nextStylerRule) return this.nextStylerRule.getLabelFunction()(value);
        };
    }
}
/**
 * A Discrete Style
 * @extends StylerRule
 */ class $dbb7c37f8910e19f$var$DiscreteStylerRule extends $dbb7c37f8910e19f$var$StylerRule {
    /**
     *
     * @param styleRule {StyleRule} the style rule configuration
     * @param geometryType {GeometryTypeEnum} the type of the geometry
     * @param attribute {string} the name of the attribute where the value is
     */ constructor(styleRule, geometryType, attribute){
        super(styleRule, geometryType);
        this.attribute = attribute;
    }
    getClassName() {
        return "DiscreteStylerRule";
    }
    getOLStyle(highlight) {
        const buckets = this._getBuckets();
        const styleFunction = (feature, resolution)=>{
            const value = this.readValue(feature);
            if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(value)) for(let b in buckets){
                const bucket = buckets[b];
                if ((bucket.getMinValue() === undefined || bucket.getMinValue() <= value) && (bucket.getMaxValue() === undefined || bucket.getMaxValue() >= value)) {
                    if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) return [
                        new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                            image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)(this.getCircleOLOptions(bucket.getRadius(), bucket.getBackgroundColor(), bucket.getBorderColor(), bucket.getBorderWidth(), highlight))
                        })
                    ];
                    if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).LINE) {
                        const lineOLStrokes = this.getLineOLStrokes(undefined, bucket.getBorderColor(), bucket.getBorderWidth(), highlight);
                        return lineOLStrokes.map((s)=>new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                                stroke: s
                            }));
                    }
                    if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON) return this.getPolygonOLStyles(bucket.getBorderColor(), bucket.getBorderWidth(), bucket.getBackgroundColor(), undefined, highlight);
                }
            }
            if (this.nextStylerRule) return this.nextStylerRule.getOLStyle(highlight)(feature, resolution);
        };
        return styleFunction;
    }
    readValue(feature) {
        return (0, $2536f84a954bf107$export$a0a81dc3380ce7d3)(super.readValue(feature));
    }
    getColorFunction() {
        const buckets = this._getBuckets();
        return (value)=>{
            if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(value)) {
                const color = buckets.filter((bucket)=>(bucket.getMinValue() === undefined || bucket.getMinValue() <= value) && (bucket.getMaxValue() === undefined || bucket.getMaxValue() >= value)).map((b)=>b.getBackgroundColor())[0];
                if (color) return color;
            }
            if (this.nextStylerRule) return this.nextStylerRule.getColorFunction()(value);
        };
    }
    getIsInScopeFunction() {
        const buckets = this._getBuckets();
        return (value)=>{
            if (value === undefined || value === null) return false;
            if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(value)) return buckets.filter((bucket)=>(bucket.getMinValue() === undefined || bucket.getMinValue() <= value) && (bucket.getMaxValue() === undefined || bucket.getMaxValue() >= value)).length > 0;
        };
    }
    _getBuckets() {
        return this.styleRuleConfig.getBuckets();
    }
    getLabelFunction(noMinMax = false) {
        const buckets = this._getBuckets();
        return (value)=>{
            if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(value)) return buckets.filter((bucket)=>(bucket.getMinValue() === undefined || bucket.getMinValue() <= value) && (bucket.getMaxValue() === undefined || bucket.getMaxValue() >= value)).map((b)=>{
                if (b.getLabel()) return b.getLabel();
                if (!noMinMax && b.getMinLabel() && b.getMaxLabel()) return b.getMinLabel() + " - " + b.getMaxLabel();
                if (noMinMax) return null;
                return b.getMinLabel() ? b.getMinLabel() : b.getMaxLabel() ? b.getMaxLabel() : null;
            })[0];
            if (this.nextStylerRule) return this.nextStylerRule.getLabelFunction(noMinMax)(value);
        };
    }
}
/**
 * A Continuous Style
 * @extends StylerRule
 */ class $dbb7c37f8910e19f$var$ContinuousStylerRule extends $dbb7c37f8910e19f$var$StylerRule {
    /**
     *
     * @param styleRule {StyleRule} the style rule configuration
     * @param geometryType {GeometryTypeEnum} the type of the geometry
     * @param attribute {string} the name of the attribute where the value is
     */ constructor(styleRule, geometryType = (0, $815c91046e476159$export$427161d533086393).POLYGON, attribute){
        super(styleRule, geometryType);
        this.attribute = attribute;
    }
    getClassName() {
        return "ContinuousStylerRule";
    }
    _interpolate(value, minColor, maxColor, minValue, maxValue) {
        const rMin = minColor.values[0];
        const gMin = minColor.values[1];
        const bMin = minColor.values[2];
        const aMin = minColor.alpha;
        const rMax = maxColor.values[0];
        const gMax = maxColor.values[1];
        const bMax = maxColor.values[2];
        const aMax = maxColor.alpha;
        const steps = 10000.0;
        const zeroedMaxValue = maxValue - minValue;
        const zeroedValue = value - minValue;
        const valueStep = zeroedMaxValue > 0 ? zeroedValue * steps / zeroedMaxValue : 0;
        const interpolatedR = (rMax - rMin) * valueStep / steps + rMin;
        const interpolatedG = (gMax - gMin) * valueStep / steps + gMin;
        const interpolatedB = (bMax - bMin) * valueStep / steps + bMin;
        const interpolatedA = (aMax - aMin) * valueStep / steps + aMin;
        return 'rgba(' + [
            interpolatedR.toFixed(0),
            interpolatedG.toFixed(0),
            interpolatedB.toFixed(0),
            interpolatedA
        ].join(',') + ')';
    }
    readValue(feature) {
        return (0, $2536f84a954bf107$export$a0a81dc3380ce7d3)(super.readValue(feature));
    }
    getColorFunction() {
        const ranges = this._getRanges();
        return (value)=>{
            if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(value)) {
                const color = ranges.filter((range)=>(range.getMinValue() === undefined || range.getMinValue() <= value) && (range.getMaxValue() === undefined || range.getMaxValue() >= value)).map((r)=>{
                    const minColor = (0, (/*@__PURE__*/$parcel$interopDefault($5f14bb65263850e1$exports)))(r.getMinBackgroundColor());
                    const maxColor = (0, (/*@__PURE__*/$parcel$interopDefault($5f14bb65263850e1$exports)))(r.getMaxBackgroundColor());
                    return this._interpolate(value, minColor, maxColor, r.getMinValue(), r.getMaxValue());
                })[0];
                if (color) return color;
            }
            if (this.nextStylerRule) return this.nextStylerRule.getColorFunction()(value);
        };
    }
    getIsInScopeFunction() {
        const ranges = this._getRanges();
        return (value)=>{
            if (value === undefined || value === null) return false;
            if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(value)) return ranges.filter((range)=>(range.getMinValue() === undefined || range.getMinValue() <= value) && (range.getMaxValue() === undefined || range.getMaxValue() >= value)).length > 0;
        };
    }
    _getRanges() {
        return this.styleRuleConfig.getRanges();
    }
    getLabelFunction() {
        const ranges = this._getRanges();
        return (value)=>{
            if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(value)) return ranges.filter((range)=>(range.getMinValue() === undefined || range.getMinValue() <= value) && (range.getMaxValue() === undefined || range.getMaxValue() >= value)).map((r)=>{
                return r.getMinValue() === value ? r.getMinLabel() : r.getMaxValue() === value ? r.getMaxLabel() : null;
            })[0];
            if (this.nextStylerRule) return this.nextStylerRule.getLabelFunction()(value);
        };
    }
    getOLStyle(highlight) {
        const ranges = this._getRanges();
        return (feature, resolution)=>{
            const value = this.readValue(feature);
            if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(value)) for(let r in ranges){
                const range = ranges[r];
                if ((range.getMinValue() === undefined || range.getMinValue() <= value) && (range.getMaxValue() === undefined || range.getMaxValue() >= value)) {
                    const minColor = (0, (/*@__PURE__*/$parcel$interopDefault($5f14bb65263850e1$exports)))(range.getMinBackgroundColor());
                    const maxColor = (0, (/*@__PURE__*/$parcel$interopDefault($5f14bb65263850e1$exports)))(range.getMaxBackgroundColor());
                    const color = this._interpolate(value, minColor, maxColor, range.getMinValue(), range.getMaxValue());
                    if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) return [
                        new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                            image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)(this.getCircleOLOptions(range.getRadius(), color, range.getBorderColor(), range.getBorderWidth(), highlight))
                        })
                    ];
                    if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).LINE) {
                        const lineOLStrokes = this.getLineOLStrokes(undefined, color, range.getBorderWidth(), highlight);
                        return lineOLStrokes.map((s)=>new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                                stroke: s
                            }));
                    }
                    if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON) return this.getPolygonOLStyles(range.getBorderColor(), range.getBorderWidth(), color, undefined, highlight);
                }
            }
            if (this.nextStylerRule) return this.nextStylerRule.getOLStyle(highlight)(feature, resolution);
        };
    }
}
/**
 * A simple style
 * @extends StylerRule
 * @hideconstructor
 */ class $dbb7c37f8910e19f$var$SimpleStylerRule extends $dbb7c37f8910e19f$var$StylerRule {
    getClassName() {
        return "SimpleStylerRule";
    }
    getOLStyle(highlight) {
        return (feature, resolution)=>{
            if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).POINT) return [
                new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                    image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)(this.getCircleOLOptions(this.styleRuleConfig.getRadius(), this.styleRuleConfig.getBackgroundColor(), this.styleRuleConfig.getBorderColor(), this.styleRuleConfig.getBorderWidth(), highlight))
                })
            ];
            else if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).LINE) {
                const lineOLStrokes = this.getLineOLStrokes(this.styleRuleConfig.getLinePattern().getLinePatternTypeEnum(), this.styleRuleConfig.getBorderColor(), this.styleRuleConfig.getBorderWidth(), highlight);
                return lineOLStrokes.map((s)=>new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                        stroke: s
                    }));
            } else if (this.geometryType === (0, $815c91046e476159$export$427161d533086393).POLYGON) {
                const linePattern = this.styleRuleConfig.getLinePattern();
                if (linePattern) return this.getPolygonWithBorderPatternOLStyles(linePattern.getColor(), linePattern.getWidth(), linePattern.getLinePatternType(), this.styleRuleConfig.getBackgroundColor(), this.styleRuleConfig.getFillPattern(), highlight);
                return this.getPolygonOLStyles(this.styleRuleConfig.getBorderColor(), this.styleRuleConfig.getBorderWidth(), this.styleRuleConfig.getBackgroundColor(), this.styleRuleConfig.getFillPattern(), highlight);
            }
        };
    }
    isNoData() {
        return this.styleRuleConfig.getStyleRuleType() === (0, $815c91046e476159$export$23989178094d68d).NODATA;
    }
    getColorFunction() {
        return (value)=>{
            if (this.isNoData() && (value === null || value === undefined)) return this.styleRuleConfig.getBackgroundColor();
            if (!this.isNoData()) return this.styleRuleConfig.getBackgroundColor();
        };
    }
    getLabelFunction() {
        return (value)=>{
            if (this.isNoData() && (value === null || value === undefined)) return this.styleRuleConfig.getLabel();
            if (!this.isNoData()) return this.styleRuleConfig.getLabel();
        };
    }
}







/**
 * A slim panel that can be placed anywhere over the map
 * @extends UIElement
 */ class $cb89f142cf8b9fe8$export$8e6dfb06e29200e6 extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Panel id
     * @param classes {string} HTML classes for the panel
     * @param runtimeConfig {MapRuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */ constructor(translator, isMobileDevice, id, classes, runtimeConfig, onChangeRuntimeConfig){
        super(id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.classes = classes;
        this.visible = false;
    }
    getClassName() {
        return "SlimPanel";
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div id="' + this.id + '" class="slim-panel-container ol-unselectable ol-control">' + '  <div aria-labelledby="' + this.id + '_title" role="dialog" aria-modal="true" class="slim-panel">' + '     <div class="slim-panel-container-header">' + '         <div class="slim-panel-title" id="' + this.id + '_title"></div>' + '         <button type="button" title="' + this.translator.translate('slimPanel.closer.name') + '" class="slim-panel-container-closer close-button"></button>' + '     </div>' + '     <div class="slim-panel-container-body"></div>' + '  </div>' + '</div>');
            if (this.classes) this.uiElement.addClass(this.classes);
            $dc57b31f1b066f38$exports('.slim-panel-container-header .close-button', this.uiElement).click(()=>{
                this.hide();
                this.logStat("HIDE");
            });
            this.uiElement.hide();
        }
        return this.uiElement;
    }
    /**
     * Set the title of the panel
     * @param titleText {string} The title
     */ setTitle(titleText) {
        $dc57b31f1b066f38$exports('.slim-panel-title', this.getUIElement()).empty().html(titleText);
    }
    /**
     * Set the content of the panel
     * @param elements {jQuery} The content
     */ setContent(elements) {
        $dc57b31f1b066f38$exports('.slim-panel-container-body', this.getUIElement()).empty().append('<div class="top"></div>').append(elements).append('<div class="bottom"></div>');
    }
    getCode() {
        return this.id;
    }
    /**
     * Hide the panel
     */ hide() {
        if (this.visible) {
            $dc57b31f1b066f38$exports('.slim-panel', this.getUIElement().fadeOut(600)).attr('tabIndex', "-1");
            this.visible = false;
            (0, $9a87c76e274c7738$export$f03163d7279986d4).openUIElements.pop();
        }
    }
    /**
     * Hide the panel
     */ hideNoAnimation() {
        if (this.visible) {
            $dc57b31f1b066f38$exports('.slim-panel', this.getUIElement().hide()).attr('tabIndex', "-1");
            this.visible = false;
            (0, $9a87c76e274c7738$export$f03163d7279986d4).openUIElements.pop();
        }
    }
    /**
     * Show without defining a position
     */ showNoPosition() {
        if (!this.visible) {
            $dc57b31f1b066f38$exports('.slim-panel', this.getUIElement().css({
                top: '',
                left: '',
                position: ''
            }).fadeIn(400));
            this.visible = true;
            (0, $9a87c76e274c7738$export$f03163d7279986d4).openUIElements.push(this);
        }
    }
    /**
     * Show in coordinates
     * @param top {number} pixels counting from top (integer)
     * @param left {number} pixels counting from left (integer)
     */ show(top, left) {
        if (!this.visible) {
            if (!this.isSmallContainerWidth && !this.isSmallContainerHeight) $dc57b31f1b066f38$exports('.slim-panel', this.getUIElement().css({
                top: top,
                left: left,
                position: 'absolute'
            }).fadeIn(400)).attr('tabIndex', "1");
            else $dc57b31f1b066f38$exports('.slim-panel', this.getUIElement().css({
                top: '',
                left: '',
                position: ''
            }).fadeIn(400)).attr('tabIndex', "1");
            this.visible = true;
            (0, $9a87c76e274c7738$export$f03163d7279986d4).openUIElements.push(this);
        }
    }
    /**
     * Show panel on top position
     */ showTop() {
        if (!this.visible) {
            $dc57b31f1b066f38$exports('.slim-panel', this.uiElement.css({
                top: '',
                left: '',
                position: ''
            }).removeClass('bottom').addClass('top').fadeIn(400)).attr('tabIndex', "1");
            this.visible = true;
            (0, $9a87c76e274c7738$export$f03163d7279986d4).openUIElements.push(this);
        }
    }
    /**
     * Show panel on bottom position
     */ showBottom() {
        if (!this.visible) {
            $dc57b31f1b066f38$exports('.slim-panel', this.uiElement.css({
                top: '',
                left: '',
                position: ''
            }).addClass('bottom').removeClass('top').fadeIn(400)).attr('tabIndex', "1");
            this.visible = true;
            (0, $9a87c76e274c7738$export$f03163d7279986d4).openUIElements.push(this);
        }
    }
    isVisible() {
        return this.visible;
    }
    close() {
        this.hideNoAnimation();
    }
}




/**
 * @module ol/Overlay
 */ /**
 * @module ol/MapEventType
 */ /**
 * @enum {string}
 */ var $392290a16437301e$export$2e2bcd8739ae039 /***
 * @typedef {'postrender'|'movestart'|'moveend'|'loadstart'|'loadend'} Types
 */  = {
    /**
   * Triggered after a map frame is rendered.
   * @event module:ol/MapEvent~MapEvent#postrender
   * @api
   */ POSTRENDER: 'postrender',
    /**
   * Triggered when the map starts moving.
   * @event module:ol/MapEvent~MapEvent#movestart
   * @api
   */ MOVESTART: 'movestart',
    /**
   * Triggered after the map is moved.
   * @event module:ol/MapEvent~MapEvent#moveend
   * @api
   */ MOVEEND: 'moveend',
    /**
   * Triggered when loading of additional map data (tiles, images, features) starts.
   * @event module:ol/MapEvent~MapEvent#loadstart
   * @api
   */ LOADSTART: 'loadstart',
    /**
   * Triggered when loading of additional map data has completed.
   * @event module:ol/MapEvent~MapEvent#loadend
   * @api
   */ LOADEND: 'loadend'
};







/**
 * @typedef {'bottom-left' | 'bottom-center' | 'bottom-right' | 'center-left' | 'center-center' | 'center-right' | 'top-left' | 'top-center' | 'top-right'} Positioning
 * The overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, or `'top-right'`.
 */ /**
 * @typedef {Object} Options
 * @property {number|string} [id] Set the overlay id. The overlay id can be used
 * with the {@link module:ol/Map~Map#getOverlayById} method.
 * @property {HTMLElement} [element] The overlay element.
 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
 * the overlay. The first element in the
 * array is the horizontal offset. A positive value shifts the overlay right.
 * The second element in the array is the vertical offset. A positive value
 * shifts the overlay down.
 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
 * in map projection.
 * @property {Positioning} [positioning='top-left'] Defines how
 * the overlay is actually positioned with respect to its `position` property.
 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, and `'top-right'`.
 * @property {boolean} [stopEvent=true] Whether event propagation to the map
 * viewport should be stopped. If `true` the overlay is placed in the same
 * container as that of the controls (CSS class name
 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
 * with CSS class name specified by the `className` property.
 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
 * in the overlay container, or appended. If the overlay is placed in the same
 * container as that of the controls (see the `stopEvent` option) you will
 * probably set `insertFirst` to `true` so the overlay is displayed below the
 * controls.
 * @property {PanIntoViewOptions|boolean} [autoPan=false] Pan the map when calling
 * `setPosition`, so that the overlay is entirely visible in the current viewport.
 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
 * name.
 */ /**
 * @typedef {Object} PanOptions
 * @property {number} [duration=1000] The duration of the animation in
 * milliseconds.
 * @property {function(number):number} [easing] The easing function to use. Can
 * be one from {@link module:ol/easing} or a custom function.
 * Default is {@link module:ol/easing.inAndOut}.
 */ /**
 * @typedef {Object} PanIntoViewOptions
 * @property {PanOptions} [animation={}] The animation parameters for the pan
 * @property {number} [margin=20] The margin (in pixels) between the
 * overlay and the borders of the map when panning into view.
 */ /**
 * @enum {string}
 * @protected
 */ const $e43d9a501c20ce7e$var$Property = {
    ELEMENT: 'element',
    MAP: 'map',
    OFFSET: 'offset',
    POSITION: 'position',
    POSITIONING: 'positioning'
};
/**
 * @typedef {import("./ObjectEventType").Types|'change:element'|'change:map'|'change:offset'|'change:position'|
 *   'change:positioning'} OverlayObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<OverlayObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|OverlayObjectEventTypes, Return>} OverlayOnSignature
 */ /**
 * @classdesc
 * An element to be displayed over the map and attached to a single map
 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
 * visible widgets. Unlike Controls, they are not in a fixed position on the
 * screen, but are tied to a geographical coordinate, so panning the map will
 * move an Overlay but not a Control.
 *
 * Example:
 *
 *     import Overlay from 'ol/Overlay.js';
 *
 *     // ...
 *     const popup = new Overlay({
 *       element: document.getElementById('popup'),
 *     });
 *     popup.setPosition(coordinate);
 *     map.addOverlay(popup);
 *
 * @api
 */ class $e43d9a501c20ce7e$var$Overlay extends (0, $d575b598d09f57d3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Overlay options.
   */ constructor(options){
        super();
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {OverlayOnSignature<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {OverlayOnSignature<void>}
     */ this.un;
        /**
     * @protected
     * @type {Options}
     */ this.options = options;
        /**
     * @protected
     * @type {number|string|undefined}
     */ this.id = options.id;
        /**
     * @protected
     * @type {boolean}
     */ this.insertFirst = options.insertFirst !== undefined ? options.insertFirst : true;
        /**
     * @protected
     * @type {boolean}
     */ this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = document.createElement('div');
        this.element.className = options.className !== undefined ? options.className : 'ol-overlay-container ' + (0, $bbcb4c1977b6e9f0$export$99b49471b0394319);
        this.element.style.position = 'absolute';
        this.element.style.pointerEvents = 'auto';
        /**
     * @protected
     * @type {PanIntoViewOptions|undefined}
     */ this.autoPan = options.autoPan === true ? {} : options.autoPan || undefined;
        /**
     * @protected
     * @type {{transform_: string,
     *         visible: boolean}}
     */ this.rendered = {
            transform_: '',
            visible: true
        };
        /**
     * @protected
     * @type {?import("./events.js").EventsKey}
     */ this.mapPostrenderListenerKey = null;
        this.addChangeListener($e43d9a501c20ce7e$var$Property.ELEMENT, this.handleElementChanged);
        this.addChangeListener($e43d9a501c20ce7e$var$Property.MAP, this.handleMapChanged);
        this.addChangeListener($e43d9a501c20ce7e$var$Property.OFFSET, this.handleOffsetChanged);
        this.addChangeListener($e43d9a501c20ce7e$var$Property.POSITION, this.handlePositionChanged);
        this.addChangeListener($e43d9a501c20ce7e$var$Property.POSITIONING, this.handlePositioningChanged);
        if (options.element !== undefined) this.setElement(options.element);
        this.setOffset(options.offset !== undefined ? options.offset : [
            0,
            0
        ]);
        this.setPositioning(options.positioning || 'top-left');
        if (options.position !== undefined) this.setPosition(options.position);
    }
    /**
   * Get the DOM element of this overlay.
   * @return {HTMLElement|undefined} The Element containing the overlay.
   * @observable
   * @api
   */ getElement() {
        return /** @type {HTMLElement|undefined} */ this.get($e43d9a501c20ce7e$var$Property.ELEMENT);
    }
    /**
   * Get the overlay identifier which is set on constructor.
   * @return {number|string|undefined} Id.
   * @api
   */ getId() {
        return this.id;
    }
    /**
   * Get the map associated with this overlay.
   * @return {import("./Map.js").default|null} The map that the
   * overlay is part of.
   * @observable
   * @api
   */ getMap() {
        return /** @type {import("./Map.js").default|null} */ this.get($e43d9a501c20ce7e$var$Property.MAP) || null;
    }
    /**
   * Get the offset of this overlay.
   * @return {Array<number>} The offset.
   * @observable
   * @api
   */ getOffset() {
        return /** @type {Array<number>} */ this.get($e43d9a501c20ce7e$var$Property.OFFSET);
    }
    /**
   * Get the current position of this overlay.
   * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
   *     anchored at.
   * @observable
   * @api
   */ getPosition() {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ this.get($e43d9a501c20ce7e$var$Property.POSITION);
    }
    /**
   * Get the current positioning of this overlay.
   * @return {Positioning} How the overlay is positioned
   *     relative to its point on the map.
   * @observable
   * @api
   */ getPositioning() {
        return /** @type {Positioning} */ this.get($e43d9a501c20ce7e$var$Property.POSITIONING);
    }
    /**
   * @protected
   */ handleElementChanged() {
        (0, $755a3001f896bcf1$export$1e1c9bf5a4ffe0d1)(this.element);
        const element = this.getElement();
        if (element) this.element.appendChild(element);
    }
    /**
   * @protected
   */ handleMapChanged() {
        if (this.mapPostrenderListenerKey) {
            this.element?.remove();
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.mapPostrenderListenerKey);
            this.mapPostrenderListenerKey = null;
        }
        const map = this.getMap();
        if (map) {
            this.mapPostrenderListenerKey = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(map, (0, $392290a16437301e$export$2e2bcd8739ae039).POSTRENDER, this.render, this);
            this.updatePixelPosition();
            const container = this.stopEvent ? map.getOverlayContainerStopEvent() : map.getOverlayContainer();
            if (this.insertFirst) container.insertBefore(this.element, container.childNodes[0] || null);
            else container.appendChild(this.element);
            this.performAutoPan();
        }
    }
    /**
   * @protected
   */ render() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handleOffsetChanged() {
        this.updatePixelPosition();
    }
    /**
   * @protected
   */ handlePositionChanged() {
        this.updatePixelPosition();
        this.performAutoPan();
    }
    /**
   * @protected
   */ handlePositioningChanged() {
        this.updatePixelPosition();
    }
    /**
   * Set the DOM element to be associated with this overlay.
   * @param {HTMLElement|undefined} element The Element containing the overlay.
   * @observable
   * @api
   */ setElement(element) {
        this.set($e43d9a501c20ce7e$var$Property.ELEMENT, element);
    }
    /**
   * Set the map to be associated with this overlay.
   * @param {import("./Map.js").default|null} map The map that the
   * overlay is part of. Pass `null` to just remove the overlay from the current map.
   * @observable
   * @api
   */ setMap(map) {
        this.set($e43d9a501c20ce7e$var$Property.MAP, map);
    }
    /**
   * Set the offset for this overlay.
   * @param {Array<number>} offset Offset.
   * @observable
   * @api
   */ setOffset(offset) {
        this.set($e43d9a501c20ce7e$var$Property.OFFSET, offset);
    }
    /**
   * Set the position for this overlay. If the position is `undefined` the
   * overlay is hidden.
   * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
   *     is anchored at.
   * @observable
   * @api
   */ setPosition(position) {
        this.set($e43d9a501c20ce7e$var$Property.POSITION, position);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary) using the configured autoPan parameters
   * @protected
   */ performAutoPan() {
        if (this.autoPan) this.panIntoView(this.autoPan);
    }
    /**
   * Pan the map so that the overlay is entirely visible in the current viewport
   * (if necessary).
   * @param {PanIntoViewOptions} [panIntoViewOptions] Options for the pan action
   * @api
   */ panIntoView(panIntoViewOptions) {
        const map = this.getMap();
        if (!map || !map.getTargetElement() || !this.get($e43d9a501c20ce7e$var$Property.POSITION)) return;
        const mapRect = this.getRect(map.getTargetElement(), map.getSize());
        const element = this.getElement();
        const overlayRect = this.getRect(element, [
            (0, $755a3001f896bcf1$export$e823f88e4111159a)(element),
            (0, $755a3001f896bcf1$export$fc5b8aac72846d1e)(element)
        ]);
        panIntoViewOptions = panIntoViewOptions || {};
        const myMargin = panIntoViewOptions.margin === undefined ? 20 : panIntoViewOptions.margin;
        if (!(0, $7e819822b33b3d32$export$be866b1e0809b17e)(mapRect, overlayRect)) {
            // the overlay is not completely inside the viewport, so pan the map
            const offsetLeft = overlayRect[0] - mapRect[0];
            const offsetRight = mapRect[2] - overlayRect[2];
            const offsetTop = overlayRect[1] - mapRect[1];
            const offsetBottom = mapRect[3] - overlayRect[3];
            const delta = [
                0,
                0
            ];
            if (offsetLeft < 0) // move map to the left
            delta[0] = offsetLeft - myMargin;
            else if (offsetRight < 0) // move map to the right
            delta[0] = Math.abs(offsetRight) + myMargin;
            if (offsetTop < 0) // move map up
            delta[1] = offsetTop - myMargin;
            else if (offsetBottom < 0) // move map down
            delta[1] = Math.abs(offsetBottom) + myMargin;
            if (delta[0] !== 0 || delta[1] !== 0) {
                const center = /** @type {import("./coordinate.js").Coordinate} */ map.getView().getCenterInternal();
                const centerPx = map.getPixelFromCoordinateInternal(center);
                if (!centerPx) return;
                const newCenterPx = [
                    centerPx[0] + delta[0],
                    centerPx[1] + delta[1]
                ];
                const panOptions = panIntoViewOptions.animation || {};
                map.getView().animateInternal({
                    center: map.getCoordinateFromPixelInternal(newCenterPx),
                    duration: panOptions.duration,
                    easing: panOptions.easing
                });
            }
        }
    }
    /**
   * Get the extent of an element relative to the document
   * @param {HTMLElement} element The element.
   * @param {import("./size.js").Size} size The size of the element.
   * @return {import("./extent.js").Extent} The extent.
   * @protected
   */ getRect(element, size) {
        const box = element.getBoundingClientRect();
        const offsetX = box.left + window.pageXOffset;
        const offsetY = box.top + window.pageYOffset;
        return [
            offsetX,
            offsetY,
            offsetX + size[0],
            offsetY + size[1]
        ];
    }
    /**
   * Set the positioning for this overlay.
   * @param {Positioning} positioning how the overlay is
   *     positioned relative to its point on the map.
   * @observable
   * @api
   */ setPositioning(positioning) {
        this.set($e43d9a501c20ce7e$var$Property.POSITIONING, positioning);
    }
    /**
   * Modify the visibility of the element.
   * @param {boolean} visible Element visibility.
   * @protected
   */ setVisible(visible) {
        if (this.rendered.visible !== visible) {
            this.element.style.display = visible ? '' : 'none';
            this.rendered.visible = visible;
        }
    }
    /**
   * Update pixel position.
   * @protected
   */ updatePixelPosition() {
        const map = this.getMap();
        const position = this.getPosition();
        if (!map || !map.isRendered() || !position) {
            this.setVisible(false);
            return;
        }
        const pixel = map.getPixelFromCoordinate(position);
        const mapSize = map.getSize();
        this.updateRenderedPosition(pixel, mapSize);
    }
    /**
   * @param {import("./pixel.js").Pixel} pixel The pixel location.
   * @param {import("./size.js").Size|undefined} mapSize The map size.
   * @protected
   */ updateRenderedPosition(pixel, mapSize) {
        const style = this.element.style;
        const offset = this.getOffset();
        const positioning = this.getPositioning();
        this.setVisible(true);
        const x = Math.round(pixel[0] + offset[0]) + 'px';
        const y = Math.round(pixel[1] + offset[1]) + 'px';
        let posX = '0%';
        let posY = '0%';
        if (positioning == 'bottom-right' || positioning == 'center-right' || positioning == 'top-right') posX = '-100%';
        else if (positioning == 'bottom-center' || positioning == 'center-center' || positioning == 'top-center') posX = '-50%';
        if (positioning == 'bottom-left' || positioning == 'bottom-center' || positioning == 'bottom-right') posY = '-100%';
        else if (positioning == 'center-left' || positioning == 'center-center' || positioning == 'center-right') posY = '-50%';
        const transform = `translate(${posX}, ${posY}) translate(${x}, ${y})`;
        if (this.rendered.transform_ != transform) {
            this.rendered.transform_ = transform;
            style.transform = transform;
        }
    }
    /**
   * returns the options this Overlay has been created with
   * @return {Options} overlay options
   */ getOptions() {
        return this.options;
    }
}
var $e43d9a501c20ce7e$export$2e2bcd8739ae039 = $e43d9a501c20ce7e$var$Overlay;




/**
 * A slim panel to point to coordinates on the map
 * @extends SlimPanel
 */ class $0923864e362ccdd0$export$9c09cd8ed33a11db extends (0, $cb89f142cf8b9fe8$export$8e6dfb06e29200e6) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Panel id
     * @param classes {string} HTML classes for the panel
     * @param runtimeConfig {MapRuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */ constructor(translator, isMobileDevice, id, classes, runtimeConfig, onChangeRuntimeConfig){
        super(translator, isMobileDevice, id, classes, runtimeConfig, onChangeRuntimeConfig);
        this.hideCallbacks = [];
    }
    getClassName() {
        return "CoordinatesPanel";
    }
    getUIElement() {
        return super.getUIElement().show().addClass('coordinates-panel');
    }
    /**
     * Add a callback to call when the panel is hidden
     * @param callback {function}
     */ onHide(callback) {
        this.hideCallbacks.push(callback);
    }
    hide() {
        if (this.isVisible()) {
            super.hide();
            this._afterHide();
        }
    }
    hideNoAnimation() {
        if (this.isVisible()) {
            super.hideNoAnimation();
            this._afterHide();
        }
    }
    _afterHide() {
        this.getOverlay().setPosition(undefined);
        for(let c in this.hideCallbacks)this.hideCallbacks[c]();
    }
    /**
     * Get the OpenLayers Overlay of this panel
     * @return {Overlay}
     */ getOverlay() {
        if (!this.overlay) this.overlay = new (0, $e43d9a501c20ce7e$export$2e2bcd8739ae039)({
            element: this.getUIElement()[0],
            autoPan: true,
            autoPanAnimation: {
                duration: 250
            }
        });
        return this.overlay;
    }
    /**
     * Show this panel on the given coordinates
     * @param wgs84Coordinates {Array<number>} The coordinates where to show the panel in WGS84
     */ showOnGeoCoords(wgs84Coordinates) {
        this.showNoPosition();
        this.coords = wgs84Coordinates;
        this.getOverlay().setPosition((0, $92f1443438429e81$export$51186ad6e864892a)(this.coords, (0, $9bc5df2b24a7fcf6$export$6dd85527b263c26d), this.getOverlay().getMap().getView().getProjection().getCode()));
    }
    /**
     * Set the current map projection
     * @param projection {Projection}
     */ setProjection(projection) {
        if (this.isVisible()) this.showOnGeoCoords(this.coords);
    }
}





/**
 * A fetcher for layer timeseries
 * @extends Base
 */ class $517497a32c92a48c$export$a1518f6bc2daa9b6 extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    randomData = false;
    /**
     *
     * @param dataSeriesUrl {string}
     * @param layer {Layer} The layer to fetch data for
     * @param coordsWgs84 {Array<number>} The coordinates to fetch data for
     */ constructor(dataSeriesUrl, layer, coordsWgs84){
        super();
        this.dataSeriesUrl = (0, $2536f84a954bf107$export$730687a846e4e808)(dataSeriesUrl);
        this.layer = layer;
        this.coordsWgs84 = coordsWgs84;
        this.cache = {};
        this.catalogue = undefined;
    }
    getClassName() {
        return "TimeseriesFetcher";
    }
    /**
     * Load data from the server
     * @param from {Date} Fetch data from
     * @param until {Date} Fetch data until
     * @param unboundedFrom {Date} Fill data with null between this and from. If undefined, no filling will happen
     * @param unboundedUntil {Date} Fill data with null between until and this. If undefined, no filling will happen
     * @param onLoad {function} A callback that receives a map of series and a boolean that will be true if the data is random
     */ loadData(from, until, unboundedFrom = from, unboundedUntil = until, onLoad) {
        this._fetch(from, until, (fetchedValues)=>{
            if (!fetchedValues) onLoad();
            else {
                const result = {};
                for(let seriesCode in fetchedValues)if (seriesCode !== 'dates') {
                    const values = {};
                    for(let i = 0; i < fetchedValues.dates.length; i++)values[(0, $aeedcab592f41cce$export$3ae94a2503e890a1)(fetchedValues.dates[i])] = fetchedValues[seriesCode][i];
                    const { dates: dates, processedValues: processedValues } = this._processData(values, unboundedFrom, unboundedUntil === until ? until : unboundedUntil);
                    result[seriesCode] = {
                        x: dates,
                        y: processedValues
                    };
                }
                onLoad(result, this.randomData);
            }
        });
    }
    _generateRandomData(from, until, onFetch) {
        this.logInfo('Will generate a time series for service: ' + this.layer.getServiceConfig().getCode() + ': from ' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from) + ' until ' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(until));
        const randNr = Math.random();
        if (randNr > 0 && randNr <= 0.0) throw 'ERROR';
        const delay = (Math.random() + Math.random() * .7) * 1000;
        setTimeout(()=>{
            const timeCalculator = this.layer.getTimeCalculator();
            const chartStyler = this.layer.getChartStyler();
            const colorscale = chartStyler.getPlotlyColorscale();
            const range = this.getRangeForRandomData(chartStyler, colorscale);
            const fetchedValues = {};
            const timeScales = this.layer.getServiceConfig().getTimeScales();
            if (timeScales && timeScales.length > 0) timeScales.forEach((timeScale)=>{
                const product = this.layer.getProductConfigForTimeScale(timeScale);
                fetchedValues[product.getCode()] = timeCalculator.getSampleData(from, until, range);
            });
            else fetchedValues[this.layer.getProductConfig().getCode()] = timeCalculator.getSampleData(from, until, range);
            fetchedValues.dates = timeCalculator.getTimeSeries(timeCalculator.fixDate(from), until);
            this.logDebug('Just generated data for service: ' + this.layer.getServiceConfig().getCode() + ': from ' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from) + ' until ' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(until), fetchedValues);
            onFetch(fetchedValues);
        }, delay);
    }
    getRangeForRandomData(chartStyler, colorscale) {
        if (chartStyler.isClassified()) return colorscale.map((c)=>c[0]);
        const min = colorscale[0][0] === undefined ? colorscale[1][0] - Math.abs(colorscale[1][0]) * .5 : colorscale[0][0];
        const max = (0, $2536f84a954bf107$export$ce275da88d3dcc54)(colorscale)[0] === undefined ? colorscale[colorscale.length - 2][0] + Math.abs(colorscale[colorscale.length - 2][0]) * .5 : (0, $2536f84a954bf107$export$ce275da88d3dcc54)(colorscale)[0];
        return [
            min,
            max
        ];
    }
    _handleFetchedValues(onFetch, data, from, until) {
        let hasError = false;
        const error = (errMsg)=>{
            if (errMsg) this.logError(errMsg);
            onFetch(undefined);
            hasError = true;
        };
        if (!data.dates) {
            error("No dates");
            return;
        }
        const dates = this.layer.getTimeCalculator().getTimeSeries(from, until);
        const fetchedValues = {};
        const timeScales = this.layer.getServiceConfig().getTimeScales();
        const timeSeriesService = this.catalogue.services.hst[this.layer.getServiceConfig().getCode()];
        if (timeScales && timeScales.length > 0) {
            timeScales.every((timeScale)=>{
                const product = this.layer.getProductConfigForTimeScale(timeScale);
                const dataSeriesCodeForTimescaleKey = timeSeriesService.inds[timeSeriesService.prds.indexOf(product.getCode())];
                if (!data[dataSeriesCodeForTimescaleKey]) {
                    error("No data for code " + dataSeriesCodeForTimescaleKey);
                    return false;
                }
                if (data.dates.length !== data[dataSeriesCodeForTimescaleKey].length) {
                    error("Dates and values have different lengths (" + dataSeriesCodeForTimescaleKey + ": " + data[dataSeriesCodeForTimescaleKey].length + ")");
                    return false;
                }
                const values = [];
                for (const date of dates){
                    const index = data.dates.indexOf((0, $aeedcab592f41cce$export$3ae94a2503e890a1)(date));
                    if (index >= 0) values.push(data[dataSeriesCodeForTimescaleKey][index]);
                    else values.push(null);
                }
                fetchedValues[product.getCode()] = values;
                return true;
            });
            if (hasError) return;
        } else {
            const dataSeriesCode = timeSeriesService.inds[timeSeriesService.prds.indexOf(this.layer.getProductConfig().getCode())];
            if (!data[dataSeriesCode] || !data.dates || data.dates.length !== data[dataSeriesCode].length) {
                error("Dates and values have different lengths (" + dataSeriesCode + ")");
                return;
            }
            const values = [];
            for (const date of dates){
                const index = data.dates.indexOf((0, $aeedcab592f41cce$export$3ae94a2503e890a1)(date));
                if (index >= 0) values.push(data[dataSeriesCode][index]);
                else values.push(null);
            }
            fetchedValues[this.layer.getProductConfig().getCode()] = values;
        }
        fetchedValues.dates = dates;
        this.logDebug('Just fetched data for service: ' + this.layer.getServiceConfig().getCode() + ': from ' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from) + ' until ' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(until), fetchedValues);
        onFetch(fetchedValues);
    }
    _fetchFromServer(from, until, onFetch) {
        this.logInfo('Will fetch a time series for service: ' + this.layer.getServiceConfig().getCode() + ': from ' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from) + ' until ' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(until));
        const prdCodes = this.layer.getServiceConfig().getTimeScales().length > 0 ? this.layer.getServiceConfig().getTimeScales().map((ts)=>this.layer.getProductConfigForTimeScale(ts).getCode()) : [
            this.layer.getProductConfig().getCode()
        ];
        const uri = this.dataSeriesUrl.format([
            this.coordsWgs84[0] + "",
            this.coordsWgs84[1] + "",
            tumbo.appCode,
            this.layer.getServiceConfig().getCode(),
            (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from),
            (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(until),
            prdCodes.join(',')
        ]);
        if (!this.catalogue) this.catalogue = {
            services: {
                hst: {}
            }
        };
        this.catalogue.services.hst[this.layer.getServiceConfig().getCode()] = {
            inds: prdCodes,
            prds: prdCodes
        };
        $.getJSON(uri, (data)=>this._handleFetchedValues(onFetch, data, from, until));
    }
    _getData(from, until, onFetch) {
        if (!this.randomData) this._fetchFromServer(from, until, onFetch);
        else this._generateRandomData(from, until, onFetch);
    }
    _fetch(from, until, onFetch) {
        try {
            const returnValues = ()=>onFetch(this._clipCache(from, until));
            if (!this.cache.from || !this.cache.until) this._getData(from, until, (data)=>{
                if (data) this._cacheData(data);
                returnValues();
            });
            else {
                const fromAheadOfCache = from > this.cache.until;
                const untilBehindOfCache = until < this.cache.from;
                if (fromAheadOfCache) this._getData(this.cache.until, until, (data)=>{
                    this._appendCacheData(data);
                    returnValues();
                });
                else if (untilBehindOfCache) this._getData(from, this.cache.from, (data)=>{
                    this._prependCacheData(data);
                    returnValues();
                });
                else {
                    const fromBeforeCache = from < this.cache.from;
                    const untilAfterCache = until > this.cache.until;
                    if (!fromBeforeCache && !untilAfterCache) returnValues();
                    else {
                        const effectiveFrom = fromBeforeCache ? from : this.cache.until;
                        const effectiveUntil = untilAfterCache ? until : this.cache.from;
                        this._getData(effectiveFrom, effectiveUntil, (data)=>{
                            if (fromBeforeCache) this._prependCacheData(data);
                            if (untilAfterCache) this._appendCacheData(data);
                            returnValues();
                        });
                    }
                }
            }
        } catch (e) {
            this._onFetchError(from, until, e, onFetch);
        }
    }
    _onFetchError(from, until, e, onFetch) {
        this.logError("Error reading data for layer {0} on coords ({1},{2}) from {3} until {4}".format([
            this.layer.getCode(),
            this.coordsWgs84[0] + "",
            this.coordsWgs84[1] + "",
            (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from),
            (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(until)
        ]), e);
        onFetch(undefined);
    }
    _clipCache(from, until) {
        //if cache does not contain data for the current product we're in an invalid state
        if (!this.cache[this.layer.getProductConfig().getCode()]) {
            this.logError("No cache data for product " + this.layer.getProductConfig().getCode());
            return undefined;
        }
        // //if cache does not contain the time frame we're in an invalid state
        // if (!this.cache.from || !this.cache.until
        //     || from < this.cache.from || from > this.cache.until
        //     || until > this.cache.until || until < this.cache.from) {
        //     this.logError("We need data from {0} until {1}, bue cache only has data from {2} until {3}".format(
        //         [formatDate(from),
        //             formatDate(until),
        //             formatDate(this.cache.from),
        //             formatDate(this.cache.until)]
        //     ))
        //     return undefined;
        // }
        const result = {};
        const timeCalculator = this.layer.getTimeCalculator();
        const start = Math.max(0, this.cache.dates.map((d)=>d.getTime()).indexOf(timeCalculator.fixDate(from).getTime()));
        const end = this.cache.dates.map((d)=>d.getTime()).indexOf(timeCalculator.fixDate(until).getTime()) + 1; //we want the first date of the last period
        for(let cacheProp in this.cache)if (cacheProp !== 'from' && cacheProp !== 'until' && cacheProp !== 'untilPeriodStart' && cacheProp !== 'dates') result[cacheProp] = this.cache[cacheProp].slice(start, end ? end : undefined);
        result.dates = timeCalculator.getTimeSeries(this.cache.dates[start], this.cache.dates[(end ? end : this.cache.dates.length) - 1], true);
        return result;
    }
    _cacheData(data) {
        if (!data.dates || data.dates.length === 0) return;
        this.cache.from = this.layer.getTimeCalculator().fixDate(data.dates[0]);
        this.cache.untilPeriodStart = (0, $2536f84a954bf107$export$ce275da88d3dcc54)(data.dates);
        this.cache.until = this.layer.getTimeCalculator().fixUnboundedDateUntil(this.cache.untilPeriodStart);
        for(let cacheProp in data)if (cacheProp !== 'from' && cacheProp !== 'until' && cacheProp !== 'untilPeriodStart') this.cache[cacheProp] = data[cacheProp];
    }
    _prependCacheData(data) {
        const sliceEnd = data.dates.map((d)=>d.getTime()).indexOf(this.cache.from.getTime());
        this.cache.from = data.dates[0];
        for(let cacheProp in this.cache)if (cacheProp !== 'from' && cacheProp !== 'until' && cacheProp !== 'untilPeriodStart') this.cache[cacheProp] = data[cacheProp].slice(0, sliceEnd).concat(this.cache[cacheProp]);
    }
    _appendCacheData(data) {
        if (!data || !data.dates || data.dates.length === 0) return;
        const sliceStart = data.dates.map((d)=>d.getTime()).indexOf(this.cache.untilPeriodStart.getTime()) + 1;
        this.cache.untilPeriodStart = (0, $2536f84a954bf107$export$ce275da88d3dcc54)(data.dates);
        this.cache.until = this.layer.getTimeCalculator().fixUnboundedDateUntil(this.cache.untilPeriodStart);
        for(let cacheProp in this.cache)if (cacheProp !== 'from' && cacheProp !== 'until' && cacheProp !== 'untilPeriodStart') this.cache[cacheProp] = this.cache[cacheProp].concat(data[cacheProp].slice(sliceStart));
    }
    //force unboundedFrom and unboundedTo
    _processData(originalValues, unboundedFrom, unboundedUntil) {
        const timeCalculator = this.layer.getTimeCalculator();
        const dates = [], processedValues = [];
        timeCalculator.getTimeSeries(timeCalculator.fixDate(unboundedFrom), unboundedUntil).forEach((date)=>{
            const formattedDate = (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(date);
            dates.push(date);
            if (originalValues[formattedDate] !== null && originalValues[formattedDate] !== undefined) processedValues.push(originalValues[formattedDate]);
            else processedValues.push(null);
        });
        return {
            dates: dates,
            processedValues: processedValues
        };
    }
}
class $517497a32c92a48c$export$34e5a43543d4712b extends $517497a32c92a48c$export$a1518f6bc2daa9b6 {
    constructor(layer, featureId){
        super(undefined, layer, undefined);
        this.featureId = featureId;
    }
    getClassName() {
        return "FeatureTimeseriesFetcher";
    }
    _fetchFromServer(from, until, onFetch) {
        const baseUrl = (0, $2536f84a954bf107$export$730687a846e4e808)('/services/hst');
        const url = new URL('https:' + baseUrl);
        const prodCode = this.layer.getProductConfig().getCode();
        url.searchParams.set('appCode', tumbo.appCode);
        url.searchParams.set('srvs', prodCode);
        url.searchParams.set('id', this.featureId);
        url.searchParams.set('date_ini', (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from));
        url.searchParams.set('date_end', (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(until));
        if (!this.catalogue) this.catalogue = {
            services: {
                hst: {}
            }
        };
        this.catalogue.services.hst[this.layer.getServiceConfig().getCode()] = {
            inds: [
                prodCode
            ],
            prds: [
                prodCode
            ]
        };
        $.getJSON(baseUrl + '?' + url.searchParams.toString(), (data)=>{
            const res = {
                dates: data.dates
            };
            res[prodCode] = data[this.layer.getChartStyler().getAttributeName()];
            this._handleFetchedValues(onFetch, res, from, until);
        });
    }
    _onFetchError(from, until, e, onFetch) {
        this.logError("Error reading data for feature layer {0} from {1} until {2}".format([
            this.layer.getCode(),
            (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from),
            (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(until)
        ]), e);
        onFetch(undefined);
    }
}







/**
 * Transform an extent
 * @param extent {Array<number>} [minX,minY,maxX,maxY]
 * @param sourceProjCode {string} EPSG code from
 * @param targetProjCode {string} EPSG code to
 * @return {Array<number>}
 */ function $40ab8c40db995546$export$751c68e0e0efff79(extent, sourceProjCode, targetProjCode) {
    if (!extent || sourceProjCode === targetProjCode) return extent;
    const transformFunction = (0, $92f1443438429e81$export$fce0c6cfca85ed96)(sourceProjCode, targetProjCode);
    return (0, $7e819822b33b3d32$export$9f9dcb98c894b623)(extent, transformFunction);
}
function $40ab8c40db995546$export$1aa710124a4b3a45(extent, maxExtent) {
    const simpleFix = (extent)=>{
        extent = [
            Math.min(extent[0], extent[2]),
            Math.min(extent[1], extent[3]),
            Math.max(extent[0], extent[2]),
            Math.max(extent[1], extent[3])
        ];
        return [
            Math.max(-180, extent[0]),
            Math.max(-90, extent[1]),
            Math.min(180, extent[2]),
            Math.min(90, extent[3])
        ];
    };
    return $40ab8c40db995546$export$624b8c8c438031ad(simpleFix(extent), simpleFix(maxExtent));
}
function $40ab8c40db995546$export$624b8c8c438031ad(extent, maxExtent) {
    if (maxExtent) extent = [
        Math.max(maxExtent[0], extent[0]),
        Math.max(maxExtent[1], extent[1]),
        Math.min(maxExtent[2], extent[2]),
        Math.min(maxExtent[3], extent[3])
    ];
    return extent;
}
function $40ab8c40db995546$export$1d7493ba19a0f3e3(extent, factor) {
    const geom = (0, $46a66e0f2fc72479$export$c16b671815801c75)(extent);
    geom.scale(factor);
    return geom.getExtent();
}
function $40ab8c40db995546$export$881b4a519e1b1429(wgs84Coords) {
    return !wgs84Coords ? wgs84Coords : wgs84Coords.map((c)=>Number(c.toFixed(4)));
}
function $40ab8c40db995546$export$3fe43bac65f73092(wgs84Coords) {
    return !wgs84Coords ? wgs84Coords : '[' + $40ab8c40db995546$export$881b4a519e1b1429(wgs84Coords).join(', ') + ']';
}
function $40ab8c40db995546$export$7df8f9a44cb07fdb(paramName = 'bbox') {
    const url = new URL(window.location.href);
    return url.searchParams.has(paramName) ? url.searchParams.get(paramName).split(',').map((value)=>Number(value)) : undefined;
}
function $40ab8c40db995546$export$3d877e168f639765(count, center, resolution, circleDistanceMultiplier = 1, circleFootSeparation = 28, rings = 1, circleStartAngle = Math.PI / 2) {
    rings = Math.max(rings, 1);
    const circumference = circleDistanceMultiplier * circleFootSeparation * (2 + count);
    const radiusFull = Math.max(circumference / (Math.PI * 2), 35) * resolution;
    let ringPopulations = [];
    for(let i = rings; i > 1; i--)ringPopulations.push(Math.round(count / (i * i)));
    ringPopulations = ringPopulations.filter((p)=>p > 3);
    ringPopulations.push(count - ringPopulations.reduce((partialSum, a)=>partialSum + a, 0));
    const resPoints = [];
    for(let p = 0; p < ringPopulations.length; p++){
        const population = ringPopulations[p];
        const angleStep = Math.PI * 2 / population;
        const radius = radiusFull / ringPopulations.length * (p + 1);
        for(let i = 0; i < population; ++i){
            const angle = circleStartAngle + i * angleStep; // Clockwise
            resPoints.push([
                center[0] + radius * Math.cos(angle),
                center[1] + radius * Math.sin(angle)
            ]);
        }
    }
    return {
        points: resPoints.map((p)=>new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)(p)),
        lines: resPoints.map((p)=>new (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039)([
                p,
                center
            ]))
    };
}
function $40ab8c40db995546$export$8e42c4827aaf16af(geom) {
    let polys = [];
    if (geom.getType() === 'GeometryCollection') {
        polys = geom.getGeometries().concat(geom.getGeometries().filter((g)=>g.getType() === 'Polygon'));
        geom.getGeometries().filter((g)=>g.getType() === 'MultiPolygon').forEach((mp)=>polys = polys.concat(mp.getPolygons()));
    } else if (geom.getType() === 'Polygon') polys.push(geom);
    else if (geom.getType() === 'MultiPolygon') polys = geom.getPolygons();
    let geometry = undefined, widest = 0;
    for(let i = 0; i < polys.length; i++){
        let width = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(polys[i].getExtent());
        if (width > widest) {
            widest = width;
            geometry = polys[i];
        }
    }
    return geometry;
}
if (!window.tumbo) window.tumbo = {};
window.tumbo.transformExtent = $40ab8c40db995546$export$751c68e0e0efff79;







/**
 * A localization translator
 * @extends Base
 */ class $31d1ba93c95d2196$export$9850010f89e291bb extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     * The dictionary for localization (string keys for string translated values)
     * @param localization {Object}
     */ constructor(localization){
        super();
        this.localization = localization;
    }
    getClassName() {
        return "Translator";
    }
    /**
     * Translate a key
     * If there is no key in the localization dictionary, the key will be returned
     * If the key starts with "#", the key is returned removing the first "#"
     * @param key {string} The key to translate
     * @param args {Array<string>} Arguments to replace in the translated string (can be empty or undefined)
     * @return {string}
     */ translate(key, args) {
        if (!key) return undefined;
        key = String(key);
        if (key.indexOf('#') === 0) return key.substr(1);
        const loc = this.localization;
        return loc[key] ? args ? loc[key].format(args) : loc[key] : key;
    }
}



var $eeeaa62421b7b994$exports = {};
'use strict';
$eeeaa62421b7b994$exports = $eeeaa62421b7b994$var$isMobile;
$eeeaa62421b7b994$exports.isMobile = $eeeaa62421b7b994$var$isMobile;
$eeeaa62421b7b994$exports.default = $eeeaa62421b7b994$var$isMobile;
const $eeeaa62421b7b994$var$mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|redmi|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
const $eeeaa62421b7b994$var$notMobileRE = /CrOS/;
const $eeeaa62421b7b994$var$tabletRE = /android|ipad|playbook|silk/i;
function $eeeaa62421b7b994$var$isMobile(opts) {
    if (!opts) opts = {};
    let ua = opts.ua;
    if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent;
    if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') ua = ua.headers['user-agent'];
    if (typeof ua !== 'string') return false;
    let result = $eeeaa62421b7b994$var$mobileRE.test(ua) && !$eeeaa62421b7b994$var$notMobileRE.test(ua) || !!opts.tablet && $eeeaa62421b7b994$var$tabletRE.test(ua);
    if (!result && opts.tablet && opts.featureDetect && navigator && navigator.maxTouchPoints > 1 && ua.indexOf('Macintosh') !== -1 && ua.indexOf('Safari') !== -1) result = true;
    return result;
}



const $b488569ebaeb416e$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $b488569ebaeb416e$export$2e2bcd8739ae039 = {
    randomUUID: $b488569ebaeb416e$var$randomUUID
};


let $d0da4566d2fd20fe$var$getRandomValues;
const $d0da4566d2fd20fe$var$rnds8 = new Uint8Array(16);
function $d0da4566d2fd20fe$export$2e2bcd8739ae039() {
    if (!$d0da4566d2fd20fe$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $d0da4566d2fd20fe$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $d0da4566d2fd20fe$var$getRandomValues($d0da4566d2fd20fe$var$rnds8);
}


var $e8c673fd2604883f$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;


function $7d240e1718cbe118$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $e8c673fd2604883f$export$2e2bcd8739ae039).test(uuid);
}
var $7d240e1718cbe118$export$2e2bcd8739ae039 = $7d240e1718cbe118$var$validate;


const $8fb7ad22aed8f433$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$8fb7ad22aed8f433$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset = 0) {
    return ($8fb7ad22aed8f433$var$byteToHex[arr[offset + 0]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 1]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 2]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 3]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 4]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 5]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 6]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 7]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 8]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 9]] + '-' + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 10]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 11]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 12]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 13]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 14]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $8fb7ad22aed8f433$var$stringify(arr, offset = 0) {
    const uuid = $8fb7ad22aed8f433$export$8fb373d660548968(arr, offset);
    if (!(0, $7d240e1718cbe118$export$2e2bcd8739ae039)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $8fb7ad22aed8f433$export$2e2bcd8739ae039 = $8fb7ad22aed8f433$var$stringify;


function $27d7069422be255c$var$v4(options, buf, offset) {
    if ((0, $b488569ebaeb416e$export$2e2bcd8739ae039).randomUUID && !buf && !options) return (0, $b488569ebaeb416e$export$2e2bcd8739ae039).randomUUID();
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $d0da4566d2fd20fe$export$2e2bcd8739ae039)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $8fb7ad22aed8f433$export$8fb373d660548968)(rnds);
}
var $27d7069422be255c$export$2e2bcd8739ae039 = $27d7069422be255c$var$v4;





/**
 * A UI usage statistics gatherer and sender
 * {UIElement} objects use this to log and this class automatically sends the stats to the server periodically
 * Shows a permission dialog to the user
 * Should be used as a singleton
 * @extends Base
 */ class $7b3a278e0e939859$export$511bae38709055e3 extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     *
     * @param translator {Translator} A translator
     * @param appCode {string} The code of this application
     * @param postURL {string} The URL to post data to
     * @param isMobile {boolean} Is this a mobile device?
     * @param target {jQuery} The target element for the user confirmation UI element
     */ constructor(translator, appCode, postURL, isMobile, target){
        super();
        this.translator = translator;
        this.postURL = postURL;
        this.appCode = appCode;
        this.isMobile = isMobile;
        this.target = target;
        this.code = localStorage.getItem("statsCode");
        this._readStatsMap();
    }
    getClassName() {
        return "StatsGatherer";
    }
    _readStatsMap() {
        const statsObjStr = localStorage.getItem("statsObject_" + this.appCode);
        this.statsMap = statsObjStr ? JSON.parse(statsObjStr) : {
            sessionStart: new Date(),
            map: {}
        };
    }
    _storeStatsMap() {
        localStorage.setItem("statsObject_" + this.appCode, JSON.stringify(this.statsMap));
    }
    _renderConfirmationElement() {
        if (!this.code) {
            const element = $dc57b31f1b066f38$exports('<div id="stats_gatherer_container" aria-labelledby="stats_gatherer_header" class="stats-gatherer-container" role="dialog" aria-modal="true">   <div class="stats-gatherer-header" id="stats_gatherer_header">' + this.translator.translate('statsGatherer.confirmation.title') + '   </div>' + '   <div class="stats-gatherer-body">' + '       <div class="stats-gatherer-text">' + this.translator.translate('statsGatherer.confirmation.text') + '       </div>' + '       <div class="stats-gatherer-buttons">' + '           <button class="action cancel-button">' + this.translator.translate('statsGatherer.confirmation.cancel') + '</button>' + '           <button class="action accept-button">' + this.translator.translate('statsGatherer.confirmation.accept') + '</button>' + '       </div>' + '   </div>' + '</div>');
            $dc57b31f1b066f38$exports('button.cancel-button', element).click(()=>element.hide());
            $dc57b31f1b066f38$exports('button.accept-button', element).click(()=>{
                this.code = (0, $27d7069422be255c$export$2e2bcd8739ae039)();
                localStorage.setItem('statsCode', this.code);
                element.hide();
            });
            this.target.append(element);
        }
    }
    /**
     * log an entry
     * @param uIElement {UIElement}
     * @param action {string}
     * @param store {boolean} if true, store immediately
     */ log(uIElement, action, store = false) {
        this.logByCode(uIElement.getCode(), (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(uIElement.getClassName(), uIElement.getClass()), action, store);
    }
    /**
     * log an entry
     * @param code {string}
     * @param clazz {string}
     * @param action {string}
     * @param store {boolean} if true, store immediately
     */ logByCode(code, clazz, action, store = false) {
        if (!this.statsMap.map[code]) this.statsMap.map[code] = {
            type: clazz
        };
        if (!this.statsMap.map[code][action]) this.statsMap.map[code][action] = {
            count: 0,
            firstExec: new Date()
        };
        this.statsMap.map[code][action].count++;
        this.statsMap.map[code][action].lastExec = new Date();
        if (store) this._storeStatsMap();
    }
    _getStats2Post() {
        if (this.code) {
            const data = [
                [
                    'code',
                    'type',
                    'action',
                    'count',
                    'firstExec',
                    'lastExec'
                ]
            ];
            Object.keys(this.statsMap.map).forEach((code)=>{
                const element = this.statsMap.map[code];
                Object.keys(element).filter((key)=>key !== 'type').forEach((action)=>{
                    data.push([
                        code,
                        element.type,
                        action,
                        element[action].count,
                        element[action].firstExec,
                        element[action].lastExec
                    ]);
                });
            });
            return {
                code: this.code,
                sessionStart: this.statsMap.sessionStart,
                data: data
            };
        } else return {};
    }
    initSendProcedure() {
        this._renderConfirmationElement();
        if (!this.storeIntervalId) this.storeIntervalId = setInterval(()=>this._storeStatsMap(), this.isMobile ? 10000 : 5000);
        if (!this.intervalId) this.intervalId = setInterval(()=>{
            if (this.code) {
                if (this.postURL) $dc57b31f1b066f38$exports.post(this.postURL, {
                    data: JSON.stringify(this._getStats2Post())
                }, (data, textStatus, jqXHR)=>{
                    if (textStatus.toLowerCase() !== 'success') this.logError("Error posting stats: " + textStatus);
                }).fail((jqXHR, textStatus, errorThrown)=>this.logError("Could not post stats [" + textStatus + "]", errorThrown));
                else if (new Date().getSeconds() % 25 === 0) this.logDebug('Would post stats', JSON.parse(JSON.stringify(this._getStats2Post())));
            }
        }, this.isMobile ? 30000 : 20000);
    }
}






/**
 * A tooltip to make the behaviour of the "title" attribute predictable across browsers and devices
 * A tooltip will be shown when there is a title attribute with text and on the following conditions:
 * . If mobile, on touch and hold the element for at least 500ms
 * . If desktop, on hover the element
 * @extends UIElement
 */ class $c2f759c93741e5b5$export$28c660c63b792dea extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     * @param id {string} A unique id for this tooltip
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param element {jQuery} The DOM application container
     */ constructor(id, translator, isMobileDevice, element){
        super(id, translator, isMobileDevice, undefined, undefined);
        this.target = element;
        this.uiElement = $dc57b31f1b066f38$exports('<div class="tumbo-tooltip"></div>').click(()=>this.hide());
        this.target.append(this.uiElement);
        const ignored = [
            'HTMLCanvasElement'
        ];
        const handleEvent = (event)=>{
            const domElement = document.elementFromPoint(event.pageX, event.pageY);
            const element = $dc57b31f1b066f38$exports(domElement);
            if (!domElement || element.hasClass('tooltiped')) return;
            if (ignored.indexOf(domElement.__proto__.constructor.name) < 0 && !$dc57b31f1b066f38$exports(domElement).hasClass('ol-control')) {
                if (element.attr('title') && element.attr('title').length > 0 || element.attr('data-title') && element.attr('data-title').length > 0) this.show(element, event.clientX, event.clientY);
                else this.hide();
            } else this.hide();
        };
        if (!isMobileDevice) this.target.mousemove(handleEvent);
        else {
            const onLongPress = (callback)=>{
                let timer;
                this.target.on('touchstart', (event)=>{
                    timer = setTimeout(()=>{
                        timer = null;
                        callback(event.originalEvent.touches[0]);
                    }, 500);
                });
                function cancel() {
                    clearTimeout(timer);
                }
                this.target.on('touchend', cancel);
                this.target.on('touchmove', cancel);
                $dc57b31f1b066f38$exports(this.target).on('click', ()=>this.hide());
            };
            onLongPress((e)=>{
                this.hide();
                handleEvent(e);
            });
        }
    }
    getClassName() {
        return "Tooltip";
    }
    getCode() {
        return "tooltip";
    }
    getUIElement() {
        return this.uiElement;
    }
    /**
     * Shows a tooltip for an element on a screen position
     * Handles the problem of having a tooltip too close to the application margins
     * @param element The tooltiped element
     * @param x The X coordinate in pixels (should come from the user triggered event - hover or touch and hold)
     * @param y The Y coordinate in pixels (should come from the user triggered event - hover or touch and hold)
     */ show(element, x, y) {
        this.tooltipedElement = element;
        const text = this.tooltipedElement.attr('title');
        this.tooltipedElement.attr('data-title', text);
        this.tooltipedElement.removeAttr('title');
        this.uiElement.html(text).show();
        const targetPosition = this.target.position();
        x -= targetPosition.left;
        y -= targetPosition.top;
        x += this.isMobileDevice ? 0 : 10;
        y += this.isMobileDevice ? -70 : 10;
        const height = this.uiElement.height();
        const width = this.uiElement.width();
        const targetWidth = this.target.width() - 20;
        const targetHeight = this.target.height() - 20;
        const left = Math.max(targetPosition.left, Math.min(x, targetPosition.left + targetWidth - width));
        const top = Math.max(targetPosition.top, Math.min(y, targetPosition.top + targetHeight - height));
        this.uiElement.css('left', left + 'px').css('top', top + 'px').show();
        this.tooltipedElement.addClass('tooltiped');
        this.logStat("SHOW");
    }
    /**
     * Hides any visible tooltip
     */ hide() {
        if (this.tooltipedElement) {
            const text = this.tooltipedElement.attr('data-title');
            this.tooltipedElement.attr('title', text);
            this.uiElement.hide();
            $dc57b31f1b066f38$exports('.tooltiped', this.target).removeClass('tooltiped');
        }
    }
}











const $5f61dedde258ef43$var$MIN_FILL_TIME_MS = 1500;
class $5f61dedde258ef43$var$ContactForm extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    constructor(translator, isMobileDevice, postUrl, runtimeConfig, onChangeRuntimeConfig){
        super('contact_form', translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.postUrl = postUrl;
    }
    getClassName() {
        return "ContactForm";
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div id="' + this.id + '" class="contact-form-container">' + '   <form>' + '       <div class="email">' + '           <label>' + this.translator.translate('contact.email') + '</label>' + '           <input type="email" maxlength="100"/>' + '           <div class="error"><ul></ul></div>' + '       </div>' + '       <div class="subject">' + '           <label>' + this.translator.translate('contact.subject') + '</label>' + '           <input type="text" maxlength="100"/>' + '           <div class="error"><ul></ul></div>' + '       </div>' + '       <div class="message">' + '           <label>' + this.translator.translate('contact.message') + '</label>' + '           <textarea maxlength="1000" rows="4"></textarea>' + '           <div class="error"><ul></ul></div>' + '       </div>' + '       <div class="submit">' + '           <button class="action submit" type="submit">' + this.translator.translate('contact.submit') + '</button>' + '       </div>' + '       <div class="additional"><input type="text"/></div>' + '   </form>' + '</div>');
            $dc57b31f1b066f38$exports('input, textarea', this.uiElement).keyup(()=>{
                if (!this.fillStart) this.fillStart = new Date();
                this._checkSubmitEnabled();
            });
            $dc57b31f1b066f38$exports('button.submit', this.uiElement).click((e)=>{
                this.logStat("SEND_MESSAGE");
                this._submit();
                return true;
            });
            this._checkSubmitEnabled();
            this.loader = new (0, $b3069bed9c6337dc$export$3b0d6d7590275603)('contact_form_loader', this.isMobileDevice, this.uiElement);
        }
        return this.uiElement;
    }
    _checkSubmitEnabled() {
        if (!this.fillStart) $dc57b31f1b066f38$exports('button.submit', this.uiElement).addClass('disabled').attr('disabled', 'disabled');
        else $dc57b31f1b066f38$exports('button.submit', this.uiElement).removeClass('disabled').removeAttr('disabled');
    }
    _submit() {
        if (!this._validateSecurity()) {
            setTimeout(()=>{
                this.fillStart = new Date();
                this._checkSubmitEnabled();
            }, $5f61dedde258ef43$var$MIN_FILL_TIME_MS);
            return;
        }
        if (!this._validateFields()) return;
        this.loader.show();
        $dc57b31f1b066f38$exports.post(this.postUrl, {
            data: JSON.stringify({
                subject: this._getSubject(),
                message: this._getMessage(),
                email: this._getEmail()
            })
        }, (data, textStatus, jqXHR)=>{
            if (textStatus.toLowerCase() !== 'success') this.logError("Error sending message: " + textStatus);
            else {
                alert(this.translator.translate('contact.confirmation'));
                this.fillStart = new Date();
                this._clear();
                this.logInfo("Message sent");
            }
            this.loader.hide();
        }).fail((jqXHR, textStatus, errorThrown)=>{
            alert(this.translator.translate('contact.sendError'));
            this.logError("Could not send message: " + textStatus, errorThrown);
            this.fillStart = new Date();
            this._checkSubmitEnabled();
            this.loader.hide();
        });
    }
    _clear() {
        $dc57b31f1b066f38$exports('input, textarea', this.uiElement).val('');
        this.fillStart = undefined;
        this._checkSubmitEnabled();
    }
    _validateFields() {
        let error = false;
        $dc57b31f1b066f38$exports('.error ul', this.uiElement).empty();
        const email = this._getEmail();
        if (!email || email.length <= 0) {
            $dc57b31f1b066f38$exports('.email .error ul', this.uiElement).append('<li>' + this.translator.translate('contact.error.mandatory') + '</li>');
            error = true;
        } else if (!(0, $2536f84a954bf107$export$18148d12c805c5b0)(email)) {
            $dc57b31f1b066f38$exports('.email .error ul', this.uiElement).append('<li>' + this.translator.translate('contact.error.invalidEmail') + '</li>');
            error = true;
        }
        const subject = this._getSubject();
        if (!subject || subject.length <= 1) {
            $dc57b31f1b066f38$exports('.subject .error ul', this.uiElement).append('<li>' + this.translator.translate('contact.error.mandatory') + '</li>');
            error = true;
        }
        const message = this._getMessage();
        if (!message || message.length <= 1) {
            $dc57b31f1b066f38$exports('.message .error ul', this.uiElement).append('<li>' + this.translator.translate('contact.error.mandatory') + '</li>');
            error = true;
        }
        if (error) $dc57b31f1b066f38$exports('.error', this.uiElement).addClass('show');
        else $dc57b31f1b066f38$exports('.error', this.uiElement).removeClass('show');
        return !error;
    }
    _getMessage() {
        return (0, $2536f84a954bf107$export$1fbf6f199c05a66)($dc57b31f1b066f38$exports('.message textarea', this.uiElement).val()).trim();
    }
    _getSubject() {
        return (0, $2536f84a954bf107$export$1fbf6f199c05a66)($dc57b31f1b066f38$exports('.subject input', this.uiElement).val()).trim();
    }
    _getEmail() {
        return (0, $2536f84a954bf107$export$1fbf6f199c05a66)($dc57b31f1b066f38$exports('.email input', this.uiElement).val()).trim();
    }
    _validateSecurity() {
        const fillTimeMs = this.fillStart ? new Date() - this.fillStart : 0;
        this.fillStart = undefined;
        this._checkSubmitEnabled();
        if (fillTimeMs < $5f61dedde258ef43$var$MIN_FILL_TIME_MS) return false;
        if (!this.uiElement.is(':visible')) return false;
        const additionalVal = $dc57b31f1b066f38$exports('.additional input', this.uiElement).val();
        if (additionalVal && additionalVal.length > 0) return false; //honeypot
        return true;
    }
}
class $5f61dedde258ef43$export$c6a80bb1e13bf921 extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    constructor(translator, isMobileDevice, modal, postUrl, runtimeConfig, onChangeRuntimeConfig){
        super('contact_button', translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.modal = modal;
        this.form = new $5f61dedde258ef43$var$ContactForm(translator, isMobileDevice, postUrl, runtimeConfig, onChangeRuntimeConfig);
    }
    getClassName() {
        return "ContactButton";
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div id="' + this.id + '" class="contact-button-container">' + '   <button type="button" title="' + this.translator.translate('contact.buttonName') + '"></button>' + '</div>');
            this.modal.setTitle(this.translator.translate('contact.formTitle'));
            this.modal.setContent(this.form.getUIElement());
            $dc57b31f1b066f38$exports('button', this.uiElement).click(()=>{
                if (this.modal.isVisible()) this.modal.hide();
                else this.modal.show();
            });
        }
        return this.uiElement;
    }
}








/**
 * A panel that shows warning messages and marks them as read on panel close
 */ class $a313b23f4bcffb20$var$WarningMessagesPanel extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     * @param warningMessages {Array<WarningMessageConfig>}
     * @param serviceWarningMessages {Array<ServiceWarningMessageConfig>}
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */ constructor(warningMessages, serviceWarningMessages, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig){
        super('warning_messages_panel', translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.warningMessages = warningMessages;
        this.serviceWarningMessages = serviceWarningMessages;
        this.visibleServiceNames = {};
        this.onCloseCallbacks = [];
        this.onShowCallbacks = [];
        this.onWarningsChangeCallbacks = [];
    }
    getClassName() {
        return "WarningMessagesPanel";
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div class="warning-messages-panel"><h2>' + this.translator.translate('warning.title') + '</h2>' + '   <div class="warning-messages-panel-container" aria-live="polite">' + '      <div class="top"></div>' + '      <ul role="list" class="general"></ul>' + '      <ul role="list" class="service"></ul>' + '      <div class="no-warnings">' + this.translator.translate('warning.noWarnings') + '</div>' + '      <div class="bottom"></div>' + '   </div>' + '   <button class="warnings-closer" type="button" title="' + this.translator.translate('warning.closeButton') + '"></button>' + '</div>').attr('id', this.id);
            let wmCount = 0;
            this._getGeneralWarningMessages2Show().forEach((wm)=>{
                const message = wm.getMessage().replaceAll('\n', '<br/>').replaceAll('\r', '<br/>');
                $dc57b31f1b066f38$exports('ul.general', this.uiElement).append($dc57b31f1b066f38$exports("<li>   <h3>" + this.translator.translate('warning.generalWarningTitle', [
                    "" + ++wmCount
                ]) + '</h3>' + '   <p>' + message + '</p>' + '</li>'));
            });
            if (this.hasUnreadWarningMessages()) this.show();
            else this.close();
            $dc57b31f1b066f38$exports('button.warnings-closer', this.uiElement).click(()=>{
                this.logStat("CLOSE");
                this.close();
            });
        }
        return this.uiElement;
    }
    _rerenderServiceMessages() {
        $dc57b31f1b066f38$exports('ul.service', this.uiElement).empty();
        this._getVisibleServiceWarningMessages().forEach((swm)=>{
            const message = swm.getMessage().replaceAll('\n', '<br/>').replaceAll('\r', '<br/>');
            $dc57b31f1b066f38$exports('ul.service', this.uiElement).append($dc57b31f1b066f38$exports("<li>   <h3>" + this.visibleServiceNames[swm.getServiceCode()] + '</h3>' + '   <p>' + message + '</p>' + '</li>'));
        });
        if (this.hasNoWarnings()) $dc57b31f1b066f38$exports('.no-warnings', this.getUIElement()).show();
        else $dc57b31f1b066f38$exports('.no-warnings', this.getUIElement()).hide();
    }
    hasNoWarnings() {
        return this._getVisibleServiceWarningMessages().length + this._getGeneralWarningMessages2Show().length === 0;
    }
    show() {
        this.getUIElement().show();
        this.visible = true;
        this._rerenderServiceMessages();
        this.onShowCallbacks.forEach((c)=>c());
    }
    close() {
        super.close();
        this.visible = false;
        this.getUIElement().hide();
        this._getGeneralWarningMessages2Show().forEach((wm)=>this._markMessageRead(wm));
        this._getVisibleServiceWarningMessages().forEach((wm)=>this._markMessageRead(wm));
        this.onCloseCallbacks.forEach((c)=>c());
    }
    onClose(callback) {
        this.onCloseCallbacks.push(callback);
    }
    onShow(callback) {
        this.onShowCallbacks.push(callback);
    }
    onWarningsChange(callback) {
        this.onWarningsChangeCallbacks.push(callback);
    }
    isVisible() {
        return this.visible;
    }
    _markMessageRead(message) {
        localStorage.setItem("wm_" + message.getCode(), '1');
    }
    _isMessageRead(message) {
        return localStorage.getItem("wm_" + message.getCode()) === '1';
    }
    _getGeneralWarningMessages2Show() {
        return this.warningMessages.filter((wm)=>wm.shouldBeShown());
    }
    _getUnreadWarningMessages() {
        return this._getGeneralWarningMessages2Show().filter((wm)=>!this._isMessageRead(wm));
    }
    _getServiceWarningMessages2Show() {
        return this.serviceWarningMessages.filter((wm)=>wm.shouldBeShown());
    }
    _getUnreadServiceWarningMessages() {
        return this._getServiceWarningMessages2Show().filter((wm)=>!this._isMessageRead(wm) && this.visibleServiceNames[wm.getServiceCode()]);
    }
    _getVisibleServiceWarningMessages() {
        return this._getServiceWarningMessages2Show().filter((wm)=>this.visibleServiceNames[wm.getServiceCode()]);
    }
    hasUnreadWarningMessages() {
        return this._getUnreadWarningMessages().length > 0 || this._getUnreadServiceWarningMessages().length > 0;
    }
    /**
     * To be called when the visible layers change
     * @param visibleLayers {Array<Layer>} The currently visible layers
     */ onChangeVisibleLayers(visibleLayers) {
        this.visibleLayers = visibleLayers;
        this._onChangeVisibleServices();
    }
    /**
     * To be called when the visible base layers change
     * @param visibleBaseLayers {Array<BaseLayer>} The currently visible base layers
     */ onChangeVisibleBaseLayers(visibleBaseLayers) {
        this.visibleBaseLayers = visibleBaseLayers;
        this._onChangeVisibleServices();
    }
    /**
     * To be called when the visible context layers change
     * @param visibleContextLayers {Array<ContextLayer>} The currently visible context layers
     */ onChangeVisibleContextLayers(visibleContextLayers) {
        this.visibleContextLayers = visibleContextLayers;
        this._onChangeVisibleServices();
    }
    _onChangeVisibleServices() {
        this.visibleServiceNames = {};
        if (this.visibleLayers) this.visibleLayers.forEach((l)=>{
            l.getAllServiceConfigs().forEach((s)=>this.visibleServiceNames[s.getCode()] = l.getName());
        });
        if (this.visibleBaseLayers) this.visibleBaseLayers.forEach((l)=>this.visibleServiceNames[l.getServiceConfig().getCode()] = l.getName());
        if (this.visibleContextLayers) this.visibleContextLayers.forEach((l)=>this.visibleServiceNames[l.getServiceConfig().getCode()] = l.getName());
        this._rerenderServiceMessages();
        this.onWarningsChangeCallbacks.forEach((c)=>c());
    }
}
/**
 * A button to open the warning messages panel
 */ class $a313b23f4bcffb20$export$7ff4c2019d0a66fb extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     * @param warningMessages {Array<WarningMessageConfig>}
     * @param serviceWarningMessages {Array<ServiceWarningMessageConfig>}
     * @param target {jQuery} The target to append this button to
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */ constructor(warningMessages, serviceWarningMessages, target, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig){
        super('warnings_button', translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.panel = new $a313b23f4bcffb20$var$WarningMessagesPanel(warningMessages, serviceWarningMessages, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.target = target;
        this.target.append(this.getUIElement());
    }
    getClassName() {
        return "WarningsButton";
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div id="' + this.id + '" class="warnings-button-container">' + '   <button type="button" title="' + this.translator.translate('warning.openButton') + '"></button>' + '</div>');
            $dc57b31f1b066f38$exports('button', this.uiElement).click(()=>{
                if (!this.panel.isVisible()) {
                    this.panel.show();
                    this.logStat("SHOW");
                }
            });
            this.panel.onClose(()=>this.getUIElement().show());
            this.panel.onShow(()=>this.getUIElement().hide());
            this.panel.onWarningsChange(()=>{
                if (this.panel.hasNoWarnings()) this.uiElement.hide();
                else this.uiElement.show();
            });
            this.target.append(this.panel.getUIElement());
        }
        return this.uiElement;
    }
    onChangeVisibleLayers(visibleLayers) {
        this.panel.onChangeVisibleLayers(visibleLayers);
    }
    onChangeVisibleBaseLayers(visibleBaseLayers) {
        this.panel.onChangeVisibleBaseLayers(visibleBaseLayers);
    }
    onChangeVisibleContextLayers(visibleContextLayers) {
        this.panel.onChangeVisibleContextLayers(visibleContextLayers);
    }
}




function $bc6d7cfcca5213f3$export$e3456b5d55e1b02f() {
    if (!window.tumbo) window.tumbo = {};
}
/**
 * The main class of a Tumbo application
 * Should be extended to create a new Tumbo App
 * @abstract
 * @extends Base
 */ class $bc6d7cfcca5213f3$export$c3599f2c821eb267 extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    static MAX_RUNTIMECONFIG_SESSION_TIME = 7200000;
    /**
     *
     * @param translations {object} A dictionary of translation keys to translations
     * @param config {object} The application configuration to be parsed
     * @param targetId {string} The DOM element id to render this application in
     * @param logger {Logger}
     */ constructor(translations, config, targetId, logger){
        super();
        tumbo.LOGGER = logger;
        this.translator = new (0, $31d1ba93c95d2196$export$9850010f89e291bb)(translations);
        this.config = config;
        this.targetId = targetId;
        if (targetId) {
            if ((0, $2536f84a954bf107$export$844ec244b1367d54)(targetId)) {
                this.target = $dc57b31f1b066f38$exports('#' + targetId);
                if (this.target.length === 0) throw 'No element found for targetId';
            } else throw 'Target must be the id of a DOM element';
        } else throw 'No target';
    }
    /**
     * log stat entry for this application
     * @param action {string}
     * @param store {boolean} If true, stores immediately
     */ logStat(action, store = false) {
        tumbo.STATS.logByCode(this.parsedConfig.getCode(), (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.getClassName(), this.getClass()), action, store);
    }
    /**
     * Loads and validates the application configuration
     */ loadConfig() {
        this.parsedConfig = this._readConfig();
        if (this.verifyErrors(true)) {
            if (this._getRuntimeConfigSerializationKey()) try {
                const runtimeConfigSerialization = this._getRuntimeConfigSerialization();
                this.runtimeConfig = this._getRuntimeConfigFromSerialization(runtimeConfigSerialization);
                this.parsedConfig.override(this.runtimeConfig);
                if (!this.verifyErrors()) {
                    this.parsedConfig.reset();
                    this.runtimeConfig.clean();
                }
                tumbo.appCode = this.parsedConfig.getCode();
            } catch (e) {
                this.runtimeConfig = this._getRuntimeConfig();
                this.logError("Could not read runtime config", e);
            }
        } else this.error = true;
    }
    _getRuntimeConfigSerialization() {
        if (this._isRuntimeConfigOutdated()) this._clearRuntimeConfig();
        return localStorage.getItem(this._getRuntimeConfigSerializationKey());
    }
    _clearRuntimeConfig() {
        localStorage.removeItem(this._getRuntimeConfigSerializationKey() + '_ts');
        localStorage.removeItem(this._getRuntimeConfigSerializationKey());
        this.logInfo("Clear localStorage config");
    }
    _isRuntimeConfigOutdated() {
        const tsStr = (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(localStorage.getItem(this._getRuntimeConfigSerializationKey() + '_ts'));
        const ts = tsStr ? new Date(tsStr) : undefined;
        return ts && Math.abs(new Date() - ts) > $bc6d7cfcca5213f3$export$c3599f2c821eb267.MAX_RUNTIMECONFIG_SESSION_TIME;
    }
    _setRuntimeConfigTS() {
        localStorage.setItem(this._getRuntimeConfigSerializationKey() + '_ts', (0, $aeedcab592f41cce$export$bfe4ac50319c1d9b)(new Date(), true));
    }
    _getRuntimeConfig() {}
    _getRuntimeConfigFromSerialization(runtimeConfigSerialization) {}
    _readConfig() {}
    _getRuntimeConfigSerializationKey() {}
    verifyErrors(write) {
        const errors = this.parsedConfig.verify();
        if (write && errors.length > 0 && tumbo.LOGGER.isOnDebug()) {
            const errStr = errors.join('<br/>');
            this.target.append($dc57b31f1b066f38$exports('<pre>' + errStr + '</pre>'));
        }
        errors.forEach((e)=>this.logError(e));
        return errors.length === 0;
    }
    /**
     * Runs this application. To be called from the outside.
     * Should not be overridden
     */ run() {
        if (!this.error) {
            this.target.addClass('ccl-color_emergency ccl-style tumbo');
            this.isMobileDevice = (0, (/*@__PURE__*/$parcel$interopDefault($eeeaa62421b7b994$exports)))();
            if (this.isMobileDevice) this.target.addClass('mobile-device');
            else this.target.removeClass('mobile-device');
            this.tooltip = new (0, $c2f759c93741e5b5$export$28c660c63b792dea)(this.parsedConfig.getCode() + 'tooltip', this.translator, this.isMobileDevice, this.target);
            this._initSizeMonitoring();
            this._doRun();
            tumbo.STATS = new (0, $7b3a278e0e939859$export$511bae38709055e3)(this.translator, this.parsedConfig.getCode(), this.parsedConfig.getStatsPostUrl(), this.isMobileDevice, this.target);
            tumbo.STATS.initSendProcedure();
            this.logStat("INIT");
            const contactPostUrl = this.parsedConfig.getContactPostUrl();
            if (contactPostUrl) {
                const modal = this.isSmallContainerWidth ? new (0, $c51f63cd05d438f7$export$f99cb66c19a01512)(this.translator, this.isMobileDevice, this.target, 'contact_form_modal', this.runtimeConfig, this.getOnChangeRuntimeConfigCallback(), true) : new (0, $c51f63cd05d438f7$export$35f3383e73608ac2)(this.translator, this.isMobileDevice, this.target, 'contact_form_modal', this.runtimeConfig, this.getOnChangeRuntimeConfigCallback(), true);
                this.contactButton = new (0, $5f61dedde258ef43$export$c6a80bb1e13bf921)(this.translator, this.isMobileDevice, modal, contactPostUrl, this.runtimeConfig, this.getOnChangeRuntimeConfigCallback());
                this.target.append(this.contactButton.getUIElement());
            }
            this.isRunning = true;
            this.onSizeChange();
        }
        if (window.tumbo.tumboColors) {
            const elementById = document.getElementsByTagName('body')[0];
            for(let name in window.tumbo.tumboColors)elementById.style.setProperty('--' + name, window.tumbo.tumboColors[name]);
        }
    }
    _initWarnings() {
        this.warningsButton = new (0, $a313b23f4bcffb20$export$7ff4c2019d0a66fb)(this.parsedConfig.getGeneralWarningMessages(), this.parsedConfig.getAllServiceWarningMessages(), this.target, this.translator, this.isMobileDevice, this.runtimeConfig, this.getOnChangeRuntimeConfigCallback());
        this.warningsButton.onChangeVisibleLayers([]);
    }
    /**
     * Should be overridden to implement this application
     * @private
     */ _doRun() {}
    /**
     * Should be overridden to make this application react to changes in window size
     */ onSizeChange() {
        (0, $9a87c76e274c7738$export$f03163d7279986d4).allUIElements.forEach((e)=>{
            e.setContainerSizeAndPosition(this.isSmallContainerWidth, this.isSmallContainerHeight, this.containerWidth, this.containerHeight, this.containerAbsolutePosition);
        });
    }
    /**
     * Should not be overridden
     * @protected
     */ _initSizeMonitoring() {
        this.target.append($dc57b31f1b066f38$exports('<div class="landscape-error"><div class="landscape-error-message">' + this.translator.translate('landscapeErrorMessage') + '</div>' + '</div>'));
        const onResize = ()=>{
            this.containerWidth = this.target.width();
            this.containerHeight = this.target.height();
            this.containerAbsolutePosition = this.target.offset();
            this.isSmallContainerWidth = this.containerWidth < (0, $9bc5df2b24a7fcf6$export$20b4de146c2df434);
            this.isSmallContainerHeight = this.containerHeight < (0, $9bc5df2b24a7fcf6$export$8e5cee14bb214560);
            if (this.containerHeight < (0, $9bc5df2b24a7fcf6$export$8e5cee14bb214560) / 2 && this.containerWidth > this.containerHeight * 1.5) $dc57b31f1b066f38$exports('.landscape-error', this.target).show();
            else $dc57b31f1b066f38$exports('.landscape-error', this.target).hide();
            if (this.isSmallContainerWidth) this.target.addClass('small-tumbo-width').addClass('small-tumbo');
            else this.target.removeClass('small-tumbo-width');
            if (this.isSmallContainerHeight) this.target.addClass('small-tumbo-height').addClass('small-tumbo');
            else this.target.removeClass('small-tumbo-height');
            if (!this.isSmallContainerHeight && !this.isSmallContainerWidth) this.target.removeClass('small-tumbo');
            if (this.isRunning) this.onSizeChange();
        };
        new ResizeObserver(onResize).observe(this.target[0]);
        onResize();
    }
    onChangeRuntimeConfig() {
        this.parsedConfig.override(this.runtimeConfig);
    }
    getOnChangeRuntimeConfigCallback() {
        return ()=>this.onChangeRuntimeConfig();
    }
    initRuntimeConfigUpdate() {
        const key = this._getRuntimeConfigSerializationKey();
        if (key) {
            if (this.runtimeConfigIntervalId) clearInterval(this.runtimeConfigIntervalId);
            this.clearOnErrorCount = 0;
            this.runtimeConfigIntervalId = setInterval(()=>{
                const serializedConfig = this.runtimeConfig.getSerializedConfig();
                if (this._isRuntimeConfigOutdated()) {
                    this._clearRuntimeConfig();
                    if (tumbo.LOGGER.isOnDebug()) this.logDebug("Would refresh page");
                    else location.reload();
                }
                if (tumbo.LOGGER.isOnDebug() && new Date().getMinutes() % 5 === 0 && new Date().getSeconds() === 0) this.logDebug("Saving runtimeConfig with " + serializedConfig.length + " chars");
                try {
                    this._setRuntimeConfigTS();
                    localStorage.setItem(key, serializedConfig);
                    this.clearOnErrorCount = 0;
                } catch (e) {
                    this.logError("Error saving runtime config to localStorage", e);
                    if (this.clearOnErrorCount < 3) {
                        localStorage.clear();
                        this.clearOnErrorCount++;
                        this.logInfo("Cleared localStorage");
                    } else {
                        clearInterval(this.runtimeConfigIntervalId);
                        this.logError('Already cleared localStorage ' + this.clearOnErrorCount + ' times. Will clear and reload.');
                        setTimeout(()=>{
                            localStorage.clear();
                            location.reload();
                        }, 5000);
                    }
                }
            }, 1000);
        }
    }
}
/**
 * Set a color by its name. It will be used in the map style.
 * Possible color names:
 *     . fundamental
 *     . fundamental-half-opacity
 *     . fundamental-contrast
 *     . background-disabled
 *     . text-background-disabled
 *     . border-disabled
 *     . background-table-header
 *     . text
 *     . text-disabled
 *     . text-disabled-light
 *     . text-context
 *
 * Call to this function should be made before calling the init function
 *
 * @param colorName {string}
 * @param color {string} Any CSS color
 */ function $bc6d7cfcca5213f3$export$130a5dc1bc9cd8e1(colorName, color) {
    if (!window.tumbo.tumboColors) window.tumbo.tumboColors = {};
    window.tumbo.tumboColors[colorName] = color;
}
$bc6d7cfcca5213f3$export$e3456b5d55e1b02f();
window.tumbo.setColor = $bc6d7cfcca5213f3$export$130a5dc1bc9cd8e1;













class $3ec0aa0ced114042$export$d304294fe97dd756 extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param id {string} The HTML id for this container
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     **/ constructor(id, translator, isMobileDevice, runtimeConfig){
        super(id, translator, isMobileDevice, runtimeConfig, undefined);
    }
    getClassName() {
        return "AbstractContainer";
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<li role="listitem" class="element timeseries-container"></li>');
            const container = this.getContainerElement();
            this.uiElement.append(container);
            if (this.isCollapsible()) $dc57b31f1b066f38$exports('.buttons-container button.expander, .header>.title', this.uiElement).click(()=>{
                if (this.isExpanded()) {
                    this.collapse();
                    this.logStat("COLLAPSE");
                } else {
                    this.expand();
                    this.logStat("EXPAND");
                }
            });
        }
        return this.uiElement;
    }
    /**
     * Generate elements to insert into this container
     * @return {jQuery}
     */ getContainerElement() {}
    isCollapsible() {
        return true;
    }
    /**
     * Is this container expanded?
     * @return {boolean}
     */ isExpanded() {
        if (!this.isCollapsible()) return true;
        return this.getSessionProp("expanded") !== false;
    }
    /**
     * Expand container
     */ expand() {
        this.setSessionProp("expanded", true);
        $dc57b31f1b066f38$exports('.buttons-container button.expander', this.uiElement).addClass('collapse').removeClass('expand');
        $dc57b31f1b066f38$exports('.container', this.uiElement).addClass('expanded');
        $dc57b31f1b066f38$exports('.body', this.uiElement).attr('aria-expanded', 'true');
        this._onExpand();
    }
    /**
     * Collapse container
     */ collapse() {
        if (this.isCollapsible()) {
            this.setSessionProp("expanded", false);
            $dc57b31f1b066f38$exports('.buttons-container button.expander', this.uiElement).addClass('expand').removeClass('collapse');
            $dc57b31f1b066f38$exports('.container', this.uiElement).removeClass('expanded');
            $dc57b31f1b066f38$exports('.body', this.uiElement).attr('aria-expanded', 'false');
            this._onCollapse();
        }
    }
    /**
     * Override to specify behaviour after expand
     */ _onExpand() {}
    /**
     * Override to specify behaviour after collapse
     */ _onCollapse() {}
    /**
     * To be called by the owner of this container when it's added to the DOM
     * Override to specify behaviour at this moment
     */ onAdd2DOM() {}
}








/**
 * A dates picker from until
 * @extends AbstractContainer
 */ class $84f00262b5923f0a$export$5109c6dd95d8fb00 extends (0, $3ec0aa0ced114042$export$d304294fe97dd756) {
    getClassName() {
        return "DatePicker";
    }
    static MAX_DAYS = 5475;
    /**
     *
     * @param id {string} The HTML id for this container
     * @param translator {Translator} A translator
     * @param layers {Array<Layer>}
     * @param periodicity {PeriodicityEnum}
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     **/ constructor(id, translator, layers, periodicity = (0, $815c91046e476159$export$45470b399d15bbcb).DAILY, runtimeConfig, onChangeRuntimeConfig, isMobileDevice){
        super(id, translator, isMobileDevice, runtimeConfig);
        this.onChangeRuntimeConfig = onChangeRuntimeConfig;
        this.layers = layers;
        this.onChangeCallbacks = new Set();
        const maxHardUntil = this._getHardMaxUntil();
        this.timeCalculator = new (0, $aeedcab592f41cce$export$41dea944c75fcd24)(periodicity, (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this._getHardMinFrom()), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(maxHardUntil), this.translator);
        this.setDefaultFromUntil(this.timeCalculator.addDays(maxHardUntil, -365), maxHardUntil);
    }
    onChange(callback) {
        if (callback) this.onChangeCallbacks.add(callback);
        return this;
    }
    _getMinUntil() {
        return this.timeCalculator.addDays(this.timeCalculator.min(this._getMaxFrom(), (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.getFrom())), 1);
    }
    _getHardMaxUntil() {
        const manyLayers = this.layers.length > 1;
        return this.layers.map((l)=>{
            const tc = l.getTimeCalculator();
            const dataUntil = l.getDataUntil();
            const year = tc.getYearFromDate(dataUntil);
            const month = tc.getMonthFromDate(dataUntil);
            const day = !manyLayers ? tc.getDayFromDate(tc.getUntil()) : tc.getUnboundedMaxDayForYearMonth(year, month);
            return (0, $aeedcab592f41cce$export$2b6cf20b1d58ec45)(year, month, day);
        }).sort((d1, d2)=>d2 - d1)[0];
    }
    _getHardMinFrom() {
        return this.layers.map((l)=>l.getDataFrom()).sort((d1, d2)=>d1 - d2)[0];
    }
    _getMaxFrom() {
        return this.timeCalculator.addDays(this.timeCalculator.max(this._getHardMaxUntil(), (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.getUntil())), -1);
    }
    getFrom() {
        const from = this.runtimeConfig.getToolProperty(this.id, 'timeFrom');
        return from ? from : (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this._getHardMinFrom());
    }
    /**
     * Set default dates
     * @param from {Date}
     * @param until {Date}
     */ setDefaultFromUntil(from, until) {
        if (!this.runtimeConfig.getToolProperty(this.id, 'timeFrom')) this.runtimeConfig.setToolProperty(this.id, 'timeFrom', (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from));
        if (!this.runtimeConfig.getToolProperty(this.id, 'timeUntil')) this.runtimeConfig.setToolProperty(this.id, 'timeUntil', (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(until));
    }
    _getThirdComponentFromDate(date) {
        switch(this.timeCalculator.getPeriodicity()){
            case (0, $815c91046e476159$export$45470b399d15bbcb).CUSTOM:
            case (0, $815c91046e476159$export$45470b399d15bbcb).YEARLY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_FORECAST:
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_UPDATED_TEN_DAILY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).WEEKLY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).ISO_WEEKLY:
                return undefined;
            case (0, $815c91046e476159$export$45470b399d15bbcb).DAILY:
                return this.timeCalculator.getDayFromDate(date);
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY:
                return this.timeCalculator.getTenDaysFromDate(date);
            default:
                return undefined;
        }
    }
    _getSecondComponentFromDate(date) {
        switch(this.timeCalculator.getPeriodicity()){
            case (0, $815c91046e476159$export$45470b399d15bbcb).CUSTOM:
            case (0, $815c91046e476159$export$45470b399d15bbcb).YEARLY:
                return undefined;
            case (0, $815c91046e476159$export$45470b399d15bbcb).WEEKLY:
                return this.timeCalculator.getWeekFromDate(date);
            case (0, $815c91046e476159$export$45470b399d15bbcb).ISO_WEEKLY:
                return this.timeCalculator.getISOWeekFromDate(date);
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_FORECAST:
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_UPDATED_TEN_DAILY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).DAILY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY:
                return this.timeCalculator.getMonthFromDate(date);
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS:
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS_30DAY:
                return this.timeCalculator.getTenDaysFromDate(date);
            case (0, $815c91046e476159$export$45470b399d15bbcb).DAILY_YEARLESS:
                return this.timeCalculator.getDayFromDate(date);
            default:
                return undefined;
        }
    }
    _getFirstComponentFromDate(date) {
        switch(this.timeCalculator.getPeriodicity()){
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS:
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS_30DAY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).DAILY_YEARLESS:
                return this.timeCalculator.getMonthFromDate(date);
            default:
                return this.timeCalculator.getYearFromDate(date);
        }
    }
    _dateFromComponents(firstComponent, secondComponent, thirdComponent) {
        switch(this.timeCalculator.getPeriodicity()){
            case (0, $815c91046e476159$export$45470b399d15bbcb).CUSTOM:
                return undefined;
            case (0, $815c91046e476159$export$45470b399d15bbcb).YEARLY:
                return (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCalculator.writeYearly(firstComponent));
            case (0, $815c91046e476159$export$45470b399d15bbcb).WEEKLY:
                return (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCalculator.writeWeekly(firstComponent, secondComponent));
            case (0, $815c91046e476159$export$45470b399d15bbcb).ISO_WEEKLY:
                return (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCalculator.writeISOWeekly(firstComponent, secondComponent));
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_UPDATED_TEN_DAILY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY:
                return (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCalculator.writeMonthly(firstComponent, secondComponent));
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_FORECAST:
                return (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCalculator.writeMonthly(firstComponent, secondComponent));
            case (0, $815c91046e476159$export$45470b399d15bbcb).DAILY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).DAILY_YEARLESS:
                return (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCalculator.writeDaily(firstComponent, secondComponent, thirdComponent));
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS_30DAY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS:
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY:
                return (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCalculator.writeTenDaily(firstComponent, secondComponent, thirdComponent));
            default:
                return undefined;
        }
    }
    _setFrom(firstComponent, secondComponent, thirdComponent) {
        const from = this.getFrom();
        const fromDate = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(from);
        firstComponent = firstComponent !== undefined ? firstComponent : this._getFirstComponentFromDate(fromDate);
        secondComponent = secondComponent !== undefined ? secondComponent : this._getSecondComponentFromDate(fromDate);
        thirdComponent = thirdComponent !== undefined ? thirdComponent : this._getThirdComponentFromDate(fromDate);
        const dateFromSliders = this.timeCalculator.isYearless() ? this._dateFromComponents(0, firstComponent, secondComponent) : this._dateFromComponents(firstComponent, secondComponent, thirdComponent);
        if (from !== (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(dateFromSliders)) {
            this.runtimeConfig.setToolProperty(this.id, 'timeFrom', (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(dateFromSliders));
            this.onChangeRuntimeConfig();
            if (this.timeCalculator.getDifferenceInDays((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.getUntil()), dateFromSliders) > $84f00262b5923f0a$export$5109c6dd95d8fb00.MAX_DAYS) {
                const fixedUntil = this.timeCalculator.min(this._getHardMaxUntil(), this.timeCalculator.addDays(dateFromSliders, $84f00262b5923f0a$export$5109c6dd95d8fb00.MAX_DAYS));
                this._setUntil(this.timeCalculator.getYearFromDate(fixedUntil), this.timeCalculator.getMonthFromDate(fixedUntil), this.timeCalculator.getDayFromDate(fixedUntil));
            } else this.onChangeCallbacks.forEach((c)=>c(this));
        }
    }
    getUntil() {
        const until = this.runtimeConfig.getToolProperty(this.id, 'timeUntil');
        return until ? until : (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this._getTimeCalculator(false).getUntil());
    }
    getUntilPeriodStart() {
        return this.timeCalculator.fixDate((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.getUntil()));
    }
    _setUntil(firstComponent, secondComponent, thirdComponent) {
        const until = this.getUntil();
        const untilDate = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(until);
        firstComponent = firstComponent !== undefined ? firstComponent : this._getFirstComponentFromDate(untilDate);
        secondComponent = secondComponent !== undefined ? secondComponent : this._getSecondComponentFromDate(untilDate);
        thirdComponent = thirdComponent !== undefined ? thirdComponent : this._getThirdComponentFromDate(untilDate);
        const dateFromSliders = this.timeCalculator.isDaily() || this.timeCalculator.isDailyYearless() ? (0, $aeedcab592f41cce$export$2b6cf20b1d58ec45)(firstComponent, secondComponent, thirdComponent) : this.timeCalculator.isTenDaily() || this.timeCalculator.isTenDailyYearless() ? (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCalculator.writeTenDaily(firstComponent, secondComponent, thirdComponent)) : this.timeCalculator.isMonthlyUpdatedTenDaily() || this.timeCalculator.isTenDailyYearless30Day() ? (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCalculator.writeMonthlyUpdatedTenDaily(firstComponent, secondComponent)) : this.timeCalculator.getLastDayOfMonthFromDate(this._dateFromComponents(firstComponent, secondComponent, thirdComponent));
        if (until !== (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(dateFromSliders)) {
            this.runtimeConfig.setToolProperty(this.id, 'timeUntil', (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(dateFromSliders));
            this.onChangeRuntimeConfig();
            if (this.timeCalculator.getDifferenceInDays(dateFromSliders, (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.getFrom())) > $84f00262b5923f0a$export$5109c6dd95d8fb00.MAX_DAYS) {
                const fixedFrom = this.timeCalculator.max(this._getHardMinFrom(), this.timeCalculator.addDays(dateFromSliders, -$84f00262b5923f0a$export$5109c6dd95d8fb00.MAX_DAYS));
                this._setFrom(this.timeCalculator.getYearFromDate(fixedFrom), this.timeCalculator.getMonthFromDate(fixedFrom), this.timeCalculator.getDayFromDate(fixedFrom));
            } else this.onChangeCallbacks.forEach((c)=>c(this));
        }
    }
    isExpanded() {
        return this.getSessionProp("expanded") === true;
    }
    getContainerElement() {
        const expanded = this.isExpanded();
        const container = $dc57b31f1b066f38$exports('<div class="date-picker container ' + (expanded ? 'expanded' : '') + '">' + '   <div class="header" role="heading">' + '       <div class="title">' + '           <h3></h3>' + '       </div>' + '       <div class="buttons-container">' + '           <button class="expander ' + (expanded ? 'collapse' : 'expand') + '" type="button" title="' + this.translator.translate('tool.charts.expander') + '"></button>' + '       </div>' + '   </div>' + '   <div class="body" aria-expanded="' + expanded + '">' + '       <div class="from title">' + this.translator.translate('tool.charts.from.title') + '</div>' + '       <div class="sliders-container from-container one"><div class="first-container"></div></div>' + '       <div class="until title">' + this.translator.translate('tool.charts.until.title') + '</div>' + '       <div class="sliders-container until-container one"><div class="first-container"></div></div>' + '   </div>' + '</div>');
        if (!this.timeCalculator.isYearly() && !this.timeCalculator.isTenDailyYearless30Day()) $dc57b31f1b066f38$exports('.sliders-container', container).append($dc57b31f1b066f38$exports('<div class="second-container"></div>')).removeClass('one').addClass('two');
        if (!this.timeCalculator.isYearly() && !this.timeCalculator.isMonthly() && !this.timeCalculator.isMonthlyForecast() && !this.timeCalculator.isMonthlyUpdatedTenDaily() && !this.timeCalculator.isWeekly() && !this.timeCalculator.isISOWeekly() && !this.timeCalculator.isYearless()) $dc57b31f1b066f38$exports('.sliders-container', container).append($dc57b31f1b066f38$exports('<div class="third-container"></div>')).removeClass('two').addClass('three');
        const onChangePicker = (picker)=>{
            const pickedFromStr = picker.getFrom();
            const pickedUntilStr = (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.timeCalculator.isMonthlyUpdatedTenDaily() ? picker.getUntil() : this.timeCalculator.getEndDateOfPeriod(picker.getUntil()));
            $dc57b31f1b066f38$exports('.header .title h3', container).html(picker.translator.translate('tool.charts.time.title', [
                pickedFromStr,
                pickedUntilStr
            ]));
        };
        onChangePicker(this);
        this.onChange(onChangePicker);
        return this._createTimePickers(container);
    }
    _createTimePickers(container) {
        this.firstComponentSliders = [];
        this.secondComponentSliders = [];
        this.thirdComponentSliders = [];
        const self = this;
        function createTimeSliders(from) {
            const createFirstComponentSlider = (from)=>{
                const timeCalculator = self._getTimeCalculator(from);
                const sliderIndex = from ? 0 : 1;
                const sliderId = self.id + '_' + (from ? 'from_firstComponent' : 'until_firstComponent');
                const pickedFromStr = self.getFrom();
                const pickedFrom = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(pickedFromStr);
                const pickedUntilStr = self.getUntil();
                const pickedUntil = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(pickedUntilStr);
                const picked = from ? pickedFrom : pickedUntil;
                const isMonth = self.timeCalculator.isYearless();
                const min = isMonth ? timeCalculator.getMinMonthForYear() : timeCalculator.getMinYear();
                const max = isMonth ? timeCalculator.getMaxMonthForYear() : timeCalculator.getMaxYear();
                self.firstComponentSliders[sliderIndex] = new (0, $c7406baad5d56380$export$472062a354075cee)(self.translator, self.isMobileDevice, sliderId, min, max, isMonth ? timeCalculator.getMonthFromDate(picked) : timeCalculator.getYearFromDate(picked), 1, max - min + 1, undefined, undefined, function(slider) {
                    const secondComponent = self.secondComponentSliders[slider.get('index')] ? self.secondComponentSliders[slider.get('index')].getValue() : undefined;
                    const thirdComponent = self.thirdComponentSliders[slider.get('index')] ? self.thirdComponentSliders[slider.get('index')].getValue() : undefined;
                    if (slider.get('from')) self._setFrom(slider.getValue(), secondComponent, thirdComponent);
                    else self._setUntil(slider.getValue(), secondComponent, thirdComponent);
                }, true, true, undefined, undefined, undefined).set('index', sliderIndex).set('from', from);
                const yearContainer = $dc57b31f1b066f38$exports('<div class="slider-container time-container first ' + (from ? 'from' : 'until') + '">' + '   <label for="' + sliderId + '">' + self.translator.translate('tool.charts.' + (from ? 'from' : 'until') + '.' + (isMonth ? 'monthLabel' : 'yearLabel')) + '</label>' + '</div>').append(self.firstComponentSliders[sliderIndex].getUIElement());
                $dc57b31f1b066f38$exports(from ? '.from-container .first-container' : '.until-container .first-container', container).empty().append(yearContainer);
            };
            createFirstComponentSlider(from);
            const createSecondComponentSlider = (from)=>{
                const timeCalculator = self._getTimeCalculator(from);
                const sliderIndex = from ? 0 : 1;
                const sliderId = self.id + '_' + (from ? 'from_secondComponent' : 'until_secondComponent');
                const picked = from ? (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(self.getFrom()) : (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(self.getUntil());
                const year = timeCalculator.getYearFromDate(picked);
                const maxSecond = (parentValue)=>self.timeCalculator.isWeekly() ? timeCalculator.getMaxWeekForYear(parentValue) : self.timeCalculator.isISOWeekly() ? timeCalculator.getMaxWeekForYear(parentValue) : timeCalculator.getMaxMonthForYear(parentValue);
                const minSecond = (parentValue)=>self.timeCalculator.isWeekly() ? timeCalculator.getMinWeekForYear(parentValue) : self.timeCalculator.isISOWeekly() ? timeCalculator.getMinWeekForYear(parentValue) : timeCalculator.getMinMonthForYear(parentValue);
                const min = minSecond(year);
                const max = maxSecond(year);
                const value = self.timeCalculator.isWeekly() ? timeCalculator.getWeekFromDate(picked) : self.timeCalculator.isISOWeekly() ? timeCalculator.getISOWeekFromDate(picked) : timeCalculator.getMonthFromDate(picked);
                self.secondComponentSliders[sliderIndex] = new (0, $c7406baad5d56380$export$472062a354075cee)(self.translator, self.isMobileDevice, sliderId, min, max, value, 1, max - min + 1, undefined, undefined, function(slider) {
                    const thirdComponent = self.thirdComponentSliders[slider.get('index')] ? self.thirdComponentSliders[slider.get('index')].getValue() : undefined;
                    if (slider.get('from')) self._setFrom(self.firstComponentSliders[slider.get('index')].getValue(), slider.getValue(), thirdComponent);
                    else self._setUntil(self.firstComponentSliders[slider.get('index')].getValue(), slider.getValue(), thirdComponent);
                }, true, true, self.firstComponentSliders[sliderIndex], maxSecond, minSecond).set('index', sliderIndex).set('from', from);
                const secondComponentLabelKey = self.timeCalculator.isWeekly() ? 'weekLabel' : self.timeCalculator.isISOWeekly() ? 'isoWeekLabel' : 'monthLabel';
                const labelKey = 'tool.charts.' + (from ? 'from' : 'until') + '.' + secondComponentLabelKey;
                const secondContainer = $dc57b31f1b066f38$exports('<div class="slider-container time-container second ' + (from ? 'from' : 'until') + '">' + '   <label for="' + sliderId + '">' + self.translator.translate(labelKey) + '</label>' + '</div>').append(self.secondComponentSliders[sliderIndex].getUIElement());
                $dc57b31f1b066f38$exports(from ? '.from-container .second-container' : '.until-container .second-container', container).empty().append(secondContainer);
            };
            if (!self.timeCalculator.isYearly() && !self.timeCalculator.isTenDailyYearless30Day()) createSecondComponentSlider(from);
            function createThirdComponentSlider(from) {
                const timeCalculator = self._getTimeCalculator(from);
                const sliderIndex = from ? 0 : 1;
                const sliderId = self.id + '_' + (from ? 'from_thirdComponent' : 'until_thirdComponent');
                const picked = from ? (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(self.getFrom()) : (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(self.getUntil());
                const year = timeCalculator.getYearFromDate(picked);
                const month = timeCalculator.getMonthFromDate(picked);
                const min = timeCalculator.isTenDaily() ? timeCalculator.getMinTenDaysForYearMonth(year, month) : timeCalculator.getMinDayForYearMonth(year, month);
                const max = timeCalculator.isTenDaily() ? timeCalculator.getMaxTenDaysForYearMonth(year, month) : timeCalculator.isDaily() ? timeCalculator.getDayFromDate(timeCalculator.min((0, $aeedcab592f41cce$export$2b6cf20b1d58ec45)(year, month, timeCalculator.getMaxDayForYearMonth(year, month)), timeCalculator.getUntil())) : timeCalculator.getMaxDayForYearMonth(year, month);
                self.thirdComponentSliders[sliderIndex] = new (0, $c7406baad5d56380$export$472062a354075cee)(self.translator, self.isMobileDevice, sliderId, min, max, self.timeCalculator.isTenDaily() ? timeCalculator.getTenDaysFromDate(picked) : timeCalculator.getDayFromDate(picked), 1, max - min + 1, undefined, undefined, function(slider) {
                    if (slider.get('from')) self._setFrom(self.firstComponentSliders[slider.get('index')].getValue(), self.secondComponentSliders[slider.get('index')].getValue(), slider.getValue());
                    else self._setUntil(self.firstComponentSliders[slider.get('index')].getValue(), self.secondComponentSliders[slider.get('index')].getValue(), slider.getValue());
                }, true, true, self.secondComponentSliders[sliderIndex], function(parentValue) {
                    return self.timeCalculator.isTenDaily() ? timeCalculator.getMaxTenDaysForYearMonth(self.firstComponentSliders[this.get('index')].getValue(), parentValue) : timeCalculator.getMaxDayForYearMonth(self.firstComponentSliders[this.get('index')].getValue(), parentValue);
                }, function(parentValue) {
                    return self.timeCalculator.isTenDaily() ? timeCalculator.getMinTenDaysForYearMonth(self.firstComponentSliders[this.get('index')].getValue(), parentValue) : timeCalculator.getMinDayForYearMonth(self.firstComponentSliders[this.get('index')].getValue(), parentValue);
                }).set('index', sliderIndex).set('from', from);
                const thirdComponentLabelKey = self.timeCalculator.isTenDaily() || self.timeCalculator.isTenDailyYearless() ? 'tenDayLabel' : 'dayLabel';
                const labelKey = 'tool.charts.' + (from ? 'from' : 'until') + '.' + thirdComponentLabelKey;
                const thirdContainer = $dc57b31f1b066f38$exports('<div class="slider-container time-container third ' + (from ? 'from' : 'until') + '">' + '   <label for="' + sliderId + '">' + self.translator.translate(labelKey) + '</label>' + '</div>').append(self.thirdComponentSliders[sliderIndex].getUIElement());
                $dc57b31f1b066f38$exports(from ? '.from-container .third-container' : '.until-container .third-container', container).empty().append(thirdContainer);
            }
            if (!self.timeCalculator.isYearly() && !self.timeCalculator.isTenDailyYearless30Day() && !self.timeCalculator.isMonthly() && !self.timeCalculator.isMonthlyForecast() && !self.timeCalculator.isMonthlyUpdatedTenDaily() && !self.timeCalculator.isWeekly() && !self.timeCalculator.isISOWeekly()) createThirdComponentSlider(from);
            const sliderIndex = from ? 0 : 1;
            if (from) self._setFrom(self.firstComponentSliders[sliderIndex].getValue(), self.secondComponentSliders[sliderIndex] ? self.secondComponentSliders[sliderIndex].getValue() : undefined, self.thirdComponentSliders[sliderIndex] ? self.thirdComponentSliders[sliderIndex].getValue() : undefined);
            else self._setUntil(self.firstComponentSliders[sliderIndex].getValue(), self.secondComponentSliders[sliderIndex] ? self.secondComponentSliders[sliderIndex].getValue() : undefined, self.thirdComponentSliders[sliderIndex] ? self.thirdComponentSliders[sliderIndex].getValue() : undefined);
            const onChange = ()=>{
                createTimeSliders(from);
                createTimeSliders(!from);
            };
            self.firstComponentSliders[sliderIndex].onChange(onChange);
            if (self.secondComponentSliders[sliderIndex]) self.secondComponentSliders[sliderIndex].onChange(onChange);
            if (self.thirdComponentSliders[sliderIndex]) self.thirdComponentSliders[sliderIndex].onChange(onChange);
        }
        createTimeSliders(true);
        createTimeSliders(false);
        return container;
    }
    _getTimeCalculator(from) {
        return new (0, $aeedcab592f41cce$export$41dea944c75fcd24)(this.timeCalculator.getPeriodicity(), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from ? this._getHardMinFrom() : this._getMinUntil()), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(from ? this._getMaxFrom() : this._getHardMaxUntil()), this.translator);
    }
}







var $a765ec5880d44928$exports = {};
var $d3c1734dacb01657$exports = {};
// shim for using process in browser
var $d3c1734dacb01657$var$process = $d3c1734dacb01657$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = 'browser';
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ''; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3c1734dacb01657$var$process.cwd = function() {
    return '/';
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
'use strict';
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
'use strict';
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup['-'.charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup['_'.charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case 'ascii':
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case 'base64':
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf);
    else return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$0934e0939605d48c$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $8a0a73e6b73fd0c4$export$d622b2ad8d90c771($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $a765ec5880d44928$require$Buffer = $0934e0939605d48c$export$a143d493d941bafc;
/**
* plotly.js v3.0.1
* Copyright 2012-2025, Plotly, Inc.
* All rights reserved.
* Licensed under the MIT license
*/ (function(root, factory) {
    if (0, $a765ec5880d44928$exports) $a765ec5880d44928$exports = factory();
    else root.moduleName = factory();
})(typeof self !== "undefined" ? self : $a765ec5880d44928$exports, ()=>{
    "use strict";
    var Plotly = (()=>{
        var VQe = Object.create;
        var MS = Object.defineProperty, HQe = Object.defineProperties, GQe = Object.getOwnPropertyDescriptor, jQe = Object.getOwnPropertyDescriptors, WQe = Object.getOwnPropertyNames, XQ = Object.getOwnPropertySymbols, ZQe = Object.getPrototypeOf, KQ = Object.prototype.hasOwnProperty, XQe = Object.prototype.propertyIsEnumerable;
        var YQ = (e, t, r)=>t in e ? MS(e, t, {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: r
            }) : e[t] = r, JQ = (e, t)=>{
            for(var r in t || (t = {}))KQ.call(t, r) && YQ(e, r, t[r]);
            if (XQ) for (var r of XQ(t))XQe.call(t, r) && YQ(e, r, t[r]);
            return e;
        }, $Q = (e, t)=>HQe(e, jQe(t));
        var Ll = (e, t)=>()=>(e && (t = e(e = 0)), t);
        var ye = (e, t)=>()=>(t || e((t = {
                    exports: {}
                }).exports, t), t.exports), QQ = (e, t)=>{
            for(var r in t)MS(e, r, {
                get: t[r],
                enumerable: !0
            });
        }, eee = (e, t, r, n)=>{
            if (t && typeof t == "object" || typeof t == "function") for (let i of WQe(t))!KQ.call(e, i) && i !== r && MS(e, i, {
                get: ()=>t[i],
                enumerable: !(n = GQe(t, i)) || n.enumerable
            });
            return e;
        };
        var YQe = (e, t, r)=>(r = e != null ? VQe(ZQe(e)) : {}, eee(t || !e || !e.__esModule ? MS(r, "default", {
                value: e,
                enumerable: !0
            }) : r, e)), B1 = (e)=>eee(MS({}, "__esModule", {
                value: !0
            }), e);
        var e6 = ye((tee)=>{
            "use strict";
            tee.version = "3.0.1";
        });
        var iee = ye((ree, t6)=>{
            (function(t, r, n) {
                r[t] = r[t] || n(), typeof t6 != "undefined" && t6.exports && (t6.exports = r[t]);
            })("Promise", typeof window != "undefined" ? window : ree, function() {
                "use strict";
                var t, r, n, i = Object.prototype.toString, a = typeof setImmediate != "undefined" ? function(E) {
                    return setImmediate(E);
                } : setTimeout;
                try {
                    Object.defineProperty({}, "x", {}), t = function(E, k, A, L) {
                        return Object.defineProperty(E, k, {
                            value: A,
                            writable: !0,
                            configurable: L !== !1
                        });
                    };
                } catch (p) {
                    t = function(k, A, L) {
                        return k[A] = L, k;
                    };
                }
                n = function() {
                    var E, k, A;
                    function L(_, C) {
                        this.fn = _, this.self = C, this.next = void 0;
                    }
                    return {
                        add: function(C, M) {
                            A = new L(C, M), k ? k.next = A : E = A, k = A, A = void 0;
                        },
                        drain: function() {
                            var C = E;
                            for(E = k = r = void 0; C;)C.fn.call(C.self), C = C.next;
                        }
                    };
                }();
                function o(p, E) {
                    n.add(p, E), r || (r = a(n.drain));
                }
                function s(p) {
                    var E, k = typeof p;
                    return p != null && (k == "object" || k == "function") && (E = p.then), typeof E == "function" ? E : !1;
                }
                function l() {
                    for(var p = 0; p < this.chain.length; p++)u(this, this.state === 1 ? this.chain[p].success : this.chain[p].failure, this.chain[p]);
                    this.chain.length = 0;
                }
                function u(p, E, k) {
                    var A, L;
                    try {
                        E === !1 ? k.reject(p.msg) : (E === !0 ? A = p.msg : A = E.call(void 0, p.msg), A === k.promise ? k.reject(TypeError("Promise-chain cycle")) : (L = s(A)) ? L.call(A, k.resolve, k.reject) : k.resolve(A));
                    } catch (_) {
                        k.reject(_);
                    }
                }
                function c(p) {
                    var E, k = this;
                    if (!k.triggered) {
                        k.triggered = !0, k.def && (k = k.def);
                        try {
                            (E = s(p)) ? o(function() {
                                var A = new d(k);
                                try {
                                    E.call(p, function() {
                                        c.apply(A, arguments);
                                    }, function() {
                                        f.apply(A, arguments);
                                    });
                                } catch (L) {
                                    f.call(A, L);
                                }
                            }) : (k.msg = p, k.state = 1, k.chain.length > 0 && o(l, k));
                        } catch (A) {
                            f.call(new d(k), A);
                        }
                    }
                }
                function f(p) {
                    var E = this;
                    E.triggered || (E.triggered = !0, E.def && (E = E.def), E.msg = p, E.state = 2, E.chain.length > 0 && o(l, E));
                }
                function h(p, E, k, A) {
                    for(var L = 0; L < E.length; L++)(function(C) {
                        p.resolve(E[C]).then(function(g) {
                            k(C, g);
                        }, A);
                    })(L);
                }
                function d(p) {
                    this.def = p, this.triggered = !1;
                }
                function v(p) {
                    this.promise = p, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
                }
                function x(p) {
                    if (typeof p != "function") throw TypeError("Not a function");
                    if (this.__NPO__ !== 0) throw TypeError("Not a promise");
                    this.__NPO__ = 1;
                    var E = new v(this);
                    this.then = function(A, L) {
                        var _ = {
                            success: typeof A == "function" ? A : !0,
                            failure: typeof L == "function" ? L : !1
                        };
                        return _.promise = new this.constructor(function(M, g) {
                            if (typeof M != "function" || typeof g != "function") throw TypeError("Not a function");
                            _.resolve = M, _.reject = g;
                        }), E.chain.push(_), E.state !== 0 && o(l, E), _.promise;
                    }, this.catch = function(A) {
                        return this.then(void 0, A);
                    };
                    try {
                        p.call(void 0, function(A) {
                            c.call(E, A);
                        }, function(A) {
                            f.call(E, A);
                        });
                    } catch (k) {
                        f.call(E, k);
                    }
                }
                var b = t({}, "constructor", x, !1);
                return x.prototype = b, t(b, "__NPO__", 0, !1), t(x, "resolve", function(E) {
                    var k = this;
                    return E && typeof E == "object" && E.__NPO__ === 1 ? E : new k(function(L, _) {
                        if (typeof L != "function" || typeof _ != "function") throw TypeError("Not a function");
                        L(E);
                    });
                }), t(x, "reject", function(E) {
                    return new this(function(A, L) {
                        if (typeof A != "function" || typeof L != "function") throw TypeError("Not a function");
                        L(E);
                    });
                }), t(x, "all", function(E) {
                    var k = this;
                    return i.call(E) != "[object Array]" ? k.reject(TypeError("Not an array")) : E.length === 0 ? k.resolve([]) : new k(function(L, _) {
                        if (typeof L != "function" || typeof _ != "function") throw TypeError("Not a function");
                        var C = E.length, M = Array(C), g = 0;
                        h(k, E, function(T, F) {
                            M[T] = F, ++g === C && L(M);
                        }, _);
                    });
                }), t(x, "race", function(E) {
                    var k = this;
                    return i.call(E) != "[object Array]" ? k.reject(TypeError("Not an array")) : new k(function(L, _) {
                        if (typeof L != "function" || typeof _ != "function") throw TypeError("Not a function");
                        h(k, E, function(M, g) {
                            L(g);
                        }, _);
                    });
                }), x;
            });
        });
        var xa = ye((qQt, r6)=>{
            (function() {
                var e = {
                    version: "3.8.2"
                }, t = [].slice, r = function(Z) {
                    return t.call(Z);
                }, n = self.document;
                function i(Z) {
                    return Z && (Z.ownerDocument || Z.document || Z).documentElement;
                }
                function a(Z) {
                    return Z && (Z.ownerDocument && Z.ownerDocument.defaultView || Z.document && Z || Z.defaultView);
                }
                if (n) try {
                    r(n.documentElement.childNodes)[0].nodeType;
                } catch (Z) {
                    r = function(oe) {
                        for(var we = oe.length, Be = new Array(we); we--;)Be[we] = oe[we];
                        return Be;
                    };
                }
                if (Date.now || (Date.now = function() {
                    return +new Date;
                }), n) try {
                    n.createElement("DIV").style.setProperty("opacity", 0, "");
                } catch (Z) {
                    var o = this.Element.prototype, s = o.setAttribute, l = o.setAttributeNS, u = this.CSSStyleDeclaration.prototype, c = u.setProperty;
                    o.setAttribute = function(oe, we) {
                        s.call(this, oe, we + "");
                    }, o.setAttributeNS = function(oe, we, Be) {
                        l.call(this, oe, we, Be + "");
                    }, u.setProperty = function(oe, we, Be) {
                        c.call(this, oe, we + "", Be);
                    };
                }
                e.ascending = f;
                function f(Z, oe) {
                    return Z < oe ? -1 : Z > oe ? 1 : Z >= oe ? 0 : NaN;
                }
                e.descending = function(Z, oe) {
                    return oe < Z ? -1 : oe > Z ? 1 : oe >= Z ? 0 : NaN;
                }, e.min = function(Z, oe) {
                    var we = -1, Be = Z.length, Ue, We;
                    if (arguments.length === 1) {
                        for(; ++we < Be;)if ((We = Z[we]) != null && We >= We) {
                            Ue = We;
                            break;
                        }
                        for(; ++we < Be;)(We = Z[we]) != null && Ue > We && (Ue = We);
                    } else {
                        for(; ++we < Be;)if ((We = oe.call(Z, Z[we], we)) != null && We >= We) {
                            Ue = We;
                            break;
                        }
                        for(; ++we < Be;)(We = oe.call(Z, Z[we], we)) != null && Ue > We && (Ue = We);
                    }
                    return Ue;
                }, e.max = function(Z, oe) {
                    var we = -1, Be = Z.length, Ue, We;
                    if (arguments.length === 1) {
                        for(; ++we < Be;)if ((We = Z[we]) != null && We >= We) {
                            Ue = We;
                            break;
                        }
                        for(; ++we < Be;)(We = Z[we]) != null && We > Ue && (Ue = We);
                    } else {
                        for(; ++we < Be;)if ((We = oe.call(Z, Z[we], we)) != null && We >= We) {
                            Ue = We;
                            break;
                        }
                        for(; ++we < Be;)(We = oe.call(Z, Z[we], we)) != null && We > Ue && (Ue = We);
                    }
                    return Ue;
                }, e.extent = function(Z, oe) {
                    var we = -1, Be = Z.length, Ue, We, wt;
                    if (arguments.length === 1) {
                        for(; ++we < Be;)if ((We = Z[we]) != null && We >= We) {
                            Ue = wt = We;
                            break;
                        }
                        for(; ++we < Be;)(We = Z[we]) != null && (Ue > We && (Ue = We), wt < We && (wt = We));
                    } else {
                        for(; ++we < Be;)if ((We = oe.call(Z, Z[we], we)) != null && We >= We) {
                            Ue = wt = We;
                            break;
                        }
                        for(; ++we < Be;)(We = oe.call(Z, Z[we], we)) != null && (Ue > We && (Ue = We), wt < We && (wt = We));
                    }
                    return [
                        Ue,
                        wt
                    ];
                };
                function h(Z) {
                    return Z === null ? NaN : +Z;
                }
                function d(Z) {
                    return !isNaN(Z);
                }
                e.sum = function(Z, oe) {
                    var we = 0, Be = Z.length, Ue, We = -1;
                    if (arguments.length === 1) for(; ++We < Be;)d(Ue = +Z[We]) && (we += Ue);
                    else for(; ++We < Be;)d(Ue = +oe.call(Z, Z[We], We)) && (we += Ue);
                    return we;
                }, e.mean = function(Z, oe) {
                    var we = 0, Be = Z.length, Ue, We = -1, wt = Be;
                    if (arguments.length === 1) for(; ++We < Be;)d(Ue = h(Z[We])) ? we += Ue : --wt;
                    else for(; ++We < Be;)d(Ue = h(oe.call(Z, Z[We], We))) ? we += Ue : --wt;
                    if (wt) return we / wt;
                }, e.quantile = function(Z, oe) {
                    var we = (Z.length - 1) * oe + 1, Be = Math.floor(we), Ue = +Z[Be - 1], We = we - Be;
                    return We ? Ue + We * (Z[Be] - Ue) : Ue;
                }, e.median = function(Z, oe) {
                    var we = [], Be = Z.length, Ue, We = -1;
                    if (arguments.length === 1) for(; ++We < Be;)d(Ue = h(Z[We])) && we.push(Ue);
                    else for(; ++We < Be;)d(Ue = h(oe.call(Z, Z[We], We))) && we.push(Ue);
                    if (we.length) return e.quantile(we.sort(f), .5);
                }, e.variance = function(Z, oe) {
                    var we = Z.length, Be = 0, Ue, We, wt = 0, tt = -1, zt = 0;
                    if (arguments.length === 1) for(; ++tt < we;)d(Ue = h(Z[tt])) && (We = Ue - Be, Be += We / ++zt, wt += We * (Ue - Be));
                    else for(; ++tt < we;)d(Ue = h(oe.call(Z, Z[tt], tt))) && (We = Ue - Be, Be += We / ++zt, wt += We * (Ue - Be));
                    if (zt > 1) return wt / (zt - 1);
                }, e.deviation = function() {
                    var Z = e.variance.apply(this, arguments);
                    return Z && Math.sqrt(Z);
                };
                function v(Z) {
                    return {
                        left: function(oe, we, Be, Ue) {
                            for(arguments.length < 3 && (Be = 0), arguments.length < 4 && (Ue = oe.length); Be < Ue;){
                                var We = Be + Ue >>> 1;
                                Z(oe[We], we) < 0 ? Be = We + 1 : Ue = We;
                            }
                            return Be;
                        },
                        right: function(oe, we, Be, Ue) {
                            for(arguments.length < 3 && (Be = 0), arguments.length < 4 && (Ue = oe.length); Be < Ue;){
                                var We = Be + Ue >>> 1;
                                Z(oe[We], we) > 0 ? Ue = We : Be = We + 1;
                            }
                            return Be;
                        }
                    };
                }
                var x = v(f);
                e.bisectLeft = x.left, e.bisect = e.bisectRight = x.right, e.bisector = function(Z) {
                    return v(Z.length === 1 ? function(oe, we) {
                        return f(Z(oe), we);
                    } : Z);
                }, e.shuffle = function(Z, oe, we) {
                    (Be = arguments.length) < 3 && (we = Z.length, Be < 2 && (oe = 0));
                    for(var Be = we - oe, Ue, We; Be;)We = Math.random() * Be-- | 0, Ue = Z[Be + oe], Z[Be + oe] = Z[We + oe], Z[We + oe] = Ue;
                    return Z;
                }, e.permute = function(Z, oe) {
                    for(var we = oe.length, Be = new Array(we); we--;)Be[we] = Z[oe[we]];
                    return Be;
                }, e.pairs = function(Z) {
                    for(var oe = 0, we = Z.length - 1, Be, Ue = Z[0], We = new Array(we < 0 ? 0 : we); oe < we;)We[oe] = [
                        Be = Ue,
                        Ue = Z[++oe]
                    ];
                    return We;
                }, e.transpose = function(Z) {
                    if (!(We = Z.length)) return [];
                    for(var oe = -1, we = e.min(Z, b), Be = new Array(we); ++oe < we;)for(var Ue = -1, We, wt = Be[oe] = new Array(We); ++Ue < We;)wt[Ue] = Z[Ue][oe];
                    return Be;
                };
                function b(Z) {
                    return Z.length;
                }
                e.zip = function() {
                    return e.transpose(arguments);
                }, e.keys = function(Z) {
                    var oe = [];
                    for(var we in Z)oe.push(we);
                    return oe;
                }, e.values = function(Z) {
                    var oe = [];
                    for(var we in Z)oe.push(Z[we]);
                    return oe;
                }, e.entries = function(Z) {
                    var oe = [];
                    for(var we in Z)oe.push({
                        key: we,
                        value: Z[we]
                    });
                    return oe;
                }, e.merge = function(Z) {
                    for(var oe = Z.length, we, Be = -1, Ue = 0, We, wt; ++Be < oe;)Ue += Z[Be].length;
                    for(We = new Array(Ue); --oe >= 0;)for(wt = Z[oe], we = wt.length; --we >= 0;)We[--Ue] = wt[we];
                    return We;
                };
                var p = Math.abs;
                e.range = function(Z, oe, we) {
                    if (arguments.length < 3 && (we = 1, arguments.length < 2 && (oe = Z, Z = 0)), (oe - Z) / we === 1 / 0) throw new Error("infinite range");
                    var Be = [], Ue = E(p(we)), We = -1, wt;
                    if (Z *= Ue, oe *= Ue, we *= Ue, we < 0) for(; (wt = Z + we * ++We) > oe;)Be.push(wt / Ue);
                    else for(; (wt = Z + we * ++We) < oe;)Be.push(wt / Ue);
                    return Be;
                };
                function E(Z) {
                    for(var oe = 1; Z * oe % 1;)oe *= 10;
                    return oe;
                }
                function k(Z, oe) {
                    for(var we in oe)Object.defineProperty(Z.prototype, we, {
                        value: oe[we],
                        enumerable: !1
                    });
                }
                e.map = function(Z, oe) {
                    var we = new A;
                    if (Z instanceof A) Z.forEach(function(tt, zt) {
                        we.set(tt, zt);
                    });
                    else if (Array.isArray(Z)) {
                        var Be = -1, Ue = Z.length, We;
                        if (arguments.length === 1) for(; ++Be < Ue;)we.set(Be, Z[Be]);
                        else for(; ++Be < Ue;)we.set(oe.call(Z, We = Z[Be], Be), We);
                    } else for(var wt in Z)we.set(wt, Z[wt]);
                    return we;
                };
                function A() {
                    this._ = Object.create(null);
                }
                var L = "__proto__", _ = "\0";
                k(A, {
                    has: g,
                    get: function(Z) {
                        return this._[C(Z)];
                    },
                    set: function(Z, oe) {
                        return this._[C(Z)] = oe;
                    },
                    remove: P,
                    keys: T,
                    values: function() {
                        var Z = [];
                        for(var oe in this._)Z.push(this._[oe]);
                        return Z;
                    },
                    entries: function() {
                        var Z = [];
                        for(var oe in this._)Z.push({
                            key: M(oe),
                            value: this._[oe]
                        });
                        return Z;
                    },
                    size: F,
                    empty: q,
                    forEach: function(Z) {
                        for(var oe in this._)Z.call(this, M(oe), this._[oe]);
                    }
                });
                function C(Z) {
                    return (Z += "") === L || Z[0] === _ ? _ + Z : Z;
                }
                function M(Z) {
                    return (Z += "")[0] === _ ? Z.slice(1) : Z;
                }
                function g(Z) {
                    return C(Z) in this._;
                }
                function P(Z) {
                    return (Z = C(Z)) in this._ && delete this._[Z];
                }
                function T() {
                    var Z = [];
                    for(var oe in this._)Z.push(M(oe));
                    return Z;
                }
                function F() {
                    var Z = 0;
                    for(var oe in this._)++Z;
                    return Z;
                }
                function q() {
                    for(var Z in this._)return !1;
                    return !0;
                }
                e.nest = function() {
                    var Z = {}, oe = [], we = [], Be, Ue;
                    function We(tt, zt, or) {
                        if (or >= oe.length) return Ue ? Ue.call(Z, zt) : Be ? zt.sort(Be) : zt;
                        for(var lr = -1, Dr = zt.length, Ir = oe[or++], oi, ui, qr, Kr = new A, ii; ++lr < Dr;)(ii = Kr.get(oi = Ir(ui = zt[lr]))) ? ii.push(ui) : Kr.set(oi, [
                            ui
                        ]);
                        return tt ? (ui = tt(), qr = function(vi, ci) {
                            ui.set(vi, We(tt, ci, or));
                        }) : (ui = {}, qr = function(vi, ci) {
                            ui[vi] = We(tt, ci, or);
                        }), Kr.forEach(qr), ui;
                    }
                    function wt(tt, zt) {
                        if (zt >= oe.length) return tt;
                        var or = [], lr = we[zt++];
                        return tt.forEach(function(Dr, Ir) {
                            or.push({
                                key: Dr,
                                values: wt(Ir, zt)
                            });
                        }), lr ? or.sort(function(Dr, Ir) {
                            return lr(Dr.key, Ir.key);
                        }) : or;
                    }
                    return Z.map = function(tt, zt) {
                        return We(zt, tt, 0);
                    }, Z.entries = function(tt) {
                        return wt(We(e.map, tt, 0), 0);
                    }, Z.key = function(tt) {
                        return oe.push(tt), Z;
                    }, Z.sortKeys = function(tt) {
                        return we[oe.length - 1] = tt, Z;
                    }, Z.sortValues = function(tt) {
                        return Be = tt, Z;
                    }, Z.rollup = function(tt) {
                        return Ue = tt, Z;
                    }, Z;
                }, e.set = function(Z) {
                    var oe = new V;
                    if (Z) for(var we = 0, Be = Z.length; we < Be; ++we)oe.add(Z[we]);
                    return oe;
                };
                function V() {
                    this._ = Object.create(null);
                }
                k(V, {
                    has: g,
                    add: function(Z) {
                        return this._[C(Z += "")] = !0, Z;
                    },
                    remove: P,
                    values: T,
                    size: F,
                    empty: q,
                    forEach: function(Z) {
                        for(var oe in this._)Z.call(this, M(oe));
                    }
                }), e.behavior = {};
                function H(Z) {
                    return Z;
                }
                e.rebind = function(Z, oe) {
                    for(var we = 1, Be = arguments.length, Ue; ++we < Be;)Z[Ue = arguments[we]] = X(Z, oe, oe[Ue]);
                    return Z;
                };
                function X(Z, oe, we) {
                    return function() {
                        var Be = we.apply(oe, arguments);
                        return Be === oe ? Z : Be;
                    };
                }
                function G(Z, oe) {
                    if (oe in Z) return oe;
                    oe = oe.charAt(0).toUpperCase() + oe.slice(1);
                    for(var we = 0, Be = N.length; we < Be; ++we){
                        var Ue = N[we] + oe;
                        if (Ue in Z) return Ue;
                    }
                }
                var N = [
                    "webkit",
                    "ms",
                    "moz",
                    "Moz",
                    "o",
                    "O"
                ];
                function W() {}
                e.dispatch = function() {
                    for(var Z = new re, oe = -1, we = arguments.length; ++oe < we;)Z[arguments[oe]] = ae(Z);
                    return Z;
                };
                function re() {}
                re.prototype.on = function(Z, oe) {
                    var we = Z.indexOf("."), Be = "";
                    if (we >= 0 && (Be = Z.slice(we + 1), Z = Z.slice(0, we)), Z) return arguments.length < 2 ? this[Z].on(Be) : this[Z].on(Be, oe);
                    if (arguments.length === 2) {
                        if (oe == null) for(Z in this)this.hasOwnProperty(Z) && this[Z].on(Be, null);
                        return this;
                    }
                };
                function ae(Z) {
                    var oe = [], we = new A;
                    function Be() {
                        for(var Ue = oe, We = -1, wt = Ue.length, tt; ++We < wt;)(tt = Ue[We].on) && tt.apply(this, arguments);
                        return Z;
                    }
                    return Be.on = function(Ue, We) {
                        var wt = we.get(Ue), tt;
                        return arguments.length < 2 ? wt && wt.on : (wt && (wt.on = null, oe = oe.slice(0, tt = oe.indexOf(wt)).concat(oe.slice(tt + 1)), we.remove(Ue)), We && oe.push(we.set(Ue, {
                            on: We
                        })), Z);
                    }, Be;
                }
                e.event = null;
                function _e() {
                    e.event.preventDefault();
                }
                function Me() {
                    for(var Z = e.event, oe; oe = Z.sourceEvent;)Z = oe;
                    return Z;
                }
                function ke(Z) {
                    for(var oe = new re, we = 0, Be = arguments.length; ++we < Be;)oe[arguments[we]] = ae(oe);
                    return oe.of = function(Ue, We) {
                        return function(wt) {
                            try {
                                var tt = wt.sourceEvent = e.event;
                                wt.target = Z, e.event = wt, oe[wt.type].apply(Ue, We);
                            } finally{
                                e.event = tt;
                            }
                        };
                    }, oe;
                }
                e.requote = function(Z) {
                    return Z.replace(ge, "\\$&");
                };
                var ge = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g, ie = {}.__proto__ ? function(Z, oe) {
                    Z.__proto__ = oe;
                } : function(Z, oe) {
                    for(var we in oe)Z[we] = oe[we];
                };
                function Te(Z) {
                    return ie(Z, Ce), Z;
                }
                var Ee = function(Z, oe) {
                    return oe.querySelector(Z);
                }, Ae = function(Z, oe) {
                    return oe.querySelectorAll(Z);
                }, ze = function(Z, oe) {
                    var we = Z.matches || Z[G(Z, "matchesSelector")];
                    return ze = function(Be, Ue) {
                        return we.call(Be, Ue);
                    }, ze(Z, oe);
                };
                typeof Sizzle == "function" && (Ee = function(Z, oe) {
                    return Sizzle(Z, oe)[0] || null;
                }, Ae = Sizzle, ze = Sizzle.matchesSelector), e.selection = function() {
                    return e.select(n.documentElement);
                };
                var Ce = e.selection.prototype = [];
                Ce.select = function(Z) {
                    var oe = [], we, Be, Ue, We;
                    Z = me(Z);
                    for(var wt = -1, tt = this.length; ++wt < tt;){
                        oe.push(we = []), we.parentNode = (Ue = this[wt]).parentNode;
                        for(var zt = -1, or = Ue.length; ++zt < or;)(We = Ue[zt]) ? (we.push(Be = Z.call(We, We.__data__, zt, wt)), Be && "__data__" in We && (Be.__data__ = We.__data__)) : we.push(null);
                    }
                    return Te(oe);
                };
                function me(Z) {
                    return typeof Z == "function" ? Z : function() {
                        return Ee(Z, this);
                    };
                }
                Ce.selectAll = function(Z) {
                    var oe = [], we, Be;
                    Z = Re(Z);
                    for(var Ue = -1, We = this.length; ++Ue < We;)for(var wt = this[Ue], tt = -1, zt = wt.length; ++tt < zt;)(Be = wt[tt]) && (oe.push(we = r(Z.call(Be, Be.__data__, tt, Ue))), we.parentNode = Be);
                    return Te(oe);
                };
                function Re(Z) {
                    return typeof Z == "function" ? Z : function() {
                        return Ae(Z, this);
                    };
                }
                var ce = "http://www.w3.org/1999/xhtml", Ge = {
                    svg: "http://www.w3.org/2000/svg",
                    xhtml: ce,
                    xlink: "http://www.w3.org/1999/xlink",
                    xml: "http://www.w3.org/XML/1998/namespace",
                    xmlns: "http://www.w3.org/2000/xmlns/"
                };
                e.ns = {
                    prefix: Ge,
                    qualify: function(Z) {
                        var oe = Z.indexOf(":"), we = Z;
                        return oe >= 0 && (we = Z.slice(0, oe)) !== "xmlns" && (Z = Z.slice(oe + 1)), Ge.hasOwnProperty(we) ? {
                            space: Ge[we],
                            local: Z
                        } : Z;
                    }
                }, Ce.attr = function(Z, oe) {
                    if (arguments.length < 2) {
                        if (typeof Z == "string") {
                            var we = this.node();
                            return Z = e.ns.qualify(Z), Z.local ? we.getAttributeNS(Z.space, Z.local) : we.getAttribute(Z);
                        }
                        for(oe in Z)this.each(nt(oe, Z[oe]));
                        return this;
                    }
                    return this.each(nt(Z, oe));
                };
                function nt(Z, oe) {
                    Z = e.ns.qualify(Z);
                    function we() {
                        this.removeAttribute(Z);
                    }
                    function Be() {
                        this.removeAttributeNS(Z.space, Z.local);
                    }
                    function Ue() {
                        this.setAttribute(Z, oe);
                    }
                    function We() {
                        this.setAttributeNS(Z.space, Z.local, oe);
                    }
                    function wt() {
                        var zt = oe.apply(this, arguments);
                        zt == null ? this.removeAttribute(Z) : this.setAttribute(Z, zt);
                    }
                    function tt() {
                        var zt = oe.apply(this, arguments);
                        zt == null ? this.removeAttributeNS(Z.space, Z.local) : this.setAttributeNS(Z.space, Z.local, zt);
                    }
                    return oe == null ? Z.local ? Be : we : typeof oe == "function" ? Z.local ? tt : wt : Z.local ? We : Ue;
                }
                function ct(Z) {
                    return Z.trim().replace(/\s+/g, " ");
                }
                Ce.classed = function(Z, oe) {
                    if (arguments.length < 2) {
                        if (typeof Z == "string") {
                            var we = this.node(), Be = (Z = rt(Z)).length, Ue = -1;
                            if (oe = we.classList) {
                                for(; ++Ue < Be;)if (!oe.contains(Z[Ue])) return !1;
                            } else for(oe = we.getAttribute("class"); ++Ue < Be;)if (!qt(Z[Ue]).test(oe)) return !1;
                            return !0;
                        }
                        for(oe in Z)this.each(ot(oe, Z[oe]));
                        return this;
                    }
                    return this.each(ot(Z, oe));
                };
                function qt(Z) {
                    return new RegExp("(?:^|\\s+)" + e.requote(Z) + "(?:\\s+|$)", "g");
                }
                function rt(Z) {
                    return (Z + "").trim().split(/^|\s+/);
                }
                function ot(Z, oe) {
                    Z = rt(Z).map(Rt);
                    var we = Z.length;
                    function Be() {
                        for(var We = -1; ++We < we;)Z[We](this, oe);
                    }
                    function Ue() {
                        for(var We = -1, wt = oe.apply(this, arguments); ++We < we;)Z[We](this, wt);
                    }
                    return typeof oe == "function" ? Ue : Be;
                }
                function Rt(Z) {
                    var oe = qt(Z);
                    return function(we, Be) {
                        if (Ue = we.classList) return Be ? Ue.add(Z) : Ue.remove(Z);
                        var Ue = we.getAttribute("class") || "";
                        Be ? (oe.lastIndex = 0, oe.test(Ue) || we.setAttribute("class", ct(Ue + " " + Z))) : we.setAttribute("class", ct(Ue.replace(oe, " ")));
                    };
                }
                Ce.style = function(Z, oe, we) {
                    var Be = arguments.length;
                    if (Be < 3) {
                        if (typeof Z != "string") {
                            Be < 2 && (oe = "");
                            for(we in Z)this.each(kt(we, Z[we], oe));
                            return this;
                        }
                        if (Be < 2) {
                            var Ue = this.node();
                            return a(Ue).getComputedStyle(Ue, null).getPropertyValue(Z);
                        }
                        we = "";
                    }
                    return this.each(kt(Z, oe, we));
                };
                function kt(Z, oe, we) {
                    function Be() {
                        this.style.removeProperty(Z);
                    }
                    function Ue() {
                        this.style.setProperty(Z, oe, we);
                    }
                    function We() {
                        var wt = oe.apply(this, arguments);
                        wt == null ? this.style.removeProperty(Z) : this.style.setProperty(Z, wt, we);
                    }
                    return oe == null ? Be : typeof oe == "function" ? We : Ue;
                }
                Ce.property = function(Z, oe) {
                    if (arguments.length < 2) {
                        if (typeof Z == "string") return this.node()[Z];
                        for(oe in Z)this.each(Ct(oe, Z[oe]));
                        return this;
                    }
                    return this.each(Ct(Z, oe));
                };
                function Ct(Z, oe) {
                    function we() {
                        delete this[Z];
                    }
                    function Be() {
                        this[Z] = oe;
                    }
                    function Ue() {
                        var We = oe.apply(this, arguments);
                        We == null ? delete this[Z] : this[Z] = We;
                    }
                    return oe == null ? we : typeof oe == "function" ? Ue : Be;
                }
                Ce.text = function(Z) {
                    return arguments.length ? this.each(typeof Z == "function" ? function() {
                        var oe = Z.apply(this, arguments);
                        this.textContent = oe == null ? "" : oe;
                    } : Z == null ? function() {
                        this.textContent = "";
                    } : function() {
                        this.textContent = Z;
                    }) : this.node().textContent;
                }, Ce.html = function(Z) {
                    return arguments.length ? this.each(typeof Z == "function" ? function() {
                        var oe = Z.apply(this, arguments);
                        this.innerHTML = oe == null ? "" : oe;
                    } : Z == null ? function() {
                        this.innerHTML = "";
                    } : function() {
                        this.innerHTML = Z;
                    }) : this.node().innerHTML;
                }, Ce.append = function(Z) {
                    return Z = Yt(Z), this.select(function() {
                        return this.appendChild(Z.apply(this, arguments));
                    });
                };
                function Yt(Z) {
                    function oe() {
                        var Be = this.ownerDocument, Ue = this.namespaceURI;
                        return Ue === ce && Be.documentElement.namespaceURI === ce ? Be.createElement(Z) : Be.createElementNS(Ue, Z);
                    }
                    function we() {
                        return this.ownerDocument.createElementNS(Z.space, Z.local);
                    }
                    return typeof Z == "function" ? Z : (Z = e.ns.qualify(Z)).local ? we : oe;
                }
                Ce.insert = function(Z, oe) {
                    return Z = Yt(Z), oe = me(oe), this.select(function() {
                        return this.insertBefore(Z.apply(this, arguments), oe.apply(this, arguments) || null);
                    });
                }, Ce.remove = function() {
                    return this.each(xr);
                };
                function xr() {
                    var Z = this.parentNode;
                    Z && Z.removeChild(this);
                }
                Ce.data = function(Z, oe) {
                    var we = -1, Be = this.length, Ue, We;
                    if (!arguments.length) {
                        for(Z = new Array(Be = (Ue = this[0]).length); ++we < Be;)(We = Ue[we]) && (Z[we] = We.__data__);
                        return Z;
                    }
                    function wt(lr, Dr) {
                        var Ir, oi = lr.length, ui = Dr.length, qr = Math.min(oi, ui), Kr = new Array(ui), ii = new Array(ui), vi = new Array(oi), ci, Jr;
                        if (oe) {
                            var un = new A, dn = new Array(oi), En;
                            for(Ir = -1; ++Ir < oi;)(ci = lr[Ir]) && (un.has(En = oe.call(ci, ci.__data__, Ir)) ? vi[Ir] = ci : un.set(En, ci), dn[Ir] = En);
                            for(Ir = -1; ++Ir < ui;)(ci = un.get(En = oe.call(Dr, Jr = Dr[Ir], Ir))) ? ci !== !0 && (Kr[Ir] = ci, ci.__data__ = Jr) : ii[Ir] = er(Jr), un.set(En, !0);
                            for(Ir = -1; ++Ir < oi;)Ir in dn && un.get(dn[Ir]) !== !0 && (vi[Ir] = lr[Ir]);
                        } else {
                            for(Ir = -1; ++Ir < qr;)ci = lr[Ir], Jr = Dr[Ir], ci ? (ci.__data__ = Jr, Kr[Ir] = ci) : ii[Ir] = er(Jr);
                            for(; Ir < ui; ++Ir)ii[Ir] = er(Dr[Ir]);
                            for(; Ir < oi; ++Ir)vi[Ir] = lr[Ir];
                        }
                        ii.update = Kr, ii.parentNode = Kr.parentNode = vi.parentNode = lr.parentNode, tt.push(ii), zt.push(Kr), or.push(vi);
                    }
                    var tt = Lt([]), zt = Te([]), or = Te([]);
                    if (typeof Z == "function") for(; ++we < Be;)wt(Ue = this[we], Z.call(Ue, Ue.parentNode.__data__, we));
                    else for(; ++we < Be;)wt(Ue = this[we], Z);
                    return zt.enter = function() {
                        return tt;
                    }, zt.exit = function() {
                        return or;
                    }, zt;
                };
                function er(Z) {
                    return {
                        __data__: Z
                    };
                }
                Ce.datum = function(Z) {
                    return arguments.length ? this.property("__data__", Z) : this.property("__data__");
                }, Ce.filter = function(Z) {
                    var oe = [], we, Be, Ue;
                    typeof Z != "function" && (Z = Ke(Z));
                    for(var We = 0, wt = this.length; We < wt; We++){
                        oe.push(we = []), we.parentNode = (Be = this[We]).parentNode;
                        for(var tt = 0, zt = Be.length; tt < zt; tt++)(Ue = Be[tt]) && Z.call(Ue, Ue.__data__, tt, We) && we.push(Ue);
                    }
                    return Te(oe);
                };
                function Ke(Z) {
                    return function() {
                        return ze(this, Z);
                    };
                }
                Ce.order = function() {
                    for(var Z = -1, oe = this.length; ++Z < oe;)for(var we = this[Z], Be = we.length - 1, Ue = we[Be], We; --Be >= 0;)(We = we[Be]) && (Ue && Ue !== We.nextSibling && Ue.parentNode.insertBefore(We, Ue), Ue = We);
                    return this;
                }, Ce.sort = function(Z) {
                    Z = xt.apply(this, arguments);
                    for(var oe = -1, we = this.length; ++oe < we;)this[oe].sort(Z);
                    return this.order();
                };
                function xt(Z) {
                    return arguments.length || (Z = f), function(oe, we) {
                        return oe && we ? Z(oe.__data__, we.__data__) : !oe - !we;
                    };
                }
                Ce.each = function(Z) {
                    return bt(this, function(oe, we, Be) {
                        Z.call(oe, oe.__data__, we, Be);
                    });
                };
                function bt(Z, oe) {
                    for(var we = 0, Be = Z.length; we < Be; we++)for(var Ue = Z[we], We = 0, wt = Ue.length, tt; We < wt; We++)(tt = Ue[We]) && oe(tt, We, we);
                    return Z;
                }
                Ce.call = function(Z) {
                    var oe = r(arguments);
                    return Z.apply(oe[0] = this, oe), this;
                }, Ce.empty = function() {
                    return !this.node();
                }, Ce.node = function() {
                    for(var Z = 0, oe = this.length; Z < oe; Z++)for(var we = this[Z], Be = 0, Ue = we.length; Be < Ue; Be++){
                        var We = we[Be];
                        if (We) return We;
                    }
                    return null;
                }, Ce.size = function() {
                    var Z = 0;
                    return bt(this, function() {
                        ++Z;
                    }), Z;
                };
                function Lt(Z) {
                    return ie(Z, St), Z;
                }
                var St = [];
                e.selection.enter = Lt, e.selection.enter.prototype = St, St.append = Ce.append, St.empty = Ce.empty, St.node = Ce.node, St.call = Ce.call, St.size = Ce.size, St.select = function(Z) {
                    for(var oe = [], we, Be, Ue, We, wt, tt = -1, zt = this.length; ++tt < zt;){
                        Ue = (We = this[tt]).update, oe.push(we = []), we.parentNode = We.parentNode;
                        for(var or = -1, lr = We.length; ++or < lr;)(wt = We[or]) ? (we.push(Ue[or] = Be = Z.call(We.parentNode, wt.__data__, or, tt)), Be.__data__ = wt.__data__) : we.push(null);
                    }
                    return Te(oe);
                }, St.insert = function(Z, oe) {
                    return arguments.length < 2 && (oe = Et(this)), Ce.insert.call(this, Z, oe);
                };
                function Et(Z) {
                    var oe, we;
                    return function(Be, Ue, We) {
                        var wt = Z[We].update, tt = wt.length, zt;
                        for(We != we && (we = We, oe = 0), Ue >= oe && (oe = Ue + 1); !(zt = wt[oe]) && ++oe < tt;);
                        return zt;
                    };
                }
                e.select = function(Z) {
                    var oe;
                    return typeof Z == "string" ? (oe = [
                        Ee(Z, n)
                    ], oe.parentNode = n.documentElement) : (oe = [
                        Z
                    ], oe.parentNode = i(Z)), Te([
                        oe
                    ]);
                }, e.selectAll = function(Z) {
                    var oe;
                    return typeof Z == "string" ? (oe = r(Ae(Z, n)), oe.parentNode = n.documentElement) : (oe = r(Z), oe.parentNode = null), Te([
                        oe
                    ]);
                }, Ce.on = function(Z, oe, we) {
                    var Be = arguments.length;
                    if (Be < 3) {
                        if (typeof Z != "string") {
                            Be < 2 && (oe = !1);
                            for(we in Z)this.each(dt(we, Z[we], oe));
                            return this;
                        }
                        if (Be < 2) return (Be = this.node()["__on" + Z]) && Be._;
                        we = !1;
                    }
                    return this.each(dt(Z, oe, we));
                };
                function dt(Z, oe, we) {
                    var Be = "__on" + Z, Ue = Z.indexOf("."), We = $t;
                    Ue > 0 && (Z = Z.slice(0, Ue));
                    var wt = Ht.get(Z);
                    wt && (Z = wt, We = fr);
                    function tt() {
                        var lr = this[Be];
                        lr && (this.removeEventListener(Z, lr, lr.$), delete this[Be]);
                    }
                    function zt() {
                        var lr = We(oe, r(arguments));
                        tt.call(this), this.addEventListener(Z, this[Be] = lr, lr.$ = we), lr._ = oe;
                    }
                    function or() {
                        var lr = new RegExp("^__on([^.]+)" + e.requote(Z) + "$"), Dr;
                        for(var Ir in this)if (Dr = Ir.match(lr)) {
                            var oi = this[Ir];
                            this.removeEventListener(Dr[1], oi, oi.$), delete this[Ir];
                        }
                    }
                    return Ue ? oe ? zt : tt : oe ? W : or;
                }
                var Ht = e.map({
                    mouseenter: "mouseover",
                    mouseleave: "mouseout"
                });
                n && Ht.forEach(function(Z) {
                    "on" + Z in n && Ht.remove(Z);
                });
                function $t(Z, oe) {
                    return function(we) {
                        var Be = e.event;
                        e.event = we, oe[0] = this.__data__;
                        try {
                            Z.apply(this, oe);
                        } finally{
                            e.event = Be;
                        }
                    };
                }
                function fr(Z, oe) {
                    var we = $t(Z, oe);
                    return function(Be) {
                        var Ue = this, We = Be.relatedTarget;
                        (!We || We !== Ue && !(We.compareDocumentPosition(Ue) & 8)) && we.call(Ue, Be);
                    };
                }
                var _r, Br = 0;
                function Or(Z) {
                    var oe = ".dragsuppress-" + ++Br, we = "click" + oe, Be = e.select(a(Z)).on("touchmove" + oe, _e).on("dragstart" + oe, _e).on("selectstart" + oe, _e);
                    if (_r == null && (_r = "onselectstart" in Z ? !1 : G(Z.style, "userSelect")), _r) {
                        var Ue = i(Z).style, We = Ue[_r];
                        Ue[_r] = "none";
                    }
                    return function(wt) {
                        if (Be.on(oe, null), _r && (Ue[_r] = We), wt) {
                            var tt = function() {
                                Be.on(we, null);
                            };
                            Be.on(we, function() {
                                _e(), tt();
                            }, !0), setTimeout(tt, 0);
                        }
                    };
                }
                e.mouse = function(Z) {
                    return ut(Z, Me());
                };
                var Nr = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
                function ut(Z, oe) {
                    oe.changedTouches && (oe = oe.changedTouches[0]);
                    var we = Z.ownerSVGElement || Z;
                    if (we.createSVGPoint) {
                        var Be = we.createSVGPoint();
                        if (Nr < 0) {
                            var Ue = a(Z);
                            if (Ue.scrollX || Ue.scrollY) {
                                we = e.select("body").append("svg").style({
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    margin: 0,
                                    padding: 0,
                                    border: "none"
                                }, "important");
                                var We = we[0][0].getScreenCTM();
                                Nr = !(We.f || We.e), we.remove();
                            }
                        }
                        return Nr ? (Be.x = oe.pageX, Be.y = oe.pageY) : (Be.x = oe.clientX, Be.y = oe.clientY), Be = Be.matrixTransform(Z.getScreenCTM().inverse()), [
                            Be.x,
                            Be.y
                        ];
                    }
                    var wt = Z.getBoundingClientRect();
                    return [
                        oe.clientX - wt.left - Z.clientLeft,
                        oe.clientY - wt.top - Z.clientTop
                    ];
                }
                e.touch = function(Z, oe, we) {
                    if (arguments.length < 3 && (we = oe, oe = Me().changedTouches), oe) {
                        for(var Be = 0, Ue = oe.length, We; Be < Ue; ++Be)if ((We = oe[Be]).identifier === we) return ut(Z, We);
                    }
                }, e.behavior.drag = function() {
                    var Z = ke(Ue, "drag", "dragstart", "dragend"), oe = null, we = We(W, e.mouse, a, "mousemove", "mouseup"), Be = We(Ne, e.touch, H, "touchmove", "touchend");
                    function Ue() {
                        this.on("mousedown.drag", we).on("touchstart.drag", Be);
                    }
                    function We(wt, tt, zt, or, lr) {
                        return function() {
                            var Dr = this, Ir = e.event.target.correspondingElement || e.event.target, oi = Dr.parentNode, ui = Z.of(Dr, arguments), qr = 0, Kr = wt(), ii = ".drag" + (Kr == null ? "" : "-" + Kr), vi, ci = e.select(zt(Ir)).on(or + ii, dn).on(lr + ii, En), Jr = Or(Ir), un = tt(oi, Kr);
                            oe ? (vi = oe.apply(Dr, arguments), vi = [
                                vi.x - un[0],
                                vi.y - un[1]
                            ]) : vi = [
                                0,
                                0
                            ], ui({
                                type: "dragstart"
                            });
                            function dn() {
                                var Nn = tt(oi, Kr), ga, ya;
                                Nn && (ga = Nn[0] - un[0], ya = Nn[1] - un[1], qr |= ga | ya, un = Nn, ui({
                                    type: "drag",
                                    x: Nn[0] + vi[0],
                                    y: Nn[1] + vi[1],
                                    dx: ga,
                                    dy: ya
                                }));
                            }
                            function En() {
                                tt(oi, Kr) && (ci.on(or + ii, null).on(lr + ii, null), Jr(qr), ui({
                                    type: "dragend"
                                }));
                            }
                        };
                    }
                    return Ue.origin = function(wt) {
                        return arguments.length ? (oe = wt, Ue) : oe;
                    }, e.rebind(Ue, Z, "on");
                };
                function Ne() {
                    return e.event.changedTouches[0].identifier;
                }
                e.touches = function(Z, oe) {
                    return arguments.length < 2 && (oe = Me().touches), oe ? r(oe).map(function(we) {
                        var Be = ut(Z, we);
                        return Be.identifier = we.identifier, Be;
                    }) : [];
                };
                var Ye = 1e-6, Ve = Ye * Ye, Xe = Math.PI, ht = 2 * Xe, Le = ht - Ye, xe = Xe / 2, Se = Xe / 180, lt = 180 / Xe;
                function Gt(Z) {
                    return Z > 0 ? 1 : Z < 0 ? -1 : 0;
                }
                function Vt(Z, oe, we) {
                    return (oe[0] - Z[0]) * (we[1] - Z[1]) - (oe[1] - Z[1]) * (we[0] - Z[0]);
                }
                function ar(Z) {
                    return Z > 1 ? 0 : Z < -1 ? Xe : Math.acos(Z);
                }
                function Qr(Z) {
                    return Z > 1 ? xe : Z < -1 ? -xe : Math.asin(Z);
                }
                function ai(Z) {
                    return ((Z = Math.exp(Z)) - 1 / Z) / 2;
                }
                function jr(Z) {
                    return ((Z = Math.exp(Z)) + 1 / Z) / 2;
                }
                function ri(Z) {
                    return ((Z = Math.exp(2 * Z)) - 1) / (Z + 1);
                }
                function bi(Z) {
                    return (Z = Math.sin(Z / 2)) * Z;
                }
                var nn = Math.SQRT2, Wi = 2, Ni = 4;
                e.interpolateZoom = function(Z, oe) {
                    var we = Z[0], Be = Z[1], Ue = Z[2], We = oe[0], wt = oe[1], tt = oe[2], zt = We - we, or = wt - Be, lr = zt * zt + or * or, Dr, Ir;
                    if (lr < Ve) Ir = Math.log(tt / Ue) / nn, Dr = function(vi) {
                        return [
                            we + vi * zt,
                            Be + vi * or,
                            Ue * Math.exp(nn * vi * Ir)
                        ];
                    };
                    else {
                        var oi = Math.sqrt(lr), ui = (tt * tt - Ue * Ue + Ni * lr) / (2 * Ue * Wi * oi), qr = (tt * tt - Ue * Ue - Ni * lr) / (2 * tt * Wi * oi), Kr = Math.log(Math.sqrt(ui * ui + 1) - ui), ii = Math.log(Math.sqrt(qr * qr + 1) - qr);
                        Ir = (ii - Kr) / nn, Dr = function(vi) {
                            var ci = vi * Ir, Jr = jr(Kr), un = Ue / (Wi * oi) * (Jr * ri(nn * ci + Kr) - ai(Kr));
                            return [
                                we + un * zt,
                                Be + un * or,
                                Ue * Jr / jr(nn * ci + Kr)
                            ];
                        };
                    }
                    return Dr.duration = Ir * 1e3, Dr;
                }, e.behavior.zoom = function() {
                    var Z = {
                        x: 0,
                        y: 0,
                        k: 1
                    }, oe, we, Be, Ue = [
                        960,
                        500
                    ], We = _n, wt = 250, tt = 0, zt = "mousedown.zoom", or = "mousemove.zoom", lr = "mouseup.zoom", Dr, Ir = "touchstart.zoom", oi, ui = ke(ci, "zoomstart", "zoom", "zoomend"), qr, Kr, ii, vi;
                    zn || (zn = "onwheel" in n ? ($i = function() {
                        return -e.event.deltaY * (e.event.deltaMode ? 120 : 1);
                    }, "wheel") : "onmousewheel" in n ? ($i = function() {
                        return e.event.wheelDelta;
                    }, "mousewheel") : ($i = function() {
                        return -e.event.detail;
                    }, "MozMousePixelScroll"));
                    function ci(pn) {
                        pn.on(zt, io).on(zn + ".zoom", _s).on("dblclick.zoom", Ns).on(Ir, Ss);
                    }
                    ci.event = function(pn) {
                        pn.each(function() {
                            var za = ui.of(this, arguments), Lo = Z;
                            Ro ? e.select(this).transition().each("start.zoom", function() {
                                Z = this.__chart__ || {
                                    x: 0,
                                    y: 0,
                                    k: 1
                                }, ya(za);
                            }).tween("zoom:zoom", function() {
                                var Fo = Ue[0], js = Ue[1], xl = we ? we[0] : Fo / 2, fu = we ? we[1] : js / 2, dl = e.interpolateZoom([
                                    (xl - Z.x) / Z.k,
                                    (fu - Z.y) / Z.k,
                                    Fo / Z.k
                                ], [
                                    (xl - Lo.x) / Lo.k,
                                    (fu - Lo.y) / Lo.k,
                                    Fo / Lo.k
                                ]);
                                return function(xc) {
                                    var At = dl(xc), Er = Fo / At[2];
                                    this.__chart__ = Z = {
                                        x: xl - At[0] * Er,
                                        y: fu - At[1] * Er,
                                        k: Er
                                    }, so(za);
                                };
                            }).each("interrupt.zoom", function() {
                                wa(za);
                            }).each("end.zoom", function() {
                                wa(za);
                            }) : (this.__chart__ = Z, ya(za), so(za), wa(za));
                        });
                    }, ci.translate = function(pn) {
                        return arguments.length ? (Z = {
                            x: +pn[0],
                            y: +pn[1],
                            k: Z.k
                        }, ga(), ci) : [
                            Z.x,
                            Z.y
                        ];
                    }, ci.scale = function(pn) {
                        return arguments.length ? (Z = {
                            x: Z.x,
                            y: Z.y,
                            k: null
                        }, dn(+pn), ga(), ci) : Z.k;
                    }, ci.scaleExtent = function(pn) {
                        return arguments.length ? (We = pn == null ? _n : [
                            +pn[0],
                            +pn[1]
                        ], ci) : We;
                    }, ci.center = function(pn) {
                        return arguments.length ? (Be = pn && [
                            +pn[0],
                            +pn[1]
                        ], ci) : Be;
                    }, ci.size = function(pn) {
                        return arguments.length ? (Ue = pn && [
                            +pn[0],
                            +pn[1]
                        ], ci) : Ue;
                    }, ci.duration = function(pn) {
                        return arguments.length ? (wt = +pn, ci) : wt;
                    }, ci.x = function(pn) {
                        return arguments.length ? (Kr = pn, qr = pn.copy(), Z = {
                            x: 0,
                            y: 0,
                            k: 1
                        }, ci) : Kr;
                    }, ci.y = function(pn) {
                        return arguments.length ? (vi = pn, ii = pn.copy(), Z = {
                            x: 0,
                            y: 0,
                            k: 1
                        }, ci) : vi;
                    };
                    function Jr(pn) {
                        return [
                            (pn[0] - Z.x) / Z.k,
                            (pn[1] - Z.y) / Z.k
                        ];
                    }
                    function un(pn) {
                        return [
                            pn[0] * Z.k + Z.x,
                            pn[1] * Z.k + Z.y
                        ];
                    }
                    function dn(pn) {
                        Z.k = Math.max(We[0], Math.min(We[1], pn));
                    }
                    function En(pn, za) {
                        za = un(za), Z.x += pn[0] - za[0], Z.y += pn[1] - za[1];
                    }
                    function Nn(pn, za, Lo, Fo) {
                        pn.__chart__ = {
                            x: Z.x,
                            y: Z.y,
                            k: Z.k
                        }, dn(Math.pow(2, Fo)), En(we = za, Lo), pn = e.select(pn), wt > 0 && (pn = pn.transition().duration(wt)), pn.call(ci.event);
                    }
                    function ga() {
                        Kr && Kr.domain(qr.range().map(function(pn) {
                            return (pn - Z.x) / Z.k;
                        }).map(qr.invert)), vi && vi.domain(ii.range().map(function(pn) {
                            return (pn - Z.y) / Z.k;
                        }).map(ii.invert));
                    }
                    function ya(pn) {
                        tt++ || pn({
                            type: "zoomstart"
                        });
                    }
                    function so(pn) {
                        ga(), pn({
                            type: "zoom",
                            scale: Z.k,
                            translate: [
                                Z.x,
                                Z.y
                            ]
                        });
                    }
                    function wa(pn) {
                        --tt || (pn({
                            type: "zoomend"
                        }), we = null);
                    }
                    function io() {
                        var pn = this, za = ui.of(pn, arguments), Lo = 0, Fo = e.select(a(pn)).on(or, fu).on(lr, dl), js = Jr(e.mouse(pn)), xl = Or(pn);
                        ea.call(pn), ya(za);
                        function fu() {
                            Lo = 1, En(e.mouse(pn), js), so(za);
                        }
                        function dl() {
                            Fo.on(or, null).on(lr, null), xl(Lo), wa(za);
                        }
                    }
                    function Ss() {
                        var pn = this, za = ui.of(pn, arguments), Lo = {}, Fo = 0, js, xl = ".zoom-" + e.event.changedTouches[0].identifier, fu = "touchmove" + xl, dl = "touchend" + xl, xc = [], At = e.select(pn), Er = Or(pn);
                        wi(), ya(za), At.on(zt, null).on(Ir, wi);
                        function Wr() {
                            var Bi = e.touches(pn);
                            return js = Z.k, Bi.forEach(function(cn) {
                                cn.identifier in Lo && (Lo[cn.identifier] = Jr(cn));
                            }), Bi;
                        }
                        function wi() {
                            var Bi = e.event.target;
                            e.select(Bi).on(fu, Ui).on(dl, Oi), xc.push(Bi);
                            for(var cn = e.event.changedTouches, On = 0, Bn = cn.length; On < Bn; ++On)Lo[cn[On].identifier] = null;
                            var yn = Wr(), to = Date.now();
                            if (yn.length === 1) {
                                if (to - oi < 500) {
                                    var Rn = yn[0];
                                    Nn(pn, Rn, Lo[Rn.identifier], Math.floor(Math.log(Z.k) / Math.LN2) + 1), _e();
                                }
                                oi = to;
                            } else if (yn.length > 1) {
                                var Rn = yn[0], Dn = yn[1], fn = Rn[0] - Dn[0], Ai = Rn[1] - Dn[1];
                                Fo = fn * fn + Ai * Ai;
                            }
                        }
                        function Ui() {
                            var Bi = e.touches(pn), cn, On, Bn, yn;
                            ea.call(pn);
                            for(var to = 0, Rn = Bi.length; to < Rn; ++to, yn = null)if (Bn = Bi[to], yn = Lo[Bn.identifier]) {
                                if (On) break;
                                cn = Bn, On = yn;
                            }
                            if (yn) {
                                var Dn = (Dn = Bn[0] - cn[0]) * Dn + (Dn = Bn[1] - cn[1]) * Dn, fn = Fo && Math.sqrt(Dn / Fo);
                                cn = [
                                    (cn[0] + Bn[0]) / 2,
                                    (cn[1] + Bn[1]) / 2
                                ], On = [
                                    (On[0] + yn[0]) / 2,
                                    (On[1] + yn[1]) / 2
                                ], dn(fn * js);
                            }
                            oi = null, En(cn, On), so(za);
                        }
                        function Oi() {
                            if (e.event.touches.length) {
                                for(var Bi = e.event.changedTouches, cn = 0, On = Bi.length; cn < On; ++cn)delete Lo[Bi[cn].identifier];
                                for(var Bn in Lo)return void Wr();
                            }
                            e.selectAll(xc).on(xl, null), At.on(zt, io).on(Ir, Ss), Er(), wa(za);
                        }
                    }
                    function _s() {
                        var pn = ui.of(this, arguments);
                        Dr ? clearTimeout(Dr) : (ea.call(this), oe = Jr(we = Be || e.mouse(this)), ya(pn)), Dr = setTimeout(function() {
                            Dr = null, wa(pn);
                        }, 50), _e(), dn(Math.pow(2, $i() * .002) * Z.k), En(we, oe), so(pn);
                    }
                    function Ns() {
                        var pn = e.mouse(this), za = Math.log(Z.k) / Math.LN2;
                        Nn(this, pn, Jr(pn), e.event.shiftKey ? Math.ceil(za) - 1 : Math.floor(za) + 1);
                    }
                    return e.rebind(ci, ui, "on");
                };
                var _n = [
                    0,
                    1 / 0
                ], $i, zn;
                e.color = Wn;
                function Wn() {}
                Wn.prototype.toString = function() {
                    return this.rgb() + "";
                }, e.hsl = It;
                function It(Z, oe, we) {
                    return this instanceof It ? (this.h = +Z, this.s = +oe, void (this.l = +we)) : arguments.length < 2 ? Z instanceof It ? new It(Z.h, Z.s, Z.l) : Ha("" + Z, oo, It) : new It(Z, oe, we);
                }
                var ft = It.prototype = new Wn;
                ft.brighter = function(Z) {
                    return Z = Math.pow(.7, arguments.length ? Z : 1), new It(this.h, this.s, this.l / Z);
                }, ft.darker = function(Z) {
                    return Z = Math.pow(.7, arguments.length ? Z : 1), new It(this.h, this.s, Z * this.l);
                }, ft.rgb = function() {
                    return jt(this.h, this.s, this.l);
                };
                function jt(Z, oe, we) {
                    var Be, Ue;
                    Z = isNaN(Z) ? 0 : (Z %= 360) < 0 ? Z + 360 : Z, oe = isNaN(oe) || oe < 0 ? 0 : oe > 1 ? 1 : oe, we = we < 0 ? 0 : we > 1 ? 1 : we, Ue = we <= .5 ? we * (1 + oe) : we + oe - we * oe, Be = 2 * we - Ue;
                    function We(tt) {
                        return tt > 360 ? tt -= 360 : tt < 0 && (tt += 360), tt < 60 ? Be + (Ue - Be) * tt / 60 : tt < 180 ? Ue : tt < 240 ? Be + (Ue - Be) * (240 - tt) / 60 : Be;
                    }
                    function wt(tt) {
                        return Math.round(We(tt) * 255);
                    }
                    return new Fa(wt(Z + 120), wt(Z), wt(Z - 120));
                }
                e.hcl = Zt;
                function Zt(Z, oe, we) {
                    return this instanceof Zt ? (this.h = +Z, this.c = +oe, void (this.l = +we)) : arguments.length < 2 ? Z instanceof Zt ? new Zt(Z.h, Z.c, Z.l) : Z instanceof Zr ? Ki(Z.l, Z.a, Z.b) : Ki((Z = xn((Z = e.rgb(Z)).r, Z.g, Z.b)).l, Z.a, Z.b) : new Zt(Z, oe, we);
                }
                var yr = Zt.prototype = new Wn;
                yr.brighter = function(Z) {
                    return new Zt(this.h, this.c, Math.min(100, this.l + Vr * (arguments.length ? Z : 1)));
                }, yr.darker = function(Z) {
                    return new Zt(this.h, this.c, Math.max(0, this.l - Vr * (arguments.length ? Z : 1)));
                }, yr.rgb = function() {
                    return Fr(this.h, this.c, this.l).rgb();
                };
                function Fr(Z, oe, we) {
                    return isNaN(Z) && (Z = 0), isNaN(oe) && (oe = 0), new Zr(we, Math.cos(Z *= Se) * oe, Math.sin(Z) * oe);
                }
                e.lab = Zr;
                function Zr(Z, oe, we) {
                    return this instanceof Zr ? (this.l = +Z, this.a = +oe, void (this.b = +we)) : arguments.length < 2 ? Z instanceof Zr ? new Zr(Z.l, Z.a, Z.b) : Z instanceof Zt ? Fr(Z.h, Z.c, Z.l) : xn((Z = Fa(Z)).r, Z.g, Z.b) : new Zr(Z, oe, we);
                }
                var Vr = 18, gi = .95047, Si = 1, Mi = 1.08883, Pi = Zr.prototype = new Wn;
                Pi.brighter = function(Z) {
                    return new Zr(Math.min(100, this.l + Vr * (arguments.length ? Z : 1)), this.a, this.b);
                }, Pi.darker = function(Z) {
                    return new Zr(Math.max(0, this.l - Vr * (arguments.length ? Z : 1)), this.a, this.b);
                }, Pi.rgb = function() {
                    return Gi(this.l, this.a, this.b);
                };
                function Gi(Z, oe, we) {
                    var Be = (Z + 16) / 116, Ue = Be + oe / 500, We = Be - we / 200;
                    return Ue = ka(Ue) * gi, Be = ka(Be) * Si, We = ka(We) * Mi, new Fa(la(3.2404542 * Ue - 1.5371385 * Be - .4985314 * We), la(-0.969266 * Ue + 1.8760108 * Be + .041556 * We), la(.0556434 * Ue - .2040259 * Be + 1.0572252 * We));
                }
                function Ki(Z, oe, we) {
                    return Z > 0 ? new Zt(Math.atan2(we, oe) * lt, Math.sqrt(oe * oe + we * we), Z) : new Zt(NaN, NaN, Z);
                }
                function ka(Z) {
                    return Z > .206893034 ? Z * Z * Z : (Z - 4 / 29) / 7.787037;
                }
                function jn(Z) {
                    return Z > .008856 ? Math.pow(Z, 1 / 3) : 7.787037 * Z + 4 / 29;
                }
                function la(Z) {
                    return Math.round(255 * (Z <= .00304 ? 12.92 * Z : 1.055 * Math.pow(Z, 1 / 2.4) - .055));
                }
                e.rgb = Fa;
                function Fa(Z, oe, we) {
                    return this instanceof Fa ? (this.r = ~~Z, this.g = ~~oe, void (this.b = ~~we)) : arguments.length < 2 ? Z instanceof Fa ? new Fa(Z.r, Z.g, Z.b) : Ha("" + Z, Fa, jt) : new Fa(Z, oe, we);
                }
                function Ra(Z) {
                    return new Fa(Z >> 16, Z >> 8 & 255, Z & 255);
                }
                function jo(Z) {
                    return Ra(Z) + "";
                }
                var oa = Fa.prototype = new Wn;
                oa.brighter = function(Z) {
                    Z = Math.pow(.7, arguments.length ? Z : 1);
                    var oe = this.r, we = this.g, Be = this.b, Ue = 30;
                    return !oe && !we && !Be ? new Fa(Ue, Ue, Ue) : (oe && oe < Ue && (oe = Ue), we && we < Ue && (we = Ue), Be && Be < Ue && (Be = Ue), new Fa(Math.min(255, oe / Z), Math.min(255, we / Z), Math.min(255, Be / Z)));
                }, oa.darker = function(Z) {
                    return Z = Math.pow(.7, arguments.length ? Z : 1), new Fa(Z * this.r, Z * this.g, Z * this.b);
                }, oa.hsl = function() {
                    return oo(this.r, this.g, this.b);
                }, oa.toString = function() {
                    return "#" + Sn(this.r) + Sn(this.g) + Sn(this.b);
                };
                function Sn(Z) {
                    return Z < 16 ? "0" + Math.max(0, Z).toString(16) : Math.min(255, Z).toString(16);
                }
                function Ha(Z, oe, we) {
                    var Be = 0, Ue = 0, We = 0, wt, tt, zt;
                    if (wt = /([a-z]+)\((.*)\)/.exec(Z = Z.toLowerCase()), wt) switch(tt = wt[2].split(","), wt[1]){
                        case "hsl":
                            return we(parseFloat(tt[0]), parseFloat(tt[1]) / 100, parseFloat(tt[2]) / 100);
                        case "rgb":
                            return oe(br(tt[0]), br(tt[1]), br(tt[2]));
                    }
                    return (zt = Hr.get(Z)) ? oe(zt.r, zt.g, zt.b) : (Z != null && Z.charAt(0) === "#" && !isNaN(zt = parseInt(Z.slice(1), 16)) && (Z.length === 4 ? (Be = (zt & 3840) >> 4, Be = Be >> 4 | Be, Ue = zt & 240, Ue = Ue >> 4 | Ue, We = zt & 15, We = We << 4 | We) : Z.length === 7 && (Be = (zt & 16711680) >> 16, Ue = (zt & 65280) >> 8, We = zt & 255)), oe(Be, Ue, We));
                }
                function oo(Z, oe, we) {
                    var Be = Math.min(Z /= 255, oe /= 255, we /= 255), Ue = Math.max(Z, oe, we), We = Ue - Be, wt, tt, zt = (Ue + Be) / 2;
                    return We ? (tt = zt < .5 ? We / (Ue + Be) : We / (2 - Ue - Be), Z == Ue ? wt = (oe - we) / We + (oe < we ? 6 : 0) : oe == Ue ? wt = (we - Z) / We + 2 : wt = (Z - oe) / We + 4, wt *= 60) : (wt = NaN, tt = zt > 0 && zt < 1 ? 0 : wt), new It(wt, tt, zt);
                }
                function xn(Z, oe, we) {
                    Z = _t(Z), oe = _t(oe), we = _t(we);
                    var Be = jn((.4124564 * Z + .3575761 * oe + .1804375 * we) / gi), Ue = jn((.2126729 * Z + .7151522 * oe + .072175 * we) / Si), We = jn((.0193339 * Z + .119192 * oe + .9503041 * we) / Mi);
                    return Zr(116 * Ue - 16, 500 * (Be - Ue), 200 * (Ue - We));
                }
                function _t(Z) {
                    return (Z /= 255) <= .04045 ? Z / 12.92 : Math.pow((Z + .055) / 1.055, 2.4);
                }
                function br(Z) {
                    var oe = parseFloat(Z);
                    return Z.charAt(Z.length - 1) === "%" ? Math.round(oe * 2.55) : oe;
                }
                var Hr = e.map({
                    aliceblue: 15792383,
                    antiquewhite: 16444375,
                    aqua: 65535,
                    aquamarine: 8388564,
                    azure: 15794175,
                    beige: 16119260,
                    bisque: 16770244,
                    black: 0,
                    blanchedalmond: 16772045,
                    blue: 255,
                    blueviolet: 9055202,
                    brown: 10824234,
                    burlywood: 14596231,
                    cadetblue: 6266528,
                    chartreuse: 8388352,
                    chocolate: 13789470,
                    coral: 16744272,
                    cornflowerblue: 6591981,
                    cornsilk: 16775388,
                    crimson: 14423100,
                    cyan: 65535,
                    darkblue: 139,
                    darkcyan: 35723,
                    darkgoldenrod: 12092939,
                    darkgray: 11119017,
                    darkgreen: 25600,
                    darkgrey: 11119017,
                    darkkhaki: 12433259,
                    darkmagenta: 9109643,
                    darkolivegreen: 5597999,
                    darkorange: 16747520,
                    darkorchid: 10040012,
                    darkred: 9109504,
                    darksalmon: 15308410,
                    darkseagreen: 9419919,
                    darkslateblue: 4734347,
                    darkslategray: 3100495,
                    darkslategrey: 3100495,
                    darkturquoise: 52945,
                    darkviolet: 9699539,
                    deeppink: 16716947,
                    deepskyblue: 49151,
                    dimgray: 6908265,
                    dimgrey: 6908265,
                    dodgerblue: 2003199,
                    firebrick: 11674146,
                    floralwhite: 16775920,
                    forestgreen: 2263842,
                    fuchsia: 16711935,
                    gainsboro: 14474460,
                    ghostwhite: 16316671,
                    gold: 16766720,
                    goldenrod: 14329120,
                    gray: 8421504,
                    green: 32768,
                    greenyellow: 11403055,
                    grey: 8421504,
                    honeydew: 15794160,
                    hotpink: 16738740,
                    indianred: 13458524,
                    indigo: 4915330,
                    ivory: 16777200,
                    khaki: 15787660,
                    lavender: 15132410,
                    lavenderblush: 16773365,
                    lawngreen: 8190976,
                    lemonchiffon: 16775885,
                    lightblue: 11393254,
                    lightcoral: 15761536,
                    lightcyan: 14745599,
                    lightgoldenrodyellow: 16448210,
                    lightgray: 13882323,
                    lightgreen: 9498256,
                    lightgrey: 13882323,
                    lightpink: 16758465,
                    lightsalmon: 16752762,
                    lightseagreen: 2142890,
                    lightskyblue: 8900346,
                    lightslategray: 7833753,
                    lightslategrey: 7833753,
                    lightsteelblue: 11584734,
                    lightyellow: 16777184,
                    lime: 65280,
                    limegreen: 3329330,
                    linen: 16445670,
                    magenta: 16711935,
                    maroon: 8388608,
                    mediumaquamarine: 6737322,
                    mediumblue: 205,
                    mediumorchid: 12211667,
                    mediumpurple: 9662683,
                    mediumseagreen: 3978097,
                    mediumslateblue: 8087790,
                    mediumspringgreen: 64154,
                    mediumturquoise: 4772300,
                    mediumvioletred: 13047173,
                    midnightblue: 1644912,
                    mintcream: 16121850,
                    mistyrose: 16770273,
                    moccasin: 16770229,
                    navajowhite: 16768685,
                    navy: 128,
                    oldlace: 16643558,
                    olive: 8421376,
                    olivedrab: 7048739,
                    orange: 16753920,
                    orangered: 16729344,
                    orchid: 14315734,
                    palegoldenrod: 15657130,
                    palegreen: 10025880,
                    paleturquoise: 11529966,
                    palevioletred: 14381203,
                    papayawhip: 16773077,
                    peachpuff: 16767673,
                    peru: 13468991,
                    pink: 16761035,
                    plum: 14524637,
                    powderblue: 11591910,
                    purple: 8388736,
                    rebeccapurple: 6697881,
                    red: 16711680,
                    rosybrown: 12357519,
                    royalblue: 4286945,
                    saddlebrown: 9127187,
                    salmon: 16416882,
                    sandybrown: 16032864,
                    seagreen: 3050327,
                    seashell: 16774638,
                    sienna: 10506797,
                    silver: 12632256,
                    skyblue: 8900331,
                    slateblue: 6970061,
                    slategray: 7372944,
                    slategrey: 7372944,
                    snow: 16775930,
                    springgreen: 65407,
                    steelblue: 4620980,
                    tan: 13808780,
                    teal: 32896,
                    thistle: 14204888,
                    tomato: 16737095,
                    turquoise: 4251856,
                    violet: 15631086,
                    wheat: 16113331,
                    white: 16777215,
                    whitesmoke: 16119285,
                    yellow: 16776960,
                    yellowgreen: 10145074
                });
                Hr.forEach(function(Z, oe) {
                    Hr.set(Z, Ra(oe));
                });
                function ti(Z) {
                    return typeof Z == "function" ? Z : function() {
                        return Z;
                    };
                }
                e.functor = ti, e.xhr = zi(H);
                function zi(Z) {
                    return function(oe, we, Be) {
                        return arguments.length === 2 && typeof we == "function" && (Be = we, we = null), Yi(oe, we, Z, Be);
                    };
                }
                function Yi(Z, oe, we, Be) {
                    var Ue = {}, We = e.dispatch("beforesend", "progress", "load", "error"), wt = {}, tt = new XMLHttpRequest, zt = null;
                    self.XDomainRequest && !("withCredentials" in tt) && /^(http(s)?:)?\/\//.test(Z) && (tt = new XDomainRequest), "onload" in tt ? tt.onload = tt.onerror = or : tt.onreadystatechange = function() {
                        tt.readyState > 3 && or();
                    };
                    function or() {
                        var lr = tt.status, Dr;
                        if (!lr && hi(tt) || lr >= 200 && lr < 300 || lr === 304) {
                            try {
                                Dr = we.call(Ue, tt);
                            } catch (Ir) {
                                We.error.call(Ue, Ir);
                                return;
                            }
                            We.load.call(Ue, Dr);
                        } else We.error.call(Ue, tt);
                    }
                    return tt.onprogress = function(lr) {
                        var Dr = e.event;
                        e.event = lr;
                        try {
                            We.progress.call(Ue, tt);
                        } finally{
                            e.event = Dr;
                        }
                    }, Ue.header = function(lr, Dr) {
                        return lr = (lr + "").toLowerCase(), arguments.length < 2 ? wt[lr] : (Dr == null ? delete wt[lr] : wt[lr] = Dr + "", Ue);
                    }, Ue.mimeType = function(lr) {
                        return arguments.length ? (oe = lr == null ? null : lr + "", Ue) : oe;
                    }, Ue.responseType = function(lr) {
                        return arguments.length ? (zt = lr, Ue) : zt;
                    }, Ue.response = function(lr) {
                        return we = lr, Ue;
                    }, [
                        "get",
                        "post"
                    ].forEach(function(lr) {
                        Ue[lr] = function() {
                            return Ue.send.apply(Ue, [
                                lr
                            ].concat(r(arguments)));
                        };
                    }), Ue.send = function(lr, Dr, Ir) {
                        if (arguments.length === 2 && typeof Dr == "function" && (Ir = Dr, Dr = null), tt.open(lr, Z, !0), oe != null && !("accept" in wt) && (wt.accept = oe + ",*/*"), tt.setRequestHeader) for(var oi in wt)tt.setRequestHeader(oi, wt[oi]);
                        return oe != null && tt.overrideMimeType && tt.overrideMimeType(oe), zt != null && (tt.responseType = zt), Ir != null && Ue.on("error", Ir).on("load", function(ui) {
                            Ir(null, ui);
                        }), We.beforesend.call(Ue, tt), tt.send(Dr == null ? null : Dr), Ue;
                    }, Ue.abort = function() {
                        return tt.abort(), Ue;
                    }, e.rebind(Ue, We, "on"), Be == null ? Ue : Ue.get(an(Be));
                }
                function an(Z) {
                    return Z.length === 1 ? function(oe, we) {
                        Z(oe == null ? we : null);
                    } : Z;
                }
                function hi(Z) {
                    var oe = Z.responseType;
                    return oe && oe !== "text" ? Z.response : Z.responseText;
                }
                e.dsv = function(Z, oe) {
                    var we = new RegExp('["' + Z + `
]`), Be = Z.charCodeAt(0);
                    function Ue(or, lr, Dr) {
                        arguments.length < 3 && (Dr = lr, lr = null);
                        var Ir = Yi(or, oe, lr == null ? We : wt(lr), Dr);
                        return Ir.row = function(oi) {
                            return arguments.length ? Ir.response((lr = oi) == null ? We : wt(oi)) : lr;
                        }, Ir;
                    }
                    function We(or) {
                        return Ue.parse(or.responseText);
                    }
                    function wt(or) {
                        return function(lr) {
                            return Ue.parse(lr.responseText, or);
                        };
                    }
                    Ue.parse = function(or, lr) {
                        var Dr;
                        return Ue.parseRows(or, function(Ir, oi) {
                            if (Dr) return Dr(Ir, oi - 1);
                            var ui = function(qr) {
                                for(var Kr = {}, ii = Ir.length, vi = 0; vi < ii; ++vi)Kr[Ir[vi]] = qr[vi];
                                return Kr;
                            };
                            Dr = lr ? function(qr, Kr) {
                                return lr(ui(qr), Kr);
                            } : ui;
                        });
                    }, Ue.parseRows = function(or, lr) {
                        var Dr = {}, Ir = {}, oi = [], ui = or.length, qr = 0, Kr = 0, ii, vi;
                        function ci() {
                            if (qr >= ui) return Ir;
                            if (vi) return vi = !1, Dr;
                            var un = qr;
                            if (or.charCodeAt(un) === 34) {
                                for(var dn = un; dn++ < ui;)if (or.charCodeAt(dn) === 34) {
                                    if (or.charCodeAt(dn + 1) !== 34) break;
                                    ++dn;
                                }
                                qr = dn + 2;
                                var En = or.charCodeAt(dn + 1);
                                return En === 13 ? (vi = !0, or.charCodeAt(dn + 2) === 10 && ++qr) : En === 10 && (vi = !0), or.slice(un + 1, dn).replace(/""/g, '"');
                            }
                            for(; qr < ui;){
                                var En = or.charCodeAt(qr++), Nn = 1;
                                if (En === 10) vi = !0;
                                else if (En === 13) vi = !0, or.charCodeAt(qr) === 10 && (++qr, ++Nn);
                                else if (En !== Be) continue;
                                return or.slice(un, qr - Nn);
                            }
                            return or.slice(un);
                        }
                        for(; (ii = ci()) !== Ir;){
                            for(var Jr = []; ii !== Dr && ii !== Ir;)Jr.push(ii), ii = ci();
                            lr && (Jr = lr(Jr, Kr++)) == null || oi.push(Jr);
                        }
                        return oi;
                    }, Ue.format = function(or) {
                        if (Array.isArray(or[0])) return Ue.formatRows(or);
                        var lr = new V, Dr = [];
                        return or.forEach(function(Ir) {
                            for(var oi in Ir)lr.has(oi) || Dr.push(lr.add(oi));
                        }), [
                            Dr.map(zt).join(Z)
                        ].concat(or.map(function(Ir) {
                            return Dr.map(function(oi) {
                                return zt(Ir[oi]);
                            }).join(Z);
                        })).join(`
`);
                    }, Ue.formatRows = function(or) {
                        return or.map(tt).join(`
`);
                    };
                    function tt(or) {
                        return or.map(zt).join(Z);
                    }
                    function zt(or) {
                        return we.test(or) ? '"' + or.replace(/\"/g, '""') + '"' : or;
                    }
                    return Ue;
                }, e.csv = e.dsv(",", "text/csv"), e.tsv = e.dsv("	", "text/tab-separated-values");
                var Ji, ua, Fn, Sa, go = this[G(this, "requestAnimationFrame")] || function(Z) {
                    setTimeout(Z, 17);
                };
                e.timer = function() {
                    Oo.apply(this, arguments);
                };
                function Oo(Z, oe, we) {
                    var Be = arguments.length;
                    Be < 2 && (oe = 0), Be < 3 && (we = Date.now());
                    var Ue = we + oe, We = {
                        c: Z,
                        t: Ue,
                        n: null
                    };
                    return ua ? ua.n = We : Ji = We, ua = We, Fn || (Sa = clearTimeout(Sa), Fn = 1, go(ho)), We;
                }
                function ho() {
                    var Z = Mo(), oe = xo() - Z;
                    oe > 24 ? (isFinite(oe) && (clearTimeout(Sa), Sa = setTimeout(ho, oe)), Fn = 0) : (Fn = 1, go(ho));
                }
                e.timer.flush = function() {
                    Mo(), xo();
                };
                function Mo() {
                    for(var Z = Date.now(), oe = Ji; oe;)Z >= oe.t && oe.c(Z - oe.t) && (oe.c = null), oe = oe.n;
                    return Z;
                }
                function xo() {
                    for(var Z, oe = Ji, we = 1 / 0; oe;)oe.c ? (oe.t < we && (we = oe.t), oe = (Z = oe).n) : oe = Z ? Z.n = oe.n : Ji = oe.n;
                    return ua = Z, we;
                }
                e.round = function(Z, oe) {
                    return oe ? Math.round(Z * (oe = Math.pow(10, oe))) / oe : Math.round(Z);
                }, e.geom = {};
                function zs(Z) {
                    return Z[0];
                }
                function ks(Z) {
                    return Z[1];
                }
                e.geom.hull = function(Z) {
                    var oe = zs, we = ks;
                    if (arguments.length) return Be(Z);
                    function Be(Ue) {
                        if (Ue.length < 3) return [];
                        var We = ti(oe), wt = ti(we), tt, zt = Ue.length, or = [], lr = [];
                        for(tt = 0; tt < zt; tt++)or.push([
                            +We.call(this, Ue[tt], tt),
                            +wt.call(this, Ue[tt], tt),
                            tt
                        ]);
                        for(or.sort(Xs), tt = 0; tt < zt; tt++)lr.push([
                            or[tt][0],
                            -or[tt][1]
                        ]);
                        var Dr = Zs(or), Ir = Zs(lr), oi = Ir[0] === Dr[0], ui = Ir[Ir.length - 1] === Dr[Dr.length - 1], qr = [];
                        for(tt = Dr.length - 1; tt >= 0; --tt)qr.push(Ue[or[Dr[tt]][2]]);
                        for(tt = +oi; tt < Ir.length - ui; ++tt)qr.push(Ue[or[Ir[tt]][2]]);
                        return qr;
                    }
                    return Be.x = function(Ue) {
                        return arguments.length ? (oe = Ue, Be) : oe;
                    }, Be.y = function(Ue) {
                        return arguments.length ? (we = Ue, Be) : we;
                    }, Be;
                };
                function Zs(Z) {
                    for(var oe = Z.length, we = [
                        0,
                        1
                    ], Be = 2, Ue = 2; Ue < oe; Ue++){
                        for(; Be > 1 && Vt(Z[we[Be - 2]], Z[we[Be - 1]], Z[Ue]) <= 0;)--Be;
                        we[Be++] = Ue;
                    }
                    return we.slice(0, Be);
                }
                function Xs(Z, oe) {
                    return Z[0] - oe[0] || Z[1] - oe[1];
                }
                e.geom.polygon = function(Z) {
                    return ie(Z, wl), Z;
                };
                var wl = e.geom.polygon.prototype = [];
                wl.area = function() {
                    for(var Z = -1, oe = this.length, we, Be = this[oe - 1], Ue = 0; ++Z < oe;)we = Be, Be = this[Z], Ue += we[1] * Be[0] - we[0] * Be[1];
                    return Ue * .5;
                }, wl.centroid = function(Z) {
                    var oe = -1, we = this.length, Be = 0, Ue = 0, We, wt = this[we - 1], tt;
                    for(arguments.length || (Z = -1 / (6 * this.area())); ++oe < we;)We = wt, wt = this[oe], tt = We[0] * wt[1] - wt[0] * We[1], Be += (We[0] + wt[0]) * tt, Ue += (We[1] + wt[1]) * tt;
                    return [
                        Be * Z,
                        Ue * Z
                    ];
                }, wl.clip = function(Z) {
                    for(var oe, we = Cs(Z), Be = -1, Ue = this.length - Cs(this), We, wt, tt = this[Ue - 1], zt, or, lr; ++Be < Ue;){
                        for(oe = Z.slice(), Z.length = 0, zt = this[Be], or = oe[(wt = oe.length - we) - 1], We = -1; ++We < wt;)lr = oe[We], os(lr, tt, zt) ? (os(or, tt, zt) || Z.push(cl(or, lr, tt, zt)), Z.push(lr)) : os(or, tt, zt) && Z.push(cl(or, lr, tt, zt)), or = lr;
                        we && Z.push(Z[0]), tt = zt;
                    }
                    return Z;
                };
                function os(Z, oe, we) {
                    return (we[0] - oe[0]) * (Z[1] - oe[1]) < (we[1] - oe[1]) * (Z[0] - oe[0]);
                }
                function cl(Z, oe, we, Be) {
                    var Ue = Z[0], We = we[0], wt = oe[0] - Ue, tt = Be[0] - We, zt = Z[1], or = we[1], lr = oe[1] - zt, Dr = Be[1] - or, Ir = (tt * (zt - or) - Dr * (Ue - We)) / (Dr * wt - tt * lr);
                    return [
                        Ue + Ir * wt,
                        zt + Ir * lr
                    ];
                }
                function Cs(Z) {
                    var oe = Z[0], we = Z[Z.length - 1];
                    return !(oe[0] - we[0] || oe[1] - we[1]);
                }
                var ml, Ys, Hs, Eo = [], fs, Ql, Hu = [];
                function fc() {
                    Ls(this), this.edge = this.site = this.circle = null;
                }
                function ms(Z) {
                    var oe = Eo.pop() || new fc;
                    return oe.site = Z, oe;
                }
                function on(Z) {
                    ko(Z), Hs.remove(Z), Eo.push(Z), Ls(Z);
                }
                function fa(Z) {
                    var oe = Z.circle, we = oe.x, Be = oe.cy, Ue = {
                        x: we,
                        y: Be
                    }, We = Z.P, wt = Z.N, tt = [
                        Z
                    ];
                    on(Z);
                    for(var zt = We; zt.circle && p(we - zt.circle.x) < Ye && p(Be - zt.circle.cy) < Ye;)We = zt.P, tt.unshift(zt), on(zt), zt = We;
                    tt.unshift(zt), ko(zt);
                    for(var or = wt; or.circle && p(we - or.circle.x) < Ye && p(Be - or.circle.cy) < Ye;)wt = or.N, tt.push(or), on(or), or = wt;
                    tt.push(or), ko(or);
                    var lr = tt.length, Dr;
                    for(Dr = 1; Dr < lr; ++Dr)or = tt[Dr], zt = tt[Dr - 1], Al(or.edge, zt.site, or.site, Ue);
                    zt = tt[0], or = tt[lr - 1], or.edge = cf(zt.site, or.site, null, Ue), Zn(zt), Zn(or);
                }
                function Qu(Z) {
                    for(var oe = Z.x, we = Z.y, Be, Ue, We, wt, tt = Hs._; tt;)if (We = Rl(tt, we) - oe, We > Ye) tt = tt.L;
                    else if (wt = oe - vo(tt, we), wt > Ye) {
                        if (!tt.R) {
                            Be = tt;
                            break;
                        }
                        tt = tt.R;
                    } else {
                        We > -Ye ? (Be = tt.P, Ue = tt) : wt > -Ye ? (Be = tt, Ue = tt.N) : Be = Ue = tt;
                        break;
                    }
                    var zt = ms(Z);
                    if (Hs.insert(Be, zt), !(!Be && !Ue)) {
                        if (Be === Ue) {
                            ko(Be), Ue = ms(Be.site), Hs.insert(zt, Ue), zt.edge = Ue.edge = cf(Be.site, zt.site), Zn(Be), Zn(Ue);
                            return;
                        }
                        if (!Ue) {
                            zt.edge = cf(Be.site, zt.site);
                            return;
                        }
                        ko(Be), ko(Ue);
                        var or = Be.site, lr = or.x, Dr = or.y, Ir = Z.x - lr, oi = Z.y - Dr, ui = Ue.site, qr = ui.x - lr, Kr = ui.y - Dr, ii = 2 * (Ir * Kr - oi * qr), vi = Ir * Ir + oi * oi, ci = qr * qr + Kr * Kr, Jr = {
                            x: (Kr * vi - oi * ci) / ii + lr,
                            y: (Ir * ci - qr * vi) / ii + Dr
                        };
                        Al(Ue.edge, or, ui, Jr), zt.edge = cf(or, Z, null, Jr), Ue.edge = cf(Z, ui, null, Jr), Zn(Be), Zn(Ue);
                    }
                }
                function Rl(Z, oe) {
                    var we = Z.site, Be = we.x, Ue = we.y, We = Ue - oe;
                    if (!We) return Be;
                    var wt = Z.P;
                    if (!wt) return -1 / 0;
                    we = wt.site;
                    var tt = we.x, zt = we.y, or = zt - oe;
                    if (!or) return tt;
                    var lr = tt - Be, Dr = 1 / We - 1 / or, Ir = lr / or;
                    return Dr ? (-Ir + Math.sqrt(Ir * Ir - 2 * Dr * (lr * lr / (-2 * or) - zt + or / 2 + Ue - We / 2))) / Dr + Be : (Be + tt) / 2;
                }
                function vo(Z, oe) {
                    var we = Z.N;
                    if (we) return Rl(we, oe);
                    var Be = Z.site;
                    return Be.y === oe ? Be.x : 1 / 0;
                }
                function Zl(Z) {
                    this.site = Z, this.edges = [];
                }
                Zl.prototype.prepare = function() {
                    for(var Z = this.edges, oe = Z.length, we; oe--;)we = Z[oe].edge, (!we.b || !we.a) && Z.splice(oe, 1);
                    return Z.sort(Xl), Z.length;
                };
                function Ks(Z) {
                    for(var oe = Z[0][0], we = Z[1][0], Be = Z[0][1], Ue = Z[1][1], We, wt, tt, zt, or = Ys, lr = or.length, Dr, Ir, oi, ui, qr, Kr; lr--;)if (Dr = or[lr], !(!Dr || !Dr.prepare())) for(oi = Dr.edges, ui = oi.length, Ir = 0; Ir < ui;)Kr = oi[Ir].end(), tt = Kr.x, zt = Kr.y, qr = oi[++Ir % ui].start(), We = qr.x, wt = qr.y, (p(tt - We) > Ye || p(zt - wt) > Ye) && (oi.splice(Ir, 0, new Hc(rh(Dr.site, Kr, p(tt - oe) < Ye && Ue - zt > Ye ? {
                        x: oe,
                        y: p(We - oe) < Ye ? wt : Ue
                    } : p(zt - Ue) < Ye && we - tt > Ye ? {
                        x: p(wt - Ue) < Ye ? We : we,
                        y: Ue
                    } : p(tt - we) < Ye && zt - Be > Ye ? {
                        x: we,
                        y: p(We - we) < Ye ? wt : Be
                    } : p(zt - Be) < Ye && tt - oe > Ye ? {
                        x: p(wt - Be) < Ye ? We : oe,
                        y: Be
                    } : null), Dr.site, null)), ++ui);
                }
                function Xl(Z, oe) {
                    return oe.angle - Z.angle;
                }
                function Ec() {
                    Ls(this), this.x = this.y = this.arc = this.site = this.cy = null;
                }
                function Zn(Z) {
                    var oe = Z.P, we = Z.N;
                    if (!(!oe || !we)) {
                        var Be = oe.site, Ue = Z.site, We = we.site;
                        if (Be !== We) {
                            var wt = Ue.x, tt = Ue.y, zt = Be.x - wt, or = Be.y - tt, lr = We.x - wt, Kr = We.y - tt, Dr = 2 * (zt * Kr - or * lr);
                            if (!(Dr >= -Ve)) {
                                var Ir = zt * zt + or * or, oi = lr * lr + Kr * Kr, ui = (Kr * Ir - or * oi) / Dr, qr = (zt * oi - lr * Ir) / Dr, Kr = qr + tt, ii = Hu.pop() || new Ec;
                                ii.arc = Z, ii.site = Ue, ii.x = ui + wt, ii.y = Kr + Math.sqrt(ui * ui + qr * qr), ii.cy = Kr, Z.circle = ii;
                                for(var vi = null, ci = Ql._; ci;)if (ii.y < ci.y || ii.y === ci.y && ii.x <= ci.x) {
                                    if (ci.L) ci = ci.L;
                                    else {
                                        vi = ci.P;
                                        break;
                                    }
                                } else if (ci.R) ci = ci.R;
                                else {
                                    vi = ci;
                                    break;
                                }
                                Ql.insert(vi, ii), vi || (fs = ii);
                            }
                        }
                    }
                }
                function ko(Z) {
                    var oe = Z.circle;
                    oe && (oe.P || (fs = oe.N), Ql.remove(oe), Hu.push(oe), Ls(oe), Z.circle = null);
                }
                function Co(Z, oe, we, Be) {
                    return function(Ue) {
                        var We = Ue.a, wt = Ue.b, tt = We.x, zt = We.y, or = wt.x, lr = wt.y, Dr = 0, Ir = 1, oi = or - tt, ui = lr - zt, qr;
                        if (qr = Z - tt, !(!oi && qr > 0)) {
                            if (qr /= oi, oi < 0) {
                                if (qr < Dr) return;
                                qr < Ir && (Ir = qr);
                            } else if (oi > 0) {
                                if (qr > Ir) return;
                                qr > Dr && (Dr = qr);
                            }
                            if (qr = we - tt, !(!oi && qr < 0)) {
                                if (qr /= oi, oi < 0) {
                                    if (qr > Ir) return;
                                    qr > Dr && (Dr = qr);
                                } else if (oi > 0) {
                                    if (qr < Dr) return;
                                    qr < Ir && (Ir = qr);
                                }
                                if (qr = oe - zt, !(!ui && qr > 0)) {
                                    if (qr /= ui, ui < 0) {
                                        if (qr < Dr) return;
                                        qr < Ir && (Ir = qr);
                                    } else if (ui > 0) {
                                        if (qr > Ir) return;
                                        qr > Dr && (Dr = qr);
                                    }
                                    if (qr = Be - zt, !(!ui && qr < 0)) {
                                        if (qr /= ui, ui < 0) {
                                            if (qr > Ir) return;
                                            qr > Dr && (Dr = qr);
                                        } else if (ui > 0) {
                                            if (qr < Dr) return;
                                            qr < Ir && (Ir = qr);
                                        }
                                        return Dr > 0 && (Ue.a = {
                                            x: tt + Dr * oi,
                                            y: zt + Dr * ui
                                        }), Ir < 1 && (Ue.b = {
                                            x: tt + Ir * oi,
                                            y: zt + Ir * ui
                                        }), Ue;
                                    }
                                }
                            }
                        }
                    };
                }
                function Tl(Z) {
                    for(var oe = ml, we = Co(Z[0][0], Z[0][1], Z[1][0], Z[1][1]), Be = oe.length, Ue; Be--;)Ue = oe[Be], (!uf(Ue, Z) || !we(Ue) || p(Ue.a.x - Ue.b.x) < Ye && p(Ue.a.y - Ue.b.y) < Ye) && (Ue.a = Ue.b = null, oe.splice(Be, 1));
                }
                function uf(Z, oe) {
                    var we = Z.b;
                    if (we) return !0;
                    var Be = Z.a, Ue = oe[0][0], We = oe[1][0], wt = oe[0][1], tt = oe[1][1], zt = Z.l, or = Z.r, lr = zt.x, Dr = zt.y, Ir = or.x, oi = or.y, ui = (lr + Ir) / 2, qr = (Dr + oi) / 2, Kr, ii;
                    if (oi === Dr) {
                        if (ui < Ue || ui >= We) return;
                        if (lr > Ir) {
                            if (!Be) Be = {
                                x: ui,
                                y: wt
                            };
                            else if (Be.y >= tt) return;
                            we = {
                                x: ui,
                                y: tt
                            };
                        } else {
                            if (!Be) Be = {
                                x: ui,
                                y: tt
                            };
                            else if (Be.y < wt) return;
                            we = {
                                x: ui,
                                y: wt
                            };
                        }
                    } else if (Kr = (lr - Ir) / (oi - Dr), ii = qr - Kr * ui, Kr < -1 || Kr > 1) {
                        if (lr > Ir) {
                            if (!Be) Be = {
                                x: (wt - ii) / Kr,
                                y: wt
                            };
                            else if (Be.y >= tt) return;
                            we = {
                                x: (tt - ii) / Kr,
                                y: tt
                            };
                        } else {
                            if (!Be) Be = {
                                x: (tt - ii) / Kr,
                                y: tt
                            };
                            else if (Be.y < wt) return;
                            we = {
                                x: (wt - ii) / Kr,
                                y: wt
                            };
                        }
                    } else if (Dr < oi) {
                        if (!Be) Be = {
                            x: Ue,
                            y: Kr * Ue + ii
                        };
                        else if (Be.x >= We) return;
                        we = {
                            x: We,
                            y: Kr * We + ii
                        };
                    } else {
                        if (!Be) Be = {
                            x: We,
                            y: Kr * We + ii
                        };
                        else if (Be.x < Ue) return;
                        we = {
                            x: Ue,
                            y: Kr * Ue + ii
                        };
                    }
                    return Z.a = Be, Z.b = we, !0;
                }
                function So(Z, oe) {
                    this.l = Z, this.r = oe, this.a = this.b = null;
                }
                function cf(Z, oe, we, Be) {
                    var Ue = new So(Z, oe);
                    return ml.push(Ue), we && Al(Ue, Z, oe, we), Be && Al(Ue, oe, Z, Be), Ys[Z.i].edges.push(new Hc(Ue, Z, oe)), Ys[oe.i].edges.push(new Hc(Ue, oe, Z)), Ue;
                }
                function rh(Z, oe, we) {
                    var Be = new So(Z, null);
                    return Be.a = oe, Be.b = we, ml.push(Be), Be;
                }
                function Al(Z, oe, we, Be) {
                    !Z.a && !Z.b ? (Z.a = Be, Z.l = oe, Z.r = we) : Z.l === we ? Z.b = Be : Z.a = Be;
                }
                function Hc(Z, oe, we) {
                    var Be = Z.a, Ue = Z.b;
                    this.edge = Z, this.site = oe, this.angle = we ? Math.atan2(we.y - oe.y, we.x - oe.x) : Z.l === oe ? Math.atan2(Ue.x - Be.x, Be.y - Ue.y) : Math.atan2(Be.x - Ue.x, Ue.y - Be.y);
                }
                Hc.prototype = {
                    start: function() {
                        return this.edge.l === this.site ? this.edge.a : this.edge.b;
                    },
                    end: function() {
                        return this.edge.l === this.site ? this.edge.b : this.edge.a;
                    }
                };
                function eu() {
                    this._ = null;
                }
                function Ls(Z) {
                    Z.U = Z.C = Z.L = Z.R = Z.P = Z.N = null;
                }
                eu.prototype = {
                    insert: function(Z, oe) {
                        var we, Be, Ue;
                        if (Z) {
                            if (oe.P = Z, oe.N = Z.N, Z.N && (Z.N.P = oe), Z.N = oe, Z.R) {
                                for(Z = Z.R; Z.L;)Z = Z.L;
                                Z.L = oe;
                            } else Z.R = oe;
                            we = Z;
                        } else this._ ? (Z = Of(this._), oe.P = null, oe.N = Z, Z.P = Z.L = oe, we = Z) : (oe.P = oe.N = null, this._ = oe, we = null);
                        for(oe.L = oe.R = null, oe.U = we, oe.C = !0, Z = oe; we && we.C;)Be = we.U, we === Be.L ? (Ue = Be.R, Ue && Ue.C ? (we.C = Ue.C = !1, Be.C = !0, Z = Be) : (Z === we.R && (mu(this, we), Z = we, we = Z.U), we.C = !1, Be.C = !0, kc(this, Be))) : (Ue = Be.L, Ue && Ue.C ? (we.C = Ue.C = !1, Be.C = !0, Z = Be) : (Z === we.L && (kc(this, we), Z = we, we = Z.U), we.C = !1, Be.C = !0, mu(this, Be))), we = Z.U;
                        this._.C = !1;
                    },
                    remove: function(Z) {
                        Z.N && (Z.N.P = Z.P), Z.P && (Z.P.N = Z.N), Z.N = Z.P = null;
                        var oe = Z.U, we, Be = Z.L, Ue = Z.R, We, wt;
                        if (Be ? Ue ? We = Of(Ue) : We = Be : We = Ue, oe ? oe.L === Z ? oe.L = We : oe.R = We : this._ = We, Be && Ue ? (wt = We.C, We.C = Z.C, We.L = Be, Be.U = We, We !== Ue ? (oe = We.U, We.U = Z.U, Z = We.R, oe.L = Z, We.R = Ue, Ue.U = We) : (We.U = oe, oe = We, Z = We.R)) : (wt = Z.C, Z = We), Z && (Z.U = oe), !wt) {
                            if (Z && Z.C) {
                                Z.C = !1;
                                return;
                            }
                            do {
                                if (Z === this._) break;
                                if (Z === oe.L) {
                                    if (we = oe.R, we.C && (we.C = !1, oe.C = !0, mu(this, oe), we = oe.R), we.L && we.L.C || we.R && we.R.C) {
                                        (!we.R || !we.R.C) && (we.L.C = !1, we.C = !0, kc(this, we), we = oe.R), we.C = oe.C, oe.C = we.R.C = !1, mu(this, oe), Z = this._;
                                        break;
                                    }
                                } else if (we = oe.L, we.C && (we.C = !1, oe.C = !0, kc(this, oe), we = oe.L), we.L && we.L.C || we.R && we.R.C) {
                                    (!we.L || !we.L.C) && (we.R.C = !1, we.C = !0, mu(this, we), we = oe.L), we.C = oe.C, oe.C = we.L.C = !1, kc(this, oe), Z = this._;
                                    break;
                                }
                                we.C = !0, Z = oe, oe = oe.U;
                            }while (!Z.C);
                            Z && (Z.C = !1);
                        }
                    }
                };
                function mu(Z, oe) {
                    var we = oe, Be = oe.R, Ue = we.U;
                    Ue ? Ue.L === we ? Ue.L = Be : Ue.R = Be : Z._ = Be, Be.U = Ue, we.U = Be, we.R = Be.L, we.R && (we.R.U = we), Be.L = we;
                }
                function kc(Z, oe) {
                    var we = oe, Be = oe.L, Ue = we.U;
                    Ue ? Ue.L === we ? Ue.L = Be : Ue.R = Be : Z._ = Be, Be.U = Ue, we.U = Be, we.L = Be.R, we.L && (we.L.U = we), Be.R = we;
                }
                function Of(Z) {
                    for(; Z.L;)Z = Z.L;
                    return Z;
                }
                function Gc(Z, oe) {
                    var we = Z.sort(vd).pop(), Be, Ue, We;
                    for(ml = [], Ys = new Array(Z.length), Hs = new eu, Ql = new eu;;)if (We = fs, we && (!We || we.y < We.y || we.y === We.y && we.x < We.x)) (we.x !== Be || we.y !== Ue) && (Ys[we.i] = new Zl(we), Qu(we), Be = we.x, Ue = we.y), we = Z.pop();
                    else if (We) fa(We.arc);
                    else break;
                    oe && (Tl(oe), Ks(oe));
                    var wt = {
                        cells: Ys,
                        edges: ml
                    };
                    return Hs = Ql = ml = Ys = null, wt;
                }
                function vd(Z, oe) {
                    return oe.y - Z.y || oe.x - Z.x;
                }
                e.geom.voronoi = function(Z) {
                    var oe = zs, we = ks, Be = oe, Ue = we, We = Bf;
                    if (Z) return wt(Z);
                    function wt(zt) {
                        var or = new Array(zt.length), lr = We[0][0], Dr = We[0][1], Ir = We[1][0], oi = We[1][1];
                        return Gc(tt(zt), We).cells.forEach(function(ui, qr) {
                            var Kr = ui.edges, ii = ui.site, vi = or[qr] = Kr.length ? Kr.map(function(ci) {
                                var Jr = ci.start();
                                return [
                                    Jr.x,
                                    Jr.y
                                ];
                            }) : ii.x >= lr && ii.x <= Ir && ii.y >= Dr && ii.y <= oi ? [
                                [
                                    lr,
                                    oi
                                ],
                                [
                                    Ir,
                                    oi
                                ],
                                [
                                    Ir,
                                    Dr
                                ],
                                [
                                    lr,
                                    Dr
                                ]
                            ] : [];
                            vi.point = zt[qr];
                        }), or;
                    }
                    function tt(zt) {
                        return zt.map(function(or, lr) {
                            return {
                                x: Math.round(Be(or, lr) / Ye) * Ye,
                                y: Math.round(Ue(or, lr) / Ye) * Ye,
                                i: lr
                            };
                        });
                    }
                    return wt.links = function(zt) {
                        return Gc(tt(zt)).edges.filter(function(or) {
                            return or.l && or.r;
                        }).map(function(or) {
                            return {
                                source: zt[or.l.i],
                                target: zt[or.r.i]
                            };
                        });
                    }, wt.triangles = function(zt) {
                        var or = [];
                        return Gc(tt(zt)).cells.forEach(function(lr, Dr) {
                            for(var Ir = lr.site, oi = lr.edges.sort(Xl), ui = -1, qr = oi.length, Kr, ii, vi = oi[qr - 1].edge, ci = vi.l === Ir ? vi.r : vi.l; ++ui < qr;)Kr = vi, ii = ci, vi = oi[ui].edge, ci = vi.l === Ir ? vi.r : vi.l, Dr < ii.i && Dr < ci.i && ss(Ir, ii, ci) < 0 && or.push([
                                zt[Dr],
                                zt[ii.i],
                                zt[ci.i]
                            ]);
                        }), or;
                    }, wt.x = function(zt) {
                        return arguments.length ? (Be = ti(oe = zt), wt) : oe;
                    }, wt.y = function(zt) {
                        return arguments.length ? (Ue = ti(we = zt), wt) : we;
                    }, wt.clipExtent = function(zt) {
                        return arguments.length ? (We = zt == null ? Bf : zt, wt) : We === Bf ? null : We;
                    }, wt.size = function(zt) {
                        return arguments.length ? wt.clipExtent(zt && [
                            [
                                0,
                                0
                            ],
                            zt
                        ]) : We === Bf ? null : We && We[1];
                    }, wt;
                };
                var Bf = [
                    [
                        -1000000,
                        -1000000
                    ],
                    [
                        1e6,
                        1e6
                    ]
                ];
                function ss(Z, oe, we) {
                    return (Z.x - we.x) * (oe.y - Z.y) - (Z.x - oe.x) * (we.y - Z.y);
                }
                e.geom.delaunay = function(Z) {
                    return e.geom.voronoi().triangles(Z);
                }, e.geom.quadtree = function(Z, oe, we, Be, Ue) {
                    var We = zs, wt = ks, tt;
                    if (tt = arguments.length) return We = ff, wt = ih, tt === 3 && (Ue = we, Be = oe, we = oe = 0), zt(Z);
                    function zt(or) {
                        var lr, Dr = ti(We), Ir = ti(wt), oi, ui, qr, Kr, ii, vi, ci, Jr;
                        if (oe != null) ii = oe, vi = we, ci = Be, Jr = Ue;
                        else if (ci = Jr = -(ii = vi = 1 / 0), oi = [], ui = [], Kr = or.length, tt) for(qr = 0; qr < Kr; ++qr)lr = or[qr], lr.x < ii && (ii = lr.x), lr.y < vi && (vi = lr.y), lr.x > ci && (ci = lr.x), lr.y > Jr && (Jr = lr.y), oi.push(lr.x), ui.push(lr.y);
                        else for(qr = 0; qr < Kr; ++qr){
                            var un = +Dr(lr = or[qr], qr), dn = +Ir(lr, qr);
                            un < ii && (ii = un), dn < vi && (vi = dn), un > ci && (ci = un), dn > Jr && (Jr = dn), oi.push(un), ui.push(dn);
                        }
                        var En = ci - ii, Nn = Jr - vi;
                        En > Nn ? Jr = vi + En : ci = ii + Nn;
                        function ga(wa, io, Ss, _s, Ns, pn, za, Lo) {
                            if (!(isNaN(Ss) || isNaN(_s))) {
                                if (wa.leaf) {
                                    var Fo = wa.x, js = wa.y;
                                    if (Fo != null) {
                                        if (p(Fo - Ss) + p(js - _s) < .01) ya(wa, io, Ss, _s, Ns, pn, za, Lo);
                                        else {
                                            var xl = wa.point;
                                            wa.x = wa.y = wa.point = null, ya(wa, xl, Fo, js, Ns, pn, za, Lo), ya(wa, io, Ss, _s, Ns, pn, za, Lo);
                                        }
                                    } else wa.x = Ss, wa.y = _s, wa.point = io;
                                } else ya(wa, io, Ss, _s, Ns, pn, za, Lo);
                            }
                        }
                        function ya(wa, io, Ss, _s, Ns, pn, za, Lo) {
                            var Fo = (Ns + za) * .5, js = (pn + Lo) * .5, xl = Ss >= Fo, fu = _s >= js, dl = fu << 1 | xl;
                            wa.leaf = !1, wa = wa.nodes[dl] || (wa.nodes[dl] = Vl()), xl ? Ns = Fo : za = Fo, fu ? pn = js : Lo = js, ga(wa, io, Ss, _s, Ns, pn, za, Lo);
                        }
                        var so = Vl();
                        if (so.add = function(wa) {
                            ga(so, wa, +Dr(wa, ++qr), +Ir(wa, qr), ii, vi, ci, Jr);
                        }, so.visit = function(wa) {
                            Js(wa, so, ii, vi, ci, Jr);
                        }, so.find = function(wa) {
                            return hc(so, wa[0], wa[1], ii, vi, ci, Jr);
                        }, qr = -1, oe == null) {
                            for(; ++qr < Kr;)ga(so, or[qr], oi[qr], ui[qr], ii, vi, ci, Jr);
                            --qr;
                        } else or.forEach(so.add);
                        return oi = ui = or = lr = null, so;
                    }
                    return zt.x = function(or) {
                        return arguments.length ? (We = or, zt) : We;
                    }, zt.y = function(or) {
                        return arguments.length ? (wt = or, zt) : wt;
                    }, zt.extent = function(or) {
                        return arguments.length ? (or == null ? oe = we = Be = Ue = null : (oe = +or[0][0], we = +or[0][1], Be = +or[1][0], Ue = +or[1][1]), zt) : oe == null ? null : [
                            [
                                oe,
                                we
                            ],
                            [
                                Be,
                                Ue
                            ]
                        ];
                    }, zt.size = function(or) {
                        return arguments.length ? (or == null ? oe = we = Be = Ue = null : (oe = we = 0, Be = +or[0], Ue = +or[1]), zt) : oe == null ? null : [
                            Be - oe,
                            Ue - we
                        ];
                    }, zt;
                };
                function ff(Z) {
                    return Z.x;
                }
                function ih(Z) {
                    return Z.y;
                }
                function Vl() {
                    return {
                        leaf: !0,
                        nodes: [],
                        point: null,
                        x: null,
                        y: null
                    };
                }
                function Js(Z, oe, we, Be, Ue, We) {
                    if (!Z(oe, we, Be, Ue, We)) {
                        var wt = (we + Ue) * .5, tt = (Be + We) * .5, zt = oe.nodes;
                        zt[0] && Js(Z, zt[0], we, Be, wt, tt), zt[1] && Js(Z, zt[1], wt, Be, Ue, tt), zt[2] && Js(Z, zt[2], we, tt, wt, We), zt[3] && Js(Z, zt[3], wt, tt, Ue, We);
                    }
                }
                function hc(Z, oe, we, Be, Ue, We, wt) {
                    var tt = 1 / 0, zt;
                    return function or(lr, Dr, Ir, oi, ui) {
                        if (!(Dr > We || Ir > wt || oi < Be || ui < Ue)) {
                            if (qr = lr.point) {
                                var qr, Kr = oe - lr.x, ii = we - lr.y, vi = Kr * Kr + ii * ii;
                                if (vi < tt) {
                                    var ci = Math.sqrt(tt = vi);
                                    Be = oe - ci, Ue = we - ci, We = oe + ci, wt = we + ci, zt = qr;
                                }
                            }
                            for(var Jr = lr.nodes, un = (Dr + oi) * .5, dn = (Ir + ui) * .5, En = oe >= un, Nn = we >= dn, ga = Nn << 1 | En, ya = ga + 4; ga < ya; ++ga)if (lr = Jr[ga & 3]) switch(ga & 3){
                                case 0:
                                    or(lr, Dr, Ir, un, dn);
                                    break;
                                case 1:
                                    or(lr, un, Ir, oi, dn);
                                    break;
                                case 2:
                                    or(lr, Dr, dn, un, ui);
                                    break;
                                case 3:
                                    or(lr, un, dn, oi, ui);
                                    break;
                            }
                        }
                    }(Z, Be, Ue, We, wt), zt;
                }
                e.interpolateRgb = Cc;
                function Cc(Z, oe) {
                    Z = e.rgb(Z), oe = e.rgb(oe);
                    var we = Z.r, Be = Z.g, Ue = Z.b, We = oe.r - we, wt = oe.g - Be, tt = oe.b - Ue;
                    return function(zt) {
                        return "#" + Sn(Math.round(we + We * zt)) + Sn(Math.round(Be + wt * zt)) + Sn(Math.round(Ue + tt * zt));
                    };
                }
                e.interpolateObject = ws;
                function ws(Z, oe) {
                    var we = {}, Be = {}, Ue;
                    for(Ue in Z)Ue in oe ? we[Ue] = Sl(Z[Ue], oe[Ue]) : Be[Ue] = Z[Ue];
                    for(Ue in oe)Ue in Z || (Be[Ue] = oe[Ue]);
                    return function(We) {
                        for(Ue in we)Be[Ue] = we[Ue](We);
                        return Be;
                    };
                }
                e.interpolateNumber = $s;
                function $s(Z, oe) {
                    return Z = +Z, oe = +oe, function(we) {
                        return Z * (1 - we) + oe * we;
                    };
                }
                e.interpolateString = hs;
                function hs(Z, oe) {
                    var we = Ms.lastIndex = dc.lastIndex = 0, Be, Ue, We, wt = -1, tt = [], zt = [];
                    for(Z = Z + "", oe = oe + ""; (Be = Ms.exec(Z)) && (Ue = dc.exec(oe));)(We = Ue.index) > we && (We = oe.slice(we, We), tt[wt] ? tt[wt] += We : tt[++wt] = We), (Be = Be[0]) === (Ue = Ue[0]) ? tt[wt] ? tt[wt] += Ue : tt[++wt] = Ue : (tt[++wt] = null, zt.push({
                        i: wt,
                        x: $s(Be, Ue)
                    })), we = dc.lastIndex;
                    return we < oe.length && (We = oe.slice(we), tt[wt] ? tt[wt] += We : tt[++wt] = We), tt.length < 2 ? zt[0] ? (oe = zt[0].x, function(or) {
                        return oe(or) + "";
                    }) : function() {
                        return oe;
                    } : (oe = zt.length, function(or) {
                        for(var lr = 0, Dr; lr < oe; ++lr)tt[(Dr = zt[lr]).i] = Dr.x(or);
                        return tt.join("");
                    });
                }
                var Ms = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, dc = new RegExp(Ms.source, "g");
                e.interpolate = Sl;
                function Sl(Z, oe) {
                    for(var we = e.interpolators.length, Be; --we >= 0 && !(Be = e.interpolators[we](Z, oe)););
                    return Be;
                }
                e.interpolators = [
                    function(Z, oe) {
                        var we = typeof oe;
                        return (we === "string" ? Hr.has(oe.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(oe) ? Cc : hs : oe instanceof Wn ? Cc : Array.isArray(oe) ? ec : we === "object" && isNaN(oe) ? ws : $s)(Z, oe);
                    }
                ], e.interpolateArray = ec;
                function ec(Z, oe) {
                    var we = [], Be = [], Ue = Z.length, We = oe.length, wt = Math.min(Z.length, oe.length), tt;
                    for(tt = 0; tt < wt; ++tt)we.push(Sl(Z[tt], oe[tt]));
                    for(; tt < Ue; ++tt)Be[tt] = Z[tt];
                    for(; tt < We; ++tt)Be[tt] = oe[tt];
                    return function(zt) {
                        for(tt = 0; tt < wt; ++tt)Be[tt] = we[tt](zt);
                        return Be;
                    };
                }
                var Ps = function() {
                    return H;
                }, ov = e.map({
                    linear: Ps,
                    poly: Mh,
                    quad: function() {
                        return Ef;
                    },
                    cubic: function() {
                        return tc;
                    },
                    sin: function() {
                        return jc;
                    },
                    exp: function() {
                        return kf;
                    },
                    circle: function() {
                        return Ml;
                    },
                    elastic: Yh,
                    back: Eh,
                    bounce: function() {
                        return nh;
                    }
                }), wo = e.map({
                    in: H,
                    out: $o,
                    "in-out": Ja,
                    "out-in": function(Z) {
                        return Ja($o(Z));
                    }
                });
                e.ease = function(Z) {
                    var oe = Z.indexOf("-"), we = oe >= 0 ? Z.slice(0, oe) : Z, Be = oe >= 0 ? Z.slice(oe + 1) : "in";
                    return we = ov.get(we) || Ps, Be = wo.get(Be) || H, Od(Be(we.apply(null, t.call(arguments, 1))));
                };
                function Od(Z) {
                    return function(oe) {
                        return oe <= 0 ? 0 : oe >= 1 ? 1 : Z(oe);
                    };
                }
                function $o(Z) {
                    return function(oe) {
                        return 1 - Z(1 - oe);
                    };
                }
                function Ja(Z) {
                    return function(oe) {
                        return .5 * (oe < .5 ? Z(2 * oe) : 2 - Z(2 - 2 * oe));
                    };
                }
                function Ef(Z) {
                    return Z * Z;
                }
                function tc(Z) {
                    return Z * Z * Z;
                }
                function uu(Z) {
                    if (Z <= 0) return 0;
                    if (Z >= 1) return 1;
                    var oe = Z * Z, we = oe * Z;
                    return 4 * (Z < .5 ? we : 3 * (Z - oe) + we - .75);
                }
                function Mh(Z) {
                    return function(oe) {
                        return Math.pow(oe, Z);
                    };
                }
                function jc(Z) {
                    return 1 - Math.cos(Z * xe);
                }
                function kf(Z) {
                    return Math.pow(2, 10 * (Z - 1));
                }
                function Ml(Z) {
                    return 1 - Math.sqrt(1 - Z * Z);
                }
                function Yh(Z, oe) {
                    var we;
                    return arguments.length < 2 && (oe = .45), arguments.length ? we = oe / ht * Math.asin(1 / Z) : (Z = 1, we = oe / 4), function(Be) {
                        return 1 + Z * Math.pow(2, -10 * Be) * Math.sin((Be - we) * ht / oe);
                    };
                }
                function Eh(Z) {
                    return Z || (Z = 1.70158), function(oe) {
                        return oe * oe * ((Z + 1) * oe - Z);
                    };
                }
                function nh(Z) {
                    return Z < 1 / 2.75 ? 7.5625 * Z * Z : Z < 2 / 2.75 ? 7.5625 * (Z -= 1.5 / 2.75) * Z + .75 : Z < 2.5 / 2.75 ? 7.5625 * (Z -= 2.25 / 2.75) * Z + .9375 : 7.5625 * (Z -= 2.625 / 2.75) * Z + .984375;
                }
                e.interpolateHcl = hf;
                function hf(Z, oe) {
                    Z = e.hcl(Z), oe = e.hcl(oe);
                    var we = Z.h, Be = Z.c, Ue = Z.l, We = oe.h - we, wt = oe.c - Be, tt = oe.l - Ue;
                    return isNaN(wt) && (wt = 0, Be = isNaN(Be) ? oe.c : Be), isNaN(We) ? (We = 0, we = isNaN(we) ? oe.h : we) : We > 180 ? We -= 360 : We < -180 && (We += 360), function(zt) {
                        return Fr(we + We * zt, Be + wt * zt, Ue + tt * zt) + "";
                    };
                }
                e.interpolateHsl = kh;
                function kh(Z, oe) {
                    Z = e.hsl(Z), oe = e.hsl(oe);
                    var we = Z.h, Be = Z.s, Ue = Z.l, We = oe.h - we, wt = oe.s - Be, tt = oe.l - Ue;
                    return isNaN(wt) && (wt = 0, Be = isNaN(Be) ? oe.s : Be), isNaN(We) ? (We = 0, we = isNaN(we) ? oe.h : we) : We > 180 ? We -= 360 : We < -180 && (We += 360), function(zt) {
                        return jt(we + We * zt, Be + wt * zt, Ue + tt * zt) + "";
                    };
                }
                e.interpolateLab = Kh;
                function Kh(Z, oe) {
                    Z = e.lab(Z), oe = e.lab(oe);
                    var we = Z.l, Be = Z.a, Ue = Z.b, We = oe.l - we, wt = oe.a - Be, tt = oe.b - Ue;
                    return function(zt) {
                        return Gi(we + We * zt, Be + wt * zt, Ue + tt * zt) + "";
                    };
                }
                e.interpolateRound = rc;
                function rc(Z, oe) {
                    return oe -= Z, function(we) {
                        return Math.round(Z + oe * we);
                    };
                }
                e.transform = function(Z) {
                    var oe = n.createElementNS(e.ns.prefix.svg, "g");
                    return (e.transform = function(we) {
                        if (we != null) {
                            oe.setAttribute("transform", we);
                            var Be = oe.transform.baseVal.consolidate();
                        }
                        return new ah(Be ? Be.matrix : Nf);
                    })(Z);
                };
                function ah(Z) {
                    var oe = [
                        Z.a,
                        Z.b
                    ], we = [
                        Z.c,
                        Z.d
                    ], Be = df(oe), Ue = Wc(oe, we), We = df(Cu(we, oe, -Ue)) || 0;
                    oe[0] * we[1] < we[0] * oe[1] && (oe[0] *= -1, oe[1] *= -1, Be *= -1, Ue *= -1), this.rotate = (Be ? Math.atan2(oe[1], oe[0]) : Math.atan2(-we[0], we[1])) * lt, this.translate = [
                        Z.e,
                        Z.f
                    ], this.scale = [
                        Be,
                        We
                    ], this.skew = We ? Math.atan2(Ue, We) * lt : 0;
                }
                ah.prototype.toString = function() {
                    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
                };
                function Wc(Z, oe) {
                    return Z[0] * oe[0] + Z[1] * oe[1];
                }
                function df(Z) {
                    var oe = Math.sqrt(Wc(Z, Z));
                    return oe && (Z[0] /= oe, Z[1] /= oe), oe;
                }
                function Cu(Z, oe, we) {
                    return Z[0] += we * oe[0], Z[1] += we * oe[1], Z;
                }
                var Nf = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: 0,
                    f: 0
                };
                e.interpolateTransform = Cf;
                function Zc(Z) {
                    return Z.length ? Z.pop() + "," : "";
                }
                function ds(Z, oe, we, Be) {
                    if (Z[0] !== oe[0] || Z[1] !== oe[1]) {
                        var Ue = we.push("translate(", null, ",", null, ")");
                        Be.push({
                            i: Ue - 4,
                            x: $s(Z[0], oe[0])
                        }, {
                            i: Ue - 2,
                            x: $s(Z[1], oe[1])
                        });
                    } else (oe[0] || oe[1]) && we.push("translate(" + oe + ")");
                }
                function Ch(Z, oe, we, Be) {
                    Z !== oe ? (Z - oe > 180 ? oe += 360 : oe - Z > 180 && (Z += 360), Be.push({
                        i: we.push(Zc(we) + "rotate(", null, ")") - 2,
                        x: $s(Z, oe)
                    })) : oe && we.push(Zc(we) + "rotate(" + oe + ")");
                }
                function Bd(Z, oe, we, Be) {
                    Z !== oe ? Be.push({
                        i: we.push(Zc(we) + "skewX(", null, ")") - 2,
                        x: $s(Z, oe)
                    }) : oe && we.push(Zc(we) + "skewX(" + oe + ")");
                }
                function Jh(Z, oe, we, Be) {
                    if (Z[0] !== oe[0] || Z[1] !== oe[1]) {
                        var Ue = we.push(Zc(we) + "scale(", null, ",", null, ")");
                        Be.push({
                            i: Ue - 4,
                            x: $s(Z[0], oe[0])
                        }, {
                            i: Ue - 2,
                            x: $s(Z[1], oe[1])
                        });
                    } else (oe[0] !== 1 || oe[1] !== 1) && we.push(Zc(we) + "scale(" + oe + ")");
                }
                function Cf(Z, oe) {
                    var we = [], Be = [];
                    return Z = e.transform(Z), oe = e.transform(oe), ds(Z.translate, oe.translate, we, Be), Ch(Z.rotate, oe.rotate, we, Be), Bd(Z.skew, oe.skew, we, Be), Jh(Z.scale, oe.scale, we, Be), Z = oe = null, function(Ue) {
                        for(var We = -1, wt = Be.length, tt; ++We < wt;)we[(tt = Be[We]).i] = tt.x(Ue);
                        return we.join("");
                    };
                }
                function pd(Z, oe) {
                    return oe = (oe -= Z = +Z) || 1 / oe, function(we) {
                        return (we - Z) / oe;
                    };
                }
                function Lu(Z, oe) {
                    return oe = (oe -= Z = +Z) || 1 / oe, function(we) {
                        return Math.max(0, Math.min(1, (we - Z) / oe));
                    };
                }
                e.layout = {}, e.layout.bundle = function() {
                    return function(Z) {
                        for(var oe = [], we = -1, Be = Z.length; ++we < Be;)oe.push($h(Z[we]));
                        return oe;
                    };
                };
                function $h(Z) {
                    for(var oe = Z.source, we = Z.target, Be = Pu(oe, we), Ue = [
                        oe
                    ]; oe !== Be;)oe = oe.parent, Ue.push(oe);
                    for(var We = Ue.length; we !== Be;)Ue.splice(We, 0, we), we = we.parent;
                    return Ue;
                }
                function tu(Z) {
                    for(var oe = [], we = Z.parent; we != null;)oe.push(Z), Z = we, we = we.parent;
                    return oe.push(Z), oe;
                }
                function Pu(Z, oe) {
                    if (Z === oe) return Z;
                    for(var we = tu(Z), Be = tu(oe), Ue = we.pop(), We = Be.pop(), wt = null; Ue === We;)wt = Ue, Ue = we.pop(), We = Be.pop();
                    return wt;
                }
                e.layout.chord = function() {
                    var Z = {}, oe, we, Be, Ue, We = 0, wt, tt, zt;
                    function or() {
                        var Dr = {}, Ir = [], oi = e.range(Ue), ui = [], qr, Kr, ii, vi, ci;
                        for(oe = [], we = [], qr = 0, vi = -1; ++vi < Ue;){
                            for(Kr = 0, ci = -1; ++ci < Ue;)Kr += Be[vi][ci];
                            Ir.push(Kr), ui.push(e.range(Ue)), qr += Kr;
                        }
                        for(wt && oi.sort(function(so, wa) {
                            return wt(Ir[so], Ir[wa]);
                        }), tt && ui.forEach(function(so, wa) {
                            so.sort(function(io, Ss) {
                                return tt(Be[wa][io], Be[wa][Ss]);
                            });
                        }), qr = (ht - We * Ue) / qr, Kr = 0, vi = -1; ++vi < Ue;){
                            for(ii = Kr, ci = -1; ++ci < Ue;){
                                var Jr = oi[vi], un = ui[Jr][ci], dn = Be[Jr][un], En = Kr, Nn = Kr += dn * qr;
                                Dr[Jr + "-" + un] = {
                                    index: Jr,
                                    subindex: un,
                                    startAngle: En,
                                    endAngle: Nn,
                                    value: dn
                                };
                            }
                            we[Jr] = {
                                index: Jr,
                                startAngle: ii,
                                endAngle: Kr,
                                value: Ir[Jr]
                            }, Kr += We;
                        }
                        for(vi = -1; ++vi < Ue;)for(ci = vi - 1; ++ci < Ue;){
                            var ga = Dr[vi + "-" + ci], ya = Dr[ci + "-" + vi];
                            (ga.value || ya.value) && oe.push(ga.value < ya.value ? {
                                source: ya,
                                target: ga
                            } : {
                                source: ga,
                                target: ya
                            });
                        }
                        zt && lr();
                    }
                    function lr() {
                        oe.sort(function(Dr, Ir) {
                            return zt((Dr.source.value + Dr.target.value) / 2, (Ir.source.value + Ir.target.value) / 2);
                        });
                    }
                    return Z.matrix = function(Dr) {
                        return arguments.length ? (Ue = (Be = Dr) && Be.length, oe = we = null, Z) : Be;
                    }, Z.padding = function(Dr) {
                        return arguments.length ? (We = Dr, oe = we = null, Z) : We;
                    }, Z.sortGroups = function(Dr) {
                        return arguments.length ? (wt = Dr, oe = we = null, Z) : wt;
                    }, Z.sortSubgroups = function(Dr) {
                        return arguments.length ? (tt = Dr, oe = null, Z) : tt;
                    }, Z.sortChords = function(Dr) {
                        return arguments.length ? (zt = Dr, oe && lr(), Z) : zt;
                    }, Z.chords = function() {
                        return oe || or(), oe;
                    }, Z.groups = function() {
                        return we || or(), we;
                    }, Z;
                }, e.layout.force = function() {
                    var Z = {}, oe = e.dispatch("start", "tick", "end"), we, Be = [
                        1,
                        1
                    ], Ue, We, wt = .9, tt = Qs, zt = Qh, or = -30, lr = gd, Dr = .1, Ir = .64, oi = [], ui = [], qr, Kr, ii;
                    function vi(Jr) {
                        return function(un, dn, En, Nn) {
                            if (un.point !== Jr) {
                                var ga = un.cx - Jr.x, ya = un.cy - Jr.y, so = Nn - dn, wa = ga * ga + ya * ya;
                                if (so * so / Ir < wa) {
                                    if (wa < lr) {
                                        var io = un.charge / wa;
                                        Jr.px -= ga * io, Jr.py -= ya * io;
                                    }
                                    return !0;
                                }
                                if (un.point && wa && wa < lr) {
                                    var io = un.pointCharge / wa;
                                    Jr.px -= ga * io, Jr.py -= ya * io;
                                }
                            }
                            return !un.charge;
                        };
                    }
                    Z.tick = function() {
                        if ((We *= .99) < .005) return we = null, oe.end({
                            type: "end",
                            alpha: We = 0
                        }), !0;
                        var Jr = oi.length, un = ui.length, dn, En, Nn, ga, ya, so, wa, io, Ss;
                        for(En = 0; En < un; ++En)Nn = ui[En], ga = Nn.source, ya = Nn.target, io = ya.x - ga.x, Ss = ya.y - ga.y, (so = io * io + Ss * Ss) && (so = We * Kr[En] * ((so = Math.sqrt(so)) - qr[En]) / so, io *= so, Ss *= so, ya.x -= io * (wa = ga.weight + ya.weight ? ga.weight / (ga.weight + ya.weight) : .5), ya.y -= Ss * wa, ga.x += io * (wa = 1 - wa), ga.y += Ss * wa);
                        if ((wa = We * Dr) && (io = Be[0] / 2, Ss = Be[1] / 2, En = -1, wa)) for(; ++En < Jr;)Nn = oi[En], Nn.x += (io - Nn.x) * wa, Nn.y += (Ss - Nn.y) * wa;
                        if (or) for(yu(dn = e.geom.quadtree(oi), We, ii), En = -1; ++En < Jr;)(Nn = oi[En]).fixed || dn.visit(vi(Nn));
                        for(En = -1; ++En < Jr;)Nn = oi[En], Nn.fixed ? (Nn.x = Nn.px, Nn.y = Nn.py) : (Nn.x -= (Nn.px - (Nn.px = Nn.x)) * wt, Nn.y -= (Nn.py - (Nn.py = Nn.y)) * wt);
                        oe.tick({
                            type: "tick",
                            alpha: We
                        });
                    }, Z.nodes = function(Jr) {
                        return arguments.length ? (oi = Jr, Z) : oi;
                    }, Z.links = function(Jr) {
                        return arguments.length ? (ui = Jr, Z) : ui;
                    }, Z.size = function(Jr) {
                        return arguments.length ? (Be = Jr, Z) : Be;
                    }, Z.linkDistance = function(Jr) {
                        return arguments.length ? (tt = typeof Jr == "function" ? Jr : +Jr, Z) : tt;
                    }, Z.distance = Z.linkDistance, Z.linkStrength = function(Jr) {
                        return arguments.length ? (zt = typeof Jr == "function" ? Jr : +Jr, Z) : zt;
                    }, Z.friction = function(Jr) {
                        return arguments.length ? (wt = +Jr, Z) : wt;
                    }, Z.charge = function(Jr) {
                        return arguments.length ? (or = typeof Jr == "function" ? Jr : +Jr, Z) : or;
                    }, Z.chargeDistance = function(Jr) {
                        return arguments.length ? (lr = Jr * Jr, Z) : Math.sqrt(lr);
                    }, Z.gravity = function(Jr) {
                        return arguments.length ? (Dr = +Jr, Z) : Dr;
                    }, Z.theta = function(Jr) {
                        return arguments.length ? (Ir = Jr * Jr, Z) : Math.sqrt(Ir);
                    }, Z.alpha = function(Jr) {
                        return arguments.length ? (Jr = +Jr, We ? Jr > 0 ? We = Jr : (we.c = null, we.t = NaN, we = null, oe.end({
                            type: "end",
                            alpha: We = 0
                        })) : Jr > 0 && (oe.start({
                            type: "start",
                            alpha: We = Jr
                        }), we = Oo(Z.tick)), Z) : We;
                    }, Z.start = function() {
                        var Jr, un = oi.length, dn = ui.length, En = Be[0], Nn = Be[1], ga, ya;
                        for(Jr = 0; Jr < un; ++Jr)(ya = oi[Jr]).index = Jr, ya.weight = 0;
                        for(Jr = 0; Jr < dn; ++Jr)ya = ui[Jr], typeof ya.source == "number" && (ya.source = oi[ya.source]), typeof ya.target == "number" && (ya.target = oi[ya.target]), ++ya.source.weight, ++ya.target.weight;
                        for(Jr = 0; Jr < un; ++Jr)ya = oi[Jr], isNaN(ya.x) && (ya.x = so("x", En)), isNaN(ya.y) && (ya.y = so("y", Nn)), isNaN(ya.px) && (ya.px = ya.x), isNaN(ya.py) && (ya.py = ya.y);
                        if (qr = [], typeof tt == "function") for(Jr = 0; Jr < dn; ++Jr)qr[Jr] = +tt.call(this, ui[Jr], Jr);
                        else for(Jr = 0; Jr < dn; ++Jr)qr[Jr] = tt;
                        if (Kr = [], typeof zt == "function") for(Jr = 0; Jr < dn; ++Jr)Kr[Jr] = +zt.call(this, ui[Jr], Jr);
                        else for(Jr = 0; Jr < dn; ++Jr)Kr[Jr] = zt;
                        if (ii = [], typeof or == "function") for(Jr = 0; Jr < un; ++Jr)ii[Jr] = +or.call(this, oi[Jr], Jr);
                        else for(Jr = 0; Jr < un; ++Jr)ii[Jr] = or;
                        function so(wa, io) {
                            if (!ga) {
                                for(ga = new Array(un), Ns = 0; Ns < un; ++Ns)ga[Ns] = [];
                                for(Ns = 0; Ns < dn; ++Ns){
                                    var Ss = ui[Ns];
                                    ga[Ss.source.index].push(Ss.target), ga[Ss.target.index].push(Ss.source);
                                }
                            }
                            for(var _s = ga[Jr], Ns = -1, pn = _s.length, za; ++Ns < pn;)if (!isNaN(za = _s[Ns][wa])) return za;
                            return Math.random() * io;
                        }
                        return Z.resume();
                    }, Z.resume = function() {
                        return Z.alpha(.1);
                    }, Z.stop = function() {
                        return Z.alpha(0);
                    }, Z.drag = function() {
                        if (Ue || (Ue = e.behavior.drag().origin(H).on("dragstart.force", Lc).on("drag.force", ci).on("dragend.force", fl)), !arguments.length) return Ue;
                        this.on("mouseover.force", Xc).on("mouseout.force", ic).call(Ue);
                    };
                    function ci(Jr) {
                        Jr.px = e.event.x, Jr.py = e.event.y, Z.resume();
                    }
                    return e.rebind(Z, oe, "on");
                };
                function Lc(Z) {
                    Z.fixed |= 2;
                }
                function fl(Z) {
                    Z.fixed &= -7;
                }
                function Xc(Z) {
                    Z.fixed |= 4, Z.px = Z.x, Z.py = Z.y;
                }
                function ic(Z) {
                    Z.fixed &= -5;
                }
                function yu(Z, oe, we) {
                    var Be = 0, Ue = 0;
                    if (Z.charge = 0, !Z.leaf) for(var We = Z.nodes, wt = We.length, tt = -1, zt; ++tt < wt;)zt = We[tt], zt != null && (yu(zt, oe, we), Z.charge += zt.charge, Be += zt.charge * zt.cx, Ue += zt.charge * zt.cy);
                    if (Z.point) {
                        Z.leaf || (Z.point.x += Math.random() - .5, Z.point.y += Math.random() - .5);
                        var or = oe * we[Z.point.index];
                        Z.charge += Z.pointCharge = or, Be += or * Z.point.x, Ue += or * Z.point.y;
                    }
                    Z.cx = Be / Z.charge, Z.cy = Ue / Z.charge;
                }
                var Qs = 20, Qh = 1, gd = 1 / 0;
                e.layout.hierarchy = function() {
                    var Z = Uf, oe = sv, we = Lf;
                    function Be(Ue) {
                        var We = [
                            Ue
                        ], wt = [], tt;
                        for(Ue.depth = 0; (tt = We.pop()) != null;)if (wt.push(tt), (or = oe.call(Be, tt, tt.depth)) && (zt = or.length)) {
                            for(var zt, or, lr; --zt >= 0;)We.push(lr = or[zt]), lr.parent = tt, lr.depth = tt.depth + 1;
                            we && (tt.value = 0), tt.children = or;
                        } else we && (tt.value = +we.call(Be, tt, tt.depth) || 0), delete tt.children;
                        return vc(Ue, function(Dr) {
                            var Ir, oi;
                            Z && (Ir = Dr.children) && Ir.sort(Z), we && (oi = Dr.parent) && (oi.value += Dr.value);
                        }), wt;
                    }
                    return Be.sort = function(Ue) {
                        return arguments.length ? (Z = Ue, Be) : Z;
                    }, Be.children = function(Ue) {
                        return arguments.length ? (oe = Ue, Be) : oe;
                    }, Be.value = function(Ue) {
                        return arguments.length ? (we = Ue, Be) : we;
                    }, Be.revalue = function(Ue) {
                        return we && (Pc(Ue, function(We) {
                            We.children && (We.value = 0);
                        }), vc(Ue, function(We) {
                            var wt;
                            We.children || (We.value = +we.call(Be, We, We.depth) || 0), (wt = We.parent) && (wt.value += We.value);
                        })), Ue;
                    }, Be;
                };
                function Gu(Z, oe) {
                    return e.rebind(Z, oe, "sort", "children", "value"), Z.nodes = Z, Z.links = Iu, Z;
                }
                function Pc(Z, oe) {
                    for(var we = [
                        Z
                    ]; (Z = we.pop()) != null;)if (oe(Z), (Ue = Z.children) && (Be = Ue.length)) for(var Be, Ue; --Be >= 0;)we.push(Ue[Be]);
                }
                function vc(Z, oe) {
                    for(var we = [
                        Z
                    ], Be = []; (Z = we.pop()) != null;)if (Be.push(Z), (wt = Z.children) && (We = wt.length)) for(var Ue = -1, We, wt; ++Ue < We;)we.push(wt[Ue]);
                    for(; (Z = Be.pop()) != null;)oe(Z);
                }
                function sv(Z) {
                    return Z.children;
                }
                function Lf(Z) {
                    return Z.value;
                }
                function Uf(Z, oe) {
                    return oe.value - Z.value;
                }
                function Iu(Z) {
                    return e.merge(Z.map(function(oe) {
                        return (oe.children || []).map(function(we) {
                            return {
                                source: oe,
                                target: we
                            };
                        });
                    }));
                }
                e.layout.partition = function() {
                    var Z = e.layout.hierarchy(), oe = [
                        1,
                        1
                    ];
                    function we(We, wt, tt, zt) {
                        var or = We.children;
                        if (We.x = wt, We.y = We.depth * zt, We.dx = tt, We.dy = zt, or && (Dr = or.length)) {
                            var lr = -1, Dr, Ir, oi;
                            for(tt = We.value ? tt / We.value : 0; ++lr < Dr;)we(Ir = or[lr], wt, oi = Ir.value * tt, zt), wt += oi;
                        }
                    }
                    function Be(We) {
                        var wt = We.children, tt = 0;
                        if (wt && (or = wt.length)) for(var zt = -1, or; ++zt < or;)tt = Math.max(tt, Be(wt[zt]));
                        return 1 + tt;
                    }
                    function Ue(We, wt) {
                        var tt = Z.call(this, We, wt);
                        return we(tt[0], 0, oe[0], oe[1] / Be(tt[0])), tt;
                    }
                    return Ue.size = function(We) {
                        return arguments.length ? (oe = We, Ue) : oe;
                    }, Gu(Ue, Z);
                }, e.layout.pie = function() {
                    var Z = Number, oe = oh, we = 0, Be = ht, Ue = 0;
                    function We(wt) {
                        var tt = wt.length, zt = wt.map(function(vi, ci) {
                            return +Z.call(We, vi, ci);
                        }), or = +(typeof we == "function" ? we.apply(this, arguments) : we), lr = (typeof Be == "function" ? Be.apply(this, arguments) : Be) - or, Dr = Math.min(Math.abs(lr) / tt, +(typeof Ue == "function" ? Ue.apply(this, arguments) : Ue)), Ir = Dr * (lr < 0 ? -1 : 1), oi = e.sum(zt), ui = oi ? (lr - tt * Ir) / oi : 0, qr = e.range(tt), Kr = [], ii;
                        return oe != null && qr.sort(oe === oh ? function(vi, ci) {
                            return zt[ci] - zt[vi];
                        } : function(vi, ci) {
                            return oe(wt[vi], wt[ci]);
                        }), qr.forEach(function(vi) {
                            Kr[vi] = {
                                data: wt[vi],
                                value: ii = zt[vi],
                                startAngle: or,
                                endAngle: or += ii * ui + Ir,
                                padAngle: Dr
                            };
                        }), Kr;
                    }
                    return We.value = function(wt) {
                        return arguments.length ? (Z = wt, We) : Z;
                    }, We.sort = function(wt) {
                        return arguments.length ? (oe = wt, We) : oe;
                    }, We.startAngle = function(wt) {
                        return arguments.length ? (we = wt, We) : we;
                    }, We.endAngle = function(wt) {
                        return arguments.length ? (Be = wt, We) : Be;
                    }, We.padAngle = function(wt) {
                        return arguments.length ? (Ue = wt, We) : Ue;
                    }, We;
                };
                var oh = {};
                e.layout.stack = function() {
                    var Z = H, oe = _u, we = xu, Be = md, Ue = ru, We = vf;
                    function wt(tt, zt) {
                        if (!(ui = tt.length)) return tt;
                        var or = tt.map(function(vi, ci) {
                            return Z.call(wt, vi, ci);
                        }), lr = or.map(function(vi) {
                            return vi.map(function(ci, Jr) {
                                return [
                                    Ue.call(wt, ci, Jr),
                                    We.call(wt, ci, Jr)
                                ];
                            });
                        }), Dr = oe.call(wt, lr, zt);
                        or = e.permute(or, Dr), lr = e.permute(lr, Dr);
                        var Ir = we.call(wt, lr, zt), oi = or[0].length, ui, qr, Kr, ii;
                        for(Kr = 0; Kr < oi; ++Kr)for(Be.call(wt, or[0][Kr], ii = Ir[Kr], lr[0][Kr][1]), qr = 1; qr < ui; ++qr)Be.call(wt, or[qr][Kr], ii += lr[qr - 1][Kr][1], lr[qr][Kr][1]);
                        return tt;
                    }
                    return wt.values = function(tt) {
                        return arguments.length ? (Z = tt, wt) : Z;
                    }, wt.order = function(tt) {
                        return arguments.length ? (oe = typeof tt == "function" ? tt : sh.get(tt) || _u, wt) : oe;
                    }, wt.offset = function(tt) {
                        return arguments.length ? (we = typeof tt == "function" ? tt : Fs.get(tt) || xu, wt) : we;
                    }, wt.x = function(tt) {
                        return arguments.length ? (Ue = tt, wt) : Ue;
                    }, wt.y = function(tt) {
                        return arguments.length ? (We = tt, wt) : We;
                    }, wt.out = function(tt) {
                        return arguments.length ? (Be = tt, wt) : Be;
                    }, wt;
                };
                function ru(Z) {
                    return Z.x;
                }
                function vf(Z) {
                    return Z.y;
                }
                function md(Z, oe, we) {
                    Z.y0 = oe, Z.y = we;
                }
                var sh = e.map({
                    "inside-out": function(Z) {
                        var oe = Z.length, we, Be, Ue = Z.map(Lh), We = Z.map(Is), wt = e.range(oe).sort(function(Dr, Ir) {
                            return Ue[Dr] - Ue[Ir];
                        }), tt = 0, zt = 0, or = [], lr = [];
                        for(we = 0; we < oe; ++we)Be = wt[we], tt < zt ? (tt += We[Be], or.push(Be)) : (zt += We[Be], lr.push(Be));
                        return lr.reverse().concat(or);
                    },
                    reverse: function(Z) {
                        return e.range(Z.length).reverse();
                    },
                    default: _u
                }), Fs = e.map({
                    silhouette: function(Z) {
                        var oe = Z.length, we = Z[0].length, Be = [], Ue = 0, We, wt, tt, zt = [];
                        for(wt = 0; wt < we; ++wt){
                            for(We = 0, tt = 0; We < oe; We++)tt += Z[We][wt][1];
                            tt > Ue && (Ue = tt), Be.push(tt);
                        }
                        for(wt = 0; wt < we; ++wt)zt[wt] = (Ue - Be[wt]) / 2;
                        return zt;
                    },
                    wiggle: function(Z) {
                        var oe = Z.length, we = Z[0], Be = we.length, Ue, We, wt, tt, zt, or, lr, Dr, Ir, oi = [];
                        for(oi[0] = Dr = Ir = 0, We = 1; We < Be; ++We){
                            for(Ue = 0, tt = 0; Ue < oe; ++Ue)tt += Z[Ue][We][1];
                            for(Ue = 0, zt = 0, lr = we[We][0] - we[We - 1][0]; Ue < oe; ++Ue){
                                for(wt = 0, or = (Z[Ue][We][1] - Z[Ue][We - 1][1]) / (2 * lr); wt < Ue; ++wt)or += (Z[wt][We][1] - Z[wt][We - 1][1]) / lr;
                                zt += or * Z[Ue][We][1];
                            }
                            oi[We] = Dr -= tt ? zt / tt * lr : 0, Dr < Ir && (Ir = Dr);
                        }
                        for(We = 0; We < Be; ++We)oi[We] -= Ir;
                        return oi;
                    },
                    expand: function(Z) {
                        var oe = Z.length, we = Z[0].length, Be = 1 / oe, Ue, We, wt, tt = [];
                        for(We = 0; We < we; ++We){
                            for(Ue = 0, wt = 0; Ue < oe; Ue++)wt += Z[Ue][We][1];
                            if (wt) for(Ue = 0; Ue < oe; Ue++)Z[Ue][We][1] /= wt;
                            else for(Ue = 0; Ue < oe; Ue++)Z[Ue][We][1] = Be;
                        }
                        for(We = 0; We < we; ++We)tt[We] = 0;
                        return tt;
                    },
                    zero: xu
                });
                function _u(Z) {
                    return e.range(Z.length);
                }
                function xu(Z) {
                    for(var oe = -1, we = Z[0].length, Be = []; ++oe < we;)Be[oe] = 0;
                    return Be;
                }
                function Lh(Z) {
                    for(var oe = 1, we = 0, Be = Z[0][1], Ue, We = Z.length; oe < We; ++oe)(Ue = Z[oe][1]) > Be && (we = oe, Be = Ue);
                    return we;
                }
                function Is(Z) {
                    return Z.reduce(Pf, 0);
                }
                function Pf(Z, oe) {
                    return Z + oe[1];
                }
                e.layout.histogram = function() {
                    var Z = !0, oe = Number, we = Vf, Be = Ic;
                    function Ue(We, Ir) {
                        for(var tt = [], zt = We.map(oe, this), or = we.call(this, zt, Ir), lr = Be.call(this, or, zt, Ir), Dr, Ir = -1, oi = zt.length, ui = lr.length - 1, qr = Z ? 1 : 1 / oi, Kr; ++Ir < ui;)Dr = tt[Ir] = [], Dr.dx = lr[Ir + 1] - (Dr.x = lr[Ir]), Dr.y = 0;
                        if (ui > 0) for(Ir = -1; ++Ir < oi;)Kr = zt[Ir], Kr >= or[0] && Kr <= or[1] && (Dr = tt[e.bisect(lr, Kr, 1, ui) - 1], Dr.y += qr, Dr.push(We[Ir]));
                        return tt;
                    }
                    return Ue.value = function(We) {
                        return arguments.length ? (oe = We, Ue) : oe;
                    }, Ue.range = function(We) {
                        return arguments.length ? (we = ti(We), Ue) : we;
                    }, Ue.bins = function(We) {
                        return arguments.length ? (Be = typeof We == "number" ? function(wt) {
                            return ju(wt, We);
                        } : ti(We), Ue) : Be;
                    }, Ue.frequency = function(We) {
                        return arguments.length ? (Z = !!We, Ue) : Z;
                    }, Ue;
                };
                function Ic(Z, oe) {
                    return ju(Z, Math.ceil(Math.log(oe.length) / Math.LN2 + 1));
                }
                function ju(Z, oe) {
                    for(var we = -1, Be = +Z[0], Ue = (Z[1] - Be) / oe, We = []; ++we <= oe;)We[we] = Ue * we + Be;
                    return We;
                }
                function Vf(Z) {
                    return [
                        e.min(Z),
                        e.max(Z)
                    ];
                }
                e.layout.pack = function() {
                    var Z = e.layout.hierarchy().sort(pc), oe = 0, we = [
                        1,
                        1
                    ], Be;
                    function Ue(We, wt) {
                        var tt = Z.call(this, We, wt), zt = tt[0], or = we[0], lr = we[1], Dr = Be == null ? Math.sqrt : typeof Be == "function" ? Be : function() {
                            return Be;
                        };
                        if (zt.x = zt.y = 0, vc(zt, function(oi) {
                            oi.r = +Dr(oi.value);
                        }), vc(zt, Ih), oe) {
                            var Ir = oe * (Be ? 1 : Math.max(2 * zt.r / or, 2 * zt.r / lr)) / 2;
                            vc(zt, function(oi) {
                                oi.r += Ir;
                            }), vc(zt, Ih), vc(zt, function(oi) {
                                oi.r -= Ir;
                            });
                        }
                        return gc(zt, or / 2, lr / 2, Be ? 1 : 1 / Math.max(2 * zt.r / or, 2 * zt.r / lr)), tt;
                    }
                    return Ue.size = function(We) {
                        return arguments.length ? (we = We, Ue) : we;
                    }, Ue.radius = function(We) {
                        return arguments.length ? (Be = We == null || typeof We == "function" ? We : +We, Ue) : Be;
                    }, Ue.padding = function(We) {
                        return arguments.length ? (oe = +We, Ue) : oe;
                    }, Gu(Ue, Z);
                };
                function pc(Z, oe) {
                    return Z.value - oe.value;
                }
                function pf(Z, oe) {
                    var we = Z._pack_next;
                    Z._pack_next = oe, oe._pack_prev = Z, oe._pack_next = we, we._pack_prev = oe;
                }
                function Ph(Z, oe) {
                    Z._pack_next = oe, oe._pack_prev = Z;
                }
                function Dl(Z, oe) {
                    var we = oe.x - Z.x, Be = oe.y - Z.y, Ue = Z.r + oe.r;
                    return .999 * Ue * Ue > we * we + Be * Be;
                }
                function Ih(Z) {
                    if (!(oe = Z.children) || !(Ir = oe.length)) return;
                    var oe, we = 1 / 0, Be = -1 / 0, Ue = 1 / 0, We = -1 / 0, wt, tt, zt, or, lr, Dr, Ir;
                    function oi(Jr) {
                        we = Math.min(Jr.x - Jr.r, we), Be = Math.max(Jr.x + Jr.r, Be), Ue = Math.min(Jr.y - Jr.r, Ue), We = Math.max(Jr.y + Jr.r, We);
                    }
                    if (oe.forEach(Wu), wt = oe[0], wt.x = -wt.r, wt.y = 0, oi(wt), Ir > 1 && (tt = oe[1], tt.x = tt.r, tt.y = 0, oi(tt), Ir > 2)) for(zt = oe[2], hl(wt, tt, zt), oi(zt), pf(wt, zt), wt._pack_prev = zt, pf(zt, tt), tt = wt._pack_next, or = 3; or < Ir; or++){
                        hl(wt, tt, zt = oe[or]);
                        var ui = 0, qr = 1, Kr = 1;
                        for(lr = tt._pack_next; lr !== tt; lr = lr._pack_next, qr++)if (Dl(lr, zt)) {
                            ui = 1;
                            break;
                        }
                        if (ui == 1) for(Dr = wt._pack_prev; Dr !== lr._pack_prev && !Dl(Dr, zt); Dr = Dr._pack_prev, Kr++);
                        ui ? (qr < Kr || qr == Kr && tt.r < wt.r ? Ph(wt, tt = lr) : Ph(wt = Dr, tt), or--) : (pf(wt, zt), tt = zt, oi(zt));
                    }
                    var ii = (we + Be) / 2, vi = (Ue + We) / 2, ci = 0;
                    for(or = 0; or < Ir; or++)zt = oe[or], zt.x -= ii, zt.y -= vi, ci = Math.max(ci, zt.r + Math.sqrt(zt.x * zt.x + zt.y * zt.y));
                    Z.r = ci, oe.forEach(Rc);
                }
                function Wu(Z) {
                    Z._pack_next = Z._pack_prev = Z;
                }
                function Rc(Z) {
                    delete Z._pack_next, delete Z._pack_prev;
                }
                function gc(Z, oe, we, Be) {
                    var Ue = Z.children;
                    if (Z.x = oe += Be * Z.x, Z.y = we += Be * Z.y, Z.r *= Be, Ue) for(var We = -1, wt = Ue.length; ++We < wt;)gc(Ue[We], oe, we, Be);
                }
                function hl(Z, oe, we) {
                    var Be = Z.r + we.r, Ue = oe.x - Z.x, We = oe.y - Z.y;
                    if (Be && (Ue || We)) {
                        var wt = oe.r + we.r, tt = Ue * Ue + We * We;
                        wt *= wt, Be *= Be;
                        var zt = .5 + (Be - wt) / (2 * tt), or = Math.sqrt(Math.max(0, 2 * wt * (Be + tt) - (Be -= tt) * Be - wt * wt)) / (2 * tt);
                        we.x = Z.x + zt * Ue + or * We, we.y = Z.y + zt * We - or * Ue;
                    } else we.x = Z.x + Be, we.y = Z.y;
                }
                e.layout.tree = function() {
                    var Z = e.layout.hierarchy().sort(null).value(null), oe = iu, we = [
                        1,
                        1
                    ], Be = null;
                    function Ue(lr, Dr) {
                        var Ir = Z.call(this, lr, Dr), oi = Ir[0], ui = We(oi);
                        if (vc(ui, wt), ui.parent.m = -ui.z, Pc(ui, tt), Be) Pc(oi, or);
                        else {
                            var qr = oi, Kr = oi, ii = oi;
                            Pc(oi, function(un) {
                                un.x < qr.x && (qr = un), un.x > Kr.x && (Kr = un), un.depth > ii.depth && (ii = un);
                            });
                            var vi = oe(qr, Kr) / 2 - qr.x, ci = we[0] / (Kr.x + oe(Kr, qr) / 2 + vi), Jr = we[1] / (ii.depth || 1);
                            Pc(oi, function(un) {
                                un.x = (un.x + vi) * ci, un.y = un.depth * Jr;
                            });
                        }
                        return Ir;
                    }
                    function We(lr) {
                        for(var Dr = {
                            A: null,
                            children: [
                                lr
                            ]
                        }, Ir = [
                            Dr
                        ], oi; (oi = Ir.pop()) != null;)for(var ui = oi.children, qr, Kr = 0, ii = ui.length; Kr < ii; ++Kr)Ir.push((ui[Kr] = qr = {
                            _: ui[Kr],
                            parent: oi,
                            children: (qr = ui[Kr].children) && qr.slice() || [],
                            A: null,
                            a: null,
                            z: 0,
                            m: 0,
                            c: 0,
                            s: 0,
                            t: null,
                            i: Kr
                        }).a = qr);
                        return Dr.children[0];
                    }
                    function wt(lr) {
                        var Dr = lr.children, Ir = lr.parent.children, oi = lr.i ? Ir[lr.i - 1] : null;
                        if (Dr.length) {
                            gf(lr);
                            var ui = (Dr[0].z + Dr[Dr.length - 1].z) / 2;
                            oi ? (lr.z = oi.z + oe(lr._, oi._), lr.m = lr.z - ui) : lr.z = ui;
                        } else oi && (lr.z = oi.z + oe(lr._, oi._));
                        lr.parent.A = zt(lr, oi, lr.parent.A || Ir[0]);
                    }
                    function tt(lr) {
                        lr._.x = lr.z + lr.parent.m, lr.m += lr.parent.m;
                    }
                    function zt(lr, Dr, Ir) {
                        if (Dr) {
                            for(var oi = lr, ui = lr, qr = Dr, Kr = oi.parent.children[0], ii = oi.m, vi = ui.m, ci = qr.m, Jr = Kr.m, un; qr = Yc(qr), oi = mc(oi), qr && oi;)Kr = mc(Kr), ui = Yc(ui), ui.a = lr, un = qr.z + ci - oi.z - ii + oe(qr._, oi._), un > 0 && (nc(gt(qr, lr, Ir), lr, un), ii += un, vi += un), ci += qr.m, ii += oi.m, Jr += Kr.m, vi += ui.m;
                            qr && !Yc(ui) && (ui.t = qr, ui.m += ci - vi), oi && !mc(Kr) && (Kr.t = oi, Kr.m += ii - Jr, Ir = lr);
                        }
                        return Ir;
                    }
                    function or(lr) {
                        lr.x *= we[0], lr.y = lr.depth * we[1];
                    }
                    return Ue.separation = function(lr) {
                        return arguments.length ? (oe = lr, Ue) : oe;
                    }, Ue.size = function(lr) {
                        return arguments.length ? (Be = (we = lr) == null ? or : null, Ue) : Be ? null : we;
                    }, Ue.nodeSize = function(lr) {
                        return arguments.length ? (Be = (we = lr) == null ? null : or, Ue) : Be ? we : null;
                    }, Gu(Ue, Z);
                };
                function iu(Z, oe) {
                    return Z.parent == oe.parent ? 1 : 2;
                }
                function mc(Z) {
                    var oe = Z.children;
                    return oe.length ? oe[0] : Z.t;
                }
                function Yc(Z) {
                    var oe = Z.children, we;
                    return (we = oe.length) ? oe[we - 1] : Z.t;
                }
                function nc(Z, oe, we) {
                    var Be = we / (oe.i - Z.i);
                    oe.c -= Be, oe.s += we, Z.c += Be, oe.z += we, oe.m += we;
                }
                function gf(Z) {
                    for(var oe = 0, we = 0, Be = Z.children, Ue = Be.length, We; --Ue >= 0;)We = Be[Ue], We.z += oe, We.m += oe, oe += We.s + (we += We.c);
                }
                function gt(Z, oe, we) {
                    return Z.a.parent === oe.parent ? Z.a : we;
                }
                e.layout.cluster = function() {
                    var Z = e.layout.hierarchy().sort(null).value(null), oe = iu, we = [
                        1,
                        1
                    ], Be = !1;
                    function Ue(We, wt) {
                        var tt = Z.call(this, We, wt), zt = tt[0], or, lr = 0;
                        vc(zt, function(qr) {
                            var Kr = qr.children;
                            Kr && Kr.length ? (qr.x = wr(Kr), qr.y = Bt(Kr)) : (qr.x = or ? lr += oe(qr, or) : 0, qr.y = 0, or = qr);
                        });
                        var Dr = vr(zt), Ir = Ur(zt), oi = Dr.x - oe(Dr, Ir) / 2, ui = Ir.x + oe(Ir, Dr) / 2;
                        return vc(zt, Be ? function(qr) {
                            qr.x = (qr.x - zt.x) * we[0], qr.y = (zt.y - qr.y) * we[1];
                        } : function(qr) {
                            qr.x = (qr.x - oi) / (ui - oi) * we[0], qr.y = (1 - (zt.y ? qr.y / zt.y : 1)) * we[1];
                        }), tt;
                    }
                    return Ue.separation = function(We) {
                        return arguments.length ? (oe = We, Ue) : oe;
                    }, Ue.size = function(We) {
                        return arguments.length ? (Be = (we = We) == null, Ue) : Be ? null : we;
                    }, Ue.nodeSize = function(We) {
                        return arguments.length ? (Be = (we = We) != null, Ue) : Be ? we : null;
                    }, Gu(Ue, Z);
                };
                function Bt(Z) {
                    return 1 + e.max(Z, function(oe) {
                        return oe.y;
                    });
                }
                function wr(Z) {
                    return Z.reduce(function(oe, we) {
                        return oe + we.x;
                    }, 0) / Z.length;
                }
                function vr(Z) {
                    var oe = Z.children;
                    return oe && oe.length ? vr(oe[0]) : Z;
                }
                function Ur(Z) {
                    var oe = Z.children, we;
                    return oe && (we = oe.length) ? Ur(oe[we - 1]) : Z;
                }
                e.layout.treemap = function() {
                    var Z = e.layout.hierarchy(), oe = Math.round, we = [
                        1,
                        1
                    ], Be = null, Ue = fi, We = !1, wt, tt = "squarify", zt = .5 * (1 + Math.sqrt(5));
                    function or(qr, Kr) {
                        for(var ii = -1, vi = qr.length, ci, Jr; ++ii < vi;)Jr = (ci = qr[ii]).value * (Kr < 0 ? 0 : Kr), ci.area = isNaN(Jr) || Jr <= 0 ? 0 : Jr;
                    }
                    function lr(qr) {
                        var Kr = qr.children;
                        if (Kr && Kr.length) {
                            var ii = Ue(qr), vi = [], ci = Kr.slice(), Jr, un = 1 / 0, dn, En = tt === "slice" ? ii.dx : tt === "dice" ? ii.dy : tt === "slice-dice" ? qr.depth & 1 ? ii.dy : ii.dx : Math.min(ii.dx, ii.dy), Nn;
                            for(or(ci, ii.dx * ii.dy / qr.value), vi.area = 0; (Nn = ci.length) > 0;)vi.push(Jr = ci[Nn - 1]), vi.area += Jr.area, tt !== "squarify" || (dn = Ir(vi, En)) <= un ? (ci.pop(), un = dn) : (vi.area -= vi.pop().area, oi(vi, En, ii, !1), En = Math.min(ii.dx, ii.dy), vi.length = vi.area = 0, un = 1 / 0);
                            vi.length && (oi(vi, En, ii, !0), vi.length = vi.area = 0), Kr.forEach(lr);
                        }
                    }
                    function Dr(qr) {
                        var Kr = qr.children;
                        if (Kr && Kr.length) {
                            var ii = Ue(qr), vi = Kr.slice(), ci, Jr = [];
                            for(or(vi, ii.dx * ii.dy / qr.value), Jr.area = 0; ci = vi.pop();)Jr.push(ci), Jr.area += ci.area, ci.z != null && (oi(Jr, ci.z ? ii.dx : ii.dy, ii, !vi.length), Jr.length = Jr.area = 0);
                            Kr.forEach(Dr);
                        }
                    }
                    function Ir(qr, Kr) {
                        for(var ii = qr.area, vi, ci = 0, Jr = 1 / 0, un = -1, dn = qr.length; ++un < dn;)(vi = qr[un].area) && (vi < Jr && (Jr = vi), vi > ci && (ci = vi));
                        return ii *= ii, Kr *= Kr, ii ? Math.max(Kr * ci * zt / ii, ii / (Kr * Jr * zt)) : 1 / 0;
                    }
                    function oi(qr, Kr, ii, vi) {
                        var ci = -1, Jr = qr.length, un = ii.x, dn = ii.y, En = Kr ? oe(qr.area / Kr) : 0, Nn;
                        if (Kr == ii.dx) {
                            for((vi || En > ii.dy) && (En = ii.dy); ++ci < Jr;)Nn = qr[ci], Nn.x = un, Nn.y = dn, Nn.dy = En, un += Nn.dx = Math.min(ii.x + ii.dx - un, En ? oe(Nn.area / En) : 0);
                            Nn.z = !0, Nn.dx += ii.x + ii.dx - un, ii.y += En, ii.dy -= En;
                        } else {
                            for((vi || En > ii.dx) && (En = ii.dx); ++ci < Jr;)Nn = qr[ci], Nn.x = un, Nn.y = dn, Nn.dx = En, dn += Nn.dy = Math.min(ii.y + ii.dy - dn, En ? oe(Nn.area / En) : 0);
                            Nn.z = !1, Nn.dy += ii.y + ii.dy - dn, ii.x += En, ii.dx -= En;
                        }
                    }
                    function ui(qr) {
                        var Kr = wt || Z(qr), ii = Kr[0];
                        return ii.x = ii.y = 0, ii.value ? (ii.dx = we[0], ii.dy = we[1]) : ii.dx = ii.dy = 0, wt && Z.revalue(ii), or([
                            ii
                        ], ii.dx * ii.dy / ii.value), (wt ? Dr : lr)(ii), We && (wt = Kr), Kr;
                    }
                    return ui.size = function(qr) {
                        return arguments.length ? (we = qr, ui) : we;
                    }, ui.padding = function(qr) {
                        if (!arguments.length) return Be;
                        function Kr(ci) {
                            var Jr = qr.call(ui, ci, ci.depth);
                            return Jr == null ? fi(ci) : xi(ci, typeof Jr == "number" ? [
                                Jr,
                                Jr,
                                Jr,
                                Jr
                            ] : Jr);
                        }
                        function ii(ci) {
                            return xi(ci, qr);
                        }
                        var vi;
                        return Ue = (Be = qr) == null ? fi : (vi = typeof qr) == "function" ? Kr : (vi === "number" && (qr = [
                            qr,
                            qr,
                            qr,
                            qr
                        ]), ii), ui;
                    }, ui.round = function(qr) {
                        return arguments.length ? (oe = qr ? Math.round : Number, ui) : oe != Number;
                    }, ui.sticky = function(qr) {
                        return arguments.length ? (We = qr, wt = null, ui) : We;
                    }, ui.ratio = function(qr) {
                        return arguments.length ? (zt = qr, ui) : zt;
                    }, ui.mode = function(qr) {
                        return arguments.length ? (tt = qr + "", ui) : tt;
                    }, Gu(ui, Z);
                };
                function fi(Z) {
                    return {
                        x: Z.x,
                        y: Z.y,
                        dx: Z.dx,
                        dy: Z.dy
                    };
                }
                function xi(Z, oe) {
                    var we = Z.x + oe[3], Be = Z.y + oe[0], Ue = Z.dx - oe[1] - oe[3], We = Z.dy - oe[0] - oe[2];
                    return Ue < 0 && (we += Ue / 2, Ue = 0), We < 0 && (Be += We / 2, We = 0), {
                        x: we,
                        y: Be,
                        dx: Ue,
                        dy: We
                    };
                }
                e.random = {
                    normal: function(Z, oe) {
                        var we = arguments.length;
                        return we < 2 && (oe = 1), we < 1 && (Z = 0), function() {
                            var Be, Ue, We;
                            do Be = Math.random() * 2 - 1, Ue = Math.random() * 2 - 1, We = Be * Be + Ue * Ue;
                            while (!We || We > 1);
                            return Z + oe * Be * Math.sqrt(-2 * Math.log(We) / We);
                        };
                    },
                    logNormal: function() {
                        var Z = e.random.normal.apply(e, arguments);
                        return function() {
                            return Math.exp(Z());
                        };
                    },
                    bates: function(Z) {
                        var oe = e.random.irwinHall(Z);
                        return function() {
                            return oe() / Z;
                        };
                    },
                    irwinHall: function(Z) {
                        return function() {
                            for(var oe = 0, we = 0; we < Z; we++)oe += Math.random();
                            return oe;
                        };
                    }
                }, e.scale = {};
                function Fi(Z) {
                    var oe = Z[0], we = Z[Z.length - 1];
                    return oe < we ? [
                        oe,
                        we
                    ] : [
                        we,
                        oe
                    ];
                }
                function Xi(Z) {
                    return Z.rangeExtent ? Z.rangeExtent() : Fi(Z.range());
                }
                function hn(Z, oe, we, Be) {
                    var Ue = we(Z[0], Z[1]), We = Be(oe[0], oe[1]);
                    return function(wt) {
                        return We(Ue(wt));
                    };
                }
                function Ti(Z, oe) {
                    var we = 0, Be = Z.length - 1, Ue = Z[we], We = Z[Be], wt;
                    return We < Ue && (wt = we, we = Be, Be = wt, wt = Ue, Ue = We, We = wt), Z[we] = oe.floor(Ue), Z[Be] = oe.ceil(We), Z;
                }
                function qi(Z) {
                    return Z ? {
                        floor: function(oe) {
                            return Math.floor(oe / Z) * Z;
                        },
                        ceil: function(oe) {
                            return Math.ceil(oe / Z) * Z;
                        }
                    } : Ii;
                }
                var Ii = {
                    floor: H,
                    ceil: H
                };
                function mi(Z, oe, we, Be) {
                    var Ue = [], We = [], wt = 0, tt = Math.min(Z.length, oe.length) - 1;
                    for(Z[tt] < Z[0] && (Z = Z.slice().reverse(), oe = oe.slice().reverse()); ++wt <= tt;)Ue.push(we(Z[wt - 1], Z[wt])), We.push(Be(oe[wt - 1], oe[wt]));
                    return function(zt) {
                        var or = e.bisect(Z, zt, 1, tt) - 1;
                        return We[or](Ue[or](zt));
                    };
                }
                e.scale.linear = function() {
                    return Pn([
                        0,
                        1
                    ], [
                        0,
                        1
                    ], Sl, !1);
                };
                function Pn(Z, oe, we, Be) {
                    var Ue, We;
                    function wt() {
                        var zt = Math.min(Z.length, oe.length) > 2 ? mi : hn, or = Be ? Lu : pd;
                        return Ue = zt(Z, oe, or, we), We = zt(oe, Z, or, Sl), tt;
                    }
                    function tt(zt) {
                        return Ue(zt);
                    }
                    return tt.invert = function(zt) {
                        return We(zt);
                    }, tt.domain = function(zt) {
                        return arguments.length ? (Z = zt.map(Number), wt()) : Z;
                    }, tt.range = function(zt) {
                        return arguments.length ? (oe = zt, wt()) : oe;
                    }, tt.rangeRound = function(zt) {
                        return tt.range(zt).interpolate(rc);
                    }, tt.clamp = function(zt) {
                        return arguments.length ? (Be = zt, wt()) : Be;
                    }, tt.interpolate = function(zt) {
                        return arguments.length ? (we = zt, wt()) : we;
                    }, tt.ticks = function(zt) {
                        return qa(Z, zt);
                    }, tt.tickFormat = function(zt, or) {
                        return d3_scale_linearTickFormat(Z, zt, or);
                    }, tt.nice = function(zt) {
                        return Ta(Z, zt), wt();
                    }, tt.copy = function() {
                        return Pn(Z, oe, we, Be);
                    }, wt();
                }
                function Ma(Z, oe) {
                    return e.rebind(Z, oe, "range", "rangeRound", "interpolate", "clamp");
                }
                function Ta(Z, oe) {
                    return Ti(Z, qi(Ea(Z, oe)[2])), Ti(Z, qi(Ea(Z, oe)[2])), Z;
                }
                function Ea(Z, oe) {
                    oe == null && (oe = 10);
                    var we = Fi(Z), Be = we[1] - we[0], Ue = Math.pow(10, Math.floor(Math.log(Be / oe) / Math.LN10)), We = oe / Be * Ue;
                    return We <= .15 ? Ue *= 10 : We <= .35 ? Ue *= 5 : We <= .75 && (Ue *= 2), we[0] = Math.ceil(we[0] / Ue) * Ue, we[1] = Math.floor(we[1] / Ue) * Ue + Ue * .5, we[2] = Ue, we;
                }
                function qa(Z, oe) {
                    return e.range.apply(e, Ea(Z, oe));
                }
                var Cn = {
                    s: 1,
                    g: 1,
                    p: 1,
                    r: 1,
                    e: 1
                };
                function sn(Z) {
                    return -Math.floor(Math.log(Z) / Math.LN10 + .01);
                }
                function Ua(Z, oe) {
                    var we = sn(oe[2]);
                    return Z in Cn ? Math.abs(we - sn(Math.max(p(oe[0]), p(oe[1])))) + +(Z !== "e") : we - (Z === "%") * 2;
                }
                e.scale.log = function() {
                    return mo(e.scale.linear().domain([
                        0,
                        1
                    ]), 10, !0, [
                        1,
                        10
                    ]);
                };
                function mo(Z, oe, we, Be) {
                    function Ue(tt) {
                        return (we ? Math.log(tt < 0 ? 0 : tt) : -Math.log(tt > 0 ? 0 : -tt)) / Math.log(oe);
                    }
                    function We(tt) {
                        return we ? Math.pow(oe, tt) : -Math.pow(oe, -tt);
                    }
                    function wt(tt) {
                        return Z(Ue(tt));
                    }
                    return wt.invert = function(tt) {
                        return We(Z.invert(tt));
                    }, wt.domain = function(tt) {
                        return arguments.length ? (we = tt[0] >= 0, Z.domain((Be = tt.map(Number)).map(Ue)), wt) : Be;
                    }, wt.base = function(tt) {
                        return arguments.length ? (oe = +tt, Z.domain(Be.map(Ue)), wt) : oe;
                    }, wt.nice = function() {
                        var tt = Ti(Be.map(Ue), we ? Math : Xo);
                        return Z.domain(tt), Be = tt.map(We), wt;
                    }, wt.ticks = function() {
                        var tt = Fi(Be), zt = [], or = tt[0], lr = tt[1], Dr = Math.floor(Ue(or)), Ir = Math.ceil(Ue(lr)), oi = oe % 1 ? 2 : oe;
                        if (isFinite(Ir - Dr)) {
                            if (we) {
                                for(; Dr < Ir; Dr++)for(var ui = 1; ui < oi; ui++)zt.push(We(Dr) * ui);
                                zt.push(We(Dr));
                            } else for(zt.push(We(Dr)); Dr++ < Ir;)for(var ui = oi - 1; ui > 0; ui--)zt.push(We(Dr) * ui);
                            for(Dr = 0; zt[Dr] < or; Dr++);
                            for(Ir = zt.length; zt[Ir - 1] > lr; Ir--);
                            zt = zt.slice(Dr, Ir);
                        }
                        return zt;
                    }, wt.copy = function() {
                        return mo(Z.copy(), oe, we, Be);
                    }, Ma(wt, Z);
                }
                var Xo = {
                    floor: function(Z) {
                        return -Math.ceil(-Z);
                    },
                    ceil: function(Z) {
                        return -Math.floor(-Z);
                    }
                };
                e.scale.pow = function() {
                    return Ts(e.scale.linear(), 1, [
                        0,
                        1
                    ]);
                };
                function Ts(Z, oe, we) {
                    var Be = Qo(oe), Ue = Qo(1 / oe);
                    function We(wt) {
                        return Z(Be(wt));
                    }
                    return We.invert = function(wt) {
                        return Ue(Z.invert(wt));
                    }, We.domain = function(wt) {
                        return arguments.length ? (Z.domain((we = wt.map(Number)).map(Be)), We) : we;
                    }, We.ticks = function(wt) {
                        return qa(we, wt);
                    }, We.tickFormat = function(wt, tt) {
                        return d3_scale_linearTickFormat(we, wt, tt);
                    }, We.nice = function(wt) {
                        return We.domain(Ta(we, wt));
                    }, We.exponent = function(wt) {
                        return arguments.length ? (Be = Qo(oe = wt), Ue = Qo(1 / oe), Z.domain(we.map(Be)), We) : oe;
                    }, We.copy = function() {
                        return Ts(Z.copy(), oe, we);
                    }, Ma(We, Z);
                }
                function Qo(Z) {
                    return function(oe) {
                        return oe < 0 ? -Math.pow(-oe, Z) : Math.pow(oe, Z);
                    };
                }
                e.scale.sqrt = function() {
                    return e.scale.pow().exponent(.5);
                }, e.scale.ordinal = function() {
                    return ys([], {
                        t: "range",
                        a: [
                            []
                        ]
                    });
                };
                function ys(Z, oe) {
                    var we, Be, Ue;
                    function We(tt) {
                        return Be[((we.get(tt) || (oe.t === "range" ? we.set(tt, Z.push(tt)) : NaN)) - 1) % Be.length];
                    }
                    function wt(tt, zt) {
                        return e.range(Z.length).map(function(or) {
                            return tt + zt * or;
                        });
                    }
                    return We.domain = function(tt) {
                        if (!arguments.length) return Z;
                        Z = [], we = new A;
                        for(var zt = -1, or = tt.length, lr; ++zt < or;)we.has(lr = tt[zt]) || we.set(lr, Z.push(lr));
                        return We[oe.t].apply(We, oe.a);
                    }, We.range = function(tt) {
                        return arguments.length ? (Be = tt, Ue = 0, oe = {
                            t: "range",
                            a: arguments
                        }, We) : Be;
                    }, We.rangePoints = function(tt, zt) {
                        arguments.length < 2 && (zt = 0);
                        var or = tt[0], lr = tt[1], Dr = Z.length < 2 ? (or = (or + lr) / 2, 0) : (lr - or) / (Z.length - 1 + zt);
                        return Be = wt(or + Dr * zt / 2, Dr), Ue = 0, oe = {
                            t: "rangePoints",
                            a: arguments
                        }, We;
                    }, We.rangeRoundPoints = function(tt, zt) {
                        arguments.length < 2 && (zt = 0);
                        var or = tt[0], lr = tt[1], Dr = Z.length < 2 ? (or = lr = Math.round((or + lr) / 2), 0) : (lr - or) / (Z.length - 1 + zt) | 0;
                        return Be = wt(or + Math.round(Dr * zt / 2 + (lr - or - (Z.length - 1 + zt) * Dr) / 2), Dr), Ue = 0, oe = {
                            t: "rangeRoundPoints",
                            a: arguments
                        }, We;
                    }, We.rangeBands = function(tt, zt, or) {
                        arguments.length < 2 && (zt = 0), arguments.length < 3 && (or = zt);
                        var lr = tt[1] < tt[0], Dr = tt[lr - 0], Ir = tt[1 - lr], oi = (Ir - Dr) / (Z.length - zt + 2 * or);
                        return Be = wt(Dr + oi * or, oi), lr && Be.reverse(), Ue = oi * (1 - zt), oe = {
                            t: "rangeBands",
                            a: arguments
                        }, We;
                    }, We.rangeRoundBands = function(tt, zt, or) {
                        arguments.length < 2 && (zt = 0), arguments.length < 3 && (or = zt);
                        var lr = tt[1] < tt[0], Dr = tt[lr - 0], Ir = tt[1 - lr], oi = Math.floor((Ir - Dr) / (Z.length - zt + 2 * or));
                        return Be = wt(Dr + Math.round((Ir - Dr - (Z.length - zt) * oi) / 2), oi), lr && Be.reverse(), Ue = Math.round(oi * (1 - zt)), oe = {
                            t: "rangeRoundBands",
                            a: arguments
                        }, We;
                    }, We.rangeBand = function() {
                        return Ue;
                    }, We.rangeExtent = function() {
                        return Fi(oe.a[0]);
                    }, We.copy = function() {
                        return ys(Z, oe);
                    }, We.domain(Z);
                }
                e.scale.category10 = function() {
                    return e.scale.ordinal().range(Bo);
                }, e.scale.category20 = function() {
                    return e.scale.ordinal().range(yl);
                }, e.scale.category20b = function() {
                    return e.scale.ordinal().range(Gs);
                }, e.scale.category20c = function() {
                    return e.scale.ordinal().range(Rs);
                };
                var Bo = [
                    2062260,
                    16744206,
                    2924588,
                    14034728,
                    9725885,
                    9197131,
                    14907330,
                    8355711,
                    12369186,
                    1556175
                ].map(jo), yl = [
                    2062260,
                    11454440,
                    16744206,
                    16759672,
                    2924588,
                    10018698,
                    14034728,
                    16750742,
                    9725885,
                    12955861,
                    9197131,
                    12885140,
                    14907330,
                    16234194,
                    8355711,
                    13092807,
                    12369186,
                    14408589,
                    1556175,
                    10410725
                ].map(jo), Gs = [
                    3750777,
                    5395619,
                    7040719,
                    10264286,
                    6519097,
                    9216594,
                    11915115,
                    13556636,
                    9202993,
                    12426809,
                    15186514,
                    15190932,
                    8666169,
                    11356490,
                    14049643,
                    15177372,
                    8077683,
                    10834324,
                    13528509,
                    14589654
                ].map(jo), Rs = [
                    3244733,
                    7057110,
                    10406625,
                    13032431,
                    15095053,
                    16616764,
                    16625259,
                    16634018,
                    3253076,
                    7652470,
                    10607003,
                    13101504,
                    7695281,
                    10394312,
                    12369372,
                    14342891,
                    6513507,
                    9868950,
                    12434877,
                    14277081
                ].map(jo);
                e.scale.quantile = function() {
                    return ia([], []);
                };
                function ia(Z, oe) {
                    var we;
                    function Be() {
                        var We = 0, wt = oe.length;
                        for(we = []; ++We < wt;)we[We - 1] = e.quantile(Z, We / wt);
                        return Ue;
                    }
                    function Ue(We) {
                        if (!isNaN(We = +We)) return oe[e.bisect(we, We)];
                    }
                    return Ue.domain = function(We) {
                        return arguments.length ? (Z = We.map(h).filter(d).sort(f), Be()) : Z;
                    }, Ue.range = function(We) {
                        return arguments.length ? (oe = We, Be()) : oe;
                    }, Ue.quantiles = function() {
                        return we;
                    }, Ue.invertExtent = function(We) {
                        return We = oe.indexOf(We), We < 0 ? [
                            NaN,
                            NaN
                        ] : [
                            We > 0 ? we[We - 1] : Z[0],
                            We < we.length ? we[We] : Z[Z.length - 1]
                        ];
                    }, Ue.copy = function() {
                        return ia(Z, oe);
                    }, Be();
                }
                e.scale.quantize = function() {
                    return Ka(0, 1, [
                        0,
                        1
                    ]);
                };
                function Ka(Z, oe, we) {
                    var Be, Ue;
                    function We(tt) {
                        return we[Math.max(0, Math.min(Ue, Math.floor(Be * (tt - Z))))];
                    }
                    function wt() {
                        return Be = we.length / (oe - Z), Ue = we.length - 1, We;
                    }
                    return We.domain = function(tt) {
                        return arguments.length ? (Z = +tt[0], oe = +tt[tt.length - 1], wt()) : [
                            Z,
                            oe
                        ];
                    }, We.range = function(tt) {
                        return arguments.length ? (we = tt, wt()) : we;
                    }, We.invertExtent = function(tt) {
                        return tt = we.indexOf(tt), tt = tt < 0 ? NaN : tt / Be + Z, [
                            tt,
                            tt + 1 / Be
                        ];
                    }, We.copy = function() {
                        return Ka(Z, oe, we);
                    }, wt();
                }
                e.scale.threshold = function() {
                    return vs([
                        .5
                    ], [
                        0,
                        1
                    ]);
                };
                function vs(Z, oe) {
                    function we(Be) {
                        if (Be <= Be) return oe[e.bisect(Z, Be)];
                    }
                    return we.domain = function(Be) {
                        return arguments.length ? (Z = Be, we) : Z;
                    }, we.range = function(Be) {
                        return arguments.length ? (oe = Be, we) : oe;
                    }, we.invertExtent = function(Be) {
                        return Be = oe.indexOf(Be), [
                            Z[Be - 1],
                            Z[Be]
                        ];
                    }, we.copy = function() {
                        return vs(Z, oe);
                    }, we;
                }
                e.scale.identity = function() {
                    return Ko([
                        0,
                        1
                    ]);
                };
                function Ko(Z) {
                    function oe(we) {
                        return +we;
                    }
                    return oe.invert = oe, oe.domain = oe.range = function(we) {
                        return arguments.length ? (Z = we.map(oe), oe) : Z;
                    }, oe.ticks = function(we) {
                        return qa(Z, we);
                    }, oe.tickFormat = function(we, Be) {
                        return d3_scale_linearTickFormat(Z, we, Be);
                    }, oe.copy = function() {
                        return Ko(Z);
                    }, oe;
                }
                e.svg = {};
                function nu() {
                    return 0;
                }
                e.svg.arc = function() {
                    var Z = ac, oe = mf, we = nu, Be = Ru, Ue = bu, We = Kc, wt = Du;
                    function tt() {
                        var or = Math.max(0, +Z.apply(this, arguments)), lr = Math.max(0, +oe.apply(this, arguments)), Dr = Ue.apply(this, arguments) - xe, Ir = We.apply(this, arguments) - xe, oi = Math.abs(Ir - Dr), ui = Dr > Ir ? 0 : 1;
                        if (lr < or && (qr = lr, lr = or, or = qr), oi >= Le) return zt(lr, ui) + (or ? zt(or, 1 - ui) : "") + "Z";
                        var qr, Kr, ii, vi, ci = 0, Jr = 0, un, dn, En, Nn, ga, ya, so, wa, io = [];
                        if ((vi = (+wt.apply(this, arguments) || 0) / 2) && (ii = Be === Ru ? Math.sqrt(or * or + lr * lr) : +Be.apply(this, arguments), ui || (Jr *= -1), lr && (Jr = Qr(ii / lr * Math.sin(vi))), or && (ci = Qr(ii / or * Math.sin(vi)))), lr) {
                            un = lr * Math.cos(Dr + Jr), dn = lr * Math.sin(Dr + Jr), En = lr * Math.cos(Ir - Jr), Nn = lr * Math.sin(Ir - Jr);
                            var Ss = Math.abs(Ir - Dr - 2 * Jr) <= Xe ? 0 : 1;
                            if (Jr && Dc(un, dn, En, Nn) === ui ^ Ss) {
                                var _s = (Dr + Ir) / 2;
                                un = lr * Math.cos(_s), dn = lr * Math.sin(_s), En = Nn = null;
                            }
                        } else un = dn = 0;
                        if (or) {
                            ga = or * Math.cos(Ir - ci), ya = or * Math.sin(Ir - ci), so = or * Math.cos(Dr + ci), wa = or * Math.sin(Dr + ci);
                            var Ns = Math.abs(Dr - Ir + 2 * ci) <= Xe ? 0 : 1;
                            if (ci && Dc(ga, ya, so, wa) === 1 - ui ^ Ns) {
                                var pn = (Dr + Ir) / 2;
                                ga = or * Math.cos(pn), ya = or * Math.sin(pn), so = wa = null;
                            }
                        } else ga = ya = 0;
                        if (oi > Ye && (qr = Math.min(Math.abs(lr - or) / 2, +we.apply(this, arguments))) > .001) {
                            Kr = or < lr ^ ui ? 0 : 1;
                            var za = qr, Lo = qr;
                            if (oi < Xe) {
                                var Fo = so == null ? [
                                    ga,
                                    ya
                                ] : En == null ? [
                                    un,
                                    dn
                                ] : cl([
                                    un,
                                    dn
                                ], [
                                    so,
                                    wa
                                ], [
                                    En,
                                    Nn
                                ], [
                                    ga,
                                    ya
                                ]), js = un - Fo[0], xl = dn - Fo[1], fu = En - Fo[0], dl = Nn - Fo[1], xc = 1 / Math.sin(Math.acos((js * fu + xl * dl) / (Math.sqrt(js * js + xl * xl) * Math.sqrt(fu * fu + dl * dl))) / 2), At = Math.sqrt(Fo[0] * Fo[0] + Fo[1] * Fo[1]);
                                Lo = Math.min(qr, (or - At) / (xc - 1)), za = Math.min(qr, (lr - At) / (xc + 1));
                            }
                            if (En != null) {
                                var Er = Da(so == null ? [
                                    ga,
                                    ya
                                ] : [
                                    so,
                                    wa
                                ], [
                                    un,
                                    dn
                                ], lr, za, ui), Wr = Da([
                                    En,
                                    Nn
                                ], [
                                    ga,
                                    ya
                                ], lr, za, ui);
                                qr === za ? io.push("M", Er[0], "A", za, ",", za, " 0 0,", Kr, " ", Er[1], "A", lr, ",", lr, " 0 ", 1 - ui ^ Dc(Er[1][0], Er[1][1], Wr[1][0], Wr[1][1]), ",", ui, " ", Wr[1], "A", za, ",", za, " 0 0,", Kr, " ", Wr[0]) : io.push("M", Er[0], "A", za, ",", za, " 0 1,", Kr, " ", Wr[0]);
                            } else io.push("M", un, ",", dn);
                            if (so != null) {
                                var wi = Da([
                                    un,
                                    dn
                                ], [
                                    so,
                                    wa
                                ], or, -Lo, ui), Ui = Da([
                                    ga,
                                    ya
                                ], En == null ? [
                                    un,
                                    dn
                                ] : [
                                    En,
                                    Nn
                                ], or, -Lo, ui);
                                qr === Lo ? io.push("L", Ui[0], "A", Lo, ",", Lo, " 0 0,", Kr, " ", Ui[1], "A", or, ",", or, " 0 ", ui ^ Dc(Ui[1][0], Ui[1][1], wi[1][0], wi[1][1]), ",", 1 - ui, " ", wi[1], "A", Lo, ",", Lo, " 0 0,", Kr, " ", wi[0]) : io.push("L", Ui[0], "A", Lo, ",", Lo, " 0 0,", Kr, " ", wi[0]);
                            } else io.push("L", ga, ",", ya);
                        } else io.push("M", un, ",", dn), En != null && io.push("A", lr, ",", lr, " 0 ", Ss, ",", ui, " ", En, ",", Nn), io.push("L", ga, ",", ya), so != null && io.push("A", or, ",", or, " 0 ", Ns, ",", 1 - ui, " ", so, ",", wa);
                        return io.push("Z"), io.join("");
                    }
                    function zt(or, lr) {
                        return "M0," + or + "A" + or + "," + or + " 0 1," + lr + " 0," + -or + "A" + or + "," + or + " 0 1," + lr + " 0," + or;
                    }
                    return tt.innerRadius = function(or) {
                        return arguments.length ? (Z = ti(or), tt) : Z;
                    }, tt.outerRadius = function(or) {
                        return arguments.length ? (oe = ti(or), tt) : oe;
                    }, tt.cornerRadius = function(or) {
                        return arguments.length ? (we = ti(or), tt) : we;
                    }, tt.padRadius = function(or) {
                        return arguments.length ? (Be = or == Ru ? Ru : ti(or), tt) : Be;
                    }, tt.startAngle = function(or) {
                        return arguments.length ? (Ue = ti(or), tt) : Ue;
                    }, tt.endAngle = function(or) {
                        return arguments.length ? (We = ti(or), tt) : We;
                    }, tt.padAngle = function(or) {
                        return arguments.length ? (wt = ti(or), tt) : wt;
                    }, tt.centroid = function() {
                        var or = (+Z.apply(this, arguments) + +oe.apply(this, arguments)) / 2, lr = (+Ue.apply(this, arguments) + +We.apply(this, arguments)) / 2 - xe;
                        return [
                            Math.cos(lr) * or,
                            Math.sin(lr) * or
                        ];
                    }, tt;
                };
                var Ru = "auto";
                function ac(Z) {
                    return Z.innerRadius;
                }
                function mf(Z) {
                    return Z.outerRadius;
                }
                function bu(Z) {
                    return Z.startAngle;
                }
                function Kc(Z) {
                    return Z.endAngle;
                }
                function Du(Z) {
                    return Z && Z.padAngle;
                }
                function Dc(Z, oe, we, Be) {
                    return (Z - we) * oe - (oe - Be) * Z > 0 ? 0 : 1;
                }
                function Da(Z, oe, we, Be, Ue) {
                    var We = Z[0] - oe[0], wt = Z[1] - oe[1], tt = (Ue ? Be : -Be) / Math.sqrt(We * We + wt * wt), zt = tt * wt, or = -tt * We, lr = Z[0] + zt, Dr = Z[1] + or, Ir = oe[0] + zt, oi = oe[1] + or, ui = (lr + Ir) / 2, qr = (Dr + oi) / 2, Kr = Ir - lr, ii = oi - Dr, vi = Kr * Kr + ii * ii, ci = we - Be, Jr = lr * oi - Ir * Dr, un = (ii < 0 ? -1 : 1) * Math.sqrt(Math.max(0, ci * ci * vi - Jr * Jr)), dn = (Jr * ii - Kr * un) / vi, En = (-Jr * Kr - ii * un) / vi, Nn = (Jr * ii + Kr * un) / vi, ga = (-Jr * Kr + ii * un) / vi, ya = dn - ui, so = En - qr, wa = Nn - ui, io = ga - qr;
                    return ya * ya + so * so > wa * wa + io * io && (dn = Nn, En = ga), [
                        [
                            dn - zt,
                            En - or
                        ],
                        [
                            dn * we / ci,
                            En * we / ci
                        ]
                    ];
                }
                function eo() {
                    return !0;
                }
                function Jc(Z) {
                    var oe = zs, we = ks, Be = eo, Ue = _c, We = Ue.key, wt = .7;
                    function tt(zt) {
                        var or = [], lr = [], Dr = -1, Ir = zt.length, oi, ui = ti(oe), qr = ti(we);
                        function Kr() {
                            or.push("M", Ue(Z(lr), wt));
                        }
                        for(; ++Dr < Ir;)Be.call(this, oi = zt[Dr], Dr) ? lr.push([
                            +ui.call(this, oi, Dr),
                            +qr.call(this, oi, Dr)
                        ]) : lr.length && (Kr(), lr = []);
                        return lr.length && Kr(), or.length ? or.join("") : null;
                    }
                    return tt.x = function(zt) {
                        return arguments.length ? (oe = zt, tt) : oe;
                    }, tt.y = function(zt) {
                        return arguments.length ? (we = zt, tt) : we;
                    }, tt.defined = function(zt) {
                        return arguments.length ? (Be = zt, tt) : Be;
                    }, tt.interpolate = function(zt) {
                        return arguments.length ? (typeof zt == "function" ? We = Ue = zt : We = (Ue = yc.get(zt) || _c).key, tt) : We;
                    }, tt.tension = function(zt) {
                        return arguments.length ? (wt = zt, tt) : wt;
                    }, tt;
                }
                e.svg.line = function() {
                    return Jc(H);
                };
                var yc = e.map({
                    linear: _c,
                    "linear-closed": le,
                    step: w,
                    "step-before": B,
                    "step-after": Q,
                    basis: yt,
                    "basis-open": Ot,
                    "basis-closed": Nt,
                    bundle: hr,
                    cardinal: qe,
                    "cardinal-open": ee,
                    "cardinal-closed": se,
                    monotone: Mt
                });
                yc.forEach(function(Z, oe) {
                    oe.key = Z, oe.closed = /-closed$/.test(Z);
                });
                function _c(Z) {
                    return Z.length > 1 ? Z.join("L") : Z + "Z";
                }
                function le(Z) {
                    return Z.join("L") + "Z";
                }
                function w(Z) {
                    for(var oe = 0, we = Z.length, Be = Z[0], Ue = [
                        Be[0],
                        ",",
                        Be[1]
                    ]; ++oe < we;)Ue.push("H", (Be[0] + (Be = Z[oe])[0]) / 2, "V", Be[1]);
                    return we > 1 && Ue.push("H", Be[0]), Ue.join("");
                }
                function B(Z) {
                    for(var oe = 0, we = Z.length, Be = Z[0], Ue = [
                        Be[0],
                        ",",
                        Be[1]
                    ]; ++oe < we;)Ue.push("V", (Be = Z[oe])[1], "H", Be[0]);
                    return Ue.join("");
                }
                function Q(Z) {
                    for(var oe = 0, we = Z.length, Be = Z[0], Ue = [
                        Be[0],
                        ",",
                        Be[1]
                    ]; ++oe < we;)Ue.push("H", (Be = Z[oe])[0], "V", Be[1]);
                    return Ue.join("");
                }
                function ee(Z, oe) {
                    return Z.length < 4 ? _c(Z) : Z[1] + je(Z.slice(1, -1), it(Z, oe));
                }
                function se(Z, oe) {
                    return Z.length < 3 ? le(Z) : Z[0] + je((Z.push(Z[0]), Z), it([
                        Z[Z.length - 2]
                    ].concat(Z, [
                        Z[1]
                    ]), oe));
                }
                function qe(Z, oe) {
                    return Z.length < 3 ? _c(Z) : Z[0] + je(Z, it(Z, oe));
                }
                function je(Z, oe) {
                    if (oe.length < 1 || Z.length != oe.length && Z.length != oe.length + 2) return _c(Z);
                    var we = Z.length != oe.length, Be = "", Ue = Z[0], We = Z[1], wt = oe[0], tt = wt, zt = 1;
                    if (we && (Be += "Q" + (We[0] - wt[0] * 2 / 3) + "," + (We[1] - wt[1] * 2 / 3) + "," + We[0] + "," + We[1], Ue = Z[1], zt = 2), oe.length > 1) {
                        tt = oe[1], We = Z[zt], zt++, Be += "C" + (Ue[0] + wt[0]) + "," + (Ue[1] + wt[1]) + "," + (We[0] - tt[0]) + "," + (We[1] - tt[1]) + "," + We[0] + "," + We[1];
                        for(var or = 2; or < oe.length; or++, zt++)We = Z[zt], tt = oe[or], Be += "S" + (We[0] - tt[0]) + "," + (We[1] - tt[1]) + "," + We[0] + "," + We[1];
                    }
                    if (we) {
                        var lr = Z[zt];
                        Be += "Q" + (We[0] + tt[0] * 2 / 3) + "," + (We[1] + tt[1] * 2 / 3) + "," + lr[0] + "," + lr[1];
                    }
                    return Be;
                }
                function it(Z, oe) {
                    for(var we = [], Be = (1 - oe) / 2, Ue, We = Z[0], wt = Z[1], tt = 1, zt = Z.length; ++tt < zt;)Ue = We, We = wt, wt = Z[tt], we.push([
                        Be * (wt[0] - Ue[0]),
                        Be * (wt[1] - Ue[1])
                    ]);
                    return we;
                }
                function yt(Z) {
                    if (Z.length < 3) return _c(Z);
                    var oe = 1, we = Z.length, Be = Z[0], Ue = Be[0], We = Be[1], wt = [
                        Ue,
                        Ue,
                        Ue,
                        (Be = Z[1])[0]
                    ], tt = [
                        We,
                        We,
                        We,
                        Be[1]
                    ], zt = [
                        Ue,
                        ",",
                        We,
                        "L",
                        Sr(Pe, wt),
                        ",",
                        Sr(Pe, tt)
                    ];
                    for(Z.push(Z[we - 1]); ++oe <= we;)Be = Z[oe], wt.shift(), wt.push(Be[0]), tt.shift(), tt.push(Be[1]), Oe(zt, wt, tt);
                    return Z.pop(), zt.push("L", Be), zt.join("");
                }
                function Ot(Z) {
                    if (Z.length < 4) return _c(Z);
                    for(var oe = [], we = -1, Be = Z.length, Ue, We = [
                        0
                    ], wt = [
                        0
                    ]; ++we < 3;)Ue = Z[we], We.push(Ue[0]), wt.push(Ue[1]);
                    for(oe.push(Sr(Pe, We) + "," + Sr(Pe, wt)), --we; ++we < Be;)Ue = Z[we], We.shift(), We.push(Ue[0]), wt.shift(), wt.push(Ue[1]), Oe(oe, We, wt);
                    return oe.join("");
                }
                function Nt(Z) {
                    for(var oe, we = -1, Be = Z.length, Ue = Be + 4, We, wt = [], tt = []; ++we < 4;)We = Z[we % Be], wt.push(We[0]), tt.push(We[1]);
                    for(oe = [
                        Sr(Pe, wt),
                        ",",
                        Sr(Pe, tt)
                    ], --we; ++we < Ue;)We = Z[we % Be], wt.shift(), wt.push(We[0]), tt.shift(), tt.push(We[1]), Oe(oe, wt, tt);
                    return oe.join("");
                }
                function hr(Z, oe) {
                    var we = Z.length - 1;
                    if (we) for(var Be = Z[0][0], Ue = Z[0][1], We = Z[we][0] - Be, wt = Z[we][1] - Ue, tt = -1, zt, or; ++tt <= we;)zt = Z[tt], or = tt / we, zt[0] = oe * zt[0] + (1 - oe) * (Be + or * We), zt[1] = oe * zt[1] + (1 - oe) * (Ue + or * wt);
                    return yt(Z);
                }
                function Sr(Z, oe) {
                    return Z[0] * oe[0] + Z[1] * oe[1] + Z[2] * oe[2] + Z[3] * oe[3];
                }
                var he = [
                    0,
                    2 / 3,
                    1 / 3,
                    0
                ], be = [
                    0,
                    1 / 3,
                    2 / 3,
                    0
                ], Pe = [
                    0,
                    1 / 6,
                    2 / 3,
                    1 / 6
                ];
                function Oe(Z, oe, we) {
                    Z.push("C", Sr(he, oe), ",", Sr(he, we), ",", Sr(be, oe), ",", Sr(be, we), ",", Sr(Pe, oe), ",", Sr(Pe, we));
                }
                function Je(Z, oe) {
                    return (oe[1] - Z[1]) / (oe[0] - Z[0]);
                }
                function He(Z) {
                    for(var oe = 0, we = Z.length - 1, Be = [], Ue = Z[0], We = Z[1], wt = Be[0] = Je(Ue, We); ++oe < we;)Be[oe] = (wt + (wt = Je(Ue = We, We = Z[oe + 1]))) / 2;
                    return Be[oe] = wt, Be;
                }
                function et(Z) {
                    for(var oe = [], we, Be, Ue, We, wt = He(Z), tt = -1, zt = Z.length - 1; ++tt < zt;)we = Je(Z[tt], Z[tt + 1]), p(we) < Ye ? wt[tt] = wt[tt + 1] = 0 : (Be = wt[tt] / we, Ue = wt[tt + 1] / we, We = Be * Be + Ue * Ue, We > 9 && (We = we * 3 / Math.sqrt(We), wt[tt] = We * Be, wt[tt + 1] = We * Ue));
                    for(tt = -1; ++tt <= zt;)We = (Z[Math.min(zt, tt + 1)][0] - Z[Math.max(0, tt - 1)][0]) / (6 * (1 + wt[tt] * wt[tt])), oe.push([
                        We || 0,
                        wt[tt] * We || 0
                    ]);
                    return oe;
                }
                function Mt(Z) {
                    return Z.length < 3 ? _c(Z) : Z[0] + je(Z, et(Z));
                }
                e.svg.line.radial = function() {
                    var Z = Jc(Dt);
                    return Z.radius = Z.x, delete Z.x, Z.angle = Z.y, delete Z.y, Z;
                };
                function Dt(Z) {
                    for(var oe, we = -1, Be = Z.length, Ue, We; ++we < Be;)oe = Z[we], Ue = oe[0], We = oe[1] - xe, oe[0] = Ue * Math.cos(We), oe[1] = Ue * Math.sin(We);
                    return Z;
                }
                function Ut(Z) {
                    var oe = zs, we = zs, Be = 0, Ue = ks, We = eo, wt = _c, tt = wt.key, zt = wt, or = "L", lr = .7;
                    function Dr(Ir) {
                        var oi = [], ui = [], qr = [], Kr = -1, ii = Ir.length, vi, ci = ti(oe), Jr = ti(Be), un = oe === we ? function() {
                            return En;
                        } : ti(we), dn = Be === Ue ? function() {
                            return Nn;
                        } : ti(Ue), En, Nn;
                        function ga() {
                            oi.push("M", wt(Z(qr), lr), or, zt(Z(ui.reverse()), lr), "Z");
                        }
                        for(; ++Kr < ii;)We.call(this, vi = Ir[Kr], Kr) ? (ui.push([
                            En = +ci.call(this, vi, Kr),
                            Nn = +Jr.call(this, vi, Kr)
                        ]), qr.push([
                            +un.call(this, vi, Kr),
                            +dn.call(this, vi, Kr)
                        ])) : ui.length && (ga(), ui = [], qr = []);
                        return ui.length && ga(), oi.length ? oi.join("") : null;
                    }
                    return Dr.x = function(Ir) {
                        return arguments.length ? (oe = we = Ir, Dr) : we;
                    }, Dr.x0 = function(Ir) {
                        return arguments.length ? (oe = Ir, Dr) : oe;
                    }, Dr.x1 = function(Ir) {
                        return arguments.length ? (we = Ir, Dr) : we;
                    }, Dr.y = function(Ir) {
                        return arguments.length ? (Be = Ue = Ir, Dr) : Ue;
                    }, Dr.y0 = function(Ir) {
                        return arguments.length ? (Be = Ir, Dr) : Be;
                    }, Dr.y1 = function(Ir) {
                        return arguments.length ? (Ue = Ir, Dr) : Ue;
                    }, Dr.defined = function(Ir) {
                        return arguments.length ? (We = Ir, Dr) : We;
                    }, Dr.interpolate = function(Ir) {
                        return arguments.length ? (typeof Ir == "function" ? tt = wt = Ir : tt = (wt = yc.get(Ir) || _c).key, zt = wt.reverse || wt, or = wt.closed ? "M" : "L", Dr) : tt;
                    }, Dr.tension = function(Ir) {
                        return arguments.length ? (lr = Ir, Dr) : lr;
                    }, Dr;
                }
                B.reverse = Q, Q.reverse = B, e.svg.area = function() {
                    return Ut(H);
                }, e.svg.area.radial = function() {
                    var Z = Ut(Dt);
                    return Z.radius = Z.x, delete Z.x, Z.innerRadius = Z.x0, delete Z.x0, Z.outerRadius = Z.x1, delete Z.x1, Z.angle = Z.y, delete Z.y, Z.startAngle = Z.y0, delete Z.y0, Z.endAngle = Z.y1, delete Z.y1, Z;
                };
                function tr(Z) {
                    return Z.source;
                }
                function mr(Z) {
                    return Z.target;
                }
                e.svg.chord = function() {
                    var Z = tr, oe = mr, we = Rr, Be = bu, Ue = Kc;
                    function We(lr, Dr) {
                        var Ir = wt(this, Z, lr, Dr), oi = wt(this, oe, lr, Dr);
                        return "M" + Ir.p0 + zt(Ir.r, Ir.p1, Ir.a1 - Ir.a0) + (tt(Ir, oi) ? or(Ir.r, Ir.p1, Ir.r, Ir.p0) : or(Ir.r, Ir.p1, oi.r, oi.p0) + zt(oi.r, oi.p1, oi.a1 - oi.a0) + or(oi.r, oi.p1, Ir.r, Ir.p0)) + "Z";
                    }
                    function wt(lr, Dr, Ir, oi) {
                        var ui = Dr.call(lr, Ir, oi), qr = we.call(lr, ui, oi), Kr = Be.call(lr, ui, oi) - xe, ii = Ue.call(lr, ui, oi) - xe;
                        return {
                            r: qr,
                            a0: Kr,
                            a1: ii,
                            p0: [
                                qr * Math.cos(Kr),
                                qr * Math.sin(Kr)
                            ],
                            p1: [
                                qr * Math.cos(ii),
                                qr * Math.sin(ii)
                            ]
                        };
                    }
                    function tt(lr, Dr) {
                        return lr.a0 == Dr.a0 && lr.a1 == Dr.a1;
                    }
                    function zt(lr, Dr, Ir) {
                        return "A" + lr + "," + lr + " 0 " + +(Ir > Xe) + ",1 " + Dr;
                    }
                    function or(lr, Dr, Ir, oi) {
                        return "Q 0,0 " + oi;
                    }
                    return We.radius = function(lr) {
                        return arguments.length ? (we = ti(lr), We) : we;
                    }, We.source = function(lr) {
                        return arguments.length ? (Z = ti(lr), We) : Z;
                    }, We.target = function(lr) {
                        return arguments.length ? (oe = ti(lr), We) : oe;
                    }, We.startAngle = function(lr) {
                        return arguments.length ? (Be = ti(lr), We) : Be;
                    }, We.endAngle = function(lr) {
                        return arguments.length ? (Ue = ti(lr), We) : Ue;
                    }, We;
                };
                function Rr(Z) {
                    return Z.radius;
                }
                e.svg.diagonal = function() {
                    var Z = tr, oe = mr, we = zr;
                    function Be(Ue, We) {
                        var wt = Z.call(this, Ue, We), tt = oe.call(this, Ue, We), zt = (wt.y + tt.y) / 2, or = [
                            wt,
                            {
                                x: wt.x,
                                y: zt
                            },
                            {
                                x: tt.x,
                                y: zt
                            },
                            tt
                        ];
                        return or = or.map(we), "M" + or[0] + "C" + or[1] + " " + or[2] + " " + or[3];
                    }
                    return Be.source = function(Ue) {
                        return arguments.length ? (Z = ti(Ue), Be) : Z;
                    }, Be.target = function(Ue) {
                        return arguments.length ? (oe = ti(Ue), Be) : oe;
                    }, Be.projection = function(Ue) {
                        return arguments.length ? (we = Ue, Be) : we;
                    }, Be;
                };
                function zr(Z) {
                    return [
                        Z.x,
                        Z.y
                    ];
                }
                e.svg.diagonal.radial = function() {
                    var Z = e.svg.diagonal(), oe = zr, we = Z.projection;
                    return Z.projection = function(Be) {
                        return arguments.length ? we(Xr(oe = Be)) : oe;
                    }, Z;
                };
                function Xr(Z) {
                    return function() {
                        var oe = Z.apply(this, arguments), we = oe[0], Be = oe[1] - xe;
                        return [
                            we * Math.cos(Be),
                            we * Math.sin(Be)
                        ];
                    };
                }
                e.svg.symbol = function() {
                    var Z = Li, oe = di;
                    function we(Be, Ue) {
                        return (Qi.get(Z.call(this, Be, Ue)) || Ci)(oe.call(this, Be, Ue));
                    }
                    return we.type = function(Be) {
                        return arguments.length ? (Z = ti(Be), we) : Z;
                    }, we.size = function(Be) {
                        return arguments.length ? (oe = ti(Be), we) : oe;
                    }, we;
                };
                function di() {
                    return 64;
                }
                function Li() {
                    return "circle";
                }
                function Ci(Z) {
                    var oe = Math.sqrt(Z / Xe);
                    return "M0," + oe + "A" + oe + "," + oe + " 0 1,1 0," + -oe + "A" + oe + "," + oe + " 0 1,1 0," + oe + "Z";
                }
                var Qi = e.map({
                    circle: Ci,
                    cross: function(Z) {
                        var oe = Math.sqrt(Z / 5) / 2;
                        return "M" + -3 * oe + "," + -oe + "H" + -oe + "V" + -3 * oe + "H" + oe + "V" + -oe + "H" + 3 * oe + "V" + oe + "H" + oe + "V" + 3 * oe + "H" + -oe + "V" + oe + "H" + -3 * oe + "Z";
                    },
                    diamond: function(Z) {
                        var oe = Math.sqrt(Z / (2 * pa)), we = oe * pa;
                        return "M0," + -oe + "L" + we + ",0 0," + oe + " " + -we + ",0Z";
                    },
                    square: function(Z) {
                        var oe = Math.sqrt(Z) / 2;
                        return "M" + -oe + "," + -oe + "L" + oe + "," + -oe + " " + oe + "," + oe + " " + -oe + "," + oe + "Z";
                    },
                    "triangle-down": function(Z) {
                        var oe = Math.sqrt(Z / Mn), we = oe * Mn / 2;
                        return "M0," + we + "L" + oe + "," + -we + " " + -oe + "," + -we + "Z";
                    },
                    "triangle-up": function(Z) {
                        var oe = Math.sqrt(Z / Mn), we = oe * Mn / 2;
                        return "M0," + -we + "L" + oe + "," + we + " " + -oe + "," + we + "Z";
                    }
                });
                e.svg.symbolTypes = Qi.keys();
                var Mn = Math.sqrt(3), pa = Math.tan(30 * Se);
                Ce.transition = function(Z) {
                    for(var oe = Ro || ++co, we = po(Z), Be = [], Ue, We, wt = Ds || {
                        time: Date.now(),
                        ease: uu,
                        delay: 0,
                        duration: 250
                    }, tt = -1, zt = this.length; ++tt < zt;){
                        Be.push(Ue = []);
                        for(var or = this[tt], lr = -1, Dr = or.length; ++lr < Dr;)(We = or[lr]) && _l(We, lr, we, oe, wt), Ue.push(We);
                    }
                    return To(Be, we, oe);
                }, Ce.interrupt = function(Z) {
                    return this.each(Z == null ? ea : Ga(po(Z)));
                };
                var ea = Ga(po());
                function Ga(Z) {
                    return function() {
                        var oe, we, Be;
                        (oe = this[Z]) && (Be = oe[we = oe.active]) && (Be.timer.c = null, Be.timer.t = NaN, --oe.count ? delete oe[we] : delete this[Z], oe.active += .5, Be.event && Be.event.interrupt.call(this, this.__data__, Be.index));
                    };
                }
                function To(Z, oe, we) {
                    return ie(Z, Wa), Z.namespace = oe, Z.id = we, Z;
                }
                var Wa = [], co = 0, Ro, Ds;
                Wa.call = Ce.call, Wa.empty = Ce.empty, Wa.node = Ce.node, Wa.size = Ce.size, e.transition = function(Z, oe) {
                    return Z && Z.transition ? Ro ? Z.transition(oe) : Z : e.selection().transition(Z);
                }, e.transition.prototype = Wa, Wa.select = function(Z) {
                    var oe = this.id, we = this.namespace, Be = [], Ue, We, wt;
                    Z = me(Z);
                    for(var tt = -1, zt = this.length; ++tt < zt;){
                        Be.push(Ue = []);
                        for(var or = this[tt], lr = -1, Dr = or.length; ++lr < Dr;)(wt = or[lr]) && (We = Z.call(wt, wt.__data__, lr, tt)) ? ("__data__" in wt && (We.__data__ = wt.__data__), _l(We, lr, we, oe, wt[we][oe]), Ue.push(We)) : Ue.push(null);
                    }
                    return To(Be, we, oe);
                }, Wa.selectAll = function(Z) {
                    var oe = this.id, we = this.namespace, Be = [], Ue, We, wt, tt, zt;
                    Z = Re(Z);
                    for(var or = -1, lr = this.length; ++or < lr;)for(var Dr = this[or], Ir = -1, oi = Dr.length; ++Ir < oi;)if (wt = Dr[Ir]) {
                        zt = wt[we][oe], We = Z.call(wt, wt.__data__, Ir, or), Be.push(Ue = []);
                        for(var ui = -1, qr = We.length; ++ui < qr;)(tt = We[ui]) && _l(tt, ui, we, oe, zt), Ue.push(tt);
                    }
                    return To(Be, we, oe);
                }, Wa.filter = function(Z) {
                    var oe = [], we, Be, Ue;
                    typeof Z != "function" && (Z = Ke(Z));
                    for(var We = 0, wt = this.length; We < wt; We++){
                        oe.push(we = []);
                        for(var Be = this[We], tt = 0, zt = Be.length; tt < zt; tt++)(Ue = Be[tt]) && Z.call(Ue, Ue.__data__, tt, We) && we.push(Ue);
                    }
                    return To(oe, this.namespace, this.id);
                }, Wa.tween = function(Z, oe) {
                    var we = this.id, Be = this.namespace;
                    return arguments.length < 2 ? this.node()[Be][we].tween.get(Z) : bt(this, oe == null ? function(Ue) {
                        Ue[Be][we].tween.remove(Z);
                    } : function(Ue) {
                        Ue[Be][we].tween.set(Z, oe);
                    });
                };
                function As(Z, oe, we, Be) {
                    var Ue = Z.id, We = Z.namespace;
                    return bt(Z, typeof we == "function" ? function(wt, tt, zt) {
                        wt[We][Ue].tween.set(oe, Be(we.call(wt, wt.__data__, tt, zt)));
                    } : (we = Be(we), function(wt) {
                        wt[We][Ue].tween.set(oe, we);
                    }));
                }
                Wa.attr = function(Z, oe) {
                    if (arguments.length < 2) {
                        for(oe in Z)this.attr(oe, Z[oe]);
                        return this;
                    }
                    var we = Z == "transform" ? Cf : Sl, Be = e.ns.qualify(Z);
                    function Ue() {
                        this.removeAttribute(Be);
                    }
                    function We() {
                        this.removeAttributeNS(Be.space, Be.local);
                    }
                    function wt(zt) {
                        return zt == null ? Ue : (zt += "", function() {
                            var or = this.getAttribute(Be), lr;
                            return or !== zt && (lr = we(or, zt), function(Dr) {
                                this.setAttribute(Be, lr(Dr));
                            });
                        });
                    }
                    function tt(zt) {
                        return zt == null ? We : (zt += "", function() {
                            var or = this.getAttributeNS(Be.space, Be.local), lr;
                            return or !== zt && (lr = we(or, zt), function(Dr) {
                                this.setAttributeNS(Be.space, Be.local, lr(Dr));
                            });
                        });
                    }
                    return As(this, "attr." + Z, oe, Be.local ? tt : wt);
                }, Wa.attrTween = function(Z, oe) {
                    var we = e.ns.qualify(Z);
                    function Be(We, wt) {
                        var tt = oe.call(this, We, wt, this.getAttribute(we));
                        return tt && function(zt) {
                            this.setAttribute(we, tt(zt));
                        };
                    }
                    function Ue(We, wt) {
                        var tt = oe.call(this, We, wt, this.getAttributeNS(we.space, we.local));
                        return tt && function(zt) {
                            this.setAttributeNS(we.space, we.local, tt(zt));
                        };
                    }
                    return this.tween("attr." + Z, we.local ? Ue : Be);
                }, Wa.style = function(Z, oe, we) {
                    var Be = arguments.length;
                    if (Be < 3) {
                        if (typeof Z != "string") {
                            Be < 2 && (oe = "");
                            for(we in Z)this.style(we, Z[we], oe);
                            return this;
                        }
                        we = "";
                    }
                    function Ue() {
                        this.style.removeProperty(Z);
                    }
                    function We(wt) {
                        return wt == null ? Ue : (wt += "", function() {
                            var tt = a(this).getComputedStyle(this, null).getPropertyValue(Z), zt;
                            return tt !== wt && (zt = Sl(tt, wt), function(or) {
                                this.style.setProperty(Z, zt(or), we);
                            });
                        });
                    }
                    return As(this, "style." + Z, oe, We);
                }, Wa.styleTween = function(Z, oe, we) {
                    arguments.length < 3 && (we = "");
                    function Be(Ue, We) {
                        var wt = oe.call(this, Ue, We, a(this).getComputedStyle(this, null).getPropertyValue(Z));
                        return wt && function(tt) {
                            this.style.setProperty(Z, wt(tt), we);
                        };
                    }
                    return this.tween("style." + Z, Be);
                }, Wa.text = function(Z) {
                    return As(this, "text", Z, yo);
                };
                function yo(Z) {
                    return Z == null && (Z = ""), function() {
                        this.textContent = Z;
                    };
                }
                Wa.remove = function() {
                    var Z = this.namespace;
                    return this.each("end.transition", function() {
                        var oe;
                        this[Z].count < 2 && (oe = this.parentNode) && oe.removeChild(this);
                    });
                }, Wa.ease = function(Z) {
                    var oe = this.id, we = this.namespace;
                    return arguments.length < 1 ? this.node()[we][oe].ease : (typeof Z != "function" && (Z = e.ease.apply(e, arguments)), bt(this, function(Be) {
                        Be[we][oe].ease = Z;
                    }));
                }, Wa.delay = function(Z) {
                    var oe = this.id, we = this.namespace;
                    return arguments.length < 1 ? this.node()[we][oe].delay : bt(this, typeof Z == "function" ? function(Be, Ue, We) {
                        Be[we][oe].delay = +Z.call(Be, Be.__data__, Ue, We);
                    } : (Z = +Z, function(Be) {
                        Be[we][oe].delay = Z;
                    }));
                }, Wa.duration = function(Z) {
                    var oe = this.id, we = this.namespace;
                    return arguments.length < 1 ? this.node()[we][oe].duration : bt(this, typeof Z == "function" ? function(Be, Ue, We) {
                        Be[we][oe].duration = Math.max(1, Z.call(Be, Be.__data__, Ue, We));
                    } : (Z = Math.max(1, Z), function(Be) {
                        Be[we][oe].duration = Z;
                    }));
                }, Wa.each = function(Z, oe) {
                    var we = this.id, Be = this.namespace;
                    if (arguments.length < 2) {
                        var Ue = Ds, We = Ro;
                        try {
                            Ro = we, bt(this, function(wt, tt, zt) {
                                Ds = wt[Be][we], Z.call(wt, wt.__data__, tt, zt);
                            });
                        } finally{
                            Ds = Ue, Ro = We;
                        }
                    } else bt(this, function(wt) {
                        var tt = wt[Be][we];
                        (tt.event || (tt.event = e.dispatch("start", "end", "interrupt"))).on(Z, oe);
                    });
                    return this;
                }, Wa.transition = function() {
                    for(var Z = this.id, oe = ++co, we = this.namespace, Be = [], Ue, We, wt, tt, zt = 0, or = this.length; zt < or; zt++){
                        Be.push(Ue = []);
                        for(var We = this[zt], lr = 0, Dr = We.length; lr < Dr; lr++)(wt = We[lr]) && (tt = wt[we][Z], _l(wt, lr, we, oe, {
                            time: tt.time,
                            ease: tt.ease,
                            delay: tt.delay + tt.duration,
                            duration: tt.duration
                        })), Ue.push(wt);
                    }
                    return To(Be, we, oe);
                };
                function po(Z) {
                    return Z == null ? "__transition__" : "__transition_" + Z + "__";
                }
                function _l(Z, oe, we, Be, Ue) {
                    var We = Z[we] || (Z[we] = {
                        active: 0,
                        count: 0
                    }), wt = We[Be], tt, zt, or, lr, Dr;
                    function Ir(qr) {
                        var Kr = wt.delay;
                        if (zt.t = Kr + tt, Kr <= qr) return oi(qr - Kr);
                        zt.c = oi;
                    }
                    function oi(qr) {
                        var Kr = We.active, ii = We[Kr];
                        ii && (ii.timer.c = null, ii.timer.t = NaN, --We.count, delete We[Kr], ii.event && ii.event.interrupt.call(Z, Z.__data__, ii.index));
                        for(var vi in We)if (+vi < Be) {
                            var ci = We[vi];
                            ci.timer.c = null, ci.timer.t = NaN, --We.count, delete We[vi];
                        }
                        zt.c = ui, Oo(function() {
                            return zt.c && ui(qr || 1) && (zt.c = null, zt.t = NaN), 1;
                        }, 0, tt), We.active = Be, wt.event && wt.event.start.call(Z, Z.__data__, oe), Dr = [], wt.tween.forEach(function(Jr, un) {
                            (un = un.call(Z, Z.__data__, oe)) && Dr.push(un);
                        }), lr = wt.ease, or = wt.duration;
                    }
                    function ui(qr) {
                        for(var Kr = qr / or, ii = lr(Kr), vi = Dr.length; vi > 0;)Dr[--vi].call(Z, ii);
                        if (Kr >= 1) return wt.event && wt.event.end.call(Z, Z.__data__, oe), --We.count ? delete We[Be] : delete Z[we], 1;
                    }
                    wt || (tt = Ue.time, zt = Oo(Ir, 0, tt), wt = We[Be] = {
                        tween: new A,
                        time: tt,
                        timer: zt,
                        delay: Ue.delay,
                        duration: Ue.duration,
                        ease: Ue.ease,
                        index: oe
                    }, Ue = null, ++We.count);
                }
                e.svg.axis = function() {
                    var Z = e.scale.linear(), oe = Hl, we = 6, Be = 6, Ue = 3, We = [
                        10
                    ], wt = null, tt;
                    function zt(or) {
                        or.each(function() {
                            var lr = e.select(this), Dr = this.__chart__ || Z, Ir = this.__chart__ = Z.copy(), oi = wt == null ? Ir.ticks ? Ir.ticks.apply(Ir, We) : Ir.domain() : wt, ui = tt == null ? Ir.tickFormat ? Ir.tickFormat.apply(Ir, We) : H : tt, qr = lr.selectAll(".tick").data(oi, Ir), Kr = qr.enter().insert("g", ".domain").attr("class", "tick").style("opacity", Ye), ii = e.transition(qr.exit()).style("opacity", Ye).remove(), vi = e.transition(qr.order()).style("opacity", 1), ci = Math.max(we, 0) + Ue, Jr, un = Xi(Ir), dn = lr.selectAll(".domain").data([
                                0
                            ]), En = (dn.enter().append("path").attr("class", "domain"), e.transition(dn));
                            Kr.append("line"), Kr.append("text");
                            var Nn = Kr.select("line"), ga = vi.select("line"), ya = qr.select("text").text(ui), so = Kr.select("text"), wa = vi.select("text"), io = oe === "top" || oe === "left" ? -1 : 1, Ss, _s, Ns, pn;
                            if (oe === "bottom" || oe === "top" ? (Jr = cu, Ss = "x", Ns = "y", _s = "x2", pn = "y2", ya.attr("dy", io < 0 ? "0em" : ".71em").style("text-anchor", "middle"), En.attr("d", "M" + un[0] + "," + io * Be + "V0H" + un[1] + "V" + io * Be)) : (Jr = el, Ss = "y", Ns = "x", _s = "y2", pn = "x2", ya.attr("dy", ".32em").style("text-anchor", io < 0 ? "end" : "start"), En.attr("d", "M" + io * Be + "," + un[0] + "H0V" + un[1] + "H" + io * Be)), Nn.attr(pn, io * we), so.attr(Ns, io * ci), ga.attr(_s, 0).attr(pn, io * we), wa.attr(Ss, 0).attr(Ns, io * ci), Ir.rangeBand) {
                                var za = Ir, Lo = za.rangeBand() / 2;
                                Dr = Ir = function(Fo) {
                                    return za(Fo) + Lo;
                                };
                            } else Dr.rangeBand ? Dr = Ir : ii.call(Jr, Ir, Dr);
                            Kr.call(Jr, Dr, Ir), vi.call(Jr, Ir, Ir);
                        });
                    }
                    return zt.scale = function(or) {
                        return arguments.length ? (Z = or, zt) : Z;
                    }, zt.orient = function(or) {
                        return arguments.length ? (oe = or in Zu ? or + "" : Hl, zt) : oe;
                    }, zt.ticks = function() {
                        return arguments.length ? (We = r(arguments), zt) : We;
                    }, zt.tickValues = function(or) {
                        return arguments.length ? (wt = or, zt) : wt;
                    }, zt.tickFormat = function(or) {
                        return arguments.length ? (tt = or, zt) : tt;
                    }, zt.tickSize = function(or) {
                        var lr = arguments.length;
                        return lr ? (we = +or, Be = +arguments[lr - 1], zt) : we;
                    }, zt.innerTickSize = function(or) {
                        return arguments.length ? (we = +or, zt) : we;
                    }, zt.outerTickSize = function(or) {
                        return arguments.length ? (Be = +or, zt) : Be;
                    }, zt.tickPadding = function(or) {
                        return arguments.length ? (Ue = +or, zt) : Ue;
                    }, zt.tickSubdivide = function() {
                        return arguments.length && zt;
                    }, zt;
                };
                var Hl = "bottom", Zu = {
                    top: 1,
                    right: 1,
                    bottom: 1,
                    left: 1
                };
                function cu(Z, oe, we) {
                    Z.attr("transform", function(Be) {
                        var Ue = oe(Be);
                        return "translate(" + (isFinite(Ue) ? Ue : we(Be)) + ",0)";
                    });
                }
                function el(Z, oe, we) {
                    Z.attr("transform", function(Be) {
                        var Ue = oe(Be);
                        return "translate(0," + (isFinite(Ue) ? Ue : we(Be)) + ")";
                    });
                }
                e.svg.brush = function() {
                    var Z = ke(lr, "brushstart", "brush", "brushend"), oe = null, we = null, Be = [
                        0,
                        0
                    ], Ue = [
                        0,
                        0
                    ], We, wt, tt = !0, zt = !0, or = zc[0];
                    function lr(qr) {
                        qr.each(function() {
                            var Kr = e.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", ui).on("touchstart.brush", ui), ii = Kr.selectAll(".background").data([
                                0
                            ]);
                            ii.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair"), Kr.selectAll(".extent").data([
                                0
                            ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
                            var vi = Kr.selectAll(".resize").data(or, H);
                            vi.exit().remove(), vi.enter().append("g").attr("class", function(dn) {
                                return "resize " + dn;
                            }).style("cursor", function(dn) {
                                return au[dn];
                            }).append("rect").attr("x", function(dn) {
                                return /[ew]$/.test(dn) ? -3 : null;
                            }).attr("y", function(dn) {
                                return /^[ns]/.test(dn) ? -3 : null;
                            }).attr("width", 6).attr("height", 6).style("visibility", "hidden"), vi.style("display", lr.empty() ? "none" : null);
                            var ci = e.transition(Kr), Jr = e.transition(ii), un;
                            oe && (un = Xi(oe), Jr.attr("x", un[0]).attr("width", un[1] - un[0]), Ir(ci)), we && (un = Xi(we), Jr.attr("y", un[0]).attr("height", un[1] - un[0]), oi(ci)), Dr(ci);
                        });
                    }
                    lr.event = function(qr) {
                        qr.each(function() {
                            var Kr = Z.of(this, arguments), ii = {
                                x: Be,
                                y: Ue,
                                i: We,
                                j: wt
                            }, vi = this.__chart__ || ii;
                            this.__chart__ = ii, Ro ? e.select(this).transition().each("start.brush", function() {
                                We = vi.i, wt = vi.j, Be = vi.x, Ue = vi.y, Kr({
                                    type: "brushstart"
                                });
                            }).tween("brush:brush", function() {
                                var ci = ec(Be, ii.x), Jr = ec(Ue, ii.y);
                                return We = wt = null, function(un) {
                                    Be = ii.x = ci(un), Ue = ii.y = Jr(un), Kr({
                                        type: "brush",
                                        mode: "resize"
                                    });
                                };
                            }).each("end.brush", function() {
                                We = ii.i, wt = ii.j, Kr({
                                    type: "brush",
                                    mode: "resize"
                                }), Kr({
                                    type: "brushend"
                                });
                            }) : (Kr({
                                type: "brushstart"
                            }), Kr({
                                type: "brush",
                                mode: "resize"
                            }), Kr({
                                type: "brushend"
                            }));
                        });
                    };
                    function Dr(qr) {
                        qr.selectAll(".resize").attr("transform", function(Kr) {
                            return "translate(" + Be[+/e$/.test(Kr)] + "," + Ue[+/^s/.test(Kr)] + ")";
                        });
                    }
                    function Ir(qr) {
                        qr.select(".extent").attr("x", Be[0]), qr.selectAll(".extent,.n>rect,.s>rect").attr("width", Be[1] - Be[0]);
                    }
                    function oi(qr) {
                        qr.select(".extent").attr("y", Ue[0]), qr.selectAll(".extent,.e>rect,.w>rect").attr("height", Ue[1] - Ue[0]);
                    }
                    function ui() {
                        var qr = this, Kr = e.select(e.event.target), ii = Z.of(qr, arguments), vi = e.select(qr), ci = Kr.datum(), Jr = !/^(n|s)$/.test(ci) && oe, un = !/^(e|w)$/.test(ci) && we, dn = Kr.classed("extent"), En = Or(qr), Nn, ga = e.mouse(qr), ya, so = e.select(a(qr)).on("keydown.brush", Ss).on("keyup.brush", _s);
                        if (e.event.changedTouches ? so.on("touchmove.brush", Ns).on("touchend.brush", za) : so.on("mousemove.brush", Ns).on("mouseup.brush", za), vi.interrupt().selectAll("*").interrupt(), dn) ga[0] = Be[0] - ga[0], ga[1] = Ue[0] - ga[1];
                        else if (ci) {
                            var wa = +/w$/.test(ci), io = +/^n/.test(ci);
                            ya = [
                                Be[1 - wa] - ga[0],
                                Ue[1 - io] - ga[1]
                            ], ga[0] = Be[wa], ga[1] = Ue[io];
                        } else e.event.altKey && (Nn = ga.slice());
                        vi.style("pointer-events", "none").selectAll(".resize").style("display", null), e.select("body").style("cursor", Kr.style("cursor")), ii({
                            type: "brushstart"
                        }), Ns();
                        function Ss() {
                            e.event.keyCode == 32 && (dn || (Nn = null, ga[0] -= Be[1], ga[1] -= Ue[1], dn = 2), _e());
                        }
                        function _s() {
                            e.event.keyCode == 32 && dn == 2 && (ga[0] += Be[1], ga[1] += Ue[1], dn = 0, _e());
                        }
                        function Ns() {
                            var Lo = e.mouse(qr), Fo = !1;
                            ya && (Lo[0] += ya[0], Lo[1] += ya[1]), dn || (e.event.altKey ? (Nn || (Nn = [
                                (Be[0] + Be[1]) / 2,
                                (Ue[0] + Ue[1]) / 2
                            ]), ga[0] = Be[+(Lo[0] < Nn[0])], ga[1] = Ue[+(Lo[1] < Nn[1])]) : Nn = null), Jr && pn(Lo, oe, 0) && (Ir(vi), Fo = !0), un && pn(Lo, we, 1) && (oi(vi), Fo = !0), Fo && (Dr(vi), ii({
                                type: "brush",
                                mode: dn ? "move" : "resize"
                            }));
                        }
                        function pn(Lo, Fo, js) {
                            var xl = Xi(Fo), fu = xl[0], dl = xl[1], xc = ga[js], At = js ? Ue : Be, Er = At[1] - At[0], Wr, wi;
                            if (dn && (fu -= xc, dl -= Er + xc), Wr = (js ? zt : tt) ? Math.max(fu, Math.min(dl, Lo[js])) : Lo[js], dn ? wi = (Wr += xc) + Er : (Nn && (xc = Math.max(fu, Math.min(dl, 2 * Nn[js] - Wr))), xc < Wr ? (wi = Wr, Wr = xc) : wi = xc), At[0] != Wr || At[1] != wi) return js ? wt = null : We = null, At[0] = Wr, At[1] = wi, !0;
                        }
                        function za() {
                            Ns(), vi.style("pointer-events", "all").selectAll(".resize").style("display", lr.empty() ? "none" : null), e.select("body").style("cursor", null), so.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null), En(), ii({
                                type: "brushend"
                            });
                        }
                    }
                    return lr.x = function(qr) {
                        return arguments.length ? (oe = qr, or = zc[!oe << 1 | !we], lr) : oe;
                    }, lr.y = function(qr) {
                        return arguments.length ? (we = qr, or = zc[!oe << 1 | !we], lr) : we;
                    }, lr.clamp = function(qr) {
                        return arguments.length ? (oe && we ? (tt = !!qr[0], zt = !!qr[1]) : oe ? tt = !!qr : we && (zt = !!qr), lr) : oe && we ? [
                            tt,
                            zt
                        ] : oe ? tt : we ? zt : null;
                    }, lr.extent = function(qr) {
                        var Kr, ii, vi, ci, Jr;
                        return arguments.length ? (oe && (Kr = qr[0], ii = qr[1], we && (Kr = Kr[0], ii = ii[0]), We = [
                            Kr,
                            ii
                        ], oe.invert && (Kr = oe(Kr), ii = oe(ii)), ii < Kr && (Jr = Kr, Kr = ii, ii = Jr), (Kr != Be[0] || ii != Be[1]) && (Be = [
                            Kr,
                            ii
                        ])), we && (vi = qr[0], ci = qr[1], oe && (vi = vi[1], ci = ci[1]), wt = [
                            vi,
                            ci
                        ], we.invert && (vi = we(vi), ci = we(ci)), ci < vi && (Jr = vi, vi = ci, ci = Jr), (vi != Ue[0] || ci != Ue[1]) && (Ue = [
                            vi,
                            ci
                        ])), lr) : (oe && (We ? (Kr = We[0], ii = We[1]) : (Kr = Be[0], ii = Be[1], oe.invert && (Kr = oe.invert(Kr), ii = oe.invert(ii)), ii < Kr && (Jr = Kr, Kr = ii, ii = Jr))), we && (wt ? (vi = wt[0], ci = wt[1]) : (vi = Ue[0], ci = Ue[1], we.invert && (vi = we.invert(vi), ci = we.invert(ci)), ci < vi && (Jr = vi, vi = ci, ci = Jr))), oe && we ? [
                            [
                                Kr,
                                vi
                            ],
                            [
                                ii,
                                ci
                            ]
                        ] : oe ? [
                            Kr,
                            ii
                        ] : we && [
                            vi,
                            ci
                        ]);
                    }, lr.clear = function() {
                        return lr.empty() || (Be = [
                            0,
                            0
                        ], Ue = [
                            0,
                            0
                        ], We = wt = null), lr;
                    }, lr.empty = function() {
                        return !!oe && Be[0] == Be[1] || !!we && Ue[0] == Ue[1];
                    }, e.rebind(lr, Z, "on");
                };
                var au = {
                    n: "ns-resize",
                    e: "ew-resize",
                    s: "ns-resize",
                    w: "ew-resize",
                    nw: "nwse-resize",
                    ne: "nesw-resize",
                    se: "nwse-resize",
                    sw: "nesw-resize"
                }, zc = [
                    [
                        "n",
                        "e",
                        "s",
                        "w",
                        "nw",
                        "ne",
                        "se",
                        "sw"
                    ],
                    [
                        "e",
                        "w"
                    ],
                    [
                        "n",
                        "s"
                    ],
                    []
                ];
                e.text = zi(function(Z) {
                    return Z.responseText;
                }), e.json = function(Z, oe) {
                    return Yi(Z, "application/json", zl, oe);
                };
                function zl(Z) {
                    return JSON.parse(Z.responseText);
                }
                e.html = function(Z, oe) {
                    return Yi(Z, "text/html", Fl, oe);
                };
                function Fl(Z) {
                    var oe = n.createRange();
                    return oe.selectNode(n.body), oe.createContextualFragment(Z.responseText);
                }
                e.xml = zi(function(Z) {
                    return Z.responseXML;
                }), typeof r6 == "object" && r6.exports ? r6.exports = e : this.d3 = e;
            }).apply(self);
        });
        var dq = ye((i6, nee)=>{
            (function(e, t) {
                typeof i6 == "object" && typeof nee != "undefined" ? t(i6) : (e = e || self, t(e.d3 = e.d3 || {}));
            })(i6, function(e) {
                "use strict";
                var t = new Date, r = new Date;
                function n(Ke, xt, bt, Lt) {
                    function St(Et) {
                        return Ke(Et = arguments.length === 0 ? new Date : new Date(+Et)), Et;
                    }
                    return St.floor = function(Et) {
                        return Ke(Et = new Date(+Et)), Et;
                    }, St.ceil = function(Et) {
                        return Ke(Et = new Date(Et - 1)), xt(Et, 1), Ke(Et), Et;
                    }, St.round = function(Et) {
                        var dt = St(Et), Ht = St.ceil(Et);
                        return Et - dt < Ht - Et ? dt : Ht;
                    }, St.offset = function(Et, dt) {
                        return xt(Et = new Date(+Et), dt == null ? 1 : Math.floor(dt)), Et;
                    }, St.range = function(Et, dt, Ht) {
                        var $t = [], fr;
                        if (Et = St.ceil(Et), Ht = Ht == null ? 1 : Math.floor(Ht), !(Et < dt) || !(Ht > 0)) return $t;
                        do $t.push(fr = new Date(+Et)), xt(Et, Ht), Ke(Et);
                        while (fr < Et && Et < dt);
                        return $t;
                    }, St.filter = function(Et) {
                        return n(function(dt) {
                            if (dt >= dt) for(; Ke(dt), !Et(dt);)dt.setTime(dt - 1);
                        }, function(dt, Ht) {
                            if (dt >= dt) {
                                if (Ht < 0) for(; ++Ht <= 0;)for(; xt(dt, -1), !Et(dt););
                                else for(; --Ht >= 0;)for(; xt(dt, 1), !Et(dt););
                            }
                        });
                    }, bt && (St.count = function(Et, dt) {
                        return t.setTime(+Et), r.setTime(+dt), Ke(t), Ke(r), Math.floor(bt(t, r));
                    }, St.every = function(Et) {
                        return Et = Math.floor(Et), !isFinite(Et) || !(Et > 0) ? null : Et > 1 ? St.filter(Lt ? function(dt) {
                            return Lt(dt) % Et === 0;
                        } : function(dt) {
                            return St.count(0, dt) % Et === 0;
                        }) : St;
                    }), St;
                }
                var i = n(function() {}, function(Ke, xt) {
                    Ke.setTime(+Ke + xt);
                }, function(Ke, xt) {
                    return xt - Ke;
                });
                i.every = function(Ke) {
                    return Ke = Math.floor(Ke), !isFinite(Ke) || !(Ke > 0) ? null : Ke > 1 ? n(function(xt) {
                        xt.setTime(Math.floor(xt / Ke) * Ke);
                    }, function(xt, bt) {
                        xt.setTime(+xt + bt * Ke);
                    }, function(xt, bt) {
                        return (bt - xt) / Ke;
                    }) : i;
                };
                var a = i.range, o = 1e3, s = 6e4, l = 36e5, u = 864e5, c = 6048e5, f = n(function(Ke) {
                    Ke.setTime(Ke - Ke.getMilliseconds());
                }, function(Ke, xt) {
                    Ke.setTime(+Ke + xt * o);
                }, function(Ke, xt) {
                    return (xt - Ke) / o;
                }, function(Ke) {
                    return Ke.getUTCSeconds();
                }), h = f.range, d = n(function(Ke) {
                    Ke.setTime(Ke - Ke.getMilliseconds() - Ke.getSeconds() * o);
                }, function(Ke, xt) {
                    Ke.setTime(+Ke + xt * s);
                }, function(Ke, xt) {
                    return (xt - Ke) / s;
                }, function(Ke) {
                    return Ke.getMinutes();
                }), v = d.range, x = n(function(Ke) {
                    Ke.setTime(Ke - Ke.getMilliseconds() - Ke.getSeconds() * o - Ke.getMinutes() * s);
                }, function(Ke, xt) {
                    Ke.setTime(+Ke + xt * l);
                }, function(Ke, xt) {
                    return (xt - Ke) / l;
                }, function(Ke) {
                    return Ke.getHours();
                }), b = x.range, p = n(function(Ke) {
                    Ke.setHours(0, 0, 0, 0);
                }, function(Ke, xt) {
                    Ke.setDate(Ke.getDate() + xt);
                }, function(Ke, xt) {
                    return (xt - Ke - (xt.getTimezoneOffset() - Ke.getTimezoneOffset()) * s) / u;
                }, function(Ke) {
                    return Ke.getDate() - 1;
                }), E = p.range;
                function k(Ke) {
                    return n(function(xt) {
                        xt.setDate(xt.getDate() - (xt.getDay() + 7 - Ke) % 7), xt.setHours(0, 0, 0, 0);
                    }, function(xt, bt) {
                        xt.setDate(xt.getDate() + bt * 7);
                    }, function(xt, bt) {
                        return (bt - xt - (bt.getTimezoneOffset() - xt.getTimezoneOffset()) * s) / c;
                    });
                }
                var A = k(0), L = k(1), _ = k(2), C = k(3), M = k(4), g = k(5), P = k(6), T = A.range, F = L.range, q = _.range, V = C.range, H = M.range, X = g.range, G = P.range, N = n(function(Ke) {
                    Ke.setDate(1), Ke.setHours(0, 0, 0, 0);
                }, function(Ke, xt) {
                    Ke.setMonth(Ke.getMonth() + xt);
                }, function(Ke, xt) {
                    return xt.getMonth() - Ke.getMonth() + (xt.getFullYear() - Ke.getFullYear()) * 12;
                }, function(Ke) {
                    return Ke.getMonth();
                }), W = N.range, re = n(function(Ke) {
                    Ke.setMonth(0, 1), Ke.setHours(0, 0, 0, 0);
                }, function(Ke, xt) {
                    Ke.setFullYear(Ke.getFullYear() + xt);
                }, function(Ke, xt) {
                    return xt.getFullYear() - Ke.getFullYear();
                }, function(Ke) {
                    return Ke.getFullYear();
                });
                re.every = function(Ke) {
                    return !isFinite(Ke = Math.floor(Ke)) || !(Ke > 0) ? null : n(function(xt) {
                        xt.setFullYear(Math.floor(xt.getFullYear() / Ke) * Ke), xt.setMonth(0, 1), xt.setHours(0, 0, 0, 0);
                    }, function(xt, bt) {
                        xt.setFullYear(xt.getFullYear() + bt * Ke);
                    });
                };
                var ae = re.range, _e = n(function(Ke) {
                    Ke.setUTCSeconds(0, 0);
                }, function(Ke, xt) {
                    Ke.setTime(+Ke + xt * s);
                }, function(Ke, xt) {
                    return (xt - Ke) / s;
                }, function(Ke) {
                    return Ke.getUTCMinutes();
                }), Me = _e.range, ke = n(function(Ke) {
                    Ke.setUTCMinutes(0, 0, 0);
                }, function(Ke, xt) {
                    Ke.setTime(+Ke + xt * l);
                }, function(Ke, xt) {
                    return (xt - Ke) / l;
                }, function(Ke) {
                    return Ke.getUTCHours();
                }), ge = ke.range, ie = n(function(Ke) {
                    Ke.setUTCHours(0, 0, 0, 0);
                }, function(Ke, xt) {
                    Ke.setUTCDate(Ke.getUTCDate() + xt);
                }, function(Ke, xt) {
                    return (xt - Ke) / u;
                }, function(Ke) {
                    return Ke.getUTCDate() - 1;
                }), Te = ie.range;
                function Ee(Ke) {
                    return n(function(xt) {
                        xt.setUTCDate(xt.getUTCDate() - (xt.getUTCDay() + 7 - Ke) % 7), xt.setUTCHours(0, 0, 0, 0);
                    }, function(xt, bt) {
                        xt.setUTCDate(xt.getUTCDate() + bt * 7);
                    }, function(xt, bt) {
                        return (bt - xt) / c;
                    });
                }
                var Ae = Ee(0), ze = Ee(1), Ce = Ee(2), me = Ee(3), Re = Ee(4), ce = Ee(5), Ge = Ee(6), nt = Ae.range, ct = ze.range, qt = Ce.range, rt = me.range, ot = Re.range, Rt = ce.range, kt = Ge.range, Ct = n(function(Ke) {
                    Ke.setUTCDate(1), Ke.setUTCHours(0, 0, 0, 0);
                }, function(Ke, xt) {
                    Ke.setUTCMonth(Ke.getUTCMonth() + xt);
                }, function(Ke, xt) {
                    return xt.getUTCMonth() - Ke.getUTCMonth() + (xt.getUTCFullYear() - Ke.getUTCFullYear()) * 12;
                }, function(Ke) {
                    return Ke.getUTCMonth();
                }), Yt = Ct.range, xr = n(function(Ke) {
                    Ke.setUTCMonth(0, 1), Ke.setUTCHours(0, 0, 0, 0);
                }, function(Ke, xt) {
                    Ke.setUTCFullYear(Ke.getUTCFullYear() + xt);
                }, function(Ke, xt) {
                    return xt.getUTCFullYear() - Ke.getUTCFullYear();
                }, function(Ke) {
                    return Ke.getUTCFullYear();
                });
                xr.every = function(Ke) {
                    return !isFinite(Ke = Math.floor(Ke)) || !(Ke > 0) ? null : n(function(xt) {
                        xt.setUTCFullYear(Math.floor(xt.getUTCFullYear() / Ke) * Ke), xt.setUTCMonth(0, 1), xt.setUTCHours(0, 0, 0, 0);
                    }, function(xt, bt) {
                        xt.setUTCFullYear(xt.getUTCFullYear() + bt * Ke);
                    });
                };
                var er = xr.range;
                e.timeDay = p, e.timeDays = E, e.timeFriday = g, e.timeFridays = X, e.timeHour = x, e.timeHours = b, e.timeInterval = n, e.timeMillisecond = i, e.timeMilliseconds = a, e.timeMinute = d, e.timeMinutes = v, e.timeMonday = L, e.timeMondays = F, e.timeMonth = N, e.timeMonths = W, e.timeSaturday = P, e.timeSaturdays = G, e.timeSecond = f, e.timeSeconds = h, e.timeSunday = A, e.timeSundays = T, e.timeThursday = M, e.timeThursdays = H, e.timeTuesday = _, e.timeTuesdays = q, e.timeWednesday = C, e.timeWednesdays = V, e.timeWeek = A, e.timeWeeks = T, e.timeYear = re, e.timeYears = ae, e.utcDay = ie, e.utcDays = Te, e.utcFriday = ce, e.utcFridays = Rt, e.utcHour = ke, e.utcHours = ge, e.utcMillisecond = i, e.utcMilliseconds = a, e.utcMinute = _e, e.utcMinutes = Me, e.utcMonday = ze, e.utcMondays = ct, e.utcMonth = Ct, e.utcMonths = Yt, e.utcSaturday = Ge, e.utcSaturdays = kt, e.utcSecond = f, e.utcSeconds = h, e.utcSunday = Ae, e.utcSundays = nt, e.utcThursday = Re, e.utcThursdays = ot, e.utcTuesday = Ce, e.utcTuesdays = qt, e.utcWednesday = me, e.utcWednesdays = rt, e.utcWeek = Ae, e.utcWeeks = nt, e.utcYear = xr, e.utcYears = er, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var e3 = ye((n6, aee)=>{
            (function(e, t) {
                typeof n6 == "object" && typeof aee != "undefined" ? t(n6, dq()) : (e = e || self, t(e.d3 = e.d3 || {}, e.d3));
            })(n6, function(e, t) {
                "use strict";
                function r(Ne) {
                    if (0 <= Ne.y && Ne.y < 100) {
                        var Ye = new Date(-1, Ne.m, Ne.d, Ne.H, Ne.M, Ne.S, Ne.L);
                        return Ye.setFullYear(Ne.y), Ye;
                    }
                    return new Date(Ne.y, Ne.m, Ne.d, Ne.H, Ne.M, Ne.S, Ne.L);
                }
                function n(Ne) {
                    if (0 <= Ne.y && Ne.y < 100) {
                        var Ye = new Date(Date.UTC(-1, Ne.m, Ne.d, Ne.H, Ne.M, Ne.S, Ne.L));
                        return Ye.setUTCFullYear(Ne.y), Ye;
                    }
                    return new Date(Date.UTC(Ne.y, Ne.m, Ne.d, Ne.H, Ne.M, Ne.S, Ne.L));
                }
                function i(Ne, Ye, Ve) {
                    return {
                        y: Ne,
                        m: Ye,
                        d: Ve,
                        H: 0,
                        M: 0,
                        S: 0,
                        L: 0
                    };
                }
                function a(Ne) {
                    var Ye = Ne.dateTime, Ve = Ne.date, Xe = Ne.time, ht = Ne.periods, Le = Ne.days, xe = Ne.shortDays, Se = Ne.months, lt = Ne.shortMonths, Gt = h(ht), Vt = d(ht), ar = h(Le), Qr = d(Le), ai = h(xe), jr = d(xe), ri = h(Se), bi = d(Se), nn = h(lt), Wi = d(lt), Ni = {
                        a: Si,
                        A: Mi,
                        b: Pi,
                        B: Gi,
                        c: null,
                        d: N,
                        e: N,
                        f: Me,
                        H: W,
                        I: re,
                        j: ae,
                        L: _e,
                        m: ke,
                        M: ge,
                        p: Ki,
                        q: ka,
                        Q: dt,
                        s: Ht,
                        S: ie,
                        u: Te,
                        U: Ee,
                        V: Ae,
                        w: ze,
                        W: Ce,
                        x: null,
                        X: null,
                        y: me,
                        Y: Re,
                        Z: ce,
                        "%": Et
                    }, _n = {
                        a: jn,
                        A: la,
                        b: Fa,
                        B: Ra,
                        c: null,
                        d: Ge,
                        e: Ge,
                        f: ot,
                        H: nt,
                        I: ct,
                        j: qt,
                        L: rt,
                        m: Rt,
                        M: kt,
                        p: jo,
                        q: oa,
                        Q: dt,
                        s: Ht,
                        S: Ct,
                        u: Yt,
                        U: xr,
                        V: er,
                        w: Ke,
                        W: xt,
                        x: null,
                        X: null,
                        y: bt,
                        Y: Lt,
                        Z: St,
                        "%": Et
                    }, $i = {
                        a: jt,
                        A: Zt,
                        b: yr,
                        B: Fr,
                        c: Zr,
                        d: M,
                        e: M,
                        f: V,
                        H: P,
                        I: P,
                        j: g,
                        L: q,
                        m: C,
                        M: T,
                        p: ft,
                        q: _,
                        Q: X,
                        s: G,
                        S: F,
                        u: x,
                        U: b,
                        V: p,
                        w: v,
                        W: E,
                        x: Vr,
                        X: gi,
                        y: A,
                        Y: k,
                        Z: L,
                        "%": H
                    };
                    Ni.x = zn(Ve, Ni), Ni.X = zn(Xe, Ni), Ni.c = zn(Ye, Ni), _n.x = zn(Ve, _n), _n.X = zn(Xe, _n), _n.c = zn(Ye, _n);
                    function zn(Sn, Ha) {
                        return function(oo) {
                            var xn = [], _t = -1, br = 0, Hr = Sn.length, ti, zi, Yi;
                            for(oo instanceof Date || (oo = new Date(+oo)); ++_t < Hr;)Sn.charCodeAt(_t) === 37 && (xn.push(Sn.slice(br, _t)), (zi = o[ti = Sn.charAt(++_t)]) != null ? ti = Sn.charAt(++_t) : zi = ti === "e" ? " " : "0", (Yi = Ha[ti]) && (ti = Yi(oo, zi)), xn.push(ti), br = _t + 1);
                            return xn.push(Sn.slice(br, _t)), xn.join("");
                        };
                    }
                    function Wn(Sn, Ha) {
                        return function(oo) {
                            var xn = i(1900, void 0, 1), _t = It(xn, Sn, oo += "", 0), br, Hr;
                            if (_t != oo.length) return null;
                            if ("Q" in xn) return new Date(xn.Q);
                            if ("s" in xn) return new Date(xn.s * 1e3 + ("L" in xn ? xn.L : 0));
                            if (Ha && !("Z" in xn) && (xn.Z = 0), "p" in xn && (xn.H = xn.H % 12 + xn.p * 12), xn.m === void 0 && (xn.m = "q" in xn ? xn.q : 0), "V" in xn) {
                                if (xn.V < 1 || xn.V > 53) return null;
                                "w" in xn || (xn.w = 1), "Z" in xn ? (br = n(i(xn.y, 0, 1)), Hr = br.getUTCDay(), br = Hr > 4 || Hr === 0 ? t.utcMonday.ceil(br) : t.utcMonday(br), br = t.utcDay.offset(br, (xn.V - 1) * 7), xn.y = br.getUTCFullYear(), xn.m = br.getUTCMonth(), xn.d = br.getUTCDate() + (xn.w + 6) % 7) : (br = r(i(xn.y, 0, 1)), Hr = br.getDay(), br = Hr > 4 || Hr === 0 ? t.timeMonday.ceil(br) : t.timeMonday(br), br = t.timeDay.offset(br, (xn.V - 1) * 7), xn.y = br.getFullYear(), xn.m = br.getMonth(), xn.d = br.getDate() + (xn.w + 6) % 7);
                            } else ("W" in xn || "U" in xn) && ("w" in xn || (xn.w = "u" in xn ? xn.u % 7 : "W" in xn ? 1 : 0), Hr = "Z" in xn ? n(i(xn.y, 0, 1)).getUTCDay() : r(i(xn.y, 0, 1)).getDay(), xn.m = 0, xn.d = "W" in xn ? (xn.w + 6) % 7 + xn.W * 7 - (Hr + 5) % 7 : xn.w + xn.U * 7 - (Hr + 6) % 7);
                            return "Z" in xn ? (xn.H += xn.Z / 100 | 0, xn.M += xn.Z % 100, n(xn)) : r(xn);
                        };
                    }
                    function It(Sn, Ha, oo, xn) {
                        for(var _t = 0, br = Ha.length, Hr = oo.length, ti, zi; _t < br;){
                            if (xn >= Hr) return -1;
                            if (ti = Ha.charCodeAt(_t++), ti === 37) {
                                if (ti = Ha.charAt(_t++), zi = $i[ti in o ? Ha.charAt(_t++) : ti], !zi || (xn = zi(Sn, oo, xn)) < 0) return -1;
                            } else if (ti != oo.charCodeAt(xn++)) return -1;
                        }
                        return xn;
                    }
                    function ft(Sn, Ha, oo) {
                        var xn = Gt.exec(Ha.slice(oo));
                        return xn ? (Sn.p = Vt[xn[0].toLowerCase()], oo + xn[0].length) : -1;
                    }
                    function jt(Sn, Ha, oo) {
                        var xn = ai.exec(Ha.slice(oo));
                        return xn ? (Sn.w = jr[xn[0].toLowerCase()], oo + xn[0].length) : -1;
                    }
                    function Zt(Sn, Ha, oo) {
                        var xn = ar.exec(Ha.slice(oo));
                        return xn ? (Sn.w = Qr[xn[0].toLowerCase()], oo + xn[0].length) : -1;
                    }
                    function yr(Sn, Ha, oo) {
                        var xn = nn.exec(Ha.slice(oo));
                        return xn ? (Sn.m = Wi[xn[0].toLowerCase()], oo + xn[0].length) : -1;
                    }
                    function Fr(Sn, Ha, oo) {
                        var xn = ri.exec(Ha.slice(oo));
                        return xn ? (Sn.m = bi[xn[0].toLowerCase()], oo + xn[0].length) : -1;
                    }
                    function Zr(Sn, Ha, oo) {
                        return It(Sn, Ye, Ha, oo);
                    }
                    function Vr(Sn, Ha, oo) {
                        return It(Sn, Ve, Ha, oo);
                    }
                    function gi(Sn, Ha, oo) {
                        return It(Sn, Xe, Ha, oo);
                    }
                    function Si(Sn) {
                        return xe[Sn.getDay()];
                    }
                    function Mi(Sn) {
                        return Le[Sn.getDay()];
                    }
                    function Pi(Sn) {
                        return lt[Sn.getMonth()];
                    }
                    function Gi(Sn) {
                        return Se[Sn.getMonth()];
                    }
                    function Ki(Sn) {
                        return ht[+(Sn.getHours() >= 12)];
                    }
                    function ka(Sn) {
                        return 1 + ~~(Sn.getMonth() / 3);
                    }
                    function jn(Sn) {
                        return xe[Sn.getUTCDay()];
                    }
                    function la(Sn) {
                        return Le[Sn.getUTCDay()];
                    }
                    function Fa(Sn) {
                        return lt[Sn.getUTCMonth()];
                    }
                    function Ra(Sn) {
                        return Se[Sn.getUTCMonth()];
                    }
                    function jo(Sn) {
                        return ht[+(Sn.getUTCHours() >= 12)];
                    }
                    function oa(Sn) {
                        return 1 + ~~(Sn.getUTCMonth() / 3);
                    }
                    return {
                        format: function(Sn) {
                            var Ha = zn(Sn += "", Ni);
                            return Ha.toString = function() {
                                return Sn;
                            }, Ha;
                        },
                        parse: function(Sn) {
                            var Ha = Wn(Sn += "", !1);
                            return Ha.toString = function() {
                                return Sn;
                            }, Ha;
                        },
                        utcFormat: function(Sn) {
                            var Ha = zn(Sn += "", _n);
                            return Ha.toString = function() {
                                return Sn;
                            }, Ha;
                        },
                        utcParse: function(Sn) {
                            var Ha = Wn(Sn += "", !0);
                            return Ha.toString = function() {
                                return Sn;
                            }, Ha;
                        }
                    };
                }
                var o = {
                    "-": "",
                    _: " ",
                    0: "0"
                }, s = /^\s*\d+/, l = /^%/, u = /[\\^$*+?|[\]().{}]/g;
                function c(Ne, Ye, Ve) {
                    var Xe = Ne < 0 ? "-" : "", ht = (Xe ? -Ne : Ne) + "", Le = ht.length;
                    return Xe + (Le < Ve ? new Array(Ve - Le + 1).join(Ye) + ht : ht);
                }
                function f(Ne) {
                    return Ne.replace(u, "\\$&");
                }
                function h(Ne) {
                    return new RegExp("^(?:" + Ne.map(f).join("|") + ")", "i");
                }
                function d(Ne) {
                    for(var Ye = {}, Ve = -1, Xe = Ne.length; ++Ve < Xe;)Ye[Ne[Ve].toLowerCase()] = Ve;
                    return Ye;
                }
                function v(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 1));
                    return Xe ? (Ne.w = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function x(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 1));
                    return Xe ? (Ne.u = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function b(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 2));
                    return Xe ? (Ne.U = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function p(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 2));
                    return Xe ? (Ne.V = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function E(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 2));
                    return Xe ? (Ne.W = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function k(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 4));
                    return Xe ? (Ne.y = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function A(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 2));
                    return Xe ? (Ne.y = +Xe[0] + (+Xe[0] > 68 ? 1900 : 2e3), Ve + Xe[0].length) : -1;
                }
                function L(Ne, Ye, Ve) {
                    var Xe = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(Ye.slice(Ve, Ve + 6));
                    return Xe ? (Ne.Z = Xe[1] ? 0 : -(Xe[2] + (Xe[3] || "00")), Ve + Xe[0].length) : -1;
                }
                function _(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 1));
                    return Xe ? (Ne.q = Xe[0] * 3 - 3, Ve + Xe[0].length) : -1;
                }
                function C(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 2));
                    return Xe ? (Ne.m = Xe[0] - 1, Ve + Xe[0].length) : -1;
                }
                function M(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 2));
                    return Xe ? (Ne.d = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function g(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 3));
                    return Xe ? (Ne.m = 0, Ne.d = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function P(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 2));
                    return Xe ? (Ne.H = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function T(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 2));
                    return Xe ? (Ne.M = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function F(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 2));
                    return Xe ? (Ne.S = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function q(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 3));
                    return Xe ? (Ne.L = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function V(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve, Ve + 6));
                    return Xe ? (Ne.L = Math.floor(Xe[0] / 1e3), Ve + Xe[0].length) : -1;
                }
                function H(Ne, Ye, Ve) {
                    var Xe = l.exec(Ye.slice(Ve, Ve + 1));
                    return Xe ? Ve + Xe[0].length : -1;
                }
                function X(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve));
                    return Xe ? (Ne.Q = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function G(Ne, Ye, Ve) {
                    var Xe = s.exec(Ye.slice(Ve));
                    return Xe ? (Ne.s = +Xe[0], Ve + Xe[0].length) : -1;
                }
                function N(Ne, Ye) {
                    return c(Ne.getDate(), Ye, 2);
                }
                function W(Ne, Ye) {
                    return c(Ne.getHours(), Ye, 2);
                }
                function re(Ne, Ye) {
                    return c(Ne.getHours() % 12 || 12, Ye, 2);
                }
                function ae(Ne, Ye) {
                    return c(1 + t.timeDay.count(t.timeYear(Ne), Ne), Ye, 3);
                }
                function _e(Ne, Ye) {
                    return c(Ne.getMilliseconds(), Ye, 3);
                }
                function Me(Ne, Ye) {
                    return _e(Ne, Ye) + "000";
                }
                function ke(Ne, Ye) {
                    return c(Ne.getMonth() + 1, Ye, 2);
                }
                function ge(Ne, Ye) {
                    return c(Ne.getMinutes(), Ye, 2);
                }
                function ie(Ne, Ye) {
                    return c(Ne.getSeconds(), Ye, 2);
                }
                function Te(Ne) {
                    var Ye = Ne.getDay();
                    return Ye === 0 ? 7 : Ye;
                }
                function Ee(Ne, Ye) {
                    return c(t.timeSunday.count(t.timeYear(Ne) - 1, Ne), Ye, 2);
                }
                function Ae(Ne, Ye) {
                    var Ve = Ne.getDay();
                    return Ne = Ve >= 4 || Ve === 0 ? t.timeThursday(Ne) : t.timeThursday.ceil(Ne), c(t.timeThursday.count(t.timeYear(Ne), Ne) + (t.timeYear(Ne).getDay() === 4), Ye, 2);
                }
                function ze(Ne) {
                    return Ne.getDay();
                }
                function Ce(Ne, Ye) {
                    return c(t.timeMonday.count(t.timeYear(Ne) - 1, Ne), Ye, 2);
                }
                function me(Ne, Ye) {
                    return c(Ne.getFullYear() % 100, Ye, 2);
                }
                function Re(Ne, Ye) {
                    return c(Ne.getFullYear() % 1e4, Ye, 4);
                }
                function ce(Ne) {
                    var Ye = Ne.getTimezoneOffset();
                    return (Ye > 0 ? "-" : (Ye *= -1, "+")) + c(Ye / 60 | 0, "0", 2) + c(Ye % 60, "0", 2);
                }
                function Ge(Ne, Ye) {
                    return c(Ne.getUTCDate(), Ye, 2);
                }
                function nt(Ne, Ye) {
                    return c(Ne.getUTCHours(), Ye, 2);
                }
                function ct(Ne, Ye) {
                    return c(Ne.getUTCHours() % 12 || 12, Ye, 2);
                }
                function qt(Ne, Ye) {
                    return c(1 + t.utcDay.count(t.utcYear(Ne), Ne), Ye, 3);
                }
                function rt(Ne, Ye) {
                    return c(Ne.getUTCMilliseconds(), Ye, 3);
                }
                function ot(Ne, Ye) {
                    return rt(Ne, Ye) + "000";
                }
                function Rt(Ne, Ye) {
                    return c(Ne.getUTCMonth() + 1, Ye, 2);
                }
                function kt(Ne, Ye) {
                    return c(Ne.getUTCMinutes(), Ye, 2);
                }
                function Ct(Ne, Ye) {
                    return c(Ne.getUTCSeconds(), Ye, 2);
                }
                function Yt(Ne) {
                    var Ye = Ne.getUTCDay();
                    return Ye === 0 ? 7 : Ye;
                }
                function xr(Ne, Ye) {
                    return c(t.utcSunday.count(t.utcYear(Ne) - 1, Ne), Ye, 2);
                }
                function er(Ne, Ye) {
                    var Ve = Ne.getUTCDay();
                    return Ne = Ve >= 4 || Ve === 0 ? t.utcThursday(Ne) : t.utcThursday.ceil(Ne), c(t.utcThursday.count(t.utcYear(Ne), Ne) + (t.utcYear(Ne).getUTCDay() === 4), Ye, 2);
                }
                function Ke(Ne) {
                    return Ne.getUTCDay();
                }
                function xt(Ne, Ye) {
                    return c(t.utcMonday.count(t.utcYear(Ne) - 1, Ne), Ye, 2);
                }
                function bt(Ne, Ye) {
                    return c(Ne.getUTCFullYear() % 100, Ye, 2);
                }
                function Lt(Ne, Ye) {
                    return c(Ne.getUTCFullYear() % 1e4, Ye, 4);
                }
                function St() {
                    return "+0000";
                }
                function Et() {
                    return "%";
                }
                function dt(Ne) {
                    return +Ne;
                }
                function Ht(Ne) {
                    return Math.floor(+Ne / 1e3);
                }
                var $t;
                fr({
                    dateTime: "%x, %X",
                    date: "%-m/%-d/%Y",
                    time: "%-I:%M:%S %p",
                    periods: [
                        "AM",
                        "PM"
                    ],
                    days: [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    shortDays: [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    months: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    shortMonths: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ]
                });
                function fr(Ne) {
                    return $t = a(Ne), e.timeFormat = $t.format, e.timeParse = $t.parse, e.utcFormat = $t.utcFormat, e.utcParse = $t.utcParse, $t;
                }
                var _r = "%Y-%m-%dT%H:%M:%S.%LZ";
                function Br(Ne) {
                    return Ne.toISOString();
                }
                var Or = Date.prototype.toISOString ? Br : e.utcFormat(_r);
                function Nr(Ne) {
                    var Ye = new Date(Ne);
                    return isNaN(Ye) ? null : Ye;
                }
                var ut = +new Date("2000-01-01T00:00:00.000Z") ? Nr : e.utcParse(_r);
                e.isoFormat = Or, e.isoParse = ut, e.timeFormatDefaultLocale = fr, e.timeFormatLocale = a, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var vq = ye((a6, oee)=>{
            (function(e, t) {
                typeof a6 == "object" && typeof oee != "undefined" ? t(a6) : (e = typeof globalThis != "undefined" ? globalThis : e || self, t(e.d3 = e.d3 || {}));
            })(a6, function(e) {
                "use strict";
                function t(C) {
                    return Math.abs(C = Math.round(C)) >= 1e21 ? C.toLocaleString("en").replace(/,/g, "") : C.toString(10);
                }
                function r(C, M) {
                    if ((g = (C = M ? C.toExponential(M - 1) : C.toExponential()).indexOf("e")) < 0) return null;
                    var g, P = C.slice(0, g);
                    return [
                        P.length > 1 ? P[0] + P.slice(2) : P,
                        +C.slice(g + 1)
                    ];
                }
                function n(C) {
                    return C = r(Math.abs(C)), C ? C[1] : NaN;
                }
                function i(C, M) {
                    return function(g, P) {
                        for(var T = g.length, F = [], q = 0, V = C[0], H = 0; T > 0 && V > 0 && (H + V + 1 > P && (V = Math.max(1, P - H)), F.push(g.substring(T -= V, T + V)), !((H += V + 1) > P));)V = C[q = (q + 1) % C.length];
                        return F.reverse().join(M);
                    };
                }
                function a(C) {
                    return function(M) {
                        return M.replace(/[0-9]/g, function(g) {
                            return C[+g];
                        });
                    };
                }
                var o = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
                function s(C) {
                    if (!(M = o.exec(C))) throw new Error("invalid format: " + C);
                    var M;
                    return new l({
                        fill: M[1],
                        align: M[2],
                        sign: M[3],
                        symbol: M[4],
                        zero: M[5],
                        width: M[6],
                        comma: M[7],
                        precision: M[8] && M[8].slice(1),
                        trim: M[9],
                        type: M[10]
                    });
                }
                s.prototype = l.prototype;
                function l(C) {
                    this.fill = C.fill === void 0 ? " " : C.fill + "", this.align = C.align === void 0 ? ">" : C.align + "", this.sign = C.sign === void 0 ? "-" : C.sign + "", this.symbol = C.symbol === void 0 ? "" : C.symbol + "", this.zero = !!C.zero, this.width = C.width === void 0 ? void 0 : +C.width, this.comma = !!C.comma, this.precision = C.precision === void 0 ? void 0 : +C.precision, this.trim = !!C.trim, this.type = C.type === void 0 ? "" : C.type + "";
                }
                l.prototype.toString = function() {
                    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
                };
                function u(C) {
                    e: for(var M = C.length, g = 1, P = -1, T; g < M; ++g)switch(C[g]){
                        case ".":
                            P = T = g;
                            break;
                        case "0":
                            P === 0 && (P = g), T = g;
                            break;
                        default:
                            if (!+C[g]) break e;
                            P > 0 && (P = 0);
                            break;
                    }
                    return P > 0 ? C.slice(0, P) + C.slice(T + 1) : C;
                }
                var c;
                function f(C, M) {
                    var g = r(C, M);
                    if (!g) return C + "";
                    var P = g[0], T = g[1], F = T - (c = Math.max(-8, Math.min(8, Math.floor(T / 3))) * 3) + 1, q = P.length;
                    return F === q ? P : F > q ? P + new Array(F - q + 1).join("0") : F > 0 ? P.slice(0, F) + "." + P.slice(F) : "0." + new Array(1 - F).join("0") + r(C, Math.max(0, M + F - 1))[0];
                }
                function h(C, M) {
                    var g = r(C, M);
                    if (!g) return C + "";
                    var P = g[0], T = g[1];
                    return T < 0 ? "0." + new Array(-T).join("0") + P : P.length > T + 1 ? P.slice(0, T + 1) + "." + P.slice(T + 1) : P + new Array(T - P.length + 2).join("0");
                }
                var d = {
                    "%": function(C, M) {
                        return (C * 100).toFixed(M);
                    },
                    b: function(C) {
                        return Math.round(C).toString(2);
                    },
                    c: function(C) {
                        return C + "";
                    },
                    d: t,
                    e: function(C, M) {
                        return C.toExponential(M);
                    },
                    f: function(C, M) {
                        return C.toFixed(M);
                    },
                    g: function(C, M) {
                        return C.toPrecision(M);
                    },
                    o: function(C) {
                        return Math.round(C).toString(8);
                    },
                    p: function(C, M) {
                        return h(C * 100, M);
                    },
                    r: h,
                    s: f,
                    X: function(C) {
                        return Math.round(C).toString(16).toUpperCase();
                    },
                    x: function(C) {
                        return Math.round(C).toString(16);
                    }
                };
                function v(C) {
                    return C;
                }
                var x = Array.prototype.map, b = [
                    "y",
                    "z",
                    "a",
                    "f",
                    "p",
                    "n",
                    "\xB5",
                    "m",
                    "",
                    "k",
                    "M",
                    "G",
                    "T",
                    "P",
                    "E",
                    "Z",
                    "Y"
                ];
                function p(C) {
                    var M = C.grouping === void 0 || C.thousands === void 0 ? v : i(x.call(C.grouping, Number), C.thousands + ""), g = C.currency === void 0 ? "" : C.currency[0] + "", P = C.currency === void 0 ? "" : C.currency[1] + "", T = C.decimal === void 0 ? "." : C.decimal + "", F = C.numerals === void 0 ? v : a(x.call(C.numerals, String)), q = C.percent === void 0 ? "%" : C.percent + "", V = C.minus === void 0 ? "-" : C.minus + "", H = C.nan === void 0 ? "NaN" : C.nan + "";
                    function X(N) {
                        N = s(N);
                        var W = N.fill, re = N.align, ae = N.sign, _e = N.symbol, Me = N.zero, ke = N.width, ge = N.comma, ie = N.precision, Te = N.trim, Ee = N.type;
                        Ee === "n" ? (ge = !0, Ee = "g") : d[Ee] || (ie === void 0 && (ie = 12), Te = !0, Ee = "g"), (Me || W === "0" && re === "=") && (Me = !0, W = "0", re = "=");
                        var Ae = _e === "$" ? g : _e === "#" && /[boxX]/.test(Ee) ? "0" + Ee.toLowerCase() : "", ze = _e === "$" ? P : /[%p]/.test(Ee) ? q : "", Ce = d[Ee], me = /[defgprs%]/.test(Ee);
                        ie = ie === void 0 ? 6 : /[gprs]/.test(Ee) ? Math.max(1, Math.min(21, ie)) : Math.max(0, Math.min(20, ie));
                        function Re(ce) {
                            var Ge = Ae, nt = ze, ct, qt, rt;
                            if (Ee === "c") nt = Ce(ce) + nt, ce = "";
                            else {
                                ce = +ce;
                                var ot = ce < 0 || 1 / ce < 0;
                                if (ce = isNaN(ce) ? H : Ce(Math.abs(ce), ie), Te && (ce = u(ce)), ot && +ce == 0 && ae !== "+" && (ot = !1), Ge = (ot ? ae === "(" ? ae : V : ae === "-" || ae === "(" ? "" : ae) + Ge, nt = (Ee === "s" ? b[8 + c / 3] : "") + nt + (ot && ae === "(" ? ")" : ""), me) {
                                    for(ct = -1, qt = ce.length; ++ct < qt;)if (rt = ce.charCodeAt(ct), 48 > rt || rt > 57) {
                                        nt = (rt === 46 ? T + ce.slice(ct + 1) : ce.slice(ct)) + nt, ce = ce.slice(0, ct);
                                        break;
                                    }
                                }
                            }
                            ge && !Me && (ce = M(ce, 1 / 0));
                            var Rt = Ge.length + ce.length + nt.length, kt = Rt < ke ? new Array(ke - Rt + 1).join(W) : "";
                            switch(ge && Me && (ce = M(kt + ce, kt.length ? ke - nt.length : 1 / 0), kt = ""), re){
                                case "<":
                                    ce = Ge + ce + nt + kt;
                                    break;
                                case "=":
                                    ce = Ge + kt + ce + nt;
                                    break;
                                case "^":
                                    ce = kt.slice(0, Rt = kt.length >> 1) + Ge + ce + nt + kt.slice(Rt);
                                    break;
                                default:
                                    ce = kt + Ge + ce + nt;
                                    break;
                            }
                            return F(ce);
                        }
                        return Re.toString = function() {
                            return N + "";
                        }, Re;
                    }
                    function G(N, W) {
                        var re = X((N = s(N), N.type = "f", N)), ae = Math.max(-8, Math.min(8, Math.floor(n(W) / 3))) * 3, _e = Math.pow(10, -ae), Me = b[8 + ae / 3];
                        return function(ke) {
                            return re(_e * ke) + Me;
                        };
                    }
                    return {
                        format: X,
                        formatPrefix: G
                    };
                }
                var E;
                k({
                    decimal: ".",
                    thousands: ",",
                    grouping: [
                        3
                    ],
                    currency: [
                        "$",
                        ""
                    ],
                    minus: "-"
                });
                function k(C) {
                    return E = p(C), e.format = E.format, e.formatPrefix = E.formatPrefix, E;
                }
                function A(C) {
                    return Math.max(0, -n(Math.abs(C)));
                }
                function L(C, M) {
                    return Math.max(0, Math.max(-8, Math.min(8, Math.floor(n(M) / 3))) * 3 - n(Math.abs(C)));
                }
                function _(C, M) {
                    return C = Math.abs(C), M = Math.abs(M) - C, Math.max(0, n(M) - n(C)) + 1;
                }
                e.FormatSpecifier = l, e.formatDefaultLocale = k, e.formatLocale = p, e.formatSpecifier = s, e.precisionFixed = A, e.precisionPrefix = L, e.precisionRound = _, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var lee = ye((OQt, see)=>{
            "use strict";
            see.exports = function(e) {
                for(var t = e.length, r, n = 0; n < t; n++)if (r = e.charCodeAt(n), (r < 9 || r > 13) && r !== 32 && r !== 133 && r !== 160 && r !== 5760 && r !== 6158 && (r < 8192 || r > 8205) && r !== 8232 && r !== 8233 && r !== 8239 && r !== 8287 && r !== 8288 && r !== 12288 && r !== 65279) return !1;
                return !0;
            };
        });
        var uo = ye((BQt, uee)=>{
            "use strict";
            var KQe = lee();
            uee.exports = function(e) {
                var t = typeof e;
                if (t === "string") {
                    var r = e;
                    if (e = +e, e === 0 && KQe(r)) return !1;
                } else if (t !== "number") return !1;
                return e - e < 1;
            };
        });
        var es = ye((NQt, cee)=>{
            "use strict";
            cee.exports = {
                BADNUM: void 0,
                FP_SAFE: Number.MAX_VALUE * 1e-4,
                ONEMAXYEAR: 316224e5,
                ONEAVGYEAR: 315576e5,
                ONEMINYEAR: 31536e6,
                ONEMAXQUARTER: 79488e5,
                ONEAVGQUARTER: 78894e5,
                ONEMINQUARTER: 76896e5,
                ONEMAXMONTH: 26784e5,
                ONEAVGMONTH: 26298e5,
                ONEMINMONTH: 24192e5,
                ONEWEEK: 6048e5,
                ONEDAY: 864e5,
                ONEHOUR: 36e5,
                ONEMIN: 6e4,
                ONESEC: 1e3,
                ONEMILLI: 1,
                ONEMICROSEC: .001,
                EPOCHJD: 24405875e-1,
                ALMOST_EQUAL: 1 - 1e-6,
                LOG_CLIP: 10,
                MINUS_SIGN: "\u2212"
            };
        });
        var pq = ye((o6, fee)=>{
            (function(e, t) {
                typeof o6 == "object" && typeof fee != "undefined" ? t(o6) : (e = typeof globalThis != "undefined" ? globalThis : e || self, t(e["base64-arraybuffer"] = {}));
            })(o6, function(e) {
                "use strict";
                for(var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", r = typeof Uint8Array == "undefined" ? [] : new Uint8Array(256), n = 0; n < t.length; n++)r[t.charCodeAt(n)] = n;
                var i = function(o) {
                    var s = new Uint8Array(o), l, u = s.length, c = "";
                    for(l = 0; l < u; l += 3)c += t[s[l] >> 2], c += t[(s[l] & 3) << 4 | s[l + 1] >> 4], c += t[(s[l + 1] & 15) << 2 | s[l + 2] >> 6], c += t[s[l + 2] & 63];
                    return u % 3 === 2 ? c = c.substring(0, c.length - 1) + "=" : u % 3 === 1 && (c = c.substring(0, c.length - 2) + "=="), c;
                }, a = function(o) {
                    var s = o.length * .75, l = o.length, u, c = 0, f, h, d, v;
                    o[o.length - 1] === "=" && (s--, o[o.length - 2] === "=" && s--);
                    var x = new ArrayBuffer(s), b = new Uint8Array(x);
                    for(u = 0; u < l; u += 4)f = r[o.charCodeAt(u)], h = r[o.charCodeAt(u + 1)], d = r[o.charCodeAt(u + 2)], v = r[o.charCodeAt(u + 3)], b[c++] = f << 2 | h >> 4, b[c++] = (h & 15) << 4 | d >> 2, b[c++] = (d & 3) << 6 | v & 63;
                    return x;
                };
                e.decode = a, e.encode = i, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var gy = ye((UQt, hee)=>{
            "use strict";
            hee.exports = function(t) {
                return window && window.process && window.process.versions ? Object.prototype.toString.call(t) === "[object Object]" : Object.prototype.toString.call(t) === "[object Object]" && Object.getPrototypeOf(t).hasOwnProperty("hasOwnProperty");
            };
        });
        var vv = ye((mg)=>{
            "use strict";
            var JQe = pq().decode, $Qe = gy(), gq = Array.isArray, QQe = ArrayBuffer, eet = DataView;
            function dee(e) {
                return QQe.isView(e) && !(e instanceof eet);
            }
            mg.isTypedArray = dee;
            function s6(e) {
                return gq(e) || dee(e);
            }
            mg.isArrayOrTypedArray = s6;
            function tet(e) {
                return !s6(e[0]);
            }
            mg.isArray1D = tet;
            mg.ensureArray = function(e, t) {
                return gq(e) || (e = []), e.length = t, e;
            };
            var Md = {
                u1c: typeof Uint8ClampedArray == "undefined" ? void 0 : Uint8ClampedArray,
                i1: typeof Int8Array == "undefined" ? void 0 : Int8Array,
                u1: typeof Uint8Array == "undefined" ? void 0 : Uint8Array,
                i2: typeof Int16Array == "undefined" ? void 0 : Int16Array,
                u2: typeof Uint16Array == "undefined" ? void 0 : Uint16Array,
                i4: typeof Int32Array == "undefined" ? void 0 : Int32Array,
                u4: typeof Uint32Array == "undefined" ? void 0 : Uint32Array,
                f4: typeof Float32Array == "undefined" ? void 0 : Float32Array,
                f8: typeof Float64Array == "undefined" ? void 0 : Float64Array
            };
            Md.uint8c = Md.u1c;
            Md.uint8 = Md.u1;
            Md.int8 = Md.i1;
            Md.uint16 = Md.u2;
            Md.int16 = Md.i2;
            Md.uint32 = Md.u4;
            Md.int32 = Md.i4;
            Md.float32 = Md.f4;
            Md.float64 = Md.f8;
            function mq(e) {
                return e.constructor === ArrayBuffer;
            }
            mg.isArrayBuffer = mq;
            mg.decodeTypedArraySpec = function(e) {
                var t = [], r = ret(e), n = r.dtype, i = Md[n];
                if (!i) throw new Error('Error in dtype: "' + n + '"');
                var a = i.BYTES_PER_ELEMENT, o = r.bdata;
                mq(o) || (o = JQe(o));
                var s = r.shape === void 0 ? [
                    o.byteLength / a
                ] : ("" + r.shape).split(",");
                s.reverse();
                var l = s.length, u, c, f = +s[0], h = a * f, d = 0;
                if (l === 1) t = new i(o);
                else if (l === 2) for(u = +s[1], c = 0; c < u; c++)t[c] = new i(o, d, f), d += h;
                else if (l === 3) {
                    u = +s[1];
                    for(var v = +s[2], x = 0; x < v; x++)for(t[x] = [], c = 0; c < u; c++)t[x][c] = new i(o, d, f), d += h;
                } else throw new Error("ndim: " + l + 'is not supported with the shape:"' + r.shape + '"');
                return t.bdata = r.bdata, t.dtype = r.dtype, t.shape = s.reverse().join(","), e._inputArray = t, t;
            };
            mg.isTypedArraySpec = function(e) {
                return $Qe(e) && e.hasOwnProperty("dtype") && typeof e.dtype == "string" && e.hasOwnProperty("bdata") && (typeof e.bdata == "string" || mq(e.bdata)) && (e.shape === void 0 || e.hasOwnProperty("shape") && (typeof e.shape == "string" || typeof e.shape == "number"));
            };
            function ret(e) {
                return {
                    bdata: e.bdata,
                    dtype: e.dtype,
                    shape: e.shape
                };
            }
            mg.concat = function() {
                var e = [], t = !0, r = 0, n, i, a, o, s, l, u, c;
                for(a = 0; a < arguments.length; a++)o = arguments[a], l = o.length, l && (i ? e.push(o) : (i = o, s = l), gq(o) ? n = !1 : (t = !1, r ? n !== o.constructor && (n = !1) : n = o.constructor), r += l);
                if (!r) return [];
                if (!e.length) return i;
                if (t) return i.concat.apply(i, e);
                if (n) {
                    for(u = new n(r), u.set(i), a = 0; a < e.length; a++)o = e[a], u.set(o, s), s += o.length;
                    return u;
                }
                for(u = new Array(r), c = 0; c < i.length; c++)u[c] = i[c];
                for(a = 0; a < e.length; a++){
                    for(o = e[a], c = 0; c < o.length; c++)u[s + c] = o[c];
                    s += c;
                }
                return u;
            };
            mg.maxRowLength = function(e) {
                return vee(e, Math.max, 0);
            };
            mg.minRowLength = function(e) {
                return vee(e, Math.min, 1 / 0);
            };
            function vee(e, t, r) {
                if (s6(e)) {
                    if (s6(e[0])) {
                        for(var n = r, i = 0; i < e.length; i++)n = t(n, e[i].length);
                        return n;
                    } else return e.length;
                }
                return 0;
            }
        });
        var ES = ye((HQt, _ee)=>{
            "use strict";
            var pee = uo(), _q = vv().isArrayOrTypedArray;
            _ee.exports = function(t, r) {
                if (pee(r)) r = String(r);
                else if (typeof r != "string" || r.substr(r.length - 4) === "[-1]") throw "bad property string";
                var n = r.split("."), i, a, o, s;
                for(s = 0; s < n.length; s++)if (String(n[s]).slice(0, 2) === "__") throw "bad property string";
                for(s = 0; s < n.length;){
                    if (i = String(n[s]).match(/^([^\[\]]*)((\[\-?[0-9]*\])+)$/), i) {
                        if (i[1]) n[s] = i[1];
                        else if (s === 0) n.splice(0, 1);
                        else throw "bad property string";
                        for(a = i[2].substr(1, i[2].length - 2).split("]["), o = 0; o < a.length; o++)s++, n.splice(s, 0, Number(a[o]));
                    }
                    s++;
                }
                return typeof t != "object" ? oet(t, r, n) : {
                    set: mee(t, n, r),
                    get: gee(t, n),
                    astr: r,
                    parts: n,
                    obj: t
                };
            };
            function gee(e, t) {
                return function(r) {
                    var n = e, i, a, o, s, l;
                    for(s = 0; s < t.length - 1; s++){
                        if (i = t[s], i === -1) {
                            for(a = !0, o = [], l = 0; l < n.length; l++)o[l] = gee(n[l], t.slice(s + 1))(r), o[l] !== o[0] && (a = !1);
                            return a ? o[0] : o;
                        }
                        if (typeof i == "number" && !_q(n) || (n = n[i], typeof n != "object" || n === null)) return;
                    }
                    if (!(typeof n != "object" || n === null) && (o = n[t[s]], !(!r && o === null))) return o;
                };
            }
            var iet = /(^|\.)args\[/;
            function yq(e, t) {
                return e === void 0 || e === null && !t.match(iet);
            }
            function mee(e, t, r) {
                return function(n) {
                    var i = e, a = "", o = [
                        [
                            e,
                            a
                        ]
                    ], s = yq(n, r), l, u;
                    for(u = 0; u < t.length - 1; u++){
                        if (l = t[u], typeof l == "number" && !_q(i)) throw "array index but container is not an array";
                        if (l === -1) {
                            if (s = !aet(i, t.slice(u + 1), n, r), s) break;
                            return;
                        }
                        if (!yee(i, l, t[u + 1], s)) break;
                        if (i = i[l], typeof i != "object" || i === null) throw "container is not an object";
                        a = net(a, l), o.push([
                            i,
                            a
                        ]);
                    }
                    if (s) {
                        if (u === t.length - 1 && (delete i[t[u]], Array.isArray(i) && +t[u] === i.length - 1)) for(; i.length && i[i.length - 1] === void 0;)i.pop();
                    } else i[t[u]] = n;
                };
            }
            function net(e, t) {
                var r = t;
                return pee(t) ? r = "[" + t + "]" : e && (r = "." + t), e + r;
            }
            function aet(e, t, r, n) {
                var i = _q(r), a = !0, o = r, s = n.replace("-1", 0), l = i ? !1 : yq(r, s), u = t[0], c;
                for(c = 0; c < e.length; c++)s = n.replace("-1", c), i && (o = r[c % r.length], l = yq(o, s)), l && (a = !1), yee(e, c, u, l) && mee(e[c], t, n.replace("-1", c))(o);
                return a;
            }
            function yee(e, t, r, n) {
                if (e[t] === void 0) {
                    if (n) return !1;
                    typeof r == "number" ? e[t] = [] : e[t] = {};
                }
                return !0;
            }
            function oet(e, t, r) {
                return {
                    set: function() {
                        throw "bad container";
                    },
                    get: function() {},
                    astr: t,
                    parts: r,
                    obj: e
                };
            }
        });
        var Tee = ye((GQt, wee)=>{
            "use strict";
            var t3 = ES(), set = /^\w*$/, uet = 0, xee = 1, l6 = 2, bee = 3, ob = 4;
            wee.exports = function(t, r, n, i) {
                n = n || "name", i = i || "value";
                var a, o, s, l = {};
                r && r.length ? (s = t3(t, r), o = s.get()) : o = t, r = r || "";
                var u = {};
                if (o) for(a = 0; a < o.length; a++)u[o[a][n]] = a;
                var c = set.test(i), f = {
                    set: function(h, d) {
                        var v = d === null ? ob : uet;
                        if (!o) {
                            if (!s || v === ob) return;
                            o = [], s.set(o);
                        }
                        var x = u[h];
                        if (x === void 0) {
                            if (v === ob) return;
                            v = v | bee, x = o.length, u[h] = x;
                        } else d !== (c ? o[x][i] : t3(o[x], i).get()) && (v = v | l6);
                        var b = o[x] = o[x] || {};
                        return b[n] = h, c ? b[i] = d : t3(b, i).set(d), d !== null && (v = v & ~ob), l[x] = l[x] | v, f;
                    },
                    get: function(h) {
                        if (o) {
                            var d = u[h];
                            if (d !== void 0) return c ? o[d][i] : t3(o[d], i).get();
                        }
                    },
                    rename: function(h, d) {
                        var v = u[h];
                        return v === void 0 || (l[v] = l[v] | xee, u[d] = v, delete u[h], o[v][n] = d), f;
                    },
                    remove: function(h) {
                        var d = u[h];
                        if (d === void 0) return f;
                        var v = o[d];
                        if (Object.keys(v).length > 2) return l[d] = l[d] | l6, f.set(h, null);
                        if (c) {
                            for(a = d; a < o.length; a++)l[a] = l[a] | bee;
                            for(a = d; a < o.length; a++)u[o[a][n]]--;
                            o.splice(d, 1), delete u[h];
                        } else t3(v, i).set(null), l[d] = l[d] | l6 | ob;
                        return f;
                    },
                    constructUpdate: function() {
                        for(var h, d, v = {}, x = Object.keys(l), b = 0; b < x.length; b++)d = x[b], h = r + "[" + d + "]", o[d] ? (l[d] & xee && (v[h + "." + n] = o[d][n]), l[d] & l6 && (c ? v[h + "." + i] = l[d] & ob ? null : o[d][i] : v[h + "." + i] = l[d] & ob ? null : t3(o[d], i).get())) : v[h] = null;
                        return v;
                    }
                };
                return f;
            };
        });
        var See = ye((jQt, Aee)=>{
            "use strict";
            var cet = /^(.*)(\.[^\.\[\]]+|\[\d\])$/, fet = /^[^\.\[\]]+$/;
            Aee.exports = function(e, t) {
                for(; t;){
                    var r = e.match(cet);
                    if (r) e = r[1];
                    else if (e.match(fet)) e = "";
                    else throw new Error("bad relativeAttr call:" + [
                        e,
                        t
                    ]);
                    if (t.charAt(0) === "^") t = t.slice(1);
                    else break;
                }
                return e && t.charAt(0) !== "[" ? e + "." + t : e + t;
            };
        });
        var u6 = ye((WQt, Mee)=>{
            "use strict";
            var het = uo();
            Mee.exports = function(t, r) {
                if (t > 0) return Math.log(t) / Math.LN10;
                var n = Math.log(Math.min(r[0], r[1])) / Math.LN10;
                return het(n) || (n = Math.log(Math.max(r[0], r[1])) / Math.LN10 - 6), n;
            };
        });
        var Cee = ye((ZQt, kee)=>{
            "use strict";
            var Eee = vv().isArrayOrTypedArray, kS = gy();
            kee.exports = function e(t, r) {
                for(var n in r){
                    var i = r[n], a = t[n];
                    if (a !== i) {
                        if (n.charAt(0) === "_" || typeof i == "function") {
                            if (n in t) continue;
                            t[n] = i;
                        } else if (Eee(i) && Eee(a) && kS(i[0])) {
                            if (n === "customdata" || n === "ids") continue;
                            for(var o = Math.min(i.length, a.length), s = 0; s < o; s++)a[s] !== i[s] && kS(i[s]) && kS(a[s]) && e(a[s], i[s]);
                        } else kS(i) && kS(a) && (e(a, i), Object.keys(a).length || delete t[n]);
                    }
                }
            };
        });
        var r3 = ye((XQt, Lee)=>{
            "use strict";
            function det(e, t) {
                var r = e % t;
                return r < 0 ? r + t : r;
            }
            function vet(e, t) {
                return Math.abs(e) > t / 2 ? e - Math.round(e / t) * t : e;
            }
            Lee.exports = {
                mod: det,
                modHalf: vet
            };
        });
        var id = ye((YQt, c6)=>{
            (function(e) {
                var t = /^\s+/, r = /\s+$/, n = 0, i = e.round, a = e.min, o = e.max, s = e.random;
                function l(me, Re) {
                    if (me = me || "", Re = Re || {}, me instanceof l) return me;
                    if (!(this instanceof l)) return new l(me, Re);
                    var ce = u(me);
                    this._originalInput = me, this._r = ce.r, this._g = ce.g, this._b = ce.b, this._a = ce.a, this._roundA = i(100 * this._a) / 100, this._format = Re.format || ce.format, this._gradientType = Re.gradientType, this._r < 1 && (this._r = i(this._r)), this._g < 1 && (this._g = i(this._g)), this._b < 1 && (this._b = i(this._b)), this._ok = ce.ok, this._tc_id = n++;
                }
                l.prototype = {
                    isDark: function() {
                        return this.getBrightness() < 128;
                    },
                    isLight: function() {
                        return !this.isDark();
                    },
                    isValid: function() {
                        return this._ok;
                    },
                    getOriginalInput: function() {
                        return this._originalInput;
                    },
                    getFormat: function() {
                        return this._format;
                    },
                    getAlpha: function() {
                        return this._a;
                    },
                    getBrightness: function() {
                        var me = this.toRgb();
                        return (me.r * 299 + me.g * 587 + me.b * 114) / 1e3;
                    },
                    getLuminance: function() {
                        var me = this.toRgb(), Re, ce, Ge, nt, ct, qt;
                        return Re = me.r / 255, ce = me.g / 255, Ge = me.b / 255, Re <= .03928 ? nt = Re / 12.92 : nt = e.pow((Re + .055) / 1.055, 2.4), ce <= .03928 ? ct = ce / 12.92 : ct = e.pow((ce + .055) / 1.055, 2.4), Ge <= .03928 ? qt = Ge / 12.92 : qt = e.pow((Ge + .055) / 1.055, 2.4), .2126 * nt + .7152 * ct + .0722 * qt;
                    },
                    setAlpha: function(me) {
                        return this._a = N(me), this._roundA = i(100 * this._a) / 100, this;
                    },
                    toHsv: function() {
                        var me = d(this._r, this._g, this._b);
                        return {
                            h: me.h * 360,
                            s: me.s,
                            v: me.v,
                            a: this._a
                        };
                    },
                    toHsvString: function() {
                        var me = d(this._r, this._g, this._b), Re = i(me.h * 360), ce = i(me.s * 100), Ge = i(me.v * 100);
                        return this._a == 1 ? "hsv(" + Re + ", " + ce + "%, " + Ge + "%)" : "hsva(" + Re + ", " + ce + "%, " + Ge + "%, " + this._roundA + ")";
                    },
                    toHsl: function() {
                        var me = f(this._r, this._g, this._b);
                        return {
                            h: me.h * 360,
                            s: me.s,
                            l: me.l,
                            a: this._a
                        };
                    },
                    toHslString: function() {
                        var me = f(this._r, this._g, this._b), Re = i(me.h * 360), ce = i(me.s * 100), Ge = i(me.l * 100);
                        return this._a == 1 ? "hsl(" + Re + ", " + ce + "%, " + Ge + "%)" : "hsla(" + Re + ", " + ce + "%, " + Ge + "%, " + this._roundA + ")";
                    },
                    toHex: function(me) {
                        return x(this._r, this._g, this._b, me);
                    },
                    toHexString: function(me) {
                        return "#" + this.toHex(me);
                    },
                    toHex8: function(me) {
                        return b(this._r, this._g, this._b, this._a, me);
                    },
                    toHex8String: function(me) {
                        return "#" + this.toHex8(me);
                    },
                    toRgb: function() {
                        return {
                            r: i(this._r),
                            g: i(this._g),
                            b: i(this._b),
                            a: this._a
                        };
                    },
                    toRgbString: function() {
                        return this._a == 1 ? "rgb(" + i(this._r) + ", " + i(this._g) + ", " + i(this._b) + ")" : "rgba(" + i(this._r) + ", " + i(this._g) + ", " + i(this._b) + ", " + this._roundA + ")";
                    },
                    toPercentageRgb: function() {
                        return {
                            r: i(W(this._r, 255) * 100) + "%",
                            g: i(W(this._g, 255) * 100) + "%",
                            b: i(W(this._b, 255) * 100) + "%",
                            a: this._a
                        };
                    },
                    toPercentageRgbString: function() {
                        return this._a == 1 ? "rgb(" + i(W(this._r, 255) * 100) + "%, " + i(W(this._g, 255) * 100) + "%, " + i(W(this._b, 255) * 100) + "%)" : "rgba(" + i(W(this._r, 255) * 100) + "%, " + i(W(this._g, 255) * 100) + "%, " + i(W(this._b, 255) * 100) + "%, " + this._roundA + ")";
                    },
                    toName: function() {
                        return this._a === 0 ? "transparent" : this._a < 1 ? !1 : X[x(this._r, this._g, this._b, !0)] || !1;
                    },
                    toFilter: function(me) {
                        var Re = "#" + p(this._r, this._g, this._b, this._a), ce = Re, Ge = this._gradientType ? "GradientType = 1, " : "";
                        if (me) {
                            var nt = l(me);
                            ce = "#" + p(nt._r, nt._g, nt._b, nt._a);
                        }
                        return "progid:DXImageTransform.Microsoft.gradient(" + Ge + "startColorstr=" + Re + ",endColorstr=" + ce + ")";
                    },
                    toString: function(me) {
                        var Re = !!me;
                        me = me || this._format;
                        var ce = !1, Ge = this._a < 1 && this._a >= 0, nt = !Re && Ge && (me === "hex" || me === "hex6" || me === "hex3" || me === "hex4" || me === "hex8" || me === "name");
                        return nt ? me === "name" && this._a === 0 ? this.toName() : this.toRgbString() : (me === "rgb" && (ce = this.toRgbString()), me === "prgb" && (ce = this.toPercentageRgbString()), (me === "hex" || me === "hex6") && (ce = this.toHexString()), me === "hex3" && (ce = this.toHexString(!0)), me === "hex4" && (ce = this.toHex8String(!0)), me === "hex8" && (ce = this.toHex8String()), me === "name" && (ce = this.toName()), me === "hsl" && (ce = this.toHslString()), me === "hsv" && (ce = this.toHsvString()), ce || this.toHexString());
                    },
                    clone: function() {
                        return l(this.toString());
                    },
                    _applyModification: function(me, Re) {
                        var ce = me.apply(null, [
                            this
                        ].concat([].slice.call(Re)));
                        return this._r = ce._r, this._g = ce._g, this._b = ce._b, this.setAlpha(ce._a), this;
                    },
                    lighten: function() {
                        return this._applyModification(L, arguments);
                    },
                    brighten: function() {
                        return this._applyModification(_, arguments);
                    },
                    darken: function() {
                        return this._applyModification(C, arguments);
                    },
                    desaturate: function() {
                        return this._applyModification(E, arguments);
                    },
                    saturate: function() {
                        return this._applyModification(k, arguments);
                    },
                    greyscale: function() {
                        return this._applyModification(A, arguments);
                    },
                    spin: function() {
                        return this._applyModification(M, arguments);
                    },
                    _applyCombination: function(me, Re) {
                        return me.apply(null, [
                            this
                        ].concat([].slice.call(Re)));
                    },
                    analogous: function() {
                        return this._applyCombination(q, arguments);
                    },
                    complement: function() {
                        return this._applyCombination(g, arguments);
                    },
                    monochromatic: function() {
                        return this._applyCombination(V, arguments);
                    },
                    splitcomplement: function() {
                        return this._applyCombination(F, arguments);
                    },
                    triad: function() {
                        return this._applyCombination(P, arguments);
                    },
                    tetrad: function() {
                        return this._applyCombination(T, arguments);
                    }
                }, l.fromRatio = function(me, Re) {
                    if (typeof me == "object") {
                        var ce = {};
                        for(var Ge in me)me.hasOwnProperty(Ge) && (Ge === "a" ? ce[Ge] = me[Ge] : ce[Ge] = ge(me[Ge]));
                        me = ce;
                    }
                    return l(me, Re);
                };
                function u(me) {
                    var Re = {
                        r: 0,
                        g: 0,
                        b: 0
                    }, ce = 1, Ge = null, nt = null, ct = null, qt = !1, rt = !1;
                    return typeof me == "string" && (me = ze(me)), typeof me == "object" && (Ae(me.r) && Ae(me.g) && Ae(me.b) ? (Re = c(me.r, me.g, me.b), qt = !0, rt = String(me.r).substr(-1) === "%" ? "prgb" : "rgb") : Ae(me.h) && Ae(me.s) && Ae(me.v) ? (Ge = ge(me.s), nt = ge(me.v), Re = v(me.h, Ge, nt), qt = !0, rt = "hsv") : Ae(me.h) && Ae(me.s) && Ae(me.l) && (Ge = ge(me.s), ct = ge(me.l), Re = h(me.h, Ge, ct), qt = !0, rt = "hsl"), me.hasOwnProperty("a") && (ce = me.a)), ce = N(ce), {
                        ok: qt,
                        format: me.format || rt,
                        r: a(255, o(Re.r, 0)),
                        g: a(255, o(Re.g, 0)),
                        b: a(255, o(Re.b, 0)),
                        a: ce
                    };
                }
                function c(me, Re, ce) {
                    return {
                        r: W(me, 255) * 255,
                        g: W(Re, 255) * 255,
                        b: W(ce, 255) * 255
                    };
                }
                function f(me, Re, ce) {
                    me = W(me, 255), Re = W(Re, 255), ce = W(ce, 255);
                    var Ge = o(me, Re, ce), nt = a(me, Re, ce), ct, qt, rt = (Ge + nt) / 2;
                    if (Ge == nt) ct = qt = 0;
                    else {
                        var ot = Ge - nt;
                        switch(qt = rt > .5 ? ot / (2 - Ge - nt) : ot / (Ge + nt), Ge){
                            case me:
                                ct = (Re - ce) / ot + (Re < ce ? 6 : 0);
                                break;
                            case Re:
                                ct = (ce - me) / ot + 2;
                                break;
                            case ce:
                                ct = (me - Re) / ot + 4;
                                break;
                        }
                        ct /= 6;
                    }
                    return {
                        h: ct,
                        s: qt,
                        l: rt
                    };
                }
                function h(me, Re, ce) {
                    var Ge, nt, ct;
                    me = W(me, 360), Re = W(Re, 100), ce = W(ce, 100);
                    function qt(Rt, kt, Ct) {
                        return Ct < 0 && (Ct += 1), Ct > 1 && (Ct -= 1), Ct < 1 / 6 ? Rt + (kt - Rt) * 6 * Ct : Ct < 0.5 ? kt : Ct < 2 / 3 ? Rt + (kt - Rt) * (2 / 3 - Ct) * 6 : Rt;
                    }
                    if (Re === 0) Ge = nt = ct = ce;
                    else {
                        var rt = ce < .5 ? ce * (1 + Re) : ce + Re - ce * Re, ot = 2 * ce - rt;
                        Ge = qt(ot, rt, me + 1 / 3), nt = qt(ot, rt, me), ct = qt(ot, rt, me - 1 / 3);
                    }
                    return {
                        r: Ge * 255,
                        g: nt * 255,
                        b: ct * 255
                    };
                }
                function d(me, Re, ce) {
                    me = W(me, 255), Re = W(Re, 255), ce = W(ce, 255);
                    var Ge = o(me, Re, ce), nt = a(me, Re, ce), ct, qt, rt = Ge, ot = Ge - nt;
                    if (qt = Ge === 0 ? 0 : ot / Ge, Ge == nt) ct = 0;
                    else {
                        switch(Ge){
                            case me:
                                ct = (Re - ce) / ot + (Re < ce ? 6 : 0);
                                break;
                            case Re:
                                ct = (ce - me) / ot + 2;
                                break;
                            case ce:
                                ct = (me - Re) / ot + 4;
                                break;
                        }
                        ct /= 6;
                    }
                    return {
                        h: ct,
                        s: qt,
                        v: rt
                    };
                }
                function v(me, Re, ce) {
                    me = W(me, 360) * 6, Re = W(Re, 100), ce = W(ce, 100);
                    var Ge = e.floor(me), nt = me - Ge, ct = ce * (1 - Re), qt = ce * (1 - nt * Re), rt = ce * (1 - (1 - nt) * Re), ot = Ge % 6, Rt = [
                        ce,
                        qt,
                        ct,
                        ct,
                        rt,
                        ce
                    ][ot], kt = [
                        rt,
                        ce,
                        ce,
                        qt,
                        ct,
                        ct
                    ][ot], Ct = [
                        ct,
                        ct,
                        rt,
                        ce,
                        ce,
                        qt
                    ][ot];
                    return {
                        r: Rt * 255,
                        g: kt * 255,
                        b: Ct * 255
                    };
                }
                function x(me, Re, ce, Ge) {
                    var nt = [
                        ke(i(me).toString(16)),
                        ke(i(Re).toString(16)),
                        ke(i(ce).toString(16))
                    ];
                    return Ge && nt[0].charAt(0) == nt[0].charAt(1) && nt[1].charAt(0) == nt[1].charAt(1) && nt[2].charAt(0) == nt[2].charAt(1) ? nt[0].charAt(0) + nt[1].charAt(0) + nt[2].charAt(0) : nt.join("");
                }
                function b(me, Re, ce, Ge, nt) {
                    var ct = [
                        ke(i(me).toString(16)),
                        ke(i(Re).toString(16)),
                        ke(i(ce).toString(16)),
                        ke(ie(Ge))
                    ];
                    return nt && ct[0].charAt(0) == ct[0].charAt(1) && ct[1].charAt(0) == ct[1].charAt(1) && ct[2].charAt(0) == ct[2].charAt(1) && ct[3].charAt(0) == ct[3].charAt(1) ? ct[0].charAt(0) + ct[1].charAt(0) + ct[2].charAt(0) + ct[3].charAt(0) : ct.join("");
                }
                function p(me, Re, ce, Ge) {
                    var nt = [
                        ke(ie(Ge)),
                        ke(i(me).toString(16)),
                        ke(i(Re).toString(16)),
                        ke(i(ce).toString(16))
                    ];
                    return nt.join("");
                }
                l.equals = function(me, Re) {
                    return !me || !Re ? !1 : l(me).toRgbString() == l(Re).toRgbString();
                }, l.random = function() {
                    return l.fromRatio({
                        r: s(),
                        g: s(),
                        b: s()
                    });
                };
                function E(me, Re) {
                    Re = Re === 0 ? 0 : Re || 10;
                    var ce = l(me).toHsl();
                    return ce.s -= Re / 100, ce.s = re(ce.s), l(ce);
                }
                function k(me, Re) {
                    Re = Re === 0 ? 0 : Re || 10;
                    var ce = l(me).toHsl();
                    return ce.s += Re / 100, ce.s = re(ce.s), l(ce);
                }
                function A(me) {
                    return l(me).desaturate(100);
                }
                function L(me, Re) {
                    Re = Re === 0 ? 0 : Re || 10;
                    var ce = l(me).toHsl();
                    return ce.l += Re / 100, ce.l = re(ce.l), l(ce);
                }
                function _(me, Re) {
                    Re = Re === 0 ? 0 : Re || 10;
                    var ce = l(me).toRgb();
                    return ce.r = o(0, a(255, ce.r - i(255 * -(Re / 100)))), ce.g = o(0, a(255, ce.g - i(255 * -(Re / 100)))), ce.b = o(0, a(255, ce.b - i(255 * -(Re / 100)))), l(ce);
                }
                function C(me, Re) {
                    Re = Re === 0 ? 0 : Re || 10;
                    var ce = l(me).toHsl();
                    return ce.l -= Re / 100, ce.l = re(ce.l), l(ce);
                }
                function M(me, Re) {
                    var ce = l(me).toHsl(), Ge = (ce.h + Re) % 360;
                    return ce.h = Ge < 0 ? 360 + Ge : Ge, l(ce);
                }
                function g(me) {
                    var Re = l(me).toHsl();
                    return Re.h = (Re.h + 180) % 360, l(Re);
                }
                function P(me) {
                    var Re = l(me).toHsl(), ce = Re.h;
                    return [
                        l(me),
                        l({
                            h: (ce + 120) % 360,
                            s: Re.s,
                            l: Re.l
                        }),
                        l({
                            h: (ce + 240) % 360,
                            s: Re.s,
                            l: Re.l
                        })
                    ];
                }
                function T(me) {
                    var Re = l(me).toHsl(), ce = Re.h;
                    return [
                        l(me),
                        l({
                            h: (ce + 90) % 360,
                            s: Re.s,
                            l: Re.l
                        }),
                        l({
                            h: (ce + 180) % 360,
                            s: Re.s,
                            l: Re.l
                        }),
                        l({
                            h: (ce + 270) % 360,
                            s: Re.s,
                            l: Re.l
                        })
                    ];
                }
                function F(me) {
                    var Re = l(me).toHsl(), ce = Re.h;
                    return [
                        l(me),
                        l({
                            h: (ce + 72) % 360,
                            s: Re.s,
                            l: Re.l
                        }),
                        l({
                            h: (ce + 216) % 360,
                            s: Re.s,
                            l: Re.l
                        })
                    ];
                }
                function q(me, Re, ce) {
                    Re = Re || 6, ce = ce || 30;
                    var Ge = l(me).toHsl(), nt = 360 / ce, ct = [
                        l(me)
                    ];
                    for(Ge.h = (Ge.h - (nt * Re >> 1) + 720) % 360; --Re;)Ge.h = (Ge.h + nt) % 360, ct.push(l(Ge));
                    return ct;
                }
                function V(me, Re) {
                    Re = Re || 6;
                    for(var ce = l(me).toHsv(), Ge = ce.h, nt = ce.s, ct = ce.v, qt = [], rt = 1 / Re; Re--;)qt.push(l({
                        h: Ge,
                        s: nt,
                        v: ct
                    })), ct = (ct + rt) % 1;
                    return qt;
                }
                l.mix = function(me, Re, ce) {
                    ce = ce === 0 ? 0 : ce || 50;
                    var Ge = l(me).toRgb(), nt = l(Re).toRgb(), ct = ce / 100, qt = {
                        r: (nt.r - Ge.r) * ct + Ge.r,
                        g: (nt.g - Ge.g) * ct + Ge.g,
                        b: (nt.b - Ge.b) * ct + Ge.b,
                        a: (nt.a - Ge.a) * ct + Ge.a
                    };
                    return l(qt);
                }, l.readability = function(me, Re) {
                    var ce = l(me), Ge = l(Re);
                    return (e.max(ce.getLuminance(), Ge.getLuminance()) + .05) / (e.min(ce.getLuminance(), Ge.getLuminance()) + .05);
                }, l.isReadable = function(me, Re, ce) {
                    var Ge = l.readability(me, Re), nt, ct;
                    switch(ct = !1, nt = Ce(ce), nt.level + nt.size){
                        case "AAsmall":
                        case "AAAlarge":
                            ct = Ge >= 4.5;
                            break;
                        case "AAlarge":
                            ct = Ge >= 3;
                            break;
                        case "AAAsmall":
                            ct = Ge >= 7;
                            break;
                    }
                    return ct;
                }, l.mostReadable = function(me, Re, ce) {
                    var Ge = null, nt = 0, ct, qt, rt, ot;
                    ce = ce || {}, qt = ce.includeFallbackColors, rt = ce.level, ot = ce.size;
                    for(var Rt = 0; Rt < Re.length; Rt++)ct = l.readability(me, Re[Rt]), ct > nt && (nt = ct, Ge = l(Re[Rt]));
                    return l.isReadable(me, Ge, {
                        level: rt,
                        size: ot
                    }) || !qt ? Ge : (ce.includeFallbackColors = !1, l.mostReadable(me, [
                        "#fff",
                        "#000"
                    ], ce));
                };
                var H = l.names = {
                    aliceblue: "f0f8ff",
                    antiquewhite: "faebd7",
                    aqua: "0ff",
                    aquamarine: "7fffd4",
                    azure: "f0ffff",
                    beige: "f5f5dc",
                    bisque: "ffe4c4",
                    black: "000",
                    blanchedalmond: "ffebcd",
                    blue: "00f",
                    blueviolet: "8a2be2",
                    brown: "a52a2a",
                    burlywood: "deb887",
                    burntsienna: "ea7e5d",
                    cadetblue: "5f9ea0",
                    chartreuse: "7fff00",
                    chocolate: "d2691e",
                    coral: "ff7f50",
                    cornflowerblue: "6495ed",
                    cornsilk: "fff8dc",
                    crimson: "dc143c",
                    cyan: "0ff",
                    darkblue: "00008b",
                    darkcyan: "008b8b",
                    darkgoldenrod: "b8860b",
                    darkgray: "a9a9a9",
                    darkgreen: "006400",
                    darkgrey: "a9a9a9",
                    darkkhaki: "bdb76b",
                    darkmagenta: "8b008b",
                    darkolivegreen: "556b2f",
                    darkorange: "ff8c00",
                    darkorchid: "9932cc",
                    darkred: "8b0000",
                    darksalmon: "e9967a",
                    darkseagreen: "8fbc8f",
                    darkslateblue: "483d8b",
                    darkslategray: "2f4f4f",
                    darkslategrey: "2f4f4f",
                    darkturquoise: "00ced1",
                    darkviolet: "9400d3",
                    deeppink: "ff1493",
                    deepskyblue: "00bfff",
                    dimgray: "696969",
                    dimgrey: "696969",
                    dodgerblue: "1e90ff",
                    firebrick: "b22222",
                    floralwhite: "fffaf0",
                    forestgreen: "228b22",
                    fuchsia: "f0f",
                    gainsboro: "dcdcdc",
                    ghostwhite: "f8f8ff",
                    gold: "ffd700",
                    goldenrod: "daa520",
                    gray: "808080",
                    green: "008000",
                    greenyellow: "adff2f",
                    grey: "808080",
                    honeydew: "f0fff0",
                    hotpink: "ff69b4",
                    indianred: "cd5c5c",
                    indigo: "4b0082",
                    ivory: "fffff0",
                    khaki: "f0e68c",
                    lavender: "e6e6fa",
                    lavenderblush: "fff0f5",
                    lawngreen: "7cfc00",
                    lemonchiffon: "fffacd",
                    lightblue: "add8e6",
                    lightcoral: "f08080",
                    lightcyan: "e0ffff",
                    lightgoldenrodyellow: "fafad2",
                    lightgray: "d3d3d3",
                    lightgreen: "90ee90",
                    lightgrey: "d3d3d3",
                    lightpink: "ffb6c1",
                    lightsalmon: "ffa07a",
                    lightseagreen: "20b2aa",
                    lightskyblue: "87cefa",
                    lightslategray: "789",
                    lightslategrey: "789",
                    lightsteelblue: "b0c4de",
                    lightyellow: "ffffe0",
                    lime: "0f0",
                    limegreen: "32cd32",
                    linen: "faf0e6",
                    magenta: "f0f",
                    maroon: "800000",
                    mediumaquamarine: "66cdaa",
                    mediumblue: "0000cd",
                    mediumorchid: "ba55d3",
                    mediumpurple: "9370db",
                    mediumseagreen: "3cb371",
                    mediumslateblue: "7b68ee",
                    mediumspringgreen: "00fa9a",
                    mediumturquoise: "48d1cc",
                    mediumvioletred: "c71585",
                    midnightblue: "191970",
                    mintcream: "f5fffa",
                    mistyrose: "ffe4e1",
                    moccasin: "ffe4b5",
                    navajowhite: "ffdead",
                    navy: "000080",
                    oldlace: "fdf5e6",
                    olive: "808000",
                    olivedrab: "6b8e23",
                    orange: "ffa500",
                    orangered: "ff4500",
                    orchid: "da70d6",
                    palegoldenrod: "eee8aa",
                    palegreen: "98fb98",
                    paleturquoise: "afeeee",
                    palevioletred: "db7093",
                    papayawhip: "ffefd5",
                    peachpuff: "ffdab9",
                    peru: "cd853f",
                    pink: "ffc0cb",
                    plum: "dda0dd",
                    powderblue: "b0e0e6",
                    purple: "800080",
                    rebeccapurple: "663399",
                    red: "f00",
                    rosybrown: "bc8f8f",
                    royalblue: "4169e1",
                    saddlebrown: "8b4513",
                    salmon: "fa8072",
                    sandybrown: "f4a460",
                    seagreen: "2e8b57",
                    seashell: "fff5ee",
                    sienna: "a0522d",
                    silver: "c0c0c0",
                    skyblue: "87ceeb",
                    slateblue: "6a5acd",
                    slategray: "708090",
                    slategrey: "708090",
                    snow: "fffafa",
                    springgreen: "00ff7f",
                    steelblue: "4682b4",
                    tan: "d2b48c",
                    teal: "008080",
                    thistle: "d8bfd8",
                    tomato: "ff6347",
                    turquoise: "40e0d0",
                    violet: "ee82ee",
                    wheat: "f5deb3",
                    white: "fff",
                    whitesmoke: "f5f5f5",
                    yellow: "ff0",
                    yellowgreen: "9acd32"
                }, X = l.hexNames = G(H);
                function G(me) {
                    var Re = {};
                    for(var ce in me)me.hasOwnProperty(ce) && (Re[me[ce]] = ce);
                    return Re;
                }
                function N(me) {
                    return me = parseFloat(me), (isNaN(me) || me < 0 || me > 1) && (me = 1), me;
                }
                function W(me, Re) {
                    _e(me) && (me = "100%");
                    var ce = Me(me);
                    return me = a(Re, o(0, parseFloat(me))), ce && (me = parseInt(me * Re, 10) / 100), e.abs(me - Re) < 1e-6 ? 1 : me % Re / parseFloat(Re);
                }
                function re(me) {
                    return a(1, o(0, me));
                }
                function ae(me) {
                    return parseInt(me, 16);
                }
                function _e(me) {
                    return typeof me == "string" && me.indexOf(".") != -1 && parseFloat(me) === 1;
                }
                function Me(me) {
                    return typeof me == "string" && me.indexOf("%") != -1;
                }
                function ke(me) {
                    return me.length == 1 ? "0" + me : "" + me;
                }
                function ge(me) {
                    return me <= 1 && (me = me * 100 + "%"), me;
                }
                function ie(me) {
                    return e.round(parseFloat(me) * 255).toString(16);
                }
                function Te(me) {
                    return ae(me) / 255;
                }
                var Ee = function() {
                    var me = "[-\\+]?\\d+%?", Re = "[-\\+]?\\d*\\.\\d+%?", ce = "(?:" + Re + ")|(?:" + me + ")", Ge = "[\\s|\\(]+(" + ce + ")[,|\\s]+(" + ce + ")[,|\\s]+(" + ce + ")\\s*\\)?", nt = "[\\s|\\(]+(" + ce + ")[,|\\s]+(" + ce + ")[,|\\s]+(" + ce + ")[,|\\s]+(" + ce + ")\\s*\\)?";
                    return {
                        CSS_UNIT: new RegExp(ce),
                        rgb: new RegExp("rgb" + Ge),
                        rgba: new RegExp("rgba" + nt),
                        hsl: new RegExp("hsl" + Ge),
                        hsla: new RegExp("hsla" + nt),
                        hsv: new RegExp("hsv" + Ge),
                        hsva: new RegExp("hsva" + nt),
                        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
                    };
                }();
                function Ae(me) {
                    return !!Ee.CSS_UNIT.exec(me);
                }
                function ze(me) {
                    me = me.replace(t, "").replace(r, "").toLowerCase();
                    var Re = !1;
                    if (H[me]) me = H[me], Re = !0;
                    else if (me == "transparent") return {
                        r: 0,
                        g: 0,
                        b: 0,
                        a: 0,
                        format: "name"
                    };
                    var ce;
                    return (ce = Ee.rgb.exec(me)) ? {
                        r: ce[1],
                        g: ce[2],
                        b: ce[3]
                    } : (ce = Ee.rgba.exec(me)) ? {
                        r: ce[1],
                        g: ce[2],
                        b: ce[3],
                        a: ce[4]
                    } : (ce = Ee.hsl.exec(me)) ? {
                        h: ce[1],
                        s: ce[2],
                        l: ce[3]
                    } : (ce = Ee.hsla.exec(me)) ? {
                        h: ce[1],
                        s: ce[2],
                        l: ce[3],
                        a: ce[4]
                    } : (ce = Ee.hsv.exec(me)) ? {
                        h: ce[1],
                        s: ce[2],
                        v: ce[3]
                    } : (ce = Ee.hsva.exec(me)) ? {
                        h: ce[1],
                        s: ce[2],
                        v: ce[3],
                        a: ce[4]
                    } : (ce = Ee.hex8.exec(me)) ? {
                        r: ae(ce[1]),
                        g: ae(ce[2]),
                        b: ae(ce[3]),
                        a: Te(ce[4]),
                        format: Re ? "name" : "hex8"
                    } : (ce = Ee.hex6.exec(me)) ? {
                        r: ae(ce[1]),
                        g: ae(ce[2]),
                        b: ae(ce[3]),
                        format: Re ? "name" : "hex"
                    } : (ce = Ee.hex4.exec(me)) ? {
                        r: ae(ce[1] + "" + ce[1]),
                        g: ae(ce[2] + "" + ce[2]),
                        b: ae(ce[3] + "" + ce[3]),
                        a: Te(ce[4] + "" + ce[4]),
                        format: Re ? "name" : "hex8"
                    } : (ce = Ee.hex3.exec(me)) ? {
                        r: ae(ce[1] + "" + ce[1]),
                        g: ae(ce[2] + "" + ce[2]),
                        b: ae(ce[3] + "" + ce[3]),
                        format: Re ? "name" : "hex"
                    } : !1;
                }
                function Ce(me) {
                    var Re, ce;
                    return me = me || {
                        level: "AA",
                        size: "small"
                    }, Re = (me.level || "AA").toUpperCase(), ce = (me.size || "small").toLowerCase(), Re !== "AA" && Re !== "AAA" && (Re = "AA"), ce !== "small" && ce !== "large" && (ce = "small"), {
                        level: Re,
                        size: ce
                    };
                }
                typeof c6 != "undefined" && c6.exports ? c6.exports = l : window.tinycolor = l;
            })(Math);
        });
        var no = ye((PS)=>{
            "use strict";
            var Pee = gy(), CS = Array.isArray;
            function pet(e, t) {
                var r, n;
                for(r = 0; r < e.length; r++){
                    if (n = e[r], n !== null && typeof n == "object") return !1;
                    n !== void 0 && (t[r] = n);
                }
                return !0;
            }
            PS.extendFlat = function() {
                return LS(arguments, !1, !1, !1);
            };
            PS.extendDeep = function() {
                return LS(arguments, !0, !1, !1);
            };
            PS.extendDeepAll = function() {
                return LS(arguments, !0, !0, !1);
            };
            PS.extendDeepNoArrays = function() {
                return LS(arguments, !0, !1, !0);
            };
            function LS(e, t, r, n) {
                var i = e[0], a = e.length, o, s, l, u, c, f, h;
                if (a === 2 && CS(i) && CS(e[1]) && i.length === 0) {
                    if (h = pet(e[1], i), h) return i;
                    i.splice(0, i.length);
                }
                for(var d = 1; d < a; d++){
                    o = e[d];
                    for(s in o)l = i[s], u = o[s], n && CS(u) ? i[s] = u : t && u && (Pee(u) || (c = CS(u))) ? (c ? (c = !1, f = l && CS(l) ? l : []) : f = l && Pee(l) ? l : {}, i[s] = LS([
                        f,
                        u
                    ], t, r, n)) : (typeof u != "undefined" || r) && (i[s] = u);
                }
                return i;
            }
        });
        var Su = ye((JQt, Iee)=>{
            "use strict";
            Iee.exports = function(e) {
                var t = e.variantValues, r = e.editType, n = e.colorEditType;
                n === void 0 && (n = r);
                var i = {
                    editType: r,
                    valType: "integer",
                    min: 1,
                    max: 1e3,
                    extras: [
                        "normal",
                        "bold"
                    ],
                    dflt: "normal"
                };
                e.noNumericWeightValues && (i.valType = "enumerated", i.values = i.extras, i.extras = void 0, i.min = void 0, i.max = void 0);
                var a = {
                    family: {
                        valType: "string",
                        noBlank: !0,
                        strict: !0,
                        editType: r
                    },
                    size: {
                        valType: "number",
                        min: 1,
                        editType: r
                    },
                    color: {
                        valType: "color",
                        editType: n
                    },
                    weight: i,
                    style: {
                        editType: r,
                        valType: "enumerated",
                        values: [
                            "normal",
                            "italic"
                        ],
                        dflt: "normal"
                    },
                    variant: e.noFontVariant ? void 0 : {
                        editType: r,
                        valType: "enumerated",
                        values: t || [
                            "normal",
                            "small-caps",
                            "all-small-caps",
                            "all-petite-caps",
                            "petite-caps",
                            "unicase"
                        ],
                        dflt: "normal"
                    },
                    textcase: e.noFontTextcase ? void 0 : {
                        editType: r,
                        valType: "enumerated",
                        values: [
                            "normal",
                            "word caps",
                            "upper",
                            "lower"
                        ],
                        dflt: "normal"
                    },
                    lineposition: e.noFontLineposition ? void 0 : {
                        editType: r,
                        valType: "flaglist",
                        flags: [
                            "under",
                            "over",
                            "through"
                        ],
                        extras: [
                            "none"
                        ],
                        dflt: "none"
                    },
                    shadow: e.noFontShadow ? void 0 : {
                        editType: r,
                        valType: "string",
                        dflt: e.autoShadowDflt ? "auto" : "none"
                    },
                    editType: r
                };
                return e.autoSize && (a.size.dflt = "auto"), e.autoColor && (a.color.dflt = "auto"), e.arrayOk && (a.family.arrayOk = !0, a.weight.arrayOk = !0, a.style.arrayOk = !0, e.noFontVariant || (a.variant.arrayOk = !0), e.noFontTextcase || (a.textcase.arrayOk = !0), e.noFontLineposition || (a.lineposition.arrayOk = !0), e.noFontShadow || (a.shadow.arrayOk = !0), a.size.arrayOk = !0, a.color.arrayOk = !0), a;
            };
        });
        var IS = ye(($Qt, Ree)=>{
            "use strict";
            Ree.exports = {
                YANGLE: 60,
                HOVERARROWSIZE: 6,
                HOVERTEXTPAD: 3,
                HOVERFONTSIZE: 13,
                HOVERFONT: "Arial, sans-serif",
                HOVERMINTIME: 50,
                HOVERID: "-hover"
            };
        });
        var N1 = ye((QQt, Fee)=>{
            "use strict";
            var Dee = IS(), zee = Su(), xq = zee({
                editType: "none"
            });
            xq.family.dflt = Dee.HOVERFONT;
            xq.size.dflt = Dee.HOVERFONTSIZE;
            Fee.exports = {
                clickmode: {
                    valType: "flaglist",
                    flags: [
                        "event",
                        "select"
                    ],
                    dflt: "event",
                    editType: "plot",
                    extras: [
                        "none"
                    ]
                },
                dragmode: {
                    valType: "enumerated",
                    values: [
                        "zoom",
                        "pan",
                        "select",
                        "lasso",
                        "drawclosedpath",
                        "drawopenpath",
                        "drawline",
                        "drawrect",
                        "drawcircle",
                        "orbit",
                        "turntable",
                        !1
                    ],
                    dflt: "zoom",
                    editType: "modebar"
                },
                hovermode: {
                    valType: "enumerated",
                    values: [
                        "x",
                        "y",
                        "closest",
                        !1,
                        "x unified",
                        "y unified"
                    ],
                    dflt: "closest",
                    editType: "modebar"
                },
                hoversubplots: {
                    valType: "enumerated",
                    values: [
                        "single",
                        "overlaying",
                        "axis"
                    ],
                    dflt: "overlaying",
                    editType: "none"
                },
                hoverdistance: {
                    valType: "integer",
                    min: -1,
                    dflt: 20,
                    editType: "none"
                },
                spikedistance: {
                    valType: "integer",
                    min: -1,
                    dflt: -1,
                    editType: "none"
                },
                hoverlabel: {
                    bgcolor: {
                        valType: "color",
                        editType: "none"
                    },
                    bordercolor: {
                        valType: "color",
                        editType: "none"
                    },
                    font: xq,
                    grouptitlefont: zee({
                        editType: "none"
                    }),
                    align: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "right",
                            "auto"
                        ],
                        dflt: "auto",
                        editType: "none"
                    },
                    namelength: {
                        valType: "integer",
                        min: -1,
                        dflt: 15,
                        editType: "none"
                    },
                    editType: "none"
                },
                selectdirection: {
                    valType: "enumerated",
                    values: [
                        "h",
                        "v",
                        "d",
                        "any"
                    ],
                    dflt: "any",
                    editType: "none"
                }
            };
        });
        var i3 = ye((eer, qee)=>{
            "use strict";
            var get = Su(), f6 = N1().hoverlabel, h6 = no().extendFlat;
            qee.exports = {
                hoverlabel: {
                    bgcolor: h6({}, f6.bgcolor, {
                        arrayOk: !0
                    }),
                    bordercolor: h6({}, f6.bordercolor, {
                        arrayOk: !0
                    }),
                    font: get({
                        arrayOk: !0,
                        editType: "none"
                    }),
                    align: h6({}, f6.align, {
                        arrayOk: !0
                    }),
                    namelength: h6({}, f6.namelength, {
                        arrayOk: !0
                    }),
                    editType: "none"
                }
            };
        });
        var vl = ye((ter, Oee)=>{
            "use strict";
            var met = Su(), yet = i3();
            Oee.exports = {
                type: {
                    valType: "enumerated",
                    values: [],
                    dflt: "scatter",
                    editType: "calc+clearAxisTypes",
                    _noTemplating: !0
                },
                visible: {
                    valType: "enumerated",
                    values: [
                        !0,
                        !1,
                        "legendonly"
                    ],
                    dflt: !0,
                    editType: "calc"
                },
                showlegend: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "style"
                },
                legend: {
                    valType: "subplotid",
                    dflt: "legend",
                    editType: "style"
                },
                legendgroup: {
                    valType: "string",
                    dflt: "",
                    editType: "style"
                },
                legendgrouptitle: {
                    text: {
                        valType: "string",
                        dflt: "",
                        editType: "style"
                    },
                    font: met({
                        editType: "style"
                    }),
                    editType: "style"
                },
                legendrank: {
                    valType: "number",
                    dflt: 1e3,
                    editType: "style"
                },
                legendwidth: {
                    valType: "number",
                    min: 0,
                    editType: "style"
                },
                opacity: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 1,
                    editType: "style"
                },
                name: {
                    valType: "string",
                    editType: "style"
                },
                uid: {
                    valType: "string",
                    editType: "plot",
                    anim: !0
                },
                ids: {
                    valType: "data_array",
                    editType: "calc",
                    anim: !0
                },
                customdata: {
                    valType: "data_array",
                    editType: "calc"
                },
                meta: {
                    valType: "any",
                    arrayOk: !0,
                    editType: "plot"
                },
                selectedpoints: {
                    valType: "any",
                    editType: "calc"
                },
                hoverinfo: {
                    valType: "flaglist",
                    flags: [
                        "x",
                        "y",
                        "z",
                        "text",
                        "name"
                    ],
                    extras: [
                        "all",
                        "none",
                        "skip"
                    ],
                    arrayOk: !0,
                    dflt: "all",
                    editType: "none"
                },
                hoverlabel: yet.hoverlabel,
                stream: {
                    token: {
                        valType: "string",
                        noBlank: !0,
                        strict: !0,
                        editType: "calc"
                    },
                    maxpoints: {
                        valType: "number",
                        min: 0,
                        max: 1e4,
                        dflt: 500,
                        editType: "calc"
                    },
                    editType: "calc"
                },
                uirevision: {
                    valType: "any",
                    editType: "none"
                }
            };
        });
        var sb = ye((rer, Uee)=>{
            "use strict";
            var _et = id(), d6 = {
                Greys: [
                    [
                        0,
                        "rgb(0,0,0)"
                    ],
                    [
                        1,
                        "rgb(255,255,255)"
                    ]
                ],
                YlGnBu: [
                    [
                        0,
                        "rgb(8,29,88)"
                    ],
                    [
                        .125,
                        "rgb(37,52,148)"
                    ],
                    [
                        .25,
                        "rgb(34,94,168)"
                    ],
                    [
                        .375,
                        "rgb(29,145,192)"
                    ],
                    [
                        .5,
                        "rgb(65,182,196)"
                    ],
                    [
                        .625,
                        "rgb(127,205,187)"
                    ],
                    [
                        .75,
                        "rgb(199,233,180)"
                    ],
                    [
                        .875,
                        "rgb(237,248,217)"
                    ],
                    [
                        1,
                        "rgb(255,255,217)"
                    ]
                ],
                Greens: [
                    [
                        0,
                        "rgb(0,68,27)"
                    ],
                    [
                        .125,
                        "rgb(0,109,44)"
                    ],
                    [
                        .25,
                        "rgb(35,139,69)"
                    ],
                    [
                        .375,
                        "rgb(65,171,93)"
                    ],
                    [
                        .5,
                        "rgb(116,196,118)"
                    ],
                    [
                        .625,
                        "rgb(161,217,155)"
                    ],
                    [
                        .75,
                        "rgb(199,233,192)"
                    ],
                    [
                        .875,
                        "rgb(229,245,224)"
                    ],
                    [
                        1,
                        "rgb(247,252,245)"
                    ]
                ],
                YlOrRd: [
                    [
                        0,
                        "rgb(128,0,38)"
                    ],
                    [
                        .125,
                        "rgb(189,0,38)"
                    ],
                    [
                        .25,
                        "rgb(227,26,28)"
                    ],
                    [
                        .375,
                        "rgb(252,78,42)"
                    ],
                    [
                        .5,
                        "rgb(253,141,60)"
                    ],
                    [
                        .625,
                        "rgb(254,178,76)"
                    ],
                    [
                        .75,
                        "rgb(254,217,118)"
                    ],
                    [
                        .875,
                        "rgb(255,237,160)"
                    ],
                    [
                        1,
                        "rgb(255,255,204)"
                    ]
                ],
                Bluered: [
                    [
                        0,
                        "rgb(0,0,255)"
                    ],
                    [
                        1,
                        "rgb(255,0,0)"
                    ]
                ],
                RdBu: [
                    [
                        0,
                        "rgb(5,10,172)"
                    ],
                    [
                        .35,
                        "rgb(106,137,247)"
                    ],
                    [
                        .5,
                        "rgb(190,190,190)"
                    ],
                    [
                        .6,
                        "rgb(220,170,132)"
                    ],
                    [
                        .7,
                        "rgb(230,145,90)"
                    ],
                    [
                        1,
                        "rgb(178,10,28)"
                    ]
                ],
                Reds: [
                    [
                        0,
                        "rgb(220,220,220)"
                    ],
                    [
                        .2,
                        "rgb(245,195,157)"
                    ],
                    [
                        .4,
                        "rgb(245,160,105)"
                    ],
                    [
                        1,
                        "rgb(178,10,28)"
                    ]
                ],
                Blues: [
                    [
                        0,
                        "rgb(5,10,172)"
                    ],
                    [
                        .35,
                        "rgb(40,60,190)"
                    ],
                    [
                        .5,
                        "rgb(70,100,245)"
                    ],
                    [
                        .6,
                        "rgb(90,120,245)"
                    ],
                    [
                        .7,
                        "rgb(106,137,247)"
                    ],
                    [
                        1,
                        "rgb(220,220,220)"
                    ]
                ],
                Picnic: [
                    [
                        0,
                        "rgb(0,0,255)"
                    ],
                    [
                        .1,
                        "rgb(51,153,255)"
                    ],
                    [
                        .2,
                        "rgb(102,204,255)"
                    ],
                    [
                        .3,
                        "rgb(153,204,255)"
                    ],
                    [
                        .4,
                        "rgb(204,204,255)"
                    ],
                    [
                        .5,
                        "rgb(255,255,255)"
                    ],
                    [
                        .6,
                        "rgb(255,204,255)"
                    ],
                    [
                        .7,
                        "rgb(255,153,255)"
                    ],
                    [
                        .8,
                        "rgb(255,102,204)"
                    ],
                    [
                        .9,
                        "rgb(255,102,102)"
                    ],
                    [
                        1,
                        "rgb(255,0,0)"
                    ]
                ],
                Rainbow: [
                    [
                        0,
                        "rgb(150,0,90)"
                    ],
                    [
                        .125,
                        "rgb(0,0,200)"
                    ],
                    [
                        .25,
                        "rgb(0,25,255)"
                    ],
                    [
                        .375,
                        "rgb(0,152,255)"
                    ],
                    [
                        .5,
                        "rgb(44,255,150)"
                    ],
                    [
                        .625,
                        "rgb(151,255,0)"
                    ],
                    [
                        .75,
                        "rgb(255,234,0)"
                    ],
                    [
                        .875,
                        "rgb(255,111,0)"
                    ],
                    [
                        1,
                        "rgb(255,0,0)"
                    ]
                ],
                Portland: [
                    [
                        0,
                        "rgb(12,51,131)"
                    ],
                    [
                        .25,
                        "rgb(10,136,186)"
                    ],
                    [
                        .5,
                        "rgb(242,211,56)"
                    ],
                    [
                        .75,
                        "rgb(242,143,56)"
                    ],
                    [
                        1,
                        "rgb(217,30,30)"
                    ]
                ],
                Jet: [
                    [
                        0,
                        "rgb(0,0,131)"
                    ],
                    [
                        .125,
                        "rgb(0,60,170)"
                    ],
                    [
                        .375,
                        "rgb(5,255,255)"
                    ],
                    [
                        .625,
                        "rgb(255,255,0)"
                    ],
                    [
                        .875,
                        "rgb(250,0,0)"
                    ],
                    [
                        1,
                        "rgb(128,0,0)"
                    ]
                ],
                Hot: [
                    [
                        0,
                        "rgb(0,0,0)"
                    ],
                    [
                        .3,
                        "rgb(230,0,0)"
                    ],
                    [
                        .6,
                        "rgb(255,210,0)"
                    ],
                    [
                        1,
                        "rgb(255,255,255)"
                    ]
                ],
                Blackbody: [
                    [
                        0,
                        "rgb(0,0,0)"
                    ],
                    [
                        .2,
                        "rgb(230,0,0)"
                    ],
                    [
                        .4,
                        "rgb(230,210,0)"
                    ],
                    [
                        .7,
                        "rgb(255,255,255)"
                    ],
                    [
                        1,
                        "rgb(160,200,255)"
                    ]
                ],
                Earth: [
                    [
                        0,
                        "rgb(0,0,130)"
                    ],
                    [
                        .1,
                        "rgb(0,180,180)"
                    ],
                    [
                        .2,
                        "rgb(40,210,40)"
                    ],
                    [
                        .4,
                        "rgb(230,230,50)"
                    ],
                    [
                        .6,
                        "rgb(120,70,20)"
                    ],
                    [
                        1,
                        "rgb(255,255,255)"
                    ]
                ],
                Electric: [
                    [
                        0,
                        "rgb(0,0,0)"
                    ],
                    [
                        .15,
                        "rgb(30,0,100)"
                    ],
                    [
                        .4,
                        "rgb(120,0,100)"
                    ],
                    [
                        .6,
                        "rgb(160,90,0)"
                    ],
                    [
                        .8,
                        "rgb(230,200,0)"
                    ],
                    [
                        1,
                        "rgb(255,250,220)"
                    ]
                ],
                Viridis: [
                    [
                        0,
                        "#440154"
                    ],
                    [
                        .06274509803921569,
                        "#48186a"
                    ],
                    [
                        .12549019607843137,
                        "#472d7b"
                    ],
                    [
                        .18823529411764706,
                        "#424086"
                    ],
                    [
                        .25098039215686274,
                        "#3b528b"
                    ],
                    [
                        .3137254901960784,
                        "#33638d"
                    ],
                    [
                        .3764705882352941,
                        "#2c728e"
                    ],
                    [
                        .4392156862745098,
                        "#26828e"
                    ],
                    [
                        .5019607843137255,
                        "#21918c"
                    ],
                    [
                        .5647058823529412,
                        "#1fa088"
                    ],
                    [
                        .6274509803921569,
                        "#28ae80"
                    ],
                    [
                        .6901960784313725,
                        "#3fbc73"
                    ],
                    [
                        .7529411764705882,
                        "#5ec962"
                    ],
                    [
                        .8156862745098039,
                        "#84d44b"
                    ],
                    [
                        .8784313725490196,
                        "#addc30"
                    ],
                    [
                        .9411764705882353,
                        "#d8e219"
                    ],
                    [
                        1,
                        "#fde725"
                    ]
                ],
                Cividis: [
                    [
                        0,
                        "rgb(0,32,76)"
                    ],
                    [
                        .058824,
                        "rgb(0,42,102)"
                    ],
                    [
                        .117647,
                        "rgb(0,52,110)"
                    ],
                    [
                        .176471,
                        "rgb(39,63,108)"
                    ],
                    [
                        .235294,
                        "rgb(60,74,107)"
                    ],
                    [
                        .294118,
                        "rgb(76,85,107)"
                    ],
                    [
                        .352941,
                        "rgb(91,95,109)"
                    ],
                    [
                        .411765,
                        "rgb(104,106,112)"
                    ],
                    [
                        .470588,
                        "rgb(117,117,117)"
                    ],
                    [
                        .529412,
                        "rgb(131,129,120)"
                    ],
                    [
                        .588235,
                        "rgb(146,140,120)"
                    ],
                    [
                        .647059,
                        "rgb(161,152,118)"
                    ],
                    [
                        .705882,
                        "rgb(176,165,114)"
                    ],
                    [
                        .764706,
                        "rgb(192,177,109)"
                    ],
                    [
                        .823529,
                        "rgb(209,191,102)"
                    ],
                    [
                        .882353,
                        "rgb(225,204,92)"
                    ],
                    [
                        .941176,
                        "rgb(243,219,79)"
                    ],
                    [
                        1,
                        "rgb(255,233,69)"
                    ]
                ]
            }, Bee = d6.RdBu;
            function xet(e, t) {
                if (t || (t = Bee), !e) return t;
                function r() {
                    try {
                        e = d6[e] || JSON.parse(e);
                    } catch (n) {
                        e = t;
                    }
                }
                return typeof e == "string" && (r(), typeof e == "string" && r()), Nee(e) ? e : t;
            }
            function Nee(e) {
                var t = 0;
                if (!Array.isArray(e) || e.length < 2 || !e[0] || !e[e.length - 1] || +e[0][0] != 0 || +e[e.length - 1][0] != 1) return !1;
                for(var r = 0; r < e.length; r++){
                    var n = e[r];
                    if (n.length !== 2 || +n[0] < t || !_et(n[1]).isValid()) return !1;
                    t = +n[0];
                }
                return !0;
            }
            function bet(e) {
                return d6[e] !== void 0 ? !0 : Nee(e);
            }
            Uee.exports = {
                scales: d6,
                defaultScale: Bee,
                get: xet,
                isValid: bet
            };
        });
        var dh = ye((lb)=>{
            "use strict";
            lb.defaults = [
                "#1f77b4",
                "#ff7f0e",
                "#2ca02c",
                "#d62728",
                "#9467bd",
                "#8c564b",
                "#e377c2",
                "#7f7f7f",
                "#bcbd22",
                "#17becf"
            ];
            lb.defaultLine = "#444";
            lb.lightLine = "#eee";
            lb.background = "#fff";
            lb.borderLine = "#BEC8D9";
            lb.lightFraction = 1000 / 11;
        });
        var va = ye((ner, Vee)=>{
            "use strict";
            var xp = id(), wet = uo(), Tet = vv().isTypedArray, nd = Vee.exports = {}, v6 = dh();
            nd.defaults = v6.defaults;
            var Aet = nd.defaultLine = v6.defaultLine;
            nd.lightLine = v6.lightLine;
            var wq = nd.background = v6.background;
            nd.tinyRGB = function(e) {
                var t = e.toRgb();
                return "rgb(" + Math.round(t.r) + ", " + Math.round(t.g) + ", " + Math.round(t.b) + ")";
            };
            nd.rgb = function(e) {
                return nd.tinyRGB(xp(e));
            };
            nd.opacity = function(e) {
                return e ? xp(e).getAlpha() : 0;
            };
            nd.addOpacity = function(e, t) {
                var r = xp(e).toRgb();
                return "rgba(" + Math.round(r.r) + ", " + Math.round(r.g) + ", " + Math.round(r.b) + ", " + t + ")";
            };
            nd.combine = function(e, t) {
                var r = xp(e).toRgb();
                if (r.a === 1) return xp(e).toRgbString();
                var n = xp(t || wq).toRgb(), i = n.a === 1 ? n : {
                    r: 255 * (1 - n.a) + n.r * n.a,
                    g: 255 * (1 - n.a) + n.g * n.a,
                    b: 255 * (1 - n.a) + n.b * n.a
                }, a = {
                    r: i.r * (1 - r.a) + r.r * r.a,
                    g: i.g * (1 - r.a) + r.g * r.a,
                    b: i.b * (1 - r.a) + r.b * r.a
                };
                return xp(a).toRgbString();
            };
            nd.interpolate = function(e, t, r) {
                var n = xp(e).toRgb(), i = xp(t).toRgb(), a = {
                    r: r * n.r + (1 - r) * i.r,
                    g: r * n.g + (1 - r) * i.g,
                    b: r * n.b + (1 - r) * i.b
                };
                return xp(a).toRgbString();
            };
            nd.contrast = function(e, t, r) {
                var n = xp(e);
                n.getAlpha() !== 1 && (n = xp(nd.combine(e, wq)));
                var i = n.isDark() ? t ? n.lighten(t) : wq : r ? n.darken(r) : Aet;
                return i.toString();
            };
            nd.stroke = function(e, t) {
                var r = xp(t);
                e.style({
                    stroke: nd.tinyRGB(r),
                    "stroke-opacity": r.getAlpha()
                });
            };
            nd.fill = function(e, t) {
                var r = xp(t);
                e.style({
                    fill: nd.tinyRGB(r),
                    "fill-opacity": r.getAlpha()
                });
            };
            nd.clean = function(e) {
                if (!(!e || typeof e != "object")) {
                    var t = Object.keys(e), r, n, i, a;
                    for(r = 0; r < t.length; r++)if (i = t[r], a = e[i], i.substr(i.length - 5) === "color") {
                        if (Array.isArray(a)) for(n = 0; n < a.length; n++)a[n] = bq(a[n]);
                        else e[i] = bq(a);
                    } else if (i.substr(i.length - 10) === "colorscale" && Array.isArray(a)) for(n = 0; n < a.length; n++)Array.isArray(a[n]) && (a[n][1] = bq(a[n][1]));
                    else if (Array.isArray(a)) {
                        var o = a[0];
                        if (!Array.isArray(o) && o && typeof o == "object") for(n = 0; n < a.length; n++)nd.clean(a[n]);
                    } else a && typeof a == "object" && !Tet(a) && nd.clean(a);
                }
            };
            function bq(e) {
                if (wet(e) || typeof e != "string") return e;
                var t = e.trim();
                if (t.substr(0, 3) !== "rgb") return e;
                var r = t.match(/^rgba?\s*\(([^()]*)\)$/);
                if (!r) return e;
                var n = r[1].trim().split(/\s*[\s,]\s*/), i = t.charAt(3) === "a" && n.length === 4;
                if (!i && n.length !== 3) return e;
                for(var a = 0; a < n.length; a++){
                    if (!n[a].length || (n[a] = Number(n[a]), !(n[a] >= 0))) return e;
                    if (a === 3) n[a] > 1 && (n[a] = 1);
                    else if (n[a] >= 1) return e;
                }
                var o = Math.round(n[0] * 255) + ", " + Math.round(n[1] * 255) + ", " + Math.round(n[2] * 255);
                return i ? "rgba(" + o + ", " + n[3] + ")" : "rgb(" + o + ")";
            }
        });
        var U1 = ye((aer, Hee)=>{
            "use strict";
            Hee.exports = {
                SHOW_PLACEHOLDER: 100,
                HIDE_PLACEHOLDER: 1e3,
                DESELECTDIM: .2
            };
        });
        var n3 = ye((Gee)=>{
            "use strict";
            Gee.counter = function(e, t, r, n) {
                var i = (t || "") + (r ? "" : "$"), a = n === !1 ? "" : "^";
                return e === "xy" ? new RegExp(a + "x([2-9]|[1-9][0-9]+)?y([2-9]|[1-9][0-9]+)?" + i) : new RegExp(a + e + "([2-9]|[1-9][0-9]+)?" + i);
            };
        });
        var Xee = ye((bp)=>{
            "use strict";
            var Tq = uo(), jee = id(), Wee = no().extendFlat, Met = vl(), Eet = sb(), ket = va(), Cet = U1().DESELECTDIM, a3 = ES(), Zee = n3().counter, Let = r3().modHalf, dm = vv().isArrayOrTypedArray, V1 = vv().isTypedArraySpec, H1 = vv().decodeTypedArraySpec;
            bp.valObjectMeta = {
                data_array: {
                    coerceFunction: function(e, t, r) {
                        t.set(dm(e) ? e : V1(e) ? H1(e) : r);
                    }
                },
                enumerated: {
                    coerceFunction: function(e, t, r, n) {
                        n.coerceNumber && (e = +e), n.values.indexOf(e) === -1 ? t.set(r) : t.set(e);
                    },
                    validateFunction: function(e, t) {
                        t.coerceNumber && (e = +e);
                        for(var r = t.values, n = 0; n < r.length; n++){
                            var i = String(r[n]);
                            if (i.charAt(0) === "/" && i.charAt(i.length - 1) === "/") {
                                var a = new RegExp(i.substr(1, i.length - 2));
                                if (a.test(e)) return !0;
                            } else if (e === r[n]) return !0;
                        }
                        return !1;
                    }
                },
                boolean: {
                    coerceFunction: function(e, t, r) {
                        e === !0 || e === !1 ? t.set(e) : t.set(r);
                    }
                },
                number: {
                    coerceFunction: function(e, t, r, n) {
                        V1(e) && (e = H1(e)), !Tq(e) || n.min !== void 0 && e < n.min || n.max !== void 0 && e > n.max ? t.set(r) : t.set(+e);
                    }
                },
                integer: {
                    coerceFunction: function(e, t, r, n) {
                        if ((n.extras || []).indexOf(e) !== -1) {
                            t.set(e);
                            return;
                        }
                        V1(e) && (e = H1(e)), e % 1 || !Tq(e) || n.min !== void 0 && e < n.min || n.max !== void 0 && e > n.max ? t.set(r) : t.set(+e);
                    }
                },
                string: {
                    coerceFunction: function(e, t, r, n) {
                        if (typeof e != "string") {
                            var i = typeof e == "number";
                            n.strict === !0 || !i ? t.set(r) : t.set(String(e));
                        } else n.noBlank && !e ? t.set(r) : t.set(e);
                    }
                },
                color: {
                    coerceFunction: function(e, t, r) {
                        V1(e) && (e = H1(e)), jee(e).isValid() ? t.set(e) : t.set(r);
                    }
                },
                colorlist: {
                    coerceFunction: function(e, t, r) {
                        function n(i) {
                            return jee(i).isValid();
                        }
                        !Array.isArray(e) || !e.length ? t.set(r) : e.every(n) ? t.set(e) : t.set(r);
                    }
                },
                colorscale: {
                    coerceFunction: function(e, t, r) {
                        t.set(Eet.get(e, r));
                    }
                },
                angle: {
                    coerceFunction: function(e, t, r) {
                        V1(e) && (e = H1(e)), e === "auto" ? t.set("auto") : Tq(e) ? t.set(Let(+e, 360)) : t.set(r);
                    }
                },
                subplotid: {
                    coerceFunction: function(e, t, r, n) {
                        var i = n.regex || Zee(r);
                        if (typeof e == "string" && i.test(e)) {
                            t.set(e);
                            return;
                        }
                        t.set(r);
                    },
                    validateFunction: function(e, t) {
                        var r = t.dflt;
                        return e === r ? !0 : typeof e != "string" ? !1 : !!Zee(r).test(e);
                    }
                },
                flaglist: {
                    coerceFunction: function(e, t, r, n) {
                        if ((n.extras || []).indexOf(e) !== -1) {
                            t.set(e);
                            return;
                        }
                        if (typeof e != "string") {
                            t.set(r);
                            return;
                        }
                        for(var i = e.split("+"), a = 0; a < i.length;){
                            var o = i[a];
                            n.flags.indexOf(o) === -1 || i.indexOf(o) < a ? i.splice(a, 1) : a++;
                        }
                        i.length ? t.set(i.join("+")) : t.set(r);
                    }
                },
                any: {
                    coerceFunction: function(e, t, r) {
                        e === void 0 ? t.set(r) : t.set(V1(e) ? H1(e) : e);
                    }
                },
                info_array: {
                    coerceFunction: function(e, t, r, n) {
                        function i(E, k, A) {
                            var L, _ = {
                                set: function(C) {
                                    L = C;
                                }
                            };
                            return A === void 0 && (A = k.dflt), bp.valObjectMeta[k.valType].coerceFunction(E, _, A, k), L;
                        }
                        if (V1(e) && (e = H1(e)), !dm(e)) {
                            t.set(r);
                            return;
                        }
                        var a = n.dimensions === 2 || n.dimensions === "1-2" && Array.isArray(e) && dm(e[0]), o = n.items, s = [], l = Array.isArray(o), u = l && a && dm(o[0]), c = a && l && !u, f = l && !c ? o.length : e.length, h, d, v, x, b, p;
                        if (r = Array.isArray(r) ? r : [], a) for(h = 0; h < f; h++)for(s[h] = [], v = dm(e[h]) ? e[h] : [], c ? b = o.length : l ? b = o[h].length : b = v.length, d = 0; d < b; d++)c ? x = o[d] : l ? x = o[h][d] : x = o, p = i(v[d], x, (r[h] || [])[d]), p !== void 0 && (s[h][d] = p);
                        else for(h = 0; h < f; h++)p = i(e[h], l ? o[h] : o, r[h]), p !== void 0 && (s[h] = p);
                        t.set(s);
                    },
                    validateFunction: function(e, t) {
                        if (!dm(e)) return !1;
                        var r = t.items, n = Array.isArray(r), i = t.dimensions === 2;
                        if (!t.freeLength && e.length !== r.length) return !1;
                        for(var a = 0; a < e.length; a++)if (i) {
                            if (!dm(e[a]) || !t.freeLength && e[a].length !== r[a].length) return !1;
                            for(var o = 0; o < e[a].length; o++)if (!p6(e[a][o], n ? r[a][o] : r)) return !1;
                        } else if (!p6(e[a], n ? r[a] : r)) return !1;
                        return !0;
                    }
                }
            };
            bp.coerce = function(e, t, r, n, i) {
                var a = a3(r, n).get(), o = a3(e, n), s = a3(t, n), l = o.get(), u = t._template;
                if (l === void 0 && u && (l = a3(u, n).get(), u = 0), i === void 0 && (i = a.dflt), a.arrayOk) {
                    if (dm(l)) return s.set(l), l;
                    if (V1(l)) return l = H1(l), s.set(l), l;
                }
                var c = bp.valObjectMeta[a.valType].coerceFunction;
                c(l, s, i, a);
                var f = s.get();
                return u && f === i && !p6(l, a) && (l = a3(u, n).get(), c(l, s, i, a), f = s.get()), f;
            };
            bp.coerce2 = function(e, t, r, n, i) {
                var a = a3(e, n), o = bp.coerce(e, t, r, n, i), s = a.get();
                return s != null ? o : !1;
            };
            bp.coerceFont = function(e, t, r, n) {
                n || (n = {}), r = Wee({}, r), r = Wee(r, n.overrideDflt || {});
                var i = {
                    family: e(t + ".family", r.family),
                    size: e(t + ".size", r.size),
                    color: e(t + ".color", r.color),
                    weight: e(t + ".weight", r.weight),
                    style: e(t + ".style", r.style)
                };
                if (n.noFontVariant || (i.variant = e(t + ".variant", r.variant)), n.noFontLineposition || (i.lineposition = e(t + ".lineposition", r.lineposition)), n.noFontTextcase || (i.textcase = e(t + ".textcase", r.textcase)), !n.noFontShadow) {
                    var a = r.shadow;
                    a === "none" && n.autoShadowDflt && (a = "auto"), i.shadow = e(t + ".shadow", a);
                }
                return i;
            };
            bp.coercePattern = function(e, t, r, n) {
                var i = e(t + ".shape");
                if (i) {
                    e(t + ".solidity"), e(t + ".size");
                    var a = e(t + ".fillmode"), o = a === "overlay";
                    if (!n) {
                        var s = e(t + ".bgcolor", o ? r : void 0);
                        e(t + ".fgcolor", o ? ket.contrast(s) : r);
                    }
                    e(t + ".fgopacity", o ? .5 : 1);
                }
            };
            bp.coerceHoverinfo = function(e, t, r) {
                var n = t._module.attributes, i = n.hoverinfo ? n : Met, a = i.hoverinfo, o;
                if (r._dataLength === 1) {
                    var s = a.dflt === "all" ? a.flags.slice() : a.dflt.split("+");
                    s.splice(s.indexOf("name"), 1), o = s.join("+");
                }
                return bp.coerce(e, t, i, "hoverinfo", o);
            };
            bp.coerceSelectionMarkerOpacity = function(e, t) {
                if (e.marker) {
                    var r = e.marker.opacity;
                    if (r !== void 0) {
                        var n, i;
                        !dm(r) && !e.selected && !e.unselected && (n = r, i = Cet * r), t("selected.marker.opacity", n), t("unselected.marker.opacity", i);
                    }
                }
            };
            function p6(e, t) {
                var r = bp.valObjectMeta[t.valType];
                if (t.arrayOk && dm(e)) return !0;
                if (r.validateFunction) return r.validateFunction(e, t);
                var n = {}, i = n, a = {
                    set: function(o) {
                        i = o;
                    }
                };
                return r.coerceFunction(e, a, n, t), i !== n;
            }
            bp.validate = p6;
        });
        var ub = ye((ler, $ee)=>{
            "use strict";
            var Yee = {
                staticPlot: {
                    valType: "boolean",
                    dflt: !1
                },
                typesetMath: {
                    valType: "boolean",
                    dflt: !0
                },
                plotlyServerURL: {
                    valType: "string",
                    dflt: ""
                },
                editable: {
                    valType: "boolean",
                    dflt: !1
                },
                edits: {
                    annotationPosition: {
                        valType: "boolean",
                        dflt: !1
                    },
                    annotationTail: {
                        valType: "boolean",
                        dflt: !1
                    },
                    annotationText: {
                        valType: "boolean",
                        dflt: !1
                    },
                    axisTitleText: {
                        valType: "boolean",
                        dflt: !1
                    },
                    colorbarPosition: {
                        valType: "boolean",
                        dflt: !1
                    },
                    colorbarTitleText: {
                        valType: "boolean",
                        dflt: !1
                    },
                    legendPosition: {
                        valType: "boolean",
                        dflt: !1
                    },
                    legendText: {
                        valType: "boolean",
                        dflt: !1
                    },
                    shapePosition: {
                        valType: "boolean",
                        dflt: !1
                    },
                    titleText: {
                        valType: "boolean",
                        dflt: !1
                    }
                },
                editSelection: {
                    valType: "boolean",
                    dflt: !0
                },
                autosizable: {
                    valType: "boolean",
                    dflt: !1
                },
                responsive: {
                    valType: "boolean",
                    dflt: !1
                },
                fillFrame: {
                    valType: "boolean",
                    dflt: !1
                },
                frameMargins: {
                    valType: "number",
                    dflt: 0,
                    min: 0,
                    max: .5
                },
                scrollZoom: {
                    valType: "flaglist",
                    flags: [
                        "cartesian",
                        "gl3d",
                        "geo",
                        "mapbox",
                        "map"
                    ],
                    extras: [
                        !0,
                        !1
                    ],
                    dflt: "gl3d+geo+map"
                },
                doubleClick: {
                    valType: "enumerated",
                    values: [
                        !1,
                        "reset",
                        "autosize",
                        "reset+autosize"
                    ],
                    dflt: "reset+autosize"
                },
                doubleClickDelay: {
                    valType: "number",
                    dflt: 300,
                    min: 0
                },
                showAxisDragHandles: {
                    valType: "boolean",
                    dflt: !0
                },
                showAxisRangeEntryBoxes: {
                    valType: "boolean",
                    dflt: !0
                },
                showTips: {
                    valType: "boolean",
                    dflt: !0
                },
                showLink: {
                    valType: "boolean",
                    dflt: !1
                },
                linkText: {
                    valType: "string",
                    dflt: "Edit chart",
                    noBlank: !0
                },
                sendData: {
                    valType: "boolean",
                    dflt: !0
                },
                showSources: {
                    valType: "any",
                    dflt: !1
                },
                displayModeBar: {
                    valType: "enumerated",
                    values: [
                        "hover",
                        !0,
                        !1
                    ],
                    dflt: "hover"
                },
                showSendToCloud: {
                    valType: "boolean",
                    dflt: !1
                },
                showEditInChartStudio: {
                    valType: "boolean",
                    dflt: !1
                },
                modeBarButtonsToRemove: {
                    valType: "any",
                    dflt: []
                },
                modeBarButtonsToAdd: {
                    valType: "any",
                    dflt: []
                },
                modeBarButtons: {
                    valType: "any",
                    dflt: !1
                },
                toImageButtonOptions: {
                    valType: "any",
                    dflt: {}
                },
                displaylogo: {
                    valType: "boolean",
                    dflt: !0
                },
                watermark: {
                    valType: "boolean",
                    dflt: !1
                },
                plotGlPixelRatio: {
                    valType: "number",
                    dflt: 2,
                    min: 1,
                    max: 4
                },
                setBackground: {
                    valType: "any",
                    dflt: "transparent"
                },
                topojsonURL: {
                    valType: "string",
                    noBlank: !0,
                    dflt: "https://cdn.plot.ly/"
                },
                mapboxAccessToken: {
                    valType: "string",
                    dflt: null
                },
                logging: {
                    valType: "integer",
                    min: 0,
                    max: 2,
                    dflt: 1
                },
                notifyOnLogging: {
                    valType: "integer",
                    min: 0,
                    max: 2,
                    dflt: 0
                },
                queueLength: {
                    valType: "integer",
                    min: 0,
                    dflt: 0
                },
                locale: {
                    valType: "string",
                    dflt: "en-US"
                },
                locales: {
                    valType: "any",
                    dflt: {}
                }
            }, Kee = {};
            function Jee(e, t) {
                for(var r in e){
                    var n = e[r];
                    n.valType ? t[r] = n.dflt : (t[r] || (t[r] = {}), Jee(n, t[r]));
                }
            }
            Jee(Yee, Kee);
            $ee.exports = {
                configAttributes: Yee,
                dfltConfig: Kee
            };
        });
        var Sq = ye((uer, Qee)=>{
            "use strict";
            var Aq = xa(), Pet = uo(), RS = [];
            Qee.exports = function(e, t) {
                if (RS.indexOf(e) !== -1) return;
                RS.push(e);
                var r = 1e3;
                Pet(t) ? r = t : t === "long" && (r = 3e3);
                var n = Aq.select("body").selectAll(".plotly-notifier").data([
                    0
                ]);
                n.enter().append("div").classed("plotly-notifier", !0);
                var i = n.selectAll(".notifier-note").data(RS);
                function a(o) {
                    o.duration(700).style("opacity", 0).each("end", function(s) {
                        var l = RS.indexOf(s);
                        l !== -1 && RS.splice(l, 1), Aq.select(this).remove();
                    });
                }
                i.enter().append("div").classed("notifier-note", !0).style("opacity", 0).each(function(o) {
                    var s = Aq.select(this);
                    s.append("button").classed("notifier-close", !0).html("&times;").on("click", function() {
                        s.transition().call(a);
                    });
                    for(var l = s.append("p"), u = o.split(/<br\s*\/?>/g), c = 0; c < u.length; c++)c && l.append("br"), l.append("span").text(u[c]);
                    t === "stick" ? s.transition().duration(350).style("opacity", 1) : s.transition().duration(700).style("opacity", 1).transition().delay(r).call(a);
                });
            };
        });
        var G1 = ye((cer, ete)=>{
            "use strict";
            var o3 = ub().dfltConfig, Mq = Sq(), Eq = ete.exports = {};
            Eq.log = function() {
                var e;
                if (o3.logging > 1) {
                    var t = [
                        "LOG:"
                    ];
                    for(e = 0; e < arguments.length; e++)t.push(arguments[e]);
                    console.trace.apply(console, t);
                }
                if (o3.notifyOnLogging > 1) {
                    var r = [];
                    for(e = 0; e < arguments.length; e++)r.push(arguments[e]);
                    Mq(r.join("<br>"), "long");
                }
            };
            Eq.warn = function() {
                var e;
                if (o3.logging > 0) {
                    var t = [
                        "WARN:"
                    ];
                    for(e = 0; e < arguments.length; e++)t.push(arguments[e]);
                    console.trace.apply(console, t);
                }
                if (o3.notifyOnLogging > 0) {
                    var r = [];
                    for(e = 0; e < arguments.length; e++)r.push(arguments[e]);
                    Mq(r.join("<br>"), "stick");
                }
            };
            Eq.error = function() {
                var e;
                if (o3.logging > 0) {
                    var t = [
                        "ERROR:"
                    ];
                    for(e = 0; e < arguments.length; e++)t.push(arguments[e]);
                    console.error.apply(console, t);
                }
                if (o3.notifyOnLogging > 0) {
                    var r = [];
                    for(e = 0; e < arguments.length; e++)r.push(arguments[e]);
                    Mq(r.join("<br>"), "stick");
                }
            };
        });
        var g6 = ye((fer, tte)=>{
            "use strict";
            tte.exports = function() {};
        });
        var kq = ye((her, rte)=>{
            "use strict";
            rte.exports = function(t, r) {
                if (r instanceof RegExp) {
                    for(var n = r.toString(), i = 0; i < t.length; i++)if (t[i] instanceof RegExp && t[i].toString() === n) return t;
                    t.push(r);
                } else (r || r === 0) && t.indexOf(r) === -1 && t.push(r);
                return t;
            };
        });
        var nte = ye((der, ite)=>{
            ite.exports = Iet;
            function Iet() {
                var e = new Float32Array(16);
                return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
            }
        });
        var ote = ye((ver, ate)=>{
            ate.exports = Ret;
            function Ret(e) {
                var t = new Float32Array(16);
                return t[0] = e[0], t[1] = e[1], t[2] = e[2], t[3] = e[3], t[4] = e[4], t[5] = e[5], t[6] = e[6], t[7] = e[7], t[8] = e[8], t[9] = e[9], t[10] = e[10], t[11] = e[11], t[12] = e[12], t[13] = e[13], t[14] = e[14], t[15] = e[15], t;
            }
        });
        var lte = ye((per, ste)=>{
            ste.exports = Det;
            function Det(e, t) {
                return e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
            }
        });
        var Cq = ye((ger, ute)=>{
            ute.exports = zet;
            function zet(e) {
                return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
            }
        });
        var fte = ye((mer, cte)=>{
            cte.exports = Fet;
            function Fet(e, t) {
                if (e === t) {
                    var r = t[1], n = t[2], i = t[3], a = t[6], o = t[7], s = t[11];
                    e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = r, e[6] = t[9], e[7] = t[13], e[8] = n, e[9] = a, e[11] = t[14], e[12] = i, e[13] = o, e[14] = s;
                } else e[0] = t[0], e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = t[1], e[5] = t[5], e[6] = t[9], e[7] = t[13], e[8] = t[2], e[9] = t[6], e[10] = t[10], e[11] = t[14], e[12] = t[3], e[13] = t[7], e[14] = t[11], e[15] = t[15];
                return e;
            }
        });
        var dte = ye((yer, hte)=>{
            hte.exports = qet;
            function qet(e, t) {
                var r = t[0], n = t[1], i = t[2], a = t[3], o = t[4], s = t[5], l = t[6], u = t[7], c = t[8], f = t[9], h = t[10], d = t[11], v = t[12], x = t[13], b = t[14], p = t[15], E = r * s - n * o, k = r * l - i * o, A = r * u - a * o, L = n * l - i * s, _ = n * u - a * s, C = i * u - a * l, M = c * x - f * v, g = c * b - h * v, P = c * p - d * v, T = f * b - h * x, F = f * p - d * x, q = h * p - d * b, V = E * q - k * F + A * T + L * P - _ * g + C * M;
                return V ? (V = 1 / V, e[0] = (s * q - l * F + u * T) * V, e[1] = (i * F - n * q - a * T) * V, e[2] = (x * C - b * _ + p * L) * V, e[3] = (h * _ - f * C - d * L) * V, e[4] = (l * P - o * q - u * g) * V, e[5] = (r * q - i * P + a * g) * V, e[6] = (b * A - v * C - p * k) * V, e[7] = (c * C - h * A + d * k) * V, e[8] = (o * F - s * P + u * M) * V, e[9] = (n * P - r * F - a * M) * V, e[10] = (v * _ - x * A + p * E) * V, e[11] = (f * A - c * _ - d * E) * V, e[12] = (s * g - o * T - l * M) * V, e[13] = (r * T - n * g + i * M) * V, e[14] = (x * k - v * L - b * E) * V, e[15] = (c * L - f * k + h * E) * V, e) : null;
            }
        });
        var pte = ye((_er, vte)=>{
            vte.exports = Oet;
            function Oet(e, t) {
                var r = t[0], n = t[1], i = t[2], a = t[3], o = t[4], s = t[5], l = t[6], u = t[7], c = t[8], f = t[9], h = t[10], d = t[11], v = t[12], x = t[13], b = t[14], p = t[15];
                return e[0] = s * (h * p - d * b) - f * (l * p - u * b) + x * (l * d - u * h), e[1] = -(n * (h * p - d * b) - f * (i * p - a * b) + x * (i * d - a * h)), e[2] = n * (l * p - u * b) - s * (i * p - a * b) + x * (i * u - a * l), e[3] = -(n * (l * d - u * h) - s * (i * d - a * h) + f * (i * u - a * l)), e[4] = -(o * (h * p - d * b) - c * (l * p - u * b) + v * (l * d - u * h)), e[5] = r * (h * p - d * b) - c * (i * p - a * b) + v * (i * d - a * h), e[6] = -(r * (l * p - u * b) - o * (i * p - a * b) + v * (i * u - a * l)), e[7] = r * (l * d - u * h) - o * (i * d - a * h) + c * (i * u - a * l), e[8] = o * (f * p - d * x) - c * (s * p - u * x) + v * (s * d - u * f), e[9] = -(r * (f * p - d * x) - c * (n * p - a * x) + v * (n * d - a * f)), e[10] = r * (s * p - u * x) - o * (n * p - a * x) + v * (n * u - a * s), e[11] = -(r * (s * d - u * f) - o * (n * d - a * f) + c * (n * u - a * s)), e[12] = -(o * (f * b - h * x) - c * (s * b - l * x) + v * (s * h - l * f)), e[13] = r * (f * b - h * x) - c * (n * b - i * x) + v * (n * h - i * f), e[14] = -(r * (s * b - l * x) - o * (n * b - i * x) + v * (n * l - i * s)), e[15] = r * (s * h - l * f) - o * (n * h - i * f) + c * (n * l - i * s), e;
            }
        });
        var mte = ye((xer, gte)=>{
            gte.exports = Bet;
            function Bet(e) {
                var t = e[0], r = e[1], n = e[2], i = e[3], a = e[4], o = e[5], s = e[6], l = e[7], u = e[8], c = e[9], f = e[10], h = e[11], d = e[12], v = e[13], x = e[14], b = e[15], p = t * o - r * a, E = t * s - n * a, k = t * l - i * a, A = r * s - n * o, L = r * l - i * o, _ = n * l - i * s, C = u * v - c * d, M = u * x - f * d, g = u * b - h * d, P = c * x - f * v, T = c * b - h * v, F = f * b - h * x;
                return p * F - E * T + k * P + A * g - L * M + _ * C;
            }
        });
        var _te = ye((ber, yte)=>{
            yte.exports = Net;
            function Net(e, t, r) {
                var n = t[0], i = t[1], a = t[2], o = t[3], s = t[4], l = t[5], u = t[6], c = t[7], f = t[8], h = t[9], d = t[10], v = t[11], x = t[12], b = t[13], p = t[14], E = t[15], k = r[0], A = r[1], L = r[2], _ = r[3];
                return e[0] = k * n + A * s + L * f + _ * x, e[1] = k * i + A * l + L * h + _ * b, e[2] = k * a + A * u + L * d + _ * p, e[3] = k * o + A * c + L * v + _ * E, k = r[4], A = r[5], L = r[6], _ = r[7], e[4] = k * n + A * s + L * f + _ * x, e[5] = k * i + A * l + L * h + _ * b, e[6] = k * a + A * u + L * d + _ * p, e[7] = k * o + A * c + L * v + _ * E, k = r[8], A = r[9], L = r[10], _ = r[11], e[8] = k * n + A * s + L * f + _ * x, e[9] = k * i + A * l + L * h + _ * b, e[10] = k * a + A * u + L * d + _ * p, e[11] = k * o + A * c + L * v + _ * E, k = r[12], A = r[13], L = r[14], _ = r[15], e[12] = k * n + A * s + L * f + _ * x, e[13] = k * i + A * l + L * h + _ * b, e[14] = k * a + A * u + L * d + _ * p, e[15] = k * o + A * c + L * v + _ * E, e;
            }
        });
        var bte = ye((wer, xte)=>{
            xte.exports = Uet;
            function Uet(e, t, r) {
                var n = r[0], i = r[1], a = r[2], o, s, l, u, c, f, h, d, v, x, b, p;
                return t === e ? (e[12] = t[0] * n + t[4] * i + t[8] * a + t[12], e[13] = t[1] * n + t[5] * i + t[9] * a + t[13], e[14] = t[2] * n + t[6] * i + t[10] * a + t[14], e[15] = t[3] * n + t[7] * i + t[11] * a + t[15]) : (o = t[0], s = t[1], l = t[2], u = t[3], c = t[4], f = t[5], h = t[6], d = t[7], v = t[8], x = t[9], b = t[10], p = t[11], e[0] = o, e[1] = s, e[2] = l, e[3] = u, e[4] = c, e[5] = f, e[6] = h, e[7] = d, e[8] = v, e[9] = x, e[10] = b, e[11] = p, e[12] = o * n + c * i + v * a + t[12], e[13] = s * n + f * i + x * a + t[13], e[14] = l * n + h * i + b * a + t[14], e[15] = u * n + d * i + p * a + t[15]), e;
            }
        });
        var Tte = ye((Ter, wte)=>{
            wte.exports = Vet;
            function Vet(e, t, r) {
                var n = r[0], i = r[1], a = r[2];
                return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e[4] = t[4] * i, e[5] = t[5] * i, e[6] = t[6] * i, e[7] = t[7] * i, e[8] = t[8] * a, e[9] = t[9] * a, e[10] = t[10] * a, e[11] = t[11] * a, e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
            }
        });
        var Ste = ye((Aer, Ate)=>{
            Ate.exports = Het;
            function Het(e, t, r, n) {
                var i = n[0], a = n[1], o = n[2], s = Math.sqrt(i * i + a * a + o * o), l, u, c, f, h, d, v, x, b, p, E, k, A, L, _, C, M, g, P, T, F, q, V, H;
                return Math.abs(s) < 1e-6 ? null : (s = 1 / s, i *= s, a *= s, o *= s, l = Math.sin(r), u = Math.cos(r), c = 1 - u, f = t[0], h = t[1], d = t[2], v = t[3], x = t[4], b = t[5], p = t[6], E = t[7], k = t[8], A = t[9], L = t[10], _ = t[11], C = i * i * c + u, M = a * i * c + o * l, g = o * i * c - a * l, P = i * a * c - o * l, T = a * a * c + u, F = o * a * c + i * l, q = i * o * c + a * l, V = a * o * c - i * l, H = o * o * c + u, e[0] = f * C + x * M + k * g, e[1] = h * C + b * M + A * g, e[2] = d * C + p * M + L * g, e[3] = v * C + E * M + _ * g, e[4] = f * P + x * T + k * F, e[5] = h * P + b * T + A * F, e[6] = d * P + p * T + L * F, e[7] = v * P + E * T + _ * F, e[8] = f * q + x * V + k * H, e[9] = h * q + b * V + A * H, e[10] = d * q + p * V + L * H, e[11] = v * q + E * V + _ * H, t !== e && (e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e);
            }
        });
        var Ete = ye((Ser, Mte)=>{
            Mte.exports = Get;
            function Get(e, t, r) {
                var n = Math.sin(r), i = Math.cos(r), a = t[4], o = t[5], s = t[6], l = t[7], u = t[8], c = t[9], f = t[10], h = t[11];
                return t !== e && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[4] = a * i + u * n, e[5] = o * i + c * n, e[6] = s * i + f * n, e[7] = l * i + h * n, e[8] = u * i - a * n, e[9] = c * i - o * n, e[10] = f * i - s * n, e[11] = h * i - l * n, e;
            }
        });
        var Cte = ye((Mer, kte)=>{
            kte.exports = jet;
            function jet(e, t, r) {
                var n = Math.sin(r), i = Math.cos(r), a = t[0], o = t[1], s = t[2], l = t[3], u = t[8], c = t[9], f = t[10], h = t[11];
                return t !== e && (e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = a * i - u * n, e[1] = o * i - c * n, e[2] = s * i - f * n, e[3] = l * i - h * n, e[8] = a * n + u * i, e[9] = o * n + c * i, e[10] = s * n + f * i, e[11] = l * n + h * i, e;
            }
        });
        var Pte = ye((Eer, Lte)=>{
            Lte.exports = Wet;
            function Wet(e, t, r) {
                var n = Math.sin(r), i = Math.cos(r), a = t[0], o = t[1], s = t[2], l = t[3], u = t[4], c = t[5], f = t[6], h = t[7];
                return t !== e && (e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = a * i + u * n, e[1] = o * i + c * n, e[2] = s * i + f * n, e[3] = l * i + h * n, e[4] = u * i - a * n, e[5] = c * i - o * n, e[6] = f * i - s * n, e[7] = h * i - l * n, e;
            }
        });
        var Rte = ye((ker, Ite)=>{
            Ite.exports = Zet;
            function Zet(e, t, r) {
                var n, i, a, o = r[0], s = r[1], l = r[2], u = Math.sqrt(o * o + s * s + l * l);
                return Math.abs(u) < 1e-6 ? null : (u = 1 / u, o *= u, s *= u, l *= u, n = Math.sin(t), i = Math.cos(t), a = 1 - i, e[0] = o * o * a + i, e[1] = s * o * a + l * n, e[2] = l * o * a - s * n, e[3] = 0, e[4] = o * s * a - l * n, e[5] = s * s * a + i, e[6] = l * s * a + o * n, e[7] = 0, e[8] = o * l * a + s * n, e[9] = s * l * a - o * n, e[10] = l * l * a + i, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e);
            }
        });
        var zte = ye((Cer, Dte)=>{
            Dte.exports = Xet;
            function Xet(e, t, r) {
                var n = t[0], i = t[1], a = t[2], o = t[3], s = n + n, l = i + i, u = a + a, c = n * s, f = n * l, h = n * u, d = i * l, v = i * u, x = a * u, b = o * s, p = o * l, E = o * u;
                return e[0] = 1 - (d + x), e[1] = f + E, e[2] = h - p, e[3] = 0, e[4] = f - E, e[5] = 1 - (c + x), e[6] = v + b, e[7] = 0, e[8] = h + p, e[9] = v - b, e[10] = 1 - (c + d), e[11] = 0, e[12] = r[0], e[13] = r[1], e[14] = r[2], e[15] = 1, e;
            }
        });
        var qte = ye((Ler, Fte)=>{
            Fte.exports = Yet;
            function Yet(e, t) {
                return e[0] = t[0], e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = t[1], e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = t[2], e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
            }
        });
        var Bte = ye((Per, Ote)=>{
            Ote.exports = Ket;
            function Ket(e, t) {
                return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = t[0], e[13] = t[1], e[14] = t[2], e[15] = 1, e;
            }
        });
        var Ute = ye((Ier, Nte)=>{
            Nte.exports = Jet;
            function Jet(e, t) {
                var r = Math.sin(t), n = Math.cos(t);
                return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = n, e[6] = r, e[7] = 0, e[8] = 0, e[9] = -r, e[10] = n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
            }
        });
        var Hte = ye((Rer, Vte)=>{
            Vte.exports = $et;
            function $et(e, t) {
                var r = Math.sin(t), n = Math.cos(t);
                return e[0] = n, e[1] = 0, e[2] = -r, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = r, e[9] = 0, e[10] = n, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
            }
        });
        var jte = ye((Der, Gte)=>{
            Gte.exports = Qet;
            function Qet(e, t) {
                var r = Math.sin(t), n = Math.cos(t);
                return e[0] = n, e[1] = r, e[2] = 0, e[3] = 0, e[4] = -r, e[5] = n, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
            }
        });
        var Lq = ye((zer, Wte)=>{
            Wte.exports = ett;
            function ett(e, t) {
                var r = t[0], n = t[1], i = t[2], a = t[3], o = r + r, s = n + n, l = i + i, u = r * o, c = n * o, f = n * s, h = i * o, d = i * s, v = i * l, x = a * o, b = a * s, p = a * l;
                return e[0] = 1 - f - v, e[1] = c + p, e[2] = h - b, e[3] = 0, e[4] = c - p, e[5] = 1 - u - v, e[6] = d + x, e[7] = 0, e[8] = h + b, e[9] = d - x, e[10] = 1 - u - f, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
            }
        });
        var Xte = ye((Fer, Zte)=>{
            Zte.exports = ttt;
            function ttt(e, t, r, n, i, a, o) {
                var s = 1 / (r - t), l = 1 / (i - n), u = 1 / (a - o);
                return e[0] = a * 2 * s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = a * 2 * l, e[6] = 0, e[7] = 0, e[8] = (r + t) * s, e[9] = (i + n) * l, e[10] = (o + a) * u, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = o * a * 2 * u, e[15] = 0, e;
            }
        });
        var Kte = ye((qer, Yte)=>{
            Yte.exports = rtt;
            function rtt(e, t, r, n, i) {
                var a = 1 / Math.tan(t / 2), o = 1 / (n - i);
                return e[0] = a / r, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = a, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = (i + n) * o, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = 2 * i * n * o, e[15] = 0, e;
            }
        });
        var $te = ye((Oer, Jte)=>{
            Jte.exports = itt;
            function itt(e, t, r, n) {
                var i = Math.tan(t.upDegrees * Math.PI / 180), a = Math.tan(t.downDegrees * Math.PI / 180), o = Math.tan(t.leftDegrees * Math.PI / 180), s = Math.tan(t.rightDegrees * Math.PI / 180), l = 2 / (o + s), u = 2 / (i + a);
                return e[0] = l, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = u, e[6] = 0, e[7] = 0, e[8] = -((o - s) * l * .5), e[9] = (i - a) * u * .5, e[10] = n / (r - n), e[11] = -1, e[12] = 0, e[13] = 0, e[14] = n * r / (r - n), e[15] = 0, e;
            }
        });
        var ere = ye((Ber, Qte)=>{
            Qte.exports = ntt;
            function ntt(e, t, r, n, i, a, o) {
                var s = 1 / (t - r), l = 1 / (n - i), u = 1 / (a - o);
                return e[0] = -2 * s, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * l, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * u, e[11] = 0, e[12] = (t + r) * s, e[13] = (i + n) * l, e[14] = (o + a) * u, e[15] = 1, e;
            }
        });
        var rre = ye((Ner, tre)=>{
            var att = Cq();
            tre.exports = ott;
            function ott(e, t, r, n) {
                var i, a, o, s, l, u, c, f, h, d, v = t[0], x = t[1], b = t[2], p = n[0], E = n[1], k = n[2], A = r[0], L = r[1], _ = r[2];
                return Math.abs(v - A) < 1e-6 && Math.abs(x - L) < 1e-6 && Math.abs(b - _) < 1e-6 ? att(e) : (c = v - A, f = x - L, h = b - _, d = 1 / Math.sqrt(c * c + f * f + h * h), c *= d, f *= d, h *= d, i = E * h - k * f, a = k * c - p * h, o = p * f - E * c, d = Math.sqrt(i * i + a * a + o * o), d ? (d = 1 / d, i *= d, a *= d, o *= d) : (i = 0, a = 0, o = 0), s = f * o - h * a, l = h * i - c * o, u = c * a - f * i, d = Math.sqrt(s * s + l * l + u * u), d ? (d = 1 / d, s *= d, l *= d, u *= d) : (s = 0, l = 0, u = 0), e[0] = i, e[1] = s, e[2] = c, e[3] = 0, e[4] = a, e[5] = l, e[6] = f, e[7] = 0, e[8] = o, e[9] = u, e[10] = h, e[11] = 0, e[12] = -(i * v + a * x + o * b), e[13] = -(s * v + l * x + u * b), e[14] = -(c * v + f * x + h * b), e[15] = 1, e);
            }
        });
        var nre = ye((Uer, ire)=>{
            ire.exports = stt;
            function stt(e) {
                return "mat4(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + e[3] + ", " + e[4] + ", " + e[5] + ", " + e[6] + ", " + e[7] + ", " + e[8] + ", " + e[9] + ", " + e[10] + ", " + e[11] + ", " + e[12] + ", " + e[13] + ", " + e[14] + ", " + e[15] + ")";
            }
        });
        var Pq = ye((Ver, are)=>{
            are.exports = {
                create: nte(),
                clone: ote(),
                copy: lte(),
                identity: Cq(),
                transpose: fte(),
                invert: dte(),
                adjoint: pte(),
                determinant: mte(),
                multiply: _te(),
                translate: bte(),
                scale: Tte(),
                rotate: Ste(),
                rotateX: Ete(),
                rotateY: Cte(),
                rotateZ: Pte(),
                fromRotation: Rte(),
                fromRotationTranslation: zte(),
                fromScaling: qte(),
                fromTranslation: Bte(),
                fromXRotation: Ute(),
                fromYRotation: Hte(),
                fromZRotation: jte(),
                fromQuat: Lq(),
                frustum: Xte(),
                perspective: Kte(),
                perspectiveFromFieldOfView: $te(),
                ortho: ere(),
                lookAt: rre(),
                str: nre()
            };
        });
        var m6 = ye((Xf)=>{
            "use strict";
            var ltt = Pq();
            Xf.init2dArray = function(e, t) {
                for(var r = new Array(e), n = 0; n < e; n++)r[n] = new Array(t);
                return r;
            };
            Xf.transposeRagged = function(e) {
                var t = 0, r = e.length, n, i;
                for(n = 0; n < r; n++)t = Math.max(t, e[n].length);
                var a = new Array(t);
                for(n = 0; n < t; n++)for(a[n] = new Array(r), i = 0; i < r; i++)a[n][i] = e[i][n];
                return a;
            };
            Xf.dot = function(e, t) {
                if (!(e.length && t.length) || e.length !== t.length) return null;
                var r = e.length, n, i;
                if (e[0].length) for(n = new Array(r), i = 0; i < r; i++)n[i] = Xf.dot(e[i], t);
                else if (t[0].length) {
                    var a = Xf.transposeRagged(t);
                    for(n = new Array(a.length), i = 0; i < a.length; i++)n[i] = Xf.dot(e, a[i]);
                } else for(n = 0, i = 0; i < r; i++)n += e[i] * t[i];
                return n;
            };
            Xf.translationMatrix = function(e, t) {
                return [
                    [
                        1,
                        0,
                        e
                    ],
                    [
                        0,
                        1,
                        t
                    ],
                    [
                        0,
                        0,
                        1
                    ]
                ];
            };
            Xf.rotationMatrix = function(e) {
                var t = e * Math.PI / 180;
                return [
                    [
                        Math.cos(t),
                        -Math.sin(t),
                        0
                    ],
                    [
                        Math.sin(t),
                        Math.cos(t),
                        0
                    ],
                    [
                        0,
                        0,
                        1
                    ]
                ];
            };
            Xf.rotationXYMatrix = function(e, t, r) {
                return Xf.dot(Xf.dot(Xf.translationMatrix(t, r), Xf.rotationMatrix(e)), Xf.translationMatrix(-t, -r));
            };
            Xf.apply3DTransform = function(e) {
                return function() {
                    var t = arguments, r = arguments.length === 1 ? t[0] : [
                        t[0],
                        t[1],
                        t[2] || 0
                    ];
                    return Xf.dot(e, [
                        r[0],
                        r[1],
                        r[2],
                        1
                    ]).slice(0, 3);
                };
            };
            Xf.apply2DTransform = function(e) {
                return function() {
                    var t = arguments;
                    t.length === 3 && (t = t[0]);
                    var r = arguments.length === 1 ? t[0] : [
                        t[0],
                        t[1]
                    ];
                    return Xf.dot(e, [
                        r[0],
                        r[1],
                        1
                    ]).slice(0, 2);
                };
            };
            Xf.apply2DTransform2 = function(e) {
                var t = Xf.apply2DTransform(e);
                return function(r) {
                    return t(r.slice(0, 2)).concat(t(r.slice(2, 4)));
                };
            };
            Xf.convertCssMatrix = function(e) {
                if (e) {
                    var t = e.length;
                    if (t === 16) return e;
                    if (t === 6) return [
                        e[0],
                        e[1],
                        0,
                        0,
                        e[2],
                        e[3],
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        e[4],
                        e[5],
                        0,
                        1
                    ];
                }
                return [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ];
            };
            Xf.inverseTransformMatrix = function(e) {
                var t = [];
                return ltt.invert(t, e), [
                    [
                        t[0],
                        t[1],
                        t[2],
                        t[3]
                    ],
                    [
                        t[4],
                        t[5],
                        t[6],
                        t[7]
                    ],
                    [
                        t[8],
                        t[9],
                        t[10],
                        t[11]
                    ],
                    [
                        t[12],
                        t[13],
                        t[14],
                        t[15]
                    ]
                ];
            };
        });
        var DS = ye((Ger, fre)=>{
            "use strict";
            var utt = xa(), ore = G1(), ctt = m6(), ftt = Pq();
            function htt(e) {
                var t;
                if (typeof e == "string") {
                    if (t = document.getElementById(e), t === null) throw new Error("No DOM element with id '" + e + "' exists on the page.");
                    return t;
                } else if (e == null) throw new Error("DOM element provided is null or undefined");
                return e;
            }
            function dtt(e) {
                var t = utt.select(e);
                return t.node() instanceof HTMLElement && t.size() && t.classed("js-plotly-plot");
            }
            function sre(e) {
                var t = e && e.parentNode;
                t && t.removeChild(e);
            }
            function vtt(e, t) {
                lre("global", e, t);
            }
            function lre(e, t, r) {
                var n = "plotly.js-style-" + e, i = document.getElementById(n);
                if (!(i && i.matches(".no-inline-styles"))) {
                    i || (i = document.createElement("style"), i.setAttribute("id", n), i.appendChild(document.createTextNode("")), document.head.appendChild(i));
                    var a = i.sheet;
                    a ? a.insertRule ? a.insertRule(t + "{" + r + "}", 0) : a.addRule ? a.addRule(t, r, 0) : ore.warn("addStyleRule failed") : ore.warn("Cannot addRelatedStyleRule, probably due to strict CSP...");
                }
            }
            function ptt(e) {
                var t = "plotly.js-style-" + e, r = document.getElementById(t);
                r && sre(r);
            }
            function gtt(e, t, r, n, i, a) {
                var o = n.split(":"), s = i.split(":"), l = "data-btn-style-event-added";
                a || (a = document), a.querySelectorAll(e).forEach(function(u) {
                    u.getAttribute(l) || (u.addEventListener("mouseenter", function() {
                        var c = this.querySelector(r);
                        c && (c.style[o[0]] = o[1]);
                    }), u.addEventListener("mouseleave", function() {
                        var c = this.querySelector(r);
                        c && (t && this.matches(t) ? c.style[o[0]] = o[1] : c.style[s[0]] = s[1]);
                    }), u.setAttribute(l, !0));
                });
            }
            function mtt(e) {
                var t = cre(e), r = [
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    1
                ];
                return t.forEach(function(n) {
                    var i = ure(n);
                    if (i) {
                        var a = ctt.convertCssMatrix(i);
                        r = ftt.multiply(r, r, a);
                    }
                }), r;
            }
            function ure(e) {
                var t = window.getComputedStyle(e, null), r = t.getPropertyValue("-webkit-transform") || t.getPropertyValue("-moz-transform") || t.getPropertyValue("-ms-transform") || t.getPropertyValue("-o-transform") || t.getPropertyValue("transform");
                return r === "none" ? null : r.replace("matrix", "").replace("3d", "").slice(1, -1).split(",").map(function(n) {
                    return +n;
                });
            }
            function cre(e) {
                for(var t = []; ytt(e);)t.push(e), e = e.parentNode, typeof ShadowRoot == "function" && e instanceof ShadowRoot && (e = e.host);
                return t;
            }
            function ytt(e) {
                return e && (e instanceof Element || e instanceof HTMLElement);
            }
            function _tt(e, t) {
                return e && t && e.top === t.top && e.left === t.left && e.right === t.right && e.bottom === t.bottom;
            }
            fre.exports = {
                getGraphDiv: htt,
                isPlotDiv: dtt,
                removeElement: sre,
                addStyleRule: vtt,
                addRelatedStyleRule: lre,
                deleteRelatedStyleRule: ptt,
                setStyleOnHover: gtt,
                getFullTransformMatrix: mtt,
                getElementTransformMatrix: ure,
                getElementAndAncestors: cre,
                equalDomRects: _tt
            };
        });
        var zS = ye((jer, hre)=>{
            "use strict";
            hre.exports = {
                mode: {
                    valType: "enumerated",
                    dflt: "afterall",
                    values: [
                        "immediate",
                        "next",
                        "afterall"
                    ]
                },
                direction: {
                    valType: "enumerated",
                    values: [
                        "forward",
                        "reverse"
                    ],
                    dflt: "forward"
                },
                fromcurrent: {
                    valType: "boolean",
                    dflt: !1
                },
                frame: {
                    duration: {
                        valType: "number",
                        min: 0,
                        dflt: 500
                    },
                    redraw: {
                        valType: "boolean",
                        dflt: !0
                    }
                },
                transition: {
                    duration: {
                        valType: "number",
                        min: 0,
                        dflt: 500,
                        editType: "none"
                    },
                    easing: {
                        valType: "enumerated",
                        dflt: "cubic-in-out",
                        values: [
                            "linear",
                            "quad",
                            "cubic",
                            "sin",
                            "exp",
                            "circle",
                            "elastic",
                            "back",
                            "bounce",
                            "linear-in",
                            "quad-in",
                            "cubic-in",
                            "sin-in",
                            "exp-in",
                            "circle-in",
                            "elastic-in",
                            "back-in",
                            "bounce-in",
                            "linear-out",
                            "quad-out",
                            "cubic-out",
                            "sin-out",
                            "exp-out",
                            "circle-out",
                            "elastic-out",
                            "back-out",
                            "bounce-out",
                            "linear-in-out",
                            "quad-in-out",
                            "cubic-in-out",
                            "sin-in-out",
                            "exp-in-out",
                            "circle-in-out",
                            "elastic-in-out",
                            "back-in-out",
                            "bounce-in-out"
                        ],
                        editType: "none"
                    },
                    ordering: {
                        valType: "enumerated",
                        values: [
                            "layout first",
                            "traces first"
                        ],
                        dflt: "layout first",
                        editType: "none"
                    }
                }
            };
        });
        var Bu = ye((Wer, _re)=>{
            "use strict";
            var vre = no().extendFlat, xtt = gy(), pre = {
                valType: "flaglist",
                extras: [
                    "none"
                ],
                flags: [
                    "calc",
                    "clearAxisTypes",
                    "plot",
                    "style",
                    "markerSize",
                    "colorbars"
                ]
            }, gre = {
                valType: "flaglist",
                extras: [
                    "none"
                ],
                flags: [
                    "calc",
                    "plot",
                    "legend",
                    "ticks",
                    "axrange",
                    "layoutstyle",
                    "modebar",
                    "camera",
                    "arraydraw",
                    "colorbars"
                ]
            }, btt = pre.flags.slice().concat([
                "fullReplot"
            ]), wtt = gre.flags.slice().concat("layoutReplot");
            _re.exports = {
                traces: pre,
                layout: gre,
                traceFlags: function() {
                    return dre(btt);
                },
                layoutFlags: function() {
                    return dre(wtt);
                },
                update: function(e, t) {
                    var r = t.editType;
                    if (r && r !== "none") for(var n = r.split("+"), i = 0; i < n.length; i++)e[n[i]] = !0;
                },
                overrideAll: mre
            };
            function dre(e) {
                for(var t = {}, r = 0; r < e.length; r++)t[e[r]] = !1;
                return t;
            }
            function mre(e, t, r) {
                var n = vre({}, e);
                for(var i in n){
                    var a = n[i];
                    xtt(a) && (n[i] = yre(a, t, r, i));
                }
                return r === "from-root" && (n.editType = t), n;
            }
            function yre(e, t, r, n) {
                if (e.valType) {
                    var i = vre({}, e);
                    if (i.editType = t, Array.isArray(e.items)) {
                        i.items = new Array(e.items.length);
                        for(var a = 0; a < e.items.length; a++)i.items[a] = yre(e.items[a], t, "from-root");
                    }
                    return i;
                } else return mre(e, t, n.charAt(0) === "_" ? "nested" : "from-root");
            }
        });
        var Ed = ye((Iq)=>{
            "use strict";
            Iq.dash = {
                valType: "string",
                values: [
                    "solid",
                    "dot",
                    "dash",
                    "longdash",
                    "dashdot",
                    "longdashdot"
                ],
                dflt: "solid",
                editType: "style"
            };
            Iq.pattern = {
                shape: {
                    valType: "enumerated",
                    values: [
                        "",
                        "/",
                        "\\",
                        "x",
                        "-",
                        "|",
                        "+",
                        "."
                    ],
                    dflt: "",
                    arrayOk: !0,
                    editType: "style"
                },
                fillmode: {
                    valType: "enumerated",
                    values: [
                        "replace",
                        "overlay"
                    ],
                    dflt: "replace",
                    editType: "style"
                },
                bgcolor: {
                    valType: "color",
                    arrayOk: !0,
                    editType: "style"
                },
                fgcolor: {
                    valType: "color",
                    arrayOk: !0,
                    editType: "style"
                },
                fgopacity: {
                    valType: "number",
                    editType: "style",
                    min: 0,
                    max: 1
                },
                size: {
                    valType: "number",
                    min: 0,
                    dflt: 8,
                    arrayOk: !0,
                    editType: "style"
                },
                solidity: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: .3,
                    arrayOk: !0,
                    editType: "style"
                },
                editType: "style"
            };
        });
        var Rq = ye((Xer, xre)=>{
            "use strict";
            xre.exports = {
                FORMAT_LINK: "https://github.com/d3/d3-format/tree/v1.4.5#d3-format",
                DATE_FORMAT_LINK: "https://github.com/d3/d3-time-format/tree/v2.2.3#locale_format"
            };
        });
        var Wo = ye((y6)=>{
            "use strict";
            var bre = Rq(), Yer = bre.FORMAT_LINK, Ker = bre.DATE_FORMAT_LINK;
            function Dq(e) {
                var t = e.description ? " " + e.description : "", r = e.keys || [];
                if (r.length > 0) {
                    for(var n = [], i = 0; i < r.length; i++)n[i] = "`" + r[i] + "`";
                    t = t + "Finally, the template string has access to ", r.length === 1 ? t = t + "variable " + n[0] : t = t + "variables " + n.slice(0, -1).join(", ") + " and " + n.slice(-1) + ".";
                }
                return t;
            }
            y6.hovertemplateAttrs = function(e, t) {
                e = e || {}, t = t || {};
                var r = Dq(t), n = {
                    valType: "string",
                    dflt: "",
                    editType: e.editType || "none"
                };
                return e.arrayOk !== !1 && (n.arrayOk = !0), n;
            };
            y6.texttemplateAttrs = function(e, t) {
                e = e || {}, t = t || {};
                var r = Dq(t), n = {
                    valType: "string",
                    dflt: "",
                    editType: e.editType || "calc"
                };
                return e.arrayOk !== !1 && (n.arrayOk = !0), n;
            };
            y6.shapeTexttemplateAttrs = function(e, t) {
                e = e || {}, t = t || {};
                var r = e.newshape ? "new " : "", n = Dq(t), i = {
                    valType: "string",
                    dflt: "",
                    editType: e.editType || "arraydraw"
                };
                return i;
            };
        });
        var b6 = ye(($er, Ere)=>{
            "use strict";
            function j1(e, t) {
                return t ? t.d2l(e) : e;
            }
            function wre(e, t) {
                return t ? t.l2d(e) : e;
            }
            function Ttt(e) {
                return e.x0;
            }
            function Att(e) {
                return e.x1;
            }
            function Stt(e) {
                return e.y0;
            }
            function Mtt(e) {
                return e.y1;
            }
            function Tre(e) {
                return e.x0shift || 0;
            }
            function Are(e) {
                return e.x1shift || 0;
            }
            function Sre(e) {
                return e.y0shift || 0;
            }
            function Mre(e) {
                return e.y1shift || 0;
            }
            function _6(e, t) {
                return j1(e.x1, t) + Are(e) - j1(e.x0, t) - Tre(e);
            }
            function x6(e, t, r) {
                return j1(e.y1, r) + Mre(e) - j1(e.y0, r) - Sre(e);
            }
            function Ett(e, t) {
                return Math.abs(_6(e, t));
            }
            function ktt(e, t, r) {
                return Math.abs(x6(e, t, r));
            }
            function Ctt(e, t, r) {
                return e.type !== "line" ? void 0 : Math.sqrt(Math.pow(_6(e, t), 2) + Math.pow(x6(e, t, r), 2));
            }
            function Ltt(e, t) {
                return wre((j1(e.x1, t) + Are(e) + j1(e.x0, t) + Tre(e)) / 2, t);
            }
            function Ptt(e, t, r) {
                return wre((j1(e.y1, r) + Mre(e) + j1(e.y0, r) + Sre(e)) / 2, r);
            }
            function Itt(e, t, r) {
                return e.type !== "line" ? void 0 : x6(e, t, r) / _6(e, t);
            }
            Ere.exports = {
                x0: Ttt,
                x1: Att,
                y0: Stt,
                y1: Mtt,
                slope: Itt,
                dx: _6,
                dy: x6,
                width: Ett,
                height: ktt,
                length: Ctt,
                xcenter: Ltt,
                ycenter: Ptt
            };
        });
        var Lre = ye((Qer, Cre)=>{
            "use strict";
            var Rtt = Bu().overrideAll, cb = vl(), kre = Su(), Dtt = Ed().dash, W1 = no().extendFlat, ztt = Wo().shapeTexttemplateAttrs, Ftt = b6();
            Cre.exports = Rtt({
                newshape: {
                    visible: W1({}, cb.visible, {}),
                    showlegend: {
                        valType: "boolean",
                        dflt: !1
                    },
                    legend: W1({}, cb.legend, {}),
                    legendgroup: W1({}, cb.legendgroup, {}),
                    legendgrouptitle: {
                        text: W1({}, cb.legendgrouptitle.text, {}),
                        font: kre({})
                    },
                    legendrank: W1({}, cb.legendrank, {}),
                    legendwidth: W1({}, cb.legendwidth, {}),
                    line: {
                        color: {
                            valType: "color"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 4
                        },
                        dash: W1({}, Dtt, {
                            dflt: "solid"
                        })
                    },
                    fillcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)"
                    },
                    fillrule: {
                        valType: "enumerated",
                        values: [
                            "evenodd",
                            "nonzero"
                        ],
                        dflt: "evenodd"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1
                    },
                    layer: {
                        valType: "enumerated",
                        values: [
                            "below",
                            "above",
                            "between"
                        ],
                        dflt: "above"
                    },
                    drawdirection: {
                        valType: "enumerated",
                        values: [
                            "ortho",
                            "horizontal",
                            "vertical",
                            "diagonal"
                        ],
                        dflt: "diagonal"
                    },
                    name: W1({}, cb.name, {}),
                    label: {
                        text: {
                            valType: "string",
                            dflt: ""
                        },
                        texttemplate: ztt({
                            newshape: !0
                        }, {
                            keys: Object.keys(Ftt)
                        }),
                        font: kre({}),
                        textposition: {
                            valType: "enumerated",
                            values: [
                                "top left",
                                "top center",
                                "top right",
                                "middle left",
                                "middle center",
                                "middle right",
                                "bottom left",
                                "bottom center",
                                "bottom right",
                                "start",
                                "middle",
                                "end"
                            ]
                        },
                        textangle: {
                            valType: "angle",
                            dflt: "auto"
                        },
                        xanchor: {
                            valType: "enumerated",
                            values: [
                                "auto",
                                "left",
                                "center",
                                "right"
                            ],
                            dflt: "auto"
                        },
                        yanchor: {
                            valType: "enumerated",
                            values: [
                                "top",
                                "middle",
                                "bottom"
                            ]
                        },
                        padding: {
                            valType: "number",
                            dflt: 3,
                            min: 0
                        }
                    }
                },
                activeshape: {
                    fillcolor: {
                        valType: "color",
                        dflt: "rgb(255,0,255)"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .5
                    }
                }
            }, "none", "from-root");
        });
        var Ire = ye((etr, Pre)=>{
            "use strict";
            var qtt = Ed().dash, Ott = no().extendFlat;
            Pre.exports = {
                newselection: {
                    mode: {
                        valType: "enumerated",
                        values: [
                            "immediate",
                            "gradual"
                        ],
                        dflt: "immediate",
                        editType: "none"
                    },
                    line: {
                        color: {
                            valType: "color",
                            editType: "none"
                        },
                        width: {
                            valType: "number",
                            min: 1,
                            dflt: 1,
                            editType: "none"
                        },
                        dash: Ott({}, qtt, {
                            dflt: "dot",
                            editType: "none"
                        }),
                        editType: "none"
                    },
                    editType: "none"
                },
                activeselection: {
                    fillcolor: {
                        valType: "color",
                        dflt: "rgba(0,0,0,0)",
                        editType: "none"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .5,
                        editType: "none"
                    },
                    editType: "none"
                }
            };
        });
        var w6 = ye((ttr, Rre)=>{
            "use strict";
            Rre.exports = function(e) {
                var t = e.editType;
                return {
                    t: {
                        valType: "number",
                        dflt: 0,
                        editType: t
                    },
                    r: {
                        valType: "number",
                        dflt: 0,
                        editType: t
                    },
                    b: {
                        valType: "number",
                        dflt: 0,
                        editType: t
                    },
                    l: {
                        valType: "number",
                        dflt: 0,
                        editType: t
                    },
                    editType: t
                };
            };
        });
        var s3 = ye((rtr, qre)=>{
            "use strict";
            var zq = Su(), Btt = zS(), T6 = dh(), Dre = Lre(), zre = Ire(), Ntt = w6(), Fre = no().extendFlat, A6 = zq({
                editType: "calc"
            });
            A6.family.dflt = '"Open Sans", verdana, arial, sans-serif';
            A6.size.dflt = 12;
            A6.color.dflt = T6.defaultLine;
            qre.exports = {
                font: A6,
                title: {
                    text: {
                        valType: "string",
                        editType: "layoutstyle"
                    },
                    font: zq({
                        editType: "layoutstyle"
                    }),
                    subtitle: {
                        text: {
                            valType: "string",
                            editType: "layoutstyle"
                        },
                        font: zq({
                            editType: "layoutstyle"
                        }),
                        editType: "layoutstyle"
                    },
                    xref: {
                        valType: "enumerated",
                        dflt: "container",
                        values: [
                            "container",
                            "paper"
                        ],
                        editType: "layoutstyle"
                    },
                    yref: {
                        valType: "enumerated",
                        dflt: "container",
                        values: [
                            "container",
                            "paper"
                        ],
                        editType: "layoutstyle"
                    },
                    x: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .5,
                        editType: "layoutstyle"
                    },
                    y: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: "auto",
                        editType: "layoutstyle"
                    },
                    xanchor: {
                        valType: "enumerated",
                        dflt: "auto",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        editType: "layoutstyle"
                    },
                    yanchor: {
                        valType: "enumerated",
                        dflt: "auto",
                        values: [
                            "auto",
                            "top",
                            "middle",
                            "bottom"
                        ],
                        editType: "layoutstyle"
                    },
                    pad: Fre(Ntt({
                        editType: "layoutstyle"
                    }), {}),
                    automargin: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    editType: "layoutstyle"
                },
                uniformtext: {
                    mode: {
                        valType: "enumerated",
                        values: [
                            !1,
                            "hide",
                            "show"
                        ],
                        dflt: !1,
                        editType: "plot"
                    },
                    minsize: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "plot"
                    },
                    editType: "plot"
                },
                autosize: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "none"
                },
                width: {
                    valType: "number",
                    min: 10,
                    dflt: 700,
                    editType: "plot"
                },
                height: {
                    valType: "number",
                    min: 10,
                    dflt: 450,
                    editType: "plot"
                },
                minreducedwidth: {
                    valType: "number",
                    min: 2,
                    dflt: 64,
                    editType: "plot"
                },
                minreducedheight: {
                    valType: "number",
                    min: 2,
                    dflt: 64,
                    editType: "plot"
                },
                margin: {
                    l: {
                        valType: "number",
                        min: 0,
                        dflt: 80,
                        editType: "plot"
                    },
                    r: {
                        valType: "number",
                        min: 0,
                        dflt: 80,
                        editType: "plot"
                    },
                    t: {
                        valType: "number",
                        min: 0,
                        dflt: 100,
                        editType: "plot"
                    },
                    b: {
                        valType: "number",
                        min: 0,
                        dflt: 80,
                        editType: "plot"
                    },
                    pad: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "plot"
                    },
                    autoexpand: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    editType: "plot"
                },
                computed: {
                    valType: "any",
                    editType: "none"
                },
                paper_bgcolor: {
                    valType: "color",
                    dflt: T6.background,
                    editType: "plot"
                },
                plot_bgcolor: {
                    valType: "color",
                    dflt: T6.background,
                    editType: "layoutstyle"
                },
                autotypenumbers: {
                    valType: "enumerated",
                    values: [
                        "convert types",
                        "strict"
                    ],
                    dflt: "convert types",
                    editType: "calc"
                },
                separators: {
                    valType: "string",
                    editType: "plot"
                },
                hidesources: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "plot"
                },
                showlegend: {
                    valType: "boolean",
                    editType: "legend"
                },
                colorway: {
                    valType: "colorlist",
                    dflt: T6.defaults,
                    editType: "calc"
                },
                datarevision: {
                    valType: "any",
                    editType: "calc"
                },
                uirevision: {
                    valType: "any",
                    editType: "none"
                },
                editrevision: {
                    valType: "any",
                    editType: "none"
                },
                selectionrevision: {
                    valType: "any",
                    editType: "none"
                },
                template: {
                    valType: "any",
                    editType: "calc"
                },
                newshape: Dre.newshape,
                activeshape: Dre.activeshape,
                newselection: zre.newselection,
                activeselection: zre.activeselection,
                meta: {
                    valType: "any",
                    arrayOk: !0,
                    editType: "plot"
                },
                transition: Fre({}, Btt.transition, {
                    editType: "none"
                })
            };
        });
        var Ore = Ll(()=>{});
        var Utt = {};
        var Bre = Ll(()=>{
            Ore();
        });
        var ba = ye((qs)=>{
            "use strict";
            var l3 = G1(), Nre = g6(), Ure = kq(), Vtt = gy(), Htt = DS().addStyleRule, Vre = no(), Gtt = vl(), jtt = s3(), Wtt = Vre.extendFlat, Fq = Vre.extendDeepAll;
            qs.modules = {};
            qs.allCategories = {};
            qs.allTypes = [];
            qs.subplotsRegistry = {};
            qs.componentsRegistry = {};
            qs.layoutArrayContainers = [];
            qs.layoutArrayRegexes = [];
            qs.traceLayoutAttributes = {};
            qs.localeRegistry = {};
            qs.apiMethodRegistry = {};
            qs.collectableSubplotTypes = null;
            qs.register = function(t) {
                if (qs.collectableSubplotTypes = null, t) t && !Array.isArray(t) && (t = [
                    t
                ]);
                else throw new Error("No argument passed to Plotly.register.");
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    if (!n) throw new Error("Invalid module was attempted to be registered!");
                    switch(n.moduleType){
                        case "trace":
                            Ztt(n);
                            break;
                        case "transform":
                            Ktt(n);
                            break;
                        case "component":
                            Ytt(n);
                            break;
                        case "locale":
                            Jtt(n);
                            break;
                        case "apiMethod":
                            var i = n.name;
                            qs.apiMethodRegistry[i] = n.fn;
                            break;
                        default:
                            throw new Error("Invalid module was attempted to be registered!");
                    }
                }
            };
            qs.getModule = function(e) {
                var t = qs.modules[Wre(e)];
                return t ? t._module : !1;
            };
            qs.traceIs = function(e, t) {
                if (e = Wre(e), e === "various") return !1;
                var r = qs.modules[e];
                return r || (e && l3.log("Unrecognized trace type " + e + "."), r = qs.modules[Gtt.type.dflt]), !!r.categories[t];
            };
            qs.getComponentMethod = function(e, t) {
                var r = qs.componentsRegistry[e];
                return r && r[t] || Nre;
            };
            qs.call = function() {
                var e = arguments[0], t = [].slice.call(arguments, 1);
                return qs.apiMethodRegistry[e].apply(null, t);
            };
            function Ztt(e) {
                var t = e.name, r = e.categories, n = e.meta;
                if (qs.modules[t]) {
                    l3.log("Type " + t + " already registered");
                    return;
                }
                qs.subplotsRegistry[e.basePlotModule.name] || Xtt(e.basePlotModule);
                for(var i = {}, a = 0; a < r.length; a++)i[r[a]] = !0, qs.allCategories[r[a]] = !0;
                qs.modules[t] = {
                    _module: e,
                    categories: i
                }, n && Object.keys(n).length && (qs.modules[t].meta = n), qs.allTypes.push(t);
                for(var o in qs.componentsRegistry)Gre(o, t);
                e.layoutAttributes && Wtt(qs.traceLayoutAttributes, e.layoutAttributes);
                var s = e.basePlotModule, l = s.name;
                if (l === "mapbox") {
                    var u = s.constants.styleRules;
                    for(var c in u)Htt(".js-plotly-plot .plotly .mapboxgl-" + c, u[c]);
                }
                l === "map" && (Bre(), B1(Utt)), (l === "geo" || l === "mapbox" || l === "map") && window.PlotlyGeoAssets === void 0 && (window.PlotlyGeoAssets = {
                    topojson: {}
                });
            }
            function Xtt(e) {
                var t = e.name;
                if (qs.subplotsRegistry[t]) {
                    l3.log("Plot type " + t + " already registered.");
                    return;
                }
                Hre(e), qs.subplotsRegistry[t] = e;
                for(var r in qs.componentsRegistry)jre(r, e.name);
            }
            function Ytt(e) {
                if (typeof e.name != "string") throw new Error("Component module *name* must be a string.");
                var t = e.name;
                qs.componentsRegistry[t] = e, e.layoutAttributes && (e.layoutAttributes._isLinkedToArray && Ure(qs.layoutArrayContainers, t), Hre(e));
                for(var r in qs.modules)Gre(t, r);
                for(var n in qs.subplotsRegistry)jre(t, n);
                e.schema && e.schema.layout && Fq(jtt, e.schema.layout);
            }
            function Ktt(e) {
                if (typeof e.name != "string") throw new Error("Transform module *name* must be a string.");
                var t = "Transform module " + e.name, r = typeof e.transform == "function", n = typeof e.calcTransform == "function";
                if (!r && !n) throw new Error(t + " is missing a *transform* or *calcTransform* method.");
                r && n && l3.log([
                    t + " has both a *transform* and *calcTransform* methods.",
                    "Please note that all *transform* methods are executed",
                    "before all *calcTransform* methods."
                ].join(" ")), Vtt(e.attributes) || l3.log(t + " registered without an *attributes* object."), typeof e.supplyDefaults != "function" && l3.log(t + " registered without a *supplyDefaults* method.");
            }
            function Jtt(e) {
                var t = e.name, r = t.split("-")[0], n = e.dictionary, i = e.format, a = n && Object.keys(n).length, o = i && Object.keys(i).length, s = qs.localeRegistry, l = s[t];
                if (l || (s[t] = l = {}), r !== t) {
                    var u = s[r];
                    u || (s[r] = u = {}), a && u.dictionary === l.dictionary && (u.dictionary = n), o && u.format === l.format && (u.format = i);
                }
                a && (l.dictionary = n), o && (l.format = i);
            }
            function Hre(e) {
                if (e.layoutAttributes) {
                    var t = e.layoutAttributes._arrayAttrRegexps;
                    if (t) for(var r = 0; r < t.length; r++)Ure(qs.layoutArrayRegexes, t[r]);
                }
            }
            function Gre(e, t) {
                var r = qs.componentsRegistry[e].schema;
                if (!(!r || !r.traces)) {
                    var n = r.traces[t];
                    n && Fq(qs.modules[t]._module.attributes, n);
                }
            }
            function jre(e, t) {
                var r = qs.componentsRegistry[e].schema;
                if (!(!r || !r.subplots)) {
                    var n = qs.subplotsRegistry[t], i = n.layoutAttributes, a = n.attr === "subplot" ? n.name : n.attr;
                    Array.isArray(a) && (a = a[0]);
                    var o = r.subplots[a];
                    i && o && Fq(i, o);
                }
            }
            function Wre(e) {
                return typeof e == "object" && (e = e.type), e;
            }
        });
        var tie = ye((Yf)=>{
            "use strict";
            var $tt = e3().timeFormat, Qre = uo(), qq = G1(), X1 = r3().mod, f3 = es(), _0 = f3.BADNUM, wp = f3.ONEDAY, FS = f3.ONEHOUR, Z1 = f3.ONEMIN, c3 = f3.ONESEC, qS = f3.EPOCHJD, my = ba(), Zre = e3().utcFormat, Qtt = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\d)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m, ert = /^\s*(-?\d\d\d\d|\d\d)(-(\d?\di?)(-(\d?\d)([ Tt]([01]?\d|2[0-3])(:([0-5]\d)(:([0-5]\d(\.\d+)?))?(Z|z|[+\-]\d\d(:?\d\d)?)?)?)?)?)?\s*$/m, Xre = new Date().getFullYear() - 70;
            function yy(e) {
                return e && my.componentsRegistry.calendars && typeof e == "string" && e !== "gregorian";
            }
            Yf.dateTick0 = function(e, t) {
                var r = trt(e, !!t);
                if (t < 2) return r;
                var n = Yf.dateTime2ms(r, e);
                return n += wp * (t - 1), Yf.ms2DateTime(n, 0, e);
            };
            function trt(e, t) {
                return yy(e) ? t ? my.getComponentMethod("calendars", "CANONICAL_SUNDAY")[e] : my.getComponentMethod("calendars", "CANONICAL_TICK")[e] : t ? "2000-01-02" : "2000-01-01";
            }
            Yf.dfltRange = function(e) {
                return yy(e) ? my.getComponentMethod("calendars", "DFLTRANGE")[e] : [
                    "2000-01-01",
                    "2001-01-01"
                ];
            };
            Yf.isJSDate = function(e) {
                return typeof e == "object" && e !== null && typeof e.getTime == "function";
            };
            var M6, E6;
            Yf.dateTime2ms = function(e, t) {
                if (Yf.isJSDate(e)) {
                    var r = e.getTimezoneOffset() * Z1, n = (e.getUTCMinutes() - e.getMinutes()) * Z1 + (e.getUTCSeconds() - e.getSeconds()) * c3 + (e.getUTCMilliseconds() - e.getMilliseconds());
                    if (n) {
                        var i = 3 * Z1;
                        r = r - i / 2 + X1(n - r + i / 2, i);
                    }
                    return e = Number(e) - r, e >= M6 && e <= E6 ? e : _0;
                }
                if (typeof e != "string" && typeof e != "number") return _0;
                e = String(e);
                var a = yy(t), o = e.charAt(0);
                a && (o === "G" || o === "g") && (e = e.substr(1), t = "");
                var s = a && t.substr(0, 7) === "chinese", l = e.match(s ? ert : Qtt);
                if (!l) return _0;
                var u = l[1], c = l[3] || "1", f = Number(l[5] || 1), h = Number(l[7] || 0), d = Number(l[9] || 0), v = Number(l[11] || 0);
                if (a) {
                    if (u.length === 2) return _0;
                    u = Number(u);
                    var x;
                    try {
                        var b = my.getComponentMethod("calendars", "getCal")(t);
                        if (s) {
                            var p = c.charAt(c.length - 1) === "i";
                            c = parseInt(c, 10), x = b.newDate(u, b.toMonthIndex(u, c, p), f);
                        } else x = b.newDate(u, Number(c), f);
                    } catch (k) {
                        return _0;
                    }
                    return x ? (x.toJD() - qS) * wp + h * FS + d * Z1 + v * c3 : _0;
                }
                u.length === 2 ? u = (Number(u) + 2e3 - Xre) % 100 + Xre : u = Number(u), c -= 1;
                var E = new Date(Date.UTC(2e3, c, f, h, d));
                return E.setUTCFullYear(u), E.getUTCMonth() !== c || E.getUTCDate() !== f ? _0 : E.getTime() + v * c3;
            };
            M6 = Yf.MIN_MS = Yf.dateTime2ms("-9999");
            E6 = Yf.MAX_MS = Yf.dateTime2ms("9999-12-31 23:59:59.9999");
            Yf.isDateTime = function(e, t) {
                return Yf.dateTime2ms(e, t) !== _0;
            };
            function u3(e, t) {
                return String(e + Math.pow(10, t)).substr(1);
            }
            var S6 = 90 * wp, Yre = 3 * FS, Kre = 5 * Z1;
            Yf.ms2DateTime = function(e, t, r) {
                if (typeof e != "number" || !(e >= M6 && e <= E6)) return _0;
                t || (t = 0);
                var n = Math.floor(X1(e + .05, 1) * 10), i = Math.round(e - n / 10), a, o, s, l, u, c;
                if (yy(r)) {
                    var f = Math.floor(i / wp) + qS, h = Math.floor(X1(e, wp));
                    try {
                        a = my.getComponentMethod("calendars", "getCal")(r).fromJD(f).formatDate("yyyy-mm-dd");
                    } catch (d) {
                        a = Zre("G%Y-%m-%d")(new Date(i));
                    }
                    if (a.charAt(0) === "-") for(; a.length < 11;)a = "-0" + a.substr(1);
                    else for(; a.length < 10;)a = "0" + a;
                    o = t < S6 ? Math.floor(h / FS) : 0, s = t < S6 ? Math.floor(h % FS / Z1) : 0, l = t < Yre ? Math.floor(h % Z1 / c3) : 0, u = t < Kre ? h % c3 * 10 + n : 0;
                } else c = new Date(i), a = Zre("%Y-%m-%d")(c), o = t < S6 ? c.getUTCHours() : 0, s = t < S6 ? c.getUTCMinutes() : 0, l = t < Yre ? c.getUTCSeconds() : 0, u = t < Kre ? c.getUTCMilliseconds() * 10 + n : 0;
                return eie(a, o, s, l, u);
            };
            Yf.ms2DateTimeLocal = function(e) {
                if (!(e >= M6 + wp && e <= E6 - wp)) return _0;
                var t = Math.floor(X1(e + .05, 1) * 10), r = new Date(Math.round(e - t / 10)), n = $tt("%Y-%m-%d")(r), i = r.getHours(), a = r.getMinutes(), o = r.getSeconds(), s = r.getUTCMilliseconds() * 10 + t;
                return eie(n, i, a, o, s);
            };
            function eie(e, t, r, n, i) {
                if ((t || r || n || i) && (e += " " + u3(t, 2) + ":" + u3(r, 2), (n || i) && (e += ":" + u3(n, 2), i))) {
                    for(var a = 4; i % 10 === 0;)a -= 1, i /= 10;
                    e += "." + u3(i, a);
                }
                return e;
            }
            Yf.cleanDate = function(e, t, r) {
                if (e === _0) return t;
                if (Yf.isJSDate(e) || typeof e == "number" && isFinite(e)) {
                    if (yy(r)) return qq.error("JS Dates and milliseconds are incompatible with world calendars", e), t;
                    if (e = Yf.ms2DateTimeLocal(+e), !e && t !== void 0) return t;
                } else if (!Yf.isDateTime(e, r)) return qq.error("unrecognized date", e), t;
                return e;
            };
            var rrt = /%\d?f/g, irt = /%h/g, nrt = {
                1: "1",
                2: "1",
                3: "2",
                4: "2"
            };
            function Jre(e, t, r, n) {
                e = e.replace(rrt, function(a) {
                    var o = Math.min(+a.charAt(1) || 6, 6), s = (t / 1e3 % 1 + 2).toFixed(o).substr(2).replace(/0+$/, "") || "0";
                    return s;
                });
                var i = new Date(Math.floor(t + .05));
                if (e = e.replace(irt, function() {
                    return nrt[r("%q")(i)];
                }), yy(n)) try {
                    e = my.getComponentMethod("calendars", "worldCalFmt")(e, t, n);
                } catch (a) {
                    return "Invalid";
                }
                return r(e)(i);
            }
            var art = [
                59,
                59.9,
                59.99,
                59.999,
                59.9999
            ];
            function ort(e, t) {
                var r = X1(e + .05, wp), n = u3(Math.floor(r / FS), 2) + ":" + u3(X1(Math.floor(r / Z1), 60), 2);
                if (t !== "M") {
                    Qre(t) || (t = 0);
                    var i = Math.min(X1(e / c3, 60), art[t]), a = (100 + i).toFixed(t).substr(1);
                    t > 0 && (a = a.replace(/0+$/, "").replace(/[\.]$/, "")), n += ":" + a;
                }
                return n;
            }
            Yf.formatDate = function(e, t, r, n, i, a) {
                if (i = yy(i) && i, !t) {
                    if (r === "y") t = a.year;
                    else if (r === "m") t = a.month;
                    else if (r === "d") t = a.dayMonth + `
` + a.year;
                    else return ort(e, r) + `
` + Jre(a.dayMonthYear, e, n, i);
                }
                return Jre(t, e, n, i);
            };
            var $re = 3 * wp;
            Yf.incrementMonth = function(e, t, r) {
                r = yy(r) && r;
                var n = X1(e, wp);
                if (e = Math.round(e - n), r) try {
                    var i = Math.round(e / wp) + qS, a = my.getComponentMethod("calendars", "getCal")(r), o = a.fromJD(i);
                    return t % 12 ? a.add(o, t, "m") : a.add(o, t / 12, "y"), (o.toJD() - qS) * wp + n;
                } catch (l) {
                    qq.error("invalid ms " + e + " in calendar " + r);
                }
                var s = new Date(e + $re);
                return s.setUTCMonth(s.getUTCMonth() + t) + n - $re;
            };
            Yf.findExactDates = function(e, t) {
                for(var r = 0, n = 0, i = 0, a = 0, o, s, l = yy(t) && my.getComponentMethod("calendars", "getCal")(t), u = 0; u < e.length; u++){
                    if (s = e[u], !Qre(s)) {
                        a++;
                        continue;
                    }
                    if (!(s % wp)) {
                        if (l) try {
                            o = l.fromJD(s / wp + qS), o.day() === 1 ? o.month() === 1 ? r++ : n++ : i++;
                        } catch (f) {}
                        else o = new Date(s), o.getUTCDate() === 1 ? o.getUTCMonth() === 0 ? r++ : n++ : i++;
                    }
                }
                n += r, i += n;
                var c = e.length - a;
                return {
                    exactYears: r / c,
                    exactMonths: n / c,
                    exactDays: i / c
                };
            };
        });
        var OS = ye((ltr, rie)=>{
            "use strict";
            rie.exports = function(t) {
                return t;
            };
        });
        var k6 = ye((_y)=>{
            "use strict";
            var srt = uo(), lrt = G1(), urt = OS(), crt = es().BADNUM, Oq = 1e-9;
            _y.findBin = function(e, t, r) {
                if (srt(t.start)) return r ? Math.ceil((e - t.start) / t.size - Oq) - 1 : Math.floor((e - t.start) / t.size + Oq);
                var n = 0, i = t.length, a = 0, o = i > 1 ? (t[i - 1] - t[0]) / (i - 1) : 1, s, l;
                for(o >= 0 ? l = r ? frt : hrt : l = r ? vrt : drt, e += o * Oq * (r ? -1 : 1) * (o >= 0 ? 1 : -1); n < i && a++ < 100;)s = Math.floor((n + i) / 2), l(t[s], e) ? n = s + 1 : i = s;
                return a > 90 && lrt.log("Long binary search..."), n - 1;
            };
            function frt(e, t) {
                return e < t;
            }
            function hrt(e, t) {
                return e <= t;
            }
            function drt(e, t) {
                return e > t;
            }
            function vrt(e, t) {
                return e >= t;
            }
            _y.sorterAsc = function(e, t) {
                return e - t;
            };
            _y.sorterDes = function(e, t) {
                return t - e;
            };
            _y.distinctVals = function(e) {
                var t = e.slice();
                t.sort(_y.sorterAsc);
                var r;
                for(r = t.length - 1; r > -1 && t[r] === crt; r--);
                for(var n = t[r] - t[0] || 1, i = n / (r || 1) / 1e4, a = [], o, s = 0; s <= r; s++){
                    var l = t[s], u = l - o;
                    o === void 0 ? (a.push(l), o = l) : u > i && (n = Math.min(n, u), a.push(l), o = l);
                }
                return {
                    vals: a,
                    minDiff: n
                };
            };
            _y.roundUp = function(e, t, r) {
                for(var n = 0, i = t.length - 1, a, o = 0, s = r ? 0 : 1, l = r ? 1 : 0, u = r ? Math.ceil : Math.floor; n < i && o++ < 100;)a = u((n + i) / 2), t[a] <= e ? n = a + s : i = a - l;
                return t[n];
            };
            _y.sort = function(e, t) {
                for(var r = 0, n = 0, i = 1; i < e.length; i++){
                    var a = t(e[i], e[i - 1]);
                    if (a < 0 ? r = 1 : a > 0 && (n = 1), r && n) return e.sort(t);
                }
                return n ? e : e.reverse();
            };
            _y.findIndexOfMin = function(e, t) {
                t = t || urt;
                for(var r = 1 / 0, n, i = 0; i < e.length; i++){
                    var a = t(e[i]);
                    a < r && (r = a, n = i);
                }
                return n;
            };
        });
        var Y1 = ye((ctr, iie)=>{
            "use strict";
            iie.exports = function(t) {
                return Object.keys(t).sort();
            };
        });
        var nie = ye((Kf)=>{
            "use strict";
            var BS = uo(), prt = vv().isArrayOrTypedArray;
            Kf.aggNums = function(e, t, r, n) {
                var i, a;
                if ((!n || n > r.length) && (n = r.length), BS(t) || (t = !1), prt(r[0])) {
                    for(a = new Array(n), i = 0; i < n; i++)a[i] = Kf.aggNums(e, t, r[i]);
                    r = a;
                }
                for(i = 0; i < n; i++)BS(t) ? BS(r[i]) && (t = e(+t, +r[i])) : t = r[i];
                return t;
            };
            Kf.len = function(e) {
                return Kf.aggNums(function(t) {
                    return t + 1;
                }, 0, e);
            };
            Kf.mean = function(e, t) {
                return t || (t = Kf.len(e)), Kf.aggNums(function(r, n) {
                    return r + n;
                }, 0, e) / t;
            };
            Kf.geometricMean = function(e, t) {
                return t || (t = Kf.len(e)), Math.pow(Kf.aggNums(function(r, n) {
                    return r * n;
                }, 1, e), 1 / t);
            };
            Kf.midRange = function(e) {
                if (!(e === void 0 || e.length === 0)) return (Kf.aggNums(Math.max, null, e) + Kf.aggNums(Math.min, null, e)) / 2;
            };
            Kf.variance = function(e, t, r) {
                return t || (t = Kf.len(e)), BS(r) || (r = Kf.mean(e, t)), Kf.aggNums(function(n, i) {
                    return n + Math.pow(i - r, 2);
                }, 0, e) / t;
            };
            Kf.stdev = function(e, t, r) {
                return Math.sqrt(Kf.variance(e, t, r));
            };
            Kf.median = function(e) {
                var t = e.slice().sort();
                return Kf.interp(t, .5);
            };
            Kf.interp = function(e, t) {
                if (!BS(t)) throw "n should be a finite number";
                if (t = t * e.length - .5, t < 0) return e[0];
                if (t > e.length - 1) return e[e.length - 1];
                var r = t % 1;
                return r * e[Math.ceil(t)] + (1 - r) * e[Math.floor(t)];
            };
        });
        var uie = ye((htr, lie)=>{
            "use strict";
            var aie = r3(), Bq = aie.mod, grt = aie.modHalf, NS = Math.PI, K1 = 2 * NS;
            function mrt(e) {
                return e / 180 * NS;
            }
            function yrt(e) {
                return e / NS * 180;
            }
            function Nq(e) {
                return Math.abs(e[1] - e[0]) > K1 - 1e-14;
            }
            function oie(e, t) {
                return grt(t - e, K1);
            }
            function _rt(e, t) {
                return Math.abs(oie(e, t));
            }
            function sie(e, t) {
                if (Nq(t)) return !0;
                var r, n;
                t[0] < t[1] ? (r = t[0], n = t[1]) : (r = t[1], n = t[0]), r = Bq(r, K1), n = Bq(n, K1), r > n && (n += K1);
                var i = Bq(e, K1), a = i + K1;
                return i >= r && i <= n || a >= r && a <= n;
            }
            function xrt(e, t, r, n) {
                if (!sie(t, n)) return !1;
                var i, a;
                return r[0] < r[1] ? (i = r[0], a = r[1]) : (i = r[1], a = r[0]), e >= i && e <= a;
            }
            function Uq(e, t, r, n, i, a, o) {
                i = i || 0, a = a || 0;
                var s = Nq([
                    r,
                    n
                ]), l, u, c, f, h;
                s ? (l = 0, u = NS, c = K1) : r < n ? (l = r, c = n) : (l = n, c = r), e < t ? (f = e, h = t) : (f = t, h = e);
                function d(p, E) {
                    return [
                        p * Math.cos(E) + i,
                        a - p * Math.sin(E)
                    ];
                }
                var v = Math.abs(c - l) <= NS ? 0 : 1;
                function x(p, E, k) {
                    return "A" + [
                        p,
                        p
                    ] + " " + [
                        0,
                        v,
                        k
                    ] + " " + d(p, E);
                }
                var b;
                return s ? f === null ? b = "M" + d(h, l) + x(h, u, 0) + x(h, c, 0) + "Z" : b = "M" + d(f, l) + x(f, u, 0) + x(f, c, 0) + "ZM" + d(h, l) + x(h, u, 1) + x(h, c, 1) + "Z" : f === null ? (b = "M" + d(h, l) + x(h, c, 0), o && (b += "L0,0Z")) : b = "M" + d(f, l) + "L" + d(h, l) + x(h, c, 0) + "L" + d(f, c) + x(f, l, 1) + "Z", b;
            }
            function brt(e, t, r, n, i) {
                return Uq(null, e, t, r, n, i, 0);
            }
            function wrt(e, t, r, n, i) {
                return Uq(null, e, t, r, n, i, 1);
            }
            function Trt(e, t, r, n, i, a) {
                return Uq(e, t, r, n, i, a, 1);
            }
            lie.exports = {
                deg2rad: mrt,
                rad2deg: yrt,
                angleDelta: oie,
                angleDist: _rt,
                isFullCircle: Nq,
                isAngleInsideSector: sie,
                isPtInsideSector: xrt,
                pathArc: brt,
                pathSector: wrt,
                pathAnnulus: Trt
            };
        });
        var cie = ye((fb)=>{
            "use strict";
            fb.isLeftAnchor = function(t) {
                return t.xanchor === "left" || t.xanchor === "auto" && t.x <= 1 / 3;
            };
            fb.isCenterAnchor = function(t) {
                return t.xanchor === "center" || t.xanchor === "auto" && t.x > 1 / 3 && t.x < 2 / 3;
            };
            fb.isRightAnchor = function(t) {
                return t.xanchor === "right" || t.xanchor === "auto" && t.x >= 2 / 3;
            };
            fb.isTopAnchor = function(t) {
                return t.yanchor === "top" || t.yanchor === "auto" && t.y >= 2 / 3;
            };
            fb.isMiddleAnchor = function(t) {
                return t.yanchor === "middle" || t.yanchor === "auto" && t.y > 1 / 3 && t.y < 2 / 3;
            };
            fb.isBottomAnchor = function(t) {
                return t.yanchor === "bottom" || t.yanchor === "auto" && t.y <= 1 / 3;
            };
        });
        var die = ye((hb)=>{
            "use strict";
            var Vq = r3().mod;
            hb.segmentsIntersect = hie;
            function hie(e, t, r, n, i, a, o, s) {
                var l = r - e, u = i - e, c = o - i, f = n - t, h = a - t, d = s - a, v = l * d - c * f;
                if (v === 0) return null;
                var x = (u * d - c * h) / v, b = (u * f - l * h) / v;
                return b < 0 || b > 1 || x < 0 || x > 1 ? null : {
                    x: e + l * x,
                    y: t + f * x
                };
            }
            hb.segmentDistance = function(t, r, n, i, a, o, s, l) {
                if (hie(t, r, n, i, a, o, s, l)) return 0;
                var u = n - t, c = i - r, f = s - a, h = l - o, d = u * u + c * c, v = f * f + h * h, x = Math.min(C6(u, c, d, a - t, o - r), C6(u, c, d, s - t, l - r), C6(f, h, v, t - a, r - o), C6(f, h, v, n - a, i - o));
                return Math.sqrt(x);
            };
            function C6(e, t, r, n, i) {
                var a = n * e + i * t;
                if (a < 0) return n * n + i * i;
                if (a > r) {
                    var o = n - e, s = i - t;
                    return o * o + s * s;
                } else {
                    var l = n * t - i * e;
                    return l * l / r;
                }
            }
            var L6, Hq, fie;
            hb.getTextLocation = function(t, r, n, i) {
                if ((t !== Hq || i !== fie) && (L6 = {}, Hq = t, fie = i), L6[n]) return L6[n];
                var a = t.getPointAtLength(Vq(n - i / 2, r)), o = t.getPointAtLength(Vq(n + i / 2, r)), s = Math.atan((o.y - a.y) / (o.x - a.x)), l = t.getPointAtLength(Vq(n, r)), u = (l.x * 4 + a.x + o.x) / 6, c = (l.y * 4 + a.y + o.y) / 6, f = {
                    x: u,
                    y: c,
                    theta: s
                };
                return L6[n] = f, f;
            };
            hb.clearLocationCache = function() {
                Hq = null;
            };
            hb.getVisibleSegment = function(t, r, n) {
                var i = r.left, a = r.right, o = r.top, s = r.bottom, l = 0, u = t.getTotalLength(), c = u, f, h;
                function d(x) {
                    var b = t.getPointAtLength(x);
                    x === 0 ? f = b : x === u && (h = b);
                    var p = b.x < i ? i - b.x : b.x > a ? b.x - a : 0, E = b.y < o ? o - b.y : b.y > s ? b.y - s : 0;
                    return Math.sqrt(p * p + E * E);
                }
                for(var v = d(l); v;){
                    if (l += v + n, l > c) return;
                    v = d(l);
                }
                for(v = d(c); v;){
                    if (c -= v + n, l > c) return;
                    v = d(c);
                }
                return {
                    min: l,
                    max: c,
                    len: c - l,
                    total: u,
                    isClosed: l === 0 && c === u && Math.abs(f.x - h.x) < .1 && Math.abs(f.y - h.y) < .1
                };
            };
            hb.findPointOnPath = function(t, r, n, i) {
                i = i || {};
                for(var a = i.pathLength || t.getTotalLength(), o = i.tolerance || .001, s = i.iterationLimit || 30, l = t.getPointAtLength(0)[n] > t.getPointAtLength(a)[n] ? -1 : 1, u = 0, c = 0, f = a, h, d, v; u < s;){
                    if (h = (c + f) / 2, d = t.getPointAtLength(h), v = d[n] - r, Math.abs(v) < o) return d;
                    l * v > 0 ? f = h : c = h, u++;
                }
                return d;
            };
        });
        var P6 = ye((US)=>{
            "use strict";
            var xy = {};
            US.throttle = function(t, r, n) {
                var i = xy[t], a = Date.now();
                if (!i) {
                    for(var o in xy)xy[o].ts < a - 6e4 && delete xy[o];
                    i = xy[t] = {
                        ts: 0,
                        timer: null
                    };
                }
                vie(i);
                function s() {
                    n(), i.ts = Date.now(), i.onDone && (i.onDone(), i.onDone = null);
                }
                if (a > i.ts + r) {
                    s();
                    return;
                }
                i.timer = setTimeout(function() {
                    s(), i.timer = null;
                }, r);
            };
            US.done = function(e) {
                var t = xy[e];
                return !t || !t.timer ? Promise.resolve() : new Promise(function(r) {
                    var n = t.onDone;
                    t.onDone = function() {
                        n && n(), r(), t.onDone = null;
                    };
                });
            };
            US.clear = function(e) {
                if (e) vie(xy[e]), delete xy[e];
                else for(var t in xy)US.clear(t);
            };
            function vie(e) {
                e && e.timer !== null && (clearTimeout(e.timer), e.timer = null);
            }
        });
        var gie = ye((gtr, pie)=>{
            "use strict";
            pie.exports = function(t) {
                t._responsiveChartHandler && (window.removeEventListener("resize", t._responsiveChartHandler), delete t._responsiveChartHandler);
            };
        });
        var mie = ye((mtr, I6)=>{
            "use strict";
            I6.exports = Gq;
            I6.exports.isMobile = Gq;
            I6.exports.default = Gq;
            var Art = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, Srt = /CrOS/, Mrt = /android|ipad|playbook|silk/i;
            function Gq(e) {
                e || (e = {});
                let t = e.ua;
                if (!t && typeof navigator != "undefined" && (t = navigator.userAgent), t && t.headers && typeof t.headers["user-agent"] == "string" && (t = t.headers["user-agent"]), typeof t != "string") return !1;
                let r = Art.test(t) && !Srt.test(t) || !!e.tablet && Mrt.test(t);
                return !r && e.tablet && e.featureDetect && navigator && navigator.maxTouchPoints > 1 && t.indexOf("Macintosh") !== -1 && t.indexOf("Safari") !== -1 && (r = !0), r;
            }
        });
        var _ie = ye((ytr, yie)=>{
            "use strict";
            var Ert = uo(), krt = mie();
            yie.exports = function(t) {
                var r;
                if (t && t.hasOwnProperty("userAgent") ? r = t.userAgent : r = Crt(), typeof r != "string") return !0;
                var n = krt({
                    ua: {
                        headers: {
                            "user-agent": r
                        }
                    },
                    tablet: !0,
                    featureDetect: !1
                });
                if (!n) for(var i = r.split(" "), a = 1; a < i.length; a++){
                    var o = i[a];
                    if (o.indexOf("Safari") !== -1) for(var s = a - 1; s > -1; s--){
                        var l = i[s];
                        if (l.substr(0, 8) === "Version/") {
                            var u = l.substr(8).split(".")[0];
                            if (Ert(u) && (u = +u), u >= 13) return !0;
                        }
                    }
                }
                return n;
            };
            function Crt() {
                var e;
                return typeof navigator != "undefined" && (e = navigator.userAgent), e && e.headers && typeof e.headers["user-agent"] == "string" && (e = e.headers["user-agent"]), e;
            }
        });
        var bie = ye((_tr, xie)=>{
            "use strict";
            var Lrt = xa();
            xie.exports = function(t, r, n) {
                var i = t.selectAll("g." + n.replace(/\s/g, ".")).data(r, function(o) {
                    return o[0].trace.uid;
                });
                i.exit().remove(), i.enter().append("g").attr("class", n), i.order();
                var a = t.classed("rangeplot") ? "nodeRangePlot3" : "node3";
                return i.each(function(o) {
                    o[0][a] = Lrt.select(this);
                }), i;
            };
        });
        var Tie = ye((xtr, wie)=>{
            "use strict";
            var Prt = ba();
            wie.exports = function(t, r) {
                for(var n = t._context.locale, i = 0; i < 2; i++){
                    for(var a = t._context.locales, o = 0; o < 2; o++){
                        var s = (a[n] || {}).dictionary;
                        if (s) {
                            var l = s[r];
                            if (l) return l;
                        }
                        a = Prt.localeRegistry;
                    }
                    var u = n.split("-")[0];
                    if (u === n) break;
                    n = u;
                }
                return r;
            };
        });
        var jq = ye((btr, Aie)=>{
            "use strict";
            Aie.exports = function(t) {
                for(var r = {}, n = [], i = 0, a = 0; a < t.length; a++){
                    var o = t[a];
                    r[o] !== 1 && (r[o] = 1, n[i++] = o);
                }
                return n;
            };
        });
        var Mie = ye((wtr, Sie)=>{
            "use strict";
            Sie.exports = function(t) {
                for(var r = Drt(t) ? Rrt : Irt, n = [], i = 0; i < t.length; i++){
                    var a = t[i];
                    r(a) && n.push(a);
                }
                return n;
            };
            function Irt(e) {
                return e.visible === !0;
            }
            function Rrt(e) {
                var t = e[0].trace;
                return t.visible === !0 && t._length !== 0;
            }
            function Drt(e) {
                return Array.isArray(e) && Array.isArray(e[0]) && e[0][0] && e[0][0].trace;
            }
        });
        var kie = ye((Ttr, Eie)=>{
            "use strict";
            Eie.exports = function(t, r) {
                if (!r) return t;
                var n = 1 / Math.abs(r), i = n > 1 ? (n * t + n * r) / n : t + r, a = String(i).length;
                if (a > 16) {
                    var o = String(r).length, s = String(t).length;
                    if (a >= s + o) {
                        var l = parseFloat(i).toPrecision(12);
                        l.indexOf("e+") === -1 && (i = +l);
                    }
                }
                return i;
            };
        });
        var Lie = ye((Atr, Cie)=>{
            "use strict";
            var zrt = uo(), Frt = es().BADNUM, qrt = /^['"%,$#\s']+|[, ]|['"%,$#\s']+$/g;
            Cie.exports = function(t) {
                return typeof t == "string" && (t = t.replace(qrt, "")), zrt(t) ? Number(t) : Frt;
            };
        });
        var Mr = ye((Str, Hie)=>{
            "use strict";
            var VS = xa(), Ort = e3().utcFormat, Brt = vq().format, Fie = uo(), qie = es(), Oie = qie.FP_SAFE, Nrt = -Oie, Pie = qie.BADNUM, li = Hie.exports = {};
            li.adjustFormat = function(t) {
                return !t || /^\d[.]\df/.test(t) || /[.]\d%/.test(t) ? t : t === "0.f" ? "~f" : /^\d%/.test(t) ? "~%" : /^\ds/.test(t) ? "~s" : !/^[~,.0$]/.test(t) && /[&fps]/.test(t) ? "~" + t : t;
            };
            var Iie = {};
            li.warnBadFormat = function(e) {
                var t = String(e);
                Iie[t] || (Iie[t] = 1, li.warn('encountered bad format: "' + t + '"'));
            };
            li.noFormat = function(e) {
                return String(e);
            };
            li.numberFormat = function(e) {
                var t;
                try {
                    t = Brt(li.adjustFormat(e));
                } catch (r) {
                    return li.warnBadFormat(e), li.noFormat;
                }
                return t;
            };
            li.nestedProperty = ES();
            li.keyedContainer = Tee();
            li.relativeAttr = See();
            li.isPlainObject = gy();
            li.toLogRange = u6();
            li.relinkPrivateKeys = Cee();
            var J1 = vv();
            li.isArrayBuffer = J1.isArrayBuffer;
            li.isTypedArray = J1.isTypedArray;
            li.isArrayOrTypedArray = J1.isArrayOrTypedArray;
            li.isArray1D = J1.isArray1D;
            li.ensureArray = J1.ensureArray;
            li.concat = J1.concat;
            li.maxRowLength = J1.maxRowLength;
            li.minRowLength = J1.minRowLength;
            var Bie = r3();
            li.mod = Bie.mod;
            li.modHalf = Bie.modHalf;
            var $1 = Xee();
            li.valObjectMeta = $1.valObjectMeta;
            li.coerce = $1.coerce;
            li.coerce2 = $1.coerce2;
            li.coerceFont = $1.coerceFont;
            li.coercePattern = $1.coercePattern;
            li.coerceHoverinfo = $1.coerceHoverinfo;
            li.coerceSelectionMarkerOpacity = $1.coerceSelectionMarkerOpacity;
            li.validate = $1.validate;
            var Wp = tie();
            li.dateTime2ms = Wp.dateTime2ms;
            li.isDateTime = Wp.isDateTime;
            li.ms2DateTime = Wp.ms2DateTime;
            li.ms2DateTimeLocal = Wp.ms2DateTimeLocal;
            li.cleanDate = Wp.cleanDate;
            li.isJSDate = Wp.isJSDate;
            li.formatDate = Wp.formatDate;
            li.incrementMonth = Wp.incrementMonth;
            li.dateTick0 = Wp.dateTick0;
            li.dfltRange = Wp.dfltRange;
            li.findExactDates = Wp.findExactDates;
            li.MIN_MS = Wp.MIN_MS;
            li.MAX_MS = Wp.MAX_MS;
            var db = k6();
            li.findBin = db.findBin;
            li.sorterAsc = db.sorterAsc;
            li.sorterDes = db.sorterDes;
            li.distinctVals = db.distinctVals;
            li.roundUp = db.roundUp;
            li.sort = db.sort;
            li.findIndexOfMin = db.findIndexOfMin;
            li.sortObjectKeys = Y1();
            var by = nie();
            li.aggNums = by.aggNums;
            li.len = by.len;
            li.mean = by.mean;
            li.geometricMean = by.geometricMean;
            li.median = by.median;
            li.midRange = by.midRange;
            li.variance = by.variance;
            li.stdev = by.stdev;
            li.interp = by.interp;
            var yg = m6();
            li.init2dArray = yg.init2dArray;
            li.transposeRagged = yg.transposeRagged;
            li.dot = yg.dot;
            li.translationMatrix = yg.translationMatrix;
            li.rotationMatrix = yg.rotationMatrix;
            li.rotationXYMatrix = yg.rotationXYMatrix;
            li.apply3DTransform = yg.apply3DTransform;
            li.apply2DTransform = yg.apply2DTransform;
            li.apply2DTransform2 = yg.apply2DTransform2;
            li.convertCssMatrix = yg.convertCssMatrix;
            li.inverseTransformMatrix = yg.inverseTransformMatrix;
            var vm = uie();
            li.deg2rad = vm.deg2rad;
            li.rad2deg = vm.rad2deg;
            li.angleDelta = vm.angleDelta;
            li.angleDist = vm.angleDist;
            li.isFullCircle = vm.isFullCircle;
            li.isAngleInsideSector = vm.isAngleInsideSector;
            li.isPtInsideSector = vm.isPtInsideSector;
            li.pathArc = vm.pathArc;
            li.pathSector = vm.pathSector;
            li.pathAnnulus = vm.pathAnnulus;
            var d3 = cie();
            li.isLeftAnchor = d3.isLeftAnchor;
            li.isCenterAnchor = d3.isCenterAnchor;
            li.isRightAnchor = d3.isRightAnchor;
            li.isTopAnchor = d3.isTopAnchor;
            li.isMiddleAnchor = d3.isMiddleAnchor;
            li.isBottomAnchor = d3.isBottomAnchor;
            var v3 = die();
            li.segmentsIntersect = v3.segmentsIntersect;
            li.segmentDistance = v3.segmentDistance;
            li.getTextLocation = v3.getTextLocation;
            li.clearLocationCache = v3.clearLocationCache;
            li.getVisibleSegment = v3.getVisibleSegment;
            li.findPointOnPath = v3.findPointOnPath;
            var z6 = no();
            li.extendFlat = z6.extendFlat;
            li.extendDeep = z6.extendDeep;
            li.extendDeepAll = z6.extendDeepAll;
            li.extendDeepNoArrays = z6.extendDeepNoArrays;
            var Wq = G1();
            li.log = Wq.log;
            li.warn = Wq.warn;
            li.error = Wq.error;
            var Urt = n3();
            li.counterRegex = Urt.counter;
            var Zq = P6();
            li.throttle = Zq.throttle;
            li.throttleDone = Zq.done;
            li.clearThrottle = Zq.clear;
            var _g = DS();
            li.getGraphDiv = _g.getGraphDiv;
            li.isPlotDiv = _g.isPlotDiv;
            li.removeElement = _g.removeElement;
            li.addStyleRule = _g.addStyleRule;
            li.addRelatedStyleRule = _g.addRelatedStyleRule;
            li.deleteRelatedStyleRule = _g.deleteRelatedStyleRule;
            li.setStyleOnHover = _g.setStyleOnHover;
            li.getFullTransformMatrix = _g.getFullTransformMatrix;
            li.getElementTransformMatrix = _g.getElementTransformMatrix;
            li.getElementAndAncestors = _g.getElementAndAncestors;
            li.equalDomRects = _g.equalDomRects;
            li.clearResponsive = gie();
            li.preserveDrawingBuffer = _ie();
            li.makeTraceGroups = bie();
            li._ = Tie();
            li.notifier = Sq();
            li.filterUnique = jq();
            li.filterVisible = Mie();
            li.pushUnique = kq();
            li.increment = kie();
            li.cleanNumber = Lie();
            li.ensureNumber = function(t) {
                return Fie(t) ? (t = Number(t), t > Oie || t < Nrt ? Pie : t) : Pie;
            };
            li.isIndex = function(e, t) {
                return t !== void 0 && e >= t ? !1 : Fie(e) && e >= 0 && e % 1 === 0;
            };
            li.noop = g6();
            li.identity = OS();
            li.repeat = function(e, t) {
                for(var r = new Array(t), n = 0; n < t; n++)r[n] = e;
                return r;
            };
            li.swapAttrs = function(e, t, r, n) {
                r || (r = "x"), n || (n = "y");
                for(var i = 0; i < t.length; i++){
                    var a = t[i], o = li.nestedProperty(e, a.replace("?", r)), s = li.nestedProperty(e, a.replace("?", n)), l = o.get();
                    o.set(s.get()), s.set(l);
                }
            };
            li.raiseToTop = function(t) {
                t.parentNode.appendChild(t);
            };
            li.cancelTransition = function(e) {
                return e.transition().duration(0);
            };
            li.constrain = function(e, t, r) {
                return t > r ? Math.max(r, Math.min(t, e)) : Math.max(t, Math.min(r, e));
            };
            li.bBoxIntersect = function(e, t, r) {
                return r = r || 0, e.left <= t.right + r && t.left <= e.right + r && e.top <= t.bottom + r && t.top <= e.bottom + r;
            };
            li.simpleMap = function(e, t, r, n, i) {
                for(var a = e.length, o = new Array(a), s = 0; s < a; s++)o[s] = t(e[s], r, n, i);
                return o;
            };
            li.randstr = function e(t, r, n, i) {
                if (n || (n = 16), r === void 0 && (r = 24), r <= 0) return "0";
                var a = Math.log(Math.pow(2, r)) / Math.log(n), o = "", s, l, u;
                for(s = 2; a === 1 / 0; s *= 2)a = Math.log(Math.pow(2, r / s)) / Math.log(n) * s;
                var c = a - Math.floor(a);
                for(s = 0; s < Math.floor(a); s++)u = Math.floor(Math.random() * n).toString(n), o = u + o;
                c && (l = Math.pow(n, c), u = Math.floor(Math.random() * l).toString(n), o = u + o);
                var f = parseInt(o, n);
                return t && t[o] || f !== 1 / 0 && f >= Math.pow(2, r) ? i > 10 ? (li.warn("randstr failed uniqueness"), o) : e(t, r, n, (i || 0) + 1) : o;
            };
            li.OptionControl = function(e, t) {
                e || (e = {}), t || (t = "opt");
                var r = {};
                return r.optionList = [], r._newoption = function(n) {
                    n[t] = e, r[n.name] = n, r.optionList.push(n);
                }, r["_" + t] = e, r;
            };
            li.smooth = function(e, t) {
                if (t = Math.round(t) || 0, t < 2) return e;
                var r = e.length, n = 2 * r, i = 2 * t - 1, a = new Array(i), o = new Array(r), s, l, u, c;
                for(s = 0; s < i; s++)a[s] = (1 - Math.cos(Math.PI * (s + 1) / t)) / (2 * t);
                for(s = 0; s < r; s++){
                    for(c = 0, l = 0; l < i; l++)u = s + l + 1 - t, u < -r ? u -= n * Math.round(u / n) : u >= n && (u -= n * Math.floor(u / n)), u < 0 ? u = -1 - u : u >= r && (u = n - 1 - u), c += e[u] * a[l];
                    o[s] = c;
                }
                return o;
            };
            li.syncOrAsync = function(e, t, r) {
                var n, i;
                function a() {
                    return li.syncOrAsync(e, t, r);
                }
                for(; e.length;)if (i = e.splice(0, 1)[0], n = i(t), n && n.then) return n.then(a);
                return r && r(t);
            };
            li.stripTrailingSlash = function(e) {
                return e.substr(-1) === "/" ? e.substr(0, e.length - 1) : e;
            };
            li.noneOrAll = function(e, t, r) {
                if (e) {
                    var n = !1, i = !0, a, o;
                    for(a = 0; a < r.length; a++)o = e[r[a]], o != null ? n = !0 : i = !1;
                    if (n && !i) for(a = 0; a < r.length; a++)e[r[a]] = t[r[a]];
                }
            };
            li.mergeArray = function(e, t, r, n) {
                var i = typeof n == "function";
                if (li.isArrayOrTypedArray(e)) for(var a = Math.min(e.length, t.length), o = 0; o < a; o++){
                    var s = e[o];
                    t[o][r] = i ? n(s) : s;
                }
            };
            li.mergeArrayCastPositive = function(e, t, r) {
                return li.mergeArray(e, t, r, function(n) {
                    var i = +n;
                    return isFinite(i) && i > 0 ? i : 0;
                });
            };
            li.fillArray = function(e, t, r, n) {
                if (n = n || li.identity, li.isArrayOrTypedArray(e)) for(var i = 0; i < t.length; i++)t[i][r] = n(e[i]);
            };
            li.castOption = function(e, t, r, n) {
                n = n || li.identity;
                var i = li.nestedProperty(e, r).get();
                return li.isArrayOrTypedArray(i) ? Array.isArray(t) && li.isArrayOrTypedArray(i[t[0]]) ? n(i[t[0]][t[1]]) : n(i[t]) : i;
            };
            li.extractOption = function(e, t, r, n) {
                if (r in e) return e[r];
                var i = li.nestedProperty(t, n).get();
                if (!Array.isArray(i)) return i;
            };
            function Nie(e) {
                var t = {};
                for(var r in e)for(var n = e[r], i = 0; i < n.length; i++)t[n[i]] = +r;
                return t;
            }
            li.tagSelected = function(e, t, r) {
                var n = t.selectedpoints, i = t._indexToPoints, a;
                i && (a = Nie(i));
                function o(f) {
                    return f !== void 0 && f < e.length;
                }
                for(var s = 0; s < n.length; s++){
                    var l = n[s];
                    if (li.isIndex(l) || li.isArrayOrTypedArray(l) && li.isIndex(l[0]) && li.isIndex(l[1])) {
                        var u = a ? a[l] : l, c = r ? r[u] : u;
                        o(c) && (e[c].selected = 1);
                    }
                }
            };
            li.selIndices2selPoints = function(e) {
                var t = e.selectedpoints, r = e._indexToPoints;
                if (r) {
                    for(var n = Nie(r), i = [], a = 0; a < t.length; a++){
                        var o = t[a];
                        if (li.isIndex(o)) {
                            var s = n[o];
                            li.isIndex(s) && i.push(s);
                        }
                    }
                    return i;
                } else return t;
            };
            li.getTargetArray = function(e, t) {
                var r = t.target;
                if (typeof r == "string" && r) {
                    var n = li.nestedProperty(e, r).get();
                    return li.isArrayOrTypedArray(n) ? n : !1;
                } else if (li.isArrayOrTypedArray(r)) return r;
                return !1;
            };
            function Uie(e, t, r) {
                var n = {};
                typeof t != "object" && (t = {});
                var i = r === "pieLike" ? -1 : 3, a = Object.keys(e), o, s, l;
                for(o = 0; o < a.length; o++)s = a[o], l = e[s], !(s.charAt(0) === "_" || typeof l == "function") && (s === "module" ? n[s] = l : Array.isArray(l) ? s === "colorscale" || i === -1 ? n[s] = l.slice() : n[s] = l.slice(0, i) : li.isTypedArray(l) ? i === -1 ? n[s] = l.subarray() : n[s] = l.subarray(0, i) : l && typeof l == "object" ? n[s] = Uie(e[s], t[s], r) : n[s] = l);
                for(a = Object.keys(t), o = 0; o < a.length; o++)s = a[o], l = t[s], (typeof l != "object" || !(s in n) || typeof n[s] != "object") && (n[s] = l);
                return n;
            }
            li.minExtend = Uie;
            li.titleCase = function(e) {
                return e.charAt(0).toUpperCase() + e.substr(1);
            };
            li.containsAny = function(e, t) {
                for(var r = 0; r < t.length; r++)if (e.indexOf(t[r]) !== -1) return !0;
                return !1;
            };
            var Vrt = /Version\/[\d\.]+.*Safari/;
            li.isSafari = function() {
                return Vrt.test(window.navigator.userAgent);
            };
            var Hrt = /iPad|iPhone|iPod/;
            li.isIOS = function() {
                return Hrt.test(window.navigator.userAgent);
            };
            var Grt = /Firefox\/(\d+)\.\d+/;
            li.getFirefoxVersion = function() {
                var e = Grt.exec(window.navigator.userAgent);
                if (e && e.length === 2) {
                    var t = parseInt(e[1]);
                    if (!isNaN(t)) return t;
                }
                return null;
            };
            li.isD3Selection = function(e) {
                return e instanceof VS.selection;
            };
            li.ensureSingle = function(e, t, r, n) {
                var i = e.select(t + (r ? "." + r : ""));
                if (i.size()) return i;
                var a = e.append(t);
                return r && a.classed(r, !0), n && a.call(n), a;
            };
            li.ensureSingleById = function(e, t, r, n) {
                var i = e.select(t + "#" + r);
                if (i.size()) return i;
                var a = e.append(t).attr("id", r);
                return n && a.call(n), a;
            };
            li.objectFromPath = function(e, t) {
                for(var r = e.split("."), n, i = n = {}, a = 0; a < r.length; a++){
                    var o = r[a], s = null, l = r[a].match(/(.*)\[([0-9]+)\]/);
                    l ? (o = l[1], s = l[2], n = n[o] = [], a === r.length - 1 ? n[s] = t : n[s] = {}, n = n[s]) : (a === r.length - 1 ? n[o] = t : n[o] = {}, n = n[o]);
                }
                return i;
            };
            var jrt = /^([^\[\.]+)\.(.+)?/, Wrt = /^([^\.]+)\[([0-9]+)\](\.)?(.+)?/;
            function R6(e) {
                return e.slice(0, 2) === "__";
            }
            li.expandObjectPaths = function(e) {
                var t, r, n, i, a, o, s;
                if (typeof e == "object" && !Array.isArray(e)) {
                    for(r in e)if (e.hasOwnProperty(r)) {
                        if (t = r.match(jrt)) {
                            if (i = e[r], n = t[1], R6(n)) continue;
                            delete e[r], e[n] = li.extendDeepNoArrays(e[n] || {}, li.objectFromPath(r, li.expandObjectPaths(i))[n]);
                        } else if (t = r.match(Wrt)) {
                            if (i = e[r], n = t[1], R6(n)) continue;
                            if (a = parseInt(t[2]), delete e[r], e[n] = e[n] || [], t[3] === ".") s = t[4], o = e[n][a] = e[n][a] || {}, li.extendDeepNoArrays(o, li.objectFromPath(s, li.expandObjectPaths(i)));
                            else {
                                if (R6(n)) continue;
                                e[n][a] = li.expandObjectPaths(i);
                            }
                        } else {
                            if (R6(r)) continue;
                            e[r] = li.expandObjectPaths(e[r]);
                        }
                    }
                }
                return e;
            };
            li.numSeparate = function(e, t, r) {
                if (r || (r = !1), typeof t != "string" || t.length === 0) throw new Error("Separator string required for formatting!");
                typeof e == "number" && (e = String(e));
                var n = /(\d+)(\d{3})/, i = t.charAt(0), a = t.charAt(1), o = e.split("."), s = o[0], l = o.length > 1 ? i + o[1] : "";
                if (a && (o.length > 1 || s.length > 4 || r)) for(; n.test(s);)s = s.replace(n, "$1" + a + "$2");
                return s + l;
            };
            li.TEMPLATE_STRING_REGEX = /%{([^\s%{}:]*)([:|\|][^}]*)?}/g;
            var Vie = /^\w*$/;
            li.templateString = function(e, t) {
                var r = {};
                return e.replace(li.TEMPLATE_STRING_REGEX, function(n, i) {
                    var a;
                    return Vie.test(i) ? a = t[i] : (r[i] = r[i] || li.nestedProperty(t, i).get, a = r[i](!0)), a !== void 0 ? a : "";
                });
            };
            var Zrt = {
                max: 10,
                count: 0,
                name: "hovertemplate"
            };
            li.hovertemplateString = function() {
                return Xq.apply(Zrt, arguments);
            };
            var Xrt = {
                max: 10,
                count: 0,
                name: "texttemplate"
            };
            li.texttemplateString = function() {
                return Xq.apply(Xrt, arguments);
            };
            var Yrt = /^(\S+)([\*\/])(-?\d+(\.\d+)?)$/;
            function Krt(e) {
                var t = e.match(Yrt);
                return t ? {
                    key: t[1],
                    op: t[2],
                    number: Number(t[3])
                } : {
                    key: e,
                    op: null,
                    number: null
                };
            }
            var Jrt = {
                max: 10,
                count: 0,
                name: "texttemplate",
                parseMultDiv: !0
            };
            li.texttemplateStringForShapes = function() {
                return Xq.apply(Jrt, arguments);
            };
            var Rie = /^[:|\|]/;
            function Xq(e, t, r) {
                var n = this, i = arguments;
                return t || (t = {}), e.replace(li.TEMPLATE_STRING_REGEX, function(a, o, s) {
                    var l = o === "xother" || o === "yother", u = o === "_xother" || o === "_yother", c = o === "_xother_" || o === "_yother_", f = o === "xother_" || o === "yother_", h = l || u || f || c, d = o;
                    (u || c) && (d = d.substring(1)), (f || c) && (d = d.substring(0, d.length - 1));
                    var v = null, x = null;
                    if (n.parseMultDiv) {
                        var b = Krt(d);
                        d = b.key, v = b.op, x = b.number;
                    }
                    var p;
                    if (h) {
                        if (p = t[d], p === void 0) return "";
                    } else {
                        var E, k;
                        for(k = 3; k < i.length; k++)if (E = i[k], !!E) {
                            if (E.hasOwnProperty(d)) {
                                p = E[d];
                                break;
                            }
                            if (Vie.test(d) || (p = li.nestedProperty(E, d).get(!0)), p !== void 0) break;
                        }
                    }
                    if (p !== void 0 && (v === "*" && (p *= x), v === "/" && (p /= x)), p === void 0 && n) return n.count < n.max && (li.warn("Variable '" + d + "' in " + n.name + " could not be found!"), p = a), n.count === n.max && li.warn("Too many " + n.name + " warnings - additional warnings will be suppressed"), n.count++, a;
                    if (s) {
                        var A;
                        if (s[0] === ":" && (A = r ? r.numberFormat : li.numberFormat, p !== "" && (p = A(s.replace(Rie, ""))(p))), s[0] === "|") {
                            A = r ? r.timeFormat : Ort;
                            var L = li.dateTime2ms(p);
                            p = li.formatDate(L, s.replace(Rie, ""), !1, A);
                        }
                    } else {
                        var _ = d + "Label";
                        t.hasOwnProperty(_) && (p = t[_]);
                    }
                    return h && (p = "(" + p + ")", (u || c) && (p = " " + p), (f || c) && (p = p + " ")), p;
                });
            }
            var D6 = 48, Die = 57;
            li.subplotSort = function(e, t) {
                for(var r = Math.min(e.length, t.length) + 1, n = 0, i = 0, a = 0; a < r; a++){
                    var o = e.charCodeAt(a) || 0, s = t.charCodeAt(a) || 0, l = o >= D6 && o <= Die, u = s >= D6 && s <= Die;
                    if (l && (n = 10 * n + o - D6), u && (i = 10 * i + s - D6), !l || !u) {
                        if (n !== i) return n - i;
                        if (o !== s) return o - s;
                    }
                }
                return i - n;
            };
            var h3 = 2e9;
            li.seedPseudoRandom = function() {
                h3 = 2e9;
            };
            li.pseudoRandom = function() {
                var e = h3;
                return h3 = (69069 * h3 + 1) % 4294967296, Math.abs(h3 - e) < 429496729 ? li.pseudoRandom() : h3 / 4294967296;
            };
            li.fillText = function(e, t, r) {
                var n = Array.isArray(r) ? function(o) {
                    r.push(o);
                } : function(o) {
                    r.text = o;
                }, i = li.extractOption(e, t, "htx", "hovertext");
                if (li.isValidTextValue(i)) return n(i);
                var a = li.extractOption(e, t, "tx", "text");
                if (li.isValidTextValue(a)) return n(a);
            };
            li.isValidTextValue = function(e) {
                return e || e === 0;
            };
            li.formatPercent = function(e, t) {
                t = t || 0;
                for(var r = (Math.round(100 * e * Math.pow(10, t)) * Math.pow(.1, t)).toFixed(t) + "%", n = 0; n < t; n++)r.indexOf(".") !== -1 && (r = r.replace("0%", "%"), r = r.replace(".%", "%"));
                return r;
            };
            li.isHidden = function(e) {
                var t = window.getComputedStyle(e).display;
                return !t || t === "none";
            };
            li.strTranslate = function(e, t) {
                return e || t ? "translate(" + e + "," + t + ")" : "";
            };
            li.strRotate = function(e) {
                return e ? "rotate(" + e + ")" : "";
            };
            li.strScale = function(e) {
                return e !== 1 ? "scale(" + e + ")" : "";
            };
            li.getTextTransform = function(e) {
                var t = e.noCenter, r = e.textX, n = e.textY, i = e.targetX, a = e.targetY, o = e.anchorX || 0, s = e.anchorY || 0, l = e.rotate, u = e.scale;
                return u ? u > 1 && (u = 1) : u = 0, li.strTranslate(i - u * (r + o), a - u * (n + s)) + li.strScale(u) + (l ? "rotate(" + l + (t ? "" : " " + r + " " + n) + ")" : "");
            };
            li.setTransormAndDisplay = function(e, t) {
                e.attr("transform", li.getTextTransform(t)), e.style("display", t.scale ? null : "none");
            };
            li.ensureUniformFontSize = function(e, t) {
                var r = li.extendFlat({}, t);
                return r.size = Math.max(t.size, e._fullLayout.uniformtext.minsize || 0), r;
            };
            li.join2 = function(e, t, r) {
                var n = e.length;
                return n > 1 ? e.slice(0, -1).join(t) + r + e[n - 1] : e.join(t);
            };
            li.bigFont = function(e) {
                return Math.round(1.2 * e);
            };
            var zie = li.getFirefoxVersion(), $rt = zie !== null && zie < 86;
            li.getPositionFromD3Event = function() {
                return $rt ? [
                    VS.event.layerX,
                    VS.event.layerY
                ] : [
                    VS.event.offsetX,
                    VS.event.offsetY
                ];
            };
        });
        var Wie = ye(()=>{
            "use strict";
            var Qrt = Mr(), Gie = {
                "X,X div": 'direction:ltr;font-family:"Open Sans",verdana,arial,sans-serif;margin:0;padding:0;',
                "X input,X button": 'font-family:"Open Sans",verdana,arial,sans-serif;',
                "X input:focus,X button:focus": "outline:none;",
                "X a": "text-decoration:none;",
                "X a:hover": "text-decoration:none;",
                "X .crisp": "shape-rendering:crispEdges;",
                "X .user-select-none": "-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-o-user-select:none;user-select:none;",
                "X svg a": "fill:#447adb;",
                "X svg a:hover": "fill:#3c6dc5;",
                "X .main-svg": "position:absolute;top:0;left:0;pointer-events:none;",
                "X .main-svg .draglayer": "pointer-events:all;",
                "X .cursor-default": "cursor:default;",
                "X .cursor-pointer": "cursor:pointer;",
                "X .cursor-crosshair": "cursor:crosshair;",
                "X .cursor-move": "cursor:move;",
                "X .cursor-col-resize": "cursor:col-resize;",
                "X .cursor-row-resize": "cursor:row-resize;",
                "X .cursor-ns-resize": "cursor:ns-resize;",
                "X .cursor-ew-resize": "cursor:ew-resize;",
                "X .cursor-sw-resize": "cursor:sw-resize;",
                "X .cursor-s-resize": "cursor:s-resize;",
                "X .cursor-se-resize": "cursor:se-resize;",
                "X .cursor-w-resize": "cursor:w-resize;",
                "X .cursor-e-resize": "cursor:e-resize;",
                "X .cursor-nw-resize": "cursor:nw-resize;",
                "X .cursor-n-resize": "cursor:n-resize;",
                "X .cursor-ne-resize": "cursor:ne-resize;",
                "X .cursor-grab": "cursor:-webkit-grab;cursor:grab;",
                "X .modebar": "position:absolute;top:2px;right:2px;",
                "X .ease-bg": "-webkit-transition:background-color .3s ease 0s;-moz-transition:background-color .3s ease 0s;-ms-transition:background-color .3s ease 0s;-o-transition:background-color .3s ease 0s;transition:background-color .3s ease 0s;",
                "X .modebar--hover>:not(.watermark)": "opacity:0;-webkit-transition:opacity .3s ease 0s;-moz-transition:opacity .3s ease 0s;-ms-transition:opacity .3s ease 0s;-o-transition:opacity .3s ease 0s;transition:opacity .3s ease 0s;",
                "X:hover .modebar--hover .modebar-group": "opacity:1;",
                "X .modebar-group": "float:left;display:inline-block;box-sizing:border-box;padding-left:8px;position:relative;vertical-align:middle;white-space:nowrap;",
                "X .modebar-btn": "position:relative;font-size:16px;padding:3px 4px;height:22px;cursor:pointer;line-height:normal;box-sizing:border-box;",
                "X .modebar-btn svg": "position:relative;top:2px;",
                "X .modebar.vertical": "display:flex;flex-direction:column;flex-wrap:wrap;align-content:flex-end;max-height:100%;",
                "X .modebar.vertical svg": "top:-1px;",
                "X .modebar.vertical .modebar-group": "display:block;float:none;padding-left:0px;padding-bottom:8px;",
                "X .modebar.vertical .modebar-group .modebar-btn": "display:block;text-align:center;",
                "X [data-title]:before,X [data-title]:after": "position:absolute;-webkit-transform:translate3d(0, 0, 0);-moz-transform:translate3d(0, 0, 0);-ms-transform:translate3d(0, 0, 0);-o-transform:translate3d(0, 0, 0);transform:translate3d(0, 0, 0);display:none;opacity:0;z-index:1001;pointer-events:none;top:110%;right:50%;",
                "X [data-title]:hover:before,X [data-title]:hover:after": "display:block;opacity:1;",
                "X [data-title]:before": 'content:"";position:absolute;background:rgba(0,0,0,0);border:6px solid rgba(0,0,0,0);z-index:1002;margin-top:-12px;border-bottom-color:#69738a;margin-right:-6px;',
                "X [data-title]:after": "content:attr(data-title);background:#69738a;color:#fff;padding:8px 10px;font-size:12px;line-height:12px;white-space:nowrap;margin-right:-18px;border-radius:2px;",
                "X .vertical [data-title]:before,X .vertical [data-title]:after": "top:0%;right:200%;",
                "X .vertical [data-title]:before": "border:6px solid rgba(0,0,0,0);border-left-color:#69738a;margin-top:8px;margin-right:-30px;",
                Y: 'font-family:"Open Sans",verdana,arial,sans-serif;position:fixed;top:50px;right:20px;z-index:10000;font-size:10pt;max-width:180px;',
                "Y p": "margin:0;",
                "Y .notifier-note": "min-width:180px;max-width:250px;border:1px solid #fff;z-index:3000;margin:0;background-color:#8c97af;background-color:rgba(140,151,175,.9);color:#fff;padding:10px;overflow-wrap:break-word;word-wrap:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto;",
                "Y .notifier-close": "color:#fff;opacity:.8;float:right;padding:0 5px;background:none;border:none;font-size:20px;font-weight:bold;line-height:20px;",
                "Y .notifier-close:hover": "color:#444;text-decoration:none;cursor:pointer;"
            };
            for(Yq in Gie)jie = Yq.replace(/^,/, " ,").replace(/X/g, ".js-plotly-plot .plotly").replace(/Y/g, ".plotly-notifier"), Qrt.addStyleRule(jie, Gie[Yq]);
            var jie, Yq;
        });
        var Kq = ye((ktr, Zie)=>{
            Zie.exports = !0;
        });
        var $q = ye((Ctr, Xie)=>{
            "use strict";
            var eit = Kq(), Jq;
            typeof window.matchMedia == "function" ? Jq = !window.matchMedia("(hover: none)").matches : Jq = eit;
            Xie.exports = Jq;
        });
        var vb = ye((Ltr, Qq)=>{
            "use strict";
            var p3 = typeof Reflect == "object" ? Reflect : null, Yie = p3 && typeof p3.apply == "function" ? p3.apply : function(t, r, n) {
                return Function.prototype.apply.call(t, r, n);
            }, F6;
            p3 && typeof p3.ownKeys == "function" ? F6 = p3.ownKeys : Object.getOwnPropertySymbols ? F6 = function(t) {
                return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t));
            } : F6 = function(t) {
                return Object.getOwnPropertyNames(t);
            };
            function tit(e) {
                console && console.warn && console.warn(e);
            }
            var Jie = Number.isNaN || function(t) {
                return t !== t;
            };
            function Tc() {
                Tc.init.call(this);
            }
            Qq.exports = Tc;
            Qq.exports.once = ait;
            Tc.EventEmitter = Tc;
            Tc.prototype._events = void 0;
            Tc.prototype._eventsCount = 0;
            Tc.prototype._maxListeners = void 0;
            var Kie = 10;
            function q6(e) {
                if (typeof e != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
            }
            Object.defineProperty(Tc, "defaultMaxListeners", {
                enumerable: !0,
                get: function() {
                    return Kie;
                },
                set: function(e) {
                    if (typeof e != "number" || e < 0 || Jie(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
                    Kie = e;
                }
            });
            Tc.init = function() {
                (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
            };
            Tc.prototype.setMaxListeners = function(t) {
                if (typeof t != "number" || t < 0 || Jie(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
                return this._maxListeners = t, this;
            };
            function $ie(e) {
                return e._maxListeners === void 0 ? Tc.defaultMaxListeners : e._maxListeners;
            }
            Tc.prototype.getMaxListeners = function() {
                return $ie(this);
            };
            Tc.prototype.emit = function(t) {
                for(var r = [], n = 1; n < arguments.length; n++)r.push(arguments[n]);
                var i = t === "error", a = this._events;
                if (a !== void 0) i = i && a.error === void 0;
                else if (!i) return !1;
                if (i) {
                    var o;
                    if (r.length > 0 && (o = r[0]), o instanceof Error) throw o;
                    var s = new Error("Unhandled error." + (o ? " (" + o.message + ")" : ""));
                    throw s.context = o, s;
                }
                var l = a[t];
                if (l === void 0) return !1;
                if (typeof l == "function") Yie(l, this, r);
                else for(var u = l.length, c = ine(l, u), n = 0; n < u; ++n)Yie(c[n], this, r);
                return !0;
            };
            function Qie(e, t, r, n) {
                var i, a, o;
                if (q6(r), a = e._events, a === void 0 ? (a = e._events = Object.create(null), e._eventsCount = 0) : (a.newListener !== void 0 && (e.emit("newListener", t, r.listener ? r.listener : r), a = e._events), o = a[t]), o === void 0) o = a[t] = r, ++e._eventsCount;
                else if (typeof o == "function" ? o = a[t] = n ? [
                    r,
                    o
                ] : [
                    o,
                    r
                ] : n ? o.unshift(r) : o.push(r), i = $ie(e), i > 0 && o.length > i && !o.warned) {
                    o.warned = !0;
                    var s = new Error("Possible EventEmitter memory leak detected. " + o.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
                    s.name = "MaxListenersExceededWarning", s.emitter = e, s.type = t, s.count = o.length, tit(s);
                }
                return e;
            }
            Tc.prototype.addListener = function(t, r) {
                return Qie(this, t, r, !1);
            };
            Tc.prototype.on = Tc.prototype.addListener;
            Tc.prototype.prependListener = function(t, r) {
                return Qie(this, t, r, !0);
            };
            function rit() {
                if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
            }
            function ene(e, t, r) {
                var n = {
                    fired: !1,
                    wrapFn: void 0,
                    target: e,
                    type: t,
                    listener: r
                }, i = rit.bind(n);
                return i.listener = r, n.wrapFn = i, i;
            }
            Tc.prototype.once = function(t, r) {
                return q6(r), this.on(t, ene(this, t, r)), this;
            };
            Tc.prototype.prependOnceListener = function(t, r) {
                return q6(r), this.prependListener(t, ene(this, t, r)), this;
            };
            Tc.prototype.removeListener = function(t, r) {
                var n, i, a, o, s;
                if (q6(r), i = this._events, i === void 0) return this;
                if (n = i[t], n === void 0) return this;
                if (n === r || n.listener === r) --this._eventsCount === 0 ? this._events = Object.create(null) : (delete i[t], i.removeListener && this.emit("removeListener", t, n.listener || r));
                else if (typeof n != "function") {
                    for(a = -1, o = n.length - 1; o >= 0; o--)if (n[o] === r || n[o].listener === r) {
                        s = n[o].listener, a = o;
                        break;
                    }
                    if (a < 0) return this;
                    a === 0 ? n.shift() : iit(n, a), n.length === 1 && (i[t] = n[0]), i.removeListener !== void 0 && this.emit("removeListener", t, s || r);
                }
                return this;
            };
            Tc.prototype.off = Tc.prototype.removeListener;
            Tc.prototype.removeAllListeners = function(t) {
                var r, n, i;
                if (n = this._events, n === void 0) return this;
                if (n.removeListener === void 0) return arguments.length === 0 ? (this._events = Object.create(null), this._eventsCount = 0) : n[t] !== void 0 && (--this._eventsCount === 0 ? this._events = Object.create(null) : delete n[t]), this;
                if (arguments.length === 0) {
                    var a = Object.keys(n), o;
                    for(i = 0; i < a.length; ++i)o = a[i], o !== "removeListener" && this.removeAllListeners(o);
                    return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
                }
                if (r = n[t], typeof r == "function") this.removeListener(t, r);
                else if (r !== void 0) for(i = r.length - 1; i >= 0; i--)this.removeListener(t, r[i]);
                return this;
            };
            function tne(e, t, r) {
                var n = e._events;
                if (n === void 0) return [];
                var i = n[t];
                return i === void 0 ? [] : typeof i == "function" ? r ? [
                    i.listener || i
                ] : [
                    i
                ] : r ? nit(i) : ine(i, i.length);
            }
            Tc.prototype.listeners = function(t) {
                return tne(this, t, !0);
            };
            Tc.prototype.rawListeners = function(t) {
                return tne(this, t, !1);
            };
            Tc.listenerCount = function(e, t) {
                return typeof e.listenerCount == "function" ? e.listenerCount(t) : rne.call(e, t);
            };
            Tc.prototype.listenerCount = rne;
            function rne(e) {
                var t = this._events;
                if (t !== void 0) {
                    var r = t[e];
                    if (typeof r == "function") return 1;
                    if (r !== void 0) return r.length;
                }
                return 0;
            }
            Tc.prototype.eventNames = function() {
                return this._eventsCount > 0 ? F6(this._events) : [];
            };
            function ine(e, t) {
                for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e[n];
                return r;
            }
            function iit(e, t) {
                for(; t + 1 < e.length; t++)e[t] = e[t + 1];
                e.pop();
            }
            function nit(e) {
                for(var t = new Array(e.length), r = 0; r < t.length; ++r)t[r] = e[r].listener || e[r];
                return t;
            }
            function ait(e, t) {
                return new Promise(function(r, n) {
                    function i(o) {
                        e.removeListener(t, a), n(o);
                    }
                    function a() {
                        typeof e.removeListener == "function" && e.removeListener("error", i), r([].slice.call(arguments));
                    }
                    nne(e, t, a, {
                        once: !0
                    }), t !== "error" && oit(e, i, {
                        once: !0
                    });
                });
            }
            function oit(e, t, r) {
                typeof e.on == "function" && nne(e, "error", t, r);
            }
            function nne(e, t, r, n) {
                if (typeof e.on == "function") n.once ? e.once(t, r) : e.on(t, r);
                else if (typeof e.addEventListener == "function") e.addEventListener(t, function i(a) {
                    n.once && e.removeEventListener(t, i), r(a);
                });
                else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
            }
        });
        var g3 = ye((Ptr, ane)=>{
            "use strict";
            var eO = vb().EventEmitter, sit = {
                init: function(e) {
                    if (e._ev instanceof eO) return e;
                    var t = new eO, r = new eO;
                    return e._ev = t, e._internalEv = r, e.on = t.on.bind(t), e.once = t.once.bind(t), e.removeListener = t.removeListener.bind(t), e.removeAllListeners = t.removeAllListeners.bind(t), e._internalOn = r.on.bind(r), e._internalOnce = r.once.bind(r), e._removeInternalListener = r.removeListener.bind(r), e._removeAllInternalListeners = r.removeAllListeners.bind(r), e.emit = function(n, i) {
                        t.emit(n, i), r.emit(n, i);
                    }, e;
                },
                triggerHandler: function(e, t, r) {
                    var n, i = e._ev;
                    if (!i) return;
                    var a = i._events[t];
                    if (!a) return;
                    function o(l) {
                        if (l.listener) {
                            if (i.removeListener(t, l.listener), !l.fired) return l.fired = !0, l.listener.apply(i, [
                                r
                            ]);
                        } else return l.apply(i, [
                            r
                        ]);
                    }
                    a = Array.isArray(a) ? a : [
                        a
                    ];
                    var s;
                    for(s = 0; s < a.length - 1; s++)o(a[s]);
                    return n = o(a[s]), n;
                },
                purge: function(e) {
                    return delete e._ev, delete e.on, delete e.once, delete e.removeListener, delete e.removeAllListeners, delete e.emit, delete e._ev, delete e._internalEv, delete e._internalOn, delete e._internalOnce, delete e._removeInternalListener, delete e._removeAllInternalListeners, e;
                }
            };
            ane.exports = sit;
        });
        var lne = ye((Itr, sne)=>{
            "use strict";
            var one = Mr(), lit = ub().dfltConfig;
            function uit(e, t) {
                for(var r = [], n, i = 0; i < t.length; i++)n = t[i], n === e ? r[i] = n : typeof n == "object" ? r[i] = Array.isArray(n) ? one.extendDeep([], n) : one.extendDeepAll({}, n) : r[i] = n;
                return r;
            }
            var wy = {};
            wy.add = function(e, t, r, n, i) {
                var a, o;
                if (e.undoQueue = e.undoQueue || {
                    index: 0,
                    queue: [],
                    sequence: !1
                }, o = e.undoQueue.index, e.autoplay) {
                    e.undoQueue.inSequence || (e.autoplay = !1);
                    return;
                }
                !e.undoQueue.sequence || e.undoQueue.beginSequence ? (a = {
                    undo: {
                        calls: [],
                        args: []
                    },
                    redo: {
                        calls: [],
                        args: []
                    }
                }, e.undoQueue.queue.splice(o, e.undoQueue.queue.length - o, a), e.undoQueue.index += 1) : a = e.undoQueue.queue[o - 1], e.undoQueue.beginSequence = !1, a && (a.undo.calls.unshift(t), a.undo.args.unshift(r), a.redo.calls.push(n), a.redo.args.push(i)), e.undoQueue.queue.length > lit.queueLength && (e.undoQueue.queue.shift(), e.undoQueue.index--);
            };
            wy.startSequence = function(e) {
                e.undoQueue = e.undoQueue || {
                    index: 0,
                    queue: [],
                    sequence: !1
                }, e.undoQueue.sequence = !0, e.undoQueue.beginSequence = !0;
            };
            wy.stopSequence = function(e) {
                e.undoQueue = e.undoQueue || {
                    index: 0,
                    queue: [],
                    sequence: !1
                }, e.undoQueue.sequence = !1, e.undoQueue.beginSequence = !1;
            };
            wy.undo = function(t) {
                var r, n;
                if (!(t.undoQueue === void 0 || isNaN(t.undoQueue.index) || t.undoQueue.index <= 0)) {
                    for(t.undoQueue.index--, r = t.undoQueue.queue[t.undoQueue.index], t.undoQueue.inSequence = !0, n = 0; n < r.undo.calls.length; n++)wy.plotDo(t, r.undo.calls[n], r.undo.args[n]);
                    t.undoQueue.inSequence = !1, t.autoplay = !1;
                }
            };
            wy.redo = function(t) {
                var r, n;
                if (!(t.undoQueue === void 0 || isNaN(t.undoQueue.index) || t.undoQueue.index >= t.undoQueue.queue.length)) {
                    for(r = t.undoQueue.queue[t.undoQueue.index], t.undoQueue.inSequence = !0, n = 0; n < r.redo.calls.length; n++)wy.plotDo(t, r.redo.calls[n], r.redo.args[n]);
                    t.undoQueue.inSequence = !1, t.autoplay = !1, t.undoQueue.index++;
                }
            };
            wy.plotDo = function(e, t, r) {
                e.autoplay = !0, r = uit(e, r), t.apply(null, r);
            };
            sne.exports = wy;
        });
        var tO = ye((Rtr, une)=>{
            "use strict";
            une.exports = {
                _isLinkedToArray: "frames_entry",
                group: {
                    valType: "string"
                },
                name: {
                    valType: "string"
                },
                traces: {
                    valType: "any"
                },
                baseframe: {
                    valType: "string"
                },
                data: {
                    valType: "any"
                },
                layout: {
                    valType: "any"
                }
            };
        });
        var _3 = ye((Bh)=>{
            "use strict";
            var x0 = ba(), HS = Mr(), B6 = vl(), rO = s3(), cit = tO(), fit = zS(), hit = ub().configAttributes, cne = Bu(), xg = HS.extendDeepAll, m3 = HS.isPlainObject, dit = HS.isArrayOrTypedArray, N6 = HS.nestedProperty, vit = HS.valObjectMeta, iO = "_isSubplotObj", U6 = "_isLinkedToArray", pit = "_arrayAttrRegexps", hne = "_deprecated", nO = [
                iO,
                U6,
                pit,
                hne
            ];
            Bh.IS_SUBPLOT_OBJ = iO;
            Bh.IS_LINKED_TO_ARRAY = U6;
            Bh.DEPRECATED = hne;
            Bh.UNDERSCORE_ATTRS = nO;
            Bh.get = function() {
                var e = {};
                return x0.allTypes.forEach(function(t) {
                    e[t] = mit(t);
                }), {
                    defs: {
                        valObjects: vit,
                        metaKeys: nO.concat([
                            "description",
                            "role",
                            "editType",
                            "impliedEdits"
                        ]),
                        editType: {
                            traces: cne.traces,
                            layout: cne.layout
                        },
                        impliedEdits: {}
                    },
                    traces: e,
                    layout: yit(),
                    frames: _it(),
                    animation: y3(fit),
                    config: y3(hit)
                };
            };
            Bh.crawl = function(e, t, r, n) {
                var i = r || 0;
                n = n || "", Object.keys(e).forEach(function(a) {
                    var o = e[a];
                    if (nO.indexOf(a) === -1) {
                        var s = (n ? n + "." : "") + a;
                        t(o, a, e, i, s), !Bh.isValObject(o) && m3(o) && a !== "impliedEdits" && Bh.crawl(o, t, i + 1, s);
                    }
                });
            };
            Bh.isValObject = function(e) {
                return e && e.valType !== void 0;
            };
            Bh.findArrayAttributes = function(e) {
                var t = [], r = [], n = [], i, a;
                function o(l, u, c, f) {
                    r = r.slice(0, f).concat([
                        u
                    ]), n = n.slice(0, f).concat([
                        l && l._isLinkedToArray
                    ]);
                    var h = l && (l.valType === "data_array" || l.arrayOk === !0) && !(r[f - 1] === "colorbar" && (u === "ticktext" || u === "tickvals"));
                    h && s(i, 0, "");
                }
                function s(l, u, c) {
                    var f = l[r[u]], h = c + r[u];
                    if (u === r.length - 1) dit(f) && t.push(a + h);
                    else if (n[u]) {
                        if (Array.isArray(f)) for(var d = 0; d < f.length; d++)m3(f[d]) && s(f[d], u + 1, h + "[" + d + "].");
                    } else m3(f) && s(f, u + 1, h + ".");
                }
                return i = e, a = "", Bh.crawl(B6, o), e._module && e._module.attributes && Bh.crawl(e._module.attributes, o), t;
            };
            Bh.getTraceValObject = function(e, t) {
                var r = t[0], n = 1, i, a, o = e._module;
                if (o || (o = (x0.modules[e.type || B6.type.dflt] || {})._module), !o) return !1;
                if (i = o.attributes, a = i && i[r], !a) {
                    var s = o.basePlotModule;
                    s && s.attributes && (a = s.attributes[r]);
                }
                return a || (a = B6[r]), dne(a, t, n);
            };
            Bh.getLayoutValObject = function(e, t) {
                var r = git(e, t[0]);
                return dne(r, t, 1);
            };
            function git(e, t) {
                var r, n, i, a, o = e._basePlotModules;
                if (o) {
                    var s;
                    for(r = 0; r < o.length; r++){
                        if (i = o[r], i.attrRegex && i.attrRegex.test(t)) {
                            if (i.layoutAttrOverrides) return i.layoutAttrOverrides;
                            !s && i.layoutAttributes && (s = i.layoutAttributes);
                        }
                        var l = i.baseLayoutAttrOverrides;
                        if (l && t in l) return l[t];
                    }
                    if (s) return s;
                }
                var u = e._modules;
                if (u) {
                    for(r = 0; r < u.length; r++)if (a = u[r].layoutAttributes, a && t in a) return a[t];
                }
                for(n in x0.componentsRegistry){
                    if (i = x0.componentsRegistry[n], i.name === "colorscale" && t.indexOf("coloraxis") === 0) return i.layoutAttributes[t];
                    if (!i.schema && t === i.name) return i.layoutAttributes;
                }
                return t in rO ? rO[t] : !1;
            }
            function dne(e, t, r) {
                if (!e) return !1;
                if (e._isLinkedToArray) {
                    if (O6(t[r])) r++;
                    else if (r < t.length) return !1;
                }
                for(; r < t.length; r++){
                    var n = e[t[r]];
                    if (m3(n)) e = n;
                    else break;
                    if (r === t.length - 1) break;
                    if (e._isLinkedToArray) {
                        if (r++, !O6(t[r])) return !1;
                    } else if (e.valType === "info_array") {
                        r++;
                        var i = t[r];
                        if (!O6(i)) return !1;
                        var a = e.items;
                        if (Array.isArray(a)) {
                            if (i >= a.length) return !1;
                            if (e.dimensions === 2) {
                                if (r++, t.length === r) return e;
                                var o = t[r];
                                if (!O6(o)) return !1;
                                e = a[i][o];
                            } else e = a[i];
                        } else e = a;
                    }
                }
                return e;
            }
            function O6(e) {
                return e === Math.round(e) && e >= 0;
            }
            function mit(e) {
                var t, r;
                t = x0.modules[e]._module, r = t.basePlotModule;
                var n = {};
                n.type = null;
                var i = xg({}, B6), a = xg({}, t.attributes);
                Bh.crawl(a, function(l, u, c, f, h) {
                    N6(i, h).set(void 0), l === void 0 && N6(a, h).set(void 0);
                }), xg(n, i), x0.traceIs(e, "noOpacity") && delete n.opacity, x0.traceIs(e, "showLegend") || (delete n.showlegend, delete n.legendgroup), x0.traceIs(e, "noHover") && (delete n.hoverinfo, delete n.hoverlabel), t.selectPoints || delete n.selectedpoints, xg(n, a), r.attributes && xg(n, r.attributes), n.type = e;
                var o = {
                    meta: t.meta || {},
                    categories: t.categories || {},
                    animatable: !!t.animatable,
                    type: e,
                    attributes: y3(n)
                };
                if (t.layoutAttributes) {
                    var s = {};
                    xg(s, t.layoutAttributes), o.layoutAttributes = y3(s);
                }
                return t.animatable || Bh.crawl(o, function(l) {
                    Bh.isValObject(l) && "anim" in l && delete l.anim;
                }), o;
            }
            function yit() {
                var e = {}, t, r;
                xg(e, rO);
                for(t in x0.subplotsRegistry)if (r = x0.subplotsRegistry[t], !!r.layoutAttributes) {
                    if (Array.isArray(r.attr)) for(var n = 0; n < r.attr.length; n++)fne(e, r, r.attr[n]);
                    else {
                        var i = r.attr === "subplot" ? r.name : r.attr;
                        fne(e, r, i);
                    }
                }
                for(t in x0.componentsRegistry){
                    r = x0.componentsRegistry[t];
                    var a = r.schema;
                    if (a && (a.subplots || a.layout)) {
                        var o = a.subplots;
                        if (o && o.xaxis && !o.yaxis) for(var s in o.xaxis)delete e.yaxis[s];
                        delete e.xaxis.shift, delete e.xaxis.autoshift;
                    } else r.name === "colorscale" ? xg(e, r.layoutAttributes) : r.layoutAttributes && Tit(e, r.layoutAttributes, r.name);
                }
                return {
                    layoutAttributes: y3(e)
                };
            }
            function _it() {
                var e = {
                    frames: xg({}, cit)
                };
                return y3(e), e.frames;
            }
            function y3(e) {
                return xit(e), bit(e), wit(e), e;
            }
            function xit(e) {
                function t(n) {
                    return {
                        valType: "string",
                        editType: "none"
                    };
                }
                function r(n, i, a) {
                    Bh.isValObject(n) ? (n.arrayOk === !0 || n.valType === "data_array") && (a[i + "src"] = t(i)) : m3(n) && (n.role = "object");
                }
                Bh.crawl(e, r);
            }
            function bit(e) {
                function t(r, n, i) {
                    if (r) {
                        var a = r[U6];
                        a && (delete r[U6], i[n] = {
                            items: {}
                        }, i[n].items[a] = r, i[n].role = "object");
                    }
                }
                Bh.crawl(e, t);
            }
            function wit(e) {
                function t(r) {
                    for(var n in r)if (m3(r[n])) t(r[n]);
                    else if (Array.isArray(r[n])) for(var i = 0; i < r[n].length; i++)t(r[n][i]);
                    else r[n] instanceof RegExp && (r[n] = r[n].toString());
                }
                t(e);
            }
            function fne(e, t, r) {
                var n = N6(e, r), i = xg({}, t.layoutAttributes);
                i[iO] = !0, n.set(i);
            }
            function Tit(e, t, r) {
                var n = N6(e, r);
                n.set(xg(n.get() || {}, t));
            }
        });
        var Vs = ye((pb)=>{
            "use strict";
            var x3 = Mr(), Ait = vl(), Q1 = "templateitemname", aO = {
                name: {
                    valType: "string",
                    editType: "none"
                }
            };
            aO[Q1] = {
                valType: "string",
                editType: "calc"
            };
            pb.templatedArray = function(e, t) {
                return t._isLinkedToArray = e, t.name = aO.name, t[Q1] = aO[Q1], t;
            };
            pb.traceTemplater = function(e) {
                var t = {}, r, n;
                for(r in e)n = e[r], Array.isArray(n) && n.length && (t[r] = 0);
                function i(a) {
                    r = x3.coerce(a, {}, Ait, "type");
                    var o = {
                        type: r,
                        _template: null
                    };
                    if (r in t) {
                        n = e[r];
                        var s = t[r] % n.length;
                        t[r]++, o._template = n[s];
                    }
                    return o;
                }
                return {
                    newTrace: i
                };
            };
            pb.newContainer = function(e, t, r) {
                var n = e._template, i = n && (n[t] || r && n[r]);
                x3.isPlainObject(i) || (i = null);
                var a = e[t] = {
                    _template: i
                };
                return a;
            };
            pb.arrayTemplater = function(e, t, r) {
                var n = e._template, i = n && n[pne(t)], a = n && n[t];
                (!Array.isArray(a) || !a.length) && (a = []);
                var o = {};
                function s(u) {
                    var c = {
                        name: u.name,
                        _input: u
                    }, f = c[Q1] = u[Q1];
                    if (!vne(f)) return c._template = i, c;
                    for(var h = 0; h < a.length; h++){
                        var d = a[h];
                        if (d.name === f) return o[f] = 1, c._template = d, c;
                    }
                    return c[r] = u[r] || !1, c._template = !1, c;
                }
                function l() {
                    for(var u = [], c = 0; c < a.length; c++){
                        var f = a[c], h = f.name;
                        if (vne(h) && !o[h]) {
                            var d = {
                                _template: f,
                                name: h,
                                _input: {
                                    _templateitemname: h
                                }
                            };
                            d[Q1] = f[Q1], u.push(d), o[h] = 1;
                        }
                    }
                    return u;
                }
                return {
                    newItem: s,
                    defaultItems: l
                };
            };
            function vne(e) {
                return e && typeof e == "string";
            }
            function pne(e) {
                var t = e.length - 1;
                return e.charAt(t) !== "s" && x3.warn("bad argument to arrayDefaultKey: " + e), e.substr(0, e.length - 1) + "defaults";
            }
            pb.arrayDefaultKey = pne;
            pb.arrayEditor = function(e, t, r) {
                var n = (x3.nestedProperty(e, t).get() || []).length, i = r._index, a = i >= n && (r._input || {})._templateitemname;
                a && (i = n);
                var o = t + "[" + i + "]", s;
                function l() {
                    s = {}, a && (s[o] = {}, s[o][Q1] = a);
                }
                l();
                function u(d, v) {
                    s[d] = v;
                }
                function c(d, v) {
                    a ? x3.nestedProperty(s[o], d).set(v) : s[o + "." + d] = v;
                }
                function f() {
                    var d = s;
                    return l(), d;
                }
                function h(d, v) {
                    d && c(d, v);
                    var x = f();
                    for(var b in x)x3.nestedProperty(e, b).set(x[b]);
                }
                return {
                    modifyBase: u,
                    modifyItem: c,
                    getUpdateObj: f,
                    applyUpdate: h
                };
            };
        });
        var ad = ye((Ftr, gne)=>{
            "use strict";
            var GS = n3().counter;
            gne.exports = {
                idRegex: {
                    x: GS("x", "( domain)?"),
                    y: GS("y", "( domain)?")
                },
                attrRegex: GS("[xy]axis"),
                xAxisMatch: GS("xaxis"),
                yAxisMatch: GS("yaxis"),
                AX_ID_PATTERN: /^[xyz][0-9]*( domain)?$/,
                AX_NAME_PATTERN: /^[xyz]axis[0-9]*$/,
                SUBPLOT_PATTERN: /^x([0-9]*)y([0-9]*)$/,
                HOUR_PATTERN: "hour",
                WEEKDAY_PATTERN: "day of week",
                MINDRAG: 8,
                MINZOOM: 20,
                DRAGGERSIZE: 20,
                REDRAWDELAY: 50,
                DFLTRANGEX: [
                    -1,
                    6
                ],
                DFLTRANGEY: [
                    -1,
                    4
                ],
                traceLayerClasses: [
                    "imagelayer",
                    "heatmaplayer",
                    "contourcarpetlayer",
                    "contourlayer",
                    "funnellayer",
                    "waterfalllayer",
                    "barlayer",
                    "carpetlayer",
                    "violinlayer",
                    "boxlayer",
                    "ohlclayer",
                    "scattercarpetlayer",
                    "scatterlayer"
                ],
                clipOnAxisFalseQuery: [
                    ".scatterlayer",
                    ".barlayer",
                    ".funnellayer",
                    ".waterfalllayer"
                ],
                layerValue2layerClass: {
                    "above traces": "above",
                    "below traces": "below"
                },
                zindexSeparator: "z"
            };
        });
        var af = ye((Tp)=>{
            "use strict";
            var Sit = ba(), oO = ad();
            Tp.id2name = function(t) {
                if (!(typeof t != "string" || !t.match(oO.AX_ID_PATTERN))) {
                    var r = t.split(" ")[0].substr(1);
                    return r === "1" && (r = ""), t.charAt(0) + "axis" + r;
                }
            };
            Tp.name2id = function(t) {
                if (t.match(oO.AX_NAME_PATTERN)) {
                    var r = t.substr(5);
                    return r === "1" && (r = ""), t.charAt(0) + r;
                }
            };
            Tp.cleanId = function(t, r, n) {
                var i = /( domain)$/.test(t);
                if (!(typeof t != "string" || !t.match(oO.AX_ID_PATTERN)) && !(r && t.charAt(0) !== r) && !(i && !n)) {
                    var a = t.split(" ")[0].substr(1).replace(/^0+/, "");
                    return a === "1" && (a = ""), t.charAt(0) + a + (i && n ? " domain" : "");
                }
            };
            Tp.list = function(e, t, r) {
                var n = e._fullLayout;
                if (!n) return [];
                var i = Tp.listIds(e, t), a = new Array(i.length), o;
                for(o = 0; o < i.length; o++){
                    var s = i[o];
                    a[o] = n[s.charAt(0) + "axis" + s.substr(1)];
                }
                if (!r) {
                    var l = n._subplots.gl3d || [];
                    for(o = 0; o < l.length; o++){
                        var u = n[l[o]];
                        t ? a.push(u[t + "axis"]) : a.push(u.xaxis, u.yaxis, u.zaxis);
                    }
                }
                return a;
            };
            Tp.listIds = function(e, t) {
                var r = e._fullLayout;
                if (!r) return [];
                var n = r._subplots;
                return t ? n[t + "axis"] : n.xaxis.concat(n.yaxis);
            };
            Tp.getFromId = function(e, t, r) {
                var n = e._fullLayout;
                return t = t === void 0 || typeof t != "string" ? t : t.replace(" domain", ""), r === "x" ? t = t.replace(/y[0-9]*/, "") : r === "y" && (t = t.replace(/x[0-9]*/, "")), n[Tp.id2name(t)];
            };
            Tp.getFromTrace = function(e, t, r) {
                var n = e._fullLayout, i = null;
                if (Sit.traceIs(t, "gl3d")) {
                    var a = t.scene;
                    a.substr(0, 5) === "scene" && (i = n[a][r + "axis"]);
                } else i = Tp.getFromId(e, t[r + "axis"] || r);
                return i;
            };
            Tp.idSort = function(e, t) {
                var r = e.charAt(0), n = t.charAt(0);
                return r !== n ? r > n ? 1 : -1 : +(e.substr(1) || 1) - +(t.substr(1) || 1);
            };
            Tp.ref2id = function(e) {
                return /^[xyz]/.test(e) ? e.split(" ")[0] : !1;
            };
            function mne(e, t) {
                if (t && t.length) {
                    for(var r = 0; r < t.length; r++)if (t[r][e]) return !0;
                }
                return !1;
            }
            Tp.isLinked = function(e, t) {
                return mne(t, e._axisMatchGroups) || mne(t, e._axisConstraintGroups);
            };
        });
        var e_ = ye((Otr, yne)=>{
            "use strict";
            function Mit(e) {
                var t = e._fullLayout._zoomlayer;
                t && t.selectAll(".outline-controllers").remove();
            }
            function Eit(e) {
                var t = e._fullLayout._zoomlayer;
                t && t.selectAll(".select-outline").remove(), e._fullLayout._outlining = !1;
            }
            yne.exports = {
                clearOutlineControllers: Mit,
                clearOutline: Eit
            };
        });
        var V6 = ye((Btr, _ne)=>{
            "use strict";
            _ne.exports = {
                scattermode: {
                    valType: "enumerated",
                    values: [
                        "group",
                        "overlay"
                    ],
                    dflt: "overlay",
                    editType: "calc"
                },
                scattergap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: "calc"
                }
            };
        });
        var kd = ye((G6)=>{
            "use strict";
            var H6 = ba(), Ntr = ad().SUBPLOT_PATTERN;
            G6.getSubplotCalcData = function(e, t, r) {
                var n = H6.subplotsRegistry[t];
                if (!n) return [];
                for(var i = n.attr, a = [], o = 0; o < e.length; o++){
                    var s = e[o], l = s[0].trace;
                    l[i] === r && a.push(s);
                }
                return a;
            };
            G6.getModuleCalcData = function(e, t, r) {
                var n = [], i = [], a;
                if (typeof t == "string" ? a = H6.getModule(t).plot : typeof t == "function" ? a = t : a = t.plot, !a) return [
                    n,
                    e
                ];
                for(var o = r, s = 0; s < e.length; s++){
                    var l = e[s], u = l[0].trace, c = u.zorder !== void 0;
                    u.visible !== !0 || u._length === 0 || (u._module && u._module.plot === a && (!c || u.zorder === o) ? n.push(l) : i.push(l));
                }
                return [
                    n,
                    i
                ];
            };
            G6.getSubplotData = function(t, r, n) {
                if (!H6.subplotsRegistry[r]) return [];
                for(var i = H6.subplotsRegistry[r].attr, a = [], o, s, l, u = 0; u < t.length; u++)o = t[u], o[i] === n && a.push(o);
                return a;
            };
        });
        var Tne = ye((gb)=>{
            "use strict";
            var kit = ba(), b3 = Mr();
            gb.manageCommandObserver = function(e, t, r, n) {
                var i = {}, a = !0;
                t && t._commandObserver && (i = t._commandObserver), i.cache || (i.cache = {}), i.lookupTable = {};
                var o = gb.hasSimpleAPICommandBindings(e, r, i.lookupTable);
                if (t && t._commandObserver) {
                    if (o) return i;
                    if (t._commandObserver.remove) return t._commandObserver.remove(), t._commandObserver = null, i;
                }
                if (o) {
                    xne(e, o, i.cache), i.check = function() {
                        if (a) {
                            var c = xne(e, o, i.cache);
                            return c.changed && n && i.lookupTable[c.value] !== void 0 && (i.disable(), Promise.resolve(n({
                                value: c.value,
                                type: o.type,
                                prop: o.prop,
                                traces: o.traces,
                                index: i.lookupTable[c.value]
                            })).then(i.enable, i.enable)), c.changed;
                        }
                    };
                    for(var s = [
                        "plotly_relayout",
                        "plotly_redraw",
                        "plotly_restyle",
                        "plotly_update",
                        "plotly_animatingframe",
                        "plotly_afterplot"
                    ], l = 0; l < s.length; l++)e._internalOn(s[l], i.check);
                    i.remove = function() {
                        for(var u = 0; u < s.length; u++)e._removeInternalListener(s[u], i.check);
                    };
                } else b3.log("Unable to automatically bind plot updates to API command"), i.lookupTable = {}, i.remove = function() {};
                return i.disable = function() {
                    a = !1;
                }, i.enable = function() {
                    a = !0;
                }, t && (t._commandObserver = i), i;
            };
            gb.hasSimpleAPICommandBindings = function(e, t, r) {
                var n, i = t.length, a;
                for(n = 0; n < i; n++){
                    var o, s = t[n], l = s.method, u = s.args;
                    if (Array.isArray(u) || (u = []), !l) return !1;
                    var c = gb.computeAPICommandBindings(e, l, u);
                    if (c.length !== 1) return !1;
                    if (!a) a = c[0], Array.isArray(a.traces) && a.traces.sort();
                    else {
                        if (o = c[0], o.type !== a.type || o.prop !== a.prop) return !1;
                        if (Array.isArray(a.traces)) {
                            if (Array.isArray(o.traces)) {
                                o.traces.sort();
                                for(var f = 0; f < a.traces.length; f++)if (a.traces[f] !== o.traces[f]) return !1;
                            } else return !1;
                        } else if (o.prop !== a.prop) return !1;
                    }
                    o = c[0];
                    var h = o.value;
                    if (Array.isArray(h)) {
                        if (h.length === 1) h = h[0];
                        else return !1;
                    }
                    r && (r[h] = n);
                }
                return a;
            };
            function xne(e, t, r) {
                var n, i, a, o = !1;
                if (t.type === "data") n = e._fullData[t.traces !== null ? t.traces[0] : 0];
                else if (t.type === "layout") n = e._fullLayout;
                else return !1;
                return i = b3.nestedProperty(n, t.prop).get(), a = r[t.type] = r[t.type] || {}, a.hasOwnProperty(t.prop) && a[t.prop] !== i && (o = !0), a[t.prop] = i, {
                    changed: o,
                    value: i
                };
            }
            gb.executeAPICommand = function(e, t, r) {
                if (t === "skip") return Promise.resolve();
                var n = kit.apiMethodRegistry[t], i = [
                    e
                ];
                Array.isArray(r) || (r = []);
                for(var a = 0; a < r.length; a++)i.push(r[a]);
                return n.apply(null, i).catch(function(o) {
                    return b3.warn("API call to Plotly." + t + " rejected.", o), Promise.reject(o);
                });
            };
            gb.computeAPICommandBindings = function(e, t, r) {
                var n;
                switch(Array.isArray(r) || (r = []), t){
                    case "restyle":
                        n = wne(e, r);
                        break;
                    case "relayout":
                        n = bne(e, r);
                        break;
                    case "update":
                        n = wne(e, [
                            r[0],
                            r[2]
                        ]).concat(bne(e, [
                            r[1]
                        ]));
                        break;
                    case "animate":
                        n = Cit(e, r);
                        break;
                    default:
                        n = [];
                }
                return n;
            };
            function Cit(e, t) {
                return Array.isArray(t[0]) && t[0].length === 1 && [
                    "string",
                    "number"
                ].indexOf(typeof t[0][0]) !== -1 ? [
                    {
                        type: "layout",
                        prop: "_currentFrame",
                        value: t[0][0].toString()
                    }
                ] : [];
            }
            function bne(e, t) {
                var r = [], n = t[0], i = {};
                if (typeof n == "string") i[n] = t[1];
                else if (b3.isPlainObject(n)) i = n;
                else return r;
                return sO(i, function(a, o, s) {
                    r.push({
                        type: "layout",
                        prop: a,
                        value: s
                    });
                }, "", 0), r;
            }
            function wne(e, t) {
                var r, n, i, a, o = [];
                if (n = t[0], i = t[1], r = t[2], a = {}, typeof n == "string") a[n] = i;
                else if (b3.isPlainObject(n)) a = n, r === void 0 && (r = i);
                else return o;
                return r === void 0 && (r = null), sO(a, function(s, l, u) {
                    var c, f;
                    if (Array.isArray(u)) {
                        f = u.slice();
                        var h = Math.min(f.length, e.data.length);
                        r && (h = Math.min(h, r.length)), c = [];
                        for(var d = 0; d < h; d++)c[d] = r ? r[d] : d;
                    } else f = u, c = r ? r.slice() : null;
                    if (c === null) Array.isArray(f) && (f = f[0]);
                    else if (Array.isArray(c)) {
                        if (!Array.isArray(f)) {
                            var v = f;
                            f = [];
                            for(var x = 0; x < c.length; x++)f[x] = v;
                        }
                        f.length = Math.min(c.length, f.length);
                    }
                    o.push({
                        type: "data",
                        prop: s,
                        traces: c,
                        value: f
                    });
                }, "", 0), o;
            }
            function sO(e, t, r, n) {
                Object.keys(e).forEach(function(i) {
                    var a = e[i];
                    if (i[0] !== "_") {
                        var o = r + (n > 0 ? "." : "") + i;
                        b3.isPlainObject(a) ? sO(a, t, o, n + 1) : t(o, i, a);
                    }
                });
            }
        });
        var Xu = ye((Htr, qne)=>{
            "use strict";
            var Lne = xa(), Lit = e3().timeFormatLocale, Pit = vq().formatLocale, jS = uo(), Iit = pq(), bl = ba(), Pne = _3(), Rit = Vs(), Ca = Mr(), Ine = va(), Ane = es().BADNUM, Ap = af(), Dit = e_().clearOutline, zit = V6(), lO = zS(), Fit = tO(), qit = kd().getModuleCalcData, Sne = Ca.relinkPrivateKeys, mb = Ca._, ha = qne.exports = {};
            Ca.extendFlat(ha, bl);
            ha.attributes = vl();
            ha.attributes.type.values = ha.allTypes;
            ha.fontAttrs = Su();
            ha.layoutAttributes = s3();
            var W6 = Tne();
            ha.executeAPICommand = W6.executeAPICommand;
            ha.computeAPICommandBindings = W6.computeAPICommandBindings;
            ha.manageCommandObserver = W6.manageCommandObserver;
            ha.hasSimpleAPICommandBindings = W6.hasSimpleAPICommandBindings;
            ha.redrawText = function(e) {
                return e = Ca.getGraphDiv(e), new Promise(function(t) {
                    setTimeout(function() {
                        e._fullLayout && (bl.getComponentMethod("annotations", "draw")(e), bl.getComponentMethod("legend", "draw")(e), bl.getComponentMethod("colorbar", "draw")(e), t(ha.previousPromises(e)));
                    }, 300);
                });
            };
            ha.resize = function(e) {
                e = Ca.getGraphDiv(e);
                var t, r = new Promise(function(n, i) {
                    (!e || Ca.isHidden(e)) && i(new Error("Resize must be passed a displayed plot div element.")), e._redrawTimer && clearTimeout(e._redrawTimer), e._resolveResize && (t = e._resolveResize), e._resolveResize = n, e._redrawTimer = setTimeout(function() {
                        if (!e.layout || e.layout.width && e.layout.height || Ca.isHidden(e)) {
                            n(e);
                            return;
                        }
                        delete e.layout.width, delete e.layout.height;
                        var a = e.changed;
                        e.autoplay = !0, bl.call("relayout", e, {
                            autosize: !0
                        }).then(function() {
                            e.changed = a, e._resolveResize === n && (delete e._resolveResize, n(e));
                        });
                    }, 100);
                });
                return t && t(r), r;
            };
            ha.previousPromises = function(e) {
                if ((e._promises || []).length) return Promise.all(e._promises).then(function() {
                    e._promises = [];
                });
            };
            ha.addLinks = function(e) {
                if (!(!e._context.showLink && !e._context.showSources)) {
                    var t = e._fullLayout, r = Ca.ensureSingle(t._paper, "text", "js-plot-link-container", function(l) {
                        l.style({
                            "font-family": '"Open Sans", Arial, sans-serif',
                            "font-size": "12px",
                            fill: Ine.defaultLine,
                            "pointer-events": "all"
                        }).each(function() {
                            var u = Lne.select(this);
                            u.append("tspan").classed("js-link-to-tool", !0), u.append("tspan").classed("js-link-spacer", !0), u.append("tspan").classed("js-sourcelinks", !0);
                        });
                    }), n = r.node(), i = {
                        y: t._paper.attr("height") - 9
                    };
                    document.body.contains(n) && n.getComputedTextLength() >= t.width - 20 ? (i["text-anchor"] = "start", i.x = 5) : (i["text-anchor"] = "end", i.x = t._paper.attr("width") - 7), r.attr(i);
                    var a = r.select(".js-link-to-tool"), o = r.select(".js-link-spacer"), s = r.select(".js-sourcelinks");
                    e._context.showSources && e._context.showSources(e), e._context.showLink && Oit(e, a), o.text(a.text() && s.text() ? " - " : "");
                }
            };
            function Oit(e, t) {
                t.text("");
                var r = t.append("a").attr({
                    "xlink:xlink:href": "#",
                    class: "link--impt link--embedview",
                    "font-weight": "bold"
                }).text(e._context.linkText + " \xBB");
                if (e._context.sendData) r.on("click", function() {
                    ha.sendDataToCloud(e);
                });
                else {
                    var n = window.location.pathname.split("/"), i = window.location.search;
                    r.attr({
                        "xlink:xlink:show": "new",
                        "xlink:xlink:href": "/" + n[2].split(".")[0] + "/" + n[1] + i
                    });
                }
            }
            ha.sendDataToCloud = function(e) {
                var t = (window.PLOTLYENV || {}).BASE_URL || e._context.plotlyServerURL;
                if (t) {
                    e.emit("plotly_beforeexport");
                    var r = Lne.select(e).append("div").attr("id", "hiddenform").style("display", "none"), n = r.append("form").attr({
                        action: t + "/external",
                        method: "post",
                        target: "_blank"
                    }), i = n.append("input").attr({
                        type: "text",
                        name: "data"
                    });
                    return i.node().value = ha.graphJson(e, !1, "keepdata"), n.node().submit(), r.remove(), e.emit("plotly_afterexport"), !1;
                }
            };
            var Bit = [
                "days",
                "shortDays",
                "months",
                "shortMonths",
                "periods",
                "dateTime",
                "date",
                "time",
                "decimal",
                "thousands",
                "grouping",
                "currency"
            ], Nit = [
                "year",
                "month",
                "dayMonth",
                "dayMonthYear"
            ];
            ha.supplyDefaults = function(e, t) {
                var r = t && t.skipUpdateCalc, n = e._fullLayout || {};
                if (n._skipDefaults) {
                    delete n._skipDefaults;
                    return;
                }
                var i = e._fullLayout = {}, a = e.layout || {}, o = e._fullData || [], s = e._fullData = [], l = e.data || [], u = e.calcdata || [], c = e._context || {}, f;
                e._transitionData || ha.createTransitionData(e), i._dfltTitle = {
                    plot: mb(e, "Click to enter Plot title"),
                    subtitle: mb(e, "Click to enter Plot subtitle"),
                    x: mb(e, "Click to enter X axis title"),
                    y: mb(e, "Click to enter Y axis title"),
                    colorbar: mb(e, "Click to enter Colorscale title"),
                    annotation: mb(e, "new text")
                }, i._traceWord = mb(e, "trace");
                var h = Mne(e, Bit);
                if (i._mapboxAccessToken = c.mapboxAccessToken, n._initialAutoSizeIsDone) {
                    var d = n.width, v = n.height;
                    ha.supplyLayoutGlobalDefaults(a, i, h), a.width || (i.width = d), a.height || (i.height = v), ha.sanitizeMargins(i);
                } else {
                    ha.supplyLayoutGlobalDefaults(a, i, h);
                    var x = !a.width || !a.height, b = i.autosize, p = c.autosizable, E = x && (b || p);
                    E ? ha.plotAutoSize(e, a, i) : x && ha.sanitizeMargins(i), !b && x && (a.width = i.width, a.height = i.height);
                }
                i._d3locale = Hit(h, i.separators), i._extraFormat = Mne(e, Nit), i._initialAutoSizeIsDone = !0, i._dataLength = l.length, i._modules = [], i._visibleModules = [], i._basePlotModules = [];
                var k = i._subplots = Vit(), A = i._splomAxes = {
                    x: {},
                    y: {}
                }, L = i._splomSubplots = {};
                i._splomGridDflt = {}, i._scatterStackOpts = {}, i._firstScatter = {}, i._alignmentOpts = {}, i._colorAxes = {}, i._requestRangeslider = {}, i._traceUids = Uit(o, l), ha.supplyDataDefaults(l, s, a, i);
                var _ = Object.keys(A.x), C = Object.keys(A.y);
                if (_.length > 1 && C.length > 1) {
                    for(bl.getComponentMethod("grid", "sizeDefaults")(a, i), f = 0; f < _.length; f++)Ca.pushUnique(k.xaxis, _[f]);
                    for(f = 0; f < C.length; f++)Ca.pushUnique(k.yaxis, C[f]);
                    for(var M in L)Ca.pushUnique(k.cartesian, M);
                }
                if (i._has = ha._hasPlotType.bind(i), o.length === s.length) for(f = 0; f < s.length; f++)Sne(s[f], o[f]);
                ha.supplyLayoutModuleDefaults(a, i, s, e._transitionData);
                var g = i._visibleModules, P = [];
                for(f = 0; f < g.length; f++){
                    var T = g[f].crossTraceDefaults;
                    T && Ca.pushUnique(P, T);
                }
                for(f = 0; f < P.length; f++)P[f](s, i);
                i._hasOnlyLargeSploms = i._basePlotModules.length === 1 && i._basePlotModules[0].name === "splom" && _.length > 15 && C.length > 15 && i.shapes.length === 0 && i.images.length === 0, ha.linkSubplots(s, i, o, n), ha.cleanPlot(s, i, o, n);
                var F = !!(n._has && n._has("cartesian")), q = !!(i._has && i._has("cartesian")), V = F, H = q;
                V && !H ? n._bgLayer.remove() : H && !V && (i._shouldCreateBgLayer = !0), n._zoomlayer && !e._dragging && Dit({
                    _fullLayout: n
                }), Git(s, i), Sne(i, n), bl.getComponentMethod("colorscale", "crossTraceDefaults")(s, i), i._preGUI || (i._preGUI = {}), i._tracePreGUI || (i._tracePreGUI = {});
                var X = i._tracePreGUI, G = {}, N;
                for(N in X)G[N] = "old";
                for(f = 0; f < s.length; f++)N = s[f]._fullInput.uid, G[N] || (X[N] = {}), G[N] = "new";
                for(N in G)G[N] === "old" && delete X[N];
                Rne(i), bl.getComponentMethod("rangeslider", "makeData")(i), !r && u.length === s.length && ha.supplyDefaultsUpdateCalc(u, s);
            };
            ha.supplyDefaultsUpdateCalc = function(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r], i = (e[r] || [])[0];
                    if (i && i.trace) {
                        var a = i.trace;
                        if (a._hasCalcTransform) {
                            var o = a._arrayAttrs, s, l, u;
                            for(s = 0; s < o.length; s++)l = o[s], u = Ca.nestedProperty(a, l).get().slice(), Ca.nestedProperty(n, l).set(u);
                        }
                        i.trace = n;
                    }
                }
            };
            function Uit(e, t) {
                var r = t.length, n = [], i, a;
                for(i = 0; i < e.length; i++){
                    var o = e[i]._fullInput;
                    o !== a && n.push(o), a = o;
                }
                var s = n.length, l = new Array(r), u = {};
                function c(d, v) {
                    l[v] = d, u[d] = 1;
                }
                function f(d, v) {
                    if (d && typeof d == "string" && !u[d]) return c(d, v), !0;
                }
                for(i = 0; i < r; i++){
                    var h = t[i].uid;
                    typeof h == "number" && (h = String(h)), !f(h, i) && (i < s && f(n[i].uid, i) || c(Ca.randstr(u), i));
                }
                return l;
            }
            function Vit() {
                var e = bl.collectableSubplotTypes, t = {}, r, n;
                if (!e) {
                    e = [];
                    var i = bl.subplotsRegistry;
                    for(var a in i){
                        var o = i[a], s = o.attr;
                        if (s && (e.push(a), Array.isArray(s))) for(n = 0; n < s.length; n++)Ca.pushUnique(e, s[n]);
                    }
                }
                for(r = 0; r < e.length; r++)t[e[r]] = [];
                return t;
            }
            function Mne(e, t) {
                var r = e._context.locale;
                r || (r = "en-US");
                var n = !1, i = {};
                function a(f) {
                    for(var h = !0, d = 0; d < t.length; d++){
                        var v = t[d];
                        i[v] || (f[v] ? i[v] = f[v] : h = !1);
                    }
                    h && (n = !0);
                }
                for(var o = 0; o < 2; o++){
                    for(var s = e._context.locales, l = 0; l < 2; l++){
                        var u = (s[r] || {}).format;
                        if (u && (a(u), n)) break;
                        s = bl.localeRegistry;
                    }
                    var c = r.split("-")[0];
                    if (n || c === r) break;
                    r = c;
                }
                return n || a(bl.localeRegistry.en.format), i;
            }
            function Hit(e, t) {
                return e.decimal = t.charAt(0), e.thousands = t.charAt(1), {
                    numberFormat: function(r) {
                        try {
                            r = Pit(e).format(Ca.adjustFormat(r));
                        } catch (n) {
                            return Ca.warnBadFormat(r), Ca.noFormat;
                        }
                        return r;
                    },
                    timeFormat: Lit(e).utcFormat
                };
            }
            function Git(e, t) {
                var r, n = [];
                t.meta && (r = t._meta = {
                    meta: t.meta,
                    layout: {
                        meta: t.meta
                    }
                });
                for(var i = 0; i < e.length; i++){
                    var a = e[i];
                    a.meta ? n[a.index] = a._meta = {
                        meta: a.meta
                    } : t.meta && (a._meta = {
                        meta: t.meta
                    }), t.meta && (a._meta.layout = {
                        meta: t.meta
                    });
                }
                n.length && (r || (r = t._meta = {}), r.data = n);
            }
            ha.createTransitionData = function(e) {
                e._transitionData || (e._transitionData = {}), e._transitionData._frames || (e._transitionData._frames = []), e._transitionData._frameHash || (e._transitionData._frameHash = {}), e._transitionData._counter || (e._transitionData._counter = 0), e._transitionData._interruptCallbacks || (e._transitionData._interruptCallbacks = []);
            };
            ha._hasPlotType = function(e) {
                var t, r = this._basePlotModules || [];
                for(t = 0; t < r.length; t++)if (r[t].name === e) return !0;
                var n = this._modules || [];
                for(t = 0; t < n.length; t++){
                    var i = n[t].name;
                    if (i === e) return !0;
                    var a = bl.modules[i];
                    if (a && a.categories[e]) return !0;
                }
                return !1;
            };
            ha.cleanPlot = function(e, t, r, n) {
                var i, a, o = n._basePlotModules || [];
                for(i = 0; i < o.length; i++){
                    var s = o[i];
                    s.clean && s.clean(e, t, r, n);
                }
                var l = n._has && n._has("gl"), u = t._has && t._has("gl");
                l && !u && n._glcontainer !== void 0 && (n._glcontainer.selectAll(".gl-canvas").remove(), n._glcontainer.selectAll(".no-webgl").remove(), n._glcanvas = null);
                var c = !!n._infolayer;
                e: for(i = 0; i < r.length; i++){
                    var f = r[i], h = f.uid;
                    for(a = 0; a < e.length; a++){
                        var d = e[a];
                        if (h === d.uid) continue e;
                    }
                    c && n._infolayer.select(".cb" + h).remove();
                }
            };
            ha.linkSubplots = function(e, t, r, n) {
                var i, a, o = n._plots || {}, s = t._plots = {}, l = t._subplots, u = {
                    _fullData: e,
                    _fullLayout: t
                }, c = l.cartesian || [];
                for(i = 0; i < c.length; i++){
                    var f = c[i], h = o[f], d = Ap.getFromId(u, f, "x"), v = Ap.getFromId(u, f, "y"), x;
                    for(h ? x = s[f] = h : (x = s[f] = {}, x.id = f), d._counterAxes.push(v._id), v._counterAxes.push(d._id), d._subplotsWith.push(f), v._subplotsWith.push(f), x.xaxis = d, x.yaxis = v, x._hasClipOnAxisFalse = !1, a = 0; a < e.length; a++){
                        var b = e[a];
                        if (b.xaxis === x.xaxis._id && b.yaxis === x.yaxis._id && b.cliponaxis === !1) {
                            x._hasClipOnAxisFalse = !0;
                            break;
                        }
                    }
                }
                var p = Ap.list(u, null, !0), E;
                for(i = 0; i < p.length; i++){
                    E = p[i];
                    var k = null;
                    E.overlaying && (k = Ap.getFromId(u, E.overlaying), k && k.overlaying && (E.overlaying = !1, k = null)), E._mainAxis = k || E, k && (E.domain = k.domain.slice()), E._anchorAxis = E.anchor === "free" ? null : Ap.getFromId(u, E.anchor);
                }
                for(i = 0; i < p.length; i++)if (E = p[i], E._counterAxes.sort(Ap.idSort), E._subplotsWith.sort(Ca.subplotSort), E._mainSubplot = jit(E, t), E._counterAxes.length && (E.spikemode && E.spikemode.indexOf("across") !== -1 || E.automargin && E.mirror && E.anchor !== "free" || bl.getComponentMethod("rangeslider", "isVisible")(E))) {
                    var A = 1, L = 0;
                    for(a = 0; a < E._counterAxes.length; a++){
                        var _ = Ap.getFromId(u, E._counterAxes[a]);
                        A = Math.min(A, _.domain[0]), L = Math.max(L, _.domain[1]);
                    }
                    A < L && (E._counterDomainMin = A, E._counterDomainMax = L);
                }
            };
            function jit(e, t) {
                var r = {
                    _fullLayout: t
                }, n = e._id.charAt(0) === "x", i = e._mainAxis._anchorAxis, a = "", o = "", s = "";
                if (i && (s = i._mainAxis._id, a = n ? e._id + s : s + e._id), !a || !t._plots[a]) {
                    a = "";
                    for(var l = e._counterAxes, u = 0; u < l.length; u++){
                        var c = l[u], f = n ? e._id + c : c + e._id;
                        o || (o = f);
                        var h = Ap.getFromId(r, c);
                        if (s && h.overlaying === s) {
                            a = f;
                            break;
                        }
                    }
                }
                return a || o;
            }
            ha.clearExpandedTraceDefaultColors = function(e) {
                var t, r, n;
                function i(o, s, l, u) {
                    r[u] = s, r.length = u + 1, o.valType === "color" && o.dflt === void 0 && t.push(r.join("."));
                }
                for(r = [], t = e._module._colorAttrs, t || (e._module._colorAttrs = t = [], Pne.crawl(e._module.attributes, i)), n = 0; n < t.length; n++){
                    var a = Ca.nestedProperty(e, "_input." + t[n]);
                    a.get() || Ca.nestedProperty(e, t[n]).set(null);
                }
            };
            ha.supplyDataDefaults = function(e, t, r, n) {
                var i = n._modules, a = n._visibleModules, o = n._basePlotModules, s = 0, l = 0, u, c, f;
                n._transformModules = [];
                function h(E) {
                    t.push(E);
                    var k = E._module;
                    k && (Ca.pushUnique(i, k), E.visible === !0 && Ca.pushUnique(a, k), Ca.pushUnique(o, E._module.basePlotModule), s++, E._input.visible !== !1 && l++);
                }
                var d = {}, v = [], x = (r.template || {}).data || {}, b = Rit.traceTemplater(x);
                for(u = 0; u < e.length; u++)f = e[u], c = b.newTrace(f), c.uid = n._traceUids[u], ha.supplyTraceDefaults(f, c, l, n, u), c.index = u, c._input = f, c._fullInput = c, h(c), bl.traceIs(c, "carpetAxis") && (d[c.carpet] = c), bl.traceIs(c, "carpetDependent") && v.push(u);
                for(u = 0; u < v.length; u++)if (c = t[v[u]], !!c.visible) {
                    var p = d[c.carpet];
                    if (c._carpet = p, !p || !p.visible) {
                        c.visible = !1;
                        continue;
                    }
                    c.xaxis = p.xaxis, c.yaxis = p.yaxis;
                }
            };
            ha.supplyAnimationDefaults = function(e) {
                e = e || {};
                var t, r = {};
                function n(i, a) {
                    return Ca.coerce(e || {}, r, lO, i, a);
                }
                if (n("mode"), n("direction"), n("fromcurrent"), Array.isArray(e.frame)) for(r.frame = [], t = 0; t < e.frame.length; t++)r.frame[t] = ha.supplyAnimationFrameDefaults(e.frame[t] || {});
                else r.frame = ha.supplyAnimationFrameDefaults(e.frame || {});
                if (Array.isArray(e.transition)) for(r.transition = [], t = 0; t < e.transition.length; t++)r.transition[t] = ha.supplyAnimationTransitionDefaults(e.transition[t] || {});
                else r.transition = ha.supplyAnimationTransitionDefaults(e.transition || {});
                return r;
            };
            ha.supplyAnimationFrameDefaults = function(e) {
                var t = {};
                function r(n, i) {
                    return Ca.coerce(e || {}, t, lO.frame, n, i);
                }
                return r("duration"), r("redraw"), t;
            };
            ha.supplyAnimationTransitionDefaults = function(e) {
                var t = {};
                function r(n, i) {
                    return Ca.coerce(e || {}, t, lO.transition, n, i);
                }
                return r("duration"), r("easing"), t;
            };
            ha.supplyFrameDefaults = function(e) {
                var t = {};
                function r(n, i) {
                    return Ca.coerce(e, t, Fit, n, i);
                }
                return r("group"), r("name"), r("traces"), r("baseframe"), r("data"), r("layout"), t;
            };
            ha.supplyTraceDefaults = function(e, t, r, n, i) {
                var a = n.colorway || Ine.defaults, o = a[r % a.length], s;
                function l(k, A) {
                    return Ca.coerce(e, t, ha.attributes, k, A);
                }
                var u = l("visible");
                l("type"), l("name", n._traceWord + " " + i), l("uirevision", n.uirevision);
                var c = ha.getModule(t);
                if (t._module = c, c) {
                    var f = c.basePlotModule, h = f.attr, d = f.attributes;
                    if (h && d) {
                        var v = n._subplots, x = "";
                        if (Array.isArray(h)) for(s = 0; s < h.length; s++){
                            var b = h[s], p = Ca.coerce(e, t, d, b);
                            v[b] && Ca.pushUnique(v[b], p), x += p;
                        }
                        else x = Ca.coerce(e, t, d, h);
                        v[f.name] && Ca.pushUnique(v[f.name], x);
                    }
                }
                if (u && (l("customdata"), l("ids"), l("meta"), bl.traceIs(t, "showLegend") ? (Ca.coerce(e, t, c.attributes.showlegend ? c.attributes : ha.attributes, "showlegend"), l("legend"), l("legendwidth"), l("legendgroup"), l("legendgrouptitle.text"), l("legendrank"), t._dfltShowLegend = !0) : t._dfltShowLegend = !1, c && c.supplyDefaults(e, t, o, n), bl.traceIs(t, "noOpacity") || l("opacity"), bl.traceIs(t, "notLegendIsolatable") && (t.visible = !!t.visible), bl.traceIs(t, "noHover") || (t.hovertemplate || Ca.coerceHoverinfo(e, t, n), t.type !== "parcats" && bl.getComponentMethod("fx", "supplyDefaults")(e, t, o, n)), c && c.selectPoints)) {
                    var E = l("selectedpoints");
                    Ca.isTypedArray(E) && (t.selectedpoints = Array.from(E));
                }
                return t;
            };
            ha.supplyLayoutGlobalDefaults = function(e, t, r) {
                function n(f, h) {
                    return Ca.coerce(e, t, ha.layoutAttributes, f, h);
                }
                var i = e.template;
                Ca.isPlainObject(i) && (t.template = i, t._template = i.layout, t._dataTemplate = i.data), n("autotypenumbers");
                var a = Ca.coerceFont(n, "font"), o = a.size;
                Ca.coerceFont(n, "title.font", a, {
                    overrideDflt: {
                        size: Math.round(o * 1.4)
                    }
                }), n("title.text", t._dfltTitle.plot), n("title.xref");
                var s = n("title.yref");
                n("title.pad.t"), n("title.pad.r"), n("title.pad.b"), n("title.pad.l");
                var l = n("title.automargin");
                n("title.x"), n("title.xanchor"), n("title.y"), n("title.yanchor"), n("title.subtitle.text", t._dfltTitle.subtitle), Ca.coerceFont(n, "title.subtitle.font", a, {
                    overrideDflt: {
                        size: Math.round(t.title.font.size * .7)
                    }
                }), l && (s === "paper" && (t.title.y !== 0 && (t.title.y = 1), t.title.yanchor === "auto" && (t.title.yanchor = t.title.y === 0 ? "top" : "bottom")), s === "container" && (t.title.y === "auto" && (t.title.y = 1), t.title.yanchor === "auto" && (t.title.yanchor = t.title.y < .5 ? "bottom" : "top")));
                var u = n("uniformtext.mode");
                u && n("uniformtext.minsize"), n("autosize", !(e.width && e.height)), n("width"), n("height"), n("minreducedwidth"), n("minreducedheight"), n("margin.l"), n("margin.r"), n("margin.t"), n("margin.b"), n("margin.pad"), n("margin.autoexpand"), e.width && e.height && ha.sanitizeMargins(t), bl.getComponentMethod("grid", "sizeDefaults")(e, t), n("paper_bgcolor"), n("separators", r.decimal + r.thousands), n("hidesources"), n("colorway"), n("datarevision");
                var c = n("uirevision");
                n("editrevision", c), n("selectionrevision", c), bl.getComponentMethod("modebar", "supplyLayoutDefaults")(e, t), bl.getComponentMethod("shapes", "supplyDrawNewShapeDefaults")(e, t, n), bl.getComponentMethod("selections", "supplyDrawNewSelectionDefaults")(e, t, n), n("meta"), Ca.isPlainObject(e.transition) && (n("transition.duration"), n("transition.easing"), n("transition.ordering")), bl.getComponentMethod("calendars", "handleDefaults")(e, t, "calendar"), bl.getComponentMethod("fx", "supplyLayoutGlobalDefaults")(e, t, n), Ca.coerce(e, t, zit, "scattermode");
            };
            function j6(e) {
                return typeof e == "string" && e.substr(e.length - 2) === "px" && parseFloat(e);
            }
            ha.plotAutoSize = function(t, r, n) {
                var i = t._context || {}, a = i.frameMargins, o, s, l = Ca.isPlotDiv(t);
                if (l && t.emit("plotly_autosize"), i.fillFrame) o = window.innerWidth, s = window.innerHeight, document.body.style.overflow = "hidden";
                else {
                    var u = l ? window.getComputedStyle(t) : {};
                    if (o = j6(u.width) || j6(u.maxWidth) || n.width, s = j6(u.height) || j6(u.maxHeight) || n.height, jS(a) && a > 0) {
                        var c = 1 - 2 * a;
                        o = Math.round(c * o), s = Math.round(c * s);
                    }
                }
                var f = ha.layoutAttributes.width.min, h = ha.layoutAttributes.height.min;
                o < f && (o = f), s < h && (s = h);
                var d = !r.width && Math.abs(n.width - o) > 1, v = !r.height && Math.abs(n.height - s) > 1;
                (v || d) && (d && (n.width = o), v && (n.height = s)), t._initialAutoSize || (t._initialAutoSize = {
                    width: o,
                    height: s
                }), ha.sanitizeMargins(n);
            };
            ha.supplyLayoutModuleDefaults = function(e, t, r, n) {
                var i = bl.componentsRegistry, a = t._basePlotModules, o, s, l, u = bl.subplotsRegistry.cartesian;
                for(o in i)l = i[o], l.includeBasePlot && l.includeBasePlot(e, t);
                a.length || a.push(u), t._has("cartesian") && (bl.getComponentMethod("grid", "contentDefaults")(e, t), u.finalizeSubplots(e, t));
                for(var c in t._subplots)t._subplots[c].sort(Ca.subplotSort);
                for(s = 0; s < a.length; s++)l = a[s], l.supplyLayoutDefaults && l.supplyLayoutDefaults(e, t, r);
                var f = t._modules;
                for(s = 0; s < f.length; s++)l = f[s], l.supplyLayoutDefaults && l.supplyLayoutDefaults(e, t, r);
                var h = t._transformModules;
                for(s = 0; s < h.length; s++)l = h[s], l.supplyLayoutDefaults && l.supplyLayoutDefaults(e, t, r, n);
                for(o in i)l = i[o], l.supplyLayoutDefaults && l.supplyLayoutDefaults(e, t, r);
            };
            ha.purge = function(e) {
                var t = e._fullLayout || {};
                t._glcontainer !== void 0 && (t._glcontainer.selectAll(".gl-canvas").remove(), t._glcontainer.remove(), t._glcanvas = null), t._modeBar && t._modeBar.destroy(), e._transitionData && (e._transitionData._interruptCallbacks && (e._transitionData._interruptCallbacks.length = 0), e._transitionData._animationRaf && window.cancelAnimationFrame(e._transitionData._animationRaf)), Ca.clearThrottle(), Ca.clearResponsive(e), delete e.data, delete e.layout, delete e._fullData, delete e._fullLayout, delete e.calcdata, delete e.empty, delete e.fid, delete e.undoqueue, delete e.undonum, delete e.autoplay, delete e.changed, delete e._promises, delete e._redrawTimer, delete e._hmlumcount, delete e._hmpixcount, delete e._transitionData, delete e._transitioning, delete e._initialAutoSize, delete e._transitioningWithDuration, delete e._dragging, delete e._dragged, delete e._dragdata, delete e._hoverdata, delete e._snapshotInProgress, delete e._editing, delete e._mouseDownTime, delete e._legendMouseDownTime, e.removeAllListeners && e.removeAllListeners();
            };
            ha.style = function(e) {
                var t = e._fullLayout._visibleModules, r = [], n;
                for(n = 0; n < t.length; n++){
                    var i = t[n];
                    i.style && Ca.pushUnique(r, i.style);
                }
                for(n = 0; n < r.length; n++)r[n](e);
            };
            ha.sanitizeMargins = function(e) {
                if (!(!e || !e.margin)) {
                    var t = e.width, r = e.height, n = e.margin, i = t - (n.l + n.r), a = r - (n.t + n.b), o;
                    i < 0 && (o = (t - 1) / (n.l + n.r), n.l = Math.floor(o * n.l), n.r = Math.floor(o * n.r)), a < 0 && (o = (r - 1) / (n.t + n.b), n.t = Math.floor(o * n.t), n.b = Math.floor(o * n.b));
                }
            };
            ha.clearAutoMarginIds = function(e) {
                e._fullLayout._pushmarginIds = {};
            };
            ha.allowAutoMargin = function(e, t) {
                e._fullLayout._pushmarginIds[t] = 1;
            };
            function Rne(e) {
                var t = e.margin;
                if (!e._size) {
                    var r = e._size = {
                        l: Math.round(t.l),
                        r: Math.round(t.r),
                        t: Math.round(t.t),
                        b: Math.round(t.b),
                        p: Math.round(t.pad)
                    };
                    r.w = Math.round(e.width) - r.l - r.r, r.h = Math.round(e.height) - r.t - r.b;
                }
                e._pushmargin || (e._pushmargin = {}), e._pushmarginIds || (e._pushmarginIds = {}), e._reservedMargin || (e._reservedMargin = {});
            }
            var Dne = 2, zne = 2;
            ha.autoMargin = function(e, t, r) {
                var n = e._fullLayout, i = n.width, a = n.height, o = n.margin, s = n.minreducedwidth, l = n.minreducedheight, u = Ca.constrain(i - o.l - o.r, Dne, s), c = Ca.constrain(a - o.t - o.b, zne, l), f = Math.max(0, i - u), h = Math.max(0, a - c), d = n._pushmargin, v = n._pushmarginIds;
                if (o.autoexpand !== !1) {
                    if (!r) delete d[t], delete v[t];
                    else {
                        var x = r.pad;
                        if (x === void 0 && (x = Math.min(12, o.l, o.r, o.t, o.b)), f) {
                            var b = (r.l + r.r) / f;
                            b > 1 && (r.l /= b, r.r /= b);
                        }
                        if (h) {
                            var p = (r.t + r.b) / h;
                            p > 1 && (r.t /= p, r.b /= p);
                        }
                        var E = r.xl !== void 0 ? r.xl : r.x, k = r.xr !== void 0 ? r.xr : r.x, A = r.yt !== void 0 ? r.yt : r.y, L = r.yb !== void 0 ? r.yb : r.y;
                        d[t] = {
                            l: {
                                val: E,
                                size: r.l + x
                            },
                            r: {
                                val: k,
                                size: r.r + x
                            },
                            b: {
                                val: L,
                                size: r.b + x
                            },
                            t: {
                                val: A,
                                size: r.t + x
                            }
                        }, v[t] = 1;
                    }
                    if (!n._replotting) return ha.doAutoMargin(e);
                }
            };
            function Wit(e) {
                if ("_redrawFromAutoMarginCount" in e._fullLayout) return !1;
                var t = Ap.list(e, "", !0);
                for(var r in t)if (t[r].autoshift || t[r].shift) return !0;
                return !1;
            }
            ha.doAutoMargin = function(e) {
                var t = e._fullLayout, r = t.width, n = t.height;
                t._size || (t._size = {}), Rne(t);
                var i = t._size, a = t.margin, o = {
                    t: 0,
                    b: 0,
                    l: 0,
                    r: 0
                }, s = Ca.extendFlat({}, i), l = a.l, u = a.r, c = a.t, f = a.b, h = t._pushmargin, d = t._pushmarginIds, v = t.minreducedwidth, x = t.minreducedheight;
                if (a.autoexpand !== !1) {
                    for(var b in h)d[b] || delete h[b];
                    var p = e._fullLayout._reservedMargin;
                    for(var E in p)for(var k in p[E]){
                        var A = p[E][k];
                        o[k] = Math.max(o[k], A);
                    }
                    h.base = {
                        l: {
                            val: 0,
                            size: l
                        },
                        r: {
                            val: 1,
                            size: u
                        },
                        t: {
                            val: 1,
                            size: c
                        },
                        b: {
                            val: 0,
                            size: f
                        }
                    };
                    for(var L in o){
                        var _ = 0;
                        for(var C in h)C !== "base" && jS(h[C][L].size) && (_ = h[C][L].size > _ ? h[C][L].size : _);
                        var M = Math.max(0, a[L] - _);
                        o[L] = Math.max(0, o[L] - M);
                    }
                    for(var g in h){
                        var P = h[g].l || {}, T = h[g].b || {}, F = P.val, q = P.size, V = T.val, H = T.size, X = r - o.r - o.l, G = n - o.t - o.b;
                        for(var N in h){
                            if (jS(q) && h[N].r) {
                                var W = h[N].r.val, re = h[N].r.size;
                                if (W > F) {
                                    var ae = (q * W + (re - X) * F) / (W - F), _e = (re * (1 - F) + (q - X) * (1 - W)) / (W - F);
                                    ae + _e > l + u && (l = ae, u = _e);
                                }
                            }
                            if (jS(H) && h[N].t) {
                                var Me = h[N].t.val, ke = h[N].t.size;
                                if (Me > V) {
                                    var ge = (H * Me + (ke - G) * V) / (Me - V), ie = (ke * (1 - V) + (H - G) * (1 - Me)) / (Me - V);
                                    ge + ie > f + c && (f = ge, c = ie);
                                }
                            }
                        }
                    }
                }
                var Te = Ca.constrain(r - a.l - a.r, Dne, v), Ee = Ca.constrain(n - a.t - a.b, zne, x), Ae = Math.max(0, r - Te), ze = Math.max(0, n - Ee);
                if (Ae) {
                    var Ce = (l + u) / Ae;
                    Ce > 1 && (l /= Ce, u /= Ce);
                }
                if (ze) {
                    var me = (f + c) / ze;
                    me > 1 && (f /= me, c /= me);
                }
                if (i.l = Math.round(l) + o.l, i.r = Math.round(u) + o.r, i.t = Math.round(c) + o.t, i.b = Math.round(f) + o.b, i.p = Math.round(a.pad), i.w = Math.round(r) - i.l - i.r, i.h = Math.round(n) - i.t - i.b, !t._replotting && (ha.didMarginChange(s, i) || Wit(e))) {
                    "_redrawFromAutoMarginCount" in t ? t._redrawFromAutoMarginCount++ : t._redrawFromAutoMarginCount = 1;
                    var Re = 3 * (1 + Object.keys(d).length);
                    if (t._redrawFromAutoMarginCount < Re) return bl.call("_doPlot", e);
                    t._size = s, Ca.warn("Too many auto-margin redraws.");
                }
                Zit(e);
            };
            function Zit(e) {
                var t = Ap.list(e, "", !0);
                [
                    "_adjustTickLabelsOverflow",
                    "_hideCounterAxisInsideTickLabels"
                ].forEach(function(r) {
                    for(var n = 0; n < t.length; n++){
                        var i = t[n][r];
                        i && i();
                    }
                });
            }
            var Ene = [
                "l",
                "r",
                "t",
                "b",
                "p",
                "w",
                "h"
            ];
            ha.didMarginChange = function(e, t) {
                for(var r = 0; r < Ene.length; r++){
                    var n = Ene[r], i = e[n], a = t[n];
                    if (!jS(i) || Math.abs(a - i) > 1) return !0;
                }
                return !1;
            };
            ha.graphJson = function(e, t, r, n, i, a) {
                (i && t && !e._fullData || i && !t && !e._fullLayout) && ha.supplyDefaults(e);
                var o = i ? e._fullData : e.data, s = i ? e._fullLayout : e.layout, l = (e._transitionData || {})._frames;
                function u(h, d) {
                    if (typeof h == "function") return d ? "_function_" : null;
                    if (Ca.isPlainObject(h)) {
                        var v = {}, x;
                        return Object.keys(h).sort().forEach(function(k) {
                            if ([
                                "_",
                                "["
                            ].indexOf(k.charAt(0)) === -1) {
                                if (typeof h[k] == "function") {
                                    d && (v[k] = "_function");
                                    return;
                                }
                                if (r === "keepdata") {
                                    if (k.substr(k.length - 3) === "src") return;
                                } else if (r === "keepstream") {
                                    if (x = h[k + "src"], typeof x == "string" && x.indexOf(":") > 0 && !Ca.isPlainObject(h.stream)) return;
                                } else if (r !== "keepall" && (x = h[k + "src"], typeof x == "string" && x.indexOf(":") > 0)) return;
                                v[k] = u(h[k], d);
                            }
                        }), v;
                    }
                    var b = Array.isArray(h), p = Ca.isTypedArray(h);
                    if ((b || p) && h.dtype && h.shape) {
                        var E = h.bdata;
                        return u({
                            dtype: h.dtype,
                            shape: h.shape,
                            bdata: Ca.isArrayBuffer(E) ? Iit.encode(E) : E
                        }, d);
                    }
                    return b ? h.map(function(k) {
                        return u(k, d);
                    }) : p ? Ca.simpleMap(h, Ca.identity) : Ca.isJSDate(h) ? Ca.ms2DateTimeLocal(+h) : h;
                }
                var c = {
                    data: (o || []).map(function(h) {
                        var d = u(h);
                        return t && delete d.fit, d;
                    })
                };
                if (!t && (c.layout = u(s), i)) {
                    var f = s._size;
                    c.layout.computed = {
                        margin: {
                            b: f.b,
                            l: f.l,
                            r: f.r,
                            t: f.t
                        }
                    };
                }
                return l && (c.frames = u(l)), a && (c.config = u(e._context, !0)), n === "object" ? c : JSON.stringify(c);
            };
            ha.modifyFrames = function(e, t) {
                var r, n, i, a = e._transitionData._frames, o = e._transitionData._frameHash;
                for(r = 0; r < t.length; r++)switch(n = t[r], n.type){
                    case "replace":
                        i = n.value;
                        var s = (a[n.index] || {}).name, l = i.name;
                        a[n.index] = o[l] = i, l !== s && (delete o[s], o[l] = i);
                        break;
                    case "insert":
                        i = n.value, o[i.name] = i, a.splice(n.index, 0, i);
                        break;
                    case "delete":
                        i = a[n.index], delete o[i.name], a.splice(n.index, 1);
                        break;
                }
                return Promise.resolve();
            };
            ha.computeFrame = function(e, t) {
                var r = e._transitionData._frameHash, n, i, a, o;
                if (!t) throw new Error("computeFrame must be given a string frame name");
                var s = r[t.toString()];
                if (!s) return !1;
                for(var l = [
                    s
                ], u = [
                    s.name
                ]; s.baseframe && (s = r[s.baseframe.toString()]) && u.indexOf(s.name) === -1;)l.push(s), u.push(s.name);
                for(var c = {}; s = l.pop();)if (s.layout && (c.layout = ha.extendLayout(c.layout, s.layout)), s.data) {
                    if (c.data || (c.data = []), i = s.traces, !i) for(i = [], n = 0; n < s.data.length; n++)i[n] = n;
                    for(c.traces || (c.traces = []), n = 0; n < s.data.length; n++)a = i[n], a != null && (o = c.traces.indexOf(a), o === -1 && (o = c.data.length, c.traces[o] = a), c.data[o] = ha.extendTrace(c.data[o], s.data[n]));
                }
                return c;
            };
            ha.recomputeFrameHash = function(e) {
                for(var t = e._transitionData._frameHash = {}, r = e._transitionData._frames, n = 0; n < r.length; n++){
                    var i = r[n];
                    i && i.name && (t[i.name] = i);
                }
            };
            ha.extendObjectWithContainers = function(e, t, r) {
                var n, i, a, o, s, l, u, c, f = Ca.extendDeepNoArrays({}, t || {}), h = Ca.expandObjectPaths(f), d = {};
                if (r && r.length) for(a = 0; a < r.length; a++)n = Ca.nestedProperty(h, r[a]), i = n.get(), i === void 0 ? Ca.nestedProperty(d, r[a]).set(null) : (n.set(null), Ca.nestedProperty(d, r[a]).set(i));
                if (e = Ca.extendDeepNoArrays(e || {}, h), r && r.length) {
                    for(a = 0; a < r.length; a++)if (s = Ca.nestedProperty(d, r[a]), u = s.get(), !!u) {
                        for(l = Ca.nestedProperty(e, r[a]), c = l.get(), Array.isArray(c) || (c = [], l.set(c)), o = 0; o < u.length; o++){
                            var v = u[o];
                            v === null ? c[o] = null : c[o] = ha.extendObjectWithContainers(c[o], v);
                        }
                        l.set(c);
                    }
                }
                return e;
            };
            ha.dataArrayContainers = [
                "transforms",
                "dimensions"
            ];
            ha.layoutArrayContainers = bl.layoutArrayContainers;
            ha.extendTrace = function(e, t) {
                return ha.extendObjectWithContainers(e, t, ha.dataArrayContainers);
            };
            ha.extendLayout = function(e, t) {
                return ha.extendObjectWithContainers(e, t, ha.layoutArrayContainers);
            };
            ha.transition = function(e, t, r, n, i, a) {
                var o = {
                    redraw: i.redraw
                }, s = {}, l = [];
                return o.prepareFn = function() {
                    for(var u = Array.isArray(t) ? t.length : 0, c = n.slice(0, u), f = 0; f < c.length; f++){
                        var h = c[f], d = e._fullData[h], v = d._module;
                        if (v) {
                            if (v.animatable) {
                                var x = v.basePlotModule.name;
                                s[x] || (s[x] = []), s[x].push(h);
                            }
                            e.data[c[f]] = ha.extendTrace(e.data[c[f]], t[f]);
                        }
                    }
                    var b = Ca.expandObjectPaths(Ca.extendDeepNoArrays({}, r)), p = /^[xy]axis[0-9]*$/;
                    for(var E in b)p.test(E) && delete b[E].range;
                    ha.extendLayout(e.layout, b), delete e.calcdata, ha.supplyDefaults(e), ha.doCalcdata(e);
                    var k = Ca.expandObjectPaths(r);
                    if (k) {
                        var A = e._fullLayout._plots;
                        for(var L in A){
                            var _ = A[L], C = _.xaxis, M = _.yaxis, g = C.range.slice(), P = M.range.slice(), T = null, F = null, q = null, V = null;
                            Array.isArray(k[C._name + ".range"]) ? T = k[C._name + ".range"].slice() : Array.isArray((k[C._name] || {}).range) && (T = k[C._name].range.slice()), Array.isArray(k[M._name + ".range"]) ? F = k[M._name + ".range"].slice() : Array.isArray((k[M._name] || {}).range) && (F = k[M._name].range.slice()), g && T && (C.r2l(g[0]) !== C.r2l(T[0]) || C.r2l(g[1]) !== C.r2l(T[1])) && (q = {
                                xr0: g,
                                xr1: T
                            }), P && F && (M.r2l(P[0]) !== M.r2l(F[0]) || M.r2l(P[1]) !== M.r2l(F[1])) && (V = {
                                yr0: P,
                                yr1: F
                            }), (q || V) && l.push(Ca.extendFlat({
                                plotinfo: _
                            }, q, V));
                        }
                    }
                    return Promise.resolve();
                }, o.runFn = function(u) {
                    var c, f = e._fullLayout._basePlotModules, h = l.length, d;
                    if (r) for(d = 0; d < f.length; d++)f[d].transitionAxes && f[d].transitionAxes(e, l, a, u);
                    h ? (c = Ca.extendFlat({}, a), c.duration = 0, delete s.cartesian) : c = a;
                    for(var v in s){
                        var x = s[v], b = e._fullData[x[0]]._module;
                        b.basePlotModule.plot(e, x, c, u);
                    }
                }, Fne(e, a, o);
            };
            ha.transitionFromReact = function(e, t, r, n) {
                var i = e._fullLayout, a = i.transition, o = {}, s = [];
                return o.prepareFn = function() {
                    var l = i._plots;
                    o.redraw = !1, t.anim === "some" && (o.redraw = !0), r.anim === "some" && (o.redraw = !0);
                    for(var u in l){
                        var c = l[u], f = c.xaxis, h = c.yaxis, d = n[f._name].range.slice(), v = n[h._name].range.slice(), x = f.range.slice(), b = h.range.slice();
                        f.setScale(), h.setScale();
                        var p = null, E = null;
                        (f.r2l(d[0]) !== f.r2l(x[0]) || f.r2l(d[1]) !== f.r2l(x[1])) && (p = {
                            xr0: d,
                            xr1: x
                        }), (h.r2l(v[0]) !== h.r2l(b[0]) || h.r2l(v[1]) !== h.r2l(b[1])) && (E = {
                            yr0: v,
                            yr1: b
                        }), (p || E) && s.push(Ca.extendFlat({
                            plotinfo: c
                        }, p, E));
                    }
                    return Promise.resolve();
                }, o.runFn = function(l) {
                    for(var u = e._fullData, c = e._fullLayout, f = c._basePlotModules, h, d, v, x = [], b = 0; b < u.length; b++)x.push(b);
                    function p() {
                        if (e._fullLayout) for(var k = 0; k < f.length; k++)f[k].transitionAxes && f[k].transitionAxes(e, s, h, l);
                    }
                    function E() {
                        if (e._fullLayout) for(var k = 0; k < f.length; k++)f[k].plot(e, v, d, l);
                    }
                    s.length && t.anim ? a.ordering === "traces first" ? (h = Ca.extendFlat({}, a, {
                        duration: 0
                    }), v = x, d = a, setTimeout(p, a.duration), E()) : (h = a, v = null, d = Ca.extendFlat({}, a, {
                        duration: 0
                    }), setTimeout(E, h.duration), p()) : s.length ? (h = a, p()) : t.anim && (v = x, d = a, E());
                }, Fne(e, a, o);
            };
            function Fne(e, t, r) {
                var n = !1;
                function i(f) {
                    var h = Promise.resolve();
                    if (!f) return h;
                    for(; f.length;)h = h.then(f.shift());
                    return h;
                }
                function a(f) {
                    if (f) for(; f.length;)f.shift();
                }
                function o() {
                    return e.emit("plotly_transitioning", []), new Promise(function(f) {
                        e._transitioning = !0, t.duration > 0 && (e._transitioningWithDuration = !0), e._transitionData._interruptCallbacks.push(function() {
                            n = !0;
                        }), r.redraw && e._transitionData._interruptCallbacks.push(function() {
                            return bl.call("redraw", e);
                        }), e._transitionData._interruptCallbacks.push(function() {
                            e.emit("plotly_transitioninterrupted", []);
                        });
                        var h = 0, d = 0;
                        function v() {
                            return h++, function() {
                                d++, !n && d === h && s(f);
                            };
                        }
                        r.runFn(v), setTimeout(v());
                    });
                }
                function s(f) {
                    if (e._transitionData) return a(e._transitionData._interruptCallbacks), Promise.resolve().then(function() {
                        if (r.redraw) return bl.call("redraw", e);
                    }).then(function() {
                        e._transitioning = !1, e._transitioningWithDuration = !1, e.emit("plotly_transitioned", []);
                    }).then(f);
                }
                function l() {
                    if (e._transitionData) return e._transitioning = !1, i(e._transitionData._interruptCallbacks);
                }
                var u = [
                    ha.previousPromises,
                    l,
                    r.prepareFn,
                    ha.rehover,
                    ha.reselect,
                    o
                ], c = Ca.syncOrAsync(u, e);
                return (!c || !c.then) && (c = Promise.resolve()), c.then(function() {
                    return e;
                });
            }
            ha.doCalcdata = function(e, t) {
                var r = Ap.list(e), n = e._fullData, i = e._fullLayout, a, o, s, l, u = new Array(n.length), c = (e.calcdata || []).slice();
                for(e.calcdata = u, i._numBoxes = 0, i._numViolins = 0, i._violinScaleGroupStats = {}, e._hmpixcount = 0, e._hmlumcount = 0, i._piecolormap = {}, i._sunburstcolormap = {}, i._treemapcolormap = {}, i._iciclecolormap = {}, i._funnelareacolormap = {}, s = 0; s < n.length; s++)if (Array.isArray(t) && t.indexOf(s) === -1) {
                    u[s] = c[s];
                    continue;
                }
                for(s = 0; s < n.length; s++)a = n[s], a._arrayAttrs = Pne.findArrayAttributes(a), a._extremes = {};
                var f = i._subplots.polar || [];
                for(s = 0; s < f.length; s++)r.push(i[f[s]].radialaxis, i[f[s]].angularaxis);
                for(var h in i._colorAxes){
                    var d = i[h];
                    d.cauto !== !1 && (delete d.cmin, delete d.cmax);
                }
                var v = !1;
                function x(E) {
                    if (a = n[E], o = a._module, a.visible === !0 && a.transforms) {
                        if (o && o.calc) {
                            var k = o.calc(e, a);
                            k[0] && k[0].t && k[0].t._scene && delete k[0].t._scene.dirty;
                        }
                        for(l = 0; l < a.transforms.length; l++){
                            var A = a.transforms[l];
                            o = transformsRegistry[A.type], o && o.calcTransform && (a._hasCalcTransform = !0, v = !0, o.calcTransform(e, a, A));
                        }
                    }
                }
                function b(E, k) {
                    if (a = n[E], o = a._module, !!o.isContainer === k) {
                        var A = [];
                        if (a.visible === !0 && a._length !== 0) {
                            delete a._indexToPoints;
                            var L = a.transforms || [];
                            for(l = L.length - 1; l >= 0; l--)if (L[l].enabled) {
                                a._indexToPoints = L[l]._indexToPoints;
                                break;
                            }
                            o && o.calc && (A = o.calc(e, a));
                        }
                        (!Array.isArray(A) || !A[0]) && (A = [
                            {
                                x: Ane,
                                y: Ane
                            }
                        ]), A[0].t || (A[0].t = {}), A[0].trace = a, u[E] = A;
                    }
                }
                for(kne(r, n, i), s = 0; s < n.length; s++)b(s, !0);
                for(s = 0; s < n.length; s++)x(s);
                for(v && kne(r, n, i), s = 0; s < n.length; s++)b(s, !0);
                for(s = 0; s < n.length; s++)b(s, !1);
                Cne(e);
                var p = Yit(r, e);
                if (p.length) {
                    for(i._numBoxes = 0, i._numViolins = 0, s = 0; s < p.length; s++)b(p[s], !0);
                    for(s = 0; s < p.length; s++)b(p[s], !1);
                    Cne(e);
                }
                bl.getComponentMethod("fx", "calc")(e), bl.getComponentMethod("errorbars", "calc")(e);
            };
            var Xit = /(total|sum|min|max|mean|geometric mean|median) (ascending|descending)/;
            function Yit(e, t) {
                var r = [], n, i, a, o, s;
                function l(N, W, re) {
                    var ae = W._id.charAt(0);
                    if (N === "histogram2dcontour") {
                        var _e = W._counterAxes[0], Me = Ap.getFromId(t, _e), ke = ae === "x" || _e === "x" && Me.type === "category", ge = ae === "y" || _e === "y" && Me.type === "category";
                        return function(ie, Te) {
                            return ie === 0 || Te === 0 || ke && ie === re[Te].length - 1 || ge && Te === re.length - 1 ? -1 : (ae === "y" ? Te : ie) - 1;
                        };
                    } else return function(ie, Te) {
                        return ae === "y" ? Te : ie;
                    };
                }
                var u = {
                    min: function(N) {
                        return Ca.aggNums(Math.min, null, N);
                    },
                    max: function(N) {
                        return Ca.aggNums(Math.max, null, N);
                    },
                    sum: function(N) {
                        return Ca.aggNums(function(W, re) {
                            return W + re;
                        }, null, N);
                    },
                    total: function(N) {
                        return Ca.aggNums(function(W, re) {
                            return W + re;
                        }, null, N);
                    },
                    mean: function(N) {
                        return Ca.mean(N);
                    },
                    "geometric mean": function(N) {
                        return Ca.geometricMean(N);
                    },
                    median: function(N) {
                        return Ca.median(N);
                    }
                };
                function c(N, W) {
                    return N[1] - W[1];
                }
                function f(N, W) {
                    return W[1] - N[1];
                }
                for(n = 0; n < e.length; n++){
                    var h = e[n];
                    if (h.type === "category") {
                        var d = h.categoryorder.match(Xit);
                        if (d) {
                            var v = d[1], x = d[2], b = h._id.charAt(0), p = b === "x", E = [];
                            for(i = 0; i < h._categories.length; i++)E.push([
                                h._categories[i],
                                []
                            ]);
                            for(i = 0; i < h._traceIndices.length; i++){
                                var k = h._traceIndices[i], A = t._fullData[k];
                                if (A.visible === !0) {
                                    var L = A.type;
                                    bl.traceIs(A, "histogram") && (delete A._xautoBinFinished, delete A._yautoBinFinished);
                                    var _ = L === "splom", C = L === "scattergl", M = t.calcdata[k];
                                    for(a = 0; a < M.length; a++){
                                        var g = M[a], P, T;
                                        if (_) {
                                            var F = A._axesDim[h._id];
                                            if (!p) {
                                                var q = A._diag[F][0];
                                                q && (h = t._fullLayout[Ap.id2name(q)]);
                                            }
                                            var V = g.trace.dimensions[F].values;
                                            for(o = 0; o < V.length; o++)for(P = h._categoriesMap[V[o]], s = 0; s < g.trace.dimensions.length; s++)if (s !== F) {
                                                var H = g.trace.dimensions[s];
                                                E[P][1].push(H.values[o]);
                                            }
                                        } else if (C) {
                                            for(o = 0; o < g.t.x.length; o++)p ? (P = g.t.x[o], T = g.t.y[o]) : (P = g.t.y[o], T = g.t.x[o]), E[P][1].push(T);
                                            g.t && g.t._scene && delete g.t._scene.dirty;
                                        } else if (g.hasOwnProperty("z")) {
                                            T = g.z;
                                            var X = l(A.type, h, T);
                                            for(o = 0; o < T.length; o++)for(s = 0; s < T[o].length; s++)P = X(s, o), P + 1 && E[P][1].push(T[o][s]);
                                        } else for(P = g.p, P === void 0 && (P = g[b]), T = g.s, T === void 0 && (T = g.v), T === void 0 && (T = p ? g.y : g.x), Array.isArray(T) || (T === void 0 ? T = [] : T = [
                                            T
                                        ]), o = 0; o < T.length; o++)E[P][1].push(T[o]);
                                    }
                                }
                            }
                            h._categoriesValue = E;
                            var G = [];
                            for(i = 0; i < E.length; i++)G.push([
                                E[i][0],
                                u[v](E[i][1])
                            ]);
                            G.sort(x === "descending" ? f : c), h._categoriesAggregatedValue = G, h._initialCategories = G.map(function(N) {
                                return N[0];
                            }), r = r.concat(h.sortByInitialCategories());
                        }
                    }
                }
                return r;
            }
            function kne(e, t, r) {
                var n = {};
                function i(l) {
                    l.clearCalc(), l.type === "multicategory" && l.setupMultiCategory(t), n[l._id] = 1;
                }
                Ca.simpleMap(e, i);
                for(var a = r._axisMatchGroups || [], o = 0; o < a.length; o++)for(var s in a[o])n[s] || i(r[Ap.id2name(s)]);
            }
            function Cne(e) {
                var t = e._fullLayout, r = t._visibleModules, n = {}, i, a, o;
                for(a = 0; a < r.length; a++){
                    var s = r[a], l = s.crossTraceCalc;
                    if (l) {
                        var u = s.basePlotModule.name;
                        n[u] ? Ca.pushUnique(n[u], l) : n[u] = [
                            l
                        ];
                    }
                }
                for(o in n){
                    var c = n[o], f = t._subplots[o];
                    if (Array.isArray(f)) for(i = 0; i < f.length; i++){
                        var h = f[i], d = o === "cartesian" ? t._plots[h] : t[h];
                        for(a = 0; a < c.length; a++)c[a](e, d, h);
                    }
                    else for(a = 0; a < c.length; a++)c[a](e);
                }
            }
            ha.rehover = function(e) {
                e._fullLayout._rehover && e._fullLayout._rehover();
            };
            ha.redrag = function(e) {
                e._fullLayout._redrag && e._fullLayout._redrag();
            };
            ha.reselect = function(e) {
                var t = e._fullLayout, r = (e.layout || {}).selections, n = t._previousSelections;
                t._previousSelections = r;
                var i = t._reselect || JSON.stringify(r) !== JSON.stringify(n);
                bl.getComponentMethod("selections", "reselect")(e, i);
            };
            ha.generalUpdatePerTraceModule = function(e, t, r, n) {
                var i = t.traceHash, a = {}, o;
                for(o = 0; o < r.length; o++){
                    var s = r[o], l = s[0].trace;
                    l.visible && (a[l.type] = a[l.type] || [], a[l.type].push(s));
                }
                for(var u in i)if (!a[u]) {
                    var c = i[u][0], f = c[0].trace;
                    f.visible = !1, a[u] = [
                        c
                    ];
                }
                for(var h in a){
                    var d = a[h], v = d[0][0].trace._module;
                    v.plot(e, t, Ca.filterVisible(d), n);
                }
                t.traceHash = a;
            };
            ha.plotBasePlot = function(e, t, r, n, i) {
                var a = bl.getModule(e), o = qit(t.calcdata, a)[0];
                a.plot(t, o, n, i);
            };
            ha.cleanBasePlot = function(e, t, r, n, i) {
                var a = i._has && i._has(e), o = r._has && r._has(e);
                a && !o && i["_" + e + "layer"].selectAll("g.trace").remove();
            };
        });
        var Zp = ye((yb)=>{
            "use strict";
            yb.xmlns = "http://www.w3.org/2000/xmlns/";
            yb.svg = "http://www.w3.org/2000/svg";
            yb.xlink = "http://www.w3.org/1999/xlink";
            yb.svgAttrs = {
                xmlns: yb.svg,
                "xmlns:xlink": yb.xlink
            };
        });
        var Nh = ye((jtr, One)=>{
            "use strict";
            One.exports = {
                FROM_BL: {
                    left: 0,
                    center: .5,
                    right: 1,
                    bottom: 0,
                    middle: .5,
                    top: 1
                },
                FROM_TL: {
                    left: 0,
                    center: .5,
                    right: 1,
                    bottom: 1,
                    middle: .5,
                    top: 0
                },
                FROM_BR: {
                    left: 1,
                    center: .5,
                    right: 0,
                    bottom: 0,
                    middle: .5,
                    top: 1
                },
                LINE_SPACING: 1.3,
                CAP_SHIFT: .7,
                MID_SHIFT: .35,
                OPPOSITE_SIDE: {
                    left: "right",
                    right: "left",
                    top: "bottom",
                    bottom: "top"
                }
            };
        });
        var Pl = ye((b0)=>{
            "use strict";
            var vh = xa(), Ty = Mr(), Kit = Ty.strTranslate, uO = Zp(), Jit = Nh().LINE_SPACING, $it = /([^$]*)([$]+[^$]*[$]+)([^$]*)/;
            b0.convertToTspans = function(e, t, r) {
                var n = e.text(), i = !e.attr("data-notex") && t && t._context.typesetMath && typeof MathJax != "undefined" && n.match($it), a = vh.select(e.node().parentNode);
                if (a.empty()) return;
                var o = e.attr("class") ? e.attr("class").split(" ")[0] : "text";
                o += "-math", a.selectAll("svg." + o).remove(), a.selectAll("g." + o + "-group").remove(), e.style("display", null).attr({
                    "data-unformatted": n,
                    "data-math": "N"
                });
                function s() {
                    a.empty() || (o = e.attr("class") + "-math", a.select("svg." + o).remove()), e.text("").style("white-space", "pre");
                    var l = fnt(e.node(), n);
                    l && e.style("pointer-events", "all"), b0.positionText(e), r && r.call(e);
                }
                return i ? (t && t._promises || []).push(new Promise(function(l) {
                    e.style("display", "none");
                    var u = parseInt(e.node().style.fontSize, 10), c = {
                        fontSize: u
                    };
                    rnt(i[2], c, function(f, h, d) {
                        a.selectAll("svg." + o).remove(), a.selectAll("g." + o + "-group").remove();
                        var v = f && f.select("svg");
                        if (!v || !v.node()) {
                            s(), l();
                            return;
                        }
                        var x = a.append("g").classed(o + "-group", !0).attr({
                            "pointer-events": "none",
                            "data-unformatted": n,
                            "data-math": "Y"
                        });
                        x.node().appendChild(v.node()), h && h.node() && v.node().insertBefore(h.node().cloneNode(!0), v.node().firstChild);
                        var b = d.width, p = d.height;
                        v.attr({
                            class: o,
                            height: p,
                            preserveAspectRatio: "xMinYMin meet"
                        }).style({
                            overflow: "visible",
                            "pointer-events": "none"
                        });
                        var E = e.node().style.fill || "black", k = v.select("g");
                        k.attr({
                            fill: E,
                            stroke: E
                        });
                        var A = k.node().getBoundingClientRect(), L = A.width, _ = A.height;
                        (L > b || _ > p) && (v.style("overflow", "hidden"), A = v.node().getBoundingClientRect(), L = A.width, _ = A.height);
                        var C = +e.attr("x"), M = +e.attr("y"), g = u || e.node().getBoundingClientRect().height, P = -g / 4;
                        if (o[0] === "y") x.attr({
                            transform: "rotate(" + [
                                -90,
                                C,
                                M
                            ] + ")" + Kit(-L / 2, P - _ / 2)
                        });
                        else if (o[0] === "l") M = P - _ / 2;
                        else if (o[0] === "a" && o.indexOf("atitle") !== 0) C = 0, M = P;
                        else {
                            var T = e.attr("text-anchor");
                            C = C - L * (T === "middle" ? .5 : T === "end" ? 1 : 0), M = M + P - _ / 2;
                        }
                        v.attr({
                            x: C,
                            y: M
                        }), r && r.call(e, x), l(x);
                    });
                })) : s(), e;
            };
            var Qit = /(<|&lt;|&#60;)/g, ent = /(>|&gt;|&#62;)/g;
            function tnt(e) {
                return e.replace(Qit, "\\lt ").replace(ent, "\\gt ");
            }
            var Bne = [
                [
                    "$",
                    "$"
                ],
                [
                    "\\(",
                    "\\)"
                ]
            ];
            function rnt(e, t, r) {
                var n = parseInt((MathJax.version || "").split(".")[0]);
                if (n !== 2 && n !== 3) {
                    Ty.warn("No MathJax version:", MathJax.version);
                    return;
                }
                var i, a, o, s, l = function() {
                    return a = Ty.extendDeepAll({}, MathJax.Hub.config), o = MathJax.Hub.processSectionDelay, MathJax.Hub.processSectionDelay !== void 0 && (MathJax.Hub.processSectionDelay = 0), MathJax.Hub.Config({
                        messageStyle: "none",
                        tex2jax: {
                            inlineMath: Bne
                        },
                        displayAlign: "left"
                    });
                }, u = function() {
                    a = Ty.extendDeepAll({}, MathJax.config), MathJax.config.tex || (MathJax.config.tex = {}), MathJax.config.tex.inlineMath = Bne;
                }, c = function() {
                    if (i = MathJax.Hub.config.menuSettings.renderer, i !== "SVG") return MathJax.Hub.setRenderer("SVG");
                }, f = function() {
                    i = MathJax.config.startup.output, i !== "svg" && (MathJax.config.startup.output = "svg");
                }, h = function() {
                    var E = "math-output-" + Ty.randstr({}, 64);
                    s = vh.select("body").append("div").attr({
                        id: E
                    }).style({
                        visibility: "hidden",
                        position: "absolute",
                        "font-size": t.fontSize + "px"
                    }).text(tnt(e));
                    var k = s.node();
                    return n === 2 ? MathJax.Hub.Typeset(k) : MathJax.typeset([
                        k
                    ]);
                }, d = function() {
                    var E = s.select(n === 2 ? ".MathJax_SVG" : ".MathJax"), k = !E.empty() && s.select("svg").node();
                    if (!k) Ty.log("There was an error in the tex syntax.", e), r();
                    else {
                        var A = k.getBoundingClientRect(), L;
                        n === 2 ? L = vh.select("body").select("#MathJax_SVG_glyphs") : L = E.select("defs"), r(E, L, A);
                    }
                    s.remove();
                }, v = function() {
                    if (i !== "SVG") return MathJax.Hub.setRenderer(i);
                }, x = function() {
                    i !== "svg" && (MathJax.config.startup.output = i);
                }, b = function() {
                    return o !== void 0 && (MathJax.Hub.processSectionDelay = o), MathJax.Hub.Config(a);
                }, p = function() {
                    MathJax.config = a;
                };
                n === 2 ? MathJax.Hub.Queue(l, c, h, d, v, b) : n === 3 && (u(), f(), MathJax.startup.defaultReady(), MathJax.startup.promise.then(function() {
                    h(), d(), x(), p();
                }));
            }
            var Hne = {
                sup: "font-size:70%",
                sub: "font-size:70%",
                s: "text-decoration:line-through",
                u: "text-decoration:underline",
                b: "font-weight:bold",
                i: "font-style:italic",
                a: "cursor:pointer",
                span: "",
                em: "font-style:italic;font-weight:bold"
            }, int = {
                sub: "0.3em",
                sup: "-0.6em"
            }, nnt = {
                sub: "-0.21em",
                sup: "0.42em"
            }, Nne = "\u200B", Une = [
                "http:",
                "https:",
                "mailto:",
                "",
                void 0,
                ":"
            ], Gne = b0.NEWLINES = /(\r\n?|\n)/g, fO = /(<[^<>]*>)/, hO = /<(\/?)([^ >]*)(\s+(.*))?>/i, ant = /<br(\s+.*)?>/i;
            b0.BR_TAG_ALL = /<br(\s+.*)?>/gi;
            var jne = /(^|[\s"'])style\s*=\s*("([^"]*);?"|'([^']*);?')/i, Wne = /(^|[\s"'])href\s*=\s*("([^"]*)"|'([^']*)')/i, Zne = /(^|[\s"'])target\s*=\s*("([^"\s]*)"|'([^'\s]*)')/i, ont = /(^|[\s"'])popup\s*=\s*("([\w=,]*)"|'([\w=,]*)')/i;
            function _b(e, t) {
                if (!e) return null;
                var r = e.match(t), n = r && (r[3] || r[4]);
                return n && Z6(n);
            }
            var snt = /(^|;)\s*color:/;
            b0.plainText = function(e, t) {
                t = t || {};
                for(var r = t.len !== void 0 && t.len !== -1 ? t.len : 1 / 0, n = t.allowedTags !== void 0 ? t.allowedTags : [
                    "br"
                ], i = "...", a = i.length, o = e.split(fO), s = [], l = "", u = 0, c = 0; c < o.length; c++){
                    var f = o[c], h = f.match(hO), d = h && h[2].toLowerCase();
                    if (d) n.indexOf(d) !== -1 && (s.push(f), l = d);
                    else {
                        var v = f.length;
                        if (u + v < r) s.push(f), u += v;
                        else if (u < r) {
                            var x = r - u;
                            l && (l !== "br" || x <= a || v <= a) && s.pop(), r > a ? s.push(f.substr(0, x - a) + i) : s.push(f.substr(0, x));
                            break;
                        }
                        l = "";
                    }
                }
                return s.join("");
            };
            var lnt = {
                mu: "\u03BC",
                amp: "&",
                lt: "<",
                gt: ">",
                nbsp: "\xA0",
                times: "\xD7",
                plusmn: "\xB1",
                deg: "\xB0"
            }, unt = /&(#\d+|#x[\da-fA-F]+|[a-z]+);/g;
            function Z6(e) {
                return e.replace(unt, function(t, r) {
                    var n;
                    return r.charAt(0) === "#" ? n = cnt(r.charAt(1) === "x" ? parseInt(r.substr(2), 16) : parseInt(r.substr(1), 10)) : n = lnt[r], n || t;
                });
            }
            b0.convertEntities = Z6;
            function cnt(e) {
                if (!(e > 1114111)) {
                    var t = String.fromCodePoint;
                    if (t) return t(e);
                    var r = String.fromCharCode;
                    return e <= 65535 ? r(e) : r((e >> 10) + 55232, e % 1024 + 56320);
                }
            }
            function fnt(e, t) {
                t = t.replace(Gne, " ");
                var r = !1, n = [], i, a = -1;
                function o() {
                    a++;
                    var _ = document.createElementNS(uO.svg, "tspan");
                    vh.select(_).attr({
                        class: "line",
                        dy: a * Jit + "em"
                    }), e.appendChild(_), i = _;
                    var C = n;
                    if (n = [
                        {
                            node: _
                        }
                    ], C.length > 1) for(var M = 1; M < C.length; M++)s(C[M]);
                }
                function s(_) {
                    var C = _.type, M = {}, g;
                    if (C === "a") {
                        g = "a";
                        var P = _.target, T = _.href, F = _.popup;
                        T && (M = {
                            "xlink:xlink:show": P === "_blank" || P.charAt(0) !== "_" ? "new" : "replace",
                            target: P,
                            "xlink:xlink:href": T
                        }, F && (M.onclick = 'window.open(this.href.baseVal,this.target.baseVal,"' + F + '");return false;'));
                    } else g = "tspan";
                    _.style && (M.style = _.style);
                    var q = document.createElementNS(uO.svg, g);
                    if (C === "sup" || C === "sub") {
                        l(i, Nne), i.appendChild(q);
                        var V = document.createElementNS(uO.svg, "tspan");
                        l(V, Nne), vh.select(V).attr("dy", nnt[C]), M.dy = int[C], i.appendChild(q), i.appendChild(V);
                    } else i.appendChild(q);
                    vh.select(q).attr(M), i = _.node = q, n.push(_);
                }
                function l(_, C) {
                    _.appendChild(document.createTextNode(C));
                }
                function u(_) {
                    if (n.length === 1) {
                        Ty.log("Ignoring unexpected end tag </" + _ + ">.", t);
                        return;
                    }
                    var C = n.pop();
                    _ !== C.type && Ty.log("Start tag <" + C.type + "> doesnt match end tag <" + _ + ">. Pretending it did match.", t), i = n[n.length - 1].node;
                }
                var c = ant.test(t);
                c ? o() : (i = e, n = [
                    {
                        node: e
                    }
                ]);
                for(var f = t.split(fO), h = 0; h < f.length; h++){
                    var d = f[h], v = d.match(hO), x = v && v[2].toLowerCase(), b = Hne[x];
                    if (x === "br") o();
                    else if (b === void 0) l(i, Z6(d));
                    else if (v[1]) u(x);
                    else {
                        var p = v[4], E = {
                            type: x
                        }, k = _b(p, jne);
                        if (k ? (k = k.replace(snt, "$1 fill:"), b && (k += ";" + b)) : b && (k = b), k && (E.style = k), x === "a") {
                            r = !0;
                            var A = _b(p, Wne);
                            if (A) {
                                var L = Xne(A);
                                L && (E.href = L, E.target = _b(p, Zne) || "_blank", E.popup = _b(p, ont));
                            }
                        }
                        s(E);
                    }
                }
                return r;
            }
            function Xne(e) {
                var t = encodeURI(decodeURI(e)), r = document.createElement("a"), n = document.createElement("a");
                r.href = e, n.href = t;
                var i = r.protocol, a = n.protocol;
                return Une.indexOf(i) !== -1 && Une.indexOf(a) !== -1 ? t : "";
            }
            b0.sanitizeHTML = function(t) {
                t = t.replace(Gne, " ");
                for(var r = document.createElement("p"), n = r, i = [], a = t.split(fO), o = 0; o < a.length; o++){
                    var s = a[o], l = s.match(hO), u = l && l[2].toLowerCase();
                    if (u in Hne) {
                        if (l[1]) i.length && (n = i.pop());
                        else {
                            var c = l[4], f = _b(c, jne), h = f ? {
                                style: f
                            } : {};
                            if (u === "a") {
                                var d = _b(c, Wne);
                                if (d) {
                                    var v = Xne(d);
                                    if (v) {
                                        h.href = v;
                                        var x = _b(c, Zne);
                                        x && (h.target = x);
                                    }
                                }
                            }
                            var b = document.createElement(u);
                            n.appendChild(b), vh.select(b).attr(h), n = b, i.push(b);
                        }
                    } else n.appendChild(document.createTextNode(Z6(s)));
                }
                var p = "innerHTML";
                return r[p];
            };
            b0.lineCount = function(t) {
                return t.selectAll("tspan.line").size() || 1;
            };
            b0.positionText = function(t, r, n) {
                return t.each(function() {
                    var i = vh.select(this);
                    function a(l, u) {
                        return u === void 0 ? (u = i.attr(l), u === null && (i.attr(l, 0), u = 0)) : i.attr(l, u), u;
                    }
                    var o = a("x", r), s = a("y", n);
                    this.nodeName === "text" && i.selectAll("tspan.line").attr({
                        x: o,
                        y: s
                    });
                });
            };
            function Vne(e, t, r) {
                var n = r.horizontalAlign, i = r.verticalAlign || "top", a = e.node().getBoundingClientRect(), o = t.node().getBoundingClientRect(), s, l, u;
                return i === "bottom" ? l = function() {
                    return a.bottom - s.height;
                } : i === "middle" ? l = function() {
                    return a.top + (a.height - s.height) / 2;
                } : l = function() {
                    return a.top;
                }, n === "right" ? u = function() {
                    return a.right - s.width;
                } : n === "center" ? u = function() {
                    return a.left + (a.width - s.width) / 2;
                } : u = function() {
                    return a.left;
                }, function() {
                    s = this.node().getBoundingClientRect();
                    var c = u() - o.left, f = l() - o.top, h = r.gd || {};
                    if (r.gd) {
                        h._fullLayout._calcInverseTransform(h);
                        var d = Ty.apply3DTransform(h._fullLayout._invTransform)(c, f);
                        c = d[0], f = d[1];
                    }
                    return this.style({
                        top: f + "px",
                        left: c + "px",
                        "z-index": 1e3
                    }), this;
                };
            }
            var cO = "1px ";
            b0.makeTextShadow = function(e) {
                var t = cO, r = cO, n = cO;
                return t + r + n + e + ", -" + t + "-" + r + n + e + ", " + t + "-" + r + n + e + ", -" + t + r + n + e;
            };
            b0.makeEditable = function(e, t) {
                var r = t.gd, n = t.delegate, i = vh.dispatch("edit", "input", "cancel"), a = n || e;
                if (e.style({
                    "pointer-events": n ? "none" : "all"
                }), e.size() !== 1) throw new Error("boo");
                function o() {
                    l(), e.style({
                        opacity: 0
                    });
                    var u = a.attr("class"), c;
                    u ? c = "." + u.split(" ")[0] + "-math-group" : c = "[class*=-math-group]", c && vh.select(e.node().parentNode).select(c).style({
                        opacity: 0
                    });
                }
                function s(u) {
                    var c = u.node(), f = document.createRange();
                    f.selectNodeContents(c);
                    var h = window.getSelection();
                    h.removeAllRanges(), h.addRange(f), c.focus();
                }
                function l() {
                    var u = vh.select(r), c = u.select(".svg-container"), f = c.append("div"), h = e.node().style, d = parseFloat(h.fontSize || 12), v = t.text;
                    v === void 0 && (v = e.attr("data-unformatted")), f.classed("plugin-editable editable", !0).style({
                        position: "absolute",
                        "font-family": h.fontFamily || "Arial",
                        "font-size": d,
                        color: t.fill || h.fill || "black",
                        opacity: 1,
                        "background-color": t.background || "transparent",
                        outline: "#ffffff33 1px solid",
                        margin: [
                            -d / 8 + 1,
                            0,
                            0,
                            -1
                        ].join("px ") + "px",
                        padding: "0",
                        "box-sizing": "border-box"
                    }).attr({
                        contenteditable: !0
                    }).text(v).call(Vne(e, c, t)).on("blur", function() {
                        r._editing = !1, e.text(this.textContent).style({
                            opacity: 1
                        });
                        var x = vh.select(this).attr("class"), b;
                        x ? b = "." + x.split(" ")[0] + "-math-group" : b = "[class*=-math-group]", b && vh.select(e.node().parentNode).select(b).style({
                            opacity: 0
                        });
                        var p = this.textContent;
                        vh.select(this).transition().duration(0).remove(), vh.select(document).on("mouseup", null), i.edit.call(e, p);
                    }).on("focus", function() {
                        var x = this;
                        r._editing = !0, vh.select(document).on("mouseup", function() {
                            if (vh.event.target === x) return !1;
                            document.activeElement === f.node() && f.node().blur();
                        });
                    }).on("keyup", function() {
                        vh.event.which === 27 ? (r._editing = !1, e.style({
                            opacity: 1
                        }), vh.select(this).style({
                            opacity: 0
                        }).on("blur", function() {
                            return !1;
                        }).transition().remove(), i.cancel.call(e, this.textContent)) : (i.input.call(e, this.textContent), vh.select(this).call(Vne(e, c, t)));
                    }).on("keydown", function() {
                        vh.event.which === 13 && this.blur();
                    }).call(s);
                }
                return t.immediate ? o() : a.on("click", o), vh.rebind(e, i, "on");
            };
        });
        var Dv = ye((Ztr, rae)=>{
            "use strict";
            var hnt = xa(), Y6 = id(), ZS = uo(), X6 = Mr(), Yne = va(), dnt = sb().isValid;
            function vnt(e, t, r) {
                var n = t ? X6.nestedProperty(e, t).get() || {} : e, i = n[r || "color"];
                i && i._inputArray && (i = i._inputArray);
                var a = !1;
                if (X6.isArrayOrTypedArray(i)) {
                    for(var o = 0; o < i.length; o++)if (ZS(i[o])) {
                        a = !0;
                        break;
                    }
                }
                return X6.isPlainObject(n) && (a || n.showscale === !0 || ZS(n.cmin) && ZS(n.cmax) || dnt(n.colorscale) || X6.isPlainObject(n.colorbar));
            }
            var Kne = [
                "showscale",
                "autocolorscale",
                "colorscale",
                "reversescale",
                "colorbar"
            ], WS = [
                "min",
                "max",
                "mid",
                "auto"
            ];
            function $ne(e) {
                var t = e._colorAx, r = t || e, n = {}, i, a, o;
                for(a = 0; a < Kne.length; a++)o = Kne[a], n[o] = r[o];
                if (t) for(i = "c", a = 0; a < WS.length; a++)o = WS[a], n[o] = r["c" + o];
                else {
                    var s;
                    for(a = 0; a < WS.length; a++){
                        if (o = WS[a], s = "c" + o, s in r) {
                            n[o] = r[s];
                            continue;
                        }
                        s = "z" + o, s in r && (n[o] = r[s]);
                    }
                    i = s.charAt(0);
                }
                return n._sync = function(l, u) {
                    var c = WS.indexOf(l) !== -1 ? i + l : l;
                    r[c] = r["_" + c] = u;
                }, n;
            }
            function Qne(e) {
                for(var t = $ne(e), r = t.min, n = t.max, i = t.reversescale ? eae(t.colorscale) : t.colorscale, a = i.length, o = new Array(a), s = new Array(a), l = 0; l < a; l++){
                    var u = i[l];
                    o[l] = r + u[0] * (n - r), s[l] = u[1];
                }
                return {
                    domain: o,
                    range: s
                };
            }
            function eae(e) {
                for(var t = e.length, r = new Array(t), n = t - 1, i = 0; n >= 0; n--, i++){
                    var a = e[n];
                    r[i] = [
                        1 - a[0],
                        a[1]
                    ];
                }
                return r;
            }
            function tae(e, t) {
                t = t || {};
                for(var r = e.domain, n = e.range, i = n.length, a = new Array(i), o = 0; o < i; o++){
                    var s = Y6(n[o]).toRgb();
                    a[o] = [
                        s.r,
                        s.g,
                        s.b,
                        s.a
                    ];
                }
                var l = hnt.scale.linear().domain(r).range(a).clamp(!0), u = t.noNumericCheck, c = t.returnArray, f;
                return u && c ? f = l : u ? f = function(h) {
                    return Jne(l(h));
                } : c ? f = function(h) {
                    return ZS(h) ? l(h) : Y6(h).isValid() ? h : Yne.defaultLine;
                } : f = function(h) {
                    return ZS(h) ? Jne(l(h)) : Y6(h).isValid() ? h : Yne.defaultLine;
                }, f.domain = l.domain, f.range = function() {
                    return n;
                }, f;
            }
            function pnt(e, t) {
                return tae(Qne(e), t);
            }
            function Jne(e) {
                var t = {
                    r: e[0],
                    g: e[1],
                    b: e[2],
                    a: e[3]
                };
                return Y6(t).toRgbString();
            }
            rae.exports = {
                hasColorscale: vnt,
                extractOpts: $ne,
                extractScale: Qne,
                flipScale: eae,
                makeColorScaleFunc: tae,
                makeColorScaleFuncFromTrace: pnt
            };
        });
        var Oc = ye((Xtr, aae)=>{
            "use strict";
            var iae = Rq(), gnt = iae.FORMAT_LINK, mnt = iae.DATE_FORMAT_LINK;
            function ynt(e, t) {
                return {
                    valType: "string",
                    dflt: "",
                    editType: "none",
                    description: (t ? dO : nae)("hover text", e) + [
                        "By default the values are formatted using " + (t ? "generic number format" : "`" + e + "axis.hoverformat`") + "."
                    ].join(" ")
                };
            }
            function dO(e, t) {
                return [
                    "Sets the " + e + " formatting rule" + (t ? "for `" + t + "` " : ""),
                    "using d3 formatting mini-languages",
                    "which are very similar to those in Python. For numbers, see: " + gnt + "."
                ].join(" ");
            }
            function nae(e, t) {
                return dO(e, t) + [
                    " And for dates see: " + mnt + ".",
                    "We add two items to d3's date formatter:",
                    "*%h* for half of the year as a decimal number as well as",
                    "*%{n}f* for fractional seconds",
                    "with n digits. For example, *2016-10-13 09:15:23.456* with tickformat",
                    "*%H~%M~%S.%2f* would display *09~15~23.46*"
                ].join(" ");
            }
            aae.exports = {
                axisHoverFormat: ynt,
                descriptionOnlyNumbers: dO,
                descriptionWithDates: nae
            };
        });
        var Cd = ye((Ytr, wae)=>{
            "use strict";
            var oae = Su(), w3 = dh(), bae = Ed().dash, pO = no().extendFlat, sae = Vs().templatedArray, lae = Oc().descriptionWithDates, _nt = es().ONEDAY, pm = ad(), xnt = pm.HOUR_PATTERN, bnt = pm.WEEKDAY_PATTERN, vO = {
                valType: "enumerated",
                values: [
                    "auto",
                    "linear",
                    "array"
                ],
                editType: "ticks",
                impliedEdits: {
                    tick0: void 0,
                    dtick: void 0
                }
            }, wnt = pO({}, vO, {
                values: vO.values.slice().concat([
                    "sync"
                ])
            });
            function uae(e) {
                return {
                    valType: "integer",
                    min: 0,
                    dflt: e ? 5 : 0,
                    editType: "ticks"
                };
            }
            var cae = {
                valType: "any",
                editType: "ticks",
                impliedEdits: {
                    tickmode: "linear"
                }
            }, fae = {
                valType: "any",
                editType: "ticks",
                impliedEdits: {
                    tickmode: "linear"
                }
            }, hae = {
                valType: "data_array",
                editType: "ticks"
            }, dae = {
                valType: "enumerated",
                values: [
                    "outside",
                    "inside",
                    ""
                ],
                editType: "ticks"
            };
            function vae(e) {
                var t = {
                    valType: "number",
                    min: 0,
                    editType: "ticks"
                };
                return e || (t.dflt = 5), t;
            }
            function pae(e) {
                var t = {
                    valType: "number",
                    min: 0,
                    editType: "ticks"
                };
                return e || (t.dflt = 1), t;
            }
            var gae = {
                valType: "color",
                dflt: w3.defaultLine,
                editType: "ticks"
            }, mae = {
                valType: "color",
                dflt: w3.lightLine,
                editType: "ticks"
            };
            function yae(e) {
                var t = {
                    valType: "number",
                    min: 0,
                    editType: "ticks"
                };
                return e || (t.dflt = 1), t;
            }
            var _ae = pO({}, bae, {
                editType: "ticks"
            }), xae = {
                valType: "boolean",
                editType: "ticks"
            };
            wae.exports = {
                visible: {
                    valType: "boolean",
                    editType: "plot"
                },
                color: {
                    valType: "color",
                    dflt: w3.defaultLine,
                    editType: "ticks"
                },
                title: {
                    text: {
                        valType: "string",
                        editType: "ticks"
                    },
                    font: oae({
                        editType: "ticks"
                    }),
                    standoff: {
                        valType: "number",
                        min: 0,
                        editType: "ticks"
                    },
                    editType: "ticks"
                },
                type: {
                    valType: "enumerated",
                    values: [
                        "-",
                        "linear",
                        "log",
                        "date",
                        "category",
                        "multicategory"
                    ],
                    dflt: "-",
                    editType: "calc",
                    _noTemplating: !0
                },
                autotypenumbers: {
                    valType: "enumerated",
                    values: [
                        "convert types",
                        "strict"
                    ],
                    dflt: "convert types",
                    editType: "calc"
                },
                autorange: {
                    valType: "enumerated",
                    values: [
                        !0,
                        !1,
                        "reversed",
                        "min reversed",
                        "max reversed",
                        "min",
                        "max"
                    ],
                    dflt: !0,
                    editType: "axrange",
                    impliedEdits: {
                        "range[0]": void 0,
                        "range[1]": void 0
                    }
                },
                autorangeoptions: {
                    minallowed: {
                        valType: "any",
                        editType: "plot",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    maxallowed: {
                        valType: "any",
                        editType: "plot",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    clipmin: {
                        valType: "any",
                        editType: "plot",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    clipmax: {
                        valType: "any",
                        editType: "plot",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    include: {
                        valType: "any",
                        arrayOk: !0,
                        editType: "plot",
                        impliedEdits: {
                            "range[0]": void 0,
                            "range[1]": void 0
                        }
                    },
                    editType: "plot"
                },
                rangemode: {
                    valType: "enumerated",
                    values: [
                        "normal",
                        "tozero",
                        "nonnegative"
                    ],
                    dflt: "normal",
                    editType: "plot"
                },
                range: {
                    valType: "info_array",
                    items: [
                        {
                            valType: "any",
                            editType: "axrange",
                            impliedEdits: {
                                "^autorange": !1
                            },
                            anim: !0
                        },
                        {
                            valType: "any",
                            editType: "axrange",
                            impliedEdits: {
                                "^autorange": !1
                            },
                            anim: !0
                        }
                    ],
                    editType: "axrange",
                    impliedEdits: {
                        autorange: !1
                    },
                    anim: !0
                },
                minallowed: {
                    valType: "any",
                    editType: "plot",
                    impliedEdits: {
                        "^autorange": !1
                    }
                },
                maxallowed: {
                    valType: "any",
                    editType: "plot",
                    impliedEdits: {
                        "^autorange": !1
                    }
                },
                fixedrange: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "calc"
                },
                insiderange: {
                    valType: "info_array",
                    items: [
                        {
                            valType: "any",
                            editType: "plot"
                        },
                        {
                            valType: "any",
                            editType: "plot"
                        }
                    ],
                    editType: "plot"
                },
                scaleanchor: {
                    valType: "enumerated",
                    values: [
                        pm.idRegex.x.toString(),
                        pm.idRegex.y.toString(),
                        !1
                    ],
                    editType: "plot"
                },
                scaleratio: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "plot"
                },
                constrain: {
                    valType: "enumerated",
                    values: [
                        "range",
                        "domain"
                    ],
                    editType: "plot"
                },
                constraintoward: {
                    valType: "enumerated",
                    values: [
                        "left",
                        "center",
                        "right",
                        "top",
                        "middle",
                        "bottom"
                    ],
                    editType: "plot"
                },
                matches: {
                    valType: "enumerated",
                    values: [
                        pm.idRegex.x.toString(),
                        pm.idRegex.y.toString()
                    ],
                    editType: "calc"
                },
                rangebreaks: sae("rangebreak", {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    bounds: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "calc"
                            },
                            {
                                valType: "any",
                                editType: "calc"
                            }
                        ],
                        editType: "calc"
                    },
                    pattern: {
                        valType: "enumerated",
                        values: [
                            bnt,
                            xnt,
                            ""
                        ],
                        editType: "calc"
                    },
                    values: {
                        valType: "info_array",
                        freeLength: !0,
                        editType: "calc",
                        items: {
                            valType: "any",
                            editType: "calc"
                        }
                    },
                    dvalue: {
                        valType: "number",
                        editType: "calc",
                        min: 0,
                        dflt: _nt
                    },
                    editType: "calc"
                }),
                tickmode: wnt,
                nticks: uae(),
                tick0: cae,
                dtick: fae,
                ticklabelstep: {
                    valType: "integer",
                    min: 1,
                    dflt: 1,
                    editType: "ticks"
                },
                tickvals: hae,
                ticktext: {
                    valType: "data_array",
                    editType: "ticks"
                },
                ticks: dae,
                tickson: {
                    valType: "enumerated",
                    values: [
                        "labels",
                        "boundaries"
                    ],
                    dflt: "labels",
                    editType: "ticks"
                },
                ticklabelmode: {
                    valType: "enumerated",
                    values: [
                        "instant",
                        "period"
                    ],
                    dflt: "instant",
                    editType: "ticks"
                },
                ticklabelposition: {
                    valType: "enumerated",
                    values: [
                        "outside",
                        "inside",
                        "outside top",
                        "inside top",
                        "outside left",
                        "inside left",
                        "outside right",
                        "inside right",
                        "outside bottom",
                        "inside bottom"
                    ],
                    dflt: "outside",
                    editType: "calc"
                },
                ticklabeloverflow: {
                    valType: "enumerated",
                    values: [
                        "allow",
                        "hide past div",
                        "hide past domain"
                    ],
                    editType: "calc"
                },
                ticklabelshift: {
                    valType: "integer",
                    dflt: 0,
                    editType: "ticks"
                },
                ticklabelstandoff: {
                    valType: "integer",
                    dflt: 0,
                    editType: "ticks"
                },
                ticklabelindex: {
                    valType: "integer",
                    arrayOk: !0,
                    editType: "calc"
                },
                mirror: {
                    valType: "enumerated",
                    values: [
                        !0,
                        "ticks",
                        !1,
                        "all",
                        "allticks"
                    ],
                    dflt: !1,
                    editType: "ticks+layoutstyle"
                },
                ticklen: vae(),
                tickwidth: pae(),
                tickcolor: gae,
                showticklabels: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "ticks"
                },
                labelalias: {
                    valType: "any",
                    dflt: !1,
                    editType: "ticks"
                },
                automargin: {
                    valType: "flaglist",
                    flags: [
                        "height",
                        "width",
                        "left",
                        "right",
                        "top",
                        "bottom"
                    ],
                    extras: [
                        !0,
                        !1
                    ],
                    dflt: !1,
                    editType: "ticks"
                },
                showspikes: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "modebar"
                },
                spikecolor: {
                    valType: "color",
                    dflt: null,
                    editType: "none"
                },
                spikethickness: {
                    valType: "number",
                    dflt: 3,
                    editType: "none"
                },
                spikedash: pO({}, bae, {
                    dflt: "dash",
                    editType: "none"
                }),
                spikemode: {
                    valType: "flaglist",
                    flags: [
                        "toaxis",
                        "across",
                        "marker"
                    ],
                    dflt: "toaxis",
                    editType: "none"
                },
                spikesnap: {
                    valType: "enumerated",
                    values: [
                        "data",
                        "cursor",
                        "hovered data"
                    ],
                    dflt: "hovered data",
                    editType: "none"
                },
                tickfont: oae({
                    editType: "ticks"
                }),
                tickangle: {
                    valType: "angle",
                    dflt: "auto",
                    editType: "ticks"
                },
                autotickangles: {
                    valType: "info_array",
                    freeLength: !0,
                    items: {
                        valType: "angle"
                    },
                    dflt: [
                        0,
                        30,
                        90
                    ],
                    editType: "ticks"
                },
                tickprefix: {
                    valType: "string",
                    dflt: "",
                    editType: "ticks"
                },
                showtickprefix: {
                    valType: "enumerated",
                    values: [
                        "all",
                        "first",
                        "last",
                        "none"
                    ],
                    dflt: "all",
                    editType: "ticks"
                },
                ticksuffix: {
                    valType: "string",
                    dflt: "",
                    editType: "ticks"
                },
                showticksuffix: {
                    valType: "enumerated",
                    values: [
                        "all",
                        "first",
                        "last",
                        "none"
                    ],
                    dflt: "all",
                    editType: "ticks"
                },
                showexponent: {
                    valType: "enumerated",
                    values: [
                        "all",
                        "first",
                        "last",
                        "none"
                    ],
                    dflt: "all",
                    editType: "ticks"
                },
                exponentformat: {
                    valType: "enumerated",
                    values: [
                        "none",
                        "e",
                        "E",
                        "power",
                        "SI",
                        "B"
                    ],
                    dflt: "B",
                    editType: "ticks"
                },
                minexponent: {
                    valType: "number",
                    dflt: 3,
                    min: 0,
                    editType: "ticks"
                },
                separatethousands: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "ticks"
                },
                tickformat: {
                    valType: "string",
                    dflt: "",
                    editType: "ticks",
                    description: lae("tick label")
                },
                tickformatstops: sae("tickformatstop", {
                    enabled: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "ticks"
                    },
                    dtickrange: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "any",
                                editType: "ticks"
                            },
                            {
                                valType: "any",
                                editType: "ticks"
                            }
                        ],
                        editType: "ticks"
                    },
                    value: {
                        valType: "string",
                        dflt: "",
                        editType: "ticks"
                    },
                    editType: "ticks"
                }),
                hoverformat: {
                    valType: "string",
                    dflt: "",
                    editType: "none",
                    description: lae("hover text")
                },
                showline: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "ticks+layoutstyle"
                },
                linecolor: {
                    valType: "color",
                    dflt: w3.defaultLine,
                    editType: "layoutstyle"
                },
                linewidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "ticks+layoutstyle"
                },
                showgrid: xae,
                gridcolor: mae,
                gridwidth: yae(),
                griddash: _ae,
                zeroline: {
                    valType: "boolean",
                    editType: "ticks"
                },
                zerolinecolor: {
                    valType: "color",
                    dflt: w3.defaultLine,
                    editType: "ticks"
                },
                zerolinewidth: {
                    valType: "number",
                    dflt: 1,
                    editType: "ticks"
                },
                showdividers: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "ticks"
                },
                dividercolor: {
                    valType: "color",
                    dflt: w3.defaultLine,
                    editType: "ticks"
                },
                dividerwidth: {
                    valType: "number",
                    dflt: 1,
                    editType: "ticks"
                },
                anchor: {
                    valType: "enumerated",
                    values: [
                        "free",
                        pm.idRegex.x.toString(),
                        pm.idRegex.y.toString()
                    ],
                    editType: "plot"
                },
                side: {
                    valType: "enumerated",
                    values: [
                        "top",
                        "bottom",
                        "left",
                        "right"
                    ],
                    editType: "plot"
                },
                overlaying: {
                    valType: "enumerated",
                    values: [
                        "free",
                        pm.idRegex.x.toString(),
                        pm.idRegex.y.toString()
                    ],
                    editType: "plot"
                },
                minor: {
                    tickmode: vO,
                    nticks: uae("minor"),
                    tick0: cae,
                    dtick: fae,
                    tickvals: hae,
                    ticks: dae,
                    ticklen: vae("minor"),
                    tickwidth: pae("minor"),
                    tickcolor: gae,
                    gridcolor: mae,
                    gridwidth: yae("minor"),
                    griddash: _ae,
                    showgrid: xae,
                    editType: "ticks"
                },
                layer: {
                    valType: "enumerated",
                    values: [
                        "above traces",
                        "below traces"
                    ],
                    dflt: "above traces",
                    editType: "plot"
                },
                domain: {
                    valType: "info_array",
                    items: [
                        {
                            valType: "number",
                            min: 0,
                            max: 1,
                            editType: "plot"
                        },
                        {
                            valType: "number",
                            min: 0,
                            max: 1,
                            editType: "plot"
                        }
                    ],
                    dflt: [
                        0,
                        1
                    ],
                    editType: "plot"
                },
                position: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 0,
                    editType: "plot"
                },
                autoshift: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "plot"
                },
                shift: {
                    valType: "number",
                    editType: "plot"
                },
                categoryorder: {
                    valType: "enumerated",
                    values: [
                        "trace",
                        "category ascending",
                        "category descending",
                        "array",
                        "total ascending",
                        "total descending",
                        "min ascending",
                        "min descending",
                        "max ascending",
                        "max descending",
                        "sum ascending",
                        "sum descending",
                        "mean ascending",
                        "mean descending",
                        "geometric mean ascending",
                        "geometric mean descending",
                        "median ascending",
                        "median descending"
                    ],
                    dflt: "trace",
                    editType: "calc"
                },
                categoryarray: {
                    valType: "data_array",
                    editType: "calc"
                },
                uirevision: {
                    valType: "any",
                    editType: "none"
                },
                editType: "calc"
            };
        });
        var K6 = ye((Ktr, Sae)=>{
            "use strict";
            var Ac = Cd(), Tae = Su(), Aae = no().extendFlat, Tnt = Bu().overrideAll;
            Sae.exports = Tnt({
                orientation: {
                    valType: "enumerated",
                    values: [
                        "h",
                        "v"
                    ],
                    dflt: "v"
                },
                thicknessmode: {
                    valType: "enumerated",
                    values: [
                        "fraction",
                        "pixels"
                    ],
                    dflt: "pixels"
                },
                thickness: {
                    valType: "number",
                    min: 0,
                    dflt: 30
                },
                lenmode: {
                    valType: "enumerated",
                    values: [
                        "fraction",
                        "pixels"
                    ],
                    dflt: "fraction"
                },
                len: {
                    valType: "number",
                    min: 0,
                    dflt: 1
                },
                x: {
                    valType: "number"
                },
                xref: {
                    valType: "enumerated",
                    dflt: "paper",
                    values: [
                        "container",
                        "paper"
                    ],
                    editType: "layoutstyle"
                },
                xanchor: {
                    valType: "enumerated",
                    values: [
                        "left",
                        "center",
                        "right"
                    ]
                },
                xpad: {
                    valType: "number",
                    min: 0,
                    dflt: 10
                },
                y: {
                    valType: "number"
                },
                yref: {
                    valType: "enumerated",
                    dflt: "paper",
                    values: [
                        "container",
                        "paper"
                    ],
                    editType: "layoutstyle"
                },
                yanchor: {
                    valType: "enumerated",
                    values: [
                        "top",
                        "middle",
                        "bottom"
                    ]
                },
                ypad: {
                    valType: "number",
                    min: 0,
                    dflt: 10
                },
                outlinecolor: Ac.linecolor,
                outlinewidth: Ac.linewidth,
                bordercolor: Ac.linecolor,
                borderwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 0
                },
                bgcolor: {
                    valType: "color",
                    dflt: "rgba(0,0,0,0)"
                },
                tickmode: Ac.minor.tickmode,
                nticks: Ac.nticks,
                tick0: Ac.tick0,
                dtick: Ac.dtick,
                tickvals: Ac.tickvals,
                ticktext: Ac.ticktext,
                ticks: Aae({}, Ac.ticks, {
                    dflt: ""
                }),
                ticklabeloverflow: Aae({}, Ac.ticklabeloverflow, {}),
                ticklabelposition: {
                    valType: "enumerated",
                    values: [
                        "outside",
                        "inside",
                        "outside top",
                        "inside top",
                        "outside left",
                        "inside left",
                        "outside right",
                        "inside right",
                        "outside bottom",
                        "inside bottom"
                    ],
                    dflt: "outside"
                },
                ticklen: Ac.ticklen,
                tickwidth: Ac.tickwidth,
                tickcolor: Ac.tickcolor,
                ticklabelstep: Ac.ticklabelstep,
                showticklabels: Ac.showticklabels,
                labelalias: Ac.labelalias,
                tickfont: Tae({}),
                tickangle: Ac.tickangle,
                tickformat: Ac.tickformat,
                tickformatstops: Ac.tickformatstops,
                tickprefix: Ac.tickprefix,
                showtickprefix: Ac.showtickprefix,
                ticksuffix: Ac.ticksuffix,
                showticksuffix: Ac.showticksuffix,
                separatethousands: Ac.separatethousands,
                exponentformat: Ac.exponentformat,
                minexponent: Ac.minexponent,
                showexponent: Ac.showexponent,
                title: {
                    text: {
                        valType: "string"
                    },
                    font: Tae({}),
                    side: {
                        valType: "enumerated",
                        values: [
                            "right",
                            "top",
                            "bottom"
                        ]
                    }
                }
            }, "colorbars", "from-root");
        });
        var Jl = ye(($tr, Eae)=>{
            "use strict";
            var Ant = K6(), Snt = n3().counter, Mnt = Y1(), Mae = sb().scales, Jtr = Mnt(Mae);
            function J6(e) {
                return "`" + e + "`";
            }
            Eae.exports = function(t, r) {
                t = t || "", r = r || {};
                var n = r.cLetter || "c", i = "onlyIfNumerical" in r ? r.onlyIfNumerical : !!t, a = "noScale" in r ? r.noScale : t === "marker.line", o = "showScaleDflt" in r ? r.showScaleDflt : n === "z", s = typeof r.colorscaleDflt == "string" ? Mae[r.colorscaleDflt] : null, l = r.editTypeOverride || "", u = t ? t + "." : "", c, f;
                "colorAttr" in r ? (c = r.colorAttr, f = r.colorAttr) : (c = ({
                    z: "z",
                    c: "color"
                })[n], f = "in " + J6(u + c));
                var h = i ? " Has an effect only if " + f + " is set to a numerical array." : "", d = n + "auto", v = n + "min", x = n + "max", b = n + "mid", p = J6(u + d), E = J6(u + v), k = J6(u + x), A = E + " and " + k, L = {};
                L[v] = L[x] = void 0;
                var _ = {};
                _[d] = !1;
                var C = {};
                return c === "color" && (C.color = {
                    valType: "color",
                    arrayOk: !0,
                    editType: l || "style"
                }, r.anim && (C.color.anim = !0)), C[d] = {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc",
                    impliedEdits: L
                }, C[v] = {
                    valType: "number",
                    dflt: null,
                    editType: l || "plot",
                    impliedEdits: _
                }, C[x] = {
                    valType: "number",
                    dflt: null,
                    editType: l || "plot",
                    impliedEdits: _
                }, C[b] = {
                    valType: "number",
                    dflt: null,
                    editType: "calc",
                    impliedEdits: L
                }, C.colorscale = {
                    valType: "colorscale",
                    editType: "calc",
                    dflt: s,
                    impliedEdits: {
                        autocolorscale: !1
                    }
                }, C.autocolorscale = {
                    valType: "boolean",
                    dflt: r.autoColorDflt !== !1,
                    editType: "calc",
                    impliedEdits: {
                        colorscale: void 0
                    }
                }, C.reversescale = {
                    valType: "boolean",
                    dflt: !1,
                    editType: "plot"
                }, a || (C.showscale = {
                    valType: "boolean",
                    dflt: o,
                    editType: "calc"
                }, C.colorbar = Ant), r.noColorAxis || (C.coloraxis = {
                    valType: "subplotid",
                    regex: Snt("coloraxis"),
                    dflt: null,
                    editType: "calc"
                }), C;
            };
        });
        var mO = ye((Qtr, kae)=>{
            "use strict";
            var Ent = no().extendFlat, knt = Jl(), gO = sb().scales;
            kae.exports = {
                editType: "calc",
                colorscale: {
                    editType: "calc",
                    sequential: {
                        valType: "colorscale",
                        dflt: gO.Reds,
                        editType: "calc"
                    },
                    sequentialminus: {
                        valType: "colorscale",
                        dflt: gO.Blues,
                        editType: "calc"
                    },
                    diverging: {
                        valType: "colorscale",
                        dflt: gO.RdBu,
                        editType: "calc"
                    }
                },
                coloraxis: Ent({
                    _isSubplotObj: !0,
                    editType: "calc"
                }, knt("", {
                    colorAttr: "corresponding trace color array(s)",
                    noColorAxis: !0,
                    showScaleDflt: !0
                }))
            };
        });
        var yO = ye((err, Cae)=>{
            "use strict";
            var Cnt = Mr();
            Cae.exports = function(t) {
                return Cnt.isPlainObject(t.colorbar);
            };
        });
        var bO = ye((xO)=>{
            "use strict";
            var _O = uo(), Lae = Mr(), Pae = es(), Lnt = Pae.ONEDAY, Pnt = Pae.ONEWEEK;
            xO.dtick = function(e, t) {
                var r = t === "log", n = t === "date", i = t === "category", a = n ? Lnt : 1;
                if (!e) return a;
                if (_O(e)) return e = Number(e), e <= 0 ? a : i ? Math.max(1, Math.round(e)) : n ? Math.max(.1, e) : e;
                if (typeof e != "string" || !(n || r)) return a;
                var o = e.charAt(0), s = e.substr(1);
                return s = _O(s) ? Number(s) : 0, s <= 0 || !(n && o === "M" && s === Math.round(s) || r && o === "L" || r && o === "D" && (s === 1 || s === 2)) ? a : e;
            };
            xO.tick0 = function(e, t, r, n) {
                if (t === "date") return Lae.cleanDate(e, Lae.dateTick0(r, n % Pnt === 0 ? 1 : 0));
                if (!(n === "D1" || n === "D2")) return _O(e) ? Number(e) : 0;
            };
        });
        var xb = ye((rrr, Rae)=>{
            "use strict";
            var Iae = bO(), Int = Mr().isArrayOrTypedArray, Rnt = vv().isTypedArraySpec, Dnt = vv().decodeTypedArraySpec;
            Rae.exports = function(t, r, n, i, a) {
                a || (a = {});
                var o = a.isMinor, s = o ? t.minor || {} : t, l = o ? r.minor : r, u = o ? "minor." : "";
                function c(E) {
                    var k = s[E];
                    return Rnt(k) && (k = Dnt(k)), k !== void 0 ? k : (l._template || {})[E];
                }
                var f = c("tick0"), h = c("dtick"), d = c("tickvals"), v = Int(d) ? "array" : h ? "linear" : "auto", x = n(u + "tickmode", v);
                if (x === "auto" || x === "sync") n(u + "nticks");
                else if (x === "linear") {
                    var b = l.dtick = Iae.dtick(h, i);
                    l.tick0 = Iae.tick0(f, i, r.calendar, b);
                } else if (i !== "multicategory") {
                    var p = n(u + "tickvals");
                    p === void 0 ? l.tickmode = "auto" : o || n("ticktext");
                }
            };
        });
        var T3 = ye((irr, zae)=>{
            "use strict";
            var wO = Mr(), Dae = Cd();
            zae.exports = function(t, r, n, i) {
                var a = i.isMinor, o = a ? t.minor || {} : t, s = a ? r.minor : r, l = a ? Dae.minor : Dae, u = a ? "minor." : "", c = wO.coerce2(o, s, l, "ticklen", a ? (r.ticklen || 5) * .6 : void 0), f = wO.coerce2(o, s, l, "tickwidth", a ? r.tickwidth || 1 : void 0), h = wO.coerce2(o, s, l, "tickcolor", (a ? r.tickcolor : void 0) || s.color), d = n(u + "ticks", !a && i.outerTicks || c || f || h ? "outside" : "");
                d || (delete s.ticklen, delete s.tickwidth, delete s.tickcolor);
            };
        });
        var TO = ye((nrr, Fae)=>{
            "use strict";
            Fae.exports = function(t) {
                var r = [
                    "showexponent",
                    "showtickprefix",
                    "showticksuffix"
                ], n = r.filter(function(a) {
                    return t[a] !== void 0;
                }), i = function(a) {
                    return t[a] === t[n[0]];
                };
                if (n.every(i) || n.length === 1) return t[n[0]];
            };
        });
        var Zd = ye((arr, qae)=>{
            "use strict";
            var $6 = Mr(), znt = Vs();
            qae.exports = function(t, r, n) {
                var i = n.name, a = n.inclusionAttr || "visible", o = r[i], s = $6.isArrayOrTypedArray(t[i]) ? t[i] : [], l = r[i] = [], u = znt.arrayTemplater(r, i, a), c, f;
                for(c = 0; c < s.length; c++){
                    var h = s[c];
                    $6.isPlainObject(h) ? f = u.newItem(h) : (f = u.newItem({}), f[a] = !1), f._index = c, f[a] !== !1 && n.handleItemDefaults(h, f, r, n), l.push(f);
                }
                var d = u.defaultItems();
                for(c = 0; c < d.length; c++)f = d[c], f._index = l.length, n.handleItemDefaults({}, f, r, n, {}), l.push(f);
                if ($6.isArrayOrTypedArray(o)) {
                    var v = Math.min(o.length, l.length);
                    for(c = 0; c < v; c++)$6.relinkPrivateKeys(l[c], o[c]);
                }
                return l;
            };
        });
        var t_ = ye((orr, Bae)=>{
            "use strict";
            var AO = Mr(), Fnt = va().contrast, Oae = Cd(), qnt = TO(), Ont = Zd();
            Bae.exports = function(t, r, n, i, a) {
                a || (a = {});
                var o = n("labelalias");
                AO.isPlainObject(o) || delete r.labelalias;
                var s = qnt(t), l = n("showticklabels");
                if (l) {
                    a.noTicklabelshift || n("ticklabelshift"), a.noTicklabelstandoff || n("ticklabelstandoff");
                    var u = a.font || {}, c = r.color, f = r.ticklabelposition || "", h = f.indexOf("inside") !== -1 ? Fnt(a.bgColor) : c && c !== Oae.color.dflt ? c : u.color;
                    if (AO.coerceFont(n, "tickfont", u, {
                        overrideDflt: {
                            color: h
                        }
                    }), !a.noTicklabelstep && i !== "multicategory" && i !== "log" && n("ticklabelstep"), !a.noAng) {
                        var d = n("tickangle");
                        !a.noAutotickangles && d === "auto" && n("autotickangles");
                    }
                    if (i !== "category") {
                        var v = n("tickformat");
                        Ont(t, r, {
                            name: "tickformatstops",
                            inclusionAttr: "enabled",
                            handleItemDefaults: Bnt
                        }), r.tickformatstops.length || delete r.tickformatstops, !a.noExp && !v && i !== "date" && (n("showexponent", s), n("exponentformat"), n("minexponent"), n("separatethousands"));
                    }
                }
            };
            function Bnt(e, t) {
                function r(i, a) {
                    return AO.coerce(e, t, Oae.tickformatstops, i, a);
                }
                var n = r("enabled");
                n && (r("dtickrange"), r("value"));
            }
        });
        var r_ = ye((srr, Nae)=>{
            "use strict";
            var Nnt = TO();
            Nae.exports = function(t, r, n, i, a) {
                a || (a = {});
                var o = a.tickSuffixDflt, s = Nnt(t), l = n("tickprefix");
                l && n("showtickprefix", s);
                var u = n("ticksuffix", o);
                u && n("showticksuffix", s);
            };
        });
        var SO = ye((lrr, Uae)=>{
            "use strict";
            var i_ = Mr(), Unt = Vs(), Vnt = xb(), Hnt = T3(), Gnt = t_(), jnt = r_(), Wnt = K6();
            Uae.exports = function(t, r, n) {
                var i = Unt.newContainer(r, "colorbar"), a = t.colorbar || {};
                function o(T, F) {
                    return i_.coerce(a, i, Wnt, T, F);
                }
                var s = n.margin || {
                    t: 0,
                    b: 0,
                    l: 0,
                    r: 0
                }, l = n.width - s.l - s.r, u = n.height - s.t - s.b, c = o("orientation"), f = c === "v", h = o("thicknessmode");
                o("thickness", h === "fraction" ? 30 / (f ? l : u) : 30);
                var d = o("lenmode");
                o("len", d === "fraction" ? 1 : f ? u : l);
                var v = o("yref"), x = o("xref"), b = v === "paper", p = x === "paper", E, k, A, L = "left";
                f ? (A = "middle", L = p ? "left" : "right", E = p ? 1.02 : 1, k = .5) : (A = b ? "bottom" : "top", L = "center", E = .5, k = b ? 1.02 : 1), i_.coerce(a, i, {
                    x: {
                        valType: "number",
                        min: p ? -2 : 0,
                        max: p ? 3 : 1,
                        dflt: E
                    }
                }, "x"), i_.coerce(a, i, {
                    y: {
                        valType: "number",
                        min: b ? -2 : 0,
                        max: b ? 3 : 1,
                        dflt: k
                    }
                }, "y"), o("xanchor", L), o("xpad"), o("yanchor", A), o("ypad"), i_.noneOrAll(a, i, [
                    "x",
                    "y"
                ]), o("outlinecolor"), o("outlinewidth"), o("bordercolor"), o("borderwidth"), o("bgcolor");
                var _ = i_.coerce(a, i, {
                    ticklabelposition: {
                        valType: "enumerated",
                        dflt: "outside",
                        values: f ? [
                            "outside",
                            "inside",
                            "outside top",
                            "inside top",
                            "outside bottom",
                            "inside bottom"
                        ] : [
                            "outside",
                            "inside",
                            "outside left",
                            "inside left",
                            "outside right",
                            "inside right"
                        ]
                    }
                }, "ticklabelposition");
                o("ticklabeloverflow", _.indexOf("inside") !== -1 ? "hide past domain" : "hide past div"), Vnt(a, i, o, "linear");
                var C = n.font, M = {
                    noAutotickangles: !0,
                    noTicklabelshift: !0,
                    noTicklabelstandoff: !0,
                    outerTicks: !1,
                    font: C
                };
                _.indexOf("inside") !== -1 && (M.bgColor = "black"), jnt(a, i, o, "linear", M), Gnt(a, i, o, "linear", M), Hnt(a, i, o, "linear", M), o("title.text", n._dfltTitle.colorbar);
                var g = i.showticklabels ? i.tickfont : C, P = i_.extendFlat({}, C, {
                    family: g.family,
                    size: i_.bigFont(g.size)
                });
                i_.coerceFont(o, "title.font", P), o("title.side", f ? "top" : "right");
            };
        });
        var Uh = ye((urr, Gae)=>{
            "use strict";
            var Vae = uo(), EO = Mr(), Znt = yO(), Xnt = SO(), Hae = sb().isValid, Ynt = ba().traceIs;
            function MO(e, t) {
                var r = t.slice(0, t.length - 1);
                return t ? EO.nestedProperty(e, r).get() || {} : e;
            }
            Gae.exports = function e(t, r, n, i, a) {
                var o = a.prefix, s = a.cLetter, l = "_module" in r, u = MO(t, o), c = MO(r, o), f = MO(r._template || {}, o) || {}, h = function() {
                    return delete t.coloraxis, delete r.coloraxis, e(t, r, n, i, a);
                };
                if (l) {
                    var d = n._colorAxes || {}, v = i(o + "coloraxis");
                    if (v) {
                        var x = Ynt(r, "contour") && EO.nestedProperty(r, "contours.coloring").get() || "heatmap", b = d[v];
                        b ? (b[2].push(h), b[0] !== x && (b[0] = !1, EO.warn([
                            "Ignoring coloraxis:",
                            v,
                            "setting",
                            "as it is linked to incompatible colorscales."
                        ].join(" ")))) : d[v] = [
                            x,
                            r,
                            [
                                h
                            ]
                        ];
                        return;
                    }
                }
                var p = u[s + "min"], E = u[s + "max"], k = Vae(p) && Vae(E) && p < E, A = i(o + s + "auto", !k);
                A ? i(o + s + "mid") : (i(o + s + "min"), i(o + s + "max"));
                var L = u.colorscale, _ = f.colorscale, C;
                if (L !== void 0 && (C = !Hae(L)), _ !== void 0 && (C = !Hae(_)), i(o + "autocolorscale", C), i(o + "colorscale"), i(o + "reversescale"), o !== "marker.line.") {
                    var M;
                    o && l && (M = Znt(u));
                    var g = i(o + "showscale", M);
                    g && (o && f && (c._template = f), Xnt(u, c, n));
                }
            };
        });
        var Xae = ye((crr, Zae)=>{
            "use strict";
            var jae = Mr(), Knt = Vs(), Wae = mO(), Jnt = Uh();
            Zae.exports = function(t, r) {
                function n(f, h) {
                    return jae.coerce(t, r, Wae, f, h);
                }
                n("colorscale.sequential"), n("colorscale.sequentialminus"), n("colorscale.diverging");
                var i = r._colorAxes, a, o;
                function s(f, h) {
                    return jae.coerce(a, o, Wae.coloraxis, f, h);
                }
                for(var l in i){
                    var u = i[l];
                    if (u[0]) a = t[l] || {}, o = Knt.newContainer(r, l, "coloraxis"), o._name = l, Jnt(a, o, r, s, {
                        prefix: "",
                        cLetter: "c"
                    });
                    else {
                        for(var c = 0; c < u[2].length; c++)u[2][c]();
                        delete r._colorAxes[l];
                    }
                }
            };
        });
        var Kae = ye((frr, Yae)=>{
            "use strict";
            var $nt = Mr(), Qnt = Dv().hasColorscale, eat = Dv().extractOpts;
            Yae.exports = function(t, r) {
                function n(c, f) {
                    var h = c["_" + f];
                    h !== void 0 && (c[f] = h);
                }
                function i(c, f) {
                    var h = f.container ? $nt.nestedProperty(c, f.container).get() : c;
                    if (h) {
                        if (h.coloraxis) h._colorAx = r[h.coloraxis];
                        else {
                            var d = eat(h), v = d.auto;
                            (v || d.min === void 0) && n(h, f.min), (v || d.max === void 0) && n(h, f.max), d.autocolorscale && n(h, "colorscale");
                        }
                    }
                }
                for(var a = 0; a < t.length; a++){
                    var o = t[a], s = o._module.colorbar;
                    if (s) {
                        if (Array.isArray(s)) for(var l = 0; l < s.length; l++)i(o, s[l]);
                        else i(o, s);
                    }
                    Qnt(o, "marker.line") && i(o, {
                        container: "marker.line",
                        min: "cmin",
                        max: "cmax"
                    });
                }
                for(var u in r._colorAxes)i(r[u], {
                    min: "cmin",
                    max: "cmax"
                });
            };
        });
        var zv = ye((hrr, $ae)=>{
            "use strict";
            var Jae = uo(), kO = Mr(), tat = Dv().extractOpts;
            $ae.exports = function(t, r, n) {
                var i = t._fullLayout, a = n.vals, o = n.containerStr, s = o ? kO.nestedProperty(r, o).get() : r, l = tat(s), u = l.auto !== !1, c = l.min, f = l.max, h = l.mid, d = function() {
                    return kO.aggNums(Math.min, null, a);
                }, v = function() {
                    return kO.aggNums(Math.max, null, a);
                };
                if (c === void 0 ? c = d() : u && (s._colorAx && Jae(c) ? c = Math.min(c, d()) : c = d()), f === void 0 ? f = v() : u && (s._colorAx && Jae(f) ? f = Math.max(f, v()) : f = v()), u && h !== void 0 && (f - h > h - c ? c = h - (f - h) : f - h < h - c && (f = h + (h - c))), c === f && (c -= .5, f += .5), l._sync("min", c), l._sync("max", f), l.autocolorscale) {
                    var x;
                    c * f < 0 ? x = i.colorscale.diverging : c >= 0 ? x = i.colorscale.sequential : x = i.colorscale.sequentialminus, l._sync("colorscale", x);
                }
            };
        });
        var Mu = ye((drr, Qae)=>{
            "use strict";
            var Q6 = sb(), A3 = Dv();
            Qae.exports = {
                moduleType: "component",
                name: "colorscale",
                attributes: Jl(),
                layoutAttributes: mO(),
                supplyLayoutDefaults: Xae(),
                handleDefaults: Uh(),
                crossTraceDefaults: Kae(),
                calc: zv(),
                scales: Q6.scales,
                defaultScale: Q6.defaultScale,
                getScale: Q6.get,
                isValidScale: Q6.isValid,
                hasColorscale: A3.hasColorscale,
                extractOpts: A3.extractOpts,
                extractScale: A3.extractScale,
                flipScale: A3.flipScale,
                makeColorScaleFunc: A3.makeColorScaleFunc,
                makeColorScaleFuncFromTrace: A3.makeColorScaleFuncFromTrace
            };
        });
        var lu = ye((vrr, toe)=>{
            "use strict";
            var eoe = Mr(), rat = vv().isTypedArraySpec;
            toe.exports = {
                hasLines: function(e) {
                    return e.visible && e.mode && e.mode.indexOf("lines") !== -1;
                },
                hasMarkers: function(e) {
                    return e.visible && (e.mode && e.mode.indexOf("markers") !== -1 || e.type === "splom");
                },
                hasText: function(e) {
                    return e.visible && e.mode && e.mode.indexOf("text") !== -1;
                },
                isBubble: function(e) {
                    var t = e.marker;
                    return eoe.isPlainObject(t) && (eoe.isArrayOrTypedArray(t.size) || rat(t.size));
                }
            };
        });
        var S3 = ye((prr, roe)=>{
            "use strict";
            var iat = uo();
            roe.exports = function(t, r) {
                r || (r = 2);
                var n = t.marker, i = n.sizeref || 1, a = n.sizemin || 0, o = n.sizemode === "area" ? function(s) {
                    return Math.sqrt(s / i);
                } : function(s) {
                    return s / i;
                };
                return function(s) {
                    var l = o(s / r);
                    return iat(l) && l > 0 ? Math.max(l, a) : 0;
                };
            };
        });
        var rp = ye((pv)=>{
            "use strict";
            var ioe = Mr();
            pv.getSubplot = function(e) {
                return e.subplot || e.xaxis + e.yaxis || e.geo;
            };
            pv.isTraceInSubplots = function(e, t) {
                if (e.type === "splom") {
                    for(var r = e.xaxes || [], n = e.yaxes || [], i = 0; i < r.length; i++)for(var a = 0; a < n.length; a++)if (t.indexOf(r[i] + n[a]) !== -1) return !0;
                    return !1;
                }
                return t.indexOf(pv.getSubplot(e)) !== -1;
            };
            pv.flat = function(e, t) {
                for(var r = new Array(e.length), n = 0; n < e.length; n++)r[n] = t;
                return r;
            };
            pv.p2c = function(e, t) {
                for(var r = new Array(e.length), n = 0; n < e.length; n++)r[n] = e[n].p2c(t);
                return r;
            };
            pv.getDistanceFunction = function(e, t, r, n) {
                return e === "closest" ? n || pv.quadrature(t, r) : e.charAt(0) === "x" ? t : r;
            };
            pv.getClosest = function(e, t, r) {
                if (r.index !== !1) r.index >= 0 && r.index < e.length ? r.distance = 0 : r.index = !1;
                else for(var n = 1 / 0, i = e.length, a = 0; a < i; a++)n = t(e[a]), n <= r.distance && (r.index = a, r.distance = n);
                return r;
            };
            pv.inbox = function(e, t, r) {
                return e * t < 0 || e === 0 ? r : 1 / 0;
            };
            pv.quadrature = function(e, t) {
                return function(r) {
                    var n = e(r), i = t(r);
                    return Math.sqrt(n * n + i * i);
                };
            };
            pv.makeEventData = function(e, t, r) {
                var n = "index" in e ? e.index : e.pointNumber, i = {
                    data: t._input,
                    fullData: t,
                    curveNumber: t.index,
                    pointNumber: n
                };
                if (t._indexToPoints) {
                    var a = t._indexToPoints[n];
                    a.length === 1 ? i.pointIndex = a[0] : i.pointIndices = a;
                } else i.pointIndex = n;
                return t._module.eventData ? i = t._module.eventData(i, e, t, r, n) : ("xVal" in e ? i.x = e.xVal : "x" in e && (i.x = e.x), "yVal" in e ? i.y = e.yVal : "y" in e && (i.y = e.y), e.xa && (i.xaxis = e.xa), e.ya && (i.yaxis = e.ya), e.zLabelVal !== void 0 && (i.z = e.zLabelVal)), pv.appendArrayPointValue(i, t, n), i;
            };
            pv.appendArrayPointValue = function(e, t, r) {
                var n = t._arrayAttrs;
                if (n) for(var i = 0; i < n.length; i++){
                    var a = n[i], o = noe(a);
                    if (e[o] === void 0) {
                        var s = ioe.nestedProperty(t, a).get(), l = aoe(s, r);
                        l !== void 0 && (e[o] = l);
                    }
                }
            };
            pv.appendArrayMultiPointValues = function(e, t, r) {
                var n = t._arrayAttrs;
                if (n) for(var i = 0; i < n.length; i++){
                    var a = n[i], o = noe(a);
                    if (e[o] === void 0) {
                        for(var s = ioe.nestedProperty(t, a).get(), l = new Array(r.length), u = 0; u < r.length; u++)l[u] = aoe(s, r[u]);
                        e[o] = l;
                    }
                }
            };
            var nat = {
                ids: "id",
                locations: "location",
                labels: "label",
                values: "value",
                "marker.colors": "color",
                parents: "parent"
            };
            function noe(e) {
                return nat[e] || e;
            }
            function aoe(e, t) {
                if (Array.isArray(t)) {
                    if (Array.isArray(e) && Array.isArray(e[t[0]])) return e[t[0]][t[1]];
                } else return e[t];
            }
            var aat = {
                x: !0,
                y: !0
            }, oat = {
                "x unified": !0,
                "y unified": !0
            };
            pv.isUnifiedHover = function(e) {
                return typeof e != "string" ? !1 : !!oat[e];
            };
            pv.isXYhover = function(e) {
                return typeof e != "string" ? !1 : !!aat[e];
            };
        });
        var XS = ye((mrr, ooe)=>{
            ooe.exports = lat;
            var CO = {
                a: 7,
                c: 6,
                h: 1,
                l: 2,
                m: 2,
                q: 4,
                s: 4,
                t: 2,
                v: 1,
                z: 0
            }, sat = /([astvzqmhlc])([^astvzqmhlc]*)/ig;
            function lat(e) {
                var t = [];
                return e.replace(sat, function(r, n, i) {
                    var a = n.toLowerCase();
                    for(i = cat(i), a == "m" && i.length > 2 && (t.push([
                        n
                    ].concat(i.splice(0, 2))), a = "l", n = n == "m" ? "l" : "L");;){
                        if (i.length == CO[a]) return i.unshift(n), t.push(i);
                        if (i.length < CO[a]) throw new Error("malformed path data");
                        t.push([
                            n
                        ].concat(i.splice(0, CO[a])));
                    }
                }), t;
            }
            var uat = /-?[0-9]*\.?[0-9]+(?:e[-+]?\d+)?/ig;
            function cat(e) {
                var t = e.match(uat);
                return t ? t.map(Number) : [];
            }
        });
        var doe = ye((yrr, hoe)=>{
            "use strict";
            var fat = XS(), Yn = function(e, t) {
                return t ? Math.round(e * (t = Math.pow(10, t))) / t : Math.round(e);
            }, ts = "M0,0Z", soe = Math.sqrt(2), n_ = Math.sqrt(3), LO = Math.PI, PO = Math.cos, IO = Math.sin;
            hoe.exports = {
                circle: {
                    n: 0,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2), i = "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z";
                        return r ? is(t, r, i) : i;
                    }
                },
                square: {
                    n: 1,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2);
                        return is(t, r, "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
                    }
                },
                diamond: {
                    n: 2,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.3, 2);
                        return is(t, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "Z");
                    }
                },
                cross: {
                    n: 3,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * .4, 2), i = Yn(e * 1.2, 2);
                        return is(t, r, "M" + i + "," + n + "H" + n + "V" + i + "H-" + n + "V" + n + "H-" + i + "V-" + n + "H-" + n + "V-" + i + "H" + n + "V-" + n + "H" + i + "Z");
                    }
                },
                x: {
                    n: 4,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * .8 / soe, 2), i = "l" + n + "," + n, a = "l" + n + ",-" + n, o = "l-" + n + ",-" + n, s = "l-" + n + "," + n;
                        return is(t, r, "M0," + n + i + a + o + a + o + s + o + s + i + s + i + "Z");
                    }
                },
                "triangle-up": {
                    n: 5,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 2 / n_, 2), i = Yn(e / 2, 2), a = Yn(e, 2);
                        return is(t, r, "M-" + n + "," + i + "H" + n + "L0,-" + a + "Z");
                    }
                },
                "triangle-down": {
                    n: 6,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 2 / n_, 2), i = Yn(e / 2, 2), a = Yn(e, 2);
                        return is(t, r, "M-" + n + ",-" + i + "H" + n + "L0," + a + "Z");
                    }
                },
                "triangle-left": {
                    n: 7,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 2 / n_, 2), i = Yn(e / 2, 2), a = Yn(e, 2);
                        return is(t, r, "M" + i + ",-" + n + "V" + n + "L-" + a + ",0Z");
                    }
                },
                "triangle-right": {
                    n: 8,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 2 / n_, 2), i = Yn(e / 2, 2), a = Yn(e, 2);
                        return is(t, r, "M-" + i + ",-" + n + "V" + n + "L" + a + ",0Z");
                    }
                },
                "triangle-ne": {
                    n: 9,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * .6, 2), i = Yn(e * 1.2, 2);
                        return is(t, r, "M-" + i + ",-" + n + "H" + n + "V" + i + "Z");
                    }
                },
                "triangle-se": {
                    n: 10,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * .6, 2), i = Yn(e * 1.2, 2);
                        return is(t, r, "M" + n + ",-" + i + "V" + n + "H-" + i + "Z");
                    }
                },
                "triangle-sw": {
                    n: 11,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * .6, 2), i = Yn(e * 1.2, 2);
                        return is(t, r, "M" + i + "," + n + "H-" + n + "V-" + i + "Z");
                    }
                },
                "triangle-nw": {
                    n: 12,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * .6, 2), i = Yn(e * 1.2, 2);
                        return is(t, r, "M-" + n + "," + i + "V-" + n + "H" + i + "Z");
                    }
                },
                pentagon: {
                    n: 13,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * .951, 2), i = Yn(e * .588, 2), a = Yn(-e, 2), o = Yn(e * -0.309, 2), s = Yn(e * .809, 2);
                        return is(t, r, "M" + n + "," + o + "L" + i + "," + s + "H-" + i + "L-" + n + "," + o + "L0," + a + "Z");
                    }
                },
                hexagon: {
                    n: 14,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2), i = Yn(e / 2, 2), a = Yn(e * n_ / 2, 2);
                        return is(t, r, "M" + a + ",-" + i + "V" + i + "L0," + n + "L-" + a + "," + i + "V-" + i + "L0,-" + n + "Z");
                    }
                },
                hexagon2: {
                    n: 15,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2), i = Yn(e / 2, 2), a = Yn(e * n_ / 2, 2);
                        return is(t, r, "M-" + i + "," + a + "H" + i + "L" + n + ",0L" + i + ",-" + a + "H-" + i + "L-" + n + ",0Z");
                    }
                },
                octagon: {
                    n: 16,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * .924, 2), i = Yn(e * .383, 2);
                        return is(t, r, "M-" + i + ",-" + n + "H" + i + "L" + n + ",-" + i + "V" + i + "L" + i + "," + n + "H-" + i + "L-" + n + "," + i + "V-" + i + "Z");
                    }
                },
                star: {
                    n: 17,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = e * 1.4, i = Yn(n * .225, 2), a = Yn(n * .951, 2), o = Yn(n * .363, 2), s = Yn(n * .588, 2), l = Yn(-n, 2), u = Yn(n * -0.309, 2), c = Yn(n * .118, 2), f = Yn(n * .809, 2), h = Yn(n * .382, 2);
                        return is(t, r, "M" + i + "," + u + "H" + a + "L" + o + "," + c + "L" + s + "," + f + "L0," + h + "L-" + s + "," + f + "L-" + o + "," + c + "L-" + a + "," + u + "H-" + i + "L0," + l + "Z");
                    }
                },
                hexagram: {
                    n: 18,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * .66, 2), i = Yn(e * .38, 2), a = Yn(e * .76, 2);
                        return is(t, r, "M-" + a + ",0l-" + i + ",-" + n + "h" + a + "l" + i + ",-" + n + "l" + i + "," + n + "h" + a + "l-" + i + "," + n + "l" + i + "," + n + "h-" + a + "l-" + i + "," + n + "l-" + i + ",-" + n + "h-" + a + "Z");
                    }
                },
                "star-triangle-up": {
                    n: 19,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * n_ * .8, 2), i = Yn(e * .8, 2), a = Yn(e * 1.6, 2), o = Yn(e * 4, 2), s = "A " + o + "," + o + " 0 0 1 ";
                        return is(t, r, "M-" + n + "," + i + s + n + "," + i + s + "0,-" + a + s + "-" + n + "," + i + "Z");
                    }
                },
                "star-triangle-down": {
                    n: 20,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * n_ * .8, 2), i = Yn(e * .8, 2), a = Yn(e * 1.6, 2), o = Yn(e * 4, 2), s = "A " + o + "," + o + " 0 0 1 ";
                        return is(t, r, "M" + n + ",-" + i + s + "-" + n + ",-" + i + s + "0," + a + s + n + ",-" + i + "Z");
                    }
                },
                "star-square": {
                    n: 21,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.1, 2), i = Yn(e * 2, 2), a = "A " + i + "," + i + " 0 0 1 ";
                        return is(t, r, "M-" + n + ",-" + n + a + "-" + n + "," + n + a + n + "," + n + a + n + ",-" + n + a + "-" + n + ",-" + n + "Z");
                    }
                },
                "star-diamond": {
                    n: 22,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.4, 2), i = Yn(e * 1.9, 2), a = "A " + i + "," + i + " 0 0 1 ";
                        return is(t, r, "M-" + n + ",0" + a + "0," + n + a + n + ",0" + a + "0,-" + n + a + "-" + n + ",0Z");
                    }
                },
                "diamond-tall": {
                    n: 23,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * .7, 2), i = Yn(e * 1.4, 2);
                        return is(t, r, "M0," + i + "L" + n + ",0L0,-" + i + "L-" + n + ",0Z");
                    }
                },
                "diamond-wide": {
                    n: 24,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.4, 2), i = Yn(e * .7, 2);
                        return is(t, r, "M0," + i + "L" + n + ",0L0,-" + i + "L-" + n + ",0Z");
                    }
                },
                hourglass: {
                    n: 25,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2);
                        return is(t, r, "M" + n + "," + n + "H-" + n + "L" + n + ",-" + n + "H-" + n + "Z");
                    },
                    noDot: !0
                },
                bowtie: {
                    n: 26,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2);
                        return is(t, r, "M" + n + "," + n + "V-" + n + "L-" + n + "," + n + "V-" + n + "Z");
                    },
                    noDot: !0
                },
                "circle-cross": {
                    n: 27,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2);
                        return is(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z");
                    },
                    needLine: !0,
                    noDot: !0
                },
                "circle-x": {
                    n: 28,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2), i = Yn(e / soe, 2);
                        return is(t, r, "M" + i + "," + i + "L-" + i + ",-" + i + "M" + i + ",-" + i + "L-" + i + "," + i + "M" + n + ",0A" + n + "," + n + " 0 1,1 0,-" + n + "A" + n + "," + n + " 0 0,1 " + n + ",0Z");
                    },
                    needLine: !0,
                    noDot: !0
                },
                "square-cross": {
                    n: 29,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2);
                        return is(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
                    },
                    needLine: !0,
                    noDot: !0
                },
                "square-x": {
                    n: 30,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2);
                        return is(t, r, "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n + "M" + n + "," + n + "H-" + n + "V-" + n + "H" + n + "Z");
                    },
                    needLine: !0,
                    noDot: !0
                },
                "diamond-cross": {
                    n: 31,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.3, 2);
                        return is(t, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "ZM0,-" + n + "V" + n + "M-" + n + ",0H" + n);
                    },
                    needLine: !0,
                    noDot: !0
                },
                "diamond-x": {
                    n: 32,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.3, 2), i = Yn(e * .65, 2);
                        return is(t, r, "M" + n + ",0L0," + n + "L-" + n + ",0L0,-" + n + "ZM-" + i + ",-" + i + "L" + i + "," + i + "M-" + i + "," + i + "L" + i + ",-" + i);
                    },
                    needLine: !0,
                    noDot: !0
                },
                "cross-thin": {
                    n: 33,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.4, 2);
                        return is(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n);
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                "x-thin": {
                    n: 34,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2);
                        return is(t, r, "M" + n + "," + n + "L-" + n + ",-" + n + "M" + n + ",-" + n + "L-" + n + "," + n);
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                asterisk: {
                    n: 35,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.2, 2), i = Yn(e * .85, 2);
                        return is(t, r, "M0," + n + "V-" + n + "M" + n + ",0H-" + n + "M" + i + "," + i + "L-" + i + ",-" + i + "M" + i + ",-" + i + "L-" + i + "," + i);
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                hash: {
                    n: 36,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e / 2, 2), i = Yn(e, 2);
                        return is(t, r, "M" + n + "," + i + "V-" + i + "M" + (n - i) + ",-" + i + "V" + i + "M" + i + "," + n + "H-" + i + "M-" + i + "," + (n - i) + "H" + i);
                    },
                    needLine: !0,
                    noFill: !0
                },
                "y-up": {
                    n: 37,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.2, 2), i = Yn(e * 1.6, 2), a = Yn(e * .8, 2);
                        return is(t, r, "M-" + n + "," + a + "L0,0M" + n + "," + a + "L0,0M0,-" + i + "L0,0");
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                "y-down": {
                    n: 38,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.2, 2), i = Yn(e * 1.6, 2), a = Yn(e * .8, 2);
                        return is(t, r, "M-" + n + ",-" + a + "L0,0M" + n + ",-" + a + "L0,0M0," + i + "L0,0");
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                "y-left": {
                    n: 39,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.2, 2), i = Yn(e * 1.6, 2), a = Yn(e * .8, 2);
                        return is(t, r, "M" + a + "," + n + "L0,0M" + a + ",-" + n + "L0,0M-" + i + ",0L0,0");
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                "y-right": {
                    n: 40,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.2, 2), i = Yn(e * 1.6, 2), a = Yn(e * .8, 2);
                        return is(t, r, "M-" + a + "," + n + "L0,0M-" + a + ",-" + n + "L0,0M" + i + ",0L0,0");
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                "line-ew": {
                    n: 41,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.4, 2);
                        return is(t, r, "M" + n + ",0H-" + n);
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                "line-ns": {
                    n: 42,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 1.4, 2);
                        return is(t, r, "M0," + n + "V-" + n);
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                "line-ne": {
                    n: 43,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2);
                        return is(t, r, "M" + n + ",-" + n + "L-" + n + "," + n);
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                "line-nw": {
                    n: 44,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2);
                        return is(t, r, "M" + n + "," + n + "L-" + n + ",-" + n);
                    },
                    needLine: !0,
                    noDot: !0,
                    noFill: !0
                },
                "arrow-up": {
                    n: 45,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2), i = Yn(e * 2, 2);
                        return is(t, r, "M0,0L-" + n + "," + i + "H" + n + "Z");
                    },
                    backoff: 1,
                    noDot: !0
                },
                "arrow-down": {
                    n: 46,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2), i = Yn(e * 2, 2);
                        return is(t, r, "M0,0L-" + n + ",-" + i + "H" + n + "Z");
                    },
                    noDot: !0
                },
                "arrow-left": {
                    n: 47,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 2, 2), i = Yn(e, 2);
                        return is(t, r, "M0,0L" + n + ",-" + i + "V" + i + "Z");
                    },
                    noDot: !0
                },
                "arrow-right": {
                    n: 48,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 2, 2), i = Yn(e, 2);
                        return is(t, r, "M0,0L-" + n + ",-" + i + "V" + i + "Z");
                    },
                    noDot: !0
                },
                "arrow-bar-up": {
                    n: 49,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2), i = Yn(e * 2, 2);
                        return is(t, r, "M-" + n + ",0H" + n + "M0,0L-" + n + "," + i + "H" + n + "Z");
                    },
                    backoff: 1,
                    needLine: !0,
                    noDot: !0
                },
                "arrow-bar-down": {
                    n: 50,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e, 2), i = Yn(e * 2, 2);
                        return is(t, r, "M-" + n + ",0H" + n + "M0,0L-" + n + ",-" + i + "H" + n + "Z");
                    },
                    needLine: !0,
                    noDot: !0
                },
                "arrow-bar-left": {
                    n: 51,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 2, 2), i = Yn(e, 2);
                        return is(t, r, "M0,-" + i + "V" + i + "M0,0L" + n + ",-" + i + "V" + i + "Z");
                    },
                    needLine: !0,
                    noDot: !0
                },
                "arrow-bar-right": {
                    n: 52,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = Yn(e * 2, 2), i = Yn(e, 2);
                        return is(t, r, "M0,-" + i + "V" + i + "M0,0L-" + n + ",-" + i + "V" + i + "Z");
                    },
                    needLine: !0,
                    noDot: !0
                },
                arrow: {
                    n: 53,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = LO / 2.5, i = 2 * e * PO(n), a = 2 * e * IO(n);
                        return is(t, r, "M0,0L" + -i + "," + a + "L" + i + "," + a + "Z");
                    },
                    backoff: .9,
                    noDot: !0
                },
                "arrow-wide": {
                    n: 54,
                    f: function(e, t, r) {
                        if (rs(t)) return ts;
                        var n = LO / 4, i = 2 * e * PO(n), a = 2 * e * IO(n);
                        return is(t, r, "M0,0L" + -i + "," + a + "A " + 2 * e + "," + 2 * e + " 0 0 1 " + i + "," + a + "Z");
                    },
                    backoff: .4,
                    noDot: !0
                }
            };
            function rs(e) {
                return e === null;
            }
            var loe, uoe, coe, foe;
            function is(e, t, r) {
                if ((!e || e % 360 === 0) && !t) return r;
                if (coe === e && foe === t && loe === r) return uoe;
                coe = e, foe = t, loe = r;
                function n(b, p) {
                    var E = PO(b), k = IO(b), A = p[0], L = p[1] + (t || 0);
                    return [
                        A * E - L * k,
                        A * k + L * E
                    ];
                }
                for(var i = e / 180 * LO, a = 0, o = 0, s = fat(r), l = "", u = 0; u < s.length; u++){
                    var c = s[u], f = c[0], h = a, d = o;
                    if (f === "M" || f === "L") a = +c[1], o = +c[2];
                    else if (f === "m" || f === "l") a += +c[1], o += +c[2];
                    else if (f === "H") a = +c[1];
                    else if (f === "h") a += +c[1];
                    else if (f === "V") o = +c[1];
                    else if (f === "v") o += +c[1];
                    else if (f === "A") {
                        a = +c[1], o = +c[2];
                        var v = n(i, [
                            +c[6],
                            +c[7]
                        ]);
                        c[6] = v[0], c[7] = v[1], c[3] = +c[3] + e;
                    }
                    (f === "H" || f === "V") && (f = "L"), (f === "h" || f === "v") && (f = "l"), (f === "m" || f === "l") && (a -= h, o -= d);
                    var x = n(i, [
                        a,
                        o
                    ]);
                    (f === "H" || f === "V") && (f = "L"), (f === "M" || f === "L" || f === "m" || f === "l") && (c[1] = x[0], c[2] = x[1]), c[0] = f, l += c[0] + c.slice(1).join(",");
                }
                return uoe = l, l;
            }
        });
        var ao = ye((_rr, Roe)=>{
            "use strict";
            var od = xa(), du = Mr(), hat = du.numberFormat, Ab = uo(), OO = id(), tL = ba(), Xd = va(), dat = Mu(), KS = du.strTranslate, rL = Pl(), vat = Zp(), pat = Nh(), gat = pat.LINE_SPACING, Toe = U1().DESELECTDIM, mat = lu(), yat = S3(), _at = rp().appendArrayPointValue, na = Roe.exports = {};
            na.font = function(e, t) {
                var r = t.variant, n = t.style, i = t.weight, a = t.color, o = t.size, s = t.family, l = t.shadow, u = t.lineposition, c = t.textcase;
                s && e.style("font-family", s), o + 1 && e.style("font-size", o + "px"), a && e.call(Xd.fill, a), i && e.style("font-weight", i), n && e.style("font-style", n), r && e.style("font-variant", r), c && e.style("text-transform", RO(bat(c))), l && e.style("text-shadow", l === "auto" ? rL.makeTextShadow(Xd.contrast(a)) : RO(l)), u && e.style("text-decoration-line", RO(wat(u)));
            };
            function RO(e) {
                return e === "none" ? void 0 : e;
            }
            var xat = {
                normal: "none",
                lower: "lowercase",
                upper: "uppercase",
                "word caps": "capitalize"
            };
            function bat(e) {
                return xat[e];
            }
            function wat(e) {
                return e.replace("under", "underline").replace("over", "overline").replace("through", "line-through").split("+").join(" ");
            }
            na.setPosition = function(e, t, r) {
                e.attr("x", t).attr("y", r);
            };
            na.setSize = function(e, t, r) {
                e.attr("width", t).attr("height", r);
            };
            na.setRect = function(e, t, r, n, i) {
                e.call(na.setPosition, t, r).call(na.setSize, n, i);
            };
            na.translatePoint = function(e, t, r, n) {
                var i = r.c2p(e.x), a = n.c2p(e.y);
                if (Ab(i) && Ab(a) && t.node()) t.node().nodeName === "text" ? t.attr("x", i).attr("y", a) : t.attr("transform", KS(i, a));
                else return !1;
                return !0;
            };
            na.translatePoints = function(e, t, r) {
                e.each(function(n) {
                    var i = od.select(this);
                    na.translatePoint(n, i, t, r);
                });
            };
            na.hideOutsideRangePoint = function(e, t, r, n, i, a) {
                t.attr("display", r.isPtWithinRange(e, i) && n.isPtWithinRange(e, a) ? null : "none");
            };
            na.hideOutsideRangePoints = function(e, t) {
                if (t._hasClipOnAxisFalse) {
                    var r = t.xaxis, n = t.yaxis;
                    e.each(function(i) {
                        var a = i[0].trace, o = a.xcalendar, s = a.ycalendar, l = tL.traceIs(a, "bar-like") ? ".bartext" : ".point,.textpoint";
                        e.selectAll(l).each(function(u) {
                            na.hideOutsideRangePoint(u, od.select(this), r, n, o, s);
                        });
                    });
                }
            };
            na.crispRound = function(e, t, r) {
                return !t || !Ab(t) ? r || 0 : e._context.staticPlot ? t : t < 1 ? 1 : Math.round(t);
            };
            na.singleLineStyle = function(e, t, r, n, i) {
                t.style("fill", "none");
                var a = (((e || [])[0] || {}).trace || {}).line || {}, o = r || a.width || 0, s = i || a.dash || "";
                Xd.stroke(t, n || a.color), na.dashLine(t, s, o);
            };
            na.lineGroupStyle = function(e, t, r, n) {
                e.style("fill", "none").each(function(i) {
                    var a = (((i || [])[0] || {}).trace || {}).line || {}, o = t || a.width || 0, s = n || a.dash || "";
                    od.select(this).call(Xd.stroke, r || a.color).call(na.dashLine, s, o);
                });
            };
            na.dashLine = function(e, t, r) {
                r = +r || 0, t = na.dashStyle(t, r), e.style({
                    "stroke-dasharray": t,
                    "stroke-width": r + "px"
                });
            };
            na.dashStyle = function(e, t) {
                t = +t || 1;
                var r = Math.max(t, 3);
                return e === "solid" ? e = "" : e === "dot" ? e = r + "px," + r + "px" : e === "dash" ? e = 3 * r + "px," + 3 * r + "px" : e === "longdash" ? e = 5 * r + "px," + 5 * r + "px" : e === "dashdot" ? e = 3 * r + "px," + r + "px," + r + "px," + r + "px" : e === "longdashdot" && (e = 5 * r + "px," + 2 * r + "px," + r + "px," + 2 * r + "px"), e;
            };
            function Aoe(e, t, r, n) {
                var i = t.fillpattern, a = t.fillgradient, o = i && na.getPatternAttr(i.shape, 0, "");
                if (o) {
                    var s = na.getPatternAttr(i.bgcolor, 0, null), l = na.getPatternAttr(i.fgcolor, 0, null), u = i.fgopacity, c = na.getPatternAttr(i.size, 0, 8), f = na.getPatternAttr(i.solidity, 0, .3), h = t.uid;
                    na.pattern(e, "point", r, h, o, c, f, void 0, i.fillmode, s, l, u);
                } else if (a && a.type !== "none") {
                    var d = a.type, v = "scatterfill-" + t.uid;
                    if (n && (v = "legendfill-" + t.uid), !n && (a.start !== void 0 || a.stop !== void 0)) {
                        var x, b;
                        d === "horizontal" ? (x = {
                            x: a.start,
                            y: 0
                        }, b = {
                            x: a.stop,
                            y: 0
                        }) : d === "vertical" && (x = {
                            x: 0,
                            y: a.start
                        }, b = {
                            x: 0,
                            y: a.stop
                        }), x.x = t._xA.c2p(x.x === void 0 ? t._extremes.x.min[0].val : x.x, !0), x.y = t._yA.c2p(x.y === void 0 ? t._extremes.y.min[0].val : x.y, !0), b.x = t._xA.c2p(b.x === void 0 ? t._extremes.x.max[0].val : b.x, !0), b.y = t._yA.c2p(b.y === void 0 ? t._extremes.y.max[0].val : b.y, !0), e.call(Eoe, r, v, "linear", a.colorscale, "fill", x, b, !0, !1);
                    } else d === "horizontal" && (d = d + "reversed"), e.call(na.gradient, r, v, d, a.colorscale, "fill");
                } else t.fillcolor && e.call(Xd.fill, t.fillcolor);
            }
            na.singleFillStyle = function(e, t) {
                var r = od.select(e.node()), n = r.data(), i = ((n[0] || [])[0] || {}).trace || {};
                Aoe(e, i, t, !1);
            };
            na.fillGroupStyle = function(e, t, r) {
                e.style("stroke-width", 0).each(function(n) {
                    var i = od.select(this);
                    n[0].trace && Aoe(i, n[0].trace, t, r);
                });
            };
            var voe = doe();
            na.symbolNames = [];
            na.symbolFuncs = [];
            na.symbolBackOffs = [];
            na.symbolNeedLines = {};
            na.symbolNoDot = {};
            na.symbolNoFill = {};
            na.symbolList = [];
            Object.keys(voe).forEach(function(e) {
                var t = voe[e], r = t.n;
                na.symbolList.push(r, String(r), e, r + 100, String(r + 100), e + "-open"), na.symbolNames[r] = e, na.symbolFuncs[r] = t.f, na.symbolBackOffs[r] = t.backoff || 0, t.needLine && (na.symbolNeedLines[r] = !0), t.noDot ? na.symbolNoDot[r] = !0 : na.symbolList.push(r + 200, String(r + 200), e + "-dot", r + 300, String(r + 300), e + "-open-dot"), t.noFill && (na.symbolNoFill[r] = !0);
            });
            var Tat = na.symbolNames.length, Aat = "M0,0.5L0.5,0L0,-0.5L-0.5,0Z";
            na.symbolNumber = function(e) {
                if (Ab(e)) e = +e;
                else if (typeof e == "string") {
                    var t = 0;
                    e.indexOf("-open") > 0 && (t = 100, e = e.replace("-open", "")), e.indexOf("-dot") > 0 && (t += 200, e = e.replace("-dot", "")), e = na.symbolNames.indexOf(e), e >= 0 && (e += t);
                }
                return e % 100 >= Tat || e >= 400 ? 0 : Math.floor(Math.max(e, 0));
            };
            function Soe(e, t, r, n) {
                var i = e % 100;
                return na.symbolFuncs[i](t, r, n) + (e >= 200 ? Aat : "");
            }
            var poe = hat("~f"), Moe = {
                radial: {
                    type: "radial"
                },
                radialreversed: {
                    type: "radial",
                    reversed: !0
                },
                horizontal: {
                    type: "linear",
                    start: {
                        x: 1,
                        y: 0
                    },
                    stop: {
                        x: 0,
                        y: 0
                    }
                },
                horizontalreversed: {
                    type: "linear",
                    start: {
                        x: 1,
                        y: 0
                    },
                    stop: {
                        x: 0,
                        y: 0
                    },
                    reversed: !0
                },
                vertical: {
                    type: "linear",
                    start: {
                        x: 0,
                        y: 1
                    },
                    stop: {
                        x: 0,
                        y: 0
                    }
                },
                verticalreversed: {
                    type: "linear",
                    start: {
                        x: 0,
                        y: 1
                    },
                    stop: {
                        x: 0,
                        y: 0
                    },
                    reversed: !0
                }
            };
            na.gradient = function(e, t, r, n, i, a) {
                var o = Moe[n];
                return Eoe(e, t, r, o.type, i, a, o.start, o.stop, !1, o.reversed);
            };
            function Eoe(e, t, r, n, i, a, o, s, l, u) {
                var c = i.length, f;
                n === "linear" ? f = {
                    node: "linearGradient",
                    attrs: {
                        x1: o.x,
                        y1: o.y,
                        x2: s.x,
                        y2: s.y,
                        gradientUnits: l ? "userSpaceOnUse" : "objectBoundingBox"
                    },
                    reversed: u
                } : n === "radial" && (f = {
                    node: "radialGradient",
                    reversed: u
                });
                for(var h = new Array(c), d = 0; d < c; d++)f.reversed ? h[c - 1 - d] = [
                    poe((1 - i[d][0]) * 100),
                    i[d][1]
                ] : h[d] = [
                    poe(i[d][0] * 100),
                    i[d][1]
                ];
                var v = t._fullLayout, x = "g" + v._uid + "-" + r, b = v._defs.select(".gradients").selectAll("#" + x).data([
                    n + h.join(";")
                ], du.identity);
                b.exit().remove(), b.enter().append(f.node).each(function() {
                    var p = od.select(this);
                    f.attrs && p.attr(f.attrs), p.attr("id", x);
                    var E = p.selectAll("stop").data(h);
                    E.exit().remove(), E.enter().append("stop"), E.each(function(k) {
                        var A = OO(k[1]);
                        od.select(this).attr({
                            offset: k[0] + "%",
                            "stop-color": Xd.tinyRGB(A),
                            "stop-opacity": A.getAlpha()
                        });
                    });
                }), e.style(a, BO(x, t)).style(a + "-opacity", null), e.classed("gradient_filled", !0);
            }
            na.pattern = function(e, t, r, n, i, a, o, s, l, u, c, f) {
                var h = t === "legend";
                s && (l === "overlay" ? (u = s, c = Xd.contrast(u)) : (u = void 0, c = s));
                var d = r._fullLayout, v = "p" + d._uid + "-" + n, x, b, p = function(q, V, H, X, G) {
                    return X + (G - X) * (q - V) / (H - V);
                }, E, k, A, L, _ = {}, C = OO(c), M = Xd.tinyRGB(C), g = C.getAlpha(), P = f * g;
                switch(i){
                    case "/":
                        x = a * Math.sqrt(2), b = a * Math.sqrt(2), E = "M-" + x / 4 + "," + b / 4 + "l" + x / 2 + ",-" + b / 2 + "M0," + b + "L" + x + ",0M" + x / 4 * 3 + "," + b / 4 * 5 + "l" + x / 2 + ",-" + b / 2, k = o * a, L = "path", _ = {
                            d: E,
                            opacity: P,
                            stroke: M,
                            "stroke-width": k + "px"
                        };
                        break;
                    case "\\":
                        x = a * Math.sqrt(2), b = a * Math.sqrt(2), E = "M" + x / 4 * 3 + ",-" + b / 4 + "l" + x / 2 + "," + b / 2 + "M0,0L" + x + "," + b + "M-" + x / 4 + "," + b / 4 * 3 + "l" + x / 2 + "," + b / 2, k = o * a, L = "path", _ = {
                            d: E,
                            opacity: P,
                            stroke: M,
                            "stroke-width": k + "px"
                        };
                        break;
                    case "x":
                        x = a * Math.sqrt(2), b = a * Math.sqrt(2), E = "M-" + x / 4 + "," + b / 4 + "l" + x / 2 + ",-" + b / 2 + "M0," + b + "L" + x + ",0M" + x / 4 * 3 + "," + b / 4 * 5 + "l" + x / 2 + ",-" + b / 2 + "M" + x / 4 * 3 + ",-" + b / 4 + "l" + x / 2 + "," + b / 2 + "M0,0L" + x + "," + b + "M-" + x / 4 + "," + b / 4 * 3 + "l" + x / 2 + "," + b / 2, k = a - a * Math.sqrt(1 - o), L = "path", _ = {
                            d: E,
                            opacity: P,
                            stroke: M,
                            "stroke-width": k + "px"
                        };
                        break;
                    case "|":
                        x = a, b = a, L = "path", E = "M" + x / 2 + ",0L" + x / 2 + "," + b, k = o * a, L = "path", _ = {
                            d: E,
                            opacity: P,
                            stroke: M,
                            "stroke-width": k + "px"
                        };
                        break;
                    case "-":
                        x = a, b = a, L = "path", E = "M0," + b / 2 + "L" + x + "," + b / 2, k = o * a, L = "path", _ = {
                            d: E,
                            opacity: P,
                            stroke: M,
                            "stroke-width": k + "px"
                        };
                        break;
                    case "+":
                        x = a, b = a, L = "path", E = "M" + x / 2 + ",0L" + x / 2 + "," + b + "M0," + b / 2 + "L" + x + "," + b / 2, k = a - a * Math.sqrt(1 - o), L = "path", _ = {
                            d: E,
                            opacity: P,
                            stroke: M,
                            "stroke-width": k + "px"
                        };
                        break;
                    case ".":
                        x = a, b = a, o < Math.PI / 4 ? A = Math.sqrt(o * a * a / Math.PI) : A = p(o, Math.PI / 4, 1, a / 2, a / Math.sqrt(2)), L = "circle", _ = {
                            cx: x / 2,
                            cy: b / 2,
                            r: A,
                            opacity: P,
                            fill: M
                        };
                        break;
                }
                var T = [
                    i || "noSh",
                    u || "noBg",
                    c || "noFg",
                    a,
                    o
                ].join(";"), F = d._defs.select(".patterns").selectAll("#" + v).data([
                    T
                ], du.identity);
                F.exit().remove(), F.enter().append("pattern").each(function() {
                    var q = od.select(this);
                    if (q.attr({
                        id: v,
                        width: x + "px",
                        height: b + "px",
                        patternUnits: "userSpaceOnUse",
                        patternTransform: h ? "scale(0.8)" : ""
                    }), u) {
                        var V = OO(u), H = Xd.tinyRGB(V), X = V.getAlpha(), G = q.selectAll("rect").data([
                            0
                        ]);
                        G.exit().remove(), G.enter().append("rect").attr({
                            width: x + "px",
                            height: b + "px",
                            fill: H,
                            "fill-opacity": X
                        });
                    }
                    var N = q.selectAll(L).data([
                        0
                    ]);
                    N.exit().remove(), N.enter().append(L).attr(_);
                }), e.style("fill", BO(v, r)).style("fill-opacity", null), e.classed("pattern_filled", !0);
            };
            na.initGradients = function(e) {
                var t = e._fullLayout, r = du.ensureSingle(t._defs, "g", "gradients");
                r.selectAll("linearGradient,radialGradient").remove(), od.select(e).selectAll(".gradient_filled").classed("gradient_filled", !1);
            };
            na.initPatterns = function(e) {
                var t = e._fullLayout, r = du.ensureSingle(t._defs, "g", "patterns");
                r.selectAll("pattern").remove(), od.select(e).selectAll(".pattern_filled").classed("pattern_filled", !1);
            };
            na.getPatternAttr = function(e, t, r) {
                return e && du.isArrayOrTypedArray(e) ? t < e.length ? e[t] : r : e;
            };
            na.pointStyle = function(e, t, r, n) {
                if (e.size()) {
                    var i = na.makePointStyleFns(t);
                    e.each(function(a) {
                        na.singlePointStyle(a, od.select(this), t, i, r, n);
                    });
                }
            };
            na.singlePointStyle = function(e, t, r, n, i, a) {
                var o = r.marker, s = o.line;
                if (a && a.i >= 0 && e.i === void 0 && (e.i = a.i), t.style("opacity", n.selectedOpacityFn ? n.selectedOpacityFn(e) : e.mo === void 0 ? o.opacity : e.mo), n.ms2mrc) {
                    var l;
                    e.ms === "various" || o.size === "various" ? l = 3 : l = n.ms2mrc(e.ms), e.mrc = l, n.selectedSizeFn && (l = e.mrc = n.selectedSizeFn(e));
                    var u = na.symbolNumber(e.mx || o.symbol) || 0;
                    e.om = u % 200 >= 100;
                    var c = UO(e, r), f = NO(e, r);
                    t.attr("d", Soe(u, l, c, f));
                }
                var h = !1, d, v, x;
                if (e.so) x = s.outlierwidth, v = s.outliercolor, d = o.outliercolor;
                else {
                    var b = (s || {}).width;
                    x = (e.mlw + 1 || b + 1 || (e.trace ? (e.trace.marker.line || {}).width : 0) + 1) - 1 || 0, "mlc" in e ? v = e.mlcc = n.lineScale(e.mlc) : du.isArrayOrTypedArray(s.color) ? v = Xd.defaultLine : v = s.color, du.isArrayOrTypedArray(o.color) && (d = Xd.defaultLine, h = !0), "mc" in e ? d = e.mcc = n.markerScale(e.mc) : d = o.color || o.colors || "rgba(0,0,0,0)", n.selectedColorFn && (d = n.selectedColorFn(e));
                }
                if (e.om) t.call(Xd.stroke, d).style({
                    "stroke-width": (x || 1) + "px",
                    fill: "none"
                });
                else {
                    t.style("stroke-width", (e.isBlank ? 0 : x) + "px");
                    var p = o.gradient, E = e.mgt;
                    E ? h = !0 : E = p && p.type, du.isArrayOrTypedArray(E) && (E = E[0], Moe[E] || (E = 0));
                    var k = o.pattern, A = k && na.getPatternAttr(k.shape, e.i, "");
                    if (E && E !== "none") {
                        var L = e.mgc;
                        L ? h = !0 : L = p.color;
                        var _ = r.uid;
                        h && (_ += "-" + e.i), na.gradient(t, i, _, E, [
                            [
                                0,
                                L
                            ],
                            [
                                1,
                                d
                            ]
                        ], "fill");
                    } else if (A) {
                        var C = !1, M = k.fgcolor;
                        !M && a && a.color && (M = a.color, C = !0);
                        var g = na.getPatternAttr(M, e.i, a && a.color || null), P = na.getPatternAttr(k.bgcolor, e.i, null), T = k.fgopacity, F = na.getPatternAttr(k.size, e.i, 8), q = na.getPatternAttr(k.solidity, e.i, .3);
                        C = C || e.mcc || du.isArrayOrTypedArray(k.shape) || du.isArrayOrTypedArray(k.bgcolor) || du.isArrayOrTypedArray(k.fgcolor) || du.isArrayOrTypedArray(k.size) || du.isArrayOrTypedArray(k.solidity);
                        var V = r.uid;
                        C && (V += "-" + e.i), na.pattern(t, "point", i, V, A, F, q, e.mcc, k.fillmode, P, g, T);
                    } else du.isArrayOrTypedArray(d) ? Xd.fill(t, d[e.i]) : Xd.fill(t, d);
                    x && Xd.stroke(t, v);
                }
            };
            na.makePointStyleFns = function(e) {
                var t = {}, r = e.marker;
                return t.markerScale = na.tryColorscale(r, ""), t.lineScale = na.tryColorscale(r, "line"), tL.traceIs(e, "symbols") && (t.ms2mrc = mat.isBubble(e) ? yat(e) : function() {
                    return (r.size || 6) / 2;
                }), e.selectedpoints && du.extendFlat(t, na.makeSelectedPointStyleFns(e)), t;
            };
            na.makeSelectedPointStyleFns = function(e) {
                var t = {}, r = e.selected || {}, n = e.unselected || {}, i = e.marker || {}, a = r.marker || {}, o = n.marker || {}, s = i.opacity, l = a.opacity, u = o.opacity, c = l !== void 0, f = u !== void 0;
                (du.isArrayOrTypedArray(s) || c || f) && (t.selectedOpacityFn = function(A) {
                    var L = A.mo === void 0 ? i.opacity : A.mo;
                    return A.selected ? c ? l : L : f ? u : Toe * L;
                });
                var h = i.color, d = a.color, v = o.color;
                (d || v) && (t.selectedColorFn = function(A) {
                    var L = A.mcc || h;
                    return A.selected ? d || L : v || L;
                });
                var x = i.size, b = a.size, p = o.size, E = b !== void 0, k = p !== void 0;
                return tL.traceIs(e, "symbols") && (E || k) && (t.selectedSizeFn = function(A) {
                    var L = A.mrc || x / 2;
                    return A.selected ? E ? b / 2 : L : k ? p / 2 : L;
                }), t;
            };
            na.makeSelectedTextStyleFns = function(e) {
                var t = {}, r = e.selected || {}, n = e.unselected || {}, i = e.textfont || {}, a = r.textfont || {}, o = n.textfont || {}, s = i.color, l = a.color, u = o.color;
                return t.selectedTextColorFn = function(c) {
                    var f = c.tc || s;
                    return c.selected ? l || f : u || (l ? f : Xd.addOpacity(f, Toe));
                }, t;
            };
            na.selectedPointStyle = function(e, t) {
                if (!(!e.size() || !t.selectedpoints)) {
                    var r = na.makeSelectedPointStyleFns(t), n = t.marker || {}, i = [];
                    r.selectedOpacityFn && i.push(function(a, o) {
                        a.style("opacity", r.selectedOpacityFn(o));
                    }), r.selectedColorFn && i.push(function(a, o) {
                        Xd.fill(a, r.selectedColorFn(o));
                    }), r.selectedSizeFn && i.push(function(a, o) {
                        var s = o.mx || n.symbol || 0, l = r.selectedSizeFn(o);
                        a.attr("d", Soe(na.symbolNumber(s), l, UO(o, t), NO(o, t))), o.mrc2 = l;
                    }), i.length && e.each(function(a) {
                        for(var o = od.select(this), s = 0; s < i.length; s++)i[s](o, a);
                    });
                }
            };
            na.tryColorscale = function(e, t) {
                var r = t ? du.nestedProperty(e, t).get() : e;
                if (r) {
                    var n = r.color;
                    if ((r.colorscale || r._colorAx) && du.isArrayOrTypedArray(n)) return dat.makeColorScaleFuncFromTrace(r);
                }
                return du.identity;
            };
            var DO = {
                start: 1,
                end: -1,
                middle: 0,
                bottom: 1,
                top: -1
            };
            function koe(e, t, r, n, i) {
                var a = od.select(e.node().parentNode), o = t.indexOf("top") !== -1 ? "top" : t.indexOf("bottom") !== -1 ? "bottom" : "middle", s = t.indexOf("left") !== -1 ? "end" : t.indexOf("right") !== -1 ? "start" : "middle", l = n ? n / .8 + 1 : 0, u = (rL.lineCount(e) - 1) * gat + 1, c = DO[s] * l, f = r * .75 + DO[o] * l + (DO[o] - 1) * u * r / 2;
                e.attr("text-anchor", s), i || a.attr("transform", KS(c, f));
            }
            function Coe(e, t) {
                var r = e.ts || t.textfont.size;
                return Ab(r) && r > 0 ? r : 0;
            }
            na.textPointStyle = function(e, t, r) {
                if (e.size()) {
                    var n;
                    if (t.selectedpoints) {
                        var i = na.makeSelectedTextStyleFns(t);
                        n = i.selectedTextColorFn;
                    }
                    var a = t.texttemplate, o = r._fullLayout;
                    e.each(function(s) {
                        var l = od.select(this), u = a ? du.extractOption(s, t, "txt", "texttemplate") : du.extractOption(s, t, "tx", "text");
                        if (!u && u !== 0) {
                            l.remove();
                            return;
                        }
                        if (a) {
                            var c = t._module.formatLabels, f = c ? c(s, t, o) : {}, h = {};
                            _at(h, t, s.i);
                            var d = t._meta || {};
                            u = du.texttemplateString(u, f, o._d3locale, h, s, d);
                        }
                        var v = s.tp || t.textposition, x = Coe(s, t), b = n ? n(s) : s.tc || t.textfont.color;
                        l.call(na.font, {
                            family: s.tf || t.textfont.family,
                            weight: s.tw || t.textfont.weight,
                            style: s.ty || t.textfont.style,
                            variant: s.tv || t.textfont.variant,
                            textcase: s.tC || t.textfont.textcase,
                            lineposition: s.tE || t.textfont.lineposition,
                            shadow: s.tS || t.textfont.shadow,
                            size: x,
                            color: b
                        }).text(u).call(rL.convertToTspans, r).call(koe, v, x, s.mrc);
                    });
                }
            };
            na.selectedTextStyle = function(e, t) {
                if (!(!e.size() || !t.selectedpoints)) {
                    var r = na.makeSelectedTextStyleFns(t);
                    e.each(function(n) {
                        var i = od.select(this), a = r.selectedTextColorFn(n), o = n.tp || t.textposition, s = Coe(n, t);
                        Xd.fill(i, a);
                        var l = tL.traceIs(t, "bar-like");
                        koe(i, o, s, n.mrc2 || n.mrc, l);
                    });
                }
            };
            var goe = .5;
            na.smoothopen = function(e, t) {
                if (e.length < 3) return "M" + e.join("L");
                var r = "M" + e[0], n = [], i;
                for(i = 1; i < e.length - 1; i++)n.push(eL(e[i - 1], e[i], e[i + 1], t));
                for(r += "Q" + n[0][0] + " " + e[1], i = 2; i < e.length - 1; i++)r += "C" + n[i - 2][1] + " " + n[i - 1][0] + " " + e[i];
                return r += "Q" + n[e.length - 3][1] + " " + e[e.length - 1], r;
            };
            na.smoothclosed = function(e, t) {
                if (e.length < 3) return "M" + e.join("L") + "Z";
                var r = "M" + e[0], n = e.length - 1, i = [
                    eL(e[n], e[0], e[1], t)
                ], a;
                for(a = 1; a < n; a++)i.push(eL(e[a - 1], e[a], e[a + 1], t));
                for(i.push(eL(e[n - 1], e[n], e[0], t)), a = 1; a <= n; a++)r += "C" + i[a - 1][1] + " " + i[a][0] + " " + e[a];
                return r += "C" + i[n][1] + " " + i[0][0] + " " + e[0] + "Z", r;
            };
            var Loe, Poe;
            function M3(e, t, r) {
                return r && (e = Ioe(e)), t ? Tb(e[1]) : wb(e[0]);
            }
            function wb(e) {
                var t = od.round(e, 2);
                return Loe = t, t;
            }
            function Tb(e) {
                var t = od.round(e, 2);
                return Poe = t, t;
            }
            function eL(e, t, r, n) {
                var i = e[0] - t[0], a = e[1] - t[1], o = r[0] - t[0], s = r[1] - t[1], l = Math.pow(i * i + a * a, goe / 2), u = Math.pow(o * o + s * s, goe / 2), c = (u * u * i - l * l * o) * n, f = (u * u * a - l * l * s) * n, h = 3 * u * (l + u), d = 3 * l * (l + u);
                return [
                    [
                        wb(t[0] + (h && c / h)),
                        Tb(t[1] + (h && f / h))
                    ],
                    [
                        wb(t[0] - (d && c / d)),
                        Tb(t[1] - (d && f / d))
                    ]
                ];
            }
            var Sat = {
                hv: function(e, t, r) {
                    return "H" + wb(t[0]) + "V" + M3(t, 1, r);
                },
                vh: function(e, t, r) {
                    return "V" + Tb(t[1]) + "H" + M3(t, 0, r);
                },
                hvh: function(e, t, r) {
                    return "H" + wb((e[0] + t[0]) / 2) + "V" + Tb(t[1]) + "H" + M3(t, 0, r);
                },
                vhv: function(e, t, r) {
                    return "V" + Tb((e[1] + t[1]) / 2) + "H" + wb(t[0]) + "V" + M3(t, 1, r);
                }
            }, Mat = function(e, t, r) {
                return "L" + M3(t, 0, r) + "," + M3(t, 1, r);
            };
            na.steps = function(e) {
                var t = Sat[e] || Mat;
                return function(r) {
                    for(var n = "M" + wb(r[0][0]) + "," + Tb(r[0][1]), i = r.length, a = 1; a < i; a++)n += t(r[a - 1], r[a], a === i - 1);
                    return n;
                };
            };
            function Ioe(e, t) {
                var r = e.backoff, n = e.trace, i = e.d, a = e.i;
                if (r && n && n.marker && n.marker.angle % 360 === 0 && n.line && n.line.shape !== "spline") {
                    var o = du.isArrayOrTypedArray(r), s = e, l = t ? t[0] : Loe || 0, u = t ? t[1] : Poe || 0, c = s[0], f = s[1], h = c - l, d = f - u, v = Math.atan2(d, h), x = o ? r[a] : r;
                    if (x === "auto") {
                        var b = s.i;
                        n.type === "scatter" && b--;
                        var p = s.marker, E = p.symbol;
                        du.isArrayOrTypedArray(E) && (E = E[b]);
                        var k = p.size;
                        du.isArrayOrTypedArray(k) && (k = k[b]), x = p ? na.symbolBackOffs[na.symbolNumber(E)] * k : 0, x += na.getMarkerStandoff(i[b], n) || 0;
                    }
                    var A = c - x * Math.cos(v), L = f - x * Math.sin(v);
                    (A <= c && A >= l || A >= c && A <= l) && (L <= f && L >= u || L >= f && L <= u) && (e = [
                        A,
                        L
                    ]);
                }
                return e;
            }
            na.applyBackoff = Ioe;
            na.makeTester = function() {
                var e = du.ensureSingleById(od.select("body"), "svg", "js-plotly-tester", function(r) {
                    r.attr(vat.svgAttrs).style({
                        position: "absolute",
                        left: "-10000px",
                        top: "-10000px",
                        width: "9000px",
                        height: "9000px",
                        "z-index": "1"
                    });
                }), t = du.ensureSingle(e, "path", "js-reference-point", function(r) {
                    r.attr("d", "M0,0H1V1H0Z").style({
                        "stroke-width": 0,
                        fill: "black"
                    });
                });
                na.tester = e, na.testref = t;
            };
            na.savedBBoxes = {};
            var zO = 0, Eat = 1e4;
            na.bBox = function(e, t, r) {
                r || (r = moe(e));
                var n;
                if (r) {
                    if (n = na.savedBBoxes[r], n) return du.extendFlat({}, n);
                } else if (e.childNodes.length === 1) {
                    var i = e.childNodes[0];
                    if (r = moe(i), r) {
                        var a = +i.getAttribute("x") || 0, o = +i.getAttribute("y") || 0, s = i.getAttribute("transform");
                        if (!s) {
                            var l = na.bBox(i, !1, r);
                            return a && (l.left += a, l.right += a), o && (l.top += o, l.bottom += o), l;
                        }
                        if (r += "~" + a + "~" + o + "~" + s, n = na.savedBBoxes[r], n) return du.extendFlat({}, n);
                    }
                }
                var u, c;
                t ? u = e : (c = na.tester.node(), u = e.cloneNode(!0), c.appendChild(u)), od.select(u).attr("transform", null).call(rL.positionText, 0, 0);
                var f = u.getBoundingClientRect(), h = na.testref.node().getBoundingClientRect();
                t || c.removeChild(u);
                var d = {
                    height: f.height,
                    width: f.width,
                    left: f.left - h.left,
                    top: f.top - h.top,
                    right: f.right - h.left,
                    bottom: f.bottom - h.top
                };
                return zO >= Eat && (na.savedBBoxes = {}, zO = 0), r && (na.savedBBoxes[r] = d), zO++, du.extendFlat({}, d);
            };
            function moe(e) {
                var t = e.getAttribute("data-unformatted");
                if (t !== null) return t + e.getAttribute("data-math") + e.getAttribute("text-anchor") + e.getAttribute("style");
            }
            na.setClipUrl = function(e, t, r) {
                e.attr("clip-path", BO(t, r));
            };
            function BO(e, t) {
                if (!e) return null;
                var r = t._context, n = r._exportedPlot ? "" : r._baseUrl || "";
                return n ? "url('" + n + "#" + e + "')" : "url(#" + e + ")";
            }
            na.getTranslate = function(e) {
                var t = /.*\btranslate\((-?\d*\.?\d*)[^-\d]*(-?\d*\.?\d*)[^\d].*/, r = e.attr ? "attr" : "getAttribute", n = e[r]("transform") || "", i = n.replace(t, function(a, o, s) {
                    return [
                        o,
                        s
                    ].join(" ");
                }).split(" ");
                return {
                    x: +i[0] || 0,
                    y: +i[1] || 0
                };
            };
            na.setTranslate = function(e, t, r) {
                var n = /(\btranslate\(.*?\);?)/, i = e.attr ? "attr" : "getAttribute", a = e.attr ? "attr" : "setAttribute", o = e[i]("transform") || "";
                return t = t || 0, r = r || 0, o = o.replace(n, "").trim(), o += KS(t, r), o = o.trim(), e[a]("transform", o), o;
            };
            na.getScale = function(e) {
                var t = /.*\bscale\((\d*\.?\d*)[^\d]*(\d*\.?\d*)[^\d].*/, r = e.attr ? "attr" : "getAttribute", n = e[r]("transform") || "", i = n.replace(t, function(a, o, s) {
                    return [
                        o,
                        s
                    ].join(" ");
                }).split(" ");
                return {
                    x: +i[0] || 1,
                    y: +i[1] || 1
                };
            };
            na.setScale = function(e, t, r) {
                var n = /(\bscale\(.*?\);?)/, i = e.attr ? "attr" : "getAttribute", a = e.attr ? "attr" : "setAttribute", o = e[i]("transform") || "";
                return t = t || 1, r = r || 1, o = o.replace(n, "").trim(), o += "scale(" + t + "," + r + ")", o = o.trim(), e[a]("transform", o), o;
            };
            var kat = /\s*sc.*/;
            na.setPointGroupScale = function(e, t, r) {
                if (t = t || 1, r = r || 1, !!e) {
                    var n = t === 1 && r === 1 ? "" : "scale(" + t + "," + r + ")";
                    e.each(function() {
                        var i = (this.getAttribute("transform") || "").replace(kat, "");
                        i += n, i = i.trim(), this.setAttribute("transform", i);
                    });
                }
            };
            var Cat = /translate\([^)]*\)\s*$/;
            na.setTextPointsScale = function(e, t, r) {
                e && e.each(function() {
                    var n, i = od.select(this), a = i.select("text");
                    if (a.node()) {
                        var o = parseFloat(a.attr("x") || 0), s = parseFloat(a.attr("y") || 0), l = (i.attr("transform") || "").match(Cat);
                        t === 1 && r === 1 ? n = [] : n = [
                            KS(o, s),
                            "scale(" + t + "," + r + ")",
                            KS(-o, -s)
                        ], l && n.push(l), i.attr("transform", n.join(""));
                    }
                });
            };
            function NO(e, t) {
                var r;
                return e && (r = e.mf), r === void 0 && (r = t.marker && t.marker.standoff || 0), !t._geo && !t._xA ? -r : r;
            }
            na.getMarkerStandoff = NO;
            var YS = Math.atan2, bb = Math.cos, E3 = Math.sin;
            function yoe(e, t) {
                var r = t[0], n = t[1];
                return [
                    r * bb(e) - n * E3(e),
                    r * E3(e) + n * bb(e)
                ];
            }
            var _oe, xoe, boe, woe, FO, qO;
            function UO(e, t) {
                var r = e.ma;
                r === void 0 && (r = t.marker.angle, (!r || du.isArrayOrTypedArray(r)) && (r = 0));
                var n, i, a = t.marker.angleref;
                if (a === "previous" || a === "north") {
                    if (t._geo) {
                        var o = t._geo.project(e.lonlat);
                        n = o[0], i = o[1];
                    } else {
                        var s = t._xA, l = t._yA;
                        if (s && l) n = s.c2p(e.x), i = l.c2p(e.y);
                        else return 90;
                    }
                    if (t._geo) {
                        var u = e.lonlat[0], c = e.lonlat[1], f = t._geo.project([
                            u,
                            c + 1e-5
                        ]), h = t._geo.project([
                            u + 1e-5,
                            c
                        ]), d = YS(h[1] - i, h[0] - n), v = YS(f[1] - i, f[0] - n), x;
                        if (a === "north") x = r / 180 * Math.PI;
                        else if (a === "previous") {
                            var b = u / 180 * Math.PI, p = c / 180 * Math.PI, E = _oe / 180 * Math.PI, k = xoe / 180 * Math.PI, A = E - b, L = bb(k) * E3(A), _ = E3(k) * bb(p) - bb(k) * E3(p) * bb(A);
                            x = -YS(L, _) - Math.PI, _oe = u, xoe = c;
                        }
                        var C = yoe(d, [
                            bb(x),
                            0
                        ]), M = yoe(v, [
                            E3(x),
                            0
                        ]);
                        r = YS(C[1] + M[1], C[0] + M[0]) / Math.PI * 180, a === "previous" && !(qO === t.uid && e.i === FO + 1) && (r = null);
                    }
                    if (a === "previous" && !t._geo) {
                        if (qO === t.uid && e.i === FO + 1 && Ab(n) && Ab(i)) {
                            var g = n - boe, P = i - woe, T = t.line && t.line.shape || "", F = T.slice(T.length - 1);
                            F === "h" && (P = 0), F === "v" && (g = 0), r += YS(P, g) / Math.PI * 180 + 90;
                        } else r = null;
                    }
                }
                return boe = n, woe = i, FO = e.i, qO = t.uid, r;
            }
            na.getMarkerAngle = UO;
        });
        var Mb = ye((xrr, qoe)=>{
            "use strict";
            var k3 = xa(), Lat = uo(), Pat = Xu(), VO = ba(), Sb = Mr(), Doe = Sb.strTranslate, iL = ao(), nL = va(), C3 = Pl(), zoe = U1(), Iat = Nh().OPPOSITE_SIDE, Foe = / [XY][0-9]* /, HO = 1.6, GO = 1.6;
            function Rat(e, t, r) {
                var n = e._fullLayout, i = r.propContainer, a = r.propName, o = r.placeholder, s = r.traceIndex, l = r.avoid || {}, u = r.attributes, c = r.transform, f = r.containerGroup, h = 1, d = i.title, v = (d && d.text ? d.text : "").trim(), x = !1, b = d && d.font ? d.font : {}, p = b.family, E = b.size, k = b.color, A = b.weight, L = b.style, _ = b.variant, C = b.textcase, M = b.lineposition, g = b.shadow, P = r.subtitlePropName, T = !!P, F = r.subtitlePlaceholder, q = (i.title || {}).subtitle || {
                    text: "",
                    font: {}
                }, V = q.text.trim(), H = !1, X = 1, G = q.font, N = G.family, W = G.size, re = G.color, ae = G.weight, _e = G.style, Me = G.variant, ke = G.textcase, ge = G.lineposition, ie = G.shadow, Te;
                a === "title.text" ? Te = "titleText" : a.indexOf("axis") !== -1 ? Te = "axisTitleText" : a.indexOf(true) && (Te = "colorbarTitleText");
                var Ee = e._context.edits[Te];
                function Ae(kt, Ct) {
                    return kt === void 0 || Ct === void 0 ? !1 : kt.replace(Foe, " % ") === Ct.replace(Foe, " % ");
                }
                v === "" ? h = 0 : Ae(v, o) && (Ee || (v = ""), h = .2, x = !0), T && (V === "" ? X = 0 : Ae(V, F) && (Ee || (V = ""), X = .2, H = !0)), r._meta ? v = Sb.templateString(v, r._meta) : n._meta && (v = Sb.templateString(v, n._meta));
                var ze = v || V || Ee, Ce;
                f || (f = Sb.ensureSingle(n._infolayer, "g", "g-" + t), Ce = n._hColorbarMoveTitle);
                var me = f.selectAll("text." + t).data(ze ? [
                    0
                ] : []);
                me.enter().append("text"), me.text(v).attr("class", t), me.exit().remove();
                var Re = null, ce = t + "-subtitle", Ge = V || Ee;
                if (T && Ge && (Re = f.selectAll("text." + ce).data(Ge ? [
                    0
                ] : []), Re.enter().append("text"), Re.text(V).attr("class", ce), Re.exit().remove()), !ze) return f;
                function nt(kt, Ct) {
                    Sb.syncOrAsync([
                        ct,
                        qt
                    ], {
                        title: kt,
                        subtitle: Ct
                    });
                }
                function ct(kt) {
                    var Ct = kt.title, Yt = kt.subtitle, xr;
                    !c && Ce && (c = {}), c ? (xr = "", c.rotate && (xr += "rotate(" + [
                        c.rotate,
                        u.x,
                        u.y
                    ] + ")"), (c.offset || Ce) && (xr += Doe(0, (c.offset || 0) - (Ce || 0)))) : xr = null, Ct.attr("transform", xr);
                    function er(Et) {
                        if (Et) {
                            var dt = k3.select(Et.node().parentNode).select("." + ce);
                            if (!dt.empty()) {
                                var Ht = Et.node().getBBox();
                                if (Ht.height) {
                                    var $t = Ht.y + Ht.height + HO * W;
                                    dt.attr("y", $t);
                                }
                            }
                        }
                    }
                    if (Ct.style("opacity", h * nL.opacity(k)).call(iL.font, {
                        color: nL.rgb(k),
                        size: k3.round(E, 2),
                        family: p,
                        weight: A,
                        style: L,
                        variant: _,
                        textcase: C,
                        shadow: g,
                        lineposition: M
                    }).attr(u).call(C3.convertToTspans, e, er), Yt) {
                        var Ke = f.select("." + t + "-math-group"), xt = Ct.node().getBBox(), bt = Ke.node() ? Ke.node().getBBox() : void 0, Lt = bt ? bt.y + bt.height + HO * W : xt.y + xt.height + GO * W, St = Sb.extendFlat({}, u, {
                            y: Lt
                        });
                        Yt.attr("transform", xr), Yt.style("opacity", X * nL.opacity(re)).call(iL.font, {
                            color: nL.rgb(re),
                            size: k3.round(W, 2),
                            family: N,
                            weight: ae,
                            style: _e,
                            variant: Me,
                            textcase: ke,
                            shadow: ie,
                            lineposition: ge
                        }).attr(St).call(C3.convertToTspans, e);
                    }
                    return Pat.previousPromises(e);
                }
                function qt(kt) {
                    var Ct = kt.title, Yt = k3.select(Ct.node().parentNode);
                    if (l && l.selection && l.side && v) {
                        Yt.attr("transform", null);
                        var xr = Iat[l.side], er = l.side === "left" || l.side === "top" ? -1 : 1, Ke = Lat(l.pad) ? l.pad : 2, xt = iL.bBox(Yt.node()), bt = {
                            t: 0,
                            b: 0,
                            l: 0,
                            r: 0
                        }, Lt = e._fullLayout._reservedMargin;
                        for(var St in Lt)for(var Et in Lt[St]){
                            var dt = Lt[St][Et];
                            bt[Et] = Math.max(bt[Et], dt);
                        }
                        var Ht = {
                            left: bt.l,
                            top: bt.t,
                            right: n.width - bt.r,
                            bottom: n.height - bt.b
                        }, $t = l.maxShift || er * (Ht[l.side] - xt[l.side]), fr = 0;
                        if ($t < 0) fr = $t;
                        else {
                            var _r = l.offsetLeft || 0, Br = l.offsetTop || 0;
                            xt.left -= _r, xt.right -= _r, xt.top -= Br, xt.bottom -= Br, l.selection.each(function() {
                                var Nr = iL.bBox(this);
                                Sb.bBoxIntersect(xt, Nr, Ke) && (fr = Math.max(fr, er * (Nr[l.side] - xt[xr]) + Ke));
                            }), fr = Math.min($t, fr), i._titleScoot = Math.abs(fr);
                        }
                        if (fr > 0 || $t < 0) {
                            var Or = {
                                left: [
                                    -fr,
                                    0
                                ],
                                right: [
                                    fr,
                                    0
                                ],
                                top: [
                                    0,
                                    -fr
                                ],
                                bottom: [
                                    0,
                                    fr
                                ]
                            }[l.side];
                            Yt.attr("transform", Doe(Or[0], Or[1]));
                        }
                    }
                }
                me.call(nt, Re);
                function rt(kt, Ct) {
                    kt.text(Ct).on("mouseover.opacity", function() {
                        k3.select(this).transition().duration(zoe.SHOW_PLACEHOLDER).style("opacity", 1);
                    }).on("mouseout.opacity", function() {
                        k3.select(this).transition().duration(zoe.HIDE_PLACEHOLDER).style("opacity", 0);
                    });
                }
                if (Ee && (v ? me.on(".opacity", null) : (rt(me, o), x = !0), me.call(C3.makeEditable, {
                    gd: e
                }).on("edit", function(kt) {
                    s !== void 0 ? VO.call("_guiRestyle", e, a, kt, s) : VO.call("_guiRelayout", e, a, kt);
                }).on("cancel", function() {
                    this.text(this.attr("data-unformatted")).call(nt);
                }).on("input", function(kt) {
                    this.text(kt || " ").call(C3.positionText, u.x, u.y);
                }), T)) {
                    if (T && !v) {
                        var ot = me.node().getBBox(), Rt = ot.y + ot.height + GO * W;
                        Re.attr("y", Rt);
                    }
                    V ? Re.on(".opacity", null) : (rt(Re, F), H = !0), Re.call(C3.makeEditable, {
                        gd: e
                    }).on("edit", function(kt) {
                        VO.call("_guiRelayout", e, "title.subtitle.text", kt);
                    }).on("cancel", function() {
                        this.text(this.attr("data-unformatted")).call(nt);
                    }).on("input", function(kt) {
                        this.text(kt || " ").call(C3.positionText, Re.attr("x"), Re.attr("y"));
                    });
                }
                return me.classed("js-placeholder", x), Re && Re.classed("js-placeholder", H), f;
            }
            qoe.exports = {
                draw: Rat,
                SUBTITLE_PADDING_EM: GO,
                SUBTITLE_PADDING_MATHJAX_EM: HO
            };
        });
        var ym = ye((brr, Voe)=>{
            "use strict";
            var Dat = xa(), zat = e3().utcFormat, Nu = Mr(), Fat = Nu.numberFormat, gm = uo(), a_ = Nu.cleanNumber, qat = Nu.ms2DateTime, Ooe = Nu.dateTime2ms, mm = Nu.ensureNumber, Boe = Nu.isArrayOrTypedArray, o_ = es(), aL = o_.FP_SAFE, bg = o_.BADNUM, Oat = o_.LOG_CLIP, Bat = o_.ONEWEEK, oL = o_.ONEDAY, sL = o_.ONEHOUR, Noe = o_.ONEMIN, Uoe = o_.ONESEC, lL = af(), fL = ad(), uL = fL.HOUR_PATTERN, cL = fL.WEEKDAY_PATTERN;
            function JS(e) {
                return Math.pow(10, e);
            }
            function jO(e) {
                return e != null;
            }
            Voe.exports = function(t, r) {
                r = r || {};
                var n = t._id || "x", i = n.charAt(0);
                function a(A, L) {
                    if (A > 0) return Math.log(A) / Math.LN10;
                    if (A <= 0 && L && t.range && t.range.length === 2) {
                        var _ = t.range[0], C = t.range[1];
                        return .5 * (_ + C - 2 * Oat * Math.abs(_ - C));
                    } else return bg;
                }
                function o(A, L, _, C) {
                    if ((C || {}).msUTC && gm(A)) return +A;
                    var M = Ooe(A, _ || t.calendar);
                    if (M === bg) {
                        if (gm(A)) {
                            A = +A;
                            var g = Math.floor(Nu.mod(A + .05, 1) * 10), P = Math.round(A - g / 10);
                            M = Ooe(new Date(P)) + g / 10;
                        } else return bg;
                    }
                    return M;
                }
                function s(A, L, _) {
                    return qat(A, L, _ || t.calendar);
                }
                function l(A) {
                    return t._categories[Math.round(A)];
                }
                function u(A) {
                    if (jO(A)) {
                        if (t._categoriesMap === void 0 && (t._categoriesMap = {}), t._categoriesMap[A] !== void 0) return t._categoriesMap[A];
                        t._categories.push(typeof A == "number" ? String(A) : A);
                        var L = t._categories.length - 1;
                        return t._categoriesMap[A] = L, L;
                    }
                    return bg;
                }
                function c(A, L) {
                    for(var _ = new Array(L), C = 0; C < L; C++){
                        var M = (A[0] || [])[C], g = (A[1] || [])[C];
                        _[C] = f([
                            M,
                            g
                        ]);
                    }
                    return _;
                }
                function f(A) {
                    if (t._categoriesMap) return t._categoriesMap[A];
                }
                function h(A) {
                    var L = f(A);
                    if (L !== void 0) return L;
                    if (gm(A)) return +A;
                }
                function d(A) {
                    return gm(A) ? +A : f(A);
                }
                function v(A, L, _) {
                    return Dat.round(_ + L * A, 2);
                }
                function x(A, L, _) {
                    return (A - _) / L;
                }
                var b = function(L) {
                    return gm(L) ? v(L, t._m, t._b) : bg;
                }, p = function(A) {
                    return x(A, t._m, t._b);
                };
                if (t.rangebreaks) {
                    var E = i === "y";
                    b = function(A) {
                        if (!gm(A)) return bg;
                        var L = t._rangebreaks.length;
                        if (!L) return v(A, t._m, t._b);
                        var _ = E;
                        t.range[0] > t.range[1] && (_ = !_);
                        for(var C = _ ? -1 : 1, M = C * A, g = 0, P = 0; P < L; P++){
                            var T = C * t._rangebreaks[P].min, F = C * t._rangebreaks[P].max;
                            if (M < T) break;
                            if (M > F) g = P + 1;
                            else {
                                g = M < (T + F) / 2 ? P : P + 1;
                                break;
                            }
                        }
                        var q = t._B[g] || 0;
                        return isFinite(q) ? v(A, t._m2, q) : 0;
                    }, p = function(A) {
                        var L = t._rangebreaks.length;
                        if (!L) return x(A, t._m, t._b);
                        for(var _ = 0, C = 0; C < L && !(A < t._rangebreaks[C].pmin); C++)A > t._rangebreaks[C].pmax && (_ = C + 1);
                        return x(A, t._m2, t._B[_]);
                    };
                }
                t.c2l = t.type === "log" ? a : mm, t.l2c = t.type === "log" ? JS : mm, t.l2p = b, t.p2l = p, t.c2p = t.type === "log" ? function(A, L) {
                    return b(a(A, L));
                } : b, t.p2c = t.type === "log" ? function(A) {
                    return JS(p(A));
                } : p, [
                    "linear",
                    "-"
                ].indexOf(t.type) !== -1 ? (t.d2r = t.r2d = t.d2c = t.r2c = t.d2l = t.r2l = a_, t.c2d = t.c2r = t.l2d = t.l2r = mm, t.d2p = t.r2p = function(A) {
                    return t.l2p(a_(A));
                }, t.p2d = t.p2r = p, t.cleanPos = mm) : t.type === "log" ? (t.d2r = t.d2l = function(A, L) {
                    return a(a_(A), L);
                }, t.r2d = t.r2c = function(A) {
                    return JS(a_(A));
                }, t.d2c = t.r2l = a_, t.c2d = t.l2r = mm, t.c2r = a, t.l2d = JS, t.d2p = function(A, L) {
                    return t.l2p(t.d2r(A, L));
                }, t.p2d = function(A) {
                    return JS(p(A));
                }, t.r2p = function(A) {
                    return t.l2p(a_(A));
                }, t.p2r = p, t.cleanPos = mm) : t.type === "date" ? (t.d2r = t.r2d = Nu.identity, t.d2c = t.r2c = t.d2l = t.r2l = o, t.c2d = t.c2r = t.l2d = t.l2r = s, t.d2p = t.r2p = function(A, L, _) {
                    return t.l2p(o(A, 0, _));
                }, t.p2d = t.p2r = function(A, L, _) {
                    return s(p(A), L, _);
                }, t.cleanPos = function(A) {
                    return Nu.cleanDate(A, bg, t.calendar);
                }) : t.type === "category" ? (t.d2c = t.d2l = u, t.r2d = t.c2d = t.l2d = l, t.d2r = t.d2l_noadd = h, t.r2c = function(A) {
                    var L = d(A);
                    return L !== void 0 ? L : t.fraction2r(.5);
                }, t.l2r = t.c2r = mm, t.r2l = d, t.d2p = function(A) {
                    return t.l2p(t.r2c(A));
                }, t.p2d = function(A) {
                    return l(p(A));
                }, t.r2p = t.d2p, t.p2r = p, t.cleanPos = function(A) {
                    return typeof A == "string" && A !== "" ? A : mm(A);
                }) : t.type === "multicategory" && (t.r2d = t.c2d = t.l2d = l, t.d2r = t.d2l_noadd = h, t.r2c = function(A) {
                    var L = h(A);
                    return L !== void 0 ? L : t.fraction2r(.5);
                }, t.r2c_just_indices = f, t.l2r = t.c2r = mm, t.r2l = h, t.d2p = function(A) {
                    return t.l2p(t.r2c(A));
                }, t.p2d = function(A) {
                    return l(p(A));
                }, t.r2p = t.d2p, t.p2r = p, t.cleanPos = function(A) {
                    return Array.isArray(A) || typeof A == "string" && A !== "" ? A : mm(A);
                }, t.setupMultiCategory = function(A) {
                    var L = t._traceIndices, _, C, M = t._matchGroup;
                    if (M && t._categories.length === 0) {
                        for(var g in M)if (g !== n) {
                            var P = r[lL.id2name(g)];
                            L = L.concat(P._traceIndices);
                        }
                    }
                    var T = [
                        [
                            0,
                            {}
                        ],
                        [
                            0,
                            {}
                        ]
                    ], F = [];
                    for(_ = 0; _ < L.length; _++){
                        var q = A[L[_]];
                        if (i in q) {
                            var V = q[i], H = q._length || Nu.minRowLength(V);
                            if (Boe(V[0]) && Boe(V[1])) for(C = 0; C < H; C++){
                                var X = V[0][C], G = V[1][C];
                                jO(X) && jO(G) && (F.push([
                                    X,
                                    G
                                ]), X in T[0][1] || (T[0][1][X] = T[0][0]++), G in T[1][1] || (T[1][1][G] = T[1][0]++));
                            }
                        }
                    }
                    for(F.sort(function(N, W) {
                        var re = T[0][1], ae = re[N[0]] - re[W[0]];
                        if (ae) return ae;
                        var _e = T[1][1];
                        return _e[N[1]] - _e[W[1]];
                    }), _ = 0; _ < F.length; _++)u(F[_]);
                }), t.fraction2r = function(A) {
                    var L = t.r2l(t.range[0]), _ = t.r2l(t.range[1]);
                    return t.l2r(L + A * (_ - L));
                }, t.r2fraction = function(A) {
                    var L = t.r2l(t.range[0]), _ = t.r2l(t.range[1]);
                    return (t.r2l(A) - L) / (_ - L);
                }, t.limitRange = function(A) {
                    var L = t.minallowed, _ = t.maxallowed;
                    if (!(L === void 0 && _ === void 0)) {
                        A || (A = "range");
                        var C = Nu.nestedProperty(t, A).get(), M = Nu.simpleMap(C, t.r2l), g = M[1] < M[0];
                        g && M.reverse();
                        var P = Nu.simpleMap([
                            L,
                            _
                        ], t.r2l);
                        if (L !== void 0 && M[0] < P[0] && (C[g ? 1 : 0] = L), _ !== void 0 && M[1] > P[1] && (C[g ? 0 : 1] = _), C[0] === C[1]) {
                            var T = t.l2r(L), F = t.l2r(_);
                            if (L !== void 0) {
                                var q = T + 1;
                                _ !== void 0 && (q = Math.min(q, F)), C[g ? 1 : 0] = q;
                            }
                            if (_ !== void 0) {
                                var V = F + 1;
                                L !== void 0 && (V = Math.max(V, T)), C[g ? 0 : 1] = V;
                            }
                        }
                    }
                }, t.cleanRange = function(A, L) {
                    t._cleanRange(A, L), t.limitRange(A);
                }, t._cleanRange = function(A, L) {
                    L || (L = {}), A || (A = "range");
                    var _ = Nu.nestedProperty(t, A).get(), C, M;
                    if (t.type === "date" ? M = Nu.dfltRange(t.calendar) : i === "y" ? M = fL.DFLTRANGEY : t._name === "realaxis" ? M = [
                        0,
                        1
                    ] : M = L.dfltRange || fL.DFLTRANGEX, M = M.slice(), (t.rangemode === "tozero" || t.rangemode === "nonnegative") && (M[0] = 0), !_ || _.length !== 2) {
                        Nu.nestedProperty(t, A).set(M);
                        return;
                    }
                    var g = _[0] === null, P = _[1] === null;
                    for(t.type === "date" && !t.autorange && (_[0] = Nu.cleanDate(_[0], bg, t.calendar), _[1] = Nu.cleanDate(_[1], bg, t.calendar)), C = 0; C < 2; C++)if (t.type === "date") {
                        if (!Nu.isDateTime(_[C], t.calendar)) {
                            t[A] = M;
                            break;
                        }
                        if (t.r2l(_[0]) === t.r2l(_[1])) {
                            var T = Nu.constrain(t.r2l(_[0]), Nu.MIN_MS + 1e3, Nu.MAX_MS - 1e3);
                            _[0] = t.l2r(T - 1e3), _[1] = t.l2r(T + 1e3);
                            break;
                        }
                    } else {
                        if (!gm(_[C])) {
                            if (!(g || P) && gm(_[1 - C])) _[C] = _[1 - C] * (C ? 10 : .1);
                            else {
                                t[A] = M;
                                break;
                            }
                        }
                        if (_[C] < -aL ? _[C] = -aL : _[C] > aL && (_[C] = aL), _[0] === _[1]) {
                            var F = Math.max(1, Math.abs(_[0] * 1e-6));
                            _[0] -= F, _[1] += F;
                        }
                    }
                }, t.setScale = function(A) {
                    var L = r._size;
                    if (t.overlaying) {
                        var _ = lL.getFromId({
                            _fullLayout: r
                        }, t.overlaying);
                        t.domain = _.domain;
                    }
                    var C = A && t._r ? "_r" : "range", M = t.calendar;
                    t.cleanRange(C);
                    var g = t.r2l(t[C][0], M), P = t.r2l(t[C][1], M), T = i === "y";
                    if (T ? (t._offset = L.t + (1 - t.domain[1]) * L.h, t._length = L.h * (t.domain[1] - t.domain[0]), t._m = t._length / (g - P), t._b = -t._m * P) : (t._offset = L.l + t.domain[0] * L.w, t._length = L.w * (t.domain[1] - t.domain[0]), t._m = t._length / (P - g), t._b = -t._m * g), t._rangebreaks = [], t._lBreaks = 0, t._m2 = 0, t._B = [], t.rangebreaks) {
                        var F, q;
                        if (t._rangebreaks = t.locateBreaks(Math.min(g, P), Math.max(g, P)), t._rangebreaks.length) {
                            for(F = 0; F < t._rangebreaks.length; F++)q = t._rangebreaks[F], t._lBreaks += Math.abs(q.max - q.min);
                            var V = T;
                            g > P && (V = !V), V && t._rangebreaks.reverse();
                            var H = V ? -1 : 1;
                            for(t._m2 = H * t._length / (Math.abs(P - g) - t._lBreaks), t._B.push(-t._m2 * (T ? P : g)), F = 0; F < t._rangebreaks.length; F++)q = t._rangebreaks[F], t._B.push(t._B[t._B.length - 1] - H * t._m2 * (q.max - q.min));
                            for(F = 0; F < t._rangebreaks.length; F++)q = t._rangebreaks[F], q.pmin = b(q.min), q.pmax = b(q.max);
                        }
                    }
                    if (!isFinite(t._m) || !isFinite(t._b) || t._length < 0) throw r._replotting = !1, new Error("Something went wrong with axis scaling");
                }, t.maskBreaks = function(A) {
                    var L = t.rangebreaks || [], _, C, M, g, P;
                    L._cachedPatterns || (L._cachedPatterns = L.map(function(re) {
                        return re.enabled && re.bounds ? Nu.simpleMap(re.bounds, re.pattern ? a_ : t.d2c) : null;
                    })), L._cachedValues || (L._cachedValues = L.map(function(re) {
                        return re.enabled && re.values ? Nu.simpleMap(re.values, t.d2c).sort(Nu.sorterAsc) : null;
                    }));
                    for(var T = 0; T < L.length; T++){
                        var F = L[T];
                        if (F.enabled) {
                            if (F.bounds) {
                                var q = F.pattern;
                                switch(_ = L._cachedPatterns[T], C = _[0], M = _[1], q){
                                    case cL:
                                        P = new Date(A), g = P.getUTCDay(), C > M && (M += 7, g < C && (g += 7));
                                        break;
                                    case uL:
                                        P = new Date(A);
                                        var V = P.getUTCHours(), H = P.getUTCMinutes(), X = P.getUTCSeconds(), G = P.getUTCMilliseconds();
                                        g = V + (H / 60 + X / 3600 + G / 36e5), C > M && (M += 24, g < C && (g += 24));
                                        break;
                                    case "":
                                        g = A;
                                        break;
                                }
                                if (g >= C && g < M) return bg;
                            } else for(var N = L._cachedValues[T], W = 0; W < N.length; W++)if (C = N[W], M = C + F.dvalue, A >= C && A < M) return bg;
                        }
                    }
                    return A;
                }, t.locateBreaks = function(A, L) {
                    var _, C, M, g, P = [];
                    if (!t.rangebreaks) return P;
                    var T = t.rangebreaks.slice().sort(function(_e, Me) {
                        return _e.pattern === cL && Me.pattern === uL ? -1 : Me.pattern === cL && _e.pattern === uL ? 1 : 0;
                    }), F = function(_e, Me) {
                        if (_e = Nu.constrain(_e, A, L), Me = Nu.constrain(Me, A, L), _e !== Me) {
                            for(var ke = !0, ge = 0; ge < P.length; ge++){
                                var ie = P[ge];
                                _e < ie.max && Me >= ie.min && (_e < ie.min && (ie.min = _e), Me > ie.max && (ie.max = Me), ke = !1);
                            }
                            ke && P.push({
                                min: _e,
                                max: Me
                            });
                        }
                    };
                    for(_ = 0; _ < T.length; _++){
                        var q = T[_];
                        if (q.enabled) {
                            if (q.bounds) {
                                var V = A, H = L;
                                q.pattern && (V = Math.floor(V)), C = Nu.simpleMap(q.bounds, q.pattern ? a_ : t.r2l), M = C[0], g = C[1];
                                var X = new Date(V), G, N;
                                switch(q.pattern){
                                    case cL:
                                        N = Bat, G = ((g < M ? 7 : 0) + (g - M)) * oL, V += M * oL - (X.getUTCDay() * oL + X.getUTCHours() * sL + X.getUTCMinutes() * Noe + X.getUTCSeconds() * Uoe + X.getUTCMilliseconds());
                                        break;
                                    case uL:
                                        N = oL, G = ((g < M ? 24 : 0) + (g - M)) * sL, V += M * sL - (X.getUTCHours() * sL + X.getUTCMinutes() * Noe + X.getUTCSeconds() * Uoe + X.getUTCMilliseconds());
                                        break;
                                    default:
                                        V = Math.min(C[0], C[1]), H = Math.max(C[0], C[1]), N = H - V, G = N;
                                }
                                for(var W = V; W < H; W += N)F(W, W + G);
                            } else for(var re = Nu.simpleMap(q.values, t.d2c), ae = 0; ae < re.length; ae++)M = re[ae], g = M + q.dvalue, F(M, g);
                        }
                    }
                    return P.sort(function(_e, Me) {
                        return _e.min - Me.min;
                    }), P;
                }, t.makeCalcdata = function(A, L, _) {
                    var C, M, g, P, T = t.type, F = T === "date" && A[L + "calendar"];
                    if (L in A) {
                        if (C = A[L], P = A._length || Nu.minRowLength(C), Nu.isTypedArray(C) && (T === "linear" || T === "log")) {
                            if (P === C.length) return C;
                            if (C.subarray) return C.subarray(0, P);
                        }
                        if (T === "multicategory") return c(C, P);
                        for(M = new Array(P), g = 0; g < P; g++)M[g] = t.d2c(C[g], 0, F, _);
                    } else {
                        var q = L + "0" in A ? t.d2c(A[L + "0"], 0, F) : 0, V = A["d" + L] ? Number(A["d" + L]) : 1;
                        for(C = A[({
                            x: "y",
                            y: "x"
                        })[L]], P = A._length || C.length, M = new Array(P), g = 0; g < P; g++)M[g] = q + g * V;
                    }
                    if (t.rangebreaks) for(g = 0; g < P; g++)M[g] = t.maskBreaks(M[g]);
                    return M;
                }, t.isValidRange = function(A, L) {
                    return Array.isArray(A) && A.length === 2 && (L && A[0] === null || gm(t.r2l(A[0]))) && (L && A[1] === null || gm(t.r2l(A[1])));
                }, t.getAutorangeDflt = function(A, L) {
                    var _ = !t.isValidRange(A, "nullOk");
                    return _ && L && L.reverseDflt ? _ = "reversed" : A && (A[0] === null && A[1] === null ? _ = !0 : A[0] === null && A[1] !== null ? _ = "min" : A[0] !== null && A[1] === null && (_ = "max")), _;
                }, t.isReversed = function() {
                    var A = t.autorange;
                    return A === "reversed" || A === "min reversed" || A === "max reversed";
                }, t.isPtWithinRange = function(A, L) {
                    var _ = t.c2l(A[i], null, L), C = t.r2l(t.range[0]), M = t.r2l(t.range[1]);
                    return C < M ? C <= _ && _ <= M : M <= _ && _ <= C;
                }, t._emptyCategories = function() {
                    t._categories = [], t._categoriesMap = {};
                }, t.clearCalc = function() {
                    var A = t._matchGroup;
                    if (A) {
                        var L = null, _ = null;
                        for(var C in A){
                            var M = r[lL.id2name(C)];
                            if (M._categories) {
                                L = M._categories, _ = M._categoriesMap;
                                break;
                            }
                        }
                        L && _ ? (t._categories = L, t._categoriesMap = _) : t._emptyCategories();
                    } else t._emptyCategories();
                    if (t._initialCategories) for(var g = 0; g < t._initialCategories.length; g++)u(t._initialCategories[g]);
                }, t.sortByInitialCategories = function() {
                    var A = [];
                    if (t._emptyCategories(), t._initialCategories) for(var L = 0; L < t._initialCategories.length; L++)u(t._initialCategories[L]);
                    A = A.concat(t._traceIndices);
                    var _ = t._matchGroup;
                    for(var C in _)if (n !== C) {
                        var M = r[lL.id2name(C)];
                        M._categories = t._categories, M._categoriesMap = t._categoriesMap, A = A.concat(M._traceIndices);
                    }
                    return A;
                };
                var k = r._d3locale;
                t.type === "date" && (t._dateFormat = k ? k.timeFormat : zat, t._extraFormat = r._extraFormat), t._separators = r.separators, t._numFormat = k ? k.numberFormat : Fat, delete t._minDtick, delete t._forceTick0;
            };
        });
        var L3 = ye((wrr, Woe)=>{
            "use strict";
            var Hoe = uo(), WO = Mr(), Nat = es().BADNUM, hL = WO.isArrayOrTypedArray, Uat = WO.isDateTime, Vat = WO.cleanNumber, Goe = Math.round;
            Woe.exports = function(t, r, n) {
                var i = t, a = n.noMultiCategory;
                if (hL(i) && !i.length) return "-";
                if (!a && Zat(i)) return "multicategory";
                if (a && Array.isArray(i[0])) {
                    for(var o = [], s = 0; s < i.length; s++)if (hL(i[s])) for(var l = 0; l < i[s].length; l++)o.push(i[s][l]);
                    i = o;
                }
                if (jat(i, r)) return "date";
                var u = n.autotypenumbers !== "strict";
                return Wat(i, u) ? "category" : Gat(i, u) ? "linear" : "-";
            };
            function Hat(e, t) {
                return t ? Hoe(e) : typeof e == "number";
            }
            function Gat(e, t) {
                for(var r = e.length, n = 0; n < r; n++)if (Hat(e[n], t)) return !0;
                return !1;
            }
            function jat(e, t) {
                for(var r = e.length, n = joe(r), i = 0, a = 0, o = {}, s = 0; s < r; s += n){
                    var l = Goe(s), u = e[l], c = String(u);
                    o[c] || (o[c] = 1, Uat(u, t) && i++, Hoe(u) && a++);
                }
                return i > a * 2;
            }
            function joe(e) {
                return Math.max(1, (e - 1) / 1e3);
            }
            function Wat(e, t) {
                for(var r = e.length, n = joe(r), i = 0, a = 0, o = {}, s = 0; s < r; s += n){
                    var l = Goe(s), u = e[l], c = String(u);
                    if (!o[c]) {
                        o[c] = 1;
                        var f = typeof u;
                        f === "boolean" ? a++ : (t ? Vat(u) !== Nat : f === "number") ? i++ : f === "string" && a++;
                    }
                }
                return a > i * 2;
            }
            function Zat(e) {
                return hL(e[0]) && hL(e[1]);
            }
        });
        var wg = ye((Trr, ese)=>{
            "use strict";
            var Xat = xa(), Koe = uo(), s_ = Mr(), dL = es().FP_SAFE, Yat = ba(), Kat = ao(), Joe = af(), Jat = Joe.getFromId, $at = Joe.isLinked;
            ese.exports = {
                applyAutorangeOptions: Qoe,
                getAutoRange: ZO,
                makePadFn: XO,
                doAutoRange: eot,
                findExtremes: tot,
                concatExtremes: JO
            };
            function ZO(e, t) {
                var r, n, i = [], a = e._fullLayout, o = XO(a, t, 0), s = XO(a, t, 1), l = JO(e, t), u = l.min, c = l.max;
                if (u.length === 0 || c.length === 0) return s_.simpleMap(t.range, t.r2l);
                var f = u[0].val, h = c[0].val;
                for(r = 1; r < u.length && f === h; r++)f = Math.min(f, u[r].val);
                for(r = 1; r < c.length && f === h; r++)h = Math.max(h, c[r].val);
                var d = t.autorange, v = d === "reversed" || d === "min reversed" || d === "max reversed";
                if (!v && t.range) {
                    var x = s_.simpleMap(t.range, t.r2l);
                    v = x[1] < x[0];
                }
                t.autorange === "reversed" && (t.autorange = !0);
                var b = t.rangemode, p = b === "tozero", E = b === "nonnegative", k = t._length, A = k / 10, L = 0, _, C, M, g, P, T;
                for(r = 0; r < u.length; r++)for(_ = u[r], n = 0; n < c.length; n++)C = c[n], T = C.val - _.val - Zoe(t, _.val, C.val), T > 0 && (P = k - o(_) - s(C), P > A ? T / P > L && (M = _, g = C, L = T / P) : T / k > L && (M = {
                    val: _.val,
                    nopad: 1
                }, g = {
                    val: C.val,
                    nopad: 1
                }, L = T / k));
                function F(G, N) {
                    return Math.max(G, s(N));
                }
                if (f === h) {
                    var q = f - 1, V = f + 1;
                    if (p) {
                        if (f === 0) i = [
                            0,
                            1
                        ];
                        else {
                            var H = (f > 0 ? c : u).reduce(F, 0), X = f / (1 - Math.min(.5, H / k));
                            i = f > 0 ? [
                                0,
                                X
                            ] : [
                                X,
                                0
                            ];
                        }
                    } else E ? i = [
                        Math.max(0, q),
                        Math.max(1, V)
                    ] : i = [
                        q,
                        V
                    ];
                } else p ? (M.val >= 0 && (M = {
                    val: 0,
                    nopad: 1
                }), g.val <= 0 && (g = {
                    val: 0,
                    nopad: 1
                })) : E && (M.val - L * o(M) < 0 && (M = {
                    val: 0,
                    nopad: 1
                }), g.val <= 0 && (g = {
                    val: 1,
                    nopad: 1
                })), L = (g.val - M.val - Zoe(t, _.val, C.val)) / (k - o(M) - s(g)), i = [
                    M.val - L * o(M),
                    g.val + L * s(g)
                ];
                return i = Qoe(i, t), t.limitRange && t.limitRange(), v && i.reverse(), s_.simpleMap(i, t.l2r || Number);
            }
            function Zoe(e, t, r) {
                var n = 0;
                if (e.rangebreaks) for(var i = e.locateBreaks(t, r), a = 0; a < i.length; a++){
                    var o = i[a];
                    n += o.max - o.min;
                }
                return n;
            }
            function XO(e, t, r) {
                var n = .05 * t._length, i = t._anchorAxis || {};
                if ((t.ticklabelposition || "").indexOf("inside") !== -1 || (i.ticklabelposition || "").indexOf("inside") !== -1) {
                    var a = t.isReversed();
                    if (!a) {
                        var o = s_.simpleMap(t.range, t.r2l);
                        a = o[1] < o[0];
                    }
                    a && (r = !r);
                }
                var s = 0;
                return $at(e, t._id) || (s = Qat(e, t, r)), n = Math.max(s, n), t.constrain === "domain" && t._inputDomain && (n *= (t._inputDomain[1] - t._inputDomain[0]) / (t.domain[1] - t.domain[0])), function(u) {
                    return u.nopad ? 0 : u.pad + (u.extrapad ? n : s);
                };
            }
            var Xoe = 3;
            function Qat(e, t, r) {
                var n = 0, i = t._id.charAt(0) === "x";
                for(var a in e._plots){
                    var o = e._plots[a];
                    if (!(t._id !== o.xaxis._id && t._id !== o.yaxis._id)) {
                        var s = (i ? o.yaxis : o.xaxis) || {};
                        if ((s.ticklabelposition || "").indexOf("inside") !== -1 && (!r && (s.side === "left" || s.side === "bottom") || r && (s.side === "top" || s.side === "right"))) {
                            if (s._vals) {
                                var l = s_.deg2rad(s._tickAngles[s._id + "tick"] || 0), u = Math.abs(Math.cos(l)), c = Math.abs(Math.sin(l));
                                if (!s._vals[0].bb) {
                                    var f = s._id + "tick", h = s._selections[f];
                                    h.each(function(E) {
                                        var k = Xat.select(this), A = k.select(".text-math-group");
                                        A.empty() && (E.bb = Kat.bBox(k.node()));
                                    });
                                }
                                for(var d = 0; d < s._vals.length; d++){
                                    var v = s._vals[d], x = v.bb;
                                    if (x) {
                                        var b = 2 * Xoe + x.width, p = 2 * Xoe + x.height;
                                        n = Math.max(n, i ? Math.max(b * u, p * c) : Math.max(p * u, b * c));
                                    }
                                }
                            }
                            s.ticks === "inside" && s.ticklabelposition === "inside" && (n += s.ticklen || 0);
                        }
                    }
                }
                return n;
            }
            function JO(e, t, r) {
                var n = t._id, i = e._fullData, a = e._fullLayout, o = [], s = [], l, u, c;
                function f(b, p) {
                    for(l = 0; l < p.length; l++){
                        var E = b[p[l]], k = (E._extremes || {})[n];
                        if (E.visible === !0 && k) {
                            for(u = 0; u < k.min.length; u++)c = k.min[u], YO(o, c.val, c.pad, {
                                extrapad: c.extrapad
                            });
                            for(u = 0; u < k.max.length; u++)c = k.max[u], KO(s, c.val, c.pad, {
                                extrapad: c.extrapad
                            });
                        }
                    }
                }
                if (f(i, t._traceIndices), f(a.annotations || [], t._annIndices || []), f(a.shapes || [], t._shapeIndices || []), t._matchGroup && !r) {
                    for(var h in t._matchGroup)if (h !== t._id) {
                        var d = Jat(e, h), v = JO(e, d, !0), x = t._length / d._length;
                        for(u = 0; u < v.min.length; u++)c = v.min[u], YO(o, c.val, c.pad * x, {
                            extrapad: c.extrapad
                        });
                        for(u = 0; u < v.max.length; u++)c = v.max[u], KO(s, c.val, c.pad * x, {
                            extrapad: c.extrapad
                        });
                    }
                }
                return {
                    min: o,
                    max: s
                };
            }
            function eot(e, t, r) {
                if (t.setScale(), t.autorange) {
                    t.range = r ? r.slice() : ZO(e, t), t._r = t.range.slice(), t._rl = s_.simpleMap(t._r, t.r2l);
                    var n = t._input, i = {};
                    i[t._attr + ".range"] = t.range, i[t._attr + ".autorange"] = t.autorange, Yat.call("_storeDirectGUIEdit", e.layout, e._fullLayout._preGUI, i), n.range = t.range.slice(), n.autorange = t.autorange;
                }
                var a = t._anchorAxis;
                if (a && a.rangeslider) {
                    var o = a.rangeslider[t._name];
                    o && o.rangemode === "auto" && (o.range = ZO(e, t)), a._input.rangeslider[t._name] = s_.extendFlat({}, o);
                }
            }
            function tot(e, t, r) {
                r || (r = {}), e._m || e.setScale();
                var n = [], i = [], a = t.length, o = r.padded || !1, s = r.tozero && (e.type === "linear" || e.type === "-"), l = e.type === "log", u = !1, c = r.vpadLinearized || !1, f, h, d, v, x, b, p, E, k;
                function A(F) {
                    if (Array.isArray(F)) return u = !0, function(V) {
                        return Math.max(Number(F[V] || 0), 0);
                    };
                    var q = Math.max(Number(F || 0), 0);
                    return function() {
                        return q;
                    };
                }
                var L = A((e._m > 0 ? r.ppadplus : r.ppadminus) || r.ppad || 0), _ = A((e._m > 0 ? r.ppadminus : r.ppadplus) || r.ppad || 0), C = A(r.vpadplus || r.vpad), M = A(r.vpadminus || r.vpad);
                if (!u) {
                    if (E = 1 / 0, k = -1 / 0, l) for(f = 0; f < a; f++)h = t[f], h < E && h > 0 && (E = h), h > k && h < dL && (k = h);
                    else for(f = 0; f < a; f++)h = t[f], h < E && h > -dL && (E = h), h > k && h < dL && (k = h);
                    t = [
                        E,
                        k
                    ], a = 2;
                }
                var g = {
                    tozero: s,
                    extrapad: o
                };
                function P(F) {
                    d = t[F], Koe(d) && (b = L(F), p = _(F), c ? (v = e.c2l(d) - M(F), x = e.c2l(d) + C(F)) : (E = d - M(F), k = d + C(F), l && E < k / 10 && (E = k / 10), v = e.c2l(E), x = e.c2l(k)), s && (v = Math.min(0, v), x = Math.max(0, x)), Yoe(v) && YO(n, v, p, g), Yoe(x) && KO(i, x, b, g));
                }
                var T = Math.min(6, a);
                for(f = 0; f < T; f++)P(f);
                for(f = a - 1; f >= T; f--)P(f);
                return {
                    min: n,
                    max: i,
                    opts: r
                };
            }
            function YO(e, t, r, n) {
                $oe(e, t, r, n, rot);
            }
            function KO(e, t, r, n) {
                $oe(e, t, r, n, iot);
            }
            function $oe(e, t, r, n, i) {
                for(var a = n.tozero, o = n.extrapad, s = !0, l = 0; l < e.length && s; l++){
                    var u = e[l];
                    if (i(u.val, t) && u.pad >= r && (u.extrapad || !o)) {
                        s = !1;
                        break;
                    } else i(t, u.val) && u.pad <= r && (o || !u.extrapad) && (e.splice(l, 1), l--);
                }
                if (s) {
                    var c = a && t === 0;
                    e.push({
                        val: t,
                        pad: c ? 0 : r,
                        extrapad: c ? !1 : o
                    });
                }
            }
            function Yoe(e) {
                return Koe(e) && Math.abs(e) < dL;
            }
            function rot(e, t) {
                return e <= t;
            }
            function iot(e, t) {
                return e >= t;
            }
            function not(e, t) {
                var r = t.autorangeoptions;
                return r && r.minallowed !== void 0 && vL(t, r.minallowed, r.maxallowed) ? r.minallowed : r && r.clipmin !== void 0 && vL(t, r.clipmin, r.clipmax) ? Math.max(e, t.d2l(r.clipmin)) : e;
            }
            function aot(e, t) {
                var r = t.autorangeoptions;
                return r && r.maxallowed !== void 0 && vL(t, r.minallowed, r.maxallowed) ? r.maxallowed : r && r.clipmax !== void 0 && vL(t, r.clipmin, r.clipmax) ? Math.min(e, t.d2l(r.clipmax)) : e;
            }
            function vL(e, t, r) {
                return t !== void 0 && r !== void 0 ? (t = e.d2l(t), r = e.d2l(r), t < r) : !0;
            }
            function Qoe(e, t) {
                if (!t || !t.autorangeoptions) return e;
                var r = e[0], n = e[1], i = t.autorangeoptions.include;
                if (i !== void 0) {
                    var a = t.d2l(r), o = t.d2l(n);
                    s_.isArrayOrTypedArray(i) || (i = [
                        i
                    ]);
                    for(var s = 0; s < i.length; s++){
                        var l = t.d2l(i[s]);
                        a >= l && (a = l, r = l), o <= l && (o = l, n = l);
                    }
                }
                return r = not(r, t), n = aot(n, t), [
                    r,
                    n
                ];
            }
        });
        var Qa = ye((Arr, wse)=>{
            "use strict";
            var w0 = xa(), ph = uo(), P3 = Xu(), QS = ba(), Vo = Mr(), I3 = Vo.strTranslate, Eb = Pl(), oot = Mb(), eM = va(), Xp = ao(), sot = Cd(), tse = bO(), Yd = es(), lot = Yd.ONEMAXYEAR, mL = Yd.ONEAVGYEAR, yL = Yd.ONEMINYEAR, uot = Yd.ONEMAXQUARTER, tB = Yd.ONEAVGQUARTER, _L = Yd.ONEMINQUARTER, cot = Yd.ONEMAXMONTH, R3 = Yd.ONEAVGMONTH, xL = Yd.ONEMINMONTH, Yp = Yd.ONEWEEK, Fv = Yd.ONEDAY, l_ = Fv / 2, xm = Yd.ONEHOUR, tM = Yd.ONEMIN, bL = Yd.ONESEC, fot = Yd.ONEMILLI, hot = Yd.ONEMICROSEC, kb = Yd.MINUS_SIGN, AL = Yd.BADNUM, rB = {
                K: "zeroline"
            }, iB = {
                K: "gridline",
                L: "path"
            }, nB = {
                K: "minor-gridline",
                L: "path"
            }, hse = {
                K: "tick",
                L: "path"
            }, rse = {
                K: "tick",
                L: "text"
            }, ise = {
                width: [
                    "x",
                    "r",
                    "l",
                    "xl",
                    "xr"
                ],
                height: [
                    "y",
                    "t",
                    "b",
                    "yt",
                    "yb"
                ],
                right: [
                    "r",
                    "xr"
                ],
                left: [
                    "l",
                    "xl"
                ],
                top: [
                    "t",
                    "yt"
                ],
                bottom: [
                    "b",
                    "yb"
                ]
            }, SL = Nh(), $S = SL.MID_SHIFT, Cb = SL.CAP_SHIFT, rM = SL.LINE_SPACING, dot = SL.OPPOSITE_SIDE, wL = 3, kn = wse.exports = {};
            kn.setConvert = ym();
            var vot = L3(), Ay = af(), pot = Ay.idSort, got = Ay.isLinked;
            kn.id2name = Ay.id2name;
            kn.name2id = Ay.name2id;
            kn.cleanId = Ay.cleanId;
            kn.list = Ay.list;
            kn.listIds = Ay.listIds;
            kn.getFromId = Ay.getFromId;
            kn.getFromTrace = Ay.getFromTrace;
            var dse = wg();
            kn.getAutoRange = dse.getAutoRange;
            kn.findExtremes = dse.findExtremes;
            var mot = 1e-4;
            function lB(e) {
                var t = (e[1] - e[0]) * mot;
                return [
                    e[0] - t,
                    e[1] + t
                ];
            }
            kn.coerceRef = function(e, t, r, n, i, a) {
                var o = n.charAt(n.length - 1), s = r._fullLayout._subplots[o + "axis"], l = n + "ref", u = {};
                return i || (i = s[0] || (typeof a == "string" ? a : a[0])), a || (a = i), s = s.concat(s.map(function(c) {
                    return c + " domain";
                })), u[l] = {
                    valType: "enumerated",
                    values: s.concat(a ? typeof a == "string" ? [
                        a
                    ] : a : []),
                    dflt: i
                }, Vo.coerce(e, t, u, l);
            };
            kn.getRefType = function(e) {
                return e === void 0 ? e : e === "paper" ? "paper" : e === "pixel" ? "pixel" : /( domain)$/.test(e) ? "domain" : "range";
            };
            kn.coercePosition = function(e, t, r, n, i, a) {
                var o, s, l = kn.getRefType(n);
                if (l !== "range") o = Vo.ensureNumber, s = r(i, a);
                else {
                    var u = kn.getFromId(t, n);
                    a = u.fraction2r(a), s = r(i, a), o = u.cleanPos;
                }
                e[i] = o(s);
            };
            kn.cleanPosition = function(e, t, r) {
                var n = r === "paper" || r === "pixel" ? Vo.ensureNumber : kn.getFromId(t, r).cleanPos;
                return n(e);
            };
            kn.redrawComponents = function(e, t) {
                t = t || kn.listIds(e);
                var r = e._fullLayout;
                function n(i, a, o, s) {
                    for(var l = QS.getComponentMethod(i, a), u = {}, c = 0; c < t.length; c++)for(var f = r[kn.id2name(t[c])], h = f[o], d = 0; d < h.length; d++){
                        var v = h[d];
                        if (!u[v] && (l(e, v), u[v] = 1, s)) return;
                    }
                }
                n("annotations", "drawOne", "_annIndices"), n("shapes", "drawOne", "_shapeIndices"), n("images", "draw", "_imgIndices", !0), n("selections", "drawOne", "_selectionIndices");
            };
            var yot = kn.getDataConversions = function(e, t, r, n) {
                var i, a = r === "x" || r === "y" || r === "z" ? r : n;
                if (Vo.isArrayOrTypedArray(a)) {
                    if (i = {
                        type: vot(n, void 0, {
                            autotypenumbers: e._fullLayout.autotypenumbers
                        }),
                        _categories: []
                    }, kn.setConvert(i), i.type === "category") for(var o = 0; o < n.length; o++)i.d2c(n[o]);
                } else i = kn.getFromTrace(e, t, a);
                return i ? {
                    d2c: i.d2c,
                    c2d: i.c2d
                } : a === "ids" ? {
                    d2c: ase,
                    c2d: ase
                } : {
                    d2c: nse,
                    c2d: nse
                };
            };
            function nse(e) {
                return +e;
            }
            function ase(e) {
                return String(e);
            }
            kn.getDataToCoordFunc = function(e, t, r, n) {
                return yot(e, t, r, n).d2c;
            };
            kn.counterLetter = function(e) {
                var t = e.charAt(0);
                if (t === "x") return "y";
                if (t === "y") return "x";
            };
            kn.minDtick = function(e, t, r, n) {
                [
                    "log",
                    "category",
                    "multicategory"
                ].indexOf(e.type) !== -1 || !n ? e._minDtick = 0 : e._minDtick === void 0 ? (e._minDtick = t, e._forceTick0 = r) : e._minDtick && ((e._minDtick / t + 1e-6) % 1 < 2e-6 && ((r - e._forceTick0) / t % 1 + 1.000001) % 1 < 2e-6 ? (e._minDtick = t, e._forceTick0 = r) : ((t / e._minDtick + 1e-6) % 1 > 2e-6 || ((r - e._forceTick0) / e._minDtick % 1 + 1.000001) % 1 > 2e-6) && (e._minDtick = 0));
            };
            kn.saveRangeInitial = function(e, t) {
                for(var r = kn.list(e, "", !0), n = !1, i = 0; i < r.length; i++){
                    var a = r[i], o = a._rangeInitial0 === void 0 && a._rangeInitial1 === void 0, s = o || a.range[0] !== a._rangeInitial0 || a.range[1] !== a._rangeInitial1, l = a.autorange;
                    (o && l !== !0 || t && s) && (a._rangeInitial0 = l === "min" || l === "max reversed" ? void 0 : a.range[0], a._rangeInitial1 = l === "max" || l === "min reversed" ? void 0 : a.range[1], a._autorangeInitial = l, n = !0);
                }
                return n;
            };
            kn.saveShowSpikeInitial = function(e, t) {
                for(var r = kn.list(e, "", !0), n = !1, i = "on", a = 0; a < r.length; a++){
                    var o = r[a], s = o._showSpikeInitial === void 0, l = s || o.showspikes !== o._showspikes;
                    (s || t && l) && (o._showSpikeInitial = o.showspikes, n = !0), i === "on" && !o.showspikes && (i = "off");
                }
                return e._fullLayout._cartesianSpikesEnabled = i, n;
            };
            kn.autoBin = function(e, t, r, n, i, a) {
                var o = Vo.aggNums(Math.min, null, e), s = Vo.aggNums(Math.max, null, e);
                if (t.type === "category" || t.type === "multicategory") return {
                    start: o - .5,
                    end: s + .5,
                    size: Math.max(1, Math.round(a) || 1),
                    _dataSpan: s - o
                };
                i || (i = t.calendar);
                var l;
                if (t.type === "log" ? l = {
                    type: "linear",
                    range: [
                        o,
                        s
                    ]
                } : l = {
                    type: t.type,
                    range: Vo.simpleMap([
                        o,
                        s
                    ], t.c2r, 0, i),
                    calendar: i
                }, kn.setConvert(l), a = a && tse.dtick(a, l.type), a) l.dtick = a, l.tick0 = tse.tick0(void 0, l.type, i);
                else {
                    var u;
                    if (r) u = (s - o) / r;
                    else {
                        var c = Vo.distinctVals(e), f = Math.pow(10, Math.floor(Math.log(c.minDiff) / Math.LN10)), h = f * Vo.roundUp(c.minDiff / f, [
                            .9,
                            1.9,
                            4.9,
                            9.9
                        ], !0);
                        u = Math.max(h, 2 * Vo.stdev(e) / Math.pow(e.length, n ? .25 : .4)), ph(u) || (u = 1);
                    }
                    kn.autoTicks(l, u);
                }
                var d = l.dtick, v = kn.tickIncrement(kn.tickFirst(l), d, "reverse", i), x, b;
                if (typeof d == "number") v = _ot(v, e, l, o, s), b = 1 + Math.floor((s - v) / d), x = v + b * d;
                else for(l.dtick.charAt(0) === "M" && (v = xot(v, e, d, o, i)), x = v, b = 0; x <= s;)x = kn.tickIncrement(x, d, !1, i), b++;
                return {
                    start: t.c2r(v, 0, i),
                    end: t.c2r(x, 0, i),
                    size: d,
                    _dataSpan: s - o
                };
            };
            function _ot(e, t, r, n, i) {
                var a = 0, o = 0, s = 0, l = 0;
                function u(d) {
                    return (1 + (d - e) * 100 / r.dtick) % 100 < 2;
                }
                for(var c = 0; c < t.length; c++)t[c] % 1 === 0 ? s++ : ph(t[c]) || l++, u(t[c]) && a++, u(t[c] + r.dtick / 2) && o++;
                var f = t.length - l;
                if (s === f && r.type !== "date") r.dtick < 1 ? e = n - .5 * r.dtick : (e -= .5, e + r.dtick < n && (e += r.dtick));
                else if (o < f * .1 && (a > f * .3 || u(n) || u(i))) {
                    var h = r.dtick / 2;
                    e += e + h < n ? h : -h;
                }
                return e;
            }
            function xot(e, t, r, n, i) {
                var a = Vo.findExactDates(t, i), o = .8;
                if (a.exactDays > o) {
                    var s = Number(r.substr(1));
                    a.exactYears > o && s % 12 === 0 ? e = kn.tickIncrement(e, "M6", "reverse") + Fv * 1.5 : a.exactMonths > o ? e = kn.tickIncrement(e, "M1", "reverse") + Fv * 15.5 : e -= l_;
                    var l = kn.tickIncrement(e, r);
                    if (l <= n) return l;
                }
                return e;
            }
            kn.prepMinorTicks = function(e, t, r) {
                if (!t.minor.dtick) {
                    delete e.dtick;
                    var n = t.dtick && ph(t._tmin), i;
                    if (n) {
                        var a = kn.tickIncrement(t._tmin, t.dtick, !0);
                        i = [
                            t._tmin,
                            a * .99 + t._tmin * .01
                        ];
                    } else {
                        var o = Vo.simpleMap(t.range, t.r2l);
                        i = [
                            o[0],
                            .8 * o[0] + .2 * o[1]
                        ];
                    }
                    if (e.range = Vo.simpleMap(i, t.l2r), e._isMinor = !0, kn.prepTicks(e, r), n) {
                        var s = ph(t.dtick), l = ph(e.dtick), u = s ? t.dtick : +t.dtick.substring(1), c = l ? e.dtick : +e.dtick.substring(1);
                        s && l ? $O(u, c) ? u === 2 * Yp && c === 2 * Fv && (e.dtick = Yp) : u === 2 * Yp && c === 3 * Fv ? e.dtick = Yp : u === Yp && !(t._input.minor || {}).nticks ? e.dtick = Fv : ose(u / c, 2.5) ? e.dtick = u / 2 : e.dtick = u : String(t.dtick).charAt(0) === "M" ? l ? e.dtick = "M1" : $O(u, c) ? u >= 12 && c === 2 && (e.dtick = "M3") : e.dtick = t.dtick : String(e.dtick).charAt(0) === "L" ? String(t.dtick).charAt(0) === "L" ? $O(u, c) || (e.dtick = ose(u / c, 2.5) ? t.dtick / 2 : t.dtick) : e.dtick = "D1" : e.dtick === "D2" && +t.dtick > 1 && (e.dtick = 1);
                    }
                    e.range = t.range;
                }
                t.minor._tick0Init === void 0 && (e.tick0 = t.tick0);
            };
            function $O(e, t) {
                return Math.abs((e / t + .5) % 1 - .5) < .001;
            }
            function ose(e, t) {
                return Math.abs(e / t - 1) < .001;
            }
            kn.prepTicks = function(e, t) {
                var r = Vo.simpleMap(e.range, e.r2l, void 0, void 0, t);
                if (e.tickmode === "auto" || !e.dtick) {
                    var n = e.nticks, i;
                    n || (e.type === "category" || e.type === "multicategory" ? (i = e.tickfont ? Vo.bigFont(e.tickfont.size || 12) : 15, n = e._length / i) : (i = e._id.charAt(0) === "y" ? 40 : 80, n = Vo.constrain(e._length / i, 4, 9) + 1), e._name === "radialaxis" && (n *= 2)), e.minor && e.minor.tickmode !== "array" || e.tickmode === "array" && (n *= 100), e._roughDTick = Math.abs(r[1] - r[0]) / n, kn.autoTicks(e, e._roughDTick), e._minDtick > 0 && e.dtick < e._minDtick * 2 && (e.dtick = e._minDtick, e.tick0 = e.l2r(e._forceTick0));
                }
                e.ticklabelmode === "period" && bot(e), e.tick0 || (e.tick0 = e.type === "date" ? "2000-01-01" : 0), e.type === "date" && e.dtick < .1 && (e.dtick = .1), mse(e);
            };
            function QO(e) {
                return +e.substring(1);
            }
            function bot(e) {
                var t;
                function r() {
                    return !(ph(e.dtick) || e.dtick.charAt(0) !== "M");
                }
                var n = r(), i = kn.getTickFormat(e);
                if (i) {
                    var a = e._dtickInit !== e.dtick;
                    /%[fLQsSMX]/.test(i) || (/%[HI]/.test(i) ? (t = xm, a && !n && e.dtick < xm && (e.dtick = xm)) : /%p/.test(i) ? (t = l_, a && !n && e.dtick < l_ && (e.dtick = l_)) : /%[Aadejuwx]/.test(i) ? (t = Fv, a && !n && e.dtick < Fv && (e.dtick = Fv)) : /%[UVW]/.test(i) ? (t = Yp, a && !n && e.dtick < Yp && (e.dtick = Yp)) : /%[Bbm]/.test(i) ? (t = R3, a && (n ? QO(e.dtick) < 1 : e.dtick < xL) && (e.dtick = "M1")) : /%[q]/.test(i) ? (t = tB, a && (n ? QO(e.dtick) < 3 : e.dtick < _L) && (e.dtick = "M3")) : /%[Yy]/.test(i) && (t = mL, a && (n ? QO(e.dtick) < 12 : e.dtick < yL) && (e.dtick = "M12")));
                }
                n = r(), n && e.tick0 === e._dowTick0 && (e.tick0 = e._rawTick0), e._definedDelta = t;
            }
            function wot(e, t, r) {
                for(var n = 0; n < e.length; n++){
                    var i = e[n].value, a = n, o = n + 1;
                    n < e.length - 1 ? (a = n, o = n + 1) : n > 0 ? (a = n - 1, o = n) : (a = n, o = n);
                    var s = e[a].value, l = e[o].value, u = Math.abs(l - s), c = r || u, f = 0;
                    c >= yL ? u >= yL && u <= lot ? f = u : f = mL : r === tB && c >= _L ? u >= _L && u <= uot ? f = u : f = tB : c >= xL ? u >= xL && u <= cot ? f = u : f = R3 : r === Yp && c >= Yp ? f = Yp : c >= Fv ? f = Fv : r === l_ && c >= l_ ? f = l_ : r === xm && c >= xm && (f = xm);
                    var h;
                    f >= u && (f = u, h = !0);
                    var d = i + f;
                    if (t.rangebreaks && f > 0) {
                        for(var v = 84, x = 0, b = 0; b < v; b++){
                            var p = (b + .5) / v;
                            t.maskBreaks(i * (1 - p) + p * d) !== AL && x++;
                        }
                        f *= x / v, f || (e[n].drop = !0), h && u > Yp && (f = u);
                    }
                    (f > 0 || n === 0) && (e[n].periodX = i + f / 2);
                }
            }
            kn.calcTicks = function(t, r) {
                for(var n = t.type, i = t.calendar, a = t.ticklabelstep, o = t.ticklabelmode === "period", s = t.range[0] > t.range[1], l = !t.ticklabelindex || Vo.isArrayOrTypedArray(t.ticklabelindex) ? t.ticklabelindex : [
                    t.ticklabelindex
                ], u = Vo.simpleMap(t.range, t.r2l, void 0, void 0, r), c = u[1] < u[0], f = Math.min(u[0], u[1]), h = Math.max(u[0], u[1]), d = Math.max(1e3, t._length || 0), v = [], x = [], b = [], p = [], E = [], k = t.minor && (t.minor.ticks || t.minor.showgrid), A = 1; A >= (k ? 0 : 1); A--){
                    var L = !A;
                    A ? (t._dtickInit = t.dtick, t._tick0Init = t.tick0) : (t.minor._dtickInit = t.minor.dtick, t.minor._tick0Init = t.minor.tick0);
                    var _ = A ? t : Vo.extendFlat({}, t, t.minor);
                    if (L ? kn.prepMinorTicks(_, t, r) : kn.prepTicks(_, r), _.tickmode === "array") {
                        A ? (b = [], v = sse(t, !L)) : (p = [], x = sse(t, !L));
                        continue;
                    }
                    if (_.tickmode === "sync") {
                        b = [], v = Tot(t);
                        continue;
                    }
                    var C = lB(u), M = C[0], g = C[1], P = ph(_.dtick), T = n === "log" && !(P || _.dtick.charAt(0) === "L"), F = kn.tickFirst(_, r);
                    if (A) {
                        if (t._tmin = F, F < M !== c) break;
                        (n === "category" || n === "multicategory") && (g = c ? Math.max(-0.5, g) : Math.min(t._categories.length - .5, g));
                    }
                    var q = null, V = F, H;
                    if (A) {
                        var X;
                        P ? X = t.dtick : n === "date" ? typeof t.dtick == "string" && t.dtick.charAt(0) === "M" && (X = R3 * t.dtick.substring(1)) : X = t._roughDTick, H = Math.round((t.r2l(V) - t.r2l(t.tick0)) / X) - 1;
                    }
                    var G = _.dtick;
                    for(_.rangebreaks && _._tick0Init !== _.tick0 && (V = eB(V, t), c || (V = kn.tickIncrement(V, G, !c, i))), A && o && (V = kn.tickIncrement(V, G, !c, i), H--); c ? V >= g : V <= g; V = kn.tickIncrement(V, G, c, i)){
                        if (A && H++, _.rangebreaks && !c) {
                            if (V < M) continue;
                            if (_.maskBreaks(V) === AL && eB(V, _) >= h) break;
                        }
                        if (b.length > d || V === q) break;
                        q = V;
                        var N = {
                            value: V
                        };
                        A ? (T && V !== (V | 0) && (N.simpleLabel = !0), a > 1 && H % a && (N.skipLabel = !0), b.push(N)) : (N.minor = !0, p.push(N));
                    }
                }
                if (!p || p.length < 2) l = !1;
                else {
                    var W = (p[1].value - p[0].value) * (s ? -1 : 1);
                    Zot(W, t.tickformat) || (l = !1);
                }
                if (!l) E = b;
                else {
                    var re = b.concat(p);
                    o && b.length && (re = re.slice(1)), re = re.sort(function(Rt, kt) {
                        return Rt.value - kt.value;
                    }).filter(function(Rt, kt, Ct) {
                        return kt === 0 || Rt.value !== Ct[kt - 1].value;
                    });
                    var ae = re.map(function(Rt, kt) {
                        return Rt.minor === void 0 && !Rt.skipLabel ? kt : null;
                    }).filter(function(Rt) {
                        return Rt !== null;
                    });
                    ae.forEach(function(Rt) {
                        l.map(function(kt) {
                            var Ct = Rt + kt;
                            Ct >= 0 && Ct < re.length && Vo.pushUnique(E, re[Ct]);
                        });
                    });
                }
                if (k) {
                    var _e = t.minor.ticks === "inside" && t.ticks === "outside" || t.minor.ticks === "outside" && t.ticks === "inside";
                    if (!_e) {
                        for(var Me = b.map(function(Rt) {
                            return Rt.value;
                        }), ke = [], ge = 0; ge < p.length; ge++){
                            var ie = p[ge], Te = ie.value;
                            if (Me.indexOf(Te) === -1) {
                                for(var Ee = !1, Ae = 0; !Ee && Ae < b.length; Ae++)1e7 + b[Ae].value === 1e7 + Te && (Ee = !0);
                                Ee || ke.push(ie);
                            }
                        }
                        p = ke;
                    }
                }
                o && wot(E, t, t._definedDelta);
                var ze;
                if (t.rangebreaks) {
                    var Ce = t._id.charAt(0) === "y", me = 1;
                    t.tickmode === "auto" && (me = t.tickfont ? t.tickfont.size : 12);
                    var Re = NaN;
                    for(ze = b.length - 1; ze > -1; ze--){
                        if (b[ze].drop) {
                            b.splice(ze, 1);
                            continue;
                        }
                        b[ze].value = eB(b[ze].value, t);
                        var ce = t.c2p(b[ze].value);
                        (Ce ? Re > ce - me : Re < ce + me) ? b.splice(c ? ze + 1 : ze, 1) : Re = ce;
                    }
                }
                fB(t) && Math.abs(u[1] - u[0]) === 360 && b.pop(), t._tmax = (b[b.length - 1] || {}).value, t._prevDateHead = "", t._inCalcTicks = !0;
                var Ge, nt = function(Rt) {
                    Rt.text = "", t._prevDateHead = Ge;
                };
                b = b.concat(p);
                function ct(Rt, kt) {
                    var Ct = kn.tickText(Rt, kt.value, !1, kt.simpleLabel), Yt = kt.periodX;
                    return Yt !== void 0 && (Ct.periodX = Yt, (Yt > h || Yt < f) && (Yt > h && (Ct.periodX = h), Yt < f && (Ct.periodX = f), nt(Ct))), Ct;
                }
                var qt;
                for(ze = 0; ze < b.length; ze++){
                    var rt = b[ze].minor, ot = b[ze].value;
                    rt ? (l && E.indexOf(b[ze]) !== -1 ? qt = ct(t, b[ze]) : qt = {
                        x: ot
                    }, qt.minor = !0, x.push(qt)) : (Ge = t._prevDateHead, qt = ct(t, b[ze]), (b[ze].skipLabel || l && E.indexOf(b[ze]) === -1) && nt(qt), v.push(qt));
                }
                return v = v.concat(x), t._inCalcTicks = !1, o && v.length && (v[0].noTick = !0), v;
            };
            function vse(e, t) {
                return e.rangebreaks && (t = t.filter(function(r) {
                    return e.maskBreaks(r.x) !== AL;
                })), t;
            }
            function Tot(e) {
                var t = e._mainAxis, r = [];
                if (t._vals) {
                    for(var n = 0; n < t._vals.length; n++)if (!t._vals[n].noTick) {
                        var i = t.l2p(t._vals[n].x), a = e.p2l(i), o = kn.tickText(e, a);
                        t._vals[n].minor && (o.minor = !0, o.text = ""), r.push(o);
                    }
                }
                return r = vse(e, r), r;
            }
            function sse(e, t) {
                var r = Vo.simpleMap(e.range, e.r2l), n = lB(r), i = Math.min(n[0], n[1]), a = Math.max(n[0], n[1]), o = e.type === "category" ? e.d2l_noadd : e.d2l;
                e.type === "log" && String(e.dtick).charAt(0) !== "L" && (e.dtick = "L" + Math.pow(10, Math.floor(Math.min(e.range[0], e.range[1])) - 1));
                for(var s = [], l = 0; l <= 1; l++)if (!(t !== void 0 && (t && l || t === !1 && !l)) && !(l && !e.minor)) {
                    var u = l ? e.minor.tickvals : e.tickvals, c = l ? [] : e.ticktext;
                    if (u) {
                        Vo.isArrayOrTypedArray(c) || (c = []);
                        for(var f = 0; f < u.length; f++){
                            var h = o(u[f]);
                            if (h > i && h < a) {
                                var d = kn.tickText(e, h, !1, String(c[f]));
                                l && (d.minor = !0, d.text = ""), s.push(d);
                            }
                        }
                    }
                }
                return s = vse(e, s), s;
            }
            var pL = [
                2,
                5,
                10
            ], lse = [
                1,
                2,
                3,
                6,
                12
            ], use = [
                1,
                2,
                5,
                10,
                15,
                30
            ], Aot = [
                1,
                2,
                3,
                7,
                14
            ], pse = [
                -0.046,
                0,
                .301,
                .477,
                .602,
                .699,
                .778,
                .845,
                .903,
                .954,
                1
            ], gse = [
                -0.301,
                0,
                .301,
                .699,
                1
            ], Sot = [
                15,
                30,
                45,
                90,
                180
            ];
            function _m(e, t, r) {
                return t * Vo.roundUp(e / t, r);
            }
            kn.autoTicks = function(e, t, r) {
                var n;
                function i(f) {
                    return Math.pow(f, Math.floor(Math.log(t) / Math.LN10));
                }
                if (e.type === "date") {
                    e.tick0 = Vo.dateTick0(e.calendar, 0);
                    var a = 2 * t;
                    if (a > mL) t /= mL, n = i(10), e.dtick = "M" + 12 * _m(t, n, pL);
                    else if (a > R3) t /= R3, e.dtick = "M" + _m(t, 1, lse);
                    else if (a > Fv) {
                        if (e.dtick = _m(t, Fv, e._hasDayOfWeekBreaks ? [
                            1,
                            2,
                            7,
                            14
                        ] : Aot), !r) {
                            var o = kn.getTickFormat(e), s = e.ticklabelmode === "period";
                            s && (e._rawTick0 = e.tick0), /%[uVW]/.test(o) ? e.tick0 = Vo.dateTick0(e.calendar, 2) : e.tick0 = Vo.dateTick0(e.calendar, 1), s && (e._dowTick0 = e.tick0);
                        }
                    } else a > xm ? e.dtick = _m(t, xm, lse) : a > tM ? e.dtick = _m(t, tM, use) : a > bL ? e.dtick = _m(t, bL, use) : (n = i(10), e.dtick = _m(t, n, pL));
                } else if (e.type === "log") {
                    e.tick0 = 0;
                    var l = Vo.simpleMap(e.range, e.r2l);
                    if (e._isMinor && (t *= 1.5), t > .7) e.dtick = Math.ceil(t);
                    else if (Math.abs(l[1] - l[0]) < 1) {
                        var u = 1.5 * Math.abs((l[1] - l[0]) / t);
                        t = Math.abs(Math.pow(10, l[1]) - Math.pow(10, l[0])) / u, n = i(10), e.dtick = "L" + _m(t, n, pL);
                    } else e.dtick = t > .3 ? "D2" : "D1";
                } else e.type === "category" || e.type === "multicategory" ? (e.tick0 = 0, e.dtick = Math.ceil(Math.max(t, 1))) : fB(e) ? (e.tick0 = 0, n = 1, e.dtick = _m(t, n, Sot)) : (e.tick0 = 0, n = i(10), e.dtick = _m(t, n, pL));
                if (e.dtick === 0 && (e.dtick = 1), !ph(e.dtick) && typeof e.dtick != "string") {
                    var c = e.dtick;
                    throw e.dtick = 1, "ax.dtick error: " + String(c);
                }
            };
            function mse(e) {
                var t = e.dtick;
                if (e._tickexponent = 0, !ph(t) && typeof t != "string" && (t = 1), (e.type === "category" || e.type === "multicategory") && (e._tickround = null), e.type === "date") {
                    var r = e.r2l(e.tick0), n = e.l2r(r).replace(/(^-|i)/g, ""), i = n.length;
                    if (String(t).charAt(0) === "M") i > 10 || n.substr(5) !== "01-01" ? e._tickround = "d" : e._tickround = +t.substr(1) % 12 === 0 ? "y" : "m";
                    else if (t >= Fv && i <= 10 || t >= Fv * 15) e._tickround = "d";
                    else if (t >= tM && i <= 16 || t >= xm) e._tickround = "M";
                    else if (t >= bL && i <= 19 || t >= tM) e._tickround = "S";
                    else {
                        var a = e.l2r(r + t).replace(/^-/, "").length;
                        e._tickround = Math.max(i, a) - 20, e._tickround < 0 && (e._tickround = 4);
                    }
                } else if (ph(t) || t.charAt(0) === "L") {
                    var o = e.range.map(e.r2d || Number);
                    ph(t) || (t = Number(t.substr(1))), e._tickround = 2 - Math.floor(Math.log(t) / Math.LN10 + .01);
                    var s = Math.max(Math.abs(o[0]), Math.abs(o[1])), l = Math.floor(Math.log(s) / Math.LN10 + .01), u = e.minexponent === void 0 ? 3 : e.minexponent;
                    Math.abs(l) > u && (TL(e.exponentformat) && !uB(l) ? e._tickexponent = 3 * Math.round((l - 1) / 3) : e._tickexponent = l);
                } else e._tickround = null;
            }
            kn.tickIncrement = function(e, t, r, n) {
                var i = r ? -1 : 1;
                if (ph(t)) return Vo.increment(e, i * t);
                var a = t.charAt(0), o = i * Number(t.substr(1));
                if (a === "M") return Vo.incrementMonth(e, o, n);
                if (a === "L") return Math.log(Math.pow(10, e) + o) / Math.LN10;
                if (a === "D") {
                    var s = t === "D2" ? gse : pse, l = e + i * .01, u = Vo.roundUp(Vo.mod(l, 1), s, r);
                    return Math.floor(l) + Math.log(w0.round(Math.pow(10, u), 1)) / Math.LN10;
                }
                throw "unrecognized dtick " + String(t);
            };
            kn.tickFirst = function(e, t) {
                var r = e.r2l || Number, n = Vo.simpleMap(e.range, r, void 0, void 0, t), i = n[1] < n[0], a = i ? Math.floor : Math.ceil, o = lB(n)[0], s = e.dtick, l = r(e.tick0);
                if (ph(s)) {
                    var u = a((o - l) / s) * s + l;
                    return (e.type === "category" || e.type === "multicategory") && (u = Vo.constrain(u, 0, e._categories.length - 1)), u;
                }
                var c = s.charAt(0), f = Number(s.substr(1));
                if (c === "M") {
                    for(var h = 0, d = l, v, x, b; h < 10;){
                        if (v = kn.tickIncrement(d, s, i, e.calendar), (v - o) * (d - o) <= 0) return i ? Math.min(d, v) : Math.max(d, v);
                        x = (o - (d + v) / 2) / (v - d), b = c + (Math.abs(Math.round(x)) || 1) * f, d = kn.tickIncrement(d, b, x < 0 ? !i : i, e.calendar), h++;
                    }
                    return Vo.error("tickFirst did not converge", e), d;
                } else {
                    if (c === "L") return Math.log(a((Math.pow(10, o) - l) / f) * f + l) / Math.LN10;
                    if (c === "D") {
                        var p = s === "D2" ? gse : pse, E = Vo.roundUp(Vo.mod(o, 1), p, i);
                        return Math.floor(o) + Math.log(w0.round(Math.pow(10, E), 1)) / Math.LN10;
                    } else throw "unrecognized dtick " + String(s);
                }
            };
            kn.tickText = function(e, t, r, n) {
                var i = yse(e, t), a = e.tickmode === "array", o = r || a, s = e.type, l = s === "category" ? e.d2l_noadd : e.d2l, u, c = function(b) {
                    var p = e.l2p(b);
                    return p >= 0 && p <= e._length ? b : null;
                };
                if (a && Vo.isArrayOrTypedArray(e.ticktext)) {
                    var f = Vo.simpleMap(e.range, e.r2l), h = (Math.abs(f[1] - f[0]) - (e._lBreaks || 0)) / 1e4;
                    for(u = 0; u < e.ticktext.length && !(Math.abs(t - l(e.tickvals[u])) < h); u++);
                    if (u < e.ticktext.length) return i.text = String(e.ticktext[u]), i.xbnd = [
                        c(i.x - .5),
                        c(i.x + e.dtick - .5)
                    ], i;
                }
                function d(b) {
                    if (b === void 0) return !0;
                    if (r) return b === "none";
                    var p = {
                        first: e._tmin,
                        last: e._tmax
                    }[b];
                    return b !== "all" && t !== p;
                }
                var v = r ? "never" : e.exponentformat !== "none" && d(e.showexponent) ? "hide" : "";
                if (s === "date" ? Mot(e, i, r, o) : s === "log" ? Eot(e, i, r, o, v) : s === "category" ? kot(e, i) : s === "multicategory" ? Cot(e, i, r) : fB(e) ? Pot(e, i, r, o, v) : Lot(e, i, r, o, v), n || (e.tickprefix && !d(e.showtickprefix) && (i.text = e.tickprefix + i.text), e.ticksuffix && !d(e.showticksuffix) && (i.text += e.ticksuffix)), e.labelalias && e.labelalias.hasOwnProperty(i.text)) {
                    var x = e.labelalias[i.text];
                    typeof x == "string" && (i.text = x);
                }
                return (e.tickson === "boundaries" || e.showdividers) && (i.xbnd = [
                    c(i.x - .5),
                    c(i.x + e.dtick - .5)
                ]), i;
            };
            kn.hoverLabelText = function(e, t, r) {
                r && (e = Vo.extendFlat({}, e, {
                    hoverformat: r
                }));
                var n = Vo.isArrayOrTypedArray(t) ? t[0] : t, i = Vo.isArrayOrTypedArray(t) ? t[1] : void 0;
                if (i !== void 0 && i !== n) return kn.hoverLabelText(e, n, r) + " - " + kn.hoverLabelText(e, i, r);
                var a = e.type === "log" && n <= 0, o = kn.tickText(e, e.c2l(a ? -n : n), "hover").text;
                return a ? n === 0 ? "0" : kb + o : o;
            };
            function yse(e, t, r) {
                var n = e.tickfont || {};
                return {
                    x: t,
                    dx: 0,
                    dy: 0,
                    text: r || "",
                    fontSize: n.size,
                    font: n.family,
                    fontWeight: n.weight,
                    fontStyle: n.style,
                    fontVariant: n.variant,
                    fontTextcase: n.textcase,
                    fontLineposition: n.lineposition,
                    fontShadow: n.shadow,
                    fontColor: n.color
                };
            }
            function Mot(e, t, r, n) {
                var i = e._tickround, a = r && e.hoverformat || kn.getTickFormat(e);
                n = !a && n, n && (ph(i) ? i = 4 : i = ({
                    y: "m",
                    m: "d",
                    d: "M",
                    M: "S",
                    S: 4
                })[i]);
                var o = Vo.formatDate(t.x, a, i, e._dateFormat, e.calendar, e._extraFormat), s, l = o.indexOf(`
`);
                if (l !== -1 && (s = o.substr(l + 1), o = o.substr(0, l)), n && (s !== void 0 && (o === "00:00:00" || o === "00:00") ? (o = s, s = "") : o.length === 8 && (o = o.replace(/:00$/, ""))), s) {
                    if (r) i === "d" ? o += ", " + s : o = s + (o ? ", " + o : "");
                    else if (!e._inCalcTicks || e._prevDateHead !== s) e._prevDateHead = s, o += "<br>" + s;
                    else {
                        var u = nM(e), c = e._trueSide || e.side;
                        (!u && c === "top" || u && c === "bottom") && (o += "<br> ");
                    }
                }
                t.text = o;
            }
            function Eot(e, t, r, n, i) {
                var a = e.dtick, o = t.x, s = e.tickformat, l = typeof a == "string" && a.charAt(0);
                if (i === "never" && (i = ""), n && l !== "L" && (a = "L3", l = "L"), s || l === "L") t.text = iM(Math.pow(10, o), e, i, n);
                else if (ph(a) || l === "D" && Vo.mod(o + .01, 1) < .1) {
                    var u = Math.round(o), c = Math.abs(u), f = e.exponentformat;
                    f === "power" || TL(f) && uB(u) ? (u === 0 ? t.text = 1 : u === 1 ? t.text = "10" : t.text = "10<sup>" + (u > 1 ? "" : kb) + c + "</sup>", t.fontSize *= 1.25) : (f === "e" || f === "E") && c > 2 ? t.text = "1" + f + (u > 0 ? "+" : kb) + c : (t.text = iM(Math.pow(10, o), e, "", "fakehover"), a === "D1" && e._id.charAt(0) === "y" && (t.dy -= t.fontSize / 6));
                } else if (l === "D") t.text = String(Math.round(Math.pow(10, Vo.mod(o, 1)))), t.fontSize *= .75;
                else throw "unrecognized dtick " + String(a);
                if (e.dtick === "D1") {
                    var h = String(t.text).charAt(0);
                    (h === "0" || h === "1") && (e._id.charAt(0) === "y" ? t.dx -= t.fontSize / 4 : (t.dy += t.fontSize / 2, t.dx += (e.range[1] > e.range[0] ? 1 : -1) * t.fontSize * (o < 0 ? .5 : .25)));
                }
            }
            function kot(e, t) {
                var r = e._categories[Math.round(t.x)];
                r === void 0 && (r = ""), t.text = String(r);
            }
            function Cot(e, t, r) {
                var n = Math.round(t.x), i = e._categories[n] || [], a = i[1] === void 0 ? "" : String(i[1]), o = i[0] === void 0 ? "" : String(i[0]);
                r ? t.text = o + " - " + a : (t.text = a, t.text2 = o);
            }
            function Lot(e, t, r, n, i) {
                i === "never" ? i = "" : e.showexponent === "all" && Math.abs(t.x / e.dtick) < 1e-6 && (i = "hide"), t.text = iM(t.x, e, i, n);
            }
            function Pot(e, t, r, n, i) {
                if (e.thetaunit === "radians" && !r) {
                    var a = t.x / 180;
                    if (a === 0) t.text = "0";
                    else {
                        var o = Iot(a);
                        if (o[1] >= 100) t.text = iM(Vo.deg2rad(t.x), e, i, n);
                        else {
                            var s = t.x < 0;
                            o[1] === 1 ? o[0] === 1 ? t.text = "\u03C0" : t.text = o[0] + "\u03C0" : t.text = [
                                "<sup>",
                                o[0],
                                "</sup>",
                                "\u2044",
                                "<sub>",
                                o[1],
                                "</sub>",
                                "\u03C0"
                            ].join(""), s && (t.text = kb + t.text);
                        }
                    }
                } else t.text = iM(t.x, e, i, n);
            }
            function Iot(e) {
                function t(s, l) {
                    return Math.abs(s - l) <= 1e-6;
                }
                function r(s, l) {
                    return t(l, 0) ? s : r(l, s % l);
                }
                function n(s) {
                    for(var l = 1; !t(Math.round(s * l) / l, s);)l *= 10;
                    return l;
                }
                var i = n(e), a = e * i, o = Math.abs(r(a, i));
                return [
                    Math.round(a / o),
                    Math.round(i / o)
                ];
            }
            var Rot = [
                "f",
                "p",
                "n",
                "\u03BC",
                "m",
                "",
                "k",
                "M",
                "G",
                "T"
            ];
            function TL(e) {
                return e === "SI" || e === "B";
            }
            function uB(e) {
                return e > 14 || e < -15;
            }
            function iM(e, t, r, n) {
                var i = e < 0, a = t._tickround, o = r || t.exponentformat || "B", s = t._tickexponent, l = kn.getTickFormat(t), u = t.separatethousands;
                if (n) {
                    var c = {
                        exponentformat: o,
                        minexponent: t.minexponent,
                        dtick: t.showexponent === "none" ? t.dtick : ph(e) && Math.abs(e) || 1,
                        range: t.showexponent === "none" ? t.range.map(t.r2d) : [
                            0,
                            e || 1
                        ]
                    };
                    mse(c), a = (Number(c._tickround) || 0) + 4, s = c._tickexponent, t.hoverformat && (l = t.hoverformat);
                }
                if (l) return t._numFormat(l)(e).replace(/-/g, kb);
                var f = Math.pow(10, -a) / 2;
                if (o === "none" && (s = 0), e = Math.abs(e), e < f) e = "0", i = !1;
                else {
                    if (e += f, s && (e *= Math.pow(10, -s), a += s), a === 0) e = String(Math.floor(e));
                    else if (a < 0) {
                        e = String(Math.round(e)), e = e.substr(0, e.length + a);
                        for(var h = a; h < 0; h++)e += "0";
                    } else {
                        e = String(e);
                        var d = e.indexOf(".") + 1;
                        d && (e = e.substr(0, d + a).replace(/\.?0+$/, ""));
                    }
                    e = Vo.numSeparate(e, t._separators, u);
                }
                if (s && o !== "hide") {
                    TL(o) && uB(s) && (o = "power");
                    var v;
                    s < 0 ? v = kb + -s : o !== "power" ? v = "+" + s : v = String(s), o === "e" || o === "E" ? e += o + v : o === "power" ? e += "\xD710<sup>" + v + "</sup>" : o === "B" && s === 9 ? e += "B" : TL(o) && (e += Rot[s / 3 + 5]);
                }
                return i ? kb + e : e;
            }
            kn.getTickFormat = function(e) {
                var t;
                function r(l) {
                    return typeof l != "string" ? l : Number(l.replace("M", "")) * R3;
                }
                function n(l, u) {
                    var c = [
                        "L",
                        "D"
                    ];
                    if (typeof l == typeof u) {
                        if (typeof l == "number") return l - u;
                        var f = c.indexOf(l.charAt(0)), h = c.indexOf(u.charAt(0));
                        return f === h ? Number(l.replace(/(L|D)/g, "")) - Number(u.replace(/(L|D)/g, "")) : f - h;
                    } else return typeof l == "number" ? 1 : -1;
                }
                function i(l, u, c) {
                    var f = c || function(v) {
                        return v;
                    }, h = u[0], d = u[1];
                    return (!h && typeof h != "number" || f(h) <= f(l)) && (!d && typeof d != "number" || f(d) >= f(l));
                }
                function a(l, u) {
                    var c = u[0] === null, f = u[1] === null, h = n(l, u[0]) >= 0, d = n(l, u[1]) <= 0;
                    return (c || h) && (f || d);
                }
                var o, s;
                if (e.tickformatstops && e.tickformatstops.length > 0) switch(e.type){
                    case "date":
                    case "linear":
                        for(t = 0; t < e.tickformatstops.length; t++)if (s = e.tickformatstops[t], s.enabled && i(e.dtick, s.dtickrange, r)) {
                            o = s;
                            break;
                        }
                        break;
                    case "log":
                        for(t = 0; t < e.tickformatstops.length; t++)if (s = e.tickformatstops[t], s.enabled && a(e.dtick, s.dtickrange)) {
                            o = s;
                            break;
                        }
                        break;
                    default:
                }
                return o ? o.value : e.tickformat;
            };
            kn.getSubplots = function(e, t) {
                var r = e._fullLayout._subplots, n = r.cartesian.concat(r.gl2d || []), i = t ? kn.findSubplotsWithAxis(n, t) : n;
                return i.sort(function(a, o) {
                    var s = a.substr(1).split("y"), l = o.substr(1).split("y");
                    return s[0] === l[0] ? +s[1] - +l[1] : +s[0] - +l[0];
                }), i;
            };
            kn.findSubplotsWithAxis = function(e, t) {
                for(var r = new RegExp(t._id.charAt(0) === "x" ? "^" + t._id + "y" : t._id + "$"), n = [], i = 0; i < e.length; i++){
                    var a = e[i];
                    r.test(a) && n.push(a);
                }
                return n;
            };
            kn.makeClipPaths = function(e) {
                var t = e._fullLayout;
                if (!t._hasOnlyLargeSploms) {
                    var r = {
                        _offset: 0,
                        _length: t.width,
                        _id: ""
                    }, n = {
                        _offset: 0,
                        _length: t.height,
                        _id: ""
                    }, i = kn.list(e, "x", !0), a = kn.list(e, "y", !0), o = [], s, l;
                    for(s = 0; s < i.length; s++)for(o.push({
                        x: i[s],
                        y: n
                    }), l = 0; l < a.length; l++)s === 0 && o.push({
                        x: r,
                        y: a[l]
                    }), o.push({
                        x: i[s],
                        y: a[l]
                    });
                    var u = t._clips.selectAll(".axesclip").data(o, function(c) {
                        return c.x._id + c.y._id;
                    });
                    u.enter().append("clipPath").classed("axesclip", !0).attr("id", function(c) {
                        return "clip" + t._uid + c.x._id + c.y._id;
                    }).append("rect"), u.exit().remove(), u.each(function(c) {
                        w0.select(this).select("rect").attr({
                            x: c.x._offset || 0,
                            y: c.y._offset || 0,
                            width: c.x._length || 1,
                            height: c.y._length || 1
                        });
                    });
                }
            };
            kn.draw = function(e, t, r) {
                var n = e._fullLayout;
                t === "redraw" && n._paper.selectAll("g.subplot").each(function(l) {
                    var u = l[0], c = n._plots[u];
                    if (c) {
                        var f = c.xaxis, h = c.yaxis;
                        c.xaxislayer.selectAll("." + f._id + "tick").remove(), c.yaxislayer.selectAll("." + h._id + "tick").remove(), c.xaxislayer.selectAll("." + f._id + "tick2").remove(), c.yaxislayer.selectAll("." + h._id + "tick2").remove(), c.xaxislayer.selectAll("." + f._id + "divider").remove(), c.yaxislayer.selectAll("." + h._id + "divider").remove(), c.minorGridlayer && c.minorGridlayer.selectAll("path").remove(), c.gridlayer && c.gridlayer.selectAll("path").remove(), c.zerolinelayer && c.zerolinelayer.selectAll("path").remove(), n._infolayer.select(".g-" + f._id + "title").remove(), n._infolayer.select(".g-" + h._id + "title").remove();
                    }
                });
                var i = !t || t === "redraw" ? kn.listIds(e) : t, a = kn.list(e), o = a.filter(function(l) {
                    return l.autoshift;
                }).map(function(l) {
                    return l.overlaying;
                });
                i.map(function(l) {
                    var u = kn.getFromId(e, l);
                    if (u.tickmode === "sync" && u.overlaying) {
                        var c = i.findIndex(function(f) {
                            return f === u.overlaying;
                        });
                        c >= 0 && i.unshift(i.splice(c, 1).shift());
                    }
                });
                var s = {
                    false: {
                        left: 0,
                        right: 0
                    }
                };
                return Vo.syncOrAsync(i.map(function(l) {
                    return function() {
                        if (l) {
                            var u = kn.getFromId(e, l);
                            r || (r = {}), r.axShifts = s, r.overlayingShiftedAx = o;
                            var c = kn.drawOne(e, u, r);
                            return u._shiftPusher && sB(u, u._fullDepth || 0, s, !0), u._r = u.range.slice(), u._rl = Vo.simpleMap(u._r, u.r2l), c;
                        }
                    };
                }));
            };
            kn.drawOne = function(e, t, r) {
                r = r || {};
                var n = r.axShifts || {}, i = r.overlayingShiftedAx || [], a, o, s;
                t.setScale();
                var l = e._fullLayout, u = t._id, c = u.charAt(0), f = kn.counterLetter(u), h = l._plots[t._mainSubplot];
                if (!h) return;
                if (t._shiftPusher = t.autoshift || i.indexOf(t._id) !== -1 || i.indexOf(t.overlaying) !== -1, t._shiftPusher & t.anchor === "free") {
                    var d = t.linewidth / 2 || 0;
                    t.ticks === "inside" && (d += t.ticklen), sB(t, d, n, !0), sB(t, t.shift || 0, n, !1);
                }
                (r.skipTitle !== !0 || t._shift === void 0) && (t._shift = Wot(t, n));
                var v = h[c + "axislayer"], x = t._mainLinePosition, b = x += t._shift, p = t._mainMirrorPosition, E = t._vals = kn.calcTicks(t), k = [
                    t.mirror,
                    b,
                    p
                ].join("_");
                for(a = 0; a < E.length; a++)E[a].axInfo = k;
                t._selections = {}, t._tickAngles && (t._prevTickAngles = t._tickAngles), t._tickAngles = {}, t._depth = null;
                var A = {};
                function L(rt) {
                    var ot = u + (rt || "tick");
                    return A[ot] || (A[ot] = qot(t, ot, b)), A[ot];
                }
                if (t.visible) {
                    var _ = kn.makeTransTickFn(t), C = kn.makeTransTickLabelFn(t), M, g, P = t.ticks === "inside", T = t.ticks === "outside";
                    if (t.tickson === "boundaries") {
                        var F = Dot(t, E);
                        g = kn.clipEnds(t, F), M = P ? g : F;
                    } else g = kn.clipEnds(t, E), M = P && t.ticklabelmode !== "period" ? g : E;
                    var q = t._gridVals = g, V = Fot(t, E);
                    if (!l._hasOnlyLargeSploms) {
                        var H = t._subplotsWith, X = {};
                        for(a = 0; a < H.length; a++){
                            o = H[a], s = l._plots[o];
                            var G = s[f + "axis"], N = G._mainAxis._id;
                            if (!X[N]) {
                                X[N] = 1;
                                var W = c === "x" ? "M0," + G._offset + "v" + G._length : "M" + G._offset + ",0h" + G._length;
                                kn.drawGrid(e, t, {
                                    vals: q,
                                    counterAxis: G,
                                    layer: s.gridlayer.select("." + u),
                                    minorLayer: s.minorGridlayer.select("." + u),
                                    path: W,
                                    transFn: _
                                }), kn.drawZeroLine(e, t, {
                                    counterAxis: G,
                                    layer: s.zerolinelayer,
                                    path: W,
                                    transFn: _
                                });
                            }
                        }
                    }
                    var re, ae = kn.getTickSigns(t), _e = kn.getTickSigns(t, "minor");
                    if (t.ticks || t.minor && t.minor.ticks) {
                        var Me = kn.makeTickPath(t, b, ae[2]), ke = kn.makeTickPath(t, b, _e[2], {
                            minor: !0
                        }), ge, ie, Te, Ee;
                        if (t._anchorAxis && t.mirror && t.mirror !== !0 ? (ge = kn.makeTickPath(t, p, ae[3]), ie = kn.makeTickPath(t, p, _e[3], {
                            minor: !0
                        }), Te = Me + ge, Ee = ke + ie) : (ge = "", ie = "", Te = Me, Ee = ke), t.showdividers && T && t.tickson === "boundaries") {
                            var Ae = {};
                            for(a = 0; a < V.length; a++)Ae[V[a].x] = 1;
                            re = function(rt) {
                                return Ae[rt.x] ? ge : Te;
                            };
                        } else re = function(rt) {
                            return rt.minor ? Ee : Te;
                        };
                    }
                    if (kn.drawTicks(e, t, {
                        vals: M,
                        layer: v,
                        path: re,
                        transFn: _
                    }), t.mirror === "allticks") {
                        var ze = Object.keys(t._linepositions || {});
                        for(a = 0; a < ze.length; a++){
                            o = ze[a], s = l._plots[o];
                            var Ce = t._linepositions[o] || [], me = Ce[0], Re = Ce[1], ce = Ce[2], Ge = kn.makeTickPath(t, me, ce ? ae[0] : _e[0], {
                                minor: ce
                            }) + kn.makeTickPath(t, Re, ce ? ae[1] : _e[1], {
                                minor: ce
                            });
                            kn.drawTicks(e, t, {
                                vals: M,
                                layer: s[c + "axislayer"],
                                path: Ge,
                                transFn: _
                            });
                        }
                    }
                    var nt = [];
                    if (nt.push(function() {
                        return kn.drawLabels(e, t, {
                            vals: E,
                            layer: v,
                            plotinfo: s,
                            transFn: C,
                            labelFns: kn.makeLabelFns(t, b)
                        });
                    }), t.type === "multicategory") {
                        var ct = {
                            x: 2,
                            y: 10
                        }[c];
                        nt.push(function() {
                            var rt = {
                                x: "height",
                                y: "width"
                            }[c], ot = L()[rt] + ct + (t._tickAngles[u + "tick"] ? t.tickfont.size * rM : 0);
                            return kn.drawLabels(e, t, {
                                vals: zot(t, E),
                                layer: v,
                                cls: u + "tick2",
                                repositionOnUpdate: !0,
                                secondary: !0,
                                transFn: _,
                                labelFns: kn.makeLabelFns(t, b + ot * ae[4])
                            });
                        }), nt.push(function() {
                            return t._depth = ae[4] * (L("tick2")[t.side] - b), Bot(e, t, {
                                vals: V,
                                layer: v,
                                path: kn.makeTickPath(t, b, ae[4], {
                                    len: t._depth
                                }),
                                transFn: _
                            });
                        });
                    } else t.title.hasOwnProperty("standoff") && nt.push(function() {
                        t._depth = ae[4] * (L()[t.side] - b);
                    });
                    var qt = QS.getComponentMethod("rangeslider", "isVisible")(t);
                    return !r.skipTitle && !(qt && t.side === "bottom") && nt.push(function() {
                        return Not(e, t);
                    }), nt.push(function() {
                        var rt = t.side.charAt(0), ot = dot[t.side].charAt(0), Rt = kn.getPxPosition(e, t), kt = T ? t.ticklen : 0, Ct, Yt, xr, er;
                        (t.automargin || qt || t._shiftPusher) && (t.type === "multicategory" ? Ct = L("tick2") : (Ct = L(), c === "x" && rt === "b" && (t._depth = Math.max(Ct.width > 0 ? Ct.bottom - Rt : 0, kt))));
                        var Ke = 0, xt = 0;
                        if (t._shiftPusher && (Ke = Math.max(kt, Ct.height > 0 ? rt === "l" ? Rt - Ct.left : Ct.right - Rt : 0), t.title.text !== l._dfltTitle[c] && (xt = (t._titleStandoff || 0) + (t._titleScoot || 0), rt === "l" && (xt += fse(t))), t._fullDepth = Math.max(Ke, xt)), t.automargin) {
                            Yt = {
                                x: 0,
                                y: 0,
                                r: 0,
                                l: 0,
                                t: 0,
                                b: 0
                            };
                            var bt = [
                                0,
                                1
                            ], Lt = typeof t._shift == "number" ? t._shift : 0;
                            if (c === "x") {
                                if (rt === "b" ? Yt[rt] = t._depth : (Yt[rt] = t._depth = Math.max(Ct.width > 0 ? Rt - Ct.top : 0, kt), bt.reverse()), Ct.width > 0) {
                                    var St = Ct.right - (t._offset + t._length);
                                    St > 0 && (Yt.xr = 1, Yt.r = St);
                                    var Et = t._offset - Ct.left;
                                    Et > 0 && (Yt.xl = 0, Yt.l = Et);
                                }
                            } else if (rt === "l" ? (t._depth = Math.max(Ct.height > 0 ? Rt - Ct.left : 0, kt), Yt[rt] = t._depth - Lt) : (t._depth = Math.max(Ct.height > 0 ? Ct.right - Rt : 0, kt), Yt[rt] = t._depth + Lt, bt.reverse()), Ct.height > 0) {
                                var dt = Ct.bottom - (t._offset + t._length);
                                dt > 0 && (Yt.yb = 0, Yt.b = dt);
                                var Ht = t._offset - Ct.top;
                                Ht > 0 && (Yt.yt = 1, Yt.t = Ht);
                            }
                            Yt[f] = t.anchor === "free" ? t.position : t._anchorAxis.domain[bt[0]], t.title.text !== l._dfltTitle[c] && (Yt[rt] += fse(t) + (t.title.standoff || 0)), t.mirror && t.anchor !== "free" && (xr = {
                                x: 0,
                                y: 0,
                                r: 0,
                                l: 0,
                                t: 0,
                                b: 0
                            }, xr[ot] = t.linewidth, t.mirror && t.mirror !== !0 && (xr[ot] += kt), t.mirror === !0 || t.mirror === "ticks" ? xr[f] = t._anchorAxis.domain[bt[1]] : (t.mirror === "all" || t.mirror === "allticks") && (xr[f] = [
                                t._counterDomainMin,
                                t._counterDomainMax
                            ][bt[1]]));
                        }
                        qt && (er = QS.getComponentMethod("rangeslider", "autoMarginOpts")(e, t)), typeof t.automargin == "string" && (cse(Yt, t.automargin), cse(xr, t.automargin)), P3.autoMargin(e, cB(t), Yt), P3.autoMargin(e, xse(t), xr), P3.autoMargin(e, bse(t), er);
                    }), Vo.syncOrAsync(nt);
                }
            };
            function cse(e, t) {
                if (e) {
                    var r = Object.keys(ise).reduce(function(n, i) {
                        return t.indexOf(i) !== -1 && ise[i].forEach(function(a) {
                            n[a] = 1;
                        }), n;
                    }, {});
                    Object.keys(e).forEach(function(n) {
                        r[n] || (n.length === 1 ? e[n] = 0 : delete e[n]);
                    });
                }
            }
            function Dot(e, t) {
                var r = [], n, i = function(a, o) {
                    var s = a.xbnd[o];
                    s !== null && r.push(Vo.extendFlat({}, a, {
                        x: s
                    }));
                };
                if (t.length) {
                    for(n = 0; n < t.length; n++)i(t[n], 0);
                    i(t[n - 1], 1);
                }
                return r;
            }
            function zot(e, t) {
                for(var r = [], n = {}, i = 0; i < t.length; i++){
                    var a = t[i];
                    n[a.text2] ? n[a.text2].push(a.x) : n[a.text2] = [
                        a.x
                    ];
                }
                for(var o in n)r.push(yse(e, Vo.interp(n[o], .5), o));
                return r;
            }
            function Fot(e, t) {
                var r = [], n, i, a = t.length && t[t.length - 1].x < t[0].x, o = function(l, u) {
                    var c = l.xbnd[u];
                    c !== null && r.push(Vo.extendFlat({}, l, {
                        x: c
                    }));
                };
                if (e.showdividers && t.length) {
                    for(n = 0; n < t.length; n++){
                        var s = t[n];
                        s.text2 !== i && o(s, a ? 1 : 0), i = s.text2;
                    }
                    o(t[n - 1], a ? 0 : 1);
                }
                return r;
            }
            function qot(e, t, r) {
                var n, i, a, o;
                if (e._selections[t].size()) n = 1 / 0, i = -1 / 0, a = 1 / 0, o = -1 / 0, e._selections[t].each(function() {
                    var l = oB(this), u = Xp.bBox(l.node().parentNode);
                    n = Math.min(n, u.top), i = Math.max(i, u.bottom), a = Math.min(a, u.left), o = Math.max(o, u.right);
                });
                else {
                    var s = kn.makeLabelFns(e, r);
                    n = i = s.yFn({
                        dx: 0,
                        dy: 0,
                        fontSize: 0
                    }), a = o = s.xFn({
                        dx: 0,
                        dy: 0,
                        fontSize: 0
                    });
                }
                return {
                    top: n,
                    bottom: i,
                    left: a,
                    right: o,
                    height: i - n,
                    width: o - a
                };
            }
            kn.getTickSigns = function(e, t) {
                var r = e._id.charAt(0), n = {
                    x: "top",
                    y: "right"
                }[r], i = e.side === n ? 1 : -1, a = [
                    -1,
                    1,
                    i,
                    -i
                ], o = t ? (e.minor || {}).ticks : e.ticks;
                return o !== "inside" == (r === "x") && (a = a.map(function(s) {
                    return -s;
                })), e.side && a.push({
                    l: -1,
                    t: -1,
                    r: 1,
                    b: 1
                }[e.side.charAt(0)]), a;
            };
            kn.makeTransTickFn = function(e) {
                return e._id.charAt(0) === "x" ? function(t) {
                    return I3(e._offset + e.l2p(t.x), 0);
                } : function(t) {
                    return I3(0, e._offset + e.l2p(t.x));
                };
            };
            kn.makeTransTickLabelFn = function(e) {
                var t = Oot(e), r = e.ticklabelshift || 0, n = e.ticklabelstandoff || 0, i = t[0], a = t[1], o = e.range[0] > e.range[1], s = e.ticklabelposition && e.ticklabelposition.indexOf("inside") !== -1, l = !s;
                if (r) {
                    var u = o ? -1 : 1;
                    r = r * u;
                }
                if (n) {
                    var c = e.side, f = s && (c === "top" || c === "left") || l && (c === "bottom" || c === "right") ? 1 : -1;
                    n = n * f;
                }
                return e._id.charAt(0) === "x" ? function(h) {
                    return I3(i + e._offset + e.l2p(aB(h)) + r, a + n);
                } : function(h) {
                    return I3(a + n, i + e._offset + e.l2p(aB(h)) + r);
                };
            };
            function aB(e) {
                return e.periodX !== void 0 ? e.periodX : e.x;
            }
            function Oot(e) {
                var t = e.ticklabelposition || "", r = function(d) {
                    return t.indexOf(d) !== -1;
                }, n = r("top"), i = r("left"), a = r("right"), o = r("bottom"), s = r("inside"), l = o || i || n || a;
                if (!l && !s) return [
                    0,
                    0
                ];
                var u = e.side, c = l ? (e.tickwidth || 0) / 2 : 0, f = wL, h = e.tickfont ? e.tickfont.size : 12;
                return (o || n) && (c += h * Cb, f += (e.linewidth || 0) / 2), (i || a) && (c += (e.linewidth || 0) / 2, f += wL), s && u === "top" && (f -= h * (1 - Cb)), (i || n) && (c = -c), (u === "bottom" || u === "right") && (f = -f), [
                    l ? c : 0,
                    s ? f : 0
                ];
            }
            kn.makeTickPath = function(e, t, r, n) {
                n || (n = {});
                var i = n.minor;
                if (i && !e.minor) return "";
                var a = n.len !== void 0 ? n.len : i ? e.minor.ticklen : e.ticklen, o = e._id.charAt(0), s = (e.linewidth || 1) / 2;
                return o === "x" ? "M0," + (t + s * r) + "v" + a * r : "M" + (t + s * r) + ",0h" + a * r;
            };
            kn.makeLabelFns = function(e, t, r) {
                var n = e.ticklabelposition || "", i = function(F) {
                    return n.indexOf(F) !== -1;
                }, a = i("top"), o = i("left"), s = i("right"), l = i("bottom"), u = l || o || a || s, c = i("inside"), f = n === "inside" && e.ticks === "inside" || !c && e.ticks === "outside" && e.tickson !== "boundaries", h = 0, d = 0, v = f ? e.ticklen : 0;
                if (c ? v *= -1 : u && (v = 0), f && (h += v, r)) {
                    var x = Vo.deg2rad(r);
                    h = v * Math.cos(x) + 1, d = v * Math.sin(x);
                }
                e.showticklabels && (f || e.showline) && (h += .2 * e.tickfont.size), h += (e.linewidth || 1) / 2 * (c ? -1 : 1);
                var b = {
                    labelStandoff: h,
                    labelShift: d
                }, p, E, k, A, L = 0, _ = e.side, C = e._id.charAt(0), M = e.tickangle, g;
                if (C === "x") g = !c && _ === "bottom" || c && _ === "top", A = g ? 1 : -1, c && (A *= -1), p = d * A, E = t + h * A, k = g ? 1 : -0.2, Math.abs(M) === 90 && (c ? k += $S : M === -90 && _ === "bottom" ? k = Cb : M === 90 && _ === "top" ? k = $S : k = .5, L = $S / 2 * (M / 90)), b.xFn = function(F) {
                    return F.dx + p + L * F.fontSize;
                }, b.yFn = function(F) {
                    return F.dy + E + F.fontSize * k;
                }, b.anchorFn = function(F, q) {
                    if (u) {
                        if (o) return "end";
                        if (s) return "start";
                    }
                    return !ph(q) || q === 0 || q === 180 ? "middle" : q * A < 0 !== c ? "end" : "start";
                }, b.heightFn = function(F, q, V) {
                    return q < -60 || q > 60 ? -0.5 * V : e.side === "top" !== c ? -V : 0;
                };
                else if (C === "y") {
                    if (g = !c && _ === "left" || c && _ === "right", A = g ? 1 : -1, c && (A *= -1), p = h, E = d * A, k = 0, !c && Math.abs(M) === 90 && (M === -90 && _ === "left" || M === 90 && _ === "right" ? k = Cb : k = .5), c) {
                        var P = ph(M) ? +M : 0;
                        if (P !== 0) {
                            var T = Vo.deg2rad(P);
                            L = Math.abs(Math.sin(T)) * Cb * A, k = 0;
                        }
                    }
                    b.xFn = function(F) {
                        return F.dx + t - (p + F.fontSize * k) * A + L * F.fontSize;
                    }, b.yFn = function(F) {
                        return F.dy + E + F.fontSize * $S;
                    }, b.anchorFn = function(F, q) {
                        return ph(q) && Math.abs(q) === 90 ? "middle" : g ? "end" : "start";
                    }, b.heightFn = function(F, q, V) {
                        return e.side === "right" && (q *= -1), q < -30 ? -V : q < 30 ? -0.5 * V : 0;
                    };
                }
                return b;
            };
            function ML(e) {
                return [
                    e.text,
                    e.x,
                    e.axInfo,
                    e.font,
                    e.fontSize,
                    e.fontColor
                ].join("_");
            }
            kn.drawTicks = function(e, t, r) {
                r = r || {};
                var n = t._id + "tick", i = [].concat(t.minor && t.minor.ticks ? r.vals.filter(function(o) {
                    return o.minor && !o.noTick;
                }) : []).concat(t.ticks ? r.vals.filter(function(o) {
                    return !o.minor && !o.noTick;
                }) : []), a = r.layer.selectAll("path." + n).data(i, ML);
                a.exit().remove(), a.enter().append("path").classed(n, 1).classed("ticks", 1).classed("crisp", r.crisp !== !1).each(function(o) {
                    return eM.stroke(w0.select(this), o.minor ? t.minor.tickcolor : t.tickcolor);
                }).style("stroke-width", function(o) {
                    return Xp.crispRound(e, o.minor ? t.minor.tickwidth : t.tickwidth, 1) + "px";
                }).attr("d", r.path).style("display", null), EL(t, [
                    hse
                ]), a.attr("transform", r.transFn);
            };
            kn.drawGrid = function(e, t, r) {
                if (r = r || {}, t.tickmode !== "sync") {
                    var n = t._id + "grid", i = t.minor && t.minor.showgrid, a = i ? r.vals.filter(function(p) {
                        return p.minor;
                    }) : [], o = t.showgrid ? r.vals.filter(function(p) {
                        return !p.minor;
                    }) : [], s = r.counterAxis;
                    if (s && kn.shouldShowZeroLine(e, t, s)) for(var l = t.tickmode === "array", u = 0; u < o.length; u++){
                        var c = o[u].x;
                        if (l ? !c : Math.abs(c) < t.dtick / 100) {
                            if (o = o.slice(0, u).concat(o.slice(u + 1)), l) u--;
                            else break;
                        }
                    }
                    t._gw = Xp.crispRound(e, t.gridwidth, 1);
                    for(var f = i ? Xp.crispRound(e, t.minor.gridwidth, 1) : 0, h = r.layer, d = r.minorLayer, v = 1; v >= 0; v--){
                        var x = v ? h : d;
                        if (x) {
                            var b = x.selectAll("path." + n).data(v ? o : a, ML);
                            b.exit().remove(), b.enter().append("path").classed(n, 1).classed("crisp", r.crisp !== !1), b.attr("transform", r.transFn).attr("d", r.path).each(function(p) {
                                return eM.stroke(w0.select(this), p.minor ? t.minor.gridcolor : t.gridcolor || "#ddd");
                            }).style("stroke-dasharray", function(p) {
                                return Xp.dashStyle(p.minor ? t.minor.griddash : t.griddash, p.minor ? t.minor.gridwidth : t.gridwidth);
                            }).style("stroke-width", function(p) {
                                return (p.minor ? f : t._gw) + "px";
                            }).style("display", null), typeof r.path == "function" && b.attr("d", r.path);
                        }
                    }
                    EL(t, [
                        iB,
                        nB
                    ]);
                }
            };
            kn.drawZeroLine = function(e, t, r) {
                r = r || r;
                var n = t._id + "zl", i = kn.shouldShowZeroLine(e, t, r.counterAxis), a = r.layer.selectAll("path." + n).data(i ? [
                    {
                        x: 0,
                        id: t._id
                    }
                ] : []);
                a.exit().remove(), a.enter().append("path").classed(n, 1).classed("zl", 1).classed("crisp", r.crisp !== !1).each(function() {
                    r.layer.selectAll("path").sort(function(o, s) {
                        return pot(o.id, s.id);
                    });
                }), a.attr("transform", r.transFn).attr("d", r.path).call(eM.stroke, t.zerolinecolor || eM.defaultLine).style("stroke-width", Xp.crispRound(e, t.zerolinewidth, t._gw || 1) + "px").style("display", null), EL(t, [
                    rB
                ]);
            };
            kn.drawLabels = function(e, t, r) {
                r = r || {};
                var n = e._fullLayout, i = t._id, a = r.cls || i + "tick", o = r.vals.filter(function(N) {
                    return N.text;
                }), s = r.labelFns, l = r.secondary ? 0 : t.tickangle, u = (t._prevTickAngles || {})[a], c = r.layer.selectAll("g." + a).data(t.showticklabels ? o : [], ML), f = [];
                c.enter().append("g").classed(a, 1).append("text").attr("text-anchor", "middle").each(function(N) {
                    var W = w0.select(this), re = e._promises.length;
                    W.call(Eb.positionText, s.xFn(N), s.yFn(N)).call(Xp.font, {
                        family: N.font,
                        size: N.fontSize,
                        color: N.fontColor,
                        weight: N.fontWeight,
                        style: N.fontStyle,
                        variant: N.fontVariant,
                        textcase: N.fontTextcase,
                        lineposition: N.fontLineposition,
                        shadow: N.fontShadow
                    }).text(N.text).call(Eb.convertToTspans, e), e._promises[re] ? f.push(e._promises.pop().then(function() {
                        h(W, l);
                    })) : h(W, l);
                }), EL(t, [
                    rse
                ]), c.exit().remove(), r.repositionOnUpdate && c.each(function(N) {
                    w0.select(this).select("text").call(Eb.positionText, s.xFn(N), s.yFn(N));
                });
                function h(N, W) {
                    N.each(function(re) {
                        var ae = w0.select(this), _e = ae.select(".text-math-group"), Me = s.anchorFn(re, W), ke = r.transFn.call(ae.node(), re) + (ph(W) && +W != 0 ? " rotate(" + W + "," + s.xFn(re) + "," + (s.yFn(re) - re.fontSize / 2) + ")" : ""), ge = Eb.lineCount(ae), ie = rM * re.fontSize, Te = s.heightFn(re, ph(W) ? +W : 0, (ge - 1) * ie);
                        if (Te && (ke += I3(0, Te)), _e.empty()) {
                            var Ee = ae.select("text");
                            Ee.attr({
                                transform: ke,
                                "text-anchor": Me
                            }), Ee.style("opacity", 1), t._adjustTickLabelsOverflow && t._adjustTickLabelsOverflow();
                        } else {
                            var Ae = Xp.bBox(_e.node()).width, ze = Ae * ({
                                end: -0.5,
                                start: .5
                            })[Me];
                            _e.attr("transform", ke + I3(ze, 0));
                        }
                    });
                }
                t._adjustTickLabelsOverflow = function() {
                    var N = t.ticklabeloverflow;
                    if (!(!N || N === "allow")) {
                        var W = N.indexOf("hide") !== -1, re = t._id.charAt(0) === "x", ae = 0, _e = re ? e._fullLayout.width : e._fullLayout.height;
                        if (N.indexOf("domain") !== -1) {
                            var Me = Vo.simpleMap(t.range, t.r2l);
                            ae = t.l2p(Me[0]) + t._offset, _e = t.l2p(Me[1]) + t._offset;
                        }
                        var ke = Math.min(ae, _e), ge = Math.max(ae, _e), ie = t.side, Te = 1 / 0, Ee = -1 / 0;
                        c.each(function(me) {
                            var Re = w0.select(this), ce = Re.select(".text-math-group");
                            if (ce.empty()) {
                                var Ge = Xp.bBox(Re.node()), nt = 0;
                                re ? (Ge.right > ge || Ge.left < ke) && (nt = 1) : (Ge.bottom > ge || Ge.top + (t.tickangle ? 0 : me.fontSize / 4) < ke) && (nt = 1);
                                var ct = Re.select("text");
                                nt ? W && ct.style("opacity", 0) : (ct.style("opacity", 1), ie === "bottom" || ie === "right" ? Te = Math.min(Te, re ? Ge.top : Ge.left) : Te = -1 / 0, ie === "top" || ie === "left" ? Ee = Math.max(Ee, re ? Ge.bottom : Ge.right) : Ee = 1 / 0);
                            }
                        });
                        for(var Ae in n._plots){
                            var ze = n._plots[Ae];
                            if (!(t._id !== ze.xaxis._id && t._id !== ze.yaxis._id)) {
                                var Ce = re ? ze.yaxis : ze.xaxis;
                                Ce && (Ce["_visibleLabelMin_" + t._id] = Te, Ce["_visibleLabelMax_" + t._id] = Ee);
                            }
                        }
                    }
                }, t._hideCounterAxisInsideTickLabels = function(N) {
                    var W = t._id.charAt(0) === "x", re = [];
                    for(var ae in n._plots){
                        var _e = n._plots[ae];
                        t._id !== _e.xaxis._id && t._id !== _e.yaxis._id || re.push(W ? _e.yaxis : _e.xaxis);
                    }
                    re.forEach(function(Me, ke) {
                        Me && nM(Me) && (N || [
                            rB,
                            nB,
                            iB,
                            hse,
                            rse
                        ]).forEach(function(ge) {
                            var ie = ge.K === "tick" && ge.L === "text" && t.ticklabelmode === "period", Te = n._plots[t._mainSubplot], Ee;
                            ge.K === rB.K ? Ee = Te.zerolinelayer.selectAll("." + t._id + "zl") : ge.K === nB.K ? Ee = Te.minorGridlayer.selectAll("." + t._id) : ge.K === iB.K ? Ee = Te.gridlayer.selectAll("." + t._id) : Ee = Te[t._id.charAt(0) + "axislayer"], Ee.each(function() {
                                var Ae = w0.select(this);
                                ge.L && (Ae = Ae.selectAll(ge.L)), Ae.each(function(ze) {
                                    var Ce = t.l2p(ie ? aB(ze) : ze.x) + t._offset, me = w0.select(this);
                                    Ce < t["_visibleLabelMax_" + Me._id] && Ce > t["_visibleLabelMin_" + Me._id] ? me.style("display", "none") : ge.K === "tick" && !ke && me.style("display", null);
                                });
                            });
                        });
                    });
                }, h(c, u + 1 ? u : l);
                function d() {
                    return f.length && Promise.all(f);
                }
                var v = null;
                function x() {
                    if (h(c, l), o.length && t.autotickangles && (t.type !== "log" || String(t.dtick).charAt(0) !== "D")) {
                        v = t.autotickangles[0];
                        var N = 0, W = [], re, ae = 1;
                        c.each(function(Ct) {
                            N = Math.max(N, Ct.fontSize);
                            var Yt = t.l2p(Ct.x), xr = oB(this), er = Xp.bBox(xr.node());
                            ae = Math.max(ae, Eb.lineCount(xr)), W.push({
                                top: 0,
                                bottom: 10,
                                height: 10,
                                left: Yt - er.width / 2,
                                right: Yt + er.width / 2 + 2,
                                width: er.width + 2
                            });
                        });
                        var _e = (t.tickson === "boundaries" || t.showdividers) && !r.secondary, Me = o.length, ke = Math.abs((o[Me - 1].x - o[0].x) * t._m) / (Me - 1), ge = _e ? ke / 2 : ke, ie = _e ? t.ticklen : N * 1.25 * ae, Te = Math.sqrt(Math.pow(ge, 2) + Math.pow(ie, 2)), Ee = ge / Te, Ae = t.autotickangles.map(function(Ct) {
                            return Ct * Math.PI / 180;
                        }), ze = Ae.find(function(Ct) {
                            return Math.abs(Math.cos(Ct)) <= Ee;
                        });
                        ze === void 0 && (ze = Ae.reduce(function(Ct, Yt) {
                            return Math.abs(Math.cos(Ct)) < Math.abs(Math.cos(Yt)) ? Ct : Yt;
                        }, Ae[0]));
                        var Ce = ze * (180 / Math.PI);
                        if (_e) {
                            var me = 2;
                            for(t.ticks && (me += t.tickwidth / 2), re = 0; re < W.length; re++){
                                var Re = o[re].xbnd, ce = W[re];
                                if (Re[0] !== null && ce.left - t.l2p(Re[0]) < me || Re[1] !== null && t.l2p(Re[1]) - ce.right < me) {
                                    v = Ce;
                                    break;
                                }
                            }
                        } else {
                            var Ge = t.ticklabelposition || "", nt = function(Ct) {
                                return Ge.indexOf(Ct) !== -1;
                            }, ct = nt("top"), qt = nt("left"), rt = nt("right"), ot = nt("bottom"), Rt = ot || qt || ct || rt, kt = Rt ? (t.tickwidth || 0) + 2 * wL : 0;
                            for(re = 0; re < W.length - 1; re++)if (Vo.bBoxIntersect(W[re], W[re + 1], kt)) {
                                v = Ce;
                                break;
                            }
                        }
                        v && h(c, v);
                    }
                }
                t._selections && (t._selections[a] = c);
                var b = [
                    d
                ];
                t.automargin && n._redrawFromAutoMarginCount && u === 90 ? (v = u, b.push(function() {
                    h(c, u);
                })) : b.push(x), t._tickAngles && b.push(function() {
                    t._tickAngles[a] = v === null ? ph(l) ? l : 0 : v;
                });
                var p = function() {
                    var N = 0, W = 0;
                    return c.each(function(re, ae) {
                        var _e = oB(this), Me = _e.select(".text-math-group");
                        if (Me.empty()) {
                            var ke;
                            t._vals[ae] && (ke = t._vals[ae].bb || Xp.bBox(_e.node()), t._vals[ae].bb = ke), N = Math.max(N, ke.width), W = Math.max(W, ke.height);
                        }
                    }), {
                        labelsMaxW: N,
                        labelsMaxH: W
                    };
                }, E = t._anchorAxis;
                if (E && (E.autorange || E.insiderange) && nM(t) && !got(n, t._id) && (n._insideTickLabelsUpdaterange || (n._insideTickLabelsUpdaterange = {}), E.autorange && (n._insideTickLabelsUpdaterange[E._name + ".autorange"] = E.autorange, b.push(p)), E.insiderange)) {
                    var k = p(), A = t._id.charAt(0) === "y" ? k.labelsMaxW : k.labelsMaxH;
                    A += 2 * wL, t.ticklabelposition === "inside" && (A += t.ticklen || 0);
                    var L = t.side === "right" || t.side === "top" ? 1 : -1, _ = L === 1 ? 1 : 0, C = L === 1 ? 0 : 1, M = [];
                    M[C] = E.range[C];
                    var g = E.range, P = E.r2p(g[_]), T = E.r2p(g[C]), F = n._insideTickLabelsUpdaterange[E._name + ".range"];
                    if (F) {
                        var q = E.r2p(F[_]), V = E.r2p(F[C]), H = L * (t._id.charAt(0) === "y" ? 1 : -1);
                        H * P < H * q && (P = q, M[_] = g[_] = F[_]), H * T > H * V && (T = V, M[C] = g[C] = F[C]);
                    }
                    var X = Math.abs(T - P);
                    X - A > 0 ? (X -= A, A *= 1 + A / X) : A = 0, t._id.charAt(0) !== "y" && (A = -A), M[_] = E.p2r(E.r2p(g[_]) + L * A), E.autorange === "min" || E.autorange === "max reversed" ? (M[0] = null, E._rangeInitial0 = void 0, E._rangeInitial1 = void 0) : (E.autorange === "max" || E.autorange === "min reversed") && (M[1] = null, E._rangeInitial0 = void 0, E._rangeInitial1 = void 0), n._insideTickLabelsUpdaterange[E._name + ".range"] = M;
                }
                var G = Vo.syncOrAsync(b);
                return G && G.then && e._promises.push(G), G;
            };
            function Bot(e, t, r) {
                var n = t._id + "divider", i = r.vals, a = r.layer.selectAll("path." + n).data(i, ML);
                a.exit().remove(), a.enter().insert("path", ":first-child").classed(n, 1).classed("crisp", 1).call(eM.stroke, t.dividercolor).style("stroke-width", Xp.crispRound(e, t.dividerwidth, 1) + "px"), a.attr("transform", r.transFn).attr("d", r.path);
            }
            kn.getPxPosition = function(e, t) {
                var r = e._fullLayout._size, n = t._id.charAt(0), i = t.side, a;
                if (t.anchor !== "free" ? a = t._anchorAxis : n === "x" ? a = {
                    _offset: r.t + (1 - (t.position || 0)) * r.h,
                    _length: 0
                } : n === "y" && (a = {
                    _offset: r.l + (t.position || 0) * r.w + t._shift,
                    _length: 0
                }), i === "top" || i === "left") return a._offset;
                if (i === "bottom" || i === "right") return a._offset + a._length;
            };
            function fse(e) {
                var t = e.title.font.size, r = (e.title.text.match(Eb.BR_TAG_ALL) || []).length;
                return e.title.hasOwnProperty("standoff") ? t * (Cb + r * rM) : r ? t * (r + 1) * rM : t;
            }
            function Not(e, t) {
                var r = e._fullLayout, n = t._id, i = n.charAt(0), a = t.title.font.size, o, s = (t.title.text.match(Eb.BR_TAG_ALL) || []).length;
                if (t.title.hasOwnProperty("standoff")) t.side === "bottom" || t.side === "right" ? o = t._depth + t.title.standoff + a * Cb : (t.side === "top" || t.side === "left") && (o = t._depth + t.title.standoff + a * ($S + s * rM));
                else {
                    var l = nM(t);
                    if (t.type === "multicategory") o = t._depth;
                    else {
                        var u = 1.5 * a;
                        l && (u = .5 * a, t.ticks === "outside" && (u += t.ticklen)), o = 10 + u + (t.linewidth ? t.linewidth - 1 : 0);
                    }
                    l || (i === "x" ? o += t.side === "top" ? a * (t.showticklabels ? 1 : 0) : a * (t.showticklabels ? 1.5 : .5) : o += t.side === "right" ? a * (t.showticklabels ? 1 : .5) : a * (t.showticklabels ? .5 : 0));
                }
                var c = kn.getPxPosition(e, t), f, h, d;
                i === "x" ? (h = t._offset + t._length / 2, d = t.side === "top" ? c - o : c + o) : (d = t._offset + t._length / 2, h = t.side === "right" ? c + o : c - o, f = {
                    rotate: "-90",
                    offset: 0
                });
                var v;
                if (t.type !== "multicategory") {
                    var x = t._selections[t._id + "tick"];
                    if (v = {
                        selection: x,
                        side: t.side
                    }, x && x.node() && x.node().parentNode) {
                        var b = Xp.getTranslate(x.node().parentNode);
                        v.offsetLeft = b.x, v.offsetTop = b.y;
                    }
                    t.title.hasOwnProperty("standoff") && (v.pad = 0);
                }
                return t._titleStandoff = o, oot.draw(e, n + "title", {
                    propContainer: t,
                    propName: t._name + ".title.text",
                    placeholder: r._dfltTitle[i],
                    avoid: v,
                    transform: f,
                    attributes: {
                        x: h,
                        y: d,
                        "text-anchor": "middle"
                    }
                });
            }
            kn.shouldShowZeroLine = function(e, t, r) {
                var n = Vo.simpleMap(t.range, t.r2l);
                return n[0] * n[1] <= 0 && t.zeroline && (t.type === "linear" || t.type === "-") && !(t.rangebreaks && t.maskBreaks(0) === AL) && (_se(t, 0) || !Uot(e, t, r, n) || Vot(e, t));
            };
            kn.clipEnds = function(e, t) {
                return t.filter(function(r) {
                    return _se(e, r.x);
                });
            };
            function _se(e, t) {
                var r = e.l2p(t);
                return r > 1 && r < e._length - 1;
            }
            function Uot(e, t, r, n) {
                var i = r._mainAxis;
                if (!i) return;
                var a = e._fullLayout, o = t._id.charAt(0), s = kn.counterLetter(t._id), l = t._offset + (Math.abs(n[0]) < Math.abs(n[1]) == (o === "x") ? 0 : t._length);
                function u(v) {
                    if (!v.showline || !v.linewidth) return !1;
                    var x = Math.max((v.linewidth + t.zerolinewidth) / 2, 1);
                    function b(k) {
                        return typeof k == "number" && Math.abs(k - l) < x;
                    }
                    if (b(v._mainLinePosition) || b(v._mainMirrorPosition)) return !0;
                    var p = v._linepositions || {};
                    for(var E in p)if (b(p[E][0]) || b(p[E][1])) return !0;
                }
                var c = a._plots[r._mainSubplot];
                if (!(c.mainplotinfo || c).overlays.length) return u(r, l);
                for(var f = kn.list(e, s), h = 0; h < f.length; h++){
                    var d = f[h];
                    if (d._mainAxis === i && u(d, l)) return !0;
                }
            }
            function Vot(e, t) {
                for(var r = e._fullData, n = t._mainSubplot, i = t._id.charAt(0), a = 0; a < r.length; a++){
                    var o = r[a];
                    if (o.visible === !0 && o.xaxis + o.yaxis === n && (QS.traceIs(o, "bar-like") && o.orientation === ({
                        x: "h",
                        y: "v"
                    })[i] || o.fill && o.fill.charAt(o.fill.length - 1) === i)) return !0;
                }
                return !1;
            }
            function oB(e) {
                var t = w0.select(e), r = t.select(".text-math-group");
                return r.empty() ? t.select("text") : r;
            }
            kn.allowAutoMargin = function(e) {
                for(var t = kn.list(e, "", !0), r = 0; r < t.length; r++){
                    var n = t[r];
                    n.automargin && (P3.allowAutoMargin(e, cB(n)), n.mirror && P3.allowAutoMargin(e, xse(n))), QS.getComponentMethod("rangeslider", "isVisible")(n) && P3.allowAutoMargin(e, bse(n));
                }
            };
            function cB(e) {
                return e._id + ".automargin";
            }
            function xse(e) {
                return cB(e) + ".mirror";
            }
            function bse(e) {
                return e._id + ".rangeslider";
            }
            kn.swap = function(e, t) {
                for(var r = Hot(e, t), n = 0; n < r.length; n++)Got(e, r[n].x, r[n].y);
            };
            function Hot(e, t) {
                var r = [], n, i;
                for(n = 0; n < t.length; n++){
                    var a = [], o = e._fullData[t[n]].xaxis, s = e._fullData[t[n]].yaxis;
                    if (!(!o || !s)) {
                        for(i = 0; i < r.length; i++)(r[i].x.indexOf(o) !== -1 || r[i].y.indexOf(s) !== -1) && a.push(i);
                        if (!a.length) {
                            r.push({
                                x: [
                                    o
                                ],
                                y: [
                                    s
                                ]
                            });
                            continue;
                        }
                        var l = r[a[0]], u;
                        if (a.length > 1) for(i = 1; i < a.length; i++)u = r[a[i]], gL(l.x, u.x), gL(l.y, u.y);
                        gL(l.x, [
                            o
                        ]), gL(l.y, [
                            s
                        ]);
                    }
                }
                return r;
            }
            function gL(e, t) {
                for(var r = 0; r < t.length; r++)e.indexOf(t[r]) === -1 && e.push(t[r]);
            }
            function Got(e, t, r) {
                var n = [], i = [], a = e.layout, o, s;
                for(o = 0; o < t.length; o++)n.push(kn.getFromId(e, t[o]));
                for(o = 0; o < r.length; o++)i.push(kn.getFromId(e, r[o]));
                var l = Object.keys(sot), u = [
                    "anchor",
                    "domain",
                    "overlaying",
                    "position",
                    "side",
                    "tickangle",
                    "editType"
                ], c = [
                    "linear",
                    "log"
                ];
                for(o = 0; o < l.length; o++){
                    var f = l[o], h = n[0][f], d = i[0][f], v = !0, x = !1, b = !1;
                    if (!(f.charAt(0) === "_" || typeof h == "function" || u.indexOf(f) !== -1)) {
                        for(s = 1; s < n.length && v; s++){
                            var p = n[s][f];
                            f === "type" && c.indexOf(h) !== -1 && c.indexOf(p) !== -1 && h !== p ? x = !0 : p !== h && (v = !1);
                        }
                        for(s = 1; s < i.length && v; s++){
                            var E = i[s][f];
                            f === "type" && c.indexOf(d) !== -1 && c.indexOf(E) !== -1 && d !== E ? b = !0 : i[s][f] !== d && (v = !1);
                        }
                        v && (x && (a[n[0]._name].type = "linear"), b && (a[i[0]._name].type = "linear"), jot(a, f, n, i, e._fullLayout._dfltTitle));
                    }
                }
                for(o = 0; o < e._fullLayout.annotations.length; o++){
                    var k = e._fullLayout.annotations[o];
                    t.indexOf(k.xref) !== -1 && r.indexOf(k.yref) !== -1 && Vo.swapAttrs(a.annotations[o], [
                        "?"
                    ]);
                }
            }
            function jot(e, t, r, n, i) {
                var a = Vo.nestedProperty, o = a(e[r[0]._name], t).get(), s = a(e[n[0]._name], t).get(), l;
                for(t === "title" && (o && o.text === i.x && (o.text = i.y), s && s.text === i.y && (s.text = i.x)), l = 0; l < r.length; l++)a(e, r[l]._name + "." + t).set(s);
                for(l = 0; l < n.length; l++)a(e, n[l]._name + "." + t).set(o);
            }
            function fB(e) {
                return e._id === "angularaxis";
            }
            function eB(e, t) {
                for(var r = t._rangebreaks.length, n = 0; n < r; n++){
                    var i = t._rangebreaks[n];
                    if (e >= i.min && e < i.max) return i.max;
                }
                return e;
            }
            function nM(e) {
                return (e.ticklabelposition || "").indexOf("inside") !== -1;
            }
            function EL(e, t) {
                nM(e._anchorAxis || {}) && e._hideCounterAxisInsideTickLabels && e._hideCounterAxisInsideTickLabels(t);
            }
            function sB(e, t, r, n) {
                var i = e.anchor !== "free" && (e.overlaying === void 0 || e.overlaying === !1) ? e._id : e.overlaying, a;
                n ? a = e.side === "right" ? t : -t : a = t, i in r || (r[i] = {}), e.side in r[i] || (r[i][e.side] = 0), r[i][e.side] += a;
            }
            function Wot(e, t) {
                return e.autoshift ? t[e.overlaying][e.side] : e.shift || 0;
            }
            function Zot(e, t) {
                return /%f/.test(t) ? e >= hot : /%L/.test(t) ? e >= fot : /%[SX]/.test(t) ? e >= bL : /%M/.test(t) ? e >= tM : /%[HI]/.test(t) ? e >= xm : /%p/.test(t) ? e >= l_ : /%[Aadejuwx]/.test(t) ? e >= Fv : /%[UVW]/.test(t) ? e >= Yp : /%[Bbm]/.test(t) ? e >= xL : /%[q]/.test(t) ? e >= _L : /%[Yy]/.test(t) ? e >= yL : !0;
            }
        });
        var hB = ye((Srr, Tse)=>{
            "use strict";
            Tse.exports = function(t, r, n) {
                var i, a;
                if (n) {
                    var o = r === "reversed" || r === "min reversed" || r === "max reversed";
                    i = n[o ? 1 : 0], a = n[o ? 0 : 1];
                }
                var s = t("autorangeoptions.minallowed", a === null ? i : void 0), l = t("autorangeoptions.maxallowed", i === null ? a : void 0);
                s === void 0 && t("autorangeoptions.clipmin"), l === void 0 && t("autorangeoptions.clipmax"), t("autorangeoptions.include");
            };
        });
        var dB = ye((Mrr, Ase)=>{
            "use strict";
            var Xot = hB();
            Ase.exports = function(t, r, n, i) {
                var a = r._template || {}, o = r.type || a.type || "-";
                n("minallowed"), n("maxallowed");
                var s = n("range");
                if (!s) {
                    var l;
                    !i.noInsiderange && o !== "log" && (l = n("insiderange"), l && (l[0] === null || l[1] === null) && (r.insiderange = !1, l = void 0), l && (s = n("range", l)));
                }
                var u = r.getAutorangeDflt(s, i), c = n("autorange", u), f;
                s && (s[0] === null && s[1] === null || (s[0] === null || s[1] === null) && (c === "reversed" || c === !0) || s[0] !== null && (c === "min" || c === "max reversed") || s[1] !== null && (c === "max" || c === "min reversed")) && (s = void 0, delete r.range, r.autorange = !0, f = !0), f || (u = r.getAutorangeDflt(s, i), c = n("autorange", u)), c && (Xot(n, c, s), (o === "linear" || o === "-") && n("rangemode")), r.cleanRange();
            };
        });
        var Mse = ye((Err, Sse)=>{
            var Yot = {
                left: 0,
                top: 0
            };
            Sse.exports = Kot;
            function Kot(e, t, r) {
                t = t || e.currentTarget || e.srcElement, Array.isArray(r) || (r = [
                    0,
                    0
                ]);
                var n = e.clientX || 0, i = e.clientY || 0, a = Jot(t);
                return r[0] = n - a.left, r[1] = i - a.top, r;
            }
            function Jot(e) {
                return e === window || e === document || e === document.body ? Yot : e.getBoundingClientRect();
            }
        });
        var kL = ye((krr, Ese)=>{
            "use strict";
            var $ot = Kq();
            function Qot() {
                var e = !1;
                try {
                    var t = Object.defineProperty({}, "passive", {
                        get: function() {
                            e = !0;
                        }
                    });
                    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
                } catch (r) {
                    e = !1;
                }
                return e;
            }
            Ese.exports = $ot && Qot();
        });
        var Cse = ye((Crr, kse)=>{
            "use strict";
            kse.exports = function(t, r, n, i, a) {
                var o = (t - n) / (i - n), s = o + r / (i - n), l = (o + s) / 2;
                return a === "left" || a === "bottom" ? o : a === "center" || a === "middle" ? l : a === "right" || a === "top" ? s : o < 2 / 3 - l ? o : s > 4 / 3 - l ? s : l;
            };
        });
        var Ise = ye((Lrr, Pse)=>{
            "use strict";
            var Lse = Mr(), est = [
                [
                    "sw-resize",
                    "s-resize",
                    "se-resize"
                ],
                [
                    "w-resize",
                    "move",
                    "e-resize"
                ],
                [
                    "nw-resize",
                    "n-resize",
                    "ne-resize"
                ]
            ];
            Pse.exports = function(t, r, n, i) {
                return n === "left" ? t = 0 : n === "center" ? t = 1 : n === "right" ? t = 2 : t = Lse.constrain(Math.floor(t * 3), 0, 2), i === "bottom" ? r = 0 : i === "middle" ? r = 1 : i === "top" ? r = 2 : r = Lse.constrain(Math.floor(r * 3), 0, 2), est[r][t];
            };
        });
        var Dse = ye((Prr, Rse)=>{
            "use strict";
            var tst = g3(), rst = P6(), ist = DS().getGraphDiv, nst = IS(), vB = Rse.exports = {};
            vB.wrapped = function(e, t, r) {
                e = ist(e), e._fullLayout && rst.clear(e._fullLayout._uid + nst.HOVERID), vB.raw(e, t, r);
            };
            vB.raw = function(t, r) {
                var n = t._fullLayout, i = t._hoverdata;
                r || (r = {}), !(r.target && !t._dragged && tst.triggerHandler(t, "plotly_beforehover", r) === !1) && (n._hoverlayer.selectAll("g").remove(), n._hoverlayer.selectAll("line").remove(), n._hoverlayer.selectAll("circle").remove(), t._hoverdata = void 0, r.target && i && t.emit("plotly_unhover", {
                    event: r,
                    points: i
                }));
            };
        });
        var gv = ye((Irr, Ose)=>{
            "use strict";
            var ast = Mse(), pB = $q(), ost = kL(), sst = Mr().removeElement, lst = ad(), Lb = Ose.exports = {};
            Lb.align = Cse();
            Lb.getCursor = Ise();
            var Fse = Dse();
            Lb.unhover = Fse.wrapped;
            Lb.unhoverRaw = Fse.raw;
            Lb.init = function(t) {
                var r = t.gd, n = 1, i = r._context.doubleClickDelay, a = t.element, o, s, l, u, c, f, h, d;
                r._mouseDownTime || (r._mouseDownTime = 0), a.style.pointerEvents = "all", a.onmousedown = b, ost ? (a._ontouchstart && a.removeEventListener("touchstart", a._ontouchstart), a._ontouchstart = b, a.addEventListener("touchstart", b, {
                    passive: !1
                })) : a.ontouchstart = b;
                function v(k, A, L) {
                    return Math.abs(k) < L && (k = 0), Math.abs(A) < L && (A = 0), [
                        k,
                        A
                    ];
                }
                var x = t.clampFn || v;
                function b(k) {
                    r._dragged = !1, r._dragging = !0;
                    var A = zse(k);
                    o = A[0], s = A[1], h = k.target, f = k, d = k.buttons === 2 || k.ctrlKey, typeof k.clientX == "undefined" && typeof k.clientY == "undefined" && (k.clientX = o, k.clientY = s), l = new Date().getTime(), l - r._mouseDownTime < i ? n += 1 : (n = 1, r._mouseDownTime = l), t.prepFn && t.prepFn(k, o, s), pB && !d ? (c = qse(), c.style.cursor = window.getComputedStyle(a).cursor) : pB || (c = document, u = window.getComputedStyle(document.documentElement).cursor, document.documentElement.style.cursor = window.getComputedStyle(a).cursor), document.addEventListener("mouseup", E), document.addEventListener("touchend", E), t.dragmode !== !1 && (k.preventDefault(), document.addEventListener("mousemove", p), document.addEventListener("touchmove", p, {
                        passive: !1
                    }));
                }
                function p(k) {
                    k.preventDefault();
                    var A = zse(k), L = t.minDrag || lst.MINDRAG, _ = x(A[0] - o, A[1] - s, L), C = _[0], M = _[1];
                    (C || M) && (r._dragged = !0, Lb.unhover(r, k)), r._dragged && t.moveFn && !d && (r._dragdata = {
                        element: a,
                        dx: C,
                        dy: M
                    }, t.moveFn(C, M));
                }
                function E(k) {
                    if (delete r._dragdata, t.dragmode !== !1 && (k.preventDefault(), document.removeEventListener("mousemove", p), document.removeEventListener("touchmove", p)), document.removeEventListener("mouseup", E), document.removeEventListener("touchend", E), pB ? sst(c) : u && (c.documentElement.style.cursor = u, u = null), !r._dragging) {
                        r._dragged = !1;
                        return;
                    }
                    if (r._dragging = !1, new Date().getTime() - r._mouseDownTime > i && (n = Math.max(n - 1, 1)), r._dragged) t.doneFn && t.doneFn();
                    else {
                        var A;
                        f.target === h ? A = f : (A = {
                            target: h,
                            srcElement: h,
                            toElement: h
                        }, Object.keys(f).concat(Object.keys(f.__proto__)).forEach((L)=>{
                            var _ = f[L];
                            !A[L] && typeof _ != "function" && (A[L] = _);
                        })), t.clickFn && t.clickFn(n, A), d || h.dispatchEvent(new MouseEvent("click", k));
                    }
                    r._dragging = !1, r._dragged = !1;
                }
            };
            function qse() {
                var e = document.createElement("div");
                e.className = "dragcover";
                var t = e.style;
                return t.position = "fixed", t.left = 0, t.right = 0, t.top = 0, t.bottom = 0, t.zIndex = 999999999, t.background = "none", document.body.appendChild(e), e;
            }
            Lb.coverSlip = qse;
            function zse(e) {
                return ast(e.changedTouches ? e.changedTouches[0] : e, document.body);
            }
        });
        var Tg = ye((Rrr, Bse)=>{
            "use strict";
            Bse.exports = function(t, r) {
                (t.attr("class") || "").split(" ").forEach(function(n) {
                    n.indexOf("cursor-") === 0 && t.classed(n, !1);
                }), r && t.classed("cursor-" + r, !0);
            };
        });
        var Vse = ye((Drr, Use)=>{
            "use strict";
            var gB = Tg(), aM = "data-savedcursor", Nse = "!!";
            Use.exports = function(t, r) {
                var n = t.attr(aM);
                if (r) {
                    if (!n) {
                        for(var i = (t.attr("class") || "").split(" "), a = 0; a < i.length; a++){
                            var o = i[a];
                            o.indexOf("cursor-") === 0 && t.attr(aM, o.substr(7)).classed(o, !1);
                        }
                        t.attr(aM) || t.attr(aM, Nse);
                    }
                    gB(t, r);
                } else n && (t.attr(aM, null), n === Nse ? gB(t) : gB(t, n));
            };
        });
        var yB = ye((zrr, Hse)=>{
            "use strict";
            var mB = Su(), ust = dh();
            Hse.exports = {
                _isSubplotObj: !0,
                visible: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "legend"
                },
                bgcolor: {
                    valType: "color",
                    editType: "legend"
                },
                bordercolor: {
                    valType: "color",
                    dflt: ust.defaultLine,
                    editType: "legend"
                },
                borderwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 0,
                    editType: "legend"
                },
                font: mB({
                    editType: "legend"
                }),
                grouptitlefont: mB({
                    editType: "legend"
                }),
                orientation: {
                    valType: "enumerated",
                    values: [
                        "v",
                        "h"
                    ],
                    dflt: "v",
                    editType: "legend"
                },
                traceorder: {
                    valType: "flaglist",
                    flags: [
                        "reversed",
                        "grouped"
                    ],
                    extras: [
                        "normal"
                    ],
                    editType: "legend"
                },
                tracegroupgap: {
                    valType: "number",
                    min: 0,
                    dflt: 10,
                    editType: "legend"
                },
                entrywidth: {
                    valType: "number",
                    min: 0,
                    editType: "legend"
                },
                entrywidthmode: {
                    valType: "enumerated",
                    values: [
                        "fraction",
                        "pixels"
                    ],
                    dflt: "pixels",
                    editType: "legend"
                },
                indentation: {
                    valType: "number",
                    min: -15,
                    dflt: 0,
                    editType: "legend"
                },
                itemsizing: {
                    valType: "enumerated",
                    values: [
                        "trace",
                        "constant"
                    ],
                    dflt: "trace",
                    editType: "legend"
                },
                itemwidth: {
                    valType: "number",
                    min: 30,
                    dflt: 30,
                    editType: "legend"
                },
                itemclick: {
                    valType: "enumerated",
                    values: [
                        "toggle",
                        "toggleothers",
                        !1
                    ],
                    dflt: "toggle",
                    editType: "legend"
                },
                itemdoubleclick: {
                    valType: "enumerated",
                    values: [
                        "toggle",
                        "toggleothers",
                        !1
                    ],
                    dflt: "toggleothers",
                    editType: "legend"
                },
                groupclick: {
                    valType: "enumerated",
                    values: [
                        "toggleitem",
                        "togglegroup"
                    ],
                    dflt: "togglegroup",
                    editType: "legend"
                },
                x: {
                    valType: "number",
                    editType: "legend"
                },
                xref: {
                    valType: "enumerated",
                    dflt: "paper",
                    values: [
                        "container",
                        "paper"
                    ],
                    editType: "layoutstyle"
                },
                xanchor: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "left",
                        "center",
                        "right"
                    ],
                    dflt: "left",
                    editType: "legend"
                },
                y: {
                    valType: "number",
                    editType: "legend"
                },
                yref: {
                    valType: "enumerated",
                    dflt: "paper",
                    values: [
                        "container",
                        "paper"
                    ],
                    editType: "layoutstyle"
                },
                yanchor: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "top",
                        "middle",
                        "bottom"
                    ],
                    editType: "legend"
                },
                uirevision: {
                    valType: "any",
                    editType: "none"
                },
                valign: {
                    valType: "enumerated",
                    values: [
                        "top",
                        "middle",
                        "bottom"
                    ],
                    dflt: "middle",
                    editType: "legend"
                },
                title: {
                    text: {
                        valType: "string",
                        dflt: "",
                        editType: "legend"
                    },
                    font: mB({
                        editType: "legend"
                    }),
                    side: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "left",
                            "top left",
                            "top center",
                            "top right"
                        ],
                        editType: "legend"
                    },
                    editType: "legend"
                },
                editType: "legend"
            };
        });
        var LL = ye((CL)=>{
            "use strict";
            CL.isGrouped = function(t) {
                return (t.traceorder || "").indexOf("grouped") !== -1;
            };
            CL.isVertical = function(t) {
                return t.orientation !== "h";
            };
            CL.isReversed = function(t) {
                return (t.traceorder || "").indexOf("reversed") !== -1;
            };
        });
        var bB = ye((qrr, Gse)=>{
            "use strict";
            var _B = ba(), Kp = Mr(), cst = Vs(), fst = vl(), hst = yB(), dst = s3(), xB = LL();
            function vst(e, t, r, n) {
                var i = t[e] || {}, a = cst.newContainer(r, e);
                function o(G, N) {
                    return Kp.coerce(i, a, hst, G, N);
                }
                var s = Kp.coerceFont(o, "font", r.font);
                o("bgcolor", r.paper_bgcolor), o("bordercolor");
                var l = o("visible");
                if (l) {
                    for(var u, c = function(G, N) {
                        var W = u._input, re = u;
                        return Kp.coerce(W, re, fst, G, N);
                    }, f = r.font || {}, h = Kp.coerceFont(o, "grouptitlefont", f, {
                        overrideDflt: {
                            size: Math.round(f.size * 1.1)
                        }
                    }), d = 0, v = !1, x = "normal", b = (r.shapes || []).filter(function(G) {
                        return G.showlegend;
                    }), p = n.concat(b).filter(function(G) {
                        return e === (G.legend || "legend");
                    }), E = 0; E < p.length; E++)if (u = p[E], !!u.visible) {
                        var k = u._isShape;
                        (u.showlegend || u._dfltShowLegend && !(u._module && u._module.attributes && u._module.attributes.showlegend && u._module.attributes.showlegend.dflt === !1)) && (d++, u.showlegend && (v = !0, (!k && _B.traceIs(u, "pie-like") || u._input.showlegend === !0) && d++), Kp.coerceFont(c, "legendgrouptitle.font", h)), (!k && _B.traceIs(u, "bar") && r.barmode === "stack" || [
                            "tonextx",
                            "tonexty"
                        ].indexOf(u.fill) !== -1) && (x = xB.isGrouped({
                            traceorder: x
                        }) ? "grouped+reversed" : "reversed"), u.legendgroup !== void 0 && u.legendgroup !== "" && (x = xB.isReversed({
                            traceorder: x
                        }) ? "reversed+grouped" : "grouped");
                    }
                    var A = Kp.coerce(t, r, dst, "showlegend", v && d > (e === "legend" ? 1 : 0));
                    if (A === !1 && (r[e] = void 0), !(A === !1 && !i.uirevision) && (o("uirevision", r.uirevision), A !== !1)) {
                        o("borderwidth");
                        var L = o("orientation"), _ = o("yref"), C = o("xref"), M = L === "h", g = _ === "paper", P = C === "paper", T, F, q, V = "left";
                        M ? (T = 0, _B.getComponentMethod("rangeslider", "isVisible")(t.xaxis) ? g ? (F = 1.1, q = "bottom") : (F = 1, q = "top") : g ? (F = -0.1, q = "top") : (F = 0, q = "bottom")) : (F = 1, q = "auto", P ? T = 1.02 : (T = 1, V = "right")), Kp.coerce(i, a, {
                            x: {
                                valType: "number",
                                editType: "legend",
                                min: P ? -2 : 0,
                                max: P ? 3 : 1,
                                dflt: T
                            }
                        }, "x"), Kp.coerce(i, a, {
                            y: {
                                valType: "number",
                                editType: "legend",
                                min: g ? -2 : 0,
                                max: g ? 3 : 1,
                                dflt: F
                            }
                        }, "y"), o("traceorder", x), xB.isGrouped(r[e]) && o("tracegroupgap"), o("entrywidth"), o("entrywidthmode"), o("indentation"), o("itemsizing"), o("itemwidth"), o("itemclick"), o("itemdoubleclick"), o("groupclick"), o("xanchor", V), o("yanchor", q), o("valign"), Kp.noneOrAll(i, a, [
                            "x",
                            "y"
                        ]);
                        var H = o("title.text");
                        if (H) {
                            o("title.side", M ? "left" : "top");
                            var X = Kp.extendFlat({}, s, {
                                size: Kp.bigFont(s.size)
                            });
                            Kp.coerceFont(o, "title.font", X);
                        }
                    }
                }
            }
            Gse.exports = function(t, r, n) {
                var i, a = n.slice(), o = r.shapes;
                if (o) for(i = 0; i < o.length; i++){
                    var s = o[i];
                    if (s.showlegend) {
                        var l = {
                            _input: s._input,
                            visible: s.visible,
                            showlegend: s.showlegend,
                            legend: s.legend
                        };
                        a.push(l);
                    }
                }
                var u = [
                    "legend"
                ];
                for(i = 0; i < a.length; i++)Kp.pushUnique(u, a[i].legend);
                for(r._legends = [], i = 0; i < u.length; i++){
                    var c = u[i];
                    vst(c, t, r, a), r[c] && r[c].visible && (r[c]._id = c), r._legends.push(c);
                }
            };
        });
        var Wse = ye((Orr, jse)=>{
            "use strict";
            var D3 = ba(), TB = Mr(), pst = TB.pushUnique, wB = !0;
            jse.exports = function(t, r, n) {
                var i = r._fullLayout;
                if (r._dragged || r._editing) return;
                var a = i.legend.itemclick, o = i.legend.itemdoubleclick, s = i.legend.groupclick;
                n === 1 && a === "toggle" && o === "toggleothers" && wB && r.data && r._context.showTips && TB.notifier(TB._(r, "Double-click on legend to isolate one trace"), "long"), wB = !1;
                var l;
                if (n === 1 ? l = a : n === 2 && (l = o), !l) return;
                var u = s === "togglegroup", c = i.hiddenlabels ? i.hiddenlabels.slice() : [], f = t.data()[0][0];
                if (f.groupTitle && f.noClick) return;
                var h = r._fullData, d = (i.shapes || []).filter(function(Rt) {
                    return Rt.showlegend;
                }), v = h.concat(d), x = f.trace;
                x._isShape && (x = x._fullInput);
                var b = x.legendgroup, p, E, k, A, L, _, C = {}, M = [], g = [], P = [];
                function T(Rt, kt) {
                    var Ct = M.indexOf(Rt), Yt = C.visible;
                    return Yt || (Yt = C.visible = []), M.indexOf(Rt) === -1 && (M.push(Rt), Ct = M.length - 1), Yt[Ct] = kt, Ct;
                }
                var F = (i.shapes || []).map(function(Rt) {
                    return Rt._input;
                }), q = !1;
                function V(Rt, kt) {
                    F[Rt].visible = kt, q = !0;
                }
                function H(Rt, kt) {
                    if (!(f.groupTitle && !u)) {
                        var Ct = Rt._fullInput || Rt, Yt = Ct._isShape, xr = Ct.index;
                        xr === void 0 && (xr = Ct._index);
                        var er = Ct.visible === !1 ? !1 : kt;
                        Yt ? V(xr, er) : T(xr, er);
                    }
                }
                var X = x.legend, G = x._fullInput, N = G && G._isShape;
                if (!N && D3.traceIs(x, "pie-like")) {
                    var W = f.label, re = c.indexOf(W);
                    if (l === "toggle") re === -1 ? c.push(W) : c.splice(re, 1);
                    else if (l === "toggleothers") {
                        var ae = re !== -1, _e = [];
                        for(p = 0; p < r.calcdata.length; p++){
                            var Me = r.calcdata[p];
                            for(E = 0; E < Me.length; E++){
                                var ke = Me[E], ge = ke.label;
                                X === Me[0].trace.legend && W !== ge && (c.indexOf(ge) === -1 && (ae = !0), pst(c, ge), _e.push(ge));
                            }
                        }
                        if (!ae) for(var ie = 0; ie < _e.length; ie++){
                            var Te = c.indexOf(_e[ie]);
                            Te !== -1 && c.splice(Te, 1);
                        }
                    }
                    D3.call("_guiRelayout", r, "hiddenlabels", c);
                } else {
                    var Ee = b && b.length, Ae = [], ze;
                    if (Ee) for(p = 0; p < v.length; p++)ze = v[p], ze.visible && ze.legendgroup === b && Ae.push(p);
                    if (l === "toggle") {
                        var Ce;
                        switch(x.visible){
                            case !0:
                                Ce = "legendonly";
                                break;
                            case !1:
                                Ce = !1;
                                break;
                            case "legendonly":
                                Ce = !0;
                                break;
                        }
                        if (Ee) {
                            if (u) for(p = 0; p < v.length; p++){
                                var me = v[p];
                                me.visible !== !1 && me.legendgroup === b && H(me, Ce);
                            }
                            else H(x, Ce);
                        } else H(x, Ce);
                    } else if (l === "toggleothers") {
                        var Re, ce, Ge, nt, ct, qt = !0;
                        for(p = 0; p < v.length; p++)if (ct = v[p], Re = ct === x, Ge = ct.showlegend !== !0, !(Re || Ge) && (ce = Ee && ct.legendgroup === b, !ce && ct.legend === X && ct.visible === !0 && !D3.traceIs(ct, "notLegendIsolatable"))) {
                            qt = !1;
                            break;
                        }
                        for(p = 0; p < v.length; p++)if (ct = v[p], !(ct.visible === !1 || ct.legend !== X) && !D3.traceIs(ct, "notLegendIsolatable")) switch(x.visible){
                            case "legendonly":
                                H(ct, !0);
                                break;
                            case !0:
                                nt = qt ? !0 : "legendonly", Re = ct === x, Ge = ct.showlegend !== !0 && !ct.legendgroup, ce = Re || Ee && ct.legendgroup === b, H(ct, ce || Ge ? !0 : nt);
                                break;
                        }
                    }
                    for(p = 0; p < g.length; p++)if (k = g[p], !!k) {
                        var rt = k.constructUpdate(), ot = Object.keys(rt);
                        for(E = 0; E < ot.length; E++)A = ot[E], _ = C[A] = C[A] || [], _[P[p]] = rt[A];
                    }
                    for(L = Object.keys(C), p = 0; p < L.length; p++)for(A = L[p], E = 0; E < M.length; E++)C[A].hasOwnProperty(E) || (C[A][E] = void 0);
                    q ? D3.call("_guiUpdate", r, C, {
                        shapes: F
                    }, M) : D3.call("_guiRestyle", r, C, M);
                }
            };
        });
        var AB = ye((Brr, Zse)=>{
            "use strict";
            Zse.exports = {
                scrollBarWidth: 6,
                scrollBarMinHeight: 20,
                scrollBarColor: "#808BA4",
                scrollBarMargin: 4,
                scrollBarEnterAttrs: {
                    rx: 20,
                    ry: 3,
                    width: 0,
                    height: 0
                },
                titlePad: 2,
                itemGap: 5
            };
        });
        var Kse = ye((Nrr, Yse)=>{
            "use strict";
            var Xse = ba(), SB = LL();
            Yse.exports = function(t, r, n) {
                var i = r._inHover, a = SB.isGrouped(r), o = SB.isReversed(r), s = {}, l = [], u = !1, c = {}, f = 0, h = 0, d, v;
                function x(G, N, W) {
                    if (r.visible !== !1 && !(n && G !== r._id)) {
                        if (N === "" || !SB.isGrouped(r)) {
                            var re = "~~i" + f;
                            l.push(re), s[re] = [
                                W
                            ], f++;
                        } else l.indexOf(N) === -1 ? (l.push(N), u = !0, s[N] = [
                            W
                        ]) : s[N].push(W);
                    }
                }
                for(d = 0; d < t.length; d++){
                    var b = t[d], p = b[0], E = p.trace, k = E.legend, A = E.legendgroup;
                    if (!(!i && (!E.visible || !E.showlegend))) {
                        if (Xse.traceIs(E, "pie-like")) for(c[A] || (c[A] = {}), v = 0; v < b.length; v++){
                            var L = b[v].label;
                            c[A][L] || (x(k, A, {
                                label: L,
                                color: b[v].color,
                                i: b[v].i,
                                trace: E,
                                pts: b[v].pts
                            }), c[A][L] = !0, h = Math.max(h, (L || "").length));
                        }
                        else x(k, A, p), h = Math.max(h, (E.name || "").length);
                    }
                }
                if (!l.length) return [];
                var _ = !u || !a, C = [];
                for(d = 0; d < l.length; d++){
                    var M = s[l[d]];
                    _ ? C.push(M[0]) : C.push(M);
                }
                for(_ && (C = [
                    C
                ]), d = 0; d < C.length; d++){
                    var g = 1 / 0;
                    for(v = 0; v < C[d].length; v++){
                        var P = C[d][v].trace.legendrank;
                        g > P && (g = P);
                    }
                    C[d][0]._groupMinRank = g, C[d][0]._preGroupSort = d;
                }
                var T = function(G, N) {
                    return G[0]._groupMinRank - N[0]._groupMinRank || G[0]._preGroupSort - N[0]._preGroupSort;
                }, F = function(G, N) {
                    return G.trace.legendrank - N.trace.legendrank || G._preSort - N._preSort;
                };
                for(C.forEach(function(G, N) {
                    G[0]._preGroupSort = N;
                }), C.sort(T), d = 0; d < C.length; d++){
                    C[d].forEach(function(G, N) {
                        G._preSort = N;
                    }), C[d].sort(F);
                    var q = C[d][0].trace, V = null;
                    for(v = 0; v < C[d].length; v++){
                        var H = C[d][v].trace.legendgrouptitle;
                        if (H && H.text) {
                            V = H, i && (H.font = r._groupTitleFont);
                            break;
                        }
                    }
                    if (o && C[d].reverse(), V) {
                        var X = !1;
                        for(v = 0; v < C[d].length; v++)if (Xse.traceIs(C[d][v].trace, "pie-like")) {
                            X = !0;
                            break;
                        }
                        C[d].unshift({
                            i: -1,
                            groupTitle: V,
                            noClick: X,
                            trace: {
                                showlegend: q.showlegend,
                                legendgroup: q.legendgroup,
                                visible: r.groupclick === "toggleitem" ? !0 : q.visible
                            }
                        });
                    }
                    for(v = 0; v < C[d].length; v++)C[d][v] = [
                        C[d][v]
                    ];
                }
                return r._lgroupsLength = C.length, r._maxNameLength = h, C;
            };
        });
        var u_ = ye((Pb)=>{
            "use strict";
            var PL = Mr();
            function Jse(e) {
                return e.indexOf("e") !== -1 ? e.replace(/[.]?0+e/, "e") : e.indexOf(".") !== -1 ? e.replace(/[.]?0+$/, "") : e;
            }
            Pb.formatPiePercent = function(t, r) {
                var n = Jse((t * 100).toPrecision(3));
                return PL.numSeparate(n, r) + "%";
            };
            Pb.formatPieValue = function(t, r) {
                var n = Jse(t.toPrecision(10));
                return PL.numSeparate(n, r);
            };
            Pb.getFirstFilled = function(t, r) {
                if (PL.isArrayOrTypedArray(t)) for(var n = 0; n < r.length; n++){
                    var i = t[r[n]];
                    if (i || i === 0 || i === "") return i;
                }
            };
            Pb.castOption = function(t, r) {
                if (PL.isArrayOrTypedArray(t)) return Pb.getFirstFilled(t, r);
                if (t) return t;
            };
            Pb.getRotationAngle = function(e) {
                return (e === "auto" ? 0 : e) * Math.PI / 180;
            };
        });
        var Qse = ye((Vrr, $se)=>{
            "use strict";
            var gst = ao(), mst = va();
            $se.exports = function(t, r, n, i) {
                var a = n.marker.pattern;
                a && a.shape ? gst.pointStyle(t, n, i, r) : mst.fill(t, r.color);
            };
        });
        var z3 = ye((Hrr, rle)=>{
            "use strict";
            var ele = va(), tle = u_().castOption, yst = Qse();
            rle.exports = function(t, r, n, i) {
                var a = n.marker.line, o = tle(a.color, r.pts) || ele.defaultLine, s = tle(a.width, r.pts) || 0;
                t.call(yst, r, n, i).style("stroke-width", s).call(ele.stroke, o);
            };
        });
        var CB = ye((Grr, lle)=>{
            "use strict";
            var qv = xa(), MB = ba(), mv = Mr(), ile = mv.strTranslate, ip = ao(), T0 = va(), EB = Dv().extractOpts, IL = lu(), _st = z3(), xst = u_().castOption, bst = AB(), nle = 12, ale = 5, Ib = 2, wst = 10, F3 = 5;
            lle.exports = function(t, r, n) {
                var i = r._fullLayout;
                n || (n = i.legend);
                var a = n.itemsizing === "constant", o = n.itemwidth, s = (o + bst.itemGap * 2) / 2, l = ile(s, 0), u = function(C, M, g, P) {
                    var T;
                    if (C + 1) T = C;
                    else if (M && M.width > 0) T = M.width;
                    else return 0;
                    return a ? P : Math.min(T, g);
                };
                t.each(function(C) {
                    var M = qv.select(this), g = mv.ensureSingle(M, "g", "layers");
                    g.style("opacity", C[0].trace.opacity);
                    var P = n.indentation, T = n.valign, F = C[0].lineHeight, q = C[0].height;
                    if (T === "middle" && P === 0 || !F || !q) g.attr("transform", null);
                    else {
                        var V = {
                            top: 1,
                            bottom: -1
                        }[T], H = V * (.5 * (F - q + 3)) || 0, X = n.indentation;
                        g.attr("transform", ile(X, H));
                    }
                    var G = g.selectAll("g.legendfill").data([
                        C
                    ]);
                    G.enter().append("g").classed("legendfill", !0);
                    var N = g.selectAll("g.legendlines").data([
                        C
                    ]);
                    N.enter().append("g").classed("legendlines", !0);
                    var W = g.selectAll("g.legendsymbols").data([
                        C
                    ]);
                    W.enter().append("g").classed("legendsymbols", !0), W.selectAll("g.legendpoints").data([
                        C
                    ]).enter().append("g").classed("legendpoints", !0);
                }).each(_).each(h).each(v).each(d).each(b).each(A).each(k).each(c).each(f).each(p).each(E);
                function c(C) {
                    var M = ole(C), g = M.showFill, P = M.showLine, T = M.showGradientLine, F = M.showGradientFill, q = M.anyFill, V = M.anyLine, H = C[0], X = H.trace, G, N, W = EB(X), re = W.colorscale, ae = W.reversescale, _e = function(Ae) {
                        if (Ae.size()) {
                            if (g) ip.fillGroupStyle(Ae, r, !0);
                            else {
                                var ze = "legendfill-" + X.uid;
                                ip.gradient(Ae, r, ze, kB(ae), re, "fill");
                            }
                        }
                    }, Me = function(Ae) {
                        if (Ae.size()) {
                            var ze = "legendline-" + X.uid;
                            ip.lineGroupStyle(Ae), ip.gradient(Ae, r, ze, kB(ae), re, "stroke");
                        }
                    }, ke = IL.hasMarkers(X) || !q ? "M5,0" : V ? "M5,-2" : "M5,-3", ge = qv.select(this), ie = ge.select(".legendfill").selectAll("path").data(g || F ? [
                        C
                    ] : []);
                    if (ie.enter().append("path").classed("js-fill", !0), ie.exit().remove(), ie.attr("d", ke + "h" + o + "v6h-" + o + "z").call(_e), P || T) {
                        var Te = u(void 0, X.line, wst, ale);
                        N = mv.minExtend(X, {
                            line: {
                                width: Te
                            }
                        }), G = [
                            mv.minExtend(H, {
                                trace: N
                            })
                        ];
                    }
                    var Ee = ge.select(".legendlines").selectAll("path").data(P || T ? [
                        G
                    ] : []);
                    Ee.enter().append("path").classed("js-line", !0), Ee.exit().remove(), Ee.attr("d", ke + (T ? "l" + o + ",0.0001" : "h" + o)).call(P ? ip.lineGroupStyle : Me);
                }
                function f(C) {
                    var M = ole(C), g = M.anyFill, P = M.anyLine, T = M.showLine, F = M.showMarker, q = C[0], V = q.trace, H = !F && !P && !g && IL.hasText(V), X, G;
                    function N(ie, Te, Ee, Ae) {
                        var ze = mv.nestedProperty(V, ie).get(), Ce = mv.isArrayOrTypedArray(ze) && Te ? Te(ze) : ze;
                        if (a && Ce && Ae !== void 0 && (Ce = Ae), Ee) {
                            if (Ce < Ee[0]) return Ee[0];
                            if (Ce > Ee[1]) return Ee[1];
                        }
                        return Ce;
                    }
                    function W(ie) {
                        return q._distinct && q.index && ie[q.index] ? ie[q.index] : ie[0];
                    }
                    if (F || H || T) {
                        var re = {}, ae = {};
                        if (F) {
                            re.mc = N("marker.color", W), re.mx = N("marker.symbol", W), re.mo = N("marker.opacity", mv.mean, [
                                .2,
                                1
                            ]), re.mlc = N("marker.line.color", W), re.mlw = N("marker.line.width", mv.mean, [
                                0,
                                5
                            ], Ib), ae.marker = {
                                sizeref: 1,
                                sizemin: 1,
                                sizemode: "diameter"
                            };
                            var _e = N("marker.size", mv.mean, [
                                2,
                                16
                            ], nle);
                            re.ms = _e, ae.marker.size = _e;
                        }
                        T && (ae.line = {
                            width: N("line.width", W, [
                                0,
                                10
                            ], ale)
                        }), H && (re.tx = "Aa", re.tp = N("textposition", W), re.ts = 10, re.tc = N("textfont.color", W), re.tf = N("textfont.family", W), re.tw = N("textfont.weight", W), re.ty = N("textfont.style", W), re.tv = N("textfont.variant", W), re.tC = N("textfont.textcase", W), re.tE = N("textfont.lineposition", W), re.tS = N("textfont.shadow", W)), X = [
                            mv.minExtend(q, re)
                        ], G = mv.minExtend(V, ae), G.selectedpoints = null, G.texttemplate = null;
                    }
                    var Me = qv.select(this).select("g.legendpoints"), ke = Me.selectAll("path.scatterpts").data(F ? X : []);
                    ke.enter().insert("path", ":first-child").classed("scatterpts", !0).attr("transform", l), ke.exit().remove(), ke.call(ip.pointStyle, G, r), F && (X[0].mrc = 3);
                    var ge = Me.selectAll("g.pointtext").data(H ? X : []);
                    ge.enter().append("g").classed("pointtext", !0).append("text").attr("transform", l), ge.exit().remove(), ge.selectAll("text").call(ip.textPointStyle, G, r);
                }
                function h(C) {
                    var M = C[0].trace, g = M.type === "waterfall";
                    if (C[0]._distinct && g) {
                        var P = C[0].trace[C[0].dir].marker;
                        return C[0].mc = P.color, C[0].mlw = P.line.width, C[0].mlc = P.line.color, x(C, this, "waterfall");
                    }
                    var T = [];
                    M.visible && g && (T = C[0].hasTotals ? [
                        [
                            "increasing",
                            "M-6,-6V6H0Z"
                        ],
                        [
                            "totals",
                            "M6,6H0L-6,-6H-0Z"
                        ],
                        [
                            "decreasing",
                            "M6,6V-6H0Z"
                        ]
                    ] : [
                        [
                            "increasing",
                            "M-6,-6V6H6Z"
                        ],
                        [
                            "decreasing",
                            "M6,6V-6H-6Z"
                        ]
                    ]);
                    var F = qv.select(this).select("g.legendpoints").selectAll("path.legendwaterfall").data(T);
                    F.enter().append("path").classed("legendwaterfall", !0).attr("transform", l).style("stroke-miterlimit", 1), F.exit().remove(), F.each(function(q) {
                        var V = qv.select(this), H = M[q[0]].marker, X = u(void 0, H.line, F3, Ib);
                        V.attr("d", q[1]).style("stroke-width", X + "px").call(T0.fill, H.color), X && V.call(T0.stroke, H.line.color);
                    });
                }
                function d(C) {
                    x(C, this);
                }
                function v(C) {
                    x(C, this, "funnel");
                }
                function x(C, M, g) {
                    var P = C[0].trace, T = P.marker || {}, F = T.line || {}, q = T.cornerradius ? "M6,3a3,3,0,0,1-3,3H-3a3,3,0,0,1-3-3V-3a3,3,0,0,1,3-3H3a3,3,0,0,1,3,3Z" : "M6,6H-6V-6H6Z", V = g ? P.visible && P.type === g : MB.traceIs(P, "bar"), H = qv.select(M).select("g.legendpoints").selectAll("path.legend" + g).data(V ? [
                        C
                    ] : []);
                    H.enter().append("path").classed("legend" + g, !0).attr("d", q).attr("transform", l), H.exit().remove(), H.each(function(X) {
                        var G = qv.select(this), N = X[0], W = u(N.mlw, T.line, F3, Ib);
                        G.style("stroke-width", W + "px");
                        var re = N.mcc;
                        if (!n._inHover && "mc" in N) {
                            var ae = EB(T), _e = ae.mid;
                            _e === void 0 && (_e = (ae.max + ae.min) / 2), re = ip.tryColorscale(T, "")(_e);
                        }
                        var Me = re || N.mc || T.color, ke = T.pattern, ge = ke && ip.getPatternAttr(ke.shape, 0, "");
                        if (ge) {
                            var ie = ip.getPatternAttr(ke.bgcolor, 0, null), Te = ip.getPatternAttr(ke.fgcolor, 0, null), Ee = ke.fgopacity, Ae = sle(ke.size, 8, 10), ze = sle(ke.solidity, .5, 1), Ce = "legend-" + P.uid;
                            G.call(ip.pattern, "legend", r, Ce, ge, Ae, ze, re, ke.fillmode, ie, Te, Ee);
                        } else G.call(T0.fill, Me);
                        W && T0.stroke(G, N.mlc || F.color);
                    });
                }
                function b(C) {
                    var M = C[0].trace, g = qv.select(this).select("g.legendpoints").selectAll("path.legendbox").data(M.visible && MB.traceIs(M, "box-violin") ? [
                        C
                    ] : []);
                    g.enter().append("path").classed("legendbox", !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", l), g.exit().remove(), g.each(function() {
                        var P = qv.select(this);
                        if ((M.boxpoints === "all" || M.points === "all") && T0.opacity(M.fillcolor) === 0 && T0.opacity((M.line || {}).color) === 0) {
                            var T = mv.minExtend(M, {
                                marker: {
                                    size: a ? nle : mv.constrain(M.marker.size, 2, 16),
                                    sizeref: 1,
                                    sizemin: 1,
                                    sizemode: "diameter"
                                }
                            });
                            g.call(ip.pointStyle, T, r);
                        } else {
                            var F = u(void 0, M.line, F3, Ib);
                            P.style("stroke-width", F + "px").call(T0.fill, M.fillcolor), F && T0.stroke(P, M.line.color);
                        }
                    });
                }
                function p(C) {
                    var M = C[0].trace, g = qv.select(this).select("g.legendpoints").selectAll("path.legendcandle").data(M.visible && M.type === "candlestick" ? [
                        C,
                        C
                    ] : []);
                    g.enter().append("path").classed("legendcandle", !0).attr("d", function(P, T) {
                        return T ? "M-15,0H-8M-8,6V-6H8Z" : "M15,0H8M8,-6V6H-8Z";
                    }).attr("transform", l).style("stroke-miterlimit", 1), g.exit().remove(), g.each(function(P, T) {
                        var F = qv.select(this), q = M[T ? "increasing" : "decreasing"], V = u(void 0, q.line, F3, Ib);
                        F.style("stroke-width", V + "px").call(T0.fill, q.fillcolor), V && T0.stroke(F, q.line.color);
                    });
                }
                function E(C) {
                    var M = C[0].trace, g = qv.select(this).select("g.legendpoints").selectAll("path.legendohlc").data(M.visible && M.type === "ohlc" ? [
                        C,
                        C
                    ] : []);
                    g.enter().append("path").classed("legendohlc", !0).attr("d", function(P, T) {
                        return T ? "M-15,0H0M-8,-6V0" : "M15,0H0M8,6V0";
                    }).attr("transform", l).style("stroke-miterlimit", 1), g.exit().remove(), g.each(function(P, T) {
                        var F = qv.select(this), q = M[T ? "increasing" : "decreasing"], V = u(void 0, q.line, F3, Ib);
                        F.style("fill", "none").call(ip.dashLine, q.line.dash, V), V && T0.stroke(F, q.line.color);
                    });
                }
                function k(C) {
                    L(C, this, "pie");
                }
                function A(C) {
                    L(C, this, "funnelarea");
                }
                function L(C, M, g) {
                    var P = C[0], T = P.trace, F = g ? T.visible && T.type === g : MB.traceIs(T, g), q = qv.select(M).select("g.legendpoints").selectAll("path.legend" + g).data(F ? [
                        C
                    ] : []);
                    if (q.enter().append("path").classed("legend" + g, !0).attr("d", "M6,6H-6V-6H6Z").attr("transform", l), q.exit().remove(), q.size()) {
                        var V = T.marker || {}, H = u(xst(V.line.width, P.pts), V.line, F3, Ib), X = "pieLike", G = mv.minExtend(T, {
                            marker: {
                                line: {
                                    width: H
                                }
                            }
                        }, X), N = mv.minExtend(P, {
                            trace: G
                        }, X);
                        _st(q, N, G, r);
                    }
                }
                function _(C) {
                    var M = C[0].trace, g, P = [];
                    if (M.visible) switch(M.type){
                        case "histogram2d":
                        case "heatmap":
                            P = [
                                [
                                    "M-15,-2V4H15V-2Z"
                                ]
                            ], g = !0;
                            break;
                        case "choropleth":
                        case "choroplethmapbox":
                        case "choroplethmap":
                            P = [
                                [
                                    "M-6,-6V6H6V-6Z"
                                ]
                            ], g = !0;
                            break;
                        case "densitymapbox":
                        case "densitymap":
                            P = [
                                [
                                    "M-6,0 a6,6 0 1,0 12,0 a 6,6 0 1,0 -12,0"
                                ]
                            ], g = "radial";
                            break;
                        case "cone":
                            P = [
                                [
                                    "M-6,2 A2,2 0 0,0 -6,6 V6L6,4Z"
                                ],
                                [
                                    "M-6,-6 A2,2 0 0,0 -6,-2 L6,-4Z"
                                ],
                                [
                                    "M-6,-2 A2,2 0 0,0 -6,2 L6,0Z"
                                ]
                            ], g = !1;
                            break;
                        case "streamtube":
                            P = [
                                [
                                    "M-6,2 A2,2 0 0,0 -6,6 H6 A2,2 0 0,1 6,2 Z"
                                ],
                                [
                                    "M-6,-6 A2,2 0 0,0 -6,-2 H6 A2,2 0 0,1 6,-6 Z"
                                ],
                                [
                                    "M-6,-2 A2,2 0 0,0 -6,2 H6 A2,2 0 0,1 6,-2 Z"
                                ]
                            ], g = !1;
                            break;
                        case "surface":
                            P = [
                                [
                                    "M-6,-6 A2,3 0 0,0 -6,0 H6 A2,3 0 0,1 6,-6 Z"
                                ],
                                [
                                    "M-6,1 A2,3 0 0,1 -6,6 H6 A2,3 0 0,0 6,0 Z"
                                ]
                            ], g = !0;
                            break;
                        case "mesh3d":
                            P = [
                                [
                                    "M-6,6H0L-6,-6Z"
                                ],
                                [
                                    "M6,6H0L6,-6Z"
                                ],
                                [
                                    "M-6,-6H6L0,6Z"
                                ]
                            ], g = !1;
                            break;
                        case "volume":
                            P = [
                                [
                                    "M-6,6H0L-6,-6Z"
                                ],
                                [
                                    "M6,6H0L6,-6Z"
                                ],
                                [
                                    "M-6,-6H6L0,6Z"
                                ]
                            ], g = !0;
                            break;
                        case "isosurface":
                            P = [
                                [
                                    "M-6,6H0L-6,-6Z"
                                ],
                                [
                                    "M6,6H0L6,-6Z"
                                ],
                                [
                                    "M-6,-6 A12,24 0 0,0 6,-6 L0,6Z"
                                ]
                            ], g = !1;
                            break;
                    }
                    var T = qv.select(this).select("g.legendpoints").selectAll("path.legend3dandfriends").data(P);
                    T.enter().append("path").classed("legend3dandfriends", !0).attr("transform", l).style("stroke-miterlimit", 1), T.exit().remove(), T.each(function(F, q) {
                        var V = qv.select(this), H = EB(M), X = H.colorscale, G = H.reversescale, N = function(_e) {
                            if (_e.size()) {
                                var Me = "legendfill-" + M.uid;
                                ip.gradient(_e, r, Me, kB(G, g === "radial"), X, "fill");
                            }
                        }, W;
                        if (X) {
                            if (!g) {
                                var ae = X.length;
                                W = q === 0 ? X[G ? ae - 1 : 0][1] : q === 1 ? X[G ? 0 : ae - 1][1] : X[Math.floor((ae - 1) / 2)][1];
                            }
                        } else {
                            var re = M.vertexcolor || M.facecolor || M.color;
                            W = mv.isArrayOrTypedArray(re) ? re[q] || re[0] : re;
                        }
                        V.attr("d", F[0]), W ? V.call(T0.fill, W) : V.call(N);
                    });
                }
            };
            function kB(e, t) {
                var r = t ? "radial" : "horizontal";
                return r + (e ? "" : "reversed");
            }
            function ole(e) {
                var t = e[0].trace, r = t.contours, n = IL.hasLines(t), i = IL.hasMarkers(t), a = t.visible && t.fill && t.fill !== "none", o = !1, s = !1;
                if (r) {
                    var l = r.coloring;
                    l === "lines" ? o = !0 : n = l === "none" || l === "heatmap" || r.showlines, r.type === "constraint" ? a = r._operation !== "=" : (l === "fill" || l === "heatmap") && (s = !0);
                }
                return {
                    showMarker: i,
                    showLine: n,
                    showFill: a,
                    showGradientLine: o,
                    showGradientFill: s,
                    anyLine: n || o,
                    anyFill: a || s
                };
            }
            function sle(e, t, r) {
                return e && mv.isArrayOrTypedArray(e) ? t : e > r ? r : e;
            }
        });
        var RB = ye((jrr, yle)=>{
            "use strict";
            var Sp = xa(), gh = Mr(), PB = Xu(), B3 = ba(), ule = g3(), LB = gv(), mh = ao(), DL = va(), Rb = Pl(), cle = Wse(), Vh = AB(), IB = Nh(), gle = IB.LINE_SPACING, O3 = IB.FROM_TL, fle = IB.FROM_BR, hle = Kse(), Tst = CB(), dle = LL(), q3 = 1, Ast = /^legend[0-9]*$/;
            yle.exports = function(t, r) {
                if (r) vle(t, r);
                else {
                    var n = t._fullLayout, i = n._legends, a = n._infolayer.selectAll('[class^="legend"]');
                    a.each(function() {
                        var u = Sp.select(this), c = u.attr("class"), f = c.split(" ")[0];
                        f.match(Ast) && i.indexOf(f) === -1 && u.remove();
                    });
                    for(var o = 0; o < i.length; o++){
                        var s = i[o], l = t._fullLayout[s];
                        vle(t, l);
                    }
                }
            };
            function Sst(e, t, r) {
                if (!(t.title.side !== "top center" && t.title.side !== "top right")) {
                    var n = t.title.font, i = n.size * gle, a = 0, o = e.node(), s = mh.bBox(o).width;
                    t.title.side === "top center" ? a = .5 * (t._width - 2 * r - 2 * Vh.titlePad - s) : t.title.side === "top right" && (a = t._width - 2 * r - 2 * Vh.titlePad - s), Rb.positionText(e, r + Vh.titlePad + a, r + i);
                }
            }
            function vle(e, t) {
                var r = t || {}, n = e._fullLayout, i = OL(r), a, o, s = r._inHover;
                if (s ? (o = r.layer, a = "hover") : (o = n._infolayer, a = i), !!o) {
                    a += n._uid, e._legendMouseDownTime || (e._legendMouseDownTime = 0);
                    var l;
                    if (s) {
                        if (!r.entries) return;
                        l = hle(r.entries, r);
                    } else {
                        for(var u = (e.calcdata || []).slice(), c = n.shapes, f = 0; f < c.length; f++){
                            var h = c[f];
                            if (h.showlegend) {
                                var d = {
                                    _isShape: !0,
                                    _fullInput: h,
                                    index: h._index,
                                    name: h.name || h.label.text || "shape " + h._index,
                                    legend: h.legend,
                                    legendgroup: h.legendgroup,
                                    legendgrouptitle: h.legendgrouptitle,
                                    legendrank: h.legendrank,
                                    legendwidth: h.legendwidth,
                                    showlegend: h.showlegend,
                                    visible: h.visible,
                                    opacity: h.opacity,
                                    mode: h.type === "line" ? "lines" : "markers",
                                    line: h.line,
                                    marker: {
                                        line: h.line,
                                        color: h.fillcolor,
                                        size: 12,
                                        symbol: h.type === "rect" ? "square" : h.type === "circle" ? "circle" : "hexagon2"
                                    }
                                };
                                u.push([
                                    {
                                        trace: d
                                    }
                                ]);
                            }
                        }
                        l = n.showlegend && hle(u, r, n._legends.length > 1);
                    }
                    var v = n.hiddenlabels || [];
                    if (!s && (!n.showlegend || !l.length)) return o.selectAll("." + i).remove(), n._topdefs.select("#" + a).remove(), PB.autoMargin(e, i);
                    var x = gh.ensureSingle(o, "g", i, function(M) {
                        s || M.attr("pointer-events", "all");
                    }), b = gh.ensureSingleById(n._topdefs, "clipPath", a, function(M) {
                        M.append("rect");
                    }), p = gh.ensureSingle(x, "rect", "bg", function(M) {
                        M.attr("shape-rendering", "crispEdges");
                    });
                    p.call(DL.stroke, r.bordercolor).call(DL.fill, r.bgcolor).style("stroke-width", r.borderwidth + "px");
                    var E = gh.ensureSingle(x, "g", "scrollbox"), k = r.title;
                    r._titleWidth = 0, r._titleHeight = 0;
                    var A;
                    k.text ? (A = gh.ensureSingle(E, "text", i + "titletext"), A.attr("text-anchor", "start").call(mh.font, k.font).text(k.text), zL(A, E, e, r, q3)) : E.selectAll("." + i + "titletext").remove();
                    var L = gh.ensureSingle(x, "rect", "scrollbar", function(M) {
                        M.attr(Vh.scrollBarEnterAttrs).call(DL.fill, Vh.scrollBarColor);
                    }), _ = E.selectAll("g.groups").data(l);
                    _.enter().append("g").attr("class", "groups"), _.exit().remove();
                    var C = _.selectAll("g.traces").data(gh.identity);
                    C.enter().append("g").attr("class", "traces"), C.exit().remove(), C.style("opacity", function(M) {
                        var g = M[0].trace;
                        return B3.traceIs(g, "pie-like") ? v.indexOf(M[0].label) !== -1 ? .5 : 1 : g.visible === "legendonly" ? .5 : 1;
                    }).each(function() {
                        Sp.select(this).call(Mst, e, r);
                    }).call(Tst, e, r).each(function() {
                        s || Sp.select(this).call(Est, e, i);
                    }), gh.syncOrAsync([
                        PB.previousPromises,
                        function() {
                            return Lst(e, _, C, r);
                        },
                        function() {
                            var M = n._size, g = r.borderwidth, P = r.xref === "paper", T = r.yref === "paper";
                            if (k.text && Sst(A, r, g), !s) {
                                var F, q;
                                P ? F = M.l + M.w * r.x - O3[FL(r)] * r._width : F = n.width * r.x - O3[FL(r)] * r._width, T ? q = M.t + M.h * (1 - r.y) - O3[qL(r)] * r._effHeight : q = n.height * (1 - r.y) - O3[qL(r)] * r._effHeight;
                                var V = Pst(e, i, F, q);
                                if (V) return;
                                if (n.margin.autoexpand) {
                                    var H = F, X = q;
                                    F = P ? gh.constrain(F, 0, n.width - r._width) : H, q = T ? gh.constrain(q, 0, n.height - r._effHeight) : X, F !== H && gh.log("Constrain " + i + ".x to make legend fit inside graph"), q !== X && gh.log("Constrain " + i + ".y to make legend fit inside graph");
                                }
                                mh.setTranslate(x, F, q);
                            }
                            if (L.on(".drag", null), x.on("wheel", null), s || r._height <= r._maxHeight || e._context.staticPlot) {
                                var G = r._effHeight;
                                s && (G = r._height), p.attr({
                                    width: r._width - g,
                                    height: G - g,
                                    x: g / 2,
                                    y: g / 2
                                }), mh.setTranslate(E, 0, 0), b.select("rect").attr({
                                    width: r._width - 2 * g,
                                    height: G - 2 * g,
                                    x: g,
                                    y: g
                                }), mh.setClipUrl(E, a, e), mh.setRect(L, 0, 0, 0, 0), delete r._scrollY;
                            } else {
                                var N = Math.max(Vh.scrollBarMinHeight, r._effHeight * r._effHeight / r._height), W = r._effHeight - N - 2 * Vh.scrollBarMargin, re = r._height - r._effHeight, ae = W / re, _e = Math.min(r._scrollY || 0, re);
                                p.attr({
                                    width: r._width - 2 * g + Vh.scrollBarWidth + Vh.scrollBarMargin,
                                    height: r._effHeight - g,
                                    x: g / 2,
                                    y: g / 2
                                }), b.select("rect").attr({
                                    width: r._width - 2 * g + Vh.scrollBarWidth + Vh.scrollBarMargin,
                                    height: r._effHeight - 2 * g,
                                    x: g,
                                    y: g + _e
                                }), mh.setClipUrl(E, a, e), ze(_e, N, ae), x.on("wheel", function() {
                                    _e = gh.constrain(r._scrollY + Sp.event.deltaY / W * re, 0, re), ze(_e, N, ae), _e !== 0 && _e !== re && Sp.event.preventDefault();
                                });
                                var Me, ke, ge, ie = function(Ge, nt, ct) {
                                    var qt = (ct - nt) / ae + Ge;
                                    return gh.constrain(qt, 0, re);
                                }, Te = function(Ge, nt, ct) {
                                    var qt = (nt - ct) / ae + Ge;
                                    return gh.constrain(qt, 0, re);
                                }, Ee = Sp.behavior.drag().on("dragstart", function() {
                                    var Ge = Sp.event.sourceEvent;
                                    Ge.type === "touchstart" ? Me = Ge.changedTouches[0].clientY : Me = Ge.clientY, ge = _e;
                                }).on("drag", function() {
                                    var Ge = Sp.event.sourceEvent;
                                    Ge.buttons === 2 || Ge.ctrlKey || (Ge.type === "touchmove" ? ke = Ge.changedTouches[0].clientY : ke = Ge.clientY, _e = ie(ge, Me, ke), ze(_e, N, ae));
                                });
                                L.call(Ee);
                                var Ae = Sp.behavior.drag().on("dragstart", function() {
                                    var Ge = Sp.event.sourceEvent;
                                    Ge.type === "touchstart" && (Me = Ge.changedTouches[0].clientY, ge = _e);
                                }).on("drag", function() {
                                    var Ge = Sp.event.sourceEvent;
                                    Ge.type === "touchmove" && (ke = Ge.changedTouches[0].clientY, _e = Te(ge, Me, ke), ze(_e, N, ae));
                                });
                                E.call(Ae);
                            }
                            function ze(Ge, nt, ct) {
                                r._scrollY = e._fullLayout[i]._scrollY = Ge, mh.setTranslate(E, 0, -Ge), mh.setRect(L, r._width, Vh.scrollBarMargin + Ge * ct, Vh.scrollBarWidth, nt), b.select("rect").attr("y", g + Ge);
                            }
                            if (e._context.edits.legendPosition) {
                                var Ce, me, Re, ce;
                                x.classed("cursor-move", !0), LB.init({
                                    element: x.node(),
                                    gd: e,
                                    prepFn: function(Ge) {
                                        if (Ge.target !== L.node()) {
                                            var nt = mh.getTranslate(x);
                                            Re = nt.x, ce = nt.y;
                                        }
                                    },
                                    moveFn: function(Ge, nt) {
                                        if (Re !== void 0 && ce !== void 0) {
                                            var ct = Re + Ge, qt = ce + nt;
                                            mh.setTranslate(x, ct, qt), Ce = LB.align(ct, r._width, M.l, M.l + M.w, r.xanchor), me = LB.align(qt + r._height, -r._height, M.t + M.h, M.t, r.yanchor);
                                        }
                                    },
                                    doneFn: function() {
                                        if (Ce !== void 0 && me !== void 0) {
                                            var Ge = {};
                                            Ge[i + ".x"] = Ce, Ge[i + ".y"] = me, B3.call("_guiRelayout", e, Ge);
                                        }
                                    },
                                    clickFn: function(Ge, nt) {
                                        var ct = o.selectAll("g.traces").filter(function() {
                                            var qt = this.getBoundingClientRect();
                                            return nt.clientX >= qt.left && nt.clientX <= qt.right && nt.clientY >= qt.top && nt.clientY <= qt.bottom;
                                        });
                                        ct.size() > 0 && mle(e, x, ct, Ge, nt);
                                    }
                                });
                            }
                        }
                    ], e);
                }
            }
            function RL(e, t, r) {
                var n = e[0], i = n.width, a = t.entrywidthmode, o = n.trace.legendwidth || t.entrywidth;
                return a === "fraction" ? t._maxWidth * o : r + (o || i);
            }
            function mle(e, t, r, n, i) {
                var a = r.data()[0][0].trace, o = {
                    event: i,
                    node: r.node(),
                    curveNumber: a.index,
                    expandedIndex: a.index,
                    data: e.data,
                    layout: e.layout,
                    frames: e._transitionData._frames,
                    config: e._context,
                    fullData: e._fullData,
                    fullLayout: e._fullLayout
                };
                a._group && (o.group = a._group), B3.traceIs(a, "pie-like") && (o.label = r.datum()[0].label);
                var s = ule.triggerHandler(e, "plotly_legendclick", o);
                if (n === 1) {
                    if (s === !1) return;
                    t._clickTimeout = setTimeout(function() {
                        e._fullLayout && cle(r, e, n);
                    }, e._context.doubleClickDelay);
                } else if (n === 2) {
                    t._clickTimeout && clearTimeout(t._clickTimeout), e._legendMouseDownTime = 0;
                    var l = ule.triggerHandler(e, "plotly_legenddoubleclick", o);
                    l !== !1 && s !== !1 && cle(r, e, n);
                }
            }
            function Mst(e, t, r) {
                var n = OL(r), i = e.data()[0][0], a = i.trace, o = B3.traceIs(a, "pie-like"), s = !r._inHover && t._context.edits.legendText && !o, l = r._maxNameLength, u, c;
                i.groupTitle ? (u = i.groupTitle.text, c = i.groupTitle.font) : (c = r.font, r.entries ? u = i.text : (u = o ? i.label : a.name, a._meta && (u = gh.templateString(u, a._meta))));
                var f = gh.ensureSingle(e, "text", n + "text");
                f.attr("text-anchor", "start").call(mh.font, c).text(s ? ple(u, l) : u);
                var h = r.indentation + r.itemwidth + Vh.itemGap * 2;
                Rb.positionText(f, h, 0), s ? f.call(Rb.makeEditable, {
                    gd: t,
                    text: u
                }).call(zL, e, t, r).on("edit", function(d) {
                    this.text(ple(d, l)).call(zL, e, t, r);
                    var v = i.trace._fullInput || {}, x = {};
                    return x.name = d, v._isShape ? B3.call("_guiRelayout", t, "shapes[" + a.index + "].name", x.name) : B3.call("_guiRestyle", t, x, a.index);
                }) : zL(f, e, t, r);
            }
            function ple(e, t) {
                var r = Math.max(4, t);
                if (e && e.trim().length >= r / 2) return e;
                e = e || "";
                for(var n = r - e.length; n > 0; n--)e += " ";
                return e;
            }
            function Est(e, t, r) {
                var n = t._context.doubleClickDelay, i, a = 1, o = gh.ensureSingle(e, "rect", r + "toggle", function(s) {
                    t._context.staticPlot || s.style("cursor", "pointer").attr("pointer-events", "all"), s.call(DL.fill, "rgba(0,0,0,0)");
                });
                t._context.staticPlot || (o.on("mousedown", function() {
                    i = new Date().getTime(), i - t._legendMouseDownTime < n ? a += 1 : (a = 1, t._legendMouseDownTime = i);
                }), o.on("mouseup", function() {
                    if (!(t._dragged || t._editing)) {
                        var s = t._fullLayout[r];
                        new Date().getTime() - t._legendMouseDownTime > n && (a = Math.max(a - 1, 1)), mle(t, s, e, a, Sp.event);
                    }
                }));
            }
            function zL(e, t, r, n, i) {
                n._inHover && e.attr("data-notex", !0), Rb.convertToTspans(e, r, function() {
                    kst(t, r, n, i);
                });
            }
            function kst(e, t, r, n) {
                var i = e.data()[0][0];
                if (!r._inHover && i && !i.trace.showlegend) {
                    e.remove();
                    return;
                }
                var a = e.select("g[class*=math-group]"), o = a.node(), s = OL(r);
                r || (r = t._fullLayout[s]);
                var l = r.borderwidth, u;
                n === q3 ? u = r.title.font : i.groupTitle ? u = i.groupTitle.font : u = r.font;
                var c = u.size * gle, f, h;
                if (o) {
                    var d = mh.bBox(o);
                    f = d.height, h = d.width, n === q3 ? mh.setTranslate(a, l, l + f * .75) : mh.setTranslate(a, 0, f * .25);
                } else {
                    var v = "." + s + (n === q3 ? "title" : "") + "text", x = e.select(v), b = Rb.lineCount(x), p = x.node();
                    if (f = c * b, h = p ? mh.bBox(p).width : 0, n === q3) r.title.side === "left" && (h += Vh.itemGap * 2), Rb.positionText(x, l + Vh.titlePad, l + c);
                    else {
                        var E = Vh.itemGap * 2 + r.indentation + r.itemwidth;
                        i.groupTitle && (E = Vh.itemGap, h -= r.indentation + r.itemwidth), Rb.positionText(x, E, -c * ((b - 1) / 2 - .3));
                    }
                }
                n === q3 ? (r._titleWidth = h, r._titleHeight = f) : (i.lineHeight = c, i.height = Math.max(f, 16) + 3, i.width = h);
            }
            function Cst(e) {
                var t = 0, r = 0, n = e.title.side;
                return n && (n.indexOf("left") !== -1 && (t = e._titleWidth), n.indexOf("top") !== -1 && (r = e._titleHeight)), [
                    t,
                    r
                ];
            }
            function Lst(e, t, r, n) {
                var i = e._fullLayout, a = OL(n);
                n || (n = i[a]);
                var o = i._size, s = dle.isVertical(n), l = dle.isGrouped(n), u = n.entrywidthmode === "fraction", c = n.borderwidth, f = 2 * c, h = Vh.itemGap, d = n.indentation + n.itemwidth + h * 2, v = 2 * (c + h), x = qL(n), b = n.y < 0 || n.y === 0 && x === "top", p = n.y > 1 || n.y === 1 && x === "bottom", E = n.tracegroupgap, k = {};
                n._maxHeight = Math.max(b || p ? i.height / 2 : o.h, 30);
                var A = 0;
                n._width = 0, n._height = 0;
                var L = Cst(n);
                if (s) r.each(function(ge) {
                    var ie = ge[0].height;
                    mh.setTranslate(this, c + L[0], c + L[1] + n._height + ie / 2 + h), n._height += ie, n._width = Math.max(n._width, ge[0].width);
                }), A = d + n._width, n._width += h + d + f, n._height += v, l && (t.each(function(ge, ie) {
                    mh.setTranslate(this, 0, ie * n.tracegroupgap);
                }), n._height += (n._lgroupsLength - 1) * n.tracegroupgap);
                else {
                    var _ = FL(n), C = n.x < 0 || n.x === 0 && _ === "right", M = n.x > 1 || n.x === 1 && _ === "left", g = p || b, P = i.width / 2;
                    n._maxWidth = Math.max(C ? g && _ === "left" ? o.l + o.w : P : M ? g && _ === "right" ? o.r + o.w : P : o.w, 2 * d);
                    var T = 0, F = 0;
                    r.each(function(ge) {
                        var ie = RL(ge, n, d);
                        T = Math.max(T, ie), F += ie;
                    }), A = null;
                    var q = 0;
                    if (l) {
                        var V = 0, H = 0, X = 0;
                        t.each(function() {
                            var ge = 0, ie = 0;
                            Sp.select(this).selectAll("g.traces").each(function(Ee) {
                                var Ae = RL(Ee, n, d), ze = Ee[0].height;
                                mh.setTranslate(this, L[0], L[1] + c + h + ze / 2 + ie), ie += ze, ge = Math.max(ge, Ae), k[Ee[0].trace.legendgroup] = ge;
                            });
                            var Te = ge + h;
                            H > 0 && Te + c + H > n._maxWidth ? (q = Math.max(q, H), H = 0, X += V + E, V = ie) : V = Math.max(V, ie), mh.setTranslate(this, H, X), H += Te;
                        }), n._width = Math.max(q, H) + c, n._height = X + V + v;
                    } else {
                        var G = r.size(), N = F + f + (G - 1) * h < n._maxWidth, W = 0, re = 0, ae = 0, _e = 0;
                        r.each(function(ge) {
                            var ie = ge[0].height, Te = RL(ge, n, d, l), Ee = N ? Te : T;
                            u || (Ee += h), Ee + c + re - h >= n._maxWidth && (q = Math.max(q, _e), re = 0, ae += W, n._height += W, W = 0), mh.setTranslate(this, L[0] + c + re, L[1] + c + ae + ie / 2 + h), _e = re + Te + h, re += Ee, W = Math.max(W, ie);
                        }), N ? (n._width = re + f, n._height = W + v) : (n._width = Math.max(q, _e) + f, n._height += W + v);
                    }
                }
                n._width = Math.ceil(Math.max(n._width + L[0], n._titleWidth + 2 * (c + Vh.titlePad))), n._height = Math.ceil(Math.max(n._height + L[1], n._titleHeight + 2 * (c + Vh.itemGap))), n._effHeight = Math.min(n._height, n._maxHeight);
                var Me = e._context.edits, ke = Me.legendText || Me.legendPosition;
                r.each(function(ge) {
                    var ie = Sp.select(this).select("." + a + "toggle"), Te = ge[0].height, Ee = ge[0].trace.legendgroup, Ae = RL(ge, n, d);
                    l && Ee !== "" && (Ae = k[Ee]);
                    var ze = ke ? d : A || Ae;
                    !s && !u && (ze += h / 2), mh.setRect(ie, 0, -Te / 2, ze, Te);
                });
            }
            function Pst(e, t, r, n) {
                var i = e._fullLayout, a = i[t], o = FL(a), s = qL(a), l = a.xref === "paper", u = a.yref === "paper";
                e._fullLayout._reservedMargin[t] = {};
                var c = a.y < .5 ? "b" : "t", f = a.x < .5 ? "l" : "r", h = {
                    r: i.width - r,
                    l: r + a._width,
                    b: i.height - n,
                    t: n + a._effHeight
                };
                if (l && u) return PB.autoMargin(e, t, {
                    x: a.x,
                    y: a.y,
                    l: a._width * O3[o],
                    r: a._width * fle[o],
                    b: a._effHeight * fle[s],
                    t: a._effHeight * O3[s]
                });
                l ? e._fullLayout._reservedMargin[t][c] = h[c] : u || a.orientation === "v" ? e._fullLayout._reservedMargin[t][f] = h[f] : e._fullLayout._reservedMargin[t][c] = h[c];
            }
            function FL(e) {
                return gh.isRightAnchor(e) ? "right" : gh.isCenterAnchor(e) ? "center" : "left";
            }
            function qL(e) {
                return gh.isBottomAnchor(e) ? "bottom" : gh.isMiddleAnchor(e) ? "middle" : "top";
            }
            function OL(e) {
                return e._id || "legend";
            }
        });
        var qB = ye((FB)=>{
            "use strict";
            var Db = xa(), Sy = uo(), _le = id(), Rf = Mr(), Ist = Rf.pushUnique, DB = Rf.strTranslate, Rst = Rf.strRotate, Dst = g3(), A0 = Pl(), zst = Vse(), bm = ao(), sd = va(), BL = gv(), wm = Qa(), Fst = ad().zindexSeparator, U3 = ba(), Ag = rp(), zb = IS(), qst = bB(), Ost = RB(), Ele = zb.YANGLE, zB = Math.PI * Ele / 180, Bst = 1 / Math.sin(zB), Nst = Math.cos(zB), Ust = Math.sin(zB), Bc = zb.HOVERARROWSIZE, Us = zb.HOVERTEXTPAD, xle = {
                box: !0,
                ohlc: !0,
                violin: !0,
                candlestick: !0
            }, Vst = {
                scatter: !0,
                scattergl: !0,
                splom: !0
            };
            function ble(e, t) {
                return e.distance - t.distance;
            }
            FB.hover = function(t, r, n, i) {
                t = Rf.getGraphDiv(t);
                var a = r.target;
                Rf.throttle(t._fullLayout._uid + zb.HOVERID, zb.HOVERMINTIME, function() {
                    Hst(t, r, n, i, a);
                });
            };
            FB.loneHover = function(t, r) {
                var n = !0;
                Array.isArray(t) || (n = !1, t = [
                    t
                ]);
                var i = r.gd, a = Ile(i), o = Rle(i), s = t.map(function(b) {
                    var p = b._x0 || b.x0 || b.x || 0, E = b._x1 || b.x1 || b.x || 0, k = b._y0 || b.y0 || b.y || 0, A = b._y1 || b.y1 || b.y || 0, L = b.eventData;
                    if (L) {
                        var _ = Math.min(p, E), C = Math.max(p, E), M = Math.min(k, A), g = Math.max(k, A), P = b.trace;
                        if (U3.traceIs(P, "gl3d")) {
                            var T = i._fullLayout[P.scene]._scene.container, F = T.offsetLeft, q = T.offsetTop;
                            _ += F, C += F, M += q, g += q;
                        }
                        L.bbox = {
                            x0: _ + o,
                            x1: C + o,
                            y0: M + a,
                            y1: g + a
                        }, r.inOut_bbox && r.inOut_bbox.push(L.bbox);
                    } else L = !1;
                    return {
                        color: b.color || sd.defaultLine,
                        x0: b.x0 || b.x || 0,
                        x1: b.x1 || b.x || 0,
                        y0: b.y0 || b.y || 0,
                        y1: b.y1 || b.y || 0,
                        xLabel: b.xLabel,
                        yLabel: b.yLabel,
                        zLabel: b.zLabel,
                        text: b.text,
                        name: b.name,
                        idealAlign: b.idealAlign,
                        borderColor: b.borderColor,
                        fontFamily: b.fontFamily,
                        fontSize: b.fontSize,
                        fontColor: b.fontColor,
                        fontWeight: b.fontWeight,
                        fontStyle: b.fontStyle,
                        fontVariant: b.fontVariant,
                        nameLength: b.nameLength,
                        textAlign: b.textAlign,
                        trace: b.trace || {
                            index: 0,
                            hoverinfo: ""
                        },
                        xa: {
                            _offset: 0
                        },
                        ya: {
                            _offset: 0
                        },
                        index: 0,
                        hovertemplate: b.hovertemplate || !1,
                        hovertemplateLabels: b.hovertemplateLabels || !1,
                        eventData: L
                    };
                }), l = !1, u = Cle(s, {
                    gd: i,
                    hovermode: "closest",
                    rotateLabels: l,
                    bgColor: r.bgColor || sd.background,
                    container: Db.select(r.container),
                    outerContainer: r.outerContainer || r.container
                }), c = u.hoverLabels, f = 5, h = 0, d = 0;
                c.sort(function(b, p) {
                    return b.y0 - p.y0;
                }).each(function(b, p) {
                    var E = b.y0 - b.by / 2;
                    E - f < h ? b.offset = h - E + f : b.offset = 0, h = E + b.by + b.offset, p === r.anchorIndex && (d = b.offset);
                }).each(function(b) {
                    b.offset -= d;
                });
                var v = i._fullLayout._invScaleX, x = i._fullLayout._invScaleY;
                return Ple(c, l, v, x), n ? c : c.node();
            };
            function Hst(e, t, r, n, i) {
                r || (r = "xy"), typeof r == "string" && (r = r.split(Fst)[0]);
                var a = Array.isArray(r) ? r : [
                    r
                ], o, s = e._fullLayout, l = s.hoversubplots, u = s._plots || [], c = u[r], f = s._has("cartesian"), h = t.hovermode || s.hovermode, d = (h || "").charAt(0) === "x", v = (h || "").charAt(0) === "y", x, b;
                if (f && (d || v) && l === "axis") {
                    for(var p = a.length, E = 0; E < p; E++)if (o = a[E], u[o]) {
                        x = wm.getFromId(e, o, "x"), b = wm.getFromId(e, o, "y");
                        var k = (d ? x : b)._subplotsWith;
                        if (k && k.length) for(var A = 0; A < k.length; A++)Ist(a, k[A]);
                    }
                }
                if (c && l !== "single") {
                    var L = c.overlays.map(function(Ni) {
                        return Ni.id;
                    });
                    a = a.concat(L);
                }
                for(var _ = a.length, C = new Array(_), M = new Array(_), g = !1, P = 0; P < _; P++)if (o = a[P], u[o]) g = !0, C[P] = u[o].xaxis, M[P] = u[o].yaxis;
                else if (s[o] && s[o]._subplot) {
                    var T = s[o]._subplot;
                    C[P] = T.xaxis, M[P] = T.yaxis;
                } else {
                    Rf.warn("Unrecognized subplot: " + o);
                    return;
                }
                if (h && !g && (h = "closest"), [
                    "x",
                    "y",
                    "closest",
                    "x unified",
                    "y unified"
                ].indexOf(h) === -1 || !e.calcdata || e.querySelector(".zoombox") || e._dragging) return BL.unhoverRaw(e, t);
                var F = s.hoverdistance;
                F === -1 && (F = 1 / 0);
                var q = s.spikedistance;
                q === -1 && (q = 1 / 0);
                var V = [], H = [], X, G, N, W, re, ae, _e, Me, ke, ge, ie, Te, Ee, Ae = {
                    hLinePoint: null,
                    vLinePoint: null
                }, ze = !1;
                if (Array.isArray(t)) for(h = "array", N = 0; N < t.length; N++)re = e.calcdata[t[N].curveNumber || 0], re && (ae = re[0].trace, re[0].trace.hoverinfo !== "skip" && (H.push(re), ae.orientation === "h" && (ze = !0)));
                else {
                    var Ce = e.calcdata.slice();
                    for(Ce.sort(function(Ni, _n) {
                        var $i = Ni[0].trace.zorder || 0, zn = _n[0].trace.zorder || 0;
                        return $i - zn;
                    }), W = 0; W < Ce.length; W++)re = Ce[W], ae = re[0].trace, ae.hoverinfo !== "skip" && Ag.isTraceInSubplots(ae, a) && (H.push(re), ae.orientation === "h" && (ze = !0));
                    var me = !i, Re, ce;
                    if (me) "xpx" in t ? Re = t.xpx : Re = C[0]._length / 2, "ypx" in t ? ce = t.ypx : ce = M[0]._length / 2;
                    else {
                        if (Dst.triggerHandler(e, "plotly_beforehover", t) === !1) return;
                        var Ge = i.getBoundingClientRect();
                        Re = t.clientX - Ge.left, ce = t.clientY - Ge.top, s._calcInverseTransform(e);
                        var nt = Rf.apply3DTransform(s._invTransform)(Re, ce);
                        if (Re = nt[0], ce = nt[1], Re < 0 || Re > C[0]._length || ce < 0 || ce > M[0]._length) return BL.unhoverRaw(e, t);
                    }
                    if (t.pointerX = Re + C[0]._offset, t.pointerY = ce + M[0]._offset, "xval" in t ? X = Ag.flat(a, t.xval) : X = Ag.p2c(C, Re), "yval" in t ? G = Ag.flat(a, t.yval) : G = Ag.p2c(M, ce), !Sy(X[0]) || !Sy(G[0])) return Rf.warn("Fx.hover failed", t, e), BL.unhoverRaw(e, t);
                }
                var ct = 1 / 0;
                function qt(Ni, _n) {
                    for(W = 0; W < H.length; W++)if (re = H[W], !(!re || !re[0] || !re[0].trace) && (ae = re[0].trace, !(ae.visible !== !0 || ae._length === 0) && [
                        "carpet",
                        "contourcarpet"
                    ].indexOf(ae._module.name) === -1)) {
                        if (ke = h, Ag.isUnifiedHover(ke) && (ke = ke.charAt(0)), ae.type === "splom" ? (Me = 0, _e = a[Me]) : (_e = Ag.getSubplot(ae), Me = a.indexOf(_e)), Te = {
                            cd: re,
                            trace: ae,
                            xa: C[Me],
                            ya: M[Me],
                            maxHoverDistance: F,
                            maxSpikeDistance: q,
                            index: !1,
                            distance: Math.min(ct, F),
                            spikeDistance: 1 / 0,
                            xSpike: void 0,
                            ySpike: void 0,
                            color: sd.defaultLine,
                            name: ae.name,
                            x0: void 0,
                            x1: void 0,
                            y0: void 0,
                            y1: void 0,
                            xLabelVal: void 0,
                            yLabelVal: void 0,
                            zLabelVal: void 0,
                            text: void 0
                        }, s[_e] && (Te.subplot = s[_e]._subplot), s._splomScenes && s._splomScenes[ae.uid] && (Te.scene = s._splomScenes[ae.uid]), ke === "array") {
                            var $i = t[W];
                            "pointNumber" in $i ? (Te.index = $i.pointNumber, ke = "closest") : (ke = "", "xval" in $i && (ge = $i.xval, ke = "x"), "yval" in $i && (ie = $i.yval, ke = ke ? "closest" : "y"));
                        } else Ni !== void 0 && _n !== void 0 ? (ge = Ni, ie = _n) : (ge = X[Me], ie = G[Me]);
                        if (Ee = V.length, F !== 0) {
                            if (ae._module && ae._module.hoverPoints) {
                                var zn = ae._module.hoverPoints(Te, ge, ie, ke, {
                                    finiteRange: !0,
                                    hoverLayer: s._hoverlayer,
                                    hoversubplots: l,
                                    gd: e
                                });
                                if (zn) for(var Wn, It = 0; It < zn.length; It++)Wn = zn[It], Sy(Wn.x0) && Sy(Wn.y0) && V.push(Zst(Wn, h));
                            } else Rf.log("Unrecognized trace type in hover:", ae);
                        }
                        if (h === "closest" && V.length > Ee && (V.splice(0, Ee), ct = V[0].distance), f && q !== 0 && V.length === 0) {
                            Te.distance = q, Te.index = !1;
                            var ft = ae._module.hoverPoints(Te, ge, ie, "closest", {
                                hoverLayer: s._hoverlayer
                            });
                            if (ft && (ft = ft.filter(function(Vr) {
                                return Vr.spikeDistance <= q;
                            })), ft && ft.length) {
                                var jt, Zt = ft.filter(function(Vr) {
                                    return Vr.xa.showspikes && Vr.xa.spikesnap !== "hovered data";
                                });
                                if (Zt.length) {
                                    var yr = Zt[0];
                                    Sy(yr.x0) && Sy(yr.y0) && (jt = ot(yr), (!Ae.vLinePoint || Ae.vLinePoint.spikeDistance > jt.spikeDistance) && (Ae.vLinePoint = jt));
                                }
                                var Fr = ft.filter(function(Vr) {
                                    return Vr.ya.showspikes && Vr.ya.spikesnap !== "hovered data";
                                });
                                if (Fr.length) {
                                    var Zr = Fr[0];
                                    Sy(Zr.x0) && Sy(Zr.y0) && (jt = ot(Zr), (!Ae.hLinePoint || Ae.hLinePoint.spikeDistance > jt.spikeDistance) && (Ae.hLinePoint = jt));
                                }
                            }
                        }
                    }
                }
                qt();
                function rt(Ni, _n, $i) {
                    for(var zn = null, Wn = 1 / 0, It, ft = 0; ft < Ni.length; ft++)x && x._id !== Ni[ft].xa._id || b && b._id !== Ni[ft].ya._id || (It = Ni[ft].spikeDistance, $i && ft === 0 && (It = -1 / 0), It <= Wn && It <= _n && (zn = Ni[ft], Wn = It));
                    return zn;
                }
                function ot(Ni) {
                    return Ni ? {
                        xa: Ni.xa,
                        ya: Ni.ya,
                        x: Ni.xSpike !== void 0 ? Ni.xSpike : (Ni.x0 + Ni.x1) / 2,
                        y: Ni.ySpike !== void 0 ? Ni.ySpike : (Ni.y0 + Ni.y1) / 2,
                        distance: Ni.distance,
                        spikeDistance: Ni.spikeDistance,
                        curveNumber: Ni.trace.index,
                        color: Ni.color,
                        pointNumber: Ni.index
                    } : null;
                }
                var Rt = {
                    fullLayout: s,
                    container: s._hoverlayer,
                    event: t
                }, kt = e._spikepoints, Ct = {
                    vLinePoint: Ae.vLinePoint,
                    hLinePoint: Ae.hLinePoint
                };
                e._spikepoints = Ct;
                var Yt = function() {
                    var Ni = V.filter(function($i) {
                        return x && x._id === $i.xa._id && b && b._id === $i.ya._id;
                    }), _n = V.filter(function($i) {
                        return !(x && x._id === $i.xa._id && b && b._id === $i.ya._id);
                    });
                    Ni.sort(ble), _n.sort(ble), V = Ni.concat(_n), V = Yst(V, h);
                };
                Yt();
                var xr = h.charAt(0), er = (xr === "x" || xr === "y") && V[0] && Vst[V[0].trace.type];
                if (f && q !== 0 && V.length !== 0) {
                    var Ke = V.filter(function(Ni) {
                        return Ni.ya.showspikes;
                    }), xt = rt(Ke, q, er);
                    Ae.hLinePoint = ot(xt);
                    var bt = V.filter(function(Ni) {
                        return Ni.xa.showspikes;
                    }), Lt = rt(bt, q, er);
                    Ae.vLinePoint = ot(Lt);
                }
                if (V.length === 0) {
                    var St = BL.unhoverRaw(e, t);
                    return f && (Ae.hLinePoint !== null || Ae.vLinePoint !== null) && Ale(kt) && Tle(e, Ae, Rt), St;
                }
                if (f && Ale(kt) && Tle(e, Ae, Rt), Ag.isXYhover(ke) && V[0].length !== 0 && V[0].trace.type !== "splom") {
                    var Et = V[0];
                    xle[Et.trace.type] ? V = V.filter(function(Ni) {
                        return Ni.trace.index === Et.trace.index;
                    }) : V = [
                        Et
                    ];
                    var dt = V.length, Ht = Mle("x", Et, s), $t = Mle("y", Et, s);
                    qt(Ht, $t);
                    var fr = [], _r = {}, Br = 0, Or = function(Ni) {
                        var _n = xle[Ni.trace.type] ? kle(Ni) : Ni.trace.index;
                        if (!_r[_n]) Br++, _r[_n] = Br, fr.push(Ni);
                        else {
                            var $i = _r[_n] - 1, zn = fr[$i];
                            $i > 0 && Math.abs(Ni.distance) < Math.abs(zn.distance) && (fr[$i] = Ni);
                        }
                    }, Nr;
                    for(Nr = 0; Nr < dt; Nr++)Or(V[Nr]);
                    for(Nr = V.length - 1; Nr > dt - 1; Nr--)Or(V[Nr]);
                    V = fr, Yt();
                }
                var ut = e._hoverdata, Ne = [], Ye = Ile(e), Ve = Rle(e);
                for(N = 0; N < V.length; N++){
                    var Xe = V[N], ht = Ag.makeEventData(Xe, Xe.trace, Xe.cd);
                    if (Xe.hovertemplate !== !1) {
                        var Le = !1;
                        Xe.cd[Xe.index] && Xe.cd[Xe.index].ht && (Le = Xe.cd[Xe.index].ht), Xe.hovertemplate = Le || Xe.trace.hovertemplate || !1;
                    }
                    if (Xe.xa && Xe.ya) {
                        var xe = Xe.x0 + Xe.xa._offset, Se = Xe.x1 + Xe.xa._offset, lt = Xe.y0 + Xe.ya._offset, Gt = Xe.y1 + Xe.ya._offset, Vt = Math.min(xe, Se), ar = Math.max(xe, Se), Qr = Math.min(lt, Gt), ai = Math.max(lt, Gt);
                        ht.bbox = {
                            x0: Vt + Ve,
                            x1: ar + Ve,
                            y0: Qr + Ye,
                            y1: ai + Ye
                        };
                    }
                    Xe.eventData = [
                        ht
                    ], Ne.push(ht);
                }
                e._hoverdata = Ne;
                var jr = h === "y" && (H.length > 1 || V.length > 1) || h === "closest" && ze && V.length > 1, ri = sd.combine(s.plot_bgcolor || sd.background, s.paper_bgcolor), bi = Cle(V, {
                    gd: e,
                    hovermode: h,
                    rotateLabels: jr,
                    bgColor: ri,
                    container: s._hoverlayer,
                    outerContainer: s._paper.node(),
                    commonLabelOpts: s.hoverlabel,
                    hoverdistance: s.hoverdistance
                }), nn = bi.hoverLabels;
                if (Ag.isUnifiedHover(h) || (jst(nn, jr, s, bi.commonLabelBoundingBox), Ple(nn, jr, s._invScaleX, s._invScaleY)), i && i.tagName) {
                    var Wi = U3.getComponentMethod("annotations", "hasClickToShow")(e, Ne);
                    zst(Db.select(i), Wi ? "pointer" : "");
                }
                !i || n || !Xst(e, t, ut) || (ut && e.emit("plotly_unhover", {
                    event: t,
                    points: ut
                }), e.emit("plotly_hover", {
                    event: t,
                    points: e._hoverdata,
                    xaxes: C,
                    yaxes: M,
                    xvals: X,
                    yvals: G
                }));
            }
            function kle(e) {
                return [
                    e.trace.index,
                    e.index,
                    e.x0,
                    e.y0,
                    e.name,
                    e.attr,
                    e.xa ? e.xa._id : "",
                    e.ya ? e.ya._id : ""
                ].join(",");
            }
            var Gst = /<extra>([\s\S]*)<\/extra>/;
            function Cle(e, t) {
                var r = t.gd, n = r._fullLayout, i = t.hovermode, a = t.rotateLabels, o = t.bgColor, s = t.container, l = t.outerContainer, u = t.commonLabelOpts || {};
                if (e.length === 0) return [
                    []
                ];
                var c = t.fontFamily || zb.HOVERFONT, f = t.fontSize || zb.HOVERFONTSIZE, h = t.fontWeight || n.font.weight, d = t.fontStyle || n.font.style, v = t.fontVariant || n.font.variant, x = t.fontTextcase || n.font.textcase, b = t.fontLineposition || n.font.lineposition, p = t.fontShadow || n.font.shadow, E = e[0], k = E.xa, A = E.ya, L = i.charAt(0), _ = L + "Label", C = E[_];
                if (C === void 0 && k.type === "multicategory") for(var M = 0; M < e.length && (C = e[M][_], C === void 0); M++);
                var g = N3(r, l), P = g.top, T = g.width, F = g.height, q = C !== void 0 && E.distance <= t.hoverdistance && (i === "x" || i === "y");
                if (q) {
                    var V = !0, H, X;
                    for(H = 0; H < e.length; H++)if (V && e[H].zLabel === void 0 && (V = !1), X = e[H].hoverinfo || e[H].trace.hoverinfo, X) {
                        var G = Array.isArray(X) ? X : X.split("+");
                        if (G.indexOf("all") === -1 && G.indexOf(i) === -1) {
                            q = !1;
                            break;
                        }
                    }
                    V && (q = !1);
                }
                var N = s.selectAll("g.axistext").data(q ? [
                    0
                ] : []);
                N.enter().append("g").classed("axistext", !0), N.exit().remove();
                var W = {
                    minX: 0,
                    maxX: 0,
                    minY: 0,
                    maxY: 0
                };
                if (N.each(function() {
                    var bt = Db.select(this), Lt = Rf.ensureSingle(bt, "path", "", function(Vt) {
                        Vt.style({
                            "stroke-width": "1px"
                        });
                    }), St = Rf.ensureSingle(bt, "text", "", function(Vt) {
                        Vt.attr("data-notex", 1);
                    }), Et = u.bgcolor || sd.defaultLine, dt = u.bordercolor || sd.contrast(Et), Ht = sd.contrast(Et), $t = u.font, fr = {
                        weight: $t.weight || h,
                        style: $t.style || d,
                        variant: $t.variant || v,
                        textcase: $t.textcase || x,
                        lineposition: $t.lineposition || b,
                        shadow: $t.shadow || p,
                        family: $t.family || c,
                        size: $t.size || f,
                        color: $t.color || Ht
                    };
                    Lt.style({
                        fill: Et,
                        stroke: dt
                    }), St.text(C).call(bm.font, fr).call(A0.positionText, 0, 0).call(A0.convertToTspans, r), bt.attr("transform", "");
                    var _r = N3(r, St.node()), Br, Or;
                    if (i === "x") {
                        var Nr = k.side === "top" ? "-" : "";
                        St.attr("text-anchor", "middle").call(A0.positionText, 0, k.side === "top" ? P - _r.bottom - Bc - Us : P - _r.top + Bc + Us), Br = k._offset + (E.x0 + E.x1) / 2, Or = A._offset + (k.side === "top" ? 0 : A._length);
                        var ut = _r.width / 2 + Us, Ne = Br;
                        Br < ut ? Ne = ut : Br > n.width - ut && (Ne = n.width - ut), Lt.attr("d", "M" + (Br - Ne) + ",0L" + (Br - Ne + Bc) + "," + Nr + Bc + "H" + ut + "v" + Nr + (Us * 2 + _r.height) + "H" + -ut + "V" + Nr + Bc + "H" + (Br - Ne - Bc) + "Z"), Br = Ne, W.minX = Br - ut, W.maxX = Br + ut, k.side === "top" ? (W.minY = Or - (Us * 2 + _r.height), W.maxY = Or - Us) : (W.minY = Or + Us, W.maxY = Or + (Us * 2 + _r.height));
                    } else {
                        var Ye, Ve, Xe;
                        A.side === "right" ? (Ye = "start", Ve = 1, Xe = "", Br = k._offset + k._length) : (Ye = "end", Ve = -1, Xe = "-", Br = k._offset), Or = A._offset + (E.y0 + E.y1) / 2, St.attr("text-anchor", Ye), Lt.attr("d", "M0,0L" + Xe + Bc + "," + Bc + "V" + (Us + _r.height / 2) + "h" + Xe + (Us * 2 + _r.width) + "V-" + (Us + _r.height / 2) + "H" + Xe + Bc + "V-" + Bc + "Z"), W.minY = Or - (Us + _r.height / 2), W.maxY = Or + (Us + _r.height / 2), A.side === "right" ? (W.minX = Br + Bc, W.maxX = Br + Bc + (Us * 2 + _r.width)) : (W.minX = Br - Bc - (Us * 2 + _r.width), W.maxX = Br - Bc);
                        var ht = _r.height / 2, Le = P - _r.top - ht, xe = "clip" + n._uid + "commonlabel" + A._id, Se;
                        if (Br < _r.width + 2 * Us + Bc) {
                            Se = "M-" + (Bc + Us) + "-" + ht + "h-" + (_r.width - Us) + "V" + ht + "h" + (_r.width - Us) + "Z";
                            var lt = _r.width - Br + Us;
                            A0.positionText(St, lt, Le), Ye === "end" && St.selectAll("tspan").each(function() {
                                var Vt = Db.select(this), ar = bm.tester.append("text").text(Vt.text()).call(bm.font, fr), Qr = N3(r, ar.node());
                                Math.round(Qr.width) < Math.round(_r.width) && Vt.attr("x", lt - Qr.width), ar.remove();
                            });
                        } else A0.positionText(St, Ve * (Us + Bc), Le), Se = null;
                        var Gt = n._topclips.selectAll("#" + xe).data(Se ? [
                            0
                        ] : []);
                        Gt.enter().append("clipPath").attr("id", xe).append("path"), Gt.exit().remove(), Gt.select("path").attr("d", Se), bm.setClipUrl(St, Se ? xe : null, r);
                    }
                    bt.attr("transform", DB(Br, Or));
                }), Ag.isUnifiedHover(i)) {
                    s.selectAll("g.hovertext").remove();
                    var re = e.filter(function(bt) {
                        return bt.hoverinfo !== "none";
                    });
                    if (re.length === 0) return [];
                    var ae = n.hoverlabel, _e = ae.font, Me = {
                        showlegend: !0,
                        legend: {
                            title: {
                                text: C,
                                font: _e
                            },
                            font: _e,
                            bgcolor: ae.bgcolor,
                            bordercolor: ae.bordercolor,
                            borderwidth: 1,
                            tracegroupgap: 7,
                            traceorder: n.legend ? n.legend.traceorder : void 0,
                            orientation: "v"
                        }
                    }, ke = {
                        font: _e
                    };
                    qst(Me, ke, r._fullData);
                    var ge = ke.legend;
                    ge.entries = [];
                    for(var ie = 0; ie < re.length; ie++){
                        var Te = re[ie];
                        if (Te.hoverinfo !== "none") {
                            var Ee = wle(Te, !0, i, n, C), Ae = Ee[0], ze = Ee[1];
                            Te.name = ze, ze !== "" ? Te.text = ze + " : " + Ae : Te.text = Ae;
                            var Ce = Te.cd[Te.index];
                            Ce && (Ce.mc && (Te.mc = Ce.mc), Ce.mcc && (Te.mc = Ce.mcc), Ce.mlc && (Te.mlc = Ce.mlc), Ce.mlcc && (Te.mlc = Ce.mlcc), Ce.mlw && (Te.mlw = Ce.mlw), Ce.mrc && (Te.mrc = Ce.mrc), Ce.dir && (Te.dir = Ce.dir)), Te._distinct = !0, ge.entries.push([
                                Te
                            ]);
                        }
                    }
                    ge.entries.sort(function(bt, Lt) {
                        return bt[0].trace.index - Lt[0].trace.index;
                    }), ge.layer = s, ge._inHover = !0, ge._groupTitleFont = ae.grouptitlefont, Ost(r, ge);
                    var me = s.select("g.legend"), Re = N3(r, me.node()), ce = Re.width + 2 * Us, Ge = Re.height + 2 * Us, nt = re[0], ct = (nt.x0 + nt.x1) / 2, qt = (nt.y0 + nt.y1) / 2, rt = !(U3.traceIs(nt.trace, "bar-like") || U3.traceIs(nt.trace, "box-violin")), ot, Rt;
                    L === "y" ? rt ? (Rt = qt - Us, ot = qt + Us) : (Rt = Math.min.apply(null, re.map(function(bt) {
                        return Math.min(bt.y0, bt.y1);
                    })), ot = Math.max.apply(null, re.map(function(bt) {
                        return Math.max(bt.y0, bt.y1);
                    }))) : Rt = ot = Rf.mean(re.map(function(bt) {
                        return (bt.y0 + bt.y1) / 2;
                    })) - Ge / 2;
                    var kt, Ct;
                    L === "x" ? rt ? (kt = ct + Us, Ct = ct - Us) : (kt = Math.max.apply(null, re.map(function(bt) {
                        return Math.max(bt.x0, bt.x1);
                    })), Ct = Math.min.apply(null, re.map(function(bt) {
                        return Math.min(bt.x0, bt.x1);
                    }))) : kt = Ct = Rf.mean(re.map(function(bt) {
                        return (bt.x0 + bt.x1) / 2;
                    })) - ce / 2;
                    var Yt = k._offset, xr = A._offset;
                    ot += xr, kt += Yt, Ct += Yt - ce, Rt += xr - Ge;
                    var er, Ke;
                    return kt + ce < T && kt >= 0 ? er = kt : Ct + ce < T && Ct >= 0 ? er = Ct : Yt + ce < T ? er = Yt : kt - ct < ct - Ct + ce ? er = T - ce : er = 0, er += Us, ot + Ge < F && ot >= 0 ? Ke = ot : Rt + Ge < F && Rt >= 0 ? Ke = Rt : xr + Ge < F ? Ke = xr : ot - qt < qt - Rt + Ge ? Ke = F - Ge : Ke = 0, Ke += Us, me.attr("transform", DB(er - 1, Ke - 1)), me;
                }
                var xt = s.selectAll("g.hovertext").data(e, function(bt) {
                    return kle(bt);
                });
                return xt.enter().append("g").classed("hovertext", !0).each(function() {
                    var bt = Db.select(this);
                    bt.append("rect").call(sd.fill, sd.addOpacity(o, .8)), bt.append("text").classed("name", !0), bt.append("path").style("stroke-width", "1px"), bt.append("text").classed("nums", !0).call(bm.font, {
                        weight: h,
                        style: d,
                        variant: v,
                        textcase: x,
                        lineposition: b,
                        shadow: p,
                        family: c,
                        size: f
                    });
                }), xt.exit().remove(), xt.each(function(bt) {
                    var Lt = Db.select(this).attr("transform", ""), St = bt.color;
                    Array.isArray(St) && (St = St[bt.eventData[0].pointNumber]);
                    var Et = bt.bgcolor || St, dt = sd.combine(sd.opacity(Et) ? Et : sd.defaultLine, o), Ht = sd.combine(sd.opacity(St) ? St : sd.defaultLine, o), $t = bt.borderColor || sd.contrast(dt), fr = wle(bt, q, i, n, C, Lt), _r = fr[0], Br = fr[1], Or = Lt.select("text.nums").call(bm.font, {
                        family: bt.fontFamily || c,
                        size: bt.fontSize || f,
                        color: bt.fontColor || $t,
                        weight: bt.fontWeight || h,
                        style: bt.fontStyle || d,
                        variant: bt.fontVariant || v,
                        textcase: bt.fontTextcase || x,
                        lineposition: bt.fontLineposition || b,
                        shadow: bt.fontShadow || p
                    }).text(_r).attr("data-notex", 1).call(A0.positionText, 0, 0).call(A0.convertToTspans, r), Nr = Lt.select("text.name"), ut = 0, Ne = 0;
                    if (Br && Br !== _r) {
                        Nr.call(bm.font, {
                            family: bt.fontFamily || c,
                            size: bt.fontSize || f,
                            color: Ht,
                            weight: bt.fontWeight || h,
                            style: bt.fontStyle || d,
                            variant: bt.fontVariant || v,
                            textcase: bt.fontTextcase || x,
                            lineposition: bt.fontLineposition || b,
                            shadow: bt.fontShadow || p
                        }).text(Br).attr("data-notex", 1).call(A0.positionText, 0, 0).call(A0.convertToTspans, r);
                        var Ye = N3(r, Nr.node());
                        ut = Ye.width + 2 * Us, Ne = Ye.height + 2 * Us;
                    } else Nr.remove(), Lt.select("rect").remove();
                    Lt.select("path").style({
                        fill: dt,
                        stroke: $t
                    });
                    var Ve = bt.xa._offset + (bt.x0 + bt.x1) / 2, Xe = bt.ya._offset + (bt.y0 + bt.y1) / 2, ht = Math.abs(bt.x1 - bt.x0), Le = Math.abs(bt.y1 - bt.y0), xe = N3(r, Or.node()), Se = xe.width / n._invScaleX, lt = xe.height / n._invScaleY;
                    bt.ty0 = (P - xe.top) / n._invScaleY, bt.bx = Se + 2 * Us, bt.by = Math.max(lt + 2 * Us, Ne), bt.anchor = "start", bt.txwidth = Se, bt.tx2width = ut, bt.offset = 0;
                    var Gt = (Se + Bc + Us + ut) * n._invScaleX, Vt, ar;
                    if (a) bt.pos = Ve, Vt = Xe + Le / 2 + Gt <= F, ar = Xe - Le / 2 - Gt >= 0, (bt.idealAlign === "top" || !Vt) && ar ? (Xe -= Le / 2, bt.anchor = "end") : Vt ? (Xe += Le / 2, bt.anchor = "start") : bt.anchor = "middle", bt.crossPos = Xe;
                    else {
                        if (bt.pos = Xe, Vt = Ve + ht / 2 + Gt <= T, ar = Ve - ht / 2 - Gt >= 0, (bt.idealAlign === "left" || !Vt) && ar) Ve -= ht / 2, bt.anchor = "end";
                        else if (Vt) Ve += ht / 2, bt.anchor = "start";
                        else {
                            bt.anchor = "middle";
                            var Qr = Gt / 2, ai = Ve + Qr - T, jr = Ve - Qr;
                            ai > 0 && (Ve -= ai), jr < 0 && (Ve += -jr);
                        }
                        bt.crossPos = Ve;
                    }
                    Or.attr("text-anchor", bt.anchor), ut && Nr.attr("text-anchor", bt.anchor), Lt.attr("transform", DB(Ve, Xe) + (a ? Rst(Ele) : ""));
                }), {
                    hoverLabels: xt,
                    commonLabelBoundingBox: W
                };
            }
            function wle(e, t, r, n, i, a) {
                var o = "", s = "";
                e.nameOverride !== void 0 && (e.name = e.nameOverride), e.name && (e.trace._meta && (e.name = Rf.templateString(e.name, e.trace._meta)), o = Sle(e.name, e.nameLength));
                var l = r.charAt(0), u = l === "x" ? "y" : "x";
                e.zLabel !== void 0 ? (e.xLabel !== void 0 && (s += "x: " + e.xLabel + "<br>"), e.yLabel !== void 0 && (s += "y: " + e.yLabel + "<br>"), e.trace.type !== "choropleth" && e.trace.type !== "choroplethmapbox" && e.trace.type !== "choroplethmap" && (s += (s ? "z: " : "") + e.zLabel)) : t && e[l + "Label"] === i ? s = e[u + "Label"] || "" : e.xLabel === void 0 ? e.yLabel !== void 0 && e.trace.type !== "scattercarpet" && (s = e.yLabel) : e.yLabel === void 0 ? s = e.xLabel : s = "(" + e.xLabel + ", " + e.yLabel + ")", (e.text || e.text === 0) && !Array.isArray(e.text) && (s += (s ? "<br>" : "") + e.text), e.extraText !== void 0 && (s += (s ? "<br>" : "") + e.extraText), a && s === "" && !e.hovertemplate && (o === "" && a.remove(), s = o);
                var c = e.hovertemplate || !1;
                if (c) {
                    var f = e.hovertemplateLabels || e;
                    e[l + "Label"] !== i && (f[l + "other"] = f[l + "Val"], f[l + "otherLabel"] = f[l + "Label"]), s = Rf.hovertemplateString(c, f, n._d3locale, e.eventData[0] || {}, e.trace._meta), s = s.replace(Gst, function(h, d) {
                        return o = Sle(d, e.nameLength), "";
                    });
                }
                return [
                    s,
                    o
                ];
            }
            function jst(e, t, r, n) {
                var i = t ? "xa" : "ya", a = t ? "ya" : "xa", o = 0, s = 1, l = e.size(), u = new Array(l), c = 0, f = n.minX, h = n.maxX, d = n.minY, v = n.maxY, x = function(X) {
                    return X * r._invScaleX;
                }, b = function(X) {
                    return X * r._invScaleY;
                };
                e.each(function(X) {
                    var G = X[i], N = X[a], W = G._id.charAt(0) === "x", re = G.range;
                    c === 0 && re && re[0] > re[1] !== W && (s = -1);
                    var ae = 0, _e = W ? r.width : r.height;
                    if (r.hovermode === "x" || r.hovermode === "y") {
                        var Me = Lle(X, t), ke = X.anchor, ge = ke === "end" ? -1 : 1, ie, Te;
                        if (ke === "middle") ie = X.crossPos + (W ? b(Me.y - X.by / 2) : x(X.bx / 2 + X.tx2width / 2)), Te = ie + (W ? b(X.by) : x(X.bx));
                        else if (W) ie = X.crossPos + b(Bc + Me.y) - b(X.by / 2 - Bc), Te = ie + b(X.by);
                        else {
                            var Ee = x(ge * Bc + Me.x), Ae = Ee + x(ge * X.bx);
                            ie = X.crossPos + Math.min(Ee, Ae), Te = X.crossPos + Math.max(Ee, Ae);
                        }
                        W ? d !== void 0 && v !== void 0 && Math.min(Te, v) - Math.max(ie, d) > 1 && (N.side === "left" ? (ae = N._mainLinePosition, _e = r.width) : _e = N._mainLinePosition) : f !== void 0 && h !== void 0 && Math.min(Te, h) - Math.max(ie, f) > 1 && (N.side === "top" ? (ae = N._mainLinePosition, _e = r.height) : _e = N._mainLinePosition);
                    }
                    u[c++] = [
                        {
                            datum: X,
                            traceIndex: X.trace.index,
                            dp: 0,
                            pos: X.pos,
                            posref: X.posref,
                            size: X.by * (W ? Bst : 1) / 2,
                            pmin: ae,
                            pmax: _e
                        }
                    ];
                }), u.sort(function(X, G) {
                    return X[0].posref - G[0].posref || s * (G[0].traceIndex - X[0].traceIndex);
                });
                var p, E, k, A, L, _, C;
                function M(X) {
                    var G = X[0], N = X[X.length - 1];
                    if (E = G.pmin - G.pos - G.dp + G.size, k = N.pos + N.dp + N.size - G.pmax, E > .01) {
                        for(L = X.length - 1; L >= 0; L--)X[L].dp += E;
                        p = !1;
                    }
                    if (!(k < .01)) {
                        if (E < -0.01) {
                            for(L = X.length - 1; L >= 0; L--)X[L].dp -= k;
                            p = !1;
                        }
                        if (p) {
                            var W = 0;
                            for(A = 0; A < X.length; A++)_ = X[A], _.pos + _.dp + _.size > G.pmax && W++;
                            for(A = X.length - 1; A >= 0 && !(W <= 0); A--)_ = X[A], _.pos > G.pmax - 1 && (_.del = !0, W--);
                            for(A = 0; A < X.length && !(W <= 0); A++)if (_ = X[A], _.pos < G.pmin + 1) for(_.del = !0, W--, k = _.size * 2, L = X.length - 1; L >= 0; L--)X[L].dp -= k;
                            for(A = X.length - 1; A >= 0 && !(W <= 0); A--)_ = X[A], _.pos + _.dp + _.size > G.pmax && (_.del = !0, W--);
                        }
                    }
                }
                for(; !p && o <= l;){
                    for(o++, p = !0, A = 0; A < u.length - 1;){
                        var g = u[A], P = u[A + 1], T = g[g.length - 1], F = P[0];
                        if (E = T.pos + T.dp + T.size - F.pos - F.dp + F.size, E > .01) {
                            for(L = P.length - 1; L >= 0; L--)P[L].dp += E;
                            for(g.push.apply(g, P), u.splice(A + 1, 1), C = 0, L = g.length - 1; L >= 0; L--)C += g[L].dp;
                            for(k = C / g.length, L = g.length - 1; L >= 0; L--)g[L].dp -= k;
                            p = !1;
                        } else A++;
                    }
                    u.forEach(M);
                }
                for(A = u.length - 1; A >= 0; A--){
                    var q = u[A];
                    for(L = q.length - 1; L >= 0; L--){
                        var V = q[L], H = V.datum;
                        H.offset = V.dp, H.del = V.del;
                    }
                }
            }
            function Lle(e, t) {
                var r = 0, n = e.offset;
                return t && (n *= -Ust, r = e.offset * Nst), {
                    x: r,
                    y: n
                };
            }
            function Wst(e) {
                var t = {
                    start: 1,
                    end: -1,
                    middle: 0
                }[e.anchor], r = t * (Bc + Us), n = r + t * (e.txwidth + Us), i = e.anchor === "middle";
                return i && (r -= e.tx2width / 2, n += e.txwidth / 2 + Us), {
                    alignShift: t,
                    textShiftX: r,
                    text2ShiftX: n
                };
            }
            function Ple(e, t, r, n) {
                var i = function(o) {
                    return o * r;
                }, a = function(o) {
                    return o * n;
                };
                e.each(function(o) {
                    var s = Db.select(this);
                    if (o.del) return s.remove();
                    var l = s.select("text.nums"), u = o.anchor, c = u === "end" ? -1 : 1, f = Wst(o), h = Lle(o, t), d = h.x, v = h.y, x = u === "middle";
                    s.select("path").attr("d", x ? "M-" + i(o.bx / 2 + o.tx2width / 2) + "," + a(v - o.by / 2) + "h" + i(o.bx) + "v" + a(o.by) + "h-" + i(o.bx) + "Z" : "M0,0L" + i(c * Bc + d) + "," + a(Bc + v) + "v" + a(o.by / 2 - Bc) + "h" + i(c * o.bx) + "v-" + a(o.by) + "H" + i(c * Bc + d) + "V" + a(v - Bc) + "Z");
                    var b = d + f.textShiftX, p = v + o.ty0 - o.by / 2 + Us, E = o.textAlign || "auto";
                    E !== "auto" && (E === "left" && u !== "start" ? (l.attr("text-anchor", "start"), b = x ? -o.bx / 2 - o.tx2width / 2 + Us : -o.bx - Us) : E === "right" && u !== "end" && (l.attr("text-anchor", "end"), b = x ? o.bx / 2 - o.tx2width / 2 - Us : o.bx + Us)), l.call(A0.positionText, i(b), a(p)), o.tx2width && (s.select("text.name").call(A0.positionText, i(f.text2ShiftX + f.alignShift * Us + d), a(v + o.ty0 - o.by / 2 + Us)), s.select("rect").call(bm.setRect, i(f.text2ShiftX + (f.alignShift - 1) * o.tx2width / 2 + d), a(v - o.by / 2 - 1), i(o.tx2width), a(o.by + 2)));
                });
            }
            function Zst(e, t) {
                var r = e.index, n = e.trace || {}, i = e.cd[0], a = e.cd[r] || {};
                function o(h) {
                    return h || Sy(h) && h === 0;
                }
                var s = Array.isArray(r) ? function(h, d) {
                    var v = Rf.castOption(i, r, h);
                    return o(v) ? v : Rf.extractOption({}, n, "", d);
                } : function(h, d) {
                    return Rf.extractOption(a, n, h, d);
                };
                function l(h, d, v) {
                    var x = s(d, v);
                    o(x) && (e[h] = x);
                }
                if (l("hoverinfo", "hi", "hoverinfo"), l("bgcolor", "hbg", "hoverlabel.bgcolor"), l("borderColor", "hbc", "hoverlabel.bordercolor"), l("fontFamily", "htf", "hoverlabel.font.family"), l("fontSize", "hts", "hoverlabel.font.size"), l("fontColor", "htc", "hoverlabel.font.color"), l("fontWeight", "htw", "hoverlabel.font.weight"), l("fontStyle", "hty", "hoverlabel.font.style"), l("fontVariant", "htv", "hoverlabel.font.variant"), l("nameLength", "hnl", "hoverlabel.namelength"), l("textAlign", "hta", "hoverlabel.align"), e.posref = t === "y" || t === "closest" && n.orientation === "h" ? e.xa._offset + (e.x0 + e.x1) / 2 : e.ya._offset + (e.y0 + e.y1) / 2, e.x0 = Rf.constrain(e.x0, 0, e.xa._length), e.x1 = Rf.constrain(e.x1, 0, e.xa._length), e.y0 = Rf.constrain(e.y0, 0, e.ya._length), e.y1 = Rf.constrain(e.y1, 0, e.ya._length), e.xLabelVal !== void 0 && (e.xLabel = "xLabel" in e ? e.xLabel : wm.hoverLabelText(e.xa, e.xLabelVal, n.xhoverformat), e.xVal = e.xa.c2d(e.xLabelVal)), e.yLabelVal !== void 0 && (e.yLabel = "yLabel" in e ? e.yLabel : wm.hoverLabelText(e.ya, e.yLabelVal, n.yhoverformat), e.yVal = e.ya.c2d(e.yLabelVal)), e.zLabelVal !== void 0 && e.zLabel === void 0 && (e.zLabel = String(e.zLabelVal)), !isNaN(e.xerr) && !(e.xa.type === "log" && e.xerr <= 0)) {
                    var u = wm.tickText(e.xa, e.xa.c2l(e.xerr), "hover").text;
                    e.xerrneg !== void 0 ? e.xLabel += " +" + u + " / -" + wm.tickText(e.xa, e.xa.c2l(e.xerrneg), "hover").text : e.xLabel += " \xB1 " + u, t === "x" && (e.distance += 1);
                }
                if (!isNaN(e.yerr) && !(e.ya.type === "log" && e.yerr <= 0)) {
                    var c = wm.tickText(e.ya, e.ya.c2l(e.yerr), "hover").text;
                    e.yerrneg !== void 0 ? e.yLabel += " +" + c + " / -" + wm.tickText(e.ya, e.ya.c2l(e.yerrneg), "hover").text : e.yLabel += " \xB1 " + c, t === "y" && (e.distance += 1);
                }
                var f = e.hoverinfo || e.trace.hoverinfo;
                return f && f !== "all" && (f = Array.isArray(f) ? f : f.split("+"), f.indexOf("x") === -1 && (e.xLabel = void 0), f.indexOf("y") === -1 && (e.yLabel = void 0), f.indexOf("z") === -1 && (e.zLabel = void 0), f.indexOf("text") === -1 && (e.text = void 0), f.indexOf("name") === -1 && (e.name = void 0)), e;
            }
            function Tle(e, t, r) {
                var n = r.container, i = r.fullLayout, a = i._size, o = r.event, s = !!t.hLinePoint, l = !!t.vLinePoint, u, c;
                if (n.selectAll(".spikeline").remove(), !!(l || s)) {
                    var f = sd.combine(i.plot_bgcolor, i.paper_bgcolor);
                    if (s) {
                        var h = t.hLinePoint, d, v;
                        u = h && h.xa, c = h && h.ya;
                        var x = c.spikesnap;
                        x === "cursor" ? (d = o.pointerX, v = o.pointerY) : (d = u._offset + h.x, v = c._offset + h.y);
                        var b = _le.readability(h.color, f) < 1.5 ? sd.contrast(f) : h.color, p = c.spikemode, E = c.spikethickness, k = c.spikecolor || b, A = wm.getPxPosition(e, c), L, _;
                        if (p.indexOf("toaxis") !== -1 || p.indexOf("across") !== -1) {
                            if (p.indexOf("toaxis") !== -1 && (L = A, _ = d), p.indexOf("across") !== -1) {
                                var C = c._counterDomainMin, M = c._counterDomainMax;
                                c.anchor === "free" && (C = Math.min(C, c.position), M = Math.max(M, c.position)), L = a.l + C * a.w, _ = a.l + M * a.w;
                            }
                            n.insert("line", ":first-child").attr({
                                x1: L,
                                x2: _,
                                y1: v,
                                y2: v,
                                "stroke-width": E,
                                stroke: k,
                                "stroke-dasharray": bm.dashStyle(c.spikedash, E)
                            }).classed("spikeline", !0).classed("crisp", !0), n.insert("line", ":first-child").attr({
                                x1: L,
                                x2: _,
                                y1: v,
                                y2: v,
                                "stroke-width": E + 2,
                                stroke: f
                            }).classed("spikeline", !0).classed("crisp", !0);
                        }
                        p.indexOf("marker") !== -1 && n.insert("circle", ":first-child").attr({
                            cx: A + (c.side !== "right" ? E : -E),
                            cy: v,
                            r: E,
                            fill: k
                        }).classed("spikeline", !0);
                    }
                    if (l) {
                        var g = t.vLinePoint, P, T;
                        u = g && g.xa, c = g && g.ya;
                        var F = u.spikesnap;
                        F === "cursor" ? (P = o.pointerX, T = o.pointerY) : (P = u._offset + g.x, T = c._offset + g.y);
                        var q = _le.readability(g.color, f) < 1.5 ? sd.contrast(f) : g.color, V = u.spikemode, H = u.spikethickness, X = u.spikecolor || q, G = wm.getPxPosition(e, u), N, W;
                        if (V.indexOf("toaxis") !== -1 || V.indexOf("across") !== -1) {
                            if (V.indexOf("toaxis") !== -1 && (N = G, W = T), V.indexOf("across") !== -1) {
                                var re = u._counterDomainMin, ae = u._counterDomainMax;
                                u.anchor === "free" && (re = Math.min(re, u.position), ae = Math.max(ae, u.position)), N = a.t + (1 - ae) * a.h, W = a.t + (1 - re) * a.h;
                            }
                            n.insert("line", ":first-child").attr({
                                x1: P,
                                x2: P,
                                y1: N,
                                y2: W,
                                "stroke-width": H,
                                stroke: X,
                                "stroke-dasharray": bm.dashStyle(u.spikedash, H)
                            }).classed("spikeline", !0).classed("crisp", !0), n.insert("line", ":first-child").attr({
                                x1: P,
                                x2: P,
                                y1: N,
                                y2: W,
                                "stroke-width": H + 2,
                                stroke: f
                            }).classed("spikeline", !0).classed("crisp", !0);
                        }
                        V.indexOf("marker") !== -1 && n.insert("circle", ":first-child").attr({
                            cx: P,
                            cy: G - (u.side !== "top" ? H : -H),
                            r: H,
                            fill: X
                        }).classed("spikeline", !0);
                    }
                }
            }
            function Xst(e, t, r) {
                if (!r || r.length !== e._hoverdata.length) return !0;
                for(var n = r.length - 1; n >= 0; n--){
                    var i = r[n], a = e._hoverdata[n];
                    if (i.curveNumber !== a.curveNumber || String(i.pointNumber) !== String(a.pointNumber) || String(i.pointNumbers) !== String(a.pointNumbers)) return !0;
                }
                return !1;
            }
            function Ale(e, t) {
                return !t || t.vLinePoint !== e._spikepoints.vLinePoint || t.hLinePoint !== e._spikepoints.hLinePoint;
            }
            function Sle(e, t) {
                return A0.plainText(e || "", {
                    len: t,
                    allowedTags: [
                        "br",
                        "sub",
                        "sup",
                        "b",
                        "i",
                        "em",
                        "s",
                        "u"
                    ]
                });
            }
            function Yst(e, t) {
                for(var r = t.charAt(0), n = [], i = [], a = [], o = 0; o < e.length; o++){
                    var s = e[o];
                    U3.traceIs(s.trace, "bar-like") || U3.traceIs(s.trace, "box-violin") ? a.push(s) : s.trace[r + "period"] ? i.push(s) : n.push(s);
                }
                return n.concat(i).concat(a);
            }
            function Mle(e, t, r) {
                var n = t[e + "a"], i = t[e + "Val"], a = t.cd[0];
                if (n.type === "category" || n.type === "multicategory") i = n._categoriesMap[i];
                else if (n.type === "date") {
                    var o = t.trace[e + "periodalignment"];
                    if (o) {
                        var s = t.cd[t.index], l = s[e + "Start"];
                        l === void 0 && (l = s[e]);
                        var u = s[e + "End"];
                        u === void 0 && (u = s[e]);
                        var c = u - l;
                        o === "end" ? i += c : o === "middle" && (i += c / 2);
                    }
                    i = n.d2c(i);
                }
                return a && a.t && a.t.posLetter === n._id && (r.boxmode === "group" || r.violinmode === "group") && (i += a.t.dPos), i;
            }
            function Ile(e) {
                return e.offsetTop + e.clientTop;
            }
            function Rle(e) {
                return e.offsetLeft + e.clientLeft;
            }
            function N3(e, t) {
                var r = e._fullLayout, n = t.getBoundingClientRect(), i = n.left, a = n.top, o = i + n.width, s = a + n.height, l = Rf.apply3DTransform(r._invTransform)(i, a), u = Rf.apply3DTransform(r._invTransform)(o, s), c = l[0], f = l[1], h = u[0], d = u[1];
                return {
                    x: c,
                    y: f,
                    width: h - c,
                    height: d - f,
                    top: Math.min(f, d),
                    left: Math.min(c, h),
                    right: Math.max(c, h),
                    bottom: Math.max(f, d)
                };
            }
        });
        var oM = ye((Zrr, Dle)=>{
            "use strict";
            var Kst = Mr(), Jst = va(), $st = rp().isUnifiedHover;
            Dle.exports = function(t, r, n, i) {
                i = i || {};
                var a = r.legend;
                function o(s) {
                    i.font[s] || (i.font[s] = a ? r.legend.font[s] : r.font[s]);
                }
                r && $st(r.hovermode) && (i.font || (i.font = {}), o("size"), o("family"), o("color"), o("weight"), o("style"), o("variant"), a ? (i.bgcolor || (i.bgcolor = Jst.combine(r.legend.bgcolor, r.paper_bgcolor)), i.bordercolor || (i.bordercolor = r.legend.bordercolor)) : i.bgcolor || (i.bgcolor = r.paper_bgcolor)), n("hoverlabel.bgcolor", i.bgcolor), n("hoverlabel.bordercolor", i.bordercolor), n("hoverlabel.namelength", i.namelength), Kst.coerceFont(n, "hoverlabel.font", i.font), n("hoverlabel.align", i.align);
            };
        });
        var Fle = ye((Xrr, zle)=>{
            "use strict";
            var Qst = Mr(), elt = oM(), tlt = N1();
            zle.exports = function(t, r) {
                function n(i, a) {
                    return Qst.coerce(t, r, tlt, i, a);
                }
                elt(t, r, n);
            };
        });
        var Ble = ye((Yrr, Ole)=>{
            "use strict";
            var qle = Mr(), rlt = i3(), ilt = oM();
            Ole.exports = function(t, r, n, i) {
                function a(s, l) {
                    return qle.coerce(t, r, rlt, s, l);
                }
                var o = qle.extendFlat({}, i.hoverlabel);
                r.hovertemplate && (o.namelength = -1), ilt(t, r, a, o);
            };
        });
        var OB = ye((Krr, Nle)=>{
            "use strict";
            var nlt = Mr(), alt = N1();
            Nle.exports = function(t, r) {
                function n(i, a) {
                    return r[i] !== void 0 ? r[i] : nlt.coerce(t, r, alt, i, a);
                }
                return n("clickmode"), n("hoversubplots"), n("hovermode");
            };
        });
        var Hle = ye((Jrr, Vle)=>{
            "use strict";
            var Ule = Mr(), olt = N1(), slt = OB(), llt = oM();
            Vle.exports = function(t, r) {
                function n(c, f) {
                    return Ule.coerce(t, r, olt, c, f);
                }
                var i = slt(t, r);
                i && (n("hoverdistance"), n("spikedistance"));
                var a = n("dragmode");
                a === "select" && n("selectdirection");
                var o = r._has("mapbox"), s = r._has("map"), l = r._has("geo"), u = r._basePlotModules.length;
                r.dragmode === "zoom" && ((o || s || l) && u === 1 || (o || s) && l && u === 2) && (r.dragmode = "pan"), llt(t, r, n), Ule.coerceFont(n, "hoverlabel.grouptitlefont", r.hoverlabel.font);
            };
        });
        var Wle = ye(($rr, jle)=>{
            "use strict";
            var BB = Mr(), Gle = ba();
            jle.exports = function(t) {
                var r = t.calcdata, n = t._fullLayout;
                function i(u) {
                    return function(c) {
                        return BB.coerceHoverinfo({
                            hoverinfo: c
                        }, {
                            _module: u._module
                        }, n);
                    };
                }
                for(var a = 0; a < r.length; a++){
                    var o = r[a], s = o[0].trace;
                    if (!Gle.traceIs(s, "pie-like")) {
                        var l = Gle.traceIs(s, "2dMap") ? ult : BB.fillArray;
                        l(s.hoverinfo, o, "hi", i(s)), s.hovertemplate && l(s.hovertemplate, o, "ht"), s.hoverlabel && (l(s.hoverlabel.bgcolor, o, "hbg"), l(s.hoverlabel.bordercolor, o, "hbc"), l(s.hoverlabel.font.size, o, "hts"), l(s.hoverlabel.font.color, o, "htc"), l(s.hoverlabel.font.family, o, "htf"), l(s.hoverlabel.font.weight, o, "htw"), l(s.hoverlabel.font.style, o, "hty"), l(s.hoverlabel.font.variant, o, "htv"), l(s.hoverlabel.namelength, o, "hnl"), l(s.hoverlabel.align, o, "hta"));
                    }
                }
            };
            function ult(e, t, r, n) {
                n = n || BB.identity, Array.isArray(e) && (t[0][r] = n(e));
            }
        });
        var Xle = ye((Qrr, Zle)=>{
            "use strict";
            var clt = ba(), flt = qB().hover;
            Zle.exports = function(t, r, n) {
                var i = clt.getComponentMethod("annotations", "onClick")(t, t._hoverdata);
                n !== void 0 && flt(t, r, n, !0);
                function a() {
                    t.emit("plotly_click", {
                        points: t._hoverdata,
                        event: r
                    });
                }
                t._hoverdata && r && r.target && (i && i.then ? i.then(a) : a(), r.stopImmediatePropagation && r.stopImmediatePropagation());
            };
        });
        var Nc = ye((eir, Jle)=>{
            "use strict";
            var hlt = xa(), NL = Mr(), dlt = gv(), sM = rp(), Yle = N1(), Kle = qB();
            Jle.exports = {
                moduleType: "component",
                name: "fx",
                constants: IS(),
                schema: {
                    layout: Yle
                },
                attributes: i3(),
                layoutAttributes: Yle,
                supplyLayoutGlobalDefaults: Fle(),
                supplyDefaults: Ble(),
                supplyLayoutDefaults: Hle(),
                calc: Wle(),
                getDistanceFunction: sM.getDistanceFunction,
                getClosest: sM.getClosest,
                inbox: sM.inbox,
                quadrature: sM.quadrature,
                appendArrayPointValue: sM.appendArrayPointValue,
                castHoverOption: plt,
                castHoverinfo: glt,
                hover: Kle.hover,
                unhover: dlt.unhover,
                loneHover: Kle.loneHover,
                loneUnhover: vlt,
                click: Xle()
            };
            function vlt(e) {
                var t = NL.isD3Selection(e) ? e : hlt.select(e);
                t.selectAll("g.hovertext").remove(), t.selectAll(".spikeline").remove();
            }
            function plt(e, t, r) {
                return NL.castOption(e, t, "hoverlabel." + r);
            }
            function glt(e, t, r) {
                function n(i) {
                    return NL.coerceHoverinfo({
                        hoverinfo: i
                    }, {
                        _module: e._module
                    }, t);
                }
                return NL.castOption(e, r, "hoverinfo", n);
            }
        });
        var Sg = ye((My)=>{
            "use strict";
            My.selectMode = function(e) {
                return e === "lasso" || e === "select";
            };
            My.drawMode = function(e) {
                return e === "drawclosedpath" || e === "drawopenpath" || e === "drawline" || e === "drawrect" || e === "drawcircle";
            };
            My.openMode = function(e) {
                return e === "drawline" || e === "drawopenpath";
            };
            My.rectMode = function(e) {
                return e === "select" || e === "drawline" || e === "drawrect" || e === "drawcircle";
            };
            My.freeMode = function(e) {
                return e === "lasso" || e === "drawclosedpath" || e === "drawopenpath";
            };
            My.selectingOrDrawing = function(e) {
                return My.freeMode(e) || My.rectMode(e);
            };
        });
        var lM = ye((rir, $le)=>{
            "use strict";
            $le.exports = function(t) {
                var r = t._fullLayout;
                r._glcanvas && r._glcanvas.size() && r._glcanvas.each(function(n) {
                    n.regl && n.regl.clear({
                        color: !0,
                        depth: !0
                    });
                });
            };
        });
        var UL = ye((iir, Qle)=>{
            "use strict";
            Qle.exports = {
                undo: {
                    width: 857.1,
                    height: 1e3,
                    path: "m857 350q0-87-34-166t-91-137-137-92-166-34q-96 0-183 41t-147 114q-4 6-4 13t5 11l76 77q6 5 14 5 9-1 13-7 41-53 100-82t126-29q58 0 110 23t92 61 61 91 22 111-22 111-61 91-92 61-110 23q-55 0-105-20t-90-57l77-77q17-16 8-38-10-23-33-23h-250q-15 0-25 11t-11 25v250q0 24 22 33 22 10 39-8l72-72q60 57 137 88t159 31q87 0 166-34t137-92 91-137 34-166z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                home: {
                    width: 928.6,
                    height: 1e3,
                    path: "m786 296v-267q0-15-11-26t-25-10h-214v214h-143v-214h-214q-15 0-25 10t-11 26v267q0 1 0 2t0 2l321 264 321-264q1-1 1-4z m124 39l-34-41q-5-5-12-6h-2q-7 0-12 3l-386 322-386-322q-7-4-13-4-7 2-12 7l-35 41q-4 5-3 13t6 12l401 334q18 15 42 15t43-15l136-114v109q0 8 5 13t13 5h107q8 0 13-5t5-13v-227l122-102q5-5 6-12t-4-13z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                "camera-retro": {
                    width: 1e3,
                    height: 1e3,
                    path: "m518 386q0 8-5 13t-13 5q-37 0-63-27t-26-63q0-8 5-13t13-5 12 5 5 13q0 23 16 38t38 16q8 0 13 5t5 13z m125-73q0-59-42-101t-101-42-101 42-42 101 42 101 101 42 101-42 42-101z m-572-320h858v71h-858v-71z m643 320q0 89-62 152t-152 62-151-62-63-152 63-151 151-63 152 63 62 151z m-571 358h214v72h-214v-72z m-72-107h858v143h-462l-36-71h-360v-72z m929 143v-714q0-30-21-51t-50-21h-858q-29 0-50 21t-21 51v714q0 30 21 51t50 21h858q29 0 50-21t21-51z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                zoombox: {
                    width: 1e3,
                    height: 1e3,
                    path: "m1000-25l-250 251c40 63 63 138 63 218 0 224-182 406-407 406-224 0-406-182-406-406s183-406 407-406c80 0 155 22 218 62l250-250 125 125z m-812 250l0 438 437 0 0-438-437 0z m62 375l313 0 0-312-313 0 0 312z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                pan: {
                    width: 1e3,
                    height: 1e3,
                    path: "m1000 350l-187 188 0-125-250 0 0 250 125 0-188 187-187-187 125 0 0-250-250 0 0 125-188-188 186-187 0 125 252 0 0-250-125 0 187-188 188 188-125 0 0 250 250 0 0-126 187 188z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                zoom_plus: {
                    width: 875,
                    height: 1e3,
                    path: "m1 787l0-875 875 0 0 875-875 0z m687-500l-187 0 0-187-125 0 0 187-188 0 0 125 188 0 0 187 125 0 0-187 187 0 0-125z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                zoom_minus: {
                    width: 875,
                    height: 1e3,
                    path: "m0 788l0-876 875 0 0 876-875 0z m688-500l-500 0 0 125 500 0 0-125z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                autoscale: {
                    width: 1e3,
                    height: 1e3,
                    path: "m250 850l-187 0-63 0 0-62 0-188 63 0 0 188 187 0 0 62z m688 0l-188 0 0-62 188 0 0-188 62 0 0 188 0 62-62 0z m-875-938l0 188-63 0 0-188 0-62 63 0 187 0 0 62-187 0z m875 188l0-188-188 0 0-62 188 0 62 0 0 62 0 188-62 0z m-125 188l-1 0-93-94-156 156 156 156 92-93 2 0 0 250-250 0 0-2 93-92-156-156-156 156 94 92 0 2-250 0 0-250 0 0 93 93 157-156-157-156-93 94 0 0 0-250 250 0 0 0-94 93 156 157 156-157-93-93 0 0 250 0 0 250z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                tooltip_basic: {
                    width: 1500,
                    height: 1e3,
                    path: "m375 725l0 0-375-375 375-374 0-1 1125 0 0 750-1125 0z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                tooltip_compare: {
                    width: 1125,
                    height: 1e3,
                    path: "m187 786l0 2-187-188 188-187 0 0 937 0 0 373-938 0z m0-499l0 1-187-188 188-188 0 0 937 0 0 376-938-1z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                plotlylogo: {
                    width: 1542,
                    height: 1e3,
                    path: "m0-10h182v-140h-182v140z m228 146h183v-286h-183v286z m225 714h182v-1000h-182v1000z m225-285h182v-715h-182v715z m225 142h183v-857h-183v857z m231-428h182v-429h-182v429z m225-291h183v-138h-183v138z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                "z-axis": {
                    width: 1e3,
                    height: 1e3,
                    path: "m833 5l-17 108v41l-130-65 130-66c0 0 0 38 0 39 0-1 36-14 39-25 4-15-6-22-16-30-15-12-39-16-56-20-90-22-187-23-279-23-261 0-341 34-353 59 3 60 228 110 228 110-140-8-351-35-351-116 0-120 293-142 474-142 155 0 477 22 477 142 0 50-74 79-163 96z m-374 94c-58-5-99-21-99-40 0-24 65-43 144-43 79 0 143 19 143 43 0 19-42 34-98 40v216h87l-132 135-133-135h88v-216z m167 515h-136v1c16 16 31 34 46 52l84 109v54h-230v-71h124v-1c-16-17-28-32-44-51l-89-114v-51h245v72z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                "3d_rotate": {
                    width: 1e3,
                    height: 1e3,
                    path: "m922 660c-5 4-9 7-14 11-359 263-580-31-580-31l-102 28 58-400c0 1 1 1 2 2 118 108 351 249 351 249s-62 27-100 42c88 83 222 183 347 122 16-8 30-17 44-27-2 1-4 2-6 4z m36-329c0 0 64 229-88 296-62 27-124 14-175-11 157-78 225-208 249-266 8-19 11-31 11-31 2 5 6 15 11 32-5-13-8-20-8-20z m-775-239c70-31 117-50 198-32-121 80-199 346-199 346l-96-15-58-12c0 0 55-226 155-287z m603 133l-317-139c0 0 4-4 19-14 7-5 24-15 24-15s-177-147-389 4c235-287 536-112 536-112l31-22 100 299-4-1z m-298-153c6-4 14-9 24-15 0 0-17 10-24 15z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                camera: {
                    width: 1e3,
                    height: 1e3,
                    path: "m500 450c-83 0-150-67-150-150 0-83 67-150 150-150 83 0 150 67 150 150 0 83-67 150-150 150z m400 150h-120c-16 0-34 13-39 29l-31 93c-6 15-23 28-40 28h-340c-16 0-34-13-39-28l-31-94c-6-15-23-28-40-28h-120c-55 0-100-45-100-100v-450c0-55 45-100 100-100h800c55 0 100 45 100 100v450c0 55-45 100-100 100z m-400-550c-138 0-250 112-250 250 0 138 112 250 250 250 138 0 250-112 250-250 0-138-112-250-250-250z m365 380c-19 0-35 16-35 35 0 19 16 35 35 35 19 0 35-16 35-35 0-19-16-35-35-35z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                movie: {
                    width: 1e3,
                    height: 1e3,
                    path: "m938 413l-188-125c0 37-17 71-44 94 64 38 107 107 107 187 0 121-98 219-219 219-121 0-219-98-219-219 0-61 25-117 66-156h-115c30 33 49 76 49 125 0 103-84 187-187 187s-188-84-188-187c0-57 26-107 65-141-38-22-65-62-65-109v-250c0-70 56-126 125-126h500c69 0 125 56 125 126l188-126c34 0 62 28 62 63v375c0 35-28 63-62 63z m-750 0c-69 0-125 56-125 125s56 125 125 125 125-56 125-125-56-125-125-125z m406-1c-87 0-157 70-157 157 0 86 70 156 157 156s156-70 156-156-70-157-156-157z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                question: {
                    width: 857.1,
                    height: 1e3,
                    path: "m500 82v107q0 8-5 13t-13 5h-107q-8 0-13-5t-5-13v-107q0-8 5-13t13-5h107q8 0 13 5t5 13z m143 375q0 49-31 91t-77 65-95 23q-136 0-207-119-9-14 4-24l74-55q4-4 10-4 9 0 14 7 30 38 48 51 19 14 48 14 27 0 48-15t21-33q0-21-11-34t-38-25q-35-16-65-48t-29-70v-20q0-8 5-13t13-5h107q8 0 13 5t5 13q0 10 12 27t30 28q18 10 28 16t25 19 25 27 16 34 7 45z m214-107q0-117-57-215t-156-156-215-58-216 58-155 156-58 215 58 215 155 156 216 58 215-58 156-156 57-215z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                disk: {
                    width: 857.1,
                    height: 1e3,
                    path: "m214-7h429v214h-429v-214z m500 0h72v500q0 8-6 21t-11 20l-157 156q-5 6-19 12t-22 5v-232q0-22-15-38t-38-16h-322q-22 0-37 16t-16 38v232h-72v-714h72v232q0 22 16 38t37 16h465q22 0 38-16t15-38v-232z m-214 518v178q0 8-5 13t-13 5h-107q-7 0-13-5t-5-13v-178q0-8 5-13t13-5h107q7 0 13 5t5 13z m357-18v-518q0-22-15-38t-38-16h-750q-23 0-38 16t-16 38v750q0 22 16 38t38 16h517q23 0 50-12t42-26l156-157q16-15 27-42t11-49z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                drawopenpath: {
                    width: 70,
                    height: 70,
                    path: "M33.21,85.65a7.31,7.31,0,0,1-2.59-.48c-8.16-3.11-9.27-19.8-9.88-41.3-.1-3.58-.19-6.68-.35-9-.15-2.1-.67-3.48-1.43-3.79-2.13-.88-7.91,2.32-12,5.86L3,32.38c1.87-1.64,11.55-9.66,18.27-6.9,2.13.87,4.75,3.14,5.17,9,.17,2.43.26,5.59.36,9.25a224.17,224.17,0,0,0,1.5,23.4c1.54,10.76,4,12.22,4.48,12.4.84.32,2.79-.46,5.76-3.59L43,80.07C41.53,81.57,37.68,85.64,33.21,85.65ZM74.81,69a11.34,11.34,0,0,0,6.09-6.72L87.26,44.5,74.72,32,56.9,38.35c-2.37.86-5.57,3.42-6.61,6L38.65,72.14l8.42,8.43ZM55,46.27a7.91,7.91,0,0,1,3.64-3.17l14.8-5.3,8,8L76.11,60.6l-.06.19a6.37,6.37,0,0,1-3,3.43L48.25,74.59,44.62,71Zm16.57,7.82A6.9,6.9,0,1,0,64.64,61,6.91,6.91,0,0,0,71.54,54.09Zm-4.05,0a2.85,2.85,0,1,1-2.85-2.85A2.86,2.86,0,0,1,67.49,54.09Zm-4.13,5.22L60.5,56.45,44.26,72.7l2.86,2.86ZM97.83,35.67,84.14,22l-8.57,8.57L89.26,44.24Zm-13.69-8,8,8-2.85,2.85-8-8Z",
                    transform: "matrix(1 0 0 1 -15 -15)"
                },
                drawclosedpath: {
                    width: 90,
                    height: 90,
                    path: "M88.41,21.12a26.56,26.56,0,0,0-36.18,0l-2.07,2-2.07-2a26.57,26.57,0,0,0-36.18,0,23.74,23.74,0,0,0,0,34.8L48,90.12a3.22,3.22,0,0,0,4.42,0l36-34.21a23.73,23.73,0,0,0,0-34.79ZM84,51.24,50.16,83.35,16.35,51.25a17.28,17.28,0,0,1,0-25.47,20,20,0,0,1,27.3,0l4.29,4.07a3.23,3.23,0,0,0,4.44,0l4.29-4.07a20,20,0,0,1,27.3,0,17.27,17.27,0,0,1,0,25.46ZM66.76,47.68h-33v6.91h33ZM53.35,35H46.44V68h6.91Z",
                    transform: "matrix(1 0 0 1 -5 -5)"
                },
                lasso: {
                    width: 1031,
                    height: 1e3,
                    path: "m1018 538c-36 207-290 336-568 286-277-48-473-256-436-463 10-57 36-108 76-151-13-66 11-137 68-183 34-28 75-41 114-42l-55-70 0 0c-2-1-3-2-4-3-10-14-8-34 5-45 14-11 34-8 45 4 1 1 2 3 2 5l0 0 113 140c16 11 31 24 45 40 4 3 6 7 8 11 48-3 100 0 151 9 278 48 473 255 436 462z m-624-379c-80 14-149 48-197 96 42 42 109 47 156 9 33-26 47-66 41-105z m-187-74c-19 16-33 37-39 60 50-32 109-55 174-68-42-25-95-24-135 8z m360 75c-34-7-69-9-102-8 8 62-16 128-68 170-73 59-175 54-244-5-9 20-16 40-20 61-28 159 121 317 333 354s407-60 434-217c28-159-121-318-333-355z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                selectbox: {
                    width: 1e3,
                    height: 1e3,
                    path: "m0 850l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-285l0-143 143 0 0 143-143 0z m857 0l0-143 143 0 0 143-143 0z m-857-286l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z m285 0l0-143 143 0 0 143-143 0z m286 0l0-143 143 0 0 143-143 0z",
                    transform: "matrix(1 0 0 -1 0 850)"
                },
                drawline: {
                    width: 70,
                    height: 70,
                    path: "M60.64,62.3a11.29,11.29,0,0,0,6.09-6.72l6.35-17.72L60.54,25.31l-17.82,6.4c-2.36.86-5.57,3.41-6.6,6L24.48,65.5l8.42,8.42ZM40.79,39.63a7.89,7.89,0,0,1,3.65-3.17l14.79-5.31,8,8L61.94,54l-.06.19a6.44,6.44,0,0,1-3,3.43L34.07,68l-3.62-3.63Zm16.57,7.81a6.9,6.9,0,1,0-6.89,6.9A6.9,6.9,0,0,0,57.36,47.44Zm-4,0a2.86,2.86,0,1,1-2.85-2.85A2.86,2.86,0,0,1,53.32,47.44Zm-4.13,5.22L46.33,49.8,30.08,66.05l2.86,2.86ZM83.65,29,70,15.34,61.4,23.9,75.09,37.59ZM70,21.06l8,8-2.84,2.85-8-8ZM87,80.49H10.67V87H87Z",
                    transform: "matrix(1 0 0 1 -15 -15)"
                },
                drawrect: {
                    width: 80,
                    height: 80,
                    path: "M78,22V79H21V22H78m9-9H12V88H87V13ZM68,46.22H31V54H68ZM53,32H45.22V69H53Z",
                    transform: "matrix(1 0 0 1 -10 -10)"
                },
                drawcircle: {
                    width: 80,
                    height: 80,
                    path: "M50,84.72C26.84,84.72,8,69.28,8,50.3S26.84,15.87,50,15.87,92,31.31,92,50.3,73.16,84.72,50,84.72Zm0-60.59c-18.6,0-33.74,11.74-33.74,26.17S31.4,76.46,50,76.46,83.74,64.72,83.74,50.3,68.6,24.13,50,24.13Zm17.15,22h-34v7.11h34Zm-13.8-13H46.24v34h7.11Z",
                    transform: "matrix(1 0 0 1 -10 -10)"
                },
                eraseshape: {
                    width: 80,
                    height: 80,
                    path: "M82.77,78H31.85L6,49.57,31.85,21.14H82.77a8.72,8.72,0,0,1,8.65,8.77V69.24A8.72,8.72,0,0,1,82.77,78ZM35.46,69.84H82.77a.57.57,0,0,0,.49-.6V29.91a.57.57,0,0,0-.49-.61H35.46L17,49.57Zm32.68-34.7-24,24,5,5,24-24Zm-19,.53-5,5,24,24,5-5Z",
                    transform: "matrix(1 0 0 1 -10 -10)"
                },
                spikeline: {
                    width: 1e3,
                    height: 1e3,
                    path: "M512 409c0-57-46-104-103-104-57 0-104 47-104 104 0 57 47 103 104 103 57 0 103-46 103-103z m-327-39l92 0 0 92-92 0z m-185 0l92 0 0 92-92 0z m370-186l92 0 0 93-92 0z m0-184l92 0 0 92-92 0z",
                    transform: "matrix(1.5 0 0 -1.5 0 850)"
                },
                pencil: {
                    width: 1792,
                    height: 1792,
                    path: "M491 1536l91-91-235-235-91 91v107h128v128h107zm523-928q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zm-54-192l416 416-832 832h-416v-416zm683 96q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z",
                    transform: "matrix(1 0 0 1 0 1)"
                },
                newplotlylogo: {
                    name: "newplotlylogo",
                    svg: [
                        "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 132 132'>",
                        " <title>plotly-logomark</title>",
                        " <g id='symbol'>",
                        "  <rect fill='#000' x='0' y='0' width='132' height='132' rx='18' ry='18'/>",
                        "  <circle fill='#9EF' cx='102' cy='30' r='6'/>",
                        "  <circle fill='#BAC' cx='78' cy='30' r='6'/>",
                        "  <circle fill='#BAC' cx='78' cy='54' r='6'/>",
                        "  <circle fill='#D69' cx='54' cy='30' r='6'/>",
                        "  <circle fill='#F26' cx='30' cy='30' r='6'/>",
                        "  <circle fill='#F26' cx='30' cy='54' r='6'/>",
                        "  <path fill='#FFF' d='M30,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,30,72Z'/>",
                        "  <path fill='#FFF' d='M78,72a6,6,0,0,0-6,6v24a6,6,0,0,0,12,0V78A6,6,0,0,0,78,72Z'/>",
                        "  <path fill='#FFF' d='M54,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,54,48Z'/>",
                        "  <path fill='#FFF' d='M102,48a6,6,0,0,0-6,6v48a6,6,0,0,0,12,0V54A6,6,0,0,0,102,48Z'/>",
                        " </g>",
                        "</svg>"
                    ].join("")
                }
            };
        });
        var HL = ye((nir, eue)=>{
            "use strict";
            var VL = 32;
            eue.exports = {
                CIRCLE_SIDES: VL,
                i000: 0,
                i090: VL / 4,
                i180: VL / 2,
                i270: VL / 4 * 3,
                cos45: Math.cos(Math.PI / 4),
                sin45: Math.sin(Math.PI / 4),
                SQRT2: Math.sqrt(2)
            };
        });
        var GL = ye((air, rue)=>{
            "use strict";
            var mlt = Mr().strTranslate;
            function tue(e, t) {
                switch(e.type){
                    case "log":
                        return e.p2d(t);
                    case "date":
                        return e.p2r(t, 0, e.calendar);
                    default:
                        return e.p2r(t);
                }
            }
            function ylt(e, t) {
                switch(e.type){
                    case "log":
                        return e.d2p(t);
                    case "date":
                        return e.r2p(t, 0, e.calendar);
                    default:
                        return e.r2p(t);
                }
            }
            function _lt(e) {
                var t = e._id.charAt(0) === "y" ? 1 : 0;
                return function(r) {
                    return tue(e, r[t]);
                };
            }
            function xlt(e) {
                return mlt(e.xaxis._offset, e.yaxis._offset);
            }
            rue.exports = {
                p2r: tue,
                r2p: ylt,
                axValue: _lt,
                getTransform: xlt
            };
        });
        var c_ = ye((Ey)=>{
            "use strict";
            var blt = XS(), aue = HL(), V3 = aue.CIRCLE_SIDES, NB = aue.SQRT2, oue = GL(), iue = oue.p2r, nue = oue.r2p, wlt = [
                0,
                3,
                4,
                5,
                6,
                1,
                2
            ], Tlt = [
                0,
                3,
                4,
                1,
                2
            ];
            Ey.writePaths = function(e) {
                var t = e.length;
                if (!t) return "M0,0Z";
                for(var r = "", n = 0; n < t; n++)for(var i = e[n].length, a = 0; a < i; a++){
                    var o = e[n][a][0];
                    if (o === "Z") r += "Z";
                    else for(var s = e[n][a].length, l = 0; l < s; l++){
                        var u = l;
                        o === "Q" || o === "S" ? u = Tlt[l] : o === "C" && (u = wlt[l]), r += e[n][a][u], l > 0 && l < s - 1 && (r += ",");
                    }
                }
                return r;
            };
            Ey.readPaths = function(e, t, r, n) {
                var i = blt(e), a = [], o = -1, s = function() {
                    o++, a[o] = [];
                }, l, u = 0, c = 0, f, h, d = function() {
                    f = u, h = c;
                };
                d();
                for(var v = 0; v < i.length; v++){
                    var x = [], b, p, E, k, A = i[v][0], L = A;
                    switch(A){
                        case "M":
                            s(), u = +i[v][1], c = +i[v][2], x.push([
                                L,
                                u,
                                c
                            ]), d();
                            break;
                        case "Q":
                        case "S":
                            b = +i[v][1], E = +i[v][2], u = +i[v][3], c = +i[v][4], x.push([
                                L,
                                u,
                                c,
                                b,
                                E
                            ]);
                            break;
                        case "C":
                            b = +i[v][1], E = +i[v][2], p = +i[v][3], k = +i[v][4], u = +i[v][5], c = +i[v][6], x.push([
                                L,
                                u,
                                c,
                                b,
                                E,
                                p,
                                k
                            ]);
                            break;
                        case "T":
                        case "L":
                            u = +i[v][1], c = +i[v][2], x.push([
                                L,
                                u,
                                c
                            ]);
                            break;
                        case "H":
                            L = "L", u = +i[v][1], x.push([
                                L,
                                u,
                                c
                            ]);
                            break;
                        case "V":
                            L = "L", c = +i[v][1], x.push([
                                L,
                                u,
                                c
                            ]);
                            break;
                        case "A":
                            L = "L";
                            var _ = +i[v][1], C = +i[v][2];
                            +i[v][4] || (_ = -_, C = -C);
                            var M = u - _, g = c;
                            for(l = 1; l <= V3 / 2; l++){
                                var P = 2 * Math.PI * l / V3;
                                x.push([
                                    L,
                                    M + _ * Math.cos(P),
                                    g + C * Math.sin(P)
                                ]);
                            }
                            break;
                        case "Z":
                            (u !== f || c !== h) && (u = f, c = h, x.push([
                                L,
                                u,
                                c
                            ]));
                            break;
                    }
                    for(var T = (r || {}).domain, F = t._fullLayout._size, q = r && r.xsizemode === "pixel", V = r && r.ysizemode === "pixel", H = n === !1, X = 0; X < x.length; X++){
                        for(l = 0; l + 2 < 7; l += 2){
                            var G = x[X][l + 1], N = x[X][l + 2];
                            G === void 0 || N === void 0 || (u = G, c = N, r && (r.xaxis && r.xaxis.p2r ? (H && (G -= r.xaxis._offset), q ? G = nue(r.xaxis, r.xanchor) + G : G = iue(r.xaxis, G)) : (H && (G -= F.l), T ? G = T.x[0] + G / F.w : G = G / F.w), r.yaxis && r.yaxis.p2r ? (H && (N -= r.yaxis._offset), V ? N = nue(r.yaxis, r.yanchor) - N : N = iue(r.yaxis, N)) : (H && (N -= F.t), T ? N = T.y[1] - N / F.h : N = 1 - N / F.h)), x[X][l + 1] = G, x[X][l + 2] = N);
                        }
                        a[o].push(x[X].slice());
                    }
                }
                return a;
            };
            function uM(e, t) {
                return Math.abs(e - t) <= 1e-6;
            }
            function jL(e, t) {
                var r = t[1] - e[1], n = t[2] - e[2];
                return Math.sqrt(r * r + n * n);
            }
            Ey.pointsOnRectangle = function(e) {
                var t = e.length;
                if (t !== 5) return !1;
                for(var r = 1; r < 3; r++){
                    var n = e[0][r] - e[1][r], i = e[3][r] - e[2][r];
                    if (!uM(n, i)) return !1;
                    var a = e[0][r] - e[3][r], o = e[1][r] - e[2][r];
                    if (!uM(a, o)) return !1;
                }
                return !uM(e[0][1], e[1][1]) && !uM(e[0][1], e[3][1]) ? !1 : !!(jL(e[0], e[1]) * jL(e[0], e[3]));
            };
            Ey.pointsOnEllipse = function(e) {
                var t = e.length;
                if (t !== V3 + 1) return !1;
                t = V3;
                for(var r = 0; r < t; r++){
                    var n = (t * 2 - r) % t, i = (t / 2 + n) % t, a = (t / 2 + r) % t;
                    if (!uM(jL(e[r], e[a]), jL(e[n], e[i]))) return !1;
                }
                return !0;
            };
            Ey.handleEllipse = function(e, t, r) {
                if (!e) return [
                    t,
                    r
                ];
                var n = Ey.ellipseOver({
                    x0: t[0],
                    y0: t[1],
                    x1: r[0],
                    y1: r[1]
                }), i = (n.x1 + n.x0) / 2, a = (n.y1 + n.y0) / 2, o = (n.x1 - n.x0) / 2, s = (n.y1 - n.y0) / 2;
                o || (o = s = s / NB), s || (s = o = o / NB);
                for(var l = [], u = 0; u < V3; u++){
                    var c = u * 2 * Math.PI / V3;
                    l.push([
                        i + o * Math.cos(c),
                        a + s * Math.sin(c)
                    ]);
                }
                return l;
            };
            Ey.ellipseOver = function(e) {
                var t = e.x0, r = e.y0, n = e.x1, i = e.y1, a = n - t, o = i - r;
                t -= a, r -= o;
                var s = (t + n) / 2, l = (r + i) / 2, u = NB;
                return a *= u, o *= u, {
                    x0: s - a,
                    y0: l - o,
                    x1: s + a,
                    y1: l + o
                };
            };
            Ey.fixDatesForPaths = function(e, t, r) {
                var n = t.type === "date", i = r.type === "date";
                if (!n && !i) return e;
                for(var a = 0; a < e.length; a++)for(var o = 0; o < e[a].length; o++)for(var s = 0; s + 2 < e[a][o].length; s += 2)n && (e[a][o][s + 1] = e[a][o][s + 1].replace(" ", "_")), i && (e[a][o][s + 2] = e[a][o][s + 2].replace(" ", "_"));
                return e;
            };
        });
        var XL = ye((sir, vue)=>{
            "use strict";
            var fue = Sg(), Alt = fue.drawMode, Slt = fue.openMode, H3 = HL(), sue = H3.i000, lue = H3.i090, uue = H3.i180, cue = H3.i270, Mlt = H3.cos45, Elt = H3.sin45, hue = GL(), WL = hue.p2r, f_ = hue.r2p, klt = e_(), Clt = klt.clearOutline, ZL = c_(), Llt = ZL.readPaths, Plt = ZL.writePaths, Ilt = ZL.ellipseOver, Rlt = ZL.fixDatesForPaths;
            function Dlt(e, t) {
                if (e.length) {
                    var r = e[0][0];
                    if (r) {
                        var n = t.gd, i = t.isActiveShape, a = t.dragmode, o = (n.layout || {}).shapes || [];
                        if (!Alt(a) && i !== void 0) {
                            var s = n._fullLayout._activeShapeIndex;
                            if (s < o.length) switch(n._fullLayout.shapes[s].type){
                                case "rect":
                                    a = "drawrect";
                                    break;
                                case "circle":
                                    a = "drawcircle";
                                    break;
                                case "line":
                                    a = "drawline";
                                    break;
                                case "path":
                                    var l = o[s].path || "";
                                    l[l.length - 1] === "Z" ? a = "drawclosedpath" : a = "drawopenpath";
                                    break;
                            }
                        }
                        var u = due(e, t, a);
                        Clt(n);
                        for(var c = t.editHelpers, f = (c || {}).modifyItem, h = [], d = 0; d < o.length; d++){
                            var v = n._fullLayout.shapes[d];
                            if (h[d] = v._input, i !== void 0 && d === n._fullLayout._activeShapeIndex) {
                                var x = u;
                                switch(v.type){
                                    case "line":
                                    case "rect":
                                    case "circle":
                                        f("x0", x.x0 - (v.x0shift || 0)), f("x1", x.x1 - (v.x1shift || 0)), f("y0", x.y0 - (v.y0shift || 0)), f("y1", x.y1 - (v.y1shift || 0));
                                        break;
                                    case "path":
                                        f("path", x.path);
                                        break;
                                }
                            }
                        }
                        return i === void 0 ? (h.push(u), h) : c ? c.getUpdateObj() : {};
                    }
                }
            }
            function due(e, t, r) {
                var n = e[0][0], i = t.gd, a = n.getAttribute("d"), o = i._fullLayout.newshape, s = t.plotinfo, l = t.isActiveShape, u = s.xaxis, c = s.yaxis, f = !!s.domain || !s.xaxis, h = !!s.domain || !s.yaxis, d = Slt(r), v = Llt(a, i, s, l), x = {
                    editable: !0,
                    visible: o.visible,
                    name: o.name,
                    showlegend: o.showlegend,
                    legend: o.legend,
                    legendwidth: o.legendwidth,
                    legendgroup: o.legendgroup,
                    legendgrouptitle: {
                        text: o.legendgrouptitle.text,
                        font: o.legendgrouptitle.font
                    },
                    legendrank: o.legendrank,
                    label: o.label,
                    xref: f ? "paper" : u._id,
                    yref: h ? "paper" : c._id,
                    layer: o.layer,
                    opacity: o.opacity,
                    line: {
                        color: o.line.color,
                        width: o.line.width,
                        dash: o.line.dash
                    }
                };
                d || (x.fillcolor = o.fillcolor, x.fillrule = o.fillrule);
                var b;
                if (v.length === 1 && (b = v[0]), b && b.length === 5 && r === "drawrect") x.type = "rect", x.x0 = b[0][1], x.y0 = b[0][2], x.x1 = b[2][1], x.y1 = b[2][2];
                else if (b && r === "drawline") x.type = "line", x.x0 = b[0][1], x.y0 = b[0][2], x.x1 = b[1][1], x.y1 = b[1][2];
                else if (b && r === "drawcircle") {
                    x.type = "circle";
                    var p = b[sue][1], E = b[lue][1], k = b[uue][1], A = b[cue][1], L = b[sue][2], _ = b[lue][2], C = b[uue][2], M = b[cue][2], g = s.xaxis && (s.xaxis.type === "date" || s.xaxis.type === "log"), P = s.yaxis && (s.yaxis.type === "date" || s.yaxis.type === "log");
                    g && (p = f_(s.xaxis, p), E = f_(s.xaxis, E), k = f_(s.xaxis, k), A = f_(s.xaxis, A)), P && (L = f_(s.yaxis, L), _ = f_(s.yaxis, _), C = f_(s.yaxis, C), M = f_(s.yaxis, M));
                    var T = (E + A) / 2, F = (L + C) / 2, q = (A - E + k - p) / 2, V = (M - _ + C - L) / 2, H = Ilt({
                        x0: T,
                        y0: F,
                        x1: T + q * Mlt,
                        y1: F + V * Elt
                    });
                    g && (H.x0 = WL(s.xaxis, H.x0), H.x1 = WL(s.xaxis, H.x1)), P && (H.y0 = WL(s.yaxis, H.y0), H.y1 = WL(s.yaxis, H.y1)), x.x0 = H.x0, x.y0 = H.y0, x.x1 = H.x1, x.y1 = H.y1;
                } else x.type = "path", u && c && Rlt(v, u, c), x.path = Plt(v), b = null;
                return x;
            }
            vue.exports = {
                newShapes: Dlt,
                createShapeObj: due
            };
        });
        var VB = ye((lir, pue)=>{
            "use strict";
            var zlt = Sg(), Flt = zlt.selectMode, qlt = e_(), Olt = qlt.clearOutline, UB = c_(), Blt = UB.readPaths, Nlt = UB.writePaths, Ult = UB.fixDatesForPaths;
            pue.exports = function(t, r) {
                if (t.length) {
                    var n = t[0][0];
                    if (n) {
                        var i = n.getAttribute("d"), a = r.gd, o = a._fullLayout.newselection, s = r.plotinfo, l = s.xaxis, u = s.yaxis, c = r.isActiveSelection, f = r.dragmode, h = (a.layout || {}).selections || [];
                        if (!Flt(f) && c !== void 0) {
                            var d = a._fullLayout._activeSelectionIndex;
                            if (d < h.length) switch(a._fullLayout.selections[d].type){
                                case "rect":
                                    f = "select";
                                    break;
                                case "path":
                                    f = "lasso";
                                    break;
                            }
                        }
                        var v = Blt(i, a, s, c), x = {
                            xref: l._id,
                            yref: u._id,
                            opacity: o.opacity,
                            line: {
                                color: o.line.color,
                                width: o.line.width,
                                dash: o.line.dash
                            }
                        }, b;
                        v.length === 1 && (b = v[0]), b && b.length === 5 && f === "select" ? (x.type = "rect", x.x0 = b[0][1], x.y0 = b[0][2], x.x1 = b[2][1], x.y1 = b[2][2]) : (x.type = "path", l && u && Ult(v, l, u), x.path = Nlt(v), b = null), Olt(a);
                        for(var p = r.editHelpers, E = (p || {}).modifyItem, k = [], A = 0; A < h.length; A++){
                            var L = a._fullLayout.selections[A];
                            if (!L) {
                                k[A] = L;
                                continue;
                            }
                            if (k[A] = L._input, c !== void 0 && A === a._fullLayout._activeSelectionIndex) {
                                var _ = x;
                                switch(L.type){
                                    case "rect":
                                        E("x0", _.x0), E("x1", _.x1), E("y0", _.y0), E("y1", _.y1);
                                        break;
                                    case "path":
                                        E("path", _.path);
                                        break;
                                }
                            }
                        }
                        return c === void 0 ? (k.push(x), k) : p ? p.getUpdateObj() : {};
                    }
                }
            };
        });
        var cM = ye((uir, gue)=>{
            "use strict";
            gue.exports = {
                segmentRE: /[MLHVQCTSZ][^MLHVQCTSZ]*/g,
                paramRE: /[^\s,]+/g,
                paramIsX: {
                    M: {
                        0: !0,
                        drawn: 0
                    },
                    L: {
                        0: !0,
                        drawn: 0
                    },
                    H: {
                        0: !0,
                        drawn: 0
                    },
                    V: {},
                    Q: {
                        0: !0,
                        2: !0,
                        drawn: 2
                    },
                    C: {
                        0: !0,
                        2: !0,
                        4: !0,
                        drawn: 4
                    },
                    T: {
                        0: !0,
                        drawn: 0
                    },
                    S: {
                        0: !0,
                        2: !0,
                        drawn: 2
                    },
                    Z: {}
                },
                paramIsY: {
                    M: {
                        1: !0,
                        drawn: 1
                    },
                    L: {
                        1: !0,
                        drawn: 1
                    },
                    H: {},
                    V: {
                        0: !0,
                        drawn: 0
                    },
                    Q: {
                        1: !0,
                        3: !0,
                        drawn: 3
                    },
                    C: {
                        1: !0,
                        3: !0,
                        5: !0,
                        drawn: 5
                    },
                    T: {
                        1: !0,
                        drawn: 1
                    },
                    S: {
                        1: !0,
                        3: !0,
                        drawn: 5
                    },
                    Z: {}
                },
                numParams: {
                    M: 2,
                    L: 2,
                    H: 1,
                    V: 1,
                    Q: 4,
                    C: 6,
                    T: 2,
                    S: 4,
                    Z: 0
                }
            };
        });
        var h_ = ye((Ld)=>{
            "use strict";
            var Fb = cM(), mue = Mr(), YL = Qa();
            Ld.rangeToShapePosition = function(e) {
                return e.type === "log" ? e.r2d : function(t) {
                    return t;
                };
            };
            Ld.shapePositionToRange = function(e) {
                return e.type === "log" ? e.d2r : function(t) {
                    return t;
                };
            };
            Ld.decodeDate = function(e) {
                return function(t) {
                    return t.replace && (t = t.replace("_", " ")), e(t);
                };
            };
            Ld.encodeDate = function(e) {
                return function(t) {
                    return e(t).replace(" ", "_");
                };
            };
            Ld.extractPathCoords = function(e, t, r) {
                var n = [], i = e.match(Fb.segmentRE);
                return i.forEach(function(a) {
                    var o = t[a.charAt(0)].drawn;
                    if (o !== void 0) {
                        var s = a.substr(1).match(Fb.paramRE);
                        if (!(!s || s.length < o)) {
                            var l = s[o], u = r ? l : mue.cleanNumber(l);
                            n.push(u);
                        }
                    }
                }), n;
            };
            Ld.getDataToPixel = function(e, t, r, n, i) {
                var a = e._fullLayout._size, o;
                if (t) {
                    if (i === "domain") o = function(l) {
                        return t._length * (n ? 1 - l : l) + t._offset;
                    };
                    else {
                        var s = Ld.shapePositionToRange(t);
                        o = function(l) {
                            var u = fM(t, r);
                            return t._offset + t.r2p(s(l, !0)) + u;
                        }, t.type === "date" && (o = Ld.decodeDate(o));
                    }
                } else n ? o = function(l) {
                    return a.t + a.h * (1 - l);
                } : o = function(l) {
                    return a.l + a.w * l;
                };
                return o;
            };
            Ld.getPixelToData = function(e, t, r, n) {
                var i = e._fullLayout._size, a;
                if (t) {
                    if (n === "domain") a = function(s) {
                        var l = (s - t._offset) / t._length;
                        return r ? 1 - l : l;
                    };
                    else {
                        var o = Ld.rangeToShapePosition(t);
                        a = function(s) {
                            return o(t.p2r(s - t._offset));
                        };
                    }
                } else r ? a = function(s) {
                    return 1 - (s - i.t) / i.h;
                } : a = function(s) {
                    return (s - i.l) / i.w;
                };
                return a;
            };
            Ld.roundPositionForSharpStrokeRendering = function(e, t) {
                var r = Math.round(t % 2) === 1, n = Math.round(e);
                return r ? n + .5 : n;
            };
            Ld.makeShapesOptionsAndPlotinfo = function(e, t) {
                var r = e._fullLayout.shapes[t] || {}, n = e._fullLayout._plots[r.xref + r.yref], i = !!n;
                return i ? n._hadPlotinfo = !0 : (n = {}, r.xref && r.xref !== "paper" && (n.xaxis = e._fullLayout[r.xref + "axis"]), r.yref && r.yref !== "paper" && (n.yaxis = e._fullLayout[r.yref + "axis"])), n.xsizemode = r.xsizemode, n.ysizemode = r.ysizemode, n.xanchor = r.xanchor, n.yanchor = r.yanchor, {
                    options: r,
                    plotinfo: n
                };
            };
            Ld.makeSelectionsOptionsAndPlotinfo = function(e, t) {
                var r = e._fullLayout.selections[t] || {}, n = e._fullLayout._plots[r.xref + r.yref], i = !!n;
                return i ? n._hadPlotinfo = !0 : (n = {}, r.xref && (n.xaxis = e._fullLayout[r.xref + "axis"]), r.yref && (n.yaxis = e._fullLayout[r.yref + "axis"])), {
                    options: r,
                    plotinfo: n
                };
            };
            Ld.getPathString = function(e, t) {
                var r = t.type, n = YL.getRefType(t.xref), i = YL.getRefType(t.yref), a = YL.getFromId(e, t.xref), o = YL.getFromId(e, t.yref), s = e._fullLayout._size, l, u, c, f, h = fM(a, t.x0shift), d = fM(a, t.x1shift), v = fM(o, t.y0shift), x = fM(o, t.y1shift), b, p, E, k;
                if (a ? n === "domain" ? u = function(q) {
                    return a._offset + a._length * q;
                } : (l = Ld.shapePositionToRange(a), u = function(q) {
                    return a._offset + a.r2p(l(q, !0));
                }) : u = function(q) {
                    return s.l + s.w * q;
                }, o ? i === "domain" ? f = function(q) {
                    return o._offset + o._length * (1 - q);
                } : (c = Ld.shapePositionToRange(o), f = function(q) {
                    return o._offset + o.r2p(c(q, !0));
                }) : f = function(q) {
                    return s.t + s.h * (1 - q);
                }, r === "path") return a && a.type === "date" && (u = Ld.decodeDate(u)), o && o.type === "date" && (f = Ld.decodeDate(f)), Vlt(t, u, f);
                if (t.xsizemode === "pixel") {
                    var A = u(t.xanchor);
                    b = A + t.x0 + h, p = A + t.x1 + d;
                } else b = u(t.x0) + h, p = u(t.x1) + d;
                if (t.ysizemode === "pixel") {
                    var L = f(t.yanchor);
                    E = L - t.y0 + v, k = L - t.y1 + x;
                } else E = f(t.y0) + v, k = f(t.y1) + x;
                if (r === "line") return "M" + b + "," + E + "L" + p + "," + k;
                if (r === "rect") return "M" + b + "," + E + "H" + p + "V" + k + "H" + b + "Z";
                var _ = (b + p) / 2, C = (E + k) / 2, M = Math.abs(_ - b), g = Math.abs(C - E), P = "A" + M + "," + g, T = _ + M + "," + C, F = _ + "," + (C - g);
                return "M" + T + P + " 0 1,1 " + F + P + " 0 0,1 " + T + "Z";
            };
            function Vlt(e, t, r) {
                var n = e.path, i = e.xsizemode, a = e.ysizemode, o = e.xanchor, s = e.yanchor;
                return n.replace(Fb.segmentRE, function(l) {
                    var u = 0, c = l.charAt(0), f = Fb.paramIsX[c], h = Fb.paramIsY[c], d = Fb.numParams[c], v = l.substr(1).replace(Fb.paramRE, function(x) {
                        return f[u] ? i === "pixel" ? x = t(o) + Number(x) : x = t(x) : h[u] && (a === "pixel" ? x = r(s) - Number(x) : x = r(x)), u++, u > d && (x = "X"), x;
                    });
                    return u > d && (v = v.replace(/[\s,]*X.*/, ""), mue.log("Ignoring extra params in segment " + l)), c + v;
                });
            }
            function fM(e, t) {
                t = t || 0;
                var r = 0;
                return t && e && (e.type === "category" || e.type === "multicategory") && (r = (e.r2p(1) - e.r2p(0)) * t), r;
            }
        });
        var GB = ye((fir, bue)=>{
            "use strict";
            var Hlt = Mr(), G3 = Qa(), yue = Pl(), _ue = ao(), Glt = c_().readPaths, HB = h_(), jlt = HB.getPathString, xue = b6(), Wlt = Nh().FROM_TL;
            bue.exports = function(t, r, n, i) {
                if (i.selectAll(".shape-label").remove(), !!(n.label.text || n.label.texttemplate)) {
                    var a;
                    if (n.label.texttemplate) {
                        var o = {};
                        if (n.type !== "path") {
                            var s = G3.getFromId(t, n.xref), l = G3.getFromId(t, n.yref);
                            for(var u in xue){
                                var c = xue[u](n, s, l);
                                c !== void 0 && (o[u] = c);
                            }
                        }
                        a = Hlt.texttemplateStringForShapes(n.label.texttemplate, {}, t._fullLayout._d3locale, o);
                    } else a = n.label.text;
                    var f = {
                        "data-index": r
                    }, h = n.label.font, d = {
                        "data-notex": 1
                    }, v = i.append("g").attr(f).classed("shape-label", !0), x = v.append("text").attr(d).classed("shape-label-text", !0).text(a), b, p, E, k;
                    if (n.path) {
                        var A = jlt(t, n), L = Glt(A, t);
                        b = 1 / 0, E = 1 / 0, p = -1 / 0, k = -1 / 0;
                        for(var _ = 0; _ < L.length; _++)for(var C = 0; C < L[_].length; C++)for(var M = L[_][C], g = 1; g < M.length; g += 2){
                            var P = M[g], T = M[g + 1];
                            b = Math.min(b, P), p = Math.max(p, P), E = Math.min(E, T), k = Math.max(k, T);
                        }
                    } else {
                        var F = G3.getFromId(t, n.xref), q = n.x0shift, V = n.x1shift, H = G3.getRefType(n.xref), X = G3.getFromId(t, n.yref), G = n.y0shift, N = n.y1shift, W = G3.getRefType(n.yref), re = function(Ee, Ae) {
                            var ze = HB.getDataToPixel(t, F, Ae, !1, H);
                            return ze(Ee);
                        }, ae = function(Ee, Ae) {
                            var ze = HB.getDataToPixel(t, X, Ae, !0, W);
                            return ze(Ee);
                        };
                        b = re(n.x0, q), p = re(n.x1, V), E = ae(n.y0, G), k = ae(n.y1, N);
                    }
                    var _e = n.label.textangle;
                    _e === "auto" && (n.type === "line" ? _e = Zlt(b, E, p, k) : _e = 0), x.call(function(Ee) {
                        return Ee.call(_ue.font, h).attr({}), yue.convertToTspans(Ee, t), Ee;
                    });
                    var Me = _ue.bBox(x.node()), ke = Xlt(b, E, p, k, n, _e, Me), ge = ke.textx, ie = ke.texty, Te = ke.xanchor;
                    x.attr({
                        "text-anchor": {
                            left: "start",
                            center: "middle",
                            right: "end"
                        }[Te],
                        y: ie,
                        x: ge,
                        transform: "rotate(" + _e + "," + ge + "," + ie + ")"
                    }).call(yue.positionText, ge, ie);
                }
            };
            function Zlt(e, t, r, n) {
                var i, a;
                return a = Math.abs(r - e), r >= e ? i = t - n : i = n - t, -180 / Math.PI * Math.atan2(i, a);
            }
            function Xlt(e, t, r, n, i, a, o) {
                var s = i.label.textposition, l = i.label.textangle, u = i.label.padding, c = i.type, f = Math.PI / 180 * a, h = Math.sin(f), d = Math.cos(f), v = i.label.xanchor, x = i.label.yanchor, b, p, E, k;
                if (c === "line") {
                    s === "start" ? (b = e, p = t) : s === "end" ? (b = r, p = n) : (b = (e + r) / 2, p = (t + n) / 2), v === "auto" && (s === "start" ? l === "auto" ? r > e ? v = "left" : r < e ? v = "right" : v = "center" : r > e ? v = "right" : r < e ? v = "left" : v = "center" : s === "end" ? l === "auto" ? r > e ? v = "right" : r < e ? v = "left" : v = "center" : r > e ? v = "left" : r < e ? v = "right" : v = "center" : v = "center");
                    var A = {
                        left: 1,
                        center: 0,
                        right: -1
                    }, L = {
                        bottom: -1,
                        middle: 0,
                        top: 1
                    };
                    if (l === "auto") {
                        var _ = L[x];
                        E = -u * h * _, k = u * d * _;
                    } else {
                        var C = A[v], M = L[x];
                        E = u * C, k = u * M;
                    }
                    b = b + E, p = p + k;
                } else E = u + 3, s.indexOf("right") !== -1 ? (b = Math.max(e, r) - E, v === "auto" && (v = "right")) : s.indexOf("left") !== -1 ? (b = Math.min(e, r) + E, v === "auto" && (v = "left")) : (b = (e + r) / 2, v === "auto" && (v = "center")), s.indexOf("top") !== -1 ? p = Math.min(t, n) : s.indexOf("bottom") !== -1 ? p = Math.max(t, n) : p = (t + n) / 2, k = u, x === "bottom" ? p = p - k : x === "top" && (p = p + k);
                var g = Wlt[x], P = i.label.font.size, T = o.height, F = (T * g - P) * h, q = -(T * g - P) * d;
                return {
                    textx: b + F,
                    texty: p + q,
                    xanchor: v
                };
            }
        });
        var $L = ye((hir, Cue)=>{
            "use strict";
            var Ylt = Mr(), Klt = Ylt.strTranslate, wue = gv(), Sue = Sg(), Jlt = Sue.drawMode, Mue = Sue.selectMode, Eue = ba(), Tue = va(), JL = HL(), $lt = JL.i000, Qlt = JL.i090, eut = JL.i180, tut = JL.i270, rut = e_(), kue = rut.clearOutlineControllers, WB = c_(), KL = WB.pointsOnRectangle, jB = WB.pointsOnEllipse, iut = WB.writePaths, nut = XL().newShapes, aut = XL().createShapeObj, out = VB(), sut = GB();
            Cue.exports = function e(t, r, n, i) {
                i || (i = 0);
                var a = n.gd;
                function o() {
                    e(t, r, n, i++), (jB(t[0]) || n.hasText) && s({
                        redrawing: !0
                    });
                }
                function s(G) {
                    var N = {};
                    n.isActiveShape !== void 0 && (n.isActiveShape = !1, N = nut(r, n)), n.isActiveSelection !== void 0 && (n.isActiveSelection = !1, N = out(r, n), a._fullLayout._reselect = !0), Object.keys(N).length && Eue.call((G || {}).redrawing ? "relayout" : "_guiRelayout", a, N);
                }
                var l = a._fullLayout, u = l._zoomlayer, c = n.dragmode, f = Jlt(c), h = Mue(c);
                (f || h) && (a._fullLayout._outlining = !0), kue(a), r.attr("d", iut(t));
                var d, v, x, b, p;
                if (!i && (n.isActiveShape || n.isActiveSelection)) {
                    p = lut([], t);
                    var E = u.append("g").attr("class", "outline-controllers");
                    P(E), X();
                }
                if (f && n.hasText) {
                    var k = u.select(".label-temp"), A = aut(r, n, n.dragmode);
                    sut(a, "label-temp", A, k);
                }
                function L(G) {
                    x = +G.srcElement.getAttribute("data-i"), b = +G.srcElement.getAttribute("data-j"), d[x][b].moveFn = _;
                }
                function _(G, N) {
                    if (t.length) {
                        var W = p[x][b][1], re = p[x][b][2], ae = t[x], _e = ae.length;
                        if (KL(ae)) {
                            var Me = G, ke = N;
                            if (n.isActiveSelection) {
                                var ge = Aue(ae, b);
                                ge[1] === ae[b][1] ? ke = 0 : Me = 0;
                            }
                            for(var ie = 0; ie < _e; ie++)if (ie !== b) {
                                var Te = ae[ie];
                                Te[1] === ae[b][1] && (Te[1] = W + Me), Te[2] === ae[b][2] && (Te[2] = re + ke);
                            }
                            if (ae[b][1] = W + Me, ae[b][2] = re + ke, !KL(ae)) for(var Ee = 0; Ee < _e; Ee++)for(var Ae = 0; Ae < ae[Ee].length; Ae++)ae[Ee][Ae] = p[x][Ee][Ae];
                        } else ae[b][1] = W + G, ae[b][2] = re + N;
                        o();
                    }
                }
                function C() {
                    s();
                }
                function M() {
                    if (t.length && t[x] && t[x].length) {
                        for(var G = [], N = 0; N < t[x].length; N++)N !== b && G.push(t[x][N]);
                        G.length > 1 && !(G.length === 2 && G[1][0] === "Z") && (b === 0 && (G[0][0] = "M"), t[x] = G, o(), s());
                    }
                }
                function g(G, N) {
                    if (G === 2) {
                        x = +N.srcElement.getAttribute("data-i"), b = +N.srcElement.getAttribute("data-j");
                        var W = t[x];
                        !KL(W) && !jB(W) && M();
                    }
                }
                function P(G) {
                    d = [];
                    for(var N = 0; N < t.length; N++){
                        var W = t[N], re = KL(W), ae = !re && jB(W);
                        d[N] = [];
                        for(var _e = W.length, Me = 0; Me < _e; Me++)if (W[Me][0] !== "Z" && !(ae && Me !== $lt && Me !== Qlt && Me !== eut && Me !== tut)) {
                            var ke = re && n.isActiveSelection, ge;
                            ke && (ge = Aue(W, Me));
                            var ie = W[Me][1], Te = W[Me][2], Ee = G.append(ke ? "rect" : "circle").attr("data-i", N).attr("data-j", Me).style({
                                fill: Tue.background,
                                stroke: Tue.defaultLine,
                                "stroke-width": 1,
                                "shape-rendering": "crispEdges"
                            });
                            if (ke) {
                                var Ae = ge[1] - ie, ze = ge[2] - Te, Ce = ze ? 5 : Math.max(Math.min(25, Math.abs(Ae) - 5), 5), me = Ae ? 5 : Math.max(Math.min(25, Math.abs(ze) - 5), 5);
                                Ee.classed(ze ? "cursor-ew-resize" : "cursor-ns-resize", !0).attr("width", Ce).attr("height", me).attr("x", ie - Ce / 2).attr("y", Te - me / 2).attr("transform", Klt(Ae / 2, ze / 2));
                            } else Ee.classed("cursor-grab", !0).attr("r", 5).attr("cx", ie).attr("cy", Te);
                            d[N][Me] = {
                                element: Ee.node(),
                                gd: a,
                                prepFn: L,
                                doneFn: C,
                                clickFn: g
                            }, wue.init(d[N][Me]);
                        }
                    }
                }
                function T(G, N) {
                    if (t.length) for(var W = 0; W < t.length; W++)for(var re = 0; re < t[W].length; re++)for(var ae = 0; ae + 2 < t[W][re].length; ae += 2)t[W][re][ae + 1] = p[W][re][ae + 1] + G, t[W][re][ae + 2] = p[W][re][ae + 2] + N;
                }
                function F(G, N) {
                    T(G, N), o();
                }
                function q(G) {
                    x = +G.srcElement.getAttribute("data-i"), x || (x = 0), v[x].moveFn = F;
                }
                function V() {
                    s();
                }
                function H(G) {
                    G === 2 && uut(a);
                }
                function X() {
                    if (v = [], !!t.length) {
                        var G = 0;
                        v[G] = {
                            element: r[0][0],
                            gd: a,
                            prepFn: q,
                            doneFn: V,
                            clickFn: H
                        }, wue.init(v[G]);
                    }
                }
            };
            function lut(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    e[r] = [];
                    for(var i = 0; i < n.length; i++){
                        e[r][i] = [];
                        for(var a = 0; a < n[i].length; a++)e[r][i][a] = n[i][a];
                    }
                }
                return e;
            }
            function Aue(e, t) {
                var r = e[t][1], n = e[t][2], i = e.length, a, o, s;
                return a = (t + 1) % i, o = e[a][1], s = e[a][2], o === r && s === n && (a = (t + 2) % i, o = e[a][1], s = e[a][2]), [
                    a,
                    o,
                    s
                ];
            }
            function uut(e) {
                if (Mue(e._fullLayout.dragmode)) {
                    kue(e);
                    var t = e._fullLayout._activeSelectionIndex, r = (e.layout || {}).selections || [];
                    if (t < r.length) {
                        for(var n = [], i = 0; i < r.length; i++)i !== t && n.push(r[i]);
                        delete e._fullLayout._activeSelectionIndex;
                        var a = e._fullLayout.selections[t];
                        e._fullLayout._deselect = {
                            xref: a.xref,
                            yref: a.yref
                        }, Eue.call("_guiRelayout", e, {
                            selections: n
                        });
                    }
                }
            }
        });
        var rP = ye((dir, Bue)=>{
            "use strict";
            var cut = xa(), zue = ba(), Lue = Mr(), j3 = Qa(), fut = c_().readPaths, hut = $L(), eP = GB(), Fue = e_().clearOutlineControllers, ZB = va(), YB = ao(), dut = Vs().arrayEditor, Pue = gv(), Iue = Tg(), qb = cM(), Mp = h_(), XB = Mp.getPathString;
            Bue.exports = {
                draw: KB,
                drawOne: que,
                eraseActiveShape: gut,
                drawLabel: eP
            };
            function KB(e) {
                var t = e._fullLayout;
                t._shapeUpperLayer.selectAll("path").remove(), t._shapeLowerLayer.selectAll("path").remove(), t._shapeUpperLayer.selectAll("text").remove(), t._shapeLowerLayer.selectAll("text").remove();
                for(var r in t._plots){
                    var n = t._plots[r].shapelayer;
                    n && (n.selectAll("path").remove(), n.selectAll("text").remove());
                }
                for(var i = 0; i < t.shapes.length; i++)t.shapes[i].visible === !0 && que(e, i);
            }
            function QL(e) {
                return !!e._fullLayout._outlining;
            }
            function tP(e) {
                return !e._context.edits.shapePosition;
            }
            function que(e, t) {
                e._fullLayout._paperdiv.selectAll('.shapelayer [data-index="' + t + '"]').remove();
                var r = Mp.makeShapesOptionsAndPlotinfo(e, t), n = r.options, i = r.plotinfo;
                if (!n._input || n.visible !== !0) return;
                if (n.layer === "above") o(e._fullLayout._shapeUpperLayer);
                else if (n.xref === "paper" || n.yref === "paper") o(e._fullLayout._shapeLowerLayer);
                else if (n.layer === "between") o(i.shapelayerBetween);
                else if (i._hadPlotinfo) {
                    var a = i.mainplotinfo || i;
                    o(a.shapelayer);
                } else o(e._fullLayout._shapeLowerLayer);
                function o(s) {
                    var l = XB(e, n), u = {
                        "data-index": t,
                        "fill-rule": n.fillrule,
                        d: l
                    }, c = n.opacity, f = n.fillcolor, h = n.line.width ? n.line.color : "rgba(0,0,0,0)", d = n.line.width, v = n.line.dash;
                    !d && n.editable === !0 && (d = 5, v = "solid");
                    var x = l[l.length - 1] !== "Z", b = tP(e) && n.editable && e._fullLayout._activeShapeIndex === t;
                    b && (f = x ? "rgba(0,0,0,0)" : e._fullLayout.activeshape.fillcolor, c = e._fullLayout.activeshape.opacity);
                    var p = s.append("g").classed("shape-group", !0).attr({
                        "data-index": t
                    }), E = p.append("path").attr(u).style("opacity", c).call(ZB.stroke, h).call(ZB.fill, f).call(YB.dashLine, v, d);
                    Oue(p, e, n), eP(e, t, n, p);
                    var k;
                    if ((b || e._context.edits.shapePosition) && (k = dut(e.layout, "shapes", n)), b) {
                        E.style({
                            cursor: "move"
                        });
                        var A = {
                            element: E.node(),
                            plotinfo: i,
                            gd: e,
                            editHelpers: k,
                            hasText: n.label.text || n.label.texttemplate,
                            isActiveShape: !0
                        }, L = fut(l, e);
                        hut(L, E, A);
                    } else e._context.edits.shapePosition ? vut(e, E, n, t, s, k) : n.editable === !0 && E.style("pointer-events", x || ZB.opacity(f) * c <= .5 ? "stroke" : "all");
                    E.node().addEventListener("click", function() {
                        return put(e, E);
                    });
                }
            }
            function Oue(e, t, r) {
                var n = (r.xref + r.yref).replace(/paper/g, "").replace(/[xyz][1-9]* *domain/g, "");
                YB.setClipUrl(e, n ? "clip" + t._fullLayout._uid + n : null, t);
            }
            function vut(e, t, r, n, i, a) {
                var o = 10, s = 10, l = r.xsizemode === "pixel", u = r.ysizemode === "pixel", c = r.type === "line", f = r.type === "path", h = a.modifyItem, d, v, x, b, p, E, k, A, L, _, C, M, g, P, T, F = cut.select(t.node().parentNode), q = j3.getFromId(e, r.xref), V = j3.getRefType(r.xref), H = j3.getFromId(e, r.yref), X = j3.getRefType(r.yref), G = r.x0shift, N = r.x1shift, W = r.y0shift, re = r.y1shift, ae = function(rt, ot) {
                    var Rt = Mp.getDataToPixel(e, q, ot, !1, V);
                    return Rt(rt);
                }, _e = function(rt, ot) {
                    var Rt = Mp.getDataToPixel(e, H, ot, !0, X);
                    return Rt(rt);
                }, Me = Mp.getPixelToData(e, q, !1, V), ke = Mp.getPixelToData(e, H, !0, X), ge = Ee(), ie = {
                    element: ge.node(),
                    gd: e,
                    prepFn: Ce,
                    doneFn: me,
                    clickFn: Re
                }, Te;
                Pue.init(ie), ge.node().onmousemove = ze;
                function Ee() {
                    return c ? Ae() : t;
                }
                function Ae() {
                    var rt = 10, ot = Math.max(r.line.width, rt), Rt = i.append("g").attr("data-index", n).attr("drag-helper", !0);
                    Rt.append("path").attr("d", t.attr("d")).style({
                        cursor: "move",
                        "stroke-width": ot,
                        "stroke-opacity": "0"
                    });
                    var kt = {
                        "fill-opacity": "0"
                    }, Ct = Math.max(ot / 2, rt);
                    return Rt.append("circle").attr({
                        "data-line-point": "start-point",
                        cx: l ? ae(r.xanchor) + r.x0 : ae(r.x0, G),
                        cy: u ? _e(r.yanchor) - r.y0 : _e(r.y0, W),
                        r: Ct
                    }).style(kt).classed("cursor-grab", !0), Rt.append("circle").attr({
                        "data-line-point": "end-point",
                        cx: l ? ae(r.xanchor) + r.x1 : ae(r.x1, N),
                        cy: u ? _e(r.yanchor) - r.y1 : _e(r.y1, re),
                        r: Ct
                    }).style(kt).classed("cursor-grab", !0), Rt;
                }
                function ze(rt) {
                    if (QL(e)) {
                        Te = null;
                        return;
                    }
                    if (c) rt.target.tagName === "path" ? Te = "move" : Te = rt.target.attributes["data-line-point"].value === "start-point" ? "resize-over-start-point" : "resize-over-end-point";
                    else {
                        var ot = ie.element.getBoundingClientRect(), Rt = ot.right - ot.left, kt = ot.bottom - ot.top, Ct = rt.clientX - ot.left, Yt = rt.clientY - ot.top, xr = !f && Rt > o && kt > s && !rt.shiftKey ? Pue.getCursor(Ct / Rt, 1 - Yt / kt) : "move";
                        Iue(t, xr), Te = xr.split("-")[0];
                    }
                }
                function Ce(rt) {
                    QL(e) || (l && (p = ae(r.xanchor)), u && (E = _e(r.yanchor)), r.type === "path" ? T = r.path : (d = l ? r.x0 : ae(r.x0), v = u ? r.y0 : _e(r.y0), x = l ? r.x1 : ae(r.x1), b = u ? r.y1 : _e(r.y1)), d < x ? (L = d, g = "x0", _ = x, P = "x1") : (L = x, g = "x1", _ = d, P = "x0"), !u && v < b || u && v > b ? (k = v, C = "y0", A = b, M = "y1") : (k = b, C = "y1", A = v, M = "y0"), ze(rt), nt(i, r), qt(t, r, e), ie.moveFn = Te === "move" ? ce : Ge, ie.altKey = rt.altKey);
                }
                function me() {
                    QL(e) || (Iue(t), ct(i), Oue(t, e, r), zue.call("_guiRelayout", e, a.getUpdateObj()));
                }
                function Re() {
                    QL(e) || ct(i);
                }
                function ce(rt, ot) {
                    if (r.type === "path") {
                        var Rt = function(Yt) {
                            return Yt;
                        }, kt = Rt, Ct = Rt;
                        l ? h("xanchor", r.xanchor = Me(p + rt)) : (kt = function(xr) {
                            return Me(ae(xr) + rt);
                        }, q && q.type === "date" && (kt = Mp.encodeDate(kt))), u ? h("yanchor", r.yanchor = ke(E + ot)) : (Ct = function(xr) {
                            return ke(_e(xr) + ot);
                        }, H && H.type === "date" && (Ct = Mp.encodeDate(Ct))), h("path", r.path = Rue(T, kt, Ct));
                    } else l ? h("xanchor", r.xanchor = Me(p + rt)) : (h("x0", r.x0 = Me(d + rt)), h("x1", r.x1 = Me(x + rt))), u ? h("yanchor", r.yanchor = ke(E + ot)) : (h("y0", r.y0 = ke(v + ot)), h("y1", r.y1 = ke(b + ot)));
                    t.attr("d", XB(e, r)), nt(i, r), eP(e, n, r, F);
                }
                function Ge(rt, ot) {
                    if (f) {
                        var Rt = function(_r) {
                            return _r;
                        }, kt = Rt, Ct = Rt;
                        l ? h("xanchor", r.xanchor = Me(p + rt)) : (kt = function(Br) {
                            return Me(ae(Br) + rt);
                        }, q && q.type === "date" && (kt = Mp.encodeDate(kt))), u ? h("yanchor", r.yanchor = ke(E + ot)) : (Ct = function(Br) {
                            return ke(_e(Br) + ot);
                        }, H && H.type === "date" && (Ct = Mp.encodeDate(Ct))), h("path", r.path = Rue(T, kt, Ct));
                    } else if (c) {
                        if (Te === "resize-over-start-point") {
                            var Yt = d + rt, xr = u ? v - ot : v + ot;
                            h("x0", r.x0 = l ? Yt : Me(Yt)), h("y0", r.y0 = u ? xr : ke(xr));
                        } else if (Te === "resize-over-end-point") {
                            var er = x + rt, Ke = u ? b - ot : b + ot;
                            h("x1", r.x1 = l ? er : Me(er)), h("y1", r.y1 = u ? Ke : ke(Ke));
                        }
                    } else {
                        var xt = function(_r) {
                            return Te.indexOf(_r) !== -1;
                        }, bt = xt("n"), Lt = xt("s"), St = xt("w"), Et = xt("e"), dt = bt ? k + ot : k, Ht = Lt ? A + ot : A, $t = St ? L + rt : L, fr = Et ? _ + rt : _;
                        u && (bt && (dt = k - ot), Lt && (Ht = A - ot)), (!u && Ht - dt > s || u && dt - Ht > s) && (h(C, r[C] = u ? dt : ke(dt)), h(M, r[M] = u ? Ht : ke(Ht))), fr - $t > o && (h(g, r[g] = l ? $t : Me($t)), h(P, r[P] = l ? fr : Me(fr)));
                    }
                    t.attr("d", XB(e, r)), nt(i, r), eP(e, n, r, F);
                }
                function nt(rt, ot) {
                    (l || u) && Rt();
                    function Rt() {
                        var kt = ot.type !== "path", Ct = rt.selectAll(".visual-cue").data([
                            0
                        ]), Yt = 1;
                        Ct.enter().append("path").attr({
                            fill: "#fff",
                            "fill-rule": "evenodd",
                            stroke: "#000",
                            "stroke-width": Yt
                        }).classed("visual-cue", !0);
                        var xr = ae(l ? ot.xanchor : Lue.midRange(kt ? [
                            ot.x0,
                            ot.x1
                        ] : Mp.extractPathCoords(ot.path, qb.paramIsX))), er = _e(u ? ot.yanchor : Lue.midRange(kt ? [
                            ot.y0,
                            ot.y1
                        ] : Mp.extractPathCoords(ot.path, qb.paramIsY)));
                        if (xr = Mp.roundPositionForSharpStrokeRendering(xr, Yt), er = Mp.roundPositionForSharpStrokeRendering(er, Yt), l && u) {
                            var Ke = "M" + (xr - 1 - Yt) + "," + (er - 1 - Yt) + "h-8v2h8 v8h2v-8 h8v-2h-8 v-8h-2 Z";
                            Ct.attr("d", Ke);
                        } else if (l) {
                            var xt = "M" + (xr - 1 - Yt) + "," + (er - 9 - Yt) + "v18 h2 v-18 Z";
                            Ct.attr("d", xt);
                        } else {
                            var bt = "M" + (xr - 9 - Yt) + "," + (er - 1 - Yt) + "h18 v2 h-18 Z";
                            Ct.attr("d", bt);
                        }
                    }
                }
                function ct(rt) {
                    rt.selectAll(".visual-cue").remove();
                }
                function qt(rt, ot, Rt) {
                    var kt = ot.xref, Ct = ot.yref, Yt = j3.getFromId(Rt, kt), xr = j3.getFromId(Rt, Ct), er = "";
                    kt !== "paper" && !Yt.autorange && (er += kt), Ct !== "paper" && !xr.autorange && (er += Ct), YB.setClipUrl(rt, er ? "clip" + Rt._fullLayout._uid + er : null, Rt);
                }
            }
            function Rue(e, t, r) {
                return e.replace(qb.segmentRE, function(n) {
                    var i = 0, a = n.charAt(0), o = qb.paramIsX[a], s = qb.paramIsY[a], l = qb.numParams[a], u = n.substr(1).replace(qb.paramRE, function(c) {
                        return i >= l || (o[i] ? c = t(c) : s[i] && (c = r(c)), i++), c;
                    });
                    return a + u;
                });
            }
            function put(e, t) {
                if (tP(e)) {
                    var r = t.node(), n = +r.getAttribute("data-index");
                    if (n >= 0) {
                        if (n === e._fullLayout._activeShapeIndex) {
                            Due(e);
                            return;
                        }
                        e._fullLayout._activeShapeIndex = n, e._fullLayout._deactivateShape = Due, KB(e);
                    }
                }
            }
            function Due(e) {
                if (tP(e)) {
                    var t = e._fullLayout._activeShapeIndex;
                    t >= 0 && (Fue(e), delete e._fullLayout._activeShapeIndex, KB(e));
                }
            }
            function gut(e) {
                if (tP(e)) {
                    Fue(e);
                    var t = e._fullLayout._activeShapeIndex, r = (e.layout || {}).shapes || [];
                    if (t < r.length) {
                        for(var n = [], i = 0; i < r.length; i++)i !== t && n.push(r[i]);
                        return delete e._fullLayout._activeShapeIndex, zue.call("_guiRelayout", e, {
                            shapes: n
                        });
                    }
                }
            }
        });
        var QB = ye((vir, Xue)=>{
            "use strict";
            var S0 = ba(), Nue = Xu(), Uue = af(), al = UL(), mut = rP().eraseActiveShape, iP = Mr(), Os = iP._, ol = Xue.exports = {};
            ol.toImage = {
                name: "toImage",
                title: function(e) {
                    var t = e._context.toImageButtonOptions || {}, r = t.format || "png";
                    return r === "png" ? Os(e, "Download plot as a png") : Os(e, "Download plot");
                },
                icon: al.camera,
                click: function(e) {
                    var t = e._context.toImageButtonOptions, r = {
                        format: t.format || "png"
                    };
                    iP.notifier(Os(e, "Taking snapshot - this may take a few seconds"), "long"), [
                        "filename",
                        "width",
                        "height",
                        "scale"
                    ].forEach(function(n) {
                        n in t && (r[n] = t[n]);
                    }), S0.call("downloadImage", e, r).then(function(n) {
                        iP.notifier(Os(e, "Snapshot succeeded") + " - " + n, "long");
                    }).catch(function() {
                        iP.notifier(Os(e, "Sorry, there was a problem downloading your snapshot!"), "long");
                    });
                }
            };
            ol.sendDataToCloud = {
                name: "sendDataToCloud",
                title: function(e) {
                    return Os(e, "Edit in Chart Studio");
                },
                icon: al.disk,
                click: function(e) {
                    Nue.sendDataToCloud(e);
                }
            };
            ol.editInChartStudio = {
                name: "editInChartStudio",
                title: function(e) {
                    return Os(e, "Edit in Chart Studio");
                },
                icon: al.pencil,
                click: function(e) {
                    Nue.sendDataToCloud(e);
                }
            };
            ol.zoom2d = {
                name: "zoom2d",
                _cat: "zoom",
                title: function(e) {
                    return Os(e, "Zoom");
                },
                attr: "dragmode",
                val: "zoom",
                icon: al.zoombox,
                click: Ov
            };
            ol.pan2d = {
                name: "pan2d",
                _cat: "pan",
                title: function(e) {
                    return Os(e, "Pan");
                },
                attr: "dragmode",
                val: "pan",
                icon: al.pan,
                click: Ov
            };
            ol.select2d = {
                name: "select2d",
                _cat: "select",
                title: function(e) {
                    return Os(e, "Box Select");
                },
                attr: "dragmode",
                val: "select",
                icon: al.selectbox,
                click: Ov
            };
            ol.lasso2d = {
                name: "lasso2d",
                _cat: "lasso",
                title: function(e) {
                    return Os(e, "Lasso Select");
                },
                attr: "dragmode",
                val: "lasso",
                icon: al.lasso,
                click: Ov
            };
            ol.drawclosedpath = {
                name: "drawclosedpath",
                title: function(e) {
                    return Os(e, "Draw closed freeform");
                },
                attr: "dragmode",
                val: "drawclosedpath",
                icon: al.drawclosedpath,
                click: Ov
            };
            ol.drawopenpath = {
                name: "drawopenpath",
                title: function(e) {
                    return Os(e, "Draw open freeform");
                },
                attr: "dragmode",
                val: "drawopenpath",
                icon: al.drawopenpath,
                click: Ov
            };
            ol.drawline = {
                name: "drawline",
                title: function(e) {
                    return Os(e, "Draw line");
                },
                attr: "dragmode",
                val: "drawline",
                icon: al.drawline,
                click: Ov
            };
            ol.drawrect = {
                name: "drawrect",
                title: function(e) {
                    return Os(e, "Draw rectangle");
                },
                attr: "dragmode",
                val: "drawrect",
                icon: al.drawrect,
                click: Ov
            };
            ol.drawcircle = {
                name: "drawcircle",
                title: function(e) {
                    return Os(e, "Draw circle");
                },
                attr: "dragmode",
                val: "drawcircle",
                icon: al.drawcircle,
                click: Ov
            };
            ol.eraseshape = {
                name: "eraseshape",
                title: function(e) {
                    return Os(e, "Erase active shape");
                },
                icon: al.eraseshape,
                click: mut
            };
            ol.zoomIn2d = {
                name: "zoomIn2d",
                _cat: "zoomin",
                title: function(e) {
                    return Os(e, "Zoom in");
                },
                attr: "zoom",
                val: "in",
                icon: al.zoom_plus,
                click: Ov
            };
            ol.zoomOut2d = {
                name: "zoomOut2d",
                _cat: "zoomout",
                title: function(e) {
                    return Os(e, "Zoom out");
                },
                attr: "zoom",
                val: "out",
                icon: al.zoom_minus,
                click: Ov
            };
            ol.autoScale2d = {
                name: "autoScale2d",
                _cat: "autoscale",
                title: function(e) {
                    return Os(e, "Autoscale");
                },
                attr: "zoom",
                val: "auto",
                icon: al.autoscale,
                click: Ov
            };
            ol.resetScale2d = {
                name: "resetScale2d",
                _cat: "resetscale",
                title: function(e) {
                    return Os(e, "Reset axes");
                },
                attr: "zoom",
                val: "reset",
                icon: al.home,
                click: Ov
            };
            ol.hoverClosestCartesian = {
                name: "hoverClosestCartesian",
                _cat: "hoverclosest",
                title: function(e) {
                    return Os(e, "Show closest data on hover");
                },
                attr: "hovermode",
                val: "closest",
                icon: al.tooltip_basic,
                gravity: "ne",
                click: Ov
            };
            ol.hoverCompareCartesian = {
                name: "hoverCompareCartesian",
                _cat: "hoverCompare",
                title: function(e) {
                    return Os(e, "Compare data on hover");
                },
                attr: "hovermode",
                val: function(e) {
                    return e._fullLayout._isHoriz ? "y" : "x";
                },
                icon: al.tooltip_compare,
                gravity: "ne",
                click: Ov
            };
            function Ov(e, t) {
                var r = t.currentTarget, n = r.getAttribute("data-attr"), i = r.getAttribute("data-val") || !0, a = e._fullLayout, o = {}, s = Uue.list(e, null, !0), l = a._cartesianSpikesEnabled, u, c;
                if (n === "zoom") {
                    var f = i === "in" ? .5 : 2, h = (1 + f) / 2, d = (1 - f) / 2, v;
                    for(c = 0; c < s.length; c++)if (u = s[c], !u.fixedrange) {
                        if (v = u._name, i === "auto") o[v + ".autorange"] = !0;
                        else if (i === "reset") u._rangeInitial0 === void 0 && u._rangeInitial1 === void 0 ? o[v + ".autorange"] = !0 : u._rangeInitial0 === void 0 ? (o[v + ".autorange"] = u._autorangeInitial, o[v + ".range"] = [
                            null,
                            u._rangeInitial1
                        ]) : u._rangeInitial1 === void 0 ? (o[v + ".range"] = [
                            u._rangeInitial0,
                            null
                        ], o[v + ".autorange"] = u._autorangeInitial) : o[v + ".range"] = [
                            u._rangeInitial0,
                            u._rangeInitial1
                        ], u._showSpikeInitial !== void 0 && (o[v + ".showspikes"] = u._showSpikeInitial, l === "on" && !u._showSpikeInitial && (l = "off"));
                        else {
                            var x = [
                                u.r2l(u.range[0]),
                                u.r2l(u.range[1])
                            ], b = [
                                h * x[0] + d * x[1],
                                h * x[1] + d * x[0]
                            ];
                            o[v + ".range[0]"] = u.l2r(b[0]), o[v + ".range[1]"] = u.l2r(b[1]);
                        }
                    }
                } else n === "hovermode" && (i === "x" || i === "y") && (i = a._isHoriz ? "y" : "x", r.setAttribute("data-val", i)), o[n] = i;
                a._cartesianSpikesEnabled = l, S0.call("_guiRelayout", e, o);
            }
            ol.zoom3d = {
                name: "zoom3d",
                _cat: "zoom",
                title: function(e) {
                    return Os(e, "Zoom");
                },
                attr: "scene.dragmode",
                val: "zoom",
                icon: al.zoombox,
                click: nP
            };
            ol.pan3d = {
                name: "pan3d",
                _cat: "pan",
                title: function(e) {
                    return Os(e, "Pan");
                },
                attr: "scene.dragmode",
                val: "pan",
                icon: al.pan,
                click: nP
            };
            ol.orbitRotation = {
                name: "orbitRotation",
                title: function(e) {
                    return Os(e, "Orbital rotation");
                },
                attr: "scene.dragmode",
                val: "orbit",
                icon: al["3d_rotate"],
                click: nP
            };
            ol.tableRotation = {
                name: "tableRotation",
                title: function(e) {
                    return Os(e, "Turntable rotation");
                },
                attr: "scene.dragmode",
                val: "turntable",
                icon: al["z-axis"],
                click: nP
            };
            function nP(e, t) {
                for(var r = t.currentTarget, n = r.getAttribute("data-attr"), i = r.getAttribute("data-val") || !0, a = e._fullLayout._subplots.gl3d || [], o = {}, s = n.split("."), l = 0; l < a.length; l++)o[a[l] + "." + s[1]] = i;
                var u = i === "pan" ? i : "zoom";
                o.dragmode = u, S0.call("_guiRelayout", e, o);
            }
            ol.resetCameraDefault3d = {
                name: "resetCameraDefault3d",
                _cat: "resetCameraDefault",
                title: function(e) {
                    return Os(e, "Reset camera to default");
                },
                attr: "resetDefault",
                icon: al.home,
                click: JB
            };
            ol.resetCameraLastSave3d = {
                name: "resetCameraLastSave3d",
                _cat: "resetCameraLastSave",
                title: function(e) {
                    return Os(e, "Reset camera to last save");
                },
                attr: "resetLastSave",
                icon: al.movie,
                click: JB
            };
            function JB(e, t) {
                for(var r = t.currentTarget, n = r.getAttribute("data-attr"), i = n === "resetLastSave", a = n === "resetDefault", o = e._fullLayout, s = o._subplots.gl3d || [], l = {}, u = 0; u < s.length; u++){
                    var c = s[u], f = c + ".camera", h = c + ".aspectratio", d = c + ".aspectmode", v = o[c]._scene, x;
                    i ? (l[f + ".up"] = v.viewInitial.up, l[f + ".eye"] = v.viewInitial.eye, l[f + ".center"] = v.viewInitial.center, x = !0) : a && (l[f + ".up"] = null, l[f + ".eye"] = null, l[f + ".center"] = null, x = !0), x && (l[h + ".x"] = v.viewInitial.aspectratio.x, l[h + ".y"] = v.viewInitial.aspectratio.y, l[h + ".z"] = v.viewInitial.aspectratio.z, l[d] = v.viewInitial.aspectmode);
                }
                S0.call("_guiRelayout", e, l);
            }
            ol.hoverClosest3d = {
                name: "hoverClosest3d",
                _cat: "hoverclosest",
                title: function(e) {
                    return Os(e, "Toggle show closest data on hover");
                },
                attr: "hovermode",
                val: null,
                toggle: !0,
                icon: al.tooltip_basic,
                gravity: "ne",
                click: yut
            };
            function Vue(e, t) {
                var r = t.currentTarget, n = r._previousVal, i = e._fullLayout, a = i._subplots.gl3d || [], o = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ], s = {}, l = {};
                if (n) l = n, r._previousVal = null;
                else {
                    for(var u = 0; u < a.length; u++){
                        var c = a[u], f = i[c], h = c + ".hovermode";
                        s[h] = f.hovermode, l[h] = !1;
                        for(var d = 0; d < 3; d++){
                            var v = o[d], x = c + "." + v + ".showspikes";
                            l[x] = !1, s[x] = f[v].showspikes;
                        }
                    }
                    r._previousVal = s;
                }
                return l;
            }
            function yut(e, t) {
                var r = Vue(e, t);
                S0.call("_guiRelayout", e, r);
            }
            ol.zoomInGeo = {
                name: "zoomInGeo",
                _cat: "zoomin",
                title: function(e) {
                    return Os(e, "Zoom in");
                },
                attr: "zoom",
                val: "in",
                icon: al.zoom_plus,
                click: $B
            };
            ol.zoomOutGeo = {
                name: "zoomOutGeo",
                _cat: "zoomout",
                title: function(e) {
                    return Os(e, "Zoom out");
                },
                attr: "zoom",
                val: "out",
                icon: al.zoom_minus,
                click: $B
            };
            ol.resetGeo = {
                name: "resetGeo",
                _cat: "reset",
                title: function(e) {
                    return Os(e, "Reset");
                },
                attr: "reset",
                val: null,
                icon: al.autoscale,
                click: $B
            };
            ol.hoverClosestGeo = {
                name: "hoverClosestGeo",
                _cat: "hoverclosest",
                title: function(e) {
                    return Os(e, "Toggle show closest data on hover");
                },
                attr: "hovermode",
                val: null,
                toggle: !0,
                icon: al.tooltip_basic,
                gravity: "ne",
                click: Gue
            };
            function $B(e, t) {
                for(var r = t.currentTarget, n = r.getAttribute("data-attr"), i = r.getAttribute("data-val") || !0, a = e._fullLayout, o = a._subplots.geo || [], s = 0; s < o.length; s++){
                    var l = o[s], u = a[l];
                    if (n === "zoom") {
                        var c = u.projection.scale, f = i === "in" ? 2 * c : .5 * c;
                        S0.call("_guiRelayout", e, l + ".projection.scale", f);
                    }
                }
                n === "reset" && W3(e, "geo");
            }
            ol.hoverClosestPie = {
                name: "hoverClosestPie",
                _cat: "hoverclosest",
                title: function(e) {
                    return Os(e, "Toggle show closest data on hover");
                },
                attr: "hovermode",
                val: "closest",
                icon: al.tooltip_basic,
                gravity: "ne",
                click: Gue
            };
            function Hue(e) {
                var t = e._fullLayout;
                return t.hovermode ? !1 : t._has("cartesian") ? t._isHoriz ? "y" : "x" : "closest";
            }
            function Gue(e) {
                var t = Hue(e);
                S0.call("_guiRelayout", e, "hovermode", t);
            }
            ol.resetViewSankey = {
                name: "resetSankeyGroup",
                title: function(e) {
                    return Os(e, "Reset view");
                },
                icon: al.home,
                click: function(e) {
                    for(var t = {
                        "node.groups": [],
                        "node.x": [],
                        "node.y": []
                    }, r = 0; r < e._fullData.length; r++){
                        var n = e._fullData[r]._viewInitial;
                        t["node.groups"].push(n.node.groups.slice()), t["node.x"].push(n.node.x.slice()), t["node.y"].push(n.node.y.slice());
                    }
                    S0.call("restyle", e, t);
                }
            };
            ol.toggleHover = {
                name: "toggleHover",
                title: function(e) {
                    return Os(e, "Toggle show closest data on hover");
                },
                attr: "hovermode",
                val: null,
                toggle: !0,
                icon: al.tooltip_basic,
                gravity: "ne",
                click: function(e, t) {
                    var r = Vue(e, t);
                    r.hovermode = Hue(e), S0.call("_guiRelayout", e, r);
                }
            };
            ol.resetViews = {
                name: "resetViews",
                title: function(e) {
                    return Os(e, "Reset views");
                },
                icon: al.home,
                click: function(e, t) {
                    var r = t.currentTarget;
                    r.setAttribute("data-attr", "zoom"), r.setAttribute("data-val", "reset"), Ov(e, t), r.setAttribute("data-attr", "resetLastSave"), JB(e, t), W3(e, "geo"), W3(e, "mapbox"), W3(e, "map");
                }
            };
            ol.toggleSpikelines = {
                name: "toggleSpikelines",
                title: function(e) {
                    return Os(e, "Toggle Spike Lines");
                },
                icon: al.spikeline,
                attr: "_cartesianSpikesEnabled",
                val: "on",
                click: function(e) {
                    var t = e._fullLayout, r = t._cartesianSpikesEnabled;
                    t._cartesianSpikesEnabled = r === "on" ? "off" : "on", S0.call("_guiRelayout", e, _ut(e));
                }
            };
            function _ut(e) {
                for(var t = e._fullLayout, r = t._cartesianSpikesEnabled === "on", n = Uue.list(e, null, !0), i = {}, a = 0; a < n.length; a++){
                    var o = n[a];
                    i[o._name + ".showspikes"] = r ? !0 : o._showSpikeInitial;
                }
                return i;
            }
            ol.resetViewMapbox = {
                name: "resetViewMapbox",
                _cat: "resetView",
                title: function(e) {
                    return Os(e, "Reset view");
                },
                attr: "reset",
                icon: al.home,
                click: function(e) {
                    W3(e, "mapbox");
                }
            };
            ol.resetViewMap = {
                name: "resetViewMap",
                _cat: "resetView",
                title: function(e) {
                    return Os(e, "Reset view");
                },
                attr: "reset",
                icon: al.home,
                click: function(e) {
                    W3(e, "map");
                }
            };
            ol.zoomInMapbox = {
                name: "zoomInMapbox",
                _cat: "zoomin",
                title: function(e) {
                    return Os(e, "Zoom in");
                },
                attr: "zoom",
                val: "in",
                icon: al.zoom_plus,
                click: jue
            };
            ol.zoomInMap = {
                name: "zoomInMap",
                _cat: "zoomin",
                title: function(e) {
                    return Os(e, "Zoom in");
                },
                attr: "zoom",
                val: "in",
                icon: al.zoom_plus,
                click: Wue
            };
            ol.zoomOutMapbox = {
                name: "zoomOutMapbox",
                _cat: "zoomout",
                title: function(e) {
                    return Os(e, "Zoom out");
                },
                attr: "zoom",
                val: "out",
                icon: al.zoom_minus,
                click: jue
            };
            ol.zoomOutMap = {
                name: "zoomOutMap",
                _cat: "zoomout",
                title: function(e) {
                    return Os(e, "Zoom out");
                },
                attr: "zoom",
                val: "out",
                icon: al.zoom_minus,
                click: Wue
            };
            function jue(e, t) {
                Zue(e, t, "mapbox");
            }
            function Wue(e, t) {
                Zue(e, t, "map");
            }
            function Zue(e, t, r) {
                for(var n = t.currentTarget, i = n.getAttribute("data-val"), a = e._fullLayout, o = a._subplots[r] || [], s = 1.05, l = {}, u = 0; u < o.length; u++){
                    var c = o[u], f = a[c].zoom, h = i === "in" ? s * f : f / s;
                    l[c + ".zoom"] = h;
                }
                S0.call("_guiRelayout", e, l);
            }
            function W3(e, t) {
                for(var r = e._fullLayout, n = r._subplots[t] || [], i = {}, a = 0; a < n.length; a++)for(var o = n[a], s = r[o]._subplot, l = s.viewInitial, u = Object.keys(l), c = 0; c < u.length; c++){
                    var f = u[c];
                    i[o + "." + f] = l[f];
                }
                S0.call("_guiRelayout", e, i);
            }
        });
        var eN = ye((pir, $ue)=>{
            "use strict";
            var Yue = QB(), xut = Object.keys(Yue), Kue = [
                "drawline",
                "drawopenpath",
                "drawclosedpath",
                "drawcircle",
                "drawrect",
                "eraseshape"
            ], Jue = [
                "v1hovermode",
                "hoverclosest",
                "hovercompare",
                "togglehover",
                "togglespikelines"
            ].concat(Kue), Z3 = [], but = function(e) {
                if (Jue.indexOf(e._cat || e.name) === -1) {
                    var t = e.name, r = (e._cat || e.name).toLowerCase();
                    Z3.indexOf(t) === -1 && Z3.push(t), Z3.indexOf(r) === -1 && Z3.push(r);
                }
            };
            xut.forEach(function(e) {
                but(Yue[e]);
            });
            Z3.sort();
            $ue.exports = {
                DRAW_MODES: Kue,
                backButtons: Jue,
                foreButtons: Z3
            };
        });
        var tN = ye((mir, Que)=>{
            "use strict";
            var gir = eN();
            Que.exports = {
                editType: "modebar",
                orientation: {
                    valType: "enumerated",
                    values: [
                        "v",
                        "h"
                    ],
                    dflt: "h",
                    editType: "modebar"
                },
                bgcolor: {
                    valType: "color",
                    editType: "modebar"
                },
                color: {
                    valType: "color",
                    editType: "modebar"
                },
                activecolor: {
                    valType: "color",
                    editType: "modebar"
                },
                uirevision: {
                    valType: "any",
                    editType: "none"
                },
                add: {
                    valType: "string",
                    arrayOk: !0,
                    dflt: "",
                    editType: "modebar"
                },
                remove: {
                    valType: "string",
                    arrayOk: !0,
                    dflt: "",
                    editType: "modebar"
                }
            };
        });
        var tce = ye((yir, ece)=>{
            "use strict";
            var wut = Mr(), hM = va(), Tut = Vs(), Aut = tN();
            ece.exports = function(t, r) {
                var n = t.modebar || {}, i = Tut.newContainer(r, "modebar");
                function a(s, l) {
                    return wut.coerce(n, i, Aut, s, l);
                }
                a("orientation"), a("bgcolor", hM.addOpacity(r.paper_bgcolor, .5));
                var o = hM.contrast(hM.rgb(r.modebar.bgcolor));
                a("color", hM.addOpacity(o, .3)), a("activecolor", hM.addOpacity(o, .7)), a("uirevision", r.uirevision), a("add"), a("remove");
            };
        });
        var ace = ye((_ir, nce)=>{
            "use strict";
            var rN = xa(), Sut = uo(), aP = Mr(), rce = UL(), Mut = e6().version, Eut = new DOMParser;
            function ice(e) {
                this.container = e.container, this.element = document.createElement("div"), this.update(e.graphInfo, e.buttons), this.container.appendChild(this.element);
            }
            var Tm = ice.prototype;
            Tm.update = function(e, t) {
                this.graphInfo = e;
                var r = this.graphInfo._context, n = this.graphInfo._fullLayout, i = "modebar-" + n._uid;
                this.element.setAttribute("id", i), this._uid = i, this.element.className = "modebar", r.displayModeBar === "hover" && (this.element.className += " modebar--hover ease-bg"), n.modebar.orientation === "v" && (this.element.className += " vertical", t = t.reverse());
                var a = n.modebar, o = "#" + i + " .modebar-group";
                document.querySelectorAll(o).forEach(function(f) {
                    f.style.backgroundColor = a.bgcolor;
                });
                var s = !this.hasButtons(t), l = this.hasLogo !== r.displaylogo, u = this.locale !== r.locale;
                if (this.locale = r.locale, (s || l || u) && (this.removeAllButtons(), this.updateButtons(t), r.watermark || r.displaylogo)) {
                    var c = this.getLogo();
                    r.watermark && (c.className = c.className + " watermark"), n.modebar.orientation === "v" ? this.element.insertBefore(c, this.element.childNodes[0]) : this.element.appendChild(c), this.hasLogo = !0;
                }
                this.updateActiveButton(), aP.setStyleOnHover("#" + i + " .modebar-btn", ".active", ".icon path", "fill: " + a.activecolor, "fill: " + a.color, this.element);
            };
            Tm.updateButtons = function(e) {
                var t = this;
                this.buttons = e, this.buttonElements = [], this.buttonsNames = [], this.buttons.forEach(function(r) {
                    var n = t.createGroup();
                    r.forEach(function(i) {
                        var a = i.name;
                        if (!a) throw new Error("must provide button 'name' in button config");
                        if (t.buttonsNames.indexOf(a) !== -1) throw new Error("button name '" + a + "' is taken");
                        t.buttonsNames.push(a);
                        var o = t.createButton(i);
                        t.buttonElements.push(o), n.appendChild(o);
                    }), t.element.appendChild(n);
                });
            };
            Tm.createGroup = function() {
                var e = document.createElement("div");
                e.className = "modebar-group";
                var t = this.graphInfo._fullLayout.modebar;
                return e.style.backgroundColor = t.bgcolor, e;
            };
            Tm.createButton = function(e) {
                var t = this, r = document.createElement("a");
                r.setAttribute("rel", "tooltip"), r.className = "modebar-btn";
                var n = e.title;
                n === void 0 ? n = e.name : typeof n == "function" && (n = n(this.graphInfo)), (n || n === 0) && r.setAttribute("data-title", n), e.attr !== void 0 && r.setAttribute("data-attr", e.attr);
                var i = e.val;
                i !== void 0 && (typeof i == "function" && (i = i(this.graphInfo)), r.setAttribute("data-val", i));
                var a = e.click;
                if (typeof a != "function") throw new Error("must provide button 'click' function in button config");
                r.addEventListener("click", function(s) {
                    e.click(t.graphInfo, s), t.updateActiveButton(s.currentTarget);
                }), r.setAttribute("data-toggle", e.toggle || !1), e.toggle && rN.select(r).classed("active", !0);
                var o = e.icon;
                return typeof o == "function" ? r.appendChild(o()) : r.appendChild(this.createIcon(o || rce.question)), r.setAttribute("data-gravity", e.gravity || "n"), r;
            };
            Tm.createIcon = function(e) {
                var t = Sut(e.height) ? Number(e.height) : e.ascent - e.descent, r = "http://www.w3.org/2000/svg", n;
                if (e.path) {
                    n = document.createElementNS(r, "svg"), n.setAttribute("viewBox", [
                        0,
                        0,
                        e.width,
                        t
                    ].join(" ")), n.setAttribute("class", "icon");
                    var i = document.createElementNS(r, "path");
                    i.setAttribute("d", e.path), e.transform ? i.setAttribute("transform", e.transform) : e.ascent !== void 0 && i.setAttribute("transform", "matrix(1 0 0 -1 0 " + e.ascent + ")"), n.appendChild(i);
                }
                if (e.svg) {
                    var a = Eut.parseFromString(e.svg, "application/xml");
                    n = a.childNodes[0];
                }
                return n.setAttribute("height", "1em"), n.setAttribute("width", "1em"), n;
            };
            Tm.updateActiveButton = function(e) {
                var t = this.graphInfo._fullLayout, r = e !== void 0 ? e.getAttribute("data-attr") : null;
                this.buttonElements.forEach(function(n) {
                    var i = n.getAttribute("data-val") || !0, a = n.getAttribute("data-attr"), o = n.getAttribute("data-toggle") === "true", s = rN.select(n), l = function(f, h) {
                        var d = t.modebar, v = f.querySelector(".icon path");
                        v && (h || f.matches(":hover") ? v.style.fill = d.activecolor : v.style.fill = d.color);
                    };
                    if (o) {
                        if (a === r) {
                            var u = !s.classed("active");
                            s.classed("active", u), l(n, u);
                        }
                    } else {
                        var c = a === null ? a : aP.nestedProperty(t, a).get();
                        s.classed("active", c === i), l(n, c === i);
                    }
                });
            };
            Tm.hasButtons = function(e) {
                var t = this.buttons;
                if (!t || e.length !== t.length) return !1;
                for(var r = 0; r < e.length; ++r){
                    if (e[r].length !== t[r].length) return !1;
                    for(var n = 0; n < e[r].length; n++)if (e[r][n].name !== t[r][n].name) return !1;
                }
                return !0;
            };
            function kut(e) {
                return e + " (v" + Mut + ")";
            }
            Tm.getLogo = function() {
                var e = this.createGroup(), t = document.createElement("a");
                return t.href = "https://plotly.com/", t.target = "_blank", t.setAttribute("data-title", kut(aP._(this.graphInfo, "Produced with Plotly.js"))), t.className = "modebar-btn plotlyjsicon modebar-btn--logo", t.appendChild(this.createIcon(rce.newplotlylogo)), e.appendChild(t), e;
            };
            Tm.removeAllButtons = function() {
                for(; this.element.firstChild;)this.element.removeChild(this.element.firstChild);
                this.hasLogo = !1;
            };
            Tm.destroy = function() {
                aP.removeElement(this.container.querySelector(".modebar"));
            };
            function Cut(e, t) {
                var r = e._fullLayout, n = new ice({
                    graphInfo: e,
                    container: r._modebardiv.node(),
                    buttons: t
                });
                return r._privateplot && rN.select(n.element).append("span").classed("badge-private float--left", !0).text("PRIVATE"), n;
            }
            nce.exports = Cut;
        });
        var lce = ye((xir, sce)=>{
            "use strict";
            var Lut = af(), oce = lu(), iN = ba(), Put = rp().isUnifiedHover, Iut = ace(), oP = QB(), Rut = eN().DRAW_MODES, Dut = Mr().extendDeep;
            sce.exports = function(t) {
                var r = t._fullLayout, n = t._context, i = r._modeBar;
                if (!n.displayModeBar && !n.watermark) {
                    i && (i.destroy(), delete r._modeBar);
                    return;
                }
                if (!Array.isArray(n.modeBarButtonsToRemove)) throw new Error([
                    "*modeBarButtonsToRemove* configuration options",
                    "must be an array."
                ].join(" "));
                if (!Array.isArray(n.modeBarButtonsToAdd)) throw new Error([
                    "*modeBarButtonsToAdd* configuration options",
                    "must be an array."
                ].join(" "));
                var a = n.modeBarButtons, o;
                Array.isArray(a) && a.length ? o = Nut(a) : !n.displayModeBar && n.watermark ? o = [] : o = zut(t), i ? i.update(t, o) : r._modeBar = Iut(t, o);
            };
            function zut(e) {
                var t = e._fullLayout, r = e._fullData, n = e._context;
                function i(N, W) {
                    if (typeof W == "string") {
                        if (W.toLowerCase() === N.toLowerCase()) return !0;
                    } else {
                        var re = W.name, ae = W._cat || W.name;
                        if (re === N || ae === N.toLowerCase()) return !0;
                    }
                    return !1;
                }
                var a = t.modebar.add;
                typeof a == "string" && (a = [
                    a
                ]);
                var o = t.modebar.remove;
                typeof o == "string" && (o = [
                    o
                ]);
                var s = n.modeBarButtonsToAdd.concat(a.filter(function(N) {
                    for(var W = 0; W < n.modeBarButtonsToRemove.length; W++)if (i(N, n.modeBarButtonsToRemove[W])) return !1;
                    return !0;
                })), l = n.modeBarButtonsToRemove.concat(o.filter(function(N) {
                    for(var W = 0; W < n.modeBarButtonsToAdd.length; W++)if (i(N, n.modeBarButtonsToAdd[W])) return !1;
                    return !0;
                })), u = t._has("cartesian"), c = t._has("gl3d"), f = t._has("geo"), h = t._has("pie"), d = t._has("funnelarea"), v = t._has("ternary"), x = t._has("mapbox"), b = t._has("map"), p = t._has("polar"), E = t._has("smith"), k = t._has("sankey"), A = Fut(t), L = Put(t.hovermode), _ = [];
                function C(N) {
                    if (N.length) {
                        for(var W = [], re = 0; re < N.length; re++){
                            for(var ae = N[re], _e = oP[ae], Me = _e.name.toLowerCase(), ke = (_e._cat || _e.name).toLowerCase(), ge = !1, ie = 0; ie < l.length; ie++){
                                var Te = l[ie].toLowerCase();
                                if (Te === Me || Te === ke) {
                                    ge = !0;
                                    break;
                                }
                            }
                            ge || W.push(oP[ae]);
                        }
                        _.push(W);
                    }
                }
                var M = [
                    "toImage"
                ];
                n.showEditInChartStudio ? M.push("editInChartStudio") : n.showSendToCloud && M.push("sendDataToCloud"), C(M);
                var g = [], P = [], T = [], F = [];
                (u || h || d || v) + f + c + x + b + p + E > 1 ? (P = [
                    "toggleHover"
                ], T = [
                    "resetViews"
                ]) : f ? (g = [
                    "zoomInGeo",
                    "zoomOutGeo"
                ], P = [
                    "hoverClosestGeo"
                ], T = [
                    "resetGeo"
                ]) : c ? (P = [
                    "hoverClosest3d"
                ], T = [
                    "resetCameraDefault3d",
                    "resetCameraLastSave3d"
                ]) : x ? (g = [
                    "zoomInMapbox",
                    "zoomOutMapbox"
                ], P = [
                    "toggleHover"
                ], T = [
                    "resetViewMapbox"
                ]) : b ? (g = [
                    "zoomInMap",
                    "zoomOutMap"
                ], P = [
                    "toggleHover"
                ], T = [
                    "resetViewMap"
                ]) : h ? P = [
                    "hoverClosestPie"
                ] : k ? (P = [
                    "hoverClosestCartesian",
                    "hoverCompareCartesian"
                ], T = [
                    "resetViewSankey"
                ]) : P = [
                    "toggleHover"
                ], u && P.push("toggleSpikelines", "hoverClosestCartesian", "hoverCompareCartesian"), (Out(r) || L) && (P = []), u && !A && (g = [
                    "zoomIn2d",
                    "zoomOut2d",
                    "autoScale2d"
                ], T[0] !== "resetViews" && (T = [
                    "resetScale2d"
                ])), c ? F = [
                    "zoom3d",
                    "pan3d",
                    "orbitRotation",
                    "tableRotation"
                ] : u && !A || v ? F = [
                    "zoom2d",
                    "pan2d"
                ] : x || b || f ? F = [
                    "pan2d"
                ] : p && (F = [
                    "zoom2d"
                ]), qut(r) && F.push("select2d", "lasso2d");
                var q = [], V = function(N) {
                    q.indexOf(N) === -1 && P.indexOf(N) !== -1 && q.push(N);
                };
                if (Array.isArray(s)) {
                    for(var H = [], X = 0; X < s.length; X++){
                        var G = s[X];
                        typeof G == "string" ? (G = G.toLowerCase(), Rut.indexOf(G) !== -1 ? (t._has("mapbox") || t._has("map") || t._has("cartesian")) && F.push(G) : G === "togglespikelines" ? V("toggleSpikelines") : G === "togglehover" ? V("toggleHover") : G === "hovercompare" ? V("hoverCompareCartesian") : G === "hoverclosest" ? (V("hoverClosestCartesian"), V("hoverClosestGeo"), V("hoverClosest3d"), V("hoverClosestPie")) : G === "v1hovermode" && (V("hoverClosestCartesian"), V("hoverCompareCartesian"), V("hoverClosestGeo"), V("hoverClosest3d"), V("hoverClosestPie"))) : H.push(G);
                    }
                    s = H;
                }
                return C(F), C(g.concat(T)), C(q), But(_, s);
            }
            function Fut(e) {
                for(var t = Lut.list({
                    _fullLayout: e
                }, null, !0), r = 0; r < t.length; r++)if (!t[r].fixedrange) return !1;
                return !0;
            }
            function qut(e) {
                for(var t = !1, r = 0; r < e.length && !t; r++){
                    var n = e[r];
                    !n._module || !n._module.selectPoints || (iN.traceIs(n, "scatter-like") ? (oce.hasMarkers(n) || oce.hasText(n)) && (t = !0) : iN.traceIs(n, "box-violin") ? (n.boxpoints === "all" || n.points === "all") && (t = !0) : t = !0);
                }
                return t;
            }
            function Out(e) {
                for(var t = 0; t < e.length; t++)if (!iN.traceIs(e[t], "noHover")) return !1;
                return !0;
            }
            function But(e, t) {
                if (t.length) {
                    if (Array.isArray(t[0])) for(var r = 0; r < t.length; r++)e.push(t[r]);
                    else e.push(t);
                }
                return e;
            }
            function Nut(e) {
                for(var t = Dut([], e), r = 0; r < t.length; r++)for(var n = t[r], i = 0; i < n.length; i++){
                    var a = n[i];
                    if (typeof a == "string") {
                        if (oP[a] !== void 0) t[r][i] = oP[a];
                        else throw new Error([
                            "*modeBarButtons* configuration options",
                            "invalid button name"
                        ].join(" "));
                    }
                }
                return t;
            }
        });
        var nN = ye((bir, uce)=>{
            "use strict";
            uce.exports = {
                moduleType: "component",
                name: "modebar",
                layoutAttributes: tN(),
                supplyLayoutDefaults: tce(),
                manage: lce()
            };
        });
        var aN = ye((wir, cce)=>{
            "use strict";
            var Uut = Nh().FROM_BL;
            cce.exports = function(t, r, n) {
                n === void 0 && (n = Uut[t.constraintoward || "center"]);
                var i = [
                    t.r2l(t.range[0]),
                    t.r2l(t.range[1])
                ], a = i[0] + (i[1] - i[0]) * n;
                t.range = t._input.range = [
                    t.l2r(a + (i[0] - a) * r),
                    t.l2r(a + (i[1] - a) * r)
                ], t.setScale();
            };
        });
        var Bb = ye((dM)=>{
            "use strict";
            var Ob = Mr(), oN = wg(), Mg = af().id2name, Vut = Cd(), fce = aN(), Hut = ym(), Gut = es().ALMOST_EQUAL, jut = Nh().FROM_BL;
            dM.handleDefaults = function(e, t, r) {
                var n = r.axIds, i = r.axHasImage, a = t._axisConstraintGroups = [], o = t._axisMatchGroups = [], s, l, u, c, f, h, d, v;
                for(s = 0; s < n.length; s++)c = Mg(n[s]), f = e[c], h = t[c], Wut(f, h, {
                    axIds: n,
                    layoutOut: t,
                    hasImage: i[c]
                });
                function x(M, g) {
                    for(s = 0; s < M.length; s++){
                        l = M[s];
                        for(u in l)t[Mg(u)][g] = l;
                    }
                }
                for(x(o, "_matchGroup"), s = 0; s < a.length; s++){
                    l = a[s];
                    for(u in l)if (h = t[Mg(u)], h.fixedrange) {
                        for(var b in l){
                            var p = Mg(b);
                            (e[p] || {}).fixedrange === !1 && Ob.warn("fixedrange was specified as false for axis " + p + " but was overridden because another axis in its constraint group has fixedrange true"), t[p].fixedrange = !0;
                        }
                        break;
                    }
                }
                for(s = 0; s < a.length;){
                    l = a[s];
                    for(u in l){
                        h = t[Mg(u)], h._matchGroup && Object.keys(h._matchGroup).length === Object.keys(l).length && (a.splice(s, 1), s--);
                        break;
                    }
                    s++;
                }
                x(a, "_constraintGroup");
                var E = [
                    "constrain",
                    "range",
                    "autorange",
                    "rangemode",
                    "rangebreaks",
                    "categoryorder",
                    "categoryarray"
                ], k = !1, A = !1;
                function L() {
                    v = h[d], d === "rangebreaks" && (A = h._hasDayOfWeekBreaks);
                }
                for(s = 0; s < o.length; s++){
                    l = o[s];
                    for(var _ = 0; _ < E.length; _++){
                        d = E[_], v = null;
                        var C;
                        for(u in l)if (c = Mg(u), f = e[c], h = t[c], d in h) {
                            if (!h.matches && (C = h, d in f)) {
                                L();
                                break;
                            }
                            v === null && d in f && L();
                        }
                        if (d === "range" && v && f.range && f.range.length === 2 && f.range[0] !== null && f.range[1] !== null && (k = !0), d === "autorange" && v === null && k && (v = !1), v === null && d in C && (v = C[d]), v !== null) for(u in l)h = t[Mg(u)], h[d] = d === "range" ? v.slice() : v, d === "rangebreaks" && (h._hasDayOfWeekBreaks = A, Hut(h, t));
                    }
                }
            };
            function Wut(e, t, r) {
                var n = r.axIds, i = r.layoutOut, a = r.hasImage, o = i._axisConstraintGroups, s = i._axisMatchGroups, l = t._id, u = l.charAt(0), c = ((i._splomAxes || {})[u] || {})[l] || {}, f = t._id, h = f.charAt(0) === "x";
                t._matchGroup = null, t._constraintGroup = null;
                function d(F, q) {
                    return Ob.coerce(e, t, Vut, F, q);
                }
                d("constrain", a ? "domain" : "range"), Ob.coerce(e, t, {
                    constraintoward: {
                        valType: "enumerated",
                        values: h ? [
                            "left",
                            "center",
                            "right"
                        ] : [
                            "bottom",
                            "middle",
                            "top"
                        ],
                        dflt: h ? "center" : "middle"
                    }
                }, "constraintoward");
                var v = t.type, x, b, p = [];
                for(x = 0; x < n.length; x++)if (b = n[x], b !== f) {
                    var E = i[Mg(b)];
                    E.type === v && p.push(b);
                }
                var k = vce(o, f);
                if (k) {
                    var A = [];
                    for(x = 0; x < p.length; x++)b = p[x], k[b] || A.push(b);
                    p = A;
                }
                var L = p.length, _, C;
                L && (e.matches || c.matches) && (_ = Ob.coerce(e, t, {
                    matches: {
                        valType: "enumerated",
                        values: p,
                        dflt: p.indexOf(c.matches) !== -1 ? c.matches : void 0
                    }
                }, "matches"));
                var M = a && !h ? t.anchor : void 0;
                if (L && !_ && (e.scaleanchor || M) && (C = Ob.coerce(e, t, {
                    scaleanchor: {
                        valType: "enumerated",
                        values: p.concat([
                            !1
                        ])
                    }
                }, "scaleanchor", M)), _) {
                    t._matchGroup = sN(s, f, _, 1);
                    var g = i[Mg(_)], P = hce(i, t) / hce(i, g);
                    h !== (_.charAt(0) === "x") && (P = (h ? "x" : "y") + P), sN(o, f, _, P);
                } else e.matches && n.indexOf(e.matches) !== -1 && Ob.warn("ignored " + t._name + '.matches: "' + e.matches + '" to avoid an infinite loop');
                if (C) {
                    var T = d("scaleratio");
                    T || (T = t.scaleratio = 1), sN(o, f, C, T);
                } else e.scaleanchor && n.indexOf(e.scaleanchor) !== -1 && Ob.warn("ignored " + t._name + '.scaleanchor: "' + e.scaleanchor + '" to avoid either an infinite loop and possibly inconsistent scaleratios, or because this axis declares a *matches* constraint.');
            }
            function hce(e, t) {
                var r = t.domain;
                return r || (r = e[Mg(t.overlaying)].domain), r[1] - r[0];
            }
            function vce(e, t) {
                for(var r = 0; r < e.length; r++)if (e[r][t]) return e[r];
                return null;
            }
            function sN(e, t, r, n) {
                var i, a, o, s, l, u = vce(e, t);
                u === null ? (u = {}, u[t] = 1, l = e.length, e.push(u)) : l = e.indexOf(u);
                var c = Object.keys(u);
                for(i = 0; i < e.length; i++)if (o = e[i], i !== l && o[r]) {
                    var f = o[r];
                    for(a = 0; a < c.length; a++)s = c[a], o[s] = lN(f, lN(n, u[s]));
                    e.splice(l, 1);
                    return;
                }
                if (n !== 1) for(a = 0; a < c.length; a++){
                    var h = c[a];
                    u[h] = lN(n, u[h]);
                }
                u[r] = 1;
            }
            function lN(e, t) {
                var r = "", n = "", i, a;
                typeof e == "string" && (r = e.match(/^[xy]*/)[0], i = r.length, e = +e.substr(i)), typeof t == "string" && (n = t.match(/^[xy]*/)[0], a = n.length, t = +t.substr(a));
                var o = e * t;
                return !i && !a ? o : !i || !a || r.charAt(0) === n.charAt(0) ? r + n + e * t : i === a ? o : (i > a ? r.substr(a) : n.substr(i)) + o;
            }
            function Zut(e, t) {
                for(var r = t._size, n = r.h / r.w, i = {}, a = Object.keys(e), o = 0; o < a.length; o++){
                    var s = a[o], l = e[s];
                    if (typeof l == "string") {
                        var u = l.match(/^[xy]*/)[0], c = u.length;
                        l = +l.substr(c);
                        for(var f = u.charAt(0) === "y" ? n : 1 / n, h = 0; h < c; h++)l *= f;
                    }
                    i[s] = l;
                }
                return i;
            }
            dM.enforce = function(t) {
                var r = t._fullLayout, n = r._axisConstraintGroups || [], i, a, o, s, l, u, c, f;
                for(i = 0; i < n.length; i++){
                    o = Zut(n[i], r);
                    var h = Object.keys(o), d = 1 / 0, v = 0, x = 1 / 0, b = {}, p = {}, E = !1;
                    for(a = 0; a < h.length; a++)s = h[a], p[s] = l = r[Mg(s)], l._inputDomain ? l.domain = l._inputDomain.slice() : l._inputDomain = l.domain.slice(), l._inputRange || (l._inputRange = l.range.slice()), l.setScale(), b[s] = u = Math.abs(l._m) / o[s], d = Math.min(d, u), (l.constrain === "domain" || !l._constraintShrinkable) && (x = Math.min(x, u)), delete l._constraintShrinkable, v = Math.max(v, u), l.constrain === "domain" && (E = !0);
                    if (!(d > Gut * v && !E)) {
                        for(a = 0; a < h.length; a++)if (s = h[a], u = b[s], l = p[s], c = l.constrain, u !== x || c === "domain") {
                            if (f = u / x, c === "range") fce(l, f);
                            else {
                                var k = l._inputDomain, A = (l.domain[1] - l.domain[0]) / (k[1] - k[0]), L = (l.r2l(l.range[1]) - l.r2l(l.range[0])) / (l.r2l(l._inputRange[1]) - l.r2l(l._inputRange[0]));
                                if (f /= A, f * L < 1) {
                                    l.domain = l._input.domain = k.slice(), fce(l, f);
                                    continue;
                                }
                                if (L < 1 && (l.range = l._input.range = l._inputRange.slice(), f *= L), l.autorange) {
                                    var _ = l.r2l(l.range[0]), C = l.r2l(l.range[1]), M = (_ + C) / 2, g = M, P = M, T = Math.abs(C - M), F = M - T * f * 1.0001, q = M + T * f * 1.0001, V = oN.makePadFn(r, l, 0), H = oN.makePadFn(r, l, 1);
                                    dce(l, f);
                                    var X = Math.abs(l._m), G = oN.concatExtremes(t, l), N = G.min, W = G.max, re, ae;
                                    for(ae = 0; ae < N.length; ae++)re = N[ae].val - V(N[ae]) / X, re > F && re < g && (g = re);
                                    for(ae = 0; ae < W.length; ae++)re = W[ae].val + H(W[ae]) / X, re < q && re > P && (P = re);
                                    var _e = (P - g) / (2 * T);
                                    f /= _e, g = l.l2r(g), P = l.l2r(P), l.range = l._input.range = _ < C ? [
                                        g,
                                        P
                                    ] : [
                                        P,
                                        g
                                    ];
                                }
                                dce(l, f);
                            }
                        }
                    }
                }
            };
            dM.getAxisGroup = function(t, r) {
                for(var n = t._axisMatchGroups, i = 0; i < n.length; i++){
                    var a = n[i];
                    if (a[r]) return "g" + i;
                }
                return r;
            };
            dM.clean = function(t, r) {
                if (r._inputDomain) {
                    for(var n = !1, i = r._id, a = t._fullLayout._axisConstraintGroups, o = 0; o < a.length; o++)if (a[o][i]) {
                        n = !0;
                        break;
                    }
                    (!n || r.constrain !== "domain") && (r._input.domain = r.domain = r._inputDomain, delete r._inputDomain);
                }
            };
            function dce(e, t) {
                var r = e._inputDomain, n = jut[e.constraintoward], i = r[0] + (r[1] - r[0]) * n;
                e.domain = e._input.domain = [
                    i + (r[0] - i) / t,
                    i + (r[1] - i) / t
                ], e.setScale();
            }
        });
        var gM = ye((ld)=>{
            "use strict";
            var lP = xa(), Bv = ba(), Jp = Xu(), M0 = Mr(), uN = Pl(), cN = lM(), vM = va(), X3 = ao(), pce = Mb(), xce = nN(), pM = Qa(), ky = Nh(), bce = Bb(), Xut = bce.enforce, Yut = bce.clean, gce = wg().doAutoRange, wce = "start", Kut = "middle", Tce = "end", Jut = ad().zindexSeparator;
            ld.layoutStyles = function(e) {
                return M0.syncOrAsync([
                    Jp.doAutoMargin,
                    Qut
                ], e);
            };
            function $ut(e, t, r) {
                for(var n = 0; n < r.length; n++){
                    var i = r[n][0], a = r[n][1];
                    if (!(i[0] >= e[1] || i[1] <= e[0]) && a[0] < t[1] && a[1] > t[0]) return !0;
                }
                return !1;
            }
            function Qut(e) {
                var t = e._fullLayout, r = t._size, n = r.p, i = pM.list(e, "", !0), a, o, s, l, u, c;
                if (t._paperdiv.style({
                    width: e._context.responsive && t.autosize && !e._context._hasZeroWidth && !e.layout.width ? "100%" : t.width + "px",
                    height: e._context.responsive && t.autosize && !e._context._hasZeroHeight && !e.layout.height ? "100%" : t.height + "px"
                }).selectAll(".main-svg").call(X3.setSize, t.width, t.height), e._context.setBackground(e, t.paper_bgcolor), ld.drawMainTitle(e), xce.manage(e), !t._has("cartesian")) return Jp.previousPromises(e);
                function f(Ce, me, Re) {
                    var ce = Ce._lw / 2;
                    if (Ce._id.charAt(0) === "x") {
                        if (me) {
                            if (Re === "top") return me._offset - n - ce;
                        } else return r.t + r.h * (1 - (Ce.position || 0)) + ce % 1;
                        return me._offset + me._length + n + ce;
                    }
                    if (me) {
                        if (Re === "right") return me._offset + me._length + n + ce;
                    } else return r.l + r.w * (Ce.position || 0) + ce % 1;
                    return me._offset - n - ce;
                }
                for(a = 0; a < i.length; a++){
                    l = i[a];
                    var h = l._anchorAxis;
                    l._linepositions = {}, l._lw = X3.crispRound(e, l.linewidth, 1), l._mainLinePosition = f(l, h, l.side), l._mainMirrorPosition = l.mirror && h ? f(l, h, ky.OPPOSITE_SIDE[l.side]) : null;
                }
                var d = [], v = [], x = [], b = vM.opacity(t.paper_bgcolor) === 1 && vM.opacity(t.plot_bgcolor) === 1 && t.paper_bgcolor === t.plot_bgcolor;
                for(o in t._plots)if (s = t._plots[o], s.mainplot) s.bg && s.bg.remove(), s.bg = void 0;
                else {
                    var p = s.xaxis.domain, E = s.yaxis.domain, k = s.plotgroup;
                    if ($ut(p, E, x) && o.indexOf(Jut) === -1) {
                        var A = k.node(), L = s.bg = M0.ensureSingle(k, "rect", "bg");
                        A.insertBefore(L.node(), A.childNodes[0]), v.push(o);
                    } else k.select("rect.bg").remove(), x.push([
                        p,
                        E
                    ]), b || (d.push(o), v.push(o));
                }
                var _ = t._bgLayer.selectAll(".bg").data(d);
                for(_.enter().append("rect").classed("bg", !0), _.exit().remove(), _.each(function(Ce) {
                    t._plots[Ce].bg = lP.select(this);
                }), a = 0; a < v.length; a++)s = t._plots[v[a]], u = s.xaxis, c = s.yaxis, s.bg && u._offset !== void 0 && c._offset !== void 0 && s.bg.call(X3.setRect, u._offset - n, c._offset - n, u._length + 2 * n, c._length + 2 * n).call(vM.fill, t.plot_bgcolor).style("stroke-width", 0);
                if (!t._hasOnlyLargeSploms) for(o in t._plots){
                    s = t._plots[o], u = s.xaxis, c = s.yaxis;
                    var C = s.clipId = "clip" + t._uid + o + "plot", M = M0.ensureSingleById(t._clips, "clipPath", C, function(Ce) {
                        Ce.classed("plotclip", !0).append("rect");
                    });
                    s.clipRect = M.select("rect").attr({
                        width: u._length,
                        height: c._length
                    }), X3.setTranslate(s.plot, u._offset, c._offset);
                    var g, P;
                    s._hasClipOnAxisFalse ? (g = null, P = C) : (g = C, P = null), X3.setClipUrl(s.plot, g, e), s.layerClipId = P;
                }
                var T, F, q, V, H, X, G, N, W, re, ae, _e, Me;
                function ke(Ce) {
                    return "M" + T + "," + Ce + "H" + F;
                }
                function ge(Ce) {
                    return "M" + u._offset + "," + Ce + "h" + u._length;
                }
                function ie(Ce) {
                    return "M" + Ce + "," + N + "V" + G;
                }
                function Te(Ce) {
                    return c._shift !== void 0 && (Ce += c._shift), "M" + Ce + "," + c._offset + "v" + c._length;
                }
                function Ee(Ce, me, Re) {
                    if (!Ce.showline || o !== Ce._mainSubplot) return "";
                    if (!Ce._anchorAxis) return Re(Ce._mainLinePosition);
                    var ce = me(Ce._mainLinePosition);
                    return Ce.mirror && (ce += me(Ce._mainMirrorPosition)), ce;
                }
                for(o in t._plots){
                    s = t._plots[o], u = s.xaxis, c = s.yaxis;
                    var Ae = "M0,0";
                    mce(u, o) && (H = sP(u, "left", c, i), T = u._offset - (H ? n + H : 0), X = sP(u, "right", c, i), F = u._offset + u._length + (X ? n + X : 0), q = f(u, c, "bottom"), V = f(u, c, "top"), Me = !u._anchorAxis || o !== u._mainSubplot, Me && (u.mirror === "allticks" || u.mirror === "all") && (u._linepositions[o] = [
                        q,
                        V
                    ]), Ae = Ee(u, ke, ge), Me && u.showline && (u.mirror === "all" || u.mirror === "allticks") && (Ae += ke(q) + ke(V)), s.xlines.style("stroke-width", u._lw + "px").call(vM.stroke, u.showline ? u.linecolor : "rgba(0,0,0,0)")), s.xlines.attr("d", Ae);
                    var ze = "M0,0";
                    mce(c, o) && (ae = sP(c, "bottom", u, i), G = c._offset + c._length + (ae ? n : 0), _e = sP(c, "top", u, i), N = c._offset - (_e ? n : 0), W = f(c, u, "left"), re = f(c, u, "right"), Me = !c._anchorAxis || o !== c._mainSubplot, Me && (c.mirror === "allticks" || c.mirror === "all") && (c._linepositions[o] = [
                        W,
                        re
                    ]), ze = Ee(c, ie, Te), Me && c.showline && (c.mirror === "all" || c.mirror === "allticks") && (ze += ie(W) + ie(re)), s.ylines.style("stroke-width", c._lw + "px").call(vM.stroke, c.showline ? c.linecolor : "rgba(0,0,0,0)")), s.ylines.attr("d", ze);
                }
                return pM.makeClipPaths(e), Jp.previousPromises(e);
            }
            function mce(e, t) {
                return (e.ticks || e.showline) && (t === e._mainSubplot || e.mirror === "all" || e.mirror === "allticks");
            }
            function yce(e, t, r) {
                if (!r.showline || !r._lw) return !1;
                if (r.mirror === "all" || r.mirror === "allticks") return !0;
                var n = r._anchorAxis;
                if (!n) return !1;
                var i = ky.FROM_BL[t];
                return r.side === t ? n.domain[i] === e.domain[i] : r.mirror && n.domain[1 - i] === e.domain[1 - i];
            }
            function sP(e, t, r, n) {
                if (yce(e, t, r)) return r._lw;
                for(var i = 0; i < n.length; i++){
                    var a = n[i];
                    if (a._mainAxis === r._mainAxis && yce(e, t, a)) return a._lw;
                }
                return 0;
            }
            ld.drawMainTitle = function(e) {
                var t = e._fullLayout.title, r = e._fullLayout, n = oct(r), i = sct(r), a = act(r, i), o = nct(r, n);
                if (pce.draw(e, "gtitle", {
                    propContainer: r,
                    propName: "title.text",
                    subtitlePropName: "title.subtitle.text",
                    placeholder: r._dfltTitle.plot,
                    subtitlePlaceholder: r._dfltTitle.subtitle,
                    attributes: {
                        x: o,
                        y: a,
                        "text-anchor": n,
                        dy: i
                    }
                }), t.text && t.automargin) {
                    var s = lP.selectAll(".gtitle"), l = X3.bBox(lP.selectAll(".g-gtitle").node()).height, u = rct(e, t, l);
                    if (u > 0) {
                        ict(e, a, u, l), s.attr({
                            x: o,
                            y: a,
                            "text-anchor": n,
                            dy: _ce(t.yanchor)
                        }).call(uN.positionText, o, a);
                        var c = (t.text.match(uN.BR_TAG_ALL) || []).length;
                        if (c) {
                            var f = ky.LINE_SPACING * c + ky.MID_SHIFT;
                            t.y === 0 && (f = -f), s.selectAll(".line").each(function() {
                                var b = +this.getAttribute("dy").slice(0, -2) - f + "em";
                                this.setAttribute("dy", b);
                            });
                        }
                        var h = lP.selectAll(".gtitle-subtitle");
                        if (h.node()) {
                            var d = s.node().getBBox(), v = d.y + d.height, x = v + pce.SUBTITLE_PADDING_EM * t.subtitle.font.size;
                            h.attr({
                                x: o,
                                y: x,
                                "text-anchor": n,
                                dy: _ce(t.yanchor)
                            }).call(uN.positionText, o, x);
                        }
                    }
                }
            };
            function ect(e, t, r, n, i) {
                var a = t.yref === "paper" ? e._fullLayout._size.h : e._fullLayout.height, o = M0.isTopAnchor(t) ? n : n - i, s = r === "b" ? a - o : o;
                return M0.isTopAnchor(t) && r === "t" || M0.isBottomAnchor(t) && r === "b" ? !1 : s < i;
            }
            function tct(e, t, r, n, i) {
                var a = 0;
                return r === "middle" && (a += i / 2), e === "t" ? (r === "top" && (a += i), a += n - t * n) : (r === "bottom" && (a += i), a += t * n), a;
            }
            function rct(e, t, r) {
                var n = t.y, i = t.yanchor, a = n > .5 ? "t" : "b", o = e._fullLayout.margin[a], s = 0;
                return t.yref === "paper" ? s = r + t.pad.t + t.pad.b : t.yref === "container" && (s = tct(a, n, i, e._fullLayout.height, r) + t.pad.t + t.pad.b), s > o ? s : 0;
            }
            function ict(e, t, r, n) {
                var i = "title.automargin", a = e._fullLayout.title, o = a.y > .5 ? "t" : "b", s = {
                    x: a.x,
                    y: a.y,
                    t: 0,
                    b: 0
                }, l = {};
                a.yref === "paper" && ect(e, a, o, t, n) ? s[o] = r : a.yref === "container" && (l[o] = r, e._fullLayout._reservedMargin[i] = l), Jp.allowAutoMargin(e, i), Jp.autoMargin(e, i, s);
            }
            function nct(e, t) {
                var r = e.title, n = e._size, i = 0;
                switch(t === wce ? i = r.pad.l : t === Tce && (i = -r.pad.r), r.xref){
                    case "paper":
                        return n.l + n.w * r.x + i;
                    case "container":
                    default:
                        return e.width * r.x + i;
                }
            }
            function act(e, t) {
                var r = e.title, n = e._size, i = 0;
                if (t === "0em" || !t ? i = -r.pad.b : t === ky.CAP_SHIFT + "em" && (i = r.pad.t), r.y === "auto") return n.t / 2;
                switch(r.yref){
                    case "paper":
                        return n.t + n.h - n.h * r.y + i;
                    case "container":
                    default:
                        return e.height - e.height * r.y + i;
                }
            }
            function _ce(e) {
                return e === "top" ? ky.CAP_SHIFT + .3 + "em" : e === "bottom" ? "-0.3em" : ky.MID_SHIFT + "em";
            }
            function oct(e) {
                var t = e.title, r = Kut;
                return M0.isRightAnchor(t) ? r = Tce : M0.isLeftAnchor(t) && (r = wce), r;
            }
            function sct(e) {
                var t = e.title, r = "0em";
                return M0.isTopAnchor(t) ? r = ky.CAP_SHIFT + "em" : M0.isMiddleAnchor(t) && (r = ky.MID_SHIFT + "em"), r;
            }
            ld.doTraceStyle = function(e) {
                var t = e.calcdata, r = [], n;
                for(n = 0; n < t.length; n++){
                    var i = t[n], a = i[0] || {}, o = a.trace || {}, s = o._module || {}, l = s.arraysToCalcdata;
                    l && l(i, o);
                    var u = s.editStyle;
                    u && r.push({
                        fn: u,
                        cd0: a
                    });
                }
                if (r.length) {
                    for(n = 0; n < r.length; n++){
                        var c = r[n];
                        c.fn(e, c.cd0);
                    }
                    cN(e), ld.redrawReglTraces(e);
                }
                return Jp.style(e), Bv.getComponentMethod("legend", "draw")(e), Jp.previousPromises(e);
            };
            ld.doColorBars = function(e) {
                return Bv.getComponentMethod("colorbar", "draw")(e), Jp.previousPromises(e);
            };
            ld.layoutReplot = function(e) {
                var t = e.layout;
                return e.layout = void 0, Bv.call("_doPlot", e, "", t);
            };
            ld.doLegend = function(e) {
                return Bv.getComponentMethod("legend", "draw")(e), Jp.previousPromises(e);
            };
            ld.doTicksRelayout = function(e) {
                return pM.draw(e, "redraw"), e._fullLayout._hasOnlyLargeSploms && (Bv.subplotsRegistry.splom.updateGrid(e), cN(e), ld.redrawReglTraces(e)), ld.drawMainTitle(e), Jp.previousPromises(e);
            };
            ld.doModeBar = function(e) {
                var t = e._fullLayout;
                xce.manage(e);
                for(var r = 0; r < t._basePlotModules.length; r++){
                    var n = t._basePlotModules[r].updateFx;
                    n && n(e);
                }
                return Jp.previousPromises(e);
            };
            ld.doCamera = function(e) {
                for(var t = e._fullLayout, r = t._subplots.gl3d, n = 0; n < r.length; n++){
                    var i = t[r[n]], a = i._scene;
                    a.setViewport(i);
                }
            };
            ld.drawData = function(e) {
                var t = e._fullLayout;
                cN(e);
                for(var r = t._basePlotModules, n = 0; n < r.length; n++)r[n].plot(e);
                return ld.redrawReglTraces(e), Jp.style(e), Bv.getComponentMethod("selections", "draw")(e), Bv.getComponentMethod("shapes", "draw")(e), Bv.getComponentMethod("annotations", "draw")(e), Bv.getComponentMethod("images", "draw")(e), t._replotting = !1, Jp.previousPromises(e);
            };
            ld.redrawReglTraces = function(e) {
                var t = e._fullLayout;
                if (t._has("regl")) {
                    var r = e._fullData, n = [], i = [], a, o;
                    for(t._hasOnlyLargeSploms && t._splomGrid.draw(), a = 0; a < r.length; a++){
                        var s = r[a];
                        s.visible === !0 && s._length !== 0 && (s.type === "splom" ? t._splomScenes[s.uid].draw() : s.type === "scattergl" ? M0.pushUnique(n, s.xaxis + s.yaxis) : s.type === "scatterpolargl" && M0.pushUnique(i, s.subplot));
                    }
                    for(a = 0; a < n.length; a++)o = t._plots[n[a]], o._scene && o._scene.draw();
                    for(a = 0; a < i.length; a++)o = t[i[a]]._subplot, o._scene && o._scene.draw();
                }
            };
            ld.doAutoRangeAndConstraints = function(e) {
                for(var t = pM.list(e, "", !0), r, n = {}, i = 0; i < t.length; i++)if (r = t[i], !n[r._id]) {
                    n[r._id] = 1, Yut(e, r), gce(e, r);
                    var a = r._matchGroup;
                    if (a) for(var o in a){
                        var s = pM.getFromId(e, o);
                        gce(e, s, r.range), n[o] = 1;
                    }
                }
                Xut(e);
            };
            ld.finalDraw = function(e) {
                Bv.getComponentMethod("rangeslider", "draw")(e), Bv.getComponentMethod("rangeselector", "draw")(e);
            };
            ld.drawMarginPushers = function(e) {
                Bv.getComponentMethod("legend", "draw")(e), Bv.getComponentMethod("rangeselector", "draw")(e), Bv.getComponentMethod("sliders", "draw")(e), Bv.getComponentMethod("updatemenus", "draw")(e), Bv.getComponentMethod("colorbar", "draw")(e);
            };
        });
        var dN = ye((Sir, kce)=>{
            "use strict";
            var lct = c_().readPaths, uct = $L(), Ace = e_().clearOutlineControllers, fN = va(), Sce = ao(), cct = Vs().arrayEditor, Mce = h_(), fct = Mce.getPathString;
            kce.exports = {
                draw: uP,
                drawOne: Ece,
                activateLastSelection: vct
            };
            function uP(e) {
                var t = e._fullLayout;
                Ace(e), t._selectionLayer.selectAll("path").remove();
                for(var r in t._plots){
                    var n = t._plots[r].selectionLayer;
                    n && n.selectAll("path").remove();
                }
                for(var i = 0; i < t.selections.length; i++)Ece(e, i);
            }
            function cP(e) {
                return e._context.editSelection;
            }
            function Ece(e, t) {
                e._fullLayout._paperdiv.selectAll('.selectionlayer [data-index="' + t + '"]').remove();
                var r = Mce.makeSelectionsOptionsAndPlotinfo(e, t), n = r.options, i = r.plotinfo;
                if (!n._input) return;
                a(e._fullLayout._selectionLayer);
                function a(o) {
                    var s = fct(e, n), l = {
                        "data-index": t,
                        "fill-rule": "evenodd",
                        d: s
                    }, u = n.opacity, c = "rgba(0,0,0,0)", f = n.line.color || fN.contrast(e._fullLayout.plot_bgcolor), h = n.line.width, d = n.line.dash;
                    h || (h = 5, d = "solid");
                    var v = cP(e) && e._fullLayout._activeSelectionIndex === t;
                    v && (c = e._fullLayout.activeselection.fillcolor, u = e._fullLayout.activeselection.opacity);
                    for(var x = [], b = 1; b >= 0; b--){
                        var p = o.append("path").attr(l).style("opacity", b ? .1 : u).call(fN.stroke, f).call(fN.fill, c).call(Sce.dashLine, b ? "solid" : d, b ? 4 + h : h);
                        if (hct(p, e, n), v) {
                            var E = cct(e.layout, "selections", n);
                            p.style({
                                cursor: "move"
                            });
                            var k = {
                                element: p.node(),
                                plotinfo: i,
                                gd: e,
                                editHelpers: E,
                                isActiveSelection: !0
                            }, A = lct(s, e);
                            uct(A, p, k);
                        } else p.style("pointer-events", b ? "all" : "none");
                        x[b] = p;
                    }
                    var L = x[0], _ = x[1];
                    _.node().addEventListener("click", function() {
                        return dct(e, L);
                    });
                }
            }
            function hct(e, t, r) {
                var n = r.xref + r.yref;
                Sce.setClipUrl(e, "clip" + t._fullLayout._uid + n, t);
            }
            function dct(e, t) {
                if (cP(e)) {
                    var r = t.node(), n = +r.getAttribute("data-index");
                    if (n >= 0) {
                        if (n === e._fullLayout._activeSelectionIndex) {
                            hN(e);
                            return;
                        }
                        e._fullLayout._activeSelectionIndex = n, e._fullLayout._deactivateSelection = hN, uP(e);
                    }
                }
            }
            function vct(e) {
                if (cP(e)) {
                    var t = e._fullLayout.selections.length - 1;
                    e._fullLayout._activeSelectionIndex = t, e._fullLayout._deactivateSelection = hN, uP(e);
                }
            }
            function hN(e) {
                if (cP(e)) {
                    var t = e._fullLayout._activeSelectionIndex;
                    t >= 0 && (Ace(e), delete e._fullLayout._activeSelectionIndex, uP(e));
                }
            }
        });
        var Lce = ye((Mir, Cce)=>{
            function pct() {
                var e, t = 0, r = !1;
                function n(i, a) {
                    return e.list.push({
                        type: i,
                        data: a ? JSON.parse(JSON.stringify(a)) : void 0
                    }), e;
                }
                return e = {
                    list: [],
                    segmentId: function() {
                        return t++;
                    },
                    checkIntersection: function(i, a) {
                        return n("check", {
                            seg1: i,
                            seg2: a
                        });
                    },
                    segmentChop: function(i, a) {
                        return n("div_seg", {
                            seg: i,
                            pt: a
                        }), n("chop", {
                            seg: i,
                            pt: a
                        });
                    },
                    statusRemove: function(i) {
                        return n("pop_seg", {
                            seg: i
                        });
                    },
                    segmentUpdate: function(i) {
                        return n("seg_update", {
                            seg: i
                        });
                    },
                    segmentNew: function(i, a) {
                        return n("new_seg", {
                            seg: i,
                            primary: a
                        });
                    },
                    segmentRemove: function(i) {
                        return n("rem_seg", {
                            seg: i
                        });
                    },
                    tempStatus: function(i, a, o) {
                        return n("temp_status", {
                            seg: i,
                            above: a,
                            below: o
                        });
                    },
                    rewind: function(i) {
                        return n("rewind", {
                            seg: i
                        });
                    },
                    status: function(i, a, o) {
                        return n("status", {
                            seg: i,
                            above: a,
                            below: o
                        });
                    },
                    vert: function(i) {
                        return i === r ? e : (r = i, n("vert", {
                            x: i
                        }));
                    },
                    log: function(i) {
                        return typeof i != "string" && (i = JSON.stringify(i, !1, "  ")), n("log", {
                            txt: i
                        });
                    },
                    reset: function() {
                        return n("reset");
                    },
                    selected: function(i) {
                        return n("selected", {
                            segs: i
                        });
                    },
                    chainStart: function(i) {
                        return n("chain_start", {
                            seg: i
                        });
                    },
                    chainRemoveHead: function(i, a) {
                        return n("chain_rem_head", {
                            index: i,
                            pt: a
                        });
                    },
                    chainRemoveTail: function(i, a) {
                        return n("chain_rem_tail", {
                            index: i,
                            pt: a
                        });
                    },
                    chainNew: function(i, a) {
                        return n("chain_new", {
                            pt1: i,
                            pt2: a
                        });
                    },
                    chainMatch: function(i) {
                        return n("chain_match", {
                            index: i
                        });
                    },
                    chainClose: function(i) {
                        return n("chain_close", {
                            index: i
                        });
                    },
                    chainAddHead: function(i, a) {
                        return n("chain_add_head", {
                            index: i,
                            pt: a
                        });
                    },
                    chainAddTail: function(i, a) {
                        return n("chain_add_tail", {
                            index: i,
                            pt: a
                        });
                    },
                    chainConnect: function(i, a) {
                        return n("chain_con", {
                            index1: i,
                            index2: a
                        });
                    },
                    chainReverse: function(i) {
                        return n("chain_rev", {
                            index: i
                        });
                    },
                    chainJoin: function(i, a) {
                        return n("chain_join", {
                            index1: i,
                            index2: a
                        });
                    },
                    done: function() {
                        return n("done");
                    }
                }, e;
            }
            Cce.exports = pct;
        });
        var Ice = ye((Eir, Pce)=>{
            function gct(e) {
                typeof e != "number" && (e = 1e-10);
                var t = {
                    epsilon: function(r) {
                        return typeof r == "number" && (e = r), e;
                    },
                    pointAboveOrOnLine: function(r, n, i) {
                        var a = n[0], o = n[1], s = i[0], l = i[1], u = r[0], c = r[1];
                        return (s - a) * (c - o) - (l - o) * (u - a) >= -e;
                    },
                    pointBetween: function(r, n, i) {
                        var a = r[1] - n[1], o = i[0] - n[0], s = r[0] - n[0], l = i[1] - n[1], u = s * o + a * l;
                        if (u < e) return !1;
                        var c = o * o + l * l;
                        return !(u - c > -e);
                    },
                    pointsSameX: function(r, n) {
                        return Math.abs(r[0] - n[0]) < e;
                    },
                    pointsSameY: function(r, n) {
                        return Math.abs(r[1] - n[1]) < e;
                    },
                    pointsSame: function(r, n) {
                        return t.pointsSameX(r, n) && t.pointsSameY(r, n);
                    },
                    pointsCompare: function(r, n) {
                        return t.pointsSameX(r, n) ? t.pointsSameY(r, n) ? 0 : r[1] < n[1] ? -1 : 1 : r[0] < n[0] ? -1 : 1;
                    },
                    pointsCollinear: function(r, n, i) {
                        var a = r[0] - n[0], o = r[1] - n[1], s = n[0] - i[0], l = n[1] - i[1];
                        return Math.abs(a * l - s * o) < e;
                    },
                    linesIntersect: function(r, n, i, a) {
                        var o = n[0] - r[0], s = n[1] - r[1], l = a[0] - i[0], u = a[1] - i[1], c = o * u - s * l;
                        if (Math.abs(c) < e) return !1;
                        var f = r[0] - i[0], h = r[1] - i[1], d = (l * h - u * f) / c, v = (o * h - s * f) / c, x = {
                            alongA: 0,
                            alongB: 0,
                            pt: [
                                r[0] + d * o,
                                r[1] + d * s
                            ]
                        };
                        return d <= -e ? x.alongA = -2 : d < e ? x.alongA = -1 : d - 1 <= -e ? x.alongA = 0 : d - 1 < e ? x.alongA = 1 : x.alongA = 2, v <= -e ? x.alongB = -2 : v < e ? x.alongB = -1 : v - 1 <= -e ? x.alongB = 0 : v - 1 < e ? x.alongB = 1 : x.alongB = 2, x;
                    },
                    pointInsideRegion: function(r, n) {
                        for(var i = r[0], a = r[1], o = n[n.length - 1][0], s = n[n.length - 1][1], l = !1, u = 0; u < n.length; u++){
                            var c = n[u][0], f = n[u][1];
                            f - a > e != s - a > e && (o - c) * (a - f) / (s - f) + c - i > e && (l = !l), o = c, s = f;
                        }
                        return l;
                    }
                };
                return t;
            }
            Pce.exports = gct;
        });
        var Dce = ye((kir, Rce)=>{
            var mct = {
                create: function() {
                    var e = {
                        root: {
                            root: !0,
                            next: null
                        },
                        exists: function(t) {
                            return !(t === null || t === e.root);
                        },
                        isEmpty: function() {
                            return e.root.next === null;
                        },
                        getHead: function() {
                            return e.root.next;
                        },
                        insertBefore: function(t, r) {
                            for(var n = e.root, i = e.root.next; i !== null;){
                                if (r(i)) {
                                    t.prev = i.prev, t.next = i, i.prev.next = t, i.prev = t;
                                    return;
                                }
                                n = i, i = i.next;
                            }
                            n.next = t, t.prev = n, t.next = null;
                        },
                        findTransition: function(t) {
                            for(var r = e.root, n = e.root.next; n !== null && !t(n);)r = n, n = n.next;
                            return {
                                before: r === e.root ? null : r,
                                after: n,
                                insert: function(i) {
                                    return i.prev = r, i.next = n, r.next = i, n !== null && (n.prev = i), i;
                                }
                            };
                        }
                    };
                    return e;
                },
                node: function(e) {
                    return e.prev = null, e.next = null, e.remove = function() {
                        e.prev.next = e.next, e.next && (e.next.prev = e.prev), e.prev = null, e.next = null;
                    }, e;
                }
            };
            Rce.exports = mct;
        });
        var Fce = ye((Cir, zce)=>{
            var mM = Dce();
            function yct(e, t, r) {
                function n(v, x) {
                    return {
                        id: r ? r.segmentId() : -1,
                        start: v,
                        end: x,
                        myFill: {
                            above: null,
                            below: null
                        },
                        otherFill: null
                    };
                }
                function i(v, x, b) {
                    return {
                        id: r ? r.segmentId() : -1,
                        start: v,
                        end: x,
                        myFill: {
                            above: b.myFill.above,
                            below: b.myFill.below
                        },
                        otherFill: null
                    };
                }
                var a = mM.create();
                function o(v, x, b, p, E, k) {
                    var A = t.pointsCompare(x, E);
                    return A !== 0 ? A : t.pointsSame(b, k) ? 0 : v !== p ? v ? 1 : -1 : t.pointAboveOrOnLine(b, p ? E : k, p ? k : E) ? 1 : -1;
                }
                function s(v, x) {
                    a.insertBefore(v, function(b) {
                        var p = o(v.isStart, v.pt, x, b.isStart, b.pt, b.other.pt);
                        return p < 0;
                    });
                }
                function l(v, x) {
                    var b = mM.node({
                        isStart: !0,
                        pt: v.start,
                        seg: v,
                        primary: x,
                        other: null,
                        status: null
                    });
                    return s(b, v.end), b;
                }
                function u(v, x, b) {
                    var p = mM.node({
                        isStart: !1,
                        pt: x.end,
                        seg: x,
                        primary: b,
                        other: v,
                        status: null
                    });
                    v.other = p, s(p, v.pt);
                }
                function c(v, x) {
                    var b = l(v, x);
                    return u(b, v, x), b;
                }
                function f(v, x) {
                    r && r.segmentChop(v.seg, x), v.other.remove(), v.seg.end = x, v.other.pt = x, s(v.other, v.pt);
                }
                function h(v, x) {
                    var b = i(x, v.seg.end, v.seg);
                    return f(v, x), c(b, v.primary);
                }
                function d(v, x) {
                    var b = mM.create();
                    function p(H, X) {
                        var G = H.seg.start, N = H.seg.end, W = X.seg.start, re = X.seg.end;
                        return t.pointsCollinear(G, W, re) ? t.pointsCollinear(N, W, re) || t.pointAboveOrOnLine(N, W, re) ? 1 : -1 : t.pointAboveOrOnLine(G, W, re) ? 1 : -1;
                    }
                    function E(H) {
                        return b.findTransition(function(X) {
                            var G = p(H, X.ev);
                            return G > 0;
                        });
                    }
                    function k(H, X) {
                        var G = H.seg, N = X.seg, W = G.start, re = G.end, ae = N.start, _e = N.end;
                        r && r.checkIntersection(G, N);
                        var Me = t.linesIntersect(W, re, ae, _e);
                        if (Me === !1) {
                            if (!t.pointsCollinear(W, re, ae) || t.pointsSame(W, _e) || t.pointsSame(re, ae)) return !1;
                            var ke = t.pointsSame(W, ae), ge = t.pointsSame(re, _e);
                            if (ke && ge) return X;
                            var ie = !ke && t.pointBetween(W, ae, _e), Te = !ge && t.pointBetween(re, ae, _e);
                            if (ke) return Te ? h(X, re) : h(H, _e), X;
                            ie && (ge || (Te ? h(X, re) : h(H, _e)), h(X, W));
                        } else Me.alongA === 0 && (Me.alongB === -1 ? h(H, ae) : Me.alongB === 0 ? h(H, Me.pt) : Me.alongB === 1 && h(H, _e)), Me.alongB === 0 && (Me.alongA === -1 ? h(X, W) : Me.alongA === 0 ? h(X, Me.pt) : Me.alongA === 1 && h(X, re));
                        return !1;
                    }
                    for(var A = []; !a.isEmpty();){
                        var L = a.getHead();
                        if (r && r.vert(L.pt[0]), L.isStart) {
                            let H = function() {
                                if (C) {
                                    var X = k(L, C);
                                    if (X) return X;
                                }
                                return M ? k(L, M) : !1;
                            };
                            var V = H;
                            r && r.segmentNew(L.seg, L.primary);
                            var _ = E(L), C = _.before ? _.before.ev : null, M = _.after ? _.after.ev : null;
                            r && r.tempStatus(L.seg, C ? C.seg : !1, M ? M.seg : !1);
                            var g = H();
                            if (g) {
                                if (e) {
                                    var P;
                                    L.seg.myFill.below === null ? P = !0 : P = L.seg.myFill.above !== L.seg.myFill.below, P && (g.seg.myFill.above = !g.seg.myFill.above);
                                } else g.seg.otherFill = L.seg.myFill;
                                r && r.segmentUpdate(g.seg), L.other.remove(), L.remove();
                            }
                            if (a.getHead() !== L) {
                                r && r.rewind(L.seg);
                                continue;
                            }
                            if (e) {
                                var P;
                                L.seg.myFill.below === null ? P = !0 : P = L.seg.myFill.above !== L.seg.myFill.below, M ? L.seg.myFill.below = M.seg.myFill.above : L.seg.myFill.below = v, P ? L.seg.myFill.above = !L.seg.myFill.below : L.seg.myFill.above = L.seg.myFill.below;
                            } else if (L.seg.otherFill === null) {
                                var T;
                                M ? L.primary === M.primary ? T = M.seg.otherFill.above : T = M.seg.myFill.above : T = L.primary ? x : v, L.seg.otherFill = {
                                    above: T,
                                    below: T
                                };
                            }
                            r && r.status(L.seg, C ? C.seg : !1, M ? M.seg : !1), L.other.status = _.insert(mM.node({
                                ev: L
                            }));
                        } else {
                            var F = L.status;
                            if (F === null) throw new Error("PolyBool: Zero-length segment detected; your epsilon is probably too small or too large");
                            if (b.exists(F.prev) && b.exists(F.next) && k(F.prev.ev, F.next.ev), r && r.statusRemove(F.ev.seg), F.remove(), !L.primary) {
                                var q = L.seg.myFill;
                                L.seg.myFill = L.seg.otherFill, L.seg.otherFill = q;
                            }
                            A.push(L.seg);
                        }
                        a.getHead().remove();
                    }
                    return r && r.done(), A;
                }
                return e ? {
                    addRegion: function(v) {
                        for(var x, b = v[v.length - 1], p = 0; p < v.length; p++){
                            x = b, b = v[p];
                            var E = t.pointsCompare(x, b);
                            E !== 0 && c(n(E < 0 ? x : b, E < 0 ? b : x), !0);
                        }
                    },
                    calculate: function(v) {
                        return d(v, !1);
                    }
                } : {
                    calculate: function(v, x, b, p) {
                        return v.forEach(function(E) {
                            c(i(E.start, E.end, E), !0);
                        }), b.forEach(function(E) {
                            c(i(E.start, E.end, E), !1);
                        }), d(x, p);
                    }
                };
            }
            zce.exports = yct;
        });
        var Oce = ye((Lir, qce)=>{
            function _ct(e, t, r) {
                var n = [], i = [];
                return e.forEach(function(a) {
                    var o = a.start, s = a.end;
                    if (t.pointsSame(o, s)) {
                        console.warn("PolyBool: Warning: Zero-length segment detected; your epsilon is probably too small or too large");
                        return;
                    }
                    r && r.chainStart(a);
                    var l = {
                        index: 0,
                        matches_head: !1,
                        matches_pt1: !1
                    }, u = {
                        index: 0,
                        matches_head: !1,
                        matches_pt1: !1
                    }, c = l;
                    function f(V, H, X) {
                        return c.index = V, c.matches_head = H, c.matches_pt1 = X, c === l ? (c = u, !1) : (c = null, !0);
                    }
                    for(var h = 0; h < n.length; h++){
                        var d = n[h], v = d[0], x = d[1], b = d[d.length - 1], p = d[d.length - 2];
                        if (t.pointsSame(v, o)) {
                            if (f(h, !0, !0)) break;
                        } else if (t.pointsSame(v, s)) {
                            if (f(h, !0, !1)) break;
                        } else if (t.pointsSame(b, o)) {
                            if (f(h, !1, !0)) break;
                        } else if (t.pointsSame(b, s) && f(h, !1, !1)) break;
                    }
                    if (c === l) {
                        n.push([
                            o,
                            s
                        ]), r && r.chainNew(o, s);
                        return;
                    }
                    if (c === u) {
                        r && r.chainMatch(l.index);
                        var E = l.index, k = l.matches_pt1 ? s : o, A = l.matches_head, d = n[E], L = A ? d[0] : d[d.length - 1], _ = A ? d[1] : d[d.length - 2], C = A ? d[d.length - 1] : d[0], M = A ? d[d.length - 2] : d[1];
                        if (t.pointsCollinear(_, L, k) && (A ? (r && r.chainRemoveHead(l.index, k), d.shift()) : (r && r.chainRemoveTail(l.index, k), d.pop()), L = _), t.pointsSame(C, k)) {
                            n.splice(E, 1), t.pointsCollinear(M, C, L) && (A ? (r && r.chainRemoveTail(l.index, L), d.pop()) : (r && r.chainRemoveHead(l.index, L), d.shift())), r && r.chainClose(l.index), i.push(d);
                            return;
                        }
                        A ? (r && r.chainAddHead(l.index, k), d.unshift(k)) : (r && r.chainAddTail(l.index, k), d.push(k));
                        return;
                    }
                    function g(V) {
                        r && r.chainReverse(V), n[V].reverse();
                    }
                    function P(V, H) {
                        var X = n[V], G = n[H], N = X[X.length - 1], W = X[X.length - 2], re = G[0], ae = G[1];
                        t.pointsCollinear(W, N, re) && (r && r.chainRemoveTail(V, N), X.pop(), N = W), t.pointsCollinear(N, re, ae) && (r && r.chainRemoveHead(H, re), G.shift()), r && r.chainJoin(V, H), n[V] = X.concat(G), n.splice(H, 1);
                    }
                    var T = l.index, F = u.index;
                    r && r.chainConnect(T, F);
                    var q = n[T].length < n[F].length;
                    l.matches_head ? u.matches_head ? q ? (g(T), P(T, F)) : (g(F), P(F, T)) : P(F, T) : u.matches_head ? P(T, F) : q ? (g(T), P(F, T)) : (g(F), P(T, F));
                }), i;
            }
            qce.exports = _ct;
        });
        var Nce = ye((Pir, Bce)=>{
            function yM(e, t, r) {
                var n = [];
                return e.forEach(function(i) {
                    var a = (i.myFill.above ? 8 : 0) + (i.myFill.below ? 4 : 0) + (i.otherFill && i.otherFill.above ? 2 : 0) + (i.otherFill && i.otherFill.below ? 1 : 0);
                    t[a] !== 0 && n.push({
                        id: r ? r.segmentId() : -1,
                        start: i.start,
                        end: i.end,
                        myFill: {
                            above: t[a] === 1,
                            below: t[a] === 2
                        },
                        otherFill: null
                    });
                }), r && r.selected(n), n;
            }
            var xct = {
                union: function(e, t) {
                    return yM(e, [
                        0,
                        2,
                        1,
                        0,
                        2,
                        2,
                        0,
                        0,
                        1,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], t);
                },
                intersect: function(e, t) {
                    return yM(e, [
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        0,
                        2,
                        0,
                        0,
                        1,
                        1,
                        0,
                        2,
                        1,
                        0
                    ], t);
                },
                difference: function(e, t) {
                    return yM(e, [
                        0,
                        0,
                        0,
                        0,
                        2,
                        0,
                        2,
                        0,
                        1,
                        1,
                        0,
                        0,
                        0,
                        1,
                        2,
                        0
                    ], t);
                },
                differenceRev: function(e, t) {
                    return yM(e, [
                        0,
                        2,
                        1,
                        0,
                        0,
                        0,
                        1,
                        1,
                        0,
                        2,
                        0,
                        2,
                        0,
                        0,
                        0,
                        0
                    ], t);
                },
                xor: function(e, t) {
                    return yM(e, [
                        0,
                        2,
                        1,
                        0,
                        2,
                        0,
                        0,
                        1,
                        1,
                        0,
                        0,
                        2,
                        0,
                        1,
                        2,
                        0
                    ], t);
                }
            };
            Bce.exports = xct;
        });
        var Vce = ye((Iir, Uce)=>{
            var bct = {
                toPolygon: function(e, t) {
                    function r(a) {
                        if (a.length <= 0) return e.segments({
                            inverted: !1,
                            regions: []
                        });
                        function o(u) {
                            var c = u.slice(0, u.length - 1);
                            return e.segments({
                                inverted: !1,
                                regions: [
                                    c
                                ]
                            });
                        }
                        for(var s = o(a[0]), l = 1; l < a.length; l++)s = e.selectDifference(e.combine(s, o(a[l])));
                        return s;
                    }
                    if (t.type === "Polygon") return e.polygon(r(t.coordinates));
                    if (t.type === "MultiPolygon") {
                        for(var n = e.segments({
                            inverted: !1,
                            regions: []
                        }), i = 0; i < t.coordinates.length; i++)n = e.selectUnion(e.combine(n, r(t.coordinates[i])));
                        return e.polygon(n);
                    }
                    throw new Error("PolyBool: Cannot convert GeoJSON object to PolyBool polygon");
                },
                fromPolygon: function(e, t, r) {
                    r = e.polygon(e.segments(r));
                    function n(d, v) {
                        return t.pointInsideRegion([
                            (d[0][0] + d[1][0]) * .5,
                            (d[0][1] + d[1][1]) * .5
                        ], v);
                    }
                    function i(d) {
                        return {
                            region: d,
                            children: []
                        };
                    }
                    var a = i(null);
                    function o(d, v) {
                        for(var x = 0; x < d.children.length; x++){
                            var b = d.children[x];
                            if (n(v, b.region)) {
                                o(b, v);
                                return;
                            }
                        }
                        for(var p = i(v), x = 0; x < d.children.length; x++){
                            var b = d.children[x];
                            n(b.region, v) && (p.children.push(b), d.children.splice(x, 1), x--);
                        }
                        d.children.push(p);
                    }
                    for(var s = 0; s < r.regions.length; s++){
                        var l = r.regions[s];
                        l.length < 3 || o(a, l);
                    }
                    function u(d, v) {
                        for(var x = 0, b = d[d.length - 1][0], p = d[d.length - 1][1], E = [], k = 0; k < d.length; k++){
                            var A = d[k][0], L = d[k][1];
                            E.push([
                                A,
                                L
                            ]), x += L * b - A * p, b = A, p = L;
                        }
                        var _ = x < 0;
                        return _ !== v && E.reverse(), E.push([
                            E[0][0],
                            E[0][1]
                        ]), E;
                    }
                    var c = [];
                    function f(d) {
                        var v = [
                            u(d.region, !1)
                        ];
                        c.push(v);
                        for(var x = 0; x < d.children.length; x++)v.push(h(d.children[x]));
                    }
                    function h(d) {
                        for(var v = 0; v < d.children.length; v++)f(d.children[v]);
                        return u(d.region, !0);
                    }
                    for(var s = 0; s < a.children.length; s++)f(a.children[s]);
                    return c.length <= 0 ? {
                        type: "Polygon",
                        coordinates: []
                    } : c.length == 1 ? {
                        type: "Polygon",
                        coordinates: c[0]
                    } : {
                        type: "MultiPolygon",
                        coordinates: c
                    };
                }
            };
            Uce.exports = bct;
        });
        var Wce = ye((Rir, jce)=>{
            var wct = Lce(), Tct = Ice(), Hce = Fce(), Act = Oce(), _M = Nce(), Gce = Vce(), E0 = !1, xM = Tct(), Ep;
            Ep = {
                buildLog: function(e) {
                    return e === !0 ? E0 = wct() : e === !1 && (E0 = !1), E0 === !1 ? !1 : E0.list;
                },
                epsilon: function(e) {
                    return xM.epsilon(e);
                },
                segments: function(e) {
                    var t = Hce(!0, xM, E0);
                    return e.regions.forEach(t.addRegion), {
                        segments: t.calculate(e.inverted),
                        inverted: e.inverted
                    };
                },
                combine: function(e, t) {
                    var r = Hce(!1, xM, E0);
                    return {
                        combined: r.calculate(e.segments, e.inverted, t.segments, t.inverted),
                        inverted1: e.inverted,
                        inverted2: t.inverted
                    };
                },
                selectUnion: function(e) {
                    return {
                        segments: _M.union(e.combined, E0),
                        inverted: e.inverted1 || e.inverted2
                    };
                },
                selectIntersect: function(e) {
                    return {
                        segments: _M.intersect(e.combined, E0),
                        inverted: e.inverted1 && e.inverted2
                    };
                },
                selectDifference: function(e) {
                    return {
                        segments: _M.difference(e.combined, E0),
                        inverted: e.inverted1 && !e.inverted2
                    };
                },
                selectDifferenceRev: function(e) {
                    return {
                        segments: _M.differenceRev(e.combined, E0),
                        inverted: !e.inverted1 && e.inverted2
                    };
                },
                selectXor: function(e) {
                    return {
                        segments: _M.xor(e.combined, E0),
                        inverted: e.inverted1 !== e.inverted2
                    };
                },
                polygon: function(e) {
                    return {
                        regions: Act(e.segments, xM, E0),
                        inverted: e.inverted
                    };
                },
                polygonFromGeoJSON: function(e) {
                    return Gce.toPolygon(Ep, e);
                },
                polygonToGeoJSON: function(e) {
                    return Gce.fromPolygon(Ep, xM, e);
                },
                union: function(e, t) {
                    return bM(e, t, Ep.selectUnion);
                },
                intersect: function(e, t) {
                    return bM(e, t, Ep.selectIntersect);
                },
                difference: function(e, t) {
                    return bM(e, t, Ep.selectDifference);
                },
                differenceRev: function(e, t) {
                    return bM(e, t, Ep.selectDifferenceRev);
                },
                xor: function(e, t) {
                    return bM(e, t, Ep.selectXor);
                }
            };
            function bM(e, t, r) {
                var n = Ep.segments(e), i = Ep.segments(t), a = Ep.combine(n, i), o = r(a);
                return Ep.polygon(o);
            }
            typeof window == "object" && (window.PolyBool = Ep);
            jce.exports = Ep;
        });
        var Xce = ye((Dir, Zce)=>{
            Zce.exports = function(t, r, n, i) {
                var a = t[0], o = t[1], s = !1;
                n === void 0 && (n = 0), i === void 0 && (i = r.length);
                for(var l = i - n, u = 0, c = l - 1; u < l; c = u++){
                    var f = r[u + n][0], h = r[u + n][1], d = r[c + n][0], v = r[c + n][1], x = h > o != v > o && a < (d - f) * (o - h) / (v - h) + f;
                    x && (s = !s);
                }
                return s;
            };
        });
        var wM = ye((zir, Yce)=>{
            "use strict";
            var vN = m6().dot, fP = es().BADNUM, hP = Yce.exports = {};
            hP.tester = function(t) {
                var r = t.slice(), n = r[0][0], i = n, a = r[0][1], o = a, s;
                for((r[r.length - 1][0] !== r[0][0] || r[r.length - 1][1] !== r[0][1]) && r.push(r[0]), s = 1; s < r.length; s++)n = Math.min(n, r[s][0]), i = Math.max(i, r[s][0]), a = Math.min(a, r[s][1]), o = Math.max(o, r[s][1]);
                var l = !1, u;
                r.length === 5 && (r[0][0] === r[1][0] ? r[2][0] === r[3][0] && r[0][1] === r[3][1] && r[1][1] === r[2][1] && (l = !0, u = function(v) {
                    return v[0] === r[0][0];
                }) : r[0][1] === r[1][1] && r[2][1] === r[3][1] && r[0][0] === r[3][0] && r[1][0] === r[2][0] && (l = !0, u = function(v) {
                    return v[1] === r[0][1];
                }));
                function c(v, x) {
                    var b = v[0], p = v[1];
                    return !(b === fP || b < n || b > i || p === fP || p < a || p > o || x && u(v));
                }
                function f(v, x) {
                    var b = v[0], p = v[1];
                    if (b === fP || b < n || b > i || p === fP || p < a || p > o) return !1;
                    var E = r.length, k = r[0][0], A = r[0][1], L = 0, _, C, M, g, P;
                    for(_ = 1; _ < E; _++)if (C = k, M = A, k = r[_][0], A = r[_][1], g = Math.min(C, k), !(b < g || b > Math.max(C, k) || p > Math.max(M, A))) {
                        if (p < Math.min(M, A)) b !== g && L++;
                        else {
                            if (k === C ? P = p : P = M + (b - C) * (A - M) / (k - C), p === P) return !(_ === 1 && x);
                            p <= P && b !== g && L++;
                        }
                    }
                    return L % 2 === 1;
                }
                var h = !0, d = r[0];
                for(s = 1; s < r.length; s++)if (d[0] !== r[s][0] || d[1] !== r[s][1]) {
                    h = !1;
                    break;
                }
                return {
                    xmin: n,
                    xmax: i,
                    ymin: a,
                    ymax: o,
                    pts: r,
                    contains: l ? c : f,
                    isRect: l,
                    degenerate: h
                };
            };
            hP.isSegmentBent = function(t, r, n, i) {
                var a = t[r], o = [
                    t[n][0] - a[0],
                    t[n][1] - a[1]
                ], s = vN(o, o), l = Math.sqrt(s), u = [
                    -o[1] / l,
                    o[0] / l
                ], c, f, h;
                for(c = r + 1; c < n; c++)if (f = [
                    t[c][0] - a[0],
                    t[c][1] - a[1]
                ], h = vN(f, o), h < 0 || h > s || Math.abs(vN(f, u)) > i) return !0;
                return !1;
            };
            hP.filter = function(t, r) {
                var n = [
                    t[0]
                ], i = 0, a = 0;
                function o(l) {
                    t.push(l);
                    var u = n.length, c = i;
                    n.splice(a + 1);
                    for(var f = c + 1; f < t.length; f++)(f === t.length - 1 || hP.isSegmentBent(t, c, f + 1, r)) && (n.push(t[f]), n.length < u - 2 && (i = f, a = n.length - 1), c = f);
                }
                if (t.length > 1) {
                    var s = t.pop();
                    o(s);
                }
                return {
                    addPt: o,
                    raw: t,
                    filtered: n
                };
            };
        });
        var Jce = ye((Fir, Kce)=>{
            "use strict";
            Kce.exports = {
                BENDPX: 1.5,
                MINSELECT: 12,
                SELECTDELAY: 100,
                SELECTID: "-select"
            };
        });
        var _fe = ye((qir, yfe)=>{
            "use strict";
            var $ce = Wce(), Sct = Xce(), SM = ba(), Mct = ao().dashStyle, TM = va(), Ect = Nc(), kct = rp().makeEventData, LM = Sg(), Cct = LM.freeMode, Lct = LM.rectMode, MM = LM.drawMode, yN = LM.openMode, _N = LM.selectMode, Qce = h_(), efe = cM(), afe = $L(), ofe = e_().clearOutline, sfe = c_(), pN = sfe.handleEllipse, Pct = sfe.readPaths, Ict = XL().newShapes, Rct = VB(), Dct = dN().activateLastSelection, vP = Mr(), zct = vP.sorterAsc, lfe = wM(), AM = P6(), k0 = af().getFromId, Fct = lM(), qct = gM().redrawReglTraces, pP = Jce(), Am = pP.MINSELECT, Oct = lfe.filter, xN = lfe.tester, bN = GL(), tfe = bN.p2r, Bct = bN.axValue, Nct = bN.getTransform;
            function wN(e) {
                return e.subplot !== void 0;
            }
            function Uct(e, t, r, n, i) {
                var a = !wN(n), o = Cct(i), s = Lct(i), l = yN(i), u = MM(i), c = _N(i), f = i === "drawline", h = i === "drawcircle", d = f || h, v = n.gd, x = v._fullLayout, b = c && x.newselection.mode === "immediate" && a, p = x._zoomlayer, E = n.element.getBoundingClientRect(), k = n.plotinfo, A = Nct(k), L = t - E.left, _ = r - E.top;
                x._calcInverseTransform(v);
                var C = vP.apply3DTransform(x._invTransform)(L, _);
                L = C[0], _ = C[1];
                var M = x._invScaleX, g = x._invScaleY, P = L, T = _, F = "M" + L + "," + _, q = n.xaxes[0], V = n.yaxes[0], H = q._length, X = V._length, G = e.altKey && !(MM(i) && l), N, W, re, ae, _e, Me, ke;
                cfe(e, v, n), o && (N = Oct([
                    [
                        L,
                        _
                    ]
                ], pP.BENDPX));
                var ge = p.selectAll("path.select-outline-" + k.id).data([
                    1
                ]), ie = u ? x.newshape : x.newselection;
                u && (n.hasText = ie.label.text || ie.label.texttemplate);
                var Te = u && !l ? ie.fillcolor : "rgba(0,0,0,0)", Ee = ie.line.color || (a ? TM.contrast(v._fullLayout.plot_bgcolor) : "#7f7f7f");
                ge.enter().append("path").attr("class", "select-outline select-outline-" + k.id).style({
                    opacity: u ? ie.opacity / 2 : 1,
                    "stroke-dasharray": Mct(ie.line.dash, ie.line.width),
                    "stroke-width": ie.line.width + "px",
                    "shape-rendering": "crispEdges"
                }).call(TM.stroke, Ee).call(TM.fill, Te).attr("fill-rule", "evenodd").classed("cursor-move", !!u).attr("transform", A).attr("d", F + "Z");
                var Ae = p.append("path").attr("class", "zoombox-corners").style({
                    fill: TM.background,
                    stroke: TM.defaultLine,
                    "stroke-width": 1
                }).attr("transform", A).attr("d", "M0,0Z");
                if (u && n.hasText) {
                    var ze = p.select(".label-temp");
                    ze.empty() && (ze = p.append("g").classed("label-temp", !0).classed("select-outline", !0).style({
                        opacity: .8
                    }));
                }
                var Ce = x._uid + pP.SELECTID, me = [], Re = gP(v, n.xaxes, n.yaxes, n.subplot);
                b && !e.shiftKey && (n._clearSubplotSelections = function() {
                    if (a) {
                        var Ge = q._id, nt = V._id;
                        pfe(v, Ge, nt, Re);
                        for(var ct = (v.layout || {}).selections || [], qt = [], rt = !1, ot = 0; ot < ct.length; ot++){
                            var Rt = x.selections[ot];
                            !Rt || Rt.xref !== Ge || Rt.yref !== nt ? qt.push(ct[ot]) : rt = !0;
                        }
                        rt && (v._fullLayout._noEmitSelectedAtStart = !0, SM.call("_guiRelayout", v, {
                            selections: qt
                        }));
                    }
                });
                var ce = tft(n);
                n.moveFn = function(Ge, nt) {
                    n._clearSubplotSelections && (n._clearSubplotSelections(), n._clearSubplotSelections = void 0), P = Math.max(0, Math.min(H, M * Ge + L)), T = Math.max(0, Math.min(X, g * nt + _));
                    var ct = Math.abs(P - L), qt = Math.abs(T - _);
                    if (s) {
                        var rt, ot, Rt;
                        if (c) {
                            var kt = x.selectdirection;
                            switch(kt === "any" ? qt < Math.min(ct * .6, Am) ? rt = "h" : ct < Math.min(qt * .6, Am) ? rt = "v" : rt = "d" : rt = kt, rt){
                                case "h":
                                    ot = h ? X / 2 : 0, Rt = X;
                                    break;
                                case "v":
                                    ot = h ? H / 2 : 0, Rt = H;
                                    break;
                            }
                        }
                        if (u) switch(x.newshape.drawdirection){
                            case "vertical":
                                rt = "h", ot = h ? X / 2 : 0, Rt = X;
                                break;
                            case "horizontal":
                                rt = "v", ot = h ? H / 2 : 0, Rt = H;
                                break;
                            case "ortho":
                                ct < qt ? (rt = "h", ot = _, Rt = T) : (rt = "v", ot = L, Rt = P);
                                break;
                            default:
                                rt = "d";
                        }
                        rt === "h" ? (ae = d ? pN(h, [
                            P,
                            ot
                        ], [
                            P,
                            Rt
                        ]) : [
                            [
                                L,
                                ot
                            ],
                            [
                                L,
                                Rt
                            ],
                            [
                                P,
                                Rt
                            ],
                            [
                                P,
                                ot
                            ]
                        ], ae.xmin = d ? P : Math.min(L, P), ae.xmax = d ? P : Math.max(L, P), ae.ymin = Math.min(ot, Rt), ae.ymax = Math.max(ot, Rt), Ae.attr("d", "M" + ae.xmin + "," + (_ - Am) + "h-4v" + 2 * Am + "h4ZM" + (ae.xmax - 1) + "," + (_ - Am) + "h4v" + 2 * Am + "h-4Z")) : rt === "v" ? (ae = d ? pN(h, [
                            ot,
                            T
                        ], [
                            Rt,
                            T
                        ]) : [
                            [
                                ot,
                                _
                            ],
                            [
                                ot,
                                T
                            ],
                            [
                                Rt,
                                T
                            ],
                            [
                                Rt,
                                _
                            ]
                        ], ae.xmin = Math.min(ot, Rt), ae.xmax = Math.max(ot, Rt), ae.ymin = d ? T : Math.min(_, T), ae.ymax = d ? T : Math.max(_, T), Ae.attr("d", "M" + (L - Am) + "," + ae.ymin + "v-4h" + 2 * Am + "v4ZM" + (L - Am) + "," + (ae.ymax - 1) + "v4h" + 2 * Am + "v-4Z")) : rt === "d" && (ae = d ? pN(h, [
                            L,
                            _
                        ], [
                            P,
                            T
                        ]) : [
                            [
                                L,
                                _
                            ],
                            [
                                L,
                                T
                            ],
                            [
                                P,
                                T
                            ],
                            [
                                P,
                                _
                            ]
                        ], ae.xmin = Math.min(L, P), ae.xmax = Math.max(L, P), ae.ymin = Math.min(_, T), ae.ymax = Math.max(_, T), Ae.attr("d", "M0,0Z"));
                    } else o && (N.addPt([
                        P,
                        T
                    ]), ae = N.filtered);
                    if (n.selectionDefs && n.selectionDefs.length ? (re = ffe(n.mergedPolygons, ae, G), ae.subtract = G, W = TN(n.selectionDefs.concat([
                        ae
                    ]))) : (re = [
                        ae
                    ], W = xN(ae)), afe(dfe(re, l), ge, n), c) {
                        var Ct = mN(v, !1), Yt = Ct.eventData ? Ct.eventData.points.slice() : [];
                        Ct = mN(v, !1, W, Re, n), W = Ct.selectionTesters, ke = Ct.eventData;
                        var xr;
                        N ? xr = N.filtered : xr = gfe(re), AM.throttle(Ce, pP.SELECTDELAY, function() {
                            me = vfe(W, Re);
                            for(var er = me.slice(), Ke = 0; Ke < Yt.length; Ke++){
                                for(var xt = Yt[Ke], bt = !1, Lt = 0; Lt < er.length; Lt++)if (er[Lt].curveNumber === xt.curveNumber && er[Lt].pointNumber === xt.pointNumber) {
                                    bt = !0;
                                    break;
                                }
                                bt || er.push(xt);
                            }
                            er.length && (ke || (ke = {}), ke.points = er), ce(ke, xr), rft(v, ke);
                        });
                    }
                }, n.clickFn = function(Ge, nt) {
                    if (Ae.remove(), v._fullLayout._activeShapeIndex >= 0) {
                        v._fullLayout._deactivateShape(v);
                        return;
                    }
                    if (!u) {
                        var ct = x.clickmode;
                        AM.done(Ce).then(function() {
                            if (AM.clear(Ce), Ge === 2) {
                                for(ge.remove(), _e = 0; _e < Re.length; _e++)Me = Re[_e], Me._module.selectPoints(Me, !1);
                                if (kM(v, Re), EM(n), SN(v), Re.length) {
                                    var qt = Re[0].xaxis, rt = Re[0].yaxis;
                                    if (qt && rt) {
                                        for(var ot = [], Rt = v._fullLayout.selections, kt = 0; kt < Rt.length; kt++){
                                            var Ct = Rt[kt];
                                            Ct && (Ct.xref !== qt._id || Ct.yref !== rt._id) && ot.push(Ct);
                                        }
                                        ot.length < Rt.length && (v._fullLayout._noEmitSelectedAtStart = !0, SM.call("_guiRelayout", v, {
                                            selections: ot
                                        }));
                                    }
                                }
                            } else ct.indexOf("select") > -1 && ufe(nt, v, n.xaxes, n.yaxes, n.subplot, n, ge), ct === "event" && CM(v, void 0);
                            Ect.click(v, nt, k.id);
                        }).catch(vP.error);
                    }
                }, n.doneFn = function() {
                    Ae.remove(), AM.done(Ce).then(function() {
                        AM.clear(Ce), !b && ae && n.selectionDefs && (ae.subtract = G, n.selectionDefs.push(ae), n.mergedPolygons.length = 0, [].push.apply(n.mergedPolygons, re)), (b || u) && EM(n, b), n.doneFnCompleted && n.doneFnCompleted(me), c && CM(v, ke);
                    }).catch(vP.error);
                };
            }
            function ufe(e, t, r, n, i, a, o) {
                var s = t._hoverdata, l = t._fullLayout, u = l.clickmode, c = u.indexOf("event") > -1, f = [], h, d, v, x, b, p, E, k, A, L;
                if (Wct(s)) {
                    cfe(e, t, a), h = gP(t, r, n, i);
                    var _ = Zct(s, h), C = _.pointNumbers.length > 0;
                    if (C ? Xct(h, _) : Yct(h) && (E = ife(_))) {
                        for(o && o.remove(), L = 0; L < h.length; L++)d = h[L], d._module.selectPoints(d, !1);
                        kM(t, h), EM(a), c && SN(t);
                    } else {
                        k = e.shiftKey && (E !== void 0 ? E : ife(_)), v = Vct(_.pointNumber, _.searchInfo, k);
                        var M = a.selectionDefs.concat([
                            v
                        ]);
                        for(x = TN(M, x), L = 0; L < h.length; L++)if (b = h[L]._module.selectPoints(h[L], x), p = hfe(b, h[L]), f.length) for(var g = 0; g < p.length; g++)f.push(p[g]);
                        else f = p;
                        if (A = {
                            points: f
                        }, kM(t, h, A), v && a && a.selectionDefs.push(v), o) {
                            var P = a.mergedPolygons, T = yN(a.dragmode);
                            afe(dfe(P, T), o, a);
                        }
                        c && CM(t, A);
                    }
                }
            }
            function Vct(e, t, r) {
                return {
                    pointNumber: e,
                    searchInfo: t,
                    subtract: !!r
                };
            }
            function gN(e) {
                return "pointNumber" in e && "searchInfo" in e;
            }
            function Hct(e) {
                return {
                    xmin: 0,
                    xmax: 0,
                    ymin: 0,
                    ymax: 0,
                    pts: [],
                    contains: function(t, r, n, i) {
                        var a = e.searchInfo.cd[0].trace.index, o = i.cd[0].trace.index;
                        return o === a && n === e.pointNumber;
                    },
                    isRect: !1,
                    degenerate: !1,
                    subtract: !!e.subtract
                };
            }
            function TN(e) {
                if (!e.length) return;
                for(var t = [], r = gN(e[0]) ? 0 : e[0][0][0], n = r, i = gN(e[0]) ? 0 : e[0][0][1], a = i, o = 0; o < e.length; o++)if (gN(e[o])) t.push(Hct(e[o]));
                else {
                    var s = xN(e[o]);
                    s.subtract = !!e[o].subtract, t.push(s), r = Math.min(r, s.xmin), n = Math.max(n, s.xmax), i = Math.min(i, s.ymin), a = Math.max(a, s.ymax);
                }
                function l(u, c, f, h) {
                    for(var d = !1, v = 0; v < t.length; v++)t[v].contains(u, c, f, h) && (d = !t[v].subtract);
                    return d;
                }
                return {
                    xmin: r,
                    xmax: n,
                    ymin: i,
                    ymax: a,
                    pts: [],
                    contains: l,
                    isRect: !1,
                    degenerate: !1
                };
            }
            function cfe(e, t, r) {
                var n = t._fullLayout, i = r.plotinfo, a = r.dragmode, o = n._lastSelectedSubplot && n._lastSelectedSubplot === i.id, s = (e.shiftKey || e.altKey) && !(MM(a) && yN(a));
                o && s && i.selection && i.selection.selectionDefs && !r.selectionDefs ? (r.selectionDefs = i.selection.selectionDefs, r.mergedPolygons = i.selection.mergedPolygons) : (!s || !i.selection) && EM(r), o || (ofe(t), n._lastSelectedSubplot = i.id);
            }
            function Gct(e) {
                return e._fullLayout._activeShapeIndex >= 0;
            }
            function jct(e) {
                return e._fullLayout._activeSelectionIndex >= 0;
            }
            function EM(e, t) {
                var r = e.dragmode, n = e.plotinfo, i = e.gd;
                Gct(i) && i._fullLayout._deactivateShape(i), jct(i) && i._fullLayout._deactivateSelection(i);
                var a = i._fullLayout, o = a._zoomlayer, s = MM(r), l = _N(r);
                if (s || l) {
                    var u = o.selectAll(".select-outline-" + n.id);
                    if (u && i._fullLayout._outlining) {
                        var c;
                        s && (c = Ict(u, e)), c && SM.call("_guiRelayout", i, {
                            shapes: c
                        });
                        var f;
                        l && !wN(e) && (f = Rct(u, e)), f && (i._fullLayout._noEmitSelectedAtStart = !0, SM.call("_guiRelayout", i, {
                            selections: f
                        }).then(function() {
                            t && Dct(i);
                        })), i._fullLayout._outlining = !1;
                    }
                }
                n.selection = {}, n.selection.selectionDefs = e.selectionDefs = [], n.selection.mergedPolygons = e.mergedPolygons = [];
            }
            function rfe(e) {
                return e._id;
            }
            function gP(e, t, r, n) {
                if (!e.calcdata) return [];
                var i = [], a = t.map(rfe), o = r.map(rfe), s, l, u;
                for(u = 0; u < e.calcdata.length; u++)if (s = e.calcdata[u], l = s[0].trace, !(l.visible !== !0 || !l._module || !l._module.selectPoints)) {
                    if (wN({
                        subplot: n
                    }) && (l.subplot === n || l.geo === n)) i.push(dP(l._module, s, t[0], r[0]));
                    else if (l.type === "splom") {
                        if (l._xaxes[a[0]] && l._yaxes[o[0]]) {
                            var c = dP(l._module, s, t[0], r[0]);
                            c.scene = e._fullLayout._splomScenes[l.uid], i.push(c);
                        }
                    } else if (l.type === "sankey") {
                        var f = dP(l._module, s, t[0], r[0]);
                        i.push(f);
                    } else {
                        if (a.indexOf(l.xaxis) === -1 && (!l._xA || !l._xA.overlaying) || o.indexOf(l.yaxis) === -1 && (!l._yA || !l._yA.overlaying)) continue;
                        i.push(dP(l._module, s, k0(e, l.xaxis), k0(e, l.yaxis)));
                    }
                }
                return i;
            }
            function dP(e, t, r, n) {
                return {
                    _module: e,
                    cd: t,
                    xaxis: r,
                    yaxis: n
                };
            }
            function Wct(e) {
                return e && Array.isArray(e) && e[0].hoverOnBox !== !0;
            }
            function Zct(e, t) {
                var r = e[0], n = -1, i = [], a, o;
                for(o = 0; o < t.length; o++)if (a = t[o], r.fullData.index === a.cd[0].trace.index) {
                    if (r.hoverOnBox === !0) break;
                    r.pointNumber !== void 0 ? n = r.pointNumber : r.binNumber !== void 0 && (n = r.binNumber, i = r.pointNumbers);
                    break;
                }
                return {
                    pointNumber: n,
                    pointNumbers: i,
                    searchInfo: a
                };
            }
            function ife(e) {
                var t = e.searchInfo.cd[0].trace, r = e.pointNumber, n = e.pointNumbers, i = n.length > 0, a = i ? n[0] : r;
                return t.selectedpoints ? t.selectedpoints.indexOf(a) > -1 : !1;
            }
            function Xct(e, t) {
                var r = [], n, i, a, o;
                for(o = 0; o < e.length; o++)n = e[o], n.cd[0].trace.selectedpoints && n.cd[0].trace.selectedpoints.length > 0 && r.push(n);
                if (r.length === 1 && (a = r[0] === t.searchInfo, a && (i = t.searchInfo.cd[0].trace, i.selectedpoints.length === t.pointNumbers.length))) {
                    for(o = 0; o < t.pointNumbers.length; o++)if (i.selectedpoints.indexOf(t.pointNumbers[o]) < 0) return !1;
                    return !0;
                }
                return !1;
            }
            function Yct(e) {
                var t = 0, r, n, i;
                for(i = 0; i < e.length; i++)if (r = e[i], n = r.cd[0].trace, n.selectedpoints && (n.selectedpoints.length > 1 || (t += n.selectedpoints.length, t > 1))) return !1;
                return t === 1;
            }
            function kM(e, t, r) {
                var n;
                for(n = 0; n < t.length; n++){
                    var i = t[n].cd[0].trace._fullInput, a = e._fullLayout._tracePreGUI[i.uid] || {};
                    a.selectedpoints === void 0 && (a.selectedpoints = i._input.selectedpoints || null);
                }
                var o;
                if (r) {
                    var s = r.points || [];
                    for(n = 0; n < t.length; n++)o = t[n].cd[0].trace, o._input.selectedpoints = o._fullInput.selectedpoints = [], o._fullInput !== o && (o.selectedpoints = []);
                    for(var l = 0; l < s.length; l++){
                        var u = s[l], c = u.data, f = u.fullData, h = u.pointIndex, d = u.pointIndices;
                        d ? ([].push.apply(c.selectedpoints, d), o._fullInput !== o && [].push.apply(f.selectedpoints, d)) : (c.selectedpoints.push(h), o._fullInput !== o && f.selectedpoints.push(h));
                    }
                } else for(n = 0; n < t.length; n++)o = t[n].cd[0].trace, delete o.selectedpoints, delete o._input.selectedpoints, o._fullInput !== o && delete o._fullInput.selectedpoints;
                Kct(e, t);
            }
            function Kct(e, t) {
                for(var r = !1, n = 0; n < t.length; n++){
                    var i = t[n], a = i.cd;
                    SM.traceIs(a[0].trace, "regl") && (r = !0);
                    var o = i._module, s = o.styleOnSelect || o.style;
                    s && (s(e, a, a[0].node3), a[0].nodeRangePlot3 && s(e, a, a[0].nodeRangePlot3));
                }
                r && (Fct(e), qct(e));
            }
            function ffe(e, t, r) {
                for(var n = r ? $ce.difference : $ce.union, i = n({
                    regions: e
                }, {
                    regions: [
                        t
                    ]
                }), a = i.regions.reverse(), o = 0; o < a.length; o++){
                    var s = a[o];
                    s.subtract = AN(s, a.slice(0, o));
                }
                return a;
            }
            function hfe(e, t) {
                if (Array.isArray(e)) for(var r = t.cd, n = t.cd[0].trace, i = 0; i < e.length; i++)e[i] = kct(e[i], n, r);
                return e;
            }
            function dfe(e, t) {
                for(var r = [], n = 0; n < e.length; n++){
                    r[n] = [];
                    for(var i = 0; i < e[n].length; i++){
                        r[n][i] = [], r[n][i][0] = i ? "L" : "M";
                        for(var a = 0; a < e[n][i].length; a++)r[n][i].push(e[n][i][a]);
                    }
                    t || r[n].push([
                        "Z",
                        r[n][0][1],
                        r[n][0][2]
                    ]);
                }
                return r;
            }
            function vfe(e, t) {
                for(var r = [], n, i = [], a, o = 0; o < t.length; o++){
                    var s = t[o];
                    a = s._module.selectPoints(s, e), i.push(a), n = hfe(a, s), r = r.concat(n);
                }
                return r;
            }
            function mN(e, t, r, n, i) {
                var a = !!n, o, s, l;
                i && (o = i.plotinfo, s = i.xaxes[0]._id, l = i.yaxes[0]._id);
                var u = [], c = [], f = nfe(e), h = e._fullLayout;
                if (o) {
                    var d = h._zoomlayer, v = h.dragmode, x = MM(v), b = _N(v);
                    if (x || b) {
                        var p = k0(e, s, "x"), E = k0(e, l, "y");
                        if (p && E) {
                            var k = d.selectAll(".select-outline-" + o.id);
                            if (k && e._fullLayout._outlining && k.length) {
                                for(var A = k[0][0], L = A.getAttribute("d"), _ = Pct(L, e, o), C = [], M = 0; M < _.length; M++){
                                    for(var g = _[M], P = [], T = 0; T < g.length; T++)P.push([
                                        d_(p, g[T][1]),
                                        d_(E, g[T][2])
                                    ]);
                                    P.xref = s, P.yref = l, P.subtract = AN(P, C), C.push(P);
                                }
                                f = f.concat(C);
                            }
                        }
                    }
                }
                var F = s && l ? [
                    s + l
                ] : h._subplots.cartesian;
                Jct(e);
                for(var q = {}, V = 0; V < F.length; V++){
                    var H = F[V], X = H.indexOf("y"), G = H.slice(0, X), N = H.slice(X), W = s && l ? r : void 0;
                    if (W = Qct(f, G, N, W), W) {
                        var re = n;
                        if (!a) {
                            var ae = k0(e, G, "x"), _e = k0(e, N, "y");
                            re = gP(e, [
                                ae
                            ], [
                                _e
                            ], H);
                            for(var Me = 0; Me < re.length; Me++){
                                var ke = re[Me], ge = ke.cd[0], ie = ge.trace;
                                if (ke._module.name === "scattergl" && !ge.t.xpx) {
                                    var Te = ie.x, Ee = ie.y, Ae = ie._length;
                                    ge.t.xpx = [], ge.t.ypx = [];
                                    for(var ze = 0; ze < Ae; ze++)ge.t.xpx[ze] = ae.c2p(Te[ze]), ge.t.ypx[ze] = _e.c2p(Ee[ze]);
                                }
                                ke._module.name === "splom" && (q[ie.uid] || (q[ie.uid] = !0));
                            }
                        }
                        var Ce = vfe(W, re);
                        u = u.concat(Ce), c = c.concat(re);
                    }
                }
                var me = {
                    points: u
                };
                kM(e, c, me);
                var Re = h.clickmode, ce = Re.indexOf("event") > -1 && t;
                if (!o && t) {
                    var Ge = nfe(e, !0);
                    if (Ge.length) {
                        var nt = Ge[0].xref, ct = Ge[0].yref;
                        if (nt && ct) {
                            var qt = gfe(Ge), rt = mfe([
                                k0(e, nt, "x"),
                                k0(e, ct, "y")
                            ]);
                            rt(me, qt);
                        }
                    }
                    e._fullLayout._noEmitSelectedAtStart ? e._fullLayout._noEmitSelectedAtStart = !1 : ce && CM(e, me), h._reselect = !1;
                }
                if (!o && h._deselect) {
                    var ot = h._deselect;
                    s = ot.xref, l = ot.yref, $ct(s, l, c) || pfe(e, s, l, n), ce && (me.points.length ? CM(e, me) : SN(e)), h._deselect = !1;
                }
                return {
                    eventData: me,
                    selectionTesters: r
                };
            }
            function Jct(e) {
                var t = e.calcdata;
                if (t) for(var r = 0; r < t.length; r++){
                    var n = t[r][0], i = n.trace, a = e._fullLayout._splomScenes;
                    if (a) {
                        var o = a[i.uid];
                        o && (o.selectBatch = []);
                    }
                }
            }
            function $ct(e, t, r) {
                for(var n = 0; n < r.length; n++){
                    var i = r[n];
                    if (i.xaxis && i.xaxis._id === e && i.yaxis && i.yaxis._id === t) return !0;
                }
                return !1;
            }
            function pfe(e, t, r, n) {
                n = gP(e, [
                    k0(e, t, "x")
                ], [
                    k0(e, r, "y")
                ], t + r);
                for(var i = 0; i < n.length; i++){
                    var a = n[i];
                    a._module.selectPoints(a, !1);
                }
                kM(e, n);
            }
            function Qct(e, t, r, n) {
                for(var i, a = 0; a < e.length; a++){
                    var o = e[a];
                    if (!(t !== o.xref || r !== o.yref)) {
                        if (i) {
                            var s = !!o.subtract;
                            i = ffe(i, o, s), n = TN(i);
                        } else i = [
                            o
                        ], n = xN(o);
                    }
                }
                return n;
            }
            function nfe(e, t) {
                for(var r = [], n = e._fullLayout, i = n.selections, a = i.length, o = 0; o < a; o++)if (!(t && o !== n._activeSelectionIndex)) {
                    var s = i[o];
                    if (s) {
                        var l = s.xref, u = s.yref, c = k0(e, l, "x"), f = k0(e, u, "y"), h, d, v, x, b;
                        if (s.type === "rect") {
                            b = [];
                            var p = d_(c, s.x0), E = d_(c, s.x1), k = d_(f, s.y0), A = d_(f, s.y1);
                            b = [
                                [
                                    p,
                                    k
                                ],
                                [
                                    p,
                                    A
                                ],
                                [
                                    E,
                                    A
                                ],
                                [
                                    E,
                                    k
                                ]
                            ], h = Math.min(p, E), d = Math.max(p, E), v = Math.min(k, A), x = Math.max(k, A), b.xmin = h, b.xmax = d, b.ymin = v, b.ymax = x, b.xref = l, b.yref = u, b.subtract = !1, b.isRect = !0, r.push(b);
                        } else if (s.type === "path") for(var L = s.path.split("Z"), _ = [], C = 0; C < L.length; C++){
                            var M = L[C];
                            if (M) {
                                M += "Z";
                                var g = Qce.extractPathCoords(M, efe.paramIsX, "raw"), P = Qce.extractPathCoords(M, efe.paramIsY, "raw");
                                h = 1 / 0, d = -1 / 0, v = 1 / 0, x = -1 / 0, b = [];
                                for(var T = 0; T < g.length; T++){
                                    var F = d_(c, g[T]), q = d_(f, P[T]);
                                    b.push([
                                        F,
                                        q
                                    ]), h = Math.min(F, h), d = Math.max(F, d), v = Math.min(q, v), x = Math.max(q, x);
                                }
                                b.xmin = h, b.xmax = d, b.ymin = v, b.ymax = x, b.xref = l, b.yref = u, b.subtract = AN(b, _), _.push(b), r.push(b);
                            }
                        }
                    }
                }
                return r;
            }
            function AN(e, t) {
                for(var r = !1, n = 0; n < t.length; n++)for(var i = t[n], a = 0; a < e.length; a++)if (Sct(e[a], i)) {
                    r = !r;
                    break;
                }
                return r;
            }
            function d_(e, t) {
                return e.type === "date" && (t = t.replace("_", " ")), e.type === "log" ? e.c2p(t) : e.r2p(t, null, e.calendar);
            }
            function gfe(e) {
                for(var t = e.length, r = [], n = 0; n < t; n++){
                    var i = e[n];
                    r = r.concat(i), r = r.concat([
                        i[0]
                    ]);
                }
                return eft(r);
            }
            function eft(e) {
                return e.isRect = e.length === 5 && e[0][0] === e[4][0] && e[0][1] === e[4][1] && e[0][0] === e[1][0] && e[2][0] === e[3][0] && e[0][1] === e[3][1] && e[1][1] === e[2][1] || e[0][1] === e[1][1] && e[2][1] === e[3][1] && e[0][0] === e[3][0] && e[1][0] === e[2][0], e.isRect && (e.xmin = Math.min(e[0][0], e[2][0]), e.xmax = Math.max(e[0][0], e[2][0]), e.ymin = Math.min(e[0][1], e[2][1]), e.ymax = Math.max(e[0][1], e[2][1])), e;
            }
            function mfe(e) {
                return function(t, r) {
                    for(var n, i, a = 0; a < e.length; a++){
                        var o = e[a], s = o._id, l = s.charAt(0);
                        if (r.isRect) {
                            n || (n = {});
                            var u = r[l + "min"], c = r[l + "max"];
                            u !== void 0 && c !== void 0 && (n[s] = [
                                tfe(o, u),
                                tfe(o, c)
                            ].sort(zct));
                        } else i || (i = {}), i[s] = r.map(Bct(o));
                    }
                    n && (t.range = n), i && (t.lassoPoints = i);
                };
            }
            function tft(e) {
                var t = e.plotinfo;
                return t.fillRangeItems || mfe(e.xaxes.concat(e.yaxes));
            }
            function rft(e, t) {
                e.emit("plotly_selecting", t);
            }
            function CM(e, t) {
                t && (t.selections = (e.layout || {}).selections || []), e.emit("plotly_selected", t);
            }
            function SN(e) {
                e.emit("plotly_deselect", null);
            }
            yfe.exports = {
                reselect: mN,
                prepSelect: Uct,
                clearOutline: ofe,
                clearSelectionsCache: EM,
                selectOnClick: ufe
            };
        });
        var MN = ye((Oir, xfe)=>{
            "use strict";
            xfe.exports = [
                {
                    path: "",
                    backoff: 0
                },
                {
                    path: "M-2.4,-3V3L0.6,0Z",
                    backoff: .6
                },
                {
                    path: "M-3.7,-2.5V2.5L1.3,0Z",
                    backoff: 1.3
                },
                {
                    path: "M-4.45,-3L-1.65,-0.2V0.2L-4.45,3L1.55,0Z",
                    backoff: 1.55
                },
                {
                    path: "M-2.2,-2.2L-0.2,-0.2V0.2L-2.2,2.2L-1.4,3L1.6,0L-1.4,-3Z",
                    backoff: 1.6
                },
                {
                    path: "M-4.4,-2.1L-0.6,-0.2V0.2L-4.4,2.1L-4,3L2,0L-4,-3Z",
                    backoff: 2
                },
                {
                    path: "M2,0A2,2 0 1,1 0,-2A2,2 0 0,1 2,0Z",
                    backoff: 0,
                    noRotate: !0
                },
                {
                    path: "M2,2V-2H-2V2Z",
                    backoff: 0,
                    noRotate: !0
                }
            ];
        });
        var PM = ye((Bir, bfe)=>{
            "use strict";
            bfe.exports = {
                axisRefDescription: function(e, t, r) {
                    return [
                        "If set to a",
                        e,
                        "axis id (e.g. *" + e + "* or",
                        "*" + e + "2*), the `" + e + "` position refers to a",
                        e,
                        "coordinate. If set to *paper*, the `" + e + "`",
                        "position refers to the distance from the",
                        t,
                        "of the plotting",
                        "area in normalized coordinates where *0* (*1*) corresponds to the",
                        t,
                        "(" + r + "). If set to a",
                        e,
                        "axis ID followed by",
                        "*domain* (separated by a space), the position behaves like for",
                        "*paper*, but refers to the distance in fractions of the domain",
                        "length from the",
                        t,
                        "of the domain of that axis: e.g.,",
                        "*" + e + "2 domain* refers to the domain of the second",
                        e,
                        " axis and a",
                        e,
                        "position of 0.5 refers to the",
                        "point between the",
                        t,
                        "and the",
                        r,
                        "of the domain of the",
                        "second",
                        e,
                        "axis."
                    ].join(" ");
                }
            };
        });
        var Nb = ye((Uir, Afe)=>{
            "use strict";
            var wfe = MN(), Tfe = Su(), mP = ad(), ift = Vs().templatedArray, Nir = PM();
            Afe.exports = ift("annotation", {
                visible: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc+arraydraw"
                },
                text: {
                    valType: "string",
                    editType: "calc+arraydraw"
                },
                textangle: {
                    valType: "angle",
                    dflt: 0,
                    editType: "calc+arraydraw"
                },
                font: Tfe({
                    editType: "calc+arraydraw",
                    colorEditType: "arraydraw"
                }),
                width: {
                    valType: "number",
                    min: 1,
                    dflt: null,
                    editType: "calc+arraydraw"
                },
                height: {
                    valType: "number",
                    min: 1,
                    dflt: null,
                    editType: "calc+arraydraw"
                },
                opacity: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 1,
                    editType: "arraydraw"
                },
                align: {
                    valType: "enumerated",
                    values: [
                        "left",
                        "center",
                        "right"
                    ],
                    dflt: "center",
                    editType: "arraydraw"
                },
                valign: {
                    valType: "enumerated",
                    values: [
                        "top",
                        "middle",
                        "bottom"
                    ],
                    dflt: "middle",
                    editType: "arraydraw"
                },
                bgcolor: {
                    valType: "color",
                    dflt: "rgba(0,0,0,0)",
                    editType: "arraydraw"
                },
                bordercolor: {
                    valType: "color",
                    dflt: "rgba(0,0,0,0)",
                    editType: "arraydraw"
                },
                borderpad: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "calc+arraydraw"
                },
                borderwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "calc+arraydraw"
                },
                showarrow: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc+arraydraw"
                },
                arrowcolor: {
                    valType: "color",
                    editType: "arraydraw"
                },
                arrowhead: {
                    valType: "integer",
                    min: 0,
                    max: wfe.length,
                    dflt: 1,
                    editType: "arraydraw"
                },
                startarrowhead: {
                    valType: "integer",
                    min: 0,
                    max: wfe.length,
                    dflt: 1,
                    editType: "arraydraw"
                },
                arrowside: {
                    valType: "flaglist",
                    flags: [
                        "end",
                        "start"
                    ],
                    extras: [
                        "none"
                    ],
                    dflt: "end",
                    editType: "arraydraw"
                },
                arrowsize: {
                    valType: "number",
                    min: .3,
                    dflt: 1,
                    editType: "calc+arraydraw"
                },
                startarrowsize: {
                    valType: "number",
                    min: .3,
                    dflt: 1,
                    editType: "calc+arraydraw"
                },
                arrowwidth: {
                    valType: "number",
                    min: .1,
                    editType: "calc+arraydraw"
                },
                standoff: {
                    valType: "number",
                    min: 0,
                    dflt: 0,
                    editType: "calc+arraydraw"
                },
                startstandoff: {
                    valType: "number",
                    min: 0,
                    dflt: 0,
                    editType: "calc+arraydraw"
                },
                ax: {
                    valType: "any",
                    editType: "calc+arraydraw"
                },
                ay: {
                    valType: "any",
                    editType: "calc+arraydraw"
                },
                axref: {
                    valType: "enumerated",
                    dflt: "pixel",
                    values: [
                        "pixel",
                        mP.idRegex.x.toString()
                    ],
                    editType: "calc"
                },
                ayref: {
                    valType: "enumerated",
                    dflt: "pixel",
                    values: [
                        "pixel",
                        mP.idRegex.y.toString()
                    ],
                    editType: "calc"
                },
                xref: {
                    valType: "enumerated",
                    values: [
                        "paper",
                        mP.idRegex.x.toString()
                    ],
                    editType: "calc"
                },
                x: {
                    valType: "any",
                    editType: "calc+arraydraw"
                },
                xanchor: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "left",
                        "center",
                        "right"
                    ],
                    dflt: "auto",
                    editType: "calc+arraydraw"
                },
                xshift: {
                    valType: "number",
                    dflt: 0,
                    editType: "calc+arraydraw"
                },
                yref: {
                    valType: "enumerated",
                    values: [
                        "paper",
                        mP.idRegex.y.toString()
                    ],
                    editType: "calc"
                },
                y: {
                    valType: "any",
                    editType: "calc+arraydraw"
                },
                yanchor: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "top",
                        "middle",
                        "bottom"
                    ],
                    dflt: "auto",
                    editType: "calc+arraydraw"
                },
                yshift: {
                    valType: "number",
                    dflt: 0,
                    editType: "calc+arraydraw"
                },
                clicktoshow: {
                    valType: "enumerated",
                    values: [
                        !1,
                        "onoff",
                        "onout"
                    ],
                    dflt: !1,
                    editType: "arraydraw"
                },
                xclick: {
                    valType: "any",
                    editType: "arraydraw"
                },
                yclick: {
                    valType: "any",
                    editType: "arraydraw"
                },
                hovertext: {
                    valType: "string",
                    editType: "arraydraw"
                },
                hoverlabel: {
                    bgcolor: {
                        valType: "color",
                        editType: "arraydraw"
                    },
                    bordercolor: {
                        valType: "color",
                        editType: "arraydraw"
                    },
                    font: Tfe({
                        editType: "arraydraw"
                    }),
                    editType: "arraydraw"
                },
                captureevents: {
                    valType: "boolean",
                    editType: "arraydraw"
                },
                editType: "calc"
            });
        });
        var Sm = ye((Vir, Sfe)=>{
            "use strict";
            Sfe.exports = {
                PTS_LINESONLY: 20,
                minTolerance: .2,
                toleranceGrowth: 10,
                maxScreensAway: 20,
                eventDataKeys: []
            };
        });
        var Eg = ye((Hir, Mfe)=>{
            "use strict";
            Mfe.exports = function(t) {
                return {
                    valType: "color",
                    editType: "style",
                    anim: !0
                };
            };
        });
        var Uc = ye((Gir, Ife)=>{
            "use strict";
            var Efe = Oc().axisHoverFormat, nft = Wo().texttemplateAttrs, aft = Wo().hovertemplateAttrs, kfe = Jl(), oft = Su(), sft = Ed().dash, lft = Ed().pattern, uft = ao(), cft = Sm(), yP = no().extendFlat, fft = Eg();
            function Cfe(e) {
                return {
                    valType: "any",
                    dflt: 0,
                    editType: "calc"
                };
            }
            function Lfe(e) {
                return {
                    valType: "any",
                    editType: "calc"
                };
            }
            function Pfe(e) {
                return {
                    valType: "enumerated",
                    values: [
                        "start",
                        "middle",
                        "end"
                    ],
                    dflt: "middle",
                    editType: "calc"
                };
            }
            Ife.exports = {
                x: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes",
                    anim: !0
                },
                x0: {
                    valType: "any",
                    dflt: 0,
                    editType: "calc+clearAxisTypes",
                    anim: !0
                },
                dx: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc",
                    anim: !0
                },
                y: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes",
                    anim: !0
                },
                y0: {
                    valType: "any",
                    dflt: 0,
                    editType: "calc+clearAxisTypes",
                    anim: !0
                },
                dy: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc",
                    anim: !0
                },
                xperiod: Cfe("x"),
                yperiod: Cfe("y"),
                xperiod0: Lfe("x0"),
                yperiod0: Lfe("y0"),
                xperiodalignment: Pfe("x"),
                yperiodalignment: Pfe("y"),
                xhoverformat: Efe("x"),
                yhoverformat: Efe("y"),
                offsetgroup: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                alignmentgroup: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                stackgroup: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                orientation: {
                    valType: "enumerated",
                    values: [
                        "v",
                        "h"
                    ],
                    editType: "calc"
                },
                groupnorm: {
                    valType: "enumerated",
                    values: [
                        "",
                        "fraction",
                        "percent"
                    ],
                    dflt: "",
                    editType: "calc"
                },
                stackgaps: {
                    valType: "enumerated",
                    values: [
                        "infer zero",
                        "interpolate"
                    ],
                    dflt: "infer zero",
                    editType: "calc"
                },
                text: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0,
                    editType: "calc"
                },
                texttemplate: nft({}, {}),
                hovertext: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0,
                    editType: "style"
                },
                mode: {
                    valType: "flaglist",
                    flags: [
                        "lines",
                        "markers",
                        "text"
                    ],
                    extras: [
                        "none"
                    ],
                    editType: "calc"
                },
                hoveron: {
                    valType: "flaglist",
                    flags: [
                        "points",
                        "fills"
                    ],
                    editType: "style"
                },
                hovertemplate: aft({}, {
                    keys: cft.eventDataKeys
                }),
                line: {
                    color: {
                        valType: "color",
                        editType: "style",
                        anim: !0
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        dflt: 2,
                        editType: "style",
                        anim: !0
                    },
                    shape: {
                        valType: "enumerated",
                        values: [
                            "linear",
                            "spline",
                            "hv",
                            "vh",
                            "hvh",
                            "vhv"
                        ],
                        dflt: "linear",
                        editType: "plot"
                    },
                    smoothing: {
                        valType: "number",
                        min: 0,
                        max: 1.3,
                        dflt: 1,
                        editType: "plot"
                    },
                    dash: yP({}, sft, {
                        editType: "style"
                    }),
                    backoff: {
                        valType: "number",
                        min: 0,
                        dflt: "auto",
                        arrayOk: !0,
                        editType: "plot"
                    },
                    simplify: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    editType: "plot"
                },
                connectgaps: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "calc"
                },
                cliponaxis: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "plot"
                },
                fill: {
                    valType: "enumerated",
                    values: [
                        "none",
                        "tozeroy",
                        "tozerox",
                        "tonexty",
                        "tonextx",
                        "toself",
                        "tonext"
                    ],
                    editType: "calc"
                },
                fillcolor: fft(!0),
                fillgradient: yP({
                    type: {
                        valType: "enumerated",
                        values: [
                            "radial",
                            "horizontal",
                            "vertical",
                            "none"
                        ],
                        dflt: "none",
                        editType: "calc"
                    },
                    start: {
                        valType: "number",
                        editType: "calc"
                    },
                    stop: {
                        valType: "number",
                        editType: "calc"
                    },
                    colorscale: {
                        valType: "colorscale",
                        editType: "style"
                    },
                    editType: "calc"
                }),
                fillpattern: lft,
                marker: yP({
                    symbol: {
                        valType: "enumerated",
                        values: uft.symbolList,
                        dflt: "circle",
                        arrayOk: !0,
                        editType: "style"
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        arrayOk: !0,
                        editType: "style",
                        anim: !0
                    },
                    angle: {
                        valType: "angle",
                        dflt: 0,
                        arrayOk: !0,
                        editType: "plot",
                        anim: !1
                    },
                    angleref: {
                        valType: "enumerated",
                        values: [
                            "previous",
                            "up"
                        ],
                        dflt: "up",
                        editType: "plot",
                        anim: !1
                    },
                    standoff: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        arrayOk: !0,
                        editType: "plot",
                        anim: !0
                    },
                    size: {
                        valType: "number",
                        min: 0,
                        dflt: 6,
                        arrayOk: !0,
                        editType: "calc",
                        anim: !0
                    },
                    maxdisplayed: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "plot"
                    },
                    sizeref: {
                        valType: "number",
                        dflt: 1,
                        editType: "calc"
                    },
                    sizemin: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "calc"
                    },
                    sizemode: {
                        valType: "enumerated",
                        values: [
                            "diameter",
                            "area"
                        ],
                        dflt: "diameter",
                        editType: "calc"
                    },
                    line: yP({
                        width: {
                            valType: "number",
                            min: 0,
                            arrayOk: !0,
                            editType: "style",
                            anim: !0
                        },
                        editType: "calc"
                    }, kfe("marker.line", {
                        anim: !0
                    })),
                    gradient: {
                        type: {
                            valType: "enumerated",
                            values: [
                                "radial",
                                "horizontal",
                                "vertical",
                                "none"
                            ],
                            arrayOk: !0,
                            dflt: "none",
                            editType: "calc"
                        },
                        color: {
                            valType: "color",
                            arrayOk: !0,
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    editType: "calc"
                }, kfe("marker", {
                    anim: !0
                })),
                selected: {
                    marker: {
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            editType: "style"
                        },
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        size: {
                            valType: "number",
                            min: 0,
                            editType: "style"
                        },
                        editType: "style"
                    },
                    textfont: {
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        editType: "style"
                    },
                    editType: "style"
                },
                unselected: {
                    marker: {
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            editType: "style"
                        },
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        size: {
                            valType: "number",
                            min: 0,
                            editType: "style"
                        },
                        editType: "style"
                    },
                    textfont: {
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        editType: "style"
                    },
                    editType: "style"
                },
                textposition: {
                    valType: "enumerated",
                    values: [
                        "top left",
                        "top center",
                        "top right",
                        "middle left",
                        "middle center",
                        "middle right",
                        "bottom left",
                        "bottom center",
                        "bottom right"
                    ],
                    dflt: "middle center",
                    arrayOk: !0,
                    editType: "calc"
                },
                textfont: oft({
                    editType: "calc",
                    colorEditType: "style",
                    arrayOk: !0
                }),
                zorder: {
                    valType: "integer",
                    dflt: 0,
                    editType: "plot"
                }
            };
        });
        var EN = ye((Wir, zfe)=>{
            "use strict";
            var Rfe = Nb(), Dfe = Uc().line, hft = Ed().dash, _P = no().extendFlat, dft = Bu().overrideAll, vft = Vs().templatedArray, jir = PM();
            zfe.exports = dft(vft("selection", {
                type: {
                    valType: "enumerated",
                    values: [
                        "rect",
                        "path"
                    ]
                },
                xref: _P({}, Rfe.xref, {}),
                yref: _P({}, Rfe.yref, {}),
                x0: {
                    valType: "any"
                },
                x1: {
                    valType: "any"
                },
                y0: {
                    valType: "any"
                },
                y1: {
                    valType: "any"
                },
                path: {
                    valType: "string",
                    editType: "arraydraw"
                },
                opacity: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: .7,
                    editType: "arraydraw"
                },
                line: {
                    color: Dfe.color,
                    width: _P({}, Dfe.width, {
                        min: 1,
                        dflt: 1
                    }),
                    dash: _P({}, hft, {
                        dflt: "dot"
                    })
                }
            }), "arraydraw", "from-root");
        });
        var Bfe = ye((Zir, Ofe)=>{
            "use strict";
            var Ffe = Mr(), xP = Qa(), pft = Zd(), gft = EN(), qfe = h_();
            Ofe.exports = function(t, r) {
                pft(t, r, {
                    name: "selections",
                    handleItemDefaults: mft
                });
                for(var n = r.selections, i = 0; i < n.length; i++){
                    var a = n[i];
                    a && a.path === void 0 && (a.x0 === void 0 || a.x1 === void 0 || a.y0 === void 0 || a.y1 === void 0) && (r.selections[i] = null);
                }
            };
            function mft(e, t, r) {
                function n(_, C) {
                    return Ffe.coerce(e, t, gft, _, C);
                }
                var i = n("path"), a = i ? "path" : "rect", o = n("type", a), s = o !== "path";
                s && delete t.path, n("opacity"), n("line.color"), n("line.width"), n("line.dash");
                for(var l = [
                    "x",
                    "y"
                ], u = 0; u < 2; u++){
                    var c = l[u], f = {
                        _fullLayout: r
                    }, h, d, v, x = xP.coerceRef(e, t, f, c);
                    if (h = xP.getFromId(f, x), h._selectionIndices.push(t._index), v = qfe.rangeToShapePosition(h), d = qfe.shapePositionToRange(h), s) {
                        var b = c + "0", p = c + "1", E = e[b], k = e[p];
                        e[b] = d(e[b], !0), e[p] = d(e[p], !0), xP.coercePosition(t, f, n, x, b), xP.coercePosition(t, f, n, x, p);
                        var A = t[b], L = t[p];
                        A !== void 0 && L !== void 0 && (t[b] = v(A), t[p] = v(L), e[b] = E, e[p] = k);
                    }
                }
                s && Ffe.noneOrAll(e, t, [
                    "x0",
                    "x1",
                    "y0",
                    "y1"
                ]);
            }
        });
        var Ufe = ye((Xir, Nfe)=>{
            "use strict";
            Nfe.exports = function(t, r, n) {
                n("newselection.mode");
                var i = n("newselection.line.width");
                i && (n("newselection.line.color"), n("newselection.line.dash")), n("activeselection.fillcolor"), n("activeselection.opacity");
            };
        });
        var IM = ye((Yir, Gfe)=>{
            "use strict";
            var yft = ba(), Vfe = Mr(), Hfe = af();
            Gfe.exports = function(t) {
                return function(n, i) {
                    var a = n[t];
                    if (Array.isArray(a)) for(var o = yft.subplotsRegistry.cartesian, s = o.idRegex, l = i._subplots, u = l.xaxis, c = l.yaxis, f = l.cartesian, h = i._has("cartesian"), d = 0; d < a.length; d++){
                        var v = a[d];
                        if (Vfe.isPlainObject(v)) {
                            var x = Hfe.cleanId(v.xref, "x", !1), b = Hfe.cleanId(v.yref, "y", !1), p = s.x.test(x), E = s.y.test(b);
                            if (p || E) {
                                h || Vfe.pushUnique(i._basePlotModules, o);
                                var k = !1;
                                p && u.indexOf(x) === -1 && (u.push(x), k = !0), E && c.indexOf(b) === -1 && (c.push(b), k = !0), k && p && E && f.push(x + b);
                            }
                        }
                    }
                };
            };
        });
        var wf = ye((Kir, Wfe)=>{
            "use strict";
            var jfe = dN(), RM = _fe();
            Wfe.exports = {
                moduleType: "component",
                name: "selections",
                layoutAttributes: EN(),
                supplyLayoutDefaults: Bfe(),
                supplyDrawNewSelectionDefaults: Ufe(),
                includeBasePlot: IM()("selections"),
                draw: jfe.draw,
                drawOne: jfe.drawOne,
                reselect: RM.reselect,
                prepSelect: RM.prepSelect,
                clearOutline: RM.clearOutline,
                clearSelectionsCache: RM.clearSelectionsCache,
                selectOnClick: RM.selectOnClick
            };
        });
        var DN = ye((Jir, hhe)=>{
            "use strict";
            var IN = xa(), C0 = Mr(), Zfe = C0.numberFormat, _ft = id(), xft = kL(), bP = ba(), rhe = C0.strTranslate, bft = Pl(), Xfe = va(), v_ = ao(), wft = Nc(), Yfe = Qa(), Tft = Tg(), Aft = gv(), ihe = Sg(), wP = ihe.selectingOrDrawing, Sft = ihe.freeMode, Mft = Nh().FROM_TL, Eft = lM(), kft = gM().redrawReglTraces, Cft = Xu(), CN = af().getFromId, Lft = wf().prepSelect, Pft = wf().clearOutline, Ift = wf().selectOnClick, kN = aN(), RN = ad(), Kfe = RN.MINDRAG, np = RN.MINZOOM, Jfe = !0;
            function Rft(e, t, r, n, i, a, o, s) {
                var l = e._fullLayout._zoomlayer, u = o + s === "nsew", c = (o + s).length === 1, f, h, d, v, x, b, p, E, k, A, L, _, C, M, g, P, T, F, q, V, H, X, G;
                r += t.yaxis._shift;
                function N() {
                    if (f = t.xaxis, h = t.yaxis, k = f._length, A = h._length, p = f._offset, E = h._offset, d = {}, d[f._id] = f, v = {}, v[h._id] = h, o && s) for(var Et = t.overlays, dt = 0; dt < Et.length; dt++){
                        var Ht = Et[dt].xaxis;
                        d[Ht._id] = Ht;
                        var $t = Et[dt].yaxis;
                        v[$t._id] = $t;
                    }
                    x = the(d), b = the(v), C = $fe(x, s), M = $fe(b, o), g = !M && !C, _ = ehe(e, e._fullLayout._axisMatchGroups, d, v), L = ehe(e, e._fullLayout._axisConstraintGroups, d, v, _);
                    var fr = L.isSubplotConstrained || _.isSubplotConstrained;
                    P = s || fr, T = o || fr;
                    var _r = e._fullLayout;
                    F = _r._has("scattergl"), q = _r._has("splom"), V = _r._has("svg");
                }
                N();
                var W = Fft(M + C, e._fullLayout.dragmode, u), re = ahe(t, o + s + "drag", W, r, n, i, a);
                if (g && !u) return re.onmousedown = null, re.style.pointerEvents = "none", re;
                var ae = {
                    element: re,
                    gd: e,
                    plotinfo: t
                };
                ae.prepFn = function(Et, dt, Ht) {
                    var $t = ae.dragmode, fr = e._fullLayout.dragmode;
                    fr !== $t && (ae.dragmode = fr), N(), X = e._fullLayout._invScaleX, G = e._fullLayout._invScaleY, g || (u ? Et.shiftKey ? fr === "pan" ? fr = "zoom" : wP(fr) || (fr = "pan") : Et.ctrlKey && (fr = "pan") : fr = "pan"), Sft(fr) ? ae.minDrag = 1 : ae.minDrag = void 0, wP(fr) ? (ae.xaxes = x, ae.yaxes = b, Lft(Et, dt, Ht, ae, fr)) : (ae.clickFn = Me, wP($t) && _e(), g || (fr === "zoom" ? (ae.moveFn = Ge, ae.doneFn = ct, ae.minDrag = 1, ce(Et, dt, Ht)) : fr === "pan" && (ae.moveFn = Ct, ae.doneFn = Ke))), e._fullLayout._redrag = function() {
                        var _r = e._dragdata;
                        if (_r && _r.element === re) {
                            var Br = e._fullLayout.dragmode;
                            wP(Br) || (N(), xt([
                                0,
                                0,
                                k,
                                A
                            ]), ae.moveFn(_r.dx, _r.dy));
                        }
                    };
                };
                function _e() {
                    ae.plotinfo.selection = !1, Pft(e);
                }
                function Me(Et, dt) {
                    var Ht = ae.gd;
                    if (Ht._fullLayout._activeShapeIndex >= 0) {
                        Ht._fullLayout._deactivateShape(Ht);
                        return;
                    }
                    var $t = Ht._fullLayout.clickmode;
                    if (PN(Ht), Et === 2 && !c && er(), u) $t.indexOf("select") > -1 && Ift(dt, Ht, x, b, t.id, ae), $t.indexOf("event") > -1 && wft.click(Ht, dt, t.id);
                    else if (Et === 1 && c) {
                        var fr = o ? h : f, _r = o === "s" || s === "w" ? 0 : 1, Br = fr._name + ".range[" + _r + "]", Or = Dft(fr, _r), Nr = "left", ut = "middle";
                        if (fr.fixedrange) return;
                        o ? (ut = o === "n" ? "top" : "bottom", fr.side === "right" && (Nr = "right")) : s === "e" && (Nr = "right"), Ht._context.showAxisRangeEntryBoxes && IN.select(re).call(bft.makeEditable, {
                            gd: Ht,
                            immediate: !0,
                            background: Ht._fullLayout.paper_bgcolor,
                            text: String(Or),
                            fill: fr.tickfont ? fr.tickfont.color : "#444",
                            horizontalAlign: Nr,
                            verticalAlign: ut
                        }).on("edit", function(Ne) {
                            var Ye = fr.d2r(Ne);
                            Ye !== void 0 && bP.call("_guiRelayout", Ht, Br, Ye);
                        });
                    }
                }
                Aft.init(ae);
                var ke, ge, ie, Te, Ee, Ae, ze, Ce, me, Re;
                function ce(Et, dt, Ht) {
                    var $t = re.getBoundingClientRect();
                    ke = dt - $t.left, ge = Ht - $t.top, e._fullLayout._calcInverseTransform(e);
                    var fr = C0.apply3DTransform(e._fullLayout._invTransform)(ke, ge);
                    ke = fr[0], ge = fr[1], ie = {
                        l: ke,
                        r: ke,
                        w: 0,
                        t: ge,
                        b: ge,
                        h: 0
                    }, Te = e._hmpixcount ? e._hmlumcount / e._hmpixcount : _ft(e._fullLayout.plot_bgcolor).getLuminance(), Ee = "M0,0H" + k + "V" + A + "H0V0", Ae = !1, ze = "xy", Re = !1, Ce = ohe(l, Te, p, E, Ee), me = she(l, p, E);
                }
                function Ge(Et, dt) {
                    if (e._transitioningWithDuration) return !1;
                    var Ht = Math.max(0, Math.min(k, X * Et + ke)), $t = Math.max(0, Math.min(A, G * dt + ge)), fr = Math.abs(Ht - ke), _r = Math.abs($t - ge);
                    ie.l = Math.min(ke, Ht), ie.r = Math.max(ke, Ht), ie.t = Math.min(ge, $t), ie.b = Math.max(ge, $t);
                    function Br() {
                        ze = "", ie.r = ie.l, ie.t = ie.b, me.attr("d", "M0,0Z");
                    }
                    if (L.isSubplotConstrained) fr > np || _r > np ? (ze = "xy", fr / k > _r / A ? (_r = fr * A / k, ge > $t ? ie.t = ge - _r : ie.b = ge + _r) : (fr = _r * k / A, ke > Ht ? ie.l = ke - fr : ie.r = ke + fr), me.attr("d", TP(ie))) : Br();
                    else if (_.isSubplotConstrained) {
                        if (fr > np || _r > np) {
                            ze = "xy";
                            var Or = Math.min(ie.l / k, (A - ie.b) / A), Nr = Math.max(ie.r / k, (A - ie.t) / A);
                            ie.l = Or * k, ie.r = Nr * k, ie.b = (1 - Or) * A, ie.t = (1 - Nr) * A, me.attr("d", TP(ie));
                        } else Br();
                    } else !M || _r < Math.min(Math.max(fr * .6, Kfe), np) ? fr < Kfe || !C ? Br() : (ie.t = 0, ie.b = A, ze = "x", me.attr("d", qft(ie, ge))) : !C || fr < Math.min(_r * .6, np) ? (ie.l = 0, ie.r = k, ze = "y", me.attr("d", Oft(ie, ke))) : (ze = "xy", me.attr("d", TP(ie)));
                    ie.w = ie.r - ie.l, ie.h = ie.b - ie.t, ze && (Re = !0), e._dragged = Re, lhe(Ce, me, ie, Ee, Ae, Te), nt(), e.emit("plotly_relayouting", H), Ae = !0;
                }
                function nt() {
                    H = {}, (ze === "xy" || ze === "x") && (LN(x, ie.l / k, ie.r / k, H, L.xaxes), Yt("x", H)), (ze === "xy" || ze === "y") && (LN(b, (A - ie.b) / A, (A - ie.t) / A, H, L.yaxes), Yt("y", H));
                }
                function ct() {
                    nt(), PN(e), Ke(), che(e);
                }
                var qt = [
                    0,
                    0,
                    k,
                    A
                ], rt = null, ot = RN.REDRAWDELAY, Rt = t.mainplot ? e._fullLayout._plots[t.mainplot] : t;
                function kt(Et) {
                    if (!e._context._scrollZoom.cartesian && !e._fullLayout._enablescrollzoom) return;
                    if (_e(), e._transitioningWithDuration) {
                        Et.preventDefault(), Et.stopPropagation();
                        return;
                    }
                    N(), clearTimeout(rt);
                    var dt = -Et.deltaY;
                    if (isFinite(dt) || (dt = Et.wheelDelta / 10), !isFinite(dt)) {
                        C0.log("Did not find wheel motion attributes: ", Et);
                        return;
                    }
                    var Ht = Math.exp(-Math.min(Math.max(dt, -20), 20) / 200), $t = Rt.draglayer.select(".nsewdrag").node().getBoundingClientRect(), fr = (Et.clientX - $t.left) / $t.width, _r = ($t.bottom - Et.clientY) / $t.height, Br;
                    function Or(Nr, ut, Ne) {
                        if (Nr.fixedrange) return;
                        var Ye = C0.simpleMap(Nr.range, Nr.r2l), Ve = Ye[0] + (Ye[1] - Ye[0]) * ut;
                        function Xe(ht) {
                            return Nr.l2r(Ve + (ht - Ve) * Ne);
                        }
                        Nr.range = Ye.map(Xe);
                    }
                    if (P) {
                        for(s || (fr = .5), Br = 0; Br < x.length; Br++)Or(x[Br], fr, Ht);
                        Yt("x"), qt[2] *= Ht, qt[0] += qt[2] * fr * (1 / Ht - 1);
                    }
                    if (T) {
                        for(o || (_r = .5), Br = 0; Br < b.length; Br++)Or(b[Br], _r, Ht);
                        Yt("y"), qt[3] *= Ht, qt[1] += qt[3] * (1 - _r) * (1 / Ht - 1);
                    }
                    xt(qt), xr(), e.emit("plotly_relayouting", H), rt = setTimeout(function() {
                        e._fullLayout && (qt = [
                            0,
                            0,
                            k,
                            A
                        ], Ke());
                    }, ot), Et.preventDefault();
                }
                o.length * s.length !== 1 && fhe(re, kt);
                function Ct(Et, dt) {
                    if (Et = Et * X, dt = dt * G, e._transitioningWithDuration) return;
                    if (e._fullLayout._replotting = !0, C === "ew" || M === "ns") {
                        var Ht = C ? -Et : 0, $t = M ? -dt : 0;
                        if (_.isSubplotConstrained) {
                            if (C && M) {
                                var fr = (Et / k - dt / A) / 2;
                                Et = fr * k, dt = -fr * A, Ht = -Et, $t = -dt;
                            }
                            M ? Ht = -$t * k / A : $t = -Ht * A / k;
                        }
                        C && (Qfe(x, Et), Yt("x")), M && (Qfe(b, dt), Yt("y")), xt([
                            Ht,
                            $t,
                            k,
                            A
                        ]), xr(), e.emit("plotly_relayouting", H);
                        return;
                    }
                    function _r(Xe, ht, Le) {
                        for(var xe = 1 - ht, Se, lt, Gt = 0; Gt < Xe.length; Gt++){
                            var Vt = Xe[Gt];
                            if (!Vt.fixedrange) {
                                Se = Vt, lt = Vt._rl[xe] + (Vt._rl[ht] - Vt._rl[xe]) / zft(Le / Vt._length);
                                var ar = Vt.l2r(lt);
                                ar !== !1 && ar !== void 0 && (Vt.range[ht] = ar);
                            }
                        }
                        return Se._length * (Se._rl[ht] - lt) / (Se._rl[ht] - Se._rl[xe]);
                    }
                    var Br = C === "w" == (M === "n") ? 1 : -1;
                    if (C && M && (L.isSubplotConstrained || _.isSubplotConstrained)) {
                        var Or = (Et / k + Br * dt / A) / 2;
                        Et = Or * k, dt = Br * Or * A;
                    }
                    var Nr, ut;
                    if (C === "w" ? Et = _r(x, 0, Et) : C === "e" ? Et = _r(x, 1, -Et) : C || (Et = 0), M === "n" ? dt = _r(b, 1, dt) : M === "s" ? dt = _r(b, 0, -dt) : M || (dt = 0), Nr = C === "w" ? Et : 0, ut = M === "n" ? dt : 0, L.isSubplotConstrained && !_.isSubplotConstrained || _.isSubplotConstrained && C && M && Br > 0) {
                        var Ne;
                        if (_.isSubplotConstrained || !C && M.length === 1) {
                            for(Ne = 0; Ne < x.length; Ne++)x[Ne].range = x[Ne]._r.slice(), kN(x[Ne], 1 - dt / A);
                            Et = dt * k / A, Nr = Et / 2;
                        }
                        if (_.isSubplotConstrained || !M && C.length === 1) {
                            for(Ne = 0; Ne < b.length; Ne++)b[Ne].range = b[Ne]._r.slice(), kN(b[Ne], 1 - Et / k);
                            dt = Et * A / k, ut = dt / 2;
                        }
                    }
                    (!_.isSubplotConstrained || !M) && Yt("x"), (!_.isSubplotConstrained || !C) && Yt("y");
                    var Ye = k - Et, Ve = A - dt;
                    _.isSubplotConstrained && !(C && M) && (C ? (ut = Nr ? 0 : Et * A / k, Ve = Ye * A / k) : (Nr = ut ? 0 : dt * k / A, Ye = Ve * k / A)), xt([
                        Nr,
                        ut,
                        Ye,
                        Ve
                    ]), xr(), e.emit("plotly_relayouting", H);
                }
                function Yt(Et, dt) {
                    for(var Ht = _.isSubplotConstrained ? ({
                        x: b,
                        y: x
                    })[Et] : _[Et + "axes"], $t = _.isSubplotConstrained ? ({
                        x: x,
                        y: b
                    })[Et] : [], fr = 0; fr < Ht.length; fr++){
                        var _r = Ht[fr], Br = _r._id, Or = _.xLinks[Br] || _.yLinks[Br], Nr = $t[0] || d[Or] || v[Or];
                        Nr && (dt ? (dt[_r._name + ".range[0]"] = dt[Nr._name + ".range[0]"], dt[_r._name + ".range[1]"] = dt[Nr._name + ".range[1]"]) : _r.range = Nr.range.slice());
                    }
                }
                function xr() {
                    var Et = [], dt;
                    function Ht(Br) {
                        for(dt = 0; dt < Br.length; dt++)Br[dt].fixedrange || Et.push(Br[dt]._id);
                    }
                    function $t(Br, Or) {
                        for(dt = 0; dt < Br.length; dt++){
                            var Nr = Br[dt], ut = Nr[Or];
                            !Nr.fixedrange && ut.tickmode === "sync" && Et.push(ut._id);
                        }
                    }
                    for(P && (Ht(x), Ht(L.xaxes), Ht(_.xaxes), $t(t.overlays, "xaxis")), T && (Ht(b), Ht(L.yaxes), Ht(_.yaxes), $t(t.overlays, "yaxis")), H = {}, dt = 0; dt < Et.length; dt++){
                        var fr = Et[dt], _r = CN(e, fr);
                        Yfe.drawOne(e, _r, {
                            skipTitle: !0
                        }), H[_r._name + ".range[0]"] = _r.range[0], H[_r._name + ".range[1]"] = _r.range[1];
                    }
                    Yfe.redrawComponents(e, Et);
                }
                function er() {
                    if (!e._transitioningWithDuration) {
                        var Et = e._context.doubleClick, dt = [];
                        C && (dt = dt.concat(x)), M && (dt = dt.concat(b)), _.xaxes && (dt = dt.concat(_.xaxes)), _.yaxes && (dt = dt.concat(_.yaxes));
                        var Ht = {}, $t, fr;
                        if (Et === "reset+autosize") for(Et = "autosize", fr = 0; fr < dt.length; fr++){
                            $t = dt[fr];
                            var _r = $t._rangeInitial0, Br = $t._rangeInitial1, Or = _r !== void 0 || Br !== void 0;
                            if (Or && (_r !== void 0 && _r !== $t.range[0] || Br !== void 0 && Br !== $t.range[1]) || !Or && $t.autorange !== !0) {
                                Et = "reset";
                                break;
                            }
                        }
                        if (Et === "autosize") for(fr = 0; fr < dt.length; fr++)$t = dt[fr], $t.fixedrange || (Ht[$t._name + ".autorange"] = !0);
                        else if (Et === "reset") {
                            for((C || L.isSubplotConstrained) && (dt = dt.concat(L.xaxes)), M && !L.isSubplotConstrained && (dt = dt.concat(L.yaxes)), L.isSubplotConstrained && (C ? M || (dt = dt.concat(b)) : dt = dt.concat(x)), fr = 0; fr < dt.length; fr++)if ($t = dt[fr], !$t.fixedrange) {
                                var Nr = $t._name, ut = $t._autorangeInitial;
                                $t._rangeInitial0 === void 0 && $t._rangeInitial1 === void 0 ? Ht[Nr + ".autorange"] = !0 : $t._rangeInitial0 === void 0 ? (Ht[Nr + ".autorange"] = ut, Ht[Nr + ".range"] = [
                                    null,
                                    $t._rangeInitial1
                                ]) : $t._rangeInitial1 === void 0 ? (Ht[Nr + ".range"] = [
                                    $t._rangeInitial0,
                                    null
                                ], Ht[Nr + ".autorange"] = ut) : Ht[Nr + ".range"] = [
                                    $t._rangeInitial0,
                                    $t._rangeInitial1
                                ];
                            }
                        }
                        e.emit("plotly_doubleclick", null), bP.call("_guiRelayout", e, Ht);
                    }
                }
                function Ke() {
                    xt([
                        0,
                        0,
                        k,
                        A
                    ]), C0.syncOrAsync([
                        Cft.previousPromises,
                        function() {
                            e._fullLayout._replotting = !1, bP.call("_guiRelayout", e, H);
                        }
                    ], e);
                }
                function xt(Et) {
                    var dt = e._fullLayout, Ht = dt._plots, $t = dt._subplots.cartesian, fr, _r, Br, Or;
                    if (q && bP.subplotsRegistry.splom.drag(e), F) {
                        for(fr = 0; fr < $t.length; fr++)if (_r = Ht[$t[fr]], Br = _r.xaxis, Or = _r.yaxis, _r._scene) {
                            Br.limitRange && Br.limitRange(), Or.limitRange && Or.limitRange();
                            var Nr = C0.simpleMap(Br.range, Br.r2l), ut = C0.simpleMap(Or.range, Or.r2l);
                            _r._scene.update({
                                range: [
                                    Nr[0],
                                    ut[0],
                                    Nr[1],
                                    ut[1]
                                ]
                            });
                        }
                    }
                    if ((q || F) && (Eft(e), kft(e)), V) {
                        var Ne = Et[2] / f._length, Ye = Et[3] / h._length;
                        for(fr = 0; fr < $t.length; fr++){
                            _r = Ht[$t[fr]], Br = _r.xaxis, Or = _r.yaxis;
                            var Ve = (P || _.isSubplotConstrained) && !Br.fixedrange && d[Br._id], Xe = (T || _.isSubplotConstrained) && !Or.fixedrange && v[Or._id], ht, Le, xe, Se;
                            if (Ve ? (ht = Ne, xe = s || _.isSubplotConstrained ? Et[0] : St(Br, ht)) : _.xaHash[Br._id] ? (ht = Ne, xe = Et[0] * Br._length / f._length) : _.yaHash[Br._id] ? (ht = Ye, xe = M === "ns" ? -Et[1] * Br._length / h._length : St(Br, ht, {
                                n: "top",
                                s: "bottom"
                            }[M])) : (ht = bt(Br, Ne, Ye), xe = Lt(Br, ht)), ht > 1 && (Br.maxallowed !== void 0 && P === (Br.range[0] < Br.range[1] ? "e" : "w") || Br.minallowed !== void 0 && P === (Br.range[0] < Br.range[1] ? "w" : "e")) && (ht = 1, xe = 0), Xe ? (Le = Ye, Se = o || _.isSubplotConstrained ? Et[1] : St(Or, Le)) : _.yaHash[Or._id] ? (Le = Ye, Se = Et[1] * Or._length / h._length) : _.xaHash[Or._id] ? (Le = Ne, Se = C === "ew" ? -Et[0] * Or._length / f._length : St(Or, Le, {
                                e: "right",
                                w: "left"
                            }[C])) : (Le = bt(Or, Ne, Ye), Se = Lt(Or, Le)), Le > 1 && (Or.maxallowed !== void 0 && T === (Or.range[0] < Or.range[1] ? "n" : "s") || Or.minallowed !== void 0 && T === (Or.range[0] < Or.range[1] ? "s" : "n")) && (Le = 1, Se = 0), !(!ht && !Le)) {
                                ht || (ht = 1), Le || (Le = 1);
                                var lt = Br._offset - xe / ht, Gt = Or._offset - Se / Le;
                                _r.clipRect.call(v_.setTranslate, xe, Se).call(v_.setScale, ht, Le), _r.plot.call(v_.setTranslate, lt, Gt).call(v_.setScale, 1 / ht, 1 / Le), (ht !== _r.xScaleFactor || Le !== _r.yScaleFactor) && (v_.setPointGroupScale(_r.zoomScalePts, ht, Le), v_.setTextPointsScale(_r.zoomScaleTxt, ht, Le)), v_.hideOutsideRangePoints(_r.clipOnAxisFalseTraces, _r), _r.xScaleFactor = ht, _r.yScaleFactor = Le;
                            }
                        }
                    }
                }
                function bt(Et, dt, Ht) {
                    return Et.fixedrange ? 0 : P && L.xaHash[Et._id] ? dt : T && (L.isSubplotConstrained ? L.xaHash : L.yaHash)[Et._id] ? Ht : 0;
                }
                function Lt(Et, dt) {
                    return dt ? (Et.range = Et._r.slice(), kN(Et, dt), St(Et, dt)) : 0;
                }
                function St(Et, dt, Ht) {
                    return Et._length * (1 - dt) * Mft[Ht || Et.constraintoward || "middle"];
                }
                return re;
            }
            function nhe(e, t, r, n) {
                var i = C0.ensureSingle(e.draglayer, t, r, function(a) {
                    a.classed("drag", !0).style({
                        fill: "transparent",
                        "stroke-width": 0
                    }).attr("data-subplot", e.id);
                });
                return i.call(Tft, n), i.node();
            }
            function ahe(e, t, r, n, i, a, o) {
                var s = nhe(e, "rect", t, r);
                return IN.select(s).call(v_.setRect, n, i, a, o), s;
            }
            function $fe(e, t) {
                for(var r = 0; r < e.length; r++)if (!e[r].fixedrange) return t;
                return "";
            }
            function Dft(e, t) {
                var r = e.range[t], n = Math.abs(r - e.range[1 - t]), i;
                return e.type === "date" ? r : e.type === "log" ? (i = Math.ceil(Math.max(0, -Math.log(n) / Math.LN10)) + 3, Zfe("." + i + "g")(Math.pow(10, r))) : (i = Math.floor(Math.log(Math.abs(r)) / Math.LN10) - Math.floor(Math.log(n) / Math.LN10) + 4, Zfe("." + String(i) + "g")(r));
            }
            function LN(e, t, r, n, i) {
                for(var a = 0; a < e.length; a++){
                    var o = e[a];
                    if (!o.fixedrange) {
                        if (o.rangebreaks) {
                            var s = o._id.charAt(0) === "y", l = s ? 1 - t : t, u = s ? 1 - r : r;
                            n[o._name + ".range[0]"] = o.l2r(o.p2l(l * o._length)), n[o._name + ".range[1]"] = o.l2r(o.p2l(u * o._length));
                        } else {
                            var c = o._rl[0], f = o._rl[1] - c;
                            n[o._name + ".range[0]"] = o.l2r(c + f * t), n[o._name + ".range[1]"] = o.l2r(c + f * r);
                        }
                    }
                }
                if (i && i.length) {
                    var h = (t + (1 - r)) / 2;
                    LN(i, h, 1 - h, n, []);
                }
            }
            function Qfe(e, t) {
                for(var r = 0; r < e.length; r++){
                    var n = e[r];
                    if (!n.fixedrange) {
                        if (n.rangebreaks) {
                            var i = 0, a = n._length, o = n.p2l(i + t) - n.p2l(i), s = n.p2l(a + t) - n.p2l(a), l = (o + s) / 2;
                            n.range = [
                                n.l2r(n._rl[0] - l),
                                n.l2r(n._rl[1] - l)
                            ];
                        } else n.range = [
                            n.l2r(n._rl[0] - t / n._m),
                            n.l2r(n._rl[1] - t / n._m)
                        ];
                        n.limitRange && n.limitRange();
                    }
                }
            }
            function zft(e) {
                return 1 - (e >= 0 ? Math.min(e, .9) : 1 / (1 / Math.max(e, -0.3) + 3.222));
            }
            function Fft(e, t, r) {
                return e ? e === "nsew" ? r ? "" : t === "pan" ? "move" : "crosshair" : e.toLowerCase() + "-resize" : "pointer";
            }
            function ohe(e, t, r, n, i) {
                return e.append("path").attr("class", "zoombox").style({
                    fill: t > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
                    "stroke-width": 0
                }).attr("transform", rhe(r, n)).attr("d", i + "Z");
            }
            function she(e, t, r) {
                return e.append("path").attr("class", "zoombox-corners").style({
                    fill: Xfe.background,
                    stroke: Xfe.defaultLine,
                    "stroke-width": 1,
                    opacity: 0
                }).attr("transform", rhe(t, r)).attr("d", "M0,0Z");
            }
            function lhe(e, t, r, n, i, a) {
                e.attr("d", n + "M" + r.l + "," + r.t + "v" + r.h + "h" + r.w + "v-" + r.h + "h-" + r.w + "Z"), uhe(e, t, i, a);
            }
            function uhe(e, t, r, n) {
                r || (e.transition().style("fill", n > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), t.transition().style("opacity", 1).duration(200));
            }
            function PN(e) {
                IN.select(e).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
            }
            function che(e) {
                Jfe && e.data && e._context.showTips && (C0.notifier(C0._(e, "Double-click to zoom back out"), "long"), Jfe = !1);
            }
            function qft(e, t) {
                return "M" + (e.l - .5) + "," + (t - np - .5) + "h-3v" + (2 * np + 1) + "h3ZM" + (e.r + .5) + "," + (t - np - .5) + "h3v" + (2 * np + 1) + "h-3Z";
            }
            function Oft(e, t) {
                return "M" + (t - np - .5) + "," + (e.t - .5) + "v-3h" + (2 * np + 1) + "v3ZM" + (t - np - .5) + "," + (e.b + .5) + "v3h" + (2 * np + 1) + "v-3Z";
            }
            function TP(e) {
                var t = Math.floor(Math.min(e.b - e.t, e.r - e.l, np) / 2);
                return "M" + (e.l - 3.5) + "," + (e.t - .5 + t) + "h3v" + -t + "h" + t + "v-3h-" + (t + 3) + "ZM" + (e.r + 3.5) + "," + (e.t - .5 + t) + "h-3v" + -t + "h" + -t + "v-3h" + (t + 3) + "ZM" + (e.r + 3.5) + "," + (e.b + .5 - t) + "h-3v" + t + "h" + -t + "v3h" + (t + 3) + "ZM" + (e.l - 3.5) + "," + (e.b + .5 - t) + "h3v" + t + "h" + t + "v3h-" + (t + 3) + "Z";
            }
            function ehe(e, t, r, n, i) {
                for(var a = !1, o = {}, s = {}, l, u, c, f, h = (i || {}).xaHash, d = (i || {}).yaHash, v = 0; v < t.length; v++){
                    var x = t[v];
                    for(l in r)if (x[l]) {
                        for(c in x)!(i && (h[c] || d[c])) && !(c.charAt(0) === "x" ? r : n)[c] && (o[c] = l);
                        for(u in n)!(i && (h[u] || d[u])) && x[u] && (a = !0);
                    }
                    for(u in n)if (x[u]) for(f in x)!(i && (h[f] || d[f])) && !(f.charAt(0) === "x" ? r : n)[f] && (s[f] = u);
                }
                a && (C0.extendFlat(o, s), s = {});
                var b = {}, p = [];
                for(c in o){
                    var E = CN(e, c);
                    p.push(E), b[E._id] = E;
                }
                var k = {}, A = [];
                for(f in s){
                    var L = CN(e, f);
                    A.push(L), k[L._id] = L;
                }
                return {
                    xaHash: b,
                    yaHash: k,
                    xaxes: p,
                    yaxes: A,
                    xLinks: o,
                    yLinks: s,
                    isSubplotConstrained: a
                };
            }
            function fhe(e, t) {
                if (!xft) e.onwheel !== void 0 ? e.onwheel = t : e.onmousewheel !== void 0 ? e.onmousewheel = t : e.isAddedWheelEvent || (e.isAddedWheelEvent = !0, e.addEventListener("wheel", t, {
                    passive: !1
                }));
                else {
                    var r = e.onwheel !== void 0 ? "wheel" : "mousewheel";
                    e._onwheel && e.removeEventListener(r, e._onwheel), e._onwheel = t, e.addEventListener(r, t, {
                        passive: !1
                    });
                }
            }
            function the(e) {
                var t = [];
                for(var r in e)t.push(e[r]);
                return t;
            }
            hhe.exports = {
                makeDragBox: Rft,
                makeDragger: nhe,
                makeRectDragger: ahe,
                makeZoombox: ohe,
                makeCorners: she,
                updateZoombox: lhe,
                xyCorners: TP,
                transitionZoombox: uhe,
                removeZoombox: PN,
                showDoubleClickNotifier: che,
                attachWheelEventHandler: fhe
            };
        });
        var zN = ye((SP)=>{
            "use strict";
            var Bft = xa(), AP = Nc(), Nft = gv(), Uft = Tg(), kg = DN().makeDragBox, ud = ad().DRAGGERSIZE;
            SP.initInteractions = function(t) {
                var r = t._fullLayout;
                if (t._context.staticPlot) {
                    Bft.select(t).selectAll(".drag").remove();
                    return;
                }
                if (!(!r._has("cartesian") && !r._has("splom"))) {
                    var n = Object.keys(r._plots || {}).sort(function(a, o) {
                        if ((r._plots[a].mainplot && !0) === (r._plots[o].mainplot && !0)) {
                            var s = a.split("y"), l = o.split("y");
                            return s[0] === l[0] ? Number(s[1] || 1) - Number(l[1] || 1) : Number(s[0] || 1) - Number(l[0] || 1);
                        }
                        return r._plots[a].mainplot ? 1 : -1;
                    });
                    n.forEach(function(a) {
                        var o = r._plots[a], s = o.xaxis, l = o.yaxis;
                        if (!o.mainplot) {
                            var u = kg(t, o, s._offset, l._offset, s._length, l._length, "ns", "ew");
                            u.onmousemove = function(h) {
                                t._fullLayout._rehover = function() {
                                    t._fullLayout._hoversubplot === a && t._fullLayout._plots[a] && AP.hover(t, h, a);
                                }, AP.hover(t, h, a), t._fullLayout._lasthover = u, t._fullLayout._hoversubplot = a;
                            }, u.onmouseout = function(h) {
                                t._dragging || (t._fullLayout._hoversubplot = null, Nft.unhover(t, h));
                            }, t._context.showAxisDragHandles && (kg(t, o, s._offset - ud, l._offset - ud, ud, ud, "n", "w"), kg(t, o, s._offset + s._length, l._offset - ud, ud, ud, "n", "e"), kg(t, o, s._offset - ud, l._offset + l._length, ud, ud, "s", "w"), kg(t, o, s._offset + s._length, l._offset + l._length, ud, ud, "s", "e"));
                        }
                        if (t._context.showAxisDragHandles) {
                            if (a === s._mainSubplot) {
                                var c = s._mainLinePosition;
                                s.side === "top" && (c -= ud), kg(t, o, s._offset + s._length * .1, c, s._length * .8, ud, "", "ew"), kg(t, o, s._offset, c, s._length * .1, ud, "", "w"), kg(t, o, s._offset + s._length * .9, c, s._length * .1, ud, "", "e");
                            }
                            if (a === l._mainSubplot) {
                                var f = l._mainLinePosition;
                                l.side !== "right" && (f -= ud), kg(t, o, f, l._offset + l._length * .1, ud, l._length * .8, "ns", ""), kg(t, o, f, l._offset + l._length * .9, ud, l._length * .1, "s", ""), kg(t, o, f, l._offset, ud, l._length * .1, "n", "");
                            }
                        }
                    });
                    var i = r._hoverlayer.node();
                    i.onmousemove = function(a) {
                        a.target = t._fullLayout._lasthover, AP.hover(t, a, r._hoversubplot);
                    }, i.onclick = function(a) {
                        a.target = t._fullLayout._lasthover, AP.click(t, a);
                    }, i.onmousedown = function(a) {
                        t._fullLayout._lasthover.onmousedown(a);
                    }, SP.updateFx(t);
                }
            };
            SP.updateFx = function(e) {
                var t = e._fullLayout, r = t.dragmode === "pan" ? "move" : "crosshair";
                Uft(t._draggers, r);
            };
        });
        var phe = ye((Qir, vhe)=>{
            "use strict";
            var dhe = ba();
            vhe.exports = function(t) {
                for(var r = dhe.layoutArrayContainers, n = dhe.layoutArrayRegexes, i = t.split("[")[0], a, o, s = 0; s < n.length; s++)if (o = t.match(n[s]), o && o.index === 0) {
                    a = o[0];
                    break;
                }
                if (a || (a = r[r.indexOf(i)]), !a) return !1;
                var l = t.substr(a.length);
                return l ? (o = l.match(/^\[(0|[1-9][0-9]*)\](\.(.+))?$/), o ? {
                    array: a,
                    index: Number(o[1]),
                    property: o[3] || ""
                } : !1) : {
                    array: a,
                    index: "",
                    property: ""
                };
            };
        });
        var mhe = ye((zM)=>{
            "use strict";
            var Vft = gy(), FN = g6(), DM = G1(), Hft = k6().sorterAsc, qN = ba();
            zM.containerArrayMatch = phe();
            var Gft = zM.isAddVal = function(t) {
                return t === "add" || Vft(t);
            }, ghe = zM.isRemoveVal = function(t) {
                return t === null || t === "remove";
            };
            zM.applyContainerArrayChanges = function(t, r, n, i, a) {
                var o = r.astr, s = qN.getComponentMethod(o, "supplyLayoutDefaults"), l = qN.getComponentMethod(o, "draw"), u = qN.getComponentMethod(o, "drawOne"), c = i.replot || i.recalc || s === FN || l === FN, f = t.layout, h = t._fullLayout;
                if (n[""]) {
                    Object.keys(n).length > 1 && DM.warn("Full array edits are incompatible with other edits", o);
                    var d = n[""][""];
                    if (ghe(d)) r.set(null);
                    else if (Array.isArray(d)) r.set(d);
                    else return DM.warn("Unrecognized full array edit value", o, d), !0;
                    return c ? !1 : (s(f, h), l(t), !0);
                }
                var v = Object.keys(n).map(Number).sort(Hft), x = r.get(), b = x || [], p = a(h, o).get(), E = [], k = -1, A = b.length, L, _, C, M, g, P, T, F;
                for(L = 0; L < v.length; L++){
                    if (C = v[L], M = n[C], g = Object.keys(M), P = M[""], T = Gft(P), C < 0 || C > b.length - (T ? 0 : 1)) {
                        DM.warn("index out of range", o, C);
                        continue;
                    }
                    if (P !== void 0) g.length > 1 && DM.warn("Insertion & removal are incompatible with edits to the same index.", o, C), ghe(P) ? E.push(C) : T ? (P === "add" && (P = {}), b.splice(C, 0, P), p && p.splice(C, 0, {})) : DM.warn("Unrecognized full object edit value", o, C, P), k === -1 && (k = C);
                    else for(_ = 0; _ < g.length; _++)F = o + "[" + C + "].", a(b[C], g[_], F).set(M[g[_]]);
                }
                for(L = E.length - 1; L >= 0; L--)b.splice(E[L], 1), p && p.splice(E[L], 1);
                if (b.length ? x || r.set(b) : r.set(null), c) return !1;
                if (s(f, h), u !== FN) {
                    var q;
                    if (k === -1) q = v;
                    else {
                        for(A = Math.max(b.length, A), q = [], L = 0; L < v.length && (C = v[L], !(C >= k)); L++)q.push(C);
                        for(L = k; L < A; L++)q.push(L);
                    }
                    for(L = 0; L < q.length; L++)u(t, q[L]);
                } else l(t);
                return !0;
            };
        });
        var She = ye((Cg)=>{
            "use strict";
            var bhe = uo(), tnr = Lq(), whe = ba(), kp = Mr(), FM = Xu(), The = af(), Ahe = va(), qM = The.cleanId, jft = The.getFromTrace, ON = whe.traceIs;
            Cg.clearPromiseQueue = function(e) {
                Array.isArray(e._promises) && e._promises.length > 0 && kp.log("Clearing previous rejected promises from queue."), e._promises = [];
            };
            Cg.cleanLayout = function(e) {
                var t, r;
                e || (e = {}), e.xaxis1 && (e.xaxis || (e.xaxis = e.xaxis1), delete e.xaxis1), e.yaxis1 && (e.yaxis || (e.yaxis = e.yaxis1), delete e.yaxis1), e.scene1 && (e.scene || (e.scene = e.scene1), delete e.scene1);
                var n = (FM.subplotsRegistry.cartesian || {}).attrRegex, i = (FM.subplotsRegistry.polar || {}).attrRegex, a = (FM.subplotsRegistry.ternary || {}).attrRegex, o = (FM.subplotsRegistry.gl3d || {}).attrRegex, s = Object.keys(e);
                for(t = 0; t < s.length; t++){
                    var l = s[t];
                    if (n && n.test(l)) {
                        var u = e[l];
                        u.anchor && u.anchor !== "free" && (u.anchor = qM(u.anchor)), u.overlaying && (u.overlaying = qM(u.overlaying)), u.type || (u.isdate ? u.type = "date" : u.islog ? u.type = "log" : u.isdate === !1 && u.islog === !1 && (u.type = "linear")), (u.autorange === "withzero" || u.autorange === "tozero") && (u.autorange = !0, u.rangemode = "tozero"), u.insiderange && delete u.range, delete u.islog, delete u.isdate, delete u.categories, MP(u, "domain") && delete u.domain;
                    }
                }
                var c = Array.isArray(e.annotations) ? e.annotations.length : 0;
                for(t = 0; t < c; t++){
                    var f = e.annotations[t];
                    kp.isPlainObject(f) && (Y3(f, "xref"), Y3(f, "yref"));
                }
                var h = Array.isArray(e.shapes) ? e.shapes.length : 0;
                for(t = 0; t < h; t++){
                    var d = e.shapes[t];
                    kp.isPlainObject(d) && (Y3(d, "xref"), Y3(d, "yref"));
                }
                var v = Array.isArray(e.images) ? e.images.length : 0;
                for(t = 0; t < v; t++){
                    var x = e.images[t];
                    kp.isPlainObject(x) && (Y3(x, "xref"), Y3(x, "yref"));
                }
                var b = e.legend;
                return b && (b.x > 3 ? (b.x = 1.02, b.xanchor = "left") : b.x < -2 && (b.x = -0.02, b.xanchor = "right"), b.y > 3 ? (b.y = 1.02, b.yanchor = "bottom") : b.y < -2 && (b.y = -0.02, b.yanchor = "top")), e.dragmode === "rotate" && (e.dragmode = "orbit"), Ahe.clean(e), e.template && e.template.layout && Cg.cleanLayout(e.template.layout), e;
            };
            function Y3(e, t) {
                var r = e[t], n = t.charAt(0);
                r && r !== "paper" && (e[t] = qM(r, n, !0));
            }
            Cg.cleanData = function(e) {
                for(var t = 0; t < e.length; t++){
                    var r = e[t], n;
                    if (r.type === "histogramy" && "xbins" in r && !("ybins" in r) && (r.ybins = r.xbins, delete r.xbins), r.type === "histogramy" && Cg.swapXYData(r), (r.type === "histogramx" || r.type === "histogramy") && (r.type = "histogram"), "scl" in r && !("colorscale" in r) && (r.colorscale = r.scl, delete r.scl), "reversescl" in r && !("reversescale" in r) && (r.reversescale = r.reversescl, delete r.reversescl), r.xaxis && (r.xaxis = qM(r.xaxis, "x")), r.yaxis && (r.yaxis = qM(r.yaxis, "y")), ON(r, "gl3d") && r.scene && (r.scene = FM.subplotsRegistry.gl3d.cleanId(r.scene)), !ON(r, "pie-like") && !ON(r, "bar-like")) {
                        if (Array.isArray(r.textposition)) for(n = 0; n < r.textposition.length; n++)r.textposition[n] = _he(r.textposition[n]);
                        else r.textposition && (r.textposition = _he(r.textposition));
                    }
                    var i = whe.getModule(r);
                    if (i && i.colorbar) {
                        var a = i.colorbar.container, o = a ? r[a] : r;
                        o && o.colorscale && (o.colorscale === "YIGnBu" && (o.colorscale = "YlGnBu"), o.colorscale === "YIOrRd" && (o.colorscale = "YlOrRd"));
                    }
                    if (r.type === "surface" && kp.isPlainObject(r.contours)) {
                        var s = [
                            "x",
                            "y",
                            "z"
                        ];
                        for(n = 0; n < s.length; n++){
                            var l = r.contours[s[n]];
                            kp.isPlainObject(l) && (l.highlightColor && (l.highlightcolor = l.highlightColor, delete l.highlightColor), l.highlightWidth && (l.highlightwidth = l.highlightWidth, delete l.highlightWidth));
                        }
                    }
                    if (r.type === "candlestick" || r.type === "ohlc") {
                        var u = (r.increasing || {}).showlegend !== !1, c = (r.decreasing || {}).showlegend !== !1, f = yhe(r.increasing), h = yhe(r.decreasing);
                        if (f !== !1 && h !== !1) {
                            var d = Wft(f, h, u, c);
                            d && (r.name = d);
                        } else (f || h) && !r.name && (r.name = f || h);
                    }
                    MP(r, "line") && delete r.line, "marker" in r && (MP(r.marker, "line") && delete r.marker.line, MP(r, "marker") && delete r.marker), Ahe.clean(r), r.autobinx && (delete r.autobinx, delete r.xbins), r.autobiny && (delete r.autobiny, delete r.ybins);
                }
            };
            function yhe(e) {
                if (!kp.isPlainObject(e)) return !1;
                var t = e.name;
                return delete e.name, delete e.showlegend, (typeof t == "string" || typeof t == "number") && String(t);
            }
            function Wft(e, t, r, n) {
                if (r && !n) return e;
                if (n && !r || !e.trim()) return t;
                if (!t.trim()) return e;
                var i = Math.min(e.length, t.length), a;
                for(a = 0; a < i && e.charAt(a) === t.charAt(a); a++);
                var o = e.substr(0, a);
                return o.trim();
            }
            function _he(e) {
                var t = "middle", r = "center";
                return typeof e == "string" && (e.indexOf("top") !== -1 ? t = "top" : e.indexOf("bottom") !== -1 && (t = "bottom"), e.indexOf("left") !== -1 ? r = "left" : e.indexOf("right") !== -1 && (r = "right")), t + " " + r;
            }
            function MP(e, t) {
                return t in e && typeof e[t] == "object" && Object.keys(e[t]).length === 0;
            }
            Cg.swapXYData = function(e) {
                var t;
                if (kp.swapAttrs(e, [
                    "?",
                    "?0",
                    "d?",
                    "?bins",
                    "nbins?",
                    "autobin?",
                    "?src",
                    "error_?"
                ]), Array.isArray(e.z) && Array.isArray(e.z[0]) && (e.transpose ? delete e.transpose : e.transpose = !0), e.error_x && e.error_y) {
                    var r = e.error_y, n = "copy_ystyle" in r ? r.copy_ystyle : !(r.color || r.thickness || r.width);
                    kp.swapAttrs(e, [
                        "error_?.copy_ystyle"
                    ]), n && kp.swapAttrs(e, [
                        "error_?.color",
                        "error_?.thickness",
                        "error_?.width"
                    ]);
                }
                if (typeof e.hoverinfo == "string") {
                    var i = e.hoverinfo.split("+");
                    for(t = 0; t < i.length; t++)i[t] === "x" ? i[t] = "y" : i[t] === "y" && (i[t] = "x");
                    e.hoverinfo = i.join("+");
                }
            };
            Cg.coerceTraceIndices = function(e, t) {
                if (bhe(t)) return [
                    t
                ];
                if (!Array.isArray(t) || !t.length) return e.data.map(function(i, a) {
                    return a;
                });
                if (Array.isArray(t)) {
                    for(var r = [], n = 0; n < t.length; n++)kp.isIndex(t[n], e.data.length) ? r.push(t[n]) : kp.warn("trace index (", t[n], ") is not a number or is out of bounds");
                    return r;
                }
                return t;
            };
            Cg.manageArrayContainers = function(e, t, r) {
                var n = e.obj, i = e.parts, a = i.length, o = i[a - 1], s = bhe(o);
                if (s && t === null) {
                    var l = i.slice(0, a - 1).join("."), u = kp.nestedProperty(n, l).get();
                    u.splice(o, 1);
                } else s && e.get() === void 0 && e.get() === void 0 && (r[e.astr] = null), e.set(t);
            };
            var Zft = /(\.[^\[\]\.]+|\[[^\[\]\.]+\])$/;
            function xhe(e) {
                var t = e.search(Zft);
                if (t > 0) return e.substr(0, t);
            }
            Cg.hasParent = function(e, t) {
                for(var r = xhe(t); r;){
                    if (r in e) return !0;
                    r = xhe(r);
                }
                return !1;
            };
            var Xft = [
                "x",
                "y",
                "z"
            ];
            Cg.clearAxisTypes = function(e, t, r) {
                for(var n = 0; n < t.length; n++)for(var i = e._fullData[n], a = 0; a < 3; a++){
                    var o = jft(e, i, Xft[a]);
                    if (o && o.type !== "log") {
                        var s = o._name, l = o._id.substr(1);
                        if (l.substr(0, 5) === "scene") {
                            if (r[l] !== void 0) continue;
                            s = l + "." + s;
                        }
                        var u = s + ".type";
                        r[s] === void 0 && r[u] === void 0 && kp.nestedProperty(e.layout, u).set(null);
                    }
                }
            };
        });
        var OP = ye((pl)=>{
            "use strict";
            var CP = xa(), Yft = uo(), Kft = $q(), sa = Mr(), Yu = sa.nestedProperty, UN = g3(), ap = lne(), L0 = ba(), FP = _3(), Ho = Xu(), Nv = Qa(), Jft = dB(), $ft = Cd(), BN = ao(), Qft = va(), eht = zN().initInteractions, tht = Zp(), rht = wf().clearOutline, Lhe = ub().dfltConfig, EP = mhe(), yh = She(), $l = gM(), p_ = Bu(), iht = ad().AX_NAME_PATTERN, NN = 0, Mhe = 5;
            function nht(e, t, r, n) {
                var i;
                if (e = sa.getGraphDiv(e), UN.init(e), sa.isPlainObject(t)) {
                    var a = t;
                    t = a.data, r = a.layout, n = a.config, i = a.frames;
                }
                var o = UN.triggerHandler(e, "plotly_beforeplot", [
                    t,
                    r,
                    n
                ]);
                if (o === !1) return Promise.reject();
                !t && !r && !sa.isPlotDiv(e) && sa.warn("Calling _doPlot as if redrawing but this container doesn't yet have a plot.", e);
                function s() {
                    if (i) return pl.addFrames(e, i);
                }
                Ihe(e, n), r || (r = {}), CP.select(e).classed("js-plotly-plot", !0), BN.makeTester(), Array.isArray(e._promises) || (e._promises = []);
                var l = (e.data || []).length === 0 && Array.isArray(t);
                Array.isArray(t) && (yh.cleanData(t), l ? e.data = t : e.data.push.apply(e.data, t), e.empty = !1), (!e.layout || l) && (e.layout = yh.cleanLayout(r)), Ho.supplyDefaults(e);
                var u = e._fullLayout, c = u._has("cartesian");
                u._replotting = !0, (l || u._shouldCreateBgLayer) && (Eht(e), u._shouldCreateBgLayer && delete u._shouldCreateBgLayer), BN.initGradients(e), BN.initPatterns(e), l && Nv.saveShowSpikeInitial(e);
                var f = !e.calcdata || e.calcdata.length !== (e._fullData || []).length;
                f && Ho.doCalcdata(e);
                for(var h = 0; h < e.calcdata.length; h++)e.calcdata[h][0].trace = e._fullData[h];
                e._context.responsive ? e._responsiveChartHandler || (e._responsiveChartHandler = function() {
                    sa.isHidden(e) || Ho.resize(e);
                }, window.addEventListener("resize", e._responsiveChartHandler)) : sa.clearResponsive(e);
                var d = sa.extendFlat({}, u._size), v = 0;
                function x() {
                    for(var C = u._basePlotModules, M = 0; M < C.length; M++)C[M].drawFramework && C[M].drawFramework(e);
                    !u._glcanvas && u._has("gl") && (u._glcanvas = u._glcontainer.selectAll(".gl-canvas").data([
                        {
                            key: "contextLayer",
                            context: !0,
                            pick: !1
                        },
                        {
                            key: "focusLayer",
                            context: !1,
                            pick: !1
                        },
                        {
                            key: "pickLayer",
                            context: !1,
                            pick: !0
                        }
                    ], function(F) {
                        return F.key;
                    }), u._glcanvas.enter().append("canvas").attr("class", function(F) {
                        return "gl-canvas gl-canvas-" + F.key.replace("Layer", "");
                    }).style({
                        position: "absolute",
                        top: 0,
                        left: 0,
                        overflow: "visible",
                        "pointer-events": "none"
                    }));
                    var g = e._context.plotGlPixelRatio;
                    if (u._glcanvas) {
                        u._glcanvas.attr("width", u.width * g).attr("height", u.height * g).style("width", u.width + "px").style("height", u.height + "px");
                        var P = u._glcanvas.data()[0].regl;
                        if (P && (Math.floor(u.width * g) !== P._gl.drawingBufferWidth || Math.floor(u.height * g) !== P._gl.drawingBufferHeight)) {
                            var T = "WebGL context buffer and canvas dimensions do not match due to browser/WebGL bug.";
                            if (v) sa.error(T);
                            else return sa.log(T + " Clearing graph and plotting again."), Ho.cleanPlot([], {}, e._fullData, u), Ho.supplyDefaults(e), u = e._fullLayout, Ho.doCalcdata(e), v++, x();
                        }
                    }
                    return u.modebar.orientation === "h" ? u._modebardiv.style("height", null).style("width", "100%") : u._modebardiv.style("width", null).style("height", u.height + "px"), Ho.previousPromises(e);
                }
                function b() {
                    if (Ho.clearAutoMarginIds(e), $l.drawMarginPushers(e), Nv.allowAutoMargin(e), e._fullLayout.title.text && e._fullLayout.title.automargin && Ho.allowAutoMargin(e, "title.automargin"), u._has("pie")) for(var C = e._fullData, M = 0; M < C.length; M++){
                        var g = C[M];
                        g.type === "pie" && g.automargin && Ho.allowAutoMargin(e, "pie." + g.uid + ".automargin");
                    }
                    return Ho.doAutoMargin(e), Ho.previousPromises(e);
                }
                function p() {
                    if (Ho.didMarginChange(d, u._size)) return sa.syncOrAsync([
                        b,
                        $l.layoutStyles
                    ], e);
                }
                function E() {
                    if (!f) {
                        k();
                        return;
                    }
                    return sa.syncOrAsync([
                        L0.getComponentMethod("shapes", "calcAutorange"),
                        L0.getComponentMethod("annotations", "calcAutorange"),
                        k
                    ], e);
                }
                function k() {
                    e._transitioning || ($l.doAutoRangeAndConstraints(e), l && Nv.saveRangeInitial(e), L0.getComponentMethod("rangeslider", "calcAutorange")(e));
                }
                function A() {
                    return Nv.draw(e, l ? "" : "redraw");
                }
                var L = [
                    Ho.previousPromises,
                    s,
                    x,
                    b,
                    p
                ];
                c && L.push(E), L.push($l.layoutStyles), c && L.push(A, function(M) {
                    var g = M._fullLayout._insideTickLabelsUpdaterange;
                    if (g) return M._fullLayout._insideTickLabelsUpdaterange = void 0, OM(M, g).then(function() {
                        Nv.saveRangeInitial(M, !0);
                    });
                }), L.push($l.drawData, $l.finalDraw, eht, Ho.addLinks, Ho.rehover, Ho.redrag, Ho.reselect, Ho.doAutoMargin, Ho.previousPromises);
                var _ = sa.syncOrAsync(L, e);
                return (!_ || !_.then) && (_ = Promise.resolve()), _.then(function() {
                    return BM(e), e;
                });
            }
            function BM(e) {
                var t = e._fullLayout;
                t._redrawFromAutoMarginCount ? t._redrawFromAutoMarginCount-- : e.emit("plotly_afterplot");
            }
            function aht(e) {
                return sa.extendFlat(Lhe, e);
            }
            function Phe(e, t) {
                try {
                    e._fullLayout._paper.style("background", t);
                } catch (r) {
                    sa.error(r);
                }
            }
            function oht(e, t) {
                var r = Qft.combine(t, "white");
                Phe(e, r);
            }
            function Ihe(e, t) {
                if (!e._context) {
                    e._context = sa.extendDeep({}, Lhe);
                    var r = CP.select("base");
                    e._context._baseUrl = r.size() && r.attr("href") ? window.location.href.split("#")[0] : "";
                }
                var n = e._context, i, a, o;
                if (t) {
                    for(a = Object.keys(t), i = 0; i < a.length; i++)o = a[i], !(o === "editable" || o === "edits") && o in n && (o === "setBackground" && t[o] === "opaque" ? n[o] = oht : n[o] = t[o]);
                    var s = t.editable;
                    if (s !== void 0) for(n.editable = s, a = Object.keys(n.edits), i = 0; i < a.length; i++)n.edits[a[i]] = s;
                    if (t.edits) for(a = Object.keys(t.edits), i = 0; i < a.length; i++)o = a[i], o in n.edits && (n.edits[o] = t.edits[o]);
                    n._exportedPlot = t._exportedPlot;
                }
                n.staticPlot && (n.editable = !1, n.edits = {}, n.autosizable = !1, n.scrollZoom = !1, n.doubleClick = !1, n.showTips = !1, n.showLink = !1, n.displayModeBar = !1), n.displayModeBar === "hover" && !Kft && (n.displayModeBar = !0), (n.setBackground === "transparent" || typeof n.setBackground != "function") && (n.setBackground = Phe), n._hasZeroHeight = n._hasZeroHeight || e.clientHeight === 0, n._hasZeroWidth = n._hasZeroWidth || e.clientWidth === 0;
                var l = n.scrollZoom, u = n._scrollZoom = {};
                if (l === !0) u.cartesian = 1, u.gl3d = 1, u.geo = 1, u.mapbox = 1, u.map = 1;
                else if (typeof l == "string") {
                    var c = l.split("+");
                    for(i = 0; i < c.length; i++)u[c[i]] = 1;
                } else l !== !1 && (u.gl3d = 1, u.geo = 1, u.mapbox = 1, u.map = 1);
            }
            function sht(e) {
                if (e = sa.getGraphDiv(e), !sa.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
                return yh.cleanData(e.data), yh.cleanLayout(e.layout), e.calcdata = void 0, pl._doPlot(e).then(function() {
                    return e.emit("plotly_redraw"), e;
                });
            }
            function lht(e, t, r, n) {
                return e = sa.getGraphDiv(e), Ho.cleanPlot([], {}, e._fullData || [], e._fullLayout || {}), Ho.purge(e), pl._doPlot(e, t, r, n);
            }
            function LP(e, t) {
                var r = t + 1, n = [], i, a;
                for(i = 0; i < e.length; i++)a = e[i], a < 0 ? n.push(r + a) : n.push(a);
                return n;
            }
            function PP(e, t, r) {
                var n, i;
                for(n = 0; n < t.length; n++){
                    if (i = t[n], i !== parseInt(i, 10)) throw new Error("all values in " + r + " must be integers");
                    if (i >= e.data.length || i < -e.data.length) throw new Error(r + " must be valid indices for gd.data.");
                    if (t.indexOf(i, n + 1) > -1 || i >= 0 && t.indexOf(-e.data.length + i) > -1 || i < 0 && t.indexOf(e.data.length + i) > -1) throw new Error("each index in " + r + " must be unique.");
                }
            }
            function Rhe(e, t, r) {
                if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
                if (typeof t == "undefined") throw new Error("currentIndices is a required argument.");
                if (Array.isArray(t) || (t = [
                    t
                ]), PP(e, t, "currentIndices"), typeof r != "undefined" && !Array.isArray(r) && (r = [
                    r
                ]), typeof r != "undefined" && PP(e, r, "newIndices"), typeof r != "undefined" && t.length !== r.length) throw new Error("current and new indices must be of equal length.");
            }
            function uht(e, t, r) {
                var n, i;
                if (!Array.isArray(e.data)) throw new Error("gd.data must be an array.");
                if (typeof t == "undefined") throw new Error("traces must be defined.");
                for(Array.isArray(t) || (t = [
                    t
                ]), n = 0; n < t.length; n++)if (i = t[n], typeof i != "object" || Array.isArray(i) || i === null) throw new Error("all values in traces array must be non-array objects");
                if (typeof r != "undefined" && !Array.isArray(r) && (r = [
                    r
                ]), typeof r != "undefined" && r.length !== t.length) throw new Error("if indices is specified, traces.length must equal indices.length");
            }
            function cht(e, t, r, n) {
                var i = sa.isPlainObject(n);
                if (!Array.isArray(e.data)) throw new Error("gd.data must be an array");
                if (!sa.isPlainObject(t)) throw new Error("update must be a key:value object");
                if (typeof r == "undefined") throw new Error("indices must be an integer or array of integers");
                PP(e, r, "indices");
                for(var a in t){
                    if (!Array.isArray(t[a]) || t[a].length !== r.length) throw new Error("attribute " + a + " must be an array of length equal to indices array length");
                    if (i && (!(a in n) || !Array.isArray(n[a]) || n[a].length !== t[a].length)) throw new Error("when maxPoints is set as a key:value object it must contain a 1:1 corrispondence with the keys and number of traces in the update object");
                }
            }
            function fht(e, t, r, n) {
                var i = sa.isPlainObject(n), a = [], o, s, l, u, c;
                Array.isArray(r) || (r = [
                    r
                ]), r = LP(r, e.data.length - 1);
                for(var f in t)for(var h = 0; h < r.length; h++){
                    if (o = e.data[r[h]], l = Yu(o, f), s = l.get(), u = t[f][h], !sa.isArrayOrTypedArray(u)) throw new Error("attribute: " + f + " index: " + h + " must be an array");
                    if (!sa.isArrayOrTypedArray(s)) throw new Error("cannot extend missing or non-array attribute: " + f);
                    if (s.constructor !== u.constructor) throw new Error("cannot extend array with an array of a different type: " + f);
                    c = i ? n[f][h] : n, Yft(c) || (c = -1), a.push({
                        prop: l,
                        target: s,
                        insert: u,
                        maxp: Math.floor(c)
                    });
                }
                return a;
            }
            function Dhe(e, t, r, n, i) {
                cht(e, t, r, n);
                for(var a = fht(e, t, r, n), o = {}, s = {}, l = 0; l < a.length; l++){
                    var u = a[l].prop, c = a[l].maxp, f = i(a[l].target, a[l].insert, c);
                    u.set(f[0]), Array.isArray(o[u.astr]) || (o[u.astr] = []), o[u.astr].push(f[1]), Array.isArray(s[u.astr]) || (s[u.astr] = []), s[u.astr].push(a[l].target.length);
                }
                return {
                    update: o,
                    maxPoints: s
                };
            }
            function zhe(e, t) {
                var r = new e.constructor(e.length + t.length);
                return r.set(e), r.set(t, e.length), r;
            }
            function Fhe(e, t, r, n) {
                e = sa.getGraphDiv(e);
                function i(l, u, c) {
                    var f, h;
                    if (sa.isTypedArray(l)) {
                        if (c < 0) {
                            var d = new l.constructor(0), v = zhe(l, u);
                            c < 0 ? (f = v, h = d) : (f = d, h = v);
                        } else if (f = new l.constructor(c), h = new l.constructor(l.length + u.length - c), c === u.length) f.set(u), h.set(l);
                        else if (c < u.length) {
                            var x = u.length - c;
                            f.set(u.subarray(x)), h.set(l), h.set(u.subarray(0, x), l.length);
                        } else {
                            var b = c - u.length, p = l.length - b;
                            f.set(l.subarray(p)), f.set(u, b), h.set(l.subarray(0, p));
                        }
                    } else f = l.concat(u), h = c >= 0 && c < f.length ? f.splice(0, f.length - c) : [];
                    return [
                        f,
                        h
                    ];
                }
                var a = Dhe(e, t, r, n, i), o = pl.redraw(e), s = [
                    e,
                    a.update,
                    r,
                    a.maxPoints
                ];
                return ap.add(e, pl.prependTraces, s, Fhe, arguments), o;
            }
            function qhe(e, t, r, n) {
                e = sa.getGraphDiv(e);
                function i(l, u, c) {
                    var f, h;
                    if (sa.isTypedArray(l)) {
                        if (c <= 0) {
                            var d = new l.constructor(0), v = zhe(u, l);
                            c < 0 ? (f = v, h = d) : (f = d, h = v);
                        } else if (f = new l.constructor(c), h = new l.constructor(l.length + u.length - c), c === u.length) f.set(u), h.set(l);
                        else if (c < u.length) {
                            var x = u.length - c;
                            f.set(u.subarray(0, x)), h.set(u.subarray(x)), h.set(l, x);
                        } else {
                            var b = c - u.length;
                            f.set(u), f.set(l.subarray(0, b), u.length), h.set(l.subarray(b));
                        }
                    } else f = u.concat(l), h = c >= 0 && c < f.length ? f.splice(c, f.length) : [];
                    return [
                        f,
                        h
                    ];
                }
                var a = Dhe(e, t, r, n, i), o = pl.redraw(e), s = [
                    e,
                    a.update,
                    r,
                    a.maxPoints
                ];
                return ap.add(e, pl.extendTraces, s, qhe, arguments), o;
            }
            function Ohe(e, t, r) {
                e = sa.getGraphDiv(e);
                var n = [], i = pl.deleteTraces, a = Ohe, o = [
                    e,
                    n
                ], s = [
                    e,
                    t
                ], l, u;
                for(uht(e, t, r), Array.isArray(t) || (t = [
                    t
                ]), t = t.map(function(c) {
                    return sa.extendFlat({}, c);
                }), yh.cleanData(t), l = 0; l < t.length; l++)e.data.push(t[l]);
                for(l = 0; l < t.length; l++)n.push(-t.length + l);
                if (typeof r == "undefined") return u = pl.redraw(e), ap.add(e, i, o, a, s), u;
                Array.isArray(r) || (r = [
                    r
                ]);
                try {
                    Rhe(e, n, r);
                } catch (c) {
                    throw e.data.splice(e.data.length - t.length, t.length), c;
                }
                return ap.startSequence(e), ap.add(e, i, o, a, s), u = pl.moveTraces(e, n, r), ap.stopSequence(e), u;
            }
            function Bhe(e, t) {
                e = sa.getGraphDiv(e);
                var r = [], n = pl.addTraces, i = Bhe, a = [
                    e,
                    r,
                    t
                ], o = [
                    e,
                    t
                ], s, l;
                if (typeof t == "undefined") throw new Error("indices must be an integer or array of integers.");
                for(Array.isArray(t) || (t = [
                    t
                ]), PP(e, t, "indices"), t = LP(t, e.data.length - 1), t.sort(sa.sorterDes), s = 0; s < t.length; s += 1)l = e.data.splice(t[s], 1)[0], r.push(l);
                var u = pl.redraw(e);
                return ap.add(e, n, a, i, o), u;
            }
            function VN(e, t, r) {
                e = sa.getGraphDiv(e);
                var n = [], i = [], a = VN, o = VN, s = [
                    e,
                    r,
                    t
                ], l = [
                    e,
                    t,
                    r
                ], u;
                if (Rhe(e, t, r), t = Array.isArray(t) ? t : [
                    t
                ], typeof r == "undefined") for(r = [], u = 0; u < t.length; u++)r.push(-t.length + u);
                for(r = Array.isArray(r) ? r : [
                    r
                ], t = LP(t, e.data.length - 1), r = LP(r, e.data.length - 1), u = 0; u < e.data.length; u++)t.indexOf(u) === -1 && n.push(e.data[u]);
                for(u = 0; u < t.length; u++)i.push({
                    newIndex: r[u],
                    trace: e.data[t[u]]
                });
                for(i.sort(function(f, h) {
                    return f.newIndex - h.newIndex;
                }), u = 0; u < i.length; u += 1)n.splice(i[u].newIndex, 0, i[u].trace);
                e.data = n;
                var c = pl.redraw(e);
                return ap.add(e, a, s, o, l), c;
            }
            function IP(e, t, r, n) {
                e = sa.getGraphDiv(e), yh.clearPromiseQueue(e);
                var i = {};
                if (typeof t == "string") i[t] = r;
                else if (sa.isPlainObject(t)) i = sa.extendFlat({}, t), n === void 0 && (n = r);
                else return sa.warn("Restyle fail.", t, r, n), Promise.reject();
                Object.keys(i).length && (e.changed = !0);
                var a = yh.coerceTraceIndices(e, n), o = Nhe(e, i, a), s = o.flags;
                s.calc && (e.calcdata = void 0), s.clearAxisTypes && yh.clearAxisTypes(e, a, {});
                var l = [];
                s.fullReplot ? l.push(pl._doPlot) : (l.push(Ho.previousPromises), Ho.supplyDefaults(e), s.markerSize && (Ho.doCalcdata(e), qP(l)), s.style && l.push($l.doTraceStyle), s.colorbars && l.push($l.doColorBars), l.push(BM)), l.push(Ho.rehover, Ho.redrag, Ho.reselect), ap.add(e, IP, [
                    e,
                    o.undoit,
                    o.traces
                ], IP, [
                    e,
                    o.redoit,
                    o.traces
                ]);
                var u = sa.syncOrAsync(l, e);
                return (!u || !u.then) && (u = Promise.resolve()), u.then(function() {
                    return e.emit("plotly_restyle", o.eventData), e;
                });
            }
            function Cy(e) {
                return e === void 0 ? null : e;
            }
            function kP(e, t) {
                return t ? function(r, n, i) {
                    var a = Yu(r, n), o = a.set;
                    return a.set = function(s) {
                        var l = (i || "") + n;
                        RP(l, a.get(), s, e), o(s);
                    }, a;
                } : Yu;
            }
            function RP(e, t, r, n) {
                if (Array.isArray(t) || Array.isArray(r)) for(var i = Array.isArray(t) ? t : [], a = Array.isArray(r) ? r : [], o = Math.max(i.length, a.length), s = 0; s < o; s++)RP(e + "[" + s + "]", i[s], a[s], n);
                else if (sa.isPlainObject(t) || sa.isPlainObject(r)) {
                    var l = sa.isPlainObject(t) ? t : {}, u = sa.isPlainObject(r) ? r : {}, c = sa.extendFlat({}, l, u);
                    for(var f in c)RP(e + "." + f, l[f], u[f], n);
                } else n[e] === void 0 && (n[e] = Cy(t));
            }
            function hht(e, t, r) {
                for(var n in r){
                    var i = Yu(e, n);
                    RP(n, i.get(), r[n], t);
                }
            }
            function Nhe(e, t, r) {
                var n = e._fullLayout, i = e._fullData, a = e.data, o = n._guiEditing, s = kP(n._preGUI, o), l = sa.extendDeepAll({}, t), u, c = p_.traceFlags(), f = {}, h = {}, d;
                function v() {
                    return r.map(function() {});
                }
                function x(me) {
                    var Re = Nv.id2name(me);
                    d.indexOf(Re) === -1 && d.push(Re);
                }
                function b(me) {
                    return "LAYOUT" + me + ".autorange";
                }
                function p(me) {
                    return "LAYOUT" + me + ".range";
                }
                function E(me) {
                    for(var Re = me; Re < i.length; Re++)if (i[Re]._input === a[me]) return i[Re];
                }
                function k(me, Re, ce) {
                    if (Array.isArray(me)) {
                        me.forEach(function(qt) {
                            k(qt, Re, ce);
                        });
                        return;
                    }
                    if (!(me in t || yh.hasParent(t, me))) {
                        var Ge;
                        if (me.substr(0, 6) === "LAYOUT") Ge = s(e.layout, me.replace("LAYOUT", ""));
                        else {
                            var nt = r[ce], ct = n._tracePreGUI[E(nt)._fullInput.uid];
                            Ge = kP(ct, o)(a[nt], me);
                        }
                        me in h || (h[me] = v()), h[me][ce] === void 0 && (h[me][ce] = Cy(Ge.get())), Re !== void 0 && Ge.set(Re);
                    }
                }
                function A(me) {
                    return function(Re) {
                        return i[Re][me];
                    };
                }
                function L(me) {
                    return function(Re, ce) {
                        return Re === !1 ? i[r[ce]][me] : null;
                    };
                }
                for(var _ in t){
                    if (yh.hasParent(t, _)) throw new Error("cannot set " + _ + " and a parent attribute simultaneously");
                    var C = t[_], M, g, P, T, F, q;
                    if ((_ === "autobinx" || _ === "autobiny") && (_ = _.charAt(_.length - 1) + "bins", Array.isArray(C) ? C = C.map(L(_)) : C === !1 ? C = r.map(A(_)) : C = null), f[_] = C, _.substr(0, 6) === "LAYOUT") {
                        P = s(e.layout, _.replace("LAYOUT", "")), h[_] = [
                            Cy(P.get())
                        ], P.set(Array.isArray(C) ? C[0] : C), c.calc = !0;
                        continue;
                    }
                    for(h[_] = v(), u = 0; u < r.length; u++){
                        M = a[r[u]], g = E(r[u]);
                        var V = n._tracePreGUI[g._fullInput.uid];
                        if (P = kP(V, o)(M, _), T = P.get(), F = Array.isArray(C) ? C[u % C.length] : C, F !== void 0) {
                            var H = P.parts[P.parts.length - 1], X = _.substr(0, _.length - H.length - 1), G = X ? X + "." : "", N = X ? Yu(g, X).get() : g;
                            if (q = FP.getTraceValObject(g, P.parts), q && q.impliedEdits && F !== null) for(var W in q.impliedEdits)k(sa.relativeAttr(_, W), q.impliedEdits[W], u);
                            else if ((H === "thicknessmode" || H === "lenmode") && T !== F && (F === "fraction" || F === "pixels") && N) {
                                var re = n._size, ae = N.orient, _e = ae === "top" || ae === "bottom";
                                if (H === "thicknessmode") {
                                    var Me = _e ? re.h : re.w;
                                    k(G + "thickness", N.thickness * (F === "fraction" ? 1 / Me : Me), u);
                                } else {
                                    var ke = _e ? re.w : re.h;
                                    k(G + "len", N.len * (F === "fraction" ? 1 / ke : ke), u);
                                }
                            } else if (_ === "type" && (F === "pie" != (T === "pie") || F === "funnelarea" != (T === "funnelarea"))) {
                                var ge = "x", ie = "y";
                                (F === "bar" || T === "bar") && M.orientation === "h" && (ge = "y", ie = "x"), sa.swapAttrs(M, [
                                    "?",
                                    "?src"
                                ], "labels", ge), sa.swapAttrs(M, [
                                    "d?",
                                    "?0"
                                ], "label", ge), sa.swapAttrs(M, [
                                    "?",
                                    "?src"
                                ], "values", ie), T === "pie" || T === "funnelarea" ? (Yu(M, "marker.color").set(Yu(M, "marker.colors").get()), n._pielayer.selectAll("g.trace").remove()) : L0.traceIs(M, "cartesian") && Yu(M, "marker.colors").set(Yu(M, "marker.color").get());
                            }
                            h[_][u] = Cy(T);
                            var Te = [
                                "swapxy",
                                "swapxyaxes",
                                "orientation",
                                "orientationaxes"
                            ];
                            if (Te.indexOf(_) !== -1) {
                                if (_ === "orientation") {
                                    P.set(F);
                                    var Ee = M.x && !M.y ? "h" : "v";
                                    if ((P.get() || Ee) === g.orientation) continue;
                                } else _ === "orientationaxes" && (M.orientation = ({
                                    v: "h",
                                    h: "v"
                                })[g.orientation]);
                                yh.swapXYData(M), c.calc = c.clearAxisTypes = !0;
                            } else Ho.dataArrayContainers.indexOf(P.parts[0]) !== -1 ? (yh.manageArrayContainers(P, F, h), c.calc = !0) : (q ? q.arrayOk && !L0.traceIs(g, "regl") && (sa.isArrayOrTypedArray(F) || sa.isArrayOrTypedArray(T)) ? c.calc = !0 : p_.update(c, q) : c.calc = !0, P.set(F));
                        }
                    }
                    if ([
                        "swapxyaxes",
                        "orientationaxes"
                    ].indexOf(_) !== -1 && Nv.swap(e, r), _ === "orientationaxes") {
                        var Ae = Yu(e.layout, "hovermode"), ze = Ae.get();
                        ze === "x" ? Ae.set("y") : ze === "y" ? Ae.set("x") : ze === "x unified" ? Ae.set("y unified") : ze === "y unified" && Ae.set("x unified");
                    }
                    if ([
                        "orientation",
                        "type"
                    ].indexOf(_) !== -1) {
                        for(d = [], u = 0; u < r.length; u++){
                            var Ce = a[r[u]];
                            L0.traceIs(Ce, "cartesian") && (x(Ce.xaxis || "x"), x(Ce.yaxis || "y"));
                        }
                        k(d.map(b), !0, 0), k(d.map(p), [
                            0,
                            1
                        ], 0);
                    }
                }
                return (c.calc || c.plot) && (c.fullReplot = !0), {
                    flags: c,
                    undoit: h,
                    redoit: f,
                    traces: r,
                    eventData: sa.extendDeepNoArrays([], [
                        l,
                        r
                    ])
                };
            }
            function OM(e, t, r) {
                e = sa.getGraphDiv(e), yh.clearPromiseQueue(e);
                var n = {};
                if (typeof t == "string") n[t] = r;
                else if (sa.isPlainObject(t)) n = sa.extendFlat({}, t);
                else return sa.warn("Relayout fail.", t, r), Promise.reject();
                Object.keys(n).length && (e.changed = !0);
                var i = Ghe(e, n), a = i.flags;
                a.calc && (e.calcdata = void 0);
                var o = [
                    Ho.previousPromises
                ];
                a.layoutReplot ? o.push($l.layoutReplot) : Object.keys(n).length && (Uhe(e, a, i) || Ho.supplyDefaults(e), a.legend && o.push($l.doLegend), a.layoutstyle && o.push($l.layoutStyles), a.axrange && qP(o, i.rangesAltered), a.ticks && o.push($l.doTicksRelayout), a.modebar && o.push($l.doModeBar), a.camera && o.push($l.doCamera), a.colorbars && o.push($l.doColorBars), o.push(BM)), o.push(Ho.rehover, Ho.redrag, Ho.reselect), ap.add(e, OM, [
                    e,
                    i.undoit
                ], OM, [
                    e,
                    i.redoit
                ]);
                var s = sa.syncOrAsync(o, e);
                return (!s || !s.then) && (s = Promise.resolve(e)), s.then(function() {
                    return e.emit("plotly_relayout", i.eventData), e;
                });
            }
            function Uhe(e, t, r) {
                var n = e._fullLayout;
                if (!t.axrange) return !1;
                for(var i in t)if (i !== "axrange" && t[i]) return !1;
                var a, o, s = function(d, v) {
                    return sa.coerce(a, o, $ft, d, v);
                }, l = {};
                for(var u in r.rangesAltered){
                    var c = Nv.id2name(u);
                    if (a = e.layout[c], o = n[c], Jft(a, o, s, l), o._matchGroup) {
                        for(var f in o._matchGroup)if (f !== u) {
                            var h = n[Nv.id2name(f)];
                            h.autorange = o.autorange, h.range = o.range.slice(), h._input.range = o.range.slice();
                        }
                    }
                }
                return !0;
            }
            function qP(e, t) {
                var r = t ? function(n) {
                    var i = [], a = !0;
                    for(var o in t){
                        var s = Nv.getFromId(n, o);
                        if (i.push(o), (s.ticklabelposition || "").indexOf("inside") !== -1 && s._anchorAxis && i.push(s._anchorAxis._id), s._matchGroup) for(var l in s._matchGroup)t[l] || i.push(l);
                    }
                    return Nv.draw(n, i, {
                        skipTitle: a
                    });
                } : function(n) {
                    return Nv.draw(n, "redraw");
                };
                e.push(rht, $l.doAutoRangeAndConstraints, r, $l.drawData, $l.finalDraw);
            }
            var Vhe = /^[xyz]axis[0-9]*\.range(\[[0|1]\])?$/, Hhe = /^[xyz]axis[0-9]*\.autorange$/, dht = /^[xyz]axis[0-9]*\.domain(\[[0|1]\])?$/;
            function Ghe(e, t) {
                var r = e.layout, n = e._fullLayout, i = n._guiEditing, a = kP(n._preGUI, i), o = Object.keys(t), s = Nv.list(e), l = sa.extendDeepAll({}, t), u = {}, c, f, h;
                for(o = Object.keys(t), f = 0; f < o.length; f++)if (o[f].indexOf("allaxes") === 0) {
                    for(h = 0; h < s.length; h++){
                        var d = s[h]._id.substr(1), v = d.indexOf("scene") !== -1 ? d + "." : "", x = o[f].replace("allaxes", v + s[h]._name);
                        t[x] || (t[x] = t[o[f]]);
                    }
                    delete t[o[f]];
                }
                var b = p_.layoutFlags(), p = {}, E = {};
                function k(ct, qt) {
                    if (Array.isArray(ct)) {
                        ct.forEach(function(ot) {
                            k(ot, qt);
                        });
                        return;
                    }
                    if (!(ct in t || yh.hasParent(t, ct))) {
                        var rt = a(r, ct);
                        ct in E || (E[ct] = Cy(rt.get())), qt !== void 0 && rt.set(qt);
                    }
                }
                var A = {}, L;
                function _(ct) {
                    var qt = Nv.name2id(ct.split(".")[0]);
                    return A[qt] = 1, qt;
                }
                for(var C in t){
                    if (yh.hasParent(t, C)) throw new Error("cannot set " + C + " and a parent attribute simultaneously");
                    for(var M = a(r, C), g = t[C], P = M.parts.length, T = P - 1; T > 0 && typeof M.parts[T] != "string";)T--;
                    var F = M.parts[T], q = M.parts[T - 1] + "." + F, V = M.parts.slice(0, T).join("."), H = Yu(e.layout, V).get(), X = Yu(n, V).get(), G = M.get();
                    if (g !== void 0) {
                        p[C] = g, E[C] = F === "reverse" ? g : Cy(G);
                        var N = FP.getLayoutValObject(n, M.parts);
                        if (N && N.impliedEdits && g !== null) for(var W in N.impliedEdits)k(sa.relativeAttr(C, W), N.impliedEdits[W]);
                        if ([
                            "width",
                            "height"
                        ].indexOf(C) !== -1) {
                            if (g) {
                                k("autosize", null);
                                var re = C === "height" ? "width" : "height";
                                k(re, n[re]);
                            } else n[C] = e._initialAutoSize[C];
                        } else if (C === "autosize") k("width", g ? null : n.width), k("height", g ? null : n.height);
                        else if (q.match(Vhe)) _(q), Yu(n, V + "._inputRange").set(null);
                        else if (q.match(Hhe)) {
                            _(q), Yu(n, V + "._inputRange").set(null);
                            var ae = Yu(n, V).get();
                            ae._inputDomain && (ae._input.domain = ae._inputDomain.slice());
                        } else q.match(dht) && Yu(n, V + "._inputDomain").set(null);
                        if (F === "type") {
                            L = H;
                            var _e = X.type === "linear" && g === "log", Me = X.type === "log" && g === "linear";
                            if (_e || Me) {
                                if (!L || !L.range) k(V + ".autorange", !0);
                                else if (X.autorange) _e && (L.range = L.range[1] > L.range[0] ? [
                                    1,
                                    2
                                ] : [
                                    2,
                                    1
                                ]);
                                else {
                                    var ke = L.range[0], ge = L.range[1];
                                    _e ? (ke <= 0 && ge <= 0 && k(V + ".autorange", !0), ke <= 0 ? ke = ge / 1e6 : ge <= 0 && (ge = ke / 1e6), k(V + ".range[0]", Math.log(ke) / Math.LN10), k(V + ".range[1]", Math.log(ge) / Math.LN10)) : (k(V + ".range[0]", Math.pow(10, ke)), k(V + ".range[1]", Math.pow(10, ge)));
                                }
                                Array.isArray(n._subplots.polar) && n._subplots.polar.length && n[M.parts[0]] && M.parts[1] === "radialaxis" && delete n[M.parts[0]]._subplot.viewInitial["radialaxis.range"], L0.getComponentMethod("annotations", "convertCoords")(e, X, g, k), L0.getComponentMethod("images", "convertCoords")(e, X, g, k);
                            } else k(V + ".autorange", !0), k(V + ".range", null);
                            Yu(n, V + "._inputRange").set(null);
                        } else if (F.match(iht)) {
                            var ie = Yu(n, C).get(), Te = (g || {}).type;
                            (!Te || Te === "-") && (Te = "linear"), L0.getComponentMethod("annotations", "convertCoords")(e, ie, Te, k), L0.getComponentMethod("images", "convertCoords")(e, ie, Te, k);
                        }
                        var Ee = EP.containerArrayMatch(C);
                        if (Ee) {
                            c = Ee.array, f = Ee.index;
                            var Ae = Ee.property, ze = N || {
                                editType: "calc"
                            };
                            f !== "" && Ae === "" && (EP.isAddVal(g) ? E[C] = null : EP.isRemoveVal(g) ? E[C] = (Yu(r, c).get() || [])[f] : sa.warn("unrecognized full object value", t)), p_.update(b, ze), u[c] || (u[c] = {});
                            var Ce = u[c][f];
                            Ce || (Ce = u[c][f] = {}), Ce[Ae] = g, delete t[C];
                        } else F === "reverse" ? (H.range ? H.range.reverse() : (k(V + ".autorange", !0), H.range = [
                            1,
                            0
                        ]), X.autorange ? b.calc = !0 : b.plot = !0) : (C === "dragmode" && (g === !1 && G !== !1 || g !== !1 && G === !1) || n._has("scatter-like") && n._has("regl") && C === "dragmode" && (g === "lasso" || g === "select") && !(G === "lasso" || G === "select") ? b.plot = !0 : N ? p_.update(b, N) : b.calc = !0, M.set(g));
                    }
                }
                for(c in u){
                    var me = EP.applyContainerArrayChanges(e, a(r, c), u[c], b, a);
                    me || (b.plot = !0);
                }
                for(var Re in A){
                    L = Nv.getFromId(e, Re);
                    var ce = L && L._constraintGroup;
                    if (ce) {
                        b.calc = !0;
                        for(var Ge in ce)A[Ge] || (Nv.getFromId(e, Ge)._constraintShrinkable = !0);
                    }
                }
                (jhe(e) || t.height || t.width) && (b.plot = !0);
                var nt = n.shapes;
                for(f = 0; f < nt.length; f++)if (nt[f].showlegend) {
                    b.calc = !0;
                    break;
                }
                return (b.plot || b.calc) && (b.layoutReplot = !0), {
                    flags: b,
                    rangesAltered: A,
                    undoit: E,
                    redoit: p,
                    eventData: l
                };
            }
            function jhe(e) {
                var t = e._fullLayout, r = t.width, n = t.height;
                return e.layout.autosize && Ho.plotAutoSize(e, e.layout, t), t.width !== r || t.height !== n;
            }
            function DP(e, t, r, n) {
                e = sa.getGraphDiv(e), yh.clearPromiseQueue(e), sa.isPlainObject(t) || (t = {}), sa.isPlainObject(r) || (r = {}), Object.keys(t).length && (e.changed = !0), Object.keys(r).length && (e.changed = !0);
                var i = yh.coerceTraceIndices(e, n), a = Nhe(e, sa.extendFlat({}, t), i), o = a.flags, s = Ghe(e, sa.extendFlat({}, r)), l = s.flags;
                (o.calc || l.calc) && (e.calcdata = void 0), o.clearAxisTypes && yh.clearAxisTypes(e, i, r);
                var u = [];
                l.layoutReplot ? u.push($l.layoutReplot) : o.fullReplot ? u.push(pl._doPlot) : (u.push(Ho.previousPromises), Uhe(e, l, s) || Ho.supplyDefaults(e), o.style && u.push($l.doTraceStyle), (o.colorbars || l.colorbars) && u.push($l.doColorBars), l.legend && u.push($l.doLegend), l.layoutstyle && u.push($l.layoutStyles), l.axrange && qP(u, s.rangesAltered), l.ticks && u.push($l.doTicksRelayout), l.modebar && u.push($l.doModeBar), l.camera && u.push($l.doCamera), u.push(BM)), u.push(Ho.rehover, Ho.redrag, Ho.reselect), ap.add(e, DP, [
                    e,
                    a.undoit,
                    s.undoit,
                    a.traces
                ], DP, [
                    e,
                    a.redoit,
                    s.redoit,
                    a.traces
                ]);
                var c = sa.syncOrAsync(u, e);
                return (!c || !c.then) && (c = Promise.resolve(e)), c.then(function() {
                    return e.emit("plotly_update", {
                        data: a.eventData,
                        layout: s.eventData
                    }), e;
                });
            }
            function GN(e) {
                return function(r) {
                    r._fullLayout._guiEditing = !0;
                    var n = e.apply(null, arguments);
                    return r._fullLayout._guiEditing = !1, n;
                };
            }
            var vht = [
                {
                    pattern: /^hiddenlabels/,
                    attr: "legend.uirevision"
                },
                {
                    pattern: /^((x|y)axis\d*)\.((auto)?range|title\.text)/
                },
                {
                    pattern: /axis\d*\.showspikes$/,
                    attr: "modebar.uirevision"
                },
                {
                    pattern: /(hover|drag)mode$/,
                    attr: "modebar.uirevision"
                },
                {
                    pattern: /^(scene\d*)\.camera/
                },
                {
                    pattern: /^(geo\d*)\.(projection|center|fitbounds)/
                },
                {
                    pattern: /^(ternary\d*\.[abc]axis)\.(min|title\.text)$/
                },
                {
                    pattern: /^(polar\d*\.radialaxis)\.((auto)?range|angle|title\.text)/
                },
                {
                    pattern: /^(polar\d*\.angularaxis)\.rotation/
                },
                {
                    pattern: /^(mapbox\d*)\.(center|zoom|bearing|pitch)/
                },
                {
                    pattern: /^(map\d*)\.(center|zoom|bearing|pitch)/
                },
                {
                    pattern: /^legend\.(x|y)$/,
                    attr: "editrevision"
                },
                {
                    pattern: /^(shapes|annotations)/,
                    attr: "editrevision"
                },
                {
                    pattern: /^title\.text$/,
                    attr: "editrevision"
                }
            ], pht = [
                {
                    pattern: /^selectedpoints$/,
                    attr: "selectionrevision"
                },
                {
                    pattern: /(^|value\.)visible$/,
                    attr: "legend.uirevision"
                },
                {
                    pattern: /^dimensions\[\d+\]\.constraintrange/
                },
                {
                    pattern: /^node\.(x|y|groups)/
                },
                {
                    pattern: /^level$/
                },
                {
                    pattern: /(^|value\.)name$/
                },
                {
                    pattern: /colorbar\.title\.text$/
                },
                {
                    pattern: /colorbar\.(x|y)$/,
                    attr: "editrevision"
                }
            ];
            function Ehe(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r], i = e.match(n.pattern);
                    if (i) {
                        var a = i[1] || "";
                        return {
                            head: a,
                            tail: e.substr(a.length + 1),
                            attr: n.attr
                        };
                    }
                }
            }
            function khe(e, t) {
                var r = Yu(t, e).get();
                if (r !== void 0) return r;
                var n = e.split(".");
                for(n.pop(); n.length > 1;)if (n.pop(), r = Yu(t, n.join(".") + ".uirevision").get(), r !== void 0) return r;
                return t.uirevision;
            }
            function ght(e, t) {
                for(var r = 0; r < t.length; r++)if (t[r]._fullInput.uid === e) return r;
                return -1;
            }
            function mht(e, t, r) {
                for(var n = 0; n < t.length; n++)if (t[n].uid === e) return n;
                return !t[r] || t[r].uid ? -1 : r;
            }
            function Che(e, t) {
                var r = sa.isPlainObject(e), n = Array.isArray(e);
                return r || n ? (r && sa.isPlainObject(t) || n && Array.isArray(t)) && JSON.stringify(e) === JSON.stringify(t) : e === t;
            }
            function yht(e, t, r, n) {
                var i = n._preGUI, a, o, s, l, u, c, f, h, d, v, x = [], b = {}, p = {};
                for(a in i){
                    if (u = Ehe(a, vht), u) {
                        if (d = u.head, v = u.tail, o = u.attr || d + ".uirevision", s = Yu(n, o).get(), l = s && khe(o, t), l && l === s) {
                            if (c = i[a], c === null && (c = void 0), f = Yu(t, a), h = f.get(), Che(h, c)) {
                                h === void 0 && v === "autorange" && x.push(d), f.set(Cy(Yu(n, a).get()));
                                continue;
                            } else if (v === "autorange" || v.substr(0, 6) === "range[") {
                                var E = i[d + ".range[0]"], k = i[d + ".range[1]"], A = i[d + ".autorange"];
                                if (A || A === null && E === null && k === null) {
                                    if (!(d in b)) {
                                        var L = Yu(t, d).get();
                                        b[d] = L && (L.autorange || L.autorange !== !1 && (!L.range || L.range.length !== 2));
                                    }
                                    if (b[d]) {
                                        f.set(Cy(Yu(n, a).get()));
                                        continue;
                                    }
                                }
                            }
                        }
                    } else sa.warn("unrecognized GUI edit: " + a);
                    delete i[a], u && u.tail.substr(0, 6) === "range[" && (p[u.head] = 1);
                }
                for(var _ = 0; _ < x.length; _++){
                    var C = x[_];
                    if (p[C]) {
                        var M = Yu(t, C).get();
                        M && delete M.autorange;
                    }
                }
                var g = n._tracePreGUI;
                for(var P in g){
                    var T = g[P], F = null, q;
                    for(a in T){
                        if (!F) {
                            var V = ght(P, r);
                            if (V < 0) {
                                delete g[P];
                                break;
                            }
                            var H = r[V];
                            q = H._fullInput;
                            var X = mht(P, e, q.index);
                            if (X < 0) {
                                delete g[P];
                                break;
                            }
                            F = e[X];
                        }
                        if (u = Ehe(a, pht), u) {
                            if (u.attr ? (s = Yu(n, u.attr).get(), l = s && khe(u.attr, t)) : (s = q.uirevision, l = F.uirevision, l === void 0 && (l = t.uirevision)), l && l === s && (c = T[a], c === null && (c = void 0), f = Yu(F, a), h = f.get(), Che(h, c))) {
                                f.set(Cy(Yu(q, a).get()));
                                continue;
                            }
                        } else sa.warn("unrecognized GUI edit: " + a + " in trace uid " + P);
                        delete T[a];
                    }
                }
            }
            function _ht(e, t, r, n) {
                var i, a;
                function o() {
                    return pl.addFrames(e, i);
                }
                e = sa.getGraphDiv(e), yh.clearPromiseQueue(e);
                var s = e._fullData, l = e._fullLayout;
                if (!sa.isPlotDiv(e) || !s || !l) a = pl.newPlot(e, t, r, n);
                else {
                    if (sa.isPlainObject(t)) {
                        var u = t;
                        t = u.data, r = u.layout, n = u.config, i = u.frames;
                    }
                    var c = !1;
                    if (n) {
                        var f = sa.extendDeep({}, e._context);
                        e._context = void 0, Ihe(e, n), c = HN(f, e._context);
                    }
                    e.data = t || [], yh.cleanData(e.data), e.layout = r || {}, yh.cleanLayout(e.layout), yht(e.data, e.layout, s, l), Ho.supplyDefaults(e, {
                        skipUpdateCalc: !0
                    });
                    var h = e._fullData, d = e._fullLayout, v = d.datarevision === void 0, x = d.transition, b = bht(e, l, d, v, x), p = b.newDataRevision, E = xht(e, s, h, v, x, p);
                    if (jhe(e) && (b.layoutReplot = !0), E.calc || b.calc) {
                        e.calcdata = void 0;
                        for(var k = Object.getOwnPropertyNames(d), A = 0; A < k.length; A++){
                            var L = k[A], _ = L.substring(0, 5);
                            if (_ === "xaxis" || _ === "yaxis") {
                                var C = d[L]._emptyCategories;
                                C && C();
                            }
                        }
                    } else Ho.supplyDefaultsUpdateCalc(e.calcdata, h);
                    var M = [];
                    if (i && (e._transitionData = {}, Ho.createTransitionData(e), M.push(o)), d.transition && !c && (E.anim || b.anim)) b.ticks && M.push($l.doTicksRelayout), Ho.doCalcdata(e), $l.doAutoRangeAndConstraints(e), M.push(function() {
                        return Ho.transitionFromReact(e, E, b, l);
                    });
                    else if (E.fullReplot || b.layoutReplot || c) e._fullLayout._skipDefaults = !0, M.push(pl._doPlot);
                    else {
                        for(var g in b.arrays){
                            var P = b.arrays[g];
                            if (P.length) {
                                var T = L0.getComponentMethod(g, "drawOne");
                                if (T !== sa.noop) for(var F = 0; F < P.length; F++)T(e, P[F]);
                                else {
                                    var q = L0.getComponentMethod(g, "draw");
                                    if (q === sa.noop) throw new Error("cannot draw components: " + g);
                                    q(e);
                                }
                            }
                        }
                        M.push(Ho.previousPromises), E.style && M.push($l.doTraceStyle), (E.colorbars || b.colorbars) && M.push($l.doColorBars), b.legend && M.push($l.doLegend), b.layoutstyle && M.push($l.layoutStyles), b.axrange && qP(M), b.ticks && M.push($l.doTicksRelayout), b.modebar && M.push($l.doModeBar), b.camera && M.push($l.doCamera), M.push(BM);
                    }
                    M.push(Ho.rehover, Ho.redrag, Ho.reselect), a = sa.syncOrAsync(M, e), (!a || !a.then) && (a = Promise.resolve(e));
                }
                return a.then(function() {
                    return e.emit("plotly_react", {
                        data: t,
                        layout: r
                    }), e;
                });
            }
            function xht(e, t, r, n, i, a) {
                var o = t.length === r.length;
                if (!i && !o) return {
                    fullReplot: !0,
                    calc: !0
                };
                var s = p_.traceFlags();
                s.arrays = {}, s.nChanges = 0, s.nChangesAnim = 0;
                var l, u;
                function c(d) {
                    var v = FP.getTraceValObject(u, d);
                    return !u._module.animatable && v.anim && (v.anim = !1), v;
                }
                var f = {
                    getValObject: c,
                    flags: s,
                    immutable: n,
                    transition: i,
                    newDataRevision: a,
                    gd: e
                }, h = {};
                for(l = 0; l < t.length; l++)if (r[l]) {
                    if (u = r[l]._fullInput, h[u.uid]) continue;
                    h[u.uid] = 1, zP(t[l]._fullInput, u, [], f);
                }
                return (s.calc || s.plot) && (s.fullReplot = !0), i && s.nChanges && s.nChangesAnim && (s.anim = s.nChanges === s.nChangesAnim && o ? "all" : "some"), s;
            }
            function bht(e, t, r, n, i) {
                var a = p_.layoutFlags();
                a.arrays = {}, a.rangesAltered = {}, a.nChanges = 0, a.nChangesAnim = 0;
                function o(h) {
                    return FP.getLayoutValObject(r, h);
                }
                for(var s in r)if (!(!s.startsWith("xaxis") && !s.startsWith("yaxis")) && t[s]) {
                    var l = r[s].domain, u = t[s].domain, c = t[s]._inputDomain;
                    t[s]._inputDomain && (l[0] === c[0] && l[1] === c[1] ? r[s].domain = t[s].domain : (l[0] !== u[0] || l[1] !== u[1]) && (r[s]._inputDomain = null));
                }
                var f = {
                    getValObject: o,
                    flags: a,
                    immutable: n,
                    transition: i,
                    gd: e
                };
                return zP(t, r, [], f), (a.plot || a.calc) && (a.layoutReplot = !0), i && a.nChanges && a.nChangesAnim && (a.anim = a.nChanges === a.nChangesAnim ? "all" : "some"), a;
            }
            function zP(e, t, r, n) {
                var i, a, o, s = n.getValObject, l = n.flags, u = n.immutable, c = n.inArray, f = n.arrayIndex;
                function h() {
                    var V = i.editType;
                    if (c && V.indexOf("arraydraw") !== -1) {
                        sa.pushUnique(l.arrays[c], f);
                        return;
                    }
                    p_.update(l, i), V !== "none" && l.nChanges++, n.transition && i.anim && l.nChangesAnim++, (Vhe.test(o) || Hhe.test(o)) && (l.rangesAltered[r[0]] = 1), a === "datarevision" && (l.newDataRevision = 1);
                }
                function d(V) {
                    return V.valType === "data_array" || V.arrayOk;
                }
                for(a in e){
                    if (l.calc && !n.transition) return;
                    var v = e[a], x = t[a], b = r.concat(a);
                    if (o = b.join("."), !(a.charAt(0) === "_" || typeof v == "function" || v === x)) {
                        if ((a === "tick0" || a === "dtick") && r[0] !== "geo") {
                            var p = t.tickmode;
                            if (p === "auto" || p === "array" || !p) continue;
                        }
                        if (!(a === "range" && t.autorange) && !((a === "zmin" || a === "zmax") && t.type === "contourcarpet") && (i = s(b), !!i && !(i._compareAsJSON && JSON.stringify(v) === JSON.stringify(x)))) {
                            var E = i.valType, k, A = d(i), L = Array.isArray(v), _ = Array.isArray(x);
                            if (L && _) {
                                var C = "_input_" + a, M = e[C], g = t[C];
                                if (Array.isArray(M) && M === g) continue;
                            }
                            if (x === void 0) A && L ? l.calc = !0 : h();
                            else if (i._isLinkedToArray) {
                                var P = [], T = !1;
                                c || (l.arrays[a] = P);
                                var F = Math.min(v.length, x.length), q = Math.max(v.length, x.length);
                                if (F !== q) {
                                    if (i.editType === "arraydraw") T = !0;
                                    else {
                                        h();
                                        continue;
                                    }
                                }
                                for(k = 0; k < F; k++)zP(v[k], x[k], b.concat(k), sa.extendFlat({
                                    inArray: a,
                                    arrayIndex: k
                                }, n));
                                if (T) for(k = F; k < q; k++)P.push(k);
                            } else !E && sa.isPlainObject(v) ? zP(v, x, b, n) : A ? L && _ ? (u && (l.calc = !0), (u || n.newDataRevision) && h()) : L !== _ ? l.calc = !0 : h() : L && _ ? (v.length !== x.length || String(v) !== String(x)) && h() : h();
                        }
                    }
                }
                for(a in t)if (!(a in e || a.charAt(0) === "_" || typeof t[a] == "function")) {
                    if (i = s(r.concat(a)), d(i) && Array.isArray(t[a])) {
                        l.calc = !0;
                        return;
                    } else h();
                }
            }
            function HN(e, t) {
                var r;
                for(r in e)if (r.charAt(0) !== "_") {
                    var n = e[r], i = t[r];
                    if (n !== i) {
                        if (sa.isPlainObject(n) && sa.isPlainObject(i)) {
                            if (HN(n, i)) return !0;
                        } else if (Array.isArray(n) && Array.isArray(i)) {
                            if (n.length !== i.length) return !0;
                            for(var a = 0; a < n.length; a++)if (n[a] !== i[a]) {
                                if (sa.isPlainObject(n[a]) && sa.isPlainObject(i[a])) {
                                    if (HN(n[a], i[a])) return !0;
                                } else return !0;
                            }
                        } else return !0;
                    }
                }
            }
            function wht(e, t, r) {
                if (e = sa.getGraphDiv(e), !sa.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before animating it. For more details, see https://plotly.com/javascript/animations/");
                var n = e._transitionData;
                n._frameQueue || (n._frameQueue = []), r = Ho.supplyAnimationDefaults(r);
                var i = r.transition, a = r.frame;
                n._frameWaitingCnt === void 0 && (n._frameWaitingCnt = 0);
                function o(u) {
                    return Array.isArray(i) ? u >= i.length ? i[0] : i[u] : i;
                }
                function s(u) {
                    return Array.isArray(a) ? u >= a.length ? a[0] : a[u] : a;
                }
                function l(u, c) {
                    var f = 0;
                    return function() {
                        if (u && ++f === c) return u();
                    };
                }
                return new Promise(function(u, c) {
                    function f() {
                        if (n._frameQueue.length !== 0) {
                            for(; n._frameQueue.length;){
                                var F = n._frameQueue.pop();
                                F.onInterrupt && F.onInterrupt();
                            }
                            e.emit("plotly_animationinterrupted", []);
                        }
                    }
                    function h(F) {
                        if (F.length !== 0) {
                            for(var q = 0; q < F.length; q++){
                                var V;
                                F[q].type === "byname" ? V = Ho.computeFrame(e, F[q].name) : V = F[q].data;
                                var H = s(q), X = o(q);
                                X.duration = Math.min(X.duration, H.duration);
                                var G = {
                                    frame: V,
                                    name: F[q].name,
                                    frameOpts: H,
                                    transitionOpts: X
                                };
                                q === F.length - 1 && (G.onComplete = l(u, 2), G.onInterrupt = c), n._frameQueue.push(G);
                            }
                            r.mode === "immediate" && (n._lastFrameAt = -1 / 0), n._animationRaf || x();
                        }
                    }
                    function d() {
                        e.emit("plotly_animated"), window.cancelAnimationFrame(n._animationRaf), n._animationRaf = null;
                    }
                    function v() {
                        n._currentFrame && n._currentFrame.onComplete && n._currentFrame.onComplete();
                        var F = n._currentFrame = n._frameQueue.shift();
                        if (F) {
                            var q = F.name ? F.name.toString() : null;
                            e._fullLayout._currentFrame = q, n._lastFrameAt = Date.now(), n._timeToNext = F.frameOpts.duration, Ho.transition(e, F.frame.data, F.frame.layout, yh.coerceTraceIndices(e, F.frame.traces), F.frameOpts, F.transitionOpts).then(function() {
                                F.onComplete && F.onComplete();
                            }), e.emit("plotly_animatingframe", {
                                name: q,
                                frame: F.frame,
                                animation: {
                                    frame: F.frameOpts,
                                    transition: F.transitionOpts
                                }
                            });
                        } else d();
                    }
                    function x() {
                        e.emit("plotly_animating"), n._lastFrameAt = -1 / 0, n._timeToNext = 0, n._runningTransitions = 0, n._currentFrame = null;
                        var F = function() {
                            n._animationRaf = window.requestAnimationFrame(F), Date.now() - n._lastFrameAt > n._timeToNext && v();
                        };
                        F();
                    }
                    var b = 0;
                    function p(F) {
                        return Array.isArray(i) ? b >= i.length ? F.transitionOpts = i[b] : F.transitionOpts = i[0] : F.transitionOpts = i, b++, F;
                    }
                    var E, k, A = [], L = t == null, _ = Array.isArray(t), C = !L && !_ && sa.isPlainObject(t);
                    if (C) A.push({
                        type: "object",
                        data: p(sa.extendFlat({}, t))
                    });
                    else if (L || [
                        "string",
                        "number"
                    ].indexOf(typeof t) !== -1) for(E = 0; E < n._frames.length; E++)k = n._frames[E], k && (L || String(k.group) === String(t)) && A.push({
                        type: "byname",
                        name: String(k.name),
                        data: p({
                            name: k.name
                        })
                    });
                    else if (_) for(E = 0; E < t.length; E++){
                        var M = t[E];
                        [
                            "number",
                            "string"
                        ].indexOf(typeof M) !== -1 ? (M = String(M), A.push({
                            type: "byname",
                            name: M,
                            data: p({
                                name: M
                            })
                        })) : sa.isPlainObject(M) && A.push({
                            type: "object",
                            data: p(sa.extendFlat({}, M))
                        });
                    }
                    for(E = 0; E < A.length; E++)if (k = A[E], k.type === "byname" && !n._frameHash[k.data.name]) {
                        sa.warn('animate failure: frame not found: "' + k.data.name + '"'), c();
                        return;
                    }
                    [
                        "next",
                        "immediate"
                    ].indexOf(r.mode) !== -1 && f(), r.direction === "reverse" && A.reverse();
                    var g = e._fullLayout._currentFrame;
                    if (g && r.fromcurrent) {
                        var P = -1;
                        for(E = 0; E < A.length; E++)if (k = A[E], k.type === "byname" && k.name === g) {
                            P = E;
                            break;
                        }
                        if (P > 0 && P < A.length - 1) {
                            var T = [];
                            for(E = 0; E < A.length; E++)k = A[E], (A[E].type !== "byname" || E > P) && T.push(k);
                            A = T;
                        }
                    }
                    A.length > 0 ? h(A) : (e.emit("plotly_animated"), u());
                });
            }
            function Tht(e, t, r) {
                if (e = sa.getGraphDiv(e), t == null) return Promise.resolve();
                if (!sa.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e + ". It's likely that you've failed to create a plot before adding frames. For more details, see https://plotly.com/javascript/animations/");
                var n, i, a, o, s = e._transitionData._frames, l = e._transitionData._frameHash;
                if (!Array.isArray(t)) throw new Error("addFrames failure: frameList must be an Array of frame definitions" + t);
                var u = s.length + t.length * 2, c = [], f = {};
                for(n = t.length - 1; n >= 0; n--)if (sa.isPlainObject(t[n])) {
                    var h = t[n].name, d = (l[h] || f[h] || {}).name, v = t[n].name, x = l[d] || f[d];
                    d && v && typeof v == "number" && x && NN < Mhe && (NN++, sa.warn('addFrames: overwriting frame "' + (l[d] || f[d]).name + '" with a frame whose name of type "number" also equates to "' + d + '". This is valid but may potentially lead to unexpected behavior since all plotly.js frame names are stored internally as strings.'), NN === Mhe && sa.warn("addFrames: This API call has yielded too many of these warnings. For the rest of this call, further warnings about numeric frame names will be suppressed.")), f[h] = {
                        name: h
                    }, c.push({
                        frame: Ho.supplyFrameDefaults(t[n]),
                        index: r && r[n] !== void 0 && r[n] !== null ? r[n] : u + n
                    });
                }
                c.sort(function(C, M) {
                    return C.index > M.index ? -1 : C.index < M.index ? 1 : 0;
                });
                var b = [], p = [], E = s.length;
                for(n = c.length - 1; n >= 0; n--){
                    if (i = c[n].frame, typeof i.name == "number" && sa.warn("Warning: addFrames accepts frames with numeric names, but the numbers areimplicitly cast to strings"), !i.name) for(; l[i.name = "frame " + e._transitionData._counter++];);
                    if (l[i.name]) {
                        for(a = 0; a < s.length && (s[a] || {}).name !== i.name; a++);
                        b.push({
                            type: "replace",
                            index: a,
                            value: i
                        }), p.unshift({
                            type: "replace",
                            index: a,
                            value: s[a]
                        });
                    } else o = Math.max(0, Math.min(c[n].index, E)), b.push({
                        type: "insert",
                        index: o,
                        value: i
                    }), p.unshift({
                        type: "delete",
                        index: o
                    }), E++;
                }
                var k = Ho.modifyFrames, A = Ho.modifyFrames, L = [
                    e,
                    p
                ], _ = [
                    e,
                    b
                ];
                return ap && ap.add(e, k, L, A, _), Ho.modifyFrames(e, b);
            }
            function Aht(e, t) {
                if (e = sa.getGraphDiv(e), !sa.isPlotDiv(e)) throw new Error("This element is not a Plotly plot: " + e);
                var r, n, i = e._transitionData._frames, a = [], o = [];
                if (!t) for(t = [], r = 0; r < i.length; r++)t.push(r);
                for(t = t.slice(), t.sort(), r = t.length - 1; r >= 0; r--)n = t[r], a.push({
                    type: "delete",
                    index: n
                }), o.unshift({
                    type: "insert",
                    index: n,
                    value: i[n]
                });
                var s = Ho.modifyFrames, l = Ho.modifyFrames, u = [
                    e,
                    o
                ], c = [
                    e,
                    a
                ];
                return ap && ap.add(e, s, u, l, c), Ho.modifyFrames(e, a);
            }
            function Sht(e) {
                e = sa.getGraphDiv(e);
                var t = e._fullLayout || {}, r = e._fullData || [];
                return Ho.cleanPlot([], {}, r, t), Ho.purge(e), UN.purge(e), t._container && t._container.remove(), delete e._context, e;
            }
            function Mht(e) {
                var t = e._fullLayout, r = e.getBoundingClientRect();
                if (!sa.equalDomRects(r, t._lastBBox)) {
                    var n = t._invTransform = sa.inverseTransformMatrix(sa.getFullTransformMatrix(e));
                    t._invScaleX = Math.sqrt(n[0][0] * n[0][0] + n[0][1] * n[0][1] + n[0][2] * n[0][2]), t._invScaleY = Math.sqrt(n[1][0] * n[1][0] + n[1][1] * n[1][1] + n[1][2] * n[1][2]), t._lastBBox = r;
                }
            }
            function Eht(e) {
                var t = CP.select(e), r = e._fullLayout;
                if (r._calcInverseTransform = Mht, r._calcInverseTransform(e), r._container = t.selectAll(".plot-container").data([
                    0
                ]), r._container.enter().insert("div", ":first-child").classed("plot-container", !0).classed("plotly", !0).style({
                    width: "100%",
                    height: "100%"
                }), r._paperdiv = r._container.selectAll(".svg-container").data([
                    0
                ]), r._paperdiv.enter().append("div").classed("user-select-none", !0).classed("svg-container", !0).style("position", "relative"), r._glcontainer = r._paperdiv.selectAll(".gl-container").data([
                    {}
                ]), r._glcontainer.enter().append("div").classed("gl-container", !0), r._paperdiv.selectAll(".main-svg").remove(), r._paperdiv.select(".modebar-container").remove(), r._paper = r._paperdiv.insert("svg", ":first-child").classed("main-svg", !0), r._toppaper = r._paperdiv.append("svg").classed("main-svg", !0), r._modebardiv = r._paperdiv.append("div"), delete r._modeBar, r._hoverpaper = r._paperdiv.append("svg").classed("main-svg", !0), !r._uid) {
                    var n = {};
                    CP.selectAll("defs").each(function() {
                        this.id && (n[this.id.split("-")[1]] = 1);
                    }), r._uid = sa.randstr(n);
                }
                r._paperdiv.selectAll(".main-svg").attr(tht.svgAttrs), r._defs = r._paper.append("defs").attr("id", "defs-" + r._uid), r._clips = r._defs.append("g").classed("clips", !0), r._topdefs = r._toppaper.append("defs").attr("id", "topdefs-" + r._uid), r._topclips = r._topdefs.append("g").classed("clips", !0), r._bgLayer = r._paper.append("g").classed("bglayer", !0), r._draggers = r._paper.append("g").classed("draglayer", !0);
                var i = r._paper.append("g").classed("layer-below", !0);
                r._imageLowerLayer = i.append("g").classed("imagelayer", !0), r._shapeLowerLayer = i.append("g").classed("shapelayer", !0), r._cartesianlayer = r._paper.append("g").classed("cartesianlayer", !0), r._polarlayer = r._paper.append("g").classed("polarlayer", !0), r._smithlayer = r._paper.append("g").classed("smithlayer", !0), r._ternarylayer = r._paper.append("g").classed("ternarylayer", !0), r._geolayer = r._paper.append("g").classed("geolayer", !0), r._funnelarealayer = r._paper.append("g").classed("funnelarealayer", !0), r._pielayer = r._paper.append("g").classed("pielayer", !0), r._iciclelayer = r._paper.append("g").classed("iciclelayer", !0), r._treemaplayer = r._paper.append("g").classed("treemaplayer", !0), r._sunburstlayer = r._paper.append("g").classed("sunburstlayer", !0), r._indicatorlayer = r._toppaper.append("g").classed("indicatorlayer", !0), r._glimages = r._paper.append("g").classed("glimages", !0);
                var a = r._toppaper.append("g").classed("layer-above", !0);
                r._imageUpperLayer = a.append("g").classed("imagelayer", !0), r._shapeUpperLayer = a.append("g").classed("shapelayer", !0), r._selectionLayer = r._toppaper.append("g").classed("selectionlayer", !0), r._infolayer = r._toppaper.append("g").classed("infolayer", !0), r._menulayer = r._toppaper.append("g").classed("menulayer", !0), r._zoomlayer = r._toppaper.append("g").classed("zoomlayer", !0), r._hoverlayer = r._hoverpaper.append("g").classed("hoverlayer", !0), r._modebardiv.classed("modebar-container", !0).style("position", "absolute").style("top", "0px").style("right", "0px"), e.emit("plotly_framework");
            }
            pl.animate = wht;
            pl.addFrames = Tht;
            pl.deleteFrames = Aht;
            pl.addTraces = Ohe;
            pl.deleteTraces = Bhe;
            pl.extendTraces = Fhe;
            pl.moveTraces = VN;
            pl.prependTraces = qhe;
            pl.newPlot = lht;
            pl._doPlot = nht;
            pl.purge = Sht;
            pl.react = _ht;
            pl.redraw = sht;
            pl.relayout = OM;
            pl.restyle = IP;
            pl.setPlotConfig = aht;
            pl.update = DP;
            pl._guiRelayout = GN(OM);
            pl._guiRestyle = GN(IP);
            pl._guiUpdate = GN(DP);
            pl._storeDirectGUIEdit = hht;
        });
        var Ly = ye((Mm)=>{
            "use strict";
            var kht = ba();
            Mm.getDelay = function(e) {
                return e._has && (e._has("gl3d") || e._has("mapbox") || e._has("map")) ? 500 : 0;
            };
            Mm.getRedrawFunc = function(e) {
                return function() {
                    kht.getComponentMethod("colorbar", "draw")(e);
                };
            };
            Mm.encodeSVG = function(e) {
                return "data:image/svg+xml," + encodeURIComponent(e);
            };
            Mm.encodeJSON = function(e) {
                return "data:application/json," + encodeURIComponent(e);
            };
            var Whe = window.URL || window.webkitURL;
            Mm.createObjectURL = function(e) {
                return Whe.createObjectURL(e);
            };
            Mm.revokeObjectURL = function(e) {
                return Whe.revokeObjectURL(e);
            };
            Mm.createBlob = function(e, t) {
                if (t === "svg") return new window.Blob([
                    e
                ], {
                    type: "image/svg+xml;charset=utf-8"
                });
                if (t === "full-json") return new window.Blob([
                    e
                ], {
                    type: "application/json;charset=utf-8"
                });
                var r = Cht(window.atob(e));
                return new window.Blob([
                    r
                ], {
                    type: "image/" + t
                });
            };
            Mm.octetStream = function(e) {
                document.location.href = "data:application/octet-stream" + e;
            };
            function Cht(e) {
                for(var t = e.length, r = new ArrayBuffer(t), n = new Uint8Array(r), i = 0; i < t; i++)n[i] = e.charCodeAt(i);
                return r;
            }
            Mm.IMAGE_URL_PREFIX = /^data:image\/\w+;base64,/;
        });
        var BP = ye((snr, Zhe)=>{
            "use strict";
            var WN = xa(), anr = Mr(), Lht = ao(), Pht = va(), onr = Zp(), jN = /"/g, NM = "TOBESTRIPPED", Iht = new RegExp('("' + NM + ")|(" + NM + '")', "g");
            function Rht(e) {
                var t = WN.select("body").append("div").style({
                    display: "none"
                }).html(""), r = e.replace(/(&[^;]*;)/gi, function(n) {
                    return n === "&lt;" ? "&#60;" : n === "&rt;" ? "&#62;" : n.indexOf("<") !== -1 || n.indexOf(">") !== -1 ? "" : t.html(n).text();
                });
                return t.remove(), r;
            }
            function Dht(e) {
                return e.replace(/&(?!\w+;|\#[0-9]+;| \#x[0-9A-F]+;)/g, "&amp;");
            }
            Zhe.exports = function(t, r, n) {
                var i = t._fullLayout, a = i._paper, o = i._toppaper, s = i.width, l = i.height, u;
                a.insert("rect", ":first-child").call(Lht.setRect, 0, 0, s, l).call(Pht.fill, i.paper_bgcolor);
                var c = i._basePlotModules || [];
                for(u = 0; u < c.length; u++){
                    var f = c[u];
                    f.toSVG && f.toSVG(t);
                }
                if (o) {
                    var h = o.node().childNodes, d = Array.prototype.slice.call(h);
                    for(u = 0; u < d.length; u++){
                        var v = d[u];
                        v.childNodes.length && a.node().appendChild(v);
                    }
                }
                i._draggers && i._draggers.remove(), a.node().style.background = "", a.selectAll("text").attr({
                    "data-unformatted": null,
                    "data-math": null
                }).each(function() {
                    var b = WN.select(this);
                    if (this.style.visibility === "hidden" || this.style.display === "none") {
                        b.remove();
                        return;
                    } else b.style({
                        visibility: null,
                        display: null
                    });
                    var p = this.style.fontFamily;
                    p && p.indexOf('"') !== -1 && b.style("font-family", p.replace(jN, NM));
                    var E = this.style.fontWeight;
                    E && (E === "normal" || E === "400") && b.style("font-weight", void 0);
                    var k = this.style.fontStyle;
                    k && k === "normal" && b.style("font-style", void 0);
                    var A = this.style.fontVariant;
                    A && A === "normal" && b.style("font-variant", void 0);
                }), a.selectAll(".gradient_filled,.pattern_filled").each(function() {
                    var b = WN.select(this), p = this.style.fill;
                    p && p.indexOf("url(") !== -1 && b.style("fill", p.replace(jN, NM));
                    var E = this.style.stroke;
                    E && E.indexOf("url(") !== -1 && b.style("stroke", E.replace(jN, NM));
                }), (r === "pdf" || r === "eps") && a.selectAll("#MathJax_SVG_glyphs path").attr("stroke-width", 0), r === "svg" && n && (a.attr("width", n * s), a.attr("height", n * l), a.attr("viewBox", "0 0 " + s + " " + l));
                var x = new window.XMLSerializer().serializeToString(a.node());
                return x = Rht(x), x = Dht(x), x = x.replace(Iht, "'"), x;
            };
        });
        var NP = ye((lnr, Xhe)=>{
            "use strict";
            var zht = Mr(), Fht = vb().EventEmitter, UM = Ly();
            function qht(e) {
                var t = e.emitter || new Fht, r = new Promise(function(n, i) {
                    var a = window.Image, o = e.svg, s = e.format || "png", l = e.canvas, u = e.scale || 1, c = e.width || 300, f = e.height || 150, h = u * c, d = u * f, v = l.getContext("2d", {
                        willReadFrequently: !0
                    }), x = new a, b, p;
                    s === "svg" || zht.isSafari() ? p = UM.encodeSVG(o) : (b = UM.createBlob(o, "svg"), p = UM.createObjectURL(b)), l.width = h, l.height = d, x.onload = function() {
                        var E;
                        switch(b = null, UM.revokeObjectURL(p), s !== "svg" && v.drawImage(x, 0, 0, h, d), s){
                            case "jpeg":
                                E = l.toDataURL("image/jpeg");
                                break;
                            case "png":
                                E = l.toDataURL("image/png");
                                break;
                            case "webp":
                                E = l.toDataURL("image/webp");
                                break;
                            case "svg":
                                E = p;
                                break;
                            default:
                                var k = "Image format is not jpeg, png, svg or webp.";
                                if (i(new Error(k)), !e.promise) return t.emit("error", k);
                        }
                        n(E), e.promise || t.emit("success", E);
                    }, x.onerror = function(E) {
                        if (b = null, UM.revokeObjectURL(p), i(E), !e.promise) return t.emit("error", E);
                    }, x.src = p;
                });
                return e.promise ? r : t;
            }
            Xhe.exports = qht;
        });
        var XN = ye((unr, Jhe)=>{
            "use strict";
            var Yhe = uo(), Khe = OP(), Oht = Xu(), Em = Mr(), VM = Ly(), Bht = BP(), Nht = NP(), Uht = e6().version, ZN = {
                format: {
                    valType: "enumerated",
                    values: [
                        "png",
                        "jpeg",
                        "webp",
                        "svg",
                        "full-json"
                    ],
                    dflt: "png"
                },
                width: {
                    valType: "number",
                    min: 1
                },
                height: {
                    valType: "number",
                    min: 1
                },
                scale: {
                    valType: "number",
                    min: 0,
                    dflt: 1
                },
                setBackground: {
                    valType: "any",
                    dflt: !1
                },
                imageDataOnly: {
                    valType: "boolean",
                    dflt: !1
                }
            };
            function Vht(e, t) {
                t = t || {};
                var r, n, i, a;
                Em.isPlainObject(e) ? (r = e.data || [], n = e.layout || {}, i = e.config || {}, a = {}) : (e = Em.getGraphDiv(e), r = Em.extendDeep([], e.data), n = Em.extendDeep({}, e.layout), i = e._context, a = e._fullLayout || {});
                function o(_) {
                    return !(_ in t) || Em.validate(t[_], ZN[_]);
                }
                if (!o("width") && t.width !== null || !o("height") && t.height !== null) throw new Error("Height and width should be pixel values.");
                if (!o("format")) throw new Error("Export format is not " + Em.join2(ZN.format.values, ", ", " or ") + ".");
                var s = {};
                function l(_, C) {
                    return Em.coerce(t, s, ZN, _, C);
                }
                var u = l("format"), c = l("width"), f = l("height"), h = l("scale"), d = l("setBackground"), v = l("imageDataOnly"), x = document.createElement("div");
                x.style.position = "absolute", x.style.left = "-5000px", document.body.appendChild(x);
                var b = Em.extendFlat({}, n);
                c ? b.width = c : t.width === null && Yhe(a.width) && (b.width = a.width), f ? b.height = f : t.height === null && Yhe(a.height) && (b.height = a.height);
                var p = Em.extendFlat({}, i, {
                    _exportedPlot: !0,
                    staticPlot: !0,
                    setBackground: d
                }), E = VM.getRedrawFunc(x);
                function k() {
                    return new Promise(function(_) {
                        setTimeout(_, VM.getDelay(x._fullLayout));
                    });
                }
                function A() {
                    return new Promise(function(_, C) {
                        var M = Bht(x, u, h), g = x._fullLayout.width, P = x._fullLayout.height;
                        function T() {
                            Khe.purge(x), document.body.removeChild(x);
                        }
                        if (u === "full-json") {
                            var F = Oht.graphJson(x, !1, "keepdata", "object", !0, !0);
                            return F.version = Uht, F = JSON.stringify(F), T(), _(v ? F : VM.encodeJSON(F));
                        }
                        if (T(), u === "svg") return _(v ? M : VM.encodeSVG(M));
                        var q = document.createElement("canvas");
                        q.id = Em.randstr(), Nht({
                            format: u,
                            width: g,
                            height: P,
                            scale: h,
                            canvas: q,
                            svg: M,
                            promise: !0
                        }).then(_).catch(C);
                    });
                }
                function L(_) {
                    return v ? _.replace(VM.IMAGE_URL_PREFIX, "") : _;
                }
                return new Promise(function(_, C) {
                    Khe.newPlot(x, r, b, p).then(E).then(k).then(A).then(function(M) {
                        _(L(M));
                    }).catch(function(M) {
                        C(M);
                    });
                });
            }
            Jhe.exports = Vht;
        });
        var tde = ye((cnr, ede)=>{
            "use strict";
            var P0 = Mr(), Hht = Xu(), Ght = _3(), jht = ub().dfltConfig, Lg = P0.isPlainObject, Vb = Array.isArray, $he = P0.isArrayOrTypedArray;
            ede.exports = function(t, r) {
                t === void 0 && (t = []), r === void 0 && (r = {});
                var n = Ght.get(), i = [], a = {
                    _context: P0.extendFlat({}, jht)
                }, o, s;
                Vb(t) ? (a.data = P0.extendDeep([], t), o = t) : (a.data = [], o = [], i.push(cd("array", "data"))), Lg(r) ? (a.layout = P0.extendDeep({}, r), s = r) : (a.layout = {}, s = {}, arguments.length > 1 && i.push(cd("object", "layout"))), Hht.supplyDefaults(a);
                for(var l = a._fullData, u = o.length, c = 0; c < u; c++){
                    var f = o[c], h = [
                        "data",
                        c
                    ];
                    if (!Lg(f)) {
                        i.push(cd("object", h));
                        continue;
                    }
                    var d = l[c], v = d.type, x = n.traces[v].attributes;
                    x.type = {
                        valType: "enumerated",
                        values: [
                            v
                        ]
                    }, d.visible === !1 && f.visible !== !1 && i.push(cd("invisible", h)), UP(f, d, x, i, h);
                }
                var b = a._fullLayout, p = Wht(n, l);
                return UP(s, b, p, i, "layout"), i.length === 0 ? void 0 : i;
            };
            function UP(e, t, r, n, i, a) {
                a = a || [];
                for(var o = Object.keys(e), s = 0; s < o.length; s++){
                    var l = o[s], u = a.slice();
                    u.push(l);
                    var c = e[l], f = t[l], h = Yht(r, l), d = (h || {}).valType, v = d === "info_array", x = d === "colorscale", b = (h || {}).items;
                    if (!Xht(r, l)) n.push(cd("schema", i, u));
                    else if (Lg(c) && Lg(f) && d !== "any") UP(c, f, h, n, i, u);
                    else if (v && Vb(c)) {
                        c.length > f.length && n.push(cd("unused", i, u.concat(f.length)));
                        var p = f.length, E = Array.isArray(b);
                        E && (p = Math.min(p, b.length));
                        var k, A, L, _, C;
                        if (h.dimensions === 2) for(A = 0; A < p; A++)if (Vb(c[A])) {
                            c[A].length > f[A].length && n.push(cd("unused", i, u.concat(A, f[A].length)));
                            var M = f[A].length;
                            for(k = 0; k < (E ? Math.min(M, b[A].length) : M); k++)L = E ? b[A][k] : b, _ = c[A][k], C = f[A][k], P0.validate(_, L) ? C !== _ && C !== +_ && n.push(cd("dynamic", i, u.concat(A, k), _, C)) : n.push(cd("value", i, u.concat(A, k), _));
                        } else n.push(cd("array", i, u.concat(A), c[A]));
                        else for(A = 0; A < p; A++)L = E ? b[A] : b, _ = c[A], C = f[A], P0.validate(_, L) ? C !== _ && C !== +_ && n.push(cd("dynamic", i, u.concat(A), _, C)) : n.push(cd("value", i, u.concat(A), _));
                    } else if (h.items && !v && Vb(c)) {
                        var g = b[Object.keys(b)[0]], P = [], T, F;
                        for(T = 0; T < f.length; T++){
                            var q = f[T]._index || T;
                            if (F = u.slice(), F.push(q), Lg(c[q]) && Lg(f[T])) {
                                P.push(q);
                                var V = c[q], H = f[T];
                                Lg(V) && V.visible !== !1 && H.visible === !1 ? n.push(cd("invisible", i, F)) : UP(V, H, g, n, i, F);
                            }
                        }
                        for(T = 0; T < c.length; T++)F = u.slice(), F.push(T), Lg(c[T]) ? P.indexOf(T) === -1 && n.push(cd("unused", i, F)) : n.push(cd("object", i, F, c[T]));
                    } else !Lg(c) && Lg(f) ? n.push(cd("object", i, u, c)) : !$he(c) && $he(f) && !v && !x ? n.push(cd("array", i, u, c)) : l in t ? P0.validate(c, h) ? h.valType === "enumerated" && (h.coerceNumber && c !== +f || c !== f) && n.push(cd("dynamic", i, u, c, f)) : n.push(cd("value", i, u, c)) : n.push(cd("unused", i, u, c));
                }
                return n;
            }
            function Wht(e, t) {
                for(var r = e.layout.layoutAttributes, n = 0; n < t.length; n++){
                    var i = t[n], a = e.traces[i.type], o = a.layoutAttributes;
                    o && (i.subplot ? P0.extendFlat(r[a.attributes.subplot.dflt], o) : P0.extendFlat(r, o));
                }
                return r;
            }
            var Zht = {
                object: function(e, t) {
                    var r;
                    return e === "layout" && t === "" ? r = "The layout argument" : e[0] === "data" && t === "" ? r = "Trace " + e[1] + " in the data argument" : r = Ub(e) + "key " + t, r + " must be linked to an object container";
                },
                array: function(e, t) {
                    var r;
                    return e === "data" ? r = "The data argument" : r = Ub(e) + "key " + t, r + " must be linked to an array container";
                },
                schema: function(e, t) {
                    return Ub(e) + "key " + t + " is not part of the schema";
                },
                unused: function(e, t, r) {
                    var n = Lg(r) ? "container" : "key";
                    return Ub(e) + n + " " + t + " did not get coerced";
                },
                dynamic: function(e, t, r, n) {
                    return [
                        Ub(e) + "key",
                        t,
                        "(set to '" + r + "')",
                        "got reset to",
                        "'" + n + "'",
                        "during defaults."
                    ].join(" ");
                },
                invisible: function(e, t) {
                    return (t ? Ub(e) + "item " + t : "Trace " + e[1]) + " got defaulted to be not visible";
                },
                value: function(e, t, r) {
                    return [
                        Ub(e) + "key " + t,
                        "is set to an invalid value (" + r + ")"
                    ].join(" ");
                }
            };
            function Ub(e) {
                return Vb(e) ? "In data trace " + e[1] + ", " : "In " + e + ", ";
            }
            function cd(e, t, r, n, i) {
                r = r || "";
                var a, o;
                Vb(t) ? (a = t[0], o = t[1]) : (a = t, o = null);
                var s = Jht(r), l = Zht[e](t, s, n, i);
                return P0.log(l), {
                    code: e,
                    container: a,
                    trace: o,
                    path: r,
                    astr: s,
                    msg: l
                };
            }
            function Xht(e, t) {
                var r = Qhe(t), n = r.keyMinusId, i = r.id;
                return n in e && e[n]._isSubplotObj && i ? !0 : t in e;
            }
            function Yht(e, t) {
                if (t in e) return e[t];
                var r = Qhe(t);
                return e[r.keyMinusId];
            }
            var Kht = P0.counterRegex("([a-z]+)");
            function Qhe(e) {
                var t = e.match(Kht);
                return {
                    keyMinusId: t && t[1],
                    id: t && t[2]
                };
            }
            function Jht(e) {
                if (!Vb(e)) return String(e);
                for(var t = "", r = 0; r < e.length; r++){
                    var n = e[r];
                    typeof n == "number" ? t = t.substr(0, t.length - 1) + "[" + n + "]" : t += n, r < e.length - 1 && (t += ".");
                }
                return t;
            }
        });
        var ide = ye((fnr, rde)=>{
            "use strict";
            var $ht = Mr(), VP = Ly();
            function Qht(e, t, r) {
                var n = document.createElement("a"), i = "download" in n, a = new Promise(function(o, s) {
                    var l, u;
                    if (i) return l = VP.createBlob(e, r), u = VP.createObjectURL(l), n.href = u, n.download = t, document.body.appendChild(n), n.click(), document.body.removeChild(n), VP.revokeObjectURL(u), l = null, o(t);
                    if ($ht.isSafari()) {
                        var c = r === "svg" ? "," : ";base64,";
                        return VP.octetStream(c + encodeURIComponent(e)), o(t);
                    }
                    s(new Error("download error"));
                });
                return a;
            }
            rde.exports = Qht;
        });
        var YN = ye((dnr, ade)=>{
            "use strict";
            var nde = Mr(), edt = XN(), tdt = ide(), hnr = Ly();
            function rdt(e, t) {
                var r;
                return nde.isPlainObject(e) || (r = nde.getGraphDiv(e)), t = t || {}, t.format = t.format || "png", t.width = t.width || null, t.height = t.height || null, t.imageDataOnly = !0, new Promise(function(n, i) {
                    r && r._snapshotInProgress && i(new Error("Snapshotting already in progress.")), r && (r._snapshotInProgress = !0);
                    var a = edt(e, t), o = t.filename || e.fn || "newplot";
                    o += "." + t.format.replace("-", "."), a.then(function(s) {
                        return r && (r._snapshotInProgress = !1), tdt(s, o, t.format);
                    }).then(function(s) {
                        n(s);
                    }).catch(function(s) {
                        r && (r._snapshotInProgress = !1), i(s);
                    });
                });
            }
            ade.exports = rdt;
        });
        var cde = ye((KN)=>{
            "use strict";
            var Cp = Mr(), Lp = Cp.isPlainObject, ode = _3(), sde = Xu(), idt = vl(), lde = Vs(), ude = ub().dfltConfig;
            KN.makeTemplate = function(e) {
                e = Cp.isPlainObject(e) ? e : Cp.getGraphDiv(e), e = Cp.extendDeep({
                    _context: ude
                }, {
                    data: e.data,
                    layout: e.layout
                }), sde.supplyDefaults(e);
                var t = e.data || [], r = e.layout || {};
                r._basePlotModules = e._fullLayout._basePlotModules, r._modules = e._fullLayout._modules;
                var n = {
                    data: {},
                    layout: {}
                };
                t.forEach(function(d) {
                    var v = {};
                    HM(d, v, adt.bind(null, d));
                    var x = Cp.coerce(d, {}, idt, "type"), b = n.data[x];
                    b || (b = n.data[x] = []), b.push(v);
                }), HM(r, n.layout, ndt.bind(null, r)), delete n.layout.template;
                var i = r.template;
                if (Lp(i)) {
                    var a = i.layout, o, s, l, u, c, f;
                    Lp(a) && HP(a, n.layout);
                    var h = i.data;
                    if (Lp(h)) {
                        for(s in n.data)if (l = h[s], Array.isArray(l)) {
                            for(c = n.data[s], f = c.length, u = l.length, o = 0; o < f; o++)HP(l[o % u], c[o]);
                            for(o = f; o < u; o++)c.push(Cp.extendDeep({}, l[o]));
                        }
                        for(s in h)s in n.data || (n.data[s] = Cp.extendDeep([], h[s]));
                    }
                }
                return n;
            };
            function HP(e, t) {
                e = Cp.extendDeep({}, e);
                var r = Object.keys(e).sort(), n, i;
                function a(c, f, h) {
                    if (Lp(f) && Lp(c)) HP(c, f);
                    else if (Array.isArray(f) && Array.isArray(c)) {
                        var d = lde.arrayTemplater({
                            _template: e
                        }, h);
                        for(i = 0; i < f.length; i++){
                            var v = f[i], x = d.newItem(v)._template;
                            x && HP(x, v);
                        }
                        var b = d.defaultItems();
                        for(i = 0; i < b.length; i++)f.push(b[i]._template);
                        for(i = 0; i < f.length; i++)delete f[i].templateitemname;
                    }
                }
                for(n = 0; n < r.length; n++){
                    var o = r[n], s = e[o];
                    if (o in t ? a(s, t[o], o) : t[o] = s, GP(o) === o) for(var l in t){
                        var u = GP(l);
                        l !== u && u === o && !(l in e) && a(s, t[l], o);
                    }
                }
            }
            function GP(e) {
                return e.replace(/[0-9]+$/, "");
            }
            function HM(e, t, r, n, i) {
                var a = i && r(i);
                for(var o in e){
                    var s = e[o], l = I0(e, o, n), u = I0(e, o, i), c = r(u);
                    if (!c) {
                        var f = GP(o);
                        f !== o && (u = I0(e, f, i), c = r(u));
                    }
                    if (!(a && a === c) && !(!c || c._noTemplating || c.valType === "data_array" || c.arrayOk && Array.isArray(s))) {
                        if (!c.valType && Lp(s)) HM(s, t, r, l, u);
                        else if (c._isLinkedToArray && Array.isArray(s)) for(var h = !1, d = 0, v = {}, x = 0; x < s.length; x++){
                            var b = s[x];
                            if (Lp(b)) {
                                var p = b.name;
                                if (p) v[p] || (HM(b, t, r, I0(s, d, l), I0(s, d, u)), d++, v[p] = 1);
                                else if (!h) {
                                    var E = lde.arrayDefaultKey(o), k = I0(e, E, n), A = I0(s, d, l);
                                    HM(b, t, r, A, I0(s, d, u));
                                    var L = Cp.nestedProperty(t, A), _ = Cp.nestedProperty(t, k);
                                    _.set(L.get()), L.set(null), h = !0;
                                }
                            }
                        }
                        else {
                            var C = Cp.nestedProperty(t, l);
                            C.set(s);
                        }
                    }
                }
            }
            function ndt(e, t) {
                return ode.getLayoutValObject(e, Cp.nestedProperty({}, t).parts);
            }
            function adt(e, t) {
                return ode.getTraceValObject(e, Cp.nestedProperty({}, t).parts);
            }
            function I0(e, t, r) {
                var n;
                return r ? Array.isArray(e) ? n = r + "[" + t + "]" : n = r + "." + t : n = t, n;
            }
            KN.validateTemplate = function(e, t) {
                var r = Cp.extendDeep({}, {
                    _context: ude,
                    data: e.data,
                    layout: e.layout
                }), n = r.layout || {};
                Lp(t) || (t = n.template || {});
                var i = t.layout, a = t.data, o = [];
                r.layout = n, r.layout.template = t, sde.supplyDefaults(r);
                var s = r._fullLayout, l = r._fullData, u = {};
                function c(k, A) {
                    for(var L in k)if (L.charAt(0) !== "_" && Lp(k[L])) {
                        var _ = GP(L), C = [], M;
                        for(M = 0; M < A.length; M++)C.push(I0(k, L, A[M])), _ !== L && C.push(I0(k, _, A[M]));
                        for(M = 0; M < C.length; M++)u[C[M]] = 1;
                        c(k[L], C);
                    }
                }
                function f(k, A) {
                    for(var L in k)if (L.indexOf("defaults") === -1 && Lp(k[L])) {
                        var _ = I0(k, L, A);
                        u[_] ? f(k[L], _) : o.push({
                            code: "unused",
                            path: _
                        });
                    }
                }
                if (Lp(i) ? (c(s, [
                    "layout"
                ]), f(i, "layout")) : o.push({
                    code: "layout"
                }), !Lp(a)) o.push({
                    code: "data"
                });
                else {
                    for(var h = {}, d, v = 0; v < l.length; v++){
                        var x = l[v];
                        d = x.type, h[d] = (h[d] || 0) + 1, x._fullInput._template || o.push({
                            code: "missing",
                            index: x.index,
                            traceType: d
                        });
                    }
                    for(d in a){
                        var b = a[d].length, p = h[d] || 0;
                        b > p ? o.push({
                            code: "unused",
                            traceType: d,
                            templateCount: b,
                            dataCount: p
                        }) : p > b && o.push({
                            code: "reused",
                            traceType: d,
                            templateCount: b,
                            dataCount: p
                        });
                    }
                }
                function E(k, A) {
                    for(var L in k)if (L.charAt(0) !== "_") {
                        var _ = k[L], C = I0(k, L, A);
                        Lp(_) ? (Array.isArray(k) && _._template === !1 && _.templateitemname && o.push({
                            code: "missing",
                            path: C,
                            templateitemname: _.templateitemname
                        }), E(_, C)) : Array.isArray(_) && odt(_) && E(_, C);
                    }
                }
                if (E({
                    data: l,
                    layout: s
                }, ""), o.length) return o.map(sdt);
            };
            function odt(e) {
                for(var t = 0; t < e.length; t++)if (Lp(e[t])) return !0;
            }
            function sdt(e) {
                var t;
                switch(e.code){
                    case "data":
                        t = "The template has no key data.";
                        break;
                    case "layout":
                        t = "The template has no key layout.";
                        break;
                    case "missing":
                        e.path ? t = "There are no templates for item " + e.path + " with name " + e.templateitemname : t = "There are no templates for trace " + e.index + ", of type " + e.traceType + ".";
                        break;
                    case "unused":
                        e.path ? t = "The template item at " + e.path + " was not used in constructing the plot." : e.dataCount ? t = "Some of the templates of type " + e.traceType + " were not used. The template has " + e.templateCount + " traces, the data only has " + e.dataCount + " of this type." : t = "The template has " + e.templateCount + " traces of type " + e.traceType + " but there are none in the data.";
                        break;
                    case "reused":
                        t = "Some of the templates of type " + e.traceType + " were used more than once. The template has " + e.templateCount + " traces, the data has " + e.dataCount + " of this type.";
                        break;
                }
                return e.msg = t, e;
            }
        });
        var hde = ye((Sc)=>{
            "use strict";
            var Hh = OP();
            Sc._doPlot = Hh._doPlot;
            Sc.newPlot = Hh.newPlot;
            Sc.restyle = Hh.restyle;
            Sc.relayout = Hh.relayout;
            Sc.redraw = Hh.redraw;
            Sc.update = Hh.update;
            Sc._guiRestyle = Hh._guiRestyle;
            Sc._guiRelayout = Hh._guiRelayout;
            Sc._guiUpdate = Hh._guiUpdate;
            Sc._storeDirectGUIEdit = Hh._storeDirectGUIEdit;
            Sc.react = Hh.react;
            Sc.extendTraces = Hh.extendTraces;
            Sc.prependTraces = Hh.prependTraces;
            Sc.addTraces = Hh.addTraces;
            Sc.deleteTraces = Hh.deleteTraces;
            Sc.moveTraces = Hh.moveTraces;
            Sc.purge = Hh.purge;
            Sc.addFrames = Hh.addFrames;
            Sc.deleteFrames = Hh.deleteFrames;
            Sc.animate = Hh.animate;
            Sc.setPlotConfig = Hh.setPlotConfig;
            var ldt = DS().getGraphDiv, udt = rP().eraseActiveShape;
            Sc.deleteActiveShape = function(e) {
                return udt(ldt(e));
            };
            Sc.toImage = XN();
            Sc.validate = tde();
            Sc.downloadImage = YN();
            var fde = cde();
            Sc.makeTemplate = fde.makeTemplate;
            Sc.validateTemplate = fde.validateTemplate;
        });
        var K3 = ye((gnr, dde)=>{
            "use strict";
            var JN = Mr(), cdt = ba();
            dde.exports = function(t, r, n, i) {
                var a = i("x"), o = i("y"), s, l = cdt.getComponentMethod("calendars", "handleTraceDefaults");
                if (l(t, r, [
                    "x",
                    "y"
                ], n), a) {
                    var u = JN.minRowLength(a);
                    o ? s = Math.min(u, JN.minRowLength(o)) : (s = u, i("y0"), i("dy"));
                } else {
                    if (!o) return 0;
                    s = JN.minRowLength(o), i("x0"), i("dx");
                }
                return r._length = s, s;
            };
        });
        var Pg = ye((mnr, gde)=>{
            "use strict";
            var vde = Mr().dateTick0, fdt = es(), hdt = fdt.ONEWEEK;
            function pde(e, t) {
                return e % hdt === 0 ? vde(t, 1) : vde(t, 0);
            }
            gde.exports = function(t, r, n, i, a) {
                if (a || (a = {
                    x: !0,
                    y: !0
                }), a.x) {
                    var o = i("xperiod");
                    o && (i("xperiod0", pde(o, r.xcalendar)), i("xperiodalignment"));
                }
                if (a.y) {
                    var s = i("yperiod");
                    s && (i("yperiod0", pde(s, r.ycalendar)), i("yperiodalignment"));
                }
            };
        });
        var _de = ye((ynr, yde)=>{
            "use strict";
            var mde = [
                "orientation",
                "groupnorm",
                "stackgaps"
            ];
            yde.exports = function(t, r, n, i) {
                var a = n._scatterStackOpts, o = i("stackgroup");
                if (o) {
                    var s = r.xaxis + r.yaxis, l = a[s];
                    l || (l = a[s] = {});
                    var u = l[o], c = !1;
                    u ? u.traces.push(r) : (u = l[o] = {
                        traceIndices: [],
                        traces: [
                            r
                        ]
                    }, c = !0);
                    for(var f = {
                        orientation: r.x && !r.y ? "h" : "v"
                    }, h = 0; h < mde.length; h++){
                        var d = mde[h], v = d + "Found";
                        if (!u[v]) {
                            var x = t[d] !== void 0, b = d === "orientation";
                            if ((x || c) && (u[d] = i(d, f[d]), b && (u.fillDflt = u[d] === "h" ? "tonextx" : "tonexty"), x && (u[v] = !0, !c && (delete u.traces[0][d], b)))) for(var p = 0; p < u.traces.length - 1; p++){
                                var E = u.traces[p];
                                E._input.fill !== E.fill && (E.fill = u.fillDflt);
                            }
                        }
                    }
                    return u;
                }
            };
        });
        var $p = ye((_nr, Tde)=>{
            "use strict";
            var xde = va(), bde = Dv().hasColorscale, wde = Uh(), ddt = lu();
            Tde.exports = function(t, r, n, i, a, o) {
                var s = ddt.isBubble(t), l = (t.line || {}).color, u;
                if (o = o || {}, l && (n = l), a("marker.symbol"), a("marker.opacity", s ? .7 : 1), a("marker.size"), o.noAngle || (a("marker.angle"), o.noAngleRef || a("marker.angleref"), o.noStandOff || a("marker.standoff")), a("marker.color", n), bde(t, "marker") && wde(t, r, i, a, {
                    prefix: "marker.",
                    cLetter: "c"
                }), o.noSelect || (a("selected.marker.color"), a("unselected.marker.color"), a("selected.marker.size"), a("unselected.marker.size")), o.noLine || (l && !Array.isArray(l) && r.marker.color !== l ? u = l : s ? u = xde.background : u = xde.defaultLine, a("marker.line.color", u), bde(t, "marker.line") && wde(t, r, i, a, {
                    prefix: "marker.line.",
                    cLetter: "c"
                }), a("marker.line.width", s ? 1 : 0)), s && (a("marker.sizeref"), a("marker.sizemin"), a("marker.sizemode")), o.gradient) {
                    var c = a("marker.gradient.type");
                    c !== "none" && a("marker.gradient.color");
                }
            };
        });
        var R0 = ye((xnr, Ade)=>{
            "use strict";
            var vdt = Mr().isArrayOrTypedArray, pdt = Dv().hasColorscale, gdt = Uh();
            Ade.exports = function(t, r, n, i, a, o) {
                o || (o = {});
                var s = (t.marker || {}).color;
                if (s && s._inputArray && (s = s._inputArray), a("line.color", n), pdt(t, "line")) gdt(t, r, i, a, {
                    prefix: "line.",
                    cLetter: "c"
                });
                else {
                    var l = (vdt(s) ? !1 : s) || n;
                    a("line.color", l);
                }
                a("line.width"), o.noDash || a("line.dash"), o.backoff && a("line.backoff");
            };
        });
        var J3 = ye((bnr, Sde)=>{
            "use strict";
            Sde.exports = function(t, r, n) {
                var i = n("line.shape");
                i === "spline" && n("line.smoothing");
            };
        });
        var D0 = ye((wnr, Mde)=>{
            "use strict";
            var mdt = Mr();
            Mde.exports = function(e, t, r, n, i) {
                i = i || {}, n("textposition"), mdt.coerceFont(n, "textfont", i.font || r.font, i), i.noSelect || (n("selected.textfont.color"), n("unselected.textfont.color"));
            };
        });
        var Ig = ye((Tnr, kde)=>{
            "use strict";
            var jP = va(), Ede = Mr().isArrayOrTypedArray;
            function ydt(e) {
                for(var t = jP.interpolate(e[0][1], e[1][1], .5), r = 2; r < e.length; r++){
                    var n = jP.interpolate(e[r - 1][1], e[r][1], .5);
                    t = jP.interpolate(t, n, e[r - 1][0] / e[r][0]);
                }
                return t;
            }
            kde.exports = function(t, r, n, i, a) {
                a || (a = {});
                var o = !1;
                if (r.marker) {
                    var s = r.marker.color, l = (r.marker.line || {}).color;
                    s && !Ede(s) ? o = s : l && !Ede(l) && (o = l);
                }
                var u;
                if (a.moduleHasFillgradient) {
                    var c = i("fillgradient.type");
                    if (c !== "none") {
                        i("fillgradient.start"), i("fillgradient.stop");
                        var f = i("fillgradient.colorscale");
                        f && (u = ydt(f));
                    }
                }
                i("fillcolor", jP.addOpacity((r.line || {}).color || o || u || n, .5));
            };
        });
        var Ide = ye((Anr, Pde)=>{
            "use strict";
            var Cde = Mr(), _dt = ba(), xdt = Uc(), bdt = Sm(), $3 = lu(), wdt = K3(), Tdt = Pg(), Adt = _de(), Sdt = $p(), Mdt = R0(), Lde = J3(), Edt = D0(), kdt = Ig(), Cdt = Mr().coercePattern;
            Pde.exports = function(t, r, n, i) {
                function a(d, v) {
                    return Cde.coerce(t, r, xdt, d, v);
                }
                var o = wdt(t, r, i, a);
                if (o || (r.visible = !1), !!r.visible) {
                    Tdt(t, r, i, a), a("xhoverformat"), a("yhoverformat"), a("zorder");
                    var s = Adt(t, r, i, a);
                    i.scattermode === "group" && r.orientation === void 0 && a("orientation", "v");
                    var l = !s && o < bdt.PTS_LINESONLY ? "lines+markers" : "lines";
                    a("text"), a("hovertext"), a("mode", l), $3.hasMarkers(r) && Sdt(t, r, n, i, a, {
                        gradient: !0
                    }), $3.hasLines(r) && (Mdt(t, r, n, i, a, {
                        backoff: !0
                    }), Lde(t, r, a), a("connectgaps"), a("line.simplify")), $3.hasText(r) && (a("texttemplate"), Edt(t, r, i, a));
                    var u = [];
                    ($3.hasMarkers(r) || $3.hasText(r)) && (a("cliponaxis"), a("marker.maxdisplayed"), u.push("points")), a("fill", s ? s.fillDflt : "none"), r.fill !== "none" && (kdt(t, r, n, a, {
                        moduleHasFillgradient: !0
                    }), $3.hasLines(r) || Lde(t, r, a), Cdt(a, "fillpattern", r.fillcolor, !1));
                    var c = (r.line || {}).color, f = (r.marker || {}).color;
                    (r.fill === "tonext" || r.fill === "toself") && u.push("fills"), a("hoveron", u.join("+") || "points"), r.hoveron !== "fills" && a("hovertemplate");
                    var h = _dt.getComponentMethod("errorbars", "supplyDefaults");
                    h(t, r, c || f || n, {
                        axis: "y"
                    }), h(t, r, c || f || n, {
                        axis: "x",
                        inherit: "y"
                    }), Cde.coerceSelectionMarkerOpacity(r, a);
                }
            };
        });
        var Hb = ye((Snr, Rde)=>{
            "use strict";
            var Ldt = Bb().getAxisGroup;
            Rde.exports = function(t, r, n, i, a) {
                var o = r.orientation, s = r[({
                    v: "x",
                    h: "y"
                })[o] + "axis"], l = Ldt(n, s) + o, u = n._alignmentOpts || {}, c = i("alignmentgroup"), f = u[l];
                f || (f = u[l] = {});
                var h = f[c];
                h ? h.traces.push(r) : h = f[c] = {
                    traces: [
                        r
                    ],
                    alignmentIndex: Object.keys(f).length,
                    offsetGroups: {}
                };
                var d = i("offsetgroup") || "", v = h.offsetGroups, x = v[d];
                r._offsetIndex = 0, (a !== "group" || d) && (x || (x = v[d] = {
                    offsetIndex: Object.keys(v).length
                }), r._offsetIndex = x.offsetIndex);
            };
        });
        var $N = ye((Mnr, Dde)=>{
            "use strict";
            var Pdt = Mr(), Idt = Hb(), Rdt = Uc();
            Dde.exports = function(t, r) {
                var n, i, a, o = r.scattermode;
                function s(h) {
                    return Pdt.coerce(i._input, i, Rdt, h);
                }
                if (r.scattermode === "group") for(a = 0; a < t.length; a++)i = t[a], i.type === "scatter" && (n = i._input, Idt(n, i, r, s, o));
                for(a = 0; a < t.length; a++){
                    var l = t[a];
                    if (l.type === "scatter") {
                        var u = l.fill;
                        if (!(u === "none" || u === "toself") && (l.opacity = void 0, u === "tonexty" || u === "tonextx")) for(var c = a - 1; c >= 0; c--){
                            var f = t[c];
                            if (f.type === "scatter" && f.xaxis === l.xaxis && f.yaxis === l.yaxis) {
                                f.opacity = void 0;
                                break;
                            }
                        }
                    }
                }
            };
        });
        var Fde = ye((Enr, zde)=>{
            "use strict";
            var Ddt = Mr(), zdt = V6();
            zde.exports = function(e, t) {
                function r(i, a) {
                    return Ddt.coerce(e, t, zdt, i, a);
                }
                var n = t.barmode === "group";
                t.scattermode === "group" && r("scattergap", n ? t.bargap : .2);
            };
        });
        var Rg = ye((knr, Ode)=>{
            "use strict";
            var Fdt = uo(), qde = Mr(), qdt = qde.dateTime2ms, WP = qde.incrementMonth, Odt = es(), Bdt = Odt.ONEAVGMONTH;
            Ode.exports = function(t, r, n, i) {
                if (r.type !== "date") return {
                    vals: i
                };
                var a = t[n + "periodalignment"];
                if (!a) return {
                    vals: i
                };
                var o = t[n + "period"], s;
                if (Fdt(o)) {
                    if (o = +o, o <= 0) return {
                        vals: i
                    };
                } else if (typeof o == "string" && o.charAt(0) === "M") {
                    var l = +o.substring(1);
                    if (l > 0 && Math.round(l) === l) s = l;
                    else return {
                        vals: i
                    };
                }
                for(var u = r.calendar, c = a === "start", f = a === "end", h = t[n + "period0"], d = qdt(h, u) || 0, v = [], x = [], b = [], p = i.length, E = 0; E < p; E++){
                    var k = i[E], A, L, _;
                    if (s) {
                        for(A = Math.round((k - d) / (s * Bdt)), _ = WP(d, s * A, u); _ > k;)_ = WP(_, -s, u);
                        for(; _ <= k;)_ = WP(_, s, u);
                        L = WP(_, -s, u);
                    } else {
                        for(A = Math.round((k - d) / o), _ = d + A * o; _ > k;)_ -= o;
                        for(; _ <= k;)_ += o;
                        L = _ - o;
                    }
                    v[E] = c ? L : f ? _ : (L + _) / 2, x[E] = L, b[E] = _;
                }
                return {
                    vals: v,
                    starts: x,
                    ends: b
                };
            };
        });
        var z0 = ye((Cnr, Nde)=>{
            "use strict";
            var QN = Dv().hasColorscale, eU = zv(), Bde = lu();
            Nde.exports = function(t, r) {
                Bde.hasLines(r) && QN(r, "line") && eU(t, r, {
                    vals: r.line.color,
                    containerStr: "line",
                    cLetter: "c"
                }), Bde.hasMarkers(r) && (QN(r, "marker") && eU(t, r, {
                    vals: r.marker.color,
                    containerStr: "marker",
                    cLetter: "c"
                }), QN(r, "marker.line") && eU(t, r, {
                    vals: r.marker.line.color,
                    containerStr: "marker.line",
                    cLetter: "c"
                }));
            };
        });
        var km = ye((Lnr, Ude)=>{
            "use strict";
            var Df = Mr();
            Ude.exports = function(t, r) {
                for(var n = 0; n < t.length; n++)t[n].i = n;
                Df.mergeArray(r.text, t, "tx"), Df.mergeArray(r.texttemplate, t, "txt"), Df.mergeArray(r.hovertext, t, "htx"), Df.mergeArray(r.customdata, t, "data"), Df.mergeArray(r.textposition, t, "tp"), r.textfont && (Df.mergeArrayCastPositive(r.textfont.size, t, "ts"), Df.mergeArray(r.textfont.color, t, "tc"), Df.mergeArray(r.textfont.family, t, "tf"), Df.mergeArray(r.textfont.weight, t, "tw"), Df.mergeArray(r.textfont.style, t, "ty"), Df.mergeArray(r.textfont.variant, t, "tv"), Df.mergeArray(r.textfont.textcase, t, "tC"), Df.mergeArray(r.textfont.lineposition, t, "tE"), Df.mergeArray(r.textfont.shadow, t, "tS"));
                var i = r.marker;
                if (i) {
                    Df.mergeArrayCastPositive(i.size, t, "ms"), Df.mergeArrayCastPositive(i.opacity, t, "mo"), Df.mergeArray(i.symbol, t, "mx"), Df.mergeArray(i.angle, t, "ma"), Df.mergeArray(i.standoff, t, "mf"), Df.mergeArray(i.color, t, "mc");
                    var a = i.line;
                    i.line && (Df.mergeArray(a.color, t, "mlc"), Df.mergeArrayCastPositive(a.width, t, "mlw"));
                    var o = i.gradient;
                    o && o.type !== "none" && (Df.mergeArray(o.type, t, "mgt"), Df.mergeArray(o.color, t, "mgc"));
                }
            };
        });
        var F0 = ye((Pnr, Hde)=>{
            "use strict";
            var Vde = Mr();
            Hde.exports = function(t, r) {
                Vde.isArrayOrTypedArray(r.selectedpoints) && Vde.tagSelected(t, r);
            };
        });
        var q0 = ye((Inr, Kde)=>{
            "use strict";
            var Gde = uo(), rU = Mr(), GM = Qa(), jde = Rg(), tU = es().BADNUM, iU = lu(), Ndt = z0(), Udt = km(), Vdt = F0();
            function Hdt(e, t) {
                var r = e._fullLayout, n = t._xA = GM.getFromId(e, t.xaxis || "x", "x"), i = t._yA = GM.getFromId(e, t.yaxis || "y", "y"), a = n.makeCalcdata(t, "x"), o = i.makeCalcdata(t, "y"), s = jde(t, n, "x", a), l = jde(t, i, "y", o), u = s.vals, c = l.vals, f = t._length, h = new Array(f), d = t.ids, v = nU(t, r, n, i), x = !1, b, p, E, k, A, L;
                Xde(r, t);
                var _ = "x", C = "y", M;
                if (v) rU.pushUnique(v.traceIndices, t.index), b = v.orientation === "v", b ? (C = "s", M = "x") : (_ = "s", M = "y"), A = v.stackgaps === "interpolate";
                else {
                    var g = Zde(t, f);
                    Wde(e, t, n, i, u, c, g);
                }
                var P = !!t.xperiodalignment, T = !!t.yperiodalignment;
                for(p = 0; p < f; p++){
                    var F = h[p] = {}, q = Gde(u[p]), V = Gde(c[p]);
                    q && V ? (F[_] = u[p], F[C] = c[p], P && (F.orig_x = a[p], F.xEnd = s.ends[p], F.xStart = s.starts[p]), T && (F.orig_y = o[p], F.yEnd = l.ends[p], F.yStart = l.starts[p])) : v && (b ? q : V) ? (F[M] = b ? u[p] : c[p], F.gap = !0, A ? (F.s = tU, x = !0) : F.s = 0) : F[_] = F[C] = tU, d && (F.id = String(d[p]));
                }
                if (Udt(h, t), Ndt(e, t), Vdt(h, t), v) {
                    for(p = 0; p < h.length;)h[p][M] === tU ? h.splice(p, 1) : p++;
                    if (rU.sort(h, function(N, W) {
                        return N[M] - W[M] || N.i - W.i;
                    }), x) {
                        for(p = 0; p < h.length - 1 && h[p].gap;)p++;
                        for(L = h[p].s, L || (L = h[p].s = 0), E = 0; E < p; E++)h[E].s = L;
                        for(k = h.length - 1; k > p && h[k].gap;)k--;
                        for(L = h[k].s, E = h.length - 1; E > k; E--)h[E].s = L;
                        for(; p < k;)if (p++, h[p].gap) {
                            for(E = p + 1; h[E].gap;)E++;
                            for(var H = h[p - 1][M], X = h[p - 1].s, G = (h[E].s - X) / (h[E][M] - H); p < E;)h[p].s = X + (h[p][M] - H) * G, p++;
                        }
                    }
                }
                return h;
            }
            function Wde(e, t, r, n, i, a, o) {
                var s = t._length, l = e._fullLayout, u = r._id, c = n._id, f = l._firstScatter[Yde(t)] === t.uid, h = (nU(t, l, r, n) || {}).orientation, d = t.fill;
                r._minDtick = 0, n._minDtick = 0;
                var v = {
                    padded: !0
                }, x = {
                    padded: !0
                };
                o && (v.ppad = x.ppad = o);
                var b = s < 2 || i[0] !== i[s - 1] || a[0] !== a[s - 1];
                b && (d === "tozerox" || d === "tonextx" && (f || h === "h")) ? v.tozero = !0 : !(t.error_y || {}).visible && (d === "tonexty" || d === "tozeroy" || !iU.hasMarkers(t) && !iU.hasText(t)) && (v.padded = !1, v.ppad = 0), b && (d === "tozeroy" || d === "tonexty" && (f || h === "v")) ? x.tozero = !0 : (d === "tonextx" || d === "tozerox") && (x.padded = !1), u && (t._extremes[u] = GM.findExtremes(r, i, v)), c && (t._extremes[c] = GM.findExtremes(n, a, x));
            }
            function Zde(e, t) {
                if (iU.hasMarkers(e)) {
                    var r = e.marker, n = 1.6 * (e.marker.sizeref || 1), i;
                    if (e.marker.sizemode === "area" ? i = function(u) {
                        return Math.max(Math.sqrt((u || 0) / n), 3);
                    } : i = function(u) {
                        return Math.max((u || 0) / n, 3);
                    }, rU.isArrayOrTypedArray(r.size)) {
                        var a = {
                            type: "linear"
                        };
                        GM.setConvert(a);
                        for(var o = a.makeCalcdata(e.marker, "size"), s = new Array(t), l = 0; l < t; l++)s[l] = i(o[l]);
                        return s;
                    } else return i(r.size);
                }
            }
            function Xde(e, t) {
                var r = Yde(t), n = e._firstScatter;
                n[r] || (n[r] = t.uid);
            }
            function Yde(e) {
                var t = e.stackgroup;
                return e.xaxis + e.yaxis + e.type + (t ? "-" + t : "");
            }
            function nU(e, t, r, n) {
                var i = e.stackgroup;
                if (i) {
                    var a = t._scatterStackOpts[r._id + n._id][i], o = a.orientation === "v" ? n : r;
                    if (o.type === "linear" || o.type === "log") return a;
                }
            }
            Kde.exports = {
                calc: Hdt,
                calcMarkerSize: Zde,
                calcAxisExpansion: Wde,
                setFirstScatter: Xde,
                getStackOpts: nU
            };
        });
        var $de = ye((Rnr, Jde)=>{
            "use strict";
            Jde.exports = ZP;
            var Gdt = Mr().distinctVals;
            function ZP(e, t) {
                this.traces = e, this.sepNegVal = t.sepNegVal, this.overlapNoMerge = t.overlapNoMerge;
                for(var r = 1 / 0, n = t.posAxis._id.charAt(0), i = [], a = 0; a < e.length; a++){
                    for(var o = e[a], s = 0; s < o.length; s++){
                        var l = o[s], u = l.p;
                        u === void 0 && (u = l[n]), u !== void 0 && i.push(u);
                    }
                    o[0] && o[0].width1 && (r = Math.min(o[0].width1, r));
                }
                this.positions = i;
                var c = Gdt(i);
                this.distinctPositions = c.vals, c.vals.length === 1 && r !== 1 / 0 ? this.minDiff = r : this.minDiff = Math.min(c.minDiff, r);
                var f = (t.posAxis || {}).type;
                (f === "category" || f === "multicategory") && (this.minDiff = 1), this.binWidth = this.minDiff, this.bins = {};
            }
            ZP.prototype.put = function(t, r, n) {
                var i = this.getLabel(t, r, n), a = this.bins[i] || 0;
                return this.bins[i] = a + n, a;
            };
            ZP.prototype.get = function(t, r, n) {
                var i = this.getLabel(t, r, n);
                return this.bins[i] || 0;
            };
            ZP.prototype.getLabel = function(t, r, n) {
                var i = n < 0 && this.sepNegVal ? "v" : "^", a = this.overlapNoMerge ? t : Math.round(t / this.binWidth);
                return i + a + "g" + r;
            };
        });
        var Gb = ye((Dnr, rve)=>{
            "use strict";
            var O0 = uo(), g_ = Mr().isArrayOrTypedArray, Q3 = es().BADNUM, jdt = ba(), jM = Qa(), Wdt = Bb().getAxisGroup, XP = $de();
            function Zdt(e, t) {
                for(var r = t.xaxis, n = t.yaxis, i = e._fullLayout, a = e._fullData, o = e.calcdata, s = [], l = [], u = 0; u < a.length; u++){
                    var c = a[u];
                    if (c.visible === !0 && jdt.traceIs(c, "bar") && c.xaxis === r._id && c.yaxis === n._id && (c.orientation === "h" ? s.push(o[u]) : l.push(o[u]), c._computePh)) for(var f = e.calcdata[u], h = 0; h < f.length; h++)typeof f[h].ph0 == "function" && (f[h].ph0 = f[h].ph0()), typeof f[h].ph1 == "function" && (f[h].ph1 = f[h].ph1());
                }
                var d = {
                    xCat: r.type === "category" || r.type === "multicategory",
                    yCat: n.type === "category" || n.type === "multicategory",
                    mode: i.barmode,
                    norm: i.barnorm,
                    gap: i.bargap,
                    groupgap: i.bargroupgap
                };
                oU(e, r, n, l, d), oU(e, n, r, s, d);
            }
            function oU(e, t, r, n, i) {
                if (n.length) {
                    var a, o, s, l, u;
                    switch(Kdt(r, n), i.mode){
                        case "overlay":
                            aU(e, t, r, n, i);
                            break;
                        case "group":
                            for(a = [], o = [], s = 0; s < n.length; s++)l = n[s], u = l[0].trace, u.offset === void 0 ? o.push(l) : a.push(l);
                            o.length && Jdt(e, t, r, o, i), a.length && aU(e, t, r, a, i);
                            break;
                        case "stack":
                        case "relative":
                            for(a = [], o = [], s = 0; s < n.length; s++)l = n[s], u = l[0].trace, u.base === void 0 ? o.push(l) : a.push(l);
                            Ydt(o), o.length && $dt(e, t, r, o, i), a.length && aU(e, t, r, a, i);
                            break;
                    }
                    Xdt(n), nvt(n, t);
                }
            }
            function Xdt(e) {
                var t, r, n, i, a, o, s;
                for(t = 0; t < e.length; t++)r = e[t], n = r[0].trace, i = r[0].t, i.cornerradiusvalue === void 0 && (a = n.marker ? n.marker.cornerradius : void 0, a !== void 0 && (o = O0(a) ? +a : +a.slice(0, -1), s = O0(a) ? "px" : "%", i.cornerradiusvalue = o, i.cornerradiusform = s));
            }
            function Ydt(e) {
                if (!(e.length < 2)) {
                    var t, r, n, i, a, o, s;
                    for(t = 0; t < e.length && (r = e[t], n = r[0].trace, a = n.marker ? n.marker.cornerradius : void 0, a === void 0); t++);
                    if (a !== void 0) for(o = O0(a) ? +a : +a.slice(0, -1), s = O0(a) ? "px" : "%", t = 0; t < e.length; t++)r = e[t], i = r[0].t, i.cornerradiusvalue = o, i.cornerradiusform = s;
                }
            }
            function Kdt(e, t) {
                var r, n;
                for(r = 0; r < t.length; r++){
                    var i = t[r], a = i[0].trace, o = a.type === "funnel" ? a._base : a.base, s, l = a.orientation === "h" ? a.xcalendar : a.ycalendar, u = e.type === "category" || e.type === "multicategory" ? function() {
                        return null;
                    } : e.d2c;
                    if (g_(o)) {
                        for(n = 0; n < Math.min(o.length, i.length); n++)s = u(o[n], 0, l), O0(s) ? (i[n].b = +s, i[n].hasB = 1) : i[n].b = 0;
                        for(; n < i.length; n++)i[n].b = 0;
                    } else {
                        s = u(o, 0, l);
                        var c = O0(s);
                        for(s = c ? s : 0, n = 0; n < i.length; n++)i[n].b = s, c && (i[n].hasB = 1);
                    }
                }
            }
            function aU(e, t, r, n, i) {
                for(var a = 0; a < n.length; a++){
                    var o = n[a], s = new XP([
                        o
                    ], {
                        posAxis: t,
                        sepNegVal: !1,
                        overlapNoMerge: !i.norm
                    });
                    sU(e, t, s, i), i.norm ? (tve(s), lU(r, s, i)) : eve(r, s);
                }
            }
            function Jdt(e, t, r, n, i) {
                var a = new XP(n, {
                    posAxis: t,
                    sepNegVal: !1,
                    overlapNoMerge: !i.norm
                });
                sU(e, t, a, i), rvt(a, t), i.norm ? (tve(a), lU(r, a, i)) : eve(r, a);
            }
            function $dt(e, t, r, n, i) {
                var a = new XP(n, {
                    posAxis: t,
                    sepNegVal: i.mode === "relative",
                    overlapNoMerge: !(i.norm || i.mode === "stack" || i.mode === "relative")
                });
                sU(e, t, a, i), tvt(r, a, i);
                for(var o = 0; o < n.length; o++)for(var s = n[o], l = s[0].t.offsetindex, u = 0; u < s.length; u++){
                    var c = s[u];
                    if (c.s !== Q3) {
                        var f = c.b + c.s === a.get(c.p, l, c.s);
                        f && (c._outmost = !0);
                    }
                }
                i.norm && lU(r, a, i);
            }
            function sU(e, t, r, n) {
                var i = e._fullLayout, a = r.positions, o = r.distinctPositions, s = r.minDiff, l = r.traces, u = l.length, c = a.length !== o.length, f = s * (1 - n.gap), h, d, v, x;
                if (t._id === "angularaxis") h = f, d = h * (1 - (n.groupgap || 0)), v = -d / 2;
                else {
                    var b = Wdt(i, t._id) + l[0][0].trace.orientation;
                    x = i._alignmentOpts[b] || {};
                }
                for(var p = 0; p < u; p++){
                    var E = l[p], k = E[0].trace;
                    if (t._id !== "angularaxis") {
                        var A = x[k.alignmentgroup] || {}, L = Object.keys(A.offsetGroups || {}).length;
                        L ? h = f / L : h = c ? f / u : f, d = h * (1 - (n.groupgap || 0)), L ? v = ((2 * k._offsetIndex + 1 - L) * h - d) / 2 : v = c ? ((2 * p + 1 - u) * h - d) / 2 : -d / 2;
                    }
                    var _ = E[0].t;
                    _.barwidth = d, _.offsetindex = k._offsetIndex || 0, _.poffset = v, _.bargroupwidth = f, _.bardelta = s;
                }
                r.binWidth = l[0][0].t.barwidth / 100, Qdt(r), evt(t, r), t._id === "angularaxis" ? Qde(t, r) : Qde(t, r, c);
            }
            function Qdt(e) {
                var t = e.traces, r, n;
                for(r = 0; r < t.length; r++){
                    var i = t[r], a = i[0], o = a.trace, s = a.t, l = o._offset || o.offset, u = s.poffset, c;
                    if (g_(l)) {
                        for(c = Array.prototype.slice.call(l, 0, i.length), n = 0; n < c.length; n++)O0(c[n]) || (c[n] = u);
                        for(n = c.length; n < i.length; n++)c.push(u);
                        s.poffset = c;
                    } else l !== void 0 && (s.poffset = l);
                    var f = o._width || o.width, h = s.barwidth;
                    if (g_(f)) {
                        var d = Array.prototype.slice.call(f, 0, i.length);
                        for(n = 0; n < d.length; n++)O0(d[n]) || (d[n] = h);
                        for(n = d.length; n < i.length; n++)d.push(h);
                        if (s.barwidth = d, l === void 0) {
                            for(c = [], n = 0; n < i.length; n++)c.push(u + (h - d[n]) / 2);
                            s.poffset = c;
                        }
                    } else f !== void 0 && (s.barwidth = f, l === void 0 && (s.poffset = u + (h - f) / 2));
                }
            }
            function evt(e, t) {
                for(var r = t.traces, n = eT(e), i = 0; i < r.length; i++)for(var a = r[i], o = a[0].t, s = o.poffset, l = g_(s), u = o.barwidth, c = g_(u), f = 0; f < a.length; f++){
                    var h = a[f], d = h.w = c ? u[f] : u;
                    h.p === void 0 && (h.p = h[n], h["orig_" + n] = h[n]);
                    var v = (l ? s[f] : s) + d / 2;
                    h[n] = h.p + v;
                }
            }
            function Qde(e, t, r) {
                var n = t.traces, i = t.minDiff, a = i / 2;
                jM.minDtick(e, t.minDiff, t.distinctPositions[0], r);
                for(var o = 0; o < n.length; o++){
                    var s = n[o], l = s[0], u = l.trace, c = [], f, h, d, v;
                    for(v = 0; v < s.length; v++)f = s[v], h = f.p - a, d = f.p + a, c.push(h, d);
                    if (u.width || u.offset) {
                        var x = l.t, b = x.poffset, p = x.barwidth, E = g_(b), k = g_(p);
                        for(v = 0; v < s.length; v++){
                            f = s[v];
                            var A = E ? b[v] : b, L = k ? p[v] : p;
                            h = f.p + A, d = h + L, c.push(h, d);
                        }
                    }
                    u._extremes[e._id] = jM.findExtremes(e, c, {
                        padded: !1
                    });
                }
            }
            function eve(e, t) {
                for(var r = t.traces, n = eT(e), i = 0; i < r.length; i++){
                    for(var a = r[i], o = a[0].trace, s = o.type === "scatter", l = o.orientation === "v", u = [], c = !1, f = 0; f < a.length; f++){
                        var h = a[f], d = s ? 0 : h.b, v = s ? l ? h.y : h.x : d + h.s;
                        h[n] = v, u.push(v), h.hasB && u.push(d), (!h.hasB || !h.b) && (c = !0);
                    }
                    o._extremes[e._id] = jM.findExtremes(e, u, {
                        tozero: c,
                        padded: !0
                    });
                }
            }
            function tvt(e, t, r) {
                var n = eT(e), i = t.traces, a, o, s, l, u, c, f;
                for(l = 0; l < i.length; l++)if (a = i[l], o = a[0].trace, o.type === "funnel") for(f = a[0].t.offsetindex, u = 0; u < a.length; u++)c = a[u], c.s !== Q3 && t.put(c.p, f, -0.5 * c.s);
                for(l = 0; l < i.length; l++){
                    a = i[l], o = a[0].trace, s = o.type === "funnel", f = o.type === "barpolar" ? 0 : a[0].t.offsetindex;
                    var h = [];
                    for(u = 0; u < a.length; u++)if (c = a[u], c.s !== Q3) {
                        var d;
                        s ? d = c.s : d = c.s + c.b;
                        var v = t.put(c.p, f, d), x = v + d;
                        c.b = v, c[n] = x, r.norm || (h.push(x), c.hasB && h.push(v));
                    }
                    r.norm || (o._extremes[e._id] = jM.findExtremes(e, h, {
                        tozero: !0,
                        padded: !0
                    }));
                }
            }
            function tve(e) {
                for(var t = e.traces, r = 0; r < t.length; r++)for(var n = t[r], i = n[0].t.offsetindex, a = 0; a < n.length; a++){
                    var o = n[a];
                    o.s !== Q3 && e.put(o.p, i, o.b + o.s);
                }
            }
            function rvt(e, t) {
                for(var r = e.traces, n = 0; n < r.length; n++){
                    var i = r[n], a = i[0].trace, o = i[0].t.offsetindex;
                    if (a.base === void 0) for(var s = new XP([
                        i
                    ], {
                        posAxis: t,
                        sepNegVal: !0,
                        overlapNoMerge: !0
                    }), l = 0; l < i.length; l++){
                        var u = i[l];
                        if (u.p !== Q3) {
                            var c = s.put(u.p, o, u.b + u.s);
                            c && (u.b = c);
                        }
                    }
                }
            }
            function lU(e, t, r) {
                var n = t.traces, i = eT(e), a = r.norm === "fraction" ? 1 : 100, o = a / 1e9, s = e.l2c(e.c2l(0)), l = r.mode === "stack" ? a : s;
                function u(_) {
                    return O0(e.c2l(_)) && (_ < s - o || _ > l + o || !O0(s));
                }
                for(var c = 0; c < n.length; c++){
                    for(var f = n[c], h = f[0].t.offsetindex, d = f[0].trace, v = [], x = !1, b = !1, p = 0; p < f.length; p++){
                        var E = f[p];
                        if (E.s !== Q3) {
                            var k = Math.abs(a / t.get(E.p, h, E.s));
                            E.b *= k, E.s *= k;
                            var A = E.b, L = A + E.s;
                            E[i] = L, v.push(L), b = b || u(L), E.hasB && (v.push(A), b = b || u(A)), (!E.hasB || !E.b) && (x = !0);
                        }
                    }
                    d._extremes[e._id] = jM.findExtremes(e, v, {
                        tozero: x,
                        padded: b
                    });
                }
            }
            function ivt(e, t, r, n) {
                for(var i = eT(n), a = 0; a < e.length; a++)for(var o = e[a], s = 0; s < o.length; s++){
                    var l = o[s], u = l[i];
                    l._sMin = t[u], l._sMax = r[u];
                }
            }
            function nvt(e, t) {
                var r = eT(t), n = {}, i, a, o, s = 1 / 0, l = -1 / 0;
                for(i = 0; i < e.length; i++)for(o = e[i], a = 0; a < o.length; a++){
                    var u = o[a].p;
                    O0(u) && (s = Math.min(s, u), l = Math.max(l, u));
                }
                var c = 1e4 / (l - s), f = n.round = function(M) {
                    return String(Math.round(c * (M - s)));
                }, h = {}, d = {}, v = e.some(function(M) {
                    var g = M[0].trace;
                    return "marker" in g && g.marker.cornerradius;
                });
                for(i = 0; i < e.length; i++){
                    o = e[i], o[0].t.extents = n;
                    var x = o[0].t.poffset, b = g_(x);
                    for(a = 0; a < o.length; a++){
                        var p = o[a], E = p[r] - p.w / 2;
                        if (O0(E)) {
                            var k = p[r] + p.w / 2, A = f(p.p);
                            n[A] ? n[A] = [
                                Math.min(E, n[A][0]),
                                Math.max(k, n[A][1])
                            ] : n[A] = [
                                E,
                                k
                            ];
                        }
                        if (p.p0 = p.p + (b ? x[a] : x), p.p1 = p.p0 + p.w, p.s0 = p.b, p.s1 = p.s0 + p.s, v) {
                            var L = Math.min(p.s0, p.s1) || 0, _ = Math.max(p.s0, p.s1) || 0, C = p[r];
                            h[C] = C in h ? Math.min(h[C], L) : L, d[C] = C in d ? Math.max(d[C], _) : _;
                        }
                    }
                }
                v && ivt(e, h, d, t);
            }
            function eT(e) {
                return e._id.charAt(0);
            }
            rve.exports = {
                crossTraceCalc: Zdt,
                setGroupPositions: oU
            };
        });
        var ove = ye((znr, ave)=>{
            "use strict";
            var ive = q0(), nve = Gb().setGroupPositions;
            function avt(e, t) {
                for(var r = t.xaxis, n = t.yaxis, i = e._fullLayout, a = e._fullData, o = e.calcdata, s = [], l = [], u = 0; u < a.length; u++){
                    var c = a[u];
                    c.visible === !0 && c.type === "scatter" && c.xaxis === r._id && c.yaxis === n._id && (c.orientation === "h" ? s.push(o[u]) : c.orientation === "v" && l.push(o[u]));
                }
                var f = {
                    mode: i.scattermode,
                    gap: i.scattergap
                };
                nve(e, r, n, l, f), nve(e, n, r, s, f);
            }
            ave.exports = function(t, r) {
                t._fullLayout.scattermode === "group" && avt(t, r);
                var n = r.xaxis, i = r.yaxis, a = n._id + i._id, o = t._fullLayout._scatterStackOpts[a];
                if (o) {
                    var s = t.calcdata, l, u, c, f, h, d, v, x, b, p, E, k, A, L, _;
                    for(var C in o){
                        p = o[C];
                        var M = p.traceIndices;
                        if (M.length) {
                            for(E = p.stackgaps === "interpolate", k = p.groupnorm, p.orientation === "v" ? (A = "x", L = "y") : (A = "y", L = "x"), _ = new Array(M.length), l = 0; l < _.length; l++)_[l] = !1;
                            d = s[M[0]];
                            var g = new Array(d.length);
                            for(l = 0; l < d.length; l++)g[l] = d[l][A];
                            for(l = 1; l < M.length; l++){
                                for(h = s[M[l]], u = c = 0; u < h.length; u++){
                                    for(v = h[u][A]; v > g[c] && c < g.length; c++)uU(h, u, g[c], l, _, E, A), u++;
                                    if (v !== g[c]) {
                                        for(f = 0; f < l; f++)uU(s[M[f]], c, v, f, _, E, A);
                                        g.splice(c, 0, v);
                                    }
                                    c++;
                                }
                                for(; c < g.length; c++)uU(h, u, g[c], l, _, E, A), u++;
                            }
                            var P = g.length;
                            for(u = 0; u < d.length; u++){
                                for(x = d[u][L] = d[u].s, l = 1; l < M.length; l++)h = s[M[l]], h[0].trace._rawLength = h[0].trace._length, h[0].trace._length = P, x += h[u].s, h[u][L] = x;
                                if (k) for(b = (k === "fraction" ? x : x / 100) || 1, l = 0; l < M.length; l++){
                                    var T = s[M[l]][u];
                                    T[L] /= b, T.sNorm = T.s / b;
                                }
                            }
                            for(l = 0; l < M.length; l++){
                                h = s[M[l]];
                                var F = h[0].trace, q = ive.calcMarkerSize(F, F._rawLength), V = Array.isArray(q);
                                if (q && _[l] || V) {
                                    var H = q;
                                    for(q = new Array(P), u = 0; u < P; u++)q[u] = h[u].gap ? 0 : V ? H[h[u].i] : H;
                                }
                                var X = new Array(P), G = new Array(P);
                                for(u = 0; u < P; u++)X[u] = h[u].x, G[u] = h[u].y;
                                ive.calcAxisExpansion(t, F, n, i, X, G, q), h[0].t.orientation = p.orientation;
                            }
                        }
                    }
                }
            };
            function uU(e, t, r, n, i, a, o) {
                i[n] = !0;
                var s = {
                    i: null,
                    gap: !0,
                    s: 0
                };
                if (s[o] = r, e.splice(t, 0, s), t && r === e[t - 1][o]) {
                    var l = e[t - 1];
                    s.s = l.s, s.i = l.i, s.gap = l.gap;
                } else a && (s.s = ovt(e, t, r, o));
                t || (e[0].t = e[1].t, e[0].trace = e[1].trace, delete e[1].t, delete e[1].trace);
            }
            function ovt(e, t, r, n) {
                var i = e[t - 1], a = e[t + 1];
                return a ? i ? i.s + (a.s - i.s) * (r - i[n]) / (a[n] - i[n]) : a.s : i.s;
            }
        });
        var fU = ye((Fnr, hve)=>{
            "use strict";
            var svt = ao(), cve = es(), WM = cve.BADNUM, fve = cve.LOG_CLIP, sve = fve + .5, lve = fve - .5, YP = Mr(), lvt = YP.segmentsIntersect, uve = YP.constrain, cU = Sm();
            hve.exports = function(t, r) {
                var n = r.trace || {}, i = r.xaxis, a = r.yaxis, o = i.type === "log", s = a.type === "log", l = i._length, u = a._length, c = r.backoff, f = n.marker, h = r.connectGaps, d = r.baseTolerance, v = r.shape, x = v === "linear", b = n.fill && n.fill !== "none", p = [], E = cU.minTolerance, k = t.length, A = new Array(k), L = 0, _, C, M, g, P, T, F, q, V, H, X, G, N, W, re, ae;
                function _e(ut) {
                    var Ne = t[ut];
                    if (!Ne) return !1;
                    var Ye = r.linearized ? i.l2p(Ne.x) : i.c2p(Ne.x), Ve = r.linearized ? a.l2p(Ne.y) : a.c2p(Ne.y);
                    if (Ye === WM) {
                        if (o && (Ye = i.c2p(Ne.x, !0)), Ye === WM) return !1;
                        s && Ve === WM && (Ye *= Math.abs(i._m * u * (i._m > 0 ? sve : lve) / (a._m * l * (a._m > 0 ? sve : lve)))), Ye *= 1e3;
                    }
                    if (Ve === WM) {
                        if (s && (Ve = a.c2p(Ne.y, !0)), Ve === WM) return !1;
                        Ve *= 1e3;
                    }
                    return [
                        Ye,
                        Ve
                    ];
                }
                function Me(ut, Ne, Ye, Ve) {
                    var Xe = Ye - ut, ht = Ve - Ne, Le = .5 - ut, xe = .5 - Ne, Se = Xe * Xe + ht * ht, lt = Xe * Le + ht * xe;
                    if (lt > 0 && lt < Se) {
                        var Gt = Le * ht - xe * Xe;
                        if (Gt * Gt < Se) return !0;
                    }
                }
                var ke, ge;
                function ie(ut, Ne) {
                    var Ye = ut[0] / l, Ve = ut[1] / u, Xe = Math.max(0, -Ye, Ye - 1, -Ve, Ve - 1);
                    return Xe && ke !== void 0 && Me(Ye, Ve, ke, ge) && (Xe = 0), Xe && Ne && Me(Ye, Ve, Ne[0] / l, Ne[1] / u) && (Xe = 0), (1 + cU.toleranceGrowth * Xe) * d;
                }
                function Te(ut, Ne) {
                    var Ye = ut[0] - Ne[0], Ve = ut[1] - Ne[1];
                    return Math.sqrt(Ye * Ye + Ve * Ve);
                }
                var Ee = cU.maxScreensAway, Ae = -l * Ee, ze = l * (1 + Ee), Ce = -u * Ee, me = u * (1 + Ee), Re = [
                    [
                        Ae,
                        Ce,
                        ze,
                        Ce
                    ],
                    [
                        ze,
                        Ce,
                        ze,
                        me
                    ],
                    [
                        ze,
                        me,
                        Ae,
                        me
                    ],
                    [
                        Ae,
                        me,
                        Ae,
                        Ce
                    ]
                ], ce, Ge, nt, ct, qt, rt;
                function ot(ut, Ne) {
                    for(var Ye = [], Ve = 0, Xe = 0; Xe < 4; Xe++){
                        var ht = Re[Xe], Le = lvt(ut[0], ut[1], Ne[0], Ne[1], ht[0], ht[1], ht[2], ht[3]);
                        Le && (!Ve || Math.abs(Le.x - Ye[0][0]) > 1 || Math.abs(Le.y - Ye[0][1]) > 1) && (Le = [
                            Le.x,
                            Le.y
                        ], Ve && Te(Le, ut) < Te(Ye[0], ut) ? Ye.unshift(Le) : Ye.push(Le), Ve++);
                    }
                    return Ye;
                }
                function Rt(ut) {
                    if (ut[0] < Ae || ut[0] > ze || ut[1] < Ce || ut[1] > me) return [
                        uve(ut[0], Ae, ze),
                        uve(ut[1], Ce, me)
                    ];
                }
                function kt(ut, Ne) {
                    if (ut[0] === Ne[0] && (ut[0] === Ae || ut[0] === ze) || ut[1] === Ne[1] && (ut[1] === Ce || ut[1] === me)) return !0;
                }
                function Ct(ut, Ne) {
                    var Ye = [], Ve = Rt(ut), Xe = Rt(Ne);
                    return Ve && Xe && kt(Ve, Xe) || (Ve && Ye.push(Ve), Xe && Ye.push(Xe)), Ye;
                }
                function Yt(ut, Ne, Ye) {
                    return function(Ve, Xe) {
                        var ht = Rt(Ve), Le = Rt(Xe), xe = [];
                        if (ht && Le && kt(ht, Le)) return xe;
                        ht && xe.push(ht), Le && xe.push(Le);
                        var Se = 2 * YP.constrain((Ve[ut] + Xe[ut]) / 2, Ne, Ye) - ((ht || Ve)[ut] + (Le || Xe)[ut]);
                        if (Se) {
                            var lt;
                            ht && Le ? lt = Se > 0 == ht[ut] > Le[ut] ? ht : Le : lt = ht || Le, lt[ut] += Se;
                        }
                        return xe;
                    };
                }
                var xr;
                v === "linear" || v === "spline" ? xr = ot : v === "hv" || v === "vh" ? xr = Ct : v === "hvh" ? xr = Yt(0, Ae, ze) : v === "vhv" && (xr = Yt(1, Ce, me));
                function er(ut, Ne) {
                    var Ye = Ne[0] - ut[0], Ve = (Ne[1] - ut[1]) / Ye, Xe = (ut[1] * Ne[0] - Ne[1] * ut[0]) / Ye;
                    return Xe > 0 ? [
                        Ve > 0 ? Ae : ze,
                        me
                    ] : [
                        Ve > 0 ? ze : Ae,
                        Ce
                    ];
                }
                function Ke(ut) {
                    var Ne = ut[0], Ye = ut[1], Ve = Ne === A[L - 1][0], Xe = Ye === A[L - 1][1];
                    if (!(Ve && Xe)) {
                        if (L > 1) {
                            var ht = Ne === A[L - 2][0], Le = Ye === A[L - 2][1];
                            Ve && (Ne === Ae || Ne === ze) && ht ? Le ? L-- : A[L - 1] = ut : Xe && (Ye === Ce || Ye === me) && Le ? ht ? L-- : A[L - 1] = ut : A[L++] = ut;
                        } else A[L++] = ut;
                    }
                }
                function xt(ut) {
                    A[L - 1][0] !== ut[0] && A[L - 1][1] !== ut[1] && Ke([
                        nt,
                        ct
                    ]), Ke(ut), qt = null, nt = ct = 0;
                }
                var bt = YP.isArrayOrTypedArray(f);
                function Lt(ut) {
                    if (ut && c && (ut.i = _, ut.d = t, ut.trace = n, ut.marker = bt ? f[ut.i] : f, ut.backoff = c), ke = ut[0] / l, ge = ut[1] / u, ce = ut[0] < Ae ? Ae : ut[0] > ze ? ze : 0, Ge = ut[1] < Ce ? Ce : ut[1] > me ? me : 0, ce || Ge) {
                        if (!L) A[L++] = [
                            ce || ut[0],
                            Ge || ut[1]
                        ];
                        else if (qt) {
                            var Ne = xr(qt, ut);
                            Ne.length > 1 && (xt(Ne[0]), A[L++] = Ne[1]);
                        } else rt = xr(A[L - 1], ut)[0], A[L++] = rt;
                        var Ye = A[L - 1];
                        ce && Ge && (Ye[0] !== ce || Ye[1] !== Ge) ? (qt && (nt !== ce && ct !== Ge ? Ke(nt && ct ? er(qt, ut) : [
                            nt || ce,
                            ct || Ge
                        ]) : nt && ct && Ke([
                            nt,
                            ct
                        ])), Ke([
                            ce,
                            Ge
                        ])) : nt - ce && ct - Ge && Ke([
                            ce || nt,
                            Ge || ct
                        ]), qt = ut, nt = ce, ct = Ge;
                    } else qt && xt(xr(qt, ut)[0]), A[L++] = ut;
                }
                for(_ = 0; _ < k; _++)if (C = _e(_), !!C) {
                    for(L = 0, qt = null, Lt(C), _++; _ < k; _++){
                        if (g = _e(_), !g) {
                            if (h) continue;
                            break;
                        }
                        if (!x || !r.simplify) {
                            Lt(g);
                            continue;
                        }
                        var St = _e(_ + 1);
                        if (H = Te(g, C), !(!(b && (L === 0 || L === k - 1)) && H < ie(g, St) * E)) {
                            for(q = [
                                (g[0] - C[0]) / H,
                                (g[1] - C[1]) / H
                            ], P = C, X = H, G = W = re = 0, F = !1, M = g, _++; _ < t.length; _++){
                                if (T = St, St = _e(_ + 1), !T) {
                                    if (h) continue;
                                    break;
                                }
                                if (V = [
                                    T[0] - C[0],
                                    T[1] - C[1]
                                ], ae = V[0] * q[1] - V[1] * q[0], W = Math.min(W, ae), re = Math.max(re, ae), re - W > ie(T, St)) break;
                                M = T, N = V[0] * q[0] + V[1] * q[1], N > X ? (X = N, g = T, F = !1) : N < G && (G = N, P = T, F = !0);
                            }
                            if (F ? (Lt(g), M !== P && Lt(P)) : (P !== C && Lt(P), M !== g && Lt(g)), Lt(M), _ >= t.length || !T) break;
                            Lt(T), C = T;
                        }
                    }
                    qt && Ke([
                        nt || qt[0],
                        ct || qt[1]
                    ]), p.push(A.slice(0, L));
                }
                var Et = v.slice(v.length - 1);
                if (c && Et !== "h" && Et !== "v") {
                    for(var dt = !1, Ht = -1, $t = [], fr = 0; fr < p.length; fr++)for(var _r = 0; _r < p[fr].length - 1; _r++){
                        var Br = p[fr][_r], Or = p[fr][_r + 1], Nr = svt.applyBackoff(Or, Br);
                        (Nr[0] !== Or[0] || Nr[1] !== Or[1]) && (dt = !0), $t[Ht + 1] || (Ht++, $t[Ht] = [
                            Br,
                            [
                                Nr[0],
                                Nr[1]
                            ]
                        ]);
                    }
                    return dt ? $t : p;
                }
                return p;
            };
        });
        var hU = ye((qnr, vve)=>{
            "use strict";
            var dve = {
                tonextx: 1,
                tonexty: 1,
                tonext: 1
            };
            vve.exports = function(t, r, n) {
                var i, a, o, s, l, u = {}, c = !1, f = -1, h = 0, d = -1;
                for(a = 0; a < n.length; a++)i = n[a][0].trace, o = i.stackgroup || "", o ? o in u ? l = u[o] : (l = u[o] = h, h++) : i.fill in dve && d >= 0 ? l = d : (l = d = h, h++), l < f && (c = !0), i._groupIndex = f = l;
                var v = n.slice();
                c && v.sort(function(b, p) {
                    var E = b[0].trace, k = p[0].trace;
                    return E._groupIndex - k._groupIndex || E.index - k.index;
                });
                var x = {};
                for(a = 0; a < v.length; a++)i = v[a][0].trace, o = i.stackgroup || "", i.visible === !0 ? (i._nexttrace = null, i.fill in dve && (s = x[o], i._prevtrace = s || null, s && (s._nexttrace = i)), i._ownfill = i.fill && (i.fill.substr(0, 6) === "tozero" || i.fill === "toself" || i.fill.substr(0, 2) === "to" && !i._prevtrace), x[o] = i) : i._prevtrace = i._nexttrace = i._ownfill = null;
                return v;
            };
        });
        var iT = ye((Onr, mve)=>{
            "use strict";
            var Dg = xa(), uvt = ba(), ZM = Mr(), tT = ZM.ensureSingle, gve = ZM.identity, zf = ao(), rT = lu(), cvt = fU(), fvt = hU(), KP = wM().tester;
            mve.exports = function(t, r, n, i, a, o) {
                var s, l, u = !a, c = !!a && a.duration > 0, f = fvt(t, r, n);
                if (s = i.selectAll("g.trace").data(f, function(d) {
                    return d[0].trace.uid;
                }), s.enter().append("g").attr("class", function(d) {
                    return "trace scatter trace" + d[0].trace.uid;
                }).style("stroke-miterlimit", 2), s.order(), hvt(t, s, r), c) {
                    o && (l = o());
                    var h = Dg.transition().duration(a.duration).ease(a.easing).each("end", function() {
                        l && l();
                    }).each("interrupt", function() {
                        l && l();
                    });
                    h.each(function() {
                        i.selectAll("g.trace").each(function(d, v) {
                            pve(t, v, r, d, f, this, a);
                        });
                    });
                } else s.each(function(d, v) {
                    pve(t, v, r, d, f, this, a);
                });
                u && s.exit().remove(), i.selectAll("path:not([d])").remove();
            };
            function hvt(e, t, r) {
                t.each(function(n) {
                    var i = tT(Dg.select(this), "g", "fills");
                    zf.setClipUrl(i, r.layerClipId, e);
                    var a = n[0].trace, o = [];
                    a._ownfill && o.push("_ownFill"), a._nexttrace && o.push("_nextFill");
                    var s = i.selectAll("g").data(o, gve);
                    s.enter().append("g"), s.exit().each(function(l) {
                        a[l] = null;
                    }).remove(), s.order().each(function(l) {
                        a[l] = tT(Dg.select(this), "path", "js-fill");
                    });
                });
            }
            function pve(e, t, r, n, i, a, o) {
                var s = e._context.staticPlot, l;
                dvt(e, t, r, n, i);
                var u = !!o && o.duration > 0;
                function c(Yt) {
                    return u ? Yt.transition() : Yt;
                }
                var f = r.xaxis, h = r.yaxis, d = n[0].trace, v = d.line, x = Dg.select(a), b = tT(x, "g", "errorbars"), p = tT(x, "g", "lines"), E = tT(x, "g", "points"), k = tT(x, "g", "text");
                if (uvt.getComponentMethod("errorbars", "plot")(e, b, r, o), d.visible !== !0) return;
                c(x).style("opacity", d.opacity);
                var A, L, _ = d.fill.charAt(d.fill.length - 1);
                _ !== "x" && _ !== "y" && (_ = "");
                var C, M;
                _ === "y" ? (C = 1, M = h.c2p(0, !0)) : _ === "x" && (C = 0, M = f.c2p(0, !0)), n[0][r.isRangePlot ? "nodeRangePlot3" : "node3"] = x;
                var g = "", P = [], T = d._prevtrace, F = null, q = null;
                T && (g = T._prevRevpath || "", L = T._nextFill, P = T._ownPolygons, F = T._fillsegments, q = T._fillElement);
                var V, H, X = "", G = "", N, W, re, ae, _e, Me, ke = [];
                d._polygons = [];
                var ge = [], ie = [], Te = ZM.noop;
                if (A = d._ownFill, rT.hasLines(d) || d.fill !== "none") {
                    L && L.datum(n), [
                        "hv",
                        "vh",
                        "hvh",
                        "vhv"
                    ].indexOf(v.shape) !== -1 ? (N = zf.steps(v.shape), W = zf.steps(v.shape.split("").reverse().join(""))) : v.shape === "spline" ? N = W = function(Yt) {
                        var xr = Yt[Yt.length - 1];
                        return Yt.length > 1 && Yt[0][0] === xr[0] && Yt[0][1] === xr[1] ? zf.smoothclosed(Yt.slice(1), v.smoothing) : zf.smoothopen(Yt, v.smoothing);
                    } : N = W = function(Yt) {
                        return "M" + Yt.join("L");
                    }, re = function(Yt) {
                        return W(Yt.reverse());
                    }, ie = cvt(n, {
                        xaxis: f,
                        yaxis: h,
                        trace: d,
                        connectGaps: d.connectgaps,
                        baseTolerance: Math.max(v.width || 1, 3) / 4,
                        shape: v.shape,
                        backoff: v.backoff,
                        simplify: v.simplify,
                        fill: d.fill
                    }), ge = new Array(ie.length);
                    var Ee = 0;
                    for(l = 0; l < ie.length; l++){
                        var Ae, ze = ie[l];
                        !Ae || !_ ? (Ae = ze.slice(), ge[Ee] = Ae, Ee++) : Ae.push.apply(Ae, ze);
                    }
                    d._fillElement = null, d._fillExclusionElement = q, d._fillsegments = ge.slice(0, Ee), ge = d._fillsegments, ie.length && (ae = ie[0][0].slice(), _e = ie[ie.length - 1], Me = _e[_e.length - 1].slice()), Te = function(Yt) {
                        return function(xr) {
                            if (V = N(xr), H = re(xr), X ? _ ? (X += "L" + V.substr(1), G = H + ("L" + G.substr(1))) : (X += "Z" + V, G = H + "Z" + G) : (X = V, G = H), rT.hasLines(d)) {
                                var er = Dg.select(this);
                                if (er.datum(n), Yt) c(er.style("opacity", 0).attr("d", V).call(zf.lineGroupStyle)).style("opacity", 1);
                                else {
                                    var Ke = c(er);
                                    Ke.attr("d", V), zf.singleLineStyle(n, Ke);
                                }
                            }
                        };
                    };
                }
                var Ce = p.selectAll(".js-line").data(ie);
                c(Ce.exit()).style("opacity", 0).remove(), Ce.each(Te(!1)), Ce.enter().append("path").classed("js-line", !0).style("vector-effect", s ? "none" : "non-scaling-stroke").call(zf.lineGroupStyle).each(Te(!0)), zf.setClipUrl(Ce, r.layerClipId, e);
                function me(Yt) {
                    c(Yt).attr("d", "M0,0Z");
                }
                var Re = function() {
                    var Yt = new Array(ge.length);
                    for(l = 0; l < ge.length; l++)Yt[l] = KP(ge[l]);
                    return Yt;
                }, ce = function(Yt) {
                    var xr, er;
                    if (!Yt || Yt.length === 0) for(xr = new Array(ge.length), er = 0; er < ge.length; er++){
                        var Ke = ge[er][0].slice(), xt = ge[er][ge[er].length - 1].slice();
                        Ke[C] = xt[C] = M;
                        var bt = [
                            xt,
                            Ke
                        ], Lt = bt.concat(ge[er]);
                        xr[er] = KP(Lt);
                    }
                    else {
                        for(xr = new Array(Yt.length - 1 + ge.length), er = 0; er < Yt.length - 1; er++)xr[er] = KP(Yt[er]);
                        var St = Yt[Yt.length - 1].slice();
                        for(St.reverse(), er = 0; er < ge.length; er++)xr[Yt.length - 1 + er] = KP(ge[er].concat(St));
                    }
                    return xr;
                };
                ie.length ? (A ? (A.datum(n), ae && Me && (_ ? (ae[C] = Me[C] = M, c(A).attr("d", "M" + Me + "L" + ae + "L" + X.substr(1)).call(zf.singleFillStyle, e), ke = ce(null)) : (c(A).attr("d", X + "Z").call(zf.singleFillStyle, e), ke = Re())), d._polygons = ke, d._fillElement = A) : L && (d.fill.substr(0, 6) === "tonext" && X && g ? (d.fill === "tonext" ? (c(L).attr("d", X + "Z" + g + "Z").call(zf.singleFillStyle, e), ke = Re(), d._polygons = ke.concat(P)) : (c(L).attr("d", X + "L" + g.substr(1) + "Z").call(zf.singleFillStyle, e), ke = ce(F), d._polygons = ke), d._fillElement = L) : me(L)), d._prevRevpath = G) : (A ? me(A) : L && me(L), d._prevRevpath = null), d._ownPolygons = ke;
                function Ge(Yt) {
                    return Yt.filter(function(xr) {
                        return !xr.gap && xr.vis;
                    });
                }
                function nt(Yt) {
                    return Yt.filter(function(xr) {
                        return xr.vis;
                    });
                }
                function ct(Yt) {
                    return Yt.filter(function(xr) {
                        return !xr.gap;
                    });
                }
                function qt(Yt) {
                    return Yt.id;
                }
                function rt(Yt) {
                    if (Yt.ids) return qt;
                }
                function ot() {
                    return !1;
                }
                function Rt(Yt, xr, er) {
                    var Ke, xt, bt, Lt = er[0].trace, St = rT.hasMarkers(Lt), Et = rT.hasText(Lt), dt = rt(Lt), Ht = ot, $t = ot;
                    if (St || Et) {
                        var fr = gve, _r = Lt.stackgroup, Br = _r && e._fullLayout._scatterStackOpts[f._id + h._id][_r].stackgaps === "infer zero";
                        Lt.marker.maxdisplayed || Lt._needsCull ? fr = Br ? nt : Ge : _r && !Br && (fr = ct), St && (Ht = fr), Et && ($t = fr);
                    }
                    xt = Yt.selectAll("path.point"), Ke = xt.data(Ht, dt);
                    var Or = Ke.enter().append("path").classed("point", !0);
                    u && Or.call(zf.pointStyle, Lt, e).call(zf.translatePoints, f, h).style("opacity", 0).transition().style("opacity", 1), Ke.order();
                    var Nr;
                    St && (Nr = zf.makePointStyleFns(Lt)), Ke.each(function(ut) {
                        var Ne = Dg.select(this), Ye = c(Ne);
                        bt = zf.translatePoint(ut, Ye, f, h), bt ? (zf.singlePointStyle(ut, Ye, Lt, Nr, e), r.layerClipId && zf.hideOutsideRangePoint(ut, Ye, f, h, Lt.xcalendar, Lt.ycalendar), Lt.customdata && Ne.classed("plotly-customdata", ut.data !== null && ut.data !== void 0)) : Ye.remove();
                    }), u ? Ke.exit().transition().style("opacity", 0).remove() : Ke.exit().remove(), xt = xr.selectAll("g"), Ke = xt.data($t, dt), Ke.enter().append("g").classed("textpoint", !0).append("text"), Ke.order(), Ke.each(function(ut) {
                        var Ne = Dg.select(this), Ye = c(Ne.select("text"));
                        bt = zf.translatePoint(ut, Ye, f, h), bt ? r.layerClipId && zf.hideOutsideRangePoint(ut, Ne, f, h, Lt.xcalendar, Lt.ycalendar) : Ne.remove();
                    }), Ke.selectAll("text").call(zf.textPointStyle, Lt, e).each(function(ut) {
                        var Ne = f.c2p(ut.x), Ye = h.c2p(ut.y);
                        Dg.select(this).selectAll("tspan.line").each(function() {
                            c(Dg.select(this)).attr({
                                x: Ne,
                                y: Ye
                            });
                        });
                    }), Ke.exit().remove();
                }
                E.datum(n), k.datum(n), Rt(E, k, n);
                var kt = d.cliponaxis === !1, Ct = kt ? null : r.layerClipId;
                zf.setClipUrl(E, Ct, e), zf.setClipUrl(k, Ct, e);
            }
            function dvt(e, t, r, n, i) {
                var a = r.xaxis, o = r.yaxis, s = Dg.extent(ZM.simpleMap(a.range, a.r2c)), l = Dg.extent(ZM.simpleMap(o.range, o.r2c)), u = n[0].trace;
                if (rT.hasMarkers(u)) {
                    var c = u.marker.maxdisplayed;
                    if (c !== 0) {
                        var f = n.filter(function(x) {
                            return x.x >= s[0] && x.x <= s[1] && x.y >= l[0] && x.y <= l[1];
                        }), h = Math.ceil(f.length / c), d = 0;
                        i.forEach(function(x, b) {
                            var p = x[0].trace;
                            rT.hasMarkers(p) && p.marker.maxdisplayed > 0 && b < t && d++;
                        });
                        var v = Math.round(d * h / 3 + Math.floor(d / 3) * h / 7.1);
                        n.forEach(function(x) {
                            delete x.vis;
                        }), f.forEach(function(x, b) {
                            Math.round((b + v) % h) === 0 && (x.vis = !0);
                        });
                    }
                }
            }
        });
        var Kd = ye((Bnr, yve)=>{
            "use strict";
            yve.exports = {
                container: "marker",
                min: "cmin",
                max: "cmax"
            };
        });
        var $P = ye((Nnr, _ve)=>{
            "use strict";
            var JP = Qa();
            _ve.exports = function(t, r, n) {
                var i = {}, a = {
                    _fullLayout: n
                }, o = JP.getFromTrace(a, r, "x"), s = JP.getFromTrace(a, r, "y"), l = t.orig_x;
                l === void 0 && (l = t.x);
                var u = t.orig_y;
                return u === void 0 && (u = t.y), i.xLabel = JP.tickText(o, o.c2l(l), !0).text, i.yLabel = JP.tickText(s, s.c2l(u), !0).text, i;
            };
        });
        var op = ye((Unr, xve)=>{
            "use strict";
            var dU = xa(), nT = ao(), vvt = ba();
            function pvt(e) {
                var t = dU.select(e).selectAll("g.trace.scatter");
                t.style("opacity", function(r) {
                    return r[0].trace.opacity;
                }), t.selectAll("g.points").each(function(r) {
                    var n = dU.select(this), i = r.trace || r[0].trace;
                    vU(n, i, e);
                }), t.selectAll("g.text").each(function(r) {
                    var n = dU.select(this), i = r.trace || r[0].trace;
                    pU(n, i, e);
                }), t.selectAll("g.trace path.js-line").call(nT.lineGroupStyle), t.selectAll("g.trace path.js-fill").call(nT.fillGroupStyle, e, !1), vvt.getComponentMethod("errorbars", "style")(t);
            }
            function vU(e, t, r) {
                nT.pointStyle(e.selectAll("path.point"), t, r);
            }
            function pU(e, t, r) {
                nT.textPointStyle(e.selectAll("text"), t, r);
            }
            function gvt(e, t, r) {
                var n = t[0].trace;
                n.selectedpoints ? (nT.selectedPointStyle(r.selectAll("path.point"), n), nT.selectedTextStyle(r.selectAll("text"), n)) : (vU(r, n, e), pU(r, n, e));
            }
            xve.exports = {
                style: pvt,
                stylePoints: vU,
                styleText: pU,
                styleOnSelect: gvt
            };
        });
        var oT = ye((Vnr, bve)=>{
            "use strict";
            var aT = va(), mvt = lu();
            bve.exports = function(t, r) {
                var n, i;
                if (t.mode === "lines") return n = t.line.color, n && aT.opacity(n) ? n : t.fillcolor;
                if (t.mode === "none") return t.fill ? t.fillcolor : "";
                var a = r.mcc || (t.marker || {}).color, o = r.mlcc || ((t.marker || {}).line || {}).color;
                return i = a && aT.opacity(a) ? a : o && aT.opacity(o) && (r.mlw || ((t.marker || {}).line || {}).width) ? o : "", i ? aT.opacity(i) < .3 ? aT.addOpacity(i, .3) : i : (n = (t.line || {}).color, n && aT.opacity(n) && mvt.hasLines(t) && t.line.width ? n : t.fillcolor);
            };
        });
        var sT = ye((Hnr, Tve)=>{
            "use strict";
            var QP = Mr(), wve = Nc(), yvt = ba(), _vt = oT(), gU = va(), xvt = QP.fillText;
            Tve.exports = function(t, r, n, i) {
                var a = t.cd, o = a[0].trace, s = t.xa, l = t.ya, u = s.c2p(r), c = l.c2p(n), f = [
                    u,
                    c
                ], h = o.hoveron || "", d = o.mode.indexOf("markers") !== -1 ? 3 : .5, v = !!o.xperiodalignment, x = !!o.yperiodalignment;
                if (h.indexOf("points") !== -1) {
                    var b = function(G) {
                        if (v) {
                            var N = s.c2p(G.xStart), W = s.c2p(G.xEnd);
                            return u >= Math.min(N, W) && u <= Math.max(N, W) ? 0 : 1 / 0;
                        }
                        var re = Math.max(3, G.mrc || 0), ae = 1 - 1 / re, _e = Math.abs(s.c2p(G.x) - u);
                        return _e < re ? ae * _e / re : _e - re + ae;
                    }, p = function(G) {
                        if (x) {
                            var N = l.c2p(G.yStart), W = l.c2p(G.yEnd);
                            return c >= Math.min(N, W) && c <= Math.max(N, W) ? 0 : 1 / 0;
                        }
                        var re = Math.max(3, G.mrc || 0), ae = 1 - 1 / re, _e = Math.abs(l.c2p(G.y) - c);
                        return _e < re ? ae * _e / re : _e - re + ae;
                    }, E = function(G) {
                        var N = Math.max(d, G.mrc || 0), W = s.c2p(G.x) - u, re = l.c2p(G.y) - c;
                        return Math.max(Math.sqrt(W * W + re * re) - N, 1 - d / N);
                    }, k = wve.getDistanceFunction(i, b, p, E);
                    if (wve.getClosest(a, k, t), t.index !== !1) {
                        var A = a[t.index], L = s.c2p(A.x, !0), _ = l.c2p(A.y, !0), C = A.mrc || 1;
                        t.index = A.i;
                        var M = a[0].t.orientation, g = M && (A.sNorm || A.s), P = M === "h" ? g : A.orig_x !== void 0 ? A.orig_x : A.x, T = M === "v" ? g : A.orig_y !== void 0 ? A.orig_y : A.y;
                        return QP.extendFlat(t, {
                            color: _vt(o, A),
                            x0: L - C,
                            x1: L + C,
                            xLabelVal: P,
                            y0: _ - C,
                            y1: _ + C,
                            yLabelVal: T,
                            spikeDistance: E(A),
                            hovertemplate: o.hovertemplate
                        }), xvt(A, o, t), yvt.getComponentMethod("errorbars", "hoverInfo")(A, o, t), [
                            t
                        ];
                    }
                }
                function F(G) {
                    if (!G) return !1;
                    var N = G.node();
                    try {
                        var W = new DOMPoint(f[0], f[1]);
                        return N.isPointInFill(W);
                    } catch (ae) {
                        var re = N.ownerSVGElement.createSVGPoint();
                        return re.x = f[0], re.y = f[1], N.isPointInFill(re);
                    }
                }
                function q(G) {
                    var N, W = [], re = 1 / 0, ae = -1 / 0, _e = 1 / 0, Me = -1 / 0, ke;
                    for(N = 0; N < G.length; N++){
                        var ge = G[N];
                        ge.contains(f) && (W.push(ge), _e = Math.min(_e, ge.ymin), Me = Math.max(Me, ge.ymax));
                    }
                    if (W.length === 0) return null;
                    _e = Math.max(_e, 0), Me = Math.min(Me, l._length), ke = (_e + Me) / 2;
                    var ie, Te, Ee, Ae, ze, Ce, me;
                    for(N = 0; N < W.length; N++)for(Te = W[N].pts, ie = 1; ie < Te.length; ie++)Ce = Te[ie - 1][1], me = Te[ie][1], Ce > ke != me >= ke && (Ae = Te[ie - 1][0], ze = Te[ie][0], me - Ce && (Ee = Ae + (ze - Ae) * (ke - Ce) / (me - Ce), re = Math.min(re, Ee), ae = Math.max(ae, Ee)));
                    return re = Math.max(re, 0), ae = Math.min(ae, s._length), {
                        x0: re,
                        x1: ae,
                        y0: ke,
                        y1: ke
                    };
                }
                if (h.indexOf("fills") !== -1 && o._fillElement) {
                    var V = F(o._fillElement) && !F(o._fillExclusionElement);
                    if (V) {
                        var H = q(o._polygons);
                        H === null && (H = {
                            x0: f[0],
                            x1: f[0],
                            y0: f[1],
                            y1: f[1]
                        });
                        var X = gU.defaultLine;
                        return gU.opacity(o.fillcolor) ? X = o.fillcolor : gU.opacity((o.line || {}).color) && (X = o.line.color), QP.extendFlat(t, {
                            distance: t.maxHoverDistance,
                            x0: H.x0,
                            x1: H.x1,
                            y0: H.y0,
                            y1: H.y1,
                            color: X,
                            hovertemplate: !1
                        }), delete t.index, o.text && !QP.isArrayOrTypedArray(o.text) ? t.text = String(o.text) : t.text = o.name, [
                            t
                        ];
                    }
                }
            };
        });
        var lT = ye((Gnr, Sve)=>{
            "use strict";
            var Ave = lu();
            Sve.exports = function(t, r) {
                var n = t.cd, i = t.xaxis, a = t.yaxis, o = [], s = n[0].trace, l, u, c, f, h = !Ave.hasMarkers(s) && !Ave.hasText(s);
                if (h) return [];
                if (r === !1) for(l = 0; l < n.length; l++)n[l].selected = 0;
                else for(l = 0; l < n.length; l++)u = n[l], c = i.c2p(u.x), f = a.c2p(u.y), u.i !== null && r.contains([
                    c,
                    f
                ], !1, l, t) ? (o.push({
                    pointNumber: u.i,
                    x: i.c2d(u.x),
                    y: a.c2d(u.y)
                }), u.selected = 1) : u.selected = 0;
                return o;
            };
        });
        var Eve = ye((jnr, Mve)=>{
            "use strict";
            Mve.exports = {
                xaxis: {
                    valType: "subplotid",
                    dflt: "x",
                    editType: "calc+clearAxisTypes"
                },
                yaxis: {
                    valType: "subplotid",
                    dflt: "y",
                    editType: "calc+clearAxisTypes"
                }
            };
        });
        var yU = ye((Wnr, Lve)=>{
            "use strict";
            var XM = ba().traceIs, mU = L3();
            Lve.exports = function(t, r, n, i) {
                n("autotypenumbers", i.autotypenumbersDflt);
                var a = n("type", (i.splomStash || {}).type);
                a === "-" && (bvt(r, i.data), r.type === "-" ? r.type = "linear" : t.type = r.type);
            };
            function bvt(e, t) {
                if (e.type === "-") {
                    var r = e._id, n = r.charAt(0), i;
                    r.indexOf("scene") !== -1 && (r = n);
                    var a = wvt(t, r, n);
                    if (a) {
                        if (a.type === "histogram" && n === ({
                            v: "y",
                            h: "x"
                        })[a.orientation || "v"]) {
                            e.type = "linear";
                            return;
                        }
                        var o = n + "calendar", s = a[o], l = {
                            noMultiCategory: !XM(a, "cartesian") || XM(a, "noMultiCategory")
                        };
                        if (a.type === "box" && a._hasPreCompStats && n === ({
                            h: "x",
                            v: "y"
                        })[a.orientation || "v"] && (l.noMultiCategory = !0), l.autotypenumbers = e.autotypenumbers, Cve(a, n)) {
                            var u = kve(a), c = [];
                            for(i = 0; i < t.length; i++){
                                var f = t[i];
                                !XM(f, "box-violin") || (f[n + "axis"] || n) !== r || (f[u] !== void 0 ? c.push(f[u][0]) : f.name !== void 0 ? c.push(f.name) : c.push("text"), f[o] !== s && (s = void 0));
                            }
                            e.type = mU(c, s, l);
                        } else if (a.type === "splom") {
                            var h = a.dimensions, d = h[a._axesDim[r]];
                            d.visible && (e.type = mU(d.values, s, l));
                        } else e.type = mU(a[n] || [
                            a[n + "0"]
                        ], s, l);
                    }
                }
            }
            function wvt(e, t, r) {
                for(var n = 0; n < e.length; n++){
                    var i = e[n];
                    if (i.type === "splom" && i._length > 0 && (i["_" + r + "axes"] || {})[t]) return i;
                    if ((i[r + "axis"] || r) === t) {
                        if (Cve(i, r)) return i;
                        if ((i[r] || []).length || i[r + "0"]) return i;
                    }
                }
            }
            function kve(e) {
                return ({
                    v: "x",
                    h: "y"
                })[e.orientation || "v"];
            }
            function Cve(e, t) {
                var r = kve(e), n = XM(e, "box-violin"), i = XM(e._fullInput || {}, "candlestick");
                return n && !i && t === r && e[r] === void 0 && e[r + "0"] === void 0;
            }
        });
        var eI = ye((Znr, Pve)=>{
            "use strict";
            var Tvt = vv().isTypedArraySpec;
            function Avt(e, t) {
                var r = t.dataAttr || e._id.charAt(0), n = {}, i, a, o;
                if (t.axData) i = t.axData;
                else for(i = [], a = 0; a < t.data.length; a++){
                    var s = t.data[a];
                    s[r + "axis"] === e._id && i.push(s);
                }
                for(a = 0; a < i.length; a++){
                    var l = i[a][r];
                    for(o = 0; o < l.length; o++){
                        var u = l[o];
                        u != null && (n[u] = 1);
                    }
                }
                return Object.keys(n);
            }
            Pve.exports = function(t, r, n, i) {
                if (r.type === "category") {
                    var a = t.categoryarray, o = Array.isArray(a) && a.length > 0 || Tvt(a), s;
                    o && (s = "array");
                    var l = n("categoryorder", s), u;
                    l === "array" && (u = n("categoryarray")), !o && l === "array" && (l = r.categoryorder = "trace"), l === "trace" ? r._initialCategories = [] : l === "array" ? r._initialCategories = u.slice() : (u = Avt(r, i).sort(), l === "category ascending" ? r._initialCategories = u : l === "category descending" && (r._initialCategories = u.reverse()));
                }
            };
        });
        var YM = ye((Xnr, Rve)=>{
            "use strict";
            var Ive = id().mix, Svt = dh(), Mvt = Mr();
            Rve.exports = function(t, r, n, i) {
                i = i || {};
                var a = i.dfltColor;
                function o(C, M) {
                    return Mvt.coerce2(t, r, i.attributes, C, M);
                }
                var s = o("linecolor", a), l = o("linewidth"), u = n("showline", i.showLine || !!s || !!l);
                u || (delete r.linecolor, delete r.linewidth);
                var c = Ive(a, i.bgColor, i.blend || Svt.lightFraction).toRgbString(), f = o("gridcolor", c), h = o("gridwidth"), d = o("griddash"), v = n("showgrid", i.showGrid || !!f || !!h || !!d);
                if (v || (delete r.gridcolor, delete r.gridwidth, delete r.griddash), i.hasMinor) {
                    var x = Ive(r.gridcolor, i.bgColor, 67).toRgbString(), b = o("minor.gridcolor", x), p = o("minor.gridwidth", r.gridwidth || 1), E = o("minor.griddash", r.griddash || "solid"), k = n("minor.showgrid", !!b || !!p || !!E);
                    k || (delete r.minor.gridcolor, delete r.minor.gridwidth, delete r.minor.griddash);
                }
                if (!i.noZeroLine) {
                    var A = o("zerolinecolor", a), L = o("zerolinewidth"), _ = n("zeroline", i.showGrid || !!A || !!L);
                    _ || (delete r.zerolinecolor, delete r.zerolinewidth);
                }
            };
        });
        var JM = ye((Ynr, Bve)=>{
            "use strict";
            var Dve = uo(), Evt = ba(), KM = Mr(), kvt = Vs(), Cvt = Zd(), _U = Cd(), zve = xb(), Fve = T3(), Lvt = t_(), Pvt = r_(), Ivt = eI(), Rvt = YM(), Dvt = dB(), qve = ym(), tI = ad().WEEKDAY_PATTERN, zvt = ad().HOUR_PATTERN;
            Bve.exports = function(t, r, n, i, a) {
                var o = i.letter, s = i.font || {}, l = i.splomStash || {}, u = n("visible", !i.visibleDflt), c = r._template || {}, f = r.type || c.type || "-", h;
                if (f === "date") {
                    var d = Evt.getComponentMethod("calendars", "handleDefaults");
                    d(t, r, "calendar", i.calendar), i.noTicklabelmode || (h = n("ticklabelmode"));
                }
                !i.noTicklabelindex && (f === "date" || f === "linear") && n("ticklabelindex");
                var v = "";
                (!i.noTicklabelposition || f === "multicategory") && (v = KM.coerce(t, r, {
                    ticklabelposition: {
                        valType: "enumerated",
                        dflt: "outside",
                        values: h === "period" ? [
                            "outside",
                            "inside"
                        ] : o === "x" ? [
                            "outside",
                            "inside",
                            "outside left",
                            "inside left",
                            "outside right",
                            "inside right"
                        ] : [
                            "outside",
                            "inside",
                            "outside top",
                            "inside top",
                            "outside bottom",
                            "inside bottom"
                        ]
                    }
                }, "ticklabelposition")), i.noTicklabeloverflow || n("ticklabeloverflow", v.indexOf("inside") !== -1 ? "hide past domain" : f === "category" || f === "multicategory" ? "allow" : "hide past div"), qve(r, a), Dvt(t, r, n, i), Ivt(t, r, n, i), f !== "category" && !i.noHover && n("hoverformat");
                var x = n("color"), b = x !== _U.color.dflt ? x : s.color, p = l.label || a._dfltTitle[o];
                if (Pvt(t, r, n, f, i), !u) return r;
                n("title.text", p), KM.coerceFont(n, "title.font", s, {
                    overrideDflt: {
                        size: KM.bigFont(s.size),
                        color: b
                    }
                }), zve(t, r, n, f);
                var E = i.hasMinor;
                if (E && (kvt.newContainer(r, "minor"), zve(t, r, n, f, {
                    isMinor: !0
                })), Lvt(t, r, n, f, i), Fve(t, r, n, i), E) {
                    var k = i.isMinor;
                    i.isMinor = !0, Fve(t, r, n, i), i.isMinor = k;
                }
                Rvt(t, r, n, {
                    dfltColor: x,
                    bgColor: i.bgColor,
                    showGrid: i.showGrid,
                    hasMinor: E,
                    attributes: _U
                }), E && !r.minor.ticks && !r.minor.showgrid && delete r.minor, (r.showline || r.ticks) && n("mirror");
                var A = f === "multicategory";
                if (!i.noTickson && (f === "category" || A) && (r.ticks || r.showgrid)) {
                    var L;
                    A && (L = "boundaries");
                    var _ = n("tickson", L);
                    _ === "boundaries" && delete r.ticklabelposition;
                }
                if (A) {
                    var C = n("showdividers");
                    C && (n("dividercolor"), n("dividerwidth"));
                }
                if (f === "date") {
                    if (Cvt(t, r, {
                        name: "rangebreaks",
                        inclusionAttr: "enabled",
                        handleItemDefaults: Fvt
                    }), !r.rangebreaks.length) delete r.rangebreaks;
                    else {
                        for(var M = 0; M < r.rangebreaks.length; M++)if (r.rangebreaks[M].pattern === tI) {
                            r._hasDayOfWeekBreaks = !0;
                            break;
                        }
                        if (qve(r, a), a._has("scattergl") || a._has("splom")) for(var g = 0; g < i.data.length; g++){
                            var P = i.data[g];
                            (P.type === "scattergl" || P.type === "splom") && (P.visible = !1, KM.warn(P.type + " traces do not work on axes with rangebreaks. Setting trace " + P.index + " to `visible: false`."));
                        }
                    }
                }
                return r;
            };
            function Fvt(e, t, r) {
                function n(h, d) {
                    return KM.coerce(e, t, _U.rangebreaks, h, d);
                }
                var i = n("enabled");
                if (i) {
                    var a = n("bounds");
                    if (a && a.length >= 2) {
                        var o = "", s, l;
                        if (a.length === 2) {
                            for(s = 0; s < 2; s++)if (l = Ove(a[s]), l) {
                                o = tI;
                                break;
                            }
                        }
                        var u = n("pattern", o);
                        if (u === tI) for(s = 0; s < 2; s++)l = Ove(a[s]), l && (t.bounds[s] = a[s] = l - 1);
                        if (u) for(s = 0; s < 2; s++)switch(l = a[s], u){
                            case tI:
                                if (!Dve(l)) {
                                    t.enabled = !1;
                                    return;
                                }
                                if (l = +l, l !== Math.floor(l) || l < 0 || l >= 7) {
                                    t.enabled = !1;
                                    return;
                                }
                                t.bounds[s] = a[s] = l;
                                break;
                            case zvt:
                                if (!Dve(l)) {
                                    t.enabled = !1;
                                    return;
                                }
                                if (l = +l, l < 0 || l > 24) {
                                    t.enabled = !1;
                                    return;
                                }
                                t.bounds[s] = a[s] = l;
                                break;
                        }
                        if (r.autorange === !1) {
                            var c = r.range;
                            if (c[0] < c[1]) {
                                if (a[0] < c[0] && a[1] > c[1]) {
                                    t.enabled = !1;
                                    return;
                                }
                            } else if (a[0] > c[0] && a[1] < c[1]) {
                                t.enabled = !1;
                                return;
                            }
                        }
                    } else {
                        var f = n("values");
                        if (f && f.length) n("dvalue");
                        else {
                            t.enabled = !1;
                            return;
                        }
                    }
                }
            }
            var qvt = {
                sun: 1,
                mon: 2,
                tue: 3,
                wed: 4,
                thu: 5,
                fri: 6,
                sat: 7
            };
            function Ove(e) {
                if (typeof e == "string") return qvt[e.substr(0, 3).toLowerCase()];
            }
        });
        var iI = ye((Knr, Nve)=>{
            "use strict";
            var Ovt = uo(), rI = Mr();
            Nve.exports = function(t, r, n, i) {
                var a = i.counterAxes || [], o = i.overlayableAxes || [], s = i.letter, l = i.grid, u = i.overlayingDomain, c, f, h, d, v, x;
                l && (f = l._domains[s][l._axisMap[r._id]], c = l._anchors[r._id], f && (h = l[s + "side"].split(" ")[0], d = l.domain[s][h === "right" || h === "top" ? 1 : 0])), f = f || [
                    0,
                    1
                ], c = c || (Ovt(t.position) ? "free" : a[0] || "free"), h = h || (s === "x" ? "bottom" : "left"), d = d || 0, v = 0, x = !1;
                var b = rI.coerce(t, r, {
                    anchor: {
                        valType: "enumerated",
                        values: [
                            "free"
                        ].concat(a),
                        dflt: c
                    }
                }, "anchor"), p = rI.coerce(t, r, {
                    side: {
                        valType: "enumerated",
                        values: s === "x" ? [
                            "bottom",
                            "top"
                        ] : [
                            "left",
                            "right"
                        ],
                        dflt: h
                    }
                }, "side");
                if (b === "free") {
                    if (s === "y") {
                        var E = n("autoshift");
                        E && (d = p === "left" ? u[0] : u[1], x = r.automargin ? r.automargin : !0, v = p === "left" ? -3 : 3), n("shift", v);
                    }
                    n("position", d);
                }
                n("automargin", x);
                var k = !1;
                if (o.length && (k = rI.coerce(t, r, {
                    overlaying: {
                        valType: "enumerated",
                        values: [
                            !1
                        ].concat(o),
                        dflt: !1
                    }
                }, "overlaying")), !k) {
                    var A = n("domain", f);
                    A[0] > A[1] - 1 / 4096 && (r.domain = f), rI.noneOrAll(t.domain, r.domain, f), r.tickmode === "sync" && (r.tickmode = "auto");
                }
                return n("layer"), r;
            };
        });
        var Yve = ye((Jnr, Xve)=>{
            "use strict";
            var jb = Mr(), Uve = va(), Bvt = rp().isUnifiedHover, Nvt = OB(), Vve = Vs(), Uvt = s3(), Hve = Cd(), Vvt = yU(), Gve = JM(), Hvt = Bb(), jve = iI(), bU = af(), Cm = bU.id2name, Wve = bU.name2id, Gvt = ad().AX_ID_PATTERN, Zve = ba(), nI = Zve.traceIs, xU = Zve.getComponentMethod;
            function aI(e, t, r) {
                Array.isArray(e[t]) ? e[t].push(r) : e[t] = [
                    r
                ];
            }
            Xve.exports = function(t, r, n) {
                var i = r.autotypenumbers, a = {}, o = {}, s = {}, l = {}, u = {}, c = {}, f = {}, h = {}, d = {}, v = {}, x, b;
                for(x = 0; x < n.length; x++){
                    var p = n[x];
                    if (nI(p, "cartesian")) {
                        var E;
                        if (p.xaxis) E = Cm(p.xaxis), aI(a, E, p);
                        else if (p.xaxes) for(b = 0; b < p.xaxes.length; b++)aI(a, Cm(p.xaxes[b]), p);
                        var k;
                        if (p.yaxis) k = Cm(p.yaxis), aI(a, k, p);
                        else if (p.yaxes) for(b = 0; b < p.yaxes.length; b++)aI(a, Cm(p.yaxes[b]), p);
                        if (p.type === "funnel" ? p.orientation === "h" ? (E && (o[E] = !0), k && (f[k] = !0)) : k && (s[k] = !0) : p.type === "image" ? (k && (h[k] = !0), E && (h[E] = !0)) : (k && (u[k] = !0, c[k] = !0), (!nI(p, "carpet") || p.type === "carpet" && !p._cheater) && E && (l[E] = !0)), p.type === "carpet" && p._cheater && E && (o[E] = !0), nI(p, "2dMap") && (d[E] = !0, d[k] = !0), nI(p, "oriented")) {
                            var A = p.orientation === "h" ? k : E;
                            v[A] = !0;
                        }
                    }
                }
                var L = r._subplots, _ = L.xaxis, C = L.yaxis, M = jb.simpleMap(_, Cm), g = jb.simpleMap(C, Cm), P = M.concat(g), T = Uve.background;
                _.length && C.length && (T = jb.coerce(t, r, Uvt, "plot_bgcolor"));
                var F = Uve.combine(T, r.paper_bgcolor), q, V, H, X, G;
                function N() {
                    var xt = a[q] || [];
                    G._traceIndices = xt.map(function(bt) {
                        return bt.index;
                    }), G._annIndices = [], G._shapeIndices = [], G._selectionIndices = [], G._imgIndices = [], G._subplotsWith = [], G._counterAxes = [], G._name = G._attr = q, G._id = V;
                }
                function W(xt, bt) {
                    return jb.coerce(X, G, Hve, xt, bt);
                }
                function re(xt, bt) {
                    return jb.coerce2(X, G, Hve, xt, bt);
                }
                function ae(xt) {
                    return xt === "x" ? C : _;
                }
                function _e(xt, bt) {
                    for(var Lt = xt === "x" ? M : g, St = [], Et = 0; Et < Lt.length; Et++){
                        var dt = Lt[Et];
                        dt !== bt && !(t[dt] || {}).overlaying && St.push(Wve(dt));
                    }
                    return St;
                }
                var Me = {
                    x: ae("x"),
                    y: ae("y")
                }, ke = Me.x.concat(Me.y), ge = {}, ie = [];
                function Te() {
                    var xt = X.matches;
                    Gvt.test(xt) && ke.indexOf(xt) === -1 && (ge[xt] = X.type, ie = Object.keys(ge));
                }
                var Ee = Nvt(t, r), Ae = Bvt(Ee);
                for(x = 0; x < P.length; x++){
                    q = P[x], V = Wve(q), H = q.charAt(0), jb.isPlainObject(t[q]) || (t[q] = {}), X = t[q], G = Vve.newContainer(r, q, H + "axis"), N();
                    var ze = H === "x" && !l[q] && o[q] || H === "y" && !u[q] && s[q], Ce = H === "y" && (!c[q] && f[q] || h[q]), me = {
                        hasMinor: !0,
                        letter: H,
                        font: r.font,
                        outerTicks: d[q],
                        showGrid: !v[q],
                        data: a[q] || [],
                        bgColor: F,
                        calendar: r.calendar,
                        automargin: !0,
                        visibleDflt: ze,
                        reverseDflt: Ce,
                        autotypenumbersDflt: i,
                        splomStash: ((r._splomAxes || {})[H] || {})[V],
                        noAutotickangles: H === "y"
                    };
                    W("uirevision", r.uirevision), Vvt(X, G, W, me), Gve(X, G, W, me, r);
                    var Re = Ae && H === Ee.charAt(0), ce = re("spikecolor", Ae ? G.color : void 0), Ge = re("spikethickness", Ae ? 1.5 : void 0), nt = re("spikedash", Ae ? "dot" : void 0), ct = re("spikemode", Ae ? "across" : void 0), qt = re("spikesnap"), rt = W("showspikes", !!Re || !!ce || !!Ge || !!nt || !!ct || !!qt);
                    rt || (delete G.spikecolor, delete G.spikethickness, delete G.spikedash, delete G.spikemode, delete G.spikesnap);
                    var ot = Cm(X.overlaying), Rt = [
                        0,
                        1
                    ];
                    if (r[ot] !== void 0) {
                        var kt = Cm(r[ot].anchor);
                        r[kt] !== void 0 && (Rt = r[kt].domain);
                    }
                    jve(X, G, W, {
                        letter: H,
                        counterAxes: Me[H],
                        overlayableAxes: _e(H, q),
                        grid: r.grid,
                        overlayingDomain: Rt
                    }), W("title.standoff"), Te(), G._input = X;
                }
                for(x = 0; x < ie.length;){
                    V = ie[x++], q = Cm(V), H = q.charAt(0), jb.isPlainObject(t[q]) || (t[q] = {}), X = t[q], G = Vve.newContainer(r, q, H + "axis"), N();
                    var Ct = {
                        letter: H,
                        font: r.font,
                        outerTicks: d[q],
                        showGrid: !v[q],
                        data: [],
                        bgColor: F,
                        calendar: r.calendar,
                        automargin: !0,
                        visibleDflt: !1,
                        reverseDflt: !1,
                        autotypenumbersDflt: i,
                        splomStash: ((r._splomAxes || {})[H] || {})[V]
                    };
                    W("uirevision", r.uirevision), G.type = ge[V] || "linear", Gve(X, G, W, Ct, r), jve(X, G, W, {
                        letter: H,
                        counterAxes: Me[H],
                        overlayableAxes: _e(H, q),
                        grid: r.grid
                    }), W("fixedrange"), Te(), G._input = X;
                }
                var Yt = xU("rangeslider", "handleDefaults"), xr = xU("rangeselector", "handleDefaults");
                for(x = 0; x < M.length; x++)q = M[x], X = t[q], G = r[q], Yt(t, r, q), G.type === "date" && xr(X, G, r, g, G.calendar), W("fixedrange");
                for(x = 0; x < g.length; x++){
                    q = g[x], X = t[q], G = r[q];
                    var er = r[Cm(G.anchor)], Ke = xU("rangeslider", "isVisible")(er);
                    W("fixedrange", Ke);
                }
                Hvt.handleDefaults(t, r, {
                    axIds: ke.concat(ie).sort(bU.idSort),
                    axHasImage: h
                });
            };
        });
        var $ve = ye(($nr, Jve)=>{
            "use strict";
            var jvt = xa(), Kve = ba(), oI = Mr(), Qp = ao(), sI = Qa();
            Jve.exports = function(t, r, n, i) {
                var a = t._fullLayout;
                if (r.length === 0) {
                    sI.redrawComponents(t);
                    return;
                }
                function o(b) {
                    var p = b.xaxis, E = b.yaxis;
                    a._defs.select("#" + b.clipId + "> rect").call(Qp.setTranslate, 0, 0).call(Qp.setScale, 1, 1), b.plot.call(Qp.setTranslate, p._offset, E._offset).call(Qp.setScale, 1, 1);
                    var k = b.plot.selectAll(".scatterlayer .trace");
                    k.selectAll(".point").call(Qp.setPointGroupScale, 1, 1), k.selectAll(".textpoint").call(Qp.setTextPointsScale, 1, 1), k.call(Qp.hideOutsideRangePoints, b);
                }
                function s(b, p) {
                    var E = b.plotinfo, k = E.xaxis, A = E.yaxis, L = k._length, _ = A._length, C = !!b.xr1, M = !!b.yr1, g = [];
                    if (C) {
                        var P = oI.simpleMap(b.xr0, k.r2l), T = oI.simpleMap(b.xr1, k.r2l), F = P[1] - P[0], q = T[1] - T[0];
                        g[0] = (P[0] * (1 - p) + p * T[0] - P[0]) / (P[1] - P[0]) * L, g[2] = L * (1 - p + p * q / F), k.range[0] = k.l2r(P[0] * (1 - p) + p * T[0]), k.range[1] = k.l2r(P[1] * (1 - p) + p * T[1]);
                    } else g[0] = 0, g[2] = L;
                    if (M) {
                        var V = oI.simpleMap(b.yr0, A.r2l), H = oI.simpleMap(b.yr1, A.r2l), X = V[1] - V[0], G = H[1] - H[0];
                        g[1] = (V[1] * (1 - p) + p * H[1] - V[1]) / (V[0] - V[1]) * _, g[3] = _ * (1 - p + p * G / X), A.range[0] = k.l2r(V[0] * (1 - p) + p * H[0]), A.range[1] = A.l2r(V[1] * (1 - p) + p * H[1]);
                    } else g[1] = 0, g[3] = _;
                    sI.drawOne(t, k, {
                        skipTitle: !0
                    }), sI.drawOne(t, A, {
                        skipTitle: !0
                    }), sI.redrawComponents(t, [
                        k._id,
                        A._id
                    ]);
                    var N = C ? L / g[2] : 1, W = M ? _ / g[3] : 1, re = C ? g[0] : 0, ae = M ? g[1] : 0, _e = C ? g[0] / g[2] * L : 0, Me = M ? g[1] / g[3] * _ : 0, ke = k._offset - _e, ge = A._offset - Me;
                    E.clipRect.call(Qp.setTranslate, re, ae).call(Qp.setScale, 1 / N, 1 / W), E.plot.call(Qp.setTranslate, ke, ge).call(Qp.setScale, N, W), Qp.setPointGroupScale(E.zoomScalePts, 1 / N, 1 / W), Qp.setTextPointsScale(E.zoomScaleTxt, 1 / N, 1 / W);
                }
                var l;
                i && (l = i());
                function u() {
                    for(var b = {}, p = 0; p < r.length; p++){
                        var E = r[p], k = E.plotinfo.xaxis, A = E.plotinfo.yaxis;
                        E.xr1 && (b[k._name + ".range"] = E.xr1.slice()), E.yr1 && (b[A._name + ".range"] = E.yr1.slice());
                    }
                    return l && l(), Kve.call("relayout", t, b).then(function() {
                        for(var L = 0; L < r.length; L++)o(r[L].plotinfo);
                    });
                }
                function c() {
                    for(var b = {}, p = 0; p < r.length; p++){
                        var E = r[p], k = E.plotinfo.xaxis, A = E.plotinfo.yaxis;
                        E.xr0 && (b[k._name + ".range"] = E.xr0.slice()), E.yr0 && (b[A._name + ".range"] = E.yr0.slice());
                    }
                    return Kve.call("relayout", t, b).then(function() {
                        for(var L = 0; L < r.length; L++)o(r[L].plotinfo);
                    });
                }
                var f, h, d, v = jvt.ease(n.easing);
                t._transitionData._interruptCallbacks.push(function() {
                    return window.cancelAnimationFrame(d), d = null, c();
                });
                function x() {
                    h = Date.now();
                    for(var b = Math.min(1, (h - f) / n.duration), p = v(b), E = 0; E < r.length; E++)s(r[E], p);
                    h - f > n.duration ? (u(), d = window.cancelAnimationFrame(x)) : d = window.requestAnimationFrame(x);
                }
                return f = Date.now(), d = window.requestAnimationFrame(x), Promise.resolve();
            };
        });
        var Jf = ye((yv)=>{
            "use strict";
            var uI = xa(), Qve = ba(), Wb = Mr(), Wvt = Xu(), Zvt = ao(), epe = kd().getModuleCalcData, m_ = af(), zg = ad(), Xvt = Zp(), ql = Wb.ensureSingle;
            function lI(e, t, r) {
                return Wb.ensureSingle(e, t, r, function(n) {
                    n.datum(r);
                });
            }
            var Zb = zg.zindexSeparator;
            yv.name = "cartesian";
            yv.attr = [
                "xaxis",
                "yaxis"
            ];
            yv.idRoot = [
                "x",
                "y"
            ];
            yv.idRegex = zg.idRegex;
            yv.attrRegex = zg.attrRegex;
            yv.attributes = Eve();
            yv.layoutAttributes = Cd();
            yv.supplyLayoutDefaults = Yve();
            yv.transitionAxes = $ve();
            yv.finalizeSubplots = function(e, t) {
                var r = t._subplots, n = r.xaxis, i = r.yaxis, a = r.cartesian, o = a, s = {}, l = {}, u, c, f;
                for(u = 0; u < o.length; u++){
                    var h = o[u].split("y");
                    s[h[0]] = 1, l["y" + h[1]] = 1;
                }
                for(u = 0; u < n.length; u++)c = n[u], s[c] || (f = (e[m_.id2name(c)] || {}).anchor, zg.idRegex.y.test(f) || (f = "y"), a.push(c + f), o.push(c + f), l[f] || (l[f] = 1, Wb.pushUnique(i, f)));
                for(u = 0; u < i.length; u++)f = i[u], l[f] || (c = (e[m_.id2name(f)] || {}).anchor, zg.idRegex.x.test(c) || (c = "x"), a.push(c + f), o.push(c + f), s[c] || (s[c] = 1, Wb.pushUnique(n, c)));
                if (!o.length) {
                    c = "", f = "";
                    for(var d in e)if (zg.attrRegex.test(d)) {
                        var v = d.charAt(0);
                        v === "x" ? (!c || +d.substr(5) < +c.substr(5)) && (c = d) : (!f || +d.substr(5) < +f.substr(5)) && (f = d);
                    }
                    c = c ? m_.name2id(c) : "x", f = f ? m_.name2id(f) : "y", n.push(c), i.push(f), a.push(c + f);
                }
            };
            yv.plot = function(e, t, r, n) {
                var i = e._fullLayout, a = i._subplots.cartesian, o = e.calcdata, s;
                if (!Array.isArray(t)) for(t = [], s = 0; s < o.length; s++)t.push(s);
                for(var l = i._zindices, u = 0; u < l.length; u++){
                    var c = l[u];
                    for(s = 0; s < a.length; s++){
                        var f = a[s], h = i._plots[f];
                        if (u > 0) {
                            var d = h.id;
                            if (d.indexOf(Zb) !== -1) continue;
                            d += Zb + (u + 1), h = Wb.extendFlat({}, h, {
                                id: d,
                                plot: i._cartesianlayer.selectAll(".subplot").select("." + d)
                            });
                        }
                        for(var v = [], x, b = 0; b < o.length; b++){
                            var p = o[b], E = p[0].trace;
                            c === (E.zorder || 0) && E.xaxis + E.yaxis === f && ((t.indexOf(E.index) !== -1 || E.carpet) && (x && x[0].trace.xaxis + x[0].trace.yaxis === f && [
                                "tonextx",
                                "tonexty",
                                "tonext"
                            ].indexOf(E.fill) !== -1 && v.indexOf(x) === -1 && v.push(x), v.push(p)), x = p);
                        }
                        tpe(e, h, v, r, n);
                    }
                }
            };
            function tpe(e, t, r, n, i) {
                for(var a = zg.traceLayerClasses, o = e._fullLayout, s = o._zindices, l = o._modules, u, c, f, h = [], d = [], v = 0; v < s.length; v++)for(var x = s[v], b = 0; b < l.length; b++){
                    u = l[b];
                    var p = u.name, E = Qve.modules[p].categories;
                    if (E.svg) {
                        var k = u.layerName || p + "layer", A = k + (v ? Number(v) + 1 : ""), L = u.plot;
                        c = epe(r, L, x), f = c[0], r = c[1], f.length && h.push({
                            i: a.indexOf(k),
                            zindex: v,
                            className: A,
                            plotMethod: L,
                            cdModule: f
                        }), E.zoomScale && d.push("." + A);
                    }
                }
                h.sort(function(M, g) {
                    return (M.zindex || 0) - (g.zindex || 0) || M.i - g.i;
                });
                var _ = t.plot.selectAll("g.mlayer").data(h, function(M) {
                    return M.className;
                });
                if (_.enter().append("g").attr("class", function(M) {
                    return M.className;
                }).classed("mlayer", !0).classed("rangeplot", t.isRangePlot), _.exit().remove(), _.order(), _.each(function(M) {
                    var g = uI.select(this), P = M.className;
                    M.plotMethod(e, t, M.cdModule, g, n, i), zg.clipOnAxisFalseQuery.indexOf("." + P) === -1 && Zvt.setClipUrl(g, t.layerClipId, e);
                }), o._has("scattergl") && (u = Qve.getModule("scattergl"), f = epe(r, u)[0], u.plot(e, t, f)), !e._context.staticPlot && (t._hasClipOnAxisFalse && (t.clipOnAxisFalseTraces = t.plot.selectAll(zg.clipOnAxisFalseQuery.join(",")).selectAll(".trace")), d.length)) {
                    var C = t.plot.selectAll(d.join(",")).selectAll(".trace");
                    t.zoomScalePts = C.selectAll("path.point"), t.zoomScaleTxt = C.selectAll(".textpoint");
                }
            }
            yv.clean = function(e, t, r, n) {
                var i = n._plots || {}, a = t._plots || {}, o = n._subplots || {}, s, l, u;
                if (n._hasOnlyLargeSploms && !t._hasOnlyLargeSploms) for(u in i)s = i[u], s.plotgroup && s.plotgroup.remove();
                var c = n._has && n._has("gl"), f = t._has && t._has("gl");
                if (c && !f) for(u in i)s = i[u], s._scene && s._scene.destroy();
                if (o.xaxis && o.yaxis) {
                    var h = m_.listIds({
                        _fullLayout: n
                    });
                    for(l = 0; l < h.length; l++){
                        var d = h[l];
                        t[m_.id2name(d)] || n._infolayer.selectAll(".g-" + d + "title").remove();
                    }
                }
                var v = n._has && n._has("cartesian"), x = t._has && t._has("cartesian");
                if (v && !x) ipe(n._cartesianlayer.selectAll(".subplot"), n), n._defs.selectAll(".axesclip").remove(), delete n._axisConstraintGroups, delete n._axisMatchGroups;
                else if (o.cartesian) for(l = 0; l < o.cartesian.length; l++){
                    var b = o.cartesian[l];
                    if (b.indexOf(Zb) === -1 && !a[b]) {
                        var p = "." + b + ",." + b + "-x,." + b + "-y";
                        n._cartesianlayer.selectAll(p).remove(), npe(b, n);
                    }
                }
            };
            yv.drawFramework = function(e) {
                var t = e._fullLayout, r = e.calcdata, n, i = {};
                for(n = 0; n < r.length; n++){
                    var a = r[n][0], o = a.trace, s = o.zorder || 0;
                    i[s] || (i[s] = []), i[s].push(a);
                }
                var l = Object.keys(i).map(Number).sort(Wb.sorterAsc);
                l.length || (l = [
                    0
                ]), t._zindices = l;
                var u = Yvt(e), c = u.length, f = [];
                for(n = 0; n < c; n++)f[n] = u[n].slice();
                for(var h = 1; h < l.length; h++){
                    var d = [];
                    for(n = 0; n < c; n++)d[n] = u[n].slice(), d[n][0] += Zb + (h + 1);
                    f = f.concat(d);
                }
                var v = t._cartesianlayer.selectAll(".subplot").data(f, String);
                v.enter().append("g").attr("class", function(x) {
                    return "subplot " + x[0];
                }), v.order(), v.exit().call(ipe, t), v.each(function(x) {
                    var b = x[0], p = b.indexOf(Zb), E = p !== -1, k = E ? b.slice(0, p) : b, A = t._plots[b];
                    A || (A = Wb.extendFlat({}, t._plots[k]), A && (A.id = b, t._plots[b] = A, t._subplots.cartesian.push(b))), A && (A.plotgroup = uI.select(this), rpe(e, A), E || (A.draglayer = ql(t._draggers, "g", b)));
                });
            };
            yv.rangePlot = function(e, t, r) {
                rpe(e, t), tpe(e, t, r), Wvt.style(e);
            };
            function Yvt(e) {
                var t = e._fullLayout, r = t._zindices.length, n = t._subplots.cartesian, i = n.length, a, o, s, l, u, c, f = [], h = [];
                for(a = 0; a < i; a++){
                    s = n[a], l = t._plots[s], u = l.xaxis, c = l.yaxis;
                    var d = u._mainAxis, v = c._mainAxis, x = d._id + v._id, b = t._plots[x];
                    l.overlays = [], x !== s && b ? (l.mainplot = x, l.mainplotinfo = b, h.push(s)) : (l.mainplot = void 0, l.mainplotinfo = void 0, f.push(s));
                }
                for(a = 0; a < h.length; a++)s = h[a], l = t._plots[s], l.mainplotinfo.overlays.push(l);
                var p = f.concat(h), E = [];
                for(a = 0; a < i; a++){
                    s = p[a], l = t._plots[s], u = l.xaxis, c = l.yaxis;
                    for(var k = [], A = 1; A <= r; A++){
                        var L = "";
                        for(A > 1 && (L += Zb + A), k.push(s + L), o = 0; o < l.overlays.length; o++)k.push(l.overlays[o].id + L);
                    }
                    k = k.concat([
                        u.layer,
                        c.layer,
                        u.overlaying || "",
                        c.overlaying || ""
                    ]), E.push(k);
                }
                return E;
            }
            function rpe(e, t) {
                var r = e._fullLayout, n = t.plotgroup, i = t.id, a = i.indexOf(Zb), o = a !== -1, s = zg.layerValue2layerClass[t.xaxis.layer], l = zg.layerValue2layerClass[t.yaxis.layer], u = r._hasOnlyLargeSploms, c = r._zindices.length > 1, f = t.mainplotinfo;
                if (!t.mainplot || c) {
                    if (u) t.xlines = ql(n, "path", "xlines-above"), t.ylines = ql(n, "path", "ylines-above"), t.xaxislayer = ql(n, "g", "xaxislayer-above"), t.yaxislayer = ql(n, "g", "yaxislayer-above");
                    else {
                        if (!o) {
                            var h = ql(n, "g", "layer-subplot");
                            t.shapelayer = ql(h, "g", "shapelayer"), t.imagelayer = ql(h, "g", "imagelayer"), f && c ? (t.minorGridlayer = f.minorGridlayer, t.gridlayer = f.gridlayer, t.zerolinelayer = f.zerolinelayer) : (t.minorGridlayer = ql(n, "g", "minor-gridlayer"), t.gridlayer = ql(n, "g", "gridlayer"), t.zerolinelayer = ql(n, "g", "zerolinelayer"));
                            var d = ql(n, "g", "layer-between");
                            t.shapelayerBetween = ql(d, "g", "shapelayer"), t.imagelayerBetween = ql(d, "g", "imagelayer"), ql(n, "path", "xlines-below"), ql(n, "path", "ylines-below"), t.overlinesBelow = ql(n, "g", "overlines-below"), ql(n, "g", "xaxislayer-below"), ql(n, "g", "yaxislayer-below"), t.overaxesBelow = ql(n, "g", "overaxes-below");
                        }
                        t.overplot = ql(n, "g", "overplot"), t.plot = ql(t.overplot, "g", i), o || (t.xlines = ql(n, "path", "xlines-above"), t.ylines = ql(n, "path", "ylines-above"), t.overlinesAbove = ql(n, "g", "overlines-above"), ql(n, "g", "xaxislayer-above"), ql(n, "g", "yaxislayer-above"), t.overaxesAbove = ql(n, "g", "overaxes-above"), t.xlines = n.select(".xlines-" + s), t.ylines = n.select(".ylines-" + l), t.xaxislayer = n.select(".xaxislayer-" + s), t.yaxislayer = n.select(".yaxislayer-" + l));
                    }
                } else {
                    var v = f.plotgroup, x = i + "-x", b = i + "-y";
                    t.minorGridlayer = f.minorGridlayer, t.gridlayer = f.gridlayer, t.zerolinelayer = f.zerolinelayer, ql(f.overlinesBelow, "path", x), ql(f.overlinesBelow, "path", b), ql(f.overaxesBelow, "g", x), ql(f.overaxesBelow, "g", b), t.plot = ql(f.overplot, "g", i), ql(f.overlinesAbove, "path", x), ql(f.overlinesAbove, "path", b), ql(f.overaxesAbove, "g", x), ql(f.overaxesAbove, "g", b), t.xlines = v.select(".overlines-" + s).select("." + x), t.ylines = v.select(".overlines-" + l).select("." + b), t.xaxislayer = v.select(".overaxes-" + s).select("." + x), t.yaxislayer = v.select(".overaxes-" + l).select("." + b);
                }
                o || (u || (lI(t.minorGridlayer, "g", t.xaxis._id), lI(t.minorGridlayer, "g", t.yaxis._id), t.minorGridlayer.selectAll("g").map(function(p) {
                    return p[0];
                }).sort(m_.idSort), lI(t.gridlayer, "g", t.xaxis._id), lI(t.gridlayer, "g", t.yaxis._id), t.gridlayer.selectAll("g").map(function(p) {
                    return p[0];
                }).sort(m_.idSort)), t.xlines.style("fill", "none").classed("crisp", !0), t.ylines.style("fill", "none").classed("crisp", !0));
            }
            function ipe(e, t) {
                if (e) {
                    var r = {};
                    e.each(function(l) {
                        var u = l[0], c = uI.select(this);
                        c.remove(), npe(u, t), r[u] = !0;
                    });
                    for(var n in t._plots)for(var i = t._plots[n], a = i.overlays || [], o = 0; o < a.length; o++){
                        var s = a[o];
                        r[s.id] && s.plot.selectAll(".trace").remove();
                    }
                }
            }
            function npe(e, t) {
                t._draggers.selectAll("g." + e).remove(), t._defs.select("#clip" + t._uid + e + "plot").remove();
            }
            yv.toSVG = function(e) {
                var t = e._fullLayout._glimages, r = uI.select(e).selectAll(".svg-container"), n = r.filter(function(a, o) {
                    return o === r.size() - 1;
                }).selectAll(".gl-canvas-context, .gl-canvas-focus");
                function i() {
                    var a = this, o = a.toDataURL("image/png"), s = t.append("svg:image");
                    s.attr({
                        xmlns: Xvt.svg,
                        "xlink:href": o,
                        preserveAspectRatio: "none",
                        x: 0,
                        y: 0,
                        width: a.style.width,
                        height: a.style.height
                    });
                }
                n.each(i);
            };
            yv.updateFx = zN().updateFx;
        });
        var ope = ye((ear, ape)=>{
            "use strict";
            var cI = lu();
            ape.exports = {
                hasLines: cI.hasLines,
                hasMarkers: cI.hasMarkers,
                hasText: cI.hasText,
                isBubble: cI.isBubble,
                attributes: Uc(),
                layoutAttributes: V6(),
                supplyDefaults: Ide(),
                crossTraceDefaults: $N(),
                supplyLayoutDefaults: Fde(),
                calc: q0().calc,
                crossTraceCalc: ove(),
                arraysToCalcdata: km(),
                plot: iT(),
                colorbar: Kd(),
                formatLabels: $P(),
                style: op().style,
                styleOnSelect: op().styleOnSelect,
                hoverPoints: sT(),
                selectPoints: lT(),
                animatable: !0,
                moduleType: "trace",
                name: "scatter",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "symbols",
                    "errorBarsOK",
                    "showLegend",
                    "scatter-like",
                    "zoomScale"
                ],
                meta: {}
            };
        });
        var upe = ye((tar, lpe)=>{
            "use strict";
            var Kvt = xa(), Jvt = va(), spe = MN(), wU = Mr(), $vt = wU.strScale, Qvt = wU.strRotate, ept = wU.strTranslate;
            lpe.exports = function(t, r, n) {
                var i = t.node(), a = spe[n.arrowhead || 0], o = spe[n.startarrowhead || 0], s = (n.arrowwidth || 1) * (n.arrowsize || 1), l = (n.arrowwidth || 1) * (n.startarrowsize || 1), u = r.indexOf("start") >= 0, c = r.indexOf("end") >= 0, f = a.backoff * s + n.standoff, h = o.backoff * l + n.startstandoff, d, v, x, b;
                if (i.nodeName === "line") {
                    d = {
                        x: +t.attr("x1"),
                        y: +t.attr("y1")
                    }, v = {
                        x: +t.attr("x2"),
                        y: +t.attr("y2")
                    };
                    var p = d.x - v.x, E = d.y - v.y;
                    if (x = Math.atan2(E, p), b = x + Math.PI, f && h && f + h > Math.sqrt(p * p + E * E)) {
                        V();
                        return;
                    }
                    if (f) {
                        if (f * f > p * p + E * E) {
                            V();
                            return;
                        }
                        var k = f * Math.cos(x), A = f * Math.sin(x);
                        v.x += k, v.y += A, t.attr({
                            x2: v.x,
                            y2: v.y
                        });
                    }
                    if (h) {
                        if (h * h > p * p + E * E) {
                            V();
                            return;
                        }
                        var L = h * Math.cos(x), _ = h * Math.sin(x);
                        d.x -= L, d.y -= _, t.attr({
                            x1: d.x,
                            y1: d.y
                        });
                    }
                } else if (i.nodeName === "path") {
                    var C = i.getTotalLength(), M = "";
                    if (C < f + h) {
                        V();
                        return;
                    }
                    var g = i.getPointAtLength(0), P = i.getPointAtLength(.1);
                    x = Math.atan2(g.y - P.y, g.x - P.x), d = i.getPointAtLength(Math.min(h, C)), M = "0px," + h + "px,";
                    var T = i.getPointAtLength(C), F = i.getPointAtLength(C - .1);
                    b = Math.atan2(T.y - F.y, T.x - F.x), v = i.getPointAtLength(Math.max(0, C - f));
                    var q = M ? h + f : f;
                    M += C - q + "px," + C + "px", t.style("stroke-dasharray", M);
                }
                function V() {
                    t.style("stroke-dasharray", "0px,100px");
                }
                function H(X, G, N, W) {
                    X.path && (X.noRotate && (N = 0), Kvt.select(i.parentNode).append("path").attr({
                        class: t.attr("class"),
                        d: X.path,
                        transform: ept(G.x, G.y) + Qvt(N * 180 / Math.PI) + $vt(W)
                    }).style({
                        fill: Jvt.rgb(n.arrowcolor),
                        "stroke-width": 0
                    }));
                }
                u && H(o, d, x, l), c && H(a, v, b, s);
            };
        });
        var fI = ye((rar, vpe)=>{
            "use strict";
            var cpe = xa(), TU = ba(), tpt = Xu(), __ = Mr(), AU = __.strTranslate, QM = Qa(), Xb = va(), Py = ao(), fpe = Nc(), SU = Pl(), MU = Tg(), $M = gv(), rpt = Vs().arrayEditor, ipt = upe();
            vpe.exports = {
                draw: npt,
                drawOne: hpe,
                drawRaw: dpe
            };
            function npt(e) {
                var t = e._fullLayout;
                t._infolayer.selectAll(".annotation").remove();
                for(var r = 0; r < t.annotations.length; r++)t.annotations[r].visible && hpe(e, r);
                return tpt.previousPromises(e);
            }
            function hpe(e, t) {
                var r = e._fullLayout, n = r.annotations[t] || {}, i = QM.getFromId(e, n.xref), a = QM.getFromId(e, n.yref);
                i && i.setScale(), a && a.setScale(), dpe(e, n, t, !1, i, a);
            }
            function y_(e, t, r, n, i) {
                var a = i[r], o = i[r + "ref"], s = r.indexOf("y") !== -1, l = QM.getRefType(o) === "domain", u = s ? n.h : n.w;
                return e ? l ? a + (s ? -t : t) / e._length : e.p2r(e.r2p(a) + t) : a + (s ? -t : t) / u;
            }
            function dpe(e, t, r, n, i, a) {
                var o = e._fullLayout, s = e._fullLayout._size, l = e._context.edits, u, c;
                n ? (u = "annotation-" + n, c = n + ".annotations") : (u = "annotation", c = "annotations");
                var f = rpt(e.layout, c, t), h = f.modifyBase, d = f.modifyItem, v = f.getUpdateObj;
                o._infolayer.selectAll("." + u + '[data-index="' + r + '"]').remove();
                var x = "clip" + o._uid + "_ann" + r;
                if (!t._input || t.visible === !1) {
                    cpe.selectAll("#" + x).remove();
                    return;
                }
                var b = {
                    x: {},
                    y: {}
                }, p = +t.textangle || 0, E = o._infolayer.append("g").classed(u, !0).attr("data-index", String(r)).style("opacity", t.opacity), k = E.append("g").classed("annotation-text-g", !0), A = l[t.showarrow ? "annotationTail" : "annotationPosition"], L = t.captureevents || l.annotationText || A;
                function _(W) {
                    var re = {
                        index: r,
                        annotation: t._input,
                        fullAnnotation: t,
                        event: W
                    };
                    return n && (re.subplotId = n), re;
                }
                var C = k.append("g").style("pointer-events", L ? "all" : null).call(MU, "pointer").on("click", function() {
                    e._dragging = !1, e.emit("plotly_clickannotation", _(cpe.event));
                });
                t.hovertext && C.on("mouseover", function() {
                    var W = t.hoverlabel, re = W.font, ae = this.getBoundingClientRect(), _e = e.getBoundingClientRect();
                    fpe.loneHover({
                        x0: ae.left - _e.left,
                        x1: ae.right - _e.left,
                        y: (ae.top + ae.bottom) / 2 - _e.top,
                        text: t.hovertext,
                        color: W.bgcolor,
                        borderColor: W.bordercolor,
                        fontFamily: re.family,
                        fontSize: re.size,
                        fontColor: re.color,
                        fontWeight: re.weight,
                        fontStyle: re.style,
                        fontVariant: re.variant,
                        fontShadow: re.fontShadow,
                        fontLineposition: re.fontLineposition,
                        fontTextcase: re.fontTextcase
                    }, {
                        container: o._hoverlayer.node(),
                        outerContainer: o._paper.node(),
                        gd: e
                    });
                }).on("mouseout", function() {
                    fpe.loneUnhover(o._hoverlayer.node());
                });
                var M = t.borderwidth, g = t.borderpad, P = M + g, T = C.append("rect").attr("class", "bg").style("stroke-width", M + "px").call(Xb.stroke, t.bordercolor).call(Xb.fill, t.bgcolor), F = t.width || t.height, q = o._topclips.selectAll("#" + x).data(F ? [
                    0
                ] : []);
                q.enter().append("clipPath").classed("annclip", !0).attr("id", x).append("rect"), q.exit().remove();
                var V = t.font, H = o._meta ? __.templateString(t.text, o._meta) : t.text, X = C.append("text").classed("annotation-text", !0).text(H);
                function G(W) {
                    return W.call(Py.font, V).attr({
                        "text-anchor": {
                            left: "start",
                            right: "end"
                        }[t.align] || "middle"
                    }), SU.convertToTspans(W, e, N), W;
                }
                function N() {
                    var W = X.selectAll("a");
                    if (W.size() === 1 && W.text() === X.text()) {
                        var re = C.insert("a", ":first-child").attr({
                            "xlink:xlink:href": W.attr("xlink:href"),
                            "xlink:xlink:show": W.attr("xlink:show")
                        }).style({
                            cursor: "pointer"
                        });
                        re.node().appendChild(T.node());
                    }
                    var ae = C.select(".annotation-text-math-group"), _e = !ae.empty(), Me = Py.bBox((_e ? ae : X).node()), ke = Me.width, ge = Me.height, ie = t.width || ke, Te = t.height || ge, Ee = Math.round(ie + 2 * P), Ae = Math.round(Te + 2 * P);
                    function ze(Ve, Xe) {
                        return Xe === "auto" && (Ve < 1 / 3 ? Xe = "left" : Ve > 2 / 3 ? Xe = "right" : Xe = "center"), ({
                            center: 0,
                            middle: 0,
                            left: .5,
                            bottom: -0.5,
                            right: -0.5,
                            top: .5
                        })[Xe];
                    }
                    for(var Ce = !1, me = [
                        "x",
                        "y"
                    ], Re = 0; Re < me.length; Re++){
                        var ce = me[Re], Ge = t[ce + "ref"] || ce, nt = t["a" + ce + "ref"], ct = {
                            x: i,
                            y: a
                        }[ce], qt = (p + (ce === "x" ? 0 : -90)) * Math.PI / 180, rt = Ee * Math.cos(qt), ot = Ae * Math.sin(qt), Rt = Math.abs(rt) + Math.abs(ot), kt = t[ce + "anchor"], Ct = t[ce + "shift"] * (ce === "x" ? 1 : -1), Yt = b[ce], xr, er, Ke, xt, bt, Lt = QM.getRefType(Ge);
                        if (ct && Lt !== "domain") {
                            var St = ct.r2fraction(t[ce]);
                            (St < 0 || St > 1) && (nt === Ge ? (St = ct.r2fraction(t["a" + ce]), (St < 0 || St > 1) && (Ce = !0)) : Ce = !0), xr = ct._offset + ct.r2p(t[ce]), xt = .5;
                        } else {
                            var Et = Lt === "domain";
                            ce === "x" ? (Ke = t[ce], xr = Et ? ct._offset + ct._length * Ke : xr = s.l + s.w * Ke) : (Ke = 1 - t[ce], xr = Et ? ct._offset + ct._length * Ke : xr = s.t + s.h * Ke), xt = t.showarrow ? .5 : Ke;
                        }
                        if (t.showarrow) {
                            Yt.head = xr;
                            var dt = t["a" + ce];
                            if (bt = rt * ze(.5, t.xanchor) - ot * ze(.5, t.yanchor), nt === Ge) {
                                var Ht = QM.getRefType(nt);
                                Ht === "domain" ? (ce === "y" && (dt = 1 - dt), Yt.tail = ct._offset + ct._length * dt) : Ht === "paper" ? ce === "y" ? (dt = 1 - dt, Yt.tail = s.t + s.h * dt) : Yt.tail = s.l + s.w * dt : Yt.tail = ct._offset + ct.r2p(dt), er = bt;
                            } else Yt.tail = xr + dt, er = bt + dt;
                            Yt.text = Yt.tail + bt;
                            var $t = o[ce === "x" ? "width" : "height"];
                            if (Ge === "paper" && (Yt.head = __.constrain(Yt.head, 1, $t - 1)), nt === "pixel") {
                                var fr = -Math.max(Yt.tail - 3, Yt.text), _r = Math.min(Yt.tail + 3, Yt.text) - $t;
                                fr > 0 ? (Yt.tail += fr, Yt.text += fr) : _r > 0 && (Yt.tail -= _r, Yt.text -= _r);
                            }
                            Yt.tail += Ct, Yt.head += Ct;
                        } else bt = Rt * ze(xt, kt), er = bt, Yt.text = xr + bt;
                        Yt.text += Ct, bt += Ct, er += Ct, t["_" + ce + "padplus"] = Rt / 2 + er, t["_" + ce + "padminus"] = Rt / 2 - er, t["_" + ce + "size"] = Rt, t["_" + ce + "shift"] = bt;
                    }
                    if (Ce) {
                        C.remove();
                        return;
                    }
                    var Br = 0, Or = 0;
                    if (t.align !== "left" && (Br = (ie - ke) * (t.align === "center" ? .5 : 1)), t.valign !== "top" && (Or = (Te - ge) * (t.valign === "middle" ? .5 : 1)), _e) ae.select("svg").attr({
                        x: P + Br - 1,
                        y: P + Or
                    }).call(Py.setClipUrl, F ? x : null, e);
                    else {
                        var Nr = P + Or - Me.top, ut = P + Br - Me.left;
                        X.call(SU.positionText, ut, Nr).call(Py.setClipUrl, F ? x : null, e);
                    }
                    q.select("rect").call(Py.setRect, P, P, ie, Te), T.call(Py.setRect, M / 2, M / 2, Ee - M, Ae - M), C.call(Py.setTranslate, Math.round(b.x.text - Ee / 2), Math.round(b.y.text - Ae / 2)), k.attr({
                        transform: "rotate(" + p + "," + b.x.text + "," + b.y.text + ")"
                    });
                    var Ne = function(Ve, Xe) {
                        E.selectAll(".annotation-arrow-g").remove();
                        var ht = b.x.head, Le = b.y.head, xe = b.x.tail + Ve, Se = b.y.tail + Xe, lt = b.x.text + Ve, Gt = b.y.text + Xe, Vt = __.rotationXYMatrix(p, lt, Gt), ar = __.apply2DTransform(Vt), Qr = __.apply2DTransform2(Vt), ai = +T.attr("width"), jr = +T.attr("height"), ri = lt - .5 * ai, bi = ri + ai, nn = Gt - .5 * jr, Wi = nn + jr, Ni = [
                            [
                                ri,
                                nn,
                                ri,
                                Wi
                            ],
                            [
                                ri,
                                Wi,
                                bi,
                                Wi
                            ],
                            [
                                bi,
                                Wi,
                                bi,
                                nn
                            ],
                            [
                                bi,
                                nn,
                                ri,
                                nn
                            ]
                        ].map(Qr);
                        if (!Ni.reduce(function(Vr, gi) {
                            return Vr ^ !!__.segmentsIntersect(ht, Le, ht + 1e6, Le + 1e6, gi[0], gi[1], gi[2], gi[3]);
                        }, !1)) {
                            Ni.forEach(function(Vr) {
                                var gi = __.segmentsIntersect(xe, Se, ht, Le, Vr[0], Vr[1], Vr[2], Vr[3]);
                                gi && (xe = gi.x, Se = gi.y);
                            });
                            var _n = t.arrowwidth, $i = t.arrowcolor, zn = t.arrowside, Wn = E.append("g").style({
                                opacity: Xb.opacity($i)
                            }).classed("annotation-arrow-g", !0), It = Wn.append("path").attr("d", "M" + xe + "," + Se + "L" + ht + "," + Le).style("stroke-width", _n + "px").call(Xb.stroke, Xb.rgb($i));
                            if (ipt(It, zn, t), l.annotationPosition && It.node().parentNode && !n) {
                                var ft = ht, jt = Le;
                                if (t.standoff) {
                                    var Zt = Math.sqrt(Math.pow(ht - xe, 2) + Math.pow(Le - Se, 2));
                                    ft += t.standoff * (xe - ht) / Zt, jt += t.standoff * (Se - Le) / Zt;
                                }
                                var yr = Wn.append("path").classed("annotation-arrow", !0).classed("anndrag", !0).classed("cursor-move", !0).attr({
                                    d: "M3,3H-3V-3H3ZM0,0L" + (xe - ft) + "," + (Se - jt),
                                    transform: AU(ft, jt)
                                }).style("stroke-width", _n + 6 + "px").call(Xb.stroke, "rgba(0,0,0,0)").call(Xb.fill, "rgba(0,0,0,0)"), Fr, Zr;
                                $M.init({
                                    element: yr.node(),
                                    gd: e,
                                    prepFn: function() {
                                        var Vr = Py.getTranslate(C);
                                        Fr = Vr.x, Zr = Vr.y, i && i.autorange && h(i._name + ".autorange", !0), a && a.autorange && h(a._name + ".autorange", !0);
                                    },
                                    moveFn: function(Vr, gi) {
                                        var Si = ar(Fr, Zr), Mi = Si[0] + Vr, Pi = Si[1] + gi;
                                        C.call(Py.setTranslate, Mi, Pi), d("x", y_(i, Vr, "x", s, t)), d("y", y_(a, gi, "y", s, t)), t.axref === t.xref && d("ax", y_(i, Vr, "ax", s, t)), t.ayref === t.yref && d("ay", y_(a, gi, "ay", s, t)), Wn.attr("transform", AU(Vr, gi)), k.attr({
                                            transform: "rotate(" + p + "," + Mi + "," + Pi + ")"
                                        });
                                    },
                                    doneFn: function() {
                                        TU.call("_guiRelayout", e, v());
                                        var Vr = document.querySelector(".js-notes-box-panel");
                                        Vr && Vr.redraw(Vr.selectedObj);
                                    }
                                });
                            }
                        }
                    };
                    if (t.showarrow && Ne(0, 0), A) {
                        var Ye;
                        $M.init({
                            element: C.node(),
                            gd: e,
                            prepFn: function() {
                                Ye = k.attr("transform");
                            },
                            moveFn: function(Ve, Xe) {
                                var ht = "pointer";
                                if (t.showarrow) t.axref === t.xref ? d("ax", y_(i, Ve, "ax", s, t)) : d("ax", t.ax + Ve), t.ayref === t.yref ? d("ay", y_(a, Xe, "ay", s.w, t)) : d("ay", t.ay + Xe), Ne(Ve, Xe);
                                else {
                                    if (n) return;
                                    var Le, xe;
                                    if (i) Le = y_(i, Ve, "x", s, t);
                                    else {
                                        var Se = t._xsize / s.w, lt = t.x + (t._xshift - t.xshift) / s.w - Se / 2;
                                        Le = $M.align(lt + Ve / s.w, Se, 0, 1, t.xanchor);
                                    }
                                    if (a) xe = y_(a, Xe, "y", s, t);
                                    else {
                                        var Gt = t._ysize / s.h, Vt = t.y - (t._yshift + t.yshift) / s.h - Gt / 2;
                                        xe = $M.align(Vt - Xe / s.h, Gt, 0, 1, t.yanchor);
                                    }
                                    d("x", Le), d("y", xe), (!i || !a) && (ht = $M.getCursor(i ? .5 : Le, a ? .5 : xe, t.xanchor, t.yanchor));
                                }
                                k.attr({
                                    transform: AU(Ve, Xe) + Ye
                                }), MU(C, ht);
                            },
                            clickFn: function(Ve, Xe) {
                                t.captureevents && e.emit("plotly_clickannotation", _(Xe));
                            },
                            doneFn: function() {
                                MU(C), TU.call("_guiRelayout", e, v());
                                var Ve = document.querySelector(".js-notes-box-panel");
                                Ve && Ve.redraw(Ve.selectedObj);
                            }
                        });
                    }
                }
                l.annotationText ? X.call(SU.makeEditable, {
                    delegate: C,
                    gd: e
                }).call(G).on("edit", function(W) {
                    t.text = W, this.call(G), d("text", W), i && i.autorange && h(i._name + ".autorange", !0), a && a.autorange && h(a._name + ".autorange", !0), TU.call("_guiRelayout", e, v());
                }) : X.call(G);
            }
        });
        var xpe = ye((iar, _pe)=>{
            "use strict";
            var ppe = Mr(), apt = ba(), gpe = Vs().arrayEditor;
            _pe.exports = {
                hasClickToShow: opt,
                onClick: spt
            };
            function opt(e, t) {
                var r = ype(e, t);
                return r.on.length > 0 || r.explicitOff.length > 0;
            }
            function spt(e, t) {
                var r = ype(e, t), n = r.on, i = r.off.concat(r.explicitOff), a = {}, o = e._fullLayout.annotations, s, l;
                if (n.length || i.length) {
                    for(s = 0; s < n.length; s++)l = gpe(e.layout, "annotations", o[n[s]]), l.modifyItem("visible", !0), ppe.extendFlat(a, l.getUpdateObj());
                    for(s = 0; s < i.length; s++)l = gpe(e.layout, "annotations", o[i[s]]), l.modifyItem("visible", !1), ppe.extendFlat(a, l.getUpdateObj());
                    return apt.call("update", e, {}, a);
                }
            }
            function ype(e, t) {
                var r = e._fullLayout.annotations, n = [], i = [], a = [], o = (t || []).length, s, l, u, c, f, h, d, v;
                for(s = 0; s < r.length; s++)if (u = r[s], c = u.clicktoshow, c) {
                    for(l = 0; l < o; l++)if (f = t[l], h = f.xaxis, d = f.yaxis, h._id === u.xref && d._id === u.yref && h.d2r(f.x) === mpe(u._xclick, h) && d.d2r(f.y) === mpe(u._yclick, d)) {
                        u.visible ? c === "onout" ? v = i : v = a : v = n, v.push(s);
                        break;
                    }
                    l === o && u.visible && c === "onout" && i.push(s);
                }
                return {
                    on: n,
                    off: i,
                    explicitOff: a
                };
            }
            function mpe(e, t) {
                return t.type === "log" ? t.l2r(e) : t.d2r(e);
            }
        });
        var kU = ye((nar, bpe)=>{
            "use strict";
            var EU = Mr(), uT = va();
            bpe.exports = function(t, r, n, i) {
                i("opacity");
                var a = i("bgcolor"), o = i("bordercolor"), s = uT.opacity(o);
                i("borderpad");
                var l = i("borderwidth"), u = i("showarrow");
                i("text", u ? " " : n._dfltTitle.annotation), i("textangle"), EU.coerceFont(i, "font", n.font), i("width"), i("align");
                var c = i("height");
                if (c && i("valign"), u) {
                    var f = i("arrowside"), h, d;
                    f.indexOf("end") !== -1 && (h = i("arrowhead"), d = i("arrowsize")), f.indexOf("start") !== -1 && (i("startarrowhead", h), i("startarrowsize", d)), i("arrowcolor", s ? r.bordercolor : uT.defaultLine), i("arrowwidth", (s && l || 1) * 2), i("standoff"), i("startstandoff");
                }
                var v = i("hovertext"), x = n.hoverlabel || {};
                if (v) {
                    var b = i("hoverlabel.bgcolor", x.bgcolor || (uT.opacity(a) ? uT.rgb(a) : uT.defaultLine)), p = i("hoverlabel.bordercolor", x.bordercolor || uT.contrast(b)), E = EU.extendFlat({}, x.font);
                    E.color || (E.color = p), EU.coerceFont(i, "hoverlabel.font", E);
                }
                i("captureevents", !!v);
            };
        });
        var Tpe = ye((aar, wpe)=>{
            "use strict";
            var CU = Mr(), Yb = Qa(), lpt = Zd(), upt = kU(), cpt = Nb();
            wpe.exports = function(t, r) {
                lpt(t, r, {
                    name: "annotations",
                    handleItemDefaults: fpt
                });
            };
            function fpt(e, t, r) {
                function n(k, A) {
                    return CU.coerce(e, t, cpt, k, A);
                }
                var i = n("visible"), a = n("clicktoshow");
                if (i || a) {
                    upt(e, t, r, n);
                    for(var o = t.showarrow, s = [
                        "x",
                        "y"
                    ], l = [
                        -10,
                        -30
                    ], u = {
                        _fullLayout: r
                    }, c = 0; c < 2; c++){
                        var f = s[c], h = Yb.coerceRef(e, t, u, f, "", "paper");
                        if (h !== "paper") {
                            var d = Yb.getFromId(u, h);
                            d._annIndices.push(t._index);
                        }
                        if (Yb.coercePosition(t, u, n, h, f, .5), o) {
                            var v = "a" + f, x = Yb.coerceRef(e, t, u, v, "pixel", [
                                "pixel",
                                "paper"
                            ]);
                            x !== "pixel" && x !== h && (x = t[v] = "pixel");
                            var b = x === "pixel" ? l[c] : .4;
                            Yb.coercePosition(t, u, n, x, v, b);
                        }
                        n(f + "anchor"), n(f + "shift");
                    }
                    if (CU.noneOrAll(e, t, [
                        "x",
                        "y"
                    ]), o && CU.noneOrAll(e, t, [
                        "ax",
                        "ay"
                    ]), a) {
                        var p = n("xclick"), E = n("yclick");
                        t._xclick = p === void 0 ? t.x : Yb.cleanPosition(p, u, t.xref), t._yclick = E === void 0 ? t.y : Yb.cleanPosition(E, u, t.yref);
                    }
                }
            }
        });
        var Mpe = ye((oar, Spe)=>{
            "use strict";
            var LU = Mr(), Kb = Qa(), hpt = fI().draw;
            Spe.exports = function(t) {
                var r = t._fullLayout, n = LU.filterVisible(r.annotations);
                if (n.length && t._fullData.length) return LU.syncOrAsync([
                    hpt,
                    dpt
                ], t);
            };
            function dpt(e) {
                var t = e._fullLayout;
                LU.filterVisible(t.annotations).forEach(function(r) {
                    var n = Kb.getFromId(e, r.xref), i = Kb.getFromId(e, r.yref), a = Kb.getRefType(r.xref), o = Kb.getRefType(r.yref);
                    r._extremes = {}, a === "range" && Ape(r, n), o === "range" && Ape(r, i);
                });
            }
            function Ape(e, t) {
                var r = t._id, n = r.charAt(0), i = e[n], a = e["a" + n], o = e[n + "ref"], s = e["a" + n + "ref"], l = e["_" + n + "padplus"], u = e["_" + n + "padminus"], c = {
                    x: 1,
                    y: -1
                }[n] * e[n + "shift"], f = 3 * e.arrowsize * e.arrowwidth || 0, h = f + c, d = f - c, v = 3 * e.startarrowsize * e.arrowwidth || 0, x = v + c, b = v - c, p;
                if (s === o) {
                    var E = Kb.findExtremes(t, [
                        t.r2c(i)
                    ], {
                        ppadplus: h,
                        ppadminus: d
                    }), k = Kb.findExtremes(t, [
                        t.r2c(a)
                    ], {
                        ppadplus: Math.max(l, x),
                        ppadminus: Math.max(u, b)
                    });
                    p = {
                        min: [
                            E.min[0],
                            k.min[0]
                        ],
                        max: [
                            E.max[0],
                            k.max[0]
                        ]
                    };
                } else x = a ? x + a : x, b = a ? b - a : b, p = Kb.findExtremes(t, [
                    t.r2c(i)
                ], {
                    ppadplus: Math.max(l, h, x),
                    ppadminus: Math.max(u, d, b)
                });
                e._extremes[r] = p;
            }
        });
        var kpe = ye((sar, Epe)=>{
            "use strict";
            var vpt = uo(), ppt = u6();
            Epe.exports = function(t, r, n, i) {
                r = r || {};
                var a = n === "log" && r.type === "linear", o = n === "linear" && r.type === "log";
                if (!(a || o)) return;
                var s = t._fullLayout.annotations, l = r._id.charAt(0), u, c;
                function f(d) {
                    var v = u[d], x = null;
                    a ? x = ppt(v, r.range) : x = Math.pow(10, v), vpt(x) || (x = null), i(c + d, x);
                }
                for(var h = 0; h < s.length; h++)u = s[h], c = "annotations[" + h + "].", u[l + "ref"] === r._id && f(l), u["a" + l + "ref"] === r._id && f("a" + l);
            };
        });
        var Ppe = ye((lar, Lpe)=>{
            "use strict";
            var PU = fI(), Cpe = xpe();
            Lpe.exports = {
                moduleType: "component",
                name: "annotations",
                layoutAttributes: Nb(),
                supplyLayoutDefaults: Tpe(),
                includeBasePlot: IM()("annotations"),
                calcAutorange: Mpe(),
                draw: PU.draw,
                drawOne: PU.drawOne,
                drawRaw: PU.drawRaw,
                hasClickToShow: Cpe.hasClickToShow,
                onClick: Cpe.onClick,
                convertCoords: kpe()
            };
        });
        var hI = ye((uar, Ipe)=>{
            "use strict";
            var Ku = Nb(), gpt = Bu().overrideAll, mpt = Vs().templatedArray;
            Ipe.exports = gpt(mpt("annotation", {
                visible: Ku.visible,
                x: {
                    valType: "any"
                },
                y: {
                    valType: "any"
                },
                z: {
                    valType: "any"
                },
                ax: {
                    valType: "number"
                },
                ay: {
                    valType: "number"
                },
                xanchor: Ku.xanchor,
                xshift: Ku.xshift,
                yanchor: Ku.yanchor,
                yshift: Ku.yshift,
                text: Ku.text,
                textangle: Ku.textangle,
                font: Ku.font,
                width: Ku.width,
                height: Ku.height,
                opacity: Ku.opacity,
                align: Ku.align,
                valign: Ku.valign,
                bgcolor: Ku.bgcolor,
                bordercolor: Ku.bordercolor,
                borderpad: Ku.borderpad,
                borderwidth: Ku.borderwidth,
                showarrow: Ku.showarrow,
                arrowcolor: Ku.arrowcolor,
                arrowhead: Ku.arrowhead,
                startarrowhead: Ku.startarrowhead,
                arrowside: Ku.arrowside,
                arrowsize: Ku.arrowsize,
                startarrowsize: Ku.startarrowsize,
                arrowwidth: Ku.arrowwidth,
                standoff: Ku.standoff,
                startstandoff: Ku.startstandoff,
                hovertext: Ku.hovertext,
                hoverlabel: Ku.hoverlabel,
                captureevents: Ku.captureevents
            }), "calc", "from-root");
        });
        var Dpe = ye((car, Rpe)=>{
            "use strict";
            var IU = Mr(), ypt = Qa(), _pt = Zd(), xpt = kU(), bpt = hI();
            Rpe.exports = function(t, r, n) {
                _pt(t, r, {
                    name: "annotations",
                    handleItemDefaults: wpt,
                    fullLayout: n.fullLayout
                });
            };
            function wpt(e, t, r, n) {
                function i(s, l) {
                    return IU.coerce(e, t, bpt, s, l);
                }
                function a(s) {
                    var l = s + "axis", u = {
                        _fullLayout: {}
                    };
                    return u._fullLayout[l] = r[l], ypt.coercePosition(t, u, i, s, s, .5);
                }
                var o = i("visible");
                o && (xpt(e, t, n.fullLayout, i), a("x"), a("y"), a("z"), IU.noneOrAll(e, t, [
                    "x",
                    "y",
                    "z"
                ]), t.xref = "x", t.yref = "y", t.zref = "z", i("xanchor"), i("yanchor"), i("xshift"), i("yshift"), t.showarrow && (t.axref = "pixel", t.ayref = "pixel", i("ax", -10), i("ay", -30), IU.noneOrAll(e, t, [
                    "ax",
                    "ay"
                ])));
            }
        });
        var Ope = ye((far, qpe)=>{
            "use strict";
            var zpe = Mr(), Fpe = Qa();
            qpe.exports = function(t) {
                for(var r = t.fullSceneLayout, n = r.annotations, i = 0; i < n.length; i++)Tpt(n[i], t);
                t.fullLayout._infolayer.selectAll(".annotation-" + t.id).remove();
            };
            function Tpt(e, t) {
                var r = t.fullSceneLayout, n = r.domain, i = t.fullLayout._size, a = {
                    pdata: null,
                    type: "linear",
                    autorange: !1,
                    range: [
                        -1 / 0,
                        1 / 0
                    ]
                };
                e._xa = {}, zpe.extendFlat(e._xa, a), Fpe.setConvert(e._xa), e._xa._offset = i.l + n.x[0] * i.w, e._xa.l2p = function() {
                    return .5 * (1 + e._pdata[0] / e._pdata[3]) * i.w * (n.x[1] - n.x[0]);
                }, e._ya = {}, zpe.extendFlat(e._ya, a), Fpe.setConvert(e._ya), e._ya._offset = i.t + (1 - n.y[1]) * i.h, e._ya.l2p = function() {
                    return .5 * (1 - e._pdata[1] / e._pdata[3]) * i.h * (n.y[1] - n.y[0]);
                };
            }
        });
        var DU = ye((har, Bpe)=>{
            "use strict";
            function RU(e, t) {
                var r = [
                    0,
                    0,
                    0,
                    0
                ], n, i;
                for(n = 0; n < 4; ++n)for(i = 0; i < 4; ++i)r[i] += e[4 * n + i] * t[n];
                return r;
            }
            function Apt(e, t) {
                var r = RU(e.projection, RU(e.view, RU(e.model, [
                    t[0],
                    t[1],
                    t[2],
                    1
                ])));
                return r;
            }
            Bpe.exports = Apt;
        });
        var Upe = ye((dar, Npe)=>{
            "use strict";
            var Spt = fI().drawRaw, Mpt = DU(), Ept = [
                "x",
                "y",
                "z"
            ];
            Npe.exports = function(t) {
                for(var r = t.fullSceneLayout, n = t.dataScale, i = r.annotations, a = 0; a < i.length; a++){
                    for(var o = i[a], s = !1, l = 0; l < 3; l++){
                        var u = Ept[l], c = o[u], f = r[u + "axis"], h = f.r2fraction(c);
                        if (h < 0 || h > 1) {
                            s = !0;
                            break;
                        }
                    }
                    s ? t.fullLayout._infolayer.select(".annotation-" + t.id + '[data-index="' + a + '"]').remove() : (o._pdata = Mpt(t.glplot.cameraParams, [
                        r.xaxis.r2l(o.x) * n[0],
                        r.yaxis.r2l(o.y) * n[1],
                        r.zaxis.r2l(o.z) * n[2]
                    ]), Spt(t.graphDiv, o, a, t.id, o._xa, o._ya));
                }
            };
        });
        var Gpe = ye((par, Hpe)=>{
            "use strict";
            var kpt = ba(), Vpe = Mr();
            Hpe.exports = {
                moduleType: "component",
                name: "annotations3d",
                schema: {
                    subplots: {
                        scene: {
                            annotations: hI()
                        }
                    }
                },
                layoutAttributes: hI(),
                handleDefaults: Dpe(),
                includeBasePlot: Cpt,
                convert: Ope(),
                draw: Upe()
            };
            function Cpt(e, t) {
                var r = kpt.subplotsRegistry.gl3d;
                if (r) for(var n = r.attrRegex, i = Object.keys(e), a = 0; a < i.length; a++){
                    var o = i[a];
                    n.test(o) && (e[o].annotations || []).length && (Vpe.pushUnique(t._basePlotModules, r), Vpe.pushUnique(t._subplots.gl3d, o));
                }
            }
        });
        var zU = ye((mar, Xpe)=>{
            "use strict";
            var jpe = Nb(), Wpe = Su(), Zpe = Uc().line, Lpt = Ed().dash, Fg = no().extendFlat, Ppt = Vs().templatedArray, gar = PM(), cT = vl(), Ipt = Wo().shapeTexttemplateAttrs, Rpt = b6();
            Xpe.exports = Ppt("shape", {
                visible: Fg({}, cT.visible, {
                    editType: "calc+arraydraw"
                }),
                showlegend: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "calc+arraydraw"
                },
                legend: Fg({}, cT.legend, {
                    editType: "calc+arraydraw"
                }),
                legendgroup: Fg({}, cT.legendgroup, {
                    editType: "calc+arraydraw"
                }),
                legendgrouptitle: {
                    text: Fg({}, cT.legendgrouptitle.text, {
                        editType: "calc+arraydraw"
                    }),
                    font: Wpe({
                        editType: "calc+arraydraw"
                    }),
                    editType: "calc+arraydraw"
                },
                legendrank: Fg({}, cT.legendrank, {
                    editType: "calc+arraydraw"
                }),
                legendwidth: Fg({}, cT.legendwidth, {
                    editType: "calc+arraydraw"
                }),
                type: {
                    valType: "enumerated",
                    values: [
                        "circle",
                        "rect",
                        "path",
                        "line"
                    ],
                    editType: "calc+arraydraw"
                },
                layer: {
                    valType: "enumerated",
                    values: [
                        "below",
                        "above",
                        "between"
                    ],
                    dflt: "above",
                    editType: "arraydraw"
                },
                xref: Fg({}, jpe.xref, {}),
                xsizemode: {
                    valType: "enumerated",
                    values: [
                        "scaled",
                        "pixel"
                    ],
                    dflt: "scaled",
                    editType: "calc+arraydraw"
                },
                xanchor: {
                    valType: "any",
                    editType: "calc+arraydraw"
                },
                x0: {
                    valType: "any",
                    editType: "calc+arraydraw"
                },
                x1: {
                    valType: "any",
                    editType: "calc+arraydraw"
                },
                x0shift: {
                    valType: "number",
                    dflt: 0,
                    min: -1,
                    max: 1,
                    editType: "calc"
                },
                x1shift: {
                    valType: "number",
                    dflt: 0,
                    min: -1,
                    max: 1,
                    editType: "calc"
                },
                yref: Fg({}, jpe.yref, {}),
                ysizemode: {
                    valType: "enumerated",
                    values: [
                        "scaled",
                        "pixel"
                    ],
                    dflt: "scaled",
                    editType: "calc+arraydraw"
                },
                yanchor: {
                    valType: "any",
                    editType: "calc+arraydraw"
                },
                y0: {
                    valType: "any",
                    editType: "calc+arraydraw"
                },
                y1: {
                    valType: "any",
                    editType: "calc+arraydraw"
                },
                y0shift: {
                    valType: "number",
                    dflt: 0,
                    min: -1,
                    max: 1,
                    editType: "calc"
                },
                y1shift: {
                    valType: "number",
                    dflt: 0,
                    min: -1,
                    max: 1,
                    editType: "calc"
                },
                path: {
                    valType: "string",
                    editType: "calc+arraydraw"
                },
                opacity: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 1,
                    editType: "arraydraw"
                },
                line: {
                    color: Fg({}, Zpe.color, {
                        editType: "arraydraw"
                    }),
                    width: Fg({}, Zpe.width, {
                        editType: "calc+arraydraw"
                    }),
                    dash: Fg({}, Lpt, {
                        editType: "arraydraw"
                    }),
                    editType: "calc+arraydraw"
                },
                fillcolor: {
                    valType: "color",
                    dflt: "rgba(0,0,0,0)",
                    editType: "arraydraw"
                },
                fillrule: {
                    valType: "enumerated",
                    values: [
                        "evenodd",
                        "nonzero"
                    ],
                    dflt: "evenodd",
                    editType: "arraydraw"
                },
                editable: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "calc+arraydraw"
                },
                label: {
                    text: {
                        valType: "string",
                        dflt: "",
                        editType: "arraydraw"
                    },
                    texttemplate: Ipt({}, {
                        keys: Object.keys(Rpt)
                    }),
                    font: Wpe({
                        editType: "calc+arraydraw",
                        colorEditType: "arraydraw"
                    }),
                    textposition: {
                        valType: "enumerated",
                        values: [
                            "top left",
                            "top center",
                            "top right",
                            "middle left",
                            "middle center",
                            "middle right",
                            "bottom left",
                            "bottom center",
                            "bottom right",
                            "start",
                            "middle",
                            "end"
                        ],
                        editType: "arraydraw"
                    },
                    textangle: {
                        valType: "angle",
                        dflt: "auto",
                        editType: "calc+arraydraw"
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "auto",
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "auto",
                        editType: "calc+arraydraw"
                    },
                    yanchor: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "middle",
                            "bottom"
                        ],
                        editType: "calc+arraydraw"
                    },
                    padding: {
                        valType: "number",
                        dflt: 3,
                        min: 0,
                        editType: "arraydraw"
                    },
                    editType: "arraydraw"
                },
                editType: "arraydraw"
            });
        });
        var Jpe = ye((yar, Kpe)=>{
            "use strict";
            var e4 = Mr(), fT = Qa(), Dpt = Zd(), zpt = zU(), Ype = h_();
            Kpe.exports = function(t, r) {
                Dpt(t, r, {
                    name: "shapes",
                    handleItemDefaults: qpt
                });
            };
            function Fpt(e, t) {
                return e ? "bottom" : t.indexOf("top") !== -1 ? "top" : t.indexOf("bottom") !== -1 ? "bottom" : "middle";
            }
            function qpt(e, t, r) {
                function n(W, re) {
                    return e4.coerce(e, t, zpt, W, re);
                }
                t._isShape = !0;
                var i = n("visible");
                if (i) {
                    var a = n("showlegend");
                    a && (n("legend"), n("legendwidth"), n("legendgroup"), n("legendgrouptitle.text"), e4.coerceFont(n, "legendgrouptitle.font"), n("legendrank"));
                    var o = n("path"), s = o ? "path" : "rect", l = n("type", s), u = l !== "path";
                    u && delete t.path, n("editable"), n("layer"), n("opacity"), n("fillcolor"), n("fillrule");
                    var c = n("line.width");
                    c && (n("line.color"), n("line.dash"));
                    for(var f = n("xsizemode"), h = n("ysizemode"), d = [
                        "x",
                        "y"
                    ], v = 0; v < 2; v++){
                        var x = d[v], b = x + "anchor", p = x === "x" ? f : h, E = {
                            _fullLayout: r
                        }, k, A, L, _ = fT.coerceRef(e, t, E, x, void 0, "paper"), C = fT.getRefType(_);
                        if (C === "range" ? (k = fT.getFromId(E, _), k._shapeIndices.push(t._index), L = Ype.rangeToShapePosition(k), A = Ype.shapePositionToRange(k), (k.type === "category" || k.type === "multicategory") && (n(x + "0shift"), n(x + "1shift"))) : A = L = e4.identity, u) {
                            var M = .25, g = .75, P = x + "0", T = x + "1", F = e[P], q = e[T];
                            e[P] = A(e[P], !0), e[T] = A(e[T], !0), p === "pixel" ? (n(P, 0), n(T, 10)) : (fT.coercePosition(t, E, n, _, P, M), fT.coercePosition(t, E, n, _, T, g)), t[P] = L(t[P]), t[T] = L(t[T]), e[P] = F, e[T] = q;
                        }
                        if (p === "pixel") {
                            var V = e[b];
                            e[b] = A(e[b], !0), fT.coercePosition(t, E, n, _, b, .25), t[b] = L(t[b]), e[b] = V;
                        }
                    }
                    u && e4.noneOrAll(e, t, [
                        "x0",
                        "x1",
                        "y0",
                        "y1"
                    ]);
                    var H = l === "line", X, G;
                    if (u && (X = n("label.texttemplate")), X || (G = n("label.text")), G || X) {
                        n("label.textangle");
                        var N = n("label.textposition", H ? "middle" : "middle center");
                        n("label.xanchor"), n("label.yanchor", Fpt(H, N)), n("label.padding"), e4.coerceFont(n, "label.font", r.font);
                    }
                }
            }
        });
        var e0e = ye((_ar, Qpe)=>{
            "use strict";
            var Opt = va(), $pe = Mr();
            function Bpt(e, t) {
                return e ? "bottom" : t.indexOf("top") !== -1 ? "top" : t.indexOf("bottom") !== -1 ? "bottom" : "middle";
            }
            Qpe.exports = function(t, r, n) {
                n("newshape.visible"), n("newshape.name"), n("newshape.showlegend"), n("newshape.legend"), n("newshape.legendwidth"), n("newshape.legendgroup"), n("newshape.legendgrouptitle.text"), $pe.coerceFont(n, "newshape.legendgrouptitle.font"), n("newshape.legendrank"), n("newshape.drawdirection"), n("newshape.layer"), n("newshape.fillcolor"), n("newshape.fillrule"), n("newshape.opacity");
                var i = n("newshape.line.width");
                if (i) {
                    var a = (t || {}).plot_bgcolor || "#FFF";
                    n("newshape.line.color", Opt.contrast(a)), n("newshape.line.dash");
                }
                var o = t.dragmode === "drawline", s = n("newshape.label.text"), l = n("newshape.label.texttemplate");
                if (s || l) {
                    n("newshape.label.textangle");
                    var u = n("newshape.label.textposition", o ? "middle" : "middle center");
                    n("newshape.label.xanchor"), n("newshape.label.yanchor", Bpt(o, u)), n("newshape.label.padding"), $pe.coerceFont(n, "newshape.label.font", r.font);
                }
                n("activeshape.fillcolor"), n("activeshape.opacity");
            };
        });
        var a0e = ye((xar, n0e)=>{
            "use strict";
            var FU = Mr(), hT = Qa(), dT = cM(), r0e = h_();
            n0e.exports = function(t) {
                var r = t._fullLayout, n = FU.filterVisible(r.shapes);
                if (!(!n.length || !t._fullData.length)) for(var i = 0; i < n.length; i++){
                    var a = n[i];
                    a._extremes = {};
                    var o, s, l = hT.getRefType(a.xref), u = hT.getRefType(a.yref);
                    a.xref !== "paper" && l !== "domain" && (o = hT.getFromId(t, a.xref), s = t0e(o, a, dT.paramIsX), s && (a._extremes[o._id] = hT.findExtremes(o, s, Npt(a)))), a.yref !== "paper" && u !== "domain" && (o = hT.getFromId(t, a.yref), s = t0e(o, a, dT.paramIsY), s && (a._extremes[o._id] = hT.findExtremes(o, s, Upt(a))));
                }
            };
            function Npt(e) {
                return i0e(e.line.width, e.xsizemode, e.x0, e.x1, e.path, !1);
            }
            function Upt(e) {
                return i0e(e.line.width, e.ysizemode, e.y0, e.y1, e.path, !0);
            }
            function i0e(e, t, r, n, i, a) {
                var o = e / 2, s = a;
                if (t === "pixel") {
                    var l = i ? r0e.extractPathCoords(i, a ? dT.paramIsY : dT.paramIsX) : [
                        r,
                        n
                    ], u = FU.aggNums(Math.max, null, l), c = FU.aggNums(Math.min, null, l), f = c < 0 ? Math.abs(c) + o : o, h = u > 0 ? u + o : o;
                    return {
                        ppad: o,
                        ppadplus: s ? f : h,
                        ppadminus: s ? h : f
                    };
                } else return {
                    ppad: o
                };
            }
            function t0e(e, t, r) {
                var n = e._id.charAt(0) === "x" ? "x" : "y", i = e.type === "category" || e.type === "multicategory", a, o, s = 0, l = 0, u = i ? e.r2c : e.d2c, c = t[n + "sizemode"] === "scaled";
                if (c ? (a = t[n + "0"], o = t[n + "1"], i && (s = t[n + "0shift"], l = t[n + "1shift"])) : (a = t[n + "anchor"], o = t[n + "anchor"]), a !== void 0) return [
                    u(a) + s,
                    u(o) + l
                ];
                if (t.path) {
                    var f = 1 / 0, h = -1 / 0, d = t.path.match(dT.segmentRE), v, x, b, p, E;
                    for(e.type === "date" && (u = r0e.decodeDate(u)), v = 0; v < d.length; v++)x = d[v], b = r[x.charAt(0)].drawn, b !== void 0 && (p = d[v].substr(1).match(dT.paramRE), !(!p || p.length < b) && (E = u(p[b]), E < f && (f = E), E > h && (h = E)));
                    if (h >= f) return [
                        f,
                        h
                    ];
                }
            }
        });
        var l0e = ye((bar, s0e)=>{
            "use strict";
            var o0e = rP();
            s0e.exports = {
                moduleType: "component",
                name: "shapes",
                layoutAttributes: zU(),
                supplyLayoutDefaults: Jpe(),
                supplyDrawNewShapeDefaults: e0e(),
                includeBasePlot: IM()("shapes"),
                calcAutorange: a0e(),
                draw: o0e.draw,
                drawOne: o0e.drawOne
            };
        });
        var qU = ye((Tar, c0e)=>{
            "use strict";
            var u0e = ad(), Vpt = Vs().templatedArray, war = PM();
            c0e.exports = Vpt("image", {
                visible: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "arraydraw"
                },
                source: {
                    valType: "string",
                    editType: "arraydraw"
                },
                layer: {
                    valType: "enumerated",
                    values: [
                        "below",
                        "above"
                    ],
                    dflt: "above",
                    editType: "arraydraw"
                },
                sizex: {
                    valType: "number",
                    dflt: 0,
                    editType: "arraydraw"
                },
                sizey: {
                    valType: "number",
                    dflt: 0,
                    editType: "arraydraw"
                },
                sizing: {
                    valType: "enumerated",
                    values: [
                        "fill",
                        "contain",
                        "stretch"
                    ],
                    dflt: "contain",
                    editType: "arraydraw"
                },
                opacity: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 1,
                    editType: "arraydraw"
                },
                x: {
                    valType: "any",
                    dflt: 0,
                    editType: "arraydraw"
                },
                y: {
                    valType: "any",
                    dflt: 0,
                    editType: "arraydraw"
                },
                xanchor: {
                    valType: "enumerated",
                    values: [
                        "left",
                        "center",
                        "right"
                    ],
                    dflt: "left",
                    editType: "arraydraw"
                },
                yanchor: {
                    valType: "enumerated",
                    values: [
                        "top",
                        "middle",
                        "bottom"
                    ],
                    dflt: "top",
                    editType: "arraydraw"
                },
                xref: {
                    valType: "enumerated",
                    values: [
                        "paper",
                        u0e.idRegex.x.toString()
                    ],
                    dflt: "paper",
                    editType: "arraydraw"
                },
                yref: {
                    valType: "enumerated",
                    values: [
                        "paper",
                        u0e.idRegex.y.toString()
                    ],
                    dflt: "paper",
                    editType: "arraydraw"
                },
                editType: "arraydraw"
            });
        });
        var h0e = ye((Aar, f0e)=>{
            "use strict";
            var Hpt = Mr(), OU = Qa(), Gpt = Zd(), jpt = qU(), Wpt = "images";
            f0e.exports = function(t, r) {
                var n = {
                    name: Wpt,
                    handleItemDefaults: Zpt
                };
                Gpt(t, r, n);
            };
            function Zpt(e, t, r) {
                function n(h, d) {
                    return Hpt.coerce(e, t, jpt, h, d);
                }
                var i = n("source"), a = n("visible", !!i);
                if (!a) return t;
                n("layer"), n("xanchor"), n("yanchor"), n("sizex"), n("sizey"), n("sizing"), n("opacity");
                for(var o = {
                    _fullLayout: r
                }, s = [
                    "x",
                    "y"
                ], l = 0; l < 2; l++){
                    var u = s[l], c = OU.coerceRef(e, t, o, u, "paper", void 0);
                    if (c !== "paper") {
                        var f = OU.getFromId(o, c);
                        f._imgIndices.push(t._index);
                    }
                    OU.coercePosition(t, o, n, c, u, 0);
                }
                return t;
            }
        });
        var g0e = ye((Sar, p0e)=>{
            "use strict";
            var d0e = xa(), Xpt = ao(), vT = Qa(), v0e = af(), Ypt = Zp();
            p0e.exports = function(t) {
                var r = t._fullLayout, n = [], i = {}, a = [], o, s;
                for(s = 0; s < r.images.length; s++){
                    var l = r.images[s];
                    if (l.visible) {
                        if (l.layer === "below" && l.xref !== "paper" && l.yref !== "paper") {
                            o = v0e.ref2id(l.xref) + v0e.ref2id(l.yref);
                            var u = r._plots[o];
                            if (!u) {
                                a.push(l);
                                continue;
                            }
                            u.mainplot && (o = u.mainplot.id), i[o] || (i[o] = []), i[o].push(l);
                        } else l.layer === "above" ? n.push(l) : a.push(l);
                    }
                }
                var c = {
                    x: {
                        left: {
                            sizing: "xMin",
                            offset: 0
                        },
                        center: {
                            sizing: "xMid",
                            offset: -0.5
                        },
                        right: {
                            sizing: "xMax",
                            offset: -1
                        }
                    },
                    y: {
                        top: {
                            sizing: "YMin",
                            offset: 0
                        },
                        middle: {
                            sizing: "YMid",
                            offset: -0.5
                        },
                        bottom: {
                            sizing: "YMax",
                            offset: -1
                        }
                    }
                };
                function f(A) {
                    var L = d0e.select(this);
                    if (this._imgSrc !== A.source) {
                        if (L.attr("xmlns", Ypt.svg), !t._context.staticPlot || A.source && A.source.slice(0, 5) === "data:") L.attr("xlink:href", A.source), this._imgSrc = A.source;
                        else {
                            var _ = new Promise((function(C) {
                                var M = new Image;
                                this.img = M, M.setAttribute("crossOrigin", "anonymous"), M.onerror = g, M.onload = function() {
                                    var P = document.createElement("canvas");
                                    P.width = this.width, P.height = this.height;
                                    var T = P.getContext("2d", {
                                        willReadFrequently: !0
                                    });
                                    T.drawImage(this, 0, 0);
                                    var F = P.toDataURL("image/png");
                                    L.attr("xlink:href", F), C();
                                }, L.on("error", g), M.src = A.source, this._imgSrc = A.source;
                                function g() {
                                    L.remove(), C();
                                }
                            }).bind(this));
                            t._promises.push(_);
                        }
                    }
                }
                function h(A) {
                    var L = d0e.select(this), _ = vT.getFromId(t, A.xref), C = vT.getFromId(t, A.yref), M = vT.getRefType(A.xref) === "domain", g = vT.getRefType(A.yref) === "domain", P = r._size, T, F;
                    _ !== void 0 ? T = typeof A.xref == "string" && M ? _._length * A.sizex : Math.abs(_.l2p(A.sizex) - _.l2p(0)) : T = A.sizex * P.w, C !== void 0 ? F = typeof A.yref == "string" && g ? C._length * A.sizey : Math.abs(C.l2p(A.sizey) - C.l2p(0)) : F = A.sizey * P.h;
                    var q = T * c.x[A.xanchor].offset, V = F * c.y[A.yanchor].offset, H = c.x[A.xanchor].sizing + c.y[A.yanchor].sizing, X, G;
                    switch(_ !== void 0 ? X = typeof A.xref == "string" && M ? _._length * A.x + _._offset : _.r2p(A.x) + _._offset : X = A.x * P.w + P.l, X += q, C !== void 0 ? G = typeof A.yref == "string" && g ? C._length * (1 - A.y) + C._offset : C.r2p(A.y) + C._offset : G = P.h - A.y * P.h + P.t, G += V, A.sizing){
                        case "fill":
                            H += " slice";
                            break;
                        case "stretch":
                            H = "none";
                            break;
                    }
                    L.attr({
                        x: X,
                        y: G,
                        width: T,
                        height: F,
                        preserveAspectRatio: H,
                        opacity: A.opacity
                    });
                    var N = _ && vT.getRefType(A.xref) !== "domain" ? _._id : "", W = C && vT.getRefType(A.yref) !== "domain" ? C._id : "", re = N + W;
                    Xpt.setClipUrl(L, re ? "clip" + r._uid + re : null, t);
                }
                function d(A) {
                    return [
                        A.xref,
                        A.x,
                        A.sizex,
                        A.yref,
                        A.y,
                        A.sizey
                    ].join("_");
                }
                function v(A, L) {
                    return A._index - L._index;
                }
                var x = r._imageLowerLayer.selectAll("image").data(a, d), b = r._imageUpperLayer.selectAll("image").data(n, d);
                x.enter().append("image"), b.enter().append("image"), x.exit().remove(), b.exit().remove(), x.each(function(A) {
                    f.bind(this)(A), h.bind(this)(A);
                }), b.each(function(A) {
                    f.bind(this)(A), h.bind(this)(A);
                }), x.sort(v), b.sort(v);
                var p = Object.keys(r._plots);
                for(s = 0; s < p.length; s++){
                    o = p[s];
                    var E = r._plots[o];
                    if (E.imagelayer) {
                        var k = E.imagelayer.selectAll("image").data(i[o] || [], d);
                        k.enter().append("image"), k.exit().remove(), k.each(function(A) {
                            f.bind(this)(A), h.bind(this)(A);
                        }), k.sort(v);
                    }
                }
            };
        });
        var _0e = ye((Mar, y0e)=>{
            "use strict";
            var m0e = uo(), Kpt = u6();
            y0e.exports = function(t, r, n, i) {
                r = r || {};
                var a = n === "log" && r.type === "linear", o = n === "linear" && r.type === "log";
                if (a || o) {
                    for(var s = t._fullLayout.images, l = r._id.charAt(0), u, c, f = 0; f < s.length; f++)if (u = s[f], c = "images[" + f + "].", u[l + "ref"] === r._id) {
                        var h = u[l], d = u["size" + l], v = null, x = null;
                        if (a) {
                            v = Kpt(h, r.range);
                            var b = d / Math.pow(10, v) / 2;
                            x = 2 * Math.log(b + Math.sqrt(1 + b * b)) / Math.LN10;
                        } else v = Math.pow(10, h), x = v * (Math.pow(10, d / 2) - Math.pow(10, -d / 2));
                        m0e(v) ? m0e(x) || (x = null) : (v = null, x = null), i(c + l, v), i(c + "size" + l, x);
                    }
                }
            };
        });
        var b0e = ye((Ear, x0e)=>{
            "use strict";
            x0e.exports = {
                moduleType: "component",
                name: "images",
                layoutAttributes: qU(),
                supplyLayoutDefaults: h0e(),
                includeBasePlot: IM()("images"),
                draw: g0e(),
                convertCoords: _0e()
            };
        });
        var dI = ye((kar, w0e)=>{
            "use strict";
            w0e.exports = {
                name: "updatemenus",
                containerClassName: "updatemenu-container",
                headerGroupClassName: "updatemenu-header-group",
                headerClassName: "updatemenu-header",
                headerArrowClassName: "updatemenu-header-arrow",
                dropdownButtonGroupClassName: "updatemenu-dropdown-button-group",
                dropdownButtonClassName: "updatemenu-dropdown-button",
                buttonClassName: "updatemenu-button",
                itemRectClassName: "updatemenu-item-rect",
                itemTextClassName: "updatemenu-item-text",
                menuIndexAttrName: "updatemenu-active-index",
                autoMarginIdRoot: "updatemenu-",
                blankHeaderOpts: {
                    label: "  "
                },
                minWidth: 30,
                minHeight: 30,
                textPadX: 24,
                arrowPadX: 16,
                rx: 2,
                ry: 2,
                textOffsetX: 12,
                textOffsetY: 3,
                arrowOffsetX: 4,
                gapButtonHeader: 5,
                gapButton: 2,
                activeColor: "#F4FAFF",
                hoverColor: "#F4FAFF",
                arrowSymbol: {
                    left: "\u25C4",
                    right: "\u25BA",
                    up: "\u25B2",
                    down: "\u25BC"
                }
            };
        });
        var BU = ye((Car, A0e)=>{
            "use strict";
            var Jpt = Su(), $pt = dh(), Qpt = no().extendFlat, e0t = Bu().overrideAll, t0t = w6(), T0e = Vs().templatedArray, r0t = T0e("button", {
                visible: {
                    valType: "boolean"
                },
                method: {
                    valType: "enumerated",
                    values: [
                        "restyle",
                        "relayout",
                        "animate",
                        "update",
                        "skip"
                    ],
                    dflt: "restyle"
                },
                args: {
                    valType: "info_array",
                    freeLength: !0,
                    items: [
                        {
                            valType: "any"
                        },
                        {
                            valType: "any"
                        },
                        {
                            valType: "any"
                        }
                    ]
                },
                args2: {
                    valType: "info_array",
                    freeLength: !0,
                    items: [
                        {
                            valType: "any"
                        },
                        {
                            valType: "any"
                        },
                        {
                            valType: "any"
                        }
                    ]
                },
                label: {
                    valType: "string",
                    dflt: ""
                },
                execute: {
                    valType: "boolean",
                    dflt: !0
                }
            });
            A0e.exports = e0t(T0e("updatemenu", {
                _arrayAttrRegexps: [
                    /^updatemenus\[(0|[1-9][0-9]+)\]\.buttons/
                ],
                visible: {
                    valType: "boolean"
                },
                type: {
                    valType: "enumerated",
                    values: [
                        "dropdown",
                        "buttons"
                    ],
                    dflt: "dropdown"
                },
                direction: {
                    valType: "enumerated",
                    values: [
                        "left",
                        "right",
                        "up",
                        "down"
                    ],
                    dflt: "down"
                },
                active: {
                    valType: "integer",
                    min: -1,
                    dflt: 0
                },
                showactive: {
                    valType: "boolean",
                    dflt: !0
                },
                buttons: r0t,
                x: {
                    valType: "number",
                    min: -2,
                    max: 3,
                    dflt: -0.05
                },
                xanchor: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "left",
                        "center",
                        "right"
                    ],
                    dflt: "right"
                },
                y: {
                    valType: "number",
                    min: -2,
                    max: 3,
                    dflt: 1
                },
                yanchor: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "top",
                        "middle",
                        "bottom"
                    ],
                    dflt: "top"
                },
                pad: Qpt(t0t({
                    editType: "arraydraw"
                }), {}),
                font: Jpt({}),
                bgcolor: {
                    valType: "color"
                },
                bordercolor: {
                    valType: "color",
                    dflt: $pt.borderLine
                },
                borderwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "arraydraw"
                }
            }), "arraydraw", "from-root");
        });
        var k0e = ye((Lar, E0e)=>{
            "use strict";
            var vI = Mr(), S0e = Zd(), M0e = BU(), i0t = dI(), n0t = i0t.name, a0t = M0e.buttons;
            E0e.exports = function(t, r) {
                var n = {
                    name: n0t,
                    handleItemDefaults: o0t
                };
                S0e(t, r, n);
            };
            function o0t(e, t, r) {
                function n(o, s) {
                    return vI.coerce(e, t, M0e, o, s);
                }
                var i = S0e(e, t, {
                    name: "buttons",
                    handleItemDefaults: s0t
                }), a = n("visible", i.length > 0);
                a && (n("active"), n("direction"), n("type"), n("showactive"), n("x"), n("y"), vI.noneOrAll(e, t, [
                    "x",
                    "y"
                ]), n("xanchor"), n("yanchor"), n("pad.t"), n("pad.r"), n("pad.b"), n("pad.l"), vI.coerceFont(n, "font", r.font), n("bgcolor", r.paper_bgcolor), n("bordercolor"), n("borderwidth"));
            }
            function s0t(e, t) {
                function r(i, a) {
                    return vI.coerce(e, t, a0t, i, a);
                }
                var n = r("visible", e.method === "skip" || Array.isArray(e.args));
                n && (r("method"), r("args"), r("args2"), r("label"), r("execute"));
            }
        });
        var P0e = ye((Par, L0e)=>{
            "use strict";
            L0e.exports = of;
            var qg = xa(), C0e = va(), pT = ao(), pI = Mr();
            function of(e, t, r) {
                this.gd = e, this.container = t, this.id = r, this.position = null, this.translateX = null, this.translateY = null, this.hbar = null, this.vbar = null, this.bg = this.container.selectAll("rect.scrollbox-bg").data([
                    0
                ]), this.bg.exit().on(".drag", null).on("wheel", null).remove(), this.bg.enter().append("rect").classed("scrollbox-bg", !0).style("pointer-events", "all").attr({
                    opacity: 0,
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                });
            }
            of.barWidth = 2;
            of.barLength = 20;
            of.barRadius = 2;
            of.barPad = 1;
            of.barColor = "#808BA4";
            of.prototype.enable = function(t, r, n) {
                var i = this.gd._fullLayout, a = i.width, o = i.height;
                this.position = t;
                var s = this.position.l, l = this.position.w, u = this.position.t, c = this.position.h, f = this.position.direction, h = f === "down", d = f === "left", v = f === "right", x = f === "up", b = l, p = c, E, k, A, L;
                !h && !d && !v && !x && (this.position.direction = "down", h = !0);
                var _ = h || x;
                _ ? (E = s, k = E + b, h ? (A = u, L = Math.min(A + p, o), p = L - A) : (L = u + p, A = Math.max(L - p, 0), p = L - A)) : (A = u, L = A + p, d ? (k = s + b, E = Math.max(k - b, 0), b = k - E) : (E = s, k = Math.min(E + b, a), b = k - E)), this._box = {
                    l: E,
                    t: A,
                    w: b,
                    h: p
                };
                var C = l > b, M = of.barLength + 2 * of.barPad, g = of.barWidth + 2 * of.barPad, P = s, T = u + c;
                T + g > o && (T = o - g);
                var F = this.container.selectAll("rect.scrollbar-horizontal").data(C ? [
                    0
                ] : []);
                F.exit().on(".drag", null).remove(), F.enter().append("rect").classed("scrollbar-horizontal", !0).call(C0e.fill, of.barColor), C ? (this.hbar = F.attr({
                    rx: of.barRadius,
                    ry: of.barRadius,
                    x: P,
                    y: T,
                    width: M,
                    height: g
                }), this._hbarXMin = P + M / 2, this._hbarTranslateMax = b - M) : (delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax);
                var q = c > p, V = of.barWidth + 2 * of.barPad, H = of.barLength + 2 * of.barPad, X = s + l, G = u;
                X + V > a && (X = a - V);
                var N = this.container.selectAll("rect.scrollbar-vertical").data(q ? [
                    0
                ] : []);
                N.exit().on(".drag", null).remove(), N.enter().append("rect").classed("scrollbar-vertical", !0).call(C0e.fill, of.barColor), q ? (this.vbar = N.attr({
                    rx: of.barRadius,
                    ry: of.barRadius,
                    x: X,
                    y: G,
                    width: V,
                    height: H
                }), this._vbarYMin = G + H / 2, this._vbarTranslateMax = p - H) : (delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
                var W = this.id, re = E - .5, ae = q ? k + V + .5 : k + .5, _e = A - .5, Me = C ? L + g + .5 : L + .5, ke = i._topdefs.selectAll("#" + W).data(C || q ? [
                    0
                ] : []);
                if (ke.exit().remove(), ke.enter().append("clipPath").attr("id", W).append("rect"), C || q ? (this._clipRect = ke.select("rect").attr({
                    x: Math.floor(re),
                    y: Math.floor(_e),
                    width: Math.ceil(ae) - Math.floor(re),
                    height: Math.ceil(Me) - Math.floor(_e)
                }), this.container.call(pT.setClipUrl, W, this.gd), this.bg.attr({
                    x: s,
                    y: u,
                    width: l,
                    height: c
                })) : (this.bg.attr({
                    width: 0,
                    height: 0
                }), this.container.on("wheel", null).on(".drag", null).call(pT.setClipUrl, null), delete this._clipRect), C || q) {
                    var ge = qg.behavior.drag().on("dragstart", function() {
                        qg.event.sourceEvent.preventDefault();
                    }).on("drag", this._onBoxDrag.bind(this));
                    this.container.on("wheel", null).on("wheel", this._onBoxWheel.bind(this)).on(".drag", null).call(ge);
                    var ie = qg.behavior.drag().on("dragstart", function() {
                        qg.event.sourceEvent.preventDefault(), qg.event.sourceEvent.stopPropagation();
                    }).on("drag", this._onBarDrag.bind(this));
                    C && this.hbar.on(".drag", null).call(ie), q && this.vbar.on(".drag", null).call(ie);
                }
                this.setTranslate(r, n);
            };
            of.prototype.disable = function() {
                (this.hbar || this.vbar) && (this.bg.attr({
                    width: 0,
                    height: 0
                }), this.container.on("wheel", null).on(".drag", null).call(pT.setClipUrl, null), delete this._clipRect), this.hbar && (this.hbar.on(".drag", null), this.hbar.remove(), delete this.hbar, delete this._hbarXMin, delete this._hbarTranslateMax), this.vbar && (this.vbar.on(".drag", null), this.vbar.remove(), delete this.vbar, delete this._vbarYMin, delete this._vbarTranslateMax);
            };
            of.prototype._onBoxDrag = function() {
                var t = this.translateX, r = this.translateY;
                this.hbar && (t -= qg.event.dx), this.vbar && (r -= qg.event.dy), this.setTranslate(t, r);
            };
            of.prototype._onBoxWheel = function() {
                var t = this.translateX, r = this.translateY;
                this.hbar && (t += qg.event.deltaY), this.vbar && (r += qg.event.deltaY), this.setTranslate(t, r);
            };
            of.prototype._onBarDrag = function() {
                var t = this.translateX, r = this.translateY;
                if (this.hbar) {
                    var n = t + this._hbarXMin, i = n + this._hbarTranslateMax, a = pI.constrain(qg.event.x, n, i), o = (a - n) / (i - n), s = this.position.w - this._box.w;
                    t = o * s;
                }
                if (this.vbar) {
                    var l = r + this._vbarYMin, u = l + this._vbarTranslateMax, c = pI.constrain(qg.event.y, l, u), f = (c - l) / (u - l), h = this.position.h - this._box.h;
                    r = f * h;
                }
                this.setTranslate(t, r);
            };
            of.prototype.setTranslate = function(t, r) {
                var n = this.position.w - this._box.w, i = this.position.h - this._box.h;
                if (t = pI.constrain(t || 0, 0, n), r = pI.constrain(r || 0, 0, i), this.translateX = t, this.translateY = r, this.container.call(pT.setTranslate, this._box.l - this.position.l - t, this._box.t - this.position.t - r), this._clipRect && this._clipRect.attr({
                    x: Math.floor(this.position.l + t - .5),
                    y: Math.floor(this.position.t + r - .5)
                }), this.hbar) {
                    var a = t / n;
                    this.hbar.call(pT.setTranslate, t + a * this._hbarTranslateMax, r);
                }
                if (this.vbar) {
                    var o = r / i;
                    this.vbar.call(pT.setTranslate, t, r + o * this._vbarTranslateMax);
                }
            };
        });
        var U0e = ye((Iar, N0e)=>{
            "use strict";
            var gT = xa(), t4 = Xu(), r4 = va(), mT = ao(), e0 = Mr(), gI = Pl(), l0t = Vs().arrayEditor, R0e = Nh().LINE_SPACING, Go = dI(), u0t = P0e();
            N0e.exports = function(t) {
                var r = t._fullLayout, n = e0.filterVisible(r[Go.name]);
                function i(h) {
                    t4.autoMargin(t, O0e(h));
                }
                var a = r._menulayer.selectAll("g." + Go.containerClassName).data(n.length > 0 ? [
                    0
                ] : []);
                if (a.enter().append("g").classed(Go.containerClassName, !0).style("cursor", "pointer"), a.exit().each(function() {
                    gT.select(this).selectAll("g." + Go.headerGroupClassName).each(i);
                }).remove(), n.length !== 0) {
                    var o = a.selectAll("g." + Go.headerGroupClassName).data(n, c0t);
                    o.enter().append("g").classed(Go.headerGroupClassName, !0);
                    for(var s = e0.ensureSingle(a, "g", Go.dropdownButtonGroupClassName, function(h) {
                        h.style("pointer-events", "all");
                    }), l = 0; l < n.length; l++){
                        var u = n[l];
                        g0t(t, u);
                    }
                    var c = "updatemenus" + r._uid, f = new u0t(t, s, c);
                    o.enter().size() && (s.node().parentNode.appendChild(s.node()), s.call(UU)), o.exit().each(function(h) {
                        s.call(UU), i(h);
                    }).remove(), o.each(function(h) {
                        var d = gT.select(this), v = h.type === "dropdown" ? s : null;
                        t4.manageCommandObserver(t, h, h.buttons, function(x) {
                            NU(t, h, h.buttons[x.index], d, v, f, x.index, !0);
                        }), h.type === "dropdown" ? (z0e(t, d, s, f, h), D0e(s, h) && i4(t, d, s, f, h)) : i4(t, d, null, null, h);
                    });
                }
            };
            function c0t(e) {
                return e._index;
            }
            function f0t(e) {
                return +e.attr(Go.menuIndexAttrName) == -1;
            }
            function D0e(e, t) {
                return +e.attr(Go.menuIndexAttrName) === t._index;
            }
            function NU(e, t, r, n, i, a, o, s) {
                t.active = o, l0t(e.layout, Go.name, t).applyUpdate("active", o), t.type === "buttons" ? i4(e, n, null, null, t) : t.type === "dropdown" && (i.attr(Go.menuIndexAttrName, "-1"), z0e(e, n, i, a, t), s || i4(e, n, i, a, t));
            }
            function z0e(e, t, r, n, i) {
                var a = e0.ensureSingle(t, "g", Go.headerClassName, function(h) {
                    h.style("pointer-events", "all");
                }), o = i._dims, s = i.active, l = i.buttons[s] || Go.blankHeaderOpts, u = {
                    y: i.pad.t,
                    yPad: 0,
                    x: i.pad.l,
                    xPad: 0,
                    index: 0
                }, c = {
                    width: o.headerWidth,
                    height: o.headerHeight
                };
                a.call(VU, i, l, e).call(B0e, i, u, c);
                var f = e0.ensureSingle(t, "text", Go.headerArrowClassName, function(h) {
                    h.attr("text-anchor", "end").call(mT.font, i.font).text(Go.arrowSymbol[i.direction]);
                });
                f.attr({
                    x: o.headerWidth - Go.arrowOffsetX + i.pad.l,
                    y: o.headerHeight / 2 + Go.textOffsetY + i.pad.t
                }), a.on("click", function() {
                    r.call(UU, String(D0e(r, i) ? -1 : i._index)), i4(e, t, r, n, i);
                }), a.on("mouseover", function() {
                    a.call(F0e);
                }), a.on("mouseout", function() {
                    a.call(q0e, i);
                }), mT.setTranslate(t, o.lx, o.ly);
            }
            function i4(e, t, r, n, i) {
                r || (r = t, r.attr("pointer-events", "all"));
                var a = !f0t(r) || i.type === "buttons" ? i.buttons : [], o = i.type === "dropdown" ? Go.dropdownButtonClassName : Go.buttonClassName, s = r.selectAll("g." + o).data(e0.filterVisible(a)), l = s.enter().append("g").classed(o, !0), u = s.exit();
                i.type === "dropdown" ? (l.attr("opacity", "0").transition().attr("opacity", "1"), u.transition().attr("opacity", "0").remove()) : u.remove();
                var c = 0, f = 0, h = i._dims, d = [
                    "up",
                    "down"
                ].indexOf(i.direction) !== -1;
                i.type === "dropdown" && (d ? f = h.headerHeight + Go.gapButtonHeader : c = h.headerWidth + Go.gapButtonHeader), i.type === "dropdown" && i.direction === "up" && (f = -Go.gapButtonHeader + Go.gapButton - h.openHeight), i.type === "dropdown" && i.direction === "left" && (c = -Go.gapButtonHeader + Go.gapButton - h.openWidth);
                var v = {
                    x: h.lx + c + i.pad.l,
                    y: h.ly + f + i.pad.t,
                    yPad: Go.gapButton,
                    xPad: Go.gapButton,
                    index: 0
                }, x = {
                    l: v.x + i.borderwidth,
                    t: v.y + i.borderwidth
                };
                s.each(function(b, p) {
                    var E = gT.select(this);
                    E.call(VU, i, b, e).call(B0e, i, v), E.on("click", function() {
                        gT.event.defaultPrevented || (b.execute && (b.args2 && i.active === p ? (NU(e, i, b, t, r, n, -1), t4.executeAPICommand(e, b.method, b.args2)) : (NU(e, i, b, t, r, n, p), t4.executeAPICommand(e, b.method, b.args))), e.emit("plotly_buttonclicked", {
                            menu: i,
                            button: b,
                            active: i.active
                        }));
                    }), E.on("mouseover", function() {
                        E.call(F0e);
                    }), E.on("mouseout", function() {
                        E.call(q0e, i), s.call(I0e, i);
                    });
                }), s.call(I0e, i), d ? (x.w = Math.max(h.openWidth, h.headerWidth), x.h = v.y - x.t) : (x.w = v.x - x.l, x.h = Math.max(h.openHeight, h.headerHeight)), x.direction = i.direction, n && (s.size() ? h0t(e, t, r, n, i, x) : d0t(n));
            }
            function h0t(e, t, r, n, i, a) {
                var o = i.direction, s = o === "up" || o === "down", l = i._dims, u = i.active, c, f, h;
                if (s) for(f = 0, h = 0; h < u; h++)f += l.heights[h] + Go.gapButton;
                else for(c = 0, h = 0; h < u; h++)c += l.widths[h] + Go.gapButton;
                n.enable(a, c, f), n.hbar && n.hbar.attr("opacity", "0").transition().attr("opacity", "1"), n.vbar && n.vbar.attr("opacity", "0").transition().attr("opacity", "1");
            }
            function d0t(e) {
                var t = !!e.hbar, r = !!e.vbar;
                t && e.hbar.transition().attr("opacity", "0").each("end", function() {
                    t = !1, r || e.disable();
                }), r && e.vbar.transition().attr("opacity", "0").each("end", function() {
                    r = !1, t || e.disable();
                });
            }
            function VU(e, t, r, n) {
                e.call(v0t, t).call(p0t, t, r, n);
            }
            function v0t(e, t) {
                var r = e0.ensureSingle(e, "rect", Go.itemRectClassName, function(n) {
                    n.attr({
                        rx: Go.rx,
                        ry: Go.ry,
                        "shape-rendering": "crispEdges"
                    });
                });
                r.call(r4.stroke, t.bordercolor).call(r4.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px");
            }
            function p0t(e, t, r, n) {
                var i = e0.ensureSingle(e, "text", Go.itemTextClassName, function(s) {
                    s.attr({
                        "text-anchor": "start",
                        "data-notex": 1
                    });
                }), a = r.label, o = n._fullLayout._meta;
                o && (a = e0.templateString(a, o)), i.call(mT.font, t.font).text(a).call(gI.convertToTspans, n);
            }
            function I0e(e, t) {
                var r = t.active;
                e.each(function(n, i) {
                    var a = gT.select(this);
                    i === r && t.showactive && a.select("rect." + Go.itemRectClassName).call(r4.fill, Go.activeColor);
                });
            }
            function F0e(e) {
                e.select("rect." + Go.itemRectClassName).call(r4.fill, Go.hoverColor);
            }
            function q0e(e, t) {
                e.select("rect." + Go.itemRectClassName).call(r4.fill, t.bgcolor);
            }
            function g0t(e, t) {
                var r = t._dims = {
                    width1: 0,
                    height1: 0,
                    heights: [],
                    widths: [],
                    totalWidth: 0,
                    totalHeight: 0,
                    openWidth: 0,
                    openHeight: 0,
                    lx: 0,
                    ly: 0
                }, n = mT.tester.selectAll("g." + Go.dropdownButtonClassName).data(e0.filterVisible(t.buttons));
                n.enter().append("g").classed(Go.dropdownButtonClassName, !0);
                var i = [
                    "up",
                    "down"
                ].indexOf(t.direction) !== -1;
                n.each(function(c, f) {
                    var h = gT.select(this);
                    h.call(VU, t, c, e);
                    var d = h.select("." + Go.itemTextClassName), v = d.node() && mT.bBox(d.node()).width, x = Math.max(v + Go.textPadX, Go.minWidth), b = t.font.size * R0e, p = gI.lineCount(d), E = Math.max(b * p, Go.minHeight) + Go.textOffsetY;
                    E = Math.ceil(E), x = Math.ceil(x), r.widths[f] = x, r.heights[f] = E, r.height1 = Math.max(r.height1, E), r.width1 = Math.max(r.width1, x), i ? (r.totalWidth = Math.max(r.totalWidth, x), r.openWidth = r.totalWidth, r.totalHeight += E + Go.gapButton, r.openHeight += E + Go.gapButton) : (r.totalWidth += x + Go.gapButton, r.openWidth += x + Go.gapButton, r.totalHeight = Math.max(r.totalHeight, E), r.openHeight = r.totalHeight);
                }), i ? r.totalHeight -= Go.gapButton : r.totalWidth -= Go.gapButton, r.headerWidth = r.width1 + Go.arrowPadX, r.headerHeight = r.height1, t.type === "dropdown" && (i ? (r.width1 += Go.arrowPadX, r.totalHeight = r.height1) : r.totalWidth = r.width1, r.totalWidth += Go.arrowPadX), n.remove();
                var a = r.totalWidth + t.pad.l + t.pad.r, o = r.totalHeight + t.pad.t + t.pad.b, s = e._fullLayout._size;
                r.lx = s.l + s.w * t.x, r.ly = s.t + s.h * (1 - t.y);
                var l = "left";
                e0.isRightAnchor(t) && (r.lx -= a, l = "right"), e0.isCenterAnchor(t) && (r.lx -= a / 2, l = "center");
                var u = "top";
                e0.isBottomAnchor(t) && (r.ly -= o, u = "bottom"), e0.isMiddleAnchor(t) && (r.ly -= o / 2, u = "middle"), r.totalWidth = Math.ceil(r.totalWidth), r.totalHeight = Math.ceil(r.totalHeight), r.lx = Math.round(r.lx), r.ly = Math.round(r.ly), t4.autoMargin(e, O0e(t), {
                    x: t.x,
                    y: t.y,
                    l: a * (({
                        right: 1,
                        center: .5
                    })[l] || 0),
                    r: a * (({
                        left: 1,
                        center: .5
                    })[l] || 0),
                    b: o * (({
                        top: 1,
                        middle: .5
                    })[u] || 0),
                    t: o * (({
                        bottom: 1,
                        middle: .5
                    })[u] || 0)
                });
            }
            function O0e(e) {
                return Go.autoMarginIdRoot + e._index;
            }
            function B0e(e, t, r, n) {
                n = n || {};
                var i = e.select("." + Go.itemRectClassName), a = e.select("." + Go.itemTextClassName), o = t.borderwidth, s = r.index, l = t._dims;
                mT.setTranslate(e, o + r.x, o + r.y);
                var u = [
                    "up",
                    "down"
                ].indexOf(t.direction) !== -1, c = n.height || (u ? l.heights[s] : l.height1);
                i.attr({
                    x: 0,
                    y: 0,
                    width: n.width || (u ? l.width1 : l.widths[s]),
                    height: c
                });
                var f = t.font.size * R0e, h = gI.lineCount(a), d = (h - 1) * f / 2;
                gI.positionText(a, Go.textOffsetX, c / 2 - d + Go.textOffsetY), u ? r.y += l.heights[s] + r.yPad : r.x += l.widths[s] + r.xPad, r.index++;
            }
            function UU(e, t) {
                e.attr(Go.menuIndexAttrName, t || "-1").selectAll("g." + Go.dropdownButtonClassName).remove();
            }
        });
        var H0e = ye((Rar, V0e)=>{
            "use strict";
            var m0t = dI();
            V0e.exports = {
                moduleType: "component",
                name: m0t.name,
                layoutAttributes: BU(),
                supplyLayoutDefaults: k0e(),
                draw: U0e()
            };
        });
        var n4 = ye((Dar, G0e)=>{
            "use strict";
            G0e.exports = {
                name: "sliders",
                containerClassName: "slider-container",
                groupClassName: "slider-group",
                inputAreaClass: "slider-input-area",
                railRectClass: "slider-rail-rect",
                railTouchRectClass: "slider-rail-touch-rect",
                gripRectClass: "slider-grip-rect",
                tickRectClass: "slider-tick-rect",
                inputProxyClass: "slider-input-proxy",
                labelsClass: "slider-labels",
                labelGroupClass: "slider-label-group",
                labelClass: "slider-label",
                currentValueClass: "slider-current-value",
                railHeight: 5,
                menuIndexAttrName: "slider-active-index",
                autoMarginIdRoot: "slider-",
                minWidth: 30,
                minHeight: 30,
                textPadX: 40,
                arrowOffsetX: 4,
                railRadius: 2,
                railWidth: 5,
                railBorder: 4,
                railBorderWidth: 1,
                railBorderColor: "#bec8d9",
                railBgColor: "#f8fafc",
                railInset: 8,
                stepInset: 10,
                gripRadius: 10,
                gripWidth: 20,
                gripHeight: 20,
                gripBorder: 20,
                gripBorderWidth: 1,
                gripBorderColor: "#bec8d9",
                gripBgColor: "#f6f8fa",
                gripBgActiveColor: "#dbdde0",
                labelPadding: 8,
                labelOffset: 0,
                tickWidth: 1,
                tickColor: "#333",
                tickOffset: 25,
                tickLength: 7,
                minorTickOffset: 25,
                minorTickColor: "#333",
                minorTickLength: 4,
                currentValuePadding: 8,
                currentValueInset: 0
            };
        });
        var HU = ye((zar, Z0e)=>{
            "use strict";
            var j0e = Su(), y0t = w6(), _0t = no().extendDeepAll, x0t = Bu().overrideAll, b0t = zS(), W0e = Vs().templatedArray, Jb = n4(), w0t = W0e("step", {
                visible: {
                    valType: "boolean",
                    dflt: !0
                },
                method: {
                    valType: "enumerated",
                    values: [
                        "restyle",
                        "relayout",
                        "animate",
                        "update",
                        "skip"
                    ],
                    dflt: "restyle"
                },
                args: {
                    valType: "info_array",
                    freeLength: !0,
                    items: [
                        {
                            valType: "any"
                        },
                        {
                            valType: "any"
                        },
                        {
                            valType: "any"
                        }
                    ]
                },
                label: {
                    valType: "string"
                },
                value: {
                    valType: "string"
                },
                execute: {
                    valType: "boolean",
                    dflt: !0
                }
            });
            Z0e.exports = x0t(W0e("slider", {
                visible: {
                    valType: "boolean",
                    dflt: !0
                },
                active: {
                    valType: "number",
                    min: 0,
                    dflt: 0
                },
                steps: w0t,
                lenmode: {
                    valType: "enumerated",
                    values: [
                        "fraction",
                        "pixels"
                    ],
                    dflt: "fraction"
                },
                len: {
                    valType: "number",
                    min: 0,
                    dflt: 1
                },
                x: {
                    valType: "number",
                    min: -2,
                    max: 3,
                    dflt: 0
                },
                pad: _0t(y0t({
                    editType: "arraydraw"
                }), {}, {
                    t: {
                        dflt: 20
                    }
                }),
                xanchor: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "left",
                        "center",
                        "right"
                    ],
                    dflt: "left"
                },
                y: {
                    valType: "number",
                    min: -2,
                    max: 3,
                    dflt: 0
                },
                yanchor: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "top",
                        "middle",
                        "bottom"
                    ],
                    dflt: "top"
                },
                transition: {
                    duration: {
                        valType: "number",
                        min: 0,
                        dflt: 150
                    },
                    easing: {
                        valType: "enumerated",
                        values: b0t.transition.easing.values,
                        dflt: "cubic-in-out"
                    }
                },
                currentvalue: {
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    xanchor: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ],
                        dflt: "left"
                    },
                    offset: {
                        valType: "number",
                        dflt: 10
                    },
                    prefix: {
                        valType: "string"
                    },
                    suffix: {
                        valType: "string"
                    },
                    font: j0e({})
                },
                font: j0e({}),
                activebgcolor: {
                    valType: "color",
                    dflt: Jb.gripBgActiveColor
                },
                bgcolor: {
                    valType: "color",
                    dflt: Jb.railBgColor
                },
                bordercolor: {
                    valType: "color",
                    dflt: Jb.railBorderColor
                },
                borderwidth: {
                    valType: "number",
                    min: 0,
                    dflt: Jb.railBorderWidth
                },
                ticklen: {
                    valType: "number",
                    min: 0,
                    dflt: Jb.tickLength
                },
                tickcolor: {
                    valType: "color",
                    dflt: Jb.tickColor
                },
                tickwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1
                },
                minorticklen: {
                    valType: "number",
                    min: 0,
                    dflt: Jb.minorTickLength
                }
            }), "arraydraw", "from-root");
        });
        var J0e = ye((Far, K0e)=>{
            "use strict";
            var yT = Mr(), X0e = Zd(), Y0e = HU(), T0t = n4(), A0t = T0t.name, S0t = Y0e.steps;
            K0e.exports = function(t, r) {
                X0e(t, r, {
                    name: A0t,
                    handleItemDefaults: M0t
                });
            };
            function M0t(e, t, r) {
                function n(f, h) {
                    return yT.coerce(e, t, Y0e, f, h);
                }
                for(var i = X0e(e, t, {
                    name: "steps",
                    handleItemDefaults: E0t
                }), a = 0, o = 0; o < i.length; o++)i[o].visible && a++;
                var s;
                if (a < 2 ? s = t.visible = !1 : s = n("visible"), !!s) {
                    t._stepCount = a;
                    var l = t._visibleSteps = yT.filterVisible(i), u = n("active");
                    (i[u] || {}).visible || (t.active = l[0]._index), n("x"), n("y"), yT.noneOrAll(e, t, [
                        "x",
                        "y"
                    ]), n("xanchor"), n("yanchor"), n("len"), n("lenmode"), n("pad.t"), n("pad.r"), n("pad.b"), n("pad.l"), yT.coerceFont(n, "font", r.font);
                    var c = n("currentvalue.visible");
                    c && (n("currentvalue.xanchor"), n("currentvalue.prefix"), n("currentvalue.suffix"), n("currentvalue.offset"), yT.coerceFont(n, "currentvalue.font", t.font)), n("transition.duration"), n("transition.easing"), n("bgcolor"), n("activebgcolor"), n("bordercolor"), n("borderwidth"), n("ticklen"), n("tickwidth"), n("tickcolor"), n("minorticklen");
                }
            }
            function E0t(e, t) {
                function r(a, o) {
                    return yT.coerce(e, t, S0t, a, o);
                }
                var n;
                if (e.method !== "skip" && !Array.isArray(e.args) ? n = t.visible = !1 : n = r("visible"), n) {
                    r("method"), r("args");
                    var i = r("label", "step-" + t._index);
                    r("value", i), r("execute");
                }
            }
        });
        var sge = ye((qar, oge)=>{
            "use strict";
            var Og = xa(), mI = Xu(), x_ = va(), Bg = ao(), t0 = Mr(), k0t = t0.strTranslate, a4 = Pl(), C0t = Vs().arrayEditor, gs = n4(), WU = Nh(), ege = WU.LINE_SPACING, GU = WU.FROM_TL, jU = WU.FROM_BR;
            oge.exports = function(t) {
                var r = t._context.staticPlot, n = t._fullLayout, i = L0t(n, t), a = n._infolayer.selectAll("g." + gs.containerClassName).data(i.length > 0 ? [
                    0
                ] : []);
                a.enter().append("g").classed(gs.containerClassName, !0).style("cursor", r ? null : "ew-resize");
                function o(c) {
                    c._commandObserver && (c._commandObserver.remove(), delete c._commandObserver), mI.autoMargin(t, tge(c));
                }
                if (a.exit().each(function() {
                    Og.select(this).selectAll("g." + gs.groupClassName).each(o);
                }).remove(), i.length !== 0) {
                    var s = a.selectAll("g." + gs.groupClassName).data(i, P0t);
                    s.enter().append("g").classed(gs.groupClassName, !0), s.exit().each(o).remove();
                    for(var l = 0; l < i.length; l++){
                        var u = i[l];
                        I0t(t, u);
                    }
                    s.each(function(c) {
                        var f = Og.select(this);
                        q0t(c), mI.manageCommandObserver(t, c, c._visibleSteps, function(h) {
                            var d = f.data()[0];
                            d.active !== h.index && (d._dragging || ige(t, f, d, h.index, !1, !0));
                        }), R0t(t, Og.select(this), c);
                    });
                }
            };
            function tge(e) {
                return gs.autoMarginIdRoot + e._index;
            }
            function L0t(e, t) {
                for(var r = e[gs.name], n = [], i = 0; i < r.length; i++){
                    var a = r[i];
                    a.visible && (a._gd = t, n.push(a));
                }
                return n;
            }
            function P0t(e) {
                return e._index;
            }
            function I0t(e, t) {
                var r = Bg.tester.selectAll("g." + gs.labelGroupClass).data(t._visibleSteps);
                r.enter().append("g").classed(gs.labelGroupClass, !0);
                var n = 0, i = 0;
                r.each(function(v) {
                    var x = Og.select(this), b = rge(x, {
                        step: v
                    }, t), p = b.node();
                    if (p) {
                        var E = Bg.bBox(p);
                        i = Math.max(i, E.height), n = Math.max(n, E.width);
                    }
                }), r.remove();
                var a = t._dims = {};
                a.inputAreaWidth = Math.max(gs.railWidth, gs.gripHeight);
                var o = e._fullLayout._size;
                a.lx = o.l + o.w * t.x, a.ly = o.t + o.h * (1 - t.y), t.lenmode === "fraction" ? a.outerLength = Math.round(o.w * t.len) : a.outerLength = t.len, a.inputAreaStart = 0, a.inputAreaLength = Math.round(a.outerLength - t.pad.l - t.pad.r);
                var s = a.inputAreaLength - 2 * gs.stepInset, l = s / (t._stepCount - 1), u = n + gs.labelPadding;
                if (a.labelStride = Math.max(1, Math.ceil(u / l)), a.labelHeight = i, a.currentValueMaxWidth = 0, a.currentValueHeight = 0, a.currentValueTotalHeight = 0, a.currentValueMaxLines = 1, t.currentvalue.visible) {
                    var c = Bg.tester.append("g");
                    r.each(function(v) {
                        var x = yI(c, t, v.label), b = x.node() && Bg.bBox(x.node()) || {
                            width: 0,
                            height: 0
                        }, p = a4.lineCount(x);
                        a.currentValueMaxWidth = Math.max(a.currentValueMaxWidth, Math.ceil(b.width)), a.currentValueHeight = Math.max(a.currentValueHeight, Math.ceil(b.height)), a.currentValueMaxLines = Math.max(a.currentValueMaxLines, p);
                    }), a.currentValueTotalHeight = a.currentValueHeight + t.currentvalue.offset, c.remove();
                }
                a.height = a.currentValueTotalHeight + gs.tickOffset + t.ticklen + gs.labelOffset + a.labelHeight + t.pad.t + t.pad.b;
                var f = "left";
                t0.isRightAnchor(t) && (a.lx -= a.outerLength, f = "right"), t0.isCenterAnchor(t) && (a.lx -= a.outerLength / 2, f = "center");
                var h = "top";
                t0.isBottomAnchor(t) && (a.ly -= a.height, h = "bottom"), t0.isMiddleAnchor(t) && (a.ly -= a.height / 2, h = "middle"), a.outerLength = Math.ceil(a.outerLength), a.height = Math.ceil(a.height), a.lx = Math.round(a.lx), a.ly = Math.round(a.ly);
                var d = {
                    y: t.y,
                    b: a.height * jU[h],
                    t: a.height * GU[h]
                };
                t.lenmode === "fraction" ? (d.l = 0, d.xl = t.x - t.len * GU[f], d.r = 0, d.xr = t.x + t.len * jU[f]) : (d.x = t.x, d.l = a.outerLength * GU[f], d.r = a.outerLength * jU[f]), mI.autoMargin(e, tge(t), d);
            }
            function R0t(e, t, r) {
                (r.steps[r.active] || {}).visible || (r.active = r._visibleSteps[0]._index), t.call(yI, r).call(B0t, r).call(z0t, r).call(F0t, r).call(O0t, e, r).call(D0t, e, r);
                var n = r._dims;
                Bg.setTranslate(t, n.lx + r.pad.l, n.ly + r.pad.t), t.call(age, r, !1), t.call(yI, r);
            }
            function yI(e, t, r) {
                if (t.currentvalue.visible) {
                    var n = t._dims, i, a;
                    switch(t.currentvalue.xanchor){
                        case "right":
                            i = n.inputAreaLength - gs.currentValueInset - n.currentValueMaxWidth, a = "left";
                            break;
                        case "center":
                            i = n.inputAreaLength * .5, a = "middle";
                            break;
                        default:
                            i = gs.currentValueInset, a = "left";
                    }
                    var o = t0.ensureSingle(e, "text", gs.labelClass, function(h) {
                        h.attr({
                            "text-anchor": a,
                            "data-notex": 1
                        });
                    }), s = t.currentvalue.prefix ? t.currentvalue.prefix : "";
                    if (typeof r == "string") s += r;
                    else {
                        var l = t.steps[t.active].label, u = t._gd._fullLayout._meta;
                        u && (l = t0.templateString(l, u)), s += l;
                    }
                    t.currentvalue.suffix && (s += t.currentvalue.suffix), o.call(Bg.font, t.currentvalue.font).text(s).call(a4.convertToTspans, t._gd);
                    var c = a4.lineCount(o), f = (n.currentValueMaxLines + 1 - c) * t.currentvalue.font.size * ege;
                    return a4.positionText(o, i, f), o;
                }
            }
            function D0t(e, t, r) {
                var n = t0.ensureSingle(e, "rect", gs.gripRectClass, function(i) {
                    i.call(nge, t, e, r).style("pointer-events", "all");
                });
                n.attr({
                    width: gs.gripWidth,
                    height: gs.gripHeight,
                    rx: gs.gripRadius,
                    ry: gs.gripRadius
                }).call(x_.stroke, r.bordercolor).call(x_.fill, r.bgcolor).style("stroke-width", r.borderwidth + "px");
            }
            function rge(e, t, r) {
                var n = t0.ensureSingle(e, "text", gs.labelClass, function(o) {
                    o.attr({
                        "text-anchor": "middle",
                        "data-notex": 1
                    });
                }), i = t.step.label, a = r._gd._fullLayout._meta;
                return a && (i = t0.templateString(i, a)), n.call(Bg.font, r.font).text(i).call(a4.convertToTspans, r._gd), n;
            }
            function z0t(e, t) {
                var r = t0.ensureSingle(e, "g", gs.labelsClass), n = t._dims, i = r.selectAll("g." + gs.labelGroupClass).data(n.labelSteps);
                i.enter().append("g").classed(gs.labelGroupClass, !0), i.exit().remove(), i.each(function(a) {
                    var o = Og.select(this);
                    o.call(rge, a, t), Bg.setTranslate(o, ZU(t, a.fraction), gs.tickOffset + t.ticklen + t.font.size * ege + gs.labelOffset + n.currentValueTotalHeight);
                });
            }
            function $0e(e, t, r, n, i) {
                var a = Math.round(n * (r._stepCount - 1)), o = r._visibleSteps[a]._index;
                o !== r.active && ige(e, t, r, o, !0, i);
            }
            function ige(e, t, r, n, i, a) {
                var o = r.active;
                r.active = n, C0t(e.layout, gs.name, r).applyUpdate("active", n);
                var s = r.steps[r.active];
                t.call(age, r, a), t.call(yI, r), e.emit("plotly_sliderchange", {
                    slider: r,
                    step: r.steps[r.active],
                    interaction: i,
                    previousActive: o
                }), s && s.method && i && (t._nextMethod ? (t._nextMethod.step = s, t._nextMethod.doCallback = i, t._nextMethod.doTransition = a) : (t._nextMethod = {
                    step: s,
                    doCallback: i,
                    doTransition: a
                }, t._nextMethodRaf = window.requestAnimationFrame(function() {
                    var l = t._nextMethod.step;
                    l.method && (l.execute && mI.executeAPICommand(e, l.method, l.args), t._nextMethod = null, t._nextMethodRaf = null);
                })));
            }
            function nge(e, t, r) {
                if (t._context.staticPlot) return;
                var n = r.node(), i = Og.select(t);
                function a() {
                    return r.data()[0];
                }
                function o() {
                    var s = a();
                    t.emit("plotly_sliderstart", {
                        slider: s
                    });
                    var l = r.select("." + gs.gripRectClass);
                    Og.event.stopPropagation(), Og.event.preventDefault(), l.call(x_.fill, s.activebgcolor);
                    var u = Q0e(s, Og.mouse(n)[0]);
                    $0e(t, r, s, u, !0), s._dragging = !0;
                    function c() {
                        var h = a(), d = Q0e(h, Og.mouse(n)[0]);
                        $0e(t, r, h, d, !1);
                    }
                    i.on("mousemove", c), i.on("touchmove", c);
                    function f() {
                        var h = a();
                        h._dragging = !1, l.call(x_.fill, h.bgcolor), i.on("mouseup", null), i.on("mousemove", null), i.on("touchend", null), i.on("touchmove", null), t.emit("plotly_sliderend", {
                            slider: h,
                            step: h.steps[h.active]
                        });
                    }
                    i.on("mouseup", f), i.on("touchend", f);
                }
                e.on("mousedown", o), e.on("touchstart", o);
            }
            function F0t(e, t) {
                var r = e.selectAll("rect." + gs.tickRectClass).data(t._visibleSteps), n = t._dims;
                r.enter().append("rect").classed(gs.tickRectClass, !0), r.exit().remove(), r.attr({
                    width: t.tickwidth + "px",
                    "shape-rendering": "crispEdges"
                }), r.each(function(i, a) {
                    var o = a % n.labelStride === 0, s = Og.select(this);
                    s.attr({
                        height: o ? t.ticklen : t.minorticklen
                    }).call(x_.fill, t.tickcolor), Bg.setTranslate(s, ZU(t, a / (t._stepCount - 1)) - .5 * t.tickwidth, (o ? gs.tickOffset : gs.minorTickOffset) + n.currentValueTotalHeight);
                });
            }
            function q0t(e) {
                var t = e._dims;
                t.labelSteps = [];
                for(var r = e._stepCount, n = 0; n < r; n += t.labelStride)t.labelSteps.push({
                    fraction: n / (r - 1),
                    step: e._visibleSteps[n]
                });
            }
            function age(e, t, r) {
                for(var n = e.select("rect." + gs.gripRectClass), i = 0, a = 0; a < t._stepCount; a++)if (t._visibleSteps[a]._index === t.active) {
                    i = a;
                    break;
                }
                var o = ZU(t, i / (t._stepCount - 1));
                if (!t._invokingCommand) {
                    var s = n;
                    r && t.transition.duration > 0 && (s = s.transition().duration(t.transition.duration).ease(t.transition.easing)), s.attr("transform", k0t(o - gs.gripWidth * .5, t._dims.currentValueTotalHeight));
                }
            }
            function ZU(e, t) {
                var r = e._dims;
                return r.inputAreaStart + gs.stepInset + (r.inputAreaLength - 2 * gs.stepInset) * Math.min(1, Math.max(0, t));
            }
            function Q0e(e, t) {
                var r = e._dims;
                return Math.min(1, Math.max(0, (t - gs.stepInset - r.inputAreaStart) / (r.inputAreaLength - 2 * gs.stepInset - 2 * r.inputAreaStart)));
            }
            function O0t(e, t, r) {
                var n = r._dims, i = t0.ensureSingle(e, "rect", gs.railTouchRectClass, function(a) {
                    a.call(nge, t, e, r).style("pointer-events", "all");
                });
                i.attr({
                    width: n.inputAreaLength,
                    height: Math.max(n.inputAreaWidth, gs.tickOffset + r.ticklen + n.labelHeight)
                }).call(x_.fill, r.bgcolor).attr("opacity", 0), Bg.setTranslate(i, 0, n.currentValueTotalHeight);
            }
            function B0t(e, t) {
                var r = t._dims, n = r.inputAreaLength - gs.railInset * 2, i = t0.ensureSingle(e, "rect", gs.railRectClass);
                i.attr({
                    width: n,
                    height: gs.railWidth,
                    rx: gs.railRadius,
                    ry: gs.railRadius,
                    "shape-rendering": "crispEdges"
                }).call(x_.stroke, t.bordercolor).call(x_.fill, t.bgcolor).style("stroke-width", t.borderwidth + "px"), Bg.setTranslate(i, gs.railInset, (r.inputAreaWidth - gs.railWidth) * .5 + r.currentValueTotalHeight);
            }
        });
        var uge = ye((Oar, lge)=>{
            "use strict";
            var N0t = n4();
            lge.exports = {
                moduleType: "component",
                name: N0t.name,
                layoutAttributes: HU(),
                supplyLayoutDefaults: J0e(),
                draw: sge()
            };
        });
        var _I = ye((Bar, fge)=>{
            "use strict";
            var cge = dh();
            fge.exports = {
                bgcolor: {
                    valType: "color",
                    dflt: cge.background,
                    editType: "plot"
                },
                bordercolor: {
                    valType: "color",
                    dflt: cge.defaultLine,
                    editType: "plot"
                },
                borderwidth: {
                    valType: "integer",
                    dflt: 0,
                    min: 0,
                    editType: "plot"
                },
                autorange: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc",
                    impliedEdits: {
                        "range[0]": void 0,
                        "range[1]": void 0
                    }
                },
                range: {
                    valType: "info_array",
                    items: [
                        {
                            valType: "any",
                            editType: "calc",
                            impliedEdits: {
                                "^autorange": !1
                            }
                        },
                        {
                            valType: "any",
                            editType: "calc",
                            impliedEdits: {
                                "^autorange": !1
                            }
                        }
                    ],
                    editType: "calc",
                    impliedEdits: {
                        autorange: !1
                    }
                },
                thickness: {
                    valType: "number",
                    dflt: .15,
                    min: 0,
                    max: 1,
                    editType: "plot"
                },
                visible: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc"
                },
                editType: "calc"
            };
        });
        var XU = ye((Nar, hge)=>{
            "use strict";
            hge.exports = {
                _isSubplotObj: !0,
                rangemode: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "fixed",
                        "match"
                    ],
                    dflt: "match",
                    editType: "calc"
                },
                range: {
                    valType: "info_array",
                    items: [
                        {
                            valType: "any",
                            editType: "plot"
                        },
                        {
                            valType: "any",
                            editType: "plot"
                        }
                    ],
                    editType: "plot"
                },
                editType: "calc"
            };
        });
        var xI = ye((Uar, dge)=>{
            "use strict";
            dge.exports = {
                name: "rangeslider",
                containerClassName: "rangeslider-container",
                bgClassName: "rangeslider-bg",
                rangePlotClassName: "rangeslider-rangeplot",
                maskMinClassName: "rangeslider-mask-min",
                maskMaxClassName: "rangeslider-mask-max",
                slideBoxClassName: "rangeslider-slidebox",
                grabberMinClassName: "rangeslider-grabber-min",
                grabAreaMinClassName: "rangeslider-grabarea-min",
                handleMinClassName: "rangeslider-handle-min",
                grabberMaxClassName: "rangeslider-grabber-max",
                grabAreaMaxClassName: "rangeslider-grabarea-max",
                handleMaxClassName: "rangeslider-handle-max",
                maskMinOppAxisClassName: "rangeslider-mask-min-opp-axis",
                maskMaxOppAxisClassName: "rangeslider-mask-max-opp-axis",
                maskColor: "rgba(0,0,0,0.4)",
                maskOppAxisColor: "rgba(0,0,0,0.2)",
                slideBoxFill: "transparent",
                slideBoxCursor: "ew-resize",
                grabAreaFill: "transparent",
                grabAreaCursor: "col-resize",
                grabAreaWidth: 10,
                handleWidth: 4,
                handleRadius: 1,
                handleStrokeWidth: 1,
                extraPad: 15
            };
        });
        var gge = ye((wI)=>{
            "use strict";
            var U0t = af(), V0t = Pl(), vge = xI(), H0t = Nh().LINE_SPACING, bI = vge.name;
            function pge(e) {
                var t = e && e[bI];
                return t && t.visible;
            }
            wI.isVisible = pge;
            wI.makeData = function(e) {
                for(var t = U0t.list({
                    _fullLayout: e
                }, "x", !0), r = e.margin, n = [], i = 0; i < t.length; i++){
                    var a = t[i];
                    if (pge(a)) {
                        n.push(a);
                        var o = a[bI];
                        o._id = bI + a._id, o._height = (e.height - r.b - r.t) * o.thickness, o._offsetShift = Math.floor(o.borderwidth / 2);
                    }
                }
                e._rangeSliderData = n;
            };
            wI.autoMarginOpts = function(e, t) {
                var r = e._fullLayout, n = t[bI], i = t._id.charAt(0), a = 0, o = 0;
                if (t.side === "bottom" && (a = t._depth, t.title.text !== r._dfltTitle[i])) {
                    o = 1.5 * t.title.font.size + 10 + n._offsetShift;
                    var s = (t.title.text.match(V0t.BR_TAG_ALL) || []).length;
                    o += s * t.title.font.size * H0t;
                }
                return {
                    x: 0,
                    y: t._counterDomainMin,
                    l: 0,
                    r: 0,
                    t: 0,
                    b: n._height + a + Math.max(r.margin.b, o),
                    pad: vge.extraPad + n._offsetShift * 2
                };
            };
        });
        var xge = ye((Har, _ge)=>{
            "use strict";
            var TI = Mr(), mge = Vs(), yge = af(), G0t = _I(), j0t = XU();
            _ge.exports = function(t, r, n) {
                var i = t[n], a = r[n];
                if (!(i.rangeslider || r._requestRangeslider[a._id])) return;
                TI.isPlainObject(i.rangeslider) || (i.rangeslider = {});
                var o = i.rangeslider, s = mge.newContainer(a, "rangeslider");
                function l(L, _) {
                    return TI.coerce(o, s, G0t, L, _);
                }
                var u, c;
                function f(L, _) {
                    return TI.coerce(u, c, j0t, L, _);
                }
                var h = l("visible");
                if (h) {
                    l("bgcolor", r.plot_bgcolor), l("bordercolor"), l("borderwidth"), l("thickness"), l("autorange", !a.isValidRange(o.range)), l("range");
                    var d = r._subplots;
                    if (d) for(var v = d.cartesian.filter(function(L) {
                        return L.substr(0, L.indexOf("y")) === yge.name2id(n);
                    }).map(function(L) {
                        return L.substr(L.indexOf("y"), L.length);
                    }), x = TI.simpleMap(v, yge.id2name), b = 0; b < x.length; b++){
                        var p = x[b];
                        u = o[p] || {}, c = mge.newContainer(s, p, "yaxis");
                        var E = r[p], k;
                        u.range && E.isValidRange(u.range) && (k = "fixed");
                        var A = f("rangemode", k);
                        A !== "match" && f("range", E.range.slice());
                    }
                    s._input = o;
                }
            };
        });
        var wge = ye((Gar, bge)=>{
            "use strict";
            var W0t = af().list, Z0t = wg().getAutoRange, X0t = xI();
            bge.exports = function(t) {
                for(var r = W0t(t, "x", !0), n = 0; n < r.length; n++){
                    var i = r[n], a = i[X0t.name];
                    a && a.visible && a.autorange && (a._input.autorange = !0, a._input.range = a.range = Z0t(t, i));
                }
            };
        });
        var Mge = ye((jar, Sge)=>{
            "use strict";
            var AI = xa(), Y0t = ba(), K0t = Xu(), Ff = Mr(), SI = Ff.strTranslate, Age = ao(), b_ = va(), J0t = Mb(), $0t = Jf(), YU = af(), Q0t = gv(), egt = Tg(), Bs = xI();
            Sge.exports = function(e) {
                for(var t = e._fullLayout, r = t._rangeSliderData, n = 0; n < r.length; n++){
                    var i = r[n][Bs.name];
                    i._clipId = i._id + "-" + t._uid;
                }
                function a(s) {
                    return s._name;
                }
                var o = t._infolayer.selectAll("g." + Bs.containerClassName).data(r, a);
                o.exit().each(function(s) {
                    var l = s[Bs.name];
                    t._topdefs.select("#" + l._clipId).remove();
                }).remove(), r.length !== 0 && (o.enter().append("g").classed(Bs.containerClassName, !0).attr("pointer-events", "all"), o.each(function(s) {
                    var l = AI.select(this), u = s[Bs.name], c = t[YU.id2name(s.anchor)], f = u[YU.id2name(s.anchor)];
                    if (u.range) {
                        var h = Ff.simpleMap(u.range, s.r2l), d = Ff.simpleMap(s.range, s.r2l), v;
                        d[0] < d[1] ? v = [
                            Math.min(h[0], d[0]),
                            Math.max(h[1], d[1])
                        ] : v = [
                            Math.max(h[0], d[0]),
                            Math.min(h[1], d[1])
                        ], u.range = u._input.range = Ff.simpleMap(v, s.l2r);
                    }
                    s.cleanRange("rangeslider.range");
                    var x = t._size, b = s.domain;
                    u._width = x.w * (b[1] - b[0]);
                    var p = Math.round(x.l + x.w * b[0]), E = Math.round(x.t + x.h * (1 - s._counterDomainMin) + (s.side === "bottom" ? s._depth : 0) + u._offsetShift + Bs.extraPad);
                    l.attr("transform", SI(p, E)), u._rl = Ff.simpleMap(u.range, s.r2l);
                    var k = u._rl[0], A = u._rl[1], L = A - k;
                    if (u.p2d = function(H) {
                        return H / u._width * L + k;
                    }, u.d2p = function(H) {
                        return (H - k) / L * u._width;
                    }, s.rangebreaks) {
                        var _ = s.locateBreaks(k, A);
                        if (_.length) {
                            var C, M, g = 0;
                            for(C = 0; C < _.length; C++)M = _[C], g += M.max - M.min;
                            var P = u._width / (A - k - g), T = [
                                -P * k
                            ];
                            for(C = 0; C < _.length; C++)M = _[C], T.push(T[T.length - 1] - P * (M.max - M.min));
                            for(u.d2p = function(H) {
                                for(var X = T[0], G = 0; G < _.length; G++){
                                    var N = _[G];
                                    if (H >= N.max) X = T[G + 1];
                                    else if (H < N.min) break;
                                }
                                return X + P * H;
                            }, C = 0; C < _.length; C++)M = _[C], M.pmin = u.d2p(M.min), M.pmax = u.d2p(M.max);
                            u.p2d = function(H) {
                                for(var X = T[0], G = 0; G < _.length; G++){
                                    var N = _[G];
                                    if (H >= N.pmax) X = T[G + 1];
                                    else if (H < N.pmin) break;
                                }
                                return (H - X) / P;
                            };
                        }
                    }
                    if (f.rangemode !== "match") {
                        var F = c.r2l(f.range[0]), q = c.r2l(f.range[1]), V = q - F;
                        u.d2pOppAxis = function(H) {
                            return (H - F) / V * u._height;
                        };
                    }
                    l.call(ngt, e, s, u).call(agt, e, s, u).call(ogt, e, s, u).call(lgt, e, s, u, f).call(ugt, e, s, u).call(cgt, e, s, u), tgt(l, e, s, u), igt(l, e, s, u, c, f), s.side === "bottom" && J0t.draw(e, s._id + "title", {
                        propContainer: s,
                        propName: s._name + ".title",
                        placeholder: t._dfltTitle.x,
                        attributes: {
                            x: s._offset + s._length / 2,
                            y: E + u._height + u._offsetShift + 10 + 1.5 * s.title.font.size,
                            "text-anchor": "middle"
                        }
                    });
                }));
            };
            function Tge(e) {
                return typeof e.clientX == "number" ? e.clientX : e.touches && e.touches.length > 0 ? e.touches[0].clientX : 0;
            }
            function tgt(e, t, r, n) {
                if (t._context.staticPlot) return;
                var i = e.select("rect." + Bs.slideBoxClassName).node(), a = e.select("rect." + Bs.grabAreaMinClassName).node(), o = e.select("rect." + Bs.grabAreaMaxClassName).node();
                function s() {
                    var l = AI.event, u = l.target, c = Tge(l), f = c - e.node().getBoundingClientRect().left, h = n.d2p(r._rl[0]), d = n.d2p(r._rl[1]), v = Q0t.coverSlip();
                    this.addEventListener("touchmove", x), this.addEventListener("touchend", b), v.addEventListener("mousemove", x), v.addEventListener("mouseup", b);
                    function x(p) {
                        var E = Tge(p), k = +E - c, A, L, _;
                        switch(u){
                            case i:
                                if (_ = "ew-resize", h + k > r._length || d + k < 0) return;
                                A = h + k, L = d + k;
                                break;
                            case a:
                                if (_ = "col-resize", h + k > r._length) return;
                                A = h + k, L = d;
                                break;
                            case o:
                                if (_ = "col-resize", d + k < 0) return;
                                A = h, L = d + k;
                                break;
                            default:
                                _ = "ew-resize", A = f, L = f + k;
                                break;
                        }
                        if (L < A) {
                            var C = L;
                            L = A, A = C;
                        }
                        n._pixelMin = A, n._pixelMax = L, egt(AI.select(v), _), rgt(e, t, r, n);
                    }
                    function b() {
                        v.removeEventListener("mousemove", x), v.removeEventListener("mouseup", b), this.removeEventListener("touchmove", x), this.removeEventListener("touchend", b), Ff.removeElement(v);
                    }
                }
                e.on("mousedown", s), e.on("touchstart", s);
            }
            function rgt(e, t, r, n) {
                function i(s) {
                    return r.l2r(Ff.constrain(s, n._rl[0], n._rl[1]));
                }
                var a = i(n.p2d(n._pixelMin)), o = i(n.p2d(n._pixelMax));
                window.requestAnimationFrame(function() {
                    Y0t.call("_guiRelayout", t, r._name + ".range", [
                        a,
                        o
                    ]);
                });
            }
            function igt(e, t, r, n, i, a) {
                var o = Bs.handleWidth / 2;
                function s(p) {
                    return Ff.constrain(p, 0, n._width);
                }
                function l(p) {
                    return Ff.constrain(p, 0, n._height);
                }
                function u(p) {
                    return Ff.constrain(p, -o, n._width + o);
                }
                var c = s(n.d2p(r._rl[0])), f = s(n.d2p(r._rl[1]));
                if (e.select("rect." + Bs.slideBoxClassName).attr("x", c).attr("width", f - c), e.select("rect." + Bs.maskMinClassName).attr("width", c), e.select("rect." + Bs.maskMaxClassName).attr("x", f).attr("width", n._width - f), a.rangemode !== "match") {
                    var h = n._height - l(n.d2pOppAxis(i._rl[1])), d = n._height - l(n.d2pOppAxis(i._rl[0]));
                    e.select("rect." + Bs.maskMinOppAxisClassName).attr("x", c).attr("height", h).attr("width", f - c), e.select("rect." + Bs.maskMaxOppAxisClassName).attr("x", c).attr("y", d).attr("height", n._height - d).attr("width", f - c), e.select("rect." + Bs.slideBoxClassName).attr("y", h).attr("height", d - h);
                }
                var v = .5, x = Math.round(u(c - o)) - v, b = Math.round(u(f - o)) + v;
                e.select("g." + Bs.grabberMinClassName).attr("transform", SI(x, v)), e.select("g." + Bs.grabberMaxClassName).attr("transform", SI(b, v));
            }
            function ngt(e, t, r, n) {
                var i = Ff.ensureSingle(e, "rect", Bs.bgClassName, function(l) {
                    l.attr({
                        x: 0,
                        y: 0,
                        "shape-rendering": "crispEdges"
                    });
                }), a = n.borderwidth % 2 === 0 ? n.borderwidth : n.borderwidth - 1, o = -n._offsetShift, s = Age.crispRound(t, n.borderwidth);
                i.attr({
                    width: n._width + a,
                    height: n._height + a,
                    transform: SI(o, o),
                    "stroke-width": s
                }).call(b_.stroke, n.bordercolor).call(b_.fill, n.bgcolor);
            }
            function agt(e, t, r, n) {
                var i = t._fullLayout, a = Ff.ensureSingleById(i._topdefs, "clipPath", n._clipId, function(o) {
                    o.append("rect").attr({
                        x: 0,
                        y: 0
                    });
                });
                a.select("rect").attr({
                    width: n._width,
                    height: n._height
                });
            }
            function ogt(e, t, r, n) {
                var i = t.calcdata, a = e.selectAll("g." + Bs.rangePlotClassName).data(r._subplotsWith, Ff.identity);
                a.enter().append("g").attr("class", function(s) {
                    return Bs.rangePlotClassName + " " + s;
                }).call(Age.setClipUrl, n._clipId, t), a.order(), a.exit().remove();
                var o;
                a.each(function(s, l) {
                    var u = AI.select(this), c = l === 0, f = YU.getFromId(t, s, "y"), h = f._name, d = n[h], v = {
                        data: [],
                        layout: {
                            xaxis: {
                                type: r.type,
                                domain: [
                                    0,
                                    1
                                ],
                                range: n.range.slice(),
                                calendar: r.calendar
                            },
                            width: n._width,
                            height: n._height,
                            margin: {
                                t: 0,
                                b: 0,
                                l: 0,
                                r: 0
                            }
                        },
                        _context: t._context
                    };
                    r.rangebreaks && (v.layout.xaxis.rangebreaks = r.rangebreaks), v.layout[h] = {
                        type: f.type,
                        domain: [
                            0,
                            1
                        ],
                        range: d.rangemode !== "match" ? d.range.slice() : f.range.slice(),
                        calendar: f.calendar
                    }, f.rangebreaks && (v.layout[h].rangebreaks = f.rangebreaks), K0t.supplyDefaults(v);
                    var x = v._fullLayout.xaxis, b = v._fullLayout[h];
                    x.clearCalc(), x.setScale(), b.clearCalc(), b.setScale();
                    var p = {
                        id: s,
                        plotgroup: u,
                        xaxis: x,
                        yaxis: b,
                        isRangePlot: !0
                    };
                    c ? o = p : (p.mainplot = "xy", p.mainplotinfo = o), $0t.rangePlot(t, p, sgt(i, s));
                });
            }
            function sgt(e, t) {
                for(var r = [], n = 0; n < e.length; n++){
                    var i = e[n], a = i[0].trace;
                    a.xaxis + a.yaxis === t && r.push(i);
                }
                return r;
            }
            function lgt(e, t, r, n, i) {
                var a = Ff.ensureSingle(e, "rect", Bs.maskMinClassName, function(u) {
                    u.attr({
                        x: 0,
                        y: 0,
                        "shape-rendering": "crispEdges"
                    });
                });
                a.attr("height", n._height).call(b_.fill, Bs.maskColor);
                var o = Ff.ensureSingle(e, "rect", Bs.maskMaxClassName, function(u) {
                    u.attr({
                        y: 0,
                        "shape-rendering": "crispEdges"
                    });
                });
                if (o.attr("height", n._height).call(b_.fill, Bs.maskColor), i.rangemode !== "match") {
                    var s = Ff.ensureSingle(e, "rect", Bs.maskMinOppAxisClassName, function(u) {
                        u.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    });
                    s.attr("width", n._width).call(b_.fill, Bs.maskOppAxisColor);
                    var l = Ff.ensureSingle(e, "rect", Bs.maskMaxOppAxisClassName, function(u) {
                        u.attr({
                            y: 0,
                            "shape-rendering": "crispEdges"
                        });
                    });
                    l.attr("width", n._width).style("border-top", Bs.maskOppBorder).call(b_.fill, Bs.maskOppAxisColor);
                }
            }
            function ugt(e, t, r, n) {
                if (!t._context.staticPlot) {
                    var i = Ff.ensureSingle(e, "rect", Bs.slideBoxClassName, function(a) {
                        a.attr({
                            y: 0,
                            cursor: Bs.slideBoxCursor,
                            "shape-rendering": "crispEdges"
                        });
                    });
                    i.attr({
                        height: n._height,
                        fill: Bs.slideBoxFill
                    });
                }
            }
            function cgt(e, t, r, n) {
                var i = Ff.ensureSingle(e, "g", Bs.grabberMinClassName), a = Ff.ensureSingle(e, "g", Bs.grabberMaxClassName), o = {
                    x: 0,
                    width: Bs.handleWidth,
                    rx: Bs.handleRadius,
                    fill: b_.background,
                    stroke: b_.defaultLine,
                    "stroke-width": Bs.handleStrokeWidth,
                    "shape-rendering": "crispEdges"
                }, s = {
                    y: Math.round(n._height / 4),
                    height: Math.round(n._height / 2)
                }, l = Ff.ensureSingle(i, "rect", Bs.handleMinClassName, function(d) {
                    d.attr(o);
                });
                l.attr(s);
                var u = Ff.ensureSingle(a, "rect", Bs.handleMaxClassName, function(d) {
                    d.attr(o);
                });
                u.attr(s);
                var c = {
                    width: Bs.grabAreaWidth,
                    x: 0,
                    y: 0,
                    fill: Bs.grabAreaFill,
                    cursor: t._context.staticPlot ? void 0 : Bs.grabAreaCursor
                }, f = Ff.ensureSingle(i, "rect", Bs.grabAreaMinClassName, function(d) {
                    d.attr(c);
                });
                f.attr("height", n._height);
                var h = Ff.ensureSingle(a, "rect", Bs.grabAreaMaxClassName, function(d) {
                    d.attr(c);
                });
                h.attr("height", n._height);
            }
        });
        var kge = ye((War, Ege)=>{
            "use strict";
            var fgt = Mr(), hgt = _I(), dgt = XU(), KU = gge();
            Ege.exports = {
                moduleType: "component",
                name: "rangeslider",
                schema: {
                    subplots: {
                        xaxis: {
                            rangeslider: fgt.extendFlat({}, hgt, {
                                yaxis: dgt
                            })
                        }
                    }
                },
                layoutAttributes: _I(),
                handleDefaults: xge(),
                calcAutorange: wge(),
                draw: Mge(),
                isVisible: KU.isVisible,
                makeData: KU.makeData,
                autoMarginOpts: KU.autoMarginOpts
            };
        });
        var MI = ye((Zar, Lge)=>{
            "use strict";
            var vgt = Su(), Cge = dh(), pgt = Vs().templatedArray, ggt = pgt("button", {
                visible: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "plot"
                },
                step: {
                    valType: "enumerated",
                    values: [
                        "month",
                        "year",
                        "day",
                        "hour",
                        "minute",
                        "second",
                        "all"
                    ],
                    dflt: "month",
                    editType: "plot"
                },
                stepmode: {
                    valType: "enumerated",
                    values: [
                        "backward",
                        "todate"
                    ],
                    dflt: "backward",
                    editType: "plot"
                },
                count: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "plot"
                },
                label: {
                    valType: "string",
                    editType: "plot"
                },
                editType: "plot"
            });
            Lge.exports = {
                visible: {
                    valType: "boolean",
                    editType: "plot"
                },
                buttons: ggt,
                x: {
                    valType: "number",
                    min: -2,
                    max: 3,
                    editType: "plot"
                },
                xanchor: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "left",
                        "center",
                        "right"
                    ],
                    dflt: "left",
                    editType: "plot"
                },
                y: {
                    valType: "number",
                    min: -2,
                    max: 3,
                    editType: "plot"
                },
                yanchor: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "top",
                        "middle",
                        "bottom"
                    ],
                    dflt: "bottom",
                    editType: "plot"
                },
                font: vgt({
                    editType: "plot"
                }),
                bgcolor: {
                    valType: "color",
                    dflt: Cge.lightLine,
                    editType: "plot"
                },
                activecolor: {
                    valType: "color",
                    editType: "plot"
                },
                bordercolor: {
                    valType: "color",
                    dflt: Cge.defaultLine,
                    editType: "plot"
                },
                borderwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 0,
                    editType: "plot"
                },
                editType: "plot"
            };
        });
        var JU = ye((Xar, Pge)=>{
            "use strict";
            Pge.exports = {
                yPad: .02,
                minButtonWidth: 30,
                rx: 3,
                ry: 3,
                lightAmount: 25,
                darkAmount: 10
            };
        });
        var Dge = ye((Yar, Rge)=>{
            "use strict";
            var EI = Mr(), mgt = va(), ygt = Vs(), _gt = Zd(), Ige = MI(), $U = JU();
            Rge.exports = function(t, r, n, i, a) {
                var o = t.rangeselector || {}, s = ygt.newContainer(r, "rangeselector");
                function l(d, v) {
                    return EI.coerce(o, s, Ige, d, v);
                }
                var u = _gt(o, s, {
                    name: "buttons",
                    handleItemDefaults: xgt,
                    calendar: a
                }), c = l("visible", u.length > 0);
                if (c) {
                    var f = bgt(r, n, i);
                    l("x", f[0]), l("y", f[1]), EI.noneOrAll(t, r, [
                        "x",
                        "y"
                    ]), l("xanchor"), l("yanchor"), EI.coerceFont(l, "font", n.font);
                    var h = l("bgcolor");
                    l("activecolor", mgt.contrast(h, $U.lightAmount, $U.darkAmount)), l("bordercolor"), l("borderwidth");
                }
            };
            function xgt(e, t, r, n) {
                var i = n.calendar;
                function a(l, u) {
                    return EI.coerce(e, t, Ige.buttons, l, u);
                }
                var o = a("visible");
                if (o) {
                    var s = a("step");
                    s !== "all" && (i && i !== "gregorian" && (s === "month" || s === "year") ? t.stepmode = "backward" : a("stepmode"), a("count")), a("label");
                }
            }
            function bgt(e, t, r) {
                for(var n = r.filter(function(s) {
                    return t[s].anchor === e._id;
                }), i = 0, a = 0; a < n.length; a++){
                    var o = t[n[a]].domain;
                    o && (i = Math.max(o[1], i));
                }
                return [
                    e.domain[0],
                    i + $U.yPad
                ];
            }
        });
        var Fge = ye((Kar, zge)=>{
            "use strict";
            var wgt = dq(), Tgt = Mr().titleCase;
            zge.exports = function(t, r) {
                var n = t._name, i = {};
                if (r.step === "all") i[n + ".autorange"] = !0;
                else {
                    var a = Agt(t, r);
                    i[n + ".range[0]"] = a[0], i[n + ".range[1]"] = a[1];
                }
                return i;
            };
            function Agt(e, t) {
                var r = e.range, n = new Date(e.r2l(r[1])), i = t.step, a = wgt["utc" + Tgt(i)], o = t.count, s;
                switch(t.stepmode){
                    case "backward":
                        s = e.l2r(+a.offset(n, -o));
                        break;
                    case "todate":
                        var l = a.offset(n, -o);
                        s = e.l2r(+a.ceil(l));
                        break;
                }
                var u = r[1];
                return [
                    s,
                    u
                ];
            }
        });
        var Gge = ye((Jar, Hge)=>{
            "use strict";
            var CI = xa(), Sgt = ba(), Mgt = Xu(), qge = va(), Vge = ao(), Iy = Mr(), Oge = Iy.strTranslate, kI = Pl(), Egt = af(), tV = Nh(), Bge = tV.LINE_SPACING, Nge = tV.FROM_TL, Uge = tV.FROM_BR, eV = JU(), kgt = Fge();
            Hge.exports = function(t) {
                var r = t._fullLayout, n = r._infolayer.selectAll(".rangeselector").data(Cgt(t), Lgt);
                n.enter().append("g").classed("rangeselector", !0), n.exit().remove(), n.style({
                    cursor: "pointer",
                    "pointer-events": "all"
                }), n.each(function(i) {
                    var a = CI.select(this), o = i, s = o.rangeselector, l = a.selectAll("g.button").data(Iy.filterVisible(s.buttons));
                    l.enter().append("g").classed("button", !0), l.exit().remove(), l.each(function(u) {
                        var c = CI.select(this), f = kgt(o, u);
                        u._isActive = Pgt(o, u, f), c.call(QU, s, u), c.call(Rgt, s, u, t), c.on("click", function() {
                            t._dragged || Sgt.call("_guiRelayout", t, f);
                        }), c.on("mouseover", function() {
                            u._isHovered = !0, c.call(QU, s, u);
                        }), c.on("mouseout", function() {
                            u._isHovered = !1, c.call(QU, s, u);
                        });
                    }), zgt(t, l, s, o._name, a);
                });
            };
            function Cgt(e) {
                for(var t = Egt.list(e, "x", !0), r = [], n = 0; n < t.length; n++){
                    var i = t[n];
                    i.rangeselector && i.rangeselector.visible && r.push(i);
                }
                return r;
            }
            function Lgt(e) {
                return e._id;
            }
            function Pgt(e, t, r) {
                if (t.step === "all") return e.autorange === !0;
                var n = Object.keys(r);
                return e.range[0] === r[n[0]] && e.range[1] === r[n[1]];
            }
            function QU(e, t, r) {
                var n = Iy.ensureSingle(e, "rect", "selector-rect", function(i) {
                    i.attr("shape-rendering", "crispEdges");
                });
                n.attr({
                    rx: eV.rx,
                    ry: eV.ry
                }), n.call(qge.stroke, t.bordercolor).call(qge.fill, Igt(t, r)).style("stroke-width", t.borderwidth + "px");
            }
            function Igt(e, t) {
                return t._isActive || t._isHovered ? e.activecolor : e.bgcolor;
            }
            function Rgt(e, t, r, n) {
                function i(o) {
                    kI.convertToTspans(o, n);
                }
                var a = Iy.ensureSingle(e, "text", "selector-text", function(o) {
                    o.attr("text-anchor", "middle");
                });
                a.call(Vge.font, t.font).text(Dgt(r, n._fullLayout._meta)).call(i);
            }
            function Dgt(e, t) {
                return e.label ? t ? Iy.templateString(e.label, t) : e.label : e.step === "all" ? "all" : e.count + e.step.charAt(0);
            }
            function zgt(e, t, r, n, i) {
                var a = 0, o = 0, s = r.borderwidth;
                t.each(function() {
                    var d = CI.select(this), v = d.select(".selector-text"), x = r.font.size * Bge, b = Math.max(x * kI.lineCount(v), 16) + 3;
                    o = Math.max(o, b);
                }), t.each(function() {
                    var d = CI.select(this), v = d.select(".selector-rect"), x = d.select(".selector-text"), b = x.node() && Vge.bBox(x.node()).width, p = r.font.size * Bge, E = kI.lineCount(x), k = Math.max(b + 10, eV.minButtonWidth);
                    d.attr("transform", Oge(s + a, s)), v.attr({
                        x: 0,
                        y: 0,
                        width: k,
                        height: o
                    }), kI.positionText(x, k / 2, o / 2 - (E - 1) * p / 2 + 3), a += k + 5;
                });
                var l = e._fullLayout._size, u = l.l + l.w * r.x, c = l.t + l.h * (1 - r.y), f = "left";
                Iy.isRightAnchor(r) && (u -= a, f = "right"), Iy.isCenterAnchor(r) && (u -= a / 2, f = "center");
                var h = "top";
                Iy.isBottomAnchor(r) && (c -= o, h = "bottom"), Iy.isMiddleAnchor(r) && (c -= o / 2, h = "middle"), a = Math.ceil(a), o = Math.ceil(o), u = Math.round(u), c = Math.round(c), Mgt.autoMargin(e, n + "-range-selector", {
                    x: r.x,
                    y: r.y,
                    l: a * Nge[f],
                    r: a * Uge[f],
                    b: o * Uge[h],
                    t: o * Nge[h]
                }), i.attr("transform", Oge(u, c));
            }
        });
        var Wge = ye(($ar, jge)=>{
            "use strict";
            jge.exports = {
                moduleType: "component",
                name: "rangeselector",
                schema: {
                    subplots: {
                        xaxis: {
                            rangeselector: MI()
                        }
                    }
                },
                layoutAttributes: MI(),
                handleDefaults: Dge(),
                draw: Gge()
            };
        });
        var Ju = ye((rV)=>{
            "use strict";
            var Zge = no().extendFlat;
            rV.attributes = function(e, t) {
                e = e || {}, t = t || {};
                var r = {
                    valType: "info_array",
                    editType: e.editType,
                    items: [
                        {
                            valType: "number",
                            min: 0,
                            max: 1,
                            editType: e.editType
                        },
                        {
                            valType: "number",
                            min: 0,
                            max: 1,
                            editType: e.editType
                        }
                    ],
                    dflt: [
                        0,
                        1
                    ]
                }, n = e.name ? e.name + " " : "", i = e.trace ? "trace " : "subplot ", a = t.description ? " " + t.description : "", o = {
                    x: Zge({}, r, {}),
                    y: Zge({}, r, {}),
                    editType: e.editType
                };
                return e.noGridCell || (o.row = {
                    valType: "integer",
                    min: 0,
                    dflt: 0,
                    editType: e.editType
                }, o.column = {
                    valType: "integer",
                    min: 0,
                    dflt: 0,
                    editType: e.editType
                }), o;
            };
            rV.defaults = function(e, t, r, n) {
                var i = n && n.x || [
                    0,
                    1
                ], a = n && n.y || [
                    0,
                    1
                ], o = t.grid;
                if (o) {
                    var s = r("domain.column");
                    s !== void 0 && (s < o.columns ? i = o._domains.x[s] : delete e.domain.column);
                    var l = r("domain.row");
                    l !== void 0 && (l < o.rows ? a = o._domains.y[l] : delete e.domain.row);
                }
                var u = r("domain.x", i), c = r("domain.y", a);
                u[0] < u[1] || (e.domain.x = i.slice()), c[0] < c[1] || (e.domain.y = a.slice());
            };
        });
        var nV = ye((eor, Jge)=>{
            "use strict";
            var Fgt = Mr(), qgt = n3().counter, Ogt = Ju().attributes, Xge = ad().idRegex, Bgt = Vs(), iV = {
                rows: {
                    valType: "integer",
                    min: 1,
                    editType: "plot"
                },
                roworder: {
                    valType: "enumerated",
                    values: [
                        "top to bottom",
                        "bottom to top"
                    ],
                    dflt: "top to bottom",
                    editType: "plot"
                },
                columns: {
                    valType: "integer",
                    min: 1,
                    editType: "plot"
                },
                subplots: {
                    valType: "info_array",
                    freeLength: !0,
                    dimensions: 2,
                    items: {
                        valType: "enumerated",
                        values: [
                            qgt("xy").toString(),
                            ""
                        ],
                        editType: "plot"
                    },
                    editType: "plot"
                },
                xaxes: {
                    valType: "info_array",
                    freeLength: !0,
                    items: {
                        valType: "enumerated",
                        values: [
                            Xge.x.toString(),
                            ""
                        ],
                        editType: "plot"
                    },
                    editType: "plot"
                },
                yaxes: {
                    valType: "info_array",
                    freeLength: !0,
                    items: {
                        valType: "enumerated",
                        values: [
                            Xge.y.toString(),
                            ""
                        ],
                        editType: "plot"
                    },
                    editType: "plot"
                },
                pattern: {
                    valType: "enumerated",
                    values: [
                        "independent",
                        "coupled"
                    ],
                    dflt: "coupled",
                    editType: "plot"
                },
                xgap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: "plot"
                },
                ygap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: "plot"
                },
                domain: Ogt({
                    name: "grid",
                    editType: "plot",
                    noGridCell: !0
                }, {}),
                xside: {
                    valType: "enumerated",
                    values: [
                        "bottom",
                        "bottom plot",
                        "top plot",
                        "top"
                    ],
                    dflt: "bottom plot",
                    editType: "plot"
                },
                yside: {
                    valType: "enumerated",
                    values: [
                        "left",
                        "left plot",
                        "right plot",
                        "right"
                    ],
                    dflt: "left plot",
                    editType: "plot"
                },
                editType: "plot"
            };
            function LI(e, t, r) {
                var n = t[r + "axes"], i = Object.keys((e._splomAxes || {})[r] || {});
                if (Array.isArray(n)) return n;
                if (i.length) return i;
            }
            function Ngt(e, t) {
                var r = e.grid || {}, n = LI(t, r, "x"), i = LI(t, r, "y");
                if (!e.grid && !n && !i) return;
                var a = Array.isArray(r.subplots) && Array.isArray(r.subplots[0]), o = Array.isArray(n), s = Array.isArray(i), l = o && n !== r.xaxes && s && i !== r.yaxes, u, c;
                a ? (u = r.subplots.length, c = r.subplots[0].length) : (s && (u = i.length), o && (c = n.length));
                var f = Bgt.newContainer(t, "grid");
                function h(_, C) {
                    return Fgt.coerce(r, f, iV, _, C);
                }
                var d = h("rows", u), v = h("columns", c);
                if (!(d * v > 1)) {
                    delete t.grid;
                    return;
                }
                if (!a && !o && !s) {
                    var x = h("pattern") === "independent";
                    x && (a = !0);
                }
                f._hasSubplotGrid = a;
                var b = h("roworder"), p = b === "top to bottom", E = a ? .2 : .1, k = a ? .3 : .1, A, L;
                l && t._splomGridDflt && (A = t._splomGridDflt.xside, L = t._splomGridDflt.yside), f._domains = {
                    x: Yge("x", h, E, A, v),
                    y: Yge("y", h, k, L, d, p)
                };
            }
            function Yge(e, t, r, n, i, a) {
                var o = t(e + "gap", r), s = t("domain." + e);
                t(e + "side", n);
                for(var l = new Array(i), u = s[0], c = (s[1] - u) / (i - o), f = c * (1 - o), h = 0; h < i; h++){
                    var d = u + c * h;
                    l[a ? i - 1 - h : h] = [
                        d,
                        d + f
                    ];
                }
                return l;
            }
            function Ugt(e, t) {
                var r = t.grid;
                if (!(!r || !r._domains)) {
                    var n = e.grid || {}, i = t._subplots, a = r._hasSubplotGrid, o = r.rows, s = r.columns, l = r.pattern === "independent", u, c, f, h, d, v, x, b = r._axisMap = {};
                    if (a) {
                        var p = n.subplots || [];
                        v = r.subplots = new Array(o);
                        var E = 1;
                        for(u = 0; u < o; u++){
                            var k = v[u] = new Array(s), A = p[u] || [];
                            for(c = 0; c < s; c++)if (l ? (d = E === 1 ? "xy" : "x" + E + "y" + E, E++) : d = A[c], k[c] = "", i.cartesian.indexOf(d) !== -1) {
                                if (x = d.indexOf("y"), f = d.slice(0, x), h = d.slice(x), b[f] !== void 0 && b[f] !== c || b[h] !== void 0 && b[h] !== u) continue;
                                k[c] = d, b[f] = c, b[h] = u;
                            }
                        }
                    } else {
                        var L = LI(t, n, "x"), _ = LI(t, n, "y");
                        r.xaxes = Kge(L, i.xaxis, s, b, "x"), r.yaxes = Kge(_, i.yaxis, o, b, "y");
                    }
                    var C = r._anchors = {}, M = r.roworder === "top to bottom";
                    for(var g in b){
                        var P = g.charAt(0), T = r[P + "side"], F, q, V;
                        if (T.length < 8) C[g] = "free";
                        else if (P === "x") {
                            if (T.charAt(0) === "t" === M ? (F = 0, q = 1, V = o) : (F = o - 1, q = -1, V = -1), a) {
                                var H = b[g];
                                for(u = F; u !== V; u += q)if (d = v[u][H], !!d && (x = d.indexOf("y"), d.slice(0, x) === g)) {
                                    C[g] = d.slice(x);
                                    break;
                                }
                            } else for(u = F; u !== V; u += q)if (h = r.yaxes[u], i.cartesian.indexOf(g + h) !== -1) {
                                C[g] = h;
                                break;
                            }
                        } else if (T.charAt(0) === "l" ? (F = 0, q = 1, V = s) : (F = s - 1, q = -1, V = -1), a) {
                            var X = b[g];
                            for(u = F; u !== V; u += q)if (d = v[X][u], !!d && (x = d.indexOf("y"), d.slice(x) === g)) {
                                C[g] = d.slice(0, x);
                                break;
                            }
                        } else for(u = F; u !== V; u += q)if (f = r.xaxes[u], i.cartesian.indexOf(f + g) !== -1) {
                            C[g] = f;
                            break;
                        }
                    }
                }
            }
            function Kge(e, t, r, n, i) {
                var a = new Array(r), o;
                function s(l, u) {
                    t.indexOf(u) !== -1 && n[u] === void 0 ? (a[l] = u, n[u] = l) : a[l] = "";
                }
                if (Array.isArray(e)) for(o = 0; o < r; o++)s(o, e[o]);
                else for(s(0, i), o = 1; o < r; o++)s(o, i + (o + 1));
                return a;
            }
            Jge.exports = {
                moduleType: "component",
                name: "grid",
                schema: {
                    layout: {
                        grid: iV
                    }
                },
                layoutAttributes: iV,
                sizeDefaults: Ngt,
                contentDefaults: Ugt
            };
        });
        var aV = ye((tor, $ge)=>{
            "use strict";
            $ge.exports = {
                visible: {
                    valType: "boolean",
                    editType: "calc"
                },
                type: {
                    valType: "enumerated",
                    values: [
                        "percent",
                        "constant",
                        "sqrt",
                        "data"
                    ],
                    editType: "calc"
                },
                symmetric: {
                    valType: "boolean",
                    editType: "calc"
                },
                array: {
                    valType: "data_array",
                    editType: "calc"
                },
                arrayminus: {
                    valType: "data_array",
                    editType: "calc"
                },
                value: {
                    valType: "number",
                    min: 0,
                    dflt: 10,
                    editType: "calc"
                },
                valueminus: {
                    valType: "number",
                    min: 0,
                    dflt: 10,
                    editType: "calc"
                },
                traceref: {
                    valType: "integer",
                    min: 0,
                    dflt: 0,
                    editType: "style"
                },
                tracerefminus: {
                    valType: "integer",
                    min: 0,
                    dflt: 0,
                    editType: "style"
                },
                copy_ystyle: {
                    valType: "boolean",
                    editType: "plot"
                },
                copy_zstyle: {
                    valType: "boolean",
                    editType: "style"
                },
                color: {
                    valType: "color",
                    editType: "style"
                },
                thickness: {
                    valType: "number",
                    min: 0,
                    dflt: 2,
                    editType: "style"
                },
                width: {
                    valType: "number",
                    min: 0,
                    editType: "plot"
                },
                editType: "calc"
            };
        });
        var tme = ye((ror, eme)=>{
            "use strict";
            var Qge = uo(), Vgt = ba(), Hgt = Mr(), Ggt = Vs(), jgt = aV();
            eme.exports = function(e, t, r, n) {
                var i = "error_" + n.axis, a = Ggt.newContainer(t, i), o = e[i] || {};
                function s(v, x) {
                    return Hgt.coerce(o, a, jgt, v, x);
                }
                var l = o.array !== void 0 || o.value !== void 0 || o.type === "sqrt", u = s("visible", l);
                if (u !== !1) {
                    var c = s("type", "array" in o ? "data" : "percent"), f = !0;
                    c !== "sqrt" && (f = s("symmetric", !((c === "data" ? "arrayminus" : "valueminus") in o))), c === "data" ? (s("array"), s("traceref"), f || (s("arrayminus"), s("tracerefminus"))) : (c === "percent" || c === "constant") && (s("value"), f || s("valueminus"));
                    var h = "copy_" + n.inherit + "style";
                    if (n.inherit) {
                        var d = t["error_" + n.inherit];
                        (d || {}).visible && s(h, !(o.color || Qge(o.thickness) || Qge(o.width)));
                    }
                    (!n.inherit || !a[h]) && (s("color", r), s("thickness"), s("width", Vgt.traceIs(t, "gl3d") ? 0 : 4));
                }
            };
        });
        var oV = ye((ior, ime)=>{
            "use strict";
            ime.exports = function(t) {
                var r = t.type, n = t.symmetric;
                if (r === "data") {
                    var i = t.array || [];
                    if (n) return function(u, c) {
                        var f = +i[c];
                        return [
                            f,
                            f
                        ];
                    };
                    var a = t.arrayminus || [];
                    return function(u, c) {
                        var f = +i[c], h = +a[c];
                        return !isNaN(f) || !isNaN(h) ? [
                            h || 0,
                            f || 0
                        ] : [
                            NaN,
                            NaN
                        ];
                    };
                } else {
                    var o = rme(r, t.value), s = rme(r, t.valueminus);
                    return n || t.valueminus === void 0 ? function(u) {
                        var c = o(u);
                        return [
                            c,
                            c
                        ];
                    } : function(u) {
                        return [
                            s(u),
                            o(u)
                        ];
                    };
                }
            };
            function rme(e, t) {
                if (e === "percent") return function(r) {
                    return Math.abs(r * t / 100);
                };
                if (e === "constant") return function() {
                    return Math.abs(t);
                };
                if (e === "sqrt") return function(r) {
                    return Math.sqrt(Math.abs(r));
                };
            }
        });
        var ome = ye((nor, ame)=>{
            "use strict";
            var sV = uo(), Wgt = ba(), lV = Qa(), Zgt = Mr(), Xgt = oV();
            ame.exports = function(t) {
                for(var r = t.calcdata, n = 0; n < r.length; n++){
                    var i = r[n], a = i[0].trace;
                    if (a.visible === !0 && Wgt.traceIs(a, "errorBarsOK")) {
                        var o = lV.getFromId(t, a.xaxis), s = lV.getFromId(t, a.yaxis);
                        nme(i, a, o, "x"), nme(i, a, s, "y");
                    }
                }
            };
            function nme(e, t, r, n) {
                var i = t["error_" + n] || {}, a = i.visible && [
                    "linear",
                    "log"
                ].indexOf(r.type) !== -1, o = [];
                if (a) {
                    for(var s = Xgt(i), l = 0; l < e.length; l++){
                        var u = e[l], c = u.i;
                        if (c === void 0) c = l;
                        else if (c === null) continue;
                        var f = u[n];
                        if (sV(r.c2l(f))) {
                            var h = s(f, c);
                            if (sV(h[0]) && sV(h[1])) {
                                var d = u[n + "s"] = f - h[0], v = u[n + "h"] = f + h[1];
                                o.push(d, v);
                            }
                        }
                    }
                    var x = r._id, b = t._extremes[x], p = lV.findExtremes(r, o, Zgt.extendFlat({
                        tozero: b.opts.tozero
                    }, {
                        padded: !0
                    }));
                    b.min = b.min.concat(p.min), b.max = b.max.concat(p.max);
                }
            }
        });
        var ume = ye((aor, lme)=>{
            "use strict";
            var sme = xa(), w_ = uo(), Ygt = ao(), Kgt = lu();
            lme.exports = function(t, r, n, i) {
                var a, o = n.xaxis, s = n.yaxis, l = i && i.duration > 0, u = t._context.staticPlot;
                r.each(function(c) {
                    var f = c[0].trace, h = f.error_x || {}, d = f.error_y || {}, v;
                    f.ids && (v = function(E) {
                        return E.id;
                    });
                    var x = Kgt.hasMarkers(f) && f.marker.maxdisplayed > 0;
                    !d.visible && !h.visible && (c = []);
                    var b = sme.select(this).selectAll("g.errorbar").data(c, v);
                    if (b.exit().remove(), !!c.length) {
                        h.visible || b.selectAll("path.xerror").remove(), d.visible || b.selectAll("path.yerror").remove(), b.style("opacity", 1);
                        var p = b.enter().append("g").classed("errorbar", !0);
                        l && p.style("opacity", 0).transition().duration(i.duration).style("opacity", 1), Ygt.setClipUrl(b, n.layerClipId, t), b.each(function(E) {
                            var k = sme.select(this), A = Jgt(E, o, s);
                            if (!(x && !E.vis)) {
                                var L, _ = k.select("path.yerror");
                                if (d.visible && w_(A.x) && w_(A.yh) && w_(A.ys)) {
                                    var C = d.width;
                                    L = "M" + (A.x - C) + "," + A.yh + "h" + 2 * C + "m-" + C + ",0V" + A.ys, A.noYS || (L += "m-" + C + ",0h" + 2 * C), a = !_.size(), a ? _ = k.append("path").style("vector-effect", u ? "none" : "non-scaling-stroke").classed("yerror", !0) : l && (_ = _.transition().duration(i.duration).ease(i.easing)), _.attr("d", L);
                                } else _.remove();
                                var M = k.select("path.xerror");
                                if (h.visible && w_(A.y) && w_(A.xh) && w_(A.xs)) {
                                    var g = (h.copy_ystyle ? d : h).width;
                                    L = "M" + A.xh + "," + (A.y - g) + "v" + 2 * g + "m0,-" + g + "H" + A.xs, A.noXS || (L += "m0,-" + g + "v" + 2 * g), a = !M.size(), a ? M = k.append("path").style("vector-effect", u ? "none" : "non-scaling-stroke").classed("xerror", !0) : l && (M = M.transition().duration(i.duration).ease(i.easing)), M.attr("d", L);
                                } else M.remove();
                            }
                        });
                    }
                });
            };
            function Jgt(e, t, r) {
                var n = {
                    x: t.c2p(e.x),
                    y: r.c2p(e.y)
                };
                return e.yh !== void 0 && (n.yh = r.c2p(e.yh), n.ys = r.c2p(e.ys), w_(n.ys) || (n.noYS = !0, n.ys = r.c2p(e.ys, !0))), e.xh !== void 0 && (n.xh = t.c2p(e.xh), n.xs = t.c2p(e.xs), w_(n.xs) || (n.noXS = !0, n.xs = t.c2p(e.xs, !0))), n;
            }
        });
        var hme = ye((oor, fme)=>{
            "use strict";
            var $gt = xa(), cme = va();
            fme.exports = function(t) {
                t.each(function(r) {
                    var n = r[0].trace, i = n.error_y || {}, a = n.error_x || {}, o = $gt.select(this);
                    o.selectAll("path.yerror").style("stroke-width", i.thickness + "px").call(cme.stroke, i.color), a.copy_ystyle && (a = i), o.selectAll("path.xerror").style("stroke-width", a.thickness + "px").call(cme.stroke, a.color);
                });
            };
        });
        var pme = ye((sor, vme)=>{
            "use strict";
            var o4 = Mr(), dme = Bu().overrideAll, s4 = aV(), $b = {
                error_x: o4.extendFlat({}, s4),
                error_y: o4.extendFlat({}, s4)
            };
            delete $b.error_x.copy_zstyle;
            delete $b.error_y.copy_zstyle;
            delete $b.error_y.copy_ystyle;
            var l4 = {
                error_x: o4.extendFlat({}, s4),
                error_y: o4.extendFlat({}, s4),
                error_z: o4.extendFlat({}, s4)
            };
            delete l4.error_x.copy_ystyle;
            delete l4.error_y.copy_ystyle;
            delete l4.error_z.copy_ystyle;
            delete l4.error_z.copy_zstyle;
            vme.exports = {
                moduleType: "component",
                name: "errorbars",
                schema: {
                    traces: {
                        scatter: $b,
                        bar: $b,
                        histogram: $b,
                        scatter3d: dme(l4, "calc", "nested"),
                        scattergl: dme($b, "calc", "nested")
                    }
                },
                supplyDefaults: tme(),
                calc: ome(),
                makeComputeError: oV(),
                plot: ume(),
                style: hme(),
                hoverInfo: Qgt
            };
            function Qgt(e, t, r) {
                (t.error_y || {}).visible && (r.yerr = e.yh - e.y, t.error_y.symmetric || (r.yerrneg = e.y - e.ys)), (t.error_x || {}).visible && (r.xerr = e.xh - e.x, t.error_x.symmetric || (r.xerrneg = e.x - e.xs));
            }
        });
        var mme = ye((lor, gme)=>{
            "use strict";
            gme.exports = {
                cn: {
                    colorbar: "colorbar",
                    cbbg: "cbbg",
                    cbfill: "cbfill",
                    cbfills: "cbfills",
                    cbline: "cbline",
                    cblines: "cblines",
                    cbaxis: "cbaxis",
                    cbtitleunshift: "cbtitleunshift",
                    cbtitle: "cbtitle",
                    cboutline: "cboutline",
                    crisp: "crisp",
                    jsPlaceholder: "js-placeholder"
                }
            };
        });
        var Ame = ye((uor, Tme)=>{
            "use strict";
            var T_ = xa(), uV = id(), II = Xu(), yme = ba(), Ry = Qa(), PI = gv(), B0 = Mr(), Ug = B0.strTranslate, wme = no().extendFlat, cV = Tg(), Ng = ao(), fV = va(), emt = Mb(), tmt = Pl(), rmt = Dv().flipScale, imt = JM(), nmt = iI(), amt = Cd(), hV = Nh(), _me = hV.LINE_SPACING, xme = hV.FROM_TL, bme = hV.FROM_BR, Vc = mme().cn;
            function omt(e) {
                var t = e._fullLayout, r = t._infolayer.selectAll("g." + Vc.colorbar).data(smt(e), function(n) {
                    return n._id;
                });
                r.enter().append("g").attr("class", function(n) {
                    return n._id;
                }).classed(Vc.colorbar, !0), r.each(function(n) {
                    var i = T_.select(this);
                    B0.ensureSingle(i, "rect", Vc.cbbg), B0.ensureSingle(i, "g", Vc.cbfills), B0.ensureSingle(i, "g", Vc.cblines), B0.ensureSingle(i, "g", Vc.cbaxis, function(o) {
                        o.classed(Vc.crisp, !0);
                    }), B0.ensureSingle(i, "g", Vc.cbtitleunshift, function(o) {
                        o.append("g").classed(Vc.cbtitle, !0);
                    }), B0.ensureSingle(i, "rect", Vc.cboutline);
                    var a = lmt(i, n, e);
                    a && a.then && (e._promises || []).push(a), e._context.edits.colorbarPosition && umt(i, n, e);
                }), r.exit().each(function(n) {
                    II.autoMargin(e, n._id);
                }).remove(), r.order();
            }
            function smt(e) {
                var t = e._fullLayout, r = e.calcdata, n = [], i, a, o, s;
                function l(k) {
                    return wme(k, {
                        _fillcolor: null,
                        _line: {
                            color: null,
                            width: null,
                            dash: null
                        },
                        _levels: {
                            start: null,
                            end: null,
                            size: null
                        },
                        _filllevels: null,
                        _fillgradient: null,
                        _zrange: null
                    });
                }
                function u() {
                    typeof s.calc == "function" ? s.calc(e, o, i) : (i._fillgradient = a.reversescale ? rmt(a.colorscale) : a.colorscale, i._zrange = [
                        a[s.min],
                        a[s.max]
                    ]);
                }
                for(var c = 0; c < r.length; c++){
                    var f = r[c];
                    if (o = f[0].trace, !!o._module) {
                        var h = o._module.colorbar;
                        if (o.visible === !0 && h) for(var d = Array.isArray(h), v = d ? h : [
                            h
                        ], x = 0; x < v.length; x++){
                            s = v[x];
                            var b = s.container;
                            a = b ? o[b] : o, a && a.showscale && (i = l(a.colorbar), i._id = "cb" + o.uid + (d && b ? "-" + b : ""), i._traceIndex = o.index, i._propPrefix = (b ? b + "." : "") + "colorbar.", i._meta = o._meta, u(), n.push(i));
                        }
                    }
                }
                for(var p in t._colorAxes)if (a = t[p], a.showscale) {
                    var E = t._colorAxes[p];
                    i = l(a.colorbar), i._id = "cb" + p, i._propPrefix = p + ".colorbar.", i._meta = t._meta, s = {
                        min: "cmin",
                        max: "cmax"
                    }, E[0] !== "heatmap" && (o = E[1], s.calc = o._module.colorbar.calc), u(), n.push(i);
                }
                return n;
            }
            function lmt(e, t, r) {
                var n = t.orientation === "v", i = t.len, a = t.lenmode, o = t.thickness, s = t.thicknessmode, l = t.outlinewidth, u = t.borderwidth, c = t.bgcolor, f = t.xanchor, h = t.yanchor, d = t.xpad, v = t.ypad, x = t.x, b = n ? t.y : 1 - t.y, p = t.yref === "paper", E = t.xref === "paper", k = r._fullLayout, A = k._size, L = t._fillcolor, _ = t._line, C = t.title, M = C.side, g = t._zrange || T_.extent((typeof L == "function" ? L : _.color).domain()), P = typeof _.color == "function" ? _.color : function() {
                    return _.color;
                }, T = typeof L == "function" ? L : function() {
                    return L;
                }, F = t._levels, q = cmt(r, t, g), V = q.fill, H = q.line, X = Math.round(o * (s === "fraction" ? n ? A.w : A.h : 1)), G = X / (n ? A.w : A.h), N = Math.round(i * (a === "fraction" ? n ? A.h : A.w : 1)), W = N / (n ? A.h : A.w), re = E ? A.w : r._fullLayout.width, ae = p ? A.h : r._fullLayout.height, _e = Math.round(n ? x * re + d : b * ae + v), Me = {
                    center: .5,
                    right: 1
                }[f] || 0, ke = {
                    top: 1,
                    middle: .5
                }[h] || 0, ge = n ? x - Me * G : b - ke * G, ie = n ? b - ke * W : x - Me * W, Te = Math.round(n ? ae * (1 - ie) : re * ie);
                t._lenFrac = W, t._thickFrac = G, t._uFrac = ge, t._vFrac = ie;
                var Ee = t._axis = fmt(r, t, g);
                Ee.position = G + (n ? x + d / A.w : b + v / A.h);
                var Ae = [
                    "top",
                    "bottom"
                ].indexOf(M) !== -1;
                if (n && Ae && (Ee.title.side = M, Ee.titlex = x + d / A.w, Ee.titley = ie + (C.side === "top" ? W - v / A.h : v / A.h)), !n && !Ae && (Ee.title.side = M, Ee.titley = b + v / A.h, Ee.titlex = ie + d / A.w), _.color && t.tickmode === "auto") {
                    Ee.tickmode = "linear", Ee.tick0 = F.start;
                    var ze = F.size, Ce = B0.constrain(N / 50, 4, 15) + 1, me = (g[1] - g[0]) / ((t.nticks || Ce) * ze);
                    if (me > 1) {
                        var Re = Math.pow(10, Math.floor(Math.log(me) / Math.LN10));
                        ze *= Re * B0.roundUp(me / Re, [
                            2,
                            5,
                            10
                        ]), (Math.abs(F.start) / F.size + 1e-6) % 1 < 2e-6 && (Ee.tick0 = 0);
                    }
                    Ee.dtick = ze;
                }
                Ee.domain = n ? [
                    ie + v / A.h,
                    ie + W - v / A.h
                ] : [
                    ie + d / A.w,
                    ie + W - d / A.w
                ], Ee.setScale(), e.attr("transform", Ug(Math.round(A.l), Math.round(A.t)));
                var ce = e.select("." + Vc.cbtitleunshift).attr("transform", Ug(-Math.round(A.l), -Math.round(A.t))), Ge = Ee.ticklabelposition, nt = Ee.title.font.size, ct = e.select("." + Vc.cbaxis), qt, rt = 0, ot = 0;
                function Rt(er, Ke) {
                    var xt = {
                        propContainer: Ee,
                        propName: t._propPrefix + "title",
                        traceIndex: t._traceIndex,
                        _meta: t._meta,
                        placeholder: k._dfltTitle.colorbar,
                        containerGroup: e.select("." + Vc.cbtitle)
                    }, bt = er.charAt(0) === "h" ? er.substr(1) : "h" + er;
                    e.selectAll("." + bt + ",." + bt + "-math-group").remove(), emt.draw(r, er, wme(xt, Ke || {}));
                }
                function kt() {
                    if (n && Ae || !n && !Ae) {
                        var er, Ke;
                        M === "top" && (er = d + A.l + re * x, Ke = v + A.t + ae * (1 - ie - W) + 3 + nt * .75), M === "bottom" && (er = d + A.l + re * x, Ke = v + A.t + ae * (1 - ie) - 3 - nt * .25), M === "right" && (Ke = v + A.t + ae * b + 3 + nt * .75, er = d + A.l + re * ie), Rt(Ee._id + "title", {
                            attributes: {
                                x: er,
                                y: Ke,
                                "text-anchor": n ? "start" : "middle"
                            }
                        });
                    }
                }
                function Ct() {
                    if (n && !Ae || !n && Ae) {
                        var er = Ee.position || 0, Ke = Ee._offset + Ee._length / 2, xt, bt;
                        if (M === "right") bt = Ke, xt = A.l + re * er + 10 + nt * (Ee.showticklabels ? 1 : .5);
                        else if (xt = Ke, M === "bottom" && (bt = A.t + ae * er + 10 + (Ge.indexOf("inside") === -1 ? Ee.tickfont.size : 0) + (Ee.ticks !== "intside" && t.ticklen || 0)), M === "top") {
                            var Lt = C.text.split("<br>").length;
                            bt = A.t + ae * er + 10 - X - _me * nt * Lt;
                        }
                        Rt((n ? "h" : "v") + Ee._id + "title", {
                            avoid: {
                                selection: T_.select(r).selectAll("g." + Ee._id + "tick"),
                                side: M,
                                offsetTop: n ? 0 : A.t,
                                offsetLeft: n ? A.l : 0,
                                maxShift: n ? k.width : k.height
                            },
                            attributes: {
                                x: xt,
                                y: bt,
                                "text-anchor": "middle"
                            },
                            transform: {
                                rotate: n ? -90 : 0,
                                offset: 0
                            }
                        });
                    }
                }
                function Yt() {
                    if (!n && !Ae || n && Ae) {
                        var er = e.select("." + Vc.cbtitle), Ke = er.select("text"), xt = [
                            -l / 2,
                            l / 2
                        ], bt = er.select(".h" + Ee._id + "title-math-group").node(), Lt = 15.6;
                        Ke.node() && (Lt = parseInt(Ke.node().style.fontSize, 10) * _me);
                        var St;
                        if (bt ? (St = Ng.bBox(bt), ot = St.width, rt = St.height, rt > Lt && (xt[1] -= (rt - Lt) / 2)) : Ke.node() && !Ke.classed(Vc.jsPlaceholder) && (St = Ng.bBox(Ke.node()), ot = St.width, rt = St.height), n) {
                            if (rt) {
                                if (rt += 5, M === "top") Ee.domain[1] -= rt / A.h, xt[1] *= -1;
                                else {
                                    Ee.domain[0] += rt / A.h;
                                    var Et = tmt.lineCount(Ke);
                                    xt[1] += (1 - Et) * Lt;
                                }
                                er.attr("transform", Ug(xt[0], xt[1])), Ee.setScale();
                            }
                        } else ot && (M === "right" && (Ee.domain[0] += (ot + nt / 2) / A.w), er.attr("transform", Ug(xt[0], xt[1])), Ee.setScale());
                    }
                    e.selectAll("." + Vc.cbfills + ",." + Vc.cblines).attr("transform", n ? Ug(0, Math.round(A.h * (1 - Ee.domain[1]))) : Ug(Math.round(A.w * Ee.domain[0]), 0)), ct.attr("transform", n ? Ug(0, Math.round(-A.t)) : Ug(Math.round(-A.l), 0));
                    var dt = e.select("." + Vc.cbfills).selectAll("rect." + Vc.cbfill).attr("style", "").data(V);
                    dt.enter().append("rect").classed(Vc.cbfill, !0).attr("style", ""), dt.exit().remove();
                    var Ht = g.map(Ee.c2p).map(Math.round).sort(function(Or, Nr) {
                        return Or - Nr;
                    });
                    dt.each(function(Or, Nr) {
                        var ut = [
                            Nr === 0 ? g[0] : (V[Nr] + V[Nr - 1]) / 2,
                            Nr === V.length - 1 ? g[1] : (V[Nr] + V[Nr + 1]) / 2
                        ].map(Ee.c2p).map(Math.round);
                        n && (ut[1] = B0.constrain(ut[1] + (ut[1] > ut[0]) ? 1 : -1, Ht[0], Ht[1]));
                        var Ne = T_.select(this).attr(n ? "x" : "y", _e).attr(n ? "y" : "x", T_.min(ut)).attr(n ? "width" : "height", Math.max(X, 2)).attr(n ? "height" : "width", Math.max(T_.max(ut) - T_.min(ut), 2));
                        if (t._fillgradient) Ng.gradient(Ne, r, t._id, n ? "vertical" : "horizontalreversed", t._fillgradient, "fill");
                        else {
                            var Ye = T(Or).replace("e-", "");
                            Ne.attr("fill", uV(Ye).toHexString());
                        }
                    });
                    var $t = e.select("." + Vc.cblines).selectAll("path." + Vc.cbline).data(_.color && _.width ? H : []);
                    $t.enter().append("path").classed(Vc.cbline, !0), $t.exit().remove(), $t.each(function(Or) {
                        var Nr = _e, ut = Math.round(Ee.c2p(Or)) + _.width / 2 % 1;
                        T_.select(this).attr("d", "M" + (n ? Nr + "," + ut : ut + "," + Nr) + (n ? "h" : "v") + X).call(Ng.lineGroupStyle, _.width, P(Or), _.dash);
                    }), ct.selectAll("g." + Ee._id + "tick,path").remove();
                    var fr = _e + X + (l || 0) / 2 - (t.ticks === "outside" ? 1 : 0), _r = Ry.calcTicks(Ee), Br = Ry.getTickSigns(Ee)[2];
                    return Ry.drawTicks(r, Ee, {
                        vals: Ee.ticks === "inside" ? Ry.clipEnds(Ee, _r) : _r,
                        layer: ct,
                        path: Ry.makeTickPath(Ee, fr, Br),
                        transFn: Ry.makeTransTickFn(Ee)
                    }), Ry.drawLabels(r, Ee, {
                        vals: _r,
                        layer: ct,
                        transFn: Ry.makeTransTickLabelFn(Ee),
                        labelFns: Ry.makeLabelFns(Ee, fr)
                    });
                }
                function xr() {
                    var er, Ke = X + l / 2;
                    Ge.indexOf("inside") === -1 && (er = Ng.bBox(ct.node()), Ke += n ? er.width : er.height), qt = ce.select("text");
                    var xt = 0, bt = n && M === "top", Lt = !n && M === "right", St = 0;
                    if (qt.node() && !qt.classed(Vc.jsPlaceholder)) {
                        var Et, dt = ce.select(".h" + Ee._id + "title-math-group").node();
                        dt && (n && Ae || !n && !Ae) ? (er = Ng.bBox(dt), xt = er.width, Et = er.height) : (er = Ng.bBox(ce.node()), xt = er.right - A.l - (n ? _e : Te), Et = er.bottom - A.t - (n ? Te : _e), !n && M === "top" && (Ke += er.height, St = er.height)), Lt && (qt.attr("transform", Ug(xt / 2 + nt / 2, 0)), xt *= 2), Ke = Math.max(Ke, n ? xt : Et);
                    }
                    var Ht = (n ? d : v) * 2 + Ke + u + l / 2, $t = 0;
                    !n && C.text && h === "bottom" && b <= 0 && ($t = Ht / 2, Ht += $t, St += $t), k._hColorbarMoveTitle = $t, k._hColorbarMoveCBTitle = St;
                    var fr = u + l, _r = (n ? _e : Te) - fr / 2 - (n ? d : 0), Br = (n ? Te : _e) - (n ? N : v + St - $t);
                    e.select("." + Vc.cbbg).attr("x", _r).attr("y", Br).attr(n ? "width" : "height", Math.max(Ht - $t, 2)).attr(n ? "height" : "width", Math.max(N + fr, 2)).call(fV.fill, c).call(fV.stroke, t.bordercolor).style("stroke-width", u);
                    var Or = Lt ? Math.max(xt - 10, 0) : 0;
                    e.selectAll("." + Vc.cboutline).attr("x", (n ? _e : Te + d) + Or).attr("y", (n ? Te + v - N : _e) + (bt ? rt : 0)).attr(n ? "width" : "height", Math.max(X, 2)).attr(n ? "height" : "width", Math.max(N - (n ? 2 * v + rt : 2 * d + Or), 2)).call(fV.stroke, t.outlinecolor).style({
                        fill: "none",
                        "stroke-width": l
                    });
                    var Nr = n ? Me * Ht : 0, ut = n ? 0 : (1 - ke) * Ht - St;
                    if (Nr = E ? A.l - Nr : -Nr, ut = p ? A.t - ut : -ut, e.attr("transform", Ug(Nr, ut)), !n && (u || uV(c).getAlpha() && !uV.equals(k.paper_bgcolor, c))) {
                        var Ne = ct.selectAll("text"), Ye = Ne[0].length, Ve = e.select("." + Vc.cbbg).node(), Xe = Ng.bBox(Ve), ht = Ng.getTranslate(e), Le = 2;
                        Ne.each(function(ri, bi) {
                            var nn = 0, Wi = Ye - 1;
                            if (bi === nn || bi === Wi) {
                                var Ni = Ng.bBox(this), _n = Ng.getTranslate(this), $i;
                                if (bi === Wi) {
                                    var zn = Ni.right + _n.x, Wn = Xe.right + ht.x + Te - u - Le + x;
                                    $i = Wn - zn, $i > 0 && ($i = 0);
                                } else if (bi === nn) {
                                    var It = Ni.left + _n.x, ft = Xe.left + ht.x + Te + u + Le;
                                    $i = ft - It, $i < 0 && ($i = 0);
                                }
                                $i && (Ye < 3 ? this.setAttribute("transform", "translate(" + $i + ",0) " + this.getAttribute("transform")) : this.setAttribute("visibility", "hidden"));
                            }
                        });
                    }
                    var xe = {}, Se = xme[f], lt = bme[f], Gt = xme[h], Vt = bme[h], ar = Ht - X;
                    n ? (a === "pixels" ? (xe.y = b, xe.t = N * Gt, xe.b = N * Vt) : (xe.t = xe.b = 0, xe.yt = b + i * Gt, xe.yb = b - i * Vt), s === "pixels" ? (xe.x = x, xe.l = Ht * Se, xe.r = Ht * lt) : (xe.l = ar * Se, xe.r = ar * lt, xe.xl = x - o * Se, xe.xr = x + o * lt)) : (a === "pixels" ? (xe.x = x, xe.l = N * Se, xe.r = N * lt) : (xe.l = xe.r = 0, xe.xl = x + i * Se, xe.xr = x - i * lt), s === "pixels" ? (xe.y = 1 - b, xe.t = Ht * Gt, xe.b = Ht * Vt) : (xe.t = ar * Gt, xe.b = ar * Vt, xe.yt = b - o * Gt, xe.yb = b + o * Vt));
                    var Qr = t.y < .5 ? "b" : "t", ai = t.x < .5 ? "l" : "r";
                    r._fullLayout._reservedMargin[t._id] = {};
                    var jr = {
                        r: k.width - _r - Nr,
                        l: _r + xe.r,
                        b: k.height - Br - ut,
                        t: Br + xe.b
                    };
                    E && p ? II.autoMargin(r, t._id, xe) : E ? r._fullLayout._reservedMargin[t._id][Qr] = jr[Qr] : p || n ? r._fullLayout._reservedMargin[t._id][ai] = jr[ai] : r._fullLayout._reservedMargin[t._id][Qr] = jr[Qr];
                }
                return B0.syncOrAsync([
                    II.previousPromises,
                    kt,
                    Yt,
                    Ct,
                    II.previousPromises,
                    xr
                ], r);
            }
            function umt(e, t, r) {
                var n = t.orientation === "v", i = r._fullLayout, a = i._size, o, s, l;
                PI.init({
                    element: e.node(),
                    gd: r,
                    prepFn: function() {
                        o = e.attr("transform"), cV(e);
                    },
                    moveFn: function(u, c) {
                        e.attr("transform", o + Ug(u, c)), s = PI.align((n ? t._uFrac : t._vFrac) + u / a.w, n ? t._thickFrac : t._lenFrac, 0, 1, t.xanchor), l = PI.align((n ? t._vFrac : 1 - t._uFrac) - c / a.h, n ? t._lenFrac : t._thickFrac, 0, 1, t.yanchor);
                        var f = PI.getCursor(s, l, t.xanchor, t.yanchor);
                        cV(e, f);
                    },
                    doneFn: function() {
                        if (cV(e), s !== void 0 && l !== void 0) {
                            var u = {};
                            u[t._propPrefix + "x"] = s, u[t._propPrefix + "y"] = l, t._traceIndex !== void 0 ? yme.call("_guiRestyle", r, u, t._traceIndex) : yme.call("_guiRelayout", r, u);
                        }
                    }
                });
            }
            function cmt(e, t, r) {
                var n = t._levels, i = [], a = [], o, s, l = n.end + n.size / 100, u = n.size, c = 1.001 * r[0] - .001 * r[1], f = 1.001 * r[1] - .001 * r[0];
                for(s = 0; s < 1e5 && (o = n.start + s * u, !(u > 0 ? o >= l : o <= l)); s++)o > c && o < f && i.push(o);
                if (t._fillgradient) a = [
                    0
                ];
                else if (typeof t._fillcolor == "function") {
                    var h = t._filllevels;
                    if (h) for(l = h.end + h.size / 100, u = h.size, s = 0; s < 1e5 && (o = h.start + s * u, !(u > 0 ? o >= l : o <= l)); s++)o > r[0] && o < r[1] && a.push(o);
                    else a = i.map(function(d) {
                        return d - n.size / 2;
                    }), a.push(a[a.length - 1] + n.size);
                } else t._fillcolor && typeof t._fillcolor == "string" && (a = [
                    0
                ]);
                return n.size < 0 && (i.reverse(), a.reverse()), {
                    line: i,
                    fill: a
                };
            }
            function fmt(e, t, r) {
                var n = e._fullLayout, i = t.orientation === "v", a = {
                    type: "linear",
                    range: r,
                    tickmode: t.tickmode,
                    nticks: t.nticks,
                    tick0: t.tick0,
                    dtick: t.dtick,
                    tickvals: t.tickvals,
                    ticktext: t.ticktext,
                    ticks: t.ticks,
                    ticklen: t.ticklen,
                    tickwidth: t.tickwidth,
                    tickcolor: t.tickcolor,
                    showticklabels: t.showticklabels,
                    labelalias: t.labelalias,
                    ticklabelposition: t.ticklabelposition,
                    ticklabeloverflow: t.ticklabeloverflow,
                    ticklabelstep: t.ticklabelstep,
                    tickfont: t.tickfont,
                    tickangle: t.tickangle,
                    tickformat: t.tickformat,
                    exponentformat: t.exponentformat,
                    minexponent: t.minexponent,
                    separatethousands: t.separatethousands,
                    showexponent: t.showexponent,
                    showtickprefix: t.showtickprefix,
                    tickprefix: t.tickprefix,
                    showticksuffix: t.showticksuffix,
                    ticksuffix: t.ticksuffix,
                    title: t.title,
                    showline: !0,
                    anchor: "free",
                    side: i ? "right" : "bottom",
                    position: 1
                }, o = i ? "y" : "x", s = {
                    type: "linear",
                    _id: o + t._id
                }, l = {
                    letter: o,
                    font: n.font,
                    noAutotickangles: o === "y",
                    noHover: !0,
                    noTickson: !0,
                    noTicklabelmode: !0,
                    noInsideRange: !0,
                    calendar: n.calendar
                };
                function u(c, f) {
                    return B0.coerce(a, s, amt, c, f);
                }
                return imt(a, s, u, l, n), nmt(a, s, u, l), s;
            }
            Tme.exports = {
                draw: omt
            };
        });
        var Mme = ye((cor, Sme)=>{
            "use strict";
            Sme.exports = {
                moduleType: "component",
                name: "colorbar",
                attributes: K6(),
                supplyDefaults: SO(),
                draw: Ame().draw,
                hasColorbar: yO()
            };
        });
        var kme = ye((hor, Eme)=>{
            "use strict";
            Eme.exports = {
                moduleType: "component",
                name: "legend",
                layoutAttributes: yB(),
                supplyLayoutDefaults: bB(),
                draw: RB(),
                style: CB()
            };
        });
        var Lme = ye((dor, Cme)=>{
            "use strict";
            Cme.exports = {
                moduleType: "locale",
                name: "en",
                dictionary: {
                    "Click to enter Colorscale title": "Click to enter Colourscale title"
                },
                format: {
                    days: [
                        "Sunday",
                        "Monday",
                        "Tuesday",
                        "Wednesday",
                        "Thursday",
                        "Friday",
                        "Saturday"
                    ],
                    shortDays: [
                        "Sun",
                        "Mon",
                        "Tue",
                        "Wed",
                        "Thu",
                        "Fri",
                        "Sat"
                    ],
                    months: [
                        "January",
                        "February",
                        "March",
                        "April",
                        "May",
                        "June",
                        "July",
                        "August",
                        "September",
                        "October",
                        "November",
                        "December"
                    ],
                    shortMonths: [
                        "Jan",
                        "Feb",
                        "Mar",
                        "Apr",
                        "May",
                        "Jun",
                        "Jul",
                        "Aug",
                        "Sep",
                        "Oct",
                        "Nov",
                        "Dec"
                    ],
                    periods: [
                        "AM",
                        "PM"
                    ],
                    dateTime: "%a %b %e %X %Y",
                    date: "%d/%m/%Y",
                    time: "%H:%M:%S",
                    decimal: ".",
                    thousands: ",",
                    grouping: [
                        3
                    ],
                    currency: [
                        "$",
                        ""
                    ],
                    year: "%Y",
                    month: "%b %Y",
                    dayMonth: "%b %-d",
                    dayMonthYear: "%b %-d, %Y"
                }
            };
        });
        var Ime = ye((vor, Pme)=>{
            "use strict";
            Pme.exports = {
                moduleType: "locale",
                name: "en-US",
                dictionary: {
                    "Click to enter Colorscale title": "Click to enter Colorscale title"
                },
                format: {
                    date: "%m/%d/%Y"
                }
            };
        });
        var vV = ye((por, Fme)=>{
            "use strict";
            var hmt = ba(), zme = Mr(), dV = zme.extendFlat, Rme = zme.extendDeep;
            function Dme(e) {
                var t;
                switch(e){
                    case "themes__thumb":
                        t = {
                            autosize: !0,
                            width: 150,
                            height: 150,
                            title: {
                                text: ""
                            },
                            showlegend: !1,
                            margin: {
                                l: 5,
                                r: 5,
                                t: 5,
                                b: 5,
                                pad: 0
                            },
                            annotations: []
                        };
                        break;
                    case "thumbnail":
                        t = {
                            title: {
                                text: ""
                            },
                            hidesources: !0,
                            showlegend: !1,
                            borderwidth: 0,
                            bordercolor: "",
                            margin: {
                                l: 1,
                                r: 1,
                                t: 1,
                                b: 1,
                                pad: 0
                            },
                            annotations: []
                        };
                        break;
                    default:
                        t = {};
                }
                return t;
            }
            function dmt(e) {
                var t = [
                    "xaxis",
                    "yaxis",
                    "zaxis"
                ];
                return t.indexOf(e.slice(0, 5)) > -1;
            }
            Fme.exports = function(t, r) {
                var n, i = t.data, a = t.layout, o = Rme([], i), s = Rme({}, a, Dme(r.tileClass)), l = t._context || {};
                if (r.width && (s.width = r.width), r.height && (s.height = r.height), r.tileClass === "thumbnail" || r.tileClass === "themes__thumb") {
                    s.annotations = [];
                    var u = Object.keys(s);
                    for(n = 0; n < u.length; n++)dmt(u[n]) && (s[u[n]].title = {
                        text: ""
                    });
                    for(n = 0; n < o.length; n++){
                        var c = o[n];
                        c.showscale = !1, c.marker && (c.marker.showscale = !1), hmt.traceIs(c, "pie-like") && (c.textposition = "none");
                    }
                }
                if (Array.isArray(r.annotations)) for(n = 0; n < r.annotations.length; n++)s.annotations.push(r.annotations[n]);
                var f = Object.keys(s).filter(function(b) {
                    return b.match(/^scene\d*$/);
                });
                if (f.length) {
                    var h = {};
                    for(r.tileClass === "thumbnail" && (h = {
                        title: {
                            text: ""
                        },
                        showaxeslabels: !1,
                        showticklabels: !1,
                        linetickenable: !1
                    }), n = 0; n < f.length; n++){
                        var d = s[f[n]];
                        d.xaxis || (d.xaxis = {}), d.yaxis || (d.yaxis = {}), d.zaxis || (d.zaxis = {}), dV(d.xaxis, h), dV(d.yaxis, h), dV(d.zaxis, h), d._scene = null;
                    }
                }
                var v = document.createElement("div");
                r.tileClass && (v.className = r.tileClass);
                var x = {
                    gd: v,
                    td: v,
                    layout: s,
                    data: o,
                    config: {
                        staticPlot: r.staticPlot === void 0 ? !0 : r.staticPlot,
                        plotGlPixelRatio: r.plotGlPixelRatio === void 0 ? 2 : r.plotGlPixelRatio,
                        displaylogo: r.displaylogo || !1,
                        showLink: r.showLink || !1,
                        showTips: r.showTips || !1,
                        mapboxAccessToken: l.mapboxAccessToken
                    }
                };
                return r.setBackground !== "transparent" && (x.config.setBackground = r.setBackground || "opaque"), x.gd.defaultLayout = Dme(r.tileClass), x;
            };
        });
        var Bme = ye((gor, Ome)=>{
            "use strict";
            var vmt = vb().EventEmitter, pmt = ba(), gmt = Mr(), qme = Ly(), mmt = vV(), ymt = BP(), _mt = NP();
            function xmt(e, t) {
                var r = new vmt, n = mmt(e, {
                    format: "png"
                }), i = n.gd;
                i.style.position = "absolute", i.style.left = "-5000px", document.body.appendChild(i);
                function a() {
                    var s = qme.getDelay(i._fullLayout);
                    setTimeout(function() {
                        var l = ymt(i), u = document.createElement("canvas");
                        u.id = gmt.randstr(), r = _mt({
                            format: t.format,
                            width: i._fullLayout.width,
                            height: i._fullLayout.height,
                            canvas: u,
                            emitter: r,
                            svg: l
                        }), r.clean = function() {
                            i && document.body.removeChild(i);
                        };
                    }, s);
                }
                var o = qme.getRedrawFunc(i);
                return pmt.call("_doPlot", i, n.data, n.layout, n.config).then(o).then(a).catch(function(s) {
                    r.emit("error", s);
                }), r;
            }
            Ome.exports = xmt;
        });
        var Vme = ye((mor, Ume)=>{
            "use strict";
            var Nme = Ly(), bmt = {
                getDelay: Nme.getDelay,
                getRedrawFunc: Nme.getRedrawFunc,
                clone: vV(),
                toSVG: BP(),
                svgToImg: NP(),
                toImage: Bme(),
                downloadImage: YN()
            };
            Ume.exports = bmt;
        });
        var Gme = ye((Dy)=>{
            "use strict";
            Dy.version = e6().version;
            iee();
            Wie();
            var wmt = ba(), u4 = Dy.register = wmt.register, gV = hde(), Hme = Object.keys(gV);
            for(RI = 0; RI < Hme.length; RI++)_T = Hme[RI], _T.charAt(0) !== "_" && (Dy[_T] = gV[_T]), u4({
                moduleType: "apiMethod",
                name: _T,
                fn: gV[_T]
            });
            var _T, RI;
            u4(ope());
            u4([
                Ppe(),
                Gpe(),
                wf(),
                l0e(),
                b0e(),
                H0e(),
                uge(),
                kge(),
                Wge(),
                nV(),
                pme(),
                Mu(),
                Mme(),
                kme(),
                Nc(),
                nN()
            ]);
            u4([
                Lme(),
                Ime()
            ]);
            window.PlotlyLocales && Array.isArray(window.PlotlyLocales) && (u4(window.PlotlyLocales), delete window.PlotlyLocales);
            Dy.Icons = UL();
            var DI = Nc(), pV = Xu();
            Dy.Plots = {
                resize: pV.resize,
                graphJson: pV.graphJson,
                sendDataToCloud: pV.sendDataToCloud
            };
            Dy.Fx = {
                hover: DI.hover,
                unhover: DI.unhover,
                loneHover: DI.loneHover,
                loneUnhover: DI.loneUnhover
            };
            Dy.Snapshot = Vme();
            Dy.PlotSchema = _3();
        });
        var Wme = ye((_or, jme)=>{
            "use strict";
            jme.exports = Gme();
        });
        var Qb = ye((xor, Zme)=>{
            "use strict";
            Zme.exports = {
                TEXTPAD: 3,
                eventDataKeys: [
                    "value",
                    "label"
                ]
            };
        });
        var Lm = ye((bor, Jme)=>{
            "use strict";
            var Tf = Uc(), Xme = Oc().axisHoverFormat, Tmt = Wo().hovertemplateAttrs, Amt = Wo().texttemplateAttrs, Kme = Jl(), Smt = Su(), Yme = Qb(), Mmt = Ed().pattern, e2 = no().extendFlat, mV = Smt({
                editType: "calc",
                arrayOk: !0,
                colorEditType: "style"
            }), Emt = Tf.marker, kmt = Emt.line, Cmt = e2({}, kmt.width, {
                dflt: 0
            }), Lmt = e2({
                width: Cmt,
                editType: "calc"
            }, Kme("marker.line")), Pmt = e2({
                line: Lmt,
                editType: "calc"
            }, Kme("marker"), {
                opacity: {
                    valType: "number",
                    arrayOk: !0,
                    dflt: 1,
                    min: 0,
                    max: 1,
                    editType: "style"
                },
                pattern: Mmt,
                cornerradius: {
                    valType: "any",
                    editType: "calc"
                }
            });
            Jme.exports = {
                x: Tf.x,
                x0: Tf.x0,
                dx: Tf.dx,
                y: Tf.y,
                y0: Tf.y0,
                dy: Tf.dy,
                xperiod: Tf.xperiod,
                yperiod: Tf.yperiod,
                xperiod0: Tf.xperiod0,
                yperiod0: Tf.yperiod0,
                xperiodalignment: Tf.xperiodalignment,
                yperiodalignment: Tf.yperiodalignment,
                xhoverformat: Xme("x"),
                yhoverformat: Xme("y"),
                text: Tf.text,
                texttemplate: Amt({
                    editType: "plot"
                }, {
                    keys: Yme.eventDataKeys
                }),
                hovertext: Tf.hovertext,
                hovertemplate: Tmt({}, {
                    keys: Yme.eventDataKeys
                }),
                textposition: {
                    valType: "enumerated",
                    values: [
                        "inside",
                        "outside",
                        "auto",
                        "none"
                    ],
                    dflt: "auto",
                    arrayOk: !0,
                    editType: "calc"
                },
                insidetextanchor: {
                    valType: "enumerated",
                    values: [
                        "end",
                        "middle",
                        "start"
                    ],
                    dflt: "end",
                    editType: "plot"
                },
                textangle: {
                    valType: "angle",
                    dflt: "auto",
                    editType: "plot"
                },
                textfont: e2({}, mV, {}),
                insidetextfont: e2({}, mV, {}),
                outsidetextfont: e2({}, mV, {}),
                constraintext: {
                    valType: "enumerated",
                    values: [
                        "inside",
                        "outside",
                        "both",
                        "none"
                    ],
                    dflt: "both",
                    editType: "calc"
                },
                cliponaxis: e2({}, Tf.cliponaxis, {}),
                orientation: {
                    valType: "enumerated",
                    values: [
                        "v",
                        "h"
                    ],
                    editType: "calc+clearAxisTypes"
                },
                base: {
                    valType: "any",
                    dflt: null,
                    arrayOk: !0,
                    editType: "calc"
                },
                offset: {
                    valType: "number",
                    dflt: null,
                    arrayOk: !0,
                    editType: "calc"
                },
                width: {
                    valType: "number",
                    dflt: null,
                    min: 0,
                    arrayOk: !0,
                    editType: "calc"
                },
                marker: Pmt,
                offsetgroup: Tf.offsetgroup,
                alignmentgroup: Tf.alignmentgroup,
                selected: {
                    marker: {
                        opacity: Tf.selected.marker.opacity,
                        color: Tf.selected.marker.color,
                        editType: "style"
                    },
                    textfont: Tf.selected.textfont,
                    editType: "style"
                },
                unselected: {
                    marker: {
                        opacity: Tf.unselected.marker.opacity,
                        color: Tf.unselected.marker.color,
                        editType: "style"
                    },
                    textfont: Tf.unselected.textfont,
                    editType: "style"
                },
                zorder: Tf.zorder
            };
        });
        var zI = ye((wor, $me)=>{
            "use strict";
            $me.exports = {
                barmode: {
                    valType: "enumerated",
                    values: [
                        "stack",
                        "group",
                        "overlay",
                        "relative"
                    ],
                    dflt: "group",
                    editType: "calc"
                },
                barnorm: {
                    valType: "enumerated",
                    values: [
                        "",
                        "fraction",
                        "percent"
                    ],
                    dflt: "",
                    editType: "calc"
                },
                bargap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: "calc"
                },
                bargroupgap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 0,
                    editType: "calc"
                },
                barcornerradius: {
                    valType: "any",
                    editType: "calc"
                }
            };
        });
        var FI = ye((Tor, tye)=>{
            "use strict";
            var Imt = va(), Qme = Dv().hasColorscale, eye = Uh(), Rmt = Mr().coercePattern;
            tye.exports = function(t, r, n, i, a) {
                var o = n("marker.color", i), s = Qme(t, "marker");
                s && eye(t, r, a, n, {
                    prefix: "marker.",
                    cLetter: "c"
                }), n("marker.line.color", Imt.defaultLine), Qme(t, "marker.line") && eye(t, r, a, n, {
                    prefix: "marker.line.",
                    cLetter: "c"
                }), n("marker.line.width"), n("marker.opacity"), Rmt(n, "marker.pattern", o, s), n("selected.marker.color"), n("unselected.marker.color");
            };
        });
        var r0 = ye((Aor, sye)=>{
            "use strict";
            var rye = uo(), xT = Mr(), iye = va(), Dmt = ba(), zmt = K3(), Fmt = Pg(), qmt = FI(), Omt = Hb(), nye = Lm(), qI = xT.coerceFont;
            function Bmt(e, t, r, n) {
                function i(u, c) {
                    return xT.coerce(e, t, nye, u, c);
                }
                var a = zmt(e, t, n, i);
                if (!a) {
                    t.visible = !1;
                    return;
                }
                Fmt(e, t, n, i), i("xhoverformat"), i("yhoverformat"), i("zorder"), i("orientation", t.x && !t.y ? "h" : "v"), i("base"), i("offset"), i("width"), i("text"), i("hovertext"), i("hovertemplate");
                var o = i("textposition");
                oye(e, t, n, i, o, {
                    moduleHasSelected: !0,
                    moduleHasUnselected: !0,
                    moduleHasConstrain: !0,
                    moduleHasCliponaxis: !0,
                    moduleHasTextangle: !0,
                    moduleHasInsideanchor: !0
                }), qmt(e, t, i, r, n);
                var s = (t.marker.line || {}).color, l = Dmt.getComponentMethod("errorbars", "supplyDefaults");
                l(e, t, s || iye.defaultLine, {
                    axis: "y"
                }), l(e, t, s || iye.defaultLine, {
                    axis: "x",
                    inherit: "y"
                }), xT.coerceSelectionMarkerOpacity(t, i);
            }
            function Nmt(e, t) {
                var r, n;
                function i(s, l) {
                    return xT.coerce(n._input, n, nye, s, l);
                }
                for(var a = 0; a < e.length; a++)if (n = e[a], n.type === "bar") {
                    r = n._input;
                    var o = i("marker.cornerradius", t.barcornerradius);
                    n.marker && (n.marker.cornerradius = aye(o)), Omt(r, n, t, i, t.barmode);
                }
            }
            function aye(e) {
                if (rye(e)) {
                    if (e = +e, e >= 0) return e;
                } else if (typeof e == "string" && (e = e.trim(), e.slice(-1) === "%" && rye(e.slice(0, -1)) && (e = +e.slice(0, -1), e >= 0))) return e + "%";
            }
            function oye(e, t, r, n, i, a) {
                a = a || {};
                var o = a.moduleHasSelected !== !1, s = a.moduleHasUnselected !== !1, l = a.moduleHasConstrain !== !1, u = a.moduleHasCliponaxis !== !1, c = a.moduleHasTextangle !== !1, f = a.moduleHasInsideanchor !== !1, h = !!a.hasPathbar, d = Array.isArray(i) || i === "auto", v = d || i === "inside", x = d || i === "outside";
                if (v || x) {
                    var b = qI(n, "textfont", r.font), p = xT.extendFlat({}, b), E = e.textfont && e.textfont.color, k = !E;
                    if (k && delete p.color, qI(n, "insidetextfont", p), h) {
                        var A = xT.extendFlat({}, b);
                        k && delete A.color, qI(n, "pathbar.textfont", A);
                    }
                    x && qI(n, "outsidetextfont", b), o && n("selected.textfont.color"), s && n("unselected.textfont.color"), l && n("constraintext"), u && n("cliponaxis"), c && n("textangle"), n("texttemplate");
                }
                v && f && n("insidetextanchor");
            }
            sye.exports = {
                supplyDefaults: Bmt,
                crossTraceDefaults: Nmt,
                handleText: oye,
                validateCornerradius: aye
            };
        });
        var yV = ye((Sor, lye)=>{
            "use strict";
            var Umt = ba(), Vmt = Qa(), Hmt = Mr(), Gmt = zI(), jmt = r0().validateCornerradius;
            lye.exports = function(e, t, r) {
                function n(x, b) {
                    return Hmt.coerce(e, t, Gmt, x, b);
                }
                for(var i = !1, a = !1, o = !1, s = {}, l = n("barmode"), u = l === "group", c = 0; c < r.length; c++){
                    var f = r[c];
                    if (Umt.traceIs(f, "bar") && f.visible) i = !0;
                    else continue;
                    var h = f.xaxis + f.yaxis;
                    if (u ? (s[h] && (o = !0), s[h] = !0) : (h += f._input.offsetgroup, s.length > 0 && !s[h] && (o = !0), s[h] = !0), f.visible && f.type === "histogram") {
                        var d = Vmt.getFromId({
                            _fullLayout: t
                        }, f[f.orientation === "v" ? "xaxis" : "yaxis"]);
                        d.type !== "category" && (a = !0);
                    }
                }
                if (!i) {
                    delete t.barmode;
                    return;
                }
                l !== "overlay" && n("barnorm"), n("bargap", a && !o ? 0 : .2), n("bargroupgap");
                var v = n("barcornerradius");
                t.barcornerradius = jmt(v);
            };
        });
        var c4 = ye((Mor, uye)=>{
            "use strict";
            var bT = Mr();
            uye.exports = function(t, r) {
                for(var n = 0; n < t.length; n++)t[n].i = n;
                bT.mergeArray(r.text, t, "tx"), bT.mergeArray(r.hovertext, t, "htx");
                var i = r.marker;
                if (i) {
                    bT.mergeArray(i.opacity, t, "mo", !0), bT.mergeArray(i.color, t, "mc");
                    var a = i.line;
                    a && (bT.mergeArray(a.color, t, "mlc"), bT.mergeArrayCastPositive(a.width, t, "mlw"));
                }
            };
        });
        var pye = ye((Eor, vye)=>{
            "use strict";
            var cye = Qa(), fye = Rg(), hye = Dv().hasColorscale, dye = zv(), Wmt = c4(), Zmt = F0();
            vye.exports = function(t, r) {
                var n = cye.getFromId(t, r.xaxis || "x"), i = cye.getFromId(t, r.yaxis || "y"), a, o, s, l, u, c, f = {
                    msUTC: !!(r.base || r.base === 0)
                };
                r.orientation === "h" ? (a = n.makeCalcdata(r, "x", f), s = i.makeCalcdata(r, "y"), l = fye(r, i, "y", s), u = !!r.yperiodalignment, c = "y") : (a = i.makeCalcdata(r, "y", f), s = n.makeCalcdata(r, "x"), l = fye(r, n, "x", s), u = !!r.xperiodalignment, c = "x"), o = l.vals;
                for(var h = Math.min(o.length, a.length), d = new Array(h), v = 0; v < h; v++)d[v] = {
                    p: o[v],
                    s: a[v]
                }, u && (d[v].orig_p = s[v], d[v][c + "End"] = l.ends[v], d[v][c + "Start"] = l.starts[v]), r.ids && (d[v].id = String(r.ids[v]));
                return hye(r, "marker") && dye(t, r, {
                    vals: r.marker.color,
                    containerStr: "marker",
                    cLetter: "c"
                }), hye(r, "marker.line") && dye(t, r, {
                    vals: r.marker.line.color,
                    containerStr: "marker.line",
                    cLetter: "c"
                }), Wmt(d, r), Zmt(d, r), d;
            };
        });
        var _v = ye((kor, mye)=>{
            "use strict";
            var Xmt = xa(), Ymt = Mr();
            function Kmt(e, t, r) {
                var n = e._fullLayout, i = n["_" + r + "Text_minsize"];
                if (i) {
                    var a = n.uniformtext.mode === "hide", o;
                    switch(r){
                        case "funnelarea":
                        case "pie":
                        case "sunburst":
                            o = "g.slice";
                            break;
                        case "treemap":
                        case "icicle":
                            o = "g.slice, g.pathbar";
                            break;
                        default:
                            o = "g.points > g.point";
                    }
                    t.selectAll(o).each(function(s) {
                        var l = s.transform;
                        if (l) {
                            l.scale = a && l.hide ? 0 : i / l.fontSize;
                            var u = Xmt.select(this).select("text");
                            Ymt.setTransormAndDisplay(u, l);
                        }
                    });
                }
            }
            function Jmt(e, t, r) {
                if (r.uniformtext.mode) {
                    var n = gye(e), i = r.uniformtext.minsize, a = t.scale * t.fontSize;
                    t.hide = a < i, r[n] = r[n] || 1 / 0, t.hide || (r[n] = Math.min(r[n], Math.max(a, i)));
                }
            }
            function $mt(e, t) {
                var r = gye(e);
                t[r] = void 0;
            }
            function gye(e) {
                return "_" + e + "Text_minsize";
            }
            mye.exports = {
                recordMinTextSize: Jmt,
                clearMinTextSize: $mt,
                resizeText: Kmt
            };
        });
        var OI = ye((t2)=>{
            "use strict";
            var Qmt = uo(), eyt = id(), yye = Mr().isArrayOrTypedArray;
            t2.coerceString = function(e, t, r) {
                if (typeof t == "string") {
                    if (t || !e.noBlank) return t;
                } else if ((typeof t == "number" || t === !0) && !e.strict) return String(t);
                return r !== void 0 ? r : e.dflt;
            };
            t2.coerceNumber = function(e, t, r) {
                if (Qmt(t)) {
                    t = +t;
                    var n = e.min, i = e.max, a = n !== void 0 && t < n || i !== void 0 && t > i;
                    if (!a) return t;
                }
                return r !== void 0 ? r : e.dflt;
            };
            t2.coerceColor = function(e, t, r) {
                return eyt(t).isValid() ? t : r !== void 0 ? r : e.dflt;
            };
            t2.coerceEnumerated = function(e, t, r) {
                return e.coerceNumber && (t = +t), e.values.indexOf(t) !== -1 ? t : r !== void 0 ? r : e.dflt;
            };
            t2.getValue = function(e, t) {
                var r;
                return yye(e) ? t < e.length && (r = e[t]) : r = e, r;
            };
            t2.getLineWidth = function(e, t) {
                var r = 0 < t.mlw ? t.mlw : yye(e.marker.line.width) ? 0 : e.marker.line.width;
                return r;
            };
        });
        var N0 = ye((Lor, Cye)=>{
            "use strict";
            var f4 = xa(), tyt = va(), h4 = ao(), _ye = Mr(), xye = ba(), bye = _v().resizeText, _V = Lm(), ryt = _V.textfont, iyt = _V.insidetextfont, nyt = _V.outsidetextfont, Jd = OI();
            function ayt(e) {
                var t = f4.select(e).selectAll('g[class^="barlayer"]').selectAll("g.trace");
                bye(e, t, "bar");
                var r = t.size(), n = e._fullLayout;
                t.style("opacity", function(i) {
                    return i[0].trace.opacity;
                }).each(function(i) {
                    (n.barmode === "stack" && r > 1 || n.bargap === 0 && n.bargroupgap === 0 && !i[0].trace.marker.line.width) && f4.select(this).attr("shape-rendering", "crispEdges");
                }), t.selectAll("g.points").each(function(i) {
                    var a = f4.select(this), o = i[0].trace;
                    wye(a, o, e);
                }), xye.getComponentMethod("errorbars", "style")(t);
            }
            function wye(e, t, r) {
                h4.pointStyle(e.selectAll("path"), t, r), Tye(e, t, r);
            }
            function Tye(e, t, r) {
                e.selectAll("text").each(function(n) {
                    var i = f4.select(this), a = _ye.ensureUniformFontSize(r, Aye(i, n, t, r));
                    h4.font(i, a);
                });
            }
            function oyt(e, t, r) {
                var n = t[0].trace;
                n.selectedpoints ? syt(r, n, e) : (wye(r, n, e), xye.getComponentMethod("errorbars", "style")(r));
            }
            function syt(e, t, r) {
                h4.selectedPointStyle(e.selectAll("path"), t), lyt(e.selectAll("text"), t, r);
            }
            function lyt(e, t, r) {
                e.each(function(n) {
                    var i = f4.select(this), a;
                    if (n.selected) {
                        a = _ye.ensureUniformFontSize(r, Aye(i, n, t, r));
                        var o = t.selected.textfont && t.selected.textfont.color;
                        o && (a.color = o), h4.font(i, a);
                    } else h4.selectedTextStyle(i, t);
                });
            }
            function Aye(e, t, r, n) {
                var i = n._fullLayout.font, a = r.textfont;
                if (e.classed("bartext-inside")) {
                    var o = kye(t, r);
                    a = Mye(r, t.i, i, o);
                } else e.classed("bartext-outside") && (a = Eye(r, t.i, i));
                return a;
            }
            function Sye(e, t, r) {
                return xV(ryt, e.textfont, t, r);
            }
            function Mye(e, t, r, n) {
                var i = Sye(e, t, r), a = e._input.textfont === void 0 || e._input.textfont.color === void 0 || Array.isArray(e.textfont.color) && e.textfont.color[t] === void 0;
                return a && (i = {
                    color: tyt.contrast(n),
                    family: i.family,
                    size: i.size,
                    weight: i.weight,
                    style: i.style,
                    variant: i.variant,
                    textcase: i.textcase,
                    lineposition: i.lineposition,
                    shadow: i.shadow
                }), xV(iyt, e.insidetextfont, t, i);
            }
            function Eye(e, t, r) {
                var n = Sye(e, t, r);
                return xV(nyt, e.outsidetextfont, t, n);
            }
            function xV(e, t, r, n) {
                t = t || {};
                var i = Jd.getValue(t.family, r), a = Jd.getValue(t.size, r), o = Jd.getValue(t.color, r), s = Jd.getValue(t.weight, r), l = Jd.getValue(t.style, r), u = Jd.getValue(t.variant, r), c = Jd.getValue(t.textcase, r), f = Jd.getValue(t.lineposition, r), h = Jd.getValue(t.shadow, r);
                return {
                    family: Jd.coerceString(e.family, i, n.family),
                    size: Jd.coerceNumber(e.size, a, n.size),
                    color: Jd.coerceColor(e.color, o, n.color),
                    weight: Jd.coerceString(e.weight, s, n.weight),
                    style: Jd.coerceString(e.style, l, n.style),
                    variant: Jd.coerceString(e.variant, u, n.variant),
                    textcase: Jd.coerceString(e.variant, c, n.textcase),
                    lineposition: Jd.coerceString(e.variant, f, n.lineposition),
                    shadow: Jd.coerceString(e.variant, h, n.shadow)
                };
            }
            function kye(e, t) {
                return t.type === "waterfall" ? t[e.dir].marker.color : e.mcc || e.mc || t.marker.color;
            }
            Cye.exports = {
                style: ayt,
                styleTextPoints: Tye,
                styleOnSelect: oyt,
                getInsideTextFont: Mye,
                getOutsideTextFont: Eye,
                getBarColor: kye,
                resizeText: bye
            };
        });
        var i2 = ye((Por, qye)=>{
            "use strict";
            var BI = xa(), NI = uo(), Pd = Mr(), uyt = Pl(), cyt = va(), A_ = ao(), fyt = ba(), UI = Qa().tickText, Lye = _v(), hyt = Lye.recordMinTextSize, dyt = Lye.clearMinTextSize, bV = N0(), wT = OI(), vyt = Qb(), Pye = Lm(), pyt = Pye.text, gyt = Pye.textposition, myt = rp().appendArrayPointValue, Uv = vyt.TEXTPAD;
            function yyt(e) {
                return e.id;
            }
            function _yt(e) {
                if (e.ids) return yyt;
            }
            function wV(e) {
                return (e > 0) - (e < 0);
            }
            function Pm(e, t) {
                return e < t ? 1 : -1;
            }
            function xyt(e, t, r, n) {
                var i = [], a = [], o = n ? t : r, s = n ? r : t;
                return i[0] = o.c2p(e.s0, !0), a[0] = s.c2p(e.p0, !0), i[1] = o.c2p(e.s1, !0), a[1] = s.c2p(e.p1, !0), n ? [
                    i,
                    a
                ] : [
                    a,
                    i
                ];
            }
            function Iye(e, t, r, n) {
                if (!t.uniformtext.mode && Rye(r)) {
                    var i;
                    return n && (i = n()), e.transition().duration(r.duration).ease(r.easing).each("end", function() {
                        i && i();
                    }).each("interrupt", function() {
                        i && i();
                    });
                } else return e;
            }
            function Rye(e) {
                return e && e.duration > 0;
            }
            function byt(e, t, r, n, i, a) {
                var o = t.xaxis, s = t.yaxis, l = e._fullLayout, u = e._context.staticPlot;
                i || (i = {
                    mode: l.barmode,
                    norm: l.barmode,
                    gap: l.bargap,
                    groupgap: l.bargroupgap
                }, dyt("bar", l));
                var c = Pd.makeTraceGroups(n, r, "trace bars").each(function(f) {
                    var h = BI.select(this), d = f[0].trace, v = f[0].t, x = d.type === "waterfall", b = d.type === "funnel", p = d.type === "histogram", E = d.type === "bar", k = E || b, A = 0;
                    x && d.connector.visible && d.connector.mode === "between" && (A = d.connector.line.width / 2);
                    var L = d.orientation === "h", _ = Rye(i), C = Pd.ensureSingle(h, "g", "points"), M = _yt(d), g = C.selectAll("g.point").data(Pd.identity, M);
                    g.enter().append("g").classed("point", !0), g.exit().remove(), g.each(function(T, F) {
                        var q = BI.select(this), V = xyt(T, o, s, L), H = V[0][0], X = V[0][1], G = V[1][0], N = V[1][1], W = (L ? X - H : N - G) === 0;
                        W && k && wT.getLineWidth(d, T) && (W = !1), W || (W = !NI(H) || !NI(X) || !NI(G) || !NI(N)), T.isBlank = W, W && (L ? X = H : N = G), A && !W && (L ? (H -= Pm(H, X) * A, X += Pm(H, X) * A) : (G -= Pm(G, N) * A, N += Pm(G, N) * A));
                        var re, ae;
                        if (d.type === "waterfall") {
                            if (!W) {
                                var _e = d[T.dir].marker;
                                re = _e.line.width, ae = _e.color;
                            }
                        } else re = wT.getLineWidth(d, T), ae = T.mc || d.marker.color;
                        function Me(Ke) {
                            var xt = BI.round(re / 2 % 1, 2);
                            return i.gap === 0 && i.groupgap === 0 ? BI.round(Math.round(Ke) - xt, 2) : Ke;
                        }
                        function ke(Ke, xt, bt) {
                            return bt && Ke === xt ? Ke : Math.abs(Ke - xt) >= 2 ? Me(Ke) : Ke > xt ? Math.ceil(Ke) : Math.floor(Ke);
                        }
                        var ge = cyt.opacity(ae), ie = ge < 1 || re > .01 ? Me : ke;
                        e._context.staticPlot || (H = ie(H, X, L), X = ie(X, H, L), G = ie(G, N, !L), N = ie(N, G, !L));
                        var Te = L ? o.c2p : s.c2p, Ee;
                        T.s0 > 0 ? Ee = T._sMax : T.s0 < 0 ? Ee = T._sMin : Ee = T.s1 > 0 ? T._sMax : T._sMin;
                        function Ae(Ke, xt) {
                            if (!Ke) return 0;
                            var bt = Math.abs(L ? N - G : X - H), Lt = Math.abs(L ? X - H : N - G), St = ie(Math.abs(Te(Ee, !0) - Te(0, !0))), Et = T.hasB ? Math.min(bt / 2, Lt / 2) : Math.min(bt / 2, St), dt;
                            if (xt === "%") {
                                var Ht = Math.min(50, Ke);
                                dt = bt * (Ht / 100);
                            } else dt = Ke;
                            return ie(Math.max(Math.min(dt, Et), 0));
                        }
                        var ze = E || p ? Ae(v.cornerradiusvalue, v.cornerradiusform) : 0, Ce, me, Re = "M" + H + "," + G + "V" + N + "H" + X + "V" + G + "Z", ce = 0;
                        if (ze && T.s) {
                            var Ge = wV(T.s0) === 0 || wV(T.s) === wV(T.s0) ? T.s1 : T.s0;
                            if (ce = ie(T.hasB ? 0 : Math.abs(Te(Ee, !0) - Te(Ge, !0))), ce < ze) {
                                var nt = Pm(H, X), ct = Pm(G, N), qt = nt === -ct ? 1 : 0;
                                if (L) {
                                    if (T.hasB) Ce = "M" + (H + ze * nt) + "," + G + "A " + ze + "," + ze + " 0 0 " + qt + " " + H + "," + (G + ze * ct) + "V" + (N - ze * ct) + "A " + ze + "," + ze + " 0 0 " + qt + " " + (H + ze * nt) + "," + N + "H" + (X - ze * nt) + "A " + ze + "," + ze + " 0 0 " + qt + " " + X + "," + (N - ze * ct) + "V" + (G + ze * ct) + "A " + ze + "," + ze + " 0 0 " + qt + " " + (X - ze * nt) + "," + G + "Z";
                                    else {
                                        me = Math.abs(X - H) + ce;
                                        var rt = me < ze ? ze - Math.sqrt(me * (2 * ze - me)) : 0, ot = ce > 0 ? Math.sqrt(ce * (2 * ze - ce)) : 0, Rt = nt > 0 ? Math.max : Math.min;
                                        Ce = "M" + H + "," + G + "V" + (N - rt * ct) + "H" + Rt(X - (ze - ce) * nt, H) + "A " + ze + "," + ze + " 0 0 " + qt + " " + X + "," + (N - ze * ct - ot) + "V" + (G + ze * ct + ot) + "A " + ze + "," + ze + " 0 0 " + qt + " " + Rt(X - (ze - ce) * nt, H) + "," + (G + rt * ct) + "Z";
                                    }
                                } else if (T.hasB) Ce = "M" + (H + ze * nt) + "," + G + "A " + ze + "," + ze + " 0 0 " + qt + " " + H + "," + (G + ze * ct) + "V" + (N - ze * ct) + "A " + ze + "," + ze + " 0 0 " + qt + " " + (H + ze * nt) + "," + N + "H" + (X - ze * nt) + "A " + ze + "," + ze + " 0 0 " + qt + " " + X + "," + (N - ze * ct) + "V" + (G + ze * ct) + "A " + ze + "," + ze + " 0 0 " + qt + " " + (X - ze * nt) + "," + G + "Z";
                                else {
                                    me = Math.abs(N - G) + ce;
                                    var kt = me < ze ? ze - Math.sqrt(me * (2 * ze - me)) : 0, Ct = ce > 0 ? Math.sqrt(ce * (2 * ze - ce)) : 0, Yt = ct > 0 ? Math.max : Math.min;
                                    Ce = "M" + (H + kt * nt) + "," + G + "V" + Yt(N - (ze - ce) * ct, G) + "A " + ze + "," + ze + " 0 0 " + qt + " " + (H + ze * nt - Ct) + "," + N + "H" + (X - ze * nt + Ct) + "A " + ze + "," + ze + " 0 0 " + qt + " " + (X - kt * nt) + "," + Yt(N - (ze - ce) * ct, G) + "V" + G + "Z";
                                }
                            } else Ce = Re;
                        } else Ce = Re;
                        var xr = Iye(Pd.ensureSingle(q, "path"), l, i, a);
                        if (xr.style("vector-effect", u ? "none" : "non-scaling-stroke").attr("d", isNaN((X - H) * (N - G)) || W && e._context.staticPlot ? "M0,0Z" : Ce).call(A_.setClipUrl, t.layerClipId, e), !l.uniformtext.mode && _) {
                            var er = A_.makePointStyleFns(d);
                            A_.singlePointStyle(T, xr, d, er, e);
                        }
                        wyt(e, t, q, f, F, H, X, G, N, ze, ce, i, a), t.layerClipId && A_.hideOutsideRangePoint(T, q.select("text"), o, s, d.xcalendar, d.ycalendar);
                    });
                    var P = d.cliponaxis === !1;
                    A_.setClipUrl(h, P ? null : t.layerClipId, e);
                });
                fyt.getComponentMethod("errorbars", "plot")(e, c, t, i);
            }
            function wyt(e, t, r, n, i, a, o, s, l, u, c, f, h) {
                var d = t.xaxis, v = t.yaxis, x = e._fullLayout, b;
                function p(me, Re, ce) {
                    var Ge = Pd.ensureSingle(me, "text").text(Re).attr({
                        class: "bartext bartext-" + b,
                        "text-anchor": "middle",
                        "data-notex": 1
                    }).call(A_.font, ce).call(uyt.convertToTspans, e);
                    return Ge;
                }
                var E = n[0].trace, k = E.orientation === "h", A = Syt(x, n, i, d, v);
                b = Myt(E, i);
                var L = f.mode === "stack" || f.mode === "relative", _ = n[i], C = !L || _._outmost, M = _.hasB, g = u && u - c > Uv;
                if (!A || b === "none" || (_.isBlank || a === o || s === l) && (b === "auto" || b === "inside")) {
                    r.select("text").remove();
                    return;
                }
                var P = x.font, T = bV.getBarColor(n[i], E), F = bV.getInsideTextFont(E, i, P, T), q = bV.getOutsideTextFont(E, i, P), V = E.insidetextanchor || "end", H = r.datum();
                k ? d.type === "log" && H.s0 <= 0 && (d.range[0] < d.range[1] ? a = 0 : a = d._length) : v.type === "log" && H.s0 <= 0 && (v.range[0] < v.range[1] ? s = v._length : s = 0);
                var X = Math.abs(o - a), G = Math.abs(l - s), N = X - 2 * Uv, W = G - 2 * Uv, re, ae, _e, Me, ke;
                if (b === "outside" && !C && !_.hasB && (b = "inside"), b === "auto") {
                    if (C) {
                        b = "inside", ke = Pd.ensureUniformFontSize(e, F), re = p(r, A, ke), ae = A_.bBox(re.node()), _e = ae.width, Me = ae.height;
                        var ge = _e > 0 && Me > 0, ie;
                        g ? M ? ie = r2(N - 2 * u, W, _e, Me, k) || r2(N, W - 2 * u, _e, Me, k) : k ? ie = r2(N - (u - c), W, _e, Me, k) || r2(N, W - 2 * (u - c), _e, Me, k) : ie = r2(N, W - (u - c), _e, Me, k) || r2(N - 2 * (u - c), W, _e, Me, k) : ie = r2(N, W, _e, Me, k), ge && ie ? b = "inside" : (b = "outside", re.remove(), re = null);
                    } else b = "inside";
                }
                if (!re) {
                    ke = Pd.ensureUniformFontSize(e, b === "outside" ? q : F), re = p(r, A, ke);
                    var Te = re.attr("transform");
                    if (re.attr("transform", ""), ae = A_.bBox(re.node()), _e = ae.width, Me = ae.height, re.attr("transform", Te), _e <= 0 || Me <= 0) {
                        re.remove();
                        return;
                    }
                }
                var Ee = E.textangle, Ae, ze;
                b === "outside" ? (ze = E.constraintext === "both" || E.constraintext === "outside", Ae = Ayt(a, o, s, l, ae, {
                    isHorizontal: k,
                    constrained: ze,
                    angle: Ee
                })) : (ze = E.constraintext === "both" || E.constraintext === "inside", Ae = Fye(a, o, s, l, ae, {
                    isHorizontal: k,
                    constrained: ze,
                    angle: Ee,
                    anchor: V,
                    hasB: M,
                    r: u,
                    overhead: c
                })), Ae.fontSize = ke.size, hyt(E.type === "histogram" ? "bar" : E.type, Ae, x), _.transform = Ae;
                var Ce = Iye(re, x, f, h);
                Pd.setTransormAndDisplay(Ce, Ae);
            }
            function r2(e, t, r, n, i) {
                if (e < 0 || t < 0) return !1;
                var a = r <= e && n <= t, o = r <= t && n <= e, s = i ? e >= r * (t / n) : t >= n * (e / r);
                return a || o || s;
            }
            function Dye(e) {
                return e === "auto" ? 0 : e;
            }
            function zye(e, t) {
                var r = Math.PI / 180 * t, n = Math.abs(Math.sin(r)), i = Math.abs(Math.cos(r));
                return {
                    x: e.width * i + e.height * n,
                    y: e.width * n + e.height * i
                };
            }
            function Fye(e, t, r, n, i, a) {
                var o = !!a.isHorizontal, s = !!a.constrained, l = a.angle || 0, u = a.anchor, c = u === "end", f = u === "start", h = a.leftToRight || 0, d = (h + 1) / 2, v = 1 - d, x = a.hasB, b = a.r, p = a.overhead, E = i.width, k = i.height, A = Math.abs(t - e), L = Math.abs(n - r), _ = A > 2 * Uv && L > 2 * Uv ? Uv : 0;
                A -= 2 * _, L -= 2 * _;
                var C = Dye(l);
                l === "auto" && !(E <= A && k <= L) && (E > A || k > L) && (!(E > L || k > A) || E < k != A < L) && (C += 90);
                var M = zye(i, C), g, P;
                if (b && b - p > Uv) {
                    var T = Tyt(e, t, r, n, M, b, p, o, x);
                    g = T.scale, P = T.pad;
                } else g = 1, s && (g = Math.min(1, A / M.x, L / M.y)), P = 0;
                var F = i.left * v + i.right * d, q = (i.top + i.bottom) / 2, V = (e + Uv) * v + (t - Uv) * d, H = (r + n) / 2, X = 0, G = 0;
                if (f || c) {
                    var N = (o ? M.x : M.y) / 2;
                    b && (c || x) && (_ += P);
                    var W = o ? Pm(e, t) : Pm(r, n);
                    o ? f ? (V = e + W * _, X = -W * N) : (V = t - W * _, X = W * N) : f ? (H = r + W * _, G = -W * N) : (H = n - W * _, G = W * N);
                }
                return {
                    textX: F,
                    textY: q,
                    targetX: V,
                    targetY: H,
                    anchorX: X,
                    anchorY: G,
                    scale: g,
                    rotate: C
                };
            }
            function Tyt(e, t, r, n, i, a, o, s, l) {
                var u = Math.max(0, Math.abs(t - e) - 2 * Uv), c = Math.max(0, Math.abs(n - r) - 2 * Uv), f = a - Uv, h = o ? f - Math.sqrt(f * f - (f - o) * (f - o)) : f, d = l ? f * 2 : s ? f - o : 2 * h, v = l ? f * 2 : s ? 2 * h : f - o, x, b, p, E, k;
                return i.y / i.x >= c / (u - d) ? E = c / i.y : i.y / i.x <= (c - v) / u ? E = u / i.x : !l && s ? (x = i.x * i.x + i.y * i.y / 4, b = -2 * i.x * (u - f) - i.y * (c / 2 - f), p = (u - f) * (u - f) + (c / 2 - f) * (c / 2 - f) - f * f, E = (-b + Math.sqrt(b * b - 4 * x * p)) / (2 * x)) : l ? (x = (i.x * i.x + i.y * i.y) / 4, b = -i.x * (u / 2 - f) - i.y * (c / 2 - f), p = (u / 2 - f) * (u / 2 - f) + (c / 2 - f) * (c / 2 - f) - f * f, E = (-b + Math.sqrt(b * b - 4 * x * p)) / (2 * x)) : (x = i.x * i.x / 4 + i.y * i.y, b = -i.x * (u / 2 - f) - 2 * i.y * (c - f), p = (u / 2 - f) * (u / 2 - f) + (c - f) * (c - f) - f * f, E = (-b + Math.sqrt(b * b - 4 * x * p)) / (2 * x)), E = Math.min(1, E), s ? k = Math.max(0, f - Math.sqrt(Math.max(0, f * f - (f - (c - i.y * E) / 2) * (f - (c - i.y * E) / 2))) - o) : k = Math.max(0, f - Math.sqrt(Math.max(0, f * f - (f - (u - i.x * E) / 2) * (f - (u - i.x * E) / 2))) - o), {
                    scale: E,
                    pad: k
                };
            }
            function Ayt(e, t, r, n, i, a) {
                var o = !!a.isHorizontal, s = !!a.constrained, l = a.angle || 0, u = i.width, c = i.height, f = Math.abs(t - e), h = Math.abs(n - r), d;
                o ? d = h > 2 * Uv ? Uv : 0 : d = f > 2 * Uv ? Uv : 0;
                var v = 1;
                s && (v = o ? Math.min(1, h / c) : Math.min(1, f / u));
                var x = Dye(l), b = zye(i, x), p = (o ? b.x : b.y) / 2, E = (i.left + i.right) / 2, k = (i.top + i.bottom) / 2, A = (e + t) / 2, L = (r + n) / 2, _ = 0, C = 0, M = o ? Pm(t, e) : Pm(r, n);
                return o ? (A = t - M * d, _ = M * p) : (L = n + M * d, C = -M * p), {
                    textX: E,
                    textY: k,
                    targetX: A,
                    targetY: L,
                    anchorX: _,
                    anchorY: C,
                    scale: v,
                    rotate: x
                };
            }
            function Syt(e, t, r, n, i) {
                var a = t[0].trace, o = a.texttemplate, s;
                return o ? s = Eyt(e, t, r, n, i) : a.textinfo ? s = kyt(t, r, n, i) : s = wT.getValue(a.text, r), wT.coerceString(pyt, s);
            }
            function Myt(e, t) {
                var r = wT.getValue(e.textposition, t);
                return wT.coerceEnumerated(gyt, r);
            }
            function Eyt(e, t, r, n, i) {
                var a = t[0].trace, o = Pd.castOption(a, r, "texttemplate");
                if (!o) return "";
                var s = a.type === "histogram", l = a.type === "waterfall", u = a.type === "funnel", c = a.orientation === "h", f, h, d, v;
                c ? (f = "y", h = i, d = "x", v = n) : (f = "x", h = n, d = "y", v = i);
                function x(_) {
                    return UI(h, h.c2l(_), !0).text;
                }
                function b(_) {
                    return UI(v, v.c2l(_), !0).text;
                }
                var p = t[r], E = {};
                E.label = p.p, E.labelLabel = E[f + "Label"] = x(p.p);
                var k = Pd.castOption(a, p.i, "text");
                (k === 0 || k) && (E.text = k), E.value = p.s, E.valueLabel = E[d + "Label"] = b(p.s);
                var A = {};
                myt(A, a, p.i), (s || A.x === void 0) && (A.x = c ? E.value : E.label), (s || A.y === void 0) && (A.y = c ? E.label : E.value), (s || A.xLabel === void 0) && (A.xLabel = c ? E.valueLabel : E.labelLabel), (s || A.yLabel === void 0) && (A.yLabel = c ? E.labelLabel : E.valueLabel), l && (E.delta = +p.rawS || p.s, E.deltaLabel = b(E.delta), E.final = p.v, E.finalLabel = b(E.final), E.initial = E.final - E.delta, E.initialLabel = b(E.initial)), u && (E.value = p.s, E.valueLabel = b(E.value), E.percentInitial = p.begR, E.percentInitialLabel = Pd.formatPercent(p.begR), E.percentPrevious = p.difR, E.percentPreviousLabel = Pd.formatPercent(p.difR), E.percentTotal = p.sumR, E.percenTotalLabel = Pd.formatPercent(p.sumR));
                var L = Pd.castOption(a, p.i, "customdata");
                return L && (E.customdata = L), Pd.texttemplateString(o, E, e._d3locale, A, E, a._meta || {});
            }
            function kyt(e, t, r, n) {
                var i = e[0].trace, a = i.orientation === "h", o = i.type === "waterfall", s = i.type === "funnel";
                function l(L) {
                    var _ = a ? n : r;
                    return UI(_, L, !0).text;
                }
                function u(L) {
                    var _ = a ? r : n;
                    return UI(_, +L, !0).text;
                }
                var c = i.textinfo, f = e[t], h = c.split("+"), d = [], v, x = function(L) {
                    return h.indexOf(L) !== -1;
                };
                if (x("label") && d.push(l(e[t].p)), x("text") && (v = Pd.castOption(i, f.i, "text"), (v === 0 || v) && d.push(v)), o) {
                    var b = +f.rawS || f.s, p = f.v, E = p - b;
                    x("initial") && d.push(u(E)), x("delta") && d.push(u(b)), x("final") && d.push(u(p));
                }
                if (s) {
                    x("value") && d.push(u(f.s));
                    var k = 0;
                    x("percent initial") && k++, x("percent previous") && k++, x("percent total") && k++;
                    var A = k > 1;
                    x("percent initial") && (v = Pd.formatPercent(f.begR), A && (v += " of initial"), d.push(v)), x("percent previous") && (v = Pd.formatPercent(f.difR), A && (v += " of previous"), d.push(v)), x("percent total") && (v = Pd.formatPercent(f.sumR), A && (v += " of total"), d.push(v));
                }
                return d.join("<br>");
            }
            qye.exports = {
                plot: byt,
                toMoveInsideBar: Fye
            };
        });
        var TT = ye((Ior, Uye)=>{
            "use strict";
            var d4 = Nc(), Cyt = ba(), Oye = va(), Lyt = Mr().fillText, Pyt = OI().getLineWidth, TV = Qa().hoverLabelText, Iyt = es().BADNUM;
            function Ryt(e, t, r, n, i) {
                var a = Bye(e, t, r, n, i);
                if (a) {
                    var o = a.cd, s = o[0].trace, l = o[a.index];
                    return a.color = Nye(s, l), Cyt.getComponentMethod("errorbars", "hoverInfo")(l, s, a), [
                        a
                    ];
                }
            }
            function Bye(e, t, r, n, i) {
                var a = e.cd, o = a[0].trace, s = a[0].t, l = n === "closest", u = o.type === "waterfall", c = e.maxHoverDistance, f = e.maxSpikeDistance, h, d, v, x, b, p, E;
                o.orientation === "h" ? (h = r, d = t, v = "y", x = "x", b = H, p = F) : (h = t, d = r, v = "x", x = "y", p = H, b = F);
                var k = o[v + "period"], A = l || k;
                function L(ie) {
                    return C(ie, -1);
                }
                function _(ie) {
                    return C(ie, 1);
                }
                function C(ie, Te) {
                    var Ee = ie.w;
                    return ie[v] + Te * Ee / 2;
                }
                function M(ie) {
                    return ie[v + "End"] - ie[v + "Start"];
                }
                var g = l ? L : k ? function(ie) {
                    return ie.p - M(ie) / 2;
                } : function(ie) {
                    return Math.min(L(ie), ie.p - s.bardelta / 2);
                }, P = l ? _ : k ? function(ie) {
                    return ie.p + M(ie) / 2;
                } : function(ie) {
                    return Math.max(_(ie), ie.p + s.bardelta / 2);
                };
                function T(ie, Te, Ee) {
                    return i.finiteRange && (Ee = 0), d4.inbox(ie - h, Te - h, Ee + Math.min(1, Math.abs(Te - ie) / E) - 1);
                }
                function F(ie) {
                    return T(g(ie), P(ie), c);
                }
                function q(ie) {
                    return T(L(ie), _(ie), f);
                }
                function V(ie) {
                    var Te = ie[x];
                    if (u) {
                        var Ee = Math.abs(ie.rawS) || 0;
                        d > 0 ? Te += Ee : d < 0 && (Te -= Ee);
                    }
                    return Te;
                }
                function H(ie) {
                    var Te = d, Ee = ie.b, Ae = V(ie);
                    return d4.inbox(Ee - Te, Ae - Te, c + (Ae - Te) / (Ae - Ee) - 1);
                }
                function X(ie) {
                    var Te = d, Ee = ie.b, Ae = V(ie);
                    return d4.inbox(Ee - Te, Ae - Te, f + (Ae - Te) / (Ae - Ee) - 1);
                }
                var G = e[v + "a"], N = e[x + "a"];
                E = Math.abs(G.r2c(G.range[1]) - G.r2c(G.range[0]));
                function W(ie) {
                    return (b(ie) + p(ie)) / 2;
                }
                var re = d4.getDistanceFunction(n, b, p, W);
                if (d4.getClosest(a, re, e), e.index !== !1 && a[e.index].p !== Iyt) {
                    A || (g = function(ie) {
                        return Math.min(L(ie), ie.p - s.bargroupwidth / 2);
                    }, P = function(ie) {
                        return Math.max(_(ie), ie.p + s.bargroupwidth / 2);
                    });
                    var ae = e.index, _e = a[ae], Me = o.base ? _e.b + _e.s : _e.s;
                    e[x + "0"] = e[x + "1"] = N.c2p(_e[x], !0), e[x + "LabelVal"] = Me;
                    var ke = s.extents[s.extents.round(_e.p)];
                    e[v + "0"] = G.c2p(l ? g(_e) : ke[0], !0), e[v + "1"] = G.c2p(l ? P(_e) : ke[1], !0);
                    var ge = _e.orig_p !== void 0;
                    return e[v + "LabelVal"] = ge ? _e.orig_p : _e.p, e.labelLabel = TV(G, e[v + "LabelVal"], o[v + "hoverformat"]), e.valueLabel = TV(N, e[x + "LabelVal"], o[x + "hoverformat"]), e.baseLabel = TV(N, _e.b, o[x + "hoverformat"]), e.spikeDistance = (X(_e) + q(_e)) / 2, e[v + "Spike"] = G.c2p(_e.p, !0), Lyt(_e, o, e), e.hovertemplate = o.hovertemplate, e;
                }
            }
            function Nye(e, t) {
                var r = t.mcc || e.marker.color, n = t.mlcc || e.marker.line.color, i = Pyt(e, t);
                if (Oye.opacity(r)) return r;
                if (Oye.opacity(n) && i) return n;
            }
            Uye.exports = {
                hoverPoints: Ryt,
                hoverOnBars: Bye,
                getTraceColor: Nye
            };
        });
        var Hye = ye((Ror, Vye)=>{
            "use strict";
            Vye.exports = function(t, r, n) {
                return t.x = "xVal" in r ? r.xVal : r.x, t.y = "yVal" in r ? r.yVal : r.y, r.xa && (t.xaxis = r.xa), r.ya && (t.yaxis = r.ya), n.orientation === "h" ? (t.label = t.y, t.value = t.x) : (t.label = t.x, t.value = t.y), t;
            };
        });
        var AT = ye((Dor, Gye)=>{
            "use strict";
            Gye.exports = function(t, r) {
                var n = t.cd, i = t.xaxis, a = t.yaxis, o = n[0].trace, s = o.type === "funnel", l = o.orientation === "h", u = [], c;
                if (r === !1) for(c = 0; c < n.length; c++)n[c].selected = 0;
                else for(c = 0; c < n.length; c++){
                    var f = n[c], h = "ct" in f ? f.ct : Dyt(f, i, a, l, s);
                    r.contains(h, !1, c, t) ? (u.push({
                        pointNumber: c,
                        x: i.c2d(f.x),
                        y: a.c2d(f.y)
                    }), f.selected = 1) : f.selected = 0;
                }
                return u;
            };
            function Dyt(e, t, r, n, i) {
                var a = t.c2p(n ? e.s0 : e.p0, !0), o = t.c2p(n ? e.s1 : e.p1, !0), s = r.c2p(n ? e.p0 : e.s0, !0), l = r.c2p(n ? e.p1 : e.s1, !0);
                return i ? [
                    (a + o) / 2,
                    (s + l) / 2
                ] : n ? [
                    o,
                    (s + l) / 2
                ] : [
                    (a + o) / 2,
                    l
                ];
            }
        });
        var Wye = ye((zor, jye)=>{
            "use strict";
            jye.exports = {
                attributes: Lm(),
                layoutAttributes: zI(),
                supplyDefaults: r0().supplyDefaults,
                crossTraceDefaults: r0().crossTraceDefaults,
                supplyLayoutDefaults: yV(),
                calc: pye(),
                crossTraceCalc: Gb().crossTraceCalc,
                colorbar: Kd(),
                arraysToCalcdata: c4(),
                plot: i2().plot,
                style: N0().style,
                styleOnSelect: N0().styleOnSelect,
                hoverPoints: TT().hoverPoints,
                eventData: Hye(),
                selectPoints: AT(),
                moduleType: "trace",
                name: "bar",
                basePlotModule: Jf(),
                categories: [
                    "bar-like",
                    "cartesian",
                    "svg",
                    "bar",
                    "oriented",
                    "errorBarsOK",
                    "showLegend",
                    "zoomScale"
                ],
                animatable: !0,
                meta: {}
            };
        });
        var Xye = ye((For, Zye)=>{
            "use strict";
            Zye.exports = Wye();
        });
        var v4 = ye((qor, $ye)=>{
            "use strict";
            var zyt = Eg(), U0 = Uc(), Yye = Lm(), Fyt = dh(), Kye = Oc().axisHoverFormat, qyt = Wo().hovertemplateAttrs, zy = no().extendFlat, ST = U0.marker, Jye = ST.line;
            $ye.exports = {
                y: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                x: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                x0: {
                    valType: "any",
                    editType: "calc+clearAxisTypes"
                },
                y0: {
                    valType: "any",
                    editType: "calc+clearAxisTypes"
                },
                dx: {
                    valType: "number",
                    editType: "calc"
                },
                dy: {
                    valType: "number",
                    editType: "calc"
                },
                xperiod: U0.xperiod,
                yperiod: U0.yperiod,
                xperiod0: U0.xperiod0,
                yperiod0: U0.yperiod0,
                xperiodalignment: U0.xperiodalignment,
                yperiodalignment: U0.yperiodalignment,
                xhoverformat: Kye("x"),
                yhoverformat: Kye("y"),
                name: {
                    valType: "string",
                    editType: "calc+clearAxisTypes"
                },
                q1: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                median: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                q3: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                lowerfence: {
                    valType: "data_array",
                    editType: "calc"
                },
                upperfence: {
                    valType: "data_array",
                    editType: "calc"
                },
                notched: {
                    valType: "boolean",
                    editType: "calc"
                },
                notchwidth: {
                    valType: "number",
                    min: 0,
                    max: .5,
                    dflt: .25,
                    editType: "calc"
                },
                notchspan: {
                    valType: "data_array",
                    editType: "calc"
                },
                boxpoints: {
                    valType: "enumerated",
                    values: [
                        "all",
                        "outliers",
                        "suspectedoutliers",
                        !1
                    ],
                    editType: "calc"
                },
                jitter: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: "calc"
                },
                pointpos: {
                    valType: "number",
                    min: -2,
                    max: 2,
                    editType: "calc"
                },
                sdmultiple: {
                    valType: "number",
                    min: 0,
                    editType: "calc",
                    dflt: 1
                },
                sizemode: {
                    valType: "enumerated",
                    values: [
                        "quartiles",
                        "sd"
                    ],
                    editType: "calc",
                    dflt: "quartiles"
                },
                boxmean: {
                    valType: "enumerated",
                    values: [
                        !0,
                        "sd",
                        !1
                    ],
                    editType: "calc"
                },
                mean: {
                    valType: "data_array",
                    editType: "calc"
                },
                sd: {
                    valType: "data_array",
                    editType: "calc"
                },
                orientation: {
                    valType: "enumerated",
                    values: [
                        "v",
                        "h"
                    ],
                    editType: "calc+clearAxisTypes"
                },
                quartilemethod: {
                    valType: "enumerated",
                    values: [
                        "linear",
                        "exclusive",
                        "inclusive"
                    ],
                    dflt: "linear",
                    editType: "calc"
                },
                width: {
                    valType: "number",
                    min: 0,
                    dflt: 0,
                    editType: "calc"
                },
                marker: {
                    outliercolor: {
                        valType: "color",
                        dflt: "rgba(0, 0, 0, 0)",
                        editType: "style"
                    },
                    symbol: zy({}, ST.symbol, {
                        arrayOk: !1,
                        editType: "plot"
                    }),
                    opacity: zy({}, ST.opacity, {
                        arrayOk: !1,
                        dflt: 1,
                        editType: "style"
                    }),
                    angle: zy({}, ST.angle, {
                        arrayOk: !1,
                        editType: "calc"
                    }),
                    size: zy({}, ST.size, {
                        arrayOk: !1,
                        editType: "calc"
                    }),
                    color: zy({}, ST.color, {
                        arrayOk: !1,
                        editType: "style"
                    }),
                    line: {
                        color: zy({}, Jye.color, {
                            arrayOk: !1,
                            dflt: Fyt.defaultLine,
                            editType: "style"
                        }),
                        width: zy({}, Jye.width, {
                            arrayOk: !1,
                            dflt: 0,
                            editType: "style"
                        }),
                        outliercolor: {
                            valType: "color",
                            editType: "style"
                        },
                        outlierwidth: {
                            valType: "number",
                            min: 0,
                            dflt: 1,
                            editType: "style"
                        },
                        editType: "style"
                    },
                    editType: "plot"
                },
                line: {
                    color: {
                        valType: "color",
                        editType: "style"
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        dflt: 2,
                        editType: "style"
                    },
                    editType: "plot"
                },
                fillcolor: zyt(),
                whiskerwidth: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: .5,
                    editType: "calc"
                },
                showwhiskers: {
                    valType: "boolean",
                    editType: "calc"
                },
                offsetgroup: Yye.offsetgroup,
                alignmentgroup: Yye.alignmentgroup,
                selected: {
                    marker: U0.selected.marker,
                    editType: "style"
                },
                unselected: {
                    marker: U0.unselected.marker,
                    editType: "style"
                },
                text: zy({}, U0.text, {}),
                hovertext: zy({}, U0.hovertext, {}),
                hovertemplate: qyt({}),
                hoveron: {
                    valType: "flaglist",
                    flags: [
                        "boxes",
                        "points"
                    ],
                    dflt: "boxes+points",
                    editType: "style"
                },
                zorder: U0.zorder
            };
        });
        var p4 = ye((Oor, Qye)=>{
            "use strict";
            Qye.exports = {
                boxmode: {
                    valType: "enumerated",
                    values: [
                        "group",
                        "overlay"
                    ],
                    dflt: "overlay",
                    editType: "calc"
                },
                boxgap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: .3,
                    editType: "calc"
                },
                boxgroupgap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: .3,
                    editType: "calc"
                }
            };
        });
        var m4 = ye((Bor, i1e)=>{
            "use strict";
            var V0 = Mr(), Oyt = ba(), Byt = va(), Nyt = Pg(), Uyt = Hb(), e1e = L3(), g4 = v4();
            function Vyt(e, t, r, n) {
                function i(v, x) {
                    return V0.coerce(e, t, g4, v, x);
                }
                if (t1e(e, t, i, n), t.visible !== !1) {
                    Nyt(e, t, n, i), i("xhoverformat"), i("yhoverformat");
                    var a = t._hasPreCompStats;
                    a && (i("lowerfence"), i("upperfence")), i("line.color", (e.marker || {}).color || r), i("line.width"), i("fillcolor", Byt.addOpacity(t.line.color, .5));
                    var o = !1;
                    if (a) {
                        var s = i("mean"), l = i("sd");
                        s && s.length && (o = !0, l && l.length && (o = "sd"));
                    }
                    i("whiskerwidth");
                    var u = i("sizemode"), c;
                    u === "quartiles" && (c = i("boxmean", o)), i("showwhiskers", u === "quartiles"), (u === "sd" || c === "sd") && i("sdmultiple"), i("width"), i("quartilemethod");
                    var f = !1;
                    if (a) {
                        var h = i("notchspan");
                        h && h.length && (f = !0);
                    } else V0.validate(e.notchwidth, g4.notchwidth) && (f = !0);
                    var d = i("notched", f);
                    d && i("notchwidth"), r1e(e, t, i, {
                        prefix: "box"
                    }), i("zorder");
                }
            }
            function t1e(e, t, r, n) {
                function i(P) {
                    var T = 0;
                    return P && P.length && (T += 1, V0.isArrayOrTypedArray(P[0]) && P[0].length && (T += 1)), T;
                }
                function a(P) {
                    return V0.validate(e[P], g4[P]);
                }
                var o = r("y"), s = r("x"), l;
                if (t.type === "box") {
                    var u = r("q1"), c = r("median"), f = r("q3");
                    t._hasPreCompStats = u && u.length && c && c.length && f && f.length, l = Math.min(V0.minRowLength(u), V0.minRowLength(c), V0.minRowLength(f));
                }
                var h = i(o), d = i(s), v = h && V0.minRowLength(o), x = d && V0.minRowLength(s), b = n.calendar, p = {
                    autotypenumbers: n.autotypenumbers
                }, E, k;
                if (t._hasPreCompStats) switch(String(d) + String(h)){
                    case "00":
                        var A = a("x0") || a("dx"), L = a("y0") || a("dy");
                        L && !A ? E = "h" : E = "v", k = l;
                        break;
                    case "10":
                        E = "v", k = Math.min(l, x);
                        break;
                    case "20":
                        E = "h", k = Math.min(l, s.length);
                        break;
                    case "01":
                        E = "h", k = Math.min(l, v);
                        break;
                    case "02":
                        E = "v", k = Math.min(l, o.length);
                        break;
                    case "12":
                        E = "v", k = Math.min(l, x, o.length);
                        break;
                    case "21":
                        E = "h", k = Math.min(l, s.length, v);
                        break;
                    case "11":
                        k = 0;
                        break;
                    case "22":
                        var _ = !1, C;
                        for(C = 0; C < s.length; C++)if (e1e(s[C], b, p) === "category") {
                            _ = !0;
                            break;
                        }
                        if (_) E = "v", k = Math.min(l, x, o.length);
                        else {
                            for(C = 0; C < o.length; C++)if (e1e(o[C], b, p) === "category") {
                                _ = !0;
                                break;
                            }
                            _ ? (E = "h", k = Math.min(l, s.length, v)) : (E = "v", k = Math.min(l, x, o.length));
                        }
                        break;
                }
                else h > 0 ? (E = "v", d > 0 ? k = Math.min(x, v) : k = Math.min(v)) : d > 0 ? (E = "h", k = Math.min(x)) : k = 0;
                if (!k) {
                    t.visible = !1;
                    return;
                }
                t._length = k;
                var M = r("orientation", E);
                t._hasPreCompStats ? M === "v" && d === 0 ? (r("x0", 0), r("dx", 1)) : M === "h" && h === 0 && (r("y0", 0), r("dy", 1)) : M === "v" && d === 0 ? r("x0") : M === "h" && h === 0 && r("y0");
                var g = Oyt.getComponentMethod("calendars", "handleTraceDefaults");
                g(e, t, [
                    "x",
                    "y"
                ], n);
            }
            function r1e(e, t, r, n) {
                var i = n.prefix, a = V0.coerce2(e, t, g4, "marker.outliercolor"), o = r("marker.line.outliercolor"), s = "outliers";
                t._hasPreCompStats ? s = "all" : (a || o) && (s = "suspectedoutliers");
                var l = r(i + "points", s);
                l ? (r("jitter", l === "all" ? .3 : 0), r("pointpos", l === "all" ? -1.5 : 0), r("marker.symbol"), r("marker.opacity"), r("marker.size"), r("marker.angle"), r("marker.color", t.line.color), r("marker.line.color"), r("marker.line.width"), l === "suspectedoutliers" && (r("marker.line.outliercolor", t.marker.color), r("marker.line.outlierwidth")), r("selected.marker.color"), r("unselected.marker.color"), r("selected.marker.size"), r("unselected.marker.size"), r("text"), r("hovertext")) : delete t.marker;
                var u = r("hoveron");
                (u === "all" || u.indexOf("points") !== -1) && r("hovertemplate"), V0.coerceSelectionMarkerOpacity(t, r);
            }
            function Hyt(e, t) {
                var r, n;
                function i(l) {
                    return V0.coerce(n._input, n, g4, l);
                }
                for(var a = 0; a < e.length; a++){
                    n = e[a];
                    var o = n.type;
                    if (o === "box" || o === "violin") {
                        r = n._input;
                        var s = t[o + "mode"];
                        s === "group" && Uyt(r, n, t, i, s);
                    }
                }
            }
            i1e.exports = {
                supplyDefaults: Vyt,
                crossTraceDefaults: Hyt,
                handleSampleDefaults: t1e,
                handlePointsDefaults: r1e
            };
        });
        var VI = ye((Nor, a1e)=>{
            "use strict";
            var Gyt = ba(), jyt = Mr(), Wyt = p4();
            function n1e(e, t, r, n, i) {
                for(var a = i + "Layout", o = !1, s = 0; s < r.length; s++){
                    var l = r[s];
                    if (Gyt.traceIs(l, a)) {
                        o = !0;
                        break;
                    }
                }
                o && (n(i + "mode"), n(i + "gap"), n(i + "groupgap"));
            }
            function Zyt(e, t, r) {
                function n(i, a) {
                    return jyt.coerce(e, t, Wyt, i, a);
                }
                n1e(e, t, r, n, "box");
            }
            a1e.exports = {
                supplyLayoutDefaults: Zyt,
                _supply: n1e
            };
        });
        var MV = ye((Uor, v1e)=>{
            "use strict";
            var SV = uo(), HI = Qa(), Xyt = Rg(), $f = Mr(), i0 = es().BADNUM, Fy = $f._;
            v1e.exports = function(t, r) {
                var n = t._fullLayout, i = HI.getFromId(t, r.xaxis || "x"), a = HI.getFromId(t, r.yaxis || "y"), o = [], s = r.type === "violin" ? "_numViolins" : "_numBoxes", l, u, c, f, h, d, v;
                r.orientation === "h" ? (c = i, f = "x", h = a, d = "y", v = !!r.yperiodalignment) : (c = a, f = "y", h = i, d = "x", v = !!r.xperiodalignment);
                var x = Yyt(r, d, h, n[s]), b = x[0], p = x[1], E = $f.distinctVals(b, h), k = E.vals, A = E.minDiff / 2, L, _, C, M, g, P, T = (r.boxpoints || r.points) === "all" ? $f.identity : function(qt) {
                    return qt.v < L.lf || qt.v > L.uf;
                };
                if (r._hasPreCompStats) {
                    var F = r[f], q = function(qt) {
                        return c.d2c((r[qt] || [])[l]);
                    }, V = 1 / 0, H = -1 / 0;
                    for(l = 0; l < r._length; l++){
                        var X = b[l];
                        if (SV(X)) {
                            if (L = {}, L.pos = L[d] = X, v && p && (L.orig_p = p[l]), L.q1 = q("q1"), L.med = q("median"), L.q3 = q("q3"), _ = [], F && $f.isArrayOrTypedArray(F[l])) for(u = 0; u < F[l].length; u++)P = c.d2c(F[l][u]), P !== i0 && (g = {
                                v: P,
                                i: [
                                    l,
                                    u
                                ]
                            }, o1e(g, r, [
                                l,
                                u
                            ]), _.push(g));
                            if (L.pts = _.sort(s1e), C = L[f] = _.map(l1e), M = C.length, L.med !== i0 && L.q1 !== i0 && L.q3 !== i0 && L.med >= L.q1 && L.q3 >= L.med) {
                                var G = q("lowerfence");
                                L.lf = G !== i0 && G <= L.q1 ? G : u1e(L, C, M);
                                var N = q("upperfence");
                                L.uf = N !== i0 && N >= L.q3 ? N : c1e(L, C, M);
                                var W = q("mean");
                                L.mean = W !== i0 ? W : M ? $f.mean(C, M) : (L.q1 + L.q3) / 2;
                                var re = q("sd");
                                L.sd = W !== i0 && re >= 0 ? re : M ? $f.stdev(C, M, L.mean) : L.q3 - L.q1, L.lo = f1e(L), L.uo = h1e(L);
                                var ae = q("notchspan");
                                ae = ae !== i0 && ae > 0 ? ae : d1e(L, M), L.ln = L.med - ae, L.un = L.med + ae;
                                var _e = L.lf, Me = L.uf;
                                r.boxpoints && C.length && (_e = Math.min(_e, C[0]), Me = Math.max(Me, C[M - 1])), r.notched && (_e = Math.min(_e, L.ln), Me = Math.max(Me, L.un)), L.min = _e, L.max = Me;
                            } else {
                                $f.warn([
                                    "Invalid input - make sure that q1 <= median <= q3",
                                    "q1 = " + L.q1,
                                    "median = " + L.med,
                                    "q3 = " + L.q3
                                ].join(`
`));
                                var ke;
                                L.med !== i0 ? ke = L.med : L.q1 !== i0 ? L.q3 !== i0 ? ke = (L.q1 + L.q3) / 2 : ke = L.q1 : L.q3 !== i0 ? ke = L.q3 : ke = 0, L.med = ke, L.q1 = L.q3 = ke, L.lf = L.uf = ke, L.mean = L.sd = ke, L.ln = L.un = ke, L.min = L.max = ke;
                            }
                            V = Math.min(V, L.min), H = Math.max(H, L.max), L.pts2 = _.filter(T), o.push(L);
                        }
                    }
                    r._extremes[c._id] = HI.findExtremes(c, [
                        V,
                        H
                    ], {
                        padded: !0
                    });
                } else {
                    var ge = c.makeCalcdata(r, f), ie = Kyt(k, A), Te = k.length, Ee = Jyt(Te);
                    for(l = 0; l < r._length; l++)if (P = ge[l], !!SV(P)) {
                        var Ae = $f.findBin(b[l], ie);
                        Ae >= 0 && Ae < Te && (g = {
                            v: P,
                            i: l
                        }, o1e(g, r, l), Ee[Ae].push(g));
                    }
                    var ze = 1 / 0, Ce = -1 / 0, me = r.quartilemethod, Re = me === "exclusive", ce = me === "inclusive";
                    for(l = 0; l < Te; l++)if (Ee[l].length > 0) {
                        if (L = {}, L.pos = L[d] = k[l], _ = L.pts = Ee[l].sort(s1e), C = L[f] = _.map(l1e), M = C.length, L.min = C[0], L.max = C[M - 1], L.mean = $f.mean(C, M), L.sd = $f.stdev(C, M, L.mean) * r.sdmultiple, L.med = $f.interp(C, .5), M % 2 && (Re || ce)) {
                            var Ge, nt;
                            Re ? (Ge = C.slice(0, M / 2), nt = C.slice(M / 2 + 1)) : ce && (Ge = C.slice(0, M / 2 + 1), nt = C.slice(M / 2)), L.q1 = $f.interp(Ge, .5), L.q3 = $f.interp(nt, .5);
                        } else L.q1 = $f.interp(C, .25), L.q3 = $f.interp(C, .75);
                        L.lf = u1e(L, C, M), L.uf = c1e(L, C, M), L.lo = f1e(L), L.uo = h1e(L);
                        var ct = d1e(L, M);
                        L.ln = L.med - ct, L.un = L.med + ct, ze = Math.min(ze, L.ln), Ce = Math.max(Ce, L.un), L.pts2 = _.filter(T), o.push(L);
                    }
                    r.notched && $f.isTypedArray(ge) && (ge = Array.from(ge)), r._extremes[c._id] = HI.findExtremes(c, r.notched ? ge.concat([
                        ze,
                        Ce
                    ]) : ge, {
                        padded: !0
                    });
                }
                return $yt(o, r), o.length > 0 ? (o[0].t = {
                    num: n[s],
                    dPos: A,
                    posLetter: d,
                    valLetter: f,
                    labels: {
                        med: Fy(t, "median:"),
                        min: Fy(t, "min:"),
                        q1: Fy(t, "q1:"),
                        q3: Fy(t, "q3:"),
                        max: Fy(t, "max:"),
                        mean: r.boxmean === "sd" || r.sizemode === "sd" ? Fy(t, "mean \xB1 \u03C3:").replace("\u03C3", r.sdmultiple === 1 ? "\u03C3" : r.sdmultiple + "\u03C3") : Fy(t, "mean:"),
                        lf: Fy(t, "lower fence:"),
                        uf: Fy(t, "upper fence:")
                    }
                }, n[s]++, o) : [
                    {
                        t: {
                            empty: !0
                        }
                    }
                ];
            };
            function Yyt(e, t, r, n) {
                var i = t in e, a = t + "0" in e, o = "d" + t in e;
                if (i || a && o) {
                    var s = r.makeCalcdata(e, t), l = Xyt(e, r, t, s).vals;
                    return [
                        l,
                        s
                    ];
                }
                var u;
                a ? u = e[t + "0"] : "name" in e && (r.type === "category" || SV(e.name) && [
                    "linear",
                    "log"
                ].indexOf(r.type) !== -1 || $f.isDateTime(e.name) && r.type === "date") ? u = e.name : u = n;
                for(var c = r.type === "multicategory" ? r.r2c_just_indices(u) : r.d2c(u, 0, e[t + "calendar"]), f = e._length, h = new Array(f), d = 0; d < f; d++)h[d] = c;
                return [
                    h
                ];
            }
            function Kyt(e, t) {
                for(var r = e.length, n = new Array(r + 1), i = 0; i < r; i++)n[i] = e[i] - t;
                return n[r] = e[r - 1] + t, n;
            }
            function Jyt(e) {
                for(var t = new Array(e), r = 0; r < e; r++)t[r] = [];
                return t;
            }
            var AV = {
                text: "tx",
                hovertext: "htx"
            };
            function o1e(e, t, r) {
                for(var n in AV)$f.isArrayOrTypedArray(t[n]) && (Array.isArray(r) ? $f.isArrayOrTypedArray(t[n][r[0]]) && (e[AV[n]] = t[n][r[0]][r[1]]) : e[AV[n]] = t[n][r]);
            }
            function $yt(e, t) {
                if ($f.isArrayOrTypedArray(t.selectedpoints)) for(var r = 0; r < e.length; r++){
                    for(var n = e[r].pts || [], i = {}, a = 0; a < n.length; a++)i[n[a].i] = a;
                    $f.tagSelected(n, t, i);
                }
            }
            function s1e(e, t) {
                return e.v - t.v;
            }
            function l1e(e) {
                return e.v;
            }
            function u1e(e, t, r) {
                return r === 0 ? e.q1 : Math.min(e.q1, t[Math.min($f.findBin(2.5 * e.q1 - 1.5 * e.q3, t, !0) + 1, r - 1)]);
            }
            function c1e(e, t, r) {
                return r === 0 ? e.q3 : Math.max(e.q3, t[Math.max($f.findBin(2.5 * e.q3 - 1.5 * e.q1, t), 0)]);
            }
            function f1e(e) {
                return 4 * e.q1 - 3 * e.q3;
            }
            function h1e(e) {
                return 4 * e.q3 - 3 * e.q1;
            }
            function d1e(e, t) {
                return t === 0 ? 0 : 1.57 * (e.q3 - e.q1) / Math.sqrt(t);
            }
        });
        var GI = ye((Vor, y1e)=>{
            "use strict";
            var p1e = Qa(), Qyt = Mr(), e1t = Bb().getAxisGroup, g1e = [
                "v",
                "h"
            ];
            function t1t(e, t) {
                for(var r = e.calcdata, n = t.xaxis, i = t.yaxis, a = 0; a < g1e.length; a++){
                    for(var o = g1e[a], s = o === "h" ? i : n, l = [], u = 0; u < r.length; u++){
                        var c = r[u], f = c[0].t, h = c[0].trace;
                        h.visible === !0 && (h.type === "box" || h.type === "candlestick") && !f.empty && (h.orientation || "v") === o && h.xaxis === n._id && h.yaxis === i._id && l.push(u);
                    }
                    m1e("box", e, l, s);
                }
            }
            function m1e(e, t, r, n) {
                var i = t.calcdata, a = t._fullLayout, o = n._id, s = o.charAt(0), l, u, c, f = [], h = 0;
                for(l = 0; l < r.length; l++)for(c = i[r[l]], u = 0; u < c.length; u++)f.push(n.c2l(c[u].pos, !0)), h += (c[u].pts2 || []).length;
                if (f.length) {
                    var d = Qyt.distinctVals(f);
                    (n.type === "category" || n.type === "multicategory") && (d.minDiff = 1);
                    var v = d.minDiff / 2;
                    p1e.minDtick(n, d.minDiff, d.vals[0], !0);
                    var x = e === "violin" ? "_numViolins" : "_numBoxes", b = a[x], p = a[e + "mode"] === "group" && b > 1, E = 1 - a[e + "gap"], k = 1 - a[e + "groupgap"];
                    for(l = 0; l < r.length; l++){
                        c = i[r[l]];
                        var A = c[0].trace, L = c[0].t, _ = A.width, C = A.side, M, g, P, T;
                        if (_) M = g = T = _ / 2, P = 0;
                        else if (M = v, p) {
                            var F = e1t(a, n._id) + A.orientation, q = a._alignmentOpts[F] || {}, V = q[A.alignmentgroup] || {}, H = Object.keys(V.offsetGroups || {}).length, X = H || b, G = H ? A._offsetIndex : L.num;
                            g = M * E * k / X, P = 2 * M * (-0.5 + (G + .5) / X) * E, T = M * E / X;
                        } else g = M * E * k, P = 0, T = M;
                        L.dPos = M, L.bPos = P, L.bdPos = g, L.wHover = T;
                        var N, W, re = P + g, ae, _e, Me, ke, ge, ie, Te = !!_, Ee = (A.boxpoints || A.points) && h > 0;
                        if (C === "positive" ? (N = M * (_ ? 1 : .5), ae = re, W = ae = P) : C === "negative" ? (N = ae = P, W = M * (_ ? 1 : .5), _e = re) : (N = W = M, ae = _e = re), Ee) {
                            var Ae = A.pointpos, ze = A.jitter, Ce = A.marker.size / 2, me = 0;
                            Ae + ze >= 0 && (me = re * (Ae + ze), me > N ? (Te = !0, ge = Ce, Me = me) : me > ae && (ge = Ce, Me = N)), me <= N && (Me = N);
                            var Re = 0;
                            Ae - ze <= 0 && (Re = -re * (Ae - ze), Re > W ? (Te = !0, ie = Ce, ke = Re) : Re > _e && (ie = Ce, ke = W)), Re <= W && (ke = W);
                        } else Me = N, ke = W;
                        var ce = new Array(c.length);
                        for(u = 0; u < c.length; u++)ce[u] = c[u].pos;
                        A._extremes[o] = p1e.findExtremes(n, ce, {
                            padded: Te,
                            vpadminus: ke,
                            vpadplus: Me,
                            vpadLinearized: !0,
                            ppadminus: {
                                x: ie,
                                y: ge
                            }[s],
                            ppadplus: {
                                x: ge,
                                y: ie
                            }[s]
                        });
                    }
                }
            }
            y1e.exports = {
                crossTraceCalc: t1t,
                setPositionOffset: m1e
            };
        });
        var jI = ye((Hor, T1e)=>{
            "use strict";
            var MT = xa(), n2 = Mr(), r1t = ao(), _1e = 5, i1t = .01;
            function n1t(e, t, r, n) {
                var i = e._context.staticPlot, a = t.xaxis, o = t.yaxis;
                n2.makeTraceGroups(n, r, "trace boxes").each(function(s) {
                    var l = MT.select(this), u = s[0], c = u.t, f = u.trace;
                    if (c.wdPos = c.bdPos * f.whiskerwidth, f.visible !== !0 || c.empty) {
                        l.remove();
                        return;
                    }
                    var h, d;
                    f.orientation === "h" ? (h = o, d = a) : (h = a, d = o), x1e(l, {
                        pos: h,
                        val: d
                    }, f, c, i), b1e(l, {
                        x: a,
                        y: o
                    }, f, c), w1e(l, {
                        pos: h,
                        val: d
                    }, f, c);
                });
            }
            function x1e(e, t, r, n, i) {
                var a = r.orientation === "h", o = t.val, s = t.pos, l = !!s.rangebreaks, u = n.bPos, c = n.wdPos || 0, f = n.bPosPxOffset || 0, h = r.whiskerwidth || 0, d = r.showwhiskers !== !1, v = r.notched || !1, x = v ? 1 - 2 * r.notchwidth : 1, b, p;
                Array.isArray(n.bdPos) ? (b = n.bdPos[0], p = n.bdPos[1]) : (b = n.bdPos, p = n.bdPos);
                var E = e.selectAll("path.box").data(r.type !== "violin" || r.box.visible ? n2.identity : []);
                E.enter().append("path").style("vector-effect", i ? "none" : "non-scaling-stroke").attr("class", "box"), E.exit().remove(), E.each(function(k) {
                    if (k.empty) return MT.select(this).attr("d", "M0,0Z");
                    var A = s.c2l(k.pos + u, !0), L = s.l2p(A - b) + f, _ = s.l2p(A + p) + f, C = l ? (L + _) / 2 : s.l2p(A) + f, M = r.whiskerwidth, g = l ? L * M + (1 - M) * C : s.l2p(A - c) + f, P = l ? _ * M + (1 - M) * C : s.l2p(A + c) + f, T = s.l2p(A - b * x) + f, F = s.l2p(A + p * x) + f, q = r.sizemode === "sd", V = o.c2p(q ? k.mean - k.sd : k.q1, !0), H = q ? o.c2p(k.mean + k.sd, !0) : o.c2p(k.q3, !0), X = n2.constrain(q ? o.c2p(k.mean, !0) : o.c2p(k.med, !0), Math.min(V, H) + 1, Math.max(V, H) - 1), G = k.lf === void 0 || r.boxpoints === !1 || q, N = o.c2p(G ? k.min : k.lf, !0), W = o.c2p(G ? k.max : k.uf, !0), re = o.c2p(k.ln, !0), ae = o.c2p(k.un, !0);
                    a ? MT.select(this).attr("d", "M" + X + "," + T + "V" + F + "M" + V + "," + L + "V" + _ + (v ? "H" + re + "L" + X + "," + F + "L" + ae + "," + _ : "") + "H" + H + "V" + L + (v ? "H" + ae + "L" + X + "," + T + "L" + re + "," + L : "") + "Z" + (d ? "M" + V + "," + C + "H" + N + "M" + H + "," + C + "H" + W + (h === 0 ? "" : "M" + N + "," + g + "V" + P + "M" + W + "," + g + "V" + P) : "")) : MT.select(this).attr("d", "M" + T + "," + X + "H" + F + "M" + L + "," + V + "H" + _ + (v ? "V" + re + "L" + F + "," + X + "L" + _ + "," + ae : "") + "V" + H + "H" + L + (v ? "V" + ae + "L" + T + "," + X + "L" + L + "," + re : "") + "Z" + (d ? "M" + C + "," + V + "V" + N + "M" + C + "," + H + "V" + W + (h === 0 ? "" : "M" + g + "," + N + "H" + P + "M" + g + "," + W + "H" + P) : ""));
                });
            }
            function b1e(e, t, r, n) {
                var i = t.x, a = t.y, o = n.bdPos, s = n.bPos, l = r.boxpoints || r.points;
                n2.seedPseudoRandom();
                var u = function(h) {
                    return h.forEach(function(d) {
                        d.t = n, d.trace = r;
                    }), h;
                }, c = e.selectAll("g.points").data(l ? u : []);
                c.enter().append("g").attr("class", "points"), c.exit().remove();
                var f = c.selectAll("path").data(function(h) {
                    var d, v = h.pts2, x = Math.max((h.max - h.min) / 10, h.q3 - h.q1), b = x * 1e-9, p = x * i1t, E = [], k = 0, A;
                    if (r.jitter) {
                        if (x === 0) for(k = 1, E = new Array(v.length), d = 0; d < v.length; d++)E[d] = 1;
                        else for(d = 0; d < v.length; d++){
                            var L = Math.max(0, d - _1e), _ = v[L].v, C = Math.min(v.length - 1, d + _1e), M = v[C].v;
                            l !== "all" && (v[d].v < h.lf ? M = Math.min(M, h.lf) : _ = Math.max(_, h.uf));
                            var g = Math.sqrt(p * (C - L) / (M - _ + b)) || 0;
                            g = n2.constrain(Math.abs(g), 0, 1), E.push(g), k = Math.max(g, k);
                        }
                        A = r.jitter * 2 / (k || 1);
                    }
                    for(d = 0; d < v.length; d++){
                        var P = v[d], T = P.v, F = r.jitter ? A * E[d] * (n2.pseudoRandom() - .5) : 0, q = h.pos + s + o * (r.pointpos + F);
                        r.orientation === "h" ? (P.y = q, P.x = T) : (P.x = q, P.y = T), l === "suspectedoutliers" && T < h.uo && T > h.lo && (P.so = !0);
                    }
                    return v;
                });
                f.enter().append("path").classed("point", !0), f.exit().remove(), f.call(r1t.translatePoints, i, a);
            }
            function w1e(e, t, r, n) {
                var i = t.val, a = t.pos, o = !!a.rangebreaks, s = n.bPos, l = n.bPosPxOffset || 0, u = r.boxmean || (r.meanline || {}).visible, c, f;
                Array.isArray(n.bdPos) ? (c = n.bdPos[0], f = n.bdPos[1]) : (c = n.bdPos, f = n.bdPos);
                var h = e.selectAll("path.mean").data(r.type === "box" && r.boxmean || r.type === "violin" && r.box.visible && r.meanline.visible ? n2.identity : []);
                h.enter().append("path").attr("class", "mean").style({
                    fill: "none",
                    "vector-effect": "non-scaling-stroke"
                }), h.exit().remove(), h.each(function(d) {
                    var v = a.c2l(d.pos + s, !0), x = a.l2p(v - c) + l, b = a.l2p(v + f) + l, p = o ? (x + b) / 2 : a.l2p(v) + l, E = i.c2p(d.mean, !0), k = i.c2p(d.mean - d.sd, !0), A = i.c2p(d.mean + d.sd, !0);
                    r.orientation === "h" ? MT.select(this).attr("d", "M" + E + "," + x + "V" + b + (u === "sd" ? "m0,0L" + k + "," + p + "L" + E + "," + x + "L" + A + "," + p + "Z" : "")) : MT.select(this).attr("d", "M" + x + "," + E + "H" + b + (u === "sd" ? "m0,0L" + p + "," + k + "L" + x + "," + E + "L" + p + "," + A + "Z" : ""));
                });
            }
            T1e.exports = {
                plot: n1t,
                plotBoxAndWhiskers: x1e,
                plotPoints: b1e,
                plotBoxMean: w1e
            };
        });
        var WI = ye((Gor, A1e)=>{
            "use strict";
            var EV = xa(), kV = va(), CV = ao();
            function a1t(e, t, r) {
                var n = r || EV.select(e).selectAll("g.trace.boxes");
                n.style("opacity", function(i) {
                    return i[0].trace.opacity;
                }), n.each(function(i) {
                    var a = EV.select(this), o = i[0].trace, s = o.line.width;
                    function l(f, h, d, v) {
                        f.style("stroke-width", h + "px").call(kV.stroke, d).call(kV.fill, v);
                    }
                    var u = a.selectAll("path.box");
                    if (o.type === "candlestick") u.each(function(f) {
                        if (!f.empty) {
                            var h = EV.select(this), d = o[f.dir];
                            l(h, d.line.width, d.line.color, d.fillcolor), h.style("opacity", o.selectedpoints && !f.selected ? .3 : 1);
                        }
                    });
                    else {
                        l(u, s, o.line.color, o.fillcolor), a.selectAll("path.mean").style({
                            "stroke-width": s,
                            "stroke-dasharray": 2 * s + "px," + s + "px"
                        }).call(kV.stroke, o.line.color);
                        var c = a.selectAll("path.point");
                        CV.pointStyle(c, o, e);
                    }
                });
            }
            function o1t(e, t, r) {
                var n = t[0].trace, i = r.selectAll("path.point");
                n.selectedpoints ? CV.selectedPointStyle(i, n) : CV.pointStyle(i, n, e);
            }
            A1e.exports = {
                style: a1t,
                styleOnSelect: o1t
            };
        });
        var PV = ye((jor, k1e)=>{
            "use strict";
            var s1t = Qa(), LV = Mr(), S_ = Nc(), S1e = va(), l1t = LV.fillText;
            function u1t(e, t, r, n) {
                var i = e.cd, a = i[0].trace, o = a.hoveron, s = [], l;
                return o.indexOf("boxes") !== -1 && (s = s.concat(M1e(e, t, r, n))), o.indexOf("points") !== -1 && (l = E1e(e, t, r)), n === "closest" ? l ? [
                    l
                ] : s : (l && s.push(l), s);
            }
            function M1e(e, t, r, n) {
                var i = e.cd, a = e.xa, o = e.ya, s = i[0].trace, l = i[0].t, u = s.type === "violin", c, f, h, d, v, x, b, p, E, k, A, L = l.bdPos, _, C, M = l.wHover, g = function(Ce) {
                    return h.c2l(Ce.pos) + l.bPos - h.c2l(x);
                };
                u && s.side !== "both" ? (s.side === "positive" && (E = function(Ce) {
                    var me = g(Ce);
                    return S_.inbox(me, me + M, k);
                }, _ = L, C = 0), s.side === "negative" && (E = function(Ce) {
                    var me = g(Ce);
                    return S_.inbox(me - M, me, k);
                }, _ = 0, C = L)) : (E = function(Ce) {
                    var me = g(Ce);
                    return S_.inbox(me - M, me + M, k);
                }, _ = C = L);
                var P;
                u ? P = function(Ce) {
                    return S_.inbox(Ce.span[0] - v, Ce.span[1] - v, k);
                } : P = function(Ce) {
                    return S_.inbox(Ce.min - v, Ce.max - v, k);
                }, s.orientation === "h" ? (v = t, x = r, b = P, p = E, c = "y", h = o, f = "x", d = a) : (v = r, x = t, b = E, p = P, c = "x", h = a, f = "y", d = o);
                var T = Math.min(1, L / Math.abs(h.r2c(h.range[1]) - h.r2c(h.range[0])));
                k = e.maxHoverDistance - T, A = e.maxSpikeDistance - T;
                function F(Ce) {
                    return (b(Ce) + p(Ce)) / 2;
                }
                var q = S_.getDistanceFunction(n, b, p, F);
                if (S_.getClosest(i, q, e), e.index === !1) return [];
                var V = i[e.index], H = s.line.color, X = (s.marker || {}).color;
                S1e.opacity(H) && s.line.width ? e.color = H : S1e.opacity(X) && s.boxpoints ? e.color = X : e.color = s.fillcolor, e[c + "0"] = h.c2p(V.pos + l.bPos - C, !0), e[c + "1"] = h.c2p(V.pos + l.bPos + _, !0), e[c + "LabelVal"] = V.orig_p !== void 0 ? V.orig_p : V.pos;
                var G = c + "Spike";
                e.spikeDistance = F(V) * A / k, e[G] = h.c2p(V.pos, !0);
                var N = s.boxmean || s.sizemode === "sd" || (s.meanline || {}).visible, W = s.boxpoints || s.points, re = W && N ? [
                    "max",
                    "uf",
                    "q3",
                    "med",
                    "mean",
                    "q1",
                    "lf",
                    "min"
                ] : W && !N ? [
                    "max",
                    "uf",
                    "q3",
                    "med",
                    "q1",
                    "lf",
                    "min"
                ] : !W && N ? [
                    "max",
                    "q3",
                    "med",
                    "mean",
                    "q1",
                    "min"
                ] : [
                    "max",
                    "q3",
                    "med",
                    "q1",
                    "min"
                ], ae = d.range[1] < d.range[0];
                s.orientation === (ae ? "v" : "h") && re.reverse();
                for(var _e = e.spikeDistance, Me = e[G], ke = [], ge = 0; ge < re.length; ge++){
                    var ie = re[ge];
                    if (ie in V) {
                        var Te = V[ie], Ee = d.c2p(Te, !0), Ae = LV.extendFlat({}, e);
                        Ae.attr = ie, Ae[f + "0"] = Ae[f + "1"] = Ee, Ae[f + "LabelVal"] = Te, Ae[f + "Label"] = (l.labels ? l.labels[ie] + " " : "") + s1t.hoverLabelText(d, Te, s[f + "hoverformat"]), Ae.hoverOnBox = !0, ie === "mean" && "sd" in V && (s.boxmean === "sd" || s.sizemode === "sd") && (Ae[f + "err"] = V.sd), Ae.hovertemplate = !1, ke.push(Ae);
                    }
                }
                e.name = "", e.spikeDistance = void 0, e[G] = void 0;
                for(var ze = 0; ze < ke.length; ze++)ke[ze].attr !== "med" ? (ke[ze].name = "", ke[ze].spikeDistance = void 0, ke[ze][G] = void 0) : (ke[ze].spikeDistance = _e, ke[ze][G] = Me);
                return ke;
            }
            function E1e(e, t, r) {
                for(var n = e.cd, i = e.xa, a = e.ya, o = n[0].trace, s = i.c2p(t), l = a.c2p(r), u, c = function(P) {
                    var T = Math.max(3, P.mrc || 0);
                    return Math.max(Math.abs(i.c2p(P.x) - s) - T, 1 - 3 / T);
                }, f = function(P) {
                    var T = Math.max(3, P.mrc || 0);
                    return Math.max(Math.abs(a.c2p(P.y) - l) - T, 1 - 3 / T);
                }, h = S_.quadrature(c, f), d = !1, v, x, b = 0; b < n.length; b++){
                    v = n[b];
                    for(var p = 0; p < (v.pts || []).length; p++){
                        x = v.pts[p];
                        var E = h(x);
                        E <= e.distance && (e.distance = E, d = [
                            b,
                            p
                        ]);
                    }
                }
                if (!d) return !1;
                v = n[d[0]], x = v.pts[d[1]];
                var k = i.c2p(x.x, !0), A = a.c2p(x.y, !0), L = x.mrc || 1;
                u = LV.extendFlat({}, e, {
                    index: x.i,
                    color: (o.marker || {}).color,
                    name: o.name,
                    x0: k - L,
                    x1: k + L,
                    y0: A - L,
                    y1: A + L,
                    spikeDistance: e.distance,
                    hovertemplate: o.hovertemplate
                });
                var _ = v.orig_p, C = _ !== void 0 ? _ : v.pos, M;
                o.orientation === "h" ? (M = a, u.xLabelVal = x.x, u.yLabelVal = C) : (M = i, u.xLabelVal = C, u.yLabelVal = x.y);
                var g = M._id.charAt(0);
                return u[g + "Spike"] = M.c2p(v.pos, !0), l1t(x, o, u), u;
            }
            k1e.exports = {
                hoverPoints: u1t,
                hoverOnBoxes: M1e,
                hoverOnPoints: E1e
            };
        });
        var L1e = ye((Wor, C1e)=>{
            "use strict";
            C1e.exports = function(t, r) {
                return r.hoverOnBox && (t.hoverOnBox = r.hoverOnBox), "xVal" in r && (t.x = r.xVal), "yVal" in r && (t.y = r.yVal), r.xa && (t.xaxis = r.xa), r.ya && (t.yaxis = r.ya), t;
            };
        });
        var IV = ye((Zor, P1e)=>{
            "use strict";
            P1e.exports = function(t, r) {
                var n = t.cd, i = t.xaxis, a = t.yaxis, o = [], s, l;
                if (r === !1) for(s = 0; s < n.length; s++)for(l = 0; l < (n[s].pts || []).length; l++)n[s].pts[l].selected = 0;
                else for(s = 0; s < n.length; s++)for(l = 0; l < (n[s].pts || []).length; l++){
                    var u = n[s].pts[l], c = i.c2p(u.x), f = a.c2p(u.y);
                    r.contains([
                        c,
                        f
                    ], null, u.i, t) ? (o.push({
                        pointNumber: u.i,
                        x: i.c2d(u.x),
                        y: a.c2d(u.y)
                    }), u.selected = 1) : u.selected = 0;
                }
                return o;
            };
        });
        var R1e = ye((Xor, I1e)=>{
            "use strict";
            I1e.exports = {
                attributes: v4(),
                layoutAttributes: p4(),
                supplyDefaults: m4().supplyDefaults,
                crossTraceDefaults: m4().crossTraceDefaults,
                supplyLayoutDefaults: VI().supplyLayoutDefaults,
                calc: MV(),
                crossTraceCalc: GI().crossTraceCalc,
                plot: jI().plot,
                style: WI().style,
                styleOnSelect: WI().styleOnSelect,
                hoverPoints: PV().hoverPoints,
                eventData: L1e(),
                selectPoints: IV(),
                moduleType: "trace",
                name: "box",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "symbols",
                    "oriented",
                    "box-violin",
                    "showLegend",
                    "boxLayout",
                    "zoomScale"
                ],
                meta: {}
            };
        });
        var z1e = ye((Yor, D1e)=>{
            "use strict";
            D1e.exports = R1e();
        });
        var ET = ye((Kor, F1e)=>{
            "use strict";
            var n0 = Uc(), c1t = vl(), f1t = Su(), RV = Oc().axisHoverFormat, h1t = Wo().hovertemplateAttrs, d1t = Wo().texttemplateAttrs, v1t = Jl(), Pp = no().extendFlat;
            F1e.exports = Pp({
                z: {
                    valType: "data_array",
                    editType: "calc"
                },
                x: Pp({}, n0.x, {
                    impliedEdits: {
                        xtype: "array"
                    }
                }),
                x0: Pp({}, n0.x0, {
                    impliedEdits: {
                        xtype: "scaled"
                    }
                }),
                dx: Pp({}, n0.dx, {
                    impliedEdits: {
                        xtype: "scaled"
                    }
                }),
                y: Pp({}, n0.y, {
                    impliedEdits: {
                        ytype: "array"
                    }
                }),
                y0: Pp({}, n0.y0, {
                    impliedEdits: {
                        ytype: "scaled"
                    }
                }),
                dy: Pp({}, n0.dy, {
                    impliedEdits: {
                        ytype: "scaled"
                    }
                }),
                xperiod: Pp({}, n0.xperiod, {
                    impliedEdits: {
                        xtype: "scaled"
                    }
                }),
                yperiod: Pp({}, n0.yperiod, {
                    impliedEdits: {
                        ytype: "scaled"
                    }
                }),
                xperiod0: Pp({}, n0.xperiod0, {
                    impliedEdits: {
                        xtype: "scaled"
                    }
                }),
                yperiod0: Pp({}, n0.yperiod0, {
                    impliedEdits: {
                        ytype: "scaled"
                    }
                }),
                xperiodalignment: Pp({}, n0.xperiodalignment, {
                    impliedEdits: {
                        xtype: "scaled"
                    }
                }),
                yperiodalignment: Pp({}, n0.yperiodalignment, {
                    impliedEdits: {
                        ytype: "scaled"
                    }
                }),
                text: {
                    valType: "data_array",
                    editType: "calc"
                },
                hovertext: {
                    valType: "data_array",
                    editType: "calc"
                },
                transpose: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "calc"
                },
                xtype: {
                    valType: "enumerated",
                    values: [
                        "array",
                        "scaled"
                    ],
                    editType: "calc+clearAxisTypes"
                },
                ytype: {
                    valType: "enumerated",
                    values: [
                        "array",
                        "scaled"
                    ],
                    editType: "calc+clearAxisTypes"
                },
                zsmooth: {
                    valType: "enumerated",
                    values: [
                        "fast",
                        "best",
                        !1
                    ],
                    dflt: !1,
                    editType: "calc"
                },
                hoverongaps: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "none"
                },
                connectgaps: {
                    valType: "boolean",
                    editType: "calc"
                },
                xgap: {
                    valType: "number",
                    dflt: 0,
                    min: 0,
                    editType: "plot"
                },
                ygap: {
                    valType: "number",
                    dflt: 0,
                    min: 0,
                    editType: "plot"
                },
                xhoverformat: RV("x"),
                yhoverformat: RV("y"),
                zhoverformat: RV("z", 1),
                hovertemplate: h1t(),
                texttemplate: d1t({
                    arrayOk: !1,
                    editType: "plot"
                }, {
                    keys: [
                        "x",
                        "y",
                        "z",
                        "text"
                    ]
                }),
                textfont: f1t({
                    editType: "plot",
                    autoSize: !0,
                    autoColor: !0,
                    colorEditType: "style"
                }),
                showlegend: Pp({}, c1t.showlegend, {
                    dflt: !1
                }),
                zorder: n0.zorder
            }, v1t("", {
                cLetter: "z",
                autoColorDflt: !1
            }));
        });
        var XI = ye((Jor, O1e)=>{
            "use strict";
            var p1t = uo(), ZI = Mr(), g1t = ba();
            O1e.exports = function(t, r, n, i, a, o) {
                var s = n("z");
                a = a || "x", o = o || "y";
                var l, u;
                if (s === void 0 || !s.length) return 0;
                if (ZI.isArray1D(s)) {
                    l = n(a), u = n(o);
                    var c = ZI.minRowLength(l), f = ZI.minRowLength(u);
                    if (c === 0 || f === 0) return 0;
                    r._length = Math.min(c, f, s.length);
                } else {
                    if (l = q1e(a, n), u = q1e(o, n), !m1t(s)) return 0;
                    n("transpose"), r._length = null;
                }
                var h = g1t.getComponentMethod("calendars", "handleTraceDefaults");
                return h(t, r, [
                    a,
                    o
                ], i), !0;
            };
            function q1e(e, t) {
                var r = t(e), n = r ? t(e + "type", "array") : "scaled";
                return n === "scaled" && (t(e + "0"), t("d" + e)), r;
            }
            function m1t(e) {
                for(var t = !0, r = !1, n = !1, i, a = 0; a < e.length; a++){
                    if (i = e[a], !ZI.isArrayOrTypedArray(i)) {
                        t = !1;
                        break;
                    }
                    i.length > 0 && (r = !0);
                    for(var o = 0; o < i.length; o++)if (p1t(i[o])) {
                        n = !0;
                        break;
                    }
                }
                return t && r && n;
            }
        });
        var y4 = ye(($or, N1e)=>{
            "use strict";
            var B1e = Mr();
            N1e.exports = function(t, r) {
                t("texttemplate");
                var n = B1e.extendFlat({}, r.font, {
                    color: "auto",
                    size: "auto"
                });
                B1e.coerceFont(t, "textfont", n);
            };
        });
        var DV = ye((Qor, U1e)=>{
            "use strict";
            U1e.exports = function(t, r, n) {
                var i = n("zsmooth");
                i === !1 && (n("xgap"), n("ygap")), n("zhoverformat");
            };
        });
        var G1e = ye((esr, H1e)=>{
            "use strict";
            var V1e = Mr(), y1t = XI(), _1t = y4(), x1t = Pg(), b1t = DV(), w1t = Uh(), T1t = ET();
            H1e.exports = function(t, r, n, i) {
                function a(s, l) {
                    return V1e.coerce(t, r, T1t, s, l);
                }
                var o = y1t(t, r, a, i);
                if (!o) {
                    r.visible = !1;
                    return;
                }
                x1t(t, r, i, a), a("xhoverformat"), a("yhoverformat"), a("text"), a("hovertext"), a("hovertemplate"), _1t(a, i), b1t(t, r, a, i), a("hoverongaps"), a("connectgaps", V1e.isArray1D(r.z) && r.zsmooth !== !1), w1t(t, r, i, a, {
                    prefix: "",
                    cLetter: "z"
                }), a("zorder");
            };
        });
        var zV = ye((tsr, j1e)=>{
            "use strict";
            var kT = uo();
            j1e.exports = {
                count: function(e, t, r) {
                    return r[e]++, 1;
                },
                sum: function(e, t, r, n) {
                    var i = n[t];
                    return kT(i) ? (i = Number(i), r[e] += i, i) : 0;
                },
                avg: function(e, t, r, n, i) {
                    var a = n[t];
                    return kT(a) && (a = Number(a), r[e] += a, i[e]++), 0;
                },
                min: function(e, t, r, n) {
                    var i = n[t];
                    if (kT(i)) {
                        if (i = Number(i), kT(r[e])) {
                            if (r[e] > i) {
                                var a = i - r[e];
                                return r[e] = i, a;
                            }
                        } else return r[e] = i, i;
                    }
                    return 0;
                },
                max: function(e, t, r, n) {
                    var i = n[t];
                    if (kT(i)) {
                        if (i = Number(i), kT(r[e])) {
                            if (r[e] < i) {
                                var a = i - r[e];
                                return r[e] = i, a;
                            }
                        } else return r[e] = i, i;
                    }
                    return 0;
                }
            };
        });
        var FV = ye((rsr, W1e)=>{
            "use strict";
            W1e.exports = {
                percent: function(e, t) {
                    for(var r = e.length, n = 100 / t, i = 0; i < r; i++)e[i] *= n;
                },
                probability: function(e, t) {
                    for(var r = e.length, n = 0; n < r; n++)e[n] /= t;
                },
                density: function(e, t, r, n) {
                    var i = e.length;
                    n = n || 1;
                    for(var a = 0; a < i; a++)e[a] *= r[a] * n;
                },
                "probability density": function(e, t, r, n) {
                    var i = e.length;
                    n && (t /= n);
                    for(var a = 0; a < i; a++)e[a] *= r[a] / t;
                }
            };
        });
        var qV = ye((isr, Z1e)=>{
            "use strict";
            Z1e.exports = function(t, r) {
                for(var n = t.length, i = 0, a = 0; a < n; a++)r[a] ? (t[a] /= r[a], i += t[a]) : t[a] = null;
                return i;
            };
        });
        var OV = ye((nsr, t_e)=>{
            "use strict";
            var CT = es(), a2 = CT.ONEAVGYEAR, X1e = CT.ONEAVGMONTH, KI = CT.ONEDAY, Y1e = CT.ONEHOUR, K1e = CT.ONEMIN, J1e = CT.ONESEC, $1e = Qa().tickIncrement;
            t_e.exports = function(t, r, n, i, a) {
                var o = -1.1 * r, s = -0.1 * r, l = t - s, u = n[0], c = n[1], f = Math.min(YI(u + s, u + l, i, a), YI(c + s, c + l, i, a)), h = Math.min(YI(u + o, u + s, i, a), YI(c + o, c + s, i, a)), d, v;
                if (f > h && h < Math.abs(c - u) / 4e3 ? (d = f, v = !1) : (d = Math.min(f, h), v = !0), i.type === "date" && d > KI) {
                    var x = d === a2 ? 1 : 6, b = d === a2 ? "M12" : "M1";
                    return function(p, E) {
                        var k = i.c2d(p, a2, a), A = k.indexOf("-", x);
                        A > 0 && (k = k.substr(0, A));
                        var L = i.d2c(k, 0, a);
                        if (L < p) {
                            var _ = $1e(L, b, !1, a);
                            (L + _) / 2 < p + t && (L = _);
                        }
                        return E && v ? $1e(L, b, !0, a) : L;
                    };
                }
                return function(p, E) {
                    var k = d * Math.round(p / d);
                    return k + d / 10 < p && k + d * .9 < p + t && (k += d), E && v && (k -= d), k;
                };
            };
            function YI(e, t, r, n) {
                if (e * t <= 0) return 1 / 0;
                for(var i = Math.abs(t - e), a = r.type === "date", o = Q1e(i, a), s = 0; s < 10; s++){
                    var l = Q1e(o * 80, a);
                    if (o === l) break;
                    if (A1t(l, e, t, a, r, n)) o = l;
                    else break;
                }
                return o;
            }
            function Q1e(e, t) {
                return t && e > J1e ? e > KI ? e > a2 * 1.1 ? a2 : e > X1e * 1.1 ? X1e : KI : e > Y1e ? Y1e : e > K1e ? K1e : J1e : Math.pow(10, Math.floor(Math.log(e) / Math.LN10));
            }
            function A1t(e, t, r, n, i, a) {
                if (n && e > KI) {
                    var o = e_e(t, i, a), s = e_e(r, i, a), l = e === a2 ? 0 : 1;
                    return o[l] !== s[l];
                }
                return Math.floor(r / e) - Math.floor(t / e) > .1;
            }
            function e_e(e, t, r) {
                var n = t.c2d(e, a2, r).split("-");
                return n[0] === "" && (n.unshift(), n[0] = "-" + n[0]), n;
            }
        });
        var UV = ye((asr, n_e)=>{
            "use strict";
            var BV = uo(), Vv = Mr(), r_e = ba(), H0 = Qa(), S1t = c4(), i_e = zV(), M1t = FV(), E1t = qV(), k1t = OV();
            function C1t(e, t) {
                var r = [], n = [], i = t.orientation === "h", a = H0.getFromId(e, i ? t.yaxis : t.xaxis), o = i ? "y" : "x", s = {
                    x: "y",
                    y: "x"
                }[o], l = t[o + "calendar"], u = t.cumulative, c, f = NV(e, t, a, o), h = f[0], d = f[1], v = typeof h.size == "string", x = [], b = v ? x : h, p = [], E = [], k = [], A = 0, L = t.histnorm, _ = t.histfunc, C = L.indexOf("density") !== -1, M, g, P;
                u.enabled && C && (L = L.replace(/ ?density$/, ""), C = !1);
                var T = _ === "max" || _ === "min", F = T ? null : 0, q = i_e.count, V = M1t[L], H = !1, X = function(me) {
                    return a.r2c(me, 0, l);
                }, G;
                for(Vv.isArrayOrTypedArray(t[s]) && _ !== "count" && (G = t[s], H = _ === "avg", q = i_e[_]), c = X(h.start), g = X(h.end) + (c - H0.tickIncrement(c, h.size, !1, l)) / 1e6; c < g && r.length < 1e6 && (M = H0.tickIncrement(c, h.size, !1, l), r.push((c + M) / 2), n.push(F), k.push([]), x.push(c), C && p.push(1 / (M - c)), H && E.push(0), !(M <= c));)c = M;
                x.push(c), !v && a.type === "date" && (b = {
                    start: X(b.start),
                    end: X(b.end),
                    size: b.size
                }), e._fullLayout._roundFnOpts || (e._fullLayout._roundFnOpts = {});
                var N = t["_" + o + "bingroup"], W = {
                    leftGap: 1 / 0,
                    rightGap: 1 / 0
                };
                N && (e._fullLayout._roundFnOpts[N] || (e._fullLayout._roundFnOpts[N] = W), W = e._fullLayout._roundFnOpts[N]);
                var re = n.length, ae = !0, _e = W.leftGap, Me = W.rightGap, ke = {};
                for(c = 0; c < d.length; c++){
                    var ge = d[c];
                    P = Vv.findBin(ge, b), P >= 0 && P < re && (A += q(P, c, n, G, E), ae && k[P].length && ge !== d[k[P][0]] && (ae = !1), k[P].push(c), ke[c] = P, _e = Math.min(_e, ge - x[P]), Me = Math.min(Me, x[P + 1] - ge));
                }
                W.leftGap = _e, W.rightGap = Me;
                var ie;
                ae || (ie = function(me, Re) {
                    return function() {
                        var ce = e._fullLayout._roundFnOpts[N];
                        return k1t(ce.leftGap, ce.rightGap, x, a, l)(me, Re);
                    };
                }), H && (A = E1t(n, E)), V && V(n, A, p), u.enabled && I1t(n, u.direction, u.currentbin);
                var Te = Math.min(r.length, n.length), Ee = [], Ae = 0, ze = Te - 1;
                for(c = 0; c < Te; c++)if (n[c]) {
                    Ae = c;
                    break;
                }
                for(c = Te - 1; c >= Ae; c--)if (n[c]) {
                    ze = c;
                    break;
                }
                for(c = Ae; c <= ze; c++)if (BV(r[c]) && BV(n[c])) {
                    var Ce = {
                        p: r[c],
                        s: n[c],
                        b: 0
                    };
                    u.enabled || (Ce.pts = k[c], ae ? Ce.ph0 = Ce.ph1 = k[c].length ? d[k[c][0]] : r[c] : (t._computePh = !0, Ce.ph0 = ie(x[c]), Ce.ph1 = ie(x[c + 1], !0))), Ee.push(Ce);
                }
                return Ee.length === 1 && (Ee[0].width1 = H0.tickIncrement(Ee[0].p, h.size, !1, l) - Ee[0].p), S1t(Ee, t), Vv.isArrayOrTypedArray(t.selectedpoints) && Vv.tagSelected(Ee, t, ke), Ee;
            }
            function NV(e, t, r, n, i) {
                var a = n + "bins", o = e._fullLayout, s = t["_" + n + "bingroup"], l = o._histogramBinOpts[s], u = o.barmode === "overlay", c, f, h, d, v, x, b, p = function(ge) {
                    return r.r2c(ge, 0, d);
                }, E = function(ge) {
                    return r.c2r(ge, 0, d);
                }, k = r.type === "date" ? function(ge) {
                    return ge || ge === 0 ? Vv.cleanDate(ge, null, d) : null;
                } : function(ge) {
                    return BV(ge) ? Number(ge) : null;
                };
                function A(ge, ie, Te) {
                    ie[ge + "Found"] ? (ie[ge] = k(ie[ge]), ie[ge] === null && (ie[ge] = Te[ge])) : (x[ge] = ie[ge] = Te[ge], Vv.nestedProperty(f[0], a + "." + ge).set(Te[ge]));
                }
                if (t["_" + n + "autoBinFinished"]) delete t["_" + n + "autoBinFinished"];
                else {
                    f = l.traces;
                    var L = [], _ = !0, C = !1, M = !1;
                    for(c = 0; c < f.length; c++)if (h = f[c], h.visible) {
                        var g = l.dirs[c];
                        v = h["_" + g + "pos0"] = r.makeCalcdata(h, g), L = Vv.concat(L, v), delete h["_" + n + "autoBinFinished"], t.visible === !0 && (_ ? _ = !1 : (delete h._autoBin, h["_" + n + "autoBinFinished"] = 1), r_e.traceIs(h, "2dMap") && (C = !0), h.type === "histogram2dcontour" && (M = !0));
                    }
                    d = f[0][n + "calendar"];
                    var P = H0.autoBin(L, r, l.nbins, C, d, l.sizeFound && l.size), T = f[0]._autoBin = {};
                    if (x = T[l.dirs[0]] = {}, M && (l.size || (P.start = E(H0.tickIncrement(p(P.start), P.size, !0, d))), l.end === void 0 && (P.end = E(H0.tickIncrement(p(P.end), P.size, !1, d)))), u && !r_e.traceIs(t, "2dMap") && P._dataSpan === 0 && r.type !== "category" && r.type !== "multicategory" && t.bingroup === "" && typeof t.xbins == "undefined") {
                        if (i) return [
                            P,
                            v,
                            !0
                        ];
                        P = L1t(e, t, r, n, a);
                    }
                    b = h.cumulative || {}, b.enabled && b.currentbin !== "include" && (b.direction === "decreasing" ? P.start = E(H0.tickIncrement(p(P.start), P.size, !0, d)) : P.end = E(H0.tickIncrement(p(P.end), P.size, !1, d))), l.size = P.size, l.sizeFound || (x.size = P.size, Vv.nestedProperty(f[0], a + ".size").set(P.size)), A("start", l, P), A("end", l, P);
                }
                v = t["_" + n + "pos0"], delete t["_" + n + "pos0"];
                var F = t._input[a] || {}, q = Vv.extendFlat({}, l), V = l.start, H = r.r2l(F.start), X = H !== void 0;
                if ((l.startFound || X) && H !== r.r2l(V)) {
                    var G = X ? H : Vv.aggNums(Math.min, null, v), N = {
                        type: r.type === "category" || r.type === "multicategory" ? "linear" : r.type,
                        r2l: r.r2l,
                        dtick: l.size,
                        tick0: V,
                        calendar: d,
                        range: [
                            G,
                            H0.tickIncrement(G, l.size, !1, d)
                        ].map(r.l2r)
                    }, W = H0.tickFirst(N);
                    W > r.r2l(G) && (W = H0.tickIncrement(W, l.size, !0, d)), q.start = r.l2r(W), X || Vv.nestedProperty(t, a + ".start").set(q.start);
                }
                var re = l.end, ae = r.r2l(F.end), _e = ae !== void 0;
                if ((l.endFound || _e) && ae !== r.r2l(re)) {
                    var Me = _e ? ae : Vv.aggNums(Math.max, null, v);
                    q.end = r.l2r(Me), _e || Vv.nestedProperty(t, a + ".start").set(q.end);
                }
                var ke = "autobin" + n;
                return t._input[ke] === !1 && (t._input[a] = Vv.extendFlat({}, t[a] || {}), delete t._input[ke], delete t[ke]), [
                    q,
                    v
                ];
            }
            function L1t(e, t, r, n, i) {
                var a = e._fullLayout, o = P1t(e, t), s = !1, l = 1 / 0, u = [
                    t
                ], c, f, h;
                for(c = 0; c < o.length; c++)if (f = o[c], f === t) s = !0;
                else if (!s) h = a._histogramBinOpts[f["_" + n + "bingroup"]], l = Math.min(l, h.size || f[i].size);
                else {
                    var d = NV(e, f, r, n, !0), v = d[0], x = d[2];
                    f["_" + n + "autoBinFinished"] = 1, f["_" + n + "pos0"] = d[1], x ? u.push(f) : l = Math.min(l, v.size);
                }
                var b = new Array(u.length);
                for(c = 0; c < u.length; c++)for(var p = u[c]["_" + n + "pos0"], E = 0; E < p.length; E++)if (p[E] !== void 0) {
                    b[c] = p[E];
                    break;
                }
                for(isFinite(l) || (l = Vv.distinctVals(b).minDiff), c = 0; c < u.length; c++){
                    f = u[c];
                    var k = f[n + "calendar"], A = {
                        start: r.c2r(b[c] - l / 2, 0, k),
                        end: r.c2r(b[c] + l / 2, 0, k),
                        size: l
                    };
                    f._input[i] = f[i] = A, h = a._histogramBinOpts[f["_" + n + "bingroup"]], h && Vv.extendFlat(h, A);
                }
                return t[i];
            }
            function P1t(e, t) {
                for(var r = t.xaxis, n = t.yaxis, i = t.orientation, a = [], o = e._fullData, s = 0; s < o.length; s++){
                    var l = o[s];
                    l.type === "histogram" && l.visible === !0 && l.orientation === i && l.xaxis === r && l.yaxis === n && a.push(l);
                }
                return a;
            }
            function I1t(e, t, r) {
                var n, i, a;
                function o(l) {
                    a = e[l], e[l] /= 2;
                }
                function s(l) {
                    i = e[l], e[l] = a + i / 2, a += i;
                }
                if (r === "half") {
                    if (t === "increasing") for(o(0), n = 1; n < e.length; n++)s(n);
                    else for(o(e.length - 1), n = e.length - 2; n >= 0; n--)s(n);
                } else if (t === "increasing") {
                    for(n = 1; n < e.length; n++)e[n] += e[n - 1];
                    r === "exclude" && (e.unshift(0), e.pop());
                } else {
                    for(n = e.length - 2; n >= 0; n--)e[n] += e[n + 1];
                    r === "exclude" && (e.push(0), e.shift());
                }
            }
            n_e.exports = {
                calc: C1t,
                calcAllAutoBins: NV
            };
        });
        var h_e = ye((osr, f_e)=>{
            "use strict";
            var a_e = Mr(), LT = Qa(), o_e = zV(), R1t = FV(), D1t = qV(), z1t = OV(), s_e = UV().calcAllAutoBins;
            f_e.exports = function(t, r) {
                var n = LT.getFromId(t, r.xaxis), i = LT.getFromId(t, r.yaxis), a = r.xcalendar, o = r.ycalendar, s = function(Et) {
                    return n.r2c(Et, 0, a);
                }, l = function(Et) {
                    return i.r2c(Et, 0, o);
                }, u = function(Et) {
                    return n.c2r(Et, 0, a);
                }, c = function(Et) {
                    return i.c2r(Et, 0, o);
                }, f, h, d, v, x = s_e(t, r, n, "x"), b = x[0], p = x[1], E = s_e(t, r, i, "y"), k = E[0], A = E[1], L = r._length;
                p.length > L && p.splice(L, p.length - L), A.length > L && A.splice(L, A.length - L);
                var _ = [], C = [], M = [], g = typeof b.size == "string", P = typeof k.size == "string", T = [], F = [], q = g ? T : b, V = P ? F : k, H = 0, X = [], G = [], N = r.histnorm, W = r.histfunc, re = N.indexOf("density") !== -1, ae = W === "max" || W === "min", _e = ae ? null : 0, Me = o_e.count, ke = R1t[N], ge = !1, ie = [], Te = [], Ee = "z" in r ? r.z : "marker" in r && Array.isArray(r.marker.color) ? r.marker.color : "";
                Ee && W !== "count" && (ge = W === "avg", Me = o_e[W]);
                var Ae = b.size, ze = s(b.start), Ce = s(b.end) + (ze - LT.tickIncrement(ze, Ae, !1, a)) / 1e6;
                for(f = ze; f < Ce; f = LT.tickIncrement(f, Ae, !1, a))C.push(_e), T.push(f), ge && M.push(0);
                T.push(f);
                var me = C.length, Re = (f - ze) / me, ce = u(ze + Re / 2), Ge = k.size, nt = l(k.start), ct = l(k.end) + (nt - LT.tickIncrement(nt, Ge, !1, o)) / 1e6;
                for(f = nt; f < ct; f = LT.tickIncrement(f, Ge, !1, o)){
                    _.push(C.slice()), F.push(f);
                    var qt = new Array(me);
                    for(h = 0; h < me; h++)qt[h] = [];
                    G.push(qt), ge && X.push(M.slice());
                }
                F.push(f);
                var rt = _.length, ot = (f - nt) / rt, Rt = c(nt + ot / 2);
                re && (ie = l_e(C.length, q, Re, g), Te = l_e(_.length, V, ot, P)), !g && n.type === "date" && (q = u_e(s, q)), !P && i.type === "date" && (V = u_e(l, V));
                var kt = !0, Ct = !0, Yt = new Array(me), xr = new Array(rt), er = 1 / 0, Ke = 1 / 0, xt = 1 / 0, bt = 1 / 0;
                for(f = 0; f < L; f++){
                    var Lt = p[f], St = A[f];
                    d = a_e.findBin(Lt, q), v = a_e.findBin(St, V), d >= 0 && d < me && v >= 0 && v < rt && (H += Me(d, f, _[v], Ee, X[v]), G[v][d].push(f), kt && (Yt[d] === void 0 ? Yt[d] = Lt : Yt[d] !== Lt && (kt = !1)), Ct && (xr[v] === void 0 ? xr[v] = St : xr[v] !== St && (Ct = !1)), er = Math.min(er, Lt - T[d]), Ke = Math.min(Ke, T[d + 1] - Lt), xt = Math.min(xt, St - F[v]), bt = Math.min(bt, F[v + 1] - St));
                }
                if (ge) for(v = 0; v < rt; v++)H += D1t(_[v], X[v]);
                if (ke) for(v = 0; v < rt; v++)ke(_[v], H, ie, Te[v]);
                return {
                    x: p,
                    xRanges: c_e(T, kt && Yt, er, Ke, n, a),
                    x0: ce,
                    dx: Re,
                    y: A,
                    yRanges: c_e(F, Ct && xr, xt, bt, i, o),
                    y0: Rt,
                    dy: ot,
                    z: _,
                    pts: G
                };
            };
            function l_e(e, t, r, n) {
                var i = new Array(e), a;
                if (n) for(a = 0; a < e; a++)i[a] = 1 / (t[a + 1] - t[a]);
                else {
                    var o = 1 / r;
                    for(a = 0; a < e; a++)i[a] = o;
                }
                return i;
            }
            function u_e(e, t) {
                return {
                    start: e(t.start),
                    end: e(t.end),
                    size: t.size
                };
            }
            function c_e(e, t, r, n, i, a) {
                var o, s = e.length - 1, l = new Array(s), u = z1t(r, n, e, i, a);
                for(o = 0; o < s; o++){
                    var c = (t || [])[o];
                    l[o] = c === void 0 ? [
                        u(e[o]),
                        u(e[o + 1], !0)
                    ] : [
                        c,
                        c
                    ];
                }
                return l;
            }
        });
        var JI = ye((ssr, p_e)=>{
            "use strict";
            var Im = Mr(), d_e = es().BADNUM, v_e = Rg();
            p_e.exports = function(t, r, n, i, a, o) {
                var s = t._length, l = r.makeCalcdata(t, i), u = n.makeCalcdata(t, a);
                l = v_e(t, r, i, l).vals, u = v_e(t, n, a, u).vals;
                var c = t.text, f = c !== void 0 && Im.isArray1D(c), h = t.hovertext, d = h !== void 0 && Im.isArray1D(h), v, x, b = Im.distinctVals(l), p = b.vals, E = Im.distinctVals(u), k = E.vals, A = [], L, _, C = k.length, M = p.length;
                for(v = 0; v < o.length; v++)A[v] = Im.init2dArray(C, M);
                f && (L = Im.init2dArray(C, M)), d && (_ = Im.init2dArray(C, M));
                var g = Im.init2dArray(C, M);
                for(v = 0; v < s; v++)if (l[v] !== d_e && u[v] !== d_e) {
                    var P = Im.findBin(l[v] + b.minDiff / 2, p), T = Im.findBin(u[v] + E.minDiff / 2, k);
                    for(x = 0; x < o.length; x++){
                        var F = o[x], q = t[F], V = A[x];
                        V[T][P] = q[v], g[T][P] = v;
                    }
                    f && (L[T][P] = c[v]), d && (_[T][P] = h[v]);
                }
                for(t["_" + i] = p, t["_" + a] = k, x = 0; x < o.length; x++)t["_" + o[x]] = A[x];
                f && (t._text = L), d && (t._hovertext = _), r && r.type === "category" && (t["_" + i + "CategoryMap"] = p.map(function(H) {
                    return r._categories[H];
                })), n && n.type === "category" && (t["_" + a + "CategoryMap"] = k.map(function(H) {
                    return n._categories[H];
                })), t._after2before = g;
            };
        });
        var QI = ye((lsr, g_e)=>{
            "use strict";
            var F1t = uo(), q1t = Mr(), $I = es().BADNUM;
            g_e.exports = function(t, r, n, i) {
                var a, o, s, l, u, c;
                function f(p) {
                    if (F1t(p)) return +p;
                }
                if (r && r.transpose) {
                    for(a = 0, u = 0; u < t.length; u++)a = Math.max(a, t[u].length);
                    if (a === 0) return !1;
                    s = function(p) {
                        return p.length;
                    }, l = function(p, E, k) {
                        return (p[k] || [])[E];
                    };
                } else a = t.length, s = function(p, E) {
                    return p[E].length;
                }, l = function(p, E, k) {
                    return (p[E] || [])[k];
                };
                var h = function(p, E, k) {
                    return E === $I || k === $I ? $I : l(p, E, k);
                };
                function d(p) {
                    if (r && r.type !== "carpet" && r.type !== "contourcarpet" && p && p.type === "category" && r["_" + p._id.charAt(0)].length) {
                        var E = p._id.charAt(0), k = {}, A = r["_" + E + "CategoryMap"] || r[E];
                        for(u = 0; u < A.length; u++)k[A[u]] = u;
                        return function(L) {
                            var _ = k[p._categories[L]];
                            return _ + 1 ? _ : $I;
                        };
                    } else return q1t.identity;
                }
                var v = d(n), x = d(i);
                i && i.type === "category" && (a = i._categories.length);
                var b = new Array(a);
                for(u = 0; u < a; u++)for(n && n.type === "category" ? o = n._categories.length : o = s(t, u), b[u] = new Array(o), c = 0; c < o; c++)b[u][c] = f(h(t, x(u), v(c)));
                return b;
            };
        });
        var e8 = ye((usr, __e)=>{
            "use strict";
            var O1t = Mr(), m_e = .01, B1t = [
                [
                    -1,
                    0
                ],
                [
                    1,
                    0
                ],
                [
                    0,
                    -1
                ],
                [
                    0,
                    1
                ]
            ];
            function N1t(e) {
                return .5 - .25 * Math.min(1, e * .5);
            }
            __e.exports = function(t, r) {
                var n = 1, i;
                for(y_e(t, r), i = 0; i < r.length && !(r[i][2] < 4); i++);
                for(r = r.slice(i), i = 0; i < 100 && n > m_e; i++)n = y_e(t, r, N1t(n));
                return n > m_e && O1t.log("interp2d didn't converge quickly", n), t;
            };
            function y_e(e, t, r) {
                var n = 0, i, a, o, s, l, u, c, f, h, d, v, x, b;
                for(s = 0; s < t.length; s++){
                    for(i = t[s], a = i[0], o = i[1], v = e[a][o], d = 0, h = 0, l = 0; l < 4; l++)u = B1t[l], c = e[a + u[0]], c && (f = c[o + u[1]], f !== void 0 && (d === 0 ? x = b = f : (x = Math.min(x, f), b = Math.max(b, f)), h++, d += f));
                    if (h === 0) throw "iterateInterp2d order is wrong: no defined neighbors";
                    e[a][o] = d / h, v === void 0 ? h < 4 && (n = 1) : (e[a][o] = (1 + r) * e[a][o] - r * v, b > x && (n = Math.max(n, Math.abs(e[a][o] - v) / (b - x))));
                }
                return n;
            }
        });
        var t8 = ye((csr, x_e)=>{
            "use strict";
            var U1t = Mr().maxRowLength;
            x_e.exports = function(t) {
                var r = [], n = {}, i = [], a = t[0], o = [], s = [
                    0,
                    0,
                    0
                ], l = U1t(t), u, c, f, h, d, v, x, b;
                for(c = 0; c < t.length; c++)for(u = o, o = a, a = t[c + 1] || [], f = 0; f < l; f++)o[f] === void 0 && (v = (o[f - 1] !== void 0 ? 1 : 0) + (o[f + 1] !== void 0 ? 1 : 0) + (u[f] !== void 0 ? 1 : 0) + (a[f] !== void 0 ? 1 : 0), v ? (c === 0 && v++, f === 0 && v++, c === t.length - 1 && v++, f === o.length - 1 && v++, v < 4 && (n[[
                    c,
                    f
                ]] = [
                    c,
                    f,
                    v
                ]), r.push([
                    c,
                    f,
                    v
                ])) : i.push([
                    c,
                    f
                ]));
                for(; i.length;){
                    for(x = {}, b = !1, d = i.length - 1; d >= 0; d--)h = i[d], c = h[0], f = h[1], v = ((n[[
                        c - 1,
                        f
                    ]] || s)[2] + (n[[
                        c + 1,
                        f
                    ]] || s)[2] + (n[[
                        c,
                        f - 1
                    ]] || s)[2] + (n[[
                        c,
                        f + 1
                    ]] || s)[2]) / 20, v && (x[h] = [
                        c,
                        f,
                        v
                    ], i.splice(d, 1), b = !0);
                    if (!b) throw "findEmpties iterated with no new neighbors";
                    for(h in x)n[h] = x[h], r.push(x[h]);
                }
                return r.sort(function(p, E) {
                    return E[2] - p[2];
                });
            };
        });
        var VV = ye((fsr, T_e)=>{
            "use strict";
            var b_e = ba(), w_e = Mr().isArrayOrTypedArray;
            T_e.exports = function(t, r, n, i, a, o) {
                var s = [], l = b_e.traceIs(t, "contour"), u = b_e.traceIs(t, "histogram"), c, f, h, d = w_e(r) && r.length > 1;
                if (d && !u && o.type !== "category") {
                    var v = r.length;
                    if (v <= a) {
                        if (l) s = Array.from(r).slice(0, a);
                        else if (a === 1) o.type === "log" ? s = [
                            .5 * r[0],
                            2 * r[0]
                        ] : s = [
                            r[0] - .5,
                            r[0] + .5
                        ];
                        else if (o.type === "log") {
                            for(s = [
                                Math.pow(r[0], 1.5) / Math.pow(r[1], .5)
                            ], h = 1; h < v; h++)s.push(Math.sqrt(r[h - 1] * r[h]));
                            s.push(Math.pow(r[v - 1], 1.5) / Math.pow(r[v - 2], .5));
                        } else {
                            for(s = [
                                1.5 * r[0] - .5 * r[1]
                            ], h = 1; h < v; h++)s.push((r[h - 1] + r[h]) * .5);
                            s.push(1.5 * r[v - 1] - .5 * r[v - 2]);
                        }
                        if (v < a) {
                            var x = s[s.length - 1], b;
                            if (o.type === "log") for(b = x / s[s.length - 2], h = v; h < a; h++)x *= b, s.push(x);
                            else for(b = x - s[s.length - 2], h = v; h < a; h++)x += b, s.push(x);
                        }
                    } else return l ? r.slice(0, a) : r.slice(0, a + 1);
                } else {
                    var p = t[o._id.charAt(0) + "calendar"];
                    if (u) c = o.r2c(n, 0, p);
                    else if (w_e(r) && r.length === 1) c = r[0];
                    else if (n === void 0) c = 0;
                    else {
                        var E = o.type === "log" ? o.d2c : o.r2c;
                        c = E(n, 0, p);
                    }
                    for(f = i || 1, h = l ? 0 : -0.5; h < a; h++)s.push(c + f * h);
                }
                return s;
            };
        });
        var n8 = ye((hsr, E_e)=>{
            "use strict";
            var A_e = ba(), HV = Mr(), r8 = Qa(), S_e = Rg(), V1t = h_e(), H1t = zv(), G1t = JI(), j1t = QI(), W1t = e8(), Z1t = t8(), i8 = VV(), GV = es().BADNUM;
            E_e.exports = function(t, r) {
                var n = r8.getFromId(t, r.xaxis || "x"), i = r8.getFromId(t, r.yaxis || "y"), a = A_e.traceIs(r, "contour"), o = A_e.traceIs(r, "histogram"), s = a ? "best" : r.zsmooth, l, u, c, f, h, d, v, x, b, p, E;
                if (n._minDtick = 0, i._minDtick = 0, o) E = V1t(t, r), f = E.orig_x, l = E.x, u = E.x0, c = E.dx, x = E.orig_y, h = E.y, d = E.y0, v = E.dy, b = E.z;
                else {
                    var k = r.z;
                    HV.isArray1D(k) ? (G1t(r, n, i, "x", "y", [
                        "z"
                    ]), l = r._x, h = r._y, k = r._z) : (f = r.x ? n.makeCalcdata(r, "x") : [], x = r.y ? i.makeCalcdata(r, "y") : [], l = S_e(r, n, "x", f).vals, h = S_e(r, i, "y", x).vals, r._x = l, r._y = h), u = r.x0, c = r.dx, d = r.y0, v = r.dy, b = j1t(k, r, n, i);
                }
                (n.rangebreaks || i.rangebreaks) && (b = X1t(l, h, b), o || (l = M_e(l), h = M_e(h), r._x = l, r._y = h)), !o && (a || r.connectgaps) && (r._emptypoints = Z1t(b), W1t(b, r._emptypoints));
                function A(q) {
                    s = r._input.zsmooth = r.zsmooth = !1, HV.warn('cannot use zsmooth: "fast": ' + q);
                }
                function L(q) {
                    if (q.length > 1) {
                        var V = (q[q.length - 1] - q[0]) / (q.length - 1), H = Math.abs(V / 100);
                        for(p = 0; p < q.length - 1; p++)if (Math.abs(q[p + 1] - q[p] - V) > H) return !1;
                    }
                    return !0;
                }
                r._islinear = !1, n.type === "log" || i.type === "log" ? s === "fast" && A("log axis found") : L(l) ? L(h) ? r._islinear = !0 : s === "fast" && A("y scale is not linear") : s === "fast" && A("x scale is not linear");
                var _ = HV.maxRowLength(b), C = r.xtype === "scaled" ? "" : l, M = i8(r, C, u, c, _, n), g = r.ytype === "scaled" ? "" : h, P = i8(r, g, d, v, b.length, i);
                r._extremes[n._id] = r8.findExtremes(n, M), r._extremes[i._id] = r8.findExtremes(i, P);
                var T = {
                    x: M,
                    y: P,
                    z: b,
                    text: r._text || r.text,
                    hovertext: r._hovertext || r.hovertext
                };
                if (r.xperiodalignment && f && (T.orig_x = f), r.yperiodalignment && x && (T.orig_y = x), C && C.length === M.length - 1 && (T.xCenter = C), g && g.length === P.length - 1 && (T.yCenter = g), o && (T.xRanges = E.xRanges, T.yRanges = E.yRanges, T.pts = E.pts), a || H1t(t, r, {
                    vals: b,
                    cLetter: "z"
                }), a && r.contours && r.contours.coloring === "heatmap") {
                    var F = {
                        type: r.type === "contour" ? "heatmap" : "histogram2d",
                        xcalendar: r.xcalendar,
                        ycalendar: r.ycalendar
                    };
                    T.xfill = i8(F, C, u, c, _, n), T.yfill = i8(F, g, d, v, b.length, i);
                }
                return [
                    T
                ];
            };
            function M_e(e) {
                for(var t = [], r = e.length, n = 0; n < r; n++){
                    var i = e[n];
                    i !== GV && t.push(i);
                }
                return t;
            }
            function X1t(e, t, r) {
                for(var n = [], i = -1, a = 0; a < r.length; a++)if (t[a] !== GV) {
                    i++, n[i] = [];
                    for(var o = 0; o < r[a].length; o++)e[o] !== GV && n[i].push(r[a][o]);
                }
                return n;
            }
        });
        var o8 = ye((a8)=>{
            "use strict";
            a8.CSS_DECLARATIONS = [
                [
                    "image-rendering",
                    "optimizeSpeed"
                ],
                [
                    "image-rendering",
                    "-moz-crisp-edges"
                ],
                [
                    "image-rendering",
                    "-o-crisp-edges"
                ],
                [
                    "image-rendering",
                    "-webkit-optimize-contrast"
                ],
                [
                    "image-rendering",
                    "optimize-contrast"
                ],
                [
                    "image-rendering",
                    "crisp-edges"
                ],
                [
                    "image-rendering",
                    "pixelated"
                ]
            ];
            a8.STYLE = a8.CSS_DECLARATIONS.map(function(e) {
                return e.join(": ") + "; ";
            }).join("");
        });
        var jV = ye((vsr, L_e)=>{
            "use strict";
            var k_e = o8(), Y1t = ao(), C_e = Mr(), PT = null;
            function K1t() {
                if (PT !== null) return PT;
                PT = !1;
                var e = C_e.isSafari() || C_e.isIOS();
                if (window.navigator.userAgent && !e) {
                    var t = Array.from(k_e.CSS_DECLARATIONS).reverse(), r = window.CSS && window.CSS.supports || window.supportsCSS;
                    if (typeof r == "function") PT = t.some(function(o) {
                        return r.apply(null, o);
                    });
                    else {
                        var n = Y1t.tester.append("image").attr("style", k_e.STYLE), i = window.getComputedStyle(n.node()), a = i.imageRendering;
                        PT = t.some(function(o) {
                            var s = o[1];
                            return a === s || a === s.toLowerCase();
                        }), n.remove();
                    }
                }
                return PT;
            }
            L_e.exports = K1t;
        });
        var s8 = ye((psr, B_e)=>{
            "use strict";
            var P_e = xa(), J1t = id(), $1t = ba(), Q1t = ao(), e_t = Qa(), G0 = Mr(), I_e = Pl(), t_t = $P(), r_t = va(), i_t = Mu().extractOpts, n_t = Mu().makeColorScaleFuncFromTrace, a_t = Zp(), o_t = Nh(), WV = o_t.LINE_SPACING, s_t = jV(), l_t = o8().STYLE, q_e = "heatmap-label";
            function O_e(e) {
                return e.selectAll("g." + q_e);
            }
            function R_e(e) {
                O_e(e).remove();
            }
            B_e.exports = function(e, t, r, n) {
                var i = t.xaxis, a = t.yaxis;
                G0.makeTraceGroups(n, r, "hm").each(function(o) {
                    var s = P_e.select(this), l = o[0], u = l.trace, c = u.xgap || 0, f = u.ygap || 0, h = l.z, d = l.x, v = l.y, x = l.xCenter, b = l.yCenter, p = $1t.traceIs(u, "contour"), E = p ? "best" : u.zsmooth, k = h.length, A = G0.maxRowLength(h), L = !1, _ = !1, C, M, g, P, T, F, q, V;
                    for(F = 0; C === void 0 && F < d.length - 1;)C = i.c2p(d[F]), F++;
                    for(F = d.length - 1; M === void 0 && F > 0;)M = i.c2p(d[F]), F--;
                    for(M < C && (g = M, M = C, C = g, L = !0), F = 0; P === void 0 && F < v.length - 1;)P = a.c2p(v[F]), F++;
                    for(F = v.length - 1; T === void 0 && F > 0;)T = a.c2p(v[F]), F--;
                    T < P && (g = P, P = T, T = g, _ = !0), p && (x = d, b = v, d = l.xfill, v = l.yfill);
                    var H = "default";
                    if (E ? H = E === "best" ? "smooth" : "fast" : u._islinear && c === 0 && f === 0 && s_t() && (H = "fast"), H !== "fast") {
                        var X = E === "best" ? 0 : .5;
                        C = Math.max(-X * i._length, C), M = Math.min((1 + X) * i._length, M), P = Math.max(-X * a._length, P), T = Math.min((1 + X) * a._length, T);
                    }
                    var G = Math.round(M - C), N = Math.round(T - P), W = C >= i._length || M <= 0 || P >= a._length || T <= 0;
                    if (W) {
                        var re = s.selectAll("image").data([]);
                        re.exit().remove(), R_e(s);
                        return;
                    }
                    var ae, _e;
                    H === "fast" ? (ae = A, _e = k) : (ae = G, _e = N);
                    var Me = document.createElement("canvas");
                    Me.width = ae, Me.height = _e;
                    var ke = Me.getContext("2d", {
                        willReadFrequently: !0
                    }), ge = n_t(u, {
                        noNumericCheck: !0,
                        returnArray: !0
                    }), ie, Te;
                    H === "fast" ? (ie = L ? function(Pi) {
                        return A - 1 - Pi;
                    } : G0.identity, Te = _ ? function(Pi) {
                        return k - 1 - Pi;
                    } : G0.identity) : (ie = function(Pi) {
                        return G0.constrain(Math.round(i.c2p(d[Pi]) - C), 0, G);
                    }, Te = function(Pi) {
                        return G0.constrain(Math.round(a.c2p(v[Pi]) - P), 0, N);
                    });
                    var Ee = Te(0), Ae = [
                        Ee,
                        Ee
                    ], ze = L ? 0 : 1, Ce = _ ? 0 : 1, me = 0, Re = 0, ce = 0, Ge = 0, nt, ct, qt, rt, ot;
                    function Rt(Pi, Gi) {
                        if (Pi !== void 0) {
                            var Ki = ge(Pi);
                            return Ki[0] = Math.round(Ki[0]), Ki[1] = Math.round(Ki[1]), Ki[2] = Math.round(Ki[2]), me += Gi, Re += Ki[0] * Gi, ce += Ki[1] * Gi, Ge += Ki[2] * Gi, Ki;
                        }
                        return [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    function kt(Pi, Gi, Ki, ka) {
                        var jn = Pi[Ki.bin0];
                        if (jn === void 0) return Rt(void 0, 1);
                        var la = Pi[Ki.bin1], Fa = Gi[Ki.bin0], Ra = Gi[Ki.bin1], jo = la - jn || 0, oa = Fa - jn || 0, Sn;
                        return la === void 0 ? Ra === void 0 ? Sn = 0 : Fa === void 0 ? Sn = 2 * (Ra - jn) : Sn = (2 * Ra - Fa - jn) * 2 / 3 : Ra === void 0 ? Fa === void 0 ? Sn = 0 : Sn = (2 * jn - la - Fa) * 2 / 3 : Fa === void 0 ? Sn = (2 * Ra - la - jn) * 2 / 3 : Sn = Ra + jn - la - Fa, Rt(jn + Ki.frac * jo + ka.frac * (oa + Ki.frac * Sn));
                    }
                    if (H !== "default") {
                        var Ct = 0, Yt;
                        try {
                            Yt = new Uint8Array(ae * _e * 4);
                        } catch (Pi) {
                            Yt = new Array(ae * _e * 4);
                        }
                        if (H === "smooth") {
                            var xr = x || d, er = b || v, Ke = new Array(xr.length), xt = new Array(er.length), bt = new Array(G), Lt = x ? z_e : D_e, St = b ? z_e : D_e, Et, dt, Ht;
                            for(F = 0; F < xr.length; F++)Ke[F] = Math.round(i.c2p(xr[F]) - C);
                            for(F = 0; F < er.length; F++)xt[F] = Math.round(a.c2p(er[F]) - P);
                            for(F = 0; F < G; F++)bt[F] = Lt(F, Ke);
                            for(q = 0; q < N; q++)for(Et = St(q, xt), dt = h[Et.bin0], Ht = h[Et.bin1], F = 0; F < G; F++, Ct += 4)ot = kt(dt, Ht, bt[F], Et), F_e(Yt, Ct, ot);
                        } else for(q = 0; q < k; q++)for(rt = h[q], Ae = Te(q), F = 0; F < A; F++)ot = Rt(rt[F], 1), Ct = (Ae * A + ie(F)) * 4, F_e(Yt, Ct, ot);
                        var $t = ke.createImageData(ae, _e);
                        try {
                            $t.data.set(Yt);
                        } catch (Pi) {
                            var fr = $t.data, _r = fr.length;
                            for(q = 0; q < _r; q++)fr[q] = Yt[q];
                        }
                        ke.putImageData($t, 0, 0);
                    } else {
                        var Br = Math.floor(c / 2), Or = Math.floor(f / 2);
                        for(q = 0; q < k; q++)if (rt = h[q], Ae.reverse(), Ae[Ce] = Te(q + 1), !(Ae[0] === Ae[1] || Ae[0] === void 0 || Ae[1] === void 0)) for(ct = ie(0), nt = [
                            ct,
                            ct
                        ], F = 0; F < A; F++)nt.reverse(), nt[ze] = ie(F + 1), !(nt[0] === nt[1] || nt[0] === void 0 || nt[1] === void 0) && (qt = rt[F], ot = Rt(qt, (nt[1] - nt[0]) * (Ae[1] - Ae[0])), ke.fillStyle = "rgba(" + ot.join(",") + ")", ke.fillRect(nt[0] + Br, Ae[0] + Or, nt[1] - nt[0] - c, Ae[1] - Ae[0] - f));
                    }
                    Re = Math.round(Re / me), ce = Math.round(ce / me), Ge = Math.round(Ge / me);
                    var Nr = J1t("rgb(" + Re + "," + ce + "," + Ge + ")");
                    e._hmpixcount = (e._hmpixcount || 0) + me, e._hmlumcount = (e._hmlumcount || 0) + me * Nr.getLuminance();
                    var ut = s.selectAll("image").data(o);
                    ut.enter().append("svg:image").attr({
                        xmlns: a_t.svg,
                        preserveAspectRatio: "none"
                    }), ut.attr({
                        height: N,
                        width: G,
                        x: C,
                        y: P,
                        "xlink:href": Me.toDataURL("image/png")
                    }), H === "fast" && !E && ut.attr("style", l_t), R_e(s);
                    var Ne = u.texttemplate;
                    if (Ne) {
                        var Ye = i_t(u), Ve = {
                            type: "linear",
                            range: [
                                Ye.min,
                                Ye.max
                            ],
                            _separators: i._separators,
                            _numFormat: i._numFormat
                        }, Xe = u.type === "histogram2dcontour", ht = u.type === "contour", Le = ht ? 1 : 0, xe = ht ? k - 1 : k, Se = ht ? 1 : 0, lt = ht ? A - 1 : A, Gt = [];
                        for(F = Le; F < xe; F++){
                            var Vt;
                            if (ht) Vt = l.y[F];
                            else if (Xe) {
                                if (F === 0 || F === k - 1) continue;
                                Vt = l.y[F];
                            } else if (l.yCenter) Vt = l.yCenter[F];
                            else {
                                if (F + 1 === k && l.y[F + 1] === void 0) continue;
                                Vt = (l.y[F] + l.y[F + 1]) / 2;
                            }
                            var ar = Math.round(a.c2p(Vt));
                            if (!(0 > ar || ar > a._length)) for(q = Se; q < lt; q++){
                                var Qr;
                                if (ht) Qr = l.x[q];
                                else if (Xe) {
                                    if (q === 0 || q === A - 1) continue;
                                    Qr = l.x[q];
                                } else if (l.xCenter) Qr = l.xCenter[q];
                                else {
                                    if (q + 1 === A && l.x[q + 1] === void 0) continue;
                                    Qr = (l.x[q] + l.x[q + 1]) / 2;
                                }
                                var ai = Math.round(i.c2p(Qr));
                                if (!(0 > ai || ai > i._length)) {
                                    var jr = t_t({
                                        x: Qr,
                                        y: Vt
                                    }, u, e._fullLayout);
                                    jr.x = Qr, jr.y = Vt;
                                    var ri = l.z[F][q];
                                    ri === void 0 ? (jr.z = "", jr.zLabel = "") : (jr.z = ri, jr.zLabel = e_t.tickText(Ve, ri, "hover").text);
                                    var bi = l.text && l.text[F] && l.text[F][q];
                                    (bi === void 0 || bi === !1) && (bi = ""), jr.text = bi;
                                    var nn = G0.texttemplateString(Ne, jr, e._fullLayout._d3locale, jr, u._meta || {});
                                    if (nn) {
                                        var Wi = nn.split("<br>"), Ni = Wi.length, _n = 0;
                                        for(V = 0; V < Ni; V++)_n = Math.max(_n, Wi[V].length);
                                        Gt.push({
                                            l: Ni,
                                            c: _n,
                                            t: nn,
                                            x: ai,
                                            y: ar,
                                            z: ri
                                        });
                                    }
                                }
                            }
                        }
                        var $i = u.textfont, zn = $i.size, Wn = e._fullLayout.font.size;
                        if (!zn || zn === "auto") {
                            var It = 1 / 0, ft = 1 / 0, jt = 0, Zt = 0;
                            for(V = 0; V < Gt.length; V++){
                                var yr = Gt[V];
                                if (jt = Math.max(jt, yr.l), Zt = Math.max(Zt, yr.c), V < Gt.length - 1) {
                                    var Fr = Gt[V + 1], Zr = Math.abs(Fr.x - yr.x), Vr = Math.abs(Fr.y - yr.y);
                                    Zr && (It = Math.min(It, Zr)), Vr && (ft = Math.min(ft, Vr));
                                }
                            }
                            !isFinite(It) || !isFinite(ft) ? zn = Wn : (It -= c, ft -= f, It /= Zt, ft /= jt, It /= WV / 2, ft /= WV, zn = Math.min(Math.floor(It), Math.floor(ft), Wn));
                        }
                        if (zn <= 0 || !isFinite(zn)) return;
                        var gi = function(Pi) {
                            return Pi.x;
                        }, Si = function(Pi) {
                            return Pi.y - zn * (Pi.l * WV / 2 - 1);
                        }, Mi = O_e(s).data(Gt);
                        Mi.enter().append("g").classed(q_e, 1).append("text").attr("text-anchor", "middle").each(function(Pi) {
                            var Gi = P_e.select(this), Ki = $i.color;
                            (!Ki || Ki === "auto") && (Ki = r_t.contrast(Pi.z === void 0 ? e._fullLayout.plot_bgcolor : "rgba(" + ge(Pi.z).join() + ")")), Gi.attr("data-notex", 1).call(I_e.positionText, gi(Pi), Si(Pi)).call(Q1t.font, {
                                family: $i.family,
                                size: zn,
                                color: Ki,
                                weight: $i.weight,
                                style: $i.style,
                                variant: $i.variant,
                                textcase: $i.textcase,
                                lineposition: $i.lineposition,
                                shadow: $i.shadow
                            }).text(Pi.t).call(I_e.convertToTspans, e);
                        });
                    }
                });
            };
            function D_e(e, t) {
                var r = t.length - 2, n = G0.constrain(G0.findBin(e, t), 0, r), i = t[n], a = t[n + 1], o = G0.constrain(n + (e - i) / (a - i) - .5, 0, r), s = Math.round(o), l = Math.abs(o - s);
                return !o || o === r || !l ? {
                    bin0: s,
                    bin1: s,
                    frac: 0
                } : {
                    bin0: s,
                    frac: l,
                    bin1: Math.round(s + l / (o - s))
                };
            }
            function z_e(e, t) {
                var r = t.length - 1, n = G0.constrain(G0.findBin(e, t), 0, r), i = t[n], a = t[n + 1], o = (e - i) / (a - i) || 0;
                return o <= 0 ? {
                    bin0: n,
                    bin1: n,
                    frac: 0
                } : o < .5 ? {
                    bin0: n,
                    bin1: n + 1,
                    frac: o
                } : {
                    bin0: n + 1,
                    bin1: n,
                    frac: 1 - o
                };
            }
            function F_e(e, t, r) {
                e[t] = r[0], e[t + 1] = r[1], e[t + 2] = r[2], e[t + 3] = Math.round(r[3] * 255);
            }
        });
        var M_ = ye((gsr, N_e)=>{
            "use strict";
            N_e.exports = {
                min: "zmin",
                max: "zmax"
            };
        });
        var l8 = ye((msr, U_e)=>{
            "use strict";
            var u_t = xa();
            U_e.exports = function(t) {
                u_t.select(t).selectAll(".hm image").style("opacity", function(r) {
                    return r.trace.opacity;
                });
            };
        });
        var c8 = ye((ysr, H_e)=>{
            "use strict";
            var V_e = Nc(), _4 = Mr(), u8 = _4.isArrayOrTypedArray, c_t = Qa(), f_t = Mu().extractOpts;
            H_e.exports = function(t, r, n, i, a) {
                a || (a = {});
                var o = a.isContour, s = t.cd[0], l = s.trace, u = t.xa, c = t.ya, f = s.x, h = s.y, d = s.z, v = s.xCenter, x = s.yCenter, b = s.zmask, p = l.zhoverformat, E = f, k = h, A, L, _, C;
                if (t.index !== !1) {
                    try {
                        _ = Math.round(t.index[1]), C = Math.round(t.index[0]);
                    } catch (re) {
                        _4.error("Error hovering on heatmap, pointNumber must be [row,col], found:", t.index);
                        return;
                    }
                    if (_ < 0 || _ >= d[0].length || C < 0 || C > d.length) return;
                } else {
                    if (V_e.inbox(r - f[0], r - f[f.length - 1], 0) > 0 || V_e.inbox(n - h[0], n - h[h.length - 1], 0) > 0) return;
                    if (o) {
                        var M;
                        for(E = [
                            2 * f[0] - f[1]
                        ], M = 1; M < f.length; M++)E.push((f[M] + f[M - 1]) / 2);
                        for(E.push([
                            2 * f[f.length - 1] - f[f.length - 2]
                        ]), k = [
                            2 * h[0] - h[1]
                        ], M = 1; M < h.length; M++)k.push((h[M] + h[M - 1]) / 2);
                        k.push([
                            2 * h[h.length - 1] - h[h.length - 2]
                        ]);
                    }
                    _ = Math.max(0, Math.min(E.length - 2, _4.findBin(r, E))), C = Math.max(0, Math.min(k.length - 2, _4.findBin(n, k)));
                }
                var g = u.c2p(f[_]), P = u.c2p(f[_ + 1]), T = c.c2p(h[C]), F = c.c2p(h[C + 1]), q, V;
                o ? (q = s.orig_x || f, V = s.orig_y || h, P = g, A = q[_], F = T, L = V[C]) : (q = s.orig_x || v || f, V = s.orig_y || x || h, A = v ? q[_] : (q[_] + q[_ + 1]) / 2, L = x ? V[C] : (V[C] + V[C + 1]) / 2, u && u.type === "category" && (A = f[_]), c && c.type === "category" && (L = h[C]), l.zsmooth && (g = P = u.c2p(A), T = F = c.c2p(L)));
                var H = d[C][_];
                if (b && !b[C][_] && (H = void 0), !(H === void 0 && !l.hoverongaps)) {
                    var X;
                    u8(s.hovertext) && u8(s.hovertext[C]) ? X = s.hovertext[C][_] : u8(s.text) && u8(s.text[C]) && (X = s.text[C][_]);
                    var G = f_t(l), N = {
                        type: "linear",
                        range: [
                            G.min,
                            G.max
                        ],
                        hoverformat: p,
                        _separators: u._separators,
                        _numFormat: u._numFormat
                    }, W = c_t.tickText(N, H, "hover").text;
                    return [
                        _4.extendFlat(t, {
                            index: l._after2before ? l._after2before[C][_] : [
                                C,
                                _
                            ],
                            distance: t.maxHoverDistance,
                            spikeDistance: t.maxSpikeDistance,
                            x0: g,
                            x1: P,
                            y0: T,
                            y1: F,
                            xLabelVal: A,
                            yLabelVal: L,
                            zLabelVal: H,
                            zLabel: W,
                            text: X
                        })
                    ];
                }
            };
        });
        var j_e = ye((_sr, G_e)=>{
            "use strict";
            G_e.exports = {
                attributes: ET(),
                supplyDefaults: G1e(),
                calc: n8(),
                plot: s8(),
                colorbar: M_(),
                style: l8(),
                hoverPoints: c8(),
                moduleType: "trace",
                name: "heatmap",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "2dMap",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var Z_e = ye((xsr, W_e)=>{
            "use strict";
            W_e.exports = j_e();
        });
        var ZV = ye((bsr, X_e)=>{
            "use strict";
            X_e.exports = function(t, r) {
                return {
                    start: {
                        valType: "any",
                        editType: "calc"
                    },
                    end: {
                        valType: "any",
                        editType: "calc"
                    },
                    size: {
                        valType: "any",
                        editType: "calc"
                    },
                    editType: "calc"
                };
            };
        });
        var K_e = ye((wsr, Y_e)=>{
            "use strict";
            Y_e.exports = {
                eventDataKeys: [
                    "binNumber"
                ]
            };
        });
        var f8 = ye((Tsr, Q_e)=>{
            "use strict";
            var Ip = Lm(), J_e = Oc().axisHoverFormat, h_t = Wo().hovertemplateAttrs, d_t = Wo().texttemplateAttrs, XV = Su(), $_e = ZV(), v_t = K_e(), YV = no().extendFlat;
            Q_e.exports = {
                x: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                y: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                xhoverformat: J_e("x"),
                yhoverformat: J_e("y"),
                text: YV({}, Ip.text, {}),
                hovertext: YV({}, Ip.hovertext, {}),
                orientation: Ip.orientation,
                histfunc: {
                    valType: "enumerated",
                    values: [
                        "count",
                        "sum",
                        "avg",
                        "min",
                        "max"
                    ],
                    dflt: "count",
                    editType: "calc"
                },
                histnorm: {
                    valType: "enumerated",
                    values: [
                        "",
                        "percent",
                        "probability",
                        "density",
                        "probability density"
                    ],
                    dflt: "",
                    editType: "calc"
                },
                cumulative: {
                    enabled: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "calc"
                    },
                    direction: {
                        valType: "enumerated",
                        values: [
                            "increasing",
                            "decreasing"
                        ],
                        dflt: "increasing",
                        editType: "calc"
                    },
                    currentbin: {
                        valType: "enumerated",
                        values: [
                            "include",
                            "exclude",
                            "half"
                        ],
                        dflt: "include",
                        editType: "calc"
                    },
                    editType: "calc"
                },
                nbinsx: {
                    valType: "integer",
                    min: 0,
                    dflt: 0,
                    editType: "calc"
                },
                xbins: $_e("x", !0),
                nbinsy: {
                    valType: "integer",
                    min: 0,
                    dflt: 0,
                    editType: "calc"
                },
                ybins: $_e("y", !0),
                autobinx: {
                    valType: "boolean",
                    dflt: null,
                    editType: "calc"
                },
                autobiny: {
                    valType: "boolean",
                    dflt: null,
                    editType: "calc"
                },
                bingroup: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                hovertemplate: h_t({}, {
                    keys: v_t.eventDataKeys
                }),
                texttemplate: d_t({
                    arrayOk: !1,
                    editType: "plot"
                }, {
                    keys: [
                        "label",
                        "value"
                    ]
                }),
                textposition: YV({}, Ip.textposition, {
                    arrayOk: !1
                }),
                textfont: XV({
                    arrayOk: !1,
                    editType: "plot",
                    colorEditType: "style"
                }),
                outsidetextfont: XV({
                    arrayOk: !1,
                    editType: "plot",
                    colorEditType: "style"
                }),
                insidetextfont: XV({
                    arrayOk: !1,
                    editType: "plot",
                    colorEditType: "style"
                }),
                insidetextanchor: Ip.insidetextanchor,
                textangle: Ip.textangle,
                cliponaxis: Ip.cliponaxis,
                constraintext: Ip.constraintext,
                marker: Ip.marker,
                offsetgroup: Ip.offsetgroup,
                alignmentgroup: Ip.alignmentgroup,
                selected: Ip.selected,
                unselected: Ip.unselected,
                zorder: Ip.zorder
            };
        });
        var ixe = ye((Asr, rxe)=>{
            "use strict";
            var exe = ba(), x4 = Mr(), txe = va(), p_t = r0().handleText, g_t = FI(), m_t = f8();
            rxe.exports = function(t, r, n, i) {
                function a(E, k) {
                    return x4.coerce(t, r, m_t, E, k);
                }
                var o = a("x"), s = a("y"), l = a("cumulative.enabled");
                l && (a("cumulative.direction"), a("cumulative.currentbin")), a("text");
                var u = a("textposition");
                p_t(t, r, i, a, u, {
                    moduleHasSelected: !0,
                    moduleHasUnselected: !0,
                    moduleHasConstrain: !0,
                    moduleHasCliponaxis: !0,
                    moduleHasTextangle: !0,
                    moduleHasInsideanchor: !0
                }), a("hovertext"), a("hovertemplate"), a("xhoverformat"), a("yhoverformat");
                var c = a("orientation", s && !o ? "h" : "v"), f = c === "v" ? "x" : "y", h = c === "v" ? "y" : "x", d = o && s ? Math.min(x4.minRowLength(o) && x4.minRowLength(s)) : x4.minRowLength(r[f] || []);
                if (!d) {
                    r.visible = !1;
                    return;
                }
                r._length = d;
                var v = exe.getComponentMethod("calendars", "handleTraceDefaults");
                v(t, r, [
                    "x",
                    "y"
                ], i);
                var x = r[h];
                x && a("histfunc"), a("histnorm"), a("autobin" + f), g_t(t, r, a, n, i), x4.coerceSelectionMarkerOpacity(r, a);
                var b = (r.marker.line || {}).color, p = exe.getComponentMethod("errorbars", "supplyDefaults");
                p(t, r, b || txe.defaultLine, {
                    axis: "y"
                }), p(t, r, b || txe.defaultLine, {
                    axis: "x",
                    inherit: "y"
                }), a("zorder");
            };
        });
        var d8 = ye((Ssr, oxe)=>{
            "use strict";
            var b4 = Mr(), y_t = af(), h8 = ba().traceIs, __t = Hb(), x_t = r0().validateCornerradius, nxe = b4.nestedProperty, KV = Bb().getAxisGroup, axe = [
                {
                    aStr: {
                        x: "xbins.start",
                        y: "ybins.start"
                    },
                    name: "start"
                },
                {
                    aStr: {
                        x: "xbins.end",
                        y: "ybins.end"
                    },
                    name: "end"
                },
                {
                    aStr: {
                        x: "xbins.size",
                        y: "ybins.size"
                    },
                    name: "size"
                },
                {
                    aStr: {
                        x: "nbinsx",
                        y: "nbinsy"
                    },
                    name: "nbins"
                }
            ], b_t = [
                "x",
                "y"
            ];
            oxe.exports = function(t, r) {
                var n = r._histogramBinOpts = {}, i = [], a = {}, o = [], s, l, u, c, f, h, d;
                function v(H, X) {
                    return b4.coerce(s._input, s, s._module.attributes, H, X);
                }
                function x(H) {
                    return H.orientation === "v" ? "x" : "y";
                }
                function b(H, X) {
                    var G = y_t.getFromTrace({
                        _fullLayout: r
                    }, H, X);
                    return G.type;
                }
                function p(H, X, G) {
                    var N = H.uid + "__" + G;
                    X || (X = N);
                    var W = b(H, G), re = H[G + "calendar"] || "", ae = n[X], _e = !0;
                    ae && (W === ae.axType && re === ae.calendar ? (_e = !1, ae.traces.push(H), ae.dirs.push(G)) : (X = N, W !== ae.axType && b4.warn([
                        "Attempted to group the bins of trace",
                        H.index,
                        "set on a",
                        "type:" + W,
                        "axis",
                        "with bins on",
                        "type:" + ae.axType,
                        "axis."
                    ].join(" ")), re !== ae.calendar && b4.warn([
                        "Attempted to group the bins of trace",
                        H.index,
                        "set with a",
                        re,
                        "calendar",
                        "with bins",
                        ae.calendar ? "on a " + ae.calendar + " calendar" : "w/o a set calendar"
                    ].join(" ")))), _e && (n[X] = {
                        traces: [
                            H
                        ],
                        dirs: [
                            G
                        ],
                        axType: W,
                        calendar: H[G + "calendar"] || ""
                    }), H["_" + G + "bingroup"] = X;
                }
                for(f = 0; f < t.length; f++)if (s = t[f], h8(s, "histogram")) {
                    if (i.push(s), delete s._xautoBinFinished, delete s._yautoBinFinished, s.type === "histogram") {
                        var E = v("marker.cornerradius", r.barcornerradius);
                        s.marker && (s.marker.cornerradius = x_t(E));
                    }
                    h8(s, "2dMap") || __t(s._input, s, r, v, r.barmode);
                }
                var k = r._alignmentOpts || {};
                for(f = 0; f < i.length; f++){
                    if (s = i[f], u = "", !h8(s, "2dMap")) {
                        if (c = x(s), r.barmode === "group" && s.alignmentgroup) {
                            var A = s[c + "axis"], L = KV(r, A) + s.orientation;
                            (k[L] || {})[s.alignmentgroup] && (u = L);
                        }
                        !u && r.barmode !== "overlay" && (u = KV(r, s.xaxis) + KV(r, s.yaxis) + x(s));
                    }
                    u ? (a[u] || (a[u] = []), a[u].push(s)) : o.push(s);
                }
                for(u in a){
                    if (l = a[u], l.length === 1) {
                        o.push(l[0]);
                        continue;
                    }
                    var _ = !1;
                    for(l.length && (s = l[0], _ = v("bingroup")), u = _ || u, f = 0; f < l.length; f++){
                        s = l[f];
                        var C = s._input.bingroup;
                        C && C !== u && b4.warn([
                            "Trace",
                            s.index,
                            "must match",
                            "within bingroup",
                            u + ".",
                            "Ignoring its bingroup:",
                            C,
                            "setting."
                        ].join(" ")), s.bingroup = u, p(s, u, x(s));
                    }
                }
                for(f = 0; f < o.length; f++){
                    s = o[f];
                    var M = v("bingroup");
                    if (h8(s, "2dMap")) for(d = 0; d < 2; d++){
                        c = b_t[d];
                        var g = v(c + "bingroup", M ? M + "__" + c : null);
                        p(s, g, c);
                    }
                    else p(s, M, x(s));
                }
                for(u in n){
                    var P = n[u];
                    for(l = P.traces, h = 0; h < axe.length; h++){
                        var T = axe[h], F = T.name, q, V;
                        if (!(F === "nbins" && P.sizeFound)) {
                            for(f = 0; f < l.length; f++){
                                if (s = l[f], c = P.dirs[f], q = T.aStr[c], nxe(s._input, q).get() !== void 0) {
                                    P[F] = v(q), P[F + "Found"] = !0;
                                    break;
                                }
                                V = (s._autoBin || {})[c] || {}, V[F] && nxe(s, q).set(V[F]);
                            }
                            if (F === "start" || F === "end") for(; f < l.length; f++)s = l[f], s["_" + c + "bingroup"] && (V = (s._autoBin || {})[c] || {}, v(q, V[F]));
                            F === "nbins" && !P.sizeFound && !P.nbinsFound && (s = l[0], P[F] = v(q));
                        }
                    }
                }
            };
        });
        var lxe = ye((Msr, sxe)=>{
            "use strict";
            var w_t = TT().hoverPoints, T_t = Qa().hoverLabelText;
            sxe.exports = function(t, r, n, i, a) {
                var o = w_t(t, r, n, i, a);
                if (o) {
                    t = o[0];
                    var s = t.cd[t.index], l = t.cd[0].trace;
                    if (!l.cumulative.enabled) {
                        var u = l.orientation === "h" ? "y" : "x";
                        t[u + "Label"] = T_t(t[u + "a"], [
                            s.ph0,
                            s.ph1
                        ], l[u + "hoverformat"]);
                    }
                    return o;
                }
            };
        });
        var JV = ye((Esr, uxe)=>{
            "use strict";
            uxe.exports = function(t, r, n, i, a) {
                if (t.x = "xVal" in r ? r.xVal : r.x, t.y = "yVal" in r ? r.yVal : r.y, "zLabelVal" in r && (t.z = r.zLabelVal), r.xa && (t.xaxis = r.xa), r.ya && (t.yaxis = r.ya), !(n.cumulative || {}).enabled) {
                    var o = Array.isArray(a) ? i[0].pts[a[0]][a[1]] : i[a].pts;
                    t.pointNumbers = o, t.binNumber = t.pointNumber, delete t.pointNumber, delete t.pointIndex;
                    var s;
                    if (n._indexToPoints) {
                        s = [];
                        for(var l = 0; l < o.length; l++)s = s.concat(n._indexToPoints[o[l]]);
                    } else s = o;
                    t.pointIndices = s;
                }
                return t;
            };
        });
        var fxe = ye((ksr, cxe)=>{
            "use strict";
            cxe.exports = {
                attributes: f8(),
                layoutAttributes: zI(),
                supplyDefaults: ixe(),
                crossTraceDefaults: d8(),
                supplyLayoutDefaults: yV(),
                calc: UV().calc,
                crossTraceCalc: Gb().crossTraceCalc,
                plot: i2().plot,
                layerName: "barlayer",
                style: N0().style,
                styleOnSelect: N0().styleOnSelect,
                colorbar: Kd(),
                hoverPoints: lxe(),
                selectPoints: AT(),
                eventData: JV(),
                moduleType: "trace",
                name: "histogram",
                basePlotModule: Jf(),
                categories: [
                    "bar-like",
                    "cartesian",
                    "svg",
                    "bar",
                    "histogram",
                    "oriented",
                    "errorBarsOK",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var dxe = ye((Csr, hxe)=>{
            "use strict";
            hxe.exports = fxe();
        });
        var p8 = ye((Lsr, pxe)=>{
            "use strict";
            var Vg = f8(), vxe = ZV(), v8 = ET(), A_t = vl(), $V = Oc().axisHoverFormat, S_t = Wo().hovertemplateAttrs, M_t = Wo().texttemplateAttrs, E_t = Jl(), w4 = no().extendFlat;
            pxe.exports = w4({
                x: Vg.x,
                y: Vg.y,
                z: {
                    valType: "data_array",
                    editType: "calc"
                },
                marker: {
                    color: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    editType: "calc"
                },
                histnorm: Vg.histnorm,
                histfunc: Vg.histfunc,
                nbinsx: Vg.nbinsx,
                xbins: vxe("x"),
                nbinsy: Vg.nbinsy,
                ybins: vxe("y"),
                autobinx: Vg.autobinx,
                autobiny: Vg.autobiny,
                bingroup: w4({}, Vg.bingroup, {}),
                xbingroup: w4({}, Vg.bingroup, {}),
                ybingroup: w4({}, Vg.bingroup, {}),
                xgap: v8.xgap,
                ygap: v8.ygap,
                zsmooth: v8.zsmooth,
                xhoverformat: $V("x"),
                yhoverformat: $V("y"),
                zhoverformat: $V("z", 1),
                hovertemplate: S_t({}, {
                    keys: "z"
                }),
                texttemplate: M_t({
                    arrayOk: !1,
                    editType: "plot"
                }, {
                    keys: "z"
                }),
                textfont: v8.textfont,
                showlegend: w4({}, A_t.showlegend, {
                    dflt: !1
                })
            }, E_t("", {
                cLetter: "z",
                autoColorDflt: !1
            }));
        });
        var QV = ye((Psr, mxe)=>{
            "use strict";
            var k_t = ba(), gxe = Mr();
            mxe.exports = function(t, r, n, i) {
                var a = n("x"), o = n("y"), s = gxe.minRowLength(a), l = gxe.minRowLength(o);
                if (!s || !l) {
                    r.visible = !1;
                    return;
                }
                r._length = Math.min(s, l);
                var u = k_t.getComponentMethod("calendars", "handleTraceDefaults");
                u(t, r, [
                    "x",
                    "y"
                ], i);
                var c = n("z") || n("marker.color");
                c && n("histfunc"), n("histnorm"), n("autobinx"), n("autobiny");
            };
        });
        var _xe = ye((Isr, yxe)=>{
            "use strict";
            var C_t = Mr(), L_t = QV(), P_t = DV(), I_t = Uh(), R_t = y4(), D_t = p8();
            yxe.exports = function(t, r, n, i) {
                function a(o, s) {
                    return C_t.coerce(t, r, D_t, o, s);
                }
                L_t(t, r, a, i), r.visible !== !1 && (P_t(t, r, a, i), I_t(t, r, i, a, {
                    prefix: "",
                    cLetter: "z"
                }), a("hovertemplate"), R_t(a, i), a("xhoverformat"), a("yhoverformat"));
            };
        });
        var wxe = ye((Rsr, bxe)=>{
            "use strict";
            var z_t = c8(), xxe = Qa().hoverLabelText;
            bxe.exports = function(t, r, n, i, a) {
                var o = z_t(t, r, n, i, a);
                if (o) {
                    t = o[0];
                    var s = t.index, l = s[0], u = s[1], c = t.cd[0], f = c.trace, h = c.xRanges[u], d = c.yRanges[l];
                    return t.xLabel = xxe(t.xa, [
                        h[0],
                        h[1]
                    ], f.xhoverformat), t.yLabel = xxe(t.ya, [
                        d[0],
                        d[1]
                    ], f.yhoverformat), o;
                }
            };
        });
        var Axe = ye((Dsr, Txe)=>{
            "use strict";
            Txe.exports = {
                attributes: p8(),
                supplyDefaults: _xe(),
                crossTraceDefaults: d8(),
                calc: n8(),
                plot: s8(),
                layerName: "heatmaplayer",
                colorbar: M_(),
                style: l8(),
                hoverPoints: wxe(),
                eventData: JV(),
                moduleType: "trace",
                name: "histogram2d",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "2dMap",
                    "histogram",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var Mxe = ye((zsr, Sxe)=>{
            "use strict";
            Sxe.exports = Axe();
        });
        var g8 = ye((Fsr, Exe)=>{
            "use strict";
            Exe.exports = {
                COMPARISON_OPS: [
                    "=",
                    "!=",
                    "<",
                    ">=",
                    ">",
                    "<="
                ],
                COMPARISON_OPS2: [
                    "=",
                    "<",
                    ">=",
                    ">",
                    "<="
                ],
                INTERVAL_OPS: [
                    "[]",
                    "()",
                    "[)",
                    "(]",
                    "][",
                    ")(",
                    "](",
                    ")["
                ],
                SET_OPS: [
                    "{}",
                    "}{"
                ],
                CONSTRAINT_REDUCTION: {
                    "=": "=",
                    "<": "<",
                    "<=": "<",
                    ">": ">",
                    ">=": ">",
                    "[]": "[]",
                    "()": "[]",
                    "[)": "[]",
                    "(]": "[]",
                    "][": "][",
                    ")(": "][",
                    "](": "][",
                    ")[": "]["
                }
            };
        });
        var T4 = ye((qsr, Pxe)=>{
            "use strict";
            var Gh = ET(), m8 = Uc(), Cxe = Oc(), eH = Cxe.axisHoverFormat, F_t = Cxe.descriptionOnlyNumbers, q_t = Jl(), O_t = Ed().dash, B_t = Su(), IT = no().extendFlat, Lxe = g8(), N_t = Lxe.COMPARISON_OPS2, U_t = Lxe.INTERVAL_OPS, kxe = m8.line;
            Pxe.exports = IT({
                z: Gh.z,
                x: Gh.x,
                x0: Gh.x0,
                dx: Gh.dx,
                y: Gh.y,
                y0: Gh.y0,
                dy: Gh.dy,
                xperiod: Gh.xperiod,
                yperiod: Gh.yperiod,
                xperiod0: m8.xperiod0,
                yperiod0: m8.yperiod0,
                xperiodalignment: Gh.xperiodalignment,
                yperiodalignment: Gh.yperiodalignment,
                text: Gh.text,
                hovertext: Gh.hovertext,
                transpose: Gh.transpose,
                xtype: Gh.xtype,
                ytype: Gh.ytype,
                xhoverformat: eH("x"),
                yhoverformat: eH("y"),
                zhoverformat: eH("z", 1),
                hovertemplate: Gh.hovertemplate,
                texttemplate: IT({}, Gh.texttemplate, {}),
                textfont: IT({}, Gh.textfont, {}),
                hoverongaps: Gh.hoverongaps,
                connectgaps: IT({}, Gh.connectgaps, {}),
                fillcolor: {
                    valType: "color",
                    editType: "calc"
                },
                autocontour: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc",
                    impliedEdits: {
                        "contours.start": void 0,
                        "contours.end": void 0,
                        "contours.size": void 0
                    }
                },
                ncontours: {
                    valType: "integer",
                    dflt: 15,
                    min: 1,
                    editType: "calc"
                },
                contours: {
                    type: {
                        valType: "enumerated",
                        values: [
                            "levels",
                            "constraint"
                        ],
                        dflt: "levels",
                        editType: "calc"
                    },
                    start: {
                        valType: "number",
                        dflt: null,
                        editType: "plot",
                        impliedEdits: {
                            "^autocontour": !1
                        }
                    },
                    end: {
                        valType: "number",
                        dflt: null,
                        editType: "plot",
                        impliedEdits: {
                            "^autocontour": !1
                        }
                    },
                    size: {
                        valType: "number",
                        dflt: null,
                        min: 0,
                        editType: "plot",
                        impliedEdits: {
                            "^autocontour": !1
                        }
                    },
                    coloring: {
                        valType: "enumerated",
                        values: [
                            "fill",
                            "heatmap",
                            "lines",
                            "none"
                        ],
                        dflt: "fill",
                        editType: "calc"
                    },
                    showlines: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    showlabels: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    labelfont: B_t({
                        editType: "plot",
                        colorEditType: "style"
                    }),
                    labelformat: {
                        valType: "string",
                        dflt: "",
                        editType: "plot",
                        description: F_t("contour label")
                    },
                    operation: {
                        valType: "enumerated",
                        values: [].concat(N_t).concat(U_t),
                        dflt: "=",
                        editType: "calc"
                    },
                    value: {
                        valType: "any",
                        dflt: 0,
                        editType: "calc"
                    },
                    editType: "calc",
                    impliedEdits: {
                        autocontour: !1
                    }
                },
                line: {
                    color: IT({}, kxe.color, {
                        editType: "style+colorbars"
                    }),
                    width: {
                        valType: "number",
                        min: 0,
                        editType: "style+colorbars"
                    },
                    dash: O_t,
                    smoothing: IT({}, kxe.smoothing, {}),
                    editType: "plot"
                },
                zorder: m8.zorder
            }, q_t("", {
                cLetter: "z",
                autoColorDflt: !1,
                editTypeOverride: "calc"
            }));
        });
        var rH = ye((Osr, Rxe)=>{
            "use strict";
            var Hv = p8(), qy = T4(), V_t = Jl(), tH = Oc().axisHoverFormat, Ixe = no().extendFlat;
            Rxe.exports = Ixe({
                x: Hv.x,
                y: Hv.y,
                z: Hv.z,
                marker: Hv.marker,
                histnorm: Hv.histnorm,
                histfunc: Hv.histfunc,
                nbinsx: Hv.nbinsx,
                xbins: Hv.xbins,
                nbinsy: Hv.nbinsy,
                ybins: Hv.ybins,
                autobinx: Hv.autobinx,
                autobiny: Hv.autobiny,
                bingroup: Hv.bingroup,
                xbingroup: Hv.xbingroup,
                ybingroup: Hv.ybingroup,
                autocontour: qy.autocontour,
                ncontours: qy.ncontours,
                contours: qy.contours,
                line: {
                    color: qy.line.color,
                    width: Ixe({}, qy.line.width, {
                        dflt: .5
                    }),
                    dash: qy.line.dash,
                    smoothing: qy.line.smoothing,
                    editType: "plot"
                },
                xhoverformat: tH("x"),
                yhoverformat: tH("y"),
                zhoverformat: tH("z", 1),
                hovertemplate: Hv.hovertemplate,
                texttemplate: qy.texttemplate,
                textfont: qy.textfont
            }, V_t("", {
                cLetter: "z",
                editTypeOverride: "calc"
            }));
        });
        var y8 = ye((Bsr, Dxe)=>{
            "use strict";
            Dxe.exports = function(t, r, n, i) {
                var a = i("contours.start"), o = i("contours.end"), s = a === !1 || o === !1, l = n("contours.size"), u;
                s ? u = r.autocontour = !0 : u = n("autocontour", !1), (u || !l) && n("ncontours");
            };
        });
        var iH = ye((Nsr, zxe)=>{
            "use strict";
            var H_t = Mr();
            zxe.exports = function(t, r, n, i) {
                i || (i = {});
                var a = t("contours.showlabels");
                if (a) {
                    var o = r.font;
                    H_t.coerceFont(t, "contours.labelfont", o, {
                        overrideDflt: {
                            color: n
                        }
                    }), t("contours.labelformat");
                }
                i.hasHover !== !1 && t("zhoverformat");
            };
        });
        var _8 = ye((Usr, Fxe)=>{
            "use strict";
            var G_t = Uh(), j_t = iH();
            Fxe.exports = function(t, r, n, i, a) {
                var o = n("contours.coloring"), s, l = "";
                o === "fill" && (s = n("contours.showlines")), s !== !1 && (o !== "lines" && (l = n("line.color", "#000")), n("line.width", .5), n("line.dash")), o !== "none" && (t.showlegend !== !0 && (r.showlegend = !1), r._dfltShowLegend = !1, G_t(t, r, i, n, {
                    prefix: "",
                    cLetter: "z"
                })), n("line.smoothing"), j_t(n, i, l, a);
            };
        });
        var Nxe = ye((Vsr, Bxe)=>{
            "use strict";
            var qxe = Mr(), W_t = QV(), Z_t = y8(), X_t = _8(), Y_t = y4(), Oxe = rH();
            Bxe.exports = function(t, r, n, i) {
                function a(s, l) {
                    return qxe.coerce(t, r, Oxe, s, l);
                }
                function o(s) {
                    return qxe.coerce2(t, r, Oxe, s);
                }
                W_t(t, r, a, i), r.visible !== !1 && (Z_t(t, r, a, o), X_t(t, r, a, i), a("xhoverformat"), a("yhoverformat"), a("hovertemplate"), r.contours && r.contours.coloring === "heatmap" && Y_t(a, i));
            };
        });
        var oH = ye((Hsr, Vxe)=>{
            "use strict";
            var aH = Qa(), nH = Mr();
            Vxe.exports = function(t, r) {
                var n = t.contours;
                if (t.autocontour) {
                    var i = t.zmin, a = t.zmax;
                    (t.zauto || i === void 0) && (i = nH.aggNums(Math.min, null, r)), (t.zauto || a === void 0) && (a = nH.aggNums(Math.max, null, r));
                    var o = Uxe(i, a, t.ncontours);
                    n.size = o.dtick, n.start = aH.tickFirst(o), o.range.reverse(), n.end = aH.tickFirst(o), n.start === i && (n.start += n.size), n.end === a && (n.end -= n.size), n.start > n.end && (n.start = n.end = (n.start + n.end) / 2), t._input.contours || (t._input.contours = {}), nH.extendFlat(t._input.contours, {
                        start: n.start,
                        end: n.end,
                        size: n.size
                    }), t._input.autocontour = !0;
                } else if (n.type !== "constraint") {
                    var s = n.start, l = n.end, u = t._input.contours;
                    if (s > l && (n.start = u.start = l, l = n.end = u.end = s, s = n.start), !(n.size > 0)) {
                        var c;
                        s === l ? c = 1 : c = Uxe(s, l, t.ncontours).dtick, u.size = n.size = c;
                    }
                }
            };
            function Uxe(e, t, r) {
                var n = {
                    type: "linear",
                    range: [
                        e,
                        t
                    ]
                };
                return aH.autoTicks(n, (t - e) / (r || 15)), n;
            }
        });
        var A4 = ye((Gsr, Hxe)=>{
            "use strict";
            Hxe.exports = function(t) {
                return t.end + t.size / 1e6;
            };
        });
        var sH = ye((jsr, jxe)=>{
            "use strict";
            var Gxe = Mu(), K_t = n8(), J_t = oH(), $_t = A4();
            jxe.exports = function(t, r) {
                var n = K_t(t, r), i = n[0].z;
                J_t(r, i);
                var a = r.contours, o = Gxe.extractOpts(r), s;
                if (a.coloring === "heatmap" && o.auto && r.autocontour === !1) {
                    var l = a.start, u = $_t(a), c = a.size || 1, f = Math.floor((u - l) / c) + 1;
                    isFinite(c) || (c = 1, f = 1);
                    var h = l - c / 2, d = h + f * c;
                    s = [
                        h,
                        d
                    ];
                } else s = i;
                return Gxe.calc(t, r, {
                    vals: s,
                    cLetter: "z"
                }), n;
            };
        });
        var S4 = ye((Wsr, Wxe)=>{
            "use strict";
            Wxe.exports = {
                BOTTOMSTART: [
                    1,
                    9,
                    13,
                    104,
                    713
                ],
                TOPSTART: [
                    4,
                    6,
                    7,
                    104,
                    713
                ],
                LEFTSTART: [
                    8,
                    12,
                    14,
                    208,
                    1114
                ],
                RIGHTSTART: [
                    2,
                    3,
                    11,
                    208,
                    1114
                ],
                NEWDELTA: [
                    null,
                    [
                        -1,
                        0
                    ],
                    [
                        0,
                        -1
                    ],
                    [
                        -1,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    null,
                    [
                        0,
                        -1
                    ],
                    [
                        -1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        0,
                        1
                    ],
                    null,
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        -1
                    ]
                ],
                CHOOSESADDLE: {
                    104: [
                        4,
                        1
                    ],
                    208: [
                        2,
                        8
                    ],
                    713: [
                        7,
                        13
                    ],
                    1114: [
                        11,
                        14
                    ]
                },
                SADDLEREMAINDER: {
                    1: 4,
                    2: 8,
                    4: 1,
                    7: 13,
                    8: 2,
                    11: 14,
                    13: 7,
                    14: 11
                },
                LABELDISTANCE: 2,
                LABELINCREASE: 10,
                LABELMIN: 3,
                LABELMAX: 10,
                LABELOPTIMIZER: {
                    EDGECOST: 1,
                    ANGLECOST: 1,
                    NEIGHBORCOST: 5,
                    SAMELEVELFACTOR: 10,
                    SAMELEVELDISTANCE: 5,
                    MAXCOST: 100,
                    INITIALSEARCHPOINTS: 10,
                    ITERATIONS: 5
                }
            };
        });
        var lH = ye((Zsr, Zxe)=>{
            "use strict";
            var x8 = S4();
            Zxe.exports = function(t) {
                var r = t[0].z, n = r.length, i = r[0].length, a = n === 2 || i === 2, o, s, l, u, c, f, h, d, v;
                for(s = 0; s < n - 1; s++)for(u = [], s === 0 && (u = u.concat(x8.BOTTOMSTART)), s === n - 2 && (u = u.concat(x8.TOPSTART)), o = 0; o < i - 1; o++)for(l = u.slice(), o === 0 && (l = l.concat(x8.LEFTSTART)), o === i - 2 && (l = l.concat(x8.RIGHTSTART)), c = o + "," + s, f = [
                    [
                        r[s][o],
                        r[s][o + 1]
                    ],
                    [
                        r[s + 1][o],
                        r[s + 1][o + 1]
                    ]
                ], v = 0; v < t.length; v++)d = t[v], h = Q_t(d.level, f), h && (d.crossings[c] = h, l.indexOf(h) !== -1 && (d.starts.push([
                    o,
                    s
                ]), a && l.indexOf(h, l.indexOf(h) + 1) !== -1 && d.starts.push([
                    o,
                    s
                ])));
            };
            function Q_t(e, t) {
                var r = (t[0][0] > e ? 0 : 1) + (t[0][1] > e ? 0 : 2) + (t[1][1] > e ? 0 : 4) + (t[1][0] > e ? 0 : 8);
                if (r === 5 || r === 10) {
                    var n = (t[0][0] + t[0][1] + t[1][0] + t[1][1]) / 4;
                    return e > n ? r === 5 ? 713 : 1114 : r === 5 ? 104 : 208;
                }
                return r === 15 ? 0 : r;
            }
        });
        var uH = ye((Xsr, Kxe)=>{
            "use strict";
            var b8 = Mr(), RT = S4();
            Kxe.exports = function(t, r, n) {
                var i, a, o, s, l;
                for(r = r || .01, n = n || .01, o = 0; o < t.length; o++){
                    for(s = t[o], l = 0; l < s.starts.length; l++)a = s.starts[l], Xxe(s, a, "edge", r, n);
                    for(i = 0; Object.keys(s.crossings).length && i < 1e4;)i++, a = Object.keys(s.crossings)[0].split(",").map(Number), Xxe(s, a, void 0, r, n);
                    i === 1e4 && b8.log("Infinite loop in contour?");
                }
            };
            function M4(e, t, r, n) {
                return Math.abs(e[0] - t[0]) < r && Math.abs(e[1] - t[1]) < n;
            }
            function ext(e, t) {
                var r = e[2] - t[2], n = e[3] - t[3];
                return Math.sqrt(r * r + n * n);
            }
            function Xxe(e, t, r, n, i) {
                var a = t.join(","), o = e.crossings[a], s = txt(o, r, t), l = [
                    Yxe(e, t, [
                        -s[0],
                        -s[1]
                    ])
                ], u = e.z.length, c = e.z[0].length, f = t.slice(), h = s.slice(), d;
                for(d = 0; d < 1e4; d++){
                    if (o > 20 ? (o = RT.CHOOSESADDLE[o][(s[0] || s[1]) < 0 ? 0 : 1], e.crossings[a] = RT.SADDLEREMAINDER[o]) : delete e.crossings[a], s = RT.NEWDELTA[o], !s) {
                        b8.log("Found bad marching index:", o, t, e.level);
                        break;
                    }
                    l.push(Yxe(e, t, s)), t[0] += s[0], t[1] += s[1], a = t.join(","), M4(l[l.length - 1], l[l.length - 2], n, i) && l.pop();
                    var v = s[0] && (t[0] < 0 || t[0] > c - 2) || s[1] && (t[1] < 0 || t[1] > u - 2), x = t[0] === f[0] && t[1] === f[1] && s[0] === h[0] && s[1] === h[1];
                    if (x || r && v) break;
                    o = e.crossings[a];
                }
                d === 1e4 && b8.log("Infinite loop in contour?");
                var b = M4(l[0], l[l.length - 1], n, i), p = 0, E = .2 * e.smoothing, k = [], A = 0, L, _, C, M, g, P, T, F, q, V, H;
                for(d = 1; d < l.length; d++)T = ext(l[d], l[d - 1]), p += T, k.push(T);
                var X = p / k.length * E;
                function G(re) {
                    return l[re % l.length];
                }
                for(d = l.length - 2; d >= A; d--)if (L = k[d], L < X) {
                    for(C = 0, _ = d - 1; _ >= A && L + k[_] < X; _--)L += k[_];
                    if (b && d === l.length - 2) for(C = 0; C < _ && L + k[C] < X; C++)L += k[C];
                    g = d - _ + C + 1, P = Math.floor((d + _ + C + 2) / 2), !b && d === l.length - 2 ? M = l[l.length - 1] : !b && _ === -1 ? M = l[0] : g % 2 ? M = G(P) : M = [
                        (G(P)[0] + G(P + 1)[0]) / 2,
                        (G(P)[1] + G(P + 1)[1]) / 2
                    ], l.splice(_ + 1, d - _ + 1, M), d = _ + 1, C && (A = C), b && (d === l.length - 2 ? l[C] = l[l.length - 1] : d === 0 && (l[l.length - 1] = l[0]));
                }
                for(l.splice(0, A), d = 0; d < l.length; d++)l[d].length = 2;
                if (!(l.length < 2)) {
                    if (b) l.pop(), e.paths.push(l);
                    else {
                        r || b8.log("Unclosed interior contour?", e.level, f.join(","), l.join("L"));
                        var N = !1;
                        for(F = 0; F < e.edgepaths.length; F++)if (V = e.edgepaths[F], !N && M4(V[0], l[l.length - 1], n, i)) {
                            l.pop(), N = !0;
                            var W = !1;
                            for(q = 0; q < e.edgepaths.length; q++)if (H = e.edgepaths[q], M4(H[H.length - 1], l[0], n, i)) {
                                W = !0, l.shift(), e.edgepaths.splice(F, 1), q === F ? e.paths.push(l.concat(H)) : (q > F && q--, e.edgepaths[q] = H.concat(l, V));
                                break;
                            }
                            W || (e.edgepaths[F] = l.concat(V));
                        }
                        for(F = 0; F < e.edgepaths.length && !N; F++)V = e.edgepaths[F], M4(V[V.length - 1], l[0], n, i) && (l.shift(), e.edgepaths[F] = V.concat(l), N = !0);
                        N || e.edgepaths.push(l);
                    }
                }
            }
            function txt(e, t, r) {
                var n = 0, i = 0;
                return e > 20 && t ? e === 208 || e === 1114 ? n = r[0] === 0 ? 1 : -1 : i = r[1] === 0 ? 1 : -1 : RT.BOTTOMSTART.indexOf(e) !== -1 ? i = 1 : RT.LEFTSTART.indexOf(e) !== -1 ? n = 1 : RT.TOPSTART.indexOf(e) !== -1 ? i = -1 : n = -1, [
                    n,
                    i
                ];
            }
            function Yxe(e, t, r) {
                var n = t[0] + Math.max(r[0], 0), i = t[1] + Math.max(r[1], 0), a = e.z[i][n], o = e.xaxis, s = e.yaxis;
                if (r[1]) {
                    var l = (e.level - a) / (e.z[i][n + 1] - a), u = (l !== 1 ? (1 - l) * o.c2l(e.x[n]) : 0) + (l !== 0 ? l * o.c2l(e.x[n + 1]) : 0);
                    return [
                        o.c2p(o.l2c(u), !0),
                        s.c2p(e.y[i], !0),
                        n + l,
                        i
                    ];
                } else {
                    var c = (e.level - a) / (e.z[i + 1][n] - a), f = (c !== 1 ? (1 - c) * s.c2l(e.y[i]) : 0) + (c !== 0 ? c * s.c2l(e.y[i + 1]) : 0);
                    return [
                        o.c2p(e.x[n], !0),
                        s.c2p(s.l2c(f), !0),
                        n,
                        i + c
                    ];
                }
            }
        });
        var ebe = ye((Ysr, Qxe)=>{
            "use strict";
            var cH = g8(), rxt = uo();
            Qxe.exports = {
                "[]": Jxe("[]"),
                "][": Jxe("]["),
                ">": fH(">"),
                "<": fH("<"),
                "=": fH("=")
            };
            function $xe(e, t) {
                var r = Array.isArray(t), n;
                function i(a) {
                    return rxt(a) ? +a : null;
                }
                return cH.COMPARISON_OPS2.indexOf(e) !== -1 ? n = i(r ? t[0] : t) : cH.INTERVAL_OPS.indexOf(e) !== -1 ? n = r ? [
                    i(t[0]),
                    i(t[1])
                ] : [
                    i(t),
                    i(t)
                ] : cH.SET_OPS.indexOf(e) !== -1 && (n = r ? t.map(i) : [
                    i(t)
                ]), n;
            }
            function Jxe(e) {
                return function(t) {
                    t = $xe(e, t);
                    var r = Math.min(t[0], t[1]), n = Math.max(t[0], t[1]);
                    return {
                        start: r,
                        end: n,
                        size: n - r
                    };
                };
            }
            function fH(e) {
                return function(t) {
                    return t = $xe(e, t), {
                        start: t,
                        end: 1 / 0,
                        size: 1 / 0
                    };
                };
            }
        });
        var hH = ye((Ksr, rbe)=>{
            "use strict";
            var tbe = Mr(), ixt = ebe(), nxt = A4();
            rbe.exports = function(t, r, n) {
                for(var i = t.type === "constraint" ? ixt[t._operation](t.value) : t, a = i.size, o = [], s = nxt(i), l = n.trace._carpetTrace, u = l ? {
                    xaxis: l.aaxis,
                    yaxis: l.baxis,
                    x: n.a,
                    y: n.b
                } : {
                    xaxis: r.xaxis,
                    yaxis: r.yaxis,
                    x: n.x,
                    y: n.y
                }, c = i.start; c < s; c += a)if (o.push(tbe.extendFlat({
                    level: c,
                    crossings: {},
                    starts: [],
                    edgepaths: [],
                    paths: [],
                    z: n.z,
                    smoothing: n.trace.line.smoothing
                }, u)), o.length > 1e3) {
                    tbe.warn("Too many contours, clipping at 1000", t);
                    break;
                }
                return o;
            };
        });
        var dH = ye((Jsr, nbe)=>{
            "use strict";
            var DT = Mr();
            nbe.exports = function(e, t) {
                var r, n, i, a = function(l) {
                    return l.reverse();
                }, o = function(l) {
                    return l;
                };
                switch(t){
                    case "=":
                    case "<":
                        return e;
                    case ">":
                        for(e.length !== 1 && DT.warn("Contour data invalid for the specified inequality operation."), n = e[0], r = 0; r < n.edgepaths.length; r++)n.edgepaths[r] = a(n.edgepaths[r]);
                        for(r = 0; r < n.paths.length; r++)n.paths[r] = a(n.paths[r]);
                        for(r = 0; r < n.starts.length; r++)n.starts[r] = a(n.starts[r]);
                        return e;
                    case "][":
                        var s = a;
                        a = o, o = s;
                    case "[]":
                        for(e.length !== 2 && DT.warn("Contour data invalid for the specified inequality range operation."), n = ibe(e[0]), i = ibe(e[1]), r = 0; r < n.edgepaths.length; r++)n.edgepaths[r] = a(n.edgepaths[r]);
                        for(r = 0; r < n.paths.length; r++)n.paths[r] = a(n.paths[r]);
                        for(r = 0; r < n.starts.length; r++)n.starts[r] = a(n.starts[r]);
                        for(; i.edgepaths.length;)n.edgepaths.push(o(i.edgepaths.shift()));
                        for(; i.paths.length;)n.paths.push(o(i.paths.shift()));
                        for(; i.starts.length;)n.starts.push(o(i.starts.shift()));
                        return [
                            n
                        ];
                }
            };
            function ibe(e) {
                return DT.extendFlat({}, e, {
                    edgepaths: DT.extendDeep([], e.edgepaths),
                    paths: DT.extendDeep([], e.paths),
                    starts: DT.extendDeep([], e.starts)
                });
            }
        });
        var vH = ye(($sr, abe)=>{
            "use strict";
            abe.exports = function(e, t) {
                var r = e[0], n = r.z, i;
                switch(t.type){
                    case "levels":
                        var a = Math.min(n[0][0], n[0][1]);
                        for(i = 0; i < e.length; i++){
                            var o = e[i];
                            o.prefixBoundary = !o.edgepaths.length && (a > o.level || o.starts.length && a === o.level);
                        }
                        break;
                    case "constraint":
                        if (r.prefixBoundary = !1, r.edgepaths.length) return;
                        var s = r.x.length, l = r.y.length, u = -1 / 0, c = 1 / 0;
                        for(i = 0; i < l; i++)c = Math.min(c, n[i][0]), c = Math.min(c, n[i][s - 1]), u = Math.max(u, n[i][0]), u = Math.max(u, n[i][s - 1]);
                        for(i = 1; i < s - 1; i++)c = Math.min(c, n[0][i]), c = Math.min(c, n[l - 1][i]), u = Math.max(u, n[0][i]), u = Math.max(u, n[l - 1][i]);
                        var f = t.value, h, d;
                        switch(t._operation){
                            case ">":
                                f > u && (r.prefixBoundary = !0);
                                break;
                            case "<":
                                (f < c || r.starts.length && f === c) && (r.prefixBoundary = !0);
                                break;
                            case "[]":
                                h = Math.min(f[0], f[1]), d = Math.max(f[0], f[1]), (d < c || h > u || r.starts.length && d === c) && (r.prefixBoundary = !0);
                                break;
                            case "][":
                                h = Math.min(f[0], f[1]), d = Math.max(f[0], f[1]), h < c && d > u && (r.prefixBoundary = !0);
                                break;
                        }
                        break;
                }
            };
        });
        var w8 = ye((Gv)=>{
            "use strict";
            var k4 = xa(), Id = Mr(), Oy = ao(), axt = Mu(), lbe = Pl(), obe = Qa(), sbe = ym(), oxt = s8(), ube = lH(), cbe = uH(), sxt = hH(), lxt = dH(), fbe = vH(), E4 = S4(), Rm = E4.LABELOPTIMIZER;
            Gv.plot = function(t, r, n, i) {
                var a = r.xaxis, o = r.yaxis;
                Id.makeTraceGroups(i, n, "contour").each(function(s) {
                    var l = k4.select(this), u = s[0], c = u.trace, f = u.x, h = u.y, d = c.contours, v = sxt(d, r, u), x = Id.ensureSingle(l, "g", "heatmapcoloring"), b = [];
                    d.coloring === "heatmap" && (b = [
                        s
                    ]), oxt(t, r, b, x), ube(v), cbe(v);
                    var p = a.c2p(f[0], !0), E = a.c2p(f[f.length - 1], !0), k = o.c2p(h[0], !0), A = o.c2p(h[h.length - 1], !0), L = [
                        [
                            p,
                            A
                        ],
                        [
                            E,
                            A
                        ],
                        [
                            E,
                            k
                        ],
                        [
                            p,
                            k
                        ]
                    ], _ = v;
                    d.type === "constraint" && (_ = lxt(v, d._operation)), uxt(l, L, d), cxt(l, _, L, d), fxt(l, v, t, u, d), dxt(l, r, t, u, L);
                });
            };
            function uxt(e, t, r) {
                var n = Id.ensureSingle(e, "g", "contourbg"), i = n.selectAll("path").data(r.coloring === "fill" ? [
                    0
                ] : []);
                i.enter().append("path"), i.exit().remove(), i.attr("d", "M" + t.join("L") + "Z").style("stroke", "none");
            }
            function cxt(e, t, r, n) {
                var i = n.coloring === "fill" || n.type === "constraint" && n._operation !== "=", a = "M" + r.join("L") + "Z";
                i && fbe(t, n);
                var o = Id.ensureSingle(e, "g", "contourfill"), s = o.selectAll("path").data(i ? t : []);
                s.enter().append("path"), s.exit().remove(), s.each(function(l) {
                    var u = (l.prefixBoundary ? a : "") + hbe(l, r);
                    u ? k4.select(this).attr("d", u).style("stroke", "none") : k4.select(this).remove();
                });
            }
            function hbe(e, t) {
                var r = "", n = 0, i = e.edgepaths.map(function(p, E) {
                    return E;
                }), a = !0, o, s, l, u, c, f;
                function h(p) {
                    return Math.abs(p[1] - t[0][1]) < .01;
                }
                function d(p) {
                    return Math.abs(p[1] - t[2][1]) < .01;
                }
                function v(p) {
                    return Math.abs(p[0] - t[0][0]) < .01;
                }
                function x(p) {
                    return Math.abs(p[0] - t[2][0]) < .01;
                }
                for(; i.length;){
                    for(f = Oy.smoothopen(e.edgepaths[n], e.smoothing), r += a ? f : f.replace(/^M/, "L"), i.splice(i.indexOf(n), 1), o = e.edgepaths[n][e.edgepaths[n].length - 1], u = -1, l = 0; l < 4; l++){
                        if (!o) {
                            Id.log("Missing end?", n, e);
                            break;
                        }
                        for(h(o) && !x(o) ? s = t[1] : v(o) ? s = t[0] : d(o) ? s = t[3] : x(o) && (s = t[2]), c = 0; c < e.edgepaths.length; c++){
                            var b = e.edgepaths[c][0];
                            Math.abs(o[0] - s[0]) < .01 ? Math.abs(o[0] - b[0]) < .01 && (b[1] - o[1]) * (s[1] - b[1]) >= 0 && (s = b, u = c) : Math.abs(o[1] - s[1]) < .01 ? Math.abs(o[1] - b[1]) < .01 && (b[0] - o[0]) * (s[0] - b[0]) >= 0 && (s = b, u = c) : Id.log("endpt to newendpt is not vert. or horz.", o, s, b);
                        }
                        if (o = s, u >= 0) break;
                        r += "L" + s;
                    }
                    if (u === e.edgepaths.length) {
                        Id.log("unclosed perimeter path");
                        break;
                    }
                    n = u, a = i.indexOf(n) === -1, a && (n = i[0], r += "Z");
                }
                for(n = 0; n < e.paths.length; n++)r += Oy.smoothclosed(e.paths[n], e.smoothing);
                return r;
            }
            function fxt(e, t, r, n, i) {
                var a = r._context.staticPlot, o = Id.ensureSingle(e, "g", "contourlines"), s = i.showlines !== !1, l = i.showlabels, u = s && l, c = Gv.createLines(o, s || l, t, a), f = Gv.createLineClip(o, u, r, n.trace.uid), h = e.selectAll("g.contourlabels").data(l ? [
                    0
                ] : []);
                if (h.exit().remove(), h.enter().append("g").classed("contourlabels", !0), l) {
                    var d = [], v = [];
                    Id.clearLocationCache();
                    var x = Gv.labelFormatter(r, n), b = Oy.tester.append("text").attr("data-notex", 1).call(Oy.font, i.labelfont), p = t[0].xaxis, E = t[0].yaxis, k = p._length, A = E._length, L = p.range, _ = E.range, C = Id.aggNums(Math.min, null, n.x), M = Id.aggNums(Math.max, null, n.x), g = Id.aggNums(Math.min, null, n.y), P = Id.aggNums(Math.max, null, n.y), T = Math.max(p.c2p(C, !0), 0), F = Math.min(p.c2p(M, !0), k), q = Math.max(E.c2p(P, !0), 0), V = Math.min(E.c2p(g, !0), A), H = {};
                    L[0] < L[1] ? (H.left = T, H.right = F) : (H.left = F, H.right = T), _[0] < _[1] ? (H.top = q, H.bottom = V) : (H.top = V, H.bottom = q), H.middle = (H.top + H.bottom) / 2, H.center = (H.left + H.right) / 2, d.push([
                        [
                            H.left,
                            H.top
                        ],
                        [
                            H.right,
                            H.top
                        ],
                        [
                            H.right,
                            H.bottom
                        ],
                        [
                            H.left,
                            H.bottom
                        ]
                    ]);
                    var X = Math.sqrt(k * k + A * A), G = E4.LABELDISTANCE * X / Math.max(1, t.length / E4.LABELINCREASE);
                    c.each(function(N) {
                        var W = Gv.calcTextOpts(N.level, x, b, r);
                        k4.select(this).selectAll("path").each(function() {
                            var re = this, ae = Id.getVisibleSegment(re, H, W.height / 2);
                            if (ae && !(ae.len < (W.width + W.height) * E4.LABELMIN)) for(var _e = Math.min(Math.ceil(ae.len / G), E4.LABELMAX), Me = 0; Me < _e; Me++){
                                var ke = Gv.findBestTextLocation(re, ae, W, v, H);
                                if (!ke) break;
                                Gv.addLabelData(ke, W, v, d);
                            }
                        });
                    }), b.remove(), Gv.drawLabels(h, v, r, f, u ? d : null);
                }
                l && !s && c.remove();
            }
            Gv.createLines = function(e, t, r, n) {
                var i = r[0].smoothing, a = e.selectAll("g.contourlevel").data(t ? r : []);
                if (a.exit().remove(), a.enter().append("g").classed("contourlevel", !0), t) {
                    var o = a.selectAll("path.openline").data(function(l) {
                        return l.pedgepaths || l.edgepaths;
                    });
                    o.exit().remove(), o.enter().append("path").classed("openline", !0), o.attr("d", function(l) {
                        return Oy.smoothopen(l, i);
                    }).style("stroke-miterlimit", 1).style("vector-effect", n ? "none" : "non-scaling-stroke");
                    var s = a.selectAll("path.closedline").data(function(l) {
                        return l.ppaths || l.paths;
                    });
                    s.exit().remove(), s.enter().append("path").classed("closedline", !0), s.attr("d", function(l) {
                        return Oy.smoothclosed(l, i);
                    }).style("stroke-miterlimit", 1).style("vector-effect", n ? "none" : "non-scaling-stroke");
                }
                return a;
            };
            Gv.createLineClip = function(e, t, r, n) {
                var i = r._fullLayout._clips, a = t ? "clipline" + n : null, o = i.selectAll("#" + a).data(t ? [
                    0
                ] : []);
                return o.exit().remove(), o.enter().append("clipPath").classed("contourlineclip", !0).attr("id", a), Oy.setClipUrl(e, a, r), o;
            };
            Gv.labelFormatter = function(e, t) {
                var r = e._fullLayout, n = t.trace, i = n.contours, a = {
                    type: "linear",
                    _id: "ycontour",
                    showexponent: "all",
                    exponentformat: "B"
                };
                if (i.labelformat) a.tickformat = i.labelformat, sbe(a, r);
                else {
                    var o = axt.extractOpts(n);
                    if (o && o.colorbar && o.colorbar._axis) a = o.colorbar._axis;
                    else {
                        if (i.type === "constraint") {
                            var s = i.value;
                            Id.isArrayOrTypedArray(s) ? a.range = [
                                s[0],
                                s[s.length - 1]
                            ] : a.range = [
                                s,
                                s
                            ];
                        } else a.range = [
                            i.start,
                            i.end
                        ], a.nticks = (i.end - i.start) / i.size;
                        a.range[0] === a.range[1] && (a.range[1] += a.range[0] || 1), a.nticks || (a.nticks = 1e3), sbe(a, r), obe.prepTicks(a), a._tmin = null, a._tmax = null;
                    }
                }
                return function(l) {
                    return obe.tickText(a, l).text;
                };
            };
            Gv.calcTextOpts = function(e, t, r, n) {
                var i = t(e);
                r.text(i).call(lbe.convertToTspans, n);
                var a = r.node(), o = Oy.bBox(a, !0);
                return {
                    text: i,
                    width: o.width,
                    height: o.height,
                    fontSize: +a.style["font-size"].replace("px", ""),
                    level: e,
                    dy: (o.top + o.bottom) / 2
                };
            };
            Gv.findBestTextLocation = function(e, t, r, n, i) {
                var a = r.width, o, s, l, u, c;
                t.isClosed ? (s = t.len / Rm.INITIALSEARCHPOINTS, o = t.min + s / 2, l = t.max) : (s = (t.len - a) / (Rm.INITIALSEARCHPOINTS + 1), o = t.min + s + a / 2, l = t.max - (s + a) / 2);
                for(var f = 1 / 0, h = 0; h < Rm.ITERATIONS; h++){
                    for(var d = o; d < l; d += s){
                        var v = Id.getTextLocation(e, t.total, d, a), x = hxt(v, r, n, i);
                        x < f && (f = x, c = v, u = d);
                    }
                    if (f > Rm.MAXCOST * 2) break;
                    h && (s /= 2), o = u - s / 2, l = o + s * 1.5;
                }
                if (f <= Rm.MAXCOST) return c;
            };
            function hxt(e, t, r, n) {
                var i = t.width / 2, a = t.height / 2, o = e.x, s = e.y, l = e.theta, u = Math.cos(l) * i, c = Math.sin(l) * i, f = (o > n.center ? n.right - o : o - n.left) / (u + Math.abs(Math.sin(l) * a)), h = (s > n.middle ? n.bottom - s : s - n.top) / (Math.abs(c) + Math.cos(l) * a);
                if (f < 1 || h < 1) return 1 / 0;
                var d = Rm.EDGECOST * (1 / (f - 1) + 1 / (h - 1));
                d += Rm.ANGLECOST * l * l;
                for(var v = o - u, x = s - c, b = o + u, p = s + c, E = 0; E < r.length; E++){
                    var k = r[E], A = Math.cos(k.theta) * k.width / 2, L = Math.sin(k.theta) * k.width / 2, _ = Id.segmentDistance(v, x, b, p, k.x - A, k.y - L, k.x + A, k.y + L) * 2 / (t.height + k.height), C = k.level === t.level, M = C ? Rm.SAMELEVELDISTANCE : 1;
                    if (_ <= M) return 1 / 0;
                    var g = Rm.NEIGHBORCOST * (C ? Rm.SAMELEVELFACTOR : 1);
                    d += g / (_ - M);
                }
                return d;
            }
            Gv.addLabelData = function(e, t, r, n) {
                var i = t.fontSize, a = t.width + i / 3, o = Math.max(0, t.height - i / 3), s = e.x, l = e.y, u = e.theta, c = Math.sin(u), f = Math.cos(u), h = function(v, x) {
                    return [
                        s + v * f - x * c,
                        l + v * c + x * f
                    ];
                }, d = [
                    h(-a / 2, -o / 2),
                    h(-a / 2, o / 2),
                    h(a / 2, o / 2),
                    h(a / 2, -o / 2)
                ];
                r.push({
                    text: t.text,
                    x: s,
                    y: l,
                    dy: t.dy,
                    theta: u,
                    level: t.level,
                    width: a,
                    height: o
                }), n.push(d);
            };
            Gv.drawLabels = function(e, t, r, n, i) {
                var a = e.selectAll("text").data(t, function(u) {
                    return u.text + "," + u.x + "," + u.y + "," + u.theta;
                });
                if (a.exit().remove(), a.enter().append("text").attr({
                    "data-notex": 1,
                    "text-anchor": "middle"
                }).each(function(u) {
                    var c = u.x + Math.sin(u.theta) * u.dy, f = u.y - Math.cos(u.theta) * u.dy;
                    k4.select(this).text(u.text).attr({
                        x: c,
                        y: f,
                        transform: "rotate(" + 180 * u.theta / Math.PI + " " + c + " " + f + ")"
                    }).call(lbe.convertToTspans, r);
                }), i) {
                    for(var o = "", s = 0; s < i.length; s++)o += "M" + i[s].join("L") + "Z";
                    var l = Id.ensureSingle(n, "path", "");
                    l.attr("d", o);
                }
            };
            function dxt(e, t, r, n, i) {
                var a = n.trace, o = r._fullLayout._clips, s = "clip" + a.uid, l = o.selectAll("#" + s).data(a.connectgaps ? [] : [
                    0
                ]);
                if (l.enter().append("clipPath").classed("contourclip", !0).attr("id", s), l.exit().remove(), a.connectgaps === !1) {
                    var u = {
                        level: .9,
                        crossings: {},
                        starts: [],
                        edgepaths: [],
                        paths: [],
                        xaxis: t.xaxis,
                        yaxis: t.yaxis,
                        x: n.x,
                        y: n.y,
                        z: vxt(n),
                        smoothing: 0
                    };
                    ube([
                        u
                    ]), cbe([
                        u
                    ]), fbe([
                        u
                    ], {
                        type: "levels"
                    });
                    var c = Id.ensureSingle(l, "path", "");
                    c.attr("d", (u.prefixBoundary ? "M" + i.join("L") + "Z" : "") + hbe(u, i));
                } else s = null;
                Oy.setClipUrl(e, s, r);
            }
            function vxt(e) {
                var t = e.trace._emptypoints, r = [], n = e.z.length, i = e.z[0].length, a, o = [], s;
                for(a = 0; a < i; a++)o.push(1);
                for(a = 0; a < n; a++)r.push(o.slice());
                for(a = 0; a < t.length; a++)s = t[a], r[s[0]][s[1]] = 0;
                return e.zmask = r, r;
            }
        });
        var gH = ye((elr, dbe)=>{
            "use strict";
            var pxt = xa(), pH = Mu(), gxt = A4();
            dbe.exports = function(t) {
                var r = t.contours, n = r.start, i = gxt(r), a = r.size || 1, o = Math.floor((i - n) / a) + 1, s = r.coloring === "lines" ? 0 : 1, l = pH.extractOpts(t);
                isFinite(a) || (a = 1, o = 1);
                var u = l.reversescale ? pH.flipScale(l.colorscale) : l.colorscale, c = u.length, f = new Array(c), h = new Array(c), d, v, x = l.min, b = l.max;
                if (r.coloring === "heatmap") {
                    for(v = 0; v < c; v++)d = u[v], f[v] = d[0] * (b - x) + x, h[v] = d[1];
                    var p = pxt.extent([
                        x,
                        b,
                        r.start,
                        r.start + a * (o - 1)
                    ]), E = p[x < b ? 0 : 1], k = p[x < b ? 1 : 0];
                    E !== x && (f.splice(0, 0, E), h.splice(0, 0, h[0])), k !== b && (f.push(k), h.push(h[h.length - 1]));
                } else {
                    var A = t._input && typeof t._input.zmin == "number" && typeof t._input.zmax == "number";
                    for(A && (n <= x || i >= b) && (n <= x && (n = x), i >= b && (i = b), o = Math.floor((i - n) / a) + 1, s = 0), v = 0; v < c; v++)d = u[v], f[v] = (d[0] * (o + s - 1) - s / 2) * a + n, h[v] = d[1];
                    (A || t.autocontour) && (f[0] > x && (f.unshift(x), h.unshift(h[0])), f[f.length - 1] < b && (f.push(b), h.push(h[h.length - 1])));
                }
                return pH.makeColorScaleFunc({
                    domain: f,
                    range: h
                }, {
                    noNumericCheck: !0
                });
            };
        });
        var A8 = ye((tlr, pbe)=>{
            "use strict";
            var T8 = xa(), vbe = ao(), mxt = l8(), yxt = gH();
            pbe.exports = function(t) {
                var r = T8.select(t).selectAll("g.contour");
                r.style("opacity", function(n) {
                    return n[0].trace.opacity;
                }), r.each(function(n) {
                    var i = T8.select(this), a = n[0].trace, o = a.contours, s = a.line, l = o.size || 1, u = o.start, c = o.type === "constraint", f = !c && o.coloring === "lines", h = !c && o.coloring === "fill", d = f || h ? yxt(a) : null;
                    i.selectAll("g.contourlevel").each(function(b) {
                        T8.select(this).selectAll("path").call(vbe.lineGroupStyle, s.width, f ? d(b.level) : s.color, s.dash);
                    });
                    var v = o.labelfont;
                    if (i.selectAll("g.contourlabels text").each(function(b) {
                        vbe.font(T8.select(this), {
                            weight: v.weight,
                            style: v.style,
                            variant: v.variant,
                            textcase: v.textcase,
                            lineposition: v.lineposition,
                            shadow: v.shadow,
                            family: v.family,
                            size: v.size,
                            color: v.color || (f ? d(b.level) : s.color)
                        });
                    }), c) i.selectAll("g.contourfill path").style("fill", a.fillcolor);
                    else if (h) {
                        var x;
                        i.selectAll("g.contourfill path").style("fill", function(b) {
                            return x === void 0 && (x = b.level), d(b.level + .5 * l);
                        }), x === void 0 && (x = u), i.selectAll("g.contourbg path").style("fill", d(x - .5 * l));
                    }
                }), mxt(t);
            };
        });
        var S8 = ye((rlr, mbe)=>{
            "use strict";
            var gbe = Mu(), _xt = gH(), xxt = A4();
            function bxt(e, t, r) {
                var n = t.contours, i = t.line, a = n.size || 1, o = n.coloring, s = _xt(t, {
                    isColorbar: !0
                });
                if (o === "heatmap") {
                    var l = gbe.extractOpts(t);
                    r._fillgradient = l.reversescale ? gbe.flipScale(l.colorscale) : l.colorscale, r._zrange = [
                        l.min,
                        l.max
                    ];
                } else o === "fill" && (r._fillcolor = s);
                r._line = {
                    color: o === "lines" ? s : i.color,
                    width: n.showlines !== !1 ? i.width : 0,
                    dash: i.dash
                }, r._levels = {
                    start: n.start,
                    end: xxt(n),
                    size: a
                };
            }
            mbe.exports = {
                min: "zmin",
                max: "zmax",
                calc: bxt
            };
        });
        var mH = ye((ilr, ybe)=>{
            "use strict";
            var M8 = va(), wxt = c8();
            ybe.exports = function(t, r, n, i, a) {
                a || (a = {}), a.isContour = !0;
                var o = wxt(t, r, n, i, a);
                return o && o.forEach(function(s) {
                    var l = s.trace;
                    l.contours.type === "constraint" && (l.fillcolor && M8.opacity(l.fillcolor) ? s.color = M8.addOpacity(l.fillcolor, 1) : l.contours.showlines && M8.opacity(l.line.color) && (s.color = M8.addOpacity(l.line.color, 1)));
                }), o;
            };
        });
        var xbe = ye((nlr, _be)=>{
            "use strict";
            _be.exports = {
                attributes: rH(),
                supplyDefaults: Nxe(),
                crossTraceDefaults: d8(),
                calc: sH(),
                plot: w8().plot,
                layerName: "contourlayer",
                style: A8(),
                colorbar: S8(),
                hoverPoints: mH(),
                moduleType: "trace",
                name: "histogram2dcontour",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "2dMap",
                    "contour",
                    "histogram",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var wbe = ye((alr, bbe)=>{
            "use strict";
            bbe.exports = xbe();
        });
        var yH = ye((olr, kbe)=>{
            "use strict";
            var Tbe = uo(), Txt = iH(), Mbe = va(), Abe = Mbe.addOpacity, Axt = Mbe.opacity, Ebe = g8(), Sbe = Mr().isArrayOrTypedArray, Sxt = Ebe.CONSTRAINT_REDUCTION, Mxt = Ebe.COMPARISON_OPS2;
            kbe.exports = function(t, r, n, i, a, o) {
                var s = r.contours, l, u, c, f = n("contours.operation");
                if (s._operation = Sxt[f], Ext(n, s), f === "=" ? l = s.showlines = !0 : (l = n("contours.showlines"), c = n("fillcolor", Abe((t.line || {}).color || a, .5))), l) {
                    var h = c && Axt(c) ? Abe(r.fillcolor, 1) : a;
                    u = n("line.color", h), n("line.width", 2), n("line.dash");
                }
                n("line.smoothing"), Txt(n, i, u, o);
            };
            function Ext(e, t) {
                var r;
                Mxt.indexOf(t.operation) === -1 ? (e("contours.value", [
                    0,
                    1
                ]), Sbe(t.value) ? t.value.length > 2 ? t.value = t.value.slice(2) : t.length === 0 ? t.value = [
                    0,
                    1
                ] : t.length < 2 ? (r = parseFloat(t.value[0]), t.value = [
                    r,
                    r + 1
                ]) : t.value = [
                    parseFloat(t.value[0]),
                    parseFloat(t.value[1])
                ] : Tbe(t.value) && (r = parseFloat(t.value), t.value = [
                    r,
                    r + 1
                ])) : (e("contours.value", 0), Tbe(t.value) || (Sbe(t.value) ? t.value = parseFloat(t.value[0]) : t.value = 0));
            }
        });
        var Pbe = ye((slr, Lbe)=>{
            "use strict";
            var _H = Mr(), kxt = XI(), Cxt = Pg(), Lxt = yH(), Pxt = y8(), Ixt = _8(), Rxt = y4(), Cbe = T4();
            Lbe.exports = function(t, r, n, i) {
                function a(u, c) {
                    return _H.coerce(t, r, Cbe, u, c);
                }
                function o(u) {
                    return _H.coerce2(t, r, Cbe, u);
                }
                var s = kxt(t, r, a, i);
                if (!s) {
                    r.visible = !1;
                    return;
                }
                Cxt(t, r, i, a), a("xhoverformat"), a("yhoverformat"), a("text"), a("hovertext"), a("hoverongaps"), a("hovertemplate");
                var l = a("contours.type") === "constraint";
                a("connectgaps", _H.isArray1D(r.z)), l ? Lxt(t, r, a, i, n) : (Pxt(t, r, a, o), Ixt(t, r, a, i)), r.contours && r.contours.coloring === "heatmap" && Rxt(a, i), a("zorder");
            };
        });
        var Rbe = ye((llr, Ibe)=>{
            "use strict";
            Ibe.exports = {
                attributes: T4(),
                supplyDefaults: Pbe(),
                calc: sH(),
                plot: w8().plot,
                style: A8(),
                colorbar: S8(),
                hoverPoints: mH(),
                moduleType: "trace",
                name: "contour",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "2dMap",
                    "contour",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var zbe = ye((ulr, Dbe)=>{
            "use strict";
            Dbe.exports = Rbe();
        });
        var xH = ye((clr, qbe)=>{
            "use strict";
            var Dxt = Wo().hovertemplateAttrs, zxt = Wo().texttemplateAttrs, Fxt = Eg(), a0 = Uc(), qxt = vl(), Fbe = Jl(), Oxt = Ed().dash, E_ = no().extendFlat, j0 = a0.marker, C4 = a0.line, Bxt = j0.line;
            qbe.exports = {
                a: {
                    valType: "data_array",
                    editType: "calc"
                },
                b: {
                    valType: "data_array",
                    editType: "calc"
                },
                c: {
                    valType: "data_array",
                    editType: "calc"
                },
                sum: {
                    valType: "number",
                    dflt: 0,
                    min: 0,
                    editType: "calc"
                },
                mode: E_({}, a0.mode, {
                    dflt: "markers"
                }),
                text: E_({}, a0.text, {}),
                texttemplate: zxt({
                    editType: "plot"
                }, {
                    keys: [
                        "a",
                        "b",
                        "c",
                        "text"
                    ]
                }),
                hovertext: E_({}, a0.hovertext, {}),
                line: {
                    color: C4.color,
                    width: C4.width,
                    dash: Oxt,
                    backoff: C4.backoff,
                    shape: E_({}, C4.shape, {
                        values: [
                            "linear",
                            "spline"
                        ]
                    }),
                    smoothing: C4.smoothing,
                    editType: "calc"
                },
                connectgaps: a0.connectgaps,
                cliponaxis: a0.cliponaxis,
                fill: E_({}, a0.fill, {
                    values: [
                        "none",
                        "toself",
                        "tonext"
                    ],
                    dflt: "none"
                }),
                fillcolor: Fxt(),
                marker: E_({
                    symbol: j0.symbol,
                    opacity: j0.opacity,
                    angle: j0.angle,
                    angleref: j0.angleref,
                    standoff: j0.standoff,
                    maxdisplayed: j0.maxdisplayed,
                    size: j0.size,
                    sizeref: j0.sizeref,
                    sizemin: j0.sizemin,
                    sizemode: j0.sizemode,
                    line: E_({
                        width: Bxt.width,
                        editType: "calc"
                    }, Fbe("marker.line")),
                    gradient: j0.gradient,
                    editType: "calc"
                }, Fbe("marker")),
                textfont: a0.textfont,
                textposition: a0.textposition,
                selected: a0.selected,
                unselected: a0.unselected,
                hoverinfo: E_({}, qxt.hoverinfo, {
                    flags: [
                        "a",
                        "b",
                        "c",
                        "text",
                        "name"
                    ]
                }),
                hoveron: a0.hoveron,
                hovertemplate: Dxt()
            };
        });
        var Ube = ye((flr, Nbe)=>{
            "use strict";
            var Obe = Mr(), Nxt = Sm(), zT = lu(), Uxt = $p(), Vxt = R0(), Bbe = J3(), Hxt = D0(), Gxt = Ig(), jxt = xH();
            Nbe.exports = function(t, r, n, i) {
                function a(h, d) {
                    return Obe.coerce(t, r, jxt, h, d);
                }
                var o = a("a"), s = a("b"), l = a("c"), u;
                if (o ? (u = o.length, s ? (u = Math.min(u, s.length), l && (u = Math.min(u, l.length))) : l ? u = Math.min(u, l.length) : u = 0) : s && l && (u = Math.min(s.length, l.length)), !u) {
                    r.visible = !1;
                    return;
                }
                r._length = u, a("sum"), a("text"), a("hovertext"), r.hoveron !== "fills" && a("hovertemplate");
                var c = u < Nxt.PTS_LINESONLY ? "lines+markers" : "lines";
                a("mode", c), zT.hasMarkers(r) && Uxt(t, r, n, i, a, {
                    gradient: !0
                }), zT.hasLines(r) && (Vxt(t, r, n, i, a, {
                    backoff: !0
                }), Bbe(t, r, a), a("connectgaps")), zT.hasText(r) && (a("texttemplate"), Hxt(t, r, i, a));
                var f = [];
                (zT.hasMarkers(r) || zT.hasText(r)) && (a("cliponaxis"), a("marker.maxdisplayed"), f.push("points")), a("fill"), r.fill !== "none" && (Gxt(t, r, n, a), zT.hasLines(r) || Bbe(t, r, a)), (r.fill === "tonext" || r.fill === "toself") && f.push("fills"), a("hoveron", f.join("+") || "points"), Obe.coerceSelectionMarkerOpacity(r, a);
            };
        });
        var Hbe = ye((hlr, Vbe)=>{
            "use strict";
            var bH = Qa();
            Vbe.exports = function(t, r, n) {
                var i = {}, a = n[r.subplot]._subplot;
                return i.aLabel = bH.tickText(a.aaxis, t.a, !0).text, i.bLabel = bH.tickText(a.baxis, t.b, !0).text, i.cLabel = bH.tickText(a.caxis, t.c, !0).text, i;
            };
        });
        var Zbe = ye((dlr, Wbe)=>{
            "use strict";
            var wH = uo(), Wxt = z0(), Zxt = km(), Xxt = F0(), Yxt = q0().calcMarkerSize, Gbe = [
                "a",
                "b",
                "c"
            ], jbe = {
                a: [
                    "b",
                    "c"
                ],
                b: [
                    "a",
                    "c"
                ],
                c: [
                    "a",
                    "b"
                ]
            };
            Wbe.exports = function(t, r) {
                var n = t._fullLayout[r.subplot], i = n.sum, a = r.sum || i, o = {
                    a: r.a,
                    b: r.b,
                    c: r.c
                }, s = r.ids, l, u, c, f, h, d;
                for(l = 0; l < Gbe.length; l++)if (c = Gbe[l], !o[c]) {
                    for(h = o[jbe[c][0]], d = o[jbe[c][1]], f = new Array(h.length), u = 0; u < h.length; u++)f[u] = a - h[u] - d[u];
                    o[c] = f;
                }
                var v = r._length, x = new Array(v), b, p, E, k, A, L;
                for(l = 0; l < v; l++)b = o.a[l], p = o.b[l], E = o.c[l], wH(b) && wH(p) && wH(E) ? (b = +b, p = +p, E = +E, k = i / (b + p + E), k !== 1 && (b *= k, p *= k, E *= k), L = b, A = E - p, x[l] = {
                    x: A,
                    y: L,
                    a: b,
                    b: p,
                    c: E
                }, s && (x[l].id = s[l])) : x[l] = {
                    x: !1,
                    y: !1
                };
                return Yxt(r, v), Wxt(t, r), Zxt(x, r), Xxt(x, r), x;
            };
        });
        var Ybe = ye((vlr, Xbe)=>{
            "use strict";
            var Kxt = iT();
            Xbe.exports = function(t, r, n) {
                var i = r.plotContainer;
                i.select(".scatterlayer").selectAll("*").remove();
                for(var a = r.xaxis, o = r.yaxis, s = {
                    xaxis: a,
                    yaxis: o,
                    plot: i,
                    layerClipId: r._hasClipOnAxisFalse ? r.clipIdRelative : null
                }, l = r.layers.frontplot.select("g.scatterlayer"), u = 0; u < n.length; u++){
                    var c = n[u];
                    c.length && (c[0].trace._xA = a, c[0].trace._yA = o);
                }
                Kxt(t, s, n, l);
            };
        });
        var Jbe = ye((plr, Kbe)=>{
            "use strict";
            var Jxt = sT();
            Kbe.exports = function(t, r, n, i) {
                var a = Jxt(t, r, n, i);
                if (!a || a[0].index === !1) return;
                var o = a[0];
                if (o.index === void 0) {
                    var s = 1 - o.y0 / t.ya._length, l = t.xa._length, u = l * s / 2, c = l - u;
                    return o.x0 = Math.max(Math.min(o.x0, c), u), o.x1 = Math.max(Math.min(o.x1, c), u), a;
                }
                var f = o.cd[o.index], h = o.trace, d = o.subplot;
                o.a = f.a, o.b = f.b, o.c = f.c, o.xLabelVal = void 0, o.yLabelVal = void 0;
                var v = {};
                v[h.subplot] = {
                    _subplot: d
                };
                var x = h._module.formatLabels(f, h, v);
                o.aLabel = x.aLabel, o.bLabel = x.bLabel, o.cLabel = x.cLabel;
                var b = f.hi || h.hoverinfo, p = [];
                function E(A, L) {
                    p.push(A._hovertitle + ": " + L);
                }
                if (!h.hovertemplate) {
                    var k = b.split("+");
                    k.indexOf("all") !== -1 && (k = [
                        "a",
                        "b",
                        "c"
                    ]), k.indexOf("a") !== -1 && E(d.aaxis, o.aLabel), k.indexOf("b") !== -1 && E(d.baxis, o.bLabel), k.indexOf("c") !== -1 && E(d.caxis, o.cLabel);
                }
                return o.extraText = p.join("<br>"), o.hovertemplate = h.hovertemplate, a;
            };
        });
        var Qbe = ye((glr, $be)=>{
            "use strict";
            $be.exports = function(t, r, n, i, a) {
                if (r.xa && (t.xaxis = r.xa), r.ya && (t.yaxis = r.ya), i[a]) {
                    var o = i[a];
                    t.a = o.a, t.b = o.b, t.c = o.c;
                } else t.a = r.a, t.b = r.b, t.c = r.c;
                return t;
            };
        });
        var c2e = ye((mlr, u2e)=>{
            "use strict";
            var a2e = xa(), $xt = id(), TH = ba(), By = Mr(), Dm = By.strTranslate, E8 = By._, qT = va(), k8 = ao(), L4 = ym(), AH = no().extendFlat, Qxt = Xu(), k_ = Qa(), e2e = gv(), t2e = Nc(), o2e = Sg(), r2e = o2e.freeMode, ebt = o2e.rectMode, SH = Mb(), tbt = wf().prepSelect, rbt = wf().selectOnClick, ibt = wf().clearOutline, nbt = wf().clearSelectionsCache, s2e = ad();
            function l2e(e, t) {
                this.id = e.id, this.graphDiv = e.graphDiv, this.init(t), this.makeFramework(t), this.updateFx(t), this.aTickLayout = null, this.bTickLayout = null, this.cTickLayout = null;
            }
            u2e.exports = l2e;
            var zm = l2e.prototype;
            zm.init = function(e) {
                this.container = e._ternarylayer, this.defs = e._defs, this.layoutId = e._uid, this.traceHash = {}, this.layers = {};
            };
            zm.plot = function(e, t) {
                var r = this, n = t[r.id], i = t._size;
                r._hasClipOnAxisFalse = !1;
                for(var a = 0; a < e.length; a++){
                    var o = e[a][0].trace;
                    if (o.cliponaxis === !1) {
                        r._hasClipOnAxisFalse = !0;
                        break;
                    }
                }
                r.updateLayers(n), r.adjustLayout(n, i), Qxt.generalUpdatePerTraceModule(r.graphDiv, r, e, n), r.layers.plotbg.select("path").call(qT.fill, n.bgcolor);
            };
            zm.makeFramework = function(e) {
                var t = this, r = t.graphDiv, n = e[t.id], i = t.clipId = "clip" + t.layoutId + t.id, a = t.clipIdRelative = "clip-relative" + t.layoutId + t.id;
                t.clipDef = By.ensureSingleById(e._clips, "clipPath", i, function(o) {
                    o.append("path").attr("d", "M0,0Z");
                }), t.clipDefRelative = By.ensureSingleById(e._clips, "clipPath", a, function(o) {
                    o.append("path").attr("d", "M0,0Z");
                }), t.plotContainer = By.ensureSingle(t.container, "g", t.id), t.updateLayers(n), k8.setClipUrl(t.layers.backplot, i, r), k8.setClipUrl(t.layers.grids, i, r);
            };
            zm.updateFx = function(e) {
                e._ternarylayer.selectAll("g.toplevel").style("cursor", e.dragmode === "pan" ? "move" : "crosshair");
            };
            zm.updateLayers = function(e) {
                var t = this, r = t.layers, n = [
                    "draglayer",
                    "plotbg",
                    "backplot",
                    "grids"
                ];
                e.aaxis.layer === "below traces" && n.push("aaxis", "aline"), e.baxis.layer === "below traces" && n.push("baxis", "bline"), e.caxis.layer === "below traces" && n.push("caxis", "cline"), n.push("frontplot"), e.aaxis.layer === "above traces" && n.push("aaxis", "aline"), e.baxis.layer === "above traces" && n.push("baxis", "bline"), e.caxis.layer === "above traces" && n.push("caxis", "cline");
                var i = t.plotContainer.selectAll("g.toplevel").data(n, String), a = [
                    "agrid",
                    "bgrid",
                    "cgrid"
                ];
                i.enter().append("g").attr("class", function(o) {
                    return "toplevel " + o;
                }).each(function(o) {
                    var s = a2e.select(this);
                    r[o] = s, o === "frontplot" ? s.append("g").classed("scatterlayer", !0) : o === "backplot" ? s.append("g").classed("maplayer", !0) : o === "plotbg" ? s.append("path").attr("d", "M0,0Z") : o === "aline" || o === "bline" || o === "cline" ? s.append("path") : o === "grids" && a.forEach(function(l) {
                        r[l] = s.append("g").classed("grid " + l, !0);
                    });
                }), i.order();
            };
            var FT = Math.sqrt(4 / 3);
            zm.adjustLayout = function(e, t) {
                var r = this, n = e.domain, i = (n.x[0] + n.x[1]) / 2, a = (n.y[0] + n.y[1]) / 2, o = n.x[1] - n.x[0], s = n.y[1] - n.y[0], l = o * t.w, u = s * t.h, c = e.sum, f = e.aaxis.min, h = e.baxis.min, d = e.caxis.min, v, x, b, p, E, k;
                l > FT * u ? (p = u, b = p * FT) : (b = l, p = b / FT), E = o * b / l, k = s * p / u, v = t.l + t.w * i - b / 2, x = t.t + t.h * (1 - a) - p / 2, r.x0 = v, r.y0 = x, r.w = b, r.h = p, r.sum = c, r.xaxis = {
                    type: "linear",
                    range: [
                        f + 2 * d - c,
                        c - f - 2 * h
                    ],
                    domain: [
                        i - E / 2,
                        i + E / 2
                    ],
                    _id: "x"
                }, L4(r.xaxis, r.graphDiv._fullLayout), r.xaxis.setScale(), r.xaxis.isPtWithinRange = function(V) {
                    return V.a >= r.aaxis.range[0] && V.a <= r.aaxis.range[1] && V.b >= r.baxis.range[1] && V.b <= r.baxis.range[0] && V.c >= r.caxis.range[1] && V.c <= r.caxis.range[0];
                }, r.yaxis = {
                    type: "linear",
                    range: [
                        f,
                        c - h - d
                    ],
                    domain: [
                        a - k / 2,
                        a + k / 2
                    ],
                    _id: "y"
                }, L4(r.yaxis, r.graphDiv._fullLayout), r.yaxis.setScale(), r.yaxis.isPtWithinRange = function() {
                    return !0;
                };
                var A = r.yaxis.domain[0], L = r.aaxis = AH({}, e.aaxis, {
                    range: [
                        f,
                        c - h - d
                    ],
                    side: "left",
                    tickangle: (+e.aaxis.tickangle || 0) - 30,
                    domain: [
                        A,
                        A + k * FT
                    ],
                    anchor: "free",
                    position: 0,
                    _id: "y",
                    _length: b
                });
                L4(L, r.graphDiv._fullLayout), L.setScale();
                var _ = r.baxis = AH({}, e.baxis, {
                    range: [
                        c - f - d,
                        h
                    ],
                    side: "bottom",
                    domain: r.xaxis.domain,
                    anchor: "free",
                    position: 0,
                    _id: "x",
                    _length: b
                });
                L4(_, r.graphDiv._fullLayout), _.setScale();
                var C = r.caxis = AH({}, e.caxis, {
                    range: [
                        c - f - h,
                        d
                    ],
                    side: "right",
                    tickangle: (+e.caxis.tickangle || 0) + 30,
                    domain: [
                        A,
                        A + k * FT
                    ],
                    anchor: "free",
                    position: 0,
                    _id: "y",
                    _length: b
                });
                L4(C, r.graphDiv._fullLayout), C.setScale();
                var M = "M" + v + "," + (x + p) + "h" + b + "l-" + b / 2 + ",-" + p + "Z";
                r.clipDef.select("path").attr("d", M), r.layers.plotbg.select("path").attr("d", M);
                var g = "M0," + p + "h" + b + "l-" + b / 2 + ",-" + p + "Z";
                r.clipDefRelative.select("path").attr("d", g);
                var P = Dm(v, x);
                r.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", P), r.clipDefRelative.select("path").attr("transform", null);
                var T = Dm(v - _._offset, x + p);
                r.layers.baxis.attr("transform", T), r.layers.bgrid.attr("transform", T);
                var F = Dm(v + b / 2, x) + "rotate(30)" + Dm(0, -L._offset);
                r.layers.aaxis.attr("transform", F), r.layers.agrid.attr("transform", F);
                var q = Dm(v + b / 2, x) + "rotate(-30)" + Dm(0, -C._offset);
                r.layers.caxis.attr("transform", q), r.layers.cgrid.attr("transform", q), r.drawAxes(!0), r.layers.aline.select("path").attr("d", L.showline ? "M" + v + "," + (x + p) + "l" + b / 2 + ",-" + p : "M0,0").call(qT.stroke, L.linecolor || "#000").style("stroke-width", (L.linewidth || 0) + "px"), r.layers.bline.select("path").attr("d", _.showline ? "M" + v + "," + (x + p) + "h" + b : "M0,0").call(qT.stroke, _.linecolor || "#000").style("stroke-width", (_.linewidth || 0) + "px"), r.layers.cline.select("path").attr("d", C.showline ? "M" + (v + b / 2) + "," + x + "l" + b / 2 + "," + p : "M0,0").call(qT.stroke, C.linecolor || "#000").style("stroke-width", (C.linewidth || 0) + "px"), r.graphDiv._context.staticPlot || r.initInteractions(), k8.setClipUrl(r.layers.frontplot, r._hasClipOnAxisFalse ? null : r.clipId, r.graphDiv);
            };
            zm.drawAxes = function(e) {
                var t = this, r = t.graphDiv, n = t.id.substr(7) + "title", i = t.layers, a = t.aaxis, o = t.baxis, s = t.caxis;
                if (t.drawAx(a), t.drawAx(o), t.drawAx(s), e) {
                    var l = Math.max(a.showticklabels ? a.tickfont.size / 2 : 0, (s.showticklabels ? s.tickfont.size * .75 : 0) + (s.ticks === "outside" ? s.ticklen * .87 : 0)), u = (o.showticklabels ? o.tickfont.size : 0) + (o.ticks === "outside" ? o.ticklen : 0) + 3;
                    i["a-title"] = SH.draw(r, "a" + n, {
                        propContainer: a,
                        propName: t.id + ".aaxis.title",
                        placeholder: E8(r, "Click to enter Component A title"),
                        attributes: {
                            x: t.x0 + t.w / 2,
                            y: t.y0 - a.title.font.size / 3 - l,
                            "text-anchor": "middle"
                        }
                    }), i["b-title"] = SH.draw(r, "b" + n, {
                        propContainer: o,
                        propName: t.id + ".baxis.title",
                        placeholder: E8(r, "Click to enter Component B title"),
                        attributes: {
                            x: t.x0 - u,
                            y: t.y0 + t.h + o.title.font.size * .83 + u,
                            "text-anchor": "middle"
                        }
                    }), i["c-title"] = SH.draw(r, "c" + n, {
                        propContainer: s,
                        propName: t.id + ".caxis.title",
                        placeholder: E8(r, "Click to enter Component C title"),
                        attributes: {
                            x: t.x0 + t.w + u,
                            y: t.y0 + t.h + s.title.font.size * .83 + u,
                            "text-anchor": "middle"
                        }
                    });
                }
            };
            zm.drawAx = function(e) {
                var t = this, r = t.graphDiv, n = e._name, i = n.charAt(0), a = e._id, o = t.layers[n], s = 30, l = i + "tickLayout", u = abt(e);
                t[l] !== u && (o.selectAll("." + a + "tick").remove(), t[l] = u), e.setScale();
                var c = k_.calcTicks(e), f = k_.clipEnds(e, c), h = k_.makeTransTickFn(e), d = k_.getTickSigns(e)[2], v = By.deg2rad(s), x = d * (e.linewidth || 1) / 2, b = d * e.ticklen, p = t.w, E = t.h, k = i === "b" ? "M0," + x + "l" + Math.sin(v) * b + "," + Math.cos(v) * b : "M" + x + ",0l" + Math.cos(v) * b + "," + -Math.sin(v) * b, A = {
                    a: "M0,0l" + E + ",-" + p / 2,
                    b: "M0,0l-" + p / 2 + ",-" + E,
                    c: "M0,0l-" + E + "," + p / 2
                }[i];
                k_.drawTicks(r, e, {
                    vals: e.ticks === "inside" ? f : c,
                    layer: o,
                    path: k,
                    transFn: h,
                    crisp: !1
                }), k_.drawGrid(r, e, {
                    vals: f,
                    layer: t.layers[i + "grid"],
                    path: A,
                    transFn: h,
                    crisp: !1
                }), k_.drawLabels(r, e, {
                    vals: c,
                    layer: o,
                    transFn: h,
                    labelFns: k_.makeLabelFns(e, 0, s)
                });
            };
            function abt(e) {
                return e.ticks + String(e.ticklen) + String(e.showticklabels);
            }
            var fd = s2e.MINZOOM / 2 + .87, obt = "m-0.87,.5h" + fd + "v3h-" + (fd + 5.2) + "l" + (fd / 2 + 2.6) + ",-" + (fd * .87 + 4.5) + "l2.6,1.5l-" + fd / 2 + "," + fd * .87 + "Z", sbt = "m0.87,.5h-" + fd + "v3h" + (fd + 5.2) + "l-" + (fd / 2 + 2.6) + ",-" + (fd * .87 + 4.5) + "l-2.6,1.5l" + fd / 2 + "," + fd * .87 + "Z", lbt = "m0,1l" + fd / 2 + "," + fd * .87 + "l2.6,-1.5l-" + (fd / 2 + 2.6) + ",-" + (fd * .87 + 4.5) + "l-" + (fd / 2 + 2.6) + "," + (fd * .87 + 4.5) + "l2.6,1.5l" + fd / 2 + ",-" + fd * .87 + "Z", ubt = "m0.5,0.5h5v-2h-5v-5h-2v5h-5v2h5v5h2Z", i2e = !0;
            zm.clearOutline = function() {
                nbt(this.dragOptions), ibt(this.dragOptions.gd);
            };
            zm.initInteractions = function() {
                var e = this, t = e.layers.plotbg.select("path").node(), r = e.graphDiv, n = r._fullLayout._zoomlayer, i, a;
                this.dragOptions = {
                    element: t,
                    gd: r,
                    plotinfo: {
                        id: e.id,
                        domain: r._fullLayout[e.id].domain,
                        xaxis: e.xaxis,
                        yaxis: e.yaxis
                    },
                    subplot: e.id,
                    prepFn: function(T, F, q) {
                        e.dragOptions.xaxes = [
                            e.xaxis
                        ], e.dragOptions.yaxes = [
                            e.yaxis
                        ], i = r._fullLayout._invScaleX, a = r._fullLayout._invScaleY;
                        var V = e.dragOptions.dragmode = r._fullLayout.dragmode;
                        r2e(V) ? e.dragOptions.minDrag = 1 : e.dragOptions.minDrag = void 0, V === "zoom" ? (e.dragOptions.moveFn = _, e.dragOptions.clickFn = p, e.dragOptions.doneFn = C, E(T, F, q)) : V === "pan" ? (e.dragOptions.moveFn = g, e.dragOptions.clickFn = p, e.dragOptions.doneFn = P, M(), e.clearOutline(r)) : (ebt(V) || r2e(V)) && tbt(T, F, q, e.dragOptions, V);
                    }
                };
                var o, s, l, u, c, f, h, d, v, x;
                function b(T) {
                    var F = {};
                    return F[e.id + ".aaxis.min"] = T.a, F[e.id + ".baxis.min"] = T.b, F[e.id + ".caxis.min"] = T.c, F;
                }
                function p(T, F) {
                    var q = r._fullLayout.clickmode;
                    n2e(r), T === 2 && (r.emit("plotly_doubleclick", null), TH.call("_guiRelayout", r, b({
                        a: 0,
                        b: 0,
                        c: 0
                    }))), q.indexOf("select") > -1 && T === 1 && rbt(F, r, [
                        e.xaxis
                    ], [
                        e.yaxis
                    ], e.id, e.dragOptions), q.indexOf("event") > -1 && t2e.click(r, F, e.id);
                }
                function E(T, F, q) {
                    var V = t.getBoundingClientRect();
                    o = F - V.left, s = q - V.top, r._fullLayout._calcInverseTransform(r);
                    var H = r._fullLayout._invTransform, X = By.apply3DTransform(H)(o, s);
                    o = X[0], s = X[1], l = {
                        a: e.aaxis.range[0],
                        b: e.baxis.range[1],
                        c: e.caxis.range[1]
                    }, c = l, u = e.aaxis.range[1] - l.a, f = $xt(e.graphDiv._fullLayout[e.id].bgcolor).getLuminance(), h = "M0," + e.h + "L" + e.w / 2 + ", 0L" + e.w + "," + e.h + "Z", d = !1, v = n.append("path").attr("class", "zoombox").attr("transform", Dm(e.x0, e.y0)).style({
                        fill: f > .2 ? "rgba(0,0,0,0)" : "rgba(255,255,255,0)",
                        "stroke-width": 0
                    }).attr("d", h), x = n.append("path").attr("class", "zoombox-corners").attr("transform", Dm(e.x0, e.y0)).style({
                        fill: qT.background,
                        stroke: qT.defaultLine,
                        "stroke-width": 1,
                        opacity: 0
                    }).attr("d", "M0,0Z"), e.clearOutline(r);
                }
                function k(T, F) {
                    return 1 - F / e.h;
                }
                function A(T, F) {
                    return 1 - (T + (e.h - F) / Math.sqrt(3)) / e.w;
                }
                function L(T, F) {
                    return (T - (e.h - F) / Math.sqrt(3)) / e.w;
                }
                function _(T, F) {
                    var q = o + T * i, V = s + F * a, H = Math.max(0, Math.min(1, k(o, s), k(q, V))), X = Math.max(0, Math.min(1, A(o, s), A(q, V))), G = Math.max(0, Math.min(1, L(o, s), L(q, V))), N = (H / 2 + G) * e.w, W = (1 - H / 2 - X) * e.w, re = (N + W) / 2, ae = W - N, _e = (1 - H) * e.h, Me = _e - ae / FT;
                    ae < s2e.MINZOOM ? (c = l, v.attr("d", h), x.attr("d", "M0,0Z")) : (c = {
                        a: l.a + H * u,
                        b: l.b + X * u,
                        c: l.c + G * u
                    }, v.attr("d", h + "M" + N + "," + _e + "H" + W + "L" + re + "," + Me + "L" + N + "," + _e + "Z"), x.attr("d", "M" + o + "," + s + ubt + "M" + N + "," + _e + obt + "M" + W + "," + _e + sbt + "M" + re + "," + Me + lbt)), d || (v.transition().style("fill", f > .2 ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.3)").duration(200), x.transition().style("opacity", 1).duration(200), d = !0), r.emit("plotly_relayouting", b(c));
                }
                function C() {
                    n2e(r), c !== l && (TH.call("_guiRelayout", r, b(c)), i2e && r.data && r._context.showTips && (By.notifier(E8(r, "Double-click to zoom back out"), "long"), i2e = !1));
                }
                function M() {
                    l = {
                        a: e.aaxis.range[0],
                        b: e.baxis.range[1],
                        c: e.caxis.range[1]
                    }, c = l;
                }
                function g(T, F) {
                    var q = T / e.xaxis._m, V = F / e.yaxis._m;
                    c = {
                        a: l.a - V,
                        b: l.b + (q + V) / 2,
                        c: l.c - (q - V) / 2
                    };
                    var H = [
                        c.a,
                        c.b,
                        c.c
                    ].sort(By.sorterAsc), X = {
                        a: H.indexOf(c.a),
                        b: H.indexOf(c.b),
                        c: H.indexOf(c.c)
                    };
                    H[0] < 0 && (H[1] + H[0] / 2 < 0 ? (H[2] += H[0] + H[1], H[0] = H[1] = 0) : (H[2] += H[0] / 2, H[1] += H[0] / 2, H[0] = 0), c = {
                        a: H[X.a],
                        b: H[X.b],
                        c: H[X.c]
                    }, F = (l.a - c.a) * e.yaxis._m, T = (l.c - c.c - l.b + c.b) * e.xaxis._m);
                    var G = Dm(e.x0 + T, e.y0 + F);
                    e.plotContainer.selectAll(".scatterlayer,.maplayer").attr("transform", G);
                    var N = Dm(-T, -F);
                    e.clipDefRelative.select("path").attr("transform", N), e.aaxis.range = [
                        c.a,
                        e.sum - c.b - c.c
                    ], e.baxis.range = [
                        e.sum - c.a - c.c,
                        c.b
                    ], e.caxis.range = [
                        e.sum - c.a - c.b,
                        c.c
                    ], e.drawAxes(!1), e._hasClipOnAxisFalse && e.plotContainer.select(".scatterlayer").selectAll(".trace").call(k8.hideOutsideRangePoints, e), r.emit("plotly_relayouting", b(c));
                }
                function P() {
                    TH.call("_guiRelayout", r, b(c));
                }
                t.onmousemove = function(T) {
                    t2e.hover(r, T, e.id), r._fullLayout._lasthover = t, r._fullLayout._hoversubplot = e.id;
                }, t.onmouseout = function(T) {
                    r._dragging || e2e.unhover(r, T);
                }, e2e.init(this.dragOptions);
            };
            function n2e(e) {
                a2e.select(e).selectAll(".zoombox,.js-zoombox-backdrop,.js-zoombox-menu,.zoombox-corners").remove();
            }
        });
        var kH = ye((ylr, f2e)=>{
            "use strict";
            var cbt = dh(), fbt = Ju().attributes, Ol = Cd(), hbt = Bu().overrideAll, MH = no().extendFlat, EH = {
                title: {
                    text: Ol.title.text,
                    font: Ol.title.font
                },
                color: Ol.color,
                tickmode: Ol.minor.tickmode,
                nticks: MH({}, Ol.nticks, {
                    dflt: 6,
                    min: 1
                }),
                tick0: Ol.tick0,
                dtick: Ol.dtick,
                tickvals: Ol.tickvals,
                ticktext: Ol.ticktext,
                ticks: Ol.ticks,
                ticklen: Ol.ticklen,
                tickwidth: Ol.tickwidth,
                tickcolor: Ol.tickcolor,
                ticklabelstep: Ol.ticklabelstep,
                showticklabels: Ol.showticklabels,
                labelalias: Ol.labelalias,
                showtickprefix: Ol.showtickprefix,
                tickprefix: Ol.tickprefix,
                showticksuffix: Ol.showticksuffix,
                ticksuffix: Ol.ticksuffix,
                showexponent: Ol.showexponent,
                exponentformat: Ol.exponentformat,
                minexponent: Ol.minexponent,
                separatethousands: Ol.separatethousands,
                tickfont: Ol.tickfont,
                tickangle: Ol.tickangle,
                tickformat: Ol.tickformat,
                tickformatstops: Ol.tickformatstops,
                hoverformat: Ol.hoverformat,
                showline: MH({}, Ol.showline, {
                    dflt: !0
                }),
                linecolor: Ol.linecolor,
                linewidth: Ol.linewidth,
                showgrid: MH({}, Ol.showgrid, {
                    dflt: !0
                }),
                gridcolor: Ol.gridcolor,
                gridwidth: Ol.gridwidth,
                griddash: Ol.griddash,
                layer: Ol.layer,
                min: {
                    valType: "number",
                    dflt: 0,
                    min: 0
                }
            }, C8 = f2e.exports = hbt({
                domain: fbt({
                    name: "ternary"
                }),
                bgcolor: {
                    valType: "color",
                    dflt: cbt.background
                },
                sum: {
                    valType: "number",
                    dflt: 1,
                    min: 0
                },
                aaxis: EH,
                baxis: EH,
                caxis: EH
            }, "plot", "from-root");
            C8.uirevision = {
                valType: "any",
                editType: "none"
            };
            C8.aaxis.uirevision = C8.baxis.uirevision = C8.caxis.uirevision = {
                valType: "any",
                editType: "none"
            };
        });
        var C_ = ye((_lr, h2e)=>{
            "use strict";
            var dbt = Mr(), vbt = Vs(), pbt = Ju().defaults;
            h2e.exports = function(t, r, n, i) {
                var a = i.type, o = i.attributes, s = i.handleDefaults, l = i.partition || "x", u = r._subplots[a], c = u.length, f = c && u[0].replace(/\d+$/, ""), h, d;
                function v(E, k) {
                    return dbt.coerce(h, d, o, E, k);
                }
                for(var x = 0; x < c; x++){
                    var b = u[x];
                    t[b] ? h = t[b] : h = t[b] = {}, d = vbt.newContainer(r, b, f), i.noUirevision || v("uirevision", r.uirevision);
                    var p = {};
                    p[l] = [
                        x / c,
                        (x + 1) / c
                    ], pbt(d, r, v, p), i.id = b, s(h, d, v, i);
                }
            };
        });
        var g2e = ye((xlr, p2e)=>{
            "use strict";
            var gbt = va(), mbt = Vs(), L8 = Mr(), ybt = C_(), _bt = t_(), xbt = r_(), bbt = T3(), wbt = xb(), Tbt = YM(), v2e = kH(), d2e = [
                "aaxis",
                "baxis",
                "caxis"
            ];
            p2e.exports = function(t, r, n) {
                ybt(t, r, n, {
                    type: "ternary",
                    attributes: v2e,
                    handleDefaults: Abt,
                    font: r.font,
                    paper_bgcolor: r.paper_bgcolor
                });
            };
            function Abt(e, t, r, n) {
                var i = r("bgcolor"), a = r("sum");
                n.bgColor = gbt.combine(i, n.paper_bgcolor);
                for(var o, s, l, u = 0; u < d2e.length; u++)o = d2e[u], s = e[o] || {}, l = mbt.newContainer(t, o), l._name = o, Sbt(s, l, n, t);
                var c = t.aaxis, f = t.baxis, h = t.caxis;
                c.min + f.min + h.min >= a && (c.min = 0, f.min = 0, h.min = 0, e.aaxis && delete e.aaxis.min, e.baxis && delete e.baxis.min, e.caxis && delete e.caxis.min);
            }
            function Sbt(e, t, r, n) {
                var i = v2e[t._name];
                function a(d, v) {
                    return L8.coerce(e, t, i, d, v);
                }
                a("uirevision", n.uirevision), t.type = "linear";
                var o = a("color"), s = o !== i.color.dflt ? o : r.font.color, l = t._name, u = l.charAt(0).toUpperCase(), c = "Component " + u, f = a("title.text", c);
                t._hovertitle = f === c ? f : u, L8.coerceFont(a, "title.font", r.font, {
                    overrideDflt: {
                        size: L8.bigFont(r.font.size),
                        color: s
                    }
                }), a("min"), wbt(e, t, a, "linear"), xbt(e, t, a, "linear"), _bt(e, t, a, "linear", {
                    noAutotickangles: !0,
                    noTicklabelshift: !0,
                    noTicklabelstandoff: !0
                }), bbt(e, t, a, {
                    outerTicks: !0
                });
                var h = a("showticklabels");
                h && (L8.coerceFont(a, "tickfont", r.font, {
                    overrideDflt: {
                        color: s
                    }
                }), a("tickangle"), a("tickformat")), Tbt(e, t, a, {
                    dfltColor: o,
                    bgColor: r.bgColor,
                    blend: 60,
                    showLine: !0,
                    showGrid: !0,
                    noZeroLine: !0,
                    attributes: i
                }), a("hoverformat"), a("layer");
            }
        });
        var m2e = ye((W0)=>{
            "use strict";
            var Mbt = c2e(), Ebt = kd().getSubplotCalcData, kbt = Mr().counterRegex, OT = "ternary";
            W0.name = OT;
            var Cbt = W0.attr = "subplot";
            W0.idRoot = OT;
            W0.idRegex = W0.attrRegex = kbt(OT);
            var Lbt = W0.attributes = {};
            Lbt[Cbt] = {
                valType: "subplotid",
                dflt: "ternary",
                editType: "calc"
            };
            W0.layoutAttributes = kH();
            W0.supplyLayoutDefaults = g2e();
            W0.plot = function(t) {
                for(var r = t._fullLayout, n = t.calcdata, i = r._subplots[OT], a = 0; a < i.length; a++){
                    var o = i[a], s = Ebt(n, OT, o), l = r[o]._subplot;
                    l || (l = new Mbt({
                        id: o,
                        graphDiv: t,
                        container: r._ternarylayer.node()
                    }, r), r[o]._subplot = l), l.plot(s, r, t._promises);
                }
            };
            W0.clean = function(e, t, r, n) {
                for(var i = n._subplots[OT] || [], a = 0; a < i.length; a++){
                    var o = i[a], s = n[o]._subplot;
                    !t[o] && s && (s.plotContainer.remove(), s.clipDef.remove(), s.clipDefRelative.remove(), s.layers["a-title"].remove(), s.layers["b-title"].remove(), s.layers["c-title"].remove());
                }
            };
            W0.updateFx = function(e) {
                var t = e._fullLayout;
                t._ternarylayer.selectAll("g.toplevel").style("cursor", t.dragmode === "pan" ? "move" : "crosshair");
            };
        });
        var _2e = ye((wlr, y2e)=>{
            "use strict";
            y2e.exports = {
                attributes: xH(),
                supplyDefaults: Ube(),
                colorbar: Kd(),
                formatLabels: Hbe(),
                calc: Zbe(),
                plot: Ybe(),
                style: op().style,
                styleOnSelect: op().styleOnSelect,
                hoverPoints: Jbe(),
                selectPoints: lT(),
                eventData: Qbe(),
                moduleType: "trace",
                name: "scatterternary",
                basePlotModule: m2e(),
                categories: [
                    "ternary",
                    "symbols",
                    "showLegend",
                    "scatter-like"
                ],
                meta: {}
            };
        });
        var b2e = ye((Tlr, x2e)=>{
            "use strict";
            x2e.exports = _2e();
        });
        var CH = ye((Alr, T2e)=>{
            "use strict";
            var jh = v4(), BT = no().extendFlat, w2e = Oc().axisHoverFormat;
            T2e.exports = {
                y: jh.y,
                x: jh.x,
                x0: jh.x0,
                y0: jh.y0,
                xhoverformat: w2e("x"),
                yhoverformat: w2e("y"),
                name: BT({}, jh.name, {}),
                orientation: BT({}, jh.orientation, {}),
                bandwidth: {
                    valType: "number",
                    min: 0,
                    editType: "calc"
                },
                scalegroup: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                scalemode: {
                    valType: "enumerated",
                    values: [
                        "width",
                        "count"
                    ],
                    dflt: "width",
                    editType: "calc"
                },
                spanmode: {
                    valType: "enumerated",
                    values: [
                        "soft",
                        "hard",
                        "manual"
                    ],
                    dflt: "soft",
                    editType: "calc"
                },
                span: {
                    valType: "info_array",
                    items: [
                        {
                            valType: "any",
                            editType: "calc"
                        },
                        {
                            valType: "any",
                            editType: "calc"
                        }
                    ],
                    editType: "calc"
                },
                line: {
                    color: {
                        valType: "color",
                        editType: "style"
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        dflt: 2,
                        editType: "style"
                    },
                    editType: "plot"
                },
                fillcolor: jh.fillcolor,
                points: BT({}, jh.boxpoints, {}),
                jitter: BT({}, jh.jitter, {}),
                pointpos: BT({}, jh.pointpos, {}),
                width: BT({}, jh.width, {}),
                marker: jh.marker,
                text: jh.text,
                hovertext: jh.hovertext,
                hovertemplate: jh.hovertemplate,
                quartilemethod: jh.quartilemethod,
                box: {
                    visible: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .25,
                        editType: "plot"
                    },
                    fillcolor: {
                        valType: "color",
                        editType: "style"
                    },
                    line: {
                        color: {
                            valType: "color",
                            editType: "style"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            editType: "style"
                        },
                        editType: "style"
                    },
                    editType: "plot"
                },
                meanline: {
                    visible: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "plot"
                    },
                    color: {
                        valType: "color",
                        editType: "style"
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        editType: "style"
                    },
                    editType: "plot"
                },
                side: {
                    valType: "enumerated",
                    values: [
                        "both",
                        "positive",
                        "negative"
                    ],
                    dflt: "both",
                    editType: "calc"
                },
                offsetgroup: jh.offsetgroup,
                alignmentgroup: jh.alignmentgroup,
                selected: jh.selected,
                unselected: jh.unselected,
                hoveron: {
                    valType: "flaglist",
                    flags: [
                        "violins",
                        "points",
                        "kde"
                    ],
                    dflt: "violins+points+kde",
                    extras: [
                        "all"
                    ],
                    editType: "style"
                },
                zorder: jh.zorder
            };
        });
        var IH = ye((Slr, A2e)=>{
            "use strict";
            var LH = p4(), PH = Mr().extendFlat;
            A2e.exports = {
                violinmode: PH({}, LH.boxmode, {}),
                violingap: PH({}, LH.boxgap, {}),
                violingroupgap: PH({}, LH.boxgroupgap, {})
            };
        });
        var C2e = ye((Mlr, k2e)=>{
            "use strict";
            var S2e = Mr(), Pbt = va(), M2e = m4(), E2e = CH();
            k2e.exports = function(t, r, n, i) {
                function a(L, _) {
                    return S2e.coerce(t, r, E2e, L, _);
                }
                function o(L, _) {
                    return S2e.coerce2(t, r, E2e, L, _);
                }
                if (M2e.handleSampleDefaults(t, r, a, i), r.visible !== !1) {
                    a("bandwidth"), a("side");
                    var s = a("width");
                    s || (a("scalegroup", r.name), a("scalemode"));
                    var l = a("span"), u;
                    Array.isArray(l) && (u = "manual"), a("spanmode", u);
                    var c = a("line.color", (t.marker || {}).color || n), f = a("line.width"), h = a("fillcolor", Pbt.addOpacity(r.line.color, .5));
                    M2e.handlePointsDefaults(t, r, a, {
                        prefix: ""
                    });
                    var d = o("box.width"), v = o("box.fillcolor", h), x = o("box.line.color", c), b = o("box.line.width", f), p = a("box.visible", !!(d || v || x || b));
                    p || (r.box = {
                        visible: !1
                    });
                    var E = o("meanline.color", c), k = o("meanline.width", f), A = a("meanline.visible", !!(E || k));
                    A || (r.meanline = {
                        visible: !1
                    }), a("quartilemethod"), a("zorder");
                }
            };
        });
        var P2e = ye((Elr, L2e)=>{
            "use strict";
            var Ibt = Mr(), Rbt = IH(), Dbt = VI();
            L2e.exports = function(t, r, n) {
                function i(a, o) {
                    return Ibt.coerce(t, r, Rbt, a, o);
                }
                Dbt._supply(t, r, n, i, "violin");
            };
        });
        var P8 = ye((o2)=>{
            "use strict";
            var zbt = Mr(), Fbt = {
                gaussian: function(e) {
                    return 1 / Math.sqrt(2 * Math.PI) * Math.exp(-0.5 * e * e);
                }
            };
            o2.makeKDE = function(e, t, r) {
                var n = r.length, i = Fbt.gaussian, a = e.bandwidth, o = 1 / (n * a);
                return function(s) {
                    for(var l = 0, u = 0; u < n; u++)l += i((s - r[u]) / a);
                    return o * l;
                };
            };
            o2.getPositionOnKdePath = function(e, t, r) {
                var n, i;
                t.orientation === "h" ? (n = "y", i = "x") : (n = "x", i = "y");
                var a = zbt.findPointOnPath(e.path, r, i, {
                    pathLength: e.pathLength
                }), o = e.posCenterPx, s = a[n], l = t.side === "both" ? 2 * o - s : o;
                return [
                    s,
                    l
                ];
            };
            o2.getKdeValue = function(e, t, r) {
                var n = e.pts.map(o2.extractVal), i = o2.makeKDE(e, t, n);
                return i(r) / e.posDensityScale;
            };
            o2.extractVal = function(e) {
                return e.v;
            };
        });
        var D2e = ye((Clr, R2e)=>{
            "use strict";
            var RH = Mr(), DH = Qa(), qbt = MV(), I2e = P8(), Obt = es().BADNUM;
            R2e.exports = function(t, r) {
                var n = qbt(t, r);
                if (n[0].t.empty) return n;
                for(var i = t._fullLayout, a = DH.getFromId(t, r[r.orientation === "h" ? "xaxis" : "yaxis"]), o = 1 / 0, s = -1 / 0, l = 0, u = 0, c = 0; c < n.length; c++){
                    var f = n[c], h = f.pts.map(I2e.extractVal), d = f.bandwidth = Nbt(r, f, h), v = f.span = Ubt(r, f, a, d);
                    if (f.min === f.max && d === 0) v = f.span = [
                        f.min,
                        f.max
                    ], f.density = [
                        {
                            v: 1,
                            t: v[0]
                        }
                    ], f.bandwidth = d, l = Math.max(l, 1);
                    else {
                        var x = v[1] - v[0], b = Math.ceil(x / (d / 3)), p = x / b;
                        if (!isFinite(p) || !isFinite(b)) return RH.error("Something went wrong with computing the violin span"), n[0].t.empty = !0, n;
                        var E = I2e.makeKDE(f, r, h);
                        f.density = new Array(b);
                        for(var k = 0, A = v[0]; A < v[1] + p / 2; k++, A += p){
                            var L = E(A);
                            f.density[k] = {
                                v: L,
                                t: A
                            }, l = Math.max(l, L);
                        }
                    }
                    u = Math.max(u, h.length), o = Math.min(o, v[0]), s = Math.max(s, v[1]);
                }
                var _ = DH.findExtremes(a, [
                    o,
                    s
                ], {
                    padded: !0
                });
                if (r._extremes[a._id] = _, r.width) n[0].t.maxKDE = l;
                else {
                    var C = i._violinScaleGroupStats, M = r.scalegroup, g = C[M];
                    g ? (g.maxKDE = Math.max(g.maxKDE, l), g.maxCount = Math.max(g.maxCount, u)) : C[M] = {
                        maxKDE: l,
                        maxCount: u
                    };
                }
                return n[0].t.labels.kde = RH._(t, "kde:"), n;
            };
            function Bbt(e, t, r) {
                var n = Math.min(t, r / 1.349);
                return 1.059 * n * Math.pow(e, -0.2);
            }
            function Nbt(e, t, r) {
                var n = t.max - t.min;
                if (!n) return e.bandwidth ? e.bandwidth : 0;
                if (e.bandwidth) return Math.max(e.bandwidth, n / 1e4);
                var i = r.length, a = RH.stdev(r, i - 1, t.mean);
                return Math.max(Bbt(i, a, t.q3 - t.q1), n / 100);
            }
            function Ubt(e, t, r, n) {
                var i = e.spanmode, a = e.span || [], o = [
                    t.min,
                    t.max
                ], s = [
                    t.min - 2 * n,
                    t.max + 2 * n
                ], l;
                function u(f) {
                    var h = a[f], d = r.type === "multicategory" ? r.r2c(h) : r.d2c(h, 0, e[t.valLetter + "calendar"]);
                    return d === Obt ? s[f] : d;
                }
                i === "soft" ? l = s : i === "hard" ? l = o : l = [
                    u(0),
                    u(1)
                ];
                var c = {
                    type: "linear",
                    range: l
                };
                return DH.setConvert(c), c.cleanRange(), l;
            }
        });
        var q2e = ye((Llr, F2e)=>{
            "use strict";
            var Vbt = GI().setPositionOffset, z2e = [
                "v",
                "h"
            ];
            F2e.exports = function(t, r) {
                for(var n = t.calcdata, i = r.xaxis, a = r.yaxis, o = 0; o < z2e.length; o++){
                    for(var s = z2e[o], l = s === "h" ? a : i, u = [], c = 0; c < n.length; c++){
                        var f = n[c], h = f[0].t, d = f[0].trace;
                        d.visible === !0 && d.type === "violin" && !h.empty && d.orientation === s && d.xaxis === i._id && d.yaxis === a._id && u.push(c);
                    }
                    Vbt("violin", t, u, l);
                }
            };
        });
        var B2e = ye((Plr, O2e)=>{
            "use strict";
            var zH = xa(), FH = Mr(), Hbt = ao(), qH = jI(), Gbt = fU(), jbt = P8();
            O2e.exports = function(t, r, n, i) {
                var a = t._context.staticPlot, o = t._fullLayout, s = r.xaxis, l = r.yaxis;
                function u(c, f) {
                    var h = Gbt(c, {
                        xaxis: s,
                        yaxis: l,
                        trace: f,
                        connectGaps: !0,
                        baseTolerance: .75,
                        shape: "spline",
                        simplify: !0,
                        linearized: !0
                    });
                    return Hbt.smoothopen(h[0], 1);
                }
                FH.makeTraceGroups(i, n, "trace violins").each(function(c) {
                    var f = zH.select(this), h = c[0], d = h.t, v = h.trace;
                    if (v.visible !== !0 || d.empty) {
                        f.remove();
                        return;
                    }
                    var x = d.bPos, b = d.bdPos, p = r[d.valLetter + "axis"], E = r[d.posLetter + "axis"], k = v.side === "both", A = k || v.side === "positive", L = k || v.side === "negative", _ = f.selectAll("path.violin").data(FH.identity);
                    _.enter().append("path").style("vector-effect", a ? "none" : "non-scaling-stroke").attr("class", "violin"), _.exit().remove(), _.each(function(V) {
                        var H = zH.select(this), X = V.density, G = X.length, N = E.c2l(V.pos + x, !0), W = E.l2p(N), re;
                        if (v.width) re = d.maxKDE / b;
                        else {
                            var ae = o._violinScaleGroupStats[v.scalegroup];
                            re = v.scalemode === "count" ? ae.maxKDE / b * (ae.maxCount / V.pts.length) : ae.maxKDE / b;
                        }
                        var _e, Me, ke, ge, ie, Te, Ee;
                        if (A) {
                            for(Te = new Array(G), ge = 0; ge < G; ge++)Ee = Te[ge] = {}, Ee[d.posLetter] = N + X[ge].v / re, Ee[d.valLetter] = p.c2l(X[ge].t, !0);
                            _e = u(Te, v);
                        }
                        if (L) {
                            for(Te = new Array(G), ie = 0, ge = G - 1; ie < G; ie++, ge--)Ee = Te[ie] = {}, Ee[d.posLetter] = N - X[ge].v / re, Ee[d.valLetter] = p.c2l(X[ge].t, !0);
                            Me = u(Te, v);
                        }
                        if (k) ke = _e + "L" + Me.substr(1) + "Z";
                        else {
                            var Ae = [
                                W,
                                p.c2p(X[0].t)
                            ], ze = [
                                W,
                                p.c2p(X[G - 1].t)
                            ];
                            v.orientation === "h" && (Ae.reverse(), ze.reverse()), A ? ke = "M" + Ae + "L" + _e.substr(1) + "L" + ze : ke = "M" + ze + "L" + Me.substr(1) + "L" + Ae;
                        }
                        H.attr("d", ke), V.posCenterPx = W, V.posDensityScale = re * b, V.path = H.node(), V.pathLength = V.path.getTotalLength() / (k ? 2 : 1);
                    });
                    var C = v.box, M = C.width, g = (C.line || {}).width, P, T;
                    k ? (P = b * M, T = 0) : A ? (P = [
                        0,
                        b * M / 2
                    ], T = g * ({
                        x: 1,
                        y: -1
                    })[d.posLetter]) : (P = [
                        b * M / 2,
                        0
                    ], T = g * ({
                        x: -1,
                        y: 1
                    })[d.posLetter]), qH.plotBoxAndWhiskers(f, {
                        pos: E,
                        val: p
                    }, v, {
                        bPos: x,
                        bdPos: P,
                        bPosPxOffset: T
                    }), qH.plotBoxMean(f, {
                        pos: E,
                        val: p
                    }, v, {
                        bPos: x,
                        bdPos: P,
                        bPosPxOffset: T
                    });
                    var F;
                    !v.box.visible && v.meanline.visible && (F = FH.identity);
                    var q = f.selectAll("path.meanline").data(F || []);
                    q.enter().append("path").attr("class", "meanline").style("fill", "none").style("vector-effect", a ? "none" : "non-scaling-stroke"), q.exit().remove(), q.each(function(V) {
                        var H = p.c2p(V.mean, !0), X = jbt.getPositionOnKdePath(V, v, H);
                        zH.select(this).attr("d", v.orientation === "h" ? "M" + H + "," + X[0] + "V" + X[1] : "M" + X[0] + "," + H + "H" + X[1]);
                    }), qH.plotPoints(f, {
                        x: s,
                        y: l
                    }, v, d);
                });
            };
        });
        var V2e = ye((Ilr, U2e)=>{
            "use strict";
            var N2e = xa(), NT = va(), Wbt = op().stylePoints;
            U2e.exports = function(t) {
                var r = N2e.select(t).selectAll("g.trace.violins");
                r.style("opacity", function(n) {
                    return n[0].trace.opacity;
                }), r.each(function(n) {
                    var i = n[0].trace, a = N2e.select(this), o = i.box || {}, s = o.line || {}, l = i.meanline || {}, u = l.width;
                    a.selectAll("path.violin").style("stroke-width", i.line.width + "px").call(NT.stroke, i.line.color).call(NT.fill, i.fillcolor), a.selectAll("path.box").style("stroke-width", s.width + "px").call(NT.stroke, s.color).call(NT.fill, o.fillcolor);
                    var c = {
                        "stroke-width": u + "px",
                        "stroke-dasharray": 2 * u + "px," + u + "px"
                    };
                    a.selectAll("path.mean").style(c).call(NT.stroke, l.color), a.selectAll("path.meanline").style(c).call(NT.stroke, l.color), Wbt(a, i, t);
                });
            };
        });
        var W2e = ye((Rlr, j2e)=>{
            "use strict";
            var Zbt = va(), OH = Mr(), Xbt = Qa(), H2e = PV(), G2e = P8();
            j2e.exports = function(t, r, n, i, a) {
                a || (a = {});
                var o = a.hoverLayer, s = t.cd, l = s[0].trace, u = l.hoveron, c = u.indexOf("violins") !== -1, f = u.indexOf("kde") !== -1, h = [], d, v;
                if (c || f) {
                    var x = H2e.hoverOnBoxes(t, r, n, i);
                    if (f && x.length > 0) {
                        var b = t.xa, p = t.ya, E, k, A, L, _;
                        l.orientation === "h" ? (_ = r, E = "y", A = p, k = "x", L = b) : (_ = n, E = "x", A = b, k = "y", L = p);
                        var C = s[t.index];
                        if (_ >= C.span[0] && _ <= C.span[1]) {
                            var M = OH.extendFlat({}, t), g = L.c2p(_, !0), P = G2e.getKdeValue(C, l, _), T = G2e.getPositionOnKdePath(C, l, g), F = A._offset, q = A._length;
                            M[E + "0"] = T[0], M[E + "1"] = T[1], M[k + "0"] = M[k + "1"] = g, M[k + "Label"] = k + ": " + Xbt.hoverLabelText(L, _, l[k + "hoverformat"]) + ", " + s[0].t.labels.kde + " " + P.toFixed(3);
                            for(var V = 0, H = 0; H < x.length; H++)if (x[H].attr === "med") {
                                V = H;
                                break;
                            }
                            M.spikeDistance = x[V].spikeDistance;
                            var X = E + "Spike";
                            M[X] = x[V][X], x[V].spikeDistance = void 0, x[V][X] = void 0, M.hovertemplate = !1, h.push(M), v = {}, v[E + "1"] = OH.constrain(F + T[0], F, F + q), v[E + "2"] = OH.constrain(F + T[1], F, F + q), v[k + "1"] = v[k + "2"] = L._offset + g;
                        }
                    }
                    c && (h = h.concat(x));
                }
                u.indexOf("points") !== -1 && (d = H2e.hoverOnPoints(t, r, n));
                var G = o.selectAll(".violinline-" + l.uid).data(v ? [
                    0
                ] : []);
                return G.enter().append("line").classed("violinline-" + l.uid, !0).attr("stroke-width", 1.5), G.exit().remove(), G.attr(v).call(Zbt.stroke, t.color), i === "closest" ? d ? [
                    d
                ] : h : (d && h.push(d), h);
            };
        });
        var X2e = ye((Dlr, Z2e)=>{
            "use strict";
            Z2e.exports = {
                attributes: CH(),
                layoutAttributes: IH(),
                supplyDefaults: C2e(),
                crossTraceDefaults: m4().crossTraceDefaults,
                supplyLayoutDefaults: P2e(),
                calc: D2e(),
                crossTraceCalc: q2e(),
                plot: B2e(),
                style: V2e(),
                styleOnSelect: op().styleOnSelect,
                hoverPoints: W2e(),
                selectPoints: IV(),
                moduleType: "trace",
                name: "violin",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "symbols",
                    "oriented",
                    "box-violin",
                    "showLegend",
                    "violinLayout",
                    "zoomScale"
                ],
                meta: {}
            };
        });
        var K2e = ye((zlr, Y2e)=>{
            "use strict";
            Y2e.exports = X2e();
        });
        var $2e = ye((Flr, J2e)=>{
            "use strict";
            J2e.exports = {
                eventDataKeys: [
                    "percentInitial",
                    "percentPrevious",
                    "percentTotal"
                ]
            };
        });
        var NH = ye((qlr, twe)=>{
            "use strict";
            var lc = Lm(), BH = Uc().line, Ybt = vl(), Q2e = Oc().axisHoverFormat, Kbt = Wo().hovertemplateAttrs, Jbt = Wo().texttemplateAttrs, ewe = $2e(), Ny = no().extendFlat, $bt = va();
            twe.exports = {
                x: lc.x,
                x0: lc.x0,
                dx: lc.dx,
                y: lc.y,
                y0: lc.y0,
                dy: lc.dy,
                xperiod: lc.xperiod,
                yperiod: lc.yperiod,
                xperiod0: lc.xperiod0,
                yperiod0: lc.yperiod0,
                xperiodalignment: lc.xperiodalignment,
                yperiodalignment: lc.yperiodalignment,
                xhoverformat: Q2e("x"),
                yhoverformat: Q2e("y"),
                hovertext: lc.hovertext,
                hovertemplate: Kbt({}, {
                    keys: ewe.eventDataKeys
                }),
                hoverinfo: Ny({}, Ybt.hoverinfo, {
                    flags: [
                        "name",
                        "x",
                        "y",
                        "text",
                        "percent initial",
                        "percent previous",
                        "percent total"
                    ]
                }),
                textinfo: {
                    valType: "flaglist",
                    flags: [
                        "label",
                        "text",
                        "percent initial",
                        "percent previous",
                        "percent total",
                        "value"
                    ],
                    extras: [
                        "none"
                    ],
                    editType: "plot",
                    arrayOk: !1
                },
                texttemplate: Jbt({
                    editType: "plot"
                }, {
                    keys: ewe.eventDataKeys.concat([
                        "label",
                        "value"
                    ])
                }),
                text: lc.text,
                textposition: lc.textposition,
                insidetextanchor: Ny({}, lc.insidetextanchor, {
                    dflt: "middle"
                }),
                textangle: Ny({}, lc.textangle, {
                    dflt: 0
                }),
                textfont: lc.textfont,
                insidetextfont: lc.insidetextfont,
                outsidetextfont: lc.outsidetextfont,
                constraintext: lc.constraintext,
                cliponaxis: lc.cliponaxis,
                orientation: Ny({}, lc.orientation, {}),
                offset: Ny({}, lc.offset, {
                    arrayOk: !1
                }),
                width: Ny({}, lc.width, {
                    arrayOk: !1
                }),
                marker: Qbt(),
                connector: {
                    fillcolor: {
                        valType: "color",
                        editType: "style"
                    },
                    line: {
                        color: Ny({}, BH.color, {
                            dflt: $bt.defaultLine
                        }),
                        width: Ny({}, BH.width, {
                            dflt: 0,
                            editType: "plot"
                        }),
                        dash: BH.dash,
                        editType: "style"
                    },
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    editType: "plot"
                },
                offsetgroup: lc.offsetgroup,
                alignmentgroup: lc.alignmentgroup,
                zorder: lc.zorder
            };
            function Qbt() {
                var e = Ny({}, lc.marker);
                return delete e.pattern, delete e.cornerradius, e;
            }
        });
        var UH = ye((Olr, rwe)=>{
            "use strict";
            rwe.exports = {
                funnelmode: {
                    valType: "enumerated",
                    values: [
                        "stack",
                        "group",
                        "overlay"
                    ],
                    dflt: "stack",
                    editType: "calc"
                },
                funnelgap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: "calc"
                },
                funnelgroupgap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 0,
                    editType: "calc"
                }
            };
        });
        var HH = ye((Blr, nwe)=>{
            "use strict";
            var I8 = Mr(), e2t = Hb(), t2t = r0().handleText, r2t = K3(), i2t = Pg(), iwe = NH(), VH = va();
            function n2t(e, t, r, n) {
                function i(f, h) {
                    return I8.coerce(e, t, iwe, f, h);
                }
                var a = r2t(e, t, n, i);
                if (!a) {
                    t.visible = !1;
                    return;
                }
                i2t(e, t, n, i), i("xhoverformat"), i("yhoverformat"), i("orientation", t.y && !t.x ? "v" : "h"), i("offset"), i("width");
                var o = i("text");
                i("hovertext"), i("hovertemplate");
                var s = i("textposition");
                t2t(e, t, n, i, s, {
                    moduleHasSelected: !1,
                    moduleHasUnselected: !1,
                    moduleHasConstrain: !0,
                    moduleHasCliponaxis: !0,
                    moduleHasTextangle: !0,
                    moduleHasInsideanchor: !0
                }), t.textposition !== "none" && !t.texttemplate && i("textinfo", I8.isArrayOrTypedArray(o) ? "text+value" : "value");
                var l = i("marker.color", r);
                i("marker.line.color", VH.defaultLine), i("marker.line.width");
                var u = i("connector.visible");
                if (u) {
                    i("connector.fillcolor", a2t(l));
                    var c = i("connector.line.width");
                    c && (i("connector.line.color"), i("connector.line.dash"));
                }
                i("zorder");
            }
            function a2t(e) {
                var t = I8.isArrayOrTypedArray(e) ? "#000" : e;
                return VH.addOpacity(t, .5 * VH.opacity(t));
            }
            function o2t(e, t) {
                var r, n;
                function i(o) {
                    return I8.coerce(n._input, n, iwe, o);
                }
                for(var a = 0; a < e.length; a++)n = e[a], n.type === "funnel" && (r = n._input, e2t(r, n, t, i, t.funnelmode));
            }
            nwe.exports = {
                supplyDefaults: n2t,
                crossTraceDefaults: o2t
            };
        });
        var owe = ye((Nlr, awe)=>{
            "use strict";
            var s2t = Mr(), l2t = UH();
            awe.exports = function(e, t, r) {
                var n = !1;
                function i(s, l) {
                    return s2t.coerce(e, t, l2t, s, l);
                }
                for(var a = 0; a < r.length; a++){
                    var o = r[a];
                    if (o.visible && o.type === "funnel") {
                        n = !0;
                        break;
                    }
                }
                n && (i("funnelmode"), i("funnelgap", .2), i("funnelgroupgap"));
            };
        });
        var lwe = ye((Ulr, swe)=>{
            "use strict";
            var UT = Mr();
            swe.exports = function(t, r) {
                for(var n = 0; n < t.length; n++)t[n].i = n;
                UT.mergeArray(r.text, t, "tx"), UT.mergeArray(r.hovertext, t, "htx");
                var i = r.marker;
                if (i) {
                    UT.mergeArray(i.opacity, t, "mo"), UT.mergeArray(i.color, t, "mc");
                    var a = i.line;
                    a && (UT.mergeArray(a.color, t, "mlc"), UT.mergeArrayCastPositive(a.width, t, "mlw"));
                }
            };
        });
        var hwe = ye((Vlr, fwe)=>{
            "use strict";
            var uwe = Qa(), cwe = Rg(), u2t = lwe(), c2t = F0(), P4 = es().BADNUM;
            fwe.exports = function(t, r) {
                var n = uwe.getFromId(t, r.xaxis || "x"), i = uwe.getFromId(t, r.yaxis || "y"), a, o, s, l, u, c, f, h;
                r.orientation === "h" ? (a = n.makeCalcdata(r, "x"), s = i.makeCalcdata(r, "y"), l = cwe(r, i, "y", s), u = !!r.yperiodalignment, c = "y") : (a = i.makeCalcdata(r, "y"), s = n.makeCalcdata(r, "x"), l = cwe(r, n, "x", s), u = !!r.xperiodalignment, c = "x"), o = l.vals;
                var d = Math.min(o.length, a.length), v = new Array(d);
                for(r._base = [], f = 0; f < d; f++){
                    a[f] < 0 && (a[f] = P4);
                    var x = !1;
                    a[f] !== P4 && f + 1 < d && a[f + 1] !== P4 && (x = !0), h = v[f] = {
                        p: o[f],
                        s: a[f],
                        cNext: x
                    }, r._base[f] = -0.5 * h.s, u && (v[f].orig_p = s[f], v[f][c + "End"] = l.ends[f], v[f][c + "Start"] = l.starts[f]), r.ids && (h.id = String(r.ids[f])), f === 0 && (v[0].vTotal = 0), v[0].vTotal += GH(h.s), h.begR = GH(h.s) / GH(v[0].s);
                }
                var b;
                for(f = 0; f < d; f++)h = v[f], h.s !== P4 && (h.sumR = h.s / v[0].vTotal, h.difR = b !== void 0 ? h.s / b : 1, b = h.s);
                return u2t(v, r), c2t(v, r), v;
            };
            function GH(e) {
                return e === P4 ? 0 : e;
            }
        });
        var pwe = ye((Hlr, vwe)=>{
            "use strict";
            var dwe = Gb().setGroupPositions;
            vwe.exports = function(t, r) {
                var n = t._fullLayout, i = t._fullData, a = t.calcdata, o = r.xaxis, s = r.yaxis, l = [], u = [], c = [], f, h;
                for(h = 0; h < i.length; h++){
                    var d = i[h], v = d.orientation === "h";
                    d.visible === !0 && d.xaxis === o._id && d.yaxis === s._id && d.type === "funnel" && (f = a[h], v ? c.push(f) : u.push(f), l.push(f));
                }
                var x = {
                    mode: n.funnelmode,
                    norm: n.funnelnorm,
                    gap: n.funnelgap,
                    groupgap: n.funnelgroupgap
                };
                for(dwe(t, o, s, u, x), dwe(t, s, o, c, x), h = 0; h < l.length; h++){
                    f = l[h];
                    for(var b = 0; b < f.length; b++)b + 1 < f.length && (f[b].nextP0 = f[b + 1].p0, f[b].nextS0 = f[b + 1].s0, f[b].nextP1 = f[b + 1].p1, f[b].nextS1 = f[b + 1].s1);
                }
            };
        });
        var _we = ye((Glr, ywe)=>{
            "use strict";
            var R8 = xa(), P_ = Mr(), gwe = ao(), L_ = es().BADNUM, f2t = i2(), h2t = _v().clearMinTextSize;
            ywe.exports = function(t, r, n, i) {
                var a = t._fullLayout;
                h2t("funnel", a), d2t(t, r, n, i), v2t(t, r, n, i), f2t.plot(t, r, n, i, {
                    mode: a.funnelmode,
                    norm: a.funnelmode,
                    gap: a.funnelgap,
                    groupgap: a.funnelgroupgap
                });
            };
            function d2t(e, t, r, n) {
                var i = t.xaxis, a = t.yaxis;
                P_.makeTraceGroups(n, r, "trace bars").each(function(o) {
                    var s = R8.select(this), l = o[0].trace, u = P_.ensureSingle(s, "g", "regions");
                    if (!l.connector || !l.connector.visible) {
                        u.remove();
                        return;
                    }
                    var c = l.orientation === "h", f = u.selectAll("g.region").data(P_.identity);
                    f.enter().append("g").classed("region", !0), f.exit().remove();
                    var h = f.size();
                    f.each(function(d, v) {
                        if (!(v !== h - 1 && !d.cNext)) {
                            var x = mwe(d, i, a, c), b = x[0], p = x[1], E = "";
                            b[0] !== L_ && p[0] !== L_ && b[1] !== L_ && p[1] !== L_ && b[2] !== L_ && p[2] !== L_ && b[3] !== L_ && p[3] !== L_ && (c ? E += "M" + b[0] + "," + p[1] + "L" + b[2] + "," + p[2] + "H" + b[3] + "L" + b[1] + "," + p[1] + "Z" : E += "M" + b[1] + "," + p[1] + "L" + b[2] + "," + p[3] + "V" + p[2] + "L" + b[1] + "," + p[0] + "Z"), E === "" && (E = "M0,0Z"), P_.ensureSingle(R8.select(this), "path").attr("d", E).call(gwe.setClipUrl, t.layerClipId, e);
                        }
                    });
                });
            }
            function v2t(e, t, r, n) {
                var i = t.xaxis, a = t.yaxis;
                P_.makeTraceGroups(n, r, "trace bars").each(function(o) {
                    var s = R8.select(this), l = o[0].trace, u = P_.ensureSingle(s, "g", "lines");
                    if (!l.connector || !l.connector.visible || !l.connector.line.width) {
                        u.remove();
                        return;
                    }
                    var c = l.orientation === "h", f = u.selectAll("g.line").data(P_.identity);
                    f.enter().append("g").classed("line", !0), f.exit().remove();
                    var h = f.size();
                    f.each(function(d, v) {
                        if (!(v !== h - 1 && !d.cNext)) {
                            var x = mwe(d, i, a, c), b = x[0], p = x[1], E = "";
                            b[3] !== void 0 && p[3] !== void 0 && (c ? (E += "M" + b[0] + "," + p[1] + "L" + b[2] + "," + p[2], E += "M" + b[1] + "," + p[1] + "L" + b[3] + "," + p[2]) : (E += "M" + b[1] + "," + p[1] + "L" + b[2] + "," + p[3], E += "M" + b[1] + "," + p[0] + "L" + b[2] + "," + p[2])), E === "" && (E = "M0,0Z"), P_.ensureSingle(R8.select(this), "path").attr("d", E).call(gwe.setClipUrl, t.layerClipId, e);
                        }
                    });
                });
            }
            function mwe(e, t, r, n) {
                var i = [], a = [], o = n ? t : r, s = n ? r : t;
                return i[0] = o.c2p(e.s0, !0), a[0] = s.c2p(e.p0, !0), i[1] = o.c2p(e.s1, !0), a[1] = s.c2p(e.p1, !0), i[2] = o.c2p(e.nextS0, !0), a[2] = s.c2p(e.nextP0, !0), i[3] = o.c2p(e.nextS1, !0), a[3] = s.c2p(e.nextP1, !0), n ? [
                    i,
                    a
                ] : [
                    a,
                    i
                ];
            }
        });
        var wwe = ye((jlr, bwe)=>{
            "use strict";
            var I4 = xa(), xwe = ao(), jH = va(), p2t = U1().DESELECTDIM, g2t = N0(), m2t = _v().resizeText, y2t = g2t.styleTextPoints;
            function _2t(e, t, r) {
                var n = r || I4.select(e).selectAll('g[class^="funnellayer"]').selectAll("g.trace");
                m2t(e, n, "funnel"), n.style("opacity", function(i) {
                    return i[0].trace.opacity;
                }), n.each(function(i) {
                    var a = I4.select(this), o = i[0].trace;
                    a.selectAll(".point > path").each(function(s) {
                        if (!s.isBlank) {
                            var l = o.marker;
                            I4.select(this).call(jH.fill, s.mc || l.color).call(jH.stroke, s.mlc || l.line.color).call(xwe.dashLine, l.line.dash, s.mlw || l.line.width).style("opacity", o.selectedpoints && !s.selected ? p2t : 1);
                        }
                    }), y2t(a, o, e), a.selectAll(".regions").each(function() {
                        I4.select(this).selectAll("path").style("stroke-width", 0).call(jH.fill, o.connector.fillcolor);
                    }), a.selectAll(".lines").each(function() {
                        var s = o.connector.line;
                        xwe.lineGroupStyle(I4.select(this).selectAll("path"), s.width, s.color, s.dash);
                    });
                });
            }
            bwe.exports = {
                style: _2t
            };
        });
        var Swe = ye((Wlr, Awe)=>{
            "use strict";
            var Twe = va().opacity, x2t = TT().hoverOnBars, WH = Mr().formatPercent;
            Awe.exports = function(t, r, n, i, a) {
                var o = x2t(t, r, n, i, a);
                if (o) {
                    var s = o.cd, l = s[0].trace, u = l.orientation === "h", c = o.index, f = s[c], h = u ? "x" : "y";
                    o[h + "LabelVal"] = f.s, o.percentInitial = f.begR, o.percentInitialLabel = WH(f.begR, 1), o.percentPrevious = f.difR, o.percentPreviousLabel = WH(f.difR, 1), o.percentTotal = f.sumR, o.percentTotalLabel = WH(f.sumR, 1);
                    var d = f.hi || l.hoverinfo, v = [];
                    if (d && d !== "none" && d !== "skip") {
                        var x = d === "all", b = d.split("+"), p = function(E) {
                            return x || b.indexOf(E) !== -1;
                        };
                        p("percent initial") && v.push(o.percentInitialLabel + " of initial"), p("percent previous") && v.push(o.percentPreviousLabel + " of previous"), p("percent total") && v.push(o.percentTotalLabel + " of total");
                    }
                    return o.extraText = v.join("<br>"), o.color = b2t(l, f), [
                        o
                    ];
                }
            };
            function b2t(e, t) {
                var r = e.marker, n = t.mc || r.color, i = t.mlc || r.line.color, a = t.mlw || r.line.width;
                if (Twe(n)) return n;
                if (Twe(i) && a) return i;
            }
        });
        var Ewe = ye((Zlr, Mwe)=>{
            "use strict";
            Mwe.exports = function(t, r) {
                return t.x = "xVal" in r ? r.xVal : r.x, t.y = "yVal" in r ? r.yVal : r.y, "percentInitial" in r && (t.percentInitial = r.percentInitial), "percentPrevious" in r && (t.percentPrevious = r.percentPrevious), "percentTotal" in r && (t.percentTotal = r.percentTotal), r.xa && (t.xaxis = r.xa), r.ya && (t.yaxis = r.ya), t;
            };
        });
        var Cwe = ye((Xlr, kwe)=>{
            "use strict";
            kwe.exports = {
                attributes: NH(),
                layoutAttributes: UH(),
                supplyDefaults: HH().supplyDefaults,
                crossTraceDefaults: HH().crossTraceDefaults,
                supplyLayoutDefaults: owe(),
                calc: hwe(),
                crossTraceCalc: pwe(),
                plot: _we(),
                style: wwe().style,
                hoverPoints: Swe(),
                eventData: Ewe(),
                selectPoints: AT(),
                moduleType: "trace",
                name: "funnel",
                basePlotModule: Jf(),
                categories: [
                    "bar-like",
                    "cartesian",
                    "svg",
                    "oriented",
                    "showLegend",
                    "zoomScale"
                ],
                meta: {}
            };
        });
        var Pwe = ye((Ylr, Lwe)=>{
            "use strict";
            Lwe.exports = Cwe();
        });
        var Rwe = ye((Klr, Iwe)=>{
            "use strict";
            Iwe.exports = {
                eventDataKeys: [
                    "initial",
                    "delta",
                    "final"
                ]
            };
        });
        var YH = ye((Jlr, Fwe)=>{
            "use strict";
            var Uu = Lm(), ZH = Uc().line, w2t = vl(), Dwe = Oc().axisHoverFormat, T2t = Wo().hovertemplateAttrs, A2t = Wo().texttemplateAttrs, zwe = Rwe(), VT = no().extendFlat, S2t = va();
            function XH(e) {
                return {
                    marker: {
                        color: VT({}, Uu.marker.color, {
                            arrayOk: !1,
                            editType: "style"
                        }),
                        line: {
                            color: VT({}, Uu.marker.line.color, {
                                arrayOk: !1,
                                editType: "style"
                            }),
                            width: VT({}, Uu.marker.line.width, {
                                arrayOk: !1,
                                editType: "style"
                            }),
                            editType: "style"
                        },
                        editType: "style"
                    },
                    editType: "style"
                };
            }
            Fwe.exports = {
                measure: {
                    valType: "data_array",
                    dflt: [],
                    editType: "calc"
                },
                base: {
                    valType: "number",
                    dflt: null,
                    arrayOk: !1,
                    editType: "calc"
                },
                x: Uu.x,
                x0: Uu.x0,
                dx: Uu.dx,
                y: Uu.y,
                y0: Uu.y0,
                dy: Uu.dy,
                xperiod: Uu.xperiod,
                yperiod: Uu.yperiod,
                xperiod0: Uu.xperiod0,
                yperiod0: Uu.yperiod0,
                xperiodalignment: Uu.xperiodalignment,
                yperiodalignment: Uu.yperiodalignment,
                xhoverformat: Dwe("x"),
                yhoverformat: Dwe("y"),
                hovertext: Uu.hovertext,
                hovertemplate: T2t({}, {
                    keys: zwe.eventDataKeys
                }),
                hoverinfo: VT({}, w2t.hoverinfo, {
                    flags: [
                        "name",
                        "x",
                        "y",
                        "text",
                        "initial",
                        "delta",
                        "final"
                    ]
                }),
                textinfo: {
                    valType: "flaglist",
                    flags: [
                        "label",
                        "text",
                        "initial",
                        "delta",
                        "final"
                    ],
                    extras: [
                        "none"
                    ],
                    editType: "plot",
                    arrayOk: !1
                },
                texttemplate: A2t({
                    editType: "plot"
                }, {
                    keys: zwe.eventDataKeys.concat([
                        "label"
                    ])
                }),
                text: Uu.text,
                textposition: Uu.textposition,
                insidetextanchor: Uu.insidetextanchor,
                textangle: Uu.textangle,
                textfont: Uu.textfont,
                insidetextfont: Uu.insidetextfont,
                outsidetextfont: Uu.outsidetextfont,
                constraintext: Uu.constraintext,
                cliponaxis: Uu.cliponaxis,
                orientation: Uu.orientation,
                offset: Uu.offset,
                width: Uu.width,
                increasing: XH("increasing"),
                decreasing: XH("decreasing"),
                totals: XH("intermediate sums and total"),
                connector: {
                    line: {
                        color: VT({}, ZH.color, {
                            dflt: S2t.defaultLine
                        }),
                        width: VT({}, ZH.width, {
                            editType: "plot"
                        }),
                        dash: ZH.dash,
                        editType: "plot"
                    },
                    mode: {
                        valType: "enumerated",
                        values: [
                            "spanning",
                            "between"
                        ],
                        dflt: "between",
                        editType: "plot"
                    },
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    editType: "plot"
                },
                offsetgroup: Uu.offsetgroup,
                alignmentgroup: Uu.alignmentgroup,
                zorder: Uu.zorder
            };
        });
        var KH = ye(($lr, qwe)=>{
            "use strict";
            qwe.exports = {
                waterfallmode: {
                    valType: "enumerated",
                    values: [
                        "group",
                        "overlay"
                    ],
                    dflt: "group",
                    editType: "calc"
                },
                waterfallgap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    editType: "calc"
                },
                waterfallgroupgap: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 0,
                    editType: "calc"
                }
            };
        });
        var HT = ye((Qlr, Owe)=>{
            "use strict";
            Owe.exports = {
                INCREASING: {
                    COLOR: "#3D9970",
                    SYMBOL: "\u25B2"
                },
                DECREASING: {
                    COLOR: "#FF4136",
                    SYMBOL: "\u25BC"
                }
            };
        });
        var $H = ye((eur, Vwe)=>{
            "use strict";
            var Bwe = Mr(), M2t = Hb(), E2t = r0().handleText, k2t = K3(), C2t = Pg(), Nwe = YH(), L2t = va(), Uwe = HT(), P2t = Uwe.INCREASING.COLOR, I2t = Uwe.DECREASING.COLOR, R2t = "#4499FF";
            function JH(e, t, r) {
                e(t + ".marker.color", r), e(t + ".marker.line.color", L2t.defaultLine), e(t + ".marker.line.width");
            }
            function D2t(e, t, r, n) {
                function i(u, c) {
                    return Bwe.coerce(e, t, Nwe, u, c);
                }
                var a = k2t(e, t, n, i);
                if (!a) {
                    t.visible = !1;
                    return;
                }
                C2t(e, t, n, i), i("xhoverformat"), i("yhoverformat"), i("measure"), i("orientation", t.x && !t.y ? "h" : "v"), i("base"), i("offset"), i("width"), i("text"), i("hovertext"), i("hovertemplate");
                var o = i("textposition");
                E2t(e, t, n, i, o, {
                    moduleHasSelected: !1,
                    moduleHasUnselected: !1,
                    moduleHasConstrain: !0,
                    moduleHasCliponaxis: !0,
                    moduleHasTextangle: !0,
                    moduleHasInsideanchor: !0
                }), t.textposition !== "none" && (i("texttemplate"), t.texttemplate || i("textinfo")), JH(i, "increasing", P2t), JH(i, "decreasing", I2t), JH(i, "totals", R2t);
                var s = i("connector.visible");
                if (s) {
                    i("connector.mode");
                    var l = i("connector.line.width");
                    l && (i("connector.line.color"), i("connector.line.dash"));
                }
                i("zorder");
            }
            function z2t(e, t) {
                var r, n;
                function i(o) {
                    return Bwe.coerce(n._input, n, Nwe, o);
                }
                if (t.waterfallmode === "group") for(var a = 0; a < e.length; a++)n = e[a], r = n._input, M2t(r, n, t, i, t.waterfallmode);
            }
            Vwe.exports = {
                supplyDefaults: D2t,
                crossTraceDefaults: z2t
            };
        });
        var Gwe = ye((tur, Hwe)=>{
            "use strict";
            var F2t = Mr(), q2t = KH();
            Hwe.exports = function(e, t, r) {
                var n = !1;
                function i(s, l) {
                    return F2t.coerce(e, t, q2t, s, l);
                }
                for(var a = 0; a < r.length; a++){
                    var o = r[a];
                    if (o.visible && o.type === "waterfall") {
                        n = !0;
                        break;
                    }
                }
                n && (i("waterfallmode"), i("waterfallgap", .2), i("waterfallgroupgap"));
            };
        });
        var Kwe = ye((rur, Ywe)=>{
            "use strict";
            var jwe = Qa(), Wwe = Rg(), Zwe = Mr().mergeArray, O2t = F0(), Xwe = es().BADNUM;
            function QH(e) {
                return e === "a" || e === "absolute";
            }
            function eG(e) {
                return e === "t" || e === "total";
            }
            Ywe.exports = function(t, r) {
                var n = jwe.getFromId(t, r.xaxis || "x"), i = jwe.getFromId(t, r.yaxis || "y"), a, o, s, l, u, c;
                r.orientation === "h" ? (a = n.makeCalcdata(r, "x"), s = i.makeCalcdata(r, "y"), l = Wwe(r, i, "y", s), u = !!r.yperiodalignment, c = "y") : (a = i.makeCalcdata(r, "y"), s = n.makeCalcdata(r, "x"), l = Wwe(r, n, "x", s), u = !!r.xperiodalignment, c = "x"), o = l.vals;
                for(var f = Math.min(o.length, a.length), h = new Array(f), d = 0, v, x = !1, b = 0; b < f; b++){
                    var p = a[b] || 0, E = !1;
                    (a[b] !== Xwe || eG(r.measure[b]) || QH(r.measure[b])) && b + 1 < f && (a[b + 1] !== Xwe || eG(r.measure[b + 1]) || QH(r.measure[b + 1])) && (E = !0);
                    var k = h[b] = {
                        i: b,
                        p: o[b],
                        s: p,
                        rawS: p,
                        cNext: E
                    };
                    QH(r.measure[b]) ? (d = k.s, k.isSum = !0, k.dir = "totals", k.s = d) : eG(r.measure[b]) ? (k.isSum = !0, k.dir = "totals", k.s = d) : (k.isSum = !1, k.dir = k.rawS < 0 ? "decreasing" : "increasing", v = k.s, k.s = d + v, d += v), k.dir === "totals" && (x = !0), u && (h[b].orig_p = s[b], h[b][c + "End"] = l.ends[b], h[b][c + "Start"] = l.starts[b]), r.ids && (k.id = String(r.ids[b])), k.v = (r.base || 0) + d;
                }
                return h.length && (h[0].hasTotals = x), Zwe(r.text, h, "tx"), Zwe(r.hovertext, h, "htx"), O2t(h, r), h;
            };
        });
        var Qwe = ye((iur, $we)=>{
            "use strict";
            var Jwe = Gb().setGroupPositions;
            $we.exports = function(t, r) {
                var n = t._fullLayout, i = t._fullData, a = t.calcdata, o = r.xaxis, s = r.yaxis, l = [], u = [], c = [], f, h;
                for(h = 0; h < i.length; h++){
                    var d = i[h];
                    d.visible === !0 && d.xaxis === o._id && d.yaxis === s._id && d.type === "waterfall" && (f = a[h], d.orientation === "h" ? c.push(f) : u.push(f), l.push(f));
                }
                var v = {
                    mode: n.waterfallmode,
                    norm: n.waterfallnorm,
                    gap: n.waterfallgap,
                    groupgap: n.waterfallgroupgap
                };
                for(Jwe(t, o, s, u, v), Jwe(t, s, o, c, v), h = 0; h < l.length; h++){
                    f = l[h];
                    for(var x = 0; x < f.length; x++){
                        var b = f[x];
                        b.isSum === !1 && (b.s0 += x === 0 ? 0 : f[x - 1].s), x + 1 < f.length && (f[x].nextP0 = f[x + 1].p0, f[x].nextS0 = f[x + 1].s0);
                    }
                }
            };
        });
        var r3e = ye((nur, t3e)=>{
            "use strict";
            var e3e = xa(), D8 = Mr(), B2t = ao(), GT = es().BADNUM, N2t = i2(), U2t = _v().clearMinTextSize;
            t3e.exports = function(t, r, n, i) {
                var a = t._fullLayout;
                U2t("waterfall", a), N2t.plot(t, r, n, i, {
                    mode: a.waterfallmode,
                    norm: a.waterfallmode,
                    gap: a.waterfallgap,
                    groupgap: a.waterfallgroupgap
                }), V2t(t, r, n, i);
            };
            function V2t(e, t, r, n) {
                var i = t.xaxis, a = t.yaxis;
                D8.makeTraceGroups(n, r, "trace bars").each(function(o) {
                    var s = e3e.select(this), l = o[0].trace, u = D8.ensureSingle(s, "g", "lines");
                    if (!l.connector || !l.connector.visible) {
                        u.remove();
                        return;
                    }
                    var c = l.orientation === "h", f = l.connector.mode, h = u.selectAll("g.line").data(D8.identity);
                    h.enter().append("g").classed("line", !0), h.exit().remove();
                    var d = h.size();
                    h.each(function(v, x) {
                        if (!(x !== d - 1 && !v.cNext)) {
                            var b = H2t(v, i, a, c), p = b[0], E = b[1], k = "";
                            p[0] !== GT && E[0] !== GT && p[1] !== GT && E[1] !== GT && (f === "spanning" && !v.isSum && x > 0 && (c ? k += "M" + p[0] + "," + E[1] + "V" + E[0] : k += "M" + p[1] + "," + E[0] + "H" + p[0]), f !== "between" && (v.isSum || x < d - 1) && (c ? k += "M" + p[1] + "," + E[0] + "V" + E[1] : k += "M" + p[0] + "," + E[1] + "H" + p[1]), p[2] !== GT && E[2] !== GT && (c ? k += "M" + p[1] + "," + E[1] + "V" + E[2] : k += "M" + p[1] + "," + E[1] + "H" + p[2])), k === "" && (k = "M0,0Z"), D8.ensureSingle(e3e.select(this), "path").attr("d", k).call(B2t.setClipUrl, t.layerClipId, e);
                        }
                    });
                });
            }
            function H2t(e, t, r, n) {
                var i = [], a = [], o = n ? t : r, s = n ? r : t;
                return i[0] = o.c2p(e.s0, !0), a[0] = s.c2p(e.p0, !0), i[1] = o.c2p(e.s1, !0), a[1] = s.c2p(e.p1, !0), i[2] = o.c2p(e.nextS0, !0), a[2] = s.c2p(e.nextP0, !0), n ? [
                    i,
                    a
                ] : [
                    a,
                    i
                ];
            }
        });
        var o3e = ye((aur, a3e)=>{
            "use strict";
            var z8 = xa(), i3e = ao(), n3e = va(), G2t = U1().DESELECTDIM, j2t = N0(), W2t = _v().resizeText, Z2t = j2t.styleTextPoints;
            function X2t(e, t, r) {
                var n = r || z8.select(e).selectAll('g[class^="waterfalllayer"]').selectAll("g.trace");
                W2t(e, n, "waterfall"), n.style("opacity", function(i) {
                    return i[0].trace.opacity;
                }), n.each(function(i) {
                    var a = z8.select(this), o = i[0].trace;
                    a.selectAll(".point > path").each(function(s) {
                        if (!s.isBlank) {
                            var l = o[s.dir].marker;
                            z8.select(this).call(n3e.fill, l.color).call(n3e.stroke, l.line.color).call(i3e.dashLine, l.line.dash, l.line.width).style("opacity", o.selectedpoints && !s.selected ? G2t : 1);
                        }
                    }), Z2t(a, o, e), a.selectAll(".lines").each(function() {
                        var s = o.connector.line;
                        i3e.lineGroupStyle(z8.select(this).selectAll("path"), s.width, s.color, s.dash);
                    });
                });
            }
            a3e.exports = {
                style: X2t
            };
        });
        var f3e = ye((our, c3e)=>{
            "use strict";
            var Y2t = Qa().hoverLabelText, s3e = va().opacity, K2t = TT().hoverOnBars, l3e = HT(), u3e = {
                increasing: l3e.INCREASING.SYMBOL,
                decreasing: l3e.DECREASING.SYMBOL
            };
            c3e.exports = function(t, r, n, i, a) {
                var o = K2t(t, r, n, i, a);
                if (!o) return;
                var s = o.cd, l = s[0].trace, u = l.orientation === "h", c = u ? "x" : "y", f = u ? t.xa : t.ya;
                function h(_) {
                    return Y2t(f, _, l[c + "hoverformat"]);
                }
                var d = o.index, v = s[d], x = v.isSum ? v.b + v.s : v.rawS;
                o.initial = v.b + v.s - x, o.delta = x, o.final = o.initial + o.delta;
                var b = h(Math.abs(o.delta));
                o.deltaLabel = x < 0 ? "(" + b + ")" : b, o.finalLabel = h(o.final), o.initialLabel = h(o.initial);
                var p = v.hi || l.hoverinfo, E = [];
                if (p && p !== "none" && p !== "skip") {
                    var k = p === "all", A = p.split("+"), L = function(_) {
                        return k || A.indexOf(_) !== -1;
                    };
                    v.isSum || (L("final") && (u ? !L("x") : !L("y")) && E.push(o.finalLabel), L("delta") && (x < 0 ? E.push(o.deltaLabel + " " + u3e.decreasing) : E.push(o.deltaLabel + " " + u3e.increasing)), L("initial") && E.push("Initial: " + o.initialLabel));
                }
                return E.length && (o.extraText = E.join("<br>")), o.color = J2t(l, v), [
                    o
                ];
            };
            function J2t(e, t) {
                var r = e[t.dir].marker, n = r.color, i = r.line.color, a = r.line.width;
                if (s3e(n)) return n;
                if (s3e(i) && a) return i;
            }
        });
        var d3e = ye((sur, h3e)=>{
            "use strict";
            h3e.exports = function(t, r) {
                return t.x = "xVal" in r ? r.xVal : r.x, t.y = "yVal" in r ? r.yVal : r.y, "initial" in r && (t.initial = r.initial), "delta" in r && (t.delta = r.delta), "final" in r && (t.final = r.final), r.xa && (t.xaxis = r.xa), r.ya && (t.yaxis = r.ya), t;
            };
        });
        var p3e = ye((lur, v3e)=>{
            "use strict";
            v3e.exports = {
                attributes: YH(),
                layoutAttributes: KH(),
                supplyDefaults: $H().supplyDefaults,
                crossTraceDefaults: $H().crossTraceDefaults,
                supplyLayoutDefaults: Gwe(),
                calc: Kwe(),
                crossTraceCalc: Qwe(),
                plot: r3e(),
                style: o3e().style,
                hoverPoints: f3e(),
                eventData: d3e(),
                selectPoints: AT(),
                moduleType: "trace",
                name: "waterfall",
                basePlotModule: Jf(),
                categories: [
                    "bar-like",
                    "cartesian",
                    "svg",
                    "oriented",
                    "showLegend",
                    "zoomScale"
                ],
                meta: {}
            };
        });
        var m3e = ye((uur, g3e)=>{
            "use strict";
            g3e.exports = p3e();
        });
        var jT = ye((cur, y3e)=>{
            "use strict";
            y3e.exports = {
                colormodel: {
                    rgb: {
                        min: [
                            0,
                            0,
                            0
                        ],
                        max: [
                            255,
                            255,
                            255
                        ],
                        fmt: function(e) {
                            return e.slice(0, 3);
                        },
                        suffix: [
                            "",
                            "",
                            ""
                        ]
                    },
                    rgba: {
                        min: [
                            0,
                            0,
                            0,
                            0
                        ],
                        max: [
                            255,
                            255,
                            255,
                            1
                        ],
                        fmt: function(e) {
                            return e.slice(0, 4);
                        },
                        suffix: [
                            "",
                            "",
                            "",
                            ""
                        ]
                    },
                    rgba256: {
                        colormodel: "rgba",
                        zminDflt: [
                            0,
                            0,
                            0,
                            0
                        ],
                        zmaxDflt: [
                            255,
                            255,
                            255,
                            255
                        ],
                        min: [
                            0,
                            0,
                            0,
                            0
                        ],
                        max: [
                            255,
                            255,
                            255,
                            1
                        ],
                        fmt: function(e) {
                            return e.slice(0, 4);
                        },
                        suffix: [
                            "",
                            "",
                            "",
                            ""
                        ]
                    },
                    hsl: {
                        min: [
                            0,
                            0,
                            0
                        ],
                        max: [
                            360,
                            100,
                            100
                        ],
                        fmt: function(e) {
                            var t = e.slice(0, 3);
                            return t[1] = t[1] + "%", t[2] = t[2] + "%", t;
                        },
                        suffix: [
                            "\xB0",
                            "%",
                            "%"
                        ]
                    },
                    hsla: {
                        min: [
                            0,
                            0,
                            0,
                            0
                        ],
                        max: [
                            360,
                            100,
                            100,
                            1
                        ],
                        fmt: function(e) {
                            var t = e.slice(0, 4);
                            return t[1] = t[1] + "%", t[2] = t[2] + "%", t;
                        },
                        suffix: [
                            "\xB0",
                            "%",
                            "%",
                            ""
                        ]
                    }
                }
            };
        });
        var tG = ye((fur, x3e)=>{
            "use strict";
            var $2t = vl(), Q2t = Uc().zorder, ewt = Wo().hovertemplateAttrs, _3e = no().extendFlat, twt = jT().colormodel, D4 = [
                "rgb",
                "rgba",
                "rgba256",
                "hsl",
                "hsla"
            ], rwt = [], iwt = [];
            for(WT = 0; WT < D4.length; WT++)R4 = twt[D4[WT]], rwt.push("For the `" + D4[WT] + "` colormodel, it is [" + (R4.zminDflt || R4.min).join(", ") + "]."), iwt.push("For the `" + D4[WT] + "` colormodel, it is [" + (R4.zmaxDflt || R4.max).join(", ") + "].");
            var R4, WT;
            x3e.exports = _3e({
                source: {
                    valType: "string",
                    editType: "calc"
                },
                z: {
                    valType: "data_array",
                    editType: "calc"
                },
                colormodel: {
                    valType: "enumerated",
                    values: D4,
                    editType: "calc"
                },
                zsmooth: {
                    valType: "enumerated",
                    values: [
                        "fast",
                        !1
                    ],
                    dflt: !1,
                    editType: "plot"
                },
                zmin: {
                    valType: "info_array",
                    items: [
                        {
                            valType: "number",
                            editType: "calc"
                        },
                        {
                            valType: "number",
                            editType: "calc"
                        },
                        {
                            valType: "number",
                            editType: "calc"
                        },
                        {
                            valType: "number",
                            editType: "calc"
                        }
                    ],
                    editType: "calc"
                },
                zmax: {
                    valType: "info_array",
                    items: [
                        {
                            valType: "number",
                            editType: "calc"
                        },
                        {
                            valType: "number",
                            editType: "calc"
                        },
                        {
                            valType: "number",
                            editType: "calc"
                        },
                        {
                            valType: "number",
                            editType: "calc"
                        }
                    ],
                    editType: "calc"
                },
                x0: {
                    valType: "any",
                    dflt: 0,
                    editType: "calc+clearAxisTypes"
                },
                y0: {
                    valType: "any",
                    dflt: 0,
                    editType: "calc+clearAxisTypes"
                },
                dx: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc"
                },
                dy: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc"
                },
                text: {
                    valType: "data_array",
                    editType: "plot"
                },
                hovertext: {
                    valType: "data_array",
                    editType: "plot"
                },
                hoverinfo: _3e({}, $2t.hoverinfo, {
                    flags: [
                        "x",
                        "y",
                        "z",
                        "color",
                        "name",
                        "text"
                    ],
                    dflt: "x+y+z+text+name"
                }),
                hovertemplate: ewt({}, {
                    keys: [
                        "z",
                        "color",
                        "colormodel"
                    ]
                }),
                zorder: Q2t
            });
        });
        var T3e = ye((hur, w3e)=>{
            "use strict";
            var nwt = Mr(), awt = tG(), b3e = jT(), owt = Ly().IMAGE_URL_PREFIX;
            w3e.exports = function(t, r) {
                function n(o, s) {
                    return nwt.coerce(t, r, awt, o, s);
                }
                n("source"), r.source && !r.source.match(owt) && delete r.source, r._hasSource = !!r.source;
                var i = n("z");
                if (r._hasZ = !(i === void 0 || !i.length || !i[0] || !i[0].length), !r._hasZ && !r._hasSource) {
                    r.visible = !1;
                    return;
                }
                n("x0"), n("y0"), n("dx"), n("dy");
                var a;
                r._hasZ ? (n("colormodel", "rgb"), a = b3e.colormodel[r.colormodel], n("zmin", a.zminDflt || a.min), n("zmax", a.zmaxDflt || a.max)) : r._hasSource && (r.colormodel = "rgba256", a = b3e.colormodel[r.colormodel], r.zmin = a.zminDflt, r.zmax = a.zmaxDflt), n("zsmooth"), n("text"), n("hovertext"), n("hovertemplate"), r._length = null, n("zorder");
            };
        });
        var Uy = ye((dur, rG)=>{
            typeof Object.create == "function" ? rG.exports = function(t, r) {
                r && (t.super_ = r, t.prototype = Object.create(r.prototype, {
                    constructor: {
                        value: t,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }));
            } : rG.exports = function(t, r) {
                if (r) {
                    t.super_ = r;
                    var n = function() {};
                    n.prototype = r.prototype, t.prototype = new n, t.prototype.constructor = t;
                }
            };
        });
        var iG = ye((vur, A3e)=>{
            A3e.exports = vb().EventEmitter;
        });
        var E3e = ye((F8)=>{
            "use strict";
            F8.byteLength = lwt;
            F8.toByteArray = cwt;
            F8.fromByteArray = dwt;
            var Fm = [], Z0 = [], swt = typeof Uint8Array != "undefined" ? Uint8Array : Array, nG = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            for(s2 = 0, S3e = nG.length; s2 < S3e; ++s2)Fm[s2] = nG[s2], Z0[nG.charCodeAt(s2)] = s2;
            var s2, S3e;
            Z0[45] = 62;
            Z0[95] = 63;
            function M3e(e) {
                var t = e.length;
                if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                var r = e.indexOf("=");
                r === -1 && (r = t);
                var n = r === t ? 0 : 4 - r % 4;
                return [
                    r,
                    n
                ];
            }
            function lwt(e) {
                var t = M3e(e), r = t[0], n = t[1];
                return (r + n) * 3 / 4 - n;
            }
            function uwt(e, t, r) {
                return (t + r) * 3 / 4 - r;
            }
            function cwt(e) {
                var t, r = M3e(e), n = r[0], i = r[1], a = new swt(uwt(e, n, i)), o = 0, s = i > 0 ? n - 4 : n, l;
                for(l = 0; l < s; l += 4)t = Z0[e.charCodeAt(l)] << 18 | Z0[e.charCodeAt(l + 1)] << 12 | Z0[e.charCodeAt(l + 2)] << 6 | Z0[e.charCodeAt(l + 3)], a[o++] = t >> 16 & 255, a[o++] = t >> 8 & 255, a[o++] = t & 255;
                return i === 2 && (t = Z0[e.charCodeAt(l)] << 2 | Z0[e.charCodeAt(l + 1)] >> 4, a[o++] = t & 255), i === 1 && (t = Z0[e.charCodeAt(l)] << 10 | Z0[e.charCodeAt(l + 1)] << 4 | Z0[e.charCodeAt(l + 2)] >> 2, a[o++] = t >> 8 & 255, a[o++] = t & 255), a;
            }
            function fwt(e) {
                return Fm[e >> 18 & 63] + Fm[e >> 12 & 63] + Fm[e >> 6 & 63] + Fm[e & 63];
            }
            function hwt(e, t, r) {
                for(var n, i = [], a = t; a < r; a += 3)n = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (e[a + 2] & 255), i.push(fwt(n));
                return i.join("");
            }
            function dwt(e) {
                for(var t, r = e.length, n = r % 3, i = [], a = 16383, o = 0, s = r - n; o < s; o += a)i.push(hwt(e, o, o + a > s ? s : o + a));
                return n === 1 ? (t = e[r - 1], i.push(Fm[t >> 2] + Fm[t << 4 & 63] + "==")) : n === 2 && (t = (e[r - 2] << 8) + e[r - 1], i.push(Fm[t >> 10] + Fm[t >> 4 & 63] + Fm[t << 2 & 63] + "=")), i.join("");
            }
        });
        var k3e = ye((aG)=>{
            aG.read = function(e, t, r, n, i) {
                var a, o, s = i * 8 - n - 1, l = (1 << s) - 1, u = l >> 1, c = -7, f = r ? i - 1 : 0, h = r ? -1 : 1, d = e[t + f];
                for(f += h, a = d & (1 << -c) - 1, d >>= -c, c += s; c > 0; a = a * 256 + e[t + f], f += h, c -= 8);
                for(o = a & (1 << -c) - 1, a >>= -c, c += n; c > 0; o = o * 256 + e[t + f], f += h, c -= 8);
                if (a === 0) a = 1 - u;
                else {
                    if (a === l) return o ? NaN : (d ? -1 : 1) * (1 / 0);
                    o = o + Math.pow(2, n), a = a - u;
                }
                return (d ? -1 : 1) * o * Math.pow(2, a - n);
            };
            aG.write = function(e, t, r, n, i, a) {
                var o, s, l, u = a * 8 - i - 1, c = (1 << u) - 1, f = c >> 1, h = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = n ? 0 : a - 1, v = n ? 1 : -1, x = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
                for(t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (s = isNaN(t) ? 1 : 0, o = c) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), o + f >= 1 ? t += h / l : t += h * Math.pow(2, 1 - f), t * l >= 2 && (o++, l /= 2), o + f >= c ? (s = 0, o = c) : o + f >= 1 ? (s = (t * l - 1) * Math.pow(2, i), o = o + f) : (s = t * Math.pow(2, f - 1) * Math.pow(2, i), o = 0)); i >= 8; e[r + d] = s & 255, d += v, s /= 256, i -= 8);
                for(o = o << i | s, u += i; u > 0; e[r + d] = o & 255, d += v, o /= 256, u -= 8);
                e[r + d - v] |= x * 128;
            };
        });
        var u2 = ye((KT)=>{
            "use strict";
            var oG = E3e(), XT = k3e(), C3e = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
            KT.Buffer = In;
            KT.SlowBuffer = _wt;
            KT.INSPECT_MAX_BYTES = 50;
            var q8 = 2147483647;
            KT.kMaxLength = q8;
            In.TYPED_ARRAY_SUPPORT = vwt();
            !In.TYPED_ARRAY_SUPPORT && typeof console != "undefined" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
            function vwt() {
                try {
                    let e = new Uint8Array(1), t = {
                        foo: function() {
                            return 42;
                        }
                    };
                    return Object.setPrototypeOf(t, Uint8Array.prototype), Object.setPrototypeOf(e, t), e.foo() === 42;
                } catch (e) {
                    return !1;
                }
            }
            Object.defineProperty(In.prototype, "parent", {
                enumerable: !0,
                get: function() {
                    if (In.isBuffer(this)) return this.buffer;
                }
            });
            Object.defineProperty(In.prototype, "offset", {
                enumerable: !0,
                get: function() {
                    if (In.isBuffer(this)) return this.byteOffset;
                }
            });
            function Vy(e) {
                if (e > q8) throw new RangeError('The value "' + e + '" is invalid for option "size"');
                let t = new Uint8Array(e);
                return Object.setPrototypeOf(t, In.prototype), t;
            }
            function In(e, t, r) {
                if (typeof e == "number") {
                    if (typeof t == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                    return cG(e);
                }
                return R3e(e, t, r);
            }
            In.poolSize = 8192;
            function R3e(e, t, r) {
                if (typeof e == "string") return gwt(e, t);
                if (ArrayBuffer.isView(e)) return mwt(e);
                if (e == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
                if (qm(e, ArrayBuffer) || e && qm(e.buffer, ArrayBuffer) || typeof SharedArrayBuffer != "undefined" && (qm(e, SharedArrayBuffer) || e && qm(e.buffer, SharedArrayBuffer))) return lG(e, t, r);
                if (typeof e == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
                let n = e.valueOf && e.valueOf();
                if (n != null && n !== e) return In.from(n, t, r);
                let i = ywt(e);
                if (i) return i;
                if (typeof Symbol != "undefined" && Symbol.toPrimitive != null && typeof e[Symbol.toPrimitive] == "function") return In.from(e[Symbol.toPrimitive]("string"), t, r);
                throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
            }
            In.from = function(e, t, r) {
                return R3e(e, t, r);
            };
            Object.setPrototypeOf(In.prototype, Uint8Array.prototype);
            Object.setPrototypeOf(In, Uint8Array);
            function D3e(e) {
                if (typeof e != "number") throw new TypeError('"size" argument must be of type number');
                if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
            }
            function pwt(e, t, r) {
                return D3e(e), e <= 0 ? Vy(e) : t !== void 0 ? typeof r == "string" ? Vy(e).fill(t, r) : Vy(e).fill(t) : Vy(e);
            }
            In.alloc = function(e, t, r) {
                return pwt(e, t, r);
            };
            function cG(e) {
                return D3e(e), Vy(e < 0 ? 0 : fG(e) | 0);
            }
            In.allocUnsafe = function(e) {
                return cG(e);
            };
            In.allocUnsafeSlow = function(e) {
                return cG(e);
            };
            function gwt(e, t) {
                if ((typeof t != "string" || t === "") && (t = "utf8"), !In.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
                let r = z3e(e, t) | 0, n = Vy(r), i = n.write(e, t);
                return i !== r && (n = n.slice(0, i)), n;
            }
            function sG(e) {
                let t = e.length < 0 ? 0 : fG(e.length) | 0, r = Vy(t);
                for(let n = 0; n < t; n += 1)r[n] = e[n] & 255;
                return r;
            }
            function mwt(e) {
                if (qm(e, Uint8Array)) {
                    let t = new Uint8Array(e);
                    return lG(t.buffer, t.byteOffset, t.byteLength);
                }
                return sG(e);
            }
            function lG(e, t, r) {
                if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
                if (e.byteLength < t + (r || 0)) throw new RangeError('"length" is outside of buffer bounds');
                let n;
                return t === void 0 && r === void 0 ? n = new Uint8Array(e) : r === void 0 ? n = new Uint8Array(e, t) : n = new Uint8Array(e, t, r), Object.setPrototypeOf(n, In.prototype), n;
            }
            function ywt(e) {
                if (In.isBuffer(e)) {
                    let t = fG(e.length) | 0, r = Vy(t);
                    return r.length === 0 || e.copy(r, 0, 0, t), r;
                }
                if (e.length !== void 0) return typeof e.length != "number" || dG(e.length) ? Vy(0) : sG(e);
                if (e.type === "Buffer" && Array.isArray(e.data)) return sG(e.data);
            }
            function fG(e) {
                if (e >= q8) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + q8.toString(16) + " bytes");
                return e | 0;
            }
            function _wt(e) {
                return +e != e && (e = 0), In.alloc(+e);
            }
            In.isBuffer = function(t) {
                return t != null && t._isBuffer === !0 && t !== In.prototype;
            };
            In.compare = function(t, r) {
                if (qm(t, Uint8Array) && (t = In.from(t, t.offset, t.byteLength)), qm(r, Uint8Array) && (r = In.from(r, r.offset, r.byteLength)), !In.isBuffer(t) || !In.isBuffer(r)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                if (t === r) return 0;
                let n = t.length, i = r.length;
                for(let a = 0, o = Math.min(n, i); a < o; ++a)if (t[a] !== r[a]) {
                    n = t[a], i = r[a];
                    break;
                }
                return n < i ? -1 : i < n ? 1 : 0;
            };
            In.isEncoding = function(t) {
                switch(String(t).toLowerCase()){
                    case "hex":
                    case "utf8":
                    case "utf-8":
                    case "ascii":
                    case "latin1":
                    case "binary":
                    case "base64":
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return !0;
                    default:
                        return !1;
                }
            };
            In.concat = function(t, r) {
                if (!Array.isArray(t)) throw new TypeError('"list" argument must be an Array of Buffers');
                if (t.length === 0) return In.alloc(0);
                let n;
                if (r === void 0) for(r = 0, n = 0; n < t.length; ++n)r += t[n].length;
                let i = In.allocUnsafe(r), a = 0;
                for(n = 0; n < t.length; ++n){
                    let o = t[n];
                    if (qm(o, Uint8Array)) a + o.length > i.length ? (In.isBuffer(o) || (o = In.from(o)), o.copy(i, a)) : Uint8Array.prototype.set.call(i, o, a);
                    else if (In.isBuffer(o)) o.copy(i, a);
                    else throw new TypeError('"list" argument must be an Array of Buffers');
                    a += o.length;
                }
                return i;
            };
            function z3e(e, t) {
                if (In.isBuffer(e)) return e.length;
                if (ArrayBuffer.isView(e) || qm(e, ArrayBuffer)) return e.byteLength;
                if (typeof e != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
                let r = e.length, n = arguments.length > 2 && arguments[2] === !0;
                if (!n && r === 0) return 0;
                let i = !1;
                for(;;)switch(t){
                    case "ascii":
                    case "latin1":
                    case "binary":
                        return r;
                    case "utf8":
                    case "utf-8":
                        return uG(e).length;
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return r * 2;
                    case "hex":
                        return r >>> 1;
                    case "base64":
                        return G3e(e).length;
                    default:
                        if (i) return n ? -1 : uG(e).length;
                        t = ("" + t).toLowerCase(), i = !0;
                }
            }
            In.byteLength = z3e;
            function xwt(e, t, r) {
                let n = !1;
                if ((t === void 0 || t < 0) && (t = 0), t > this.length || ((r === void 0 || r > this.length) && (r = this.length), r <= 0) || (r >>>= 0, t >>>= 0, r <= t)) return "";
                for(e || (e = "utf8");;)switch(e){
                    case "hex":
                        return Lwt(this, t, r);
                    case "utf8":
                    case "utf-8":
                        return q3e(this, t, r);
                    case "ascii":
                        return kwt(this, t, r);
                    case "latin1":
                    case "binary":
                        return Cwt(this, t, r);
                    case "base64":
                        return Mwt(this, t, r);
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return Pwt(this, t, r);
                    default:
                        if (n) throw new TypeError("Unknown encoding: " + e);
                        e = (e + "").toLowerCase(), n = !0;
                }
            }
            In.prototype._isBuffer = !0;
            function l2(e, t, r) {
                let n = e[t];
                e[t] = e[r], e[r] = n;
            }
            In.prototype.swap16 = function() {
                let t = this.length;
                if (t % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                for(let r = 0; r < t; r += 2)l2(this, r, r + 1);
                return this;
            };
            In.prototype.swap32 = function() {
                let t = this.length;
                if (t % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                for(let r = 0; r < t; r += 4)l2(this, r, r + 3), l2(this, r + 1, r + 2);
                return this;
            };
            In.prototype.swap64 = function() {
                let t = this.length;
                if (t % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                for(let r = 0; r < t; r += 8)l2(this, r, r + 7), l2(this, r + 1, r + 6), l2(this, r + 2, r + 5), l2(this, r + 3, r + 4);
                return this;
            };
            In.prototype.toString = function() {
                let t = this.length;
                return t === 0 ? "" : arguments.length === 0 ? q3e(this, 0, t) : xwt.apply(this, arguments);
            };
            In.prototype.toLocaleString = In.prototype.toString;
            In.prototype.equals = function(t) {
                if (!In.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
                return this === t ? !0 : In.compare(this, t) === 0;
            };
            In.prototype.inspect = function() {
                let t = "", r = KT.INSPECT_MAX_BYTES;
                return t = this.toString("hex", 0, r).replace(/(.{2})/g, "$1 ").trim(), this.length > r && (t += " ... "), "<Buffer " + t + ">";
            };
            C3e && (In.prototype[C3e] = In.prototype.inspect);
            In.prototype.compare = function(t, r, n, i, a) {
                if (qm(t, Uint8Array) && (t = In.from(t, t.offset, t.byteLength)), !In.isBuffer(t)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof t);
                if (r === void 0 && (r = 0), n === void 0 && (n = t ? t.length : 0), i === void 0 && (i = 0), a === void 0 && (a = this.length), r < 0 || n > t.length || i < 0 || a > this.length) throw new RangeError("out of range index");
                if (i >= a && r >= n) return 0;
                if (i >= a) return -1;
                if (r >= n) return 1;
                if (r >>>= 0, n >>>= 0, i >>>= 0, a >>>= 0, this === t) return 0;
                let o = a - i, s = n - r, l = Math.min(o, s), u = this.slice(i, a), c = t.slice(r, n);
                for(let f = 0; f < l; ++f)if (u[f] !== c[f]) {
                    o = u[f], s = c[f];
                    break;
                }
                return o < s ? -1 : s < o ? 1 : 0;
            };
            function F3e(e, t, r, n, i) {
                if (e.length === 0) return -1;
                if (typeof r == "string" ? (n = r, r = 0) : r > 2147483647 ? r = 2147483647 : r < -2147483648 && (r = -2147483648), r = +r, dG(r) && (r = i ? 0 : e.length - 1), r < 0 && (r = e.length + r), r >= e.length) {
                    if (i) return -1;
                    r = e.length - 1;
                } else if (r < 0) {
                    if (i) r = 0;
                    else return -1;
                }
                if (typeof t == "string" && (t = In.from(t, n)), In.isBuffer(t)) return t.length === 0 ? -1 : L3e(e, t, r, n, i);
                if (typeof t == "number") return t = t & 255, typeof Uint8Array.prototype.indexOf == "function" ? i ? Uint8Array.prototype.indexOf.call(e, t, r) : Uint8Array.prototype.lastIndexOf.call(e, t, r) : L3e(e, [
                    t
                ], r, n, i);
                throw new TypeError("val must be string, number or Buffer");
            }
            function L3e(e, t, r, n, i) {
                let a = 1, o = e.length, s = t.length;
                if (n !== void 0 && (n = String(n).toLowerCase(), n === "ucs2" || n === "ucs-2" || n === "utf16le" || n === "utf-16le")) {
                    if (e.length < 2 || t.length < 2) return -1;
                    a = 2, o /= 2, s /= 2, r /= 2;
                }
                function l(c, f) {
                    return a === 1 ? c[f] : c.readUInt16BE(f * a);
                }
                let u;
                if (i) {
                    let c = -1;
                    for(u = r; u < o; u++)if (l(e, u) === l(t, c === -1 ? 0 : u - c)) {
                        if (c === -1 && (c = u), u - c + 1 === s) return c * a;
                    } else c !== -1 && (u -= u - c), c = -1;
                } else for(r + s > o && (r = o - s), u = r; u >= 0; u--){
                    let c = !0;
                    for(let f = 0; f < s; f++)if (l(e, u + f) !== l(t, f)) {
                        c = !1;
                        break;
                    }
                    if (c) return u;
                }
                return -1;
            }
            In.prototype.includes = function(t, r, n) {
                return this.indexOf(t, r, n) !== -1;
            };
            In.prototype.indexOf = function(t, r, n) {
                return F3e(this, t, r, n, !0);
            };
            In.prototype.lastIndexOf = function(t, r, n) {
                return F3e(this, t, r, n, !1);
            };
            function bwt(e, t, r, n) {
                r = Number(r) || 0;
                let i = e.length - r;
                n ? (n = Number(n), n > i && (n = i)) : n = i;
                let a = t.length;
                n > a / 2 && (n = a / 2);
                let o;
                for(o = 0; o < n; ++o){
                    let s = parseInt(t.substr(o * 2, 2), 16);
                    if (dG(s)) return o;
                    e[r + o] = s;
                }
                return o;
            }
            function wwt(e, t, r, n) {
                return O8(uG(t, e.length - r), e, r, n);
            }
            function Twt(e, t, r, n) {
                return O8(zwt(t), e, r, n);
            }
            function Awt(e, t, r, n) {
                return O8(G3e(t), e, r, n);
            }
            function Swt(e, t, r, n) {
                return O8(Fwt(t, e.length - r), e, r, n);
            }
            In.prototype.write = function(t, r, n, i) {
                if (r === void 0) i = "utf8", n = this.length, r = 0;
                else if (n === void 0 && typeof r == "string") i = r, n = this.length, r = 0;
                else if (isFinite(r)) r = r >>> 0, isFinite(n) ? (n = n >>> 0, i === void 0 && (i = "utf8")) : (i = n, n = void 0);
                else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                let a = this.length - r;
                if ((n === void 0 || n > a) && (n = a), t.length > 0 && (n < 0 || r < 0) || r > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                i || (i = "utf8");
                let o = !1;
                for(;;)switch(i){
                    case "hex":
                        return bwt(this, t, r, n);
                    case "utf8":
                    case "utf-8":
                        return wwt(this, t, r, n);
                    case "ascii":
                    case "latin1":
                    case "binary":
                        return Twt(this, t, r, n);
                    case "base64":
                        return Awt(this, t, r, n);
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return Swt(this, t, r, n);
                    default:
                        if (o) throw new TypeError("Unknown encoding: " + i);
                        i = ("" + i).toLowerCase(), o = !0;
                }
            };
            In.prototype.toJSON = function() {
                return {
                    type: "Buffer",
                    data: Array.prototype.slice.call(this._arr || this, 0)
                };
            };
            function Mwt(e, t, r) {
                return t === 0 && r === e.length ? oG.fromByteArray(e) : oG.fromByteArray(e.slice(t, r));
            }
            function q3e(e, t, r) {
                r = Math.min(e.length, r);
                let n = [], i = t;
                for(; i < r;){
                    let a = e[i], o = null, s = a > 239 ? 4 : a > 223 ? 3 : a > 191 ? 2 : 1;
                    if (i + s <= r) {
                        let l, u, c, f;
                        switch(s){
                            case 1:
                                a < 128 && (o = a);
                                break;
                            case 2:
                                l = e[i + 1], (l & 192) === 128 && (f = (a & 31) << 6 | l & 63, f > 127 && (o = f));
                                break;
                            case 3:
                                l = e[i + 1], u = e[i + 2], (l & 192) === 128 && (u & 192) === 128 && (f = (a & 15) << 12 | (l & 63) << 6 | u & 63, f > 2047 && (f < 55296 || f > 57343) && (o = f));
                                break;
                            case 4:
                                l = e[i + 1], u = e[i + 2], c = e[i + 3], (l & 192) === 128 && (u & 192) === 128 && (c & 192) === 128 && (f = (a & 15) << 18 | (l & 63) << 12 | (u & 63) << 6 | c & 63, f > 65535 && f < 1114112 && (o = f));
                        }
                    }
                    o === null ? (o = 65533, s = 1) : o > 65535 && (o -= 65536, n.push(o >>> 10 & 1023 | 55296), o = 56320 | o & 1023), n.push(o), i += s;
                }
                return Ewt(n);
            }
            var P3e = 4096;
            function Ewt(e) {
                let t = e.length;
                if (t <= P3e) return String.fromCharCode.apply(String, e);
                let r = "", n = 0;
                for(; n < t;)r += String.fromCharCode.apply(String, e.slice(n, n += P3e));
                return r;
            }
            function kwt(e, t, r) {
                let n = "";
                r = Math.min(e.length, r);
                for(let i = t; i < r; ++i)n += String.fromCharCode(e[i] & 127);
                return n;
            }
            function Cwt(e, t, r) {
                let n = "";
                r = Math.min(e.length, r);
                for(let i = t; i < r; ++i)n += String.fromCharCode(e[i]);
                return n;
            }
            function Lwt(e, t, r) {
                let n = e.length;
                (!t || t < 0) && (t = 0), (!r || r < 0 || r > n) && (r = n);
                let i = "";
                for(let a = t; a < r; ++a)i += qwt[e[a]];
                return i;
            }
            function Pwt(e, t, r) {
                let n = e.slice(t, r), i = "";
                for(let a = 0; a < n.length - 1; a += 2)i += String.fromCharCode(n[a] + n[a + 1] * 256);
                return i;
            }
            In.prototype.slice = function(t, r) {
                let n = this.length;
                t = ~~t, r = r === void 0 ? n : ~~r, t < 0 ? (t += n, t < 0 && (t = 0)) : t > n && (t = n), r < 0 ? (r += n, r < 0 && (r = 0)) : r > n && (r = n), r < t && (r = t);
                let i = this.subarray(t, r);
                return Object.setPrototypeOf(i, In.prototype), i;
            };
            function $d(e, t, r) {
                if (e % 1 !== 0 || e < 0) throw new RangeError("offset is not uint");
                if (e + t > r) throw new RangeError("Trying to access beyond buffer length");
            }
            In.prototype.readUintLE = In.prototype.readUIntLE = function(t, r, n) {
                t = t >>> 0, r = r >>> 0, n || $d(t, r, this.length);
                let i = this[t], a = 1, o = 0;
                for(; ++o < r && (a *= 256);)i += this[t + o] * a;
                return i;
            };
            In.prototype.readUintBE = In.prototype.readUIntBE = function(t, r, n) {
                t = t >>> 0, r = r >>> 0, n || $d(t, r, this.length);
                let i = this[t + --r], a = 1;
                for(; r > 0 && (a *= 256);)i += this[t + --r] * a;
                return i;
            };
            In.prototype.readUint8 = In.prototype.readUInt8 = function(t, r) {
                return t = t >>> 0, r || $d(t, 1, this.length), this[t];
            };
            In.prototype.readUint16LE = In.prototype.readUInt16LE = function(t, r) {
                return t = t >>> 0, r || $d(t, 2, this.length), this[t] | this[t + 1] << 8;
            };
            In.prototype.readUint16BE = In.prototype.readUInt16BE = function(t, r) {
                return t = t >>> 0, r || $d(t, 2, this.length), this[t] << 8 | this[t + 1];
            };
            In.prototype.readUint32LE = In.prototype.readUInt32LE = function(t, r) {
                return t = t >>> 0, r || $d(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + this[t + 3] * 16777216;
            };
            In.prototype.readUint32BE = In.prototype.readUInt32BE = function(t, r) {
                return t = t >>> 0, r || $d(t, 4, this.length), this[t] * 16777216 + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]);
            };
            In.prototype.readBigUInt64LE = I_(function(t) {
                t = t >>> 0, YT(t, "offset");
                let r = this[t], n = this[t + 7];
                (r === void 0 || n === void 0) && z4(t, this.length - 8);
                let i = r + this[++t] * 256 + this[++t] * 2 ** 16 + this[++t] * 2 ** 24, a = this[++t] + this[++t] * 256 + this[++t] * 2 ** 16 + n * 2 ** 24;
                return BigInt(i) + (BigInt(a) << BigInt(32));
            });
            In.prototype.readBigUInt64BE = I_(function(t) {
                t = t >>> 0, YT(t, "offset");
                let r = this[t], n = this[t + 7];
                (r === void 0 || n === void 0) && z4(t, this.length - 8);
                let i = r * 2 ** 24 + this[++t] * 2 ** 16 + this[++t] * 256 + this[++t], a = this[++t] * 2 ** 24 + this[++t] * 2 ** 16 + this[++t] * 256 + n;
                return (BigInt(i) << BigInt(32)) + BigInt(a);
            });
            In.prototype.readIntLE = function(t, r, n) {
                t = t >>> 0, r = r >>> 0, n || $d(t, r, this.length);
                let i = this[t], a = 1, o = 0;
                for(; ++o < r && (a *= 256);)i += this[t + o] * a;
                return a *= 128, i >= a && (i -= Math.pow(2, 8 * r)), i;
            };
            In.prototype.readIntBE = function(t, r, n) {
                t = t >>> 0, r = r >>> 0, n || $d(t, r, this.length);
                let i = r, a = 1, o = this[t + --i];
                for(; i > 0 && (a *= 256);)o += this[t + --i] * a;
                return a *= 128, o >= a && (o -= Math.pow(2, 8 * r)), o;
            };
            In.prototype.readInt8 = function(t, r) {
                return t = t >>> 0, r || $d(t, 1, this.length), this[t] & 128 ? (255 - this[t] + 1) * -1 : this[t];
            };
            In.prototype.readInt16LE = function(t, r) {
                t = t >>> 0, r || $d(t, 2, this.length);
                let n = this[t] | this[t + 1] << 8;
                return n & 32768 ? n | 4294901760 : n;
            };
            In.prototype.readInt16BE = function(t, r) {
                t = t >>> 0, r || $d(t, 2, this.length);
                let n = this[t + 1] | this[t] << 8;
                return n & 32768 ? n | 4294901760 : n;
            };
            In.prototype.readInt32LE = function(t, r) {
                return t = t >>> 0, r || $d(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24;
            };
            In.prototype.readInt32BE = function(t, r) {
                return t = t >>> 0, r || $d(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3];
            };
            In.prototype.readBigInt64LE = I_(function(t) {
                t = t >>> 0, YT(t, "offset");
                let r = this[t], n = this[t + 7];
                (r === void 0 || n === void 0) && z4(t, this.length - 8);
                let i = this[t + 4] + this[t + 5] * 256 + this[t + 6] * 2 ** 16 + (n << 24);
                return (BigInt(i) << BigInt(32)) + BigInt(r + this[++t] * 256 + this[++t] * 2 ** 16 + this[++t] * 2 ** 24);
            });
            In.prototype.readBigInt64BE = I_(function(t) {
                t = t >>> 0, YT(t, "offset");
                let r = this[t], n = this[t + 7];
                (r === void 0 || n === void 0) && z4(t, this.length - 8);
                let i = (r << 24) + this[++t] * 2 ** 16 + this[++t] * 256 + this[++t];
                return (BigInt(i) << BigInt(32)) + BigInt(this[++t] * 2 ** 24 + this[++t] * 2 ** 16 + this[++t] * 256 + n);
            });
            In.prototype.readFloatLE = function(t, r) {
                return t = t >>> 0, r || $d(t, 4, this.length), XT.read(this, t, !0, 23, 4);
            };
            In.prototype.readFloatBE = function(t, r) {
                return t = t >>> 0, r || $d(t, 4, this.length), XT.read(this, t, !1, 23, 4);
            };
            In.prototype.readDoubleLE = function(t, r) {
                return t = t >>> 0, r || $d(t, 8, this.length), XT.read(this, t, !0, 52, 8);
            };
            In.prototype.readDoubleBE = function(t, r) {
                return t = t >>> 0, r || $d(t, 8, this.length), XT.read(this, t, !1, 52, 8);
            };
            function Rp(e, t, r, n, i, a) {
                if (!In.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
                if (t > i || t < a) throw new RangeError('"value" argument is out of bounds');
                if (r + n > e.length) throw new RangeError("Index out of range");
            }
            In.prototype.writeUintLE = In.prototype.writeUIntLE = function(t, r, n, i) {
                if (t = +t, r = r >>> 0, n = n >>> 0, !i) {
                    let s = Math.pow(2, 8 * n) - 1;
                    Rp(this, t, r, n, s, 0);
                }
                let a = 1, o = 0;
                for(this[r] = t & 255; ++o < n && (a *= 256);)this[r + o] = t / a & 255;
                return r + n;
            };
            In.prototype.writeUintBE = In.prototype.writeUIntBE = function(t, r, n, i) {
                if (t = +t, r = r >>> 0, n = n >>> 0, !i) {
                    let s = Math.pow(2, 8 * n) - 1;
                    Rp(this, t, r, n, s, 0);
                }
                let a = n - 1, o = 1;
                for(this[r + a] = t & 255; --a >= 0 && (o *= 256);)this[r + a] = t / o & 255;
                return r + n;
            };
            In.prototype.writeUint8 = In.prototype.writeUInt8 = function(t, r, n) {
                return t = +t, r = r >>> 0, n || Rp(this, t, r, 1, 255, 0), this[r] = t & 255, r + 1;
            };
            In.prototype.writeUint16LE = In.prototype.writeUInt16LE = function(t, r, n) {
                return t = +t, r = r >>> 0, n || Rp(this, t, r, 2, 65535, 0), this[r] = t & 255, this[r + 1] = t >>> 8, r + 2;
            };
            In.prototype.writeUint16BE = In.prototype.writeUInt16BE = function(t, r, n) {
                return t = +t, r = r >>> 0, n || Rp(this, t, r, 2, 65535, 0), this[r] = t >>> 8, this[r + 1] = t & 255, r + 2;
            };
            In.prototype.writeUint32LE = In.prototype.writeUInt32LE = function(t, r, n) {
                return t = +t, r = r >>> 0, n || Rp(this, t, r, 4, 4294967295, 0), this[r + 3] = t >>> 24, this[r + 2] = t >>> 16, this[r + 1] = t >>> 8, this[r] = t & 255, r + 4;
            };
            In.prototype.writeUint32BE = In.prototype.writeUInt32BE = function(t, r, n) {
                return t = +t, r = r >>> 0, n || Rp(this, t, r, 4, 4294967295, 0), this[r] = t >>> 24, this[r + 1] = t >>> 16, this[r + 2] = t >>> 8, this[r + 3] = t & 255, r + 4;
            };
            function O3e(e, t, r, n, i) {
                H3e(t, n, i, e, r, 7);
                let a = Number(t & BigInt(4294967295));
                e[r++] = a, a = a >> 8, e[r++] = a, a = a >> 8, e[r++] = a, a = a >> 8, e[r++] = a;
                let o = Number(t >> BigInt(32) & BigInt(4294967295));
                return e[r++] = o, o = o >> 8, e[r++] = o, o = o >> 8, e[r++] = o, o = o >> 8, e[r++] = o, r;
            }
            function B3e(e, t, r, n, i) {
                H3e(t, n, i, e, r, 7);
                let a = Number(t & BigInt(4294967295));
                e[r + 7] = a, a = a >> 8, e[r + 6] = a, a = a >> 8, e[r + 5] = a, a = a >> 8, e[r + 4] = a;
                let o = Number(t >> BigInt(32) & BigInt(4294967295));
                return e[r + 3] = o, o = o >> 8, e[r + 2] = o, o = o >> 8, e[r + 1] = o, o = o >> 8, e[r] = o, r + 8;
            }
            In.prototype.writeBigUInt64LE = I_(function(t, r = 0) {
                return O3e(this, t, r, BigInt(0), BigInt("0xffffffffffffffff"));
            });
            In.prototype.writeBigUInt64BE = I_(function(t, r = 0) {
                return B3e(this, t, r, BigInt(0), BigInt("0xffffffffffffffff"));
            });
            In.prototype.writeIntLE = function(t, r, n, i) {
                if (t = +t, r = r >>> 0, !i) {
                    let l = Math.pow(2, 8 * n - 1);
                    Rp(this, t, r, n, l - 1, -l);
                }
                let a = 0, o = 1, s = 0;
                for(this[r] = t & 255; ++a < n && (o *= 256);)t < 0 && s === 0 && this[r + a - 1] !== 0 && (s = 1), this[r + a] = (t / o >> 0) - s & 255;
                return r + n;
            };
            In.prototype.writeIntBE = function(t, r, n, i) {
                if (t = +t, r = r >>> 0, !i) {
                    let l = Math.pow(2, 8 * n - 1);
                    Rp(this, t, r, n, l - 1, -l);
                }
                let a = n - 1, o = 1, s = 0;
                for(this[r + a] = t & 255; --a >= 0 && (o *= 256);)t < 0 && s === 0 && this[r + a + 1] !== 0 && (s = 1), this[r + a] = (t / o >> 0) - s & 255;
                return r + n;
            };
            In.prototype.writeInt8 = function(t, r, n) {
                return t = +t, r = r >>> 0, n || Rp(this, t, r, 1, 127, -128), t < 0 && (t = 255 + t + 1), this[r] = t & 255, r + 1;
            };
            In.prototype.writeInt16LE = function(t, r, n) {
                return t = +t, r = r >>> 0, n || Rp(this, t, r, 2, 32767, -32768), this[r] = t & 255, this[r + 1] = t >>> 8, r + 2;
            };
            In.prototype.writeInt16BE = function(t, r, n) {
                return t = +t, r = r >>> 0, n || Rp(this, t, r, 2, 32767, -32768), this[r] = t >>> 8, this[r + 1] = t & 255, r + 2;
            };
            In.prototype.writeInt32LE = function(t, r, n) {
                return t = +t, r = r >>> 0, n || Rp(this, t, r, 4, 2147483647, -2147483648), this[r] = t & 255, this[r + 1] = t >>> 8, this[r + 2] = t >>> 16, this[r + 3] = t >>> 24, r + 4;
            };
            In.prototype.writeInt32BE = function(t, r, n) {
                return t = +t, r = r >>> 0, n || Rp(this, t, r, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), this[r] = t >>> 24, this[r + 1] = t >>> 16, this[r + 2] = t >>> 8, this[r + 3] = t & 255, r + 4;
            };
            In.prototype.writeBigInt64LE = I_(function(t, r = 0) {
                return O3e(this, t, r, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
            });
            In.prototype.writeBigInt64BE = I_(function(t, r = 0) {
                return B3e(this, t, r, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
            });
            function N3e(e, t, r, n, i, a) {
                if (r + n > e.length) throw new RangeError("Index out of range");
                if (r < 0) throw new RangeError("Index out of range");
            }
            function U3e(e, t, r, n, i) {
                return t = +t, r = r >>> 0, i || N3e(e, t, r, 4, 34028234663852886e22, -340282346638528860000000000000000000000), XT.write(e, t, r, n, 23, 4), r + 4;
            }
            In.prototype.writeFloatLE = function(t, r, n) {
                return U3e(this, t, r, !0, n);
            };
            In.prototype.writeFloatBE = function(t, r, n) {
                return U3e(this, t, r, !1, n);
            };
            function V3e(e, t, r, n, i) {
                return t = +t, r = r >>> 0, i || N3e(e, t, r, 8, 17976931348623157e292, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000), XT.write(e, t, r, n, 52, 8), r + 8;
            }
            In.prototype.writeDoubleLE = function(t, r, n) {
                return V3e(this, t, r, !0, n);
            };
            In.prototype.writeDoubleBE = function(t, r, n) {
                return V3e(this, t, r, !1, n);
            };
            In.prototype.copy = function(t, r, n, i) {
                if (!In.isBuffer(t)) throw new TypeError("argument should be a Buffer");
                if (n || (n = 0), !i && i !== 0 && (i = this.length), r >= t.length && (r = t.length), r || (r = 0), i > 0 && i < n && (i = n), i === n || t.length === 0 || this.length === 0) return 0;
                if (r < 0) throw new RangeError("targetStart out of bounds");
                if (n < 0 || n >= this.length) throw new RangeError("Index out of range");
                if (i < 0) throw new RangeError("sourceEnd out of bounds");
                i > this.length && (i = this.length), t.length - r < i - n && (i = t.length - r + n);
                let a = i - n;
                return this === t && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(r, n, i) : Uint8Array.prototype.set.call(t, this.subarray(n, i), r), a;
            };
            In.prototype.fill = function(t, r, n, i) {
                if (typeof t == "string") {
                    if (typeof r == "string" ? (i = r, r = 0, n = this.length) : typeof n == "string" && (i = n, n = this.length), i !== void 0 && typeof i != "string") throw new TypeError("encoding must be a string");
                    if (typeof i == "string" && !In.isEncoding(i)) throw new TypeError("Unknown encoding: " + i);
                    if (t.length === 1) {
                        let o = t.charCodeAt(0);
                        (i === "utf8" && o < 128 || i === "latin1") && (t = o);
                    }
                } else typeof t == "number" ? t = t & 255 : typeof t == "boolean" && (t = Number(t));
                if (r < 0 || this.length < r || this.length < n) throw new RangeError("Out of range index");
                if (n <= r) return this;
                r = r >>> 0, n = n === void 0 ? this.length : n >>> 0, t || (t = 0);
                let a;
                if (typeof t == "number") for(a = r; a < n; ++a)this[a] = t;
                else {
                    let o = In.isBuffer(t) ? t : In.from(t, i), s = o.length;
                    if (s === 0) throw new TypeError('The value "' + t + '" is invalid for argument "value"');
                    for(a = 0; a < n - r; ++a)this[a + r] = o[a % s];
                }
                return this;
            };
            var ZT = {};
            function hG(e, t, r) {
                ZT[e] = class extends r {
                    constructor(){
                        super(), Object.defineProperty(this, "message", {
                            value: t.apply(this, arguments),
                            writable: !0,
                            configurable: !0
                        }), this.name = `${this.name} [${e}]`, this.stack, delete this.name;
                    }
                    get code() {
                        return e;
                    }
                    set code(i) {
                        Object.defineProperty(this, "code", {
                            configurable: !0,
                            enumerable: !0,
                            value: i,
                            writable: !0
                        });
                    }
                    toString() {
                        return `${this.name} [${e}]: ${this.message}`;
                    }
                };
            }
            hG("ERR_BUFFER_OUT_OF_BOUNDS", function(e) {
                return e ? `${e} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
            }, RangeError);
            hG("ERR_INVALID_ARG_TYPE", function(e, t) {
                return `The "${e}" argument must be of type number. Received type ${typeof t}`;
            }, TypeError);
            hG("ERR_OUT_OF_RANGE", function(e, t, r) {
                let n = `The value of "${e}" is out of range.`, i = r;
                return Number.isInteger(r) && Math.abs(r) > 2 ** 32 ? i = I3e(String(r)) : typeof r == "bigint" && (i = String(r), (r > BigInt(2) ** BigInt(32) || r < -(BigInt(2) ** BigInt(32))) && (i = I3e(i)), i += "n"), n += ` It must be ${t}. Received ${i}`, n;
            }, RangeError);
            function I3e(e) {
                let t = "", r = e.length, n = e[0] === "-" ? 1 : 0;
                for(; r >= n + 4; r -= 3)t = `_${e.slice(r - 3, r)}${t}`;
                return `${e.slice(0, r)}${t}`;
            }
            function Iwt(e, t, r) {
                YT(t, "offset"), (e[t] === void 0 || e[t + r] === void 0) && z4(t, e.length - (r + 1));
            }
            function H3e(e, t, r, n, i, a) {
                if (e > r || e < t) {
                    let o = typeof t == "bigint" ? "n" : "", s;
                    throw a > 3 ? t === 0 || t === BigInt(0) ? s = `>= 0${o} and < 2${o} ** ${(a + 1) * 8}${o}` : s = `>= -(2${o} ** ${(a + 1) * 8 - 1}${o}) and < 2 ** ${(a + 1) * 8 - 1}${o}` : s = `>= ${t}${o} and <= ${r}${o}`, new ZT.ERR_OUT_OF_RANGE("value", s, e);
                }
                Iwt(n, i, a);
            }
            function YT(e, t) {
                if (typeof e != "number") throw new ZT.ERR_INVALID_ARG_TYPE(t, "number", e);
            }
            function z4(e, t, r) {
                throw Math.floor(e) !== e ? (YT(e, r), new ZT.ERR_OUT_OF_RANGE(r || "offset", "an integer", e)) : t < 0 ? new ZT.ERR_BUFFER_OUT_OF_BOUNDS : new ZT.ERR_OUT_OF_RANGE(r || "offset", `>= ${r ? 1 : 0} and <= ${t}`, e);
            }
            var Rwt = /[^+/0-9A-Za-z-_]/g;
            function Dwt(e) {
                if (e = e.split("=")[0], e = e.trim().replace(Rwt, ""), e.length < 2) return "";
                for(; e.length % 4 !== 0;)e = e + "=";
                return e;
            }
            function uG(e, t) {
                t = t || 1 / 0;
                let r, n = e.length, i = null, a = [];
                for(let o = 0; o < n; ++o){
                    if (r = e.charCodeAt(o), r > 55295 && r < 57344) {
                        if (!i) {
                            if (r > 56319) {
                                (t -= 3) > -1 && a.push(239, 191, 189);
                                continue;
                            } else if (o + 1 === n) {
                                (t -= 3) > -1 && a.push(239, 191, 189);
                                continue;
                            }
                            i = r;
                            continue;
                        }
                        if (r < 56320) {
                            (t -= 3) > -1 && a.push(239, 191, 189), i = r;
                            continue;
                        }
                        r = (i - 55296 << 10 | r - 56320) + 65536;
                    } else i && (t -= 3) > -1 && a.push(239, 191, 189);
                    if (i = null, r < 128) {
                        if ((t -= 1) < 0) break;
                        a.push(r);
                    } else if (r < 2048) {
                        if ((t -= 2) < 0) break;
                        a.push(r >> 6 | 192, r & 63 | 128);
                    } else if (r < 65536) {
                        if ((t -= 3) < 0) break;
                        a.push(r >> 12 | 224, r >> 6 & 63 | 128, r & 63 | 128);
                    } else if (r < 1114112) {
                        if ((t -= 4) < 0) break;
                        a.push(r >> 18 | 240, r >> 12 & 63 | 128, r >> 6 & 63 | 128, r & 63 | 128);
                    } else throw new Error("Invalid code point");
                }
                return a;
            }
            function zwt(e) {
                let t = [];
                for(let r = 0; r < e.length; ++r)t.push(e.charCodeAt(r) & 255);
                return t;
            }
            function Fwt(e, t) {
                let r, n, i, a = [];
                for(let o = 0; o < e.length && !((t -= 2) < 0); ++o)r = e.charCodeAt(o), n = r >> 8, i = r % 256, a.push(i), a.push(n);
                return a;
            }
            function G3e(e) {
                return oG.toByteArray(Dwt(e));
            }
            function O8(e, t, r, n) {
                let i;
                for(i = 0; i < n && !(i + r >= t.length || i >= e.length); ++i)t[i + r] = e[i];
                return i;
            }
            function qm(e, t) {
                return e instanceof t || e != null && e.constructor != null && e.constructor.name != null && e.constructor.name === t.name;
            }
            function dG(e) {
                return e !== e;
            }
            var qwt = function() {
                let e = "0123456789abcdef", t = new Array(256);
                for(let r = 0; r < 16; ++r){
                    let n = r * 16;
                    for(let i = 0; i < 16; ++i)t[n + i] = e[r] + e[i];
                }
                return t;
            }();
            function I_(e) {
                return typeof BigInt == "undefined" ? Owt : e;
            }
            function Owt() {
                throw new Error("BigInt not supported");
            }
        });
        var B8 = ye((_ur, j3e)=>{
            "use strict";
            j3e.exports = function() {
                if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function") return !1;
                if (typeof Symbol.iterator == "symbol") return !0;
                var t = {}, r = Symbol("test"), n = Object(r);
                if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]") return !1;
                var i = 42;
                t[r] = i;
                for(r in t)return !1;
                if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0) return !1;
                var a = Object.getOwnPropertySymbols(t);
                if (a.length !== 1 || a[0] !== r || !Object.prototype.propertyIsEnumerable.call(t, r)) return !1;
                if (typeof Object.getOwnPropertyDescriptor == "function") {
                    var o = Object.getOwnPropertyDescriptor(t, r);
                    if (o.value !== i || o.enumerable !== !0) return !1;
                }
                return !0;
            };
        });
        var F4 = ye((xur, W3e)=>{
            "use strict";
            var Bwt = B8();
            W3e.exports = function() {
                return Bwt() && !!Symbol.toStringTag;
            };
        });
        var X3e = ye((bur, Z3e)=>{
            "use strict";
            Z3e.exports = Error;
        });
        var K3e = ye((wur, Y3e)=>{
            "use strict";
            Y3e.exports = EvalError;
        });
        var $3e = ye((Tur, J3e)=>{
            "use strict";
            J3e.exports = RangeError;
        });
        var eTe = ye((Aur, Q3e)=>{
            "use strict";
            Q3e.exports = ReferenceError;
        });
        var vG = ye((Sur, tTe)=>{
            "use strict";
            tTe.exports = SyntaxError;
        });
        var q4 = ye((Mur, rTe)=>{
            "use strict";
            rTe.exports = TypeError;
        });
        var nTe = ye((Eur, iTe)=>{
            "use strict";
            iTe.exports = URIError;
        });
        var sTe = ye((kur, oTe)=>{
            "use strict";
            var aTe = typeof Symbol != "undefined" && Symbol, Nwt = B8();
            oTe.exports = function() {
                return typeof aTe != "function" || typeof Symbol != "function" || typeof aTe("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : Nwt();
            };
        });
        var cTe = ye((Cur, uTe)=>{
            "use strict";
            var lTe = {
                foo: {}
            }, Uwt = Object;
            uTe.exports = function() {
                return ({
                    __proto__: lTe
                }).foo === lTe.foo && !(({
                    __proto__: null
                }) instanceof Uwt);
            };
        });
        var dTe = ye((Lur, hTe)=>{
            "use strict";
            var Vwt = "Function.prototype.bind called on incompatible ", Hwt = Object.prototype.toString, Gwt = Math.max, jwt = "[object Function]", fTe = function(t, r) {
                for(var n = [], i = 0; i < t.length; i += 1)n[i] = t[i];
                for(var a = 0; a < r.length; a += 1)n[a + t.length] = r[a];
                return n;
            }, Wwt = function(t, r) {
                for(var n = [], i = r || 0, a = 0; i < t.length; i += 1, a += 1)n[a] = t[i];
                return n;
            }, Zwt = function(e, t) {
                for(var r = "", n = 0; n < e.length; n += 1)r += e[n], n + 1 < e.length && (r += t);
                return r;
            };
            hTe.exports = function(t) {
                var r = this;
                if (typeof r != "function" || Hwt.apply(r) !== jwt) throw new TypeError(Vwt + r);
                for(var n = Wwt(arguments, 1), i, a = function() {
                    if (this instanceof i) {
                        var c = r.apply(this, fTe(n, arguments));
                        return Object(c) === c ? c : this;
                    }
                    return r.apply(t, fTe(n, arguments));
                }, o = Gwt(0, r.length - n.length), s = [], l = 0; l < o; l++)s[l] = "$" + l;
                if (i = Function("binder", "return function (" + Zwt(s, ",") + "){ return binder.apply(this,arguments); }")(a), r.prototype) {
                    var u = function() {};
                    u.prototype = r.prototype, i.prototype = new u, u.prototype = null;
                }
                return i;
            };
        });
        var N8 = ye((Pur, vTe)=>{
            "use strict";
            var Xwt = dTe();
            vTe.exports = Function.prototype.bind || Xwt;
        });
        var gTe = ye((Iur, pTe)=>{
            "use strict";
            var Ywt = Function.prototype.call, Kwt = Object.prototype.hasOwnProperty, Jwt = N8();
            pTe.exports = Jwt.call(Ywt, Kwt);
        });
        var t5 = ye((Rur, bTe)=>{
            "use strict";
            var jl, $wt = X3e(), Qwt = K3e(), e3t = $3e(), t3t = eTe(), e5 = vG(), QT = q4(), r3t = nTe(), xTe = Function, pG = function(e) {
                try {
                    return xTe('"use strict"; return (' + e + ").constructor;")();
                } catch (t) {}
            }, c2 = Object.getOwnPropertyDescriptor;
            if (c2) try {
                c2({}, "");
            } catch (e) {
                c2 = null;
            }
            var gG = function() {
                throw new QT;
            }, i3t = c2 ? function() {
                try {
                    return arguments.callee, gG;
                } catch (e) {
                    try {
                        return c2(arguments, "callee").get;
                    } catch (t) {
                        return gG;
                    }
                }
            }() : gG, JT = sTe()(), n3t = cTe()(), Qd = Object.getPrototypeOf || (n3t ? function(e) {
                return e.__proto__;
            } : null), $T = {}, a3t = typeof Uint8Array == "undefined" || !Qd ? jl : Qd(Uint8Array), f2 = {
                __proto__: null,
                "%AggregateError%": typeof AggregateError == "undefined" ? jl : AggregateError,
                "%Array%": Array,
                "%ArrayBuffer%": typeof ArrayBuffer == "undefined" ? jl : ArrayBuffer,
                "%ArrayIteratorPrototype%": JT && Qd ? Qd([][Symbol.iterator]()) : jl,
                "%AsyncFromSyncIteratorPrototype%": jl,
                "%AsyncFunction%": $T,
                "%AsyncGenerator%": $T,
                "%AsyncGeneratorFunction%": $T,
                "%AsyncIteratorPrototype%": $T,
                "%Atomics%": typeof Atomics == "undefined" ? jl : Atomics,
                "%BigInt%": typeof BigInt == "undefined" ? jl : BigInt,
                "%BigInt64Array%": typeof BigInt64Array == "undefined" ? jl : BigInt64Array,
                "%BigUint64Array%": typeof BigUint64Array == "undefined" ? jl : BigUint64Array,
                "%Boolean%": Boolean,
                "%DataView%": typeof DataView == "undefined" ? jl : DataView,
                "%Date%": Date,
                "%decodeURI%": decodeURI,
                "%decodeURIComponent%": decodeURIComponent,
                "%encodeURI%": encodeURI,
                "%encodeURIComponent%": encodeURIComponent,
                "%Error%": $wt,
                "%eval%": eval,
                "%EvalError%": Qwt,
                "%Float32Array%": typeof Float32Array == "undefined" ? jl : Float32Array,
                "%Float64Array%": typeof Float64Array == "undefined" ? jl : Float64Array,
                "%FinalizationRegistry%": typeof FinalizationRegistry == "undefined" ? jl : FinalizationRegistry,
                "%Function%": xTe,
                "%GeneratorFunction%": $T,
                "%Int8Array%": typeof Int8Array == "undefined" ? jl : Int8Array,
                "%Int16Array%": typeof Int16Array == "undefined" ? jl : Int16Array,
                "%Int32Array%": typeof Int32Array == "undefined" ? jl : Int32Array,
                "%isFinite%": isFinite,
                "%isNaN%": isNaN,
                "%IteratorPrototype%": JT && Qd ? Qd(Qd([][Symbol.iterator]())) : jl,
                "%JSON%": typeof JSON == "object" ? JSON : jl,
                "%Map%": typeof Map == "undefined" ? jl : Map,
                "%MapIteratorPrototype%": typeof Map == "undefined" || !JT || !Qd ? jl : Qd(new Map()[Symbol.iterator]()),
                "%Math%": Math,
                "%Number%": Number,
                "%Object%": Object,
                "%parseFloat%": parseFloat,
                "%parseInt%": parseInt,
                "%Promise%": typeof Promise == "undefined" ? jl : Promise,
                "%Proxy%": typeof Proxy == "undefined" ? jl : Proxy,
                "%RangeError%": e3t,
                "%ReferenceError%": t3t,
                "%Reflect%": typeof Reflect == "undefined" ? jl : Reflect,
                "%RegExp%": RegExp,
                "%Set%": typeof Set == "undefined" ? jl : Set,
                "%SetIteratorPrototype%": typeof Set == "undefined" || !JT || !Qd ? jl : Qd(new Set()[Symbol.iterator]()),
                "%SharedArrayBuffer%": typeof SharedArrayBuffer == "undefined" ? jl : SharedArrayBuffer,
                "%String%": String,
                "%StringIteratorPrototype%": JT && Qd ? Qd(""[Symbol.iterator]()) : jl,
                "%Symbol%": JT ? Symbol : jl,
                "%SyntaxError%": e5,
                "%ThrowTypeError%": i3t,
                "%TypedArray%": a3t,
                "%TypeError%": QT,
                "%Uint8Array%": typeof Uint8Array == "undefined" ? jl : Uint8Array,
                "%Uint8ClampedArray%": typeof Uint8ClampedArray == "undefined" ? jl : Uint8ClampedArray,
                "%Uint16Array%": typeof Uint16Array == "undefined" ? jl : Uint16Array,
                "%Uint32Array%": typeof Uint32Array == "undefined" ? jl : Uint32Array,
                "%URIError%": r3t,
                "%WeakMap%": typeof WeakMap == "undefined" ? jl : WeakMap,
                "%WeakRef%": typeof WeakRef == "undefined" ? jl : WeakRef,
                "%WeakSet%": typeof WeakSet == "undefined" ? jl : WeakSet
            };
            if (Qd) try {
                null.error;
            } catch (e) {
                mTe = Qd(Qd(e)), f2["%Error.prototype%"] = mTe;
            }
            var mTe, o3t = function e(t) {
                var r;
                if (t === "%AsyncFunction%") r = pG("async function () {}");
                else if (t === "%GeneratorFunction%") r = pG("function* () {}");
                else if (t === "%AsyncGeneratorFunction%") r = pG("async function* () {}");
                else if (t === "%AsyncGenerator%") {
                    var n = e("%AsyncGeneratorFunction%");
                    n && (r = n.prototype);
                } else if (t === "%AsyncIteratorPrototype%") {
                    var i = e("%AsyncGenerator%");
                    i && Qd && (r = Qd(i.prototype));
                }
                return f2[t] = r, r;
            }, yTe = {
                __proto__: null,
                "%ArrayBufferPrototype%": [
                    "ArrayBuffer",
                    "prototype"
                ],
                "%ArrayPrototype%": [
                    "Array",
                    "prototype"
                ],
                "%ArrayProto_entries%": [
                    "Array",
                    "prototype",
                    "entries"
                ],
                "%ArrayProto_forEach%": [
                    "Array",
                    "prototype",
                    "forEach"
                ],
                "%ArrayProto_keys%": [
                    "Array",
                    "prototype",
                    "keys"
                ],
                "%ArrayProto_values%": [
                    "Array",
                    "prototype",
                    "values"
                ],
                "%AsyncFunctionPrototype%": [
                    "AsyncFunction",
                    "prototype"
                ],
                "%AsyncGenerator%": [
                    "AsyncGeneratorFunction",
                    "prototype"
                ],
                "%AsyncGeneratorPrototype%": [
                    "AsyncGeneratorFunction",
                    "prototype",
                    "prototype"
                ],
                "%BooleanPrototype%": [
                    "Boolean",
                    "prototype"
                ],
                "%DataViewPrototype%": [
                    "DataView",
                    "prototype"
                ],
                "%DatePrototype%": [
                    "Date",
                    "prototype"
                ],
                "%ErrorPrototype%": [
                    "Error",
                    "prototype"
                ],
                "%EvalErrorPrototype%": [
                    "EvalError",
                    "prototype"
                ],
                "%Float32ArrayPrototype%": [
                    "Float32Array",
                    "prototype"
                ],
                "%Float64ArrayPrototype%": [
                    "Float64Array",
                    "prototype"
                ],
                "%FunctionPrototype%": [
                    "Function",
                    "prototype"
                ],
                "%Generator%": [
                    "GeneratorFunction",
                    "prototype"
                ],
                "%GeneratorPrototype%": [
                    "GeneratorFunction",
                    "prototype",
                    "prototype"
                ],
                "%Int8ArrayPrototype%": [
                    "Int8Array",
                    "prototype"
                ],
                "%Int16ArrayPrototype%": [
                    "Int16Array",
                    "prototype"
                ],
                "%Int32ArrayPrototype%": [
                    "Int32Array",
                    "prototype"
                ],
                "%JSONParse%": [
                    "JSON",
                    "parse"
                ],
                "%JSONStringify%": [
                    "JSON",
                    "stringify"
                ],
                "%MapPrototype%": [
                    "Map",
                    "prototype"
                ],
                "%NumberPrototype%": [
                    "Number",
                    "prototype"
                ],
                "%ObjectPrototype%": [
                    "Object",
                    "prototype"
                ],
                "%ObjProto_toString%": [
                    "Object",
                    "prototype",
                    "toString"
                ],
                "%ObjProto_valueOf%": [
                    "Object",
                    "prototype",
                    "valueOf"
                ],
                "%PromisePrototype%": [
                    "Promise",
                    "prototype"
                ],
                "%PromiseProto_then%": [
                    "Promise",
                    "prototype",
                    "then"
                ],
                "%Promise_all%": [
                    "Promise",
                    "all"
                ],
                "%Promise_reject%": [
                    "Promise",
                    "reject"
                ],
                "%Promise_resolve%": [
                    "Promise",
                    "resolve"
                ],
                "%RangeErrorPrototype%": [
                    "RangeError",
                    "prototype"
                ],
                "%ReferenceErrorPrototype%": [
                    "ReferenceError",
                    "prototype"
                ],
                "%RegExpPrototype%": [
                    "RegExp",
                    "prototype"
                ],
                "%SetPrototype%": [
                    "Set",
                    "prototype"
                ],
                "%SharedArrayBufferPrototype%": [
                    "SharedArrayBuffer",
                    "prototype"
                ],
                "%StringPrototype%": [
                    "String",
                    "prototype"
                ],
                "%SymbolPrototype%": [
                    "Symbol",
                    "prototype"
                ],
                "%SyntaxErrorPrototype%": [
                    "SyntaxError",
                    "prototype"
                ],
                "%TypedArrayPrototype%": [
                    "TypedArray",
                    "prototype"
                ],
                "%TypeErrorPrototype%": [
                    "TypeError",
                    "prototype"
                ],
                "%Uint8ArrayPrototype%": [
                    "Uint8Array",
                    "prototype"
                ],
                "%Uint8ClampedArrayPrototype%": [
                    "Uint8ClampedArray",
                    "prototype"
                ],
                "%Uint16ArrayPrototype%": [
                    "Uint16Array",
                    "prototype"
                ],
                "%Uint32ArrayPrototype%": [
                    "Uint32Array",
                    "prototype"
                ],
                "%URIErrorPrototype%": [
                    "URIError",
                    "prototype"
                ],
                "%WeakMapPrototype%": [
                    "WeakMap",
                    "prototype"
                ],
                "%WeakSetPrototype%": [
                    "WeakSet",
                    "prototype"
                ]
            }, O4 = N8(), U8 = gTe(), s3t = O4.call(Function.call, Array.prototype.concat), l3t = O4.call(Function.apply, Array.prototype.splice), _Te = O4.call(Function.call, String.prototype.replace), V8 = O4.call(Function.call, String.prototype.slice), u3t = O4.call(Function.call, RegExp.prototype.exec), c3t = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, f3t = /\\(\\)?/g, h3t = function(t) {
                var r = V8(t, 0, 1), n = V8(t, -1);
                if (r === "%" && n !== "%") throw new e5("invalid intrinsic syntax, expected closing `%`");
                if (n === "%" && r !== "%") throw new e5("invalid intrinsic syntax, expected opening `%`");
                var i = [];
                return _Te(t, c3t, function(a, o, s, l) {
                    i[i.length] = s ? _Te(l, f3t, "$1") : o || a;
                }), i;
            }, d3t = function(t, r) {
                var n = t, i;
                if (U8(yTe, n) && (i = yTe[n], n = "%" + i[0] + "%"), U8(f2, n)) {
                    var a = f2[n];
                    if (a === $T && (a = o3t(n)), typeof a == "undefined" && !r) throw new QT("intrinsic " + t + " exists, but is not available. Please file an issue!");
                    return {
                        alias: i,
                        name: n,
                        value: a
                    };
                }
                throw new e5("intrinsic " + t + " does not exist!");
            };
            bTe.exports = function(t, r) {
                if (typeof t != "string" || t.length === 0) throw new QT("intrinsic name must be a non-empty string");
                if (arguments.length > 1 && typeof r != "boolean") throw new QT('"allowMissing" argument must be a boolean');
                if (u3t(/^%?[^%]*%?$/, t) === null) throw new e5("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
                var n = h3t(t), i = n.length > 0 ? n[0] : "", a = d3t("%" + i + "%", r), o = a.name, s = a.value, l = !1, u = a.alias;
                u && (i = u[0], l3t(n, s3t([
                    0,
                    1
                ], u)));
                for(var c = 1, f = !0; c < n.length; c += 1){
                    var h = n[c], d = V8(h, 0, 1), v = V8(h, -1);
                    if ((d === '"' || d === "'" || d === "`" || v === '"' || v === "'" || v === "`") && d !== v) throw new e5("property names with quotes must have matching quotes");
                    if ((h === "constructor" || !f) && (l = !0), i += "." + h, o = "%" + i + "%", U8(f2, o)) s = f2[o];
                    else if (s != null) {
                        if (!(h in s)) {
                            if (!r) throw new QT("base intrinsic for " + t + " exists, but the property is not available.");
                            return;
                        }
                        if (c2 && c + 1 >= n.length) {
                            var x = c2(s, h);
                            f = !!x, f && "get" in x && !("originalValue" in x.get) ? s = x.get : s = s[h];
                        } else f = U8(s, h), s = s[h];
                        f && !l && (f2[o] = s);
                    }
                }
                return s;
            };
        });
        var G8 = ye((Dur, wTe)=>{
            "use strict";
            var v3t = t5(), H8 = v3t("%Object.defineProperty%", !0) || !1;
            if (H8) try {
                H8({}, "a", {
                    value: 1
                });
            } catch (e) {
                H8 = !1;
            }
            wTe.exports = H8;
        });
        var B4 = ye((zur, TTe)=>{
            "use strict";
            var p3t = t5(), j8 = p3t("%Object.getOwnPropertyDescriptor%", !0);
            if (j8) try {
                j8([], "length");
            } catch (e) {
                j8 = null;
            }
            TTe.exports = j8;
        });
        var ETe = ye((Fur, MTe)=>{
            "use strict";
            var ATe = G8(), g3t = vG(), r5 = q4(), STe = B4();
            MTe.exports = function(t, r, n) {
                if (!t || typeof t != "object" && typeof t != "function") throw new r5("`obj` must be an object or a function`");
                if (typeof r != "string" && typeof r != "symbol") throw new r5("`property` must be a string or a symbol`");
                if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null) throw new r5("`nonEnumerable`, if provided, must be a boolean or null");
                if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null) throw new r5("`nonWritable`, if provided, must be a boolean or null");
                if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null) throw new r5("`nonConfigurable`, if provided, must be a boolean or null");
                if (arguments.length > 6 && typeof arguments[6] != "boolean") throw new r5("`loose`, if provided, must be a boolean");
                var i = arguments.length > 3 ? arguments[3] : null, a = arguments.length > 4 ? arguments[4] : null, o = arguments.length > 5 ? arguments[5] : null, s = arguments.length > 6 ? arguments[6] : !1, l = !!STe && STe(t, r);
                if (ATe) ATe(t, r, {
                    configurable: o === null && l ? l.configurable : !o,
                    enumerable: i === null && l ? l.enumerable : !i,
                    value: n,
                    writable: a === null && l ? l.writable : !a
                });
                else if (s || !i && !a && !o) t[r] = n;
                else throw new g3t("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
            };
        });
        var yG = ye((qur, CTe)=>{
            "use strict";
            var mG = G8(), kTe = function() {
                return !!mG;
            };
            kTe.hasArrayLengthDefineBug = function() {
                if (!mG) return null;
                try {
                    return mG([], "length", {
                        value: 1
                    }).length !== 1;
                } catch (t) {
                    return !0;
                }
            };
            CTe.exports = kTe;
        });
        var DTe = ye((Our, RTe)=>{
            "use strict";
            var m3t = t5(), LTe = ETe(), y3t = yG()(), PTe = B4(), ITe = q4(), _3t = m3t("%Math.floor%");
            RTe.exports = function(t, r) {
                if (typeof t != "function") throw new ITe("`fn` is not a function");
                if (typeof r != "number" || r < 0 || r > 4294967295 || _3t(r) !== r) throw new ITe("`length` must be a positive 32-bit integer");
                var n = arguments.length > 2 && !!arguments[2], i = !0, a = !0;
                if ("length" in t && PTe) {
                    var o = PTe(t, "length");
                    o && !o.configurable && (i = !1), o && !o.writable && (a = !1);
                }
                return (i || a || !n) && (y3t ? LTe(t, "length", r, !0, !0) : LTe(t, "length", r)), t;
            };
        });
        var N4 = ye((Bur, W8)=>{
            "use strict";
            var _G = N8(), Z8 = t5(), x3t = DTe(), b3t = q4(), qTe = Z8("%Function.prototype.apply%"), OTe = Z8("%Function.prototype.call%"), BTe = Z8("%Reflect.apply%", !0) || _G.call(OTe, qTe), zTe = G8(), w3t = Z8("%Math.max%");
            W8.exports = function(t) {
                if (typeof t != "function") throw new b3t("a function is required");
                var r = BTe(_G, OTe, arguments);
                return x3t(r, 1 + w3t(0, t.length - (arguments.length - 1)), !0);
            };
            var FTe = function() {
                return BTe(_G, qTe, arguments);
            };
            zTe ? zTe(W8.exports, "apply", {
                value: FTe
            }) : W8.exports.apply = FTe;
        });
        var i5 = ye((Nur, VTe)=>{
            "use strict";
            var NTe = t5(), UTe = N4(), T3t = UTe(NTe("String.prototype.indexOf"));
            VTe.exports = function(t, r) {
                var n = NTe(t, !!r);
                return typeof n == "function" && T3t(t, ".prototype.") > -1 ? UTe(n) : n;
            };
        });
        var jTe = ye((Uur, GTe)=>{
            "use strict";
            var A3t = F4()(), S3t = i5(), xG = S3t("Object.prototype.toString"), X8 = function(t) {
                return A3t && t && typeof t == "object" && Symbol.toStringTag in t ? !1 : xG(t) === "[object Arguments]";
            }, HTe = function(t) {
                return X8(t) ? !0 : t !== null && typeof t == "object" && typeof t.length == "number" && t.length >= 0 && xG(t) !== "[object Array]" && xG(t.callee) === "[object Function]";
            }, M3t = function() {
                return X8(arguments);
            }();
            X8.isLegacyArguments = HTe;
            GTe.exports = M3t ? X8 : HTe;
        });
        var XTe = ye((Vur, ZTe)=>{
            "use strict";
            var E3t = Object.prototype.toString, k3t = Function.prototype.toString, C3t = /^\s*(?:function)?\*/, WTe = F4()(), bG = Object.getPrototypeOf, L3t = function() {
                if (!WTe) return !1;
                try {
                    return Function("return function*() {}")();
                } catch (e) {}
            }, wG;
            ZTe.exports = function(t) {
                if (typeof t != "function") return !1;
                if (C3t.test(k3t.call(t))) return !0;
                if (!WTe) {
                    var r = E3t.call(t);
                    return r === "[object GeneratorFunction]";
                }
                if (!bG) return !1;
                if (typeof wG == "undefined") {
                    var n = L3t();
                    wG = n ? bG(n) : !1;
                }
                return bG(t) === wG;
            };
        });
        var $Te = ye((Hur, JTe)=>{
            "use strict";
            var KTe = Function.prototype.toString, n5 = typeof Reflect == "object" && Reflect !== null && Reflect.apply, AG, Y8;
            if (typeof n5 == "function" && typeof Object.defineProperty == "function") try {
                AG = Object.defineProperty({}, "length", {
                    get: function() {
                        throw Y8;
                    }
                }), Y8 = {}, n5(function() {
                    throw 42;
                }, null, AG);
            } catch (e) {
                e !== Y8 && (n5 = null);
            }
            else n5 = null;
            var P3t = /^\s*class\b/, SG = function(t) {
                try {
                    var r = KTe.call(t);
                    return P3t.test(r);
                } catch (n) {
                    return !1;
                }
            }, TG = function(t) {
                try {
                    return SG(t) ? !1 : (KTe.call(t), !0);
                } catch (r) {
                    return !1;
                }
            }, K8 = Object.prototype.toString, I3t = "[object Object]", R3t = "[object Function]", D3t = "[object GeneratorFunction]", z3t = "[object HTMLAllCollection]", F3t = "[object HTML document.all class]", q3t = "[object HTMLCollection]", O3t = typeof Symbol == "function" && !!Symbol.toStringTag, B3t = !(0 in [
                , 
            ]), MG = function() {
                return !1;
            };
            typeof document == "object" && (YTe = document.all, K8.call(YTe) === K8.call(document.all) && (MG = function(t) {
                if ((B3t || !t) && (typeof t == "undefined" || typeof t == "object")) try {
                    var r = K8.call(t);
                    return (r === z3t || r === F3t || r === q3t || r === I3t) && t("") == null;
                } catch (n) {}
                return !1;
            }));
            var YTe;
            JTe.exports = n5 ? function(t) {
                if (MG(t)) return !0;
                if (!t || typeof t != "function" && typeof t != "object") return !1;
                try {
                    n5(t, null, AG);
                } catch (r) {
                    if (r !== Y8) return !1;
                }
                return !SG(t) && TG(t);
            } : function(t) {
                if (MG(t)) return !0;
                if (!t || typeof t != "function" && typeof t != "object") return !1;
                if (O3t) return TG(t);
                if (SG(t)) return !1;
                var r = K8.call(t);
                return r !== R3t && r !== D3t && !/^\[object HTML/.test(r) ? !1 : TG(t);
            };
        });
        var EG = ye((Gur, e5e)=>{
            "use strict";
            var N3t = $Te(), U3t = Object.prototype.toString, QTe = Object.prototype.hasOwnProperty, V3t = function(t, r, n) {
                for(var i = 0, a = t.length; i < a; i++)QTe.call(t, i) && (n == null ? r(t[i], i, t) : r.call(n, t[i], i, t));
            }, H3t = function(t, r, n) {
                for(var i = 0, a = t.length; i < a; i++)n == null ? r(t.charAt(i), i, t) : r.call(n, t.charAt(i), i, t);
            }, G3t = function(t, r, n) {
                for(var i in t)QTe.call(t, i) && (n == null ? r(t[i], i, t) : r.call(n, t[i], i, t));
            }, j3t = function(t, r, n) {
                if (!N3t(r)) throw new TypeError("iterator must be a function");
                var i;
                arguments.length >= 3 && (i = n), U3t.call(t) === "[object Array]" ? V3t(t, r, i) : typeof t == "string" ? H3t(t, r, i) : G3t(t, r, i);
            };
            e5e.exports = j3t;
        });
        var CG = ye((jur, t5e)=>{
            "use strict";
            var kG = [
                "BigInt64Array",
                "BigUint64Array",
                "Float32Array",
                "Float64Array",
                "Int16Array",
                "Int32Array",
                "Int8Array",
                "Uint16Array",
                "Uint32Array",
                "Uint8Array",
                "Uint8ClampedArray"
            ], W3t = typeof globalThis == "undefined" ? window : globalThis;
            t5e.exports = function() {
                for(var t = [], r = 0; r < kG.length; r++)typeof W3t[kG[r]] == "function" && (t[t.length] = kG[r]);
                return t;
            };
        });
        var o5e = ye((Wur, a5e)=>{
            "use strict";
            var $8 = EG(), Z3t = CG(), r5e = N4(), IG = i5(), J8 = B4(), X3t = IG("Object.prototype.toString"), n5e = F4()(), i5e = typeof globalThis == "undefined" ? window : globalThis, PG = Z3t(), RG = IG("String.prototype.slice"), LG = Object.getPrototypeOf, Y3t = IG("Array.prototype.indexOf", !0) || function(t, r) {
                for(var n = 0; n < t.length; n += 1)if (t[n] === r) return n;
                return -1;
            }, Q8 = {
                __proto__: null
            };
            n5e && J8 && LG ? $8(PG, function(e) {
                var t = new i5e[e];
                if (Symbol.toStringTag in t) {
                    var r = LG(t), n = J8(r, Symbol.toStringTag);
                    if (!n) {
                        var i = LG(r);
                        n = J8(i, Symbol.toStringTag);
                    }
                    Q8["$" + e] = r5e(n.get);
                }
            }) : $8(PG, function(e) {
                var t = new i5e[e], r = t.slice || t.set;
                r && (Q8["$" + e] = r5e(r));
            });
            var K3t = function(t) {
                var r = !1;
                return $8(Q8, function(n, i) {
                    if (!r) try {
                        "$" + n(t) === i && (r = RG(i, 1));
                    } catch (a) {}
                }), r;
            }, J3t = function(t) {
                var r = !1;
                return $8(Q8, function(n, i) {
                    if (!r) try {
                        n(t), r = RG(i, 1);
                    } catch (a) {}
                }), r;
            };
            a5e.exports = function(t) {
                if (!t || typeof t != "object") return !1;
                if (!n5e) {
                    var r = RG(X3t(t), 8, -1);
                    return Y3t(PG, r) > -1 ? r : r !== "Object" ? !1 : J3t(t);
                }
                return J8 ? K3t(t) : null;
            };
        });
        var h5e = ye((Zur, f5e)=>{
            "use strict";
            var s5e = EG(), $3t = CG(), zG = i5(), Q3t = zG("Object.prototype.toString"), l5e = F4()(), eR = B4(), eTt = typeof globalThis == "undefined" ? window : globalThis, u5e = $3t(), tTt = zG("Array.prototype.indexOf", !0) || function(t, r) {
                for(var n = 0; n < t.length; n += 1)if (t[n] === r) return n;
                return -1;
            }, rTt = zG("String.prototype.slice"), c5e = {}, DG = Object.getPrototypeOf;
            l5e && eR && DG && s5e(u5e, function(e) {
                var t = new eTt[e];
                if (Symbol.toStringTag in t) {
                    var r = DG(t), n = eR(r, Symbol.toStringTag);
                    if (!n) {
                        var i = DG(r);
                        n = eR(i, Symbol.toStringTag);
                    }
                    c5e[e] = n.get;
                }
            });
            var iTt = function(t) {
                var r = !1;
                return s5e(c5e, function(n, i) {
                    if (!r) try {
                        r = n.call(t) === i;
                    } catch (a) {}
                }), r;
            };
            f5e.exports = function(t) {
                if (!t || typeof t != "object") return !1;
                if (!l5e || !(Symbol.toStringTag in t)) {
                    var r = rTt(Q3t(t), 8, -1);
                    return tTt(u5e, r) > -1;
                }
                return eR ? iTt(t) : !1;
            };
        });
        var OG = ye((Bl)=>{
            "use strict";
            var nTt = jTe(), aTt = XTe(), Hg = o5e(), d5e = h5e();
            function a5(e) {
                return e.call.bind(e);
            }
            var v5e = typeof BigInt != "undefined", p5e = typeof Symbol != "undefined", X0 = a5(Object.prototype.toString), oTt = a5(Number.prototype.valueOf), sTt = a5(String.prototype.valueOf), lTt = a5(Boolean.prototype.valueOf);
            v5e && (g5e = a5(BigInt.prototype.valueOf));
            var g5e;
            p5e && (m5e = a5(Symbol.prototype.valueOf));
            var m5e;
            function V4(e, t) {
                if (typeof e != "object") return !1;
                try {
                    return t(e), !0;
                } catch (r) {
                    return !1;
                }
            }
            Bl.isArgumentsObject = nTt;
            Bl.isGeneratorFunction = aTt;
            Bl.isTypedArray = d5e;
            function uTt(e) {
                return typeof Promise != "undefined" && e instanceof Promise || e !== null && typeof e == "object" && typeof e.then == "function" && typeof e.catch == "function";
            }
            Bl.isPromise = uTt;
            function cTt(e) {
                return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : d5e(e) || _5e(e);
            }
            Bl.isArrayBufferView = cTt;
            function fTt(e) {
                return Hg(e) === "Uint8Array";
            }
            Bl.isUint8Array = fTt;
            function hTt(e) {
                return Hg(e) === "Uint8ClampedArray";
            }
            Bl.isUint8ClampedArray = hTt;
            function dTt(e) {
                return Hg(e) === "Uint16Array";
            }
            Bl.isUint16Array = dTt;
            function vTt(e) {
                return Hg(e) === "Uint32Array";
            }
            Bl.isUint32Array = vTt;
            function pTt(e) {
                return Hg(e) === "Int8Array";
            }
            Bl.isInt8Array = pTt;
            function gTt(e) {
                return Hg(e) === "Int16Array";
            }
            Bl.isInt16Array = gTt;
            function mTt(e) {
                return Hg(e) === "Int32Array";
            }
            Bl.isInt32Array = mTt;
            function yTt(e) {
                return Hg(e) === "Float32Array";
            }
            Bl.isFloat32Array = yTt;
            function _Tt(e) {
                return Hg(e) === "Float64Array";
            }
            Bl.isFloat64Array = _Tt;
            function xTt(e) {
                return Hg(e) === "BigInt64Array";
            }
            Bl.isBigInt64Array = xTt;
            function bTt(e) {
                return Hg(e) === "BigUint64Array";
            }
            Bl.isBigUint64Array = bTt;
            function tR(e) {
                return X0(e) === "[object Map]";
            }
            tR.working = typeof Map != "undefined" && tR(new Map);
            function wTt(e) {
                return typeof Map == "undefined" ? !1 : tR.working ? tR(e) : e instanceof Map;
            }
            Bl.isMap = wTt;
            function rR(e) {
                return X0(e) === "[object Set]";
            }
            rR.working = typeof Set != "undefined" && rR(new Set);
            function TTt(e) {
                return typeof Set == "undefined" ? !1 : rR.working ? rR(e) : e instanceof Set;
            }
            Bl.isSet = TTt;
            function iR(e) {
                return X0(e) === "[object WeakMap]";
            }
            iR.working = typeof WeakMap != "undefined" && iR(new WeakMap);
            function ATt(e) {
                return typeof WeakMap == "undefined" ? !1 : iR.working ? iR(e) : e instanceof WeakMap;
            }
            Bl.isWeakMap = ATt;
            function qG(e) {
                return X0(e) === "[object WeakSet]";
            }
            qG.working = typeof WeakSet != "undefined" && qG(new WeakSet);
            function STt(e) {
                return qG(e);
            }
            Bl.isWeakSet = STt;
            function nR(e) {
                return X0(e) === "[object ArrayBuffer]";
            }
            nR.working = typeof ArrayBuffer != "undefined" && nR(new ArrayBuffer);
            function y5e(e) {
                return typeof ArrayBuffer == "undefined" ? !1 : nR.working ? nR(e) : e instanceof ArrayBuffer;
            }
            Bl.isArrayBuffer = y5e;
            function aR(e) {
                return X0(e) === "[object DataView]";
            }
            aR.working = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined" && aR(new DataView(new ArrayBuffer(1), 0, 1));
            function _5e(e) {
                return typeof DataView == "undefined" ? !1 : aR.working ? aR(e) : e instanceof DataView;
            }
            Bl.isDataView = _5e;
            var FG = typeof SharedArrayBuffer != "undefined" ? SharedArrayBuffer : void 0;
            function U4(e) {
                return X0(e) === "[object SharedArrayBuffer]";
            }
            function x5e(e) {
                return typeof FG == "undefined" ? !1 : (typeof U4.working == "undefined" && (U4.working = U4(new FG)), U4.working ? U4(e) : e instanceof FG);
            }
            Bl.isSharedArrayBuffer = x5e;
            function MTt(e) {
                return X0(e) === "[object AsyncFunction]";
            }
            Bl.isAsyncFunction = MTt;
            function ETt(e) {
                return X0(e) === "[object Map Iterator]";
            }
            Bl.isMapIterator = ETt;
            function kTt(e) {
                return X0(e) === "[object Set Iterator]";
            }
            Bl.isSetIterator = kTt;
            function CTt(e) {
                return X0(e) === "[object Generator]";
            }
            Bl.isGeneratorObject = CTt;
            function LTt(e) {
                return X0(e) === "[object WebAssembly.Module]";
            }
            Bl.isWebAssemblyCompiledModule = LTt;
            function b5e(e) {
                return V4(e, oTt);
            }
            Bl.isNumberObject = b5e;
            function w5e(e) {
                return V4(e, sTt);
            }
            Bl.isStringObject = w5e;
            function T5e(e) {
                return V4(e, lTt);
            }
            Bl.isBooleanObject = T5e;
            function A5e(e) {
                return v5e && V4(e, g5e);
            }
            Bl.isBigIntObject = A5e;
            function S5e(e) {
                return p5e && V4(e, m5e);
            }
            Bl.isSymbolObject = S5e;
            function PTt(e) {
                return b5e(e) || w5e(e) || T5e(e) || A5e(e) || S5e(e);
            }
            Bl.isBoxedPrimitive = PTt;
            function ITt(e) {
                return typeof Uint8Array != "undefined" && (y5e(e) || x5e(e));
            }
            Bl.isAnyArrayBuffer = ITt;
            [
                "isProxy",
                "isExternal",
                "isModuleNamespaceObject"
            ].forEach(function(e) {
                Object.defineProperty(Bl, e, {
                    enumerable: !1,
                    value: function() {
                        throw new Error(e + " is not supported in userland");
                    }
                });
            });
        });
        var BG = ye((Yur, M5e)=>{
            M5e.exports = function(t) {
                return t && typeof t == "object" && typeof t.copy == "function" && typeof t.fill == "function" && typeof t.readUInt8 == "function";
            };
        });
        var jG = ye((Nl)=>{
            var E5e = Object.getOwnPropertyDescriptors || function(t) {
                for(var r = Object.keys(t), n = {}, i = 0; i < r.length; i++)n[r[i]] = Object.getOwnPropertyDescriptor(t, r[i]);
                return n;
            }, RTt = /%[sdj%]/g;
            Nl.format = function(e) {
                if (!hR(e)) {
                    for(var t = [], r = 0; r < arguments.length; r++)t.push(R_(arguments[r]));
                    return t.join(" ");
                }
                for(var r = 1, n = arguments, i = n.length, a = String(e).replace(RTt, function(s) {
                    if (s === "%%") return "%";
                    if (r >= i) return s;
                    switch(s){
                        case "%s":
                            return String(n[r++]);
                        case "%d":
                            return Number(n[r++]);
                        case "%j":
                            try {
                                return JSON.stringify(n[r++]);
                            } catch (l) {
                                return "[Circular]";
                            }
                        default:
                            return s;
                    }
                }), o = n[r]; r < i; o = n[++r])fR(o) || !o5(o) ? a += " " + o : a += " " + R_(o);
                return a;
            };
            Nl.deprecate = function(e, t) {
                var r;
                return function() {
                    return Nl.deprecate(e, t).apply(this, arguments);
                };
                function n() {
                    if (!r) {
                        if ($d3c1734dacb01657$exports.throwDeprecation) throw new Error(t);
                        $d3c1734dacb01657$exports.traceDeprecation ? console.trace(t) : console.error(t), r = !0;
                    }
                    return e.apply(this, arguments);
                }
            };
            var oR = {}, k5e = /^$/;
            sR = "false", sR = sR.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), k5e = new RegExp("^" + sR + "$", "i");
            var sR;
            Nl.debuglog = function(e) {
                if (e = e.toUpperCase(), !oR[e]) {
                    if (k5e.test(e)) {
                        var t = $d3c1734dacb01657$exports.pid;
                        oR[e] = function() {
                            var r = Nl.format.apply(Nl, arguments);
                            console.error("%s %d: %s", e, t, r);
                        };
                    } else oR[e] = function() {};
                }
                return oR[e];
            };
            function R_(e, t) {
                var r = {
                    seen: [],
                    stylize: zTt
                };
                return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), HG(t) ? r.showHidden = t : t && Nl._extend(r, t), d2(r.showHidden) && (r.showHidden = !1), d2(r.depth) && (r.depth = 2), d2(r.colors) && (r.colors = !1), d2(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = DTt), uR(r, e, r.depth);
            }
            Nl.inspect = R_;
            R_.colors = {
                bold: [
                    1,
                    22
                ],
                italic: [
                    3,
                    23
                ],
                underline: [
                    4,
                    24
                ],
                inverse: [
                    7,
                    27
                ],
                white: [
                    37,
                    39
                ],
                grey: [
                    90,
                    39
                ],
                black: [
                    30,
                    39
                ],
                blue: [
                    34,
                    39
                ],
                cyan: [
                    36,
                    39
                ],
                green: [
                    32,
                    39
                ],
                magenta: [
                    35,
                    39
                ],
                red: [
                    31,
                    39
                ],
                yellow: [
                    33,
                    39
                ]
            };
            R_.styles = {
                special: "cyan",
                number: "yellow",
                boolean: "yellow",
                undefined: "grey",
                null: "bold",
                string: "green",
                date: "magenta",
                regexp: "red"
            };
            function DTt(e, t) {
                var r = R_.styles[t];
                return r ? "\x1B[" + R_.colors[r][0] + "m" + e + "\x1B[" + R_.colors[r][1] + "m" : e;
            }
            function zTt(e, t) {
                return e;
            }
            function FTt(e) {
                var t = {};
                return e.forEach(function(r, n) {
                    t[r] = !0;
                }), t;
            }
            function uR(e, t, r) {
                if (e.customInspect && t && lR(t.inspect) && t.inspect !== Nl.inspect && !(t.constructor && t.constructor.prototype === t)) {
                    var n = t.inspect(r, e);
                    return hR(n) || (n = uR(e, n, r)), n;
                }
                var i = qTt(e, t);
                if (i) return i;
                var a = Object.keys(t), o = FTt(a);
                if (e.showHidden && (a = Object.getOwnPropertyNames(t)), G4(t) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return NG(t);
                if (a.length === 0) {
                    if (lR(t)) {
                        var s = t.name ? ": " + t.name : "";
                        return e.stylize("[Function" + s + "]", "special");
                    }
                    if (H4(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                    if (cR(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                    if (G4(t)) return NG(t);
                }
                var l = "", u = !1, c = [
                    "{",
                    "}"
                ];
                if (C5e(t) && (u = !0, c = [
                    "[",
                    "]"
                ]), lR(t)) {
                    var f = t.name ? ": " + t.name : "";
                    l = " [Function" + f + "]";
                }
                if (H4(t) && (l = " " + RegExp.prototype.toString.call(t)), cR(t) && (l = " " + Date.prototype.toUTCString.call(t)), G4(t) && (l = " " + NG(t)), a.length === 0 && (!u || t.length == 0)) return c[0] + l + c[1];
                if (r < 0) return H4(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special");
                e.seen.push(t);
                var h;
                return u ? h = OTt(e, t, r, o, a) : h = a.map(function(d) {
                    return VG(e, t, r, o, d, u);
                }), e.seen.pop(), BTt(h, l, c);
            }
            function qTt(e, t) {
                if (d2(t)) return e.stylize("undefined", "undefined");
                if (hR(t)) {
                    var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                    return e.stylize(r, "string");
                }
                if (L5e(t)) return e.stylize("" + t, "number");
                if (HG(t)) return e.stylize("" + t, "boolean");
                if (fR(t)) return e.stylize("null", "null");
            }
            function NG(e) {
                return "[" + Error.prototype.toString.call(e) + "]";
            }
            function OTt(e, t, r, n, i) {
                for(var a = [], o = 0, s = t.length; o < s; ++o)P5e(t, String(o)) ? a.push(VG(e, t, r, n, String(o), !0)) : a.push("");
                return i.forEach(function(l) {
                    l.match(/^\d+$/) || a.push(VG(e, t, r, n, l, !0));
                }), a;
            }
            function VG(e, t, r, n, i, a) {
                var o, s, l;
                if (l = Object.getOwnPropertyDescriptor(t, i) || {
                    value: t[i]
                }, l.get ? l.set ? s = e.stylize("[Getter/Setter]", "special") : s = e.stylize("[Getter]", "special") : l.set && (s = e.stylize("[Setter]", "special")), P5e(n, i) || (o = "[" + i + "]"), s || (e.seen.indexOf(l.value) < 0 ? (fR(r) ? s = uR(e, l.value, null) : s = uR(e, l.value, r - 1), s.indexOf(`
`) > -1 && (a ? s = s.split(`
`).map(function(u) {
                    return "  " + u;
                }).join(`
`).slice(2) : s = `
` + s.split(`
`).map(function(u) {
                    return "   " + u;
                }).join(`
`))) : s = e.stylize("[Circular]", "special")), d2(o)) {
                    if (a && i.match(/^\d+$/)) return s;
                    o = JSON.stringify("" + i), o.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.slice(1, -1), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
                }
                return o + ": " + s;
            }
            function BTt(e, t, r) {
                var n = 0, i = e.reduce(function(a, o) {
                    return n++, o.indexOf(`
`) >= 0 && n++, a + o.replace(/\u001b\[\d\d?m/g, "").length + 1;
                }, 0);
                return i > 60 ? r[0] + (t === "" ? "" : t + `
 `) + " " + e.join(`,
  `) + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
            }
            Nl.types = OG();
            function C5e(e) {
                return Array.isArray(e);
            }
            Nl.isArray = C5e;
            function HG(e) {
                return typeof e == "boolean";
            }
            Nl.isBoolean = HG;
            function fR(e) {
                return e === null;
            }
            Nl.isNull = fR;
            function NTt(e) {
                return e == null;
            }
            Nl.isNullOrUndefined = NTt;
            function L5e(e) {
                return typeof e == "number";
            }
            Nl.isNumber = L5e;
            function hR(e) {
                return typeof e == "string";
            }
            Nl.isString = hR;
            function UTt(e) {
                return typeof e == "symbol";
            }
            Nl.isSymbol = UTt;
            function d2(e) {
                return e === void 0;
            }
            Nl.isUndefined = d2;
            function H4(e) {
                return o5(e) && GG(e) === "[object RegExp]";
            }
            Nl.isRegExp = H4;
            Nl.types.isRegExp = H4;
            function o5(e) {
                return typeof e == "object" && e !== null;
            }
            Nl.isObject = o5;
            function cR(e) {
                return o5(e) && GG(e) === "[object Date]";
            }
            Nl.isDate = cR;
            Nl.types.isDate = cR;
            function G4(e) {
                return o5(e) && (GG(e) === "[object Error]" || e instanceof Error);
            }
            Nl.isError = G4;
            Nl.types.isNativeError = G4;
            function lR(e) {
                return typeof e == "function";
            }
            Nl.isFunction = lR;
            function VTt(e) {
                return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || typeof e == "undefined";
            }
            Nl.isPrimitive = VTt;
            Nl.isBuffer = BG();
            function GG(e) {
                return Object.prototype.toString.call(e);
            }
            function UG(e) {
                return e < 10 ? "0" + e.toString(10) : e.toString(10);
            }
            var HTt = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ];
            function GTt() {
                var e = new Date, t = [
                    UG(e.getHours()),
                    UG(e.getMinutes()),
                    UG(e.getSeconds())
                ].join(":");
                return [
                    e.getDate(),
                    HTt[e.getMonth()],
                    t
                ].join(" ");
            }
            Nl.log = function() {
                console.log("%s - %s", GTt(), Nl.format.apply(Nl, arguments));
            };
            Nl.inherits = Uy();
            Nl._extend = function(e, t) {
                if (!t || !o5(t)) return e;
                for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                return e;
            };
            function P5e(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
            }
            var h2 = typeof Symbol != "undefined" ? Symbol("util.promisify.custom") : void 0;
            Nl.promisify = function(t) {
                if (typeof t != "function") throw new TypeError('The "original" argument must be of type Function');
                if (h2 && t[h2]) {
                    var r = t[h2];
                    if (typeof r != "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                    return Object.defineProperty(r, h2, {
                        value: r,
                        enumerable: !1,
                        writable: !1,
                        configurable: !0
                    }), r;
                }
                function r() {
                    for(var n, i, a = new Promise(function(l, u) {
                        n = l, i = u;
                    }), o = [], s = 0; s < arguments.length; s++)o.push(arguments[s]);
                    o.push(function(l, u) {
                        l ? i(l) : n(u);
                    });
                    try {
                        t.apply(this, o);
                    } catch (l) {
                        i(l);
                    }
                    return a;
                }
                return Object.setPrototypeOf(r, Object.getPrototypeOf(t)), h2 && Object.defineProperty(r, h2, {
                    value: r,
                    enumerable: !1,
                    writable: !1,
                    configurable: !0
                }), Object.defineProperties(r, E5e(t));
            };
            Nl.promisify.custom = h2;
            function jTt(e, t) {
                if (!e) {
                    var r = new Error("Promise was rejected with a falsy value");
                    r.reason = e, e = r;
                }
                return t(e);
            }
            function WTt(e) {
                if (typeof e != "function") throw new TypeError('The "original" argument must be of type Function');
                function t() {
                    for(var r = [], n = 0; n < arguments.length; n++)r.push(arguments[n]);
                    var i = r.pop();
                    if (typeof i != "function") throw new TypeError("The last argument must be of type Function");
                    var a = this, o = function() {
                        return i.apply(a, arguments);
                    };
                    e.apply(this, r).then(function(s) {
                        $d3c1734dacb01657$exports.nextTick(o.bind(null, null, s));
                    }, function(s) {
                        $d3c1734dacb01657$exports.nextTick(jTt.bind(null, s, o));
                    });
                }
                return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, E5e(e)), t;
            }
            Nl.callbackify = WTt;
        });
        var z5e = ye((Jur, D5e)=>{
            "use strict";
            function I5e(e, t) {
                var r = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(e);
                    t && (n = n.filter(function(i) {
                        return Object.getOwnPropertyDescriptor(e, i).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function ZTt(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t] != null ? arguments[t] : {};
                    t % 2 ? I5e(Object(r), !0).forEach(function(n) {
                        XTt(e, n, r[n]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : I5e(Object(r)).forEach(function(n) {
                        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
                    });
                }
                return e;
            }
            function XTt(e, t, r) {
                return t in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r, e;
            }
            function YTt(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function R5e(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            function KTt(e, t, r) {
                return t && R5e(e.prototype, t), r && R5e(e, r), e;
            }
            var JTt = u2(), dR = JTt.Buffer, $Tt = jG(), WG = $Tt.inspect, QTt = WG && WG.custom || "inspect";
            function e5t(e, t, r) {
                dR.prototype.copy.call(e, t, r);
            }
            D5e.exports = function() {
                function e() {
                    YTt(this, e), this.head = null, this.tail = null, this.length = 0;
                }
                return KTt(e, [
                    {
                        key: "push",
                        value: function(r) {
                            var n = {
                                data: r,
                                next: null
                            };
                            this.length > 0 ? this.tail.next = n : this.head = n, this.tail = n, ++this.length;
                        }
                    },
                    {
                        key: "unshift",
                        value: function(r) {
                            var n = {
                                data: r,
                                next: this.head
                            };
                            this.length === 0 && (this.tail = n), this.head = n, ++this.length;
                        }
                    },
                    {
                        key: "shift",
                        value: function() {
                            if (this.length !== 0) {
                                var r = this.head.data;
                                return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, r;
                            }
                        }
                    },
                    {
                        key: "clear",
                        value: function() {
                            this.head = this.tail = null, this.length = 0;
                        }
                    },
                    {
                        key: "join",
                        value: function(r) {
                            if (this.length === 0) return "";
                            for(var n = this.head, i = "" + n.data; n = n.next;)i += r + n.data;
                            return i;
                        }
                    },
                    {
                        key: "concat",
                        value: function(r) {
                            if (this.length === 0) return dR.alloc(0);
                            for(var n = dR.allocUnsafe(r >>> 0), i = this.head, a = 0; i;)e5t(i.data, n, a), a += i.data.length, i = i.next;
                            return n;
                        }
                    },
                    {
                        key: "consume",
                        value: function(r, n) {
                            var i;
                            return r < this.head.data.length ? (i = this.head.data.slice(0, r), this.head.data = this.head.data.slice(r)) : r === this.head.data.length ? i = this.shift() : i = n ? this._getString(r) : this._getBuffer(r), i;
                        }
                    },
                    {
                        key: "first",
                        value: function() {
                            return this.head.data;
                        }
                    },
                    {
                        key: "_getString",
                        value: function(r) {
                            var n = this.head, i = 1, a = n.data;
                            for(r -= a.length; n = n.next;){
                                var o = n.data, s = r > o.length ? o.length : r;
                                if (s === o.length ? a += o : a += o.slice(0, r), r -= s, r === 0) {
                                    s === o.length ? (++i, n.next ? this.head = n.next : this.head = this.tail = null) : (this.head = n, n.data = o.slice(s));
                                    break;
                                }
                                ++i;
                            }
                            return this.length -= i, a;
                        }
                    },
                    {
                        key: "_getBuffer",
                        value: function(r) {
                            var n = dR.allocUnsafe(r), i = this.head, a = 1;
                            for(i.data.copy(n), r -= i.data.length; i = i.next;){
                                var o = i.data, s = r > o.length ? o.length : r;
                                if (o.copy(n, n.length - r, 0, s), r -= s, r === 0) {
                                    s === o.length ? (++a, i.next ? this.head = i.next : this.head = this.tail = null) : (this.head = i, i.data = o.slice(s));
                                    break;
                                }
                                ++a;
                            }
                            return this.length -= a, n;
                        }
                    },
                    {
                        key: QTt,
                        value: function(r, n) {
                            return WG(this, ZTt({}, n, {
                                depth: 0,
                                customInspect: !1
                            }));
                        }
                    }
                ]), e;
            }();
        });
        var XG = ye(($ur, q5e)=>{
            "use strict";
            function t5t(e, t) {
                var r = this, n = this._readableState && this._readableState.destroyed, i = this._writableState && this._writableState.destroyed;
                return n || i ? (t ? t(e) : e && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, $d3c1734dacb01657$exports.nextTick(ZG, this, e)) : $d3c1734dacb01657$exports.nextTick(ZG, this, e)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(e || null, function(a) {
                    !t && a ? r._writableState ? r._writableState.errorEmitted ? $d3c1734dacb01657$exports.nextTick(vR, r) : (r._writableState.errorEmitted = !0, $d3c1734dacb01657$exports.nextTick(F5e, r, a)) : $d3c1734dacb01657$exports.nextTick(F5e, r, a) : t ? ($d3c1734dacb01657$exports.nextTick(vR, r), t(a)) : $d3c1734dacb01657$exports.nextTick(vR, r);
                }), this);
            }
            function F5e(e, t) {
                ZG(e, t), vR(e);
            }
            function vR(e) {
                e._writableState && !e._writableState.emitClose || e._readableState && !e._readableState.emitClose || e.emit("close");
            }
            function r5t() {
                this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
            }
            function ZG(e, t) {
                e.emit("error", t);
            }
            function i5t(e, t) {
                var r = e._readableState, n = e._writableState;
                r && r.autoDestroy || n && n.autoDestroy ? e.destroy(t) : e.emit("error", t);
            }
            q5e.exports = {
                destroy: t5t,
                undestroy: r5t,
                errorOrDestroy: i5t
            };
        });
        var v2 = ye((Qur, N5e)=>{
            "use strict";
            function n5t(e, t) {
                e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
            }
            var B5e = {};
            function Y0(e, t, r) {
                r || (r = Error);
                function n(a, o, s) {
                    return typeof t == "string" ? t : t(a, o, s);
                }
                var i = function(a) {
                    n5t(o, a);
                    function o(s, l, u) {
                        return a.call(this, n(s, l, u)) || this;
                    }
                    return o;
                }(r);
                i.prototype.name = r.name, i.prototype.code = e, B5e[e] = i;
            }
            function O5e(e, t) {
                if (Array.isArray(e)) {
                    var r = e.length;
                    return e = e.map(function(n) {
                        return String(n);
                    }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : r === 2 ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                } else return "of ".concat(t, " ").concat(String(e));
            }
            function a5t(e, t, r) {
                return e.substr(!r || r < 0 ? 0 : +r, t.length) === t;
            }
            function o5t(e, t, r) {
                return (r === void 0 || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
            }
            function s5t(e, t, r) {
                return typeof r != "number" && (r = 0), r + t.length > e.length ? !1 : e.indexOf(t, r) !== -1;
            }
            Y0("ERR_INVALID_OPT_VALUE", function(e, t) {
                return 'The value "' + t + '" is invalid for option "' + e + '"';
            }, TypeError);
            Y0("ERR_INVALID_ARG_TYPE", function(e, t, r) {
                var n;
                typeof t == "string" && a5t(t, "not ") ? (n = "must not be", t = t.replace(/^not /, "")) : n = "must be";
                var i;
                if (o5t(e, " argument")) i = "The ".concat(e, " ").concat(n, " ").concat(O5e(t, "type"));
                else {
                    var a = s5t(e, ".") ? "property" : "argument";
                    i = 'The "'.concat(e, '" ').concat(a, " ").concat(n, " ").concat(O5e(t, "type"));
                }
                return i += ". Received type ".concat(typeof r), i;
            }, TypeError);
            Y0("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
            Y0("ERR_METHOD_NOT_IMPLEMENTED", function(e) {
                return "The " + e + " method is not implemented";
            });
            Y0("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
            Y0("ERR_STREAM_DESTROYED", function(e) {
                return "Cannot call " + e + " after a stream was destroyed";
            });
            Y0("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
            Y0("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
            Y0("ERR_STREAM_WRITE_AFTER_END", "write after end");
            Y0("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
            Y0("ERR_UNKNOWN_ENCODING", function(e) {
                return "Unknown encoding: " + e;
            }, TypeError);
            Y0("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
            N5e.exports.codes = B5e;
        });
        var YG = ye((ecr, U5e)=>{
            "use strict";
            var l5t = v2().codes.ERR_INVALID_OPT_VALUE;
            function u5t(e, t, r) {
                return e.highWaterMark != null ? e.highWaterMark : t ? e[r] : null;
            }
            function c5t(e, t, r, n) {
                var i = u5t(t, n, r);
                if (i != null) {
                    if (!(isFinite(i) && Math.floor(i) === i) || i < 0) {
                        var a = n ? r : "highWaterMark";
                        throw new l5t(a, i);
                    }
                    return Math.floor(i);
                }
                return e.objectMode ? 16 : 16384;
            }
            U5e.exports = {
                getHighWaterMark: c5t
            };
        });
        var H5e = ye((tcr, V5e)=>{
            V5e.exports = f5t;
            function f5t(e, t) {
                if (KG("noDeprecation")) return e;
                var r = !1;
                function n() {
                    if (!r) {
                        if (KG("throwDeprecation")) throw new Error(t);
                        KG("traceDeprecation") ? console.trace(t) : console.warn(t), r = !0;
                    }
                    return e.apply(this, arguments);
                }
                return n;
            }
            function KG(e) {
                try {
                    if (!window.localStorage) return !1;
                } catch (r) {
                    return !1;
                }
                var t = window.localStorage[e];
                return t == null ? !1 : String(t).toLowerCase() === "true";
            }
        });
        var QG = ye((rcr, Y5e)=>{
            "use strict";
            Y5e.exports = _h;
            function j5e(e) {
                var t = this;
                this.next = null, this.entry = null, this.finish = function() {
                    O5t(t, e);
                };
            }
            var s5;
            _h.WritableState = W4;
            var h5t = {
                deprecate: H5e()
            }, W5e = iG(), gR = u2().Buffer, d5t = window.Uint8Array || function() {};
            function v5t(e) {
                return gR.from(e);
            }
            function p5t(e) {
                return gR.isBuffer(e) || e instanceof d5t;
            }
            var $G = XG(), g5t = YG(), m5t = g5t.getHighWaterMark, D_ = v2().codes, y5t = D_.ERR_INVALID_ARG_TYPE, _5t = D_.ERR_METHOD_NOT_IMPLEMENTED, x5t = D_.ERR_MULTIPLE_CALLBACK, b5t = D_.ERR_STREAM_CANNOT_PIPE, w5t = D_.ERR_STREAM_DESTROYED, T5t = D_.ERR_STREAM_NULL_VALUES, A5t = D_.ERR_STREAM_WRITE_AFTER_END, S5t = D_.ERR_UNKNOWN_ENCODING, l5 = $G.errorOrDestroy;
            Uy()(_h, W5e);
            function M5t() {}
            function W4(e, t, r) {
                s5 = s5 || p2(), e = e || {}, typeof r != "boolean" && (r = t instanceof s5), this.objectMode = !!e.objectMode, r && (this.objectMode = this.objectMode || !!e.writableObjectMode), this.highWaterMark = m5t(this, e, "writableHighWaterMark", r), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
                var n = e.decodeStrings === !1;
                this.decodeStrings = !n, this.defaultEncoding = e.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(i) {
                    R5t(t, i);
                }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = e.emitClose !== !1, this.autoDestroy = !!e.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new j5e(this);
            }
            W4.prototype.getBuffer = function() {
                for(var t = this.bufferedRequest, r = []; t;)r.push(t), t = t.next;
                return r;
            };
            (function() {
                try {
                    Object.defineProperty(W4.prototype, "buffer", {
                        get: h5t.deprecate(function() {
                            return this.getBuffer();
                        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
                    });
                } catch (e) {}
            })();
            var pR;
            typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (pR = Function.prototype[Symbol.hasInstance], Object.defineProperty(_h, Symbol.hasInstance, {
                value: function(t) {
                    return pR.call(this, t) ? !0 : this !== _h ? !1 : t && t._writableState instanceof W4;
                }
            })) : pR = function(t) {
                return t instanceof this;
            };
            function _h(e) {
                s5 = s5 || p2();
                var t = this instanceof s5;
                if (!t && !pR.call(_h, this)) return new _h(e);
                this._writableState = new W4(e, this, t), this.writable = !0, e && (typeof e.write == "function" && (this._write = e.write), typeof e.writev == "function" && (this._writev = e.writev), typeof e.destroy == "function" && (this._destroy = e.destroy), typeof e.final == "function" && (this._final = e.final)), W5e.call(this);
            }
            _h.prototype.pipe = function() {
                l5(this, new b5t);
            };
            function E5t(e, t) {
                var r = new A5t;
                l5(e, r), $d3c1734dacb01657$exports.nextTick(t, r);
            }
            function k5t(e, t, r, n) {
                var i;
                return r === null ? i = new T5t : typeof r != "string" && !t.objectMode && (i = new y5t("chunk", [
                    "string",
                    "Buffer"
                ], r)), i ? (l5(e, i), $d3c1734dacb01657$exports.nextTick(n, i), !1) : !0;
            }
            _h.prototype.write = function(e, t, r) {
                var n = this._writableState, i = !1, a = !n.objectMode && p5t(e);
                return a && !gR.isBuffer(e) && (e = v5t(e)), typeof t == "function" && (r = t, t = null), a ? t = "buffer" : t || (t = n.defaultEncoding), typeof r != "function" && (r = M5t), n.ending ? E5t(this, r) : (a || k5t(this, n, e, r)) && (n.pendingcb++, i = L5t(this, n, a, e, t, r)), i;
            };
            _h.prototype.cork = function() {
                this._writableState.corked++;
            };
            _h.prototype.uncork = function() {
                var e = this._writableState;
                e.corked && (e.corked--, !e.writing && !e.corked && !e.bufferProcessing && e.bufferedRequest && Z5e(this, e));
            };
            _h.prototype.setDefaultEncoding = function(t) {
                if (typeof t == "string" && (t = t.toLowerCase()), !([
                    "hex",
                    "utf8",
                    "utf-8",
                    "ascii",
                    "binary",
                    "base64",
                    "ucs2",
                    "ucs-2",
                    "utf16le",
                    "utf-16le",
                    "raw"
                ].indexOf((t + "").toLowerCase()) > -1)) throw new S5t(t);
                return this._writableState.defaultEncoding = t, this;
            };
            Object.defineProperty(_h.prototype, "writableBuffer", {
                enumerable: !1,
                get: function() {
                    return this._writableState && this._writableState.getBuffer();
                }
            });
            function C5t(e, t, r) {
                return !e.objectMode && e.decodeStrings !== !1 && typeof t == "string" && (t = gR.from(t, r)), t;
            }
            Object.defineProperty(_h.prototype, "writableHighWaterMark", {
                enumerable: !1,
                get: function() {
                    return this._writableState.highWaterMark;
                }
            });
            function L5t(e, t, r, n, i, a) {
                if (!r) {
                    var o = C5t(t, n, i);
                    n !== o && (r = !0, i = "buffer", n = o);
                }
                var s = t.objectMode ? 1 : n.length;
                t.length += s;
                var l = t.length < t.highWaterMark;
                if (l || (t.needDrain = !0), t.writing || t.corked) {
                    var u = t.lastBufferedRequest;
                    t.lastBufferedRequest = {
                        chunk: n,
                        encoding: i,
                        isBuf: r,
                        callback: a,
                        next: null
                    }, u ? u.next = t.lastBufferedRequest : t.bufferedRequest = t.lastBufferedRequest, t.bufferedRequestCount += 1;
                } else JG(e, t, !1, s, n, i, a);
                return l;
            }
            function JG(e, t, r, n, i, a, o) {
                t.writelen = n, t.writecb = o, t.writing = !0, t.sync = !0, t.destroyed ? t.onwrite(new w5t("write")) : r ? e._writev(i, t.onwrite) : e._write(i, a, t.onwrite), t.sync = !1;
            }
            function P5t(e, t, r, n, i) {
                --t.pendingcb, r ? ($d3c1734dacb01657$exports.nextTick(i, n), $d3c1734dacb01657$exports.nextTick(j4, e, t), e._writableState.errorEmitted = !0, l5(e, n)) : (i(n), e._writableState.errorEmitted = !0, l5(e, n), j4(e, t));
            }
            function I5t(e) {
                e.writing = !1, e.writecb = null, e.length -= e.writelen, e.writelen = 0;
            }
            function R5t(e, t) {
                var r = e._writableState, n = r.sync, i = r.writecb;
                if (typeof i != "function") throw new x5t;
                if (I5t(r), t) P5t(e, r, n, t, i);
                else {
                    var a = X5e(r) || e.destroyed;
                    !a && !r.corked && !r.bufferProcessing && r.bufferedRequest && Z5e(e, r), n ? $d3c1734dacb01657$exports.nextTick(G5e, e, r, a, i) : G5e(e, r, a, i);
                }
            }
            function G5e(e, t, r, n) {
                r || D5t(e, t), t.pendingcb--, n(), j4(e, t);
            }
            function D5t(e, t) {
                t.length === 0 && t.needDrain && (t.needDrain = !1, e.emit("drain"));
            }
            function Z5e(e, t) {
                t.bufferProcessing = !0;
                var r = t.bufferedRequest;
                if (e._writev && r && r.next) {
                    var n = t.bufferedRequestCount, i = new Array(n), a = t.corkedRequestsFree;
                    a.entry = r;
                    for(var o = 0, s = !0; r;)i[o] = r, r.isBuf || (s = !1), r = r.next, o += 1;
                    i.allBuffers = s, JG(e, t, !0, t.length, i, "", a.finish), t.pendingcb++, t.lastBufferedRequest = null, a.next ? (t.corkedRequestsFree = a.next, a.next = null) : t.corkedRequestsFree = new j5e(t), t.bufferedRequestCount = 0;
                } else {
                    for(; r;){
                        var l = r.chunk, u = r.encoding, c = r.callback, f = t.objectMode ? 1 : l.length;
                        if (JG(e, t, !1, f, l, u, c), r = r.next, t.bufferedRequestCount--, t.writing) break;
                    }
                    r === null && (t.lastBufferedRequest = null);
                }
                t.bufferedRequest = r, t.bufferProcessing = !1;
            }
            _h.prototype._write = function(e, t, r) {
                r(new _5t("_write()"));
            };
            _h.prototype._writev = null;
            _h.prototype.end = function(e, t, r) {
                var n = this._writableState;
                return typeof e == "function" ? (r = e, e = null, t = null) : typeof t == "function" && (r = t, t = null), e != null && this.write(e, t), n.corked && (n.corked = 1, this.uncork()), n.ending || q5t(this, n, r), this;
            };
            Object.defineProperty(_h.prototype, "writableLength", {
                enumerable: !1,
                get: function() {
                    return this._writableState.length;
                }
            });
            function X5e(e) {
                return e.ending && e.length === 0 && e.bufferedRequest === null && !e.finished && !e.writing;
            }
            function z5t(e, t) {
                e._final(function(r) {
                    t.pendingcb--, r && l5(e, r), t.prefinished = !0, e.emit("prefinish"), j4(e, t);
                });
            }
            function F5t(e, t) {
                !t.prefinished && !t.finalCalled && (typeof e._final == "function" && !t.destroyed ? (t.pendingcb++, t.finalCalled = !0, $d3c1734dacb01657$exports.nextTick(z5t, e, t)) : (t.prefinished = !0, e.emit("prefinish")));
            }
            function j4(e, t) {
                var r = X5e(t);
                if (r && (F5t(e, t), t.pendingcb === 0 && (t.finished = !0, e.emit("finish"), t.autoDestroy))) {
                    var n = e._readableState;
                    (!n || n.autoDestroy && n.endEmitted) && e.destroy();
                }
                return r;
            }
            function q5t(e, t, r) {
                t.ending = !0, j4(e, t), r && (t.finished ? $d3c1734dacb01657$exports.nextTick(r) : e.once("finish", r)), t.ended = !0, e.writable = !1;
            }
            function O5t(e, t, r) {
                var n = e.entry;
                for(e.entry = null; n;){
                    var i = n.callback;
                    t.pendingcb--, i(r), n = n.next;
                }
                t.corkedRequestsFree.next = e;
            }
            Object.defineProperty(_h.prototype, "destroyed", {
                enumerable: !1,
                get: function() {
                    return this._writableState === void 0 ? !1 : this._writableState.destroyed;
                },
                set: function(t) {
                    this._writableState && (this._writableState.destroyed = t);
                }
            });
            _h.prototype.destroy = $G.destroy;
            _h.prototype._undestroy = $G.undestroy;
            _h.prototype._destroy = function(e, t) {
                t(e);
            };
        });
        var p2 = ye((icr, J5e)=>{
            "use strict";
            var B5t = Object.keys || function(e) {
                var t = [];
                for(var r in e)t.push(r);
                return t;
            };
            J5e.exports = Om;
            var K5e = rj(), tj = QG();
            Uy()(Om, K5e);
            for(ej = B5t(tj.prototype), mR = 0; mR < ej.length; mR++)yR = ej[mR], Om.prototype[yR] || (Om.prototype[yR] = tj.prototype[yR]);
            var ej, yR, mR;
            function Om(e) {
                if (!(this instanceof Om)) return new Om(e);
                K5e.call(this, e), tj.call(this, e), this.allowHalfOpen = !0, e && (e.readable === !1 && (this.readable = !1), e.writable === !1 && (this.writable = !1), e.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", N5t)));
            }
            Object.defineProperty(Om.prototype, "writableHighWaterMark", {
                enumerable: !1,
                get: function() {
                    return this._writableState.highWaterMark;
                }
            });
            Object.defineProperty(Om.prototype, "writableBuffer", {
                enumerable: !1,
                get: function() {
                    return this._writableState && this._writableState.getBuffer();
                }
            });
            Object.defineProperty(Om.prototype, "writableLength", {
                enumerable: !1,
                get: function() {
                    return this._writableState.length;
                }
            });
            function N5t() {
                this._writableState.ended || $d3c1734dacb01657$exports.nextTick(U5t, this);
            }
            function U5t(e) {
                e.end();
            }
            Object.defineProperty(Om.prototype, "destroyed", {
                enumerable: !1,
                get: function() {
                    return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
                },
                set: function(t) {
                    this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = t, this._writableState.destroyed = t);
                }
            });
        });
        var eAe = ye((ij, Q5e)=>{
            var _R = u2(), Bm = _R.Buffer;
            function $5e(e, t) {
                for(var r in e)t[r] = e[r];
            }
            Bm.from && Bm.alloc && Bm.allocUnsafe && Bm.allocUnsafeSlow ? Q5e.exports = _R : ($5e(_R, ij), ij.Buffer = g2);
            function g2(e, t, r) {
                return Bm(e, t, r);
            }
            g2.prototype = Object.create(Bm.prototype);
            $5e(Bm, g2);
            g2.from = function(e, t, r) {
                if (typeof e == "number") throw new TypeError("Argument must not be a number");
                return Bm(e, t, r);
            };
            g2.alloc = function(e, t, r) {
                if (typeof e != "number") throw new TypeError("Argument must be a number");
                var n = Bm(e);
                return t !== void 0 ? typeof r == "string" ? n.fill(t, r) : n.fill(t) : n.fill(0), n;
            };
            g2.allocUnsafe = function(e) {
                if (typeof e != "number") throw new TypeError("Argument must be a number");
                return Bm(e);
            };
            g2.allocUnsafeSlow = function(e) {
                if (typeof e != "number") throw new TypeError("Argument must be a number");
                return _R.SlowBuffer(e);
            };
        });
        var oj = ye((rAe)=>{
            "use strict";
            var aj = eAe().Buffer, tAe = aj.isEncoding || function(e) {
                switch(e = "" + e, e && e.toLowerCase()){
                    case "hex":
                    case "utf8":
                    case "utf-8":
                    case "ascii":
                    case "binary":
                    case "base64":
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                    case "raw":
                        return !0;
                    default:
                        return !1;
                }
            };
            function V5t(e) {
                if (!e) return "utf8";
                for(var t;;)switch(e){
                    case "utf8":
                    case "utf-8":
                        return "utf8";
                    case "ucs2":
                    case "ucs-2":
                    case "utf16le":
                    case "utf-16le":
                        return "utf16le";
                    case "latin1":
                    case "binary":
                        return "latin1";
                    case "base64":
                    case "ascii":
                    case "hex":
                        return e;
                    default:
                        if (t) return;
                        e = ("" + e).toLowerCase(), t = !0;
                }
            }
            function H5t(e) {
                var t = V5t(e);
                if (typeof t != "string" && (aj.isEncoding === tAe || !tAe(e))) throw new Error("Unknown encoding: " + e);
                return t || e;
            }
            rAe.StringDecoder = Z4;
            function Z4(e) {
                this.encoding = H5t(e);
                var t;
                switch(this.encoding){
                    case "utf16le":
                        this.text = Y5t, this.end = K5t, t = 4;
                        break;
                    case "utf8":
                        this.fillLast = W5t, t = 4;
                        break;
                    case "base64":
                        this.text = J5t, this.end = $5t, t = 3;
                        break;
                    default:
                        this.write = Q5t, this.end = eAt;
                        return;
                }
                this.lastNeed = 0, this.lastTotal = 0, this.lastChar = aj.allocUnsafe(t);
            }
            Z4.prototype.write = function(e) {
                if (e.length === 0) return "";
                var t, r;
                if (this.lastNeed) {
                    if (t = this.fillLast(e), t === void 0) return "";
                    r = this.lastNeed, this.lastNeed = 0;
                } else r = 0;
                return r < e.length ? t ? t + this.text(e, r) : this.text(e, r) : t || "";
            };
            Z4.prototype.end = X5t;
            Z4.prototype.text = Z5t;
            Z4.prototype.fillLast = function(e) {
                if (this.lastNeed <= e.length) return e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                e.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, e.length), this.lastNeed -= e.length;
            };
            function nj(e) {
                return e <= 127 ? 0 : e >> 5 === 6 ? 2 : e >> 4 === 14 ? 3 : e >> 3 === 30 ? 4 : e >> 6 === 2 ? -1 : -2;
            }
            function G5t(e, t, r) {
                var n = t.length - 1;
                if (n < r) return 0;
                var i = nj(t[n]);
                return i >= 0 ? (i > 0 && (e.lastNeed = i - 1), i) : --n < r || i === -2 ? 0 : (i = nj(t[n]), i >= 0 ? (i > 0 && (e.lastNeed = i - 2), i) : --n < r || i === -2 ? 0 : (i = nj(t[n]), i >= 0 ? (i > 0 && (i === 2 ? i = 0 : e.lastNeed = i - 3), i) : 0));
            }
            function j5t(e, t, r) {
                if ((t[0] & 192) !== 128) return e.lastNeed = 0, "\uFFFD";
                if (e.lastNeed > 1 && t.length > 1) {
                    if ((t[1] & 192) !== 128) return e.lastNeed = 1, "\uFFFD";
                    if (e.lastNeed > 2 && t.length > 2 && (t[2] & 192) !== 128) return e.lastNeed = 2, "\uFFFD";
                }
            }
            function W5t(e) {
                var t = this.lastTotal - this.lastNeed, r = j5t(this, e, t);
                if (r !== void 0) return r;
                if (this.lastNeed <= e.length) return e.copy(this.lastChar, t, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
                e.copy(this.lastChar, t, 0, e.length), this.lastNeed -= e.length;
            }
            function Z5t(e, t) {
                var r = G5t(this, e, t);
                if (!this.lastNeed) return e.toString("utf8", t);
                this.lastTotal = r;
                var n = e.length - (r - this.lastNeed);
                return e.copy(this.lastChar, 0, n), e.toString("utf8", t, n);
            }
            function X5t(e) {
                var t = e && e.length ? this.write(e) : "";
                return this.lastNeed ? t + "\uFFFD" : t;
            }
            function Y5t(e, t) {
                if ((e.length - t) % 2 === 0) {
                    var r = e.toString("utf16le", t);
                    if (r) {
                        var n = r.charCodeAt(r.length - 1);
                        if (n >= 55296 && n <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1], r.slice(0, -1);
                    }
                    return r;
                }
                return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = e[e.length - 1], e.toString("utf16le", t, e.length - 1);
            }
            function K5t(e) {
                var t = e && e.length ? this.write(e) : "";
                if (this.lastNeed) {
                    var r = this.lastTotal - this.lastNeed;
                    return t + this.lastChar.toString("utf16le", 0, r);
                }
                return t;
            }
            function J5t(e, t) {
                var r = (e.length - t) % 3;
                return r === 0 ? e.toString("base64", t) : (this.lastNeed = 3 - r, this.lastTotal = 3, r === 1 ? this.lastChar[0] = e[e.length - 1] : (this.lastChar[0] = e[e.length - 2], this.lastChar[1] = e[e.length - 1]), e.toString("base64", t, e.length - r));
            }
            function $5t(e) {
                var t = e && e.length ? this.write(e) : "";
                return this.lastNeed ? t + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : t;
            }
            function Q5t(e) {
                return e.toString(this.encoding);
            }
            function eAt(e) {
                return e && e.length ? this.write(e) : "";
            }
        });
        var xR = ye((acr, aAe)=>{
            "use strict";
            var iAe = v2().codes.ERR_STREAM_PREMATURE_CLOSE;
            function tAt(e) {
                var t = !1;
                return function() {
                    if (!t) {
                        t = !0;
                        for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                        e.apply(this, n);
                    }
                };
            }
            function rAt() {}
            function iAt(e) {
                return e.setHeader && typeof e.abort == "function";
            }
            function nAe(e, t, r) {
                if (typeof t == "function") return nAe(e, null, t);
                t || (t = {}), r = tAt(r || rAt);
                var n = t.readable || t.readable !== !1 && e.readable, i = t.writable || t.writable !== !1 && e.writable, a = function() {
                    e.writable || s();
                }, o = e._writableState && e._writableState.finished, s = function() {
                    i = !1, o = !0, n || r.call(e);
                }, l = e._readableState && e._readableState.endEmitted, u = function() {
                    n = !1, l = !0, i || r.call(e);
                }, c = function(v) {
                    r.call(e, v);
                }, f = function() {
                    var v;
                    if (n && !l) return (!e._readableState || !e._readableState.ended) && (v = new iAe), r.call(e, v);
                    if (i && !o) return (!e._writableState || !e._writableState.ended) && (v = new iAe), r.call(e, v);
                }, h = function() {
                    e.req.on("finish", s);
                };
                return iAt(e) ? (e.on("complete", s), e.on("abort", f), e.req ? h() : e.on("request", h)) : i && !e._writableState && (e.on("end", a), e.on("close", a)), e.on("end", u), e.on("finish", s), t.error !== !1 && e.on("error", c), e.on("close", f), function() {
                    e.removeListener("complete", s), e.removeListener("abort", f), e.removeListener("request", h), e.req && e.req.removeListener("finish", s), e.removeListener("end", a), e.removeListener("close", a), e.removeListener("finish", s), e.removeListener("end", u), e.removeListener("error", c), e.removeListener("close", f);
                };
            }
            aAe.exports = nAe;
        });
        var sAe = ye((ocr, oAe)=>{
            "use strict";
            var bR;
            function z_(e, t, r) {
                return t in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r, e;
            }
            var nAt = xR(), F_ = Symbol("lastResolve"), m2 = Symbol("lastReject"), X4 = Symbol("error"), wR = Symbol("ended"), y2 = Symbol("lastPromise"), sj = Symbol("handlePromise"), _2 = Symbol("stream");
            function q_(e, t) {
                return {
                    value: e,
                    done: t
                };
            }
            function aAt(e) {
                var t = e[F_];
                if (t !== null) {
                    var r = e[_2].read();
                    r !== null && (e[y2] = null, e[F_] = null, e[m2] = null, t(q_(r, !1)));
                }
            }
            function oAt(e) {
                $d3c1734dacb01657$exports.nextTick(aAt, e);
            }
            function sAt(e, t) {
                return function(r, n) {
                    e.then(function() {
                        if (t[wR]) {
                            r(q_(void 0, !0));
                            return;
                        }
                        t[sj](r, n);
                    }, n);
                };
            }
            var lAt = Object.getPrototypeOf(function() {}), uAt = Object.setPrototypeOf((bR = {
                get stream () {
                    return this[_2];
                },
                next: function() {
                    var t = this, r = this[X4];
                    if (r !== null) return Promise.reject(r);
                    if (this[wR]) return Promise.resolve(q_(void 0, !0));
                    if (this[_2].destroyed) return new Promise(function(o, s) {
                        $d3c1734dacb01657$exports.nextTick(function() {
                            t[X4] ? s(t[X4]) : o(q_(void 0, !0));
                        });
                    });
                    var n = this[y2], i;
                    if (n) i = new Promise(sAt(n, this));
                    else {
                        var a = this[_2].read();
                        if (a !== null) return Promise.resolve(q_(a, !1));
                        i = new Promise(this[sj]);
                    }
                    return this[y2] = i, i;
                }
            }, z_(bR, Symbol.asyncIterator, function() {
                return this;
            }), z_(bR, "return", function() {
                var t = this;
                return new Promise(function(r, n) {
                    t[_2].destroy(null, function(i) {
                        if (i) {
                            n(i);
                            return;
                        }
                        r(q_(void 0, !0));
                    });
                });
            }), bR), lAt), cAt = function(t) {
                var r, n = Object.create(uAt, (r = {}, z_(r, _2, {
                    value: t,
                    writable: !0
                }), z_(r, F_, {
                    value: null,
                    writable: !0
                }), z_(r, m2, {
                    value: null,
                    writable: !0
                }), z_(r, X4, {
                    value: null,
                    writable: !0
                }), z_(r, wR, {
                    value: t._readableState.endEmitted,
                    writable: !0
                }), z_(r, sj, {
                    value: function(a, o) {
                        var s = n[_2].read();
                        s ? (n[y2] = null, n[F_] = null, n[m2] = null, a(q_(s, !1))) : (n[F_] = a, n[m2] = o);
                    },
                    writable: !0
                }), r));
                return n[y2] = null, nAt(t, function(i) {
                    if (i && i.code !== "ERR_STREAM_PREMATURE_CLOSE") {
                        var a = n[m2];
                        a !== null && (n[y2] = null, n[F_] = null, n[m2] = null, a(i)), n[X4] = i;
                        return;
                    }
                    var o = n[F_];
                    o !== null && (n[y2] = null, n[F_] = null, n[m2] = null, o(q_(void 0, !0))), n[wR] = !0;
                }), t.on("readable", oAt.bind(null, n)), n;
            };
            oAe.exports = cAt;
        });
        var uAe = ye((scr, lAe)=>{
            lAe.exports = function() {
                throw new Error("Readable.from is not available in the browser");
            };
        });
        var rj = ye((ucr, _Ae)=>{
            "use strict";
            _Ae.exports = vu;
            var u5;
            vu.ReadableState = dAe;
            var lcr = vb().EventEmitter, hAe = function(t, r) {
                return t.listeners(r).length;
            }, K4 = iG(), TR = u2().Buffer, fAt = window.Uint8Array || function() {};
            function hAt(e) {
                return TR.from(e);
            }
            function dAt(e) {
                return TR.isBuffer(e) || e instanceof fAt;
            }
            var lj = jG(), Il;
            lj && lj.debuglog ? Il = lj.debuglog("stream") : Il = function() {};
            var vAt = z5e(), pj = XG(), pAt = YG(), gAt = pAt.getHighWaterMark, AR = v2().codes, mAt = AR.ERR_INVALID_ARG_TYPE, yAt = AR.ERR_STREAM_PUSH_AFTER_EOF, _At = AR.ERR_METHOD_NOT_IMPLEMENTED, xAt = AR.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, c5, uj, cj;
            Uy()(vu, K4);
            var Y4 = pj.errorOrDestroy, fj = [
                "error",
                "close",
                "destroy",
                "pause",
                "resume"
            ];
            function bAt(e, t, r) {
                if (typeof e.prependListener == "function") return e.prependListener(t, r);
                !e._events || !e._events[t] ? e.on(t, r) : Array.isArray(e._events[t]) ? e._events[t].unshift(r) : e._events[t] = [
                    r,
                    e._events[t]
                ];
            }
            function dAe(e, t, r) {
                u5 = u5 || p2(), e = e || {}, typeof r != "boolean" && (r = t instanceof u5), this.objectMode = !!e.objectMode, r && (this.objectMode = this.objectMode || !!e.readableObjectMode), this.highWaterMark = gAt(this, e, "readableHighWaterMark", r), this.buffer = new vAt, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = e.emitClose !== !1, this.autoDestroy = !!e.autoDestroy, this.destroyed = !1, this.defaultEncoding = e.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, e.encoding && (c5 || (c5 = oj().StringDecoder), this.decoder = new c5(e.encoding), this.encoding = e.encoding);
            }
            function vu(e) {
                if (u5 = u5 || p2(), !(this instanceof vu)) return new vu(e);
                var t = this instanceof u5;
                this._readableState = new dAe(e, this, t), this.readable = !0, e && (typeof e.read == "function" && (this._read = e.read), typeof e.destroy == "function" && (this._destroy = e.destroy)), K4.call(this);
            }
            Object.defineProperty(vu.prototype, "destroyed", {
                enumerable: !1,
                get: function() {
                    return this._readableState === void 0 ? !1 : this._readableState.destroyed;
                },
                set: function(t) {
                    this._readableState && (this._readableState.destroyed = t);
                }
            });
            vu.prototype.destroy = pj.destroy;
            vu.prototype._undestroy = pj.undestroy;
            vu.prototype._destroy = function(e, t) {
                t(e);
            };
            vu.prototype.push = function(e, t) {
                var r = this._readableState, n;
                return r.objectMode ? n = !0 : typeof e == "string" && (t = t || r.defaultEncoding, t !== r.encoding && (e = TR.from(e, t), t = ""), n = !0), vAe(this, e, t, !1, n);
            };
            vu.prototype.unshift = function(e) {
                return vAe(this, e, null, !0, !1);
            };
            function vAe(e, t, r, n, i) {
                Il("readableAddChunk", t);
                var a = e._readableState;
                if (t === null) a.reading = !1, AAt(e, a);
                else {
                    var o;
                    if (i || (o = wAt(a, t)), o) Y4(e, o);
                    else if (a.objectMode || t && t.length > 0) {
                        if (typeof t != "string" && !a.objectMode && Object.getPrototypeOf(t) !== TR.prototype && (t = hAt(t)), n) a.endEmitted ? Y4(e, new xAt) : hj(e, a, t, !0);
                        else if (a.ended) Y4(e, new yAt);
                        else {
                            if (a.destroyed) return !1;
                            a.reading = !1, a.decoder && !r ? (t = a.decoder.write(t), a.objectMode || t.length !== 0 ? hj(e, a, t, !1) : vj(e, a)) : hj(e, a, t, !1);
                        }
                    } else n || (a.reading = !1, vj(e, a));
                }
                return !a.ended && (a.length < a.highWaterMark || a.length === 0);
            }
            function hj(e, t, r, n) {
                t.flowing && t.length === 0 && !t.sync ? (t.awaitDrain = 0, e.emit("data", r)) : (t.length += t.objectMode ? 1 : r.length, n ? t.buffer.unshift(r) : t.buffer.push(r), t.needReadable && SR(e)), vj(e, t);
            }
            function wAt(e, t) {
                var r;
                return !dAt(t) && typeof t != "string" && t !== void 0 && !e.objectMode && (r = new mAt("chunk", [
                    "string",
                    "Buffer",
                    "Uint8Array"
                ], t)), r;
            }
            vu.prototype.isPaused = function() {
                return this._readableState.flowing === !1;
            };
            vu.prototype.setEncoding = function(e) {
                c5 || (c5 = oj().StringDecoder);
                var t = new c5(e);
                this._readableState.decoder = t, this._readableState.encoding = this._readableState.decoder.encoding;
                for(var r = this._readableState.buffer.head, n = ""; r !== null;)n += t.write(r.data), r = r.next;
                return this._readableState.buffer.clear(), n !== "" && this._readableState.buffer.push(n), this._readableState.length = n.length, this;
            };
            var cAe = 1073741824;
            function TAt(e) {
                return e >= cAe ? e = cAe : (e--, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e++), e;
            }
            function fAe(e, t) {
                return e <= 0 || t.length === 0 && t.ended ? 0 : t.objectMode ? 1 : e !== e ? t.flowing && t.length ? t.buffer.head.data.length : t.length : (e > t.highWaterMark && (t.highWaterMark = TAt(e)), e <= t.length ? e : t.ended ? t.length : (t.needReadable = !0, 0));
            }
            vu.prototype.read = function(e) {
                Il("read", e), e = parseInt(e, 10);
                var t = this._readableState, r = e;
                if (e !== 0 && (t.emittedReadable = !1), e === 0 && t.needReadable && ((t.highWaterMark !== 0 ? t.length >= t.highWaterMark : t.length > 0) || t.ended)) return Il("read: emitReadable", t.length, t.ended), t.length === 0 && t.ended ? dj(this) : SR(this), null;
                if (e = fAe(e, t), e === 0 && t.ended) return t.length === 0 && dj(this), null;
                var n = t.needReadable;
                Il("need readable", n), (t.length === 0 || t.length - e < t.highWaterMark) && (n = !0, Il("length less than watermark", n)), t.ended || t.reading ? (n = !1, Il("reading or ended", n)) : n && (Il("do read"), t.reading = !0, t.sync = !0, t.length === 0 && (t.needReadable = !0), this._read(t.highWaterMark), t.sync = !1, t.reading || (e = fAe(r, t)));
                var i;
                return e > 0 ? i = mAe(e, t) : i = null, i === null ? (t.needReadable = t.length <= t.highWaterMark, e = 0) : (t.length -= e, t.awaitDrain = 0), t.length === 0 && (t.ended || (t.needReadable = !0), r !== e && t.ended && dj(this)), i !== null && this.emit("data", i), i;
            };
            function AAt(e, t) {
                if (Il("onEofChunk"), !t.ended) {
                    if (t.decoder) {
                        var r = t.decoder.end();
                        r && r.length && (t.buffer.push(r), t.length += t.objectMode ? 1 : r.length);
                    }
                    t.ended = !0, t.sync ? SR(e) : (t.needReadable = !1, t.emittedReadable || (t.emittedReadable = !0, pAe(e)));
                }
            }
            function SR(e) {
                var t = e._readableState;
                Il("emitReadable", t.needReadable, t.emittedReadable), t.needReadable = !1, t.emittedReadable || (Il("emitReadable", t.flowing), t.emittedReadable = !0, $d3c1734dacb01657$exports.nextTick(pAe, e));
            }
            function pAe(e) {
                var t = e._readableState;
                Il("emitReadable_", t.destroyed, t.length, t.ended), !t.destroyed && (t.length || t.ended) && (e.emit("readable"), t.emittedReadable = !1), t.needReadable = !t.flowing && !t.ended && t.length <= t.highWaterMark, gj(e);
            }
            function vj(e, t) {
                t.readingMore || (t.readingMore = !0, $d3c1734dacb01657$exports.nextTick(SAt, e, t));
            }
            function SAt(e, t) {
                for(; !t.reading && !t.ended && (t.length < t.highWaterMark || t.flowing && t.length === 0);){
                    var r = t.length;
                    if (Il("maybeReadMore read 0"), e.read(0), r === t.length) break;
                }
                t.readingMore = !1;
            }
            vu.prototype._read = function(e) {
                Y4(this, new _At("_read()"));
            };
            vu.prototype.pipe = function(e, t) {
                var r = this, n = this._readableState;
                switch(n.pipesCount){
                    case 0:
                        n.pipes = e;
                        break;
                    case 1:
                        n.pipes = [
                            n.pipes,
                            e
                        ];
                        break;
                    default:
                        n.pipes.push(e);
                        break;
                }
                n.pipesCount += 1, Il("pipe count=%d opts=%j", n.pipesCount, t);
                var i = (!t || t.end !== !1) && e !== $d3c1734dacb01657$exports.stdout && e !== $d3c1734dacb01657$exports.stderr, a = i ? s : x;
                n.endEmitted ? $d3c1734dacb01657$exports.nextTick(a) : r.once("end", a), e.on("unpipe", o);
                function o(b, p) {
                    Il("onunpipe"), b === r && p && p.hasUnpiped === !1 && (p.hasUnpiped = !0, c());
                }
                function s() {
                    Il("onend"), e.end();
                }
                var l = MAt(r);
                e.on("drain", l);
                var u = !1;
                function c() {
                    Il("cleanup"), e.removeListener("close", d), e.removeListener("finish", v), e.removeListener("drain", l), e.removeListener("error", h), e.removeListener("unpipe", o), r.removeListener("end", s), r.removeListener("end", x), r.removeListener("data", f), u = !0, n.awaitDrain && (!e._writableState || e._writableState.needDrain) && l();
                }
                r.on("data", f);
                function f(b) {
                    Il("ondata");
                    var p = e.write(b);
                    Il("dest.write", p), p === !1 && ((n.pipesCount === 1 && n.pipes === e || n.pipesCount > 1 && yAe(n.pipes, e) !== -1) && !u && (Il("false write response, pause", n.awaitDrain), n.awaitDrain++), r.pause());
                }
                function h(b) {
                    Il("onerror", b), x(), e.removeListener("error", h), hAe(e, "error") === 0 && Y4(e, b);
                }
                bAt(e, "error", h);
                function d() {
                    e.removeListener("finish", v), x();
                }
                e.once("close", d);
                function v() {
                    Il("onfinish"), e.removeListener("close", d), x();
                }
                e.once("finish", v);
                function x() {
                    Il("unpipe"), r.unpipe(e);
                }
                return e.emit("pipe", r), n.flowing || (Il("pipe resume"), r.resume()), e;
            };
            function MAt(e) {
                return function() {
                    var r = e._readableState;
                    Il("pipeOnDrain", r.awaitDrain), r.awaitDrain && r.awaitDrain--, r.awaitDrain === 0 && hAe(e, "data") && (r.flowing = !0, gj(e));
                };
            }
            vu.prototype.unpipe = function(e) {
                var t = this._readableState, r = {
                    hasUnpiped: !1
                };
                if (t.pipesCount === 0) return this;
                if (t.pipesCount === 1) return e && e !== t.pipes ? this : (e || (e = t.pipes), t.pipes = null, t.pipesCount = 0, t.flowing = !1, e && e.emit("unpipe", this, r), this);
                if (!e) {
                    var n = t.pipes, i = t.pipesCount;
                    t.pipes = null, t.pipesCount = 0, t.flowing = !1;
                    for(var a = 0; a < i; a++)n[a].emit("unpipe", this, {
                        hasUnpiped: !1
                    });
                    return this;
                }
                var o = yAe(t.pipes, e);
                return o === -1 ? this : (t.pipes.splice(o, 1), t.pipesCount -= 1, t.pipesCount === 1 && (t.pipes = t.pipes[0]), e.emit("unpipe", this, r), this);
            };
            vu.prototype.on = function(e, t) {
                var r = K4.prototype.on.call(this, e, t), n = this._readableState;
                return e === "data" ? (n.readableListening = this.listenerCount("readable") > 0, n.flowing !== !1 && this.resume()) : e === "readable" && !n.endEmitted && !n.readableListening && (n.readableListening = n.needReadable = !0, n.flowing = !1, n.emittedReadable = !1, Il("on readable", n.length, n.reading), n.length ? SR(this) : n.reading || $d3c1734dacb01657$exports.nextTick(EAt, this)), r;
            };
            vu.prototype.addListener = vu.prototype.on;
            vu.prototype.removeListener = function(e, t) {
                var r = K4.prototype.removeListener.call(this, e, t);
                return e === "readable" && $d3c1734dacb01657$exports.nextTick(gAe, this), r;
            };
            vu.prototype.removeAllListeners = function(e) {
                var t = K4.prototype.removeAllListeners.apply(this, arguments);
                return (e === "readable" || e === void 0) && $d3c1734dacb01657$exports.nextTick(gAe, this), t;
            };
            function gAe(e) {
                var t = e._readableState;
                t.readableListening = e.listenerCount("readable") > 0, t.resumeScheduled && !t.paused ? t.flowing = !0 : e.listenerCount("data") > 0 && e.resume();
            }
            function EAt(e) {
                Il("readable nexttick read 0"), e.read(0);
            }
            vu.prototype.resume = function() {
                var e = this._readableState;
                return e.flowing || (Il("resume"), e.flowing = !e.readableListening, kAt(this, e)), e.paused = !1, this;
            };
            function kAt(e, t) {
                t.resumeScheduled || (t.resumeScheduled = !0, $d3c1734dacb01657$exports.nextTick(CAt, e, t));
            }
            function CAt(e, t) {
                Il("resume", t.reading), t.reading || e.read(0), t.resumeScheduled = !1, e.emit("resume"), gj(e), t.flowing && !t.reading && e.read(0);
            }
            vu.prototype.pause = function() {
                return Il("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (Il("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
            };
            function gj(e) {
                var t = e._readableState;
                for(Il("flow", t.flowing); t.flowing && e.read() !== null;);
            }
            vu.prototype.wrap = function(e) {
                var t = this, r = this._readableState, n = !1;
                e.on("end", function() {
                    if (Il("wrapped end"), r.decoder && !r.ended) {
                        var o = r.decoder.end();
                        o && o.length && t.push(o);
                    }
                    t.push(null);
                }), e.on("data", function(o) {
                    if (Il("wrapped data"), r.decoder && (o = r.decoder.write(o)), !(r.objectMode && o == null) && !(!r.objectMode && (!o || !o.length))) {
                        var s = t.push(o);
                        s || (n = !0, e.pause());
                    }
                });
                for(var i in e)this[i] === void 0 && typeof e[i] == "function" && (this[i] = function(s) {
                    return function() {
                        return e[s].apply(e, arguments);
                    };
                }(i));
                for(var a = 0; a < fj.length; a++)e.on(fj[a], this.emit.bind(this, fj[a]));
                return this._read = function(o) {
                    Il("wrapped _read", o), n && (n = !1, e.resume());
                }, this;
            };
            typeof Symbol == "function" && (vu.prototype[Symbol.asyncIterator] = function() {
                return uj === void 0 && (uj = sAe()), uj(this);
            });
            Object.defineProperty(vu.prototype, "readableHighWaterMark", {
                enumerable: !1,
                get: function() {
                    return this._readableState.highWaterMark;
                }
            });
            Object.defineProperty(vu.prototype, "readableBuffer", {
                enumerable: !1,
                get: function() {
                    return this._readableState && this._readableState.buffer;
                }
            });
            Object.defineProperty(vu.prototype, "readableFlowing", {
                enumerable: !1,
                get: function() {
                    return this._readableState.flowing;
                },
                set: function(t) {
                    this._readableState && (this._readableState.flowing = t);
                }
            });
            vu._fromList = mAe;
            Object.defineProperty(vu.prototype, "readableLength", {
                enumerable: !1,
                get: function() {
                    return this._readableState.length;
                }
            });
            function mAe(e, t) {
                if (t.length === 0) return null;
                var r;
                return t.objectMode ? r = t.buffer.shift() : !e || e >= t.length ? (t.decoder ? r = t.buffer.join("") : t.buffer.length === 1 ? r = t.buffer.first() : r = t.buffer.concat(t.length), t.buffer.clear()) : r = t.buffer.consume(e, t.decoder), r;
            }
            function dj(e) {
                var t = e._readableState;
                Il("endReadable", t.endEmitted), t.endEmitted || (t.ended = !0, $d3c1734dacb01657$exports.nextTick(LAt, t, e));
            }
            function LAt(e, t) {
                if (Il("endReadableNT", e.endEmitted, e.length), !e.endEmitted && e.length === 0 && (e.endEmitted = !0, t.readable = !1, t.emit("end"), e.autoDestroy)) {
                    var r = t._writableState;
                    (!r || r.autoDestroy && r.finished) && t.destroy();
                }
            }
            typeof Symbol == "function" && (vu.from = function(e, t) {
                return cj === void 0 && (cj = uAe()), cj(vu, e, t);
            });
            function yAe(e, t) {
                for(var r = 0, n = e.length; r < n; r++)if (e[r] === t) return r;
                return -1;
            }
        });
        var mj = ye((ccr, bAe)=>{
            "use strict";
            bAe.exports = Hy;
            var MR = v2().codes, PAt = MR.ERR_METHOD_NOT_IMPLEMENTED, IAt = MR.ERR_MULTIPLE_CALLBACK, RAt = MR.ERR_TRANSFORM_ALREADY_TRANSFORMING, DAt = MR.ERR_TRANSFORM_WITH_LENGTH_0, ER = p2();
            Uy()(Hy, ER);
            function zAt(e, t) {
                var r = this._transformState;
                r.transforming = !1;
                var n = r.writecb;
                if (n === null) return this.emit("error", new IAt);
                r.writechunk = null, r.writecb = null, t != null && this.push(t), n(e);
                var i = this._readableState;
                i.reading = !1, (i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
            }
            function Hy(e) {
                if (!(this instanceof Hy)) return new Hy(e);
                ER.call(this, e), this._transformState = {
                    afterTransform: zAt.bind(this),
                    needTransform: !1,
                    transforming: !1,
                    writecb: null,
                    writechunk: null,
                    writeencoding: null
                }, this._readableState.needReadable = !0, this._readableState.sync = !1, e && (typeof e.transform == "function" && (this._transform = e.transform), typeof e.flush == "function" && (this._flush = e.flush)), this.on("prefinish", FAt);
            }
            function FAt() {
                var e = this;
                typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(t, r) {
                    xAe(e, t, r);
                }) : xAe(this, null, null);
            }
            Hy.prototype.push = function(e, t) {
                return this._transformState.needTransform = !1, ER.prototype.push.call(this, e, t);
            };
            Hy.prototype._transform = function(e, t, r) {
                r(new PAt("_transform()"));
            };
            Hy.prototype._write = function(e, t, r) {
                var n = this._transformState;
                if (n.writecb = r, n.writechunk = e, n.writeencoding = t, !n.transforming) {
                    var i = this._readableState;
                    (n.needTransform || i.needReadable || i.length < i.highWaterMark) && this._read(i.highWaterMark);
                }
            };
            Hy.prototype._read = function(e) {
                var t = this._transformState;
                t.writechunk !== null && !t.transforming ? (t.transforming = !0, this._transform(t.writechunk, t.writeencoding, t.afterTransform)) : t.needTransform = !0;
            };
            Hy.prototype._destroy = function(e, t) {
                ER.prototype._destroy.call(this, e, function(r) {
                    t(r);
                });
            };
            function xAe(e, t, r) {
                if (t) return e.emit("error", t);
                if (r != null && e.push(r), e._writableState.length) throw new DAt;
                if (e._transformState.transforming) throw new RAt;
                return e.push(null);
            }
        });
        var AAe = ye((fcr, TAe)=>{
            "use strict";
            TAe.exports = J4;
            var wAe = mj();
            Uy()(J4, wAe);
            function J4(e) {
                if (!(this instanceof J4)) return new J4(e);
                wAe.call(this, e);
            }
            J4.prototype._transform = function(e, t, r) {
                r(null, e);
            };
        });
        var CAe = ye((hcr, kAe)=>{
            "use strict";
            var yj;
            function qAt(e) {
                var t = !1;
                return function() {
                    t || (t = !0, e.apply(void 0, arguments));
                };
            }
            var EAe = v2().codes, OAt = EAe.ERR_MISSING_ARGS, BAt = EAe.ERR_STREAM_DESTROYED;
            function SAe(e) {
                if (e) throw e;
            }
            function NAt(e) {
                return e.setHeader && typeof e.abort == "function";
            }
            function UAt(e, t, r, n) {
                n = qAt(n);
                var i = !1;
                e.on("close", function() {
                    i = !0;
                }), yj === void 0 && (yj = xR()), yj(e, {
                    readable: t,
                    writable: r
                }, function(o) {
                    if (o) return n(o);
                    i = !0, n();
                });
                var a = !1;
                return function(o) {
                    if (!i && !a) {
                        if (a = !0, NAt(e)) return e.abort();
                        if (typeof e.destroy == "function") return e.destroy();
                        n(o || new BAt("pipe"));
                    }
                };
            }
            function MAe(e) {
                e();
            }
            function VAt(e, t) {
                return e.pipe(t);
            }
            function HAt(e) {
                return !e.length || typeof e[e.length - 1] != "function" ? SAe : e.pop();
            }
            function GAt() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                var n = HAt(t);
                if (Array.isArray(t[0]) && (t = t[0]), t.length < 2) throw new OAt("streams");
                var i, a = t.map(function(o, s) {
                    var l = s < t.length - 1, u = s > 0;
                    return UAt(o, l, u, function(c) {
                        i || (i = c), c && a.forEach(MAe), !l && (a.forEach(MAe), n(i));
                    });
                });
                return t.reduce(VAt);
            }
            kAe.exports = GAt;
        });
        var PAe = ye((dcr, LAe)=>{
            LAe.exports = K0;
            var _j = vb().EventEmitter, jAt = Uy();
            jAt(K0, _j);
            K0.Readable = rj();
            K0.Writable = QG();
            K0.Duplex = p2();
            K0.Transform = mj();
            K0.PassThrough = AAe();
            K0.finished = xR();
            K0.pipeline = CAe();
            K0.Stream = K0;
            function K0() {
                _j.call(this);
            }
            K0.prototype.pipe = function(e, t) {
                var r = this;
                function n(c) {
                    e.writable && e.write(c) === !1 && r.pause && r.pause();
                }
                r.on("data", n);
                function i() {
                    r.readable && r.resume && r.resume();
                }
                e.on("drain", i), !e._isStdio && (!t || t.end !== !1) && (r.on("end", o), r.on("close", s));
                var a = !1;
                function o() {
                    a || (a = !0, e.end());
                }
                function s() {
                    a || (a = !0, typeof e.destroy == "function" && e.destroy());
                }
                function l(c) {
                    if (u(), _j.listenerCount(this, "error") === 0) throw c;
                }
                r.on("error", l), e.on("error", l);
                function u() {
                    r.removeListener("data", n), e.removeListener("drain", i), r.removeListener("end", o), r.removeListener("close", s), r.removeListener("error", l), e.removeListener("error", l), r.removeListener("end", u), r.removeListener("close", u), e.removeListener("close", u);
                }
                return r.on("end", u), r.on("close", u), e.on("close", u), e.emit("pipe", r), e;
            };
        });
        var h5 = ye((Ul)=>{
            var IAe = Object.getOwnPropertyDescriptors || function(t) {
                for(var r = Object.keys(t), n = {}, i = 0; i < r.length; i++)n[r[i]] = Object.getOwnPropertyDescriptor(t, r[i]);
                return n;
            }, WAt = /%[sdj%]/g;
            Ul.format = function(e) {
                if (!DR(e)) {
                    for(var t = [], r = 0; r < arguments.length; r++)t.push(O_(arguments[r]));
                    return t.join(" ");
                }
                for(var r = 1, n = arguments, i = n.length, a = String(e).replace(WAt, function(s) {
                    if (s === "%%") return "%";
                    if (r >= i) return s;
                    switch(s){
                        case "%s":
                            return String(n[r++]);
                        case "%d":
                            return Number(n[r++]);
                        case "%j":
                            try {
                                return JSON.stringify(n[r++]);
                            } catch (l) {
                                return "[Circular]";
                            }
                        default:
                            return s;
                    }
                }), o = n[r]; r < i; o = n[++r])RR(o) || !f5(o) ? a += " " + o : a += " " + O_(o);
                return a;
            };
            Ul.deprecate = function(e, t) {
                var r;
                return function() {
                    return Ul.deprecate(e, t).apply(this, arguments);
                };
                function n() {
                    if (!r) {
                        if ($d3c1734dacb01657$exports.throwDeprecation) throw new Error(t);
                        $d3c1734dacb01657$exports.traceDeprecation ? console.trace(t) : console.error(t), r = !0;
                    }
                    return e.apply(this, arguments);
                }
            };
            var kR = {}, RAe = /^$/;
            CR = "false", CR = CR.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), RAe = new RegExp("^" + CR + "$", "i");
            var CR;
            Ul.debuglog = function(e) {
                if (e = e.toUpperCase(), !kR[e]) {
                    if (RAe.test(e)) {
                        var t = $d3c1734dacb01657$exports.pid;
                        kR[e] = function() {
                            var r = Ul.format.apply(Ul, arguments);
                            console.error("%s %d: %s", e, t, r);
                        };
                    } else kR[e] = function() {};
                }
                return kR[e];
            };
            function O_(e, t) {
                var r = {
                    seen: [],
                    stylize: XAt
                };
                return arguments.length >= 3 && (r.depth = arguments[2]), arguments.length >= 4 && (r.colors = arguments[3]), Tj(t) ? r.showHidden = t : t && Ul._extend(r, t), b2(r.showHidden) && (r.showHidden = !1), b2(r.depth) && (r.depth = 2), b2(r.colors) && (r.colors = !1), b2(r.customInspect) && (r.customInspect = !0), r.colors && (r.stylize = ZAt), PR(r, e, r.depth);
            }
            Ul.inspect = O_;
            O_.colors = {
                bold: [
                    1,
                    22
                ],
                italic: [
                    3,
                    23
                ],
                underline: [
                    4,
                    24
                ],
                inverse: [
                    7,
                    27
                ],
                white: [
                    37,
                    39
                ],
                grey: [
                    90,
                    39
                ],
                black: [
                    30,
                    39
                ],
                blue: [
                    34,
                    39
                ],
                cyan: [
                    36,
                    39
                ],
                green: [
                    32,
                    39
                ],
                magenta: [
                    35,
                    39
                ],
                red: [
                    31,
                    39
                ],
                yellow: [
                    33,
                    39
                ]
            };
            O_.styles = {
                special: "cyan",
                number: "yellow",
                boolean: "yellow",
                undefined: "grey",
                null: "bold",
                string: "green",
                date: "magenta",
                regexp: "red"
            };
            function ZAt(e, t) {
                var r = O_.styles[t];
                return r ? "\x1B[" + O_.colors[r][0] + "m" + e + "\x1B[" + O_.colors[r][1] + "m" : e;
            }
            function XAt(e, t) {
                return e;
            }
            function YAt(e) {
                var t = {};
                return e.forEach(function(r, n) {
                    t[r] = !0;
                }), t;
            }
            function PR(e, t, r) {
                if (e.customInspect && t && LR(t.inspect) && t.inspect !== Ul.inspect && !(t.constructor && t.constructor.prototype === t)) {
                    var n = t.inspect(r, e);
                    return DR(n) || (n = PR(e, n, r)), n;
                }
                var i = KAt(e, t);
                if (i) return i;
                var a = Object.keys(t), o = YAt(a);
                if (e.showHidden && (a = Object.getOwnPropertyNames(t)), Q4(t) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return xj(t);
                if (a.length === 0) {
                    if (LR(t)) {
                        var s = t.name ? ": " + t.name : "";
                        return e.stylize("[Function" + s + "]", "special");
                    }
                    if ($4(t)) return e.stylize(RegExp.prototype.toString.call(t), "regexp");
                    if (IR(t)) return e.stylize(Date.prototype.toString.call(t), "date");
                    if (Q4(t)) return xj(t);
                }
                var l = "", u = !1, c = [
                    "{",
                    "}"
                ];
                if (DAe(t) && (u = !0, c = [
                    "[",
                    "]"
                ]), LR(t)) {
                    var f = t.name ? ": " + t.name : "";
                    l = " [Function" + f + "]";
                }
                if ($4(t) && (l = " " + RegExp.prototype.toString.call(t)), IR(t) && (l = " " + Date.prototype.toUTCString.call(t)), Q4(t) && (l = " " + xj(t)), a.length === 0 && (!u || t.length == 0)) return c[0] + l + c[1];
                if (r < 0) return $4(t) ? e.stylize(RegExp.prototype.toString.call(t), "regexp") : e.stylize("[Object]", "special");
                e.seen.push(t);
                var h;
                return u ? h = JAt(e, t, r, o, a) : h = a.map(function(d) {
                    return wj(e, t, r, o, d, u);
                }), e.seen.pop(), $At(h, l, c);
            }
            function KAt(e, t) {
                if (b2(t)) return e.stylize("undefined", "undefined");
                if (DR(t)) {
                    var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
                    return e.stylize(r, "string");
                }
                if (zAe(t)) return e.stylize("" + t, "number");
                if (Tj(t)) return e.stylize("" + t, "boolean");
                if (RR(t)) return e.stylize("null", "null");
            }
            function xj(e) {
                return "[" + Error.prototype.toString.call(e) + "]";
            }
            function JAt(e, t, r, n, i) {
                for(var a = [], o = 0, s = t.length; o < s; ++o)FAe(t, String(o)) ? a.push(wj(e, t, r, n, String(o), !0)) : a.push("");
                return i.forEach(function(l) {
                    l.match(/^\d+$/) || a.push(wj(e, t, r, n, l, !0));
                }), a;
            }
            function wj(e, t, r, n, i, a) {
                var o, s, l;
                if (l = Object.getOwnPropertyDescriptor(t, i) || {
                    value: t[i]
                }, l.get ? l.set ? s = e.stylize("[Getter/Setter]", "special") : s = e.stylize("[Getter]", "special") : l.set && (s = e.stylize("[Setter]", "special")), FAe(n, i) || (o = "[" + i + "]"), s || (e.seen.indexOf(l.value) < 0 ? (RR(r) ? s = PR(e, l.value, null) : s = PR(e, l.value, r - 1), s.indexOf(`
`) > -1 && (a ? s = s.split(`
`).map(function(u) {
                    return "  " + u;
                }).join(`
`).slice(2) : s = `
` + s.split(`
`).map(function(u) {
                    return "   " + u;
                }).join(`
`))) : s = e.stylize("[Circular]", "special")), b2(o)) {
                    if (a && i.match(/^\d+$/)) return s;
                    o = JSON.stringify("" + i), o.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (o = o.slice(1, -1), o = e.stylize(o, "name")) : (o = o.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), o = e.stylize(o, "string"));
                }
                return o + ": " + s;
            }
            function $At(e, t, r) {
                var n = 0, i = e.reduce(function(a, o) {
                    return n++, o.indexOf(`
`) >= 0 && n++, a + o.replace(/\u001b\[\d\d?m/g, "").length + 1;
                }, 0);
                return i > 60 ? r[0] + (t === "" ? "" : t + `
 `) + " " + e.join(`,
  `) + " " + r[1] : r[0] + t + " " + e.join(", ") + " " + r[1];
            }
            Ul.types = OG();
            function DAe(e) {
                return Array.isArray(e);
            }
            Ul.isArray = DAe;
            function Tj(e) {
                return typeof e == "boolean";
            }
            Ul.isBoolean = Tj;
            function RR(e) {
                return e === null;
            }
            Ul.isNull = RR;
            function QAt(e) {
                return e == null;
            }
            Ul.isNullOrUndefined = QAt;
            function zAe(e) {
                return typeof e == "number";
            }
            Ul.isNumber = zAe;
            function DR(e) {
                return typeof e == "string";
            }
            Ul.isString = DR;
            function eSt(e) {
                return typeof e == "symbol";
            }
            Ul.isSymbol = eSt;
            function b2(e) {
                return e === void 0;
            }
            Ul.isUndefined = b2;
            function $4(e) {
                return f5(e) && Aj(e) === "[object RegExp]";
            }
            Ul.isRegExp = $4;
            Ul.types.isRegExp = $4;
            function f5(e) {
                return typeof e == "object" && e !== null;
            }
            Ul.isObject = f5;
            function IR(e) {
                return f5(e) && Aj(e) === "[object Date]";
            }
            Ul.isDate = IR;
            Ul.types.isDate = IR;
            function Q4(e) {
                return f5(e) && (Aj(e) === "[object Error]" || e instanceof Error);
            }
            Ul.isError = Q4;
            Ul.types.isNativeError = Q4;
            function LR(e) {
                return typeof e == "function";
            }
            Ul.isFunction = LR;
            function tSt(e) {
                return e === null || typeof e == "boolean" || typeof e == "number" || typeof e == "string" || typeof e == "symbol" || typeof e == "undefined";
            }
            Ul.isPrimitive = tSt;
            Ul.isBuffer = BG();
            function Aj(e) {
                return Object.prototype.toString.call(e);
            }
            function bj(e) {
                return e < 10 ? "0" + e.toString(10) : e.toString(10);
            }
            var rSt = [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ];
            function iSt() {
                var e = new Date, t = [
                    bj(e.getHours()),
                    bj(e.getMinutes()),
                    bj(e.getSeconds())
                ].join(":");
                return [
                    e.getDate(),
                    rSt[e.getMonth()],
                    t
                ].join(" ");
            }
            Ul.log = function() {
                console.log("%s - %s", iSt(), Ul.format.apply(Ul, arguments));
            };
            Ul.inherits = Uy();
            Ul._extend = function(e, t) {
                if (!t || !f5(t)) return e;
                for(var r = Object.keys(t), n = r.length; n--;)e[r[n]] = t[r[n]];
                return e;
            };
            function FAe(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
            }
            var x2 = typeof Symbol != "undefined" ? Symbol("util.promisify.custom") : void 0;
            Ul.promisify = function(t) {
                if (typeof t != "function") throw new TypeError('The "original" argument must be of type Function');
                if (x2 && t[x2]) {
                    var r = t[x2];
                    if (typeof r != "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
                    return Object.defineProperty(r, x2, {
                        value: r,
                        enumerable: !1,
                        writable: !1,
                        configurable: !0
                    }), r;
                }
                function r() {
                    for(var n, i, a = new Promise(function(l, u) {
                        n = l, i = u;
                    }), o = [], s = 0; s < arguments.length; s++)o.push(arguments[s]);
                    o.push(function(l, u) {
                        l ? i(l) : n(u);
                    });
                    try {
                        t.apply(this, o);
                    } catch (l) {
                        i(l);
                    }
                    return a;
                }
                return Object.setPrototypeOf(r, Object.getPrototypeOf(t)), x2 && Object.defineProperty(r, x2, {
                    value: r,
                    enumerable: !1,
                    writable: !1,
                    configurable: !0
                }), Object.defineProperties(r, IAe(t));
            };
            Ul.promisify.custom = x2;
            function nSt(e, t) {
                if (!e) {
                    var r = new Error("Promise was rejected with a falsy value");
                    r.reason = e, e = r;
                }
                return t(e);
            }
            function aSt(e) {
                if (typeof e != "function") throw new TypeError('The "original" argument must be of type Function');
                function t() {
                    for(var r = [], n = 0; n < arguments.length; n++)r.push(arguments[n]);
                    var i = r.pop();
                    if (typeof i != "function") throw new TypeError("The last argument must be of type Function");
                    var a = this, o = function() {
                        return i.apply(a, arguments);
                    };
                    e.apply(this, r).then(function(s) {
                        $d3c1734dacb01657$exports.nextTick(o.bind(null, null, s));
                    }, function(s) {
                        $d3c1734dacb01657$exports.nextTick(nSt.bind(null, s, o));
                    });
                }
                return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, IAe(e)), t;
            }
            Ul.callbackify = aSt;
        });
        var Ej = ye((pcr, NAe)=>{
            "use strict";
            function B_(e) {
                "@babel/helpers - typeof";
                return B_ = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, B_(e);
            }
            function qAe(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, sSt(n.key), n);
                }
            }
            function oSt(e, t, r) {
                return t && qAe(e.prototype, t), r && qAe(e, r), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            }
            function sSt(e) {
                var t = lSt(e, "string");
                return B_(t) === "symbol" ? t : String(t);
            }
            function lSt(e, t) {
                if (B_(e) !== "object" || e === null) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                    var n = r.call(e, t || "default");
                    if (B_(n) !== "object") return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (t === "string" ? String : Number)(e);
            }
            function uSt(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function cSt(e, t) {
                if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && Mj(e, t);
            }
            function Mj(e, t) {
                return Mj = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
                    return n.__proto__ = i, n;
                }, Mj(e, t);
            }
            function fSt(e) {
                var t = vSt();
                return function() {
                    var n = zR(e), i;
                    if (t) {
                        var a = zR(this).constructor;
                        i = Reflect.construct(n, arguments, a);
                    } else i = n.apply(this, arguments);
                    return hSt(this, i);
                };
            }
            function hSt(e, t) {
                if (t && (B_(t) === "object" || typeof t == "function")) return t;
                if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                return dSt(e);
            }
            function dSt(e) {
                if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function vSt() {
                if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
                if (typeof Proxy == "function") return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }
            function zR(e) {
                return zR = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                    return r.__proto__ || Object.getPrototypeOf(r);
                }, zR(e);
            }
            var BAe = {}, d5, Sj;
            function eE(e, t, r) {
                r || (r = Error);
                function n(a, o, s) {
                    return typeof t == "string" ? t : t(a, o, s);
                }
                var i = function(a) {
                    cSt(s, a);
                    var o = fSt(s);
                    function s(l, u, c) {
                        var f;
                        return uSt(this, s), f = o.call(this, n(l, u, c)), f.code = e, f;
                    }
                    return oSt(s);
                }(r);
                BAe[e] = i;
            }
            function OAe(e, t) {
                if (Array.isArray(e)) {
                    var r = e.length;
                    return e = e.map(function(n) {
                        return String(n);
                    }), r > 2 ? "one of ".concat(t, " ").concat(e.slice(0, r - 1).join(", "), ", or ") + e[r - 1] : r === 2 ? "one of ".concat(t, " ").concat(e[0], " or ").concat(e[1]) : "of ".concat(t, " ").concat(e[0]);
                } else return "of ".concat(t, " ").concat(String(e));
            }
            function pSt(e, t, r) {
                return e.substr(!r || r < 0 ? 0 : +r, t.length) === t;
            }
            function gSt(e, t, r) {
                return (r === void 0 || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
            }
            function mSt(e, t, r) {
                return typeof r != "number" && (r = 0), r + t.length > e.length ? !1 : e.indexOf(t, r) !== -1;
            }
            eE("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);
            eE("ERR_INVALID_ARG_TYPE", function(e, t, r) {
                d5 === void 0 && (d5 = tE()), d5(typeof e == "string", "'name' must be a string");
                var n;
                typeof t == "string" && pSt(t, "not ") ? (n = "must not be", t = t.replace(/^not /, "")) : n = "must be";
                var i;
                if (gSt(e, " argument")) i = "The ".concat(e, " ").concat(n, " ").concat(OAe(t, "type"));
                else {
                    var a = mSt(e, ".") ? "property" : "argument";
                    i = 'The "'.concat(e, '" ').concat(a, " ").concat(n, " ").concat(OAe(t, "type"));
                }
                return i += ". Received type ".concat(B_(r)), i;
            }, TypeError);
            eE("ERR_INVALID_ARG_VALUE", function(e, t) {
                var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "is invalid";
                Sj === void 0 && (Sj = h5());
                var n = Sj.inspect(t);
                return n.length > 128 && (n = "".concat(n.slice(0, 128), "...")), "The argument '".concat(e, "' ").concat(r, ". Received ").concat(n);
            }, TypeError, RangeError);
            eE("ERR_INVALID_RETURN_VALUE", function(e, t, r) {
                var n;
                return r && r.constructor && r.constructor.name ? n = "instance of ".concat(r.constructor.name) : n = "type ".concat(B_(r)), "Expected ".concat(e, ' to be returned from the "').concat(t, '"') + " function but got ".concat(n, ".");
            }, TypeError);
            eE("ERR_MISSING_ARGS", function() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                d5 === void 0 && (d5 = tE()), d5(t.length > 0, "At least one arg needs to be specified");
                var n = "The ", i = t.length;
                switch(t = t.map(function(a) {
                    return '"'.concat(a, '"');
                }), i){
                    case 1:
                        n += "".concat(t[0], " argument");
                        break;
                    case 2:
                        n += "".concat(t[0], " and ").concat(t[1], " arguments");
                        break;
                    default:
                        n += t.slice(0, i - 1).join(", "), n += ", and ".concat(t[i - 1], " arguments");
                        break;
                }
                return "".concat(n, " must be specified");
            }, TypeError);
            NAe.exports.codes = BAe;
        });
        var KAe = ye((gcr, YAe)=>{
            "use strict";
            function UAe(e, t) {
                var r = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var n = Object.getOwnPropertySymbols(e);
                    t && (n = n.filter(function(i) {
                        return Object.getOwnPropertyDescriptor(e, i).enumerable;
                    })), r.push.apply(r, n);
                }
                return r;
            }
            function VAe(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t] != null ? arguments[t] : {};
                    t % 2 ? UAe(Object(r), !0).forEach(function(n) {
                        ySt(e, n, r[n]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : UAe(Object(r)).forEach(function(n) {
                        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
                    });
                }
                return e;
            }
            function ySt(e, t, r) {
                return t = WAe(t), t in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r, e;
            }
            function _St(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function HAe(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, WAe(n.key), n);
                }
            }
            function xSt(e, t, r) {
                return t && HAe(e.prototype, t), r && HAe(e, r), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            }
            function WAe(e) {
                var t = bSt(e, "string");
                return Dp(t) === "symbol" ? t : String(t);
            }
            function bSt(e, t) {
                if (Dp(e) !== "object" || e === null) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                    var n = r.call(e, t || "default");
                    if (Dp(n) !== "object") return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (t === "string" ? String : Number)(e);
            }
            function wSt(e, t) {
                if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && aE(e, t);
            }
            function TSt(e) {
                var t = XAe();
                return function() {
                    var n = oE(e), i;
                    if (t) {
                        var a = oE(this).constructor;
                        i = Reflect.construct(n, arguments, a);
                    } else i = n.apply(this, arguments);
                    return ZAe(this, i);
                };
            }
            function ZAe(e, t) {
                if (t && (Dp(t) === "object" || typeof t == "function")) return t;
                if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                return kj(e);
            }
            function kj(e) {
                if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }
            function Cj(e) {
                var t = typeof Map == "function" ? new Map : void 0;
                return Cj = function(n) {
                    if (n === null || !ASt(n)) return n;
                    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
                    if (typeof t != "undefined") {
                        if (t.has(n)) return t.get(n);
                        t.set(n, i);
                    }
                    function i() {
                        return FR(n, arguments, oE(this).constructor);
                    }
                    return i.prototype = Object.create(n.prototype, {
                        constructor: {
                            value: i,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), aE(i, n);
                }, Cj(e);
            }
            function FR(e, t, r) {
                return XAe() ? FR = Reflect.construct.bind() : FR = function(i, a, o) {
                    var s = [
                        null
                    ];
                    s.push.apply(s, a);
                    var l = Function.bind.apply(i, s), u = new l;
                    return o && aE(u, o.prototype), u;
                }, FR.apply(null, arguments);
            }
            function XAe() {
                if (typeof Reflect == "undefined" || !Reflect.construct || Reflect.construct.sham) return !1;
                if (typeof Proxy == "function") return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }
            function ASt(e) {
                return Function.toString.call(e).indexOf("[native code]") !== -1;
            }
            function aE(e, t) {
                return aE = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
                    return n.__proto__ = i, n;
                }, aE(e, t);
            }
            function oE(e) {
                return oE = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
                    return r.__proto__ || Object.getPrototypeOf(r);
                }, oE(e);
            }
            function Dp(e) {
                "@babel/helpers - typeof";
                return Dp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, Dp(e);
            }
            var SSt = h5(), Lj = SSt.inspect, MSt = Ej(), ESt = MSt.codes.ERR_INVALID_ARG_TYPE;
            function GAe(e, t, r) {
                return (r === void 0 || r > e.length) && (r = e.length), e.substring(r - t.length, r) === t;
            }
            function kSt(e, t) {
                if (t = Math.floor(t), e.length == 0 || t == 0) return "";
                var r = e.length * t;
                for(t = Math.floor(Math.log(t) / Math.log(2)); t;)e += e, t--;
                return e += e.substring(0, r - e.length), e;
            }
            var Gg = "", rE = "", iE = "", xv = "", w2 = {
                deepStrictEqual: "Expected values to be strictly deep-equal:",
                strictEqual: "Expected values to be strictly equal:",
                strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
                deepEqual: "Expected values to be loosely deep-equal:",
                equal: "Expected values to be loosely equal:",
                notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
                notStrictEqual: 'Expected "actual" to be strictly unequal to:',
                notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
                notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
                notEqual: 'Expected "actual" to be loosely unequal to:',
                notIdentical: "Values identical but not reference-equal:"
            }, CSt = 10;
            function jAe(e) {
                var t = Object.keys(e), r = Object.create(Object.getPrototypeOf(e));
                return t.forEach(function(n) {
                    r[n] = e[n];
                }), Object.defineProperty(r, "message", {
                    value: e.message
                }), r;
            }
            function nE(e) {
                return Lj(e, {
                    compact: !1,
                    customInspect: !1,
                    depth: 1e3,
                    maxArrayLength: 1 / 0,
                    showHidden: !1,
                    breakLength: 1 / 0,
                    showProxy: !1,
                    sorted: !0,
                    getters: !0
                });
            }
            function LSt(e, t, r) {
                var n = "", i = "", a = 0, o = "", s = !1, l = nE(e), u = l.split(`
`), c = nE(t).split(`
`), f = 0, h = "";
                if (r === "strictEqual" && Dp(e) === "object" && Dp(t) === "object" && e !== null && t !== null && (r = "strictEqualObject"), u.length === 1 && c.length === 1 && u[0] !== c[0]) {
                    var d = u[0].length + c[0].length;
                    if (d <= CSt) {
                        if ((Dp(e) !== "object" || e === null) && (Dp(t) !== "object" || t === null) && (e !== 0 || t !== 0)) return "".concat(w2[r], `

`) + "".concat(u[0], " !== ").concat(c[0], `
`);
                    } else if (r !== "strictEqualObject") {
                        var v = $d3c1734dacb01657$exports.stderr && $d3c1734dacb01657$exports.stderr.isTTY ? $d3c1734dacb01657$exports.stderr.columns : 80;
                        if (d < v) {
                            for(; u[0][f] === c[0][f];)f++;
                            f > 2 && (h = `
  `.concat(kSt(" ", f), "^"), f = 0);
                        }
                    }
                }
                for(var x = u[u.length - 1], b = c[c.length - 1]; x === b && (f++ < 2 ? o = `
  `.concat(x).concat(o) : n = x, u.pop(), c.pop(), !(u.length === 0 || c.length === 0));)x = u[u.length - 1], b = c[c.length - 1];
                var p = Math.max(u.length, c.length);
                if (p === 0) {
                    var E = l.split(`
`);
                    if (E.length > 30) for(E[26] = "".concat(Gg, "...").concat(xv); E.length > 27;)E.pop();
                    return "".concat(w2.notIdentical, `

`).concat(E.join(`
`), `
`);
                }
                f > 3 && (o = `
`.concat(Gg, "...").concat(xv).concat(o), s = !0), n !== "" && (o = `
  `.concat(n).concat(o), n = "");
                var k = 0, A = w2[r] + `
`.concat(rE, "+ actual").concat(xv, " ").concat(iE, "- expected").concat(xv), L = " ".concat(Gg, "...").concat(xv, " Lines skipped");
                for(f = 0; f < p; f++){
                    var _ = f - a;
                    if (u.length < f + 1) _ > 1 && f > 2 && (_ > 4 ? (i += `
`.concat(Gg, "...").concat(xv), s = !0) : _ > 3 && (i += `
  `.concat(c[f - 2]), k++), i += `
  `.concat(c[f - 1]), k++), a = f, n += `
`.concat(iE, "-").concat(xv, " ").concat(c[f]), k++;
                    else if (c.length < f + 1) _ > 1 && f > 2 && (_ > 4 ? (i += `
`.concat(Gg, "...").concat(xv), s = !0) : _ > 3 && (i += `
  `.concat(u[f - 2]), k++), i += `
  `.concat(u[f - 1]), k++), a = f, i += `
`.concat(rE, "+").concat(xv, " ").concat(u[f]), k++;
                    else {
                        var C = c[f], M = u[f], g = M !== C && (!GAe(M, ",") || M.slice(0, -1) !== C);
                        g && GAe(C, ",") && C.slice(0, -1) === M && (g = !1, M += ","), g ? (_ > 1 && f > 2 && (_ > 4 ? (i += `
`.concat(Gg, "...").concat(xv), s = !0) : _ > 3 && (i += `
  `.concat(u[f - 2]), k++), i += `
  `.concat(u[f - 1]), k++), a = f, i += `
`.concat(rE, "+").concat(xv, " ").concat(M), n += `
`.concat(iE, "-").concat(xv, " ").concat(C), k += 2) : (i += n, n = "", (_ === 1 || f === 0) && (i += `
  `.concat(M), k++));
                    }
                    if (k > 20 && f < p - 2) return "".concat(A).concat(L, `
`).concat(i, `
`).concat(Gg, "...").concat(xv).concat(n, `
`) + "".concat(Gg, "...").concat(xv);
                }
                return "".concat(A).concat(s ? L : "", `
`).concat(i).concat(n).concat(o).concat(h);
            }
            var PSt = function(e, t) {
                wSt(n, e);
                var r = TSt(n);
                function n(i) {
                    var a;
                    if (_St(this, n), Dp(i) !== "object" || i === null) throw new ESt("options", "Object", i);
                    var o = i.message, s = i.operator, l = i.stackStartFn, u = i.actual, c = i.expected, f = Error.stackTraceLimit;
                    if (Error.stackTraceLimit = 0, o != null) a = r.call(this, String(o));
                    else if ($d3c1734dacb01657$exports.stderr && $d3c1734dacb01657$exports.stderr.isTTY && ($d3c1734dacb01657$exports.stderr && $d3c1734dacb01657$exports.stderr.getColorDepth && $d3c1734dacb01657$exports.stderr.getColorDepth() !== 1 ? (Gg = "\x1B[34m", rE = "\x1B[32m", xv = "\x1B[39m", iE = "\x1B[31m") : (Gg = "", rE = "", xv = "", iE = "")), Dp(u) === "object" && u !== null && Dp(c) === "object" && c !== null && "stack" in u && u instanceof Error && "stack" in c && c instanceof Error && (u = jAe(u), c = jAe(c)), s === "deepStrictEqual" || s === "strictEqual") a = r.call(this, LSt(u, c, s));
                    else if (s === "notDeepStrictEqual" || s === "notStrictEqual") {
                        var h = w2[s], d = nE(u).split(`
`);
                        if (s === "notStrictEqual" && Dp(u) === "object" && u !== null && (h = w2.notStrictEqualObject), d.length > 30) for(d[26] = "".concat(Gg, "...").concat(xv); d.length > 27;)d.pop();
                        d.length === 1 ? a = r.call(this, "".concat(h, " ").concat(d[0])) : a = r.call(this, "".concat(h, `

`).concat(d.join(`
`), `
`));
                    } else {
                        var v = nE(u), x = "", b = w2[s];
                        s === "notDeepEqual" || s === "notEqual" ? (v = "".concat(w2[s], `

`).concat(v), v.length > 1024 && (v = "".concat(v.slice(0, 1021), "..."))) : (x = "".concat(nE(c)), v.length > 512 && (v = "".concat(v.slice(0, 509), "...")), x.length > 512 && (x = "".concat(x.slice(0, 509), "...")), s === "deepEqual" || s === "equal" ? v = "".concat(b, `

`).concat(v, `

should equal

`) : x = " ".concat(s, " ").concat(x)), a = r.call(this, "".concat(v).concat(x));
                    }
                    return Error.stackTraceLimit = f, a.generatedMessage = !o, Object.defineProperty(kj(a), "name", {
                        value: "AssertionError [ERR_ASSERTION]",
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }), a.code = "ERR_ASSERTION", a.actual = u, a.expected = c, a.operator = s, Error.captureStackTrace && Error.captureStackTrace(kj(a), l), a.stack, a.name = "AssertionError", ZAe(a);
                }
                return xSt(n, [
                    {
                        key: "toString",
                        value: function() {
                            return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                        }
                    },
                    {
                        key: t,
                        value: function(a, o) {
                            return Lj(this, VAe(VAe({}, o), {}, {
                                customInspect: !1,
                                depth: 0
                            }));
                        }
                    }
                ]), n;
            }(Cj(Error), Lj.custom);
            YAe.exports = PSt;
        });
        var Pj = ye((mcr, $Ae)=>{
            "use strict";
            var JAe = Object.prototype.toString;
            $Ae.exports = function(t) {
                var r = JAe.call(t), n = r === "[object Arguments]";
                return n || (n = r !== "[object Array]" && t !== null && typeof t == "object" && typeof t.length == "number" && t.length >= 0 && JAe.call(t.callee) === "[object Function]"), n;
            };
        });
        var sSe = ye((ycr, oSe)=>{
            "use strict";
            var aSe;
            Object.keys || (sE = Object.prototype.hasOwnProperty, Ij = Object.prototype.toString, QAe = Pj(), Rj = Object.prototype.propertyIsEnumerable, eSe = !Rj.call({
                toString: null
            }, "toString"), tSe = Rj.call(function() {}, "prototype"), lE = [
                "toString",
                "toLocaleString",
                "valueOf",
                "hasOwnProperty",
                "isPrototypeOf",
                "propertyIsEnumerable",
                "constructor"
            ], qR = function(e) {
                var t = e.constructor;
                return t && t.prototype === e;
            }, rSe = {
                $applicationCache: !0,
                $console: !0,
                $external: !0,
                $frame: !0,
                $frameElement: !0,
                $frames: !0,
                $innerHeight: !0,
                $innerWidth: !0,
                $onmozfullscreenchange: !0,
                $onmozfullscreenerror: !0,
                $outerHeight: !0,
                $outerWidth: !0,
                $pageXOffset: !0,
                $pageYOffset: !0,
                $parent: !0,
                $scrollLeft: !0,
                $scrollTop: !0,
                $scrollX: !0,
                $scrollY: !0,
                $self: !0,
                $webkitIndexedDB: !0,
                $webkitStorageInfo: !0,
                $window: !0
            }, iSe = function() {
                if (typeof window == "undefined") return !1;
                for(var e in window)try {
                    if (!rSe["$" + e] && sE.call(window, e) && window[e] !== null && typeof window[e] == "object") try {
                        qR(window[e]);
                    } catch (t) {
                        return !0;
                    }
                } catch (t) {
                    return !0;
                }
                return !1;
            }(), nSe = function(e) {
                if (typeof window == "undefined" || !iSe) return qR(e);
                try {
                    return qR(e);
                } catch (t) {
                    return !1;
                }
            }, aSe = function(t) {
                var r = t !== null && typeof t == "object", n = Ij.call(t) === "[object Function]", i = QAe(t), a = r && Ij.call(t) === "[object String]", o = [];
                if (!r && !n && !i) throw new TypeError("Object.keys called on a non-object");
                var s = tSe && n;
                if (a && t.length > 0 && !sE.call(t, 0)) for(var l = 0; l < t.length; ++l)o.push(String(l));
                if (i && t.length > 0) for(var u = 0; u < t.length; ++u)o.push(String(u));
                else for(var c in t)!(s && c === "prototype") && sE.call(t, c) && o.push(String(c));
                if (eSe) for(var f = nSe(t), h = 0; h < lE.length; ++h)!(f && lE[h] === "constructor") && sE.call(t, lE[h]) && o.push(lE[h]);
                return o;
            });
            var sE, Ij, QAe, Rj, eSe, tSe, lE, qR, rSe, iSe, nSe;
            oSe.exports = aSe;
        });
        var Dj = ye((_cr, cSe)=>{
            "use strict";
            var ISt = Array.prototype.slice, RSt = Pj(), lSe = Object.keys, OR = lSe ? function(t) {
                return lSe(t);
            } : sSe(), uSe = Object.keys;
            OR.shim = function() {
                if (Object.keys) {
                    var t = function() {
                        var r = Object.keys(arguments);
                        return r && r.length === arguments.length;
                    }(1, 2);
                    t || (Object.keys = function(n) {
                        return RSt(n) ? uSe(ISt.call(n)) : uSe(n);
                    });
                } else Object.keys = OR;
                return Object.keys || OR;
            };
            cSe.exports = OR;
        });
        var gSe = ye((xcr, pSe)=>{
            "use strict";
            var DSt = Dj(), dSe = B8()(), vSe = i5(), fSe = Object, zSt = vSe("Array.prototype.push"), hSe = vSe("Object.prototype.propertyIsEnumerable"), FSt = dSe ? Object.getOwnPropertySymbols : null;
            pSe.exports = function(t, r) {
                if (t == null) throw new TypeError("target must be an object");
                var n = fSe(t);
                if (arguments.length === 1) return n;
                for(var i = 1; i < arguments.length; ++i){
                    var a = fSe(arguments[i]), o = DSt(a), s = dSe && (Object.getOwnPropertySymbols || FSt);
                    if (s) for(var l = s(a), u = 0; u < l.length; ++u){
                        var c = l[u];
                        hSe(a, c) && zSt(o, c);
                    }
                    for(var f = 0; f < o.length; ++f){
                        var h = o[f];
                        if (hSe(a, h)) {
                            var d = a[h];
                            n[h] = d;
                        }
                    }
                }
                return n;
            };
        });
        var ySe = ye((bcr, mSe)=>{
            "use strict";
            var zj = gSe(), qSt = function() {
                if (!Object.assign) return !1;
                for(var e = "abcdefghijklmnopqrst", t = e.split(""), r = {}, n = 0; n < t.length; ++n)r[t[n]] = t[n];
                var i = Object.assign({}, r), a = "";
                for(var o in i)a += o;
                return e !== a;
            }, OSt = function() {
                if (!Object.assign || !Object.preventExtensions) return !1;
                var e = Object.preventExtensions({
                    1: 2
                });
                try {
                    Object.assign(e, "xy");
                } catch (t) {
                    return e[1] === "y";
                }
                return !1;
            };
            mSe.exports = function() {
                return !Object.assign || qSt() || OSt() ? zj : Object.assign;
            };
        });
        var Fj = ye((wcr, xSe)=>{
            "use strict";
            var _Se = function(e) {
                return e !== e;
            };
            xSe.exports = function(t, r) {
                return t === 0 && r === 0 ? 1 / t === 1 / r : !!(t === r || _Se(t) && _Se(r));
            };
        });
        var BR = ye((Tcr, bSe)=>{
            "use strict";
            var BSt = Fj();
            bSe.exports = function() {
                return typeof Object.is == "function" ? Object.is : BSt;
            };
        });
        var uE = ye((Acr, SSe)=>{
            "use strict";
            var NSt = Dj(), USt = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", VSt = Object.prototype.toString, HSt = Array.prototype.concat, wSe = Object.defineProperty, GSt = function(e) {
                return typeof e == "function" && VSt.call(e) === "[object Function]";
            }, jSt = yG()(), TSe = wSe && jSt, WSt = function(e, t, r, n) {
                if (t in e) {
                    if (n === !0) {
                        if (e[t] === r) return;
                    } else if (!GSt(n) || !n()) return;
                }
                TSe ? wSe(e, t, {
                    configurable: !0,
                    enumerable: !1,
                    value: r,
                    writable: !0
                }) : e[t] = r;
            }, ASe = function(e, t) {
                var r = arguments.length > 2 ? arguments[2] : {}, n = NSt(t);
                USt && (n = HSt.call(n, Object.getOwnPropertySymbols(t)));
                for(var i = 0; i < n.length; i += 1)WSt(e, n[i], t[n[i]], r[n[i]]);
            };
            ASe.supportsDescriptors = !!TSe;
            SSe.exports = ASe;
        });
        var ESe = ye((Scr, MSe)=>{
            "use strict";
            var ZSt = BR(), XSt = uE();
            MSe.exports = function() {
                var t = ZSt();
                return XSt(Object, {
                    is: t
                }, {
                    is: function() {
                        return Object.is !== t;
                    }
                }), t;
            };
        });
        var PSe = ye((Mcr, LSe)=>{
            "use strict";
            var YSt = uE(), KSt = N4(), JSt = Fj(), kSe = BR(), $St = ESe(), CSe = KSt(kSe(), Object);
            YSt(CSe, {
                getPolyfill: kSe,
                implementation: JSt,
                shim: $St
            });
            LSe.exports = CSe;
        });
        var qj = ye((Ecr, ISe)=>{
            "use strict";
            ISe.exports = function(t) {
                return t !== t;
            };
        });
        var Oj = ye((kcr, RSe)=>{
            "use strict";
            var QSt = qj();
            RSe.exports = function() {
                return Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a") ? Number.isNaN : QSt;
            };
        });
        var zSe = ye((Ccr, DSe)=>{
            "use strict";
            var eMt = uE(), tMt = Oj();
            DSe.exports = function() {
                var t = tMt();
                return eMt(Number, {
                    isNaN: t
                }, {
                    isNaN: function() {
                        return Number.isNaN !== t;
                    }
                }), t;
            };
        });
        var BSe = ye((Lcr, OSe)=>{
            "use strict";
            var rMt = N4(), iMt = uE(), nMt = qj(), FSe = Oj(), aMt = zSe(), qSe = rMt(FSe(), Number);
            iMt(qSe, {
                getPolyfill: FSe,
                implementation: nMt,
                shim: aMt
            });
            OSe.exports = qSe;
        });
        var aMe = ye((Pcr, nMe)=>{
            "use strict";
            function NSe(e, t) {
                return uMt(e) || lMt(e, t) || sMt(e, t) || oMt();
            }
            function oMt() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function sMt(e, t) {
                if (e) {
                    if (typeof e == "string") return USe(e, t);
                    var r = Object.prototype.toString.call(e).slice(8, -1);
                    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
                    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return USe(e, t);
                }
            }
            function USe(e, t) {
                (t == null || t > e.length) && (t = e.length);
                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                return n;
            }
            function lMt(e, t) {
                var r = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (r != null) {
                    var n, i, a, o, s = [], l = !0, u = !1;
                    try {
                        if (a = (r = r.call(e)).next, t === 0) {
                            if (Object(r) !== r) return;
                            l = !1;
                        } else for(; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); l = !0);
                    } catch (c) {
                        u = !0, i = c;
                    } finally{
                        try {
                            if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
                        } finally{
                            if (u) throw i;
                        }
                    }
                    return s;
                }
            }
            function uMt(e) {
                if (Array.isArray(e)) return e;
            }
            function J0(e) {
                "@babel/helpers - typeof";
                return J0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, J0(e);
            }
            var cMt = /a/g.flags !== void 0, WR = function(t) {
                var r = [];
                return t.forEach(function(n) {
                    return r.push(n);
                }), r;
            }, VSe = function(t) {
                var r = [];
                return t.forEach(function(n, i) {
                    return r.push([
                        i,
                        n
                    ]);
                }), r;
            }, QSe = Object.is ? Object.is : PSe(), GR = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
                return [];
            }, Bj = Number.isNaN ? Number.isNaN : BSe();
            function Uj(e) {
                return e.call.bind(e);
            }
            var fE = Uj(Object.prototype.hasOwnProperty), jR = Uj(Object.prototype.propertyIsEnumerable), HSe = Uj(Object.prototype.toString), sp = h5().types, fMt = sp.isAnyArrayBuffer, hMt = sp.isArrayBufferView, GSe = sp.isDate, NR = sp.isMap, jSe = sp.isRegExp, UR = sp.isSet, dMt = sp.isNativeError, vMt = sp.isBoxedPrimitive, WSe = sp.isNumberObject, ZSe = sp.isStringObject, XSe = sp.isBooleanObject, YSe = sp.isBigIntObject, pMt = sp.isSymbolObject, gMt = sp.isFloat32Array, mMt = sp.isFloat64Array;
            function yMt(e) {
                if (e.length === 0 || e.length > 10) return !0;
                for(var t = 0; t < e.length; t++){
                    var r = e.charCodeAt(t);
                    if (r < 48 || r > 57) return !0;
                }
                return e.length === 10 && e >= Math.pow(2, 32);
            }
            function VR(e) {
                return Object.keys(e).filter(yMt).concat(GR(e).filter(Object.prototype.propertyIsEnumerable.bind(e)));
            }
            function eMe(e, t) {
                if (e === t) return 0;
                for(var r = e.length, n = t.length, i = 0, a = Math.min(r, n); i < a; ++i)if (e[i] !== t[i]) {
                    r = e[i], n = t[i];
                    break;
                }
                return r < n ? -1 : n < r ? 1 : 0;
            }
            var HR = void 0, _Mt = !0, xMt = !1, Nj = 0, Vj = 1, tMe = 2, rMe = 3;
            function bMt(e, t) {
                return cMt ? e.source === t.source && e.flags === t.flags : RegExp.prototype.toString.call(e) === RegExp.prototype.toString.call(t);
            }
            function wMt(e, t) {
                if (e.byteLength !== t.byteLength) return !1;
                for(var r = 0; r < e.byteLength; r++)if (e[r] !== t[r]) return !1;
                return !0;
            }
            function TMt(e, t) {
                return e.byteLength !== t.byteLength ? !1 : eMe(new Uint8Array(e.buffer, e.byteOffset, e.byteLength), new Uint8Array(t.buffer, t.byteOffset, t.byteLength)) === 0;
            }
            function AMt(e, t) {
                return e.byteLength === t.byteLength && eMe(new Uint8Array(e), new Uint8Array(t)) === 0;
            }
            function SMt(e, t) {
                return WSe(e) ? WSe(t) && QSe(Number.prototype.valueOf.call(e), Number.prototype.valueOf.call(t)) : ZSe(e) ? ZSe(t) && String.prototype.valueOf.call(e) === String.prototype.valueOf.call(t) : XSe(e) ? XSe(t) && Boolean.prototype.valueOf.call(e) === Boolean.prototype.valueOf.call(t) : YSe(e) ? YSe(t) && BigInt.prototype.valueOf.call(e) === BigInt.prototype.valueOf.call(t) : pMt(t) && Symbol.prototype.valueOf.call(e) === Symbol.prototype.valueOf.call(t);
            }
            function $0(e, t, r, n) {
                if (e === t) return e !== 0 ? !0 : r ? QSe(e, t) : !0;
                if (r) {
                    if (J0(e) !== "object") return typeof e == "number" && Bj(e) && Bj(t);
                    if (J0(t) !== "object" || e === null || t === null || Object.getPrototypeOf(e) !== Object.getPrototypeOf(t)) return !1;
                } else {
                    if (e === null || J0(e) !== "object") return t === null || J0(t) !== "object" ? e == t : !1;
                    if (t === null || J0(t) !== "object") return !1;
                }
                var i = HSe(e), a = HSe(t);
                if (i !== a) return !1;
                if (Array.isArray(e)) {
                    if (e.length !== t.length) return !1;
                    var o = VR(e, HR), s = VR(t, HR);
                    return o.length !== s.length ? !1 : cE(e, t, r, n, Vj, o);
                }
                if (i === "[object Object]" && (!NR(e) && NR(t) || !UR(e) && UR(t))) return !1;
                if (GSe(e)) {
                    if (!GSe(t) || Date.prototype.getTime.call(e) !== Date.prototype.getTime.call(t)) return !1;
                } else if (jSe(e)) {
                    if (!jSe(t) || !bMt(e, t)) return !1;
                } else if (dMt(e) || e instanceof Error) {
                    if (e.message !== t.message || e.name !== t.name) return !1;
                } else if (hMt(e)) {
                    if (!r && (gMt(e) || mMt(e))) {
                        if (!wMt(e, t)) return !1;
                    } else if (!TMt(e, t)) return !1;
                    var l = VR(e, HR), u = VR(t, HR);
                    return l.length !== u.length ? !1 : cE(e, t, r, n, Nj, l);
                } else {
                    if (UR(e)) return !UR(t) || e.size !== t.size ? !1 : cE(e, t, r, n, tMe);
                    if (NR(e)) return !NR(t) || e.size !== t.size ? !1 : cE(e, t, r, n, rMe);
                    if (fMt(e)) {
                        if (!AMt(e, t)) return !1;
                    } else if (vMt(e) && !SMt(e, t)) return !1;
                }
                return cE(e, t, r, n, Nj);
            }
            function KSe(e, t) {
                return t.filter(function(r) {
                    return jR(e, r);
                });
            }
            function cE(e, t, r, n, i, a) {
                if (arguments.length === 5) {
                    a = Object.keys(e);
                    var o = Object.keys(t);
                    if (a.length !== o.length) return !1;
                }
                for(var s = 0; s < a.length; s++)if (!fE(t, a[s])) return !1;
                if (r && arguments.length === 5) {
                    var l = GR(e);
                    if (l.length !== 0) {
                        var u = 0;
                        for(s = 0; s < l.length; s++){
                            var c = l[s];
                            if (jR(e, c)) {
                                if (!jR(t, c)) return !1;
                                a.push(c), u++;
                            } else if (jR(t, c)) return !1;
                        }
                        var f = GR(t);
                        if (l.length !== f.length && KSe(t, f).length !== u) return !1;
                    } else {
                        var h = GR(t);
                        if (h.length !== 0 && KSe(t, h).length !== 0) return !1;
                    }
                }
                if (a.length === 0 && (i === Nj || i === Vj && e.length === 0 || e.size === 0)) return !0;
                if (n === void 0) n = {
                    val1: new Map,
                    val2: new Map,
                    position: 0
                };
                else {
                    var d = n.val1.get(e);
                    if (d !== void 0) {
                        var v = n.val2.get(t);
                        if (v !== void 0) return d === v;
                    }
                    n.position++;
                }
                n.val1.set(e, n.position), n.val2.set(t, n.position);
                var x = LMt(e, t, r, a, n, i);
                return n.val1.delete(e), n.val2.delete(t), x;
            }
            function JSe(e, t, r, n) {
                for(var i = WR(e), a = 0; a < i.length; a++){
                    var o = i[a];
                    if ($0(t, o, r, n)) return e.delete(o), !0;
                }
                return !1;
            }
            function iMe(e) {
                switch(J0(e)){
                    case "undefined":
                        return null;
                    case "object":
                        return;
                    case "symbol":
                        return !1;
                    case "string":
                        e = +e;
                    case "number":
                        if (Bj(e)) return !1;
                }
                return !0;
            }
            function MMt(e, t, r) {
                var n = iMe(r);
                return n != null ? n : t.has(n) && !e.has(n);
            }
            function EMt(e, t, r, n, i) {
                var a = iMe(r);
                if (a != null) return a;
                var o = t.get(a);
                return o === void 0 && !t.has(a) || !$0(n, o, !1, i) ? !1 : !e.has(a) && $0(n, o, !1, i);
            }
            function kMt(e, t, r, n) {
                for(var i = null, a = WR(e), o = 0; o < a.length; o++){
                    var s = a[o];
                    if (J0(s) === "object" && s !== null) i === null && (i = new Set), i.add(s);
                    else if (!t.has(s)) {
                        if (r || !MMt(e, t, s)) return !1;
                        i === null && (i = new Set), i.add(s);
                    }
                }
                if (i !== null) {
                    for(var l = WR(t), u = 0; u < l.length; u++){
                        var c = l[u];
                        if (J0(c) === "object" && c !== null) {
                            if (!JSe(i, c, r, n)) return !1;
                        } else if (!r && !e.has(c) && !JSe(i, c, r, n)) return !1;
                    }
                    return i.size === 0;
                }
                return !0;
            }
            function $Se(e, t, r, n, i, a) {
                for(var o = WR(e), s = 0; s < o.length; s++){
                    var l = o[s];
                    if ($0(r, l, i, a) && $0(n, t.get(l), i, a)) return e.delete(l), !0;
                }
                return !1;
            }
            function CMt(e, t, r, n) {
                for(var i = null, a = VSe(e), o = 0; o < a.length; o++){
                    var s = NSe(a[o], 2), l = s[0], u = s[1];
                    if (J0(l) === "object" && l !== null) i === null && (i = new Set), i.add(l);
                    else {
                        var c = t.get(l);
                        if (c === void 0 && !t.has(l) || !$0(u, c, r, n)) {
                            if (r || !EMt(e, t, l, u, n)) return !1;
                            i === null && (i = new Set), i.add(l);
                        }
                    }
                }
                if (i !== null) {
                    for(var f = VSe(t), h = 0; h < f.length; h++){
                        var d = NSe(f[h], 2), v = d[0], x = d[1];
                        if (J0(v) === "object" && v !== null) {
                            if (!$Se(i, e, v, x, r, n)) return !1;
                        } else if (!r && (!e.has(v) || !$0(e.get(v), x, !1, n)) && !$Se(i, e, v, x, !1, n)) return !1;
                    }
                    return i.size === 0;
                }
                return !0;
            }
            function LMt(e, t, r, n, i, a) {
                var o = 0;
                if (a === tMe) {
                    if (!kMt(e, t, r, i)) return !1;
                } else if (a === rMe) {
                    if (!CMt(e, t, r, i)) return !1;
                } else if (a === Vj) for(; o < e.length; o++)if (fE(e, o)) {
                    if (!fE(t, o) || !$0(e[o], t[o], r, i)) return !1;
                } else {
                    if (fE(t, o)) return !1;
                    for(var s = Object.keys(e); o < s.length; o++){
                        var l = s[o];
                        if (!fE(t, l) || !$0(e[l], t[l], r, i)) return !1;
                    }
                    return s.length === Object.keys(t).length;
                }
                for(o = 0; o < n.length; o++){
                    var u = n[o];
                    if (!$0(e[u], t[u], r, i)) return !1;
                }
                return !0;
            }
            function PMt(e, t) {
                return $0(e, t, xMt);
            }
            function IMt(e, t) {
                return $0(e, t, _Mt);
            }
            nMe.exports = {
                isDeepEqual: PMt,
                isDeepStrictEqual: IMt
            };
        });
        var tE = ye((Icr, TMe)=>{
            "use strict";
            function jg(e) {
                "@babel/helpers - typeof";
                return jg = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                }, jg(e);
            }
            function oMe(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, DMt(n.key), n);
                }
            }
            function RMt(e, t, r) {
                return t && oMe(e.prototype, t), r && oMe(e, r), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), e;
            }
            function DMt(e) {
                var t = zMt(e, "string");
                return jg(t) === "symbol" ? t : String(t);
            }
            function zMt(e, t) {
                if (jg(e) !== "object" || e === null) return e;
                var r = e[Symbol.toPrimitive];
                if (r !== void 0) {
                    var n = r.call(e, t || "default");
                    if (jg(n) !== "object") return n;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (t === "string" ? String : Number)(e);
            }
            function FMt(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            var qMt = Ej(), hE = qMt.codes, sMe = hE.ERR_AMBIGUOUS_ARGUMENT, v5 = hE.ERR_INVALID_ARG_TYPE, OMt = hE.ERR_INVALID_ARG_VALUE, BMt = hE.ERR_INVALID_RETURN_VALUE, U_ = hE.ERR_MISSING_ARGS, V_ = KAe(), NMt = h5(), ZR = NMt.inspect, fMe = h5().types, UMt = fMe.isPromise, XR = fMe.isRegExp, VMt = ySe()(), hMe = BR()(), YR = i5()("RegExp.prototype.test"), N_, KR;
            function dE() {
                var e = aMe();
                N_ = e.isDeepEqual, KR = e.isDeepStrictEqual;
            }
            var lMe = !1, sf = TMe.exports = Hj, JR = {};
            function Wg(e) {
                throw e.message instanceof Error ? e.message : new V_(e);
            }
            function dMe(e, t, r, n, i) {
                var a = arguments.length, o;
                if (a === 0) o = "Failed";
                else if (a === 1) r = e, e = void 0;
                else {
                    if (lMe === !1) {
                        lMe = !0;
                        var s = $d3c1734dacb01657$exports.emitWarning ? $d3c1734dacb01657$exports.emitWarning : console.warn.bind(console);
                        s("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
                    }
                    a === 2 && (n = "!=");
                }
                if (r instanceof Error) throw r;
                var l = {
                    actual: e,
                    expected: t,
                    operator: n === void 0 ? "fail" : n,
                    stackStartFn: i || dMe
                };
                r !== void 0 && (l.message = r);
                var u = new V_(l);
                throw o && (u.message = o, u.generatedMessage = !0), u;
            }
            sf.fail = dMe;
            sf.AssertionError = V_;
            function vMe(e, t, r, n) {
                if (!r) {
                    var i = !1;
                    if (t === 0) i = !0, n = "No value argument passed to `assert.ok()`";
                    else if (n instanceof Error) throw n;
                    var a = new V_({
                        actual: r,
                        expected: !0,
                        message: n,
                        operator: "==",
                        stackStartFn: e
                    });
                    throw a.generatedMessage = i, a;
                }
            }
            function Hj() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                vMe.apply(void 0, [
                    Hj,
                    t.length
                ].concat(t));
            }
            sf.ok = Hj;
            sf.equal = function e(t, r, n) {
                if (arguments.length < 2) throw new U_("actual", "expected");
                t != r && Wg({
                    actual: t,
                    expected: r,
                    message: n,
                    operator: "==",
                    stackStartFn: e
                });
            };
            sf.notEqual = function e(t, r, n) {
                if (arguments.length < 2) throw new U_("actual", "expected");
                t == r && Wg({
                    actual: t,
                    expected: r,
                    message: n,
                    operator: "!=",
                    stackStartFn: e
                });
            };
            sf.deepEqual = function e(t, r, n) {
                if (arguments.length < 2) throw new U_("actual", "expected");
                N_ === void 0 && dE(), N_(t, r) || Wg({
                    actual: t,
                    expected: r,
                    message: n,
                    operator: "deepEqual",
                    stackStartFn: e
                });
            };
            sf.notDeepEqual = function e(t, r, n) {
                if (arguments.length < 2) throw new U_("actual", "expected");
                N_ === void 0 && dE(), N_(t, r) && Wg({
                    actual: t,
                    expected: r,
                    message: n,
                    operator: "notDeepEqual",
                    stackStartFn: e
                });
            };
            sf.deepStrictEqual = function e(t, r, n) {
                if (arguments.length < 2) throw new U_("actual", "expected");
                N_ === void 0 && dE(), KR(t, r) || Wg({
                    actual: t,
                    expected: r,
                    message: n,
                    operator: "deepStrictEqual",
                    stackStartFn: e
                });
            };
            sf.notDeepStrictEqual = pMe;
            function pMe(e, t, r) {
                if (arguments.length < 2) throw new U_("actual", "expected");
                N_ === void 0 && dE(), KR(e, t) && Wg({
                    actual: e,
                    expected: t,
                    message: r,
                    operator: "notDeepStrictEqual",
                    stackStartFn: pMe
                });
            }
            sf.strictEqual = function e(t, r, n) {
                if (arguments.length < 2) throw new U_("actual", "expected");
                hMe(t, r) || Wg({
                    actual: t,
                    expected: r,
                    message: n,
                    operator: "strictEqual",
                    stackStartFn: e
                });
            };
            sf.notStrictEqual = function e(t, r, n) {
                if (arguments.length < 2) throw new U_("actual", "expected");
                hMe(t, r) && Wg({
                    actual: t,
                    expected: r,
                    message: n,
                    operator: "notStrictEqual",
                    stackStartFn: e
                });
            };
            var uMe = RMt(function e(t, r, n) {
                var i = this;
                FMt(this, e), r.forEach(function(a) {
                    a in t && (n !== void 0 && typeof n[a] == "string" && XR(t[a]) && YR(t[a], n[a]) ? i[a] = n[a] : i[a] = t[a]);
                });
            });
            function HMt(e, t, r, n, i, a) {
                if (!(r in e) || !KR(e[r], t[r])) {
                    if (!n) {
                        var o = new uMe(e, i), s = new uMe(t, i, e), l = new V_({
                            actual: o,
                            expected: s,
                            operator: "deepStrictEqual",
                            stackStartFn: a
                        });
                        throw l.actual = e, l.expected = t, l.operator = a.name, l;
                    }
                    Wg({
                        actual: e,
                        expected: t,
                        message: n,
                        operator: a.name,
                        stackStartFn: a
                    });
                }
            }
            function gMe(e, t, r, n) {
                if (typeof t != "function") {
                    if (XR(t)) return YR(t, e);
                    if (arguments.length === 2) throw new v5("expected", [
                        "Function",
                        "RegExp"
                    ], t);
                    if (jg(e) !== "object" || e === null) {
                        var i = new V_({
                            actual: e,
                            expected: t,
                            message: r,
                            operator: "deepStrictEqual",
                            stackStartFn: n
                        });
                        throw i.operator = n.name, i;
                    }
                    var a = Object.keys(t);
                    if (t instanceof Error) a.push("name", "message");
                    else if (a.length === 0) throw new OMt("error", t, "may not be an empty object");
                    return N_ === void 0 && dE(), a.forEach(function(o) {
                        typeof e[o] == "string" && XR(t[o]) && YR(t[o], e[o]) || HMt(e, t, o, r, a, n);
                    }), !0;
                }
                return t.prototype !== void 0 && e instanceof t ? !0 : Error.isPrototypeOf(t) ? !1 : t.call({}, e) === !0;
            }
            function mMe(e) {
                if (typeof e != "function") throw new v5("fn", "Function", e);
                try {
                    e();
                } catch (t) {
                    return t;
                }
                return JR;
            }
            function cMe(e) {
                return UMt(e) || e !== null && jg(e) === "object" && typeof e.then == "function" && typeof e.catch == "function";
            }
            function yMe(e) {
                return Promise.resolve().then(function() {
                    var t;
                    if (typeof e == "function") {
                        if (t = e(), !cMe(t)) throw new BMt("instance of Promise", "promiseFn", t);
                    } else if (cMe(e)) t = e;
                    else throw new v5("promiseFn", [
                        "Function",
                        "Promise"
                    ], e);
                    return Promise.resolve().then(function() {
                        return t;
                    }).then(function() {
                        return JR;
                    }).catch(function(r) {
                        return r;
                    });
                });
            }
            function _Me(e, t, r, n) {
                if (typeof r == "string") {
                    if (arguments.length === 4) throw new v5("error", [
                        "Object",
                        "Error",
                        "Function",
                        "RegExp"
                    ], r);
                    if (jg(t) === "object" && t !== null) {
                        if (t.message === r) throw new sMe("error/message", 'The error message "'.concat(t.message, '" is identical to the message.'));
                    } else if (t === r) throw new sMe("error/message", 'The error "'.concat(t, '" is identical to the message.'));
                    n = r, r = void 0;
                } else if (r != null && jg(r) !== "object" && typeof r != "function") throw new v5("error", [
                    "Object",
                    "Error",
                    "Function",
                    "RegExp"
                ], r);
                if (t === JR) {
                    var i = "";
                    r && r.name && (i += " (".concat(r.name, ")")), i += n ? ": ".concat(n) : ".";
                    var a = e.name === "rejects" ? "rejection" : "exception";
                    Wg({
                        actual: void 0,
                        expected: r,
                        operator: e.name,
                        message: "Missing expected ".concat(a).concat(i),
                        stackStartFn: e
                    });
                }
                if (r && !gMe(t, r, n, e)) throw t;
            }
            function xMe(e, t, r, n) {
                if (t !== JR) {
                    if (typeof r == "string" && (n = r, r = void 0), !r || gMe(t, r)) {
                        var i = n ? ": ".concat(n) : ".", a = e.name === "doesNotReject" ? "rejection" : "exception";
                        Wg({
                            actual: t,
                            expected: r,
                            operator: e.name,
                            message: "Got unwanted ".concat(a).concat(i, `
`) + 'Actual message: "'.concat(t && t.message, '"'),
                            stackStartFn: e
                        });
                    }
                    throw t;
                }
            }
            sf.throws = function e(t) {
                for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                _Me.apply(void 0, [
                    e,
                    mMe(t)
                ].concat(n));
            };
            sf.rejects = function e(t) {
                for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                return yMe(t).then(function(a) {
                    return _Me.apply(void 0, [
                        e,
                        a
                    ].concat(n));
                });
            };
            sf.doesNotThrow = function e(t) {
                for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                xMe.apply(void 0, [
                    e,
                    mMe(t)
                ].concat(n));
            };
            sf.doesNotReject = function e(t) {
                for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                return yMe(t).then(function(a) {
                    return xMe.apply(void 0, [
                        e,
                        a
                    ].concat(n));
                });
            };
            sf.ifError = function e(t) {
                if (t != null) {
                    var r = "ifError got unwanted exception: ";
                    jg(t) === "object" && typeof t.message == "string" ? t.message.length === 0 && t.constructor ? r += t.constructor.name : r += t.message : r += ZR(t);
                    var n = new V_({
                        actual: t,
                        expected: null,
                        operator: "ifError",
                        message: r,
                        stackStartFn: e
                    }), i = t.stack;
                    if (typeof i == "string") {
                        var a = i.split(`
`);
                        a.shift();
                        for(var o = n.stack.split(`
`), s = 0; s < a.length; s++){
                            var l = o.indexOf(a[s]);
                            if (l !== -1) {
                                o = o.slice(0, l);
                                break;
                            }
                        }
                        n.stack = "".concat(o.join(`
`), `
`).concat(a.join(`
`));
                    }
                    throw n;
                }
            };
            function bMe(e, t, r, n, i) {
                if (!XR(t)) throw new v5("regexp", "RegExp", t);
                var a = i === "match";
                if (typeof e != "string" || YR(t, e) !== a) {
                    if (r instanceof Error) throw r;
                    var o = !r;
                    r = r || (typeof e != "string" ? 'The "string" argument must be of type string. Received type ' + "".concat(jg(e), " (").concat(ZR(e), ")") : (a ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat(ZR(t), `. Input:

`).concat(ZR(e), `
`));
                    var s = new V_({
                        actual: e,
                        expected: t,
                        message: r,
                        operator: i,
                        stackStartFn: n
                    });
                    throw s.generatedMessage = o, s;
                }
            }
            sf.match = function e(t, r, n) {
                bMe(t, r, n, e, "match");
            };
            sf.doesNotMatch = function e(t, r, n) {
                bMe(t, r, n, e, "doesNotMatch");
            };
            function wMe() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                vMe.apply(void 0, [
                    wMe,
                    t.length
                ].concat(t));
            }
            sf.strict = VMt(wMe, sf, {
                equal: sf.strictEqual,
                deepEqual: sf.deepStrictEqual,
                notEqual: sf.notStrictEqual,
                notDeepEqual: sf.notDeepStrictEqual
            });
            sf.strict.strict = sf.strict;
        });
        var SMe = ye((Rcr, AMe)=>{
            var vE = 1e3, pE = vE * 60, gE = pE * 60, mE = gE * 24, GMt = mE * 365.25;
            AMe.exports = function(e, t) {
                t = t || {};
                var r = typeof e;
                if (r === "string" && e.length > 0) return jMt(e);
                if (r === "number" && isNaN(e) === !1) return t.long ? ZMt(e) : WMt(e);
                throw new Error("val is not a non-empty string or a valid number. val=" + JSON.stringify(e));
            };
            function jMt(e) {
                if (e = String(e), !(e.length > 100)) {
                    var t = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(e);
                    if (t) {
                        var r = parseFloat(t[1]), n = (t[2] || "ms").toLowerCase();
                        switch(n){
                            case "years":
                            case "year":
                            case "yrs":
                            case "yr":
                            case "y":
                                return r * GMt;
                            case "days":
                            case "day":
                            case "d":
                                return r * mE;
                            case "hours":
                            case "hour":
                            case "hrs":
                            case "hr":
                            case "h":
                                return r * gE;
                            case "minutes":
                            case "minute":
                            case "mins":
                            case "min":
                            case "m":
                                return r * pE;
                            case "seconds":
                            case "second":
                            case "secs":
                            case "sec":
                            case "s":
                                return r * vE;
                            case "milliseconds":
                            case "millisecond":
                            case "msecs":
                            case "msec":
                            case "ms":
                                return r;
                            default:
                                return;
                        }
                    }
                }
            }
            function WMt(e) {
                return e >= mE ? Math.round(e / mE) + "d" : e >= gE ? Math.round(e / gE) + "h" : e >= pE ? Math.round(e / pE) + "m" : e >= vE ? Math.round(e / vE) + "s" : e + "ms";
            }
            function ZMt(e) {
                return $R(e, mE, "day") || $R(e, gE, "hour") || $R(e, pE, "minute") || $R(e, vE, "second") || e + " ms";
            }
            function $R(e, t, r) {
                if (!(e < t)) return e < t * 1.5 ? Math.floor(e / t) + " " + r : Math.ceil(e / t) + " " + r + "s";
            }
        });
        var EMe = ye(($u, MMe)=>{
            $u = MMe.exports = jj.debug = jj.default = jj;
            $u.coerce = $Mt;
            $u.disable = KMt;
            $u.enable = YMt;
            $u.enabled = JMt;
            $u.humanize = SMe();
            $u.names = [];
            $u.skips = [];
            $u.formatters = {};
            var Gj;
            function XMt(e) {
                var t = 0, r;
                for(r in e)t = (t << 5) - t + e.charCodeAt(r), t |= 0;
                return $u.colors[Math.abs(t) % $u.colors.length];
            }
            function jj(e) {
                function t() {
                    if (t.enabled) {
                        var r = t, n = +new Date, i = n - (Gj || n);
                        r.diff = i, r.prev = Gj, r.curr = n, Gj = n;
                        for(var a = new Array(arguments.length), o = 0; o < a.length; o++)a[o] = arguments[o];
                        a[0] = $u.coerce(a[0]), typeof a[0] != "string" && a.unshift("%O");
                        var s = 0;
                        a[0] = a[0].replace(/%([a-zA-Z%])/g, function(u, c) {
                            if (u === "%%") return u;
                            s++;
                            var f = $u.formatters[c];
                            if (typeof f == "function") {
                                var h = a[s];
                                u = f.call(r, h), a.splice(s, 1), s--;
                            }
                            return u;
                        }), $u.formatArgs.call(r, a);
                        var l = t.log || $u.log || console.log.bind(console);
                        l.apply(r, a);
                    }
                }
                return t.namespace = e, t.enabled = $u.enabled(e), t.useColors = $u.useColors(), t.color = XMt(e), typeof $u.init == "function" && $u.init(t), t;
            }
            function YMt(e) {
                $u.save(e), $u.names = [], $u.skips = [];
                for(var t = (typeof e == "string" ? e : "").split(/[\s,]+/), r = t.length, n = 0; n < r; n++)t[n] && (e = t[n].replace(/\*/g, ".*?"), e[0] === "-" ? $u.skips.push(new RegExp("^" + e.substr(1) + "$")) : $u.names.push(new RegExp("^" + e + "$")));
            }
            function KMt() {
                $u.enable("");
            }
            function JMt(e) {
                var t, r;
                for(t = 0, r = $u.skips.length; t < r; t++)if ($u.skips[t].test(e)) return !1;
                for(t = 0, r = $u.names.length; t < r; t++)if ($u.names[t].test(e)) return !0;
                return !1;
            }
            function $Mt(e) {
                return e instanceof Error ? e.stack || e.message : e;
            }
        });
        var LMe = ye((lp, CMe)=>{
            lp = CMe.exports = EMe();
            lp.log = t4t;
            lp.formatArgs = e4t;
            lp.save = r4t;
            lp.load = kMe;
            lp.useColors = QMt;
            lp.storage = typeof chrome != "undefined" && typeof chrome.storage != "undefined" ? chrome.storage.local : i4t();
            lp.colors = [
                "lightseagreen",
                "forestgreen",
                "goldenrod",
                "dodgerblue",
                "darkorchid",
                "crimson"
            ];
            function QMt() {
                return typeof window != "undefined" && window.process && window.process.type === "renderer" ? !0 : typeof document != "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window != "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator != "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
            }
            lp.formatters.j = function(e) {
                try {
                    return JSON.stringify(e);
                } catch (t) {
                    return "[UnexpectedJSONParseError]: " + t.message;
                }
            };
            function e4t(e) {
                var t = this.useColors;
                if (e[0] = (t ? "%c" : "") + this.namespace + (t ? " %c" : " ") + e[0] + (t ? "%c " : " ") + "+" + lp.humanize(this.diff), !!t) {
                    var r = "color: " + this.color;
                    e.splice(1, 0, r, "color: inherit");
                    var n = 0, i = 0;
                    e[0].replace(/%[a-zA-Z%]/g, function(a) {
                        a !== "%%" && (n++, a === "%c" && (i = n));
                    }), e.splice(i, 0, r);
                }
            }
            function t4t() {
                return typeof console == "object" && console.log && Function.prototype.apply.call(console.log, console, arguments);
            }
            function r4t(e) {
                try {
                    e == null ? lp.storage.removeItem("debug") : lp.storage.debug = e;
                } catch (t) {}
            }
            function kMe() {
                var e;
                try {
                    e = lp.storage.debug;
                } catch (t) {}
                return e, e;
            }
            lp.enable(kMe());
            function i4t() {
                try {
                    return window.localStorage;
                } catch (e) {}
            }
        });
        var OMe = ye((Dcr, qMe)=>{
            var p5 = tE(), H_ = LMe()("stream-parser");
            qMe.exports = a4t;
            var IMe = -1, QR = 0, n4t = 1, RMe = 2;
            function a4t(e) {
                var t = e && typeof e._transform == "function", r = e && typeof e._write == "function";
                if (!t && !r) throw new Error("must pass a Writable or Transform stream in");
                H_("extending Parser into stream"), e._bytes = o4t, e._skipBytes = s4t, t && (e._passthrough = l4t), t ? e._transform = c4t : e._write = u4t;
            }
            function yE(e) {
                H_("initializing parser stream"), e._parserBytesLeft = 0, e._parserBuffers = [], e._parserBuffered = 0, e._parserState = IMe, e._parserCallback = null, typeof e.push == "function" && (e._parserOutput = e.push.bind(e)), e._parserInit = !0;
            }
            function o4t(e, t) {
                p5(!this._parserCallback, 'there is already a "callback" set!'), p5(isFinite(e) && e > 0, 'can only buffer a finite number of bytes > 0, got "' + e + '"'), this._parserInit || yE(this), H_("buffering %o bytes", e), this._parserBytesLeft = e, this._parserCallback = t, this._parserState = QR;
            }
            function s4t(e, t) {
                p5(!this._parserCallback, 'there is already a "callback" set!'), p5(e > 0, 'can only skip > 0 bytes, got "' + e + '"'), this._parserInit || yE(this), H_("skipping %o bytes", e), this._parserBytesLeft = e, this._parserCallback = t, this._parserState = n4t;
            }
            function l4t(e, t) {
                p5(!this._parserCallback, 'There is already a "callback" set!'), p5(e > 0, 'can only pass through > 0 bytes, got "' + e + '"'), this._parserInit || yE(this), H_("passing through %o bytes", e), this._parserBytesLeft = e, this._parserCallback = t, this._parserState = RMe;
            }
            function u4t(e, t, r) {
                this._parserInit || yE(this), H_("write(%o bytes)", e.length), typeof t == "function" && (r = t), zMe(this, e, null, r);
            }
            function c4t(e, t, r) {
                this._parserInit || yE(this), H_("transform(%o bytes)", e.length), typeof t != "function" && (t = this._parserOutput), zMe(this, e, t, r);
            }
            function DMe(e, t, r, n) {
                return e._parserBytesLeft <= 0 ? n(new Error("got data but not currently parsing anything")) : t.length <= e._parserBytesLeft ? function() {
                    return PMe(e, t, r, n);
                } : function() {
                    var i = t.slice(0, e._parserBytesLeft);
                    return PMe(e, i, r, function(a) {
                        if (a) return n(a);
                        if (t.length > i.length) return function() {
                            return DMe(e, t.slice(i.length), r, n);
                        };
                    });
                };
            }
            function PMe(e, t, r, n) {
                if (e._parserBytesLeft -= t.length, H_("%o bytes left for stream piece", e._parserBytesLeft), e._parserState === QR ? (e._parserBuffers.push(t), e._parserBuffered += t.length) : e._parserState === RMe && r(t), e._parserBytesLeft === 0) {
                    var i = e._parserCallback;
                    if (i && e._parserState === QR && e._parserBuffers.length > 1 && (t = $a765ec5880d44928$require$Buffer.concat(e._parserBuffers, e._parserBuffered)), e._parserState !== QR && (t = null), e._parserCallback = null, e._parserBuffered = 0, e._parserState = IMe, e._parserBuffers.splice(0), i) {
                        var a = [];
                        t && a.push(t), r && a.push(r);
                        var o = i.length > a.length;
                        o && a.push(FMe(n));
                        var s = i.apply(e, a);
                        if (!o || n === s) return n;
                    }
                } else return n;
            }
            var zMe = FMe(DMe);
            function FMe(e) {
                return function() {
                    for(var t = e.apply(this, arguments); typeof t == "function";)t = t();
                    return t;
                };
            }
        });
        var Eu = ye((Gy)=>{
            "use strict";
            var BMe = PAe().Transform, f4t = OMe();
            function _E() {
                BMe.call(this, {
                    readableObjectMode: !0
                });
            }
            _E.prototype = Object.create(BMe.prototype);
            _E.prototype.constructor = _E;
            f4t(_E.prototype);
            Gy.ParserStream = _E;
            Gy.sliceEq = function(e, t, r) {
                for(var n = t, i = 0; i < r.length;)if (e[n++] !== r[i++]) return !1;
                return !0;
            };
            Gy.str2arr = function(e, t) {
                var r = [], n = 0;
                if (t && t === "hex") for(; n < e.length;)r.push(parseInt(e.slice(n, n + 2), 16)), n += 2;
                else for(; n < e.length; n++)r.push(e.charCodeAt(n) & 255);
                return r;
            };
            Gy.readUInt16LE = function(e, t) {
                return e[t] | e[t + 1] << 8;
            };
            Gy.readUInt16BE = function(e, t) {
                return e[t + 1] | e[t] << 8;
            };
            Gy.readUInt32LE = function(e, t) {
                return e[t] | e[t + 1] << 8 | e[t + 2] << 16 | e[t + 3] * 16777216;
            };
            Gy.readUInt32BE = function(e, t) {
                return e[t + 3] | e[t + 2] << 8 | e[t + 1] << 16 | e[t] * 16777216;
            };
            function eD(e, t, r) {
                Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack || "", this.name = this.constructor.name, this.message = e, t && (this.code = t), r && (this.statusCode = r);
            }
            eD.prototype = Object.create(Error.prototype);
            eD.prototype.constructor = eD;
            Gy.ProbeError = eD;
        });
        var NMe = ye((Fcr, tD)=>{
            "use strict";
            var g5 = Eu().readUInt16BE, Zj = Eu().readUInt32BE;
            function xE(e, t) {
                if (e.length < 4 + t) return null;
                var r = Zj(e, t);
                return e.length < r + t || r < 8 ? null : {
                    boxtype: String.fromCharCode.apply(null, e.slice(t + 4, t + 8)),
                    data: e.slice(t + 8, t + r),
                    end: t + r
                };
            }
            tD.exports.unbox = xE;
            function h4t(e, t) {
                for(var r = 0;;){
                    var n = xE(e, r);
                    if (!n) break;
                    switch(n.boxtype){
                        case "ispe":
                            t.sizes.push({
                                width: Zj(n.data, 4),
                                height: Zj(n.data, 8)
                            });
                            break;
                        case "irot":
                            t.transforms.push({
                                type: "irot",
                                value: n.data[0] & 3
                            });
                            break;
                        case "imir":
                            t.transforms.push({
                                type: "imir",
                                value: n.data[0] & 1
                            });
                            break;
                    }
                    r = n.end;
                }
            }
            function Wj(e, t, r) {
                for(var n = 0, i = 0; i < r; i++)n = n * 256 + (e[t + i] || 0);
                return n;
            }
            function d4t(e, t) {
                for(var r = e[4] >> 4 & 15, n = e[4] & 15, i = e[5] >> 4 & 15, a = g5(e, 6), o = 8, s = 0; s < a; s++){
                    var l = g5(e, o);
                    o += 2;
                    var u = g5(e, o);
                    o += 2;
                    var c = Wj(e, o, i);
                    o += i;
                    var f = g5(e, o);
                    if (o += 2, u === 0 && f === 1) {
                        var h = Wj(e, o, r), d = Wj(e, o + r, n);
                        t.item_loc[l] = {
                            length: d,
                            offset: h + c
                        };
                    }
                    o += f * (r + n);
                }
            }
            function v4t(e, t) {
                for(var r = g5(e, 4), n = 6, i = 0; i < r; i++){
                    var a = xE(e, n);
                    if (!a) break;
                    if (a.boxtype === "infe") {
                        for(var o = g5(a.data, 4), s = "", l = 8; l < a.data.length && a.data[l]; l++)s += String.fromCharCode(a.data[l]);
                        t.item_inf[s] = o;
                    }
                    n = a.end;
                }
            }
            function p4t(e, t) {
                for(var r = 0;;){
                    var n = xE(e, r);
                    if (!n) break;
                    n.boxtype === "ipco" && h4t(n.data, t), r = n.end;
                }
            }
            function g4t(e, t) {
                for(var r = 4;;){
                    var n = xE(e, r);
                    if (!n) break;
                    n.boxtype === "iprp" && p4t(n.data, t), n.boxtype === "iloc" && d4t(n.data, t), n.boxtype === "iinf" && v4t(n.data, t), r = n.end;
                }
            }
            function m4t(e) {
                var t = e.reduce(function(i, a) {
                    return i.width > a.width || i.width === a.width && i.height > a.height ? i : a;
                }), r = e.reduce(function(i, a) {
                    return i.height > a.height || i.height === a.height && i.width > a.width ? i : a;
                }), n;
                return t.width > r.height || t.width === r.height && t.height > r.width ? n = t : n = r, n;
            }
            tD.exports.readSizeFromMeta = function(e) {
                var t = {
                    sizes: [],
                    transforms: [],
                    item_inf: {},
                    item_loc: {}
                };
                if (g4t(e, t), !!t.sizes.length) {
                    var r = m4t(t.sizes), n = 1;
                    t.transforms.forEach(function(a) {
                        var o = {
                            1: 6,
                            2: 5,
                            3: 8,
                            4: 7,
                            5: 4,
                            6: 3,
                            7: 2,
                            8: 1
                        }, s = {
                            1: 4,
                            2: 3,
                            3: 2,
                            4: 1,
                            5: 6,
                            6: 5,
                            7: 8,
                            8: 7
                        };
                        if (a.type === "imir" && (a.value === 0 ? n = s[n] : (n = s[n], n = o[n], n = o[n])), a.type === "irot") for(var l = 0; l < a.value; l++)n = o[n];
                    });
                    var i = null;
                    return t.item_inf.Exif && (i = t.item_loc[t.item_inf.Exif]), {
                        width: r.width,
                        height: r.height,
                        orientation: t.transforms.length ? n : null,
                        variants: t.sizes,
                        exif_location: i
                    };
                }
            };
            tD.exports.getMimeType = function(e) {
                var t = String.fromCharCode.apply(null, e.slice(0, 4)), r = {};
                r[t] = !0;
                for(var n = 8; n < e.length; n += 4)r[String.fromCharCode.apply(null, e.slice(n, n + 4))] = !0;
                if (!(!r.mif1 && !r.msf1 && !r.miaf)) return t === "avif" || t === "avis" || t === "avio" ? {
                    type: "avif",
                    mime: "image/avif"
                } : t === "heic" || t === "heix" ? {
                    type: "heic",
                    mime: "image/heic"
                } : t === "hevc" || t === "hevx" ? {
                    type: "heic",
                    mime: "image/heic-sequence"
                } : r.avif || r.avis ? {
                    type: "avif",
                    mime: "image/avif"
                } : r.heic || r.heix || r.hevc || r.hevx || r.heis ? r.msf1 ? {
                    type: "heif",
                    mime: "image/heif-sequence"
                } : {
                    type: "heif",
                    mime: "image/heif"
                } : {
                    type: "avif",
                    mime: "image/avif"
                };
            };
        });
        var iD = ye((qcr, Xj)=>{
            "use strict";
            function rD(e, t) {
                var r = new Error(e);
                return r.code = t, r;
            }
            function y4t(e) {
                try {
                    return decodeURIComponent(escape(e));
                } catch (t) {
                    return e;
                }
            }
            function jy(e, t, r) {
                this.input = e.subarray(t, r), this.start = t;
                var n = String.fromCharCode.apply(null, this.input.subarray(0, 4));
                if (n !== "II*\0" && n !== "MM\0*") throw rD("invalid TIFF signature", "EBADDATA");
                this.big_endian = n[0] === "M";
            }
            jy.prototype.each = function(e) {
                this.aborted = !1;
                var t = this.read_uint32(4);
                for(this.ifds_to_read = [
                    {
                        id: 0,
                        offset: t
                    }
                ]; this.ifds_to_read.length > 0 && !this.aborted;){
                    var r = this.ifds_to_read.shift();
                    r.offset && this.scan_ifd(r.id, r.offset, e);
                }
            };
            jy.prototype.read_uint16 = function(e) {
                var t = this.input;
                if (e + 2 > t.length) throw rD("unexpected EOF", "EBADDATA");
                return this.big_endian ? t[e] * 256 + t[e + 1] : t[e] + t[e + 1] * 256;
            };
            jy.prototype.read_uint32 = function(e) {
                var t = this.input;
                if (e + 4 > t.length) throw rD("unexpected EOF", "EBADDATA");
                return this.big_endian ? t[e] * 16777216 + t[e + 1] * 65536 + t[e + 2] * 256 + t[e + 3] : t[e] + t[e + 1] * 256 + t[e + 2] * 65536 + t[e + 3] * 16777216;
            };
            jy.prototype.is_subifd_link = function(e, t) {
                return e === 0 && t === 34665 || e === 0 && t === 34853 || e === 34665 && t === 40965;
            };
            jy.prototype.exif_format_length = function(e) {
                switch(e){
                    case 1:
                    case 2:
                    case 6:
                    case 7:
                        return 1;
                    case 3:
                    case 8:
                        return 2;
                    case 4:
                    case 9:
                    case 11:
                        return 4;
                    case 5:
                    case 10:
                    case 12:
                        return 8;
                    default:
                        return 0;
                }
            };
            jy.prototype.exif_format_read = function(e, t) {
                var r;
                switch(e){
                    case 1:
                    case 2:
                        return r = this.input[t], r;
                    case 6:
                        return r = this.input[t], r | (r & 128) * 33554430;
                    case 3:
                        return r = this.read_uint16(t), r;
                    case 8:
                        return r = this.read_uint16(t), r | (r & 32768) * 131070;
                    case 4:
                        return r = this.read_uint32(t), r;
                    case 9:
                        return r = this.read_uint32(t), r | 0;
                    case 5:
                    case 10:
                    case 11:
                    case 12:
                        return null;
                    case 7:
                        return null;
                    default:
                        return null;
                }
            };
            jy.prototype.scan_ifd = function(e, t, r) {
                var n = this.read_uint16(t);
                t += 2;
                for(var i = 0; i < n; i++){
                    var a = this.read_uint16(t), o = this.read_uint16(t + 2), s = this.read_uint32(t + 4), l = this.exif_format_length(o), u = s * l, c = u <= 4 ? t + 8 : this.read_uint32(t + 8), f = !1;
                    if (c + u > this.input.length) throw rD("unexpected EOF", "EBADDATA");
                    for(var h = [], d = c, v = 0; v < s; v++, d += l){
                        var x = this.exif_format_read(o, d);
                        if (x === null) {
                            h = null;
                            break;
                        }
                        h.push(x);
                    }
                    Array.isArray(h) && o === 2 && (h = y4t(String.fromCharCode.apply(null, h)), h && h[h.length - 1] === "\0" && (h = h.slice(0, -1))), this.is_subifd_link(e, a) && Array.isArray(h) && Number.isInteger(h[0]) && h[0] > 0 && (this.ifds_to_read.push({
                        id: a,
                        offset: h[0]
                    }), f = !0);
                    var b = {
                        is_big_endian: this.big_endian,
                        ifd: e,
                        tag: a,
                        format: o,
                        count: s,
                        entry_offset: t + this.start,
                        data_length: u,
                        data_offset: c + this.start,
                        value: h,
                        is_subifd_link: f
                    };
                    if (r(b) === !1) {
                        this.aborted = !0;
                        return;
                    }
                    t += 12;
                }
                e === 0 && this.ifds_to_read.push({
                    id: 1,
                    offset: this.read_uint32(t)
                });
            };
            Xj.exports.ExifParser = jy;
            Xj.exports.get_orientation = function(e) {
                var t = 0;
                try {
                    return new jy(e, 0, e.length).each(function(r) {
                        if (r.ifd === 0 && r.tag === 274 && Array.isArray(r.value)) return t = r.value[0], !1;
                    }), t;
                } catch (r) {
                    return -1;
                }
            };
        });
        var VMe = ye((Ocr, UMe)=>{
            "use strict";
            var _4t = Eu().str2arr, x4t = Eu().sliceEq, b4t = Eu().readUInt32BE, nD = NMe(), w4t = iD(), T4t = _4t("ftyp");
            UMe.exports = function(e) {
                if (x4t(e, 4, T4t)) {
                    var t = nD.unbox(e, 0);
                    if (t) {
                        var r = nD.getMimeType(t.data);
                        if (r) {
                            for(var n, i = t.end;;){
                                var a = nD.unbox(e, i);
                                if (!a) break;
                                if (i = a.end, a.boxtype === "mdat") return;
                                if (a.boxtype === "meta") {
                                    n = a.data;
                                    break;
                                }
                            }
                            if (n) {
                                var o = nD.readSizeFromMeta(n);
                                if (o) {
                                    var s = {
                                        width: o.width,
                                        height: o.height,
                                        type: r.type,
                                        mime: r.mime,
                                        wUnits: "px",
                                        hUnits: "px"
                                    };
                                    if (o.variants.length > 1 && (s.variants = o.variants), o.orientation && (s.orientation = o.orientation), o.exif_location && o.exif_location.offset + o.exif_location.length <= e.length) {
                                        var l = b4t(e, o.exif_location.offset), u = e.slice(o.exif_location.offset + l + 4, o.exif_location.offset + o.exif_location.length), c = w4t.get_orientation(u);
                                        c > 0 && (s.orientation = c);
                                    }
                                    return s;
                                }
                            }
                        }
                    }
                }
            };
        });
        var jMe = ye((Bcr, GMe)=>{
            "use strict";
            var A4t = Eu().str2arr, S4t = Eu().sliceEq, HMe = Eu().readUInt16LE, M4t = A4t("BM");
            GMe.exports = function(e) {
                if (!(e.length < 26) && S4t(e, 0, M4t)) return {
                    width: HMe(e, 18),
                    height: HMe(e, 22),
                    type: "bmp",
                    mime: "image/bmp",
                    wUnits: "px",
                    hUnits: "px"
                };
            };
        });
        var KMe = ye((Ncr, YMe)=>{
            "use strict";
            var XMe = Eu().str2arr, WMe = Eu().sliceEq, ZMe = Eu().readUInt16LE, E4t = XMe("GIF87a"), k4t = XMe("GIF89a");
            YMe.exports = function(e) {
                if (!(e.length < 10) && !(!WMe(e, 0, E4t) && !WMe(e, 0, k4t))) return {
                    width: ZMe(e, 6),
                    height: ZMe(e, 8),
                    type: "gif",
                    mime: "image/gif",
                    wUnits: "px",
                    hUnits: "px"
                };
            };
        });
        var QMe = ye((Ucr, $Me)=>{
            "use strict";
            var Yj = Eu().readUInt16LE, C4t = 0, L4t = 1, JMe = 16;
            $Me.exports = function(e) {
                var t = Yj(e, 0), r = Yj(e, 2), n = Yj(e, 4);
                if (!(t !== C4t || r !== L4t || !n)) {
                    for(var i = [], a = {
                        width: 0,
                        height: 0
                    }, o = 0; o < n; o++){
                        var s = e[6 + JMe * o] || 256, l = e[6 + JMe * o + 1] || 256, u = {
                            width: s,
                            height: l
                        };
                        i.push(u), (s > a.width || l > a.height) && (a = u);
                    }
                    return {
                        width: a.width,
                        height: a.height,
                        variants: i,
                        type: "ico",
                        mime: "image/x-icon",
                        wUnits: "px",
                        hUnits: "px"
                    };
                }
            };
        });
        var t4e = ye((Vcr, e4e)=>{
            "use strict";
            var Kj = Eu().readUInt16BE, P4t = Eu().str2arr, I4t = Eu().sliceEq, R4t = iD(), D4t = P4t("Exif\0\0");
            e4e.exports = function(e) {
                if (!(e.length < 2) && !(e[0] !== 255 || e[1] !== 216 || e[2] !== 255)) for(var t = 2;;){
                    for(;;){
                        if (e.length - t < 2) return;
                        if (e[t++] === 255) break;
                    }
                    for(var r = e[t++], n; r === 255;)r = e[t++];
                    if (208 <= r && r <= 217 || r === 1) n = 0;
                    else if (192 <= r && r <= 254) {
                        if (e.length - t < 2) return;
                        n = Kj(e, t) - 2, t += 2;
                    } else return;
                    if (r === 217 || r === 218) return;
                    var i;
                    if (r === 225 && n >= 10 && I4t(e, t, D4t) && (i = R4t.get_orientation(e.slice(t + 6, t + n))), n >= 5 && 192 <= r && r <= 207 && r !== 196 && r !== 200 && r !== 204) {
                        if (e.length - t < n) return;
                        var a = {
                            width: Kj(e, t + 3),
                            height: Kj(e, t + 1),
                            type: "jpg",
                            mime: "image/jpeg",
                            wUnits: "px",
                            hUnits: "px"
                        };
                        return i > 0 && (a.orientation = i), a;
                    }
                    t += n;
                }
            };
        });
        var o4e = ye((Hcr, a4e)=>{
            "use strict";
            var n4e = Eu().str2arr, r4e = Eu().sliceEq, i4e = Eu().readUInt32BE, z4t = n4e(`\x89PNG\r

`), F4t = n4e("IHDR");
            a4e.exports = function(e) {
                if (!(e.length < 24) && r4e(e, 0, z4t) && r4e(e, 12, F4t)) return {
                    width: i4e(e, 16),
                    height: i4e(e, 20),
                    type: "png",
                    mime: "image/png",
                    wUnits: "px",
                    hUnits: "px"
                };
            };
        });
        var u4e = ye((Gcr, l4e)=>{
            "use strict";
            var q4t = Eu().str2arr, O4t = Eu().sliceEq, s4e = Eu().readUInt32BE, B4t = q4t("8BPS\0");
            l4e.exports = function(e) {
                if (!(e.length < 22) && O4t(e, 0, B4t)) return {
                    width: s4e(e, 18),
                    height: s4e(e, 14),
                    type: "psd",
                    mime: "image/vnd.adobe.photoshop",
                    wUnits: "px",
                    hUnits: "px"
                };
            };
        });
        var h4e = ye((jcr, f4e)=>{
            "use strict";
            function N4t(e) {
                return e === 32 || e === 9 || e === 13 || e === 10;
            }
            function m5(e) {
                return typeof e == "number" && isFinite(e) && e > 0;
            }
            function U4t(e) {
                var t = 0, r = e.length;
                for(e[0] === 239 && e[1] === 187 && e[2] === 191 && (t = 3); t < r && N4t(e[t]);)t++;
                return t === r ? !1 : e[t] === 60;
            }
            var V4t = /<[-_.:a-zA-Z0-9][^>]*>/, H4t = /^<([-_.:a-zA-Z0-9]+:)?svg\s/, G4t = /[^-]\bwidth="([^%]+?)"|[^-]\bwidth='([^%]+?)'/, j4t = /\bheight="([^%]+?)"|\bheight='([^%]+?)'/, W4t = /\bview[bB]ox="(.+?)"|\bview[bB]ox='(.+?)'/, c4e = /in$|mm$|cm$|pt$|pc$|px$|em$|ex$/;
            function Z4t(e) {
                var t = e.match(G4t), r = e.match(j4t), n = e.match(W4t);
                return {
                    width: t && (t[1] || t[2]),
                    height: r && (r[1] || r[2]),
                    viewbox: n && (n[1] || n[2])
                };
            }
            function Nm(e) {
                return c4e.test(e) ? e.match(c4e)[0] : "px";
            }
            f4e.exports = function(e) {
                if (U4t(e)) {
                    for(var t = "", r = 0; r < e.length; r++)t += String.fromCharCode(e[r]);
                    var n = (t.match(V4t) || [
                        ""
                    ])[0];
                    if (H4t.test(n)) {
                        var i = Z4t(n), a = parseFloat(i.width), o = parseFloat(i.height);
                        if (i.width && i.height) return !m5(a) || !m5(o) ? void 0 : {
                            width: a,
                            height: o,
                            type: "svg",
                            mime: "image/svg+xml",
                            wUnits: Nm(i.width),
                            hUnits: Nm(i.height)
                        };
                        var s = (i.viewbox || "").split(" "), l = {
                            width: s[2],
                            height: s[3]
                        }, u = parseFloat(l.width), c = parseFloat(l.height);
                        if (!(!m5(u) || !m5(c)) && Nm(l.width) === Nm(l.height)) {
                            var f = u / c;
                            return i.width ? m5(a) ? {
                                width: a,
                                height: a / f,
                                type: "svg",
                                mime: "image/svg+xml",
                                wUnits: Nm(i.width),
                                hUnits: Nm(i.width)
                            } : void 0 : i.height ? m5(o) ? {
                                width: o * f,
                                height: o,
                                type: "svg",
                                mime: "image/svg+xml",
                                wUnits: Nm(i.height),
                                hUnits: Nm(i.height)
                            } : void 0 : {
                                width: u,
                                height: c,
                                type: "svg",
                                mime: "image/svg+xml",
                                wUnits: Nm(l.width),
                                hUnits: Nm(l.height)
                            };
                        }
                    }
                }
            };
        });
        var m4e = ye((Wcr, g4e)=>{
            "use strict";
            var p4e = Eu().str2arr, d4e = Eu().sliceEq, X4t = Eu().readUInt16LE, Y4t = Eu().readUInt16BE, K4t = Eu().readUInt32LE, J4t = Eu().readUInt32BE, $4t = p4e("II*\0"), Q4t = p4e("MM\0*");
            function aD(e, t, r) {
                return r ? Y4t(e, t) : X4t(e, t);
            }
            function Jj(e, t, r) {
                return r ? J4t(e, t) : K4t(e, t);
            }
            function v4e(e, t, r) {
                var n = aD(e, t + 2, r), i = Jj(e, t + 4, r);
                return i !== 1 || n !== 3 && n !== 4 ? null : n === 3 ? aD(e, t + 8, r) : Jj(e, t + 8, r);
            }
            g4e.exports = function(e) {
                if (!(e.length < 8) && !(!d4e(e, 0, $4t) && !d4e(e, 0, Q4t))) {
                    var t = e[0] === 77, r = Jj(e, 4, t) - 8;
                    if (!(r < 0)) {
                        var n = r + 8;
                        if (!(e.length - n < 2)) {
                            var i = aD(e, n + 0, t) * 12;
                            if (!(i <= 0) && (n += 2, !(e.length - n < i))) {
                                var a, o, s, l;
                                for(a = 0; a < i; a += 12)l = aD(e, n + a, t), l === 256 ? o = v4e(e, n + a, t) : l === 257 && (s = v4e(e, n + a, t));
                                if (o && s) return {
                                    width: o,
                                    height: s,
                                    type: "tiff",
                                    mime: "image/tiff",
                                    wUnits: "px",
                                    hUnits: "px"
                                };
                            }
                        }
                    }
                }
            };
        });
        var w4e = ye((Zcr, b4e)=>{
            "use strict";
            var x4e = Eu().str2arr, y4e = Eu().sliceEq, _4e = Eu().readUInt16LE, $j = Eu().readUInt32LE, eEt = iD(), tEt = x4e("RIFF"), rEt = x4e("WEBP");
            function iEt(e, t) {
                if (!(e[t + 3] !== 157 || e[t + 4] !== 1 || e[t + 5] !== 42)) return {
                    width: _4e(e, t + 6) & 16383,
                    height: _4e(e, t + 8) & 16383,
                    type: "webp",
                    mime: "image/webp",
                    wUnits: "px",
                    hUnits: "px"
                };
            }
            function nEt(e, t) {
                if (e[t] === 47) {
                    var r = $j(e, t + 1);
                    return {
                        width: (r & 16383) + 1,
                        height: (r >> 14 & 16383) + 1,
                        type: "webp",
                        mime: "image/webp",
                        wUnits: "px",
                        hUnits: "px"
                    };
                }
            }
            function aEt(e, t) {
                return {
                    width: (e[t + 6] << 16 | e[t + 5] << 8 | e[t + 4]) + 1,
                    height: (e[t + 9] << t | e[t + 8] << 8 | e[t + 7]) + 1,
                    type: "webp",
                    mime: "image/webp",
                    wUnits: "px",
                    hUnits: "px"
                };
            }
            b4e.exports = function(e) {
                if (!(e.length < 16) && !(!y4e(e, 0, tEt) && !y4e(e, 8, rEt))) {
                    var t = 12, r = null, n = 0, i = $j(e, 4) + 8;
                    if (!(i > e.length)) {
                        for(; t + 8 < i;){
                            if (e[t] === 0) {
                                t++;
                                continue;
                            }
                            var a = String.fromCharCode.apply(null, e.slice(t, t + 4)), o = $j(e, t + 4);
                            a === "VP8 " && o >= 10 ? r = r || iEt(e, t + 8) : a === "VP8L" && o >= 9 ? r = r || nEt(e, t + 8) : a === "VP8X" && o >= 10 ? r = r || aEt(e, t + 8) : a === "EXIF" && (n = eEt.get_orientation(e.slice(t + 8, t + 8 + o)), t = 1 / 0), t += 8 + o;
                        }
                        if (r) return n > 0 && (r.orientation = n), r;
                    }
                }
            };
        });
        var A4e = ye((Xcr, T4e)=>{
            "use strict";
            T4e.exports = {
                avif: VMe(),
                bmp: jMe(),
                gif: KMe(),
                ico: QMe(),
                jpeg: t4e(),
                png: o4e(),
                psd: u4e(),
                svg: h4e(),
                tiff: m4e(),
                webp: w4e()
            };
        });
        var S4e = ye((Ycr, eW)=>{
            "use strict";
            var Qj = A4e();
            function oEt(e) {
                for(var t = Object.keys(Qj), r = 0; r < t.length; r++){
                    var n = Qj[t[r]](e);
                    if (n) return n;
                }
                return null;
            }
            eW.exports = function(t) {
                return oEt(t);
            };
            eW.exports.parsers = Qj;
        });
        var E4e = ye((M4e)=>{
            "use strict";
            var sEt = S4e(), lEt = Ly().IMAGE_URL_PREFIX, uEt = u2().Buffer;
            M4e.getImageSize = function(e) {
                var t = e.replace(lEt, ""), r = new uEt(t, "base64");
                return sEt(r);
            };
        });
        var L4e = ye((Jcr, C4e)=>{
            "use strict";
            var k4e = Mr(), cEt = jT(), fEt = uo(), oD = Qa(), hEt = Mr().maxRowLength, dEt = E4e().getImageSize;
            C4e.exports = function(t, r) {
                var n, i;
                if (r._hasZ) n = r.z.length, i = hEt(r.z);
                else if (r._hasSource) {
                    var a = dEt(r.source);
                    n = a.height, i = a.width;
                }
                var o = oD.getFromId(t, r.xaxis || "x"), s = oD.getFromId(t, r.yaxis || "y"), l = o.d2c(r.x0) - r.dx / 2, u = s.d2c(r.y0) - r.dy / 2, c, f = [
                    l,
                    l + i * r.dx
                ], h = [
                    u,
                    u + n * r.dy
                ];
                if (o && o.type === "log") for(c = 0; c < i; c++)f.push(l + c * r.dx);
                if (s && s.type === "log") for(c = 0; c < n; c++)h.push(u + c * r.dy);
                r._extremes[o._id] = oD.findExtremes(o, f), r._extremes[s._id] = oD.findExtremes(s, h), r._scaler = gEt(r);
                var d = {
                    x0: l,
                    y0: u,
                    z: r.z,
                    w: i,
                    h: n
                };
                return [
                    d
                ];
            };
            function vEt(e, t, r, n) {
                return function(i) {
                    return k4e.constrain((i - e) * t, r, n);
                };
            }
            function pEt(e, t) {
                return function(r) {
                    return k4e.constrain(r, e, t);
                };
            }
            function gEt(e) {
                var t = cEt.colormodel[e.colormodel], r = t.colormodel || e.colormodel, n = r.length;
                e._sArray = [];
                for(var i = 0; i < n; i++)t.min[i] !== e.zmin[i] || t.max[i] !== e.zmax[i] ? e._sArray.push(vEt(e.zmin[i], (t.max[i] - t.min[i]) / (e.zmax[i] - e.zmin[i]), t.min[i], t.max[i])) : e._sArray.push(pEt(t.min[i], t.max[i]));
                return function(a) {
                    for(var o = a.slice(0, n), s = 0; s < n; s++){
                        var l = o[s];
                        if (!fEt(l)) return !1;
                        o[s] = e._sArray[s](l);
                    }
                    return o;
                };
            }
        });
        var R4e = ye(($cr, I4e)=>{
            "use strict";
            var mEt = xa(), T2 = Mr(), P4e = T2.strTranslate, yEt = Zp(), _Et = jT(), xEt = jV(), bEt = o8().STYLE;
            I4e.exports = function(t, r, n, i) {
                var a = r.xaxis, o = r.yaxis, s = !t._context._exportedPlot && xEt();
                T2.makeTraceGroups(i, n, "im").each(function(l) {
                    var u = mEt.select(this), c = l[0], f = c.trace, h = (f.zsmooth === "fast" || f.zsmooth === !1 && s) && !f._hasZ && f._hasSource && a.type === "linear" && o.type === "linear";
                    f._realImage = h;
                    var d = c.z, v = c.x0, x = c.y0, b = c.w, p = c.h, E = f.dx, k = f.dy, A, L, _, C, M, g;
                    for(g = 0; A === void 0 && g < b;)A = a.c2p(v + g * E), g++;
                    for(g = b; L === void 0 && g > 0;)L = a.c2p(v + g * E), g--;
                    for(g = 0; C === void 0 && g < p;)C = o.c2p(x + g * k), g++;
                    for(g = p; M === void 0 && g > 0;)M = o.c2p(x + g * k), g--;
                    if (L < A && (_ = L, L = A, A = _), M < C && (_ = C, C = M, M = _), !h) {
                        var P = .5;
                        A = Math.max(-P * a._length, A), L = Math.min((1 + P) * a._length, L), C = Math.max(-P * o._length, C), M = Math.min((1 + P) * o._length, M);
                    }
                    var T = Math.round(L - A), F = Math.round(M - C), q = T <= 0 || F <= 0;
                    if (q) {
                        var V = u.selectAll("image").data([]);
                        V.exit().remove();
                        return;
                    }
                    function H(ge) {
                        var ie = document.createElement("canvas");
                        ie.width = T, ie.height = F;
                        var Te = ie.getContext("2d", {
                            willReadFrequently: !0
                        }), Ee = function(rt) {
                            return T2.constrain(Math.round(a.c2p(v + rt * E) - A), 0, T);
                        }, Ae = function(rt) {
                            return T2.constrain(Math.round(o.c2p(x + rt * k) - C), 0, F);
                        }, ze = _Et.colormodel[f.colormodel], Ce = ze.colormodel || f.colormodel, me = ze.fmt, Re;
                        for(g = 0; g < c.w; g++){
                            var ce = Ee(g), Ge = Ee(g + 1);
                            if (!(Ge === ce || isNaN(Ge) || isNaN(ce))) for(var nt = 0; nt < c.h; nt++){
                                var ct = Ae(nt), qt = Ae(nt + 1);
                                qt === ct || isNaN(qt) || isNaN(ct) || !ge(g, nt) || (Re = f._scaler(ge(g, nt)), Re ? Te.fillStyle = Ce + "(" + me(Re).join(",") + ")" : Te.fillStyle = "rgba(0,0,0,0)", Te.fillRect(ce, ct, Ge - ce, qt - ct));
                            }
                        }
                        return ie;
                    }
                    var X = u.selectAll("image").data([
                        l
                    ]);
                    X.enter().append("svg:image").attr({
                        xmlns: yEt.svg,
                        preserveAspectRatio: "none"
                    }), X.exit().remove();
                    var G = f.zsmooth === !1 ? bEt : "";
                    if (h) {
                        var N = T2.simpleMap(a.range, a.r2l), W = T2.simpleMap(o.range, o.r2l), re = N[1] < N[0], ae = W[1] > W[0];
                        if (re || ae) {
                            var _e = A + T / 2, Me = C + F / 2;
                            G += "transform:" + P4e(_e + "px", Me + "px") + "scale(" + (re ? -1 : 1) + "," + (ae ? -1 : 1) + ")" + P4e(-_e + "px", -Me + "px") + ";";
                        }
                    }
                    X.attr("style", G);
                    var ke = new Promise(function(ge) {
                        if (f._hasZ) ge();
                        else if (f._hasSource) {
                            if (f._canvas && f._canvas.el.width === b && f._canvas.el.height === p && f._canvas.source === f.source) ge();
                            else {
                                var ie = document.createElement("canvas");
                                ie.width = b, ie.height = p;
                                var Te = ie.getContext("2d", {
                                    willReadFrequently: !0
                                });
                                f._image = f._image || new Image;
                                var Ee = f._image;
                                Ee.onload = function() {
                                    Te.drawImage(Ee, 0, 0), f._canvas = {
                                        el: ie,
                                        source: f.source
                                    }, ge();
                                }, Ee.setAttribute("src", f.source);
                            }
                        }
                    }).then(function() {
                        var ge, ie;
                        if (f._hasZ) ie = H(function(Ae, ze) {
                            var Ce = d[ze][Ae];
                            return T2.isTypedArray(Ce) && (Ce = Array.from(Ce)), Ce;
                        }), ge = ie.toDataURL("image/png");
                        else if (f._hasSource) {
                            if (h) ge = f.source;
                            else {
                                var Te = f._canvas.el.getContext("2d", {
                                    willReadFrequently: !0
                                }), Ee = Te.getImageData(0, 0, b, p).data;
                                ie = H(function(Ae, ze) {
                                    var Ce = 4 * (ze * b + Ae);
                                    return [
                                        Ee[Ce],
                                        Ee[Ce + 1],
                                        Ee[Ce + 2],
                                        Ee[Ce + 3]
                                    ];
                                }), ge = ie.toDataURL("image/png");
                            }
                        }
                        X.attr({
                            "xlink:href": ge,
                            height: F,
                            width: T,
                            x: A,
                            y: C
                        });
                    });
                    t._promises.push(ke);
                });
            };
        });
        var z4e = ye((Qcr, D4e)=>{
            "use strict";
            var wEt = xa();
            D4e.exports = function(t) {
                wEt.select(t).selectAll(".im image").style("opacity", function(r) {
                    return r[0].trace.opacity;
                });
            };
        });
        var B4e = ye((efr, O4e)=>{
            "use strict";
            var F4e = Nc(), q4e = Mr(), sD = q4e.isArrayOrTypedArray, TEt = jT();
            O4e.exports = function(t, r, n) {
                var i = t.cd[0], a = i.trace, o = t.xa, s = t.ya;
                if (!(F4e.inbox(r - i.x0, r - (i.x0 + i.w * a.dx), 0) > 0 || F4e.inbox(n - i.y0, n - (i.y0 + i.h * a.dy), 0) > 0)) {
                    var l = Math.floor((r - i.x0) / a.dx), u = Math.floor(Math.abs(n - i.y0) / a.dy), c;
                    if (a._hasZ ? c = i.z[u][l] : a._hasSource && (c = a._canvas.el.getContext("2d", {
                        willReadFrequently: !0
                    }).getImageData(l, u, 1, 1).data), !!c) {
                        var f = i.hi || a.hoverinfo, h;
                        if (f) {
                            var d = f.split("+");
                            d.indexOf("all") !== -1 && (d = [
                                "color"
                            ]), d.indexOf("color") !== -1 && (h = !0);
                        }
                        var v = TEt.colormodel[a.colormodel], x = v.colormodel || a.colormodel, b = x.length, p = a._scaler(c), E = v.suffix, k = [];
                        (a.hovertemplate || h) && (k.push("[" + [
                            p[0] + E[0],
                            p[1] + E[1],
                            p[2] + E[2]
                        ].join(", ")), b === 4 && k.push(", " + p[3] + E[3]), k.push("]"), k = k.join(""), t.extraText = x.toUpperCase() + ": " + k);
                        var A;
                        sD(a.hovertext) && sD(a.hovertext[u]) ? A = a.hovertext[u][l] : sD(a.text) && sD(a.text[u]) && (A = a.text[u][l]);
                        var L = s.c2p(i.y0 + (u + .5) * a.dy), _ = i.x0 + (l + .5) * a.dx, C = i.y0 + (u + .5) * a.dy, M = "[" + c.slice(0, a.colormodel.length).join(", ") + "]";
                        return [
                            q4e.extendFlat(t, {
                                index: [
                                    u,
                                    l
                                ],
                                x0: o.c2p(i.x0 + l * a.dx),
                                x1: o.c2p(i.x0 + (l + 1) * a.dx),
                                y0: L,
                                y1: L,
                                color: p,
                                xVal: _,
                                xLabelVal: _,
                                yVal: C,
                                yLabelVal: C,
                                zLabelVal: M,
                                text: A,
                                hovertemplateLabels: {
                                    zLabel: M,
                                    colorLabel: k,
                                    "color[0]Label": p[0] + E[0],
                                    "color[1]Label": p[1] + E[1],
                                    "color[2]Label": p[2] + E[2],
                                    "color[3]Label": p[3] + E[3]
                                }
                            })
                        ];
                    }
                }
            };
        });
        var U4e = ye((tfr, N4e)=>{
            "use strict";
            N4e.exports = function(t, r) {
                return "xVal" in r && (t.x = r.xVal), "yVal" in r && (t.y = r.yVal), r.xa && (t.xaxis = r.xa), r.ya && (t.yaxis = r.ya), t.color = r.color, t.colormodel = r.trace.colormodel, t.z || (t.z = r.color), t;
            };
        });
        var H4e = ye((rfr, V4e)=>{
            "use strict";
            V4e.exports = {
                attributes: tG(),
                supplyDefaults: T3e(),
                calc: L4e(),
                plot: R4e(),
                style: z4e(),
                hoverPoints: B4e(),
                eventData: U4e(),
                moduleType: "trace",
                name: "image",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "2dMap",
                    "noSortingByValue"
                ],
                animatable: !1,
                meta: {}
            };
        });
        var j4e = ye((ifr, G4e)=>{
            "use strict";
            G4e.exports = H4e();
        });
        var A2 = ye((nfr, W4e)=>{
            "use strict";
            var AEt = vl(), SEt = Ju().attributes, MEt = Su(), EEt = dh(), kEt = Wo().hovertemplateAttrs, CEt = Wo().texttemplateAttrs, bE = no().extendFlat, LEt = Ed().pattern, lD = MEt({
                editType: "plot",
                arrayOk: !0,
                colorEditType: "plot"
            });
            W4e.exports = {
                labels: {
                    valType: "data_array",
                    editType: "calc"
                },
                label0: {
                    valType: "number",
                    dflt: 0,
                    editType: "calc"
                },
                dlabel: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc"
                },
                values: {
                    valType: "data_array",
                    editType: "calc"
                },
                marker: {
                    colors: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    line: {
                        color: {
                            valType: "color",
                            dflt: EEt.defaultLine,
                            arrayOk: !0,
                            editType: "style"
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            arrayOk: !0,
                            editType: "style"
                        },
                        editType: "calc"
                    },
                    pattern: LEt,
                    editType: "calc"
                },
                text: {
                    valType: "data_array",
                    editType: "plot"
                },
                hovertext: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0,
                    editType: "style"
                },
                scalegroup: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                textinfo: {
                    valType: "flaglist",
                    flags: [
                        "label",
                        "text",
                        "value",
                        "percent"
                    ],
                    extras: [
                        "none"
                    ],
                    editType: "calc"
                },
                hoverinfo: bE({}, AEt.hoverinfo, {
                    flags: [
                        "label",
                        "text",
                        "value",
                        "percent",
                        "name"
                    ]
                }),
                hovertemplate: kEt({}, {
                    keys: [
                        "label",
                        "color",
                        "value",
                        "percent",
                        "text"
                    ]
                }),
                texttemplate: CEt({
                    editType: "plot"
                }, {
                    keys: [
                        "label",
                        "color",
                        "value",
                        "percent",
                        "text"
                    ]
                }),
                textposition: {
                    valType: "enumerated",
                    values: [
                        "inside",
                        "outside",
                        "auto",
                        "none"
                    ],
                    dflt: "auto",
                    arrayOk: !0,
                    editType: "plot"
                },
                textfont: bE({}, lD, {}),
                insidetextorientation: {
                    valType: "enumerated",
                    values: [
                        "horizontal",
                        "radial",
                        "tangential",
                        "auto"
                    ],
                    dflt: "auto",
                    editType: "plot"
                },
                insidetextfont: bE({}, lD, {}),
                outsidetextfont: bE({}, lD, {}),
                automargin: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "plot"
                },
                title: {
                    text: {
                        valType: "string",
                        dflt: "",
                        editType: "plot"
                    },
                    font: bE({}, lD, {}),
                    position: {
                        valType: "enumerated",
                        values: [
                            "top left",
                            "top center",
                            "top right",
                            "middle center",
                            "bottom left",
                            "bottom center",
                            "bottom right"
                        ],
                        editType: "plot"
                    },
                    editType: "plot"
                },
                domain: SEt({
                    name: "pie",
                    trace: !0,
                    editType: "calc"
                }),
                hole: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 0,
                    editType: "calc"
                },
                sort: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc"
                },
                direction: {
                    valType: "enumerated",
                    values: [
                        "clockwise",
                        "counterclockwise"
                    ],
                    dflt: "counterclockwise",
                    editType: "calc"
                },
                rotation: {
                    valType: "angle",
                    dflt: 0,
                    editType: "calc"
                },
                pull: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 0,
                    arrayOk: !0,
                    editType: "calc"
                }
            };
        });
        var S2 = ye((afr, Y4e)=>{
            "use strict";
            var PEt = uo(), wE = Mr(), IEt = A2(), REt = Ju().defaults, DEt = r0().handleText, zEt = Mr().coercePattern;
            function Z4e(e, t) {
                var r = wE.isArrayOrTypedArray(e), n = wE.isArrayOrTypedArray(t), i = Math.min(r ? e.length : 1 / 0, n ? t.length : 1 / 0);
                if (isFinite(i) || (i = 0), i && n) {
                    for(var a, o = 0; o < i; o++){
                        var s = t[o];
                        if (PEt(s) && s > 0) {
                            a = !0;
                            break;
                        }
                    }
                    a || (i = 0);
                }
                return {
                    hasLabels: r,
                    hasValues: n,
                    len: i
                };
            }
            function X4e(e, t, r, n, i) {
                var a = n("marker.line.width");
                a && n("marker.line.color", i ? void 0 : r.paper_bgcolor);
                var o = n("marker.colors");
                zEt(n, "marker.pattern", o), e.marker && !t.marker.pattern.fgcolor && (t.marker.pattern.fgcolor = e.marker.colors), t.marker.pattern.bgcolor || (t.marker.pattern.bgcolor = r.paper_bgcolor);
            }
            function FEt(e, t, r, n) {
                function i(E, k) {
                    return wE.coerce(e, t, IEt, E, k);
                }
                var a = i("labels"), o = i("values"), s = Z4e(a, o), l = s.len;
                if (t._hasLabels = s.hasLabels, t._hasValues = s.hasValues, !t._hasLabels && t._hasValues && (i("label0"), i("dlabel")), !l) {
                    t.visible = !1;
                    return;
                }
                t._length = l, X4e(e, t, n, i, !0), i("scalegroup");
                var u = i("text"), c = i("texttemplate"), f;
                if (c || (f = i("textinfo", wE.isArrayOrTypedArray(u) ? "text+percent" : "percent")), i("hovertext"), i("hovertemplate"), c || f && f !== "none") {
                    var h = i("textposition");
                    DEt(e, t, n, i, h, {
                        moduleHasSelected: !1,
                        moduleHasUnselected: !1,
                        moduleHasConstrain: !1,
                        moduleHasCliponaxis: !1,
                        moduleHasTextangle: !1,
                        moduleHasInsideanchor: !1
                    });
                    var d = Array.isArray(h) || h === "auto", v = d || h === "outside";
                    v && i("automargin"), (h === "inside" || h === "auto" || Array.isArray(h)) && i("insidetextorientation");
                } else f === "none" && i("textposition", "none");
                REt(t, n, i);
                var x = i("hole"), b = i("title.text");
                if (b) {
                    var p = i("title.position", x ? "middle center" : "top center");
                    !x && p === "middle center" && (t.title.position = "top center"), wE.coerceFont(i, "title.font", n.font);
                }
                i("sort"), i("direction"), i("rotation"), i("pull");
            }
            Y4e.exports = {
                handleLabelsAndValues: Z4e,
                handleMarkerDefaults: X4e,
                supplyDefaults: FEt
            };
        });
        var uD = ye((ofr, K4e)=>{
            "use strict";
            K4e.exports = {
                hiddenlabels: {
                    valType: "data_array",
                    editType: "calc"
                },
                piecolorway: {
                    valType: "colorlist",
                    editType: "calc"
                },
                extendpiecolors: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc"
                }
            };
        });
        var $4e = ye((sfr, J4e)=>{
            "use strict";
            var qEt = Mr(), OEt = uD();
            J4e.exports = function(t, r) {
                function n(i, a) {
                    return qEt.coerce(t, r, OEt, i, a);
                }
                n("hiddenlabels"), n("piecolorway", r.colorway), n("extendpiecolors");
            };
        });
        var y5 = ye((lfr, tEe)=>{
            "use strict";
            var BEt = uo(), tW = id(), NEt = va(), UEt = {};
            function VEt(e, t) {
                var r = [], n = e._fullLayout, i = n.hiddenlabels || [], a = t.labels, o = t.marker.colors || [], s = t.values, l = t._length, u = t._hasValues && l, c, f;
                if (t.dlabel) for(a = new Array(l), c = 0; c < l; c++)a[c] = String(t.label0 + c * t.dlabel);
                var h = {}, d = Q4e(n["_" + t.type + "colormap"]), v = 0, x = !1;
                for(c = 0; c < l; c++){
                    var b, p, E;
                    if (u) {
                        if (b = s[c], !BEt(b)) continue;
                        b = +b;
                    } else b = 1;
                    p = a[c], (p === void 0 || p === "") && (p = c), p = String(p);
                    var k = h[p];
                    k === void 0 ? (h[p] = r.length, E = i.indexOf(p) !== -1, E || (v += b), r.push({
                        v: b,
                        label: p,
                        color: d(o[c], p),
                        i: c,
                        pts: [
                            c
                        ],
                        hidden: E
                    })) : (x = !0, f = r[k], f.v += b, f.pts.push(c), f.hidden || (v += b), f.color === !1 && o[c] && (f.color = d(o[c], p)));
                }
                r = r.filter(function(L) {
                    return L.v >= 0;
                });
                var A = t.type === "funnelarea" ? x : t.sort;
                return A && r.sort(function(L, _) {
                    return _.v - L.v;
                }), r[0] && (r[0].vTotal = v), r;
            }
            function Q4e(e) {
                return function(r, n) {
                    return !r || (r = tW(r), !r.isValid()) ? !1 : (r = NEt.addOpacity(r, r.getAlpha()), e[n] || (e[n] = r), r);
                };
            }
            function HEt(e, t) {
                var r = (t || {}).type;
                r || (r = "pie");
                var n = e._fullLayout, i = e.calcdata, a = n[r + "colorway"], o = n["_" + r + "colormap"];
                n["extend" + r + "colors"] && (a = eEe(a, UEt));
                for(var s = 0, l = 0; l < i.length; l++){
                    var u = i[l], c = u[0].trace.type;
                    if (c === r) for(var f = 0; f < u.length; f++){
                        var h = u[f];
                        h.color === !1 && (o[h.label] ? h.color = o[h.label] : (o[h.label] = h.color = a[s % a.length], s++));
                    }
                }
            }
            function eEe(e, t) {
                var r, n = JSON.stringify(e), i = t[n];
                if (!i) {
                    for(i = e.slice(), r = 0; r < e.length; r++)i.push(tW(e[r]).lighten(20).toHexString());
                    for(r = 0; r < e.length; r++)i.push(tW(e[r]).darken(20).toHexString());
                    t[n] = i;
                }
                return i;
            }
            tEe.exports = {
                calc: VEt,
                crossTraceCalc: HEt,
                makePullColorFn: Q4e,
                generateExtendedColors: eEe
            };
        });
        var iEe = ye((ufr, rEe)=>{
            "use strict";
            var GEt = rp().appendArrayMultiPointValues;
            rEe.exports = function(t, r) {
                var n = {
                    curveNumber: r.index,
                    pointNumbers: t.pts,
                    data: r._input,
                    fullData: r,
                    label: t.label,
                    color: t.color,
                    value: t.v,
                    percent: t.percent,
                    text: t.text,
                    bbox: t.bbox,
                    v: t.v
                };
                return t.pts.length === 1 && (n.pointNumber = n.i = t.pts[0]), GEt(n, r, t.pts), r.type === "funnelarea" && (delete n.v, delete n.i), n;
            };
        });
        var dD = ye((cfr, AEe)=>{
            "use strict";
            var zp = xa(), jEt = Xu(), cD = Nc(), uEe = va(), Wy = ao(), ev = Mr(), WEt = ev.strScale, nEe = ev.strTranslate, rW = Pl(), cEe = _v(), ZEt = cEe.recordMinTextSize, XEt = cEe.clearMinTextSize, fEe = Qb().TEXTPAD, Zo = u_(), fD = iEe(), aEe = Mr().isValidTextValue;
            function YEt(e, t) {
                var r = e._context.staticPlot, n = e._fullLayout, i = n._size;
                XEt("pie", n), vEe(t, e), bEe(t, i);
                var a = ev.makeTraceGroups(n._pielayer, t, "trace").each(function(o) {
                    var s = zp.select(this), l = o[0], u = l.trace;
                    nkt(o), s.attr("stroke-linejoin", "round"), s.each(function() {
                        var c = zp.select(this).selectAll("g.slice").data(o);
                        c.enter().append("g").classed("slice", !0), c.exit().remove();
                        var f = [
                            [
                                [],
                                []
                            ],
                            [
                                [],
                                []
                            ]
                        ], h = !1;
                        c.each(function(A, L) {
                            if (A.hidden) {
                                zp.select(this).selectAll("path,g").remove();
                                return;
                            }
                            A.pointNumber = A.i, A.curveNumber = u.index, f[A.pxmid[1] < 0 ? 0 : 1][A.pxmid[0] < 0 ? 0 : 1].push(A);
                            var _ = l.cx, C = l.cy, M = zp.select(this), g = M.selectAll("path.surface").data([
                                A
                            ]);
                            if (g.enter().append("path").classed("surface", !0).style({
                                "pointer-events": r ? "none" : "all"
                            }), M.call(hEe, e, o), u.pull) {
                                var P = +Zo.castOption(u.pull, A.pts) || 0;
                                P > 0 && (_ += P * A.pxmid[0], C += P * A.pxmid[1]);
                            }
                            A.cxFinal = _, A.cyFinal = C;
                            function T(N, W, re, ae) {
                                var _e = ae * (W[0] - N[0]), Me = ae * (W[1] - N[1]);
                                return "a" + ae * l.r + "," + ae * l.r + " 0 " + A.largeArc + (re ? " 1 " : " 0 ") + _e + "," + Me;
                            }
                            var F = u.hole;
                            if (A.v === l.vTotal) {
                                var q = "M" + (_ + A.px0[0]) + "," + (C + A.px0[1]) + T(A.px0, A.pxmid, !0, 1) + T(A.pxmid, A.px0, !0, 1) + "Z";
                                F ? g.attr("d", "M" + (_ + F * A.px0[0]) + "," + (C + F * A.px0[1]) + T(A.px0, A.pxmid, !1, F) + T(A.pxmid, A.px0, !1, F) + "Z" + q) : g.attr("d", q);
                            } else {
                                var V = T(A.px0, A.px1, !0, 1);
                                if (F) {
                                    var H = 1 - F;
                                    g.attr("d", "M" + (_ + F * A.px1[0]) + "," + (C + F * A.px1[1]) + T(A.px1, A.px0, !1, F) + "l" + H * A.px0[0] + "," + H * A.px0[1] + V + "Z");
                                } else g.attr("d", "M" + _ + "," + C + "l" + A.px0[0] + "," + A.px0[1] + V + "Z");
                            }
                            wEe(e, A, l);
                            var X = Zo.castOption(u.textposition, A.pts), G = M.selectAll("g.slicetext").data(A.text && X !== "none" ? [
                                0
                            ] : []);
                            G.enter().append("g").classed("slicetext", !0), G.exit().remove(), G.each(function() {
                                var N = ev.ensureSingle(zp.select(this), "text", "", function(ie) {
                                    ie.attr("data-notex", 1);
                                }), W = ev.ensureUniformFontSize(e, X === "outside" ? JEt(u, A, n.font) : dEe(u, A, n.font));
                                N.text(A.text).attr({
                                    class: "slicetext",
                                    transform: "",
                                    "text-anchor": "middle"
                                }).call(Wy.font, W).call(rW.convertToTspans, e);
                                var re = Wy.bBox(N.node()), ae;
                                if (X === "outside") ae = lEe(re, A);
                                else if (ae = pEe(re, A, l), X === "auto" && ae.scale < 1) {
                                    var _e = ev.ensureUniformFontSize(e, u.outsidetextfont);
                                    N.call(Wy.font, _e), re = Wy.bBox(N.node()), ae = lEe(re, A);
                                }
                                var Me = ae.textPosAngle, ke = Me === void 0 ? A.pxmid : hD(l.r, Me);
                                if (ae.targetX = _ + ke[0] * ae.rCenter + (ae.x || 0), ae.targetY = C + ke[1] * ae.rCenter + (ae.y || 0), TEe(ae, re), ae.outside) {
                                    var ge = ae.targetY;
                                    A.yLabelMin = ge - re.height / 2, A.yLabelMid = ge, A.yLabelMax = ge + re.height / 2, A.labelExtraX = 0, A.labelExtraY = 0, h = !0;
                                }
                                ae.fontSize = W.size, ZEt(u.type, ae, n), o[L].transform = ae, ev.setTransormAndDisplay(N, ae);
                            });
                        });
                        var d = zp.select(this).selectAll("g.titletext").data(u.title.text ? [
                            0
                        ] : []);
                        if (d.enter().append("g").classed("titletext", !0), d.exit().remove(), d.each(function() {
                            var A = ev.ensureSingle(zp.select(this), "text", "", function(C) {
                                C.attr("data-notex", 1);
                            }), L = u.title.text;
                            u._meta && (L = ev.templateString(L, u._meta)), A.text(L).attr({
                                class: "titletext",
                                transform: "",
                                "text-anchor": "middle"
                            }).call(Wy.font, u.title.font).call(rW.convertToTspans, e);
                            var _;
                            u.title.position === "middle center" ? _ = ekt(l) : _ = _Ee(l, i), A.attr("transform", nEe(_.x, _.y) + WEt(Math.min(1, _.scale)) + nEe(_.tx, _.ty));
                        }), h && rkt(f, u), KEt(c, u), h && u.automargin) {
                            var v = Wy.bBox(s.node()), x = u.domain, b = i.w * (x.x[1] - x.x[0]), p = i.h * (x.y[1] - x.y[0]), E = (.5 * b - l.r) / i.w, k = (.5 * p - l.r) / i.h;
                            jEt.autoMargin(e, "pie." + u.uid + ".automargin", {
                                xl: x.x[0] - E,
                                xr: x.x[1] + E,
                                yb: x.y[0] - k,
                                yt: x.y[1] + k,
                                l: Math.max(l.cx - l.r - v.left, 0),
                                r: Math.max(v.right - (l.cx + l.r), 0),
                                b: Math.max(v.bottom - (l.cy + l.r), 0),
                                t: Math.max(l.cy - l.r - v.top, 0),
                                pad: 5
                            });
                        }
                    });
                });
                setTimeout(function() {
                    a.selectAll("tspan").each(function() {
                        var o = zp.select(this);
                        o.attr("dy") && o.attr("dy", o.attr("dy"));
                    });
                }, 0);
            }
            function KEt(e, t) {
                e.each(function(r) {
                    var n = zp.select(this);
                    if (!r.labelExtraX && !r.labelExtraY) {
                        n.select("path.textline").remove();
                        return;
                    }
                    var i = n.select("g.slicetext text");
                    r.transform.targetX += r.labelExtraX, r.transform.targetY += r.labelExtraY, ev.setTransormAndDisplay(i, r.transform);
                    var a = r.cxFinal + r.pxmid[0], o = r.cyFinal + r.pxmid[1], s = "M" + a + "," + o, l = (r.yLabelMax - r.yLabelMin) * (r.pxmid[0] < 0 ? -1 : 1) / 4;
                    if (r.labelExtraX) {
                        var u = r.labelExtraX * r.pxmid[1] / r.pxmid[0], c = r.yLabelMid + r.labelExtraY - (r.cyFinal + r.pxmid[1]);
                        Math.abs(u) > Math.abs(c) ? s += "l" + c * r.pxmid[0] / r.pxmid[1] + "," + c + "H" + (a + r.labelExtraX + l) : s += "l" + r.labelExtraX + "," + u + "v" + (c - u) + "h" + l;
                    } else s += "V" + (r.yLabelMid + r.labelExtraY) + "h" + l;
                    ev.ensureSingle(n, "path", "textline").call(uEe.stroke, t.outsidetextfont.color).attr({
                        "stroke-width": Math.min(2, t.outsidetextfont.size / 8),
                        d: s,
                        fill: "none"
                    });
                });
            }
            function hEe(e, t, r) {
                var n = r[0], i = n.cx, a = n.cy, o = n.trace, s = o.type === "funnelarea";
                "_hasHoverLabel" in o || (o._hasHoverLabel = !1), "_hasHoverEvent" in o || (o._hasHoverEvent = !1), e.on("mouseover", function(l) {
                    var u = t._fullLayout, c = t._fullData[o.index];
                    if (!(t._dragging || u.hovermode === !1)) {
                        var f = c.hoverinfo;
                        if (Array.isArray(f) && (f = cD.castHoverinfo({
                            hoverinfo: [
                                Zo.castOption(f, l.pts)
                            ],
                            _module: o._module
                        }, u, 0)), f === "all" && (f = "label+text+value+percent+name"), c.hovertemplate || f !== "none" && f !== "skip" && f) {
                            var h = l.rInscribed || 0, d = i + l.pxmid[0] * (1 - h), v = a + l.pxmid[1] * (1 - h), x = u.separators, b = [];
                            if (f && f.indexOf("label") !== -1 && b.push(l.label), l.text = Zo.castOption(c.hovertext || c.text, l.pts), f && f.indexOf("text") !== -1) {
                                var p = l.text;
                                ev.isValidTextValue(p) && b.push(p);
                            }
                            l.value = l.v, l.valueLabel = Zo.formatPieValue(l.v, x), f && f.indexOf("value") !== -1 && b.push(l.valueLabel), l.percent = l.v / n.vTotal, l.percentLabel = Zo.formatPiePercent(l.percent, x), f && f.indexOf("percent") !== -1 && b.push(l.percentLabel);
                            var E = c.hoverlabel, k = E.font, A = [];
                            cD.loneHover({
                                trace: o,
                                x0: d - h * n.r,
                                x1: d + h * n.r,
                                y: v,
                                _x0: s ? i + l.TL[0] : d - h * n.r,
                                _x1: s ? i + l.TR[0] : d + h * n.r,
                                _y0: s ? a + l.TL[1] : v - h * n.r,
                                _y1: s ? a + l.BL[1] : v + h * n.r,
                                text: b.join("<br>"),
                                name: c.hovertemplate || f.indexOf("name") !== -1 ? c.name : void 0,
                                idealAlign: l.pxmid[0] < 0 ? "left" : "right",
                                color: Zo.castOption(E.bgcolor, l.pts) || l.color,
                                borderColor: Zo.castOption(E.bordercolor, l.pts),
                                fontFamily: Zo.castOption(k.family, l.pts),
                                fontSize: Zo.castOption(k.size, l.pts),
                                fontColor: Zo.castOption(k.color, l.pts),
                                nameLength: Zo.castOption(E.namelength, l.pts),
                                textAlign: Zo.castOption(E.align, l.pts),
                                hovertemplate: Zo.castOption(c.hovertemplate, l.pts),
                                hovertemplateLabels: l,
                                eventData: [
                                    fD(l, c)
                                ]
                            }, {
                                container: u._hoverlayer.node(),
                                outerContainer: u._paper.node(),
                                gd: t,
                                inOut_bbox: A
                            }), l.bbox = A[0], o._hasHoverLabel = !0;
                        }
                        o._hasHoverEvent = !0, t.emit("plotly_hover", {
                            points: [
                                fD(l, c)
                            ],
                            event: zp.event
                        });
                    }
                }), e.on("mouseout", function(l) {
                    var u = t._fullLayout, c = t._fullData[o.index], f = zp.select(this).datum();
                    o._hasHoverEvent && (l.originalEvent = zp.event, t.emit("plotly_unhover", {
                        points: [
                            fD(f, c)
                        ],
                        event: zp.event
                    }), o._hasHoverEvent = !1), o._hasHoverLabel && (cD.loneUnhover(u._hoverlayer.node()), o._hasHoverLabel = !1);
                }), e.on("click", function(l) {
                    var u = t._fullLayout, c = t._fullData[o.index];
                    t._dragging || u.hovermode === !1 || (t._hoverdata = [
                        fD(l, c)
                    ], cD.click(t, zp.event));
                });
            }
            function JEt(e, t, r) {
                var n = Zo.castOption(e.outsidetextfont.color, t.pts) || Zo.castOption(e.textfont.color, t.pts) || r.color, i = Zo.castOption(e.outsidetextfont.family, t.pts) || Zo.castOption(e.textfont.family, t.pts) || r.family, a = Zo.castOption(e.outsidetextfont.size, t.pts) || Zo.castOption(e.textfont.size, t.pts) || r.size, o = Zo.castOption(e.outsidetextfont.weight, t.pts) || Zo.castOption(e.textfont.weight, t.pts) || r.weight, s = Zo.castOption(e.outsidetextfont.style, t.pts) || Zo.castOption(e.textfont.style, t.pts) || r.style, l = Zo.castOption(e.outsidetextfont.variant, t.pts) || Zo.castOption(e.textfont.variant, t.pts) || r.variant, u = Zo.castOption(e.outsidetextfont.textcase, t.pts) || Zo.castOption(e.textfont.textcase, t.pts) || r.textcase, c = Zo.castOption(e.outsidetextfont.lineposition, t.pts) || Zo.castOption(e.textfont.lineposition, t.pts) || r.lineposition, f = Zo.castOption(e.outsidetextfont.shadow, t.pts) || Zo.castOption(e.textfont.shadow, t.pts) || r.shadow;
                return {
                    color: n,
                    family: i,
                    size: a,
                    weight: o,
                    style: s,
                    variant: l,
                    textcase: u,
                    lineposition: c,
                    shadow: f
                };
            }
            function dEe(e, t, r) {
                var n = Zo.castOption(e.insidetextfont.color, t.pts);
                !n && e._input.textfont && (n = Zo.castOption(e._input.textfont.color, t.pts));
                var i = Zo.castOption(e.insidetextfont.family, t.pts) || Zo.castOption(e.textfont.family, t.pts) || r.family, a = Zo.castOption(e.insidetextfont.size, t.pts) || Zo.castOption(e.textfont.size, t.pts) || r.size, o = Zo.castOption(e.insidetextfont.weight, t.pts) || Zo.castOption(e.textfont.weight, t.pts) || r.weight, s = Zo.castOption(e.insidetextfont.style, t.pts) || Zo.castOption(e.textfont.style, t.pts) || r.style, l = Zo.castOption(e.insidetextfont.variant, t.pts) || Zo.castOption(e.textfont.variant, t.pts) || r.variant, u = Zo.castOption(e.insidetextfont.textcase, t.pts) || Zo.castOption(e.textfont.textcase, t.pts) || r.textcase, c = Zo.castOption(e.insidetextfont.lineposition, t.pts) || Zo.castOption(e.textfont.lineposition, t.pts) || r.lineposition, f = Zo.castOption(e.insidetextfont.shadow, t.pts) || Zo.castOption(e.textfont.shadow, t.pts) || r.shadow;
                return {
                    color: n || uEe.contrast(t.color),
                    family: i,
                    size: a,
                    weight: o,
                    style: s,
                    variant: l,
                    textcase: u,
                    lineposition: c,
                    shadow: f
                };
            }
            function vEe(e, t) {
                for(var r, n, i = 0; i < e.length; i++)if (r = e[i][0], n = r.trace, n.title.text) {
                    var a = n.title.text;
                    n._meta && (a = ev.templateString(a, n._meta));
                    var o = Wy.tester.append("text").attr("data-notex", 1).text(a).call(Wy.font, n.title.font).call(rW.convertToTspans, t), s = Wy.bBox(o.node(), !0);
                    r.titleBox = {
                        width: s.width,
                        height: s.height
                    }, o.remove();
                }
            }
            function pEe(e, t, r) {
                var n = r.r || t.rpx1, i = t.rInscribed, a = t.startangle === t.stopangle;
                if (a) return {
                    rCenter: 1 - i,
                    scale: 0,
                    rotate: 0,
                    textPosAngle: 0
                };
                var o = t.ring, s = o === 1 && Math.abs(t.startangle - t.stopangle) === Math.PI * 2, l = t.halfangle, u = t.midangle, c = r.trace.insidetextorientation, f = c === "horizontal", h = c === "tangential", d = c === "radial", v = c === "auto", x = [], b;
                if (!v) {
                    var p = function(M, g) {
                        if ($Et(t, M)) {
                            var P = Math.abs(M - t.startangle), T = Math.abs(M - t.stopangle), F = P < T ? P : T;
                            g === "tan" ? b = sEe(e, n, o, F, 0) : b = oEe(e, n, o, F, Math.PI / 2), b.textPosAngle = M, x.push(b);
                        }
                    }, E;
                    if (f || h) {
                        for(E = 4; E >= -4; E -= 2)p(Math.PI * E, "tan");
                        for(E = 4; E >= -4; E -= 2)p(Math.PI * (E + 1), "tan");
                    }
                    if (f || d) {
                        for(E = 4; E >= -4; E -= 2)p(Math.PI * (E + 1.5), "rad");
                        for(E = 4; E >= -4; E -= 2)p(Math.PI * (E + .5), "rad");
                    }
                }
                if (s || v || f) {
                    var k = Math.sqrt(e.width * e.width + e.height * e.height);
                    if (b = {
                        scale: i * n * 2 / k,
                        rCenter: 1 - i,
                        rotate: 0
                    }, b.textPosAngle = (t.startangle + t.stopangle) / 2, b.scale >= 1) return b;
                    x.push(b);
                }
                (v || d) && (b = oEe(e, n, o, l, u), b.textPosAngle = (t.startangle + t.stopangle) / 2, x.push(b)), (v || h) && (b = sEe(e, n, o, l, u), b.textPosAngle = (t.startangle + t.stopangle) / 2, x.push(b));
                for(var A = 0, L = 0, _ = 0; _ < x.length; _++){
                    var C = x[_].scale;
                    if (L < C && (L = C, A = _), !v && L >= 1) break;
                }
                return x[A];
            }
            function $Et(e, t) {
                var r = e.startangle, n = e.stopangle;
                return r > t && t > n || r < t && t < n;
            }
            function oEe(e, t, r, n, i) {
                t = Math.max(0, t - 2 * fEe);
                var a = e.width / e.height, o = yEe(a, n, t, r);
                return {
                    scale: o * 2 / e.height,
                    rCenter: gEe(a, o / t),
                    rotate: mEe(i)
                };
            }
            function sEe(e, t, r, n, i) {
                t = Math.max(0, t - 2 * fEe);
                var a = e.height / e.width, o = yEe(a, n, t, r);
                return {
                    scale: o * 2 / e.width,
                    rCenter: gEe(a, o / t),
                    rotate: mEe(i + Math.PI / 2)
                };
            }
            function gEe(e, t) {
                return Math.cos(t) - e * t;
            }
            function mEe(e) {
                return (180 / Math.PI * e + 720) % 180 - 90;
            }
            function yEe(e, t, r, n) {
                var i = e + 1 / (2 * Math.tan(t));
                return r * Math.min(1 / (Math.sqrt(i * i + .5) + i), n / (Math.sqrt(e * e + n / 2) + e));
            }
            function QEt(e, t) {
                return e.v === t.vTotal && !t.trace.hole ? 1 : Math.min(1 / (1 + 1 / Math.sin(e.halfangle)), e.ring / 2);
            }
            function lEe(e, t) {
                var r = t.pxmid[0], n = t.pxmid[1], i = e.width / 2, a = e.height / 2;
                return r < 0 && (i *= -1), n < 0 && (a *= -1), {
                    scale: 1,
                    rCenter: 1,
                    rotate: 0,
                    x: i + Math.abs(a) * (i > 0 ? 1 : -1) / 2,
                    y: a / (1 + r * r / (n * n)),
                    outside: !0
                };
            }
            function ekt(e) {
                var t = Math.sqrt(e.titleBox.width * e.titleBox.width + e.titleBox.height * e.titleBox.height);
                return {
                    x: e.cx,
                    y: e.cy,
                    scale: e.trace.hole * e.r * 2 / t,
                    tx: 0,
                    ty: -e.titleBox.height / 2 + e.trace.title.font.size
                };
            }
            function _Ee(e, t) {
                var r = 1, n = 1, i, a = e.trace, o = {
                    x: e.cx,
                    y: e.cy
                }, s = {
                    tx: 0,
                    ty: 0
                };
                s.ty += a.title.font.size, i = xEe(a), a.title.position.indexOf("top") !== -1 ? (o.y -= (1 + i) * e.r, s.ty -= e.titleBox.height) : a.title.position.indexOf("bottom") !== -1 && (o.y += (1 + i) * e.r);
                var l = tkt(e.r, e.trace.aspectratio), u = t.w * (a.domain.x[1] - a.domain.x[0]) / 2;
                return a.title.position.indexOf("left") !== -1 ? (u = u + l, o.x -= (1 + i) * l, s.tx += e.titleBox.width / 2) : a.title.position.indexOf("center") !== -1 ? u *= 2 : a.title.position.indexOf("right") !== -1 && (u = u + l, o.x += (1 + i) * l, s.tx -= e.titleBox.width / 2), r = u / e.titleBox.width, n = iW(e, t) / e.titleBox.height, {
                    x: o.x,
                    y: o.y,
                    scale: Math.min(r, n),
                    tx: s.tx,
                    ty: s.ty
                };
            }
            function tkt(e, t) {
                return e / (t === void 0 ? 1 : t);
            }
            function iW(e, t) {
                var r = e.trace, n = t.h * (r.domain.y[1] - r.domain.y[0]);
                return Math.min(e.titleBox.height, n / 2);
            }
            function xEe(e) {
                var t = e.pull;
                if (!t) return 0;
                var r;
                if (ev.isArrayOrTypedArray(t)) for(t = 0, r = 0; r < e.pull.length; r++)e.pull[r] > t && (t = e.pull[r]);
                return t;
            }
            function rkt(e, t) {
                var r, n, i, a, o, s, l, u, c, f, h, d, v;
                function x(k, A) {
                    return k.pxmid[1] - A.pxmid[1];
                }
                function b(k, A) {
                    return A.pxmid[1] - k.pxmid[1];
                }
                function p(k, A) {
                    A || (A = {});
                    var L = A.labelExtraY + (n ? A.yLabelMax : A.yLabelMin), _ = n ? k.yLabelMin : k.yLabelMax, C = n ? k.yLabelMax : k.yLabelMin, M = k.cyFinal + o(k.px0[1], k.px1[1]), g = L - _, P, T, F, q, V, H;
                    if (g * l > 0 && (k.labelExtraY = g), !!ev.isArrayOrTypedArray(t.pull)) for(T = 0; T < f.length; T++)F = f[T], !(F === k || (Zo.castOption(t.pull, k.pts) || 0) >= (Zo.castOption(t.pull, F.pts) || 0)) && ((k.pxmid[1] - F.pxmid[1]) * l > 0 ? (q = F.cyFinal + o(F.px0[1], F.px1[1]), g = q - _ - k.labelExtraY, g * l > 0 && (k.labelExtraY += g)) : (C + k.labelExtraY - M) * l > 0 && (P = 3 * s * Math.abs(T - f.indexOf(k)), V = F.cxFinal + a(F.px0[0], F.px1[0]), H = V + P - (k.cxFinal + k.pxmid[0]) - k.labelExtraX, H * s > 0 && (k.labelExtraX += H)));
                }
                for(n = 0; n < 2; n++)for(i = n ? x : b, o = n ? Math.max : Math.min, l = n ? 1 : -1, r = 0; r < 2; r++){
                    for(a = r ? Math.max : Math.min, s = r ? 1 : -1, u = e[n][r], u.sort(i), c = e[1 - n][r], f = c.concat(u), d = [], h = 0; h < u.length; h++)u[h].yLabelMid !== void 0 && d.push(u[h]);
                    for(v = !1, h = 0; n && h < c.length; h++)if (c[h].yLabelMid !== void 0) {
                        v = c[h];
                        break;
                    }
                    for(h = 0; h < d.length; h++){
                        var E = h && d[h - 1];
                        v && !h && (E = v), p(d[h], E);
                    }
                }
            }
            function bEe(e, t) {
                for(var r = [], n = 0; n < e.length; n++){
                    var i = e[n][0], a = i.trace, o = a.domain, s = t.w * (o.x[1] - o.x[0]), l = t.h * (o.y[1] - o.y[0]);
                    a.title.text && a.title.position !== "middle center" && (l -= iW(i, t));
                    var u = s / 2, c = l / 2;
                    a.type === "funnelarea" && !a.scalegroup && (c /= a.aspectratio), i.r = Math.min(u, c) / (1 + xEe(a)), i.cx = t.l + t.w * (a.domain.x[1] + a.domain.x[0]) / 2, i.cy = t.t + t.h * (1 - a.domain.y[0]) - l / 2, a.title.text && a.title.position.indexOf("bottom") !== -1 && (i.cy -= iW(i, t)), a.scalegroup && r.indexOf(a.scalegroup) === -1 && r.push(a.scalegroup);
                }
                ikt(e, r);
            }
            function ikt(e, t) {
                for(var r, n, i, a = 0; a < t.length; a++){
                    var o = 1 / 0, s = t[a];
                    for(n = 0; n < e.length; n++)if (r = e[n][0], i = r.trace, i.scalegroup === s) {
                        var l;
                        if (i.type === "pie") l = r.r * r.r;
                        else if (i.type === "funnelarea") {
                            var u, c;
                            i.aspectratio > 1 ? (u = r.r, c = u / i.aspectratio) : (c = r.r, u = c * i.aspectratio), u *= (1 + i.baseratio) / 2, l = u * c;
                        }
                        o = Math.min(o, l / r.vTotal);
                    }
                    for(n = 0; n < e.length; n++)if (r = e[n][0], i = r.trace, i.scalegroup === s) {
                        var f = o * r.vTotal;
                        i.type === "funnelarea" && (f /= (1 + i.baseratio) / 2, f /= i.aspectratio), r.r = Math.sqrt(f);
                    }
                }
            }
            function nkt(e) {
                var t = e[0], r = t.r, n = t.trace, i = Zo.getRotationAngle(n.rotation), a = 2 * Math.PI / t.vTotal, o = "px0", s = "px1", l, u, c;
                if (n.direction === "counterclockwise") {
                    for(l = 0; l < e.length && e[l].hidden; l++);
                    if (l === e.length) return;
                    i += a * e[l].v, a *= -1, o = "px1", s = "px0";
                }
                for(c = hD(r, i), l = 0; l < e.length; l++)u = e[l], !u.hidden && (u[o] = c, u.startangle = i, i += a * u.v / 2, u.pxmid = hD(r, i), u.midangle = i, i += a * u.v / 2, c = hD(r, i), u.stopangle = i, u[s] = c, u.largeArc = u.v > t.vTotal / 2 ? 1 : 0, u.halfangle = Math.PI * Math.min(u.v / t.vTotal, .5), u.ring = 1 - n.hole, u.rInscribed = QEt(u, t));
            }
            function hD(e, t) {
                return [
                    e * Math.sin(t),
                    -e * Math.cos(t)
                ];
            }
            function wEe(e, t, r) {
                var n = e._fullLayout, i = r.trace, a = i.texttemplate, o = i.textinfo;
                if (!a && o && o !== "none") {
                    var s = o.split("+"), l = function(A) {
                        return s.indexOf(A) !== -1;
                    }, u = l("label"), c = l("text"), f = l("value"), h = l("percent"), d = n.separators, v;
                    if (v = u ? [
                        t.label
                    ] : [], c) {
                        var x = Zo.getFirstFilled(i.text, t.pts);
                        aEe(x) && v.push(x);
                    }
                    f && v.push(Zo.formatPieValue(t.v, d)), h && v.push(Zo.formatPiePercent(t.v / r.vTotal, d)), t.text = v.join("<br>");
                }
                function b(A) {
                    return {
                        label: A.label,
                        value: A.v,
                        valueLabel: Zo.formatPieValue(A.v, n.separators),
                        percent: A.v / r.vTotal,
                        percentLabel: Zo.formatPiePercent(A.v / r.vTotal, n.separators),
                        color: A.color,
                        text: A.text,
                        customdata: ev.castOption(i, A.i, "customdata")
                    };
                }
                if (a) {
                    var p = ev.castOption(i, t.i, "texttemplate");
                    if (!p) t.text = "";
                    else {
                        var E = b(t), k = Zo.getFirstFilled(i.text, t.pts);
                        (aEe(k) || k === "") && (E.text = k), t.text = ev.texttemplateString(p, E, e._fullLayout._d3locale, E, i._meta || {});
                    }
                }
            }
            function TEe(e, t) {
                var r = e.rotate * Math.PI / 180, n = Math.cos(r), i = Math.sin(r), a = (t.left + t.right) / 2, o = (t.top + t.bottom) / 2;
                e.textX = a * n - o * i, e.textY = a * i + o * n, e.noCenter = !0;
            }
            AEe.exports = {
                plot: YEt,
                formatSliceLabel: wEe,
                transformInsideText: pEe,
                determineInsideTextFont: dEe,
                positionTitleOutside: _Ee,
                prerenderTitles: vEe,
                layoutAreas: bEe,
                attachFxHandlers: hEe,
                computeTransform: TEe
            };
        });
        var EEe = ye((ffr, MEe)=>{
            "use strict";
            var SEe = xa(), akt = z3(), okt = _v().resizeText;
            MEe.exports = function(t) {
                var r = t._fullLayout._pielayer.selectAll(".trace");
                okt(t, r, "pie"), r.each(function(n) {
                    var i = n[0], a = i.trace, o = SEe.select(this);
                    o.style({
                        opacity: a.opacity
                    }), o.selectAll("path.surface").each(function(s) {
                        SEe.select(this).call(akt, s, a, t);
                    });
                });
            };
        });
        var CEe = ye((_5)=>{
            "use strict";
            var kEe = Xu();
            _5.name = "pie";
            _5.plot = function(e, t, r, n) {
                kEe.plotBasePlot(_5.name, e, t, r, n);
            };
            _5.clean = function(e, t, r, n) {
                kEe.cleanBasePlot(_5.name, e, t, r, n);
            };
        });
        var PEe = ye((dfr, LEe)=>{
            "use strict";
            LEe.exports = {
                attributes: A2(),
                supplyDefaults: S2().supplyDefaults,
                supplyLayoutDefaults: $4e(),
                layoutAttributes: uD(),
                calc: y5().calc,
                crossTraceCalc: y5().crossTraceCalc,
                plot: dD().plot,
                style: EEe(),
                styleOne: z3(),
                moduleType: "trace",
                name: "pie",
                basePlotModule: CEe(),
                categories: [
                    "pie-like",
                    "pie",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var REe = ye((vfr, IEe)=>{
            "use strict";
            IEe.exports = PEe();
        });
        var zEe = ye((x5)=>{
            "use strict";
            var DEe = Xu();
            x5.name = "sunburst";
            x5.plot = function(e, t, r, n) {
                DEe.plotBasePlot(x5.name, e, t, r, n);
            };
            x5.clean = function(e, t, r, n) {
                DEe.cleanBasePlot(x5.name, e, t, r, n);
            };
        });
        var nW = ye((gfr, FEe)=>{
            "use strict";
            FEe.exports = {
                CLICK_TRANSITION_TIME: 750,
                CLICK_TRANSITION_EASING: "linear",
                eventDataKeys: [
                    "currentPath",
                    "root",
                    "entry",
                    "percentRoot",
                    "percentEntry",
                    "percentParent"
                ]
            };
        });
        var AE = ye((mfr, OEe)=>{
            "use strict";
            var skt = vl(), lkt = Wo().hovertemplateAttrs, ukt = Wo().texttemplateAttrs, ckt = Jl(), fkt = Ju().attributes, Zy = A2(), qEe = nW(), TE = no().extendFlat, hkt = Ed().pattern;
            OEe.exports = {
                labels: {
                    valType: "data_array",
                    editType: "calc"
                },
                parents: {
                    valType: "data_array",
                    editType: "calc"
                },
                values: {
                    valType: "data_array",
                    editType: "calc"
                },
                branchvalues: {
                    valType: "enumerated",
                    values: [
                        "remainder",
                        "total"
                    ],
                    dflt: "remainder",
                    editType: "calc"
                },
                count: {
                    valType: "flaglist",
                    flags: [
                        "branches",
                        "leaves"
                    ],
                    dflt: "leaves",
                    editType: "calc"
                },
                level: {
                    valType: "any",
                    editType: "plot",
                    anim: !0
                },
                maxdepth: {
                    valType: "integer",
                    editType: "plot",
                    dflt: -1
                },
                marker: TE({
                    colors: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    line: {
                        color: TE({}, Zy.marker.line.color, {
                            dflt: null
                        }),
                        width: TE({}, Zy.marker.line.width, {
                            dflt: 1
                        }),
                        editType: "calc"
                    },
                    pattern: hkt,
                    editType: "calc"
                }, ckt("marker", {
                    colorAttr: "colors",
                    anim: !1
                })),
                leaf: {
                    opacity: {
                        valType: "number",
                        editType: "style",
                        min: 0,
                        max: 1
                    },
                    editType: "plot"
                },
                text: Zy.text,
                textinfo: {
                    valType: "flaglist",
                    flags: [
                        "label",
                        "text",
                        "value",
                        "current path",
                        "percent root",
                        "percent entry",
                        "percent parent"
                    ],
                    extras: [
                        "none"
                    ],
                    editType: "plot"
                },
                texttemplate: ukt({
                    editType: "plot"
                }, {
                    keys: qEe.eventDataKeys.concat([
                        "label",
                        "value"
                    ])
                }),
                hovertext: Zy.hovertext,
                hoverinfo: TE({}, skt.hoverinfo, {
                    flags: [
                        "label",
                        "text",
                        "value",
                        "name",
                        "current path",
                        "percent root",
                        "percent entry",
                        "percent parent"
                    ],
                    dflt: "label+text+value+name"
                }),
                hovertemplate: lkt({}, {
                    keys: qEe.eventDataKeys
                }),
                textfont: Zy.textfont,
                insidetextorientation: Zy.insidetextorientation,
                insidetextfont: Zy.insidetextfont,
                outsidetextfont: TE({}, Zy.outsidetextfont, {}),
                rotation: {
                    valType: "angle",
                    dflt: 0,
                    editType: "plot"
                },
                sort: Zy.sort,
                root: {
                    color: {
                        valType: "color",
                        editType: "calc",
                        dflt: "rgba(0,0,0,0)"
                    },
                    editType: "calc"
                },
                domain: fkt({
                    name: "sunburst",
                    trace: !0,
                    editType: "calc"
                })
            };
        });
        var aW = ye((yfr, BEe)=>{
            "use strict";
            BEe.exports = {
                sunburstcolorway: {
                    valType: "colorlist",
                    editType: "calc"
                },
                extendsunburstcolors: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc"
                }
            };
        });
        var HEe = ye((_fr, VEe)=>{
            "use strict";
            var NEe = Mr(), dkt = AE(), vkt = Ju().defaults, pkt = r0().handleText, gkt = S2().handleMarkerDefaults, UEe = Mu(), mkt = UEe.hasColorscale, ykt = UEe.handleDefaults;
            VEe.exports = function(t, r, n, i) {
                function a(h, d) {
                    return NEe.coerce(t, r, dkt, h, d);
                }
                var o = a("labels"), s = a("parents");
                if (!o || !o.length || !s || !s.length) {
                    r.visible = !1;
                    return;
                }
                var l = a("values");
                l && l.length ? a("branchvalues") : a("count"), a("level"), a("maxdepth"), gkt(t, r, i, a);
                var u = r._hasColorscale = mkt(t, "marker", "colors") || (t.marker || {}).coloraxis;
                u && ykt(t, r, i, a, {
                    prefix: "marker.",
                    cLetter: "c"
                }), a("leaf.opacity", u ? 1 : .7);
                var c = a("text");
                a("texttemplate"), r.texttemplate || a("textinfo", NEe.isArrayOrTypedArray(c) ? "text+label" : "label"), a("hovertext"), a("hovertemplate");
                var f = "auto";
                pkt(t, r, i, a, f, {
                    moduleHasSelected: !1,
                    moduleHasUnselected: !1,
                    moduleHasConstrain: !1,
                    moduleHasCliponaxis: !1,
                    moduleHasTextangle: !1,
                    moduleHasInsideanchor: !1
                }), a("insidetextorientation"), a("sort"), a("rotation"), a("root.color"), vkt(r, i, a), r._length = null;
            };
        });
        var jEe = ye((xfr, GEe)=>{
            "use strict";
            var _kt = Mr(), xkt = aW();
            GEe.exports = function(t, r) {
                function n(i, a) {
                    return _kt.coerce(t, r, xkt, i, a);
                }
                n("sunburstcolorway", r.colorway), n("extendsunburstcolors");
            };
        });
        var SE = ye((vD, WEe)=>{
            (function(e, t) {
                typeof vD == "object" && typeof WEe != "undefined" ? t(vD) : (e = e || self, t(e.d3 = e.d3 || {}));
            })(vD, function(e) {
                "use strict";
                function t(Ve, Xe) {
                    return Ve.parent === Xe.parent ? 1 : 2;
                }
                function r(Ve) {
                    return Ve.reduce(n, 0) / Ve.length;
                }
                function n(Ve, Xe) {
                    return Ve + Xe.x;
                }
                function i(Ve) {
                    return 1 + Ve.reduce(a, 0);
                }
                function a(Ve, Xe) {
                    return Math.max(Ve, Xe.y);
                }
                function o(Ve) {
                    for(var Xe; Xe = Ve.children;)Ve = Xe[0];
                    return Ve;
                }
                function s(Ve) {
                    for(var Xe; Xe = Ve.children;)Ve = Xe[Xe.length - 1];
                    return Ve;
                }
                function l() {
                    var Ve = t, Xe = 1, ht = 1, Le = !1;
                    function xe(Se) {
                        var lt, Gt = 0;
                        Se.eachAfter(function(jr) {
                            var ri = jr.children;
                            ri ? (jr.x = r(ri), jr.y = i(ri)) : (jr.x = lt ? Gt += Ve(jr, lt) : 0, jr.y = 0, lt = jr);
                        });
                        var Vt = o(Se), ar = s(Se), Qr = Vt.x - Ve(Vt, ar) / 2, ai = ar.x + Ve(ar, Vt) / 2;
                        return Se.eachAfter(Le ? function(jr) {
                            jr.x = (jr.x - Se.x) * Xe, jr.y = (Se.y - jr.y) * ht;
                        } : function(jr) {
                            jr.x = (jr.x - Qr) / (ai - Qr) * Xe, jr.y = (1 - (Se.y ? jr.y / Se.y : 1)) * ht;
                        });
                    }
                    return xe.separation = function(Se) {
                        return arguments.length ? (Ve = Se, xe) : Ve;
                    }, xe.size = function(Se) {
                        return arguments.length ? (Le = !1, Xe = +Se[0], ht = +Se[1], xe) : Le ? null : [
                            Xe,
                            ht
                        ];
                    }, xe.nodeSize = function(Se) {
                        return arguments.length ? (Le = !0, Xe = +Se[0], ht = +Se[1], xe) : Le ? [
                            Xe,
                            ht
                        ] : null;
                    }, xe;
                }
                function u(Ve) {
                    var Xe = 0, ht = Ve.children, Le = ht && ht.length;
                    if (!Le) Xe = 1;
                    else for(; --Le >= 0;)Xe += ht[Le].value;
                    Ve.value = Xe;
                }
                function c() {
                    return this.eachAfter(u);
                }
                function f(Ve) {
                    var Xe = this, ht, Le = [
                        Xe
                    ], xe, Se, lt;
                    do for(ht = Le.reverse(), Le = []; Xe = ht.pop();)if (Ve(Xe), xe = Xe.children, xe) for(Se = 0, lt = xe.length; Se < lt; ++Se)Le.push(xe[Se]);
                    while (Le.length);
                    return this;
                }
                function h(Ve) {
                    for(var Xe = this, ht = [
                        Xe
                    ], Le, xe; Xe = ht.pop();)if (Ve(Xe), Le = Xe.children, Le) for(xe = Le.length - 1; xe >= 0; --xe)ht.push(Le[xe]);
                    return this;
                }
                function d(Ve) {
                    for(var Xe = this, ht = [
                        Xe
                    ], Le = [], xe, Se, lt; Xe = ht.pop();)if (Le.push(Xe), xe = Xe.children, xe) for(Se = 0, lt = xe.length; Se < lt; ++Se)ht.push(xe[Se]);
                    for(; Xe = Le.pop();)Ve(Xe);
                    return this;
                }
                function v(Ve) {
                    return this.eachAfter(function(Xe) {
                        for(var ht = +Ve(Xe.data) || 0, Le = Xe.children, xe = Le && Le.length; --xe >= 0;)ht += Le[xe].value;
                        Xe.value = ht;
                    });
                }
                function x(Ve) {
                    return this.eachBefore(function(Xe) {
                        Xe.children && Xe.children.sort(Ve);
                    });
                }
                function b(Ve) {
                    for(var Xe = this, ht = p(Xe, Ve), Le = [
                        Xe
                    ]; Xe !== ht;)Xe = Xe.parent, Le.push(Xe);
                    for(var xe = Le.length; Ve !== ht;)Le.splice(xe, 0, Ve), Ve = Ve.parent;
                    return Le;
                }
                function p(Ve, Xe) {
                    if (Ve === Xe) return Ve;
                    var ht = Ve.ancestors(), Le = Xe.ancestors(), xe = null;
                    for(Ve = ht.pop(), Xe = Le.pop(); Ve === Xe;)xe = Ve, Ve = ht.pop(), Xe = Le.pop();
                    return xe;
                }
                function E() {
                    for(var Ve = this, Xe = [
                        Ve
                    ]; Ve = Ve.parent;)Xe.push(Ve);
                    return Xe;
                }
                function k() {
                    var Ve = [];
                    return this.each(function(Xe) {
                        Ve.push(Xe);
                    }), Ve;
                }
                function A() {
                    var Ve = [];
                    return this.eachBefore(function(Xe) {
                        Xe.children || Ve.push(Xe);
                    }), Ve;
                }
                function L() {
                    var Ve = this, Xe = [];
                    return Ve.each(function(ht) {
                        ht !== Ve && Xe.push({
                            source: ht.parent,
                            target: ht
                        });
                    }), Xe;
                }
                function _(Ve, Xe) {
                    var ht = new T(Ve), Le = +Ve.value && (ht.value = Ve.value), xe, Se = [
                        ht
                    ], lt, Gt, Vt, ar;
                    for(Xe == null && (Xe = M); xe = Se.pop();)if (Le && (xe.value = +xe.data.value), (Gt = Xe(xe.data)) && (ar = Gt.length)) for(xe.children = new Array(ar), Vt = ar - 1; Vt >= 0; --Vt)Se.push(lt = xe.children[Vt] = new T(Gt[Vt])), lt.parent = xe, lt.depth = xe.depth + 1;
                    return ht.eachBefore(P);
                }
                function C() {
                    return _(this).eachBefore(g);
                }
                function M(Ve) {
                    return Ve.children;
                }
                function g(Ve) {
                    Ve.data = Ve.data.data;
                }
                function P(Ve) {
                    var Xe = 0;
                    do Ve.height = Xe;
                    while ((Ve = Ve.parent) && Ve.height < ++Xe);
                }
                function T(Ve) {
                    this.data = Ve, this.depth = this.height = 0, this.parent = null;
                }
                T.prototype = _.prototype = {
                    constructor: T,
                    count: c,
                    each: f,
                    eachAfter: d,
                    eachBefore: h,
                    sum: v,
                    sort: x,
                    path: b,
                    ancestors: E,
                    descendants: k,
                    leaves: A,
                    links: L,
                    copy: C
                };
                var F = Array.prototype.slice;
                function q(Ve) {
                    for(var Xe = Ve.length, ht, Le; Xe;)Le = Math.random() * Xe-- | 0, ht = Ve[Xe], Ve[Xe] = Ve[Le], Ve[Le] = ht;
                    return Ve;
                }
                function V(Ve) {
                    for(var Xe = 0, ht = (Ve = q(F.call(Ve))).length, Le = [], xe, Se; Xe < ht;)xe = Ve[Xe], Se && G(Se, xe) ? ++Xe : (Se = W(Le = H(Le, xe)), Xe = 0);
                    return Se;
                }
                function H(Ve, Xe) {
                    var ht, Le;
                    if (N(Xe, Ve)) return [
                        Xe
                    ];
                    for(ht = 0; ht < Ve.length; ++ht)if (X(Xe, Ve[ht]) && N(ae(Ve[ht], Xe), Ve)) return [
                        Ve[ht],
                        Xe
                    ];
                    for(ht = 0; ht < Ve.length - 1; ++ht)for(Le = ht + 1; Le < Ve.length; ++Le)if (X(ae(Ve[ht], Ve[Le]), Xe) && X(ae(Ve[ht], Xe), Ve[Le]) && X(ae(Ve[Le], Xe), Ve[ht]) && N(_e(Ve[ht], Ve[Le], Xe), Ve)) return [
                        Ve[ht],
                        Ve[Le],
                        Xe
                    ];
                    throw new Error;
                }
                function X(Ve, Xe) {
                    var ht = Ve.r - Xe.r, Le = Xe.x - Ve.x, xe = Xe.y - Ve.y;
                    return ht < 0 || ht * ht < Le * Le + xe * xe;
                }
                function G(Ve, Xe) {
                    var ht = Ve.r - Xe.r + 1e-6, Le = Xe.x - Ve.x, xe = Xe.y - Ve.y;
                    return ht > 0 && ht * ht > Le * Le + xe * xe;
                }
                function N(Ve, Xe) {
                    for(var ht = 0; ht < Xe.length; ++ht)if (!G(Ve, Xe[ht])) return !1;
                    return !0;
                }
                function W(Ve) {
                    switch(Ve.length){
                        case 1:
                            return re(Ve[0]);
                        case 2:
                            return ae(Ve[0], Ve[1]);
                        case 3:
                            return _e(Ve[0], Ve[1], Ve[2]);
                    }
                }
                function re(Ve) {
                    return {
                        x: Ve.x,
                        y: Ve.y,
                        r: Ve.r
                    };
                }
                function ae(Ve, Xe) {
                    var ht = Ve.x, Le = Ve.y, xe = Ve.r, Se = Xe.x, lt = Xe.y, Gt = Xe.r, Vt = Se - ht, ar = lt - Le, Qr = Gt - xe, ai = Math.sqrt(Vt * Vt + ar * ar);
                    return {
                        x: (ht + Se + Vt / ai * Qr) / 2,
                        y: (Le + lt + ar / ai * Qr) / 2,
                        r: (ai + xe + Gt) / 2
                    };
                }
                function _e(Ve, Xe, ht) {
                    var Le = Ve.x, xe = Ve.y, Se = Ve.r, lt = Xe.x, Gt = Xe.y, Vt = Xe.r, ar = ht.x, Qr = ht.y, ai = ht.r, jr = Le - lt, ri = Le - ar, bi = xe - Gt, nn = xe - Qr, Wi = Vt - Se, Ni = ai - Se, _n = Le * Le + xe * xe - Se * Se, $i = _n - lt * lt - Gt * Gt + Vt * Vt, zn = _n - ar * ar - Qr * Qr + ai * ai, Wn = ri * bi - jr * nn, It = (bi * zn - nn * $i) / (Wn * 2) - Le, ft = (nn * Wi - bi * Ni) / Wn, jt = (ri * $i - jr * zn) / (Wn * 2) - xe, Zt = (jr * Ni - ri * Wi) / Wn, yr = ft * ft + Zt * Zt - 1, Fr = 2 * (Se + It * ft + jt * Zt), Zr = It * It + jt * jt - Se * Se, Vr = -(yr ? (Fr + Math.sqrt(Fr * Fr - 4 * yr * Zr)) / (2 * yr) : Zr / Fr);
                    return {
                        x: Le + It + ft * Vr,
                        y: xe + jt + Zt * Vr,
                        r: Vr
                    };
                }
                function Me(Ve, Xe, ht) {
                    var Le = Ve.x - Xe.x, xe, Se, lt = Ve.y - Xe.y, Gt, Vt, ar = Le * Le + lt * lt;
                    ar ? (Se = Xe.r + ht.r, Se *= Se, Vt = Ve.r + ht.r, Vt *= Vt, Se > Vt ? (xe = (ar + Vt - Se) / (2 * ar), Gt = Math.sqrt(Math.max(0, Vt / ar - xe * xe)), ht.x = Ve.x - xe * Le - Gt * lt, ht.y = Ve.y - xe * lt + Gt * Le) : (xe = (ar + Se - Vt) / (2 * ar), Gt = Math.sqrt(Math.max(0, Se / ar - xe * xe)), ht.x = Xe.x + xe * Le - Gt * lt, ht.y = Xe.y + xe * lt + Gt * Le)) : (ht.x = Xe.x + ht.r, ht.y = Xe.y);
                }
                function ke(Ve, Xe) {
                    var ht = Ve.r + Xe.r - 1e-6, Le = Xe.x - Ve.x, xe = Xe.y - Ve.y;
                    return ht > 0 && ht * ht > Le * Le + xe * xe;
                }
                function ge(Ve) {
                    var Xe = Ve._, ht = Ve.next._, Le = Xe.r + ht.r, xe = (Xe.x * ht.r + ht.x * Xe.r) / Le, Se = (Xe.y * ht.r + ht.y * Xe.r) / Le;
                    return xe * xe + Se * Se;
                }
                function ie(Ve) {
                    this._ = Ve, this.next = null, this.previous = null;
                }
                function Te(Ve) {
                    if (!(xe = Ve.length)) return 0;
                    var Xe, ht, Le, xe, Se, lt, Gt, Vt, ar, Qr, ai;
                    if (Xe = Ve[0], Xe.x = 0, Xe.y = 0, !(xe > 1)) return Xe.r;
                    if (ht = Ve[1], Xe.x = -ht.r, ht.x = Xe.r, ht.y = 0, !(xe > 2)) return Xe.r + ht.r;
                    Me(ht, Xe, Le = Ve[2]), Xe = new ie(Xe), ht = new ie(ht), Le = new ie(Le), Xe.next = Le.previous = ht, ht.next = Xe.previous = Le, Le.next = ht.previous = Xe;
                    e: for(Gt = 3; Gt < xe; ++Gt){
                        Me(Xe._, ht._, Le = Ve[Gt]), Le = new ie(Le), Vt = ht.next, ar = Xe.previous, Qr = ht._.r, ai = Xe._.r;
                        do if (Qr <= ai) {
                            if (ke(Vt._, Le._)) {
                                ht = Vt, Xe.next = ht, ht.previous = Xe, --Gt;
                                continue e;
                            }
                            Qr += Vt._.r, Vt = Vt.next;
                        } else {
                            if (ke(ar._, Le._)) {
                                Xe = ar, Xe.next = ht, ht.previous = Xe, --Gt;
                                continue e;
                            }
                            ai += ar._.r, ar = ar.previous;
                        }
                        while (Vt !== ar.next);
                        for(Le.previous = Xe, Le.next = ht, Xe.next = ht.previous = ht = Le, Se = ge(Xe); (Le = Le.next) !== ht;)(lt = ge(Le)) < Se && (Xe = Le, Se = lt);
                        ht = Xe.next;
                    }
                    for(Xe = [
                        ht._
                    ], Le = ht; (Le = Le.next) !== ht;)Xe.push(Le._);
                    for(Le = V(Xe), Gt = 0; Gt < xe; ++Gt)Xe = Ve[Gt], Xe.x -= Le.x, Xe.y -= Le.y;
                    return Le.r;
                }
                function Ee(Ve) {
                    return Te(Ve), Ve;
                }
                function Ae(Ve) {
                    return Ve == null ? null : ze(Ve);
                }
                function ze(Ve) {
                    if (typeof Ve != "function") throw new Error;
                    return Ve;
                }
                function Ce() {
                    return 0;
                }
                function me(Ve) {
                    return function() {
                        return Ve;
                    };
                }
                function Re(Ve) {
                    return Math.sqrt(Ve.value);
                }
                function ce() {
                    var Ve = null, Xe = 1, ht = 1, Le = Ce;
                    function xe(Se) {
                        return Se.x = Xe / 2, Se.y = ht / 2, Ve ? Se.eachBefore(Ge(Ve)).eachAfter(nt(Le, .5)).eachBefore(ct(1)) : Se.eachBefore(Ge(Re)).eachAfter(nt(Ce, 1)).eachAfter(nt(Le, Se.r / Math.min(Xe, ht))).eachBefore(ct(Math.min(Xe, ht) / (2 * Se.r))), Se;
                    }
                    return xe.radius = function(Se) {
                        return arguments.length ? (Ve = Ae(Se), xe) : Ve;
                    }, xe.size = function(Se) {
                        return arguments.length ? (Xe = +Se[0], ht = +Se[1], xe) : [
                            Xe,
                            ht
                        ];
                    }, xe.padding = function(Se) {
                        return arguments.length ? (Le = typeof Se == "function" ? Se : me(+Se), xe) : Le;
                    }, xe;
                }
                function Ge(Ve) {
                    return function(Xe) {
                        Xe.children || (Xe.r = Math.max(0, +Ve(Xe) || 0));
                    };
                }
                function nt(Ve, Xe) {
                    return function(ht) {
                        if (Le = ht.children) {
                            var Le, xe, Se = Le.length, lt = Ve(ht) * Xe || 0, Gt;
                            if (lt) for(xe = 0; xe < Se; ++xe)Le[xe].r += lt;
                            if (Gt = Te(Le), lt) for(xe = 0; xe < Se; ++xe)Le[xe].r -= lt;
                            ht.r = Gt + lt;
                        }
                    };
                }
                function ct(Ve) {
                    return function(Xe) {
                        var ht = Xe.parent;
                        Xe.r *= Ve, ht && (Xe.x = ht.x + Ve * Xe.x, Xe.y = ht.y + Ve * Xe.y);
                    };
                }
                function qt(Ve) {
                    Ve.x0 = Math.round(Ve.x0), Ve.y0 = Math.round(Ve.y0), Ve.x1 = Math.round(Ve.x1), Ve.y1 = Math.round(Ve.y1);
                }
                function rt(Ve, Xe, ht, Le, xe) {
                    for(var Se = Ve.children, lt, Gt = -1, Vt = Se.length, ar = Ve.value && (Le - Xe) / Ve.value; ++Gt < Vt;)lt = Se[Gt], lt.y0 = ht, lt.y1 = xe, lt.x0 = Xe, lt.x1 = Xe += lt.value * ar;
                }
                function ot() {
                    var Ve = 1, Xe = 1, ht = 0, Le = !1;
                    function xe(lt) {
                        var Gt = lt.height + 1;
                        return lt.x0 = lt.y0 = ht, lt.x1 = Ve, lt.y1 = Xe / Gt, lt.eachBefore(Se(Xe, Gt)), Le && lt.eachBefore(qt), lt;
                    }
                    function Se(lt, Gt) {
                        return function(Vt) {
                            Vt.children && rt(Vt, Vt.x0, lt * (Vt.depth + 1) / Gt, Vt.x1, lt * (Vt.depth + 2) / Gt);
                            var ar = Vt.x0, Qr = Vt.y0, ai = Vt.x1 - ht, jr = Vt.y1 - ht;
                            ai < ar && (ar = ai = (ar + ai) / 2), jr < Qr && (Qr = jr = (Qr + jr) / 2), Vt.x0 = ar, Vt.y0 = Qr, Vt.x1 = ai, Vt.y1 = jr;
                        };
                    }
                    return xe.round = function(lt) {
                        return arguments.length ? (Le = !!lt, xe) : Le;
                    }, xe.size = function(lt) {
                        return arguments.length ? (Ve = +lt[0], Xe = +lt[1], xe) : [
                            Ve,
                            Xe
                        ];
                    }, xe.padding = function(lt) {
                        return arguments.length ? (ht = +lt, xe) : ht;
                    }, xe;
                }
                var Rt = "$", kt = {
                    depth: -1
                }, Ct = {};
                function Yt(Ve) {
                    return Ve.id;
                }
                function xr(Ve) {
                    return Ve.parentId;
                }
                function er() {
                    var Ve = Yt, Xe = xr;
                    function ht(Le) {
                        var xe, Se, lt = Le.length, Gt, Vt, ar, Qr = new Array(lt), ai, jr, ri = {};
                        for(Se = 0; Se < lt; ++Se)xe = Le[Se], ar = Qr[Se] = new T(xe), (ai = Ve(xe, Se, Le)) != null && (ai += "") && (jr = Rt + (ar.id = ai), ri[jr] = jr in ri ? Ct : ar);
                        for(Se = 0; Se < lt; ++Se)if (ar = Qr[Se], ai = Xe(Le[Se], Se, Le), ai == null || !(ai += "")) {
                            if (Gt) throw new Error("multiple roots");
                            Gt = ar;
                        } else {
                            if (Vt = ri[Rt + ai], !Vt) throw new Error("missing: " + ai);
                            if (Vt === Ct) throw new Error("ambiguous: " + ai);
                            Vt.children ? Vt.children.push(ar) : Vt.children = [
                                ar
                            ], ar.parent = Vt;
                        }
                        if (!Gt) throw new Error("no root");
                        if (Gt.parent = kt, Gt.eachBefore(function(bi) {
                            bi.depth = bi.parent.depth + 1, --lt;
                        }).eachBefore(P), Gt.parent = null, lt > 0) throw new Error("cycle");
                        return Gt;
                    }
                    return ht.id = function(Le) {
                        return arguments.length ? (Ve = ze(Le), ht) : Ve;
                    }, ht.parentId = function(Le) {
                        return arguments.length ? (Xe = ze(Le), ht) : Xe;
                    }, ht;
                }
                function Ke(Ve, Xe) {
                    return Ve.parent === Xe.parent ? 1 : 2;
                }
                function xt(Ve) {
                    var Xe = Ve.children;
                    return Xe ? Xe[0] : Ve.t;
                }
                function bt(Ve) {
                    var Xe = Ve.children;
                    return Xe ? Xe[Xe.length - 1] : Ve.t;
                }
                function Lt(Ve, Xe, ht) {
                    var Le = ht / (Xe.i - Ve.i);
                    Xe.c -= Le, Xe.s += ht, Ve.c += Le, Xe.z += ht, Xe.m += ht;
                }
                function St(Ve) {
                    for(var Xe = 0, ht = 0, Le = Ve.children, xe = Le.length, Se; --xe >= 0;)Se = Le[xe], Se.z += Xe, Se.m += Xe, Xe += Se.s + (ht += Se.c);
                }
                function Et(Ve, Xe, ht) {
                    return Ve.a.parent === Xe.parent ? Ve.a : ht;
                }
                function dt(Ve, Xe) {
                    this._ = Ve, this.parent = null, this.children = null, this.A = null, this.a = this, this.z = 0, this.m = 0, this.c = 0, this.s = 0, this.t = null, this.i = Xe;
                }
                dt.prototype = Object.create(T.prototype);
                function Ht(Ve) {
                    for(var Xe = new dt(Ve, 0), ht, Le = [
                        Xe
                    ], xe, Se, lt, Gt; ht = Le.pop();)if (Se = ht._.children) for(ht.children = new Array(Gt = Se.length), lt = Gt - 1; lt >= 0; --lt)Le.push(xe = ht.children[lt] = new dt(Se[lt], lt)), xe.parent = ht;
                    return (Xe.parent = new dt(null, 0)).children = [
                        Xe
                    ], Xe;
                }
                function $t() {
                    var Ve = Ke, Xe = 1, ht = 1, Le = null;
                    function xe(ar) {
                        var Qr = Ht(ar);
                        if (Qr.eachAfter(Se), Qr.parent.m = -Qr.z, Qr.eachBefore(lt), Le) ar.eachBefore(Vt);
                        else {
                            var ai = ar, jr = ar, ri = ar;
                            ar.eachBefore(function(_n) {
                                _n.x < ai.x && (ai = _n), _n.x > jr.x && (jr = _n), _n.depth > ri.depth && (ri = _n);
                            });
                            var bi = ai === jr ? 1 : Ve(ai, jr) / 2, nn = bi - ai.x, Wi = Xe / (jr.x + bi + nn), Ni = ht / (ri.depth || 1);
                            ar.eachBefore(function(_n) {
                                _n.x = (_n.x + nn) * Wi, _n.y = _n.depth * Ni;
                            });
                        }
                        return ar;
                    }
                    function Se(ar) {
                        var Qr = ar.children, ai = ar.parent.children, jr = ar.i ? ai[ar.i - 1] : null;
                        if (Qr) {
                            St(ar);
                            var ri = (Qr[0].z + Qr[Qr.length - 1].z) / 2;
                            jr ? (ar.z = jr.z + Ve(ar._, jr._), ar.m = ar.z - ri) : ar.z = ri;
                        } else jr && (ar.z = jr.z + Ve(ar._, jr._));
                        ar.parent.A = Gt(ar, jr, ar.parent.A || ai[0]);
                    }
                    function lt(ar) {
                        ar._.x = ar.z + ar.parent.m, ar.m += ar.parent.m;
                    }
                    function Gt(ar, Qr, ai) {
                        if (Qr) {
                            for(var jr = ar, ri = ar, bi = Qr, nn = jr.parent.children[0], Wi = jr.m, Ni = ri.m, _n = bi.m, $i = nn.m, zn; bi = bt(bi), jr = xt(jr), bi && jr;)nn = xt(nn), ri = bt(ri), ri.a = ar, zn = bi.z + _n - jr.z - Wi + Ve(bi._, jr._), zn > 0 && (Lt(Et(bi, ar, ai), ar, zn), Wi += zn, Ni += zn), _n += bi.m, Wi += jr.m, $i += nn.m, Ni += ri.m;
                            bi && !bt(ri) && (ri.t = bi, ri.m += _n - Ni), jr && !xt(nn) && (nn.t = jr, nn.m += Wi - $i, ai = ar);
                        }
                        return ai;
                    }
                    function Vt(ar) {
                        ar.x *= Xe, ar.y = ar.depth * ht;
                    }
                    return xe.separation = function(ar) {
                        return arguments.length ? (Ve = ar, xe) : Ve;
                    }, xe.size = function(ar) {
                        return arguments.length ? (Le = !1, Xe = +ar[0], ht = +ar[1], xe) : Le ? null : [
                            Xe,
                            ht
                        ];
                    }, xe.nodeSize = function(ar) {
                        return arguments.length ? (Le = !0, Xe = +ar[0], ht = +ar[1], xe) : Le ? [
                            Xe,
                            ht
                        ] : null;
                    }, xe;
                }
                function fr(Ve, Xe, ht, Le, xe) {
                    for(var Se = Ve.children, lt, Gt = -1, Vt = Se.length, ar = Ve.value && (xe - ht) / Ve.value; ++Gt < Vt;)lt = Se[Gt], lt.x0 = Xe, lt.x1 = Le, lt.y0 = ht, lt.y1 = ht += lt.value * ar;
                }
                var _r = (1 + Math.sqrt(5)) / 2;
                function Br(Ve, Xe, ht, Le, xe, Se) {
                    for(var lt = [], Gt = Xe.children, Vt, ar, Qr = 0, ai = 0, jr = Gt.length, ri, bi, nn = Xe.value, Wi, Ni, _n, $i, zn, Wn, It; Qr < jr;){
                        ri = xe - ht, bi = Se - Le;
                        do Wi = Gt[ai++].value;
                        while (!Wi && ai < jr);
                        for(Ni = _n = Wi, Wn = Math.max(bi / ri, ri / bi) / (nn * Ve), It = Wi * Wi * Wn, zn = Math.max(_n / It, It / Ni); ai < jr; ++ai){
                            if (Wi += ar = Gt[ai].value, ar < Ni && (Ni = ar), ar > _n && (_n = ar), It = Wi * Wi * Wn, $i = Math.max(_n / It, It / Ni), $i > zn) {
                                Wi -= ar;
                                break;
                            }
                            zn = $i;
                        }
                        lt.push(Vt = {
                            value: Wi,
                            dice: ri < bi,
                            children: Gt.slice(Qr, ai)
                        }), Vt.dice ? rt(Vt, ht, Le, xe, nn ? Le += bi * Wi / nn : Se) : fr(Vt, ht, Le, nn ? ht += ri * Wi / nn : xe, Se), nn -= Wi, Qr = ai;
                    }
                    return lt;
                }
                var Or = function Ve(Xe) {
                    function ht(Le, xe, Se, lt, Gt) {
                        Br(Xe, Le, xe, Se, lt, Gt);
                    }
                    return ht.ratio = function(Le) {
                        return Ve((Le = +Le) > 1 ? Le : 1);
                    }, ht;
                }(_r);
                function Nr() {
                    var Ve = Or, Xe = !1, ht = 1, Le = 1, xe = [
                        0
                    ], Se = Ce, lt = Ce, Gt = Ce, Vt = Ce, ar = Ce;
                    function Qr(jr) {
                        return jr.x0 = jr.y0 = 0, jr.x1 = ht, jr.y1 = Le, jr.eachBefore(ai), xe = [
                            0
                        ], Xe && jr.eachBefore(qt), jr;
                    }
                    function ai(jr) {
                        var ri = xe[jr.depth], bi = jr.x0 + ri, nn = jr.y0 + ri, Wi = jr.x1 - ri, Ni = jr.y1 - ri;
                        Wi < bi && (bi = Wi = (bi + Wi) / 2), Ni < nn && (nn = Ni = (nn + Ni) / 2), jr.x0 = bi, jr.y0 = nn, jr.x1 = Wi, jr.y1 = Ni, jr.children && (ri = xe[jr.depth + 1] = Se(jr) / 2, bi += ar(jr) - ri, nn += lt(jr) - ri, Wi -= Gt(jr) - ri, Ni -= Vt(jr) - ri, Wi < bi && (bi = Wi = (bi + Wi) / 2), Ni < nn && (nn = Ni = (nn + Ni) / 2), Ve(jr, bi, nn, Wi, Ni));
                    }
                    return Qr.round = function(jr) {
                        return arguments.length ? (Xe = !!jr, Qr) : Xe;
                    }, Qr.size = function(jr) {
                        return arguments.length ? (ht = +jr[0], Le = +jr[1], Qr) : [
                            ht,
                            Le
                        ];
                    }, Qr.tile = function(jr) {
                        return arguments.length ? (Ve = ze(jr), Qr) : Ve;
                    }, Qr.padding = function(jr) {
                        return arguments.length ? Qr.paddingInner(jr).paddingOuter(jr) : Qr.paddingInner();
                    }, Qr.paddingInner = function(jr) {
                        return arguments.length ? (Se = typeof jr == "function" ? jr : me(+jr), Qr) : Se;
                    }, Qr.paddingOuter = function(jr) {
                        return arguments.length ? Qr.paddingTop(jr).paddingRight(jr).paddingBottom(jr).paddingLeft(jr) : Qr.paddingTop();
                    }, Qr.paddingTop = function(jr) {
                        return arguments.length ? (lt = typeof jr == "function" ? jr : me(+jr), Qr) : lt;
                    }, Qr.paddingRight = function(jr) {
                        return arguments.length ? (Gt = typeof jr == "function" ? jr : me(+jr), Qr) : Gt;
                    }, Qr.paddingBottom = function(jr) {
                        return arguments.length ? (Vt = typeof jr == "function" ? jr : me(+jr), Qr) : Vt;
                    }, Qr.paddingLeft = function(jr) {
                        return arguments.length ? (ar = typeof jr == "function" ? jr : me(+jr), Qr) : ar;
                    }, Qr;
                }
                function ut(Ve, Xe, ht, Le, xe) {
                    var Se = Ve.children, lt, Gt = Se.length, Vt, ar = new Array(Gt + 1);
                    for(ar[0] = Vt = lt = 0; lt < Gt; ++lt)ar[lt + 1] = Vt += Se[lt].value;
                    Qr(0, Gt, Ve.value, Xe, ht, Le, xe);
                    function Qr(ai, jr, ri, bi, nn, Wi, Ni) {
                        if (ai >= jr - 1) {
                            var _n = Se[ai];
                            _n.x0 = bi, _n.y0 = nn, _n.x1 = Wi, _n.y1 = Ni;
                            return;
                        }
                        for(var $i = ar[ai], zn = ri / 2 + $i, Wn = ai + 1, It = jr - 1; Wn < It;){
                            var ft = Wn + It >>> 1;
                            ar[ft] < zn ? Wn = ft + 1 : It = ft;
                        }
                        zn - ar[Wn - 1] < ar[Wn] - zn && ai + 1 < Wn && --Wn;
                        var jt = ar[Wn] - $i, Zt = ri - jt;
                        if (Wi - bi > Ni - nn) {
                            var yr = (bi * Zt + Wi * jt) / ri;
                            Qr(ai, Wn, jt, bi, nn, yr, Ni), Qr(Wn, jr, Zt, yr, nn, Wi, Ni);
                        } else {
                            var Fr = (nn * Zt + Ni * jt) / ri;
                            Qr(ai, Wn, jt, bi, nn, Wi, Fr), Qr(Wn, jr, Zt, bi, Fr, Wi, Ni);
                        }
                    }
                }
                function Ne(Ve, Xe, ht, Le, xe) {
                    (Ve.depth & 1 ? fr : rt)(Ve, Xe, ht, Le, xe);
                }
                var Ye = function Ve(Xe) {
                    function ht(Le, xe, Se, lt, Gt) {
                        if ((Vt = Le._squarify) && Vt.ratio === Xe) for(var Vt, ar, Qr, ai, jr = -1, ri, bi = Vt.length, nn = Le.value; ++jr < bi;){
                            for(ar = Vt[jr], Qr = ar.children, ai = ar.value = 0, ri = Qr.length; ai < ri; ++ai)ar.value += Qr[ai].value;
                            ar.dice ? rt(ar, xe, Se, lt, Se += (Gt - Se) * ar.value / nn) : fr(ar, xe, Se, xe += (lt - xe) * ar.value / nn, Gt), nn -= ar.value;
                        }
                        else Le._squarify = Vt = Br(Xe, Le, xe, Se, lt, Gt), Vt.ratio = Xe;
                    }
                    return ht.ratio = function(Le) {
                        return Ve((Le = +Le) > 1 ? Le : 1);
                    }, ht;
                }(_r);
                e.cluster = l, e.hierarchy = _, e.pack = ce, e.packEnclose = V, e.packSiblings = Ee, e.partition = ot, e.stratify = er, e.tree = $t, e.treemap = Nr, e.treemapBinary = ut, e.treemapDice = rt, e.treemapResquarify = Ye, e.treemapSlice = fr, e.treemapSliceDice = Ne, e.treemapSquarify = Or, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var EE = ye((ME)=>{
            "use strict";
            var ZEe = SE(), bkt = uo(), b5 = Mr(), wkt = Mu().makeColorScaleFuncFromTrace, Tkt = y5().makePullColorFn, Akt = y5().generateExtendedColors, Skt = Mu().calc, Mkt = es().ALMOST_EQUAL, Ekt = {}, kkt = {}, Ckt = {};
            ME.calc = function(e, t) {
                var r = e._fullLayout, n = t.ids, i = b5.isArrayOrTypedArray(n), a = t.labels, o = t.parents, s = t.values, l = b5.isArrayOrTypedArray(s), u = [], c = {}, f = {}, h = function(G, N) {
                    c[G] ? c[G].push(N) : c[G] = [
                        N
                    ], f[N] = 1;
                }, d = function(G) {
                    return G || typeof G == "number";
                }, v = function(G) {
                    return !l || bkt(s[G]) && s[G] >= 0;
                }, x, b, p;
                i ? (x = Math.min(n.length, o.length), b = function(G) {
                    return d(n[G]) && v(G);
                }, p = function(G) {
                    return String(n[G]);
                }) : (x = Math.min(a.length, o.length), b = function(G) {
                    return d(a[G]) && v(G);
                }, p = function(G) {
                    return String(a[G]);
                }), l && (x = Math.min(x, s.length));
                for(var E = 0; E < x; E++)if (b(E)) {
                    var k = p(E), A = d(o[E]) ? String(o[E]) : "", L = {
                        i: E,
                        id: k,
                        pid: A,
                        label: d(a[E]) ? String(a[E]) : ""
                    };
                    l && (L.v = +s[E]), u.push(L), h(A, k);
                }
                if (c[""]) {
                    if (c[""].length > 1) {
                        for(var M = b5.randstr(), g = 0; g < u.length; g++)u[g].pid === "" && (u[g].pid = M);
                        u.unshift({
                            hasMultipleRoots: !0,
                            id: M,
                            pid: "",
                            label: ""
                        });
                    }
                } else {
                    var _ = [], C;
                    for(C in c)f[C] || _.push(C);
                    if (_.length === 1) C = _[0], u.unshift({
                        hasImpliedRoot: !0,
                        id: C,
                        pid: "",
                        label: C
                    });
                    else return b5.warn([
                        "Multiple implied roots, cannot build",
                        t.type,
                        "hierarchy of",
                        t.name + ".",
                        "These roots include:",
                        _.join(", ")
                    ].join(" "));
                }
                var P;
                try {
                    P = ZEe.stratify().id(function(G) {
                        return G.id;
                    }).parentId(function(G) {
                        return G.pid;
                    })(u);
                } catch (G) {
                    return b5.warn([
                        "Failed to build",
                        t.type,
                        "hierarchy of",
                        t.name + ".",
                        "Error:",
                        G.message
                    ].join(" "));
                }
                var T = ZEe.hierarchy(P), F = !1;
                if (l) switch(t.branchvalues){
                    case "remainder":
                        T.sum(function(G) {
                            return G.data.v;
                        });
                        break;
                    case "total":
                        T.each(function(G) {
                            var N = G.data.data, W = N.v;
                            if (G.children) {
                                var re = G.children.reduce(function(ae, _e) {
                                    return ae + _e.data.data.v;
                                }, 0);
                                if ((N.hasImpliedRoot || N.hasMultipleRoots) && (W = re), W < re * Mkt) return F = !0, b5.warn([
                                    "Total value for node",
                                    G.data.data.id,
                                    "of",
                                    t.name,
                                    "is smaller than the sum of its children.",
                                    `
parent value =`,
                                    W,
                                    `
children sum =`,
                                    re
                                ].join(" "));
                            }
                            G.value = W;
                        });
                        break;
                }
                else XEe(T, t, {
                    branches: t.count.indexOf("branches") !== -1,
                    leaves: t.count.indexOf("leaves") !== -1
                });
                if (!F) {
                    t.sort && T.sort(function(G, N) {
                        return N.value - G.value;
                    });
                    var q, V, H = t.marker.colors || [], X = !!H.length;
                    return t._hasColorscale ? (X || (H = l ? t.values : t._values), Skt(e, t, {
                        vals: H,
                        containerStr: "marker",
                        cLetter: "c"
                    }), V = wkt(t.marker)) : q = Tkt(r["_" + t.type + "colormap"]), T.each(function(G) {
                        var N = G.data.data;
                        N.color = t._hasColorscale ? V(H[N.i]) : q(H[N.i], N.id);
                    }), u[0].hierarchy = T, u;
                }
            };
            ME._runCrossTraceCalc = function(e, t) {
                var r = t._fullLayout, n = t.calcdata, i = r[e + "colorway"], a = r["_" + e + "colormap"];
                r["extend" + e + "colors"] && (i = Akt(i, e === "icicle" ? Ckt : e === "treemap" ? kkt : Ekt));
                var o = 0, s;
                function l(h) {
                    var d = h.data.data, v = d.id;
                    d.color === !1 && (a[v] ? d.color = a[v] : h.parent ? h.parent.parent ? d.color = h.parent.data.data.color : (a[v] = d.color = i[o % i.length], o++) : d.color = s);
                }
                for(var u = 0; u < n.length; u++){
                    var c = n[u], f = c[0];
                    f.trace.type === e && f.hierarchy && (s = f.trace.root.color, f.hierarchy.each(l));
                }
            };
            ME.crossTraceCalc = function(e) {
                return ME._runCrossTraceCalc("sunburst", e);
            };
            function XEe(e, t, r) {
                var n = 0, i = e.children;
                if (i) {
                    for(var a = i.length, o = 0; o < a; o++)n += XEe(i[o], t, r);
                    r.branches && n++;
                } else r.leaves && n++;
                return e.value = e.data.data.value = n, t._values || (t._values = []), t._values[e.data.data.i] = n, n;
            }
        });
        function Xy(e, t, r) {
            e.prototype = t.prototype = r, r.constructor = e;
        }
        function G_(e, t) {
            var r = Object.create(e.prototype);
            for(var n in t)r[n] = t[n];
            return r;
        }
        var pD = Ll(()=>{});
        function Vm() {}
        function KEe() {
            return this.rgb().formatHex();
        }
        function qkt() {
            return this.rgb().formatHex8();
        }
        function Okt() {
            return ike(this).formatHsl();
        }
        function JEe() {
            return this.rgb().formatRgb();
        }
        function W_(e) {
            var t, r;
            return e = (e + "").trim().toLowerCase(), (t = Lkt.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? $Ee(t) : r === 3 ? new hd(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? gD(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? gD(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = Pkt.exec(e)) ? new hd(t[1], t[2], t[3], 1) : (t = Ikt.exec(e)) ? new hd(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Rkt.exec(e)) ? gD(t[1], t[2], t[3], t[4]) : (t = Dkt.exec(e)) ? gD(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = zkt.exec(e)) ? tke(t[1], t[2] / 100, t[3] / 100, 1) : (t = Fkt.exec(e)) ? tke(t[1], t[2] / 100, t[3] / 100, t[4]) : YEe.hasOwnProperty(e) ? $Ee(YEe[e]) : e === "transparent" ? new hd(NaN, NaN, NaN, 0) : null;
        }
        function $Ee(e) {
            return new hd(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
        }
        function gD(e, t, r, n) {
            return n <= 0 && (e = t = r = NaN), new hd(e, t, r, n);
        }
        function CE(e) {
            return e instanceof Vm || (e = W_(e)), e ? (e = e.rgb(), new hd(e.r, e.g, e.b, e.opacity)) : new hd;
        }
        function T5(e, t, r, n) {
            return arguments.length === 1 ? CE(e) : new hd(e, t, r, n == null ? 1 : n);
        }
        function hd(e, t, r, n) {
            this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
        }
        function QEe() {
            return `#${M2(this.r)}${M2(this.g)}${M2(this.b)}`;
        }
        function Bkt() {
            return `#${M2(this.r)}${M2(this.g)}${M2(this.b)}${M2((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
        }
        function eke() {
            let e = yD(this.opacity);
            return `${e === 1 ? "rgb(" : "rgba("}${E2(this.r)}, ${E2(this.g)}, ${E2(this.b)}${e === 1 ? ")" : `, ${e})`}`;
        }
        function yD(e) {
            return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
        }
        function E2(e) {
            return Math.max(0, Math.min(255, Math.round(e) || 0));
        }
        function M2(e) {
            return e = E2(e), (e < 16 ? "0" : "") + e.toString(16);
        }
        function tke(e, t, r, n) {
            return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new Zg(e, t, r, n);
        }
        function ike(e) {
            if (e instanceof Zg) return new Zg(e.h, e.s, e.l, e.opacity);
            if (e instanceof Vm || (e = W_(e)), !e) return new Zg;
            if (e instanceof Zg) return e;
            e = e.rgb();
            var t = e.r / 255, r = e.g / 255, n = e.b / 255, i = Math.min(t, r, n), a = Math.max(t, r, n), o = NaN, s = a - i, l = (a + i) / 2;
            return s ? (t === a ? o = (r - n) / s + (r < n) * 6 : r === a ? o = (n - t) / s + 2 : o = (t - r) / s + 4, s /= l < .5 ? a + i : 2 - a - i, o *= 60) : s = l > 0 && l < 1 ? 0 : o, new Zg(o, s, l, e.opacity);
        }
        function LE(e, t, r, n) {
            return arguments.length === 1 ? ike(e) : new Zg(e, t, r, n == null ? 1 : n);
        }
        function Zg(e, t, r, n) {
            this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
        }
        function rke(e) {
            return e = (e || 0) % 360, e < 0 ? e + 360 : e;
        }
        function mD(e) {
            return Math.max(0, Math.min(1, e || 0));
        }
        function oW(e, t, r) {
            return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
        }
        var j_, k2, w5, kE, Um, Lkt, Pkt, Ikt, Rkt, Dkt, zkt, Fkt, YEe, _D = Ll(()=>{
            pD();
            j_ = .7, k2 = 1 / j_, w5 = "\\s*([+-]?\\d+)\\s*", kE = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Um = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Lkt = /^#([0-9a-f]{3,8})$/, Pkt = new RegExp(`^rgb\\(${w5},${w5},${w5}\\)$`), Ikt = new RegExp(`^rgb\\(${Um},${Um},${Um}\\)$`), Rkt = new RegExp(`^rgba\\(${w5},${w5},${w5},${kE}\\)$`), Dkt = new RegExp(`^rgba\\(${Um},${Um},${Um},${kE}\\)$`), zkt = new RegExp(`^hsl\\(${kE},${Um},${Um}\\)$`), Fkt = new RegExp(`^hsla\\(${kE},${Um},${Um},${kE}\\)$`), YEe = {
                aliceblue: 15792383,
                antiquewhite: 16444375,
                aqua: 65535,
                aquamarine: 8388564,
                azure: 15794175,
                beige: 16119260,
                bisque: 16770244,
                black: 0,
                blanchedalmond: 16772045,
                blue: 255,
                blueviolet: 9055202,
                brown: 10824234,
                burlywood: 14596231,
                cadetblue: 6266528,
                chartreuse: 8388352,
                chocolate: 13789470,
                coral: 16744272,
                cornflowerblue: 6591981,
                cornsilk: 16775388,
                crimson: 14423100,
                cyan: 65535,
                darkblue: 139,
                darkcyan: 35723,
                darkgoldenrod: 12092939,
                darkgray: 11119017,
                darkgreen: 25600,
                darkgrey: 11119017,
                darkkhaki: 12433259,
                darkmagenta: 9109643,
                darkolivegreen: 5597999,
                darkorange: 16747520,
                darkorchid: 10040012,
                darkred: 9109504,
                darksalmon: 15308410,
                darkseagreen: 9419919,
                darkslateblue: 4734347,
                darkslategray: 3100495,
                darkslategrey: 3100495,
                darkturquoise: 52945,
                darkviolet: 9699539,
                deeppink: 16716947,
                deepskyblue: 49151,
                dimgray: 6908265,
                dimgrey: 6908265,
                dodgerblue: 2003199,
                firebrick: 11674146,
                floralwhite: 16775920,
                forestgreen: 2263842,
                fuchsia: 16711935,
                gainsboro: 14474460,
                ghostwhite: 16316671,
                gold: 16766720,
                goldenrod: 14329120,
                gray: 8421504,
                green: 32768,
                greenyellow: 11403055,
                grey: 8421504,
                honeydew: 15794160,
                hotpink: 16738740,
                indianred: 13458524,
                indigo: 4915330,
                ivory: 16777200,
                khaki: 15787660,
                lavender: 15132410,
                lavenderblush: 16773365,
                lawngreen: 8190976,
                lemonchiffon: 16775885,
                lightblue: 11393254,
                lightcoral: 15761536,
                lightcyan: 14745599,
                lightgoldenrodyellow: 16448210,
                lightgray: 13882323,
                lightgreen: 9498256,
                lightgrey: 13882323,
                lightpink: 16758465,
                lightsalmon: 16752762,
                lightseagreen: 2142890,
                lightskyblue: 8900346,
                lightslategray: 7833753,
                lightslategrey: 7833753,
                lightsteelblue: 11584734,
                lightyellow: 16777184,
                lime: 65280,
                limegreen: 3329330,
                linen: 16445670,
                magenta: 16711935,
                maroon: 8388608,
                mediumaquamarine: 6737322,
                mediumblue: 205,
                mediumorchid: 12211667,
                mediumpurple: 9662683,
                mediumseagreen: 3978097,
                mediumslateblue: 8087790,
                mediumspringgreen: 64154,
                mediumturquoise: 4772300,
                mediumvioletred: 13047173,
                midnightblue: 1644912,
                mintcream: 16121850,
                mistyrose: 16770273,
                moccasin: 16770229,
                navajowhite: 16768685,
                navy: 128,
                oldlace: 16643558,
                olive: 8421376,
                olivedrab: 7048739,
                orange: 16753920,
                orangered: 16729344,
                orchid: 14315734,
                palegoldenrod: 15657130,
                palegreen: 10025880,
                paleturquoise: 11529966,
                palevioletred: 14381203,
                papayawhip: 16773077,
                peachpuff: 16767673,
                peru: 13468991,
                pink: 16761035,
                plum: 14524637,
                powderblue: 11591910,
                purple: 8388736,
                rebeccapurple: 6697881,
                red: 16711680,
                rosybrown: 12357519,
                royalblue: 4286945,
                saddlebrown: 9127187,
                salmon: 16416882,
                sandybrown: 16032864,
                seagreen: 3050327,
                seashell: 16774638,
                sienna: 10506797,
                silver: 12632256,
                skyblue: 8900331,
                slateblue: 6970061,
                slategray: 7372944,
                slategrey: 7372944,
                snow: 16775930,
                springgreen: 65407,
                steelblue: 4620980,
                tan: 13808780,
                teal: 32896,
                thistle: 14204888,
                tomato: 16737095,
                turquoise: 4251856,
                violet: 15631086,
                wheat: 16113331,
                white: 16777215,
                whitesmoke: 16119285,
                yellow: 16776960,
                yellowgreen: 10145074
            };
            Xy(Vm, W_, {
                copy (e) {
                    return Object.assign(new this.constructor, this, e);
                },
                displayable () {
                    return this.rgb().displayable();
                },
                hex: KEe,
                formatHex: KEe,
                formatHex8: qkt,
                formatHsl: Okt,
                formatRgb: JEe,
                toString: JEe
            });
            Xy(hd, T5, G_(Vm, {
                brighter (e) {
                    return e = e == null ? k2 : Math.pow(k2, e), new hd(this.r * e, this.g * e, this.b * e, this.opacity);
                },
                darker (e) {
                    return e = e == null ? j_ : Math.pow(j_, e), new hd(this.r * e, this.g * e, this.b * e, this.opacity);
                },
                rgb () {
                    return this;
                },
                clamp () {
                    return new hd(E2(this.r), E2(this.g), E2(this.b), yD(this.opacity));
                },
                displayable () {
                    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
                },
                hex: QEe,
                formatHex: QEe,
                formatHex8: Bkt,
                formatRgb: eke,
                toString: eke
            }));
            Xy(Zg, LE, G_(Vm, {
                brighter (e) {
                    return e = e == null ? k2 : Math.pow(k2, e), new Zg(this.h, this.s, this.l * e, this.opacity);
                },
                darker (e) {
                    return e = e == null ? j_ : Math.pow(j_, e), new Zg(this.h, this.s, this.l * e, this.opacity);
                },
                rgb () {
                    var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < .5 ? r : 1 - r) * t, i = 2 * r - n;
                    return new hd(oW(e >= 240 ? e - 240 : e + 120, i, n), oW(e, i, n), oW(e < 120 ? e + 240 : e - 120, i, n), this.opacity);
                },
                clamp () {
                    return new Zg(rke(this.h), mD(this.s), mD(this.l), yD(this.opacity));
                },
                displayable () {
                    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
                },
                formatHsl () {
                    let e = yD(this.opacity);
                    return `${e === 1 ? "hsl(" : "hsla("}${rke(this.h)}, ${mD(this.s) * 100}%, ${mD(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
                }
            }));
        });
        var xD, bD, sW = Ll(()=>{
            xD = Math.PI / 180, bD = 180 / Math.PI;
        });
        function uke(e) {
            if (e instanceof Hm) return new Hm(e.l, e.a, e.b, e.opacity);
            if (e instanceof Yy) return cke(e);
            e instanceof hd || (e = CE(e));
            var t = fW(e.r), r = fW(e.g), n = fW(e.b), i = lW((.2225045 * t + .7168786 * r + .0606169 * n) / ake), a, o;
            return t === r && r === n ? a = o = i : (a = lW((.4360747 * t + .3850649 * r + .1430804 * n) / nke), o = lW((.0139322 * t + .0971045 * r + .7141733 * n) / oke)), new Hm(116 * i - 16, 500 * (a - i), 200 * (i - o), e.opacity);
        }
        function S5(e, t, r, n) {
            return arguments.length === 1 ? uke(e) : new Hm(e, t, r, n == null ? 1 : n);
        }
        function Hm(e, t, r, n) {
            this.l = +e, this.a = +t, this.b = +r, this.opacity = +n;
        }
        function lW(e) {
            return e > Nkt ? Math.pow(e, 1 / 3) : e / lke + ske;
        }
        function uW(e) {
            return e > A5 ? e * e * e : lke * (e - ske);
        }
        function cW(e) {
            return 255 * (e <= .0031308 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055);
        }
        function fW(e) {
            return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
        }
        function Ukt(e) {
            if (e instanceof Yy) return new Yy(e.h, e.c, e.l, e.opacity);
            if (e instanceof Hm || (e = uke(e)), e.a === 0 && e.b === 0) return new Yy(NaN, 0 < e.l && e.l < 100 ? 0 : NaN, e.l, e.opacity);
            var t = Math.atan2(e.b, e.a) * bD;
            return new Yy(t < 0 ? t + 360 : t, Math.sqrt(e.a * e.a + e.b * e.b), e.l, e.opacity);
        }
        function PE(e, t, r, n) {
            return arguments.length === 1 ? Ukt(e) : new Yy(e, t, r, n == null ? 1 : n);
        }
        function Yy(e, t, r, n) {
            this.h = +e, this.c = +t, this.l = +r, this.opacity = +n;
        }
        function cke(e) {
            if (isNaN(e.h)) return new Hm(e.l, 0, 0, e.opacity);
            var t = e.h * xD;
            return new Hm(e.l, Math.cos(t) * e.c, Math.sin(t) * e.c, e.opacity);
        }
        var wD, nke, ake, oke, ske, A5, lke, Nkt, fke = Ll(()=>{
            pD();
            _D();
            sW();
            wD = 18, nke = .96422, ake = 1, oke = .82521, ske = 4 / 29, A5 = 6 / 29, lke = 3 * A5 * A5, Nkt = A5 * A5 * A5;
            Xy(Hm, S5, G_(Vm, {
                brighter (e) {
                    return new Hm(this.l + wD * (e == null ? 1 : e), this.a, this.b, this.opacity);
                },
                darker (e) {
                    return new Hm(this.l - wD * (e == null ? 1 : e), this.a, this.b, this.opacity);
                },
                rgb () {
                    var e = (this.l + 16) / 116, t = isNaN(this.a) ? e : e + this.a / 500, r = isNaN(this.b) ? e : e - this.b / 200;
                    return t = nke * uW(t), e = ake * uW(e), r = oke * uW(r), new hd(cW(3.1338561 * t - 1.6168667 * e - .4906146 * r), cW(-0.9787684 * t + 1.9161415 * e + .033454 * r), cW(.0719453 * t - .2289914 * e + 1.4052427 * r), this.opacity);
                }
            }));
            Xy(Yy, PE, G_(Vm, {
                brighter (e) {
                    return new Yy(this.h, this.c, this.l + wD * (e == null ? 1 : e), this.opacity);
                },
                darker (e) {
                    return new Yy(this.h, this.c, this.l - wD * (e == null ? 1 : e), this.opacity);
                },
                rgb () {
                    return cke(this).rgb();
                }
            }));
        });
        function Vkt(e) {
            if (e instanceof C2) return new C2(e.h, e.s, e.l, e.opacity);
            e instanceof hd || (e = CE(e));
            var t = e.r / 255, r = e.g / 255, n = e.b / 255, i = (vke * n + hke * t - dke * r) / (vke + hke - dke), a = n - i, o = (IE * (r - i) - dW * a) / TD, s = Math.sqrt(o * o + a * a) / (IE * i * (1 - i)), l = s ? Math.atan2(o, a) * bD - 120 : NaN;
            return new C2(l < 0 ? l + 360 : l, s, i, e.opacity);
        }
        function M5(e, t, r, n) {
            return arguments.length === 1 ? Vkt(e) : new C2(e, t, r, n == null ? 1 : n);
        }
        function C2(e, t, r, n) {
            this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
        }
        var pke, hW, dW, TD, IE, hke, dke, vke, gke = Ll(()=>{
            pD();
            _D();
            sW();
            pke = -0.14861, hW = 1.78277, dW = -0.29227, TD = -0.90649, IE = 1.97294, hke = IE * TD, dke = IE * hW, vke = hW * dW - TD * pke;
            Xy(C2, M5, G_(Vm, {
                brighter (e) {
                    return e = e == null ? k2 : Math.pow(k2, e), new C2(this.h, this.s, this.l * e, this.opacity);
                },
                darker (e) {
                    return e = e == null ? j_ : Math.pow(j_, e), new C2(this.h, this.s, this.l * e, this.opacity);
                },
                rgb () {
                    var e = isNaN(this.h) ? 0 : (this.h + 120) * xD, t = +this.l, r = isNaN(this.s) ? 0 : this.s * t * (1 - t), n = Math.cos(e), i = Math.sin(e);
                    return new hd(255 * (t + r * (pke * n + hW * i)), 255 * (t + r * (dW * n + TD * i)), 255 * (t + r * (IE * n)), this.opacity);
                }
            }));
        });
        var L2 = Ll(()=>{
            _D();
            fke();
            gke();
        });
        function vW(e, t, r, n, i) {
            var a = e * e, o = a * e;
            return ((1 - 3 * e + 3 * a - o) * t + (4 - 6 * a + 3 * o) * r + (1 + 3 * e + 3 * a - 3 * o) * n + o * i) / 6;
        }
        function AD(e) {
            var t = e.length - 1;
            return function(r) {
                var n = r <= 0 ? r = 0 : r >= 1 ? (r = 1, t - 1) : Math.floor(r * t), i = e[n], a = e[n + 1], o = n > 0 ? e[n - 1] : 2 * i - a, s = n < t - 1 ? e[n + 2] : 2 * a - i;
                return vW((r - n / t) * t, o, i, a, s);
            };
        }
        var SD = Ll(()=>{});
        function MD(e) {
            var t = e.length;
            return function(r) {
                var n = Math.floor(((r %= 1) < 0 ? ++r : r) * t), i = e[(n + t - 1) % t], a = e[n % t], o = e[(n + 1) % t], s = e[(n + 2) % t];
                return vW((r - n / t) * t, i, a, o, s);
            };
        }
        var pW = Ll(()=>{
            SD();
        });
        var E5, gW = Ll(()=>{
            E5 = (e)=>()=>e;
        });
        function mke(e, t) {
            return function(r) {
                return e + r * t;
            };
        }
        function Hkt(e, t, r) {
            return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
                return Math.pow(e + n * t, r);
            };
        }
        function Z_(e, t) {
            var r = t - e;
            return r ? mke(e, r > 180 || r < -180 ? r - 360 * Math.round(r / 360) : r) : E5(isNaN(e) ? t : e);
        }
        function yke(e) {
            return (e = +e) == 1 ? qf : function(t, r) {
                return r - t ? Hkt(t, r, e) : E5(isNaN(t) ? r : t);
            };
        }
        function qf(e, t) {
            var r = t - e;
            return r ? mke(e, r) : E5(isNaN(e) ? t : e);
        }
        var P2 = Ll(()=>{
            gW();
        });
        function _ke(e) {
            return function(t) {
                var r = t.length, n = new Array(r), i = new Array(r), a = new Array(r), o, s;
                for(o = 0; o < r; ++o)s = T5(t[o]), n[o] = s.r || 0, i[o] = s.g || 0, a[o] = s.b || 0;
                return n = e(n), i = e(i), a = e(a), s.opacity = 1, function(l) {
                    return s.r = n(l), s.g = i(l), s.b = a(l), s + "";
                };
            };
        }
        var RE, xke, bke, mW = Ll(()=>{
            L2();
            SD();
            pW();
            P2();
            RE = function e(t) {
                var r = yke(t);
                function n(i, a) {
                    var o = r((i = T5(i)).r, (a = T5(a)).r), s = r(i.g, a.g), l = r(i.b, a.b), u = qf(i.opacity, a.opacity);
                    return function(c) {
                        return i.r = o(c), i.g = s(c), i.b = l(c), i.opacity = u(c), i + "";
                    };
                }
                return n.gamma = e, n;
            }(1);
            xke = _ke(AD), bke = _ke(MD);
        });
        function k5(e, t) {
            t || (t = []);
            var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), i;
            return function(a) {
                for(i = 0; i < r; ++i)n[i] = e[i] * (1 - a) + t[i] * a;
                return n;
            };
        }
        function ED(e) {
            return ArrayBuffer.isView(e) && !(e instanceof DataView);
        }
        var kD = Ll(()=>{});
        function wke(e, t) {
            return (ED(t) ? k5 : yW)(e, t);
        }
        function yW(e, t) {
            var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, i = new Array(n), a = new Array(r), o;
            for(o = 0; o < n; ++o)i[o] = X_(e[o], t[o]);
            for(; o < r; ++o)a[o] = t[o];
            return function(s) {
                for(o = 0; o < n; ++o)a[o] = i[o](s);
                return a;
            };
        }
        var _W = Ll(()=>{
            DE();
            kD();
        });
        function CD(e, t) {
            var r = new Date;
            return e = +e, t = +t, function(n) {
                return r.setTime(e * (1 - n) + t * n), r;
            };
        }
        var xW = Ll(()=>{});
        function Fp(e, t) {
            return e = +e, t = +t, function(r) {
                return e * (1 - r) + t * r;
            };
        }
        var zE = Ll(()=>{});
        function LD(e, t) {
            var r = {}, n = {}, i;
            (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
            for(i in t)i in e ? r[i] = X_(e[i], t[i]) : n[i] = t[i];
            return function(a) {
                for(i in r)n[i] = r[i](a);
                return n;
            };
        }
        var bW = Ll(()=>{
            DE();
        });
        function Gkt(e) {
            return function() {
                return e;
            };
        }
        function jkt(e) {
            return function(t) {
                return e(t) + "";
            };
        }
        function PD(e, t) {
            var r = TW.lastIndex = wW.lastIndex = 0, n, i, a, o = -1, s = [], l = [];
            for(e = e + "", t = t + ""; (n = TW.exec(e)) && (i = wW.exec(t));)(a = i.index) > r && (a = t.slice(r, a), s[o] ? s[o] += a : s[++o] = a), (n = n[0]) === (i = i[0]) ? s[o] ? s[o] += i : s[++o] = i : (s[++o] = null, l.push({
                i: o,
                x: Fp(n, i)
            })), r = wW.lastIndex;
            return r < t.length && (a = t.slice(r), s[o] ? s[o] += a : s[++o] = a), s.length < 2 ? l[0] ? jkt(l[0].x) : Gkt(t) : (t = l.length, function(u) {
                for(var c = 0, f; c < t; ++c)s[(f = l[c]).i] = f.x(u);
                return s.join("");
            });
        }
        var TW, wW, AW = Ll(()=>{
            zE();
            TW = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, wW = new RegExp(TW.source, "g");
        });
        function X_(e, t) {
            var r = typeof t, n;
            return t == null || r === "boolean" ? E5(t) : (r === "number" ? Fp : r === "string" ? (n = W_(t)) ? (t = n, RE) : PD : t instanceof W_ ? RE : t instanceof Date ? CD : ED(t) ? k5 : Array.isArray(t) ? yW : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? LD : Fp)(e, t);
        }
        var DE = Ll(()=>{
            L2();
            mW();
            _W();
            xW();
            zE();
            bW();
            AW();
            gW();
            kD();
        });
        function Tke(e) {
            var t = e.length;
            return function(r) {
                return e[Math.max(0, Math.min(t - 1, Math.floor(r * t)))];
            };
        }
        var Ake = Ll(()=>{});
        function Ske(e, t) {
            var r = Z_(+e, +t);
            return function(n) {
                var i = r(n);
                return i - 360 * Math.floor(i / 360);
            };
        }
        var Mke = Ll(()=>{
            P2();
        });
        function Eke(e, t) {
            return e = +e, t = +t, function(r) {
                return Math.round(e * (1 - r) + t * r);
            };
        }
        var kke = Ll(()=>{});
        function SW(e, t, r, n, i, a) {
            var o, s, l;
            return (o = Math.sqrt(e * e + t * t)) && (e /= o, t /= o), (l = e * r + t * n) && (r -= e * l, n -= t * l), (s = Math.sqrt(r * r + n * n)) && (r /= s, n /= s, l /= s), e * n < t * r && (e = -e, t = -t, l = -l, o = -o), {
                translateX: i,
                translateY: a,
                rotate: Math.atan2(t, e) * Cke,
                skewX: Math.atan(l) * Cke,
                scaleX: o,
                scaleY: s
            };
        }
        var Cke, ID, Lke = Ll(()=>{
            Cke = 180 / Math.PI, ID = {
                translateX: 0,
                translateY: 0,
                rotate: 0,
                skewX: 0,
                scaleX: 1,
                scaleY: 1
            };
        });
        function Pke(e) {
            let t = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(e + "");
            return t.isIdentity ? ID : SW(t.a, t.b, t.c, t.d, t.e, t.f);
        }
        function Ike(e) {
            return e == null ? ID : (RD || (RD = document.createElementNS("http://www.w3.org/2000/svg", "g")), RD.setAttribute("transform", e), (e = RD.transform.baseVal.consolidate()) ? (e = e.matrix, SW(e.a, e.b, e.c, e.d, e.e, e.f)) : ID);
        }
        var RD, Rke = Ll(()=>{
            Lke();
        });
        function Dke(e, t, r, n) {
            function i(u) {
                return u.length ? u.pop() + " " : "";
            }
            function a(u, c, f, h, d, v) {
                if (u !== f || c !== h) {
                    var x = d.push("translate(", null, t, null, r);
                    v.push({
                        i: x - 4,
                        x: Fp(u, f)
                    }, {
                        i: x - 2,
                        x: Fp(c, h)
                    });
                } else (f || h) && d.push("translate(" + f + t + h + r);
            }
            function o(u, c, f, h) {
                u !== c ? (u - c > 180 ? c += 360 : c - u > 180 && (u += 360), h.push({
                    i: f.push(i(f) + "rotate(", null, n) - 2,
                    x: Fp(u, c)
                })) : c && f.push(i(f) + "rotate(" + c + n);
            }
            function s(u, c, f, h) {
                u !== c ? h.push({
                    i: f.push(i(f) + "skewX(", null, n) - 2,
                    x: Fp(u, c)
                }) : c && f.push(i(f) + "skewX(" + c + n);
            }
            function l(u, c, f, h, d, v) {
                if (u !== f || c !== h) {
                    var x = d.push(i(d) + "scale(", null, ",", null, ")");
                    v.push({
                        i: x - 4,
                        x: Fp(u, f)
                    }, {
                        i: x - 2,
                        x: Fp(c, h)
                    });
                } else (f !== 1 || h !== 1) && d.push(i(d) + "scale(" + f + "," + h + ")");
            }
            return function(u, c) {
                var f = [], h = [];
                return u = e(u), c = e(c), a(u.translateX, u.translateY, c.translateX, c.translateY, f, h), o(u.rotate, c.rotate, f, h), s(u.skewX, c.skewX, f, h), l(u.scaleX, u.scaleY, c.scaleX, c.scaleY, f, h), u = c = null, function(d) {
                    for(var v = -1, x = h.length, b; ++v < x;)f[(b = h[v]).i] = b.x(d);
                    return f.join("");
                };
            };
        }
        var zke, Fke, qke = Ll(()=>{
            zE();
            Rke();
            zke = Dke(Pke, "px, ", "px)", "deg)"), Fke = Dke(Ike, ", ", ")", ")");
        });
        function Oke(e) {
            return ((e = Math.exp(e)) + 1 / e) / 2;
        }
        function Zkt(e) {
            return ((e = Math.exp(e)) - 1 / e) / 2;
        }
        function Xkt(e) {
            return ((e = Math.exp(2 * e)) - 1) / (e + 1);
        }
        var Wkt, Bke, Nke = Ll(()=>{
            Wkt = 1e-12;
            Bke = function e(t, r, n) {
                function i(a, o) {
                    var s = a[0], l = a[1], u = a[2], c = o[0], f = o[1], h = o[2], d = c - s, v = f - l, x = d * d + v * v, b, p;
                    if (x < Wkt) p = Math.log(h / u) / t, b = function(C) {
                        return [
                            s + C * d,
                            l + C * v,
                            u * Math.exp(t * C * p)
                        ];
                    };
                    else {
                        var E = Math.sqrt(x), k = (h * h - u * u + n * x) / (2 * u * r * E), A = (h * h - u * u - n * x) / (2 * h * r * E), L = Math.log(Math.sqrt(k * k + 1) - k), _ = Math.log(Math.sqrt(A * A + 1) - A);
                        p = (_ - L) / t, b = function(C) {
                            var M = C * p, g = Oke(L), P = u / (r * E) * (g * Xkt(t * M + L) - Zkt(L));
                            return [
                                s + P * d,
                                l + P * v,
                                u * g / Oke(t * M + L)
                            ];
                        };
                    }
                    return b.duration = p * 1e3 * t / Math.SQRT2, b;
                }
                return i.rho = function(a) {
                    var o = Math.max(.001, +a), s = o * o, l = s * s;
                    return e(o, s, l);
                }, i;
            }(Math.SQRT2, 2, 4);
        });
        function Uke(e) {
            return function(t, r) {
                var n = e((t = LE(t)).h, (r = LE(r)).h), i = qf(t.s, r.s), a = qf(t.l, r.l), o = qf(t.opacity, r.opacity);
                return function(s) {
                    return t.h = n(s), t.s = i(s), t.l = a(s), t.opacity = o(s), t + "";
                };
            };
        }
        var Vke, Hke, Gke = Ll(()=>{
            L2();
            P2();
            Vke = Uke(Z_), Hke = Uke(qf);
        });
        function MW(e, t) {
            var r = qf((e = S5(e)).l, (t = S5(t)).l), n = qf(e.a, t.a), i = qf(e.b, t.b), a = qf(e.opacity, t.opacity);
            return function(o) {
                return e.l = r(o), e.a = n(o), e.b = i(o), e.opacity = a(o), e + "";
            };
        }
        var jke = Ll(()=>{
            L2();
            P2();
        });
        function Wke(e) {
            return function(t, r) {
                var n = e((t = PE(t)).h, (r = PE(r)).h), i = qf(t.c, r.c), a = qf(t.l, r.l), o = qf(t.opacity, r.opacity);
                return function(s) {
                    return t.h = n(s), t.c = i(s), t.l = a(s), t.opacity = o(s), t + "";
                };
            };
        }
        var Zke, Xke, Yke = Ll(()=>{
            L2();
            P2();
            Zke = Wke(Z_), Xke = Wke(qf);
        });
        function Kke(e) {
            return function t(r) {
                r = +r;
                function n(i, a) {
                    var o = e((i = M5(i)).h, (a = M5(a)).h), s = qf(i.s, a.s), l = qf(i.l, a.l), u = qf(i.opacity, a.opacity);
                    return function(c) {
                        return i.h = o(c), i.s = s(c), i.l = l(Math.pow(c, r)), i.opacity = u(c), i + "";
                    };
                }
                return n.gamma = t, n;
            }(1);
        }
        var Jke, $ke, Qke = Ll(()=>{
            L2();
            P2();
            Jke = Kke(Z_), $ke = Kke(qf);
        });
        function EW(e, t) {
            t === void 0 && (t = e, e = X_);
            for(var r = 0, n = t.length - 1, i = t[0], a = new Array(n < 0 ? 0 : n); r < n;)a[r] = e(i, i = t[++r]);
            return function(o) {
                var s = Math.max(0, Math.min(n - 1, Math.floor(o *= n)));
                return a[s](o - s);
            };
        }
        var eCe = Ll(()=>{
            DE();
        });
        function tCe(e, t) {
            for(var r = new Array(t), n = 0; n < t; ++n)r[n] = e(n / (t - 1));
            return r;
        }
        var rCe = Ll(()=>{});
        var I2 = {};
        QQ(I2, {
            interpolate: ()=>X_,
            interpolateArray: ()=>wke,
            interpolateBasis: ()=>AD,
            interpolateBasisClosed: ()=>MD,
            interpolateCubehelix: ()=>Jke,
            interpolateCubehelixLong: ()=>$ke,
            interpolateDate: ()=>CD,
            interpolateDiscrete: ()=>Tke,
            interpolateHcl: ()=>Zke,
            interpolateHclLong: ()=>Xke,
            interpolateHsl: ()=>Vke,
            interpolateHslLong: ()=>Hke,
            interpolateHue: ()=>Ske,
            interpolateLab: ()=>MW,
            interpolateNumber: ()=>Fp,
            interpolateNumberArray: ()=>k5,
            interpolateObject: ()=>LD,
            interpolateRgb: ()=>RE,
            interpolateRgbBasis: ()=>xke,
            interpolateRgbBasisClosed: ()=>bke,
            interpolateRound: ()=>Eke,
            interpolateString: ()=>PD,
            interpolateTransformCss: ()=>zke,
            interpolateTransformSvg: ()=>Fke,
            interpolateZoom: ()=>Bke,
            piecewise: ()=>EW,
            quantize: ()=>tCe
        });
        var R2 = Ll(()=>{
            DE();
            _W();
            SD();
            pW();
            xW();
            Ake();
            Mke();
            zE();
            kD();
            bW();
            kke();
            AW();
            qke();
            Nke();
            mW();
            Gke();
            jke();
            Yke();
            Qke();
            eCe();
            rCe();
        });
        var DD = ye((cdr, iCe)=>{
            "use strict";
            var Ykt = ao(), Kkt = va();
            iCe.exports = function(t, r, n, i, a) {
                var o = r.data.data, s = o.i, l = a || o.color;
                if (s >= 0) {
                    r.i = o.i;
                    var u = n.marker;
                    u.pattern ? (!u.colors || !u.pattern.shape) && (u.color = l, r.color = l) : (u.color = l, r.color = l), Ykt.pointStyle(t, n, i, r);
                } else Kkt.fill(t, l);
            };
        });
        var kW = ye((fdr, lCe)=>{
            "use strict";
            var nCe = xa(), aCe = va(), oCe = Mr(), Jkt = _v().resizeText, $kt = DD();
            function Qkt(e) {
                var t = e._fullLayout._sunburstlayer.selectAll(".trace");
                Jkt(e, t, "sunburst"), t.each(function(r) {
                    var n = nCe.select(this), i = r[0], a = i.trace;
                    n.style("opacity", a.opacity), n.selectAll("path.surface").each(function(o) {
                        nCe.select(this).call(sCe, o, a, e);
                    });
                });
            }
            function sCe(e, t, r, n) {
                var i = t.data.data, a = !t.children, o = i.i, s = oCe.castOption(r, o, "marker.line.color") || aCe.defaultLine, l = oCe.castOption(r, o, "marker.line.width") || 0;
                e.call($kt, t, r, n).style("stroke-width", l).call(aCe.stroke, s).style("opacity", a ? r.leaf.opacity : null);
            }
            lCe.exports = {
                style: Qkt,
                styleOne: sCe
            };
        });
        var Ky = ye((bs)=>{
            "use strict";
            var D2 = Mr(), eCt = va(), tCt = Tg(), uCe = u_();
            bs.findEntryWithLevel = function(e, t) {
                var r;
                return t && e.eachAfter(function(n) {
                    if (bs.getPtId(n) === t) return r = n.copy();
                }), r || e;
            };
            bs.findEntryWithChild = function(e, t) {
                var r;
                return e.eachAfter(function(n) {
                    for(var i = n.children || [], a = 0; a < i.length; a++){
                        var o = i[a];
                        if (bs.getPtId(o) === t) return r = n.copy();
                    }
                }), r || e;
            };
            bs.isEntry = function(e) {
                return !e.parent;
            };
            bs.isLeaf = function(e) {
                return !e.children;
            };
            bs.getPtId = function(e) {
                return e.data.data.id;
            };
            bs.getPtLabel = function(e) {
                return e.data.data.label;
            };
            bs.getValue = function(e) {
                return e.value;
            };
            bs.isHierarchyRoot = function(e) {
                return cCe(e) === "";
            };
            bs.setSliceCursor = function(e, t, r) {
                var n = r.isTransitioning;
                if (!n) {
                    var i = e.datum();
                    n = r.hideOnRoot && bs.isHierarchyRoot(i) || r.hideOnLeaves && bs.isLeaf(i);
                }
                tCt(e, n ? null : "pointer");
            };
            function rCt(e, t, r) {
                return {
                    color: bs.getOutsideTextFontKey("color", e, t, r),
                    family: bs.getOutsideTextFontKey("family", e, t, r),
                    size: bs.getOutsideTextFontKey("size", e, t, r),
                    weight: bs.getOutsideTextFontKey("weight", e, t, r),
                    style: bs.getOutsideTextFontKey("style", e, t, r),
                    variant: bs.getOutsideTextFontKey("variant", e, t, r),
                    textcase: bs.getOutsideTextFontKey("textcase", e, t, r),
                    lineposition: bs.getOutsideTextFontKey("lineposition", e, t, r),
                    shadow: bs.getOutsideTextFontKey("shadow", e, t, r)
                };
            }
            function iCt(e, t, r, n) {
                var i = (n || {}).onPathbar, a = t.data.data, o = a.i, s = D2.castOption(e, o, (i ? "pathbar.textfont" : "insidetextfont") + ".color");
                return !s && e._input.textfont && (s = D2.castOption(e._input, o, "textfont.color")), {
                    color: s || eCt.contrast(a.color),
                    family: bs.getInsideTextFontKey("family", e, t, r, n),
                    size: bs.getInsideTextFontKey("size", e, t, r, n),
                    weight: bs.getInsideTextFontKey("weight", e, t, r, n),
                    style: bs.getInsideTextFontKey("style", e, t, r, n),
                    variant: bs.getInsideTextFontKey("variant", e, t, r, n),
                    textcase: bs.getInsideTextFontKey("textcase", e, t, r, n),
                    lineposition: bs.getInsideTextFontKey("lineposition", e, t, r, n),
                    shadow: bs.getInsideTextFontKey("shadow", e, t, r, n)
                };
            }
            bs.getInsideTextFontKey = function(e, t, r, n, i) {
                var a = (i || {}).onPathbar, o = a ? "pathbar.textfont" : "insidetextfont", s = r.data.data.i;
                return D2.castOption(t, s, o + "." + e) || D2.castOption(t, s, "textfont." + e) || n.size;
            };
            bs.getOutsideTextFontKey = function(e, t, r, n) {
                var i = r.data.data.i;
                return D2.castOption(t, i, "outsidetextfont." + e) || D2.castOption(t, i, "textfont." + e) || n.size;
            };
            bs.isOutsideText = function(e, t) {
                return !e._hasColorscale && bs.isHierarchyRoot(t);
            };
            bs.determineTextFont = function(e, t, r, n) {
                return bs.isOutsideText(e, t) ? rCt(e, t, r) : iCt(e, t, r, n);
            };
            bs.hasTransition = function(e) {
                return !!(e && e.duration > 0);
            };
            bs.getMaxDepth = function(e) {
                return e.maxdepth >= 0 ? e.maxdepth : 1 / 0;
            };
            bs.isHeader = function(e, t) {
                return !(bs.isLeaf(e) || e.depth === t._maxDepth - 1);
            };
            function cCe(e) {
                return e.data.data.pid;
            }
            bs.getParent = function(e, t) {
                return bs.findEntryWithLevel(e, cCe(t));
            };
            bs.listPath = function(e, t) {
                var r = e.parent;
                if (!r) return [];
                var n = t ? [
                    r.data[t]
                ] : [
                    r
                ];
                return bs.listPath(r, t).concat(n);
            };
            bs.getPath = function(e) {
                return bs.listPath(e, "label").join("/") + "/";
            };
            bs.formatValue = uCe.formatPieValue;
            bs.formatPercent = function(e, t) {
                var r = D2.formatPercent(e, 0);
                return r === "0%" && (r = uCe.formatPiePercent(e, t)), r;
            };
        });
        var OE = ye((ddr, dCe)=>{
            "use strict";
            var C5 = xa(), fCe = ba(), nCt = rp().appendArrayPointValue, FE = Nc(), hCe = Mr(), aCt = g3(), Wh = Ky(), oCt = u_(), sCt = oCt.formatPieValue;
            dCe.exports = function(t, r, n, i, a) {
                var o = i[0], s = o.trace, l = o.hierarchy, u = s.type === "sunburst", c = s.type === "treemap" || s.type === "icicle";
                "_hasHoverLabel" in s || (s._hasHoverLabel = !1), "_hasHoverEvent" in s || (s._hasHoverEvent = !1);
                var f = function(v) {
                    var x = n._fullLayout;
                    if (!(n._dragging || x.hovermode === !1)) {
                        var b = n._fullData[s.index], p = v.data.data, E = p.i, k = Wh.isHierarchyRoot(v), A = Wh.getParent(l, v), L = Wh.getValue(v), _ = function(Me) {
                            return hCe.castOption(b, E, Me);
                        }, C = _("hovertemplate"), M = FE.castHoverinfo(b, x, E), g = x.separators, P;
                        if (C || M && M !== "none" && M !== "skip") {
                            var T, F;
                            u && (T = o.cx + v.pxmid[0] * (1 - v.rInscribed), F = o.cy + v.pxmid[1] * (1 - v.rInscribed)), c && (T = v._hoverX, F = v._hoverY);
                            var q = {}, V = [], H = [], X = function(Me) {
                                return V.indexOf(Me) !== -1;
                            };
                            M && (V = M === "all" ? b._module.attributes.hoverinfo.flags : M.split("+")), q.label = p.label, X("label") && q.label && H.push(q.label), p.hasOwnProperty("v") && (q.value = p.v, q.valueLabel = sCt(q.value, g), X("value") && H.push(q.valueLabel)), q.currentPath = v.currentPath = Wh.getPath(v.data), X("current path") && !k && H.push(q.currentPath);
                            var G, N = [], W = function() {
                                N.indexOf(G) === -1 && (H.push(G), N.push(G));
                            };
                            q.percentParent = v.percentParent = L / Wh.getValue(A), q.parent = v.parentString = Wh.getPtLabel(A), X("percent parent") && (G = Wh.formatPercent(q.percentParent, g) + " of " + q.parent, W()), q.percentEntry = v.percentEntry = L / Wh.getValue(r), q.entry = v.entry = Wh.getPtLabel(r), X("percent entry") && !k && !v.onPathbar && (G = Wh.formatPercent(q.percentEntry, g) + " of " + q.entry, W()), q.percentRoot = v.percentRoot = L / Wh.getValue(l), q.root = v.root = Wh.getPtLabel(l), X("percent root") && !k && (G = Wh.formatPercent(q.percentRoot, g) + " of " + q.root, W()), q.text = _("hovertext") || _("text"), X("text") && (G = q.text, hCe.isValidTextValue(G) && H.push(G)), P = [
                                qE(v, b, a.eventDataKeys)
                            ];
                            var re = {
                                trace: b,
                                y: F,
                                _x0: v._x0,
                                _x1: v._x1,
                                _y0: v._y0,
                                _y1: v._y1,
                                text: H.join("<br>"),
                                name: C || X("name") ? b.name : void 0,
                                color: _("hoverlabel.bgcolor") || p.color,
                                borderColor: _("hoverlabel.bordercolor"),
                                fontFamily: _("hoverlabel.font.family"),
                                fontSize: _("hoverlabel.font.size"),
                                fontColor: _("hoverlabel.font.color"),
                                fontWeight: _("hoverlabel.font.weight"),
                                fontStyle: _("hoverlabel.font.style"),
                                fontVariant: _("hoverlabel.font.variant"),
                                nameLength: _("hoverlabel.namelength"),
                                textAlign: _("hoverlabel.align"),
                                hovertemplate: C,
                                hovertemplateLabels: q,
                                eventData: P
                            };
                            u && (re.x0 = T - v.rInscribed * v.rpx1, re.x1 = T + v.rInscribed * v.rpx1, re.idealAlign = v.pxmid[0] < 0 ? "left" : "right"), c && (re.x = T, re.idealAlign = T < 0 ? "left" : "right");
                            var ae = [];
                            FE.loneHover(re, {
                                container: x._hoverlayer.node(),
                                outerContainer: x._paper.node(),
                                gd: n,
                                inOut_bbox: ae
                            }), P[0].bbox = ae[0], s._hasHoverLabel = !0;
                        }
                        if (c) {
                            var _e = t.select("path.surface");
                            a.styleOne(_e, v, b, n, {
                                hovered: !0
                            });
                        }
                        s._hasHoverEvent = !0, n.emit("plotly_hover", {
                            points: P || [
                                qE(v, b, a.eventDataKeys)
                            ],
                            event: C5.event
                        });
                    }
                }, h = function(v) {
                    var x = n._fullLayout, b = n._fullData[s.index], p = C5.select(this).datum();
                    if (s._hasHoverEvent && (v.originalEvent = C5.event, n.emit("plotly_unhover", {
                        points: [
                            qE(p, b, a.eventDataKeys)
                        ],
                        event: C5.event
                    }), s._hasHoverEvent = !1), s._hasHoverLabel && (FE.loneUnhover(x._hoverlayer.node()), s._hasHoverLabel = !1), c) {
                        var E = t.select("path.surface");
                        a.styleOne(E, p, b, n, {
                            hovered: !1
                        });
                    }
                }, d = function(v) {
                    var x = n._fullLayout, b = n._fullData[s.index], p = u && (Wh.isHierarchyRoot(v) || Wh.isLeaf(v)), E = Wh.getPtId(v), k = Wh.isEntry(v) ? Wh.findEntryWithChild(l, E) : Wh.findEntryWithLevel(l, E), A = Wh.getPtId(k), L = {
                        points: [
                            qE(v, b, a.eventDataKeys)
                        ],
                        event: C5.event
                    };
                    p || (L.nextLevel = A);
                    var _ = aCt.triggerHandler(n, "plotly_" + s.type + "click", L);
                    if (_ !== !1 && x.hovermode && (n._hoverdata = [
                        qE(v, b, a.eventDataKeys)
                    ], FE.click(n, C5.event)), !p && _ !== !1 && !n._dragging && !n._transitioning) {
                        fCe.call("_storeDirectGUIEdit", b, x._tracePreGUI[b.uid], {
                            level: b.level
                        });
                        var C = {
                            data: [
                                {
                                    level: A
                                }
                            ],
                            traces: [
                                s.index
                            ]
                        }, M = {
                            frame: {
                                redraw: !1,
                                duration: a.transitionTime
                            },
                            transition: {
                                duration: a.transitionTime,
                                easing: a.transitionEasing
                            },
                            mode: "immediate",
                            fromcurrent: !0
                        };
                        FE.loneUnhover(x._hoverlayer.node()), fCe.call("animate", n, C, M);
                    }
                };
                t.on("mouseover", f), t.on("mouseout", h), t.on("click", d);
            };
            function qE(e, t, r) {
                for(var n = e.data.data, i = {
                    curveNumber: t.index,
                    pointNumber: n.i,
                    data: t._input,
                    fullData: t
                }, a = 0; a < r.length; a++){
                    var o = r[a];
                    o in e && (i[o] = e[o]);
                }
                return "parentString" in e && !Wh.isHierarchyRoot(e) && (i.parent = e.parentString), nCt(i, t, n.i), i;
            }
        });
        var FD = ye((zD)=>{
            "use strict";
            var BE = xa(), lCt = SE(), Xg = (R2(), B1(I2)).interpolate, vCe = ao(), bv = Mr(), uCt = Pl(), yCe = _v(), pCe = yCe.recordMinTextSize, cCt = yCe.clearMinTextSize, _Ce = dD(), fCt = u_().getRotationAngle, hCt = _Ce.computeTransform, dCt = _Ce.transformInsideText, vCt = kW().styleOne, pCt = N0().resizeText, gCt = OE(), CW = nW(), sl = Ky();
            zD.plot = function(e, t, r, n) {
                var i = e._fullLayout, a = i._sunburstlayer, o, s, l = !r, u = !i.uniformtext.mode && sl.hasTransition(r);
                if (cCt("sunburst", i), o = a.selectAll("g.trace.sunburst").data(t, function(f) {
                    return f[0].trace.uid;
                }), o.enter().append("g").classed("trace", !0).classed("sunburst", !0).attr("stroke-linejoin", "round"), o.order(), u) {
                    n && (s = n());
                    var c = BE.transition().duration(r.duration).ease(r.easing).each("end", function() {
                        s && s();
                    }).each("interrupt", function() {
                        s && s();
                    });
                    c.each(function() {
                        a.selectAll("g.trace").each(function(f) {
                            gCe(e, f, this, r);
                        });
                    });
                } else o.each(function(f) {
                    gCe(e, f, this, r);
                }), i.uniformtext.mode && pCt(e, i._sunburstlayer.selectAll(".trace"), "sunburst");
                l && o.exit().remove();
            };
            function gCe(e, t, r, n) {
                var i = e._context.staticPlot, a = e._fullLayout, o = !a.uniformtext.mode && sl.hasTransition(n), s = BE.select(r), l = s.selectAll("g.slice"), u = t[0], c = u.trace, f = u.hierarchy, h = sl.findEntryWithLevel(f, c.level), d = sl.getMaxDepth(c), v = a._size, x = c.domain, b = v.w * (x.x[1] - x.x[0]), p = v.h * (x.y[1] - x.y[0]), E = .5 * Math.min(b, p), k = u.cx = v.l + v.w * (x.x[1] + x.x[0]) / 2, A = u.cy = v.t + v.h * (1 - x.y[0]) - p / 2;
                if (!h) return l.remove();
                var L = null, _ = {};
                o && l.each(function(ge) {
                    _[sl.getPtId(ge)] = {
                        rpx0: ge.rpx0,
                        rpx1: ge.rpx1,
                        x0: ge.x0,
                        x1: ge.x1,
                        transform: ge.transform
                    }, !L && sl.isEntry(ge) && (L = ge);
                });
                var C = mCt(h).descendants(), M = h.height + 1, g = 0, P = d;
                u.hasMultipleRoots && sl.isHierarchyRoot(h) && (C = C.slice(1), M -= 1, g = 1, P += 1), C = C.filter(function(ge) {
                    return ge.y1 <= P;
                });
                var T = fCt(c.rotation);
                T && C.forEach(function(ge) {
                    ge.x0 += T, ge.x1 += T;
                });
                var F = Math.min(M, d), q = function(ge) {
                    return (ge - g) / F * E;
                }, V = function(ge, ie) {
                    return [
                        ge * Math.cos(ie),
                        -ge * Math.sin(ie)
                    ];
                }, H = function(ge) {
                    return bv.pathAnnulus(ge.rpx0, ge.rpx1, ge.x0, ge.x1, k, A);
                }, X = function(ge) {
                    return k + mCe(ge)[0] * (ge.transform.rCenter || 0) + (ge.transform.x || 0);
                }, G = function(ge) {
                    return A + mCe(ge)[1] * (ge.transform.rCenter || 0) + (ge.transform.y || 0);
                };
                l = l.data(C, sl.getPtId), l.enter().append("g").classed("slice", !0), o ? l.exit().transition().each(function() {
                    var ge = BE.select(this), ie = ge.select("path.surface");
                    ie.transition().attrTween("d", function(Ee) {
                        var Ae = ae(Ee);
                        return function(ze) {
                            return H(Ae(ze));
                        };
                    });
                    var Te = ge.select("g.slicetext");
                    Te.attr("opacity", 0);
                }).remove() : l.exit().remove(), l.order();
                var N = null;
                if (o && L) {
                    var W = sl.getPtId(L);
                    l.each(function(ge) {
                        N === null && sl.getPtId(ge) === W && (N = ge.x1);
                    });
                }
                var re = l;
                o && (re = re.transition().each("end", function() {
                    var ge = BE.select(this);
                    sl.setSliceCursor(ge, e, {
                        hideOnRoot: !0,
                        hideOnLeaves: !0,
                        isTransitioning: !1
                    });
                })), re.each(function(ge) {
                    var ie = BE.select(this), Te = bv.ensureSingle(ie, "path", "surface", function(Re) {
                        Re.style("pointer-events", i ? "none" : "all");
                    });
                    ge.rpx0 = q(ge.y0), ge.rpx1 = q(ge.y1), ge.xmid = (ge.x0 + ge.x1) / 2, ge.pxmid = V(ge.rpx1, ge.xmid), ge.midangle = -(ge.xmid - Math.PI / 2), ge.startangle = -(ge.x0 - Math.PI / 2), ge.stopangle = -(ge.x1 - Math.PI / 2), ge.halfangle = .5 * Math.min(bv.angleDelta(ge.x0, ge.x1) || Math.PI, Math.PI), ge.ring = 1 - ge.rpx0 / ge.rpx1, ge.rInscribed = yCt(ge, c), o ? Te.transition().attrTween("d", function(Re) {
                        var ce = _e(Re);
                        return function(Ge) {
                            return H(ce(Ge));
                        };
                    }) : Te.attr("d", H), ie.call(gCt, h, e, t, {
                        eventDataKeys: CW.eventDataKeys,
                        transitionTime: CW.CLICK_TRANSITION_TIME,
                        transitionEasing: CW.CLICK_TRANSITION_EASING
                    }).call(sl.setSliceCursor, e, {
                        hideOnRoot: !0,
                        hideOnLeaves: !0,
                        isTransitioning: e._transitioning
                    }), Te.call(vCt, ge, c, e);
                    var Ee = bv.ensureSingle(ie, "g", "slicetext"), Ae = bv.ensureSingle(Ee, "text", "", function(Re) {
                        Re.attr("data-notex", 1);
                    }), ze = bv.ensureUniformFontSize(e, sl.determineTextFont(c, ge, a.font));
                    Ae.text(zD.formatSliceLabel(ge, h, c, t, a)).classed("slicetext", !0).attr("text-anchor", "middle").call(vCe.font, ze).call(uCt.convertToTspans, e);
                    var Ce = vCe.bBox(Ae.node());
                    ge.transform = dCt(Ce, ge, u), ge.transform.targetX = X(ge), ge.transform.targetY = G(ge);
                    var me = function(Re, ce) {
                        var Ge = Re.transform;
                        return hCt(Ge, ce), Ge.fontSize = ze.size, pCe(c.type, Ge, a), bv.getTextTransform(Ge);
                    };
                    o ? Ae.transition().attrTween("transform", function(Re) {
                        var ce = Me(Re);
                        return function(Ge) {
                            return me(ce(Ge), Ce);
                        };
                    }) : Ae.attr("transform", me(ge, Ce));
                });
                function ae(ge) {
                    var ie = sl.getPtId(ge), Te = _[ie], Ee = _[sl.getPtId(h)], Ae;
                    if (Ee) {
                        var ze = (ge.x1 > Ee.x1 ? 2 * Math.PI : 0) + T;
                        Ae = ge.rpx1 < Ee.rpx1 ? {
                            x0: ge.x0,
                            x1: ge.x1,
                            rpx0: 0,
                            rpx1: 0
                        } : {
                            x0: ze,
                            x1: ze,
                            rpx0: ge.rpx0,
                            rpx1: ge.rpx1
                        };
                    } else {
                        var Ce, me = sl.getPtId(ge.parent);
                        l.each(function(ct) {
                            if (sl.getPtId(ct) === me) return Ce = ct;
                        });
                        var Re = Ce.children, ce;
                        Re.forEach(function(ct, qt) {
                            if (sl.getPtId(ct) === ie) return ce = qt;
                        });
                        var Ge = Re.length, nt = Xg(Ce.x0, Ce.x1);
                        Ae = {
                            rpx0: E,
                            rpx1: E,
                            x0: nt(ce / Ge),
                            x1: nt((ce + 1) / Ge)
                        };
                    }
                    return Xg(Te, Ae);
                }
                function _e(ge) {
                    var ie = _[sl.getPtId(ge)], Te, Ee = {
                        x0: ge.x0,
                        x1: ge.x1,
                        rpx0: ge.rpx0,
                        rpx1: ge.rpx1
                    };
                    if (ie) Te = ie;
                    else if (L) {
                        if (ge.parent) {
                            if (N) {
                                var Ae = (ge.x1 > N ? 2 * Math.PI : 0) + T;
                                Te = {
                                    x0: Ae,
                                    x1: Ae
                                };
                            } else Te = {
                                rpx0: E,
                                rpx1: E
                            }, bv.extendFlat(Te, ke(ge));
                        } else Te = {
                            rpx0: 0,
                            rpx1: 0
                        };
                    } else Te = {
                        x0: T,
                        x1: T
                    };
                    return Xg(Te, Ee);
                }
                function Me(ge) {
                    var ie = _[sl.getPtId(ge)], Te, Ee = ge.transform;
                    if (ie) Te = ie;
                    else if (Te = {
                        rpx1: ge.rpx1,
                        transform: {
                            textPosAngle: Ee.textPosAngle,
                            scale: 0,
                            rotate: Ee.rotate,
                            rCenter: Ee.rCenter,
                            x: Ee.x,
                            y: Ee.y
                        }
                    }, L) {
                        if (ge.parent) {
                            if (N) {
                                var Ae = ge.x1 > N ? 2 * Math.PI : 0;
                                Te.x0 = Te.x1 = Ae;
                            } else bv.extendFlat(Te, ke(ge));
                        } else Te.x0 = Te.x1 = T;
                    } else Te.x0 = Te.x1 = T;
                    var ze = Xg(Te.transform.textPosAngle, ge.transform.textPosAngle), Ce = Xg(Te.rpx1, ge.rpx1), me = Xg(Te.x0, ge.x0), Re = Xg(Te.x1, ge.x1), ce = Xg(Te.transform.scale, Ee.scale), Ge = Xg(Te.transform.rotate, Ee.rotate), nt = Ee.rCenter === 0 ? 3 : Te.transform.rCenter === 0 ? 1 / 3 : 1, ct = Xg(Te.transform.rCenter, Ee.rCenter), qt = function(rt) {
                        return ct(Math.pow(rt, nt));
                    };
                    return function(rt) {
                        var ot = Ce(rt), Rt = me(rt), kt = Re(rt), Ct = qt(rt), Yt = V(ot, (Rt + kt) / 2), xr = ze(rt), er = {
                            pxmid: Yt,
                            rpx1: ot,
                            transform: {
                                textPosAngle: xr,
                                rCenter: Ct,
                                x: Ee.x,
                                y: Ee.y
                            }
                        };
                        return pCe(c.type, Ee, a), {
                            transform: {
                                targetX: X(er),
                                targetY: G(er),
                                scale: ce(rt),
                                rotate: Ge(rt),
                                rCenter: Ct
                            }
                        };
                    };
                }
                function ke(ge) {
                    var ie = ge.parent, Te = _[sl.getPtId(ie)], Ee = {};
                    if (Te) {
                        var Ae = ie.children, ze = Ae.indexOf(ge), Ce = Ae.length, me = Xg(Te.x0, Te.x1);
                        Ee.x0 = me(ze / Ce), Ee.x1 = me(ze / Ce);
                    } else Ee.x0 = Ee.x1 = 0;
                    return Ee;
                }
            }
            function mCt(e) {
                return lCt.partition().size([
                    2 * Math.PI,
                    e.height + 1
                ])(e);
            }
            zD.formatSliceLabel = function(e, t, r, n, i) {
                var a = r.texttemplate, o = r.textinfo;
                if (!a && (!o || o === "none")) return "";
                var s = i.separators, l = n[0], u = e.data.data, c = l.hierarchy, f = sl.isHierarchyRoot(e), h = sl.getParent(c, e), d = sl.getValue(e);
                if (!a) {
                    var v = o.split("+"), x = function(g) {
                        return v.indexOf(g) !== -1;
                    }, b = [], p;
                    if (x("label") && u.label && b.push(u.label), u.hasOwnProperty("v") && x("value") && b.push(sl.formatValue(u.v, s)), !f) {
                        x("current path") && b.push(sl.getPath(e.data));
                        var E = 0;
                        x("percent parent") && E++, x("percent entry") && E++, x("percent root") && E++;
                        var k = E > 1;
                        if (E) {
                            var A, L = function(g) {
                                p = sl.formatPercent(A, s), k && (p += " of " + g), b.push(p);
                            };
                            x("percent parent") && !f && (A = d / sl.getValue(h), L("parent")), x("percent entry") && (A = d / sl.getValue(t), L("entry")), x("percent root") && (A = d / sl.getValue(c), L("root"));
                        }
                    }
                    return x("text") && (p = bv.castOption(r, u.i, "text"), bv.isValidTextValue(p) && b.push(p)), b.join("<br>");
                }
                var _ = bv.castOption(r, u.i, "texttemplate");
                if (!_) return "";
                var C = {};
                u.label && (C.label = u.label), u.hasOwnProperty("v") && (C.value = u.v, C.valueLabel = sl.formatValue(u.v, s)), C.currentPath = sl.getPath(e.data), f || (C.percentParent = d / sl.getValue(h), C.percentParentLabel = sl.formatPercent(C.percentParent, s), C.parent = sl.getPtLabel(h)), C.percentEntry = d / sl.getValue(t), C.percentEntryLabel = sl.formatPercent(C.percentEntry, s), C.entry = sl.getPtLabel(t), C.percentRoot = d / sl.getValue(c), C.percentRootLabel = sl.formatPercent(C.percentRoot, s), C.root = sl.getPtLabel(c), u.hasOwnProperty("color") && (C.color = u.color);
                var M = bv.castOption(r, u.i, "text");
                return (bv.isValidTextValue(M) || M === "") && (C.text = M), C.customdata = bv.castOption(r, u.i, "customdata"), bv.texttemplateString(_, C, i._d3locale, C, r._meta || {});
            };
            function yCt(e) {
                return e.rpx0 === 0 && bv.isFullCircle([
                    e.x0,
                    e.x1
                ]) ? 1 : Math.max(0, Math.min(1 / (1 + 1 / Math.sin(e.halfangle)), e.ring / 2));
            }
            function mCe(e) {
                return _Ct(e.rpx1, e.transform.textPosAngle);
            }
            function _Ct(e, t) {
                return [
                    e * Math.sin(t),
                    -e * Math.cos(t)
                ];
            }
        });
        var bCe = ye((pdr, xCe)=>{
            "use strict";
            xCe.exports = {
                moduleType: "trace",
                name: "sunburst",
                basePlotModule: zEe(),
                categories: [],
                animatable: !0,
                attributes: AE(),
                layoutAttributes: aW(),
                supplyDefaults: HEe(),
                supplyLayoutDefaults: jEe(),
                calc: EE().calc,
                crossTraceCalc: EE().crossTraceCalc,
                plot: FD().plot,
                style: kW().style,
                colorbar: Kd(),
                meta: {}
            };
        });
        var TCe = ye((gdr, wCe)=>{
            "use strict";
            wCe.exports = bCe();
        });
        var SCe = ye((L5)=>{
            "use strict";
            var ACe = Xu();
            L5.name = "treemap";
            L5.plot = function(e, t, r, n) {
                ACe.plotBasePlot(L5.name, e, t, r, n);
            };
            L5.clean = function(e, t, r, n) {
                ACe.cleanBasePlot(L5.name, e, t, r, n);
            };
        });
        var z2 = ye((ydr, MCe)=>{
            "use strict";
            MCe.exports = {
                CLICK_TRANSITION_TIME: 750,
                CLICK_TRANSITION_EASING: "poly",
                eventDataKeys: [
                    "currentPath",
                    "root",
                    "entry",
                    "percentRoot",
                    "percentEntry",
                    "percentParent"
                ],
                gapWithPathbar: 1
            };
        });
        var qD = ye((_dr, kCe)=>{
            "use strict";
            var xCt = Wo().hovertemplateAttrs, bCt = Wo().texttemplateAttrs, wCt = Jl(), TCt = Ju().attributes, F2 = A2(), Q0 = AE(), ECe = z2(), LW = no().extendFlat, ACt = Ed().pattern;
            kCe.exports = {
                labels: Q0.labels,
                parents: Q0.parents,
                values: Q0.values,
                branchvalues: Q0.branchvalues,
                count: Q0.count,
                level: Q0.level,
                maxdepth: Q0.maxdepth,
                tiling: {
                    packing: {
                        valType: "enumerated",
                        values: [
                            "squarify",
                            "binary",
                            "dice",
                            "slice",
                            "slice-dice",
                            "dice-slice"
                        ],
                        dflt: "squarify",
                        editType: "plot"
                    },
                    squarifyratio: {
                        valType: "number",
                        min: 1,
                        dflt: 1,
                        editType: "plot"
                    },
                    flip: {
                        valType: "flaglist",
                        flags: [
                            "x",
                            "y"
                        ],
                        dflt: "",
                        editType: "plot"
                    },
                    pad: {
                        valType: "number",
                        min: 0,
                        dflt: 3,
                        editType: "plot"
                    },
                    editType: "calc"
                },
                marker: LW({
                    pad: {
                        t: {
                            valType: "number",
                            min: 0,
                            editType: "plot"
                        },
                        l: {
                            valType: "number",
                            min: 0,
                            editType: "plot"
                        },
                        r: {
                            valType: "number",
                            min: 0,
                            editType: "plot"
                        },
                        b: {
                            valType: "number",
                            min: 0,
                            editType: "plot"
                        },
                        editType: "calc"
                    },
                    colors: Q0.marker.colors,
                    pattern: ACt,
                    depthfade: {
                        valType: "enumerated",
                        values: [
                            !0,
                            !1,
                            "reversed"
                        ],
                        editType: "style"
                    },
                    line: Q0.marker.line,
                    cornerradius: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "plot"
                    },
                    editType: "calc"
                }, wCt("marker", {
                    colorAttr: "colors",
                    anim: !1
                })),
                pathbar: {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    side: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom"
                        ],
                        dflt: "top",
                        editType: "plot"
                    },
                    edgeshape: {
                        valType: "enumerated",
                        values: [
                            ">",
                            "<",
                            "|",
                            "/",
                            "\\"
                        ],
                        dflt: ">",
                        editType: "plot"
                    },
                    thickness: {
                        valType: "number",
                        min: 12,
                        editType: "plot"
                    },
                    textfont: LW({}, F2.textfont, {}),
                    editType: "calc"
                },
                text: F2.text,
                textinfo: Q0.textinfo,
                texttemplate: bCt({
                    editType: "plot"
                }, {
                    keys: ECe.eventDataKeys.concat([
                        "label",
                        "value"
                    ])
                }),
                hovertext: F2.hovertext,
                hoverinfo: Q0.hoverinfo,
                hovertemplate: xCt({}, {
                    keys: ECe.eventDataKeys
                }),
                textfont: F2.textfont,
                insidetextfont: F2.insidetextfont,
                outsidetextfont: LW({}, F2.outsidetextfont, {}),
                textposition: {
                    valType: "enumerated",
                    values: [
                        "top left",
                        "top center",
                        "top right",
                        "middle left",
                        "middle center",
                        "middle right",
                        "bottom left",
                        "bottom center",
                        "bottom right"
                    ],
                    dflt: "top left",
                    editType: "plot"
                },
                sort: F2.sort,
                root: Q0.root,
                domain: TCt({
                    name: "treemap",
                    trace: !0,
                    editType: "calc"
                })
            };
        });
        var PW = ye((xdr, CCe)=>{
            "use strict";
            CCe.exports = {
                treemapcolorway: {
                    valType: "colorlist",
                    editType: "calc"
                },
                extendtreemapcolors: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc"
                }
            };
        });
        var RCe = ye((bdr, ICe)=>{
            "use strict";
            var LCe = Mr(), SCt = qD(), MCt = va(), ECt = Ju().defaults, kCt = r0().handleText, CCt = Qb().TEXTPAD, LCt = S2().handleMarkerDefaults, PCe = Mu(), PCt = PCe.hasColorscale, ICt = PCe.handleDefaults;
            ICe.exports = function(t, r, n, i) {
                function a(b, p) {
                    return LCe.coerce(t, r, SCt, b, p);
                }
                var o = a("labels"), s = a("parents");
                if (!o || !o.length || !s || !s.length) {
                    r.visible = !1;
                    return;
                }
                var l = a("values");
                l && l.length ? a("branchvalues") : a("count"), a("level"), a("maxdepth");
                var u = a("tiling.packing");
                u === "squarify" && a("tiling.squarifyratio"), a("tiling.flip"), a("tiling.pad");
                var c = a("text");
                a("texttemplate"), r.texttemplate || a("textinfo", LCe.isArrayOrTypedArray(c) ? "text+label" : "label"), a("hovertext"), a("hovertemplate");
                var f = a("pathbar.visible"), h = "auto";
                kCt(t, r, i, a, h, {
                    hasPathbar: f,
                    moduleHasSelected: !1,
                    moduleHasUnselected: !1,
                    moduleHasConstrain: !1,
                    moduleHasCliponaxis: !1,
                    moduleHasTextangle: !1,
                    moduleHasInsideanchor: !1
                }), a("textposition");
                var d = r.textposition.indexOf("bottom") !== -1;
                LCt(t, r, i, a);
                var v = r._hasColorscale = PCt(t, "marker", "colors") || (t.marker || {}).coloraxis;
                v ? ICt(t, r, i, a, {
                    prefix: "marker.",
                    cLetter: "c"
                }) : a("marker.depthfade", !(r.marker.colors || []).length);
                var x = r.textfont.size * 2;
                a("marker.pad.t", d ? x / 4 : x), a("marker.pad.l", x / 4), a("marker.pad.r", x / 4), a("marker.pad.b", d ? x : x / 4), a("marker.cornerradius"), r._hovered = {
                    marker: {
                        line: {
                            width: 2,
                            color: MCt.contrast(i.paper_bgcolor)
                        }
                    }
                }, f && (a("pathbar.thickness", r.pathbar.textfont.size + 2 * CCt), a("pathbar.side"), a("pathbar.edgeshape")), a("sort"), a("root.color"), ECt(r, i, a), r._length = null;
            };
        });
        var zCe = ye((wdr, DCe)=>{
            "use strict";
            var RCt = Mr(), DCt = PW();
            DCe.exports = function(t, r) {
                function n(i, a) {
                    return RCt.coerce(t, r, DCt, i, a);
                }
                n("treemapcolorway", r.colorway), n("extendtreemapcolors");
            };
        });
        var RW = ye((IW)=>{
            "use strict";
            var FCe = EE();
            IW.calc = function(e, t) {
                return FCe.calc(e, t);
            };
            IW.crossTraceCalc = function(e) {
                return FCe._runCrossTraceCalc("treemap", e);
            };
        });
        var DW = ye((Adr, qCe)=>{
            "use strict";
            qCe.exports = function e(t, r, n) {
                var i;
                n.swapXY && (i = t.x0, t.x0 = t.y0, t.y0 = i, i = t.x1, t.x1 = t.y1, t.y1 = i), n.flipX && (i = t.x0, t.x0 = r[0] - t.x1, t.x1 = r[0] - i), n.flipY && (i = t.y0, t.y0 = r[1] - t.y1, t.y1 = r[1] - i);
                var a = t.children;
                if (a) for(var o = 0; o < a.length; o++)e(a[o], r, n);
            };
        });
        var zW = ye((Sdr, OCe)=>{
            "use strict";
            var P5 = SE(), zCt = DW();
            OCe.exports = function(t, r, n) {
                var i = n.flipX, a = n.flipY, o = n.packing === "dice-slice", s = n.pad[a ? "bottom" : "top"], l = n.pad[i ? "right" : "left"], u = n.pad[i ? "left" : "right"], c = n.pad[a ? "top" : "bottom"], f;
                o && (f = l, l = s, s = f, f = u, u = c, c = f);
                var h = P5.treemap().tile(FCt(n.packing, n.squarifyratio)).paddingInner(n.pad.inner).paddingLeft(l).paddingRight(u).paddingTop(s).paddingBottom(c).size(o ? [
                    r[1],
                    r[0]
                ] : r)(t);
                return (o || i || a) && zCt(h, r, {
                    swapXY: o,
                    flipX: i,
                    flipY: a
                }), h;
            };
            function FCt(e, t) {
                switch(e){
                    case "squarify":
                        return P5.treemapSquarify.ratio(t);
                    case "binary":
                        return P5.treemapBinary;
                    case "dice":
                        return P5.treemapDice;
                    case "slice":
                        return P5.treemapSlice;
                    default:
                        return P5.treemapSliceDice;
                }
            }
        });
        var OD = ye((Mdr, VCe)=>{
            "use strict";
            var BCe = xa(), I5 = va(), NCe = Mr(), FW = Ky(), qCt = _v().resizeText, OCt = DD();
            function BCt(e) {
                var t = e._fullLayout._treemaplayer.selectAll(".trace");
                qCt(e, t, "treemap"), t.each(function(r) {
                    var n = BCe.select(this), i = r[0], a = i.trace;
                    n.style("opacity", a.opacity), n.selectAll("path.surface").each(function(o) {
                        BCe.select(this).call(UCe, o, a, e, {
                            hovered: !1
                        });
                    });
                });
            }
            function UCe(e, t, r, n, i) {
                var a = (i || {}).hovered, o = t.data.data, s = o.i, l, u, c = o.color, f = FW.isHierarchyRoot(t), h = 1;
                if (a) l = r._hovered.marker.line.color, u = r._hovered.marker.line.width;
                else if (f && c === r.root.color) h = 100, l = "rgba(0,0,0,0)", u = 0;
                else if (l = NCe.castOption(r, s, "marker.line.color") || I5.defaultLine, u = NCe.castOption(r, s, "marker.line.width") || 0, !r._hasColorscale && !t.onPathbar) {
                    var d = r.marker.depthfade;
                    if (d) {
                        var v = I5.combine(I5.addOpacity(r._backgroundColor, .75), c), x;
                        if (d === !0) {
                            var b = FW.getMaxDepth(r);
                            isFinite(b) ? FW.isLeaf(t) ? x = 0 : x = r._maxVisibleLayers - (t.data.depth - r._entryDepth) : x = t.data.height + 1;
                        } else x = t.data.depth - r._entryDepth, r._atRootLevel || x++;
                        if (x > 0) for(var p = 0; p < x; p++){
                            var E = .5 * p / x;
                            c = I5.combine(I5.addOpacity(v, E), c);
                        }
                    }
                }
                e.call(OCt, t, r, n, c).style("stroke-width", u).call(I5.stroke, l).style("opacity", h);
            }
            VCe.exports = {
                style: BCt,
                styleOne: UCe
            };
        });
        var ZCe = ye((Edr, WCe)=>{
            "use strict";
            var HCe = xa(), BD = Mr(), GCe = ao(), NCt = Pl(), UCt = zW(), jCe = OD().styleOne, qW = z2(), R5 = Ky(), VCt = OE(), OW = !0;
            WCe.exports = function(t, r, n, i, a) {
                var o = a.barDifY, s = a.width, l = a.height, u = a.viewX, c = a.viewY, f = a.pathSlice, h = a.toMoveInsideSlice, d = a.strTransform, v = a.hasTransition, x = a.handleSlicesExit, b = a.makeUpdateSliceInterpolator, p = a.makeUpdateTextInterpolator, E = {}, k = t._context.staticPlot, A = t._fullLayout, L = r[0], _ = L.trace, C = L.hierarchy, M = s / _._entryDepth, g = R5.listPath(n.data, "id"), P = UCt(C.copy(), [
                    s,
                    l
                ], {
                    packing: "dice",
                    pad: {
                        inner: 0,
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0
                    }
                }).descendants();
                P = P.filter(function(F) {
                    var q = g.indexOf(F.data.id);
                    return q === -1 ? !1 : (F.x0 = M * q, F.x1 = M * (q + 1), F.y0 = o, F.y1 = o + l, F.onPathbar = !0, !0);
                }), P.reverse(), i = i.data(P, R5.getPtId), i.enter().append("g").classed("pathbar", !0), x(i, OW, E, [
                    s,
                    l
                ], f), i.order();
                var T = i;
                v && (T = T.transition().each("end", function() {
                    var F = HCe.select(this);
                    R5.setSliceCursor(F, t, {
                        hideOnRoot: !1,
                        hideOnLeaves: !1,
                        isTransitioning: !1
                    });
                })), T.each(function(F) {
                    F._x0 = u(F.x0), F._x1 = u(F.x1), F._y0 = c(F.y0), F._y1 = c(F.y1), F._hoverX = u(F.x1 - Math.min(s, l) / 2), F._hoverY = c(F.y1 - l / 2);
                    var q = HCe.select(this), V = BD.ensureSingle(q, "path", "surface", function(N) {
                        N.style("pointer-events", k ? "none" : "all");
                    });
                    v ? V.transition().attrTween("d", function(N) {
                        var W = b(N, OW, E, [
                            s,
                            l
                        ]);
                        return function(re) {
                            return f(W(re));
                        };
                    }) : V.attr("d", f), q.call(VCt, n, t, r, {
                        styleOne: jCe,
                        eventDataKeys: qW.eventDataKeys,
                        transitionTime: qW.CLICK_TRANSITION_TIME,
                        transitionEasing: qW.CLICK_TRANSITION_EASING
                    }).call(R5.setSliceCursor, t, {
                        hideOnRoot: !1,
                        hideOnLeaves: !1,
                        isTransitioning: t._transitioning
                    }), V.call(jCe, F, _, t, {
                        hovered: !1
                    }), F._text = (R5.getPtLabel(F) || "").split("<br>").join(" ") || "";
                    var H = BD.ensureSingle(q, "g", "slicetext"), X = BD.ensureSingle(H, "text", "", function(N) {
                        N.attr("data-notex", 1);
                    }), G = BD.ensureUniformFontSize(t, R5.determineTextFont(_, F, A.font, {
                        onPathbar: !0
                    }));
                    X.text(F._text || " ").classed("slicetext", !0).attr("text-anchor", "start").call(GCe.font, G).call(NCt.convertToTspans, t), F.textBB = GCe.bBox(X.node()), F.transform = h(F, {
                        fontSize: G.size,
                        onPathbar: !0
                    }), F.transform.fontSize = G.size, v ? X.transition().attrTween("transform", function(N) {
                        var W = p(N, OW, E, [
                            s,
                            l
                        ]);
                        return function(re) {
                            return d(W(re));
                        };
                    }) : X.attr("transform", d(F));
                });
            };
        });
        var JCe = ye((kdr, KCe)=>{
            "use strict";
            var XCe = xa(), BW = (R2(), B1(I2)).interpolate, Y_ = Ky(), NE = Mr(), YCe = Qb().TEXTPAD, HCt = i2(), GCt = HCt.toMoveInsideBar, jCt = _v(), NW = jCt.recordMinTextSize, WCt = z2(), ZCt = ZCe();
            function q2(e) {
                return Y_.isHierarchyRoot(e) ? "" : Y_.getPtId(e);
            }
            KCe.exports = function(t, r, n, i, a) {
                var o = t._fullLayout, s = r[0], l = s.trace, u = l.type, c = u === "icicle", f = s.hierarchy, h = Y_.findEntryWithLevel(f, l.level), d = XCe.select(n), v = d.selectAll("g.pathbar"), x = d.selectAll("g.slice");
                if (!h) {
                    v.remove(), x.remove();
                    return;
                }
                var b = Y_.isHierarchyRoot(h), p = !o.uniformtext.mode && Y_.hasTransition(i), E = Y_.getMaxDepth(l), k = function(Ke) {
                    return Ke.data.depth - h.data.depth < E;
                }, A = o._size, L = l.domain, _ = A.w * (L.x[1] - L.x[0]), C = A.h * (L.y[1] - L.y[0]), M = _, g = l.pathbar.thickness, P = l.marker.line.width + WCt.gapWithPathbar, T = l.pathbar.visible ? l.pathbar.side.indexOf("bottom") > -1 ? C + P : -(g + P) : 0, F = {
                    x0: M,
                    x1: M,
                    y0: T,
                    y1: T + g
                }, q = function(Ke, xt, bt) {
                    var Lt = l.tiling.pad, St = function($t) {
                        return $t - Lt <= xt.x0;
                    }, Et = function($t) {
                        return $t + Lt >= xt.x1;
                    }, dt = function($t) {
                        return $t - Lt <= xt.y0;
                    }, Ht = function($t) {
                        return $t + Lt >= xt.y1;
                    };
                    return Ke.x0 === xt.x0 && Ke.x1 === xt.x1 && Ke.y0 === xt.y0 && Ke.y1 === xt.y1 ? {
                        x0: Ke.x0,
                        x1: Ke.x1,
                        y0: Ke.y0,
                        y1: Ke.y1
                    } : {
                        x0: St(Ke.x0 - Lt) ? 0 : Et(Ke.x0 - Lt) ? bt[0] : Ke.x0,
                        x1: St(Ke.x1 + Lt) ? 0 : Et(Ke.x1 + Lt) ? bt[0] : Ke.x1,
                        y0: dt(Ke.y0 - Lt) ? 0 : Ht(Ke.y0 - Lt) ? bt[1] : Ke.y0,
                        y1: dt(Ke.y1 + Lt) ? 0 : Ht(Ke.y1 + Lt) ? bt[1] : Ke.y1
                    };
                }, V = null, H = {}, X = {}, G = null, N = function(Ke, xt) {
                    return xt ? H[q2(Ke)] : X[q2(Ke)];
                }, W = function(Ke, xt, bt, Lt) {
                    if (xt) return H[q2(f)] || F;
                    var St = X[l.level] || bt;
                    return k(Ke) ? q(Ke, St, Lt) : {};
                };
                s.hasMultipleRoots && b && E++, l._maxDepth = E, l._backgroundColor = o.paper_bgcolor, l._entryDepth = h.data.depth, l._atRootLevel = b;
                var re = -_ / 2 + A.l + A.w * (L.x[1] + L.x[0]) / 2, ae = -C / 2 + A.t + A.h * (1 - (L.y[1] + L.y[0]) / 2), _e = function(Ke) {
                    return re + Ke;
                }, Me = function(Ke) {
                    return ae + Ke;
                }, ke = Me(0), ge = _e(0), ie = function(Ke) {
                    return ge + Ke;
                }, Te = function(Ke) {
                    return ke + Ke;
                };
                function Ee(Ke, xt) {
                    return Ke + "," + xt;
                }
                var Ae = ie(0), ze = function(Ke) {
                    Ke.x = Math.max(Ae, Ke.x);
                }, Ce = l.pathbar.edgeshape, me = function(Ke) {
                    var xt = ie(Math.max(Math.min(Ke.x0, Ke.x0), 0)), bt = ie(Math.min(Math.max(Ke.x1, Ke.x1), M)), Lt = Te(Ke.y0), St = Te(Ke.y1), Et = g / 2, dt = {}, Ht = {};
                    dt.x = xt, Ht.x = bt, dt.y = Ht.y = (Lt + St) / 2;
                    var $t = {
                        x: xt,
                        y: Lt
                    }, fr = {
                        x: bt,
                        y: Lt
                    }, _r = {
                        x: bt,
                        y: St
                    }, Br = {
                        x: xt,
                        y: St
                    };
                    return Ce === ">" ? ($t.x -= Et, fr.x -= Et, _r.x -= Et, Br.x -= Et) : Ce === "/" ? (_r.x -= Et, Br.x -= Et, dt.x -= Et / 2, Ht.x -= Et / 2) : Ce === "\\" ? ($t.x -= Et, fr.x -= Et, dt.x -= Et / 2, Ht.x -= Et / 2) : Ce === "<" && (dt.x -= Et, Ht.x -= Et), ze($t), ze(Br), ze(dt), ze(fr), ze(_r), ze(Ht), "M" + Ee($t.x, $t.y) + "L" + Ee(fr.x, fr.y) + "L" + Ee(Ht.x, Ht.y) + "L" + Ee(_r.x, _r.y) + "L" + Ee(Br.x, Br.y) + "L" + Ee(dt.x, dt.y) + "Z";
                }, Re = l[c ? "tiling" : "marker"].pad, ce = function(Ke) {
                    return l.textposition.indexOf(Ke) !== -1;
                }, Ge = ce("top"), nt = ce("left"), ct = ce("right"), qt = ce("bottom"), rt = function(Ke) {
                    var xt = _e(Ke.x0), bt = _e(Ke.x1), Lt = Me(Ke.y0), St = Me(Ke.y1), Et = bt - xt, dt = St - Lt;
                    if (!Et || !dt) return "";
                    var Ht = l.marker.cornerradius || 0, $t = Math.min(Ht, Et / 2, dt / 2);
                    $t && Ke.data && Ke.data.data && Ke.data.data.label && (Ge && ($t = Math.min($t, Re.t)), nt && ($t = Math.min($t, Re.l)), ct && ($t = Math.min($t, Re.r)), qt && ($t = Math.min($t, Re.b)));
                    var fr = function(_r, Br) {
                        return $t ? "a" + Ee($t, $t) + " 0 0 1 " + Ee(_r, Br) : "";
                    };
                    return "M" + Ee(xt, Lt + $t) + fr($t, -$t) + "L" + Ee(bt - $t, Lt) + fr($t, $t) + "L" + Ee(bt, St - $t) + fr(-$t, $t) + "L" + Ee(xt + $t, St) + fr(-$t, -$t) + "Z";
                }, ot = function(Ke, xt) {
                    var bt = Ke.x0, Lt = Ke.x1, St = Ke.y0, Et = Ke.y1, dt = Ke.textBB, Ht = Ge || xt.isHeader && !qt, $t = Ht ? "start" : qt ? "end" : "middle", fr = ce("right"), _r = ce("left") || xt.onPathbar, Br = _r ? -1 : fr ? 1 : 0;
                    if (xt.isHeader) {
                        if (bt += (c ? Re : Re.l) - YCe, Lt -= (c ? Re : Re.r) - YCe, bt >= Lt) {
                            var Or = (bt + Lt) / 2;
                            bt = Or, Lt = Or;
                        }
                        var Nr;
                        qt ? (Nr = Et - (c ? Re : Re.b), St < Nr && Nr < Et && (St = Nr)) : (Nr = St + (c ? Re : Re.t), St < Nr && Nr < Et && (Et = Nr));
                    }
                    var ut = GCt(bt, Lt, St, Et, dt, {
                        isHorizontal: !1,
                        constrained: !0,
                        angle: 0,
                        anchor: $t,
                        leftToRight: Br
                    });
                    return ut.fontSize = xt.fontSize, ut.targetX = _e(ut.targetX), ut.targetY = Me(ut.targetY), isNaN(ut.targetX) || isNaN(ut.targetY) ? {} : (bt !== Lt && St !== Et && NW(l.type, ut, o), {
                        scale: ut.scale,
                        rotate: ut.rotate,
                        textX: ut.textX,
                        textY: ut.textY,
                        anchorX: ut.anchorX,
                        anchorY: ut.anchorY,
                        targetX: ut.targetX,
                        targetY: ut.targetY
                    });
                }, Rt = function(Ke, xt) {
                    for(var bt, Lt = 0, St = Ke; !bt && Lt < E;)Lt++, St = St.parent, St ? bt = N(St, xt) : Lt = E;
                    return bt || {};
                }, kt = function(Ke, xt, bt, Lt) {
                    var St = N(Ke, xt), Et;
                    if (xt) Et = F;
                    else {
                        var dt = N(h, xt);
                        dt ? Et = q(Ke, dt, Lt) : Et = {};
                    }
                    return BW(St, Et);
                }, Ct = function(Ke, xt, bt, Lt, St) {
                    var Et = N(Ke, xt), dt;
                    if (Et) dt = Et;
                    else if (xt) dt = F;
                    else if (V) {
                        if (Ke.parent) {
                            var Ht = G || bt;
                            Ht && !xt ? dt = q(Ke, Ht, Lt) : (dt = {}, NE.extendFlat(dt, Rt(Ke, xt)));
                        } else dt = NE.extendFlat({}, Ke), c && (St.orientation === "h" ? St.flipX ? dt.x0 = Ke.x1 : dt.x1 = 0 : St.flipY ? dt.y0 = Ke.y1 : dt.y1 = 0);
                    } else dt = {};
                    return BW(dt, {
                        x0: Ke.x0,
                        x1: Ke.x1,
                        y0: Ke.y0,
                        y1: Ke.y1
                    });
                }, Yt = function(Ke, xt, bt, Lt) {
                    var St = N(Ke, xt), Et = {}, dt = W(Ke, xt, bt, Lt);
                    NE.extendFlat(Et, {
                        transform: ot({
                            x0: dt.x0,
                            x1: dt.x1,
                            y0: dt.y0,
                            y1: dt.y1,
                            textBB: Ke.textBB,
                            _text: Ke._text
                        }, {
                            isHeader: Y_.isHeader(Ke, l)
                        })
                    }), St ? Et = St : Ke.parent && NE.extendFlat(Et, Rt(Ke, xt));
                    var Ht = Ke.transform;
                    return Ke.x0 !== Ke.x1 && Ke.y0 !== Ke.y1 && NW(l.type, Ht, o), BW(Et, {
                        transform: {
                            scale: Ht.scale,
                            rotate: Ht.rotate,
                            textX: Ht.textX,
                            textY: Ht.textY,
                            anchorX: Ht.anchorX,
                            anchorY: Ht.anchorY,
                            targetX: Ht.targetX,
                            targetY: Ht.targetY
                        }
                    });
                }, xr = function(Ke, xt, bt, Lt, St) {
                    var Et = Lt[0], dt = Lt[1];
                    p ? Ke.exit().transition().each(function() {
                        var Ht = XCe.select(this), $t = Ht.select("path.surface");
                        $t.transition().attrTween("d", function(_r) {
                            var Br = kt(_r, xt, bt, [
                                Et,
                                dt
                            ]);
                            return function(Or) {
                                return St(Br(Or));
                            };
                        });
                        var fr = Ht.select("g.slicetext");
                        fr.attr("opacity", 0);
                    }).remove() : Ke.exit().remove();
                }, er = function(Ke) {
                    var xt = Ke.transform;
                    return Ke.x0 !== Ke.x1 && Ke.y0 !== Ke.y1 && NW(l.type, xt, o), NE.getTextTransform({
                        textX: xt.textX,
                        textY: xt.textY,
                        anchorX: xt.anchorX,
                        anchorY: xt.anchorY,
                        targetX: xt.targetX,
                        targetY: xt.targetY,
                        scale: xt.scale,
                        rotate: xt.rotate
                    });
                };
                p && (v.each(function(Ke) {
                    H[q2(Ke)] = {
                        x0: Ke.x0,
                        x1: Ke.x1,
                        y0: Ke.y0,
                        y1: Ke.y1
                    }, Ke.transform && (H[q2(Ke)].transform = {
                        textX: Ke.transform.textX,
                        textY: Ke.transform.textY,
                        anchorX: Ke.transform.anchorX,
                        anchorY: Ke.transform.anchorY,
                        targetX: Ke.transform.targetX,
                        targetY: Ke.transform.targetY,
                        scale: Ke.transform.scale,
                        rotate: Ke.transform.rotate
                    });
                }), x.each(function(Ke) {
                    X[q2(Ke)] = {
                        x0: Ke.x0,
                        x1: Ke.x1,
                        y0: Ke.y0,
                        y1: Ke.y1
                    }, Ke.transform && (X[q2(Ke)].transform = {
                        textX: Ke.transform.textX,
                        textY: Ke.transform.textY,
                        anchorX: Ke.transform.anchorX,
                        anchorY: Ke.transform.anchorY,
                        targetX: Ke.transform.targetX,
                        targetY: Ke.transform.targetY,
                        scale: Ke.transform.scale,
                        rotate: Ke.transform.rotate
                    }), !V && Y_.isEntry(Ke) && (V = Ke);
                })), G = a(t, r, h, x, {
                    width: _,
                    height: C,
                    viewX: _e,
                    viewY: Me,
                    pathSlice: rt,
                    toMoveInsideSlice: ot,
                    prevEntry: V,
                    makeUpdateSliceInterpolator: Ct,
                    makeUpdateTextInterpolator: Yt,
                    handleSlicesExit: xr,
                    hasTransition: p,
                    strTransform: er
                }), l.pathbar.visible ? ZCt(t, r, h, v, {
                    barDifY: T,
                    width: M,
                    height: g,
                    viewX: ie,
                    viewY: Te,
                    pathSlice: me,
                    toMoveInsideSlice: ot,
                    makeUpdateSliceInterpolator: Ct,
                    makeUpdateTextInterpolator: Yt,
                    handleSlicesExit: xr,
                    hasTransition: p,
                    strTransform: er
                }) : v.remove();
            };
        });
        var UW = ye((Cdr, QCe)=>{
            "use strict";
            var XCt = xa(), YCt = Ky(), KCt = _v(), JCt = KCt.clearMinTextSize, $Ct = N0().resizeText, $Ce = JCe();
            QCe.exports = function(t, r, n, i, a) {
                var o = a.type, s = a.drawDescendants, l = t._fullLayout, u = l["_" + o + "layer"], c, f, h = !n;
                if (JCt(o, l), c = u.selectAll("g.trace." + o).data(r, function(v) {
                    return v[0].trace.uid;
                }), c.enter().append("g").classed("trace", !0).classed(o, !0), c.order(), !l.uniformtext.mode && YCt.hasTransition(n)) {
                    i && (f = i());
                    var d = XCt.transition().duration(n.duration).ease(n.easing).each("end", function() {
                        f && f();
                    }).each("interrupt", function() {
                        f && f();
                    });
                    d.each(function() {
                        u.selectAll("g.trace").each(function(v) {
                            $Ce(t, v, this, n, s);
                        });
                    });
                } else c.each(function(v) {
                    $Ce(t, v, this, n, s);
                }), l.uniformtext.mode && $Ct(t, u.selectAll(".trace"), o);
                h && c.exit().remove();
            };
        });
        var n6e = ye((Ldr, i6e)=>{
            "use strict";
            var e6e = xa(), ND = Mr(), t6e = ao(), QCt = Pl(), e6t = zW(), r6e = OD().styleOne, VW = z2(), K_ = Ky(), t6t = OE(), r6t = FD().formatSliceLabel, HW = !1;
            i6e.exports = function(t, r, n, i, a) {
                var o = a.width, s = a.height, l = a.viewX, u = a.viewY, c = a.pathSlice, f = a.toMoveInsideSlice, h = a.strTransform, d = a.hasTransition, v = a.handleSlicesExit, x = a.makeUpdateSliceInterpolator, b = a.makeUpdateTextInterpolator, p = a.prevEntry, E = {}, k = t._context.staticPlot, A = t._fullLayout, L = r[0], _ = L.trace, C = _.textposition.indexOf("left") !== -1, M = _.textposition.indexOf("right") !== -1, g = _.textposition.indexOf("bottom") !== -1, P = !g && !_.marker.pad.t || g && !_.marker.pad.b, T = e6t(n, [
                    o,
                    s
                ], {
                    packing: _.tiling.packing,
                    squarifyratio: _.tiling.squarifyratio,
                    flipX: _.tiling.flip.indexOf("x") > -1,
                    flipY: _.tiling.flip.indexOf("y") > -1,
                    pad: {
                        inner: _.tiling.pad,
                        top: _.marker.pad.t,
                        left: _.marker.pad.l,
                        right: _.marker.pad.r,
                        bottom: _.marker.pad.b
                    }
                }), F = T.descendants(), q = 1 / 0, V = -1 / 0;
                F.forEach(function(W) {
                    var re = W.depth;
                    re >= _._maxDepth ? (W.x0 = W.x1 = (W.x0 + W.x1) / 2, W.y0 = W.y1 = (W.y0 + W.y1) / 2) : (q = Math.min(q, re), V = Math.max(V, re));
                }), i = i.data(F, K_.getPtId), _._maxVisibleLayers = isFinite(V) ? V - q + 1 : 0, i.enter().append("g").classed("slice", !0), v(i, HW, E, [
                    o,
                    s
                ], c), i.order();
                var H = null;
                if (d && p) {
                    var X = K_.getPtId(p);
                    i.each(function(W) {
                        H === null && K_.getPtId(W) === X && (H = {
                            x0: W.x0,
                            x1: W.x1,
                            y0: W.y0,
                            y1: W.y1
                        });
                    });
                }
                var G = function() {
                    return H || {
                        x0: 0,
                        x1: o,
                        y0: 0,
                        y1: s
                    };
                }, N = i;
                return d && (N = N.transition().each("end", function() {
                    var W = e6e.select(this);
                    K_.setSliceCursor(W, t, {
                        hideOnRoot: !0,
                        hideOnLeaves: !1,
                        isTransitioning: !1
                    });
                })), N.each(function(W) {
                    var re = K_.isHeader(W, _);
                    W._x0 = l(W.x0), W._x1 = l(W.x1), W._y0 = u(W.y0), W._y1 = u(W.y1), W._hoverX = l(W.x1 - _.marker.pad.r), W._hoverY = u(g ? W.y1 - _.marker.pad.b / 2 : W.y0 + _.marker.pad.t / 2);
                    var ae = e6e.select(this), _e = ND.ensureSingle(ae, "path", "surface", function(Ee) {
                        Ee.style("pointer-events", k ? "none" : "all");
                    });
                    d ? _e.transition().attrTween("d", function(Ee) {
                        var Ae = x(Ee, HW, G(), [
                            o,
                            s
                        ]);
                        return function(ze) {
                            return c(Ae(ze));
                        };
                    }) : _e.attr("d", c), ae.call(t6t, n, t, r, {
                        styleOne: r6e,
                        eventDataKeys: VW.eventDataKeys,
                        transitionTime: VW.CLICK_TRANSITION_TIME,
                        transitionEasing: VW.CLICK_TRANSITION_EASING
                    }).call(K_.setSliceCursor, t, {
                        isTransitioning: t._transitioning
                    }), _e.call(r6e, W, _, t, {
                        hovered: !1
                    }), W.x0 === W.x1 || W.y0 === W.y1 ? W._text = "" : re ? W._text = P ? "" : K_.getPtLabel(W) || "" : W._text = r6t(W, n, _, r, A) || "";
                    var Me = ND.ensureSingle(ae, "g", "slicetext"), ke = ND.ensureSingle(Me, "text", "", function(Ee) {
                        Ee.attr("data-notex", 1);
                    }), ge = ND.ensureUniformFontSize(t, K_.determineTextFont(_, W, A.font)), ie = W._text || " ", Te = re && ie.indexOf("<br>") === -1;
                    ke.text(ie).classed("slicetext", !0).attr("text-anchor", M ? "end" : C || Te ? "start" : "middle").call(t6e.font, ge).call(QCt.convertToTspans, t), W.textBB = t6e.bBox(ke.node()), W.transform = f(W, {
                        fontSize: ge.size,
                        isHeader: re
                    }), W.transform.fontSize = ge.size, d ? ke.transition().attrTween("transform", function(Ee) {
                        var Ae = b(Ee, HW, G(), [
                            o,
                            s
                        ]);
                        return function(ze) {
                            return h(Ae(ze));
                        };
                    }) : ke.attr("transform", h(W));
                }), H;
            };
        });
        var o6e = ye((Pdr, a6e)=>{
            "use strict";
            var i6t = UW(), n6t = n6e();
            a6e.exports = function(t, r, n, i) {
                return i6t(t, r, n, i, {
                    type: "treemap",
                    drawDescendants: n6t
                });
            };
        });
        var l6e = ye((Idr, s6e)=>{
            "use strict";
            s6e.exports = {
                moduleType: "trace",
                name: "treemap",
                basePlotModule: SCe(),
                categories: [],
                animatable: !0,
                attributes: qD(),
                layoutAttributes: PW(),
                supplyDefaults: RCe(),
                supplyLayoutDefaults: zCe(),
                calc: RW().calc,
                crossTraceCalc: RW().crossTraceCalc,
                plot: o6e(),
                style: OD().style,
                colorbar: Kd(),
                meta: {}
            };
        });
        var c6e = ye((Rdr, u6e)=>{
            "use strict";
            u6e.exports = l6e();
        });
        var h6e = ye((D5)=>{
            "use strict";
            var f6e = Xu();
            D5.name = "icicle";
            D5.plot = function(e, t, r, n) {
                f6e.plotBasePlot(D5.name, e, t, r, n);
            };
            D5.clean = function(e, t, r, n) {
                f6e.cleanBasePlot(D5.name, e, t, r, n);
            };
        });
        var GW = ye((zdr, v6e)=>{
            "use strict";
            var a6t = Wo().hovertemplateAttrs, o6t = Wo().texttemplateAttrs, s6t = Jl(), l6t = Ju().attributes, UE = A2(), o0 = AE(), UD = qD(), d6e = z2(), u6t = no().extendFlat, c6t = Ed().pattern;
            v6e.exports = {
                labels: o0.labels,
                parents: o0.parents,
                values: o0.values,
                branchvalues: o0.branchvalues,
                count: o0.count,
                level: o0.level,
                maxdepth: o0.maxdepth,
                tiling: {
                    orientation: {
                        valType: "enumerated",
                        values: [
                            "v",
                            "h"
                        ],
                        dflt: "h",
                        editType: "plot"
                    },
                    flip: UD.tiling.flip,
                    pad: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "plot"
                    },
                    editType: "calc"
                },
                marker: u6t({
                    colors: o0.marker.colors,
                    line: o0.marker.line,
                    pattern: c6t,
                    editType: "calc"
                }, s6t("marker", {
                    colorAttr: "colors",
                    anim: !1
                })),
                leaf: o0.leaf,
                pathbar: UD.pathbar,
                text: UE.text,
                textinfo: o0.textinfo,
                texttemplate: o6t({
                    editType: "plot"
                }, {
                    keys: d6e.eventDataKeys.concat([
                        "label",
                        "value"
                    ])
                }),
                hovertext: UE.hovertext,
                hoverinfo: o0.hoverinfo,
                hovertemplate: a6t({}, {
                    keys: d6e.eventDataKeys
                }),
                textfont: UE.textfont,
                insidetextfont: UE.insidetextfont,
                outsidetextfont: UD.outsidetextfont,
                textposition: UD.textposition,
                sort: UE.sort,
                root: o0.root,
                domain: l6t({
                    name: "icicle",
                    trace: !0,
                    editType: "calc"
                })
            };
        });
        var jW = ye((Fdr, p6e)=>{
            "use strict";
            p6e.exports = {
                iciclecolorway: {
                    valType: "colorlist",
                    editType: "calc"
                },
                extendiciclecolors: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc"
                }
            };
        });
        var _6e = ye((qdr, y6e)=>{
            "use strict";
            var g6e = Mr(), f6t = GW(), h6t = va(), d6t = Ju().defaults, v6t = r0().handleText, p6t = Qb().TEXTPAD, g6t = S2().handleMarkerDefaults, m6e = Mu(), m6t = m6e.hasColorscale, y6t = m6e.handleDefaults;
            y6e.exports = function(t, r, n, i) {
                function a(d, v) {
                    return g6e.coerce(t, r, f6t, d, v);
                }
                var o = a("labels"), s = a("parents");
                if (!o || !o.length || !s || !s.length) {
                    r.visible = !1;
                    return;
                }
                var l = a("values");
                l && l.length ? a("branchvalues") : a("count"), a("level"), a("maxdepth"), a("tiling.orientation"), a("tiling.flip"), a("tiling.pad");
                var u = a("text");
                a("texttemplate"), r.texttemplate || a("textinfo", g6e.isArrayOrTypedArray(u) ? "text+label" : "label"), a("hovertext"), a("hovertemplate");
                var c = a("pathbar.visible"), f = "auto";
                v6t(t, r, i, a, f, {
                    hasPathbar: c,
                    moduleHasSelected: !1,
                    moduleHasUnselected: !1,
                    moduleHasConstrain: !1,
                    moduleHasCliponaxis: !1,
                    moduleHasTextangle: !1,
                    moduleHasInsideanchor: !1
                }), a("textposition"), g6t(t, r, i, a);
                var h = r._hasColorscale = m6t(t, "marker", "colors") || (t.marker || {}).coloraxis;
                h && y6t(t, r, i, a, {
                    prefix: "marker.",
                    cLetter: "c"
                }), a("leaf.opacity", h ? 1 : .7), r._hovered = {
                    marker: {
                        line: {
                            width: 2,
                            color: h6t.contrast(i.paper_bgcolor)
                        }
                    }
                }, c && (a("pathbar.thickness", r.pathbar.textfont.size + 2 * p6t), a("pathbar.side"), a("pathbar.edgeshape")), a("sort"), a("root.color"), d6t(r, i, a), r._length = null;
            };
        });
        var b6e = ye((Odr, x6e)=>{
            "use strict";
            var _6t = Mr(), x6t = jW();
            x6e.exports = function(t, r) {
                function n(i, a) {
                    return _6t.coerce(t, r, x6t, i, a);
                }
                n("iciclecolorway", r.colorway), n("extendiciclecolors");
            };
        });
        var ZW = ye((WW)=>{
            "use strict";
            var w6e = EE();
            WW.calc = function(e, t) {
                return w6e.calc(e, t);
            };
            WW.crossTraceCalc = function(e) {
                return w6e._runCrossTraceCalc("icicle", e);
            };
        });
        var A6e = ye((Ndr, T6e)=>{
            "use strict";
            var b6t = SE(), w6t = DW();
            T6e.exports = function(t, r, n) {
                var i = n.flipX, a = n.flipY, o = n.orientation === "h", s = n.maxDepth, l = r[0], u = r[1];
                s && (l = (t.height + 1) * r[0] / Math.min(t.height + 1, s), u = (t.height + 1) * r[1] / Math.min(t.height + 1, s));
                var c = b6t.partition().padding(n.pad.inner).size(o ? [
                    r[1],
                    l
                ] : [
                    r[0],
                    u
                ])(t);
                return (o || i || a) && w6t(c, r, {
                    swapXY: o,
                    flipX: i,
                    flipY: a
                }), c;
            };
        });
        var XW = ye((Udr, C6e)=>{
            "use strict";
            var S6e = xa(), M6e = va(), E6e = Mr(), T6t = _v().resizeText, A6t = DD();
            function S6t(e) {
                var t = e._fullLayout._iciclelayer.selectAll(".trace");
                T6t(e, t, "icicle"), t.each(function(r) {
                    var n = S6e.select(this), i = r[0], a = i.trace;
                    n.style("opacity", a.opacity), n.selectAll("path.surface").each(function(o) {
                        S6e.select(this).call(k6e, o, a, e);
                    });
                });
            }
            function k6e(e, t, r, n) {
                var i = t.data.data, a = !t.children, o = i.i, s = E6e.castOption(r, o, "marker.line.color") || M6e.defaultLine, l = E6e.castOption(r, o, "marker.line.width") || 0;
                e.call(A6t, t, r, n).style("stroke-width", l).call(M6e.stroke, s).style("opacity", a ? r.leaf.opacity : null);
            }
            C6e.exports = {
                style: S6t,
                styleOne: k6e
            };
        });
        var D6e = ye((Vdr, R6e)=>{
            "use strict";
            var L6e = xa(), VD = Mr(), P6e = ao(), M6t = Pl(), E6t = A6e(), I6e = XW().styleOne, YW = z2(), z5 = Ky(), k6t = OE(), C6t = FD().formatSliceLabel, KW = !1;
            R6e.exports = function(t, r, n, i, a) {
                var o = a.width, s = a.height, l = a.viewX, u = a.viewY, c = a.pathSlice, f = a.toMoveInsideSlice, h = a.strTransform, d = a.hasTransition, v = a.handleSlicesExit, x = a.makeUpdateSliceInterpolator, b = a.makeUpdateTextInterpolator, p = a.prevEntry, E = {}, k = t._context.staticPlot, A = t._fullLayout, L = r[0], _ = L.trace, C = _.textposition.indexOf("left") !== -1, M = _.textposition.indexOf("right") !== -1, g = _.textposition.indexOf("bottom") !== -1, P = E6t(n, [
                    o,
                    s
                ], {
                    flipX: _.tiling.flip.indexOf("x") > -1,
                    flipY: _.tiling.flip.indexOf("y") > -1,
                    orientation: _.tiling.orientation,
                    pad: {
                        inner: _.tiling.pad
                    },
                    maxDepth: _._maxDepth
                }), T = P.descendants(), F = 1 / 0, q = -1 / 0;
                T.forEach(function(N) {
                    var W = N.depth;
                    W >= _._maxDepth ? (N.x0 = N.x1 = (N.x0 + N.x1) / 2, N.y0 = N.y1 = (N.y0 + N.y1) / 2) : (F = Math.min(F, W), q = Math.max(q, W));
                }), i = i.data(T, z5.getPtId), _._maxVisibleLayers = isFinite(q) ? q - F + 1 : 0, i.enter().append("g").classed("slice", !0), v(i, KW, E, [
                    o,
                    s
                ], c), i.order();
                var V = null;
                if (d && p) {
                    var H = z5.getPtId(p);
                    i.each(function(N) {
                        V === null && z5.getPtId(N) === H && (V = {
                            x0: N.x0,
                            x1: N.x1,
                            y0: N.y0,
                            y1: N.y1
                        });
                    });
                }
                var X = function() {
                    return V || {
                        x0: 0,
                        x1: o,
                        y0: 0,
                        y1: s
                    };
                }, G = i;
                return d && (G = G.transition().each("end", function() {
                    var N = L6e.select(this);
                    z5.setSliceCursor(N, t, {
                        hideOnRoot: !0,
                        hideOnLeaves: !1,
                        isTransitioning: !1
                    });
                })), G.each(function(N) {
                    N._x0 = l(N.x0), N._x1 = l(N.x1), N._y0 = u(N.y0), N._y1 = u(N.y1), N._hoverX = l(N.x1 - _.tiling.pad), N._hoverY = u(g ? N.y1 - _.tiling.pad / 2 : N.y0 + _.tiling.pad / 2);
                    var W = L6e.select(this), re = VD.ensureSingle(W, "path", "surface", function(ke) {
                        ke.style("pointer-events", k ? "none" : "all");
                    });
                    d ? re.transition().attrTween("d", function(ke) {
                        var ge = x(ke, KW, X(), [
                            o,
                            s
                        ], {
                            orientation: _.tiling.orientation,
                            flipX: _.tiling.flip.indexOf("x") > -1,
                            flipY: _.tiling.flip.indexOf("y") > -1
                        });
                        return function(ie) {
                            return c(ge(ie));
                        };
                    }) : re.attr("d", c), W.call(k6t, n, t, r, {
                        styleOne: I6e,
                        eventDataKeys: YW.eventDataKeys,
                        transitionTime: YW.CLICK_TRANSITION_TIME,
                        transitionEasing: YW.CLICK_TRANSITION_EASING
                    }).call(z5.setSliceCursor, t, {
                        isTransitioning: t._transitioning
                    }), re.call(I6e, N, _, t, {
                        hovered: !1
                    }), N.x0 === N.x1 || N.y0 === N.y1 ? N._text = "" : N._text = C6t(N, n, _, r, A) || "";
                    var ae = VD.ensureSingle(W, "g", "slicetext"), _e = VD.ensureSingle(ae, "text", "", function(ke) {
                        ke.attr("data-notex", 1);
                    }), Me = VD.ensureUniformFontSize(t, z5.determineTextFont(_, N, A.font));
                    _e.text(N._text || " ").classed("slicetext", !0).attr("text-anchor", M ? "end" : C ? "start" : "middle").call(P6e.font, Me).call(M6t.convertToTspans, t), N.textBB = P6e.bBox(_e.node()), N.transform = f(N, {
                        fontSize: Me.size
                    }), N.transform.fontSize = Me.size, d ? _e.transition().attrTween("transform", function(ke) {
                        var ge = b(ke, KW, X(), [
                            o,
                            s
                        ]);
                        return function(ie) {
                            return h(ge(ie));
                        };
                    }) : _e.attr("transform", h(N));
                }), V;
            };
        });
        var F6e = ye((Hdr, z6e)=>{
            "use strict";
            var L6t = UW(), P6t = D6e();
            z6e.exports = function(t, r, n, i) {
                return L6t(t, r, n, i, {
                    type: "icicle",
                    drawDescendants: P6t
                });
            };
        });
        var O6e = ye((Gdr, q6e)=>{
            "use strict";
            q6e.exports = {
                moduleType: "trace",
                name: "icicle",
                basePlotModule: h6e(),
                categories: [],
                animatable: !0,
                attributes: GW(),
                layoutAttributes: jW(),
                supplyDefaults: _6e(),
                supplyLayoutDefaults: b6e(),
                calc: ZW().calc,
                crossTraceCalc: ZW().crossTraceCalc,
                plot: F6e(),
                style: XW().style,
                colorbar: Kd(),
                meta: {}
            };
        });
        var N6e = ye((jdr, B6e)=>{
            "use strict";
            B6e.exports = O6e();
        });
        var V6e = ye((F5)=>{
            "use strict";
            var U6e = Xu();
            F5.name = "funnelarea";
            F5.plot = function(e, t, r, n) {
                U6e.plotBasePlot(F5.name, e, t, r, n);
            };
            F5.clean = function(e, t, r, n) {
                U6e.cleanBasePlot(F5.name, e, t, r, n);
            };
        });
        var JW = ye((Zdr, H6e)=>{
            "use strict";
            var tv = A2(), I6t = vl(), R6t = Ju().attributes, D6t = Wo().hovertemplateAttrs, z6t = Wo().texttemplateAttrs, O2 = no().extendFlat;
            H6e.exports = {
                labels: tv.labels,
                label0: tv.label0,
                dlabel: tv.dlabel,
                values: tv.values,
                marker: {
                    colors: tv.marker.colors,
                    line: {
                        color: O2({}, tv.marker.line.color, {
                            dflt: null
                        }),
                        width: O2({}, tv.marker.line.width, {
                            dflt: 1
                        }),
                        editType: "calc"
                    },
                    pattern: tv.marker.pattern,
                    editType: "calc"
                },
                text: tv.text,
                hovertext: tv.hovertext,
                scalegroup: O2({}, tv.scalegroup, {}),
                textinfo: O2({}, tv.textinfo, {
                    flags: [
                        "label",
                        "text",
                        "value",
                        "percent"
                    ]
                }),
                texttemplate: z6t({
                    editType: "plot"
                }, {
                    keys: [
                        "label",
                        "color",
                        "value",
                        "text",
                        "percent"
                    ]
                }),
                hoverinfo: O2({}, I6t.hoverinfo, {
                    flags: [
                        "label",
                        "text",
                        "value",
                        "percent",
                        "name"
                    ]
                }),
                hovertemplate: D6t({}, {
                    keys: [
                        "label",
                        "color",
                        "value",
                        "text",
                        "percent"
                    ]
                }),
                textposition: O2({}, tv.textposition, {
                    values: [
                        "inside",
                        "none"
                    ],
                    dflt: "inside"
                }),
                textfont: tv.textfont,
                insidetextfont: tv.insidetextfont,
                title: {
                    text: tv.title.text,
                    font: tv.title.font,
                    position: O2({}, tv.title.position, {
                        values: [
                            "top left",
                            "top center",
                            "top right"
                        ],
                        dflt: "top center"
                    }),
                    editType: "plot"
                },
                domain: R6t({
                    name: "funnelarea",
                    trace: !0,
                    editType: "calc"
                }),
                aspectratio: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "plot"
                },
                baseratio: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: .333,
                    editType: "plot"
                }
            };
        });
        var $W = ye((Xdr, G6e)=>{
            "use strict";
            var F6t = uD().hiddenlabels;
            G6e.exports = {
                hiddenlabels: F6t,
                funnelareacolorway: {
                    valType: "colorlist",
                    editType: "calc"
                },
                extendfunnelareacolors: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc"
                }
            };
        });
        var Z6e = ye((Ydr, W6e)=>{
            "use strict";
            var j6e = Mr(), q6t = JW(), O6t = Ju().defaults, B6t = r0().handleText, N6t = S2().handleLabelsAndValues, U6t = S2().handleMarkerDefaults;
            W6e.exports = function(t, r, n, i) {
                function a(x, b) {
                    return j6e.coerce(t, r, q6t, x, b);
                }
                var o = a("labels"), s = a("values"), l = N6t(o, s), u = l.len;
                if (r._hasLabels = l.hasLabels, r._hasValues = l.hasValues, !r._hasLabels && r._hasValues && (a("label0"), a("dlabel")), !u) {
                    r.visible = !1;
                    return;
                }
                r._length = u, U6t(t, r, i, a), a("scalegroup");
                var c = a("text"), f = a("texttemplate"), h;
                if (f || (h = a("textinfo", Array.isArray(c) ? "text+percent" : "percent")), a("hovertext"), a("hovertemplate"), f || h && h !== "none") {
                    var d = a("textposition");
                    B6t(t, r, i, a, d, {
                        moduleHasSelected: !1,
                        moduleHasUnselected: !1,
                        moduleHasConstrain: !1,
                        moduleHasCliponaxis: !1,
                        moduleHasTextangle: !1,
                        moduleHasInsideanchor: !1
                    });
                } else h === "none" && a("textposition", "none");
                O6t(r, i, a);
                var v = a("title.text");
                v && (a("title.position"), j6e.coerceFont(a, "title.font", i.font)), a("aspectratio"), a("baseratio");
            };
        });
        var Y6e = ye((Kdr, X6e)=>{
            "use strict";
            var V6t = Mr(), H6t = $W();
            X6e.exports = function(t, r) {
                function n(i, a) {
                    return V6t.coerce(t, r, H6t, i, a);
                }
                n("hiddenlabels"), n("funnelareacolorway", r.colorway), n("extendfunnelareacolors");
            };
        });
        var QW = ye((Jdr, J6e)=>{
            "use strict";
            var K6e = y5();
            function G6t(e, t) {
                return K6e.calc(e, t);
            }
            function j6t(e) {
                K6e.crossTraceCalc(e, {
                    type: "funnelarea"
                });
            }
            J6e.exports = {
                calc: G6t,
                crossTraceCalc: j6t
            };
        });
        var rLe = ye(($dr, tLe)=>{
            "use strict";
            var B2 = xa(), eZ = ao(), J_ = Mr(), W6t = J_.strScale, $6e = J_.strTranslate, Q6e = Pl(), Z6t = i2(), X6t = Z6t.toMoveInsideBar, eLe = _v(), Y6t = eLe.recordMinTextSize, K6t = eLe.clearMinTextSize, J6t = u_(), q5 = dD(), $6t = q5.attachFxHandlers, Q6t = q5.determineInsideTextFont, eLt = q5.layoutAreas, tLt = q5.prerenderTitles, rLt = q5.positionTitleOutside, iLt = q5.formatSliceLabel;
            tLe.exports = function(t, r) {
                var n = t._context.staticPlot, i = t._fullLayout;
                K6t("funnelarea", i), tLt(r, t), eLt(r, i._size), J_.makeTraceGroups(i._funnelarealayer, r, "trace").each(function(a) {
                    var o = B2.select(this), s = a[0], l = s.trace;
                    aLt(a), o.each(function() {
                        var u = B2.select(this).selectAll("g.slice").data(a);
                        u.enter().append("g").classed("slice", !0), u.exit().remove(), u.each(function(f, h) {
                            if (f.hidden) {
                                B2.select(this).selectAll("path,g").remove();
                                return;
                            }
                            f.pointNumber = f.i, f.curveNumber = l.index;
                            var d = s.cx, v = s.cy, x = B2.select(this), b = x.selectAll("path.surface").data([
                                f
                            ]);
                            b.enter().append("path").classed("surface", !0).style({
                                "pointer-events": n ? "none" : "all"
                            }), x.call($6t, t, a);
                            var p = "M" + (d + f.TR[0]) + "," + (v + f.TR[1]) + tZ(f.TR, f.BR) + tZ(f.BR, f.BL) + tZ(f.BL, f.TL) + "Z";
                            b.attr("d", p), iLt(t, f, s);
                            var E = J6t.castOption(l.textposition, f.pts), k = x.selectAll("g.slicetext").data(f.text && E !== "none" ? [
                                0
                            ] : []);
                            k.enter().append("g").classed("slicetext", !0), k.exit().remove(), k.each(function() {
                                var A = J_.ensureSingle(B2.select(this), "text", "", function(F) {
                                    F.attr("data-notex", 1);
                                }), L = J_.ensureUniformFontSize(t, Q6t(l, f, i.font));
                                A.text(f.text).attr({
                                    class: "slicetext",
                                    transform: "",
                                    "text-anchor": "middle"
                                }).call(eZ.font, L).call(Q6e.convertToTspans, t);
                                var _ = eZ.bBox(A.node()), C, M, g, P = Math.min(f.BL[1], f.BR[1]) + v, T = Math.max(f.TL[1], f.TR[1]) + v;
                                M = Math.max(f.TL[0], f.BL[0]) + d, g = Math.min(f.TR[0], f.BR[0]) + d, C = X6t(M, g, P, T, _, {
                                    isHorizontal: !0,
                                    constrained: !0,
                                    angle: 0,
                                    anchor: "middle"
                                }), C.fontSize = L.size, Y6t(l.type, C, i), a[h].transform = C, J_.setTransormAndDisplay(A, C);
                            });
                        });
                        var c = B2.select(this).selectAll("g.titletext").data(l.title.text ? [
                            0
                        ] : []);
                        c.enter().append("g").classed("titletext", !0), c.exit().remove(), c.each(function() {
                            var f = J_.ensureSingle(B2.select(this), "text", "", function(v) {
                                v.attr("data-notex", 1);
                            }), h = l.title.text;
                            l._meta && (h = J_.templateString(h, l._meta)), f.text(h).attr({
                                class: "titletext",
                                transform: "",
                                "text-anchor": "middle"
                            }).call(eZ.font, l.title.font).call(Q6e.convertToTspans, t);
                            var d = rLt(s, i._size);
                            f.attr("transform", $6e(d.x, d.y) + W6t(Math.min(1, d.scale)) + $6e(d.tx, d.ty));
                        });
                    });
                });
            };
            function tZ(e, t) {
                var r = t[0] - e[0], n = t[1] - e[1];
                return "l" + r + "," + n;
            }
            function nLt(e, t) {
                return [
                    .5 * (e[0] + t[0]),
                    .5 * (e[1] + t[1])
                ];
            }
            function aLt(e) {
                if (!e.length) return;
                var t = e[0], r = t.trace, n = r.aspectratio, i = r.baseratio;
                i > .999 && (i = .999);
                var a = Math.pow(i, 2), o = t.vTotal, s = o * a / (1 - a), l = o, u = s / o;
                function c() {
                    var q = Math.sqrt(u);
                    return {
                        x: q,
                        y: -q
                    };
                }
                function f() {
                    var q = c();
                    return [
                        q.x,
                        q.y
                    ];
                }
                var h, d = [];
                d.push(f());
                var v, x;
                for(v = e.length - 1; v > -1; v--)if (x = e[v], !x.hidden) {
                    var b = x.v / l;
                    u += b, d.push(f());
                }
                var p = 1 / 0, E = -1 / 0;
                for(v = 0; v < d.length; v++)h = d[v], p = Math.min(p, h[1]), E = Math.max(E, h[1]);
                for(v = 0; v < d.length; v++)d[v][1] -= (E + p) / 2;
                var k = d[d.length - 1][0], A = t.r, L = (E - p) / 2, _ = A / k, C = A / L * n;
                for(t.r = C * L, v = 0; v < d.length; v++)d[v][0] *= _, d[v][1] *= C;
                h = d[0];
                var M = [
                    -h[0],
                    h[1]
                ], g = [
                    h[0],
                    h[1]
                ], P = 0;
                for(v = e.length - 1; v > -1; v--)if (x = e[v], !x.hidden) {
                    P += 1;
                    var T = d[P][0], F = d[P][1];
                    x.TL = [
                        -T,
                        F
                    ], x.TR = [
                        T,
                        F
                    ], x.BL = M, x.BR = g, x.pxmid = nLt(x.TR, x.BR), M = x.TL, g = x.TR;
                }
            }
        });
        var aLe = ye((Qdr, nLe)=>{
            "use strict";
            var iLe = xa(), oLt = z3(), sLt = _v().resizeText;
            nLe.exports = function(t) {
                var r = t._fullLayout._funnelarealayer.selectAll(".trace");
                sLt(t, r, "funnelarea"), r.each(function(n) {
                    var i = n[0], a = i.trace, o = iLe.select(this);
                    o.style({
                        opacity: a.opacity
                    }), o.selectAll("path.surface").each(function(s) {
                        iLe.select(this).call(oLt, s, a, t);
                    });
                });
            };
        });
        var sLe = ye((evr, oLe)=>{
            "use strict";
            oLe.exports = {
                moduleType: "trace",
                name: "funnelarea",
                basePlotModule: V6e(),
                categories: [
                    "pie-like",
                    "funnelarea",
                    "showLegend"
                ],
                attributes: JW(),
                layoutAttributes: $W(),
                supplyDefaults: Z6e(),
                supplyLayoutDefaults: Y6e(),
                calc: QW().calc,
                crossTraceCalc: QW().crossTraceCalc,
                plot: rLe(),
                style: aLe(),
                styleOne: z3(),
                meta: {}
            };
        });
        var uLe = ye((tvr, lLe)=>{
            "use strict";
            lLe.exports = sLe();
        });
        var Rd = ye((rvr, cLe)=>{
            (function() {
                var e = {
                    1964: function(i, a, o) {
                        i.exports = {
                            alpha_shape: o(3502),
                            convex_hull: o(7352),
                            delaunay_triangulate: o(7642),
                            gl_cone3d: o(6405),
                            gl_error3d: o(9165),
                            gl_line3d: o(5714),
                            gl_mesh3d: o(7201),
                            gl_plot3d: o(4100),
                            gl_scatter3d: o(8418),
                            gl_streamtube3d: o(7815),
                            gl_surface3d: o(9499),
                            ndarray: o(9618),
                            ndarray_linear_interpolate: o(4317)
                        };
                    },
                    4793: function(i, a, o) {
                        "use strict";
                        var s;
                        function l(Le, xe) {
                            if (!(Le instanceof xe)) throw new TypeError("Cannot call a class as a function");
                        }
                        function u(Le, xe) {
                            for(var Se = 0; Se < xe.length; Se++){
                                var lt = xe[Se];
                                lt.enumerable = lt.enumerable || !1, lt.configurable = !0, "value" in lt && (lt.writable = !0), Object.defineProperty(Le, f(lt.key), lt);
                            }
                        }
                        function c(Le, xe, Se) {
                            return xe && u(Le.prototype, xe), Se && u(Le, Se), Object.defineProperty(Le, "prototype", {
                                writable: !1
                            }), Le;
                        }
                        function f(Le) {
                            var xe = h(Le, "string");
                            return A(xe) == "symbol" ? xe : xe + "";
                        }
                        function h(Le, xe) {
                            if (A(Le) != "object" || !Le) return Le;
                            var Se = Le[Symbol.toPrimitive];
                            if (Se !== void 0) {
                                var lt = Se.call(Le, xe || "default");
                                if (A(lt) != "object") return lt;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return (xe === "string" ? String : Number)(Le);
                        }
                        function d(Le, xe, Se) {
                            return xe = p(xe), v(Le, b() ? Reflect.construct(xe, Se || [], p(Le).constructor) : xe.apply(Le, Se));
                        }
                        function v(Le, xe) {
                            if (xe && (A(xe) == "object" || typeof xe == "function")) return xe;
                            if (xe !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
                            return x(Le);
                        }
                        function x(Le) {
                            if (Le === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                            return Le;
                        }
                        function b() {
                            try {
                                var Le = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
                            } catch (xe) {}
                            return (b = function() {
                                return !!Le;
                            })();
                        }
                        function p(Le) {
                            return p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(xe) {
                                return xe.__proto__ || Object.getPrototypeOf(xe);
                            }, p(Le);
                        }
                        function E(Le, xe) {
                            if (typeof xe != "function" && xe !== null) throw new TypeError("Super expression must either be null or a function");
                            Le.prototype = Object.create(xe && xe.prototype, {
                                constructor: {
                                    value: Le,
                                    writable: !0,
                                    configurable: !0
                                }
                            }), Object.defineProperty(Le, "prototype", {
                                writable: !1
                            }), xe && k(Le, xe);
                        }
                        function k(Le, xe) {
                            return k = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(Se, lt) {
                                return Se.__proto__ = lt, Se;
                            }, k(Le, xe);
                        }
                        function A(Le) {
                            "@babel/helpers - typeof";
                            return A = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(xe) {
                                return typeof xe;
                            } : function(xe) {
                                return xe && typeof Symbol == "function" && xe.constructor === Symbol && xe !== Symbol.prototype ? "symbol" : typeof xe;
                            }, A(Le);
                        }
                        var L = o(7507), _ = o(3778), C = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
                        a.hp = T, s = _e, a.IS = 50;
                        var M = 2147483647;
                        s = M, T.TYPED_ARRAY_SUPPORT = g(), !T.TYPED_ARRAY_SUPPORT && typeof console != "undefined" && typeof console.error == "function" && console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
                        function g() {
                            try {
                                var Le = new Uint8Array(1), xe = {
                                    foo: function() {
                                        return 42;
                                    }
                                };
                                return Object.setPrototypeOf(xe, Uint8Array.prototype), Object.setPrototypeOf(Le, xe), Le.foo() === 42;
                            } catch (Se) {
                                return !1;
                            }
                        }
                        Object.defineProperty(T.prototype, "parent", {
                            enumerable: !0,
                            get: function() {
                                if (T.isBuffer(this)) return this.buffer;
                            }
                        }), Object.defineProperty(T.prototype, "offset", {
                            enumerable: !0,
                            get: function() {
                                if (T.isBuffer(this)) return this.byteOffset;
                            }
                        });
                        function P(Le) {
                            if (Le > M) throw new RangeError('The value "' + Le + '" is invalid for option "size"');
                            var xe = new Uint8Array(Le);
                            return Object.setPrototypeOf(xe, T.prototype), xe;
                        }
                        function T(Le, xe, Se) {
                            if (typeof Le == "number") {
                                if (typeof xe == "string") throw new TypeError('The "string" argument must be of type string. Received type number');
                                return H(Le);
                            }
                            return F(Le, xe, Se);
                        }
                        T.poolSize = 8192;
                        function F(Le, xe, Se) {
                            if (typeof Le == "string") return X(Le, xe);
                            if (ArrayBuffer.isView(Le)) return N(Le);
                            if (Le == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + A(Le));
                            if (Ne(Le, ArrayBuffer) || Le && Ne(Le.buffer, ArrayBuffer) || typeof SharedArrayBuffer != "undefined" && (Ne(Le, SharedArrayBuffer) || Le && Ne(Le.buffer, SharedArrayBuffer))) return W(Le, xe, Se);
                            if (typeof Le == "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
                            var lt = Le.valueOf && Le.valueOf();
                            if (lt != null && lt !== Le) return T.from(lt, xe, Se);
                            var Gt = re(Le);
                            if (Gt) return Gt;
                            if (typeof Symbol != "undefined" && Symbol.toPrimitive != null && typeof Le[Symbol.toPrimitive] == "function") return T.from(Le[Symbol.toPrimitive]("string"), xe, Se);
                            throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + A(Le));
                        }
                        T.from = function(Le, xe, Se) {
                            return F(Le, xe, Se);
                        }, Object.setPrototypeOf(T.prototype, Uint8Array.prototype), Object.setPrototypeOf(T, Uint8Array);
                        function q(Le) {
                            if (typeof Le != "number") throw new TypeError('"size" argument must be of type number');
                            if (Le < 0) throw new RangeError('The value "' + Le + '" is invalid for option "size"');
                        }
                        function V(Le, xe, Se) {
                            return q(Le), Le <= 0 ? P(Le) : xe !== void 0 ? typeof Se == "string" ? P(Le).fill(xe, Se) : P(Le).fill(xe) : P(Le);
                        }
                        T.alloc = function(Le, xe, Se) {
                            return V(Le, xe, Se);
                        };
                        function H(Le) {
                            return q(Le), P(Le < 0 ? 0 : ae(Le) | 0);
                        }
                        T.allocUnsafe = function(Le) {
                            return H(Le);
                        }, T.allocUnsafeSlow = function(Le) {
                            return H(Le);
                        };
                        function X(Le, xe) {
                            if ((typeof xe != "string" || xe === "") && (xe = "utf8"), !T.isEncoding(xe)) throw new TypeError("Unknown encoding: " + xe);
                            var Se = Me(Le, xe) | 0, lt = P(Se), Gt = lt.write(Le, xe);
                            return Gt !== Se && (lt = lt.slice(0, Gt)), lt;
                        }
                        function G(Le) {
                            for(var xe = Le.length < 0 ? 0 : ae(Le.length) | 0, Se = P(xe), lt = 0; lt < xe; lt += 1)Se[lt] = Le[lt] & 255;
                            return Se;
                        }
                        function N(Le) {
                            if (Ne(Le, Uint8Array)) {
                                var xe = new Uint8Array(Le);
                                return W(xe.buffer, xe.byteOffset, xe.byteLength);
                            }
                            return G(Le);
                        }
                        function W(Le, xe, Se) {
                            if (xe < 0 || Le.byteLength < xe) throw new RangeError('"offset" is outside of buffer bounds');
                            if (Le.byteLength < xe + (Se || 0)) throw new RangeError('"length" is outside of buffer bounds');
                            var lt;
                            return xe === void 0 && Se === void 0 ? lt = new Uint8Array(Le) : Se === void 0 ? lt = new Uint8Array(Le, xe) : lt = new Uint8Array(Le, xe, Se), Object.setPrototypeOf(lt, T.prototype), lt;
                        }
                        function re(Le) {
                            if (T.isBuffer(Le)) {
                                var xe = ae(Le.length) | 0, Se = P(xe);
                                return Se.length === 0 || Le.copy(Se, 0, 0, xe), Se;
                            }
                            if (Le.length !== void 0) return typeof Le.length != "number" || Ye(Le.length) ? P(0) : G(Le);
                            if (Le.type === "Buffer" && Array.isArray(Le.data)) return G(Le.data);
                        }
                        function ae(Le) {
                            if (Le >= M) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + M.toString(16) + " bytes");
                            return Le | 0;
                        }
                        function _e(Le) {
                            return +Le != Le && (Le = 0), T.alloc(+Le);
                        }
                        T.isBuffer = function(xe) {
                            return xe != null && xe._isBuffer === !0 && xe !== T.prototype;
                        }, T.compare = function(xe, Se) {
                            if (Ne(xe, Uint8Array) && (xe = T.from(xe, xe.offset, xe.byteLength)), Ne(Se, Uint8Array) && (Se = T.from(Se, Se.offset, Se.byteLength)), !T.isBuffer(xe) || !T.isBuffer(Se)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
                            if (xe === Se) return 0;
                            for(var lt = xe.length, Gt = Se.length, Vt = 0, ar = Math.min(lt, Gt); Vt < ar; ++Vt)if (xe[Vt] !== Se[Vt]) {
                                lt = xe[Vt], Gt = Se[Vt];
                                break;
                            }
                            return lt < Gt ? -1 : Gt < lt ? 1 : 0;
                        }, T.isEncoding = function(xe) {
                            switch(String(xe).toLowerCase()){
                                case "hex":
                                case "utf8":
                                case "utf-8":
                                case "ascii":
                                case "latin1":
                                case "binary":
                                case "base64":
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return !0;
                                default:
                                    return !1;
                            }
                        }, T.concat = function(xe, Se) {
                            if (!Array.isArray(xe)) throw new TypeError('"list" argument must be an Array of Buffers');
                            if (xe.length === 0) return T.alloc(0);
                            var lt;
                            if (Se === void 0) for(Se = 0, lt = 0; lt < xe.length; ++lt)Se += xe[lt].length;
                            var Gt = T.allocUnsafe(Se), Vt = 0;
                            for(lt = 0; lt < xe.length; ++lt){
                                var ar = xe[lt];
                                if (Ne(ar, Uint8Array)) Vt + ar.length > Gt.length ? (T.isBuffer(ar) || (ar = T.from(ar)), ar.copy(Gt, Vt)) : Uint8Array.prototype.set.call(Gt, ar, Vt);
                                else if (T.isBuffer(ar)) ar.copy(Gt, Vt);
                                else throw new TypeError('"list" argument must be an Array of Buffers');
                                Vt += ar.length;
                            }
                            return Gt;
                        };
                        function Me(Le, xe) {
                            if (T.isBuffer(Le)) return Le.length;
                            if (ArrayBuffer.isView(Le) || Ne(Le, ArrayBuffer)) return Le.byteLength;
                            if (typeof Le != "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + A(Le));
                            var Se = Le.length, lt = arguments.length > 2 && arguments[2] === !0;
                            if (!lt && Se === 0) return 0;
                            for(var Gt = !1;;)switch(xe){
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return Se;
                                case "utf8":
                                case "utf-8":
                                    return _r(Le).length;
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return Se * 2;
                                case "hex":
                                    return Se >>> 1;
                                case "base64":
                                    return Nr(Le).length;
                                default:
                                    if (Gt) return lt ? -1 : _r(Le).length;
                                    xe = ("" + xe).toLowerCase(), Gt = !0;
                            }
                        }
                        T.byteLength = Me;
                        function ke(Le, xe, Se) {
                            var lt = !1;
                            if ((xe === void 0 || xe < 0) && (xe = 0), xe > this.length || ((Se === void 0 || Se > this.length) && (Se = this.length), Se <= 0) || (Se >>>= 0, xe >>>= 0, Se <= xe)) return "";
                            for(Le || (Le = "utf8");;)switch(Le){
                                case "hex":
                                    return rt(this, xe, Se);
                                case "utf8":
                                case "utf-8":
                                    return ce(this, xe, Se);
                                case "ascii":
                                    return ct(this, xe, Se);
                                case "latin1":
                                case "binary":
                                    return qt(this, xe, Se);
                                case "base64":
                                    return Re(this, xe, Se);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return ot(this, xe, Se);
                                default:
                                    if (lt) throw new TypeError("Unknown encoding: " + Le);
                                    Le = (Le + "").toLowerCase(), lt = !0;
                            }
                        }
                        T.prototype._isBuffer = !0;
                        function ge(Le, xe, Se) {
                            var lt = Le[xe];
                            Le[xe] = Le[Se], Le[Se] = lt;
                        }
                        T.prototype.swap16 = function() {
                            var xe = this.length;
                            if (xe % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
                            for(var Se = 0; Se < xe; Se += 2)ge(this, Se, Se + 1);
                            return this;
                        }, T.prototype.swap32 = function() {
                            var xe = this.length;
                            if (xe % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
                            for(var Se = 0; Se < xe; Se += 4)ge(this, Se, Se + 3), ge(this, Se + 1, Se + 2);
                            return this;
                        }, T.prototype.swap64 = function() {
                            var xe = this.length;
                            if (xe % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
                            for(var Se = 0; Se < xe; Se += 8)ge(this, Se, Se + 7), ge(this, Se + 1, Se + 6), ge(this, Se + 2, Se + 5), ge(this, Se + 3, Se + 4);
                            return this;
                        }, T.prototype.toString = function() {
                            var xe = this.length;
                            return xe === 0 ? "" : arguments.length === 0 ? ce(this, 0, xe) : ke.apply(this, arguments);
                        }, T.prototype.toLocaleString = T.prototype.toString, T.prototype.equals = function(xe) {
                            if (!T.isBuffer(xe)) throw new TypeError("Argument must be a Buffer");
                            return this === xe ? !0 : T.compare(this, xe) === 0;
                        }, T.prototype.inspect = function() {
                            var xe = "", Se = a.IS;
                            return xe = this.toString("hex", 0, Se).replace(/(.{2})/g, "$1 ").trim(), this.length > Se && (xe += " ... "), "<Buffer " + xe + ">";
                        }, C && (T.prototype[C] = T.prototype.inspect), T.prototype.compare = function(xe, Se, lt, Gt, Vt) {
                            if (Ne(xe, Uint8Array) && (xe = T.from(xe, xe.offset, xe.byteLength)), !T.isBuffer(xe)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + A(xe));
                            if (Se === void 0 && (Se = 0), lt === void 0 && (lt = xe ? xe.length : 0), Gt === void 0 && (Gt = 0), Vt === void 0 && (Vt = this.length), Se < 0 || lt > xe.length || Gt < 0 || Vt > this.length) throw new RangeError("out of range index");
                            if (Gt >= Vt && Se >= lt) return 0;
                            if (Gt >= Vt) return -1;
                            if (Se >= lt) return 1;
                            if (Se >>>= 0, lt >>>= 0, Gt >>>= 0, Vt >>>= 0, this === xe) return 0;
                            for(var ar = Vt - Gt, Qr = lt - Se, ai = Math.min(ar, Qr), jr = this.slice(Gt, Vt), ri = xe.slice(Se, lt), bi = 0; bi < ai; ++bi)if (jr[bi] !== ri[bi]) {
                                ar = jr[bi], Qr = ri[bi];
                                break;
                            }
                            return ar < Qr ? -1 : Qr < ar ? 1 : 0;
                        };
                        function ie(Le, xe, Se, lt, Gt) {
                            if (Le.length === 0) return -1;
                            if (typeof Se == "string" ? (lt = Se, Se = 0) : Se > 2147483647 ? Se = 2147483647 : Se < -2147483648 && (Se = -2147483648), Se = +Se, Ye(Se) && (Se = Gt ? 0 : Le.length - 1), Se < 0 && (Se = Le.length + Se), Se >= Le.length) {
                                if (Gt) return -1;
                                Se = Le.length - 1;
                            } else if (Se < 0) {
                                if (Gt) Se = 0;
                                else return -1;
                            }
                            if (typeof xe == "string" && (xe = T.from(xe, lt)), T.isBuffer(xe)) return xe.length === 0 ? -1 : Te(Le, xe, Se, lt, Gt);
                            if (typeof xe == "number") return xe = xe & 255, typeof Uint8Array.prototype.indexOf == "function" ? Gt ? Uint8Array.prototype.indexOf.call(Le, xe, Se) : Uint8Array.prototype.lastIndexOf.call(Le, xe, Se) : Te(Le, [
                                xe
                            ], Se, lt, Gt);
                            throw new TypeError("val must be string, number or Buffer");
                        }
                        function Te(Le, xe, Se, lt, Gt) {
                            var Vt = 1, ar = Le.length, Qr = xe.length;
                            if (lt !== void 0 && (lt = String(lt).toLowerCase(), lt === "ucs2" || lt === "ucs-2" || lt === "utf16le" || lt === "utf-16le")) {
                                if (Le.length < 2 || xe.length < 2) return -1;
                                Vt = 2, ar /= 2, Qr /= 2, Se /= 2;
                            }
                            function ai(Wi, Ni) {
                                return Vt === 1 ? Wi[Ni] : Wi.readUInt16BE(Ni * Vt);
                            }
                            var jr;
                            if (Gt) {
                                var ri = -1;
                                for(jr = Se; jr < ar; jr++)if (ai(Le, jr) === ai(xe, ri === -1 ? 0 : jr - ri)) {
                                    if (ri === -1 && (ri = jr), jr - ri + 1 === Qr) return ri * Vt;
                                } else ri !== -1 && (jr -= jr - ri), ri = -1;
                            } else for(Se + Qr > ar && (Se = ar - Qr), jr = Se; jr >= 0; jr--){
                                for(var bi = !0, nn = 0; nn < Qr; nn++)if (ai(Le, jr + nn) !== ai(xe, nn)) {
                                    bi = !1;
                                    break;
                                }
                                if (bi) return jr;
                            }
                            return -1;
                        }
                        T.prototype.includes = function(xe, Se, lt) {
                            return this.indexOf(xe, Se, lt) !== -1;
                        }, T.prototype.indexOf = function(xe, Se, lt) {
                            return ie(this, xe, Se, lt, !0);
                        }, T.prototype.lastIndexOf = function(xe, Se, lt) {
                            return ie(this, xe, Se, lt, !1);
                        };
                        function Ee(Le, xe, Se, lt) {
                            Se = Number(Se) || 0;
                            var Gt = Le.length - Se;
                            lt ? (lt = Number(lt), lt > Gt && (lt = Gt)) : lt = Gt;
                            var Vt = xe.length;
                            lt > Vt / 2 && (lt = Vt / 2);
                            var ar;
                            for(ar = 0; ar < lt; ++ar){
                                var Qr = parseInt(xe.substr(ar * 2, 2), 16);
                                if (Ye(Qr)) return ar;
                                Le[Se + ar] = Qr;
                            }
                            return ar;
                        }
                        function Ae(Le, xe, Se, lt) {
                            return ut(_r(xe, Le.length - Se), Le, Se, lt);
                        }
                        function ze(Le, xe, Se, lt) {
                            return ut(Br(xe), Le, Se, lt);
                        }
                        function Ce(Le, xe, Se, lt) {
                            return ut(Nr(xe), Le, Se, lt);
                        }
                        function me(Le, xe, Se, lt) {
                            return ut(Or(xe, Le.length - Se), Le, Se, lt);
                        }
                        T.prototype.write = function(xe, Se, lt, Gt) {
                            if (Se === void 0) Gt = "utf8", lt = this.length, Se = 0;
                            else if (lt === void 0 && typeof Se == "string") Gt = Se, lt = this.length, Se = 0;
                            else if (isFinite(Se)) Se = Se >>> 0, isFinite(lt) ? (lt = lt >>> 0, Gt === void 0 && (Gt = "utf8")) : (Gt = lt, lt = void 0);
                            else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
                            var Vt = this.length - Se;
                            if ((lt === void 0 || lt > Vt) && (lt = Vt), xe.length > 0 && (lt < 0 || Se < 0) || Se > this.length) throw new RangeError("Attempt to write outside buffer bounds");
                            Gt || (Gt = "utf8");
                            for(var ar = !1;;)switch(Gt){
                                case "hex":
                                    return Ee(this, xe, Se, lt);
                                case "utf8":
                                case "utf-8":
                                    return Ae(this, xe, Se, lt);
                                case "ascii":
                                case "latin1":
                                case "binary":
                                    return ze(this, xe, Se, lt);
                                case "base64":
                                    return Ce(this, xe, Se, lt);
                                case "ucs2":
                                case "ucs-2":
                                case "utf16le":
                                case "utf-16le":
                                    return me(this, xe, Se, lt);
                                default:
                                    if (ar) throw new TypeError("Unknown encoding: " + Gt);
                                    Gt = ("" + Gt).toLowerCase(), ar = !0;
                            }
                        }, T.prototype.toJSON = function() {
                            return {
                                type: "Buffer",
                                data: Array.prototype.slice.call(this._arr || this, 0)
                            };
                        };
                        function Re(Le, xe, Se) {
                            return xe === 0 && Se === Le.length ? L.fromByteArray(Le) : L.fromByteArray(Le.slice(xe, Se));
                        }
                        function ce(Le, xe, Se) {
                            Se = Math.min(Le.length, Se);
                            for(var lt = [], Gt = xe; Gt < Se;){
                                var Vt = Le[Gt], ar = null, Qr = Vt > 239 ? 4 : Vt > 223 ? 3 : Vt > 191 ? 2 : 1;
                                if (Gt + Qr <= Se) {
                                    var ai = void 0, jr = void 0, ri = void 0, bi = void 0;
                                    switch(Qr){
                                        case 1:
                                            Vt < 128 && (ar = Vt);
                                            break;
                                        case 2:
                                            ai = Le[Gt + 1], (ai & 192) === 128 && (bi = (Vt & 31) << 6 | ai & 63, bi > 127 && (ar = bi));
                                            break;
                                        case 3:
                                            ai = Le[Gt + 1], jr = Le[Gt + 2], (ai & 192) === 128 && (jr & 192) === 128 && (bi = (Vt & 15) << 12 | (ai & 63) << 6 | jr & 63, bi > 2047 && (bi < 55296 || bi > 57343) && (ar = bi));
                                            break;
                                        case 4:
                                            ai = Le[Gt + 1], jr = Le[Gt + 2], ri = Le[Gt + 3], (ai & 192) === 128 && (jr & 192) === 128 && (ri & 192) === 128 && (bi = (Vt & 15) << 18 | (ai & 63) << 12 | (jr & 63) << 6 | ri & 63, bi > 65535 && bi < 1114112 && (ar = bi));
                                    }
                                }
                                ar === null ? (ar = 65533, Qr = 1) : ar > 65535 && (ar -= 65536, lt.push(ar >>> 10 & 1023 | 55296), ar = 56320 | ar & 1023), lt.push(ar), Gt += Qr;
                            }
                            return nt(lt);
                        }
                        var Ge = 4096;
                        function nt(Le) {
                            var xe = Le.length;
                            if (xe <= Ge) return String.fromCharCode.apply(String, Le);
                            for(var Se = "", lt = 0; lt < xe;)Se += String.fromCharCode.apply(String, Le.slice(lt, lt += Ge));
                            return Se;
                        }
                        function ct(Le, xe, Se) {
                            var lt = "";
                            Se = Math.min(Le.length, Se);
                            for(var Gt = xe; Gt < Se; ++Gt)lt += String.fromCharCode(Le[Gt] & 127);
                            return lt;
                        }
                        function qt(Le, xe, Se) {
                            var lt = "";
                            Se = Math.min(Le.length, Se);
                            for(var Gt = xe; Gt < Se; ++Gt)lt += String.fromCharCode(Le[Gt]);
                            return lt;
                        }
                        function rt(Le, xe, Se) {
                            var lt = Le.length;
                            (!xe || xe < 0) && (xe = 0), (!Se || Se < 0 || Se > lt) && (Se = lt);
                            for(var Gt = "", Vt = xe; Vt < Se; ++Vt)Gt += Ve[Le[Vt]];
                            return Gt;
                        }
                        function ot(Le, xe, Se) {
                            for(var lt = Le.slice(xe, Se), Gt = "", Vt = 0; Vt < lt.length - 1; Vt += 2)Gt += String.fromCharCode(lt[Vt] + lt[Vt + 1] * 256);
                            return Gt;
                        }
                        T.prototype.slice = function(xe, Se) {
                            var lt = this.length;
                            xe = ~~xe, Se = Se === void 0 ? lt : ~~Se, xe < 0 ? (xe += lt, xe < 0 && (xe = 0)) : xe > lt && (xe = lt), Se < 0 ? (Se += lt, Se < 0 && (Se = 0)) : Se > lt && (Se = lt), Se < xe && (Se = xe);
                            var Gt = this.subarray(xe, Se);
                            return Object.setPrototypeOf(Gt, T.prototype), Gt;
                        };
                        function Rt(Le, xe, Se) {
                            if (Le % 1 !== 0 || Le < 0) throw new RangeError("offset is not uint");
                            if (Le + xe > Se) throw new RangeError("Trying to access beyond buffer length");
                        }
                        T.prototype.readUintLE = T.prototype.readUIntLE = function(xe, Se, lt) {
                            xe = xe >>> 0, Se = Se >>> 0, lt || Rt(xe, Se, this.length);
                            for(var Gt = this[xe], Vt = 1, ar = 0; ++ar < Se && (Vt *= 256);)Gt += this[xe + ar] * Vt;
                            return Gt;
                        }, T.prototype.readUintBE = T.prototype.readUIntBE = function(xe, Se, lt) {
                            xe = xe >>> 0, Se = Se >>> 0, lt || Rt(xe, Se, this.length);
                            for(var Gt = this[xe + --Se], Vt = 1; Se > 0 && (Vt *= 256);)Gt += this[xe + --Se] * Vt;
                            return Gt;
                        }, T.prototype.readUint8 = T.prototype.readUInt8 = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 1, this.length), this[xe];
                        }, T.prototype.readUint16LE = T.prototype.readUInt16LE = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 2, this.length), this[xe] | this[xe + 1] << 8;
                        }, T.prototype.readUint16BE = T.prototype.readUInt16BE = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 2, this.length), this[xe] << 8 | this[xe + 1];
                        }, T.prototype.readUint32LE = T.prototype.readUInt32LE = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 4, this.length), (this[xe] | this[xe + 1] << 8 | this[xe + 2] << 16) + this[xe + 3] * 16777216;
                        }, T.prototype.readUint32BE = T.prototype.readUInt32BE = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 4, this.length), this[xe] * 16777216 + (this[xe + 1] << 16 | this[xe + 2] << 8 | this[xe + 3]);
                        }, T.prototype.readBigUInt64LE = Xe(function(xe) {
                            xe = xe >>> 0, dt(xe, "offset");
                            var Se = this[xe], lt = this[xe + 7];
                            (Se === void 0 || lt === void 0) && Ht(xe, this.length - 8);
                            var Gt = Se + this[++xe] * Math.pow(2, 8) + this[++xe] * Math.pow(2, 16) + this[++xe] * Math.pow(2, 24), Vt = this[++xe] + this[++xe] * Math.pow(2, 8) + this[++xe] * Math.pow(2, 16) + lt * Math.pow(2, 24);
                            return BigInt(Gt) + (BigInt(Vt) << BigInt(32));
                        }), T.prototype.readBigUInt64BE = Xe(function(xe) {
                            xe = xe >>> 0, dt(xe, "offset");
                            var Se = this[xe], lt = this[xe + 7];
                            (Se === void 0 || lt === void 0) && Ht(xe, this.length - 8);
                            var Gt = Se * Math.pow(2, 24) + this[++xe] * Math.pow(2, 16) + this[++xe] * Math.pow(2, 8) + this[++xe], Vt = this[++xe] * Math.pow(2, 24) + this[++xe] * Math.pow(2, 16) + this[++xe] * Math.pow(2, 8) + lt;
                            return (BigInt(Gt) << BigInt(32)) + BigInt(Vt);
                        }), T.prototype.readIntLE = function(xe, Se, lt) {
                            xe = xe >>> 0, Se = Se >>> 0, lt || Rt(xe, Se, this.length);
                            for(var Gt = this[xe], Vt = 1, ar = 0; ++ar < Se && (Vt *= 256);)Gt += this[xe + ar] * Vt;
                            return Vt *= 128, Gt >= Vt && (Gt -= Math.pow(2, 8 * Se)), Gt;
                        }, T.prototype.readIntBE = function(xe, Se, lt) {
                            xe = xe >>> 0, Se = Se >>> 0, lt || Rt(xe, Se, this.length);
                            for(var Gt = Se, Vt = 1, ar = this[xe + --Gt]; Gt > 0 && (Vt *= 256);)ar += this[xe + --Gt] * Vt;
                            return Vt *= 128, ar >= Vt && (ar -= Math.pow(2, 8 * Se)), ar;
                        }, T.prototype.readInt8 = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 1, this.length), this[xe] & 128 ? (255 - this[xe] + 1) * -1 : this[xe];
                        }, T.prototype.readInt16LE = function(xe, Se) {
                            xe = xe >>> 0, Se || Rt(xe, 2, this.length);
                            var lt = this[xe] | this[xe + 1] << 8;
                            return lt & 32768 ? lt | 4294901760 : lt;
                        }, T.prototype.readInt16BE = function(xe, Se) {
                            xe = xe >>> 0, Se || Rt(xe, 2, this.length);
                            var lt = this[xe + 1] | this[xe] << 8;
                            return lt & 32768 ? lt | 4294901760 : lt;
                        }, T.prototype.readInt32LE = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 4, this.length), this[xe] | this[xe + 1] << 8 | this[xe + 2] << 16 | this[xe + 3] << 24;
                        }, T.prototype.readInt32BE = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 4, this.length), this[xe] << 24 | this[xe + 1] << 16 | this[xe + 2] << 8 | this[xe + 3];
                        }, T.prototype.readBigInt64LE = Xe(function(xe) {
                            xe = xe >>> 0, dt(xe, "offset");
                            var Se = this[xe], lt = this[xe + 7];
                            (Se === void 0 || lt === void 0) && Ht(xe, this.length - 8);
                            var Gt = this[xe + 4] + this[xe + 5] * Math.pow(2, 8) + this[xe + 6] * Math.pow(2, 16) + (lt << 24);
                            return (BigInt(Gt) << BigInt(32)) + BigInt(Se + this[++xe] * Math.pow(2, 8) + this[++xe] * Math.pow(2, 16) + this[++xe] * Math.pow(2, 24));
                        }), T.prototype.readBigInt64BE = Xe(function(xe) {
                            xe = xe >>> 0, dt(xe, "offset");
                            var Se = this[xe], lt = this[xe + 7];
                            (Se === void 0 || lt === void 0) && Ht(xe, this.length - 8);
                            var Gt = (Se << 24) + this[++xe] * Math.pow(2, 16) + this[++xe] * Math.pow(2, 8) + this[++xe];
                            return (BigInt(Gt) << BigInt(32)) + BigInt(this[++xe] * Math.pow(2, 24) + this[++xe] * Math.pow(2, 16) + this[++xe] * Math.pow(2, 8) + lt);
                        }), T.prototype.readFloatLE = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 4, this.length), _.read(this, xe, !0, 23, 4);
                        }, T.prototype.readFloatBE = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 4, this.length), _.read(this, xe, !1, 23, 4);
                        }, T.prototype.readDoubleLE = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 8, this.length), _.read(this, xe, !0, 52, 8);
                        }, T.prototype.readDoubleBE = function(xe, Se) {
                            return xe = xe >>> 0, Se || Rt(xe, 8, this.length), _.read(this, xe, !1, 52, 8);
                        };
                        function kt(Le, xe, Se, lt, Gt, Vt) {
                            if (!T.isBuffer(Le)) throw new TypeError('"buffer" argument must be a Buffer instance');
                            if (xe > Gt || xe < Vt) throw new RangeError('"value" argument is out of bounds');
                            if (Se + lt > Le.length) throw new RangeError("Index out of range");
                        }
                        T.prototype.writeUintLE = T.prototype.writeUIntLE = function(xe, Se, lt, Gt) {
                            if (xe = +xe, Se = Se >>> 0, lt = lt >>> 0, !Gt) {
                                var Vt = Math.pow(2, 8 * lt) - 1;
                                kt(this, xe, Se, lt, Vt, 0);
                            }
                            var ar = 1, Qr = 0;
                            for(this[Se] = xe & 255; ++Qr < lt && (ar *= 256);)this[Se + Qr] = xe / ar & 255;
                            return Se + lt;
                        }, T.prototype.writeUintBE = T.prototype.writeUIntBE = function(xe, Se, lt, Gt) {
                            if (xe = +xe, Se = Se >>> 0, lt = lt >>> 0, !Gt) {
                                var Vt = Math.pow(2, 8 * lt) - 1;
                                kt(this, xe, Se, lt, Vt, 0);
                            }
                            var ar = lt - 1, Qr = 1;
                            for(this[Se + ar] = xe & 255; --ar >= 0 && (Qr *= 256);)this[Se + ar] = xe / Qr & 255;
                            return Se + lt;
                        }, T.prototype.writeUint8 = T.prototype.writeUInt8 = function(xe, Se, lt) {
                            return xe = +xe, Se = Se >>> 0, lt || kt(this, xe, Se, 1, 255, 0), this[Se] = xe & 255, Se + 1;
                        }, T.prototype.writeUint16LE = T.prototype.writeUInt16LE = function(xe, Se, lt) {
                            return xe = +xe, Se = Se >>> 0, lt || kt(this, xe, Se, 2, 65535, 0), this[Se] = xe & 255, this[Se + 1] = xe >>> 8, Se + 2;
                        }, T.prototype.writeUint16BE = T.prototype.writeUInt16BE = function(xe, Se, lt) {
                            return xe = +xe, Se = Se >>> 0, lt || kt(this, xe, Se, 2, 65535, 0), this[Se] = xe >>> 8, this[Se + 1] = xe & 255, Se + 2;
                        }, T.prototype.writeUint32LE = T.prototype.writeUInt32LE = function(xe, Se, lt) {
                            return xe = +xe, Se = Se >>> 0, lt || kt(this, xe, Se, 4, 4294967295, 0), this[Se + 3] = xe >>> 24, this[Se + 2] = xe >>> 16, this[Se + 1] = xe >>> 8, this[Se] = xe & 255, Se + 4;
                        }, T.prototype.writeUint32BE = T.prototype.writeUInt32BE = function(xe, Se, lt) {
                            return xe = +xe, Se = Se >>> 0, lt || kt(this, xe, Se, 4, 4294967295, 0), this[Se] = xe >>> 24, this[Se + 1] = xe >>> 16, this[Se + 2] = xe >>> 8, this[Se + 3] = xe & 255, Se + 4;
                        };
                        function Ct(Le, xe, Se, lt, Gt) {
                            Et(xe, lt, Gt, Le, Se, 7);
                            var Vt = Number(xe & BigInt(4294967295));
                            Le[Se++] = Vt, Vt = Vt >> 8, Le[Se++] = Vt, Vt = Vt >> 8, Le[Se++] = Vt, Vt = Vt >> 8, Le[Se++] = Vt;
                            var ar = Number(xe >> BigInt(32) & BigInt(4294967295));
                            return Le[Se++] = ar, ar = ar >> 8, Le[Se++] = ar, ar = ar >> 8, Le[Se++] = ar, ar = ar >> 8, Le[Se++] = ar, Se;
                        }
                        function Yt(Le, xe, Se, lt, Gt) {
                            Et(xe, lt, Gt, Le, Se, 7);
                            var Vt = Number(xe & BigInt(4294967295));
                            Le[Se + 7] = Vt, Vt = Vt >> 8, Le[Se + 6] = Vt, Vt = Vt >> 8, Le[Se + 5] = Vt, Vt = Vt >> 8, Le[Se + 4] = Vt;
                            var ar = Number(xe >> BigInt(32) & BigInt(4294967295));
                            return Le[Se + 3] = ar, ar = ar >> 8, Le[Se + 2] = ar, ar = ar >> 8, Le[Se + 1] = ar, ar = ar >> 8, Le[Se] = ar, Se + 8;
                        }
                        T.prototype.writeBigUInt64LE = Xe(function(xe) {
                            var Se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                            return Ct(this, xe, Se, BigInt(0), BigInt("0xffffffffffffffff"));
                        }), T.prototype.writeBigUInt64BE = Xe(function(xe) {
                            var Se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                            return Yt(this, xe, Se, BigInt(0), BigInt("0xffffffffffffffff"));
                        }), T.prototype.writeIntLE = function(xe, Se, lt, Gt) {
                            if (xe = +xe, Se = Se >>> 0, !Gt) {
                                var Vt = Math.pow(2, 8 * lt - 1);
                                kt(this, xe, Se, lt, Vt - 1, -Vt);
                            }
                            var ar = 0, Qr = 1, ai = 0;
                            for(this[Se] = xe & 255; ++ar < lt && (Qr *= 256);)xe < 0 && ai === 0 && this[Se + ar - 1] !== 0 && (ai = 1), this[Se + ar] = (xe / Qr >> 0) - ai & 255;
                            return Se + lt;
                        }, T.prototype.writeIntBE = function(xe, Se, lt, Gt) {
                            if (xe = +xe, Se = Se >>> 0, !Gt) {
                                var Vt = Math.pow(2, 8 * lt - 1);
                                kt(this, xe, Se, lt, Vt - 1, -Vt);
                            }
                            var ar = lt - 1, Qr = 1, ai = 0;
                            for(this[Se + ar] = xe & 255; --ar >= 0 && (Qr *= 256);)xe < 0 && ai === 0 && this[Se + ar + 1] !== 0 && (ai = 1), this[Se + ar] = (xe / Qr >> 0) - ai & 255;
                            return Se + lt;
                        }, T.prototype.writeInt8 = function(xe, Se, lt) {
                            return xe = +xe, Se = Se >>> 0, lt || kt(this, xe, Se, 1, 127, -128), xe < 0 && (xe = 255 + xe + 1), this[Se] = xe & 255, Se + 1;
                        }, T.prototype.writeInt16LE = function(xe, Se, lt) {
                            return xe = +xe, Se = Se >>> 0, lt || kt(this, xe, Se, 2, 32767, -32768), this[Se] = xe & 255, this[Se + 1] = xe >>> 8, Se + 2;
                        }, T.prototype.writeInt16BE = function(xe, Se, lt) {
                            return xe = +xe, Se = Se >>> 0, lt || kt(this, xe, Se, 2, 32767, -32768), this[Se] = xe >>> 8, this[Se + 1] = xe & 255, Se + 2;
                        }, T.prototype.writeInt32LE = function(xe, Se, lt) {
                            return xe = +xe, Se = Se >>> 0, lt || kt(this, xe, Se, 4, 2147483647, -2147483648), this[Se] = xe & 255, this[Se + 1] = xe >>> 8, this[Se + 2] = xe >>> 16, this[Se + 3] = xe >>> 24, Se + 4;
                        }, T.prototype.writeInt32BE = function(xe, Se, lt) {
                            return xe = +xe, Se = Se >>> 0, lt || kt(this, xe, Se, 4, 2147483647, -2147483648), xe < 0 && (xe = 4294967295 + xe + 1), this[Se] = xe >>> 24, this[Se + 1] = xe >>> 16, this[Se + 2] = xe >>> 8, this[Se + 3] = xe & 255, Se + 4;
                        }, T.prototype.writeBigInt64LE = Xe(function(xe) {
                            var Se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                            return Ct(this, xe, Se, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                        }), T.prototype.writeBigInt64BE = Xe(function(xe) {
                            var Se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                            return Yt(this, xe, Se, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
                        });
                        function xr(Le, xe, Se, lt, Gt, Vt) {
                            if (Se + lt > Le.length) throw new RangeError("Index out of range");
                            if (Se < 0) throw new RangeError("Index out of range");
                        }
                        function er(Le, xe, Se, lt, Gt) {
                            return xe = +xe, Se = Se >>> 0, Gt || xr(Le, xe, Se, 4, 34028234663852886e22, -340282346638528860000000000000000000000), _.write(Le, xe, Se, lt, 23, 4), Se + 4;
                        }
                        T.prototype.writeFloatLE = function(xe, Se, lt) {
                            return er(this, xe, Se, !0, lt);
                        }, T.prototype.writeFloatBE = function(xe, Se, lt) {
                            return er(this, xe, Se, !1, lt);
                        };
                        function Ke(Le, xe, Se, lt, Gt) {
                            return xe = +xe, Se = Se >>> 0, Gt || xr(Le, xe, Se, 8, 17976931348623157e292, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000), _.write(Le, xe, Se, lt, 52, 8), Se + 8;
                        }
                        T.prototype.writeDoubleLE = function(xe, Se, lt) {
                            return Ke(this, xe, Se, !0, lt);
                        }, T.prototype.writeDoubleBE = function(xe, Se, lt) {
                            return Ke(this, xe, Se, !1, lt);
                        }, T.prototype.copy = function(xe, Se, lt, Gt) {
                            if (!T.isBuffer(xe)) throw new TypeError("argument should be a Buffer");
                            if (lt || (lt = 0), !Gt && Gt !== 0 && (Gt = this.length), Se >= xe.length && (Se = xe.length), Se || (Se = 0), Gt > 0 && Gt < lt && (Gt = lt), Gt === lt || xe.length === 0 || this.length === 0) return 0;
                            if (Se < 0) throw new RangeError("targetStart out of bounds");
                            if (lt < 0 || lt >= this.length) throw new RangeError("Index out of range");
                            if (Gt < 0) throw new RangeError("sourceEnd out of bounds");
                            Gt > this.length && (Gt = this.length), xe.length - Se < Gt - lt && (Gt = xe.length - Se + lt);
                            var Vt = Gt - lt;
                            return this === xe && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(Se, lt, Gt) : Uint8Array.prototype.set.call(xe, this.subarray(lt, Gt), Se), Vt;
                        }, T.prototype.fill = function(xe, Se, lt, Gt) {
                            if (typeof xe == "string") {
                                if (typeof Se == "string" ? (Gt = Se, Se = 0, lt = this.length) : typeof lt == "string" && (Gt = lt, lt = this.length), Gt !== void 0 && typeof Gt != "string") throw new TypeError("encoding must be a string");
                                if (typeof Gt == "string" && !T.isEncoding(Gt)) throw new TypeError("Unknown encoding: " + Gt);
                                if (xe.length === 1) {
                                    var Vt = xe.charCodeAt(0);
                                    (Gt === "utf8" && Vt < 128 || Gt === "latin1") && (xe = Vt);
                                }
                            } else typeof xe == "number" ? xe = xe & 255 : typeof xe == "boolean" && (xe = Number(xe));
                            if (Se < 0 || this.length < Se || this.length < lt) throw new RangeError("Out of range index");
                            if (lt <= Se) return this;
                            Se = Se >>> 0, lt = lt === void 0 ? this.length : lt >>> 0, xe || (xe = 0);
                            var ar;
                            if (typeof xe == "number") for(ar = Se; ar < lt; ++ar)this[ar] = xe;
                            else {
                                var Qr = T.isBuffer(xe) ? xe : T.from(xe, Gt), ai = Qr.length;
                                if (ai === 0) throw new TypeError('The value "' + xe + '" is invalid for argument "value"');
                                for(ar = 0; ar < lt - Se; ++ar)this[ar + Se] = Qr[ar % ai];
                            }
                            return this;
                        };
                        var xt = {};
                        function bt(Le, xe, Se) {
                            xt[Le] = function(lt) {
                                function Gt() {
                                    var Vt;
                                    return l(this, Gt), Vt = d(this, Gt), Object.defineProperty(Vt, "message", {
                                        value: xe.apply(Vt, arguments),
                                        writable: !0,
                                        configurable: !0
                                    }), Vt.name = "".concat(Vt.name, " [").concat(Le, "]"), Vt.stack, delete Vt.name, Vt;
                                }
                                return E(Gt, lt), c(Gt, [
                                    {
                                        key: "code",
                                        get: function() {
                                            return Le;
                                        },
                                        set: function(ar) {
                                            Object.defineProperty(this, "code", {
                                                configurable: !0,
                                                enumerable: !0,
                                                value: ar,
                                                writable: !0
                                            });
                                        }
                                    },
                                    {
                                        key: "toString",
                                        value: function() {
                                            return "".concat(this.name, " [").concat(Le, "]: ").concat(this.message);
                                        }
                                    }
                                ]);
                            }(Se);
                        }
                        bt("ERR_BUFFER_OUT_OF_BOUNDS", function(Le) {
                            return Le ? "".concat(Le, " is outside of buffer bounds") : "Attempt to access memory outside buffer bounds";
                        }, RangeError), bt("ERR_INVALID_ARG_TYPE", function(Le, xe) {
                            return 'The "'.concat(Le, '" argument must be of type number. Received type ').concat(A(xe));
                        }, TypeError), bt("ERR_OUT_OF_RANGE", function(Le, xe, Se) {
                            var lt = 'The value of "'.concat(Le, '" is out of range.'), Gt = Se;
                            return Number.isInteger(Se) && Math.abs(Se) > Math.pow(2, 32) ? Gt = Lt(String(Se)) : typeof Se == "bigint" && (Gt = String(Se), (Se > Math.pow(BigInt(2), BigInt(32)) || Se < -Math.pow(BigInt(2), BigInt(32))) && (Gt = Lt(Gt)), Gt += "n"), lt += " It must be ".concat(xe, ". Received ").concat(Gt), lt;
                        }, RangeError);
                        function Lt(Le) {
                            for(var xe = "", Se = Le.length, lt = Le[0] === "-" ? 1 : 0; Se >= lt + 4; Se -= 3)xe = "_".concat(Le.slice(Se - 3, Se)).concat(xe);
                            return "".concat(Le.slice(0, Se)).concat(xe);
                        }
                        function St(Le, xe, Se) {
                            dt(xe, "offset"), (Le[xe] === void 0 || Le[xe + Se] === void 0) && Ht(xe, Le.length - (Se + 1));
                        }
                        function Et(Le, xe, Se, lt, Gt, Vt) {
                            if (Le > Se || Le < xe) {
                                var ar = typeof xe == "bigint" ? "n" : "", Qr;
                                throw Vt > 3 ? xe === 0 || xe === BigInt(0) ? Qr = ">= 0".concat(ar, " and < 2").concat(ar, " ** ").concat((Vt + 1) * 8).concat(ar) : Qr = ">= -(2".concat(ar, " ** ").concat((Vt + 1) * 8 - 1).concat(ar, ") and < 2 ** ") + "".concat((Vt + 1) * 8 - 1).concat(ar) : Qr = ">= ".concat(xe).concat(ar, " and <= ").concat(Se).concat(ar), new xt.ERR_OUT_OF_RANGE("value", Qr, Le);
                            }
                            St(lt, Gt, Vt);
                        }
                        function dt(Le, xe) {
                            if (typeof Le != "number") throw new xt.ERR_INVALID_ARG_TYPE(xe, "number", Le);
                        }
                        function Ht(Le, xe, Se) {
                            throw Math.floor(Le) !== Le ? (dt(Le, Se), new xt.ERR_OUT_OF_RANGE(Se || "offset", "an integer", Le)) : xe < 0 ? new xt.ERR_BUFFER_OUT_OF_BOUNDS : new xt.ERR_OUT_OF_RANGE(Se || "offset", ">= ".concat(Se ? 1 : 0, " and <= ").concat(xe), Le);
                        }
                        var $t = /[^+/0-9A-Za-z-_]/g;
                        function fr(Le) {
                            if (Le = Le.split("=")[0], Le = Le.trim().replace($t, ""), Le.length < 2) return "";
                            for(; Le.length % 4 !== 0;)Le = Le + "=";
                            return Le;
                        }
                        function _r(Le, xe) {
                            xe = xe || 1 / 0;
                            for(var Se, lt = Le.length, Gt = null, Vt = [], ar = 0; ar < lt; ++ar){
                                if (Se = Le.charCodeAt(ar), Se > 55295 && Se < 57344) {
                                    if (!Gt) {
                                        if (Se > 56319) {
                                            (xe -= 3) > -1 && Vt.push(239, 191, 189);
                                            continue;
                                        } else if (ar + 1 === lt) {
                                            (xe -= 3) > -1 && Vt.push(239, 191, 189);
                                            continue;
                                        }
                                        Gt = Se;
                                        continue;
                                    }
                                    if (Se < 56320) {
                                        (xe -= 3) > -1 && Vt.push(239, 191, 189), Gt = Se;
                                        continue;
                                    }
                                    Se = (Gt - 55296 << 10 | Se - 56320) + 65536;
                                } else Gt && (xe -= 3) > -1 && Vt.push(239, 191, 189);
                                if (Gt = null, Se < 128) {
                                    if ((xe -= 1) < 0) break;
                                    Vt.push(Se);
                                } else if (Se < 2048) {
                                    if ((xe -= 2) < 0) break;
                                    Vt.push(Se >> 6 | 192, Se & 63 | 128);
                                } else if (Se < 65536) {
                                    if ((xe -= 3) < 0) break;
                                    Vt.push(Se >> 12 | 224, Se >> 6 & 63 | 128, Se & 63 | 128);
                                } else if (Se < 1114112) {
                                    if ((xe -= 4) < 0) break;
                                    Vt.push(Se >> 18 | 240, Se >> 12 & 63 | 128, Se >> 6 & 63 | 128, Se & 63 | 128);
                                } else throw new Error("Invalid code point");
                            }
                            return Vt;
                        }
                        function Br(Le) {
                            for(var xe = [], Se = 0; Se < Le.length; ++Se)xe.push(Le.charCodeAt(Se) & 255);
                            return xe;
                        }
                        function Or(Le, xe) {
                            for(var Se, lt, Gt, Vt = [], ar = 0; ar < Le.length && !((xe -= 2) < 0); ++ar)Se = Le.charCodeAt(ar), lt = Se >> 8, Gt = Se % 256, Vt.push(Gt), Vt.push(lt);
                            return Vt;
                        }
                        function Nr(Le) {
                            return L.toByteArray(fr(Le));
                        }
                        function ut(Le, xe, Se, lt) {
                            var Gt;
                            for(Gt = 0; Gt < lt && !(Gt + Se >= xe.length || Gt >= Le.length); ++Gt)xe[Gt + Se] = Le[Gt];
                            return Gt;
                        }
                        function Ne(Le, xe) {
                            return Le instanceof xe || Le != null && Le.constructor != null && Le.constructor.name != null && Le.constructor.name === xe.name;
                        }
                        function Ye(Le) {
                            return Le !== Le;
                        }
                        var Ve = function() {
                            for(var Le = "0123456789abcdef", xe = new Array(256), Se = 0; Se < 16; ++Se)for(var lt = Se * 16, Gt = 0; Gt < 16; ++Gt)xe[lt + Gt] = Le[Se] + Le[Gt];
                            return xe;
                        }();
                        function Xe(Le) {
                            return typeof BigInt == "undefined" ? ht : Le;
                        }
                        function ht() {
                            throw new Error("BigInt not supported");
                        }
                    },
                    9216: function(i) {
                        "use strict";
                        i.exports = l, i.exports.isMobile = l, i.exports.default = l;
                        var a = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i, o = /CrOS/, s = /android|ipad|playbook|silk/i;
                        function l(u) {
                            u || (u = {});
                            var c = u.ua;
                            if (!c && typeof navigator != "undefined" && (c = navigator.userAgent), c && c.headers && typeof c.headers["user-agent"] == "string" && (c = c.headers["user-agent"]), typeof c != "string") return !1;
                            var f = a.test(c) && !o.test(c) || !!u.tablet && s.test(c);
                            return !f && u.tablet && u.featureDetect && navigator && navigator.maxTouchPoints > 1 && c.indexOf("Macintosh") !== -1 && c.indexOf("Safari") !== -1 && (f = !0), f;
                        }
                    },
                    6296: function(i, a, o) {
                        "use strict";
                        i.exports = h;
                        var s = o(7261), l = o(9977), u = o(1811);
                        function c(d, v) {
                            this._controllerNames = Object.keys(d), this._controllerList = this._controllerNames.map(function(x) {
                                return d[x];
                            }), this._mode = v, this._active = d[v], this._active || (this._mode = "turntable", this._active = d.turntable), this.modes = this._controllerNames, this.computedMatrix = this._active.computedMatrix, this.computedEye = this._active.computedEye, this.computedUp = this._active.computedUp, this.computedCenter = this._active.computedCenter, this.computedRadius = this._active.computedRadius;
                        }
                        var f = c.prototype;
                        f.flush = function(d) {
                            for(var v = this._controllerList, x = 0; x < v.length; ++x)v[x].flush(d);
                        }, f.idle = function(d) {
                            for(var v = this._controllerList, x = 0; x < v.length; ++x)v[x].idle(d);
                        }, f.lookAt = function(d, v, x, b) {
                            for(var p = this._controllerList, E = 0; E < p.length; ++E)p[E].lookAt(d, v, x, b);
                        }, f.rotate = function(d, v, x, b) {
                            for(var p = this._controllerList, E = 0; E < p.length; ++E)p[E].rotate(d, v, x, b);
                        }, f.pan = function(d, v, x, b) {
                            for(var p = this._controllerList, E = 0; E < p.length; ++E)p[E].pan(d, v, x, b);
                        }, f.translate = function(d, v, x, b) {
                            for(var p = this._controllerList, E = 0; E < p.length; ++E)p[E].translate(d, v, x, b);
                        }, f.setMatrix = function(d, v) {
                            for(var x = this._controllerList, b = 0; b < x.length; ++b)x[b].setMatrix(d, v);
                        }, f.setDistanceLimits = function(d, v) {
                            for(var x = this._controllerList, b = 0; b < x.length; ++b)x[b].setDistanceLimits(d, v);
                        }, f.setDistance = function(d, v) {
                            for(var x = this._controllerList, b = 0; b < x.length; ++b)x[b].setDistance(d, v);
                        }, f.recalcMatrix = function(d) {
                            this._active.recalcMatrix(d);
                        }, f.getDistance = function(d) {
                            return this._active.getDistance(d);
                        }, f.getDistanceLimits = function(d) {
                            return this._active.getDistanceLimits(d);
                        }, f.lastT = function() {
                            return this._active.lastT();
                        }, f.setMode = function(d) {
                            if (d !== this._mode) {
                                var v = this._controllerNames.indexOf(d);
                                if (!(v < 0)) {
                                    var x = this._active, b = this._controllerList[v], p = Math.max(x.lastT(), b.lastT());
                                    x.recalcMatrix(p), b.setMatrix(p, x.computedMatrix), this._active = b, this._mode = d, this.computedMatrix = this._active.computedMatrix, this.computedEye = this._active.computedEye, this.computedUp = this._active.computedUp, this.computedCenter = this._active.computedCenter, this.computedRadius = this._active.computedRadius;
                                }
                            }
                        }, f.getMode = function() {
                            return this._mode;
                        };
                        function h(d) {
                            d = d || {};
                            var v = d.eye || [
                                0,
                                0,
                                1
                            ], x = d.center || [
                                0,
                                0,
                                0
                            ], b = d.up || [
                                0,
                                1,
                                0
                            ], p = d.distanceLimits || [
                                0,
                                1 / 0
                            ], E = d.mode || "turntable", k = s(), A = l(), L = u();
                            return k.setDistanceLimits(p[0], p[1]), k.lookAt(0, v, x, b), A.setDistanceLimits(p[0], p[1]), A.lookAt(0, v, x, b), L.setDistanceLimits(p[0], p[1]), L.lookAt(0, v, x, b), new c({
                                turntable: k,
                                orbit: A,
                                matrix: L
                            }, E);
                        }
                    },
                    7169: function(i, a, o) {
                        "use strict";
                        var s = typeof WeakMap == "undefined" ? o(1538) : WeakMap, l = o(2762), u = o(8116), c = new s;
                        function f(h) {
                            var d = c.get(h), v = d && (d._triangleBuffer.handle || d._triangleBuffer.buffer);
                            if (!v || !h.isBuffer(v)) {
                                var x = l(h, new Float32Array([
                                    -1,
                                    -1,
                                    -1,
                                    4,
                                    4,
                                    -1
                                ]));
                                d = u(h, [
                                    {
                                        buffer: x,
                                        type: h.FLOAT,
                                        size: 2
                                    }
                                ]), d._triangleBuffer = x, c.set(h, d);
                            }
                            d.bind(), h.drawArrays(h.TRIANGLES, 0, 3), d.unbind();
                        }
                        i.exports = f;
                    },
                    1085: function(i, a, o) {
                        var s = o(1371);
                        i.exports = l;
                        function l(u, c, f) {
                            c = typeof c == "number" ? c : 1, f = f || ": ";
                            var h = u.split(/\r?\n/), d = String(h.length + c - 1).length;
                            return h.map(function(v, x) {
                                var b = x + c, p = String(b).length, E = s(b, d - p);
                                return E + f + v;
                            }).join(`
`);
                        }
                    },
                    3952: function(i, a, o) {
                        "use strict";
                        i.exports = u;
                        var s = o(3250);
                        function l(c, f) {
                            for(var h = new Array(f + 1), d = 0; d < c.length; ++d)h[d] = c[d];
                            for(var d = 0; d <= c.length; ++d){
                                for(var v = c.length; v <= f; ++v){
                                    for(var x = new Array(f), b = 0; b < f; ++b)x[b] = Math.pow(v + 1 - d, b);
                                    h[v] = x;
                                }
                                var p = s.apply(void 0, h);
                                if (p) return !0;
                            }
                            return !1;
                        }
                        function u(c) {
                            var f = c.length;
                            if (f === 0) return [];
                            if (f === 1) return [
                                0
                            ];
                            for(var h = c[0].length, d = [
                                c[0]
                            ], v = [
                                0
                            ], x = 1; x < f; ++x){
                                if (d.push(c[x]), !l(d, h)) {
                                    d.pop();
                                    continue;
                                }
                                if (v.push(x), v.length === h + 1) return v;
                            }
                            return v;
                        }
                    },
                    5995: function(i, a, o) {
                        "use strict";
                        i.exports = u;
                        var s = o(7642), l = o(6037);
                        function u(c, f) {
                            return s(f).filter(function(h) {
                                for(var d = new Array(h.length), v = 0; v < h.length; ++v)d[v] = f[h[v]];
                                return l(d) * c < 1;
                            });
                        }
                    },
                    3502: function(i, a, o) {
                        i.exports = u;
                        var s = o(5995), l = o(9127);
                        function u(c, f) {
                            return l(s(c, f));
                        }
                    },
                    6468: function(i) {
                        i.exports = function(o) {
                            return atob(o);
                        };
                    },
                    2642: function(i, a, o) {
                        "use strict";
                        i.exports = u;
                        var s = o(727);
                        function l(c) {
                            for(var f = 0, h = 0; h < c.length; ++h)f += c[h];
                            return f;
                        }
                        function u(c, f) {
                            for(var h = f.length, d = new Array(h + 1), v = 0; v < h; ++v){
                                for(var x = new Array(h + 1), b = 0; b <= h; ++b)x[b] = c[b][v];
                                d[v] = x;
                            }
                            d[h] = new Array(h + 1);
                            for(var v = 0; v <= h; ++v)d[h][v] = 1;
                            for(var p = new Array(h + 1), v = 0; v < h; ++v)p[v] = f[v];
                            p[h] = 1;
                            var E = s(d, p), k = l(E[h + 1]);
                            k === 0 && (k = 1);
                            for(var A = new Array(h + 1), v = 0; v <= h; ++v)A[v] = l(E[v]) / k;
                            return A;
                        }
                    },
                    7507: function(i, a) {
                        "use strict";
                        a.byteLength = d, a.toByteArray = x, a.fromByteArray = E;
                        for(var o = [], s = [], l = typeof Uint8Array != "undefined" ? Uint8Array : Array, u = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", c = 0, f = u.length; c < f; ++c)o[c] = u[c], s[u.charCodeAt(c)] = c;
                        s[45] = 62, s[95] = 63;
                        function h(k) {
                            var A = k.length;
                            if (A % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
                            var L = k.indexOf("=");
                            L === -1 && (L = A);
                            var _ = L === A ? 0 : 4 - L % 4;
                            return [
                                L,
                                _
                            ];
                        }
                        function d(k) {
                            var A = h(k), L = A[0], _ = A[1];
                            return (L + _) * 3 / 4 - _;
                        }
                        function v(k, A, L) {
                            return (A + L) * 3 / 4 - L;
                        }
                        function x(k) {
                            var A, L = h(k), _ = L[0], C = L[1], M = new l(v(k, _, C)), g = 0, P = C > 0 ? _ - 4 : _, T;
                            for(T = 0; T < P; T += 4)A = s[k.charCodeAt(T)] << 18 | s[k.charCodeAt(T + 1)] << 12 | s[k.charCodeAt(T + 2)] << 6 | s[k.charCodeAt(T + 3)], M[g++] = A >> 16 & 255, M[g++] = A >> 8 & 255, M[g++] = A & 255;
                            return C === 2 && (A = s[k.charCodeAt(T)] << 2 | s[k.charCodeAt(T + 1)] >> 4, M[g++] = A & 255), C === 1 && (A = s[k.charCodeAt(T)] << 10 | s[k.charCodeAt(T + 1)] << 4 | s[k.charCodeAt(T + 2)] >> 2, M[g++] = A >> 8 & 255, M[g++] = A & 255), M;
                        }
                        function b(k) {
                            return o[k >> 18 & 63] + o[k >> 12 & 63] + o[k >> 6 & 63] + o[k & 63];
                        }
                        function p(k, A, L) {
                            for(var _, C = [], M = A; M < L; M += 3)_ = (k[M] << 16 & 16711680) + (k[M + 1] << 8 & 65280) + (k[M + 2] & 255), C.push(b(_));
                            return C.join("");
                        }
                        function E(k) {
                            for(var A, L = k.length, _ = L % 3, C = [], M = 16383, g = 0, P = L - _; g < P; g += M)C.push(p(k, g, g + M > P ? P : g + M));
                            return _ === 1 ? (A = k[L - 1], C.push(o[A >> 2] + o[A << 4 & 63] + "==")) : _ === 2 && (A = (k[L - 2] << 8) + k[L - 1], C.push(o[A >> 10] + o[A >> 4 & 63] + o[A << 2 & 63] + "=")), C.join("");
                        }
                    },
                    3865: function(i, a, o) {
                        "use strict";
                        var s = o(869);
                        i.exports = l;
                        function l(u, c) {
                            return s(u[0].mul(c[1]).add(c[0].mul(u[1])), u[1].mul(c[1]));
                        }
                    },
                    1318: function(i) {
                        "use strict";
                        i.exports = a;
                        function a(o, s) {
                            return o[0].mul(s[1]).cmp(s[0].mul(o[1]));
                        }
                    },
                    8697: function(i, a, o) {
                        "use strict";
                        var s = o(869);
                        i.exports = l;
                        function l(u, c) {
                            return s(u[0].mul(c[1]), u[1].mul(c[0]));
                        }
                    },
                    7842: function(i, a, o) {
                        "use strict";
                        var s = o(6330), l = o(1533), u = o(2651), c = o(6768), f = o(869), h = o(8697);
                        i.exports = d;
                        function d(v, x) {
                            if (s(v)) return x ? h(v, d(x)) : [
                                v[0].clone(),
                                v[1].clone()
                            ];
                            var b = 0, p, E;
                            if (l(v)) p = v.clone();
                            else if (typeof v == "string") p = c(v);
                            else {
                                if (v === 0) return [
                                    u(0),
                                    u(1)
                                ];
                                if (v === Math.floor(v)) p = u(v);
                                else {
                                    for(; v !== Math.floor(v);)v = v * Math.pow(2, 256), b -= 256;
                                    p = u(v);
                                }
                            }
                            if (s(x)) p.mul(x[1]), E = x[0].clone();
                            else if (l(x)) E = x.clone();
                            else if (typeof x == "string") E = c(x);
                            else if (!x) E = u(1);
                            else if (x === Math.floor(x)) E = u(x);
                            else {
                                for(; x !== Math.floor(x);)x = x * Math.pow(2, 256), b += 256;
                                E = u(x);
                            }
                            return b > 0 ? p = p.ushln(b) : b < 0 && (E = E.ushln(-b)), f(p, E);
                        }
                    },
                    6330: function(i, a, o) {
                        "use strict";
                        var s = o(1533);
                        i.exports = l;
                        function l(u) {
                            return Array.isArray(u) && u.length === 2 && s(u[0]) && s(u[1]);
                        }
                    },
                    5716: function(i, a, o) {
                        "use strict";
                        var s = o(6859);
                        i.exports = l;
                        function l(u) {
                            return u.cmp(new s(0));
                        }
                    },
                    1369: function(i, a, o) {
                        "use strict";
                        var s = o(5716);
                        i.exports = l;
                        function l(u) {
                            var c = u.length, f = u.words, h = 0;
                            if (c === 1) h = f[0];
                            else if (c === 2) h = f[0] + f[1] * 67108864;
                            else for(var d = 0; d < c; d++){
                                var v = f[d];
                                h += v * Math.pow(67108864, d);
                            }
                            return s(u) * h;
                        }
                    },
                    4025: function(i, a, o) {
                        "use strict";
                        var s = o(2361), l = o(8828).countTrailingZeros;
                        i.exports = u;
                        function u(c) {
                            var f = l(s.lo(c));
                            if (f < 32) return f;
                            var h = l(s.hi(c));
                            return h > 20 ? 52 : h + 32;
                        }
                    },
                    1533: function(i, a, o) {
                        "use strict";
                        var s = o(6859);
                        i.exports = l;
                        function l(u) {
                            return u && typeof u == "object" && !!u.words;
                        }
                    },
                    2651: function(i, a, o) {
                        "use strict";
                        var s = o(6859), l = o(2361);
                        i.exports = u;
                        function u(c) {
                            var f = l.exponent(c);
                            return f < 52 ? new s(c) : new s(c * Math.pow(2, 52 - f)).ushln(f - 52);
                        }
                    },
                    869: function(i, a, o) {
                        "use strict";
                        var s = o(2651), l = o(5716);
                        i.exports = u;
                        function u(c, f) {
                            var h = l(c), d = l(f);
                            if (h === 0) return [
                                s(0),
                                s(1)
                            ];
                            if (d === 0) return [
                                s(0),
                                s(0)
                            ];
                            d < 0 && (c = c.neg(), f = f.neg());
                            var v = c.gcd(f);
                            return v.cmpn(1) ? [
                                c.div(v),
                                f.div(v)
                            ] : [
                                c,
                                f
                            ];
                        }
                    },
                    6768: function(i, a, o) {
                        "use strict";
                        var s = o(6859);
                        i.exports = l;
                        function l(u) {
                            return new s(u);
                        }
                    },
                    6504: function(i, a, o) {
                        "use strict";
                        var s = o(869);
                        i.exports = l;
                        function l(u, c) {
                            return s(u[0].mul(c[0]), u[1].mul(c[1]));
                        }
                    },
                    7721: function(i, a, o) {
                        "use strict";
                        var s = o(5716);
                        i.exports = l;
                        function l(u) {
                            return s(u[0]) * s(u[1]);
                        }
                    },
                    5572: function(i, a, o) {
                        "use strict";
                        var s = o(869);
                        i.exports = l;
                        function l(u, c) {
                            return s(u[0].mul(c[1]).sub(u[1].mul(c[0])), u[1].mul(c[1]));
                        }
                    },
                    946: function(i, a, o) {
                        "use strict";
                        var s = o(1369), l = o(4025);
                        i.exports = u;
                        function u(c) {
                            var f = c[0], h = c[1];
                            if (f.cmpn(0) === 0) return 0;
                            var d = f.abs().divmod(h.abs()), v = d.div, x = s(v), b = d.mod, p = f.negative !== h.negative ? -1 : 1;
                            if (b.cmpn(0) === 0) return p * x;
                            if (x) {
                                var E = l(x) + 4, k = s(b.ushln(E).divRound(h));
                                return p * (x + k * Math.pow(2, -E));
                            } else {
                                var A = h.bitLength() - b.bitLength() + 53, k = s(b.ushln(A).divRound(h));
                                return A < 1023 ? p * k * Math.pow(2, -A) : (k *= Math.pow(2, -1023), p * k * Math.pow(2, 1023 - A));
                            }
                        }
                    },
                    2478: function(i) {
                        "use strict";
                        function a(f, h, d, v, x) {
                            for(var b = x + 1; v <= x;){
                                var p = v + x >>> 1, E = f[p], k = d !== void 0 ? d(E, h) : E - h;
                                k >= 0 ? (b = p, x = p - 1) : v = p + 1;
                            }
                            return b;
                        }
                        function o(f, h, d, v, x) {
                            for(var b = x + 1; v <= x;){
                                var p = v + x >>> 1, E = f[p], k = d !== void 0 ? d(E, h) : E - h;
                                k > 0 ? (b = p, x = p - 1) : v = p + 1;
                            }
                            return b;
                        }
                        function s(f, h, d, v, x) {
                            for(var b = v - 1; v <= x;){
                                var p = v + x >>> 1, E = f[p], k = d !== void 0 ? d(E, h) : E - h;
                                k < 0 ? (b = p, v = p + 1) : x = p - 1;
                            }
                            return b;
                        }
                        function l(f, h, d, v, x) {
                            for(var b = v - 1; v <= x;){
                                var p = v + x >>> 1, E = f[p], k = d !== void 0 ? d(E, h) : E - h;
                                k <= 0 ? (b = p, v = p + 1) : x = p - 1;
                            }
                            return b;
                        }
                        function u(f, h, d, v, x) {
                            for(; v <= x;){
                                var b = v + x >>> 1, p = f[b], E = d !== void 0 ? d(p, h) : p - h;
                                if (E === 0) return b;
                                E <= 0 ? v = b + 1 : x = b - 1;
                            }
                            return -1;
                        }
                        function c(f, h, d, v, x, b) {
                            return typeof d == "function" ? b(f, h, d, v === void 0 ? 0 : v | 0, x === void 0 ? f.length - 1 : x | 0) : b(f, h, void 0, d === void 0 ? 0 : d | 0, v === void 0 ? f.length - 1 : v | 0);
                        }
                        i.exports = {
                            ge: function(f, h, d, v, x) {
                                return c(f, h, d, v, x, a);
                            },
                            gt: function(f, h, d, v, x) {
                                return c(f, h, d, v, x, o);
                            },
                            lt: function(f, h, d, v, x) {
                                return c(f, h, d, v, x, s);
                            },
                            le: function(f, h, d, v, x) {
                                return c(f, h, d, v, x, l);
                            },
                            eq: function(f, h, d, v, x) {
                                return c(f, h, d, v, x, u);
                            }
                        };
                    },
                    8828: function(i, a) {
                        "use strict";
                        "use restrict";
                        var o = 32;
                        a.INT_BITS = o, a.INT_MAX = 2147483647, a.INT_MIN = -1 << o - 1, a.sign = function(u) {
                            return (u > 0) - (u < 0);
                        }, a.abs = function(u) {
                            var c = u >> o - 1;
                            return (u ^ c) - c;
                        }, a.min = function(u, c) {
                            return c ^ (u ^ c) & -(u < c);
                        }, a.max = function(u, c) {
                            return u ^ (u ^ c) & -(u < c);
                        }, a.isPow2 = function(u) {
                            return !(u & u - 1) && !!u;
                        }, a.log2 = function(u) {
                            var c, f;
                            return c = (u > 65535) << 4, u >>>= c, f = (u > 255) << 3, u >>>= f, c |= f, f = (u > 15) << 2, u >>>= f, c |= f, f = (u > 3) << 1, u >>>= f, c |= f, c | u >> 1;
                        }, a.log10 = function(u) {
                            return u >= 1e9 ? 9 : u >= 1e8 ? 8 : u >= 1e7 ? 7 : u >= 1e6 ? 6 : u >= 1e5 ? 5 : u >= 1e4 ? 4 : u >= 1e3 ? 3 : u >= 100 ? 2 : u >= 10 ? 1 : 0;
                        }, a.popCount = function(u) {
                            return u = u - (u >>> 1 & 1431655765), u = (u & 858993459) + (u >>> 2 & 858993459), (u + (u >>> 4) & 252645135) * 16843009 >>> 24;
                        };
                        function s(u) {
                            var c = 32;
                            return u &= -u, u && c--, u & 65535 && (c -= 16), u & 16711935 && (c -= 8), u & 252645135 && (c -= 4), u & 858993459 && (c -= 2), u & 1431655765 && (c -= 1), c;
                        }
                        a.countTrailingZeros = s, a.nextPow2 = function(u) {
                            return u += u === 0, --u, u |= u >>> 1, u |= u >>> 2, u |= u >>> 4, u |= u >>> 8, u |= u >>> 16, u + 1;
                        }, a.prevPow2 = function(u) {
                            return u |= u >>> 1, u |= u >>> 2, u |= u >>> 4, u |= u >>> 8, u |= u >>> 16, u - (u >>> 1);
                        }, a.parity = function(u) {
                            return u ^= u >>> 16, u ^= u >>> 8, u ^= u >>> 4, u &= 15, 27030 >>> u & 1;
                        };
                        var l = new Array(256);
                        (function(u) {
                            for(var c = 0; c < 256; ++c){
                                var f = c, h = c, d = 7;
                                for(f >>>= 1; f; f >>>= 1)h <<= 1, h |= f & 1, --d;
                                u[c] = h << d & 255;
                            }
                        })(l), a.reverse = function(u) {
                            return l[u & 255] << 24 | l[u >>> 8 & 255] << 16 | l[u >>> 16 & 255] << 8 | l[u >>> 24 & 255];
                        }, a.interleave2 = function(u, c) {
                            return u &= 65535, u = (u | u << 8) & 16711935, u = (u | u << 4) & 252645135, u = (u | u << 2) & 858993459, u = (u | u << 1) & 1431655765, c &= 65535, c = (c | c << 8) & 16711935, c = (c | c << 4) & 252645135, c = (c | c << 2) & 858993459, c = (c | c << 1) & 1431655765, u | c << 1;
                        }, a.deinterleave2 = function(u, c) {
                            return u = u >>> c & 1431655765, u = (u | u >>> 1) & 858993459, u = (u | u >>> 2) & 252645135, u = (u | u >>> 4) & 16711935, u = (u | u >>> 16) & 65535, u << 16 >> 16;
                        }, a.interleave3 = function(u, c, f) {
                            return u &= 1023, u = (u | u << 16) & 4278190335, u = (u | u << 8) & 251719695, u = (u | u << 4) & 3272356035, u = (u | u << 2) & 1227133513, c &= 1023, c = (c | c << 16) & 4278190335, c = (c | c << 8) & 251719695, c = (c | c << 4) & 3272356035, c = (c | c << 2) & 1227133513, u |= c << 1, f &= 1023, f = (f | f << 16) & 4278190335, f = (f | f << 8) & 251719695, f = (f | f << 4) & 3272356035, f = (f | f << 2) & 1227133513, u | f << 2;
                        }, a.deinterleave3 = function(u, c) {
                            return u = u >>> c & 1227133513, u = (u | u >>> 2) & 3272356035, u = (u | u >>> 4) & 251719695, u = (u | u >>> 8) & 4278190335, u = (u | u >>> 16) & 1023, u << 22 >> 22;
                        }, a.nextCombination = function(u) {
                            var c = u | u - 1;
                            return c + 1 | (~c & -~c) - 1 >>> s(u) + 1;
                        };
                    },
                    6859: function(i, a, o) {
                        i = o.nmd(i), function(s, l) {
                            "use strict";
                            function u(G, N) {
                                if (!G) throw new Error(N || "Assertion failed");
                            }
                            function c(G, N) {
                                G.super_ = N;
                                var W = function() {};
                                W.prototype = N.prototype, G.prototype = new W, G.prototype.constructor = G;
                            }
                            function f(G, N, W) {
                                if (f.isBN(G)) return G;
                                this.negative = 0, this.words = null, this.length = 0, this.red = null, G !== null && ((N === "le" || N === "be") && (W = N, N = 10), this._init(G || 0, N || 10, W || "be"));
                            }
                            typeof s == "object" ? s.exports = f : l.BN = f, f.BN = f, f.wordSize = 26;
                            var h;
                            try {
                                typeof window != "undefined" && typeof window.Buffer != "undefined" ? h = window.Buffer : h = o(7790).Buffer;
                            } catch (G) {}
                            f.isBN = function(N) {
                                return N instanceof f ? !0 : N !== null && typeof N == "object" && N.constructor.wordSize === f.wordSize && Array.isArray(N.words);
                            }, f.max = function(N, W) {
                                return N.cmp(W) > 0 ? N : W;
                            }, f.min = function(N, W) {
                                return N.cmp(W) < 0 ? N : W;
                            }, f.prototype._init = function(N, W, re) {
                                if (typeof N == "number") return this._initNumber(N, W, re);
                                if (typeof N == "object") return this._initArray(N, W, re);
                                W === "hex" && (W = 16), u(W === (W | 0) && W >= 2 && W <= 36), N = N.toString().replace(/\s+/g, "");
                                var ae = 0;
                                N[0] === "-" && (ae++, this.negative = 1), ae < N.length && (W === 16 ? this._parseHex(N, ae, re) : (this._parseBase(N, W, ae), re === "le" && this._initArray(this.toArray(), W, re)));
                            }, f.prototype._initNumber = function(N, W, re) {
                                N < 0 && (this.negative = 1, N = -N), N < 67108864 ? (this.words = [
                                    N & 67108863
                                ], this.length = 1) : N < 4503599627370496 ? (this.words = [
                                    N & 67108863,
                                    N / 67108864 & 67108863
                                ], this.length = 2) : (u(N < 9007199254740992), this.words = [
                                    N & 67108863,
                                    N / 67108864 & 67108863,
                                    1
                                ], this.length = 3), re === "le" && this._initArray(this.toArray(), W, re);
                            }, f.prototype._initArray = function(N, W, re) {
                                if (u(typeof N.length == "number"), N.length <= 0) return this.words = [
                                    0
                                ], this.length = 1, this;
                                this.length = Math.ceil(N.length / 3), this.words = new Array(this.length);
                                for(var ae = 0; ae < this.length; ae++)this.words[ae] = 0;
                                var _e, Me, ke = 0;
                                if (re === "be") for(ae = N.length - 1, _e = 0; ae >= 0; ae -= 3)Me = N[ae] | N[ae - 1] << 8 | N[ae - 2] << 16, this.words[_e] |= Me << ke & 67108863, this.words[_e + 1] = Me >>> 26 - ke & 67108863, ke += 24, ke >= 26 && (ke -= 26, _e++);
                                else if (re === "le") for(ae = 0, _e = 0; ae < N.length; ae += 3)Me = N[ae] | N[ae + 1] << 8 | N[ae + 2] << 16, this.words[_e] |= Me << ke & 67108863, this.words[_e + 1] = Me >>> 26 - ke & 67108863, ke += 24, ke >= 26 && (ke -= 26, _e++);
                                return this.strip();
                            };
                            function d(G, N) {
                                var W = G.charCodeAt(N);
                                return W >= 65 && W <= 70 ? W - 55 : W >= 97 && W <= 102 ? W - 87 : W - 48 & 15;
                            }
                            function v(G, N, W) {
                                var re = d(G, W);
                                return W - 1 >= N && (re |= d(G, W - 1) << 4), re;
                            }
                            f.prototype._parseHex = function(N, W, re) {
                                this.length = Math.ceil((N.length - W) / 6), this.words = new Array(this.length);
                                for(var ae = 0; ae < this.length; ae++)this.words[ae] = 0;
                                var _e = 0, Me = 0, ke;
                                if (re === "be") for(ae = N.length - 1; ae >= W; ae -= 2)ke = v(N, W, ae) << _e, this.words[Me] |= ke & 67108863, _e >= 18 ? (_e -= 18, Me += 1, this.words[Me] |= ke >>> 26) : _e += 8;
                                else {
                                    var ge = N.length - W;
                                    for(ae = ge % 2 === 0 ? W + 1 : W; ae < N.length; ae += 2)ke = v(N, W, ae) << _e, this.words[Me] |= ke & 67108863, _e >= 18 ? (_e -= 18, Me += 1, this.words[Me] |= ke >>> 26) : _e += 8;
                                }
                                this.strip();
                            };
                            function x(G, N, W, re) {
                                for(var ae = 0, _e = Math.min(G.length, W), Me = N; Me < _e; Me++){
                                    var ke = G.charCodeAt(Me) - 48;
                                    ae *= re, ke >= 49 ? ae += ke - 49 + 10 : ke >= 17 ? ae += ke - 17 + 10 : ae += ke;
                                }
                                return ae;
                            }
                            f.prototype._parseBase = function(N, W, re) {
                                this.words = [
                                    0
                                ], this.length = 1;
                                for(var ae = 0, _e = 1; _e <= 67108863; _e *= W)ae++;
                                ae--, _e = _e / W | 0;
                                for(var Me = N.length - re, ke = Me % ae, ge = Math.min(Me, Me - ke) + re, ie = 0, Te = re; Te < ge; Te += ae)ie = x(N, Te, Te + ae, W), this.imuln(_e), this.words[0] + ie < 67108864 ? this.words[0] += ie : this._iaddn(ie);
                                if (ke !== 0) {
                                    var Ee = 1;
                                    for(ie = x(N, Te, N.length, W), Te = 0; Te < ke; Te++)Ee *= W;
                                    this.imuln(Ee), this.words[0] + ie < 67108864 ? this.words[0] += ie : this._iaddn(ie);
                                }
                                this.strip();
                            }, f.prototype.copy = function(N) {
                                N.words = new Array(this.length);
                                for(var W = 0; W < this.length; W++)N.words[W] = this.words[W];
                                N.length = this.length, N.negative = this.negative, N.red = this.red;
                            }, f.prototype.clone = function() {
                                var N = new f(null);
                                return this.copy(N), N;
                            }, f.prototype._expand = function(N) {
                                for(; this.length < N;)this.words[this.length++] = 0;
                                return this;
                            }, f.prototype.strip = function() {
                                for(; this.length > 1 && this.words[this.length - 1] === 0;)this.length--;
                                return this._normSign();
                            }, f.prototype._normSign = function() {
                                return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
                            }, f.prototype.inspect = function() {
                                return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
                            };
                            var b = [
                                "",
                                "0",
                                "00",
                                "000",
                                "0000",
                                "00000",
                                "000000",
                                "0000000",
                                "00000000",
                                "000000000",
                                "0000000000",
                                "00000000000",
                                "000000000000",
                                "0000000000000",
                                "00000000000000",
                                "000000000000000",
                                "0000000000000000",
                                "00000000000000000",
                                "000000000000000000",
                                "0000000000000000000",
                                "00000000000000000000",
                                "000000000000000000000",
                                "0000000000000000000000",
                                "00000000000000000000000",
                                "000000000000000000000000",
                                "0000000000000000000000000"
                            ], p = [
                                0,
                                0,
                                25,
                                16,
                                12,
                                11,
                                10,
                                9,
                                8,
                                8,
                                7,
                                7,
                                7,
                                7,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                6,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5,
                                5
                            ], E = [
                                0,
                                0,
                                33554432,
                                43046721,
                                16777216,
                                48828125,
                                60466176,
                                40353607,
                                16777216,
                                43046721,
                                1e7,
                                19487171,
                                35831808,
                                62748517,
                                7529536,
                                11390625,
                                16777216,
                                24137569,
                                34012224,
                                47045881,
                                64e6,
                                4084101,
                                5153632,
                                6436343,
                                7962624,
                                9765625,
                                11881376,
                                14348907,
                                17210368,
                                20511149,
                                243e5,
                                28629151,
                                33554432,
                                39135393,
                                45435424,
                                52521875,
                                60466176
                            ];
                            f.prototype.toString = function(N, W) {
                                N = N || 10, W = W | 0 || 1;
                                var re;
                                if (N === 16 || N === "hex") {
                                    re = "";
                                    for(var ae = 0, _e = 0, Me = 0; Me < this.length; Me++){
                                        var ke = this.words[Me], ge = ((ke << ae | _e) & 16777215).toString(16);
                                        _e = ke >>> 24 - ae & 16777215, _e !== 0 || Me !== this.length - 1 ? re = b[6 - ge.length] + ge + re : re = ge + re, ae += 2, ae >= 26 && (ae -= 26, Me--);
                                    }
                                    for(_e !== 0 && (re = _e.toString(16) + re); re.length % W !== 0;)re = "0" + re;
                                    return this.negative !== 0 && (re = "-" + re), re;
                                }
                                if (N === (N | 0) && N >= 2 && N <= 36) {
                                    var ie = p[N], Te = E[N];
                                    re = "";
                                    var Ee = this.clone();
                                    for(Ee.negative = 0; !Ee.isZero();){
                                        var Ae = Ee.modn(Te).toString(N);
                                        Ee = Ee.idivn(Te), Ee.isZero() ? re = Ae + re : re = b[ie - Ae.length] + Ae + re;
                                    }
                                    for(this.isZero() && (re = "0" + re); re.length % W !== 0;)re = "0" + re;
                                    return this.negative !== 0 && (re = "-" + re), re;
                                }
                                u(!1, "Base should be between 2 and 36");
                            }, f.prototype.toNumber = function() {
                                var N = this.words[0];
                                return this.length === 2 ? N += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? N += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && u(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -N : N;
                            }, f.prototype.toJSON = function() {
                                return this.toString(16);
                            }, f.prototype.toBuffer = function(N, W) {
                                return u(typeof h != "undefined"), this.toArrayLike(h, N, W);
                            }, f.prototype.toArray = function(N, W) {
                                return this.toArrayLike(Array, N, W);
                            }, f.prototype.toArrayLike = function(N, W, re) {
                                var ae = this.byteLength(), _e = re || Math.max(1, ae);
                                u(ae <= _e, "byte array longer than desired length"), u(_e > 0, "Requested array length <= 0"), this.strip();
                                var Me = W === "le", ke = new N(_e), ge, ie, Te = this.clone();
                                if (Me) {
                                    for(ie = 0; !Te.isZero(); ie++)ge = Te.andln(255), Te.iushrn(8), ke[ie] = ge;
                                    for(; ie < _e; ie++)ke[ie] = 0;
                                } else {
                                    for(ie = 0; ie < _e - ae; ie++)ke[ie] = 0;
                                    for(ie = 0; !Te.isZero(); ie++)ge = Te.andln(255), Te.iushrn(8), ke[_e - ie - 1] = ge;
                                }
                                return ke;
                            }, Math.clz32 ? f.prototype._countBits = function(N) {
                                return 32 - Math.clz32(N);
                            } : f.prototype._countBits = function(N) {
                                var W = N, re = 0;
                                return W >= 4096 && (re += 13, W >>>= 13), W >= 64 && (re += 7, W >>>= 7), W >= 8 && (re += 4, W >>>= 4), W >= 2 && (re += 2, W >>>= 2), re + W;
                            }, f.prototype._zeroBits = function(N) {
                                if (N === 0) return 26;
                                var W = N, re = 0;
                                return W & 8191 || (re += 13, W >>>= 13), W & 127 || (re += 7, W >>>= 7), W & 15 || (re += 4, W >>>= 4), W & 3 || (re += 2, W >>>= 2), W & 1 || re++, re;
                            }, f.prototype.bitLength = function() {
                                var N = this.words[this.length - 1], W = this._countBits(N);
                                return (this.length - 1) * 26 + W;
                            };
                            function k(G) {
                                for(var N = new Array(G.bitLength()), W = 0; W < N.length; W++){
                                    var re = W / 26 | 0, ae = W % 26;
                                    N[W] = (G.words[re] & 1 << ae) >>> ae;
                                }
                                return N;
                            }
                            f.prototype.zeroBits = function() {
                                if (this.isZero()) return 0;
                                for(var N = 0, W = 0; W < this.length; W++){
                                    var re = this._zeroBits(this.words[W]);
                                    if (N += re, re !== 26) break;
                                }
                                return N;
                            }, f.prototype.byteLength = function() {
                                return Math.ceil(this.bitLength() / 8);
                            }, f.prototype.toTwos = function(N) {
                                return this.negative !== 0 ? this.abs().inotn(N).iaddn(1) : this.clone();
                            }, f.prototype.fromTwos = function(N) {
                                return this.testn(N - 1) ? this.notn(N).iaddn(1).ineg() : this.clone();
                            }, f.prototype.isNeg = function() {
                                return this.negative !== 0;
                            }, f.prototype.neg = function() {
                                return this.clone().ineg();
                            }, f.prototype.ineg = function() {
                                return this.isZero() || (this.negative ^= 1), this;
                            }, f.prototype.iuor = function(N) {
                                for(; this.length < N.length;)this.words[this.length++] = 0;
                                for(var W = 0; W < N.length; W++)this.words[W] = this.words[W] | N.words[W];
                                return this.strip();
                            }, f.prototype.ior = function(N) {
                                return u((this.negative | N.negative) === 0), this.iuor(N);
                            }, f.prototype.or = function(N) {
                                return this.length > N.length ? this.clone().ior(N) : N.clone().ior(this);
                            }, f.prototype.uor = function(N) {
                                return this.length > N.length ? this.clone().iuor(N) : N.clone().iuor(this);
                            }, f.prototype.iuand = function(N) {
                                var W;
                                this.length > N.length ? W = N : W = this;
                                for(var re = 0; re < W.length; re++)this.words[re] = this.words[re] & N.words[re];
                                return this.length = W.length, this.strip();
                            }, f.prototype.iand = function(N) {
                                return u((this.negative | N.negative) === 0), this.iuand(N);
                            }, f.prototype.and = function(N) {
                                return this.length > N.length ? this.clone().iand(N) : N.clone().iand(this);
                            }, f.prototype.uand = function(N) {
                                return this.length > N.length ? this.clone().iuand(N) : N.clone().iuand(this);
                            }, f.prototype.iuxor = function(N) {
                                var W, re;
                                this.length > N.length ? (W = this, re = N) : (W = N, re = this);
                                for(var ae = 0; ae < re.length; ae++)this.words[ae] = W.words[ae] ^ re.words[ae];
                                if (this !== W) for(; ae < W.length; ae++)this.words[ae] = W.words[ae];
                                return this.length = W.length, this.strip();
                            }, f.prototype.ixor = function(N) {
                                return u((this.negative | N.negative) === 0), this.iuxor(N);
                            }, f.prototype.xor = function(N) {
                                return this.length > N.length ? this.clone().ixor(N) : N.clone().ixor(this);
                            }, f.prototype.uxor = function(N) {
                                return this.length > N.length ? this.clone().iuxor(N) : N.clone().iuxor(this);
                            }, f.prototype.inotn = function(N) {
                                u(typeof N == "number" && N >= 0);
                                var W = Math.ceil(N / 26) | 0, re = N % 26;
                                this._expand(W), re > 0 && W--;
                                for(var ae = 0; ae < W; ae++)this.words[ae] = ~this.words[ae] & 67108863;
                                return re > 0 && (this.words[ae] = ~this.words[ae] & 67108863 >> 26 - re), this.strip();
                            }, f.prototype.notn = function(N) {
                                return this.clone().inotn(N);
                            }, f.prototype.setn = function(N, W) {
                                u(typeof N == "number" && N >= 0);
                                var re = N / 26 | 0, ae = N % 26;
                                return this._expand(re + 1), W ? this.words[re] = this.words[re] | 1 << ae : this.words[re] = this.words[re] & ~(1 << ae), this.strip();
                            }, f.prototype.iadd = function(N) {
                                var W;
                                if (this.negative !== 0 && N.negative === 0) return this.negative = 0, W = this.isub(N), this.negative ^= 1, this._normSign();
                                if (this.negative === 0 && N.negative !== 0) return N.negative = 0, W = this.isub(N), N.negative = 1, W._normSign();
                                var re, ae;
                                this.length > N.length ? (re = this, ae = N) : (re = N, ae = this);
                                for(var _e = 0, Me = 0; Me < ae.length; Me++)W = (re.words[Me] | 0) + (ae.words[Me] | 0) + _e, this.words[Me] = W & 67108863, _e = W >>> 26;
                                for(; _e !== 0 && Me < re.length; Me++)W = (re.words[Me] | 0) + _e, this.words[Me] = W & 67108863, _e = W >>> 26;
                                if (this.length = re.length, _e !== 0) this.words[this.length] = _e, this.length++;
                                else if (re !== this) for(; Me < re.length; Me++)this.words[Me] = re.words[Me];
                                return this;
                            }, f.prototype.add = function(N) {
                                var W;
                                return N.negative !== 0 && this.negative === 0 ? (N.negative = 0, W = this.sub(N), N.negative ^= 1, W) : N.negative === 0 && this.negative !== 0 ? (this.negative = 0, W = N.sub(this), this.negative = 1, W) : this.length > N.length ? this.clone().iadd(N) : N.clone().iadd(this);
                            }, f.prototype.isub = function(N) {
                                if (N.negative !== 0) {
                                    N.negative = 0;
                                    var W = this.iadd(N);
                                    return N.negative = 1, W._normSign();
                                } else if (this.negative !== 0) return this.negative = 0, this.iadd(N), this.negative = 1, this._normSign();
                                var re = this.cmp(N);
                                if (re === 0) return this.negative = 0, this.length = 1, this.words[0] = 0, this;
                                var ae, _e;
                                re > 0 ? (ae = this, _e = N) : (ae = N, _e = this);
                                for(var Me = 0, ke = 0; ke < _e.length; ke++)W = (ae.words[ke] | 0) - (_e.words[ke] | 0) + Me, Me = W >> 26, this.words[ke] = W & 67108863;
                                for(; Me !== 0 && ke < ae.length; ke++)W = (ae.words[ke] | 0) + Me, Me = W >> 26, this.words[ke] = W & 67108863;
                                if (Me === 0 && ke < ae.length && ae !== this) for(; ke < ae.length; ke++)this.words[ke] = ae.words[ke];
                                return this.length = Math.max(this.length, ke), ae !== this && (this.negative = 1), this.strip();
                            }, f.prototype.sub = function(N) {
                                return this.clone().isub(N);
                            };
                            function A(G, N, W) {
                                W.negative = N.negative ^ G.negative;
                                var re = G.length + N.length | 0;
                                W.length = re, re = re - 1 | 0;
                                var ae = G.words[0] | 0, _e = N.words[0] | 0, Me = ae * _e, ke = Me & 67108863, ge = Me / 67108864 | 0;
                                W.words[0] = ke;
                                for(var ie = 1; ie < re; ie++){
                                    for(var Te = ge >>> 26, Ee = ge & 67108863, Ae = Math.min(ie, N.length - 1), ze = Math.max(0, ie - G.length + 1); ze <= Ae; ze++){
                                        var Ce = ie - ze | 0;
                                        ae = G.words[Ce] | 0, _e = N.words[ze] | 0, Me = ae * _e + Ee, Te += Me / 67108864 | 0, Ee = Me & 67108863;
                                    }
                                    W.words[ie] = Ee | 0, ge = Te | 0;
                                }
                                return ge !== 0 ? W.words[ie] = ge | 0 : W.length--, W.strip();
                            }
                            var L = function(N, W, re) {
                                var ae = N.words, _e = W.words, Me = re.words, ke = 0, ge, ie, Te, Ee = ae[0] | 0, Ae = Ee & 8191, ze = Ee >>> 13, Ce = ae[1] | 0, me = Ce & 8191, Re = Ce >>> 13, ce = ae[2] | 0, Ge = ce & 8191, nt = ce >>> 13, ct = ae[3] | 0, qt = ct & 8191, rt = ct >>> 13, ot = ae[4] | 0, Rt = ot & 8191, kt = ot >>> 13, Ct = ae[5] | 0, Yt = Ct & 8191, xr = Ct >>> 13, er = ae[6] | 0, Ke = er & 8191, xt = er >>> 13, bt = ae[7] | 0, Lt = bt & 8191, St = bt >>> 13, Et = ae[8] | 0, dt = Et & 8191, Ht = Et >>> 13, $t = ae[9] | 0, fr = $t & 8191, _r = $t >>> 13, Br = _e[0] | 0, Or = Br & 8191, Nr = Br >>> 13, ut = _e[1] | 0, Ne = ut & 8191, Ye = ut >>> 13, Ve = _e[2] | 0, Xe = Ve & 8191, ht = Ve >>> 13, Le = _e[3] | 0, xe = Le & 8191, Se = Le >>> 13, lt = _e[4] | 0, Gt = lt & 8191, Vt = lt >>> 13, ar = _e[5] | 0, Qr = ar & 8191, ai = ar >>> 13, jr = _e[6] | 0, ri = jr & 8191, bi = jr >>> 13, nn = _e[7] | 0, Wi = nn & 8191, Ni = nn >>> 13, _n = _e[8] | 0, $i = _n & 8191, zn = _n >>> 13, Wn = _e[9] | 0, It = Wn & 8191, ft = Wn >>> 13;
                                re.negative = N.negative ^ W.negative, re.length = 19, ge = Math.imul(Ae, Or), ie = Math.imul(Ae, Nr), ie = ie + Math.imul(ze, Or) | 0, Te = Math.imul(ze, Nr);
                                var jt = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (jt >>> 26) | 0, jt &= 67108863, ge = Math.imul(me, Or), ie = Math.imul(me, Nr), ie = ie + Math.imul(Re, Or) | 0, Te = Math.imul(Re, Nr), ge = ge + Math.imul(Ae, Ne) | 0, ie = ie + Math.imul(Ae, Ye) | 0, ie = ie + Math.imul(ze, Ne) | 0, Te = Te + Math.imul(ze, Ye) | 0;
                                var Zt = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Zt >>> 26) | 0, Zt &= 67108863, ge = Math.imul(Ge, Or), ie = Math.imul(Ge, Nr), ie = ie + Math.imul(nt, Or) | 0, Te = Math.imul(nt, Nr), ge = ge + Math.imul(me, Ne) | 0, ie = ie + Math.imul(me, Ye) | 0, ie = ie + Math.imul(Re, Ne) | 0, Te = Te + Math.imul(Re, Ye) | 0, ge = ge + Math.imul(Ae, Xe) | 0, ie = ie + Math.imul(Ae, ht) | 0, ie = ie + Math.imul(ze, Xe) | 0, Te = Te + Math.imul(ze, ht) | 0;
                                var yr = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (yr >>> 26) | 0, yr &= 67108863, ge = Math.imul(qt, Or), ie = Math.imul(qt, Nr), ie = ie + Math.imul(rt, Or) | 0, Te = Math.imul(rt, Nr), ge = ge + Math.imul(Ge, Ne) | 0, ie = ie + Math.imul(Ge, Ye) | 0, ie = ie + Math.imul(nt, Ne) | 0, Te = Te + Math.imul(nt, Ye) | 0, ge = ge + Math.imul(me, Xe) | 0, ie = ie + Math.imul(me, ht) | 0, ie = ie + Math.imul(Re, Xe) | 0, Te = Te + Math.imul(Re, ht) | 0, ge = ge + Math.imul(Ae, xe) | 0, ie = ie + Math.imul(Ae, Se) | 0, ie = ie + Math.imul(ze, xe) | 0, Te = Te + Math.imul(ze, Se) | 0;
                                var Fr = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Fr >>> 26) | 0, Fr &= 67108863, ge = Math.imul(Rt, Or), ie = Math.imul(Rt, Nr), ie = ie + Math.imul(kt, Or) | 0, Te = Math.imul(kt, Nr), ge = ge + Math.imul(qt, Ne) | 0, ie = ie + Math.imul(qt, Ye) | 0, ie = ie + Math.imul(rt, Ne) | 0, Te = Te + Math.imul(rt, Ye) | 0, ge = ge + Math.imul(Ge, Xe) | 0, ie = ie + Math.imul(Ge, ht) | 0, ie = ie + Math.imul(nt, Xe) | 0, Te = Te + Math.imul(nt, ht) | 0, ge = ge + Math.imul(me, xe) | 0, ie = ie + Math.imul(me, Se) | 0, ie = ie + Math.imul(Re, xe) | 0, Te = Te + Math.imul(Re, Se) | 0, ge = ge + Math.imul(Ae, Gt) | 0, ie = ie + Math.imul(Ae, Vt) | 0, ie = ie + Math.imul(ze, Gt) | 0, Te = Te + Math.imul(ze, Vt) | 0;
                                var Zr = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Zr >>> 26) | 0, Zr &= 67108863, ge = Math.imul(Yt, Or), ie = Math.imul(Yt, Nr), ie = ie + Math.imul(xr, Or) | 0, Te = Math.imul(xr, Nr), ge = ge + Math.imul(Rt, Ne) | 0, ie = ie + Math.imul(Rt, Ye) | 0, ie = ie + Math.imul(kt, Ne) | 0, Te = Te + Math.imul(kt, Ye) | 0, ge = ge + Math.imul(qt, Xe) | 0, ie = ie + Math.imul(qt, ht) | 0, ie = ie + Math.imul(rt, Xe) | 0, Te = Te + Math.imul(rt, ht) | 0, ge = ge + Math.imul(Ge, xe) | 0, ie = ie + Math.imul(Ge, Se) | 0, ie = ie + Math.imul(nt, xe) | 0, Te = Te + Math.imul(nt, Se) | 0, ge = ge + Math.imul(me, Gt) | 0, ie = ie + Math.imul(me, Vt) | 0, ie = ie + Math.imul(Re, Gt) | 0, Te = Te + Math.imul(Re, Vt) | 0, ge = ge + Math.imul(Ae, Qr) | 0, ie = ie + Math.imul(Ae, ai) | 0, ie = ie + Math.imul(ze, Qr) | 0, Te = Te + Math.imul(ze, ai) | 0;
                                var Vr = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Vr >>> 26) | 0, Vr &= 67108863, ge = Math.imul(Ke, Or), ie = Math.imul(Ke, Nr), ie = ie + Math.imul(xt, Or) | 0, Te = Math.imul(xt, Nr), ge = ge + Math.imul(Yt, Ne) | 0, ie = ie + Math.imul(Yt, Ye) | 0, ie = ie + Math.imul(xr, Ne) | 0, Te = Te + Math.imul(xr, Ye) | 0, ge = ge + Math.imul(Rt, Xe) | 0, ie = ie + Math.imul(Rt, ht) | 0, ie = ie + Math.imul(kt, Xe) | 0, Te = Te + Math.imul(kt, ht) | 0, ge = ge + Math.imul(qt, xe) | 0, ie = ie + Math.imul(qt, Se) | 0, ie = ie + Math.imul(rt, xe) | 0, Te = Te + Math.imul(rt, Se) | 0, ge = ge + Math.imul(Ge, Gt) | 0, ie = ie + Math.imul(Ge, Vt) | 0, ie = ie + Math.imul(nt, Gt) | 0, Te = Te + Math.imul(nt, Vt) | 0, ge = ge + Math.imul(me, Qr) | 0, ie = ie + Math.imul(me, ai) | 0, ie = ie + Math.imul(Re, Qr) | 0, Te = Te + Math.imul(Re, ai) | 0, ge = ge + Math.imul(Ae, ri) | 0, ie = ie + Math.imul(Ae, bi) | 0, ie = ie + Math.imul(ze, ri) | 0, Te = Te + Math.imul(ze, bi) | 0;
                                var gi = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (gi >>> 26) | 0, gi &= 67108863, ge = Math.imul(Lt, Or), ie = Math.imul(Lt, Nr), ie = ie + Math.imul(St, Or) | 0, Te = Math.imul(St, Nr), ge = ge + Math.imul(Ke, Ne) | 0, ie = ie + Math.imul(Ke, Ye) | 0, ie = ie + Math.imul(xt, Ne) | 0, Te = Te + Math.imul(xt, Ye) | 0, ge = ge + Math.imul(Yt, Xe) | 0, ie = ie + Math.imul(Yt, ht) | 0, ie = ie + Math.imul(xr, Xe) | 0, Te = Te + Math.imul(xr, ht) | 0, ge = ge + Math.imul(Rt, xe) | 0, ie = ie + Math.imul(Rt, Se) | 0, ie = ie + Math.imul(kt, xe) | 0, Te = Te + Math.imul(kt, Se) | 0, ge = ge + Math.imul(qt, Gt) | 0, ie = ie + Math.imul(qt, Vt) | 0, ie = ie + Math.imul(rt, Gt) | 0, Te = Te + Math.imul(rt, Vt) | 0, ge = ge + Math.imul(Ge, Qr) | 0, ie = ie + Math.imul(Ge, ai) | 0, ie = ie + Math.imul(nt, Qr) | 0, Te = Te + Math.imul(nt, ai) | 0, ge = ge + Math.imul(me, ri) | 0, ie = ie + Math.imul(me, bi) | 0, ie = ie + Math.imul(Re, ri) | 0, Te = Te + Math.imul(Re, bi) | 0, ge = ge + Math.imul(Ae, Wi) | 0, ie = ie + Math.imul(Ae, Ni) | 0, ie = ie + Math.imul(ze, Wi) | 0, Te = Te + Math.imul(ze, Ni) | 0;
                                var Si = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Si >>> 26) | 0, Si &= 67108863, ge = Math.imul(dt, Or), ie = Math.imul(dt, Nr), ie = ie + Math.imul(Ht, Or) | 0, Te = Math.imul(Ht, Nr), ge = ge + Math.imul(Lt, Ne) | 0, ie = ie + Math.imul(Lt, Ye) | 0, ie = ie + Math.imul(St, Ne) | 0, Te = Te + Math.imul(St, Ye) | 0, ge = ge + Math.imul(Ke, Xe) | 0, ie = ie + Math.imul(Ke, ht) | 0, ie = ie + Math.imul(xt, Xe) | 0, Te = Te + Math.imul(xt, ht) | 0, ge = ge + Math.imul(Yt, xe) | 0, ie = ie + Math.imul(Yt, Se) | 0, ie = ie + Math.imul(xr, xe) | 0, Te = Te + Math.imul(xr, Se) | 0, ge = ge + Math.imul(Rt, Gt) | 0, ie = ie + Math.imul(Rt, Vt) | 0, ie = ie + Math.imul(kt, Gt) | 0, Te = Te + Math.imul(kt, Vt) | 0, ge = ge + Math.imul(qt, Qr) | 0, ie = ie + Math.imul(qt, ai) | 0, ie = ie + Math.imul(rt, Qr) | 0, Te = Te + Math.imul(rt, ai) | 0, ge = ge + Math.imul(Ge, ri) | 0, ie = ie + Math.imul(Ge, bi) | 0, ie = ie + Math.imul(nt, ri) | 0, Te = Te + Math.imul(nt, bi) | 0, ge = ge + Math.imul(me, Wi) | 0, ie = ie + Math.imul(me, Ni) | 0, ie = ie + Math.imul(Re, Wi) | 0, Te = Te + Math.imul(Re, Ni) | 0, ge = ge + Math.imul(Ae, $i) | 0, ie = ie + Math.imul(Ae, zn) | 0, ie = ie + Math.imul(ze, $i) | 0, Te = Te + Math.imul(ze, zn) | 0;
                                var Mi = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Mi >>> 26) | 0, Mi &= 67108863, ge = Math.imul(fr, Or), ie = Math.imul(fr, Nr), ie = ie + Math.imul(_r, Or) | 0, Te = Math.imul(_r, Nr), ge = ge + Math.imul(dt, Ne) | 0, ie = ie + Math.imul(dt, Ye) | 0, ie = ie + Math.imul(Ht, Ne) | 0, Te = Te + Math.imul(Ht, Ye) | 0, ge = ge + Math.imul(Lt, Xe) | 0, ie = ie + Math.imul(Lt, ht) | 0, ie = ie + Math.imul(St, Xe) | 0, Te = Te + Math.imul(St, ht) | 0, ge = ge + Math.imul(Ke, xe) | 0, ie = ie + Math.imul(Ke, Se) | 0, ie = ie + Math.imul(xt, xe) | 0, Te = Te + Math.imul(xt, Se) | 0, ge = ge + Math.imul(Yt, Gt) | 0, ie = ie + Math.imul(Yt, Vt) | 0, ie = ie + Math.imul(xr, Gt) | 0, Te = Te + Math.imul(xr, Vt) | 0, ge = ge + Math.imul(Rt, Qr) | 0, ie = ie + Math.imul(Rt, ai) | 0, ie = ie + Math.imul(kt, Qr) | 0, Te = Te + Math.imul(kt, ai) | 0, ge = ge + Math.imul(qt, ri) | 0, ie = ie + Math.imul(qt, bi) | 0, ie = ie + Math.imul(rt, ri) | 0, Te = Te + Math.imul(rt, bi) | 0, ge = ge + Math.imul(Ge, Wi) | 0, ie = ie + Math.imul(Ge, Ni) | 0, ie = ie + Math.imul(nt, Wi) | 0, Te = Te + Math.imul(nt, Ni) | 0, ge = ge + Math.imul(me, $i) | 0, ie = ie + Math.imul(me, zn) | 0, ie = ie + Math.imul(Re, $i) | 0, Te = Te + Math.imul(Re, zn) | 0, ge = ge + Math.imul(Ae, It) | 0, ie = ie + Math.imul(Ae, ft) | 0, ie = ie + Math.imul(ze, It) | 0, Te = Te + Math.imul(ze, ft) | 0;
                                var Pi = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Pi >>> 26) | 0, Pi &= 67108863, ge = Math.imul(fr, Ne), ie = Math.imul(fr, Ye), ie = ie + Math.imul(_r, Ne) | 0, Te = Math.imul(_r, Ye), ge = ge + Math.imul(dt, Xe) | 0, ie = ie + Math.imul(dt, ht) | 0, ie = ie + Math.imul(Ht, Xe) | 0, Te = Te + Math.imul(Ht, ht) | 0, ge = ge + Math.imul(Lt, xe) | 0, ie = ie + Math.imul(Lt, Se) | 0, ie = ie + Math.imul(St, xe) | 0, Te = Te + Math.imul(St, Se) | 0, ge = ge + Math.imul(Ke, Gt) | 0, ie = ie + Math.imul(Ke, Vt) | 0, ie = ie + Math.imul(xt, Gt) | 0, Te = Te + Math.imul(xt, Vt) | 0, ge = ge + Math.imul(Yt, Qr) | 0, ie = ie + Math.imul(Yt, ai) | 0, ie = ie + Math.imul(xr, Qr) | 0, Te = Te + Math.imul(xr, ai) | 0, ge = ge + Math.imul(Rt, ri) | 0, ie = ie + Math.imul(Rt, bi) | 0, ie = ie + Math.imul(kt, ri) | 0, Te = Te + Math.imul(kt, bi) | 0, ge = ge + Math.imul(qt, Wi) | 0, ie = ie + Math.imul(qt, Ni) | 0, ie = ie + Math.imul(rt, Wi) | 0, Te = Te + Math.imul(rt, Ni) | 0, ge = ge + Math.imul(Ge, $i) | 0, ie = ie + Math.imul(Ge, zn) | 0, ie = ie + Math.imul(nt, $i) | 0, Te = Te + Math.imul(nt, zn) | 0, ge = ge + Math.imul(me, It) | 0, ie = ie + Math.imul(me, ft) | 0, ie = ie + Math.imul(Re, It) | 0, Te = Te + Math.imul(Re, ft) | 0;
                                var Gi = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Gi >>> 26) | 0, Gi &= 67108863, ge = Math.imul(fr, Xe), ie = Math.imul(fr, ht), ie = ie + Math.imul(_r, Xe) | 0, Te = Math.imul(_r, ht), ge = ge + Math.imul(dt, xe) | 0, ie = ie + Math.imul(dt, Se) | 0, ie = ie + Math.imul(Ht, xe) | 0, Te = Te + Math.imul(Ht, Se) | 0, ge = ge + Math.imul(Lt, Gt) | 0, ie = ie + Math.imul(Lt, Vt) | 0, ie = ie + Math.imul(St, Gt) | 0, Te = Te + Math.imul(St, Vt) | 0, ge = ge + Math.imul(Ke, Qr) | 0, ie = ie + Math.imul(Ke, ai) | 0, ie = ie + Math.imul(xt, Qr) | 0, Te = Te + Math.imul(xt, ai) | 0, ge = ge + Math.imul(Yt, ri) | 0, ie = ie + Math.imul(Yt, bi) | 0, ie = ie + Math.imul(xr, ri) | 0, Te = Te + Math.imul(xr, bi) | 0, ge = ge + Math.imul(Rt, Wi) | 0, ie = ie + Math.imul(Rt, Ni) | 0, ie = ie + Math.imul(kt, Wi) | 0, Te = Te + Math.imul(kt, Ni) | 0, ge = ge + Math.imul(qt, $i) | 0, ie = ie + Math.imul(qt, zn) | 0, ie = ie + Math.imul(rt, $i) | 0, Te = Te + Math.imul(rt, zn) | 0, ge = ge + Math.imul(Ge, It) | 0, ie = ie + Math.imul(Ge, ft) | 0, ie = ie + Math.imul(nt, It) | 0, Te = Te + Math.imul(nt, ft) | 0;
                                var Ki = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Ki >>> 26) | 0, Ki &= 67108863, ge = Math.imul(fr, xe), ie = Math.imul(fr, Se), ie = ie + Math.imul(_r, xe) | 0, Te = Math.imul(_r, Se), ge = ge + Math.imul(dt, Gt) | 0, ie = ie + Math.imul(dt, Vt) | 0, ie = ie + Math.imul(Ht, Gt) | 0, Te = Te + Math.imul(Ht, Vt) | 0, ge = ge + Math.imul(Lt, Qr) | 0, ie = ie + Math.imul(Lt, ai) | 0, ie = ie + Math.imul(St, Qr) | 0, Te = Te + Math.imul(St, ai) | 0, ge = ge + Math.imul(Ke, ri) | 0, ie = ie + Math.imul(Ke, bi) | 0, ie = ie + Math.imul(xt, ri) | 0, Te = Te + Math.imul(xt, bi) | 0, ge = ge + Math.imul(Yt, Wi) | 0, ie = ie + Math.imul(Yt, Ni) | 0, ie = ie + Math.imul(xr, Wi) | 0, Te = Te + Math.imul(xr, Ni) | 0, ge = ge + Math.imul(Rt, $i) | 0, ie = ie + Math.imul(Rt, zn) | 0, ie = ie + Math.imul(kt, $i) | 0, Te = Te + Math.imul(kt, zn) | 0, ge = ge + Math.imul(qt, It) | 0, ie = ie + Math.imul(qt, ft) | 0, ie = ie + Math.imul(rt, It) | 0, Te = Te + Math.imul(rt, ft) | 0;
                                var ka = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (ka >>> 26) | 0, ka &= 67108863, ge = Math.imul(fr, Gt), ie = Math.imul(fr, Vt), ie = ie + Math.imul(_r, Gt) | 0, Te = Math.imul(_r, Vt), ge = ge + Math.imul(dt, Qr) | 0, ie = ie + Math.imul(dt, ai) | 0, ie = ie + Math.imul(Ht, Qr) | 0, Te = Te + Math.imul(Ht, ai) | 0, ge = ge + Math.imul(Lt, ri) | 0, ie = ie + Math.imul(Lt, bi) | 0, ie = ie + Math.imul(St, ri) | 0, Te = Te + Math.imul(St, bi) | 0, ge = ge + Math.imul(Ke, Wi) | 0, ie = ie + Math.imul(Ke, Ni) | 0, ie = ie + Math.imul(xt, Wi) | 0, Te = Te + Math.imul(xt, Ni) | 0, ge = ge + Math.imul(Yt, $i) | 0, ie = ie + Math.imul(Yt, zn) | 0, ie = ie + Math.imul(xr, $i) | 0, Te = Te + Math.imul(xr, zn) | 0, ge = ge + Math.imul(Rt, It) | 0, ie = ie + Math.imul(Rt, ft) | 0, ie = ie + Math.imul(kt, It) | 0, Te = Te + Math.imul(kt, ft) | 0;
                                var jn = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (jn >>> 26) | 0, jn &= 67108863, ge = Math.imul(fr, Qr), ie = Math.imul(fr, ai), ie = ie + Math.imul(_r, Qr) | 0, Te = Math.imul(_r, ai), ge = ge + Math.imul(dt, ri) | 0, ie = ie + Math.imul(dt, bi) | 0, ie = ie + Math.imul(Ht, ri) | 0, Te = Te + Math.imul(Ht, bi) | 0, ge = ge + Math.imul(Lt, Wi) | 0, ie = ie + Math.imul(Lt, Ni) | 0, ie = ie + Math.imul(St, Wi) | 0, Te = Te + Math.imul(St, Ni) | 0, ge = ge + Math.imul(Ke, $i) | 0, ie = ie + Math.imul(Ke, zn) | 0, ie = ie + Math.imul(xt, $i) | 0, Te = Te + Math.imul(xt, zn) | 0, ge = ge + Math.imul(Yt, It) | 0, ie = ie + Math.imul(Yt, ft) | 0, ie = ie + Math.imul(xr, It) | 0, Te = Te + Math.imul(xr, ft) | 0;
                                var la = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (la >>> 26) | 0, la &= 67108863, ge = Math.imul(fr, ri), ie = Math.imul(fr, bi), ie = ie + Math.imul(_r, ri) | 0, Te = Math.imul(_r, bi), ge = ge + Math.imul(dt, Wi) | 0, ie = ie + Math.imul(dt, Ni) | 0, ie = ie + Math.imul(Ht, Wi) | 0, Te = Te + Math.imul(Ht, Ni) | 0, ge = ge + Math.imul(Lt, $i) | 0, ie = ie + Math.imul(Lt, zn) | 0, ie = ie + Math.imul(St, $i) | 0, Te = Te + Math.imul(St, zn) | 0, ge = ge + Math.imul(Ke, It) | 0, ie = ie + Math.imul(Ke, ft) | 0, ie = ie + Math.imul(xt, It) | 0, Te = Te + Math.imul(xt, ft) | 0;
                                var Fa = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Fa >>> 26) | 0, Fa &= 67108863, ge = Math.imul(fr, Wi), ie = Math.imul(fr, Ni), ie = ie + Math.imul(_r, Wi) | 0, Te = Math.imul(_r, Ni), ge = ge + Math.imul(dt, $i) | 0, ie = ie + Math.imul(dt, zn) | 0, ie = ie + Math.imul(Ht, $i) | 0, Te = Te + Math.imul(Ht, zn) | 0, ge = ge + Math.imul(Lt, It) | 0, ie = ie + Math.imul(Lt, ft) | 0, ie = ie + Math.imul(St, It) | 0, Te = Te + Math.imul(St, ft) | 0;
                                var Ra = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (Ra >>> 26) | 0, Ra &= 67108863, ge = Math.imul(fr, $i), ie = Math.imul(fr, zn), ie = ie + Math.imul(_r, $i) | 0, Te = Math.imul(_r, zn), ge = ge + Math.imul(dt, It) | 0, ie = ie + Math.imul(dt, ft) | 0, ie = ie + Math.imul(Ht, It) | 0, Te = Te + Math.imul(Ht, ft) | 0;
                                var jo = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                ke = (Te + (ie >>> 13) | 0) + (jo >>> 26) | 0, jo &= 67108863, ge = Math.imul(fr, It), ie = Math.imul(fr, ft), ie = ie + Math.imul(_r, It) | 0, Te = Math.imul(_r, ft);
                                var oa = (ke + ge | 0) + ((ie & 8191) << 13) | 0;
                                return ke = (Te + (ie >>> 13) | 0) + (oa >>> 26) | 0, oa &= 67108863, Me[0] = jt, Me[1] = Zt, Me[2] = yr, Me[3] = Fr, Me[4] = Zr, Me[5] = Vr, Me[6] = gi, Me[7] = Si, Me[8] = Mi, Me[9] = Pi, Me[10] = Gi, Me[11] = Ki, Me[12] = ka, Me[13] = jn, Me[14] = la, Me[15] = Fa, Me[16] = Ra, Me[17] = jo, Me[18] = oa, ke !== 0 && (Me[19] = ke, re.length++), re;
                            };
                            Math.imul || (L = A);
                            function _(G, N, W) {
                                W.negative = N.negative ^ G.negative, W.length = G.length + N.length;
                                for(var re = 0, ae = 0, _e = 0; _e < W.length - 1; _e++){
                                    var Me = ae;
                                    ae = 0;
                                    for(var ke = re & 67108863, ge = Math.min(_e, N.length - 1), ie = Math.max(0, _e - G.length + 1); ie <= ge; ie++){
                                        var Te = _e - ie, Ee = G.words[Te] | 0, Ae = N.words[ie] | 0, ze = Ee * Ae, Ce = ze & 67108863;
                                        Me = Me + (ze / 67108864 | 0) | 0, Ce = Ce + ke | 0, ke = Ce & 67108863, Me = Me + (Ce >>> 26) | 0, ae += Me >>> 26, Me &= 67108863;
                                    }
                                    W.words[_e] = ke, re = Me, Me = ae;
                                }
                                return re !== 0 ? W.words[_e] = re : W.length--, W.strip();
                            }
                            function C(G, N, W) {
                                var re = new M;
                                return re.mulp(G, N, W);
                            }
                            f.prototype.mulTo = function(N, W) {
                                var re, ae = this.length + N.length;
                                return this.length === 10 && N.length === 10 ? re = L(this, N, W) : ae < 63 ? re = A(this, N, W) : ae < 1024 ? re = _(this, N, W) : re = C(this, N, W), re;
                            };
                            function M(G, N) {
                                this.x = G, this.y = N;
                            }
                            M.prototype.makeRBT = function(N) {
                                for(var W = new Array(N), re = f.prototype._countBits(N) - 1, ae = 0; ae < N; ae++)W[ae] = this.revBin(ae, re, N);
                                return W;
                            }, M.prototype.revBin = function(N, W, re) {
                                if (N === 0 || N === re - 1) return N;
                                for(var ae = 0, _e = 0; _e < W; _e++)ae |= (N & 1) << W - _e - 1, N >>= 1;
                                return ae;
                            }, M.prototype.permute = function(N, W, re, ae, _e, Me) {
                                for(var ke = 0; ke < Me; ke++)ae[ke] = W[N[ke]], _e[ke] = re[N[ke]];
                            }, M.prototype.transform = function(N, W, re, ae, _e, Me) {
                                this.permute(Me, N, W, re, ae, _e);
                                for(var ke = 1; ke < _e; ke <<= 1)for(var ge = ke << 1, ie = Math.cos(2 * Math.PI / ge), Te = Math.sin(2 * Math.PI / ge), Ee = 0; Ee < _e; Ee += ge)for(var Ae = ie, ze = Te, Ce = 0; Ce < ke; Ce++){
                                    var me = re[Ee + Ce], Re = ae[Ee + Ce], ce = re[Ee + Ce + ke], Ge = ae[Ee + Ce + ke], nt = Ae * ce - ze * Ge;
                                    Ge = Ae * Ge + ze * ce, ce = nt, re[Ee + Ce] = me + ce, ae[Ee + Ce] = Re + Ge, re[Ee + Ce + ke] = me - ce, ae[Ee + Ce + ke] = Re - Ge, Ce !== ge && (nt = ie * Ae - Te * ze, ze = ie * ze + Te * Ae, Ae = nt);
                                }
                            }, M.prototype.guessLen13b = function(N, W) {
                                var re = Math.max(W, N) | 1, ae = re & 1, _e = 0;
                                for(re = re / 2 | 0; re; re = re >>> 1)_e++;
                                return 1 << _e + 1 + ae;
                            }, M.prototype.conjugate = function(N, W, re) {
                                if (!(re <= 1)) for(var ae = 0; ae < re / 2; ae++){
                                    var _e = N[ae];
                                    N[ae] = N[re - ae - 1], N[re - ae - 1] = _e, _e = W[ae], W[ae] = -W[re - ae - 1], W[re - ae - 1] = -_e;
                                }
                            }, M.prototype.normalize13b = function(N, W) {
                                for(var re = 0, ae = 0; ae < W / 2; ae++){
                                    var _e = Math.round(N[2 * ae + 1] / W) * 8192 + Math.round(N[2 * ae] / W) + re;
                                    N[ae] = _e & 67108863, _e < 67108864 ? re = 0 : re = _e / 67108864 | 0;
                                }
                                return N;
                            }, M.prototype.convert13b = function(N, W, re, ae) {
                                for(var _e = 0, Me = 0; Me < W; Me++)_e = _e + (N[Me] | 0), re[2 * Me] = _e & 8191, _e = _e >>> 13, re[2 * Me + 1] = _e & 8191, _e = _e >>> 13;
                                for(Me = 2 * W; Me < ae; ++Me)re[Me] = 0;
                                u(_e === 0), u((_e & -8192) === 0);
                            }, M.prototype.stub = function(N) {
                                for(var W = new Array(N), re = 0; re < N; re++)W[re] = 0;
                                return W;
                            }, M.prototype.mulp = function(N, W, re) {
                                var ae = 2 * this.guessLen13b(N.length, W.length), _e = this.makeRBT(ae), Me = this.stub(ae), ke = new Array(ae), ge = new Array(ae), ie = new Array(ae), Te = new Array(ae), Ee = new Array(ae), Ae = new Array(ae), ze = re.words;
                                ze.length = ae, this.convert13b(N.words, N.length, ke, ae), this.convert13b(W.words, W.length, Te, ae), this.transform(ke, Me, ge, ie, ae, _e), this.transform(Te, Me, Ee, Ae, ae, _e);
                                for(var Ce = 0; Ce < ae; Ce++){
                                    var me = ge[Ce] * Ee[Ce] - ie[Ce] * Ae[Ce];
                                    ie[Ce] = ge[Ce] * Ae[Ce] + ie[Ce] * Ee[Ce], ge[Ce] = me;
                                }
                                return this.conjugate(ge, ie, ae), this.transform(ge, ie, ze, Me, ae, _e), this.conjugate(ze, Me, ae), this.normalize13b(ze, ae), re.negative = N.negative ^ W.negative, re.length = N.length + W.length, re.strip();
                            }, f.prototype.mul = function(N) {
                                var W = new f(null);
                                return W.words = new Array(this.length + N.length), this.mulTo(N, W);
                            }, f.prototype.mulf = function(N) {
                                var W = new f(null);
                                return W.words = new Array(this.length + N.length), C(this, N, W);
                            }, f.prototype.imul = function(N) {
                                return this.clone().mulTo(N, this);
                            }, f.prototype.imuln = function(N) {
                                u(typeof N == "number"), u(N < 67108864);
                                for(var W = 0, re = 0; re < this.length; re++){
                                    var ae = (this.words[re] | 0) * N, _e = (ae & 67108863) + (W & 67108863);
                                    W >>= 26, W += ae / 67108864 | 0, W += _e >>> 26, this.words[re] = _e & 67108863;
                                }
                                return W !== 0 && (this.words[re] = W, this.length++), this;
                            }, f.prototype.muln = function(N) {
                                return this.clone().imuln(N);
                            }, f.prototype.sqr = function() {
                                return this.mul(this);
                            }, f.prototype.isqr = function() {
                                return this.imul(this.clone());
                            }, f.prototype.pow = function(N) {
                                var W = k(N);
                                if (W.length === 0) return new f(1);
                                for(var re = this, ae = 0; ae < W.length && W[ae] === 0; ae++, re = re.sqr());
                                if (++ae < W.length) for(var _e = re.sqr(); ae < W.length; ae++, _e = _e.sqr())W[ae] !== 0 && (re = re.mul(_e));
                                return re;
                            }, f.prototype.iushln = function(N) {
                                u(typeof N == "number" && N >= 0);
                                var W = N % 26, re = (N - W) / 26, ae = 67108863 >>> 26 - W << 26 - W, _e;
                                if (W !== 0) {
                                    var Me = 0;
                                    for(_e = 0; _e < this.length; _e++){
                                        var ke = this.words[_e] & ae, ge = (this.words[_e] | 0) - ke << W;
                                        this.words[_e] = ge | Me, Me = ke >>> 26 - W;
                                    }
                                    Me && (this.words[_e] = Me, this.length++);
                                }
                                if (re !== 0) {
                                    for(_e = this.length - 1; _e >= 0; _e--)this.words[_e + re] = this.words[_e];
                                    for(_e = 0; _e < re; _e++)this.words[_e] = 0;
                                    this.length += re;
                                }
                                return this.strip();
                            }, f.prototype.ishln = function(N) {
                                return u(this.negative === 0), this.iushln(N);
                            }, f.prototype.iushrn = function(N, W, re) {
                                u(typeof N == "number" && N >= 0);
                                var ae;
                                W ? ae = (W - W % 26) / 26 : ae = 0;
                                var _e = N % 26, Me = Math.min((N - _e) / 26, this.length), ke = 67108863 ^ 67108863 >>> _e << _e, ge = re;
                                if (ae -= Me, ae = Math.max(0, ae), ge) {
                                    for(var ie = 0; ie < Me; ie++)ge.words[ie] = this.words[ie];
                                    ge.length = Me;
                                }
                                if (Me !== 0) {
                                    if (this.length > Me) for(this.length -= Me, ie = 0; ie < this.length; ie++)this.words[ie] = this.words[ie + Me];
                                    else this.words[0] = 0, this.length = 1;
                                }
                                var Te = 0;
                                for(ie = this.length - 1; ie >= 0 && (Te !== 0 || ie >= ae); ie--){
                                    var Ee = this.words[ie] | 0;
                                    this.words[ie] = Te << 26 - _e | Ee >>> _e, Te = Ee & ke;
                                }
                                return ge && Te !== 0 && (ge.words[ge.length++] = Te), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
                            }, f.prototype.ishrn = function(N, W, re) {
                                return u(this.negative === 0), this.iushrn(N, W, re);
                            }, f.prototype.shln = function(N) {
                                return this.clone().ishln(N);
                            }, f.prototype.ushln = function(N) {
                                return this.clone().iushln(N);
                            }, f.prototype.shrn = function(N) {
                                return this.clone().ishrn(N);
                            }, f.prototype.ushrn = function(N) {
                                return this.clone().iushrn(N);
                            }, f.prototype.testn = function(N) {
                                u(typeof N == "number" && N >= 0);
                                var W = N % 26, re = (N - W) / 26, ae = 1 << W;
                                if (this.length <= re) return !1;
                                var _e = this.words[re];
                                return !!(_e & ae);
                            }, f.prototype.imaskn = function(N) {
                                u(typeof N == "number" && N >= 0);
                                var W = N % 26, re = (N - W) / 26;
                                if (u(this.negative === 0, "imaskn works only with positive numbers"), this.length <= re) return this;
                                if (W !== 0 && re++, this.length = Math.min(re, this.length), W !== 0) {
                                    var ae = 67108863 ^ 67108863 >>> W << W;
                                    this.words[this.length - 1] &= ae;
                                }
                                return this.strip();
                            }, f.prototype.maskn = function(N) {
                                return this.clone().imaskn(N);
                            }, f.prototype.iaddn = function(N) {
                                return u(typeof N == "number"), u(N < 67108864), N < 0 ? this.isubn(-N) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < N ? (this.words[0] = N - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(N), this.negative = 1, this) : this._iaddn(N);
                            }, f.prototype._iaddn = function(N) {
                                this.words[0] += N;
                                for(var W = 0; W < this.length && this.words[W] >= 67108864; W++)this.words[W] -= 67108864, W === this.length - 1 ? this.words[W + 1] = 1 : this.words[W + 1]++;
                                return this.length = Math.max(this.length, W + 1), this;
                            }, f.prototype.isubn = function(N) {
                                if (u(typeof N == "number"), u(N < 67108864), N < 0) return this.iaddn(-N);
                                if (this.negative !== 0) return this.negative = 0, this.iaddn(N), this.negative = 1, this;
                                if (this.words[0] -= N, this.length === 1 && this.words[0] < 0) this.words[0] = -this.words[0], this.negative = 1;
                                else for(var W = 0; W < this.length && this.words[W] < 0; W++)this.words[W] += 67108864, this.words[W + 1] -= 1;
                                return this.strip();
                            }, f.prototype.addn = function(N) {
                                return this.clone().iaddn(N);
                            }, f.prototype.subn = function(N) {
                                return this.clone().isubn(N);
                            }, f.prototype.iabs = function() {
                                return this.negative = 0, this;
                            }, f.prototype.abs = function() {
                                return this.clone().iabs();
                            }, f.prototype._ishlnsubmul = function(N, W, re) {
                                var ae = N.length + re, _e;
                                this._expand(ae);
                                var Me, ke = 0;
                                for(_e = 0; _e < N.length; _e++){
                                    Me = (this.words[_e + re] | 0) + ke;
                                    var ge = (N.words[_e] | 0) * W;
                                    Me -= ge & 67108863, ke = (Me >> 26) - (ge / 67108864 | 0), this.words[_e + re] = Me & 67108863;
                                }
                                for(; _e < this.length - re; _e++)Me = (this.words[_e + re] | 0) + ke, ke = Me >> 26, this.words[_e + re] = Me & 67108863;
                                if (ke === 0) return this.strip();
                                for(u(ke === -1), ke = 0, _e = 0; _e < this.length; _e++)Me = -(this.words[_e] | 0) + ke, ke = Me >> 26, this.words[_e] = Me & 67108863;
                                return this.negative = 1, this.strip();
                            }, f.prototype._wordDiv = function(N, W) {
                                var re = this.length - N.length, ae = this.clone(), _e = N, Me = _e.words[_e.length - 1] | 0, ke = this._countBits(Me);
                                re = 26 - ke, re !== 0 && (_e = _e.ushln(re), ae.iushln(re), Me = _e.words[_e.length - 1] | 0);
                                var ge = ae.length - _e.length, ie;
                                if (W !== "mod") {
                                    ie = new f(null), ie.length = ge + 1, ie.words = new Array(ie.length);
                                    for(var Te = 0; Te < ie.length; Te++)ie.words[Te] = 0;
                                }
                                var Ee = ae.clone()._ishlnsubmul(_e, 1, ge);
                                Ee.negative === 0 && (ae = Ee, ie && (ie.words[ge] = 1));
                                for(var Ae = ge - 1; Ae >= 0; Ae--){
                                    var ze = (ae.words[_e.length + Ae] | 0) * 67108864 + (ae.words[_e.length + Ae - 1] | 0);
                                    for(ze = Math.min(ze / Me | 0, 67108863), ae._ishlnsubmul(_e, ze, Ae); ae.negative !== 0;)ze--, ae.negative = 0, ae._ishlnsubmul(_e, 1, Ae), ae.isZero() || (ae.negative ^= 1);
                                    ie && (ie.words[Ae] = ze);
                                }
                                return ie && ie.strip(), ae.strip(), W !== "div" && re !== 0 && ae.iushrn(re), {
                                    div: ie || null,
                                    mod: ae
                                };
                            }, f.prototype.divmod = function(N, W, re) {
                                if (u(!N.isZero()), this.isZero()) return {
                                    div: new f(0),
                                    mod: new f(0)
                                };
                                var ae, _e, Me;
                                return this.negative !== 0 && N.negative === 0 ? (Me = this.neg().divmod(N, W), W !== "mod" && (ae = Me.div.neg()), W !== "div" && (_e = Me.mod.neg(), re && _e.negative !== 0 && _e.iadd(N)), {
                                    div: ae,
                                    mod: _e
                                }) : this.negative === 0 && N.negative !== 0 ? (Me = this.divmod(N.neg(), W), W !== "mod" && (ae = Me.div.neg()), {
                                    div: ae,
                                    mod: Me.mod
                                }) : this.negative & N.negative ? (Me = this.neg().divmod(N.neg(), W), W !== "div" && (_e = Me.mod.neg(), re && _e.negative !== 0 && _e.isub(N)), {
                                    div: Me.div,
                                    mod: _e
                                }) : N.length > this.length || this.cmp(N) < 0 ? {
                                    div: new f(0),
                                    mod: this
                                } : N.length === 1 ? W === "div" ? {
                                    div: this.divn(N.words[0]),
                                    mod: null
                                } : W === "mod" ? {
                                    div: null,
                                    mod: new f(this.modn(N.words[0]))
                                } : {
                                    div: this.divn(N.words[0]),
                                    mod: new f(this.modn(N.words[0]))
                                } : this._wordDiv(N, W);
                            }, f.prototype.div = function(N) {
                                return this.divmod(N, "div", !1).div;
                            }, f.prototype.mod = function(N) {
                                return this.divmod(N, "mod", !1).mod;
                            }, f.prototype.umod = function(N) {
                                return this.divmod(N, "mod", !0).mod;
                            }, f.prototype.divRound = function(N) {
                                var W = this.divmod(N);
                                if (W.mod.isZero()) return W.div;
                                var re = W.div.negative !== 0 ? W.mod.isub(N) : W.mod, ae = N.ushrn(1), _e = N.andln(1), Me = re.cmp(ae);
                                return Me < 0 || _e === 1 && Me === 0 ? W.div : W.div.negative !== 0 ? W.div.isubn(1) : W.div.iaddn(1);
                            }, f.prototype.modn = function(N) {
                                u(N <= 67108863);
                                for(var W = 67108864 % N, re = 0, ae = this.length - 1; ae >= 0; ae--)re = (W * re + (this.words[ae] | 0)) % N;
                                return re;
                            }, f.prototype.idivn = function(N) {
                                u(N <= 67108863);
                                for(var W = 0, re = this.length - 1; re >= 0; re--){
                                    var ae = (this.words[re] | 0) + W * 67108864;
                                    this.words[re] = ae / N | 0, W = ae % N;
                                }
                                return this.strip();
                            }, f.prototype.divn = function(N) {
                                return this.clone().idivn(N);
                            }, f.prototype.egcd = function(N) {
                                u(N.negative === 0), u(!N.isZero());
                                var W = this, re = N.clone();
                                W.negative !== 0 ? W = W.umod(N) : W = W.clone();
                                for(var ae = new f(1), _e = new f(0), Me = new f(0), ke = new f(1), ge = 0; W.isEven() && re.isEven();)W.iushrn(1), re.iushrn(1), ++ge;
                                for(var ie = re.clone(), Te = W.clone(); !W.isZero();){
                                    for(var Ee = 0, Ae = 1; !(W.words[0] & Ae) && Ee < 26; ++Ee, Ae <<= 1);
                                    if (Ee > 0) for(W.iushrn(Ee); Ee-- > 0;)(ae.isOdd() || _e.isOdd()) && (ae.iadd(ie), _e.isub(Te)), ae.iushrn(1), _e.iushrn(1);
                                    for(var ze = 0, Ce = 1; !(re.words[0] & Ce) && ze < 26; ++ze, Ce <<= 1);
                                    if (ze > 0) for(re.iushrn(ze); ze-- > 0;)(Me.isOdd() || ke.isOdd()) && (Me.iadd(ie), ke.isub(Te)), Me.iushrn(1), ke.iushrn(1);
                                    W.cmp(re) >= 0 ? (W.isub(re), ae.isub(Me), _e.isub(ke)) : (re.isub(W), Me.isub(ae), ke.isub(_e));
                                }
                                return {
                                    a: Me,
                                    b: ke,
                                    gcd: re.iushln(ge)
                                };
                            }, f.prototype._invmp = function(N) {
                                u(N.negative === 0), u(!N.isZero());
                                var W = this, re = N.clone();
                                W.negative !== 0 ? W = W.umod(N) : W = W.clone();
                                for(var ae = new f(1), _e = new f(0), Me = re.clone(); W.cmpn(1) > 0 && re.cmpn(1) > 0;){
                                    for(var ke = 0, ge = 1; !(W.words[0] & ge) && ke < 26; ++ke, ge <<= 1);
                                    if (ke > 0) for(W.iushrn(ke); ke-- > 0;)ae.isOdd() && ae.iadd(Me), ae.iushrn(1);
                                    for(var ie = 0, Te = 1; !(re.words[0] & Te) && ie < 26; ++ie, Te <<= 1);
                                    if (ie > 0) for(re.iushrn(ie); ie-- > 0;)_e.isOdd() && _e.iadd(Me), _e.iushrn(1);
                                    W.cmp(re) >= 0 ? (W.isub(re), ae.isub(_e)) : (re.isub(W), _e.isub(ae));
                                }
                                var Ee;
                                return W.cmpn(1) === 0 ? Ee = ae : Ee = _e, Ee.cmpn(0) < 0 && Ee.iadd(N), Ee;
                            }, f.prototype.gcd = function(N) {
                                if (this.isZero()) return N.abs();
                                if (N.isZero()) return this.abs();
                                var W = this.clone(), re = N.clone();
                                W.negative = 0, re.negative = 0;
                                for(var ae = 0; W.isEven() && re.isEven(); ae++)W.iushrn(1), re.iushrn(1);
                                do {
                                    for(; W.isEven();)W.iushrn(1);
                                    for(; re.isEven();)re.iushrn(1);
                                    var _e = W.cmp(re);
                                    if (_e < 0) {
                                        var Me = W;
                                        W = re, re = Me;
                                    } else if (_e === 0 || re.cmpn(1) === 0) break;
                                    W.isub(re);
                                }while (!0);
                                return re.iushln(ae);
                            }, f.prototype.invm = function(N) {
                                return this.egcd(N).a.umod(N);
                            }, f.prototype.isEven = function() {
                                return (this.words[0] & 1) === 0;
                            }, f.prototype.isOdd = function() {
                                return (this.words[0] & 1) === 1;
                            }, f.prototype.andln = function(N) {
                                return this.words[0] & N;
                            }, f.prototype.bincn = function(N) {
                                u(typeof N == "number");
                                var W = N % 26, re = (N - W) / 26, ae = 1 << W;
                                if (this.length <= re) return this._expand(re + 1), this.words[re] |= ae, this;
                                for(var _e = ae, Me = re; _e !== 0 && Me < this.length; Me++){
                                    var ke = this.words[Me] | 0;
                                    ke += _e, _e = ke >>> 26, ke &= 67108863, this.words[Me] = ke;
                                }
                                return _e !== 0 && (this.words[Me] = _e, this.length++), this;
                            }, f.prototype.isZero = function() {
                                return this.length === 1 && this.words[0] === 0;
                            }, f.prototype.cmpn = function(N) {
                                var W = N < 0;
                                if (this.negative !== 0 && !W) return -1;
                                if (this.negative === 0 && W) return 1;
                                this.strip();
                                var re;
                                if (this.length > 1) re = 1;
                                else {
                                    W && (N = -N), u(N <= 67108863, "Number is too big");
                                    var ae = this.words[0] | 0;
                                    re = ae === N ? 0 : ae < N ? -1 : 1;
                                }
                                return this.negative !== 0 ? -re | 0 : re;
                            }, f.prototype.cmp = function(N) {
                                if (this.negative !== 0 && N.negative === 0) return -1;
                                if (this.negative === 0 && N.negative !== 0) return 1;
                                var W = this.ucmp(N);
                                return this.negative !== 0 ? -W | 0 : W;
                            }, f.prototype.ucmp = function(N) {
                                if (this.length > N.length) return 1;
                                if (this.length < N.length) return -1;
                                for(var W = 0, re = this.length - 1; re >= 0; re--){
                                    var ae = this.words[re] | 0, _e = N.words[re] | 0;
                                    if (ae !== _e) {
                                        ae < _e ? W = -1 : ae > _e && (W = 1);
                                        break;
                                    }
                                }
                                return W;
                            }, f.prototype.gtn = function(N) {
                                return this.cmpn(N) === 1;
                            }, f.prototype.gt = function(N) {
                                return this.cmp(N) === 1;
                            }, f.prototype.gten = function(N) {
                                return this.cmpn(N) >= 0;
                            }, f.prototype.gte = function(N) {
                                return this.cmp(N) >= 0;
                            }, f.prototype.ltn = function(N) {
                                return this.cmpn(N) === -1;
                            }, f.prototype.lt = function(N) {
                                return this.cmp(N) === -1;
                            }, f.prototype.lten = function(N) {
                                return this.cmpn(N) <= 0;
                            }, f.prototype.lte = function(N) {
                                return this.cmp(N) <= 0;
                            }, f.prototype.eqn = function(N) {
                                return this.cmpn(N) === 0;
                            }, f.prototype.eq = function(N) {
                                return this.cmp(N) === 0;
                            }, f.red = function(N) {
                                return new H(N);
                            }, f.prototype.toRed = function(N) {
                                return u(!this.red, "Already a number in reduction context"), u(this.negative === 0, "red works only with positives"), N.convertTo(this)._forceRed(N);
                            }, f.prototype.fromRed = function() {
                                return u(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
                            }, f.prototype._forceRed = function(N) {
                                return this.red = N, this;
                            }, f.prototype.forceRed = function(N) {
                                return u(!this.red, "Already a number in reduction context"), this._forceRed(N);
                            }, f.prototype.redAdd = function(N) {
                                return u(this.red, "redAdd works only with red numbers"), this.red.add(this, N);
                            }, f.prototype.redIAdd = function(N) {
                                return u(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, N);
                            }, f.prototype.redSub = function(N) {
                                return u(this.red, "redSub works only with red numbers"), this.red.sub(this, N);
                            }, f.prototype.redISub = function(N) {
                                return u(this.red, "redISub works only with red numbers"), this.red.isub(this, N);
                            }, f.prototype.redShl = function(N) {
                                return u(this.red, "redShl works only with red numbers"), this.red.shl(this, N);
                            }, f.prototype.redMul = function(N) {
                                return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, N), this.red.mul(this, N);
                            }, f.prototype.redIMul = function(N) {
                                return u(this.red, "redMul works only with red numbers"), this.red._verify2(this, N), this.red.imul(this, N);
                            }, f.prototype.redSqr = function() {
                                return u(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
                            }, f.prototype.redISqr = function() {
                                return u(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
                            }, f.prototype.redSqrt = function() {
                                return u(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
                            }, f.prototype.redInvm = function() {
                                return u(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
                            }, f.prototype.redNeg = function() {
                                return u(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
                            }, f.prototype.redPow = function(N) {
                                return u(this.red && !N.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, N);
                            };
                            var g = {
                                k256: null,
                                p224: null,
                                p192: null,
                                p25519: null
                            };
                            function P(G, N) {
                                this.name = G, this.p = new f(N, 16), this.n = this.p.bitLength(), this.k = new f(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
                            }
                            P.prototype._tmp = function() {
                                var N = new f(null);
                                return N.words = new Array(Math.ceil(this.n / 13)), N;
                            }, P.prototype.ireduce = function(N) {
                                var W = N, re;
                                do this.split(W, this.tmp), W = this.imulK(W), W = W.iadd(this.tmp), re = W.bitLength();
                                while (re > this.n);
                                var ae = re < this.n ? -1 : W.ucmp(this.p);
                                return ae === 0 ? (W.words[0] = 0, W.length = 1) : ae > 0 ? W.isub(this.p) : W.strip !== void 0 ? W.strip() : W._strip(), W;
                            }, P.prototype.split = function(N, W) {
                                N.iushrn(this.n, 0, W);
                            }, P.prototype.imulK = function(N) {
                                return N.imul(this.k);
                            };
                            function T() {
                                P.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
                            }
                            c(T, P), T.prototype.split = function(N, W) {
                                for(var re = 4194303, ae = Math.min(N.length, 9), _e = 0; _e < ae; _e++)W.words[_e] = N.words[_e];
                                if (W.length = ae, N.length <= 9) {
                                    N.words[0] = 0, N.length = 1;
                                    return;
                                }
                                var Me = N.words[9];
                                for(W.words[W.length++] = Me & re, _e = 10; _e < N.length; _e++){
                                    var ke = N.words[_e] | 0;
                                    N.words[_e - 10] = (ke & re) << 4 | Me >>> 22, Me = ke;
                                }
                                Me >>>= 22, N.words[_e - 10] = Me, Me === 0 && N.length > 10 ? N.length -= 10 : N.length -= 9;
                            }, T.prototype.imulK = function(N) {
                                N.words[N.length] = 0, N.words[N.length + 1] = 0, N.length += 2;
                                for(var W = 0, re = 0; re < N.length; re++){
                                    var ae = N.words[re] | 0;
                                    W += ae * 977, N.words[re] = W & 67108863, W = ae * 64 + (W / 67108864 | 0);
                                }
                                return N.words[N.length - 1] === 0 && (N.length--, N.words[N.length - 1] === 0 && N.length--), N;
                            };
                            function F() {
                                P.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
                            }
                            c(F, P);
                            function q() {
                                P.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
                            }
                            c(q, P);
                            function V() {
                                P.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
                            }
                            c(V, P), V.prototype.imulK = function(N) {
                                for(var W = 0, re = 0; re < N.length; re++){
                                    var ae = (N.words[re] | 0) * 19 + W, _e = ae & 67108863;
                                    ae >>>= 26, N.words[re] = _e, W = ae;
                                }
                                return W !== 0 && (N.words[N.length++] = W), N;
                            }, f._prime = function(N) {
                                if (g[N]) return g[N];
                                var W;
                                if (N === "k256") W = new T;
                                else if (N === "p224") W = new F;
                                else if (N === "p192") W = new q;
                                else if (N === "p25519") W = new V;
                                else throw new Error("Unknown prime " + N);
                                return g[N] = W, W;
                            };
                            function H(G) {
                                if (typeof G == "string") {
                                    var N = f._prime(G);
                                    this.m = N.p, this.prime = N;
                                } else u(G.gtn(1), "modulus must be greater than 1"), this.m = G, this.prime = null;
                            }
                            H.prototype._verify1 = function(N) {
                                u(N.negative === 0, "red works only with positives"), u(N.red, "red works only with red numbers");
                            }, H.prototype._verify2 = function(N, W) {
                                u((N.negative | W.negative) === 0, "red works only with positives"), u(N.red && N.red === W.red, "red works only with red numbers");
                            }, H.prototype.imod = function(N) {
                                return this.prime ? this.prime.ireduce(N)._forceRed(this) : N.umod(this.m)._forceRed(this);
                            }, H.prototype.neg = function(N) {
                                return N.isZero() ? N.clone() : this.m.sub(N)._forceRed(this);
                            }, H.prototype.add = function(N, W) {
                                this._verify2(N, W);
                                var re = N.add(W);
                                return re.cmp(this.m) >= 0 && re.isub(this.m), re._forceRed(this);
                            }, H.prototype.iadd = function(N, W) {
                                this._verify2(N, W);
                                var re = N.iadd(W);
                                return re.cmp(this.m) >= 0 && re.isub(this.m), re;
                            }, H.prototype.sub = function(N, W) {
                                this._verify2(N, W);
                                var re = N.sub(W);
                                return re.cmpn(0) < 0 && re.iadd(this.m), re._forceRed(this);
                            }, H.prototype.isub = function(N, W) {
                                this._verify2(N, W);
                                var re = N.isub(W);
                                return re.cmpn(0) < 0 && re.iadd(this.m), re;
                            }, H.prototype.shl = function(N, W) {
                                return this._verify1(N), this.imod(N.ushln(W));
                            }, H.prototype.imul = function(N, W) {
                                return this._verify2(N, W), this.imod(N.imul(W));
                            }, H.prototype.mul = function(N, W) {
                                return this._verify2(N, W), this.imod(N.mul(W));
                            }, H.prototype.isqr = function(N) {
                                return this.imul(N, N.clone());
                            }, H.prototype.sqr = function(N) {
                                return this.mul(N, N);
                            }, H.prototype.sqrt = function(N) {
                                if (N.isZero()) return N.clone();
                                var W = this.m.andln(3);
                                if (u(W % 2 === 1), W === 3) {
                                    var re = this.m.add(new f(1)).iushrn(2);
                                    return this.pow(N, re);
                                }
                                for(var ae = this.m.subn(1), _e = 0; !ae.isZero() && ae.andln(1) === 0;)_e++, ae.iushrn(1);
                                u(!ae.isZero());
                                var Me = new f(1).toRed(this), ke = Me.redNeg(), ge = this.m.subn(1).iushrn(1), ie = this.m.bitLength();
                                for(ie = new f(2 * ie * ie).toRed(this); this.pow(ie, ge).cmp(ke) !== 0;)ie.redIAdd(ke);
                                for(var Te = this.pow(ie, ae), Ee = this.pow(N, ae.addn(1).iushrn(1)), Ae = this.pow(N, ae), ze = _e; Ae.cmp(Me) !== 0;){
                                    for(var Ce = Ae, me = 0; Ce.cmp(Me) !== 0; me++)Ce = Ce.redSqr();
                                    u(me < ze);
                                    var Re = this.pow(Te, new f(1).iushln(ze - me - 1));
                                    Ee = Ee.redMul(Re), Te = Re.redSqr(), Ae = Ae.redMul(Te), ze = me;
                                }
                                return Ee;
                            }, H.prototype.invm = function(N) {
                                var W = N._invmp(this.m);
                                return W.negative !== 0 ? (W.negative = 0, this.imod(W).redNeg()) : this.imod(W);
                            }, H.prototype.pow = function(N, W) {
                                if (W.isZero()) return new f(1).toRed(this);
                                if (W.cmpn(1) === 0) return N.clone();
                                var re = 4, ae = new Array(1 << re);
                                ae[0] = new f(1).toRed(this), ae[1] = N;
                                for(var _e = 2; _e < ae.length; _e++)ae[_e] = this.mul(ae[_e - 1], N);
                                var Me = ae[0], ke = 0, ge = 0, ie = W.bitLength() % 26;
                                for(ie === 0 && (ie = 26), _e = W.length - 1; _e >= 0; _e--){
                                    for(var Te = W.words[_e], Ee = ie - 1; Ee >= 0; Ee--){
                                        var Ae = Te >> Ee & 1;
                                        if (Me !== ae[0] && (Me = this.sqr(Me)), Ae === 0 && ke === 0) {
                                            ge = 0;
                                            continue;
                                        }
                                        ke <<= 1, ke |= Ae, ge++, !(ge !== re && (_e !== 0 || Ee !== 0)) && (Me = this.mul(Me, ae[ke]), ge = 0, ke = 0);
                                    }
                                    ie = 26;
                                }
                                return Me;
                            }, H.prototype.convertTo = function(N) {
                                var W = N.umod(this.m);
                                return W === N ? W.clone() : W;
                            }, H.prototype.convertFrom = function(N) {
                                var W = N.clone();
                                return W.red = null, W;
                            }, f.mont = function(N) {
                                return new X(N);
                            };
                            function X(G) {
                                H.call(this, G), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new f(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
                            }
                            c(X, H), X.prototype.convertTo = function(N) {
                                return this.imod(N.ushln(this.shift));
                            }, X.prototype.convertFrom = function(N) {
                                var W = this.imod(N.mul(this.rinv));
                                return W.red = null, W;
                            }, X.prototype.imul = function(N, W) {
                                if (N.isZero() || W.isZero()) return N.words[0] = 0, N.length = 1, N;
                                var re = N.imul(W), ae = re.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _e = re.isub(ae).iushrn(this.shift), Me = _e;
                                return _e.cmp(this.m) >= 0 ? Me = _e.isub(this.m) : _e.cmpn(0) < 0 && (Me = _e.iadd(this.m)), Me._forceRed(this);
                            }, X.prototype.mul = function(N, W) {
                                if (N.isZero() || W.isZero()) return new f(0)._forceRed(this);
                                var re = N.mul(W), ae = re.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _e = re.isub(ae).iushrn(this.shift), Me = _e;
                                return _e.cmp(this.m) >= 0 ? Me = _e.isub(this.m) : _e.cmpn(0) < 0 && (Me = _e.iadd(this.m)), Me._forceRed(this);
                            }, X.prototype.invm = function(N) {
                                var W = this.imod(N._invmp(this.m).mul(this.r2));
                                return W._forceRed(this);
                            };
                        }(i, this);
                    },
                    6204: function(i) {
                        "use strict";
                        i.exports = a;
                        function a(o) {
                            var s, l, u, c = o.length, f = 0;
                            for(s = 0; s < c; ++s)f += o[s].length;
                            var h = new Array(f), d = 0;
                            for(s = 0; s < c; ++s){
                                var v = o[s], x = v.length;
                                for(l = 0; l < x; ++l){
                                    var b = h[d++] = new Array(x - 1), p = 0;
                                    for(u = 0; u < x; ++u)u !== l && (b[p++] = v[u]);
                                    if (l & 1) {
                                        var E = b[1];
                                        b[1] = b[0], b[0] = E;
                                    }
                                }
                            }
                            return h;
                        }
                    },
                    6867: function(i, a, o) {
                        "use strict";
                        i.exports = p;
                        var s = o(1888), l = o(855), u = o(7150);
                        function c(E, k) {
                            for(var A = 0; A < E; ++A)if (!(k[A] <= k[A + E])) return !0;
                            return !1;
                        }
                        function f(E, k, A, L) {
                            for(var _ = 0, C = 0, M = 0, g = E.length; M < g; ++M){
                                var P = E[M];
                                if (!c(k, P)) {
                                    for(var T = 0; T < 2 * k; ++T)A[_++] = P[T];
                                    L[C++] = M;
                                }
                            }
                            return C;
                        }
                        function h(E, k, A, L) {
                            var _ = E.length, C = k.length;
                            if (!(_ <= 0 || C <= 0)) {
                                var M = E[0].length >>> 1;
                                if (!(M <= 0)) {
                                    var g, P = s.mallocDouble(2 * M * _), T = s.mallocInt32(_);
                                    if (_ = f(E, M, P, T), _ > 0) {
                                        if (M === 1 && L) l.init(_), g = l.sweepComplete(M, A, 0, _, P, T, 0, _, P, T);
                                        else {
                                            var F = s.mallocDouble(2 * M * C), q = s.mallocInt32(C);
                                            C = f(k, M, F, q), C > 0 && (l.init(_ + C), M === 1 ? g = l.sweepBipartite(M, A, 0, _, P, T, 0, C, F, q) : g = u(M, A, L, _, P, T, C, F, q), s.free(F), s.free(q));
                                        }
                                        s.free(P), s.free(T);
                                    }
                                    return g;
                                }
                            }
                        }
                        var d;
                        function v(E, k) {
                            d.push([
                                E,
                                k
                            ]);
                        }
                        function x(E) {
                            return d = [], h(E, E, v, !0), d;
                        }
                        function b(E, k) {
                            return d = [], h(E, k, v, !1), d;
                        }
                        function p(E, k, A) {
                            switch(arguments.length){
                                case 1:
                                    return x(E);
                                case 2:
                                    return typeof k == "function" ? h(E, E, k, !0) : b(E, k);
                                case 3:
                                    return h(E, k, A, !1);
                                default:
                                    throw new Error("box-intersect: Invalid arguments");
                            }
                        }
                    },
                    2455: function(i, a) {
                        "use strict";
                        function o() {
                            function u(h, d, v, x, b, p, E, k, A, L, _) {
                                for(var C = 2 * h, M = x, g = C * x; M < b; ++M, g += C){
                                    var P = p[d + g], T = p[d + g + h], F = E[M];
                                    e: for(var q = k, V = C * k; q < A; ++q, V += C){
                                        var H = L[d + V], X = L[d + V + h], G = _[q];
                                        if (!(X < P || T < H)) {
                                            for(var N = d + 1; N < h; ++N){
                                                var W = p[N + g], re = p[N + h + g], ae = L[N + V], _e = L[N + h + V];
                                                if (re < ae || _e < W) continue e;
                                            }
                                            var Me = v(F, G);
                                            if (Me !== void 0) return Me;
                                        }
                                    }
                                }
                            }
                            function c(h, d, v, x, b, p, E, k, A, L, _) {
                                for(var C = 2 * h, M = k, g = C * k; M < A; ++M, g += C){
                                    var P = L[d + g], T = L[d + g + h], F = _[M];
                                    e: for(var q = x, V = C * x; q < b; ++q, V += C){
                                        var H = p[d + V], X = p[d + V + h], G = E[q];
                                        if (!(T < H || X < P)) {
                                            for(var N = d + 1; N < h; ++N){
                                                var W = p[N + V], re = p[N + h + V], ae = L[N + g], _e = L[N + h + g];
                                                if (re < ae || _e < W) continue e;
                                            }
                                            var Me = v(G, F);
                                            if (Me !== void 0) return Me;
                                        }
                                    }
                                }
                            }
                            function f(h, d, v, x, b, p, E, k, A, L, _) {
                                return b - x > A - k ? u(h, d, v, x, b, p, E, k, A, L, _) : c(h, d, v, x, b, p, E, k, A, L, _);
                            }
                            return f;
                        }
                        function s() {
                            function u(v, x, b, p, E, k, A, L, _, C, M) {
                                for(var g = 2 * v, P = p, T = g * p; P < E; ++P, T += g){
                                    var F = k[x + T], q = k[x + T + v], V = A[P];
                                    e: for(var H = L, X = g * L; H < _; ++H, X += g){
                                        var G = C[x + X], N = M[H];
                                        if (!(G <= F || q < G)) {
                                            for(var W = x + 1; W < v; ++W){
                                                var re = k[W + T], ae = k[W + v + T], _e = C[W + X], Me = C[W + v + X];
                                                if (ae < _e || Me < re) continue e;
                                            }
                                            var ke = b(N, V);
                                            if (ke !== void 0) return ke;
                                        }
                                    }
                                }
                            }
                            function c(v, x, b, p, E, k, A, L, _, C, M) {
                                for(var g = 2 * v, P = p, T = g * p; P < E; ++P, T += g){
                                    var F = k[x + T], q = k[x + T + v], V = A[P];
                                    e: for(var H = L, X = g * L; H < _; ++H, X += g){
                                        var G = C[x + X], N = M[H];
                                        if (!(G < F || q < G)) {
                                            for(var W = x + 1; W < v; ++W){
                                                var re = k[W + T], ae = k[W + v + T], _e = C[W + X], Me = C[W + v + X];
                                                if (ae < _e || Me < re) continue e;
                                            }
                                            var ke = b(V, N);
                                            if (ke !== void 0) return ke;
                                        }
                                    }
                                }
                            }
                            function f(v, x, b, p, E, k, A, L, _, C, M) {
                                for(var g = 2 * v, P = L, T = g * L; P < _; ++P, T += g){
                                    var F = C[x + T], q = M[P];
                                    e: for(var V = p, H = g * p; V < E; ++V, H += g){
                                        var X = k[x + H], G = k[x + H + v], N = A[V];
                                        if (!(F <= X || G < F)) {
                                            for(var W = x + 1; W < v; ++W){
                                                var re = k[W + H], ae = k[W + v + H], _e = C[W + T], Me = C[W + v + T];
                                                if (ae < _e || Me < re) continue e;
                                            }
                                            var ke = b(q, N);
                                            if (ke !== void 0) return ke;
                                        }
                                    }
                                }
                            }
                            function h(v, x, b, p, E, k, A, L, _, C, M) {
                                for(var g = 2 * v, P = L, T = g * L; P < _; ++P, T += g){
                                    var F = C[x + T], q = M[P];
                                    e: for(var V = p, H = g * p; V < E; ++V, H += g){
                                        var X = k[x + H], G = k[x + H + v], N = A[V];
                                        if (!(F < X || G < F)) {
                                            for(var W = x + 1; W < v; ++W){
                                                var re = k[W + H], ae = k[W + v + H], _e = C[W + T], Me = C[W + v + T];
                                                if (ae < _e || Me < re) continue e;
                                            }
                                            var ke = b(N, q);
                                            if (ke !== void 0) return ke;
                                        }
                                    }
                                }
                            }
                            function d(v, x, b, p, E, k, A, L, _, C, M, g) {
                                return k - E > C - _ ? p ? u(v, x, b, E, k, A, L, _, C, M, g) : c(v, x, b, E, k, A, L, _, C, M, g) : p ? f(v, x, b, E, k, A, L, _, C, M, g) : h(v, x, b, E, k, A, L, _, C, M, g);
                            }
                            return d;
                        }
                        function l(u) {
                            return u ? o() : s();
                        }
                        a.partial = l(!1), a.full = l(!0);
                    },
                    7150: function(i, a, o) {
                        "use strict";
                        i.exports = G;
                        var s = o(1888), l = o(8828), u = o(2455), c = u.partial, f = u.full, h = o(855), d = o(3545), v = o(8105), x = 128, b = 4194304, p = 4194304, E = v("!(lo>=p0)&&!(p1>=hi)"), k = v("lo===p0"), A = v("lo<p0"), L = v("hi<=p0"), _ = v("lo<=p0&&p0<=hi"), C = v("lo<p0&&p0<=hi"), M = 6, g = 2, P = 1024, T = s.mallocInt32(P), F = s.mallocDouble(P);
                        function q(N, W) {
                            var re = 8 * l.log2(W + 1) * (N + 1) | 0, ae = l.nextPow2(M * re);
                            T.length < ae && (s.free(T), T = s.mallocInt32(ae));
                            var _e = l.nextPow2(g * re);
                            F.length < _e && (s.free(F), F = s.mallocDouble(_e));
                        }
                        function V(N, W, re, ae, _e, Me, ke, ge, ie) {
                            var Te = M * N;
                            T[Te] = W, T[Te + 1] = re, T[Te + 2] = ae, T[Te + 3] = _e, T[Te + 4] = Me, T[Te + 5] = ke;
                            var Ee = g * N;
                            F[Ee] = ge, F[Ee + 1] = ie;
                        }
                        function H(N, W, re, ae, _e, Me, ke, ge, ie, Te, Ee) {
                            var Ae = 2 * N, ze = ie * Ae, Ce = Te[ze + W];
                            e: for(var me = _e, Re = _e * Ae; me < Me; ++me, Re += Ae){
                                var ce = ke[Re + W], Ge = ke[Re + W + N];
                                if (!(Ce < ce || Ge < Ce) && !(ae && Ce === ce)) {
                                    for(var nt = ge[me], ct = W + 1; ct < N; ++ct){
                                        var ce = ke[Re + ct], Ge = ke[Re + ct + N], qt = Te[ze + ct], rt = Te[ze + ct + N];
                                        if (Ge < qt || rt < ce) continue e;
                                    }
                                    var ot;
                                    if (ae ? ot = re(Ee, nt) : ot = re(nt, Ee), ot !== void 0) return ot;
                                }
                            }
                        }
                        function X(N, W, re, ae, _e, Me, ke, ge, ie, Te) {
                            var Ee = 2 * N, Ae = ge * Ee, ze = ie[Ae + W];
                            e: for(var Ce = ae, me = ae * Ee; Ce < _e; ++Ce, me += Ee){
                                var Re = ke[Ce];
                                if (Re !== Te) {
                                    var ce = Me[me + W], Ge = Me[me + W + N];
                                    if (!(ze < ce || Ge < ze)) {
                                        for(var nt = W + 1; nt < N; ++nt){
                                            var ce = Me[me + nt], Ge = Me[me + nt + N], ct = ie[Ae + nt], qt = ie[Ae + nt + N];
                                            if (Ge < ct || qt < ce) continue e;
                                        }
                                        var rt = re(Re, Te);
                                        if (rt !== void 0) return rt;
                                    }
                                }
                            }
                        }
                        function G(N, W, re, ae, _e, Me, ke, ge, ie) {
                            q(N, ae + ke);
                            var Te = 0, Ee = 2 * N, Ae;
                            for(V(Te++, 0, 0, ae, 0, ke, re ? 16 : 0, -1 / 0, 1 / 0), re || V(Te++, 0, 0, ke, 0, ae, 1, -1 / 0, 1 / 0); Te > 0;){
                                Te -= 1;
                                var ze = Te * M, Ce = T[ze], me = T[ze + 1], Re = T[ze + 2], ce = T[ze + 3], Ge = T[ze + 4], nt = T[ze + 5], ct = Te * g, qt = F[ct], rt = F[ct + 1], ot = nt & 1, Rt = !!(nt & 16), kt = _e, Ct = Me, Yt = ge, xr = ie;
                                if (ot && (kt = ge, Ct = ie, Yt = _e, xr = Me), !(nt & 2 && (Re = A(N, Ce, me, Re, kt, Ct, rt), me >= Re)) && !(nt & 4 && (me = L(N, Ce, me, Re, kt, Ct, qt), me >= Re))) {
                                    var er = Re - me, Ke = Ge - ce;
                                    if (Rt) {
                                        if (N * er * (er + Ke) < p) {
                                            if (Ae = h.scanComplete(N, Ce, W, me, Re, kt, Ct, ce, Ge, Yt, xr), Ae !== void 0) return Ae;
                                            continue;
                                        }
                                    } else if (N * Math.min(er, Ke) < x) {
                                        if (Ae = c(N, Ce, W, ot, me, Re, kt, Ct, ce, Ge, Yt, xr), Ae !== void 0) return Ae;
                                        continue;
                                    } else if (N * er * Ke < b) {
                                        if (Ae = h.scanBipartite(N, Ce, W, ot, me, Re, kt, Ct, ce, Ge, Yt, xr), Ae !== void 0) return Ae;
                                        continue;
                                    }
                                    var xt = E(N, Ce, me, Re, kt, Ct, qt, rt);
                                    if (me < xt) {
                                        if (N * (xt - me) < x) {
                                            if (Ae = f(N, Ce + 1, W, me, xt, kt, Ct, ce, Ge, Yt, xr), Ae !== void 0) return Ae;
                                        } else if (Ce === N - 2) {
                                            if (ot ? Ae = h.sweepBipartite(N, W, ce, Ge, Yt, xr, me, xt, kt, Ct) : Ae = h.sweepBipartite(N, W, me, xt, kt, Ct, ce, Ge, Yt, xr), Ae !== void 0) return Ae;
                                        } else V(Te++, Ce + 1, me, xt, ce, Ge, ot, -1 / 0, 1 / 0), V(Te++, Ce + 1, ce, Ge, me, xt, ot ^ 1, -1 / 0, 1 / 0);
                                    }
                                    if (xt < Re) {
                                        var bt = d(N, Ce, ce, Ge, Yt, xr), Lt = Yt[Ee * bt + Ce], St = k(N, Ce, bt, Ge, Yt, xr, Lt);
                                        if (St < Ge && V(Te++, Ce, xt, Re, St, Ge, (ot | 4) + (Rt ? 16 : 0), Lt, rt), ce < bt && V(Te++, Ce, xt, Re, ce, bt, (ot | 2) + (Rt ? 16 : 0), qt, Lt), bt + 1 === St) {
                                            if (Rt ? Ae = X(N, Ce, W, xt, Re, kt, Ct, bt, Yt, xr[bt]) : Ae = H(N, Ce, W, ot, xt, Re, kt, Ct, bt, Yt, xr[bt]), Ae !== void 0) return Ae;
                                        } else if (bt < St) {
                                            var Et;
                                            if (Rt) {
                                                if (Et = _(N, Ce, xt, Re, kt, Ct, Lt), xt < Et) {
                                                    var dt = k(N, Ce, xt, Et, kt, Ct, Lt);
                                                    if (Ce === N - 2) {
                                                        if (xt < dt && (Ae = h.sweepComplete(N, W, xt, dt, kt, Ct, bt, St, Yt, xr), Ae !== void 0) || dt < Et && (Ae = h.sweepBipartite(N, W, dt, Et, kt, Ct, bt, St, Yt, xr), Ae !== void 0)) return Ae;
                                                    } else xt < dt && V(Te++, Ce + 1, xt, dt, bt, St, 16, -1 / 0, 1 / 0), dt < Et && (V(Te++, Ce + 1, dt, Et, bt, St, 0, -1 / 0, 1 / 0), V(Te++, Ce + 1, bt, St, dt, Et, 1, -1 / 0, 1 / 0));
                                                }
                                            } else ot ? Et = C(N, Ce, xt, Re, kt, Ct, Lt) : Et = _(N, Ce, xt, Re, kt, Ct, Lt), xt < Et && (Ce === N - 2 ? ot ? Ae = h.sweepBipartite(N, W, bt, St, Yt, xr, xt, Et, kt, Ct) : Ae = h.sweepBipartite(N, W, xt, Et, kt, Ct, bt, St, Yt, xr) : (V(Te++, Ce + 1, xt, Et, bt, St, ot, -1 / 0, 1 / 0), V(Te++, Ce + 1, bt, St, xt, Et, ot ^ 1, -1 / 0, 1 / 0)));
                                        }
                                    }
                                }
                            }
                        }
                    },
                    3545: function(i, a, o) {
                        "use strict";
                        i.exports = f;
                        var s = o(8105), l = s("lo<p0"), u = 8;
                        function c(h, d, v, x, b, p) {
                            for(var E = 2 * h, k = E * (v + 1) + d, A = v + 1; A < x; ++A, k += E)for(var L = b[k], _ = A, C = E * (A - 1); _ > v && b[C + d] > L; --_, C -= E){
                                for(var M = C, g = C + E, P = 0; P < E; ++P, ++M, ++g){
                                    var T = b[M];
                                    b[M] = b[g], b[g] = T;
                                }
                                var F = p[_];
                                p[_] = p[_ - 1], p[_ - 1] = F;
                            }
                        }
                        function f(h, d, v, x, b, p) {
                            if (x <= v + 1) return v;
                            for(var E = v, k = x, A = x + v >>> 1, L = 2 * h, _ = A, C = b[L * A + d]; E < k;){
                                if (k - E < u) {
                                    c(h, d, E, k, b, p), C = b[L * A + d];
                                    break;
                                }
                                var M = k - E, g = Math.random() * M + E | 0, P = b[L * g + d], T = Math.random() * M + E | 0, F = b[L * T + d], q = Math.random() * M + E | 0, V = b[L * q + d];
                                P <= F ? V >= F ? (_ = T, C = F) : P >= V ? (_ = g, C = P) : (_ = q, C = V) : F >= V ? (_ = T, C = F) : V >= P ? (_ = g, C = P) : (_ = q, C = V);
                                for(var G = L * (k - 1), N = L * _, H = 0; H < L; ++H, ++G, ++N){
                                    var X = b[G];
                                    b[G] = b[N], b[N] = X;
                                }
                                var W = p[k - 1];
                                p[k - 1] = p[_], p[_] = W, _ = l(h, d, E, k - 1, b, p, C);
                                for(var G = L * (k - 1), N = L * _, H = 0; H < L; ++H, ++G, ++N){
                                    var X = b[G];
                                    b[G] = b[N], b[N] = X;
                                }
                                var W = p[k - 1];
                                if (p[k - 1] = p[_], p[_] = W, A < _) {
                                    for(k = _ - 1; E < k && b[L * (k - 1) + d] === C;)k -= 1;
                                    k += 1;
                                } else if (_ < A) for(E = _ + 1; E < k && b[L * E + d] === C;)E += 1;
                                else break;
                            }
                            return l(h, d, v, A, b, p, b[L * A + d]);
                        }
                    },
                    8105: function(i) {
                        "use strict";
                        i.exports = o;
                        var a = {
                            "lo===p0": s,
                            "lo<p0": l,
                            "lo<=p0": u,
                            "hi<=p0": c,
                            "lo<p0&&p0<=hi": h,
                            "lo<=p0&&p0<=hi": f,
                            "!(lo>=p0)&&!(p1>=hi)": d
                        };
                        function o(v) {
                            return a[v];
                        }
                        function s(v, x, b, p, E, k, A) {
                            for(var L = 2 * v, _ = L * b, C = _, M = b, g = x, P = v + x, T = b; p > T; ++T, _ += L){
                                var F = E[_ + g];
                                if (F === A) {
                                    if (M === T) M += 1, C += L;
                                    else {
                                        for(var q = 0; L > q; ++q){
                                            var V = E[_ + q];
                                            E[_ + q] = E[C], E[C++] = V;
                                        }
                                        var H = k[T];
                                        k[T] = k[M], k[M++] = H;
                                    }
                                }
                            }
                            return M;
                        }
                        function l(v, x, b, p, E, k, A) {
                            for(var L = 2 * v, _ = L * b, C = _, M = b, g = x, P = v + x, T = b; p > T; ++T, _ += L){
                                var F = E[_ + g];
                                if (F < A) {
                                    if (M === T) M += 1, C += L;
                                    else {
                                        for(var q = 0; L > q; ++q){
                                            var V = E[_ + q];
                                            E[_ + q] = E[C], E[C++] = V;
                                        }
                                        var H = k[T];
                                        k[T] = k[M], k[M++] = H;
                                    }
                                }
                            }
                            return M;
                        }
                        function u(v, x, b, p, E, k, A) {
                            for(var L = 2 * v, _ = L * b, C = _, M = b, g = x, P = v + x, T = b; p > T; ++T, _ += L){
                                var F = E[_ + P];
                                if (F <= A) {
                                    if (M === T) M += 1, C += L;
                                    else {
                                        for(var q = 0; L > q; ++q){
                                            var V = E[_ + q];
                                            E[_ + q] = E[C], E[C++] = V;
                                        }
                                        var H = k[T];
                                        k[T] = k[M], k[M++] = H;
                                    }
                                }
                            }
                            return M;
                        }
                        function c(v, x, b, p, E, k, A) {
                            for(var L = 2 * v, _ = L * b, C = _, M = b, g = x, P = v + x, T = b; p > T; ++T, _ += L){
                                var F = E[_ + P];
                                if (F <= A) {
                                    if (M === T) M += 1, C += L;
                                    else {
                                        for(var q = 0; L > q; ++q){
                                            var V = E[_ + q];
                                            E[_ + q] = E[C], E[C++] = V;
                                        }
                                        var H = k[T];
                                        k[T] = k[M], k[M++] = H;
                                    }
                                }
                            }
                            return M;
                        }
                        function f(v, x, b, p, E, k, A) {
                            for(var L = 2 * v, _ = L * b, C = _, M = b, g = x, P = v + x, T = b; p > T; ++T, _ += L){
                                var F = E[_ + g], q = E[_ + P];
                                if (F <= A && A <= q) {
                                    if (M === T) M += 1, C += L;
                                    else {
                                        for(var V = 0; L > V; ++V){
                                            var H = E[_ + V];
                                            E[_ + V] = E[C], E[C++] = H;
                                        }
                                        var X = k[T];
                                        k[T] = k[M], k[M++] = X;
                                    }
                                }
                            }
                            return M;
                        }
                        function h(v, x, b, p, E, k, A) {
                            for(var L = 2 * v, _ = L * b, C = _, M = b, g = x, P = v + x, T = b; p > T; ++T, _ += L){
                                var F = E[_ + g], q = E[_ + P];
                                if (F < A && A <= q) {
                                    if (M === T) M += 1, C += L;
                                    else {
                                        for(var V = 0; L > V; ++V){
                                            var H = E[_ + V];
                                            E[_ + V] = E[C], E[C++] = H;
                                        }
                                        var X = k[T];
                                        k[T] = k[M], k[M++] = X;
                                    }
                                }
                            }
                            return M;
                        }
                        function d(v, x, b, p, E, k, A, L) {
                            for(var _ = 2 * v, C = _ * b, M = C, g = b, P = x, T = v + x, F = b; p > F; ++F, C += _){
                                var q = E[C + P], V = E[C + T];
                                if (!(q >= A) && !(L >= V)) {
                                    if (g === F) g += 1, M += _;
                                    else {
                                        for(var H = 0; _ > H; ++H){
                                            var X = E[C + H];
                                            E[C + H] = E[M], E[M++] = X;
                                        }
                                        var G = k[F];
                                        k[F] = k[g], k[g++] = G;
                                    }
                                }
                            }
                            return g;
                        }
                    },
                    4192: function(i) {
                        "use strict";
                        i.exports = o;
                        var a = 32;
                        function o(x, b) {
                            b <= 4 * a ? s(0, b - 1, x) : v(0, b - 1, x);
                        }
                        function s(x, b, p) {
                            for(var E = 2 * (x + 1), k = x + 1; k <= b; ++k){
                                for(var A = p[E++], L = p[E++], _ = k, C = E - 2; _-- > x;){
                                    var M = p[C - 2], g = p[C - 1];
                                    if (M < A) break;
                                    if (M === A && g < L) break;
                                    p[C] = M, p[C + 1] = g, C -= 2;
                                }
                                p[C] = A, p[C + 1] = L;
                            }
                        }
                        function l(x, b, p) {
                            x *= 2, b *= 2;
                            var E = p[x], k = p[x + 1];
                            p[x] = p[b], p[x + 1] = p[b + 1], p[b] = E, p[b + 1] = k;
                        }
                        function u(x, b, p) {
                            x *= 2, b *= 2, p[x] = p[b], p[x + 1] = p[b + 1];
                        }
                        function c(x, b, p, E) {
                            x *= 2, b *= 2, p *= 2;
                            var k = E[x], A = E[x + 1];
                            E[x] = E[b], E[x + 1] = E[b + 1], E[b] = E[p], E[b + 1] = E[p + 1], E[p] = k, E[p + 1] = A;
                        }
                        function f(x, b, p, E, k) {
                            x *= 2, b *= 2, k[x] = k[b], k[b] = p, k[x + 1] = k[b + 1], k[b + 1] = E;
                        }
                        function h(x, b, p) {
                            x *= 2, b *= 2;
                            var E = p[x], k = p[b];
                            return E < k ? !1 : E === k ? p[x + 1] > p[b + 1] : !0;
                        }
                        function d(x, b, p, E) {
                            x *= 2;
                            var k = E[x];
                            return k < b ? !0 : k === b ? E[x + 1] < p : !1;
                        }
                        function v(x, b, p) {
                            var E = (b - x + 1) / 6 | 0, k = x + E, A = b - E, L = x + b >> 1, _ = L - E, C = L + E, M = k, g = _, P = L, T = C, F = A, q = x + 1, V = b - 1, H = 0;
                            h(M, g, p) && (H = M, M = g, g = H), h(T, F, p) && (H = T, T = F, F = H), h(M, P, p) && (H = M, M = P, P = H), h(g, P, p) && (H = g, g = P, P = H), h(M, T, p) && (H = M, M = T, T = H), h(P, T, p) && (H = P, P = T, T = H), h(g, F, p) && (H = g, g = F, F = H), h(g, P, p) && (H = g, g = P, P = H), h(T, F, p) && (H = T, T = F, F = H);
                            for(var X = p[2 * g], G = p[2 * g + 1], N = p[2 * T], W = p[2 * T + 1], re = 2 * M, ae = 2 * P, _e = 2 * F, Me = 2 * k, ke = 2 * L, ge = 2 * A, ie = 0; ie < 2; ++ie){
                                var Te = p[re + ie], Ee = p[ae + ie], Ae = p[_e + ie];
                                p[Me + ie] = Te, p[ke + ie] = Ee, p[ge + ie] = Ae;
                            }
                            u(_, x, p), u(C, b, p);
                            for(var ze = q; ze <= V; ++ze)if (d(ze, X, G, p)) ze !== q && l(ze, q, p), ++q;
                            else if (!d(ze, N, W, p)) for(;;)if (d(V, N, W, p)) {
                                d(V, X, G, p) ? (c(ze, q, V, p), ++q, --V) : (l(ze, V, p), --V);
                                break;
                            } else {
                                if (--V < ze) break;
                                continue;
                            }
                            f(x, q - 1, X, G, p), f(b, V + 1, N, W, p), q - 2 - x <= a ? s(x, q - 2, p) : v(x, q - 2, p), b - (V + 2) <= a ? s(V + 2, b, p) : v(V + 2, b, p), V - q <= a ? s(q, V, p) : v(q, V, p);
                        }
                    },
                    855: function(i, a, o) {
                        "use strict";
                        i.exports = {
                            init: k,
                            sweepBipartite: _,
                            sweepComplete: C,
                            scanBipartite: M,
                            scanComplete: g
                        };
                        var s = o(1888), l = o(8828), u = o(4192), c = 268435456, f = 1024, h = s.mallocInt32(f), d = s.mallocInt32(f), v = s.mallocInt32(f), x = s.mallocInt32(f), b = s.mallocInt32(f), p = s.mallocInt32(f), E = s.mallocDouble(f * 8);
                        function k(P) {
                            var T = l.nextPow2(P);
                            h.length < T && (s.free(h), h = s.mallocInt32(T)), d.length < T && (s.free(d), d = s.mallocInt32(T)), v.length < T && (s.free(v), v = s.mallocInt32(T)), x.length < T && (s.free(x), x = s.mallocInt32(T)), b.length < T && (s.free(b), b = s.mallocInt32(T)), p.length < T && (s.free(p), p = s.mallocInt32(T));
                            var F = 8 * T;
                            E.length < F && (s.free(E), E = s.mallocDouble(F));
                        }
                        function A(P, T, F, q) {
                            var V = T[q], H = P[F - 1];
                            P[V] = H, T[H] = V;
                        }
                        function L(P, T, F, q) {
                            P[F] = q, T[q] = F;
                        }
                        function _(P, T, F, q, V, H, X, G, N, W) {
                            for(var re = 0, ae = 2 * P, _e = P - 1, Me = ae - 1, ke = F; ke < q; ++ke){
                                var ge = H[ke], ie = ae * ke;
                                E[re++] = V[ie + _e], E[re++] = -(ge + 1), E[re++] = V[ie + Me], E[re++] = ge;
                            }
                            for(var ke = X; ke < G; ++ke){
                                var ge = W[ke] + c, Te = ae * ke;
                                E[re++] = N[Te + _e], E[re++] = -ge, E[re++] = N[Te + Me], E[re++] = ge;
                            }
                            var Ee = re >>> 1;
                            u(E, Ee);
                            for(var Ae = 0, ze = 0, ke = 0; ke < Ee; ++ke){
                                var Ce = E[2 * ke + 1] | 0;
                                if (Ce >= c) Ce = Ce - c | 0, A(v, x, ze--, Ce);
                                else if (Ce >= 0) A(h, d, Ae--, Ce);
                                else if (Ce <= -c) {
                                    Ce = -Ce - c | 0;
                                    for(var me = 0; me < Ae; ++me){
                                        var Re = T(h[me], Ce);
                                        if (Re !== void 0) return Re;
                                    }
                                    L(v, x, ze++, Ce);
                                } else {
                                    Ce = -Ce - 1 | 0;
                                    for(var me = 0; me < ze; ++me){
                                        var Re = T(Ce, v[me]);
                                        if (Re !== void 0) return Re;
                                    }
                                    L(h, d, Ae++, Ce);
                                }
                            }
                        }
                        function C(P, T, F, q, V, H, X, G, N, W) {
                            for(var re = 0, ae = 2 * P, _e = P - 1, Me = ae - 1, ke = F; ke < q; ++ke){
                                var ge = H[ke] + 1 << 1, ie = ae * ke;
                                E[re++] = V[ie + _e], E[re++] = -ge, E[re++] = V[ie + Me], E[re++] = ge;
                            }
                            for(var ke = X; ke < G; ++ke){
                                var ge = W[ke] + 1 << 1, Te = ae * ke;
                                E[re++] = N[Te + _e], E[re++] = -ge | 1, E[re++] = N[Te + Me], E[re++] = ge | 1;
                            }
                            var Ee = re >>> 1;
                            u(E, Ee);
                            for(var Ae = 0, ze = 0, Ce = 0, ke = 0; ke < Ee; ++ke){
                                var me = E[2 * ke + 1] | 0, Re = me & 1;
                                if (ke < Ee - 1 && me >> 1 === E[2 * ke + 3] >> 1 && (Re = 2, ke += 1), me < 0) {
                                    for(var ce = -(me >> 1) - 1, Ge = 0; Ge < Ce; ++Ge){
                                        var nt = T(b[Ge], ce);
                                        if (nt !== void 0) return nt;
                                    }
                                    if (Re !== 0) for(var Ge = 0; Ge < Ae; ++Ge){
                                        var nt = T(h[Ge], ce);
                                        if (nt !== void 0) return nt;
                                    }
                                    if (Re !== 1) for(var Ge = 0; Ge < ze; ++Ge){
                                        var nt = T(v[Ge], ce);
                                        if (nt !== void 0) return nt;
                                    }
                                    Re === 0 ? L(h, d, Ae++, ce) : Re === 1 ? L(v, x, ze++, ce) : Re === 2 && L(b, p, Ce++, ce);
                                } else {
                                    var ce = (me >> 1) - 1;
                                    Re === 0 ? A(h, d, Ae--, ce) : Re === 1 ? A(v, x, ze--, ce) : Re === 2 && A(b, p, Ce--, ce);
                                }
                            }
                        }
                        function M(P, T, F, q, V, H, X, G, N, W, re, ae) {
                            var _e = 0, Me = 2 * P, ke = T, ge = T + P, ie = 1, Te = 1;
                            q ? Te = c : ie = c;
                            for(var Ee = V; Ee < H; ++Ee){
                                var Ae = Ee + ie, ze = Me * Ee;
                                E[_e++] = X[ze + ke], E[_e++] = -Ae, E[_e++] = X[ze + ge], E[_e++] = Ae;
                            }
                            for(var Ee = N; Ee < W; ++Ee){
                                var Ae = Ee + Te, Ce = Me * Ee;
                                E[_e++] = re[Ce + ke], E[_e++] = -Ae;
                            }
                            var me = _e >>> 1;
                            u(E, me);
                            for(var Re = 0, Ee = 0; Ee < me; ++Ee){
                                var ce = E[2 * Ee + 1] | 0;
                                if (ce < 0) {
                                    var Ae = -ce, Ge = !1;
                                    if (Ae >= c ? (Ge = !q, Ae -= c) : (Ge = !!q, Ae -= 1), Ge) L(h, d, Re++, Ae);
                                    else {
                                        var nt = ae[Ae], ct = Me * Ae, qt = re[ct + T + 1], rt = re[ct + T + 1 + P];
                                        e: for(var ot = 0; ot < Re; ++ot){
                                            var Rt = h[ot], kt = Me * Rt;
                                            if (!(rt < X[kt + T + 1] || X[kt + T + 1 + P] < qt)) {
                                                for(var Ct = T + 2; Ct < P; ++Ct)if (re[ct + Ct + P] < X[kt + Ct] || X[kt + Ct + P] < re[ct + Ct]) continue e;
                                                var Yt = G[Rt], xr;
                                                if (q ? xr = F(nt, Yt) : xr = F(Yt, nt), xr !== void 0) return xr;
                                            }
                                        }
                                    }
                                } else A(h, d, Re--, ce - ie);
                            }
                        }
                        function g(P, T, F, q, V, H, X, G, N, W, re) {
                            for(var ae = 0, _e = 2 * P, Me = T, ke = T + P, ge = q; ge < V; ++ge){
                                var ie = ge + c, Te = _e * ge;
                                E[ae++] = H[Te + Me], E[ae++] = -ie, E[ae++] = H[Te + ke], E[ae++] = ie;
                            }
                            for(var ge = G; ge < N; ++ge){
                                var ie = ge + 1, Ee = _e * ge;
                                E[ae++] = W[Ee + Me], E[ae++] = -ie;
                            }
                            var Ae = ae >>> 1;
                            u(E, Ae);
                            for(var ze = 0, ge = 0; ge < Ae; ++ge){
                                var Ce = E[2 * ge + 1] | 0;
                                if (Ce < 0) {
                                    var ie = -Ce;
                                    if (ie >= c) h[ze++] = ie - c;
                                    else {
                                        ie -= 1;
                                        var me = re[ie], Re = _e * ie, ce = W[Re + T + 1], Ge = W[Re + T + 1 + P];
                                        e: for(var nt = 0; nt < ze; ++nt){
                                            var ct = h[nt], qt = X[ct];
                                            if (qt === me) break;
                                            var rt = _e * ct;
                                            if (!(Ge < H[rt + T + 1] || H[rt + T + 1 + P] < ce)) {
                                                for(var ot = T + 2; ot < P; ++ot)if (W[Re + ot + P] < H[rt + ot] || H[rt + ot + P] < W[Re + ot]) continue e;
                                                var Rt = F(qt, me);
                                                if (Rt !== void 0) return Rt;
                                            }
                                        }
                                    }
                                } else {
                                    for(var ie = Ce - c, nt = ze - 1; nt >= 0; --nt)if (h[nt] === ie) {
                                        for(var ot = nt + 1; ot < ze; ++ot)h[ot - 1] = h[ot];
                                        break;
                                    }
                                    --ze;
                                }
                            }
                        }
                    },
                    2538: function(i, a, o) {
                        "use strict";
                        var s = o(8902), l = o(5542), u = o(2272), c = o(5023);
                        i.exports = x;
                        function f(b) {
                            return [
                                Math.min(b[0], b[1]),
                                Math.max(b[0], b[1])
                            ];
                        }
                        function h(b, p) {
                            return b[0] - p[0] || b[1] - p[1];
                        }
                        function d(b) {
                            return b.map(f).sort(h);
                        }
                        function v(b, p, E) {
                            return p in b ? b[p] : E;
                        }
                        function x(b, p, E) {
                            Array.isArray(p) ? (E = E || {}, p = p || []) : (E = p || {}, p = []);
                            var k = !!v(E, "delaunay", !0), A = !!v(E, "interior", !0), L = !!v(E, "exterior", !0), _ = !!v(E, "infinity", !1);
                            if (!A && !L || b.length === 0) return [];
                            var C = s(b, p);
                            if (k || A !== L || _) {
                                for(var M = l(b.length, d(p)), g = 0; g < C.length; ++g){
                                    var P = C[g];
                                    M.addTriangle(P[0], P[1], P[2]);
                                }
                                return k && u(b, M), L ? A ? _ ? c(M, 0, _) : M.cells() : c(M, 1, _) : c(M, -1);
                            } else return C;
                        }
                    },
                    2272: function(i, a, o) {
                        "use strict";
                        var s = o(2646)[4], l = o(2478);
                        i.exports = c;
                        function u(f, h, d, v, x, b) {
                            var p = h.opposite(v, x);
                            if (!(p < 0)) {
                                if (x < v) {
                                    var E = v;
                                    v = x, x = E, E = b, b = p, p = E;
                                }
                                h.isConstraint(v, x) || s(f[v], f[x], f[b], f[p]) < 0 && d.push(v, x);
                            }
                        }
                        function c(f, h) {
                            for(var d = [], v = f.length, x = h.stars, b = 0; b < v; ++b)for(var p = x[b], E = 1; E < p.length; E += 2){
                                var k = p[E];
                                if (!(k < b) && !h.isConstraint(b, k)) {
                                    for(var A = p[E - 1], L = -1, _ = 1; _ < p.length; _ += 2)if (p[_ - 1] === k) {
                                        L = p[_];
                                        break;
                                    }
                                    L < 0 || s(f[b], f[k], f[A], f[L]) < 0 && d.push(b, k);
                                }
                            }
                            for(; d.length > 0;){
                                for(var k = d.pop(), b = d.pop(), A = -1, L = -1, p = x[b], C = 1; C < p.length; C += 2){
                                    var M = p[C - 1], g = p[C];
                                    M === k ? L = g : g === k && (A = M);
                                }
                                A < 0 || L < 0 || s(f[b], f[k], f[A], f[L]) >= 0 || (h.flip(b, k), u(f, h, d, A, b, L), u(f, h, d, b, L, A), u(f, h, d, L, k, A), u(f, h, d, k, A, L));
                            }
                        }
                    },
                    5023: function(i, a, o) {
                        "use strict";
                        var s = o(2478);
                        i.exports = d;
                        function l(v, x, b, p, E, k, A) {
                            this.cells = v, this.neighbor = x, this.flags = p, this.constraint = b, this.active = E, this.next = k, this.boundary = A;
                        }
                        var u = l.prototype;
                        function c(v, x) {
                            return v[0] - x[0] || v[1] - x[1] || v[2] - x[2];
                        }
                        u.locate = function() {
                            var v = [
                                0,
                                0,
                                0
                            ];
                            return function(x, b, p) {
                                var E = x, k = b, A = p;
                                return b < p ? b < x && (E = b, k = p, A = x) : p < x && (E = p, k = x, A = b), E < 0 ? -1 : (v[0] = E, v[1] = k, v[2] = A, s.eq(this.cells, v, c));
                            };
                        }();
                        function f(v, x) {
                            for(var b = v.cells(), p = b.length, E = 0; E < p; ++E){
                                var k = b[E], A = k[0], L = k[1], _ = k[2];
                                L < _ ? L < A && (k[0] = L, k[1] = _, k[2] = A) : _ < A && (k[0] = _, k[1] = A, k[2] = L);
                            }
                            b.sort(c);
                            for(var C = new Array(p), E = 0; E < C.length; ++E)C[E] = 0;
                            var M = [], g = [], P = new Array(3 * p), T = new Array(3 * p), F = null;
                            x && (F = []);
                            for(var q = new l(b, P, T, C, M, g, F), E = 0; E < p; ++E)for(var k = b[E], V = 0; V < 3; ++V){
                                var A = k[V], L = k[(V + 1) % 3], H = P[3 * E + V] = q.locate(L, A, v.opposite(L, A)), X = T[3 * E + V] = v.isConstraint(A, L);
                                H < 0 && (X ? g.push(E) : (M.push(E), C[E] = 1), x && F.push([
                                    L,
                                    A,
                                    -1
                                ]));
                            }
                            return q;
                        }
                        function h(v, x, b) {
                            for(var p = 0, E = 0; E < v.length; ++E)x[E] === b && (v[p++] = v[E]);
                            return v.length = p, v;
                        }
                        function d(v, x, b) {
                            var p = f(v, b);
                            if (x === 0) return b ? p.cells.concat(p.boundary) : p.cells;
                            for(var E = 1, k = p.active, A = p.next, L = p.flags, _ = p.cells, C = p.constraint, M = p.neighbor; k.length > 0 || A.length > 0;){
                                for(; k.length > 0;){
                                    var g = k.pop();
                                    if (L[g] !== -E) {
                                        L[g] = E;
                                        for(var P = _[g], T = 0; T < 3; ++T){
                                            var F = M[3 * g + T];
                                            F >= 0 && L[F] === 0 && (C[3 * g + T] ? A.push(F) : (k.push(F), L[F] = E));
                                        }
                                    }
                                }
                                var q = A;
                                A = k, k = q, A.length = 0, E = -E;
                            }
                            var V = h(_, L, x);
                            return b ? V.concat(p.boundary) : V;
                        }
                    },
                    8902: function(i, a, o) {
                        "use strict";
                        var s = o(2478), l = o(3250)[3], u = 0, c = 1, f = 2;
                        i.exports = A;
                        function h(L, _, C, M, g) {
                            this.a = L, this.b = _, this.idx = C, this.lowerIds = M, this.upperIds = g;
                        }
                        function d(L, _, C, M) {
                            this.a = L, this.b = _, this.type = C, this.idx = M;
                        }
                        function v(L, _) {
                            var C = L.a[0] - _.a[0] || L.a[1] - _.a[1] || L.type - _.type;
                            return C || L.type !== u && (C = l(L.a, L.b, _.b), C) ? C : L.idx - _.idx;
                        }
                        function x(L, _) {
                            return l(L.a, L.b, _);
                        }
                        function b(L, _, C, M, g) {
                            for(var P = s.lt(_, M, x), T = s.gt(_, M, x), F = P; F < T; ++F){
                                for(var q = _[F], V = q.lowerIds, X = V.length; X > 1 && l(C[V[X - 2]], C[V[X - 1]], M) > 0;)L.push([
                                    V[X - 1],
                                    V[X - 2],
                                    g
                                ]), X -= 1;
                                V.length = X, V.push(g);
                                for(var H = q.upperIds, X = H.length; X > 1 && l(C[H[X - 2]], C[H[X - 1]], M) < 0;)L.push([
                                    H[X - 2],
                                    H[X - 1],
                                    g
                                ]), X -= 1;
                                H.length = X, H.push(g);
                            }
                        }
                        function p(L, _) {
                            var C;
                            return L.a[0] < _.a[0] ? C = l(L.a, L.b, _.a) : C = l(_.b, _.a, L.a), C || (_.b[0] < L.b[0] ? C = l(L.a, L.b, _.b) : C = l(_.b, _.a, L.b), C || L.idx - _.idx);
                        }
                        function E(L, _, C) {
                            var M = s.le(L, C, p), g = L[M], P = g.upperIds, T = P[P.length - 1];
                            g.upperIds = [
                                T
                            ], L.splice(M + 1, 0, new h(C.a, C.b, C.idx, [
                                T
                            ], P));
                        }
                        function k(L, _, C) {
                            var M = C.a;
                            C.a = C.b, C.b = M;
                            var g = s.eq(L, C, p), P = L[g], T = L[g - 1];
                            T.upperIds = P.upperIds, L.splice(g, 1);
                        }
                        function A(L, _) {
                            for(var C = L.length, M = _.length, g = [], P = 0; P < C; ++P)g.push(new d(L[P], null, u, P));
                            for(var P = 0; P < M; ++P){
                                var T = _[P], F = L[T[0]], q = L[T[1]];
                                F[0] < q[0] ? g.push(new d(F, q, f, P), new d(q, F, c, P)) : F[0] > q[0] && g.push(new d(q, F, f, P), new d(F, q, c, P));
                            }
                            g.sort(v);
                            for(var V = g[0].a[0] - (1 + Math.abs(g[0].a[0])) * Math.pow(2, -52), H = [
                                new h([
                                    V,
                                    1
                                ], [
                                    V,
                                    0
                                ], -1, [], [], [], [])
                            ], X = [], P = 0, G = g.length; P < G; ++P){
                                var N = g[P], W = N.type;
                                W === u ? b(X, H, L, N.a, N.idx) : W === f ? E(H, L, N) : k(H, L, N);
                            }
                            return X;
                        }
                    },
                    5542: function(i, a, o) {
                        "use strict";
                        var s = o(2478);
                        i.exports = f;
                        function l(h, d) {
                            this.stars = h, this.edges = d;
                        }
                        var u = l.prototype;
                        function c(h, d, v) {
                            for(var x = 1, b = h.length; x < b; x += 2)if (h[x - 1] === d && h[x] === v) {
                                h[x - 1] = h[b - 2], h[x] = h[b - 1], h.length = b - 2;
                                return;
                            }
                        }
                        u.isConstraint = function() {
                            var h = [
                                0,
                                0
                            ];
                            function d(v, x) {
                                return v[0] - x[0] || v[1] - x[1];
                            }
                            return function(v, x) {
                                return h[0] = Math.min(v, x), h[1] = Math.max(v, x), s.eq(this.edges, h, d) >= 0;
                            };
                        }(), u.removeTriangle = function(h, d, v) {
                            var x = this.stars;
                            c(x[h], d, v), c(x[d], v, h), c(x[v], h, d);
                        }, u.addTriangle = function(h, d, v) {
                            var x = this.stars;
                            x[h].push(d, v), x[d].push(v, h), x[v].push(h, d);
                        }, u.opposite = function(h, d) {
                            for(var v = this.stars[d], x = 1, b = v.length; x < b; x += 2)if (v[x] === h) return v[x - 1];
                            return -1;
                        }, u.flip = function(h, d) {
                            var v = this.opposite(h, d), x = this.opposite(d, h);
                            this.removeTriangle(h, d, v), this.removeTriangle(d, h, x), this.addTriangle(h, x, v), this.addTriangle(d, v, x);
                        }, u.edges = function() {
                            for(var h = this.stars, d = [], v = 0, x = h.length; v < x; ++v)for(var b = h[v], p = 0, E = b.length; p < E; p += 2)d.push([
                                b[p],
                                b[p + 1]
                            ]);
                            return d;
                        }, u.cells = function() {
                            for(var h = this.stars, d = [], v = 0, x = h.length; v < x; ++v)for(var b = h[v], p = 0, E = b.length; p < E; p += 2){
                                var k = b[p], A = b[p + 1];
                                v < Math.min(k, A) && d.push([
                                    v,
                                    k,
                                    A
                                ]);
                            }
                            return d;
                        };
                        function f(h, d) {
                            for(var v = new Array(h), x = 0; x < h; ++x)v[x] = [];
                            return new l(v, d);
                        }
                    },
                    2419: function(i) {
                        "use strict";
                        i.exports = a;
                        function a(o) {
                            for(var s = 1, l = 1; l < o.length; ++l)for(var u = 0; u < l; ++u)if (o[l] < o[u]) s = -s;
                            else if (o[u] === o[l]) return 0;
                            return s;
                        }
                    },
                    3628: function(i, a, o) {
                        "use strict";
                        var s = o(1338), l = o(727);
                        function u(h, d) {
                            for(var v = 0, x = h.length, b = 0; b < x; ++b)v += h[b] * d[b];
                            return v;
                        }
                        function c(h) {
                            var d = h.length;
                            if (d === 0) return [];
                            var v = h[0].length, x = s([
                                h.length + 1,
                                h.length + 1
                            ], 1), b = s([
                                h.length + 1
                            ], 1);
                            x[d][d] = 0;
                            for(var p = 0; p < d; ++p){
                                for(var E = 0; E <= p; ++E)x[E][p] = x[p][E] = 2 * u(h[p], h[E]);
                                b[p] = u(h[p], h[p]);
                            }
                            for(var k = l(x, b), A = 0, L = k[d + 1], p = 0; p < L.length; ++p)A += L[p];
                            for(var _ = new Array(d), p = 0; p < d; ++p){
                                for(var L = k[p], C = 0, E = 0; E < L.length; ++E)C += L[E];
                                _[p] = C / A;
                            }
                            return _;
                        }
                        function f(h) {
                            if (h.length === 0) return [];
                            for(var d = h[0].length, v = s([
                                d
                            ]), x = c(h), b = 0; b < h.length; ++b)for(var p = 0; p < d; ++p)v[p] += h[b][p] * x[b];
                            return v;
                        }
                        f.barycenetric = c, i.exports = f;
                    },
                    6037: function(i, a, o) {
                        i.exports = l;
                        var s = o(3628);
                        function l(u) {
                            for(var c = s(u), f = 0, h = 0; h < u.length; ++h)for(var d = u[h], v = 0; v < c.length; ++v)f += Math.pow(d[v] - c[v], 2);
                            return Math.sqrt(f / u.length);
                        }
                    },
                    332: function(i, a, o) {
                        "use strict";
                        i.exports = F;
                        var s = o(1755), l = o(6867), u = o(1125), c = o(7842), f = o(1318), h = o(946), d = o(5838), v = o(1278), x = o(3637);
                        function b(q) {
                            var V = h(q);
                            return [
                                v(V, -1 / 0),
                                v(V, 1 / 0)
                            ];
                        }
                        function p(q, V) {
                            for(var H = new Array(V.length), X = 0; X < V.length; ++X){
                                var G = V[X], N = q[G[0]], W = q[G[1]];
                                H[X] = [
                                    v(Math.min(N[0], W[0]), -1 / 0),
                                    v(Math.min(N[1], W[1]), -1 / 0),
                                    v(Math.max(N[0], W[0]), 1 / 0),
                                    v(Math.max(N[1], W[1]), 1 / 0)
                                ];
                            }
                            return H;
                        }
                        function E(q) {
                            for(var V = new Array(q.length), H = 0; H < q.length; ++H){
                                var X = q[H];
                                V[H] = [
                                    v(X[0], -1 / 0),
                                    v(X[1], -1 / 0),
                                    v(X[0], 1 / 0),
                                    v(X[1], 1 / 0)
                                ];
                            }
                            return V;
                        }
                        function k(q, V, H) {
                            var X = [];
                            return l(H, function(G, N) {
                                var W = V[G], re = V[N];
                                if (!(W[0] === re[0] || W[0] === re[1] || W[1] === re[0] || W[1] === re[1])) {
                                    var ae = q[W[0]], _e = q[W[1]], Me = q[re[0]], ke = q[re[1]];
                                    u(ae, _e, Me, ke) && X.push([
                                        G,
                                        N
                                    ]);
                                }
                            }), X;
                        }
                        function A(q, V, H, X) {
                            var G = [];
                            return l(H, X, function(N, W) {
                                var re = V[N];
                                if (!(re[0] === W || re[1] === W)) {
                                    var ae = q[W], _e = q[re[0]], Me = q[re[1]];
                                    u(_e, Me, ae, ae) && G.push([
                                        N,
                                        W
                                    ]);
                                }
                            }), G;
                        }
                        function L(q, V, H, X, G) {
                            var N, W, re = q.map(function(ct) {
                                return [
                                    c(ct[0]),
                                    c(ct[1])
                                ];
                            });
                            for(N = 0; N < H.length; ++N){
                                var ae = H[N];
                                W = ae[0];
                                var _e = ae[1], Me = V[W], ke = V[_e], ge = x(d(q[Me[0]]), d(q[Me[1]]), d(q[ke[0]]), d(q[ke[1]]));
                                if (ge) {
                                    var ie = q.length;
                                    q.push([
                                        h(ge[0]),
                                        h(ge[1])
                                    ]), re.push(ge), X.push([
                                        W,
                                        ie
                                    ], [
                                        _e,
                                        ie
                                    ]);
                                }
                            }
                            for(X.sort(function(ct, qt) {
                                if (ct[0] !== qt[0]) return ct[0] - qt[0];
                                var rt = re[ct[1]], ot = re[qt[1]];
                                return f(rt[0], ot[0]) || f(rt[1], ot[1]);
                            }), N = X.length - 1; N >= 0; --N){
                                var Te = X[N];
                                W = Te[0];
                                var Ee = V[W], Ae = Ee[0], ze = Ee[1], Ce = q[Ae], me = q[ze];
                                if ((Ce[0] - me[0] || Ce[1] - me[1]) < 0) {
                                    var Re = Ae;
                                    Ae = ze, ze = Re;
                                }
                                Ee[0] = Ae;
                                var ce = Ee[1] = Te[1], Ge;
                                for(G && (Ge = Ee[2]); N > 0 && X[N - 1][0] === W;){
                                    var Te = X[--N], nt = Te[1];
                                    G ? V.push([
                                        ce,
                                        nt,
                                        Ge
                                    ]) : V.push([
                                        ce,
                                        nt
                                    ]), ce = nt;
                                }
                                G ? V.push([
                                    ce,
                                    ze,
                                    Ge
                                ]) : V.push([
                                    ce,
                                    ze
                                ]);
                            }
                            return re;
                        }
                        function _(q, V, H) {
                            for(var X = V.length, G = new s(X), N = [], W = 0; W < V.length; ++W){
                                var re = V[W], ae = b(re[0]), _e = b(re[1]);
                                N.push([
                                    v(ae[0], -1 / 0),
                                    v(_e[0], -1 / 0),
                                    v(ae[1], 1 / 0),
                                    v(_e[1], 1 / 0)
                                ]);
                            }
                            l(N, function(Te, Ee) {
                                G.link(Te, Ee);
                            });
                            for(var Me = !0, ke = new Array(X), W = 0; W < X; ++W){
                                var ge = G.find(W);
                                ge !== W && (Me = !1, q[ge] = [
                                    Math.min(q[W][0], q[ge][0]),
                                    Math.min(q[W][1], q[ge][1])
                                ]);
                            }
                            if (Me) return null;
                            for(var ie = 0, W = 0; W < X; ++W){
                                var ge = G.find(W);
                                ge === W ? (ke[W] = ie, q[ie++] = q[W]) : ke[W] = -1;
                            }
                            q.length = ie;
                            for(var W = 0; W < X; ++W)ke[W] < 0 && (ke[W] = ke[G.find(W)]);
                            return ke;
                        }
                        function C(q, V) {
                            return q[0] - V[0] || q[1] - V[1];
                        }
                        function M(q, V) {
                            var H = q[0] - V[0] || q[1] - V[1];
                            return H || (q[2] < V[2] ? -1 : q[2] > V[2] ? 1 : 0);
                        }
                        function g(q, V, H) {
                            if (q.length !== 0) {
                                if (V) for(var X = 0; X < q.length; ++X){
                                    var G = q[X], N = V[G[0]], W = V[G[1]];
                                    G[0] = Math.min(N, W), G[1] = Math.max(N, W);
                                }
                                else for(var X = 0; X < q.length; ++X){
                                    var G = q[X], N = G[0], W = G[1];
                                    G[0] = Math.min(N, W), G[1] = Math.max(N, W);
                                }
                                H ? q.sort(M) : q.sort(C);
                                for(var re = 1, X = 1; X < q.length; ++X){
                                    var ae = q[X - 1], _e = q[X];
                                    _e[0] === ae[0] && _e[1] === ae[1] && (!H || _e[2] === ae[2]) || (q[re++] = _e);
                                }
                                q.length = re;
                            }
                        }
                        function P(q, V, H) {
                            var X = _(q, [], E(q));
                            return g(V, X, H), !!X;
                        }
                        function T(q, V, H) {
                            var X = p(q, V), G = k(q, V, X), N = E(q), W = A(q, V, X, N), re = L(q, V, G, W, H), ae = _(q, re, N);
                            return g(V, ae, H), ae ? !0 : G.length > 0 || W.length > 0;
                        }
                        function F(q, V, H) {
                            var X;
                            if (H) {
                                X = V;
                                for(var G = new Array(V.length), N = 0; N < V.length; ++N){
                                    var W = V[N];
                                    G[N] = [
                                        W[0],
                                        W[1],
                                        H[N]
                                    ];
                                }
                                V = G;
                            }
                            for(var re = P(q, V, !!H); T(q, V, !!H);)re = !0;
                            if (H && re) {
                                X.length = 0, H.length = 0;
                                for(var N = 0; N < V.length; ++N){
                                    var W = V[N];
                                    X.push([
                                        W[0],
                                        W[1]
                                    ]), H.push(W[2]);
                                }
                            }
                            return re;
                        }
                    },
                    3637: function(i, a, o) {
                        "use strict";
                        i.exports = x;
                        var s = o(6504), l = o(8697), u = o(5572), c = o(7721), f = o(544), h = o(2653), d = o(8987);
                        function v(b, p) {
                            return u(s(b[0], p[1]), s(b[1], p[0]));
                        }
                        function x(b, p, E, k) {
                            var A = f(p, b), L = f(k, E), _ = v(A, L);
                            if (c(_) === 0) return null;
                            var C = f(b, E), M = v(L, C), g = l(M, _), P = d(A, g), T = h(b, P);
                            return T;
                        }
                    },
                    3642: function(i) {
                        i.exports = {
                            jet: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        131
                                    ]
                                },
                                {
                                    index: .125,
                                    rgb: [
                                        0,
                                        60,
                                        170
                                    ]
                                },
                                {
                                    index: .375,
                                    rgb: [
                                        5,
                                        255,
                                        255
                                    ]
                                },
                                {
                                    index: .625,
                                    rgb: [
                                        255,
                                        255,
                                        0
                                    ]
                                },
                                {
                                    index: .875,
                                    rgb: [
                                        250,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        128,
                                        0,
                                        0
                                    ]
                                }
                            ],
                            hsv: [
                                {
                                    index: 0,
                                    rgb: [
                                        255,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: .169,
                                    rgb: [
                                        253,
                                        255,
                                        2
                                    ]
                                },
                                {
                                    index: .173,
                                    rgb: [
                                        247,
                                        255,
                                        2
                                    ]
                                },
                                {
                                    index: .337,
                                    rgb: [
                                        0,
                                        252,
                                        4
                                    ]
                                },
                                {
                                    index: .341,
                                    rgb: [
                                        0,
                                        252,
                                        10
                                    ]
                                },
                                {
                                    index: .506,
                                    rgb: [
                                        1,
                                        249,
                                        255
                                    ]
                                },
                                {
                                    index: .671,
                                    rgb: [
                                        2,
                                        0,
                                        253
                                    ]
                                },
                                {
                                    index: .675,
                                    rgb: [
                                        8,
                                        0,
                                        253
                                    ]
                                },
                                {
                                    index: .839,
                                    rgb: [
                                        255,
                                        0,
                                        251
                                    ]
                                },
                                {
                                    index: .843,
                                    rgb: [
                                        255,
                                        0,
                                        245
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        0,
                                        6
                                    ]
                                }
                            ],
                            hot: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: .3,
                                    rgb: [
                                        230,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: .6,
                                    rgb: [
                                        255,
                                        210,
                                        0
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        255,
                                        255
                                    ]
                                }
                            ],
                            spring: [
                                {
                                    index: 0,
                                    rgb: [
                                        255,
                                        0,
                                        255
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        255,
                                        0
                                    ]
                                }
                            ],
                            summer: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        128,
                                        102
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        255,
                                        102
                                    ]
                                }
                            ],
                            autumn: [
                                {
                                    index: 0,
                                    rgb: [
                                        255,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        255,
                                        0
                                    ]
                                }
                            ],
                            winter: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        255
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        0,
                                        255,
                                        128
                                    ]
                                }
                            ],
                            bone: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: .376,
                                    rgb: [
                                        84,
                                        84,
                                        116
                                    ]
                                },
                                {
                                    index: .753,
                                    rgb: [
                                        169,
                                        200,
                                        200
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        255,
                                        255
                                    ]
                                }
                            ],
                            copper: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: .804,
                                    rgb: [
                                        255,
                                        160,
                                        102
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        199,
                                        127
                                    ]
                                }
                            ],
                            greys: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        255,
                                        255
                                    ]
                                }
                            ],
                            yignbu: [
                                {
                                    index: 0,
                                    rgb: [
                                        8,
                                        29,
                                        88
                                    ]
                                },
                                {
                                    index: .125,
                                    rgb: [
                                        37,
                                        52,
                                        148
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        34,
                                        94,
                                        168
                                    ]
                                },
                                {
                                    index: .375,
                                    rgb: [
                                        29,
                                        145,
                                        192
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        65,
                                        182,
                                        196
                                    ]
                                },
                                {
                                    index: .625,
                                    rgb: [
                                        127,
                                        205,
                                        187
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        199,
                                        233,
                                        180
                                    ]
                                },
                                {
                                    index: .875,
                                    rgb: [
                                        237,
                                        248,
                                        217
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        255,
                                        217
                                    ]
                                }
                            ],
                            greens: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        68,
                                        27
                                    ]
                                },
                                {
                                    index: .125,
                                    rgb: [
                                        0,
                                        109,
                                        44
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        35,
                                        139,
                                        69
                                    ]
                                },
                                {
                                    index: .375,
                                    rgb: [
                                        65,
                                        171,
                                        93
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        116,
                                        196,
                                        118
                                    ]
                                },
                                {
                                    index: .625,
                                    rgb: [
                                        161,
                                        217,
                                        155
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        199,
                                        233,
                                        192
                                    ]
                                },
                                {
                                    index: .875,
                                    rgb: [
                                        229,
                                        245,
                                        224
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        247,
                                        252,
                                        245
                                    ]
                                }
                            ],
                            yiorrd: [
                                {
                                    index: 0,
                                    rgb: [
                                        128,
                                        0,
                                        38
                                    ]
                                },
                                {
                                    index: .125,
                                    rgb: [
                                        189,
                                        0,
                                        38
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        227,
                                        26,
                                        28
                                    ]
                                },
                                {
                                    index: .375,
                                    rgb: [
                                        252,
                                        78,
                                        42
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        253,
                                        141,
                                        60
                                    ]
                                },
                                {
                                    index: .625,
                                    rgb: [
                                        254,
                                        178,
                                        76
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        254,
                                        217,
                                        118
                                    ]
                                },
                                {
                                    index: .875,
                                    rgb: [
                                        255,
                                        237,
                                        160
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        255,
                                        204
                                    ]
                                }
                            ],
                            bluered: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        255
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        0,
                                        0
                                    ]
                                }
                            ],
                            rdbu: [
                                {
                                    index: 0,
                                    rgb: [
                                        5,
                                        10,
                                        172
                                    ]
                                },
                                {
                                    index: .35,
                                    rgb: [
                                        106,
                                        137,
                                        247
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        190,
                                        190,
                                        190
                                    ]
                                },
                                {
                                    index: .6,
                                    rgb: [
                                        220,
                                        170,
                                        132
                                    ]
                                },
                                {
                                    index: .7,
                                    rgb: [
                                        230,
                                        145,
                                        90
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        178,
                                        10,
                                        28
                                    ]
                                }
                            ],
                            picnic: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        255
                                    ]
                                },
                                {
                                    index: .1,
                                    rgb: [
                                        51,
                                        153,
                                        255
                                    ]
                                },
                                {
                                    index: .2,
                                    rgb: [
                                        102,
                                        204,
                                        255
                                    ]
                                },
                                {
                                    index: .3,
                                    rgb: [
                                        153,
                                        204,
                                        255
                                    ]
                                },
                                {
                                    index: .4,
                                    rgb: [
                                        204,
                                        204,
                                        255
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        255,
                                        255,
                                        255
                                    ]
                                },
                                {
                                    index: .6,
                                    rgb: [
                                        255,
                                        204,
                                        255
                                    ]
                                },
                                {
                                    index: .7,
                                    rgb: [
                                        255,
                                        153,
                                        255
                                    ]
                                },
                                {
                                    index: .8,
                                    rgb: [
                                        255,
                                        102,
                                        204
                                    ]
                                },
                                {
                                    index: .9,
                                    rgb: [
                                        255,
                                        102,
                                        102
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        0,
                                        0
                                    ]
                                }
                            ],
                            rainbow: [
                                {
                                    index: 0,
                                    rgb: [
                                        150,
                                        0,
                                        90
                                    ]
                                },
                                {
                                    index: .125,
                                    rgb: [
                                        0,
                                        0,
                                        200
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        0,
                                        25,
                                        255
                                    ]
                                },
                                {
                                    index: .375,
                                    rgb: [
                                        0,
                                        152,
                                        255
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        44,
                                        255,
                                        150
                                    ]
                                },
                                {
                                    index: .625,
                                    rgb: [
                                        151,
                                        255,
                                        0
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        255,
                                        234,
                                        0
                                    ]
                                },
                                {
                                    index: .875,
                                    rgb: [
                                        255,
                                        111,
                                        0
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        0,
                                        0
                                    ]
                                }
                            ],
                            portland: [
                                {
                                    index: 0,
                                    rgb: [
                                        12,
                                        51,
                                        131
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        10,
                                        136,
                                        186
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        242,
                                        211,
                                        56
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        242,
                                        143,
                                        56
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        217,
                                        30,
                                        30
                                    ]
                                }
                            ],
                            blackbody: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: .2,
                                    rgb: [
                                        230,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: .4,
                                    rgb: [
                                        230,
                                        210,
                                        0
                                    ]
                                },
                                {
                                    index: .7,
                                    rgb: [
                                        255,
                                        255,
                                        255
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        160,
                                        200,
                                        255
                                    ]
                                }
                            ],
                            earth: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        130
                                    ]
                                },
                                {
                                    index: .1,
                                    rgb: [
                                        0,
                                        180,
                                        180
                                    ]
                                },
                                {
                                    index: .2,
                                    rgb: [
                                        40,
                                        210,
                                        40
                                    ]
                                },
                                {
                                    index: .4,
                                    rgb: [
                                        230,
                                        230,
                                        50
                                    ]
                                },
                                {
                                    index: .6,
                                    rgb: [
                                        120,
                                        70,
                                        20
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        255,
                                        255
                                    ]
                                }
                            ],
                            electric: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: .15,
                                    rgb: [
                                        30,
                                        0,
                                        100
                                    ]
                                },
                                {
                                    index: .4,
                                    rgb: [
                                        120,
                                        0,
                                        100
                                    ]
                                },
                                {
                                    index: .6,
                                    rgb: [
                                        160,
                                        90,
                                        0
                                    ]
                                },
                                {
                                    index: .8,
                                    rgb: [
                                        230,
                                        200,
                                        0
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        250,
                                        220
                                    ]
                                }
                            ],
                            alpha: [
                                {
                                    index: 0,
                                    rgb: [
                                        255,
                                        255,
                                        255,
                                        0
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        255,
                                        255,
                                        1
                                    ]
                                }
                            ],
                            viridis: [
                                {
                                    index: 0,
                                    rgb: [
                                        68,
                                        1,
                                        84
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        71,
                                        44,
                                        122
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        59,
                                        81,
                                        139
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        44,
                                        113,
                                        142
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        33,
                                        144,
                                        141
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        39,
                                        173,
                                        129
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        92,
                                        200,
                                        99
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        170,
                                        220,
                                        50
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        253,
                                        231,
                                        37
                                    ]
                                }
                            ],
                            inferno: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        4
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        31,
                                        12,
                                        72
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        85,
                                        15,
                                        109
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        136,
                                        34,
                                        106
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        186,
                                        54,
                                        85
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        227,
                                        89,
                                        51
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        249,
                                        140,
                                        10
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        249,
                                        201,
                                        50
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        252,
                                        255,
                                        164
                                    ]
                                }
                            ],
                            magma: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        4
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        28,
                                        16,
                                        68
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        79,
                                        18,
                                        123
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        129,
                                        37,
                                        129
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        181,
                                        54,
                                        122
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        229,
                                        80,
                                        100
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        251,
                                        135,
                                        97
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        254,
                                        194,
                                        135
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        252,
                                        253,
                                        191
                                    ]
                                }
                            ],
                            plasma: [
                                {
                                    index: 0,
                                    rgb: [
                                        13,
                                        8,
                                        135
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        75,
                                        3,
                                        161
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        125,
                                        3,
                                        168
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        168,
                                        34,
                                        150
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        203,
                                        70,
                                        121
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        229,
                                        107,
                                        93
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        248,
                                        148,
                                        65
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        253,
                                        195,
                                        40
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        240,
                                        249,
                                        33
                                    ]
                                }
                            ],
                            warm: [
                                {
                                    index: 0,
                                    rgb: [
                                        125,
                                        0,
                                        179
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        172,
                                        0,
                                        187
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        219,
                                        0,
                                        170
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        255,
                                        0,
                                        130
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        255,
                                        63,
                                        74
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        255,
                                        123,
                                        0
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        234,
                                        176,
                                        0
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        190,
                                        228,
                                        0
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        147,
                                        255,
                                        0
                                    ]
                                }
                            ],
                            cool: [
                                {
                                    index: 0,
                                    rgb: [
                                        125,
                                        0,
                                        179
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        116,
                                        0,
                                        218
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        98,
                                        74,
                                        237
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        68,
                                        146,
                                        231
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        0,
                                        204,
                                        197
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        0,
                                        247,
                                        146
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        0,
                                        255,
                                        88
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        40,
                                        255,
                                        8
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        147,
                                        255,
                                        0
                                    ]
                                }
                            ],
                            "rainbow-soft": [
                                {
                                    index: 0,
                                    rgb: [
                                        125,
                                        0,
                                        179
                                    ]
                                },
                                {
                                    index: .1,
                                    rgb: [
                                        199,
                                        0,
                                        180
                                    ]
                                },
                                {
                                    index: .2,
                                    rgb: [
                                        255,
                                        0,
                                        121
                                    ]
                                },
                                {
                                    index: .3,
                                    rgb: [
                                        255,
                                        108,
                                        0
                                    ]
                                },
                                {
                                    index: .4,
                                    rgb: [
                                        222,
                                        194,
                                        0
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        150,
                                        255,
                                        0
                                    ]
                                },
                                {
                                    index: .6,
                                    rgb: [
                                        0,
                                        255,
                                        55
                                    ]
                                },
                                {
                                    index: .7,
                                    rgb: [
                                        0,
                                        246,
                                        150
                                    ]
                                },
                                {
                                    index: .8,
                                    rgb: [
                                        50,
                                        167,
                                        222
                                    ]
                                },
                                {
                                    index: .9,
                                    rgb: [
                                        103,
                                        51,
                                        235
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        124,
                                        0,
                                        186
                                    ]
                                }
                            ],
                            bathymetry: [
                                {
                                    index: 0,
                                    rgb: [
                                        40,
                                        26,
                                        44
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        59,
                                        49,
                                        90
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        64,
                                        76,
                                        139
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        63,
                                        110,
                                        151
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        72,
                                        142,
                                        158
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        85,
                                        174,
                                        163
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        120,
                                        206,
                                        163
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        187,
                                        230,
                                        172
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        253,
                                        254,
                                        204
                                    ]
                                }
                            ],
                            cdom: [
                                {
                                    index: 0,
                                    rgb: [
                                        47,
                                        15,
                                        62
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        87,
                                        23,
                                        86
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        130,
                                        28,
                                        99
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        171,
                                        41,
                                        96
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        206,
                                        67,
                                        86
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        230,
                                        106,
                                        84
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        242,
                                        149,
                                        103
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        249,
                                        193,
                                        135
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        254,
                                        237,
                                        176
                                    ]
                                }
                            ],
                            chlorophyll: [
                                {
                                    index: 0,
                                    rgb: [
                                        18,
                                        36,
                                        20
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        25,
                                        63,
                                        41
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        24,
                                        91,
                                        59
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        13,
                                        119,
                                        72
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        18,
                                        148,
                                        80
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        80,
                                        173,
                                        89
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        132,
                                        196,
                                        122
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        175,
                                        221,
                                        162
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        215,
                                        249,
                                        208
                                    ]
                                }
                            ],
                            density: [
                                {
                                    index: 0,
                                    rgb: [
                                        54,
                                        14,
                                        36
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        89,
                                        23,
                                        80
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        110,
                                        45,
                                        132
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        120,
                                        77,
                                        178
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        120,
                                        113,
                                        213
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        115,
                                        151,
                                        228
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        134,
                                        185,
                                        227
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        177,
                                        214,
                                        227
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        230,
                                        241,
                                        241
                                    ]
                                }
                            ],
                            "freesurface-blue": [
                                {
                                    index: 0,
                                    rgb: [
                                        30,
                                        4,
                                        110
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        47,
                                        14,
                                        176
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        41,
                                        45,
                                        236
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        25,
                                        99,
                                        212
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        68,
                                        131,
                                        200
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        114,
                                        156,
                                        197
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        157,
                                        181,
                                        203
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        200,
                                        208,
                                        216
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        241,
                                        237,
                                        236
                                    ]
                                }
                            ],
                            "freesurface-red": [
                                {
                                    index: 0,
                                    rgb: [
                                        60,
                                        9,
                                        18
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        100,
                                        17,
                                        27
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        142,
                                        20,
                                        29
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        177,
                                        43,
                                        27
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        192,
                                        87,
                                        63
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        205,
                                        125,
                                        105
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        216,
                                        162,
                                        148
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        227,
                                        199,
                                        193
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        241,
                                        237,
                                        236
                                    ]
                                }
                            ],
                            oxygen: [
                                {
                                    index: 0,
                                    rgb: [
                                        64,
                                        5,
                                        5
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        106,
                                        6,
                                        15
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        144,
                                        26,
                                        7
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        168,
                                        64,
                                        3
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        188,
                                        100,
                                        4
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        206,
                                        136,
                                        11
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        220,
                                        174,
                                        25
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        231,
                                        215,
                                        44
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        248,
                                        254,
                                        105
                                    ]
                                }
                            ],
                            par: [
                                {
                                    index: 0,
                                    rgb: [
                                        51,
                                        20,
                                        24
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        90,
                                        32,
                                        35
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        129,
                                        44,
                                        34
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        159,
                                        68,
                                        25
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        182,
                                        99,
                                        19
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        199,
                                        134,
                                        22
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        212,
                                        171,
                                        35
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        221,
                                        210,
                                        54
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        225,
                                        253,
                                        75
                                    ]
                                }
                            ],
                            phase: [
                                {
                                    index: 0,
                                    rgb: [
                                        145,
                                        105,
                                        18
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        184,
                                        71,
                                        38
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        186,
                                        58,
                                        115
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        160,
                                        71,
                                        185
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        110,
                                        97,
                                        218
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        50,
                                        123,
                                        164
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        31,
                                        131,
                                        110
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        77,
                                        129,
                                        34
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        145,
                                        105,
                                        18
                                    ]
                                }
                            ],
                            salinity: [
                                {
                                    index: 0,
                                    rgb: [
                                        42,
                                        24,
                                        108
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        33,
                                        50,
                                        162
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        15,
                                        90,
                                        145
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        40,
                                        118,
                                        137
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        59,
                                        146,
                                        135
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        79,
                                        175,
                                        126
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        120,
                                        203,
                                        104
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        193,
                                        221,
                                        100
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        253,
                                        239,
                                        154
                                    ]
                                }
                            ],
                            temperature: [
                                {
                                    index: 0,
                                    rgb: [
                                        4,
                                        35,
                                        51
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        23,
                                        51,
                                        122
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        85,
                                        59,
                                        157
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        129,
                                        79,
                                        143
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        175,
                                        95,
                                        130
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        222,
                                        112,
                                        101
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        249,
                                        146,
                                        66
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        249,
                                        196,
                                        65
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        232,
                                        250,
                                        91
                                    ]
                                }
                            ],
                            turbidity: [
                                {
                                    index: 0,
                                    rgb: [
                                        34,
                                        31,
                                        27
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        65,
                                        50,
                                        41
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        98,
                                        69,
                                        52
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        131,
                                        89,
                                        57
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        161,
                                        112,
                                        59
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        185,
                                        140,
                                        66
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        202,
                                        174,
                                        88
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        216,
                                        209,
                                        126
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        233,
                                        246,
                                        171
                                    ]
                                }
                            ],
                            "velocity-blue": [
                                {
                                    index: 0,
                                    rgb: [
                                        17,
                                        32,
                                        64
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        35,
                                        52,
                                        116
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        29,
                                        81,
                                        156
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        31,
                                        113,
                                        162
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        50,
                                        144,
                                        169
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        87,
                                        173,
                                        176
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        149,
                                        196,
                                        189
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        203,
                                        221,
                                        211
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        254,
                                        251,
                                        230
                                    ]
                                }
                            ],
                            "velocity-green": [
                                {
                                    index: 0,
                                    rgb: [
                                        23,
                                        35,
                                        19
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        24,
                                        64,
                                        38
                                    ]
                                },
                                {
                                    index: .25,
                                    rgb: [
                                        11,
                                        95,
                                        45
                                    ]
                                },
                                {
                                    index: .38,
                                    rgb: [
                                        39,
                                        123,
                                        35
                                    ]
                                },
                                {
                                    index: .5,
                                    rgb: [
                                        95,
                                        146,
                                        12
                                    ]
                                },
                                {
                                    index: .63,
                                    rgb: [
                                        152,
                                        165,
                                        18
                                    ]
                                },
                                {
                                    index: .75,
                                    rgb: [
                                        201,
                                        186,
                                        69
                                    ]
                                },
                                {
                                    index: .88,
                                    rgb: [
                                        233,
                                        216,
                                        137
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        255,
                                        253,
                                        205
                                    ]
                                }
                            ],
                            cubehelix: [
                                {
                                    index: 0,
                                    rgb: [
                                        0,
                                        0,
                                        0
                                    ]
                                },
                                {
                                    index: .07,
                                    rgb: [
                                        22,
                                        5,
                                        59
                                    ]
                                },
                                {
                                    index: .13,
                                    rgb: [
                                        60,
                                        4,
                                        105
                                    ]
                                },
                                {
                                    index: .2,
                                    rgb: [
                                        109,
                                        1,
                                        135
                                    ]
                                },
                                {
                                    index: .27,
                                    rgb: [
                                        161,
                                        0,
                                        147
                                    ]
                                },
                                {
                                    index: .33,
                                    rgb: [
                                        210,
                                        2,
                                        142
                                    ]
                                },
                                {
                                    index: .4,
                                    rgb: [
                                        251,
                                        11,
                                        123
                                    ]
                                },
                                {
                                    index: .47,
                                    rgb: [
                                        255,
                                        29,
                                        97
                                    ]
                                },
                                {
                                    index: .53,
                                    rgb: [
                                        255,
                                        54,
                                        69
                                    ]
                                },
                                {
                                    index: .6,
                                    rgb: [
                                        255,
                                        85,
                                        46
                                    ]
                                },
                                {
                                    index: .67,
                                    rgb: [
                                        255,
                                        120,
                                        34
                                    ]
                                },
                                {
                                    index: .73,
                                    rgb: [
                                        255,
                                        157,
                                        37
                                    ]
                                },
                                {
                                    index: .8,
                                    rgb: [
                                        241,
                                        191,
                                        57
                                    ]
                                },
                                {
                                    index: .87,
                                    rgb: [
                                        224,
                                        220,
                                        93
                                    ]
                                },
                                {
                                    index: .93,
                                    rgb: [
                                        218,
                                        241,
                                        142
                                    ]
                                },
                                {
                                    index: 1,
                                    rgb: [
                                        227,
                                        253,
                                        198
                                    ]
                                }
                            ]
                        };
                    },
                    6729: function(i, a, o) {
                        "use strict";
                        var s = o(3642), l = o(395);
                        i.exports = u;
                        function u(d) {
                            var v, x, b, p, E, k, A, L, g, _, C;
                            if (d || (d = {}), L = (d.nshades || 72) - 1, A = d.format || "hex", k = d.colormap, k || (k = "jet"), typeof k == "string") {
                                if (k = k.toLowerCase(), !s[k]) throw Error(k + " not a supported colorscale");
                                E = s[k];
                            } else if (Array.isArray(k)) E = k.slice();
                            else throw Error("unsupported colormap option", k);
                            if (E.length > L + 1) throw new Error(k + " map requires nshades to be at least size " + E.length);
                            Array.isArray(d.alpha) ? d.alpha.length !== 2 ? _ = [
                                1,
                                1
                            ] : _ = d.alpha.slice() : typeof d.alpha == "number" ? _ = [
                                d.alpha,
                                d.alpha
                            ] : _ = [
                                1,
                                1
                            ], v = E.map(function(F) {
                                return Math.round(F.index * L);
                            }), _[0] = Math.min(Math.max(_[0], 0), 1), _[1] = Math.min(Math.max(_[1], 0), 1);
                            var M = E.map(function(F, q) {
                                var V = E[q].index, H = E[q].rgb.slice();
                                return H.length === 4 && H[3] >= 0 && H[3] <= 1 || (H[3] = _[0] + (_[1] - _[0]) * V), H;
                            }), g = [];
                            for(C = 0; C < v.length - 1; ++C){
                                p = v[C + 1] - v[C], x = M[C], b = M[C + 1];
                                for(var P = 0; P < p; P++){
                                    var T = P / p;
                                    g.push([
                                        Math.round(l(x[0], b[0], T)),
                                        Math.round(l(x[1], b[1], T)),
                                        Math.round(l(x[2], b[2], T)),
                                        l(x[3], b[3], T)
                                    ]);
                                }
                            }
                            return g.push(E[E.length - 1].rgb.concat(_[1])), A === "hex" ? g = g.map(f) : A === "rgbaString" ? g = g.map(h) : A === "float" && (g = g.map(c)), g;
                        }
                        function c(d) {
                            return [
                                d[0] / 255,
                                d[1] / 255,
                                d[2] / 255,
                                d[3]
                            ];
                        }
                        function f(d) {
                            for(var v, x = "#", b = 0; b < 3; ++b)v = d[b], v = v.toString(16), x += ("00" + v).substr(v.length);
                            return x;
                        }
                        function h(d) {
                            return "rgba(" + d.join(",") + ")";
                        }
                    },
                    3140: function(i, a, o) {
                        "use strict";
                        i.exports = d;
                        var s = o(3250), l = o(8572), u = o(9362), c = o(5382), f = o(8210);
                        function h(v, x, b) {
                            var p = u(v[0], -x[0]), E = u(v[1], -x[1]), k = u(b[0], -x[0]), A = u(b[1], -x[1]), L = f(c(p, k), c(E, A));
                            return L[L.length - 1] >= 0;
                        }
                        function d(v, x, b, p) {
                            var E = s(x, b, p);
                            if (E === 0) {
                                var k = l(s(v, x, b)), A = l(s(v, x, p));
                                if (k === A) {
                                    if (k === 0) {
                                        var L = h(v, x, b), _ = h(v, x, p);
                                        return L === _ ? 0 : L ? 1 : -1;
                                    }
                                    return 0;
                                } else {
                                    if (A === 0) return k > 0 || h(v, x, p) ? -1 : 1;
                                    if (k === 0) return A > 0 || h(v, x, b) ? 1 : -1;
                                }
                                return l(A - k);
                            }
                            var C = s(v, x, b);
                            if (C > 0) return E > 0 && s(v, x, p) > 0 ? 1 : -1;
                            if (C < 0) return E > 0 || s(v, x, p) > 0 ? 1 : -1;
                            var M = s(v, x, p);
                            return M > 0 || h(v, x, b) ? 1 : -1;
                        }
                    },
                    8572: function(i) {
                        "use strict";
                        i.exports = function(o) {
                            return o < 0 ? -1 : o > 0 ? 1 : 0;
                        };
                    },
                    8507: function(i) {
                        i.exports = s;
                        var a = Math.min;
                        function o(l, u) {
                            return l - u;
                        }
                        function s(l, u) {
                            var c = l.length, f = l.length - u.length;
                            if (f) return f;
                            switch(c){
                                case 0:
                                    return 0;
                                case 1:
                                    return l[0] - u[0];
                                case 2:
                                    return l[0] + l[1] - u[0] - u[1] || a(l[0], l[1]) - a(u[0], u[1]);
                                case 3:
                                    var h = l[0] + l[1], d = u[0] + u[1];
                                    if (f = h + l[2] - (d + u[2]), f) return f;
                                    var v = a(l[0], l[1]), x = a(u[0], u[1]);
                                    return a(v, l[2]) - a(x, u[2]) || a(v + l[2], h) - a(x + u[2], d);
                                case 4:
                                    var b = l[0], p = l[1], E = l[2], k = l[3], A = u[0], L = u[1], _ = u[2], C = u[3];
                                    return b + p + E + k - (A + L + _ + C) || a(b, p, E, k) - a(A, L, _, C, A) || a(b + p, b + E, b + k, p + E, p + k, E + k) - a(A + L, A + _, A + C, L + _, L + C, _ + C) || a(b + p + E, b + p + k, b + E + k, p + E + k) - a(A + L + _, A + L + C, A + _ + C, L + _ + C);
                                default:
                                    for(var M = l.slice().sort(o), g = u.slice().sort(o), P = 0; P < c; ++P)if (f = M[P] - g[P], f) return f;
                                    return 0;
                            }
                        }
                    },
                    3788: function(i, a, o) {
                        "use strict";
                        var s = o(8507), l = o(2419);
                        i.exports = u;
                        function u(c, f) {
                            return s(c, f) || l(c) - l(f);
                        }
                    },
                    7352: function(i, a, o) {
                        "use strict";
                        var s = o(5721), l = o(4750), u = o(2690);
                        i.exports = c;
                        function c(f) {
                            var h = f.length;
                            if (h === 0) return [];
                            if (h === 1) return [
                                [
                                    0
                                ]
                            ];
                            var d = f[0].length;
                            return d === 0 ? [] : d === 1 ? s(f) : d === 2 ? l(f) : u(f, d);
                        }
                    },
                    5721: function(i) {
                        "use strict";
                        i.exports = a;
                        function a(o) {
                            for(var s = 0, l = 0, u = 1; u < o.length; ++u)o[u][0] < o[s][0] && (s = u), o[u][0] > o[l][0] && (l = u);
                            return s < l ? [
                                [
                                    s
                                ],
                                [
                                    l
                                ]
                            ] : s > l ? [
                                [
                                    l
                                ],
                                [
                                    s
                                ]
                            ] : [
                                [
                                    s
                                ]
                            ];
                        }
                    },
                    4750: function(i, a, o) {
                        "use strict";
                        i.exports = l;
                        var s = o(3090);
                        function l(u) {
                            var c = s(u), f = c.length;
                            if (f <= 2) return [];
                            for(var h = new Array(f), d = c[f - 1], v = 0; v < f; ++v){
                                var x = c[v];
                                h[v] = [
                                    d,
                                    x
                                ], d = x;
                            }
                            return h;
                        }
                    },
                    2690: function(i, a, o) {
                        "use strict";
                        i.exports = f;
                        var s = o(8954), l = o(3952);
                        function u(h, d) {
                            for(var v = h.length, x = new Array(v), b = 0; b < d.length; ++b)x[b] = h[d[b]];
                            for(var p = d.length, b = 0; b < v; ++b)d.indexOf(b) < 0 && (x[p++] = h[b]);
                            return x;
                        }
                        function c(h, d) {
                            for(var v = h.length, x = d.length, b = 0; b < v; ++b)for(var p = h[b], E = 0; E < p.length; ++E){
                                var k = p[E];
                                if (k < x) p[E] = d[k];
                                else {
                                    k = k - x;
                                    for(var A = 0; A < x; ++A)k >= d[A] && (k += 1);
                                    p[E] = k;
                                }
                            }
                            return h;
                        }
                        function f(h, d) {
                            try {
                                return s(h, !0);
                            } catch (p) {
                                var v = l(h);
                                if (v.length <= d) return [];
                                var x = u(h, v), b = s(x, !0);
                                return c(b, v);
                            }
                        }
                    },
                    4769: function(i) {
                        "use strict";
                        function a(s, l, u, c, f, h) {
                            var d = 6 * f * f - 6 * f, v = 3 * f * f - 4 * f + 1, x = -6 * f * f + 6 * f, b = 3 * f * f - 2 * f;
                            if (s.length) {
                                h || (h = new Array(s.length));
                                for(var p = s.length - 1; p >= 0; --p)h[p] = d * s[p] + v * l[p] + x * u[p] + b * c[p];
                                return h;
                            }
                            return d * s + v * l + x * u[p] + b * c;
                        }
                        function o(s, l, u, c, f, h) {
                            var d = f - 1, v = f * f, x = d * d, b = (1 + 2 * f) * x, p = f * x, E = v * (3 - 2 * f), k = v * d;
                            if (s.length) {
                                h || (h = new Array(s.length));
                                for(var A = s.length - 1; A >= 0; --A)h[A] = b * s[A] + p * l[A] + E * u[A] + k * c[A];
                                return h;
                            }
                            return b * s + p * l + E * u + k * c;
                        }
                        i.exports = o, i.exports.derivative = a;
                    },
                    7642: function(i, a, o) {
                        "use strict";
                        var s = o(8954), l = o(1682);
                        i.exports = h;
                        function u(d, v) {
                            this.point = d, this.index = v;
                        }
                        function c(d, v) {
                            for(var x = d.point, b = v.point, p = x.length, E = 0; E < p; ++E){
                                var k = b[E] - x[E];
                                if (k) return k;
                            }
                            return 0;
                        }
                        function f(d, v, x) {
                            if (d === 1) return x ? [
                                [
                                    -1,
                                    0
                                ]
                            ] : [];
                            var b = v.map(function(L, _) {
                                return [
                                    L[0],
                                    _
                                ];
                            });
                            b.sort(function(L, _) {
                                return L[0] - _[0];
                            });
                            for(var p = new Array(d - 1), E = 1; E < d; ++E){
                                var k = b[E - 1], A = b[E];
                                p[E - 1] = [
                                    k[1],
                                    A[1]
                                ];
                            }
                            return x && p.push([
                                -1,
                                p[0][1]
                            ], [
                                p[d - 1][1],
                                -1
                            ]), p;
                        }
                        function h(d, v) {
                            var x = d.length;
                            if (x === 0) return [];
                            var b = d[0].length;
                            if (b < 1) return [];
                            if (b === 1) return f(x, d, v);
                            for(var p = new Array(x), E = 1, k = 0; k < x; ++k){
                                for(var A = d[k], L = new Array(b + 1), _ = 0, C = 0; C < b; ++C){
                                    var M = A[C];
                                    L[C] = M, _ += M * M;
                                }
                                L[b] = _, p[k] = new u(L, k), E = Math.max(_, E);
                            }
                            l(p, c), x = p.length;
                            for(var g = new Array(x + b + 1), P = new Array(x + b + 1), T = (b + 1) * (b + 1) * E, F = new Array(b + 1), k = 0; k <= b; ++k)F[k] = 0;
                            F[b] = T, g[0] = F.slice(), P[0] = -1;
                            for(var k = 0; k <= b; ++k){
                                var L = F.slice();
                                L[k] = 1, g[k + 1] = L, P[k + 1] = -1;
                            }
                            for(var k = 0; k < x; ++k){
                                var q = p[k];
                                g[k + b + 1] = q.point, P[k + b + 1] = q.index;
                            }
                            var V = s(g, !1);
                            if (v ? V = V.filter(function(H) {
                                for(var X = 0, G = 0; G <= b; ++G){
                                    var N = P[H[G]];
                                    if (N < 0 && ++X >= 2) return !1;
                                    H[G] = N;
                                }
                                return !0;
                            }) : V = V.filter(function(H) {
                                for(var X = 0; X <= b; ++X){
                                    var G = P[H[X]];
                                    if (G < 0) return !1;
                                    H[X] = G;
                                }
                                return !0;
                            }), b & 1) for(var k = 0; k < V.length; ++k){
                                var q = V[k], L = q[0];
                                q[0] = q[1], q[1] = L;
                            }
                            return V;
                        }
                    },
                    2361: function(i) {
                        var a = !1;
                        if (typeof Float64Array != "undefined") {
                            var o = new Float64Array(1), s = new Uint32Array(o.buffer);
                            if (o[0] = 1, a = !0, s[1] === 1072693248) {
                                let E = function(L, _) {
                                    return s[0] = L, s[1] = _, o[0];
                                }, k = function(L) {
                                    return o[0] = L, s[0];
                                }, A = function(L) {
                                    return o[0] = L, s[1];
                                };
                                var u = E, c = k, f = A;
                                i.exports = function(_) {
                                    return o[0] = _, [
                                        s[0],
                                        s[1]
                                    ];
                                }, i.exports.pack = E, i.exports.lo = k, i.exports.hi = A;
                            } else if (s[0] === 1072693248) {
                                let E = function(L, _) {
                                    return s[1] = L, s[0] = _, o[0];
                                }, k = function(L) {
                                    return o[0] = L, s[1];
                                }, A = function(L) {
                                    return o[0] = L, s[0];
                                };
                                var h = E, d = k, v = A;
                                i.exports = function(_) {
                                    return o[0] = _, [
                                        s[1],
                                        s[0]
                                    ];
                                }, i.exports.pack = E, i.exports.lo = k, i.exports.hi = A;
                            } else a = !1;
                        }
                        if (!a) {
                            let E = function(L, _) {
                                return l.writeUInt32LE(L, 0, !0), l.writeUInt32LE(_, 4, !0), l.readDoubleLE(0, !0);
                            }, k = function(L) {
                                return l.writeDoubleLE(L, 0, !0), l.readUInt32LE(0, !0);
                            }, A = function(L) {
                                return l.writeDoubleLE(L, 0, !0), l.readUInt32LE(4, !0);
                            };
                            var x = E, b = k, p = A, l = new $a765ec5880d44928$require$Buffer(8);
                            i.exports = function(_) {
                                return l.writeDoubleLE(_, 0, !0), [
                                    l.readUInt32LE(0, !0),
                                    l.readUInt32LE(4, !0)
                                ];
                            }, i.exports.pack = E, i.exports.lo = k, i.exports.hi = A;
                        }
                        i.exports.sign = function(E) {
                            return i.exports.hi(E) >>> 31;
                        }, i.exports.exponent = function(E) {
                            var k = i.exports.hi(E);
                            return (k << 1 >>> 21) - 1023;
                        }, i.exports.fraction = function(E) {
                            var k = i.exports.lo(E), A = i.exports.hi(E), L = A & 1048575;
                            return A & 2146435072 && (L += 1048576), [
                                k,
                                L
                            ];
                        }, i.exports.denormalized = function(E) {
                            var k = i.exports.hi(E);
                            return !(k & 2146435072);
                        };
                    },
                    1338: function(i) {
                        "use strict";
                        function a(l, u, c) {
                            var f = l[c] | 0;
                            if (f <= 0) return [];
                            var h = new Array(f), d;
                            if (c === l.length - 1) for(d = 0; d < f; ++d)h[d] = u;
                            else for(d = 0; d < f; ++d)h[d] = a(l, u, c + 1);
                            return h;
                        }
                        function o(l, u) {
                            var c, f;
                            for(c = new Array(l), f = 0; f < l; ++f)c[f] = u;
                            return c;
                        }
                        function s(l, u) {
                            switch(typeof u == "undefined" && (u = 0), typeof l){
                                case "number":
                                    if (l > 0) return o(l | 0, u);
                                    break;
                                case "object":
                                    if (typeof l.length == "number") return a(l, u, 0);
                                    break;
                            }
                            return [];
                        }
                        i.exports = s;
                    },
                    3134: function(i, a, o) {
                        "use strict";
                        i.exports = l;
                        var s = o(1682);
                        function l(u, c) {
                            var f = u.length;
                            if (typeof c != "number") {
                                c = 0;
                                for(var h = 0; h < f; ++h){
                                    var d = u[h];
                                    c = Math.max(c, d[0], d[1]);
                                }
                                c = (c | 0) + 1;
                            }
                            c = c | 0;
                            for(var v = new Array(c), h = 0; h < c; ++h)v[h] = [];
                            for(var h = 0; h < f; ++h){
                                var d = u[h];
                                v[d[0]].push(d[1]), v[d[1]].push(d[0]);
                            }
                            for(var x = 0; x < c; ++x)s(v[x], function(b, p) {
                                return b - p;
                            });
                            return v;
                        }
                    },
                    5033: function(i) {
                        "use strict";
                        i.exports = a;
                        function a(o, s, l) {
                            var u = s || 0, c = l || 1;
                            return [
                                [
                                    o[12] + o[0],
                                    o[13] + o[1],
                                    o[14] + o[2],
                                    o[15] + o[3]
                                ],
                                [
                                    o[12] - o[0],
                                    o[13] - o[1],
                                    o[14] - o[2],
                                    o[15] - o[3]
                                ],
                                [
                                    o[12] + o[4],
                                    o[13] + o[5],
                                    o[14] + o[6],
                                    o[15] + o[7]
                                ],
                                [
                                    o[12] - o[4],
                                    o[13] - o[5],
                                    o[14] - o[6],
                                    o[15] - o[7]
                                ],
                                [
                                    u * o[12] + o[8],
                                    u * o[13] + o[9],
                                    u * o[14] + o[10],
                                    u * o[15] + o[11]
                                ],
                                [
                                    c * o[12] - o[8],
                                    c * o[13] - o[9],
                                    c * o[14] - o[10],
                                    c * o[15] - o[11]
                                ]
                            ];
                        }
                    },
                    9215: function(i, a, o) {
                        "use strict";
                        i.exports = d;
                        var s = o(4769), l = o(2478);
                        function u(v, x, b) {
                            return Math.min(x, Math.max(v, b));
                        }
                        function c(v, x, b) {
                            this.dimension = v.length, this.bounds = [
                                new Array(this.dimension),
                                new Array(this.dimension)
                            ];
                            for(var p = 0; p < this.dimension; ++p)this.bounds[0][p] = -1 / 0, this.bounds[1][p] = 1 / 0;
                            this._state = v.slice().reverse(), this._velocity = x.slice().reverse(), this._time = [
                                b
                            ], this._scratch = [
                                v.slice(),
                                v.slice(),
                                v.slice(),
                                v.slice(),
                                v.slice()
                            ];
                        }
                        var f = c.prototype;
                        f.flush = function(v) {
                            var x = l.gt(this._time, v) - 1;
                            x <= 0 || (this._time.splice(0, x), this._state.splice(0, x * this.dimension), this._velocity.splice(0, x * this.dimension));
                        }, f.curve = function(v) {
                            var x = this._time, b = x.length, p = l.le(x, v), E = this._scratch[0], k = this._state, A = this._velocity, L = this.dimension, _ = this.bounds;
                            if (p < 0) for(var C = L - 1, M = 0; M < L; ++M, --C)E[M] = k[C];
                            else if (p >= b - 1) for(var C = k.length - 1, g = v - x[b - 1], M = 0; M < L; ++M, --C)E[M] = k[C] + g * A[C];
                            else {
                                for(var C = L * (p + 1) - 1, P = x[p], T = x[p + 1], F = T - P || 1, q = this._scratch[1], V = this._scratch[2], H = this._scratch[3], X = this._scratch[4], G = !0, M = 0; M < L; ++M, --C)q[M] = k[C], H[M] = A[C] * F, V[M] = k[C + L], X[M] = A[C + L] * F, G = G && q[M] === V[M] && H[M] === X[M] && H[M] === 0;
                                if (G) for(var M = 0; M < L; ++M)E[M] = q[M];
                                else s(q, H, V, X, (v - P) / F, E);
                            }
                            for(var N = _[0], W = _[1], M = 0; M < L; ++M)E[M] = u(N[M], W[M], E[M]);
                            return E;
                        }, f.dcurve = function(v) {
                            var x = this._time, b = x.length, p = l.le(x, v), E = this._scratch[0], k = this._state, A = this._velocity, L = this.dimension;
                            if (p >= b - 1) for(var _ = k.length - 1, C = v - x[b - 1], M = 0; M < L; ++M, --_)E[M] = A[_];
                            else {
                                for(var _ = L * (p + 1) - 1, g = x[p], P = x[p + 1], T = P - g || 1, F = this._scratch[1], q = this._scratch[2], V = this._scratch[3], H = this._scratch[4], X = !0, M = 0; M < L; ++M, --_)F[M] = k[_], V[M] = A[_] * T, q[M] = k[_ + L], H[M] = A[_ + L] * T, X = X && F[M] === q[M] && V[M] === H[M] && V[M] === 0;
                                if (X) for(var M = 0; M < L; ++M)E[M] = 0;
                                else {
                                    s.derivative(F, V, q, H, (v - g) / T, E);
                                    for(var M = 0; M < L; ++M)E[M] /= T;
                                }
                            }
                            return E;
                        }, f.lastT = function() {
                            var v = this._time;
                            return v[v.length - 1];
                        }, f.stable = function() {
                            for(var v = this._velocity, x = v.length, b = this.dimension - 1; b >= 0; --b)if (v[--x]) return !1;
                            return !0;
                        }, f.jump = function(v) {
                            var x = this.lastT(), b = this.dimension;
                            if (!(v < x || arguments.length !== b + 1)) {
                                var p = this._state, E = this._velocity, k = p.length - this.dimension, A = this.bounds, L = A[0], _ = A[1];
                                this._time.push(x, v);
                                for(var C = 0; C < 2; ++C)for(var M = 0; M < b; ++M)p.push(p[k++]), E.push(0);
                                this._time.push(v);
                                for(var M = b; M > 0; --M)p.push(u(L[M - 1], _[M - 1], arguments[M])), E.push(0);
                            }
                        }, f.push = function(v) {
                            var x = this.lastT(), b = this.dimension;
                            if (!(v < x || arguments.length !== b + 1)) {
                                var p = this._state, E = this._velocity, k = p.length - this.dimension, A = v - x, L = this.bounds, _ = L[0], C = L[1], M = A > 1e-6 ? 1 / A : 0;
                                this._time.push(v);
                                for(var g = b; g > 0; --g){
                                    var P = u(_[g - 1], C[g - 1], arguments[g]);
                                    p.push(P), E.push((P - p[k++]) * M);
                                }
                            }
                        }, f.set = function(v) {
                            var x = this.dimension;
                            if (!(v < this.lastT() || arguments.length !== x + 1)) {
                                var b = this._state, p = this._velocity, E = this.bounds, k = E[0], A = E[1];
                                this._time.push(v);
                                for(var L = x; L > 0; --L)b.push(u(k[L - 1], A[L - 1], arguments[L])), p.push(0);
                            }
                        }, f.move = function(v) {
                            var x = this.lastT(), b = this.dimension;
                            if (!(v <= x || arguments.length !== b + 1)) {
                                var p = this._state, E = this._velocity, k = p.length - this.dimension, A = this.bounds, L = A[0], _ = A[1], C = v - x, M = C > 1e-6 ? 1 / C : 0;
                                this._time.push(v);
                                for(var g = b; g > 0; --g){
                                    var P = arguments[g];
                                    p.push(u(L[g - 1], _[g - 1], p[k++] + P)), E.push(P * M);
                                }
                            }
                        }, f.idle = function(v) {
                            var x = this.lastT();
                            if (!(v < x)) {
                                var b = this.dimension, p = this._state, E = this._velocity, k = p.length - b, A = this.bounds, L = A[0], _ = A[1], C = v - x;
                                this._time.push(v);
                                for(var M = b - 1; M >= 0; --M)p.push(u(L[M], _[M], p[k] + C * E[k])), E.push(0), k += 1;
                            }
                        };
                        function h(v) {
                            for(var x = new Array(v), b = 0; b < v; ++b)x[b] = 0;
                            return x;
                        }
                        function d(v, x, b) {
                            switch(arguments.length){
                                case 0:
                                    return new c([
                                        0
                                    ], [
                                        0
                                    ], 0);
                                case 1:
                                    if (typeof v == "number") {
                                        var p = h(v);
                                        return new c(p, p, 0);
                                    } else return new c(v, h(v.length), 0);
                                case 2:
                                    if (typeof x == "number") {
                                        var p = h(v.length);
                                        return new c(v, p, +x);
                                    } else b = 0;
                                case 3:
                                    if (v.length !== x.length) throw new Error("state and velocity lengths must match");
                                    return new c(v, x, b);
                            }
                        }
                    },
                    3840: function(i) {
                        "use strict";
                        i.exports = L;
                        var a = 0, o = 1;
                        function s(_, C, M, g, P, T) {
                            this._color = _, this.key = C, this.value = M, this.left = g, this.right = P, this._count = T;
                        }
                        function l(_) {
                            return new s(_._color, _.key, _.value, _.left, _.right, _._count);
                        }
                        function u(_, C) {
                            return new s(_, C.key, C.value, C.left, C.right, C._count);
                        }
                        function c(_) {
                            _._count = 1 + (_.left ? _.left._count : 0) + (_.right ? _.right._count : 0);
                        }
                        function f(_, C) {
                            this._compare = _, this.root = C;
                        }
                        var h = f.prototype;
                        Object.defineProperty(h, "keys", {
                            get: function() {
                                var _ = [];
                                return this.forEach(function(C, M) {
                                    _.push(C);
                                }), _;
                            }
                        }), Object.defineProperty(h, "values", {
                            get: function() {
                                var _ = [];
                                return this.forEach(function(C, M) {
                                    _.push(M);
                                }), _;
                            }
                        }), Object.defineProperty(h, "length", {
                            get: function() {
                                return this.root ? this.root._count : 0;
                            }
                        }), h.insert = function(_, C) {
                            for(var M = this._compare, g = this.root, P = [], T = []; g;){
                                var F = M(_, g.key);
                                P.push(g), T.push(F), F <= 0 ? g = g.left : g = g.right;
                            }
                            P.push(new s(a, _, C, null, null, 1));
                            for(var q = P.length - 2; q >= 0; --q){
                                var g = P[q];
                                T[q] <= 0 ? P[q] = new s(g._color, g.key, g.value, P[q + 1], g.right, g._count + 1) : P[q] = new s(g._color, g.key, g.value, g.left, P[q + 1], g._count + 1);
                            }
                            for(var q = P.length - 1; q > 1; --q){
                                var V = P[q - 1], g = P[q];
                                if (V._color === o || g._color === o) break;
                                var H = P[q - 2];
                                if (H.left === V) {
                                    if (V.left === g) {
                                        var X = H.right;
                                        if (X && X._color === a) V._color = o, H.right = u(o, X), H._color = a, q -= 1;
                                        else {
                                            if (H._color = a, H.left = V.right, V._color = o, V.right = H, P[q - 2] = V, P[q - 1] = g, c(H), c(V), q >= 3) {
                                                var G = P[q - 3];
                                                G.left === H ? G.left = V : G.right = V;
                                            }
                                            break;
                                        }
                                    } else {
                                        var X = H.right;
                                        if (X && X._color === a) V._color = o, H.right = u(o, X), H._color = a, q -= 1;
                                        else {
                                            if (V.right = g.left, H._color = a, H.left = g.right, g._color = o, g.left = V, g.right = H, P[q - 2] = g, P[q - 1] = V, c(H), c(V), c(g), q >= 3) {
                                                var G = P[q - 3];
                                                G.left === H ? G.left = g : G.right = g;
                                            }
                                            break;
                                        }
                                    }
                                } else if (V.right === g) {
                                    var X = H.left;
                                    if (X && X._color === a) V._color = o, H.left = u(o, X), H._color = a, q -= 1;
                                    else {
                                        if (H._color = a, H.right = V.left, V._color = o, V.left = H, P[q - 2] = V, P[q - 1] = g, c(H), c(V), q >= 3) {
                                            var G = P[q - 3];
                                            G.right === H ? G.right = V : G.left = V;
                                        }
                                        break;
                                    }
                                } else {
                                    var X = H.left;
                                    if (X && X._color === a) V._color = o, H.left = u(o, X), H._color = a, q -= 1;
                                    else {
                                        if (V.left = g.right, H._color = a, H.right = g.left, g._color = o, g.right = V, g.left = H, P[q - 2] = g, P[q - 1] = V, c(H), c(V), c(g), q >= 3) {
                                            var G = P[q - 3];
                                            G.right === H ? G.right = g : G.left = g;
                                        }
                                        break;
                                    }
                                }
                            }
                            return P[0]._color = o, new f(M, P[0]);
                        };
                        function d(_, C) {
                            if (C.left) {
                                var M = d(_, C.left);
                                if (M) return M;
                            }
                            var M = _(C.key, C.value);
                            if (M) return M;
                            if (C.right) return d(_, C.right);
                        }
                        function v(_, C, M, g) {
                            var P = C(_, g.key);
                            if (P <= 0) {
                                if (g.left) {
                                    var T = v(_, C, M, g.left);
                                    if (T) return T;
                                }
                                var T = M(g.key, g.value);
                                if (T) return T;
                            }
                            if (g.right) return v(_, C, M, g.right);
                        }
                        function x(_, C, M, g, P) {
                            var T = M(_, P.key), F = M(C, P.key), q;
                            if (T <= 0 && (P.left && (q = x(_, C, M, g, P.left), q) || F > 0 && (q = g(P.key, P.value), q))) return q;
                            if (F > 0 && P.right) return x(_, C, M, g, P.right);
                        }
                        h.forEach = function(C, M, g) {
                            if (this.root) switch(arguments.length){
                                case 1:
                                    return d(C, this.root);
                                case 2:
                                    return v(M, this._compare, C, this.root);
                                case 3:
                                    return this._compare(M, g) >= 0 ? void 0 : x(M, g, this._compare, C, this.root);
                            }
                        }, Object.defineProperty(h, "begin", {
                            get: function() {
                                for(var _ = [], C = this.root; C;)_.push(C), C = C.left;
                                return new b(this, _);
                            }
                        }), Object.defineProperty(h, "end", {
                            get: function() {
                                for(var _ = [], C = this.root; C;)_.push(C), C = C.right;
                                return new b(this, _);
                            }
                        }), h.at = function(_) {
                            if (_ < 0) return new b(this, []);
                            for(var C = this.root, M = [];;){
                                if (M.push(C), C.left) {
                                    if (_ < C.left._count) {
                                        C = C.left;
                                        continue;
                                    }
                                    _ -= C.left._count;
                                }
                                if (!_) return new b(this, M);
                                if (_ -= 1, C.right) {
                                    if (_ >= C.right._count) break;
                                    C = C.right;
                                } else break;
                            }
                            return new b(this, []);
                        }, h.ge = function(_) {
                            for(var C = this._compare, M = this.root, g = [], P = 0; M;){
                                var T = C(_, M.key);
                                g.push(M), T <= 0 && (P = g.length), T <= 0 ? M = M.left : M = M.right;
                            }
                            return g.length = P, new b(this, g);
                        }, h.gt = function(_) {
                            for(var C = this._compare, M = this.root, g = [], P = 0; M;){
                                var T = C(_, M.key);
                                g.push(M), T < 0 && (P = g.length), T < 0 ? M = M.left : M = M.right;
                            }
                            return g.length = P, new b(this, g);
                        }, h.lt = function(_) {
                            for(var C = this._compare, M = this.root, g = [], P = 0; M;){
                                var T = C(_, M.key);
                                g.push(M), T > 0 && (P = g.length), T <= 0 ? M = M.left : M = M.right;
                            }
                            return g.length = P, new b(this, g);
                        }, h.le = function(_) {
                            for(var C = this._compare, M = this.root, g = [], P = 0; M;){
                                var T = C(_, M.key);
                                g.push(M), T >= 0 && (P = g.length), T < 0 ? M = M.left : M = M.right;
                            }
                            return g.length = P, new b(this, g);
                        }, h.find = function(_) {
                            for(var C = this._compare, M = this.root, g = []; M;){
                                var P = C(_, M.key);
                                if (g.push(M), P === 0) return new b(this, g);
                                P <= 0 ? M = M.left : M = M.right;
                            }
                            return new b(this, []);
                        }, h.remove = function(_) {
                            var C = this.find(_);
                            return C ? C.remove() : this;
                        }, h.get = function(_) {
                            for(var C = this._compare, M = this.root; M;){
                                var g = C(_, M.key);
                                if (g === 0) return M.value;
                                g <= 0 ? M = M.left : M = M.right;
                            }
                        };
                        function b(_, C) {
                            this.tree = _, this._stack = C;
                        }
                        var p = b.prototype;
                        Object.defineProperty(p, "valid", {
                            get: function() {
                                return this._stack.length > 0;
                            }
                        }), Object.defineProperty(p, "node", {
                            get: function() {
                                return this._stack.length > 0 ? this._stack[this._stack.length - 1] : null;
                            },
                            enumerable: !0
                        }), p.clone = function() {
                            return new b(this.tree, this._stack.slice());
                        };
                        function E(_, C) {
                            _.key = C.key, _.value = C.value, _.left = C.left, _.right = C.right, _._color = C._color, _._count = C._count;
                        }
                        function k(_) {
                            for(var C, M, g, P, T = _.length - 1; T >= 0; --T){
                                if (C = _[T], T === 0) {
                                    C._color = o;
                                    return;
                                }
                                if (M = _[T - 1], M.left === C) {
                                    if (g = M.right, g.right && g.right._color === a) {
                                        if (g = M.right = l(g), P = g.right = l(g.right), M.right = g.left, g.left = M, g.right = P, g._color = M._color, C._color = o, M._color = o, P._color = o, c(M), c(g), T > 1) {
                                            var F = _[T - 2];
                                            F.left === M ? F.left = g : F.right = g;
                                        }
                                        _[T - 1] = g;
                                        return;
                                    } else if (g.left && g.left._color === a) {
                                        if (g = M.right = l(g), P = g.left = l(g.left), M.right = P.left, g.left = P.right, P.left = M, P.right = g, P._color = M._color, M._color = o, g._color = o, C._color = o, c(M), c(g), c(P), T > 1) {
                                            var F = _[T - 2];
                                            F.left === M ? F.left = P : F.right = P;
                                        }
                                        _[T - 1] = P;
                                        return;
                                    }
                                    if (g._color === o) {
                                        if (M._color === a) {
                                            M._color = o, M.right = u(a, g);
                                            return;
                                        } else {
                                            M.right = u(a, g);
                                            continue;
                                        }
                                    } else {
                                        if (g = l(g), M.right = g.left, g.left = M, g._color = M._color, M._color = a, c(M), c(g), T > 1) {
                                            var F = _[T - 2];
                                            F.left === M ? F.left = g : F.right = g;
                                        }
                                        _[T - 1] = g, _[T] = M, T + 1 < _.length ? _[T + 1] = C : _.push(C), T = T + 2;
                                    }
                                } else {
                                    if (g = M.left, g.left && g.left._color === a) {
                                        if (g = M.left = l(g), P = g.left = l(g.left), M.left = g.right, g.right = M, g.left = P, g._color = M._color, C._color = o, M._color = o, P._color = o, c(M), c(g), T > 1) {
                                            var F = _[T - 2];
                                            F.right === M ? F.right = g : F.left = g;
                                        }
                                        _[T - 1] = g;
                                        return;
                                    } else if (g.right && g.right._color === a) {
                                        if (g = M.left = l(g), P = g.right = l(g.right), M.left = P.right, g.right = P.left, P.right = M, P.left = g, P._color = M._color, M._color = o, g._color = o, C._color = o, c(M), c(g), c(P), T > 1) {
                                            var F = _[T - 2];
                                            F.right === M ? F.right = P : F.left = P;
                                        }
                                        _[T - 1] = P;
                                        return;
                                    }
                                    if (g._color === o) {
                                        if (M._color === a) {
                                            M._color = o, M.left = u(a, g);
                                            return;
                                        } else {
                                            M.left = u(a, g);
                                            continue;
                                        }
                                    } else {
                                        if (g = l(g), M.left = g.right, g.right = M, g._color = M._color, M._color = a, c(M), c(g), T > 1) {
                                            var F = _[T - 2];
                                            F.right === M ? F.right = g : F.left = g;
                                        }
                                        _[T - 1] = g, _[T] = M, T + 1 < _.length ? _[T + 1] = C : _.push(C), T = T + 2;
                                    }
                                }
                            }
                        }
                        p.remove = function() {
                            var _ = this._stack;
                            if (_.length === 0) return this.tree;
                            var C = new Array(_.length), M = _[_.length - 1];
                            C[C.length - 1] = new s(M._color, M.key, M.value, M.left, M.right, M._count);
                            for(var g = _.length - 2; g >= 0; --g){
                                var M = _[g];
                                M.left === _[g + 1] ? C[g] = new s(M._color, M.key, M.value, C[g + 1], M.right, M._count) : C[g] = new s(M._color, M.key, M.value, M.left, C[g + 1], M._count);
                            }
                            if (M = C[C.length - 1], M.left && M.right) {
                                var P = C.length;
                                for(M = M.left; M.right;)C.push(M), M = M.right;
                                var T = C[P - 1];
                                C.push(new s(M._color, T.key, T.value, M.left, M.right, M._count)), C[P - 1].key = M.key, C[P - 1].value = M.value;
                                for(var g = C.length - 2; g >= P; --g)M = C[g], C[g] = new s(M._color, M.key, M.value, M.left, C[g + 1], M._count);
                                C[P - 1].left = C[P];
                            }
                            if (M = C[C.length - 1], M._color === a) {
                                var F = C[C.length - 2];
                                F.left === M ? F.left = null : F.right === M && (F.right = null), C.pop();
                                for(var g = 0; g < C.length; ++g)C[g]._count--;
                                return new f(this.tree._compare, C[0]);
                            } else if (M.left || M.right) {
                                M.left ? E(M, M.left) : M.right && E(M, M.right), M._color = o;
                                for(var g = 0; g < C.length - 1; ++g)C[g]._count--;
                                return new f(this.tree._compare, C[0]);
                            } else {
                                if (C.length === 1) return new f(this.tree._compare, null);
                                for(var g = 0; g < C.length; ++g)C[g]._count--;
                                var q = C[C.length - 2];
                                k(C), q.left === M ? q.left = null : q.right = null;
                            }
                            return new f(this.tree._compare, C[0]);
                        }, Object.defineProperty(p, "key", {
                            get: function() {
                                if (this._stack.length > 0) return this._stack[this._stack.length - 1].key;
                            },
                            enumerable: !0
                        }), Object.defineProperty(p, "value", {
                            get: function() {
                                if (this._stack.length > 0) return this._stack[this._stack.length - 1].value;
                            },
                            enumerable: !0
                        }), Object.defineProperty(p, "index", {
                            get: function() {
                                var _ = 0, C = this._stack;
                                if (C.length === 0) {
                                    var M = this.tree.root;
                                    return M ? M._count : 0;
                                } else C[C.length - 1].left && (_ = C[C.length - 1].left._count);
                                for(var g = C.length - 2; g >= 0; --g)C[g + 1] === C[g].right && (++_, C[g].left && (_ += C[g].left._count));
                                return _;
                            },
                            enumerable: !0
                        }), p.next = function() {
                            var _ = this._stack;
                            if (_.length !== 0) {
                                var C = _[_.length - 1];
                                if (C.right) for(C = C.right; C;)_.push(C), C = C.left;
                                else for(_.pop(); _.length > 0 && _[_.length - 1].right === C;)C = _[_.length - 1], _.pop();
                            }
                        }, Object.defineProperty(p, "hasNext", {
                            get: function() {
                                var _ = this._stack;
                                if (_.length === 0) return !1;
                                if (_[_.length - 1].right) return !0;
                                for(var C = _.length - 1; C > 0; --C)if (_[C - 1].left === _[C]) return !0;
                                return !1;
                            }
                        }), p.update = function(_) {
                            var C = this._stack;
                            if (C.length === 0) throw new Error("Can't update empty node!");
                            var M = new Array(C.length), g = C[C.length - 1];
                            M[M.length - 1] = new s(g._color, g.key, _, g.left, g.right, g._count);
                            for(var P = C.length - 2; P >= 0; --P)g = C[P], g.left === C[P + 1] ? M[P] = new s(g._color, g.key, g.value, M[P + 1], g.right, g._count) : M[P] = new s(g._color, g.key, g.value, g.left, M[P + 1], g._count);
                            return new f(this.tree._compare, M[0]);
                        }, p.prev = function() {
                            var _ = this._stack;
                            if (_.length !== 0) {
                                var C = _[_.length - 1];
                                if (C.left) for(C = C.left; C;)_.push(C), C = C.right;
                                else for(_.pop(); _.length > 0 && _[_.length - 1].left === C;)C = _[_.length - 1], _.pop();
                            }
                        }, Object.defineProperty(p, "hasPrev", {
                            get: function() {
                                var _ = this._stack;
                                if (_.length === 0) return !1;
                                if (_[_.length - 1].left) return !0;
                                for(var C = _.length - 1; C > 0; --C)if (_[C - 1].right === _[C]) return !0;
                                return !1;
                            }
                        });
                        function A(_, C) {
                            return _ < C ? -1 : _ > C ? 1 : 0;
                        }
                        function L(_) {
                            return new f(_ || A, null);
                        }
                    },
                    3837: function(i, a, o) {
                        "use strict";
                        i.exports = q;
                        var s = o(4935), l = o(501), u = o(5304), c = o(6429), f = o(6444), h = new Float32Array([
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ]), d = ArrayBuffer, v = DataView;
                        function x(V) {
                            return d.isView(V) && !(V instanceof v);
                        }
                        function b(V) {
                            return Array.isArray(V) || x(V);
                        }
                        function p(V, H) {
                            return V[0] = H[0], V[1] = H[1], V[2] = H[2], V;
                        }
                        function E(V) {
                            this.gl = V, this.pixelRatio = 1, this.bounds = [
                                [
                                    -10,
                                    -10,
                                    -10
                                ],
                                [
                                    10,
                                    10,
                                    10
                                ]
                            ], this.ticks = [
                                [],
                                [],
                                []
                            ], this.autoTicks = !0, this.tickSpacing = [
                                1,
                                1,
                                1
                            ], this.tickEnable = [
                                !0,
                                !0,
                                !0
                            ], this.tickFont = [
                                "sans-serif",
                                "sans-serif",
                                "sans-serif"
                            ], this.tickFontStyle = [
                                "normal",
                                "normal",
                                "normal"
                            ], this.tickFontWeight = [
                                "normal",
                                "normal",
                                "normal"
                            ], this.tickFontVariant = [
                                "normal",
                                "normal",
                                "normal"
                            ], this.tickSize = [
                                12,
                                12,
                                12
                            ], this.tickAngle = [
                                0,
                                0,
                                0
                            ], this.tickAlign = [
                                "auto",
                                "auto",
                                "auto"
                            ], this.tickColor = [
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ]
                            ], this.tickPad = [
                                10,
                                10,
                                10
                            ], this.lastCubeProps = {
                                cubeEdges: [
                                    0,
                                    0,
                                    0
                                ],
                                axis: [
                                    0,
                                    0,
                                    0
                                ]
                            }, this.labels = [
                                "x",
                                "y",
                                "z"
                            ], this.labelEnable = [
                                !0,
                                !0,
                                !0
                            ], this.labelFont = [
                                "sans-serif",
                                "sans-serif",
                                "sans-serif"
                            ], this.labelFontStyle = [
                                "normal",
                                "normal",
                                "normal"
                            ], this.labelFontWeight = [
                                "normal",
                                "normal",
                                "normal"
                            ], this.labelFontVariant = [
                                "normal",
                                "normal",
                                "normal"
                            ], this.labelSize = [
                                20,
                                20,
                                20
                            ], this.labelAngle = [
                                0,
                                0,
                                0
                            ], this.labelAlign = [
                                "auto",
                                "auto",
                                "auto"
                            ], this.labelColor = [
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ]
                            ], this.labelPad = [
                                10,
                                10,
                                10
                            ], this.lineEnable = [
                                !0,
                                !0,
                                !0
                            ], this.lineMirror = [
                                !1,
                                !1,
                                !1
                            ], this.lineWidth = [
                                1,
                                1,
                                1
                            ], this.lineColor = [
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ]
                            ], this.lineTickEnable = [
                                !0,
                                !0,
                                !0
                            ], this.lineTickMirror = [
                                !1,
                                !1,
                                !1
                            ], this.lineTickLength = [
                                0,
                                0,
                                0
                            ], this.lineTickWidth = [
                                1,
                                1,
                                1
                            ], this.lineTickColor = [
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ]
                            ], this.gridEnable = [
                                !0,
                                !0,
                                !0
                            ], this.gridWidth = [
                                1,
                                1,
                                1
                            ], this.gridColor = [
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ]
                            ], this.zeroEnable = [
                                !0,
                                !0,
                                !0
                            ], this.zeroLineColor = [
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ]
                            ], this.zeroLineWidth = [
                                2,
                                2,
                                2
                            ], this.backgroundEnable = [
                                !1,
                                !1,
                                !1
                            ], this.backgroundColor = [
                                [
                                    .8,
                                    .8,
                                    .8,
                                    .5
                                ],
                                [
                                    .8,
                                    .8,
                                    .8,
                                    .5
                                ],
                                [
                                    .8,
                                    .8,
                                    .8,
                                    .5
                                ]
                            ], this._firstInit = !0, this._text = null, this._lines = null, this._background = u(V);
                        }
                        var k = E.prototype;
                        k.update = function(V) {
                            V = V || {};
                            function H(Ae, ze, Ce) {
                                if (Ce in V) {
                                    var me = V[Ce], Re = this[Ce], ce;
                                    (Ae ? b(me) && b(me[0]) : b(me)) ? this[Ce] = ce = [
                                        ze(me[0]),
                                        ze(me[1]),
                                        ze(me[2])
                                    ] : this[Ce] = ce = [
                                        ze(me),
                                        ze(me),
                                        ze(me)
                                    ];
                                    for(var Ge = 0; Ge < 3; ++Ge)if (ce[Ge] !== Re[Ge]) return !0;
                                }
                                return !1;
                            }
                            var X = H.bind(this, !1, Number), G = H.bind(this, !1, Boolean), N = H.bind(this, !1, String), W = H.bind(this, !0, function(Ae) {
                                if (b(Ae)) {
                                    if (Ae.length === 3) return [
                                        +Ae[0],
                                        +Ae[1],
                                        +Ae[2],
                                        1
                                    ];
                                    if (Ae.length === 4) return [
                                        +Ae[0],
                                        +Ae[1],
                                        +Ae[2],
                                        +Ae[3]
                                    ];
                                }
                                return [
                                    0,
                                    0,
                                    0,
                                    1
                                ];
                            }), re, ae = !1, _e = !1;
                            if ("bounds" in V) for(var Me = V.bounds, ke = 0; ke < 2; ++ke)for(var ge = 0; ge < 3; ++ge)Me[ke][ge] !== this.bounds[ke][ge] && (_e = !0), this.bounds[ke][ge] = Me[ke][ge];
                            if ("ticks" in V) {
                                re = V.ticks, ae = !0, this.autoTicks = !1;
                                for(var ke = 0; ke < 3; ++ke)this.tickSpacing[ke] = 0;
                            } else X("tickSpacing") && (this.autoTicks = !0, _e = !0);
                            if (this._firstInit && ("ticks" in V || "tickSpacing" in V || (this.autoTicks = !0), _e = !0, ae = !0, this._firstInit = !1), _e && this.autoTicks && (re = f.create(this.bounds, this.tickSpacing), ae = !0), ae) {
                                for(var ke = 0; ke < 3; ++ke)re[ke].sort(function(ze, Ce) {
                                    return ze.x - Ce.x;
                                });
                                f.equal(re, this.ticks) ? ae = !1 : this.ticks = re;
                            }
                            G("tickEnable"), N("tickFont") && (ae = !0), N("tickFontStyle") && (ae = !0), N("tickFontWeight") && (ae = !0), N("tickFontVariant") && (ae = !0), X("tickSize"), X("tickAngle"), X("tickPad"), W("tickColor");
                            var ie = N("labels");
                            N("labelFont") && (ie = !0), N("labelFontStyle") && (ie = !0), N("labelFontWeight") && (ie = !0), N("labelFontVariant") && (ie = !0), G("labelEnable"), X("labelSize"), X("labelPad"), W("labelColor"), G("lineEnable"), G("lineMirror"), X("lineWidth"), W("lineColor"), G("lineTickEnable"), G("lineTickMirror"), X("lineTickLength"), X("lineTickWidth"), W("lineTickColor"), G("gridEnable"), X("gridWidth"), W("gridColor"), G("zeroEnable"), W("zeroLineColor"), X("zeroLineWidth"), G("backgroundEnable"), W("backgroundColor");
                            var Te = [
                                {
                                    family: this.labelFont[0],
                                    style: this.labelFontStyle[0],
                                    weight: this.labelFontWeight[0],
                                    variant: this.labelFontVariant[0]
                                },
                                {
                                    family: this.labelFont[1],
                                    style: this.labelFontStyle[1],
                                    weight: this.labelFontWeight[1],
                                    variant: this.labelFontVariant[1]
                                },
                                {
                                    family: this.labelFont[2],
                                    style: this.labelFontStyle[2],
                                    weight: this.labelFontWeight[2],
                                    variant: this.labelFontVariant[2]
                                }
                            ], Ee = [
                                {
                                    family: this.tickFont[0],
                                    style: this.tickFontStyle[0],
                                    weight: this.tickFontWeight[0],
                                    variant: this.tickFontVariant[0]
                                },
                                {
                                    family: this.tickFont[1],
                                    style: this.tickFontStyle[1],
                                    weight: this.tickFontWeight[1],
                                    variant: this.tickFontVariant[1]
                                },
                                {
                                    family: this.tickFont[2],
                                    style: this.tickFontStyle[2],
                                    weight: this.tickFontWeight[2],
                                    variant: this.tickFontVariant[2]
                                }
                            ];
                            this._text ? this._text && (ie || ae) && this._text.update(this.bounds, this.labels, Te, this.ticks, Ee) : this._text = s(this.gl, this.bounds, this.labels, Te, this.ticks, Ee), this._lines && ae && (this._lines.dispose(), this._lines = null), this._lines || (this._lines = l(this.gl, this.bounds, this.ticks));
                        };
                        function A() {
                            this.primalOffset = [
                                0,
                                0,
                                0
                            ], this.primalMinor = [
                                0,
                                0,
                                0
                            ], this.mirrorOffset = [
                                0,
                                0,
                                0
                            ], this.mirrorMinor = [
                                0,
                                0,
                                0
                            ];
                        }
                        var L = [
                            new A,
                            new A,
                            new A
                        ];
                        function _(V, H, X, G, N) {
                            for(var W = V.primalOffset, re = V.primalMinor, ae = V.mirrorOffset, _e = V.mirrorMinor, Me = G[H], ke = 0; ke < 3; ++ke)if (H !== ke) {
                                var ge = W, ie = ae, Te = re, Ee = _e;
                                Me & 1 << ke && (ge = ae, ie = W, Te = _e, Ee = re), ge[ke] = X[0][ke], ie[ke] = X[1][ke], N[ke] > 0 ? (Te[ke] = -1, Ee[ke] = 0) : (Te[ke] = 0, Ee[ke] = 1);
                            }
                        }
                        var C = [
                            0,
                            0,
                            0
                        ], M = {
                            model: h,
                            view: h,
                            projection: h,
                            _ortho: !1
                        };
                        k.isOpaque = function() {
                            return !0;
                        }, k.isTransparent = function() {
                            return !1;
                        }, k.drawTransparent = function(V) {};
                        var g = 0, P = [
                            0,
                            0,
                            0
                        ], T = [
                            0,
                            0,
                            0
                        ], F = [
                            0,
                            0,
                            0
                        ];
                        k.draw = function(V) {
                            V = V || M;
                            for(var Ce = this.gl, H = V.model || h, X = V.view || h, G = V.projection || h, N = this.bounds, W = V._ortho || !1, re = c(H, X, G, N, W), ae = re.cubeEdges, _e = re.axis, Me = X[12], ke = X[13], ge = X[14], ie = X[15], Te = W ? 2 : 1, Ee = Te * this.pixelRatio * (G[3] * Me + G[7] * ke + G[11] * ge + G[15] * ie) / Ce.drawingBufferHeight, Ae = 0; Ae < 3; ++Ae)this.lastCubeProps.cubeEdges[Ae] = ae[Ae], this.lastCubeProps.axis[Ae] = _e[Ae];
                            for(var ze = L, Ae = 0; Ae < 3; ++Ae)_(L[Ae], Ae, this.bounds, ae, _e);
                            for(var Ce = this.gl, me = C, Ae = 0; Ae < 3; ++Ae)this.backgroundEnable[Ae] ? me[Ae] = _e[Ae] : me[Ae] = 0;
                            this._background.draw(H, X, G, N, me, this.backgroundColor), this._lines.bind(H, X, G, this);
                            for(var Ae = 0; Ae < 3; ++Ae){
                                var Re = [
                                    0,
                                    0,
                                    0
                                ];
                                _e[Ae] > 0 ? Re[Ae] = N[1][Ae] : Re[Ae] = N[0][Ae];
                                for(var ce = 0; ce < 2; ++ce){
                                    var Ge = (Ae + 1 + ce) % 3, nt = (Ae + 1 + (ce ^ 1)) % 3;
                                    this.gridEnable[Ge] && this._lines.drawGrid(Ge, nt, this.bounds, Re, this.gridColor[Ge], this.gridWidth[Ge] * this.pixelRatio);
                                }
                                for(var ce = 0; ce < 2; ++ce){
                                    var Ge = (Ae + 1 + ce) % 3, nt = (Ae + 1 + (ce ^ 1)) % 3;
                                    this.zeroEnable[nt] && Math.min(N[0][nt], N[1][nt]) <= 0 && Math.max(N[0][nt], N[1][nt]) >= 0 && this._lines.drawZero(Ge, nt, this.bounds, Re, this.zeroLineColor[nt], this.zeroLineWidth[nt] * this.pixelRatio);
                                }
                            }
                            for(var Ae = 0; Ae < 3; ++Ae){
                                this.lineEnable[Ae] && this._lines.drawAxisLine(Ae, this.bounds, ze[Ae].primalOffset, this.lineColor[Ae], this.lineWidth[Ae] * this.pixelRatio), this.lineMirror[Ae] && this._lines.drawAxisLine(Ae, this.bounds, ze[Ae].mirrorOffset, this.lineColor[Ae], this.lineWidth[Ae] * this.pixelRatio);
                                for(var ct = p(P, ze[Ae].primalMinor), qt = p(T, ze[Ae].mirrorMinor), rt = this.lineTickLength, ce = 0; ce < 3; ++ce){
                                    var ot = Ee / H[5 * ce];
                                    ct[ce] *= rt[ce] * ot, qt[ce] *= rt[ce] * ot;
                                }
                                this.lineTickEnable[Ae] && this._lines.drawAxisTicks(Ae, ze[Ae].primalOffset, ct, this.lineTickColor[Ae], this.lineTickWidth[Ae] * this.pixelRatio), this.lineTickMirror[Ae] && this._lines.drawAxisTicks(Ae, ze[Ae].mirrorOffset, qt, this.lineTickColor[Ae], this.lineTickWidth[Ae] * this.pixelRatio);
                            }
                            this._lines.unbind(), this._text.bind(H, X, G, this.pixelRatio);
                            var Rt, kt = .5, Ct, Yt;
                            function xr(St) {
                                Yt = [
                                    0,
                                    0,
                                    0
                                ], Yt[St] = 1;
                            }
                            function er(St, Et, dt) {
                                var Ht = (St + 1) % 3, $t = (St + 2) % 3, fr = Et[Ht], _r = Et[$t], Br = dt[Ht], Or = dt[$t];
                                if (fr > 0 && Or > 0) {
                                    xr(Ht);
                                    return;
                                } else if (fr > 0 && Or < 0) {
                                    xr(Ht);
                                    return;
                                } else if (fr < 0 && Or > 0) {
                                    xr(Ht);
                                    return;
                                } else if (fr < 0 && Or < 0) {
                                    xr(Ht);
                                    return;
                                } else if (_r > 0 && Br > 0) {
                                    xr($t);
                                    return;
                                } else if (_r > 0 && Br < 0) {
                                    xr($t);
                                    return;
                                } else if (_r < 0 && Br > 0) {
                                    xr($t);
                                    return;
                                } else if (_r < 0 && Br < 0) {
                                    xr($t);
                                    return;
                                }
                            }
                            for(var Ae = 0; Ae < 3; ++Ae){
                                for(var Ke = ze[Ae].primalMinor, xt = ze[Ae].mirrorMinor, bt = p(F, ze[Ae].primalOffset), ce = 0; ce < 3; ++ce)this.lineTickEnable[Ae] && (bt[ce] += Ee * Ke[ce] * Math.max(this.lineTickLength[ce], 0) / H[5 * ce]);
                                var Lt = [
                                    0,
                                    0,
                                    0
                                ];
                                if (Lt[Ae] = 1, this.tickEnable[Ae]) {
                                    this.tickAngle[Ae] === -3600 ? (this.tickAngle[Ae] = 0, this.tickAlign[Ae] = "auto") : this.tickAlign[Ae] = -1, Ct = 1, Rt = [
                                        this.tickAlign[Ae],
                                        kt,
                                        Ct
                                    ], Rt[0] === "auto" ? Rt[0] = g : Rt[0] = parseInt("" + Rt[0]), Yt = [
                                        0,
                                        0,
                                        0
                                    ], er(Ae, Ke, xt);
                                    for(var ce = 0; ce < 3; ++ce)bt[ce] += Ee * Ke[ce] * this.tickPad[ce] / H[5 * ce];
                                    this._text.drawTicks(Ae, this.tickSize[Ae], this.tickAngle[Ae], bt, this.tickColor[Ae], Lt, Yt, Rt);
                                }
                                if (this.labelEnable[Ae]) {
                                    Ct = 0, Yt = [
                                        0,
                                        0,
                                        0
                                    ], this.labels[Ae].length > 4 && (xr(Ae), Ct = 1), Rt = [
                                        this.labelAlign[Ae],
                                        kt,
                                        Ct
                                    ], Rt[0] === "auto" ? Rt[0] = g : Rt[0] = parseInt("" + Rt[0]);
                                    for(var ce = 0; ce < 3; ++ce)bt[ce] += Ee * Ke[ce] * this.labelPad[ce] / H[5 * ce];
                                    bt[Ae] += .5 * (N[0][Ae] + N[1][Ae]), this._text.drawLabel(Ae, this.labelSize[Ae], this.labelAngle[Ae], bt, this.labelColor[Ae], [
                                        0,
                                        0,
                                        0
                                    ], Yt, Rt);
                                }
                            }
                            this._text.unbind();
                        }, k.dispose = function() {
                            this._text.dispose(), this._lines.dispose(), this._background.dispose(), this._lines = null, this._text = null, this._background = null, this.gl = null;
                        };
                        function q(V, H) {
                            var X = new E(V);
                            return X.update(H), X;
                        }
                    },
                    5304: function(i, a, o) {
                        "use strict";
                        i.exports = h;
                        var s = o(2762), l = o(8116), u = o(1879).bg;
                        function c(d, v, x, b) {
                            this.gl = d, this.buffer = v, this.vao = x, this.shader = b;
                        }
                        var f = c.prototype;
                        f.draw = function(d, v, x, b, p, E) {
                            for(var k = !1, A = 0; A < 3; ++A)k = k || p[A];
                            if (k) {
                                var L = this.gl;
                                L.enable(L.POLYGON_OFFSET_FILL), L.polygonOffset(1, 2), this.shader.bind(), this.shader.uniforms = {
                                    model: d,
                                    view: v,
                                    projection: x,
                                    bounds: b,
                                    enable: p,
                                    colors: E
                                }, this.vao.bind(), this.vao.draw(this.gl.TRIANGLES, 36), this.vao.unbind(), L.disable(L.POLYGON_OFFSET_FILL);
                            }
                        }, f.dispose = function() {
                            this.vao.dispose(), this.buffer.dispose(), this.shader.dispose();
                        };
                        function h(d) {
                            for(var v = [], x = [], b = 0, p = 0; p < 3; ++p)for(var E = (p + 1) % 3, k = (p + 2) % 3, A = [
                                0,
                                0,
                                0
                            ], L = [
                                0,
                                0,
                                0
                            ], _ = -1; _ <= 1; _ += 2){
                                x.push(b, b + 2, b + 1, b + 1, b + 2, b + 3), A[p] = _, L[p] = _;
                                for(var C = -1; C <= 1; C += 2){
                                    A[E] = C;
                                    for(var M = -1; M <= 1; M += 2)A[k] = M, v.push(A[0], A[1], A[2], L[0], L[1], L[2]), b += 1;
                                }
                                var g = E;
                                E = k, k = g;
                            }
                            var P = s(d, new Float32Array(v)), T = s(d, new Uint16Array(x), d.ELEMENT_ARRAY_BUFFER), F = l(d, [
                                {
                                    buffer: P,
                                    type: d.FLOAT,
                                    size: 3,
                                    offset: 0,
                                    stride: 24
                                },
                                {
                                    buffer: P,
                                    type: d.FLOAT,
                                    size: 3,
                                    offset: 12,
                                    stride: 24
                                }
                            ], T), q = u(d);
                            return q.attributes.position.location = 0, q.attributes.normal.location = 1, new c(d, P, F, q);
                        }
                    },
                    6429: function(i, a, o) {
                        "use strict";
                        i.exports = _;
                        var s = o(8828), l = o(6760), u = o(5202), c = o(3250), f = new Array(16), h = new Array(8), d = new Array(8), v = new Array(3), x = [
                            0,
                            0,
                            0
                        ];
                        (function() {
                            for(var C = 0; C < 8; ++C)h[C] = [
                                1,
                                1,
                                1,
                                1
                            ], d[C] = [
                                1,
                                1,
                                1
                            ];
                        })();
                        function b(C, M, g) {
                            for(var P = 0; P < 4; ++P){
                                C[P] = g[12 + P];
                                for(var T = 0; T < 3; ++T)C[P] += M[T] * g[4 * T + P];
                            }
                        }
                        var p = [
                            [
                                0,
                                0,
                                1,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                -1,
                                1,
                                0
                            ],
                            [
                                0,
                                -1,
                                0,
                                1,
                                0
                            ],
                            [
                                0,
                                1,
                                0,
                                1,
                                0
                            ],
                            [
                                -1,
                                0,
                                0,
                                1,
                                0
                            ],
                            [
                                1,
                                0,
                                0,
                                1,
                                0
                            ]
                        ];
                        function E(C) {
                            for(var M = 0; M < p.length; ++M)if (C = u.positive(C, p[M]), C.length < 3) return 0;
                            for(var g = C[0], P = g[0] / g[3], T = g[1] / g[3], F = 0, M = 1; M + 1 < C.length; ++M){
                                var q = C[M], V = C[M + 1], H = q[0] / q[3], X = q[1] / q[3], G = V[0] / V[3], N = V[1] / V[3], W = H - P, re = X - T, ae = G - P, _e = N - T;
                                F += Math.abs(W * _e - re * ae);
                            }
                            return F;
                        }
                        var k = [
                            1,
                            1,
                            1
                        ], A = [
                            0,
                            0,
                            0
                        ], L = {
                            cubeEdges: k,
                            axis: A
                        };
                        function _(C, M, g, P, T) {
                            l(f, M, C), l(f, g, f);
                            for(var F = 0, q = 0; q < 2; ++q){
                                v[2] = P[q][2];
                                for(var V = 0; V < 2; ++V){
                                    v[1] = P[V][1];
                                    for(var H = 0; H < 2; ++H)v[0] = P[H][0], b(h[F], v, f), F += 1;
                                }
                            }
                            for(var X = -1, q = 0; q < 8; ++q){
                                for(var G = h[q][3], N = 0; N < 3; ++N)d[q][N] = h[q][N] / G;
                                T && (d[q][2] *= -1), G < 0 && (X < 0 || d[q][2] < d[X][2]) && (X = q);
                            }
                            if (X < 0) {
                                X = 0;
                                for(var W = 0; W < 3; ++W){
                                    for(var re = (W + 2) % 3, ae = (W + 1) % 3, _e = -1, Me = -1, ke = 0; ke < 2; ++ke){
                                        var ge = ke << W, ie = ge + (ke << re) + (1 - ke << ae), Te = ge + (1 - ke << re) + (ke << ae);
                                        c(d[ge], d[ie], d[Te], x) < 0 || (ke ? _e = 1 : Me = 1);
                                    }
                                    if (_e < 0 || Me < 0) {
                                        Me > _e && (X |= 1 << W);
                                        continue;
                                    }
                                    for(var ke = 0; ke < 2; ++ke){
                                        var ge = ke << W, ie = ge + (ke << re) + (1 - ke << ae), Te = ge + (1 - ke << re) + (ke << ae), Ee = E([
                                            h[ge],
                                            h[ie],
                                            h[Te],
                                            h[ge + (1 << re) + (1 << ae)]
                                        ]);
                                        ke ? _e = Ee : Me = Ee;
                                    }
                                    if (Me > _e) {
                                        X |= 1 << W;
                                        continue;
                                    }
                                }
                            }
                            for(var Ae = 7 ^ X, ze = -1, q = 0; q < 8; ++q)q === X || q === Ae || (ze < 0 || d[ze][1] > d[q][1]) && (ze = q);
                            for(var Ce = -1, q = 0; q < 3; ++q){
                                var me = ze ^ 1 << q;
                                if (!(me === X || me === Ae)) {
                                    Ce < 0 && (Ce = me);
                                    var ae = d[me];
                                    ae[0] < d[Ce][0] && (Ce = me);
                                }
                            }
                            for(var Re = -1, q = 0; q < 3; ++q){
                                var me = ze ^ 1 << q;
                                if (!(me === X || me === Ae || me === Ce)) {
                                    Re < 0 && (Re = me);
                                    var ae = d[me];
                                    ae[0] > d[Re][0] && (Re = me);
                                }
                            }
                            var ce = k;
                            ce[0] = ce[1] = ce[2] = 0, ce[s.log2(Ce ^ ze)] = ze & Ce, ce[s.log2(ze ^ Re)] = ze & Re;
                            var Ge = Re ^ 7;
                            Ge === X || Ge === Ae ? (Ge = Ce ^ 7, ce[s.log2(Re ^ Ge)] = Ge & Re) : ce[s.log2(Ce ^ Ge)] = Ge & Ce;
                            for(var nt = A, ct = X, W = 0; W < 3; ++W)ct & 1 << W ? nt[W] = -1 : nt[W] = 1;
                            return L;
                        }
                    },
                    501: function(i, a, o) {
                        "use strict";
                        i.exports = k;
                        var s = o(2762), l = o(8116), u = o(1879).n, c = [
                            0,
                            0,
                            0
                        ], f = [
                            0,
                            0,
                            0
                        ], h = [
                            0,
                            0,
                            0
                        ], d = [
                            0,
                            0,
                            0
                        ], v = [
                            1,
                            1
                        ];
                        function x(A) {
                            return A[0] = A[1] = A[2] = 0, A;
                        }
                        function b(A, L) {
                            return A[0] = L[0], A[1] = L[1], A[2] = L[2], A;
                        }
                        function p(A, L, _, C, M, g, P, T) {
                            this.gl = A, this.vertBuffer = L, this.vao = _, this.shader = C, this.tickCount = M, this.tickOffset = g, this.gridCount = P, this.gridOffset = T;
                        }
                        var E = p.prototype;
                        E.bind = function(A, L, _) {
                            this.shader.bind(), this.shader.uniforms.model = A, this.shader.uniforms.view = L, this.shader.uniforms.projection = _, v[0] = this.gl.drawingBufferWidth, v[1] = this.gl.drawingBufferHeight, this.shader.uniforms.screenShape = v, this.vao.bind();
                        }, E.unbind = function() {
                            this.vao.unbind();
                        }, E.drawAxisLine = function(A, L, _, C, M) {
                            var g = x(f);
                            this.shader.uniforms.majorAxis = f, g[A] = L[1][A] - L[0][A], this.shader.uniforms.minorAxis = g;
                            var P = b(d, _);
                            P[A] += L[0][A], this.shader.uniforms.offset = P, this.shader.uniforms.lineWidth = M, this.shader.uniforms.color = C;
                            var T = x(h);
                            T[(A + 2) % 3] = 1, this.shader.uniforms.screenAxis = T, this.vao.draw(this.gl.TRIANGLES, 6);
                            var T = x(h);
                            T[(A + 1) % 3] = 1, this.shader.uniforms.screenAxis = T, this.vao.draw(this.gl.TRIANGLES, 6);
                        }, E.drawAxisTicks = function(A, L, _, C, M) {
                            if (this.tickCount[A]) {
                                var g = x(c);
                                g[A] = 1, this.shader.uniforms.majorAxis = g, this.shader.uniforms.offset = L, this.shader.uniforms.minorAxis = _, this.shader.uniforms.color = C, this.shader.uniforms.lineWidth = M;
                                var P = x(h);
                                P[A] = 1, this.shader.uniforms.screenAxis = P, this.vao.draw(this.gl.TRIANGLES, this.tickCount[A], this.tickOffset[A]);
                            }
                        }, E.drawGrid = function(A, L, _, C, M, g) {
                            if (this.gridCount[A]) {
                                var P = x(f);
                                P[L] = _[1][L] - _[0][L], this.shader.uniforms.minorAxis = P;
                                var T = b(d, C);
                                T[L] += _[0][L], this.shader.uniforms.offset = T;
                                var F = x(c);
                                F[A] = 1, this.shader.uniforms.majorAxis = F;
                                var q = x(h);
                                q[A] = 1, this.shader.uniforms.screenAxis = q, this.shader.uniforms.lineWidth = g, this.shader.uniforms.color = M, this.vao.draw(this.gl.TRIANGLES, this.gridCount[A], this.gridOffset[A]);
                            }
                        }, E.drawZero = function(A, L, _, C, M, g) {
                            var P = x(f);
                            this.shader.uniforms.majorAxis = P, P[A] = _[1][A] - _[0][A], this.shader.uniforms.minorAxis = P;
                            var T = b(d, C);
                            T[A] += _[0][A], this.shader.uniforms.offset = T;
                            var F = x(h);
                            F[L] = 1, this.shader.uniforms.screenAxis = F, this.shader.uniforms.lineWidth = g, this.shader.uniforms.color = M, this.vao.draw(this.gl.TRIANGLES, 6);
                        }, E.dispose = function() {
                            this.vao.dispose(), this.vertBuffer.dispose(), this.shader.dispose();
                        };
                        function k(A, L, _) {
                            var C = [], M = [
                                0,
                                0,
                                0
                            ], g = [
                                0,
                                0,
                                0
                            ], P = [
                                0,
                                0,
                                0
                            ], T = [
                                0,
                                0,
                                0
                            ];
                            C.push(0, 0, 1, 0, 1, 1, 0, 0, -1, 0, 0, -1, 0, 1, 1, 0, 1, -1);
                            for(var F = 0; F < 3; ++F){
                                for(var H = C.length / 3 | 0, q = 0; q < _[F].length; ++q){
                                    var V = +_[F][q].x;
                                    C.push(V, 0, 1, V, 1, 1, V, 0, -1, V, 0, -1, V, 1, 1, V, 1, -1);
                                }
                                var G = C.length / 3 | 0;
                                M[F] = H, g[F] = G - H;
                                for(var H = C.length / 3 | 0, X = 0; X < _[F].length; ++X){
                                    var V = +_[F][X].x;
                                    C.push(V, 0, 1, V, 1, 1, V, 0, -1, V, 0, -1, V, 1, 1, V, 1, -1);
                                }
                                var G = C.length / 3 | 0;
                                P[F] = H, T[F] = G - H;
                            }
                            var N = s(A, new Float32Array(C)), W = l(A, [
                                {
                                    buffer: N,
                                    type: A.FLOAT,
                                    size: 3,
                                    stride: 0,
                                    offset: 0
                                }
                            ]), re = u(A);
                            return re.attributes.position.location = 0, new p(A, N, W, re, g, M, T, P);
                        }
                    },
                    1879: function(i, a, o) {
                        "use strict";
                        var s = o(3236), l = o(9405), u = s([
                            `precision highp float;
#define GLSLIFY 1

attribute vec3 position;

uniform mat4 model, view, projection;
uniform vec3 offset, majorAxis, minorAxis, screenAxis;
uniform float lineWidth;
uniform vec2 screenShape;

vec3 project(vec3 p) {
  vec4 pp = projection * (view * (model * vec4(p, 1.0)));
  return pp.xyz / max(pp.w, 0.0001);
}

void main() {
  vec3 major = position.x * majorAxis;
  vec3 minor = position.y * minorAxis;

  vec3 vPosition = major + minor + offset;
  vec3 pPosition = project(vPosition);
  vec3 offset = project(vPosition + screenAxis * position.z);

  vec2 screen = normalize((offset - pPosition).xy * screenShape) / screenShape;

  gl_Position = vec4(pPosition + vec3(0.5 * screen * lineWidth, 0), 1.0);
}
`
                        ]), c = s([
                            `precision highp float;
#define GLSLIFY 1

uniform vec4 color;
void main() {
  gl_FragColor = color;
}`
                        ]);
                        a.n = function(x) {
                            return l(x, u, c, null, [
                                {
                                    name: "position",
                                    type: "vec3"
                                }
                            ]);
                        };
                        var f = s([
                            `precision highp float;
#define GLSLIFY 1

attribute vec3 position;

uniform mat4 model, view, projection;
uniform vec3 offset, axis, alignDir, alignOpt;
uniform float scale, angle, pixelScale;
uniform vec2 resolution;

vec3 project(vec3 p) {
  vec4 pp = projection * (view * (model * vec4(p, 1.0)));
  return pp.xyz / max(pp.w, 0.0001);
}

float computeViewAngle(vec3 a, vec3 b) {
  vec3 A = project(a);
  vec3 B = project(b);

  return atan(
    (B.y - A.y) * resolution.y,
    (B.x - A.x) * resolution.x
  );
}

const float PI = 3.141592;
const float TWO_PI = 2.0 * PI;
const float HALF_PI = 0.5 * PI;
const float ONE_AND_HALF_PI = 1.5 * PI;

int option = int(floor(alignOpt.x + 0.001));
float hv_ratio =       alignOpt.y;
bool enableAlign =    (alignOpt.z != 0.0);

float mod_angle(float a) {
  return mod(a, PI);
}

float positive_angle(float a) {
  return mod_angle((a < 0.0) ?
    a + TWO_PI :
    a
  );
}

float look_upwards(float a) {
  float b = positive_angle(a);
  return ((b > HALF_PI) && (b <= ONE_AND_HALF_PI)) ?
    b - PI :
    b;
}

float look_horizontal_or_vertical(float a, float ratio) {
  // ratio controls the ratio between being horizontal to (vertical + horizontal)
  // if ratio is set to 0.5 then it is 50%, 50%.
  // when using a higher ratio e.g. 0.75 the result would
  // likely be more horizontal than vertical.

  float b = positive_angle(a);

  return
    (b < (      ratio) * HALF_PI) ? 0.0 :
    (b < (2.0 - ratio) * HALF_PI) ? -HALF_PI :
    (b < (2.0 + ratio) * HALF_PI) ? 0.0 :
    (b < (4.0 - ratio) * HALF_PI) ? HALF_PI :
                                    0.0;
}

float roundTo(float a, float b) {
  return float(b * floor((a + 0.5 * b) / b));
}

float look_round_n_directions(float a, int n) {
  float b = positive_angle(a);
  float div = TWO_PI / float(n);
  float c = roundTo(b, div);
  return look_upwards(c);
}

float applyAlignOption(float rawAngle, float delta) {
  return
    (option >  2) ? look_round_n_directions(rawAngle + delta, option) :       // option 3-n: round to n directions
    (option == 2) ? look_horizontal_or_vertical(rawAngle + delta, hv_ratio) : // horizontal or vertical
    (option == 1) ? rawAngle + delta :       // use free angle, and flip to align with one direction of the axis
    (option == 0) ? look_upwards(rawAngle) : // use free angle, and stay upwards
    (option ==-1) ? 0.0 :                    // useful for backward compatibility, all texts remains horizontal
                    rawAngle;                // otherwise return back raw input angle
}

bool isAxisTitle = (axis.x == 0.0) &&
                   (axis.y == 0.0) &&
                   (axis.z == 0.0);

void main() {
  //Compute world offset
  float axisDistance = position.z;
  vec3 dataPosition = axisDistance * axis + offset;

  float beta = angle; // i.e. user defined attributes for each tick

  float axisAngle;
  float clipAngle;
  float flip;

  if (enableAlign) {
    axisAngle = (isAxisTitle) ? HALF_PI :
                      computeViewAngle(dataPosition, dataPosition + axis);
    clipAngle = computeViewAngle(dataPosition, dataPosition + alignDir);

    axisAngle += (sin(axisAngle) < 0.0) ? PI : 0.0;
    clipAngle += (sin(clipAngle) < 0.0) ? PI : 0.0;

    flip = (dot(vec2(cos(axisAngle), sin(axisAngle)),
                vec2(sin(clipAngle),-cos(clipAngle))) > 0.0) ? 1.0 : 0.0;

    beta += applyAlignOption(clipAngle, flip * PI);
  }

  //Compute plane offset
  vec2 planeCoord = position.xy * pixelScale;

  mat2 planeXform = scale * mat2(
     cos(beta), sin(beta),
    -sin(beta), cos(beta)
  );

  vec2 viewOffset = 2.0 * planeXform * planeCoord / resolution;

  //Compute clip position
  vec3 clipPosition = project(dataPosition);

  //Apply text offset in clip coordinates
  clipPosition += vec3(viewOffset, 0.0);

  //Done
  gl_Position = vec4(clipPosition, 1.0);
}
`
                        ]), h = s([
                            `precision highp float;
#define GLSLIFY 1

uniform vec4 color;
void main() {
  gl_FragColor = color;
}`
                        ]);
                        a.Q = function(x) {
                            return l(x, f, h, null, [
                                {
                                    name: "position",
                                    type: "vec3"
                                }
                            ]);
                        };
                        var d = s([
                            `precision highp float;
#define GLSLIFY 1

attribute vec3 position;
attribute vec3 normal;

uniform mat4 model, view, projection;
uniform vec3 enable;
uniform vec3 bounds[2];

varying vec3 colorChannel;

void main() {

  vec3 signAxis = sign(bounds[1] - bounds[0]);

  vec3 realNormal = signAxis * normal;

  if(dot(realNormal, enable) > 0.0) {
    vec3 minRange = min(bounds[0], bounds[1]);
    vec3 maxRange = max(bounds[0], bounds[1]);
    vec3 nPosition = mix(minRange, maxRange, 0.5 * (position + 1.0));
    gl_Position = projection * (view * (model * vec4(nPosition, 1.0)));
  } else {
    gl_Position = vec4(0,0,0,0);
  }

  colorChannel = abs(realNormal);
}
`
                        ]), v = s([
                            `precision highp float;
#define GLSLIFY 1

uniform vec4 colors[3];

varying vec3 colorChannel;

void main() {
  gl_FragColor = colorChannel.x * colors[0] +
                 colorChannel.y * colors[1] +
                 colorChannel.z * colors[2];
}`
                        ]);
                        a.bg = function(x) {
                            return l(x, d, v, null, [
                                {
                                    name: "position",
                                    type: "vec3"
                                },
                                {
                                    name: "normal",
                                    type: "vec3"
                                }
                            ]);
                        };
                    },
                    4935: function(i, a, o) {
                        "use strict";
                        i.exports = E;
                        var s = o(2762), l = o(8116), u = o(4359), c = o(1879).Q, f = window || $d3c1734dacb01657$exports.global || {}, h = f.__TEXT_CACHE || {};
                        f.__TEXT_CACHE = {};
                        var d = 3;
                        function v(k, A, L, _) {
                            this.gl = k, this.shader = A, this.buffer = L, this.vao = _, this.tickOffset = this.tickCount = this.labelOffset = this.labelCount = null;
                        }
                        var x = v.prototype, b = [
                            0,
                            0
                        ];
                        x.bind = function(k, A, L, _) {
                            this.vao.bind(), this.shader.bind();
                            var C = this.shader.uniforms;
                            C.model = k, C.view = A, C.projection = L, C.pixelScale = _, b[0] = this.gl.drawingBufferWidth, b[1] = this.gl.drawingBufferHeight, this.shader.uniforms.resolution = b;
                        }, x.unbind = function() {
                            this.vao.unbind();
                        }, x.update = function(k, A, L, _, C) {
                            var M = [];
                            function g(W, re, ae, _e, Me, ke) {
                                var ge = [
                                    ae.style,
                                    ae.weight,
                                    ae.variant,
                                    ae.family
                                ].join("_"), ie = h[ge];
                                ie || (ie = h[ge] = {});
                                var Te = ie[re];
                                Te || (Te = ie[re] = p(re, {
                                    triangles: !0,
                                    font: ae.family,
                                    fontStyle: ae.style,
                                    fontWeight: ae.weight,
                                    fontVariant: ae.variant,
                                    textAlign: "center",
                                    textBaseline: "middle",
                                    lineSpacing: Me,
                                    styletags: ke
                                }));
                                for(var Ee = (_e || 12) / 12, Ae = Te.positions, ze = Te.cells, Ce = 0, me = ze.length; Ce < me; ++Ce)for(var Re = ze[Ce], ce = 2; ce >= 0; --ce){
                                    var Ge = Ae[Re[ce]];
                                    M.push(Ee * Ge[0], -Ee * Ge[1], W);
                                }
                            }
                            for(var P = [
                                0,
                                0,
                                0
                            ], T = [
                                0,
                                0,
                                0
                            ], F = [
                                0,
                                0,
                                0
                            ], q = [
                                0,
                                0,
                                0
                            ], V = 1.25, H = {
                                breaklines: !0,
                                bolds: !0,
                                italics: !0,
                                subscripts: !0,
                                superscripts: !0
                            }, X = 0; X < 3; ++X){
                                F[X] = M.length / d | 0, g(.5 * (k[0][X] + k[1][X]), A[X], L[X], 12, V, H), q[X] = (M.length / d | 0) - F[X], P[X] = M.length / d | 0;
                                for(var G = 0; G < _[X].length; ++G)if (_[X][G].text) {
                                    var N = {
                                        family: _[X][G].font || C[X].family,
                                        style: C[X].fontStyle || C[X].style,
                                        weight: C[X].fontWeight || C[X].weight,
                                        variant: C[X].fontVariant || C[X].variant
                                    };
                                    g(_[X][G].x, _[X][G].text, N, _[X][G].fontSize || 12, V, H);
                                }
                                T[X] = (M.length / d | 0) - P[X];
                            }
                            this.buffer.update(M), this.tickOffset = P, this.tickCount = T, this.labelOffset = F, this.labelCount = q;
                        }, x.drawTicks = function(k, A, L, _, C, M, g, P) {
                            this.tickCount[k] && (this.shader.uniforms.axis = M, this.shader.uniforms.color = C, this.shader.uniforms.angle = L, this.shader.uniforms.scale = A, this.shader.uniforms.offset = _, this.shader.uniforms.alignDir = g, this.shader.uniforms.alignOpt = P, this.vao.draw(this.gl.TRIANGLES, this.tickCount[k], this.tickOffset[k]));
                        }, x.drawLabel = function(k, A, L, _, C, M, g, P) {
                            this.labelCount[k] && (this.shader.uniforms.axis = M, this.shader.uniforms.color = C, this.shader.uniforms.angle = L, this.shader.uniforms.scale = A, this.shader.uniforms.offset = _, this.shader.uniforms.alignDir = g, this.shader.uniforms.alignOpt = P, this.vao.draw(this.gl.TRIANGLES, this.labelCount[k], this.labelOffset[k]));
                        }, x.dispose = function() {
                            this.shader.dispose(), this.vao.dispose(), this.buffer.dispose();
                        };
                        function p(k, A) {
                            try {
                                return u(k, A);
                            } catch (L) {
                                return console.warn('error vectorizing text:"' + k + '" error:', L), {
                                    cells: [],
                                    positions: []
                                };
                            }
                        }
                        function E(k, A, L, _, C, M) {
                            var g = s(k), P = l(k, [
                                {
                                    buffer: g,
                                    size: 3
                                }
                            ]), T = c(k);
                            T.attributes.position.location = 0;
                            var F = new v(k, T, g, P);
                            return F.update(A, L, _, C, M), F;
                        }
                    },
                    6444: function(i, a) {
                        "use strict";
                        a.create = s, a.equal = l;
                        function o(u, c) {
                            var f = u + "", h = f.indexOf("."), d = 0;
                            h >= 0 && (d = f.length - h - 1);
                            var v = Math.pow(10, d), x = Math.round(u * c * v), b = x + "";
                            if (b.indexOf("e") >= 0) return b;
                            var p = x / v, E = x % v;
                            x < 0 ? (p = -Math.ceil(p) | 0, E = -E | 0) : (p = Math.floor(p) | 0, E = E | 0);
                            var k = "" + p;
                            if (x < 0 && (k = "-" + k), d) {
                                for(var A = "" + E; A.length < d;)A = "0" + A;
                                return k + "." + A;
                            } else return k;
                        }
                        function s(u, c) {
                            for(var f = [], h = 0; h < 3; ++h){
                                for(var d = [], v = .5 * (u[0][h] + u[1][h]), x = 0; x * c[h] <= u[1][h]; ++x)d.push({
                                    x: x * c[h],
                                    text: o(c[h], x)
                                });
                                for(var x = -1; x * c[h] >= u[0][h]; --x)d.push({
                                    x: x * c[h],
                                    text: o(c[h], x)
                                });
                                f.push(d);
                            }
                            return f;
                        }
                        function l(u, c) {
                            for(var f = 0; f < 3; ++f){
                                if (u[f].length !== c[f].length) return !1;
                                for(var h = 0; h < u[f].length; ++h){
                                    var d = u[f][h], v = c[f][h];
                                    if (d.x !== v.x || d.text !== v.text || d.font !== v.font || d.fontColor !== v.fontColor || d.fontSize !== v.fontSize || d.dx !== v.dx || d.dy !== v.dy) return !1;
                                }
                            }
                            return !0;
                        }
                    },
                    5445: function(i, a, o) {
                        "use strict";
                        i.exports = L;
                        var s = o(5033), l = o(5202), u = o(6429), c = o(6760), f = o(5665), h = o(5352), d = new Float32Array([
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ]), v = new Float32Array(16);
                        function x(_, C, M) {
                            this.lo = _, this.hi = C, this.pixelsPerDataUnit = M;
                        }
                        var b = [
                            0,
                            0,
                            0,
                            1
                        ], p = [
                            0,
                            0,
                            0,
                            1
                        ];
                        function E(_, C, M, g, P) {
                            for(var T = 0; T < 3; ++T){
                                for(var F = b, q = p, V = 0; V < 3; ++V)q[V] = F[V] = M[V];
                                q[3] = F[3] = 1, q[T] += 1, h(q, q, C), q[3] < 0 && (_[T] = 1 / 0), F[T] -= 1, h(F, F, C), F[3] < 0 && (_[T] = 1 / 0);
                                var H = (F[0] / F[3] - q[0] / q[3]) * g, X = (F[1] / F[3] - q[1] / q[3]) * P;
                                _[T] = .25 * Math.sqrt(H * H + X * X);
                            }
                            return _;
                        }
                        var k = [
                            new x(1 / 0, -1 / 0, 1 / 0),
                            new x(1 / 0, -1 / 0, 1 / 0),
                            new x(1 / 0, -1 / 0, 1 / 0)
                        ], A = [
                            0,
                            0,
                            0
                        ];
                        function L(_, C, M, g, X) {
                            var T = C.model || d, F = C.view || d, q = C.projection || d, V = C._ortho || !1, H = _.bounds, X = X || u(T, F, q, H, V), G = X.axis;
                            c(v, F, T), c(v, q, v);
                            for(var N = k, W = 0; W < 3; ++W)N[W].lo = 1 / 0, N[W].hi = -1 / 0, N[W].pixelsPerDataUnit = 1 / 0;
                            var re = s(f(v, v));
                            f(v, v);
                            for(var ae = 0; ae < 3; ++ae){
                                var _e = (ae + 1) % 3, Me = (ae + 2) % 3, ke = A;
                                e: for(var W = 0; W < 2; ++W){
                                    var ge = [];
                                    if (G[ae] < 0 != !!W) {
                                        ke[ae] = H[W][ae];
                                        for(var ie = 0; ie < 2; ++ie){
                                            ke[_e] = H[ie ^ W][_e];
                                            for(var Te = 0; Te < 2; ++Te)ke[Me] = H[Te ^ ie ^ W][Me], ge.push(ke.slice());
                                        }
                                        for(var Ee = V ? 5 : 4, ie = Ee; ie === Ee; ++ie){
                                            if (ge.length === 0) continue e;
                                            ge = l.positive(ge, re[ie]);
                                        }
                                        for(var ie = 0; ie < ge.length; ++ie)for(var Me = ge[ie], Ae = E(A, v, Me, M, g), Te = 0; Te < 3; ++Te)N[Te].lo = Math.min(N[Te].lo, Me[Te]), N[Te].hi = Math.max(N[Te].hi, Me[Te]), Te !== ae && (N[Te].pixelsPerDataUnit = Math.min(N[Te].pixelsPerDataUnit, Math.abs(Ae[Te])));
                                    }
                                }
                            }
                            return N;
                        }
                    },
                    2762: function(i, a, o) {
                        "use strict";
                        var s = o(1888), l = o(5298), u = o(9618), c = [
                            "uint8",
                            "uint8_clamped",
                            "uint16",
                            "uint32",
                            "int8",
                            "int16",
                            "int32",
                            "float32"
                        ];
                        function f(p, E, k, A, L) {
                            this.gl = p, this.type = E, this.handle = k, this.length = A, this.usage = L;
                        }
                        var h = f.prototype;
                        h.bind = function() {
                            this.gl.bindBuffer(this.type, this.handle);
                        }, h.unbind = function() {
                            this.gl.bindBuffer(this.type, null);
                        }, h.dispose = function() {
                            this.gl.deleteBuffer(this.handle);
                        };
                        function d(p, E, k, A, L, _) {
                            var C = L.length * L.BYTES_PER_ELEMENT;
                            if (_ < 0) return p.bufferData(E, L, A), C;
                            if (C + _ > k) throw new Error("gl-buffer: If resizing buffer, must not specify offset");
                            return p.bufferSubData(E, _, L), k;
                        }
                        function v(p, E) {
                            for(var k = s.malloc(p.length, E), A = p.length, L = 0; L < A; ++L)k[L] = p[L];
                            return k;
                        }
                        function x(p, E) {
                            for(var k = 1, A = E.length - 1; A >= 0; --A){
                                if (E[A] !== k) return !1;
                                k *= p[A];
                            }
                            return !0;
                        }
                        h.update = function(p, E) {
                            if (typeof E != "number" && (E = -1), this.bind(), typeof p == "object" && typeof p.shape != "undefined") {
                                var k = p.dtype;
                                if (c.indexOf(k) < 0 && (k = "float32"), this.type === this.gl.ELEMENT_ARRAY_BUFFER) {
                                    var A = gl.getExtension("OES_element_index_uint");
                                    A && k !== "uint16" ? k = "uint32" : k = "uint16";
                                }
                                if (k === p.dtype && x(p.shape, p.stride)) p.offset === 0 && p.data.length === p.shape[0] ? this.length = d(this.gl, this.type, this.length, this.usage, p.data, E) : this.length = d(this.gl, this.type, this.length, this.usage, p.data.subarray(p.offset, p.shape[0]), E);
                                else {
                                    var L = s.malloc(p.size, k), _ = u(L, p.shape);
                                    l.assign(_, p), E < 0 ? this.length = d(this.gl, this.type, this.length, this.usage, L, E) : this.length = d(this.gl, this.type, this.length, this.usage, L.subarray(0, p.size), E), s.free(L);
                                }
                            } else if (Array.isArray(p)) {
                                var C;
                                this.type === this.gl.ELEMENT_ARRAY_BUFFER ? C = v(p, "uint16") : C = v(p, "float32"), E < 0 ? this.length = d(this.gl, this.type, this.length, this.usage, C, E) : this.length = d(this.gl, this.type, this.length, this.usage, C.subarray(0, p.length), E), s.free(C);
                            } else if (typeof p == "object" && typeof p.length == "number") this.length = d(this.gl, this.type, this.length, this.usage, p, E);
                            else if (typeof p == "number" || p === void 0) {
                                if (E >= 0) throw new Error("gl-buffer: Cannot specify offset when resizing buffer");
                                p = p | 0, p <= 0 && (p = 1), this.gl.bufferData(this.type, p | 0, this.usage), this.length = p;
                            } else throw new Error("gl-buffer: Invalid data type");
                        };
                        function b(p, E, k, A) {
                            if (k = k || p.ARRAY_BUFFER, A = A || p.DYNAMIC_DRAW, k !== p.ARRAY_BUFFER && k !== p.ELEMENT_ARRAY_BUFFER) throw new Error("gl-buffer: Invalid type for webgl buffer, must be either gl.ARRAY_BUFFER or gl.ELEMENT_ARRAY_BUFFER");
                            if (A !== p.DYNAMIC_DRAW && A !== p.STATIC_DRAW && A !== p.STREAM_DRAW) throw new Error("gl-buffer: Invalid usage for buffer, must be either gl.DYNAMIC_DRAW, gl.STATIC_DRAW or gl.STREAM_DRAW");
                            var L = p.createBuffer(), _ = new f(p, k, L, 0, A);
                            return _.update(E), _;
                        }
                        i.exports = b;
                    },
                    6405: function(i, a, o) {
                        "use strict";
                        var s = o(2931);
                        i.exports = function(u, c) {
                            var f = u.positions, h = u.vectors, d = {
                                positions: [],
                                vertexIntensity: [],
                                vertexIntensityBounds: u.vertexIntensityBounds,
                                vectors: [],
                                cells: [],
                                coneOffset: u.coneOffset,
                                colormap: u.colormap
                            };
                            if (u.positions.length === 0) return c && (c[0] = [
                                0,
                                0,
                                0
                            ], c[1] = [
                                0,
                                0,
                                0
                            ]), d;
                            for(var v = 0, x = 1 / 0, b = -1 / 0, p = 1 / 0, E = -1 / 0, k = 1 / 0, A = -1 / 0, L = null, _ = null, C = [], M = 1 / 0, g = !1, P = u.coneSizemode === "raw", T = 0; T < f.length; T++){
                                var F = f[T];
                                x = Math.min(F[0], x), b = Math.max(F[0], b), p = Math.min(F[1], p), E = Math.max(F[1], E), k = Math.min(F[2], k), A = Math.max(F[2], A);
                                var q = h[T];
                                if (s.length(q) > v && (v = s.length(q)), T && !P) {
                                    var V = 2 * s.distance(L, F) / (s.length(_) + s.length(q));
                                    V ? (M = Math.min(M, V), g = !1) : g = !0;
                                }
                                g || (L = F, _ = q), C.push(q);
                            }
                            var H = [
                                x,
                                p,
                                k
                            ], X = [
                                b,
                                E,
                                A
                            ];
                            c && (c[0] = H, c[1] = X), v === 0 && (v = 1);
                            var G = 1 / v;
                            isFinite(M) || (M = 1), d.vectorScale = M;
                            var N = u.coneSize || (P ? 1 : .5);
                            u.absoluteConeSize && (N = u.absoluteConeSize * G), d.coneScale = N;
                            for(var T = 0, W = 0; T < f.length; T++)for(var F = f[T], re = F[0], ae = F[1], _e = F[2], Me = C[T], ke = s.length(Me) * G, ge = 0, ie = 8; ge < ie; ge++){
                                d.positions.push([
                                    re,
                                    ae,
                                    _e,
                                    W++
                                ]), d.positions.push([
                                    re,
                                    ae,
                                    _e,
                                    W++
                                ]), d.positions.push([
                                    re,
                                    ae,
                                    _e,
                                    W++
                                ]), d.positions.push([
                                    re,
                                    ae,
                                    _e,
                                    W++
                                ]), d.positions.push([
                                    re,
                                    ae,
                                    _e,
                                    W++
                                ]), d.positions.push([
                                    re,
                                    ae,
                                    _e,
                                    W++
                                ]), d.vectors.push(Me), d.vectors.push(Me), d.vectors.push(Me), d.vectors.push(Me), d.vectors.push(Me), d.vectors.push(Me), d.vertexIntensity.push(ke, ke, ke), d.vertexIntensity.push(ke, ke, ke);
                                var Te = d.positions.length;
                                d.cells.push([
                                    Te - 6,
                                    Te - 5,
                                    Te - 4
                                ], [
                                    Te - 3,
                                    Te - 2,
                                    Te - 1
                                ]);
                            }
                            return d;
                        };
                        var l = o(614);
                        i.exports.createMesh = o(9060), i.exports.createConeMesh = function(u, c) {
                            return i.exports.createMesh(u, c, {
                                shaders: l,
                                traceType: "cone"
                            });
                        };
                    },
                    9060: function(i, a, o) {
                        "use strict";
                        var s = o(9405), l = o(2762), u = o(8116), c = o(7766), f = o(6760), h = o(7608), d = o(9618), v = o(6729), x = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ];
                        function b(C, M, g, P, T, F, q, V, H, X, G) {
                            this.gl = C, this.pixelRatio = 1, this.cells = [], this.positions = [], this.intensity = [], this.texture = M, this.dirty = !0, this.triShader = g, this.pickShader = P, this.trianglePositions = T, this.triangleVectors = F, this.triangleColors = V, this.triangleUVs = H, this.triangleIds = q, this.triangleVAO = X, this.triangleCount = 0, this.pickId = 1, this.bounds = [
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ],
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ]
                            ], this.clipBounds = [
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ],
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ]
                            ], this.lightPosition = [
                                1e5,
                                1e5,
                                0
                            ], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.opacity = 1, this.traceType = G, this.tubeScale = 1, this.coneScale = 2, this.vectorScale = 1, this.coneOffset = .25, this._model = x, this._view = x, this._projection = x, this._resolution = [
                                1,
                                1
                            ];
                        }
                        var p = b.prototype;
                        p.isOpaque = function() {
                            return this.opacity >= 1;
                        }, p.isTransparent = function() {
                            return this.opacity < 1;
                        }, p.pickSlots = 1, p.setPickBase = function(C) {
                            this.pickId = C;
                        };
                        function E(C) {
                            for(var M = v({
                                colormap: C,
                                nshades: 256,
                                format: "rgba"
                            }), g = new Uint8Array(1024), P = 0; P < 256; ++P){
                                for(var T = M[P], F = 0; F < 3; ++F)g[4 * P + F] = T[F];
                                g[4 * P + 3] = T[3] * 255;
                            }
                            return d(g, [
                                256,
                                256,
                                4
                            ], [
                                4,
                                0,
                                1
                            ]);
                        }
                        function k(C) {
                            for(var M = C.length, g = new Array(M), P = 0; P < M; ++P)g[P] = C[P][2];
                            return g;
                        }
                        p.update = function(C) {
                            C = C || {};
                            var M = this.gl;
                            this.dirty = !0, "lightPosition" in C && (this.lightPosition = C.lightPosition), "opacity" in C && (this.opacity = C.opacity), "ambient" in C && (this.ambientLight = C.ambient), "diffuse" in C && (this.diffuseLight = C.diffuse), "specular" in C && (this.specularLight = C.specular), "roughness" in C && (this.roughness = C.roughness), "fresnel" in C && (this.fresnel = C.fresnel), C.tubeScale !== void 0 && (this.tubeScale = C.tubeScale), C.vectorScale !== void 0 && (this.vectorScale = C.vectorScale), C.coneScale !== void 0 && (this.coneScale = C.coneScale), C.coneOffset !== void 0 && (this.coneOffset = C.coneOffset), C.colormap && (this.texture.shape = [
                                256,
                                256
                            ], this.texture.minFilter = M.LINEAR_MIPMAP_LINEAR, this.texture.magFilter = M.LINEAR, this.texture.setPixels(E(C.colormap)), this.texture.generateMipmap());
                            var g = C.cells, P = C.positions, T = C.vectors;
                            if (!(!P || !g || !T)) {
                                var F = [], q = [], V = [], H = [], X = [];
                                this.cells = g, this.positions = P, this.vectors = T;
                                var G = C.meshColor || [
                                    1,
                                    1,
                                    1,
                                    1
                                ], N = C.vertexIntensity, W = 1 / 0, re = -1 / 0;
                                if (N) {
                                    if (C.vertexIntensityBounds) W = +C.vertexIntensityBounds[0], re = +C.vertexIntensityBounds[1];
                                    else for(var ae = 0; ae < N.length; ++ae){
                                        var _e = N[ae];
                                        W = Math.min(W, _e), re = Math.max(re, _e);
                                    }
                                } else for(var ae = 0; ae < P.length; ++ae){
                                    var _e = P[ae][2];
                                    W = Math.min(W, _e), re = Math.max(re, _e);
                                }
                                N ? this.intensity = N : this.intensity = k(P), this.bounds = [
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ],
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                ];
                                for(var ae = 0; ae < P.length; ++ae)for(var Me = P[ae], ke = 0; ke < 3; ++ke)isNaN(Me[ke]) || !isFinite(Me[ke]) || (this.bounds[0][ke] = Math.min(this.bounds[0][ke], Me[ke]), this.bounds[1][ke] = Math.max(this.bounds[1][ke], Me[ke]));
                                var ge = 0;
                                e: for(var ae = 0; ae < g.length; ++ae){
                                    var ie = g[ae];
                                    switch(ie.length){
                                        case 3:
                                            for(var ke = 0; ke < 3; ++ke)for(var Te = ie[ke], Me = P[Te], Ee = 0; Ee < 3; ++Ee)if (isNaN(Me[Ee]) || !isFinite(Me[Ee])) continue e;
                                            for(var ke = 0; ke < 3; ++ke){
                                                var Te = ie[2 - ke], Me = P[Te];
                                                F.push(Me[0], Me[1], Me[2], Me[3]);
                                                var Ae = T[Te];
                                                q.push(Ae[0], Ae[1], Ae[2], Ae[3] || 0);
                                                var ze = G;
                                                ze.length === 3 ? V.push(ze[0], ze[1], ze[2], 1) : V.push(ze[0], ze[1], ze[2], ze[3]);
                                                var Ce;
                                                N ? Ce = [
                                                    (N[Te] - W) / (re - W),
                                                    0
                                                ] : Ce = [
                                                    (Me[2] - W) / (re - W),
                                                    0
                                                ], H.push(Ce[0], Ce[1]), X.push(ae);
                                            }
                                            ge += 1;
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                this.triangleCount = ge, this.trianglePositions.update(F), this.triangleVectors.update(q), this.triangleColors.update(V), this.triangleUVs.update(H), this.triangleIds.update(new Uint32Array(X));
                            }
                        }, p.drawTransparent = p.draw = function(C) {
                            C = C || {};
                            for(var M = this.gl, g = C.model || x, P = C.view || x, T = C.projection || x, F = [
                                [
                                    -1000000,
                                    -1000000,
                                    -1000000
                                ],
                                [
                                    1e6,
                                    1e6,
                                    1e6
                                ]
                            ], q = 0; q < 3; ++q)F[0][q] = Math.max(F[0][q], this.clipBounds[0][q]), F[1][q] = Math.min(F[1][q], this.clipBounds[1][q]);
                            var V = {
                                model: g,
                                view: P,
                                projection: T,
                                inverseModel: x.slice(),
                                clipBounds: F,
                                kambient: this.ambientLight,
                                kdiffuse: this.diffuseLight,
                                kspecular: this.specularLight,
                                roughness: this.roughness,
                                fresnel: this.fresnel,
                                eyePosition: [
                                    0,
                                    0,
                                    0
                                ],
                                lightPosition: [
                                    0,
                                    0,
                                    0
                                ],
                                opacity: this.opacity,
                                tubeScale: this.tubeScale,
                                vectorScale: this.vectorScale,
                                coneScale: this.coneScale,
                                coneOffset: this.coneOffset,
                                texture: 0
                            };
                            V.inverseModel = h(V.inverseModel, V.model), M.disable(M.CULL_FACE), this.texture.bind(0);
                            var H = new Array(16);
                            f(H, V.view, V.model), f(H, V.projection, H), h(H, H);
                            for(var q = 0; q < 3; ++q)V.eyePosition[q] = H[12 + q] / H[15];
                            for(var X = H[15], q = 0; q < 3; ++q)X += this.lightPosition[q] * H[4 * q + 3];
                            for(var q = 0; q < 3; ++q){
                                for(var G = H[12 + q], N = 0; N < 3; ++N)G += H[4 * N + q] * this.lightPosition[N];
                                V.lightPosition[q] = G / X;
                            }
                            if (this.triangleCount > 0) {
                                var W = this.triShader;
                                W.bind(), W.uniforms = V, this.triangleVAO.bind(), M.drawArrays(M.TRIANGLES, 0, this.triangleCount * 3), this.triangleVAO.unbind();
                            }
                        }, p.drawPick = function(C) {
                            C = C || {};
                            for(var M = this.gl, g = C.model || x, P = C.view || x, T = C.projection || x, F = [
                                [
                                    -1000000,
                                    -1000000,
                                    -1000000
                                ],
                                [
                                    1e6,
                                    1e6,
                                    1e6
                                ]
                            ], q = 0; q < 3; ++q)F[0][q] = Math.max(F[0][q], this.clipBounds[0][q]), F[1][q] = Math.min(F[1][q], this.clipBounds[1][q]);
                            this._model = [].slice.call(g), this._view = [].slice.call(P), this._projection = [].slice.call(T), this._resolution = [
                                M.drawingBufferWidth,
                                M.drawingBufferHeight
                            ];
                            var V = {
                                model: g,
                                view: P,
                                projection: T,
                                clipBounds: F,
                                tubeScale: this.tubeScale,
                                vectorScale: this.vectorScale,
                                coneScale: this.coneScale,
                                coneOffset: this.coneOffset,
                                pickId: this.pickId / 255
                            }, H = this.pickShader;
                            H.bind(), H.uniforms = V, this.triangleCount > 0 && (this.triangleVAO.bind(), M.drawArrays(M.TRIANGLES, 0, this.triangleCount * 3), this.triangleVAO.unbind());
                        }, p.pick = function(C) {
                            if (!C || C.id !== this.pickId) return null;
                            var M = C.value[0] + 256 * C.value[1] + 65536 * C.value[2], g = this.cells[M], P = this.positions[g[1]].slice(0, 3), T = {
                                position: P,
                                dataCoordinate: P,
                                index: Math.floor(g[1] / 48)
                            };
                            return this.traceType === "cone" ? T.index = Math.floor(g[1] / 48) : this.traceType === "streamtube" && (T.intensity = this.intensity[g[1]], T.velocity = this.vectors[g[1]].slice(0, 3), T.divergence = this.vectors[g[1]][3], T.index = M), T;
                        }, p.dispose = function() {
                            this.texture.dispose(), this.triShader.dispose(), this.pickShader.dispose(), this.triangleVAO.dispose(), this.trianglePositions.dispose(), this.triangleVectors.dispose(), this.triangleColors.dispose(), this.triangleUVs.dispose(), this.triangleIds.dispose();
                        };
                        function A(C, M) {
                            var g = s(C, M.meshShader.vertex, M.meshShader.fragment, null, M.meshShader.attributes);
                            return g.attributes.position.location = 0, g.attributes.color.location = 2, g.attributes.uv.location = 3, g.attributes.vector.location = 4, g;
                        }
                        function L(C, M) {
                            var g = s(C, M.pickShader.vertex, M.pickShader.fragment, null, M.pickShader.attributes);
                            return g.attributes.position.location = 0, g.attributes.id.location = 1, g.attributes.vector.location = 4, g;
                        }
                        function _(C, M, g) {
                            var P = g.shaders;
                            arguments.length === 1 && (M = C, C = M.gl);
                            var T = A(C, P), F = L(C, P), q = c(C, d(new Uint8Array([
                                255,
                                255,
                                255,
                                255
                            ]), [
                                1,
                                1,
                                4
                            ]));
                            q.generateMipmap(), q.minFilter = C.LINEAR_MIPMAP_LINEAR, q.magFilter = C.LINEAR;
                            var V = l(C), H = l(C), X = l(C), G = l(C), N = l(C), W = u(C, [
                                {
                                    buffer: V,
                                    type: C.FLOAT,
                                    size: 4
                                },
                                {
                                    buffer: N,
                                    type: C.UNSIGNED_BYTE,
                                    size: 4,
                                    normalized: !0
                                },
                                {
                                    buffer: X,
                                    type: C.FLOAT,
                                    size: 4
                                },
                                {
                                    buffer: G,
                                    type: C.FLOAT,
                                    size: 2
                                },
                                {
                                    buffer: H,
                                    type: C.FLOAT,
                                    size: 4
                                }
                            ]), re = new b(C, q, T, F, V, H, N, X, G, W, g.traceType || "cone");
                            return re.update(M), re;
                        }
                        i.exports = _;
                    },
                    614: function(i, a, o) {
                        var s = o(3236), l = s([
                            `precision highp float;

precision highp float;
#define GLSLIFY 1

vec3 getOrthogonalVector(vec3 v) {
  // Return up-vector for only-z vector.
  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).
  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.
  // Assign z = 0, x = -b, y = a:
  // a*-b + b*a + c*0 = -ba + ba + 0 = 0
  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {
    return normalize(vec3(-v.y, v.x, 0.0));
  } else {
    return normalize(vec3(0.0, v.z, -v.y));
  }
}

// Calculate the cone vertex and normal at the given index.
//
// The returned vertex is for a cone with its top at origin and height of 1.0,
// pointing in the direction of the vector attribute.
//
// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.
// These vertices are used to make up the triangles of the cone by the following:
//   segment + 0 top vertex
//   segment + 1 perimeter vertex a+1
//   segment + 2 perimeter vertex a
//   segment + 3 center base vertex
//   segment + 4 perimeter vertex a
//   segment + 5 perimeter vertex a+1
// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.
// To go from index to segment, floor(index / 6)
// To go from segment to angle, 2*pi * (segment/segmentCount)
// To go from index to segment index, index - (segment*6)
//
vec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {

  const float segmentCount = 8.0;

  float index = rawIndex - floor(rawIndex /
    (segmentCount * 6.0)) *
    (segmentCount * 6.0);

  float segment = floor(0.001 + index/6.0);
  float segmentIndex = index - (segment*6.0);

  normal = -normalize(d);

  if (segmentIndex > 2.99 && segmentIndex < 3.01) {
    return mix(vec3(0.0), -d, coneOffset);
  }

  float nextAngle = (
    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||
    (segmentIndex > 4.99 &&  segmentIndex < 5.01)
  ) ? 1.0 : 0.0;
  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);

  vec3 v1 = mix(d, vec3(0.0), coneOffset);
  vec3 v2 = v1 - d;

  vec3 u = getOrthogonalVector(d);
  vec3 v = normalize(cross(u, d));

  vec3 x = u * cos(angle) * length(d)*0.25;
  vec3 y = v * sin(angle) * length(d)*0.25;
  vec3 v3 = v2 + x + y;
  if (segmentIndex < 3.0) {
    vec3 tx = u * sin(angle);
    vec3 ty = v * -cos(angle);
    vec3 tangent = tx + ty;
    normal = normalize(cross(v3 - v1, tangent));
  }

  if (segmentIndex == 0.0) {
    return mix(d, vec3(0.0), coneOffset);
  }
  return v3;
}

attribute vec3 vector;
attribute vec4 color, position;
attribute vec2 uv;

uniform float vectorScale, coneScale, coneOffset;
uniform mat4 model, view, projection, inverseModel;
uniform vec3 eyePosition, lightPosition;

varying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;
varying vec4 f_color;
varying vec2 f_uv;

void main() {
  // Scale the vector magnitude to stay constant with
  // model & view changes.
  vec3 normal;
  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector), position.w, coneOffset, normal);
  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);

  //Lighting geometry parameters
  vec4 cameraCoordinate = view * conePosition;
  cameraCoordinate.xyz /= cameraCoordinate.w;
  f_lightDirection = lightPosition - cameraCoordinate.xyz;
  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;
  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);

  // vec4 m_position  = model * vec4(conePosition, 1.0);
  vec4 t_position  = view * conePosition;
  gl_Position      = projection * t_position;

  f_color          = color;
  f_data           = conePosition.xyz;
  f_position       = position.xyz;
  f_uv             = uv;
}
`
                        ]), u = s([
                            `#extension GL_OES_standard_derivatives : enable

precision highp float;
#define GLSLIFY 1

float beckmannDistribution(float x, float roughness) {
  float NdotH = max(x, 0.0001);
  float cos2Alpha = NdotH * NdotH;
  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;
  float roughness2 = roughness * roughness;
  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;
  return exp(tan2Alpha / roughness2) / denom;
}

float cookTorranceSpecular(
  vec3 lightDirection,
  vec3 viewDirection,
  vec3 surfaceNormal,
  float roughness,
  float fresnel) {

  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);
  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);

  //Half angle vector
  vec3 H = normalize(lightDirection + viewDirection);

  //Geometric term
  float NdotH = max(dot(surfaceNormal, H), 0.0);
  float VdotH = max(dot(viewDirection, H), 0.000001);
  float LdotH = max(dot(lightDirection, H), 0.000001);
  float G1 = (2.0 * NdotH * VdotN) / VdotH;
  float G2 = (2.0 * NdotH * LdotN) / LdotH;
  float G = min(1.0, min(G1, G2));
  
  //Distribution term
  float D = beckmannDistribution(NdotH, roughness);

  //Fresnel term
  float F = pow(1.0 - VdotN, fresnel);

  //Multiply terms and done
  return  G * F * D / max(3.14159265 * VdotN, 0.000001);
}

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3 clipBounds[2];
uniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;
uniform sampler2D texture;

varying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;
varying vec4 f_color;
varying vec2 f_uv;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;
  vec3 N = normalize(f_normal);
  vec3 L = normalize(f_lightDirection);
  vec3 V = normalize(f_eyeDirection);

  if(gl_FrontFacing) {
    N = -N;
  }

  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));
  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);

  vec4 surfaceColor = f_color * texture2D(texture, f_uv);
  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);

  gl_FragColor = litColor * opacity;
}
`
                        ]), c = s([
                            `precision highp float;

precision highp float;
#define GLSLIFY 1

vec3 getOrthogonalVector(vec3 v) {
  // Return up-vector for only-z vector.
  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).
  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.
  // Assign z = 0, x = -b, y = a:
  // a*-b + b*a + c*0 = -ba + ba + 0 = 0
  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {
    return normalize(vec3(-v.y, v.x, 0.0));
  } else {
    return normalize(vec3(0.0, v.z, -v.y));
  }
}

// Calculate the cone vertex and normal at the given index.
//
// The returned vertex is for a cone with its top at origin and height of 1.0,
// pointing in the direction of the vector attribute.
//
// Each cone is made up of a top vertex, a center base vertex and base perimeter vertices.
// These vertices are used to make up the triangles of the cone by the following:
//   segment + 0 top vertex
//   segment + 1 perimeter vertex a+1
//   segment + 2 perimeter vertex a
//   segment + 3 center base vertex
//   segment + 4 perimeter vertex a
//   segment + 5 perimeter vertex a+1
// Where segment is the number of the radial segment * 6 and a is the angle at that radial segment.
// To go from index to segment, floor(index / 6)
// To go from segment to angle, 2*pi * (segment/segmentCount)
// To go from index to segment index, index - (segment*6)
//
vec3 getConePosition(vec3 d, float rawIndex, float coneOffset, out vec3 normal) {

  const float segmentCount = 8.0;

  float index = rawIndex - floor(rawIndex /
    (segmentCount * 6.0)) *
    (segmentCount * 6.0);

  float segment = floor(0.001 + index/6.0);
  float segmentIndex = index - (segment*6.0);

  normal = -normalize(d);

  if (segmentIndex > 2.99 && segmentIndex < 3.01) {
    return mix(vec3(0.0), -d, coneOffset);
  }

  float nextAngle = (
    (segmentIndex > 0.99 &&  segmentIndex < 1.01) ||
    (segmentIndex > 4.99 &&  segmentIndex < 5.01)
  ) ? 1.0 : 0.0;
  float angle = 2.0 * 3.14159 * ((segment + nextAngle) / segmentCount);

  vec3 v1 = mix(d, vec3(0.0), coneOffset);
  vec3 v2 = v1 - d;

  vec3 u = getOrthogonalVector(d);
  vec3 v = normalize(cross(u, d));

  vec3 x = u * cos(angle) * length(d)*0.25;
  vec3 y = v * sin(angle) * length(d)*0.25;
  vec3 v3 = v2 + x + y;
  if (segmentIndex < 3.0) {
    vec3 tx = u * sin(angle);
    vec3 ty = v * -cos(angle);
    vec3 tangent = tx + ty;
    normal = normalize(cross(v3 - v1, tangent));
  }

  if (segmentIndex == 0.0) {
    return mix(d, vec3(0.0), coneOffset);
  }
  return v3;
}

attribute vec4 vector;
attribute vec4 position;
attribute vec4 id;

uniform mat4 model, view, projection;
uniform float vectorScale, coneScale, coneOffset;

varying vec3 f_position;
varying vec4 f_id;

void main() {
  vec3 normal;
  vec3 XYZ = getConePosition(mat3(model) * ((vectorScale * coneScale) * vector.xyz), position.w, coneOffset, normal);
  vec4 conePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);
  gl_Position = projection * (view * conePosition);
  f_id        = id;
  f_position  = position.xyz;
}
`
                        ]), f = s([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3  clipBounds[2];
uniform float pickId;

varying vec3 f_position;
varying vec4 f_id;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;

  gl_FragColor = vec4(pickId, f_id.xyz);
}`
                        ]);
                        a.meshShader = {
                            vertex: l,
                            fragment: u,
                            attributes: [
                                {
                                    name: "position",
                                    type: "vec4"
                                },
                                {
                                    name: "color",
                                    type: "vec4"
                                },
                                {
                                    name: "uv",
                                    type: "vec2"
                                },
                                {
                                    name: "vector",
                                    type: "vec3"
                                }
                            ]
                        }, a.pickShader = {
                            vertex: c,
                            fragment: f,
                            attributes: [
                                {
                                    name: "position",
                                    type: "vec4"
                                },
                                {
                                    name: "id",
                                    type: "vec4"
                                },
                                {
                                    name: "vector",
                                    type: "vec3"
                                }
                            ]
                        };
                    },
                    737: function(i) {
                        i.exports = {
                            0: "NONE",
                            1: "ONE",
                            2: "LINE_LOOP",
                            3: "LINE_STRIP",
                            4: "TRIANGLES",
                            5: "TRIANGLE_STRIP",
                            6: "TRIANGLE_FAN",
                            256: "DEPTH_BUFFER_BIT",
                            512: "NEVER",
                            513: "LESS",
                            514: "EQUAL",
                            515: "LEQUAL",
                            516: "GREATER",
                            517: "NOTEQUAL",
                            518: "GEQUAL",
                            519: "ALWAYS",
                            768: "SRC_COLOR",
                            769: "ONE_MINUS_SRC_COLOR",
                            770: "SRC_ALPHA",
                            771: "ONE_MINUS_SRC_ALPHA",
                            772: "DST_ALPHA",
                            773: "ONE_MINUS_DST_ALPHA",
                            774: "DST_COLOR",
                            775: "ONE_MINUS_DST_COLOR",
                            776: "SRC_ALPHA_SATURATE",
                            1024: "STENCIL_BUFFER_BIT",
                            1028: "FRONT",
                            1029: "BACK",
                            1032: "FRONT_AND_BACK",
                            1280: "INVALID_ENUM",
                            1281: "INVALID_VALUE",
                            1282: "INVALID_OPERATION",
                            1285: "OUT_OF_MEMORY",
                            1286: "INVALID_FRAMEBUFFER_OPERATION",
                            2304: "CW",
                            2305: "CCW",
                            2849: "LINE_WIDTH",
                            2884: "CULL_FACE",
                            2885: "CULL_FACE_MODE",
                            2886: "FRONT_FACE",
                            2928: "DEPTH_RANGE",
                            2929: "DEPTH_TEST",
                            2930: "DEPTH_WRITEMASK",
                            2931: "DEPTH_CLEAR_VALUE",
                            2932: "DEPTH_FUNC",
                            2960: "STENCIL_TEST",
                            2961: "STENCIL_CLEAR_VALUE",
                            2962: "STENCIL_FUNC",
                            2963: "STENCIL_VALUE_MASK",
                            2964: "STENCIL_FAIL",
                            2965: "STENCIL_PASS_DEPTH_FAIL",
                            2966: "STENCIL_PASS_DEPTH_PASS",
                            2967: "STENCIL_REF",
                            2968: "STENCIL_WRITEMASK",
                            2978: "VIEWPORT",
                            3024: "DITHER",
                            3042: "BLEND",
                            3088: "SCISSOR_BOX",
                            3089: "SCISSOR_TEST",
                            3106: "COLOR_CLEAR_VALUE",
                            3107: "COLOR_WRITEMASK",
                            3317: "UNPACK_ALIGNMENT",
                            3333: "PACK_ALIGNMENT",
                            3379: "MAX_TEXTURE_SIZE",
                            3386: "MAX_VIEWPORT_DIMS",
                            3408: "SUBPIXEL_BITS",
                            3410: "RED_BITS",
                            3411: "GREEN_BITS",
                            3412: "BLUE_BITS",
                            3413: "ALPHA_BITS",
                            3414: "DEPTH_BITS",
                            3415: "STENCIL_BITS",
                            3553: "TEXTURE_2D",
                            4352: "DONT_CARE",
                            4353: "FASTEST",
                            4354: "NICEST",
                            5120: "BYTE",
                            5121: "UNSIGNED_BYTE",
                            5122: "SHORT",
                            5123: "UNSIGNED_SHORT",
                            5124: "INT",
                            5125: "UNSIGNED_INT",
                            5126: "FLOAT",
                            5386: "INVERT",
                            5890: "TEXTURE",
                            6401: "STENCIL_INDEX",
                            6402: "DEPTH_COMPONENT",
                            6406: "ALPHA",
                            6407: "RGB",
                            6408: "RGBA",
                            6409: "LUMINANCE",
                            6410: "LUMINANCE_ALPHA",
                            7680: "KEEP",
                            7681: "REPLACE",
                            7682: "INCR",
                            7683: "DECR",
                            7936: "VENDOR",
                            7937: "RENDERER",
                            7938: "VERSION",
                            9728: "NEAREST",
                            9729: "LINEAR",
                            9984: "NEAREST_MIPMAP_NEAREST",
                            9985: "LINEAR_MIPMAP_NEAREST",
                            9986: "NEAREST_MIPMAP_LINEAR",
                            9987: "LINEAR_MIPMAP_LINEAR",
                            10240: "TEXTURE_MAG_FILTER",
                            10241: "TEXTURE_MIN_FILTER",
                            10242: "TEXTURE_WRAP_S",
                            10243: "TEXTURE_WRAP_T",
                            10497: "REPEAT",
                            10752: "POLYGON_OFFSET_UNITS",
                            16384: "COLOR_BUFFER_BIT",
                            32769: "CONSTANT_COLOR",
                            32770: "ONE_MINUS_CONSTANT_COLOR",
                            32771: "CONSTANT_ALPHA",
                            32772: "ONE_MINUS_CONSTANT_ALPHA",
                            32773: "BLEND_COLOR",
                            32774: "FUNC_ADD",
                            32777: "BLEND_EQUATION_RGB",
                            32778: "FUNC_SUBTRACT",
                            32779: "FUNC_REVERSE_SUBTRACT",
                            32819: "UNSIGNED_SHORT_4_4_4_4",
                            32820: "UNSIGNED_SHORT_5_5_5_1",
                            32823: "POLYGON_OFFSET_FILL",
                            32824: "POLYGON_OFFSET_FACTOR",
                            32854: "RGBA4",
                            32855: "RGB5_A1",
                            32873: "TEXTURE_BINDING_2D",
                            32926: "SAMPLE_ALPHA_TO_COVERAGE",
                            32928: "SAMPLE_COVERAGE",
                            32936: "SAMPLE_BUFFERS",
                            32937: "SAMPLES",
                            32938: "SAMPLE_COVERAGE_VALUE",
                            32939: "SAMPLE_COVERAGE_INVERT",
                            32968: "BLEND_DST_RGB",
                            32969: "BLEND_SRC_RGB",
                            32970: "BLEND_DST_ALPHA",
                            32971: "BLEND_SRC_ALPHA",
                            33071: "CLAMP_TO_EDGE",
                            33170: "GENERATE_MIPMAP_HINT",
                            33189: "DEPTH_COMPONENT16",
                            33306: "DEPTH_STENCIL_ATTACHMENT",
                            33635: "UNSIGNED_SHORT_5_6_5",
                            33648: "MIRRORED_REPEAT",
                            33901: "ALIASED_POINT_SIZE_RANGE",
                            33902: "ALIASED_LINE_WIDTH_RANGE",
                            33984: "TEXTURE0",
                            33985: "TEXTURE1",
                            33986: "TEXTURE2",
                            33987: "TEXTURE3",
                            33988: "TEXTURE4",
                            33989: "TEXTURE5",
                            33990: "TEXTURE6",
                            33991: "TEXTURE7",
                            33992: "TEXTURE8",
                            33993: "TEXTURE9",
                            33994: "TEXTURE10",
                            33995: "TEXTURE11",
                            33996: "TEXTURE12",
                            33997: "TEXTURE13",
                            33998: "TEXTURE14",
                            33999: "TEXTURE15",
                            34e3: "TEXTURE16",
                            34001: "TEXTURE17",
                            34002: "TEXTURE18",
                            34003: "TEXTURE19",
                            34004: "TEXTURE20",
                            34005: "TEXTURE21",
                            34006: "TEXTURE22",
                            34007: "TEXTURE23",
                            34008: "TEXTURE24",
                            34009: "TEXTURE25",
                            34010: "TEXTURE26",
                            34011: "TEXTURE27",
                            34012: "TEXTURE28",
                            34013: "TEXTURE29",
                            34014: "TEXTURE30",
                            34015: "TEXTURE31",
                            34016: "ACTIVE_TEXTURE",
                            34024: "MAX_RENDERBUFFER_SIZE",
                            34041: "DEPTH_STENCIL",
                            34055: "INCR_WRAP",
                            34056: "DECR_WRAP",
                            34067: "TEXTURE_CUBE_MAP",
                            34068: "TEXTURE_BINDING_CUBE_MAP",
                            34069: "TEXTURE_CUBE_MAP_POSITIVE_X",
                            34070: "TEXTURE_CUBE_MAP_NEGATIVE_X",
                            34071: "TEXTURE_CUBE_MAP_POSITIVE_Y",
                            34072: "TEXTURE_CUBE_MAP_NEGATIVE_Y",
                            34073: "TEXTURE_CUBE_MAP_POSITIVE_Z",
                            34074: "TEXTURE_CUBE_MAP_NEGATIVE_Z",
                            34076: "MAX_CUBE_MAP_TEXTURE_SIZE",
                            34338: "VERTEX_ATTRIB_ARRAY_ENABLED",
                            34339: "VERTEX_ATTRIB_ARRAY_SIZE",
                            34340: "VERTEX_ATTRIB_ARRAY_STRIDE",
                            34341: "VERTEX_ATTRIB_ARRAY_TYPE",
                            34342: "CURRENT_VERTEX_ATTRIB",
                            34373: "VERTEX_ATTRIB_ARRAY_POINTER",
                            34466: "NUM_COMPRESSED_TEXTURE_FORMATS",
                            34467: "COMPRESSED_TEXTURE_FORMATS",
                            34660: "BUFFER_SIZE",
                            34661: "BUFFER_USAGE",
                            34816: "STENCIL_BACK_FUNC",
                            34817: "STENCIL_BACK_FAIL",
                            34818: "STENCIL_BACK_PASS_DEPTH_FAIL",
                            34819: "STENCIL_BACK_PASS_DEPTH_PASS",
                            34877: "BLEND_EQUATION_ALPHA",
                            34921: "MAX_VERTEX_ATTRIBS",
                            34922: "VERTEX_ATTRIB_ARRAY_NORMALIZED",
                            34930: "MAX_TEXTURE_IMAGE_UNITS",
                            34962: "ARRAY_BUFFER",
                            34963: "ELEMENT_ARRAY_BUFFER",
                            34964: "ARRAY_BUFFER_BINDING",
                            34965: "ELEMENT_ARRAY_BUFFER_BINDING",
                            34975: "VERTEX_ATTRIB_ARRAY_BUFFER_BINDING",
                            35040: "STREAM_DRAW",
                            35044: "STATIC_DRAW",
                            35048: "DYNAMIC_DRAW",
                            35632: "FRAGMENT_SHADER",
                            35633: "VERTEX_SHADER",
                            35660: "MAX_VERTEX_TEXTURE_IMAGE_UNITS",
                            35661: "MAX_COMBINED_TEXTURE_IMAGE_UNITS",
                            35663: "SHADER_TYPE",
                            35664: "FLOAT_VEC2",
                            35665: "FLOAT_VEC3",
                            35666: "FLOAT_VEC4",
                            35667: "INT_VEC2",
                            35668: "INT_VEC3",
                            35669: "INT_VEC4",
                            35670: "BOOL",
                            35671: "BOOL_VEC2",
                            35672: "BOOL_VEC3",
                            35673: "BOOL_VEC4",
                            35674: "FLOAT_MAT2",
                            35675: "FLOAT_MAT3",
                            35676: "FLOAT_MAT4",
                            35678: "SAMPLER_2D",
                            35680: "SAMPLER_CUBE",
                            35712: "DELETE_STATUS",
                            35713: "COMPILE_STATUS",
                            35714: "LINK_STATUS",
                            35715: "VALIDATE_STATUS",
                            35716: "INFO_LOG_LENGTH",
                            35717: "ATTACHED_SHADERS",
                            35718: "ACTIVE_UNIFORMS",
                            35719: "ACTIVE_UNIFORM_MAX_LENGTH",
                            35720: "SHADER_SOURCE_LENGTH",
                            35721: "ACTIVE_ATTRIBUTES",
                            35722: "ACTIVE_ATTRIBUTE_MAX_LENGTH",
                            35724: "SHADING_LANGUAGE_VERSION",
                            35725: "CURRENT_PROGRAM",
                            36003: "STENCIL_BACK_REF",
                            36004: "STENCIL_BACK_VALUE_MASK",
                            36005: "STENCIL_BACK_WRITEMASK",
                            36006: "FRAMEBUFFER_BINDING",
                            36007: "RENDERBUFFER_BINDING",
                            36048: "FRAMEBUFFER_ATTACHMENT_OBJECT_TYPE",
                            36049: "FRAMEBUFFER_ATTACHMENT_OBJECT_NAME",
                            36050: "FRAMEBUFFER_ATTACHMENT_TEXTURE_LEVEL",
                            36051: "FRAMEBUFFER_ATTACHMENT_TEXTURE_CUBE_MAP_FACE",
                            36053: "FRAMEBUFFER_COMPLETE",
                            36054: "FRAMEBUFFER_INCOMPLETE_ATTACHMENT",
                            36055: "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT",
                            36057: "FRAMEBUFFER_INCOMPLETE_DIMENSIONS",
                            36061: "FRAMEBUFFER_UNSUPPORTED",
                            36064: "COLOR_ATTACHMENT0",
                            36096: "DEPTH_ATTACHMENT",
                            36128: "STENCIL_ATTACHMENT",
                            36160: "FRAMEBUFFER",
                            36161: "RENDERBUFFER",
                            36162: "RENDERBUFFER_WIDTH",
                            36163: "RENDERBUFFER_HEIGHT",
                            36164: "RENDERBUFFER_INTERNAL_FORMAT",
                            36168: "STENCIL_INDEX8",
                            36176: "RENDERBUFFER_RED_SIZE",
                            36177: "RENDERBUFFER_GREEN_SIZE",
                            36178: "RENDERBUFFER_BLUE_SIZE",
                            36179: "RENDERBUFFER_ALPHA_SIZE",
                            36180: "RENDERBUFFER_DEPTH_SIZE",
                            36181: "RENDERBUFFER_STENCIL_SIZE",
                            36194: "RGB565",
                            36336: "LOW_FLOAT",
                            36337: "MEDIUM_FLOAT",
                            36338: "HIGH_FLOAT",
                            36339: "LOW_INT",
                            36340: "MEDIUM_INT",
                            36341: "HIGH_INT",
                            36346: "SHADER_COMPILER",
                            36347: "MAX_VERTEX_UNIFORM_VECTORS",
                            36348: "MAX_VARYING_VECTORS",
                            36349: "MAX_FRAGMENT_UNIFORM_VECTORS",
                            37440: "UNPACK_FLIP_Y_WEBGL",
                            37441: "UNPACK_PREMULTIPLY_ALPHA_WEBGL",
                            37442: "CONTEXT_LOST_WEBGL",
                            37443: "UNPACK_COLORSPACE_CONVERSION_WEBGL",
                            37444: "BROWSER_DEFAULT_WEBGL"
                        };
                    },
                    5171: function(i, a, o) {
                        var s = o(737);
                        i.exports = function(u) {
                            return s[u];
                        };
                    },
                    9165: function(i, a, o) {
                        "use strict";
                        i.exports = b;
                        var s = o(2762), l = o(8116), u = o(3436), c = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ];
                        function f(p, E, k, A) {
                            this.gl = p, this.shader = A, this.buffer = E, this.vao = k, this.pixelRatio = 1, this.bounds = [
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ],
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ]
                            ], this.clipBounds = [
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ],
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ]
                            ], this.lineWidth = [
                                1,
                                1,
                                1
                            ], this.capSize = [
                                10,
                                10,
                                10
                            ], this.lineCount = [
                                0,
                                0,
                                0
                            ], this.lineOffset = [
                                0,
                                0,
                                0
                            ], this.opacity = 1, this.hasAlpha = !1;
                        }
                        var h = f.prototype;
                        h.isOpaque = function() {
                            return !this.hasAlpha;
                        }, h.isTransparent = function() {
                            return this.hasAlpha;
                        }, h.drawTransparent = h.draw = function(p) {
                            var E = this.gl, k = this.shader.uniforms;
                            this.shader.bind();
                            var A = k.view = p.view || c, L = k.projection = p.projection || c;
                            k.model = p.model || c, k.clipBounds = this.clipBounds, k.opacity = this.opacity;
                            var _ = A[12], C = A[13], M = A[14], g = A[15], P = p._ortho || !1, T = P ? 2 : 1, F = T * this.pixelRatio * (L[3] * _ + L[7] * C + L[11] * M + L[15] * g) / E.drawingBufferHeight;
                            this.vao.bind();
                            for(var q = 0; q < 3; ++q)E.lineWidth(this.lineWidth[q] * this.pixelRatio), k.capSize = this.capSize[q] * F, this.lineCount[q] && E.drawArrays(E.LINES, this.lineOffset[q], this.lineCount[q]);
                            this.vao.unbind();
                        };
                        function d(p, E) {
                            for(var k = 0; k < 3; ++k)p[0][k] = Math.min(p[0][k], E[k]), p[1][k] = Math.max(p[1][k], E[k]);
                        }
                        var v = function() {
                            for(var p = new Array(3), E = 0; E < 3; ++E){
                                for(var k = [], A = 1; A <= 2; ++A)for(var L = -1; L <= 1; L += 2){
                                    var _ = (A + E) % 3, C = [
                                        0,
                                        0,
                                        0
                                    ];
                                    C[_] = L, k.push(C);
                                }
                                p[E] = k;
                            }
                            return p;
                        }();
                        function x(p, E, k, A) {
                            for(var L = v[A], _ = 0; _ < L.length; ++_){
                                var C = L[_];
                                p.push(E[0], E[1], E[2], k[0], k[1], k[2], k[3], C[0], C[1], C[2]);
                            }
                            return L.length;
                        }
                        h.update = function(p) {
                            p = p || {}, "lineWidth" in p && (this.lineWidth = p.lineWidth, Array.isArray(this.lineWidth) || (this.lineWidth = [
                                this.lineWidth,
                                this.lineWidth,
                                this.lineWidth
                            ])), "capSize" in p && (this.capSize = p.capSize, Array.isArray(this.capSize) || (this.capSize = [
                                this.capSize,
                                this.capSize,
                                this.capSize
                            ])), this.hasAlpha = !1, "opacity" in p && (this.opacity = +p.opacity, this.opacity < 1 && (this.hasAlpha = !0));
                            var E = p.color || [
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ]
                            ], k = p.position, A = p.error;
                            if (Array.isArray(E[0]) || (E = [
                                E,
                                E,
                                E
                            ]), k && A) {
                                var L = [], _ = k.length, C = 0;
                                this.bounds = [
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ],
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                ], this.lineCount = [
                                    0,
                                    0,
                                    0
                                ];
                                for(var M = 0; M < 3; ++M){
                                    this.lineOffset[M] = C;
                                    e: for(var g = 0; g < _; ++g){
                                        for(var P = k[g], T = 0; T < 3; ++T)if (isNaN(P[T]) || !isFinite(P[T])) continue e;
                                        var F = A[g], q = E[M];
                                        if (Array.isArray(q[0]) && (q = E[g]), q.length === 3 ? q = [
                                            q[0],
                                            q[1],
                                            q[2],
                                            1
                                        ] : q.length === 4 && (q = [
                                            q[0],
                                            q[1],
                                            q[2],
                                            q[3]
                                        ], !this.hasAlpha && q[3] < 1 && (this.hasAlpha = !0)), !(isNaN(F[0][M]) || isNaN(F[1][M]))) {
                                            if (F[0][M] < 0) {
                                                var V = P.slice();
                                                V[M] += F[0][M], L.push(P[0], P[1], P[2], q[0], q[1], q[2], q[3], 0, 0, 0, V[0], V[1], V[2], q[0], q[1], q[2], q[3], 0, 0, 0), d(this.bounds, V), C += 2 + x(L, V, q, M);
                                            }
                                            if (F[1][M] > 0) {
                                                var V = P.slice();
                                                V[M] += F[1][M], L.push(P[0], P[1], P[2], q[0], q[1], q[2], q[3], 0, 0, 0, V[0], V[1], V[2], q[0], q[1], q[2], q[3], 0, 0, 0), d(this.bounds, V), C += 2 + x(L, V, q, M);
                                            }
                                        }
                                    }
                                    this.lineCount[M] = C - this.lineOffset[M];
                                }
                                this.buffer.update(L);
                            }
                        }, h.dispose = function() {
                            this.shader.dispose(), this.buffer.dispose(), this.vao.dispose();
                        };
                        function b(p) {
                            var E = p.gl, k = s(E), A = l(E, [
                                {
                                    buffer: k,
                                    type: E.FLOAT,
                                    size: 3,
                                    offset: 0,
                                    stride: 40
                                },
                                {
                                    buffer: k,
                                    type: E.FLOAT,
                                    size: 4,
                                    offset: 12,
                                    stride: 40
                                },
                                {
                                    buffer: k,
                                    type: E.FLOAT,
                                    size: 3,
                                    offset: 28,
                                    stride: 40
                                }
                            ]), L = u(E);
                            L.attributes.position.location = 0, L.attributes.color.location = 1, L.attributes.offset.location = 2;
                            var _ = new f(E, k, A, L);
                            return _.update(p), _;
                        }
                    },
                    3436: function(i, a, o) {
                        "use strict";
                        var s = o(3236), l = o(9405), u = s([
                            `precision highp float;
#define GLSLIFY 1

attribute vec3 position, offset;
attribute vec4 color;
uniform mat4 model, view, projection;
uniform float capSize;
varying vec4 fragColor;
varying vec3 fragPosition;

void main() {
  vec4 worldPosition  = model * vec4(position, 1.0);
  worldPosition       = (worldPosition / worldPosition.w) + vec4(capSize * offset, 0.0);
  gl_Position         = projection * (view * worldPosition);
  fragColor           = color;
  fragPosition        = position;
}`
                        ]), c = s([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3 clipBounds[2];
uniform float opacity;
varying vec3 fragPosition;
varying vec4 fragColor;

void main() {
  if (
    outOfRange(clipBounds[0], clipBounds[1], fragPosition) ||
    fragColor.a * opacity == 0.
  ) discard;

  gl_FragColor = opacity * fragColor;
}`
                        ]);
                        i.exports = function(f) {
                            return l(f, u, c, null, [
                                {
                                    name: "position",
                                    type: "vec3"
                                },
                                {
                                    name: "color",
                                    type: "vec4"
                                },
                                {
                                    name: "offset",
                                    type: "vec3"
                                }
                            ]);
                        };
                    },
                    2260: function(i, a, o) {
                        "use strict";
                        var s = o(7766);
                        i.exports = C;
                        var l = null, u, c, f, h;
                        function d(M) {
                            var g = M.getParameter(M.FRAMEBUFFER_BINDING), P = M.getParameter(M.RENDERBUFFER_BINDING), T = M.getParameter(M.TEXTURE_BINDING_2D);
                            return [
                                g,
                                P,
                                T
                            ];
                        }
                        function v(M, g) {
                            M.bindFramebuffer(M.FRAMEBUFFER, g[0]), M.bindRenderbuffer(M.RENDERBUFFER, g[1]), M.bindTexture(M.TEXTURE_2D, g[2]);
                        }
                        function x(M, g) {
                            var P = M.getParameter(g.MAX_COLOR_ATTACHMENTS_WEBGL);
                            l = new Array(P + 1);
                            for(var T = 0; T <= P; ++T){
                                for(var F = new Array(P), q = 0; q < T; ++q)F[q] = M.COLOR_ATTACHMENT0 + q;
                                for(var q = T; q < P; ++q)F[q] = M.NONE;
                                l[T] = F;
                            }
                        }
                        function b(M) {
                            switch(M){
                                case u:
                                    throw new Error("gl-fbo: Framebuffer unsupported");
                                case c:
                                    throw new Error("gl-fbo: Framebuffer incomplete attachment");
                                case f:
                                    throw new Error("gl-fbo: Framebuffer incomplete dimensions");
                                case h:
                                    throw new Error("gl-fbo: Framebuffer incomplete missing attachment");
                                default:
                                    throw new Error("gl-fbo: Framebuffer failed for unspecified reason");
                            }
                        }
                        function p(M, g, P, T, F, q) {
                            if (!T) return null;
                            var V = s(M, g, P, F, T);
                            return V.magFilter = M.NEAREST, V.minFilter = M.NEAREST, V.mipSamples = 1, V.bind(), M.framebufferTexture2D(M.FRAMEBUFFER, q, M.TEXTURE_2D, V.handle, 0), V;
                        }
                        function E(M, g, P, T, F) {
                            var q = M.createRenderbuffer();
                            return M.bindRenderbuffer(M.RENDERBUFFER, q), M.renderbufferStorage(M.RENDERBUFFER, T, g, P), M.framebufferRenderbuffer(M.FRAMEBUFFER, F, M.RENDERBUFFER, q), q;
                        }
                        function k(M) {
                            var g = d(M.gl), P = M.gl, T = M.handle = P.createFramebuffer(), F = M._shape[0], q = M._shape[1], V = M.color.length, H = M._ext, X = M._useStencil, G = M._useDepth, N = M._colorType;
                            P.bindFramebuffer(P.FRAMEBUFFER, T);
                            for(var W = 0; W < V; ++W)M.color[W] = p(P, F, q, N, P.RGBA, P.COLOR_ATTACHMENT0 + W);
                            V === 0 ? (M._color_rb = E(P, F, q, P.RGBA4, P.COLOR_ATTACHMENT0), H && H.drawBuffersWEBGL(l[0])) : V > 1 && H.drawBuffersWEBGL(l[V]);
                            var re = P.getExtension("WEBGL_depth_texture");
                            re ? X ? M.depth = p(P, F, q, re.UNSIGNED_INT_24_8_WEBGL, P.DEPTH_STENCIL, P.DEPTH_STENCIL_ATTACHMENT) : G && (M.depth = p(P, F, q, P.UNSIGNED_SHORT, P.DEPTH_COMPONENT, P.DEPTH_ATTACHMENT)) : G && X ? M._depth_rb = E(P, F, q, P.DEPTH_STENCIL, P.DEPTH_STENCIL_ATTACHMENT) : G ? M._depth_rb = E(P, F, q, P.DEPTH_COMPONENT16, P.DEPTH_ATTACHMENT) : X && (M._depth_rb = E(P, F, q, P.STENCIL_INDEX, P.STENCIL_ATTACHMENT));
                            var ae = P.checkFramebufferStatus(P.FRAMEBUFFER);
                            if (ae !== P.FRAMEBUFFER_COMPLETE) {
                                M._destroyed = !0, P.bindFramebuffer(P.FRAMEBUFFER, null), P.deleteFramebuffer(M.handle), M.handle = null, M.depth && (M.depth.dispose(), M.depth = null), M._depth_rb && (P.deleteRenderbuffer(M._depth_rb), M._depth_rb = null);
                                for(var W = 0; W < M.color.length; ++W)M.color[W].dispose(), M.color[W] = null;
                                M._color_rb && (P.deleteRenderbuffer(M._color_rb), M._color_rb = null), v(P, g), b(ae);
                            }
                            v(P, g);
                        }
                        function A(M, g, P, T, F, q, V, H) {
                            this.gl = M, this._shape = [
                                g | 0,
                                P | 0
                            ], this._destroyed = !1, this._ext = H, this.color = new Array(F);
                            for(var X = 0; X < F; ++X)this.color[X] = null;
                            this._color_rb = null, this.depth = null, this._depth_rb = null, this._colorType = T, this._useDepth = q, this._useStencil = V;
                            var G = this, N = [
                                g | 0,
                                P | 0
                            ];
                            Object.defineProperties(N, {
                                0: {
                                    get: function() {
                                        return G._shape[0];
                                    },
                                    set: function(W) {
                                        return G.width = W;
                                    }
                                },
                                1: {
                                    get: function() {
                                        return G._shape[1];
                                    },
                                    set: function(W) {
                                        return G.height = W;
                                    }
                                }
                            }), this._shapeVector = N, k(this);
                        }
                        var L = A.prototype;
                        function _(M, g, P) {
                            if (M._destroyed) throw new Error("gl-fbo: Can't resize destroyed FBO");
                            if (!(M._shape[0] === g && M._shape[1] === P)) {
                                var T = M.gl, F = T.getParameter(T.MAX_RENDERBUFFER_SIZE);
                                if (g < 0 || g > F || P < 0 || P > F) throw new Error("gl-fbo: Can't resize FBO, invalid dimensions");
                                M._shape[0] = g, M._shape[1] = P;
                                for(var q = d(T), V = 0; V < M.color.length; ++V)M.color[V].shape = M._shape;
                                M._color_rb && (T.bindRenderbuffer(T.RENDERBUFFER, M._color_rb), T.renderbufferStorage(T.RENDERBUFFER, T.RGBA4, M._shape[0], M._shape[1])), M.depth && (M.depth.shape = M._shape), M._depth_rb && (T.bindRenderbuffer(T.RENDERBUFFER, M._depth_rb), M._useDepth && M._useStencil ? T.renderbufferStorage(T.RENDERBUFFER, T.DEPTH_STENCIL, M._shape[0], M._shape[1]) : M._useDepth ? T.renderbufferStorage(T.RENDERBUFFER, T.DEPTH_COMPONENT16, M._shape[0], M._shape[1]) : M._useStencil && T.renderbufferStorage(T.RENDERBUFFER, T.STENCIL_INDEX, M._shape[0], M._shape[1])), T.bindFramebuffer(T.FRAMEBUFFER, M.handle);
                                var H = T.checkFramebufferStatus(T.FRAMEBUFFER);
                                H !== T.FRAMEBUFFER_COMPLETE && (M.dispose(), v(T, q), b(H)), v(T, q);
                            }
                        }
                        Object.defineProperties(L, {
                            shape: {
                                get: function() {
                                    return this._destroyed ? [
                                        0,
                                        0
                                    ] : this._shapeVector;
                                },
                                set: function(M) {
                                    if (Array.isArray(M) || (M = [
                                        M | 0,
                                        M | 0
                                    ]), M.length !== 2) throw new Error("gl-fbo: Shape vector must be length 2");
                                    var g = M[0] | 0, P = M[1] | 0;
                                    return _(this, g, P), [
                                        g,
                                        P
                                    ];
                                },
                                enumerable: !1
                            },
                            width: {
                                get: function() {
                                    return this._destroyed ? 0 : this._shape[0];
                                },
                                set: function(M) {
                                    return M = M | 0, _(this, M, this._shape[1]), M;
                                },
                                enumerable: !1
                            },
                            height: {
                                get: function() {
                                    return this._destroyed ? 0 : this._shape[1];
                                },
                                set: function(M) {
                                    return M = M | 0, _(this, this._shape[0], M), M;
                                },
                                enumerable: !1
                            }
                        }), L.bind = function() {
                            if (!this._destroyed) {
                                var M = this.gl;
                                M.bindFramebuffer(M.FRAMEBUFFER, this.handle), M.viewport(0, 0, this._shape[0], this._shape[1]);
                            }
                        }, L.dispose = function() {
                            if (!this._destroyed) {
                                this._destroyed = !0;
                                var M = this.gl;
                                M.deleteFramebuffer(this.handle), this.handle = null, this.depth && (this.depth.dispose(), this.depth = null), this._depth_rb && (M.deleteRenderbuffer(this._depth_rb), this._depth_rb = null);
                                for(var g = 0; g < this.color.length; ++g)this.color[g].dispose(), this.color[g] = null;
                                this._color_rb && (M.deleteRenderbuffer(this._color_rb), this._color_rb = null);
                            }
                        };
                        function C(M, g, P, T) {
                            u || (u = M.FRAMEBUFFER_UNSUPPORTED, c = M.FRAMEBUFFER_INCOMPLETE_ATTACHMENT, f = M.FRAMEBUFFER_INCOMPLETE_DIMENSIONS, h = M.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT);
                            var F = M.getExtension("WEBGL_draw_buffers");
                            if (!l && F && x(M, F), Array.isArray(g) && (T = P, P = g[1] | 0, g = g[0] | 0), typeof g != "number") throw new Error("gl-fbo: Missing shape parameter");
                            var q = M.getParameter(M.MAX_RENDERBUFFER_SIZE);
                            if (g < 0 || g > q || P < 0 || P > q) throw new Error("gl-fbo: Parameters are too large for FBO");
                            T = T || {};
                            var V = 1;
                            if ("color" in T) {
                                if (V = Math.max(T.color | 0, 0), V < 0) throw new Error("gl-fbo: Must specify a nonnegative number of colors");
                                if (V > 1) {
                                    if (F) {
                                        if (V > M.getParameter(F.MAX_COLOR_ATTACHMENTS_WEBGL)) throw new Error("gl-fbo: Context does not support " + V + " draw buffers");
                                    } else throw new Error("gl-fbo: Multiple draw buffer extension not supported");
                                }
                            }
                            var H = M.UNSIGNED_BYTE, X = M.getExtension("OES_texture_float");
                            if (T.float && V > 0) {
                                if (!X) throw new Error("gl-fbo: Context does not support floating point textures");
                                H = M.FLOAT;
                            } else T.preferFloat && V > 0 && X && (H = M.FLOAT);
                            var G = !0;
                            "depth" in T && (G = !!T.depth);
                            var N = !1;
                            return "stencil" in T && (N = !!T.stencil), new A(M, g, P, H, V, G, N, F);
                        }
                    },
                    2992: function(i, a, o) {
                        var s = o(3387).sprintf, l = o(5171), u = o(1848), c = o(1085);
                        i.exports = f;
                        function f(h, d, v) {
                            "use strict";
                            var x = u(d) || "of unknown name (see npm glsl-shader-name)", b = "unknown type";
                            v !== void 0 && (b = v === l.FRAGMENT_SHADER ? "fragment" : "vertex");
                            for(var p = s(`Error compiling %s shader %s:
`, b, x), E = s("%s%s", p, h), k = h.split(`
`), A = {}, L = 0; L < k.length; L++){
                                var _ = k[L];
                                if (!(_ === "" || _ === "\0")) {
                                    var C = parseInt(_.split(":")[2]);
                                    if (isNaN(C)) throw new Error(s("Could not parse error: %s", _));
                                    A[C] = _;
                                }
                            }
                            for(var M = c(d).split(`
`), L = 0; L < M.length; L++)if (!(!A[L + 3] && !A[L + 2] && !A[L + 1])) {
                                var g = M[L];
                                if (p += g + `
`, A[L + 1]) {
                                    var P = A[L + 1];
                                    P = P.substr(P.split(":", 3).join(":").length + 1).trim(), p += s(`^^^ %s

`, P);
                                }
                            }
                            return {
                                long: p.trim(),
                                short: E.trim()
                            };
                        }
                    },
                    7319: function(i, a, o) {
                        var s = o(3236), l = o(9405), u = s([
                            `precision highp float;
#define GLSLIFY 1

attribute vec3 position, nextPosition;
attribute float arcLength, lineWidth;
attribute vec4 color;

uniform vec2 screenShape;
uniform float pixelRatio;
uniform mat4 model, view, projection;

varying vec4 fragColor;
varying vec3 worldPosition;
varying float pixelArcLength;

vec4 project(vec3 p) {
  return projection * (view * (model * vec4(p, 1.0)));
}

void main() {
  vec4 startPoint = project(position);
  vec4 endPoint   = project(nextPosition);

  vec2 A = startPoint.xy / startPoint.w;
  vec2 B =   endPoint.xy /   endPoint.w;

  float clipAngle = atan(
    (B.y - A.y) * screenShape.y,
    (B.x - A.x) * screenShape.x
  );

  vec2 offset = 0.5 * pixelRatio * lineWidth * vec2(
    sin(clipAngle),
    -cos(clipAngle)
  ) / screenShape;

  gl_Position = vec4(startPoint.xy + startPoint.w * offset, startPoint.zw);

  worldPosition = position;
  pixelArcLength = arcLength;
  fragColor = color;
}
`
                        ]), c = s([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3      clipBounds[2];
uniform sampler2D dashTexture;
uniform float     dashScale;
uniform float     opacity;

varying vec3    worldPosition;
varying float   pixelArcLength;
varying vec4    fragColor;

void main() {
  if (
    outOfRange(clipBounds[0], clipBounds[1], worldPosition) ||
    fragColor.a * opacity == 0.
  ) discard;

  float dashWeight = texture2D(dashTexture, vec2(dashScale * pixelArcLength, 0)).r;
  if(dashWeight < 0.5) {
    discard;
  }
  gl_FragColor = fragColor * opacity;
}
`
                        ]), f = s([
                            `precision highp float;
#define GLSLIFY 1

#define FLOAT_MAX  1.70141184e38
#define FLOAT_MIN  1.17549435e-38

// https://github.com/mikolalysenko/glsl-read-float/blob/master/index.glsl
vec4 packFloat(float v) {
  float av = abs(v);

  //Handle special cases
  if(av < FLOAT_MIN) {
    return vec4(0.0, 0.0, 0.0, 0.0);
  } else if(v > FLOAT_MAX) {
    return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;
  } else if(v < -FLOAT_MAX) {
    return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;
  }

  vec4 c = vec4(0,0,0,0);

  //Compute exponent and mantissa
  float e = floor(log2(av));
  float m = av * pow(2.0, -e) - 1.0;

  //Unpack mantissa
  c[1] = floor(128.0 * m);
  m -= c[1] / 128.0;
  c[2] = floor(32768.0 * m);
  m -= c[2] / 32768.0;
  c[3] = floor(8388608.0 * m);

  //Unpack exponent
  float ebias = e + 127.0;
  c[0] = floor(ebias / 2.0);
  ebias -= c[0] * 2.0;
  c[1] += floor(ebias) * 128.0;

  //Unpack sign bit
  c[0] += 128.0 * step(0.0, -v);

  //Scale back to range
  return c / 255.0;
}

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform float pickId;
uniform vec3 clipBounds[2];

varying vec3 worldPosition;
varying float pixelArcLength;
varying vec4 fragColor;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], worldPosition)) discard;

  gl_FragColor = vec4(pickId/255.0, packFloat(pixelArcLength).xyz);
}`
                        ]), h = [
                            {
                                name: "position",
                                type: "vec3"
                            },
                            {
                                name: "nextPosition",
                                type: "vec3"
                            },
                            {
                                name: "arcLength",
                                type: "float"
                            },
                            {
                                name: "lineWidth",
                                type: "float"
                            },
                            {
                                name: "color",
                                type: "vec4"
                            }
                        ];
                        a.createShader = function(d) {
                            return l(d, u, c, null, h);
                        }, a.createPickShader = function(d) {
                            return l(d, u, f, null, h);
                        };
                    },
                    5714: function(i, a, o) {
                        "use strict";
                        i.exports = M;
                        var s = o(2762), l = o(8116), u = o(7766), c = new Uint8Array(4), f = new Float32Array(c.buffer);
                        function h(g, P, T, F) {
                            return c[0] = F, c[1] = T, c[2] = P, c[3] = g, f[0];
                        }
                        var d = o(2478), v = o(9618), x = o(7319), b = x.createShader, p = x.createPickShader, E = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ];
                        function k(g, P) {
                            for(var T = 0, F = 0; F < 3; ++F){
                                var q = g[F] - P[F];
                                T += q * q;
                            }
                            return Math.sqrt(T);
                        }
                        function A(g) {
                            for(var P = [
                                [
                                    -1000000,
                                    -1000000,
                                    -1000000
                                ],
                                [
                                    1e6,
                                    1e6,
                                    1e6
                                ]
                            ], T = 0; T < 3; ++T)P[0][T] = Math.max(g[0][T], P[0][T]), P[1][T] = Math.min(g[1][T], P[1][T]);
                            return P;
                        }
                        function L(g, P, T, F) {
                            this.arcLength = g, this.position = P, this.index = T, this.dataCoordinate = F;
                        }
                        function _(g, P, T, F, q, V) {
                            this.gl = g, this.shader = P, this.pickShader = T, this.buffer = F, this.vao = q, this.clipBounds = [
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ],
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ]
                            ], this.points = [], this.arcLength = [], this.vertexCount = 0, this.bounds = [
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ]
                            ], this.pickId = 0, this.lineWidth = 1, this.texture = V, this.dashScale = 1, this.opacity = 1, this.hasAlpha = !1, this.dirty = !0, this.pixelRatio = 1;
                        }
                        var C = _.prototype;
                        C.isTransparent = function() {
                            return this.hasAlpha;
                        }, C.isOpaque = function() {
                            return !this.hasAlpha;
                        }, C.pickSlots = 1, C.setPickBase = function(g) {
                            this.pickId = g;
                        }, C.drawTransparent = C.draw = function(g) {
                            if (this.vertexCount) {
                                var P = this.gl, T = this.shader, F = this.vao;
                                T.bind(), T.uniforms = {
                                    model: g.model || E,
                                    view: g.view || E,
                                    projection: g.projection || E,
                                    clipBounds: A(this.clipBounds),
                                    dashTexture: this.texture.bind(),
                                    dashScale: this.dashScale / this.arcLength[this.arcLength.length - 1],
                                    opacity: this.opacity,
                                    screenShape: [
                                        P.drawingBufferWidth,
                                        P.drawingBufferHeight
                                    ],
                                    pixelRatio: this.pixelRatio
                                }, F.bind(), F.draw(P.TRIANGLE_STRIP, this.vertexCount), F.unbind();
                            }
                        }, C.drawPick = function(g) {
                            if (this.vertexCount) {
                                var P = this.gl, T = this.pickShader, F = this.vao;
                                T.bind(), T.uniforms = {
                                    model: g.model || E,
                                    view: g.view || E,
                                    projection: g.projection || E,
                                    pickId: this.pickId,
                                    clipBounds: A(this.clipBounds),
                                    screenShape: [
                                        P.drawingBufferWidth,
                                        P.drawingBufferHeight
                                    ],
                                    pixelRatio: this.pixelRatio
                                }, F.bind(), F.draw(P.TRIANGLE_STRIP, this.vertexCount), F.unbind();
                            }
                        }, C.update = function(g) {
                            var P, T;
                            this.dirty = !0;
                            var F = !!g.connectGaps;
                            "dashScale" in g && (this.dashScale = g.dashScale), this.hasAlpha = !1, "opacity" in g && (this.opacity = +g.opacity, this.opacity < 1 && (this.hasAlpha = !0));
                            var q = [], V = [], H = [], X = 0, G = 0, N = [
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ],
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ]
                            ], W = g.position || g.positions;
                            if (W) {
                                var re = g.color || g.colors || [
                                    0,
                                    0,
                                    0,
                                    1
                                ], ae = g.lineWidth || 1, _e = !1;
                                e: for(P = 1; P < W.length; ++P){
                                    var Me = W[P - 1], ke = W[P];
                                    for(V.push(X), H.push(Me.slice()), T = 0; T < 3; ++T){
                                        if (isNaN(Me[T]) || isNaN(ke[T]) || !isFinite(Me[T]) || !isFinite(ke[T])) {
                                            if (!F && q.length > 0) {
                                                for(var ge = 0; ge < 24; ++ge)q.push(q[q.length - 12]);
                                                G += 2, _e = !0;
                                            }
                                            continue e;
                                        }
                                        N[0][T] = Math.min(N[0][T], Me[T], ke[T]), N[1][T] = Math.max(N[1][T], Me[T], ke[T]);
                                    }
                                    var ie, Te;
                                    Array.isArray(re[0]) ? (ie = re.length > P - 1 ? re[P - 1] : re.length > 0 ? re[re.length - 1] : [
                                        0,
                                        0,
                                        0,
                                        1
                                    ], Te = re.length > P ? re[P] : re.length > 0 ? re[re.length - 1] : [
                                        0,
                                        0,
                                        0,
                                        1
                                    ]) : ie = Te = re, ie.length === 3 && (ie = [
                                        ie[0],
                                        ie[1],
                                        ie[2],
                                        1
                                    ]), Te.length === 3 && (Te = [
                                        Te[0],
                                        Te[1],
                                        Te[2],
                                        1
                                    ]), !this.hasAlpha && ie[3] < 1 && (this.hasAlpha = !0);
                                    var Ee;
                                    Array.isArray(ae) ? Ee = ae.length > P - 1 ? ae[P - 1] : ae.length > 0 ? ae[ae.length - 1] : [
                                        0,
                                        0,
                                        0,
                                        1
                                    ] : Ee = ae;
                                    var Ae = X;
                                    if (X += k(Me, ke), _e) {
                                        for(T = 0; T < 2; ++T)q.push(Me[0], Me[1], Me[2], ke[0], ke[1], ke[2], Ae, Ee, ie[0], ie[1], ie[2], ie[3]);
                                        G += 2, _e = !1;
                                    }
                                    q.push(Me[0], Me[1], Me[2], ke[0], ke[1], ke[2], Ae, Ee, ie[0], ie[1], ie[2], ie[3], Me[0], Me[1], Me[2], ke[0], ke[1], ke[2], Ae, -Ee, ie[0], ie[1], ie[2], ie[3], ke[0], ke[1], ke[2], Me[0], Me[1], Me[2], X, -Ee, Te[0], Te[1], Te[2], Te[3], ke[0], ke[1], ke[2], Me[0], Me[1], Me[2], X, Ee, Te[0], Te[1], Te[2], Te[3]), G += 4;
                                }
                            }
                            if (this.buffer.update(q), V.push(X), H.push(W[W.length - 1].slice()), this.bounds = N, this.vertexCount = G, this.points = H, this.arcLength = V, "dashes" in g) {
                                var ze = g.dashes, Ce = ze.slice();
                                for(Ce.unshift(0), P = 1; P < Ce.length; ++P)Ce[P] = Ce[P - 1] + Ce[P];
                                var me = v(new Array(1024), [
                                    256,
                                    1,
                                    4
                                ]);
                                for(P = 0; P < 256; ++P){
                                    for(T = 0; T < 4; ++T)me.set(P, 0, T, 0);
                                    d.le(Ce, Ce[Ce.length - 1] * P / 255) & 1 ? me.set(P, 0, 0, 0) : me.set(P, 0, 0, 255);
                                }
                                this.texture.setPixels(me);
                            }
                        }, C.dispose = function() {
                            this.shader.dispose(), this.vao.dispose(), this.buffer.dispose();
                        }, C.pick = function(g) {
                            if (!g || g.id !== this.pickId) return null;
                            var P = h(g.value[0], g.value[1], g.value[2], 0), T = d.le(this.arcLength, P);
                            if (T < 0) return null;
                            if (T === this.arcLength.length - 1) return new L(this.arcLength[this.arcLength.length - 1], this.points[this.points.length - 1].slice(), T);
                            for(var F = this.points[T], q = this.points[Math.min(T + 1, this.points.length - 1)], V = (P - this.arcLength[T]) / (this.arcLength[T + 1] - this.arcLength[T]), H = 1 - V, X = [
                                0,
                                0,
                                0
                            ], G = 0; G < 3; ++G)X[G] = H * F[G] + V * q[G];
                            var N = Math.min(V < .5 ? T : T + 1, this.points.length - 1);
                            return new L(P, X, N, this.points[N]);
                        };
                        function M(g) {
                            var P = g.gl || g.scene && g.scene.gl, T = b(P);
                            T.attributes.position.location = 0, T.attributes.nextPosition.location = 1, T.attributes.arcLength.location = 2, T.attributes.lineWidth.location = 3, T.attributes.color.location = 4;
                            var F = p(P);
                            F.attributes.position.location = 0, F.attributes.nextPosition.location = 1, F.attributes.arcLength.location = 2, F.attributes.lineWidth.location = 3, F.attributes.color.location = 4;
                            for(var q = s(P), V = l(P, [
                                {
                                    buffer: q,
                                    size: 3,
                                    offset: 0,
                                    stride: 48
                                },
                                {
                                    buffer: q,
                                    size: 3,
                                    offset: 12,
                                    stride: 48
                                },
                                {
                                    buffer: q,
                                    size: 1,
                                    offset: 24,
                                    stride: 48
                                },
                                {
                                    buffer: q,
                                    size: 1,
                                    offset: 28,
                                    stride: 48
                                },
                                {
                                    buffer: q,
                                    size: 4,
                                    offset: 32,
                                    stride: 48
                                }
                            ]), H = v(new Array(1024), [
                                256,
                                1,
                                4
                            ]), X = 0; X < 1024; ++X)H.data[X] = 255;
                            var G = u(P, H);
                            G.wrap = P.REPEAT;
                            var N = new _(P, T, F, q, V, G);
                            return N.update(g), N;
                        }
                    },
                    1903: function(i) {
                        i.exports = a;
                        function a(o) {
                            var s = new Float32Array(16);
                            return s[0] = o[0], s[1] = o[1], s[2] = o[2], s[3] = o[3], s[4] = o[4], s[5] = o[5], s[6] = o[6], s[7] = o[7], s[8] = o[8], s[9] = o[9], s[10] = o[10], s[11] = o[11], s[12] = o[12], s[13] = o[13], s[14] = o[14], s[15] = o[15], s;
                        }
                    },
                    6864: function(i) {
                        i.exports = a;
                        function a() {
                            var o = new Float32Array(16);
                            return o[0] = 1, o[1] = 0, o[2] = 0, o[3] = 0, o[4] = 0, o[5] = 1, o[6] = 0, o[7] = 0, o[8] = 0, o[9] = 0, o[10] = 1, o[11] = 0, o[12] = 0, o[13] = 0, o[14] = 0, o[15] = 1, o;
                        }
                    },
                    9921: function(i) {
                        i.exports = a;
                        function a(o) {
                            var s = o[0], l = o[1], u = o[2], c = o[3], f = o[4], h = o[5], d = o[6], v = o[7], x = o[8], b = o[9], p = o[10], E = o[11], k = o[12], A = o[13], L = o[14], _ = o[15], C = s * h - l * f, M = s * d - u * f, g = s * v - c * f, P = l * d - u * h, T = l * v - c * h, F = u * v - c * d, q = x * A - b * k, V = x * L - p * k, H = x * _ - E * k, X = b * L - p * A, G = b * _ - E * A, N = p * _ - E * L;
                            return C * N - M * G + g * X + P * H - T * V + F * q;
                        }
                    },
                    7399: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            var l = s[0], u = s[1], c = s[2], f = s[3], h = l + l, d = u + u, v = c + c, x = l * h, b = u * h, p = u * d, E = c * h, k = c * d, A = c * v, L = f * h, _ = f * d, C = f * v;
                            return o[0] = 1 - p - A, o[1] = b + C, o[2] = E - _, o[3] = 0, o[4] = b - C, o[5] = 1 - x - A, o[6] = k + L, o[7] = 0, o[8] = E + _, o[9] = k - L, o[10] = 1 - x - p, o[11] = 0, o[12] = 0, o[13] = 0, o[14] = 0, o[15] = 1, o;
                        }
                    },
                    6743: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = s[0], c = s[1], f = s[2], h = s[3], d = u + u, v = c + c, x = f + f, b = u * d, p = u * v, E = u * x, k = c * v, A = c * x, L = f * x, _ = h * d, C = h * v, M = h * x;
                            return o[0] = 1 - (k + L), o[1] = p + M, o[2] = E - C, o[3] = 0, o[4] = p - M, o[5] = 1 - (b + L), o[6] = A + _, o[7] = 0, o[8] = E + C, o[9] = A - _, o[10] = 1 - (b + k), o[11] = 0, o[12] = l[0], o[13] = l[1], o[14] = l[2], o[15] = 1, o;
                        }
                    },
                    7894: function(i) {
                        i.exports = a;
                        function a(o) {
                            return o[0] = 1, o[1] = 0, o[2] = 0, o[3] = 0, o[4] = 0, o[5] = 1, o[6] = 0, o[7] = 0, o[8] = 0, o[9] = 0, o[10] = 1, o[11] = 0, o[12] = 0, o[13] = 0, o[14] = 0, o[15] = 1, o;
                        }
                    },
                    7608: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            var l = s[0], u = s[1], c = s[2], f = s[3], h = s[4], d = s[5], v = s[6], x = s[7], b = s[8], p = s[9], E = s[10], k = s[11], A = s[12], L = s[13], _ = s[14], C = s[15], M = l * d - u * h, g = l * v - c * h, P = l * x - f * h, T = u * v - c * d, F = u * x - f * d, q = c * x - f * v, V = b * L - p * A, H = b * _ - E * A, X = b * C - k * A, G = p * _ - E * L, N = p * C - k * L, W = E * C - k * _, re = M * W - g * N + P * G + T * X - F * H + q * V;
                            return re ? (re = 1 / re, o[0] = (d * W - v * N + x * G) * re, o[1] = (c * N - u * W - f * G) * re, o[2] = (L * q - _ * F + C * T) * re, o[3] = (E * F - p * q - k * T) * re, o[4] = (v * X - h * W - x * H) * re, o[5] = (l * W - c * X + f * H) * re, o[6] = (_ * P - A * q - C * g) * re, o[7] = (b * q - E * P + k * g) * re, o[8] = (h * N - d * X + x * V) * re, o[9] = (u * X - l * N - f * V) * re, o[10] = (A * F - L * P + C * M) * re, o[11] = (p * P - b * F - k * M) * re, o[12] = (d * H - h * G - v * V) * re, o[13] = (l * G - u * H + c * V) * re, o[14] = (L * g - A * T - _ * M) * re, o[15] = (b * T - p * g + E * M) * re, o) : null;
                        }
                    },
                    6582: function(i, a, o) {
                        var s = o(7894);
                        i.exports = l;
                        function l(u, c, f, h) {
                            var d, v, x, b, p, E, k, A, L, _, C = c[0], M = c[1], g = c[2], P = h[0], T = h[1], F = h[2], q = f[0], V = f[1], H = f[2];
                            return Math.abs(C - q) < 1e-6 && Math.abs(M - V) < 1e-6 && Math.abs(g - H) < 1e-6 ? s(u) : (k = C - q, A = M - V, L = g - H, _ = 1 / Math.sqrt(k * k + A * A + L * L), k *= _, A *= _, L *= _, d = T * L - F * A, v = F * k - P * L, x = P * A - T * k, _ = Math.sqrt(d * d + v * v + x * x), _ ? (_ = 1 / _, d *= _, v *= _, x *= _) : (d = 0, v = 0, x = 0), b = A * x - L * v, p = L * d - k * x, E = k * v - A * d, _ = Math.sqrt(b * b + p * p + E * E), _ ? (_ = 1 / _, b *= _, p *= _, E *= _) : (b = 0, p = 0, E = 0), u[0] = d, u[1] = b, u[2] = k, u[3] = 0, u[4] = v, u[5] = p, u[6] = A, u[7] = 0, u[8] = x, u[9] = E, u[10] = L, u[11] = 0, u[12] = -(d * C + v * M + x * g), u[13] = -(b * C + p * M + E * g), u[14] = -(k * C + A * M + L * g), u[15] = 1, u);
                        }
                    },
                    6760: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = s[0], c = s[1], f = s[2], h = s[3], d = s[4], v = s[5], x = s[6], b = s[7], p = s[8], E = s[9], k = s[10], A = s[11], L = s[12], _ = s[13], C = s[14], M = s[15], g = l[0], P = l[1], T = l[2], F = l[3];
                            return o[0] = g * u + P * d + T * p + F * L, o[1] = g * c + P * v + T * E + F * _, o[2] = g * f + P * x + T * k + F * C, o[3] = g * h + P * b + T * A + F * M, g = l[4], P = l[5], T = l[6], F = l[7], o[4] = g * u + P * d + T * p + F * L, o[5] = g * c + P * v + T * E + F * _, o[6] = g * f + P * x + T * k + F * C, o[7] = g * h + P * b + T * A + F * M, g = l[8], P = l[9], T = l[10], F = l[11], o[8] = g * u + P * d + T * p + F * L, o[9] = g * c + P * v + T * E + F * _, o[10] = g * f + P * x + T * k + F * C, o[11] = g * h + P * b + T * A + F * M, g = l[12], P = l[13], T = l[14], F = l[15], o[12] = g * u + P * d + T * p + F * L, o[13] = g * c + P * v + T * E + F * _, o[14] = g * f + P * x + T * k + F * C, o[15] = g * h + P * b + T * A + F * M, o;
                        }
                    },
                    4040: function(i) {
                        i.exports = a;
                        function a(o, s, l, u, c, f, h) {
                            var d = 1 / (s - l), v = 1 / (u - c), x = 1 / (f - h);
                            return o[0] = -2 * d, o[1] = 0, o[2] = 0, o[3] = 0, o[4] = 0, o[5] = -2 * v, o[6] = 0, o[7] = 0, o[8] = 0, o[9] = 0, o[10] = 2 * x, o[11] = 0, o[12] = (s + l) * d, o[13] = (c + u) * v, o[14] = (h + f) * x, o[15] = 1, o;
                        }
                    },
                    4772: function(i) {
                        i.exports = a;
                        function a(o, s, l, u, c) {
                            var f = 1 / Math.tan(s / 2), h = 1 / (u - c);
                            return o[0] = f / l, o[1] = 0, o[2] = 0, o[3] = 0, o[4] = 0, o[5] = f, o[6] = 0, o[7] = 0, o[8] = 0, o[9] = 0, o[10] = (c + u) * h, o[11] = -1, o[12] = 0, o[13] = 0, o[14] = 2 * c * u * h, o[15] = 0, o;
                        }
                    },
                    6079: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            var c = u[0], f = u[1], h = u[2], d = Math.sqrt(c * c + f * f + h * h), v, x, b, p, E, k, A, L, _, C, M, g, P, T, F, q, V, H, X, G, N, W, re, ae;
                            return Math.abs(d) < 1e-6 ? null : (d = 1 / d, c *= d, f *= d, h *= d, v = Math.sin(l), x = Math.cos(l), b = 1 - x, p = s[0], E = s[1], k = s[2], A = s[3], L = s[4], _ = s[5], C = s[6], M = s[7], g = s[8], P = s[9], T = s[10], F = s[11], q = c * c * b + x, V = f * c * b + h * v, H = h * c * b - f * v, X = c * f * b - h * v, G = f * f * b + x, N = h * f * b + c * v, W = c * h * b + f * v, re = f * h * b - c * v, ae = h * h * b + x, o[0] = p * q + L * V + g * H, o[1] = E * q + _ * V + P * H, o[2] = k * q + C * V + T * H, o[3] = A * q + M * V + F * H, o[4] = p * X + L * G + g * N, o[5] = E * X + _ * G + P * N, o[6] = k * X + C * G + T * N, o[7] = A * X + M * G + F * N, o[8] = p * W + L * re + g * ae, o[9] = E * W + _ * re + P * ae, o[10] = k * W + C * re + T * ae, o[11] = A * W + M * re + F * ae, s !== o && (o[12] = s[12], o[13] = s[13], o[14] = s[14], o[15] = s[15]), o);
                        }
                    },
                    5567: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = Math.sin(l), c = Math.cos(l), f = s[4], h = s[5], d = s[6], v = s[7], x = s[8], b = s[9], p = s[10], E = s[11];
                            return s !== o && (o[0] = s[0], o[1] = s[1], o[2] = s[2], o[3] = s[3], o[12] = s[12], o[13] = s[13], o[14] = s[14], o[15] = s[15]), o[4] = f * c + x * u, o[5] = h * c + b * u, o[6] = d * c + p * u, o[7] = v * c + E * u, o[8] = x * c - f * u, o[9] = b * c - h * u, o[10] = p * c - d * u, o[11] = E * c - v * u, o;
                        }
                    },
                    2408: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = Math.sin(l), c = Math.cos(l), f = s[0], h = s[1], d = s[2], v = s[3], x = s[8], b = s[9], p = s[10], E = s[11];
                            return s !== o && (o[4] = s[4], o[5] = s[5], o[6] = s[6], o[7] = s[7], o[12] = s[12], o[13] = s[13], o[14] = s[14], o[15] = s[15]), o[0] = f * c - x * u, o[1] = h * c - b * u, o[2] = d * c - p * u, o[3] = v * c - E * u, o[8] = f * u + x * c, o[9] = h * u + b * c, o[10] = d * u + p * c, o[11] = v * u + E * c, o;
                        }
                    },
                    7089: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = Math.sin(l), c = Math.cos(l), f = s[0], h = s[1], d = s[2], v = s[3], x = s[4], b = s[5], p = s[6], E = s[7];
                            return s !== o && (o[8] = s[8], o[9] = s[9], o[10] = s[10], o[11] = s[11], o[12] = s[12], o[13] = s[13], o[14] = s[14], o[15] = s[15]), o[0] = f * c + x * u, o[1] = h * c + b * u, o[2] = d * c + p * u, o[3] = v * c + E * u, o[4] = x * c - f * u, o[5] = b * c - h * u, o[6] = p * c - d * u, o[7] = E * c - v * u, o;
                        }
                    },
                    2504: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = l[0], c = l[1], f = l[2];
                            return o[0] = s[0] * u, o[1] = s[1] * u, o[2] = s[2] * u, o[3] = s[3] * u, o[4] = s[4] * c, o[5] = s[5] * c, o[6] = s[6] * c, o[7] = s[7] * c, o[8] = s[8] * f, o[9] = s[9] * f, o[10] = s[10] * f, o[11] = s[11] * f, o[12] = s[12], o[13] = s[13], o[14] = s[14], o[15] = s[15], o;
                        }
                    },
                    7656: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = l[0], c = l[1], f = l[2], h, d, v, x, b, p, E, k, A, L, _, C;
                            return s === o ? (o[12] = s[0] * u + s[4] * c + s[8] * f + s[12], o[13] = s[1] * u + s[5] * c + s[9] * f + s[13], o[14] = s[2] * u + s[6] * c + s[10] * f + s[14], o[15] = s[3] * u + s[7] * c + s[11] * f + s[15]) : (h = s[0], d = s[1], v = s[2], x = s[3], b = s[4], p = s[5], E = s[6], k = s[7], A = s[8], L = s[9], _ = s[10], C = s[11], o[0] = h, o[1] = d, o[2] = v, o[3] = x, o[4] = b, o[5] = p, o[6] = E, o[7] = k, o[8] = A, o[9] = L, o[10] = _, o[11] = C, o[12] = h * u + b * c + A * f + s[12], o[13] = d * u + p * c + L * f + s[13], o[14] = v * u + E * c + _ * f + s[14], o[15] = x * u + k * c + C * f + s[15]), o;
                        }
                    },
                    5665: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            if (o === s) {
                                var l = s[1], u = s[2], c = s[3], f = s[6], h = s[7], d = s[11];
                                o[1] = s[4], o[2] = s[8], o[3] = s[12], o[4] = l, o[6] = s[9], o[7] = s[13], o[8] = u, o[9] = f, o[11] = s[14], o[12] = c, o[13] = h, o[14] = d;
                            } else o[0] = s[0], o[1] = s[4], o[2] = s[8], o[3] = s[12], o[4] = s[1], o[5] = s[5], o[6] = s[9], o[7] = s[13], o[8] = s[2], o[9] = s[6], o[10] = s[10], o[11] = s[14], o[12] = s[3], o[13] = s[7], o[14] = s[11], o[15] = s[15];
                            return o;
                        }
                    },
                    7626: function(i, a, o) {
                        "use strict";
                        var s = o(2642), l = o(9346);
                        i.exports = d;
                        function u(v, x) {
                            for(var b = [
                                0,
                                0,
                                0,
                                0
                            ], p = 0; p < 4; ++p)for(var E = 0; E < 4; ++E)b[E] += v[4 * p + E] * x[p];
                            return b;
                        }
                        function c(v, x, b, p, E) {
                            for(var k = u(p, u(b, u(x, [
                                v[0],
                                v[1],
                                v[2],
                                1
                            ]))), A = 0; A < 3; ++A)k[A] /= k[3];
                            return [
                                .5 * E[0] * (1 + k[0]),
                                .5 * E[1] * (1 - k[1])
                            ];
                        }
                        function f(v, x) {
                            if (v.length === 2) {
                                for(var b = 0, p = 0, E = 0; E < 2; ++E)b += Math.pow(x[E] - v[0][E], 2), p += Math.pow(x[E] - v[1][E], 2);
                                return b = Math.sqrt(b), p = Math.sqrt(p), b + p < 1e-6 ? [
                                    1,
                                    0
                                ] : [
                                    p / (b + p),
                                    b / (p + b)
                                ];
                            } else if (v.length === 3) {
                                var k = [
                                    0,
                                    0
                                ];
                                return l(v[0], v[1], v[2], x, k), s(v, k);
                            }
                            return [];
                        }
                        function h(v, x) {
                            for(var b = [
                                0,
                                0,
                                0
                            ], p = 0; p < v.length; ++p)for(var E = v[p], k = x[p], A = 0; A < 3; ++A)b[A] += k * E[A];
                            return b;
                        }
                        function d(v, x, b, p, E, k) {
                            if (v.length === 1) return [
                                0,
                                v[0].slice()
                            ];
                            for(var A = new Array(v.length), L = 0; L < v.length; ++L)A[L] = c(v[L], b, p, E, k);
                            for(var _ = 0, C = 1 / 0, L = 0; L < A.length; ++L){
                                for(var M = 0, g = 0; g < 2; ++g)M += Math.pow(A[L][g] - x[g], 2);
                                M < C && (C = M, _ = L);
                            }
                            for(var P = f(A, x), T = 0, L = 0; L < 3; ++L){
                                if (P[L] < -0.001 || P[L] > 1.0001) return null;
                                T += P[L];
                            }
                            return Math.abs(T - 1) > .001 ? null : [
                                _,
                                h(v, P),
                                P
                            ];
                        }
                    },
                    840: function(i, a, o) {
                        var s = o(3236), l = s([
                            `precision highp float;
#define GLSLIFY 1

attribute vec3 position, normal;
attribute vec4 color;
attribute vec2 uv;

uniform mat4 model
           , view
           , projection
           , inverseModel;
uniform vec3 eyePosition
           , lightPosition;

varying vec3 f_normal
           , f_lightDirection
           , f_eyeDirection
           , f_data;
varying vec4 f_color;
varying vec2 f_uv;

vec4 project(vec3 p) {
  return projection * (view * (model * vec4(p, 1.0)));
}

void main() {
  gl_Position      = project(position);

  //Lighting geometry parameters
  vec4 cameraCoordinate = view * vec4(position , 1.0);
  cameraCoordinate.xyz /= cameraCoordinate.w;
  f_lightDirection = lightPosition - cameraCoordinate.xyz;
  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;
  f_normal  = normalize((vec4(normal, 0.0) * inverseModel).xyz);

  f_color          = color;
  f_data           = position;
  f_uv             = uv;
}
`
                        ]), u = s([
                            `#extension GL_OES_standard_derivatives : enable

precision highp float;
#define GLSLIFY 1

float beckmannDistribution(float x, float roughness) {
  float NdotH = max(x, 0.0001);
  float cos2Alpha = NdotH * NdotH;
  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;
  float roughness2 = roughness * roughness;
  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;
  return exp(tan2Alpha / roughness2) / denom;
}

float cookTorranceSpecular(
  vec3 lightDirection,
  vec3 viewDirection,
  vec3 surfaceNormal,
  float roughness,
  float fresnel) {

  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);
  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);

  //Half angle vector
  vec3 H = normalize(lightDirection + viewDirection);

  //Geometric term
  float NdotH = max(dot(surfaceNormal, H), 0.0);
  float VdotH = max(dot(viewDirection, H), 0.000001);
  float LdotH = max(dot(lightDirection, H), 0.000001);
  float G1 = (2.0 * NdotH * VdotN) / VdotH;
  float G2 = (2.0 * NdotH * LdotN) / LdotH;
  float G = min(1.0, min(G1, G2));
  
  //Distribution term
  float D = beckmannDistribution(NdotH, roughness);

  //Fresnel term
  float F = pow(1.0 - VdotN, fresnel);

  //Multiply terms and done
  return  G * F * D / max(3.14159265 * VdotN, 0.000001);
}

//#pragma glslify: beckmann = require(glsl-specular-beckmann) // used in gl-surface3d

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3 clipBounds[2];
uniform float roughness
            , fresnel
            , kambient
            , kdiffuse
            , kspecular;
uniform sampler2D texture;

varying vec3 f_normal
           , f_lightDirection
           , f_eyeDirection
           , f_data;
varying vec4 f_color;
varying vec2 f_uv;

void main() {
  if (f_color.a == 0.0 ||
    outOfRange(clipBounds[0], clipBounds[1], f_data)
  ) discard;

  vec3 N = normalize(f_normal);
  vec3 L = normalize(f_lightDirection);
  vec3 V = normalize(f_eyeDirection);

  if(gl_FrontFacing) {
    N = -N;
  }

  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));
  //float specular = max(0.0, beckmann(L, V, N, roughness)); // used in gl-surface3d

  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);

  vec4 surfaceColor = vec4(f_color.rgb, 1.0) * texture2D(texture, f_uv);
  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);

  gl_FragColor = litColor * f_color.a;
}
`
                        ]), c = s([
                            `precision highp float;
#define GLSLIFY 1

attribute vec3 position;
attribute vec4 color;
attribute vec2 uv;

uniform mat4 model, view, projection;

varying vec4 f_color;
varying vec3 f_data;
varying vec2 f_uv;

void main() {
  gl_Position = projection * (view * (model * vec4(position, 1.0)));
  f_color = color;
  f_data  = position;
  f_uv    = uv;
}`
                        ]), f = s([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3 clipBounds[2];
uniform sampler2D texture;
uniform float opacity;

varying vec4 f_color;
varying vec3 f_data;
varying vec2 f_uv;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], f_data)) discard;

  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;
}`
                        ]), h = s([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

attribute vec3 position;
attribute vec4 color;
attribute vec2 uv;
attribute float pointSize;

uniform mat4 model, view, projection;
uniform vec3 clipBounds[2];

varying vec4 f_color;
varying vec2 f_uv;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], position)) {

    gl_Position = vec4(0.0, 0.0 ,0.0 ,0.0);
  } else {
    gl_Position = projection * (view * (model * vec4(position, 1.0)));
  }
  gl_PointSize = pointSize;
  f_color = color;
  f_uv = uv;
}`
                        ]), d = s([
                            `precision highp float;
#define GLSLIFY 1

uniform sampler2D texture;
uniform float opacity;

varying vec4 f_color;
varying vec2 f_uv;

void main() {
  vec2 pointR = gl_PointCoord.xy - vec2(0.5, 0.5);
  if(dot(pointR, pointR) > 0.25) {
    discard;
  }
  gl_FragColor = f_color * texture2D(texture, f_uv) * opacity;
}`
                        ]), v = s([
                            `precision highp float;
#define GLSLIFY 1

attribute vec3 position;
attribute vec4 id;

uniform mat4 model, view, projection;

varying vec3 f_position;
varying vec4 f_id;

void main() {
  gl_Position = projection * (view * (model * vec4(position, 1.0)));
  f_id        = id;
  f_position  = position;
}`
                        ]), x = s([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3  clipBounds[2];
uniform float pickId;

varying vec3 f_position;
varying vec4 f_id;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;

  gl_FragColor = vec4(pickId, f_id.xyz);
}`
                        ]), b = s([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

attribute vec3  position;
attribute float pointSize;
attribute vec4  id;

uniform mat4 model, view, projection;
uniform vec3 clipBounds[2];

varying vec3 f_position;
varying vec4 f_id;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], position)) {

    gl_Position = vec4(0.0, 0.0, 0.0, 0.0);
  } else {
    gl_Position  = projection * (view * (model * vec4(position, 1.0)));
    gl_PointSize = pointSize;
  }
  f_id         = id;
  f_position   = position;
}`
                        ]), p = s([
                            `precision highp float;
#define GLSLIFY 1

attribute vec3 position;

uniform mat4 model, view, projection;

void main() {
  gl_Position = projection * (view * (model * vec4(position, 1.0)));
}`
                        ]), E = s([
                            `precision highp float;
#define GLSLIFY 1

uniform vec3 contourColor;

void main() {
  gl_FragColor = vec4(contourColor, 1.0);
}
`
                        ]);
                        a.meshShader = {
                            vertex: l,
                            fragment: u,
                            attributes: [
                                {
                                    name: "position",
                                    type: "vec3"
                                },
                                {
                                    name: "normal",
                                    type: "vec3"
                                },
                                {
                                    name: "color",
                                    type: "vec4"
                                },
                                {
                                    name: "uv",
                                    type: "vec2"
                                }
                            ]
                        }, a.wireShader = {
                            vertex: c,
                            fragment: f,
                            attributes: [
                                {
                                    name: "position",
                                    type: "vec3"
                                },
                                {
                                    name: "color",
                                    type: "vec4"
                                },
                                {
                                    name: "uv",
                                    type: "vec2"
                                }
                            ]
                        }, a.pointShader = {
                            vertex: h,
                            fragment: d,
                            attributes: [
                                {
                                    name: "position",
                                    type: "vec3"
                                },
                                {
                                    name: "color",
                                    type: "vec4"
                                },
                                {
                                    name: "uv",
                                    type: "vec2"
                                },
                                {
                                    name: "pointSize",
                                    type: "float"
                                }
                            ]
                        }, a.pickShader = {
                            vertex: v,
                            fragment: x,
                            attributes: [
                                {
                                    name: "position",
                                    type: "vec3"
                                },
                                {
                                    name: "id",
                                    type: "vec4"
                                }
                            ]
                        }, a.pointPickShader = {
                            vertex: b,
                            fragment: x,
                            attributes: [
                                {
                                    name: "position",
                                    type: "vec3"
                                },
                                {
                                    name: "pointSize",
                                    type: "float"
                                },
                                {
                                    name: "id",
                                    type: "vec4"
                                }
                            ]
                        }, a.contourShader = {
                            vertex: p,
                            fragment: E,
                            attributes: [
                                {
                                    name: "position",
                                    type: "vec3"
                                }
                            ]
                        };
                    },
                    7201: function(i, a, o) {
                        "use strict";
                        var s = 1e-6, l = 1e-6, u = o(9405), c = o(2762), f = o(8116), h = o(7766), d = o(8406), v = o(6760), x = o(7608), b = o(9618), p = o(6729), E = o(7765), k = o(1888), A = o(840), L = o(7626), _ = A.meshShader, C = A.wireShader, M = A.pointShader, g = A.pickShader, P = A.pointPickShader, T = A.contourShader, F = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ];
                        function q(ge, ie, Te, Ee, Ae, ze, Ce, me, Re, ce, Ge, nt, ct, qt, rt, ot, Rt, kt, Ct, Yt, xr, er, Ke, xt, bt, Lt, St) {
                            this.gl = ge, this.pixelRatio = 1, this.cells = [], this.positions = [], this.intensity = [], this.texture = ie, this.dirty = !0, this.triShader = Te, this.lineShader = Ee, this.pointShader = Ae, this.pickShader = ze, this.pointPickShader = Ce, this.contourShader = me, this.trianglePositions = Re, this.triangleColors = Ge, this.triangleNormals = ct, this.triangleUVs = nt, this.triangleIds = ce, this.triangleVAO = qt, this.triangleCount = 0, this.lineWidth = 1, this.edgePositions = rt, this.edgeColors = Rt, this.edgeUVs = kt, this.edgeIds = ot, this.edgeVAO = Ct, this.edgeCount = 0, this.pointPositions = Yt, this.pointColors = er, this.pointUVs = Ke, this.pointSizes = xt, this.pointIds = xr, this.pointVAO = bt, this.pointCount = 0, this.contourLineWidth = 1, this.contourPositions = Lt, this.contourVAO = St, this.contourCount = 0, this.contourColor = [
                                0,
                                0,
                                0
                            ], this.contourEnable = !0, this.pickVertex = !0, this.pickId = 1, this.bounds = [
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ],
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ]
                            ], this.clipBounds = [
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ],
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ]
                            ], this.lightPosition = [
                                1e5,
                                1e5,
                                0
                            ], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.opacity = 1, this.hasAlpha = !1, this.opacityscale = !1, this._model = F, this._view = F, this._projection = F, this._resolution = [
                                1,
                                1
                            ];
                        }
                        var V = q.prototype;
                        V.isOpaque = function() {
                            return !this.hasAlpha;
                        }, V.isTransparent = function() {
                            return this.hasAlpha;
                        }, V.pickSlots = 1, V.setPickBase = function(ge) {
                            this.pickId = ge;
                        };
                        function H(ge, ie) {
                            if (!ie || !ie.length) return 1;
                            for(var Te = 0; Te < ie.length; ++Te){
                                if (ie.length < 2) return 1;
                                if (ie[Te][0] === ge) return ie[Te][1];
                                if (ie[Te][0] > ge && Te > 0) {
                                    var Ee = (ie[Te][0] - ge) / (ie[Te][0] - ie[Te - 1][0]);
                                    return ie[Te][1] * (1 - Ee) + Ee * ie[Te - 1][1];
                                }
                            }
                            return 1;
                        }
                        function X(ge, ie) {
                            for(var Te = p({
                                colormap: ge,
                                nshades: 256,
                                format: "rgba"
                            }), Ee = new Uint8Array(1024), Ae = 0; Ae < 256; ++Ae){
                                for(var ze = Te[Ae], Ce = 0; Ce < 3; ++Ce)Ee[4 * Ae + Ce] = ze[Ce];
                                ie ? Ee[4 * Ae + 3] = 255 * H(Ae / 255, ie) : Ee[4 * Ae + 3] = 255 * ze[3];
                            }
                            return b(Ee, [
                                256,
                                256,
                                4
                            ], [
                                4,
                                0,
                                1
                            ]);
                        }
                        function G(ge) {
                            for(var ie = ge.length, Te = new Array(ie), Ee = 0; Ee < ie; ++Ee)Te[Ee] = ge[Ee][2];
                            return Te;
                        }
                        V.highlight = function(ge) {
                            if (!ge || !this.contourEnable) {
                                this.contourCount = 0;
                                return;
                            }
                            for(var ie = E(this.cells, this.intensity, ge.intensity), Te = ie.cells, Ee = ie.vertexIds, Ae = ie.vertexWeights, ze = Te.length, Ce = k.mallocFloat32(6 * ze), me = 0, Re = 0; Re < ze; ++Re)for(var ce = Te[Re], Ge = 0; Ge < 2; ++Ge){
                                var nt = ce[0];
                                ce.length === 2 && (nt = ce[Ge]);
                                for(var ct = Ee[nt][0], qt = Ee[nt][1], rt = Ae[nt], ot = 1 - rt, Rt = this.positions[ct], kt = this.positions[qt], Ct = 0; Ct < 3; ++Ct)Ce[me++] = rt * Rt[Ct] + ot * kt[Ct];
                            }
                            this.contourCount = me / 3 | 0, this.contourPositions.update(Ce.subarray(0, me)), k.free(Ce);
                        }, V.update = function(ge) {
                            ge = ge || {};
                            var ie = this.gl;
                            this.dirty = !0, "contourEnable" in ge && (this.contourEnable = ge.contourEnable), "contourColor" in ge && (this.contourColor = ge.contourColor), "lineWidth" in ge && (this.lineWidth = ge.lineWidth), "lightPosition" in ge && (this.lightPosition = ge.lightPosition), this.hasAlpha = !1, "opacity" in ge && (this.opacity = ge.opacity, this.opacity < 1 && (this.hasAlpha = !0)), "opacityscale" in ge && (this.opacityscale = ge.opacityscale, this.hasAlpha = !0), "ambient" in ge && (this.ambientLight = ge.ambient), "diffuse" in ge && (this.diffuseLight = ge.diffuse), "specular" in ge && (this.specularLight = ge.specular), "roughness" in ge && (this.roughness = ge.roughness), "fresnel" in ge && (this.fresnel = ge.fresnel), ge.texture ? (this.texture.dispose(), this.texture = h(ie, ge.texture)) : ge.colormap && (this.texture.shape = [
                                256,
                                256
                            ], this.texture.minFilter = ie.LINEAR_MIPMAP_LINEAR, this.texture.magFilter = ie.LINEAR, this.texture.setPixels(X(ge.colormap, this.opacityscale)), this.texture.generateMipmap());
                            var Te = ge.cells, Ee = ge.positions;
                            if (!(!Ee || !Te)) {
                                var Ae = [], ze = [], Ce = [], me = [], Re = [], ce = [], Ge = [], nt = [], ct = [], qt = [], rt = [], ot = [], Rt = [], kt = [];
                                this.cells = Te, this.positions = Ee;
                                var Ct = ge.vertexNormals, Yt = ge.cellNormals, xr = ge.vertexNormalsEpsilon === void 0 ? s : ge.vertexNormalsEpsilon, er = ge.faceNormalsEpsilon === void 0 ? l : ge.faceNormalsEpsilon;
                                ge.useFacetNormals && !Yt && (Yt = d.faceNormals(Te, Ee, er)), !Yt && !Ct && (Ct = d.vertexNormals(Te, Ee, xr));
                                var Ke = ge.vertexColors, xt = ge.cellColors, bt = ge.meshColor || [
                                    1,
                                    1,
                                    1,
                                    1
                                ], Lt = ge.vertexUVs, St = ge.vertexIntensity, Et = ge.cellUVs, dt = ge.cellIntensity, Ht = 1 / 0, $t = -1 / 0;
                                if (!Lt && !Et) {
                                    if (St) {
                                        if (ge.vertexIntensityBounds) Ht = +ge.vertexIntensityBounds[0], $t = +ge.vertexIntensityBounds[1];
                                        else for(var fr = 0; fr < St.length; ++fr){
                                            var _r = St[fr];
                                            Ht = Math.min(Ht, _r), $t = Math.max($t, _r);
                                        }
                                    } else if (dt) {
                                        if (ge.cellIntensityBounds) Ht = +ge.cellIntensityBounds[0], $t = +ge.cellIntensityBounds[1];
                                        else for(var fr = 0; fr < dt.length; ++fr){
                                            var _r = dt[fr];
                                            Ht = Math.min(Ht, _r), $t = Math.max($t, _r);
                                        }
                                    } else for(var fr = 0; fr < Ee.length; ++fr){
                                        var _r = Ee[fr][2];
                                        Ht = Math.min(Ht, _r), $t = Math.max($t, _r);
                                    }
                                }
                                St ? this.intensity = St : dt ? this.intensity = dt : this.intensity = G(Ee), this.pickVertex = !(dt || xt);
                                var Br = ge.pointSizes, Or = ge.pointSize || 1;
                                this.bounds = [
                                    [
                                        1 / 0,
                                        1 / 0,
                                        1 / 0
                                    ],
                                    [
                                        -1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ]
                                ];
                                for(var fr = 0; fr < Ee.length; ++fr)for(var Nr = Ee[fr], ut = 0; ut < 3; ++ut)isNaN(Nr[ut]) || !isFinite(Nr[ut]) || (this.bounds[0][ut] = Math.min(this.bounds[0][ut], Nr[ut]), this.bounds[1][ut] = Math.max(this.bounds[1][ut], Nr[ut]));
                                var Ne = 0, Ye = 0, Ve = 0;
                                e: for(var fr = 0; fr < Te.length; ++fr){
                                    var Xe = Te[fr];
                                    switch(Xe.length){
                                        case 1:
                                            for(var ht = Xe[0], Nr = Ee[ht], ut = 0; ut < 3; ++ut)if (isNaN(Nr[ut]) || !isFinite(Nr[ut])) continue e;
                                            qt.push(Nr[0], Nr[1], Nr[2]);
                                            var Le;
                                            Ke ? Le = Ke[ht] : xt ? Le = xt[fr] : Le = bt, this.opacityscale && St ? ze.push(Le[0], Le[1], Le[2], this.opacity * H((St[ht] - Ht) / ($t - Ht), this.opacityscale)) : Le.length === 3 ? rt.push(Le[0], Le[1], Le[2], this.opacity) : (rt.push(Le[0], Le[1], Le[2], Le[3] * this.opacity), Le[3] < 1 && (this.hasAlpha = !0));
                                            var xe;
                                            Lt ? xe = Lt[ht] : St ? xe = [
                                                (St[ht] - Ht) / ($t - Ht),
                                                0
                                            ] : Et ? xe = Et[fr] : dt ? xe = [
                                                (dt[fr] - Ht) / ($t - Ht),
                                                0
                                            ] : xe = [
                                                (Nr[2] - Ht) / ($t - Ht),
                                                0
                                            ], ot.push(xe[0], xe[1]), Br ? Rt.push(Br[ht]) : Rt.push(Or), kt.push(fr), Ve += 1;
                                            break;
                                        case 2:
                                            for(var ut = 0; ut < 2; ++ut)for(var ht = Xe[ut], Nr = Ee[ht], Se = 0; Se < 3; ++Se)if (isNaN(Nr[Se]) || !isFinite(Nr[Se])) continue e;
                                            for(var ut = 0; ut < 2; ++ut){
                                                var ht = Xe[ut], Nr = Ee[ht];
                                                ce.push(Nr[0], Nr[1], Nr[2]);
                                                var Le;
                                                Ke ? Le = Ke[ht] : xt ? Le = xt[fr] : Le = bt, this.opacityscale && St ? ze.push(Le[0], Le[1], Le[2], this.opacity * H((St[ht] - Ht) / ($t - Ht), this.opacityscale)) : Le.length === 3 ? Ge.push(Le[0], Le[1], Le[2], this.opacity) : (Ge.push(Le[0], Le[1], Le[2], Le[3] * this.opacity), Le[3] < 1 && (this.hasAlpha = !0));
                                                var xe;
                                                Lt ? xe = Lt[ht] : St ? xe = [
                                                    (St[ht] - Ht) / ($t - Ht),
                                                    0
                                                ] : Et ? xe = Et[fr] : dt ? xe = [
                                                    (dt[fr] - Ht) / ($t - Ht),
                                                    0
                                                ] : xe = [
                                                    (Nr[2] - Ht) / ($t - Ht),
                                                    0
                                                ], nt.push(xe[0], xe[1]), ct.push(fr);
                                            }
                                            Ye += 1;
                                            break;
                                        case 3:
                                            for(var ut = 0; ut < 3; ++ut)for(var ht = Xe[ut], Nr = Ee[ht], Se = 0; Se < 3; ++Se)if (isNaN(Nr[Se]) || !isFinite(Nr[Se])) continue e;
                                            for(var ut = 0; ut < 3; ++ut){
                                                var ht = Xe[2 - ut], Nr = Ee[ht];
                                                Ae.push(Nr[0], Nr[1], Nr[2]);
                                                var Le;
                                                Ke ? Le = Ke[ht] : xt ? Le = xt[fr] : Le = bt, Le ? this.opacityscale && St ? ze.push(Le[0], Le[1], Le[2], this.opacity * H((St[ht] - Ht) / ($t - Ht), this.opacityscale)) : Le.length === 3 ? ze.push(Le[0], Le[1], Le[2], this.opacity) : (ze.push(Le[0], Le[1], Le[2], Le[3] * this.opacity), Le[3] < 1 && (this.hasAlpha = !0)) : ze.push(.5, .5, .5, 1);
                                                var xe;
                                                Lt ? xe = Lt[ht] : St ? xe = [
                                                    (St[ht] - Ht) / ($t - Ht),
                                                    0
                                                ] : Et ? xe = Et[fr] : dt ? xe = [
                                                    (dt[fr] - Ht) / ($t - Ht),
                                                    0
                                                ] : xe = [
                                                    (Nr[2] - Ht) / ($t - Ht),
                                                    0
                                                ], me.push(xe[0], xe[1]);
                                                var lt;
                                                Ct ? lt = Ct[ht] : lt = Yt[fr], Ce.push(lt[0], lt[1], lt[2]), Re.push(fr);
                                            }
                                            Ne += 1;
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                this.pointCount = Ve, this.edgeCount = Ye, this.triangleCount = Ne, this.pointPositions.update(qt), this.pointColors.update(rt), this.pointUVs.update(ot), this.pointSizes.update(Rt), this.pointIds.update(new Uint32Array(kt)), this.edgePositions.update(ce), this.edgeColors.update(Ge), this.edgeUVs.update(nt), this.edgeIds.update(new Uint32Array(ct)), this.trianglePositions.update(Ae), this.triangleColors.update(ze), this.triangleUVs.update(me), this.triangleNormals.update(Ce), this.triangleIds.update(new Uint32Array(Re));
                            }
                        }, V.drawTransparent = V.draw = function(ge) {
                            ge = ge || {};
                            for(var ie = this.gl, Te = ge.model || F, Ee = ge.view || F, Ae = ge.projection || F, ze = [
                                [
                                    -1000000,
                                    -1000000,
                                    -1000000
                                ],
                                [
                                    1e6,
                                    1e6,
                                    1e6
                                ]
                            ], Ce = 0; Ce < 3; ++Ce)ze[0][Ce] = Math.max(ze[0][Ce], this.clipBounds[0][Ce]), ze[1][Ce] = Math.min(ze[1][Ce], this.clipBounds[1][Ce]);
                            var me = {
                                model: Te,
                                view: Ee,
                                projection: Ae,
                                inverseModel: F.slice(),
                                clipBounds: ze,
                                kambient: this.ambientLight,
                                kdiffuse: this.diffuseLight,
                                kspecular: this.specularLight,
                                roughness: this.roughness,
                                fresnel: this.fresnel,
                                eyePosition: [
                                    0,
                                    0,
                                    0
                                ],
                                lightPosition: [
                                    0,
                                    0,
                                    0
                                ],
                                contourColor: this.contourColor,
                                texture: 0
                            };
                            me.inverseModel = x(me.inverseModel, me.model), ie.disable(ie.CULL_FACE), this.texture.bind(0);
                            var Re = new Array(16);
                            v(Re, me.view, me.model), v(Re, me.projection, Re), x(Re, Re);
                            for(var Ce = 0; Ce < 3; ++Ce)me.eyePosition[Ce] = Re[12 + Ce] / Re[15];
                            for(var ce = Re[15], Ce = 0; Ce < 3; ++Ce)ce += this.lightPosition[Ce] * Re[4 * Ce + 3];
                            for(var Ce = 0; Ce < 3; ++Ce){
                                for(var Ge = Re[12 + Ce], nt = 0; nt < 3; ++nt)Ge += Re[4 * nt + Ce] * this.lightPosition[nt];
                                me.lightPosition[Ce] = Ge / ce;
                            }
                            if (this.triangleCount > 0) {
                                var ct = this.triShader;
                                ct.bind(), ct.uniforms = me, this.triangleVAO.bind(), ie.drawArrays(ie.TRIANGLES, 0, this.triangleCount * 3), this.triangleVAO.unbind();
                            }
                            if (this.edgeCount > 0 && this.lineWidth > 0) {
                                var ct = this.lineShader;
                                ct.bind(), ct.uniforms = me, this.edgeVAO.bind(), ie.lineWidth(this.lineWidth * this.pixelRatio), ie.drawArrays(ie.LINES, 0, this.edgeCount * 2), this.edgeVAO.unbind();
                            }
                            if (this.pointCount > 0) {
                                var ct = this.pointShader;
                                ct.bind(), ct.uniforms = me, this.pointVAO.bind(), ie.drawArrays(ie.POINTS, 0, this.pointCount), this.pointVAO.unbind();
                            }
                            if (this.contourEnable && this.contourCount > 0 && this.contourLineWidth > 0) {
                                var ct = this.contourShader;
                                ct.bind(), ct.uniforms = me, this.contourVAO.bind(), ie.drawArrays(ie.LINES, 0, this.contourCount), this.contourVAO.unbind();
                            }
                        }, V.drawPick = function(ge) {
                            ge = ge || {};
                            for(var ie = this.gl, Te = ge.model || F, Ee = ge.view || F, Ae = ge.projection || F, ze = [
                                [
                                    -1000000,
                                    -1000000,
                                    -1000000
                                ],
                                [
                                    1e6,
                                    1e6,
                                    1e6
                                ]
                            ], Ce = 0; Ce < 3; ++Ce)ze[0][Ce] = Math.max(ze[0][Ce], this.clipBounds[0][Ce]), ze[1][Ce] = Math.min(ze[1][Ce], this.clipBounds[1][Ce]);
                            this._model = [].slice.call(Te), this._view = [].slice.call(Ee), this._projection = [].slice.call(Ae), this._resolution = [
                                ie.drawingBufferWidth,
                                ie.drawingBufferHeight
                            ];
                            var me = {
                                model: Te,
                                view: Ee,
                                projection: Ae,
                                clipBounds: ze,
                                pickId: this.pickId / 255
                            }, Re = this.pickShader;
                            if (Re.bind(), Re.uniforms = me, this.triangleCount > 0 && (this.triangleVAO.bind(), ie.drawArrays(ie.TRIANGLES, 0, this.triangleCount * 3), this.triangleVAO.unbind()), this.edgeCount > 0 && (this.edgeVAO.bind(), ie.lineWidth(this.lineWidth * this.pixelRatio), ie.drawArrays(ie.LINES, 0, this.edgeCount * 2), this.edgeVAO.unbind()), this.pointCount > 0) {
                                var Re = this.pointPickShader;
                                Re.bind(), Re.uniforms = me, this.pointVAO.bind(), ie.drawArrays(ie.POINTS, 0, this.pointCount), this.pointVAO.unbind();
                            }
                        }, V.pick = function(ge) {
                            if (!ge || ge.id !== this.pickId) return null;
                            for(var ie = ge.value[0] + 256 * ge.value[1] + 65536 * ge.value[2], Te = this.cells[ie], Ee = this.positions, Ae = new Array(Te.length), ze = 0; ze < Te.length; ++ze)Ae[ze] = Ee[Te[ze]];
                            var Ce = ge.coord[0], me = ge.coord[1];
                            if (!this.pickVertex) {
                                var Re = this.positions[Te[0]], ce = this.positions[Te[1]], Ge = this.positions[Te[2]], nt = [
                                    (Re[0] + ce[0] + Ge[0]) / 3,
                                    (Re[1] + ce[1] + Ge[1]) / 3,
                                    (Re[2] + ce[2] + Ge[2]) / 3
                                ];
                                return {
                                    _cellCenter: !0,
                                    position: [
                                        Ce,
                                        me
                                    ],
                                    index: ie,
                                    cell: Te,
                                    cellId: ie,
                                    intensity: this.intensity[ie],
                                    dataCoordinate: nt
                                };
                            }
                            var ct = L(Ae, [
                                Ce * this.pixelRatio,
                                this._resolution[1] - me * this.pixelRatio
                            ], this._model, this._view, this._projection, this._resolution);
                            if (!ct) return null;
                            for(var qt = ct[2], rt = 0, ze = 0; ze < Te.length; ++ze)rt += qt[ze] * this.intensity[Te[ze]];
                            return {
                                position: ct[1],
                                index: Te[ct[0]],
                                cell: Te,
                                cellId: ie,
                                intensity: rt,
                                dataCoordinate: this.positions[Te[ct[0]]]
                            };
                        }, V.dispose = function() {
                            this.texture.dispose(), this.triShader.dispose(), this.lineShader.dispose(), this.pointShader.dispose(), this.pickShader.dispose(), this.pointPickShader.dispose(), this.triangleVAO.dispose(), this.trianglePositions.dispose(), this.triangleColors.dispose(), this.triangleUVs.dispose(), this.triangleNormals.dispose(), this.triangleIds.dispose(), this.edgeVAO.dispose(), this.edgePositions.dispose(), this.edgeColors.dispose(), this.edgeUVs.dispose(), this.edgeIds.dispose(), this.pointVAO.dispose(), this.pointPositions.dispose(), this.pointColors.dispose(), this.pointUVs.dispose(), this.pointSizes.dispose(), this.pointIds.dispose(), this.contourVAO.dispose(), this.contourPositions.dispose(), this.contourShader.dispose();
                        };
                        function N(ge) {
                            var ie = u(ge, _.vertex, _.fragment);
                            return ie.attributes.position.location = 0, ie.attributes.color.location = 2, ie.attributes.uv.location = 3, ie.attributes.normal.location = 4, ie;
                        }
                        function W(ge) {
                            var ie = u(ge, C.vertex, C.fragment);
                            return ie.attributes.position.location = 0, ie.attributes.color.location = 2, ie.attributes.uv.location = 3, ie;
                        }
                        function re(ge) {
                            var ie = u(ge, M.vertex, M.fragment);
                            return ie.attributes.position.location = 0, ie.attributes.color.location = 2, ie.attributes.uv.location = 3, ie.attributes.pointSize.location = 4, ie;
                        }
                        function ae(ge) {
                            var ie = u(ge, g.vertex, g.fragment);
                            return ie.attributes.position.location = 0, ie.attributes.id.location = 1, ie;
                        }
                        function _e(ge) {
                            var ie = u(ge, P.vertex, P.fragment);
                            return ie.attributes.position.location = 0, ie.attributes.id.location = 1, ie.attributes.pointSize.location = 4, ie;
                        }
                        function Me(ge) {
                            var ie = u(ge, T.vertex, T.fragment);
                            return ie.attributes.position.location = 0, ie;
                        }
                        function ke(ge, ie) {
                            arguments.length === 1 && (ie = ge, ge = ie.gl);
                            var Te = ge.getExtension("OES_standard_derivatives") || ge.getExtension("MOZ_OES_standard_derivatives") || ge.getExtension("WEBKIT_OES_standard_derivatives");
                            if (!Te) throw new Error("derivatives not supported");
                            var Ee = N(ge), Ae = W(ge), ze = re(ge), Ce = ae(ge), me = _e(ge), Re = Me(ge), ce = h(ge, b(new Uint8Array([
                                255,
                                255,
                                255,
                                255
                            ]), [
                                1,
                                1,
                                4
                            ]));
                            ce.generateMipmap(), ce.minFilter = ge.LINEAR_MIPMAP_LINEAR, ce.magFilter = ge.LINEAR;
                            var Ge = c(ge), nt = c(ge), ct = c(ge), qt = c(ge), rt = c(ge), ot = f(ge, [
                                {
                                    buffer: Ge,
                                    type: ge.FLOAT,
                                    size: 3
                                },
                                {
                                    buffer: rt,
                                    type: ge.UNSIGNED_BYTE,
                                    size: 4,
                                    normalized: !0
                                },
                                {
                                    buffer: nt,
                                    type: ge.FLOAT,
                                    size: 4
                                },
                                {
                                    buffer: ct,
                                    type: ge.FLOAT,
                                    size: 2
                                },
                                {
                                    buffer: qt,
                                    type: ge.FLOAT,
                                    size: 3
                                }
                            ]), Rt = c(ge), kt = c(ge), Ct = c(ge), Yt = c(ge), xr = f(ge, [
                                {
                                    buffer: Rt,
                                    type: ge.FLOAT,
                                    size: 3
                                },
                                {
                                    buffer: Yt,
                                    type: ge.UNSIGNED_BYTE,
                                    size: 4,
                                    normalized: !0
                                },
                                {
                                    buffer: kt,
                                    type: ge.FLOAT,
                                    size: 4
                                },
                                {
                                    buffer: Ct,
                                    type: ge.FLOAT,
                                    size: 2
                                }
                            ]), er = c(ge), Ke = c(ge), xt = c(ge), bt = c(ge), Lt = c(ge), St = f(ge, [
                                {
                                    buffer: er,
                                    type: ge.FLOAT,
                                    size: 3
                                },
                                {
                                    buffer: Lt,
                                    type: ge.UNSIGNED_BYTE,
                                    size: 4,
                                    normalized: !0
                                },
                                {
                                    buffer: Ke,
                                    type: ge.FLOAT,
                                    size: 4
                                },
                                {
                                    buffer: xt,
                                    type: ge.FLOAT,
                                    size: 2
                                },
                                {
                                    buffer: bt,
                                    type: ge.FLOAT,
                                    size: 1
                                }
                            ]), Et = c(ge), dt = f(ge, [
                                {
                                    buffer: Et,
                                    type: ge.FLOAT,
                                    size: 3
                                }
                            ]), Ht = new q(ge, ce, Ee, Ae, ze, Ce, me, Re, Ge, rt, nt, ct, qt, ot, Rt, Yt, kt, Ct, xr, er, Lt, Ke, xt, bt, St, Et, dt);
                            return Ht.update(ie), Ht;
                        }
                        i.exports = ke;
                    },
                    4437: function(i, a, o) {
                        "use strict";
                        i.exports = d;
                        var s = o(3025), l = o(6296), u = o(351), c = o(8512), f = o(24), h = o(7520);
                        function d(v, x) {
                            v = v || document.body, x = x || {};
                            var b = [
                                .01,
                                1 / 0
                            ];
                            "distanceLimits" in x && (b[0] = x.distanceLimits[0], b[1] = x.distanceLimits[1]), "zoomMin" in x && (b[0] = x.zoomMin), "zoomMax" in x && (b[1] = x.zoomMax);
                            var p = l({
                                center: x.center || [
                                    0,
                                    0,
                                    0
                                ],
                                up: x.up || [
                                    0,
                                    1,
                                    0
                                ],
                                eye: x.eye || [
                                    0,
                                    0,
                                    10
                                ],
                                mode: x.mode || "orbit",
                                distanceLimits: b
                            }), E = [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], k = 0, A = v.clientWidth, L = v.clientHeight, _ = {
                                keyBindingMode: "rotate",
                                enableWheel: !0,
                                view: p,
                                element: v,
                                delay: x.delay || 16,
                                rotateSpeed: x.rotateSpeed || 1,
                                zoomSpeed: x.zoomSpeed || 1,
                                translateSpeed: x.translateSpeed || 1,
                                flipX: !!x.flipX,
                                flipY: !!x.flipY,
                                modes: p.modes,
                                _ortho: x._ortho || x.projection && x.projection.type === "orthographic" || !1,
                                tick: function() {
                                    var C = s(), M = this.delay, g = C - 2 * M;
                                    p.idle(C - M), p.recalcMatrix(g), p.flush(C - (100 + M * 2));
                                    for(var P = !0, T = p.computedMatrix, F = 0; F < 16; ++F)P = P && E[F] === T[F], E[F] = T[F];
                                    var q = v.clientWidth === A && v.clientHeight === L;
                                    return A = v.clientWidth, L = v.clientHeight, P ? !q : (k = Math.exp(p.computedRadius[0]), !0);
                                },
                                lookAt: function(C, M, g) {
                                    p.lookAt(p.lastT(), C, M, g);
                                },
                                rotate: function(C, M, g) {
                                    p.rotate(p.lastT(), C, M, g);
                                },
                                pan: function(C, M, g) {
                                    p.pan(p.lastT(), C, M, g);
                                },
                                translate: function(C, M, g) {
                                    p.translate(p.lastT(), C, M, g);
                                }
                            };
                            return Object.defineProperties(_, {
                                matrix: {
                                    get: function() {
                                        return p.computedMatrix;
                                    },
                                    set: function(C) {
                                        return p.setMatrix(p.lastT(), C), p.computedMatrix;
                                    },
                                    enumerable: !0
                                },
                                mode: {
                                    get: function() {
                                        return p.getMode();
                                    },
                                    set: function(C) {
                                        var M = p.computedUp.slice(), g = p.computedEye.slice(), P = p.computedCenter.slice();
                                        if (p.setMode(C), C === "turntable") {
                                            var T = s();
                                            p._active.lookAt(T, g, P, M), p._active.lookAt(T + 500, g, P, [
                                                0,
                                                0,
                                                1
                                            ]), p._active.flush(T);
                                        }
                                        return p.getMode();
                                    },
                                    enumerable: !0
                                },
                                center: {
                                    get: function() {
                                        return p.computedCenter;
                                    },
                                    set: function(C) {
                                        return p.lookAt(p.lastT(), null, C), p.computedCenter;
                                    },
                                    enumerable: !0
                                },
                                eye: {
                                    get: function() {
                                        return p.computedEye;
                                    },
                                    set: function(C) {
                                        return p.lookAt(p.lastT(), C), p.computedEye;
                                    },
                                    enumerable: !0
                                },
                                up: {
                                    get: function() {
                                        return p.computedUp;
                                    },
                                    set: function(C) {
                                        return p.lookAt(p.lastT(), null, null, C), p.computedUp;
                                    },
                                    enumerable: !0
                                },
                                distance: {
                                    get: function() {
                                        return k;
                                    },
                                    set: function(C) {
                                        return p.setDistance(p.lastT(), C), C;
                                    },
                                    enumerable: !0
                                },
                                distanceLimits: {
                                    get: function() {
                                        return p.getDistanceLimits(b);
                                    },
                                    set: function(C) {
                                        return p.setDistanceLimits(C), C;
                                    },
                                    enumerable: !0
                                }
                            }), v.addEventListener("contextmenu", function(C) {
                                return C.preventDefault(), !1;
                            }), _._lastX = -1, _._lastY = -1, _._lastMods = {
                                shift: !1,
                                control: !1,
                                alt: !1,
                                meta: !1
                            }, _.enableMouseListeners = function() {
                                _.mouseListener = u(v, C), v.addEventListener("touchstart", function(M) {
                                    var g = f(M.changedTouches[0], v);
                                    C(0, g[0], g[1], _._lastMods), C(1, g[0], g[1], _._lastMods);
                                }, h ? {
                                    passive: !0
                                } : !1), v.addEventListener("touchmove", function(M) {
                                    var g = f(M.changedTouches[0], v);
                                    C(1, g[0], g[1], _._lastMods), M.preventDefault();
                                }, h ? {
                                    passive: !1
                                } : !1), v.addEventListener("touchend", function(M) {
                                    C(0, _._lastX, _._lastY, _._lastMods);
                                }, h ? {
                                    passive: !0
                                } : !1);
                                function C(M, g, P, T) {
                                    var F = _.keyBindingMode;
                                    if (F !== !1) {
                                        var q = F === "rotate", V = F === "pan", H = F === "zoom", X = !!T.control, G = !!T.alt, N = !!T.shift, W = !!(M & 1), re = !!(M & 2), ae = !!(M & 4), _e = 1 / v.clientHeight, Me = _e * (g - _._lastX), ke = _e * (P - _._lastY), ge = _.flipX ? 1 : -1, ie = _.flipY ? 1 : -1, Te = Math.PI * _.rotateSpeed, Ee = s();
                                        if (_._lastX !== -1 && _._lastY !== -1 && ((q && W && !X && !G && !N || W && !X && !G && N) && p.rotate(Ee, ge * Te * Me, -ie * Te * ke, 0), (V && W && !X && !G && !N || re || W && X && !G && !N) && p.pan(Ee, -_.translateSpeed * Me * k, _.translateSpeed * ke * k, 0), H && W && !X && !G && !N || ae || W && !X && G && !N)) {
                                            var Ae = -_.zoomSpeed * ke / window.innerHeight * (Ee - p.lastT()) * 100;
                                            p.pan(Ee, 0, 0, k * (Math.exp(Ae) - 1));
                                        }
                                        return _._lastX = g, _._lastY = P, _._lastMods = T, !0;
                                    }
                                }
                                _.wheelListener = c(v, function(M, g) {
                                    if (_.keyBindingMode !== !1 && _.enableWheel) {
                                        var P = _.flipX ? 1 : -1, T = _.flipY ? 1 : -1, F = s();
                                        if (Math.abs(M) > Math.abs(g)) p.rotate(F, 0, 0, -M * P * Math.PI * _.rotateSpeed / window.innerWidth);
                                        else if (!_._ortho) {
                                            var q = -_.zoomSpeed * T * g / window.innerHeight * (F - p.lastT()) / 20;
                                            p.pan(F, 0, 0, k * (Math.exp(q) - 1));
                                        }
                                    }
                                }, !0);
                            }, _.enableMouseListeners(), _;
                        }
                    },
                    799: function(i, a, o) {
                        var s = o(3236), l = o(9405), u = s([
                            `precision mediump float;
#define GLSLIFY 1
attribute vec2 position;
varying vec2 uv;
void main() {
  uv = position;
  gl_Position = vec4(position, 0, 1);
}`
                        ]), c = s([
                            `precision mediump float;
#define GLSLIFY 1

uniform sampler2D accumBuffer;
varying vec2 uv;

void main() {
  vec4 accum = texture2D(accumBuffer, 0.5 * (uv + 1.0));
  gl_FragColor = min(vec4(1,1,1,1), accum);
}`
                        ]);
                        i.exports = function(f) {
                            return l(f, u, c, null, [
                                {
                                    name: "position",
                                    type: "vec2"
                                }
                            ]);
                        };
                    },
                    4100: function(i, a, o) {
                        "use strict";
                        var s = o(4437), l = o(3837), u = o(5445), c = o(4449), f = o(3589), h = o(2260), d = o(7169), v = o(351), x = o(4772), b = o(4040), p = o(799), E = o(9216)({
                            tablet: !0,
                            featureDetect: !0
                        });
                        i.exports = {
                            createScene: C,
                            createCamera: s
                        };
                        function k() {
                            this.mouse = [
                                -1,
                                -1
                            ], this.screen = null, this.distance = 1 / 0, this.index = null, this.dataCoordinate = null, this.dataPosition = null, this.object = null, this.data = null;
                        }
                        function A(g, P) {
                            var T = null;
                            try {
                                T = g.getContext("webgl", P), T || (T = g.getContext("experimental-webgl", P));
                            } catch (F) {
                                return null;
                            }
                            return T;
                        }
                        function L(g) {
                            var P = Math.round(Math.log(Math.abs(g)) / Math.log(10));
                            if (P < 0) {
                                var T = Math.round(Math.pow(10, -P));
                                return Math.ceil(g * T) / T;
                            } else if (P > 0) {
                                var T = Math.round(Math.pow(10, P));
                                return Math.ceil(g / T) * T;
                            }
                            return Math.ceil(g);
                        }
                        function _(g) {
                            return typeof g == "boolean" ? g : !0;
                        }
                        function C(g) {
                            g = g || {}, g.camera = g.camera || {};
                            var P = g.canvas;
                            if (!P) {
                                if (P = document.createElement("canvas"), g.container) {
                                    var T = g.container;
                                    T.appendChild(P);
                                } else document.body.appendChild(P);
                            }
                            var F = g.gl;
                            if (F || (g.glOptions && (E = !!g.glOptions.preserveDrawingBuffer), F = A(P, g.glOptions || {
                                premultipliedAlpha: !0,
                                antialias: !0,
                                preserveDrawingBuffer: E
                            })), !F) throw new Error("webgl not supported");
                            var q = g.bounds || [
                                [
                                    -10,
                                    -10,
                                    -10
                                ],
                                [
                                    10,
                                    10,
                                    10
                                ]
                            ], V = new k, H = h(F, F.drawingBufferWidth, F.drawingBufferHeight, {
                                preferFloat: !E
                            }), X = p(F), G = g.cameraObject && g.cameraObject._ortho === !0 || g.camera.projection && g.camera.projection.type === "orthographic" || !1, N = {
                                eye: g.camera.eye || [
                                    2,
                                    0,
                                    0
                                ],
                                center: g.camera.center || [
                                    0,
                                    0,
                                    0
                                ],
                                up: g.camera.up || [
                                    0,
                                    1,
                                    0
                                ],
                                zoomMin: g.camera.zoomMax || .1,
                                zoomMax: g.camera.zoomMin || 100,
                                mode: g.camera.mode || "turntable",
                                _ortho: G
                            }, W = g.axes || {}, re = l(F, W);
                            re.enable = !W.disable;
                            var ae = g.spikes || {}, _e = c(F, ae), Me = [], ke = [], ge = [], ie = [], Te = !0, Ce = !0, Ee = new Array(16), Ae = new Array(16), ze = {
                                view: null,
                                projection: Ee,
                                model: Ae,
                                _ortho: !1
                            }, Ce = !0, me = [
                                F.drawingBufferWidth,
                                F.drawingBufferHeight
                            ], Re = g.cameraObject || s(P, N), ce = {
                                gl: F,
                                contextLost: !1,
                                pixelRatio: g.pixelRatio || 1,
                                canvas: P,
                                selection: V,
                                camera: Re,
                                axes: re,
                                axesPixels: null,
                                spikes: _e,
                                bounds: q,
                                objects: Me,
                                shape: me,
                                aspect: g.aspectRatio || [
                                    1,
                                    1,
                                    1
                                ],
                                pickRadius: g.pickRadius || 10,
                                zNear: g.zNear || .01,
                                zFar: g.zFar || 1e3,
                                fovy: g.fovy || Math.PI / 4,
                                clearColor: g.clearColor || [
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                autoResize: _(g.autoResize),
                                autoBounds: _(g.autoBounds),
                                autoScale: !!g.autoScale,
                                autoCenter: _(g.autoCenter),
                                clipToBounds: _(g.clipToBounds),
                                snapToData: !!g.snapToData,
                                onselect: g.onselect || null,
                                onrender: g.onrender || null,
                                onclick: g.onclick || null,
                                cameraParams: ze,
                                oncontextloss: null,
                                mouseListener: null,
                                _stopped: !1,
                                getAspectratio: function() {
                                    return {
                                        x: this.aspect[0],
                                        y: this.aspect[1],
                                        z: this.aspect[2]
                                    };
                                },
                                setAspectratio: function(Yt) {
                                    this.aspect[0] = Yt.x, this.aspect[1] = Yt.y, this.aspect[2] = Yt.z, Ce = !0;
                                },
                                setBounds: function(Yt, xr) {
                                    this.bounds[0][Yt] = xr.min, this.bounds[1][Yt] = xr.max;
                                },
                                setClearColor: function(Yt) {
                                    this.clearColor = Yt;
                                },
                                clearRGBA: function() {
                                    this.gl.clearColor(this.clearColor[0], this.clearColor[1], this.clearColor[2], this.clearColor[3]), this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
                                }
                            }, Ge = [
                                F.drawingBufferWidth / ce.pixelRatio | 0,
                                F.drawingBufferHeight / ce.pixelRatio | 0
                            ];
                            function nt() {
                                if (!ce._stopped && ce.autoResize) {
                                    var Yt = P.parentNode, xr = 1, er = 1;
                                    Yt && Yt !== document.body ? (xr = Yt.clientWidth, er = Yt.clientHeight) : (xr = window.innerWidth, er = window.innerHeight);
                                    var Ke = Math.ceil(xr * ce.pixelRatio) | 0, xt = Math.ceil(er * ce.pixelRatio) | 0;
                                    if (Ke !== P.width || xt !== P.height) {
                                        P.width = Ke, P.height = xt;
                                        var bt = P.style;
                                        bt.position = bt.position || "absolute", bt.left = "0px", bt.top = "0px", bt.width = xr + "px", bt.height = er + "px", Te = !0;
                                    }
                                }
                            }
                            ce.autoResize && nt(), window.addEventListener("resize", nt);
                            function ct() {
                                for(var Yt = Me.length, xr = ie.length, er = 0; er < xr; ++er)ge[er] = 0;
                                e: for(var er = 0; er < Yt; ++er){
                                    var Ke = Me[er], xt = Ke.pickSlots;
                                    if (!xt) {
                                        ke[er] = -1;
                                        continue;
                                    }
                                    for(var bt = 0; bt < xr; ++bt)if (ge[bt] + xt < 255) {
                                        ke[er] = bt, Ke.setPickBase(ge[bt] + 1), ge[bt] += xt;
                                        continue e;
                                    }
                                    var Lt = f(F, me);
                                    ke[er] = xr, ie.push(Lt), ge.push(xt), Ke.setPickBase(1), xr += 1;
                                }
                                for(; xr > 0 && ge[xr - 1] === 0;)ge.pop(), ie.pop().dispose();
                            }
                            ce.update = function(Yt) {
                                ce._stopped || (Yt = Yt || {}, Te = !0, Ce = !0);
                            }, ce.add = function(Yt) {
                                ce._stopped || (Yt.axes = re, Me.push(Yt), ke.push(-1), Te = !0, Ce = !0, ct());
                            }, ce.remove = function(Yt) {
                                if (!ce._stopped) {
                                    var xr = Me.indexOf(Yt);
                                    xr < 0 || (Me.splice(xr, 1), ke.pop(), Te = !0, Ce = !0, ct());
                                }
                            }, ce.dispose = function() {
                                if (!ce._stopped && (ce._stopped = !0, window.removeEventListener("resize", nt), P.removeEventListener("webglcontextlost", qt), ce.mouseListener.enabled = !1, !ce.contextLost)) {
                                    re.dispose(), _e.dispose();
                                    for(var Yt = 0; Yt < Me.length; ++Yt)Me[Yt].dispose();
                                    H.dispose();
                                    for(var Yt = 0; Yt < ie.length; ++Yt)ie[Yt].dispose();
                                    X.dispose(), F = null, re = null, _e = null, Me = [];
                                }
                            }, ce._mouseRotating = !1, ce._prevButtons = 0, ce.enableMouseListeners = function() {
                                ce.mouseListener = v(P, function(Yt, xr, er) {
                                    if (!ce._stopped) {
                                        var Ke = ie.length, xt = Me.length, bt = V.object;
                                        V.distance = 1 / 0, V.mouse[0] = xr, V.mouse[1] = er, V.object = null, V.screen = null, V.dataCoordinate = V.dataPosition = null;
                                        var Lt = !1;
                                        if (Yt && ce._prevButtons) ce._mouseRotating = !0;
                                        else {
                                            ce._mouseRotating && (Ce = !0), ce._mouseRotating = !1;
                                            for(var St = 0; St < Ke; ++St){
                                                var Et = ie[St].query(xr, Ge[1] - er - 1, ce.pickRadius);
                                                if (Et) {
                                                    if (Et.distance > V.distance) continue;
                                                    for(var dt = 0; dt < xt; ++dt){
                                                        var Ht = Me[dt];
                                                        if (ke[dt] === St) {
                                                            var $t = Ht.pick(Et);
                                                            $t && (V.buttons = Yt, V.screen = Et.coord, V.distance = Et.distance, V.object = Ht, V.index = $t.distance, V.dataPosition = $t.position, V.dataCoordinate = $t.dataCoordinate, V.data = $t, Lt = !0);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        bt && bt !== V.object && (bt.highlight && bt.highlight(null), Te = !0), V.object && (V.object.highlight && V.object.highlight(V.data), Te = !0), Lt = Lt || V.object !== bt, Lt && ce.onselect && ce.onselect(V), Yt & 1 && !(ce._prevButtons & 1) && ce.onclick && ce.onclick(V), ce._prevButtons = Yt;
                                    }
                                });
                            };
                            function qt() {
                                if (ce.contextLost) return !0;
                                F.isContextLost() && (ce.contextLost = !0, ce.mouseListener.enabled = !1, ce.selection.object = null, ce.oncontextloss && ce.oncontextloss());
                            }
                            P.addEventListener("webglcontextlost", qt);
                            function rt() {
                                if (!qt()) {
                                    F.colorMask(!0, !0, !0, !0), F.depthMask(!0), F.disable(F.BLEND), F.enable(F.DEPTH_TEST), F.depthFunc(F.LEQUAL);
                                    for(var Yt = Me.length, xr = ie.length, er = 0; er < xr; ++er){
                                        var Ke = ie[er];
                                        Ke.shape = Ge, Ke.begin();
                                        for(var xt = 0; xt < Yt; ++xt)if (ke[xt] === er) {
                                            var bt = Me[xt];
                                            bt.drawPick && (bt.pixelRatio = 1, bt.drawPick(ze));
                                        }
                                        Ke.end();
                                    }
                                }
                            }
                            var ot = [
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ],
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ]
                            ], Rt = [
                                ot[0].slice(),
                                ot[1].slice()
                            ];
                            function kt() {
                                if (!qt()) {
                                    nt();
                                    var Yt = ce.camera.tick();
                                    ze.view = ce.camera.matrix, Te = Te || Yt, Ce = Ce || Yt, re.pixelRatio = ce.pixelRatio, _e.pixelRatio = ce.pixelRatio;
                                    var xr = Me.length, er = ot[0], Ke = ot[1];
                                    er[0] = er[1] = er[2] = 1 / 0, Ke[0] = Ke[1] = Ke[2] = -1 / 0;
                                    for(var xt = 0; xt < xr; ++xt){
                                        var bt = Me[xt];
                                        bt.pixelRatio = ce.pixelRatio, bt.axes = ce.axes, Te = Te || !!bt.dirty, Ce = Ce || !!bt.dirty;
                                        var Lt = bt.bounds;
                                        if (Lt) for(var St = Lt[0], Et = Lt[1], dt = 0; dt < 3; ++dt)er[dt] = Math.min(er[dt], St[dt]), Ke[dt] = Math.max(Ke[dt], Et[dt]);
                                    }
                                    var Ht = ce.bounds;
                                    if (ce.autoBounds) for(var dt = 0; dt < 3; ++dt){
                                        if (Ke[dt] < er[dt]) er[dt] = -1, Ke[dt] = 1;
                                        else {
                                            er[dt] === Ke[dt] && (er[dt] -= 1, Ke[dt] += 1);
                                            var $t = .05 * (Ke[dt] - er[dt]);
                                            er[dt] = er[dt] - $t, Ke[dt] = Ke[dt] + $t;
                                        }
                                        Ht[0][dt] = er[dt], Ht[1][dt] = Ke[dt];
                                    }
                                    for(var fr = !1, dt = 0; dt < 3; ++dt)fr = fr || Rt[0][dt] !== Ht[0][dt] || Rt[1][dt] !== Ht[1][dt], Rt[0][dt] = Ht[0][dt], Rt[1][dt] = Ht[1][dt];
                                    if (Ce = Ce || fr, Te = Te || fr, !!Te) {
                                        if (fr) {
                                            for(var _r = [
                                                0,
                                                0,
                                                0
                                            ], xt = 0; xt < 3; ++xt)_r[xt] = L((Ht[1][xt] - Ht[0][xt]) / 10);
                                            re.autoTicks ? re.update({
                                                bounds: Ht,
                                                tickSpacing: _r
                                            }) : re.update({
                                                bounds: Ht
                                            });
                                        }
                                        var Br = F.drawingBufferWidth, Or = F.drawingBufferHeight;
                                        me[0] = Br, me[1] = Or, Ge[0] = Math.max(Br / ce.pixelRatio, 1) | 0, Ge[1] = Math.max(Or / ce.pixelRatio, 1) | 0, M(ce, G);
                                        for(var xt = 0; xt < xr; ++xt){
                                            var bt = Me[xt];
                                            bt.axesBounds = Ht, ce.clipToBounds && (bt.clipBounds = Ht);
                                        }
                                        V.object && (ce.snapToData ? _e.position = V.dataCoordinate : _e.position = V.dataPosition, _e.bounds = Ht), Ce && (Ce = !1, rt()), ce.axesPixels = u(ce.axes, ze, Br, Or), ce.onrender && ce.onrender(), F.bindFramebuffer(F.FRAMEBUFFER, null), F.viewport(0, 0, Br, Or), ce.clearRGBA(), F.depthMask(!0), F.colorMask(!0, !0, !0, !0), F.enable(F.DEPTH_TEST), F.depthFunc(F.LEQUAL), F.disable(F.BLEND), F.disable(F.CULL_FACE);
                                        var Nr = !1;
                                        re.enable && (Nr = Nr || re.isTransparent(), re.draw(ze)), _e.axes = re, V.object && _e.draw(ze), F.disable(F.CULL_FACE);
                                        for(var xt = 0; xt < xr; ++xt){
                                            var bt = Me[xt];
                                            bt.axes = re, bt.pixelRatio = ce.pixelRatio, bt.isOpaque && bt.isOpaque() && bt.draw(ze), bt.isTransparent && bt.isTransparent() && (Nr = !0);
                                        }
                                        if (Nr) {
                                            H.shape = me, H.bind(), F.clear(F.DEPTH_BUFFER_BIT), F.colorMask(!1, !1, !1, !1), F.depthMask(!0), F.depthFunc(F.LESS), re.enable && re.isTransparent() && re.drawTransparent(ze);
                                            for(var xt = 0; xt < xr; ++xt){
                                                var bt = Me[xt];
                                                bt.isOpaque && bt.isOpaque() && bt.draw(ze);
                                            }
                                            F.enable(F.BLEND), F.blendEquation(F.FUNC_ADD), F.blendFunc(F.ONE, F.ONE_MINUS_SRC_ALPHA), F.colorMask(!0, !0, !0, !0), F.depthMask(!1), F.clearColor(0, 0, 0, 0), F.clear(F.COLOR_BUFFER_BIT), re.isTransparent() && re.drawTransparent(ze);
                                            for(var xt = 0; xt < xr; ++xt){
                                                var bt = Me[xt];
                                                bt.isTransparent && bt.isTransparent() && bt.drawTransparent(ze);
                                            }
                                            F.bindFramebuffer(F.FRAMEBUFFER, null), F.blendFunc(F.ONE, F.ONE_MINUS_SRC_ALPHA), F.disable(F.DEPTH_TEST), X.bind(), H.color[0].bind(0), X.uniforms.accumBuffer = 0, d(F), F.disable(F.BLEND);
                                        }
                                        Te = !1;
                                        for(var xt = 0; xt < xr; ++xt)Me[xt].dirty = !1;
                                    }
                                }
                            }
                            function Ct() {
                                ce._stopped || ce.contextLost || (kt(), requestAnimationFrame(Ct));
                            }
                            return ce.enableMouseListeners(), Ct(), ce.redraw = function() {
                                ce._stopped || (Te = !0, kt());
                            }, ce;
                        }
                        function M(g, P) {
                            var T = g.bounds, F = g.cameraParams, q = F.projection, V = F.model, H = g.gl.drawingBufferWidth, X = g.gl.drawingBufferHeight, G = g.zNear, N = g.zFar, W = g.fovy, re = H / X;
                            P ? (b(q, -re, re, -1, 1, G, N), F._ortho = !0) : (x(q, W, re, G, N), F._ortho = !1);
                            for(var ae = 0; ae < 16; ++ae)V[ae] = 0;
                            V[15] = 1;
                            for(var _e = 0, ae = 0; ae < 3; ++ae)_e = Math.max(_e, T[1][ae] - T[0][ae]);
                            for(var ae = 0; ae < 3; ++ae)g.autoScale ? V[5 * ae] = g.aspect[ae] / (T[1][ae] - T[0][ae]) : V[5 * ae] = 1 / _e, g.autoCenter && (V[12 + ae] = -V[5 * ae] * .5 * (T[0][ae] + T[1][ae]));
                        }
                    },
                    783: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            var c = s[0], f = s[1], h = s[2], d = s[3], v = l[0], x = l[1], b = l[2], p = l[3], E, k, A, L, _;
                            return k = c * v + f * x + h * b + d * p, k < 0 && (k = -k, v = -v, x = -x, b = -b, p = -p), 1 - k > 1e-6 ? (E = Math.acos(k), A = Math.sin(E), L = Math.sin((1 - u) * E) / A, _ = Math.sin(u * E) / A) : (L = 1 - u, _ = u), o[0] = L * c + _ * v, o[1] = L * f + _ * x, o[2] = L * h + _ * b, o[3] = L * d + _ * p, o;
                        }
                    },
                    5964: function(i) {
                        "use strict";
                        i.exports = function(a) {
                            return !a && a !== 0 ? "" : a.toString();
                        };
                    },
                    9366: function(i, a, o) {
                        "use strict";
                        var s = o(4359);
                        i.exports = u;
                        var l = {};
                        function u(c, f, h) {
                            var d = [
                                f.style,
                                f.weight,
                                f.variant,
                                f.family
                            ].join("_"), v = l[d];
                            if (v || (v = l[d] = {}), c in v) return v[c];
                            var x = {
                                textAlign: "center",
                                textBaseline: "middle",
                                lineHeight: 1,
                                font: f.family,
                                fontStyle: f.style,
                                fontWeight: f.weight,
                                fontVariant: f.variant,
                                lineSpacing: 1.25,
                                styletags: {
                                    breaklines: !0,
                                    bolds: !0,
                                    italics: !0,
                                    subscripts: !0,
                                    superscripts: !0
                                }
                            };
                            x.triangles = !0;
                            var b = s(c, x);
                            x.triangles = !1;
                            var p = s(c, x), E, k;
                            if (h && h !== 1) {
                                for(E = 0; E < b.positions.length; ++E)for(k = 0; k < b.positions[E].length; ++k)b.positions[E][k] /= h;
                                for(E = 0; E < p.positions.length; ++E)for(k = 0; k < p.positions[E].length; ++k)p.positions[E][k] /= h;
                            }
                            var A = [
                                [
                                    1 / 0,
                                    1 / 0
                                ],
                                [
                                    -1 / 0,
                                    -1 / 0
                                ]
                            ], L = p.positions.length;
                            for(E = 0; E < L; ++E){
                                var _ = p.positions[E];
                                for(k = 0; k < 2; ++k)A[0][k] = Math.min(A[0][k], _[k]), A[1][k] = Math.max(A[1][k], _[k]);
                            }
                            return v[c] = [
                                b,
                                p,
                                A
                            ];
                        }
                    },
                    1283: function(i, a, o) {
                        var s = o(9405), l = o(3236), u = l([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

attribute vec3 position;
attribute vec4 color;
attribute vec2 glyph;
attribute vec4 id;

uniform vec4 highlightId;
uniform float highlightScale;
uniform mat4 model, view, projection;
uniform vec3 clipBounds[2];

varying vec4 interpColor;
varying vec4 pickId;
varying vec3 dataCoordinate;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], position)) {

    gl_Position = vec4(0,0,0,0);
  } else {
    float scale = 1.0;
    if(distance(highlightId, id) < 0.0001) {
      scale = highlightScale;
    }

    vec4 worldPosition = model * vec4(position, 1);
    vec4 viewPosition = view * worldPosition;
    viewPosition = viewPosition / viewPosition.w;
    vec4 clipPosition = projection * (viewPosition + scale * vec4(glyph.x, -glyph.y, 0, 0));

    gl_Position = clipPosition;
    interpColor = color;
    pickId = id;
    dataCoordinate = position;
  }
}`
                        ]), c = l([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

attribute vec3 position;
attribute vec4 color;
attribute vec2 glyph;
attribute vec4 id;

uniform mat4 model, view, projection;
uniform vec2 screenSize;
uniform vec3 clipBounds[2];
uniform float highlightScale, pixelRatio;
uniform vec4 highlightId;

varying vec4 interpColor;
varying vec4 pickId;
varying vec3 dataCoordinate;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], position)) {

    gl_Position = vec4(0,0,0,0);
  } else {
    float scale = pixelRatio;
    if(distance(highlightId.bgr, id.bgr) < 0.001) {
      scale *= highlightScale;
    }

    vec4 worldPosition = model * vec4(position, 1.0);
    vec4 viewPosition = view * worldPosition;
    vec4 clipPosition = projection * viewPosition;
    clipPosition /= clipPosition.w;

    gl_Position = clipPosition + vec4(screenSize * scale * vec2(glyph.x, -glyph.y), 0.0, 0.0);
    interpColor = color;
    pickId = id;
    dataCoordinate = position;
  }
}`
                        ]), f = l([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

attribute vec3 position;
attribute vec4 color;
attribute vec2 glyph;
attribute vec4 id;

uniform float highlightScale;
uniform vec4 highlightId;
uniform vec3 axes[2];
uniform mat4 model, view, projection;
uniform vec2 screenSize;
uniform vec3 clipBounds[2];
uniform float scale, pixelRatio;

varying vec4 interpColor;
varying vec4 pickId;
varying vec3 dataCoordinate;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], position)) {

    gl_Position = vec4(0,0,0,0);
  } else {
    float lscale = pixelRatio * scale;
    if(distance(highlightId, id) < 0.0001) {
      lscale *= highlightScale;
    }

    vec4 clipCenter   = projection * (view * (model * vec4(position, 1)));
    vec3 dataPosition = position + 0.5*lscale*(axes[0] * glyph.x + axes[1] * glyph.y) * clipCenter.w * screenSize.y;
    vec4 clipPosition = projection * (view * (model * vec4(dataPosition, 1)));

    gl_Position = clipPosition;
    interpColor = color;
    pickId = id;
    dataCoordinate = dataPosition;
  }
}
`
                        ]), h = l([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3 fragClipBounds[2];
uniform float opacity;

varying vec4 interpColor;
varying vec3 dataCoordinate;

void main() {
  if (
    outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate) ||
    interpColor.a * opacity == 0.
  ) discard;
  gl_FragColor = interpColor * opacity;
}
`
                        ]), d = l([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3 fragClipBounds[2];
uniform float pickGroup;

varying vec4 pickId;
varying vec3 dataCoordinate;

void main() {
  if (outOfRange(fragClipBounds[0], fragClipBounds[1], dataCoordinate)) discard;

  gl_FragColor = vec4(pickGroup, pickId.bgr);
}`
                        ]), v = [
                            {
                                name: "position",
                                type: "vec3"
                            },
                            {
                                name: "color",
                                type: "vec4"
                            },
                            {
                                name: "glyph",
                                type: "vec2"
                            },
                            {
                                name: "id",
                                type: "vec4"
                            }
                        ], x = {
                            vertex: u,
                            fragment: h,
                            attributes: v
                        }, b = {
                            vertex: c,
                            fragment: h,
                            attributes: v
                        }, p = {
                            vertex: f,
                            fragment: h,
                            attributes: v
                        }, E = {
                            vertex: u,
                            fragment: d,
                            attributes: v
                        }, k = {
                            vertex: c,
                            fragment: d,
                            attributes: v
                        }, A = {
                            vertex: f,
                            fragment: d,
                            attributes: v
                        };
                        function L(_, C) {
                            var M = s(_, C), g = M.attributes;
                            return g.position.location = 0, g.color.location = 1, g.glyph.location = 2, g.id.location = 3, M;
                        }
                        a.createPerspective = function(_) {
                            return L(_, x);
                        }, a.createOrtho = function(_) {
                            return L(_, b);
                        }, a.createProject = function(_) {
                            return L(_, p);
                        }, a.createPickPerspective = function(_) {
                            return L(_, E);
                        }, a.createPickOrtho = function(_) {
                            return L(_, k);
                        }, a.createPickProject = function(_) {
                            return L(_, A);
                        };
                    },
                    8418: function(i, a, o) {
                        "use strict";
                        var s = o(5219), l = o(2762), u = o(8116), c = o(1888), f = o(6760), h = o(1283), d = o(9366), v = o(5964), x = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ], b = ArrayBuffer, p = DataView;
                        function E(Ae) {
                            return b.isView(Ae) && !(Ae instanceof p);
                        }
                        function k(Ae) {
                            return Array.isArray(Ae) || E(Ae);
                        }
                        i.exports = Ee;
                        function A(Ae, ze) {
                            var Ce = Ae[0], me = Ae[1], Re = Ae[2], ce = Ae[3];
                            return Ae[0] = ze[0] * Ce + ze[4] * me + ze[8] * Re + ze[12] * ce, Ae[1] = ze[1] * Ce + ze[5] * me + ze[9] * Re + ze[13] * ce, Ae[2] = ze[2] * Ce + ze[6] * me + ze[10] * Re + ze[14] * ce, Ae[3] = ze[3] * Ce + ze[7] * me + ze[11] * Re + ze[15] * ce, Ae;
                        }
                        function L(Ae, ze, Ce, me) {
                            return A(me, me, Ce), A(me, me, ze), A(me, me, Ae);
                        }
                        function _(Ae, ze) {
                            this.index = Ae, this.dataCoordinate = this.position = ze;
                        }
                        function C(Ae) {
                            return Ae === !0 || Ae > 1 ? 1 : Ae;
                        }
                        function M(Ae, ze, Ce, me, Re, ce, Ge, nt, ct, qt, rt, ot) {
                            this.gl = Ae, this.pixelRatio = 1, this.shader = ze, this.orthoShader = Ce, this.projectShader = me, this.pointBuffer = Re, this.colorBuffer = ce, this.glyphBuffer = Ge, this.idBuffer = nt, this.vao = ct, this.vertexCount = 0, this.lineVertexCount = 0, this.opacity = 1, this.hasAlpha = !1, this.lineWidth = 0, this.projectScale = [
                                .6666666666666666,
                                .6666666666666666,
                                .6666666666666666
                            ], this.projectOpacity = [
                                1,
                                1,
                                1
                            ], this.projectHasAlpha = !1, this.pickId = 0, this.pickPerspectiveShader = qt, this.pickOrthoShader = rt, this.pickProjectShader = ot, this.points = [], this._selectResult = new _(0, [
                                0,
                                0,
                                0
                            ]), this.useOrtho = !0, this.bounds = [
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ],
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ]
                            ], this.axesProject = [
                                !0,
                                !0,
                                !0
                            ], this.axesBounds = [
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ],
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ]
                            ], this.highlightId = [
                                1,
                                1,
                                1,
                                1
                            ], this.highlightScale = 2, this.clipBounds = [
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ],
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ]
                            ], this.dirty = !0;
                        }
                        var g = M.prototype;
                        g.pickSlots = 1, g.setPickBase = function(Ae) {
                            this.pickId = Ae;
                        }, g.isTransparent = function() {
                            if (this.hasAlpha) return !0;
                            for(var Ae = 0; Ae < 3; ++Ae)if (this.axesProject[Ae] && this.projectHasAlpha) return !0;
                            return !1;
                        }, g.isOpaque = function() {
                            if (!this.hasAlpha) return !0;
                            for(var Ae = 0; Ae < 3; ++Ae)if (this.axesProject[Ae] && !this.projectHasAlpha) return !0;
                            return !1;
                        };
                        var P = [
                            0,
                            0
                        ], T = [
                            0,
                            0,
                            0
                        ], F = [
                            0,
                            0,
                            0
                        ], q = [
                            0,
                            0,
                            0,
                            1
                        ], V = [
                            0,
                            0,
                            0,
                            1
                        ], H = x.slice(), X = [
                            0,
                            0,
                            0
                        ], G = [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0
                            ]
                        ];
                        function N(Ae) {
                            return Ae[0] = Ae[1] = Ae[2] = 0, Ae;
                        }
                        function W(Ae, ze) {
                            return Ae[0] = ze[0], Ae[1] = ze[1], Ae[2] = ze[2], Ae[3] = 1, Ae;
                        }
                        function re(Ae, ze, Ce, me) {
                            return Ae[0] = ze[0], Ae[1] = ze[1], Ae[2] = ze[2], Ae[Ce] = me, Ae;
                        }
                        function ae(Ae) {
                            for(var ze = G, Ce = 0; Ce < 2; ++Ce)for(var me = 0; me < 3; ++me)ze[Ce][me] = Math.max(Math.min(Ae[Ce][me], 1e8), -100000000);
                            return ze;
                        }
                        function _e(Ae, ze, Ce, me) {
                            var Re = ze.axesProject, ce = ze.gl, Ge = Ae.uniforms, nt = Ce.model || x, ct = Ce.view || x, qt = Ce.projection || x, rt = ze.axesBounds, ot = ae(ze.clipBounds), Rt;
                            ze.axes && ze.axes.lastCubeProps ? Rt = ze.axes.lastCubeProps.axis : Rt = [
                                1,
                                1,
                                1
                            ], P[0] = 2 / ce.drawingBufferWidth, P[1] = 2 / ce.drawingBufferHeight, Ae.bind(), Ge.view = ct, Ge.projection = qt, Ge.screenSize = P, Ge.highlightId = ze.highlightId, Ge.highlightScale = ze.highlightScale, Ge.clipBounds = ot, Ge.pickGroup = ze.pickId / 255, Ge.pixelRatio = me;
                            for(var kt = 0; kt < 3; ++kt)if (Re[kt]) {
                                Ge.scale = ze.projectScale[kt], Ge.opacity = ze.projectOpacity[kt];
                                for(var Ct = H, Yt = 0; Yt < 16; ++Yt)Ct[Yt] = 0;
                                for(var Yt = 0; Yt < 4; ++Yt)Ct[5 * Yt] = 1;
                                Ct[5 * kt] = 0, Rt[kt] < 0 ? Ct[12 + kt] = rt[0][kt] : Ct[12 + kt] = rt[1][kt], f(Ct, nt, Ct), Ge.model = Ct;
                                var xr = (kt + 1) % 3, er = (kt + 2) % 3, Ke = N(T), xt = N(F);
                                Ke[xr] = 1, xt[er] = 1;
                                var bt = L(qt, ct, nt, W(q, Ke)), Lt = L(qt, ct, nt, W(V, xt));
                                if (Math.abs(bt[1]) > Math.abs(Lt[1])) {
                                    var St = bt;
                                    bt = Lt, Lt = St, St = Ke, Ke = xt, xt = St;
                                    var Et = xr;
                                    xr = er, er = Et;
                                }
                                bt[0] < 0 && (Ke[xr] = -1), Lt[1] > 0 && (xt[er] = -1);
                                for(var dt = 0, Ht = 0, Yt = 0; Yt < 4; ++Yt)dt += Math.pow(nt[4 * xr + Yt], 2), Ht += Math.pow(nt[4 * er + Yt], 2);
                                Ke[xr] /= Math.sqrt(dt), xt[er] /= Math.sqrt(Ht), Ge.axes[0] = Ke, Ge.axes[1] = xt, Ge.fragClipBounds[0] = re(X, ot[0], kt, -100000000), Ge.fragClipBounds[1] = re(X, ot[1], kt, 1e8), ze.vao.bind(), ze.vao.draw(ce.TRIANGLES, ze.vertexCount), ze.lineWidth > 0 && (ce.lineWidth(ze.lineWidth * me), ze.vao.draw(ce.LINES, ze.lineVertexCount, ze.vertexCount)), ze.vao.unbind();
                            }
                        }
                        var Me = [
                            -100000000,
                            -100000000,
                            -100000000
                        ], ke = [
                            1e8,
                            1e8,
                            1e8
                        ], ge = [
                            Me,
                            ke
                        ];
                        function ie(Ae, ze, Ce, me, Re, ce, Ge) {
                            var nt = Ce.gl;
                            if ((ce === Ce.projectHasAlpha || Ge) && _e(ze, Ce, me, Re), ce === Ce.hasAlpha || Ge) {
                                Ae.bind();
                                var ct = Ae.uniforms;
                                ct.model = me.model || x, ct.view = me.view || x, ct.projection = me.projection || x, P[0] = 2 / nt.drawingBufferWidth, P[1] = 2 / nt.drawingBufferHeight, ct.screenSize = P, ct.highlightId = Ce.highlightId, ct.highlightScale = Ce.highlightScale, ct.fragClipBounds = ge, ct.clipBounds = Ce.axes.bounds, ct.opacity = Ce.opacity, ct.pickGroup = Ce.pickId / 255, ct.pixelRatio = Re, Ce.vao.bind(), Ce.vao.draw(nt.TRIANGLES, Ce.vertexCount), Ce.lineWidth > 0 && (nt.lineWidth(Ce.lineWidth * Re), Ce.vao.draw(nt.LINES, Ce.lineVertexCount, Ce.vertexCount)), Ce.vao.unbind();
                            }
                        }
                        g.draw = function(Ae) {
                            var ze = this.useOrtho ? this.orthoShader : this.shader;
                            ie(ze, this.projectShader, this, Ae, this.pixelRatio, !1, !1);
                        }, g.drawTransparent = function(Ae) {
                            var ze = this.useOrtho ? this.orthoShader : this.shader;
                            ie(ze, this.projectShader, this, Ae, this.pixelRatio, !0, !1);
                        }, g.drawPick = function(Ae) {
                            var ze = this.useOrtho ? this.pickOrthoShader : this.pickPerspectiveShader;
                            ie(ze, this.pickProjectShader, this, Ae, 1, !0, !0);
                        }, g.pick = function(Ae) {
                            if (!Ae || Ae.id !== this.pickId) return null;
                            var ze = Ae.value[2] + (Ae.value[1] << 8) + (Ae.value[0] << 16);
                            if (ze >= this.pointCount || ze < 0) return null;
                            var Ce = this.points[ze], me = this._selectResult;
                            me.index = ze;
                            for(var Re = 0; Re < 3; ++Re)me.position[Re] = me.dataCoordinate[Re] = Ce[Re];
                            return me;
                        }, g.highlight = function(Ae) {
                            if (!Ae) this.highlightId = [
                                1,
                                1,
                                1,
                                1
                            ];
                            else {
                                var ze = Ae.index, Ce = ze & 255, me = ze >> 8 & 255, Re = ze >> 16 & 255;
                                this.highlightId = [
                                    Ce / 255,
                                    me / 255,
                                    Re / 255,
                                    0
                                ];
                            }
                        };
                        function Te(Ae, ze, Ce, me) {
                            var Re;
                            k(Ae) ? ze < Ae.length ? Re = Ae[ze] : Re = void 0 : Re = Ae, Re = v(Re);
                            var ce = !0;
                            s(Re) && (Re = "\u25BC", ce = !1), Ce || (Ce = {});
                            var Ge = Ce.family;
                            k(Ge) && (Ge = Ge[ze]), Ge || (Ge = "normal");
                            var nt = Ce.weight;
                            k(nt) && (nt = nt[ze]), nt || (nt = "normal");
                            var ct = Ce.style;
                            k(ct) && (ct = ct[ze]), ct || (ct = "normal");
                            var qt = Ce.variant;
                            k(qt) && (qt = qt[ze]), qt || (qt = "normal");
                            var rt = d(Re, {
                                family: Ge,
                                weight: nt,
                                style: ct,
                                variant: qt
                            }, me), rt = d(Re, Ce, me);
                            return {
                                mesh: rt[0],
                                lines: rt[1],
                                bounds: rt[2],
                                visible: ce
                            };
                        }
                        g.update = function(Ae) {
                            if (Ae = Ae || {}, "perspective" in Ae && (this.useOrtho = !Ae.perspective), "orthographic" in Ae && (this.useOrtho = !!Ae.orthographic), "lineWidth" in Ae && (this.lineWidth = Ae.lineWidth), "project" in Ae) {
                                if (k(Ae.project)) this.axesProject = Ae.project;
                                else {
                                    var ze = !!Ae.project;
                                    this.axesProject = [
                                        ze,
                                        ze,
                                        ze
                                    ];
                                }
                            }
                            if ("projectScale" in Ae) {
                                if (k(Ae.projectScale)) this.projectScale = Ae.projectScale.slice();
                                else {
                                    var Ce = +Ae.projectScale;
                                    this.projectScale = [
                                        Ce,
                                        Ce,
                                        Ce
                                    ];
                                }
                            }
                            if (this.projectHasAlpha = !1, "projectOpacity" in Ae) {
                                if (k(Ae.projectOpacity)) this.projectOpacity = Ae.projectOpacity.slice();
                                else {
                                    var Ce = +Ae.projectOpacity;
                                    this.projectOpacity = [
                                        Ce,
                                        Ce,
                                        Ce
                                    ];
                                }
                                for(var me = 0; me < 3; ++me)this.projectOpacity[me] = C(this.projectOpacity[me]), this.projectOpacity[me] < 1 && (this.projectHasAlpha = !0);
                            }
                            this.hasAlpha = !1, "opacity" in Ae && (this.opacity = C(Ae.opacity), this.opacity < 1 && (this.hasAlpha = !0)), this.dirty = !0;
                            var Re = Ae.position, ce = {
                                family: Ae.font || "normal",
                                style: Ae.fontStyle || "normal",
                                weight: Ae.fontWeight || "normal",
                                variant: Ae.fontVariant || "normal"
                            }, Ge = Ae.alignment || [
                                0,
                                0
                            ], nt, ct;
                            if (Ge.length === 2) nt = Ge[0], ct = Ge[1];
                            else {
                                nt = [], ct = [];
                                for(var me = 0; me < Ge.length; ++me)nt[me] = Ge[me][0], ct[me] = Ge[me][1];
                            }
                            var qt = [
                                1 / 0,
                                1 / 0,
                                1 / 0
                            ], rt = [
                                -1 / 0,
                                -1 / 0,
                                -1 / 0
                            ], ot = Ae.glyph, Rt = Ae.color, kt = Ae.size, Ct = Ae.angle, Yt = Ae.lineColor, xr = -1, er = 0, Ke = 0, xt = 0;
                            if (Re.length) {
                                xt = Re.length;
                                e: for(var me = 0; me < xt; ++me){
                                    for(var bt = Re[me], Lt = 0; Lt < 3; ++Lt)if (isNaN(bt[Lt]) || !isFinite(bt[Lt])) continue e;
                                    var St = Te(ot, me, ce, this.pixelRatio), Et = St.mesh, dt = St.lines, Ht = St.bounds;
                                    er += Et.cells.length * 3, Ke += dt.edges.length * 2;
                                }
                            }
                            var $t = er + Ke, fr = c.mallocFloat(3 * $t), _r = c.mallocFloat(4 * $t), Br = c.mallocFloat(2 * $t), Or = c.mallocUint32($t);
                            if ($t > 0) {
                                var Nr = 0, ut = er, Ne = [
                                    0,
                                    0,
                                    0,
                                    1
                                ], Ye = [
                                    0,
                                    0,
                                    0,
                                    1
                                ], Ve = k(Rt) && k(Rt[0]), Xe = k(Yt) && k(Yt[0]);
                                e: for(var me = 0; me < xt; ++me){
                                    xr += 1;
                                    for(var bt = Re[me], Lt = 0; Lt < 3; ++Lt){
                                        if (isNaN(bt[Lt]) || !isFinite(bt[Lt])) continue e;
                                        rt[Lt] = Math.max(rt[Lt], bt[Lt]), qt[Lt] = Math.min(qt[Lt], bt[Lt]);
                                    }
                                    var St = Te(ot, me, ce, this.pixelRatio), Et = St.mesh, dt = St.lines, Ht = St.bounds, ht = St.visible;
                                    if (!ht) Ne = [
                                        1,
                                        1,
                                        1,
                                        0
                                    ];
                                    else if (k(Rt)) {
                                        var Le;
                                        if (Ve ? me < Rt.length ? Le = Rt[me] : Le = [
                                            0,
                                            0,
                                            0,
                                            0
                                        ] : Le = Rt, Le.length === 3) {
                                            for(var Lt = 0; Lt < 3; ++Lt)Ne[Lt] = Le[Lt];
                                            Ne[3] = 1;
                                        } else if (Le.length === 4) {
                                            for(var Lt = 0; Lt < 4; ++Lt)Ne[Lt] = Le[Lt];
                                            !this.hasAlpha && Le[3] < 1 && (this.hasAlpha = !0);
                                        }
                                    } else Ne[0] = Ne[1] = Ne[2] = 0, Ne[3] = 1;
                                    if (!ht) Ye = [
                                        1,
                                        1,
                                        1,
                                        0
                                    ];
                                    else if (k(Yt)) {
                                        var Le;
                                        if (Xe ? me < Yt.length ? Le = Yt[me] : Le = [
                                            0,
                                            0,
                                            0,
                                            0
                                        ] : Le = Yt, Le.length === 3) {
                                            for(var Lt = 0; Lt < 3; ++Lt)Ye[Lt] = Le[Lt];
                                            Ye[Lt] = 1;
                                        } else if (Le.length === 4) {
                                            for(var Lt = 0; Lt < 4; ++Lt)Ye[Lt] = Le[Lt];
                                            !this.hasAlpha && Le[3] < 1 && (this.hasAlpha = !0);
                                        }
                                    } else Ye[0] = Ye[1] = Ye[2] = 0, Ye[3] = 1;
                                    var xe = .5;
                                    ht ? k(kt) ? me < kt.length ? xe = +kt[me] : xe = 12 : kt ? xe = +kt : this.useOrtho && (xe = 12) : xe = 0;
                                    var Se = 0;
                                    k(Ct) ? me < Ct.length ? Se = +Ct[me] : Se = 0 : Ct && (Se = +Ct);
                                    for(var lt = Math.cos(Se), Gt = Math.sin(Se), bt = Re[me], Lt = 0; Lt < 3; ++Lt)rt[Lt] = Math.max(rt[Lt], bt[Lt]), qt[Lt] = Math.min(qt[Lt], bt[Lt]);
                                    var Vt = nt, ar = ct, Vt = 0;
                                    k(nt) ? me < nt.length ? Vt = nt[me] : Vt = 0 : nt && (Vt = nt);
                                    var ar = 0;
                                    k(ct) ? me < ct.length ? ar = ct[me] : ar = 0 : ct && (ar = ct), Vt *= Vt > 0 ? 1 - Ht[0][0] : Vt < 0 ? 1 + Ht[1][0] : 1, ar *= ar > 0 ? 1 - Ht[0][1] : ar < 0 ? 1 + Ht[1][1] : 1;
                                    for(var Qr = [
                                        Vt,
                                        ar
                                    ], nn = Et.cells || [], Wi = Et.positions || [], Lt = 0; Lt < nn.length; ++Lt)for(var ai = nn[Lt], jr = 0; jr < 3; ++jr){
                                        for(var ri = 0; ri < 3; ++ri)fr[3 * Nr + ri] = bt[ri];
                                        for(var ri = 0; ri < 4; ++ri)_r[4 * Nr + ri] = Ne[ri];
                                        Or[Nr] = xr;
                                        var bi = Wi[ai[jr]];
                                        Br[2 * Nr] = xe * (lt * bi[0] - Gt * bi[1] + Qr[0]), Br[2 * Nr + 1] = xe * (Gt * bi[0] + lt * bi[1] + Qr[1]), Nr += 1;
                                    }
                                    for(var nn = dt.edges, Wi = dt.positions, Lt = 0; Lt < nn.length; ++Lt)for(var ai = nn[Lt], jr = 0; jr < 2; ++jr){
                                        for(var ri = 0; ri < 3; ++ri)fr[3 * ut + ri] = bt[ri];
                                        for(var ri = 0; ri < 4; ++ri)_r[4 * ut + ri] = Ye[ri];
                                        Or[ut] = xr;
                                        var bi = Wi[ai[jr]];
                                        Br[2 * ut] = xe * (lt * bi[0] - Gt * bi[1] + Qr[0]), Br[2 * ut + 1] = xe * (Gt * bi[0] + lt * bi[1] + Qr[1]), ut += 1;
                                    }
                                }
                            }
                            this.bounds = [
                                qt,
                                rt
                            ], this.points = Re, this.pointCount = Re.length, this.vertexCount = er, this.lineVertexCount = Ke, this.pointBuffer.update(fr), this.colorBuffer.update(_r), this.glyphBuffer.update(Br), this.idBuffer.update(Or), c.free(fr), c.free(_r), c.free(Br), c.free(Or);
                        }, g.dispose = function() {
                            this.shader.dispose(), this.orthoShader.dispose(), this.pickPerspectiveShader.dispose(), this.pickOrthoShader.dispose(), this.vao.dispose(), this.pointBuffer.dispose(), this.colorBuffer.dispose(), this.glyphBuffer.dispose(), this.idBuffer.dispose();
                        };
                        function Ee(Ae) {
                            var ze = Ae.gl, Ce = h.createPerspective(ze), me = h.createOrtho(ze), Re = h.createProject(ze), ce = h.createPickPerspective(ze), Ge = h.createPickOrtho(ze), nt = h.createPickProject(ze), ct = l(ze), qt = l(ze), rt = l(ze), ot = l(ze), Rt = u(ze, [
                                {
                                    buffer: ct,
                                    size: 3,
                                    type: ze.FLOAT
                                },
                                {
                                    buffer: qt,
                                    size: 4,
                                    type: ze.FLOAT
                                },
                                {
                                    buffer: rt,
                                    size: 2,
                                    type: ze.FLOAT
                                },
                                {
                                    buffer: ot,
                                    size: 4,
                                    type: ze.UNSIGNED_BYTE,
                                    normalized: !0
                                }
                            ]), kt = new M(ze, Ce, me, Re, ct, qt, rt, ot, Rt, ce, Ge, nt);
                            return kt.update(Ae), kt;
                        }
                    },
                    3589: function(i, a, o) {
                        "use strict";
                        i.exports = x;
                        var s = o(2260), l = o(1888), u = o(9618), c = o(8828).nextPow2, f = function(b, p, E) {
                            for(var k = 1e8, A = -1, L = -1, _ = b.shape[0], C = b.shape[1], M = 0; M < _; M++)for(var g = 0; g < C; g++){
                                var P = b.get(M, g, 0), T = b.get(M, g, 1), F = b.get(M, g, 2), q = b.get(M, g, 3);
                                if (P < 255 || T < 255 || F < 255 || q < 255) {
                                    var V = p - M, H = E - g, X = V * V + H * H;
                                    X < k && (k = X, A = M, L = g);
                                }
                            }
                            return [
                                A,
                                L,
                                k
                            ];
                        };
                        function h(b, p, E, k, A) {
                            this.coord = [
                                b,
                                p
                            ], this.id = E, this.value = k, this.distance = A;
                        }
                        function d(b, p, E) {
                            this.gl = b, this.fbo = p, this.buffer = E, this._readTimeout = null;
                            var k = this;
                            this._readCallback = function() {
                                k.gl && (p.bind(), b.readPixels(0, 0, p.shape[0], p.shape[1], b.RGBA, b.UNSIGNED_BYTE, k.buffer), k._readTimeout = null);
                            };
                        }
                        var v = d.prototype;
                        Object.defineProperty(v, "shape", {
                            get: function() {
                                return this.gl ? this.fbo.shape.slice() : [
                                    0,
                                    0
                                ];
                            },
                            set: function(b) {
                                if (this.gl) {
                                    this.fbo.shape = b;
                                    var p = this.fbo.shape[0], E = this.fbo.shape[1];
                                    if (E * p * 4 > this.buffer.length) {
                                        l.free(this.buffer);
                                        for(var k = this.buffer = l.mallocUint8(c(E * p * 4)), A = 0; A < E * p * 4; ++A)k[A] = 255;
                                    }
                                    return b;
                                }
                            }
                        }), v.begin = function() {
                            var b = this.gl, p = this.shape;
                            b && (this.fbo.bind(), b.clearColor(1, 1, 1, 1), b.clear(b.COLOR_BUFFER_BIT | b.DEPTH_BUFFER_BIT));
                        }, v.end = function() {
                            var b = this.gl;
                            b && (b.bindFramebuffer(b.FRAMEBUFFER, null), this._readTimeout || clearTimeout(this._readTimeout), this._readTimeout = setTimeout(this._readCallback, 1));
                        }, v.query = function(b, p, E) {
                            if (!this.gl) return null;
                            var k = this.fbo.shape.slice();
                            b = b | 0, p = p | 0, typeof E != "number" && (E = 1);
                            var A = Math.min(Math.max(b - E, 0), k[0]) | 0, L = Math.min(Math.max(b + E, 0), k[0]) | 0, _ = Math.min(Math.max(p - E, 0), k[1]) | 0, C = Math.min(Math.max(p + E, 0), k[1]) | 0;
                            if (L <= A || C <= _) return null;
                            var M = [
                                L - A,
                                C - _
                            ], g = u(this.buffer, [
                                M[0],
                                M[1],
                                4
                            ], [
                                4,
                                k[0] * 4,
                                1
                            ], 4 * (A + k[0] * _)), P = f(g.hi(M[0], M[1], 1), E, E), T = P[0], F = P[1];
                            if (T < 0 || Math.pow(this.radius, 2) < P[2]) return null;
                            var q = g.get(T, F, 0), V = g.get(T, F, 1), H = g.get(T, F, 2), X = g.get(T, F, 3);
                            return new h(T + A | 0, F + _ | 0, q, [
                                V,
                                H,
                                X
                            ], Math.sqrt(P[2]));
                        }, v.dispose = function() {
                            this.gl && (this.fbo.dispose(), l.free(this.buffer), this.gl = null, this._readTimeout && clearTimeout(this._readTimeout));
                        };
                        function x(b, p) {
                            var E = p[0], k = p[1], A = {}, L = s(b, E, k, A), _ = l.mallocUint8(E * k * 4);
                            return new d(b, L, _);
                        }
                    },
                    9405: function(i, a, o) {
                        "use strict";
                        var s = o(3327), l = o(8731), u = o(216), c = o(5091), f = o(2145), h = o(8866);
                        function d(p) {
                            this.gl = p, this.gl.lastAttribCount = 0, this._vref = this._fref = this._relink = this.vertShader = this.fragShader = this.program = this.attributes = this.uniforms = this.types = null;
                        }
                        var v = d.prototype;
                        v.bind = function() {
                            this.program || this._relink();
                            var p, E = this.gl.getProgramParameter(this.program, this.gl.ACTIVE_ATTRIBUTES), k = this.gl.lastAttribCount;
                            if (E > k) for(p = k; p < E; p++)this.gl.enableVertexAttribArray(p);
                            else if (k > E) for(p = E; p < k; p++)this.gl.disableVertexAttribArray(p);
                            this.gl.lastAttribCount = E, this.gl.useProgram(this.program);
                        }, v.dispose = function() {
                            for(var p = this.gl.lastAttribCount, E = 0; E < p; E++)this.gl.disableVertexAttribArray(E);
                            this.gl.lastAttribCount = 0, this._fref && this._fref.dispose(), this._vref && this._vref.dispose(), this.attributes = this.types = this.vertShader = this.fragShader = this.program = this._relink = this._fref = this._vref = null;
                        };
                        function x(p, E) {
                            return p.name < E.name ? -1 : 1;
                        }
                        v.update = function(p, E, k, A) {
                            if (!E || arguments.length === 1) {
                                var L = p;
                                p = L.vertex, E = L.fragment, k = L.uniforms, A = L.attributes;
                            }
                            var _ = this, C = _.gl, M = _._vref;
                            _._vref = c.shader(C, C.VERTEX_SHADER, p), M && M.dispose(), _.vertShader = _._vref.shader;
                            var g = this._fref;
                            if (_._fref = c.shader(C, C.FRAGMENT_SHADER, E), g && g.dispose(), _.fragShader = _._fref.shader, !k || !A) {
                                var P = C.createProgram();
                                if (C.attachShader(P, _.fragShader), C.attachShader(P, _.vertShader), C.linkProgram(P), !C.getProgramParameter(P, C.LINK_STATUS)) {
                                    var T = C.getProgramInfoLog(P);
                                    throw new h(T, "Error linking program:" + T);
                                }
                                k = k || f.uniforms(C, P), A = A || f.attributes(C, P), C.deleteProgram(P);
                            }
                            A = A.slice(), A.sort(x);
                            var F = [], q = [], V = [], H;
                            for(H = 0; H < A.length; ++H){
                                var X = A[H];
                                if (X.type.indexOf("mat") >= 0) {
                                    for(var G = X.type.charAt(X.type.length - 1) | 0, N = new Array(G), W = 0; W < G; ++W)N[W] = V.length, q.push(X.name + "[" + W + "]"), typeof X.location == "number" ? V.push(X.location + W) : Array.isArray(X.location) && X.location.length === G && typeof X.location[W] == "number" ? V.push(X.location[W] | 0) : V.push(-1);
                                    F.push({
                                        name: X.name,
                                        type: X.type,
                                        locations: N
                                    });
                                } else F.push({
                                    name: X.name,
                                    type: X.type,
                                    locations: [
                                        V.length
                                    ]
                                }), q.push(X.name), typeof X.location == "number" ? V.push(X.location | 0) : V.push(-1);
                            }
                            var re = 0;
                            for(H = 0; H < V.length; ++H)if (V[H] < 0) {
                                for(; V.indexOf(re) >= 0;)re += 1;
                                V[H] = re;
                            }
                            var ae = new Array(k.length);
                            function _e() {
                                _.program = c.program(C, _._vref, _._fref, q, V);
                                for(var Me = 0; Me < k.length; ++Me)ae[Me] = C.getUniformLocation(_.program, k[Me].name);
                            }
                            _e(), _._relink = _e, _.types = {
                                uniforms: u(k),
                                attributes: u(A)
                            }, _.attributes = l(C, _, F, V), Object.defineProperty(_, "uniforms", s(C, _, k, ae));
                        };
                        function b(p, E, k, A, L) {
                            var _ = new d(p);
                            return _.update(E, k, A, L), _;
                        }
                        i.exports = b;
                    },
                    8866: function(i) {
                        function a(o, s, l) {
                            this.shortMessage = s || "", this.longMessage = l || "", this.rawError = o || "", this.message = "gl-shader: " + (s || o || "") + (l ? `
` + l : ""), this.stack = new Error().stack;
                        }
                        a.prototype = new Error, a.prototype.name = "GLError", a.prototype.constructor = a, i.exports = a;
                    },
                    8731: function(i, a, o) {
                        "use strict";
                        i.exports = d;
                        var s = o(8866);
                        function l(v, x, b, p, E, k) {
                            this._gl = v, this._wrapper = x, this._index = b, this._locations = p, this._dimension = E, this._constFunc = k;
                        }
                        var u = l.prototype;
                        u.pointer = function(x, b, p, E) {
                            var k = this, A = k._gl, L = k._locations[k._index];
                            A.vertexAttribPointer(L, k._dimension, x || A.FLOAT, !!b, p || 0, E || 0), A.enableVertexAttribArray(L);
                        }, u.set = function(v, x, b, p) {
                            return this._constFunc(this._locations[this._index], v, x, b, p);
                        }, Object.defineProperty(u, "location", {
                            get: function() {
                                return this._locations[this._index];
                            },
                            set: function(v) {
                                return v !== this._locations[this._index] && (this._locations[this._index] = v | 0, this._wrapper.program = null), v | 0;
                            }
                        });
                        var c = [
                            function(v, x, b) {
                                return b.length === void 0 ? v.vertexAttrib1f(x, b) : v.vertexAttrib1fv(x, b);
                            },
                            function(v, x, b, p) {
                                return b.length === void 0 ? v.vertexAttrib2f(x, b, p) : v.vertexAttrib2fv(x, b);
                            },
                            function(v, x, b, p, E) {
                                return b.length === void 0 ? v.vertexAttrib3f(x, b, p, E) : v.vertexAttrib3fv(x, b);
                            },
                            function(v, x, b, p, E, k) {
                                return b.length === void 0 ? v.vertexAttrib4f(x, b, p, E, k) : v.vertexAttrib4fv(x, b);
                            }
                        ];
                        function f(v, x, b, p, E, k, A) {
                            var L = c[E], _ = new l(v, x, b, p, E, L);
                            Object.defineProperty(k, A, {
                                set: function(C) {
                                    return v.disableVertexAttribArray(p[b]), L(v, p[b], C), C;
                                },
                                get: function() {
                                    return _;
                                },
                                enumerable: !0
                            });
                        }
                        function h(v, x, b, p, E, k, A) {
                            for(var L = new Array(E), _ = new Array(E), C = 0; C < E; ++C)f(v, x, b[C], p, E, L, C), _[C] = L[C];
                            Object.defineProperty(L, "location", {
                                set: function(P) {
                                    if (Array.isArray(P)) for(var T = 0; T < E; ++T)_[T].location = P[T];
                                    else for(var T = 0; T < E; ++T)_[T].location = P + T;
                                    return P;
                                },
                                get: function() {
                                    for(var P = new Array(E), T = 0; T < E; ++T)P[T] = p[b[T]];
                                    return P;
                                },
                                enumerable: !0
                            }), L.pointer = function(P, T, F, q) {
                                P = P || v.FLOAT, T = !!T, F = F || E * E, q = q || 0;
                                for(var V = 0; V < E; ++V){
                                    var H = p[b[V]];
                                    v.vertexAttribPointer(H, E, P, T, F, q + V * E), v.enableVertexAttribArray(H);
                                }
                            };
                            var M = new Array(E), g = v["vertexAttrib" + E + "fv"];
                            Object.defineProperty(k, A, {
                                set: function(P) {
                                    for(var T = 0; T < E; ++T){
                                        var F = p[b[T]];
                                        if (v.disableVertexAttribArray(F), Array.isArray(P[0])) g.call(v, F, P[T]);
                                        else {
                                            for(var q = 0; q < E; ++q)M[q] = P[E * T + q];
                                            g.call(v, F, M);
                                        }
                                    }
                                    return P;
                                },
                                get: function() {
                                    return L;
                                },
                                enumerable: !0
                            });
                        }
                        function d(v, x, b, p) {
                            for(var E = {}, k = 0, A = b.length; k < A; ++k){
                                var L = b[k], _ = L.name, C = L.type, M = L.locations;
                                switch(C){
                                    case "bool":
                                    case "int":
                                    case "float":
                                        f(v, x, M[0], p, 1, E, _);
                                        break;
                                    default:
                                        if (C.indexOf("vec") >= 0) {
                                            var g = C.charCodeAt(C.length - 1) - 48;
                                            if (g < 2 || g > 4) throw new s("", "Invalid data type for attribute " + _ + ": " + C);
                                            f(v, x, M[0], p, g, E, _);
                                        } else if (C.indexOf("mat") >= 0) {
                                            var g = C.charCodeAt(C.length - 1) - 48;
                                            if (g < 2 || g > 4) throw new s("", "Invalid data type for attribute " + _ + ": " + C);
                                            h(v, x, M, p, g, E, _);
                                        } else throw new s("", "Unknown data type for attribute " + _ + ": " + C);
                                        break;
                                }
                            }
                            return E;
                        }
                    },
                    3327: function(i, a, o) {
                        "use strict";
                        var s = o(216), l = o(8866);
                        i.exports = f;
                        function u(h) {
                            return function() {
                                return h;
                            };
                        }
                        function c(h, d) {
                            for(var v = new Array(h), x = 0; x < h; ++x)v[x] = d;
                            return v;
                        }
                        function f(h, d, v, x) {
                            function b(C) {
                                return function(M, g, P) {
                                    return M.getUniform(g.program, P[C]);
                                };
                            }
                            function p(C) {
                                return function(g) {
                                    for(var P = E("", C), T = 0; T < P.length; ++T){
                                        var F = P[T], q = F[0], V = F[1];
                                        if (x[V]) {
                                            var H = g;
                                            if (typeof q == "string" && (q.indexOf(".") === 0 || q.indexOf("[") === 0)) {
                                                var X = q;
                                                if (q.indexOf(".") === 0 && (X = q.slice(1)), X.indexOf("]") === X.length - 1) {
                                                    var G = X.indexOf("["), N = X.slice(0, G), W = X.slice(G + 1, X.length - 1);
                                                    H = N ? g[N][W] : g[W];
                                                } else H = g[X];
                                            }
                                            var re = v[V].type, ae;
                                            switch(re){
                                                case "bool":
                                                case "int":
                                                case "sampler2D":
                                                case "samplerCube":
                                                    h.uniform1i(x[V], H);
                                                    break;
                                                case "float":
                                                    h.uniform1f(x[V], H);
                                                    break;
                                                default:
                                                    var _e = re.indexOf("vec");
                                                    if (0 <= _e && _e <= 1 && re.length === 4 + _e) {
                                                        if (ae = re.charCodeAt(re.length - 1) - 48, ae < 2 || ae > 4) throw new l("", "Invalid data type");
                                                        switch(re.charAt(0)){
                                                            case "b":
                                                            case "i":
                                                                h["uniform" + ae + "iv"](x[V], H);
                                                                break;
                                                            case "v":
                                                                h["uniform" + ae + "fv"](x[V], H);
                                                                break;
                                                            default:
                                                                throw new l("", "Unrecognized data type for vector " + name + ": " + re);
                                                        }
                                                    } else if (re.indexOf("mat") === 0 && re.length === 4) {
                                                        if (ae = re.charCodeAt(re.length - 1) - 48, ae < 2 || ae > 4) throw new l("", "Invalid uniform dimension type for matrix " + name + ": " + re);
                                                        h["uniformMatrix" + ae + "fv"](x[V], !1, H);
                                                        break;
                                                    } else throw new l("", "Unknown uniform data type for " + name + ": " + re);
                                            }
                                        }
                                    }
                                };
                            }
                            function E(C, M) {
                                if (typeof M != "object") return [
                                    [
                                        C,
                                        M
                                    ]
                                ];
                                var g = [];
                                for(var P in M){
                                    var T = M[P], F = C;
                                    parseInt(P) + "" === P ? F += "[" + P + "]" : F += "." + P, typeof T == "object" ? g.push.apply(g, E(F, T)) : g.push([
                                        F,
                                        T
                                    ]);
                                }
                                return g;
                            }
                            function k(C) {
                                switch(C){
                                    case "bool":
                                        return !1;
                                    case "int":
                                    case "sampler2D":
                                    case "samplerCube":
                                        return 0;
                                    case "float":
                                        return 0;
                                    default:
                                        var M = C.indexOf("vec");
                                        if (0 <= M && M <= 1 && C.length === 4 + M) {
                                            var g = C.charCodeAt(C.length - 1) - 48;
                                            if (g < 2 || g > 4) throw new l("", "Invalid data type");
                                            return C.charAt(0) === "b" ? c(g, !1) : c(g, 0);
                                        } else if (C.indexOf("mat") === 0 && C.length === 4) {
                                            var g = C.charCodeAt(C.length - 1) - 48;
                                            if (g < 2 || g > 4) throw new l("", "Invalid uniform dimension type for matrix " + name + ": " + C);
                                            return c(g * g, 0);
                                        } else throw new l("", "Unknown uniform data type for " + name + ": " + C);
                                }
                            }
                            function A(C, M, g) {
                                if (typeof g == "object") {
                                    var P = L(g);
                                    Object.defineProperty(C, M, {
                                        get: u(P),
                                        set: p(g),
                                        enumerable: !0,
                                        configurable: !1
                                    });
                                } else x[g] ? Object.defineProperty(C, M, {
                                    get: b(g),
                                    set: p(g),
                                    enumerable: !0,
                                    configurable: !1
                                }) : C[M] = k(v[g].type);
                            }
                            function L(C) {
                                var M;
                                if (Array.isArray(C)) {
                                    M = new Array(C.length);
                                    for(var g = 0; g < C.length; ++g)A(M, g, C[g]);
                                } else {
                                    M = {};
                                    for(var P in C)A(M, P, C[P]);
                                }
                                return M;
                            }
                            var _ = s(v, !0);
                            return {
                                get: u(L(_)),
                                set: p(_),
                                enumerable: !0,
                                configurable: !0
                            };
                        }
                    },
                    216: function(i) {
                        "use strict";
                        i.exports = a;
                        function a(o, s) {
                            for(var l = {}, u = 0; u < o.length; ++u)for(var c = o[u].name, f = c.split("."), h = l, d = 0; d < f.length; ++d){
                                var v = f[d].split("[");
                                if (v.length > 1) {
                                    v[0] in h || (h[v[0]] = []), h = h[v[0]];
                                    for(var x = 1; x < v.length; ++x){
                                        var b = parseInt(v[x]);
                                        x < v.length - 1 || d < f.length - 1 ? (b in h || (x < v.length - 1 ? h[b] = [] : h[b] = {}), h = h[b]) : s ? h[b] = u : h[b] = o[u].type;
                                    }
                                } else d < f.length - 1 ? (v[0] in h || (h[v[0]] = {}), h = h[v[0]]) : s ? h[v[0]] = u : h[v[0]] = o[u].type;
                            }
                            return l;
                        }
                    },
                    2145: function(i, a) {
                        "use strict";
                        a.uniforms = u, a.attributes = c;
                        var o = {
                            FLOAT: "float",
                            FLOAT_VEC2: "vec2",
                            FLOAT_VEC3: "vec3",
                            FLOAT_VEC4: "vec4",
                            INT: "int",
                            INT_VEC2: "ivec2",
                            INT_VEC3: "ivec3",
                            INT_VEC4: "ivec4",
                            BOOL: "bool",
                            BOOL_VEC2: "bvec2",
                            BOOL_VEC3: "bvec3",
                            BOOL_VEC4: "bvec4",
                            FLOAT_MAT2: "mat2",
                            FLOAT_MAT3: "mat3",
                            FLOAT_MAT4: "mat4",
                            SAMPLER_2D: "sampler2D",
                            SAMPLER_CUBE: "samplerCube"
                        }, s = null;
                        function l(f, h) {
                            if (!s) {
                                var d = Object.keys(o);
                                s = {};
                                for(var v = 0; v < d.length; ++v){
                                    var x = d[v];
                                    s[f[x]] = o[x];
                                }
                            }
                            return s[h];
                        }
                        function u(f, h) {
                            for(var d = f.getProgramParameter(h, f.ACTIVE_UNIFORMS), v = [], x = 0; x < d; ++x){
                                var b = f.getActiveUniform(h, x);
                                if (b) {
                                    var p = l(f, b.type);
                                    if (b.size > 1) for(var E = 0; E < b.size; ++E)v.push({
                                        name: b.name.replace("[0]", "[" + E + "]"),
                                        type: p
                                    });
                                    else v.push({
                                        name: b.name,
                                        type: p
                                    });
                                }
                            }
                            return v;
                        }
                        function c(f, h) {
                            for(var d = f.getProgramParameter(h, f.ACTIVE_ATTRIBUTES), v = [], x = 0; x < d; ++x){
                                var b = f.getActiveAttrib(h, x);
                                b && v.push({
                                    name: b.name,
                                    type: l(f, b.type)
                                });
                            }
                            return v;
                        }
                    },
                    5091: function(i, a, o) {
                        "use strict";
                        a.shader = E, a.program = k;
                        var s = o(8866), l = o(2992), u = typeof WeakMap == "undefined" ? o(606) : WeakMap, c = new u, f = 0;
                        function h(A, L, _, C, M, g, P) {
                            this.id = A, this.src = L, this.type = _, this.shader = C, this.count = g, this.programs = [], this.cache = P;
                        }
                        h.prototype.dispose = function() {
                            if (--this.count === 0) {
                                for(var A = this.cache, L = A.gl, _ = this.programs, C = 0, M = _.length; C < M; ++C){
                                    var g = A.programs[_[C]];
                                    g && (delete A.programs[C], L.deleteProgram(g));
                                }
                                L.deleteShader(this.shader), delete A.shaders[this.type === L.FRAGMENT_SHADER | 0][this.src];
                            }
                        };
                        function d(A) {
                            this.gl = A, this.shaders = [
                                {},
                                {}
                            ], this.programs = {};
                        }
                        var v = d.prototype;
                        function x(A, L, _) {
                            var C = A.createShader(L);
                            if (A.shaderSource(C, _), A.compileShader(C), !A.getShaderParameter(C, A.COMPILE_STATUS)) {
                                var M = A.getShaderInfoLog(C);
                                try {
                                    var g = l(M, _, L);
                                } catch (P) {
                                    throw console.warn("Failed to format compiler error: " + P), new s(M, `Error compiling shader:
` + M);
                                }
                                throw new s(M, g.short, g.long);
                            }
                            return C;
                        }
                        v.getShaderReference = function(A, L) {
                            var _ = this.gl, C = this.shaders[A === _.FRAGMENT_SHADER | 0], M = C[L];
                            if (!M || !_.isShader(M.shader)) {
                                var g = x(_, A, L);
                                M = C[L] = new h(f++, L, A, g, [], 1, this);
                            } else M.count += 1;
                            return M;
                        };
                        function b(A, L, _, C, M) {
                            var g = A.createProgram();
                            A.attachShader(g, L), A.attachShader(g, _);
                            for(var P = 0; P < C.length; ++P)A.bindAttribLocation(g, M[P], C[P]);
                            if (A.linkProgram(g), !A.getProgramParameter(g, A.LINK_STATUS)) {
                                var T = A.getProgramInfoLog(g);
                                throw new s(T, "Error linking program: " + T);
                            }
                            return g;
                        }
                        v.getProgram = function(A, L, _, C) {
                            var M = [
                                A.id,
                                L.id,
                                _.join(":"),
                                C.join(":")
                            ].join("@"), g = this.programs[M];
                            return (!g || !this.gl.isProgram(g)) && (this.programs[M] = g = b(this.gl, A.shader, L.shader, _, C), A.programs.push(M), L.programs.push(M)), g;
                        };
                        function p(A) {
                            var L = c.get(A);
                            return L || (L = new d(A), c.set(A, L)), L;
                        }
                        function E(A, L, _) {
                            return p(A).getShaderReference(L, _);
                        }
                        function k(A, L, _, C, M) {
                            return p(A).getProgram(L, _, C, M);
                        }
                    },
                    1493: function(i, a, o) {
                        "use strict";
                        var s = o(3236), l = o(9405), u = s([
                            `precision mediump float;
#define GLSLIFY 1

attribute vec3 position, color;
attribute float weight;

uniform mat4 model, view, projection;
uniform vec3 coordinates[3];
uniform vec4 colors[3];
uniform vec2 screenShape;
uniform float lineWidth;

varying vec4 fragColor;

void main() {
  vec3 vertexPosition = mix(coordinates[0],
    mix(coordinates[2], coordinates[1], 0.5 * (position + 1.0)), abs(position));

  vec4 clipPos = projection * (view * (model * vec4(vertexPosition, 1.0)));
  vec2 clipOffset = (projection * (view * (model * vec4(color, 0.0)))).xy;
  vec2 delta = weight * clipOffset * screenShape;
  vec2 lineOffset = normalize(vec2(delta.y, -delta.x)) / screenShape;

  gl_Position   = vec4(clipPos.xy + clipPos.w * 0.5 * lineWidth * lineOffset, clipPos.z, clipPos.w);
  fragColor     = color.x * colors[0] + color.y * colors[1] + color.z * colors[2];
}
`
                        ]), c = s([
                            `precision mediump float;
#define GLSLIFY 1

varying vec4 fragColor;

void main() {
  gl_FragColor = fragColor;
}`
                        ]);
                        i.exports = function(f) {
                            return l(f, u, c, null, [
                                {
                                    name: "position",
                                    type: "vec3"
                                },
                                {
                                    name: "color",
                                    type: "vec3"
                                },
                                {
                                    name: "weight",
                                    type: "float"
                                }
                            ]);
                        };
                    },
                    4449: function(i, a, o) {
                        "use strict";
                        var s = o(2762), l = o(8116), u = o(1493);
                        i.exports = b;
                        var c = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ];
                        function f(p, E, k, A) {
                            this.gl = p, this.buffer = E, this.vao = k, this.shader = A, this.pixelRatio = 1, this.bounds = [
                                [
                                    -1000,
                                    -1000,
                                    -1000
                                ],
                                [
                                    1e3,
                                    1e3,
                                    1e3
                                ]
                            ], this.position = [
                                0,
                                0,
                                0
                            ], this.lineWidth = [
                                2,
                                2,
                                2
                            ], this.colors = [
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ]
                            ], this.enabled = [
                                !0,
                                !0,
                                !0
                            ], this.drawSides = [
                                !0,
                                !0,
                                !0
                            ], this.axes = null;
                        }
                        var h = f.prototype, d = [
                            0,
                            0,
                            0
                        ], v = [
                            0,
                            0,
                            0
                        ], x = [
                            0,
                            0
                        ];
                        h.isTransparent = function() {
                            return !1;
                        }, h.drawTransparent = function(p) {}, h.draw = function(p) {
                            var E = this.gl, k = this.vao, A = this.shader;
                            k.bind(), A.bind();
                            var L = p.model || c, _ = p.view || c, C = p.projection || c, M;
                            this.axes && (M = this.axes.lastCubeProps.axis);
                            for(var g = d, P = v, T = 0; T < 3; ++T)M && M[T] < 0 ? (g[T] = this.bounds[0][T], P[T] = this.bounds[1][T]) : (g[T] = this.bounds[1][T], P[T] = this.bounds[0][T]);
                            x[0] = E.drawingBufferWidth, x[1] = E.drawingBufferHeight, A.uniforms.model = L, A.uniforms.view = _, A.uniforms.projection = C, A.uniforms.coordinates = [
                                this.position,
                                g,
                                P
                            ], A.uniforms.colors = this.colors, A.uniforms.screenShape = x;
                            for(var T = 0; T < 3; ++T)A.uniforms.lineWidth = this.lineWidth[T] * this.pixelRatio, this.enabled[T] && (k.draw(E.TRIANGLES, 6, 6 * T), this.drawSides[T] && k.draw(E.TRIANGLES, 12, 18 + 12 * T));
                            k.unbind();
                        }, h.update = function(p) {
                            p && ("bounds" in p && (this.bounds = p.bounds), "position" in p && (this.position = p.position), "lineWidth" in p && (this.lineWidth = p.lineWidth), "colors" in p && (this.colors = p.colors), "enabled" in p && (this.enabled = p.enabled), "drawSides" in p && (this.drawSides = p.drawSides));
                        }, h.dispose = function() {
                            this.vao.dispose(), this.buffer.dispose(), this.shader.dispose();
                        };
                        function b(p, E) {
                            var k = [];
                            function A(g, P, T, F, q, V) {
                                var H = [
                                    g,
                                    P,
                                    T,
                                    0,
                                    0,
                                    0,
                                    1
                                ];
                                H[F + 3] = 1, H[F] = q, k.push.apply(k, H), H[6] = -1, k.push.apply(k, H), H[F] = V, k.push.apply(k, H), k.push.apply(k, H), H[6] = 1, k.push.apply(k, H), H[F] = q, k.push.apply(k, H);
                            }
                            A(0, 0, 0, 0, 0, 1), A(0, 0, 0, 1, 0, 1), A(0, 0, 0, 2, 0, 1), A(1, 0, 0, 1, -1, 1), A(1, 0, 0, 2, -1, 1), A(0, 1, 0, 0, -1, 1), A(0, 1, 0, 2, -1, 1), A(0, 0, 1, 0, -1, 1), A(0, 0, 1, 1, -1, 1);
                            var L = s(p, k), _ = l(p, [
                                {
                                    type: p.FLOAT,
                                    buffer: L,
                                    size: 3,
                                    offset: 0,
                                    stride: 28
                                },
                                {
                                    type: p.FLOAT,
                                    buffer: L,
                                    size: 3,
                                    offset: 12,
                                    stride: 28
                                },
                                {
                                    type: p.FLOAT,
                                    buffer: L,
                                    size: 1,
                                    offset: 24,
                                    stride: 28
                                }
                            ]), C = u(p);
                            C.attributes.position.location = 0, C.attributes.color.location = 1, C.attributes.weight.location = 2;
                            var M = new f(p, L, _, C);
                            return M.update(E), M;
                        }
                    },
                    6740: function(i, a, o) {
                        var s = o(3236), l = s([
                            `precision highp float;

precision highp float;
#define GLSLIFY 1

vec3 getOrthogonalVector(vec3 v) {
  // Return up-vector for only-z vector.
  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).
  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.
  // Assign z = 0, x = -b, y = a:
  // a*-b + b*a + c*0 = -ba + ba + 0 = 0
  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {
    return normalize(vec3(-v.y, v.x, 0.0));
  } else {
    return normalize(vec3(0.0, v.z, -v.y));
  }
}

// Calculate the tube vertex and normal at the given index.
//
// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.
//
// Each tube segment is made up of a ring of vertices.
// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.
// The indexes of tube segments run from 0 to 8.
//
vec3 getTubePosition(vec3 d, float index, out vec3 normal) {
  float segmentCount = 8.0;

  float angle = 2.0 * 3.14159 * (index / segmentCount);

  vec3 u = getOrthogonalVector(d);
  vec3 v = normalize(cross(u, d));

  vec3 x = u * cos(angle) * length(d);
  vec3 y = v * sin(angle) * length(d);
  vec3 v3 = x + y;

  normal = normalize(v3);

  return v3;
}

attribute vec4 vector;
attribute vec4 color, position;
attribute vec2 uv;

uniform float vectorScale, tubeScale;
uniform mat4 model, view, projection, inverseModel;
uniform vec3 eyePosition, lightPosition;

varying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;
varying vec4 f_color;
varying vec2 f_uv;

void main() {
  // Scale the vector magnitude to stay constant with
  // model & view changes.
  vec3 normal;
  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);
  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);

  //Lighting geometry parameters
  vec4 cameraCoordinate = view * tubePosition;
  cameraCoordinate.xyz /= cameraCoordinate.w;
  f_lightDirection = lightPosition - cameraCoordinate.xyz;
  f_eyeDirection   = eyePosition - cameraCoordinate.xyz;
  f_normal = normalize((vec4(normal, 0.0) * inverseModel).xyz);

  // vec4 m_position  = model * vec4(tubePosition, 1.0);
  vec4 t_position  = view * tubePosition;
  gl_Position      = projection * t_position;

  f_color          = color;
  f_data           = tubePosition.xyz;
  f_position       = position.xyz;
  f_uv             = uv;
}
`
                        ]), u = s([
                            `#extension GL_OES_standard_derivatives : enable

precision highp float;
#define GLSLIFY 1

float beckmannDistribution(float x, float roughness) {
  float NdotH = max(x, 0.0001);
  float cos2Alpha = NdotH * NdotH;
  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;
  float roughness2 = roughness * roughness;
  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;
  return exp(tan2Alpha / roughness2) / denom;
}

float cookTorranceSpecular(
  vec3 lightDirection,
  vec3 viewDirection,
  vec3 surfaceNormal,
  float roughness,
  float fresnel) {

  float VdotN = max(dot(viewDirection, surfaceNormal), 0.0);
  float LdotN = max(dot(lightDirection, surfaceNormal), 0.0);

  //Half angle vector
  vec3 H = normalize(lightDirection + viewDirection);

  //Geometric term
  float NdotH = max(dot(surfaceNormal, H), 0.0);
  float VdotH = max(dot(viewDirection, H), 0.000001);
  float LdotH = max(dot(lightDirection, H), 0.000001);
  float G1 = (2.0 * NdotH * VdotN) / VdotH;
  float G2 = (2.0 * NdotH * LdotN) / LdotH;
  float G = min(1.0, min(G1, G2));
  
  //Distribution term
  float D = beckmannDistribution(NdotH, roughness);

  //Fresnel term
  float F = pow(1.0 - VdotN, fresnel);

  //Multiply terms and done
  return  G * F * D / max(3.14159265 * VdotN, 0.000001);
}

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3 clipBounds[2];
uniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;
uniform sampler2D texture;

varying vec3 f_normal, f_lightDirection, f_eyeDirection, f_data, f_position;
varying vec4 f_color;
varying vec2 f_uv;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;
  vec3 N = normalize(f_normal);
  vec3 L = normalize(f_lightDirection);
  vec3 V = normalize(f_eyeDirection);

  if(gl_FrontFacing) {
    N = -N;
  }

  float specular = min(1.0, max(0.0, cookTorranceSpecular(L, V, N, roughness, fresnel)));
  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);

  vec4 surfaceColor = f_color * texture2D(texture, f_uv);
  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);

  gl_FragColor = litColor * opacity;
}
`
                        ]), c = s([
                            `precision highp float;

precision highp float;
#define GLSLIFY 1

vec3 getOrthogonalVector(vec3 v) {
  // Return up-vector for only-z vector.
  // Return ax + by + cz = 0, a point that lies on the plane that has v as a normal and that isn't (0,0,0).
  // From the above if-statement we have ||a|| > 0  U  ||b|| > 0.
  // Assign z = 0, x = -b, y = a:
  // a*-b + b*a + c*0 = -ba + ba + 0 = 0
  if (v.x*v.x > v.z*v.z || v.y*v.y > v.z*v.z) {
    return normalize(vec3(-v.y, v.x, 0.0));
  } else {
    return normalize(vec3(0.0, v.z, -v.y));
  }
}

// Calculate the tube vertex and normal at the given index.
//
// The returned vertex is for a tube ring with its center at origin, radius of length(d), pointing in the direction of d.
//
// Each tube segment is made up of a ring of vertices.
// These vertices are used to make up the triangles of the tube by connecting them together in the vertex array.
// The indexes of tube segments run from 0 to 8.
//
vec3 getTubePosition(vec3 d, float index, out vec3 normal) {
  float segmentCount = 8.0;

  float angle = 2.0 * 3.14159 * (index / segmentCount);

  vec3 u = getOrthogonalVector(d);
  vec3 v = normalize(cross(u, d));

  vec3 x = u * cos(angle) * length(d);
  vec3 y = v * sin(angle) * length(d);
  vec3 v3 = x + y;

  normal = normalize(v3);

  return v3;
}

attribute vec4 vector;
attribute vec4 position;
attribute vec4 id;

uniform mat4 model, view, projection;
uniform float tubeScale;

varying vec3 f_position;
varying vec4 f_id;

void main() {
  vec3 normal;
  vec3 XYZ = getTubePosition(mat3(model) * (tubeScale * vector.w * normalize(vector.xyz)), position.w, normal);
  vec4 tubePosition = model * vec4(position.xyz, 1.0) + vec4(XYZ, 0.0);

  gl_Position = projection * (view * tubePosition);
  f_id        = id;
  f_position  = position.xyz;
}
`
                        ]), f = s([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3  clipBounds[2];
uniform float pickId;

varying vec3 f_position;
varying vec4 f_id;

void main() {
  if (outOfRange(clipBounds[0], clipBounds[1], f_position)) discard;

  gl_FragColor = vec4(pickId, f_id.xyz);
}`
                        ]);
                        a.meshShader = {
                            vertex: l,
                            fragment: u,
                            attributes: [
                                {
                                    name: "position",
                                    type: "vec4"
                                },
                                {
                                    name: "color",
                                    type: "vec4"
                                },
                                {
                                    name: "uv",
                                    type: "vec2"
                                },
                                {
                                    name: "vector",
                                    type: "vec4"
                                }
                            ]
                        }, a.pickShader = {
                            vertex: c,
                            fragment: f,
                            attributes: [
                                {
                                    name: "position",
                                    type: "vec4"
                                },
                                {
                                    name: "id",
                                    type: "vec4"
                                },
                                {
                                    name: "vector",
                                    type: "vec4"
                                }
                            ]
                        };
                    },
                    7815: function(i, a, o) {
                        "use strict";
                        var s = o(2931), l = o(9970), u = [
                            "xyz",
                            "xzy",
                            "yxz",
                            "yzx",
                            "zxy",
                            "zyx"
                        ], c = function(A, L, _, C) {
                            for(var M = A.points, g = A.velocities, P = A.divergences, T = [], F = [], q = [], V = [], H = [], X = [], G = 0, N = 0, W = l.create(), re = l.create(), ae = 8, _e = 0; _e < M.length; _e++){
                                var Me = M[_e], ke = g[_e], ge = P[_e];
                                L === 0 && (ge = _ * .05), N = s.length(ke) / C, W = l.create(), s.copy(W, ke), W[3] = ge;
                                for(var ie = 0; ie < ae; ie++)H[ie] = [
                                    Me[0],
                                    Me[1],
                                    Me[2],
                                    ie
                                ];
                                if (V.length > 0) for(var ie = 0; ie < ae; ie++){
                                    var Te = (ie + 1) % ae;
                                    T.push(V[ie], H[ie], H[Te], H[Te], V[Te], V[ie]), q.push(re, W, W, W, re, re), X.push(G, N, N, N, G, G);
                                    var Ee = T.length;
                                    F.push([
                                        Ee - 6,
                                        Ee - 5,
                                        Ee - 4
                                    ], [
                                        Ee - 3,
                                        Ee - 2,
                                        Ee - 1
                                    ]);
                                }
                                var Ae = V;
                                V = H, H = Ae;
                                var ze = re;
                                re = W, W = ze;
                                var Ce = G;
                                G = N, N = Ce;
                            }
                            return {
                                positions: T,
                                cells: F,
                                vectors: q,
                                vertexIntensity: X
                            };
                        }, f = function(A, L, _, C) {
                            for(var M = 0, g = 0; g < A.length; g++)for(var P = A[g].velocities, T = 0; T < P.length; T++)M = Math.max(M, s.length(P[T]));
                            for(var F = A.map(function(_e) {
                                return c(_e, _, C, M);
                            }), q = [], V = [], H = [], X = [], g = 0; g < F.length; g++){
                                var G = F[g], N = q.length;
                                q = q.concat(G.positions), H = H.concat(G.vectors), X = X.concat(G.vertexIntensity);
                                for(var T = 0; T < G.cells.length; T++){
                                    var W = G.cells[T], re = [];
                                    V.push(re);
                                    for(var ae = 0; ae < W.length; ae++)re.push(W[ae] + N);
                                }
                            }
                            return {
                                positions: q,
                                cells: V,
                                vectors: H,
                                vertexIntensity: X,
                                colormap: L
                            };
                        }, h = function(A, L) {
                            var _ = A.length, C;
                            for(C = 0; C < _; C++){
                                var M = A[C];
                                if (M === L) return C;
                                if (M > L) return C - 1;
                            }
                            return C;
                        }, d = function(A, L, _) {
                            return A < L ? L : A > _ ? _ : A;
                        }, v = function(A, L, _) {
                            var C = L.vectors, M = L.meshgrid, g = A[0], P = A[1], T = A[2], F = M[0].length, q = M[1].length, V = M[2].length, H = h(M[0], g), X = h(M[1], P), G = h(M[2], T), N = H + 1, W = X + 1, re = G + 1;
                            if (H = d(H, 0, F - 1), N = d(N, 0, F - 1), X = d(X, 0, q - 1), W = d(W, 0, q - 1), G = d(G, 0, V - 1), re = d(re, 0, V - 1), H < 0 || X < 0 || G < 0 || N > F - 1 || W > q - 1 || re > V - 1) return s.create();
                            var ae = M[0][H], _e = M[0][N], Me = M[1][X], ke = M[1][W], ge = M[2][G], ie = M[2][re], Te = (g - ae) / (_e - ae), Ee = (P - Me) / (ke - Me), Ae = (T - ge) / (ie - ge);
                            isFinite(Te) || (Te = .5), isFinite(Ee) || (Ee = .5), isFinite(Ae) || (Ae = .5);
                            var ze, Ce, me, Re, ce, Ge;
                            switch(_.reversedX && (H = F - 1 - H, N = F - 1 - N), _.reversedY && (X = q - 1 - X, W = q - 1 - W), _.reversedZ && (G = V - 1 - G, re = V - 1 - re), _.filled){
                                case 5:
                                    ce = G, Ge = re, me = X * V, Re = W * V, ze = H * V * q, Ce = N * V * q;
                                    break;
                                case 4:
                                    ce = G, Ge = re, ze = H * V, Ce = N * V, me = X * V * F, Re = W * V * F;
                                    break;
                                case 3:
                                    me = X, Re = W, ce = G * q, Ge = re * q, ze = H * q * V, Ce = N * q * V;
                                    break;
                                case 2:
                                    me = X, Re = W, ze = H * q, Ce = N * q, ce = G * q * F, Ge = re * q * F;
                                    break;
                                case 1:
                                    ze = H, Ce = N, ce = G * F, Ge = re * F, me = X * F * V, Re = W * F * V;
                                    break;
                                default:
                                    ze = H, Ce = N, me = X * F, Re = W * F, ce = G * F * q, Ge = re * F * q;
                                    break;
                            }
                            var nt = C[ze + me + ce], ct = C[ze + me + Ge], qt = C[ze + Re + ce], rt = C[ze + Re + Ge], ot = C[Ce + me + ce], Rt = C[Ce + me + Ge], kt = C[Ce + Re + ce], Ct = C[Ce + Re + Ge], Yt = s.create(), xr = s.create(), er = s.create(), Ke = s.create();
                            s.lerp(Yt, nt, ot, Te), s.lerp(xr, ct, Rt, Te), s.lerp(er, qt, kt, Te), s.lerp(Ke, rt, Ct, Te);
                            var xt = s.create(), bt = s.create();
                            s.lerp(xt, Yt, er, Ee), s.lerp(bt, xr, Ke, Ee);
                            var Lt = s.create();
                            return s.lerp(Lt, xt, bt, Ae), Lt;
                        }, x = function(A, L) {
                            var _ = L[0], C = L[1], M = L[2];
                            return A[0] = _ < 0 ? -_ : _, A[1] = C < 0 ? -C : C, A[2] = M < 0 ? -M : M, A;
                        }, b = function(A) {
                            var L = 1 / 0;
                            A.sort(function(g, P) {
                                return g - P;
                            });
                            for(var _ = A.length, C = 1; C < _; C++){
                                var M = Math.abs(A[C] - A[C - 1]);
                                M < L && (L = M);
                            }
                            return L;
                        }, p = function(A) {
                            for(var L = [], _ = [], C = [], M = {}, g = {}, P = {}, T = A.length, F = 0; F < T; F++){
                                var q = A[F], V = q[0], H = q[1], X = q[2];
                                M[V] || (L.push(V), M[V] = !0), g[H] || (_.push(H), g[H] = !0), P[X] || (C.push(X), P[X] = !0);
                            }
                            var G = b(L), N = b(_), W = b(C), re = Math.min(G, N, W);
                            return isFinite(re) ? re : 1;
                        };
                        i.exports = function(A, L) {
                            var _ = A.startingPositions, C = A.maxLength || 1e3, M = A.tubeSize || 1, g = A.absoluteTubeSize, P = A.gridFill || "+x+y+z", T = {};
                            P.indexOf("-x") !== -1 && (T.reversedX = !0), P.indexOf("-y") !== -1 && (T.reversedY = !0), P.indexOf("-z") !== -1 && (T.reversedZ = !0), T.filled = u.indexOf(P.replace(/-/g, "").replace(/\+/g, ""));
                            var F = A.getVelocity || function(Rt) {
                                return v(Rt, A, T);
                            }, q = A.getDivergence || function(Rt, kt) {
                                var Ct = s.create(), Yt = 1e-4;
                                s.add(Ct, Rt, [
                                    Yt,
                                    0,
                                    0
                                ]);
                                var xr = F(Ct);
                                s.subtract(xr, xr, kt), s.scale(xr, xr, 1 / Yt), s.add(Ct, Rt, [
                                    0,
                                    Yt,
                                    0
                                ]);
                                var er = F(Ct);
                                s.subtract(er, er, kt), s.scale(er, er, 1 / Yt), s.add(Ct, Rt, [
                                    0,
                                    0,
                                    Yt
                                ]);
                                var Ke = F(Ct);
                                return s.subtract(Ke, Ke, kt), s.scale(Ke, Ke, 1 / Yt), s.add(Ct, xr, er), s.add(Ct, Ct, Ke), Ct;
                            }, V = [], H = L[0][0], X = L[0][1], G = L[0][2], N = L[1][0], W = L[1][1], re = L[1][2], ae = function(Rt) {
                                var kt = Rt[0], Ct = Rt[1], Yt = Rt[2];
                                return !(kt < H || kt > N || Ct < X || Ct > W || Yt < G || Yt > re);
                            }, _e = s.distance(L[0], L[1]), Me = 10 * _e / C, ke = Me * Me, ge = 1, ie = 0, Te = _.length;
                            Te > 1 && (ge = p(_));
                            for(var Ee = 0; Ee < Te; Ee++){
                                var Ae = s.create();
                                s.copy(Ae, _[Ee]);
                                var ze = [
                                    Ae
                                ], Ce = [], me = F(Ae), Re = Ae;
                                Ce.push(me);
                                var ce = [], Ge = q(Ae, me), nt = s.length(Ge);
                                isFinite(nt) && nt > ie && (ie = nt), ce.push(nt), V.push({
                                    points: ze,
                                    velocities: Ce,
                                    divergences: ce
                                });
                                for(var ct = 0; ct < C * 100 && ze.length < C && ae(Ae);){
                                    ct++;
                                    var qt = s.clone(me), rt = s.squaredLength(qt);
                                    if (rt === 0) break;
                                    if (rt > ke && s.scale(qt, qt, Me / Math.sqrt(rt)), s.add(qt, qt, Ae), me = F(qt), s.squaredDistance(Re, qt) - ke > -0.0001 * ke) {
                                        ze.push(qt), Re = qt, Ce.push(me);
                                        var Ge = q(qt, me), nt = s.length(Ge);
                                        isFinite(nt) && nt > ie && (ie = nt), ce.push(nt);
                                    }
                                    Ae = qt;
                                }
                            }
                            var ot = f(V, A.colormap, ie, ge);
                            return g ? ot.tubeScale = g : (ie === 0 && (ie = 1), ot.tubeScale = M * .5 * ge / ie), ot;
                        };
                        var E = o(6740), k = o(6405).createMesh;
                        i.exports.createTubeMesh = function(A, L) {
                            return k(A, L, {
                                shaders: E,
                                traceType: "streamtube"
                            });
                        };
                    },
                    990: function(i, a, o) {
                        var s = o(9405), l = o(3236), u = l([
                            `precision highp float;
#define GLSLIFY 1

attribute vec4 uv;
attribute vec3 f;
attribute vec3 normal;

uniform vec3 objectOffset;
uniform mat4 model, view, projection, inverseModel;
uniform vec3 lightPosition, eyePosition;
uniform sampler2D colormap;

varying float value, kill;
varying vec3 worldCoordinate;
varying vec2 planeCoordinate;
varying vec3 lightDirection, eyeDirection, surfaceNormal;
varying vec4 vColor;

void main() {
  vec3 localCoordinate = vec3(uv.zw, f.x);
  worldCoordinate = objectOffset + localCoordinate;
  mat4 objectOffsetTranslation = mat4(1.0) + mat4(vec4(0), vec4(0), vec4(0), vec4(objectOffset, 0));
  vec4 worldPosition = (model * objectOffsetTranslation) * vec4(localCoordinate, 1.0);
  vec4 clipPosition = projection * (view * worldPosition);
  gl_Position = clipPosition;
  kill = f.y;
  value = f.z;
  planeCoordinate = uv.xy;

  vColor = texture2D(colormap, vec2(value, value));

  //Lighting geometry parameters
  vec4 cameraCoordinate = view * worldPosition;
  cameraCoordinate.xyz /= cameraCoordinate.w;
  lightDirection = lightPosition - cameraCoordinate.xyz;
  eyeDirection   = eyePosition - cameraCoordinate.xyz;
  surfaceNormal  = normalize((vec4(normal,0) * inverseModel).xyz);
}
`
                        ]), c = l([
                            `precision highp float;
#define GLSLIFY 1

float beckmannDistribution(float x, float roughness) {
  float NdotH = max(x, 0.0001);
  float cos2Alpha = NdotH * NdotH;
  float tan2Alpha = (cos2Alpha - 1.0) / cos2Alpha;
  float roughness2 = roughness * roughness;
  float denom = 3.141592653589793 * roughness2 * cos2Alpha * cos2Alpha;
  return exp(tan2Alpha / roughness2) / denom;
}

float beckmannSpecular(
  vec3 lightDirection,
  vec3 viewDirection,
  vec3 surfaceNormal,
  float roughness) {
  return beckmannDistribution(dot(surfaceNormal, normalize(lightDirection + viewDirection)), roughness);
}

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec3 lowerBound, upperBound;
uniform float contourTint;
uniform vec4 contourColor;
uniform sampler2D colormap;
uniform vec3 clipBounds[2];
uniform float roughness, fresnel, kambient, kdiffuse, kspecular, opacity;
uniform float vertexColor;

varying float value, kill;
varying vec3 worldCoordinate;
varying vec3 lightDirection, eyeDirection, surfaceNormal;
varying vec4 vColor;

void main() {
  if (
    kill > 0.0 ||
    vColor.a == 0.0 ||
    outOfRange(clipBounds[0], clipBounds[1], worldCoordinate)
  ) discard;

  vec3 N = normalize(surfaceNormal);
  vec3 V = normalize(eyeDirection);
  vec3 L = normalize(lightDirection);

  if(gl_FrontFacing) {
    N = -N;
  }

  float specular = max(beckmannSpecular(L, V, N, roughness), 0.);
  float diffuse  = min(kambient + kdiffuse * max(dot(N, L), 0.0), 1.0);

  //decide how to interpolate color \u2014 in vertex or in fragment
  vec4 surfaceColor =
    step(vertexColor, .5) * texture2D(colormap, vec2(value, value)) +
    step(.5, vertexColor) * vColor;

  vec4 litColor = surfaceColor.a * vec4(diffuse * surfaceColor.rgb + kspecular * vec3(1,1,1) * specular,  1.0);

  gl_FragColor = mix(litColor, contourColor, contourTint) * opacity;
}
`
                        ]), f = l([
                            `precision highp float;
#define GLSLIFY 1

attribute vec4 uv;
attribute float f;

uniform vec3 objectOffset;
uniform mat3 permutation;
uniform mat4 model, view, projection;
uniform float height, zOffset;
uniform sampler2D colormap;

varying float value, kill;
varying vec3 worldCoordinate;
varying vec2 planeCoordinate;
varying vec3 lightDirection, eyeDirection, surfaceNormal;
varying vec4 vColor;

void main() {
  vec3 dataCoordinate = permutation * vec3(uv.xy, height);
  worldCoordinate = objectOffset + dataCoordinate;
  mat4 objectOffsetTranslation = mat4(1.0) + mat4(vec4(0), vec4(0), vec4(0), vec4(objectOffset, 0));
  vec4 worldPosition = (model * objectOffsetTranslation) * vec4(dataCoordinate, 1.0);

  vec4 clipPosition = projection * (view * worldPosition);
  clipPosition.z += zOffset;

  gl_Position = clipPosition;
  value = f + objectOffset.z;
  kill = -1.0;
  planeCoordinate = uv.zw;

  vColor = texture2D(colormap, vec2(value, value));

  //Don't do lighting for contours
  surfaceNormal   = vec3(1,0,0);
  eyeDirection    = vec3(0,1,0);
  lightDirection  = vec3(0,0,1);
}
`
                        ]), h = l([
                            `precision highp float;
#define GLSLIFY 1

bool outOfRange(float a, float b, float p) {
  return ((p > max(a, b)) || 
          (p < min(a, b)));
}

bool outOfRange(vec2 a, vec2 b, vec2 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y));
}

bool outOfRange(vec3 a, vec3 b, vec3 p) {
  return (outOfRange(a.x, b.x, p.x) ||
          outOfRange(a.y, b.y, p.y) ||
          outOfRange(a.z, b.z, p.z));
}

bool outOfRange(vec4 a, vec4 b, vec4 p) {
  return outOfRange(a.xyz, b.xyz, p.xyz);
}

uniform vec2 shape;
uniform vec3 clipBounds[2];
uniform float pickId;

varying float value, kill;
varying vec3 worldCoordinate;
varying vec2 planeCoordinate;
varying vec3 surfaceNormal;

vec2 splitFloat(float v) {
  float vh = 255.0 * v;
  float upper = floor(vh);
  float lower = fract(vh);
  return vec2(upper / 255.0, floor(lower * 16.0) / 16.0);
}

void main() {
  if ((kill > 0.0) ||
      (outOfRange(clipBounds[0], clipBounds[1], worldCoordinate))) discard;

  vec2 ux = splitFloat(planeCoordinate.x / shape.x);
  vec2 uy = splitFloat(planeCoordinate.y / shape.y);
  gl_FragColor = vec4(pickId, ux.x, uy.x, ux.y + (uy.y/16.0));
}
`
                        ]);
                        a.createShader = function(d) {
                            var v = s(d, u, c, null, [
                                {
                                    name: "uv",
                                    type: "vec4"
                                },
                                {
                                    name: "f",
                                    type: "vec3"
                                },
                                {
                                    name: "normal",
                                    type: "vec3"
                                }
                            ]);
                            return v.attributes.uv.location = 0, v.attributes.f.location = 1, v.attributes.normal.location = 2, v;
                        }, a.createPickShader = function(d) {
                            var v = s(d, u, h, null, [
                                {
                                    name: "uv",
                                    type: "vec4"
                                },
                                {
                                    name: "f",
                                    type: "vec3"
                                },
                                {
                                    name: "normal",
                                    type: "vec3"
                                }
                            ]);
                            return v.attributes.uv.location = 0, v.attributes.f.location = 1, v.attributes.normal.location = 2, v;
                        }, a.createContourShader = function(d) {
                            var v = s(d, f, c, null, [
                                {
                                    name: "uv",
                                    type: "vec4"
                                },
                                {
                                    name: "f",
                                    type: "float"
                                }
                            ]);
                            return v.attributes.uv.location = 0, v.attributes.f.location = 1, v;
                        }, a.createPickContourShader = function(d) {
                            var v = s(d, f, h, null, [
                                {
                                    name: "uv",
                                    type: "vec4"
                                },
                                {
                                    name: "f",
                                    type: "float"
                                }
                            ]);
                            return v.attributes.uv.location = 0, v.attributes.f.location = 1, v;
                        };
                    },
                    9499: function(i, a, o) {
                        "use strict";
                        i.exports = ze;
                        var s = o(8828), l = o(2762), u = o(8116), c = o(7766), f = o(1888), h = o(6729), d = o(5298), v = o(9994), x = o(9618), b = o(3711), p = o(6760), E = o(7608), k = o(2478), A = o(6199), L = o(990), _ = L.createShader, C = L.createContourShader, M = L.createPickShader, g = L.createPickContourShader, P = 40, T = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ], F = [
                            [
                                0,
                                0
                            ],
                            [
                                0,
                                1
                            ],
                            [
                                1,
                                0
                            ],
                            [
                                1,
                                1
                            ],
                            [
                                1,
                                0
                            ],
                            [
                                0,
                                1
                            ]
                        ], q = [
                            [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ]
                        ];
                        (function() {
                            for(var Ce = 0; Ce < 3; ++Ce){
                                var me = q[Ce], Re = (Ce + 1) % 3, ce = (Ce + 2) % 3;
                                me[Re + 0] = 1, me[ce + 3] = 1, me[Ce + 6] = 1;
                            }
                        })();
                        function V(Ce, me, Re, ce, Ge) {
                            this.position = Ce, this.index = me, this.uv = Re, this.level = ce, this.dataCoordinate = Ge;
                        }
                        var H = 256;
                        function X(Ce, me, Re, ce, Ge, nt, ct, qt, rt, ot, Rt, kt, Ct, Yt, xr) {
                            this.gl = Ce, this.shape = me, this.bounds = Re, this.objectOffset = xr, this.intensityBounds = [], this._shader = ce, this._pickShader = Ge, this._coordinateBuffer = nt, this._vao = ct, this._colorMap = qt, this._contourShader = rt, this._contourPickShader = ot, this._contourBuffer = Rt, this._contourVAO = kt, this._contourOffsets = [
                                [],
                                [],
                                []
                            ], this._contourCounts = [
                                [],
                                [],
                                []
                            ], this._vertexCount = 0, this._pickResult = new V([
                                0,
                                0,
                                0
                            ], [
                                0,
                                0
                            ], [
                                0,
                                0
                            ], [
                                0,
                                0,
                                0
                            ], [
                                0,
                                0,
                                0
                            ]), this._dynamicBuffer = Ct, this._dynamicVAO = Yt, this._dynamicOffsets = [
                                0,
                                0,
                                0
                            ], this._dynamicCounts = [
                                0,
                                0,
                                0
                            ], this.contourWidth = [
                                1,
                                1,
                                1
                            ], this.contourLevels = [
                                [
                                    1
                                ],
                                [
                                    1
                                ],
                                [
                                    1
                                ]
                            ], this.contourTint = [
                                0,
                                0,
                                0
                            ], this.contourColor = [
                                [
                                    .5,
                                    .5,
                                    .5,
                                    1
                                ],
                                [
                                    .5,
                                    .5,
                                    .5,
                                    1
                                ],
                                [
                                    .5,
                                    .5,
                                    .5,
                                    1
                                ]
                            ], this.showContour = !0, this.showSurface = !0, this.enableHighlight = [
                                !0,
                                !0,
                                !0
                            ], this.highlightColor = [
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ]
                            ], this.highlightTint = [
                                1,
                                1,
                                1
                            ], this.highlightLevel = [
                                -1,
                                -1,
                                -1
                            ], this.enableDynamic = [
                                !0,
                                !0,
                                !0
                            ], this.dynamicLevel = [
                                NaN,
                                NaN,
                                NaN
                            ], this.dynamicColor = [
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ],
                                [
                                    0,
                                    0,
                                    0,
                                    1
                                ]
                            ], this.dynamicTint = [
                                1,
                                1,
                                1
                            ], this.dynamicWidth = [
                                1,
                                1,
                                1
                            ], this.axesBounds = [
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ],
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ]
                            ], this.surfaceProject = [
                                !1,
                                !1,
                                !1
                            ], this.contourProject = [
                                [
                                    !1,
                                    !1,
                                    !1
                                ],
                                [
                                    !1,
                                    !1,
                                    !1
                                ],
                                [
                                    !1,
                                    !1,
                                    !1
                                ]
                            ], this.colorBounds = [
                                !1,
                                !1
                            ], this._field = [
                                x(f.mallocFloat(1024), [
                                    0,
                                    0
                                ]),
                                x(f.mallocFloat(1024), [
                                    0,
                                    0
                                ]),
                                x(f.mallocFloat(1024), [
                                    0,
                                    0
                                ])
                            ], this.pickId = 1, this.clipBounds = [
                                [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ],
                                [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ]
                            ], this.snapToData = !1, this.pixelRatio = 1, this.opacity = 1, this.lightPosition = [
                                10,
                                1e4,
                                0
                            ], this.ambientLight = .8, this.diffuseLight = .8, this.specularLight = 2, this.roughness = .5, this.fresnel = 1.5, this.vertexColor = 0, this.dirty = !0;
                        }
                        var G = X.prototype;
                        G.genColormap = function(Ce, me) {
                            var Re = !1, ce = v([
                                h({
                                    colormap: Ce,
                                    nshades: H,
                                    format: "rgba"
                                }).map(function(Ge, nt) {
                                    var ct = me ? N(nt / 255, me) : Ge[3];
                                    return ct < 1 && (Re = !0), [
                                        Ge[0],
                                        Ge[1],
                                        Ge[2],
                                        255 * ct
                                    ];
                                })
                            ]);
                            return d.divseq(ce, 255), this.hasAlphaScale = Re, ce;
                        }, G.isTransparent = function() {
                            return this.opacity < 1 || this.hasAlphaScale;
                        }, G.isOpaque = function() {
                            return !this.isTransparent();
                        }, G.pickSlots = 1, G.setPickBase = function(Ce) {
                            this.pickId = Ce;
                        };
                        function N(Ce, me) {
                            if (!me || !me.length) return 1;
                            for(var Re = 0; Re < me.length; ++Re){
                                if (me.length < 2) return 1;
                                if (me[Re][0] === Ce) return me[Re][1];
                                if (me[Re][0] > Ce && Re > 0) {
                                    var ce = (me[Re][0] - Ce) / (me[Re][0] - me[Re - 1][0]);
                                    return me[Re][1] * (1 - ce) + ce * me[Re - 1][1];
                                }
                            }
                            return 1;
                        }
                        var W = [
                            0,
                            0,
                            0
                        ], re = {
                            showSurface: !1,
                            showContour: !1,
                            projections: [
                                T.slice(),
                                T.slice(),
                                T.slice()
                            ],
                            clipBounds: [
                                [
                                    [
                                        0,
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0,
                                        0
                                    ]
                                ],
                                [
                                    [
                                        0,
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0,
                                        0
                                    ]
                                ],
                                [
                                    [
                                        0,
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        0,
                                        0
                                    ]
                                ]
                            ]
                        };
                        function ae(Ce, me) {
                            var Re, ce, Ge, nt = me.axes && me.axes.lastCubeProps.axis || W, ct = me.showSurface, qt = me.showContour;
                            for(Re = 0; Re < 3; ++Re)for(ct = ct || me.surfaceProject[Re], ce = 0; ce < 3; ++ce)qt = qt || me.contourProject[Re][ce];
                            for(Re = 0; Re < 3; ++Re){
                                var rt = re.projections[Re];
                                for(ce = 0; ce < 16; ++ce)rt[ce] = 0;
                                for(ce = 0; ce < 4; ++ce)rt[5 * ce] = 1;
                                rt[5 * Re] = 0, rt[12 + Re] = me.axesBounds[+(nt[Re] > 0)][Re], p(rt, Ce.model, rt);
                                var ot = re.clipBounds[Re];
                                for(Ge = 0; Ge < 2; ++Ge)for(ce = 0; ce < 3; ++ce)ot[Ge][ce] = Ce.clipBounds[Ge][ce];
                                ot[0][Re] = -100000000, ot[1][Re] = 1e8;
                            }
                            return re.showSurface = ct, re.showContour = qt, re;
                        }
                        var _e = {
                            model: T,
                            view: T,
                            projection: T,
                            inverseModel: T.slice(),
                            lowerBound: [
                                0,
                                0,
                                0
                            ],
                            upperBound: [
                                0,
                                0,
                                0
                            ],
                            colorMap: 0,
                            clipBounds: [
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ]
                            ],
                            height: 0,
                            contourTint: 0,
                            contourColor: [
                                0,
                                0,
                                0,
                                1
                            ],
                            permutation: [
                                1,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                1
                            ],
                            zOffset: -0.0001,
                            objectOffset: [
                                0,
                                0,
                                0
                            ],
                            kambient: 1,
                            kdiffuse: 1,
                            kspecular: 1,
                            lightPosition: [
                                1e3,
                                1e3,
                                1e3
                            ],
                            eyePosition: [
                                0,
                                0,
                                0
                            ],
                            roughness: 1,
                            fresnel: 1,
                            opacity: 1,
                            vertexColor: 0
                        }, Me = T.slice(), ke = [
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ];
                        function ge(Ce, me) {
                            Ce = Ce || {};
                            var Re = this.gl;
                            Re.disable(Re.CULL_FACE), this._colorMap.bind(0);
                            var ce = _e;
                            ce.model = Ce.model || T, ce.view = Ce.view || T, ce.projection = Ce.projection || T, ce.lowerBound = [
                                this.bounds[0][0],
                                this.bounds[0][1],
                                this.colorBounds[0] || this.bounds[0][2]
                            ], ce.upperBound = [
                                this.bounds[1][0],
                                this.bounds[1][1],
                                this.colorBounds[1] || this.bounds[1][2]
                            ], ce.objectOffset = this.objectOffset, ce.contourColor = this.contourColor[0], ce.inverseModel = E(ce.inverseModel, ce.model);
                            for(var Ge = 0; Ge < 2; ++Ge)for(var nt = ce.clipBounds[Ge], ct = 0; ct < 3; ++ct)nt[ct] = Math.min(Math.max(this.clipBounds[Ge][ct], -100000000), 1e8);
                            ce.kambient = this.ambientLight, ce.kdiffuse = this.diffuseLight, ce.kspecular = this.specularLight, ce.roughness = this.roughness, ce.fresnel = this.fresnel, ce.opacity = this.opacity, ce.height = 0, ce.permutation = ke, ce.vertexColor = this.vertexColor;
                            var qt = Me;
                            for(p(qt, ce.view, ce.model), p(qt, ce.projection, qt), E(qt, qt), Ge = 0; Ge < 3; ++Ge)ce.eyePosition[Ge] = qt[12 + Ge] / qt[15];
                            var rt = qt[15];
                            for(Ge = 0; Ge < 3; ++Ge)rt += this.lightPosition[Ge] * qt[4 * Ge + 3];
                            for(Ge = 0; Ge < 3; ++Ge){
                                var ot = qt[12 + Ge];
                                for(ct = 0; ct < 3; ++ct)ot += qt[4 * ct + Ge] * this.lightPosition[ct];
                                ce.lightPosition[Ge] = ot / rt;
                            }
                            var Rt = ae(ce, this);
                            if (Rt.showSurface) {
                                for(this._shader.bind(), this._shader.uniforms = ce, this._vao.bind(), this.showSurface && this._vertexCount && this._vao.draw(Re.TRIANGLES, this._vertexCount), Ge = 0; Ge < 3; ++Ge)!this.surfaceProject[Ge] || !this.vertexCount || (this._shader.uniforms.model = Rt.projections[Ge], this._shader.uniforms.clipBounds = Rt.clipBounds[Ge], this._vao.draw(Re.TRIANGLES, this._vertexCount));
                                this._vao.unbind();
                            }
                            if (Rt.showContour) {
                                var kt = this._contourShader;
                                ce.kambient = 1, ce.kdiffuse = 0, ce.kspecular = 0, ce.opacity = 1, kt.bind(), kt.uniforms = ce;
                                var Ct = this._contourVAO;
                                for(Ct.bind(), Ge = 0; Ge < 3; ++Ge)for(kt.uniforms.permutation = q[Ge], Re.lineWidth(this.contourWidth[Ge] * this.pixelRatio), ct = 0; ct < this.contourLevels[Ge].length; ++ct)ct === this.highlightLevel[Ge] ? (kt.uniforms.contourColor = this.highlightColor[Ge], kt.uniforms.contourTint = this.highlightTint[Ge]) : (ct === 0 || ct - 1 === this.highlightLevel[Ge]) && (kt.uniforms.contourColor = this.contourColor[Ge], kt.uniforms.contourTint = this.contourTint[Ge]), this._contourCounts[Ge][ct] && (kt.uniforms.height = this.contourLevels[Ge][ct], Ct.draw(Re.LINES, this._contourCounts[Ge][ct], this._contourOffsets[Ge][ct]));
                                for(Ge = 0; Ge < 3; ++Ge)for(kt.uniforms.model = Rt.projections[Ge], kt.uniforms.clipBounds = Rt.clipBounds[Ge], ct = 0; ct < 3; ++ct)if (this.contourProject[Ge][ct]) {
                                    kt.uniforms.permutation = q[ct], Re.lineWidth(this.contourWidth[ct] * this.pixelRatio);
                                    for(var Yt = 0; Yt < this.contourLevels[ct].length; ++Yt)Yt === this.highlightLevel[ct] ? (kt.uniforms.contourColor = this.highlightColor[ct], kt.uniforms.contourTint = this.highlightTint[ct]) : (Yt === 0 || Yt - 1 === this.highlightLevel[ct]) && (kt.uniforms.contourColor = this.contourColor[ct], kt.uniforms.contourTint = this.contourTint[ct]), this._contourCounts[ct][Yt] && (kt.uniforms.height = this.contourLevels[ct][Yt], Ct.draw(Re.LINES, this._contourCounts[ct][Yt], this._contourOffsets[ct][Yt]));
                                }
                                for(Ct.unbind(), Ct = this._dynamicVAO, Ct.bind(), Ge = 0; Ge < 3; ++Ge)if (this._dynamicCounts[Ge] !== 0) for(kt.uniforms.model = ce.model, kt.uniforms.clipBounds = ce.clipBounds, kt.uniforms.permutation = q[Ge], Re.lineWidth(this.dynamicWidth[Ge] * this.pixelRatio), kt.uniforms.contourColor = this.dynamicColor[Ge], kt.uniforms.contourTint = this.dynamicTint[Ge], kt.uniforms.height = this.dynamicLevel[Ge], Ct.draw(Re.LINES, this._dynamicCounts[Ge], this._dynamicOffsets[Ge]), ct = 0; ct < 3; ++ct)this.contourProject[ct][Ge] && (kt.uniforms.model = Rt.projections[ct], kt.uniforms.clipBounds = Rt.clipBounds[ct], Ct.draw(Re.LINES, this._dynamicCounts[Ge], this._dynamicOffsets[Ge]));
                                Ct.unbind();
                            }
                        }
                        G.draw = function(Ce) {
                            return ge.call(this, Ce, !1);
                        }, G.drawTransparent = function(Ce) {
                            return ge.call(this, Ce, !0);
                        };
                        var ie = {
                            model: T,
                            view: T,
                            projection: T,
                            inverseModel: T,
                            clipBounds: [
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ]
                            ],
                            height: 0,
                            shape: [
                                0,
                                0
                            ],
                            pickId: 0,
                            lowerBound: [
                                0,
                                0,
                                0
                            ],
                            upperBound: [
                                0,
                                0,
                                0
                            ],
                            zOffset: 0,
                            objectOffset: [
                                0,
                                0,
                                0
                            ],
                            permutation: [
                                1,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                1
                            ],
                            lightPosition: [
                                0,
                                0,
                                0
                            ],
                            eyePosition: [
                                0,
                                0,
                                0
                            ]
                        };
                        G.drawPick = function(Ce) {
                            Ce = Ce || {};
                            var me = this.gl;
                            me.disable(me.CULL_FACE);
                            var Re = ie;
                            Re.model = Ce.model || T, Re.view = Ce.view || T, Re.projection = Ce.projection || T, Re.shape = this._field[2].shape, Re.pickId = this.pickId / 255, Re.lowerBound = this.bounds[0], Re.upperBound = this.bounds[1], Re.objectOffset = this.objectOffset, Re.permutation = ke;
                            for(var ce = 0; ce < 2; ++ce)for(var Ge = Re.clipBounds[ce], nt = 0; nt < 3; ++nt)Ge[nt] = Math.min(Math.max(this.clipBounds[ce][nt], -100000000), 1e8);
                            var ct = ae(Re, this);
                            if (ct.showSurface) {
                                for(this._pickShader.bind(), this._pickShader.uniforms = Re, this._vao.bind(), this._vao.draw(me.TRIANGLES, this._vertexCount), ce = 0; ce < 3; ++ce)this.surfaceProject[ce] && (this._pickShader.uniforms.model = ct.projections[ce], this._pickShader.uniforms.clipBounds = ct.clipBounds[ce], this._vao.draw(me.TRIANGLES, this._vertexCount));
                                this._vao.unbind();
                            }
                            if (ct.showContour) {
                                var qt = this._contourPickShader;
                                qt.bind(), qt.uniforms = Re;
                                var rt = this._contourVAO;
                                for(rt.bind(), nt = 0; nt < 3; ++nt)for(me.lineWidth(this.contourWidth[nt] * this.pixelRatio), qt.uniforms.permutation = q[nt], ce = 0; ce < this.contourLevels[nt].length; ++ce)this._contourCounts[nt][ce] && (qt.uniforms.height = this.contourLevels[nt][ce], rt.draw(me.LINES, this._contourCounts[nt][ce], this._contourOffsets[nt][ce]));
                                for(ce = 0; ce < 3; ++ce)for(qt.uniforms.model = ct.projections[ce], qt.uniforms.clipBounds = ct.clipBounds[ce], nt = 0; nt < 3; ++nt)if (this.contourProject[ce][nt]) {
                                    qt.uniforms.permutation = q[nt], me.lineWidth(this.contourWidth[nt] * this.pixelRatio);
                                    for(var ot = 0; ot < this.contourLevels[nt].length; ++ot)this._contourCounts[nt][ot] && (qt.uniforms.height = this.contourLevels[nt][ot], rt.draw(me.LINES, this._contourCounts[nt][ot], this._contourOffsets[nt][ot]));
                                }
                                rt.unbind();
                            }
                        }, G.pick = function(Ce) {
                            if (!Ce || Ce.id !== this.pickId) return null;
                            var me = this._field[2].shape, Re = this._pickResult, ce = me[0] * (Ce.value[0] + (Ce.value[2] >> 4) / 16) / 255, Ge = Math.floor(ce), nt = ce - Ge, ct = me[1] * (Ce.value[1] + (Ce.value[2] & 15) / 16) / 255, qt = Math.floor(ct), rt = ct - qt;
                            Ge += 1, qt += 1;
                            var ot = Re.position;
                            ot[0] = ot[1] = ot[2] = 0;
                            for(var Rt = 0; Rt < 2; ++Rt)for(var kt = Rt ? nt : 1 - nt, Ct = 0; Ct < 2; ++Ct)for(var Yt = Ct ? rt : 1 - rt, xr = Ge + Rt, er = qt + Ct, Ke = kt * Yt, xt = 0; xt < 3; ++xt)ot[xt] += this._field[xt].get(xr, er) * Ke;
                            for(var bt = this._pickResult.level, Lt = 0; Lt < 3; ++Lt)if (bt[Lt] = k.le(this.contourLevels[Lt], ot[Lt]), bt[Lt] < 0) this.contourLevels[Lt].length > 0 && (bt[Lt] = 0);
                            else if (bt[Lt] < this.contourLevels[Lt].length - 1) {
                                var St = this.contourLevels[Lt][bt[Lt]], Et = this.contourLevels[Lt][bt[Lt] + 1];
                                Math.abs(St - ot[Lt]) > Math.abs(Et - ot[Lt]) && (bt[Lt] += 1);
                            }
                            for(Re.index[0] = nt < .5 ? Ge : Ge + 1, Re.index[1] = rt < .5 ? qt : qt + 1, Re.uv[0] = ce / me[0], Re.uv[1] = ct / me[1], xt = 0; xt < 3; ++xt)Re.dataCoordinate[xt] = this._field[xt].get(Re.index[0], Re.index[1]);
                            return Re;
                        }, G.padField = function(Ce, me) {
                            var Re = me.shape.slice(), ce = Ce.shape.slice();
                            d.assign(Ce.lo(1, 1).hi(Re[0], Re[1]), me), d.assign(Ce.lo(1).hi(Re[0], 1), me.hi(Re[0], 1)), d.assign(Ce.lo(1, ce[1] - 1).hi(Re[0], 1), me.lo(0, Re[1] - 1).hi(Re[0], 1)), d.assign(Ce.lo(0, 1).hi(1, Re[1]), me.hi(1)), d.assign(Ce.lo(ce[0] - 1, 1).hi(1, Re[1]), me.lo(Re[0] - 1)), Ce.set(0, 0, me.get(0, 0)), Ce.set(0, ce[1] - 1, me.get(0, Re[1] - 1)), Ce.set(ce[0] - 1, 0, me.get(Re[0] - 1, 0)), Ce.set(ce[0] - 1, ce[1] - 1, me.get(Re[0] - 1, Re[1] - 1));
                        };
                        function Te(Ce, me) {
                            return Array.isArray(Ce) ? [
                                me(Ce[0]),
                                me(Ce[1]),
                                me(Ce[2])
                            ] : [
                                me(Ce),
                                me(Ce),
                                me(Ce)
                            ];
                        }
                        function Ee(Ce) {
                            return Array.isArray(Ce) ? Ce.length === 3 ? [
                                Ce[0],
                                Ce[1],
                                Ce[2],
                                1
                            ] : [
                                Ce[0],
                                Ce[1],
                                Ce[2],
                                Ce[3]
                            ] : [
                                0,
                                0,
                                0,
                                1
                            ];
                        }
                        function Ae(Ce) {
                            if (Array.isArray(Ce)) {
                                if (Array.isArray(Ce)) return [
                                    Ee(Ce[0]),
                                    Ee(Ce[1]),
                                    Ee(Ce[2])
                                ];
                                var me = Ee(Ce);
                                return [
                                    me.slice(),
                                    me.slice(),
                                    me.slice()
                                ];
                            }
                        }
                        G.update = function(Ce) {
                            Ce = Ce || {}, this.objectOffset = Ce.objectOffset || this.objectOffset, this.dirty = !0, "contourWidth" in Ce && (this.contourWidth = Te(Ce.contourWidth, Number)), "showContour" in Ce && (this.showContour = Te(Ce.showContour, Boolean)), "showSurface" in Ce && (this.showSurface = !!Ce.showSurface), "contourTint" in Ce && (this.contourTint = Te(Ce.contourTint, Boolean)), "contourColor" in Ce && (this.contourColor = Ae(Ce.contourColor)), "contourProject" in Ce && (this.contourProject = Te(Ce.contourProject, function(Gi) {
                                return Te(Gi, Boolean);
                            })), "surfaceProject" in Ce && (this.surfaceProject = Ce.surfaceProject), "dynamicColor" in Ce && (this.dynamicColor = Ae(Ce.dynamicColor)), "dynamicTint" in Ce && (this.dynamicTint = Te(Ce.dynamicTint, Number)), "dynamicWidth" in Ce && (this.dynamicWidth = Te(Ce.dynamicWidth, Number)), "opacity" in Ce && (this.opacity = Ce.opacity), "opacityscale" in Ce && (this.opacityscale = Ce.opacityscale), "colorBounds" in Ce && (this.colorBounds = Ce.colorBounds), "vertexColor" in Ce && (this.vertexColor = Ce.vertexColor ? 1 : 0), "colormap" in Ce && this._colorMap.setPixels(this.genColormap(Ce.colormap, this.opacityscale));
                            var me = Ce.field || Ce.coords && Ce.coords[2] || null, Re = !1;
                            if (me || (this._field[2].shape[0] || this._field[2].shape[2] ? me = this._field[2].lo(1, 1).hi(this._field[2].shape[0] - 2, this._field[2].shape[1] - 2) : me = this._field[2].hi(0, 0)), "field" in Ce || "coords" in Ce) {
                                var ce = (me.shape[0] + 2) * (me.shape[1] + 2);
                                ce > this._field[2].data.length && (f.freeFloat(this._field[2].data), this._field[2].data = f.mallocFloat(s.nextPow2(ce))), this._field[2] = x(this._field[2].data, [
                                    me.shape[0] + 2,
                                    me.shape[1] + 2
                                ]), this.padField(this._field[2], me), this.shape = me.shape.slice();
                                for(var Ge = this.shape, nt = 0; nt < 2; ++nt)this._field[2].size > this._field[nt].data.length && (f.freeFloat(this._field[nt].data), this._field[nt].data = f.mallocFloat(this._field[2].size)), this._field[nt] = x(this._field[nt].data, [
                                    Ge[0] + 2,
                                    Ge[1] + 2
                                ]);
                                if (Ce.coords) {
                                    var ct = Ce.coords;
                                    if (!Array.isArray(ct) || ct.length !== 3) throw new Error("gl-surface: invalid coordinates for x/y");
                                    for(nt = 0; nt < 2; ++nt){
                                        var qt = ct[nt];
                                        for(Ct = 0; Ct < 2; ++Ct)if (qt.shape[Ct] !== Ge[Ct]) throw new Error("gl-surface: coords have incorrect shape");
                                        this.padField(this._field[nt], qt);
                                    }
                                } else if (Ce.ticks) {
                                    var rt = Ce.ticks;
                                    if (!Array.isArray(rt) || rt.length !== 2) throw new Error("gl-surface: invalid ticks");
                                    for(nt = 0; nt < 2; ++nt){
                                        var ot = rt[nt];
                                        if ((Array.isArray(ot) || ot.length) && (ot = x(ot)), ot.shape[0] !== Ge[nt]) throw new Error("gl-surface: invalid tick length");
                                        var Rt = x(ot.data, Ge);
                                        Rt.stride[nt] = ot.stride[0], Rt.stride[nt ^ 1] = 0, this.padField(this._field[nt], Rt);
                                    }
                                } else {
                                    for(nt = 0; nt < 2; ++nt){
                                        var kt = [
                                            0,
                                            0
                                        ];
                                        kt[nt] = 1, this._field[nt] = x(this._field[nt].data, [
                                            Ge[0] + 2,
                                            Ge[1] + 2
                                        ], kt, 0);
                                    }
                                    this._field[0].set(0, 0, 0);
                                    for(var Ct = 0; Ct < Ge[0]; ++Ct)this._field[0].set(Ct + 1, 0, Ct);
                                    for(this._field[0].set(Ge[0] + 1, 0, Ge[0] - 1), this._field[1].set(0, 0, 0), Ct = 0; Ct < Ge[1]; ++Ct)this._field[1].set(0, Ct + 1, Ct);
                                    this._field[1].set(0, Ge[1] + 1, Ge[1] - 1);
                                }
                                var Yt = this._field, xr = x(f.mallocFloat(Yt[2].size * 6), [
                                    3,
                                    Ge[0] + 2,
                                    Ge[1] + 2,
                                    2
                                ]);
                                for(nt = 0; nt < 3; ++nt)A(xr.pick(nt), Yt[nt], "mirror");
                                var er = x(f.mallocFloat(Yt[2].size * 3), [
                                    Ge[0] + 2,
                                    Ge[1] + 2,
                                    3
                                ]);
                                for(nt = 0; nt < Ge[0] + 2; ++nt)for(Ct = 0; Ct < Ge[1] + 2; ++Ct){
                                    var Ke = xr.get(0, nt, Ct, 0), xt = xr.get(0, nt, Ct, 1), bt = xr.get(1, nt, Ct, 0), Lt = xr.get(1, nt, Ct, 1), St = xr.get(2, nt, Ct, 0), Et = xr.get(2, nt, Ct, 1), dt = bt * Et - Lt * St, Ht = St * xt - Et * Ke, $t = Ke * Lt - xt * bt, fr = Math.sqrt(dt * dt + Ht * Ht + $t * $t);
                                    fr < 1e-8 ? (fr = Math.max(Math.abs(dt), Math.abs(Ht), Math.abs($t)), fr < 1e-8 ? ($t = 1, Ht = dt = 0, fr = 1) : fr = 1 / fr) : fr = 1 / Math.sqrt(fr), er.set(nt, Ct, 0, dt * fr), er.set(nt, Ct, 1, Ht * fr), er.set(nt, Ct, 2, $t * fr);
                                }
                                f.free(xr.data);
                                var _r = [
                                    1 / 0,
                                    1 / 0,
                                    1 / 0
                                ], Br = [
                                    -1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], Or = 1 / 0, Nr = -1 / 0, ut = (Ge[0] - 1) * (Ge[1] - 1) * 6, Ne = f.mallocFloat(s.nextPow2(10 * ut)), Ye = 0, Ve = 0;
                                for(nt = 0; nt < Ge[0] - 1; ++nt)e: for(Ct = 0; Ct < Ge[1] - 1; ++Ct){
                                    for(var Xe = 0; Xe < 2; ++Xe)for(var ht = 0; ht < 2; ++ht)for(var Le = 0; Le < 3; ++Le){
                                        var xe = this._field[Le].get(1 + nt + Xe, 1 + Ct + ht);
                                        if (isNaN(xe) || !isFinite(xe)) continue e;
                                    }
                                    for(Le = 0; Le < 6; ++Le){
                                        var Se = nt + F[Le][0], lt = Ct + F[Le][1], Gt = this._field[0].get(Se + 1, lt + 1), Vt = this._field[1].get(Se + 1, lt + 1);
                                        xe = this._field[2].get(Se + 1, lt + 1), dt = er.get(Se + 1, lt + 1, 0), Ht = er.get(Se + 1, lt + 1, 1), $t = er.get(Se + 1, lt + 1, 2), Ce.intensity && (ar = Ce.intensity.get(Se, lt));
                                        var ar = Ce.intensity ? Ce.intensity.get(Se, lt) : xe + this.objectOffset[2];
                                        Ne[Ye++] = Se, Ne[Ye++] = lt, Ne[Ye++] = Gt, Ne[Ye++] = Vt, Ne[Ye++] = xe, Ne[Ye++] = 0, Ne[Ye++] = ar, Ne[Ye++] = dt, Ne[Ye++] = Ht, Ne[Ye++] = $t, _r[0] = Math.min(_r[0], Gt + this.objectOffset[0]), _r[1] = Math.min(_r[1], Vt + this.objectOffset[1]), _r[2] = Math.min(_r[2], xe + this.objectOffset[2]), Or = Math.min(Or, ar), Br[0] = Math.max(Br[0], Gt + this.objectOffset[0]), Br[1] = Math.max(Br[1], Vt + this.objectOffset[1]), Br[2] = Math.max(Br[2], xe + this.objectOffset[2]), Nr = Math.max(Nr, ar), Ve += 1;
                                    }
                                }
                                for(Ce.intensityBounds && (Or = +Ce.intensityBounds[0], Nr = +Ce.intensityBounds[1]), nt = 6; nt < Ye; nt += 10)Ne[nt] = (Ne[nt] - Or) / (Nr - Or);
                                this._vertexCount = Ve, this._coordinateBuffer.update(Ne.subarray(0, Ye)), f.freeFloat(Ne), f.free(er.data), this.bounds = [
                                    _r,
                                    Br
                                ], this.intensity = Ce.intensity || this._field[2], (this.intensityBounds[0] !== Or || this.intensityBounds[1] !== Nr) && (Re = !0), this.intensityBounds = [
                                    Or,
                                    Nr
                                ];
                            }
                            if ("levels" in Ce) {
                                var Qr = Ce.levels;
                                for(Array.isArray(Qr[0]) ? Qr = Qr.slice() : Qr = [
                                    [],
                                    [],
                                    Qr
                                ], nt = 0; nt < 3; ++nt)Qr[nt] = Qr[nt].slice(), Qr[nt].sort(function(Gi, Ki) {
                                    return Gi - Ki;
                                });
                                for(nt = 0; nt < 3; ++nt)for(Ct = 0; Ct < Qr[nt].length; ++Ct)Qr[nt][Ct] -= this.objectOffset[nt];
                                e: for(nt = 0; nt < 3; ++nt){
                                    if (Qr[nt].length !== this.contourLevels[nt].length) {
                                        Re = !0;
                                        break;
                                    }
                                    for(Ct = 0; Ct < Qr[nt].length; ++Ct)if (Qr[nt][Ct] !== this.contourLevels[nt][Ct]) {
                                        Re = !0;
                                        break e;
                                    }
                                }
                                this.contourLevels = Qr;
                            }
                            if (Re) {
                                Yt = this._field, Ge = this.shape;
                                for(var ai = [], jr = 0; jr < 3; ++jr){
                                    var ri = this.contourLevels[jr], bi = [], nn = [], Wi = [
                                        0,
                                        0,
                                        0
                                    ];
                                    for(nt = 0; nt < ri.length; ++nt){
                                        var Ni = b(this._field[jr], ri[nt]);
                                        bi.push(ai.length / 5 | 0), Ve = 0;
                                        e: for(Ct = 0; Ct < Ni.cells.length; ++Ct){
                                            var _n = Ni.cells[Ct];
                                            for(Le = 0; Le < 2; ++Le){
                                                var $i = Ni.positions[_n[Le]], zn = $i[0], Wn = Math.floor(zn) | 0, It = zn - Wn, ft = $i[1], jt = Math.floor(ft) | 0, Zt = ft - jt, yr = !1;
                                                t: for(var Fr = 0; Fr < 3; ++Fr){
                                                    Wi[Fr] = 0;
                                                    var Zr = (jr + Fr + 1) % 3;
                                                    for(Xe = 0; Xe < 2; ++Xe){
                                                        var Vr = Xe ? It : 1 - It;
                                                        for(Se = Math.min(Math.max(Wn + Xe, 0), Ge[0]) | 0, ht = 0; ht < 2; ++ht){
                                                            var gi = ht ? Zt : 1 - Zt;
                                                            if (lt = Math.min(Math.max(jt + ht, 0), Ge[1]) | 0, Fr < 2 ? xe = this._field[Zr].get(Se, lt) : xe = (this.intensity.get(Se, lt) - this.intensityBounds[0]) / (this.intensityBounds[1] - this.intensityBounds[0]), !isFinite(xe) || isNaN(xe)) {
                                                                yr = !0;
                                                                break t;
                                                            }
                                                            var Si = Vr * gi;
                                                            Wi[Fr] += Si * xe;
                                                        }
                                                    }
                                                }
                                                if (!yr) ai.push(Wi[0], Wi[1], $i[0], $i[1], Wi[2]), Ve += 1;
                                                else {
                                                    if (Le > 0) {
                                                        for(var Mi = 0; Mi < 5; ++Mi)ai.pop();
                                                        Ve -= 1;
                                                    }
                                                    continue e;
                                                }
                                            }
                                        }
                                        nn.push(Ve);
                                    }
                                    this._contourOffsets[jr] = bi, this._contourCounts[jr] = nn;
                                }
                                var Pi = f.mallocFloat(ai.length);
                                for(nt = 0; nt < ai.length; ++nt)Pi[nt] = ai[nt];
                                this._contourBuffer.update(Pi), f.freeFloat(Pi);
                            }
                        }, G.dispose = function() {
                            this._shader.dispose(), this._vao.dispose(), this._coordinateBuffer.dispose(), this._colorMap.dispose(), this._contourBuffer.dispose(), this._contourVAO.dispose(), this._contourShader.dispose(), this._contourPickShader.dispose(), this._dynamicBuffer.dispose(), this._dynamicVAO.dispose();
                            for(var Ce = 0; Ce < 3; ++Ce)f.freeFloat(this._field[Ce].data);
                        }, G.highlight = function(Ce) {
                            var me;
                            if (!Ce) {
                                this._dynamicCounts = [
                                    0,
                                    0,
                                    0
                                ], this.dyanamicLevel = [
                                    NaN,
                                    NaN,
                                    NaN
                                ], this.highlightLevel = [
                                    -1,
                                    -1,
                                    -1
                                ];
                                return;
                            }
                            for(me = 0; me < 3; ++me)this.enableHighlight[me] ? this.highlightLevel[me] = Ce.level[me] : this.highlightLevel[me] = -1;
                            var Re;
                            for(this.snapToData ? Re = Ce.dataCoordinate : Re = Ce.position, me = 0; me < 3; ++me)Re[me] -= this.objectOffset[me];
                            if (!((!this.enableDynamic[0] || Re[0] === this.dynamicLevel[0]) && (!this.enableDynamic[1] || Re[1] === this.dynamicLevel[1]) && (!this.enableDynamic[2] || Re[2] === this.dynamicLevel[2]))) {
                                for(var ce = 0, Ge = this.shape, nt = f.mallocFloat(12 * Ge[0] * Ge[1]), ct = 0; ct < 3; ++ct){
                                    if (!this.enableDynamic[ct]) {
                                        this.dynamicLevel[ct] = NaN, this._dynamicCounts[ct] = 0;
                                        continue;
                                    }
                                    this.dynamicLevel[ct] = Re[ct];
                                    var qt = (ct + 1) % 3, rt = (ct + 2) % 3, ot = this._field[ct], Rt = this._field[qt], kt = this._field[rt], Ct = b(ot, Re[ct]), Yt = Ct.cells, xr = Ct.positions;
                                    for(this._dynamicOffsets[ct] = ce, me = 0; me < Yt.length; ++me)for(var er = Yt[me], Ke = 0; Ke < 2; ++Ke){
                                        var xt = xr[er[Ke]], bt = +xt[0], Lt = bt | 0, St = Math.min(Lt + 1, Ge[0]) | 0, Et = bt - Lt, dt = 1 - Et, Ht = +xt[1], $t = Ht | 0, fr = Math.min($t + 1, Ge[1]) | 0, _r = Ht - $t, Br = 1 - _r, Or = dt * Br, Nr = dt * _r, ut = Et * Br, Ne = Et * _r, Ye = Or * Rt.get(Lt, $t) + Nr * Rt.get(Lt, fr) + ut * Rt.get(St, $t) + Ne * Rt.get(St, fr), Ve = Or * kt.get(Lt, $t) + Nr * kt.get(Lt, fr) + ut * kt.get(St, $t) + Ne * kt.get(St, fr);
                                        if (isNaN(Ye) || isNaN(Ve)) {
                                            Ke && (ce -= 1);
                                            break;
                                        }
                                        nt[2 * ce + 0] = Ye, nt[2 * ce + 1] = Ve, ce += 1;
                                    }
                                    this._dynamicCounts[ct] = ce - this._dynamicOffsets[ct];
                                }
                                this._dynamicBuffer.update(nt.subarray(0, 2 * ce)), f.freeFloat(nt);
                            }
                        };
                        function ze(Ce) {
                            var me = Ce.gl, Re = _(me), ce = M(me), Ge = C(me), nt = g(me), ct = l(me), qt = u(me, [
                                {
                                    buffer: ct,
                                    size: 4,
                                    stride: P,
                                    offset: 0
                                },
                                {
                                    buffer: ct,
                                    size: 3,
                                    stride: P,
                                    offset: 16
                                },
                                {
                                    buffer: ct,
                                    size: 3,
                                    stride: P,
                                    offset: 28
                                }
                            ]), rt = l(me), ot = u(me, [
                                {
                                    buffer: rt,
                                    size: 4,
                                    stride: 20,
                                    offset: 0
                                },
                                {
                                    buffer: rt,
                                    size: 1,
                                    stride: 20,
                                    offset: 16
                                }
                            ]), Rt = l(me), kt = u(me, [
                                {
                                    buffer: Rt,
                                    size: 2,
                                    type: me.FLOAT
                                }
                            ]), Ct = c(me, 1, H, me.RGBA, me.UNSIGNED_BYTE);
                            Ct.minFilter = me.LINEAR, Ct.magFilter = me.LINEAR;
                            var Yt = new X(me, [
                                0,
                                0
                            ], [
                                [
                                    0,
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    0,
                                    0
                                ]
                            ], Re, ce, ct, qt, Ct, Ge, nt, rt, ot, Rt, kt, [
                                0,
                                0,
                                0
                            ]), xr = {
                                levels: [
                                    [],
                                    [],
                                    []
                                ]
                            };
                            for(var er in Ce)xr[er] = Ce[er];
                            return xr.colormap = xr.colormap || "jet", Yt.update(xr), Yt;
                        }
                    },
                    7766: function(i, a, o) {
                        "use strict";
                        var s = o(9618), l = o(5298), u = o(1888);
                        i.exports = g;
                        var c = null, f = null, h = null;
                        function d(P) {
                            c = [
                                P.LINEAR,
                                P.NEAREST_MIPMAP_LINEAR,
                                P.LINEAR_MIPMAP_NEAREST,
                                P.LINEAR_MIPMAP_NEAREST
                            ], f = [
                                P.NEAREST,
                                P.LINEAR,
                                P.NEAREST_MIPMAP_NEAREST,
                                P.NEAREST_MIPMAP_LINEAR,
                                P.LINEAR_MIPMAP_NEAREST,
                                P.LINEAR_MIPMAP_LINEAR
                            ], h = [
                                P.REPEAT,
                                P.CLAMP_TO_EDGE,
                                P.MIRRORED_REPEAT
                            ];
                        }
                        function v(P) {
                            return typeof HTMLCanvasElement != "undefined" && P instanceof HTMLCanvasElement || typeof HTMLImageElement != "undefined" && P instanceof HTMLImageElement || typeof HTMLVideoElement != "undefined" && P instanceof HTMLVideoElement || typeof ImageData != "undefined" && P instanceof ImageData;
                        }
                        var x = function(P, T) {
                            l.muls(P, T, 255);
                        };
                        function b(P, T, F) {
                            var q = P.gl, V = q.getParameter(q.MAX_TEXTURE_SIZE);
                            if (T < 0 || T > V || F < 0 || F > V) throw new Error("gl-texture2d: Invalid texture size");
                            return P._shape = [
                                T,
                                F
                            ], P.bind(), q.texImage2D(q.TEXTURE_2D, 0, P.format, T, F, 0, P.format, P.type, null), P._mipLevels = [
                                0
                            ], P;
                        }
                        function p(P, T, F, q, V, H) {
                            this.gl = P, this.handle = T, this.format = V, this.type = H, this._shape = [
                                F,
                                q
                            ], this._mipLevels = [
                                0
                            ], this._magFilter = P.NEAREST, this._minFilter = P.NEAREST, this._wrapS = P.CLAMP_TO_EDGE, this._wrapT = P.CLAMP_TO_EDGE, this._anisoSamples = 1;
                            var X = this, G = [
                                this._wrapS,
                                this._wrapT
                            ];
                            Object.defineProperties(G, [
                                {
                                    get: function() {
                                        return X._wrapS;
                                    },
                                    set: function(W) {
                                        return X.wrapS = W;
                                    }
                                },
                                {
                                    get: function() {
                                        return X._wrapT;
                                    },
                                    set: function(W) {
                                        return X.wrapT = W;
                                    }
                                }
                            ]), this._wrapVector = G;
                            var N = [
                                this._shape[0],
                                this._shape[1]
                            ];
                            Object.defineProperties(N, [
                                {
                                    get: function() {
                                        return X._shape[0];
                                    },
                                    set: function(W) {
                                        return X.width = W;
                                    }
                                },
                                {
                                    get: function() {
                                        return X._shape[1];
                                    },
                                    set: function(W) {
                                        return X.height = W;
                                    }
                                }
                            ]), this._shapeVector = N;
                        }
                        var E = p.prototype;
                        Object.defineProperties(E, {
                            minFilter: {
                                get: function() {
                                    return this._minFilter;
                                },
                                set: function(P) {
                                    this.bind();
                                    var T = this.gl;
                                    if (this.type === T.FLOAT && c.indexOf(P) >= 0 && (T.getExtension("OES_texture_float_linear") || (P = T.NEAREST)), f.indexOf(P) < 0) throw new Error("gl-texture2d: Unknown filter mode " + P);
                                    return T.texParameteri(T.TEXTURE_2D, T.TEXTURE_MIN_FILTER, P), this._minFilter = P;
                                }
                            },
                            magFilter: {
                                get: function() {
                                    return this._magFilter;
                                },
                                set: function(P) {
                                    this.bind();
                                    var T = this.gl;
                                    if (this.type === T.FLOAT && c.indexOf(P) >= 0 && (T.getExtension("OES_texture_float_linear") || (P = T.NEAREST)), f.indexOf(P) < 0) throw new Error("gl-texture2d: Unknown filter mode " + P);
                                    return T.texParameteri(T.TEXTURE_2D, T.TEXTURE_MAG_FILTER, P), this._magFilter = P;
                                }
                            },
                            mipSamples: {
                                get: function() {
                                    return this._anisoSamples;
                                },
                                set: function(P) {
                                    var T = this._anisoSamples;
                                    if (this._anisoSamples = Math.max(P, 1) | 0, T !== this._anisoSamples) {
                                        var F = this.gl.getExtension("EXT_texture_filter_anisotropic");
                                        F && this.gl.texParameterf(this.gl.TEXTURE_2D, F.TEXTURE_MAX_ANISOTROPY_EXT, this._anisoSamples);
                                    }
                                    return this._anisoSamples;
                                }
                            },
                            wrapS: {
                                get: function() {
                                    return this._wrapS;
                                },
                                set: function(P) {
                                    if (this.bind(), h.indexOf(P) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + P);
                                    return this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_S, P), this._wrapS = P;
                                }
                            },
                            wrapT: {
                                get: function() {
                                    return this._wrapT;
                                },
                                set: function(P) {
                                    if (this.bind(), h.indexOf(P) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + P);
                                    return this.gl.texParameteri(this.gl.TEXTURE_2D, this.gl.TEXTURE_WRAP_T, P), this._wrapT = P;
                                }
                            },
                            wrap: {
                                get: function() {
                                    return this._wrapVector;
                                },
                                set: function(P) {
                                    if (Array.isArray(P) || (P = [
                                        P,
                                        P
                                    ]), P.length !== 2) throw new Error("gl-texture2d: Must specify wrap mode for rows and columns");
                                    for(var T = 0; T < 2; ++T)if (h.indexOf(P[T]) < 0) throw new Error("gl-texture2d: Unknown wrap mode " + P);
                                    this._wrapS = P[0], this._wrapT = P[1];
                                    var F = this.gl;
                                    return this.bind(), F.texParameteri(F.TEXTURE_2D, F.TEXTURE_WRAP_S, this._wrapS), F.texParameteri(F.TEXTURE_2D, F.TEXTURE_WRAP_T, this._wrapT), P;
                                }
                            },
                            shape: {
                                get: function() {
                                    return this._shapeVector;
                                },
                                set: function(P) {
                                    if (!Array.isArray(P)) P = [
                                        P | 0,
                                        P | 0
                                    ];
                                    else if (P.length !== 2) throw new Error("gl-texture2d: Invalid texture shape");
                                    return b(this, P[0] | 0, P[1] | 0), [
                                        P[0] | 0,
                                        P[1] | 0
                                    ];
                                }
                            },
                            width: {
                                get: function() {
                                    return this._shape[0];
                                },
                                set: function(P) {
                                    return P = P | 0, b(this, P, this._shape[1]), P;
                                }
                            },
                            height: {
                                get: function() {
                                    return this._shape[1];
                                },
                                set: function(P) {
                                    return P = P | 0, b(this, this._shape[0], P), P;
                                }
                            }
                        }), E.bind = function(P) {
                            var T = this.gl;
                            return P !== void 0 && T.activeTexture(T.TEXTURE0 + (P | 0)), T.bindTexture(T.TEXTURE_2D, this.handle), P !== void 0 ? P | 0 : T.getParameter(T.ACTIVE_TEXTURE) - T.TEXTURE0;
                        }, E.dispose = function() {
                            this.gl.deleteTexture(this.handle);
                        }, E.generateMipmap = function() {
                            this.bind(), this.gl.generateMipmap(this.gl.TEXTURE_2D);
                            for(var P = Math.min(this._shape[0], this._shape[1]), T = 0; P > 0; ++T, P >>>= 1)this._mipLevels.indexOf(T) < 0 && this._mipLevels.push(T);
                        }, E.setPixels = function(P, T, F, q) {
                            var V = this.gl;
                            this.bind(), Array.isArray(T) ? (q = F, F = T[1] | 0, T = T[0] | 0) : (T = T || 0, F = F || 0), q = q || 0;
                            var H = v(P) ? P : P.raw;
                            if (H) {
                                var X = this._mipLevels.indexOf(q) < 0;
                                X ? (V.texImage2D(V.TEXTURE_2D, 0, this.format, this.format, this.type, H), this._mipLevels.push(q)) : V.texSubImage2D(V.TEXTURE_2D, q, T, F, this.format, this.type, H);
                            } else if (P.shape && P.stride && P.data) {
                                if (P.shape.length < 2 || T + P.shape[1] > this._shape[1] >>> q || F + P.shape[0] > this._shape[0] >>> q || T < 0 || F < 0) throw new Error("gl-texture2d: Texture dimensions are out of bounds");
                                A(V, T, F, q, this.format, this.type, this._mipLevels, P);
                            } else throw new Error("gl-texture2d: Unsupported data type");
                        };
                        function k(P, T) {
                            return P.length === 3 ? T[2] === 1 && T[1] === P[0] * P[2] && T[0] === P[2] : T[0] === 1 && T[1] === P[0];
                        }
                        function A(P, T, F, q, V, H, X, G) {
                            var N = G.dtype, W = G.shape.slice();
                            if (W.length < 2 || W.length > 3) throw new Error("gl-texture2d: Invalid ndarray, must be 2d or 3d");
                            var re = 0, ae = 0, _e = k(W, G.stride.slice());
                            N === "float32" ? re = P.FLOAT : N === "float64" ? (re = P.FLOAT, _e = !1, N = "float32") : N === "uint8" ? re = P.UNSIGNED_BYTE : (re = P.UNSIGNED_BYTE, _e = !1, N = "uint8");
                            var Me = 1;
                            if (W.length === 2) ae = P.LUMINANCE, W = [
                                W[0],
                                W[1],
                                1
                            ], G = s(G.data, W, [
                                G.stride[0],
                                G.stride[1],
                                1
                            ], G.offset);
                            else if (W.length === 3) {
                                if (W[2] === 1) ae = P.ALPHA;
                                else if (W[2] === 2) ae = P.LUMINANCE_ALPHA;
                                else if (W[2] === 3) ae = P.RGB;
                                else if (W[2] === 4) ae = P.RGBA;
                                else throw new Error("gl-texture2d: Invalid shape for pixel coords");
                                Me = W[2];
                            } else throw new Error("gl-texture2d: Invalid shape for texture");
                            if ((ae === P.LUMINANCE || ae === P.ALPHA) && (V === P.LUMINANCE || V === P.ALPHA) && (ae = V), ae !== V) throw new Error("gl-texture2d: Incompatible texture format for setPixels");
                            var ke = G.size, ge = X.indexOf(q) < 0;
                            if (ge && X.push(q), re === H && _e) G.offset === 0 && G.data.length === ke ? ge ? P.texImage2D(P.TEXTURE_2D, q, V, W[0], W[1], 0, V, H, G.data) : P.texSubImage2D(P.TEXTURE_2D, q, T, F, W[0], W[1], V, H, G.data) : ge ? P.texImage2D(P.TEXTURE_2D, q, V, W[0], W[1], 0, V, H, G.data.subarray(G.offset, G.offset + ke)) : P.texSubImage2D(P.TEXTURE_2D, q, T, F, W[0], W[1], V, H, G.data.subarray(G.offset, G.offset + ke));
                            else {
                                var ie;
                                H === P.FLOAT ? ie = u.mallocFloat32(ke) : ie = u.mallocUint8(ke);
                                var Te = s(ie, W, [
                                    W[2],
                                    W[2] * W[0],
                                    1
                                ]);
                                re === P.FLOAT && H === P.UNSIGNED_BYTE ? x(Te, G) : l.assign(Te, G), ge ? P.texImage2D(P.TEXTURE_2D, q, V, W[0], W[1], 0, V, H, ie.subarray(0, ke)) : P.texSubImage2D(P.TEXTURE_2D, q, T, F, W[0], W[1], V, H, ie.subarray(0, ke)), H === P.FLOAT ? u.freeFloat32(ie) : u.freeUint8(ie);
                            }
                        }
                        function L(P) {
                            var T = P.createTexture();
                            return P.bindTexture(P.TEXTURE_2D, T), P.texParameteri(P.TEXTURE_2D, P.TEXTURE_MIN_FILTER, P.NEAREST), P.texParameteri(P.TEXTURE_2D, P.TEXTURE_MAG_FILTER, P.NEAREST), P.texParameteri(P.TEXTURE_2D, P.TEXTURE_WRAP_S, P.CLAMP_TO_EDGE), P.texParameteri(P.TEXTURE_2D, P.TEXTURE_WRAP_T, P.CLAMP_TO_EDGE), T;
                        }
                        function _(P, T, F, q, V) {
                            var H = P.getParameter(P.MAX_TEXTURE_SIZE);
                            if (T < 0 || T > H || F < 0 || F > H) throw new Error("gl-texture2d: Invalid texture shape");
                            if (V === P.FLOAT && !P.getExtension("OES_texture_float")) throw new Error("gl-texture2d: Floating point textures not supported on this platform");
                            var X = L(P);
                            return P.texImage2D(P.TEXTURE_2D, 0, q, T, F, 0, q, V, null), new p(P, X, T, F, q, V);
                        }
                        function C(P, T, F, q, V, H) {
                            var X = L(P);
                            return P.texImage2D(P.TEXTURE_2D, 0, V, V, H, T), new p(P, X, F, q, V, H);
                        }
                        function M(P, T) {
                            var F = T.dtype, q = T.shape.slice(), V = P.getParameter(P.MAX_TEXTURE_SIZE);
                            if (q[0] < 0 || q[0] > V || q[1] < 0 || q[1] > V) throw new Error("gl-texture2d: Invalid texture size");
                            var H = k(q, T.stride.slice()), X = 0;
                            F === "float32" ? X = P.FLOAT : F === "float64" ? (X = P.FLOAT, H = !1, F = "float32") : F === "uint8" ? X = P.UNSIGNED_BYTE : (X = P.UNSIGNED_BYTE, H = !1, F = "uint8");
                            var G = 0;
                            if (q.length === 2) G = P.LUMINANCE, q = [
                                q[0],
                                q[1],
                                1
                            ], T = s(T.data, q, [
                                T.stride[0],
                                T.stride[1],
                                1
                            ], T.offset);
                            else if (q.length === 3) {
                                if (q[2] === 1) G = P.ALPHA;
                                else if (q[2] === 2) G = P.LUMINANCE_ALPHA;
                                else if (q[2] === 3) G = P.RGB;
                                else if (q[2] === 4) G = P.RGBA;
                                else throw new Error("gl-texture2d: Invalid shape for pixel coords");
                            } else throw new Error("gl-texture2d: Invalid shape for texture");
                            X === P.FLOAT && !P.getExtension("OES_texture_float") && (X = P.UNSIGNED_BYTE, H = !1);
                            var N, W, re = T.size;
                            if (H) T.offset === 0 && T.data.length === re ? N = T.data : N = T.data.subarray(T.offset, T.offset + re);
                            else {
                                var ae = [
                                    q[2],
                                    q[2] * q[0],
                                    1
                                ];
                                W = u.malloc(re, F);
                                var _e = s(W, q, ae, 0);
                                (F === "float32" || F === "float64") && X === P.UNSIGNED_BYTE ? x(_e, T) : l.assign(_e, T), N = W.subarray(0, re);
                            }
                            var Me = L(P);
                            return P.texImage2D(P.TEXTURE_2D, 0, G, q[0], q[1], 0, G, X, N), H || u.free(W), new p(P, Me, q[0], q[1], G, X);
                        }
                        function g(P) {
                            if (arguments.length <= 1) throw new Error("gl-texture2d: Missing arguments for texture2d constructor");
                            if (c || d(P), typeof arguments[1] == "number") return _(P, arguments[1], arguments[2], arguments[3] || P.RGBA, arguments[4] || P.UNSIGNED_BYTE);
                            if (Array.isArray(arguments[1])) return _(P, arguments[1][0] | 0, arguments[1][1] | 0, arguments[2] || P.RGBA, arguments[3] || P.UNSIGNED_BYTE);
                            if (typeof arguments[1] == "object") {
                                var T = arguments[1], F = v(T) ? T : T.raw;
                                if (F) return C(P, F, T.width | 0, T.height | 0, arguments[2] || P.RGBA, arguments[3] || P.UNSIGNED_BYTE);
                                if (T.shape && T.data && T.stride) return M(P, T);
                            }
                            throw new Error("gl-texture2d: Invalid arguments for texture2d constructor");
                        }
                    },
                    1433: function(i) {
                        "use strict";
                        function a(o, s, l) {
                            s ? s.bind() : o.bindBuffer(o.ELEMENT_ARRAY_BUFFER, null);
                            var u = o.getParameter(o.MAX_VERTEX_ATTRIBS) | 0;
                            if (l) {
                                if (l.length > u) throw new Error("gl-vao: Too many vertex attributes");
                                for(var c = 0; c < l.length; ++c){
                                    var f = l[c];
                                    if (f.buffer) {
                                        var h = f.buffer, d = f.size || 4, v = f.type || o.FLOAT, x = !!f.normalized, b = f.stride || 0, p = f.offset || 0;
                                        h.bind(), o.enableVertexAttribArray(c), o.vertexAttribPointer(c, d, v, x, b, p);
                                    } else {
                                        if (typeof f == "number") o.vertexAttrib1f(c, f);
                                        else if (f.length === 1) o.vertexAttrib1f(c, f[0]);
                                        else if (f.length === 2) o.vertexAttrib2f(c, f[0], f[1]);
                                        else if (f.length === 3) o.vertexAttrib3f(c, f[0], f[1], f[2]);
                                        else if (f.length === 4) o.vertexAttrib4f(c, f[0], f[1], f[2], f[3]);
                                        else throw new Error("gl-vao: Invalid vertex attribute");
                                        o.disableVertexAttribArray(c);
                                    }
                                }
                                for(; c < u; ++c)o.disableVertexAttribArray(c);
                            } else {
                                o.bindBuffer(o.ARRAY_BUFFER, null);
                                for(var c = 0; c < u; ++c)o.disableVertexAttribArray(c);
                            }
                        }
                        i.exports = a;
                    },
                    870: function(i, a, o) {
                        "use strict";
                        var s = o(1433);
                        function l(c) {
                            this.gl = c, this._elements = null, this._attributes = null, this._elementsType = c.UNSIGNED_SHORT;
                        }
                        l.prototype.bind = function() {
                            s(this.gl, this._elements, this._attributes);
                        }, l.prototype.update = function(c, f, h) {
                            this._elements = f, this._attributes = c, this._elementsType = h || this.gl.UNSIGNED_SHORT;
                        }, l.prototype.dispose = function() {}, l.prototype.unbind = function() {}, l.prototype.draw = function(c, f, h) {
                            h = h || 0;
                            var d = this.gl;
                            this._elements ? d.drawElements(c, f, this._elementsType, h) : d.drawArrays(c, h, f);
                        };
                        function u(c) {
                            return new l(c);
                        }
                        i.exports = u;
                    },
                    7518: function(i, a, o) {
                        "use strict";
                        var s = o(1433);
                        function l(f, h, d, v, x, b) {
                            this.location = f, this.dimension = h, this.a = d, this.b = v, this.c = x, this.d = b;
                        }
                        l.prototype.bind = function(f) {
                            switch(this.dimension){
                                case 1:
                                    f.vertexAttrib1f(this.location, this.a);
                                    break;
                                case 2:
                                    f.vertexAttrib2f(this.location, this.a, this.b);
                                    break;
                                case 3:
                                    f.vertexAttrib3f(this.location, this.a, this.b, this.c);
                                    break;
                                case 4:
                                    f.vertexAttrib4f(this.location, this.a, this.b, this.c, this.d);
                                    break;
                            }
                        };
                        function u(f, h, d) {
                            this.gl = f, this._ext = h, this.handle = d, this._attribs = [], this._useElements = !1, this._elementsType = f.UNSIGNED_SHORT;
                        }
                        u.prototype.bind = function() {
                            this._ext.bindVertexArrayOES(this.handle);
                            for(var f = 0; f < this._attribs.length; ++f)this._attribs[f].bind(this.gl);
                        }, u.prototype.unbind = function() {
                            this._ext.bindVertexArrayOES(null);
                        }, u.prototype.dispose = function() {
                            this._ext.deleteVertexArrayOES(this.handle);
                        }, u.prototype.update = function(f, h, d) {
                            if (this.bind(), s(this.gl, h, f), this.unbind(), this._attribs.length = 0, f) for(var v = 0; v < f.length; ++v){
                                var x = f[v];
                                typeof x == "number" ? this._attribs.push(new l(v, 1, x)) : Array.isArray(x) && this._attribs.push(new l(v, x.length, x[0], x[1], x[2], x[3]));
                            }
                            this._useElements = !!h, this._elementsType = d || this.gl.UNSIGNED_SHORT;
                        }, u.prototype.draw = function(f, h, d) {
                            d = d || 0;
                            var v = this.gl;
                            this._useElements ? v.drawElements(f, h, this._elementsType, d) : v.drawArrays(f, d, h);
                        };
                        function c(f, h) {
                            return new u(f, h, h.createVertexArrayOES());
                        }
                        i.exports = c;
                    },
                    8116: function(i, a, o) {
                        "use strict";
                        var s = o(7518), l = o(870);
                        function u(f) {
                            this.bindVertexArrayOES = f.bindVertexArray.bind(f), this.createVertexArrayOES = f.createVertexArray.bind(f), this.deleteVertexArrayOES = f.deleteVertexArray.bind(f);
                        }
                        function c(f, h, d, v) {
                            var x = f.createVertexArray ? new u(f) : f.getExtension("OES_vertex_array_object"), b;
                            return x ? b = s(f, x) : b = l(f), b.update(h, d, v), b;
                        }
                        i.exports = c;
                    },
                    5632: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = s[0] + l[0], o[1] = s[1] + l[1], o[2] = s[2] + l[2], o;
                        }
                    },
                    8192: function(i, a, o) {
                        i.exports = c;
                        var s = o(2825), l = o(3536), u = o(244);
                        function c(f, h) {
                            var d = s(f[0], f[1], f[2]), v = s(h[0], h[1], h[2]);
                            l(d, d), l(v, v);
                            var x = u(d, v);
                            return x > 1 ? 0 : Math.acos(x);
                        }
                    },
                    9226: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] = Math.ceil(s[0]), o[1] = Math.ceil(s[1]), o[2] = Math.ceil(s[2]), o;
                        }
                    },
                    3126: function(i) {
                        i.exports = a;
                        function a(o) {
                            var s = new Float32Array(3);
                            return s[0] = o[0], s[1] = o[1], s[2] = o[2], s;
                        }
                    },
                    3990: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] = s[0], o[1] = s[1], o[2] = s[2], o;
                        }
                    },
                    1091: function(i) {
                        i.exports = a;
                        function a() {
                            var o = new Float32Array(3);
                            return o[0] = 0, o[1] = 0, o[2] = 0, o;
                        }
                    },
                    5911: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = s[0], c = s[1], f = s[2], h = l[0], d = l[1], v = l[2];
                            return o[0] = c * v - f * d, o[1] = f * h - u * v, o[2] = u * d - c * h, o;
                        }
                    },
                    5455: function(i, a, o) {
                        i.exports = o(7056);
                    },
                    7056: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            var l = s[0] - o[0], u = s[1] - o[1], c = s[2] - o[2];
                            return Math.sqrt(l * l + u * u + c * c);
                        }
                    },
                    4008: function(i, a, o) {
                        i.exports = o(6690);
                    },
                    6690: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = s[0] / l[0], o[1] = s[1] / l[1], o[2] = s[2] / l[2], o;
                        }
                    },
                    244: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] * s[0] + o[1] * s[1] + o[2] * s[2];
                        }
                    },
                    2613: function(i) {
                        i.exports = 1e-6;
                    },
                    9922: function(i, a, o) {
                        i.exports = l;
                        var s = o(2613);
                        function l(u, c) {
                            var f = u[0], h = u[1], d = u[2], v = c[0], x = c[1], b = c[2];
                            return Math.abs(f - v) <= s * Math.max(1, Math.abs(f), Math.abs(v)) && Math.abs(h - x) <= s * Math.max(1, Math.abs(h), Math.abs(x)) && Math.abs(d - b) <= s * Math.max(1, Math.abs(d), Math.abs(b));
                        }
                    },
                    9265: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] === s[0] && o[1] === s[1] && o[2] === s[2];
                        }
                    },
                    2681: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] = Math.floor(s[0]), o[1] = Math.floor(s[1]), o[2] = Math.floor(s[2]), o;
                        }
                    },
                    5137: function(i, a, o) {
                        i.exports = l;
                        var s = o(1091)();
                        function l(u, c, f, h, d, v) {
                            var x, b;
                            for(c || (c = 3), f || (f = 0), h ? b = Math.min(h * c + f, u.length) : b = u.length, x = f; x < b; x += c)s[0] = u[x], s[1] = u[x + 1], s[2] = u[x + 2], d(s, s, v), u[x] = s[0], u[x + 1] = s[1], u[x + 2] = s[2];
                            return u;
                        }
                    },
                    2825: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = new Float32Array(3);
                            return u[0] = o, u[1] = s, u[2] = l, u;
                        }
                    },
                    2931: function(i, a, o) {
                        i.exports = {
                            EPSILON: o(2613),
                            create: o(1091),
                            clone: o(3126),
                            angle: o(8192),
                            fromValues: o(2825),
                            copy: o(3990),
                            set: o(1463),
                            equals: o(9922),
                            exactEquals: o(9265),
                            add: o(5632),
                            subtract: o(6843),
                            sub: o(2229),
                            multiply: o(5847),
                            mul: o(4505),
                            divide: o(6690),
                            div: o(4008),
                            min: o(8107),
                            max: o(7417),
                            floor: o(2681),
                            ceil: o(9226),
                            round: o(2447),
                            scale: o(6621),
                            scaleAndAdd: o(8489),
                            distance: o(7056),
                            dist: o(5455),
                            squaredDistance: o(2953),
                            sqrDist: o(6141),
                            length: o(1387),
                            len: o(868),
                            squaredLength: o(3066),
                            sqrLen: o(5486),
                            negate: o(5093),
                            inverse: o(811),
                            normalize: o(3536),
                            dot: o(244),
                            cross: o(5911),
                            lerp: o(6658),
                            random: o(7636),
                            transformMat4: o(5673),
                            transformMat3: o(492),
                            transformQuat: o(264),
                            rotateX: o(6894),
                            rotateY: o(109),
                            rotateZ: o(8692),
                            forEach: o(5137)
                        };
                    },
                    811: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] = 1 / s[0], o[1] = 1 / s[1], o[2] = 1 / s[2], o;
                        }
                    },
                    868: function(i, a, o) {
                        i.exports = o(1387);
                    },
                    1387: function(i) {
                        i.exports = a;
                        function a(o) {
                            var s = o[0], l = o[1], u = o[2];
                            return Math.sqrt(s * s + l * l + u * u);
                        }
                    },
                    6658: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            var c = s[0], f = s[1], h = s[2];
                            return o[0] = c + u * (l[0] - c), o[1] = f + u * (l[1] - f), o[2] = h + u * (l[2] - h), o;
                        }
                    },
                    7417: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = Math.max(s[0], l[0]), o[1] = Math.max(s[1], l[1]), o[2] = Math.max(s[2], l[2]), o;
                        }
                    },
                    8107: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = Math.min(s[0], l[0]), o[1] = Math.min(s[1], l[1]), o[2] = Math.min(s[2], l[2]), o;
                        }
                    },
                    4505: function(i, a, o) {
                        i.exports = o(5847);
                    },
                    5847: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = s[0] * l[0], o[1] = s[1] * l[1], o[2] = s[2] * l[2], o;
                        }
                    },
                    5093: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] = -s[0], o[1] = -s[1], o[2] = -s[2], o;
                        }
                    },
                    3536: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            var l = s[0], u = s[1], c = s[2], f = l * l + u * u + c * c;
                            return f > 0 && (f = 1 / Math.sqrt(f), o[0] = s[0] * f, o[1] = s[1] * f, o[2] = s[2] * f), o;
                        }
                    },
                    7636: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            s = s || 1;
                            var l = Math.random() * 2 * Math.PI, u = Math.random() * 2 - 1, c = Math.sqrt(1 - u * u) * s;
                            return o[0] = Math.cos(l) * c, o[1] = Math.sin(l) * c, o[2] = u * s, o;
                        }
                    },
                    6894: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            var c = l[1], f = l[2], h = s[1] - c, d = s[2] - f, v = Math.sin(u), x = Math.cos(u);
                            return o[0] = s[0], o[1] = c + h * x - d * v, o[2] = f + h * v + d * x, o;
                        }
                    },
                    109: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            var c = l[0], f = l[2], h = s[0] - c, d = s[2] - f, v = Math.sin(u), x = Math.cos(u);
                            return o[0] = c + d * v + h * x, o[1] = s[1], o[2] = f + d * x - h * v, o;
                        }
                    },
                    8692: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            var c = l[0], f = l[1], h = s[0] - c, d = s[1] - f, v = Math.sin(u), x = Math.cos(u);
                            return o[0] = c + h * x - d * v, o[1] = f + h * v + d * x, o[2] = s[2], o;
                        }
                    },
                    2447: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] = Math.round(s[0]), o[1] = Math.round(s[1]), o[2] = Math.round(s[2]), o;
                        }
                    },
                    6621: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = s[0] * l, o[1] = s[1] * l, o[2] = s[2] * l, o;
                        }
                    },
                    8489: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            return o[0] = s[0] + l[0] * u, o[1] = s[1] + l[1] * u, o[2] = s[2] + l[2] * u, o;
                        }
                    },
                    1463: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            return o[0] = s, o[1] = l, o[2] = u, o;
                        }
                    },
                    6141: function(i, a, o) {
                        i.exports = o(2953);
                    },
                    5486: function(i, a, o) {
                        i.exports = o(3066);
                    },
                    2953: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            var l = s[0] - o[0], u = s[1] - o[1], c = s[2] - o[2];
                            return l * l + u * u + c * c;
                        }
                    },
                    3066: function(i) {
                        i.exports = a;
                        function a(o) {
                            var s = o[0], l = o[1], u = o[2];
                            return s * s + l * l + u * u;
                        }
                    },
                    2229: function(i, a, o) {
                        i.exports = o(6843);
                    },
                    6843: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = s[0] - l[0], o[1] = s[1] - l[1], o[2] = s[2] - l[2], o;
                        }
                    },
                    492: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = s[0], c = s[1], f = s[2];
                            return o[0] = u * l[0] + c * l[3] + f * l[6], o[1] = u * l[1] + c * l[4] + f * l[7], o[2] = u * l[2] + c * l[5] + f * l[8], o;
                        }
                    },
                    5673: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = s[0], c = s[1], f = s[2], h = l[3] * u + l[7] * c + l[11] * f + l[15];
                            return h = h || 1, o[0] = (l[0] * u + l[4] * c + l[8] * f + l[12]) / h, o[1] = (l[1] * u + l[5] * c + l[9] * f + l[13]) / h, o[2] = (l[2] * u + l[6] * c + l[10] * f + l[14]) / h, o;
                        }
                    },
                    264: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = s[0], c = s[1], f = s[2], h = l[0], d = l[1], v = l[2], x = l[3], b = x * u + d * f - v * c, p = x * c + v * u - h * f, E = x * f + h * c - d * u, k = -h * u - d * c - v * f;
                            return o[0] = b * x + k * -h + p * -v - E * -d, o[1] = p * x + k * -d + E * -h - b * -v, o[2] = E * x + k * -v + b * -d - p * -h, o;
                        }
                    },
                    4361: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = s[0] + l[0], o[1] = s[1] + l[1], o[2] = s[2] + l[2], o[3] = s[3] + l[3], o;
                        }
                    },
                    2335: function(i) {
                        i.exports = a;
                        function a(o) {
                            var s = new Float32Array(4);
                            return s[0] = o[0], s[1] = o[1], s[2] = o[2], s[3] = o[3], s;
                        }
                    },
                    2933: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] = s[0], o[1] = s[1], o[2] = s[2], o[3] = s[3], o;
                        }
                    },
                    7536: function(i) {
                        i.exports = a;
                        function a() {
                            var o = new Float32Array(4);
                            return o[0] = 0, o[1] = 0, o[2] = 0, o[3] = 0, o;
                        }
                    },
                    4691: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            var l = s[0] - o[0], u = s[1] - o[1], c = s[2] - o[2], f = s[3] - o[3];
                            return Math.sqrt(l * l + u * u + c * c + f * f);
                        }
                    },
                    1373: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = s[0] / l[0], o[1] = s[1] / l[1], o[2] = s[2] / l[2], o[3] = s[3] / l[3], o;
                        }
                    },
                    3750: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] * s[0] + o[1] * s[1] + o[2] * s[2] + o[3] * s[3];
                        }
                    },
                    3390: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            var c = new Float32Array(4);
                            return c[0] = o, c[1] = s, c[2] = l, c[3] = u, c;
                        }
                    },
                    9970: function(i, a, o) {
                        i.exports = {
                            create: o(7536),
                            clone: o(2335),
                            fromValues: o(3390),
                            copy: o(2933),
                            set: o(4578),
                            add: o(4361),
                            subtract: o(6860),
                            multiply: o(3576),
                            divide: o(1373),
                            min: o(2334),
                            max: o(160),
                            scale: o(9288),
                            scaleAndAdd: o(4844),
                            distance: o(4691),
                            squaredDistance: o(7960),
                            length: o(6808),
                            squaredLength: o(483),
                            negate: o(1498),
                            inverse: o(4494),
                            normalize: o(5177),
                            dot: o(3750),
                            lerp: o(2573),
                            random: o(9131),
                            transformMat4: o(5352),
                            transformQuat: o(4041)
                        };
                    },
                    4494: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] = 1 / s[0], o[1] = 1 / s[1], o[2] = 1 / s[2], o[3] = 1 / s[3], o;
                        }
                    },
                    6808: function(i) {
                        i.exports = a;
                        function a(o) {
                            var s = o[0], l = o[1], u = o[2], c = o[3];
                            return Math.sqrt(s * s + l * l + u * u + c * c);
                        }
                    },
                    2573: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            var c = s[0], f = s[1], h = s[2], d = s[3];
                            return o[0] = c + u * (l[0] - c), o[1] = f + u * (l[1] - f), o[2] = h + u * (l[2] - h), o[3] = d + u * (l[3] - d), o;
                        }
                    },
                    160: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = Math.max(s[0], l[0]), o[1] = Math.max(s[1], l[1]), o[2] = Math.max(s[2], l[2]), o[3] = Math.max(s[3], l[3]), o;
                        }
                    },
                    2334: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = Math.min(s[0], l[0]), o[1] = Math.min(s[1], l[1]), o[2] = Math.min(s[2], l[2]), o[3] = Math.min(s[3], l[3]), o;
                        }
                    },
                    3576: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = s[0] * l[0], o[1] = s[1] * l[1], o[2] = s[2] * l[2], o[3] = s[3] * l[3], o;
                        }
                    },
                    1498: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            return o[0] = -s[0], o[1] = -s[1], o[2] = -s[2], o[3] = -s[3], o;
                        }
                    },
                    5177: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            var l = s[0], u = s[1], c = s[2], f = s[3], h = l * l + u * u + c * c + f * f;
                            return h > 0 && (h = 1 / Math.sqrt(h), o[0] = l * h, o[1] = u * h, o[2] = c * h, o[3] = f * h), o;
                        }
                    },
                    9131: function(i, a, o) {
                        var s = o(5177), l = o(9288);
                        i.exports = u;
                        function u(c, f) {
                            return f = f || 1, c[0] = Math.random(), c[1] = Math.random(), c[2] = Math.random(), c[3] = Math.random(), s(c, c), l(c, c, f), c;
                        }
                    },
                    9288: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = s[0] * l, o[1] = s[1] * l, o[2] = s[2] * l, o[3] = s[3] * l, o;
                        }
                    },
                    4844: function(i) {
                        i.exports = a;
                        function a(o, s, l, u) {
                            return o[0] = s[0] + l[0] * u, o[1] = s[1] + l[1] * u, o[2] = s[2] + l[2] * u, o[3] = s[3] + l[3] * u, o;
                        }
                    },
                    4578: function(i) {
                        i.exports = a;
                        function a(o, s, l, u, c) {
                            return o[0] = s, o[1] = l, o[2] = u, o[3] = c, o;
                        }
                    },
                    7960: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            var l = s[0] - o[0], u = s[1] - o[1], c = s[2] - o[2], f = s[3] - o[3];
                            return l * l + u * u + c * c + f * f;
                        }
                    },
                    483: function(i) {
                        i.exports = a;
                        function a(o) {
                            var s = o[0], l = o[1], u = o[2], c = o[3];
                            return s * s + l * l + u * u + c * c;
                        }
                    },
                    6860: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            return o[0] = s[0] - l[0], o[1] = s[1] - l[1], o[2] = s[2] - l[2], o[3] = s[3] - l[3], o;
                        }
                    },
                    5352: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = s[0], c = s[1], f = s[2], h = s[3];
                            return o[0] = l[0] * u + l[4] * c + l[8] * f + l[12] * h, o[1] = l[1] * u + l[5] * c + l[9] * f + l[13] * h, o[2] = l[2] * u + l[6] * c + l[10] * f + l[14] * h, o[3] = l[3] * u + l[7] * c + l[11] * f + l[15] * h, o;
                        }
                    },
                    4041: function(i) {
                        i.exports = a;
                        function a(o, s, l) {
                            var u = s[0], c = s[1], f = s[2], h = l[0], d = l[1], v = l[2], x = l[3], b = x * u + d * f - v * c, p = x * c + v * u - h * f, E = x * f + h * c - d * u, k = -h * u - d * c - v * f;
                            return o[0] = b * x + k * -h + p * -v - E * -d, o[1] = p * x + k * -d + E * -h - b * -v, o[2] = E * x + k * -v + b * -d - p * -h, o[3] = s[3], o;
                        }
                    },
                    1848: function(i, a, o) {
                        var s = o(4905), l = o(6468);
                        i.exports = u;
                        function u(c) {
                            for(var f = Array.isArray(c) ? c : s(c), h = 0; h < f.length; h++){
                                var d = f[h];
                                if (d.type === "preprocessor") {
                                    var v = d.data.match(/\#define\s+SHADER_NAME(_B64)?\s+(.+)$/);
                                    if (v && v[2]) {
                                        var x = v[1], b = v[2];
                                        return (x ? l(b) : b).trim();
                                    }
                                }
                            }
                        }
                    },
                    5874: function(i, a, o) {
                        i.exports = T;
                        var s = o(620), l = o(7827), u = o(6852), c = o(7932), f = o(3508), h = 999, d = 9999, v = 0, x = 1, b = 2, p = 3, E = 4, k = 5, A = 6, L = 7, _ = 8, C = 9, M = 10, g = 11, P = [
                            "block-comment",
                            "line-comment",
                            "preprocessor",
                            "operator",
                            "integer",
                            "float",
                            "ident",
                            "builtin",
                            "keyword",
                            "whitespace",
                            "eof",
                            "integer"
                        ];
                        function T(F) {
                            var q = 0, V = 0, H = h, X, G, N = [], W = [], re = 0, ae = 0, _e = 1, Me = 0, ke = 0, ge = !1, ie = !1, Te = "", Ee;
                            F = F || {};
                            var Ae = u, ze = s;
                            F.version === "300 es" && (Ae = f, ze = c);
                            for(var Ce = {}, me = {}, q = 0; q < Ae.length; q++)Ce[Ae[q]] = !0;
                            for(var q = 0; q < ze.length; q++)me[ze[q]] = !0;
                            return function(Ke) {
                                return W = [], Ke !== null ? ce(Ke) : Ge();
                            };
                            function Re(Ke) {
                                Ke.length && W.push({
                                    type: P[H],
                                    data: Ke,
                                    position: ke,
                                    line: _e,
                                    column: Me
                                });
                            }
                            function ce(Ke) {
                                q = 0, Ke.toString && (Ke = Ke.toString()), Te += Ke.replace(/\r\n/g, `
`), Ee = Te.length;
                                for(var xt; X = Te[q], q < Ee;){
                                    switch(xt = q, H){
                                        case v:
                                            q = ot();
                                            break;
                                        case x:
                                            q = rt();
                                            break;
                                        case b:
                                            q = qt();
                                            break;
                                        case p:
                                            q = Rt();
                                            break;
                                        case E:
                                            q = Yt();
                                            break;
                                        case g:
                                            q = Ct();
                                            break;
                                        case k:
                                            q = xr();
                                            break;
                                        case d:
                                            q = er();
                                            break;
                                        case C:
                                            q = ct();
                                            break;
                                        case h:
                                            q = nt();
                                            break;
                                    }
                                    if (xt !== q) switch(Te[xt]){
                                        case `
`:
                                            Me = 0, ++_e;
                                            break;
                                        default:
                                            ++Me;
                                            break;
                                    }
                                }
                                return V += q, Te = Te.slice(q), W;
                            }
                            function Ge(Ke) {
                                return N.length && Re(N.join("")), H = M, Re("(eof)"), W;
                            }
                            function nt() {
                                return N = N.length ? [] : N, G === "/" && X === "*" ? (ke = V + q - 1, H = v, G = X, q + 1) : G === "/" && X === "/" ? (ke = V + q - 1, H = x, G = X, q + 1) : X === "#" ? (H = b, ke = V + q, q) : /\s/.test(X) ? (H = C, ke = V + q, q) : (ge = /\d/.test(X), ie = /[^\w_]/.test(X), ke = V + q, H = ge ? E : ie ? p : d, q);
                            }
                            function ct() {
                                return /[^\s]/g.test(X) ? (Re(N.join("")), H = h, q) : (N.push(X), G = X, q + 1);
                            }
                            function qt() {
                                return (X === "\r" || X === `
`) && G !== "\\" ? (Re(N.join("")), H = h, q) : (N.push(X), G = X, q + 1);
                            }
                            function rt() {
                                return qt();
                            }
                            function ot() {
                                return X === "/" && G === "*" ? (N.push(X), Re(N.join("")), H = h, q + 1) : (N.push(X), G = X, q + 1);
                            }
                            function Rt() {
                                if (G === "." && /\d/.test(X)) return H = k, q;
                                if (G === "/" && X === "*") return H = v, q;
                                if (G === "/" && X === "/") return H = x, q;
                                if (X === "." && N.length) {
                                    for(; kt(N););
                                    return H = k, q;
                                }
                                if (X === ";" || X === ")" || X === "(") {
                                    if (N.length) for(; kt(N););
                                    return Re(X), H = h, q + 1;
                                }
                                var Ke = N.length === 2 && X !== "=";
                                if (/[\w_\d\s]/.test(X) || Ke) {
                                    for(; kt(N););
                                    return H = h, q;
                                }
                                return N.push(X), G = X, q + 1;
                            }
                            function kt(Ke) {
                                var xt = 0, bt, Lt;
                                do {
                                    if (bt = l.indexOf(Ke.slice(0, Ke.length + xt).join("")), Lt = l[bt], bt === -1) {
                                        if (xt-- + Ke.length > 0) continue;
                                        Lt = Ke.slice(0, 1).join("");
                                    }
                                    return Re(Lt), ke += Lt.length, N = N.slice(Lt.length), N.length;
                                }while (!0);
                            }
                            function Ct() {
                                return /[^a-fA-F0-9]/.test(X) ? (Re(N.join("")), H = h, q) : (N.push(X), G = X, q + 1);
                            }
                            function Yt() {
                                return X === "." || /[eE]/.test(X) ? (N.push(X), H = k, G = X, q + 1) : X === "x" && N.length === 1 && N[0] === "0" ? (H = g, N.push(X), G = X, q + 1) : /[^\d]/.test(X) ? (Re(N.join("")), H = h, q) : (N.push(X), G = X, q + 1);
                            }
                            function xr() {
                                return X === "f" && (N.push(X), G = X, q += 1), /[eE]/.test(X) || (X === "-" || X === "+") && /[eE]/.test(G) ? (N.push(X), G = X, q + 1) : /[^\d]/.test(X) ? (Re(N.join("")), H = h, q) : (N.push(X), G = X, q + 1);
                            }
                            function er() {
                                if (/[^\d\w_]/.test(X)) {
                                    var Ke = N.join("");
                                    return me[Ke] ? H = _ : Ce[Ke] ? H = L : H = A, Re(N.join("")), H = h, q;
                                }
                                return N.push(X), G = X, q + 1;
                            }
                        }
                    },
                    3508: function(i, a, o) {
                        var s = o(6852);
                        s = s.slice().filter(function(l) {
                            return !/^(gl\_|texture)/.test(l);
                        }), i.exports = s.concat([
                            "gl_VertexID",
                            "gl_InstanceID",
                            "gl_Position",
                            "gl_PointSize",
                            "gl_FragCoord",
                            "gl_FrontFacing",
                            "gl_FragDepth",
                            "gl_PointCoord",
                            "gl_MaxVertexAttribs",
                            "gl_MaxVertexUniformVectors",
                            "gl_MaxVertexOutputVectors",
                            "gl_MaxFragmentInputVectors",
                            "gl_MaxVertexTextureImageUnits",
                            "gl_MaxCombinedTextureImageUnits",
                            "gl_MaxTextureImageUnits",
                            "gl_MaxFragmentUniformVectors",
                            "gl_MaxDrawBuffers",
                            "gl_MinProgramTexelOffset",
                            "gl_MaxProgramTexelOffset",
                            "gl_DepthRangeParameters",
                            "gl_DepthRange",
                            "trunc",
                            "round",
                            "roundEven",
                            "isnan",
                            "isinf",
                            "floatBitsToInt",
                            "floatBitsToUint",
                            "intBitsToFloat",
                            "uintBitsToFloat",
                            "packSnorm2x16",
                            "unpackSnorm2x16",
                            "packUnorm2x16",
                            "unpackUnorm2x16",
                            "packHalf2x16",
                            "unpackHalf2x16",
                            "outerProduct",
                            "transpose",
                            "determinant",
                            "inverse",
                            "texture",
                            "textureSize",
                            "textureProj",
                            "textureLod",
                            "textureOffset",
                            "texelFetch",
                            "texelFetchOffset",
                            "textureProjOffset",
                            "textureLodOffset",
                            "textureProjLod",
                            "textureProjLodOffset",
                            "textureGrad",
                            "textureGradOffset",
                            "textureProjGrad",
                            "textureProjGradOffset"
                        ]);
                    },
                    6852: function(i) {
                        i.exports = [
                            "abs",
                            "acos",
                            "all",
                            "any",
                            "asin",
                            "atan",
                            "ceil",
                            "clamp",
                            "cos",
                            "cross",
                            "dFdx",
                            "dFdy",
                            "degrees",
                            "distance",
                            "dot",
                            "equal",
                            "exp",
                            "exp2",
                            "faceforward",
                            "floor",
                            "fract",
                            "gl_BackColor",
                            "gl_BackLightModelProduct",
                            "gl_BackLightProduct",
                            "gl_BackMaterial",
                            "gl_BackSecondaryColor",
                            "gl_ClipPlane",
                            "gl_ClipVertex",
                            "gl_Color",
                            "gl_DepthRange",
                            "gl_DepthRangeParameters",
                            "gl_EyePlaneQ",
                            "gl_EyePlaneR",
                            "gl_EyePlaneS",
                            "gl_EyePlaneT",
                            "gl_Fog",
                            "gl_FogCoord",
                            "gl_FogFragCoord",
                            "gl_FogParameters",
                            "gl_FragColor",
                            "gl_FragCoord",
                            "gl_FragData",
                            "gl_FragDepth",
                            "gl_FragDepthEXT",
                            "gl_FrontColor",
                            "gl_FrontFacing",
                            "gl_FrontLightModelProduct",
                            "gl_FrontLightProduct",
                            "gl_FrontMaterial",
                            "gl_FrontSecondaryColor",
                            "gl_LightModel",
                            "gl_LightModelParameters",
                            "gl_LightModelProducts",
                            "gl_LightProducts",
                            "gl_LightSource",
                            "gl_LightSourceParameters",
                            "gl_MaterialParameters",
                            "gl_MaxClipPlanes",
                            "gl_MaxCombinedTextureImageUnits",
                            "gl_MaxDrawBuffers",
                            "gl_MaxFragmentUniformComponents",
                            "gl_MaxLights",
                            "gl_MaxTextureCoords",
                            "gl_MaxTextureImageUnits",
                            "gl_MaxTextureUnits",
                            "gl_MaxVaryingFloats",
                            "gl_MaxVertexAttribs",
                            "gl_MaxVertexTextureImageUnits",
                            "gl_MaxVertexUniformComponents",
                            "gl_ModelViewMatrix",
                            "gl_ModelViewMatrixInverse",
                            "gl_ModelViewMatrixInverseTranspose",
                            "gl_ModelViewMatrixTranspose",
                            "gl_ModelViewProjectionMatrix",
                            "gl_ModelViewProjectionMatrixInverse",
                            "gl_ModelViewProjectionMatrixInverseTranspose",
                            "gl_ModelViewProjectionMatrixTranspose",
                            "gl_MultiTexCoord0",
                            "gl_MultiTexCoord1",
                            "gl_MultiTexCoord2",
                            "gl_MultiTexCoord3",
                            "gl_MultiTexCoord4",
                            "gl_MultiTexCoord5",
                            "gl_MultiTexCoord6",
                            "gl_MultiTexCoord7",
                            "gl_Normal",
                            "gl_NormalMatrix",
                            "gl_NormalScale",
                            "gl_ObjectPlaneQ",
                            "gl_ObjectPlaneR",
                            "gl_ObjectPlaneS",
                            "gl_ObjectPlaneT",
                            "gl_Point",
                            "gl_PointCoord",
                            "gl_PointParameters",
                            "gl_PointSize",
                            "gl_Position",
                            "gl_ProjectionMatrix",
                            "gl_ProjectionMatrixInverse",
                            "gl_ProjectionMatrixInverseTranspose",
                            "gl_ProjectionMatrixTranspose",
                            "gl_SecondaryColor",
                            "gl_TexCoord",
                            "gl_TextureEnvColor",
                            "gl_TextureMatrix",
                            "gl_TextureMatrixInverse",
                            "gl_TextureMatrixInverseTranspose",
                            "gl_TextureMatrixTranspose",
                            "gl_Vertex",
                            "greaterThan",
                            "greaterThanEqual",
                            "inversesqrt",
                            "length",
                            "lessThan",
                            "lessThanEqual",
                            "log",
                            "log2",
                            "matrixCompMult",
                            "max",
                            "min",
                            "mix",
                            "mod",
                            "normalize",
                            "not",
                            "notEqual",
                            "pow",
                            "radians",
                            "reflect",
                            "refract",
                            "sign",
                            "sin",
                            "smoothstep",
                            "sqrt",
                            "step",
                            "tan",
                            "texture2D",
                            "texture2DLod",
                            "texture2DProj",
                            "texture2DProjLod",
                            "textureCube",
                            "textureCubeLod",
                            "texture2DLodEXT",
                            "texture2DProjLodEXT",
                            "textureCubeLodEXT",
                            "texture2DGradEXT",
                            "texture2DProjGradEXT",
                            "textureCubeGradEXT"
                        ];
                    },
                    7932: function(i, a, o) {
                        var s = o(620);
                        i.exports = s.slice().concat([
                            "layout",
                            "centroid",
                            "smooth",
                            "case",
                            "mat2x2",
                            "mat2x3",
                            "mat2x4",
                            "mat3x2",
                            "mat3x3",
                            "mat3x4",
                            "mat4x2",
                            "mat4x3",
                            "mat4x4",
                            "uvec2",
                            "uvec3",
                            "uvec4",
                            "samplerCubeShadow",
                            "sampler2DArray",
                            "sampler2DArrayShadow",
                            "isampler2D",
                            "isampler3D",
                            "isamplerCube",
                            "isampler2DArray",
                            "usampler2D",
                            "usampler3D",
                            "usamplerCube",
                            "usampler2DArray",
                            "coherent",
                            "restrict",
                            "readonly",
                            "writeonly",
                            "resource",
                            "atomic_uint",
                            "noperspective",
                            "patch",
                            "sample",
                            "subroutine",
                            "common",
                            "partition",
                            "active",
                            "filter",
                            "image1D",
                            "image2D",
                            "image3D",
                            "imageCube",
                            "iimage1D",
                            "iimage2D",
                            "iimage3D",
                            "iimageCube",
                            "uimage1D",
                            "uimage2D",
                            "uimage3D",
                            "uimageCube",
                            "image1DArray",
                            "image2DArray",
                            "iimage1DArray",
                            "iimage2DArray",
                            "uimage1DArray",
                            "uimage2DArray",
                            "image1DShadow",
                            "image2DShadow",
                            "image1DArrayShadow",
                            "image2DArrayShadow",
                            "imageBuffer",
                            "iimageBuffer",
                            "uimageBuffer",
                            "sampler1DArray",
                            "sampler1DArrayShadow",
                            "isampler1D",
                            "isampler1DArray",
                            "usampler1D",
                            "usampler1DArray",
                            "isampler2DRect",
                            "usampler2DRect",
                            "samplerBuffer",
                            "isamplerBuffer",
                            "usamplerBuffer",
                            "sampler2DMS",
                            "isampler2DMS",
                            "usampler2DMS",
                            "sampler2DMSArray",
                            "isampler2DMSArray",
                            "usampler2DMSArray"
                        ]);
                    },
                    620: function(i) {
                        i.exports = [
                            "precision",
                            "highp",
                            "mediump",
                            "lowp",
                            "attribute",
                            "const",
                            "uniform",
                            "varying",
                            "break",
                            "continue",
                            "do",
                            "for",
                            "while",
                            "if",
                            "else",
                            "in",
                            "out",
                            "inout",
                            "float",
                            "int",
                            "uint",
                            "void",
                            "bool",
                            "true",
                            "false",
                            "discard",
                            "return",
                            "mat2",
                            "mat3",
                            "mat4",
                            "vec2",
                            "vec3",
                            "vec4",
                            "ivec2",
                            "ivec3",
                            "ivec4",
                            "bvec2",
                            "bvec3",
                            "bvec4",
                            "sampler1D",
                            "sampler2D",
                            "sampler3D",
                            "samplerCube",
                            "sampler1DShadow",
                            "sampler2DShadow",
                            "struct",
                            "asm",
                            "class",
                            "union",
                            "enum",
                            "typedef",
                            "template",
                            "this",
                            "packed",
                            "goto",
                            "switch",
                            "default",
                            "inline",
                            "noinline",
                            "volatile",
                            "public",
                            "static",
                            "extern",
                            "external",
                            "interface",
                            "long",
                            "short",
                            "double",
                            "half",
                            "fixed",
                            "unsigned",
                            "input",
                            "output",
                            "hvec2",
                            "hvec3",
                            "hvec4",
                            "dvec2",
                            "dvec3",
                            "dvec4",
                            "fvec2",
                            "fvec3",
                            "fvec4",
                            "sampler2DRect",
                            "sampler3DRect",
                            "sampler2DRectShadow",
                            "sizeof",
                            "cast",
                            "namespace",
                            "using"
                        ];
                    },
                    7827: function(i) {
                        i.exports = [
                            "<<=",
                            ">>=",
                            "++",
                            "--",
                            "<<",
                            ">>",
                            "<=",
                            ">=",
                            "==",
                            "!=",
                            "&&",
                            "||",
                            "+=",
                            "-=",
                            "*=",
                            "/=",
                            "%=",
                            "&=",
                            "^^",
                            "^=",
                            "|=",
                            "(",
                            ")",
                            "[",
                            "]",
                            ".",
                            "!",
                            "~",
                            "*",
                            "/",
                            "%",
                            "+",
                            "-",
                            "<",
                            ">",
                            "&",
                            "^",
                            "|",
                            "?",
                            ":",
                            "=",
                            ",",
                            ";",
                            "{",
                            "}"
                        ];
                    },
                    4905: function(i, a, o) {
                        var s = o(5874);
                        i.exports = l;
                        function l(u, c) {
                            var f = s(c), h = [];
                            return h = h.concat(f(u)), h = h.concat(f(null)), h;
                        }
                    },
                    3236: function(i) {
                        i.exports = function(a) {
                            typeof a == "string" && (a = [
                                a
                            ]);
                            for(var o = [].slice.call(arguments, 1), s = [], l = 0; l < a.length - 1; l++)s.push(a[l], o[l] || "");
                            return s.push(a[l]), s.join("");
                        };
                    },
                    7520: function(i, a, o) {
                        "use strict";
                        var s = o(9507);
                        function l() {
                            var u = !1;
                            try {
                                var c = Object.defineProperty({}, "passive", {
                                    get: function() {
                                        u = !0;
                                    }
                                });
                                window.addEventListener("test", null, c), window.removeEventListener("test", null, c);
                            } catch (f) {
                                u = !1;
                            }
                            return u;
                        }
                        i.exports = s && l();
                    },
                    3778: function(i, a) {
                        a.read = function(o, s, l, u, c) {
                            var f, h, d = c * 8 - u - 1, v = (1 << d) - 1, x = v >> 1, b = -7, p = l ? c - 1 : 0, E = l ? -1 : 1, k = o[s + p];
                            for(p += E, f = k & (1 << -b) - 1, k >>= -b, b += d; b > 0; f = f * 256 + o[s + p], p += E, b -= 8);
                            for(h = f & (1 << -b) - 1, f >>= -b, b += u; b > 0; h = h * 256 + o[s + p], p += E, b -= 8);
                            if (f === 0) f = 1 - x;
                            else {
                                if (f === v) return h ? NaN : (k ? -1 : 1) * (1 / 0);
                                h = h + Math.pow(2, u), f = f - x;
                            }
                            return (k ? -1 : 1) * h * Math.pow(2, f - u);
                        }, a.write = function(o, s, l, u, c, f) {
                            var h, d, v, x = f * 8 - c - 1, b = (1 << x) - 1, p = b >> 1, E = c === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, k = u ? 0 : f - 1, A = u ? 1 : -1, L = s < 0 || s === 0 && 1 / s < 0 ? 1 : 0;
                            for(s = Math.abs(s), isNaN(s) || s === 1 / 0 ? (d = isNaN(s) ? 1 : 0, h = b) : (h = Math.floor(Math.log(s) / Math.LN2), s * (v = Math.pow(2, -h)) < 1 && (h--, v *= 2), h + p >= 1 ? s += E / v : s += E * Math.pow(2, 1 - p), s * v >= 2 && (h++, v /= 2), h + p >= b ? (d = 0, h = b) : h + p >= 1 ? (d = (s * v - 1) * Math.pow(2, c), h = h + p) : (d = s * Math.pow(2, p - 1) * Math.pow(2, c), h = 0)); c >= 8; o[l + k] = d & 255, k += A, d /= 256, c -= 8);
                            for(h = h << c | d, x += c; x > 0; o[l + k] = h & 255, k += A, h /= 256, x -= 8);
                            o[l + k - A] |= L * 128;
                        };
                    },
                    8954: function(i, a, o) {
                        "use strict";
                        i.exports = p;
                        var s = o(3250), l = o(6803).Fw;
                        function u(E, k, A) {
                            this.vertices = E, this.adjacent = k, this.boundary = A, this.lastVisited = -1;
                        }
                        u.prototype.flip = function() {
                            var E = this.vertices[0];
                            this.vertices[0] = this.vertices[1], this.vertices[1] = E;
                            var k = this.adjacent[0];
                            this.adjacent[0] = this.adjacent[1], this.adjacent[1] = k;
                        };
                        function c(E, k, A) {
                            this.vertices = E, this.cell = k, this.index = A;
                        }
                        function f(E, k) {
                            return l(E.vertices, k.vertices);
                        }
                        function h(E) {
                            return function() {
                                var k = this.tuple;
                                return E.apply(this, k);
                            };
                        }
                        function d(E) {
                            var k = s[E + 1];
                            return k || (k = s), h(k);
                        }
                        var v = [];
                        function x(E, k, A) {
                            this.dimension = E, this.vertices = k, this.simplices = A, this.interior = A.filter(function(C) {
                                return !C.boundary;
                            }), this.tuple = new Array(E + 1);
                            for(var L = 0; L <= E; ++L)this.tuple[L] = this.vertices[L];
                            var _ = v[E];
                            _ || (_ = v[E] = d(E)), this.orient = _;
                        }
                        var b = x.prototype;
                        b.handleBoundaryDegeneracy = function(E, k) {
                            var A = this.dimension, L = this.vertices.length - 1, _ = this.tuple, C = this.vertices, M = [
                                E
                            ];
                            for(E.lastVisited = -L; M.length > 0;){
                                E = M.pop();
                                for(var g = E.adjacent, P = 0; P <= A; ++P){
                                    var T = g[P];
                                    if (!(!T.boundary || T.lastVisited <= -L)) {
                                        for(var F = T.vertices, q = 0; q <= A; ++q){
                                            var V = F[q];
                                            V < 0 ? _[q] = k : _[q] = C[V];
                                        }
                                        var H = this.orient();
                                        if (H > 0) return T;
                                        T.lastVisited = -L, H === 0 && M.push(T);
                                    }
                                }
                            }
                            return null;
                        }, b.walk = function(E, k) {
                            var A = this.vertices.length - 1, L = this.dimension, _ = this.vertices, C = this.tuple, M = k ? this.interior.length * Math.random() | 0 : this.interior.length - 1, g = this.interior[M];
                            e: for(; !g.boundary;){
                                for(var P = g.vertices, T = g.adjacent, F = 0; F <= L; ++F)C[F] = _[P[F]];
                                g.lastVisited = A;
                                for(var F = 0; F <= L; ++F){
                                    var q = T[F];
                                    if (!(q.lastVisited >= A)) {
                                        var V = C[F];
                                        C[F] = E;
                                        var H = this.orient();
                                        if (C[F] = V, H < 0) {
                                            g = q;
                                            continue e;
                                        } else q.boundary ? q.lastVisited = -A : q.lastVisited = A;
                                    }
                                }
                                return;
                            }
                            return g;
                        }, b.addPeaks = function(E, k) {
                            var A = this.vertices.length - 1, L = this.dimension, _ = this.vertices, C = this.tuple, M = this.interior, g = this.simplices, P = [
                                k
                            ];
                            k.lastVisited = A, k.vertices[k.vertices.indexOf(-1)] = A, k.boundary = !1, M.push(k);
                            for(var T = []; P.length > 0;){
                                var k = P.pop(), F = k.vertices, q = k.adjacent, V = F.indexOf(A);
                                if (!(V < 0)) {
                                    for(var H = 0; H <= L; ++H)if (H !== V) {
                                        var X = q[H];
                                        if (!(!X.boundary || X.lastVisited >= A)) {
                                            var G = X.vertices;
                                            if (X.lastVisited !== -A) {
                                                for(var N = 0, W = 0; W <= L; ++W)G[W] < 0 ? (N = W, C[W] = E) : C[W] = _[G[W]];
                                                var re = this.orient();
                                                if (re > 0) {
                                                    G[N] = A, X.boundary = !1, M.push(X), P.push(X), X.lastVisited = A;
                                                    continue;
                                                } else X.lastVisited = -A;
                                            }
                                            var ae = X.adjacent, _e = F.slice(), Me = q.slice(), ke = new u(_e, Me, !0);
                                            g.push(ke);
                                            var ge = ae.indexOf(k);
                                            if (!(ge < 0)) {
                                                ae[ge] = ke, Me[V] = X, _e[H] = -1, Me[H] = k, q[H] = ke, ke.flip();
                                                for(var W = 0; W <= L; ++W){
                                                    var ie = _e[W];
                                                    if (!(ie < 0 || ie === A)) {
                                                        for(var Te = new Array(L - 1), Ee = 0, Ae = 0; Ae <= L; ++Ae){
                                                            var ze = _e[Ae];
                                                            ze < 0 || Ae === W || (Te[Ee++] = ze);
                                                        }
                                                        T.push(new c(Te, ke, W));
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            T.sort(f);
                            for(var H = 0; H + 1 < T.length; H += 2){
                                var Ce = T[H], me = T[H + 1], Re = Ce.index, ce = me.index;
                                Re < 0 || ce < 0 || (Ce.cell.adjacent[Ce.index] = me.cell, me.cell.adjacent[me.index] = Ce.cell);
                            }
                        }, b.insert = function(E, k) {
                            var A = this.vertices;
                            A.push(E);
                            var L = this.walk(E, k);
                            if (L) {
                                for(var _ = this.dimension, C = this.tuple, M = 0; M <= _; ++M){
                                    var g = L.vertices[M];
                                    g < 0 ? C[M] = E : C[M] = A[g];
                                }
                                var P = this.orient(C);
                                P < 0 || P === 0 && (L = this.handleBoundaryDegeneracy(L, E), !L) || this.addPeaks(E, L);
                            }
                        }, b.boundary = function() {
                            for(var E = this.dimension, k = [], A = this.simplices, L = A.length, _ = 0; _ < L; ++_){
                                var C = A[_];
                                if (C.boundary) {
                                    for(var M = new Array(E), g = C.vertices, P = 0, T = 0, F = 0; F <= E; ++F)g[F] >= 0 ? M[P++] = g[F] : T = F & 1;
                                    if (T === (E & 1)) {
                                        var q = M[0];
                                        M[0] = M[1], M[1] = q;
                                    }
                                    k.push(M);
                                }
                            }
                            return k;
                        };
                        function p(E, k) {
                            var A = E.length;
                            if (A === 0) throw new Error("Must have at least d+1 points");
                            var L = E[0].length;
                            if (A <= L) throw new Error("Must input at least d+1 points");
                            var _ = E.slice(0, L + 1), C = s.apply(void 0, _);
                            if (C === 0) throw new Error("Input not in general position");
                            for(var M = new Array(L + 1), g = 0; g <= L; ++g)M[g] = g;
                            C < 0 && (M[0] = 1, M[1] = 0);
                            for(var P = new u(M, new Array(L + 1), !1), T = P.adjacent, F = new Array(L + 2), g = 0; g <= L; ++g){
                                for(var q = M.slice(), V = 0; V <= L; ++V)V === g && (q[V] = -1);
                                var H = q[0];
                                q[0] = q[1], q[1] = H;
                                var X = new u(q, new Array(L + 1), !0);
                                T[g] = X, F[g] = X;
                            }
                            F[L + 1] = P;
                            for(var g = 0; g <= L; ++g)for(var q = T[g].vertices, G = T[g].adjacent, V = 0; V <= L; ++V){
                                var N = q[V];
                                if (N < 0) {
                                    G[V] = P;
                                    continue;
                                }
                                for(var W = 0; W <= L; ++W)T[W].vertices.indexOf(N) < 0 && (G[V] = T[W]);
                            }
                            for(var re = new x(L, _, F), ae = !!k, g = L + 1; g < A; ++g)re.insert(E[g], ae);
                            return re.boundary();
                        }
                    },
                    3352: function(i, a, o) {
                        "use strict";
                        var s = o(2478), l = 0, u = 1, c = 2;
                        i.exports = P;
                        function f(T, F, q, V, H) {
                            this.mid = T, this.left = F, this.right = q, this.leftPoints = V, this.rightPoints = H, this.count = (F ? F.count : 0) + (q ? q.count : 0) + V.length;
                        }
                        var h = f.prototype;
                        function d(T, F) {
                            T.mid = F.mid, T.left = F.left, T.right = F.right, T.leftPoints = F.leftPoints, T.rightPoints = F.rightPoints, T.count = F.count;
                        }
                        function v(T, F) {
                            var q = C(F);
                            T.mid = q.mid, T.left = q.left, T.right = q.right, T.leftPoints = q.leftPoints, T.rightPoints = q.rightPoints, T.count = q.count;
                        }
                        function x(T, F) {
                            var q = T.intervals([]);
                            q.push(F), v(T, q);
                        }
                        function b(T, F) {
                            var q = T.intervals([]), V = q.indexOf(F);
                            return V < 0 ? l : (q.splice(V, 1), v(T, q), u);
                        }
                        h.intervals = function(T) {
                            return T.push.apply(T, this.leftPoints), this.left && this.left.intervals(T), this.right && this.right.intervals(T), T;
                        }, h.insert = function(T) {
                            var F = this.count - this.leftPoints.length;
                            if (this.count += 1, T[1] < this.mid) this.left ? 4 * (this.left.count + 1) > 3 * (F + 1) ? x(this, T) : this.left.insert(T) : this.left = C([
                                T
                            ]);
                            else if (T[0] > this.mid) this.right ? 4 * (this.right.count + 1) > 3 * (F + 1) ? x(this, T) : this.right.insert(T) : this.right = C([
                                T
                            ]);
                            else {
                                var q = s.ge(this.leftPoints, T, L), V = s.ge(this.rightPoints, T, _);
                                this.leftPoints.splice(q, 0, T), this.rightPoints.splice(V, 0, T);
                            }
                        }, h.remove = function(T) {
                            var F = this.count - this.leftPoints;
                            if (T[1] < this.mid) {
                                if (!this.left) return l;
                                var q = this.right ? this.right.count : 0;
                                if (4 * q > 3 * (F - 1)) return b(this, T);
                                var V = this.left.remove(T);
                                return V === c ? (this.left = null, this.count -= 1, u) : (V === u && (this.count -= 1), V);
                            } else if (T[0] > this.mid) {
                                if (!this.right) return l;
                                var H = this.left ? this.left.count : 0;
                                if (4 * H > 3 * (F - 1)) return b(this, T);
                                var V = this.right.remove(T);
                                return V === c ? (this.right = null, this.count -= 1, u) : (V === u && (this.count -= 1), V);
                            } else {
                                if (this.count === 1) return this.leftPoints[0] === T ? c : l;
                                if (this.leftPoints.length === 1 && this.leftPoints[0] === T) {
                                    if (this.left && this.right) {
                                        for(var X = this, G = this.left; G.right;)X = G, G = G.right;
                                        if (X === this) G.right = this.right;
                                        else {
                                            var N = this.left, V = this.right;
                                            X.count -= G.count, X.right = G.left, G.left = N, G.right = V;
                                        }
                                        d(this, G), this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
                                    } else this.left ? d(this, this.left) : d(this, this.right);
                                    return u;
                                }
                                for(var N = s.ge(this.leftPoints, T, L); N < this.leftPoints.length && this.leftPoints[N][0] === T[0]; ++N)if (this.leftPoints[N] === T) {
                                    this.count -= 1, this.leftPoints.splice(N, 1);
                                    for(var V = s.ge(this.rightPoints, T, _); V < this.rightPoints.length && this.rightPoints[V][1] === T[1]; ++V)if (this.rightPoints[V] === T) return this.rightPoints.splice(V, 1), u;
                                }
                                return l;
                            }
                        };
                        function p(T, F, q) {
                            for(var V = 0; V < T.length && T[V][0] <= F; ++V){
                                var H = q(T[V]);
                                if (H) return H;
                            }
                        }
                        function E(T, F, q) {
                            for(var V = T.length - 1; V >= 0 && T[V][1] >= F; --V){
                                var H = q(T[V]);
                                if (H) return H;
                            }
                        }
                        function k(T, F) {
                            for(var q = 0; q < T.length; ++q){
                                var V = F(T[q]);
                                if (V) return V;
                            }
                        }
                        h.queryPoint = function(T, F) {
                            if (T < this.mid) {
                                if (this.left) {
                                    var q = this.left.queryPoint(T, F);
                                    if (q) return q;
                                }
                                return p(this.leftPoints, T, F);
                            } else if (T > this.mid) {
                                if (this.right) {
                                    var q = this.right.queryPoint(T, F);
                                    if (q) return q;
                                }
                                return E(this.rightPoints, T, F);
                            } else return k(this.leftPoints, F);
                        }, h.queryInterval = function(T, F, q) {
                            if (T < this.mid && this.left) {
                                var V = this.left.queryInterval(T, F, q);
                                if (V) return V;
                            }
                            if (F > this.mid && this.right) {
                                var V = this.right.queryInterval(T, F, q);
                                if (V) return V;
                            }
                            return F < this.mid ? p(this.leftPoints, F, q) : T > this.mid ? E(this.rightPoints, T, q) : k(this.leftPoints, q);
                        };
                        function A(T, F) {
                            return T - F;
                        }
                        function L(T, F) {
                            var q = T[0] - F[0];
                            return q || T[1] - F[1];
                        }
                        function _(T, F) {
                            var q = T[1] - F[1];
                            return q || T[0] - F[0];
                        }
                        function C(T) {
                            if (T.length === 0) return null;
                            for(var F = [], q = 0; q < T.length; ++q)F.push(T[q][0], T[q][1]);
                            F.sort(A);
                            for(var V = F[F.length >> 1], H = [], X = [], G = [], q = 0; q < T.length; ++q){
                                var N = T[q];
                                N[1] < V ? H.push(N) : V < N[0] ? X.push(N) : G.push(N);
                            }
                            var W = G, re = G.slice();
                            return W.sort(L), re.sort(_), new f(V, C(H), C(X), W, re);
                        }
                        function M(T) {
                            this.root = T;
                        }
                        var g = M.prototype;
                        g.insert = function(T) {
                            this.root ? this.root.insert(T) : this.root = new f(T[0], null, null, [
                                T
                            ], [
                                T
                            ]);
                        }, g.remove = function(T) {
                            if (this.root) {
                                var F = this.root.remove(T);
                                return F === c && (this.root = null), F !== l;
                            }
                            return !1;
                        }, g.queryPoint = function(T, F) {
                            if (this.root) return this.root.queryPoint(T, F);
                        }, g.queryInterval = function(T, F, q) {
                            if (T <= F && this.root) return this.root.queryInterval(T, F, q);
                        }, Object.defineProperty(g, "count", {
                            get: function() {
                                return this.root ? this.root.count : 0;
                            }
                        }), Object.defineProperty(g, "intervals", {
                            get: function() {
                                return this.root ? this.root.intervals([]) : [];
                            }
                        });
                        function P(T) {
                            return !T || T.length === 0 ? new M(null) : new M(C(T));
                        }
                    },
                    9507: function(i) {
                        i.exports = !0;
                    },
                    7163: function(i) {
                        i.exports = function(s) {
                            return s != null && (a(s) || o(s) || !!s._isBuffer);
                        };
                        function a(s) {
                            return !!s.constructor && typeof s.constructor.isBuffer == "function" && s.constructor.isBuffer(s);
                        }
                        function o(s) {
                            return typeof s.readFloatLE == "function" && typeof s.slice == "function" && a(s.slice(0, 0));
                        }
                    },
                    5219: function(i) {
                        "use strict";
                        i.exports = function(a) {
                            for(var o = a.length, s, l = 0; l < o; l++)if (s = a.charCodeAt(l), (s < 9 || s > 13) && s !== 32 && s !== 133 && s !== 160 && s !== 5760 && s !== 6158 && (s < 8192 || s > 8205) && s !== 8232 && s !== 8233 && s !== 8239 && s !== 8287 && s !== 8288 && s !== 12288 && s !== 65279) return !1;
                            return !0;
                        };
                    },
                    395: function(i) {
                        function a(o, s, l) {
                            return o * (1 - l) + s * l;
                        }
                        i.exports = a;
                    },
                    2652: function(i, a, o) {
                        var s = o(4335), l = o(6864), u = o(1903), c = o(9921), f = o(7608), h = o(5665), d = {
                            length: o(1387),
                            normalize: o(3536),
                            dot: o(244),
                            cross: o(5911)
                        }, v = l(), x = l(), b = [
                            0,
                            0,
                            0,
                            0
                        ], p = [
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0
                            ],
                            [
                                0,
                                0,
                                0
                            ]
                        ], E = [
                            0,
                            0,
                            0
                        ];
                        i.exports = function(C, M, g, P, T, F) {
                            if (M || (M = [
                                0,
                                0,
                                0
                            ]), g || (g = [
                                0,
                                0,
                                0
                            ]), P || (P = [
                                0,
                                0,
                                0
                            ]), T || (T = [
                                0,
                                0,
                                0,
                                1
                            ]), F || (F = [
                                0,
                                0,
                                0,
                                1
                            ]), !s(v, C) || (u(x, v), x[3] = 0, x[7] = 0, x[11] = 0, x[15] = 1, Math.abs(c(x) < 1e-8))) return !1;
                            var q = v[3], V = v[7], H = v[11], X = v[12], G = v[13], N = v[14], W = v[15];
                            if (q !== 0 || V !== 0 || H !== 0) {
                                b[0] = q, b[1] = V, b[2] = H, b[3] = W;
                                var re = f(x, x);
                                if (!re) return !1;
                                h(x, x), k(T, b, x);
                            } else T[0] = T[1] = T[2] = 0, T[3] = 1;
                            if (M[0] = X, M[1] = G, M[2] = N, A(p, v), g[0] = d.length(p[0]), d.normalize(p[0], p[0]), P[0] = d.dot(p[0], p[1]), L(p[1], p[1], p[0], 1, -P[0]), g[1] = d.length(p[1]), d.normalize(p[1], p[1]), P[0] /= g[1], P[1] = d.dot(p[0], p[2]), L(p[2], p[2], p[0], 1, -P[1]), P[2] = d.dot(p[1], p[2]), L(p[2], p[2], p[1], 1, -P[2]), g[2] = d.length(p[2]), d.normalize(p[2], p[2]), P[1] /= g[2], P[2] /= g[2], d.cross(E, p[1], p[2]), d.dot(p[0], E) < 0) for(var ae = 0; ae < 3; ae++)g[ae] *= -1, p[ae][0] *= -1, p[ae][1] *= -1, p[ae][2] *= -1;
                            return F[0] = .5 * Math.sqrt(Math.max(1 + p[0][0] - p[1][1] - p[2][2], 0)), F[1] = .5 * Math.sqrt(Math.max(1 - p[0][0] + p[1][1] - p[2][2], 0)), F[2] = .5 * Math.sqrt(Math.max(1 - p[0][0] - p[1][1] + p[2][2], 0)), F[3] = .5 * Math.sqrt(Math.max(1 + p[0][0] + p[1][1] + p[2][2], 0)), p[2][1] > p[1][2] && (F[0] = -F[0]), p[0][2] > p[2][0] && (F[1] = -F[1]), p[1][0] > p[0][1] && (F[2] = -F[2]), !0;
                        };
                        function k(_, C, M) {
                            var g = C[0], P = C[1], T = C[2], F = C[3];
                            return _[0] = M[0] * g + M[4] * P + M[8] * T + M[12] * F, _[1] = M[1] * g + M[5] * P + M[9] * T + M[13] * F, _[2] = M[2] * g + M[6] * P + M[10] * T + M[14] * F, _[3] = M[3] * g + M[7] * P + M[11] * T + M[15] * F, _;
                        }
                        function A(_, C) {
                            _[0][0] = C[0], _[0][1] = C[1], _[0][2] = C[2], _[1][0] = C[4], _[1][1] = C[5], _[1][2] = C[6], _[2][0] = C[8], _[2][1] = C[9], _[2][2] = C[10];
                        }
                        function L(_, C, M, g, P) {
                            _[0] = C[0] * g + M[0] * P, _[1] = C[1] * g + M[1] * P, _[2] = C[2] * g + M[2] * P;
                        }
                    },
                    4335: function(i) {
                        i.exports = function(o, s) {
                            var l = s[15];
                            if (l === 0) return !1;
                            for(var u = 1 / l, c = 0; c < 16; c++)o[c] = s[c] * u;
                            return !0;
                        };
                    },
                    7442: function(i, a, o) {
                        var s = o(6658), l = o(7182), u = o(2652), c = o(9921), f = o(8648), h = b(), d = b(), v = b();
                        i.exports = x;
                        function x(k, A, L, _) {
                            if (c(A) === 0 || c(L) === 0) return !1;
                            var C = u(A, h.translate, h.scale, h.skew, h.perspective, h.quaternion), M = u(L, d.translate, d.scale, d.skew, d.perspective, d.quaternion);
                            return !C || !M ? !1 : (s(v.translate, h.translate, d.translate, _), s(v.skew, h.skew, d.skew, _), s(v.scale, h.scale, d.scale, _), s(v.perspective, h.perspective, d.perspective, _), f(v.quaternion, h.quaternion, d.quaternion, _), l(k, v.translate, v.scale, v.skew, v.perspective, v.quaternion), !0);
                        }
                        function b() {
                            return {
                                translate: p(),
                                scale: p(1),
                                skew: p(),
                                perspective: E(),
                                quaternion: E()
                            };
                        }
                        function p(k) {
                            return [
                                k || 0,
                                k || 0,
                                k || 0
                            ];
                        }
                        function E() {
                            return [
                                0,
                                0,
                                0,
                                1
                            ];
                        }
                    },
                    7182: function(i, a, o) {
                        var s = {
                            identity: o(7894),
                            translate: o(7656),
                            multiply: o(6760),
                            create: o(6864),
                            scale: o(2504),
                            fromRotationTranslation: o(6743)
                        }, l = s.create(), u = s.create();
                        i.exports = function(f, h, d, v, x, b) {
                            return s.identity(f), s.fromRotationTranslation(f, b, h), f[3] = x[0], f[7] = x[1], f[11] = x[2], f[15] = x[3], s.identity(u), v[2] !== 0 && (u[9] = v[2], s.multiply(f, f, u)), v[1] !== 0 && (u[9] = 0, u[8] = v[1], s.multiply(f, f, u)), v[0] !== 0 && (u[8] = 0, u[4] = v[0], s.multiply(f, f, u)), s.scale(f, f, d), f;
                        };
                    },
                    1811: function(i, a, o) {
                        "use strict";
                        var s = o(2478), l = o(7442), u = o(7608), c = o(5567), f = o(2408), h = o(7089), d = o(6582), v = o(7656), x = o(2504), b = o(3536), p = [
                            0,
                            0,
                            0
                        ];
                        i.exports = L;
                        function E(_) {
                            this._components = _.slice(), this._time = [
                                0
                            ], this.prevMatrix = _.slice(), this.nextMatrix = _.slice(), this.computedMatrix = _.slice(), this.computedInverse = _.slice(), this.computedEye = [
                                0,
                                0,
                                0
                            ], this.computedUp = [
                                0,
                                0,
                                0
                            ], this.computedCenter = [
                                0,
                                0,
                                0
                            ], this.computedRadius = [
                                0
                            ], this._limits = [
                                -1 / 0,
                                1 / 0
                            ];
                        }
                        var k = E.prototype;
                        k.recalcMatrix = function(_) {
                            var C = this._time, M = s.le(C, _), g = this.computedMatrix;
                            if (!(M < 0)) {
                                var P = this._components;
                                if (M === C.length - 1) for(var T = 16 * M, F = 0; F < 16; ++F)g[F] = P[T++];
                                else {
                                    for(var q = C[M + 1] - C[M], T = 16 * M, V = this.prevMatrix, H = !0, F = 0; F < 16; ++F)V[F] = P[T++];
                                    for(var X = this.nextMatrix, F = 0; F < 16; ++F)X[F] = P[T++], H = H && V[F] === X[F];
                                    if (q < 1e-6 || H) for(var F = 0; F < 16; ++F)g[F] = V[F];
                                    else l(g, V, X, (_ - C[M]) / q);
                                }
                                var G = this.computedUp;
                                G[0] = g[1], G[1] = g[5], G[2] = g[9], b(G, G);
                                var N = this.computedInverse;
                                u(N, g);
                                var W = this.computedEye, re = N[15];
                                W[0] = N[12] / re, W[1] = N[13] / re, W[2] = N[14] / re;
                                for(var ae = this.computedCenter, _e = Math.exp(this.computedRadius[0]), F = 0; F < 3; ++F)ae[F] = W[F] - g[2 + 4 * F] * _e;
                            }
                        }, k.idle = function(_) {
                            if (!(_ < this.lastT())) {
                                for(var C = this._components, M = C.length - 16, g = 0; g < 16; ++g)C.push(C[M++]);
                                this._time.push(_);
                            }
                        }, k.flush = function(_) {
                            var C = s.gt(this._time, _) - 2;
                            C < 0 || (this._time.splice(0, C), this._components.splice(0, 16 * C));
                        }, k.lastT = function() {
                            return this._time[this._time.length - 1];
                        }, k.lookAt = function(_, C, M, g) {
                            this.recalcMatrix(_), C = C || this.computedEye, M = M || p, g = g || this.computedUp, this.setMatrix(_, d(this.computedMatrix, C, M, g));
                            for(var P = 0, T = 0; T < 3; ++T)P += Math.pow(M[T] - C[T], 2);
                            P = Math.log(Math.sqrt(P)), this.computedRadius[0] = P;
                        }, k.rotate = function(_, C, M, g) {
                            this.recalcMatrix(_);
                            var P = this.computedInverse;
                            C && f(P, P, C), M && c(P, P, M), g && h(P, P, g), this.setMatrix(_, u(this.computedMatrix, P));
                        };
                        var A = [
                            0,
                            0,
                            0
                        ];
                        k.pan = function(_, C, M, g) {
                            A[0] = -(C || 0), A[1] = -(M || 0), A[2] = -(g || 0), this.recalcMatrix(_);
                            var P = this.computedInverse;
                            v(P, P, A), this.setMatrix(_, u(P, P));
                        }, k.translate = function(_, C, M, g) {
                            A[0] = C || 0, A[1] = M || 0, A[2] = g || 0, this.recalcMatrix(_);
                            var P = this.computedMatrix;
                            v(P, P, A), this.setMatrix(_, P);
                        }, k.setMatrix = function(_, C) {
                            if (!(_ < this.lastT())) {
                                this._time.push(_);
                                for(var M = 0; M < 16; ++M)this._components.push(C[M]);
                            }
                        }, k.setDistance = function(_, C) {
                            this.computedRadius[0] = C;
                        }, k.setDistanceLimits = function(_, C) {
                            var M = this._limits;
                            M[0] = _, M[1] = C;
                        }, k.getDistanceLimits = function(_) {
                            var C = this._limits;
                            return _ ? (_[0] = C[0], _[1] = C[1], _) : C;
                        };
                        function L(_) {
                            _ = _ || {};
                            var C = _.matrix || [
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1,
                                0,
                                0,
                                0,
                                0,
                                1
                            ];
                            return new E(C);
                        }
                    },
                    3090: function(i, a, o) {
                        "use strict";
                        i.exports = l;
                        var s = o(3250)[3];
                        function l(u) {
                            var c = u.length;
                            if (c < 3) {
                                for(var E = new Array(c), f = 0; f < c; ++f)E[f] = f;
                                return c === 2 && u[0][0] === u[1][0] && u[0][1] === u[1][1] ? [
                                    0
                                ] : E;
                            }
                            for(var h = new Array(c), f = 0; f < c; ++f)h[f] = f;
                            h.sort(function(_, C) {
                                var M = u[_][0] - u[C][0];
                                return M || u[_][1] - u[C][1];
                            });
                            for(var d = [
                                h[0],
                                h[1]
                            ], v = [
                                h[0],
                                h[1]
                            ], f = 2; f < c; ++f){
                                for(var x = h[f], b = u[x], p = d.length; p > 1 && s(u[d[p - 2]], u[d[p - 1]], b) <= 0;)p -= 1, d.pop();
                                for(d.push(x), p = v.length; p > 1 && s(u[v[p - 2]], u[v[p - 1]], b) >= 0;)p -= 1, v.pop();
                                v.push(x);
                            }
                            for(var E = new Array(v.length + d.length - 2), k = 0, f = 0, A = d.length; f < A; ++f)E[k++] = d[f];
                            for(var L = v.length - 2; L > 0; --L)E[k++] = v[L];
                            return E;
                        }
                    },
                    351: function(i, a, o) {
                        "use strict";
                        i.exports = l;
                        var s = o(4687);
                        function l(u, c) {
                            c || (c = u, u = window);
                            var f = 0, h = 0, d = 0, v = {
                                shift: !1,
                                alt: !1,
                                control: !1,
                                meta: !1
                            }, x = !1;
                            function b(T) {
                                var F = !1;
                                return "altKey" in T && (F = F || T.altKey !== v.alt, v.alt = !!T.altKey), "shiftKey" in T && (F = F || T.shiftKey !== v.shift, v.shift = !!T.shiftKey), "ctrlKey" in T && (F = F || T.ctrlKey !== v.control, v.control = !!T.ctrlKey), "metaKey" in T && (F = F || T.metaKey !== v.meta, v.meta = !!T.metaKey), F;
                            }
                            function p(T, F) {
                                var q = s.x(F), V = s.y(F);
                                "buttons" in F && (T = F.buttons | 0), (T !== f || q !== h || V !== d || b(F)) && (f = T | 0, h = q || 0, d = V || 0, c && c(f, h, d, v));
                            }
                            function E(T) {
                                p(0, T);
                            }
                            function k() {
                                (f || h || d || v.shift || v.alt || v.meta || v.control) && (h = d = 0, f = 0, v.shift = v.alt = v.control = v.meta = !1, c && c(0, 0, 0, v));
                            }
                            function A(T) {
                                b(T) && c && c(f, h, d, v);
                            }
                            function L(T) {
                                s.buttons(T) === 0 ? p(0, T) : p(f, T);
                            }
                            function _(T) {
                                p(f | s.buttons(T), T);
                            }
                            function C(T) {
                                p(f & ~s.buttons(T), T);
                            }
                            function M() {
                                x || (x = !0, u.addEventListener("mousemove", L), u.addEventListener("mousedown", _), u.addEventListener("mouseup", C), u.addEventListener("mouseleave", E), u.addEventListener("mouseenter", E), u.addEventListener("mouseout", E), u.addEventListener("mouseover", E), u.addEventListener("blur", k), u.addEventListener("keyup", A), u.addEventListener("keydown", A), u.addEventListener("keypress", A), u !== window && (window.addEventListener("blur", k), window.addEventListener("keyup", A), window.addEventListener("keydown", A), window.addEventListener("keypress", A)));
                            }
                            function g() {
                                x && (x = !1, u.removeEventListener("mousemove", L), u.removeEventListener("mousedown", _), u.removeEventListener("mouseup", C), u.removeEventListener("mouseleave", E), u.removeEventListener("mouseenter", E), u.removeEventListener("mouseout", E), u.removeEventListener("mouseover", E), u.removeEventListener("blur", k), u.removeEventListener("keyup", A), u.removeEventListener("keydown", A), u.removeEventListener("keypress", A), u !== window && (window.removeEventListener("blur", k), window.removeEventListener("keyup", A), window.removeEventListener("keydown", A), window.removeEventListener("keypress", A)));
                            }
                            M();
                            var P = {
                                element: u
                            };
                            return Object.defineProperties(P, {
                                enabled: {
                                    get: function() {
                                        return x;
                                    },
                                    set: function(T) {
                                        T ? M() : g();
                                    },
                                    enumerable: !0
                                },
                                buttons: {
                                    get: function() {
                                        return f;
                                    },
                                    enumerable: !0
                                },
                                x: {
                                    get: function() {
                                        return h;
                                    },
                                    enumerable: !0
                                },
                                y: {
                                    get: function() {
                                        return d;
                                    },
                                    enumerable: !0
                                },
                                mods: {
                                    get: function() {
                                        return v;
                                    },
                                    enumerable: !0
                                }
                            }), P;
                        }
                    },
                    24: function(i) {
                        var a = {
                            left: 0,
                            top: 0
                        };
                        i.exports = o;
                        function o(l, u, c) {
                            u = u || l.currentTarget || l.srcElement, Array.isArray(c) || (c = [
                                0,
                                0
                            ]);
                            var f = l.clientX || 0, h = l.clientY || 0, d = s(u);
                            return c[0] = f - d.left, c[1] = h - d.top, c;
                        }
                        function s(l) {
                            return l === window || l === document || l === document.body ? a : l.getBoundingClientRect();
                        }
                    },
                    4687: function(i, a) {
                        "use strict";
                        function o(c) {
                            if (typeof c == "object") {
                                if ("buttons" in c) return c.buttons;
                                if ("which" in c) {
                                    var f = c.which;
                                    if (f === 2) return 4;
                                    if (f === 3) return 2;
                                    if (f > 0) return 1 << f - 1;
                                } else if ("button" in c) {
                                    var f = c.button;
                                    if (f === 1) return 4;
                                    if (f === 2) return 2;
                                    if (f >= 0) return 1 << f;
                                }
                            }
                            return 0;
                        }
                        a.buttons = o;
                        function s(c) {
                            return c.target || c.srcElement || window;
                        }
                        a.element = s;
                        function l(c) {
                            if (typeof c == "object") {
                                if ("offsetX" in c) return c.offsetX;
                                var f = s(c), h = f.getBoundingClientRect();
                                return c.clientX - h.left;
                            }
                            return 0;
                        }
                        a.x = l;
                        function u(c) {
                            if (typeof c == "object") {
                                if ("offsetY" in c) return c.offsetY;
                                var f = s(c), h = f.getBoundingClientRect();
                                return c.clientY - h.top;
                            }
                            return 0;
                        }
                        a.y = u;
                    },
                    8512: function(i, a, o) {
                        "use strict";
                        var s = o(665);
                        i.exports = l;
                        function l(u, c, f) {
                            typeof u == "function" && (f = !!c, c = u, u = window);
                            var h = s("ex", u), d = function(v) {
                                f && v.preventDefault();
                                var x = v.deltaX || 0, b = v.deltaY || 0, p = v.deltaZ || 0, E = v.deltaMode, k = 1;
                                switch(E){
                                    case 1:
                                        k = h;
                                        break;
                                    case 2:
                                        k = window.innerHeight;
                                        break;
                                }
                                if (x *= k, b *= k, p *= k, x || b || p) return c(x, b, p, v);
                            };
                            return u.addEventListener("wheel", d), d;
                        }
                    },
                    2640: function(i, a, o) {
                        "use strict";
                        var s = o(1888);
                        i.exports = c;
                        var l = {
                            "false,0,1": function(h, d, v, x, b) {
                                return function(E, k, A, L) {
                                    var _ = E.shape[0] | 0, C = E.shape[1] | 0, M = E.data, g = E.offset | 0, P = E.stride[0] | 0, T = E.stride[1] | 0, F = g, q, V = -P | 0, H = 0, X = -T | 0, G = 0, N = -P - T | 0, W = 0, re = P | 0, ae = T - P * _ | 0, _e = 0, Me = 0, ke = 0, ge = 2 * _ | 0, ie = x(ge), Te = x(ge), Ee = 0, Ae = 0, ze = -1, Ce = -1, me = 0, Re = -_ | 0, ce = _ | 0, Ge = 0, nt = -_ - 1 | 0, ct = _ - 1 | 0, qt = 0, rt = 0, ot = 0;
                                    for(_e = 0; _e < _; ++_e)ie[Ee++] = v(M[F], k, A, L), F += re;
                                    if (F += ae, C > 0) {
                                        if (Me = 1, ie[Ee++] = v(M[F], k, A, L), F += re, _ > 0) for(_e = 1, q = M[F], Ae = ie[Ee] = v(q, k, A, L), me = ie[Ee + ze], Ge = ie[Ee + Re], qt = ie[Ee + nt], (Ae !== me || Ae !== Ge || Ae !== qt) && (H = M[F + V], G = M[F + X], W = M[F + N], h(_e, Me, q, H, G, W, Ae, me, Ge, qt, k, A, L), rt = Te[Ee] = ke++), Ee += 1, F += re, _e = 2; _e < _; ++_e)q = M[F], Ae = ie[Ee] = v(q, k, A, L), me = ie[Ee + ze], Ge = ie[Ee + Re], qt = ie[Ee + nt], (Ae !== me || Ae !== Ge || Ae !== qt) && (H = M[F + V], G = M[F + X], W = M[F + N], h(_e, Me, q, H, G, W, Ae, me, Ge, qt, k, A, L), rt = Te[Ee] = ke++, qt !== me && d(Te[Ee + ze], rt, W, H, qt, me, k, A, L)), Ee += 1, F += re;
                                        for(F += ae, Ee = 0, ot = ze, ze = Ce, Ce = ot, ot = Re, Re = ce, ce = ot, ot = nt, nt = ct, ct = ot, Me = 2; Me < C; ++Me){
                                            if (ie[Ee++] = v(M[F], k, A, L), F += re, _ > 0) for(_e = 1, q = M[F], Ae = ie[Ee] = v(q, k, A, L), me = ie[Ee + ze], Ge = ie[Ee + Re], qt = ie[Ee + nt], (Ae !== me || Ae !== Ge || Ae !== qt) && (H = M[F + V], G = M[F + X], W = M[F + N], h(_e, Me, q, H, G, W, Ae, me, Ge, qt, k, A, L), rt = Te[Ee] = ke++, qt !== Ge && d(Te[Ee + Re], rt, G, W, Ge, qt, k, A, L)), Ee += 1, F += re, _e = 2; _e < _; ++_e)q = M[F], Ae = ie[Ee] = v(q, k, A, L), me = ie[Ee + ze], Ge = ie[Ee + Re], qt = ie[Ee + nt], (Ae !== me || Ae !== Ge || Ae !== qt) && (H = M[F + V], G = M[F + X], W = M[F + N], h(_e, Me, q, H, G, W, Ae, me, Ge, qt, k, A, L), rt = Te[Ee] = ke++, qt !== Ge && d(Te[Ee + Re], rt, G, W, Ge, qt, k, A, L), qt !== me && d(Te[Ee + ze], rt, W, H, qt, me, k, A, L)), Ee += 1, F += re;
                                            Me & 1 && (Ee = 0), ot = ze, ze = Ce, Ce = ot, ot = Re, Re = ce, ce = ot, ot = nt, nt = ct, ct = ot, F += ae;
                                        }
                                    }
                                    b(Te), b(ie);
                                };
                            },
                            "false,1,0": function(h, d, v, x, b) {
                                return function(E, k, A, L) {
                                    var _ = E.shape[0] | 0, C = E.shape[1] | 0, M = E.data, g = E.offset | 0, P = E.stride[0] | 0, T = E.stride[1] | 0, F = g, q, V = -P | 0, H = 0, X = -T | 0, G = 0, N = -P - T | 0, W = 0, re = T | 0, ae = P - T * C | 0, _e = 0, Me = 0, ke = 0, ge = 2 * C | 0, ie = x(ge), Te = x(ge), Ee = 0, Ae = 0, ze = -1, Ce = -1, me = 0, Re = -C | 0, ce = C | 0, Ge = 0, nt = -C - 1 | 0, ct = C - 1 | 0, qt = 0, rt = 0, ot = 0;
                                    for(Me = 0; Me < C; ++Me)ie[Ee++] = v(M[F], k, A, L), F += re;
                                    if (F += ae, _ > 0) {
                                        if (_e = 1, ie[Ee++] = v(M[F], k, A, L), F += re, C > 0) for(Me = 1, q = M[F], Ae = ie[Ee] = v(q, k, A, L), Ge = ie[Ee + Re], me = ie[Ee + ze], qt = ie[Ee + nt], (Ae !== Ge || Ae !== me || Ae !== qt) && (H = M[F + V], G = M[F + X], W = M[F + N], h(_e, Me, q, H, G, W, Ae, Ge, me, qt, k, A, L), rt = Te[Ee] = ke++), Ee += 1, F += re, Me = 2; Me < C; ++Me)q = M[F], Ae = ie[Ee] = v(q, k, A, L), Ge = ie[Ee + Re], me = ie[Ee + ze], qt = ie[Ee + nt], (Ae !== Ge || Ae !== me || Ae !== qt) && (H = M[F + V], G = M[F + X], W = M[F + N], h(_e, Me, q, H, G, W, Ae, Ge, me, qt, k, A, L), rt = Te[Ee] = ke++, qt !== me && d(Te[Ee + ze], rt, G, W, me, qt, k, A, L)), Ee += 1, F += re;
                                        for(F += ae, Ee = 0, ot = Re, Re = ce, ce = ot, ot = ze, ze = Ce, Ce = ot, ot = nt, nt = ct, ct = ot, _e = 2; _e < _; ++_e){
                                            if (ie[Ee++] = v(M[F], k, A, L), F += re, C > 0) for(Me = 1, q = M[F], Ae = ie[Ee] = v(q, k, A, L), Ge = ie[Ee + Re], me = ie[Ee + ze], qt = ie[Ee + nt], (Ae !== Ge || Ae !== me || Ae !== qt) && (H = M[F + V], G = M[F + X], W = M[F + N], h(_e, Me, q, H, G, W, Ae, Ge, me, qt, k, A, L), rt = Te[Ee] = ke++, qt !== Ge && d(Te[Ee + Re], rt, W, H, qt, Ge, k, A, L)), Ee += 1, F += re, Me = 2; Me < C; ++Me)q = M[F], Ae = ie[Ee] = v(q, k, A, L), Ge = ie[Ee + Re], me = ie[Ee + ze], qt = ie[Ee + nt], (Ae !== Ge || Ae !== me || Ae !== qt) && (H = M[F + V], G = M[F + X], W = M[F + N], h(_e, Me, q, H, G, W, Ae, Ge, me, qt, k, A, L), rt = Te[Ee] = ke++, qt !== me && d(Te[Ee + ze], rt, G, W, me, qt, k, A, L), qt !== Ge && d(Te[Ee + Re], rt, W, H, qt, Ge, k, A, L)), Ee += 1, F += re;
                                            _e & 1 && (Ee = 0), ot = Re, Re = ce, ce = ot, ot = ze, ze = Ce, Ce = ot, ot = nt, nt = ct, ct = ot, F += ae;
                                        }
                                    }
                                    b(Te), b(ie);
                                };
                            }
                        };
                        function u(f, h, d, v, x, b) {
                            var p = [
                                b,
                                x
                            ].join(","), E = l[p];
                            return E(f, h, d, s.mallocUint32, s.freeUint32);
                        }
                        function c(f) {
                            function h(k) {
                                throw new Error("ndarray-extract-contour: " + k);
                            }
                            typeof f != "object" && h("Must specify arguments");
                            var d = f.order;
                            Array.isArray(d) || h("Must specify order");
                            var v = f.arrayArguments || 1;
                            v < 1 && h("Must have at least one array argument");
                            var x = f.scalarArguments || 0;
                            x < 0 && h("Scalar arg count must be > 0"), typeof f.vertex != "function" && h("Must specify vertex creation function"), typeof f.cell != "function" && h("Must specify cell creation function"), typeof f.phase != "function" && h("Must specify phase function");
                            for(var b = f.getters || [], p = new Array(v), E = 0; E < v; ++E)b.indexOf(E) >= 0 ? p[E] = !0 : p[E] = !1;
                            return u(f.vertex, f.cell, f.phase, x, d, p);
                        }
                    },
                    6199: function(i, a, o) {
                        "use strict";
                        var s = o(1338), l = {
                            zero: function(L, _, C, M) {
                                var g = L[0], P = C[0];
                                M |= 0;
                                var T = 0, F = P;
                                for(T = 0; T < g; ++T)_[M] = 0, M += F;
                            },
                            fdTemplate1: function(L, _, C, M, g, P, T) {
                                var F = L[0], q = C[0], V = P[0], H = -1 * q, X = q;
                                M |= 0, T |= 0;
                                var G = 0, N = q, W = V;
                                for(G = 0; G < F; ++G)g[T] = .5 * (_[M + H] - _[M + X]), M += N, T += W;
                            },
                            fdTemplate2: function(L, _, C, M, g, P, T, F, q, V) {
                                var H = L[0], X = L[1], G = C[0], N = C[1], W = P[0], re = P[1], ae = q[0], _e = q[1], Me = -1 * G, ke = G, ge = -1 * N, ie = N;
                                M |= 0, T |= 0, V |= 0;
                                var Te = 0, Ee = 0, Ae = N, ze = G - X * N, Ce = re, me = W - X * re, Re = _e, ce = ae - X * _e;
                                for(Ee = 0; Ee < H; ++Ee){
                                    for(Te = 0; Te < X; ++Te)g[T] = .5 * (_[M + Me] - _[M + ke]), F[V] = .5 * (_[M + ge] - _[M + ie]), M += Ae, T += Ce, V += Re;
                                    M += ze, T += me, V += ce;
                                }
                            }
                        }, u = {
                            cdiff: function(L) {
                                var _ = {};
                                return function(M, g, P) {
                                    var T = M.dtype, F = M.order, q = g.dtype, V = g.order, H = P.dtype, X = P.order, G = [
                                        T,
                                        F.join(),
                                        q,
                                        V.join(),
                                        H,
                                        X.join()
                                    ].join(), N = _[G];
                                    return N || (_[G] = N = L([
                                        T,
                                        F,
                                        q,
                                        V,
                                        H,
                                        X
                                    ])), N(M.shape.slice(0), M.data, M.stride, M.offset | 0, g.data, g.stride, g.offset | 0, P.data, P.stride, P.offset | 0);
                                };
                            },
                            zero: function(L) {
                                var _ = {};
                                return function(M) {
                                    var g = M.dtype, P = M.order, T = [
                                        g,
                                        P.join()
                                    ].join(), F = _[T];
                                    return F || (_[T] = F = L([
                                        g,
                                        P
                                    ])), F(M.shape.slice(0), M.data, M.stride, M.offset | 0);
                                };
                            },
                            fdTemplate1: function(L) {
                                var _ = {};
                                return function(M, g) {
                                    var P = M.dtype, T = M.order, F = g.dtype, q = g.order, V = [
                                        P,
                                        T.join(),
                                        F,
                                        q.join()
                                    ].join(), H = _[V];
                                    return H || (_[V] = H = L([
                                        P,
                                        T,
                                        F,
                                        q
                                    ])), H(M.shape.slice(0), M.data, M.stride, M.offset | 0, g.data, g.stride, g.offset | 0);
                                };
                            },
                            fdTemplate2: function(L) {
                                var _ = {};
                                return function(M, g, P) {
                                    var T = M.dtype, F = M.order, q = g.dtype, V = g.order, H = P.dtype, X = P.order, G = [
                                        T,
                                        F.join(),
                                        q,
                                        V.join(),
                                        H,
                                        X.join()
                                    ].join(), N = _[G];
                                    return N || (_[G] = N = L([
                                        T,
                                        F,
                                        q,
                                        V,
                                        H,
                                        X
                                    ])), N(M.shape.slice(0), M.data, M.stride, M.offset | 0, g.data, g.stride, g.offset | 0, P.data, P.stride, P.offset | 0);
                                };
                            }
                        };
                        function c(L) {
                            var _ = u[L.funcName];
                            return _(f.bind(void 0, L));
                        }
                        function f(L) {
                            return l[L.funcName];
                        }
                        function h(L) {
                            return c({
                                funcName: L.funcName
                            });
                        }
                        var d = {}, v = {}, x = {
                            body: "",
                            args: [],
                            thisVars: [],
                            localVars: []
                        }, b = h({
                            funcName: "cdiff"
                        }), p = h({
                            funcName: "zero"
                        });
                        function E(L) {
                            return L in d ? d[L] : d[L] = h({
                                funcName: "fdTemplate" + L
                            });
                        }
                        function k(L, _, C, M) {
                            return function(g, P) {
                                var T = P.shape.slice();
                                return T[0] > 2 && T[1] > 2 && M(P.pick(-1, -1).lo(1, 1).hi(T[0] - 2, T[1] - 2), g.pick(-1, -1, 0).lo(1, 1).hi(T[0] - 2, T[1] - 2), g.pick(-1, -1, 1).lo(1, 1).hi(T[0] - 2, T[1] - 2)), T[1] > 2 && (C(P.pick(0, -1).lo(1).hi(T[1] - 2), g.pick(0, -1, 1).lo(1).hi(T[1] - 2)), _(g.pick(0, -1, 0).lo(1).hi(T[1] - 2))), T[1] > 2 && (C(P.pick(T[0] - 1, -1).lo(1).hi(T[1] - 2), g.pick(T[0] - 1, -1, 1).lo(1).hi(T[1] - 2)), _(g.pick(T[0] - 1, -1, 0).lo(1).hi(T[1] - 2))), T[0] > 2 && (C(P.pick(-1, 0).lo(1).hi(T[0] - 2), g.pick(-1, 0, 0).lo(1).hi(T[0] - 2)), _(g.pick(-1, 0, 1).lo(1).hi(T[0] - 2))), T[0] > 2 && (C(P.pick(-1, T[1] - 1).lo(1).hi(T[0] - 2), g.pick(-1, T[1] - 1, 0).lo(1).hi(T[0] - 2)), _(g.pick(-1, T[1] - 1, 1).lo(1).hi(T[0] - 2))), g.set(0, 0, 0, 0), g.set(0, 0, 1, 0), g.set(T[0] - 1, 0, 0, 0), g.set(T[0] - 1, 0, 1, 0), g.set(0, T[1] - 1, 0, 0), g.set(0, T[1] - 1, 1, 0), g.set(T[0] - 1, T[1] - 1, 0, 0), g.set(T[0] - 1, T[1] - 1, 1, 0), g;
                            };
                        }
                        function A(L) {
                            var _ = L.join(), T = v[_];
                            if (T) return T;
                            for(var C = L.length, M = [
                                b,
                                p
                            ], g = 1; g <= C; ++g)M.push(E(g));
                            var P = k, T = P.apply(void 0, M);
                            return v[_] = T, T;
                        }
                        i.exports = function(_, C, M) {
                            if (Array.isArray(M) || (typeof M == "string" ? M = s(C.dimension, M) : M = s(C.dimension, "clamp")), C.size === 0) return _;
                            if (C.dimension === 0) return _.set(0), _;
                            var g = A(M);
                            return g(_, C);
                        };
                    },
                    4317: function(i) {
                        "use strict";
                        function a(c, f) {
                            var h = Math.floor(f), d = f - h, v = 0 <= h && h < c.shape[0], x = 0 <= h + 1 && h + 1 < c.shape[0], b = v ? +c.get(h) : 0, p = x ? +c.get(h + 1) : 0;
                            return (1 - d) * b + d * p;
                        }
                        function o(c, f, h) {
                            var d = Math.floor(f), v = f - d, x = 0 <= d && d < c.shape[0], b = 0 <= d + 1 && d + 1 < c.shape[0], p = Math.floor(h), E = h - p, k = 0 <= p && p < c.shape[1], A = 0 <= p + 1 && p + 1 < c.shape[1], L = x && k ? c.get(d, p) : 0, _ = x && A ? c.get(d, p + 1) : 0, C = b && k ? c.get(d + 1, p) : 0, M = b && A ? c.get(d + 1, p + 1) : 0;
                            return (1 - E) * ((1 - v) * L + v * C) + E * ((1 - v) * _ + v * M);
                        }
                        function s(c, f, h, d) {
                            var v = Math.floor(f), x = f - v, b = 0 <= v && v < c.shape[0], p = 0 <= v + 1 && v + 1 < c.shape[0], E = Math.floor(h), k = h - E, A = 0 <= E && E < c.shape[1], L = 0 <= E + 1 && E + 1 < c.shape[1], _ = Math.floor(d), C = d - _, M = 0 <= _ && _ < c.shape[2], g = 0 <= _ + 1 && _ + 1 < c.shape[2], P = b && A && M ? c.get(v, E, _) : 0, T = b && L && M ? c.get(v, E + 1, _) : 0, F = p && A && M ? c.get(v + 1, E, _) : 0, q = p && L && M ? c.get(v + 1, E + 1, _) : 0, V = b && A && g ? c.get(v, E, _ + 1) : 0, H = b && L && g ? c.get(v, E + 1, _ + 1) : 0, X = p && A && g ? c.get(v + 1, E, _ + 1) : 0, G = p && L && g ? c.get(v + 1, E + 1, _ + 1) : 0;
                            return (1 - C) * ((1 - k) * ((1 - x) * P + x * F) + k * ((1 - x) * T + x * q)) + C * ((1 - k) * ((1 - x) * V + x * X) + k * ((1 - x) * H + x * G));
                        }
                        function l(c) {
                            var f = c.shape.length | 0, h = new Array(f), d = new Array(f), v = new Array(f), x = new Array(f), b, p;
                            for(b = 0; b < f; ++b)p = +arguments[b + 1], h[b] = Math.floor(p), d[b] = p - h[b], v[b] = 0 <= h[b] && h[b] < c.shape[b], x[b] = 0 <= h[b] + 1 && h[b] + 1 < c.shape[b];
                            var E = 0, k, A, L;
                            e: for(b = 0; b < 1 << f; ++b){
                                for(A = 1, L = c.offset, k = 0; k < f; ++k)if (b & 1 << k) {
                                    if (!x[k]) continue e;
                                    A *= d[k], L += c.stride[k] * (h[k] + 1);
                                } else {
                                    if (!v[k]) continue e;
                                    A *= 1 - d[k], L += c.stride[k] * h[k];
                                }
                                E += A * c.data[L];
                            }
                            return E;
                        }
                        function u(c, f, h, d) {
                            switch(c.shape.length){
                                case 0:
                                    return 0;
                                case 1:
                                    return a(c, f);
                                case 2:
                                    return o(c, f, h);
                                case 3:
                                    return s(c, f, h, d);
                                default:
                                    return l.apply(void 0, arguments);
                            }
                        }
                        i.exports = u, i.exports.d1 = a, i.exports.d2 = o, i.exports.d3 = s;
                    },
                    5298: function(i, a) {
                        "use strict";
                        var o = {
                            "float64,2,1,0": function() {
                                return function(v, x, b, p, E) {
                                    var k = v[0], A = v[1], L = v[2], _ = b[0], C = b[1], M = b[2];
                                    p |= 0;
                                    var g = 0, P = 0, T = 0, F = M, q = C - L * M, V = _ - A * C;
                                    for(T = 0; T < k; ++T){
                                        for(P = 0; P < A; ++P){
                                            for(g = 0; g < L; ++g)x[p] /= E, p += F;
                                            p += q;
                                        }
                                        p += V;
                                    }
                                };
                            },
                            "uint8,2,0,1,float64,2,1,0": function() {
                                return function(v, x, b, p, E, k, A, L) {
                                    var _ = v[0], C = v[1], M = v[2], g = b[0], P = b[1], T = b[2], F = k[0], q = k[1], V = k[2];
                                    p |= 0, A |= 0;
                                    for(var H = p, X = A, G = v[0] | 0; G > 0;){
                                        G < 64 ? (_ = G, G = 0) : (_ = 64, G -= 64);
                                        for(var N = v[1] | 0; N > 0;){
                                            N < 64 ? (C = N, N = 0) : (C = 64, N -= 64), p = H + G * g + N * P, A = X + G * F + N * q;
                                            var W = 0, re = 0, ae = 0, _e = T, Me = g - M * T, ke = P - _ * g, ge = V, ie = F - M * V, Te = q - _ * F;
                                            for(ae = 0; ae < C; ++ae){
                                                for(re = 0; re < _; ++re){
                                                    for(W = 0; W < M; ++W)x[p] = E[A] * L, p += _e, A += ge;
                                                    p += Me, A += ie;
                                                }
                                                p += ke, A += Te;
                                            }
                                        }
                                    }
                                };
                            },
                            "float32,1,0,float32,1,0": function() {
                                return function(v, x, b, p, E, k, A) {
                                    var L = v[0], _ = v[1], C = b[0], M = b[1], g = k[0], P = k[1];
                                    p |= 0, A |= 0;
                                    var T = 0, F = 0, q = M, V = C - _ * M, H = P, X = g - _ * P;
                                    for(F = 0; F < L; ++F){
                                        for(T = 0; T < _; ++T)x[p] = E[A], p += q, A += H;
                                        p += V, A += X;
                                    }
                                };
                            },
                            "float32,1,0,float32,0,1": function() {
                                return function(v, x, b, p, E, k, A) {
                                    var L = v[0], _ = v[1], C = b[0], M = b[1], g = k[0], P = k[1];
                                    p |= 0, A |= 0;
                                    for(var T = p, F = A, q = v[1] | 0; q > 0;){
                                        q < 64 ? (_ = q, q = 0) : (_ = 64, q -= 64);
                                        for(var V = v[0] | 0; V > 0;){
                                            V < 64 ? (L = V, V = 0) : (L = 64, V -= 64), p = T + q * M + V * C, A = F + q * P + V * g;
                                            var H = 0, X = 0, G = M, N = C - _ * M, W = P, re = g - _ * P;
                                            for(X = 0; X < L; ++X){
                                                for(H = 0; H < _; ++H)x[p] = E[A], p += G, A += W;
                                                p += N, A += re;
                                            }
                                        }
                                    }
                                };
                            },
                            "uint8,2,0,1,uint8,1,2,0": function() {
                                return function(v, x, b, p, E, k, A) {
                                    var L = v[0], _ = v[1], C = v[2], M = b[0], g = b[1], P = b[2], T = k[0], F = k[1], q = k[2];
                                    p |= 0, A |= 0;
                                    for(var V = p, H = A, X = v[2] | 0; X > 0;){
                                        X < 64 ? (C = X, X = 0) : (C = 64, X -= 64);
                                        for(var G = v[0] | 0; G > 0;){
                                            G < 64 ? (L = G, G = 0) : (L = 64, G -= 64);
                                            for(var N = v[1] | 0; N > 0;){
                                                N < 64 ? (_ = N, N = 0) : (_ = 64, N -= 64), p = V + X * P + G * M + N * g, A = H + X * q + G * T + N * F;
                                                var W = 0, re = 0, ae = 0, _e = P, Me = M - C * P, ke = g - L * M, ge = q, ie = T - C * q, Te = F - L * T;
                                                for(ae = 0; ae < _; ++ae){
                                                    for(re = 0; re < L; ++re){
                                                        for(W = 0; W < C; ++W)x[p] = E[A], p += _e, A += ge;
                                                        p += Me, A += ie;
                                                    }
                                                    p += ke, A += Te;
                                                }
                                            }
                                        }
                                    }
                                };
                            },
                            "uint8,2,0,1,array,2,0,1": function() {
                                return function(v, x, b, p, E, k, A) {
                                    var L = v[0], _ = v[1], C = v[2], M = b[0], g = b[1], P = b[2], T = k[0], F = k[1], q = k[2];
                                    p |= 0, A |= 0;
                                    var V = 0, H = 0, X = 0, G = P, N = M - C * P, W = g - L * M, re = q, ae = T - C * q, _e = F - L * T;
                                    for(X = 0; X < _; ++X){
                                        for(H = 0; H < L; ++H){
                                            for(V = 0; V < C; ++V)x[p] = E[A], p += G, A += re;
                                            p += N, A += ae;
                                        }
                                        p += W, A += _e;
                                    }
                                };
                            }
                        };
                        function s(d, v) {
                            var x = v.join(","), b = o[x];
                            return b();
                        }
                        var l = s, u = {
                            mul: function(d) {
                                var v = {};
                                return function(b, p, E) {
                                    var k = b.dtype, A = b.order, L = p.dtype, _ = p.order, C = E.dtype, M = E.order, g = [
                                        k,
                                        A.join(),
                                        L,
                                        _.join(),
                                        C,
                                        M.join()
                                    ].join(), P = v[g];
                                    return P || (v[g] = P = d([
                                        k,
                                        A,
                                        L,
                                        _,
                                        C,
                                        M
                                    ])), P(b.shape.slice(0), b.data, b.stride, b.offset | 0, p.data, p.stride, p.offset | 0, E.data, E.stride, E.offset | 0);
                                };
                            },
                            muls: function(d) {
                                var v = {};
                                return function(b, p, E) {
                                    var k = b.dtype, A = b.order, L = p.dtype, _ = p.order, C = [
                                        k,
                                        A.join(),
                                        L,
                                        _.join()
                                    ].join(), M = v[C];
                                    return M || (v[C] = M = d([
                                        k,
                                        A,
                                        L,
                                        _
                                    ])), M(b.shape.slice(0), b.data, b.stride, b.offset | 0, p.data, p.stride, p.offset | 0, E);
                                };
                            },
                            mulseq: function(d) {
                                var v = {};
                                return function(b, p) {
                                    var E = b.dtype, k = b.order, A = [
                                        E,
                                        k.join()
                                    ].join(), L = v[A];
                                    return L || (v[A] = L = d([
                                        E,
                                        k
                                    ])), L(b.shape.slice(0), b.data, b.stride, b.offset | 0, p);
                                };
                            },
                            div: function(d) {
                                var v = {};
                                return function(b, p, E) {
                                    var k = b.dtype, A = b.order, L = p.dtype, _ = p.order, C = E.dtype, M = E.order, g = [
                                        k,
                                        A.join(),
                                        L,
                                        _.join(),
                                        C,
                                        M.join()
                                    ].join(), P = v[g];
                                    return P || (v[g] = P = d([
                                        k,
                                        A,
                                        L,
                                        _,
                                        C,
                                        M
                                    ])), P(b.shape.slice(0), b.data, b.stride, b.offset | 0, p.data, p.stride, p.offset | 0, E.data, E.stride, E.offset | 0);
                                };
                            },
                            divs: function(d) {
                                var v = {};
                                return function(b, p, E) {
                                    var k = b.dtype, A = b.order, L = p.dtype, _ = p.order, C = [
                                        k,
                                        A.join(),
                                        L,
                                        _.join()
                                    ].join(), M = v[C];
                                    return M || (v[C] = M = d([
                                        k,
                                        A,
                                        L,
                                        _
                                    ])), M(b.shape.slice(0), b.data, b.stride, b.offset | 0, p.data, p.stride, p.offset | 0, E);
                                };
                            },
                            divseq: function(d) {
                                var v = {};
                                return function(b, p) {
                                    var E = b.dtype, k = b.order, A = [
                                        E,
                                        k.join()
                                    ].join(), L = v[A];
                                    return L || (v[A] = L = d([
                                        E,
                                        k
                                    ])), L(b.shape.slice(0), b.data, b.stride, b.offset | 0, p);
                                };
                            },
                            assign: function(d) {
                                var v = {};
                                return function(b, p) {
                                    var E = b.dtype, k = b.order, A = p.dtype, L = p.order, _ = [
                                        E,
                                        k.join(),
                                        A,
                                        L.join()
                                    ].join(), C = v[_];
                                    return C || (v[_] = C = d([
                                        E,
                                        k,
                                        A,
                                        L
                                    ])), C(b.shape.slice(0), b.data, b.stride, b.offset | 0, p.data, p.stride, p.offset | 0);
                                };
                            }
                        };
                        function c(d) {
                            var v = u[d.funcName];
                            return v(l.bind(void 0, d));
                        }
                        function f(d) {
                            return c({
                                funcName: d.funcName
                            });
                        }
                        var h = {
                            mul: "*",
                            div: "/"
                        };
                        (function() {
                            for(var d in h)a[d] = f({
                                funcName: d
                            }), a[d + "s"] = f({
                                funcName: d + "s"
                            }), a[d + "seq"] = f({
                                funcName: d + "seq"
                            });
                        })(), a.assign = f({
                            funcName: "assign"
                        });
                    },
                    9994: function(i, a, o) {
                        "use strict";
                        var s = o(9618), l = o(8277);
                        i.exports = function(c, f) {
                            for(var h = [], d = c, v = 1; Array.isArray(d);)h.push(d.length), v *= d.length, d = d[0];
                            return h.length === 0 ? s() : (f || (f = s(new Float64Array(v), h)), l(f, c), f);
                        };
                    },
                    8277: function(i) {
                        "use strict";
                        function a() {
                            return function(f, h, d, v, x) {
                                var b = f[0], p = f[1], E = f[2], k = d[0], A = d[1], L = d[2], _ = [
                                    0,
                                    0,
                                    0
                                ];
                                v |= 0;
                                var C = 0, M = 0, g = 0, P = L, T = A - E * L, F = k - p * A;
                                for(g = 0; g < b; ++g){
                                    for(M = 0; M < p; ++M){
                                        for(C = 0; C < E; ++C){
                                            var q = x, V;
                                            for(V = 0; V < _.length - 1; ++V)q = q[_[V]];
                                            h[v] = q[_[_.length - 1]];
                                            v += P, ++_[2];
                                        }
                                        v += T, _[2] -= E, ++_[1];
                                    }
                                    v += F, _[1] -= p, ++_[0];
                                }
                            };
                        }
                        function o() {
                            return a();
                        }
                        var s = o;
                        function l(f) {
                            var h = {};
                            return function(v, x) {
                                var b = v.dtype, p = v.order, E = [
                                    b,
                                    p.join()
                                ].join(), k = h[E];
                                return k || (h[E] = k = f([
                                    b,
                                    p
                                ])), k(v.shape.slice(0), v.data, v.stride, v.offset | 0, x);
                            };
                        }
                        function u(f) {
                            return l(s.bind(void 0, f));
                        }
                        function c(f) {
                            return u({
                                funcName: f.funcName
                            });
                        }
                        i.exports = c({
                            funcName: "convert"
                        });
                    },
                    7640: function(i, a, o) {
                        "use strict";
                        var s = o(1888);
                        function l(x) {
                            switch(x){
                                case "uint32":
                                    return [
                                        s.mallocUint32,
                                        s.freeUint32
                                    ];
                                default:
                                    return null;
                            }
                        }
                        var u = {
                            "uint32,1,0": function(x, b) {
                                return function(E, k, A, L, _, C, M, g, P, T, F) {
                                    var q, V, H, X = E * _ + L, G, N = x(g), W, re, ae, _e;
                                    for(q = E + 1; q <= k; ++q){
                                        for(V = q, X += _, H = X, W = 0, re = X, G = 0; G < g; ++G)N[W++] = A[re], re += P;
                                        e: for(; V-- > E;){
                                            W = 0, re = H - _;
                                            t: for(G = 0; G < g; ++G){
                                                if (ae = A[re], _e = N[W], ae < _e) break e;
                                                if (ae > _e) break t;
                                                re += T, W += F;
                                            }
                                            for(W = H, re = H - _, G = 0; G < g; ++G)A[W] = A[re], W += P, re += P;
                                            H -= _;
                                        }
                                        for(W = H, re = 0, G = 0; G < g; ++G)A[W] = N[re++], W += P;
                                    }
                                    b(N);
                                };
                            }
                        };
                        function c(x, b) {
                            var p = l(b), E = [
                                b,
                                x
                            ].join(","), k = u[E];
                            return p ? k(p[0], p[1]) : k();
                        }
                        var f = {
                            "uint32,1,0": function(x, b, p) {
                                return function E(k, A, L, _, C, M, g, P, T, F, q) {
                                    var V = (A - k + 1) / 6 | 0, H = k + V, X = A - V, G = k + A >> 1, N = G - V, W = G + V, re = H, ae = N, _e = G, Me = W, ke = X, ge = k + 1, ie = A - 1, Te = !0, Ee, Ae, ze, Ce, me, Re, ce, Ge, nt, ct = 0, qt = 0, rt = 0, ot, Rt, kt, Ct, Yt, xr, er, Ke, xt, bt, Lt, St, Et, dt, Ht, $t, fr = P, _r = b(fr), Br = b(fr);
                                    Rt = C * re, kt = C * ae, $t = _;
                                    e: for(ot = 0; ot < P; ++ot){
                                        if (ce = Rt + $t, Ge = kt + $t, rt = L[ce] - L[Ge], rt > 0) {
                                            Ae = re, re = ae, ae = Ae;
                                            break e;
                                        }
                                        if (rt < 0) break e;
                                        $t += F;
                                    }
                                    Rt = C * Me, kt = C * ke, $t = _;
                                    e: for(ot = 0; ot < P; ++ot){
                                        if (ce = Rt + $t, Ge = kt + $t, rt = L[ce] - L[Ge], rt > 0) {
                                            Ae = Me, Me = ke, ke = Ae;
                                            break e;
                                        }
                                        if (rt < 0) break e;
                                        $t += F;
                                    }
                                    Rt = C * re, kt = C * _e, $t = _;
                                    e: for(ot = 0; ot < P; ++ot){
                                        if (ce = Rt + $t, Ge = kt + $t, rt = L[ce] - L[Ge], rt > 0) {
                                            Ae = re, re = _e, _e = Ae;
                                            break e;
                                        }
                                        if (rt < 0) break e;
                                        $t += F;
                                    }
                                    Rt = C * ae, kt = C * _e, $t = _;
                                    e: for(ot = 0; ot < P; ++ot){
                                        if (ce = Rt + $t, Ge = kt + $t, rt = L[ce] - L[Ge], rt > 0) {
                                            Ae = ae, ae = _e, _e = Ae;
                                            break e;
                                        }
                                        if (rt < 0) break e;
                                        $t += F;
                                    }
                                    Rt = C * re, kt = C * Me, $t = _;
                                    e: for(ot = 0; ot < P; ++ot){
                                        if (ce = Rt + $t, Ge = kt + $t, rt = L[ce] - L[Ge], rt > 0) {
                                            Ae = re, re = Me, Me = Ae;
                                            break e;
                                        }
                                        if (rt < 0) break e;
                                        $t += F;
                                    }
                                    Rt = C * _e, kt = C * Me, $t = _;
                                    e: for(ot = 0; ot < P; ++ot){
                                        if (ce = Rt + $t, Ge = kt + $t, rt = L[ce] - L[Ge], rt > 0) {
                                            Ae = _e, _e = Me, Me = Ae;
                                            break e;
                                        }
                                        if (rt < 0) break e;
                                        $t += F;
                                    }
                                    Rt = C * ae, kt = C * ke, $t = _;
                                    e: for(ot = 0; ot < P; ++ot){
                                        if (ce = Rt + $t, Ge = kt + $t, rt = L[ce] - L[Ge], rt > 0) {
                                            Ae = ae, ae = ke, ke = Ae;
                                            break e;
                                        }
                                        if (rt < 0) break e;
                                        $t += F;
                                    }
                                    Rt = C * ae, kt = C * _e, $t = _;
                                    e: for(ot = 0; ot < P; ++ot){
                                        if (ce = Rt + $t, Ge = kt + $t, rt = L[ce] - L[Ge], rt > 0) {
                                            Ae = ae, ae = _e, _e = Ae;
                                            break e;
                                        }
                                        if (rt < 0) break e;
                                        $t += F;
                                    }
                                    Rt = C * Me, kt = C * ke, $t = _;
                                    e: for(ot = 0; ot < P; ++ot){
                                        if (ce = Rt + $t, Ge = kt + $t, rt = L[ce] - L[Ge], rt > 0) {
                                            Ae = Me, Me = ke, ke = Ae;
                                            break e;
                                        }
                                        if (rt < 0) break e;
                                        $t += F;
                                    }
                                    for(Rt = C * re, kt = C * ae, Ct = C * _e, Yt = C * Me, xr = C * ke, er = C * H, Ke = C * G, xt = C * X, Ht = 0, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, nt = Ct + $t, bt = Yt + $t, Lt = xr + $t, St = er + $t, Et = Ke + $t, dt = xt + $t, _r[Ht] = L[Ge], Br[Ht] = L[bt], Te = Te && _r[Ht] === Br[Ht], ze = L[ce], Ce = L[nt], me = L[Lt], L[St] = ze, L[Et] = Ce, L[dt] = me, ++Ht, $t += T;
                                    for(Rt = C * N, kt = C * k, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, L[ce] = L[Ge], $t += T;
                                    for(Rt = C * W, kt = C * A, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, L[ce] = L[Ge], $t += T;
                                    if (Te) for(Re = ge; Re <= ie; ++Re){
                                        ce = _ + Re * C, Ht = 0;
                                        e: for(ot = 0; ot < P; ++ot){
                                            if (rt = L[ce] - _r[Ht], rt !== 0) break e;
                                            Ht += q, ce += F;
                                        }
                                        if (rt !== 0) {
                                            if (rt < 0) {
                                                if (Re !== ge) for(Rt = C * Re, kt = C * ge, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, Ee = L[ce], L[ce] = L[Ge], L[Ge] = Ee, $t += T;
                                                ++ge;
                                            } else for(;;){
                                                ce = _ + ie * C, Ht = 0;
                                                e: for(ot = 0; ot < P; ++ot){
                                                    if (rt = L[ce] - _r[Ht], rt !== 0) break e;
                                                    Ht += q, ce += F;
                                                }
                                                if (rt > 0) ie--;
                                                else if (rt < 0) {
                                                    for(Rt = C * Re, kt = C * ge, Ct = C * ie, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, nt = Ct + $t, Ee = L[ce], L[ce] = L[Ge], L[Ge] = L[nt], L[nt] = Ee, $t += T;
                                                    ++ge, --ie;
                                                    break;
                                                } else {
                                                    for(Rt = C * Re, kt = C * ie, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, Ee = L[ce], L[ce] = L[Ge], L[Ge] = Ee, $t += T;
                                                    --ie;
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    else for(Re = ge; Re <= ie; ++Re){
                                        ce = _ + Re * C, Ht = 0;
                                        e: for(ot = 0; ot < P; ++ot){
                                            if (ct = L[ce] - _r[Ht], ct !== 0) break e;
                                            Ht += q, ce += F;
                                        }
                                        if (ct < 0) {
                                            if (Re !== ge) for(Rt = C * Re, kt = C * ge, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, Ee = L[ce], L[ce] = L[Ge], L[Ge] = Ee, $t += T;
                                            ++ge;
                                        } else {
                                            ce = _ + Re * C, Ht = 0;
                                            e: for(ot = 0; ot < P; ++ot){
                                                if (qt = L[ce] - Br[Ht], qt !== 0) break e;
                                                Ht += q, ce += F;
                                            }
                                            if (qt > 0) for(;;){
                                                ce = _ + ie * C, Ht = 0;
                                                e: for(ot = 0; ot < P; ++ot){
                                                    if (rt = L[ce] - Br[Ht], rt !== 0) break e;
                                                    Ht += q, ce += F;
                                                }
                                                if (rt > 0) {
                                                    if (--ie < Re) break;
                                                    continue;
                                                } else {
                                                    ce = _ + ie * C, Ht = 0;
                                                    e: for(ot = 0; ot < P; ++ot){
                                                        if (rt = L[ce] - _r[Ht], rt !== 0) break e;
                                                        Ht += q, ce += F;
                                                    }
                                                    if (rt < 0) {
                                                        for(Rt = C * Re, kt = C * ge, Ct = C * ie, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, nt = Ct + $t, Ee = L[ce], L[ce] = L[Ge], L[Ge] = L[nt], L[nt] = Ee, $t += T;
                                                        ++ge, --ie;
                                                    } else {
                                                        for(Rt = C * Re, kt = C * ie, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, Ee = L[ce], L[ce] = L[Ge], L[Ge] = Ee, $t += T;
                                                        --ie;
                                                    }
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                    for(Rt = C * k, kt = C * (ge - 1), Ht = 0, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, L[ce] = L[Ge], L[Ge] = _r[Ht], ++Ht, $t += T;
                                    for(Rt = C * A, kt = C * (ie + 1), Ht = 0, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, L[ce] = L[Ge], L[Ge] = Br[Ht], ++Ht, $t += T;
                                    if (ge - 2 - k <= 32 ? x(k, ge - 2, L, _, C, M, g, P, T, F, q) : E(k, ge - 2, L, _, C, M, g, P, T, F, q), A - (ie + 2) <= 32 ? x(ie + 2, A, L, _, C, M, g, P, T, F, q) : E(ie + 2, A, L, _, C, M, g, P, T, F, q), Te) {
                                        p(_r), p(Br);
                                        return;
                                    }
                                    if (ge < H && ie > X) {
                                        e: for(;;){
                                            for(ce = _ + ge * C, Ht = 0, $t = _, ot = 0; ot < P; ++ot){
                                                if (L[ce] !== _r[Ht]) break e;
                                                ++Ht, ce += T;
                                            }
                                            ++ge;
                                        }
                                        e: for(;;){
                                            for(ce = _ + ie * C, Ht = 0, $t = _, ot = 0; ot < P; ++ot){
                                                if (L[ce] !== Br[Ht]) break e;
                                                ++Ht, ce += T;
                                            }
                                            --ie;
                                        }
                                        for(Re = ge; Re <= ie; ++Re){
                                            ce = _ + Re * C, Ht = 0;
                                            e: for(ot = 0; ot < P; ++ot){
                                                if (ct = L[ce] - _r[Ht], ct !== 0) break e;
                                                Ht += q, ce += F;
                                            }
                                            if (ct === 0) {
                                                if (Re !== ge) for(Rt = C * Re, kt = C * ge, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, Ee = L[ce], L[ce] = L[Ge], L[Ge] = Ee, $t += T;
                                                ++ge;
                                            } else {
                                                ce = _ + Re * C, Ht = 0;
                                                e: for(ot = 0; ot < P; ++ot){
                                                    if (qt = L[ce] - Br[Ht], qt !== 0) break e;
                                                    Ht += q, ce += F;
                                                }
                                                if (qt === 0) for(;;){
                                                    ce = _ + ie * C, Ht = 0;
                                                    e: for(ot = 0; ot < P; ++ot){
                                                        if (rt = L[ce] - Br[Ht], rt !== 0) break e;
                                                        Ht += q, ce += F;
                                                    }
                                                    if (rt === 0) {
                                                        if (--ie < Re) break;
                                                        continue;
                                                    } else {
                                                        ce = _ + ie * C, Ht = 0;
                                                        e: for(ot = 0; ot < P; ++ot){
                                                            if (rt = L[ce] - _r[Ht], rt !== 0) break e;
                                                            Ht += q, ce += F;
                                                        }
                                                        if (rt < 0) {
                                                            for(Rt = C * Re, kt = C * ge, Ct = C * ie, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, nt = Ct + $t, Ee = L[ce], L[ce] = L[Ge], L[Ge] = L[nt], L[nt] = Ee, $t += T;
                                                            ++ge, --ie;
                                                        } else {
                                                            for(Rt = C * Re, kt = C * ie, $t = _, ot = 0; ot < P; ++ot)ce = Rt + $t, Ge = kt + $t, Ee = L[ce], L[ce] = L[Ge], L[Ge] = Ee, $t += T;
                                                            --ie;
                                                        }
                                                        break;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    p(_r), p(Br), ie - ge <= 32 ? x(ge, ie, L, _, C, M, g, P, T, F, q) : E(ge, ie, L, _, C, M, g, P, T, F, q);
                                };
                            }
                        };
                        function h(x, b, p) {
                            var E = l(b), k = [
                                b,
                                x
                            ].join(","), A = f[k];
                            return x.length > 1 && E ? A(p, E[0], E[1]) : A(p);
                        }
                        var d = {
                            "uint32,1,0": function(x, b) {
                                return function(p) {
                                    var E = p.data, k = p.offset | 0, A = p.shape, L = p.stride, _ = L[0] | 0, C = A[0] | 0, M = L[1] | 0, g = A[1] | 0, P = M, T = M, F = 1;
                                    C <= 32 ? x(0, C - 1, E, k, _, M, C, g, P, T, F) : b(0, C - 1, E, k, _, M, C, g, P, T, F);
                                };
                            }
                        };
                        function v(x, b) {
                            var p = [
                                b,
                                x
                            ].join(","), E = d[p], k = c(x, b), A = h(x, b, k);
                            return E(k, A);
                        }
                        i.exports = v;
                    },
                    446: function(i, a, o) {
                        "use strict";
                        var s = o(7640), l = {};
                        function u(c) {
                            var f = c.order, h = c.dtype, d = [
                                f,
                                h
                            ], v = d.join(":"), x = l[v];
                            return x || (l[v] = x = s(f, h)), x(c), c;
                        }
                        i.exports = u;
                    },
                    9618: function(i, a, o) {
                        var s = o(7163), l = typeof Float64Array != "undefined";
                        function u(b, p) {
                            return b[0] - p[0];
                        }
                        function c() {
                            var b = this.stride, p = new Array(b.length), E;
                            for(E = 0; E < p.length; ++E)p[E] = [
                                Math.abs(b[E]),
                                E
                            ];
                            p.sort(u);
                            var k = new Array(p.length);
                            for(E = 0; E < k.length; ++E)k[E] = p[E][1];
                            return k;
                        }
                        var f = {
                            T: function(b) {
                                function p(k) {
                                    this.data = k;
                                }
                                var E = p.prototype;
                                return E.dtype = b, E.index = function() {
                                    return -1;
                                }, E.size = 0, E.dimension = -1, E.shape = E.stride = E.order = [], E.lo = E.hi = E.transpose = E.step = function() {
                                    return new p(this.data);
                                }, E.get = E.set = function() {}, E.pick = function() {
                                    return null;
                                }, function(A) {
                                    return new p(A);
                                };
                            },
                            0: function(b, p) {
                                function E(A, L) {
                                    this.data = A, this.offset = L;
                                }
                                var k = E.prototype;
                                return k.dtype = b, k.index = function() {
                                    return this.offset;
                                }, k.dimension = 0, k.size = 1, k.shape = k.stride = k.order = [], k.lo = k.hi = k.transpose = k.step = function() {
                                    return new E(this.data, this.offset);
                                }, k.pick = function() {
                                    return p(this.data);
                                }, k.valueOf = k.get = function() {
                                    return b === "generic" ? this.data.get(this.offset) : this.data[this.offset];
                                }, k.set = function(L) {
                                    return b === "generic" ? this.data.set(this.offset, L) : this.data[this.offset] = L;
                                }, function(L, _, C, M) {
                                    return new E(L, M);
                                };
                            },
                            1: function(b, p, E) {
                                function k(L, _, C, M) {
                                    this.data = L, this.shape = [
                                        _
                                    ], this.stride = [
                                        C
                                    ], this.offset = M | 0;
                                }
                                var A = k.prototype;
                                return A.dtype = b, A.dimension = 1, Object.defineProperty(A, "size", {
                                    get: function() {
                                        return this.shape[0];
                                    }
                                }), A.order = [
                                    0
                                ], A.set = function(_, C) {
                                    return b === "generic" ? this.data.set(this.offset + this.stride[0] * _, C) : this.data[this.offset + this.stride[0] * _] = C;
                                }, A.get = function(_) {
                                    return b === "generic" ? this.data.get(this.offset + this.stride[0] * _) : this.data[this.offset + this.stride[0] * _];
                                }, A.index = function(_) {
                                    return this.offset + this.stride[0] * _;
                                }, A.hi = function(_) {
                                    return new k(this.data, typeof _ != "number" || _ < 0 ? this.shape[0] : _ | 0, this.stride[0], this.offset);
                                }, A.lo = function(_) {
                                    var C = this.offset, M = 0, g = this.shape[0], P = this.stride[0];
                                    return typeof _ == "number" && _ >= 0 && (M = _ | 0, C += P * M, g -= M), new k(this.data, g, P, C);
                                }, A.step = function(_) {
                                    var C = this.shape[0], M = this.stride[0], g = this.offset, P = 0, T = Math.ceil;
                                    return typeof _ == "number" && (P = _ | 0, P < 0 ? (g += M * (C - 1), C = T(-C / P)) : C = T(C / P), M *= P), new k(this.data, C, M, g);
                                }, A.transpose = function(_) {
                                    _ = _ === void 0 ? 0 : _ | 0;
                                    var C = this.shape, M = this.stride;
                                    return new k(this.data, C[_], M[_], this.offset);
                                }, A.pick = function(_) {
                                    var C = [], M = [], g = this.offset;
                                    typeof _ == "number" && _ >= 0 ? g = g + this.stride[0] * _ | 0 : (C.push(this.shape[0]), M.push(this.stride[0]));
                                    var P = p[C.length + 1];
                                    return P(this.data, C, M, g);
                                }, function(_, C, M, g) {
                                    return new k(_, C[0], M[0], g);
                                };
                            },
                            2: function(b, p, E) {
                                function k(L, _, C, M, g, P) {
                                    this.data = L, this.shape = [
                                        _,
                                        C
                                    ], this.stride = [
                                        M,
                                        g
                                    ], this.offset = P | 0;
                                }
                                var A = k.prototype;
                                return A.dtype = b, A.dimension = 2, Object.defineProperty(A, "size", {
                                    get: function() {
                                        return this.shape[0] * this.shape[1];
                                    }
                                }), Object.defineProperty(A, "order", {
                                    get: function() {
                                        return Math.abs(this.stride[0]) > Math.abs(this.stride[1]) ? [
                                            1,
                                            0
                                        ] : [
                                            0,
                                            1
                                        ];
                                    }
                                }), A.set = function(_, C, M) {
                                    return b === "generic" ? this.data.set(this.offset + this.stride[0] * _ + this.stride[1] * C, M) : this.data[this.offset + this.stride[0] * _ + this.stride[1] * C] = M;
                                }, A.get = function(_, C) {
                                    return b === "generic" ? this.data.get(this.offset + this.stride[0] * _ + this.stride[1] * C) : this.data[this.offset + this.stride[0] * _ + this.stride[1] * C];
                                }, A.index = function(_, C) {
                                    return this.offset + this.stride[0] * _ + this.stride[1] * C;
                                }, A.hi = function(_, C) {
                                    return new k(this.data, typeof _ != "number" || _ < 0 ? this.shape[0] : _ | 0, typeof C != "number" || C < 0 ? this.shape[1] : C | 0, this.stride[0], this.stride[1], this.offset);
                                }, A.lo = function(_, C) {
                                    var M = this.offset, g = 0, P = this.shape[0], T = this.shape[1], F = this.stride[0], q = this.stride[1];
                                    return typeof _ == "number" && _ >= 0 && (g = _ | 0, M += F * g, P -= g), typeof C == "number" && C >= 0 && (g = C | 0, M += q * g, T -= g), new k(this.data, P, T, F, q, M);
                                }, A.step = function(_, C) {
                                    var M = this.shape[0], g = this.shape[1], P = this.stride[0], T = this.stride[1], F = this.offset, q = 0, V = Math.ceil;
                                    return typeof _ == "number" && (q = _ | 0, q < 0 ? (F += P * (M - 1), M = V(-M / q)) : M = V(M / q), P *= q), typeof C == "number" && (q = C | 0, q < 0 ? (F += T * (g - 1), g = V(-g / q)) : g = V(g / q), T *= q), new k(this.data, M, g, P, T, F);
                                }, A.transpose = function(_, C) {
                                    _ = _ === void 0 ? 0 : _ | 0, C = C === void 0 ? 1 : C | 0;
                                    var M = this.shape, g = this.stride;
                                    return new k(this.data, M[_], M[C], g[_], g[C], this.offset);
                                }, A.pick = function(_, C) {
                                    var M = [], g = [], P = this.offset;
                                    typeof _ == "number" && _ >= 0 ? P = P + this.stride[0] * _ | 0 : (M.push(this.shape[0]), g.push(this.stride[0])), typeof C == "number" && C >= 0 ? P = P + this.stride[1] * C | 0 : (M.push(this.shape[1]), g.push(this.stride[1]));
                                    var T = p[M.length + 1];
                                    return T(this.data, M, g, P);
                                }, function(_, C, M, g) {
                                    return new k(_, C[0], C[1], M[0], M[1], g);
                                };
                            },
                            3: function(b, p, E) {
                                function k(L, _, C, M, g, P, T, F) {
                                    this.data = L, this.shape = [
                                        _,
                                        C,
                                        M
                                    ], this.stride = [
                                        g,
                                        P,
                                        T
                                    ], this.offset = F | 0;
                                }
                                var A = k.prototype;
                                return A.dtype = b, A.dimension = 3, Object.defineProperty(A, "size", {
                                    get: function() {
                                        return this.shape[0] * this.shape[1] * this.shape[2];
                                    }
                                }), Object.defineProperty(A, "order", {
                                    get: function() {
                                        var _ = Math.abs(this.stride[0]), C = Math.abs(this.stride[1]), M = Math.abs(this.stride[2]);
                                        return _ > C ? C > M ? [
                                            2,
                                            1,
                                            0
                                        ] : _ > M ? [
                                            1,
                                            2,
                                            0
                                        ] : [
                                            1,
                                            0,
                                            2
                                        ] : _ > M ? [
                                            2,
                                            0,
                                            1
                                        ] : M > C ? [
                                            0,
                                            1,
                                            2
                                        ] : [
                                            0,
                                            2,
                                            1
                                        ];
                                    }
                                }), A.set = function(_, C, M, g) {
                                    return b === "generic" ? this.data.set(this.offset + this.stride[0] * _ + this.stride[1] * C + this.stride[2] * M, g) : this.data[this.offset + this.stride[0] * _ + this.stride[1] * C + this.stride[2] * M] = g;
                                }, A.get = function(_, C, M) {
                                    return b === "generic" ? this.data.get(this.offset + this.stride[0] * _ + this.stride[1] * C + this.stride[2] * M) : this.data[this.offset + this.stride[0] * _ + this.stride[1] * C + this.stride[2] * M];
                                }, A.index = function(_, C, M) {
                                    return this.offset + this.stride[0] * _ + this.stride[1] * C + this.stride[2] * M;
                                }, A.hi = function(_, C, M) {
                                    return new k(this.data, typeof _ != "number" || _ < 0 ? this.shape[0] : _ | 0, typeof C != "number" || C < 0 ? this.shape[1] : C | 0, typeof M != "number" || M < 0 ? this.shape[2] : M | 0, this.stride[0], this.stride[1], this.stride[2], this.offset);
                                }, A.lo = function(_, C, M) {
                                    var g = this.offset, P = 0, T = this.shape[0], F = this.shape[1], q = this.shape[2], V = this.stride[0], H = this.stride[1], X = this.stride[2];
                                    return typeof _ == "number" && _ >= 0 && (P = _ | 0, g += V * P, T -= P), typeof C == "number" && C >= 0 && (P = C | 0, g += H * P, F -= P), typeof M == "number" && M >= 0 && (P = M | 0, g += X * P, q -= P), new k(this.data, T, F, q, V, H, X, g);
                                }, A.step = function(_, C, M) {
                                    var g = this.shape[0], P = this.shape[1], T = this.shape[2], F = this.stride[0], q = this.stride[1], V = this.stride[2], H = this.offset, X = 0, G = Math.ceil;
                                    return typeof _ == "number" && (X = _ | 0, X < 0 ? (H += F * (g - 1), g = G(-g / X)) : g = G(g / X), F *= X), typeof C == "number" && (X = C | 0, X < 0 ? (H += q * (P - 1), P = G(-P / X)) : P = G(P / X), q *= X), typeof M == "number" && (X = M | 0, X < 0 ? (H += V * (T - 1), T = G(-T / X)) : T = G(T / X), V *= X), new k(this.data, g, P, T, F, q, V, H);
                                }, A.transpose = function(_, C, M) {
                                    _ = _ === void 0 ? 0 : _ | 0, C = C === void 0 ? 1 : C | 0, M = M === void 0 ? 2 : M | 0;
                                    var g = this.shape, P = this.stride;
                                    return new k(this.data, g[_], g[C], g[M], P[_], P[C], P[M], this.offset);
                                }, A.pick = function(_, C, M) {
                                    var g = [], P = [], T = this.offset;
                                    typeof _ == "number" && _ >= 0 ? T = T + this.stride[0] * _ | 0 : (g.push(this.shape[0]), P.push(this.stride[0])), typeof C == "number" && C >= 0 ? T = T + this.stride[1] * C | 0 : (g.push(this.shape[1]), P.push(this.stride[1])), typeof M == "number" && M >= 0 ? T = T + this.stride[2] * M | 0 : (g.push(this.shape[2]), P.push(this.stride[2]));
                                    var F = p[g.length + 1];
                                    return F(this.data, g, P, T);
                                }, function(_, C, M, g) {
                                    return new k(_, C[0], C[1], C[2], M[0], M[1], M[2], g);
                                };
                            },
                            4: function(b, p, E) {
                                function k(L, _, C, M, g, P, T, F, q, V) {
                                    this.data = L, this.shape = [
                                        _,
                                        C,
                                        M,
                                        g
                                    ], this.stride = [
                                        P,
                                        T,
                                        F,
                                        q
                                    ], this.offset = V | 0;
                                }
                                var A = k.prototype;
                                return A.dtype = b, A.dimension = 4, Object.defineProperty(A, "size", {
                                    get: function() {
                                        return this.shape[0] * this.shape[1] * this.shape[2] * this.shape[3];
                                    }
                                }), Object.defineProperty(A, "order", {
                                    get: E
                                }), A.set = function(_, C, M, g, P) {
                                    return b === "generic" ? this.data.set(this.offset + this.stride[0] * _ + this.stride[1] * C + this.stride[2] * M + this.stride[3] * g, P) : this.data[this.offset + this.stride[0] * _ + this.stride[1] * C + this.stride[2] * M + this.stride[3] * g] = P;
                                }, A.get = function(_, C, M, g) {
                                    return b === "generic" ? this.data.get(this.offset + this.stride[0] * _ + this.stride[1] * C + this.stride[2] * M + this.stride[3] * g) : this.data[this.offset + this.stride[0] * _ + this.stride[1] * C + this.stride[2] * M + this.stride[3] * g];
                                }, A.index = function(_, C, M, g) {
                                    return this.offset + this.stride[0] * _ + this.stride[1] * C + this.stride[2] * M + this.stride[3] * g;
                                }, A.hi = function(_, C, M, g) {
                                    return new k(this.data, typeof _ != "number" || _ < 0 ? this.shape[0] : _ | 0, typeof C != "number" || C < 0 ? this.shape[1] : C | 0, typeof M != "number" || M < 0 ? this.shape[2] : M | 0, typeof g != "number" || g < 0 ? this.shape[3] : g | 0, this.stride[0], this.stride[1], this.stride[2], this.stride[3], this.offset);
                                }, A.lo = function(_, C, M, g) {
                                    var P = this.offset, T = 0, F = this.shape[0], q = this.shape[1], V = this.shape[2], H = this.shape[3], X = this.stride[0], G = this.stride[1], N = this.stride[2], W = this.stride[3];
                                    return typeof _ == "number" && _ >= 0 && (T = _ | 0, P += X * T, F -= T), typeof C == "number" && C >= 0 && (T = C | 0, P += G * T, q -= T), typeof M == "number" && M >= 0 && (T = M | 0, P += N * T, V -= T), typeof g == "number" && g >= 0 && (T = g | 0, P += W * T, H -= T), new k(this.data, F, q, V, H, X, G, N, W, P);
                                }, A.step = function(_, C, M, g) {
                                    var P = this.shape[0], T = this.shape[1], F = this.shape[2], q = this.shape[3], V = this.stride[0], H = this.stride[1], X = this.stride[2], G = this.stride[3], N = this.offset, W = 0, re = Math.ceil;
                                    return typeof _ == "number" && (W = _ | 0, W < 0 ? (N += V * (P - 1), P = re(-P / W)) : P = re(P / W), V *= W), typeof C == "number" && (W = C | 0, W < 0 ? (N += H * (T - 1), T = re(-T / W)) : T = re(T / W), H *= W), typeof M == "number" && (W = M | 0, W < 0 ? (N += X * (F - 1), F = re(-F / W)) : F = re(F / W), X *= W), typeof g == "number" && (W = g | 0, W < 0 ? (N += G * (q - 1), q = re(-q / W)) : q = re(q / W), G *= W), new k(this.data, P, T, F, q, V, H, X, G, N);
                                }, A.transpose = function(_, C, M, g) {
                                    _ = _ === void 0 ? 0 : _ | 0, C = C === void 0 ? 1 : C | 0, M = M === void 0 ? 2 : M | 0, g = g === void 0 ? 3 : g | 0;
                                    var P = this.shape, T = this.stride;
                                    return new k(this.data, P[_], P[C], P[M], P[g], T[_], T[C], T[M], T[g], this.offset);
                                }, A.pick = function(_, C, M, g) {
                                    var P = [], T = [], F = this.offset;
                                    typeof _ == "number" && _ >= 0 ? F = F + this.stride[0] * _ | 0 : (P.push(this.shape[0]), T.push(this.stride[0])), typeof C == "number" && C >= 0 ? F = F + this.stride[1] * C | 0 : (P.push(this.shape[1]), T.push(this.stride[1])), typeof M == "number" && M >= 0 ? F = F + this.stride[2] * M | 0 : (P.push(this.shape[2]), T.push(this.stride[2])), typeof g == "number" && g >= 0 ? F = F + this.stride[3] * g | 0 : (P.push(this.shape[3]), T.push(this.stride[3]));
                                    var q = p[P.length + 1];
                                    return q(this.data, P, T, F);
                                }, function(_, C, M, g) {
                                    return new k(_, C[0], C[1], C[2], C[3], M[0], M[1], M[2], M[3], g);
                                };
                            },
                            5: function(p, E, k) {
                                function A(_, C, M, g, P, T, F, q, V, H, X, G) {
                                    this.data = _, this.shape = [
                                        C,
                                        M,
                                        g,
                                        P,
                                        T
                                    ], this.stride = [
                                        F,
                                        q,
                                        V,
                                        H,
                                        X
                                    ], this.offset = G | 0;
                                }
                                var L = A.prototype;
                                return L.dtype = p, L.dimension = 5, Object.defineProperty(L, "size", {
                                    get: function() {
                                        return this.shape[0] * this.shape[1] * this.shape[2] * this.shape[3] * this.shape[4];
                                    }
                                }), Object.defineProperty(L, "order", {
                                    get: k
                                }), L.set = function(C, M, g, P, T, F) {
                                    return p === "generic" ? this.data.set(this.offset + this.stride[0] * C + this.stride[1] * M + this.stride[2] * g + this.stride[3] * P + this.stride[4] * T, F) : this.data[this.offset + this.stride[0] * C + this.stride[1] * M + this.stride[2] * g + this.stride[3] * P + this.stride[4] * T] = F;
                                }, L.get = function(C, M, g, P, T) {
                                    return p === "generic" ? this.data.get(this.offset + this.stride[0] * C + this.stride[1] * M + this.stride[2] * g + this.stride[3] * P + this.stride[4] * T) : this.data[this.offset + this.stride[0] * C + this.stride[1] * M + this.stride[2] * g + this.stride[3] * P + this.stride[4] * T];
                                }, L.index = function(C, M, g, P, T) {
                                    return this.offset + this.stride[0] * C + this.stride[1] * M + this.stride[2] * g + this.stride[3] * P + this.stride[4] * T;
                                }, L.hi = function(C, M, g, P, T) {
                                    return new A(this.data, typeof C != "number" || C < 0 ? this.shape[0] : C | 0, typeof M != "number" || M < 0 ? this.shape[1] : M | 0, typeof g != "number" || g < 0 ? this.shape[2] : g | 0, typeof P != "number" || P < 0 ? this.shape[3] : P | 0, typeof T != "number" || T < 0 ? this.shape[4] : T | 0, this.stride[0], this.stride[1], this.stride[2], this.stride[3], this.stride[4], this.offset);
                                }, L.lo = function(C, M, g, P, T) {
                                    var F = this.offset, q = 0, V = this.shape[0], H = this.shape[1], X = this.shape[2], G = this.shape[3], N = this.shape[4], W = this.stride[0], re = this.stride[1], ae = this.stride[2], _e = this.stride[3], Me = this.stride[4];
                                    return typeof C == "number" && C >= 0 && (q = C | 0, F += W * q, V -= q), typeof M == "number" && M >= 0 && (q = M | 0, F += re * q, H -= q), typeof g == "number" && g >= 0 && (q = g | 0, F += ae * q, X -= q), typeof P == "number" && P >= 0 && (q = P | 0, F += _e * q, G -= q), typeof T == "number" && T >= 0 && (q = T | 0, F += Me * q, N -= q), new A(this.data, V, H, X, G, N, W, re, ae, _e, Me, F);
                                }, L.step = function(C, M, g, P, T) {
                                    var F = this.shape[0], q = this.shape[1], V = this.shape[2], H = this.shape[3], X = this.shape[4], G = this.stride[0], N = this.stride[1], W = this.stride[2], re = this.stride[3], ae = this.stride[4], _e = this.offset, Me = 0, ke = Math.ceil;
                                    return typeof C == "number" && (Me = C | 0, Me < 0 ? (_e += G * (F - 1), F = ke(-F / Me)) : F = ke(F / Me), G *= Me), typeof M == "number" && (Me = M | 0, Me < 0 ? (_e += N * (q - 1), q = ke(-q / Me)) : q = ke(q / Me), N *= Me), typeof g == "number" && (Me = g | 0, Me < 0 ? (_e += W * (V - 1), V = ke(-V / Me)) : V = ke(V / Me), W *= Me), typeof P == "number" && (Me = P | 0, Me < 0 ? (_e += re * (H - 1), H = ke(-H / Me)) : H = ke(H / Me), re *= Me), typeof T == "number" && (Me = T | 0, Me < 0 ? (_e += ae * (X - 1), X = ke(-X / Me)) : X = ke(X / Me), ae *= Me), new A(this.data, F, q, V, H, X, G, N, W, re, ae, _e);
                                }, L.transpose = function(C, M, g, P, T) {
                                    C = C === void 0 ? 0 : C | 0, M = M === void 0 ? 1 : M | 0, g = g === void 0 ? 2 : g | 0, P = P === void 0 ? 3 : P | 0, T = T === void 0 ? 4 : T | 0;
                                    var F = this.shape, q = this.stride;
                                    return new A(this.data, F[C], F[M], F[g], F[P], F[T], q[C], q[M], q[g], q[P], q[T], this.offset);
                                }, L.pick = function(C, M, g, P, T) {
                                    var F = [], q = [], V = this.offset;
                                    typeof C == "number" && C >= 0 ? V = V + this.stride[0] * C | 0 : (F.push(this.shape[0]), q.push(this.stride[0])), typeof M == "number" && M >= 0 ? V = V + this.stride[1] * M | 0 : (F.push(this.shape[1]), q.push(this.stride[1])), typeof g == "number" && g >= 0 ? V = V + this.stride[2] * g | 0 : (F.push(this.shape[2]), q.push(this.stride[2])), typeof P == "number" && P >= 0 ? V = V + this.stride[3] * P | 0 : (F.push(this.shape[3]), q.push(this.stride[3])), typeof T == "number" && T >= 0 ? V = V + this.stride[4] * T | 0 : (F.push(this.shape[4]), q.push(this.stride[4]));
                                    var H = E[F.length + 1];
                                    return H(this.data, F, q, V);
                                }, function(C, M, g, P) {
                                    return new A(C, M[0], M[1], M[2], M[3], M[4], g[0], g[1], g[2], g[3], g[4], P);
                                };
                            }
                        };
                        function h(b, p) {
                            var E = p === -1 ? "T" : String(p), k = f[E];
                            return p === -1 ? k(b) : p === 0 ? k(b, v[b][0]) : k(b, v[b], c);
                        }
                        function d(b) {
                            if (s(b)) return "buffer";
                            if (l) switch(Object.prototype.toString.call(b)){
                                case "[object Float64Array]":
                                    return "float64";
                                case "[object Float32Array]":
                                    return "float32";
                                case "[object Int8Array]":
                                    return "int8";
                                case "[object Int16Array]":
                                    return "int16";
                                case "[object Int32Array]":
                                    return "int32";
                                case "[object Uint8ClampedArray]":
                                    return "uint8_clamped";
                                case "[object Uint8Array]":
                                    return "uint8";
                                case "[object Uint16Array]":
                                    return "uint16";
                                case "[object Uint32Array]":
                                    return "uint32";
                                case "[object BigInt64Array]":
                                    return "bigint64";
                                case "[object BigUint64Array]":
                                    return "biguint64";
                            }
                            return Array.isArray(b) ? "array" : "generic";
                        }
                        var v = {
                            generic: [],
                            buffer: [],
                            array: [],
                            float32: [],
                            float64: [],
                            int8: [],
                            int16: [],
                            int32: [],
                            uint8_clamped: [],
                            uint8: [],
                            uint16: [],
                            uint32: [],
                            bigint64: [],
                            biguint64: []
                        };
                        function x(b, p, E, k) {
                            if (b === void 0) {
                                var g = v.array[0];
                                return g([]);
                            } else typeof b == "number" && (b = [
                                b
                            ]);
                            p === void 0 && (p = [
                                b.length
                            ]);
                            var A = p.length;
                            if (E === void 0) {
                                E = new Array(A);
                                for(var L = A - 1, _ = 1; L >= 0; --L)E[L] = _, _ *= p[L];
                            }
                            if (k === void 0) {
                                k = 0;
                                for(var L = 0; L < A; ++L)E[L] < 0 && (k -= (p[L] - 1) * E[L]);
                            }
                            for(var C = d(b), M = v[C]; M.length <= A + 1;)M.push(h(C, M.length - 1));
                            var g = M[A + 1];
                            return g(b, p, E, k);
                        }
                        i.exports = x;
                    },
                    1278: function(i, a, o) {
                        "use strict";
                        var s = o(2361), l = Math.pow(2, -1074), u = 4294967295;
                        i.exports = c;
                        function c(f, h) {
                            if (isNaN(f) || isNaN(h)) return NaN;
                            if (f === h) return f;
                            if (f === 0) return h < 0 ? -l : l;
                            var d = s.hi(f), v = s.lo(f);
                            return h > f == f > 0 ? v === u ? (d += 1, v = 0) : v += 1 : v === 0 ? (v = u, d -= 1) : v -= 1, s.pack(v, d);
                        }
                    },
                    8406: function(i, a) {
                        var o = 1e-6, s = 1e-6;
                        a.vertexNormals = function(l, u, c) {
                            for(var f = u.length, h = new Array(f), d = c === void 0 ? o : c, v = 0; v < f; ++v)h[v] = [
                                0,
                                0,
                                0
                            ];
                            for(var v = 0; v < l.length; ++v)for(var x = l[v], b = 0, p = x[x.length - 1], E = x[0], k = 0; k < x.length; ++k){
                                b = p, p = E, E = x[(k + 1) % x.length];
                                for(var A = u[b], L = u[p], _ = u[E], C = new Array(3), M = 0, g = new Array(3), P = 0, T = 0; T < 3; ++T)C[T] = A[T] - L[T], M += C[T] * C[T], g[T] = _[T] - L[T], P += g[T] * g[T];
                                if (M * P > d) for(var F = h[p], q = 1 / Math.sqrt(M * P), T = 0; T < 3; ++T){
                                    var V = (T + 1) % 3, H = (T + 2) % 3;
                                    F[T] += q * (g[V] * C[H] - g[H] * C[V]);
                                }
                            }
                            for(var v = 0; v < f; ++v){
                                for(var F = h[v], X = 0, T = 0; T < 3; ++T)X += F[T] * F[T];
                                if (X > d) for(var q = 1 / Math.sqrt(X), T = 0; T < 3; ++T)F[T] *= q;
                                else for(var T = 0; T < 3; ++T)F[T] = 0;
                            }
                            return h;
                        }, a.faceNormals = function(l, u, c) {
                            for(var f = l.length, h = new Array(f), d = c === void 0 ? s : c, v = 0; v < f; ++v){
                                for(var x = l[v], b = new Array(3), p = 0; p < 3; ++p)b[p] = u[x[p]];
                                for(var E = new Array(3), k = new Array(3), p = 0; p < 3; ++p)E[p] = b[1][p] - b[0][p], k[p] = b[2][p] - b[0][p];
                                for(var A = new Array(3), L = 0, p = 0; p < 3; ++p){
                                    var _ = (p + 1) % 3, C = (p + 2) % 3;
                                    A[p] = E[_] * k[C] - E[C] * k[_], L += A[p] * A[p];
                                }
                                L > d ? L = 1 / Math.sqrt(L) : L = 0;
                                for(var p = 0; p < 3; ++p)A[p] *= L;
                                h[v] = A;
                            }
                            return h;
                        };
                    },
                    4081: function(i) {
                        "use strict";
                        i.exports = a;
                        function a(o, s, l, u, c, f, h, d, v, x) {
                            var b = s + f + x;
                            if (p > 0) {
                                var p = Math.sqrt(b + 1);
                                o[0] = .5 * (h - v) / p, o[1] = .5 * (d - u) / p, o[2] = .5 * (l - f) / p, o[3] = .5 * p;
                            } else {
                                var E = Math.max(s, f, x), p = Math.sqrt(2 * E - b + 1);
                                s >= E ? (o[0] = .5 * p, o[1] = .5 * (c + l) / p, o[2] = .5 * (d + u) / p, o[3] = .5 * (h - v) / p) : f >= E ? (o[0] = .5 * (l + c) / p, o[1] = .5 * p, o[2] = .5 * (v + h) / p, o[3] = .5 * (d - u) / p) : (o[0] = .5 * (u + d) / p, o[1] = .5 * (h + v) / p, o[2] = .5 * p, o[3] = .5 * (l - c) / p);
                            }
                            return o;
                        }
                    },
                    9977: function(i, a, o) {
                        "use strict";
                        i.exports = p;
                        var s = o(9215), l = o(6582), u = o(7399), c = o(7608), f = o(4081);
                        function h(E, k, A) {
                            return Math.sqrt(Math.pow(E, 2) + Math.pow(k, 2) + Math.pow(A, 2));
                        }
                        function d(E, k, A, L) {
                            return Math.sqrt(Math.pow(E, 2) + Math.pow(k, 2) + Math.pow(A, 2) + Math.pow(L, 2));
                        }
                        function v(E, k) {
                            var A = k[0], L = k[1], _ = k[2], C = k[3], M = d(A, L, _, C);
                            M > 1e-6 ? (E[0] = A / M, E[1] = L / M, E[2] = _ / M, E[3] = C / M) : (E[0] = E[1] = E[2] = 0, E[3] = 1);
                        }
                        function x(E, k, A) {
                            this.radius = s([
                                A
                            ]), this.center = s(k), this.rotation = s(E), this.computedRadius = this.radius.curve(0), this.computedCenter = this.center.curve(0), this.computedRotation = this.rotation.curve(0), this.computedUp = [
                                .1,
                                0,
                                0
                            ], this.computedEye = [
                                .1,
                                0,
                                0
                            ], this.computedMatrix = [
                                .1,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0,
                                0
                            ], this.recalcMatrix(0);
                        }
                        var b = x.prototype;
                        b.lastT = function() {
                            return Math.max(this.radius.lastT(), this.center.lastT(), this.rotation.lastT());
                        }, b.recalcMatrix = function(E) {
                            this.radius.curve(E), this.center.curve(E), this.rotation.curve(E);
                            var k = this.computedRotation;
                            v(k, k);
                            var A = this.computedMatrix;
                            u(A, k);
                            var L = this.computedCenter, _ = this.computedEye, C = this.computedUp, M = Math.exp(this.computedRadius[0]);
                            _[0] = L[0] + M * A[2], _[1] = L[1] + M * A[6], _[2] = L[2] + M * A[10], C[0] = A[1], C[1] = A[5], C[2] = A[9];
                            for(var g = 0; g < 3; ++g){
                                for(var P = 0, T = 0; T < 3; ++T)P += A[g + 4 * T] * _[T];
                                A[12 + g] = -P;
                            }
                        }, b.getMatrix = function(E, k) {
                            this.recalcMatrix(E);
                            var A = this.computedMatrix;
                            if (k) {
                                for(var L = 0; L < 16; ++L)k[L] = A[L];
                                return k;
                            }
                            return A;
                        }, b.idle = function(E) {
                            this.center.idle(E), this.radius.idle(E), this.rotation.idle(E);
                        }, b.flush = function(E) {
                            this.center.flush(E), this.radius.flush(E), this.rotation.flush(E);
                        }, b.pan = function(E, k, A, L) {
                            k = k || 0, A = A || 0, L = L || 0, this.recalcMatrix(E);
                            var _ = this.computedMatrix, C = _[1], M = _[5], g = _[9], P = h(C, M, g);
                            C /= P, M /= P, g /= P;
                            var T = _[0], F = _[4], q = _[8], V = T * C + F * M + q * g;
                            T -= C * V, F -= M * V, q -= g * V;
                            var H = h(T, F, q);
                            T /= H, F /= H, q /= H;
                            var X = _[2], G = _[6], N = _[10], W = X * C + G * M + N * g, re = X * T + G * F + N * q;
                            X -= W * C + re * T, G -= W * M + re * F, N -= W * g + re * q;
                            var ae = h(X, G, N);
                            X /= ae, G /= ae, N /= ae;
                            var _e = T * k + C * A, Me = F * k + M * A, ke = q * k + g * A;
                            this.center.move(E, _e, Me, ke);
                            var ge = Math.exp(this.computedRadius[0]);
                            ge = Math.max(1e-4, ge + L), this.radius.set(E, Math.log(ge));
                        }, b.rotate = function(E, k, A, L) {
                            this.recalcMatrix(E), k = k || 0, A = A || 0;
                            var _ = this.computedMatrix, C = _[0], M = _[4], g = _[8], P = _[1], T = _[5], F = _[9], q = _[2], V = _[6], H = _[10], X = k * C + A * P, G = k * M + A * T, N = k * g + A * F, W = -(V * N - H * G), re = -(H * X - q * N), ae = -(q * G - V * X), _e = Math.sqrt(Math.max(0, 1 - Math.pow(W, 2) - Math.pow(re, 2) - Math.pow(ae, 2))), Me = d(W, re, ae, _e);
                            Me > 1e-6 ? (W /= Me, re /= Me, ae /= Me, _e /= Me) : (W = re = ae = 0, _e = 1);
                            var ke = this.computedRotation, ge = ke[0], ie = ke[1], Te = ke[2], Ee = ke[3], Ae = ge * _e + Ee * W + ie * ae - Te * re, ze = ie * _e + Ee * re + Te * W - ge * ae, Ce = Te * _e + Ee * ae + ge * re - ie * W, me = Ee * _e - ge * W - ie * re - Te * ae;
                            if (L) {
                                W = q, re = V, ae = H;
                                var Re = Math.sin(L) / h(W, re, ae);
                                W *= Re, re *= Re, ae *= Re, _e = Math.cos(k), Ae = Ae * _e + me * W + ze * ae - Ce * re, ze = ze * _e + me * re + Ce * W - Ae * ae, Ce = Ce * _e + me * ae + Ae * re - ze * W, me = me * _e - Ae * W - ze * re - Ce * ae;
                            }
                            var ce = d(Ae, ze, Ce, me);
                            ce > 1e-6 ? (Ae /= ce, ze /= ce, Ce /= ce, me /= ce) : (Ae = ze = Ce = 0, me = 1), this.rotation.set(E, Ae, ze, Ce, me);
                        }, b.lookAt = function(E, k, A, L) {
                            this.recalcMatrix(E), A = A || this.computedCenter, k = k || this.computedEye, L = L || this.computedUp;
                            var _ = this.computedMatrix;
                            l(_, k, A, L);
                            var C = this.computedRotation;
                            f(C, _[0], _[1], _[2], _[4], _[5], _[6], _[8], _[9], _[10]), v(C, C), this.rotation.set(E, C[0], C[1], C[2], C[3]);
                            for(var M = 0, g = 0; g < 3; ++g)M += Math.pow(A[g] - k[g], 2);
                            this.radius.set(E, .5 * Math.log(Math.max(M, 1e-6))), this.center.set(E, A[0], A[1], A[2]);
                        }, b.translate = function(E, k, A, L) {
                            this.center.move(E, k || 0, A || 0, L || 0);
                        }, b.setMatrix = function(E, k) {
                            var A = this.computedRotation;
                            f(A, k[0], k[1], k[2], k[4], k[5], k[6], k[8], k[9], k[10]), v(A, A), this.rotation.set(E, A[0], A[1], A[2], A[3]);
                            var L = this.computedMatrix;
                            c(L, k);
                            var _ = L[15];
                            if (Math.abs(_) > 1e-6) {
                                var C = L[12] / _, M = L[13] / _, g = L[14] / _;
                                this.recalcMatrix(E);
                                var P = Math.exp(this.computedRadius[0]);
                                this.center.set(E, C - L[2] * P, M - L[6] * P, g - L[10] * P), this.radius.idle(E);
                            } else this.center.idle(E), this.radius.idle(E);
                        }, b.setDistance = function(E, k) {
                            k > 0 && this.radius.set(E, Math.log(k));
                        }, b.setDistanceLimits = function(E, k) {
                            E > 0 ? E = Math.log(E) : E = -1 / 0, k > 0 ? k = Math.log(k) : k = 1 / 0, k = Math.max(k, E), this.radius.bounds[0][0] = E, this.radius.bounds[1][0] = k;
                        }, b.getDistanceLimits = function(E) {
                            var k = this.radius.bounds;
                            return E ? (E[0] = Math.exp(k[0][0]), E[1] = Math.exp(k[1][0]), E) : [
                                Math.exp(k[0][0]),
                                Math.exp(k[1][0])
                            ];
                        }, b.toJSON = function() {
                            return this.recalcMatrix(this.lastT()), {
                                center: this.computedCenter.slice(),
                                rotation: this.computedRotation.slice(),
                                distance: Math.log(this.computedRadius[0]),
                                zoomMin: this.radius.bounds[0][0],
                                zoomMax: this.radius.bounds[1][0]
                            };
                        }, b.fromJSON = function(E) {
                            var k = this.lastT(), A = E.center;
                            A && this.center.set(k, A[0], A[1], A[2]);
                            var L = E.rotation;
                            L && this.rotation.set(k, L[0], L[1], L[2], L[3]);
                            var _ = E.distance;
                            _ && _ > 0 && this.radius.set(k, Math.log(_)), this.setDistanceLimits(E.zoomMin, E.zoomMax);
                        };
                        function p(E) {
                            E = E || {};
                            var k = E.center || [
                                0,
                                0,
                                0
                            ], A = E.rotation || [
                                0,
                                0,
                                0,
                                1
                            ], L = E.radius || 1;
                            k = [].slice.call(k, 0, 3), A = [].slice.call(A, 0, 4), v(A, A);
                            var _ = new x(A, k, Math.log(L));
                            return _.setDistanceLimits(E.zoomMin, E.zoomMax), ("eye" in E || "up" in E) && _.lookAt(0, E.eye, E.center, E.up), _;
                        }
                    },
                    1371: function(i, a, o) {
                        "use strict";
                        var s = o(3233);
                        i.exports = function(u, c, f) {
                            return f = typeof f != "undefined" ? f + "" : " ", s(f, c) + u;
                        };
                    },
                    3202: function(i) {
                        i.exports = function(o, s) {
                            s || (s = [
                                0,
                                ""
                            ]), o = String(o);
                            var l = parseFloat(o, 10);
                            return s[0] = l, s[1] = o.match(/[\d.\-\+]*\s*(.*)/)[1] || "", s;
                        };
                    },
                    3088: function(i, a, o) {
                        "use strict";
                        i.exports = l;
                        var s = o(3140);
                        function l(u, c) {
                            for(var f = c.length | 0, h = u.length, d = [
                                new Array(f),
                                new Array(f)
                            ], v = 0; v < f; ++v)d[0][v] = [], d[1][v] = [];
                            for(var v = 0; v < h; ++v){
                                var x = u[v];
                                d[0][x[0]].push(x), d[1][x[1]].push(x);
                            }
                            for(var b = [], v = 0; v < f; ++v)d[0][v].length + d[1][v].length === 0 && b.push([
                                v
                            ]);
                            function p(g, P) {
                                var T = d[P][g[P]];
                                T.splice(T.indexOf(g), 1);
                            }
                            function E(g, P, T) {
                                for(var F, q, V, H = 0; H < 2; ++H)if (d[H][P].length > 0) {
                                    F = d[H][P][0], V = H;
                                    break;
                                }
                                q = F[V ^ 1];
                                for(var X = 0; X < 2; ++X)for(var G = d[X][P], N = 0; N < G.length; ++N){
                                    var W = G[N], re = W[X ^ 1], ae = s(c[g], c[P], c[q], c[re]);
                                    ae > 0 && (F = W, q = re, V = X);
                                }
                                return T || F && p(F, V), q;
                            }
                            function k(g, P) {
                                var T = d[P][g][0], F = [
                                    g
                                ];
                                p(T, P);
                                for(var q = T[P ^ 1], V = P;;){
                                    for(; q !== g;)F.push(q), q = E(F[F.length - 2], q, !1);
                                    if (d[0][g].length + d[1][g].length === 0) break;
                                    var H = F[F.length - 1], X = g, G = F[1], N = E(H, X, !0);
                                    if (s(c[H], c[X], c[G], c[N]) < 0) break;
                                    F.push(g), q = E(H, X);
                                }
                                return F;
                            }
                            function A(g, P) {
                                return P[1] === P[P.length - 1];
                            }
                            for(var v = 0; v < f; ++v)for(var L = 0; L < 2; ++L){
                                for(var _ = []; d[L][v].length > 0;){
                                    var C = d[0][v].length, M = k(v, L);
                                    A(_, M) ? _.push.apply(_, M) : (_.length > 0 && b.push(_), _ = M);
                                }
                                _.length > 0 && b.push(_);
                            }
                            return b;
                        }
                    },
                    5609: function(i, a, o) {
                        "use strict";
                        i.exports = l;
                        var s = o(3134);
                        function l(u, c) {
                            for(var f = s(u, c.length), h = new Array(c.length), d = new Array(c.length), v = [], x = 0; x < c.length; ++x){
                                var b = f[x].length;
                                d[x] = b, h[x] = !0, b <= 1 && v.push(x);
                            }
                            for(; v.length > 0;){
                                var p = v.pop();
                                h[p] = !1;
                                for(var E = f[p], x = 0; x < E.length; ++x){
                                    var k = E[x];
                                    --d[k] === 0 && v.push(k);
                                }
                            }
                            for(var A = new Array(c.length), L = [], x = 0; x < c.length; ++x)if (h[x]) {
                                var p = L.length;
                                A[x] = p, L.push(c[x]);
                            } else A[x] = -1;
                            for(var _ = [], x = 0; x < u.length; ++x){
                                var C = u[x];
                                h[C[0]] && h[C[1]] && _.push([
                                    A[C[0]],
                                    A[C[1]]
                                ]);
                            }
                            return [
                                _,
                                L
                            ];
                        }
                    },
                    2095: function(i, a, o) {
                        "use strict";
                        i.exports = b;
                        var s = o(3134), l = o(3088), u = o(5085), c = o(5250), f = o(8210), h = o(1682), d = o(5609);
                        function v(p, E) {
                            for(var k = new Array(p), A = 0; A < p; ++A)k[A] = E;
                            return k;
                        }
                        function x(p) {
                            for(var E = new Array(p), k = 0; k < p; ++k)E[k] = [];
                            return E;
                        }
                        function b(p, E) {
                            var Re = d(p, E);
                            p = Re[0], E = Re[1];
                            for(var k = E.length, A = p.length, L = s(p, E.length), _ = 0; _ < k; ++_)if (L[_].length % 2 === 1) throw new Error("planar-graph-to-polyline: graph must be manifold");
                            var C = l(p, E);
                            function M(ot) {
                                for(var Rt = ot.length, kt = [
                                    0
                                ], Ct = 0; Ct < Rt; ++Ct){
                                    var Yt = E[ot[Ct]], xr = E[ot[(Ct + 1) % Rt]], er = c(-Yt[0], Yt[1]), Ke = c(-Yt[0], xr[1]), xt = c(xr[0], Yt[1]), bt = c(xr[0], xr[1]);
                                    kt = f(kt, f(f(er, Ke), f(xt, bt)));
                                }
                                return kt[kt.length - 1] > 0;
                            }
                            C = C.filter(M);
                            for(var g = C.length, P = new Array(g), T = new Array(g), _ = 0; _ < g; ++_){
                                P[_] = _;
                                var F = new Array(g), q = C[_].map(function(Rt) {
                                    return E[Rt];
                                }), V = u([
                                    q
                                ]), H = 0;
                                e: for(var X = 0; X < g; ++X)if (F[X] = 0, _ !== X) {
                                    for(var G = C[X], N = G.length, W = 0; W < N; ++W){
                                        var re = V(E[G[W]]);
                                        if (re !== 0) {
                                            re < 0 && (F[X] = 1, H += 1);
                                            continue e;
                                        }
                                    }
                                    F[X] = 1, H += 1;
                                }
                                T[_] = [
                                    H,
                                    _,
                                    F
                                ];
                            }
                            T.sort(function(ot, Rt) {
                                return Rt[0] - ot[0];
                            });
                            for(var _ = 0; _ < g; ++_)for(var F = T[_], ae = F[1], _e = F[2], X = 0; X < g; ++X)_e[X] && (P[X] = ae);
                            for(var Me = x(g), _ = 0; _ < g; ++_)Me[_].push(P[_]), Me[P[_]].push(_);
                            for(var ke = {}, ge = v(k, !1), _ = 0; _ < g; ++_)for(var G = C[_], N = G.length, X = 0; X < N; ++X){
                                var ie = G[X], Te = G[(X + 1) % N], Ee = Math.min(ie, Te) + ":" + Math.max(ie, Te);
                                if (Ee in ke) {
                                    var Ae = ke[Ee];
                                    Me[Ae].push(_), Me[_].push(Ae), ge[ie] = ge[Te] = !0;
                                } else ke[Ee] = _;
                            }
                            function ze(ot) {
                                for(var Rt = ot.length, kt = 0; kt < Rt; ++kt)if (!ge[ot[kt]]) return !1;
                                return !0;
                            }
                            for(var Ce = [], me = v(g, -1), _ = 0; _ < g; ++_)P[_] === _ && !ze(C[_]) ? (Ce.push(_), me[_] = 0) : me[_] = -1;
                            for(var Re = []; Ce.length > 0;){
                                var ce = Ce.pop(), Ge = Me[ce];
                                h(Ge, function(ot, Rt) {
                                    return ot - Rt;
                                });
                                var nt = Ge.length, ct = me[ce], qt;
                                if (ct === 0) {
                                    var G = C[ce];
                                    qt = [
                                        G
                                    ];
                                }
                                for(var _ = 0; _ < nt; ++_){
                                    var rt = Ge[_];
                                    if (!(me[rt] >= 0) && (me[rt] = ct ^ 1, Ce.push(rt), ct === 0)) {
                                        var G = C[rt];
                                        ze(G) || (G.reverse(), qt.push(G));
                                    }
                                }
                                ct === 0 && Re.push(qt);
                            }
                            return Re;
                        }
                    },
                    5085: function(i, a, o) {
                        i.exports = E;
                        var s = o(3250)[3], l = o(4209), u = o(3352), c = o(2478);
                        function f() {
                            return !0;
                        }
                        function h(k) {
                            return function(A, L) {
                                var _ = k[A];
                                return _ ? !!_.queryPoint(L, f) : !1;
                            };
                        }
                        function d(k) {
                            for(var A = {}, L = 0; L < k.length; ++L){
                                var _ = k[L], C = _[0][0], M = _[0][1], g = _[1][1], P = [
                                    Math.min(M, g),
                                    Math.max(M, g)
                                ];
                                C in A ? A[C].push(P) : A[C] = [
                                    P
                                ];
                            }
                            for(var T = {}, F = Object.keys(A), L = 0; L < F.length; ++L){
                                var q = A[F[L]];
                                T[F[L]] = u(q);
                            }
                            return h(T);
                        }
                        function v(k, A) {
                            return function(L) {
                                var _ = c.le(A, L[0]);
                                if (_ < 0) return 1;
                                var C = k[_];
                                if (!C) {
                                    if (_ > 0 && A[_] === L[0]) C = k[_ - 1];
                                    else return 1;
                                }
                                for(var M = 1; C;){
                                    var g = C.key, P = s(L, g[0], g[1]);
                                    if (g[0][0] < g[1][0]) {
                                        if (P < 0) C = C.left;
                                        else if (P > 0) M = -1, C = C.right;
                                        else return 0;
                                    } else if (P > 0) C = C.left;
                                    else if (P < 0) M = 1, C = C.right;
                                    else return 0;
                                }
                                return M;
                            };
                        }
                        function x(k) {
                            return 1;
                        }
                        function b(k) {
                            return function(L) {
                                return k(L[0], L[1]) ? 0 : 1;
                            };
                        }
                        function p(k, A) {
                            return function(_) {
                                return k(_[0], _[1]) ? 0 : A(_);
                            };
                        }
                        function E(k) {
                            for(var A = k.length, L = [], _ = [], C = 0, M = 0; M < A; ++M)for(var g = k[M], P = g.length, T = P - 1, F = 0; F < P; T = F++){
                                var q = g[T], V = g[F];
                                q[0] === V[0] ? _.push([
                                    q,
                                    V
                                ]) : L.push([
                                    q,
                                    V
                                ]);
                            }
                            if (L.length === 0) return _.length === 0 ? x : b(d(_));
                            var H = l(L), X = v(H.slabs, H.coordinates);
                            return _.length === 0 ? X : p(d(_), X);
                        }
                    },
                    9346: function(i) {
                        "use strict";
                        var a = new Float64Array(4), o = new Float64Array(4), s = new Float64Array(4);
                        function l(u, c, f, h, d) {
                            a.length < h.length && (a = new Float64Array(h.length), o = new Float64Array(h.length), s = new Float64Array(h.length));
                            for(var v = 0; v < h.length; ++v)a[v] = u[v] - h[v], o[v] = c[v] - u[v], s[v] = f[v] - u[v];
                            for(var x = 0, b = 0, p = 0, E = 0, k = 0, A = 0, v = 0; v < h.length; ++v){
                                var L = o[v], _ = s[v], C = a[v];
                                x += L * L, b += L * _, p += _ * _, E += C * L, k += C * _, A += C * C;
                            }
                            var M = Math.abs(x * p - b * b), g = b * k - p * E, P = b * E - x * k, T;
                            if (g + P <= M) {
                                if (g < 0) P < 0 && E < 0 ? (P = 0, -E >= x ? (g = 1, T = x + 2 * E + A) : (g = -E / x, T = E * g + A)) : (g = 0, k >= 0 ? (P = 0, T = A) : -k >= p ? (P = 1, T = p + 2 * k + A) : (P = -k / p, T = k * P + A));
                                else if (P < 0) P = 0, E >= 0 ? (g = 0, T = A) : -E >= x ? (g = 1, T = x + 2 * E + A) : (g = -E / x, T = E * g + A);
                                else {
                                    var F = 1 / M;
                                    g *= F, P *= F, T = g * (x * g + b * P + 2 * E) + P * (b * g + p * P + 2 * k) + A;
                                }
                            } else {
                                var q, V, H, X;
                                g < 0 ? (q = b + E, V = p + k, V > q ? (H = V - q, X = x - 2 * b + p, H >= X ? (g = 1, P = 0, T = x + 2 * E + A) : (g = H / X, P = 1 - g, T = g * (x * g + b * P + 2 * E) + P * (b * g + p * P + 2 * k) + A)) : (g = 0, V <= 0 ? (P = 1, T = p + 2 * k + A) : k >= 0 ? (P = 0, T = A) : (P = -k / p, T = k * P + A))) : P < 0 ? (q = b + k, V = x + E, V > q ? (H = V - q, X = x - 2 * b + p, H >= X ? (P = 1, g = 0, T = p + 2 * k + A) : (P = H / X, g = 1 - P, T = g * (x * g + b * P + 2 * E) + P * (b * g + p * P + 2 * k) + A)) : (P = 0, V <= 0 ? (g = 1, T = x + 2 * E + A) : E >= 0 ? (g = 0, T = A) : (g = -E / x, T = E * g + A))) : (H = p + k - b - E, H <= 0 ? (g = 0, P = 1, T = p + 2 * k + A) : (X = x - 2 * b + p, H >= X ? (g = 1, P = 0, T = x + 2 * E + A) : (g = H / X, P = 1 - g, T = g * (x * g + b * P + 2 * E) + P * (b * g + p * P + 2 * k) + A)));
                            }
                            for(var G = 1 - g - P, v = 0; v < h.length; ++v)d[v] = G * u[v] + g * c[v] + P * f[v];
                            return T < 0 ? 0 : T;
                        }
                        i.exports = l;
                    },
                    8648: function(i, a, o) {
                        i.exports = o(783);
                    },
                    2653: function(i, a, o) {
                        "use strict";
                        var s = o(3865);
                        i.exports = l;
                        function l(u, c) {
                            for(var f = u.length, h = new Array(f), d = 0; d < f; ++d)h[d] = s(u[d], c[d]);
                            return h;
                        }
                    },
                    5838: function(i, a, o) {
                        "use strict";
                        i.exports = l;
                        var s = o(7842);
                        function l(u) {
                            for(var c = new Array(u.length), f = 0; f < u.length; ++f)c[f] = s(u[f]);
                            return c;
                        }
                    },
                    8987: function(i, a, o) {
                        "use strict";
                        var s = o(7842), l = o(6504);
                        i.exports = u;
                        function u(c, f) {
                            for(var h = s(f), d = c.length, v = new Array(d), x = 0; x < d; ++x)v[x] = l(c[x], h);
                            return v;
                        }
                    },
                    544: function(i, a, o) {
                        "use strict";
                        var s = o(5572);
                        i.exports = l;
                        function l(u, c) {
                            for(var f = u.length, h = new Array(f), d = 0; d < f; ++d)h[d] = s(u[d], c[d]);
                            return h;
                        }
                    },
                    5771: function(i, a, o) {
                        "use strict";
                        var s = o(8507), l = o(3788), u = o(2419);
                        i.exports = c;
                        function c(f) {
                            f.sort(l);
                            for(var h = f.length, d = 0, v = 0; v < h; ++v){
                                var x = f[v], b = u(x);
                                if (b !== 0) {
                                    if (d > 0) {
                                        var p = f[d - 1];
                                        if (s(x, p) === 0 && u(p) !== b) {
                                            d -= 1;
                                            continue;
                                        }
                                    }
                                    f[d++] = x;
                                }
                            }
                            return f.length = d, f;
                        }
                    },
                    3233: function(i) {
                        "use strict";
                        var a = "", o;
                        i.exports = s;
                        function s(l, u) {
                            if (typeof l != "string") throw new TypeError("expected a string");
                            if (u === 1) return l;
                            if (u === 2) return l + l;
                            var c = l.length * u;
                            if (o !== l || typeof o == "undefined") o = l, a = "";
                            else if (a.length >= c) return a.substr(0, c);
                            for(; c > a.length && u > 1;)u & 1 && (a += l), u >>= 1, l += l;
                            return a += l, a = a.substr(0, c), a;
                        }
                    },
                    3025: function(i, a, o) {
                        i.exports = o.g.performance && o.g.performance.now ? function() {
                            return performance.now();
                        } : Date.now || function() {
                            return +new Date;
                        };
                    },
                    7004: function(i) {
                        "use strict";
                        i.exports = a;
                        function a(o) {
                            for(var s = o.length, l = o[o.length - 1], u = s, c = s - 2; c >= 0; --c){
                                var f = l, h = o[c];
                                l = f + h;
                                var d = l - f, v = h - d;
                                v && (o[--u] = l, l = v);
                            }
                            for(var x = 0, c = u; c < s; ++c){
                                var f = o[c], h = l;
                                l = f + h;
                                var d = l - f, v = h - d;
                                v && (o[x++] = v);
                            }
                            return o[x++] = l, o.length = x, o;
                        }
                    },
                    2962: function(i, a, o) {
                        "use strict";
                        var s = o(5250), l = o(8210), u = o(3012), c = o(7004), f = 6;
                        function h(A, L, _, C) {
                            return function(g) {
                                return C(A(_(g[0][0], g[1][1]), _(-g[0][1], g[1][0])));
                            };
                        }
                        function d(A, L, _, C) {
                            return function(g) {
                                return C(A(L(A(_(g[1][1], g[2][2]), _(-g[1][2], g[2][1])), g[0][0]), A(L(A(_(g[1][0], g[2][2]), _(-g[1][2], g[2][0])), -g[0][1]), L(A(_(g[1][0], g[2][1]), _(-g[1][1], g[2][0])), g[0][2]))));
                            };
                        }
                        function v(A, L, _, C) {
                            return function(g) {
                                return C(A(A(L(A(L(A(_(g[2][2], g[3][3]), _(-g[2][3], g[3][2])), g[1][1]), A(L(A(_(g[2][1], g[3][3]), _(-g[2][3], g[3][1])), -g[1][2]), L(A(_(g[2][1], g[3][2]), _(-g[2][2], g[3][1])), g[1][3]))), g[0][0]), L(A(L(A(_(g[2][2], g[3][3]), _(-g[2][3], g[3][2])), g[1][0]), A(L(A(_(g[2][0], g[3][3]), _(-g[2][3], g[3][0])), -g[1][2]), L(A(_(g[2][0], g[3][2]), _(-g[2][2], g[3][0])), g[1][3]))), -g[0][1])), A(L(A(L(A(_(g[2][1], g[3][3]), _(-g[2][3], g[3][1])), g[1][0]), A(L(A(_(g[2][0], g[3][3]), _(-g[2][3], g[3][0])), -g[1][1]), L(A(_(g[2][0], g[3][1]), _(-g[2][1], g[3][0])), g[1][3]))), g[0][2]), L(A(L(A(_(g[2][1], g[3][2]), _(-g[2][2], g[3][1])), g[1][0]), A(L(A(_(g[2][0], g[3][2]), _(-g[2][2], g[3][0])), -g[1][1]), L(A(_(g[2][0], g[3][1]), _(-g[2][1], g[3][0])), g[1][2]))), -g[0][3]))));
                            };
                        }
                        function x(A, L, _, C) {
                            return function(g) {
                                return C(A(A(L(A(A(L(A(L(A(_(g[3][3], g[4][4]), _(-g[3][4], g[4][3])), g[2][2]), A(L(A(_(g[3][2], g[4][4]), _(-g[3][4], g[4][2])), -g[2][3]), L(A(_(g[3][2], g[4][3]), _(-g[3][3], g[4][2])), g[2][4]))), g[1][1]), L(A(L(A(_(g[3][3], g[4][4]), _(-g[3][4], g[4][3])), g[2][1]), A(L(A(_(g[3][1], g[4][4]), _(-g[3][4], g[4][1])), -g[2][3]), L(A(_(g[3][1], g[4][3]), _(-g[3][3], g[4][1])), g[2][4]))), -g[1][2])), A(L(A(L(A(_(g[3][2], g[4][4]), _(-g[3][4], g[4][2])), g[2][1]), A(L(A(_(g[3][1], g[4][4]), _(-g[3][4], g[4][1])), -g[2][2]), L(A(_(g[3][1], g[4][2]), _(-g[3][2], g[4][1])), g[2][4]))), g[1][3]), L(A(L(A(_(g[3][2], g[4][3]), _(-g[3][3], g[4][2])), g[2][1]), A(L(A(_(g[3][1], g[4][3]), _(-g[3][3], g[4][1])), -g[2][2]), L(A(_(g[3][1], g[4][2]), _(-g[3][2], g[4][1])), g[2][3]))), -g[1][4]))), g[0][0]), L(A(A(L(A(L(A(_(g[3][3], g[4][4]), _(-g[3][4], g[4][3])), g[2][2]), A(L(A(_(g[3][2], g[4][4]), _(-g[3][4], g[4][2])), -g[2][3]), L(A(_(g[3][2], g[4][3]), _(-g[3][3], g[4][2])), g[2][4]))), g[1][0]), L(A(L(A(_(g[3][3], g[4][4]), _(-g[3][4], g[4][3])), g[2][0]), A(L(A(_(g[3][0], g[4][4]), _(-g[3][4], g[4][0])), -g[2][3]), L(A(_(g[3][0], g[4][3]), _(-g[3][3], g[4][0])), g[2][4]))), -g[1][2])), A(L(A(L(A(_(g[3][2], g[4][4]), _(-g[3][4], g[4][2])), g[2][0]), A(L(A(_(g[3][0], g[4][4]), _(-g[3][4], g[4][0])), -g[2][2]), L(A(_(g[3][0], g[4][2]), _(-g[3][2], g[4][0])), g[2][4]))), g[1][3]), L(A(L(A(_(g[3][2], g[4][3]), _(-g[3][3], g[4][2])), g[2][0]), A(L(A(_(g[3][0], g[4][3]), _(-g[3][3], g[4][0])), -g[2][2]), L(A(_(g[3][0], g[4][2]), _(-g[3][2], g[4][0])), g[2][3]))), -g[1][4]))), -g[0][1])), A(L(A(A(L(A(L(A(_(g[3][3], g[4][4]), _(-g[3][4], g[4][3])), g[2][1]), A(L(A(_(g[3][1], g[4][4]), _(-g[3][4], g[4][1])), -g[2][3]), L(A(_(g[3][1], g[4][3]), _(-g[3][3], g[4][1])), g[2][4]))), g[1][0]), L(A(L(A(_(g[3][3], g[4][4]), _(-g[3][4], g[4][3])), g[2][0]), A(L(A(_(g[3][0], g[4][4]), _(-g[3][4], g[4][0])), -g[2][3]), L(A(_(g[3][0], g[4][3]), _(-g[3][3], g[4][0])), g[2][4]))), -g[1][1])), A(L(A(L(A(_(g[3][1], g[4][4]), _(-g[3][4], g[4][1])), g[2][0]), A(L(A(_(g[3][0], g[4][4]), _(-g[3][4], g[4][0])), -g[2][1]), L(A(_(g[3][0], g[4][1]), _(-g[3][1], g[4][0])), g[2][4]))), g[1][3]), L(A(L(A(_(g[3][1], g[4][3]), _(-g[3][3], g[4][1])), g[2][0]), A(L(A(_(g[3][0], g[4][3]), _(-g[3][3], g[4][0])), -g[2][1]), L(A(_(g[3][0], g[4][1]), _(-g[3][1], g[4][0])), g[2][3]))), -g[1][4]))), g[0][2]), A(L(A(A(L(A(L(A(_(g[3][2], g[4][4]), _(-g[3][4], g[4][2])), g[2][1]), A(L(A(_(g[3][1], g[4][4]), _(-g[3][4], g[4][1])), -g[2][2]), L(A(_(g[3][1], g[4][2]), _(-g[3][2], g[4][1])), g[2][4]))), g[1][0]), L(A(L(A(_(g[3][2], g[4][4]), _(-g[3][4], g[4][2])), g[2][0]), A(L(A(_(g[3][0], g[4][4]), _(-g[3][4], g[4][0])), -g[2][2]), L(A(_(g[3][0], g[4][2]), _(-g[3][2], g[4][0])), g[2][4]))), -g[1][1])), A(L(A(L(A(_(g[3][1], g[4][4]), _(-g[3][4], g[4][1])), g[2][0]), A(L(A(_(g[3][0], g[4][4]), _(-g[3][4], g[4][0])), -g[2][1]), L(A(_(g[3][0], g[4][1]), _(-g[3][1], g[4][0])), g[2][4]))), g[1][2]), L(A(L(A(_(g[3][1], g[4][2]), _(-g[3][2], g[4][1])), g[2][0]), A(L(A(_(g[3][0], g[4][2]), _(-g[3][2], g[4][0])), -g[2][1]), L(A(_(g[3][0], g[4][1]), _(-g[3][1], g[4][0])), g[2][2]))), -g[1][4]))), -g[0][3]), L(A(A(L(A(L(A(_(g[3][2], g[4][3]), _(-g[3][3], g[4][2])), g[2][1]), A(L(A(_(g[3][1], g[4][3]), _(-g[3][3], g[4][1])), -g[2][2]), L(A(_(g[3][1], g[4][2]), _(-g[3][2], g[4][1])), g[2][3]))), g[1][0]), L(A(L(A(_(g[3][2], g[4][3]), _(-g[3][3], g[4][2])), g[2][0]), A(L(A(_(g[3][0], g[4][3]), _(-g[3][3], g[4][0])), -g[2][2]), L(A(_(g[3][0], g[4][2]), _(-g[3][2], g[4][0])), g[2][3]))), -g[1][1])), A(L(A(L(A(_(g[3][1], g[4][3]), _(-g[3][3], g[4][1])), g[2][0]), A(L(A(_(g[3][0], g[4][3]), _(-g[3][3], g[4][0])), -g[2][1]), L(A(_(g[3][0], g[4][1]), _(-g[3][1], g[4][0])), g[2][3]))), g[1][2]), L(A(L(A(_(g[3][1], g[4][2]), _(-g[3][2], g[4][1])), g[2][0]), A(L(A(_(g[3][0], g[4][2]), _(-g[3][2], g[4][0])), -g[2][1]), L(A(_(g[3][0], g[4][1]), _(-g[3][1], g[4][0])), g[2][2]))), -g[1][3]))), g[0][4])))));
                            };
                        }
                        function b(A) {
                            var L = A === 2 ? h : A === 3 ? d : A === 4 ? v : A === 5 ? x : void 0;
                            return L(l, u, s, c);
                        }
                        var p = [
                            function() {
                                return [
                                    0
                                ];
                            },
                            function(L) {
                                return [
                                    L[0][0]
                                ];
                            }
                        ];
                        function E(A, L, _, C, M, g, P, T) {
                            return function(q) {
                                switch(q.length){
                                    case 0:
                                        return A(q);
                                    case 1:
                                        return L(q);
                                    case 2:
                                        return _(q);
                                    case 3:
                                        return C(q);
                                    case 4:
                                        return M(q);
                                    case 5:
                                        return g(q);
                                }
                                var V = P[q.length];
                                return V || (V = P[q.length] = T(q.length)), V(q);
                            };
                        }
                        function k() {
                            for(; p.length < f;)p.push(b(p.length));
                            i.exports = E.apply(void 0, p.concat([
                                p,
                                b
                            ]));
                            for(var A = 0; A < p.length; ++A)i.exports[A] = p[A];
                        }
                        k();
                    },
                    1944: function(i, a, o) {
                        "use strict";
                        var s = o(5250), l = o(8210);
                        i.exports = u;
                        function u(c, f) {
                            for(var h = s(c[0], f[0]), d = 1; d < c.length; ++d)h = l(h, s(c[d], f[d]));
                            return h;
                        }
                    },
                    2646: function(i, a, o) {
                        "use strict";
                        var s = o(5250), l = o(8210), u = o(8545), c = o(3012), f = 6;
                        function h(M) {
                            var g = M === 3 ? b : M === 4 ? p : M === 5 ? E : k;
                            return g(l, u, s, c);
                        }
                        function d() {
                            return 0;
                        }
                        function v() {
                            return 0;
                        }
                        function x() {
                            return 0;
                        }
                        function b(M, g, P, T) {
                            function F(q, V, H) {
                                var X = P(q[0], q[0]), G = T(X, V[0]), N = T(X, H[0]), W = P(V[0], V[0]), re = T(W, q[0]), ae = T(W, H[0]), _e = P(H[0], H[0]), Me = T(_e, q[0]), ke = T(_e, V[0]), ge = M(g(ke, ae), g(re, G)), ie = g(Me, N), Te = g(ge, ie);
                                return Te[Te.length - 1];
                            }
                            return F;
                        }
                        function p(M, g, P, T) {
                            function F(q, V, H, X) {
                                var G = M(P(q[0], q[0]), P(q[1], q[1])), N = T(G, V[0]), W = T(G, H[0]), re = T(G, X[0]), ae = M(P(V[0], V[0]), P(V[1], V[1])), _e = T(ae, q[0]), Me = T(ae, H[0]), ke = T(ae, X[0]), ge = M(P(H[0], H[0]), P(H[1], H[1])), ie = T(ge, q[0]), Te = T(ge, V[0]), Ee = T(ge, X[0]), Ae = M(P(X[0], X[0]), P(X[1], X[1])), ze = T(Ae, q[0]), Ce = T(Ae, V[0]), me = T(Ae, H[0]), Re = M(M(T(g(me, Ee), V[1]), M(T(g(Ce, ke), -H[1]), T(g(Te, Me), X[1]))), M(T(g(Ce, ke), q[1]), M(T(g(ze, re), -V[1]), T(g(_e, N), X[1])))), ce = M(M(T(g(me, Ee), q[1]), M(T(g(ze, re), -H[1]), T(g(ie, W), X[1]))), M(T(g(Te, Me), q[1]), M(T(g(ie, W), -V[1]), T(g(_e, N), H[1])))), Ge = g(Re, ce);
                                return Ge[Ge.length - 1];
                            }
                            return F;
                        }
                        function E(M, g, P, T) {
                            function F(q, V, H, X, G) {
                                var N = M(P(q[0], q[0]), M(P(q[1], q[1]), P(q[2], q[2]))), W = T(N, V[0]), re = T(N, H[0]), ae = T(N, X[0]), _e = T(N, G[0]), Me = M(P(V[0], V[0]), M(P(V[1], V[1]), P(V[2], V[2]))), ke = T(Me, q[0]), ge = T(Me, H[0]), ie = T(Me, X[0]), Te = T(Me, G[0]), Ee = M(P(H[0], H[0]), M(P(H[1], H[1]), P(H[2], H[2]))), Ae = T(Ee, q[0]), ze = T(Ee, V[0]), Ce = T(Ee, X[0]), me = T(Ee, G[0]), Re = M(P(X[0], X[0]), M(P(X[1], X[1]), P(X[2], X[2]))), ce = T(Re, q[0]), Ge = T(Re, V[0]), nt = T(Re, H[0]), ct = T(Re, G[0]), qt = M(P(G[0], G[0]), M(P(G[1], G[1]), P(G[2], G[2]))), rt = T(qt, q[0]), ot = T(qt, V[0]), Rt = T(qt, H[0]), kt = T(qt, X[0]), Ct = M(M(M(T(M(T(g(kt, ct), H[1]), M(T(g(Rt, me), -X[1]), T(g(nt, Ce), G[1]))), V[2]), M(T(M(T(g(kt, ct), V[1]), M(T(g(ot, Te), -X[1]), T(g(Ge, ie), G[1]))), -H[2]), T(M(T(g(Rt, me), V[1]), M(T(g(ot, Te), -H[1]), T(g(ze, ge), G[1]))), X[2]))), M(T(M(T(g(nt, Ce), V[1]), M(T(g(Ge, ie), -H[1]), T(g(ze, ge), X[1]))), -G[2]), M(T(M(T(g(kt, ct), V[1]), M(T(g(ot, Te), -X[1]), T(g(Ge, ie), G[1]))), q[2]), T(M(T(g(kt, ct), q[1]), M(T(g(rt, _e), -X[1]), T(g(ce, ae), G[1]))), -V[2])))), M(M(T(M(T(g(ot, Te), q[1]), M(T(g(rt, _e), -V[1]), T(g(ke, W), G[1]))), X[2]), M(T(M(T(g(Ge, ie), q[1]), M(T(g(ce, ae), -V[1]), T(g(ke, W), X[1]))), -G[2]), T(M(T(g(nt, Ce), V[1]), M(T(g(Ge, ie), -H[1]), T(g(ze, ge), X[1]))), q[2]))), M(T(M(T(g(nt, Ce), q[1]), M(T(g(ce, ae), -H[1]), T(g(Ae, re), X[1]))), -V[2]), M(T(M(T(g(Ge, ie), q[1]), M(T(g(ce, ae), -V[1]), T(g(ke, W), X[1]))), H[2]), T(M(T(g(ze, ge), q[1]), M(T(g(Ae, re), -V[1]), T(g(ke, W), H[1]))), -X[2]))))), Yt = M(M(M(T(M(T(g(kt, ct), H[1]), M(T(g(Rt, me), -X[1]), T(g(nt, Ce), G[1]))), q[2]), T(M(T(g(kt, ct), q[1]), M(T(g(rt, _e), -X[1]), T(g(ce, ae), G[1]))), -H[2])), M(T(M(T(g(Rt, me), q[1]), M(T(g(rt, _e), -H[1]), T(g(Ae, re), G[1]))), X[2]), T(M(T(g(nt, Ce), q[1]), M(T(g(ce, ae), -H[1]), T(g(Ae, re), X[1]))), -G[2]))), M(M(T(M(T(g(Rt, me), V[1]), M(T(g(ot, Te), -H[1]), T(g(ze, ge), G[1]))), q[2]), T(M(T(g(Rt, me), q[1]), M(T(g(rt, _e), -H[1]), T(g(Ae, re), G[1]))), -V[2])), M(T(M(T(g(ot, Te), q[1]), M(T(g(rt, _e), -V[1]), T(g(ke, W), G[1]))), H[2]), T(M(T(g(ze, ge), q[1]), M(T(g(Ae, re), -V[1]), T(g(ke, W), H[1]))), -G[2])))), xr = g(Ct, Yt);
                                return xr[xr.length - 1];
                            }
                            return F;
                        }
                        function k(M, g, P, T) {
                            function F(q, V, H, X, G, N) {
                                var W = M(M(P(q[0], q[0]), P(q[1], q[1])), M(P(q[2], q[2]), P(q[3], q[3]))), re = T(W, V[0]), ae = T(W, H[0]), _e = T(W, X[0]), Me = T(W, G[0]), ke = T(W, N[0]), ge = M(M(P(V[0], V[0]), P(V[1], V[1])), M(P(V[2], V[2]), P(V[3], V[3]))), ie = T(ge, q[0]), Te = T(ge, H[0]), Ee = T(ge, X[0]), Ae = T(ge, G[0]), ze = T(ge, N[0]), Ce = M(M(P(H[0], H[0]), P(H[1], H[1])), M(P(H[2], H[2]), P(H[3], H[3]))), me = T(Ce, q[0]), Re = T(Ce, V[0]), ce = T(Ce, X[0]), Ge = T(Ce, G[0]), nt = T(Ce, N[0]), ct = M(M(P(X[0], X[0]), P(X[1], X[1])), M(P(X[2], X[2]), P(X[3], X[3]))), qt = T(ct, q[0]), rt = T(ct, V[0]), ot = T(ct, H[0]), Rt = T(ct, G[0]), kt = T(ct, N[0]), Ct = M(M(P(G[0], G[0]), P(G[1], G[1])), M(P(G[2], G[2]), P(G[3], G[3]))), Yt = T(Ct, q[0]), xr = T(Ct, V[0]), er = T(Ct, H[0]), Ke = T(Ct, X[0]), xt = T(Ct, N[0]), bt = M(M(P(N[0], N[0]), P(N[1], N[1])), M(P(N[2], N[2]), P(N[3], N[3]))), Lt = T(bt, q[0]), St = T(bt, V[0]), Et = T(bt, H[0]), dt = T(bt, X[0]), Ht = T(bt, G[0]), $t = M(M(M(T(M(M(T(M(T(g(Ht, xt), X[1]), M(T(g(dt, kt), -G[1]), T(g(Ke, Rt), N[1]))), H[2]), T(M(T(g(Ht, xt), H[1]), M(T(g(Et, nt), -G[1]), T(g(er, Ge), N[1]))), -X[2])), M(T(M(T(g(dt, kt), H[1]), M(T(g(Et, nt), -X[1]), T(g(ot, ce), N[1]))), G[2]), T(M(T(g(Ke, Rt), H[1]), M(T(g(er, Ge), -X[1]), T(g(ot, ce), G[1]))), -N[2]))), V[3]), M(T(M(M(T(M(T(g(Ht, xt), X[1]), M(T(g(dt, kt), -G[1]), T(g(Ke, Rt), N[1]))), V[2]), T(M(T(g(Ht, xt), V[1]), M(T(g(St, ze), -G[1]), T(g(xr, Ae), N[1]))), -X[2])), M(T(M(T(g(dt, kt), V[1]), M(T(g(St, ze), -X[1]), T(g(rt, Ee), N[1]))), G[2]), T(M(T(g(Ke, Rt), V[1]), M(T(g(xr, Ae), -X[1]), T(g(rt, Ee), G[1]))), -N[2]))), -H[3]), T(M(M(T(M(T(g(Ht, xt), H[1]), M(T(g(Et, nt), -G[1]), T(g(er, Ge), N[1]))), V[2]), T(M(T(g(Ht, xt), V[1]), M(T(g(St, ze), -G[1]), T(g(xr, Ae), N[1]))), -H[2])), M(T(M(T(g(Et, nt), V[1]), M(T(g(St, ze), -H[1]), T(g(Re, Te), N[1]))), G[2]), T(M(T(g(er, Ge), V[1]), M(T(g(xr, Ae), -H[1]), T(g(Re, Te), G[1]))), -N[2]))), X[3]))), M(M(T(M(M(T(M(T(g(dt, kt), H[1]), M(T(g(Et, nt), -X[1]), T(g(ot, ce), N[1]))), V[2]), T(M(T(g(dt, kt), V[1]), M(T(g(St, ze), -X[1]), T(g(rt, Ee), N[1]))), -H[2])), M(T(M(T(g(Et, nt), V[1]), M(T(g(St, ze), -H[1]), T(g(Re, Te), N[1]))), X[2]), T(M(T(g(ot, ce), V[1]), M(T(g(rt, Ee), -H[1]), T(g(Re, Te), X[1]))), -N[2]))), -G[3]), T(M(M(T(M(T(g(Ke, Rt), H[1]), M(T(g(er, Ge), -X[1]), T(g(ot, ce), G[1]))), V[2]), T(M(T(g(Ke, Rt), V[1]), M(T(g(xr, Ae), -X[1]), T(g(rt, Ee), G[1]))), -H[2])), M(T(M(T(g(er, Ge), V[1]), M(T(g(xr, Ae), -H[1]), T(g(Re, Te), G[1]))), X[2]), T(M(T(g(ot, ce), V[1]), M(T(g(rt, Ee), -H[1]), T(g(Re, Te), X[1]))), -G[2]))), N[3])), M(T(M(M(T(M(T(g(Ht, xt), X[1]), M(T(g(dt, kt), -G[1]), T(g(Ke, Rt), N[1]))), V[2]), T(M(T(g(Ht, xt), V[1]), M(T(g(St, ze), -G[1]), T(g(xr, Ae), N[1]))), -X[2])), M(T(M(T(g(dt, kt), V[1]), M(T(g(St, ze), -X[1]), T(g(rt, Ee), N[1]))), G[2]), T(M(T(g(Ke, Rt), V[1]), M(T(g(xr, Ae), -X[1]), T(g(rt, Ee), G[1]))), -N[2]))), q[3]), T(M(M(T(M(T(g(Ht, xt), X[1]), M(T(g(dt, kt), -G[1]), T(g(Ke, Rt), N[1]))), q[2]), T(M(T(g(Ht, xt), q[1]), M(T(g(Lt, ke), -G[1]), T(g(Yt, Me), N[1]))), -X[2])), M(T(M(T(g(dt, kt), q[1]), M(T(g(Lt, ke), -X[1]), T(g(qt, _e), N[1]))), G[2]), T(M(T(g(Ke, Rt), q[1]), M(T(g(Yt, Me), -X[1]), T(g(qt, _e), G[1]))), -N[2]))), -V[3])))), M(M(M(T(M(M(T(M(T(g(Ht, xt), V[1]), M(T(g(St, ze), -G[1]), T(g(xr, Ae), N[1]))), q[2]), T(M(T(g(Ht, xt), q[1]), M(T(g(Lt, ke), -G[1]), T(g(Yt, Me), N[1]))), -V[2])), M(T(M(T(g(St, ze), q[1]), M(T(g(Lt, ke), -V[1]), T(g(ie, re), N[1]))), G[2]), T(M(T(g(xr, Ae), q[1]), M(T(g(Yt, Me), -V[1]), T(g(ie, re), G[1]))), -N[2]))), X[3]), T(M(M(T(M(T(g(dt, kt), V[1]), M(T(g(St, ze), -X[1]), T(g(rt, Ee), N[1]))), q[2]), T(M(T(g(dt, kt), q[1]), M(T(g(Lt, ke), -X[1]), T(g(qt, _e), N[1]))), -V[2])), M(T(M(T(g(St, ze), q[1]), M(T(g(Lt, ke), -V[1]), T(g(ie, re), N[1]))), X[2]), T(M(T(g(rt, Ee), q[1]), M(T(g(qt, _e), -V[1]), T(g(ie, re), X[1]))), -N[2]))), -G[3])), M(T(M(M(T(M(T(g(Ke, Rt), V[1]), M(T(g(xr, Ae), -X[1]), T(g(rt, Ee), G[1]))), q[2]), T(M(T(g(Ke, Rt), q[1]), M(T(g(Yt, Me), -X[1]), T(g(qt, _e), G[1]))), -V[2])), M(T(M(T(g(xr, Ae), q[1]), M(T(g(Yt, Me), -V[1]), T(g(ie, re), G[1]))), X[2]), T(M(T(g(rt, Ee), q[1]), M(T(g(qt, _e), -V[1]), T(g(ie, re), X[1]))), -G[2]))), N[3]), T(M(M(T(M(T(g(dt, kt), H[1]), M(T(g(Et, nt), -X[1]), T(g(ot, ce), N[1]))), V[2]), T(M(T(g(dt, kt), V[1]), M(T(g(St, ze), -X[1]), T(g(rt, Ee), N[1]))), -H[2])), M(T(M(T(g(Et, nt), V[1]), M(T(g(St, ze), -H[1]), T(g(Re, Te), N[1]))), X[2]), T(M(T(g(ot, ce), V[1]), M(T(g(rt, Ee), -H[1]), T(g(Re, Te), X[1]))), -N[2]))), q[3]))), M(M(T(M(M(T(M(T(g(dt, kt), H[1]), M(T(g(Et, nt), -X[1]), T(g(ot, ce), N[1]))), q[2]), T(M(T(g(dt, kt), q[1]), M(T(g(Lt, ke), -X[1]), T(g(qt, _e), N[1]))), -H[2])), M(T(M(T(g(Et, nt), q[1]), M(T(g(Lt, ke), -H[1]), T(g(me, ae), N[1]))), X[2]), T(M(T(g(ot, ce), q[1]), M(T(g(qt, _e), -H[1]), T(g(me, ae), X[1]))), -N[2]))), -V[3]), T(M(M(T(M(T(g(dt, kt), V[1]), M(T(g(St, ze), -X[1]), T(g(rt, Ee), N[1]))), q[2]), T(M(T(g(dt, kt), q[1]), M(T(g(Lt, ke), -X[1]), T(g(qt, _e), N[1]))), -V[2])), M(T(M(T(g(St, ze), q[1]), M(T(g(Lt, ke), -V[1]), T(g(ie, re), N[1]))), X[2]), T(M(T(g(rt, Ee), q[1]), M(T(g(qt, _e), -V[1]), T(g(ie, re), X[1]))), -N[2]))), H[3])), M(T(M(M(T(M(T(g(Et, nt), V[1]), M(T(g(St, ze), -H[1]), T(g(Re, Te), N[1]))), q[2]), T(M(T(g(Et, nt), q[1]), M(T(g(Lt, ke), -H[1]), T(g(me, ae), N[1]))), -V[2])), M(T(M(T(g(St, ze), q[1]), M(T(g(Lt, ke), -V[1]), T(g(ie, re), N[1]))), H[2]), T(M(T(g(Re, Te), q[1]), M(T(g(me, ae), -V[1]), T(g(ie, re), H[1]))), -N[2]))), -X[3]), T(M(M(T(M(T(g(ot, ce), V[1]), M(T(g(rt, Ee), -H[1]), T(g(Re, Te), X[1]))), q[2]), T(M(T(g(ot, ce), q[1]), M(T(g(qt, _e), -H[1]), T(g(me, ae), X[1]))), -V[2])), M(T(M(T(g(rt, Ee), q[1]), M(T(g(qt, _e), -V[1]), T(g(ie, re), X[1]))), H[2]), T(M(T(g(Re, Te), q[1]), M(T(g(me, ae), -V[1]), T(g(ie, re), H[1]))), -X[2]))), N[3]))))), fr = M(M(M(T(M(M(T(M(T(g(Ht, xt), X[1]), M(T(g(dt, kt), -G[1]), T(g(Ke, Rt), N[1]))), H[2]), T(M(T(g(Ht, xt), H[1]), M(T(g(Et, nt), -G[1]), T(g(er, Ge), N[1]))), -X[2])), M(T(M(T(g(dt, kt), H[1]), M(T(g(Et, nt), -X[1]), T(g(ot, ce), N[1]))), G[2]), T(M(T(g(Ke, Rt), H[1]), M(T(g(er, Ge), -X[1]), T(g(ot, ce), G[1]))), -N[2]))), q[3]), M(T(M(M(T(M(T(g(Ht, xt), X[1]), M(T(g(dt, kt), -G[1]), T(g(Ke, Rt), N[1]))), q[2]), T(M(T(g(Ht, xt), q[1]), M(T(g(Lt, ke), -G[1]), T(g(Yt, Me), N[1]))), -X[2])), M(T(M(T(g(dt, kt), q[1]), M(T(g(Lt, ke), -X[1]), T(g(qt, _e), N[1]))), G[2]), T(M(T(g(Ke, Rt), q[1]), M(T(g(Yt, Me), -X[1]), T(g(qt, _e), G[1]))), -N[2]))), -H[3]), T(M(M(T(M(T(g(Ht, xt), H[1]), M(T(g(Et, nt), -G[1]), T(g(er, Ge), N[1]))), q[2]), T(M(T(g(Ht, xt), q[1]), M(T(g(Lt, ke), -G[1]), T(g(Yt, Me), N[1]))), -H[2])), M(T(M(T(g(Et, nt), q[1]), M(T(g(Lt, ke), -H[1]), T(g(me, ae), N[1]))), G[2]), T(M(T(g(er, Ge), q[1]), M(T(g(Yt, Me), -H[1]), T(g(me, ae), G[1]))), -N[2]))), X[3]))), M(M(T(M(M(T(M(T(g(dt, kt), H[1]), M(T(g(Et, nt), -X[1]), T(g(ot, ce), N[1]))), q[2]), T(M(T(g(dt, kt), q[1]), M(T(g(Lt, ke), -X[1]), T(g(qt, _e), N[1]))), -H[2])), M(T(M(T(g(Et, nt), q[1]), M(T(g(Lt, ke), -H[1]), T(g(me, ae), N[1]))), X[2]), T(M(T(g(ot, ce), q[1]), M(T(g(qt, _e), -H[1]), T(g(me, ae), X[1]))), -N[2]))), -G[3]), T(M(M(T(M(T(g(Ke, Rt), H[1]), M(T(g(er, Ge), -X[1]), T(g(ot, ce), G[1]))), q[2]), T(M(T(g(Ke, Rt), q[1]), M(T(g(Yt, Me), -X[1]), T(g(qt, _e), G[1]))), -H[2])), M(T(M(T(g(er, Ge), q[1]), M(T(g(Yt, Me), -H[1]), T(g(me, ae), G[1]))), X[2]), T(M(T(g(ot, ce), q[1]), M(T(g(qt, _e), -H[1]), T(g(me, ae), X[1]))), -G[2]))), N[3])), M(T(M(M(T(M(T(g(Ht, xt), H[1]), M(T(g(Et, nt), -G[1]), T(g(er, Ge), N[1]))), V[2]), T(M(T(g(Ht, xt), V[1]), M(T(g(St, ze), -G[1]), T(g(xr, Ae), N[1]))), -H[2])), M(T(M(T(g(Et, nt), V[1]), M(T(g(St, ze), -H[1]), T(g(Re, Te), N[1]))), G[2]), T(M(T(g(er, Ge), V[1]), M(T(g(xr, Ae), -H[1]), T(g(Re, Te), G[1]))), -N[2]))), q[3]), T(M(M(T(M(T(g(Ht, xt), H[1]), M(T(g(Et, nt), -G[1]), T(g(er, Ge), N[1]))), q[2]), T(M(T(g(Ht, xt), q[1]), M(T(g(Lt, ke), -G[1]), T(g(Yt, Me), N[1]))), -H[2])), M(T(M(T(g(Et, nt), q[1]), M(T(g(Lt, ke), -H[1]), T(g(me, ae), N[1]))), G[2]), T(M(T(g(er, Ge), q[1]), M(T(g(Yt, Me), -H[1]), T(g(me, ae), G[1]))), -N[2]))), -V[3])))), M(M(M(T(M(M(T(M(T(g(Ht, xt), V[1]), M(T(g(St, ze), -G[1]), T(g(xr, Ae), N[1]))), q[2]), T(M(T(g(Ht, xt), q[1]), M(T(g(Lt, ke), -G[1]), T(g(Yt, Me), N[1]))), -V[2])), M(T(M(T(g(St, ze), q[1]), M(T(g(Lt, ke), -V[1]), T(g(ie, re), N[1]))), G[2]), T(M(T(g(xr, Ae), q[1]), M(T(g(Yt, Me), -V[1]), T(g(ie, re), G[1]))), -N[2]))), H[3]), T(M(M(T(M(T(g(Et, nt), V[1]), M(T(g(St, ze), -H[1]), T(g(Re, Te), N[1]))), q[2]), T(M(T(g(Et, nt), q[1]), M(T(g(Lt, ke), -H[1]), T(g(me, ae), N[1]))), -V[2])), M(T(M(T(g(St, ze), q[1]), M(T(g(Lt, ke), -V[1]), T(g(ie, re), N[1]))), H[2]), T(M(T(g(Re, Te), q[1]), M(T(g(me, ae), -V[1]), T(g(ie, re), H[1]))), -N[2]))), -G[3])), M(T(M(M(T(M(T(g(er, Ge), V[1]), M(T(g(xr, Ae), -H[1]), T(g(Re, Te), G[1]))), q[2]), T(M(T(g(er, Ge), q[1]), M(T(g(Yt, Me), -H[1]), T(g(me, ae), G[1]))), -V[2])), M(T(M(T(g(xr, Ae), q[1]), M(T(g(Yt, Me), -V[1]), T(g(ie, re), G[1]))), H[2]), T(M(T(g(Re, Te), q[1]), M(T(g(me, ae), -V[1]), T(g(ie, re), H[1]))), -G[2]))), N[3]), T(M(M(T(M(T(g(Ke, Rt), H[1]), M(T(g(er, Ge), -X[1]), T(g(ot, ce), G[1]))), V[2]), T(M(T(g(Ke, Rt), V[1]), M(T(g(xr, Ae), -X[1]), T(g(rt, Ee), G[1]))), -H[2])), M(T(M(T(g(er, Ge), V[1]), M(T(g(xr, Ae), -H[1]), T(g(Re, Te), G[1]))), X[2]), T(M(T(g(ot, ce), V[1]), M(T(g(rt, Ee), -H[1]), T(g(Re, Te), X[1]))), -G[2]))), q[3]))), M(M(T(M(M(T(M(T(g(Ke, Rt), H[1]), M(T(g(er, Ge), -X[1]), T(g(ot, ce), G[1]))), q[2]), T(M(T(g(Ke, Rt), q[1]), M(T(g(Yt, Me), -X[1]), T(g(qt, _e), G[1]))), -H[2])), M(T(M(T(g(er, Ge), q[1]), M(T(g(Yt, Me), -H[1]), T(g(me, ae), G[1]))), X[2]), T(M(T(g(ot, ce), q[1]), M(T(g(qt, _e), -H[1]), T(g(me, ae), X[1]))), -G[2]))), -V[3]), T(M(M(T(M(T(g(Ke, Rt), V[1]), M(T(g(xr, Ae), -X[1]), T(g(rt, Ee), G[1]))), q[2]), T(M(T(g(Ke, Rt), q[1]), M(T(g(Yt, Me), -X[1]), T(g(qt, _e), G[1]))), -V[2])), M(T(M(T(g(xr, Ae), q[1]), M(T(g(Yt, Me), -V[1]), T(g(ie, re), G[1]))), X[2]), T(M(T(g(rt, Ee), q[1]), M(T(g(qt, _e), -V[1]), T(g(ie, re), X[1]))), -G[2]))), H[3])), M(T(M(M(T(M(T(g(er, Ge), V[1]), M(T(g(xr, Ae), -H[1]), T(g(Re, Te), G[1]))), q[2]), T(M(T(g(er, Ge), q[1]), M(T(g(Yt, Me), -H[1]), T(g(me, ae), G[1]))), -V[2])), M(T(M(T(g(xr, Ae), q[1]), M(T(g(Yt, Me), -V[1]), T(g(ie, re), G[1]))), H[2]), T(M(T(g(Re, Te), q[1]), M(T(g(me, ae), -V[1]), T(g(ie, re), H[1]))), -G[2]))), -X[3]), T(M(M(T(M(T(g(ot, ce), V[1]), M(T(g(rt, Ee), -H[1]), T(g(Re, Te), X[1]))), q[2]), T(M(T(g(ot, ce), q[1]), M(T(g(qt, _e), -H[1]), T(g(me, ae), X[1]))), -V[2])), M(T(M(T(g(rt, Ee), q[1]), M(T(g(qt, _e), -V[1]), T(g(ie, re), X[1]))), H[2]), T(M(T(g(Re, Te), q[1]), M(T(g(me, ae), -V[1]), T(g(ie, re), H[1]))), -X[2]))), G[3]))))), _r = g($t, fr);
                                return _r[_r.length - 1];
                            }
                            return F;
                        }
                        var A = [
                            d,
                            v,
                            x
                        ];
                        function L(M) {
                            var g = A[M.length];
                            return g || (g = A[M.length] = h(M.length)), g.apply(void 0, M);
                        }
                        function _(M, g, P, T, F, q, V, H) {
                            function X(G, N, W, re, ae, _e) {
                                switch(arguments.length){
                                    case 0:
                                    case 1:
                                        return 0;
                                    case 2:
                                        return T(G, N);
                                    case 3:
                                        return F(G, N, W);
                                    case 4:
                                        return q(G, N, W, re);
                                    case 5:
                                        return V(G, N, W, re, ae);
                                    case 6:
                                        return H(G, N, W, re, ae, _e);
                                }
                                for(var Me = new Array(arguments.length), ke = 0; ke < arguments.length; ++ke)Me[ke] = arguments[ke];
                                return M(Me);
                            }
                            return X;
                        }
                        function C() {
                            for(; A.length <= f;)A.push(h(A.length));
                            i.exports = _.apply(void 0, [
                                L
                            ].concat(A));
                            for(var M = 0; M <= f; ++M)i.exports[M] = A[M];
                        }
                        C();
                    },
                    727: function(i, a, o) {
                        "use strict";
                        var s = o(2962), l = 6;
                        function u(A) {
                            var L = A === 2 ? h : A === 3 ? d : A === 4 ? v : A === 5 ? x : b;
                            return A < 6 ? L(s[A]) : L(s);
                        }
                        function c() {
                            return [
                                [
                                    0
                                ]
                            ];
                        }
                        function f(A, L) {
                            return [
                                [
                                    L[0]
                                ],
                                [
                                    A[0][0]
                                ]
                            ];
                        }
                        function h(A) {
                            return function(_, C) {
                                return [
                                    A([
                                        [
                                            +C[0],
                                            +_[0][1]
                                        ],
                                        [
                                            +C[1],
                                            +_[1][1]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +C[0]
                                        ],
                                        [
                                            +_[1][0],
                                            +C[1]
                                        ]
                                    ]),
                                    A(_)
                                ];
                            };
                        }
                        function d(A) {
                            return function(_, C) {
                                return [
                                    A([
                                        [
                                            +C[0],
                                            +_[0][1],
                                            +_[0][2]
                                        ],
                                        [
                                            +C[1],
                                            +_[1][1],
                                            +_[1][2]
                                        ],
                                        [
                                            +C[2],
                                            +_[2][1],
                                            +_[2][2]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +C[0],
                                            +_[0][2]
                                        ],
                                        [
                                            +_[1][0],
                                            +C[1],
                                            +_[1][2]
                                        ],
                                        [
                                            +_[2][0],
                                            +C[2],
                                            +_[2][2]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +_[0][1],
                                            +C[0]
                                        ],
                                        [
                                            +_[1][0],
                                            +_[1][1],
                                            +C[1]
                                        ],
                                        [
                                            +_[2][0],
                                            +_[2][1],
                                            +C[2]
                                        ]
                                    ]),
                                    A(_)
                                ];
                            };
                        }
                        function v(A) {
                            return function(_, C) {
                                return [
                                    A([
                                        [
                                            +C[0],
                                            +_[0][1],
                                            +_[0][2],
                                            +_[0][3]
                                        ],
                                        [
                                            +C[1],
                                            +_[1][1],
                                            +_[1][2],
                                            +_[1][3]
                                        ],
                                        [
                                            +C[2],
                                            +_[2][1],
                                            +_[2][2],
                                            +_[2][3]
                                        ],
                                        [
                                            +C[3],
                                            +_[3][1],
                                            +_[3][2],
                                            +_[3][3]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +C[0],
                                            +_[0][2],
                                            +_[0][3]
                                        ],
                                        [
                                            +_[1][0],
                                            +C[1],
                                            +_[1][2],
                                            +_[1][3]
                                        ],
                                        [
                                            +_[2][0],
                                            +C[2],
                                            +_[2][2],
                                            +_[2][3]
                                        ],
                                        [
                                            +_[3][0],
                                            +C[3],
                                            +_[3][2],
                                            +_[3][3]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +_[0][1],
                                            +C[0],
                                            +_[0][3]
                                        ],
                                        [
                                            +_[1][0],
                                            +_[1][1],
                                            +C[1],
                                            +_[1][3]
                                        ],
                                        [
                                            +_[2][0],
                                            +_[2][1],
                                            +C[2],
                                            +_[2][3]
                                        ],
                                        [
                                            +_[3][0],
                                            +_[3][1],
                                            +C[3],
                                            +_[3][3]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +_[0][1],
                                            +_[0][2],
                                            +C[0]
                                        ],
                                        [
                                            +_[1][0],
                                            +_[1][1],
                                            +_[1][2],
                                            +C[1]
                                        ],
                                        [
                                            +_[2][0],
                                            +_[2][1],
                                            +_[2][2],
                                            +C[2]
                                        ],
                                        [
                                            +_[3][0],
                                            +_[3][1],
                                            +_[3][2],
                                            +C[3]
                                        ]
                                    ]),
                                    A(_)
                                ];
                            };
                        }
                        function x(A) {
                            return function(_, C) {
                                return [
                                    A([
                                        [
                                            +C[0],
                                            +_[0][1],
                                            +_[0][2],
                                            +_[0][3],
                                            +_[0][4]
                                        ],
                                        [
                                            +C[1],
                                            +_[1][1],
                                            +_[1][2],
                                            +_[1][3],
                                            +_[1][4]
                                        ],
                                        [
                                            +C[2],
                                            +_[2][1],
                                            +_[2][2],
                                            +_[2][3],
                                            +_[2][4]
                                        ],
                                        [
                                            +C[3],
                                            +_[3][1],
                                            +_[3][2],
                                            +_[3][3],
                                            +_[3][4]
                                        ],
                                        [
                                            +C[4],
                                            +_[4][1],
                                            +_[4][2],
                                            +_[4][3],
                                            +_[4][4]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +C[0],
                                            +_[0][2],
                                            +_[0][3],
                                            +_[0][4]
                                        ],
                                        [
                                            +_[1][0],
                                            +C[1],
                                            +_[1][2],
                                            +_[1][3],
                                            +_[1][4]
                                        ],
                                        [
                                            +_[2][0],
                                            +C[2],
                                            +_[2][2],
                                            +_[2][3],
                                            +_[2][4]
                                        ],
                                        [
                                            +_[3][0],
                                            +C[3],
                                            +_[3][2],
                                            +_[3][3],
                                            +_[3][4]
                                        ],
                                        [
                                            +_[4][0],
                                            +C[4],
                                            +_[4][2],
                                            +_[4][3],
                                            +_[4][4]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +_[0][1],
                                            +C[0],
                                            +_[0][3],
                                            +_[0][4]
                                        ],
                                        [
                                            +_[1][0],
                                            +_[1][1],
                                            +C[1],
                                            +_[1][3],
                                            +_[1][4]
                                        ],
                                        [
                                            +_[2][0],
                                            +_[2][1],
                                            +C[2],
                                            +_[2][3],
                                            +_[2][4]
                                        ],
                                        [
                                            +_[3][0],
                                            +_[3][1],
                                            +C[3],
                                            +_[3][3],
                                            +_[3][4]
                                        ],
                                        [
                                            +_[4][0],
                                            +_[4][1],
                                            +C[4],
                                            +_[4][3],
                                            +_[4][4]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +_[0][1],
                                            +_[0][2],
                                            +C[0],
                                            +_[0][4]
                                        ],
                                        [
                                            +_[1][0],
                                            +_[1][1],
                                            +_[1][2],
                                            +C[1],
                                            +_[1][4]
                                        ],
                                        [
                                            +_[2][0],
                                            +_[2][1],
                                            +_[2][2],
                                            +C[2],
                                            +_[2][4]
                                        ],
                                        [
                                            +_[3][0],
                                            +_[3][1],
                                            +_[3][2],
                                            +C[3],
                                            +_[3][4]
                                        ],
                                        [
                                            +_[4][0],
                                            +_[4][1],
                                            +_[4][2],
                                            +C[4],
                                            +_[4][4]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +_[0][1],
                                            +_[0][2],
                                            +_[0][3],
                                            +C[0]
                                        ],
                                        [
                                            +_[1][0],
                                            +_[1][1],
                                            +_[1][2],
                                            +_[1][3],
                                            +C[1]
                                        ],
                                        [
                                            +_[2][0],
                                            +_[2][1],
                                            +_[2][2],
                                            +_[2][3],
                                            +C[2]
                                        ],
                                        [
                                            +_[3][0],
                                            +_[3][1],
                                            +_[3][2],
                                            +_[3][3],
                                            +C[3]
                                        ],
                                        [
                                            +_[4][0],
                                            +_[4][1],
                                            +_[4][2],
                                            +_[4][3],
                                            +C[4]
                                        ]
                                    ]),
                                    A(_)
                                ];
                            };
                        }
                        function b(A) {
                            return function(_, C) {
                                return [
                                    A([
                                        [
                                            +C[0],
                                            +_[0][1],
                                            +_[0][2],
                                            +_[0][3],
                                            +_[0][4],
                                            +_[0][5]
                                        ],
                                        [
                                            +C[1],
                                            +_[1][1],
                                            +_[1][2],
                                            +_[1][3],
                                            +_[1][4],
                                            +_[1][5]
                                        ],
                                        [
                                            +C[2],
                                            +_[2][1],
                                            +_[2][2],
                                            +_[2][3],
                                            +_[2][4],
                                            +_[2][5]
                                        ],
                                        [
                                            +C[3],
                                            +_[3][1],
                                            +_[3][2],
                                            +_[3][3],
                                            +_[3][4],
                                            +_[3][5]
                                        ],
                                        [
                                            +C[4],
                                            +_[4][1],
                                            +_[4][2],
                                            +_[4][3],
                                            +_[4][4],
                                            +_[4][5]
                                        ],
                                        [
                                            +C[5],
                                            +_[5][1],
                                            +_[5][2],
                                            +_[5][3],
                                            +_[5][4],
                                            +_[5][5]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +C[0],
                                            +_[0][2],
                                            +_[0][3],
                                            +_[0][4],
                                            +_[0][5]
                                        ],
                                        [
                                            +_[1][0],
                                            +C[1],
                                            +_[1][2],
                                            +_[1][3],
                                            +_[1][4],
                                            +_[1][5]
                                        ],
                                        [
                                            +_[2][0],
                                            +C[2],
                                            +_[2][2],
                                            +_[2][3],
                                            +_[2][4],
                                            +_[2][5]
                                        ],
                                        [
                                            +_[3][0],
                                            +C[3],
                                            +_[3][2],
                                            +_[3][3],
                                            +_[3][4],
                                            +_[3][5]
                                        ],
                                        [
                                            +_[4][0],
                                            +C[4],
                                            +_[4][2],
                                            +_[4][3],
                                            +_[4][4],
                                            +_[4][5]
                                        ],
                                        [
                                            +_[5][0],
                                            +C[5],
                                            +_[5][2],
                                            +_[5][3],
                                            +_[5][4],
                                            +_[5][5]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +_[0][1],
                                            +C[0],
                                            +_[0][3],
                                            +_[0][4],
                                            +_[0][5]
                                        ],
                                        [
                                            +_[1][0],
                                            +_[1][1],
                                            +C[1],
                                            +_[1][3],
                                            +_[1][4],
                                            +_[1][5]
                                        ],
                                        [
                                            +_[2][0],
                                            +_[2][1],
                                            +C[2],
                                            +_[2][3],
                                            +_[2][4],
                                            +_[2][5]
                                        ],
                                        [
                                            +_[3][0],
                                            +_[3][1],
                                            +C[3],
                                            +_[3][3],
                                            +_[3][4],
                                            +_[3][5]
                                        ],
                                        [
                                            +_[4][0],
                                            +_[4][1],
                                            +C[4],
                                            +_[4][3],
                                            +_[4][4],
                                            +_[4][5]
                                        ],
                                        [
                                            +_[5][0],
                                            +_[5][1],
                                            +C[5],
                                            +_[5][3],
                                            +_[5][4],
                                            +_[5][5]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +_[0][1],
                                            +_[0][2],
                                            +C[0],
                                            +_[0][4],
                                            +_[0][5]
                                        ],
                                        [
                                            +_[1][0],
                                            +_[1][1],
                                            +_[1][2],
                                            +C[1],
                                            +_[1][4],
                                            +_[1][5]
                                        ],
                                        [
                                            +_[2][0],
                                            +_[2][1],
                                            +_[2][2],
                                            +C[2],
                                            +_[2][4],
                                            +_[2][5]
                                        ],
                                        [
                                            +_[3][0],
                                            +_[3][1],
                                            +_[3][2],
                                            +C[3],
                                            +_[3][4],
                                            +_[3][5]
                                        ],
                                        [
                                            +_[4][0],
                                            +_[4][1],
                                            +_[4][2],
                                            +C[4],
                                            +_[4][4],
                                            +_[4][5]
                                        ],
                                        [
                                            +_[5][0],
                                            +_[5][1],
                                            +_[5][2],
                                            +C[5],
                                            +_[5][4],
                                            +_[5][5]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +_[0][1],
                                            +_[0][2],
                                            +_[0][3],
                                            +C[0],
                                            +_[0][5]
                                        ],
                                        [
                                            +_[1][0],
                                            +_[1][1],
                                            +_[1][2],
                                            +_[1][3],
                                            +C[1],
                                            +_[1][5]
                                        ],
                                        [
                                            +_[2][0],
                                            +_[2][1],
                                            +_[2][2],
                                            +_[2][3],
                                            +C[2],
                                            +_[2][5]
                                        ],
                                        [
                                            +_[3][0],
                                            +_[3][1],
                                            +_[3][2],
                                            +_[3][3],
                                            +C[3],
                                            +_[3][5]
                                        ],
                                        [
                                            +_[4][0],
                                            +_[4][1],
                                            +_[4][2],
                                            +_[4][3],
                                            +C[4],
                                            +_[4][5]
                                        ],
                                        [
                                            +_[5][0],
                                            +_[5][1],
                                            +_[5][2],
                                            +_[5][3],
                                            +C[5],
                                            +_[5][5]
                                        ]
                                    ]),
                                    A([
                                        [
                                            +_[0][0],
                                            +_[0][1],
                                            +_[0][2],
                                            +_[0][3],
                                            +_[0][4],
                                            +C[0]
                                        ],
                                        [
                                            +_[1][0],
                                            +_[1][1],
                                            +_[1][2],
                                            +_[1][3],
                                            +_[1][4],
                                            +C[1]
                                        ],
                                        [
                                            +_[2][0],
                                            +_[2][1],
                                            +_[2][2],
                                            +_[2][3],
                                            +_[2][4],
                                            +C[2]
                                        ],
                                        [
                                            +_[3][0],
                                            +_[3][1],
                                            +_[3][2],
                                            +_[3][3],
                                            +_[3][4],
                                            +C[3]
                                        ],
                                        [
                                            +_[4][0],
                                            +_[4][1],
                                            +_[4][2],
                                            +_[4][3],
                                            +_[4][4],
                                            +C[4]
                                        ],
                                        [
                                            +_[5][0],
                                            +_[5][1],
                                            +_[5][2],
                                            +_[5][3],
                                            +_[5][4],
                                            +C[5]
                                        ]
                                    ]),
                                    A(_)
                                ];
                            };
                        }
                        var p = [
                            c,
                            f
                        ];
                        function E(A, L, _, C, M, g, P, T) {
                            return function(q, V) {
                                switch(q.length){
                                    case 0:
                                        return A(q, V);
                                    case 1:
                                        return L(q, V);
                                    case 2:
                                        return _(q, V);
                                    case 3:
                                        return C(q, V);
                                    case 4:
                                        return M(q, V);
                                    case 5:
                                        return g(q, V);
                                }
                                var H = P[q.length];
                                return H || (H = P[q.length] = T(q.length)), H(q, V);
                            };
                        }
                        function k() {
                            for(; p.length < l;)p.push(u(p.length));
                            i.exports = E.apply(void 0, p.concat([
                                p,
                                u
                            ]));
                            for(var A = 0; A < l; ++A)i.exports[A] = p[A];
                        }
                        k();
                    },
                    3250: function(i, a, o) {
                        "use strict";
                        var s = o(5250), l = o(8210), u = o(3012), c = o(8545), f = 5, h = 11102230246251565e-32, d = (3 + 16 * h) * h, v = (7 + 56 * h) * h;
                        function x(g, P, T, F) {
                            return function(V, H, X) {
                                var G = g(g(P(H[1], X[0]), P(-X[1], H[0])), g(P(V[1], H[0]), P(-H[1], V[0]))), N = g(P(V[1], X[0]), P(-X[1], V[0])), W = F(G, N);
                                return W[W.length - 1];
                            };
                        }
                        function b(g, P, T, F) {
                            return function(V, H, X, G) {
                                var N = g(g(T(g(P(X[1], G[0]), P(-G[1], X[0])), H[2]), g(T(g(P(H[1], G[0]), P(-G[1], H[0])), -X[2]), T(g(P(H[1], X[0]), P(-X[1], H[0])), G[2]))), g(T(g(P(H[1], G[0]), P(-G[1], H[0])), V[2]), g(T(g(P(V[1], G[0]), P(-G[1], V[0])), -H[2]), T(g(P(V[1], H[0]), P(-H[1], V[0])), G[2])))), W = g(g(T(g(P(X[1], G[0]), P(-G[1], X[0])), V[2]), g(T(g(P(V[1], G[0]), P(-G[1], V[0])), -X[2]), T(g(P(V[1], X[0]), P(-X[1], V[0])), G[2]))), g(T(g(P(H[1], X[0]), P(-X[1], H[0])), V[2]), g(T(g(P(V[1], X[0]), P(-X[1], V[0])), -H[2]), T(g(P(V[1], H[0]), P(-H[1], V[0])), X[2])))), re = F(N, W);
                                return re[re.length - 1];
                            };
                        }
                        function p(g, P, T, F) {
                            return function(V, H, X, G, N) {
                                var W = g(g(g(T(g(T(g(P(G[1], N[0]), P(-N[1], G[0])), X[2]), g(T(g(P(X[1], N[0]), P(-N[1], X[0])), -G[2]), T(g(P(X[1], G[0]), P(-G[1], X[0])), N[2]))), H[3]), g(T(g(T(g(P(G[1], N[0]), P(-N[1], G[0])), H[2]), g(T(g(P(H[1], N[0]), P(-N[1], H[0])), -G[2]), T(g(P(H[1], G[0]), P(-G[1], H[0])), N[2]))), -X[3]), T(g(T(g(P(X[1], N[0]), P(-N[1], X[0])), H[2]), g(T(g(P(H[1], N[0]), P(-N[1], H[0])), -X[2]), T(g(P(H[1], X[0]), P(-X[1], H[0])), N[2]))), G[3]))), g(T(g(T(g(P(X[1], G[0]), P(-G[1], X[0])), H[2]), g(T(g(P(H[1], G[0]), P(-G[1], H[0])), -X[2]), T(g(P(H[1], X[0]), P(-X[1], H[0])), G[2]))), -N[3]), g(T(g(T(g(P(G[1], N[0]), P(-N[1], G[0])), H[2]), g(T(g(P(H[1], N[0]), P(-N[1], H[0])), -G[2]), T(g(P(H[1], G[0]), P(-G[1], H[0])), N[2]))), V[3]), T(g(T(g(P(G[1], N[0]), P(-N[1], G[0])), V[2]), g(T(g(P(V[1], N[0]), P(-N[1], V[0])), -G[2]), T(g(P(V[1], G[0]), P(-G[1], V[0])), N[2]))), -H[3])))), g(g(T(g(T(g(P(H[1], N[0]), P(-N[1], H[0])), V[2]), g(T(g(P(V[1], N[0]), P(-N[1], V[0])), -H[2]), T(g(P(V[1], H[0]), P(-H[1], V[0])), N[2]))), G[3]), g(T(g(T(g(P(H[1], G[0]), P(-G[1], H[0])), V[2]), g(T(g(P(V[1], G[0]), P(-G[1], V[0])), -H[2]), T(g(P(V[1], H[0]), P(-H[1], V[0])), G[2]))), -N[3]), T(g(T(g(P(X[1], G[0]), P(-G[1], X[0])), H[2]), g(T(g(P(H[1], G[0]), P(-G[1], H[0])), -X[2]), T(g(P(H[1], X[0]), P(-X[1], H[0])), G[2]))), V[3]))), g(T(g(T(g(P(X[1], G[0]), P(-G[1], X[0])), V[2]), g(T(g(P(V[1], G[0]), P(-G[1], V[0])), -X[2]), T(g(P(V[1], X[0]), P(-X[1], V[0])), G[2]))), -H[3]), g(T(g(T(g(P(H[1], G[0]), P(-G[1], H[0])), V[2]), g(T(g(P(V[1], G[0]), P(-G[1], V[0])), -H[2]), T(g(P(V[1], H[0]), P(-H[1], V[0])), G[2]))), X[3]), T(g(T(g(P(H[1], X[0]), P(-X[1], H[0])), V[2]), g(T(g(P(V[1], X[0]), P(-X[1], V[0])), -H[2]), T(g(P(V[1], H[0]), P(-H[1], V[0])), X[2]))), -G[3]))))), re = g(g(g(T(g(T(g(P(G[1], N[0]), P(-N[1], G[0])), X[2]), g(T(g(P(X[1], N[0]), P(-N[1], X[0])), -G[2]), T(g(P(X[1], G[0]), P(-G[1], X[0])), N[2]))), V[3]), T(g(T(g(P(G[1], N[0]), P(-N[1], G[0])), V[2]), g(T(g(P(V[1], N[0]), P(-N[1], V[0])), -G[2]), T(g(P(V[1], G[0]), P(-G[1], V[0])), N[2]))), -X[3])), g(T(g(T(g(P(X[1], N[0]), P(-N[1], X[0])), V[2]), g(T(g(P(V[1], N[0]), P(-N[1], V[0])), -X[2]), T(g(P(V[1], X[0]), P(-X[1], V[0])), N[2]))), G[3]), T(g(T(g(P(X[1], G[0]), P(-G[1], X[0])), V[2]), g(T(g(P(V[1], G[0]), P(-G[1], V[0])), -X[2]), T(g(P(V[1], X[0]), P(-X[1], V[0])), G[2]))), -N[3]))), g(g(T(g(T(g(P(X[1], N[0]), P(-N[1], X[0])), H[2]), g(T(g(P(H[1], N[0]), P(-N[1], H[0])), -X[2]), T(g(P(H[1], X[0]), P(-X[1], H[0])), N[2]))), V[3]), T(g(T(g(P(X[1], N[0]), P(-N[1], X[0])), V[2]), g(T(g(P(V[1], N[0]), P(-N[1], V[0])), -X[2]), T(g(P(V[1], X[0]), P(-X[1], V[0])), N[2]))), -H[3])), g(T(g(T(g(P(H[1], N[0]), P(-N[1], H[0])), V[2]), g(T(g(P(V[1], N[0]), P(-N[1], V[0])), -H[2]), T(g(P(V[1], H[0]), P(-H[1], V[0])), N[2]))), X[3]), T(g(T(g(P(H[1], X[0]), P(-X[1], H[0])), V[2]), g(T(g(P(V[1], X[0]), P(-X[1], V[0])), -H[2]), T(g(P(V[1], H[0]), P(-H[1], V[0])), X[2]))), -N[3])))), ae = F(W, re);
                                return ae[ae.length - 1];
                            };
                        }
                        function E(g) {
                            var P = g === 3 ? x : g === 4 ? b : p;
                            return P(l, s, u, c);
                        }
                        var k = E(3), A = E(4), L = [
                            function() {
                                return 0;
                            },
                            function() {
                                return 0;
                            },
                            function(P, T) {
                                return T[0] - P[0];
                            },
                            function(P, T, F) {
                                var q = (P[1] - F[1]) * (T[0] - F[0]), V = (P[0] - F[0]) * (T[1] - F[1]), H = q - V, X;
                                if (q > 0) {
                                    if (V <= 0) return H;
                                    X = q + V;
                                } else if (q < 0) {
                                    if (V >= 0) return H;
                                    X = -(q + V);
                                } else return H;
                                var G = d * X;
                                return H >= G || H <= -G ? H : k(P, T, F);
                            },
                            function(P, T, F, q) {
                                var V = P[0] - q[0], H = T[0] - q[0], X = F[0] - q[0], G = P[1] - q[1], N = T[1] - q[1], W = F[1] - q[1], re = P[2] - q[2], ae = T[2] - q[2], _e = F[2] - q[2], Me = H * W, ke = X * N, ge = X * G, ie = V * W, Te = V * N, Ee = H * G, Ae = re * (Me - ke) + ae * (ge - ie) + _e * (Te - Ee), ze = (Math.abs(Me) + Math.abs(ke)) * Math.abs(re) + (Math.abs(ge) + Math.abs(ie)) * Math.abs(ae) + (Math.abs(Te) + Math.abs(Ee)) * Math.abs(_e), Ce = v * ze;
                                return Ae > Ce || -Ae > Ce ? Ae : A(P, T, F, q);
                            }
                        ];
                        function _(g) {
                            var P = L[g.length];
                            return P || (P = L[g.length] = E(g.length)), P.apply(void 0, g);
                        }
                        function C(g, P, T, F, q, V, H) {
                            return function(G, N, W, re, ae) {
                                switch(arguments.length){
                                    case 0:
                                    case 1:
                                        return 0;
                                    case 2:
                                        return F(G, N);
                                    case 3:
                                        return q(G, N, W);
                                    case 4:
                                        return V(G, N, W, re);
                                    case 5:
                                        return H(G, N, W, re, ae);
                                }
                                for(var _e = new Array(arguments.length), Me = 0; Me < arguments.length; ++Me)_e[Me] = arguments[Me];
                                return g(_e);
                            };
                        }
                        function M() {
                            for(; L.length <= f;)L.push(E(L.length));
                            i.exports = C.apply(void 0, [
                                _
                            ].concat(L));
                            for(var g = 0; g <= f; ++g)i.exports[g] = L[g];
                        }
                        M();
                    },
                    5382: function(i, a, o) {
                        "use strict";
                        var s = o(8210), l = o(3012);
                        i.exports = u;
                        function u(c, f) {
                            if (c.length === 1) return l(f, c[0]);
                            if (f.length === 1) return l(c, f[0]);
                            if (c.length === 0 || f.length === 0) return [
                                0
                            ];
                            var h = [
                                0
                            ];
                            if (c.length < f.length) for(var d = 0; d < c.length; ++d)h = s(h, l(f, c[d]));
                            else for(var d = 0; d < f.length; ++d)h = s(h, l(c, f[d]));
                            return h;
                        }
                    },
                    3012: function(i, a, o) {
                        "use strict";
                        var s = o(5250), l = o(9362);
                        i.exports = u;
                        function u(c, f) {
                            var h = c.length;
                            if (h === 1) {
                                var d = s(c[0], f);
                                return d[0] ? d : [
                                    d[1]
                                ];
                            }
                            var v = new Array(2 * h), x = [
                                .1,
                                .1
                            ], b = [
                                .1,
                                .1
                            ], p = 0;
                            s(c[0], f, x), x[0] && (v[p++] = x[0]);
                            for(var E = 1; E < h; ++E){
                                s(c[E], f, b);
                                var k = x[1];
                                l(k, b[0], x), x[0] && (v[p++] = x[0]);
                                var A = b[1], L = x[1], _ = A + L, C = _ - A, M = L - C;
                                x[1] = _, M && (v[p++] = M);
                            }
                            return x[1] && (v[p++] = x[1]), p === 0 && (v[p++] = 0), v.length = p, v;
                        }
                    },
                    1125: function(i, a, o) {
                        "use strict";
                        i.exports = u;
                        var s = o(3250)[3];
                        function l(c, f, h, d) {
                            for(var v = 0; v < 2; ++v){
                                var x = c[v], b = f[v], p = Math.min(x, b), E = Math.max(x, b), k = h[v], A = d[v], L = Math.min(k, A), _ = Math.max(k, A);
                                if (_ < p || E < L) return !1;
                            }
                            return !0;
                        }
                        function u(c, f, h, d) {
                            var v = s(c, h, d), x = s(f, h, d);
                            if (v > 0 && x > 0 || v < 0 && x < 0) return !1;
                            var b = s(h, c, f), p = s(d, c, f);
                            return b > 0 && p > 0 || b < 0 && p < 0 ? !1 : v === 0 && x === 0 && b === 0 && p === 0 ? l(c, f, h, d) : !0;
                        }
                    },
                    8545: function(i) {
                        "use strict";
                        i.exports = o;
                        function a(s, l) {
                            var u = s + l, c = u - s, f = u - c, h = l - c, d = s - f, v = d + h;
                            return v ? [
                                v,
                                u
                            ] : [
                                u
                            ];
                        }
                        function o(s, l) {
                            var u = s.length | 0, c = l.length | 0;
                            if (u === 1 && c === 1) return a(s[0], -l[0]);
                            var f = u + c, h = new Array(f), d = 0, v = 0, x = 0, b = Math.abs, p = s[v], E = b(p), k = -l[x], A = b(k), L, _;
                            E < A ? (_ = p, v += 1, v < u && (p = s[v], E = b(p))) : (_ = k, x += 1, x < c && (k = -l[x], A = b(k))), v < u && E < A || x >= c ? (L = p, v += 1, v < u && (p = s[v], E = b(p))) : (L = k, x += 1, x < c && (k = -l[x], A = b(k)));
                            for(var C = L + _, M = C - L, g = _ - M, P = g, T = C, F, q, V, H, X; v < u && x < c;)E < A ? (L = p, v += 1, v < u && (p = s[v], E = b(p))) : (L = k, x += 1, x < c && (k = -l[x], A = b(k))), _ = P, C = L + _, M = C - L, g = _ - M, g && (h[d++] = g), F = T + C, q = F - T, V = F - q, H = C - q, X = T - V, P = X + H, T = F;
                            for(; v < u;)L = p, _ = P, C = L + _, M = C - L, g = _ - M, g && (h[d++] = g), F = T + C, q = F - T, V = F - q, H = C - q, X = T - V, P = X + H, T = F, v += 1, v < u && (p = s[v]);
                            for(; x < c;)L = k, _ = P, C = L + _, M = C - L, g = _ - M, g && (h[d++] = g), F = T + C, q = F - T, V = F - q, H = C - q, X = T - V, P = X + H, T = F, x += 1, x < c && (k = -l[x]);
                            return P && (h[d++] = P), T && (h[d++] = T), d || (h[d++] = 0), h.length = d, h;
                        }
                    },
                    8210: function(i) {
                        "use strict";
                        i.exports = o;
                        function a(s, l) {
                            var u = s + l, c = u - s, f = u - c, h = l - c, d = s - f, v = d + h;
                            return v ? [
                                v,
                                u
                            ] : [
                                u
                            ];
                        }
                        function o(s, l) {
                            var u = s.length | 0, c = l.length | 0;
                            if (u === 1 && c === 1) return a(s[0], l[0]);
                            var f = u + c, h = new Array(f), d = 0, v = 0, x = 0, b = Math.abs, p = s[v], E = b(p), k = l[x], A = b(k), L, _;
                            E < A ? (_ = p, v += 1, v < u && (p = s[v], E = b(p))) : (_ = k, x += 1, x < c && (k = l[x], A = b(k))), v < u && E < A || x >= c ? (L = p, v += 1, v < u && (p = s[v], E = b(p))) : (L = k, x += 1, x < c && (k = l[x], A = b(k)));
                            for(var C = L + _, M = C - L, g = _ - M, P = g, T = C, F, q, V, H, X; v < u && x < c;)E < A ? (L = p, v += 1, v < u && (p = s[v], E = b(p))) : (L = k, x += 1, x < c && (k = l[x], A = b(k))), _ = P, C = L + _, M = C - L, g = _ - M, g && (h[d++] = g), F = T + C, q = F - T, V = F - q, H = C - q, X = T - V, P = X + H, T = F;
                            for(; v < u;)L = p, _ = P, C = L + _, M = C - L, g = _ - M, g && (h[d++] = g), F = T + C, q = F - T, V = F - q, H = C - q, X = T - V, P = X + H, T = F, v += 1, v < u && (p = s[v]);
                            for(; x < c;)L = k, _ = P, C = L + _, M = C - L, g = _ - M, g && (h[d++] = g), F = T + C, q = F - T, V = F - q, H = C - q, X = T - V, P = X + H, T = F, x += 1, x < c && (k = l[x]);
                            return P && (h[d++] = P), T && (h[d++] = T), d || (h[d++] = 0), h.length = d, h;
                        }
                    },
                    9127: function(i, a, o) {
                        "use strict";
                        i.exports = u;
                        var s = o(6204), l = o(5771);
                        function u(c) {
                            return l(s(c));
                        }
                    },
                    7765: function(i, a, o) {
                        "use strict";
                        i.exports = p;
                        var s = o(9618), l = o(1888), u = o(446), c = o(1570);
                        function f(E) {
                            for(var k = E.length, A = 0, L = 0; L < k; ++L)A = Math.max(A, E[L].length) | 0;
                            return A - 1;
                        }
                        function h(E, k) {
                            for(var A = E.length, L = l.mallocUint8(A), _ = 0; _ < A; ++_)L[_] = E[_] < k | 0;
                            return L;
                        }
                        function d(E, k) {
                            for(var A = E.length, L = k * (k + 1) / 2 * A | 0, _ = l.mallocUint32(L * 2), C = 0, M = 0; M < A; ++M)for(var g = E[M], k = g.length, P = 0; P < k; ++P)for(var T = 0; T < P; ++T){
                                var F = g[T], q = g[P];
                                _[C++] = Math.min(F, q) | 0, _[C++] = Math.max(F, q) | 0;
                            }
                            var V = C / 2 | 0;
                            u(s(_, [
                                V,
                                2
                            ]));
                            for(var H = 2, M = 2; M < C; M += 2)_[M - 2] === _[M] && _[M - 1] === _[M + 1] || (_[H++] = _[M], _[H++] = _[M + 1]);
                            return s(_, [
                                H / 2 | 0,
                                2
                            ]);
                        }
                        function v(E, k, A, L) {
                            for(var _ = E.data, C = E.shape[0], M = l.mallocDouble(C), g = 0, P = 0; P < C; ++P){
                                var T = _[2 * P], F = _[2 * P + 1];
                                if (A[T] !== A[F]) {
                                    var q = k[T], V = k[F];
                                    _[2 * g] = T, _[2 * g + 1] = F, M[g++] = (V - L) / (V - q);
                                }
                            }
                            return E.shape[0] = g, s(M, [
                                g
                            ]);
                        }
                        function x(E, k) {
                            var A = l.mallocInt32(k * 2), L = E.shape[0], _ = E.data;
                            A[0] = 0;
                            for(var C = 0, M = 0; M < L; ++M){
                                var g = _[2 * M];
                                if (g !== C) {
                                    for(A[2 * C + 1] = M; ++C < g;)A[2 * C] = M, A[2 * C + 1] = M;
                                    A[2 * C] = M;
                                }
                            }
                            for(A[2 * C + 1] = L; ++C < k;)A[2 * C] = A[2 * C + 1] = L;
                            return A;
                        }
                        function b(E) {
                            for(var k = E.shape[0] | 0, A = E.data, L = new Array(k), _ = 0; _ < k; ++_)L[_] = [
                                A[2 * _],
                                A[2 * _ + 1]
                            ];
                            return L;
                        }
                        function p(E, k, A, L) {
                            A = A || 0, typeof L == "undefined" && (L = f(E));
                            var _ = E.length;
                            if (_ === 0 || L < 1) return {
                                cells: [],
                                vertexIds: [],
                                vertexWeights: []
                            };
                            var C = h(k, +A), M = d(E, L), g = v(M, k, C, +A), P = x(M, k.length | 0), T = c(L)(E, M.data, P, C), F = b(M), q = [].slice.call(g.data, 0, g.shape[0]);
                            return l.free(C), l.free(M.data), l.free(g.data), l.free(P), {
                                cells: T,
                                vertexIds: F,
                                vertexWeights: q
                            };
                        }
                    },
                    1570: function(i) {
                        "use strict";
                        i.exports = o;
                        var a = [
                            function() {
                                function l(c, f, h, d) {
                                    for(var v = Math.min(h, d) | 0, x = Math.max(h, d) | 0, b = c[2 * v], p = c[2 * v + 1]; b < p;){
                                        var E = b + p >> 1, k = f[2 * E + 1];
                                        if (k === x) return E;
                                        x < k ? p = E : b = E + 1;
                                    }
                                    return b;
                                }
                                function u(c, f, h, d) {
                                    for(var v = c.length, x = [], b = 0; b < v; ++b)var p = c[b], E = p.length;
                                    return x;
                                }
                                return u;
                            },
                            function() {
                                function l(c, f, h, d) {
                                    for(var v = Math.min(h, d) | 0, x = Math.max(h, d) | 0, b = c[2 * v], p = c[2 * v + 1]; b < p;){
                                        var E = b + p >> 1, k = f[2 * E + 1];
                                        if (k === x) return E;
                                        x < k ? p = E : b = E + 1;
                                    }
                                    return b;
                                }
                                function u(c, f, h, d) {
                                    for(var v = c.length, x = [], b = 0; b < v; ++b){
                                        var p = c[b], E = p.length;
                                        if (E === 2) {
                                            var k = (d[p[0]] << 0) + (d[p[1]] << 1);
                                            if (k === 0 || k === 3) continue;
                                            switch(k){
                                                case 0:
                                                    break;
                                                case 1:
                                                    x.push([
                                                        l(h, f, p[0], p[1])
                                                    ]);
                                                    break;
                                                case 2:
                                                    x.push([
                                                        l(h, f, p[1], p[0])
                                                    ]);
                                                    break;
                                                case 3:
                                                    break;
                                            }
                                        }
                                    }
                                    return x;
                                }
                                return u;
                            },
                            function() {
                                function l(c, f, h, d) {
                                    for(var v = Math.min(h, d) | 0, x = Math.max(h, d) | 0, b = c[2 * v], p = c[2 * v + 1]; b < p;){
                                        var E = b + p >> 1, k = f[2 * E + 1];
                                        if (k === x) return E;
                                        x < k ? p = E : b = E + 1;
                                    }
                                    return b;
                                }
                                function u(c, f, h, d) {
                                    for(var v = c.length, x = [], b = 0; b < v; ++b){
                                        var p = c[b], E = p.length;
                                        if (E === 3) {
                                            var k = (d[p[0]] << 0) + (d[p[1]] << 1) + (d[p[2]] << 2);
                                            if (k === 0 || k === 7) continue;
                                            switch(k){
                                                case 0:
                                                    break;
                                                case 1:
                                                    x.push([
                                                        l(h, f, p[0], p[2]),
                                                        l(h, f, p[0], p[1])
                                                    ]);
                                                    break;
                                                case 2:
                                                    x.push([
                                                        l(h, f, p[1], p[0]),
                                                        l(h, f, p[1], p[2])
                                                    ]);
                                                    break;
                                                case 3:
                                                    x.push([
                                                        l(h, f, p[0], p[2]),
                                                        l(h, f, p[1], p[2])
                                                    ]);
                                                    break;
                                                case 4:
                                                    x.push([
                                                        l(h, f, p[2], p[1]),
                                                        l(h, f, p[2], p[0])
                                                    ]);
                                                    break;
                                                case 5:
                                                    x.push([
                                                        l(h, f, p[2], p[1]),
                                                        l(h, f, p[0], p[1])
                                                    ]);
                                                    break;
                                                case 6:
                                                    x.push([
                                                        l(h, f, p[1], p[0]),
                                                        l(h, f, p[2], p[0])
                                                    ]);
                                                    break;
                                                case 7:
                                                    break;
                                            }
                                        } else if (E === 2) {
                                            var k = (d[p[0]] << 0) + (d[p[1]] << 1);
                                            if (k === 0 || k === 3) continue;
                                            switch(k){
                                                case 0:
                                                    break;
                                                case 1:
                                                    x.push([
                                                        l(h, f, p[0], p[1])
                                                    ]);
                                                    break;
                                                case 2:
                                                    x.push([
                                                        l(h, f, p[1], p[0])
                                                    ]);
                                                    break;
                                                case 3:
                                                    break;
                                            }
                                        }
                                    }
                                    return x;
                                }
                                return u;
                            },
                            function() {
                                function l(c, f, h, d) {
                                    for(var v = Math.min(h, d) | 0, x = Math.max(h, d) | 0, b = c[2 * v], p = c[2 * v + 1]; b < p;){
                                        var E = b + p >> 1, k = f[2 * E + 1];
                                        if (k === x) return E;
                                        x < k ? p = E : b = E + 1;
                                    }
                                    return b;
                                }
                                function u(c, f, h, d) {
                                    for(var v = c.length, x = [], b = 0; b < v; ++b){
                                        var p = c[b], E = p.length;
                                        if (E === 4) {
                                            var k = (d[p[0]] << 0) + (d[p[1]] << 1) + (d[p[2]] << 2) + (d[p[3]] << 3);
                                            if (k === 0 || k === 15) continue;
                                            switch(k){
                                                case 0:
                                                    break;
                                                case 1:
                                                    x.push([
                                                        l(h, f, p[0], p[1]),
                                                        l(h, f, p[0], p[2]),
                                                        l(h, f, p[0], p[3])
                                                    ]);
                                                    break;
                                                case 2:
                                                    x.push([
                                                        l(h, f, p[1], p[2]),
                                                        l(h, f, p[1], p[0]),
                                                        l(h, f, p[1], p[3])
                                                    ]);
                                                    break;
                                                case 3:
                                                    x.push([
                                                        l(h, f, p[1], p[2]),
                                                        l(h, f, p[0], p[2]),
                                                        l(h, f, p[0], p[3])
                                                    ], [
                                                        l(h, f, p[1], p[3]),
                                                        l(h, f, p[1], p[2]),
                                                        l(h, f, p[0], p[3])
                                                    ]);
                                                    break;
                                                case 4:
                                                    x.push([
                                                        l(h, f, p[2], p[0]),
                                                        l(h, f, p[2], p[1]),
                                                        l(h, f, p[2], p[3])
                                                    ]);
                                                    break;
                                                case 5:
                                                    x.push([
                                                        l(h, f, p[0], p[1]),
                                                        l(h, f, p[2], p[1]),
                                                        l(h, f, p[0], p[3])
                                                    ], [
                                                        l(h, f, p[2], p[1]),
                                                        l(h, f, p[2], p[3]),
                                                        l(h, f, p[0], p[3])
                                                    ]);
                                                    break;
                                                case 6:
                                                    x.push([
                                                        l(h, f, p[2], p[0]),
                                                        l(h, f, p[1], p[0]),
                                                        l(h, f, p[1], p[3])
                                                    ], [
                                                        l(h, f, p[2], p[3]),
                                                        l(h, f, p[2], p[0]),
                                                        l(h, f, p[1], p[3])
                                                    ]);
                                                    break;
                                                case 7:
                                                    x.push([
                                                        l(h, f, p[0], p[3]),
                                                        l(h, f, p[1], p[3]),
                                                        l(h, f, p[2], p[3])
                                                    ]);
                                                    break;
                                                case 8:
                                                    x.push([
                                                        l(h, f, p[3], p[1]),
                                                        l(h, f, p[3], p[0]),
                                                        l(h, f, p[3], p[2])
                                                    ]);
                                                    break;
                                                case 9:
                                                    x.push([
                                                        l(h, f, p[3], p[1]),
                                                        l(h, f, p[0], p[1]),
                                                        l(h, f, p[0], p[2])
                                                    ], [
                                                        l(h, f, p[3], p[2]),
                                                        l(h, f, p[3], p[1]),
                                                        l(h, f, p[0], p[2])
                                                    ]);
                                                    break;
                                                case 10:
                                                    x.push([
                                                        l(h, f, p[1], p[0]),
                                                        l(h, f, p[3], p[0]),
                                                        l(h, f, p[1], p[2])
                                                    ], [
                                                        l(h, f, p[3], p[0]),
                                                        l(h, f, p[3], p[2]),
                                                        l(h, f, p[1], p[2])
                                                    ]);
                                                    break;
                                                case 11:
                                                    x.push([
                                                        l(h, f, p[1], p[2]),
                                                        l(h, f, p[0], p[2]),
                                                        l(h, f, p[3], p[2])
                                                    ]);
                                                    break;
                                                case 12:
                                                    x.push([
                                                        l(h, f, p[3], p[0]),
                                                        l(h, f, p[2], p[0]),
                                                        l(h, f, p[2], p[1])
                                                    ], [
                                                        l(h, f, p[3], p[1]),
                                                        l(h, f, p[3], p[0]),
                                                        l(h, f, p[2], p[1])
                                                    ]);
                                                    break;
                                                case 13:
                                                    x.push([
                                                        l(h, f, p[0], p[1]),
                                                        l(h, f, p[2], p[1]),
                                                        l(h, f, p[3], p[1])
                                                    ]);
                                                    break;
                                                case 14:
                                                    x.push([
                                                        l(h, f, p[2], p[0]),
                                                        l(h, f, p[1], p[0]),
                                                        l(h, f, p[3], p[0])
                                                    ]);
                                                    break;
                                                case 15:
                                                    break;
                                            }
                                        } else if (E === 3) {
                                            var k = (d[p[0]] << 0) + (d[p[1]] << 1) + (d[p[2]] << 2);
                                            if (k === 0 || k === 7) continue;
                                            switch(k){
                                                case 0:
                                                    break;
                                                case 1:
                                                    x.push([
                                                        l(h, f, p[0], p[2]),
                                                        l(h, f, p[0], p[1])
                                                    ]);
                                                    break;
                                                case 2:
                                                    x.push([
                                                        l(h, f, p[1], p[0]),
                                                        l(h, f, p[1], p[2])
                                                    ]);
                                                    break;
                                                case 3:
                                                    x.push([
                                                        l(h, f, p[0], p[2]),
                                                        l(h, f, p[1], p[2])
                                                    ]);
                                                    break;
                                                case 4:
                                                    x.push([
                                                        l(h, f, p[2], p[1]),
                                                        l(h, f, p[2], p[0])
                                                    ]);
                                                    break;
                                                case 5:
                                                    x.push([
                                                        l(h, f, p[2], p[1]),
                                                        l(h, f, p[0], p[1])
                                                    ]);
                                                    break;
                                                case 6:
                                                    x.push([
                                                        l(h, f, p[1], p[0]),
                                                        l(h, f, p[2], p[0])
                                                    ]);
                                                    break;
                                                case 7:
                                                    break;
                                            }
                                        } else if (E === 2) {
                                            var k = (d[p[0]] << 0) + (d[p[1]] << 1);
                                            if (k === 0 || k === 3) continue;
                                            switch(k){
                                                case 0:
                                                    break;
                                                case 1:
                                                    x.push([
                                                        l(h, f, p[0], p[1])
                                                    ]);
                                                    break;
                                                case 2:
                                                    x.push([
                                                        l(h, f, p[1], p[0])
                                                    ]);
                                                    break;
                                                case 3:
                                                    break;
                                            }
                                        }
                                    }
                                    return x;
                                }
                                return u;
                            }
                        ];
                        function o(s) {
                            return a[s]();
                        }
                    },
                    6803: function(i, a, o) {
                        "use strict";
                        var s, l = o(8828), u = o(1755);
                        function c(P) {
                            for(var T = 0, F = Math.max, q = 0, V = P.length; q < V; ++q)T = F(T, P[q].length);
                            return T - 1;
                        }
                        s = c;
                        function f(P) {
                            for(var T = -1, F = Math.max, q = 0, V = P.length; q < V; ++q)for(var H = P[q], X = 0, G = H.length; X < G; ++X)T = F(T, H[X]);
                            return T + 1;
                        }
                        s = f;
                        function h(P) {
                            for(var T = new Array(P.length), F = 0, q = P.length; F < q; ++F)T[F] = P[F].slice(0);
                            return T;
                        }
                        s = h;
                        function d(P, T) {
                            var F = P.length, q = P.length - T.length, V = Math.min;
                            if (q) return q;
                            switch(F){
                                case 0:
                                    return 0;
                                case 1:
                                    return P[0] - T[0];
                                case 2:
                                    var W = P[0] + P[1] - T[0] - T[1];
                                    return W || V(P[0], P[1]) - V(T[0], T[1]);
                                case 3:
                                    var H = P[0] + P[1], X = T[0] + T[1];
                                    if (W = H + P[2] - (X + T[2]), W) return W;
                                    var G = V(P[0], P[1]), N = V(T[0], T[1]), W = V(G, P[2]) - V(N, T[2]);
                                    return W || V(G + P[2], H) - V(N + T[2], X);
                                default:
                                    var re = P.slice(0);
                                    re.sort();
                                    var ae = T.slice(0);
                                    ae.sort();
                                    for(var _e = 0; _e < F; ++_e)if (q = re[_e] - ae[_e], q) return q;
                                    return 0;
                            }
                        }
                        a.Fw = d;
                        function v(P, T) {
                            return d(P[0], T[0]);
                        }
                        function x(P, T) {
                            if (T) {
                                for(var F = P.length, q = new Array(F), V = 0; V < F; ++V)q[V] = [
                                    P[V],
                                    T[V]
                                ];
                                q.sort(v);
                                for(var V = 0; V < F; ++V)P[V] = q[V][0], T[V] = q[V][1];
                                return P;
                            } else return P.sort(d), P;
                        }
                        s = x;
                        function b(P) {
                            if (P.length === 0) return [];
                            for(var T = 1, F = P.length, q = 1; q < F; ++q){
                                var V = P[q];
                                if (d(V, P[q - 1])) {
                                    if (q === T) {
                                        T++;
                                        continue;
                                    }
                                    P[T++] = V;
                                }
                            }
                            return P.length = T, P;
                        }
                        s = b;
                        function p(P, T) {
                            for(var F = 0, q = P.length - 1, V = -1; F <= q;){
                                var H = F + q >> 1, X = d(P[H], T);
                                X <= 0 ? (X === 0 && (V = H), F = H + 1) : X > 0 && (q = H - 1);
                            }
                            return V;
                        }
                        s = p;
                        function E(P, T) {
                            for(var F = new Array(P.length), q = 0, V = F.length; q < V; ++q)F[q] = [];
                            for(var H = [], q = 0, X = T.length; q < X; ++q)for(var G = T[q], N = G.length, W = 1, re = 1 << N; W < re; ++W){
                                H.length = l.popCount(W);
                                for(var ae = 0, _e = 0; _e < N; ++_e)W & 1 << _e && (H[ae++] = G[_e]);
                                var Me = p(P, H);
                                if (!(Me < 0)) for(; F[Me++].push(q), !(Me >= P.length || d(P[Me], H) !== 0););
                            }
                            return F;
                        }
                        s = E;
                        function k(P, T) {
                            if (!T) return E(b(L(P, 0)), P, 0);
                            for(var F = new Array(T), q = 0; q < T; ++q)F[q] = [];
                            for(var q = 0, V = P.length; q < V; ++q)for(var H = P[q], X = 0, G = H.length; X < G; ++X)F[H[X]].push(q);
                            return F;
                        }
                        s = k;
                        function A(P) {
                            for(var T = [], F = 0, q = P.length; F < q; ++F)for(var V = P[F], H = V.length | 0, X = 1, G = 1 << H; X < G; ++X){
                                for(var N = [], W = 0; W < H; ++W)X >>> W & 1 && N.push(V[W]);
                                T.push(N);
                            }
                            return x(T);
                        }
                        s = A;
                        function L(P, T) {
                            if (T < 0) return [];
                            for(var F = [], q = (1 << T + 1) - 1, V = 0; V < P.length; ++V)for(var H = P[V], X = q; X < 1 << H.length; X = l.nextCombination(X)){
                                for(var G = new Array(T + 1), N = 0, W = 0; W < H.length; ++W)X & 1 << W && (G[N++] = H[W]);
                                F.push(G);
                            }
                            return x(F);
                        }
                        s = L;
                        function _(P) {
                            for(var T = [], F = 0, q = P.length; F < q; ++F)for(var V = P[F], H = 0, X = V.length; H < X; ++H){
                                for(var G = new Array(V.length - 1), N = 0, W = 0; N < X; ++N)N !== H && (G[W++] = V[N]);
                                T.push(G);
                            }
                            return x(T);
                        }
                        s = _;
                        function C(P, T) {
                            for(var F = new u(T), q = 0; q < P.length; ++q)for(var V = P[q], H = 0; H < V.length; ++H)for(var X = H + 1; X < V.length; ++X)F.link(V[H], V[X]);
                            for(var G = [], N = F.ranks, q = 0; q < N.length; ++q)N[q] = -1;
                            for(var q = 0; q < P.length; ++q){
                                var W = F.find(P[q][0]);
                                N[W] < 0 ? (N[W] = G.length, G.push([
                                    P[q].slice(0)
                                ])) : G[N[W]].push(P[q].slice(0));
                            }
                            return G;
                        }
                        function M(P) {
                            for(var T = b(x(L(P, 0))), F = new u(T.length), q = 0; q < P.length; ++q)for(var V = P[q], H = 0; H < V.length; ++H)for(var X = p(T, [
                                V[H]
                            ]), G = H + 1; G < V.length; ++G)F.link(X, p(T, [
                                V[G]
                            ]));
                            for(var N = [], W = F.ranks, q = 0; q < W.length; ++q)W[q] = -1;
                            for(var q = 0; q < P.length; ++q){
                                var re = F.find(p(T, [
                                    P[q][0]
                                ]));
                                W[re] < 0 ? (W[re] = N.length, N.push([
                                    P[q].slice(0)
                                ])) : N[W[re]].push(P[q].slice(0));
                            }
                            return N;
                        }
                        function g(P, T) {
                            return T ? C(P, T) : M(P);
                        }
                        s = g;
                    },
                    3105: function(i, a) {
                        "use strict";
                        "use restrict";
                        var o = 32;
                        a.INT_BITS = o, a.INT_MAX = 2147483647, a.INT_MIN = -1 << o - 1, a.sign = function(u) {
                            return (u > 0) - (u < 0);
                        }, a.abs = function(u) {
                            var c = u >> o - 1;
                            return (u ^ c) - c;
                        }, a.min = function(u, c) {
                            return c ^ (u ^ c) & -(u < c);
                        }, a.max = function(u, c) {
                            return u ^ (u ^ c) & -(u < c);
                        }, a.isPow2 = function(u) {
                            return !(u & u - 1) && !!u;
                        }, a.log2 = function(u) {
                            var c, f;
                            return c = (u > 65535) << 4, u >>>= c, f = (u > 255) << 3, u >>>= f, c |= f, f = (u > 15) << 2, u >>>= f, c |= f, f = (u > 3) << 1, u >>>= f, c |= f, c | u >> 1;
                        }, a.log10 = function(u) {
                            return u >= 1e9 ? 9 : u >= 1e8 ? 8 : u >= 1e7 ? 7 : u >= 1e6 ? 6 : u >= 1e5 ? 5 : u >= 1e4 ? 4 : u >= 1e3 ? 3 : u >= 100 ? 2 : u >= 10 ? 1 : 0;
                        }, a.popCount = function(u) {
                            return u = u - (u >>> 1 & 1431655765), u = (u & 858993459) + (u >>> 2 & 858993459), (u + (u >>> 4) & 252645135) * 16843009 >>> 24;
                        };
                        function s(u) {
                            var c = 32;
                            return u &= -u, u && c--, u & 65535 && (c -= 16), u & 16711935 && (c -= 8), u & 252645135 && (c -= 4), u & 858993459 && (c -= 2), u & 1431655765 && (c -= 1), c;
                        }
                        a.countTrailingZeros = s, a.nextPow2 = function(u) {
                            return u += u === 0, --u, u |= u >>> 1, u |= u >>> 2, u |= u >>> 4, u |= u >>> 8, u |= u >>> 16, u + 1;
                        }, a.prevPow2 = function(u) {
                            return u |= u >>> 1, u |= u >>> 2, u |= u >>> 4, u |= u >>> 8, u |= u >>> 16, u - (u >>> 1);
                        }, a.parity = function(u) {
                            return u ^= u >>> 16, u ^= u >>> 8, u ^= u >>> 4, u &= 15, 27030 >>> u & 1;
                        };
                        var l = new Array(256);
                        (function(u) {
                            for(var c = 0; c < 256; ++c){
                                var f = c, h = c, d = 7;
                                for(f >>>= 1; f; f >>>= 1)h <<= 1, h |= f & 1, --d;
                                u[c] = h << d & 255;
                            }
                        })(l), a.reverse = function(u) {
                            return l[u & 255] << 24 | l[u >>> 8 & 255] << 16 | l[u >>> 16 & 255] << 8 | l[u >>> 24 & 255];
                        }, a.interleave2 = function(u, c) {
                            return u &= 65535, u = (u | u << 8) & 16711935, u = (u | u << 4) & 252645135, u = (u | u << 2) & 858993459, u = (u | u << 1) & 1431655765, c &= 65535, c = (c | c << 8) & 16711935, c = (c | c << 4) & 252645135, c = (c | c << 2) & 858993459, c = (c | c << 1) & 1431655765, u | c << 1;
                        }, a.deinterleave2 = function(u, c) {
                            return u = u >>> c & 1431655765, u = (u | u >>> 1) & 858993459, u = (u | u >>> 2) & 252645135, u = (u | u >>> 4) & 16711935, u = (u | u >>> 16) & 65535, u << 16 >> 16;
                        }, a.interleave3 = function(u, c, f) {
                            return u &= 1023, u = (u | u << 16) & 4278190335, u = (u | u << 8) & 251719695, u = (u | u << 4) & 3272356035, u = (u | u << 2) & 1227133513, c &= 1023, c = (c | c << 16) & 4278190335, c = (c | c << 8) & 251719695, c = (c | c << 4) & 3272356035, c = (c | c << 2) & 1227133513, u |= c << 1, f &= 1023, f = (f | f << 16) & 4278190335, f = (f | f << 8) & 251719695, f = (f | f << 4) & 3272356035, f = (f | f << 2) & 1227133513, u | f << 2;
                        }, a.deinterleave3 = function(u, c) {
                            return u = u >>> c & 1227133513, u = (u | u >>> 2) & 3272356035, u = (u | u >>> 4) & 251719695, u = (u | u >>> 8) & 4278190335, u = (u | u >>> 16) & 1023, u << 22 >> 22;
                        }, a.nextCombination = function(u) {
                            var c = u | u - 1;
                            return c + 1 | (~c & -~c) - 1 >>> s(u) + 1;
                        };
                    },
                    2014: function(i, a, o) {
                        "use strict";
                        "use restrict";
                        var s = o(3105), l = o(4623);
                        function u(g) {
                            for(var P = 0, T = Math.max, F = 0, q = g.length; F < q; ++F)P = T(P, g[F].length);
                            return P - 1;
                        }
                        a.dimension = u;
                        function c(g) {
                            for(var P = -1, T = Math.max, F = 0, q = g.length; F < q; ++F)for(var V = g[F], H = 0, X = V.length; H < X; ++H)P = T(P, V[H]);
                            return P + 1;
                        }
                        a.countVertices = c;
                        function f(g) {
                            for(var P = new Array(g.length), T = 0, F = g.length; T < F; ++T)P[T] = g[T].slice(0);
                            return P;
                        }
                        a.cloneCells = f;
                        function h(g, P) {
                            var T = g.length, F = g.length - P.length, q = Math.min;
                            if (F) return F;
                            switch(T){
                                case 0:
                                    return 0;
                                case 1:
                                    return g[0] - P[0];
                                case 2:
                                    var N = g[0] + g[1] - P[0] - P[1];
                                    return N || q(g[0], g[1]) - q(P[0], P[1]);
                                case 3:
                                    var V = g[0] + g[1], H = P[0] + P[1];
                                    if (N = V + g[2] - (H + P[2]), N) return N;
                                    var X = q(g[0], g[1]), G = q(P[0], P[1]), N = q(X, g[2]) - q(G, P[2]);
                                    return N || q(X + g[2], V) - q(G + P[2], H);
                                default:
                                    var W = g.slice(0);
                                    W.sort();
                                    var re = P.slice(0);
                                    re.sort();
                                    for(var ae = 0; ae < T; ++ae)if (F = W[ae] - re[ae], F) return F;
                                    return 0;
                            }
                        }
                        a.compareCells = h;
                        function d(g, P) {
                            return h(g[0], P[0]);
                        }
                        function v(g, P) {
                            if (P) {
                                for(var T = g.length, F = new Array(T), q = 0; q < T; ++q)F[q] = [
                                    g[q],
                                    P[q]
                                ];
                                F.sort(d);
                                for(var q = 0; q < T; ++q)g[q] = F[q][0], P[q] = F[q][1];
                                return g;
                            } else return g.sort(h), g;
                        }
                        a.normalize = v;
                        function x(g) {
                            if (g.length === 0) return [];
                            for(var P = 1, T = g.length, F = 1; F < T; ++F){
                                var q = g[F];
                                if (h(q, g[F - 1])) {
                                    if (F === P) {
                                        P++;
                                        continue;
                                    }
                                    g[P++] = q;
                                }
                            }
                            return g.length = P, g;
                        }
                        a.unique = x;
                        function b(g, P) {
                            for(var T = 0, F = g.length - 1, q = -1; T <= F;){
                                var V = T + F >> 1, H = h(g[V], P);
                                H <= 0 ? (H === 0 && (q = V), T = V + 1) : H > 0 && (F = V - 1);
                            }
                            return q;
                        }
                        a.findCell = b;
                        function p(g, P) {
                            for(var T = new Array(g.length), F = 0, q = T.length; F < q; ++F)T[F] = [];
                            for(var V = [], F = 0, H = P.length; F < H; ++F)for(var X = P[F], G = X.length, N = 1, W = 1 << G; N < W; ++N){
                                V.length = s.popCount(N);
                                for(var re = 0, ae = 0; ae < G; ++ae)N & 1 << ae && (V[re++] = X[ae]);
                                var _e = b(g, V);
                                if (!(_e < 0)) for(; T[_e++].push(F), !(_e >= g.length || h(g[_e], V) !== 0););
                            }
                            return T;
                        }
                        a.incidence = p;
                        function E(g, P) {
                            if (!P) return p(x(A(g, 0)), g, 0);
                            for(var T = new Array(P), F = 0; F < P; ++F)T[F] = [];
                            for(var F = 0, q = g.length; F < q; ++F)for(var V = g[F], H = 0, X = V.length; H < X; ++H)T[V[H]].push(F);
                            return T;
                        }
                        a.dual = E;
                        function k(g) {
                            for(var P = [], T = 0, F = g.length; T < F; ++T)for(var q = g[T], V = q.length | 0, H = 1, X = 1 << V; H < X; ++H){
                                for(var G = [], N = 0; N < V; ++N)H >>> N & 1 && G.push(q[N]);
                                P.push(G);
                            }
                            return v(P);
                        }
                        a.explode = k;
                        function A(g, P) {
                            if (P < 0) return [];
                            for(var T = [], F = (1 << P + 1) - 1, q = 0; q < g.length; ++q)for(var V = g[q], H = F; H < 1 << V.length; H = s.nextCombination(H)){
                                for(var X = new Array(P + 1), G = 0, N = 0; N < V.length; ++N)H & 1 << N && (X[G++] = V[N]);
                                T.push(X);
                            }
                            return v(T);
                        }
                        a.skeleton = A;
                        function L(g) {
                            for(var P = [], T = 0, F = g.length; T < F; ++T)for(var q = g[T], V = 0, H = q.length; V < H; ++V){
                                for(var X = new Array(q.length - 1), G = 0, N = 0; G < H; ++G)G !== V && (X[N++] = q[G]);
                                P.push(X);
                            }
                            return v(P);
                        }
                        a.boundary = L;
                        function _(g, P) {
                            for(var T = new l(P), F = 0; F < g.length; ++F)for(var q = g[F], V = 0; V < q.length; ++V)for(var H = V + 1; H < q.length; ++H)T.link(q[V], q[H]);
                            for(var X = [], G = T.ranks, F = 0; F < G.length; ++F)G[F] = -1;
                            for(var F = 0; F < g.length; ++F){
                                var N = T.find(g[F][0]);
                                G[N] < 0 ? (G[N] = X.length, X.push([
                                    g[F].slice(0)
                                ])) : X[G[N]].push(g[F].slice(0));
                            }
                            return X;
                        }
                        function C(g) {
                            for(var P = x(v(A(g, 0))), T = new l(P.length), F = 0; F < g.length; ++F)for(var q = g[F], V = 0; V < q.length; ++V)for(var H = b(P, [
                                q[V]
                            ]), X = V + 1; X < q.length; ++X)T.link(H, b(P, [
                                q[X]
                            ]));
                            for(var G = [], N = T.ranks, F = 0; F < N.length; ++F)N[F] = -1;
                            for(var F = 0; F < g.length; ++F){
                                var W = T.find(b(P, [
                                    g[F][0]
                                ]));
                                N[W] < 0 ? (N[W] = G.length, G.push([
                                    g[F].slice(0)
                                ])) : G[N[W]].push(g[F].slice(0));
                            }
                            return G;
                        }
                        function M(g, P) {
                            return P ? _(g, P) : C(g);
                        }
                        a.connectedComponents = M;
                    },
                    4623: function(i) {
                        "use strict";
                        "use restrict";
                        i.exports = a;
                        function a(o) {
                            this.roots = new Array(o), this.ranks = new Array(o);
                            for(var s = 0; s < o; ++s)this.roots[s] = s, this.ranks[s] = 0;
                        }
                        a.prototype.length = function() {
                            return this.roots.length;
                        }, a.prototype.makeSet = function() {
                            var o = this.roots.length;
                            return this.roots.push(o), this.ranks.push(0), o;
                        }, a.prototype.find = function(o) {
                            for(var s = this.roots; s[o] !== o;){
                                var l = s[o];
                                s[o] = s[l], o = l;
                            }
                            return o;
                        }, a.prototype.link = function(o, s) {
                            var l = this.find(o), u = this.find(s);
                            if (l !== u) {
                                var c = this.ranks, f = this.roots, h = c[l], d = c[u];
                                h < d ? f[l] = u : d < h ? f[u] = l : (f[u] = l, ++c[l]);
                            }
                        };
                    },
                    5878: function(i, a, o) {
                        "use strict";
                        i.exports = c;
                        var s = o(3250), l = o(2014);
                        function u(f, h, d) {
                            var v = Math.abs(s(f, h, d)), x = Math.sqrt(Math.pow(h[0] - d[0], 2) + Math.pow(h[1] - d[1], 2));
                            return v / x;
                        }
                        function c(f, h, d) {
                            for(var v = h.length, x = f.length, b = new Array(v), p = new Array(v), E = new Array(v), k = new Array(v), A = 0; A < v; ++A)b[A] = p[A] = -1, E[A] = 1 / 0, k[A] = !1;
                            for(var A = 0; A < x; ++A){
                                var L = f[A];
                                if (L.length !== 2) throw new Error("Input must be a graph");
                                var _ = L[1], C = L[0];
                                p[C] !== -1 ? p[C] = -2 : p[C] = _, b[_] !== -1 ? b[_] = -2 : b[_] = C;
                            }
                            function M(ie) {
                                if (k[ie]) return 1 / 0;
                                var Te = b[ie], Ee = p[ie];
                                return Te < 0 || Ee < 0 ? 1 / 0 : u(h[ie], h[Te], h[Ee]);
                            }
                            function g(ie, Te) {
                                var Ee = G[ie], Ae = G[Te];
                                G[ie] = Ae, G[Te] = Ee, N[Ee] = Te, N[Ae] = ie;
                            }
                            function P(ie) {
                                return E[G[ie]];
                            }
                            function T(ie) {
                                return ie & 1 ? ie - 1 >> 1 : (ie >> 1) - 1;
                            }
                            function F(ie) {
                                for(var Te = P(ie);;){
                                    var Ee = Te, Ae = 2 * ie + 1, ze = 2 * (ie + 1), Ce = ie;
                                    if (Ae < re) {
                                        var me = P(Ae);
                                        me < Ee && (Ce = Ae, Ee = me);
                                    }
                                    if (ze < re) {
                                        var Re = P(ze);
                                        Re < Ee && (Ce = ze);
                                    }
                                    if (Ce === ie) return ie;
                                    g(ie, Ce), ie = Ce;
                                }
                            }
                            function q(ie) {
                                for(var Te = P(ie); ie > 0;){
                                    var Ee = T(ie);
                                    if (Ee >= 0) {
                                        var Ae = P(Ee);
                                        if (Te < Ae) {
                                            g(ie, Ee), ie = Ee;
                                            continue;
                                        }
                                    }
                                    return ie;
                                }
                            }
                            function V() {
                                if (re > 0) {
                                    var ie = G[0];
                                    return g(0, re - 1), re -= 1, F(0), ie;
                                }
                                return -1;
                            }
                            function H(ie, Te) {
                                var Ee = G[ie];
                                return E[Ee] === Te ? ie : (E[Ee] = -1 / 0, q(ie), V(), E[Ee] = Te, re += 1, q(re - 1));
                            }
                            function X(ie) {
                                if (!k[ie]) {
                                    k[ie] = !0;
                                    var Te = b[ie], Ee = p[ie];
                                    b[Ee] >= 0 && (b[Ee] = Te), p[Te] >= 0 && (p[Te] = Ee), N[Te] >= 0 && H(N[Te], M(Te)), N[Ee] >= 0 && H(N[Ee], M(Ee));
                                }
                            }
                            for(var G = [], N = new Array(v), A = 0; A < v; ++A){
                                var W = E[A] = M(A);
                                W < 1 / 0 ? (N[A] = G.length, G.push(A)) : N[A] = -1;
                            }
                            for(var re = G.length, A = re >> 1; A >= 0; --A)F(A);
                            for(;;){
                                var ae = V();
                                if (ae < 0 || E[ae] > d) break;
                                X(ae);
                            }
                            for(var _e = [], A = 0; A < v; ++A)k[A] || (N[A] = _e.length, _e.push(h[A].slice()));
                            var Me = _e.length;
                            function ke(ie, Te) {
                                if (ie[Te] < 0) return Te;
                                var Ee = Te, Ae = Te;
                                do {
                                    var ze = ie[Ae];
                                    if (!k[Ae] || ze < 0 || ze === Ae || (Ae = ze, ze = ie[Ae], !k[Ae] || ze < 0 || ze === Ae)) break;
                                    Ae = ze, Ee = ie[Ee];
                                }while (Ee !== Ae);
                                for(var Ce = Te; Ce !== Ae; Ce = ie[Ce])ie[Ce] = Ae;
                                return Ae;
                            }
                            var ge = [];
                            return f.forEach(function(ie) {
                                var Te = ke(b, ie[0]), Ee = ke(p, ie[1]);
                                if (Te >= 0 && Ee >= 0 && Te !== Ee) {
                                    var Ae = N[Te], ze = N[Ee];
                                    Ae !== ze && ge.push([
                                        Ae,
                                        ze
                                    ]);
                                }
                            }), l.unique(l.normalize(ge)), {
                                positions: _e,
                                edges: ge
                            };
                        }
                    },
                    1303: function(i, a, o) {
                        "use strict";
                        i.exports = u;
                        var s = o(3250);
                        function l(c, f) {
                            var h, d;
                            if (f[0][0] < f[1][0]) h = f[0], d = f[1];
                            else if (f[0][0] > f[1][0]) h = f[1], d = f[0];
                            else {
                                var v = Math.min(c[0][1], c[1][1]), x = Math.max(c[0][1], c[1][1]), b = Math.min(f[0][1], f[1][1]), p = Math.max(f[0][1], f[1][1]);
                                return x < b ? x - b : v > p ? v - p : x - p;
                            }
                            var E, k;
                            c[0][1] < c[1][1] ? (E = c[0], k = c[1]) : (E = c[1], k = c[0]);
                            var A = s(d, h, E);
                            return A || (A = s(d, h, k), A) ? A : k - d;
                        }
                        function u(c, f) {
                            var h, d;
                            if (f[0][0] < f[1][0]) h = f[0], d = f[1];
                            else if (f[0][0] > f[1][0]) h = f[1], d = f[0];
                            else return l(f, c);
                            var v, x;
                            if (c[0][0] < c[1][0]) v = c[0], x = c[1];
                            else if (c[0][0] > c[1][0]) v = c[1], x = c[0];
                            else return -l(c, f);
                            var b = s(h, d, x), p = s(h, d, v);
                            if (b < 0) {
                                if (p <= 0) return b;
                            } else if (b > 0) {
                                if (p >= 0) return b;
                            } else if (p) return p;
                            if (b = s(x, v, d), p = s(x, v, h), b < 0) {
                                if (p <= 0) return b;
                            } else if (b > 0) {
                                if (p >= 0) return b;
                            } else if (p) return p;
                            return d[0] - x[0];
                        }
                    },
                    4209: function(i, a, o) {
                        "use strict";
                        i.exports = p;
                        var s = o(2478), l = o(3840), u = o(3250), c = o(1303);
                        function f(E, k, A) {
                            this.slabs = E, this.coordinates = k, this.horizontal = A;
                        }
                        var h = f.prototype;
                        function d(E, k) {
                            return E.y - k;
                        }
                        function v(E, k) {
                            for(var A = null; E;){
                                var L = E.key, _, C;
                                L[0][0] < L[1][0] ? (_ = L[0], C = L[1]) : (_ = L[1], C = L[0]);
                                var M = u(_, C, k);
                                if (M < 0) E = E.left;
                                else if (M > 0) {
                                    if (k[0] !== L[1][0]) A = E, E = E.right;
                                    else {
                                        var g = v(E.right, k);
                                        if (g) return g;
                                        E = E.left;
                                    }
                                } else {
                                    if (k[0] !== L[1][0]) return E;
                                    var g = v(E.right, k);
                                    if (g) return g;
                                    E = E.left;
                                }
                            }
                            return A;
                        }
                        h.castUp = function(E) {
                            var k = s.le(this.coordinates, E[0]);
                            if (k < 0) return -1;
                            var A = this.slabs[k], L = v(this.slabs[k], E), _ = -1;
                            if (L && (_ = L.value), this.coordinates[k] === E[0]) {
                                var C = null;
                                if (L && (C = L.key), k > 0) {
                                    var M = v(this.slabs[k - 1], E);
                                    M && (C ? c(M.key, C) > 0 && (C = M.key, _ = M.value) : (_ = M.value, C = M.key));
                                }
                                var g = this.horizontal[k];
                                if (g.length > 0) {
                                    var P = s.ge(g, E[1], d);
                                    if (P < g.length) {
                                        var T = g[P];
                                        if (E[1] === T.y) {
                                            if (T.closed) return T.index;
                                            for(; P < g.length - 1 && g[P + 1].y === E[1];)if (P = P + 1, T = g[P], T.closed) return T.index;
                                            if (T.y === E[1] && !T.start) {
                                                if (P = P + 1, P >= g.length) return _;
                                                T = g[P];
                                            }
                                        }
                                        if (T.start) {
                                            if (C) {
                                                var F = u(C[0], C[1], [
                                                    E[0],
                                                    T.y
                                                ]);
                                                C[0][0] > C[1][0] && (F = -F), F > 0 && (_ = T.index);
                                            } else _ = T.index;
                                        } else T.y !== E[1] && (_ = T.index);
                                    }
                                }
                            }
                            return _;
                        };
                        function x(E, k, A, L) {
                            this.y = E, this.index = k, this.start = A, this.closed = L;
                        }
                        function b(E, k, A, L) {
                            this.x = E, this.segment = k, this.create = A, this.index = L;
                        }
                        function p(E) {
                            for(var k = E.length, A = 2 * k, L = new Array(A), _ = 0; _ < k; ++_){
                                var C = E[_], M = C[0][0] < C[1][0];
                                L[2 * _] = new b(C[0][0], C, M, _), L[2 * _ + 1] = new b(C[1][0], C, !M, _);
                            }
                            L.sort(function(G, N) {
                                var W = G.x - N.x;
                                return W || (W = G.create - N.create, W) ? W : Math.min(G.segment[0][1], G.segment[1][1]) - Math.min(N.segment[0][1], N.segment[1][1]);
                            });
                            for(var g = l(c), P = [], T = [], F = [], q = -1 / 0, _ = 0; _ < A;){
                                for(var V = L[_].x, H = []; _ < A;){
                                    var X = L[_];
                                    if (X.x !== V) break;
                                    _ += 1, X.segment[0][0] === X.x && X.segment[1][0] === X.x ? X.create && (X.segment[0][1] < X.segment[1][1] ? (H.push(new x(X.segment[0][1], X.index, !0, !0)), H.push(new x(X.segment[1][1], X.index, !1, !1))) : (H.push(new x(X.segment[1][1], X.index, !0, !1)), H.push(new x(X.segment[0][1], X.index, !1, !0)))) : X.create ? g = g.insert(X.segment, X.index) : g = g.remove(X.segment);
                                }
                                P.push(g.root), T.push(V), F.push(H);
                            }
                            return new f(P, T, F);
                        }
                    },
                    5202: function(i, a, o) {
                        "use strict";
                        var s = o(1944), l = o(8210);
                        i.exports = f, i.exports.positive = h, i.exports.negative = d;
                        function u(v, x) {
                            var b = l(s(v, x), [
                                x[x.length - 1]
                            ]);
                            return b[b.length - 1];
                        }
                        function c(v, x, b, p) {
                            var E = p - x, k = -x / E;
                            k < 0 ? k = 0 : k > 1 && (k = 1);
                            for(var A = 1 - k, L = v.length, _ = new Array(L), C = 0; C < L; ++C)_[C] = k * v[C] + A * b[C];
                            return _;
                        }
                        function f(v, x) {
                            for(var b = [], p = [], E = u(v[v.length - 1], x), k = v[v.length - 1], A = v[0], L = 0; L < v.length; ++L, k = A){
                                A = v[L];
                                var _ = u(A, x);
                                if (E < 0 && _ > 0 || E > 0 && _ < 0) {
                                    var C = c(k, _, A, E);
                                    b.push(C), p.push(C.slice());
                                }
                                _ < 0 ? p.push(A.slice()) : _ > 0 ? b.push(A.slice()) : (b.push(A.slice()), p.push(A.slice())), E = _;
                            }
                            return {
                                positive: b,
                                negative: p
                            };
                        }
                        function h(v, x) {
                            for(var b = [], p = u(v[v.length - 1], x), E = v[v.length - 1], k = v[0], A = 0; A < v.length; ++A, E = k){
                                k = v[A];
                                var L = u(k, x);
                                (p < 0 && L > 0 || p > 0 && L < 0) && b.push(c(E, L, k, p)), L >= 0 && b.push(k.slice()), p = L;
                            }
                            return b;
                        }
                        function d(v, x) {
                            for(var b = [], p = u(v[v.length - 1], x), E = v[v.length - 1], k = v[0], A = 0; A < v.length; ++A, E = k){
                                k = v[A];
                                var L = u(k, x);
                                (p < 0 && L > 0 || p > 0 && L < 0) && b.push(c(E, L, k, p)), L <= 0 && b.push(k.slice()), p = L;
                            }
                            return b;
                        }
                    },
                    3387: function(i, a, o) {
                        var s;
                        (function() {
                            "use strict";
                            var l = {
                                not_string: /[^s]/,
                                not_bool: /[^t]/,
                                not_type: /[^T]/,
                                not_primitive: /[^v]/,
                                number: /[diefg]/,
                                numeric_arg: /[bcdiefguxX]/,
                                json: /[j]/,
                                not_json: /[^j]/,
                                text: /^[^\x25]+/,
                                modulo: /^\x25{2}/,
                                placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
                                key: /^([a-z_][a-z_\d]*)/i,
                                key_access: /^\.([a-z_][a-z_\d]*)/i,
                                index_access: /^\[(\d+)\]/,
                                sign: /^[+-]/
                            };
                            function u(v) {
                                return f(d(v), arguments);
                            }
                            function c(v, x) {
                                return u.apply(null, [
                                    v
                                ].concat(x || []));
                            }
                            function f(v, x) {
                                var b = 1, p = v.length, E, k = "", A, L, _, C, M, g, P, T;
                                for(A = 0; A < p; A++)if (typeof v[A] == "string") k += v[A];
                                else if (typeof v[A] == "object") {
                                    if (_ = v[A], _.keys) for(E = x[b], L = 0; L < _.keys.length; L++){
                                        if (E == null) throw new Error(u('[sprintf] Cannot access property "%s" of undefined value "%s"', _.keys[L], _.keys[L - 1]));
                                        E = E[_.keys[L]];
                                    }
                                    else _.param_no ? E = x[_.param_no] : E = x[b++];
                                    if (l.not_type.test(_.type) && l.not_primitive.test(_.type) && E instanceof Function && (E = E()), l.numeric_arg.test(_.type) && typeof E != "number" && isNaN(E)) throw new TypeError(u("[sprintf] expecting number but found %T", E));
                                    switch(l.number.test(_.type) && (P = E >= 0), _.type){
                                        case "b":
                                            E = parseInt(E, 10).toString(2);
                                            break;
                                        case "c":
                                            E = String.fromCharCode(parseInt(E, 10));
                                            break;
                                        case "d":
                                        case "i":
                                            E = parseInt(E, 10);
                                            break;
                                        case "j":
                                            E = JSON.stringify(E, null, _.width ? parseInt(_.width) : 0);
                                            break;
                                        case "e":
                                            E = _.precision ? parseFloat(E).toExponential(_.precision) : parseFloat(E).toExponential();
                                            break;
                                        case "f":
                                            E = _.precision ? parseFloat(E).toFixed(_.precision) : parseFloat(E);
                                            break;
                                        case "g":
                                            E = _.precision ? String(Number(E.toPrecision(_.precision))) : parseFloat(E);
                                            break;
                                        case "o":
                                            E = (parseInt(E, 10) >>> 0).toString(8);
                                            break;
                                        case "s":
                                            E = String(E), E = _.precision ? E.substring(0, _.precision) : E;
                                            break;
                                        case "t":
                                            E = String(!!E), E = _.precision ? E.substring(0, _.precision) : E;
                                            break;
                                        case "T":
                                            E = Object.prototype.toString.call(E).slice(8, -1).toLowerCase(), E = _.precision ? E.substring(0, _.precision) : E;
                                            break;
                                        case "u":
                                            E = parseInt(E, 10) >>> 0;
                                            break;
                                        case "v":
                                            E = E.valueOf(), E = _.precision ? E.substring(0, _.precision) : E;
                                            break;
                                        case "x":
                                            E = (parseInt(E, 10) >>> 0).toString(16);
                                            break;
                                        case "X":
                                            E = (parseInt(E, 10) >>> 0).toString(16).toUpperCase();
                                            break;
                                    }
                                    l.json.test(_.type) ? k += E : (l.number.test(_.type) && (!P || _.sign) ? (T = P ? "+" : "-", E = E.toString().replace(l.sign, "")) : T = "", M = _.pad_char ? _.pad_char === "0" ? "0" : _.pad_char.charAt(1) : " ", g = _.width - (T + E).length, C = _.width && g > 0 ? M.repeat(g) : "", k += _.align ? T + E + C : M === "0" ? T + C + E : C + T + E);
                                }
                                return k;
                            }
                            var h = Object.create(null);
                            function d(v) {
                                if (h[v]) return h[v];
                                for(var x = v, b, p = [], E = 0; x;){
                                    if ((b = l.text.exec(x)) !== null) p.push(b[0]);
                                    else if ((b = l.modulo.exec(x)) !== null) p.push("%");
                                    else if ((b = l.placeholder.exec(x)) !== null) {
                                        if (b[2]) {
                                            E |= 1;
                                            var k = [], A = b[2], L = [];
                                            if ((L = l.key.exec(A)) !== null) for(k.push(L[1]); (A = A.substring(L[0].length)) !== "";)if ((L = l.key_access.exec(A)) !== null) k.push(L[1]);
                                            else if ((L = l.index_access.exec(A)) !== null) k.push(L[1]);
                                            else throw new SyntaxError("[sprintf] failed to parse named argument key");
                                            else throw new SyntaxError("[sprintf] failed to parse named argument key");
                                            b[2] = k;
                                        } else E |= 2;
                                        if (E === 3) throw new Error("[sprintf] mixing positional and named placeholders is not (yet) supported");
                                        p.push({
                                            placeholder: b[0],
                                            param_no: b[1],
                                            keys: b[2],
                                            sign: b[3],
                                            pad_char: b[4],
                                            align: b[5],
                                            width: b[6],
                                            precision: b[7],
                                            type: b[8]
                                        });
                                    } else throw new SyntaxError("[sprintf] unexpected placeholder");
                                    x = x.substring(b[0].length);
                                }
                                return h[v] = p;
                            }
                            a.sprintf = u, a.vsprintf = c, typeof window != "undefined" && (window.sprintf = u, window.vsprintf = c, s = (function() {
                                return {
                                    sprintf: u,
                                    vsprintf: c
                                };
                            }).call(a, o, a, i), s !== void 0 && (i.exports = s));
                        })();
                    },
                    3711: function(i, a, o) {
                        "use strict";
                        i.exports = d;
                        var s = o(2640), l = o(781), u = {
                            "2d": function(v, x, b) {
                                var p = v({
                                    order: x,
                                    scalarArguments: 3,
                                    getters: b === "generic" ? [
                                        0
                                    ] : void 0,
                                    phase: function(k, A, L, _) {
                                        return k > _ | 0;
                                    },
                                    vertex: function(k, A, L, _, C, M, g, P, T, F, q, V, H) {
                                        var X = (g << 0) + (P << 1) + (T << 2) + (F << 3) | 0;
                                        if (!(X === 0 || X === 15)) switch(X){
                                            case 0:
                                                q.push([
                                                    k - .5,
                                                    A - .5
                                                ]);
                                                break;
                                            case 1:
                                                q.push([
                                                    k - .25 - .25 * (_ + L - 2 * H) / (L - _),
                                                    A - .25 - .25 * (C + L - 2 * H) / (L - C)
                                                ]);
                                                break;
                                            case 2:
                                                q.push([
                                                    k - .75 - .25 * (-_ - L + 2 * H) / (_ - L),
                                                    A - .25 - .25 * (M + _ - 2 * H) / (_ - M)
                                                ]);
                                                break;
                                            case 3:
                                                q.push([
                                                    k - .5,
                                                    A - .5 - .5 * (C + L + M + _ - 4 * H) / (L - C + _ - M)
                                                ]);
                                                break;
                                            case 4:
                                                q.push([
                                                    k - .25 - .25 * (M + C - 2 * H) / (C - M),
                                                    A - .75 - .25 * (-C - L + 2 * H) / (C - L)
                                                ]);
                                                break;
                                            case 5:
                                                q.push([
                                                    k - .5 - .5 * (_ + L + M + C - 4 * H) / (L - _ + C - M),
                                                    A - .5
                                                ]);
                                                break;
                                            case 6:
                                                q.push([
                                                    k - .5 - .25 * (-_ - L + M + C) / (_ - L + C - M),
                                                    A - .5 - .25 * (-C - L + M + _) / (C - L + _ - M)
                                                ]);
                                                break;
                                            case 7:
                                                q.push([
                                                    k - .75 - .25 * (M + C - 2 * H) / (C - M),
                                                    A - .75 - .25 * (M + _ - 2 * H) / (_ - M)
                                                ]);
                                                break;
                                            case 8:
                                                q.push([
                                                    k - .75 - .25 * (-M - C + 2 * H) / (M - C),
                                                    A - .75 - .25 * (-M - _ + 2 * H) / (M - _)
                                                ]);
                                                break;
                                            case 9:
                                                q.push([
                                                    k - .5 - .25 * (_ + L + -M - C) / (L - _ + M - C),
                                                    A - .5 - .25 * (C + L + -M - _) / (L - C + M - _)
                                                ]);
                                                break;
                                            case 10:
                                                q.push([
                                                    k - .5 - .5 * (-_ - L + -M - C + 4 * H) / (_ - L + M - C),
                                                    A - .5
                                                ]);
                                                break;
                                            case 11:
                                                q.push([
                                                    k - .25 - .25 * (-M - C + 2 * H) / (M - C),
                                                    A - .75 - .25 * (C + L - 2 * H) / (L - C)
                                                ]);
                                                break;
                                            case 12:
                                                q.push([
                                                    k - .5,
                                                    A - .5 - .5 * (-C - L + -M - _ + 4 * H) / (C - L + M - _)
                                                ]);
                                                break;
                                            case 13:
                                                q.push([
                                                    k - .75 - .25 * (_ + L - 2 * H) / (L - _),
                                                    A - .25 - .25 * (-M - _ + 2 * H) / (M - _)
                                                ]);
                                                break;
                                            case 14:
                                                q.push([
                                                    k - .25 - .25 * (-_ - L + 2 * H) / (_ - L),
                                                    A - .25 - .25 * (-C - L + 2 * H) / (C - L)
                                                ]);
                                                break;
                                            case 15:
                                                q.push([
                                                    k - .5,
                                                    A - .5
                                                ]);
                                                break;
                                        }
                                    },
                                    cell: function(k, A, L, _, C, M, g, P, T) {
                                        C ? P.push([
                                            k,
                                            A
                                        ]) : P.push([
                                            A,
                                            k
                                        ]);
                                    }
                                });
                                return function(E, k) {
                                    var A = [], L = [];
                                    return p(E, A, L, k), {
                                        positions: A,
                                        cells: L
                                    };
                                };
                            }
                        };
                        function c(v, x) {
                            var b = v.length + "d", p = u[b];
                            if (p) return p(s, v, x);
                        }
                        function f(v, x) {
                            for(var b = l(v, x), p = b.length, E = new Array(p), k = new Array(p), A = 0; A < p; ++A)E[A] = [
                                b[A]
                            ], k[A] = [
                                A
                            ];
                            return {
                                positions: E,
                                cells: k
                            };
                        }
                        var h = {};
                        function d(v, E) {
                            if (v.dimension <= 0) return {
                                positions: [],
                                cells: []
                            };
                            if (v.dimension === 1) return f(v, E);
                            var b = v.order.join() + "-" + v.dtype, p = h[b], E = +E || 0;
                            return p || (p = h[b] = c(v.order, v.dtype)), p(v, E);
                        }
                    },
                    665: function(i, a, o) {
                        "use strict";
                        var s = o(3202);
                        i.exports = f;
                        var l = 96;
                        function u(h, d) {
                            var v = s(getComputedStyle(h).getPropertyValue(d));
                            return v[0] * f(v[1], h);
                        }
                        function c(h, d) {
                            var v = document.createElement("div");
                            v.style["font-size"] = "128" + h, d.appendChild(v);
                            var x = u(v, "font-size") / 128;
                            return d.removeChild(v), x;
                        }
                        function f(h, d) {
                            switch(d = d || document.body, h = (h || "px").trim().toLowerCase(), (d === window || d === document) && (d = document.body), h){
                                case "%":
                                    return d.clientHeight / 100;
                                case "ch":
                                case "ex":
                                    return c(h, d);
                                case "em":
                                    return u(d, "font-size");
                                case "rem":
                                    return u(document.body, "font-size");
                                case "vw":
                                    return window.innerWidth / 100;
                                case "vh":
                                    return window.innerHeight / 100;
                                case "vmin":
                                    return Math.min(window.innerWidth, window.innerHeight) / 100;
                                case "vmax":
                                    return Math.max(window.innerWidth, window.innerHeight) / 100;
                                case "in":
                                    return l;
                                case "cm":
                                    return l / 2.54;
                                case "mm":
                                    return l / 25.4;
                                case "pt":
                                    return l / 72;
                                case "pc":
                                    return l / 6;
                            }
                            return 1;
                        }
                    },
                    7261: function(i, a, o) {
                        "use strict";
                        i.exports = k;
                        var s = o(9215), l = o(7608), u = o(6079), c = o(5911), f = o(3536), h = o(244);
                        function d(A, L, _) {
                            return Math.sqrt(Math.pow(A, 2) + Math.pow(L, 2) + Math.pow(_, 2));
                        }
                        function v(A) {
                            return Math.min(1, Math.max(-1, A));
                        }
                        function x(A) {
                            var L = Math.abs(A[0]), _ = Math.abs(A[1]), C = Math.abs(A[2]), M = [
                                0,
                                0,
                                0
                            ];
                            L > Math.max(_, C) ? M[2] = 1 : _ > Math.max(L, C) ? M[0] = 1 : M[1] = 1;
                            for(var g = 0, P = 0, T = 0; T < 3; ++T)g += A[T] * A[T], P += M[T] * A[T];
                            for(var T = 0; T < 3; ++T)M[T] -= P / g * A[T];
                            return f(M, M), M;
                        }
                        function b(A, L, _, C, M, g, P, T) {
                            this.center = s(_), this.up = s(C), this.right = s(M), this.radius = s([
                                g
                            ]), this.angle = s([
                                P,
                                T
                            ]), this.angle.bounds = [
                                [
                                    -1 / 0,
                                    -Math.PI / 2
                                ],
                                [
                                    1 / 0,
                                    Math.PI / 2
                                ]
                            ], this.setDistanceLimits(A, L), this.computedCenter = this.center.curve(0), this.computedUp = this.up.curve(0), this.computedRight = this.right.curve(0), this.computedRadius = this.radius.curve(0), this.computedAngle = this.angle.curve(0), this.computedToward = [
                                0,
                                0,
                                0
                            ], this.computedEye = [
                                0,
                                0,
                                0
                            ], this.computedMatrix = new Array(16);
                            for(var F = 0; F < 16; ++F)this.computedMatrix[F] = .5;
                            this.recalcMatrix(0);
                        }
                        var p = b.prototype;
                        p.setDistanceLimits = function(A, L) {
                            A > 0 ? A = Math.log(A) : A = -1 / 0, L > 0 ? L = Math.log(L) : L = 1 / 0, L = Math.max(L, A), this.radius.bounds[0][0] = A, this.radius.bounds[1][0] = L;
                        }, p.getDistanceLimits = function(A) {
                            var L = this.radius.bounds[0];
                            return A ? (A[0] = Math.exp(L[0][0]), A[1] = Math.exp(L[1][0]), A) : [
                                Math.exp(L[0][0]),
                                Math.exp(L[1][0])
                            ];
                        }, p.recalcMatrix = function(A) {
                            this.center.curve(A), this.up.curve(A), this.right.curve(A), this.radius.curve(A), this.angle.curve(A);
                            for(var L = this.computedUp, _ = this.computedRight, C = 0, M = 0, g = 0; g < 3; ++g)M += L[g] * _[g], C += L[g] * L[g];
                            for(var P = Math.sqrt(C), T = 0, g = 0; g < 3; ++g)_[g] -= L[g] * M / C, T += _[g] * _[g], L[g] /= P;
                            for(var F = Math.sqrt(T), g = 0; g < 3; ++g)_[g] /= F;
                            var q = this.computedToward;
                            c(q, L, _), f(q, q);
                            for(var V = Math.exp(this.computedRadius[0]), H = this.computedAngle[0], X = this.computedAngle[1], G = Math.cos(H), N = Math.sin(H), W = Math.cos(X), re = Math.sin(X), ae = this.computedCenter, _e = G * W, Me = N * W, ke = re, ge = -G * re, ie = -N * re, Te = W, Ee = this.computedEye, Ae = this.computedMatrix, g = 0; g < 3; ++g){
                                var ze = _e * _[g] + Me * q[g] + ke * L[g];
                                Ae[4 * g + 1] = ge * _[g] + ie * q[g] + Te * L[g], Ae[4 * g + 2] = ze, Ae[4 * g + 3] = 0;
                            }
                            var Ce = Ae[1], me = Ae[5], Re = Ae[9], ce = Ae[2], Ge = Ae[6], nt = Ae[10], ct = me * nt - Re * Ge, qt = Re * ce - Ce * nt, rt = Ce * Ge - me * ce, ot = d(ct, qt, rt);
                            ct /= ot, qt /= ot, rt /= ot, Ae[0] = ct, Ae[4] = qt, Ae[8] = rt;
                            for(var g = 0; g < 3; ++g)Ee[g] = ae[g] + Ae[2 + 4 * g] * V;
                            for(var g = 0; g < 3; ++g){
                                for(var T = 0, Rt = 0; Rt < 3; ++Rt)T += Ae[g + 4 * Rt] * Ee[Rt];
                                Ae[12 + g] = -T;
                            }
                            Ae[15] = 1;
                        }, p.getMatrix = function(A, L) {
                            this.recalcMatrix(A);
                            var _ = this.computedMatrix;
                            if (L) {
                                for(var C = 0; C < 16; ++C)L[C] = _[C];
                                return L;
                            }
                            return _;
                        };
                        var E = [
                            0,
                            0,
                            0
                        ];
                        p.rotate = function(A, L, _, C) {
                            if (this.angle.move(A, L, _), C) {
                                this.recalcMatrix(A);
                                var M = this.computedMatrix;
                                E[0] = M[2], E[1] = M[6], E[2] = M[10];
                                for(var g = this.computedUp, P = this.computedRight, T = this.computedToward, F = 0; F < 3; ++F)M[4 * F] = g[F], M[4 * F + 1] = P[F], M[4 * F + 2] = T[F];
                                u(M, M, C, E);
                                for(var F = 0; F < 3; ++F)g[F] = M[4 * F], P[F] = M[4 * F + 1];
                                this.up.set(A, g[0], g[1], g[2]), this.right.set(A, P[0], P[1], P[2]);
                            }
                        }, p.pan = function(A, L, _, C) {
                            L = L || 0, _ = _ || 0, C = C || 0, this.recalcMatrix(A);
                            var M = this.computedMatrix, g = Math.exp(this.computedRadius[0]), P = M[1], T = M[5], F = M[9], q = d(P, T, F);
                            P /= q, T /= q, F /= q;
                            var V = M[0], H = M[4], X = M[8], G = V * P + H * T + X * F;
                            V -= P * G, H -= T * G, X -= F * G;
                            var N = d(V, H, X);
                            V /= N, H /= N, X /= N;
                            var W = V * L + P * _, re = H * L + T * _, ae = X * L + F * _;
                            this.center.move(A, W, re, ae);
                            var _e = Math.exp(this.computedRadius[0]);
                            _e = Math.max(1e-4, _e + C), this.radius.set(A, Math.log(_e));
                        }, p.translate = function(A, L, _, C) {
                            this.center.move(A, L || 0, _ || 0, C || 0);
                        }, p.setMatrix = function(A, L, _, C) {
                            var M = 1;
                            typeof _ == "number" && (M = _ | 0), (M < 0 || M > 3) && (M = 1);
                            var g = (M + 2) % 3, P = (M + 1) % 3;
                            L || (this.recalcMatrix(A), L = this.computedMatrix);
                            var T = L[M], F = L[M + 4], q = L[M + 8];
                            if (C) {
                                var H = Math.abs(T), X = Math.abs(F), G = Math.abs(q), N = Math.max(H, X, G);
                                H === N ? (T = T < 0 ? -1 : 1, F = q = 0) : G === N ? (q = q < 0 ? -1 : 1, T = F = 0) : (F = F < 0 ? -1 : 1, T = q = 0);
                            } else {
                                var V = d(T, F, q);
                                T /= V, F /= V, q /= V;
                            }
                            var W = L[g], re = L[g + 4], ae = L[g + 8], _e = W * T + re * F + ae * q;
                            W -= T * _e, re -= F * _e, ae -= q * _e;
                            var Me = d(W, re, ae);
                            W /= Me, re /= Me, ae /= Me;
                            var ke = F * ae - q * re, ge = q * W - T * ae, ie = T * re - F * W, Te = d(ke, ge, ie);
                            ke /= Te, ge /= Te, ie /= Te, this.center.jump(A, er, Ke, xt), this.radius.idle(A), this.up.jump(A, T, F, q), this.right.jump(A, W, re, ae);
                            var Ee, Ae;
                            if (M === 2) {
                                var ze = L[1], Ce = L[5], me = L[9], Re = ze * W + Ce * re + me * ae, ce = ze * ke + Ce * ge + me * ie;
                                qt < 0 ? Ee = -Math.PI / 2 : Ee = Math.PI / 2, Ae = Math.atan2(ce, Re);
                            } else {
                                var Ge = L[2], nt = L[6], ct = L[10], qt = Ge * T + nt * F + ct * q, rt = Ge * W + nt * re + ct * ae, ot = Ge * ke + nt * ge + ct * ie;
                                Ee = Math.asin(v(qt)), Ae = Math.atan2(ot, rt);
                            }
                            this.angle.jump(A, Ae, Ee), this.recalcMatrix(A);
                            var Rt = L[2], kt = L[6], Ct = L[10], Yt = this.computedMatrix;
                            l(Yt, L);
                            var xr = Yt[15], er = Yt[12] / xr, Ke = Yt[13] / xr, xt = Yt[14] / xr, bt = Math.exp(this.computedRadius[0]);
                            this.center.jump(A, er - Rt * bt, Ke - kt * bt, xt - Ct * bt);
                        }, p.lastT = function() {
                            return Math.max(this.center.lastT(), this.up.lastT(), this.right.lastT(), this.radius.lastT(), this.angle.lastT());
                        }, p.idle = function(A) {
                            this.center.idle(A), this.up.idle(A), this.right.idle(A), this.radius.idle(A), this.angle.idle(A);
                        }, p.flush = function(A) {
                            this.center.flush(A), this.up.flush(A), this.right.flush(A), this.radius.flush(A), this.angle.flush(A);
                        }, p.setDistance = function(A, L) {
                            L > 0 && this.radius.set(A, Math.log(L));
                        }, p.lookAt = function(A, L, _, C) {
                            this.recalcMatrix(A), L = L || this.computedEye, _ = _ || this.computedCenter, C = C || this.computedUp;
                            var M = C[0], g = C[1], P = C[2], T = d(M, g, P);
                            if (!(T < 1e-6)) {
                                M /= T, g /= T, P /= T;
                                var F = L[0] - _[0], q = L[1] - _[1], V = L[2] - _[2], H = d(F, q, V);
                                if (!(H < 1e-6)) {
                                    F /= H, q /= H, V /= H;
                                    var X = this.computedRight, G = X[0], N = X[1], W = X[2], re = M * G + g * N + P * W;
                                    G -= re * M, N -= re * g, W -= re * P;
                                    var ae = d(G, N, W);
                                    if (!(ae < .01 && (G = g * V - P * q, N = P * F - M * V, W = M * q - g * F, ae = d(G, N, W), ae < 1e-6))) {
                                        G /= ae, N /= ae, W /= ae, this.up.set(A, M, g, P), this.right.set(A, G, N, W), this.center.set(A, _[0], _[1], _[2]), this.radius.set(A, Math.log(H));
                                        var _e = g * W - P * N, Me = P * G - M * W, ke = M * N - g * G, ge = d(_e, Me, ke);
                                        _e /= ge, Me /= ge, ke /= ge;
                                        var ie = M * F + g * q + P * V, Te = G * F + N * q + W * V, Ee = _e * F + Me * q + ke * V, Ae = Math.asin(v(ie)), ze = Math.atan2(Ee, Te), Ce = this.angle._state, me = Ce[Ce.length - 1], Re = Ce[Ce.length - 2];
                                        me = me % (2 * Math.PI);
                                        var ce = Math.abs(me + 2 * Math.PI - ze), Ge = Math.abs(me - ze), nt = Math.abs(me - 2 * Math.PI - ze);
                                        ce < Ge && (me += 2 * Math.PI), nt < Ge && (me -= 2 * Math.PI), this.angle.jump(this.angle.lastT(), me, Re), this.angle.set(A, ze, Ae);
                                    }
                                }
                            }
                        };
                        function k(A) {
                            A = A || {};
                            var L = A.center || [
                                0,
                                0,
                                0
                            ], _ = A.up || [
                                0,
                                1,
                                0
                            ], C = A.right || x(_), M = A.radius || 1, g = A.theta || 0, P = A.phi || 0;
                            if (L = [].slice.call(L, 0, 3), _ = [].slice.call(_, 0, 3), f(_, _), C = [].slice.call(C, 0, 3), f(C, C), "eye" in A) {
                                var T = A.eye, F = [
                                    T[0] - L[0],
                                    T[1] - L[1],
                                    T[2] - L[2]
                                ];
                                c(C, F, _), d(C[0], C[1], C[2]) < 1e-6 ? C = x(_) : f(C, C), M = d(F[0], F[1], F[2]);
                                var q = h(_, F) / M, V = h(C, F) / M;
                                P = Math.acos(q), g = Math.acos(V);
                            }
                            return M = Math.log(M), new b(A.zoomMin, A.zoomMax, L, _, C, M, g, P);
                        }
                    },
                    5250: function(i) {
                        "use strict";
                        i.exports = o;
                        var a = +(Math.pow(2, 27) + 1);
                        function o(s, l, u) {
                            var c = s * l, f = a * s, h = f - s, d = f - h, v = s - d, x = a * l, b = x - l, p = x - b, E = l - p, k = c - d * p, A = k - v * p, L = A - d * E, _ = v * E - L;
                            return u ? (u[0] = _, u[1] = c, u) : [
                                _,
                                c
                            ];
                        }
                    },
                    9362: function(i) {
                        "use strict";
                        i.exports = a;
                        function a(o, s, l) {
                            var u = o + s, c = u - o, f = u - c, h = s - c, d = o - f;
                            return l ? (l[0] = d + h, l[1] = u, l) : [
                                d + h,
                                u
                            ];
                        }
                    },
                    1888: function(i, a, o) {
                        "use strict";
                        var s = o(8828), l = o(1338), u = o(4793).hp;
                        o.g.__TYPEDARRAY_POOL || (o.g.__TYPEDARRAY_POOL = {
                            UINT8: l([
                                32,
                                0
                            ]),
                            UINT16: l([
                                32,
                                0
                            ]),
                            UINT32: l([
                                32,
                                0
                            ]),
                            BIGUINT64: l([
                                32,
                                0
                            ]),
                            INT8: l([
                                32,
                                0
                            ]),
                            INT16: l([
                                32,
                                0
                            ]),
                            INT32: l([
                                32,
                                0
                            ]),
                            BIGINT64: l([
                                32,
                                0
                            ]),
                            FLOAT: l([
                                32,
                                0
                            ]),
                            DOUBLE: l([
                                32,
                                0
                            ]),
                            DATA: l([
                                32,
                                0
                            ]),
                            UINT8C: l([
                                32,
                                0
                            ]),
                            BUFFER: l([
                                32,
                                0
                            ])
                        });
                        var c = typeof Uint8ClampedArray != "undefined", f = typeof BigUint64Array != "undefined", h = typeof BigInt64Array != "undefined", d = o.g.__TYPEDARRAY_POOL;
                        d.UINT8C || (d.UINT8C = l([
                            32,
                            0
                        ])), d.BIGUINT64 || (d.BIGUINT64 = l([
                            32,
                            0
                        ])), d.BIGINT64 || (d.BIGINT64 = l([
                            32,
                            0
                        ])), d.BUFFER || (d.BUFFER = l([
                            32,
                            0
                        ]));
                        var v = d.DATA, x = d.BUFFER;
                        a.free = function(G) {
                            if (u.isBuffer(G)) x[s.log2(G.length)].push(G);
                            else {
                                if (Object.prototype.toString.call(G) !== "[object ArrayBuffer]" && (G = G.buffer), !G) return;
                                var N = G.length || G.byteLength, W = s.log2(N) | 0;
                                v[W].push(G);
                            }
                        };
                        function b(X) {
                            if (X) {
                                var G = X.length || X.byteLength, N = s.log2(G);
                                v[N].push(X);
                            }
                        }
                        function p(X) {
                            b(X.buffer);
                        }
                        a.freeUint8 = a.freeUint16 = a.freeUint32 = a.freeBigUint64 = a.freeInt8 = a.freeInt16 = a.freeInt32 = a.freeBigInt64 = a.freeFloat32 = a.freeFloat = a.freeFloat64 = a.freeDouble = a.freeUint8Clamped = a.freeDataView = p, a.freeArrayBuffer = b, a.freeBuffer = function(G) {
                            x[s.log2(G.length)].push(G);
                        }, a.malloc = function(G, N) {
                            if (N === void 0 || N === "arraybuffer") return E(G);
                            switch(N){
                                case "uint8":
                                    return k(G);
                                case "uint16":
                                    return A(G);
                                case "uint32":
                                    return L(G);
                                case "int8":
                                    return _(G);
                                case "int16":
                                    return C(G);
                                case "int32":
                                    return M(G);
                                case "float":
                                case "float32":
                                    return g(G);
                                case "double":
                                case "float64":
                                    return P(G);
                                case "uint8_clamped":
                                    return T(G);
                                case "bigint64":
                                    return q(G);
                                case "biguint64":
                                    return F(G);
                                case "buffer":
                                    return H(G);
                                case "data":
                                case "dataview":
                                    return V(G);
                                default:
                                    return null;
                            }
                            return null;
                        };
                        function E(G) {
                            var G = s.nextPow2(G), N = s.log2(G), W = v[N];
                            return W.length > 0 ? W.pop() : new ArrayBuffer(G);
                        }
                        a.mallocArrayBuffer = E;
                        function k(X) {
                            return new Uint8Array(E(X), 0, X);
                        }
                        a.mallocUint8 = k;
                        function A(X) {
                            return new Uint16Array(E(2 * X), 0, X);
                        }
                        a.mallocUint16 = A;
                        function L(X) {
                            return new Uint32Array(E(4 * X), 0, X);
                        }
                        a.mallocUint32 = L;
                        function _(X) {
                            return new Int8Array(E(X), 0, X);
                        }
                        a.mallocInt8 = _;
                        function C(X) {
                            return new Int16Array(E(2 * X), 0, X);
                        }
                        a.mallocInt16 = C;
                        function M(X) {
                            return new Int32Array(E(4 * X), 0, X);
                        }
                        a.mallocInt32 = M;
                        function g(X) {
                            return new Float32Array(E(4 * X), 0, X);
                        }
                        a.mallocFloat32 = a.mallocFloat = g;
                        function P(X) {
                            return new Float64Array(E(8 * X), 0, X);
                        }
                        a.mallocFloat64 = a.mallocDouble = P;
                        function T(X) {
                            return c ? new Uint8ClampedArray(E(X), 0, X) : k(X);
                        }
                        a.mallocUint8Clamped = T;
                        function F(X) {
                            return f ? new BigUint64Array(E(8 * X), 0, X) : null;
                        }
                        a.mallocBigUint64 = F;
                        function q(X) {
                            return h ? new BigInt64Array(E(8 * X), 0, X) : null;
                        }
                        a.mallocBigInt64 = q;
                        function V(X) {
                            return new DataView(E(X), 0, X);
                        }
                        a.mallocDataView = V;
                        function H(X) {
                            X = s.nextPow2(X);
                            var G = s.log2(X), N = x[G];
                            return N.length > 0 ? N.pop() : new u(X);
                        }
                        a.mallocBuffer = H, a.clearCache = function() {
                            for(var G = 0; G < 32; ++G)d.UINT8[G].length = 0, d.UINT16[G].length = 0, d.UINT32[G].length = 0, d.INT8[G].length = 0, d.INT16[G].length = 0, d.INT32[G].length = 0, d.FLOAT[G].length = 0, d.DOUBLE[G].length = 0, d.BIGUINT64[G].length = 0, d.BIGINT64[G].length = 0, d.UINT8C[G].length = 0, v[G].length = 0, x[G].length = 0;
                        };
                    },
                    1755: function(i) {
                        "use strict";
                        "use restrict";
                        i.exports = a;
                        function a(s) {
                            this.roots = new Array(s), this.ranks = new Array(s);
                            for(var l = 0; l < s; ++l)this.roots[l] = l, this.ranks[l] = 0;
                        }
                        var o = a.prototype;
                        Object.defineProperty(o, "length", {
                            get: function() {
                                return this.roots.length;
                            }
                        }), o.makeSet = function() {
                            var s = this.roots.length;
                            return this.roots.push(s), this.ranks.push(0), s;
                        }, o.find = function(s) {
                            for(var l = s, u = this.roots; u[s] !== s;)s = u[s];
                            for(; u[l] !== s;){
                                var c = u[l];
                                u[l] = s, l = c;
                            }
                            return s;
                        }, o.link = function(s, l) {
                            var u = this.find(s), c = this.find(l);
                            if (u !== c) {
                                var f = this.ranks, h = this.roots, d = f[u], v = f[c];
                                d < v ? h[u] = c : v < d ? h[c] = u : (h[c] = u, ++f[u]);
                            }
                        };
                    },
                    1682: function(i) {
                        "use strict";
                        function a(l, u) {
                            for(var c = 1, f = l.length, h = l[0], d = l[0], v = 1; v < f; ++v)if (d = h, h = l[v], u(h, d)) {
                                if (v === c) {
                                    c++;
                                    continue;
                                }
                                l[c++] = h;
                            }
                            return l.length = c, l;
                        }
                        function o(l) {
                            for(var u = 1, c = l.length, f = l[0], h = l[0], d = 1; d < c; ++d, h = f)if (h = f, f = l[d], f !== h) {
                                if (d === u) {
                                    u++;
                                    continue;
                                }
                                l[u++] = f;
                            }
                            return l.length = u, l;
                        }
                        function s(l, u, c) {
                            return l.length === 0 ? l : u ? (c || l.sort(u), a(l, u)) : (c || l.sort(), o(l));
                        }
                        i.exports = s;
                    },
                    4359: function(i, a, o) {
                        "use strict";
                        i.exports = c;
                        var s = o(7718), l = null, u = null;
                        typeof document != "undefined" && (l = document.createElement("canvas"), l.width = 8192, l.height = 1024, u = l.getContext("2d"));
                        function c(f, h) {
                            return (typeof h != "object" || h === null) && (h = {}), s(f, h.canvas || l, h.context || u, h);
                        }
                    },
                    7718: function(i, a, o) {
                        i.exports = q, i.exports.processPixels = F;
                        var s = o(3711), l = o(9618), u = o(5878), c = o(332), f = o(2538), h = o(2095), d = "b", v = "b|", x = "i", b = "i|", p = "sup", E = "+", k = "+1", A = "sub", L = "-", _ = "-1";
                        function C(V, H, X, G) {
                            for(var N = "<" + V + ">", W = "</" + V + ">", re = N.length, ae = W.length, _e = H[0] === E || H[0] === L, Me = 0, ke = -ae; Me > -1 && (Me = X.indexOf(N, Me), !(Me === -1 || (ke = X.indexOf(W, Me + re), ke === -1) || ke <= Me));){
                                for(var ge = Me; ge < ke + ae; ++ge)if (ge < Me + re || ge >= ke) G[ge] = null, X = X.substr(0, ge) + " " + X.substr(ge + 1);
                                else if (G[ge] !== null) {
                                    var ie = G[ge].indexOf(H[0]);
                                    ie === -1 ? G[ge] += H : _e && (G[ge] = G[ge].substr(0, ie + 1) + (1 + parseInt(G[ge][ie + 1])) + G[ge].substr(ie + 2));
                                }
                                var Te = Me + re, Ee = X.substr(Te, ke - Te), Ae = Ee.indexOf(N);
                                Ae !== -1 ? Me = Ae : Me = ke + ae;
                            }
                            return G;
                        }
                        function M(V, H, X) {
                            for(var G = H.textAlign || "start", N = H.textBaseline || "alphabetic", W = [
                                1073741824,
                                1073741824
                            ], re = [
                                0,
                                0
                            ], ae = V.length, _e = 0; _e < ae; ++_e)for(var Me = V[_e], ke = 0; ke < 2; ++ke)W[ke] = Math.min(W[ke], Me[ke]) | 0, re[ke] = Math.max(re[ke], Me[ke]) | 0;
                            var ge = 0;
                            switch(G){
                                case "center":
                                    ge = -0.5 * (W[0] + re[0]);
                                    break;
                                case "right":
                                case "end":
                                    ge = -re[0];
                                    break;
                                case "left":
                                case "start":
                                    ge = -W[0];
                                    break;
                                default:
                                    throw new Error("vectorize-text: Unrecognized textAlign: '" + G + "'");
                            }
                            var ie = 0;
                            switch(N){
                                case "hanging":
                                case "top":
                                    ie = -W[1];
                                    break;
                                case "middle":
                                    ie = -0.5 * (W[1] + re[1]);
                                    break;
                                case "alphabetic":
                                case "ideographic":
                                    ie = -3 * X;
                                    break;
                                case "bottom":
                                    ie = -re[1];
                                    break;
                                default:
                                    throw new Error("vectorize-text: Unrecoginized textBaseline: '" + N + "'");
                            }
                            var Te = 1 / X;
                            return "lineHeight" in H ? Te *= +H.lineHeight : "width" in H ? Te = H.width / (re[0] - W[0]) : "height" in H && (Te = H.height / (re[1] - W[1])), V.map(function(Ee) {
                                return [
                                    Te * (Ee[0] + ge),
                                    Te * (Ee[1] + ie)
                                ];
                            });
                        }
                        function g(V, H, X, G, N, W) {
                            X = X.replace(/\n/g, ""), W.breaklines === !0 ? X = X.replace(/\<br\>/g, `
`) : X = X.replace(/\<br\>/g, " ");
                            var re = "", ae = [];
                            for(me = 0; me < X.length; ++me)ae[me] = re;
                            W.bolds === !0 && (ae = C(d, v, X, ae)), W.italics === !0 && (ae = C(x, b, X, ae)), W.superscripts === !0 && (ae = C(p, k, X, ae)), W.subscripts === !0 && (ae = C(A, _, X, ae));
                            var _e = [], Me = "";
                            for(me = 0; me < X.length; ++me)ae[me] !== null && (Me += X[me], _e.push(ae[me]));
                            var ke = Me.split(`
`), ge = ke.length, ie = Math.round(N * G), Te = G, Ee = G * 2, Ae = 0, ze = ge * ie + Ee;
                            V.height < ze && (V.height = ze), H.fillStyle = "#000", H.fillRect(0, 0, V.width, V.height), H.fillStyle = "#fff";
                            var Ce, me, Re, ce, Ge, nt = 0, ct = "";
                            function qt() {
                                if (ct !== "") {
                                    var Ke = H.measureText(ct).width;
                                    H.fillText(ct, Te + Re, Ee + ce), Re += Ke;
                                }
                            }
                            function rt() {
                                return "" + Math.round(Ge) + "px ";
                            }
                            function ot(Ke, xt) {
                                var bt = "" + H.font;
                                if (W.subscripts === !0) {
                                    var Lt = Ke.indexOf(L), St = xt.indexOf(L), Et = Lt > -1 ? parseInt(Ke[1 + Lt]) : 0, dt = St > -1 ? parseInt(xt[1 + St]) : 0;
                                    Et !== dt && (bt = bt.replace(rt(), "?px "), Ge *= Math.pow(.75, dt - Et), bt = bt.replace("?px ", rt())), ce += .25 * ie * (dt - Et);
                                }
                                if (W.superscripts === !0) {
                                    var Ht = Ke.indexOf(E), $t = xt.indexOf(E), fr = Ht > -1 ? parseInt(Ke[1 + Ht]) : 0, _r = $t > -1 ? parseInt(xt[1 + $t]) : 0;
                                    fr !== _r && (bt = bt.replace(rt(), "?px "), Ge *= Math.pow(.75, _r - fr), bt = bt.replace("?px ", rt())), ce -= .25 * ie * (_r - fr);
                                }
                                if (W.bolds === !0) {
                                    var Br = Ke.indexOf(v) > -1, Or = xt.indexOf(v) > -1;
                                    !Br && Or && (Nr ? bt = bt.replace("italic ", "italic bold ") : bt = "bold " + bt), Br && !Or && (bt = bt.replace("bold ", ""));
                                }
                                if (W.italics === !0) {
                                    var Nr = Ke.indexOf(b) > -1, ut = xt.indexOf(b) > -1;
                                    !Nr && ut && (bt = "italic " + bt), Nr && !ut && (bt = bt.replace("italic ", ""));
                                }
                                H.font = bt;
                            }
                            for(Ce = 0; Ce < ge; ++Ce){
                                var Rt = ke[Ce] + `
`;
                                for(Re = 0, ce = Ce * ie, Ge = G, ct = "", me = 0; me < Rt.length; ++me){
                                    var kt = me + nt < _e.length ? _e[me + nt] : _e[_e.length - 1];
                                    re === kt ? ct += Rt[me] : (qt(), ct = Rt[me], kt !== void 0 && (ot(re, kt), re = kt));
                                }
                                qt(), nt += Rt.length;
                                var Ct = Math.round(Re + 2 * Te) | 0;
                                Ae < Ct && (Ae = Ct);
                            }
                            var Yt = Ae, xr = Ee + ie * ge, er = l(H.getImageData(0, 0, Yt, xr).data, [
                                xr,
                                Yt,
                                4
                            ]);
                            return er.pick(-1, -1, 0).transpose(1, 0);
                        }
                        function P(V, H) {
                            var X = s(V, 128);
                            return H ? u(X.cells, X.positions, .25) : {
                                edges: X.cells,
                                positions: X.positions
                            };
                        }
                        function T(V, H, X, G) {
                            var N = P(V, G), W = M(N.positions, H, X), re = N.edges, ae = H.orientation === "ccw";
                            if (c(W, re), H.polygons || H.polygon || H.polyline) {
                                for(var _e = h(re, W), Me = new Array(_e.length), ke = 0; ke < _e.length; ++ke){
                                    for(var ge = _e[ke], ie = new Array(ge.length), Te = 0; Te < ge.length; ++Te){
                                        for(var Ee = ge[Te], Ae = new Array(Ee.length), ze = 0; ze < Ee.length; ++ze)Ae[ze] = W[Ee[ze]].slice();
                                        ae && Ae.reverse(), ie[Te] = Ae;
                                    }
                                    Me[ke] = ie;
                                }
                                return Me;
                            } else return H.triangles || H.triangulate || H.triangle ? {
                                cells: f(W, re, {
                                    delaunay: !1,
                                    exterior: !1,
                                    interior: !0
                                }),
                                positions: W
                            } : {
                                edges: re,
                                positions: W
                            };
                        }
                        function F(V, H, X) {
                            try {
                                return T(V, H, X, !0);
                            } catch (G) {}
                            try {
                                return T(V, H, X, !1);
                            } catch (G) {}
                            return H.polygons || H.polyline || H.polygon ? [] : H.triangles || H.triangulate || H.triangle ? {
                                cells: [],
                                positions: []
                            } : {
                                edges: [],
                                positions: []
                            };
                        }
                        function q(V, H, X, G) {
                            var N = 64, W = 1.25, re = {
                                breaklines: !1,
                                bolds: !1,
                                italics: !1,
                                subscripts: !1,
                                superscripts: !1
                            };
                            G && (G.size && G.size > 0 && (N = G.size), G.lineSpacing && G.lineSpacing > 0 && (W = G.lineSpacing), G.styletags && G.styletags.breaklines && (re.breaklines = !!G.styletags.breaklines), G.styletags && G.styletags.bolds && (re.bolds = !!G.styletags.bolds), G.styletags && G.styletags.italics && (re.italics = !!G.styletags.italics), G.styletags && G.styletags.subscripts && (re.subscripts = !!G.styletags.subscripts), G.styletags && G.styletags.superscripts && (re.superscripts = !!G.styletags.superscripts)), X.font = [
                                G.fontStyle,
                                G.fontVariant,
                                G.fontWeight,
                                N + "px",
                                G.font
                            ].filter(function(_e) {
                                return _e;
                            }).join(" "), X.textAlign = "start", X.textBaseline = "alphabetic", X.direction = "ltr";
                            var ae = g(H, X, V, N, W, re);
                            return F(ae, G, N);
                        }
                    },
                    1538: function(i) {
                        (function() {
                            "use strict";
                            if (typeof ses != "undefined" && ses.ok && !ses.ok()) return;
                            function o(T) {
                                T.permitHostObjects___ && T.permitHostObjects___(o);
                            }
                            typeof ses != "undefined" && (ses.weakMapPermitHostObjects = o);
                            var s = !1;
                            if (typeof WeakMap == "function") {
                                var l = WeakMap;
                                if (!(typeof navigator != "undefined" && /Firefox/.test(navigator.userAgent))) {
                                    var u = new l, c = Object.freeze({});
                                    if (u.set(c, 1), u.get(c) !== 1) s = !0;
                                    else {
                                        i.exports = WeakMap;
                                        return;
                                    }
                                }
                            }
                            var f = Object.prototype.hasOwnProperty, h = Object.getOwnPropertyNames, d = Object.defineProperty, v = Object.isExtensible, x = "weakmap:", b = x + "ident:" + Math.random() + "___";
                            if (typeof crypto != "undefined" && typeof crypto.getRandomValues == "function" && typeof ArrayBuffer == "function" && typeof Uint8Array == "function") {
                                var p = new ArrayBuffer(25), E = new Uint8Array(p);
                                crypto.getRandomValues(E), b = x + "rand:" + Array.prototype.map.call(E, function(T) {
                                    return (T % 36).toString(36);
                                }).join("") + "___";
                            }
                            function k(T) {
                                return !(T.substr(0, x.length) == x && T.substr(T.length - 3) === "___");
                            }
                            if (d(Object, "getOwnPropertyNames", {
                                value: function(F) {
                                    return h(F).filter(k);
                                }
                            }), "getPropertyNames" in Object) {
                                var A = Object.getPropertyNames;
                                d(Object, "getPropertyNames", {
                                    value: function(F) {
                                        return A(F).filter(k);
                                    }
                                });
                            }
                            function L(T) {
                                if (T !== Object(T)) throw new TypeError("Not an object: " + T);
                                var F = T[b];
                                if (F && F.key === T) return F;
                                if (v(T)) {
                                    F = {
                                        key: T
                                    };
                                    try {
                                        return d(T, b, {
                                            value: F,
                                            writable: !1,
                                            enumerable: !1,
                                            configurable: !1
                                        }), F;
                                    } catch (q) {
                                        return;
                                    }
                                }
                            }
                            (function() {
                                var T = Object.freeze;
                                d(Object, "freeze", {
                                    value: function(H) {
                                        return L(H), T(H);
                                    }
                                });
                                var F = Object.seal;
                                d(Object, "seal", {
                                    value: function(H) {
                                        return L(H), F(H);
                                    }
                                });
                                var q = Object.preventExtensions;
                                d(Object, "preventExtensions", {
                                    value: function(H) {
                                        return L(H), q(H);
                                    }
                                });
                            })();
                            function _(T) {
                                return T.prototype = null, Object.freeze(T);
                            }
                            var C = !1;
                            function M() {
                                !C && typeof console != "undefined" && (C = !0, console.warn("WeakMap should be invoked as new WeakMap(), not WeakMap(). This will be an error in the future."));
                            }
                            var g = 0, P = function() {
                                this instanceof P || M();
                                var T = [], F = [], q = g++;
                                function V(N, W) {
                                    var re, ae = L(N);
                                    return ae ? q in ae ? ae[q] : W : (re = T.indexOf(N), re >= 0 ? F[re] : W);
                                }
                                function H(N) {
                                    var W = L(N);
                                    return W ? q in W : T.indexOf(N) >= 0;
                                }
                                function X(N, W) {
                                    var re, ae = L(N);
                                    return ae ? ae[q] = W : (re = T.indexOf(N), re >= 0 ? F[re] = W : (re = T.length, F[re] = W, T[re] = N)), this;
                                }
                                function G(N) {
                                    var W = L(N), re, ae;
                                    return W ? q in W && delete W[q] : (re = T.indexOf(N), re < 0 ? !1 : (ae = T.length - 1, T[re] = void 0, F[re] = F[ae], T[re] = T[ae], T.length = ae, F.length = ae, !0));
                                }
                                return Object.create(P.prototype, {
                                    get___: {
                                        value: _(V)
                                    },
                                    has___: {
                                        value: _(H)
                                    },
                                    set___: {
                                        value: _(X)
                                    },
                                    delete___: {
                                        value: _(G)
                                    }
                                });
                            };
                            P.prototype = Object.create(Object.prototype, {
                                get: {
                                    value: function(F, q) {
                                        return this.get___(F, q);
                                    },
                                    writable: !0,
                                    configurable: !0
                                },
                                has: {
                                    value: function(F) {
                                        return this.has___(F);
                                    },
                                    writable: !0,
                                    configurable: !0
                                },
                                set: {
                                    value: function(F, q) {
                                        return this.set___(F, q);
                                    },
                                    writable: !0,
                                    configurable: !0
                                },
                                delete: {
                                    value: function(F) {
                                        return this.delete___(F);
                                    },
                                    writable: !0,
                                    configurable: !0
                                }
                            }), typeof l == "function" ? function() {
                                s && typeof Proxy != "undefined" && (Proxy = void 0);
                                function T() {
                                    this instanceof P || M();
                                    var F = new l, q = void 0, V = !1;
                                    function H(W, re) {
                                        return q ? F.has(W) ? F.get(W) : q.get___(W, re) : F.get(W, re);
                                    }
                                    function X(W) {
                                        return F.has(W) || (q ? q.has___(W) : !1);
                                    }
                                    var G;
                                    s ? G = function(W, re) {
                                        return F.set(W, re), F.has(W) || (q || (q = new P), q.set(W, re)), this;
                                    } : G = function(W, re) {
                                        if (V) try {
                                            F.set(W, re);
                                        } catch (ae) {
                                            q || (q = new P), q.set___(W, re);
                                        }
                                        else F.set(W, re);
                                        return this;
                                    };
                                    function N(W) {
                                        var re = !!F.delete(W);
                                        return q && q.delete___(W) || re;
                                    }
                                    return Object.create(P.prototype, {
                                        get___: {
                                            value: _(H)
                                        },
                                        has___: {
                                            value: _(X)
                                        },
                                        set___: {
                                            value: _(G)
                                        },
                                        delete___: {
                                            value: _(N)
                                        },
                                        permitHostObjects___: {
                                            value: _(function(W) {
                                                if (W === o) V = !0;
                                                else throw new Error("bogus call to permitHostObjects___");
                                            })
                                        }
                                    });
                                }
                                T.prototype = P.prototype, i.exports = T, Object.defineProperty(WeakMap.prototype, "constructor", {
                                    value: WeakMap,
                                    enumerable: !1,
                                    configurable: !0,
                                    writable: !0
                                });
                            }() : (typeof Proxy != "undefined" && (Proxy = void 0), i.exports = P);
                        })();
                    },
                    236: function(i, a, o) {
                        var s = o(8284);
                        i.exports = l;
                        function l() {
                            var u = {};
                            return function(c) {
                                if ((typeof c != "object" || c === null) && typeof c != "function") throw new Error("Weakmap-shim: Key must be object");
                                var f = c.valueOf(u);
                                return f && f.identity === u ? f : s(c, u);
                            };
                        }
                    },
                    8284: function(i) {
                        i.exports = a;
                        function a(o, s) {
                            var l = {
                                identity: s
                            }, u = o.valueOf;
                            return Object.defineProperty(o, "valueOf", {
                                value: function(c) {
                                    return c !== s ? u.apply(this, arguments) : l;
                                },
                                writable: !0
                            }), l;
                        }
                    },
                    606: function(i, a, o) {
                        var s = o(236);
                        i.exports = l;
                        function l() {
                            var u = s();
                            return {
                                get: function(c, f) {
                                    var h = u(c);
                                    return h.hasOwnProperty("value") ? h.value : f;
                                },
                                set: function(c, f) {
                                    return u(c).value = f, this;
                                },
                                has: function(c) {
                                    return "value" in u(c);
                                },
                                delete: function(c) {
                                    return delete u(c).value;
                                }
                            };
                        }
                    },
                    3349: function(i) {
                        "use strict";
                        function a() {
                            return function(f, h, d, v, x, b) {
                                var p = f[0], E = d[0], k = [
                                    0
                                ], A = E;
                                v |= 0;
                                var L = 0, _ = E;
                                for(L = 0; L < p; ++L){
                                    var C = h[v] - b, M = h[v + A] - b;
                                    C >= 0 != M >= 0 && x.push(k[0] + .5 + .5 * (C + M) / (C - M));
                                    v += _, ++k[0];
                                }
                            };
                        }
                        function o() {
                            return a();
                        }
                        var s = o;
                        function l(f) {
                            var h = {};
                            return function(v, x, b) {
                                var p = v.dtype, E = v.order, k = [
                                    p,
                                    E.join()
                                ].join(), A = h[k];
                                return A || (h[k] = A = f([
                                    p,
                                    E
                                ])), A(v.shape.slice(0), v.data, v.stride, v.offset | 0, x, b);
                            };
                        }
                        function u(f) {
                            return l(s.bind(void 0, f));
                        }
                        function c(f) {
                            return u({
                                funcName: f.funcName
                            });
                        }
                        i.exports = c({
                            funcName: "zeroCrossings"
                        });
                    },
                    781: function(i, a, o) {
                        "use strict";
                        i.exports = l;
                        var s = o(3349);
                        function l(u, c) {
                            var f = [];
                            return c = +c || 0, s(u.hi(u.shape[0] - 1), f, c), f;
                        }
                    },
                    7790: function() {}
                }, t = {};
                function r(i) {
                    var a = t[i];
                    if (a !== void 0) return a.exports;
                    var o = t[i] = {
                        id: i,
                        loaded: !1,
                        exports: {}
                    };
                    return e[i].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
                }
                (function() {
                    r.g = function() {
                        if (typeof globalThis == "object") return globalThis;
                        try {
                            return this || new Function("return this")();
                        } catch (i) {
                            if (typeof window == "object") return window;
                        }
                    }();
                })(), function() {
                    r.nmd = function(i) {
                        return i.paths = [], i.children || (i.children = []), i;
                    };
                }();
                var n = r(1964);
                cLe.exports = n;
            })();
        });
        var rZ = ye((ivr, fLe)=>{
            "use strict";
            fLe.exports = {
                aliceblue: [
                    240,
                    248,
                    255
                ],
                antiquewhite: [
                    250,
                    235,
                    215
                ],
                aqua: [
                    0,
                    255,
                    255
                ],
                aquamarine: [
                    127,
                    255,
                    212
                ],
                azure: [
                    240,
                    255,
                    255
                ],
                beige: [
                    245,
                    245,
                    220
                ],
                bisque: [
                    255,
                    228,
                    196
                ],
                black: [
                    0,
                    0,
                    0
                ],
                blanchedalmond: [
                    255,
                    235,
                    205
                ],
                blue: [
                    0,
                    0,
                    255
                ],
                blueviolet: [
                    138,
                    43,
                    226
                ],
                brown: [
                    165,
                    42,
                    42
                ],
                burlywood: [
                    222,
                    184,
                    135
                ],
                cadetblue: [
                    95,
                    158,
                    160
                ],
                chartreuse: [
                    127,
                    255,
                    0
                ],
                chocolate: [
                    210,
                    105,
                    30
                ],
                coral: [
                    255,
                    127,
                    80
                ],
                cornflowerblue: [
                    100,
                    149,
                    237
                ],
                cornsilk: [
                    255,
                    248,
                    220
                ],
                crimson: [
                    220,
                    20,
                    60
                ],
                cyan: [
                    0,
                    255,
                    255
                ],
                darkblue: [
                    0,
                    0,
                    139
                ],
                darkcyan: [
                    0,
                    139,
                    139
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11
                ],
                darkgray: [
                    169,
                    169,
                    169
                ],
                darkgreen: [
                    0,
                    100,
                    0
                ],
                darkgrey: [
                    169,
                    169,
                    169
                ],
                darkkhaki: [
                    189,
                    183,
                    107
                ],
                darkmagenta: [
                    139,
                    0,
                    139
                ],
                darkolivegreen: [
                    85,
                    107,
                    47
                ],
                darkorange: [
                    255,
                    140,
                    0
                ],
                darkorchid: [
                    153,
                    50,
                    204
                ],
                darkred: [
                    139,
                    0,
                    0
                ],
                darksalmon: [
                    233,
                    150,
                    122
                ],
                darkseagreen: [
                    143,
                    188,
                    143
                ],
                darkslateblue: [
                    72,
                    61,
                    139
                ],
                darkslategray: [
                    47,
                    79,
                    79
                ],
                darkslategrey: [
                    47,
                    79,
                    79
                ],
                darkturquoise: [
                    0,
                    206,
                    209
                ],
                darkviolet: [
                    148,
                    0,
                    211
                ],
                deeppink: [
                    255,
                    20,
                    147
                ],
                deepskyblue: [
                    0,
                    191,
                    255
                ],
                dimgray: [
                    105,
                    105,
                    105
                ],
                dimgrey: [
                    105,
                    105,
                    105
                ],
                dodgerblue: [
                    30,
                    144,
                    255
                ],
                firebrick: [
                    178,
                    34,
                    34
                ],
                floralwhite: [
                    255,
                    250,
                    240
                ],
                forestgreen: [
                    34,
                    139,
                    34
                ],
                fuchsia: [
                    255,
                    0,
                    255
                ],
                gainsboro: [
                    220,
                    220,
                    220
                ],
                ghostwhite: [
                    248,
                    248,
                    255
                ],
                gold: [
                    255,
                    215,
                    0
                ],
                goldenrod: [
                    218,
                    165,
                    32
                ],
                gray: [
                    128,
                    128,
                    128
                ],
                green: [
                    0,
                    128,
                    0
                ],
                greenyellow: [
                    173,
                    255,
                    47
                ],
                grey: [
                    128,
                    128,
                    128
                ],
                honeydew: [
                    240,
                    255,
                    240
                ],
                hotpink: [
                    255,
                    105,
                    180
                ],
                indianred: [
                    205,
                    92,
                    92
                ],
                indigo: [
                    75,
                    0,
                    130
                ],
                ivory: [
                    255,
                    255,
                    240
                ],
                khaki: [
                    240,
                    230,
                    140
                ],
                lavender: [
                    230,
                    230,
                    250
                ],
                lavenderblush: [
                    255,
                    240,
                    245
                ],
                lawngreen: [
                    124,
                    252,
                    0
                ],
                lemonchiffon: [
                    255,
                    250,
                    205
                ],
                lightblue: [
                    173,
                    216,
                    230
                ],
                lightcoral: [
                    240,
                    128,
                    128
                ],
                lightcyan: [
                    224,
                    255,
                    255
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210
                ],
                lightgray: [
                    211,
                    211,
                    211
                ],
                lightgreen: [
                    144,
                    238,
                    144
                ],
                lightgrey: [
                    211,
                    211,
                    211
                ],
                lightpink: [
                    255,
                    182,
                    193
                ],
                lightsalmon: [
                    255,
                    160,
                    122
                ],
                lightseagreen: [
                    32,
                    178,
                    170
                ],
                lightskyblue: [
                    135,
                    206,
                    250
                ],
                lightslategray: [
                    119,
                    136,
                    153
                ],
                lightslategrey: [
                    119,
                    136,
                    153
                ],
                lightsteelblue: [
                    176,
                    196,
                    222
                ],
                lightyellow: [
                    255,
                    255,
                    224
                ],
                lime: [
                    0,
                    255,
                    0
                ],
                limegreen: [
                    50,
                    205,
                    50
                ],
                linen: [
                    250,
                    240,
                    230
                ],
                magenta: [
                    255,
                    0,
                    255
                ],
                maroon: [
                    128,
                    0,
                    0
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170
                ],
                mediumblue: [
                    0,
                    0,
                    205
                ],
                mediumorchid: [
                    186,
                    85,
                    211
                ],
                mediumpurple: [
                    147,
                    112,
                    219
                ],
                mediumseagreen: [
                    60,
                    179,
                    113
                ],
                mediumslateblue: [
                    123,
                    104,
                    238
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154
                ],
                mediumturquoise: [
                    72,
                    209,
                    204
                ],
                mediumvioletred: [
                    199,
                    21,
                    133
                ],
                midnightblue: [
                    25,
                    25,
                    112
                ],
                mintcream: [
                    245,
                    255,
                    250
                ],
                mistyrose: [
                    255,
                    228,
                    225
                ],
                moccasin: [
                    255,
                    228,
                    181
                ],
                navajowhite: [
                    255,
                    222,
                    173
                ],
                navy: [
                    0,
                    0,
                    128
                ],
                oldlace: [
                    253,
                    245,
                    230
                ],
                olive: [
                    128,
                    128,
                    0
                ],
                olivedrab: [
                    107,
                    142,
                    35
                ],
                orange: [
                    255,
                    165,
                    0
                ],
                orangered: [
                    255,
                    69,
                    0
                ],
                orchid: [
                    218,
                    112,
                    214
                ],
                palegoldenrod: [
                    238,
                    232,
                    170
                ],
                palegreen: [
                    152,
                    251,
                    152
                ],
                paleturquoise: [
                    175,
                    238,
                    238
                ],
                palevioletred: [
                    219,
                    112,
                    147
                ],
                papayawhip: [
                    255,
                    239,
                    213
                ],
                peachpuff: [
                    255,
                    218,
                    185
                ],
                peru: [
                    205,
                    133,
                    63
                ],
                pink: [
                    255,
                    192,
                    203
                ],
                plum: [
                    221,
                    160,
                    221
                ],
                powderblue: [
                    176,
                    224,
                    230
                ],
                purple: [
                    128,
                    0,
                    128
                ],
                rebeccapurple: [
                    102,
                    51,
                    153
                ],
                red: [
                    255,
                    0,
                    0
                ],
                rosybrown: [
                    188,
                    143,
                    143
                ],
                royalblue: [
                    65,
                    105,
                    225
                ],
                saddlebrown: [
                    139,
                    69,
                    19
                ],
                salmon: [
                    250,
                    128,
                    114
                ],
                sandybrown: [
                    244,
                    164,
                    96
                ],
                seagreen: [
                    46,
                    139,
                    87
                ],
                seashell: [
                    255,
                    245,
                    238
                ],
                sienna: [
                    160,
                    82,
                    45
                ],
                silver: [
                    192,
                    192,
                    192
                ],
                skyblue: [
                    135,
                    206,
                    235
                ],
                slateblue: [
                    106,
                    90,
                    205
                ],
                slategray: [
                    112,
                    128,
                    144
                ],
                slategrey: [
                    112,
                    128,
                    144
                ],
                snow: [
                    255,
                    250,
                    250
                ],
                springgreen: [
                    0,
                    255,
                    127
                ],
                steelblue: [
                    70,
                    130,
                    180
                ],
                tan: [
                    210,
                    180,
                    140
                ],
                teal: [
                    0,
                    128,
                    128
                ],
                thistle: [
                    216,
                    191,
                    216
                ],
                tomato: [
                    255,
                    99,
                    71
                ],
                turquoise: [
                    64,
                    224,
                    208
                ],
                violet: [
                    238,
                    130,
                    238
                ],
                wheat: [
                    245,
                    222,
                    179
                ],
                white: [
                    255,
                    255,
                    255
                ],
                whitesmoke: [
                    245,
                    245,
                    245
                ],
                yellow: [
                    255,
                    255,
                    0
                ],
                yellowgreen: [
                    154,
                    205,
                    50
                ]
            };
        });
        var pLe = ye((nvr, vLe)=>{
            "use strict";
            var hLe = rZ();
            vLe.exports = lLt;
            var dLe = {
                red: 0,
                orange: 60,
                yellow: 120,
                green: 180,
                blue: 240,
                purple: 300
            };
            function lLt(e) {
                var t, r = [], n = 1, i;
                if (typeof e == "string") {
                    if (e = e.toLowerCase(), hLe[e]) r = hLe[e].slice(), i = "rgb";
                    else if (e === "transparent") n = 0, i = "rgb", r = [
                        0,
                        0,
                        0
                    ];
                    else if (/^#[A-Fa-f0-9]+$/.test(e)) {
                        var a = e.slice(1), o = a.length, s = o <= 4;
                        n = 1, s ? (r = [
                            parseInt(a[0] + a[0], 16),
                            parseInt(a[1] + a[1], 16),
                            parseInt(a[2] + a[2], 16)
                        ], o === 4 && (n = parseInt(a[3] + a[3], 16) / 255)) : (r = [
                            parseInt(a[0] + a[1], 16),
                            parseInt(a[2] + a[3], 16),
                            parseInt(a[4] + a[5], 16)
                        ], o === 8 && (n = parseInt(a[6] + a[7], 16) / 255)), r[0] || (r[0] = 0), r[1] || (r[1] = 0), r[2] || (r[2] = 0), i = "rgb";
                    } else if (t = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(e)) {
                        var l = t[1], u = l === "rgb", a = l.replace(/a$/, "");
                        i = a;
                        var o = a === "cmyk" ? 4 : a === "gray" ? 1 : 3;
                        r = t[2].trim().split(/\s*[,\/]\s*|\s+/).map(function(h, d) {
                            if (/%$/.test(h)) return d === o ? parseFloat(h) / 100 : a === "rgb" ? parseFloat(h) * 255 / 100 : parseFloat(h);
                            if (a[d] === "h") {
                                if (/deg$/.test(h)) return parseFloat(h);
                                if (dLe[h] !== void 0) return dLe[h];
                            }
                            return parseFloat(h);
                        }), l === a && r.push(1), n = u || r[o] === void 0 ? 1 : r[o], r = r.slice(0, o);
                    } else e.length > 10 && /[0-9](?:\s|\/)/.test(e) && (r = e.match(/([0-9]+)/g).map(function(c) {
                        return parseFloat(c);
                    }), i = e.match(/([a-z])/ig).join("").toLowerCase());
                } else isNaN(e) ? Array.isArray(e) || e.length ? (r = [
                    e[0],
                    e[1],
                    e[2]
                ], i = "rgb", n = e.length === 4 ? e[3] : 1) : e instanceof Object && (e.r != null || e.red != null || e.R != null ? (i = "rgb", r = [
                    e.r || e.red || e.R || 0,
                    e.g || e.green || e.G || 0,
                    e.b || e.blue || e.B || 0
                ]) : (i = "hsl", r = [
                    e.h || e.hue || e.H || 0,
                    e.s || e.saturation || e.S || 0,
                    e.l || e.lightness || e.L || e.b || e.brightness
                ]), n = e.a || e.alpha || e.opacity || 1, e.opacity != null && (n /= 100)) : (i = "rgb", r = [
                    e >>> 16,
                    (e & 65280) >>> 8,
                    e & 255
                ]);
                return {
                    space: i,
                    values: r,
                    alpha: n
                };
            }
        });
        var mLe = ye((avr, gLe)=>{
            "use strict";
            var uLt = pLe();
            gLe.exports = function(t) {
                Array.isArray(t) && t.raw && (t = String.raw.apply(null, arguments));
                var r, n, i, a = uLt(t);
                if (!a.space) return [];
                var o = [
                    0,
                    0,
                    0
                ], s = a.space[0] === "h" ? [
                    360,
                    100,
                    100
                ] : [
                    255,
                    255,
                    255
                ];
                return r = Array(3), r[0] = Math.min(Math.max(a.values[0], o[0]), s[0]), r[1] = Math.min(Math.max(a.values[1], o[1]), s[1]), r[2] = Math.min(Math.max(a.values[2], o[2]), s[2]), a.space[0] === "h" && (r = cLt(r)), r.push(Math.min(Math.max(a.alpha, 0), 1)), r;
            };
            function cLt(e) {
                var t = e[0] / 360, r = e[1] / 100, n = e[2] / 100, i, a, o, s, l, u = 0;
                if (r === 0) return l = n * 255, [
                    l,
                    l,
                    l
                ];
                for(a = n < .5 ? n * (1 + r) : n + r - n * r, i = 2 * n - a, s = [
                    0,
                    0,
                    0
                ]; u < 3;)o = t + 1 / 3 * -(u - 1), o < 0 ? o++ : o > 1 && o--, l = 6 * o < 1 ? i + (a - i) * 6 * o : 2 * o < 1 ? a : 3 * o < 2 ? i + (a - i) * (2 / 3 - o) * 6 : i, s[u++] = l * 255;
                return s;
            }
        });
        var VE = ye((ovr, yLe)=>{
            yLe.exports = fLt;
            function fLt(e, t, r) {
                return t < r ? e < t ? t : e > r ? r : e : e < r ? r : e > t ? t : e;
            }
        });
        var HD = ye((svr, _Le)=>{
            _Le.exports = function(e) {
                switch(e){
                    case "int8":
                        return Int8Array;
                    case "int16":
                        return Int16Array;
                    case "int32":
                        return Int32Array;
                    case "uint8":
                        return Uint8Array;
                    case "uint16":
                        return Uint16Array;
                    case "uint32":
                        return Uint32Array;
                    case "float32":
                        return Float32Array;
                    case "float64":
                        return Float64Array;
                    case "array":
                        return Array;
                    case "uint8_clamped":
                        return Uint8ClampedArray;
                }
            };
        });
        var $_ = ye((lvr, xLe)=>{
            "use strict";
            var hLt = mLe(), GD = VE(), dLt = HD();
            xLe.exports = function(t, r) {
                (r === "float" || !r) && (r = "array"), r === "uint" && (r = "uint8"), r === "uint_clamped" && (r = "uint8_clamped");
                var n = dLt(r), i = new n(4), a = r !== "uint8" && r !== "uint8_clamped";
                return (!t.length || typeof t == "string") && (t = hLt(t), t[0] /= 255, t[1] /= 255, t[2] /= 255), vLt(t) ? (i[0] = t[0], i[1] = t[1], i[2] = t[2], i[3] = t[3] != null ? t[3] : 255, a && (i[0] /= 255, i[1] /= 255, i[2] /= 255, i[3] /= 255), i) : (a ? (i[0] = t[0], i[1] = t[1], i[2] = t[2], i[3] = t[3] != null ? t[3] : 1) : (i[0] = GD(Math.floor(t[0] * 255), 0, 255), i[1] = GD(Math.floor(t[1] * 255), 0, 255), i[2] = GD(Math.floor(t[2] * 255), 0, 255), i[3] = t[3] == null ? 255 : GD(Math.floor(t[3] * 255), 0, 255)), i);
            };
            function vLt(e) {
                return !!(e instanceof Uint8Array || e instanceof Uint8ClampedArray || Array.isArray(e) && (e[0] > 1 || e[0] === 0) && (e[1] > 1 || e[1] === 0) && (e[2] > 1 || e[2] === 0) && (!e[3] || e[3] > 1));
            }
        });
        var Jy = ye((uvr, bLe)=>{
            "use strict";
            var pLt = $_();
            function gLt(e) {
                return e ? pLt(e) : [
                    0,
                    0,
                    0,
                    1
                ];
            }
            bLe.exports = gLt;
        });
        var $y = ye((cvr, kLe)=>{
            "use strict";
            var MLe = uo(), mLt = id(), jD = $_(), WD = Mu(), yLt = dh().defaultLine, wLe = vv().isArrayOrTypedArray, iZ = jD(yLt), ELe = 1;
            function TLe(e, t) {
                var r = e;
                return r[3] *= t, r;
            }
            function ALe(e) {
                if (MLe(e)) return iZ;
                var t = jD(e);
                return t.length ? t : iZ;
            }
            function SLe(e) {
                return MLe(e) ? e : ELe;
            }
            function _Lt(e, t, r) {
                var n = e.color;
                n && n._inputArray && (n = n._inputArray);
                var i = wLe(n), a = wLe(t), o = WD.extractOpts(e), s = [], l, u, c, f, h;
                if (o.colorscale !== void 0 ? l = WD.makeColorScaleFuncFromTrace(e) : l = ALe, i ? u = function(v, x) {
                    return v[x] === void 0 ? iZ : jD(l(v[x]));
                } : u = ALe, a ? c = function(v, x) {
                    return v[x] === void 0 ? ELe : SLe(v[x]);
                } : c = SLe, i || a) for(var d = 0; d < r; d++)f = u(n, d), h = c(t, d), s[d] = TLe(f, h);
                else s = TLe(jD(n), t);
                return s;
            }
            function xLt(e) {
                var t = WD.extractOpts(e), r = t.colorscale;
                return t.reversescale && (r = WD.flipScale(t.colorscale)), r.map(function(n) {
                    var i = n[0], a = mLt(n[1]), o = a.toRgb();
                    return {
                        index: i,
                        rgb: [
                            o.r,
                            o.g,
                            o.b,
                            o.a
                        ]
                    };
                });
            }
            kLe.exports = {
                formatColor: _Lt,
                parseColorScale: xLt
            };
        });
        var nZ = ye((fvr, CLe)=>{
            "use strict";
            CLe.exports = {
                solid: [
                    [],
                    0
                ],
                dot: [
                    [
                        .5,
                        1
                    ],
                    200
                ],
                dash: [
                    [
                        .5,
                        1
                    ],
                    50
                ],
                longdash: [
                    [
                        .5,
                        1
                    ],
                    10
                ],
                dashdot: [
                    [
                        .5,
                        .625,
                        .875,
                        1
                    ],
                    50
                ],
                longdashdot: [
                    [
                        .5,
                        .7,
                        .8,
                        1
                    ],
                    10
                ]
            };
        });
        var ZD = ye((hvr, LLe)=>{
            "use strict";
            LLe.exports = {
                circle: "\u25CF",
                "circle-open": "\u25CB",
                square: "\u25A0",
                "square-open": "\u25A1",
                diamond: "\u25C6",
                "diamond-open": "\u25C7",
                cross: "+",
                x: "\u274C"
            };
        });
        var ILe = ye((dvr, PLe)=>{
            "use strict";
            var bLt = ba();
            function aZ(e, t, r, n) {
                if (!t || !t.visible) return null;
                for(var i = bLt.getComponentMethod("errorbars", "makeComputeError")(t), a = new Array(e.length), o = 0; o < e.length; o++){
                    var s = i(+e[o], o);
                    if (n.type === "log") {
                        var l = n.c2l(e[o]), u = e[o] - s[0], c = e[o] + s[1];
                        if (a[o] = [
                            (n.c2l(u, !0) - l) * r,
                            (n.c2l(c, !0) - l) * r
                        ], u > 0) {
                            var f = n.c2l(u);
                            n._lowerLogErrorBound || (n._lowerLogErrorBound = f), n._lowerErrorBound = Math.min(n._lowerLogErrorBound, f);
                        }
                    } else a[o] = [
                        -s[0] * r,
                        s[1] * r
                    ];
                }
                return a;
            }
            function wLt(e) {
                for(var t = 0; t < e.length; t++)if (e[t]) return e[t].length;
                return 0;
            }
            function TLt(e, t, r) {
                var n = [
                    aZ(e.x, e.error_x, t[0], r.xaxis),
                    aZ(e.y, e.error_y, t[1], r.yaxis),
                    aZ(e.z, e.error_z, t[2], r.zaxis)
                ], i = wLt(n);
                if (i === 0) return null;
                for(var a = new Array(i), o = 0; o < i; o++){
                    for(var s = [
                        [
                            0,
                            0,
                            0
                        ],
                        [
                            0,
                            0,
                            0
                        ]
                    ], l = 0; l < 3; l++)if (n[l]) for(var u = 0; u < 2; u++)s[u][l] = n[l][o][u];
                    a[o] = s;
                }
                return a;
            }
            PLe.exports = TLt;
        });
        var ULe = ye((vvr, NLe)=>{
            "use strict";
            var ALt = Rd().gl_line3d, RLe = Rd().gl_scatter3d, SLt = Rd().gl_error3d, MLt = Rd().gl_mesh3d, ELt = Rd().delaunay_triangulate, Qy = Mr(), OLe = Jy(), XD = $y().formatColor, kLt = S3(), oZ = nZ(), CLt = ZD(), LLt = Qa(), PLt = rp().appendArrayPointValue, ILt = ILe();
            function BLe(e, t) {
                this.scene = e, this.uid = t, this.linePlot = null, this.scatterPlot = null, this.errorBars = null, this.textMarkers = null, this.delaunayMesh = null, this.color = null, this.mode = "", this.dataPoints = [], this.axesBounds = [
                    [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ],
                    [
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ]
                ], this.textLabels = null, this.data = null;
            }
            var lZ = BLe.prototype;
            lZ.handlePick = function(e) {
                if (e.object && (e.object === this.linePlot || e.object === this.delaunayMesh || e.object === this.textMarkers || e.object === this.scatterPlot)) {
                    var t = e.index = e.data.index;
                    return e.object.highlight && e.object.highlight(null), this.scatterPlot && (e.object = this.scatterPlot, this.scatterPlot.highlight(e.data)), e.textLabel = "", this.textLabels && (Qy.isArrayOrTypedArray(this.textLabels) ? (this.textLabels[t] || this.textLabels[t] === 0) && (e.textLabel = this.textLabels[t]) : e.textLabel = this.textLabels), e.traceCoordinate = [
                        this.data.x[t],
                        this.data.y[t],
                        this.data.z[t]
                    ], !0;
                }
            };
            function RLt(e, t, r) {
                var n = (r + 1) % 3, i = (r + 2) % 3, a = [], o = [], s;
                for(s = 0; s < e.length; ++s){
                    var l = e[s];
                    isNaN(l[n]) || !isFinite(l[n]) || isNaN(l[i]) || !isFinite(l[i]) || (a.push([
                        l[n],
                        l[i]
                    ]), o.push(s));
                }
                var u = ELt(a);
                for(s = 0; s < u.length; ++s)for(var c = u[s], f = 0; f < c.length; ++f)c[f] = o[c[f]];
                return {
                    positions: e,
                    cells: u,
                    meshColor: t
                };
            }
            function DLt(e) {
                for(var t = [
                    0,
                    0,
                    0
                ], r = [
                    [
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0
                    ]
                ], n = [
                    1,
                    1,
                    1
                ], i = 0; i < 3; i++){
                    var a = e[i];
                    a && a.copy_zstyle !== !1 && e[2].visible !== !1 && (a = e[2]), !(!a || !a.visible) && (t[i] = a.width / 2, r[i] = OLe(a.color), n[i] = a.thickness);
                }
                return {
                    capSize: t,
                    color: r,
                    lineWidth: n
                };
            }
            function DLe(e) {
                return e == null ? 0 : e.indexOf("left") > -1 ? -1 : e.indexOf("right") > -1 ? 1 : 0;
            }
            function zLe(e) {
                return e == null ? 0 : e.indexOf("top") > -1 ? -1 : e.indexOf("bottom") > -1 ? 1 : 0;
            }
            function zLt(e) {
                var t = 0, r = 0, n = [
                    t,
                    r
                ];
                if (Array.isArray(e)) for(var i = 0; i < e.length; i++)n[i] = [
                    t,
                    r
                ], e[i] && (n[i][0] = DLe(e[i]), n[i][1] = zLe(e[i]));
                else n[0] = DLe(e), n[1] = zLe(e);
                return n;
            }
            function FLt(e, t) {
                return t(e * 4);
            }
            function qLt(e) {
                return CLt[e];
            }
            function sZ(e, t, r, n, i) {
                var a = null;
                if (Qy.isArrayOrTypedArray(e)) {
                    a = [];
                    for(var o = 0; o < t; o++)e[o] === void 0 ? a[o] = n : a[o] = r(e[o], i);
                } else a = r(e, Qy.identity);
                return a;
            }
            function OLt(e, t) {
                var r = [], n = e.fullSceneLayout, i = e.dataScale, a = n.xaxis, o = n.yaxis, s = n.zaxis, l = t.marker, u = t.line, c = t.x || [], f = t.y || [], h = t.z || [], d = c.length, v = t.xcalendar, x = t.ycalendar, b = t.zcalendar, p, E, k, A, L, _;
                for(L = 0; L < d; L++)p = a.d2l(c[L], 0, v) * i[0], E = o.d2l(f[L], 0, x) * i[1], k = s.d2l(h[L], 0, b) * i[2], r[L] = [
                    p,
                    E,
                    k
                ];
                if (Array.isArray(t.text)) _ = t.text;
                else if (Qy.isTypedArray(t.text)) _ = Array.from(t.text);
                else if (t.text !== void 0) for(_ = new Array(d), L = 0; L < d; L++)_[L] = t.text;
                function C(_e, Me) {
                    var ke = n[_e];
                    return LLt.tickText(ke, ke.d2l(Me), !0).text;
                }
                var M = t.texttemplate;
                if (M) {
                    var g = e.fullLayout, P = g._d3locale, T = Array.isArray(M), F = T ? Math.min(M.length, d) : d, q = T ? function(_e) {
                        return M[_e];
                    } : function() {
                        return M;
                    };
                    for(_ = new Array(F), L = 0; L < F; L++){
                        var V = {
                            x: c[L],
                            y: f[L],
                            z: h[L]
                        }, H = {
                            xLabel: C("xaxis", c[L]),
                            yLabel: C("yaxis", f[L]),
                            zLabel: C("zaxis", h[L])
                        }, X = {};
                        PLt(X, t, L);
                        var G = t._meta || {};
                        _[L] = Qy.texttemplateString(q(L), H, P, X, V, G);
                    }
                }
                if (A = {
                    position: r,
                    mode: t.mode,
                    text: _
                }, "line" in t && (A.lineColor = XD(u, 1, d), A.lineWidth = u.width, A.lineDashes = u.dash), "marker" in t) {
                    var N = kLt(t);
                    A.scatterColor = XD(l, 1, d), A.scatterSize = sZ(l.size, d, FLt, 20, N), A.scatterMarker = sZ(l.symbol, d, qLt, "\u25CF"), A.scatterLineWidth = l.line.width, A.scatterLineColor = XD(l.line, 1, d), A.scatterAngle = 0;
                }
                "textposition" in t && (A.textOffset = zLt(t.textposition), A.textColor = XD(t.textfont, 1, d), A.textSize = sZ(t.textfont.size, d, Qy.identity, 12), A.textFontFamily = t.textfont.family, A.textFontWeight = t.textfont.weight, A.textFontStyle = t.textfont.style, A.textFontVariant = t.textfont.variant, A.textAngle = 0);
                var W = [
                    "x",
                    "y",
                    "z"
                ];
                for(A.project = [
                    !1,
                    !1,
                    !1
                ], A.projectScale = [
                    1,
                    1,
                    1
                ], A.projectOpacity = [
                    1,
                    1,
                    1
                ], L = 0; L < 3; ++L){
                    var re = t.projection[W[L]];
                    (A.project[L] = re.show) && (A.projectOpacity[L] = re.opacity, A.projectScale[L] = re.scale);
                }
                A.errorBounds = ILt(t, i, n);
                var ae = DLt([
                    t.error_x,
                    t.error_y,
                    t.error_z
                ]);
                return A.errorColor = ae.color, A.errorLineWidth = ae.lineWidth, A.errorCapSize = ae.capSize, A.delaunayAxis = t.surfaceaxis, A.delaunayColor = OLe(t.surfacecolor), A;
            }
            function FLe(e) {
                if (Qy.isArrayOrTypedArray(e)) {
                    var t = e[0];
                    return Qy.isArrayOrTypedArray(t) && (e = t), "rgb(" + e.slice(0, 3).map(function(r) {
                        return Math.round(r * 255);
                    }) + ")";
                }
                return null;
            }
            function qLe(e) {
                return Qy.isArrayOrTypedArray(e) ? e.length === 4 && typeof e[0] == "number" ? FLe(e) : e.map(FLe) : null;
            }
            lZ.update = function(e) {
                var t = this.scene.glplot.gl, r, n, i, a, o = oZ.solid;
                this.data = e;
                var s = OLt(this.scene, e);
                "mode" in s && (this.mode = s.mode), "lineDashes" in s && s.lineDashes in oZ && (o = oZ[s.lineDashes]), this.color = qLe(s.scatterColor) || qLe(s.lineColor), this.dataPoints = s.position, r = {
                    gl: this.scene.glplot.gl,
                    position: s.position,
                    color: s.lineColor,
                    lineWidth: s.lineWidth || 1,
                    dashes: o[0],
                    dashScale: o[1],
                    opacity: e.opacity,
                    connectGaps: e.connectgaps
                }, this.mode.indexOf("lines") !== -1 ? this.linePlot ? this.linePlot.update(r) : (this.linePlot = ALt(r), this.linePlot._trace = this, this.scene.glplot.add(this.linePlot)) : this.linePlot && (this.scene.glplot.remove(this.linePlot), this.linePlot.dispose(), this.linePlot = null);
                var l = e.opacity;
                if (e.marker && e.marker.opacity !== void 0 && (l *= e.marker.opacity), n = {
                    gl: this.scene.glplot.gl,
                    position: s.position,
                    color: s.scatterColor,
                    size: s.scatterSize,
                    glyph: s.scatterMarker,
                    opacity: l,
                    orthographic: !0,
                    lineWidth: s.scatterLineWidth,
                    lineColor: s.scatterLineColor,
                    project: s.project,
                    projectScale: s.projectScale,
                    projectOpacity: s.projectOpacity
                }, this.mode.indexOf("markers") !== -1 ? this.scatterPlot ? this.scatterPlot.update(n) : (this.scatterPlot = RLe(n), this.scatterPlot._trace = this, this.scatterPlot.highlightScale = 1, this.scene.glplot.add(this.scatterPlot)) : this.scatterPlot && (this.scene.glplot.remove(this.scatterPlot), this.scatterPlot.dispose(), this.scatterPlot = null), a = {
                    gl: this.scene.glplot.gl,
                    position: s.position,
                    glyph: s.text,
                    color: s.textColor,
                    size: s.textSize,
                    angle: s.textAngle,
                    alignment: s.textOffset,
                    font: s.textFontFamily,
                    fontWeight: s.textFontWeight,
                    fontStyle: s.textFontStyle,
                    fontVariant: s.textFontVariant,
                    orthographic: !0,
                    lineWidth: 0,
                    project: !1,
                    opacity: e.opacity
                }, this.textLabels = e.hovertext || e.text, this.mode.indexOf("text") !== -1 ? this.textMarkers ? this.textMarkers.update(a) : (this.textMarkers = RLe(a), this.textMarkers._trace = this, this.textMarkers.highlightScale = 1, this.scene.glplot.add(this.textMarkers)) : this.textMarkers && (this.scene.glplot.remove(this.textMarkers), this.textMarkers.dispose(), this.textMarkers = null), i = {
                    gl: this.scene.glplot.gl,
                    position: s.position,
                    color: s.errorColor,
                    error: s.errorBounds,
                    lineWidth: s.errorLineWidth,
                    capSize: s.errorCapSize,
                    opacity: e.opacity
                }, this.errorBars ? s.errorBounds ? this.errorBars.update(i) : (this.scene.glplot.remove(this.errorBars), this.errorBars.dispose(), this.errorBars = null) : s.errorBounds && (this.errorBars = SLt(i), this.errorBars._trace = this, this.scene.glplot.add(this.errorBars)), s.delaunayAxis >= 0) {
                    var u = RLt(s.position, s.delaunayColor, s.delaunayAxis);
                    u.opacity = e.opacity, this.delaunayMesh ? this.delaunayMesh.update(u) : (u.gl = t, this.delaunayMesh = MLt(u), this.delaunayMesh._trace = this, this.scene.glplot.add(this.delaunayMesh));
                } else this.delaunayMesh && (this.scene.glplot.remove(this.delaunayMesh), this.delaunayMesh.dispose(), this.delaunayMesh = null);
            };
            lZ.dispose = function() {
                this.linePlot && (this.scene.glplot.remove(this.linePlot), this.linePlot.dispose()), this.scatterPlot && (this.scene.glplot.remove(this.scatterPlot), this.scatterPlot.dispose()), this.errorBars && (this.scene.glplot.remove(this.errorBars), this.errorBars.dispose()), this.textMarkers && (this.scene.glplot.remove(this.textMarkers), this.textMarkers.dispose()), this.delaunayMesh && (this.scene.glplot.remove(this.delaunayMesh), this.delaunayMesh.dispose());
            };
            function BLt(e, t) {
                var r = new BLe(e, t.uid);
                return r.update(t), r;
            }
            NLe.exports = BLt;
        });
        var dZ = ye((pvr, GLe)=>{
            "use strict";
            var e1 = Uc(), NLt = Su(), hZ = Jl(), uZ = Oc().axisHoverFormat, ULt = Wo().hovertemplateAttrs, VLt = Wo().texttemplateAttrs, VLe = vl(), HLt = nZ(), GLt = ZD(), Yg = no().extendFlat, jLt = Bu().overrideAll, HLe = Y1(), WLt = e1.line, N2 = e1.marker, ZLt = N2.line, XLt = Yg({
                width: WLt.width,
                dash: {
                    valType: "enumerated",
                    values: HLe(HLt),
                    dflt: "solid"
                }
            }, hZ("line"));
            function cZ(e) {
                return {
                    show: {
                        valType: "boolean",
                        dflt: !1
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1
                    },
                    scale: {
                        valType: "number",
                        min: 0,
                        max: 10,
                        dflt: 2 / 3
                    }
                };
            }
            var fZ = GLe.exports = jLt({
                x: e1.x,
                y: e1.y,
                z: {
                    valType: "data_array"
                },
                text: Yg({}, e1.text, {}),
                texttemplate: VLt({}, {}),
                hovertext: Yg({}, e1.hovertext, {}),
                hovertemplate: ULt(),
                xhoverformat: uZ("x"),
                yhoverformat: uZ("y"),
                zhoverformat: uZ("z"),
                mode: Yg({}, e1.mode, {
                    dflt: "lines+markers"
                }),
                surfaceaxis: {
                    valType: "enumerated",
                    values: [
                        -1,
                        0,
                        1,
                        2
                    ],
                    dflt: -1
                },
                surfacecolor: {
                    valType: "color"
                },
                projection: {
                    x: cZ("x"),
                    y: cZ("y"),
                    z: cZ("z")
                },
                connectgaps: e1.connectgaps,
                line: XLt,
                marker: Yg({
                    symbol: {
                        valType: "enumerated",
                        values: HLe(GLt),
                        dflt: "circle",
                        arrayOk: !0
                    },
                    size: Yg({}, N2.size, {
                        dflt: 8
                    }),
                    sizeref: N2.sizeref,
                    sizemin: N2.sizemin,
                    sizemode: N2.sizemode,
                    opacity: Yg({}, N2.opacity, {
                        arrayOk: !1
                    }),
                    colorbar: N2.colorbar,
                    line: Yg({
                        width: Yg({}, ZLt.width, {
                            arrayOk: !1
                        })
                    }, hZ("marker.line"))
                }, hZ("marker")),
                textposition: Yg({}, e1.textposition, {
                    dflt: "top center"
                }),
                textfont: NLt({
                    noFontShadow: !0,
                    noFontLineposition: !0,
                    noFontTextcase: !0,
                    editType: "calc",
                    colorEditType: "style",
                    arrayOk: !0,
                    variantValues: [
                        "normal",
                        "small-caps"
                    ]
                }),
                opacity: VLe.opacity,
                hoverinfo: Yg({}, VLe.hoverinfo)
            }, "calc", "nested");
            fZ.x.editType = fZ.y.editType = fZ.z.editType = "calc+clearAxisTypes";
        });
        var ZLe = ye((gvr, WLe)=>{
            "use strict";
            var jLe = ba(), YLt = Mr(), vZ = lu(), KLt = $p(), JLt = R0(), $Lt = D0(), QLt = dZ();
            WLe.exports = function(t, r, n, i) {
                function a(d, v) {
                    return YLt.coerce(t, r, QLt, d, v);
                }
                var o = ePt(t, r, a, i);
                if (!o) {
                    r.visible = !1;
                    return;
                }
                a("text"), a("hovertext"), a("hovertemplate"), a("xhoverformat"), a("yhoverformat"), a("zhoverformat"), a("mode"), vZ.hasMarkers(r) && KLt(t, r, n, i, a, {
                    noSelect: !0,
                    noAngle: !0
                }), vZ.hasLines(r) && (a("connectgaps"), JLt(t, r, n, i, a)), vZ.hasText(r) && (a("texttemplate"), $Lt(t, r, i, a, {
                    noSelect: !0,
                    noFontShadow: !0,
                    noFontLineposition: !0,
                    noFontTextcase: !0
                }));
                var s = (r.line || {}).color, l = (r.marker || {}).color;
                a("surfaceaxis") >= 0 && a("surfacecolor", s || l);
                for(var u = [
                    "x",
                    "y",
                    "z"
                ], c = 0; c < 3; ++c){
                    var f = "projection." + u[c];
                    a(f + ".show") && (a(f + ".opacity"), a(f + ".scale"));
                }
                var h = jLe.getComponentMethod("errorbars", "supplyDefaults");
                h(t, r, s || l || n, {
                    axis: "z"
                }), h(t, r, s || l || n, {
                    axis: "y",
                    inherit: "z"
                }), h(t, r, s || l || n, {
                    axis: "x",
                    inherit: "z"
                });
            };
            function ePt(e, t, r, n) {
                var i = 0, a = r("x"), o = r("y"), s = r("z"), l = jLe.getComponentMethod("calendars", "handleTraceDefaults");
                return l(e, t, [
                    "x",
                    "y",
                    "z"
                ], n), a && o && s && (i = Math.min(a.length, o.length, s.length), t._length = t._xlength = t._ylength = t._zlength = i), i;
            }
        });
        var YLe = ye((mvr, XLe)=>{
            "use strict";
            var tPt = km(), rPt = z0();
            XLe.exports = function(t, r) {
                var n = [
                    {
                        x: !1,
                        y: !1,
                        trace: r,
                        t: {}
                    }
                ];
                return tPt(n, r), rPt(t, r), n;
            };
        });
        var JLe = ye((yvr, KLe)=>{
            KLe.exports = iPt;
            function iPt(e, t) {
                if (typeof e != "string") throw new TypeError("must specify type string");
                if (t = t || {}, typeof document == "undefined" && !t.canvas) return null;
                var r = t.canvas || document.createElement("canvas");
                typeof t.width == "number" && (r.width = t.width), typeof t.height == "number" && (r.height = t.height);
                var n = t, i;
                try {
                    var a = [
                        e
                    ];
                    e.indexOf("webgl") === 0 && a.push("experimental-" + e);
                    for(var o = 0; o < a.length; o++)if (i = r.getContext(a[o], n), i) return i;
                } catch (s) {
                    i = null;
                }
                return i || null;
            }
        });
        var QLe = ye((_vr, $Le)=>{
            var nPt = JLe();
            $Le.exports = function(t) {
                return nPt("webgl", t);
            };
        });
        var pZ = ye((xvr, tPe)=>{
            "use strict";
            var ePe = va(), aPt = function() {};
            tPe.exports = function(t) {
                for(var r in t)typeof t[r] == "function" && (t[r] = aPt);
                t.destroy = function() {
                    t.container.parentNode.removeChild(t.container);
                };
                var n = document.createElement("div");
                n.className = "no-webgl", n.style.cursor = "pointer", n.style.fontSize = "24px", n.style.color = ePe.defaults[0], n.style.position = "absolute", n.style.left = n.style.top = "0px", n.style.width = n.style.height = "100%", n.style["background-color"] = ePe.lightLine, n.style["z-index"] = 30;
                var i = document.createElement("p");
                return i.textContent = "WebGL is not supported by your browser - visit https://get.webgl.org for more info", i.style.position = "relative", i.style.top = "50%", i.style.left = "50%", i.style.height = "30%", i.style.width = "50%", i.style.margin = "-15% 0 0 -25%", n.appendChild(i), t.container.appendChild(n), t.container.style.background = "#FFFFFF", t.container.onclick = function() {
                    window.open("https://get.webgl.org");
                }, !1;
            };
        });
        var nPe = ye((bvr, iPe)=>{
            "use strict";
            var U2 = Jy(), oPt = Mr(), sPt = [
                "xaxis",
                "yaxis",
                "zaxis"
            ];
            function rPe() {
                this.bounds = [
                    [
                        -10,
                        -10,
                        -10
                    ],
                    [
                        10,
                        10,
                        10
                    ]
                ], this.ticks = [
                    [],
                    [],
                    []
                ], this.tickEnable = [
                    !0,
                    !0,
                    !0
                ], this.tickFont = [
                    "sans-serif",
                    "sans-serif",
                    "sans-serif"
                ], this.tickSize = [
                    12,
                    12,
                    12
                ], this.tickFontWeight = [
                    "normal",
                    "normal",
                    "normal",
                    "normal"
                ], this.tickFontStyle = [
                    "normal",
                    "normal",
                    "normal",
                    "normal"
                ], this.tickFontVariant = [
                    "normal",
                    "normal",
                    "normal",
                    "normal"
                ], this.tickAngle = [
                    0,
                    0,
                    0
                ], this.tickColor = [
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ]
                ], this.tickPad = [
                    18,
                    18,
                    18
                ], this.labels = [
                    "x",
                    "y",
                    "z"
                ], this.labelEnable = [
                    !0,
                    !0,
                    !0
                ], this.labelFont = [
                    "Open Sans",
                    "Open Sans",
                    "Open Sans"
                ], this.labelSize = [
                    20,
                    20,
                    20
                ], this.labelFontWeight = [
                    "normal",
                    "normal",
                    "normal",
                    "normal"
                ], this.labelFontStyle = [
                    "normal",
                    "normal",
                    "normal",
                    "normal"
                ], this.labelFontVariant = [
                    "normal",
                    "normal",
                    "normal",
                    "normal"
                ], this.labelColor = [
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ]
                ], this.labelPad = [
                    30,
                    30,
                    30
                ], this.lineEnable = [
                    !0,
                    !0,
                    !0
                ], this.lineMirror = [
                    !1,
                    !1,
                    !1
                ], this.lineWidth = [
                    1,
                    1,
                    1
                ], this.lineColor = [
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ]
                ], this.lineTickEnable = [
                    !0,
                    !0,
                    !0
                ], this.lineTickMirror = [
                    !1,
                    !1,
                    !1
                ], this.lineTickLength = [
                    10,
                    10,
                    10
                ], this.lineTickWidth = [
                    1,
                    1,
                    1
                ], this.lineTickColor = [
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ]
                ], this.gridEnable = [
                    !0,
                    !0,
                    !0
                ], this.gridWidth = [
                    1,
                    1,
                    1
                ], this.gridColor = [
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ]
                ], this.zeroEnable = [
                    !0,
                    !0,
                    !0
                ], this.zeroLineColor = [
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ]
                ], this.zeroLineWidth = [
                    2,
                    2,
                    2
                ], this.backgroundEnable = [
                    !0,
                    !0,
                    !0
                ], this.backgroundColor = [
                    [
                        .8,
                        .8,
                        .8,
                        .5
                    ],
                    [
                        .8,
                        .8,
                        .8,
                        .5
                    ],
                    [
                        .8,
                        .8,
                        .8,
                        .5
                    ]
                ], this._defaultTickPad = this.tickPad.slice(), this._defaultLabelPad = this.labelPad.slice(), this._defaultLineTickLength = this.lineTickLength.slice();
            }
            var lPt = rPe.prototype;
            lPt.merge = function(e, t) {
                for(var r = this, n = 0; n < 3; ++n){
                    var i = t[sPt[n]];
                    if (!i.visible) {
                        r.tickEnable[n] = !1, r.labelEnable[n] = !1, r.lineEnable[n] = !1, r.lineTickEnable[n] = !1, r.gridEnable[n] = !1, r.zeroEnable[n] = !1, r.backgroundEnable[n] = !1;
                        continue;
                    }
                    r.labels[n] = e._meta ? oPt.templateString(i.title.text, e._meta) : i.title.text, "font" in i.title && (i.title.font.color && (r.labelColor[n] = U2(i.title.font.color)), i.title.font.family && (r.labelFont[n] = i.title.font.family), i.title.font.size && (r.labelSize[n] = i.title.font.size), i.title.font.weight && (r.labelFontWeight[n] = i.title.font.weight), i.title.font.style && (r.labelFontStyle[n] = i.title.font.style), i.title.font.variant && (r.labelFontVariant[n] = i.title.font.variant)), "showline" in i && (r.lineEnable[n] = i.showline), "linecolor" in i && (r.lineColor[n] = U2(i.linecolor)), "linewidth" in i && (r.lineWidth[n] = i.linewidth), "showgrid" in i && (r.gridEnable[n] = i.showgrid), "gridcolor" in i && (r.gridColor[n] = U2(i.gridcolor)), "gridwidth" in i && (r.gridWidth[n] = i.gridwidth), i.type === "log" ? r.zeroEnable[n] = !1 : "zeroline" in i && (r.zeroEnable[n] = i.zeroline), "zerolinecolor" in i && (r.zeroLineColor[n] = U2(i.zerolinecolor)), "zerolinewidth" in i && (r.zeroLineWidth[n] = i.zerolinewidth), "ticks" in i && i.ticks ? r.lineTickEnable[n] = !0 : r.lineTickEnable[n] = !1, "ticklen" in i && (r.lineTickLength[n] = r._defaultLineTickLength[n] = i.ticklen), "tickcolor" in i && (r.lineTickColor[n] = U2(i.tickcolor)), "tickwidth" in i && (r.lineTickWidth[n] = i.tickwidth), "tickangle" in i && (r.tickAngle[n] = i.tickangle === "auto" ? -3600 : Math.PI * -i.tickangle / 180), "showticklabels" in i && (r.tickEnable[n] = i.showticklabels), "tickfont" in i && (i.tickfont.color && (r.tickColor[n] = U2(i.tickfont.color)), i.tickfont.family && (r.tickFont[n] = i.tickfont.family), i.tickfont.size && (r.tickSize[n] = i.tickfont.size), i.tickfont.weight && (r.tickFontWeight[n] = i.tickfont.weight), i.tickfont.style && (r.tickFontStyle[n] = i.tickfont.style), i.tickfont.variant && (r.tickFontVariant[n] = i.tickfont.variant)), "mirror" in i ? [
                        "ticks",
                        "all",
                        "allticks"
                    ].indexOf(i.mirror) !== -1 ? (r.lineTickMirror[n] = !0, r.lineMirror[n] = !0) : i.mirror === !0 ? (r.lineTickMirror[n] = !1, r.lineMirror[n] = !0) : (r.lineTickMirror[n] = !1, r.lineMirror[n] = !1) : r.lineMirror[n] = !1, "showbackground" in i && i.showbackground !== !1 ? (r.backgroundEnable[n] = !0, r.backgroundColor[n] = U2(i.backgroundcolor)) : r.backgroundEnable[n] = !1;
                }
            };
            function uPt(e, t) {
                var r = new rPe;
                return r.merge(e, t), r;
            }
            iPe.exports = uPt;
        });
        var sPe = ye((wvr, oPe)=>{
            "use strict";
            var cPt = Jy(), fPt = [
                "xaxis",
                "yaxis",
                "zaxis"
            ];
            function aPe() {
                this.enabled = [
                    !0,
                    !0,
                    !0
                ], this.colors = [
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ],
                    [
                        0,
                        0,
                        0,
                        1
                    ]
                ], this.drawSides = [
                    !0,
                    !0,
                    !0
                ], this.lineWidth = [
                    1,
                    1,
                    1
                ];
            }
            var hPt = aPe.prototype;
            hPt.merge = function(e) {
                for(var t = 0; t < 3; ++t){
                    var r = e[fPt[t]];
                    if (!r.visible) {
                        this.enabled[t] = !1, this.drawSides[t] = !1;
                        continue;
                    }
                    this.enabled[t] = r.showspikes, this.colors[t] = cPt(r.spikecolor), this.drawSides[t] = r.spikesides, this.lineWidth[t] = r.spikethickness;
                }
            };
            function dPt(e) {
                var t = new aPe;
                return t.merge(e), t;
            }
            oPe.exports = dPt;
        });
        var cPe = ye((Tvr, uPe)=>{
            "use strict";
            uPe.exports = yPt;
            var lPe = Qa(), vPt = Mr(), pPt = [
                "xaxis",
                "yaxis",
                "zaxis"
            ], gPt = [
                0,
                0,
                0
            ];
            function mPt(e) {
                for(var t = new Array(3), r = 0; r < 3; ++r){
                    for(var n = e[r], i = new Array(n.length), a = 0; a < n.length; ++a)i[a] = n[a].x;
                    t[r] = i;
                }
                return t;
            }
            function yPt(e) {
                for(var t = e.axesOptions, r = e.glplot.axesPixels, n = e.fullSceneLayout, i = [
                    [],
                    [],
                    []
                ], a = 0; a < 3; ++a){
                    var o = n[pPt[a]];
                    if (o._length = (r[a].hi - r[a].lo) * r[a].pixelsPerDataUnit / e.dataScale[a], Math.abs(o._length) === 1 / 0 || isNaN(o._length)) i[a] = [];
                    else {
                        o._input_range = o.range.slice(), o.range[0] = r[a].lo / e.dataScale[a], o.range[1] = r[a].hi / e.dataScale[a], o._m = 1 / (e.dataScale[a] * r[a].pixelsPerDataUnit), o.range[0] === o.range[1] && (o.range[0] -= 1, o.range[1] += 1);
                        var s = o.tickmode;
                        if (o.tickmode === "auto") {
                            o.tickmode = "linear";
                            var l = o.nticks || vPt.constrain(o._length / 40, 4, 9);
                            lPe.autoTicks(o, Math.abs(o.range[1] - o.range[0]) / l);
                        }
                        for(var u = lPe.calcTicks(o, {
                            msUTC: !0
                        }), c = 0; c < u.length; ++c)u[c].x = u[c].x * e.dataScale[a], o.type === "date" && (u[c].text = u[c].text.replace(/\<br\>/g, " "));
                        i[a] = u, o.tickmode = s;
                    }
                }
                t.ticks = i;
                for(var a = 0; a < 3; ++a){
                    gPt[a] = .5 * (e.glplot.bounds[0][a] + e.glplot.bounds[1][a]);
                    for(var c = 0; c < 2; ++c)t.bounds[c][a] = e.glplot.bounds[c][a];
                }
                e.contourLevels = mPt(i);
            }
        });
        var mPe = ye((Avr, gPe)=>{
            "use strict";
            var dPe = Rd().gl_plot3d, _Pt = dPe.createCamera, fPe = dPe.createScene, xPt = QLe(), bPt = kL(), JD = ba(), up = Mr(), KD = up.preserveDrawingBuffer(), $D = Qa(), Kg = Nc(), wPt = Jy(), TPt = pZ(), APt = DU(), SPt = nPe(), MPt = sPe(), EPt = cPe(), kPt = wg().applyAutorangeOptions, HE, YD, vPe = !1;
            function pPe(e, t) {
                var r = document.createElement("div"), n = e.container;
                this.graphDiv = e.graphDiv;
                var i = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                i.style.position = "absolute", i.style.top = i.style.left = "0px", i.style.width = i.style.height = "100%", i.style["z-index"] = 20, i.style["pointer-events"] = "none", r.appendChild(i), this.svgContainer = i, r.id = e.id, r.style.position = "absolute", r.style.top = r.style.left = "0px", r.style.width = r.style.height = "100%", n.appendChild(r), this.fullLayout = t, this.id = e.id || "scene", this.fullSceneLayout = t[this.id], this.plotArgs = [
                    [],
                    {},
                    {}
                ], this.axesOptions = SPt(t, t[this.id]), this.spikeOptions = MPt(t[this.id]), this.container = r, this.staticMode = !!e.staticPlot, this.pixelRatio = this.pixelRatio || e.plotGlPixelRatio || 2, this.dataScale = [
                    1,
                    1,
                    1
                ], this.contourLevels = [
                    [],
                    [],
                    []
                ], this.convertAnnotations = JD.getComponentMethod("annotations3d", "convert"), this.drawAnnotations = JD.getComponentMethod("annotations3d", "draw"), this.initializeGLPlot();
            }
            var wv = pPe.prototype;
            wv.prepareOptions = function() {
                var e = this, t = {
                    canvas: e.canvas,
                    gl: e.gl,
                    glOptions: {
                        preserveDrawingBuffer: KD,
                        premultipliedAlpha: !0,
                        antialias: !0
                    },
                    container: e.container,
                    axes: e.axesOptions,
                    spikes: e.spikeOptions,
                    pickRadius: 10,
                    snapToData: !0,
                    autoScale: !0,
                    autoBounds: !1,
                    cameraObject: e.camera,
                    pixelRatio: e.pixelRatio
                };
                if (e.staticMode) {
                    if (!YD && (HE = document.createElement("canvas"), YD = xPt({
                        canvas: HE,
                        preserveDrawingBuffer: !0,
                        premultipliedAlpha: !0,
                        antialias: !0
                    }), !YD)) throw new Error("error creating static canvas/context for image server");
                    t.gl = YD, t.canvas = HE;
                }
                return t;
            };
            var hPe = !0;
            wv.tryCreatePlot = function() {
                var e = this, t = e.prepareOptions(), r = !0;
                try {
                    e.glplot = fPe(t);
                } catch (n) {
                    if (e.staticMode || !hPe || KD) r = !1;
                    else {
                        up.warn([
                            "webgl setup failed possibly due to",
                            "false preserveDrawingBuffer config.",
                            "The mobile/tablet device may not be detected by is-mobile module.",
                            "Enabling preserveDrawingBuffer in second attempt to create webgl scene..."
                        ].join(" "));
                        try {
                            KD = t.glOptions.preserveDrawingBuffer = !0, e.glplot = fPe(t);
                        } catch (i) {
                            KD = t.glOptions.preserveDrawingBuffer = !1, r = !1;
                        }
                    }
                }
                return hPe = !1, r;
            };
            wv.initializeGLCamera = function() {
                var e = this, t = e.fullSceneLayout.camera, r = t.projection.type === "orthographic";
                e.camera = _Pt(e.container, {
                    center: [
                        t.center.x,
                        t.center.y,
                        t.center.z
                    ],
                    eye: [
                        t.eye.x,
                        t.eye.y,
                        t.eye.z
                    ],
                    up: [
                        t.up.x,
                        t.up.y,
                        t.up.z
                    ],
                    _ortho: r,
                    zoomMin: .01,
                    zoomMax: 100,
                    mode: "orbit"
                });
            };
            wv.initializeGLPlot = function() {
                var e = this;
                e.initializeGLCamera();
                var t = e.tryCreatePlot();
                if (!t) return TPt(e);
                e.traces = {}, e.make4thDimension();
                var r = e.graphDiv, n = r.layout, i = function() {
                    var o = {};
                    return e.isCameraChanged(n) && (o[e.id + ".camera"] = e.getCamera()), e.isAspectChanged(n) && (o[e.id + ".aspectratio"] = e.glplot.getAspectratio(), n[e.id].aspectmode !== "manual" && (e.fullSceneLayout.aspectmode = n[e.id].aspectmode = o[e.id + ".aspectmode"] = "manual")), o;
                }, a = function(o) {
                    if (o.fullSceneLayout.dragmode !== !1) {
                        var s = i();
                        o.saveLayout(n), o.graphDiv.emit("plotly_relayout", s);
                    }
                };
                return e.glplot.canvas && (e.glplot.canvas.addEventListener("mouseup", function() {
                    a(e);
                }), e.glplot.canvas.addEventListener("touchstart", function() {
                    vPe = !0;
                }), e.glplot.canvas.addEventListener("wheel", function(o) {
                    if (r._context._scrollZoom.gl3d) {
                        if (e.camera._ortho) {
                            var s = o.deltaX > o.deltaY ? 1.1 : .9090909090909091, l = e.glplot.getAspectratio();
                            e.glplot.setAspectratio({
                                x: s * l.x,
                                y: s * l.y,
                                z: s * l.z
                            });
                        }
                        a(e);
                    }
                }, bPt ? {
                    passive: !1
                } : !1), e.glplot.canvas.addEventListener("mousemove", function() {
                    if (e.fullSceneLayout.dragmode !== !1 && e.camera.mouseListener.buttons !== 0) {
                        var o = i();
                        e.graphDiv.emit("plotly_relayouting", o);
                    }
                }), e.staticMode || e.glplot.canvas.addEventListener("webglcontextlost", function(o) {
                    r && r.emit && r.emit("plotly_webglcontextlost", {
                        event: o,
                        layer: e.id
                    });
                }, !1)), e.glplot.oncontextloss = function() {
                    e.recoverContext();
                }, e.glplot.onrender = function() {
                    e.render();
                }, !0;
            };
            wv.render = function() {
                var e = this, t = e.graphDiv, r, n = e.svgContainer, i = e.container.getBoundingClientRect();
                t._fullLayout._calcInverseTransform(t);
                var a = t._fullLayout._invScaleX, o = t._fullLayout._invScaleY, s = i.width * a, l = i.height * o;
                n.setAttributeNS(null, "viewBox", "0 0 " + s + " " + l), n.setAttributeNS(null, "width", s), n.setAttributeNS(null, "height", l), EPt(e), e.glplot.axes.update(e.axesOptions);
                for(var u = Object.keys(e.traces), c = null, f = e.glplot.selection, h = 0; h < u.length; ++h)r = e.traces[u[h]], r.data.hoverinfo !== "skip" && r.handlePick(f) && (c = r), r.setContourLevels && r.setContourLevels();
                function d(P, T, F) {
                    var q = e.fullSceneLayout[P + "axis"];
                    return q.type !== "log" && (T = q.d2l(T)), $D.hoverLabelText(q, T, F);
                }
                if (c !== null) {
                    var v = APt(e.glplot.cameraParams, f.dataCoordinate);
                    r = c.data;
                    var x = t._fullData[r.index], b = f.index, p = {
                        xLabel: d("x", f.traceCoordinate[0], r.xhoverformat),
                        yLabel: d("y", f.traceCoordinate[1], r.yhoverformat),
                        zLabel: d("z", f.traceCoordinate[2], r.zhoverformat)
                    }, E = Kg.castHoverinfo(x, e.fullLayout, b), k = (E || "").split("+"), A = E && E === "all";
                    !x.hovertemplate && !A && (k.indexOf("x") === -1 && (p.xLabel = void 0), k.indexOf("y") === -1 && (p.yLabel = void 0), k.indexOf("z") === -1 && (p.zLabel = void 0), k.indexOf("text") === -1 && (f.textLabel = void 0), k.indexOf("name") === -1 && (c.name = void 0));
                    var L, _ = [];
                    r.type === "cone" || r.type === "streamtube" ? (p.uLabel = d("x", f.traceCoordinate[3], r.uhoverformat), (A || k.indexOf("u") !== -1) && _.push("u: " + p.uLabel), p.vLabel = d("y", f.traceCoordinate[4], r.vhoverformat), (A || k.indexOf("v") !== -1) && _.push("v: " + p.vLabel), p.wLabel = d("z", f.traceCoordinate[5], r.whoverformat), (A || k.indexOf("w") !== -1) && _.push("w: " + p.wLabel), p.normLabel = f.traceCoordinate[6].toPrecision(3), (A || k.indexOf("norm") !== -1) && _.push("norm: " + p.normLabel), r.type === "streamtube" && (p.divergenceLabel = f.traceCoordinate[7].toPrecision(3), (A || k.indexOf("divergence") !== -1) && _.push("divergence: " + p.divergenceLabel)), f.textLabel && _.push(f.textLabel), L = _.join("<br>")) : r.type === "isosurface" || r.type === "volume" ? (p.valueLabel = $D.hoverLabelText(e._mockAxis, e._mockAxis.d2l(f.traceCoordinate[3]), r.valuehoverformat), _.push("value: " + p.valueLabel), f.textLabel && _.push(f.textLabel), L = _.join("<br>")) : L = f.textLabel;
                    var C = {
                        x: f.traceCoordinate[0],
                        y: f.traceCoordinate[1],
                        z: f.traceCoordinate[2],
                        data: x._input,
                        fullData: x,
                        curveNumber: x.index,
                        pointNumber: b
                    };
                    Kg.appendArrayPointValue(C, x, b), r._module.eventData && (C = x._module.eventData(C, f, x, {}, b));
                    var M = {
                        points: [
                            C
                        ]
                    };
                    if (e.fullSceneLayout.hovermode) {
                        var g = [];
                        Kg.loneHover({
                            trace: x,
                            x: (.5 + .5 * v[0] / v[3]) * s,
                            y: (.5 - .5 * v[1] / v[3]) * l,
                            xLabel: p.xLabel,
                            yLabel: p.yLabel,
                            zLabel: p.zLabel,
                            text: L,
                            name: c.name,
                            color: Kg.castHoverOption(x, b, "bgcolor") || c.color,
                            borderColor: Kg.castHoverOption(x, b, "bordercolor"),
                            fontFamily: Kg.castHoverOption(x, b, "font.family"),
                            fontSize: Kg.castHoverOption(x, b, "font.size"),
                            fontColor: Kg.castHoverOption(x, b, "font.color"),
                            nameLength: Kg.castHoverOption(x, b, "namelength"),
                            textAlign: Kg.castHoverOption(x, b, "align"),
                            hovertemplate: up.castOption(x, b, "hovertemplate"),
                            hovertemplateLabels: up.extendFlat({}, C, p),
                            eventData: [
                                C
                            ]
                        }, {
                            container: n,
                            gd: t,
                            inOut_bbox: g
                        }), C.bbox = g[0];
                    }
                    f.distance < 5 && (f.buttons || vPe) ? t.emit("plotly_click", M) : t.emit("plotly_hover", M), this.oldEventData = M;
                } else Kg.loneUnhover(n), this.oldEventData && t.emit("plotly_unhover", this.oldEventData), this.oldEventData = void 0;
                e.drawAnnotations(e);
            };
            wv.recoverContext = function() {
                var e = this;
                e.glplot.dispose();
                var t = function() {
                    if (e.glplot.gl.isContextLost()) {
                        requestAnimationFrame(t);
                        return;
                    }
                    if (!e.initializeGLPlot()) {
                        up.error("Catastrophic and unrecoverable WebGL error. Context lost.");
                        return;
                    }
                    e.plot.apply(e, e.plotArgs);
                };
                requestAnimationFrame(t);
            };
            var GE = [
                "xaxis",
                "yaxis",
                "zaxis"
            ];
            function CPt(e, t, r) {
                for(var n = e.fullSceneLayout, i = 0; i < 3; i++){
                    var a = GE[i], o = a.charAt(0), s = n[a], l = t[o], u = t[o + "calendar"], c = t["_" + o + "length"];
                    if (!up.isArrayOrTypedArray(l)) r[0][i] = Math.min(r[0][i], 0), r[1][i] = Math.max(r[1][i], c - 1);
                    else for(var f, h = 0; h < (c || l.length); h++)if (up.isArrayOrTypedArray(l[h])) for(var d = 0; d < l[h].length; ++d)f = s.d2l(l[h][d], 0, u), !isNaN(f) && isFinite(f) && (r[0][i] = Math.min(r[0][i], f), r[1][i] = Math.max(r[1][i], f));
                    else f = s.d2l(l[h], 0, u), !isNaN(f) && isFinite(f) && (r[0][i] = Math.min(r[0][i], f), r[1][i] = Math.max(r[1][i], f));
                }
            }
            function LPt(e, t) {
                for(var r = e.fullSceneLayout, n = r.annotations || [], i = 0; i < 3; i++)for(var a = GE[i], o = a.charAt(0), s = r[a], l = 0; l < n.length; l++){
                    var u = n[l];
                    if (u.visible) {
                        var c = s.r2l(u[o]);
                        !isNaN(c) && isFinite(c) && (t[0][i] = Math.min(t[0][i], c), t[1][i] = Math.max(t[1][i], c));
                    }
                }
            }
            wv.plot = function(e, t, r) {
                var n = this;
                if (n.plotArgs = [
                    e,
                    t,
                    r
                ], !n.glplot.contextLost) {
                    var i, a, o, s, l, u, c = t[n.id], f = r[n.id];
                    n.fullLayout = t, n.fullSceneLayout = c, n.axesOptions.merge(t, c), n.spikeOptions.merge(c), n.setViewport(c), n.updateFx(c.dragmode, c.hovermode), n.camera.enableWheel = n.graphDiv._context._scrollZoom.gl3d, n.glplot.setClearColor(wPt(c.bgcolor)), n.setConvert(l), e ? Array.isArray(e) || (e = [
                        e
                    ]) : e = [];
                    var h = [
                        [
                            1 / 0,
                            1 / 0,
                            1 / 0
                        ],
                        [
                            -1 / 0,
                            -1 / 0,
                            -1 / 0
                        ]
                    ];
                    for(o = 0; o < e.length; ++o)i = e[o], !(i.visible !== !0 || i._length === 0) && CPt(this, i, h);
                    LPt(this, h);
                    var d = [
                        1,
                        1,
                        1
                    ];
                    for(s = 0; s < 3; ++s)h[1][s] === h[0][s] ? d[s] = 1 : d[s] = 1 / (h[1][s] - h[0][s]);
                    for(n.dataScale = d, n.convertAnnotations(this), o = 0; o < e.length; ++o)i = e[o], !(i.visible !== !0 || i._length === 0) && (a = n.traces[i.uid], a ? a.data.type === i.type ? a.update(i) : (a.dispose(), a = i._module.plot(this, i), n.traces[i.uid] = a) : (a = i._module.plot(this, i), n.traces[i.uid] = a), a.name = i.name);
                    var v = Object.keys(n.traces);
                    e: for(o = 0; o < v.length; ++o){
                        for(s = 0; s < e.length; ++s)if (e[s].uid === v[o] && e[s].visible === !0 && e[s]._length !== 0) continue e;
                        a = n.traces[v[o]], a.dispose(), delete n.traces[v[o]];
                    }
                    n.glplot.objects.sort(function(ae, _e) {
                        return ae._trace.data.index - _e._trace.data.index;
                    });
                    var x = [
                        [
                            0,
                            0,
                            0
                        ],
                        [
                            0,
                            0,
                            0
                        ]
                    ], b = [], p = {};
                    for(o = 0; o < 3; ++o){
                        l = c[GE[o]], u = l.type, u in p ? (p[u].acc *= d[o], p[u].count += 1) : p[u] = {
                            acc: d[o],
                            count: 1
                        };
                        var E;
                        if (l.autorange) {
                            x[0][o] = 1 / 0, x[1][o] = -1 / 0;
                            var k = n.glplot.objects, A = n.fullSceneLayout.annotations || [], L = l._name.charAt(0);
                            for(s = 0; s < k.length; s++){
                                var _ = k[s], C = _.bounds, M = _._trace.data._pad || 0;
                                _.constructor.name === "ErrorBars" && l._lowerLogErrorBound ? x[0][o] = Math.min(x[0][o], l._lowerLogErrorBound) : x[0][o] = Math.min(x[0][o], C[0][o] / d[o] - M), x[1][o] = Math.max(x[1][o], C[1][o] / d[o] + M);
                            }
                            for(s = 0; s < A.length; s++){
                                var g = A[s];
                                if (g.visible) {
                                    var P = l.r2l(g[L]);
                                    x[0][o] = Math.min(x[0][o], P), x[1][o] = Math.max(x[1][o], P);
                                }
                            }
                            if ("rangemode" in l && l.rangemode === "tozero" && (x[0][o] = Math.min(x[0][o], 0), x[1][o] = Math.max(x[1][o], 0)), x[0][o] > x[1][o]) x[0][o] = -1, x[1][o] = 1;
                            else {
                                var T = x[1][o] - x[0][o];
                                x[0][o] -= T / 32, x[1][o] += T / 32;
                            }
                            if (E = [
                                x[0][o],
                                x[1][o]
                            ], E = kPt(E, l), x[0][o] = E[0], x[1][o] = E[1], l.isReversed()) {
                                var F = x[0][o];
                                x[0][o] = x[1][o], x[1][o] = F;
                            }
                        } else E = l.range, x[0][o] = l.r2l(E[0]), x[1][o] = l.r2l(E[1]);
                        x[0][o] === x[1][o] && (x[0][o] -= 1, x[1][o] += 1), b[o] = x[1][o] - x[0][o], l.range = [
                            x[0][o],
                            x[1][o]
                        ], l.limitRange(), n.glplot.setBounds(o, {
                            min: l.range[0] * d[o],
                            max: l.range[1] * d[o]
                        });
                    }
                    var q, V = c.aspectmode;
                    if (V === "cube") q = [
                        1,
                        1,
                        1
                    ];
                    else if (V === "manual") {
                        var H = c.aspectratio;
                        q = [
                            H.x,
                            H.y,
                            H.z
                        ];
                    } else if (V === "auto" || V === "data") {
                        var X = [
                            1,
                            1,
                            1
                        ];
                        for(o = 0; o < 3; ++o){
                            l = c[GE[o]], u = l.type;
                            var G = p[u];
                            X[o] = Math.pow(G.acc, 1 / G.count) / d[o];
                        }
                        V === "data" || Math.max.apply(null, X) / Math.min.apply(null, X) <= 4 ? q = X : q = [
                            1,
                            1,
                            1
                        ];
                    } else throw new Error("scene.js aspectRatio was not one of the enumerated types");
                    c.aspectratio.x = f.aspectratio.x = q[0], c.aspectratio.y = f.aspectratio.y = q[1], c.aspectratio.z = f.aspectratio.z = q[2], n.glplot.setAspectratio(c.aspectratio), n.viewInitial.aspectratio || (n.viewInitial.aspectratio = {
                        x: c.aspectratio.x,
                        y: c.aspectratio.y,
                        z: c.aspectratio.z
                    }), n.viewInitial.aspectmode || (n.viewInitial.aspectmode = c.aspectmode);
                    var N = c.domain || null, W = t._size || null;
                    if (N && W) {
                        var re = n.container.style;
                        re.position = "absolute", re.left = W.l + N.x[0] * W.w + "px", re.top = W.t + (1 - N.y[1]) * W.h + "px", re.width = W.w * (N.x[1] - N.x[0]) + "px", re.height = W.h * (N.y[1] - N.y[0]) + "px";
                    }
                    n.glplot.redraw();
                }
            };
            wv.destroy = function() {
                var e = this;
                e.glplot && (e.camera.mouseListener.enabled = !1, e.container.removeEventListener("wheel", e.camera.wheelListener), e.camera = null, e.glplot.dispose(), e.container.parentNode.removeChild(e.container), e.glplot = null);
            };
            function PPt(e) {
                return [
                    [
                        e.eye.x,
                        e.eye.y,
                        e.eye.z
                    ],
                    [
                        e.center.x,
                        e.center.y,
                        e.center.z
                    ],
                    [
                        e.up.x,
                        e.up.y,
                        e.up.z
                    ]
                ];
            }
            function IPt(e) {
                return {
                    up: {
                        x: e.up[0],
                        y: e.up[1],
                        z: e.up[2]
                    },
                    center: {
                        x: e.center[0],
                        y: e.center[1],
                        z: e.center[2]
                    },
                    eye: {
                        x: e.eye[0],
                        y: e.eye[1],
                        z: e.eye[2]
                    },
                    projection: {
                        type: e._ortho === !0 ? "orthographic" : "perspective"
                    }
                };
            }
            wv.getCamera = function() {
                var e = this;
                return e.camera.view.recalcMatrix(e.camera.view.lastT()), IPt(e.camera);
            };
            wv.setViewport = function(e) {
                var t = this, r = e.camera;
                t.camera.lookAt.apply(this, PPt(r)), t.glplot.setAspectratio(e.aspectratio);
                var n = r.projection.type === "orthographic", i = t.camera._ortho;
                n !== i && (t.glplot.redraw(), t.glplot.clearRGBA(), t.glplot.dispose(), t.initializeGLPlot());
            };
            wv.isCameraChanged = function(e) {
                var t = this, r = t.getCamera(), n = up.nestedProperty(e, t.id + ".camera"), i = n.get();
                function a(u, c, f, h) {
                    var d = [
                        "up",
                        "center",
                        "eye"
                    ], v = [
                        "x",
                        "y",
                        "z"
                    ];
                    return c[d[f]] && u[d[f]][v[h]] === c[d[f]][v[h]];
                }
                var o = !1;
                if (i === void 0) o = !0;
                else {
                    for(var s = 0; s < 3; s++)for(var l = 0; l < 3; l++)if (!a(r, i, s, l)) {
                        o = !0;
                        break;
                    }
                    (!i.projection || r.projection && r.projection.type !== i.projection.type) && (o = !0);
                }
                return o;
            };
            wv.isAspectChanged = function(e) {
                var t = this, r = t.glplot.getAspectratio(), n = up.nestedProperty(e, t.id + ".aspectratio"), i = n.get();
                return i === void 0 || i.x !== r.x || i.y !== r.y || i.z !== r.z;
            };
            wv.saveLayout = function(e) {
                var t = this, r = t.fullLayout, n, i, a, o, s, l, u = t.isCameraChanged(e), c = t.isAspectChanged(e), f = u || c;
                if (f) {
                    var h = {};
                    if (u && (n = t.getCamera(), i = up.nestedProperty(e, t.id + ".camera"), a = i.get(), h[t.id + ".camera"] = a), c && (o = t.glplot.getAspectratio(), s = up.nestedProperty(e, t.id + ".aspectratio"), l = s.get(), h[t.id + ".aspectratio"] = l), JD.call("_storeDirectGUIEdit", e, r._preGUI, h), u) {
                        i.set(n);
                        var d = up.nestedProperty(r, t.id + ".camera");
                        d.set(n);
                    }
                    if (c) {
                        s.set(o);
                        var v = up.nestedProperty(r, t.id + ".aspectratio");
                        v.set(o), t.glplot.redraw();
                    }
                }
                return f;
            };
            wv.updateFx = function(e, t) {
                var r = this, n = r.camera;
                if (n) {
                    if (e === "orbit") n.mode = "orbit", n.keyBindingMode = "rotate";
                    else if (e === "turntable") {
                        n.up = [
                            0,
                            0,
                            1
                        ], n.mode = "turntable", n.keyBindingMode = "rotate";
                        var i = r.graphDiv, a = i._fullLayout, o = r.fullSceneLayout.camera, s = o.up.x, l = o.up.y, u = o.up.z;
                        if (u / Math.sqrt(s * s + l * l + u * u) < .999) {
                            var c = r.id + ".camera.up", f = {
                                x: 0,
                                y: 0,
                                z: 1
                            }, h = {};
                            h[c] = f;
                            var d = i.layout;
                            JD.call("_storeDirectGUIEdit", d, a._preGUI, h), o.up = f, up.nestedProperty(d, c).set(f);
                        }
                    } else n.keyBindingMode = e;
                }
                r.fullSceneLayout.hovermode = t;
            };
            function RPt(e, t, r) {
                for(var n = 0, i = r - 1; n < i; ++n, --i)for(var a = 0; a < t; ++a)for(var o = 0; o < 4; ++o){
                    var s = 4 * (t * n + a) + o, l = 4 * (t * i + a) + o, u = e[s];
                    e[s] = e[l], e[l] = u;
                }
            }
            function DPt(e, t, r) {
                for(var n = 0; n < r; ++n)for(var i = 0; i < t; ++i){
                    var a = 4 * (t * n + i), o = e[a + 3];
                    if (o > 0) for(var s = 255 / o, l = 0; l < 3; ++l)e[a + l] = Math.min(s * e[a + l], 255);
                }
            }
            wv.toImage = function(e) {
                var t = this;
                e || (e = "png"), t.staticMode && t.container.appendChild(HE), t.glplot.redraw();
                var r = t.glplot.gl, n = r.drawingBufferWidth, i = r.drawingBufferHeight;
                r.bindFramebuffer(r.FRAMEBUFFER, null);
                var a = new Uint8Array(n * i * 4);
                r.readPixels(0, 0, n, i, r.RGBA, r.UNSIGNED_BYTE, a), RPt(a, n, i), DPt(a, n, i);
                var o = document.createElement("canvas");
                o.width = n, o.height = i;
                var s = o.getContext("2d", {
                    willReadFrequently: !0
                }), l = s.createImageData(n, i);
                l.data.set(a), s.putImageData(l, 0, 0);
                var u;
                switch(e){
                    case "jpeg":
                        u = o.toDataURL("image/jpeg");
                        break;
                    case "webp":
                        u = o.toDataURL("image/webp");
                        break;
                    default:
                        u = o.toDataURL("image/png");
                }
                return t.staticMode && t.container.removeChild(HE), u;
            };
            wv.setConvert = function() {
                for(var e = this, t = 0; t < 3; t++){
                    var r = e.fullSceneLayout[GE[t]];
                    $D.setConvert(r, e.fullLayout), r.setScale = up.noop;
                }
            };
            wv.make4thDimension = function() {
                var e = this, t = e.graphDiv, r = t._fullLayout;
                e._mockAxis = {
                    type: "linear",
                    showexponent: "all",
                    exponentformat: "B"
                }, $D.setConvert(e._mockAxis, r);
            };
            gPe.exports = pPe;
        });
        var _Pe = ye((Svr, yPe)=>{
            "use strict";
            yPe.exports = {
                scene: {
                    valType: "subplotid",
                    dflt: "scene",
                    editType: "calc+clearAxisTypes"
                }
            };
        });
        var mZ = ye((Mvr, xPe)=>{
            "use strict";
            var zPt = va(), cs = Cd(), gZ = no().extendFlat, FPt = Bu().overrideAll;
            xPe.exports = FPt({
                visible: cs.visible,
                showspikes: {
                    valType: "boolean",
                    dflt: !0
                },
                spikesides: {
                    valType: "boolean",
                    dflt: !0
                },
                spikethickness: {
                    valType: "number",
                    min: 0,
                    dflt: 2
                },
                spikecolor: {
                    valType: "color",
                    dflt: zPt.defaultLine
                },
                showbackground: {
                    valType: "boolean",
                    dflt: !1
                },
                backgroundcolor: {
                    valType: "color",
                    dflt: "rgba(204, 204, 204, 0.5)"
                },
                showaxeslabels: {
                    valType: "boolean",
                    dflt: !0
                },
                color: cs.color,
                categoryorder: cs.categoryorder,
                categoryarray: cs.categoryarray,
                title: {
                    text: cs.title.text,
                    font: cs.title.font
                },
                type: gZ({}, cs.type, {
                    values: [
                        "-",
                        "linear",
                        "log",
                        "date",
                        "category"
                    ]
                }),
                autotypenumbers: cs.autotypenumbers,
                autorange: cs.autorange,
                autorangeoptions: {
                    minallowed: cs.autorangeoptions.minallowed,
                    maxallowed: cs.autorangeoptions.maxallowed,
                    clipmin: cs.autorangeoptions.clipmin,
                    clipmax: cs.autorangeoptions.clipmax,
                    include: cs.autorangeoptions.include,
                    editType: "plot"
                },
                rangemode: cs.rangemode,
                minallowed: cs.minallowed,
                maxallowed: cs.maxallowed,
                range: gZ({}, cs.range, {
                    items: [
                        {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "^autorange": !1
                            }
                        },
                        {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "^autorange": !1
                            }
                        }
                    ],
                    anim: !1
                }),
                tickmode: cs.minor.tickmode,
                nticks: cs.nticks,
                tick0: cs.tick0,
                dtick: cs.dtick,
                tickvals: cs.tickvals,
                ticktext: cs.ticktext,
                ticks: cs.ticks,
                mirror: cs.mirror,
                ticklen: cs.ticklen,
                tickwidth: cs.tickwidth,
                tickcolor: cs.tickcolor,
                showticklabels: cs.showticklabels,
                labelalias: cs.labelalias,
                tickfont: cs.tickfont,
                tickangle: cs.tickangle,
                tickprefix: cs.tickprefix,
                showtickprefix: cs.showtickprefix,
                ticksuffix: cs.ticksuffix,
                showticksuffix: cs.showticksuffix,
                showexponent: cs.showexponent,
                exponentformat: cs.exponentformat,
                minexponent: cs.minexponent,
                separatethousands: cs.separatethousands,
                tickformat: cs.tickformat,
                tickformatstops: cs.tickformatstops,
                hoverformat: cs.hoverformat,
                showline: cs.showline,
                linecolor: cs.linecolor,
                linewidth: cs.linewidth,
                showgrid: cs.showgrid,
                gridcolor: gZ({}, cs.gridcolor, {
                    dflt: "rgb(204, 204, 204)"
                }),
                gridwidth: cs.gridwidth,
                zeroline: cs.zeroline,
                zerolinecolor: cs.zerolinecolor,
                zerolinewidth: cs.zerolinewidth
            }, "plot", "from-root");
        });
        var bZ = ye((Evr, bPe)=>{
            "use strict";
            var yZ = mZ(), qPt = Ju().attributes, _Z = no().extendFlat, OPt = Mr().counterRegex;
            function xZ(e, t, r) {
                return {
                    x: {
                        valType: "number",
                        dflt: e,
                        editType: "camera"
                    },
                    y: {
                        valType: "number",
                        dflt: t,
                        editType: "camera"
                    },
                    z: {
                        valType: "number",
                        dflt: r,
                        editType: "camera"
                    },
                    editType: "camera"
                };
            }
            bPe.exports = {
                _arrayAttrRegexps: [
                    OPt("scene", ".annotations", !0)
                ],
                bgcolor: {
                    valType: "color",
                    dflt: "rgba(0,0,0,0)",
                    editType: "plot"
                },
                camera: {
                    up: _Z(xZ(0, 0, 1), {}),
                    center: _Z(xZ(0, 0, 0), {}),
                    eye: _Z(xZ(1.25, 1.25, 1.25), {}),
                    projection: {
                        type: {
                            valType: "enumerated",
                            values: [
                                "perspective",
                                "orthographic"
                            ],
                            dflt: "perspective",
                            editType: "calc"
                        },
                        editType: "calc"
                    },
                    editType: "camera"
                },
                domain: qPt({
                    name: "scene",
                    editType: "plot"
                }),
                aspectmode: {
                    valType: "enumerated",
                    values: [
                        "auto",
                        "cube",
                        "data",
                        "manual"
                    ],
                    dflt: "auto",
                    editType: "plot",
                    impliedEdits: {
                        "aspectratio.x": void 0,
                        "aspectratio.y": void 0,
                        "aspectratio.z": void 0
                    }
                },
                aspectratio: {
                    x: {
                        valType: "number",
                        min: 0,
                        editType: "plot",
                        impliedEdits: {
                            "^aspectmode": "manual"
                        }
                    },
                    y: {
                        valType: "number",
                        min: 0,
                        editType: "plot",
                        impliedEdits: {
                            "^aspectmode": "manual"
                        }
                    },
                    z: {
                        valType: "number",
                        min: 0,
                        editType: "plot",
                        impliedEdits: {
                            "^aspectmode": "manual"
                        }
                    },
                    editType: "plot",
                    impliedEdits: {
                        aspectmode: "manual"
                    }
                },
                xaxis: yZ,
                yaxis: yZ,
                zaxis: yZ,
                dragmode: {
                    valType: "enumerated",
                    values: [
                        "orbit",
                        "turntable",
                        "zoom",
                        "pan",
                        !1
                    ],
                    editType: "plot"
                },
                hovermode: {
                    valType: "enumerated",
                    values: [
                        "closest",
                        !1
                    ],
                    dflt: "closest",
                    editType: "modebar"
                },
                uirevision: {
                    valType: "any",
                    editType: "none"
                },
                editType: "plot"
            };
        });
        var SPe = ye((kvr, APe)=>{
            "use strict";
            var BPt = id().mix, wPe = Mr(), NPt = Vs(), UPt = mZ(), VPt = yU(), HPt = JM(), TPe = [
                "xaxis",
                "yaxis",
                "zaxis"
            ], GPt = 13600 / 187;
            APe.exports = function(t, r, n) {
                var i, a;
                function o(u, c) {
                    return wPe.coerce(i, a, UPt, u, c);
                }
                for(var s = 0; s < TPe.length; s++){
                    var l = TPe[s];
                    i = t[l] || {}, a = NPt.newContainer(r, l), a._id = l[0] + n.scene, a._name = l, VPt(i, a, o, n), HPt(i, a, o, {
                        font: n.font,
                        letter: l[0],
                        data: n.data,
                        showGrid: !0,
                        noAutotickangles: !0,
                        noTicklabelindex: !0,
                        noTickson: !0,
                        noTicklabelmode: !0,
                        noTicklabelshift: !0,
                        noTicklabelstandoff: !0,
                        noTicklabelstep: !0,
                        noTicklabelposition: !0,
                        noTicklabeloverflow: !0,
                        noInsiderange: !0,
                        bgColor: n.bgColor,
                        calendar: n.calendar
                    }, n.fullLayout), o("gridcolor", BPt(a.color, n.bgColor, GPt).toRgbString()), o("title.text", l[0]), a.setScale = wPe.noop, o("showspikes") && (o("spikesides"), o("spikethickness"), o("spikecolor", a.color)), o("showaxeslabels"), o("showbackground") && o("backgroundcolor");
                }
            };
        });
        var CPe = ye((Cvr, kPe)=>{
            "use strict";
            var jPt = Mr(), WPt = va(), ZPt = ba(), XPt = C_(), YPt = SPe(), MPe = bZ(), KPt = kd().getSubplotData, EPe = "gl3d";
            kPe.exports = function(t, r, n) {
                var i = r._basePlotModules.length > 1;
                function a(o) {
                    if (!i) {
                        var s = jPt.validate(t[o], MPe[o]);
                        if (s) return t[o];
                    }
                }
                XPt(t, r, n, {
                    type: EPe,
                    attributes: MPe,
                    handleDefaults: JPt,
                    fullLayout: r,
                    font: r.font,
                    fullData: n,
                    getDfltFromLayout: a,
                    autotypenumbersDflt: r.autotypenumbers,
                    paper_bgcolor: r.paper_bgcolor,
                    calendar: r.calendar
                });
            };
            function JPt(e, t, r, n) {
                for(var i = r("bgcolor"), a = WPt.combine(i, n.paper_bgcolor), o = [
                    "up",
                    "center",
                    "eye"
                ], s = 0; s < o.length; s++)r("camera." + o[s] + ".x"), r("camera." + o[s] + ".y"), r("camera." + o[s] + ".z");
                r("camera.projection.type");
                var l = !!r("aspectratio.x") && !!r("aspectratio.y") && !!r("aspectratio.z"), u = l ? "manual" : "auto", c = r("aspectmode", u);
                l || (e.aspectratio = t.aspectratio = {
                    x: 1,
                    y: 1,
                    z: 1
                }, c === "manual" && (t.aspectmode = "auto"), e.aspectmode = t.aspectmode);
                var f = KPt(n.fullData, EPe, n.id);
                YPt(e, t, {
                    font: n.font,
                    scene: n.id,
                    data: f,
                    bgColor: a,
                    calendar: n.calendar,
                    autotypenumbersDflt: n.autotypenumbersDflt,
                    fullLayout: n.fullLayout
                }), ZPt.getComponentMethod("annotations3d", "handleDefaults")(e, t, n);
                var h = n.getDfltFromLayout("dragmode");
                if (h !== !1 && !h) {
                    if (h = "orbit", e.camera && e.camera.up) {
                        var d = e.camera.up.x, v = e.camera.up.y, x = e.camera.up.z;
                        x !== 0 && (!d || !v || !x || x / Math.sqrt(d * d + v * v + x * x) > .999) && (h = "turntable");
                    } else h = "turntable";
                }
                r("dragmode", h), r("hovermode", n.getDfltFromLayout("hovermode"));
            }
        });
        var Q_ = ye((cp)=>{
            "use strict";
            var $Pt = Bu().overrideAll, QPt = N1(), eIt = mPe(), tIt = kd().getSubplotData, rIt = Mr(), iIt = Zp(), O5 = "gl3d", wZ = "scene";
            cp.name = O5;
            cp.attr = wZ;
            cp.idRoot = wZ;
            cp.idRegex = cp.attrRegex = rIt.counterRegex("scene");
            cp.attributes = _Pe();
            cp.layoutAttributes = bZ();
            cp.baseLayoutAttrOverrides = $Pt({
                hoverlabel: QPt.hoverlabel
            }, "plot", "nested");
            cp.supplyLayoutDefaults = CPe();
            cp.plot = function(t) {
                for(var r = t._fullLayout, n = t._fullData, i = r._subplots[O5], a = 0; a < i.length; a++){
                    var o = i[a], s = tIt(n, O5, o), l = r[o], u = l.camera, c = l._scene;
                    c || (c = new eIt({
                        id: o,
                        graphDiv: t,
                        container: t.querySelector(".gl-container"),
                        staticPlot: t._context.staticPlot,
                        plotGlPixelRatio: t._context.plotGlPixelRatio,
                        camera: u
                    }, r), l._scene = c), c.viewInitial || (c.viewInitial = {
                        up: {
                            x: u.up.x,
                            y: u.up.y,
                            z: u.up.z
                        },
                        eye: {
                            x: u.eye.x,
                            y: u.eye.y,
                            z: u.eye.z
                        },
                        center: {
                            x: u.center.x,
                            y: u.center.y,
                            z: u.center.z
                        }
                    }), c.plot(s, r, t.layout);
                }
            };
            cp.clean = function(e, t, r, n) {
                for(var i = n._subplots[O5] || [], a = 0; a < i.length; a++){
                    var o = i[a];
                    !t[o] && n[o]._scene && (n[o]._scene.destroy(), n._infolayer && n._infolayer.selectAll(".annotation-" + o).remove());
                }
            };
            cp.toSVG = function(e) {
                for(var t = e._fullLayout, r = t._subplots[O5], n = t._size, i = 0; i < r.length; i++){
                    var a = t[r[i]], o = a.domain, s = a._scene, l = s.toImage("png"), u = t._glimages.append("svg:image");
                    u.attr({
                        xmlns: iIt.svg,
                        "xlink:href": l,
                        x: n.l + n.w * o.x[0],
                        y: n.t + n.h * (1 - o.y[1]),
                        width: n.w * (o.x[1] - o.x[0]),
                        height: n.h * (o.y[1] - o.y[0]),
                        preserveAspectRatio: "none"
                    }), s.destroy();
                }
            };
            cp.cleanId = function(t) {
                if (t.match(/^scene[0-9]*$/)) {
                    var r = t.substr(5);
                    return r === "1" && (r = ""), wZ + r;
                }
            };
            cp.updateFx = function(e) {
                for(var t = e._fullLayout, r = t._subplots[O5], n = 0; n < r.length; n++){
                    var i = t[r[n]]._scene;
                    i.updateFx(t.dragmode, t.hovermode);
                }
            };
        });
        var PPe = ye((Pvr, LPe)=>{
            "use strict";
            LPe.exports = {
                plot: ULe(),
                attributes: dZ(),
                markerSymbols: ZD(),
                supplyDefaults: ZLe(),
                colorbar: [
                    {
                        container: "marker",
                        min: "cmin",
                        max: "cmax"
                    },
                    {
                        container: "line",
                        min: "cmin",
                        max: "cmax"
                    }
                ],
                calc: YLe(),
                moduleType: "trace",
                name: "scatter3d",
                basePlotModule: Q_(),
                categories: [
                    "gl3d",
                    "symbols",
                    "showLegend",
                    "scatter-like"
                ],
                meta: {}
            };
        });
        var RPe = ye((Ivr, IPe)=>{
            "use strict";
            IPe.exports = PPe();
        });
        var jE = ye((Rvr, FPe)=>{
            "use strict";
            var DPe = va(), nIt = Jl(), TZ = Oc().axisHoverFormat, aIt = Wo().hovertemplateAttrs, zPe = vl(), AZ = no().extendFlat, oIt = Bu().overrideAll;
            function SZ(e) {
                return {
                    valType: "boolean",
                    dflt: !1
                };
            }
            function MZ(e) {
                return {
                    show: {
                        valType: "boolean",
                        dflt: !1
                    },
                    start: {
                        valType: "number",
                        dflt: null,
                        editType: "plot"
                    },
                    end: {
                        valType: "number",
                        dflt: null,
                        editType: "plot"
                    },
                    size: {
                        valType: "number",
                        dflt: null,
                        min: 0,
                        editType: "plot"
                    },
                    project: {
                        x: SZ("x"),
                        y: SZ("y"),
                        z: SZ("z")
                    },
                    color: {
                        valType: "color",
                        dflt: DPe.defaultLine
                    },
                    usecolormap: {
                        valType: "boolean",
                        dflt: !1
                    },
                    width: {
                        valType: "number",
                        min: 1,
                        max: 16,
                        dflt: 2
                    },
                    highlight: {
                        valType: "boolean",
                        dflt: !0
                    },
                    highlightcolor: {
                        valType: "color",
                        dflt: DPe.defaultLine
                    },
                    highlightwidth: {
                        valType: "number",
                        min: 1,
                        max: 16,
                        dflt: 2
                    }
                };
            }
            var EZ = FPe.exports = oIt(AZ({
                z: {
                    valType: "data_array"
                },
                x: {
                    valType: "data_array"
                },
                y: {
                    valType: "data_array"
                },
                text: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0
                },
                hovertext: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0
                },
                hovertemplate: aIt(),
                xhoverformat: TZ("x"),
                yhoverformat: TZ("y"),
                zhoverformat: TZ("z"),
                connectgaps: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "calc"
                },
                surfacecolor: {
                    valType: "data_array"
                }
            }, nIt("", {
                colorAttr: "z or surfacecolor",
                showScaleDflt: !0,
                autoColorDflt: !1,
                editTypeOverride: "calc"
            }), {
                contours: {
                    x: MZ("x"),
                    y: MZ("y"),
                    z: MZ("z")
                },
                hidesurface: {
                    valType: "boolean",
                    dflt: !1
                },
                lightposition: {
                    x: {
                        valType: "number",
                        min: -100000,
                        max: 1e5,
                        dflt: 10
                    },
                    y: {
                        valType: "number",
                        min: -100000,
                        max: 1e5,
                        dflt: 1e4
                    },
                    z: {
                        valType: "number",
                        min: -100000,
                        max: 1e5,
                        dflt: 0
                    }
                },
                lighting: {
                    ambient: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .8
                    },
                    diffuse: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .8
                    },
                    specular: {
                        valType: "number",
                        min: 0,
                        max: 2,
                        dflt: .05
                    },
                    roughness: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .5
                    },
                    fresnel: {
                        valType: "number",
                        min: 0,
                        max: 5,
                        dflt: .2
                    }
                },
                opacity: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 1
                },
                opacityscale: {
                    valType: "any",
                    editType: "calc"
                },
                hoverinfo: AZ({}, zPe.hoverinfo),
                showlegend: AZ({}, zPe.showlegend, {
                    dflt: !1
                })
            }), "calc", "nested");
            EZ.x.editType = EZ.y.editType = EZ.z.editType = "calc+clearAxisTypes";
        });
        var CZ = ye((Dvr, BPe)=>{
            "use strict";
            var sIt = ba(), qPe = Mr(), lIt = Uh(), uIt = jE(), kZ = .1;
            function cIt(e, t) {
                for(var r = [], n = 32, i = 0; i < n; i++){
                    var a = i / (n - 1), o = t + (1 - t) * (1 - Math.pow(Math.sin(e * a * Math.PI), 2));
                    r.push([
                        a,
                        Math.max(0, Math.min(1, o))
                    ]);
                }
                return r;
            }
            function fIt(e) {
                var t = 0;
                if (!Array.isArray(e) || e.length < 2 || !e[0] || !e[e.length - 1] || +e[0][0] != 0 || +e[e.length - 1][0] != 1) return !1;
                for(var r = 0; r < e.length; r++){
                    var n = e[r];
                    if (n.length !== 2 || +n[0] < t) return !1;
                    t = +n[0];
                }
                return !0;
            }
            function hIt(e, t, r, n) {
                var i, a;
                function o(b, p) {
                    return qPe.coerce(e, t, uIt, b, p);
                }
                var s = o("x"), l = o("y"), u = o("z");
                if (!u || !u.length || s && s.length < 1 || l && l.length < 1) {
                    t.visible = !1;
                    return;
                }
                t._xlength = Array.isArray(s) && qPe.isArrayOrTypedArray(s[0]) ? u.length : u[0].length, t._ylength = u.length;
                var c = sIt.getComponentMethod("calendars", "handleTraceDefaults");
                c(e, t, [
                    "x",
                    "y",
                    "z"
                ], n), o("text"), o("hovertext"), o("hovertemplate"), o("xhoverformat"), o("yhoverformat"), o("zhoverformat"), [
                    "lighting.ambient",
                    "lighting.diffuse",
                    "lighting.specular",
                    "lighting.roughness",
                    "lighting.fresnel",
                    "lightposition.x",
                    "lightposition.y",
                    "lightposition.z",
                    "hidesurface",
                    "connectgaps",
                    "opacity"
                ].forEach(function(b) {
                    o(b);
                });
                var f = o("surfacecolor"), h = [
                    "x",
                    "y",
                    "z"
                ];
                for(i = 0; i < 3; ++i){
                    var d = "contours." + h[i], v = o(d + ".show"), x = o(d + ".highlight");
                    if (v || x) for(a = 0; a < 3; ++a)o(d + ".project." + h[a]);
                    v && (o(d + ".color"), o(d + ".width"), o(d + ".usecolormap")), x && (o(d + ".highlightcolor"), o(d + ".highlightwidth")), o(d + ".start"), o(d + ".end"), o(d + ".size");
                }
                lIt(e, t, n, o, {
                    prefix: "",
                    cLetter: "c"
                }), OPe(e, t, n, o), t._length = null;
            }
            function OPe(e, t, r, n) {
                var i = n("opacityscale");
                i === "max" ? t.opacityscale = [
                    [
                        0,
                        kZ
                    ],
                    [
                        1,
                        1
                    ]
                ] : i === "min" ? t.opacityscale = [
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        kZ
                    ]
                ] : i === "extremes" ? t.opacityscale = cIt(1, kZ) : fIt(i) || (t.opacityscale = void 0);
            }
            BPe.exports = {
                supplyDefaults: hIt,
                opacityscaleDefaults: OPe
            };
        });
        var VPe = ye((zvr, UPe)=>{
            "use strict";
            var NPe = zv();
            UPe.exports = function(t, r) {
                r.surfacecolor ? NPe(t, r, {
                    vals: r.surfacecolor,
                    containerStr: "",
                    cLetter: "c"
                }) : NPe(t, r, {
                    vals: r.z,
                    containerStr: "",
                    cLetter: "c"
                });
            };
        });
        var XPe = ye((Fvr, ZPe)=>{
            "use strict";
            var dIt = Rd().gl_surface3d, B5 = Rd().ndarray, vIt = Rd().ndarray_linear_interpolate.d2, pIt = e8(), gIt = t8(), WE = Mr().isArrayOrTypedArray, mIt = $y().parseColorScale, HPe = Jy(), yIt = Mu().extractOpts;
            function jPe(e, t, r) {
                this.scene = e, this.uid = r, this.surface = t, this.data = null, this.showContour = [
                    !1,
                    !1,
                    !1
                ], this.contourStart = [
                    null,
                    null,
                    null
                ], this.contourEnd = [
                    null,
                    null,
                    null
                ], this.contourSize = [
                    0,
                    0,
                    0
                ], this.minValues = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], this.maxValues = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ], this.dataScaleX = 1, this.dataScaleY = 1, this.refineData = !0, this.objectOffset = [
                    0,
                    0,
                    0
                ];
            }
            var Jg = jPe.prototype;
            Jg.getXat = function(e, t, r, n) {
                var i = WE(this.data.x) ? WE(this.data.x[0]) ? this.data.x[t][e] : this.data.x[e] : e;
                return r === void 0 ? i : n.d2l(i, 0, r);
            };
            Jg.getYat = function(e, t, r, n) {
                var i = WE(this.data.y) ? WE(this.data.y[0]) ? this.data.y[t][e] : this.data.y[t] : t;
                return r === void 0 ? i : n.d2l(i, 0, r);
            };
            Jg.getZat = function(e, t, r, n) {
                var i = this.data.z[t][e];
                return i === null && this.data.connectgaps && this.data._interpolatedZ && (i = this.data._interpolatedZ[t][e]), r === void 0 ? i : n.d2l(i, 0, r);
            };
            Jg.handlePick = function(e) {
                if (e.object === this.surface) {
                    var t = (e.data.index[0] - 1) / this.dataScaleX - 1, r = (e.data.index[1] - 1) / this.dataScaleY - 1, n = Math.max(Math.min(Math.round(t), this.data.z[0].length - 1), 0), i = Math.max(Math.min(Math.round(r), this.data._ylength - 1), 0);
                    e.index = [
                        n,
                        i
                    ], e.traceCoordinate = [
                        this.getXat(n, i),
                        this.getYat(n, i),
                        this.getZat(n, i)
                    ], e.dataCoordinate = [
                        this.getXat(n, i, this.data.xcalendar, this.scene.fullSceneLayout.xaxis),
                        this.getYat(n, i, this.data.ycalendar, this.scene.fullSceneLayout.yaxis),
                        this.getZat(n, i, this.data.zcalendar, this.scene.fullSceneLayout.zaxis)
                    ];
                    for(var a = 0; a < 3; a++){
                        var o = e.dataCoordinate[a];
                        o != null && (e.dataCoordinate[a] *= this.scene.dataScale[a]);
                    }
                    var s = this.data.hovertext || this.data.text;
                    return WE(s) && s[i] && s[i][n] !== void 0 ? e.textLabel = s[i][n] : s ? e.textLabel = s : e.textLabel = "", e.data.dataCoordinate = e.dataCoordinate.slice(), this.surface.highlight(e.data), this.scene.glplot.spikes.position = e.dataCoordinate, !0;
                }
            };
            function _It(e) {
                var t = e[0].rgb, r = e[e.length - 1].rgb;
                return t[0] === r[0] && t[1] === r[1] && t[2] === r[2] && t[3] === r[3];
            }
            var N5 = [
                2,
                3,
                5,
                7,
                11,
                13,
                17,
                19,
                23,
                29,
                31,
                37,
                41,
                43,
                47,
                53,
                59,
                61,
                67,
                71,
                73,
                79,
                83,
                89,
                97,
                101,
                103,
                107,
                109,
                113,
                127,
                131,
                137,
                139,
                149,
                151,
                157,
                163,
                167,
                173,
                179,
                181,
                191,
                193,
                197,
                199,
                211,
                223,
                227,
                229,
                233,
                239,
                241,
                251,
                257,
                263,
                269,
                271,
                277,
                281,
                283,
                293,
                307,
                311,
                313,
                317,
                331,
                337,
                347,
                349,
                353,
                359,
                367,
                373,
                379,
                383,
                389,
                397,
                401,
                409,
                419,
                421,
                431,
                433,
                439,
                443,
                449,
                457,
                461,
                463,
                467,
                479,
                487,
                491,
                499,
                503,
                509,
                521,
                523,
                541,
                547,
                557,
                563,
                569,
                571,
                577,
                587,
                593,
                599,
                601,
                607,
                613,
                617,
                619,
                631,
                641,
                643,
                647,
                653,
                659,
                661,
                673,
                677,
                683,
                691,
                701,
                709,
                719,
                727,
                733,
                739,
                743,
                751,
                757,
                761,
                769,
                773,
                787,
                797,
                809,
                811,
                821,
                823,
                827,
                829,
                839,
                853,
                857,
                859,
                863,
                877,
                881,
                883,
                887,
                907,
                911,
                919,
                929,
                937,
                941,
                947,
                953,
                967,
                971,
                977,
                983,
                991,
                997,
                1009,
                1013,
                1019,
                1021,
                1031,
                1033,
                1039,
                1049,
                1051,
                1061,
                1063,
                1069,
                1087,
                1091,
                1093,
                1097,
                1103,
                1109,
                1117,
                1123,
                1129,
                1151,
                1153,
                1163,
                1171,
                1181,
                1187,
                1193,
                1201,
                1213,
                1217,
                1223,
                1229,
                1231,
                1237,
                1249,
                1259,
                1277,
                1279,
                1283,
                1289,
                1291,
                1297,
                1301,
                1303,
                1307,
                1319,
                1321,
                1327,
                1361,
                1367,
                1373,
                1381,
                1399,
                1409,
                1423,
                1427,
                1429,
                1433,
                1439,
                1447,
                1451,
                1453,
                1459,
                1471,
                1481,
                1483,
                1487,
                1489,
                1493,
                1499,
                1511,
                1523,
                1531,
                1543,
                1549,
                1553,
                1559,
                1567,
                1571,
                1579,
                1583,
                1597,
                1601,
                1607,
                1609,
                1613,
                1619,
                1621,
                1627,
                1637,
                1657,
                1663,
                1667,
                1669,
                1693,
                1697,
                1699,
                1709,
                1721,
                1723,
                1733,
                1741,
                1747,
                1753,
                1759,
                1777,
                1783,
                1787,
                1789,
                1801,
                1811,
                1823,
                1831,
                1847,
                1861,
                1867,
                1871,
                1873,
                1877,
                1879,
                1889,
                1901,
                1907,
                1913,
                1931,
                1933,
                1949,
                1951,
                1973,
                1979,
                1987,
                1993,
                1997,
                1999,
                2003,
                2011,
                2017,
                2027,
                2029,
                2039,
                2053,
                2063,
                2069,
                2081,
                2083,
                2087,
                2089,
                2099,
                2111,
                2113,
                2129,
                2131,
                2137,
                2141,
                2143,
                2153,
                2161,
                2179,
                2203,
                2207,
                2213,
                2221,
                2237,
                2239,
                2243,
                2251,
                2267,
                2269,
                2273,
                2281,
                2287,
                2293,
                2297,
                2309,
                2311,
                2333,
                2339,
                2341,
                2347,
                2351,
                2357,
                2371,
                2377,
                2381,
                2383,
                2389,
                2393,
                2399,
                2411,
                2417,
                2423,
                2437,
                2441,
                2447,
                2459,
                2467,
                2473,
                2477,
                2503,
                2521,
                2531,
                2539,
                2543,
                2549,
                2551,
                2557,
                2579,
                2591,
                2593,
                2609,
                2617,
                2621,
                2633,
                2647,
                2657,
                2659,
                2663,
                2671,
                2677,
                2683,
                2687,
                2689,
                2693,
                2699,
                2707,
                2711,
                2713,
                2719,
                2729,
                2731,
                2741,
                2749,
                2753,
                2767,
                2777,
                2789,
                2791,
                2797,
                2801,
                2803,
                2819,
                2833,
                2837,
                2843,
                2851,
                2857,
                2861,
                2879,
                2887,
                2897,
                2903,
                2909,
                2917,
                2927,
                2939,
                2953,
                2957,
                2963,
                2969,
                2971,
                2999
            ];
            function xIt(e, t) {
                if (e < t) return 0;
                for(var r = 0; Math.floor(e % t) === 0;)e /= t, r++;
                return r;
            }
            function LZ(e) {
                for(var t = [], r = 0; r < N5.length; r++){
                    var n = N5[r];
                    t.push(xIt(e, n));
                }
                return t;
            }
            function bIt(e) {
                for(var t = LZ(e), r = e, n = 0; n < N5.length; n++)if (t[n] > 0) {
                    r = N5[n];
                    break;
                }
                return r;
            }
            function wIt(e, t) {
                if (!(e < 1 || t < 1)) {
                    for(var r = LZ(e), n = LZ(t), i = 1, a = 0; a < N5.length; a++)i *= Math.pow(N5[a], Math.max(r[a], n[a]));
                    return i;
                }
            }
            function TIt(e) {
                if (e.length !== 0) {
                    for(var t = 1, r = 0; r < e.length; r++)t = wIt(t, e[r]);
                    return t;
                }
            }
            Jg.calcXnums = function(e) {
                var t, r = [];
                for(t = 1; t < e; t++){
                    var n = this.getXat(t - 1, 0), i = this.getXat(t, 0);
                    i !== n && n !== void 0 && n !== null && i !== void 0 && i !== null ? r[t - 1] = Math.abs(i - n) : r[t - 1] = 0;
                }
                var a = 0;
                for(t = 1; t < e; t++)a += r[t - 1];
                for(t = 1; t < e; t++)r[t - 1] === 0 ? r[t - 1] = 1 : r[t - 1] = Math.round(a / r[t - 1]);
                return r;
            };
            Jg.calcYnums = function(e) {
                var t, r = [];
                for(t = 1; t < e; t++){
                    var n = this.getYat(0, t - 1), i = this.getYat(0, t);
                    i !== n && n !== void 0 && n !== null && i !== void 0 && i !== null ? r[t - 1] = Math.abs(i - n) : r[t - 1] = 0;
                }
                var a = 0;
                for(t = 1; t < e; t++)a += r[t - 1];
                for(t = 1; t < e; t++)r[t - 1] === 0 ? r[t - 1] = 1 : r[t - 1] = Math.round(a / r[t - 1]);
                return r;
            };
            var WPe = [
                1,
                2,
                4,
                6,
                12,
                24,
                36,
                48,
                60,
                120,
                180,
                240,
                360,
                720,
                840,
                1260
            ], GPe = WPe[9], QD = WPe[13];
            Jg.estimateScale = function(e, t) {
                for(var r = t === 0 ? this.calcXnums(e) : this.calcYnums(e), n = 1 + TIt(r); n < GPe;)n *= 2;
                for(; n > QD;)n--, n /= bIt(n), n++, n < GPe && (n = QD);
                var i = Math.round(n / e);
                return i > 1 ? i : 1;
            };
            function AIt(e, t, r) {
                var n = r[8] + r[2] * t[0] + r[5] * t[1];
                return e[0] = (r[6] + r[0] * t[0] + r[3] * t[1]) / n, e[1] = (r[7] + r[1] * t[0] + r[4] * t[1]) / n, e;
            }
            function SIt(e, t, r) {
                return MIt(e, t, AIt, r), e;
            }
            function MIt(e, t, r, n) {
                for(var i = [
                    0,
                    0
                ], a = e.shape[0], o = e.shape[1], s = 0; s < a; s++)for(var l = 0; l < o; l++)r(i, [
                    s,
                    l
                ], n), e.set(s, l, vIt(t, i[0], i[1]));
                return e;
            }
            Jg.refineCoords = function(e) {
                for(var t = this.dataScaleX, r = this.dataScaleY, n = e[0].shape[0], i = e[0].shape[1], a = Math.floor(e[0].shape[0] * t + 1) | 0, o = Math.floor(e[0].shape[1] * r + 1) | 0, s = 1 + n + 1, l = 1 + i + 1, u = B5(new Float32Array(s * l), [
                    s,
                    l
                ]), c = [
                    1 / t,
                    0,
                    0,
                    0,
                    1 / r,
                    0,
                    0,
                    0,
                    1
                ], f = 0; f < e.length; ++f){
                    this.surface.padField(u, e[f]);
                    var h = B5(new Float32Array(a * o), [
                        a,
                        o
                    ]);
                    SIt(h, u, c), e[f] = h;
                }
            };
            function EIt(e, t) {
                for(var r = !1, n = 0; n < e.length; n++)if (t === e[n]) {
                    r = !0;
                    break;
                }
                r === !1 && e.push(t);
            }
            Jg.setContourLevels = function() {
                var e = [
                    [],
                    [],
                    []
                ], t = [
                    !1,
                    !1,
                    !1
                ], r = !1, n, i, a;
                for(n = 0; n < 3; ++n)if (this.showContour[n] && (r = !0, this.contourSize[n] > 0 && this.contourStart[n] !== null && this.contourEnd[n] !== null && this.contourEnd[n] > this.contourStart[n])) for(t[n] = !0, i = this.contourStart[n]; i < this.contourEnd[n]; i += this.contourSize[n])a = i * this.scene.dataScale[n], EIt(e[n], a);
                if (r) {
                    var o = [
                        [],
                        [],
                        []
                    ];
                    for(n = 0; n < 3; ++n)this.showContour[n] && (o[n] = t[n] ? e[n] : this.scene.contourLevels[n]);
                    this.surface.update({
                        levels: o
                    });
                }
            };
            Jg.update = function(e) {
                var t = this.scene, r = t.fullSceneLayout, n = this.surface, i = mIt(e), a = t.dataScale, o = e.z[0].length, s = e._ylength, l = t.contourLevels;
                this.data = e;
                var u, c, f, h, d = [];
                for(u = 0; u < 3; u++)for(d[u] = [], c = 0; c < o; c++)d[u][c] = [];
                for(c = 0; c < o; c++)for(f = 0; f < s; f++)d[0][c][f] = this.getXat(c, f, e.xcalendar, r.xaxis), d[1][c][f] = this.getYat(c, f, e.ycalendar, r.yaxis), d[2][c][f] = this.getZat(c, f, e.zcalendar, r.zaxis);
                if (e.connectgaps) for(e._emptypoints = gIt(d[2]), pIt(d[2], e._emptypoints), e._interpolatedZ = [], c = 0; c < o; c++)for(e._interpolatedZ[c] = [], f = 0; f < s; f++)e._interpolatedZ[c][f] = d[2][c][f];
                for(u = 0; u < 3; u++)for(c = 0; c < o; c++)for(f = 0; f < s; f++)h = d[u][c][f], h == null ? d[u][c][f] = NaN : h = d[u][c][f] *= a[u];
                for(u = 0; u < 3; u++)for(c = 0; c < o; c++)for(f = 0; f < s; f++)h = d[u][c][f], h != null && (this.minValues[u] > h && (this.minValues[u] = h), this.maxValues[u] < h && (this.maxValues[u] = h));
                for(u = 0; u < 3; u++)this.objectOffset[u] = .5 * (this.minValues[u] + this.maxValues[u]);
                for(u = 0; u < 3; u++)for(c = 0; c < o; c++)for(f = 0; f < s; f++)h = d[u][c][f], h != null && (d[u][c][f] -= this.objectOffset[u]);
                var v = [
                    B5(new Float32Array(o * s), [
                        o,
                        s
                    ]),
                    B5(new Float32Array(o * s), [
                        o,
                        s
                    ]),
                    B5(new Float32Array(o * s), [
                        o,
                        s
                    ])
                ];
                for(u = 0; u < 3; u++)for(c = 0; c < o; c++)for(f = 0; f < s; f++)v[u].set(c, f, d[u][c][f]);
                d = [];
                var x = {
                    colormap: i,
                    levels: [
                        [],
                        [],
                        []
                    ],
                    showContour: [
                        !0,
                        !0,
                        !0
                    ],
                    showSurface: !e.hidesurface,
                    contourProject: [
                        [
                            !1,
                            !1,
                            !1
                        ],
                        [
                            !1,
                            !1,
                            !1
                        ],
                        [
                            !1,
                            !1,
                            !1
                        ]
                    ],
                    contourWidth: [
                        1,
                        1,
                        1
                    ],
                    contourColor: [
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    contourTint: [
                        1,
                        1,
                        1
                    ],
                    dynamicColor: [
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    dynamicWidth: [
                        1,
                        1,
                        1
                    ],
                    dynamicTint: [
                        1,
                        1,
                        1
                    ],
                    opacityscale: e.opacityscale,
                    opacity: e.opacity
                }, b = yIt(e);
                if (x.intensityBounds = [
                    b.min,
                    b.max
                ], e.surfacecolor) {
                    var p = B5(new Float32Array(o * s), [
                        o,
                        s
                    ]);
                    for(c = 0; c < o; c++)for(f = 0; f < s; f++)p.set(c, f, e.surfacecolor[f][c]);
                    v.push(p);
                } else x.intensityBounds[0] *= a[2], x.intensityBounds[1] *= a[2];
                (QD < v[0].shape[0] || QD < v[0].shape[1]) && (this.refineData = !1), this.refineData === !0 && (this.dataScaleX = this.estimateScale(v[0].shape[0], 0), this.dataScaleY = this.estimateScale(v[0].shape[1], 1), (this.dataScaleX !== 1 || this.dataScaleY !== 1) && this.refineCoords(v)), e.surfacecolor && (x.intensity = v.pop());
                var E = [
                    !0,
                    !0,
                    !0
                ], k = [
                    "x",
                    "y",
                    "z"
                ];
                for(u = 0; u < 3; ++u){
                    var A = e.contours[k[u]];
                    E[u] = A.highlight, x.showContour[u] = A.show || A.highlight, x.showContour[u] && (x.contourProject[u] = [
                        A.project.x,
                        A.project.y,
                        A.project.z
                    ], A.show ? (this.showContour[u] = !0, x.levels[u] = l[u], n.highlightColor[u] = x.contourColor[u] = HPe(A.color), A.usecolormap ? n.highlightTint[u] = x.contourTint[u] = 0 : n.highlightTint[u] = x.contourTint[u] = 1, x.contourWidth[u] = A.width, this.contourStart[u] = A.start, this.contourEnd[u] = A.end, this.contourSize[u] = A.size) : (this.showContour[u] = !1, this.contourStart[u] = null, this.contourEnd[u] = null, this.contourSize[u] = 0), A.highlight && (x.dynamicColor[u] = HPe(A.highlightcolor), x.dynamicWidth[u] = A.highlightwidth));
                }
                _It(i) && (x.vertexColor = !0), x.objectOffset = this.objectOffset, x.coords = v, n.update(x), n.visible = e.visible, n.enableDynamic = E, n.enableHighlight = E, n.snapToData = !0, "lighting" in e && (n.ambientLight = e.lighting.ambient, n.diffuseLight = e.lighting.diffuse, n.specularLight = e.lighting.specular, n.roughness = e.lighting.roughness, n.fresnel = e.lighting.fresnel), "lightposition" in e && (n.lightPosition = [
                    e.lightposition.x,
                    e.lightposition.y,
                    e.lightposition.z
                ]);
            };
            Jg.dispose = function() {
                this.scene.glplot.remove(this.surface), this.surface.dispose();
            };
            function kIt(e, t) {
                var r = e.glplot.gl, n = dIt({
                    gl: r
                }), i = new jPe(e, n, t.uid);
                return n._trace = i, i.update(t), e.glplot.add(n), i;
            }
            ZPe.exports = kIt;
        });
        var KPe = ye((qvr, YPe)=>{
            "use strict";
            YPe.exports = {
                attributes: jE(),
                supplyDefaults: CZ().supplyDefaults,
                colorbar: {
                    min: "cmin",
                    max: "cmax"
                },
                calc: VPe(),
                plot: XPe(),
                moduleType: "trace",
                name: "surface",
                basePlotModule: Q_(),
                categories: [
                    "gl3d",
                    "2dMap",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var $Pe = ye((Ovr, JPe)=>{
            "use strict";
            JPe.exports = KPe();
        });
        var U5 = ye((Bvr, eIe)=>{
            "use strict";
            var CIt = Jl(), PZ = Oc().axisHoverFormat, LIt = Wo().hovertemplateAttrs, ex = jE(), QPe = vl(), tx = no().extendFlat;
            eIe.exports = tx({
                x: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                y: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                z: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                i: {
                    valType: "data_array",
                    editType: "calc"
                },
                j: {
                    valType: "data_array",
                    editType: "calc"
                },
                k: {
                    valType: "data_array",
                    editType: "calc"
                },
                text: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0,
                    editType: "calc"
                },
                hovertext: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0,
                    editType: "calc"
                },
                hovertemplate: LIt({
                    editType: "calc"
                }),
                xhoverformat: PZ("x"),
                yhoverformat: PZ("y"),
                zhoverformat: PZ("z"),
                delaunayaxis: {
                    valType: "enumerated",
                    values: [
                        "x",
                        "y",
                        "z"
                    ],
                    dflt: "z",
                    editType: "calc"
                },
                alphahull: {
                    valType: "number",
                    dflt: -1,
                    editType: "calc"
                },
                intensity: {
                    valType: "data_array",
                    editType: "calc"
                },
                intensitymode: {
                    valType: "enumerated",
                    values: [
                        "vertex",
                        "cell"
                    ],
                    dflt: "vertex",
                    editType: "calc"
                },
                color: {
                    valType: "color",
                    editType: "calc"
                },
                vertexcolor: {
                    valType: "data_array",
                    editType: "calc"
                },
                facecolor: {
                    valType: "data_array",
                    editType: "calc"
                }
            }, CIt("", {
                colorAttr: "`intensity`",
                showScaleDflt: !0,
                editTypeOverride: "calc"
            }), {
                opacity: ex.opacity,
                flatshading: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "calc"
                },
                contour: {
                    show: tx({}, ex.contours.x.show, {}),
                    color: ex.contours.x.color,
                    width: ex.contours.x.width,
                    editType: "calc"
                },
                lightposition: {
                    x: tx({}, ex.lightposition.x, {
                        dflt: 1e5
                    }),
                    y: tx({}, ex.lightposition.y, {
                        dflt: 1e5
                    }),
                    z: tx({}, ex.lightposition.z, {
                        dflt: 0
                    }),
                    editType: "calc"
                },
                lighting: tx({
                    vertexnormalsepsilon: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1e-12,
                        editType: "calc"
                    },
                    facenormalsepsilon: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1e-6,
                        editType: "calc"
                    },
                    editType: "calc"
                }, ex.lighting),
                hoverinfo: tx({}, QPe.hoverinfo, {
                    editType: "calc"
                }),
                showlegend: tx({}, QPe.showlegend, {
                    dflt: !1
                })
            });
        });
        var tz = ye((Nvr, rIe)=>{
            "use strict";
            var PIt = Jl(), ez = Oc().axisHoverFormat, IIt = Wo().hovertemplateAttrs, ZE = U5(), tIe = vl(), IZ = no().extendFlat, RIt = Bu().overrideAll;
            function RZ(e) {
                return {
                    show: {
                        valType: "boolean",
                        dflt: !1
                    },
                    locations: {
                        valType: "data_array",
                        dflt: []
                    },
                    fill: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1
                    }
                };
            }
            function DZ(e) {
                return {
                    show: {
                        valType: "boolean",
                        dflt: !0
                    },
                    fill: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1
                    }
                };
            }
            var V5 = rIe.exports = RIt(IZ({
                x: {
                    valType: "data_array"
                },
                y: {
                    valType: "data_array"
                },
                z: {
                    valType: "data_array"
                },
                value: {
                    valType: "data_array"
                },
                isomin: {
                    valType: "number"
                },
                isomax: {
                    valType: "number"
                },
                surface: {
                    show: {
                        valType: "boolean",
                        dflt: !0
                    },
                    count: {
                        valType: "integer",
                        dflt: 2,
                        min: 1
                    },
                    fill: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1
                    },
                    pattern: {
                        valType: "flaglist",
                        flags: [
                            "A",
                            "B",
                            "C",
                            "D",
                            "E"
                        ],
                        extras: [
                            "all",
                            "odd",
                            "even"
                        ],
                        dflt: "all"
                    }
                },
                spaceframe: {
                    show: {
                        valType: "boolean",
                        dflt: !1
                    },
                    fill: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: .15
                    }
                },
                slices: {
                    x: RZ("x"),
                    y: RZ("y"),
                    z: RZ("z")
                },
                caps: {
                    x: DZ("x"),
                    y: DZ("y"),
                    z: DZ("z")
                },
                text: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0
                },
                hovertext: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0
                },
                hovertemplate: IIt(),
                xhoverformat: ez("x"),
                yhoverformat: ez("y"),
                zhoverformat: ez("z"),
                valuehoverformat: ez("value", 1),
                showlegend: IZ({}, tIe.showlegend, {
                    dflt: !1
                })
            }, PIt("", {
                colorAttr: "`value`",
                showScaleDflt: !0,
                editTypeOverride: "calc"
            }), {
                opacity: ZE.opacity,
                lightposition: ZE.lightposition,
                lighting: ZE.lighting,
                flatshading: ZE.flatshading,
                contour: ZE.contour,
                hoverinfo: IZ({}, tIe.hoverinfo)
            }), "calc", "nested");
            V5.flatshading.dflt = !0;
            V5.lighting.facenormalsepsilon.dflt = 0;
            V5.x.editType = V5.y.editType = V5.z.editType = V5.value.editType = "calc+clearAxisTypes";
        });
        var zZ = ye((Uvr, nIe)=>{
            "use strict";
            var DIt = Mr(), zIt = ba(), FIt = tz(), qIt = Uh();
            function OIt(e, t, r, n) {
                function i(a, o) {
                    return DIt.coerce(e, t, FIt, a, o);
                }
                iIe(e, t, r, n, i);
            }
            function iIe(e, t, r, n, i) {
                var a = i("isomin"), o = i("isomax");
                o != null && a !== void 0 && a !== null && a > o && (t.isomin = null, t.isomax = null);
                var s = i("x"), l = i("y"), u = i("z"), c = i("value");
                if (!s || !s.length || !l || !l.length || !u || !u.length || !c || !c.length) {
                    t.visible = !1;
                    return;
                }
                var f = zIt.getComponentMethod("calendars", "handleTraceDefaults");
                f(e, t, [
                    "x",
                    "y",
                    "z"
                ], n), i("valuehoverformat"), [
                    "x",
                    "y",
                    "z"
                ].forEach(function(x) {
                    i(x + "hoverformat");
                    var b = "caps." + x, p = i(b + ".show");
                    p && i(b + ".fill");
                    var E = "slices." + x, k = i(E + ".show");
                    k && (i(E + ".fill"), i(E + ".locations"));
                });
                var h = i("spaceframe.show");
                h && i("spaceframe.fill");
                var d = i("surface.show");
                d && (i("surface.count"), i("surface.fill"), i("surface.pattern"));
                var v = i("contour.show");
                v && (i("contour.color"), i("contour.width")), [
                    "text",
                    "hovertext",
                    "hovertemplate",
                    "lighting.ambient",
                    "lighting.diffuse",
                    "lighting.specular",
                    "lighting.roughness",
                    "lighting.fresnel",
                    "lighting.vertexnormalsepsilon",
                    "lighting.facenormalsepsilon",
                    "lightposition.x",
                    "lightposition.y",
                    "lightposition.z",
                    "flatshading",
                    "opacity"
                ].forEach(function(x) {
                    i(x);
                }), qIt(e, t, n, i, {
                    prefix: "",
                    cLetter: "c"
                }), t._length = null;
            }
            nIe.exports = {
                supplyDefaults: OIt,
                supplyIsoDefaults: iIe
            };
        });
        var rz = ye((Vvr, oIe)=>{
            "use strict";
            var qZ = Mr(), BIt = zv();
            function NIt(e, t) {
                t._len = Math.min(t.u.length, t.v.length, t.w.length, t.x.length, t.y.length, t.z.length), t._u = Gm(t.u, t._len), t._v = Gm(t.v, t._len), t._w = Gm(t.w, t._len), t._x = Gm(t.x, t._len), t._y = Gm(t.y, t._len), t._z = Gm(t.z, t._len);
                var r = aIe(t);
                t._gridFill = r.fill, t._Xs = r.Xs, t._Ys = r.Ys, t._Zs = r.Zs, t._len = r.len;
                var n = 0, i, a, o;
                t.starts && (i = Gm(t.starts.x || []), a = Gm(t.starts.y || []), o = Gm(t.starts.z || []), n = Math.min(i.length, a.length, o.length)), t._startsX = i || [], t._startsY = a || [], t._startsZ = o || [];
                var s = 0, l = 1 / 0, u;
                for(u = 0; u < t._len; u++){
                    var c = t._u[u], f = t._v[u], h = t._w[u], d = Math.sqrt(c * c + f * f + h * h);
                    s = Math.max(s, d), l = Math.min(l, d);
                }
                for(BIt(e, t, {
                    vals: [
                        l,
                        s
                    ],
                    containerStr: "",
                    cLetter: "c"
                }), u = 0; u < n; u++){
                    var v = i[u];
                    r.xMax = Math.max(r.xMax, v), r.xMin = Math.min(r.xMin, v);
                    var x = a[u];
                    r.yMax = Math.max(r.yMax, x), r.yMin = Math.min(r.yMin, x);
                    var b = o[u];
                    r.zMax = Math.max(r.zMax, b), r.zMin = Math.min(r.zMin, b);
                }
                t._slen = n, t._normMax = s, t._xbnds = [
                    r.xMin,
                    r.xMax
                ], t._ybnds = [
                    r.yMin,
                    r.yMax
                ], t._zbnds = [
                    r.zMin,
                    r.zMax
                ];
            }
            function aIe(e) {
                var t = e._x, r = e._y, n = e._z, i = e._len, a, o, s, l = -1 / 0, u = 1 / 0, c = -1 / 0, f = 1 / 0, h = -1 / 0, d = 1 / 0, v = "", x, b, p, E, k, A, L, _, C;
                for(i && (E = t[0], A = r[0], _ = n[0]), i > 1 && (k = t[i - 1], L = r[i - 1], C = n[i - 1]), a = 0; a < i; a++)l = Math.max(l, t[a]), u = Math.min(u, t[a]), c = Math.max(c, r[a]), f = Math.min(f, r[a]), h = Math.max(h, n[a]), d = Math.min(d, n[a]), !x && t[a] !== E && (x = !0, v += "x"), !b && r[a] !== A && (b = !0, v += "y"), !p && n[a] !== _ && (p = !0, v += "z");
                x || (v += "x"), b || (v += "y"), p || (v += "z");
                var M = FZ(e._x), g = FZ(e._y), P = FZ(e._z);
                v = v.replace("x", (E > k ? "-" : "+") + "x"), v = v.replace("y", (A > L ? "-" : "+") + "y"), v = v.replace("z", (_ > C ? "-" : "+") + "z");
                var T = function() {
                    i = 0, M = [], g = [], P = [];
                };
                (!i || i < M.length * g.length * P.length) && T();
                var F = function(ze) {
                    return ze === "x" ? t : ze === "y" ? r : n;
                }, q = function(ze) {
                    return ze === "x" ? M : ze === "y" ? g : P;
                }, V = function(ze) {
                    return ze[i - 1] < ze[0] ? -1 : 1;
                }, H = F(v[1]), X = F(v[3]), G = F(v[5]), N = q(v[1]).length, W = q(v[3]).length, re = q(v[5]).length, ae = !1, _e = function(ze, Ce, me) {
                    return N * (W * ze + Ce) + me;
                }, Me = V(F(v[1])), ke = V(F(v[3])), ge = V(F(v[5]));
                for(a = 0; a < re - 1; a++){
                    for(o = 0; o < W - 1; o++){
                        for(s = 0; s < N - 1; s++){
                            var ie = _e(a, o, s), Te = _e(a, o, s + 1), Ee = _e(a, o + 1, s), Ae = _e(a + 1, o, s);
                            if ((!(H[ie] * Me < H[Te] * Me) || !(X[ie] * ke < X[Ee] * ke) || !(G[ie] * ge < G[Ae] * ge)) && (ae = !0), ae) break;
                        }
                        if (ae) break;
                    }
                    if (ae) break;
                }
                return ae && (qZ.warn("Encountered arbitrary coordinates! Unable to input data grid."), T()), {
                    xMin: u,
                    yMin: f,
                    zMin: d,
                    xMax: l,
                    yMax: c,
                    zMax: h,
                    Xs: M,
                    Ys: g,
                    Zs: P,
                    len: i,
                    fill: v
                };
            }
            function FZ(e) {
                return qZ.distinctVals(e).vals;
            }
            function Gm(e, t) {
                if (t === void 0 && (t = e.length), qZ.isTypedArray(e)) return e.subarray(0, t);
                for(var r = [], n = 0; n < t; n++)r[n] = +e[n];
                return r;
            }
            oIe.exports = {
                calc: NIt,
                filter: Gm,
                processGrid: aIe
            };
        });
        var OZ = ye((Hvr, sIe)=>{
            "use strict";
            var UIt = zv(), VIt = rz().processGrid, iz = rz().filter;
            sIe.exports = function(t, r) {
                r._len = Math.min(r.x.length, r.y.length, r.z.length, r.value.length), r._x = iz(r.x, r._len), r._y = iz(r.y, r._len), r._z = iz(r.z, r._len), r._value = iz(r.value, r._len);
                var n = VIt(r);
                r._gridFill = n.fill, r._Xs = n.Xs, r._Ys = n.Ys, r._Zs = n.Zs, r._len = n.len;
                for(var i = 1 / 0, a = -1 / 0, o = 0; o < r._len; o++){
                    var s = r._value[o];
                    i = Math.min(i, s), a = Math.max(a, s);
                }
                r._minValues = i, r._maxValues = a, r._vMin = r.isomin === void 0 || r.isomin === null ? i : r.isomin, r._vMax = r.isomax === void 0 || r.isomax === null ? a : r.isomax, UIt(t, r, {
                    vals: [
                        r._vMin,
                        r._vMax
                    ],
                    containerStr: "",
                    cLetter: "c"
                });
            };
        });
        var H5 = ye((Gvr, lIe)=>{
            "use strict";
            lIe.exports = function(t, r, n, i) {
                i = i || t.length;
                for(var a = new Array(i), o = 0; o < i; o++)a[o] = [
                    t[o],
                    r[o],
                    n[o]
                ];
                return a;
            };
        });
        var nz = ye((jvr, hIe)=>{
            "use strict";
            var HIt = Rd().gl_mesh3d, GIt = $y().parseColorScale, jIt = Mr().isArrayOrTypedArray, WIt = Jy(), ZIt = Mu().extractOpts, uIe = H5(), XE = function(e, t) {
                for(var r = t.length - 1; r > 0; r--){
                    var n = Math.min(t[r], t[r - 1]), i = Math.max(t[r], t[r - 1]);
                    if (i > n && n < e && e <= i) return {
                        id: r,
                        distRatio: (i - e) / (i - n)
                    };
                }
                return {
                    id: 0,
                    distRatio: 0
                };
            };
            function cIe(e, t, r) {
                this.scene = e, this.uid = r, this.mesh = t, this.name = "", this.data = null, this.showContour = !1;
            }
            var BZ = cIe.prototype;
            BZ.handlePick = function(e) {
                if (e.object === this.mesh) {
                    var t = e.data.index, r = this.data._meshX[t], n = this.data._meshY[t], i = this.data._meshZ[t], a = this.data._Ys.length, o = this.data._Zs.length, s = XE(r, this.data._Xs).id, l = XE(n, this.data._Ys).id, u = XE(i, this.data._Zs).id, c = e.index = u + o * l + o * a * s;
                    e.traceCoordinate = [
                        this.data._meshX[c],
                        this.data._meshY[c],
                        this.data._meshZ[c],
                        this.data._value[c]
                    ];
                    var f = this.data.hovertext || this.data.text;
                    return jIt(f) && f[c] !== void 0 ? e.textLabel = f[c] : f && (e.textLabel = f), !0;
                }
            };
            BZ.update = function(e) {
                var t = this.scene, r = t.fullSceneLayout;
                this.data = fIe(e);
                function n(l, u, c, f) {
                    return u.map(function(h) {
                        return l.d2l(h, 0, f) * c;
                    });
                }
                var i = uIe(n(r.xaxis, e._meshX, t.dataScale[0], e.xcalendar), n(r.yaxis, e._meshY, t.dataScale[1], e.ycalendar), n(r.zaxis, e._meshZ, t.dataScale[2], e.zcalendar)), a = uIe(e._meshI, e._meshJ, e._meshK), o = {
                    positions: i,
                    cells: a,
                    lightPosition: [
                        e.lightposition.x,
                        e.lightposition.y,
                        e.lightposition.z
                    ],
                    ambient: e.lighting.ambient,
                    diffuse: e.lighting.diffuse,
                    specular: e.lighting.specular,
                    roughness: e.lighting.roughness,
                    fresnel: e.lighting.fresnel,
                    vertexNormalsEpsilon: e.lighting.vertexnormalsepsilon,
                    faceNormalsEpsilon: e.lighting.facenormalsepsilon,
                    opacity: e.opacity,
                    contourEnable: e.contour.show,
                    contourColor: WIt(e.contour.color).slice(0, 3),
                    contourWidth: e.contour.width,
                    useFacetNormals: e.flatshading
                }, s = ZIt(e);
                o.vertexIntensity = e._meshIntensity, o.vertexIntensityBounds = [
                    s.min,
                    s.max
                ], o.colormap = GIt(e), this.mesh.update(o);
            };
            BZ.dispose = function() {
                this.scene.glplot.remove(this.mesh), this.mesh.dispose();
            };
            var XIt = [
                "xyz",
                "xzy",
                "yxz",
                "yzx",
                "zxy",
                "zyx"
            ];
            function fIe(e) {
                e._meshI = [], e._meshJ = [], e._meshK = [];
                var t = e.surface.show, r = e.spaceframe.show, n = e.surface.fill, i = e.spaceframe.fill, a = !1, o = !1, s = 0, l, u, c = e._Xs, f = e._Ys, h = e._Zs, d = c.length, v = f.length, x = h.length, b = XIt.indexOf(e._gridFill.replace(/-/g, "").replace(/\+/g, "")), p = function(bt, Lt, St) {
                    switch(b){
                        case 5:
                            return St + x * Lt + x * v * bt;
                        case 4:
                            return St + x * bt + x * d * Lt;
                        case 3:
                            return Lt + v * St + v * x * bt;
                        case 2:
                            return Lt + v * bt + v * d * St;
                        case 1:
                            return bt + d * St + d * x * Lt;
                        default:
                            return bt + d * Lt + d * v * St;
                    }
                }, E = e._minValues, k = e._maxValues, A = e._vMin, L = e._vMax, _, C, M, g;
                function P(bt, Lt, St) {
                    for(var Et = g.length, dt = u; dt < Et; dt++)if (bt === _[dt] && Lt === C[dt] && St === M[dt]) return dt;
                    return -1;
                }
                function T() {
                    u = l;
                }
                function F() {
                    _ = [], C = [], M = [], g = [], l = 0, T();
                }
                function q(bt, Lt, St, Et) {
                    return _.push(bt), C.push(Lt), M.push(St), g.push(Et), l++, l - 1;
                }
                function V(bt, Lt, St) {
                    return e._meshI.push(bt), e._meshJ.push(Lt), e._meshK.push(St), s++, s - 1;
                }
                function H(bt, Lt, St) {
                    for(var Et = [], dt = 0; dt < bt.length; dt++)Et[dt] = (bt[dt] + Lt[dt] + St[dt]) / 3;
                    return Et;
                }
                function X(bt, Lt, St) {
                    for(var Et = [], dt = 0; dt < bt.length; dt++)Et[dt] = bt[dt] * (1 - St) + St * Lt[dt];
                    return Et;
                }
                var G;
                function N(bt) {
                    G = bt;
                }
                function W(bt, Lt) {
                    var St = bt[0], Et = bt[1], dt = bt[2], Ht = H(St, Et, dt), $t = Math.sqrt(1 - G), fr = X(Ht, St, $t), _r = X(Ht, Et, $t), Br = X(Ht, dt, $t), Or = Lt[0], Nr = Lt[1], ut = Lt[2];
                    return {
                        xyzv: [
                            [
                                St,
                                Et,
                                _r
                            ],
                            [
                                _r,
                                fr,
                                St
                            ],
                            [
                                Et,
                                dt,
                                Br
                            ],
                            [
                                Br,
                                _r,
                                Et
                            ],
                            [
                                dt,
                                St,
                                fr
                            ],
                            [
                                fr,
                                Br,
                                dt
                            ]
                        ],
                        abc: [
                            [
                                Or,
                                Nr,
                                -1
                            ],
                            [
                                -1,
                                -1,
                                Or
                            ],
                            [
                                Nr,
                                ut,
                                -1
                            ],
                            [
                                -1,
                                -1,
                                Nr
                            ],
                            [
                                ut,
                                Or,
                                -1
                            ],
                            [
                                -1,
                                -1,
                                ut
                            ]
                        ]
                    };
                }
                function re(bt, Lt) {
                    return bt === "all" || bt === null ? !0 : bt.indexOf(Lt) > -1;
                }
                function ae(bt, Lt) {
                    return bt === null ? Lt : bt;
                }
                function _e(bt, Lt, St) {
                    T();
                    var Et = [
                        Lt
                    ], dt = [
                        St
                    ];
                    if (G >= 1) Et = [
                        Lt
                    ], dt = [
                        St
                    ];
                    else if (G > 0) {
                        var Ht = W(Lt, St);
                        Et = Ht.xyzv, dt = Ht.abc;
                    }
                    for(var $t = 0; $t < Et.length; $t++){
                        Lt = Et[$t], St = dt[$t];
                        for(var fr = [], _r = 0; _r < 3; _r++){
                            var Br = Lt[_r][0], Or = Lt[_r][1], Nr = Lt[_r][2], ut = Lt[_r][3], Ne = St[_r] > -1 ? St[_r] : P(Br, Or, Nr);
                            Ne > -1 ? fr[_r] = Ne : fr[_r] = q(Br, Or, Nr, ae(bt, ut));
                        }
                        V(fr[0], fr[1], fr[2]);
                    }
                }
                function Me(bt, Lt, St) {
                    var Et = function(dt, Ht, $t) {
                        _e(bt, [
                            Lt[dt],
                            Lt[Ht],
                            Lt[$t]
                        ], [
                            St[dt],
                            St[Ht],
                            St[$t]
                        ]);
                    };
                    Et(0, 1, 2), Et(2, 3, 0);
                }
                function ke(bt, Lt, St) {
                    var Et = function(dt, Ht, $t) {
                        _e(bt, [
                            Lt[dt],
                            Lt[Ht],
                            Lt[$t]
                        ], [
                            St[dt],
                            St[Ht],
                            St[$t]
                        ]);
                    };
                    Et(0, 1, 2), Et(3, 0, 1), Et(2, 3, 0), Et(1, 2, 3);
                }
                function ge(bt, Lt, St, Et) {
                    var dt = bt[3];
                    dt < St && (dt = St), dt > Et && (dt = Et);
                    for(var Ht = (bt[3] - dt) / (bt[3] - Lt[3] + 1e-9), $t = [], fr = 0; fr < 4; fr++)$t[fr] = (1 - Ht) * bt[fr] + Ht * Lt[fr];
                    return $t;
                }
                function ie(bt, Lt, St) {
                    return bt >= Lt && bt <= St;
                }
                function Te(bt) {
                    var Lt = .001 * (L - A);
                    return bt >= A - Lt && bt <= L + Lt;
                }
                function Ee(bt) {
                    for(var Lt = [], St = 0; St < 4; St++){
                        var Et = bt[St];
                        Lt.push([
                            e._x[Et],
                            e._y[Et],
                            e._z[Et],
                            e._value[Et]
                        ]);
                    }
                    return Lt;
                }
                var Ae = 3;
                function ze(bt, Lt, St, Et, dt, Ht) {
                    Ht || (Ht = 1), St = [
                        -1,
                        -1,
                        -1
                    ];
                    var $t = !1, fr = [
                        ie(Lt[0][3], Et, dt),
                        ie(Lt[1][3], Et, dt),
                        ie(Lt[2][3], Et, dt)
                    ];
                    if (!fr[0] && !fr[1] && !fr[2]) return !1;
                    var _r = function(Or, Nr, ut) {
                        return Te(Nr[0][3]) && Te(Nr[1][3]) && Te(Nr[2][3]) ? (_e(Or, Nr, ut), !0) : Ht < Ae ? ze(Or, Nr, ut, A, L, ++Ht) : !1;
                    };
                    if (fr[0] && fr[1] && fr[2]) return _r(bt, Lt, St) || $t;
                    var Br = !1;
                    return [
                        [
                            0,
                            1,
                            2
                        ],
                        [
                            2,
                            0,
                            1
                        ],
                        [
                            1,
                            2,
                            0
                        ]
                    ].forEach(function(Or) {
                        if (fr[Or[0]] && fr[Or[1]] && !fr[Or[2]]) {
                            var Nr = Lt[Or[0]], ut = Lt[Or[1]], Ne = Lt[Or[2]], Ye = ge(Ne, Nr, Et, dt), Ve = ge(Ne, ut, Et, dt);
                            $t = _r(bt, [
                                Ve,
                                Ye,
                                Nr
                            ], [
                                -1,
                                -1,
                                St[Or[0]]
                            ]) || $t, $t = _r(bt, [
                                Nr,
                                ut,
                                Ve
                            ], [
                                St[Or[0]],
                                St[Or[1]],
                                -1
                            ]) || $t, Br = !0;
                        }
                    }), Br || [
                        [
                            0,
                            1,
                            2
                        ],
                        [
                            1,
                            2,
                            0
                        ],
                        [
                            2,
                            0,
                            1
                        ]
                    ].forEach(function(Or) {
                        if (fr[Or[0]] && !fr[Or[1]] && !fr[Or[2]]) {
                            var Nr = Lt[Or[0]], ut = Lt[Or[1]], Ne = Lt[Or[2]], Ye = ge(ut, Nr, Et, dt), Ve = ge(Ne, Nr, Et, dt);
                            $t = _r(bt, [
                                Ve,
                                Ye,
                                Nr
                            ], [
                                -1,
                                -1,
                                St[Or[0]]
                            ]) || $t, Br = !0;
                        }
                    }), $t;
                }
                function Ce(bt, Lt, St, Et) {
                    var dt = !1, Ht = Ee(Lt), $t = [
                        ie(Ht[0][3], St, Et),
                        ie(Ht[1][3], St, Et),
                        ie(Ht[2][3], St, Et),
                        ie(Ht[3][3], St, Et)
                    ];
                    if (!$t[0] && !$t[1] && !$t[2] && !$t[3]) return dt;
                    if ($t[0] && $t[1] && $t[2] && $t[3]) return o && (dt = ke(bt, Ht, Lt) || dt), dt;
                    var fr = !1;
                    return [
                        [
                            0,
                            1,
                            2,
                            3
                        ],
                        [
                            3,
                            0,
                            1,
                            2
                        ],
                        [
                            2,
                            3,
                            0,
                            1
                        ],
                        [
                            1,
                            2,
                            3,
                            0
                        ]
                    ].forEach(function(_r) {
                        if ($t[_r[0]] && $t[_r[1]] && $t[_r[2]] && !$t[_r[3]]) {
                            var Br = Ht[_r[0]], Or = Ht[_r[1]], Nr = Ht[_r[2]], ut = Ht[_r[3]];
                            if (o) dt = _e(bt, [
                                Br,
                                Or,
                                Nr
                            ], [
                                Lt[_r[0]],
                                Lt[_r[1]],
                                Lt[_r[2]]
                            ]) || dt;
                            else {
                                var Ne = ge(ut, Br, St, Et), Ye = ge(ut, Or, St, Et), Ve = ge(ut, Nr, St, Et);
                                dt = _e(null, [
                                    Ne,
                                    Ye,
                                    Ve
                                ], [
                                    -1,
                                    -1,
                                    -1
                                ]) || dt;
                            }
                            fr = !0;
                        }
                    }), fr || ([
                        [
                            0,
                            1,
                            2,
                            3
                        ],
                        [
                            1,
                            2,
                            3,
                            0
                        ],
                        [
                            2,
                            3,
                            0,
                            1
                        ],
                        [
                            3,
                            0,
                            1,
                            2
                        ],
                        [
                            0,
                            2,
                            3,
                            1
                        ],
                        [
                            1,
                            3,
                            2,
                            0
                        ]
                    ].forEach(function(_r) {
                        if ($t[_r[0]] && $t[_r[1]] && !$t[_r[2]] && !$t[_r[3]]) {
                            var Br = Ht[_r[0]], Or = Ht[_r[1]], Nr = Ht[_r[2]], ut = Ht[_r[3]], Ne = ge(Nr, Br, St, Et), Ye = ge(Nr, Or, St, Et), Ve = ge(ut, Or, St, Et), Xe = ge(ut, Br, St, Et);
                            o ? (dt = _e(bt, [
                                Br,
                                Xe,
                                Ne
                            ], [
                                Lt[_r[0]],
                                -1,
                                -1
                            ]) || dt, dt = _e(bt, [
                                Or,
                                Ye,
                                Ve
                            ], [
                                Lt[_r[1]],
                                -1,
                                -1
                            ]) || dt) : dt = Me(null, [
                                Ne,
                                Ye,
                                Ve,
                                Xe
                            ], [
                                -1,
                                -1,
                                -1,
                                -1
                            ]) || dt, fr = !0;
                        }
                    }), fr) || [
                        [
                            0,
                            1,
                            2,
                            3
                        ],
                        [
                            1,
                            2,
                            3,
                            0
                        ],
                        [
                            2,
                            3,
                            0,
                            1
                        ],
                        [
                            3,
                            0,
                            1,
                            2
                        ]
                    ].forEach(function(_r) {
                        if ($t[_r[0]] && !$t[_r[1]] && !$t[_r[2]] && !$t[_r[3]]) {
                            var Br = Ht[_r[0]], Or = Ht[_r[1]], Nr = Ht[_r[2]], ut = Ht[_r[3]], Ne = ge(Or, Br, St, Et), Ye = ge(Nr, Br, St, Et), Ve = ge(ut, Br, St, Et);
                            o ? (dt = _e(bt, [
                                Br,
                                Ne,
                                Ye
                            ], [
                                Lt[_r[0]],
                                -1,
                                -1
                            ]) || dt, dt = _e(bt, [
                                Br,
                                Ye,
                                Ve
                            ], [
                                Lt[_r[0]],
                                -1,
                                -1
                            ]) || dt, dt = _e(bt, [
                                Br,
                                Ve,
                                Ne
                            ], [
                                Lt[_r[0]],
                                -1,
                                -1
                            ]) || dt) : dt = _e(null, [
                                Ne,
                                Ye,
                                Ve
                            ], [
                                -1,
                                -1,
                                -1
                            ]) || dt, fr = !0;
                        }
                    }), dt;
                }
                function me(bt, Lt, St, Et, dt, Ht, $t, fr, _r, Br, Or) {
                    var Nr = !1;
                    return a && (re(bt, "A") && (Nr = Ce(null, [
                        Lt,
                        St,
                        Et,
                        Ht
                    ], Br, Or) || Nr), re(bt, "B") && (Nr = Ce(null, [
                        St,
                        Et,
                        dt,
                        _r
                    ], Br, Or) || Nr), re(bt, "C") && (Nr = Ce(null, [
                        St,
                        Ht,
                        $t,
                        _r
                    ], Br, Or) || Nr), re(bt, "D") && (Nr = Ce(null, [
                        Et,
                        Ht,
                        fr,
                        _r
                    ], Br, Or) || Nr), re(bt, "E") && (Nr = Ce(null, [
                        St,
                        Et,
                        Ht,
                        _r
                    ], Br, Or) || Nr)), o && (Nr = Ce(bt, [
                        St,
                        Et,
                        Ht,
                        _r
                    ], Br, Or) || Nr), Nr;
                }
                function Re(bt, Lt, St, Et, dt, Ht, $t, fr) {
                    return [
                        fr[0] === !0 ? !0 : ze(bt, Ee([
                            Lt,
                            St,
                            Et
                        ]), [
                            Lt,
                            St,
                            Et
                        ], Ht, $t),
                        fr[1] === !0 ? !0 : ze(bt, Ee([
                            Et,
                            dt,
                            Lt
                        ]), [
                            Et,
                            dt,
                            Lt
                        ], Ht, $t)
                    ];
                }
                function ce(bt, Lt, St, Et, dt, Ht, $t, fr, _r) {
                    return fr ? Re(bt, Lt, St, dt, Et, Ht, $t, _r) : Re(bt, St, dt, Et, Lt, Ht, $t, _r);
                }
                function Ge(bt, Lt, St, Et, dt, Ht, $t) {
                    var fr = !1, _r, Br, Or, Nr, ut = function() {
                        fr = ze(bt, [
                            _r,
                            Br,
                            Or
                        ], [
                            -1,
                            -1,
                            -1
                        ], dt, Ht) || fr, fr = ze(bt, [
                            Or,
                            Nr,
                            _r
                        ], [
                            -1,
                            -1,
                            -1
                        ], dt, Ht) || fr;
                    }, Ne = $t[0], Ye = $t[1], Ve = $t[2];
                    return Ne && (_r = X(Ee([
                        p(Lt, St - 0, Et - 0)
                    ])[0], Ee([
                        p(Lt - 1, St - 0, Et - 0)
                    ])[0], Ne), Br = X(Ee([
                        p(Lt, St - 0, Et - 1)
                    ])[0], Ee([
                        p(Lt - 1, St - 0, Et - 1)
                    ])[0], Ne), Or = X(Ee([
                        p(Lt, St - 1, Et - 1)
                    ])[0], Ee([
                        p(Lt - 1, St - 1, Et - 1)
                    ])[0], Ne), Nr = X(Ee([
                        p(Lt, St - 1, Et - 0)
                    ])[0], Ee([
                        p(Lt - 1, St - 1, Et - 0)
                    ])[0], Ne), ut()), Ye && (_r = X(Ee([
                        p(Lt - 0, St, Et - 0)
                    ])[0], Ee([
                        p(Lt - 0, St - 1, Et - 0)
                    ])[0], Ye), Br = X(Ee([
                        p(Lt - 0, St, Et - 1)
                    ])[0], Ee([
                        p(Lt - 0, St - 1, Et - 1)
                    ])[0], Ye), Or = X(Ee([
                        p(Lt - 1, St, Et - 1)
                    ])[0], Ee([
                        p(Lt - 1, St - 1, Et - 1)
                    ])[0], Ye), Nr = X(Ee([
                        p(Lt - 1, St, Et - 0)
                    ])[0], Ee([
                        p(Lt - 1, St - 1, Et - 0)
                    ])[0], Ye), ut()), Ve && (_r = X(Ee([
                        p(Lt - 0, St - 0, Et)
                    ])[0], Ee([
                        p(Lt - 0, St - 0, Et - 1)
                    ])[0], Ve), Br = X(Ee([
                        p(Lt - 0, St - 1, Et)
                    ])[0], Ee([
                        p(Lt - 0, St - 1, Et - 1)
                    ])[0], Ve), Or = X(Ee([
                        p(Lt - 1, St - 1, Et)
                    ])[0], Ee([
                        p(Lt - 1, St - 1, Et - 1)
                    ])[0], Ve), Nr = X(Ee([
                        p(Lt - 1, St - 0, Et)
                    ])[0], Ee([
                        p(Lt - 1, St - 0, Et - 1)
                    ])[0], Ve), ut()), fr;
                }
                function nt(bt, Lt, St, Et, dt, Ht, $t, fr, _r, Br, Or, Nr) {
                    var ut = bt;
                    return Nr ? (a && bt === "even" && (ut = null), me(ut, Lt, St, Et, dt, Ht, $t, fr, _r, Br, Or)) : (a && bt === "odd" && (ut = null), me(ut, _r, fr, $t, Ht, dt, Et, St, Lt, Br, Or));
                }
                function ct(bt, Lt, St, Et, dt) {
                    for(var Ht = [], $t = 0, fr = 0; fr < Lt.length; fr++)for(var _r = Lt[fr], Br = 1; Br < x; Br++)for(var Or = 1; Or < v; Or++)Ht.push(ce(bt, p(_r, Or - 1, Br - 1), p(_r, Or - 1, Br), p(_r, Or, Br - 1), p(_r, Or, Br), St, Et, (_r + Or + Br) % 2, dt && dt[$t] ? dt[$t] : [])), $t++;
                    return Ht;
                }
                function qt(bt, Lt, St, Et, dt) {
                    for(var Ht = [], $t = 0, fr = 0; fr < Lt.length; fr++)for(var _r = Lt[fr], Br = 1; Br < d; Br++)for(var Or = 1; Or < x; Or++)Ht.push(ce(bt, p(Br - 1, _r, Or - 1), p(Br, _r, Or - 1), p(Br - 1, _r, Or), p(Br, _r, Or), St, Et, (Br + _r + Or) % 2, dt && dt[$t] ? dt[$t] : [])), $t++;
                    return Ht;
                }
                function rt(bt, Lt, St, Et, dt) {
                    for(var Ht = [], $t = 0, fr = 0; fr < Lt.length; fr++)for(var _r = Lt[fr], Br = 1; Br < v; Br++)for(var Or = 1; Or < d; Or++)Ht.push(ce(bt, p(Or - 1, Br - 1, _r), p(Or - 1, Br, _r), p(Or, Br - 1, _r), p(Or, Br, _r), St, Et, (Or + Br + _r) % 2, dt && dt[$t] ? dt[$t] : [])), $t++;
                    return Ht;
                }
                function ot(bt, Lt, St) {
                    for(var Et = 1; Et < x; Et++)for(var dt = 1; dt < v; dt++)for(var Ht = 1; Ht < d; Ht++)nt(bt, p(Ht - 1, dt - 1, Et - 1), p(Ht - 1, dt - 1, Et), p(Ht - 1, dt, Et - 1), p(Ht - 1, dt, Et), p(Ht, dt - 1, Et - 1), p(Ht, dt - 1, Et), p(Ht, dt, Et - 1), p(Ht, dt, Et), Lt, St, (Ht + dt + Et) % 2);
                }
                function Rt(bt, Lt, St) {
                    o = !0, ot(bt, Lt, St), o = !1;
                }
                function kt(bt, Lt, St) {
                    a = !0, ot(bt, Lt, St), a = !1;
                }
                function Ct(bt, Lt, St, Et, dt, Ht) {
                    for(var $t = [], fr = 0, _r = 0; _r < Lt.length; _r++)for(var Br = Lt[_r], Or = 1; Or < x; Or++)for(var Nr = 1; Nr < v; Nr++)$t.push(Ge(bt, Br, Nr, Or, St, Et, dt[_r], Ht && Ht[fr] ? Ht[fr] : [])), fr++;
                    return $t;
                }
                function Yt(bt, Lt, St, Et, dt, Ht) {
                    for(var $t = [], fr = 0, _r = 0; _r < Lt.length; _r++)for(var Br = Lt[_r], Or = 1; Or < d; Or++)for(var Nr = 1; Nr < x; Nr++)$t.push(Ge(bt, Or, Br, Nr, St, Et, dt[_r], Ht && Ht[fr] ? Ht[fr] : [])), fr++;
                    return $t;
                }
                function xr(bt, Lt, St, Et, dt, Ht) {
                    for(var $t = [], fr = 0, _r = 0; _r < Lt.length; _r++)for(var Br = Lt[_r], Or = 1; Or < v; Or++)for(var Nr = 1; Nr < d; Nr++)$t.push(Ge(bt, Nr, Or, Br, St, Et, dt[_r], Ht && Ht[fr] ? Ht[fr] : [])), fr++;
                    return $t;
                }
                function er(bt, Lt) {
                    for(var St = [], Et = bt; Et < Lt; Et++)St.push(Et);
                    return St;
                }
                function Ke() {
                    for(var bt = 0; bt < d; bt++)for(var Lt = 0; Lt < v; Lt++)for(var St = 0; St < x; St++){
                        var Et = p(bt, Lt, St);
                        q(e._x[Et], e._y[Et], e._z[Et], e._value[Et]);
                    }
                }
                function xt() {
                    F(), Ke();
                    var bt = null;
                    if (r && i && (N(i), Rt(bt, A, L)), t && n) {
                        N(n);
                        for(var Lt = e.surface.pattern, St = e.surface.count, Et = 0; Et < St; Et++){
                            var dt = St === 1 ? .5 : Et / (St - 1), Ht = (1 - dt) * A + dt * L, $t = Math.abs(Ht - E), fr = Math.abs(Ht - k), _r = $t > fr ? [
                                E,
                                Ht
                            ] : [
                                Ht,
                                k
                            ];
                            kt(Lt, _r[0], _r[1]);
                        }
                    }
                    var Br = [
                        [
                            Math.min(A, k),
                            Math.max(A, k)
                        ],
                        [
                            Math.min(E, L),
                            Math.max(E, L)
                        ]
                    ];
                    [
                        "x",
                        "y",
                        "z"
                    ].forEach(function(Or) {
                        for(var Nr = [], ut = 0; ut < Br.length; ut++){
                            var Ne = 0, Ye = Br[ut][0], Ve = Br[ut][1], Xe = e.slices[Or];
                            if (Xe.show && Xe.fill) {
                                N(Xe.fill);
                                var ht = [], Le = [], xe = [];
                                if (Xe.locations.length) for(var Se = 0; Se < Xe.locations.length; Se++){
                                    var lt = XE(Xe.locations[Se], Or === "x" ? c : Or === "y" ? f : h);
                                    lt.distRatio === 0 ? ht.push(lt.id) : lt.id > 0 && (Le.push(lt.id), Or === "x" ? xe.push([
                                        lt.distRatio,
                                        0,
                                        0
                                    ]) : Or === "y" ? xe.push([
                                        0,
                                        lt.distRatio,
                                        0
                                    ]) : xe.push([
                                        0,
                                        0,
                                        lt.distRatio
                                    ]));
                                }
                                else Or === "x" ? ht = er(1, d - 1) : Or === "y" ? ht = er(1, v - 1) : ht = er(1, x - 1);
                                Le.length > 0 && (Or === "x" ? Nr[Ne] = Ct(bt, Le, Ye, Ve, xe, Nr[Ne]) : Or === "y" ? Nr[Ne] = Yt(bt, Le, Ye, Ve, xe, Nr[Ne]) : Nr[Ne] = xr(bt, Le, Ye, Ve, xe, Nr[Ne]), Ne++), ht.length > 0 && (Or === "x" ? Nr[Ne] = ct(bt, ht, Ye, Ve, Nr[Ne]) : Or === "y" ? Nr[Ne] = qt(bt, ht, Ye, Ve, Nr[Ne]) : Nr[Ne] = rt(bt, ht, Ye, Ve, Nr[Ne]), Ne++);
                            }
                            var Gt = e.caps[Or];
                            Gt.show && Gt.fill && (N(Gt.fill), Or === "x" ? Nr[Ne] = ct(bt, [
                                0,
                                d - 1
                            ], Ye, Ve, Nr[Ne]) : Or === "y" ? Nr[Ne] = qt(bt, [
                                0,
                                v - 1
                            ], Ye, Ve, Nr[Ne]) : Nr[Ne] = rt(bt, [
                                0,
                                x - 1
                            ], Ye, Ve, Nr[Ne]), Ne++);
                        }
                    }), s === 0 && F(), e._meshX = _, e._meshY = C, e._meshZ = M, e._meshIntensity = g, e._Xs = c, e._Ys = f, e._Zs = h;
                }
                return xt(), e;
            }
            function YIt(e, t) {
                var r = e.glplot.gl, n = HIt({
                    gl: r
                }), i = new cIe(e, n, t.uid);
                return n._trace = i, i.update(t), e.glplot.add(n), i;
            }
            hIe.exports = {
                findNearestOnAxis: XE,
                generateIsoMeshes: fIe,
                createIsosurfaceTrace: YIt
            };
        });
        var vIe = ye((Wvr, dIe)=>{
            "use strict";
            dIe.exports = {
                attributes: tz(),
                supplyDefaults: zZ().supplyDefaults,
                calc: OZ(),
                colorbar: {
                    min: "cmin",
                    max: "cmax"
                },
                plot: nz().createIsosurfaceTrace,
                moduleType: "trace",
                name: "isosurface",
                basePlotModule: Q_(),
                categories: [
                    "gl3d",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var gIe = ye((Zvr, pIe)=>{
            "use strict";
            pIe.exports = vIe();
        });
        var UZ = ye((Xvr, yIe)=>{
            "use strict";
            var KIt = Jl(), xh = tz(), JIt = jE(), mIe = vl(), NZ = no().extendFlat, $It = Bu().overrideAll, az = yIe.exports = $It(NZ({
                x: xh.x,
                y: xh.y,
                z: xh.z,
                value: xh.value,
                isomin: xh.isomin,
                isomax: xh.isomax,
                surface: xh.surface,
                spaceframe: {
                    show: {
                        valType: "boolean",
                        dflt: !1
                    },
                    fill: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1
                    }
                },
                slices: xh.slices,
                caps: xh.caps,
                text: xh.text,
                hovertext: xh.hovertext,
                xhoverformat: xh.xhoverformat,
                yhoverformat: xh.yhoverformat,
                zhoverformat: xh.zhoverformat,
                valuehoverformat: xh.valuehoverformat,
                hovertemplate: xh.hovertemplate
            }, KIt("", {
                colorAttr: "`value`",
                showScaleDflt: !0,
                editTypeOverride: "calc"
            }), {
                colorbar: xh.colorbar,
                opacity: xh.opacity,
                opacityscale: JIt.opacityscale,
                lightposition: xh.lightposition,
                lighting: xh.lighting,
                flatshading: xh.flatshading,
                contour: xh.contour,
                hoverinfo: NZ({}, mIe.hoverinfo),
                showlegend: NZ({}, mIe.showlegend, {
                    dflt: !1
                })
            }), "calc", "nested");
            az.x.editType = az.y.editType = az.z.editType = az.value.editType = "calc+clearAxisTypes";
        });
        var xIe = ye((Yvr, _Ie)=>{
            "use strict";
            var QIt = Mr(), e8t = UZ(), t8t = zZ().supplyIsoDefaults, r8t = CZ().opacityscaleDefaults;
            _Ie.exports = function(t, r, n, i) {
                function a(o, s) {
                    return QIt.coerce(t, r, e8t, o, s);
                }
                t8t(t, r, n, i, a), r8t(t, r, i, a);
            };
        });
        var AIe = ye((Kvr, TIe)=>{
            "use strict";
            var i8t = Rd().gl_mesh3d, n8t = $y().parseColorScale, a8t = Mr().isArrayOrTypedArray, o8t = Jy(), s8t = Mu().extractOpts, bIe = H5(), VZ = nz().findNearestOnAxis, l8t = nz().generateIsoMeshes;
            function wIe(e, t, r) {
                this.scene = e, this.uid = r, this.mesh = t, this.name = "", this.data = null, this.showContour = !1;
            }
            var HZ = wIe.prototype;
            HZ.handlePick = function(e) {
                if (e.object === this.mesh) {
                    var t = e.data.index, r = this.data._meshX[t], n = this.data._meshY[t], i = this.data._meshZ[t], a = this.data._Ys.length, o = this.data._Zs.length, s = VZ(r, this.data._Xs).id, l = VZ(n, this.data._Ys).id, u = VZ(i, this.data._Zs).id, c = e.index = u + o * l + o * a * s;
                    e.traceCoordinate = [
                        this.data._meshX[c],
                        this.data._meshY[c],
                        this.data._meshZ[c],
                        this.data._value[c]
                    ];
                    var f = this.data.hovertext || this.data.text;
                    return a8t(f) && f[c] !== void 0 ? e.textLabel = f[c] : f && (e.textLabel = f), !0;
                }
            };
            HZ.update = function(e) {
                var t = this.scene, r = t.fullSceneLayout;
                this.data = l8t(e);
                function n(l, u, c, f) {
                    return u.map(function(h) {
                        return l.d2l(h, 0, f) * c;
                    });
                }
                var i = bIe(n(r.xaxis, e._meshX, t.dataScale[0], e.xcalendar), n(r.yaxis, e._meshY, t.dataScale[1], e.ycalendar), n(r.zaxis, e._meshZ, t.dataScale[2], e.zcalendar)), a = bIe(e._meshI, e._meshJ, e._meshK), o = {
                    positions: i,
                    cells: a,
                    lightPosition: [
                        e.lightposition.x,
                        e.lightposition.y,
                        e.lightposition.z
                    ],
                    ambient: e.lighting.ambient,
                    diffuse: e.lighting.diffuse,
                    specular: e.lighting.specular,
                    roughness: e.lighting.roughness,
                    fresnel: e.lighting.fresnel,
                    vertexNormalsEpsilon: e.lighting.vertexnormalsepsilon,
                    faceNormalsEpsilon: e.lighting.facenormalsepsilon,
                    opacity: e.opacity,
                    opacityscale: e.opacityscale,
                    contourEnable: e.contour.show,
                    contourColor: o8t(e.contour.color).slice(0, 3),
                    contourWidth: e.contour.width,
                    useFacetNormals: e.flatshading
                }, s = s8t(e);
                o.vertexIntensity = e._meshIntensity, o.vertexIntensityBounds = [
                    s.min,
                    s.max
                ], o.colormap = n8t(e), this.mesh.update(o);
            };
            HZ.dispose = function() {
                this.scene.glplot.remove(this.mesh), this.mesh.dispose();
            };
            function u8t(e, t) {
                var r = e.glplot.gl, n = i8t({
                    gl: r
                }), i = new wIe(e, n, t.uid);
                return n._trace = i, i.update(t), e.glplot.add(n), i;
            }
            TIe.exports = u8t;
        });
        var MIe = ye((Jvr, SIe)=>{
            "use strict";
            SIe.exports = {
                attributes: UZ(),
                supplyDefaults: xIe(),
                calc: OZ(),
                colorbar: {
                    min: "cmin",
                    max: "cmax"
                },
                plot: AIe(),
                moduleType: "trace",
                name: "volume",
                basePlotModule: Q_(),
                categories: [
                    "gl3d",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var kIe = ye(($vr, EIe)=>{
            "use strict";
            EIe.exports = MIe();
        });
        var PIe = ye((Qvr, LIe)=>{
            "use strict";
            var c8t = ba(), CIe = Mr(), f8t = Uh(), h8t = U5();
            LIe.exports = function(t, r, n, i) {
                function a(c, f) {
                    return CIe.coerce(t, r, h8t, c, f);
                }
                function o(c) {
                    var f = c.map(function(h) {
                        var d = a(h);
                        return d && CIe.isArrayOrTypedArray(d) ? d : null;
                    });
                    return f.every(function(h) {
                        return h && h.length === f[0].length;
                    }) && f;
                }
                var s = o([
                    "x",
                    "y",
                    "z"
                ]);
                if (!s) {
                    r.visible = !1;
                    return;
                }
                if (o([
                    "i",
                    "j",
                    "k"
                ]), r.i && (!r.j || !r.k) || r.j && (!r.k || !r.i) || r.k && (!r.i || !r.j)) {
                    r.visible = !1;
                    return;
                }
                var l = c8t.getComponentMethod("calendars", "handleTraceDefaults");
                l(t, r, [
                    "x",
                    "y",
                    "z"
                ], i), [
                    "lighting.ambient",
                    "lighting.diffuse",
                    "lighting.specular",
                    "lighting.roughness",
                    "lighting.fresnel",
                    "lighting.vertexnormalsepsilon",
                    "lighting.facenormalsepsilon",
                    "lightposition.x",
                    "lightposition.y",
                    "lightposition.z",
                    "flatshading",
                    "alphahull",
                    "delaunayaxis",
                    "opacity"
                ].forEach(function(c) {
                    a(c);
                });
                var u = a("contour.show");
                u && (a("contour.color"), a("contour.width")), "intensity" in t ? (a("intensity"), a("intensitymode"), f8t(t, r, i, a, {
                    prefix: "",
                    cLetter: "c"
                })) : (r.showscale = !1, "facecolor" in t ? a("facecolor") : "vertexcolor" in t ? a("vertexcolor") : a("color", n)), a("text"), a("hovertext"), a("hovertemplate"), a("xhoverformat"), a("yhoverformat"), a("zhoverformat"), r._length = null;
            };
        });
        var RIe = ye((epr, IIe)=>{
            "use strict";
            var d8t = zv();
            IIe.exports = function(t, r) {
                r.intensity && d8t(t, r, {
                    vals: r.intensity,
                    containerStr: "",
                    cLetter: "c"
                });
            };
        });
        var OIe = ye((tpr, qIe)=>{
            "use strict";
            var v8t = Rd().gl_mesh3d, p8t = Rd().delaunay_triangulate, g8t = Rd().alpha_shape, m8t = Rd().convex_hull, y8t = $y().parseColorScale, _8t = Mr().isArrayOrTypedArray, ZZ = Jy(), x8t = Mu().extractOpts, DIe = H5();
            function FIe(e, t, r) {
                this.scene = e, this.uid = r, this.mesh = t, this.name = "", this.color = "#fff", this.data = null, this.showContour = !1;
            }
            var XZ = FIe.prototype;
            XZ.handlePick = function(e) {
                if (e.object === this.mesh) {
                    var t = e.index = e.data.index;
                    e.data._cellCenter ? e.traceCoordinate = e.data.dataCoordinate : e.traceCoordinate = [
                        this.data.x[t],
                        this.data.y[t],
                        this.data.z[t]
                    ];
                    var r = this.data.hovertext || this.data.text;
                    return _8t(r) && r[t] !== void 0 ? e.textLabel = r[t] : r && (e.textLabel = r), !0;
                }
            };
            function zIe(e) {
                for(var t = [], r = e.length, n = 0; n < r; n++)t[n] = ZZ(e[n]);
                return t;
            }
            function GZ(e, t, r, n) {
                for(var i = [], a = t.length, o = 0; o < a; o++)i[o] = e.d2l(t[o], 0, n) * r;
                return i;
            }
            function jZ(e) {
                for(var t = [], r = e.length, n = 0; n < r; n++)t[n] = Math.round(e[n]);
                return t;
            }
            function b8t(e, t) {
                for(var r = [
                    "x",
                    "y",
                    "z"
                ].indexOf(e), n = [], i = t.length, a = 0; a < i; a++)n[a] = [
                    t[a][(r + 1) % 3],
                    t[a][(r + 2) % 3]
                ];
                return p8t(n);
            }
            function WZ(e, t) {
                for(var r = e.length, n = 0; n < r; n++)if (e[n] <= -0.5 || e[n] >= t - .5) return !1;
                return !0;
            }
            XZ.update = function(e) {
                var t = this.scene, r = t.fullSceneLayout;
                this.data = e;
                var n = e.x.length, i = DIe(GZ(r.xaxis, e.x, t.dataScale[0], e.xcalendar), GZ(r.yaxis, e.y, t.dataScale[1], e.ycalendar), GZ(r.zaxis, e.z, t.dataScale[2], e.zcalendar)), a;
                if (e.i && e.j && e.k) {
                    if (e.i.length !== e.j.length || e.j.length !== e.k.length || !WZ(e.i, n) || !WZ(e.j, n) || !WZ(e.k, n)) return;
                    a = DIe(jZ(e.i), jZ(e.j), jZ(e.k));
                } else e.alphahull === 0 ? a = m8t(i) : e.alphahull > 0 ? a = g8t(e.alphahull, i) : a = b8t(e.delaunayaxis, i);
                var o = {
                    positions: i,
                    cells: a,
                    lightPosition: [
                        e.lightposition.x,
                        e.lightposition.y,
                        e.lightposition.z
                    ],
                    ambient: e.lighting.ambient,
                    diffuse: e.lighting.diffuse,
                    specular: e.lighting.specular,
                    roughness: e.lighting.roughness,
                    fresnel: e.lighting.fresnel,
                    vertexNormalsEpsilon: e.lighting.vertexnormalsepsilon,
                    faceNormalsEpsilon: e.lighting.facenormalsepsilon,
                    opacity: e.opacity,
                    contourEnable: e.contour.show,
                    contourColor: ZZ(e.contour.color).slice(0, 3),
                    contourWidth: e.contour.width,
                    useFacetNormals: e.flatshading
                };
                if (e.intensity) {
                    var s = x8t(e);
                    this.color = "#fff";
                    var l = e.intensitymode;
                    o[l + "Intensity"] = e.intensity, o[l + "IntensityBounds"] = [
                        s.min,
                        s.max
                    ], o.colormap = y8t(e);
                } else e.vertexcolor ? (this.color = e.vertexcolor[0], o.vertexColors = zIe(e.vertexcolor)) : e.facecolor ? (this.color = e.facecolor[0], o.cellColors = zIe(e.facecolor)) : (this.color = e.color, o.meshColor = ZZ(e.color));
                this.mesh.update(o);
            };
            XZ.dispose = function() {
                this.scene.glplot.remove(this.mesh), this.mesh.dispose();
            };
            function w8t(e, t) {
                var r = e.glplot.gl, n = v8t({
                    gl: r
                }), i = new FIe(e, n, t.uid);
                return n._trace = i, i.update(t), e.glplot.add(n), i;
            }
            qIe.exports = w8t;
        });
        var NIe = ye((rpr, BIe)=>{
            "use strict";
            BIe.exports = {
                attributes: U5(),
                supplyDefaults: PIe(),
                calc: RIe(),
                colorbar: {
                    min: "cmin",
                    max: "cmax"
                },
                plot: OIe(),
                moduleType: "trace",
                name: "mesh3d",
                basePlotModule: Q_(),
                categories: [
                    "gl3d",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var VIe = ye((ipr, UIe)=>{
            "use strict";
            UIe.exports = NIe();
        });
        var KZ = ye((npr, GIe)=>{
            "use strict";
            var T8t = Jl(), G5 = Oc().axisHoverFormat, A8t = Wo().hovertemplateAttrs, S8t = U5(), HIe = vl(), YZ = no().extendFlat, oz = {
                x: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                y: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                z: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                u: {
                    valType: "data_array",
                    editType: "calc"
                },
                v: {
                    valType: "data_array",
                    editType: "calc"
                },
                w: {
                    valType: "data_array",
                    editType: "calc"
                },
                sizemode: {
                    valType: "enumerated",
                    values: [
                        "scaled",
                        "absolute",
                        "raw"
                    ],
                    editType: "calc",
                    dflt: "scaled"
                },
                sizeref: {
                    valType: "number",
                    editType: "calc",
                    min: 0
                },
                anchor: {
                    valType: "enumerated",
                    editType: "calc",
                    values: [
                        "tip",
                        "tail",
                        "cm",
                        "center"
                    ],
                    dflt: "cm"
                },
                text: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0,
                    editType: "calc"
                },
                hovertext: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0,
                    editType: "calc"
                },
                hovertemplate: A8t({
                    editType: "calc"
                }, {
                    keys: [
                        "norm"
                    ]
                }),
                uhoverformat: G5("u", 1),
                vhoverformat: G5("v", 1),
                whoverformat: G5("w", 1),
                xhoverformat: G5("x"),
                yhoverformat: G5("y"),
                zhoverformat: G5("z"),
                showlegend: YZ({}, HIe.showlegend, {
                    dflt: !1
                })
            };
            YZ(oz, T8t("", {
                colorAttr: "u/v/w norm",
                showScaleDflt: !0,
                editTypeOverride: "calc"
            }));
            var M8t = [
                "opacity",
                "lightposition",
                "lighting"
            ];
            M8t.forEach(function(e) {
                oz[e] = S8t[e];
            });
            oz.hoverinfo = YZ({}, HIe.hoverinfo, {
                editType: "calc",
                flags: [
                    "x",
                    "y",
                    "z",
                    "u",
                    "v",
                    "w",
                    "norm",
                    "text",
                    "name"
                ],
                dflt: "x+y+z+norm+text+name"
            });
            GIe.exports = oz;
        });
        var WIe = ye((apr, jIe)=>{
            "use strict";
            var E8t = Mr(), k8t = Uh(), C8t = KZ();
            jIe.exports = function(t, r, n, i) {
                function a(d, v) {
                    return E8t.coerce(t, r, C8t, d, v);
                }
                var o = a("u"), s = a("v"), l = a("w"), u = a("x"), c = a("y"), f = a("z");
                if (!o || !o.length || !s || !s.length || !l || !l.length || !u || !u.length || !c || !c.length || !f || !f.length) {
                    r.visible = !1;
                    return;
                }
                var h = a("sizemode");
                a("sizeref", h === "raw" ? 1 : .5), a("anchor"), a("lighting.ambient"), a("lighting.diffuse"), a("lighting.specular"), a("lighting.roughness"), a("lighting.fresnel"), a("lightposition.x"), a("lightposition.y"), a("lightposition.z"), k8t(t, r, i, a, {
                    prefix: "",
                    cLetter: "c"
                }), a("text"), a("hovertext"), a("hovertemplate"), a("uhoverformat"), a("vhoverformat"), a("whoverformat"), a("xhoverformat"), a("yhoverformat"), a("zhoverformat"), r._length = null;
            };
        });
        var XIe = ye((opr, ZIe)=>{
            "use strict";
            var L8t = zv();
            ZIe.exports = function(t, r) {
                for(var n = r.u, i = r.v, a = r.w, o = Math.min(r.x.length, r.y.length, r.z.length, n.length, i.length, a.length), s = -1 / 0, l = 1 / 0, u = 0; u < o; u++){
                    var c = n[u], f = i[u], h = a[u], d = Math.sqrt(c * c + f * f + h * h);
                    s = Math.max(s, d), l = Math.min(l, d);
                }
                r._len = o, r._normMax = s, L8t(t, r, {
                    vals: [
                        l,
                        s
                    ],
                    containerStr: "",
                    cLetter: "c"
                });
            };
        });
        var QIe = ye((spr, $Ie)=>{
            "use strict";
            var P8t = Rd().gl_cone3d, I8t = Rd().gl_cone3d.createConeMesh, R8t = Mr().simpleMap, D8t = $y().parseColorScale, z8t = Mu().extractOpts, F8t = Mr().isArrayOrTypedArray, YIe = H5();
            function KIe(e, t) {
                this.scene = e, this.uid = t, this.mesh = null, this.data = null;
            }
            var JZ = KIe.prototype;
            JZ.handlePick = function(e) {
                if (e.object === this.mesh) {
                    var t = e.index = e.data.index, r = this.data.x[t], n = this.data.y[t], i = this.data.z[t], a = this.data.u[t], o = this.data.v[t], s = this.data.w[t];
                    e.traceCoordinate = [
                        r,
                        n,
                        i,
                        a,
                        o,
                        s,
                        Math.sqrt(a * a + o * o + s * s)
                    ];
                    var l = this.data.hovertext || this.data.text;
                    return F8t(l) && l[t] !== void 0 ? e.textLabel = l[t] : l && (e.textLabel = l), !0;
                }
            };
            var q8t = {
                xaxis: 0,
                yaxis: 1,
                zaxis: 2
            }, O8t = {
                tip: 1,
                tail: 0,
                cm: .25,
                center: .5
            }, B8t = {
                tip: 1,
                tail: 1,
                cm: .75,
                center: .5
            };
            function JIe(e, t) {
                var r = e.fullSceneLayout, n = e.dataScale, i = {};
                function a(c, f) {
                    var h = r[f], d = n[q8t[f]];
                    return R8t(c, function(v) {
                        return h.d2l(v) * d;
                    });
                }
                i.vectors = YIe(a(t.u, "xaxis"), a(t.v, "yaxis"), a(t.w, "zaxis"), t._len), i.positions = YIe(a(t.x, "xaxis"), a(t.y, "yaxis"), a(t.z, "zaxis"), t._len);
                var o = z8t(t);
                i.colormap = D8t(t), i.vertexIntensityBounds = [
                    o.min / t._normMax,
                    o.max / t._normMax
                ], i.coneOffset = O8t[t.anchor];
                var s = t.sizemode;
                s === "scaled" ? i.coneSize = t.sizeref || .5 : s === "absolute" ? i.coneSize = t.sizeref && t._normMax ? t.sizeref / t._normMax : .5 : s === "raw" && (i.coneSize = t.sizeref), i.coneSizemode = s;
                var l = P8t(i), u = t.lightposition;
                return l.lightPosition = [
                    u.x,
                    u.y,
                    u.z
                ], l.ambient = t.lighting.ambient, l.diffuse = t.lighting.diffuse, l.specular = t.lighting.specular, l.roughness = t.lighting.roughness, l.fresnel = t.lighting.fresnel, l.opacity = t.opacity, t._pad = B8t[t.anchor] * l.vectorScale * l.coneScale * t._normMax, l;
            }
            JZ.update = function(e) {
                this.data = e;
                var t = JIe(this.scene, e);
                this.mesh.update(t);
            };
            JZ.dispose = function() {
                this.scene.glplot.remove(this.mesh), this.mesh.dispose();
            };
            function N8t(e, t) {
                var r = e.glplot.gl, n = JIe(e, t), i = I8t(r, n), a = new KIe(e, t.uid);
                return a.mesh = i, a.data = t, i._trace = a, e.glplot.add(i), a;
            }
            $Ie.exports = N8t;
        });
        var t8e = ye((lpr, e8e)=>{
            "use strict";
            e8e.exports = {
                moduleType: "trace",
                name: "cone",
                basePlotModule: Q_(),
                categories: [
                    "gl3d",
                    "showLegend"
                ],
                attributes: KZ(),
                supplyDefaults: WIe(),
                colorbar: {
                    min: "cmin",
                    max: "cmax"
                },
                calc: XIe(),
                plot: QIe(),
                eventData: function(e, t) {
                    return e.norm = t.traceCoordinate[6], e;
                },
                meta: {}
            };
        });
        var i8e = ye((upr, r8e)=>{
            "use strict";
            r8e.exports = t8e();
        });
        var QZ = ye((cpr, a8e)=>{
            "use strict";
            var U8t = Jl(), j5 = Oc().axisHoverFormat, V8t = Wo().hovertemplateAttrs, H8t = U5(), n8e = vl(), $Z = no().extendFlat, sz = {
                x: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                y: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                z: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                u: {
                    valType: "data_array",
                    editType: "calc"
                },
                v: {
                    valType: "data_array",
                    editType: "calc"
                },
                w: {
                    valType: "data_array",
                    editType: "calc"
                },
                starts: {
                    x: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    y: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    z: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    editType: "calc"
                },
                maxdisplayed: {
                    valType: "integer",
                    min: 0,
                    dflt: 1e3,
                    editType: "calc"
                },
                sizeref: {
                    valType: "number",
                    editType: "calc",
                    min: 0,
                    dflt: 1
                },
                text: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                hovertext: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                hovertemplate: V8t({
                    editType: "calc"
                }, {
                    keys: [
                        "tubex",
                        "tubey",
                        "tubez",
                        "tubeu",
                        "tubev",
                        "tubew",
                        "norm",
                        "divergence"
                    ]
                }),
                uhoverformat: j5("u", 1),
                vhoverformat: j5("v", 1),
                whoverformat: j5("w", 1),
                xhoverformat: j5("x"),
                yhoverformat: j5("y"),
                zhoverformat: j5("z"),
                showlegend: $Z({}, n8e.showlegend, {
                    dflt: !1
                })
            };
            $Z(sz, U8t("", {
                colorAttr: "u/v/w norm",
                showScaleDflt: !0,
                editTypeOverride: "calc"
            }));
            var G8t = [
                "opacity",
                "lightposition",
                "lighting"
            ];
            G8t.forEach(function(e) {
                sz[e] = H8t[e];
            });
            sz.hoverinfo = $Z({}, n8e.hoverinfo, {
                editType: "calc",
                flags: [
                    "x",
                    "y",
                    "z",
                    "u",
                    "v",
                    "w",
                    "norm",
                    "divergence",
                    "text",
                    "name"
                ],
                dflt: "x+y+z+norm+text+name"
            });
            a8e.exports = sz;
        });
        var s8e = ye((fpr, o8e)=>{
            "use strict";
            var j8t = Mr(), W8t = Uh(), Z8t = QZ();
            o8e.exports = function(t, r, n, i) {
                function a(h, d) {
                    return j8t.coerce(t, r, Z8t, h, d);
                }
                var o = a("u"), s = a("v"), l = a("w"), u = a("x"), c = a("y"), f = a("z");
                if (!o || !o.length || !s || !s.length || !l || !l.length || !u || !u.length || !c || !c.length || !f || !f.length) {
                    r.visible = !1;
                    return;
                }
                a("starts.x"), a("starts.y"), a("starts.z"), a("maxdisplayed"), a("sizeref"), a("lighting.ambient"), a("lighting.diffuse"), a("lighting.specular"), a("lighting.roughness"), a("lighting.fresnel"), a("lightposition.x"), a("lightposition.y"), a("lightposition.z"), W8t(t, r, i, a, {
                    prefix: "",
                    cLetter: "c"
                }), a("text"), a("hovertext"), a("hovertemplate"), a("uhoverformat"), a("vhoverformat"), a("whoverformat"), a("xhoverformat"), a("yhoverformat"), a("zhoverformat"), r._length = null;
            };
        });
        var p8e = ye((hpr, v8e)=>{
            "use strict";
            var c8e = Rd().gl_streamtube3d, X8t = c8e.createTubeMesh, Y8t = Mr(), K8t = $y().parseColorScale, J8t = Mu().extractOpts, l8e = H5(), f8e = {
                xaxis: 0,
                yaxis: 1,
                zaxis: 2
            };
            function h8e(e, t) {
                this.scene = e, this.uid = t, this.mesh = null, this.data = null;
            }
            var tX = h8e.prototype;
            tX.handlePick = function(e) {
                var t = this.scene.fullSceneLayout, r = this.scene.dataScale;
                function n(o, s) {
                    var l = t[s], u = r[f8e[s]];
                    return l.l2c(o) / u;
                }
                if (e.object === this.mesh) {
                    var i = e.data.position, a = e.data.velocity;
                    return e.traceCoordinate = [
                        n(i[0], "xaxis"),
                        n(i[1], "yaxis"),
                        n(i[2], "zaxis"),
                        n(a[0], "xaxis"),
                        n(a[1], "yaxis"),
                        n(a[2], "zaxis"),
                        e.data.intensity * this.data._normMax,
                        e.data.divergence
                    ], e.textLabel = this.data.hovertext || this.data.text, !0;
                }
            };
            function u8e(e) {
                var t = e.length, r;
                return t > 2 ? r = e.slice(1, t - 1) : t === 2 ? r = [
                    (e[0] + e[1]) / 2
                ] : r = e, r;
            }
            function eX(e) {
                var t = e.length;
                return t === 1 ? [
                    .5,
                    .5
                ] : [
                    e[1] - e[0],
                    e[t - 1] - e[t - 2]
                ];
            }
            function d8e(e, t) {
                var r = e.fullSceneLayout, n = e.dataScale, i = t._len, a = {};
                function o(F, q) {
                    var V = r[q], H = n[f8e[q]];
                    return Y8t.simpleMap(F, function(X) {
                        return V.d2l(X) * H;
                    });
                }
                if (a.vectors = l8e(o(t._u, "xaxis"), o(t._v, "yaxis"), o(t._w, "zaxis"), i), !i) return {
                    positions: [],
                    cells: []
                };
                var s = o(t._Xs, "xaxis"), l = o(t._Ys, "yaxis"), u = o(t._Zs, "zaxis");
                a.meshgrid = [
                    s,
                    l,
                    u
                ], a.gridFill = t._gridFill;
                var c = t._slen;
                if (c) a.startingPositions = l8e(o(t._startsX, "xaxis"), o(t._startsY, "yaxis"), o(t._startsZ, "zaxis"));
                else {
                    for(var f = l[0], h = u8e(s), d = u8e(u), v = new Array(h.length * d.length), x = 0, b = 0; b < h.length; b++)for(var p = 0; p < d.length; p++)v[x++] = [
                        h[b],
                        f,
                        d[p]
                    ];
                    a.startingPositions = v;
                }
                a.colormap = K8t(t), a.tubeSize = t.sizeref, a.maxLength = t.maxdisplayed;
                var E = o(t._xbnds, "xaxis"), k = o(t._ybnds, "yaxis"), A = o(t._zbnds, "zaxis"), L = eX(s), _ = eX(l), C = eX(u), M = [
                    [
                        E[0] - L[0],
                        k[0] - _[0],
                        A[0] - C[0]
                    ],
                    [
                        E[1] + L[1],
                        k[1] + _[1],
                        A[1] + C[1]
                    ]
                ], g = c8e(a, M), P = J8t(t);
                g.vertexIntensityBounds = [
                    P.min / t._normMax,
                    P.max / t._normMax
                ];
                var T = t.lightposition;
                return g.lightPosition = [
                    T.x,
                    T.y,
                    T.z
                ], g.ambient = t.lighting.ambient, g.diffuse = t.lighting.diffuse, g.specular = t.lighting.specular, g.roughness = t.lighting.roughness, g.fresnel = t.lighting.fresnel, g.opacity = t.opacity, t._pad = g.tubeScale * t.sizeref * 2, g;
            }
            tX.update = function(e) {
                this.data = e;
                var t = d8e(this.scene, e);
                this.mesh.update(t);
            };
            tX.dispose = function() {
                this.scene.glplot.remove(this.mesh), this.mesh.dispose();
            };
            function $8t(e, t) {
                var r = e.glplot.gl, n = d8e(e, t), i = X8t(r, n), a = new h8e(e, t.uid);
                return a.mesh = i, a.data = t, i._trace = a, e.glplot.add(i), a;
            }
            v8e.exports = $8t;
        });
        var m8e = ye((dpr, g8e)=>{
            "use strict";
            g8e.exports = {
                moduleType: "trace",
                name: "streamtube",
                basePlotModule: Q_(),
                categories: [
                    "gl3d",
                    "showLegend"
                ],
                attributes: QZ(),
                supplyDefaults: s8e(),
                colorbar: {
                    min: "cmin",
                    max: "cmax"
                },
                calc: rz().calc,
                plot: p8e(),
                eventData: function(e, t) {
                    return e.tubex = e.x, e.tubey = e.y, e.tubez = e.z, e.tubeu = t.traceCoordinate[3], e.tubev = t.traceCoordinate[4], e.tubew = t.traceCoordinate[5], e.norm = t.traceCoordinate[6], e.divergence = t.traceCoordinate[7], delete e.x, delete e.y, delete e.z, e;
                },
                meta: {}
            };
        });
        var _8e = ye((vpr, y8e)=>{
            "use strict";
            y8e.exports = m8e();
        });
        var H2 = ye((ppr, w8e)=>{
            "use strict";
            var Q8t = Wo().hovertemplateAttrs, eRt = Wo().texttemplateAttrs, tRt = Eg(), jm = Uc(), rRt = vl(), x8e = Jl(), iRt = Ed().dash, V2 = no().extendFlat, nRt = Bu().overrideAll, eg = jm.marker, b8e = jm.line, aRt = eg.line;
            w8e.exports = nRt({
                lon: {
                    valType: "data_array"
                },
                lat: {
                    valType: "data_array"
                },
                locations: {
                    valType: "data_array"
                },
                locationmode: {
                    valType: "enumerated",
                    values: [
                        "ISO-3",
                        "USA-states",
                        "country names",
                        "geojson-id"
                    ],
                    dflt: "ISO-3"
                },
                geojson: {
                    valType: "any",
                    editType: "calc"
                },
                featureidkey: {
                    valType: "string",
                    editType: "calc",
                    dflt: "id"
                },
                mode: V2({}, jm.mode, {
                    dflt: "markers"
                }),
                text: V2({}, jm.text, {}),
                texttemplate: eRt({
                    editType: "plot"
                }, {
                    keys: [
                        "lat",
                        "lon",
                        "location",
                        "text"
                    ]
                }),
                hovertext: V2({}, jm.hovertext, {}),
                textfont: jm.textfont,
                textposition: jm.textposition,
                line: {
                    color: b8e.color,
                    width: b8e.width,
                    dash: iRt
                },
                connectgaps: jm.connectgaps,
                marker: V2({
                    symbol: eg.symbol,
                    opacity: eg.opacity,
                    angle: eg.angle,
                    angleref: V2({}, eg.angleref, {
                        values: [
                            "previous",
                            "up",
                            "north"
                        ]
                    }),
                    standoff: eg.standoff,
                    size: eg.size,
                    sizeref: eg.sizeref,
                    sizemin: eg.sizemin,
                    sizemode: eg.sizemode,
                    colorbar: eg.colorbar,
                    line: V2({
                        width: aRt.width
                    }, x8e("marker.line")),
                    gradient: eg.gradient
                }, x8e("marker")),
                fill: {
                    valType: "enumerated",
                    values: [
                        "none",
                        "toself"
                    ],
                    dflt: "none"
                },
                fillcolor: tRt(),
                selected: jm.selected,
                unselected: jm.unselected,
                hoverinfo: V2({}, rRt.hoverinfo, {
                    flags: [
                        "lon",
                        "lat",
                        "location",
                        "text",
                        "name"
                    ]
                }),
                hovertemplate: Q8t()
            }, "calc", "nested");
        });
        var A8e = ye((gpr, T8e)=>{
            "use strict";
            var rX = Mr(), iX = lu(), oRt = $p(), sRt = R0(), lRt = D0(), uRt = Ig(), cRt = H2();
            T8e.exports = function(t, r, n, i) {
                function a(d, v) {
                    return rX.coerce(t, r, cRt, d, v);
                }
                var o = a("locations"), s;
                if (o && o.length) {
                    var l = a("geojson"), u;
                    (typeof l == "string" && l !== "" || rX.isPlainObject(l)) && (u = "geojson-id");
                    var c = a("locationmode", u);
                    c === "geojson-id" && a("featureidkey"), s = o.length;
                } else {
                    var f = a("lon") || [], h = a("lat") || [];
                    s = Math.min(f.length, h.length);
                }
                if (!s) {
                    r.visible = !1;
                    return;
                }
                r._length = s, a("text"), a("hovertext"), a("hovertemplate"), a("mode"), iX.hasMarkers(r) && oRt(t, r, n, i, a, {
                    gradient: !0
                }), iX.hasLines(r) && (sRt(t, r, n, i, a), a("connectgaps")), iX.hasText(r) && (a("texttemplate"), lRt(t, r, i, a)), a("fill"), r.fill !== "none" && uRt(t, r, n, a), rX.coerceSelectionMarkerOpacity(r, a);
            };
        });
        var E8e = ye((mpr, M8e)=>{
            "use strict";
            var S8e = Qa();
            M8e.exports = function(t, r, n) {
                var i = {}, a = n[r.geo]._subplot, o = a.mockAxis, s = t.lonlat;
                return i.lonLabel = S8e.tickText(o, o.c2l(s[0]), !0).text, i.latLabel = S8e.tickText(o, o.c2l(s[1]), !0).text, i;
            };
        });
        var lz = ye((ypr, P8e)=>{
            "use strict";
            var nX = uo(), k8e = es().BADNUM, fRt = z0(), hRt = km(), dRt = F0(), vRt = Mr().isArrayOrTypedArray, C8e = Mr()._;
            function L8e(e) {
                return e && typeof e == "string";
            }
            P8e.exports = function(t, r) {
                var n = vRt(r.locations), i = n ? r.locations.length : r._length, a = new Array(i), o;
                r.geojson ? o = function(h) {
                    return L8e(h) || nX(h);
                } : o = L8e;
                for(var s = 0; s < i; s++){
                    var l = a[s] = {};
                    if (n) {
                        var u = r.locations[s];
                        l.loc = o(u) ? u : null;
                    } else {
                        var c = r.lon[s], f = r.lat[s];
                        nX(c) && nX(f) ? l.lonlat = [
                            +c,
                            +f
                        ] : l.lonlat = [
                            k8e,
                            k8e
                        ];
                    }
                }
                return hRt(a, r), fRt(t, r), dRt(a, r), i && (a[0].t = {
                    labels: {
                        lat: C8e(t, "lat:") + " ",
                        lon: C8e(t, "lon:") + " "
                    }
                }), a;
            };
        });
        var YE = ye((Tv)=>{
            "use strict";
            Tv.projNames = {
                airy: "airy",
                aitoff: "aitoff",
                "albers usa": "albersUsa",
                albers: "albers",
                august: "august",
                "azimuthal equal area": "azimuthalEqualArea",
                "azimuthal equidistant": "azimuthalEquidistant",
                baker: "baker",
                bertin1953: "bertin1953",
                boggs: "boggs",
                bonne: "bonne",
                bottomley: "bottomley",
                bromley: "bromley",
                collignon: "collignon",
                "conic conformal": "conicConformal",
                "conic equal area": "conicEqualArea",
                "conic equidistant": "conicEquidistant",
                craig: "craig",
                craster: "craster",
                "cylindrical equal area": "cylindricalEqualArea",
                "cylindrical stereographic": "cylindricalStereographic",
                eckert1: "eckert1",
                eckert2: "eckert2",
                eckert3: "eckert3",
                eckert4: "eckert4",
                eckert5: "eckert5",
                eckert6: "eckert6",
                eisenlohr: "eisenlohr",
                "equal earth": "equalEarth",
                equirectangular: "equirectangular",
                fahey: "fahey",
                "foucaut sinusoidal": "foucautSinusoidal",
                foucaut: "foucaut",
                ginzburg4: "ginzburg4",
                ginzburg5: "ginzburg5",
                ginzburg6: "ginzburg6",
                ginzburg8: "ginzburg8",
                ginzburg9: "ginzburg9",
                gnomonic: "gnomonic",
                "gringorten quincuncial": "gringortenQuincuncial",
                gringorten: "gringorten",
                guyou: "guyou",
                hammer: "hammer",
                hill: "hill",
                homolosine: "homolosine",
                hufnagel: "hufnagel",
                hyperelliptical: "hyperelliptical",
                kavrayskiy7: "kavrayskiy7",
                lagrange: "lagrange",
                larrivee: "larrivee",
                laskowski: "laskowski",
                loximuthal: "loximuthal",
                mercator: "mercator",
                miller: "miller",
                mollweide: "mollweide",
                "mt flat polar parabolic": "mtFlatPolarParabolic",
                "mt flat polar quartic": "mtFlatPolarQuartic",
                "mt flat polar sinusoidal": "mtFlatPolarSinusoidal",
                "natural earth": "naturalEarth",
                "natural earth1": "naturalEarth1",
                "natural earth2": "naturalEarth2",
                "nell hammer": "nellHammer",
                nicolosi: "nicolosi",
                orthographic: "orthographic",
                patterson: "patterson",
                "peirce quincuncial": "peirceQuincuncial",
                polyconic: "polyconic",
                "rectangular polyconic": "rectangularPolyconic",
                robinson: "robinson",
                satellite: "satellite",
                "sinu mollweide": "sinuMollweide",
                sinusoidal: "sinusoidal",
                stereographic: "stereographic",
                times: "times",
                "transverse mercator": "transverseMercator",
                "van der grinten": "vanDerGrinten",
                "van der grinten2": "vanDerGrinten2",
                "van der grinten3": "vanDerGrinten3",
                "van der grinten4": "vanDerGrinten4",
                wagner4: "wagner4",
                wagner6: "wagner6",
                wiechel: "wiechel",
                "winkel tripel": "winkel3",
                winkel3: "winkel3"
            };
            Tv.axesNames = [
                "lonaxis",
                "lataxis"
            ];
            Tv.lonaxisSpan = {
                orthographic: 180,
                "azimuthal equal area": 360,
                "azimuthal equidistant": 360,
                "conic conformal": 180,
                gnomonic: 160,
                stereographic: 180,
                "transverse mercator": 180,
                "*": 360
            };
            Tv.lataxisSpan = {
                "conic conformal": 150,
                stereographic: 179.5,
                "*": 180
            };
            Tv.scopeDefaults = {
                world: {
                    lonaxisRange: [
                        -180,
                        180
                    ],
                    lataxisRange: [
                        -90,
                        90
                    ],
                    projType: "equirectangular",
                    projRotate: [
                        0,
                        0,
                        0
                    ]
                },
                usa: {
                    lonaxisRange: [
                        -180,
                        -50
                    ],
                    lataxisRange: [
                        15,
                        80
                    ],
                    projType: "albers usa"
                },
                europe: {
                    lonaxisRange: [
                        -30,
                        60
                    ],
                    lataxisRange: [
                        30,
                        85
                    ],
                    projType: "conic conformal",
                    projRotate: [
                        15,
                        0,
                        0
                    ],
                    projParallels: [
                        0,
                        60
                    ]
                },
                asia: {
                    lonaxisRange: [
                        22,
                        160
                    ],
                    lataxisRange: [
                        -15,
                        55
                    ],
                    projType: "mercator",
                    projRotate: [
                        0,
                        0,
                        0
                    ]
                },
                africa: {
                    lonaxisRange: [
                        -30,
                        60
                    ],
                    lataxisRange: [
                        -40,
                        40
                    ],
                    projType: "mercator",
                    projRotate: [
                        0,
                        0,
                        0
                    ]
                },
                "north america": {
                    lonaxisRange: [
                        -180,
                        -45
                    ],
                    lataxisRange: [
                        5,
                        85
                    ],
                    projType: "conic conformal",
                    projRotate: [
                        -100,
                        0,
                        0
                    ],
                    projParallels: [
                        29.5,
                        45.5
                    ]
                },
                "south america": {
                    lonaxisRange: [
                        -100,
                        -30
                    ],
                    lataxisRange: [
                        -60,
                        15
                    ],
                    projType: "mercator",
                    projRotate: [
                        0,
                        0,
                        0
                    ]
                }
            };
            Tv.clipPad = .001;
            Tv.precision = .1;
            Tv.landColor = "#F0DC82";
            Tv.waterColor = "#3399FF";
            Tv.locationmodeToLayer = {
                "ISO-3": "countries",
                "USA-states": "subunits",
                "country names": "countries"
            };
            Tv.sphereSVG = {
                type: "Sphere"
            };
            Tv.fillLayers = {
                ocean: 1,
                land: 1,
                lakes: 1
            };
            Tv.lineLayers = {
                subunits: 1,
                countries: 1,
                coastlines: 1,
                rivers: 1,
                frame: 1
            };
            Tv.layers = [
                "bg",
                "ocean",
                "land",
                "lakes",
                "subunits",
                "countries",
                "coastlines",
                "rivers",
                "lataxis",
                "lonaxis",
                "frame",
                "backplot",
                "frontplot"
            ];
            Tv.layersForChoropleth = [
                "bg",
                "ocean",
                "land",
                "subunits",
                "countries",
                "coastlines",
                "lataxis",
                "lonaxis",
                "frame",
                "backplot",
                "rivers",
                "lakes",
                "frontplot"
            ];
            Tv.layerNameToAdjective = {
                ocean: "ocean",
                land: "land",
                lakes: "lake",
                subunits: "subunit",
                countries: "country",
                coastlines: "coastline",
                rivers: "river",
                frame: "frame"
            };
        });
        var aX = ye((uz, I8e)=>{
            (function(e, t) {
                typeof uz == "object" && typeof I8e != "undefined" ? t(uz) : (e = e || self, t(e.topojson = e.topojson || {}));
            })(uz, function(e) {
                "use strict";
                function t(k) {
                    return k;
                }
                function r(k) {
                    if (k == null) return t;
                    var A, L, _ = k.scale[0], C = k.scale[1], M = k.translate[0], g = k.translate[1];
                    return function(P, T) {
                        T || (A = L = 0);
                        var F = 2, q = P.length, V = new Array(q);
                        for(V[0] = (A += P[0]) * _ + M, V[1] = (L += P[1]) * C + g; F < q;)V[F] = P[F], ++F;
                        return V;
                    };
                }
                function n(k) {
                    var A = r(k.transform), L, _ = 1 / 0, C = _, M = -_, g = -_;
                    function P(F) {
                        F = A(F), F[0] < _ && (_ = F[0]), F[0] > M && (M = F[0]), F[1] < C && (C = F[1]), F[1] > g && (g = F[1]);
                    }
                    function T(F) {
                        switch(F.type){
                            case "GeometryCollection":
                                F.geometries.forEach(T);
                                break;
                            case "Point":
                                P(F.coordinates);
                                break;
                            case "MultiPoint":
                                F.coordinates.forEach(P);
                                break;
                        }
                    }
                    k.arcs.forEach(function(F) {
                        for(var q = -1, V = F.length, H; ++q < V;)H = A(F[q], q), H[0] < _ && (_ = H[0]), H[0] > M && (M = H[0]), H[1] < C && (C = H[1]), H[1] > g && (g = H[1]);
                    });
                    for(L in k.objects)T(k.objects[L]);
                    return [
                        _,
                        C,
                        M,
                        g
                    ];
                }
                function i(k, A) {
                    for(var L, _ = k.length, C = _ - A; C < --_;)L = k[C], k[C++] = k[_], k[_] = L;
                }
                function a(k, A) {
                    return typeof A == "string" && (A = k.objects[A]), A.type === "GeometryCollection" ? {
                        type: "FeatureCollection",
                        features: A.geometries.map(function(L) {
                            return o(k, L);
                        })
                    } : o(k, A);
                }
                function o(k, A) {
                    var L = A.id, _ = A.bbox, C = A.properties == null ? {} : A.properties, M = s(k, A);
                    return L == null && _ == null ? {
                        type: "Feature",
                        properties: C,
                        geometry: M
                    } : _ == null ? {
                        type: "Feature",
                        id: L,
                        properties: C,
                        geometry: M
                    } : {
                        type: "Feature",
                        id: L,
                        bbox: _,
                        properties: C,
                        geometry: M
                    };
                }
                function s(k, A) {
                    var L = r(k.transform), _ = k.arcs;
                    function C(q, V) {
                        V.length && V.pop();
                        for(var H = _[q < 0 ? ~q : q], X = 0, G = H.length; X < G; ++X)V.push(L(H[X], X));
                        q < 0 && i(V, G);
                    }
                    function M(q) {
                        return L(q);
                    }
                    function g(q) {
                        for(var V = [], H = 0, X = q.length; H < X; ++H)C(q[H], V);
                        return V.length < 2 && V.push(V[0]), V;
                    }
                    function P(q) {
                        for(var V = g(q); V.length < 4;)V.push(V[0]);
                        return V;
                    }
                    function T(q) {
                        return q.map(P);
                    }
                    function F(q) {
                        var V = q.type, H;
                        switch(V){
                            case "GeometryCollection":
                                return {
                                    type: V,
                                    geometries: q.geometries.map(F)
                                };
                            case "Point":
                                H = M(q.coordinates);
                                break;
                            case "MultiPoint":
                                H = q.coordinates.map(M);
                                break;
                            case "LineString":
                                H = g(q.arcs);
                                break;
                            case "MultiLineString":
                                H = q.arcs.map(g);
                                break;
                            case "Polygon":
                                H = T(q.arcs);
                                break;
                            case "MultiPolygon":
                                H = q.arcs.map(T);
                                break;
                            default:
                                return null;
                        }
                        return {
                            type: V,
                            coordinates: H
                        };
                    }
                    return F(A);
                }
                function l(k, A) {
                    var L = {}, _ = {}, C = {}, M = [], g = -1;
                    A.forEach(function(F, q) {
                        var V = k.arcs[F < 0 ? ~F : F], H;
                        V.length < 3 && !V[1][0] && !V[1][1] && (H = A[++g], A[g] = F, A[q] = H);
                    }), A.forEach(function(F) {
                        var q = P(F), V = q[0], H = q[1], X, G;
                        if (X = C[V]) {
                            if (delete C[X.end], X.push(F), X.end = H, G = _[H]) {
                                delete _[G.start];
                                var N = G === X ? X : X.concat(G);
                                _[N.start = X.start] = C[N.end = G.end] = N;
                            } else _[X.start] = C[X.end] = X;
                        } else if (X = _[H]) {
                            if (delete _[X.start], X.unshift(F), X.start = V, G = C[V]) {
                                delete C[G.end];
                                var W = G === X ? X : G.concat(X);
                                _[W.start = G.start] = C[W.end = X.end] = W;
                            } else _[X.start] = C[X.end] = X;
                        } else X = [
                            F
                        ], _[X.start = V] = C[X.end = H] = X;
                    });
                    function P(F) {
                        var q = k.arcs[F < 0 ? ~F : F], V = q[0], H;
                        return k.transform ? (H = [
                            0,
                            0
                        ], q.forEach(function(X) {
                            H[0] += X[0], H[1] += X[1];
                        })) : H = q[q.length - 1], F < 0 ? [
                            H,
                            V
                        ] : [
                            V,
                            H
                        ];
                    }
                    function T(F, q) {
                        for(var V in F){
                            var H = F[V];
                            delete q[H.start], delete H.start, delete H.end, H.forEach(function(X) {
                                L[X < 0 ? ~X : X] = 1;
                            }), M.push(H);
                        }
                    }
                    return T(C, _), T(_, C), A.forEach(function(F) {
                        L[F < 0 ? ~F : F] || M.push([
                            F
                        ]);
                    }), M;
                }
                function u(k) {
                    return s(k, c.apply(this, arguments));
                }
                function c(k, A, L) {
                    var _, C, M;
                    if (arguments.length > 1) _ = f(k, A, L);
                    else for(C = 0, _ = new Array(M = k.arcs.length); C < M; ++C)_[C] = C;
                    return {
                        type: "MultiLineString",
                        arcs: l(k, _)
                    };
                }
                function f(k, A, L) {
                    var _ = [], C = [], M;
                    function g(V) {
                        var H = V < 0 ? ~V : V;
                        (C[H] || (C[H] = [])).push({
                            i: V,
                            g: M
                        });
                    }
                    function P(V) {
                        V.forEach(g);
                    }
                    function T(V) {
                        V.forEach(P);
                    }
                    function F(V) {
                        V.forEach(T);
                    }
                    function q(V) {
                        switch(M = V, V.type){
                            case "GeometryCollection":
                                V.geometries.forEach(q);
                                break;
                            case "LineString":
                                P(V.arcs);
                                break;
                            case "MultiLineString":
                            case "Polygon":
                                T(V.arcs);
                                break;
                            case "MultiPolygon":
                                F(V.arcs);
                                break;
                        }
                    }
                    return q(A), C.forEach(L == null ? function(V) {
                        _.push(V[0].i);
                    } : function(V) {
                        L(V[0].g, V[V.length - 1].g) && _.push(V[0].i);
                    }), _;
                }
                function h(k) {
                    for(var A = -1, L = k.length, _, C = k[L - 1], M = 0; ++A < L;)_ = C, C = k[A], M += _[0] * C[1] - _[1] * C[0];
                    return Math.abs(M);
                }
                function d(k) {
                    return s(k, v.apply(this, arguments));
                }
                function v(k, A) {
                    var L = {}, _ = [], C = [];
                    A.forEach(M);
                    function M(T) {
                        switch(T.type){
                            case "GeometryCollection":
                                T.geometries.forEach(M);
                                break;
                            case "Polygon":
                                g(T.arcs);
                                break;
                            case "MultiPolygon":
                                T.arcs.forEach(g);
                                break;
                        }
                    }
                    function g(T) {
                        T.forEach(function(F) {
                            F.forEach(function(q) {
                                (L[q = q < 0 ? ~q : q] || (L[q] = [])).push(T);
                            });
                        }), _.push(T);
                    }
                    function P(T) {
                        return h(s(k, {
                            type: "Polygon",
                            arcs: [
                                T
                            ]
                        }).coordinates[0]);
                    }
                    return _.forEach(function(T) {
                        if (!T._) {
                            var F = [], q = [
                                T
                            ];
                            for(T._ = 1, C.push(F); T = q.pop();)F.push(T), T.forEach(function(V) {
                                V.forEach(function(H) {
                                    L[H < 0 ? ~H : H].forEach(function(X) {
                                        X._ || (X._ = 1, q.push(X));
                                    });
                                });
                            });
                        }
                    }), _.forEach(function(T) {
                        delete T._;
                    }), {
                        type: "MultiPolygon",
                        arcs: C.map(function(T) {
                            var F = [], q;
                            if (T.forEach(function(N) {
                                N.forEach(function(W) {
                                    W.forEach(function(re) {
                                        L[re < 0 ? ~re : re].length < 2 && F.push(re);
                                    });
                                });
                            }), F = l(k, F), (q = F.length) > 1) for(var V = 1, H = P(F[0]), X, G; V < q; ++V)(X = P(F[V])) > H && (G = F[0], F[0] = F[V], F[V] = G, H = X);
                            return F;
                        }).filter(function(T) {
                            return T.length > 0;
                        })
                    };
                }
                function x(k, A) {
                    for(var L = 0, _ = k.length; L < _;){
                        var C = L + _ >>> 1;
                        k[C] < A ? L = C + 1 : _ = C;
                    }
                    return L;
                }
                function b(k) {
                    var A = {}, L = k.map(function() {
                        return [];
                    });
                    function _(N, W) {
                        N.forEach(function(re) {
                            re < 0 && (re = ~re);
                            var ae = A[re];
                            ae ? ae.push(W) : A[re] = [
                                W
                            ];
                        });
                    }
                    function C(N, W) {
                        N.forEach(function(re) {
                            _(re, W);
                        });
                    }
                    function M(N, W) {
                        N.type === "GeometryCollection" ? N.geometries.forEach(function(re) {
                            M(re, W);
                        }) : N.type in g && g[N.type](N.arcs, W);
                    }
                    var g = {
                        LineString: _,
                        MultiLineString: C,
                        Polygon: C,
                        MultiPolygon: function(N, W) {
                            N.forEach(function(re) {
                                C(re, W);
                            });
                        }
                    };
                    k.forEach(M);
                    for(var P in A)for(var T = A[P], F = T.length, q = 0; q < F; ++q)for(var V = q + 1; V < F; ++V){
                        var H = T[q], X = T[V], G;
                        (G = L[H])[P = x(G, X)] !== X && G.splice(P, 0, X), (G = L[X])[P = x(G, H)] !== H && G.splice(P, 0, H);
                    }
                    return L;
                }
                function p(k) {
                    if (k == null) return t;
                    var A, L, _ = k.scale[0], C = k.scale[1], M = k.translate[0], g = k.translate[1];
                    return function(P, T) {
                        T || (A = L = 0);
                        var F = 2, q = P.length, V = new Array(q), H = Math.round((P[0] - M) / _), X = Math.round((P[1] - g) / C);
                        for(V[0] = H - A, A = H, V[1] = X - L, L = X; F < q;)V[F] = P[F], ++F;
                        return V;
                    };
                }
                function E(k, A) {
                    if (k.transform) throw new Error("already quantized");
                    if (!A || !A.scale) {
                        if (!((g = Math.floor(A)) >= 2)) throw new Error("n must be \u22652");
                        T = k.bbox || n(k);
                        var L = T[0], _ = T[1], C = T[2], M = T[3], g;
                        A = {
                            scale: [
                                C - L ? (C - L) / (g - 1) : 1,
                                M - _ ? (M - _) / (g - 1) : 1
                            ],
                            translate: [
                                L,
                                _
                            ]
                        };
                    } else T = k.bbox;
                    var P = p(A), T, F, q = k.objects, V = {};
                    function H(N) {
                        return P(N);
                    }
                    function X(N) {
                        var W;
                        switch(N.type){
                            case "GeometryCollection":
                                W = {
                                    type: "GeometryCollection",
                                    geometries: N.geometries.map(X)
                                };
                                break;
                            case "Point":
                                W = {
                                    type: "Point",
                                    coordinates: H(N.coordinates)
                                };
                                break;
                            case "MultiPoint":
                                W = {
                                    type: "MultiPoint",
                                    coordinates: N.coordinates.map(H)
                                };
                                break;
                            default:
                                return N;
                        }
                        return N.id != null && (W.id = N.id), N.bbox != null && (W.bbox = N.bbox), N.properties != null && (W.properties = N.properties), W;
                    }
                    function G(N) {
                        var W = 0, re = 1, ae = N.length, _e, Me = new Array(ae);
                        for(Me[0] = P(N[0], 0); ++W < ae;)((_e = P(N[W], W))[0] || _e[1]) && (Me[re++] = _e);
                        return re === 1 && (Me[re++] = [
                            0,
                            0
                        ]), Me.length = re, Me;
                    }
                    for(F in q)V[F] = X(q[F]);
                    return {
                        type: "Topology",
                        bbox: T,
                        transform: A,
                        objects: V,
                        arcs: k.arcs.map(G)
                    };
                }
                e.bbox = n, e.feature = a, e.merge = d, e.mergeArcs = v, e.mesh = u, e.meshArcs = c, e.neighbors = b, e.quantize = E, e.transform = r, e.untransform = p, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var cz = ye((xpr, R8e)=>{
            "use strict";
            var oX = R8e.exports = {}, pRt = YE().locationmodeToLayer, gRt = aX().feature;
            oX.getTopojsonName = function(e) {
                return [
                    e.scope.replace(/ /g, "-"),
                    "_",
                    e.resolution.toString(),
                    "m"
                ].join("");
            };
            oX.getTopojsonPath = function(e, t) {
                return e + t + ".json";
            };
            oX.getTopojsonFeatures = function(e, t) {
                var r = pRt[e.locationmode], n = t.objects[r];
                return gRt(t, n).features;
            };
        });
        var rx = ye((KE)=>{
            "use strict";
            var mRt = es().BADNUM;
            KE.calcTraceToLineCoords = function(e) {
                for(var t = e[0].trace, r = t.connectgaps, n = [], i = [], a = 0; a < e.length; a++){
                    var o = e[a], s = o.lonlat;
                    s[0] !== mRt ? i.push(s) : !r && i.length > 0 && (n.push(i), i = []);
                }
                return i.length > 0 && n.push(i), n;
            };
            KE.makeLine = function(e) {
                return e.length === 1 ? {
                    type: "LineString",
                    coordinates: e[0]
                } : {
                    type: "MultiLineString",
                    coordinates: e
                };
            };
            KE.makePolygon = function(e) {
                if (e.length === 1) return {
                    type: "Polygon",
                    coordinates: e
                };
                for(var t = new Array(e.length), r = 0; r < e.length; r++)t[r] = [
                    e[r]
                ];
                return {
                    type: "MultiPolygon",
                    coordinates: t
                };
            };
            KE.makeBlank = function() {
                return {
                    type: "Point",
                    coordinates: []
                };
            };
        });
        var z8e = ye((wpr, D8e)=>{
            D8e.exports = {
                AFG: "afghan",
                ALA: "\\b\\wland",
                ALB: "albania",
                DZA: "algeria",
                ASM: "^(?=.*americ).*samoa",
                AND: "andorra",
                AGO: "angola",
                AIA: "anguill?a",
                ATA: "antarctica",
                ATG: "antigua",
                ARG: "argentin",
                ARM: "armenia",
                ABW: "^(?!.*bonaire).*\\baruba",
                AUS: "australia",
                AUT: "^(?!.*hungary).*austria|\\baustri.*\\bemp",
                AZE: "azerbaijan",
                BHS: "bahamas",
                BHR: "bahrain",
                BGD: "bangladesh|^(?=.*east).*paki?stan",
                BRB: "barbados",
                BLR: "belarus|byelo",
                BEL: "^(?!.*luxem).*belgium",
                BLZ: "belize|^(?=.*british).*honduras",
                BEN: "benin|dahome",
                BMU: "bermuda",
                BTN: "bhutan",
                BOL: "bolivia",
                BES: "^(?=.*bonaire).*eustatius|^(?=.*carib).*netherlands|\\bbes.?islands",
                BIH: "herzegovina|bosnia",
                BWA: "botswana|bechuana",
                BVT: "bouvet",
                BRA: "brazil",
                IOT: "british.?indian.?ocean",
                BRN: "brunei",
                BGR: "bulgaria",
                BFA: "burkina|\\bfaso|upper.?volta",
                BDI: "burundi",
                CPV: "verde",
                KHM: "cambodia|kampuchea|khmer",
                CMR: "cameroon",
                CAN: "canada",
                CYM: "cayman",
                CAF: "\\bcentral.african.republic",
                TCD: "\\bchad",
                CHL: "\\bchile",
                CHN: "^(?!.*\\bmac)(?!.*\\bhong)(?!.*\\btai)(?!.*\\brep).*china|^(?=.*peo)(?=.*rep).*china",
                CXR: "christmas",
                CCK: "\\bcocos|keeling",
                COL: "colombia",
                COM: "comoro",
                COG: "^(?!.*\\bdem)(?!.*\\bd[\\.]?r)(?!.*kinshasa)(?!.*zaire)(?!.*belg)(?!.*l.opoldville)(?!.*free).*\\bcongo",
                COK: "\\bcook",
                CRI: "costa.?rica",
                CIV: "ivoire|ivory",
                HRV: "croatia",
                CUB: "\\bcuba",
                CUW: "^(?!.*bonaire).*\\bcura(c|\xE7)ao",
                CYP: "cyprus",
                CSK: "czechoslovakia",
                CZE: "^(?=.*rep).*czech|czechia|bohemia",
                COD: "\\bdem.*congo|congo.*\\bdem|congo.*\\bd[\\.]?r|\\bd[\\.]?r.*congo|belgian.?congo|congo.?free.?state|kinshasa|zaire|l.opoldville|drc|droc|rdc",
                DNK: "denmark",
                DJI: "djibouti",
                DMA: "dominica(?!n)",
                DOM: "dominican.rep",
                ECU: "ecuador",
                EGY: "egypt",
                SLV: "el.?salvador",
                GNQ: "guine.*eq|eq.*guine|^(?=.*span).*guinea",
                ERI: "eritrea",
                EST: "estonia",
                ETH: "ethiopia|abyssinia",
                FLK: "falkland|malvinas",
                FRO: "faroe|faeroe",
                FJI: "fiji",
                FIN: "finland",
                FRA: "^(?!.*\\bdep)(?!.*martinique).*france|french.?republic|\\bgaul",
                GUF: "^(?=.*french).*guiana",
                PYF: "french.?polynesia|tahiti",
                ATF: "french.?southern",
                GAB: "gabon",
                GMB: "gambia",
                GEO: "^(?!.*south).*georgia",
                DDR: "german.?democratic.?republic|democratic.?republic.*germany|east.germany",
                DEU: "^(?!.*east).*germany|^(?=.*\\bfed.*\\brep).*german",
                GHA: "ghana|gold.?coast",
                GIB: "gibraltar",
                GRC: "greece|hellenic|hellas",
                GRL: "greenland",
                GRD: "grenada",
                GLP: "guadeloupe",
                GUM: "\\bguam",
                GTM: "guatemala",
                GGY: "guernsey",
                GIN: "^(?!.*eq)(?!.*span)(?!.*bissau)(?!.*portu)(?!.*new).*guinea",
                GNB: "bissau|^(?=.*portu).*guinea",
                GUY: "guyana|british.?guiana",
                HTI: "haiti",
                HMD: "heard.*mcdonald",
                VAT: "holy.?see|vatican|papal.?st",
                HND: "^(?!.*brit).*honduras",
                HKG: "hong.?kong",
                HUN: "^(?!.*austr).*hungary",
                ISL: "iceland",
                IND: "india(?!.*ocea)",
                IDN: "indonesia",
                IRN: "\\biran|persia",
                IRQ: "\\biraq|mesopotamia",
                IRL: "(^ireland)|(^republic.*ireland)",
                IMN: "^(?=.*isle).*\\bman",
                ISR: "israel",
                ITA: "italy",
                JAM: "jamaica",
                JPN: "japan",
                JEY: "jersey",
                JOR: "jordan",
                KAZ: "kazak",
                KEN: "kenya|british.?east.?africa|east.?africa.?prot",
                KIR: "kiribati",
                PRK: "^(?=.*democrat|people|north|d.*p.*.r).*\\bkorea|dprk|korea.*(d.*p.*r)",
                KWT: "kuwait",
                KGZ: "kyrgyz|kirghiz",
                LAO: "\\blaos?\\b",
                LVA: "latvia",
                LBN: "lebanon",
                LSO: "lesotho|basuto",
                LBR: "liberia",
                LBY: "libya",
                LIE: "liechtenstein",
                LTU: "lithuania",
                LUX: "^(?!.*belg).*luxem",
                MAC: "maca(o|u)",
                MDG: "madagascar|malagasy",
                MWI: "malawi|nyasa",
                MYS: "malaysia",
                MDV: "maldive",
                MLI: "\\bmali\\b",
                MLT: "\\bmalta",
                MHL: "marshall",
                MTQ: "martinique",
                MRT: "mauritania",
                MUS: "mauritius",
                MYT: "\\bmayotte",
                MEX: "\\bmexic",
                FSM: "fed.*micronesia|micronesia.*fed",
                MCO: "monaco",
                MNG: "mongolia",
                MNE: "^(?!.*serbia).*montenegro",
                MSR: "montserrat",
                MAR: "morocco|\\bmaroc",
                MOZ: "mozambique",
                MMR: "myanmar|burma",
                NAM: "namibia",
                NRU: "nauru",
                NPL: "nepal",
                NLD: "^(?!.*\\bant)(?!.*\\bcarib).*netherlands",
                ANT: "^(?=.*\\bant).*(nether|dutch)",
                NCL: "new.?caledonia",
                NZL: "new.?zealand",
                NIC: "nicaragua",
                NER: "\\bniger(?!ia)",
                NGA: "nigeria",
                NIU: "niue",
                NFK: "norfolk",
                MNP: "mariana",
                NOR: "norway",
                OMN: "\\boman|trucial",
                PAK: "^(?!.*east).*paki?stan",
                PLW: "palau",
                PSE: "palestin|\\bgaza|west.?bank",
                PAN: "panama",
                PNG: "papua|new.?guinea",
                PRY: "paraguay",
                PER: "peru",
                PHL: "philippines",
                PCN: "pitcairn",
                POL: "poland",
                PRT: "portugal",
                PRI: "puerto.?rico",
                QAT: "qatar",
                KOR: "^(?!.*d.*p.*r)(?!.*democrat)(?!.*people)(?!.*north).*\\bkorea(?!.*d.*p.*r)",
                MDA: "moldov|b(a|e)ssarabia",
                REU: "r(e|\xE9)union",
                ROU: "r(o|u|ou)mania",
                RUS: "\\brussia|soviet.?union|u\\.?s\\.?s\\.?r|socialist.?republics",
                RWA: "rwanda",
                BLM: "barth(e|\xE9)lemy",
                SHN: "helena",
                KNA: "kitts|\\bnevis",
                LCA: "\\blucia",
                MAF: "^(?=.*collectivity).*martin|^(?=.*france).*martin(?!ique)|^(?=.*french).*martin(?!ique)",
                SPM: "miquelon",
                VCT: "vincent",
                WSM: "^(?!.*amer).*samoa",
                SMR: "san.?marino",
                STP: "\\bs(a|\xE3)o.?tom(e|\xE9)",
                SAU: "\\bsa\\w*.?arabia",
                SEN: "senegal",
                SRB: "^(?!.*monte).*serbia",
                SYC: "seychell",
                SLE: "sierra",
                SGP: "singapore",
                SXM: "^(?!.*martin)(?!.*saba).*maarten",
                SVK: "^(?!.*cze).*slovak",
                SVN: "slovenia",
                SLB: "solomon",
                SOM: "somali",
                ZAF: "south.africa|s\\\\..?africa",
                SGS: "south.?georgia|sandwich",
                SSD: "\\bs\\w*.?sudan",
                ESP: "spain",
                LKA: "sri.?lanka|ceylon",
                SDN: "^(?!.*\\bs(?!u)).*sudan",
                SUR: "surinam|dutch.?guiana",
                SJM: "svalbard",
                SWZ: "swaziland",
                SWE: "sweden",
                CHE: "switz|swiss",
                SYR: "syria",
                TWN: "taiwan|taipei|formosa|^(?!.*peo)(?=.*rep).*china",
                TJK: "tajik",
                THA: "thailand|\\bsiam",
                MKD: "macedonia|fyrom",
                TLS: "^(?=.*leste).*timor|^(?=.*east).*timor",
                TGO: "togo",
                TKL: "tokelau",
                TON: "tonga",
                TTO: "trinidad|tobago",
                TUN: "tunisia",
                TUR: "turkey",
                TKM: "turkmen",
                TCA: "turks",
                TUV: "tuvalu",
                UGA: "uganda",
                UKR: "ukrain",
                ARE: "emirates|^u\\.?a\\.?e\\.?$|united.?arab.?em",
                GBR: "united.?kingdom|britain|^u\\.?k\\.?$",
                TZA: "tanzania",
                USA: "united.?states\\b(?!.*islands)|\\bu\\.?s\\.?a\\.?\\b|^\\s*u\\.?s\\.?\\b(?!.*islands)",
                UMI: "minor.?outlying.?is",
                URY: "uruguay",
                UZB: "uzbek",
                VUT: "vanuatu|new.?hebrides",
                VEN: "venezuela",
                VNM: "^(?!.*republic).*viet.?nam|^(?=.*socialist).*viet.?nam",
                VGB: "^(?=.*\\bu\\.?\\s?k).*virgin|^(?=.*brit).*virgin|^(?=.*kingdom).*virgin",
                VIR: "^(?=.*\\bu\\.?\\s?s).*virgin|^(?=.*states).*virgin",
                WLF: "futuna|wallis",
                ESH: "western.sahara",
                YEM: "^(?!.*arab)(?!.*north)(?!.*sana)(?!.*peo)(?!.*dem)(?!.*south)(?!.*aden)(?!.*\\bp\\.?d\\.?r).*yemen",
                YMD: "^(?=.*peo).*yemen|^(?!.*rep)(?=.*dem).*yemen|^(?=.*south).*yemen|^(?=.*aden).*yemen|^(?=.*\\bp\\.?d\\.?r).*yemen",
                YUG: "yugoslavia",
                ZMB: "zambia|northern.?rhodesia",
                EAZ: "zanzibar",
                ZWE: "zimbabwe|^(?!.*northern).*rhodesia"
            };
        });
        var dz = ye((ku)=>{
            "use strict";
            Object.defineProperty(ku, "__esModule", {
                value: !0
            });
            var qp = 63710088e-1, lX = {
                centimeters: qp * 100,
                centimetres: qp * 100,
                degrees: 360 / (2 * Math.PI),
                feet: qp * 3.28084,
                inches: qp * 39.37,
                kilometers: qp / 1e3,
                kilometres: qp / 1e3,
                meters: qp,
                metres: qp,
                miles: qp / 1609.344,
                millimeters: qp * 1e3,
                millimetres: qp * 1e3,
                nauticalmiles: qp / 1852,
                radians: 1,
                yards: qp * 1.0936
            }, sX = {
                acres: 247105e-9,
                centimeters: 1e4,
                centimetres: 1e4,
                feet: 10.763910417,
                hectares: 1e-4,
                inches: 1550.003100006,
                kilometers: 1e-6,
                kilometres: 1e-6,
                meters: 1,
                metres: 1,
                miles: 386e-9,
                nauticalmiles: 29155334959812285e-23,
                millimeters: 1e6,
                millimetres: 1e6,
                yards: 1.195990046
            };
            function ix(e, t, r = {}) {
                let n = {
                    type: "Feature"
                };
                return (r.id === 0 || r.id) && (n.id = r.id), r.bbox && (n.bbox = r.bbox), n.properties = t || {}, n.geometry = e, n;
            }
            function yRt(e, t, r = {}) {
                switch(e){
                    case "Point":
                        return uX(t).geometry;
                    case "LineString":
                        return fX(t).geometry;
                    case "Polygon":
                        return cX(t).geometry;
                    case "MultiPoint":
                        return q8e(t).geometry;
                    case "MultiLineString":
                        return F8e(t).geometry;
                    case "MultiPolygon":
                        return O8e(t).geometry;
                    default:
                        throw new Error(e + " is invalid");
                }
            }
            function uX(e, t, r = {}) {
                if (!e) throw new Error("coordinates is required");
                if (!Array.isArray(e)) throw new Error("coordinates must be an Array");
                if (e.length < 2) throw new Error("coordinates must be at least 2 numbers long");
                if (!fz(e[0]) || !fz(e[1])) throw new Error("coordinates must contain numbers");
                return ix({
                    type: "Point",
                    coordinates: e
                }, t, r);
            }
            function _Rt(e, t, r = {}) {
                return hz(e.map((n)=>uX(n, t)), r);
            }
            function cX(e, t, r = {}) {
                for (let i of e){
                    if (i.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
                    if (i[i.length - 1].length !== i[0].length) throw new Error("First and last Position are not equivalent.");
                    for(let a = 0; a < i[i.length - 1].length; a++)if (i[i.length - 1][a] !== i[0][a]) throw new Error("First and last Position are not equivalent.");
                }
                return ix({
                    type: "Polygon",
                    coordinates: e
                }, t, r);
            }
            function xRt(e, t, r = {}) {
                return hz(e.map((n)=>cX(n, t)), r);
            }
            function fX(e, t, r = {}) {
                if (e.length < 2) throw new Error("coordinates must be an array of two or more positions");
                return ix({
                    type: "LineString",
                    coordinates: e
                }, t, r);
            }
            function bRt(e, t, r = {}) {
                return hz(e.map((n)=>fX(n, t)), r);
            }
            function hz(e, t = {}) {
                let r = {
                    type: "FeatureCollection"
                };
                return t.id && (r.id = t.id), t.bbox && (r.bbox = t.bbox), r.features = e, r;
            }
            function F8e(e, t, r = {}) {
                return ix({
                    type: "MultiLineString",
                    coordinates: e
                }, t, r);
            }
            function q8e(e, t, r = {}) {
                return ix({
                    type: "MultiPoint",
                    coordinates: e
                }, t, r);
            }
            function O8e(e, t, r = {}) {
                return ix({
                    type: "MultiPolygon",
                    coordinates: e
                }, t, r);
            }
            function wRt(e, t, r = {}) {
                return ix({
                    type: "GeometryCollection",
                    geometries: e
                }, t, r);
            }
            function TRt(e, t = 0) {
                if (t && !(t >= 0)) throw new Error("precision must be a positive number");
                let r = Math.pow(10, t || 0);
                return Math.round(e * r) / r;
            }
            function B8e(e, t = "kilometers") {
                let r = lX[t];
                if (!r) throw new Error(t + " units is invalid");
                return e * r;
            }
            function hX(e, t = "kilometers") {
                let r = lX[t];
                if (!r) throw new Error(t + " units is invalid");
                return e / r;
            }
            function ARt(e, t) {
                return N8e(hX(e, t));
            }
            function SRt(e) {
                let t = e % 360;
                return t < 0 && (t += 360), t;
            }
            function MRt(e) {
                return e = e % 360, e > 0 ? e > 180 ? e - 360 : e : e < -180 ? e + 360 : e;
            }
            function N8e(e) {
                return e % (2 * Math.PI) * 180 / Math.PI;
            }
            function ERt(e) {
                return e % 360 * Math.PI / 180;
            }
            function kRt(e, t = "kilometers", r = "kilometers") {
                if (!(e >= 0)) throw new Error("length must be a positive number");
                return B8e(hX(e, t), r);
            }
            function CRt(e, t = "meters", r = "kilometers") {
                if (!(e >= 0)) throw new Error("area must be a positive number");
                let n = sX[t];
                if (!n) throw new Error("invalid original units");
                let i = sX[r];
                if (!i) throw new Error("invalid final units");
                return e / n * i;
            }
            function fz(e) {
                return !isNaN(e) && e !== null && !Array.isArray(e);
            }
            function LRt(e) {
                return e !== null && typeof e == "object" && !Array.isArray(e);
            }
            function PRt(e) {
                if (!e) throw new Error("bbox is required");
                if (!Array.isArray(e)) throw new Error("bbox must be an Array");
                if (e.length !== 4 && e.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
                e.forEach((t)=>{
                    if (!fz(t)) throw new Error("bbox must only contain numbers");
                });
            }
            function IRt(e) {
                if (!e) throw new Error("id is required");
                if ([
                    "string",
                    "number"
                ].indexOf(typeof e) === -1) throw new Error("id must be a number or a string");
            }
            ku.areaFactors = sX;
            ku.azimuthToBearing = MRt;
            ku.bearingToAzimuth = SRt;
            ku.convertArea = CRt;
            ku.convertLength = kRt;
            ku.degreesToRadians = ERt;
            ku.earthRadius = qp;
            ku.factors = lX;
            ku.feature = ix;
            ku.featureCollection = hz;
            ku.geometry = yRt;
            ku.geometryCollection = wRt;
            ku.isNumber = fz;
            ku.isObject = LRt;
            ku.lengthToDegrees = ARt;
            ku.lengthToRadians = hX;
            ku.lineString = fX;
            ku.lineStrings = bRt;
            ku.multiLineString = F8e;
            ku.multiPoint = q8e;
            ku.multiPolygon = O8e;
            ku.point = uX;
            ku.points = _Rt;
            ku.polygon = cX;
            ku.polygons = xRt;
            ku.radiansToDegrees = N8e;
            ku.radiansToLength = B8e;
            ku.round = TRt;
            ku.validateBBox = PRt;
            ku.validateId = IRt;
        });
        var pz = ye((Dd)=>{
            "use strict";
            Object.defineProperty(Dd, "__esModule", {
                value: !0
            });
            var jv = dz();
            function JE(e, t, r) {
                if (e !== null) for(var n, i, a, o, s, l, u, c = 0, f = 0, h, d = e.type, v = d === "FeatureCollection", x = d === "Feature", b = v ? e.features.length : 1, p = 0; p < b; p++){
                    u = v ? e.features[p].geometry : x ? e.geometry : e, h = u ? u.type === "GeometryCollection" : !1, s = h ? u.geometries.length : 1;
                    for(var E = 0; E < s; E++){
                        var k = 0, A = 0;
                        if (o = h ? u.geometries[E] : u, o !== null) {
                            l = o.coordinates;
                            var L = o.type;
                            switch(c = r && (L === "Polygon" || L === "MultiPolygon") ? 1 : 0, L){
                                case null:
                                    break;
                                case "Point":
                                    if (t(l, f, p, k, A) === !1) return !1;
                                    f++, k++;
                                    break;
                                case "LineString":
                                case "MultiPoint":
                                    for(n = 0; n < l.length; n++){
                                        if (t(l[n], f, p, k, A) === !1) return !1;
                                        f++, L === "MultiPoint" && k++;
                                    }
                                    L === "LineString" && k++;
                                    break;
                                case "Polygon":
                                case "MultiLineString":
                                    for(n = 0; n < l.length; n++){
                                        for(i = 0; i < l[n].length - c; i++){
                                            if (t(l[n][i], f, p, k, A) === !1) return !1;
                                            f++;
                                        }
                                        L === "MultiLineString" && k++, L === "Polygon" && A++;
                                    }
                                    L === "Polygon" && k++;
                                    break;
                                case "MultiPolygon":
                                    for(n = 0; n < l.length; n++){
                                        for(A = 0, i = 0; i < l[n].length; i++){
                                            for(a = 0; a < l[n][i].length - c; a++){
                                                if (t(l[n][i][a], f, p, k, A) === !1) return !1;
                                                f++;
                                            }
                                            A++;
                                        }
                                        k++;
                                    }
                                    break;
                                case "GeometryCollection":
                                    for(n = 0; n < o.geometries.length; n++)if (JE(o.geometries[n], t, r) === !1) return !1;
                                    break;
                                default:
                                    throw new Error("Unknown Geometry Type");
                            }
                        }
                    }
                }
            }
            function RRt(e, t, r, n) {
                var i = r;
                return JE(e, function(a, o, s, l, u) {
                    o === 0 && r === void 0 ? i = a : i = t(i, a, o, s, l, u);
                }, n), i;
            }
            function U8e(e, t) {
                var r;
                switch(e.type){
                    case "FeatureCollection":
                        for(r = 0; r < e.features.length && t(e.features[r].properties, r) !== !1; r++);
                        break;
                    case "Feature":
                        t(e.properties, 0);
                        break;
                }
            }
            function DRt(e, t, r) {
                var n = r;
                return U8e(e, function(i, a) {
                    a === 0 && r === void 0 ? n = i : n = t(n, i, a);
                }), n;
            }
            function V8e(e, t) {
                if (e.type === "Feature") t(e, 0);
                else if (e.type === "FeatureCollection") for(var r = 0; r < e.features.length && t(e.features[r], r) !== !1; r++);
            }
            function zRt(e, t, r) {
                var n = r;
                return V8e(e, function(i, a) {
                    a === 0 && r === void 0 ? n = i : n = t(n, i, a);
                }), n;
            }
            function FRt(e) {
                var t = [];
                return JE(e, function(r) {
                    t.push(r);
                }), t;
            }
            function dX(e, t) {
                var r, n, i, a, o, s, l, u, c, f, h = 0, d = e.type === "FeatureCollection", v = e.type === "Feature", x = d ? e.features.length : 1;
                for(r = 0; r < x; r++){
                    for(s = d ? e.features[r].geometry : v ? e.geometry : e, u = d ? e.features[r].properties : v ? e.properties : {}, c = d ? e.features[r].bbox : v ? e.bbox : void 0, f = d ? e.features[r].id : v ? e.id : void 0, l = s ? s.type === "GeometryCollection" : !1, o = l ? s.geometries.length : 1, i = 0; i < o; i++){
                        if (a = l ? s.geometries[i] : s, a === null) {
                            if (t(null, h, u, c, f) === !1) return !1;
                            continue;
                        }
                        switch(a.type){
                            case "Point":
                            case "LineString":
                            case "MultiPoint":
                            case "Polygon":
                            case "MultiLineString":
                            case "MultiPolygon":
                                if (t(a, h, u, c, f) === !1) return !1;
                                break;
                            case "GeometryCollection":
                                for(n = 0; n < a.geometries.length; n++)if (t(a.geometries[n], h, u, c, f) === !1) return !1;
                                break;
                            default:
                                throw new Error("Unknown Geometry Type");
                        }
                    }
                    h++;
                }
            }
            function qRt(e, t, r) {
                var n = r;
                return dX(e, function(i, a, o, s, l) {
                    a === 0 && r === void 0 ? n = i : n = t(n, i, a, o, s, l);
                }), n;
            }
            function vz(e, t) {
                dX(e, function(r, n, i, a, o) {
                    var s = r === null ? null : r.type;
                    switch(s){
                        case null:
                        case "Point":
                        case "LineString":
                        case "Polygon":
                            return t(jv.feature.call(void 0, r, i, {
                                bbox: a,
                                id: o
                            }), n, 0) === !1 ? !1 : void 0;
                    }
                    var l;
                    switch(s){
                        case "MultiPoint":
                            l = "Point";
                            break;
                        case "MultiLineString":
                            l = "LineString";
                            break;
                        case "MultiPolygon":
                            l = "Polygon";
                            break;
                    }
                    for(var u = 0; u < r.coordinates.length; u++){
                        var c = r.coordinates[u], f = {
                            type: l,
                            coordinates: c
                        };
                        if (t(jv.feature.call(void 0, f, i), n, u) === !1) return !1;
                    }
                });
            }
            function ORt(e, t, r) {
                var n = r;
                return vz(e, function(i, a, o) {
                    a === 0 && o === 0 && r === void 0 ? n = i : n = t(n, i, a, o);
                }), n;
            }
            function H8e(e, t) {
                vz(e, function(r, n, i) {
                    var a = 0;
                    if (r.geometry) {
                        var o = r.geometry.type;
                        if (!(o === "Point" || o === "MultiPoint")) {
                            var s, l = 0, u = 0, c = 0;
                            if (JE(r, function(f, h, d, v, x) {
                                if (s === void 0 || n > l || v > u || x > c) {
                                    s = f, l = n, u = v, c = x, a = 0;
                                    return;
                                }
                                var b = jv.lineString.call(void 0, [
                                    s,
                                    f
                                ], r.properties);
                                if (t(b, n, i, x, a) === !1) return !1;
                                a++, s = f;
                            }) === !1) return !1;
                        }
                    }
                });
            }
            function BRt(e, t, r) {
                var n = r, i = !1;
                return H8e(e, function(a, o, s, l, u) {
                    i === !1 && r === void 0 ? n = a : n = t(n, a, o, s, l, u), i = !0;
                }), n;
            }
            function G8e(e, t) {
                if (!e) throw new Error("geojson is required");
                vz(e, function(r, n, i) {
                    if (r.geometry !== null) {
                        var a = r.geometry.type, o = r.geometry.coordinates;
                        switch(a){
                            case "LineString":
                                if (t(r, n, i, 0, 0) === !1) return !1;
                                break;
                            case "Polygon":
                                for(var s = 0; s < o.length; s++)if (t(jv.lineString.call(void 0, o[s], r.properties), n, i, s) === !1) return !1;
                                break;
                        }
                    }
                });
            }
            function NRt(e, t, r) {
                var n = r;
                return G8e(e, function(i, a, o, s) {
                    a === 0 && r === void 0 ? n = i : n = t(n, i, a, o, s);
                }), n;
            }
            function URt(e, t) {
                if (t = t || {}, !jv.isObject.call(void 0, t)) throw new Error("options is invalid");
                var r = t.featureIndex || 0, n = t.multiFeatureIndex || 0, i = t.geometryIndex || 0, a = t.segmentIndex || 0, o = t.properties, s;
                switch(e.type){
                    case "FeatureCollection":
                        r < 0 && (r = e.features.length + r), o = o || e.features[r].properties, s = e.features[r].geometry;
                        break;
                    case "Feature":
                        o = o || e.properties, s = e.geometry;
                        break;
                    case "Point":
                    case "MultiPoint":
                        return null;
                    case "LineString":
                    case "Polygon":
                    case "MultiLineString":
                    case "MultiPolygon":
                        s = e;
                        break;
                    default:
                        throw new Error("geojson is invalid");
                }
                if (s === null) return null;
                var l = s.coordinates;
                switch(s.type){
                    case "Point":
                    case "MultiPoint":
                        return null;
                    case "LineString":
                        return a < 0 && (a = l.length + a - 1), jv.lineString.call(void 0, [
                            l[a],
                            l[a + 1]
                        ], o, t);
                    case "Polygon":
                        return i < 0 && (i = l.length + i), a < 0 && (a = l[i].length + a - 1), jv.lineString.call(void 0, [
                            l[i][a],
                            l[i][a + 1]
                        ], o, t);
                    case "MultiLineString":
                        return n < 0 && (n = l.length + n), a < 0 && (a = l[n].length + a - 1), jv.lineString.call(void 0, [
                            l[n][a],
                            l[n][a + 1]
                        ], o, t);
                    case "MultiPolygon":
                        return n < 0 && (n = l.length + n), i < 0 && (i = l[n].length + i), a < 0 && (a = l[n][i].length - a - 1), jv.lineString.call(void 0, [
                            l[n][i][a],
                            l[n][i][a + 1]
                        ], o, t);
                }
                throw new Error("geojson is invalid");
            }
            function VRt(e, t) {
                if (t = t || {}, !jv.isObject.call(void 0, t)) throw new Error("options is invalid");
                var r = t.featureIndex || 0, n = t.multiFeatureIndex || 0, i = t.geometryIndex || 0, a = t.coordIndex || 0, o = t.properties, s;
                switch(e.type){
                    case "FeatureCollection":
                        r < 0 && (r = e.features.length + r), o = o || e.features[r].properties, s = e.features[r].geometry;
                        break;
                    case "Feature":
                        o = o || e.properties, s = e.geometry;
                        break;
                    case "Point":
                    case "MultiPoint":
                        return null;
                    case "LineString":
                    case "Polygon":
                    case "MultiLineString":
                    case "MultiPolygon":
                        s = e;
                        break;
                    default:
                        throw new Error("geojson is invalid");
                }
                if (s === null) return null;
                var l = s.coordinates;
                switch(s.type){
                    case "Point":
                        return jv.point.call(void 0, l, o, t);
                    case "MultiPoint":
                        return n < 0 && (n = l.length + n), jv.point.call(void 0, l[n], o, t);
                    case "LineString":
                        return a < 0 && (a = l.length + a), jv.point.call(void 0, l[a], o, t);
                    case "Polygon":
                        return i < 0 && (i = l.length + i), a < 0 && (a = l[i].length + a), jv.point.call(void 0, l[i][a], o, t);
                    case "MultiLineString":
                        return n < 0 && (n = l.length + n), a < 0 && (a = l[n].length + a), jv.point.call(void 0, l[n][a], o, t);
                    case "MultiPolygon":
                        return n < 0 && (n = l.length + n), i < 0 && (i = l[n].length + i), a < 0 && (a = l[n][i].length - a), jv.point.call(void 0, l[n][i][a], o, t);
                }
                throw new Error("geojson is invalid");
            }
            Dd.coordAll = FRt;
            Dd.coordEach = JE;
            Dd.coordReduce = RRt;
            Dd.featureEach = V8e;
            Dd.featureReduce = zRt;
            Dd.findPoint = VRt;
            Dd.findSegment = URt;
            Dd.flattenEach = vz;
            Dd.flattenReduce = ORt;
            Dd.geomEach = dX;
            Dd.geomReduce = qRt;
            Dd.lineEach = G8e;
            Dd.lineReduce = NRt;
            Dd.propEach = U8e;
            Dd.propReduce = DRt;
            Dd.segmentEach = H8e;
            Dd.segmentReduce = BRt;
        });
        var Y8e = ye((gz)=>{
            "use strict";
            Object.defineProperty(gz, "__esModule", {
                value: !0
            });
            var j8e = dz(), HRt = pz();
            function X8e(e) {
                return HRt.geomReduce.call(void 0, e, (t, r)=>t + GRt(r), 0);
            }
            function GRt(e) {
                let t = 0, r;
                switch(e.type){
                    case "Polygon":
                        return W8e(e.coordinates);
                    case "MultiPolygon":
                        for(r = 0; r < e.coordinates.length; r++)t += W8e(e.coordinates[r]);
                        return t;
                    case "Point":
                    case "MultiPoint":
                    case "LineString":
                    case "MultiLineString":
                        return 0;
                }
                return 0;
            }
            function W8e(e) {
                let t = 0;
                if (e && e.length > 0) {
                    t += Math.abs(Z8e(e[0]));
                    for(let r = 1; r < e.length; r++)t -= Math.abs(Z8e(e[r]));
                }
                return t;
            }
            var jRt = j8e.earthRadius * j8e.earthRadius / 2, vX = Math.PI / 180;
            function Z8e(e) {
                let t = e.length - 1;
                if (t <= 2) return 0;
                let r = 0, n = 0;
                for(; n < t;){
                    let i = e[n], a = e[n + 1 === t ? 0 : n + 1], o = e[n + 2 >= t ? (n + 2) % t : n + 2], s = i[0] * vX, l = a[1] * vX, u = o[0] * vX;
                    r += (u - s) * Math.sin(l), n++;
                }
                return r * jRt;
            }
            var WRt = X8e;
            gz.area = X8e;
            gz.default = WRt;
        });
        var J8e = ye((mz)=>{
            "use strict";
            Object.defineProperty(mz, "__esModule", {
                value: !0
            });
            var ZRt = dz(), XRt = pz();
            function K8e(e, t = {}) {
                let r = 0, n = 0, i = 0;
                return XRt.coordEach.call(void 0, e, function(a) {
                    r += a[0], n += a[1], i++;
                }, !0), ZRt.point.call(void 0, [
                    r / i,
                    n / i
                ], t.properties);
            }
            var YRt = K8e;
            mz.centroid = K8e;
            mz.default = YRt;
        });
        var Q8e = ye((yz)=>{
            "use strict";
            Object.defineProperty(yz, "__esModule", {
                value: !0
            });
            var KRt = pz();
            function $8e(e, t = {}) {
                if (e.bbox != null && t.recompute !== !0) return e.bbox;
                let r = [
                    1 / 0,
                    1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                return KRt.coordEach.call(void 0, e, (n)=>{
                    r[0] > n[0] && (r[0] = n[0]), r[1] > n[1] && (r[1] = n[1]), r[2] < n[0] && (r[2] = n[0]), r[3] < n[1] && (r[3] = n[1]);
                }), r;
            }
            var JRt = $8e;
            yz.bbox = $8e;
            yz.default = JRt;
        });
        var nx = ye((kpr, nRe)=>{
            "use strict";
            var $Rt = xa(), rRe = z8e(), { area: QRt } = Y8e(), { centroid: eDt } = J8e(), { bbox: tDt } = Q8e(), eRe = OS(), W5 = G1(), rDt = gy(), iDt = ES(), _z = wM(), tRe = Object.keys(rRe), nDt = {
                "ISO-3": eRe,
                "USA-states": eRe,
                "country names": aDt
            };
            function aDt(e) {
                for(var t = 0; t < tRe.length; t++){
                    var r = tRe[t], n = new RegExp(rRe[r]);
                    if (n.test(e.trim().toLowerCase())) return r;
                }
                return W5.log("Unrecognized country name: " + e + "."), !1;
            }
            function oDt(e, t, r) {
                if (!t || typeof t != "string") return !1;
                var n = nDt[e](t), i, a, o;
                if (n) {
                    if (e === "USA-states") for(i = [], o = 0; o < r.length; o++)a = r[o], a.properties && a.properties.gu && a.properties.gu === "USA" && i.push(a);
                    else i = r;
                    for(o = 0; o < i.length; o++)if (a = i[o], a.id === n) return a;
                    W5.log([
                        "Location with id",
                        n,
                        "does not have a matching topojson feature at this resolution."
                    ].join(" "));
                }
                return !1;
            }
            function sDt(e) {
                var t = e.geometry, r = t.coordinates, n = e.id, i = [], a, o, s, l;
                function u(c) {
                    for(var f = 0; f < c.length - 1; f++)if (c[f][0] > 0 && c[f + 1][0] < 0) return f;
                    return null;
                }
                switch(n === "RUS" || n === "FJI" ? a = function(c) {
                    var f;
                    if (u(c) === null) f = c;
                    else for(f = new Array(c.length), l = 0; l < c.length; l++)f[l] = [
                        c[l][0] < 0 ? c[l][0] + 360 : c[l][0],
                        c[l][1]
                    ];
                    i.push(_z.tester(f));
                } : n === "ATA" ? a = function(c) {
                    var f = u(c);
                    if (f === null) return i.push(_z.tester(c));
                    var h = new Array(c.length + 1), d = 0;
                    for(l = 0; l < c.length; l++)l > f ? h[d++] = [
                        c[l][0] + 360,
                        c[l][1]
                    ] : l === f ? (h[d++] = c[l], h[d++] = [
                        c[l][0],
                        -90
                    ]) : h[d++] = c[l];
                    var v = _z.tester(h);
                    v.pts.pop(), i.push(v);
                } : a = function(c) {
                    i.push(_z.tester(c));
                }, t.type){
                    case "MultiPolygon":
                        for(o = 0; o < r.length; o++)for(s = 0; s < r[o].length; s++)a(r[o][s]);
                        break;
                    case "Polygon":
                        for(o = 0; o < r.length; o++)a(r[o]);
                        break;
                }
                return i;
            }
            function iRe(e) {
                var t = e.geojson, r = window.PlotlyGeoAssets || {}, n = typeof t == "string" ? r[t] : t;
                return rDt(n) ? n : (W5.error("Oops ... something went wrong when fetching " + t), !1);
            }
            function lDt(e) {
                var t = e[0].trace, r = iRe(t);
                if (!r) return !1;
                var n = {}, i = [], a;
                for(a = 0; a < t._length; a++){
                    var o = e[a];
                    (o.loc || o.loc === 0) && (n[o.loc] = o);
                }
                function s(c) {
                    var f = iDt(c, t.featureidkey || "id").get(), h = n[f];
                    if (h) {
                        var d = c.geometry;
                        if (d.type === "Polygon" || d.type === "MultiPolygon") {
                            var v = {
                                type: "Feature",
                                id: f,
                                geometry: d,
                                properties: {}
                            };
                            v.geometry.coordinates.length > 0 ? v.properties.ct = uDt(v) : v.properties.ct = [
                                NaN,
                                NaN
                            ], h.fIn = c, h.fOut = v, i.push(v);
                        } else W5.log([
                            "Location",
                            h.loc,
                            "does not have a valid GeoJSON geometry.",
                            "Traces with locationmode *geojson-id* only support",
                            "*Polygon* and *MultiPolygon* geometries."
                        ].join(" "));
                    }
                    delete n[f];
                }
                switch(r.type){
                    case "FeatureCollection":
                        var l = r.features;
                        for(a = 0; a < l.length; a++)s(l[a]);
                        break;
                    case "Feature":
                        s(r);
                        break;
                    default:
                        return W5.warn([
                            "Invalid GeoJSON type",
                            (r.type || "none") + ".",
                            "Traces with locationmode *geojson-id* only support",
                            "*FeatureCollection* and *Feature* types."
                        ].join(" ")), !1;
                }
                for(var u in n)W5.log([
                    "Location *" + u + "*",
                    "does not have a matching feature with id-key",
                    "*" + t.featureidkey + "*."
                ].join(" "));
                return i;
            }
            function uDt(e) {
                var t = e.geometry, r;
                if (t.type === "MultiPolygon") for(var n = t.coordinates, i = 0, a = 0; a < n.length; a++){
                    var o = {
                        type: "Polygon",
                        coordinates: n[a]
                    }, s = QRt(o);
                    s > i && (i = s, r = o);
                }
                else r = t;
                return eDt(r).geometry.coordinates;
            }
            function cDt(e) {
                var t = window.PlotlyGeoAssets || {}, r = [];
                function n(l) {
                    return new Promise(function(u, c) {
                        $Rt.json(l, function(f, h) {
                            if (f) {
                                delete t[l];
                                var d = f.status === 404 ? 'GeoJSON at URL "' + l + '" does not exist.' : "Unexpected error while fetching from " + l;
                                return c(new Error(d));
                            }
                            return t[l] = h, u(h);
                        });
                    });
                }
                function i(l) {
                    return new Promise(function(u, c) {
                        var f = 0, h = setInterval(function() {
                            if (t[l] && t[l] !== "pending") return clearInterval(h), u(t[l]);
                            if (f > 100) return clearInterval(h), c("Unexpected error while fetching from " + l);
                            f++;
                        }, 50);
                    });
                }
                for(var a = 0; a < e.length; a++){
                    var o = e[a][0].trace, s = o.geojson;
                    typeof s == "string" && (t[s] ? t[s] === "pending" && r.push(i(s)) : (t[s] = "pending", r.push(n(s))));
                }
                return r;
            }
            function fDt(e) {
                return tDt(e);
            }
            nRe.exports = {
                locationToFeature: oDt,
                feature2polygons: sDt,
                getTraceGeojson: iRe,
                extractTraceFeature: lDt,
                fetchTraceGeoData: cDt,
                computeBbox: fDt
            };
        });
        var pX = ye((Cpr, sRe)=>{
            "use strict";
            var hDt = xa(), dDt = ao(), aRe = va(), oRe = op(), vDt = oRe.stylePoints, pDt = oRe.styleText;
            sRe.exports = function(t, r) {
                r && gDt(t, r);
            };
            function gDt(e, t) {
                var r = t[0].trace, n = t[0].node3;
                n.style("opacity", t[0].trace.opacity), vDt(n, r, e), pDt(n, r, e), n.selectAll("path.js-line").style("fill", "none").each(function(i) {
                    var a = hDt.select(this), o = i.trace, s = o.line || {};
                    a.call(aRe.stroke, s.color).call(dDt.dashLine, s.dash || "", s.width || 0), o.fill !== "none" && a.call(aRe.fill, o.fillcolor);
                });
            }
        });
        var _X = ye((Lpr, cRe)=>{
            "use strict";
            var lRe = xa(), bz = Mr(), mDt = cz().getTopojsonFeatures, gX = rx(), xz = nx(), uRe = wg().findExtremes, yX = es().BADNUM, yDt = q0().calcMarkerSize, mX = lu(), _Dt = pX();
            function xDt(e, t, r) {
                var n = t.layers.frontplot.select(".scatterlayer"), i = bz.makeTraceGroups(n, r, "trace scattergeo");
                function a(o, s) {
                    o.lonlat[0] === yX && lRe.select(s).remove();
                }
                i.selectAll("*").remove(), i.each(function(o) {
                    var s = lRe.select(this), l = o[0].trace;
                    if (mX.hasLines(l) || l.fill !== "none") {
                        var u = gX.calcTraceToLineCoords(o), c = l.fill !== "none" ? gX.makePolygon(u) : gX.makeLine(u);
                        s.selectAll("path.js-line").data([
                            {
                                geojson: c,
                                trace: l
                            }
                        ]).enter().append("path").classed("js-line", !0).style("stroke-miterlimit", 2);
                    }
                    mX.hasMarkers(l) && s.selectAll("path.point").data(bz.identity).enter().append("path").classed("point", !0).each(function(f) {
                        a(f, this);
                    }), mX.hasText(l) && s.selectAll("g").data(bz.identity).enter().append("g").append("text").each(function(f) {
                        a(f, this);
                    }), _Dt(e, o);
                });
            }
            function bDt(e, t) {
                var r = e[0].trace, n = t[r.geo], i = n._subplot, a = r._length, o, s;
                if (bz.isArrayOrTypedArray(r.locations)) {
                    var l = r.locationmode, u = l === "geojson-id" ? xz.extractTraceFeature(e) : mDt(r, i.topojson);
                    for(o = 0; o < a; o++){
                        s = e[o];
                        var c = l === "geojson-id" ? s.fOut : xz.locationToFeature(l, s.loc, u);
                        s.lonlat = c ? c.properties.ct : [
                            yX,
                            yX
                        ];
                    }
                }
                var f = {
                    padded: !0
                }, h, d;
                if (n.fitbounds === "geojson" && r.locationmode === "geojson-id") {
                    var v = xz.computeBbox(xz.getTraceGeojson(r));
                    h = [
                        v[0],
                        v[2]
                    ], d = [
                        v[1],
                        v[3]
                    ];
                } else {
                    for(h = new Array(a), d = new Array(a), o = 0; o < a; o++)s = e[o], h[o] = s.lonlat[0], d[o] = s.lonlat[1];
                    f.ppad = yDt(r, a);
                }
                r._extremes.lon = uRe(n.lonaxis._ax, h, f), r._extremes.lat = uRe(n.lataxis._ax, d, f);
            }
            cRe.exports = {
                calcGeoJSON: bDt,
                plot: xDt
            };
        });
        var hRe = ye((Ppr, fRe)=>{
            "use strict";
            var wDt = Nc(), TDt = es().BADNUM, ADt = oT(), SDt = Mr().fillText, MDt = H2();
            fRe.exports = function(t, r, n) {
                var i = t.cd, a = i[0].trace, o = t.xa, s = t.ya, l = t.subplot, u = l.projection.isLonLatOverEdges, c = l.project;
                function f(E) {
                    var k = E.lonlat;
                    if (k[0] === TDt || u(k)) return 1 / 0;
                    var A = c(k), L = c([
                        r,
                        n
                    ]), _ = Math.abs(A[0] - L[0]), C = Math.abs(A[1] - L[1]), M = Math.max(3, E.mrc || 0);
                    return Math.max(Math.sqrt(_ * _ + C * C) - M, 1 - 3 / M);
                }
                if (wDt.getClosest(i, f, t), t.index !== !1) {
                    var h = i[t.index], d = h.lonlat, v = [
                        o.c2p(d),
                        s.c2p(d)
                    ], x = h.mrc || 1;
                    t.x0 = v[0] - x, t.x1 = v[0] + x, t.y0 = v[1] - x, t.y1 = v[1] + x, t.loc = h.loc, t.lon = d[0], t.lat = d[1];
                    var b = {};
                    b[a.geo] = {
                        _subplot: l
                    };
                    var p = a._module.formatLabels(h, a, b);
                    return t.lonLabel = p.lonLabel, t.latLabel = p.latLabel, t.color = ADt(a, h), t.extraText = EDt(a, h, t, i[0].t.labels), t.hovertemplate = a.hovertemplate, [
                        t
                    ];
                }
            };
            function EDt(e, t, r, n) {
                if (e.hovertemplate) return;
                var i = t.hi || e.hoverinfo, a = i === "all" ? MDt.hoverinfo.flags : i.split("+"), o = a.indexOf("location") !== -1 && Array.isArray(e.locations), s = a.indexOf("lon") !== -1, l = a.indexOf("lat") !== -1, u = a.indexOf("text") !== -1, c = [];
                function f(h) {
                    return h + "\xB0";
                }
                return o ? c.push(t.loc) : s && l ? c.push("(" + f(r.latLabel) + ", " + f(r.lonLabel) + ")") : s ? c.push(n.lon + f(r.lonLabel)) : l && c.push(n.lat + f(r.latLabel)), u && SDt(t, e, c), c.join("<br>");
            }
        });
        var vRe = ye((Ipr, dRe)=>{
            "use strict";
            dRe.exports = function(t, r, n, i, a) {
                t.lon = r.lon, t.lat = r.lat, t.location = r.loc ? r.loc : null;
                var o = i[a];
                return o.fIn && o.fIn.properties && (t.properties = o.fIn.properties), t;
            };
        });
        var mRe = ye((Rpr, gRe)=>{
            "use strict";
            var pRe = lu(), kDt = es().BADNUM;
            gRe.exports = function(t, r) {
                var n = t.cd, i = t.xaxis, a = t.yaxis, o = [], s = n[0].trace, l, u, c, f, h, d = !pRe.hasMarkers(s) && !pRe.hasText(s);
                if (d) return [];
                if (r === !1) for(h = 0; h < n.length; h++)n[h].selected = 0;
                else for(h = 0; h < n.length; h++)l = n[h], u = l.lonlat, u[0] !== kDt && (c = i.c2p(u), f = a.c2p(u), r.contains([
                    c,
                    f
                ], null, h, t) ? (o.push({
                    pointNumber: h,
                    lon: u[0],
                    lat: u[1]
                }), l.selected = 1) : l.selected = 0);
                return o;
            };
        });
        var $E = ye((wz, yRe)=>{
            (function(e, t) {
                t(typeof wz == "object" && typeof yRe != "undefined" ? wz : e.d3 = e.d3 || {});
            })(wz, function(e) {
                "use strict";
                function t(Ee, Ae) {
                    return Ee < Ae ? -1 : Ee > Ae ? 1 : Ee >= Ae ? 0 : NaN;
                }
                function r(Ee) {
                    return Ee.length === 1 && (Ee = n(Ee)), {
                        left: function(Ae, ze, Ce, me) {
                            for(Ce == null && (Ce = 0), me == null && (me = Ae.length); Ce < me;){
                                var Re = Ce + me >>> 1;
                                Ee(Ae[Re], ze) < 0 ? Ce = Re + 1 : me = Re;
                            }
                            return Ce;
                        },
                        right: function(Ae, ze, Ce, me) {
                            for(Ce == null && (Ce = 0), me == null && (me = Ae.length); Ce < me;){
                                var Re = Ce + me >>> 1;
                                Ee(Ae[Re], ze) > 0 ? me = Re : Ce = Re + 1;
                            }
                            return Ce;
                        }
                    };
                }
                function n(Ee) {
                    return function(Ae, ze) {
                        return t(Ee(Ae), ze);
                    };
                }
                var i = r(t), a = i.right, o = i.left;
                function s(Ee, Ae) {
                    Ae == null && (Ae = l);
                    for(var ze = 0, Ce = Ee.length - 1, me = Ee[0], Re = new Array(Ce < 0 ? 0 : Ce); ze < Ce;)Re[ze] = Ae(me, me = Ee[++ze]);
                    return Re;
                }
                function l(Ee, Ae) {
                    return [
                        Ee,
                        Ae
                    ];
                }
                function u(Ee, Ae, ze) {
                    var Ce = Ee.length, me = Ae.length, Re = new Array(Ce * me), ce, Ge, nt, ct;
                    for(ze == null && (ze = l), ce = nt = 0; ce < Ce; ++ce)for(ct = Ee[ce], Ge = 0; Ge < me; ++Ge, ++nt)Re[nt] = ze(ct, Ae[Ge]);
                    return Re;
                }
                function c(Ee, Ae) {
                    return Ae < Ee ? -1 : Ae > Ee ? 1 : Ae >= Ee ? 0 : NaN;
                }
                function f(Ee) {
                    return Ee === null ? NaN : +Ee;
                }
                function h(Ee, Ae) {
                    var ze = Ee.length, Ce = 0, me = -1, Re = 0, ce, Ge, nt = 0;
                    if (Ae == null) for(; ++me < ze;)isNaN(ce = f(Ee[me])) || (Ge = ce - Re, Re += Ge / ++Ce, nt += Ge * (ce - Re));
                    else for(; ++me < ze;)isNaN(ce = f(Ae(Ee[me], me, Ee))) || (Ge = ce - Re, Re += Ge / ++Ce, nt += Ge * (ce - Re));
                    if (Ce > 1) return nt / (Ce - 1);
                }
                function d(Ee, Ae) {
                    var ze = h(Ee, Ae);
                    return ze && Math.sqrt(ze);
                }
                function v(Ee, Ae) {
                    var ze = Ee.length, Ce = -1, me, Re, ce;
                    if (Ae == null) {
                        for(; ++Ce < ze;)if ((me = Ee[Ce]) != null && me >= me) for(Re = ce = me; ++Ce < ze;)(me = Ee[Ce]) != null && (Re > me && (Re = me), ce < me && (ce = me));
                    } else for(; ++Ce < ze;)if ((me = Ae(Ee[Ce], Ce, Ee)) != null && me >= me) for(Re = ce = me; ++Ce < ze;)(me = Ae(Ee[Ce], Ce, Ee)) != null && (Re > me && (Re = me), ce < me && (ce = me));
                    return [
                        Re,
                        ce
                    ];
                }
                var x = Array.prototype, b = x.slice, p = x.map;
                function E(Ee) {
                    return function() {
                        return Ee;
                    };
                }
                function k(Ee) {
                    return Ee;
                }
                function A(Ee, Ae, ze) {
                    Ee = +Ee, Ae = +Ae, ze = (me = arguments.length) < 2 ? (Ae = Ee, Ee = 0, 1) : me < 3 ? 1 : +ze;
                    for(var Ce = -1, me = Math.max(0, Math.ceil((Ae - Ee) / ze)) | 0, Re = new Array(me); ++Ce < me;)Re[Ce] = Ee + Ce * ze;
                    return Re;
                }
                var L = Math.sqrt(50), _ = Math.sqrt(10), C = Math.sqrt(2);
                function M(Ee, Ae, ze) {
                    var Ce, me = -1, Re, ce, Ge;
                    if (Ae = +Ae, Ee = +Ee, ze = +ze, Ee === Ae && ze > 0) return [
                        Ee
                    ];
                    if ((Ce = Ae < Ee) && (Re = Ee, Ee = Ae, Ae = Re), (Ge = g(Ee, Ae, ze)) === 0 || !isFinite(Ge)) return [];
                    if (Ge > 0) for(Ee = Math.ceil(Ee / Ge), Ae = Math.floor(Ae / Ge), ce = new Array(Re = Math.ceil(Ae - Ee + 1)); ++me < Re;)ce[me] = (Ee + me) * Ge;
                    else for(Ee = Math.floor(Ee * Ge), Ae = Math.ceil(Ae * Ge), ce = new Array(Re = Math.ceil(Ee - Ae + 1)); ++me < Re;)ce[me] = (Ee - me) / Ge;
                    return Ce && ce.reverse(), ce;
                }
                function g(Ee, Ae, ze) {
                    var Ce = (Ae - Ee) / Math.max(0, ze), me = Math.floor(Math.log(Ce) / Math.LN10), Re = Ce / Math.pow(10, me);
                    return me >= 0 ? (Re >= L ? 10 : Re >= _ ? 5 : Re >= C ? 2 : 1) * Math.pow(10, me) : -Math.pow(10, -me) / (Re >= L ? 10 : Re >= _ ? 5 : Re >= C ? 2 : 1);
                }
                function P(Ee, Ae, ze) {
                    var Ce = Math.abs(Ae - Ee) / Math.max(0, ze), me = Math.pow(10, Math.floor(Math.log(Ce) / Math.LN10)), Re = Ce / me;
                    return Re >= L ? me *= 10 : Re >= _ ? me *= 5 : Re >= C && (me *= 2), Ae < Ee ? -me : me;
                }
                function T(Ee) {
                    return Math.ceil(Math.log(Ee.length) / Math.LN2) + 1;
                }
                function F() {
                    var Ee = k, Ae = v, ze = T;
                    function Ce(me) {
                        var Re, ce = me.length, Ge, nt = new Array(ce);
                        for(Re = 0; Re < ce; ++Re)nt[Re] = Ee(me[Re], Re, me);
                        var ct = Ae(nt), qt = ct[0], rt = ct[1], ot = ze(nt, qt, rt);
                        Array.isArray(ot) || (ot = P(qt, rt, ot), ot = A(Math.ceil(qt / ot) * ot, rt, ot));
                        for(var Rt = ot.length; ot[0] <= qt;)ot.shift(), --Rt;
                        for(; ot[Rt - 1] > rt;)ot.pop(), --Rt;
                        var kt = new Array(Rt + 1), Ct;
                        for(Re = 0; Re <= Rt; ++Re)Ct = kt[Re] = [], Ct.x0 = Re > 0 ? ot[Re - 1] : qt, Ct.x1 = Re < Rt ? ot[Re] : rt;
                        for(Re = 0; Re < ce; ++Re)Ge = nt[Re], qt <= Ge && Ge <= rt && kt[a(ot, Ge, 0, Rt)].push(me[Re]);
                        return kt;
                    }
                    return Ce.value = function(me) {
                        return arguments.length ? (Ee = typeof me == "function" ? me : E(me), Ce) : Ee;
                    }, Ce.domain = function(me) {
                        return arguments.length ? (Ae = typeof me == "function" ? me : E([
                            me[0],
                            me[1]
                        ]), Ce) : Ae;
                    }, Ce.thresholds = function(me) {
                        return arguments.length ? (ze = typeof me == "function" ? me : Array.isArray(me) ? E(b.call(me)) : E(me), Ce) : ze;
                    }, Ce;
                }
                function q(Ee, Ae, ze) {
                    if (ze == null && (ze = f), !!(Ce = Ee.length)) {
                        if ((Ae = +Ae) <= 0 || Ce < 2) return +ze(Ee[0], 0, Ee);
                        if (Ae >= 1) return +ze(Ee[Ce - 1], Ce - 1, Ee);
                        var Ce, me = (Ce - 1) * Ae, Re = Math.floor(me), ce = +ze(Ee[Re], Re, Ee), Ge = +ze(Ee[Re + 1], Re + 1, Ee);
                        return ce + (Ge - ce) * (me - Re);
                    }
                }
                function V(Ee, Ae, ze) {
                    return Ee = p.call(Ee, f).sort(t), Math.ceil((ze - Ae) / (2 * (q(Ee, .75) - q(Ee, .25)) * Math.pow(Ee.length, -1 / 3)));
                }
                function H(Ee, Ae, ze) {
                    return Math.ceil((ze - Ae) / (3.5 * d(Ee) * Math.pow(Ee.length, -1 / 3)));
                }
                function X(Ee, Ae) {
                    var ze = Ee.length, Ce = -1, me, Re;
                    if (Ae == null) {
                        for(; ++Ce < ze;)if ((me = Ee[Ce]) != null && me >= me) for(Re = me; ++Ce < ze;)(me = Ee[Ce]) != null && me > Re && (Re = me);
                    } else for(; ++Ce < ze;)if ((me = Ae(Ee[Ce], Ce, Ee)) != null && me >= me) for(Re = me; ++Ce < ze;)(me = Ae(Ee[Ce], Ce, Ee)) != null && me > Re && (Re = me);
                    return Re;
                }
                function G(Ee, Ae) {
                    var ze = Ee.length, Ce = ze, me = -1, Re, ce = 0;
                    if (Ae == null) for(; ++me < ze;)isNaN(Re = f(Ee[me])) ? --Ce : ce += Re;
                    else for(; ++me < ze;)isNaN(Re = f(Ae(Ee[me], me, Ee))) ? --Ce : ce += Re;
                    if (Ce) return ce / Ce;
                }
                function N(Ee, Ae) {
                    var ze = Ee.length, Ce = -1, me, Re = [];
                    if (Ae == null) for(; ++Ce < ze;)isNaN(me = f(Ee[Ce])) || Re.push(me);
                    else for(; ++Ce < ze;)isNaN(me = f(Ae(Ee[Ce], Ce, Ee))) || Re.push(me);
                    return q(Re.sort(t), .5);
                }
                function W(Ee) {
                    for(var Ae = Ee.length, ze, Ce = -1, me = 0, Re, ce; ++Ce < Ae;)me += Ee[Ce].length;
                    for(Re = new Array(me); --Ae >= 0;)for(ce = Ee[Ae], ze = ce.length; --ze >= 0;)Re[--me] = ce[ze];
                    return Re;
                }
                function re(Ee, Ae) {
                    var ze = Ee.length, Ce = -1, me, Re;
                    if (Ae == null) {
                        for(; ++Ce < ze;)if ((me = Ee[Ce]) != null && me >= me) for(Re = me; ++Ce < ze;)(me = Ee[Ce]) != null && Re > me && (Re = me);
                    } else for(; ++Ce < ze;)if ((me = Ae(Ee[Ce], Ce, Ee)) != null && me >= me) for(Re = me; ++Ce < ze;)(me = Ae(Ee[Ce], Ce, Ee)) != null && Re > me && (Re = me);
                    return Re;
                }
                function ae(Ee, Ae) {
                    for(var ze = Ae.length, Ce = new Array(ze); ze--;)Ce[ze] = Ee[Ae[ze]];
                    return Ce;
                }
                function _e(Ee, Ae) {
                    if (ze = Ee.length) {
                        var ze, Ce = 0, me = 0, Re, ce = Ee[me];
                        for(Ae == null && (Ae = t); ++Ce < ze;)(Ae(Re = Ee[Ce], ce) < 0 || Ae(ce, ce) !== 0) && (ce = Re, me = Ce);
                        if (Ae(ce, ce) === 0) return me;
                    }
                }
                function Me(Ee, Ae, ze) {
                    for(var Ce = (ze == null ? Ee.length : ze) - (Ae = Ae == null ? 0 : +Ae), me, Re; Ce;)Re = Math.random() * Ce-- | 0, me = Ee[Ce + Ae], Ee[Ce + Ae] = Ee[Re + Ae], Ee[Re + Ae] = me;
                    return Ee;
                }
                function ke(Ee, Ae) {
                    var ze = Ee.length, Ce = -1, me, Re = 0;
                    if (Ae == null) for(; ++Ce < ze;)(me = +Ee[Ce]) && (Re += me);
                    else for(; ++Ce < ze;)(me = +Ae(Ee[Ce], Ce, Ee)) && (Re += me);
                    return Re;
                }
                function ge(Ee) {
                    if (!(Re = Ee.length)) return [];
                    for(var Ae = -1, ze = re(Ee, ie), Ce = new Array(ze); ++Ae < ze;)for(var me = -1, Re, ce = Ce[Ae] = new Array(Re); ++me < Re;)ce[me] = Ee[me][Ae];
                    return Ce;
                }
                function ie(Ee) {
                    return Ee.length;
                }
                function Te() {
                    return ge(arguments);
                }
                e.bisect = a, e.bisectRight = a, e.bisectLeft = o, e.ascending = t, e.bisector = r, e.cross = u, e.descending = c, e.deviation = d, e.extent = v, e.histogram = F, e.thresholdFreedmanDiaconis = V, e.thresholdScott = H, e.thresholdSturges = T, e.max = X, e.mean = G, e.median = N, e.merge = W, e.min = re, e.pairs = s, e.permute = ae, e.quantile = q, e.range = A, e.scan = _e, e.shuffle = Me, e.sum = ke, e.ticks = M, e.tickIncrement = g, e.tickStep = P, e.transpose = ge, e.variance = h, e.zip = Te, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var xX = ye((Tz, _Re)=>{
            (function(e, t) {
                typeof Tz == "object" && typeof _Re != "undefined" ? t(Tz, $E()) : (e = e || self, t(e.d3 = e.d3 || {}, e.d3));
            })(Tz, function(e, t) {
                "use strict";
                function r() {
                    return new n;
                }
                function n() {
                    this.reset();
                }
                n.prototype = {
                    constructor: n,
                    reset: function() {
                        this.s = this.t = 0;
                    },
                    add: function(gt) {
                        a(i, gt, this.t), a(this, i.s, this.s), this.s ? this.t += i.t : this.s = i.t;
                    },
                    valueOf: function() {
                        return this.s;
                    }
                };
                var i = new n;
                function a(gt, Bt, wr) {
                    var vr = gt.s = Bt + wr, Ur = vr - Bt, fi = vr - Ur;
                    gt.t = Bt - fi + (wr - Ur);
                }
                var o = 1e-6, s = 1e-12, l = Math.PI, u = l / 2, c = l / 4, f = l * 2, h = 180 / l, d = l / 180, v = Math.abs, x = Math.atan, b = Math.atan2, p = Math.cos, E = Math.ceil, k = Math.exp, A = Math.log, L = Math.pow, _ = Math.sin, C = Math.sign || function(gt) {
                    return gt > 0 ? 1 : gt < 0 ? -1 : 0;
                }, M = Math.sqrt, g = Math.tan;
                function P(gt) {
                    return gt > 1 ? 0 : gt < -1 ? l : Math.acos(gt);
                }
                function T(gt) {
                    return gt > 1 ? u : gt < -1 ? -u : Math.asin(gt);
                }
                function F(gt) {
                    return (gt = _(gt / 2)) * gt;
                }
                function q() {}
                function V(gt, Bt) {
                    gt && X.hasOwnProperty(gt.type) && X[gt.type](gt, Bt);
                }
                var H = {
                    Feature: function(gt, Bt) {
                        V(gt.geometry, Bt);
                    },
                    FeatureCollection: function(gt, Bt) {
                        for(var wr = gt.features, vr = -1, Ur = wr.length; ++vr < Ur;)V(wr[vr].geometry, Bt);
                    }
                }, X = {
                    Sphere: function(gt, Bt) {
                        Bt.sphere();
                    },
                    Point: function(gt, Bt) {
                        gt = gt.coordinates, Bt.point(gt[0], gt[1], gt[2]);
                    },
                    MultiPoint: function(gt, Bt) {
                        for(var wr = gt.coordinates, vr = -1, Ur = wr.length; ++vr < Ur;)gt = wr[vr], Bt.point(gt[0], gt[1], gt[2]);
                    },
                    LineString: function(gt, Bt) {
                        G(gt.coordinates, Bt, 0);
                    },
                    MultiLineString: function(gt, Bt) {
                        for(var wr = gt.coordinates, vr = -1, Ur = wr.length; ++vr < Ur;)G(wr[vr], Bt, 0);
                    },
                    Polygon: function(gt, Bt) {
                        N(gt.coordinates, Bt);
                    },
                    MultiPolygon: function(gt, Bt) {
                        for(var wr = gt.coordinates, vr = -1, Ur = wr.length; ++vr < Ur;)N(wr[vr], Bt);
                    },
                    GeometryCollection: function(gt, Bt) {
                        for(var wr = gt.geometries, vr = -1, Ur = wr.length; ++vr < Ur;)V(wr[vr], Bt);
                    }
                };
                function G(gt, Bt, wr) {
                    var vr = -1, Ur = gt.length - wr, fi;
                    for(Bt.lineStart(); ++vr < Ur;)fi = gt[vr], Bt.point(fi[0], fi[1], fi[2]);
                    Bt.lineEnd();
                }
                function N(gt, Bt) {
                    var wr = -1, vr = gt.length;
                    for(Bt.polygonStart(); ++wr < vr;)G(gt[wr], Bt, 1);
                    Bt.polygonEnd();
                }
                function W(gt, Bt) {
                    gt && H.hasOwnProperty(gt.type) ? H[gt.type](gt, Bt) : V(gt, Bt);
                }
                var re = r(), ae = r(), _e, Me, ke, ge, ie, Te = {
                    point: q,
                    lineStart: q,
                    lineEnd: q,
                    polygonStart: function() {
                        re.reset(), Te.lineStart = Ee, Te.lineEnd = Ae;
                    },
                    polygonEnd: function() {
                        var gt = +re;
                        ae.add(gt < 0 ? f + gt : gt), this.lineStart = this.lineEnd = this.point = q;
                    },
                    sphere: function() {
                        ae.add(f);
                    }
                };
                function Ee() {
                    Te.point = ze;
                }
                function Ae() {
                    Ce(_e, Me);
                }
                function ze(gt, Bt) {
                    Te.point = Ce, _e = gt, Me = Bt, gt *= d, Bt *= d, ke = gt, ge = p(Bt = Bt / 2 + c), ie = _(Bt);
                }
                function Ce(gt, Bt) {
                    gt *= d, Bt *= d, Bt = Bt / 2 + c;
                    var wr = gt - ke, vr = wr >= 0 ? 1 : -1, Ur = vr * wr, fi = p(Bt), xi = _(Bt), Fi = ie * xi, Xi = ge * fi + Fi * p(Ur), hn = Fi * vr * _(Ur);
                    re.add(b(hn, Xi)), ke = gt, ge = fi, ie = xi;
                }
                function me(gt) {
                    return ae.reset(), W(gt, Te), ae * 2;
                }
                function Re(gt) {
                    return [
                        b(gt[1], gt[0]),
                        T(gt[2])
                    ];
                }
                function ce(gt) {
                    var Bt = gt[0], wr = gt[1], vr = p(wr);
                    return [
                        vr * p(Bt),
                        vr * _(Bt),
                        _(wr)
                    ];
                }
                function Ge(gt, Bt) {
                    return gt[0] * Bt[0] + gt[1] * Bt[1] + gt[2] * Bt[2];
                }
                function nt(gt, Bt) {
                    return [
                        gt[1] * Bt[2] - gt[2] * Bt[1],
                        gt[2] * Bt[0] - gt[0] * Bt[2],
                        gt[0] * Bt[1] - gt[1] * Bt[0]
                    ];
                }
                function ct(gt, Bt) {
                    gt[0] += Bt[0], gt[1] += Bt[1], gt[2] += Bt[2];
                }
                function qt(gt, Bt) {
                    return [
                        gt[0] * Bt,
                        gt[1] * Bt,
                        gt[2] * Bt
                    ];
                }
                function rt(gt) {
                    var Bt = M(gt[0] * gt[0] + gt[1] * gt[1] + gt[2] * gt[2]);
                    gt[0] /= Bt, gt[1] /= Bt, gt[2] /= Bt;
                }
                var ot, Rt, kt, Ct, Yt, xr, er, Ke, xt = r(), bt, Lt, St = {
                    point: Et,
                    lineStart: Ht,
                    lineEnd: $t,
                    polygonStart: function() {
                        St.point = fr, St.lineStart = _r, St.lineEnd = Br, xt.reset(), Te.polygonStart();
                    },
                    polygonEnd: function() {
                        Te.polygonEnd(), St.point = Et, St.lineStart = Ht, St.lineEnd = $t, re < 0 ? (ot = -(kt = 180), Rt = -(Ct = 90)) : xt > o ? Ct = 90 : xt < -o && (Rt = -90), Lt[0] = ot, Lt[1] = kt;
                    },
                    sphere: function() {
                        ot = -(kt = 180), Rt = -(Ct = 90);
                    }
                };
                function Et(gt, Bt) {
                    bt.push(Lt = [
                        ot = gt,
                        kt = gt
                    ]), Bt < Rt && (Rt = Bt), Bt > Ct && (Ct = Bt);
                }
                function dt(gt, Bt) {
                    var wr = ce([
                        gt * d,
                        Bt * d
                    ]);
                    if (Ke) {
                        var vr = nt(Ke, wr), Ur = [
                            vr[1],
                            -vr[0],
                            0
                        ], fi = nt(Ur, vr);
                        rt(fi), fi = Re(fi);
                        var xi = gt - Yt, Fi = xi > 0 ? 1 : -1, Xi = fi[0] * h * Fi, hn, Ti = v(xi) > 180;
                        Ti ^ (Fi * Yt < Xi && Xi < Fi * gt) ? (hn = fi[1] * h, hn > Ct && (Ct = hn)) : (Xi = (Xi + 360) % 360 - 180, Ti ^ (Fi * Yt < Xi && Xi < Fi * gt) ? (hn = -fi[1] * h, hn < Rt && (Rt = hn)) : (Bt < Rt && (Rt = Bt), Bt > Ct && (Ct = Bt))), Ti ? gt < Yt ? Or(ot, gt) > Or(ot, kt) && (kt = gt) : Or(gt, kt) > Or(ot, kt) && (ot = gt) : kt >= ot ? (gt < ot && (ot = gt), gt > kt && (kt = gt)) : gt > Yt ? Or(ot, gt) > Or(ot, kt) && (kt = gt) : Or(gt, kt) > Or(ot, kt) && (ot = gt);
                    } else bt.push(Lt = [
                        ot = gt,
                        kt = gt
                    ]);
                    Bt < Rt && (Rt = Bt), Bt > Ct && (Ct = Bt), Ke = wr, Yt = gt;
                }
                function Ht() {
                    St.point = dt;
                }
                function $t() {
                    Lt[0] = ot, Lt[1] = kt, St.point = Et, Ke = null;
                }
                function fr(gt, Bt) {
                    if (Ke) {
                        var wr = gt - Yt;
                        xt.add(v(wr) > 180 ? wr + (wr > 0 ? 360 : -360) : wr);
                    } else xr = gt, er = Bt;
                    Te.point(gt, Bt), dt(gt, Bt);
                }
                function _r() {
                    Te.lineStart();
                }
                function Br() {
                    fr(xr, er), Te.lineEnd(), v(xt) > o && (ot = -(kt = 180)), Lt[0] = ot, Lt[1] = kt, Ke = null;
                }
                function Or(gt, Bt) {
                    return (Bt -= gt) < 0 ? Bt + 360 : Bt;
                }
                function Nr(gt, Bt) {
                    return gt[0] - Bt[0];
                }
                function ut(gt, Bt) {
                    return gt[0] <= gt[1] ? gt[0] <= Bt && Bt <= gt[1] : Bt < gt[0] || gt[1] < Bt;
                }
                function Ne(gt) {
                    var Bt, wr, vr, Ur, fi, xi, Fi;
                    if (Ct = kt = -(ot = Rt = 1 / 0), bt = [], W(gt, St), wr = bt.length) {
                        for(bt.sort(Nr), Bt = 1, vr = bt[0], fi = [
                            vr
                        ]; Bt < wr; ++Bt)Ur = bt[Bt], ut(vr, Ur[0]) || ut(vr, Ur[1]) ? (Or(vr[0], Ur[1]) > Or(vr[0], vr[1]) && (vr[1] = Ur[1]), Or(Ur[0], vr[1]) > Or(vr[0], vr[1]) && (vr[0] = Ur[0])) : fi.push(vr = Ur);
                        for(xi = -1 / 0, wr = fi.length - 1, Bt = 0, vr = fi[wr]; Bt <= wr; vr = Ur, ++Bt)Ur = fi[Bt], (Fi = Or(vr[1], Ur[0])) > xi && (xi = Fi, ot = Ur[0], kt = vr[1]);
                    }
                    return bt = Lt = null, ot === 1 / 0 || Rt === 1 / 0 ? [
                        [
                            NaN,
                            NaN
                        ],
                        [
                            NaN,
                            NaN
                        ]
                    ] : [
                        [
                            ot,
                            Rt
                        ],
                        [
                            kt,
                            Ct
                        ]
                    ];
                }
                var Ye, Ve, Xe, ht, Le, xe, Se, lt, Gt, Vt, ar, Qr, ai, jr, ri, bi, nn = {
                    sphere: q,
                    point: Wi,
                    lineStart: _n,
                    lineEnd: Wn,
                    polygonStart: function() {
                        nn.lineStart = It, nn.lineEnd = ft;
                    },
                    polygonEnd: function() {
                        nn.lineStart = _n, nn.lineEnd = Wn;
                    }
                };
                function Wi(gt, Bt) {
                    gt *= d, Bt *= d;
                    var wr = p(Bt);
                    Ni(wr * p(gt), wr * _(gt), _(Bt));
                }
                function Ni(gt, Bt, wr) {
                    ++Ye, Xe += (gt - Xe) / Ye, ht += (Bt - ht) / Ye, Le += (wr - Le) / Ye;
                }
                function _n() {
                    nn.point = $i;
                }
                function $i(gt, Bt) {
                    gt *= d, Bt *= d;
                    var wr = p(Bt);
                    jr = wr * p(gt), ri = wr * _(gt), bi = _(Bt), nn.point = zn, Ni(jr, ri, bi);
                }
                function zn(gt, Bt) {
                    gt *= d, Bt *= d;
                    var wr = p(Bt), vr = wr * p(gt), Ur = wr * _(gt), fi = _(Bt), xi = b(M((xi = ri * fi - bi * Ur) * xi + (xi = bi * vr - jr * fi) * xi + (xi = jr * Ur - ri * vr) * xi), jr * vr + ri * Ur + bi * fi);
                    Ve += xi, xe += xi * (jr + (jr = vr)), Se += xi * (ri + (ri = Ur)), lt += xi * (bi + (bi = fi)), Ni(jr, ri, bi);
                }
                function Wn() {
                    nn.point = Wi;
                }
                function It() {
                    nn.point = jt;
                }
                function ft() {
                    Zt(Qr, ai), nn.point = Wi;
                }
                function jt(gt, Bt) {
                    Qr = gt, ai = Bt, gt *= d, Bt *= d, nn.point = Zt;
                    var wr = p(Bt);
                    jr = wr * p(gt), ri = wr * _(gt), bi = _(Bt), Ni(jr, ri, bi);
                }
                function Zt(gt, Bt) {
                    gt *= d, Bt *= d;
                    var wr = p(Bt), vr = wr * p(gt), Ur = wr * _(gt), fi = _(Bt), xi = ri * fi - bi * Ur, Fi = bi * vr - jr * fi, Xi = jr * Ur - ri * vr, hn = M(xi * xi + Fi * Fi + Xi * Xi), Ti = T(hn), qi = hn && -Ti / hn;
                    Gt += qi * xi, Vt += qi * Fi, ar += qi * Xi, Ve += Ti, xe += Ti * (jr + (jr = vr)), Se += Ti * (ri + (ri = Ur)), lt += Ti * (bi + (bi = fi)), Ni(jr, ri, bi);
                }
                function yr(gt) {
                    Ye = Ve = Xe = ht = Le = xe = Se = lt = Gt = Vt = ar = 0, W(gt, nn);
                    var Bt = Gt, wr = Vt, vr = ar, Ur = Bt * Bt + wr * wr + vr * vr;
                    return Ur < s && (Bt = xe, wr = Se, vr = lt, Ve < o && (Bt = Xe, wr = ht, vr = Le), Ur = Bt * Bt + wr * wr + vr * vr, Ur < s) ? [
                        NaN,
                        NaN
                    ] : [
                        b(wr, Bt) * h,
                        T(vr / M(Ur)) * h
                    ];
                }
                function Fr(gt) {
                    return function() {
                        return gt;
                    };
                }
                function Zr(gt, Bt) {
                    function wr(vr, Ur) {
                        return vr = gt(vr, Ur), Bt(vr[0], vr[1]);
                    }
                    return gt.invert && Bt.invert && (wr.invert = function(vr, Ur) {
                        return vr = Bt.invert(vr, Ur), vr && gt.invert(vr[0], vr[1]);
                    }), wr;
                }
                function Vr(gt, Bt) {
                    return [
                        v(gt) > l ? gt + Math.round(-gt / f) * f : gt,
                        Bt
                    ];
                }
                Vr.invert = Vr;
                function gi(gt, Bt, wr) {
                    return (gt %= f) ? Bt || wr ? Zr(Mi(gt), Pi(Bt, wr)) : Mi(gt) : Bt || wr ? Pi(Bt, wr) : Vr;
                }
                function Si(gt) {
                    return function(Bt, wr) {
                        return Bt += gt, [
                            Bt > l ? Bt - f : Bt < -l ? Bt + f : Bt,
                            wr
                        ];
                    };
                }
                function Mi(gt) {
                    var Bt = Si(gt);
                    return Bt.invert = Si(-gt), Bt;
                }
                function Pi(gt, Bt) {
                    var wr = p(gt), vr = _(gt), Ur = p(Bt), fi = _(Bt);
                    function xi(Fi, Xi) {
                        var hn = p(Xi), Ti = p(Fi) * hn, qi = _(Fi) * hn, Ii = _(Xi), mi = Ii * wr + Ti * vr;
                        return [
                            b(qi * Ur - mi * fi, Ti * wr - Ii * vr),
                            T(mi * Ur + qi * fi)
                        ];
                    }
                    return xi.invert = function(Fi, Xi) {
                        var hn = p(Xi), Ti = p(Fi) * hn, qi = _(Fi) * hn, Ii = _(Xi), mi = Ii * Ur - qi * fi;
                        return [
                            b(qi * Ur + Ii * fi, Ti * wr + mi * vr),
                            T(mi * wr - Ti * vr)
                        ];
                    }, xi;
                }
                function Gi(gt) {
                    gt = gi(gt[0] * d, gt[1] * d, gt.length > 2 ? gt[2] * d : 0);
                    function Bt(wr) {
                        return wr = gt(wr[0] * d, wr[1] * d), wr[0] *= h, wr[1] *= h, wr;
                    }
                    return Bt.invert = function(wr) {
                        return wr = gt.invert(wr[0] * d, wr[1] * d), wr[0] *= h, wr[1] *= h, wr;
                    }, Bt;
                }
                function Ki(gt, Bt, wr, vr, Ur, fi) {
                    if (wr) {
                        var xi = p(Bt), Fi = _(Bt), Xi = vr * wr;
                        Ur == null ? (Ur = Bt + vr * f, fi = Bt - Xi / 2) : (Ur = ka(xi, Ur), fi = ka(xi, fi), (vr > 0 ? Ur < fi : Ur > fi) && (Ur += vr * f));
                        for(var hn, Ti = Ur; vr > 0 ? Ti > fi : Ti < fi; Ti -= Xi)hn = Re([
                            xi,
                            -Fi * p(Ti),
                            -Fi * _(Ti)
                        ]), gt.point(hn[0], hn[1]);
                    }
                }
                function ka(gt, Bt) {
                    Bt = ce(Bt), Bt[0] -= gt, rt(Bt);
                    var wr = P(-Bt[1]);
                    return ((-Bt[2] < 0 ? -wr : wr) + f - o) % f;
                }
                function jn() {
                    var gt = Fr([
                        0,
                        0
                    ]), Bt = Fr(90), wr = Fr(6), vr, Ur, fi = {
                        point: xi
                    };
                    function xi(Xi, hn) {
                        vr.push(Xi = Ur(Xi, hn)), Xi[0] *= h, Xi[1] *= h;
                    }
                    function Fi() {
                        var Xi = gt.apply(this, arguments), hn = Bt.apply(this, arguments) * d, Ti = wr.apply(this, arguments) * d;
                        return vr = [], Ur = gi(-Xi[0] * d, -Xi[1] * d, 0).invert, Ki(fi, hn, Ti, 1), Xi = {
                            type: "Polygon",
                            coordinates: [
                                vr
                            ]
                        }, vr = Ur = null, Xi;
                    }
                    return Fi.center = function(Xi) {
                        return arguments.length ? (gt = typeof Xi == "function" ? Xi : Fr([
                            +Xi[0],
                            +Xi[1]
                        ]), Fi) : gt;
                    }, Fi.radius = function(Xi) {
                        return arguments.length ? (Bt = typeof Xi == "function" ? Xi : Fr(+Xi), Fi) : Bt;
                    }, Fi.precision = function(Xi) {
                        return arguments.length ? (wr = typeof Xi == "function" ? Xi : Fr(+Xi), Fi) : wr;
                    }, Fi;
                }
                function la() {
                    var gt = [], Bt;
                    return {
                        point: function(wr, vr, Ur) {
                            Bt.push([
                                wr,
                                vr,
                                Ur
                            ]);
                        },
                        lineStart: function() {
                            gt.push(Bt = []);
                        },
                        lineEnd: q,
                        rejoin: function() {
                            gt.length > 1 && gt.push(gt.pop().concat(gt.shift()));
                        },
                        result: function() {
                            var wr = gt;
                            return gt = [], Bt = null, wr;
                        }
                    };
                }
                function Fa(gt, Bt) {
                    return v(gt[0] - Bt[0]) < o && v(gt[1] - Bt[1]) < o;
                }
                function Ra(gt, Bt, wr, vr) {
                    this.x = gt, this.z = Bt, this.o = wr, this.e = vr, this.v = !1, this.n = this.p = null;
                }
                function jo(gt, Bt, wr, vr, Ur) {
                    var fi = [], xi = [], Fi, Xi;
                    if (gt.forEach(function(Pn) {
                        if (!((Ma = Pn.length - 1) <= 0)) {
                            var Ma, Ta = Pn[0], Ea = Pn[Ma], qa;
                            if (Fa(Ta, Ea)) {
                                if (!Ta[2] && !Ea[2]) {
                                    for(Ur.lineStart(), Fi = 0; Fi < Ma; ++Fi)Ur.point((Ta = Pn[Fi])[0], Ta[1]);
                                    Ur.lineEnd();
                                    return;
                                }
                                Ea[0] += 2 * o;
                            }
                            fi.push(qa = new Ra(Ta, Pn, null, !0)), xi.push(qa.o = new Ra(Ta, null, qa, !1)), fi.push(qa = new Ra(Ea, Pn, null, !1)), xi.push(qa.o = new Ra(Ea, null, qa, !0));
                        }
                    }), !!fi.length) {
                        for(xi.sort(Bt), oa(fi), oa(xi), Fi = 0, Xi = xi.length; Fi < Xi; ++Fi)xi[Fi].e = wr = !wr;
                        for(var hn = fi[0], Ti, qi;;){
                            for(var Ii = hn, mi = !0; Ii.v;)if ((Ii = Ii.n) === hn) return;
                            Ti = Ii.z, Ur.lineStart();
                            do {
                                if (Ii.v = Ii.o.v = !0, Ii.e) {
                                    if (mi) for(Fi = 0, Xi = Ti.length; Fi < Xi; ++Fi)Ur.point((qi = Ti[Fi])[0], qi[1]);
                                    else vr(Ii.x, Ii.n.x, 1, Ur);
                                    Ii = Ii.n;
                                } else {
                                    if (mi) for(Ti = Ii.p.z, Fi = Ti.length - 1; Fi >= 0; --Fi)Ur.point((qi = Ti[Fi])[0], qi[1]);
                                    else vr(Ii.x, Ii.p.x, -1, Ur);
                                    Ii = Ii.p;
                                }
                                Ii = Ii.o, Ti = Ii.z, mi = !mi;
                            }while (!Ii.v);
                            Ur.lineEnd();
                        }
                    }
                }
                function oa(gt) {
                    if (Bt = gt.length) {
                        for(var Bt, wr = 0, vr = gt[0], Ur; ++wr < Bt;)vr.n = Ur = gt[wr], Ur.p = vr, vr = Ur;
                        vr.n = Ur = gt[0], Ur.p = vr;
                    }
                }
                var Sn = r();
                function Ha(gt) {
                    return v(gt[0]) <= l ? gt[0] : C(gt[0]) * ((v(gt[0]) + l) % f - l);
                }
                function oo(gt, Bt) {
                    var wr = Ha(Bt), vr = Bt[1], Ur = _(vr), fi = [
                        _(wr),
                        -p(wr),
                        0
                    ], xi = 0, Fi = 0;
                    Sn.reset(), Ur === 1 ? vr = u + o : Ur === -1 && (vr = -u - o);
                    for(var Xi = 0, hn = gt.length; Xi < hn; ++Xi)if (qi = (Ti = gt[Xi]).length) for(var Ti, qi, Ii = Ti[qi - 1], mi = Ha(Ii), Pn = Ii[1] / 2 + c, Ma = _(Pn), Ta = p(Pn), Ea = 0; Ea < qi; ++Ea, mi = Cn, Ma = Ua, Ta = mo, Ii = qa){
                        var qa = Ti[Ea], Cn = Ha(qa), sn = qa[1] / 2 + c, Ua = _(sn), mo = p(sn), Xo = Cn - mi, Ts = Xo >= 0 ? 1 : -1, Qo = Ts * Xo, ys = Qo > l, Bo = Ma * Ua;
                        if (Sn.add(b(Bo * Ts * _(Qo), Ta * mo + Bo * p(Qo))), xi += ys ? Xo + Ts * f : Xo, ys ^ mi >= wr ^ Cn >= wr) {
                            var yl = nt(ce(Ii), ce(qa));
                            rt(yl);
                            var Gs = nt(fi, yl);
                            rt(Gs);
                            var Rs = (ys ^ Xo >= 0 ? -1 : 1) * T(Gs[2]);
                            (vr > Rs || vr === Rs && (yl[0] || yl[1])) && (Fi += ys ^ Xo >= 0 ? 1 : -1);
                        }
                    }
                    return (xi < -o || xi < o && Sn < -o) ^ Fi & 1;
                }
                function xn(gt, Bt, wr, vr) {
                    return function(Ur) {
                        var fi = Bt(Ur), xi = la(), Fi = Bt(xi), Xi = !1, hn, Ti, qi, Ii = {
                            point: mi,
                            lineStart: Ma,
                            lineEnd: Ta,
                            polygonStart: function() {
                                Ii.point = Ea, Ii.lineStart = qa, Ii.lineEnd = Cn, Ti = [], hn = [];
                            },
                            polygonEnd: function() {
                                Ii.point = mi, Ii.lineStart = Ma, Ii.lineEnd = Ta, Ti = t.merge(Ti);
                                var sn = oo(hn, vr);
                                Ti.length ? (Xi || (Ur.polygonStart(), Xi = !0), jo(Ti, br, sn, wr, Ur)) : sn && (Xi || (Ur.polygonStart(), Xi = !0), Ur.lineStart(), wr(null, null, 1, Ur), Ur.lineEnd()), Xi && (Ur.polygonEnd(), Xi = !1), Ti = hn = null;
                            },
                            sphere: function() {
                                Ur.polygonStart(), Ur.lineStart(), wr(null, null, 1, Ur), Ur.lineEnd(), Ur.polygonEnd();
                            }
                        };
                        function mi(sn, Ua) {
                            gt(sn, Ua) && Ur.point(sn, Ua);
                        }
                        function Pn(sn, Ua) {
                            fi.point(sn, Ua);
                        }
                        function Ma() {
                            Ii.point = Pn, fi.lineStart();
                        }
                        function Ta() {
                            Ii.point = mi, fi.lineEnd();
                        }
                        function Ea(sn, Ua) {
                            qi.push([
                                sn,
                                Ua
                            ]), Fi.point(sn, Ua);
                        }
                        function qa() {
                            Fi.lineStart(), qi = [];
                        }
                        function Cn() {
                            Ea(qi[0][0], qi[0][1]), Fi.lineEnd();
                            var sn = Fi.clean(), Ua = xi.result(), mo, Xo = Ua.length, Ts, Qo, ys;
                            if (qi.pop(), hn.push(qi), qi = null, !!Xo) {
                                if (sn & 1) {
                                    if (Qo = Ua[0], (Ts = Qo.length - 1) > 0) {
                                        for(Xi || (Ur.polygonStart(), Xi = !0), Ur.lineStart(), mo = 0; mo < Ts; ++mo)Ur.point((ys = Qo[mo])[0], ys[1]);
                                        Ur.lineEnd();
                                    }
                                    return;
                                }
                                Xo > 1 && sn & 2 && Ua.push(Ua.pop().concat(Ua.shift())), Ti.push(Ua.filter(_t));
                            }
                        }
                        return Ii;
                    };
                }
                function _t(gt) {
                    return gt.length > 1;
                }
                function br(gt, Bt) {
                    return ((gt = gt.x)[0] < 0 ? gt[1] - u - o : u - gt[1]) - ((Bt = Bt.x)[0] < 0 ? Bt[1] - u - o : u - Bt[1]);
                }
                var Hr = xn(function() {
                    return !0;
                }, ti, Yi, [
                    -l,
                    -u
                ]);
                function ti(gt) {
                    var Bt = NaN, wr = NaN, vr = NaN, Ur;
                    return {
                        lineStart: function() {
                            gt.lineStart(), Ur = 1;
                        },
                        point: function(fi, xi) {
                            var Fi = fi > 0 ? l : -l, Xi = v(fi - Bt);
                            v(Xi - l) < o ? (gt.point(Bt, wr = (wr + xi) / 2 > 0 ? u : -u), gt.point(vr, wr), gt.lineEnd(), gt.lineStart(), gt.point(Fi, wr), gt.point(fi, wr), Ur = 0) : vr !== Fi && Xi >= l && (v(Bt - vr) < o && (Bt -= vr * o), v(fi - Fi) < o && (fi -= Fi * o), wr = zi(Bt, wr, fi, xi), gt.point(vr, wr), gt.lineEnd(), gt.lineStart(), gt.point(Fi, wr), Ur = 0), gt.point(Bt = fi, wr = xi), vr = Fi;
                        },
                        lineEnd: function() {
                            gt.lineEnd(), Bt = wr = NaN;
                        },
                        clean: function() {
                            return 2 - Ur;
                        }
                    };
                }
                function zi(gt, Bt, wr, vr) {
                    var Ur, fi, xi = _(gt - wr);
                    return v(xi) > o ? x((_(Bt) * (fi = p(vr)) * _(wr) - _(vr) * (Ur = p(Bt)) * _(gt)) / (Ur * fi * xi)) : (Bt + vr) / 2;
                }
                function Yi(gt, Bt, wr, vr) {
                    var Ur;
                    if (gt == null) Ur = wr * u, vr.point(-l, Ur), vr.point(0, Ur), vr.point(l, Ur), vr.point(l, 0), vr.point(l, -Ur), vr.point(0, -Ur), vr.point(-l, -Ur), vr.point(-l, 0), vr.point(-l, Ur);
                    else if (v(gt[0] - Bt[0]) > o) {
                        var fi = gt[0] < Bt[0] ? l : -l;
                        Ur = wr * fi / 2, vr.point(-fi, Ur), vr.point(0, Ur), vr.point(fi, Ur);
                    } else vr.point(Bt[0], Bt[1]);
                }
                function an(gt) {
                    var Bt = p(gt), wr = 6 * d, vr = Bt > 0, Ur = v(Bt) > o;
                    function fi(Ti, qi, Ii, mi) {
                        Ki(mi, gt, wr, Ii, Ti, qi);
                    }
                    function xi(Ti, qi) {
                        return p(Ti) * p(qi) > Bt;
                    }
                    function Fi(Ti) {
                        var qi, Ii, mi, Pn, Ma;
                        return {
                            lineStart: function() {
                                Pn = mi = !1, Ma = 1;
                            },
                            point: function(Ta, Ea) {
                                var qa = [
                                    Ta,
                                    Ea
                                ], Cn, sn = xi(Ta, Ea), Ua = vr ? sn ? 0 : hn(Ta, Ea) : sn ? hn(Ta + (Ta < 0 ? l : -l), Ea) : 0;
                                if (!qi && (Pn = mi = sn) && Ti.lineStart(), sn !== mi && (Cn = Xi(qi, qa), (!Cn || Fa(qi, Cn) || Fa(qa, Cn)) && (qa[2] = 1)), sn !== mi) Ma = 0, sn ? (Ti.lineStart(), Cn = Xi(qa, qi), Ti.point(Cn[0], Cn[1])) : (Cn = Xi(qi, qa), Ti.point(Cn[0], Cn[1], 2), Ti.lineEnd()), qi = Cn;
                                else if (Ur && qi && vr ^ sn) {
                                    var mo;
                                    !(Ua & Ii) && (mo = Xi(qa, qi, !0)) && (Ma = 0, vr ? (Ti.lineStart(), Ti.point(mo[0][0], mo[0][1]), Ti.point(mo[1][0], mo[1][1]), Ti.lineEnd()) : (Ti.point(mo[1][0], mo[1][1]), Ti.lineEnd(), Ti.lineStart(), Ti.point(mo[0][0], mo[0][1], 3)));
                                }
                                sn && (!qi || !Fa(qi, qa)) && Ti.point(qa[0], qa[1]), qi = qa, mi = sn, Ii = Ua;
                            },
                            lineEnd: function() {
                                mi && Ti.lineEnd(), qi = null;
                            },
                            clean: function() {
                                return Ma | (Pn && mi) << 1;
                            }
                        };
                    }
                    function Xi(Ti, qi, Ii) {
                        var mi = ce(Ti), Pn = ce(qi), Ma = [
                            1,
                            0,
                            0
                        ], Ta = nt(mi, Pn), Ea = Ge(Ta, Ta), qa = Ta[0], Cn = Ea - qa * qa;
                        if (!Cn) return !Ii && Ti;
                        var sn = Bt * Ea / Cn, Ua = -Bt * qa / Cn, mo = nt(Ma, Ta), Xo = qt(Ma, sn), Ts = qt(Ta, Ua);
                        ct(Xo, Ts);
                        var Qo = mo, ys = Ge(Xo, Qo), Bo = Ge(Qo, Qo), yl = ys * ys - Bo * (Ge(Xo, Xo) - 1);
                        if (!(yl < 0)) {
                            var Gs = M(yl), Rs = qt(Qo, (-ys - Gs) / Bo);
                            if (ct(Rs, Xo), Rs = Re(Rs), !Ii) return Rs;
                            var ia = Ti[0], Ka = qi[0], vs = Ti[1], Ko = qi[1], nu;
                            Ka < ia && (nu = ia, ia = Ka, Ka = nu);
                            var Ru = Ka - ia, ac = v(Ru - l) < o, mf = ac || Ru < o;
                            if (!ac && Ko < vs && (nu = vs, vs = Ko, Ko = nu), mf ? ac ? vs + Ko > 0 ^ Rs[1] < (v(Rs[0] - ia) < o ? vs : Ko) : vs <= Rs[1] && Rs[1] <= Ko : Ru > l ^ (ia <= Rs[0] && Rs[0] <= Ka)) {
                                var bu = qt(Qo, (-ys + Gs) / Bo);
                                return ct(bu, Xo), [
                                    Rs,
                                    Re(bu)
                                ];
                            }
                        }
                    }
                    function hn(Ti, qi) {
                        var Ii = vr ? gt : l - gt, mi = 0;
                        return Ti < -Ii ? mi |= 1 : Ti > Ii && (mi |= 2), qi < -Ii ? mi |= 4 : qi > Ii && (mi |= 8), mi;
                    }
                    return xn(xi, Fi, fi, vr ? [
                        0,
                        -gt
                    ] : [
                        -l,
                        gt - l
                    ]);
                }
                function hi(gt, Bt, wr, vr, Ur, fi) {
                    var xi = gt[0], Fi = gt[1], Xi = Bt[0], hn = Bt[1], Ti = 0, qi = 1, Ii = Xi - xi, mi = hn - Fi, Pn;
                    if (Pn = wr - xi, !(!Ii && Pn > 0)) {
                        if (Pn /= Ii, Ii < 0) {
                            if (Pn < Ti) return;
                            Pn < qi && (qi = Pn);
                        } else if (Ii > 0) {
                            if (Pn > qi) return;
                            Pn > Ti && (Ti = Pn);
                        }
                        if (Pn = Ur - xi, !(!Ii && Pn < 0)) {
                            if (Pn /= Ii, Ii < 0) {
                                if (Pn > qi) return;
                                Pn > Ti && (Ti = Pn);
                            } else if (Ii > 0) {
                                if (Pn < Ti) return;
                                Pn < qi && (qi = Pn);
                            }
                            if (Pn = vr - Fi, !(!mi && Pn > 0)) {
                                if (Pn /= mi, mi < 0) {
                                    if (Pn < Ti) return;
                                    Pn < qi && (qi = Pn);
                                } else if (mi > 0) {
                                    if (Pn > qi) return;
                                    Pn > Ti && (Ti = Pn);
                                }
                                if (Pn = fi - Fi, !(!mi && Pn < 0)) {
                                    if (Pn /= mi, mi < 0) {
                                        if (Pn > qi) return;
                                        Pn > Ti && (Ti = Pn);
                                    } else if (mi > 0) {
                                        if (Pn < Ti) return;
                                        Pn < qi && (qi = Pn);
                                    }
                                    return Ti > 0 && (gt[0] = xi + Ti * Ii, gt[1] = Fi + Ti * mi), qi < 1 && (Bt[0] = xi + qi * Ii, Bt[1] = Fi + qi * mi), !0;
                                }
                            }
                        }
                    }
                }
                var Ji = 1e9, ua = -Ji;
                function Fn(gt, Bt, wr, vr) {
                    function Ur(hn, Ti) {
                        return gt <= hn && hn <= wr && Bt <= Ti && Ti <= vr;
                    }
                    function fi(hn, Ti, qi, Ii) {
                        var mi = 0, Pn = 0;
                        if (hn == null || (mi = xi(hn, qi)) !== (Pn = xi(Ti, qi)) || Xi(hn, Ti) < 0 ^ qi > 0) do Ii.point(mi === 0 || mi === 3 ? gt : wr, mi > 1 ? vr : Bt);
                        while ((mi = (mi + qi + 4) % 4) !== Pn);
                        else Ii.point(Ti[0], Ti[1]);
                    }
                    function xi(hn, Ti) {
                        return v(hn[0] - gt) < o ? Ti > 0 ? 0 : 3 : v(hn[0] - wr) < o ? Ti > 0 ? 2 : 1 : v(hn[1] - Bt) < o ? Ti > 0 ? 1 : 0 : Ti > 0 ? 3 : 2;
                    }
                    function Fi(hn, Ti) {
                        return Xi(hn.x, Ti.x);
                    }
                    function Xi(hn, Ti) {
                        var qi = xi(hn, 1), Ii = xi(Ti, 1);
                        return qi !== Ii ? qi - Ii : qi === 0 ? Ti[1] - hn[1] : qi === 1 ? hn[0] - Ti[0] : qi === 2 ? hn[1] - Ti[1] : Ti[0] - hn[0];
                    }
                    return function(hn) {
                        var Ti = hn, qi = la(), Ii, mi, Pn, Ma, Ta, Ea, qa, Cn, sn, Ua, mo, Xo = {
                            point: Ts,
                            lineStart: yl,
                            lineEnd: Gs,
                            polygonStart: ys,
                            polygonEnd: Bo
                        };
                        function Ts(ia, Ka) {
                            Ur(ia, Ka) && Ti.point(ia, Ka);
                        }
                        function Qo() {
                            for(var ia = 0, Ka = 0, vs = mi.length; Ka < vs; ++Ka)for(var Ko = mi[Ka], nu = 1, Ru = Ko.length, ac = Ko[0], mf, bu, Kc = ac[0], Du = ac[1]; nu < Ru; ++nu)mf = Kc, bu = Du, ac = Ko[nu], Kc = ac[0], Du = ac[1], bu <= vr ? Du > vr && (Kc - mf) * (vr - bu) > (Du - bu) * (gt - mf) && ++ia : Du <= vr && (Kc - mf) * (vr - bu) < (Du - bu) * (gt - mf) && --ia;
                            return ia;
                        }
                        function ys() {
                            Ti = qi, Ii = [], mi = [], mo = !0;
                        }
                        function Bo() {
                            var ia = Qo(), Ka = mo && ia, vs = (Ii = t.merge(Ii)).length;
                            (Ka || vs) && (hn.polygonStart(), Ka && (hn.lineStart(), fi(null, null, 1, hn), hn.lineEnd()), vs && jo(Ii, Fi, ia, fi, hn), hn.polygonEnd()), Ti = hn, Ii = mi = Pn = null;
                        }
                        function yl() {
                            Xo.point = Rs, mi && mi.push(Pn = []), Ua = !0, sn = !1, qa = Cn = NaN;
                        }
                        function Gs() {
                            Ii && (Rs(Ma, Ta), Ea && sn && qi.rejoin(), Ii.push(qi.result())), Xo.point = Ts, sn && Ti.lineEnd();
                        }
                        function Rs(ia, Ka) {
                            var vs = Ur(ia, Ka);
                            if (mi && Pn.push([
                                ia,
                                Ka
                            ]), Ua) Ma = ia, Ta = Ka, Ea = vs, Ua = !1, vs && (Ti.lineStart(), Ti.point(ia, Ka));
                            else if (vs && sn) Ti.point(ia, Ka);
                            else {
                                var Ko = [
                                    qa = Math.max(ua, Math.min(Ji, qa)),
                                    Cn = Math.max(ua, Math.min(Ji, Cn))
                                ], nu = [
                                    ia = Math.max(ua, Math.min(Ji, ia)),
                                    Ka = Math.max(ua, Math.min(Ji, Ka))
                                ];
                                hi(Ko, nu, gt, Bt, wr, vr) ? (sn || (Ti.lineStart(), Ti.point(Ko[0], Ko[1])), Ti.point(nu[0], nu[1]), vs || Ti.lineEnd(), mo = !1) : vs && (Ti.lineStart(), Ti.point(ia, Ka), mo = !1);
                            }
                            qa = ia, Cn = Ka, sn = vs;
                        }
                        return Xo;
                    };
                }
                function Sa() {
                    var gt = 0, Bt = 0, wr = 960, vr = 500, Ur, fi, xi;
                    return xi = {
                        stream: function(Fi) {
                            return Ur && fi === Fi ? Ur : Ur = Fn(gt, Bt, wr, vr)(fi = Fi);
                        },
                        extent: function(Fi) {
                            return arguments.length ? (gt = +Fi[0][0], Bt = +Fi[0][1], wr = +Fi[1][0], vr = +Fi[1][1], Ur = fi = null, xi) : [
                                [
                                    gt,
                                    Bt
                                ],
                                [
                                    wr,
                                    vr
                                ]
                            ];
                        }
                    };
                }
                var go = r(), Oo, ho, Mo, xo = {
                    sphere: q,
                    point: q,
                    lineStart: zs,
                    lineEnd: q,
                    polygonStart: q,
                    polygonEnd: q
                };
                function zs() {
                    xo.point = Zs, xo.lineEnd = ks;
                }
                function ks() {
                    xo.point = xo.lineEnd = q;
                }
                function Zs(gt, Bt) {
                    gt *= d, Bt *= d, Oo = gt, ho = _(Bt), Mo = p(Bt), xo.point = Xs;
                }
                function Xs(gt, Bt) {
                    gt *= d, Bt *= d;
                    var wr = _(Bt), vr = p(Bt), Ur = v(gt - Oo), fi = p(Ur), xi = _(Ur), Fi = vr * xi, Xi = Mo * wr - ho * vr * fi, hn = ho * wr + Mo * vr * fi;
                    go.add(b(M(Fi * Fi + Xi * Xi), hn)), Oo = gt, ho = wr, Mo = vr;
                }
                function wl(gt) {
                    return go.reset(), W(gt, xo), +go;
                }
                var os = [
                    null,
                    null
                ], cl = {
                    type: "LineString",
                    coordinates: os
                };
                function Cs(gt, Bt) {
                    return os[0] = gt, os[1] = Bt, wl(cl);
                }
                var ml = {
                    Feature: function(gt, Bt) {
                        return Hs(gt.geometry, Bt);
                    },
                    FeatureCollection: function(gt, Bt) {
                        for(var wr = gt.features, vr = -1, Ur = wr.length; ++vr < Ur;)if (Hs(wr[vr].geometry, Bt)) return !0;
                        return !1;
                    }
                }, Ys = {
                    Sphere: function() {
                        return !0;
                    },
                    Point: function(gt, Bt) {
                        return Eo(gt.coordinates, Bt);
                    },
                    MultiPoint: function(gt, Bt) {
                        for(var wr = gt.coordinates, vr = -1, Ur = wr.length; ++vr < Ur;)if (Eo(wr[vr], Bt)) return !0;
                        return !1;
                    },
                    LineString: function(gt, Bt) {
                        return fs(gt.coordinates, Bt);
                    },
                    MultiLineString: function(gt, Bt) {
                        for(var wr = gt.coordinates, vr = -1, Ur = wr.length; ++vr < Ur;)if (fs(wr[vr], Bt)) return !0;
                        return !1;
                    },
                    Polygon: function(gt, Bt) {
                        return Ql(gt.coordinates, Bt);
                    },
                    MultiPolygon: function(gt, Bt) {
                        for(var wr = gt.coordinates, vr = -1, Ur = wr.length; ++vr < Ur;)if (Ql(wr[vr], Bt)) return !0;
                        return !1;
                    },
                    GeometryCollection: function(gt, Bt) {
                        for(var wr = gt.geometries, vr = -1, Ur = wr.length; ++vr < Ur;)if (Hs(wr[vr], Bt)) return !0;
                        return !1;
                    }
                };
                function Hs(gt, Bt) {
                    return gt && Ys.hasOwnProperty(gt.type) ? Ys[gt.type](gt, Bt) : !1;
                }
                function Eo(gt, Bt) {
                    return Cs(gt, Bt) === 0;
                }
                function fs(gt, Bt) {
                    for(var wr, vr, Ur, fi = 0, xi = gt.length; fi < xi; fi++){
                        if (vr = Cs(gt[fi], Bt), vr === 0 || fi > 0 && (Ur = Cs(gt[fi], gt[fi - 1]), Ur > 0 && wr <= Ur && vr <= Ur && (wr + vr - Ur) * (1 - Math.pow((wr - vr) / Ur, 2)) < s * Ur)) return !0;
                        wr = vr;
                    }
                    return !1;
                }
                function Ql(gt, Bt) {
                    return !!oo(gt.map(Hu), fc(Bt));
                }
                function Hu(gt) {
                    return gt = gt.map(fc), gt.pop(), gt;
                }
                function fc(gt) {
                    return [
                        gt[0] * d,
                        gt[1] * d
                    ];
                }
                function ms(gt, Bt) {
                    return (gt && ml.hasOwnProperty(gt.type) ? ml[gt.type] : Hs)(gt, Bt);
                }
                function on(gt, Bt, wr) {
                    var vr = t.range(gt, Bt - o, wr).concat(Bt);
                    return function(Ur) {
                        return vr.map(function(fi) {
                            return [
                                Ur,
                                fi
                            ];
                        });
                    };
                }
                function fa(gt, Bt, wr) {
                    var vr = t.range(gt, Bt - o, wr).concat(Bt);
                    return function(Ur) {
                        return vr.map(function(fi) {
                            return [
                                fi,
                                Ur
                            ];
                        });
                    };
                }
                function Qu() {
                    var gt, Bt, wr, vr, Ur, fi, xi, Fi, Xi = 10, hn = Xi, Ti = 90, qi = 360, Ii, mi, Pn, Ma, Ta = 2.5;
                    function Ea() {
                        return {
                            type: "MultiLineString",
                            coordinates: qa()
                        };
                    }
                    function qa() {
                        return t.range(E(vr / Ti) * Ti, wr, Ti).map(Pn).concat(t.range(E(Fi / qi) * qi, xi, qi).map(Ma)).concat(t.range(E(Bt / Xi) * Xi, gt, Xi).filter(function(Cn) {
                            return v(Cn % Ti) > o;
                        }).map(Ii)).concat(t.range(E(fi / hn) * hn, Ur, hn).filter(function(Cn) {
                            return v(Cn % qi) > o;
                        }).map(mi));
                    }
                    return Ea.lines = function() {
                        return qa().map(function(Cn) {
                            return {
                                type: "LineString",
                                coordinates: Cn
                            };
                        });
                    }, Ea.outline = function() {
                        return {
                            type: "Polygon",
                            coordinates: [
                                Pn(vr).concat(Ma(xi).slice(1), Pn(wr).reverse().slice(1), Ma(Fi).reverse().slice(1))
                            ]
                        };
                    }, Ea.extent = function(Cn) {
                        return arguments.length ? Ea.extentMajor(Cn).extentMinor(Cn) : Ea.extentMinor();
                    }, Ea.extentMajor = function(Cn) {
                        return arguments.length ? (vr = +Cn[0][0], wr = +Cn[1][0], Fi = +Cn[0][1], xi = +Cn[1][1], vr > wr && (Cn = vr, vr = wr, wr = Cn), Fi > xi && (Cn = Fi, Fi = xi, xi = Cn), Ea.precision(Ta)) : [
                            [
                                vr,
                                Fi
                            ],
                            [
                                wr,
                                xi
                            ]
                        ];
                    }, Ea.extentMinor = function(Cn) {
                        return arguments.length ? (Bt = +Cn[0][0], gt = +Cn[1][0], fi = +Cn[0][1], Ur = +Cn[1][1], Bt > gt && (Cn = Bt, Bt = gt, gt = Cn), fi > Ur && (Cn = fi, fi = Ur, Ur = Cn), Ea.precision(Ta)) : [
                            [
                                Bt,
                                fi
                            ],
                            [
                                gt,
                                Ur
                            ]
                        ];
                    }, Ea.step = function(Cn) {
                        return arguments.length ? Ea.stepMajor(Cn).stepMinor(Cn) : Ea.stepMinor();
                    }, Ea.stepMajor = function(Cn) {
                        return arguments.length ? (Ti = +Cn[0], qi = +Cn[1], Ea) : [
                            Ti,
                            qi
                        ];
                    }, Ea.stepMinor = function(Cn) {
                        return arguments.length ? (Xi = +Cn[0], hn = +Cn[1], Ea) : [
                            Xi,
                            hn
                        ];
                    }, Ea.precision = function(Cn) {
                        return arguments.length ? (Ta = +Cn, Ii = on(fi, Ur, 90), mi = fa(Bt, gt, Ta), Pn = on(Fi, xi, 90), Ma = fa(vr, wr, Ta), Ea) : Ta;
                    }, Ea.extentMajor([
                        [
                            -180,
                            -90 + o
                        ],
                        [
                            180,
                            90 - o
                        ]
                    ]).extentMinor([
                        [
                            -180,
                            -80 - o
                        ],
                        [
                            180,
                            80 + o
                        ]
                    ]);
                }
                function Rl() {
                    return Qu()();
                }
                function vo(gt, Bt) {
                    var wr = gt[0] * d, vr = gt[1] * d, Ur = Bt[0] * d, fi = Bt[1] * d, xi = p(vr), Fi = _(vr), Xi = p(fi), hn = _(fi), Ti = xi * p(wr), qi = xi * _(wr), Ii = Xi * p(Ur), mi = Xi * _(Ur), Pn = 2 * T(M(F(fi - vr) + xi * Xi * F(Ur - wr))), Ma = _(Pn), Ta = Pn ? function(Ea) {
                        var qa = _(Ea *= Pn) / Ma, Cn = _(Pn - Ea) / Ma, sn = Cn * Ti + qa * Ii, Ua = Cn * qi + qa * mi, mo = Cn * Fi + qa * hn;
                        return [
                            b(Ua, sn) * h,
                            b(mo, M(sn * sn + Ua * Ua)) * h
                        ];
                    } : function() {
                        return [
                            wr * h,
                            vr * h
                        ];
                    };
                    return Ta.distance = Pn, Ta;
                }
                function Zl(gt) {
                    return gt;
                }
                var Ks = r(), Xl = r(), Ec, Zn, ko, Co, Tl = {
                    point: q,
                    lineStart: q,
                    lineEnd: q,
                    polygonStart: function() {
                        Tl.lineStart = uf, Tl.lineEnd = rh;
                    },
                    polygonEnd: function() {
                        Tl.lineStart = Tl.lineEnd = Tl.point = q, Ks.add(v(Xl)), Xl.reset();
                    },
                    result: function() {
                        var gt = Ks / 2;
                        return Ks.reset(), gt;
                    }
                };
                function uf() {
                    Tl.point = So;
                }
                function So(gt, Bt) {
                    Tl.point = cf, Ec = ko = gt, Zn = Co = Bt;
                }
                function cf(gt, Bt) {
                    Xl.add(Co * gt - ko * Bt), ko = gt, Co = Bt;
                }
                function rh() {
                    cf(Ec, Zn);
                }
                var Al = 1 / 0, Hc = Al, eu = -Al, Ls = eu, mu = {
                    point: kc,
                    lineStart: q,
                    lineEnd: q,
                    polygonStart: q,
                    polygonEnd: q,
                    result: function() {
                        var gt = [
                            [
                                Al,
                                Hc
                            ],
                            [
                                eu,
                                Ls
                            ]
                        ];
                        return eu = Ls = -(Hc = Al = 1 / 0), gt;
                    }
                };
                function kc(gt, Bt) {
                    gt < Al && (Al = gt), gt > eu && (eu = gt), Bt < Hc && (Hc = Bt), Bt > Ls && (Ls = Bt);
                }
                var Of = 0, Gc = 0, vd = 0, Bf = 0, ss = 0, ff = 0, ih = 0, Vl = 0, Js = 0, hc, Cc, ws, $s, hs = {
                    point: Ms,
                    lineStart: dc,
                    lineEnd: Ps,
                    polygonStart: function() {
                        hs.lineStart = ov, hs.lineEnd = wo;
                    },
                    polygonEnd: function() {
                        hs.point = Ms, hs.lineStart = dc, hs.lineEnd = Ps;
                    },
                    result: function() {
                        var gt = Js ? [
                            ih / Js,
                            Vl / Js
                        ] : ff ? [
                            Bf / ff,
                            ss / ff
                        ] : vd ? [
                            Of / vd,
                            Gc / vd
                        ] : [
                            NaN,
                            NaN
                        ];
                        return Of = Gc = vd = Bf = ss = ff = ih = Vl = Js = 0, gt;
                    }
                };
                function Ms(gt, Bt) {
                    Of += gt, Gc += Bt, ++vd;
                }
                function dc() {
                    hs.point = Sl;
                }
                function Sl(gt, Bt) {
                    hs.point = ec, Ms(ws = gt, $s = Bt);
                }
                function ec(gt, Bt) {
                    var wr = gt - ws, vr = Bt - $s, Ur = M(wr * wr + vr * vr);
                    Bf += Ur * (ws + gt) / 2, ss += Ur * ($s + Bt) / 2, ff += Ur, Ms(ws = gt, $s = Bt);
                }
                function Ps() {
                    hs.point = Ms;
                }
                function ov() {
                    hs.point = Od;
                }
                function wo() {
                    $o(hc, Cc);
                }
                function Od(gt, Bt) {
                    hs.point = $o, Ms(hc = ws = gt, Cc = $s = Bt);
                }
                function $o(gt, Bt) {
                    var wr = gt - ws, vr = Bt - $s, Ur = M(wr * wr + vr * vr);
                    Bf += Ur * (ws + gt) / 2, ss += Ur * ($s + Bt) / 2, ff += Ur, Ur = $s * gt - ws * Bt, ih += Ur * (ws + gt), Vl += Ur * ($s + Bt), Js += Ur * 3, Ms(ws = gt, $s = Bt);
                }
                function Ja(gt) {
                    this._context = gt;
                }
                Ja.prototype = {
                    _radius: 4.5,
                    pointRadius: function(gt) {
                        return this._radius = gt, this;
                    },
                    polygonStart: function() {
                        this._line = 0;
                    },
                    polygonEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._point = 0;
                    },
                    lineEnd: function() {
                        this._line === 0 && this._context.closePath(), this._point = NaN;
                    },
                    point: function(gt, Bt) {
                        switch(this._point){
                            case 0:
                                this._context.moveTo(gt, Bt), this._point = 1;
                                break;
                            case 1:
                                this._context.lineTo(gt, Bt);
                                break;
                            default:
                                this._context.moveTo(gt + this._radius, Bt), this._context.arc(gt, Bt, this._radius, 0, f);
                                break;
                        }
                    },
                    result: q
                };
                var Ef = r(), tc, uu, Mh, jc, kf, Ml = {
                    point: q,
                    lineStart: function() {
                        Ml.point = Yh;
                    },
                    lineEnd: function() {
                        tc && Eh(uu, Mh), Ml.point = q;
                    },
                    polygonStart: function() {
                        tc = !0;
                    },
                    polygonEnd: function() {
                        tc = null;
                    },
                    result: function() {
                        var gt = +Ef;
                        return Ef.reset(), gt;
                    }
                };
                function Yh(gt, Bt) {
                    Ml.point = Eh, uu = jc = gt, Mh = kf = Bt;
                }
                function Eh(gt, Bt) {
                    jc -= gt, kf -= Bt, Ef.add(M(jc * jc + kf * kf)), jc = gt, kf = Bt;
                }
                function nh() {
                    this._string = [];
                }
                nh.prototype = {
                    _radius: 4.5,
                    _circle: hf(4.5),
                    pointRadius: function(gt) {
                        return (gt = +gt) !== this._radius && (this._radius = gt, this._circle = null), this;
                    },
                    polygonStart: function() {
                        this._line = 0;
                    },
                    polygonEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._point = 0;
                    },
                    lineEnd: function() {
                        this._line === 0 && this._string.push("Z"), this._point = NaN;
                    },
                    point: function(gt, Bt) {
                        switch(this._point){
                            case 0:
                                this._string.push("M", gt, ",", Bt), this._point = 1;
                                break;
                            case 1:
                                this._string.push("L", gt, ",", Bt);
                                break;
                            default:
                                this._circle == null && (this._circle = hf(this._radius)), this._string.push("M", gt, ",", Bt, this._circle);
                                break;
                        }
                    },
                    result: function() {
                        if (this._string.length) {
                            var gt = this._string.join("");
                            return this._string = [], gt;
                        } else return null;
                    }
                };
                function hf(gt) {
                    return "m0," + gt + "a" + gt + "," + gt + " 0 1,1 0," + -2 * gt + "a" + gt + "," + gt + " 0 1,1 0," + 2 * gt + "z";
                }
                function kh(gt, Bt) {
                    var wr = 4.5, vr, Ur;
                    function fi(xi) {
                        return xi && (typeof wr == "function" && Ur.pointRadius(+wr.apply(this, arguments)), W(xi, vr(Ur))), Ur.result();
                    }
                    return fi.area = function(xi) {
                        return W(xi, vr(Tl)), Tl.result();
                    }, fi.measure = function(xi) {
                        return W(xi, vr(Ml)), Ml.result();
                    }, fi.bounds = function(xi) {
                        return W(xi, vr(mu)), mu.result();
                    }, fi.centroid = function(xi) {
                        return W(xi, vr(hs)), hs.result();
                    }, fi.projection = function(xi) {
                        return arguments.length ? (vr = xi == null ? (gt = null, Zl) : (gt = xi).stream, fi) : gt;
                    }, fi.context = function(xi) {
                        return arguments.length ? (Ur = xi == null ? (Bt = null, new nh) : new Ja(Bt = xi), typeof wr != "function" && Ur.pointRadius(wr), fi) : Bt;
                    }, fi.pointRadius = function(xi) {
                        return arguments.length ? (wr = typeof xi == "function" ? xi : (Ur.pointRadius(+xi), +xi), fi) : wr;
                    }, fi.projection(gt).context(Bt);
                }
                function Kh(gt) {
                    return {
                        stream: rc(gt)
                    };
                }
                function rc(gt) {
                    return function(Bt) {
                        var wr = new ah;
                        for(var vr in gt)wr[vr] = gt[vr];
                        return wr.stream = Bt, wr;
                    };
                }
                function ah() {}
                ah.prototype = {
                    constructor: ah,
                    point: function(gt, Bt) {
                        this.stream.point(gt, Bt);
                    },
                    sphere: function() {
                        this.stream.sphere();
                    },
                    lineStart: function() {
                        this.stream.lineStart();
                    },
                    lineEnd: function() {
                        this.stream.lineEnd();
                    },
                    polygonStart: function() {
                        this.stream.polygonStart();
                    },
                    polygonEnd: function() {
                        this.stream.polygonEnd();
                    }
                };
                function Wc(gt, Bt, wr) {
                    var vr = gt.clipExtent && gt.clipExtent();
                    return gt.scale(150).translate([
                        0,
                        0
                    ]), vr != null && gt.clipExtent(null), W(wr, gt.stream(mu)), Bt(mu.result()), vr != null && gt.clipExtent(vr), gt;
                }
                function df(gt, Bt, wr) {
                    return Wc(gt, function(vr) {
                        var Ur = Bt[1][0] - Bt[0][0], fi = Bt[1][1] - Bt[0][1], xi = Math.min(Ur / (vr[1][0] - vr[0][0]), fi / (vr[1][1] - vr[0][1])), Fi = +Bt[0][0] + (Ur - xi * (vr[1][0] + vr[0][0])) / 2, Xi = +Bt[0][1] + (fi - xi * (vr[1][1] + vr[0][1])) / 2;
                        gt.scale(150 * xi).translate([
                            Fi,
                            Xi
                        ]);
                    }, wr);
                }
                function Cu(gt, Bt, wr) {
                    return df(gt, [
                        [
                            0,
                            0
                        ],
                        Bt
                    ], wr);
                }
                function Nf(gt, Bt, wr) {
                    return Wc(gt, function(vr) {
                        var Ur = +Bt, fi = Ur / (vr[1][0] - vr[0][0]), xi = (Ur - fi * (vr[1][0] + vr[0][0])) / 2, Fi = -fi * vr[0][1];
                        gt.scale(150 * fi).translate([
                            xi,
                            Fi
                        ]);
                    }, wr);
                }
                function Zc(gt, Bt, wr) {
                    return Wc(gt, function(vr) {
                        var Ur = +Bt, fi = Ur / (vr[1][1] - vr[0][1]), xi = -fi * vr[0][0], Fi = (Ur - fi * (vr[1][1] + vr[0][1])) / 2;
                        gt.scale(150 * fi).translate([
                            xi,
                            Fi
                        ]);
                    }, wr);
                }
                var ds = 16, Ch = p(30 * d);
                function Bd(gt, Bt) {
                    return +Bt ? Cf(gt, Bt) : Jh(gt);
                }
                function Jh(gt) {
                    return rc({
                        point: function(Bt, wr) {
                            Bt = gt(Bt, wr), this.stream.point(Bt[0], Bt[1]);
                        }
                    });
                }
                function Cf(gt, Bt) {
                    function wr(vr, Ur, fi, xi, Fi, Xi, hn, Ti, qi, Ii, mi, Pn, Ma, Ta) {
                        var Ea = hn - vr, qa = Ti - Ur, Cn = Ea * Ea + qa * qa;
                        if (Cn > 4 * Bt && Ma--) {
                            var sn = xi + Ii, Ua = Fi + mi, mo = Xi + Pn, Xo = M(sn * sn + Ua * Ua + mo * mo), Ts = T(mo /= Xo), Qo = v(v(mo) - 1) < o || v(fi - qi) < o ? (fi + qi) / 2 : b(Ua, sn), ys = gt(Qo, Ts), Bo = ys[0], yl = ys[1], Gs = Bo - vr, Rs = yl - Ur, ia = qa * Gs - Ea * Rs;
                            (ia * ia / Cn > Bt || v((Ea * Gs + qa * Rs) / Cn - .5) > .3 || xi * Ii + Fi * mi + Xi * Pn < Ch) && (wr(vr, Ur, fi, xi, Fi, Xi, Bo, yl, Qo, sn /= Xo, Ua /= Xo, mo, Ma, Ta), Ta.point(Bo, yl), wr(Bo, yl, Qo, sn, Ua, mo, hn, Ti, qi, Ii, mi, Pn, Ma, Ta));
                        }
                    }
                    return function(vr) {
                        var Ur, fi, xi, Fi, Xi, hn, Ti, qi, Ii, mi, Pn, Ma, Ta = {
                            point: Ea,
                            lineStart: qa,
                            lineEnd: sn,
                            polygonStart: function() {
                                vr.polygonStart(), Ta.lineStart = Ua;
                            },
                            polygonEnd: function() {
                                vr.polygonEnd(), Ta.lineStart = qa;
                            }
                        };
                        function Ea(Ts, Qo) {
                            Ts = gt(Ts, Qo), vr.point(Ts[0], Ts[1]);
                        }
                        function qa() {
                            qi = NaN, Ta.point = Cn, vr.lineStart();
                        }
                        function Cn(Ts, Qo) {
                            var ys = ce([
                                Ts,
                                Qo
                            ]), Bo = gt(Ts, Qo);
                            wr(qi, Ii, Ti, mi, Pn, Ma, qi = Bo[0], Ii = Bo[1], Ti = Ts, mi = ys[0], Pn = ys[1], Ma = ys[2], ds, vr), vr.point(qi, Ii);
                        }
                        function sn() {
                            Ta.point = Ea, vr.lineEnd();
                        }
                        function Ua() {
                            qa(), Ta.point = mo, Ta.lineEnd = Xo;
                        }
                        function mo(Ts, Qo) {
                            Cn(Ur = Ts, Qo), fi = qi, xi = Ii, Fi = mi, Xi = Pn, hn = Ma, Ta.point = Cn;
                        }
                        function Xo() {
                            wr(qi, Ii, Ti, mi, Pn, Ma, fi, xi, Ur, Fi, Xi, hn, ds, vr), Ta.lineEnd = sn, sn();
                        }
                        return Ta;
                    };
                }
                var pd = rc({
                    point: function(gt, Bt) {
                        this.stream.point(gt * d, Bt * d);
                    }
                });
                function Lu(gt) {
                    return rc({
                        point: function(Bt, wr) {
                            var vr = gt(Bt, wr);
                            return this.stream.point(vr[0], vr[1]);
                        }
                    });
                }
                function $h(gt, Bt, wr, vr, Ur) {
                    function fi(xi, Fi) {
                        return xi *= vr, Fi *= Ur, [
                            Bt + gt * xi,
                            wr - gt * Fi
                        ];
                    }
                    return fi.invert = function(xi, Fi) {
                        return [
                            (xi - Bt) / gt * vr,
                            (wr - Fi) / gt * Ur
                        ];
                    }, fi;
                }
                function tu(gt, Bt, wr, vr, Ur, fi) {
                    var xi = p(fi), Fi = _(fi), Xi = xi * gt, hn = Fi * gt, Ti = xi / gt, qi = Fi / gt, Ii = (Fi * wr - xi * Bt) / gt, mi = (Fi * Bt + xi * wr) / gt;
                    function Pn(Ma, Ta) {
                        return Ma *= vr, Ta *= Ur, [
                            Xi * Ma - hn * Ta + Bt,
                            wr - hn * Ma - Xi * Ta
                        ];
                    }
                    return Pn.invert = function(Ma, Ta) {
                        return [
                            vr * (Ti * Ma - qi * Ta + Ii),
                            Ur * (mi - qi * Ma - Ti * Ta)
                        ];
                    }, Pn;
                }
                function Pu(gt) {
                    return Lc(function() {
                        return gt;
                    })();
                }
                function Lc(gt) {
                    var Bt, wr = 150, vr = 480, Ur = 250, fi = 0, xi = 0, Fi = 0, Xi = 0, hn = 0, Ti, qi = 0, Ii = 1, mi = 1, Pn = null, Ma = Hr, Ta = null, Ea, qa, Cn, sn = Zl, Ua = .5, mo, Xo, Ts, Qo, ys;
                    function Bo(ia) {
                        return Ts(ia[0] * d, ia[1] * d);
                    }
                    function yl(ia) {
                        return ia = Ts.invert(ia[0], ia[1]), ia && [
                            ia[0] * h,
                            ia[1] * h
                        ];
                    }
                    Bo.stream = function(ia) {
                        return Qo && ys === ia ? Qo : Qo = pd(Lu(Ti)(Ma(mo(sn(ys = ia)))));
                    }, Bo.preclip = function(ia) {
                        return arguments.length ? (Ma = ia, Pn = void 0, Rs()) : Ma;
                    }, Bo.postclip = function(ia) {
                        return arguments.length ? (sn = ia, Ta = Ea = qa = Cn = null, Rs()) : sn;
                    }, Bo.clipAngle = function(ia) {
                        return arguments.length ? (Ma = +ia ? an(Pn = ia * d) : (Pn = null, Hr), Rs()) : Pn * h;
                    }, Bo.clipExtent = function(ia) {
                        return arguments.length ? (sn = ia == null ? (Ta = Ea = qa = Cn = null, Zl) : Fn(Ta = +ia[0][0], Ea = +ia[0][1], qa = +ia[1][0], Cn = +ia[1][1]), Rs()) : Ta == null ? null : [
                            [
                                Ta,
                                Ea
                            ],
                            [
                                qa,
                                Cn
                            ]
                        ];
                    }, Bo.scale = function(ia) {
                        return arguments.length ? (wr = +ia, Gs()) : wr;
                    }, Bo.translate = function(ia) {
                        return arguments.length ? (vr = +ia[0], Ur = +ia[1], Gs()) : [
                            vr,
                            Ur
                        ];
                    }, Bo.center = function(ia) {
                        return arguments.length ? (fi = ia[0] % 360 * d, xi = ia[1] % 360 * d, Gs()) : [
                            fi * h,
                            xi * h
                        ];
                    }, Bo.rotate = function(ia) {
                        return arguments.length ? (Fi = ia[0] % 360 * d, Xi = ia[1] % 360 * d, hn = ia.length > 2 ? ia[2] % 360 * d : 0, Gs()) : [
                            Fi * h,
                            Xi * h,
                            hn * h
                        ];
                    }, Bo.angle = function(ia) {
                        return arguments.length ? (qi = ia % 360 * d, Gs()) : qi * h;
                    }, Bo.reflectX = function(ia) {
                        return arguments.length ? (Ii = ia ? -1 : 1, Gs()) : Ii < 0;
                    }, Bo.reflectY = function(ia) {
                        return arguments.length ? (mi = ia ? -1 : 1, Gs()) : mi < 0;
                    }, Bo.precision = function(ia) {
                        return arguments.length ? (mo = Bd(Xo, Ua = ia * ia), Rs()) : M(Ua);
                    }, Bo.fitExtent = function(ia, Ka) {
                        return df(Bo, ia, Ka);
                    }, Bo.fitSize = function(ia, Ka) {
                        return Cu(Bo, ia, Ka);
                    }, Bo.fitWidth = function(ia, Ka) {
                        return Nf(Bo, ia, Ka);
                    }, Bo.fitHeight = function(ia, Ka) {
                        return Zc(Bo, ia, Ka);
                    };
                    function Gs() {
                        var ia = tu(wr, 0, 0, Ii, mi, qi).apply(null, Bt(fi, xi)), Ka = (qi ? tu : $h)(wr, vr - ia[0], Ur - ia[1], Ii, mi, qi);
                        return Ti = gi(Fi, Xi, hn), Xo = Zr(Bt, Ka), Ts = Zr(Ti, Xo), mo = Bd(Xo, Ua), Rs();
                    }
                    function Rs() {
                        return Qo = ys = null, Bo;
                    }
                    return function() {
                        return Bt = gt.apply(this, arguments), Bo.invert = Bt.invert && yl, Gs();
                    };
                }
                function fl(gt) {
                    var Bt = 0, wr = l / 3, vr = Lc(gt), Ur = vr(Bt, wr);
                    return Ur.parallels = function(fi) {
                        return arguments.length ? vr(Bt = fi[0] * d, wr = fi[1] * d) : [
                            Bt * h,
                            wr * h
                        ];
                    }, Ur;
                }
                function Xc(gt) {
                    var Bt = p(gt);
                    function wr(vr, Ur) {
                        return [
                            vr * Bt,
                            _(Ur) / Bt
                        ];
                    }
                    return wr.invert = function(vr, Ur) {
                        return [
                            vr / Bt,
                            T(Ur * Bt)
                        ];
                    }, wr;
                }
                function ic(gt, Bt) {
                    var wr = _(gt), vr = (wr + _(Bt)) / 2;
                    if (v(vr) < o) return Xc(gt);
                    var Ur = 1 + wr * (2 * vr - wr), fi = M(Ur) / vr;
                    function xi(Fi, Xi) {
                        var hn = M(Ur - 2 * vr * _(Xi)) / vr;
                        return [
                            hn * _(Fi *= vr),
                            fi - hn * p(Fi)
                        ];
                    }
                    return xi.invert = function(Fi, Xi) {
                        var hn = fi - Xi, Ti = b(Fi, v(hn)) * C(hn);
                        return hn * vr < 0 && (Ti -= l * C(Fi) * C(hn)), [
                            Ti / vr,
                            T((Ur - (Fi * Fi + hn * hn) * vr * vr) / (2 * vr))
                        ];
                    }, xi;
                }
                function yu() {
                    return fl(ic).scale(155.424).center([
                        0,
                        33.6442
                    ]);
                }
                function Qs() {
                    return yu().parallels([
                        29.5,
                        45.5
                    ]).scale(1070).translate([
                        480,
                        250
                    ]).rotate([
                        96,
                        0
                    ]).center([
                        -0.6,
                        38.7
                    ]);
                }
                function Qh(gt) {
                    var Bt = gt.length;
                    return {
                        point: function(wr, vr) {
                            for(var Ur = -1; ++Ur < Bt;)gt[Ur].point(wr, vr);
                        },
                        sphere: function() {
                            for(var wr = -1; ++wr < Bt;)gt[wr].sphere();
                        },
                        lineStart: function() {
                            for(var wr = -1; ++wr < Bt;)gt[wr].lineStart();
                        },
                        lineEnd: function() {
                            for(var wr = -1; ++wr < Bt;)gt[wr].lineEnd();
                        },
                        polygonStart: function() {
                            for(var wr = -1; ++wr < Bt;)gt[wr].polygonStart();
                        },
                        polygonEnd: function() {
                            for(var wr = -1; ++wr < Bt;)gt[wr].polygonEnd();
                        }
                    };
                }
                function gd() {
                    var gt, Bt, wr = Qs(), vr, Ur = yu().rotate([
                        154,
                        0
                    ]).center([
                        -2,
                        58.5
                    ]).parallels([
                        55,
                        65
                    ]), fi, xi = yu().rotate([
                        157,
                        0
                    ]).center([
                        -3,
                        19.9
                    ]).parallels([
                        8,
                        18
                    ]), Fi, Xi, hn = {
                        point: function(Ii, mi) {
                            Xi = [
                                Ii,
                                mi
                            ];
                        }
                    };
                    function Ti(Ii) {
                        var mi = Ii[0], Pn = Ii[1];
                        return Xi = null, vr.point(mi, Pn), Xi || (fi.point(mi, Pn), Xi) || (Fi.point(mi, Pn), Xi);
                    }
                    Ti.invert = function(Ii) {
                        var mi = wr.scale(), Pn = wr.translate(), Ma = (Ii[0] - Pn[0]) / mi, Ta = (Ii[1] - Pn[1]) / mi;
                        return (Ta >= .12 && Ta < .234 && Ma >= -0.425 && Ma < -0.214 ? Ur : Ta >= .166 && Ta < .234 && Ma >= -0.214 && Ma < -0.115 ? xi : wr).invert(Ii);
                    }, Ti.stream = function(Ii) {
                        return gt && Bt === Ii ? gt : gt = Qh([
                            wr.stream(Bt = Ii),
                            Ur.stream(Ii),
                            xi.stream(Ii)
                        ]);
                    }, Ti.precision = function(Ii) {
                        return arguments.length ? (wr.precision(Ii), Ur.precision(Ii), xi.precision(Ii), qi()) : wr.precision();
                    }, Ti.scale = function(Ii) {
                        return arguments.length ? (wr.scale(Ii), Ur.scale(Ii * .35), xi.scale(Ii), Ti.translate(wr.translate())) : wr.scale();
                    }, Ti.translate = function(Ii) {
                        if (!arguments.length) return wr.translate();
                        var mi = wr.scale(), Pn = +Ii[0], Ma = +Ii[1];
                        return vr = wr.translate(Ii).clipExtent([
                            [
                                Pn - .455 * mi,
                                Ma - .238 * mi
                            ],
                            [
                                Pn + .455 * mi,
                                Ma + .238 * mi
                            ]
                        ]).stream(hn), fi = Ur.translate([
                            Pn - .307 * mi,
                            Ma + .201 * mi
                        ]).clipExtent([
                            [
                                Pn - .425 * mi + o,
                                Ma + .12 * mi + o
                            ],
                            [
                                Pn - .214 * mi - o,
                                Ma + .234 * mi - o
                            ]
                        ]).stream(hn), Fi = xi.translate([
                            Pn - .205 * mi,
                            Ma + .212 * mi
                        ]).clipExtent([
                            [
                                Pn - .214 * mi + o,
                                Ma + .166 * mi + o
                            ],
                            [
                                Pn - .115 * mi - o,
                                Ma + .234 * mi - o
                            ]
                        ]).stream(hn), qi();
                    }, Ti.fitExtent = function(Ii, mi) {
                        return df(Ti, Ii, mi);
                    }, Ti.fitSize = function(Ii, mi) {
                        return Cu(Ti, Ii, mi);
                    }, Ti.fitWidth = function(Ii, mi) {
                        return Nf(Ti, Ii, mi);
                    }, Ti.fitHeight = function(Ii, mi) {
                        return Zc(Ti, Ii, mi);
                    };
                    function qi() {
                        return gt = Bt = null, Ti;
                    }
                    return Ti.scale(1070);
                }
                function Gu(gt) {
                    return function(Bt, wr) {
                        var vr = p(Bt), Ur = p(wr), fi = gt(vr * Ur);
                        return [
                            fi * Ur * _(Bt),
                            fi * _(wr)
                        ];
                    };
                }
                function Pc(gt) {
                    return function(Bt, wr) {
                        var vr = M(Bt * Bt + wr * wr), Ur = gt(vr), fi = _(Ur), xi = p(Ur);
                        return [
                            b(Bt * fi, vr * xi),
                            T(vr && wr * fi / vr)
                        ];
                    };
                }
                var vc = Gu(function(gt) {
                    return M(2 / (1 + gt));
                });
                vc.invert = Pc(function(gt) {
                    return 2 * T(gt / 2);
                });
                function sv() {
                    return Pu(vc).scale(124.75).clipAngle(179.999);
                }
                var Lf = Gu(function(gt) {
                    return (gt = P(gt)) && gt / _(gt);
                });
                Lf.invert = Pc(function(gt) {
                    return gt;
                });
                function Uf() {
                    return Pu(Lf).scale(79.4188).clipAngle(179.999);
                }
                function Iu(gt, Bt) {
                    return [
                        gt,
                        A(g((u + Bt) / 2))
                    ];
                }
                Iu.invert = function(gt, Bt) {
                    return [
                        gt,
                        2 * x(k(Bt)) - u
                    ];
                };
                function oh() {
                    return ru(Iu).scale(961 / f);
                }
                function ru(gt) {
                    var Bt = Pu(gt), wr = Bt.center, vr = Bt.scale, Ur = Bt.translate, fi = Bt.clipExtent, xi = null, Fi, Xi, hn;
                    Bt.scale = function(qi) {
                        return arguments.length ? (vr(qi), Ti()) : vr();
                    }, Bt.translate = function(qi) {
                        return arguments.length ? (Ur(qi), Ti()) : Ur();
                    }, Bt.center = function(qi) {
                        return arguments.length ? (wr(qi), Ti()) : wr();
                    }, Bt.clipExtent = function(qi) {
                        return arguments.length ? (qi == null ? xi = Fi = Xi = hn = null : (xi = +qi[0][0], Fi = +qi[0][1], Xi = +qi[1][0], hn = +qi[1][1]), Ti()) : xi == null ? null : [
                            [
                                xi,
                                Fi
                            ],
                            [
                                Xi,
                                hn
                            ]
                        ];
                    };
                    function Ti() {
                        var qi = l * vr(), Ii = Bt(Gi(Bt.rotate()).invert([
                            0,
                            0
                        ]));
                        return fi(xi == null ? [
                            [
                                Ii[0] - qi,
                                Ii[1] - qi
                            ],
                            [
                                Ii[0] + qi,
                                Ii[1] + qi
                            ]
                        ] : gt === Iu ? [
                            [
                                Math.max(Ii[0] - qi, xi),
                                Fi
                            ],
                            [
                                Math.min(Ii[0] + qi, Xi),
                                hn
                            ]
                        ] : [
                            [
                                xi,
                                Math.max(Ii[1] - qi, Fi)
                            ],
                            [
                                Xi,
                                Math.min(Ii[1] + qi, hn)
                            ]
                        ]);
                    }
                    return Ti();
                }
                function vf(gt) {
                    return g((u + gt) / 2);
                }
                function md(gt, Bt) {
                    var wr = p(gt), vr = gt === Bt ? _(gt) : A(wr / p(Bt)) / A(vf(Bt) / vf(gt)), Ur = wr * L(vf(gt), vr) / vr;
                    if (!vr) return Iu;
                    function fi(xi, Fi) {
                        Ur > 0 ? Fi < -u + o && (Fi = -u + o) : Fi > u - o && (Fi = u - o);
                        var Xi = Ur / L(vf(Fi), vr);
                        return [
                            Xi * _(vr * xi),
                            Ur - Xi * p(vr * xi)
                        ];
                    }
                    return fi.invert = function(xi, Fi) {
                        var Xi = Ur - Fi, hn = C(vr) * M(xi * xi + Xi * Xi), Ti = b(xi, v(Xi)) * C(Xi);
                        return Xi * vr < 0 && (Ti -= l * C(xi) * C(Xi)), [
                            Ti / vr,
                            2 * x(L(Ur / hn, 1 / vr)) - u
                        ];
                    }, fi;
                }
                function sh() {
                    return fl(md).scale(109.5).parallels([
                        30,
                        30
                    ]);
                }
                function Fs(gt, Bt) {
                    return [
                        gt,
                        Bt
                    ];
                }
                Fs.invert = Fs;
                function _u() {
                    return Pu(Fs).scale(152.63);
                }
                function xu(gt, Bt) {
                    var wr = p(gt), vr = gt === Bt ? _(gt) : (wr - p(Bt)) / (Bt - gt), Ur = wr / vr + gt;
                    if (v(vr) < o) return Fs;
                    function fi(xi, Fi) {
                        var Xi = Ur - Fi, hn = vr * xi;
                        return [
                            Xi * _(hn),
                            Ur - Xi * p(hn)
                        ];
                    }
                    return fi.invert = function(xi, Fi) {
                        var Xi = Ur - Fi, hn = b(xi, v(Xi)) * C(Xi);
                        return Xi * vr < 0 && (hn -= l * C(xi) * C(Xi)), [
                            hn / vr,
                            Ur - C(vr) * M(xi * xi + Xi * Xi)
                        ];
                    }, fi;
                }
                function Lh() {
                    return fl(xu).scale(131.154).center([
                        0,
                        13.9389
                    ]);
                }
                var Is = 1.340264, Pf = -0.081106, Ic = 893e-6, ju = .003796, Vf = M(3) / 2, pc = 12;
                function pf(gt, Bt) {
                    var wr = T(Vf * _(Bt)), vr = wr * wr, Ur = vr * vr * vr;
                    return [
                        gt * p(wr) / (Vf * (Is + 3 * Pf * vr + Ur * (7 * Ic + 9 * ju * vr))),
                        wr * (Is + Pf * vr + Ur * (Ic + ju * vr))
                    ];
                }
                pf.invert = function(gt, Bt) {
                    for(var wr = Bt, vr = wr * wr, Ur = vr * vr * vr, fi = 0, xi, Fi, Xi; fi < pc && (Fi = wr * (Is + Pf * vr + Ur * (Ic + ju * vr)) - Bt, Xi = Is + 3 * Pf * vr + Ur * (7 * Ic + 9 * ju * vr), wr -= xi = Fi / Xi, vr = wr * wr, Ur = vr * vr * vr, !(v(xi) < s)); ++fi);
                    return [
                        Vf * gt * (Is + 3 * Pf * vr + Ur * (7 * Ic + 9 * ju * vr)) / p(wr),
                        T(_(wr) / Vf)
                    ];
                };
                function Ph() {
                    return Pu(pf).scale(177.158);
                }
                function Dl(gt, Bt) {
                    var wr = p(Bt), vr = p(gt) * wr;
                    return [
                        wr * _(gt) / vr,
                        _(Bt) / vr
                    ];
                }
                Dl.invert = Pc(x);
                function Ih() {
                    return Pu(Dl).scale(144.049).clipAngle(60);
                }
                function Wu() {
                    var gt = 1, Bt = 0, wr = 0, vr = 1, Ur = 1, fi = 0, xi, Fi, Xi = null, hn, Ti, qi, Ii = 1, mi = 1, Pn = rc({
                        point: function(sn, Ua) {
                            var mo = Cn([
                                sn,
                                Ua
                            ]);
                            this.stream.point(mo[0], mo[1]);
                        }
                    }), Ma = Zl, Ta, Ea;
                    function qa() {
                        return Ii = gt * vr, mi = gt * Ur, Ta = Ea = null, Cn;
                    }
                    function Cn(sn) {
                        var Ua = sn[0] * Ii, mo = sn[1] * mi;
                        if (fi) {
                            var Xo = mo * xi - Ua * Fi;
                            Ua = Ua * xi + mo * Fi, mo = Xo;
                        }
                        return [
                            Ua + Bt,
                            mo + wr
                        ];
                    }
                    return Cn.invert = function(sn) {
                        var Ua = sn[0] - Bt, mo = sn[1] - wr;
                        if (fi) {
                            var Xo = mo * xi + Ua * Fi;
                            Ua = Ua * xi - mo * Fi, mo = Xo;
                        }
                        return [
                            Ua / Ii,
                            mo / mi
                        ];
                    }, Cn.stream = function(sn) {
                        return Ta && Ea === sn ? Ta : Ta = Pn(Ma(Ea = sn));
                    }, Cn.postclip = function(sn) {
                        return arguments.length ? (Ma = sn, Xi = hn = Ti = qi = null, qa()) : Ma;
                    }, Cn.clipExtent = function(sn) {
                        return arguments.length ? (Ma = sn == null ? (Xi = hn = Ti = qi = null, Zl) : Fn(Xi = +sn[0][0], hn = +sn[0][1], Ti = +sn[1][0], qi = +sn[1][1]), qa()) : Xi == null ? null : [
                            [
                                Xi,
                                hn
                            ],
                            [
                                Ti,
                                qi
                            ]
                        ];
                    }, Cn.scale = function(sn) {
                        return arguments.length ? (gt = +sn, qa()) : gt;
                    }, Cn.translate = function(sn) {
                        return arguments.length ? (Bt = +sn[0], wr = +sn[1], qa()) : [
                            Bt,
                            wr
                        ];
                    }, Cn.angle = function(sn) {
                        return arguments.length ? (fi = sn % 360 * d, Fi = _(fi), xi = p(fi), qa()) : fi * h;
                    }, Cn.reflectX = function(sn) {
                        return arguments.length ? (vr = sn ? -1 : 1, qa()) : vr < 0;
                    }, Cn.reflectY = function(sn) {
                        return arguments.length ? (Ur = sn ? -1 : 1, qa()) : Ur < 0;
                    }, Cn.fitExtent = function(sn, Ua) {
                        return df(Cn, sn, Ua);
                    }, Cn.fitSize = function(sn, Ua) {
                        return Cu(Cn, sn, Ua);
                    }, Cn.fitWidth = function(sn, Ua) {
                        return Nf(Cn, sn, Ua);
                    }, Cn.fitHeight = function(sn, Ua) {
                        return Zc(Cn, sn, Ua);
                    }, Cn;
                }
                function Rc(gt, Bt) {
                    var wr = Bt * Bt, vr = wr * wr;
                    return [
                        gt * (.8707 - .131979 * wr + vr * (-0.013791 + vr * (.003971 * wr - .001529 * vr))),
                        Bt * (1.007226 + wr * (.015085 + vr * (-0.044475 + .028874 * wr - .005916 * vr)))
                    ];
                }
                Rc.invert = function(gt, Bt) {
                    var wr = Bt, vr = 25, Ur;
                    do {
                        var fi = wr * wr, xi = fi * fi;
                        wr -= Ur = (wr * (1.007226 + fi * (.015085 + xi * (-0.044475 + .028874 * fi - .005916 * xi))) - Bt) / (1.007226 + fi * (0.045255 + xi * (-0.311325 + 0.259866 * fi - .005916 * 11 * xi)));
                    }while (v(Ur) > o && --vr > 0);
                    return [
                        gt / (.8707 + (fi = wr * wr) * (-0.131979 + fi * (-0.013791 + fi * fi * fi * (.003971 - .001529 * fi)))),
                        wr
                    ];
                };
                function gc() {
                    return Pu(Rc).scale(175.295);
                }
                function hl(gt, Bt) {
                    return [
                        p(Bt) * _(gt),
                        _(Bt)
                    ];
                }
                hl.invert = Pc(T);
                function iu() {
                    return Pu(hl).scale(249.5).clipAngle(90 + o);
                }
                function mc(gt, Bt) {
                    var wr = p(Bt), vr = 1 + p(gt) * wr;
                    return [
                        wr * _(gt) / vr,
                        _(Bt) / vr
                    ];
                }
                mc.invert = Pc(function(gt) {
                    return 2 * x(gt);
                });
                function Yc() {
                    return Pu(mc).scale(250).clipAngle(142);
                }
                function nc(gt, Bt) {
                    return [
                        A(g((u + Bt) / 2)),
                        -gt
                    ];
                }
                nc.invert = function(gt, Bt) {
                    return [
                        -Bt,
                        2 * x(k(gt)) - u
                    ];
                };
                function gf() {
                    var gt = ru(nc), Bt = gt.center, wr = gt.rotate;
                    return gt.center = function(vr) {
                        return arguments.length ? Bt([
                            -vr[1],
                            vr[0]
                        ]) : (vr = Bt(), [
                            vr[1],
                            -vr[0]
                        ]);
                    }, gt.rotate = function(vr) {
                        return arguments.length ? wr([
                            vr[0],
                            vr[1],
                            vr.length > 2 ? vr[2] + 90 : 90
                        ]) : (vr = wr(), [
                            vr[0],
                            vr[1],
                            vr[2] - 90
                        ]);
                    }, wr([
                        0,
                        0,
                        90
                    ]).scale(159.155);
                }
                e.geoAlbers = Qs, e.geoAlbersUsa = gd, e.geoArea = me, e.geoAzimuthalEqualArea = sv, e.geoAzimuthalEqualAreaRaw = vc, e.geoAzimuthalEquidistant = Uf, e.geoAzimuthalEquidistantRaw = Lf, e.geoBounds = Ne, e.geoCentroid = yr, e.geoCircle = jn, e.geoClipAntimeridian = Hr, e.geoClipCircle = an, e.geoClipExtent = Sa, e.geoClipRectangle = Fn, e.geoConicConformal = sh, e.geoConicConformalRaw = md, e.geoConicEqualArea = yu, e.geoConicEqualAreaRaw = ic, e.geoConicEquidistant = Lh, e.geoConicEquidistantRaw = xu, e.geoContains = ms, e.geoDistance = Cs, e.geoEqualEarth = Ph, e.geoEqualEarthRaw = pf, e.geoEquirectangular = _u, e.geoEquirectangularRaw = Fs, e.geoGnomonic = Ih, e.geoGnomonicRaw = Dl, e.geoGraticule = Qu, e.geoGraticule10 = Rl, e.geoIdentity = Wu, e.geoInterpolate = vo, e.geoLength = wl, e.geoMercator = oh, e.geoMercatorRaw = Iu, e.geoNaturalEarth1 = gc, e.geoNaturalEarth1Raw = Rc, e.geoOrthographic = iu, e.geoOrthographicRaw = hl, e.geoPath = kh, e.geoProjection = Pu, e.geoProjectionMutator = Lc, e.geoRotation = Gi, e.geoStereographic = Yc, e.geoStereographicRaw = mc, e.geoStream = W, e.geoTransform = Kh, e.geoTransverseMercator = gf, e.geoTransverseMercatorRaw = nc, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var bRe = ye((Az, xRe)=>{
            (function(e, t) {
                typeof Az == "object" && typeof xRe != "undefined" ? t(Az, xX(), $E()) : t(e.d3 = e.d3 || {}, e.d3, e.d3);
            })(Az, function(e, t, r) {
                "use strict";
                var n = Math.abs, i = Math.atan, a = Math.atan2, o = Math.cos, s = Math.exp, l = Math.floor, u = Math.log, c = Math.max, f = Math.min, h = Math.pow, d = Math.round, v = Math.sign || function(he) {
                    return he > 0 ? 1 : he < 0 ? -1 : 0;
                }, x = Math.sin, b = Math.tan, p = 1e-6, E = 1e-12, k = Math.PI, A = k / 2, L = k / 4, _ = Math.SQRT1_2, C = H(2), M = H(k), g = k * 2, P = 180 / k, T = k / 180;
                function F(he) {
                    return he ? he / Math.sin(he) : 1;
                }
                function q(he) {
                    return he > 1 ? A : he < -1 ? -A : Math.asin(he);
                }
                function V(he) {
                    return he > 1 ? 0 : he < -1 ? k : Math.acos(he);
                }
                function H(he) {
                    return he > 0 ? Math.sqrt(he) : 0;
                }
                function X(he) {
                    return he = s(2 * he), (he - 1) / (he + 1);
                }
                function G(he) {
                    return (s(he) - s(-he)) / 2;
                }
                function N(he) {
                    return (s(he) + s(-he)) / 2;
                }
                function W(he) {
                    return u(he + H(he * he + 1));
                }
                function re(he) {
                    return u(he + H(he * he - 1));
                }
                function ae(he) {
                    var be = b(he / 2), Pe = 2 * u(o(he / 2)) / (be * be);
                    function Oe(Je, He) {
                        var et = o(Je), Mt = o(He), Dt = x(He), Ut = Mt * et, tr = -((1 - Ut ? u((1 + Ut) / 2) / (1 - Ut) : -0.5) + Pe / (1 + Ut));
                        return [
                            tr * Mt * x(Je),
                            tr * Dt
                        ];
                    }
                    return Oe.invert = function(Je, He) {
                        var et = H(Je * Je + He * He), Mt = -he / 2, Dt = 50, Ut;
                        if (!et) return [
                            0,
                            0
                        ];
                        do {
                            var tr = Mt / 2, mr = o(tr), Rr = x(tr), zr = Rr / mr, Xr = -u(n(mr));
                            Mt -= Ut = (2 / zr * Xr - Pe * zr - et) / (-Xr / (Rr * Rr) + 1 - Pe / (2 * mr * mr)) * (mr < 0 ? .7 : 1);
                        }while (n(Ut) > p && --Dt > 0);
                        var di = x(Mt);
                        return [
                            a(Je * di, et * o(Mt)),
                            q(He * di / et)
                        ];
                    }, Oe;
                }
                function _e() {
                    var he = A, be = t.geoProjectionMutator(ae), Pe = be(he);
                    return Pe.radius = function(Oe) {
                        return arguments.length ? be(he = Oe * T) : he * P;
                    }, Pe.scale(179.976).clipAngle(147);
                }
                function Me(he, be) {
                    var Pe = o(be), Oe = F(V(Pe * o(he /= 2)));
                    return [
                        2 * Pe * x(he) * Oe,
                        x(be) * Oe
                    ];
                }
                Me.invert = function(he, be) {
                    if (!(he * he + 4 * be * be > k * k + p)) {
                        var Pe = he, Oe = be, Je = 25;
                        do {
                            var He = x(Pe), et = x(Pe / 2), Mt = o(Pe / 2), Dt = x(Oe), Ut = o(Oe), tr = x(2 * Oe), mr = Dt * Dt, Rr = Ut * Ut, zr = et * et, Xr = 1 - Rr * Mt * Mt, di = Xr ? V(Ut * Mt) * H(Li = 1 / Xr) : Li = 0, Li, Ci = 2 * di * Ut * et - he, Qi = di * Dt - be, Mn = Li * (Rr * zr + di * Ut * Mt * mr), pa = Li * (.5 * He * tr - di * 2 * Dt * et), ea = Li * .25 * (tr * et - di * Dt * Rr * He), Ga = Li * (mr * Mt + di * zr * Ut), To = pa * ea - Ga * Mn;
                            if (!To) break;
                            var Wa = (Qi * pa - Ci * Ga) / To, co = (Ci * ea - Qi * Mn) / To;
                            Pe -= Wa, Oe -= co;
                        }while ((n(Wa) > p || n(co) > p) && --Je > 0);
                        return [
                            Pe,
                            Oe
                        ];
                    }
                };
                function ke() {
                    return t.geoProjection(Me).scale(152.63);
                }
                function ge(he) {
                    var be = x(he), Pe = o(he), Oe = he >= 0 ? 1 : -1, Je = b(Oe * he), He = (1 + be - Pe) / 2;
                    function et(Mt, Dt) {
                        var Ut = o(Dt), tr = o(Mt /= 2);
                        return [
                            (1 + Ut) * x(Mt),
                            (Oe * Dt > -a(tr, Je) - .001 ? 0 : -Oe * 10) + He + x(Dt) * Pe - (1 + Ut) * be * tr
                        ];
                    }
                    return et.invert = function(Mt, Dt) {
                        var Ut = 0, tr = 0, mr = 50;
                        do {
                            var Rr = o(Ut), zr = x(Ut), Xr = o(tr), di = x(tr), Li = 1 + Xr, Ci = Li * zr - Mt, Qi = He + di * Pe - Li * be * Rr - Dt, Mn = Li * Rr / 2, pa = -zr * di, ea = be * Li * zr / 2, Ga = Pe * Xr + be * Rr * di, To = pa * ea - Ga * Mn, Wa = (Qi * pa - Ci * Ga) / To / 2, co = (Ci * ea - Qi * Mn) / To;
                            n(co) > 2 && (co /= 2), Ut -= Wa, tr -= co;
                        }while ((n(Wa) > p || n(co) > p) && --mr > 0);
                        return Oe * tr > -a(o(Ut), Je) - .001 ? [
                            Ut * 2,
                            tr
                        ] : null;
                    }, et;
                }
                function ie() {
                    var he = 20 * T, be = he >= 0 ? 1 : -1, Pe = b(be * he), Oe = t.geoProjectionMutator(ge), Je = Oe(he), He = Je.stream;
                    return Je.parallel = function(et) {
                        return arguments.length ? (Pe = b((be = (he = et * T) >= 0 ? 1 : -1) * he), Oe(he)) : he * P;
                    }, Je.stream = function(et) {
                        var Mt = Je.rotate(), Dt = He(et), Ut = (Je.rotate([
                            0,
                            0
                        ]), He(et)), tr = Je.precision();
                        return Je.rotate(Mt), Dt.sphere = function() {
                            Ut.polygonStart(), Ut.lineStart();
                            for(var mr = be * -180; be * mr < 180; mr += be * 90)Ut.point(mr, be * 90);
                            if (he) for(; be * (mr -= 3 * be * tr) >= -180;)Ut.point(mr, be * -a(o(mr * T / 2), Pe) * P);
                            Ut.lineEnd(), Ut.polygonEnd();
                        }, Dt;
                    }, Je.scale(218.695).center([
                        0,
                        28.0974
                    ]);
                }
                function Te(he, be) {
                    var Pe = b(be / 2), Oe = H(1 - Pe * Pe), Je = 1 + Oe * o(he /= 2), He = x(he) * Oe / Je, et = Pe / Je, Mt = He * He, Dt = et * et;
                    return [
                        4 / 3 * He * (3 + Mt - 3 * Dt),
                        4 / 3 * et * (3 + 3 * Mt - Dt)
                    ];
                }
                Te.invert = function(he, be) {
                    if (he *= 3 / 8, be *= 3 / 8, !he && n(be) > 1) return null;
                    var Pe = he * he, Oe = be * be, Je = 1 + Pe + Oe, He = H((Je - H(Je * Je - 4 * be * be)) / 2), et = q(He) / 3, Mt = He ? re(n(be / He)) / 3 : W(n(he)) / 3, Dt = o(et), Ut = N(Mt), tr = Ut * Ut - Dt * Dt;
                    return [
                        v(he) * 2 * a(G(Mt) * Dt, .25 - tr),
                        v(be) * 2 * a(Ut * x(et), .25 + tr)
                    ];
                };
                function Ee() {
                    return t.geoProjection(Te).scale(66.1603);
                }
                var Ae = H(8), ze = u(1 + C);
                function Ce(he, be) {
                    var Pe = n(be);
                    return Pe < L ? [
                        he,
                        u(b(L + be / 2))
                    ] : [
                        he * o(Pe) * (2 * C - 1 / x(Pe)),
                        v(be) * (2 * C * (Pe - L) - u(b(Pe / 2)))
                    ];
                }
                Ce.invert = function(he, be) {
                    if ((He = n(be)) < ze) return [
                        he,
                        2 * i(s(be)) - A
                    ];
                    var Pe = L, Oe = 25, Je, He;
                    do {
                        var et = o(Pe / 2), Mt = b(Pe / 2);
                        Pe -= Je = (Ae * (Pe - L) - u(Mt) - He) / (Ae - et * et / (2 * Mt));
                    }while (n(Je) > E && --Oe > 0);
                    return [
                        he / (o(Pe) * (Ae - 1 / x(Pe))),
                        v(be) * Pe
                    ];
                };
                function me() {
                    return t.geoProjection(Ce).scale(112.314);
                }
                function Re(he) {
                    var be = 2 * k / he;
                    function Pe(Oe, Je) {
                        var He = t.geoAzimuthalEquidistantRaw(Oe, Je);
                        if (n(Oe) > A) {
                            var et = a(He[1], He[0]), Mt = H(He[0] * He[0] + He[1] * He[1]), Dt = be * d((et - A) / be) + A, Ut = a(x(et -= Dt), 2 - o(et));
                            et = Dt + q(k / Mt * x(Ut)) - Ut, He[0] = Mt * o(et), He[1] = Mt * x(et);
                        }
                        return He;
                    }
                    return Pe.invert = function(Oe, Je) {
                        var He = H(Oe * Oe + Je * Je);
                        if (He > A) {
                            var et = a(Je, Oe), Mt = be * d((et - A) / be) + A, Dt = et > Mt ? -1 : 1, Ut = He * o(Mt - et), tr = 1 / b(Dt * V((Ut - k) / H(k * (k - 2 * Ut) + He * He)));
                            et = Mt + 2 * i((tr + Dt * H(tr * tr - 3)) / 3), Oe = He * o(et), Je = He * x(et);
                        }
                        return t.geoAzimuthalEquidistantRaw.invert(Oe, Je);
                    }, Pe;
                }
                function ce() {
                    var he = 5, be = t.geoProjectionMutator(Re), Pe = be(he), Oe = Pe.stream, Je = .01, He = -o(Je * T), et = x(Je * T);
                    return Pe.lobes = function(Mt) {
                        return arguments.length ? be(he = +Mt) : he;
                    }, Pe.stream = function(Mt) {
                        var Dt = Pe.rotate(), Ut = Oe(Mt), tr = (Pe.rotate([
                            0,
                            0
                        ]), Oe(Mt));
                        return Pe.rotate(Dt), Ut.sphere = function() {
                            tr.polygonStart(), tr.lineStart();
                            for(var mr = 0, Rr = 360 / he, zr = 2 * k / he, Xr = 90 - 180 / he, di = A; mr < he; ++mr, Xr -= Rr, di -= zr)tr.point(a(et * o(di), He) * P, q(et * x(di)) * P), Xr < -90 ? (tr.point(-90, -180 - Xr - Je), tr.point(-90, -180 - Xr + Je)) : (tr.point(90, Xr + Je), tr.point(90, Xr - Je));
                            tr.lineEnd(), tr.polygonEnd();
                        }, Ut;
                    }, Pe.scale(87.8076).center([
                        0,
                        17.1875
                    ]).clipAngle(179.999);
                }
                function Ge(he, be) {
                    if (arguments.length < 2 && (be = he), be === 1) return t.geoAzimuthalEqualAreaRaw;
                    if (be === 1 / 0) return nt;
                    function Pe(Oe, Je) {
                        var He = t.geoAzimuthalEqualAreaRaw(Oe / be, Je);
                        return He[0] *= he, He;
                    }
                    return Pe.invert = function(Oe, Je) {
                        var He = t.geoAzimuthalEqualAreaRaw.invert(Oe / he, Je);
                        return He[0] *= be, He;
                    }, Pe;
                }
                function nt(he, be) {
                    return [
                        he * o(be) / o(be /= 2),
                        2 * x(be)
                    ];
                }
                nt.invert = function(he, be) {
                    var Pe = 2 * q(be / 2);
                    return [
                        he * o(Pe / 2) / o(Pe),
                        Pe
                    ];
                };
                function ct() {
                    var he = 2, be = t.geoProjectionMutator(Ge), Pe = be(he);
                    return Pe.coefficient = function(Oe) {
                        return arguments.length ? be(he = +Oe) : he;
                    }, Pe.scale(169.529);
                }
                function qt(he, be, Pe) {
                    var Oe = 100, Je, He, et;
                    Pe = Pe === void 0 ? 0 : +Pe, be = +be;
                    do He = he(Pe), et = he(Pe + p), He === et && (et = He + p), Pe -= Je = -1 * p * (He - be) / (He - et);
                    while (Oe-- > 0 && n(Je) > p);
                    return Oe < 0 ? NaN : Pe;
                }
                function rt(he, be, Pe) {
                    return be === void 0 && (be = 40), Pe === void 0 && (Pe = E), function(Oe, Je, He, et) {
                        var Mt, Dt, Ut;
                        He = He === void 0 ? 0 : +He, et = et === void 0 ? 0 : +et;
                        for(var tr = 0; tr < be; tr++){
                            var mr = he(He, et), Rr = mr[0] - Oe, zr = mr[1] - Je;
                            if (n(Rr) < Pe && n(zr) < Pe) break;
                            var Xr = Rr * Rr + zr * zr;
                            if (Xr > Mt) {
                                He -= Dt /= 2, et -= Ut /= 2;
                                continue;
                            }
                            Mt = Xr;
                            var di = (He > 0 ? -1 : 1) * Pe, Li = (et > 0 ? -1 : 1) * Pe, Ci = he(He + di, et), Qi = he(He, et + Li), Mn = (Ci[0] - mr[0]) / di, pa = (Ci[1] - mr[1]) / di, ea = (Qi[0] - mr[0]) / Li, Ga = (Qi[1] - mr[1]) / Li, To = Ga * Mn - pa * ea, Wa = (n(To) < .5 ? .5 : 1) / To;
                            if (Dt = (zr * ea - Rr * Ga) * Wa, Ut = (Rr * pa - zr * Mn) * Wa, He += Dt, et += Ut, n(Dt) < Pe && n(Ut) < Pe) break;
                        }
                        return [
                            He,
                            et
                        ];
                    };
                }
                function ot() {
                    var he = Ge(1.68, 2), be = 1.4, Pe = 12;
                    function Oe(Je, He) {
                        if (Je + He < -be) {
                            var et = (Je - He + 1.6) * (Je + He + be) / 8;
                            Je += et, He -= .8 * et * x(He + k / 2);
                        }
                        var Mt = he(Je, He), Dt = (1 - o(Je * He)) / Pe;
                        return Mt[1] < 0 && (Mt[0] *= 1 + Dt), Mt[1] > 0 && (Mt[1] *= 1 + Dt / 1.5 * Mt[0] * Mt[0]), Mt;
                    }
                    return Oe.invert = rt(Oe), Oe;
                }
                function Rt() {
                    return t.geoProjection(ot()).rotate([
                        -16.5,
                        -42
                    ]).scale(176.57).center([
                        7.93,
                        .09
                    ]);
                }
                function kt(he, be) {
                    var Pe = he * x(be), Oe = 30, Je;
                    do be -= Je = (be + x(be) - Pe) / (1 + o(be));
                    while (n(Je) > p && --Oe > 0);
                    return be / 2;
                }
                function Ct(he, be, Pe) {
                    function Oe(Je, He) {
                        return [
                            he * Je * o(He = kt(Pe, He)),
                            be * x(He)
                        ];
                    }
                    return Oe.invert = function(Je, He) {
                        return He = q(He / be), [
                            Je / (he * o(He)),
                            q((2 * He + x(2 * He)) / Pe)
                        ];
                    }, Oe;
                }
                var Yt = Ct(C / A, C, k);
                function xr() {
                    return t.geoProjection(Yt).scale(169.529);
                }
                var er = 2.00276, Ke = 1.11072;
                function xt(he, be) {
                    var Pe = kt(k, be);
                    return [
                        er * he / (1 / o(be) + Ke / o(Pe)),
                        (be + C * x(Pe)) / er
                    ];
                }
                xt.invert = function(he, be) {
                    var Pe = er * be, Oe = be < 0 ? -L : L, Je = 25, He, et;
                    do et = Pe - C * x(Oe), Oe -= He = (x(2 * Oe) + 2 * Oe - k * x(et)) / (2 * o(2 * Oe) + 2 + k * o(et) * C * o(Oe));
                    while (n(He) > p && --Je > 0);
                    return et = Pe - C * x(Oe), [
                        he * (1 / o(et) + Ke / o(Oe)) / er,
                        et
                    ];
                };
                function bt() {
                    return t.geoProjection(xt).scale(160.857);
                }
                function Lt(he) {
                    var be = 0, Pe = t.geoProjectionMutator(he), Oe = Pe(be);
                    return Oe.parallel = function(Je) {
                        return arguments.length ? Pe(be = Je * T) : be * P;
                    }, Oe;
                }
                function St(he, be) {
                    return [
                        he * o(be),
                        be
                    ];
                }
                St.invert = function(he, be) {
                    return [
                        he / o(be),
                        be
                    ];
                };
                function Et() {
                    return t.geoProjection(St).scale(152.63);
                }
                function dt(he) {
                    if (!he) return St;
                    var be = 1 / b(he);
                    function Pe(Oe, Je) {
                        var He = be + he - Je, et = He && Oe * o(Je) / He;
                        return [
                            He * x(et),
                            be - He * o(et)
                        ];
                    }
                    return Pe.invert = function(Oe, Je) {
                        var He = H(Oe * Oe + (Je = be - Je) * Je), et = be + he - He;
                        return [
                            He / o(et) * a(Oe, Je),
                            et
                        ];
                    }, Pe;
                }
                function Ht() {
                    return Lt(dt).scale(123.082).center([
                        0,
                        26.1441
                    ]).parallel(45);
                }
                function $t(he) {
                    function be(Pe, Oe) {
                        var Je = A - Oe, He = Je && Pe * he * x(Je) / Je;
                        return [
                            Je * x(He) / he,
                            A - Je * o(He)
                        ];
                    }
                    return be.invert = function(Pe, Oe) {
                        var Je = Pe * he, He = A - Oe, et = H(Je * Je + He * He), Mt = a(Je, He);
                        return [
                            (et ? et / x(et) : 1) * Mt / he,
                            A - et
                        ];
                    }, be;
                }
                function fr() {
                    var he = .5, be = t.geoProjectionMutator($t), Pe = be(he);
                    return Pe.fraction = function(Oe) {
                        return arguments.length ? be(he = +Oe) : he;
                    }, Pe.scale(158.837);
                }
                var _r = Ct(1, 4 / k, k);
                function Br() {
                    return t.geoProjection(_r).scale(152.63);
                }
                function Or(he, be, Pe, Oe, Je, He) {
                    var et = o(He), Mt;
                    if (n(he) > 1 || n(He) > 1) Mt = V(Pe * Je + be * Oe * et);
                    else {
                        var Dt = x(he / 2), Ut = x(He / 2);
                        Mt = 2 * q(H(Dt * Dt + be * Oe * Ut * Ut));
                    }
                    return n(Mt) > p ? [
                        Mt,
                        a(Oe * x(He), be * Je - Pe * Oe * et)
                    ] : [
                        0,
                        0
                    ];
                }
                function Nr(he, be, Pe) {
                    return V((he * he + be * be - Pe * Pe) / (2 * he * be));
                }
                function ut(he) {
                    return he - 2 * k * l((he + k) / (2 * k));
                }
                function Ne(he, be, Pe) {
                    for(var Oe = [
                        [
                            he[0],
                            he[1],
                            x(he[1]),
                            o(he[1])
                        ],
                        [
                            be[0],
                            be[1],
                            x(be[1]),
                            o(be[1])
                        ],
                        [
                            Pe[0],
                            Pe[1],
                            x(Pe[1]),
                            o(Pe[1])
                        ]
                    ], Je = Oe[2], He, et = 0; et < 3; ++et, Je = He)He = Oe[et], Je.v = Or(He[1] - Je[1], Je[3], Je[2], He[3], He[2], He[0] - Je[0]), Je.point = [
                        0,
                        0
                    ];
                    var Mt = Nr(Oe[0].v[0], Oe[2].v[0], Oe[1].v[0]), Dt = Nr(Oe[0].v[0], Oe[1].v[0], Oe[2].v[0]), Ut = k - Mt;
                    Oe[2].point[1] = 0, Oe[0].point[0] = -(Oe[1].point[0] = Oe[0].v[0] / 2);
                    var tr = [
                        Oe[2].point[0] = Oe[0].point[0] + Oe[2].v[0] * o(Mt),
                        2 * (Oe[0].point[1] = Oe[1].point[1] = Oe[2].v[0] * x(Mt))
                    ];
                    function mr(Rr, zr) {
                        var Xr = x(zr), di = o(zr), Li = new Array(3), Ci;
                        for(Ci = 0; Ci < 3; ++Ci){
                            var Qi = Oe[Ci];
                            if (Li[Ci] = Or(zr - Qi[1], Qi[3], Qi[2], di, Xr, Rr - Qi[0]), !Li[Ci][0]) return Qi.point;
                            Li[Ci][1] = ut(Li[Ci][1] - Qi.v[1]);
                        }
                        var Mn = tr.slice();
                        for(Ci = 0; Ci < 3; ++Ci){
                            var pa = Ci == 2 ? 0 : Ci + 1, ea = Nr(Oe[Ci].v[0], Li[Ci][0], Li[pa][0]);
                            Li[Ci][1] < 0 && (ea = -ea), Ci ? Ci == 1 ? (ea = Dt - ea, Mn[0] -= Li[Ci][0] * o(ea), Mn[1] -= Li[Ci][0] * x(ea)) : (ea = Ut - ea, Mn[0] += Li[Ci][0] * o(ea), Mn[1] += Li[Ci][0] * x(ea)) : (Mn[0] += Li[Ci][0] * o(ea), Mn[1] -= Li[Ci][0] * x(ea));
                        }
                        return Mn[0] /= 3, Mn[1] /= 3, Mn;
                    }
                    return mr;
                }
                function Ye(he) {
                    return he[0] *= T, he[1] *= T, he;
                }
                function Ve() {
                    return Xe([
                        0,
                        22
                    ], [
                        45,
                        22
                    ], [
                        22.5,
                        -22
                    ]).scale(380).center([
                        22.5,
                        2
                    ]);
                }
                function Xe(he, be, Pe) {
                    var Oe = t.geoCentroid({
                        type: "MultiPoint",
                        coordinates: [
                            he,
                            be,
                            Pe
                        ]
                    }), Je = [
                        -Oe[0],
                        -Oe[1]
                    ], He = t.geoRotation(Je), et = Ne(Ye(He(he)), Ye(He(be)), Ye(He(Pe)));
                    et.invert = rt(et);
                    var Mt = t.geoProjection(et).rotate(Je), Dt = Mt.center;
                    return delete Mt.rotate, Mt.center = function(Ut) {
                        return arguments.length ? Dt(He(Ut)) : He.invert(Dt());
                    }, Mt.clipAngle(90);
                }
                function ht(he, be) {
                    var Pe = H(1 - x(be));
                    return [
                        2 / M * he * Pe,
                        M * (1 - Pe)
                    ];
                }
                ht.invert = function(he, be) {
                    var Pe = (Pe = be / M - 1) * Pe;
                    return [
                        Pe > 0 ? he * H(k / Pe) / 2 : 0,
                        q(1 - Pe)
                    ];
                };
                function Le() {
                    return t.geoProjection(ht).scale(95.6464).center([
                        0,
                        30
                    ]);
                }
                function xe(he) {
                    var be = b(he);
                    function Pe(Oe, Je) {
                        return [
                            Oe,
                            (Oe ? Oe / x(Oe) : 1) * (x(Je) * o(Oe) - be * o(Je))
                        ];
                    }
                    return Pe.invert = be ? function(Oe, Je) {
                        Oe && (Je *= x(Oe) / Oe);
                        var He = o(Oe);
                        return [
                            Oe,
                            2 * a(H(He * He + be * be - Je * Je) - He, be - Je)
                        ];
                    } : function(Oe, Je) {
                        return [
                            Oe,
                            q(Oe ? Je * b(Oe) / Oe : Je)
                        ];
                    }, Pe;
                }
                function Se() {
                    return Lt(xe).scale(249.828).clipAngle(90);
                }
                var lt = H(3);
                function Gt(he, be) {
                    return [
                        lt * he * (2 * o(2 * be / 3) - 1) / M,
                        lt * M * x(be / 3)
                    ];
                }
                Gt.invert = function(he, be) {
                    var Pe = 3 * q(be / (lt * M));
                    return [
                        M * he / (lt * (2 * o(2 * Pe / 3) - 1)),
                        Pe
                    ];
                };
                function Vt() {
                    return t.geoProjection(Gt).scale(156.19);
                }
                function ar(he) {
                    var be = o(he);
                    function Pe(Oe, Je) {
                        return [
                            Oe * be,
                            x(Je) / be
                        ];
                    }
                    return Pe.invert = function(Oe, Je) {
                        return [
                            Oe / be,
                            q(Je * be)
                        ];
                    }, Pe;
                }
                function Qr() {
                    return Lt(ar).parallel(38.58).scale(195.044);
                }
                function ai(he) {
                    var be = o(he);
                    function Pe(Oe, Je) {
                        return [
                            Oe * be,
                            (1 + be) * b(Je / 2)
                        ];
                    }
                    return Pe.invert = function(Oe, Je) {
                        return [
                            Oe / be,
                            i(Je / (1 + be)) * 2
                        ];
                    }, Pe;
                }
                function jr() {
                    return Lt(ai).scale(124.75);
                }
                function ri(he, be) {
                    var Pe = H(8 / (3 * k));
                    return [
                        Pe * he * (1 - n(be) / k),
                        Pe * be
                    ];
                }
                ri.invert = function(he, be) {
                    var Pe = H(8 / (3 * k)), Oe = be / Pe;
                    return [
                        he / (Pe * (1 - n(Oe) / k)),
                        Oe
                    ];
                };
                function bi() {
                    return t.geoProjection(ri).scale(165.664);
                }
                function nn(he, be) {
                    var Pe = H(4 - 3 * x(n(be)));
                    return [
                        2 / H(6 * k) * he * Pe,
                        v(be) * H(2 * k / 3) * (2 - Pe)
                    ];
                }
                nn.invert = function(he, be) {
                    var Pe = 2 - n(be) / H(2 * k / 3);
                    return [
                        he * H(6 * k) / (2 * Pe),
                        v(be) * q((4 - Pe * Pe) / 3)
                    ];
                };
                function Wi() {
                    return t.geoProjection(nn).scale(165.664);
                }
                function Ni(he, be) {
                    var Pe = H(k * (4 + k));
                    return [
                        2 / Pe * he * (1 + H(1 - 4 * be * be / (k * k))),
                        4 / Pe * be
                    ];
                }
                Ni.invert = function(he, be) {
                    var Pe = H(k * (4 + k)) / 2;
                    return [
                        he * Pe / (1 + H(1 - be * be * (4 + k) / (4 * k))),
                        be * Pe / 2
                    ];
                };
                function _n() {
                    return t.geoProjection(Ni).scale(180.739);
                }
                function $i(he, be) {
                    var Pe = (2 + A) * x(be);
                    be /= 2;
                    for(var Oe = 0, Je = 1 / 0; Oe < 10 && n(Je) > p; Oe++){
                        var He = o(be);
                        be -= Je = (be + x(be) * (He + 2) - Pe) / (2 * He * (1 + He));
                    }
                    return [
                        2 / H(k * (4 + k)) * he * (1 + o(be)),
                        2 * H(k / (4 + k)) * x(be)
                    ];
                }
                $i.invert = function(he, be) {
                    var Pe = be * H((4 + k) / k) / 2, Oe = q(Pe), Je = o(Oe);
                    return [
                        he / (2 / H(k * (4 + k)) * (1 + Je)),
                        q((Oe + Pe * (Je + 2)) / (2 + A))
                    ];
                };
                function zn() {
                    return t.geoProjection($i).scale(180.739);
                }
                function Wn(he, be) {
                    return [
                        he * (1 + o(be)) / H(2 + k),
                        2 * be / H(2 + k)
                    ];
                }
                Wn.invert = function(he, be) {
                    var Pe = H(2 + k), Oe = be * Pe / 2;
                    return [
                        Pe * he / (1 + o(Oe)),
                        Oe
                    ];
                };
                function It() {
                    return t.geoProjection(Wn).scale(173.044);
                }
                function ft(he, be) {
                    for(var Pe = (1 + A) * x(be), Oe = 0, Je = 1 / 0; Oe < 10 && n(Je) > p; Oe++)be -= Je = (be + x(be) - Pe) / (1 + o(be));
                    return Pe = H(2 + k), [
                        he * (1 + o(be)) / Pe,
                        2 * be / Pe
                    ];
                }
                ft.invert = function(he, be) {
                    var Pe = 1 + A, Oe = H(Pe / 2);
                    return [
                        he * 2 * Oe / (1 + o(be *= Oe)),
                        q((be + x(be)) / Pe)
                    ];
                };
                function jt() {
                    return t.geoProjection(ft).scale(173.044);
                }
                var Zt = 3 + 2 * C;
                function yr(he, be) {
                    var Pe = x(he /= 2), Oe = o(he), Je = H(o(be)), He = o(be /= 2), et = x(be) / (He + C * Oe * Je), Mt = H(2 / (1 + et * et)), Dt = H((C * He + (Oe + Pe) * Je) / (C * He + (Oe - Pe) * Je));
                    return [
                        Zt * (Mt * (Dt - 1 / Dt) - 2 * u(Dt)),
                        Zt * (Mt * et * (Dt + 1 / Dt) - 2 * i(et))
                    ];
                }
                yr.invert = function(he, be) {
                    if (!(He = Te.invert(he / 1.2, be * 1.065))) return null;
                    var Pe = He[0], Oe = He[1], Je = 20, He;
                    he /= Zt, be /= Zt;
                    do {
                        var et = Pe / 2, Mt = Oe / 2, Dt = x(et), Ut = o(et), tr = x(Mt), mr = o(Mt), Rr = o(Oe), zr = H(Rr), Xr = tr / (mr + C * Ut * zr), di = Xr * Xr, Li = H(2 / (1 + di)), Ci = C * mr + (Ut + Dt) * zr, Qi = C * mr + (Ut - Dt) * zr, Mn = Ci / Qi, pa = H(Mn), ea = pa - 1 / pa, Ga = pa + 1 / pa, To = Li * ea - 2 * u(pa) - he, Wa = Li * Xr * Ga - 2 * i(Xr) - be, co = tr && _ * zr * Dt * di / tr, Ro = (C * Ut * mr + zr) / (2 * (mr + C * Ut * zr) * (mr + C * Ut * zr) * zr), Ds = -0.5 * Xr * Li * Li * Li, As = Ds * co, yo = Ds * Ro, po = (po = 2 * mr + C * zr * (Ut - Dt)) * po * pa, _l = (C * Ut * mr * zr + Rr) / po, Hl = -(C * Dt * tr) / (zr * po), Zu = ea * As - 2 * _l / pa + Li * (_l + _l / Mn), cu = ea * yo - 2 * Hl / pa + Li * (Hl + Hl / Mn), el = Xr * Ga * As - 2 * co / (1 + di) + Li * Ga * co + Li * Xr * (_l - _l / Mn), au = Xr * Ga * yo - 2 * Ro / (1 + di) + Li * Ga * Ro + Li * Xr * (Hl - Hl / Mn), zc = cu * el - au * Zu;
                        if (!zc) break;
                        var zl = (Wa * cu - To * au) / zc, Fl = (To * el - Wa * Zu) / zc;
                        Pe -= zl, Oe = c(-A, f(A, Oe - Fl));
                    }while ((n(zl) > p || n(Fl) > p) && --Je > 0);
                    return n(n(Oe) - A) < p ? [
                        0,
                        Oe
                    ] : Je && [
                        Pe,
                        Oe
                    ];
                };
                function Fr() {
                    return t.geoProjection(yr).scale(62.5271);
                }
                var Zr = o(35 * T);
                function Vr(he, be) {
                    var Pe = b(be / 2);
                    return [
                        he * Zr * H(1 - Pe * Pe),
                        (1 + Zr) * Pe
                    ];
                }
                Vr.invert = function(he, be) {
                    var Pe = be / (1 + Zr);
                    return [
                        he && he / (Zr * H(1 - Pe * Pe)),
                        2 * i(Pe)
                    ];
                };
                function gi() {
                    return t.geoProjection(Vr).scale(137.152);
                }
                function Si(he, be) {
                    var Pe = be / 2, Oe = o(Pe);
                    return [
                        2 * he / M * o(be) * Oe * Oe,
                        M * b(Pe)
                    ];
                }
                Si.invert = function(he, be) {
                    var Pe = i(be / M), Oe = o(Pe), Je = 2 * Pe;
                    return [
                        he * M / 2 / (o(Je) * Oe * Oe),
                        Je
                    ];
                };
                function Mi() {
                    return t.geoProjection(Si).scale(135.264);
                }
                function Pi(he) {
                    var be = 1 - he, Pe = He(k, 0)[0] - He(-k, 0)[0], Oe = He(0, A)[1] - He(0, -A)[1], Je = H(2 * Oe / Pe);
                    function He(Dt, Ut) {
                        var tr = o(Ut), mr = x(Ut);
                        return [
                            tr / (be + he * tr) * Dt,
                            be * Ut + he * mr
                        ];
                    }
                    function et(Dt, Ut) {
                        var tr = He(Dt, Ut);
                        return [
                            tr[0] * Je,
                            tr[1] / Je
                        ];
                    }
                    function Mt(Dt) {
                        return et(0, Dt)[1];
                    }
                    return et.invert = function(Dt, Ut) {
                        var tr = qt(Mt, Ut), mr = Dt / Je * (he + be / o(tr));
                        return [
                            mr,
                            tr
                        ];
                    }, et;
                }
                function Gi() {
                    var he = .5, be = t.geoProjectionMutator(Pi), Pe = be(he);
                    return Pe.alpha = function(Oe) {
                        return arguments.length ? be(he = +Oe) : he;
                    }, Pe.scale(168.725);
                }
                function Ki(he) {
                    return [
                        he[0] / 2,
                        q(b(he[1] / 2 * T)) * P
                    ];
                }
                function ka(he) {
                    return [
                        he[0] * 2,
                        2 * i(x(he[1] * T)) * P
                    ];
                }
                function jn(he) {
                    he == null && (he = t.geoOrthographic);
                    var be = he(), Pe = t.geoEquirectangular().scale(P).precision(0).clipAngle(null).translate([
                        0,
                        0
                    ]);
                    function Oe(He) {
                        return be(Ki(He));
                    }
                    be.invert && (Oe.invert = function(He) {
                        return ka(be.invert(He));
                    }), Oe.stream = function(He) {
                        var et = be.stream(He), Mt = Pe.stream({
                            point: function(Dt, Ut) {
                                et.point(Dt / 2, q(b(-Ut / 2 * T)) * P);
                            },
                            lineStart: function() {
                                et.lineStart();
                            },
                            lineEnd: function() {
                                et.lineEnd();
                            },
                            polygonStart: function() {
                                et.polygonStart();
                            },
                            polygonEnd: function() {
                                et.polygonEnd();
                            }
                        });
                        return Mt.sphere = et.sphere, Mt;
                    };
                    function Je(He) {
                        Oe[He] = function() {
                            return arguments.length ? (be[He].apply(be, arguments), Oe) : be[He]();
                        };
                    }
                    return Oe.rotate = function(He) {
                        return arguments.length ? (Pe.rotate(He), Oe) : Pe.rotate();
                    }, Oe.center = function(He) {
                        return arguments.length ? (be.center(Ki(He)), Oe) : ka(be.center());
                    }, Je("angle"), Je("clipAngle"), Je("clipExtent"), Je("fitExtent"), Je("fitHeight"), Je("fitSize"), Je("fitWidth"), Je("scale"), Je("translate"), Je("precision"), Oe.scale(249.5);
                }
                function la(he, be) {
                    var Pe = 2 * k / be, Oe = he * he;
                    function Je(He, et) {
                        var Mt = t.geoAzimuthalEquidistantRaw(He, et), Dt = Mt[0], Ut = Mt[1], tr = Dt * Dt + Ut * Ut;
                        if (tr > Oe) {
                            var mr = H(tr), Rr = a(Ut, Dt), zr = Pe * d(Rr / Pe), Xr = Rr - zr, di = he * o(Xr), Li = (he * x(Xr) - Xr * x(di)) / (A - di), Ci = Fa(Xr, Li), Qi = (k - he) / Ra(Ci, di, k);
                            Dt = mr;
                            var Mn = 50, pa;
                            do Dt -= pa = (he + Ra(Ci, di, Dt) * Qi - mr) / (Ci(Dt) * Qi);
                            while (n(pa) > p && --Mn > 0);
                            Ut = Xr * x(Dt), Dt < A && (Ut -= Li * (Dt - A));
                            var ea = x(zr), Ga = o(zr);
                            Mt[0] = Dt * Ga - Ut * ea, Mt[1] = Dt * ea + Ut * Ga;
                        }
                        return Mt;
                    }
                    return Je.invert = function(He, et) {
                        var Mt = He * He + et * et;
                        if (Mt > Oe) {
                            var Dt = H(Mt), Ut = a(et, He), tr = Pe * d(Ut / Pe), mr = Ut - tr;
                            He = Dt * o(mr), et = Dt * x(mr);
                            for(var Rr = He - A, zr = x(He), Xr = et / zr, di = He < A ? 1 / 0 : 0, Li = 10;;){
                                var Ci = he * x(Xr), Qi = he * o(Xr), Mn = x(Qi), pa = A - Qi, ea = (Ci - Xr * Mn) / pa, Ga = Fa(Xr, ea);
                                if (n(di) < E || !--Li) break;
                                Xr -= di = (Xr * zr - ea * Rr - et) / (zr - Rr * 2 * (pa * (Qi + Xr * Ci * o(Qi) - Mn) - Ci * (Ci - Xr * Mn)) / (pa * pa));
                            }
                            Dt = he + Ra(Ga, Qi, He) * (k - he) / Ra(Ga, Qi, k), Ut = tr + Xr, He = Dt * o(Ut), et = Dt * x(Ut);
                        }
                        return t.geoAzimuthalEquidistantRaw.invert(He, et);
                    }, Je;
                }
                function Fa(he, be) {
                    return function(Pe) {
                        var Oe = he * o(Pe);
                        return Pe < A && (Oe -= be), H(1 + Oe * Oe);
                    };
                }
                function Ra(he, be, Pe) {
                    for(var Oe = 50, Je = (Pe - be) / Oe, He = he(be) + he(Pe), et = 1, Mt = be; et < Oe; ++et)He += 2 * he(Mt += Je);
                    return He * .5 * Je;
                }
                function jo() {
                    var he = 6, be = 30 * T, Pe = o(be), Oe = x(be), Je = t.geoProjectionMutator(la), He = Je(be, he), et = He.stream, Mt = .01, Dt = -o(Mt * T), Ut = x(Mt * T);
                    return He.radius = function(tr) {
                        return arguments.length ? (Pe = o(be = tr * T), Oe = x(be), Je(be, he)) : be * P;
                    }, He.lobes = function(tr) {
                        return arguments.length ? Je(be, he = +tr) : he;
                    }, He.stream = function(tr) {
                        var mr = He.rotate(), Rr = et(tr), zr = (He.rotate([
                            0,
                            0
                        ]), et(tr));
                        return He.rotate(mr), Rr.sphere = function() {
                            zr.polygonStart(), zr.lineStart();
                            for(var Xr = 0, di = 2 * k / he, Li = 0; Xr < he; ++Xr, Li -= di)zr.point(a(Ut * o(Li), Dt) * P, q(Ut * x(Li)) * P), zr.point(a(Oe * o(Li - di / 2), Pe) * P, q(Oe * x(Li - di / 2)) * P);
                            zr.lineEnd(), zr.polygonEnd();
                        }, Rr;
                    }, He.rotate([
                        90,
                        -40
                    ]).scale(91.7095).clipAngle(179.999);
                }
                function oa(he, be, Pe, Oe, Je, He, et, Mt) {
                    arguments.length < 8 && (Mt = 0);
                    function Dt(Ut, tr) {
                        if (!tr) return [
                            he * Ut / k,
                            0
                        ];
                        var mr = tr * tr, Rr = he + mr * (be + mr * (Pe + mr * Oe)), zr = tr * (Je - 1 + mr * (He - Mt + mr * et)), Xr = (Rr * Rr + zr * zr) / (2 * zr), di = Ut * q(Rr / Xr) / k;
                        return [
                            Xr * x(di),
                            tr * (1 + mr * Mt) + Xr * (1 - o(di))
                        ];
                    }
                    return Dt.invert = function(Ut, tr) {
                        var mr = k * Ut / he, Rr = tr, zr, Xr, di = 50;
                        do {
                            var Li = Rr * Rr, Ci = he + Li * (be + Li * (Pe + Li * Oe)), Qi = Rr * (Je - 1 + Li * (He - Mt + Li * et)), Mn = Ci * Ci + Qi * Qi, pa = 2 * Qi, ea = Mn / pa, Ga = ea * ea, To = q(Ci / ea) / k, Wa = mr * To, co = Ci * Ci, Ro = (2 * be + Li * (4 * Pe + Li * 6 * Oe)) * Rr, Ds = Je + Li * (3 * He + Li * 5 * et), As = 2 * (Ci * Ro + Qi * (Ds - 1)), yo = 2 * (Ds - 1), po = (As * pa - Mn * yo) / (pa * pa), _l = o(Wa), Hl = x(Wa), Zu = ea * _l, cu = ea * Hl, el = mr / k * (1 / H(1 - co / Ga)) * (Ro * ea - Ci * po) / Ga, au = cu - Ut, zc = Rr * (1 + Li * Mt) + ea - Zu - tr, zl = po * Hl + Zu * el, Fl = Zu * To, Z = 1 + po - (po * _l - cu * el), oe = cu * To, we = zl * oe - Z * Fl;
                            if (!we) break;
                            mr -= zr = (zc * zl - au * Z) / we, Rr -= Xr = (au * oe - zc * Fl) / we;
                        }while ((n(zr) > p || n(Xr) > p) && --di > 0);
                        return [
                            mr,
                            Rr
                        ];
                    }, Dt;
                }
                var Sn = oa(2.8284, -1.6988, .75432, -0.18071, 1.76003, -0.38914, .042555);
                function Ha() {
                    return t.geoProjection(Sn).scale(149.995);
                }
                var oo = oa(2.583819, -0.835827, .170354, -0.038094, 1.543313, -0.411435, .082742);
                function xn() {
                    return t.geoProjection(oo).scale(153.93);
                }
                var _t = oa(5 / 6 * k, -0.62636, -0.0344, 0, 1.3493, -0.05524, 0, .045);
                function br() {
                    return t.geoProjection(_t).scale(130.945);
                }
                function Hr(he, be) {
                    var Pe = he * he, Oe = be * be;
                    return [
                        he * (1 - .162388 * Oe) * (.87 - 952426e-9 * Pe * Pe),
                        be * (1 + Oe / 12)
                    ];
                }
                Hr.invert = function(he, be) {
                    var Pe = he, Oe = be, Je = 50, He;
                    do {
                        var et = Oe * Oe;
                        Oe -= He = (Oe * (1 + et / 12) - be) / (1 + et / 4);
                    }while (n(He) > p && --Je > 0);
                    Je = 50, he /= 1 - .162388 * et;
                    do {
                        var Mt = (Mt = Pe * Pe) * Mt;
                        Pe -= He = (Pe * (.87 - 952426e-9 * Mt) - he) / (.87 - .00476213 * Mt);
                    }while (n(He) > p && --Je > 0);
                    return [
                        Pe,
                        Oe
                    ];
                };
                function ti() {
                    return t.geoProjection(Hr).scale(131.747);
                }
                var zi = oa(2.6516, -0.76534, .19123, -0.047094, 1.36289, -0.13965, .031762);
                function Yi() {
                    return t.geoProjection(zi).scale(131.087);
                }
                function an(he) {
                    var be = he(A, 0)[0] - he(-A, 0)[0];
                    function Pe(Oe, Je) {
                        var He = Oe > 0 ? -0.5 : .5, et = he(Oe + He * k, Je);
                        return et[0] -= He * be, et;
                    }
                    return he.invert && (Pe.invert = function(Oe, Je) {
                        var He = Oe > 0 ? -0.5 : .5, et = he.invert(Oe + He * be, Je), Mt = et[0] - He * k;
                        return Mt < -k ? Mt += 2 * k : Mt > k && (Mt -= 2 * k), et[0] = Mt, et;
                    }), Pe;
                }
                function hi(he, be) {
                    var Pe = v(he), Oe = v(be), Je = o(be), He = o(he) * Je, et = x(he) * Je, Mt = x(Oe * be);
                    he = n(a(et, Mt)), be = q(He), n(he - A) > p && (he %= A);
                    var Dt = Ji(he > k / 4 ? A - he : he, be);
                    return he > k / 4 && (Mt = Dt[0], Dt[0] = -Dt[1], Dt[1] = -Mt), Dt[0] *= Pe, Dt[1] *= -Oe, Dt;
                }
                hi.invert = function(he, be) {
                    n(he) > 1 && (he = v(he) * 2 - he), n(be) > 1 && (be = v(be) * 2 - be);
                    var Pe = v(he), Oe = v(be), Je = -Pe * he, He = -Oe * be, et = He / Je < 1, Mt = ua(et ? He : Je, et ? Je : He), Dt = Mt[0], Ut = Mt[1], tr = o(Ut);
                    return et && (Dt = -A - Dt), [
                        Pe * (a(x(Dt) * tr, -x(Ut)) + k),
                        Oe * q(o(Dt) * tr)
                    ];
                };
                function Ji(he, be) {
                    if (be === A) return [
                        0,
                        0
                    ];
                    var Pe = x(be), Oe = Pe * Pe, Je = Oe * Oe, He = 1 + Je, et = 1 + 3 * Je, Mt = 1 - Je, Dt = q(1 / H(He)), Ut = Mt + Oe * He * Dt, tr = (1 - Pe) / Ut, mr = H(tr), Rr = tr * He, zr = H(Rr), Xr = mr * Mt, di, Li;
                    if (he === 0) return [
                        0,
                        -(Xr + Oe * zr)
                    ];
                    var Ci = o(be), Qi = 1 / Ci, Mn = 2 * Pe * Ci, pa = (-3 * Oe + Dt * et) * Mn, ea = (-Ut * Ci - (1 - Pe) * pa) / (Ut * Ut), Ga = .5 * ea / mr, To = Mt * Ga - 2 * Oe * mr * Mn, Wa = Oe * He * ea + tr * et * Mn, co = -Qi * Mn, Ro = -Qi * Wa, Ds = -2 * Qi * To, As = 4 * he / k, yo;
                    if (he > .222 * k || be < k / 4 && he > .175 * k) {
                        if (di = (Xr + Oe * H(Rr * (1 + Je) - Xr * Xr)) / (1 + Je), he > k / 4) return [
                            di,
                            di
                        ];
                        var po = di, _l = .5 * di;
                        di = .5 * (_l + po), Li = 50;
                        do {
                            var Hl = H(Rr - di * di), Zu = di * (Ds + co * Hl) + Ro * q(di / zr) - As;
                            if (!Zu) break;
                            Zu < 0 ? _l = di : po = di, di = .5 * (_l + po);
                        }while (n(po - _l) > p && --Li > 0);
                    } else {
                        di = p, Li = 25;
                        do {
                            var cu = di * di, el = H(Rr - cu), au = Ds + co * el, zc = di * au + Ro * q(di / zr) - As, zl = au + (Ro - co * cu) / el;
                            di -= yo = el ? zc / zl : 0;
                        }while (n(yo) > p && --Li > 0);
                    }
                    return [
                        di,
                        -Xr - Oe * H(Rr - di * di)
                    ];
                }
                function ua(he, be) {
                    for(var Pe = 0, Oe = 1, Je = .5, He = 50;;){
                        var et = Je * Je, Mt = H(Je), Dt = q(1 / H(1 + et)), Ut = 1 - et + Je * (1 + et) * Dt, tr = (1 - Mt) / Ut, mr = H(tr), Rr = tr * (1 + et), zr = mr * (1 - et), Xr = Rr - he * he, di = H(Xr), Li = be + zr + Je * di;
                        if (n(Oe - Pe) < E || --He === 0 || Li === 0) break;
                        Li > 0 ? Pe = Je : Oe = Je, Je = .5 * (Pe + Oe);
                    }
                    if (!He) return null;
                    var Ci = q(Mt), Qi = o(Ci), Mn = 1 / Qi, pa = 2 * Mt * Qi, ea = (-3 * Je + Dt * (1 + 3 * et)) * pa, Ga = (-Ut * Qi - (1 - Mt) * ea) / (Ut * Ut), To = .5 * Ga / mr, Wa = (1 - et) * To - 2 * Je * mr * pa, co = -2 * Mn * Wa, Ro = -Mn * pa, Ds = -Mn * (Je * (1 + et) * Ga + tr * (1 + 3 * et) * pa);
                    return [
                        k / 4 * (he * (co + Ro * di) + Ds * q(he / H(Rr))),
                        Ci
                    ];
                }
                function Fn() {
                    return t.geoProjection(an(hi)).scale(239.75);
                }
                function Sa(he, be, Pe) {
                    var Oe, Je, He;
                    return he ? (Oe = go(he, Pe), be ? (Je = go(be, 1 - Pe), He = Je[1] * Je[1] + Pe * Oe[0] * Oe[0] * Je[0] * Je[0], [
                        [
                            Oe[0] * Je[2] / He,
                            Oe[1] * Oe[2] * Je[0] * Je[1] / He
                        ],
                        [
                            Oe[1] * Je[1] / He,
                            -Oe[0] * Oe[2] * Je[0] * Je[2] / He
                        ],
                        [
                            Oe[2] * Je[1] * Je[2] / He,
                            -Pe * Oe[0] * Oe[1] * Je[0] / He
                        ]
                    ]) : [
                        [
                            Oe[0],
                            0
                        ],
                        [
                            Oe[1],
                            0
                        ],
                        [
                            Oe[2],
                            0
                        ]
                    ]) : (Je = go(be, 1 - Pe), [
                        [
                            0,
                            Je[0] / Je[1]
                        ],
                        [
                            1 / Je[1],
                            0
                        ],
                        [
                            Je[2] / Je[1],
                            0
                        ]
                    ]);
                }
                function go(he, be) {
                    var Pe, Oe, Je, He, et;
                    if (be < p) return He = x(he), Oe = o(he), Pe = be * (he - He * Oe) / 4, [
                        He - Pe * Oe,
                        Oe + Pe * He,
                        1 - be * He * He / 2,
                        he - Pe
                    ];
                    if (be >= 1 - p) return Pe = (1 - be) / 4, Oe = N(he), He = X(he), Je = 1 / Oe, et = Oe * G(he), [
                        He + Pe * (et - he) / (Oe * Oe),
                        Je - Pe * He * Je * (et - he),
                        Je + Pe * He * Je * (et + he),
                        2 * i(s(he)) - A + Pe * (et - he) / Oe
                    ];
                    var Mt = [
                        1,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], Dt = [
                        H(be),
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ], Ut = 0;
                    for(Oe = H(1 - be), et = 1; n(Dt[Ut] / Mt[Ut]) > p && Ut < 8;)Pe = Mt[Ut++], Dt[Ut] = (Pe - Oe) / 2, Mt[Ut] = (Pe + Oe) / 2, Oe = H(Pe * Oe), et *= 2;
                    Je = et * Mt[Ut] * he;
                    do He = Dt[Ut] * x(Oe = Je) / Mt[Ut], Je = (q(He) + Je) / 2;
                    while (--Ut);
                    return [
                        x(Je),
                        He = o(Je),
                        He / o(Je - Oe),
                        Je
                    ];
                }
                function Oo(he, be, Pe) {
                    var Oe = n(he), Je = n(be), He = G(Je);
                    if (Oe) {
                        var et = 1 / x(Oe), Mt = 1 / (b(Oe) * b(Oe)), Dt = -(Mt + Pe * (He * He * et * et) - 1 + Pe), Ut = (Pe - 1) * Mt, tr = (-Dt + H(Dt * Dt - 4 * Ut)) / 2;
                        return [
                            ho(i(1 / H(tr)), Pe) * v(he),
                            ho(i(H((tr / Mt - 1) / Pe)), 1 - Pe) * v(be)
                        ];
                    }
                    return [
                        0,
                        ho(i(He), 1 - Pe) * v(be)
                    ];
                }
                function ho(he, be) {
                    if (!be) return he;
                    if (be === 1) return u(b(he / 2 + L));
                    for(var Pe = 1, Oe = H(1 - be), Je = H(be), He = 0; n(Je) > p; He++){
                        if (he % k) {
                            var et = i(Oe * b(he) / Pe);
                            et < 0 && (et += k), he += et + ~~(he / k) * k;
                        } else he += he;
                        Je = (Pe + Oe) / 2, Oe = H(Pe * Oe), Je = ((Pe = Je) - Oe) / 2;
                    }
                    return he / (h(2, He) * Pe);
                }
                function Mo(he, be) {
                    var Pe = (C - 1) / (C + 1), Oe = H(1 - Pe * Pe), Je = ho(A, Oe * Oe), He = -1, et = u(b(k / 4 + n(be) / 2)), Mt = s(He * et) / H(Pe), Dt = xo(Mt * o(He * he), Mt * x(He * he)), Ut = Oo(Dt[0], Dt[1], Oe * Oe);
                    return [
                        -Ut[1],
                        (be >= 0 ? 1 : -1) * (.5 * Je - Ut[0])
                    ];
                }
                function xo(he, be) {
                    var Pe = he * he, Oe = be + 1, Je = 1 - Pe - be * be;
                    return [
                        .5 * ((he >= 0 ? A : -A) - a(Je, 2 * he)),
                        -0.25 * u(Je * Je + 4 * Pe) + .5 * u(Oe * Oe + Pe)
                    ];
                }
                function zs(he, be) {
                    var Pe = be[0] * be[0] + be[1] * be[1];
                    return [
                        (he[0] * be[0] + he[1] * be[1]) / Pe,
                        (he[1] * be[0] - he[0] * be[1]) / Pe
                    ];
                }
                Mo.invert = function(he, be) {
                    var Pe = (C - 1) / (C + 1), Oe = H(1 - Pe * Pe), Je = ho(A, Oe * Oe), He = -1, et = Sa(.5 * Je - be, -he, Oe * Oe), Mt = zs(et[0], et[1]), Dt = a(Mt[1], Mt[0]) / He;
                    return [
                        Dt,
                        2 * i(s(.5 / He * u(Pe * Mt[0] * Mt[0] + Pe * Mt[1] * Mt[1]))) - A
                    ];
                };
                function ks() {
                    return t.geoProjection(an(Mo)).scale(151.496);
                }
                function Zs(he) {
                    var be = x(he), Pe = o(he), Oe = Xs(he);
                    Oe.invert = Xs(-he);
                    function Je(He, et) {
                        var Mt = Oe(He, et);
                        He = Mt[0], et = Mt[1];
                        var Dt = x(et), Ut = o(et), tr = o(He), mr = V(be * Dt + Pe * Ut * tr), Rr = x(mr), zr = n(Rr) > p ? mr / Rr : 1;
                        return [
                            zr * Pe * x(He),
                            (n(He) > A ? zr : -zr) * (be * Ut - Pe * Dt * tr)
                        ];
                    }
                    return Je.invert = function(He, et) {
                        var Mt = H(He * He + et * et), Dt = -x(Mt), Ut = o(Mt), tr = Mt * Ut, mr = -et * Dt, Rr = Mt * be, zr = H(tr * tr + mr * mr - Rr * Rr), Xr = a(tr * Rr + mr * zr, mr * Rr - tr * zr), di = (Mt > A ? -1 : 1) * a(He * Dt, Mt * o(Xr) * Ut + et * x(Xr) * Dt);
                        return Oe.invert(di, Xr);
                    }, Je;
                }
                function Xs(he) {
                    var be = x(he), Pe = o(he);
                    return function(Oe, Je) {
                        var He = o(Je), et = o(Oe) * He, Mt = x(Oe) * He, Dt = x(Je);
                        return [
                            a(Mt, et * Pe - Dt * be),
                            q(Dt * Pe + et * be)
                        ];
                    };
                }
                function wl() {
                    var he = 0, be = t.geoProjectionMutator(Zs), Pe = be(he), Oe = Pe.rotate, Je = Pe.stream, He = t.geoCircle();
                    return Pe.parallel = function(et) {
                        if (!arguments.length) return he * P;
                        var Mt = Pe.rotate();
                        return be(he = et * T).rotate(Mt);
                    }, Pe.rotate = function(et) {
                        return arguments.length ? (Oe.call(Pe, [
                            et[0],
                            et[1] - he * P
                        ]), He.center([
                            -et[0],
                            -et[1]
                        ]), Pe) : (et = Oe.call(Pe), et[1] += he * P, et);
                    }, Pe.stream = function(et) {
                        return et = Je(et), et.sphere = function() {
                            et.polygonStart();
                            var Mt = .01, Dt = He.radius(90 - Mt)().coordinates[0], Ut = Dt.length - 1, tr = -1, mr;
                            for(et.lineStart(); ++tr < Ut;)et.point((mr = Dt[tr])[0], mr[1]);
                            for(et.lineEnd(), Dt = He.radius(90 + Mt)().coordinates[0], Ut = Dt.length - 1, et.lineStart(); --tr >= 0;)et.point((mr = Dt[tr])[0], mr[1]);
                            et.lineEnd(), et.polygonEnd();
                        }, et;
                    }, Pe.scale(79.4187).parallel(45).clipAngle(179.999);
                }
                var os = 3, cl = q(1 - 1 / os) * P, Cs = ar(0);
                function ml(he) {
                    var be = cl * T, Pe = ht(k, be)[0] - ht(-k, be)[0], Oe = Cs(0, be)[1], Je = ht(0, be)[1], He = M - Je, et = g / he, Mt = 4 / g, Dt = Oe + He * He * 4 / g;
                    function Ut(tr, mr) {
                        var Rr, zr = n(mr);
                        if (zr > be) {
                            var Xr = f(he - 1, c(0, l((tr + k) / et)));
                            tr += k * (he - 1) / he - Xr * et, Rr = ht(tr, zr), Rr[0] = Rr[0] * g / Pe - g * (he - 1) / (2 * he) + Xr * g / he, Rr[1] = Oe + (Rr[1] - Je) * 4 * He / g, mr < 0 && (Rr[1] = -Rr[1]);
                        } else Rr = Cs(tr, mr);
                        return Rr[0] *= Mt, Rr[1] /= Dt, Rr;
                    }
                    return Ut.invert = function(tr, mr) {
                        tr /= Mt, mr *= Dt;
                        var Rr = n(mr);
                        if (Rr > Oe) {
                            var zr = f(he - 1, c(0, l((tr + k) / et)));
                            tr = (tr + k * (he - 1) / he - zr * et) * Pe / g;
                            var Xr = ht.invert(tr, .25 * (Rr - Oe) * g / He + Je);
                            return Xr[0] -= k * (he - 1) / he - zr * et, mr < 0 && (Xr[1] = -Xr[1]), Xr;
                        }
                        return Cs.invert(tr, mr);
                    }, Ut;
                }
                function Ys(he, be) {
                    return [
                        he,
                        be & 1 ? 90 - p : cl
                    ];
                }
                function Hs(he, be) {
                    return [
                        he,
                        be & 1 ? -90 + p : -cl
                    ];
                }
                function Eo(he) {
                    return [
                        he[0] * (1 - p),
                        he[1]
                    ];
                }
                function fs(he) {
                    var be = [].concat(r.range(-180, 180 + he / 2, he).map(Ys), r.range(180, -180 - he / 2, -he).map(Hs));
                    return {
                        type: "Polygon",
                        coordinates: [
                            he === 180 ? be.map(Eo) : be
                        ]
                    };
                }
                function Ql() {
                    var he = 4, be = t.geoProjectionMutator(ml), Pe = be(he), Oe = Pe.stream;
                    return Pe.lobes = function(Je) {
                        return arguments.length ? be(he = +Je) : he;
                    }, Pe.stream = function(Je) {
                        var He = Pe.rotate(), et = Oe(Je), Mt = (Pe.rotate([
                            0,
                            0
                        ]), Oe(Je));
                        return Pe.rotate(He), et.sphere = function() {
                            t.geoStream(fs(180 / he), Mt);
                        }, et;
                    }, Pe.scale(239.75);
                }
                function Hu(he) {
                    var be = 1 + he, Pe = x(1 / be), Oe = q(Pe), Je = 2 * H(k / (He = k + 4 * Oe * be)), He, et = .5 * Je * (be + H(he * (2 + he))), Mt = he * he, Dt = be * be;
                    function Ut(tr, mr) {
                        var Rr = 1 - x(mr), zr, Xr;
                        if (Rr && Rr < 2) {
                            var di = A - mr, Li = 25, Ci;
                            do {
                                var Qi = x(di), Mn = o(di), pa = Oe + a(Qi, be - Mn), ea = 1 + Dt - 2 * be * Mn;
                                di -= Ci = (di - Mt * Oe - be * Qi + ea * pa - .5 * Rr * He) / (2 * be * Qi * pa);
                            }while (n(Ci) > E && --Li > 0);
                            zr = Je * H(ea), Xr = tr * pa / k;
                        } else zr = Je * (he + Rr), Xr = tr * Oe / k;
                        return [
                            zr * x(Xr),
                            et - zr * o(Xr)
                        ];
                    }
                    return Ut.invert = function(tr, mr) {
                        var Rr = tr * tr + (mr -= et) * mr, zr = (1 + Dt - Rr / (Je * Je)) / (2 * be), Xr = V(zr), di = x(Xr), Li = Oe + a(di, be - zr);
                        return [
                            q(tr / H(Rr)) * k / Li,
                            q(1 - 2 * (Xr - Mt * Oe - be * di + (1 + Dt - 2 * be * zr) * Li) / He)
                        ];
                    }, Ut;
                }
                function fc() {
                    var he = 1, be = t.geoProjectionMutator(Hu), Pe = be(he);
                    return Pe.ratio = function(Oe) {
                        return arguments.length ? be(he = +Oe) : he;
                    }, Pe.scale(167.774).center([
                        0,
                        18.67
                    ]);
                }
                var ms = .7109889596207567, on = .0528035274542;
                function fa(he, be) {
                    return be > -ms ? (he = Yt(he, be), he[1] += on, he) : St(he, be);
                }
                fa.invert = function(he, be) {
                    return be > -ms ? Yt.invert(he, be - on) : St.invert(he, be);
                };
                function Qu() {
                    return t.geoProjection(fa).rotate([
                        -20,
                        -55
                    ]).scale(164.263).center([
                        0,
                        -5.4036
                    ]);
                }
                function Rl(he, be) {
                    return n(be) > ms ? (he = Yt(he, be), he[1] -= be > 0 ? on : -on, he) : St(he, be);
                }
                Rl.invert = function(he, be) {
                    return n(be) > ms ? Yt.invert(he, be + (be > 0 ? on : -on)) : St.invert(he, be);
                };
                function vo() {
                    return t.geoProjection(Rl).scale(152.63);
                }
                function Zl(he, be, Pe, Oe) {
                    var Je = H(4 * k / (2 * Pe + (1 + he - be / 2) * x(2 * Pe) + (he + be) / 2 * x(4 * Pe) + be / 2 * x(6 * Pe))), He = H(Oe * x(Pe) * H((1 + he * o(2 * Pe) + be * o(4 * Pe)) / (1 + he + be))), et = Pe * Dt(1);
                    function Mt(mr) {
                        return H(1 + he * o(2 * mr) + be * o(4 * mr));
                    }
                    function Dt(mr) {
                        var Rr = mr * Pe;
                        return (2 * Rr + (1 + he - be / 2) * x(2 * Rr) + (he + be) / 2 * x(4 * Rr) + be / 2 * x(6 * Rr)) / Pe;
                    }
                    function Ut(mr) {
                        return Mt(mr) * x(mr);
                    }
                    var tr = function(mr, Rr) {
                        var zr = Pe * qt(Dt, et * x(Rr) / Pe, Rr / k);
                        isNaN(zr) && (zr = Pe * v(Rr));
                        var Xr = Je * Mt(zr);
                        return [
                            Xr * He * mr / k * o(zr),
                            Xr / He * x(zr)
                        ];
                    };
                    return tr.invert = function(mr, Rr) {
                        var zr = qt(Ut, Rr * He / Je);
                        return [
                            mr * k / (o(zr) * Je * He * Mt(zr)),
                            q(Pe * Dt(zr / Pe) / et)
                        ];
                    }, Pe === 0 && (Je = H(Oe / k), tr = function(mr, Rr) {
                        return [
                            mr * Je,
                            x(Rr) / Je
                        ];
                    }, tr.invert = function(mr, Rr) {
                        return [
                            mr / Je,
                            q(Rr * Je)
                        ];
                    }), tr;
                }
                function Ks() {
                    var he = 1, be = 0, Pe = 45 * T, Oe = 2, Je = t.geoProjectionMutator(Zl), He = Je(he, be, Pe, Oe);
                    return He.a = function(et) {
                        return arguments.length ? Je(he = +et, be, Pe, Oe) : he;
                    }, He.b = function(et) {
                        return arguments.length ? Je(he, be = +et, Pe, Oe) : be;
                    }, He.psiMax = function(et) {
                        return arguments.length ? Je(he, be, Pe = +et * T, Oe) : Pe * P;
                    }, He.ratio = function(et) {
                        return arguments.length ? Je(he, be, Pe, Oe = +et) : Oe;
                    }, He.scale(180.739);
                }
                function Xl(he, be, Pe, Oe, Je, He, et, Mt, Dt, Ut, tr) {
                    if (tr.nanEncountered) return NaN;
                    var mr, Rr, zr, Xr, di, Li, Ci, Qi, Mn, pa;
                    if (mr = Pe - be, Rr = he(be + mr * .25), zr = he(Pe - mr * .25), isNaN(Rr)) {
                        tr.nanEncountered = !0;
                        return;
                    }
                    if (isNaN(zr)) {
                        tr.nanEncountered = !0;
                        return;
                    }
                    return Xr = mr * (Oe + 4 * Rr + Je) / 12, di = mr * (Je + 4 * zr + He) / 12, Li = Xr + di, pa = (Li - et) / 15, Ut > Dt ? (tr.maxDepthCount++, Li + pa) : Math.abs(pa) < Mt ? Li + pa : (Ci = be + mr * .5, Qi = Xl(he, be, Ci, Oe, Rr, Je, Xr, Mt * .5, Dt, Ut + 1, tr), isNaN(Qi) ? (tr.nanEncountered = !0, NaN) : (Mn = Xl(he, Ci, Pe, Je, zr, He, di, Mt * .5, Dt, Ut + 1, tr), isNaN(Mn) ? (tr.nanEncountered = !0, NaN) : Qi + Mn));
                }
                function Ec(he, be, Pe, Oe, Je) {
                    var He = {
                        maxDepthCount: 0,
                        nanEncountered: !1
                    };
                    Oe === void 0 && (Oe = 1e-8), Je === void 0 && (Je = 20);
                    var et = he(be), Mt = he(.5 * (be + Pe)), Dt = he(Pe), Ut = (et + 4 * Mt + Dt) * (Pe - be) / 6, tr = Xl(he, be, Pe, et, Mt, Dt, Ut, Oe, Je, 1, He);
                    return tr;
                }
                function Zn(he, be, Pe) {
                    function Oe(zr) {
                        return he + (1 - he) * h(1 - h(zr, be), 1 / be);
                    }
                    function Je(zr) {
                        return Ec(Oe, 0, zr, 1e-4);
                    }
                    for(var He = 1 / Je(1), et = 1e3, Mt = (1 + 1e-8) * He, Dt = [], Ut = 0; Ut <= et; Ut++)Dt.push(Je(Ut / et) * Mt);
                    function tr(zr) {
                        var Xr = 0, di = et, Li = et >> 1;
                        do Dt[Li] > zr ? di = Li : Xr = Li, Li = Xr + di >> 1;
                        while (Li > Xr);
                        var Ci = Dt[Li + 1] - Dt[Li];
                        return Ci && (Ci = (zr - Dt[Li + 1]) / Ci), (Li + 1 + Ci) / et;
                    }
                    var mr = 2 * tr(1) / k * He / Pe, Rr = function(zr, Xr) {
                        var di = tr(n(x(Xr))), Li = Oe(di) * zr;
                        return di /= mr, [
                            Li,
                            Xr >= 0 ? di : -di
                        ];
                    };
                    return Rr.invert = function(zr, Xr) {
                        var di;
                        return Xr *= mr, n(Xr) < 1 && (di = v(Xr) * q(Je(n(Xr)) * He)), [
                            zr / Oe(n(Xr)),
                            di
                        ];
                    }, Rr;
                }
                function ko() {
                    var he = 0, be = 2.5, Pe = 1.183136, Oe = t.geoProjectionMutator(Zn), Je = Oe(he, be, Pe);
                    return Je.alpha = function(He) {
                        return arguments.length ? Oe(he = +He, be, Pe) : he;
                    }, Je.k = function(He) {
                        return arguments.length ? Oe(he, be = +He, Pe) : be;
                    }, Je.gamma = function(He) {
                        return arguments.length ? Oe(he, be, Pe = +He) : Pe;
                    }, Je.scale(152.63);
                }
                function Co(he, be) {
                    return n(he[0] - be[0]) < p && n(he[1] - be[1]) < p;
                }
                function Tl(he, be) {
                    for(var Pe = -1, Oe = he.length, Je = he[0], He, et, Mt, Dt = []; ++Pe < Oe;){
                        He = he[Pe], et = (He[0] - Je[0]) / be, Mt = (He[1] - Je[1]) / be;
                        for(var Ut = 0; Ut < be; ++Ut)Dt.push([
                            Je[0] + Ut * et,
                            Je[1] + Ut * Mt
                        ]);
                        Je = He;
                    }
                    return Dt.push(He), Dt;
                }
                function uf(he) {
                    var be = [], Pe, Oe, Je, He, et, Mt, Dt, Ut = he[0].length;
                    for(Dt = 0; Dt < Ut; ++Dt)Pe = he[0][Dt], Oe = Pe[0][0], Je = Pe[0][1], He = Pe[1][1], et = Pe[2][0], Mt = Pe[2][1], be.push(Tl([
                        [
                            Oe + p,
                            Je + p
                        ],
                        [
                            Oe + p,
                            He - p
                        ],
                        [
                            et - p,
                            He - p
                        ],
                        [
                            et - p,
                            Mt + p
                        ]
                    ], 30));
                    for(Dt = he[1].length - 1; Dt >= 0; --Dt)Pe = he[1][Dt], Oe = Pe[0][0], Je = Pe[0][1], He = Pe[1][1], et = Pe[2][0], Mt = Pe[2][1], be.push(Tl([
                        [
                            et - p,
                            Mt - p
                        ],
                        [
                            et - p,
                            He + p
                        ],
                        [
                            Oe + p,
                            He + p
                        ],
                        [
                            Oe + p,
                            Je - p
                        ]
                    ], 30));
                    return {
                        type: "Polygon",
                        coordinates: [
                            r.merge(be)
                        ]
                    };
                }
                function So(he, be, Pe) {
                    var Oe, Je;
                    function He(Dt, Ut) {
                        for(var tr = Ut < 0 ? -1 : 1, mr = be[+(Ut < 0)], Rr = 0, zr = mr.length - 1; Rr < zr && Dt > mr[Rr][2][0]; ++Rr);
                        var Xr = he(Dt - mr[Rr][1][0], Ut);
                        return Xr[0] += he(mr[Rr][1][0], tr * Ut > tr * mr[Rr][0][1] ? mr[Rr][0][1] : Ut)[0], Xr;
                    }
                    Pe ? He.invert = Pe(He) : he.invert && (He.invert = function(Dt, Ut) {
                        for(var tr = Je[+(Ut < 0)], mr = be[+(Ut < 0)], Rr = 0, zr = tr.length; Rr < zr; ++Rr){
                            var Xr = tr[Rr];
                            if (Xr[0][0] <= Dt && Dt < Xr[1][0] && Xr[0][1] <= Ut && Ut < Xr[1][1]) {
                                var di = he.invert(Dt - he(mr[Rr][1][0], 0)[0], Ut);
                                return di[0] += mr[Rr][1][0], Co(He(di[0], di[1]), [
                                    Dt,
                                    Ut
                                ]) ? di : null;
                            }
                        }
                    });
                    var et = t.geoProjection(He), Mt = et.stream;
                    return et.stream = function(Dt) {
                        var Ut = et.rotate(), tr = Mt(Dt), mr = (et.rotate([
                            0,
                            0
                        ]), Mt(Dt));
                        return et.rotate(Ut), tr.sphere = function() {
                            t.geoStream(Oe, mr);
                        }, tr;
                    }, et.lobes = function(Dt) {
                        return arguments.length ? (Oe = uf(Dt), be = Dt.map(function(Ut) {
                            return Ut.map(function(tr) {
                                return [
                                    [
                                        tr[0][0] * T,
                                        tr[0][1] * T
                                    ],
                                    [
                                        tr[1][0] * T,
                                        tr[1][1] * T
                                    ],
                                    [
                                        tr[2][0] * T,
                                        tr[2][1] * T
                                    ]
                                ];
                            });
                        }), Je = be.map(function(Ut) {
                            return Ut.map(function(tr) {
                                var mr = he(tr[0][0], tr[0][1])[0], Rr = he(tr[2][0], tr[2][1])[0], zr = he(tr[1][0], tr[0][1])[1], Xr = he(tr[1][0], tr[1][1])[1], di;
                                return zr > Xr && (di = zr, zr = Xr, Xr = di), [
                                    [
                                        mr,
                                        zr
                                    ],
                                    [
                                        Rr,
                                        Xr
                                    ]
                                ];
                            });
                        }), et) : be.map(function(Ut) {
                            return Ut.map(function(tr) {
                                return [
                                    [
                                        tr[0][0] * P,
                                        tr[0][1] * P
                                    ],
                                    [
                                        tr[1][0] * P,
                                        tr[1][1] * P
                                    ],
                                    [
                                        tr[2][0] * P,
                                        tr[2][1] * P
                                    ]
                                ];
                            });
                        });
                    }, be != null && et.lobes(be), et;
                }
                var cf = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -100,
                                90
                            ],
                            [
                                -40,
                                0
                            ]
                        ],
                        [
                            [
                                -40,
                                0
                            ],
                            [
                                30,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -160,
                                -90
                            ],
                            [
                                -100,
                                0
                            ]
                        ],
                        [
                            [
                                -100,
                                0
                            ],
                            [
                                -60,
                                -90
                            ],
                            [
                                -20,
                                0
                            ]
                        ],
                        [
                            [
                                -20,
                                0
                            ],
                            [
                                20,
                                -90
                            ],
                            [
                                80,
                                0
                            ]
                        ],
                        [
                            [
                                80,
                                0
                            ],
                            [
                                140,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function rh() {
                    return So(xt, cf).scale(160.857);
                }
                var Al = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -100,
                                90
                            ],
                            [
                                -40,
                                0
                            ]
                        ],
                        [
                            [
                                -40,
                                0
                            ],
                            [
                                30,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -160,
                                -90
                            ],
                            [
                                -100,
                                0
                            ]
                        ],
                        [
                            [
                                -100,
                                0
                            ],
                            [
                                -60,
                                -90
                            ],
                            [
                                -20,
                                0
                            ]
                        ],
                        [
                            [
                                -20,
                                0
                            ],
                            [
                                20,
                                -90
                            ],
                            [
                                80,
                                0
                            ]
                        ],
                        [
                            [
                                80,
                                0
                            ],
                            [
                                140,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function Hc() {
                    return So(Rl, Al).scale(152.63);
                }
                var eu = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -100,
                                90
                            ],
                            [
                                -40,
                                0
                            ]
                        ],
                        [
                            [
                                -40,
                                0
                            ],
                            [
                                30,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -160,
                                -90
                            ],
                            [
                                -100,
                                0
                            ]
                        ],
                        [
                            [
                                -100,
                                0
                            ],
                            [
                                -60,
                                -90
                            ],
                            [
                                -20,
                                0
                            ]
                        ],
                        [
                            [
                                -20,
                                0
                            ],
                            [
                                20,
                                -90
                            ],
                            [
                                80,
                                0
                            ]
                        ],
                        [
                            [
                                80,
                                0
                            ],
                            [
                                140,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function Ls() {
                    return So(Yt, eu).scale(169.529);
                }
                var mu = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -90,
                                90
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        [
                            [
                                0,
                                0
                            ],
                            [
                                90,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -90,
                                -90
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        [
                            [
                                0,
                                0
                            ],
                            [
                                90,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function kc() {
                    return So(Yt, mu).scale(169.529).rotate([
                        20,
                        0
                    ]);
                }
                var Of = [
                    [
                        [
                            [
                                -180,
                                35
                            ],
                            [
                                -30,
                                90
                            ],
                            [
                                0,
                                35
                            ]
                        ],
                        [
                            [
                                0,
                                35
                            ],
                            [
                                30,
                                90
                            ],
                            [
                                180,
                                35
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                -10
                            ],
                            [
                                -102,
                                -90
                            ],
                            [
                                -65,
                                -10
                            ]
                        ],
                        [
                            [
                                -65,
                                -10
                            ],
                            [
                                5,
                                -90
                            ],
                            [
                                77,
                                -10
                            ]
                        ],
                        [
                            [
                                77,
                                -10
                            ],
                            [
                                103,
                                -90
                            ],
                            [
                                180,
                                -10
                            ]
                        ]
                    ]
                ];
                function Gc() {
                    return So(fa, Of, rt).rotate([
                        -20,
                        -55
                    ]).scale(164.263).center([
                        0,
                        -5.4036
                    ]);
                }
                var vd = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -110,
                                90
                            ],
                            [
                                -40,
                                0
                            ]
                        ],
                        [
                            [
                                -40,
                                0
                            ],
                            [
                                0,
                                90
                            ],
                            [
                                40,
                                0
                            ]
                        ],
                        [
                            [
                                40,
                                0
                            ],
                            [
                                110,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -110,
                                -90
                            ],
                            [
                                -40,
                                0
                            ]
                        ],
                        [
                            [
                                -40,
                                0
                            ],
                            [
                                0,
                                -90
                            ],
                            [
                                40,
                                0
                            ]
                        ],
                        [
                            [
                                40,
                                0
                            ],
                            [
                                110,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function Bf() {
                    return So(St, vd).scale(152.63).rotate([
                        -20,
                        0
                    ]);
                }
                function ss(he, be) {
                    return [
                        3 / g * he * H(k * k / 3 - be * be),
                        be
                    ];
                }
                ss.invert = function(he, be) {
                    return [
                        g / 3 * he / H(k * k / 3 - be * be),
                        be
                    ];
                };
                function ff() {
                    return t.geoProjection(ss).scale(158.837);
                }
                function ih(he) {
                    function be(Pe, Oe) {
                        if (n(n(Oe) - A) < p) return [
                            0,
                            Oe < 0 ? -2 : 2
                        ];
                        var Je = x(Oe), He = h((1 + Je) / (1 - Je), he / 2), et = .5 * (He + 1 / He) + o(Pe *= he);
                        return [
                            2 * x(Pe) / et,
                            (He - 1 / He) / et
                        ];
                    }
                    return be.invert = function(Pe, Oe) {
                        var Je = n(Oe);
                        if (n(Je - 2) < p) return Pe ? null : [
                            0,
                            v(Oe) * A
                        ];
                        if (Je > 2) return null;
                        Pe /= 2, Oe /= 2;
                        var He = Pe * Pe, et = Oe * Oe, Mt = 2 * Oe / (1 + He + et);
                        return Mt = h((1 + Mt) / (1 - Mt), 1 / he), [
                            a(2 * Pe, 1 - He - et) / he,
                            q((Mt - 1) / (Mt + 1))
                        ];
                    }, be;
                }
                function Vl() {
                    var he = .5, be = t.geoProjectionMutator(ih), Pe = be(he);
                    return Pe.spacing = function(Oe) {
                        return arguments.length ? be(he = +Oe) : he;
                    }, Pe.scale(124.75);
                }
                var Js = k / C;
                function hc(he, be) {
                    return [
                        he * (1 + H(o(be))) / 2,
                        be / (o(be / 2) * o(he / 6))
                    ];
                }
                hc.invert = function(he, be) {
                    var Pe = n(he), Oe = n(be), Je = p, He = A;
                    Oe < Js ? He *= Oe / Js : Je += 6 * V(Js / Oe);
                    for(var et = 0; et < 25; et++){
                        var Mt = x(He), Dt = H(o(He)), Ut = x(He / 2), tr = o(He / 2), mr = x(Je / 6), Rr = o(Je / 6), zr = .5 * Je * (1 + Dt) - Pe, Xr = He / (tr * Rr) - Oe, di = Dt ? -0.25 * Je * Mt / Dt : 0, Li = .5 * (1 + Dt), Ci = (1 + .5 * He * Ut / tr) / (tr * Rr), Qi = He / tr * (mr / 6) / (Rr * Rr), Mn = di * Qi - Ci * Li, pa = (zr * Qi - Xr * Li) / Mn, ea = (Xr * di - zr * Ci) / Mn;
                        if (He -= pa, Je -= ea, n(pa) < p && n(ea) < p) break;
                    }
                    return [
                        he < 0 ? -Je : Je,
                        be < 0 ? -He : He
                    ];
                };
                function Cc() {
                    return t.geoProjection(hc).scale(97.2672);
                }
                function ws(he, be) {
                    var Pe = he * he, Oe = be * be;
                    return [
                        he * (.975534 + Oe * (-0.119161 + Pe * -0.0143059 + Oe * -0.0547009)),
                        be * (1.00384 + Pe * (.0802894 + Oe * -0.02855 + Pe * 199025e-9) + Oe * (.0998909 + Oe * -0.0491032))
                    ];
                }
                ws.invert = function(he, be) {
                    var Pe = v(he) * k, Oe = be / 2, Je = 50;
                    do {
                        var He = Pe * Pe, et = Oe * Oe, Mt = Pe * Oe, Dt = Pe * (.975534 + et * (-0.119161 + He * -0.0143059 + et * -0.0547009)) - he, Ut = Oe * (1.00384 + He * (.0802894 + et * -0.02855 + He * 199025e-9) + et * (.0998909 + et * -0.0491032)) - be, tr = .975534 - et * (.119161 + 3 * He * .0143059 + et * .0547009), mr = -Mt * (0.238322 + 0.2188036 * et + 0.0286118 * He), Rr = Mt * (0.1605788 + 0.0007961 * He + -0.0571 * et), zr = 1.00384 + He * (.0802894 + 199025e-9 * He) + et * (3 * (.0998909 - .02855 * He) - 0.245516 * et), Xr = mr * Rr - zr * tr, di = (Ut * mr - Dt * zr) / Xr, Li = (Dt * Rr - Ut * tr) / Xr;
                        Pe -= di, Oe -= Li;
                    }while ((n(di) > p || n(Li) > p) && --Je > 0);
                    return Je && [
                        Pe,
                        Oe
                    ];
                };
                function $s() {
                    return t.geoProjection(ws).scale(139.98);
                }
                function hs(he, be) {
                    return [
                        x(he) / o(be),
                        b(be) * o(he)
                    ];
                }
                hs.invert = function(he, be) {
                    var Pe = he * he, Oe = be * be, Je = Oe + 1, He = Pe + Je, et = he ? _ * H((He - H(He * He - 4 * Pe)) / Pe) : 1 / H(Je);
                    return [
                        q(he * et),
                        v(be) * V(et)
                    ];
                };
                function Ms() {
                    return t.geoProjection(hs).scale(144.049).clipAngle(89.999);
                }
                function dc(he) {
                    var be = o(he), Pe = b(L + he / 2);
                    function Oe(Je, He) {
                        var et = He - he, Mt = n(et) < p ? Je * be : n(Mt = L + He / 2) < p || n(n(Mt) - A) < p ? 0 : Je * et / u(b(Mt) / Pe);
                        return [
                            Mt,
                            et
                        ];
                    }
                    return Oe.invert = function(Je, He) {
                        var et, Mt = He + he;
                        return [
                            n(He) < p ? Je / be : n(et = L + Mt / 2) < p || n(n(et) - A) < p ? 0 : Je * u(b(et) / Pe) / He,
                            Mt
                        ];
                    }, Oe;
                }
                function Sl() {
                    return Lt(dc).parallel(40).scale(158.837);
                }
                function ec(he, be) {
                    return [
                        he,
                        1.25 * u(b(L + .4 * be))
                    ];
                }
                ec.invert = function(he, be) {
                    return [
                        he,
                        2.5 * i(s(.8 * be)) - .625 * k
                    ];
                };
                function Ps() {
                    return t.geoProjection(ec).scale(108.318);
                }
                function ov(he) {
                    var be = he.length - 1;
                    function Pe(Oe, Je) {
                        for(var He = o(Je), et = 2 / (1 + He * o(Oe)), Mt = et * He * x(Oe), Dt = et * x(Je), Ut = be, tr = he[Ut], mr = tr[0], Rr = tr[1], zr; --Ut >= 0;)tr = he[Ut], mr = tr[0] + Mt * (zr = mr) - Dt * Rr, Rr = tr[1] + Mt * Rr + Dt * zr;
                        return mr = Mt * (zr = mr) - Dt * Rr, Rr = Mt * Rr + Dt * zr, [
                            mr,
                            Rr
                        ];
                    }
                    return Pe.invert = function(Oe, Je) {
                        var He = 20, et = Oe, Mt = Je;
                        do {
                            for(var Dt = be, Ut = he[Dt], tr = Ut[0], mr = Ut[1], Rr = 0, zr = 0, Xr; --Dt >= 0;)Ut = he[Dt], Rr = tr + et * (Xr = Rr) - Mt * zr, zr = mr + et * zr + Mt * Xr, tr = Ut[0] + et * (Xr = tr) - Mt * mr, mr = Ut[1] + et * mr + Mt * Xr;
                            Rr = tr + et * (Xr = Rr) - Mt * zr, zr = mr + et * zr + Mt * Xr, tr = et * (Xr = tr) - Mt * mr - Oe, mr = et * mr + Mt * Xr - Je;
                            var di = Rr * Rr + zr * zr, Li, Ci;
                            et -= Li = (tr * Rr + mr * zr) / di, Mt -= Ci = (mr * Rr - tr * zr) / di;
                        }while (n(Li) + n(Ci) > p * p && --He > 0);
                        if (He) {
                            var Qi = H(et * et + Mt * Mt), Mn = 2 * i(Qi * .5), pa = x(Mn);
                            return [
                                a(et * pa, Qi * o(Mn)),
                                Qi ? q(Mt * pa / Qi) : 0
                            ];
                        }
                    }, Pe;
                }
                var wo = [
                    [
                        .9972523,
                        0
                    ],
                    [
                        .0052513,
                        -0.0041175
                    ],
                    [
                        .0074606,
                        .0048125
                    ],
                    [
                        -0.0153783,
                        -0.1968253
                    ],
                    [
                        .0636871,
                        -0.1408027
                    ],
                    [
                        .3660976,
                        -0.2937382
                    ]
                ], Od = [
                    [
                        .98879,
                        0
                    ],
                    [
                        0,
                        0
                    ],
                    [
                        -0.050909,
                        0
                    ],
                    [
                        0,
                        0
                    ],
                    [
                        .075528,
                        0
                    ]
                ], $o = [
                    [
                        .984299,
                        0
                    ],
                    [
                        .0211642,
                        .0037608
                    ],
                    [
                        -0.1036018,
                        -0.0575102
                    ],
                    [
                        -0.0329095,
                        -0.0320119
                    ],
                    [
                        .0499471,
                        .1223335
                    ],
                    [
                        .026046,
                        .0899805
                    ],
                    [
                        7388e-7,
                        -0.1435792
                    ],
                    [
                        .0075848,
                        -0.1334108
                    ],
                    [
                        -0.0216473,
                        .0776645
                    ],
                    [
                        -0.0225161,
                        .0853673
                    ]
                ], Ja = [
                    [
                        .9245,
                        0
                    ],
                    [
                        0,
                        0
                    ],
                    [
                        .01943,
                        0
                    ]
                ], Ef = [
                    [
                        .721316,
                        0
                    ],
                    [
                        0,
                        0
                    ],
                    [
                        -0.00881625,
                        -0.00617325
                    ]
                ];
                function tc() {
                    return Ml(wo, [
                        152,
                        -64
                    ]).scale(1400).center([
                        -160.908,
                        62.4864
                    ]).clipAngle(30).angle(7.8);
                }
                function uu() {
                    return Ml(Od, [
                        95,
                        -38
                    ]).scale(1e3).clipAngle(55).center([
                        -96.5563,
                        38.8675
                    ]);
                }
                function Mh() {
                    return Ml($o, [
                        120,
                        -45
                    ]).scale(359.513).clipAngle(55).center([
                        -117.474,
                        53.0628
                    ]);
                }
                function jc() {
                    return Ml(Ja, [
                        -20,
                        -18
                    ]).scale(209.091).center([
                        20,
                        16.7214
                    ]).clipAngle(82);
                }
                function kf() {
                    return Ml(Ef, [
                        165,
                        10
                    ]).scale(250).clipAngle(130).center([
                        -165,
                        -10
                    ]);
                }
                function Ml(he, be) {
                    var Pe = t.geoProjection(ov(he)).rotate(be).clipAngle(90), Oe = t.geoRotation(be), Je = Pe.center;
                    return delete Pe.rotate, Pe.center = function(He) {
                        return arguments.length ? Je(Oe(He)) : Oe.invert(Je());
                    }, Pe;
                }
                var Yh = H(6), Eh = H(7);
                function nh(he, be) {
                    var Pe = q(7 * x(be) / (3 * Yh));
                    return [
                        Yh * he * (2 * o(2 * Pe / 3) - 1) / Eh,
                        9 * x(Pe / 3) / Eh
                    ];
                }
                nh.invert = function(he, be) {
                    var Pe = 3 * q(be * Eh / 9);
                    return [
                        he * Eh / (Yh * (2 * o(2 * Pe / 3) - 1)),
                        q(x(Pe) * 3 * Yh / 7)
                    ];
                };
                function hf() {
                    return t.geoProjection(nh).scale(164.859);
                }
                function kh(he, be) {
                    for(var Pe = (1 + _) * x(be), Oe = be, Je = 0, He; Je < 25 && (Oe -= He = (x(Oe / 2) + x(Oe) - Pe) / (.5 * o(Oe / 2) + o(Oe)), !(n(He) < p)); Je++);
                    return [
                        he * (1 + 2 * o(Oe) / o(Oe / 2)) / (3 * C),
                        2 * H(3) * x(Oe / 2) / H(2 + C)
                    ];
                }
                kh.invert = function(he, be) {
                    var Pe = be * H(2 + C) / (2 * H(3)), Oe = 2 * q(Pe);
                    return [
                        3 * C * he / (1 + 2 * o(Oe) / o(Oe / 2)),
                        q((Pe + x(Oe)) / (1 + _))
                    ];
                };
                function Kh() {
                    return t.geoProjection(kh).scale(188.209);
                }
                function rc(he, be) {
                    for(var Pe = H(6 / (4 + k)), Oe = (1 + k / 4) * x(be), Je = be / 2, He = 0, et; He < 25 && (Je -= et = (Je / 2 + x(Je) - Oe) / (.5 + o(Je)), !(n(et) < p)); He++);
                    return [
                        Pe * (.5 + o(Je)) * he / 1.5,
                        Pe * Je
                    ];
                }
                rc.invert = function(he, be) {
                    var Pe = H(6 / (4 + k)), Oe = be / Pe;
                    return n(n(Oe) - A) < p && (Oe = Oe < 0 ? -A : A), [
                        1.5 * he / (Pe * (.5 + o(Oe))),
                        q((Oe / 2 + x(Oe)) / (1 + k / 4))
                    ];
                };
                function ah() {
                    return t.geoProjection(rc).scale(166.518);
                }
                function Wc(he, be) {
                    var Pe = be * be, Oe = Pe * Pe, Je = Pe * Oe;
                    return [
                        he * (.84719 - .13063 * Pe + Je * Je * (-0.04515 + .05494 * Pe - .02326 * Oe + .00331 * Je)),
                        be * (1.01183 + Oe * Oe * (-0.02625 + .01926 * Pe - .00396 * Oe))
                    ];
                }
                Wc.invert = function(he, be) {
                    var Pe = be, Oe = 25, Je, He, et, Mt;
                    do He = Pe * Pe, et = He * He, Pe -= Je = (Pe * (1.01183 + et * et * (-0.02625 + .01926 * He - .00396 * et)) - be) / (1.01183 + et * et * (-0.23625 + 0.21186 * He + -0.05148 * et));
                    while (n(Je) > E && --Oe > 0);
                    return He = Pe * Pe, et = He * He, Mt = He * et, [
                        he / (.84719 - .13063 * He + Mt * Mt * (-0.04515 + .05494 * He - .02326 * et + .00331 * Mt)),
                        Pe
                    ];
                };
                function df() {
                    return t.geoProjection(Wc).scale(175.295);
                }
                function Cu(he, be) {
                    return [
                        he * (1 + o(be)) / 2,
                        2 * (be - b(be / 2))
                    ];
                }
                Cu.invert = function(he, be) {
                    for(var Pe = be / 2, Oe = 0, Je = 1 / 0; Oe < 10 && n(Je) > p; ++Oe){
                        var He = o(be / 2);
                        be -= Je = (be - b(be / 2) - Pe) / (1 - .5 / (He * He));
                    }
                    return [
                        2 * he / (1 + o(be)),
                        be
                    ];
                };
                function Nf() {
                    return t.geoProjection(Cu).scale(152.63);
                }
                var Zc = [
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -90,
                                90
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        [
                            [
                                0,
                                0
                            ],
                            [
                                90,
                                90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ],
                    [
                        [
                            [
                                -180,
                                0
                            ],
                            [
                                -90,
                                -90
                            ],
                            [
                                0,
                                0
                            ]
                        ],
                        [
                            [
                                0,
                                0
                            ],
                            [
                                90,
                                -90
                            ],
                            [
                                180,
                                0
                            ]
                        ]
                    ]
                ];
                function ds() {
                    return So(Ge(1 / 0), Zc).rotate([
                        20,
                        0
                    ]).scale(152.63);
                }
                function Ch(he, be) {
                    var Pe = x(be), Oe = o(be), Je = v(he);
                    if (he === 0 || n(be) === A) return [
                        0,
                        be
                    ];
                    if (be === 0) return [
                        he,
                        0
                    ];
                    if (n(he) === A) return [
                        he * Oe,
                        A * Pe
                    ];
                    var He = k / (2 * he) - 2 * he / k, et = 2 * be / k, Mt = (1 - et * et) / (Pe - et), Dt = He * He, Ut = Mt * Mt, tr = 1 + Dt / Ut, mr = 1 + Ut / Dt, Rr = (He * Pe / Mt - He / 2) / tr, zr = (Ut * Pe / Dt + Mt / 2) / mr, Xr = Rr * Rr + Oe * Oe / tr, di = zr * zr - (Ut * Pe * Pe / Dt + Mt * Pe - 1) / mr;
                    return [
                        A * (Rr + H(Xr) * Je),
                        A * (zr + H(di < 0 ? 0 : di) * v(-be * He) * Je)
                    ];
                }
                Ch.invert = function(he, be) {
                    he /= A, be /= A;
                    var Pe = he * he, Oe = be * be, Je = Pe + Oe, He = k * k;
                    return [
                        he ? (Je - 1 + H((1 - Je) * (1 - Je) + 4 * Pe)) / (2 * he) * A : 0,
                        qt(function(et) {
                            return Je * (k * x(et) - 2 * et) * k + 4 * et * et * (be - x(et)) + 2 * k * et - He * be;
                        }, 0)
                    ];
                };
                function Bd() {
                    return t.geoProjection(Ch).scale(127.267);
                }
                var Jh = 1.0148, Cf = .23185, pd = -0.14499, Lu = .02406, $h = Jh, tu = 5 * Cf, Pu = 7 * pd, Lc = 9 * Lu, fl = 1.790857183;
                function Xc(he, be) {
                    var Pe = be * be;
                    return [
                        he,
                        be * (Jh + Pe * Pe * (Cf + Pe * (pd + Lu * Pe)))
                    ];
                }
                Xc.invert = function(he, be) {
                    be > fl ? be = fl : be < -fl && (be = -fl);
                    var Pe = be, Oe;
                    do {
                        var Je = Pe * Pe;
                        Pe -= Oe = (Pe * (Jh + Je * Je * (Cf + Je * (pd + Lu * Je))) - be) / ($h + Je * Je * (tu + Je * (Pu + Lc * Je)));
                    }while (n(Oe) > p);
                    return [
                        he,
                        Pe
                    ];
                };
                function ic() {
                    return t.geoProjection(Xc).scale(139.319);
                }
                function yu(he, be) {
                    if (n(be) < p) return [
                        he,
                        0
                    ];
                    var Pe = b(be), Oe = he * x(be);
                    return [
                        x(Oe) / Pe,
                        be + (1 - o(Oe)) / Pe
                    ];
                }
                yu.invert = function(he, be) {
                    if (n(be) < p) return [
                        he,
                        0
                    ];
                    var Pe = he * he + be * be, Oe = be * .5, Je = 10, He;
                    do {
                        var et = b(Oe), Mt = 1 / o(Oe), Dt = Pe - 2 * be * Oe + Oe * Oe;
                        Oe -= He = (et * Dt + 2 * (Oe - be)) / (2 + Dt * Mt * Mt + 2 * (Oe - be) * et);
                    }while (n(He) > p && --Je > 0);
                    return et = b(Oe), [
                        (n(be) < n(Oe + 1 / et) ? q(he * et) : v(be) * v(he) * (V(n(he * et)) + A)) / x(Oe),
                        Oe
                    ];
                };
                function Qs() {
                    return t.geoProjection(yu).scale(103.74);
                }
                function Qh(he, be) {
                    var Pe = Pc(he[1], he[0]), Oe = Pc(be[1], be[0]), Je = sv(Pe, Oe), He = vc(Pe) / vc(Oe);
                    return Gu([
                        1,
                        0,
                        he[0][0],
                        0,
                        1,
                        he[0][1]
                    ], Gu([
                        He,
                        0,
                        0,
                        0,
                        He,
                        0
                    ], Gu([
                        o(Je),
                        x(Je),
                        0,
                        -x(Je),
                        o(Je),
                        0
                    ], [
                        1,
                        0,
                        -be[0][0],
                        0,
                        1,
                        -be[0][1]
                    ])));
                }
                function gd(he) {
                    var be = 1 / (he[0] * he[4] - he[1] * he[3]);
                    return [
                        be * he[4],
                        -be * he[1],
                        be * (he[1] * he[5] - he[2] * he[4]),
                        -be * he[3],
                        be * he[0],
                        be * (he[2] * he[3] - he[0] * he[5])
                    ];
                }
                function Gu(he, be) {
                    return [
                        he[0] * be[0] + he[1] * be[3],
                        he[0] * be[1] + he[1] * be[4],
                        he[0] * be[2] + he[1] * be[5] + he[2],
                        he[3] * be[0] + he[4] * be[3],
                        he[3] * be[1] + he[4] * be[4],
                        he[3] * be[2] + he[4] * be[5] + he[5]
                    ];
                }
                function Pc(he, be) {
                    return [
                        he[0] - be[0],
                        he[1] - be[1]
                    ];
                }
                function vc(he) {
                    return H(he[0] * he[0] + he[1] * he[1]);
                }
                function sv(he, be) {
                    return a(he[0] * be[1] - he[1] * be[0], he[0] * be[0] + he[1] * be[1]);
                }
                function Lf(he, be, Pe) {
                    Oe(he, {
                        transform: null
                    });
                    function Oe(Ut, tr) {
                        if (Ut.edges = ru(Ut.face), tr.face) {
                            var mr = Ut.shared = oh(Ut.face, tr.face), Rr = Qh(mr.map(tr.project), mr.map(Ut.project));
                            Ut.transform = tr.transform ? Gu(tr.transform, Rr) : Rr;
                            for(var zr = tr.edges, Xr = 0, di = zr.length; Xr < di; ++Xr)Iu(mr[0], zr[Xr][1]) && Iu(mr[1], zr[Xr][0]) && (zr[Xr] = Ut), Iu(mr[0], zr[Xr][0]) && Iu(mr[1], zr[Xr][1]) && (zr[Xr] = Ut);
                            for(zr = Ut.edges, Xr = 0, di = zr.length; Xr < di; ++Xr)Iu(mr[0], zr[Xr][0]) && Iu(mr[1], zr[Xr][1]) && (zr[Xr] = tr), Iu(mr[0], zr[Xr][1]) && Iu(mr[1], zr[Xr][0]) && (zr[Xr] = tr);
                        } else Ut.transform = tr.transform;
                        return Ut.children && Ut.children.forEach(function(Li) {
                            Oe(Li, Ut);
                        }), Ut;
                    }
                    function Je(Ut, tr) {
                        var mr = be(Ut, tr), Rr = mr.project([
                            Ut * P,
                            tr * P
                        ]), zr;
                        return (zr = mr.transform) ? [
                            zr[0] * Rr[0] + zr[1] * Rr[1] + zr[2],
                            -(zr[3] * Rr[0] + zr[4] * Rr[1] + zr[5])
                        ] : (Rr[1] = -Rr[1], Rr);
                    }
                    vf(he) && (Je.invert = function(Ut, tr) {
                        var mr = He(he, [
                            Ut,
                            -tr
                        ]);
                        return mr && (mr[0] *= T, mr[1] *= T, mr);
                    });
                    function He(Ut, tr) {
                        var mr = Ut.project.invert, Rr = Ut.transform, zr = tr;
                        if (Rr && (Rr = gd(Rr), zr = [
                            Rr[0] * zr[0] + Rr[1] * zr[1] + Rr[2],
                            Rr[3] * zr[0] + Rr[4] * zr[1] + Rr[5]
                        ]), mr && Ut === et(Xr = mr(zr))) return Xr;
                        for(var Xr, di = Ut.children, Li = 0, Ci = di && di.length; Li < Ci; ++Li)if (Xr = He(di[Li], tr)) return Xr;
                    }
                    function et(Ut) {
                        return be(Ut[0] * T, Ut[1] * T);
                    }
                    var Mt = t.geoProjection(Je), Dt = Mt.stream;
                    return Mt.stream = function(Ut) {
                        var tr = Mt.rotate(), mr = Dt(Ut), Rr = (Mt.rotate([
                            0,
                            0
                        ]), Dt(Ut));
                        return Mt.rotate(tr), mr.sphere = function() {
                            Rr.polygonStart(), Rr.lineStart(), Uf(Rr, he), Rr.lineEnd(), Rr.polygonEnd();
                        }, mr;
                    }, Mt.angle(Pe == null ? -30 : Pe * P);
                }
                function Uf(he, be, Pe) {
                    var Oe, Je = be.edges, He = Je.length, et, Mt = {
                        type: "MultiPoint",
                        coordinates: be.face
                    }, Dt = be.face.filter(function(di) {
                        return n(di[1]) !== 90;
                    }), Ut = t.geoBounds({
                        type: "MultiPoint",
                        coordinates: Dt
                    }), tr = !1, mr = -1, Rr = Ut[1][0] - Ut[0][0], zr = Rr === 180 || Rr === 360 ? [
                        (Ut[0][0] + Ut[1][0]) / 2,
                        (Ut[0][1] + Ut[1][1]) / 2
                    ] : t.geoCentroid(Mt);
                    if (Pe) for(; ++mr < He && Je[mr] !== Pe;);
                    ++mr;
                    for(var Xr = 0; Xr < He; ++Xr)et = Je[(Xr + mr) % He], Array.isArray(et) ? (tr || (he.point((Oe = t.geoInterpolate(et[0], zr)(p))[0], Oe[1]), tr = !0), he.point((Oe = t.geoInterpolate(et[1], zr)(p))[0], Oe[1])) : (tr = !1, et !== Pe && Uf(he, et, be));
                }
                function Iu(he, be) {
                    return he && be && he[0] === be[0] && he[1] === be[1];
                }
                function oh(he, be) {
                    for(var Pe, Oe, Je = he.length, He = null, et = 0; et < Je; ++et){
                        Pe = he[et];
                        for(var Mt = be.length; --Mt >= 0;)if (Oe = be[Mt], Pe[0] === Oe[0] && Pe[1] === Oe[1]) {
                            if (He) return [
                                He,
                                Pe
                            ];
                            He = Pe;
                        }
                    }
                }
                function ru(he) {
                    for(var be = he.length, Pe = [], Oe = he[be - 1], Je = 0; Je < be; ++Je)Pe.push([
                        Oe,
                        Oe = he[Je]
                    ]);
                    return Pe;
                }
                function vf(he) {
                    return he.project.invert || he.children && he.children.some(vf);
                }
                var md = [
                    [
                        0,
                        90
                    ],
                    [
                        -90,
                        0
                    ],
                    [
                        0,
                        0
                    ],
                    [
                        90,
                        0
                    ],
                    [
                        180,
                        0
                    ],
                    [
                        0,
                        -90
                    ]
                ], sh = [
                    [
                        0,
                        2,
                        1
                    ],
                    [
                        0,
                        3,
                        2
                    ],
                    [
                        5,
                        1,
                        2
                    ],
                    [
                        5,
                        2,
                        3
                    ],
                    [
                        0,
                        1,
                        4
                    ],
                    [
                        0,
                        4,
                        3
                    ],
                    [
                        5,
                        4,
                        1
                    ],
                    [
                        5,
                        3,
                        4
                    ]
                ].map(function(he) {
                    return he.map(function(be) {
                        return md[be];
                    });
                });
                function Fs(he) {
                    he = he || function(Pe) {
                        var Oe = t.geoCentroid({
                            type: "MultiPoint",
                            coordinates: Pe
                        });
                        return t.geoGnomonic().scale(1).translate([
                            0,
                            0
                        ]).rotate([
                            -Oe[0],
                            -Oe[1]
                        ]);
                    };
                    var be = sh.map(function(Pe) {
                        return {
                            face: Pe,
                            project: he(Pe)
                        };
                    });
                    return [
                        -1,
                        0,
                        0,
                        1,
                        0,
                        1,
                        4,
                        5
                    ].forEach(function(Pe, Oe) {
                        var Je = be[Pe];
                        Je && (Je.children || (Je.children = [])).push(be[Oe]);
                    }), Lf(be[0], function(Pe, Oe) {
                        return be[Pe < -k / 2 ? Oe < 0 ? 6 : 4 : Pe < 0 ? Oe < 0 ? 2 : 0 : Pe < k / 2 ? Oe < 0 ? 3 : 1 : Oe < 0 ? 7 : 5];
                    }).angle(-30).scale(101.858).center([
                        0,
                        45
                    ]);
                }
                var _u = 2 / H(3);
                function xu(he, be) {
                    var Pe = ht(he, be);
                    return [
                        Pe[0] * _u,
                        Pe[1]
                    ];
                }
                xu.invert = function(he, be) {
                    return ht.invert(he / _u, be);
                };
                function Lh(he) {
                    he = he || function(Pe) {
                        var Oe = t.geoCentroid({
                            type: "MultiPoint",
                            coordinates: Pe
                        });
                        return t.geoProjection(xu).translate([
                            0,
                            0
                        ]).scale(1).rotate(Oe[1] > 0 ? [
                            -Oe[0],
                            0
                        ] : [
                            180 - Oe[0],
                            180
                        ]);
                    };
                    var be = sh.map(function(Pe) {
                        return {
                            face: Pe,
                            project: he(Pe)
                        };
                    });
                    return [
                        -1,
                        0,
                        0,
                        1,
                        0,
                        1,
                        4,
                        5
                    ].forEach(function(Pe, Oe) {
                        var Je = be[Pe];
                        Je && (Je.children || (Je.children = [])).push(be[Oe]);
                    }), Lf(be[0], function(Pe, Oe) {
                        return be[Pe < -k / 2 ? Oe < 0 ? 6 : 4 : Pe < 0 ? Oe < 0 ? 2 : 0 : Pe < k / 2 ? Oe < 0 ? 3 : 1 : Oe < 0 ? 7 : 5];
                    }).angle(-30).scale(121.906).center([
                        0,
                        48.5904
                    ]);
                }
                function Is(he) {
                    he = he || function(et) {
                        var Mt = et.length === 6 ? t.geoCentroid({
                            type: "MultiPoint",
                            coordinates: et
                        }) : et[0];
                        return t.geoGnomonic().scale(1).translate([
                            0,
                            0
                        ]).rotate([
                            -Mt[0],
                            -Mt[1]
                        ]);
                    };
                    var be = sh.map(function(et) {
                        for(var Mt = et.map(Vf), Dt = Mt.length, Ut = Mt[Dt - 1], tr, mr = [], Rr = 0; Rr < Dt; ++Rr)tr = Mt[Rr], mr.push(ju([
                            Ut[0] * .9486832980505138 + tr[0] * .31622776601683794,
                            Ut[1] * .9486832980505138 + tr[1] * .31622776601683794,
                            Ut[2] * .9486832980505138 + tr[2] * .31622776601683794
                        ]), ju([
                            tr[0] * .9486832980505138 + Ut[0] * .31622776601683794,
                            tr[1] * .9486832980505138 + Ut[1] * .31622776601683794,
                            tr[2] * .9486832980505138 + Ut[2] * .31622776601683794
                        ])), Ut = tr;
                        return mr;
                    }), Pe = [], Oe = [
                        -1,
                        0,
                        0,
                        1,
                        0,
                        1,
                        4,
                        5
                    ];
                    be.forEach(function(et, Mt) {
                        for(var Dt = sh[Mt], Ut = Dt.length, tr = Pe[Mt] = [], mr = 0; mr < Ut; ++mr)be.push([
                            Dt[mr],
                            et[(mr * 2 + 2) % (2 * Ut)],
                            et[(mr * 2 + 1) % (2 * Ut)]
                        ]), Oe.push(Mt), tr.push(Ic(Vf(et[(mr * 2 + 2) % (2 * Ut)]), Vf(et[(mr * 2 + 1) % (2 * Ut)])));
                    });
                    var Je = be.map(function(et) {
                        return {
                            project: he(et),
                            face: et
                        };
                    });
                    Oe.forEach(function(et, Mt) {
                        var Dt = Je[et];
                        Dt && (Dt.children || (Dt.children = [])).push(Je[Mt]);
                    });
                    function He(et, Mt) {
                        var Dt = o(Mt), Ut = [
                            Dt * o(et),
                            Dt * x(et),
                            x(Mt)
                        ], tr = et < -k / 2 ? Mt < 0 ? 6 : 4 : et < 0 ? Mt < 0 ? 2 : 0 : et < k / 2 ? Mt < 0 ? 3 : 1 : Mt < 0 ? 7 : 5, mr = Pe[tr];
                        return Je[Pf(mr[0], Ut) < 0 ? 8 + 3 * tr : Pf(mr[1], Ut) < 0 ? 8 + 3 * tr + 1 : Pf(mr[2], Ut) < 0 ? 8 + 3 * tr + 2 : tr];
                    }
                    return Lf(Je[0], He).angle(-30).scale(110.625).center([
                        0,
                        45
                    ]);
                }
                function Pf(he, be) {
                    for(var Pe = 0, Oe = he.length, Je = 0; Pe < Oe; ++Pe)Je += he[Pe] * be[Pe];
                    return Je;
                }
                function Ic(he, be) {
                    return [
                        he[1] * be[2] - he[2] * be[1],
                        he[2] * be[0] - he[0] * be[2],
                        he[0] * be[1] - he[1] * be[0]
                    ];
                }
                function ju(he) {
                    return [
                        a(he[1], he[0]) * P,
                        q(c(-1, f(1, he[2]))) * P
                    ];
                }
                function Vf(he) {
                    var be = he[0] * T, Pe = he[1] * T, Oe = o(Pe);
                    return [
                        Oe * o(be),
                        Oe * x(be),
                        x(Pe)
                    ];
                }
                function pc() {}
                function pf(he) {
                    if ((Pe = he.length) < 4) return !1;
                    for(var be = 0, Pe, Oe = he[Pe - 1][1] * he[0][0] - he[Pe - 1][0] * he[0][1]; ++be < Pe;)Oe += he[be - 1][1] * he[be][0] - he[be - 1][0] * he[be][1];
                    return Oe <= 0;
                }
                function Ph(he, be) {
                    for(var Pe = be[0], Oe = be[1], Je = !1, He = 0, et = he.length, Mt = et - 1; He < et; Mt = He++){
                        var Dt = he[He], Ut = Dt[0], tr = Dt[1], mr = he[Mt], Rr = mr[0], zr = mr[1];
                        tr > Oe ^ zr > Oe && Pe < (Rr - Ut) * (Oe - tr) / (zr - tr) + Ut && (Je = !Je);
                    }
                    return Je;
                }
                function Dl(he, be) {
                    var Pe = be.stream, Oe;
                    if (!Pe) throw new Error("invalid projection");
                    switch(he && he.type){
                        case "Feature":
                            Oe = Wu;
                            break;
                        case "FeatureCollection":
                            Oe = Ih;
                            break;
                        default:
                            Oe = gc;
                            break;
                    }
                    return Oe(he, Pe);
                }
                function Ih(he, be) {
                    return {
                        type: "FeatureCollection",
                        features: he.features.map(function(Pe) {
                            return Wu(Pe, be);
                        })
                    };
                }
                function Wu(he, be) {
                    return {
                        type: "Feature",
                        id: he.id,
                        properties: he.properties,
                        geometry: gc(he.geometry, be)
                    };
                }
                function Rc(he, be) {
                    return {
                        type: "GeometryCollection",
                        geometries: he.geometries.map(function(Pe) {
                            return gc(Pe, be);
                        })
                    };
                }
                function gc(he, be) {
                    if (!he) return null;
                    if (he.type === "GeometryCollection") return Rc(he, be);
                    var Pe;
                    switch(he.type){
                        case "Point":
                            Pe = mc;
                            break;
                        case "MultiPoint":
                            Pe = mc;
                            break;
                        case "LineString":
                            Pe = Yc;
                            break;
                        case "MultiLineString":
                            Pe = Yc;
                            break;
                        case "Polygon":
                            Pe = nc;
                            break;
                        case "MultiPolygon":
                            Pe = nc;
                            break;
                        case "Sphere":
                            Pe = nc;
                            break;
                        default:
                            return null;
                    }
                    return t.geoStream(he, be(Pe)), Pe.result();
                }
                var hl = [], iu = [], mc = {
                    point: function(he, be) {
                        hl.push([
                            he,
                            be
                        ]);
                    },
                    result: function() {
                        var he = hl.length ? hl.length < 2 ? {
                            type: "Point",
                            coordinates: hl[0]
                        } : {
                            type: "MultiPoint",
                            coordinates: hl
                        } : null;
                        return hl = [], he;
                    }
                }, Yc = {
                    lineStart: pc,
                    point: function(he, be) {
                        hl.push([
                            he,
                            be
                        ]);
                    },
                    lineEnd: function() {
                        hl.length && (iu.push(hl), hl = []);
                    },
                    result: function() {
                        var he = iu.length ? iu.length < 2 ? {
                            type: "LineString",
                            coordinates: iu[0]
                        } : {
                            type: "MultiLineString",
                            coordinates: iu
                        } : null;
                        return iu = [], he;
                    }
                }, nc = {
                    polygonStart: pc,
                    lineStart: pc,
                    point: function(he, be) {
                        hl.push([
                            he,
                            be
                        ]);
                    },
                    lineEnd: function() {
                        var he = hl.length;
                        if (he) {
                            do hl.push(hl[0].slice());
                            while (++he < 4);
                            iu.push(hl), hl = [];
                        }
                    },
                    polygonEnd: pc,
                    result: function() {
                        if (!iu.length) return null;
                        var he = [], be = [];
                        return iu.forEach(function(Pe) {
                            pf(Pe) ? he.push([
                                Pe
                            ]) : be.push(Pe);
                        }), be.forEach(function(Pe) {
                            var Oe = Pe[0];
                            he.some(function(Je) {
                                if (Ph(Je[0], Oe)) return Je.push(Pe), !0;
                            }) || he.push([
                                Pe
                            ]);
                        }), iu = [], he.length ? he.length > 1 ? {
                            type: "MultiPolygon",
                            coordinates: he
                        } : {
                            type: "Polygon",
                            coordinates: he[0]
                        } : null;
                    }
                };
                function gf(he) {
                    var be = he(A, 0)[0] - he(-A, 0)[0];
                    function Pe(Oe, Je) {
                        var He = n(Oe) < A, et = he(He ? Oe : Oe > 0 ? Oe - k : Oe + k, Je), Mt = (et[0] - et[1]) * _, Dt = (et[0] + et[1]) * _;
                        if (He) return [
                            Mt,
                            Dt
                        ];
                        var Ut = be * _, tr = Mt > 0 ^ Dt > 0 ? -1 : 1;
                        return [
                            tr * Mt - v(Dt) * Ut,
                            tr * Dt - v(Mt) * Ut
                        ];
                    }
                    return he.invert && (Pe.invert = function(Oe, Je) {
                        var He = (Oe + Je) * _, et = (Je - Oe) * _, Mt = n(He) < .5 * be && n(et) < .5 * be;
                        if (!Mt) {
                            var Dt = be * _, Ut = He > 0 ^ et > 0 ? -1 : 1, tr = -Ut * Oe + (et > 0 ? 1 : -1) * Dt, mr = -Ut * Je + (He > 0 ? 1 : -1) * Dt;
                            He = (-tr - mr) * _, et = (tr - mr) * _;
                        }
                        var Rr = he.invert(He, et);
                        return Mt || (Rr[0] += He > 0 ? k : -k), Rr;
                    }), t.geoProjection(Pe).rotate([
                        -90,
                        -90,
                        45
                    ]).clipAngle(179.999);
                }
                function gt() {
                    return gf(hi).scale(176.423);
                }
                function Bt() {
                    return gf(Mo).scale(111.48);
                }
                function wr(he, be) {
                    if (!(0 <= (be = +be) && be <= 20)) throw new Error("invalid digits");
                    function Pe(Ut) {
                        var tr = Ut.length, mr = 2, Rr = new Array(tr);
                        for(Rr[0] = +Ut[0].toFixed(be), Rr[1] = +Ut[1].toFixed(be); mr < tr;)Rr[mr] = Ut[mr], ++mr;
                        return Rr;
                    }
                    function Oe(Ut) {
                        return Ut.map(Pe);
                    }
                    function Je(Ut) {
                        for(var tr = Pe(Ut[0]), mr = [
                            tr
                        ], Rr = 1; Rr < Ut.length; Rr++){
                            var zr = Pe(Ut[Rr]);
                            (zr.length > 2 || zr[0] != tr[0] || zr[1] != tr[1]) && (mr.push(zr), tr = zr);
                        }
                        return mr.length === 1 && Ut.length > 1 && mr.push(Pe(Ut[Ut.length - 1])), mr;
                    }
                    function He(Ut) {
                        return Ut.map(Je);
                    }
                    function et(Ut) {
                        if (Ut == null) return Ut;
                        var tr;
                        switch(Ut.type){
                            case "GeometryCollection":
                                tr = {
                                    type: "GeometryCollection",
                                    geometries: Ut.geometries.map(et)
                                };
                                break;
                            case "Point":
                                tr = {
                                    type: "Point",
                                    coordinates: Pe(Ut.coordinates)
                                };
                                break;
                            case "MultiPoint":
                                tr = {
                                    type: Ut.type,
                                    coordinates: Oe(Ut.coordinates)
                                };
                                break;
                            case "LineString":
                                tr = {
                                    type: Ut.type,
                                    coordinates: Je(Ut.coordinates)
                                };
                                break;
                            case "MultiLineString":
                            case "Polygon":
                                tr = {
                                    type: Ut.type,
                                    coordinates: He(Ut.coordinates)
                                };
                                break;
                            case "MultiPolygon":
                                tr = {
                                    type: "MultiPolygon",
                                    coordinates: Ut.coordinates.map(He)
                                };
                                break;
                            default:
                                return Ut;
                        }
                        return Ut.bbox != null && (tr.bbox = Ut.bbox), tr;
                    }
                    function Mt(Ut) {
                        var tr = {
                            type: "Feature",
                            properties: Ut.properties,
                            geometry: et(Ut.geometry)
                        };
                        return Ut.id != null && (tr.id = Ut.id), Ut.bbox != null && (tr.bbox = Ut.bbox), tr;
                    }
                    if (he != null) switch(he.type){
                        case "Feature":
                            return Mt(he);
                        case "FeatureCollection":
                            var Dt = {
                                type: "FeatureCollection",
                                features: he.features.map(Mt)
                            };
                            return he.bbox != null && (Dt.bbox = he.bbox), Dt;
                        default:
                            return et(he);
                    }
                    return he;
                }
                function vr(he) {
                    var be = x(he);
                    function Pe(Oe, Je) {
                        var He = be ? b(Oe * be / 2) / be : Oe / 2;
                        if (!Je) return [
                            2 * He,
                            -he
                        ];
                        var et = 2 * i(He * x(Je)), Mt = 1 / b(Je);
                        return [
                            x(et) * Mt,
                            Je + (1 - o(et)) * Mt - he
                        ];
                    }
                    return Pe.invert = function(Oe, Je) {
                        if (n(Je += he) < p) return [
                            be ? 2 * i(be * Oe / 2) / be : Oe,
                            0
                        ];
                        var He = Oe * Oe + Je * Je, et = 0, Mt = 10, Dt;
                        do {
                            var Ut = b(et), tr = 1 / o(et), mr = He - 2 * Je * et + et * et;
                            et -= Dt = (Ut * mr + 2 * (et - Je)) / (2 + mr * tr * tr + 2 * (et - Je) * Ut);
                        }while (n(Dt) > p && --Mt > 0);
                        var Rr = Oe * (Ut = b(et)), zr = b(n(Je) < n(et + 1 / Ut) ? q(Rr) * .5 : V(Rr) * .5 + k / 4) / x(et);
                        return [
                            be ? 2 * i(be * zr) / be : 2 * zr,
                            et
                        ];
                    }, Pe;
                }
                function Ur() {
                    return Lt(vr).scale(131.215);
                }
                var fi = [
                    [
                        .9986,
                        -0.062
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        .9986,
                        .062
                    ],
                    [
                        .9954,
                        .124
                    ],
                    [
                        .99,
                        .186
                    ],
                    [
                        .9822,
                        .248
                    ],
                    [
                        .973,
                        .31
                    ],
                    [
                        .96,
                        .372
                    ],
                    [
                        .9427,
                        .434
                    ],
                    [
                        .9216,
                        .4958
                    ],
                    [
                        .8962,
                        .5571
                    ],
                    [
                        .8679,
                        .6176
                    ],
                    [
                        .835,
                        .6769
                    ],
                    [
                        .7986,
                        .7346
                    ],
                    [
                        .7597,
                        .7903
                    ],
                    [
                        .7186,
                        .8435
                    ],
                    [
                        .6732,
                        .8936
                    ],
                    [
                        .6213,
                        .9394
                    ],
                    [
                        .5722,
                        .9761
                    ],
                    [
                        .5322,
                        1
                    ]
                ];
                fi.forEach(function(he) {
                    he[1] *= 1.0144;
                });
                function xi(he, be) {
                    var Pe = f(18, n(be) * 36 / k), Oe = l(Pe), Je = Pe - Oe, He = (mr = fi[Oe])[0], et = mr[1], Mt = (mr = fi[++Oe])[0], Dt = mr[1], Ut = (mr = fi[f(19, ++Oe)])[0], tr = mr[1], mr;
                    return [
                        he * (Mt + Je * (Ut - He) / 2 + Je * Je * (Ut - 2 * Mt + He) / 2),
                        (be > 0 ? A : -A) * (Dt + Je * (tr - et) / 2 + Je * Je * (tr - 2 * Dt + et) / 2)
                    ];
                }
                xi.invert = function(he, be) {
                    var Pe = be / A, Oe = Pe * 90, Je = f(18, n(Oe / 5)), He = c(0, l(Je));
                    do {
                        var et = fi[He][1], Mt = fi[He + 1][1], Dt = fi[f(19, He + 2)][1], Ut = Dt - et, tr = Dt - 2 * Mt + et, mr = 2 * (n(Pe) - Mt) / Ut, Rr = tr / Ut, zr = mr * (1 - Rr * mr * (1 - 2 * Rr * mr));
                        if (zr >= 0 || He === 1) {
                            Oe = (be >= 0 ? 5 : -5) * (zr + Je);
                            var Xr = 50, di;
                            do Je = f(18, n(Oe) / 5), He = l(Je), zr = Je - He, et = fi[He][1], Mt = fi[He + 1][1], Dt = fi[f(19, He + 2)][1], Oe -= (di = (be >= 0 ? A : -A) * (Mt + zr * (Dt - et) / 2 + zr * zr * (Dt - 2 * Mt + et) / 2) - be) * P;
                            while (n(di) > E && --Xr > 0);
                            break;
                        }
                    }while (--He >= 0);
                    var Li = fi[He][0], Ci = fi[He + 1][0], Qi = fi[f(19, He + 2)][0];
                    return [
                        he / (Ci + zr * (Qi - Li) / 2 + zr * zr * (Qi - 2 * Ci + Li) / 2),
                        Oe * T
                    ];
                };
                function Fi() {
                    return t.geoProjection(xi).scale(152.63);
                }
                function Xi(he) {
                    function be(Pe, Oe) {
                        var Je = o(Oe), He = (he - 1) / (he - Je * o(Pe));
                        return [
                            He * Je * x(Pe),
                            He * x(Oe)
                        ];
                    }
                    return be.invert = function(Pe, Oe) {
                        var Je = Pe * Pe + Oe * Oe, He = H(Je), et = (he - H(1 - Je * (he + 1) / (he - 1))) / ((he - 1) / He + He / (he - 1));
                        return [
                            a(Pe * et, He * H(1 - et * et)),
                            He ? q(Oe * et / He) : 0
                        ];
                    }, be;
                }
                function hn(he, be) {
                    var Pe = Xi(he);
                    if (!be) return Pe;
                    var Oe = o(be), Je = x(be);
                    function He(et, Mt) {
                        var Dt = Pe(et, Mt), Ut = Dt[1], tr = Ut * Je / (he - 1) + Oe;
                        return [
                            Dt[0] * Oe / tr,
                            Ut / tr
                        ];
                    }
                    return He.invert = function(et, Mt) {
                        var Dt = (he - 1) / (he - 1 - Mt * Je);
                        return Pe.invert(Dt * et, Dt * Mt * Oe);
                    }, He;
                }
                function Ti() {
                    var he = 2, be = 0, Pe = t.geoProjectionMutator(hn), Oe = Pe(he, be);
                    return Oe.distance = function(Je) {
                        return arguments.length ? Pe(he = +Je, be) : he;
                    }, Oe.tilt = function(Je) {
                        return arguments.length ? Pe(he, be = Je * T) : be * P;
                    }, Oe.scale(432.147).clipAngle(V(1 / he) * P - 1e-6);
                }
                var qi = 1e-4, Ii = 1e4, mi = -180, Pn = mi + qi, Ma = 180, Ta = Ma - qi, Ea = -90, qa = Ea + qi, Cn = 90, sn = Cn - qi;
                function Ua(he) {
                    return he.length > 0;
                }
                function mo(he) {
                    return Math.floor(he * Ii) / Ii;
                }
                function Xo(he) {
                    return he === Ea || he === Cn ? [
                        0,
                        he
                    ] : [
                        mi,
                        mo(he)
                    ];
                }
                function Ts(he) {
                    var be = he[0], Pe = he[1], Oe = !1;
                    return be <= Pn ? (be = mi, Oe = !0) : be >= Ta && (be = Ma, Oe = !0), Pe <= qa ? (Pe = Ea, Oe = !0) : Pe >= sn && (Pe = Cn, Oe = !0), Oe ? [
                        be,
                        Pe
                    ] : he;
                }
                function Qo(he) {
                    return he.map(Ts);
                }
                function ys(he, be, Pe) {
                    for(var Oe = 0, Je = he.length; Oe < Je; ++Oe){
                        var He = he[Oe].slice();
                        Pe.push({
                            index: -1,
                            polygon: be,
                            ring: He
                        });
                        for(var et = 0, Mt = He.length; et < Mt; ++et){
                            var Dt = He[et], Ut = Dt[0], tr = Dt[1];
                            if (Ut <= Pn || Ut >= Ta || tr <= qa || tr >= sn) {
                                He[et] = Ts(Dt);
                                for(var mr = et + 1; mr < Mt; ++mr){
                                    var Rr = He[mr], zr = Rr[0], Xr = Rr[1];
                                    if (zr > Pn && zr < Ta && Xr > qa && Xr < sn) break;
                                }
                                if (mr === et + 1) continue;
                                if (et) {
                                    var di = {
                                        index: -1,
                                        polygon: be,
                                        ring: He.slice(0, et + 1)
                                    };
                                    di.ring[di.ring.length - 1] = Xo(tr), Pe[Pe.length - 1] = di;
                                } else Pe.pop();
                                if (mr >= Mt) break;
                                Pe.push({
                                    index: -1,
                                    polygon: be,
                                    ring: He = He.slice(mr - 1)
                                }), He[0] = Xo(He[0][1]), et = -1, Mt = He.length;
                            }
                        }
                    }
                }
                function Bo(he) {
                    var be, Pe = he.length, Oe = {}, Je = {}, He, et, Mt, Dt, Ut;
                    for(be = 0; be < Pe; ++be){
                        if (He = he[be], et = He.ring[0], Dt = He.ring[He.ring.length - 1], et[0] === Dt[0] && et[1] === Dt[1]) {
                            He.polygon.push(He.ring), he[be] = null;
                            continue;
                        }
                        He.index = be, Oe[et] = Je[Dt] = He;
                    }
                    for(be = 0; be < Pe; ++be)if (He = he[be], He) {
                        if (et = He.ring[0], Dt = He.ring[He.ring.length - 1], Mt = Je[et], Ut = Oe[Dt], delete Oe[et], delete Je[Dt], et[0] === Dt[0] && et[1] === Dt[1]) {
                            He.polygon.push(He.ring);
                            continue;
                        }
                        Mt ? (delete Je[et], delete Oe[Mt.ring[0]], Mt.ring.pop(), he[Mt.index] = null, He = {
                            index: -1,
                            polygon: Mt.polygon,
                            ring: Mt.ring.concat(He.ring)
                        }, Mt === Ut ? He.polygon.push(He.ring) : (He.index = Pe++, he.push(Oe[He.ring[0]] = Je[He.ring[He.ring.length - 1]] = He))) : Ut ? (delete Oe[Dt], delete Je[Ut.ring[Ut.ring.length - 1]], He.ring.pop(), He = {
                            index: Pe++,
                            polygon: Ut.polygon,
                            ring: He.ring.concat(Ut.ring)
                        }, he[Ut.index] = null, he.push(Oe[He.ring[0]] = Je[He.ring[He.ring.length - 1]] = He)) : (He.ring.push(He.ring[0]), He.polygon.push(He.ring));
                    }
                }
                function yl(he) {
                    var be = {
                        type: "Feature",
                        geometry: Gs(he.geometry)
                    };
                    return he.id != null && (be.id = he.id), he.bbox != null && (be.bbox = he.bbox), he.properties != null && (be.properties = he.properties), be;
                }
                function Gs(he) {
                    if (he == null) return he;
                    var be, Pe, Oe, Je;
                    switch(he.type){
                        case "GeometryCollection":
                            be = {
                                type: "GeometryCollection",
                                geometries: he.geometries.map(Gs)
                            };
                            break;
                        case "Point":
                            be = {
                                type: "Point",
                                coordinates: Ts(he.coordinates)
                            };
                            break;
                        case "MultiPoint":
                        case "LineString":
                            be = {
                                type: he.type,
                                coordinates: Qo(he.coordinates)
                            };
                            break;
                        case "MultiLineString":
                            be = {
                                type: "MultiLineString",
                                coordinates: he.coordinates.map(Qo)
                            };
                            break;
                        case "Polygon":
                            var He = [];
                            ys(he.coordinates, He, Pe = []), Bo(Pe), be = {
                                type: "Polygon",
                                coordinates: He
                            };
                            break;
                        case "MultiPolygon":
                            Pe = [], Oe = -1, Je = he.coordinates.length;
                            for(var et = new Array(Je); ++Oe < Je;)ys(he.coordinates[Oe], et[Oe] = [], Pe);
                            Bo(Pe), be = {
                                type: "MultiPolygon",
                                coordinates: et.filter(Ua)
                            };
                            break;
                        default:
                            return he;
                    }
                    return he.bbox != null && (be.bbox = he.bbox), be;
                }
                function Rs(he) {
                    if (he == null) return he;
                    switch(he.type){
                        case "Feature":
                            return yl(he);
                        case "FeatureCollection":
                            var be = {
                                type: "FeatureCollection",
                                features: he.features.map(yl)
                            };
                            return he.bbox != null && (be.bbox = he.bbox), be;
                        default:
                            return Gs(he);
                    }
                }
                function ia(he, be) {
                    var Pe = b(be / 2), Oe = x(L * Pe);
                    return [
                        he * (.74482 - .34588 * Oe * Oe),
                        1.70711 * Pe
                    ];
                }
                ia.invert = function(he, be) {
                    var Pe = be / 1.70711, Oe = x(L * Pe);
                    return [
                        he / (.74482 - .34588 * Oe * Oe),
                        2 * i(Pe)
                    ];
                };
                function Ka() {
                    return t.geoProjection(ia).scale(146.153);
                }
                function vs(he, be, Pe) {
                    var Oe = t.geoInterpolate(be, Pe), Je = Oe(.5), He = t.geoRotation([
                        -Je[0],
                        -Je[1]
                    ])(be), et = Oe.distance / 2, Mt = -q(x(He[1] * T) / x(et)), Dt = [
                        -Je[0],
                        -Je[1],
                        -(He[0] > 0 ? k - Mt : Mt) * P
                    ], Ut = t.geoProjection(he(et)).rotate(Dt), tr = t.geoRotation(Dt), mr = Ut.center;
                    return delete Ut.rotate, Ut.center = function(Rr) {
                        return arguments.length ? mr(tr(Rr)) : tr.invert(mr());
                    }, Ut.clipAngle(90);
                }
                function Ko(he) {
                    var be = o(he);
                    function Pe(Oe, Je) {
                        var He = t.geoGnomonicRaw(Oe, Je);
                        return He[0] *= be, He;
                    }
                    return Pe.invert = function(Oe, Je) {
                        return t.geoGnomonicRaw.invert(Oe / be, Je);
                    }, Pe;
                }
                function nu() {
                    return Ru([
                        -158,
                        21.5
                    ], [
                        -77,
                        39
                    ]).clipAngle(60).scale(400);
                }
                function Ru(he, be) {
                    return vs(Ko, he, be);
                }
                function ac(he) {
                    if (!(he *= 2)) return t.geoAzimuthalEquidistantRaw;
                    var be = -he / 2, Pe = -be, Oe = he * he, Je = b(Pe), He = .5 / x(Pe);
                    function et(Mt, Dt) {
                        var Ut = V(o(Dt) * o(Mt - be)), tr = V(o(Dt) * o(Mt - Pe)), mr = Dt < 0 ? -1 : 1;
                        return Ut *= Ut, tr *= tr, [
                            (Ut - tr) / (2 * he),
                            mr * H(4 * Oe * tr - (Oe - Ut + tr) * (Oe - Ut + tr)) / (2 * he)
                        ];
                    }
                    return et.invert = function(Mt, Dt) {
                        var Ut = Dt * Dt, tr = o(H(Ut + (Rr = Mt + be) * Rr)), mr = o(H(Ut + (Rr = Mt + Pe) * Rr)), Rr, zr;
                        return [
                            a(zr = tr - mr, Rr = (tr + mr) * Je),
                            (Dt < 0 ? -1 : 1) * V(H(Rr * Rr + zr * zr) * He)
                        ];
                    }, et;
                }
                function mf() {
                    return bu([
                        -158,
                        21.5
                    ], [
                        -77,
                        39
                    ]).clipAngle(130).scale(122.571);
                }
                function bu(he, be) {
                    return vs(ac, he, be);
                }
                function Kc(he, be) {
                    if (n(be) < p) return [
                        he,
                        0
                    ];
                    var Pe = n(be / A), Oe = q(Pe);
                    if (n(he) < p || n(n(be) - A) < p) return [
                        0,
                        v(be) * k * b(Oe / 2)
                    ];
                    var Je = o(Oe), He = n(k / he - he / k) / 2, et = He * He, Mt = Je / (Pe + Je - 1), Dt = Mt * (2 / Pe - 1), Ut = Dt * Dt, tr = Ut + et, mr = Mt - Ut, Rr = et + Mt;
                    return [
                        v(he) * k * (He * mr + H(et * mr * mr - tr * (Mt * Mt - Ut))) / tr,
                        v(be) * k * (Dt * Rr - He * H((et + 1) * tr - Rr * Rr)) / tr
                    ];
                }
                Kc.invert = function(he, be) {
                    if (n(be) < p) return [
                        he,
                        0
                    ];
                    if (n(he) < p) return [
                        0,
                        A * x(2 * i(be / k))
                    ];
                    var Pe = (he /= k) * he, Oe = (be /= k) * be, Je = Pe + Oe, He = Je * Je, et = -n(be) * (1 + Je), Mt = et - 2 * Oe + Pe, Dt = -2 * et + 1 + 2 * Oe + He, Ut = Oe / Dt + (2 * Mt * Mt * Mt / (Dt * Dt * Dt) - 9 * et * Mt / (Dt * Dt)) / 27, tr = (et - Mt * Mt / (3 * Dt)) / Dt, mr = 2 * H(-tr / 3), Rr = V(3 * Ut / (tr * mr)) / 3;
                    return [
                        k * (Je - 1 + H(1 + 2 * (Pe - Oe) + He)) / (2 * he),
                        v(be) * k * (-mr * o(Rr + k / 3) - Mt / (3 * Dt))
                    ];
                };
                function Du() {
                    return t.geoProjection(Kc).scale(79.4183);
                }
                function Dc(he, be) {
                    if (n(be) < p) return [
                        he,
                        0
                    ];
                    var Pe = n(be / A), Oe = q(Pe);
                    if (n(he) < p || n(n(be) - A) < p) return [
                        0,
                        v(be) * k * b(Oe / 2)
                    ];
                    var Je = o(Oe), He = n(k / he - he / k) / 2, et = He * He, Mt = Je * (H(1 + et) - He * Je) / (1 + et * Pe * Pe);
                    return [
                        v(he) * k * Mt,
                        v(be) * k * H(1 - Mt * (2 * He + Mt))
                    ];
                }
                Dc.invert = function(he, be) {
                    if (!he) return [
                        0,
                        A * x(2 * i(be / k))
                    ];
                    var Pe = n(he / k), Oe = (1 - Pe * Pe - (be /= k) * be) / (2 * Pe), Je = Oe * Oe, He = H(Je + 1);
                    return [
                        v(he) * k * (He - Oe),
                        v(be) * A * x(2 * a(H((1 - 2 * Oe * Pe) * (Oe + He) - Pe), H(He + Oe + Pe)))
                    ];
                };
                function Da() {
                    return t.geoProjection(Dc).scale(79.4183);
                }
                function eo(he, be) {
                    if (n(be) < p) return [
                        he,
                        0
                    ];
                    var Pe = be / A, Oe = q(Pe);
                    if (n(he) < p || n(n(be) - A) < p) return [
                        0,
                        k * b(Oe / 2)
                    ];
                    var Je = (k / he - he / k) / 2, He = Pe / (1 + o(Oe));
                    return [
                        k * (v(he) * H(Je * Je + 1 - He * He) - Je),
                        k * He
                    ];
                }
                eo.invert = function(he, be) {
                    if (!be) return [
                        he,
                        0
                    ];
                    var Pe = be / k, Oe = (k * k * (1 - Pe * Pe) - he * he) / (2 * k * he);
                    return [
                        he ? k * (v(he) * H(Oe * Oe + 1) - Oe) : 0,
                        A * x(2 * i(Pe))
                    ];
                };
                function Jc() {
                    return t.geoProjection(eo).scale(79.4183);
                }
                function yc(he, be) {
                    if (!be) return [
                        he,
                        0
                    ];
                    var Pe = n(be);
                    if (!he || Pe === A) return [
                        0,
                        be
                    ];
                    var Oe = Pe / A, Je = Oe * Oe, He = (8 * Oe - Je * (Je + 2) - 5) / (2 * Je * (Oe - 1)), et = He * He, Mt = Oe * He, Dt = Je + et + 2 * Mt, Ut = Oe + 3 * He, tr = he / A, mr = tr + 1 / tr, Rr = v(n(he) - A) * H(mr * mr - 4), zr = Rr * Rr, Xr = Dt * (Je + et * zr - 1) + (1 - Je) * (Je * (Ut * Ut + 4 * et) + 12 * Mt * et + 4 * et * et), di = (Rr * (Dt + et - 1) + 2 * H(Xr)) / (4 * Dt + zr);
                    return [
                        v(he) * A * di,
                        v(be) * A * H(1 + Rr * n(di) - di * di)
                    ];
                }
                yc.invert = function(he, be) {
                    var Pe;
                    if (!he || !be) return [
                        he,
                        be
                    ];
                    be /= k;
                    var Oe = v(he) * he / A, Je = (Oe * Oe - 1 + 4 * be * be) / n(Oe), He = Je * Je, et = 2 * be, Mt = 50;
                    do {
                        var Dt = et * et, Ut = (8 * et - Dt * (Dt + 2) - 5) / (2 * Dt * (et - 1)), tr = (3 * et - Dt * et - 10) / (2 * Dt * et), mr = Ut * Ut, Rr = et * Ut, zr = et + Ut, Xr = zr * zr, di = et + 3 * Ut, Li = Xr * (Dt + mr * He - 1) + (1 - Dt) * (Dt * (di * di + 4 * mr) + mr * (12 * Rr + 4 * mr)), Ci = -2 * zr * (4 * Rr * mr + (1 - 4 * Dt + 3 * Dt * Dt) * (1 + tr) + mr * (-6 + 14 * Dt - He + (-8 + 8 * Dt - 2 * He) * tr) + Rr * (-8 + 12 * Dt + (-10 + 10 * Dt - He) * tr)), Qi = H(Li), Mn = Je * (Xr + mr - 1) + 2 * Qi - Oe * (4 * Xr + He), pa = Je * (2 * Ut * tr + 2 * zr * (1 + tr)) + Ci / Qi - 8 * zr * (Je * (-1 + mr + Xr) + 2 * Qi) * (1 + tr) / (He + 4 * Xr);
                        et -= Pe = Mn / pa;
                    }while (Pe > p && --Mt > 0);
                    return [
                        v(he) * (H(Je * Je + 4) + Je) * k / 4,
                        A * et
                    ];
                };
                function _c() {
                    return t.geoProjection(yc).scale(127.16);
                }
                function le(he, be, Pe, Oe, Je) {
                    function He(et, Mt) {
                        var Dt = Pe * x(Oe * Mt), Ut = H(1 - Dt * Dt), tr = H(2 / (1 + Ut * o(et *= Je)));
                        return [
                            he * Ut * tr * x(et),
                            be * Dt * tr
                        ];
                    }
                    return He.invert = function(et, Mt) {
                        var Dt = et / he, Ut = Mt / be, tr = H(Dt * Dt + Ut * Ut), mr = 2 * q(tr / 2);
                        return [
                            a(et * b(mr), he * tr) / Je,
                            tr && q(Mt * x(mr) / (be * Pe * tr)) / Oe
                        ];
                    }, He;
                }
                function w(he, be, Pe, Oe) {
                    var Je = k / 3;
                    he = c(he, p), be = c(be, p), he = f(he, A), be = f(be, k - p), Pe = c(Pe, 0), Pe = f(Pe, 100 - p), Oe = c(Oe, p);
                    var He = Pe / 100 + 1, et = Oe / 100, Mt = V(He * o(Je)) / Je, Dt = x(he) / x(Mt * A), Ut = be / k, tr = H(et * x(he / 2) / x(be / 2)), mr = tr / H(Ut * Dt * Mt), Rr = 1 / (tr * H(Ut * Dt * Mt));
                    return le(mr, Rr, Dt, Mt, Ut);
                }
                function B() {
                    var he = 65 * T, be = 60 * T, Pe = 20, Oe = 200, Je = t.geoProjectionMutator(w), He = Je(he, be, Pe, Oe);
                    return He.poleline = function(et) {
                        return arguments.length ? Je(he = +et * T, be, Pe, Oe) : he * P;
                    }, He.parallels = function(et) {
                        return arguments.length ? Je(he, be = +et * T, Pe, Oe) : be * P;
                    }, He.inflation = function(et) {
                        return arguments.length ? Je(he, be, Pe = +et, Oe) : Pe;
                    }, He.ratio = function(et) {
                        return arguments.length ? Je(he, be, Pe, Oe = +et) : Oe;
                    }, He.scale(163.775);
                }
                function Q() {
                    return B().poleline(65).parallels(60).inflation(0).ratio(200).scale(172.633);
                }
                var ee = 4 * k + 3 * H(3), se = 2 * H(2 * k * H(3) / ee), qe = Ct(se * H(3) / k, se, ee / 6);
                function je() {
                    return t.geoProjection(qe).scale(176.84);
                }
                function it(he, be) {
                    return [
                        he * H(1 - 3 * be * be / (k * k)),
                        be
                    ];
                }
                it.invert = function(he, be) {
                    return [
                        he / H(1 - 3 * be * be / (k * k)),
                        be
                    ];
                };
                function yt() {
                    return t.geoProjection(it).scale(152.63);
                }
                function Ot(he, be) {
                    var Pe = o(be), Oe = o(he) * Pe, Je = 1 - Oe, He = o(he = a(x(he) * Pe, -x(be))), et = x(he);
                    return Pe = H(1 - Oe * Oe), [
                        et * Pe - He * Je,
                        -He * Pe - et * Je
                    ];
                }
                Ot.invert = function(he, be) {
                    var Pe = (he * he + be * be) / -2, Oe = H(-Pe * (2 + Pe)), Je = be * Pe + he * Oe, He = he * Pe - be * Oe, et = H(He * He + Je * Je);
                    return [
                        a(Oe * Je, et * (1 + Pe)),
                        et ? -q(Oe * He / et) : 0
                    ];
                };
                function Nt() {
                    return t.geoProjection(Ot).rotate([
                        0,
                        -90,
                        45
                    ]).scale(124.75).clipAngle(179.999);
                }
                function hr(he, be) {
                    var Pe = Me(he, be);
                    return [
                        (Pe[0] + he / A) / 2,
                        (Pe[1] + be) / 2
                    ];
                }
                hr.invert = function(he, be) {
                    var Pe = he, Oe = be, Je = 25;
                    do {
                        var He = o(Oe), et = x(Oe), Mt = x(2 * Oe), Dt = et * et, Ut = He * He, tr = x(Pe), mr = o(Pe / 2), Rr = x(Pe / 2), zr = Rr * Rr, Xr = 1 - Ut * mr * mr, di = Xr ? V(He * mr) * H(Li = 1 / Xr) : Li = 0, Li, Ci = .5 * (2 * di * He * Rr + Pe / A) - he, Qi = .5 * (di * et + Oe) - be, Mn = .5 * Li * (Ut * zr + di * He * mr * Dt) + .5 / A, pa = Li * (tr * Mt / 4 - di * et * Rr), ea = .125 * Li * (Mt * Rr - di * et * Ut * tr), Ga = .5 * Li * (Dt * mr + di * zr * He) + .5, To = pa * ea - Ga * Mn, Wa = (Qi * pa - Ci * Ga) / To, co = (Ci * ea - Qi * Mn) / To;
                        Pe -= Wa, Oe -= co;
                    }while ((n(Wa) > p || n(co) > p) && --Je > 0);
                    return [
                        Pe,
                        Oe
                    ];
                };
                function Sr() {
                    return t.geoProjection(hr).scale(158.837);
                }
                e.geoNaturalEarth = t.geoNaturalEarth1, e.geoNaturalEarthRaw = t.geoNaturalEarth1Raw, e.geoAiry = _e, e.geoAiryRaw = ae, e.geoAitoff = ke, e.geoAitoffRaw = Me, e.geoArmadillo = ie, e.geoArmadilloRaw = ge, e.geoAugust = Ee, e.geoAugustRaw = Te, e.geoBaker = me, e.geoBakerRaw = Ce, e.geoBerghaus = ce, e.geoBerghausRaw = Re, e.geoBertin1953 = Rt, e.geoBertin1953Raw = ot, e.geoBoggs = bt, e.geoBoggsRaw = xt, e.geoBonne = Ht, e.geoBonneRaw = dt, e.geoBottomley = fr, e.geoBottomleyRaw = $t, e.geoBromley = Br, e.geoBromleyRaw = _r, e.geoChamberlin = Xe, e.geoChamberlinRaw = Ne, e.geoChamberlinAfrica = Ve, e.geoCollignon = Le, e.geoCollignonRaw = ht, e.geoCraig = Se, e.geoCraigRaw = xe, e.geoCraster = Vt, e.geoCrasterRaw = Gt, e.geoCylindricalEqualArea = Qr, e.geoCylindricalEqualAreaRaw = ar, e.geoCylindricalStereographic = jr, e.geoCylindricalStereographicRaw = ai, e.geoEckert1 = bi, e.geoEckert1Raw = ri, e.geoEckert2 = Wi, e.geoEckert2Raw = nn, e.geoEckert3 = _n, e.geoEckert3Raw = Ni, e.geoEckert4 = zn, e.geoEckert4Raw = $i, e.geoEckert5 = It, e.geoEckert5Raw = Wn, e.geoEckert6 = jt, e.geoEckert6Raw = ft, e.geoEisenlohr = Fr, e.geoEisenlohrRaw = yr, e.geoFahey = gi, e.geoFaheyRaw = Vr, e.geoFoucaut = Mi, e.geoFoucautRaw = Si, e.geoFoucautSinusoidal = Gi, e.geoFoucautSinusoidalRaw = Pi, e.geoGilbert = jn, e.geoGingery = jo, e.geoGingeryRaw = la, e.geoGinzburg4 = Ha, e.geoGinzburg4Raw = Sn, e.geoGinzburg5 = xn, e.geoGinzburg5Raw = oo, e.geoGinzburg6 = br, e.geoGinzburg6Raw = _t, e.geoGinzburg8 = ti, e.geoGinzburg8Raw = Hr, e.geoGinzburg9 = Yi, e.geoGinzburg9Raw = zi, e.geoGringorten = Fn, e.geoGringortenRaw = hi, e.geoGuyou = ks, e.geoGuyouRaw = Mo, e.geoHammer = ct, e.geoHammerRaw = Ge, e.geoHammerRetroazimuthal = wl, e.geoHammerRetroazimuthalRaw = Zs, e.geoHealpix = Ql, e.geoHealpixRaw = ml, e.geoHill = fc, e.geoHillRaw = Hu, e.geoHomolosine = vo, e.geoHomolosineRaw = Rl, e.geoHufnagel = Ks, e.geoHufnagelRaw = Zl, e.geoHyperelliptical = ko, e.geoHyperellipticalRaw = Zn, e.geoInterrupt = So, e.geoInterruptedBoggs = rh, e.geoInterruptedHomolosine = Hc, e.geoInterruptedMollweide = Ls, e.geoInterruptedMollweideHemispheres = kc, e.geoInterruptedSinuMollweide = Gc, e.geoInterruptedSinusoidal = Bf, e.geoKavrayskiy7 = ff, e.geoKavrayskiy7Raw = ss, e.geoLagrange = Vl, e.geoLagrangeRaw = ih, e.geoLarrivee = Cc, e.geoLarriveeRaw = hc, e.geoLaskowski = $s, e.geoLaskowskiRaw = ws, e.geoLittrow = Ms, e.geoLittrowRaw = hs, e.geoLoximuthal = Sl, e.geoLoximuthalRaw = dc, e.geoMiller = Ps, e.geoMillerRaw = ec, e.geoModifiedStereographic = Ml, e.geoModifiedStereographicRaw = ov, e.geoModifiedStereographicAlaska = tc, e.geoModifiedStereographicGs48 = uu, e.geoModifiedStereographicGs50 = Mh, e.geoModifiedStereographicMiller = jc, e.geoModifiedStereographicLee = kf, e.geoMollweide = xr, e.geoMollweideRaw = Yt, e.geoMtFlatPolarParabolic = hf, e.geoMtFlatPolarParabolicRaw = nh, e.geoMtFlatPolarQuartic = Kh, e.geoMtFlatPolarQuarticRaw = kh, e.geoMtFlatPolarSinusoidal = ah, e.geoMtFlatPolarSinusoidalRaw = rc, e.geoNaturalEarth2 = df, e.geoNaturalEarth2Raw = Wc, e.geoNellHammer = Nf, e.geoNellHammerRaw = Cu, e.geoInterruptedQuarticAuthalic = ds, e.geoNicolosi = Bd, e.geoNicolosiRaw = Ch, e.geoPatterson = ic, e.geoPattersonRaw = Xc, e.geoPolyconic = Qs, e.geoPolyconicRaw = yu, e.geoPolyhedral = Lf, e.geoPolyhedralButterfly = Fs, e.geoPolyhedralCollignon = Lh, e.geoPolyhedralWaterman = Is, e.geoProject = Dl, e.geoGringortenQuincuncial = gt, e.geoPeirceQuincuncial = Bt, e.geoPierceQuincuncial = Bt, e.geoQuantize = wr, e.geoQuincuncial = gf, e.geoRectangularPolyconic = Ur, e.geoRectangularPolyconicRaw = vr, e.geoRobinson = Fi, e.geoRobinsonRaw = xi, e.geoSatellite = Ti, e.geoSatelliteRaw = hn, e.geoSinuMollweide = Qu, e.geoSinuMollweideRaw = fa, e.geoSinusoidal = Et, e.geoSinusoidalRaw = St, e.geoStitch = Rs, e.geoTimes = Ka, e.geoTimesRaw = ia, e.geoTwoPointAzimuthal = Ru, e.geoTwoPointAzimuthalRaw = Ko, e.geoTwoPointAzimuthalUsa = nu, e.geoTwoPointEquidistant = bu, e.geoTwoPointEquidistantRaw = ac, e.geoTwoPointEquidistantUsa = mf, e.geoVanDerGrinten = Du, e.geoVanDerGrintenRaw = Kc, e.geoVanDerGrinten2 = Da, e.geoVanDerGrinten2Raw = Dc, e.geoVanDerGrinten3 = Jc, e.geoVanDerGrinten3Raw = eo, e.geoVanDerGrinten4 = _c, e.geoVanDerGrinten4Raw = yc, e.geoWagner = B, e.geoWagner7 = Q, e.geoWagnerRaw = w, e.geoWagner4 = je, e.geoWagner4Raw = qe, e.geoWagner6 = yt, e.geoWagner6Raw = it, e.geoWiechel = Nt, e.geoWiechelRaw = Ot, e.geoWinkel3 = Sr, e.geoWinkel3Raw = hr, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var MRe = ye((Dpr, SRe)=>{
            "use strict";
            var Zh = xa(), bX = Mr(), CDt = ba(), Z5 = Math.PI / 180, G2 = 180 / Math.PI, TX = {
                cursor: "pointer"
            }, AX = {
                cursor: "auto"
            };
            function LDt(e, t) {
                var r = e.projection, n;
                return t._isScoped ? n = PDt : t._isClipped ? n = RDt : n = IDt, n(e, r);
            }
            SRe.exports = LDt;
            function SX(e, t) {
                return Zh.behavior.zoom().translate(t.translate()).scale(t.scale());
            }
            function MX(e, t, r) {
                var n = e.id, i = e.graphDiv, a = i.layout, o = a[n], s = i._fullLayout, l = s[n], u = {}, c = {};
                function f(h, d) {
                    u[n + "." + h] = bX.nestedProperty(o, h).get(), CDt.call("_storeDirectGUIEdit", a, s._preGUI, u);
                    var v = bX.nestedProperty(l, h);
                    v.get() !== d && (v.set(d), bX.nestedProperty(o, h).set(d), c[n + "." + h] = d);
                }
                r(f), f("projection.scale", t.scale() / e.fitScale), f("fitbounds", !1), i.emit("plotly_relayout", c);
            }
            function PDt(e, t) {
                var r = SX(e, t);
                function n() {
                    Zh.select(this).style(TX);
                }
                function i() {
                    t.scale(Zh.event.scale).translate(Zh.event.translate), e.render(!0);
                    var s = t.invert(e.midPt);
                    e.graphDiv.emit("plotly_relayouting", {
                        "geo.projection.scale": t.scale() / e.fitScale,
                        "geo.center.lon": s[0],
                        "geo.center.lat": s[1]
                    });
                }
                function a(s) {
                    var l = t.invert(e.midPt);
                    s("center.lon", l[0]), s("center.lat", l[1]);
                }
                function o() {
                    Zh.select(this).style(AX), MX(e, t, a);
                }
                return r.on("zoomstart", n).on("zoom", i).on("zoomend", o), r;
            }
            function IDt(e, t) {
                var r = SX(e, t), n = 2, i, a, o, s, l, u, c, f, h;
                function d(k) {
                    return t.invert(k);
                }
                function v(k) {
                    var A = d(k);
                    if (!A) return !0;
                    var L = t(A);
                    return Math.abs(L[0] - k[0]) > n || Math.abs(L[1] - k[1]) > n;
                }
                function x() {
                    Zh.select(this).style(TX), i = Zh.mouse(this), a = t.rotate(), o = t.translate(), s = a, l = d(i);
                }
                function b() {
                    if (u = Zh.mouse(this), v(i)) {
                        r.scale(t.scale()), r.translate(t.translate());
                        return;
                    }
                    t.scale(Zh.event.scale), t.translate([
                        o[0],
                        Zh.event.translate[1]
                    ]), l ? d(u) && (f = d(u), c = [
                        s[0] + (f[0] - l[0]),
                        a[1],
                        a[2]
                    ], t.rotate(c), s = c) : (i = u, l = d(i)), h = !0, e.render(!0);
                    var k = t.rotate(), A = t.invert(e.midPt);
                    e.graphDiv.emit("plotly_relayouting", {
                        "geo.projection.scale": t.scale() / e.fitScale,
                        "geo.center.lon": A[0],
                        "geo.center.lat": A[1],
                        "geo.projection.rotation.lon": -k[0]
                    });
                }
                function p() {
                    Zh.select(this).style(AX), h && MX(e, t, E);
                }
                function E(k) {
                    var A = t.rotate(), L = t.invert(e.midPt);
                    k("projection.rotation.lon", -A[0]), k("center.lon", L[0]), k("center.lat", L[1]);
                }
                return r.on("zoomstart", x).on("zoom", b).on("zoomend", p), r;
            }
            function RDt(e, t) {
                var r = {
                    r: t.rotate(),
                    k: t.scale()
                }, n = SX(e, t), i = UDt(n, "zoomstart", "zoom", "zoomend"), a = 0, o = n.on, s;
                n.on("zoomstart", function() {
                    Zh.select(this).style(TX);
                    var h = Zh.mouse(this), d = t.rotate(), v = d, x = t.translate(), b = DDt(d);
                    s = Sz(t, h), o.call(n, "zoom", function() {
                        var p = Zh.mouse(this);
                        if (t.scale(r.k = Zh.event.scale), !s) h = p, s = Sz(t, h);
                        else if (Sz(t, p)) {
                            t.rotate(d).translate(x);
                            var E = Sz(t, p), k = FDt(s, E), A = ODt(zDt(b, k)), L = r.r = qDt(A, s, v);
                            (!isFinite(L[0]) || !isFinite(L[1]) || !isFinite(L[2])) && (L = v), t.rotate(L), v = L;
                        }
                        u(i.of(this, arguments));
                    }), l(i.of(this, arguments));
                }).on("zoomend", function() {
                    Zh.select(this).style(AX), o.call(n, "zoom", null), c(i.of(this, arguments)), MX(e, t, f);
                }).on("zoom.redraw", function() {
                    e.render(!0);
                    var h = t.rotate();
                    e.graphDiv.emit("plotly_relayouting", {
                        "geo.projection.scale": t.scale() / e.fitScale,
                        "geo.projection.rotation.lon": -h[0],
                        "geo.projection.rotation.lat": -h[1]
                    });
                });
                function l(h) {
                    a++ || h({
                        type: "zoomstart"
                    });
                }
                function u(h) {
                    h({
                        type: "zoom"
                    });
                }
                function c(h) {
                    --a || h({
                        type: "zoomend"
                    });
                }
                function f(h) {
                    var d = t.rotate();
                    h("projection.rotation.lon", -d[0]), h("projection.rotation.lat", -d[1]);
                }
                return Zh.rebind(n, i, "on");
            }
            function Sz(e, t) {
                var r = e.invert(t);
                return r && isFinite(r[0]) && isFinite(r[1]) && BDt(r);
            }
            function DDt(e) {
                var t = .5 * e[0] * Z5, r = .5 * e[1] * Z5, n = .5 * e[2] * Z5, i = Math.sin(t), a = Math.cos(t), o = Math.sin(r), s = Math.cos(r), l = Math.sin(n), u = Math.cos(n);
                return [
                    a * s * u + i * o * l,
                    i * s * u - a * o * l,
                    a * o * u + i * s * l,
                    a * s * l - i * o * u
                ];
            }
            function zDt(e, t) {
                var r = e[0], n = e[1], i = e[2], a = e[3], o = t[0], s = t[1], l = t[2], u = t[3];
                return [
                    r * o - n * s - i * l - a * u,
                    r * s + n * o + i * u - a * l,
                    r * l - n * u + i * o + a * s,
                    r * u + n * l - i * s + a * o
                ];
            }
            function FDt(e, t) {
                if (!(!e || !t)) {
                    var r = NDt(e, t), n = Math.sqrt(ARe(r, r)), i = .5 * Math.acos(Math.max(-1, Math.min(1, ARe(e, t)))), a = Math.sin(i) / n;
                    return n && [
                        Math.cos(i),
                        r[2] * a,
                        -r[1] * a,
                        r[0] * a
                    ];
                }
            }
            function qDt(e, t, r) {
                var n = wX(t, 2, e[0]);
                n = wX(n, 1, e[1]), n = wX(n, 0, e[2] - r[2]);
                var i = t[0], a = t[1], o = t[2], s = n[0], l = n[1], u = n[2], c = Math.atan2(a, i) * G2, f = Math.sqrt(i * i + a * a), h, d;
                Math.abs(l) > f ? (d = (l > 0 ? 90 : -90) - c, h = 0) : (d = Math.asin(l / f) * G2 - c, h = Math.sqrt(f * f - l * l));
                var v = 180 - d - 2 * c, x = (Math.atan2(u, s) - Math.atan2(o, h)) * G2, b = (Math.atan2(u, s) - Math.atan2(o, -h)) * G2, p = wRe(r[0], r[1], d, x), E = wRe(r[0], r[1], v, b);
                return p <= E ? [
                    d,
                    x,
                    r[2]
                ] : [
                    v,
                    b,
                    r[2]
                ];
            }
            function wRe(e, t, r, n) {
                var i = TRe(r - e), a = TRe(n - t);
                return Math.sqrt(i * i + a * a);
            }
            function TRe(e) {
                return (e % 360 + 540) % 360 - 180;
            }
            function wX(e, t, r) {
                var n = r * Z5, i = e.slice(), a = t === 0 ? 1 : 0, o = t === 2 ? 1 : 2, s = Math.cos(n), l = Math.sin(n);
                return i[a] = e[a] * s - e[o] * l, i[o] = e[o] * s + e[a] * l, i;
            }
            function ODt(e) {
                return [
                    Math.atan2(2 * (e[0] * e[1] + e[2] * e[3]), 1 - 2 * (e[1] * e[1] + e[2] * e[2])) * G2,
                    Math.asin(Math.max(-1, Math.min(1, 2 * (e[0] * e[2] - e[3] * e[1])))) * G2,
                    Math.atan2(2 * (e[0] * e[3] + e[1] * e[2]), 1 - 2 * (e[2] * e[2] + e[3] * e[3])) * G2
                ];
            }
            function BDt(e) {
                var t = e[0] * Z5, r = e[1] * Z5, n = Math.cos(r);
                return [
                    n * Math.cos(t),
                    n * Math.sin(t),
                    Math.sin(r)
                ];
            }
            function ARe(e, t) {
                for(var r = 0, n = 0, i = e.length; n < i; ++n)r += e[n] * t[n];
                return r;
            }
            function NDt(e, t) {
                return [
                    e[1] * t[2] - e[2] * t[1],
                    e[2] * t[0] - e[0] * t[2],
                    e[0] * t[1] - e[1] * t[0]
                ];
            }
            function UDt(e) {
                for(var t = 0, r = arguments.length, n = []; ++t < r;)n.push(arguments[t]);
                var i = Zh.dispatch.apply(null, n);
                return i.of = function(a, o) {
                    return function(s) {
                        var l;
                        try {
                            l = s.sourceEvent = Zh.event, s.target = e, Zh.event = s, i[s.type].apply(a, o);
                        } finally{
                            Zh.event = l;
                        }
                    };
                }, i;
            }
        });
        var RRe = ye((zpr, IRe)=>{
            "use strict";
            var t1 = xa(), CX = xX(), VDt = CX.geoPath, HDt = CX.geoDistance, GDt = bRe(), jDt = ba(), ek = Mr(), WDt = ek.strTranslate, Mz = va(), QE = ao(), ERe = Nc(), ZDt = Xu(), kX = Qa(), kRe = wg().getAutoRange, EX = gv(), XDt = wf().prepSelect, YDt = wf().clearOutline, KDt = wf().selectOnClick, JDt = MRe(), fp = YE(), $Dt = nx(), LRe = cz(), QDt = aX().feature;
            function PRe(e) {
                this.id = e.id, this.graphDiv = e.graphDiv, this.container = e.container, this.topojsonURL = e.topojsonURL, this.isStatic = e.staticPlot, this.topojsonName = null, this.topojson = null, this.projection = null, this.scope = null, this.viewInitial = null, this.fitScale = null, this.bounds = null, this.midPt = null, this.hasChoropleth = !1, this.traceHash = {}, this.layers = {}, this.basePaths = {}, this.dataPaths = {}, this.dataPoints = {}, this.clipDef = null, this.clipRect = null, this.bgRect = null, this.makeFramework();
            }
            var $g = PRe.prototype;
            IRe.exports = function(t) {
                return new PRe(t);
            };
            $g.plot = function(e, t, r, n) {
                var i = this;
                if (n) return i.update(e, t, !0);
                i._geoCalcData = e, i._fullLayout = t;
                var a = t[this.id], o = [], s = !1;
                for(var l in fp.layerNameToAdjective)if (l !== "frame" && a["show" + l]) {
                    s = !0;
                    break;
                }
                for(var u = !1, c = 0; c < e.length; c++){
                    var f = e[0][0].trace;
                    f._geo = i, f.locationmode && (s = !0);
                    var h = f.marker;
                    if (h) {
                        var d = h.angle, v = h.angleref;
                        (d || v === "north" || v === "previous") && (u = !0);
                    }
                }
                if (this._hasMarkerAngles = u, s) {
                    var x = LRe.getTopojsonName(a);
                    (i.topojson === null || x !== i.topojsonName) && (i.topojsonName = x, PlotlyGeoAssets.topojson[i.topojsonName] === void 0 && o.push(i.fetchTopojson()));
                }
                o = o.concat($Dt.fetchTraceGeoData(e)), r.push(new Promise(function(b, p) {
                    Promise.all(o).then(function() {
                        i.topojson = PlotlyGeoAssets.topojson[i.topojsonName], i.update(e, t), b();
                    }).catch(p);
                }));
            };
            $g.fetchTopojson = function() {
                var e = this, t = LRe.getTopojsonPath(e.topojsonURL, e.topojsonName);
                return new Promise(function(r, n) {
                    t1.json(t, function(i, a) {
                        if (i) return i.status === 404 ? n(new Error([
                            "plotly.js could not find topojson file at",
                            t + ".",
                            "Make sure the *topojsonURL* plot config option",
                            "is set properly."
                        ].join(" "))) : n(new Error([
                            "unexpected error while fetching topojson file at",
                            t
                        ].join(" ")));
                        PlotlyGeoAssets.topojson[e.topojsonName] = a, r();
                    });
                });
            };
            $g.update = function(e, t, r) {
                var n = t[this.id];
                this.hasChoropleth = !1;
                for(var i = 0; i < e.length; i++){
                    var a = e[i], o = a[0].trace;
                    o.type === "choropleth" && (this.hasChoropleth = !0), o.visible === !0 && o._length > 0 && o._module.calcGeoJSON(a, t);
                }
                if (!r) {
                    var s = this.updateProjection(e, t);
                    if (s) return;
                    (!this.viewInitial || this.scope !== n.scope) && this.saveViewInitial(n);
                }
                this.scope = n.scope, this.updateBaseLayers(t, n), this.updateDims(t, n), this.updateFx(t, n), ZDt.generalUpdatePerTraceModule(this.graphDiv, this, e, n);
                var l = this.layers.frontplot.select(".scatterlayer");
                this.dataPoints.point = l.selectAll(".point"), this.dataPoints.text = l.selectAll("text"), this.dataPaths.line = l.selectAll(".js-line");
                var u = this.layers.backplot.select(".choroplethlayer");
                this.dataPaths.choropleth = u.selectAll("path"), this._render();
            };
            $g.updateProjection = function(e, t) {
                var r = this.graphDiv, n = t[this.id], i = t._size, a = n.domain, o = n.projection, s = n.lonaxis, l = n.lataxis, u = s._ax, c = l._ax, f = this.projection = ezt(n), h = [
                    [
                        i.l + i.w * a.x[0],
                        i.t + i.h * (1 - a.y[1])
                    ],
                    [
                        i.l + i.w * a.x[1],
                        i.t + i.h * (1 - a.y[0])
                    ]
                ], d = n.center || {}, v = o.rotation || {}, x = s.range || [], b = l.range || [];
                if (n.fitbounds) {
                    u._length = h[1][0] - h[0][0], c._length = h[1][1] - h[0][1], u.range = kRe(r, u), c.range = kRe(r, c);
                    var p = (u.range[0] + u.range[1]) / 2, E = (c.range[0] + c.range[1]) / 2;
                    if (n._isScoped) d = {
                        lon: p,
                        lat: E
                    };
                    else if (n._isClipped) {
                        d = {
                            lon: p,
                            lat: E
                        }, v = {
                            lon: p,
                            lat: E,
                            roll: v.roll
                        };
                        var k = o.type, A = fp.lonaxisSpan[k] / 2 || 180, L = fp.lataxisSpan[k] / 2 || 90;
                        x = [
                            p - A,
                            p + A
                        ], b = [
                            E - L,
                            E + L
                        ];
                    } else d = {
                        lon: p,
                        lat: E
                    }, v = {
                        lon: p,
                        lat: v.lat,
                        roll: v.roll
                    };
                }
                f.center([
                    d.lon - v.lon,
                    d.lat - v.lat
                ]).rotate([
                    -v.lon,
                    -v.lat,
                    v.roll
                ]).parallels(o.parallels);
                var _ = CRe(x, b);
                f.fitExtent(h, _);
                var C = this.bounds = f.getBounds(_), M = this.fitScale = f.scale(), g = f.translate();
                if (n.fitbounds) {
                    var P = f.getBounds(CRe(u.range, c.range)), T = Math.min((C[1][0] - C[0][0]) / (P[1][0] - P[0][0]), (C[1][1] - C[0][1]) / (P[1][1] - P[0][1]));
                    isFinite(T) ? f.scale(T * M) : ek.warn("Something went wrong during" + this.id + "fitbounds computations.");
                } else f.scale(o.scale * M);
                var F = this.midPt = [
                    (C[0][0] + C[1][0]) / 2,
                    (C[0][1] + C[1][1]) / 2
                ];
                if (f.translate([
                    g[0] + (F[0] - g[0]),
                    g[1] + (F[1] - g[1])
                ]).clipExtent(C), n._isAlbersUsa) {
                    var q = f([
                        d.lon,
                        d.lat
                    ]), V = f.translate();
                    f.translate([
                        V[0] - (q[0] - V[0]),
                        V[1] - (q[1] - V[1])
                    ]);
                }
            };
            $g.updateBaseLayers = function(e, t) {
                var r = this, n = r.topojson, i = r.layers, a = r.basePaths;
                function o(h) {
                    return h === "lonaxis" || h === "lataxis";
                }
                function s(h) {
                    return !!fp.lineLayers[h];
                }
                function l(h) {
                    return !!fp.fillLayers[h];
                }
                var u = this.hasChoropleth ? fp.layersForChoropleth : fp.layers, c = u.filter(function(h) {
                    return s(h) || l(h) ? t["show" + h] : o(h) ? t[h].showgrid : !0;
                }), f = r.framework.selectAll(".layer").data(c, String);
                f.exit().each(function(h) {
                    delete i[h], delete a[h], t1.select(this).remove();
                }), f.enter().append("g").attr("class", function(h) {
                    return "layer " + h;
                }).each(function(h) {
                    var d = i[h] = t1.select(this);
                    h === "bg" ? r.bgRect = d.append("rect").style("pointer-events", "all") : o(h) ? a[h] = d.append("path").style("fill", "none") : h === "backplot" ? d.append("g").classed("choroplethlayer", !0) : h === "frontplot" ? d.append("g").classed("scatterlayer", !0) : s(h) ? a[h] = d.append("path").style("fill", "none").style("stroke-miterlimit", 2) : l(h) && (a[h] = d.append("path").style("stroke", "none"));
                }), f.order(), f.each(function(h) {
                    var d = a[h], v = fp.layerNameToAdjective[h];
                    h === "frame" ? d.datum(fp.sphereSVG) : s(h) || l(h) ? d.datum(QDt(n, n.objects[h])) : o(h) && d.datum(tzt(h, t, e)).call(Mz.stroke, t[h].gridcolor).call(QE.dashLine, t[h].griddash, t[h].gridwidth), s(h) ? d.call(Mz.stroke, t[v + "color"]).call(QE.dashLine, "", t[v + "width"]) : l(h) && d.call(Mz.fill, t[v + "color"]);
                });
            };
            $g.updateDims = function(e, t) {
                var r = this.bounds, n = (t.framewidth || 0) / 2, i = r[0][0] - n, a = r[0][1] - n, o = r[1][0] - i + n, s = r[1][1] - a + n;
                QE.setRect(this.clipRect, i, a, o, s), this.bgRect.call(QE.setRect, i, a, o, s).call(Mz.fill, t.bgcolor), this.xaxis._offset = i, this.xaxis._length = o, this.yaxis._offset = a, this.yaxis._length = s;
            };
            $g.updateFx = function(e, t) {
                var r = this, n = r.graphDiv, i = r.bgRect, a = e.dragmode, o = e.clickmode;
                if (r.isStatic) return;
                function s() {
                    var f = r.viewInitial, h = {};
                    for(var d in f)h[r.id + "." + d] = f[d];
                    jDt.call("_guiRelayout", n, h), n.emit("plotly_doubleclick", null);
                }
                function l(f) {
                    return r.projection.invert([
                        f[0] + r.xaxis._offset,
                        f[1] + r.yaxis._offset
                    ]);
                }
                var u = function(f, h) {
                    if (h.isRect) {
                        var d = f.range = {};
                        d[r.id] = [
                            l([
                                h.xmin,
                                h.ymin
                            ]),
                            l([
                                h.xmax,
                                h.ymax
                            ])
                        ];
                    } else {
                        var v = f.lassoPoints = {};
                        v[r.id] = h.map(l);
                    }
                }, c = {
                    element: r.bgRect.node(),
                    gd: n,
                    plotinfo: {
                        id: r.id,
                        xaxis: r.xaxis,
                        yaxis: r.yaxis,
                        fillRangeItems: u
                    },
                    xaxes: [
                        r.xaxis
                    ],
                    yaxes: [
                        r.yaxis
                    ],
                    subplot: r.id,
                    clickFn: function(f) {
                        f === 2 && YDt(n);
                    }
                };
                a === "pan" ? (i.node().onmousedown = null, i.call(JDt(r, t)), i.on("dblclick.zoom", s), n._context._scrollZoom.geo || i.on("wheel.zoom", null)) : (a === "select" || a === "lasso") && (i.on(".zoom", null), c.prepFn = function(f, h, d) {
                    XDt(f, h, d, c, a);
                }, EX.init(c)), i.on("mousemove", function() {
                    var f = r.projection.invert(ek.getPositionFromD3Event());
                    if (!f) return EX.unhover(n, t1.event);
                    r.xaxis.p2c = function() {
                        return f[0];
                    }, r.yaxis.p2c = function() {
                        return f[1];
                    }, ERe.hover(n, t1.event, r.id);
                }), i.on("mouseout", function() {
                    n._dragging || EX.unhover(n, t1.event);
                }), i.on("click", function() {
                    a !== "select" && a !== "lasso" && (o.indexOf("select") > -1 && KDt(t1.event, n, [
                        r.xaxis
                    ], [
                        r.yaxis
                    ], r.id, c), o.indexOf("event") > -1 && ERe.click(n, t1.event));
                });
            };
            $g.makeFramework = function() {
                var e = this, t = e.graphDiv, r = t._fullLayout, n = "clip" + r._uid + e.id;
                e.clipDef = r._clips.append("clipPath").attr("id", n), e.clipRect = e.clipDef.append("rect"), e.framework = t1.select(e.container).append("g").attr("class", "geo " + e.id).call(QE.setClipUrl, n, t), e.project = function(i) {
                    var a = e.projection(i);
                    return a ? [
                        a[0] - e.xaxis._offset,
                        a[1] - e.yaxis._offset
                    ] : [
                        null,
                        null
                    ];
                }, e.xaxis = {
                    _id: "x",
                    c2p: function(i) {
                        return e.project(i)[0];
                    }
                }, e.yaxis = {
                    _id: "y",
                    c2p: function(i) {
                        return e.project(i)[1];
                    }
                }, e.mockAxis = {
                    type: "linear",
                    showexponent: "all",
                    exponentformat: "B"
                }, kX.setConvert(e.mockAxis, r);
            };
            $g.saveViewInitial = function(e) {
                var t = e.center || {}, r = e.projection, n = r.rotation || {};
                this.viewInitial = {
                    fitbounds: e.fitbounds,
                    "projection.scale": r.scale
                };
                var i;
                e._isScoped ? i = {
                    "center.lon": t.lon,
                    "center.lat": t.lat
                } : e._isClipped ? i = {
                    "projection.rotation.lon": n.lon,
                    "projection.rotation.lat": n.lat
                } : i = {
                    "center.lon": t.lon,
                    "center.lat": t.lat,
                    "projection.rotation.lon": n.lon
                }, ek.extendFlat(this.viewInitial, i);
            };
            $g.render = function(e) {
                this._hasMarkerAngles && e ? this.plot(this._geoCalcData, this._fullLayout, [], !0) : this._render();
            };
            $g._render = function() {
                var e = this.projection, t = e.getPath(), r;
                function n(a) {
                    var o = e(a.lonlat);
                    return o ? WDt(o[0], o[1]) : null;
                }
                function i(a) {
                    return e.isLonLatOverEdges(a.lonlat) ? "none" : null;
                }
                for(r in this.basePaths)this.basePaths[r].attr("d", t);
                for(r in this.dataPaths)this.dataPaths[r].attr("d", function(a) {
                    return t(a.geojson);
                });
                for(r in this.dataPoints)this.dataPoints[r].attr("display", i).attr("transform", n);
            };
            function ezt(e) {
                var t = e.projection, r = t.type, n = fp.projNames[r];
                n = "geo" + ek.titleCase(n);
                for(var i = CX[n] || GDt[n], a = i(), o = e._isSatellite ? Math.acos(1 / t.distance) * 180 / Math.PI : e._isClipped ? fp.lonaxisSpan[r] / 2 : null, s = [
                    "center",
                    "rotate",
                    "parallels",
                    "clipExtent"
                ], l = function(f) {
                    return f ? a : [];
                }, u = 0; u < s.length; u++){
                    var c = s[u];
                    typeof a[c] != "function" && (a[c] = l);
                }
                return a.isLonLatOverEdges = function(f) {
                    if (a(f) === null) return !0;
                    if (o) {
                        var h = a.rotate(), d = HDt(f, [
                            -h[0],
                            -h[1]
                        ]), v = o * Math.PI / 180;
                        return d > v;
                    } else return !1;
                }, a.getPath = function() {
                    return VDt().projection(a);
                }, a.getBounds = function(f) {
                    return a.getPath().bounds(f);
                }, a.precision(fp.precision), e._isSatellite && a.tilt(t.tilt).distance(t.distance), o && a.clipAngle(o - fp.clipPad), a;
            }
            function tzt(e, t, r) {
                var n = 1e-6, i = 2.5, a = t[e], o = fp.scopeDefaults[t.scope], s, l, u;
                e === "lonaxis" ? (s = o.lonaxisRange, l = o.lataxisRange, u = function(E, k) {
                    return [
                        E,
                        k
                    ];
                }) : e === "lataxis" && (s = o.lataxisRange, l = o.lonaxisRange, u = function(E, k) {
                    return [
                        k,
                        E
                    ];
                });
                var c = {
                    type: "linear",
                    range: [
                        s[0],
                        s[1] - n
                    ],
                    tick0: a.tick0,
                    dtick: a.dtick
                };
                kX.setConvert(c, r);
                var f = kX.calcTicks(c);
                !t.isScoped && e === "lonaxis" && f.pop();
                for(var h = f.length, d = new Array(h), v = 0; v < h; v++)for(var x = f[v].x, b = d[v] = [], p = l[0]; p < l[1] + i; p += i)b.push(u(x, p));
                return {
                    type: "MultiLineString",
                    coordinates: d
                };
            }
            function CRe(e, t) {
                var r = fp.clipPad, n = e[0] + r, i = e[1] - r, a = t[0] + r, o = t[1] - r;
                n > 0 && i < 0 && (i += 360);
                var s = (i - n) / 4;
                return {
                    type: "Polygon",
                    coordinates: [
                        [
                            [
                                n,
                                a
                            ],
                            [
                                n,
                                o
                            ],
                            [
                                n + s,
                                o
                            ],
                            [
                                n + 2 * s,
                                o
                            ],
                            [
                                n + 3 * s,
                                o
                            ],
                            [
                                i,
                                o
                            ],
                            [
                                i,
                                a
                            ],
                            [
                                i - s,
                                a
                            ],
                            [
                                i - 2 * s,
                                a
                            ],
                            [
                                i - 3 * s,
                                a
                            ],
                            [
                                n,
                                a
                            ]
                        ]
                    ]
                };
            }
        });
        var LX = ye((Fpr, FRe)=>{
            "use strict";
            var Y5 = dh(), rzt = Ju().attributes, izt = Ed().dash, X5 = YE(), nzt = Bu().overrideAll, DRe = Y1(), zRe = {
                range: {
                    valType: "info_array",
                    items: [
                        {
                            valType: "number"
                        },
                        {
                            valType: "number"
                        }
                    ]
                },
                showgrid: {
                    valType: "boolean",
                    dflt: !1
                },
                tick0: {
                    valType: "number",
                    dflt: 0
                },
                dtick: {
                    valType: "number"
                },
                gridcolor: {
                    valType: "color",
                    dflt: Y5.lightLine
                },
                gridwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1
                },
                griddash: izt
            }, azt = FRe.exports = nzt({
                domain: rzt({
                    name: "geo"
                }, {}),
                fitbounds: {
                    valType: "enumerated",
                    values: [
                        !1,
                        "locations",
                        "geojson"
                    ],
                    dflt: !1,
                    editType: "plot"
                },
                resolution: {
                    valType: "enumerated",
                    values: [
                        110,
                        50
                    ],
                    dflt: 110,
                    coerceNumber: !0
                },
                scope: {
                    valType: "enumerated",
                    values: DRe(X5.scopeDefaults),
                    dflt: "world"
                },
                projection: {
                    type: {
                        valType: "enumerated",
                        values: DRe(X5.projNames)
                    },
                    rotation: {
                        lon: {
                            valType: "number"
                        },
                        lat: {
                            valType: "number"
                        },
                        roll: {
                            valType: "number"
                        }
                    },
                    tilt: {
                        valType: "number",
                        dflt: 0
                    },
                    distance: {
                        valType: "number",
                        min: 1.001,
                        dflt: 2
                    },
                    parallels: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number"
                            },
                            {
                                valType: "number"
                            }
                        ]
                    },
                    scale: {
                        valType: "number",
                        min: 0,
                        dflt: 1
                    }
                },
                center: {
                    lon: {
                        valType: "number"
                    },
                    lat: {
                        valType: "number"
                    }
                },
                visible: {
                    valType: "boolean",
                    dflt: !0
                },
                showcoastlines: {
                    valType: "boolean"
                },
                coastlinecolor: {
                    valType: "color",
                    dflt: Y5.defaultLine
                },
                coastlinewidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1
                },
                showland: {
                    valType: "boolean",
                    dflt: !1
                },
                landcolor: {
                    valType: "color",
                    dflt: X5.landColor
                },
                showocean: {
                    valType: "boolean",
                    dflt: !1
                },
                oceancolor: {
                    valType: "color",
                    dflt: X5.waterColor
                },
                showlakes: {
                    valType: "boolean",
                    dflt: !1
                },
                lakecolor: {
                    valType: "color",
                    dflt: X5.waterColor
                },
                showrivers: {
                    valType: "boolean",
                    dflt: !1
                },
                rivercolor: {
                    valType: "color",
                    dflt: X5.waterColor
                },
                riverwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1
                },
                showcountries: {
                    valType: "boolean"
                },
                countrycolor: {
                    valType: "color",
                    dflt: Y5.defaultLine
                },
                countrywidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1
                },
                showsubunits: {
                    valType: "boolean"
                },
                subunitcolor: {
                    valType: "color",
                    dflt: Y5.defaultLine
                },
                subunitwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1
                },
                showframe: {
                    valType: "boolean"
                },
                framecolor: {
                    valType: "color",
                    dflt: Y5.defaultLine
                },
                framewidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1
                },
                bgcolor: {
                    valType: "color",
                    dflt: Y5.background
                },
                lonaxis: zRe,
                lataxis: zRe
            }, "plot", "from-root");
            azt.uirevision = {
                valType: "any",
                editType: "none"
            };
        });
        var BRe = ye((qpr, ORe)=>{
            "use strict";
            var Ez = Mr(), ozt = C_(), szt = kd().getSubplotData, kz = YE(), lzt = LX(), qRe = kz.axesNames;
            ORe.exports = function(t, r, n) {
                ozt(t, r, n, {
                    type: "geo",
                    attributes: lzt,
                    handleDefaults: uzt,
                    fullData: n,
                    partition: "y"
                });
            };
            function uzt(e, t, r, n) {
                var i = szt(n.fullData, "geo", n.id), a = i.map(function(ae) {
                    return ae.index;
                }), o = r("resolution"), s = r("scope"), l = kz.scopeDefaults[s], u = r("projection.type", l.projType), c = t._isAlbersUsa = u === "albers usa";
                c && (s = t.scope = "usa");
                var f = t._isScoped = s !== "world", h = t._isSatellite = u === "satellite", d = t._isConic = u.indexOf("conic") !== -1 || u === "albers", v = t._isClipped = !!kz.lonaxisSpan[u];
                if (e.visible === !1) {
                    var x = Ez.extendDeep({}, t._template);
                    x.showcoastlines = !1, x.showcountries = !1, x.showframe = !1, x.showlakes = !1, x.showland = !1, x.showocean = !1, x.showrivers = !1, x.showsubunits = !1, x.lonaxis && (x.lonaxis.showgrid = !1), x.lataxis && (x.lataxis.showgrid = !1), t._template = x;
                }
                for(var b = r("visible"), p, E = 0; E < qRe.length; E++){
                    var k = qRe[E], A = [
                        30,
                        10
                    ][E], L;
                    if (f) L = l[k + "Range"];
                    else {
                        var _ = kz[k + "Span"], C = (_[u] || _["*"]) / 2, M = r("projection.rotation." + k.substr(0, 3), l.projRotate[E]);
                        L = [
                            M - C,
                            M + C
                        ];
                    }
                    var g = r(k + ".range", L);
                    r(k + ".tick0"), r(k + ".dtick", A), p = r(k + ".showgrid", b ? void 0 : !1), p && (r(k + ".gridcolor"), r(k + ".gridwidth"), r(k + ".griddash")), t[k]._ax = {
                        type: "linear",
                        _id: k.slice(0, 3),
                        _traceIndices: a,
                        setScale: Ez.identity,
                        c2l: Ez.identity,
                        r2l: Ez.identity,
                        autorange: !0,
                        range: g.slice(),
                        _m: 1,
                        _input: {}
                    };
                }
                var P = t.lonaxis.range, T = t.lataxis.range, F = P[0], q = P[1];
                F > 0 && q < 0 && (q += 360);
                var V = (F + q) / 2, H;
                if (!c) {
                    var X = f ? l.projRotate : [
                        V,
                        0,
                        0
                    ];
                    H = r("projection.rotation.lon", X[0]), r("projection.rotation.lat", X[1]), r("projection.rotation.roll", X[2]), p = r("showcoastlines", !f && b), p && (r("coastlinecolor"), r("coastlinewidth")), p = r("showocean", b ? void 0 : !1), p && r("oceancolor");
                }
                var G, N;
                if (c ? (G = -96.6, N = 38.7) : (G = f ? V : H, N = (T[0] + T[1]) / 2), r("center.lon", G), r("center.lat", N), h && (r("projection.tilt"), r("projection.distance")), d) {
                    var W = l.projParallels || [
                        0,
                        60
                    ];
                    r("projection.parallels", W);
                }
                r("projection.scale"), p = r("showland", b ? void 0 : !1), p && r("landcolor"), p = r("showlakes", b ? void 0 : !1), p && r("lakecolor"), p = r("showrivers", b ? void 0 : !1), p && (r("rivercolor"), r("riverwidth")), p = r("showcountries", f && s !== "usa" && b), p && (r("countrycolor"), r("countrywidth")), (s === "usa" || s === "north america" && o === 50) && (r("showsubunits", b), r("subunitcolor"), r("subunitwidth")), f || (p = r("showframe", b), p && (r("framecolor"), r("framewidth"))), r("bgcolor");
                var re = r("fitbounds");
                re && (delete t.projection.scale, f ? (delete t.center.lon, delete t.center.lat) : v ? (delete t.center.lon, delete t.center.lat, delete t.projection.rotation.lon, delete t.projection.rotation.lat, delete t.lonaxis.range, delete t.lataxis.range) : (delete t.center.lon, delete t.center.lat, delete t.projection.rotation.lon));
            }
        });
        var PX = ye((Opr, VRe)=>{
            "use strict";
            var czt = kd().getSubplotCalcData, fzt = Mr().counterRegex, hzt = RRe(), Wm = "geo", NRe = fzt(Wm), URe = {};
            URe[Wm] = {
                valType: "subplotid",
                dflt: Wm,
                editType: "calc"
            };
            function dzt(e) {
                for(var t = e._fullLayout, r = e.calcdata, n = t._subplots[Wm], i = 0; i < n.length; i++){
                    var a = n[i], o = czt(r, Wm, a), s = t[a], l = s._subplot;
                    l || (l = hzt({
                        id: a,
                        graphDiv: e,
                        container: t._geolayer.node(),
                        topojsonURL: e._context.topojsonURL,
                        staticPlot: e._context.staticPlot
                    }), t[a]._subplot = l), l.plot(o, t, e._promises);
                }
            }
            function vzt(e, t, r, n) {
                for(var i = n._subplots[Wm] || [], a = 0; a < i.length; a++){
                    var o = i[a], s = n[o]._subplot;
                    !t[o] && s && (s.framework.remove(), s.clipDef.remove());
                }
            }
            function pzt(e) {
                for(var t = e._fullLayout, r = t._subplots[Wm], n = 0; n < r.length; n++){
                    var i = t[r[n]], a = i._subplot;
                    a.updateFx(t, i);
                }
            }
            VRe.exports = {
                attr: Wm,
                name: Wm,
                idRoot: Wm,
                idRegex: NRe,
                attrRegex: NRe,
                attributes: URe,
                layoutAttributes: LX(),
                supplyLayoutDefaults: BRe(),
                plot: dzt,
                updateFx: pzt,
                clean: vzt
            };
        });
        var GRe = ye((Bpr, HRe)=>{
            "use strict";
            HRe.exports = {
                attributes: H2(),
                supplyDefaults: A8e(),
                colorbar: Kd(),
                formatLabels: E8e(),
                calc: lz(),
                calcGeoJSON: _X().calcGeoJSON,
                plot: _X().plot,
                style: pX(),
                styleOnSelect: op().styleOnSelect,
                hoverPoints: hRe(),
                eventData: vRe(),
                selectPoints: mRe(),
                moduleType: "trace",
                name: "scattergeo",
                basePlotModule: PX(),
                categories: [
                    "geo",
                    "symbols",
                    "showLegend",
                    "scatter-like"
                ],
                meta: {}
            };
        });
        var WRe = ye((Npr, jRe)=>{
            "use strict";
            jRe.exports = GRe();
        });
        var K5 = ye((Upr, YRe)=>{
            "use strict";
            var gzt = Wo().hovertemplateAttrs, ox = H2(), mzt = Jl(), ZRe = vl(), yzt = dh().defaultLine, ax = no().extendFlat, XRe = ox.marker.line;
            YRe.exports = ax({
                locations: {
                    valType: "data_array",
                    editType: "calc"
                },
                locationmode: ox.locationmode,
                z: {
                    valType: "data_array",
                    editType: "calc"
                },
                geojson: ax({}, ox.geojson, {}),
                featureidkey: ox.featureidkey,
                text: ax({}, ox.text, {}),
                hovertext: ax({}, ox.hovertext, {}),
                marker: {
                    line: {
                        color: ax({}, XRe.color, {
                            dflt: yzt
                        }),
                        width: ax({}, XRe.width, {
                            dflt: 1
                        }),
                        editType: "calc"
                    },
                    opacity: {
                        valType: "number",
                        arrayOk: !0,
                        min: 0,
                        max: 1,
                        dflt: 1,
                        editType: "style"
                    },
                    editType: "calc"
                },
                selected: {
                    marker: {
                        opacity: ox.selected.marker.opacity,
                        editType: "plot"
                    },
                    editType: "plot"
                },
                unselected: {
                    marker: {
                        opacity: ox.unselected.marker.opacity,
                        editType: "plot"
                    },
                    editType: "plot"
                },
                hoverinfo: ax({}, ZRe.hoverinfo, {
                    editType: "calc",
                    flags: [
                        "location",
                        "z",
                        "text",
                        "name"
                    ]
                }),
                hovertemplate: gzt(),
                showlegend: ax({}, ZRe.showlegend, {
                    dflt: !1
                })
            }, mzt("", {
                cLetter: "z",
                editTypeOverride: "calc"
            }));
        });
        var JRe = ye((Vpr, KRe)=>{
            "use strict";
            var Cz = Mr(), _zt = Uh(), xzt = K5();
            KRe.exports = function(t, r, n, i) {
                function a(h, d) {
                    return Cz.coerce(t, r, xzt, h, d);
                }
                var o = a("locations"), s = a("z");
                if (!(o && o.length && Cz.isArrayOrTypedArray(s) && s.length)) {
                    r.visible = !1;
                    return;
                }
                r._length = Math.min(o.length, s.length);
                var l = a("geojson"), u;
                (typeof l == "string" && l !== "" || Cz.isPlainObject(l)) && (u = "geojson-id");
                var c = a("locationmode", u);
                c === "geojson-id" && a("featureidkey"), a("text"), a("hovertext"), a("hovertemplate");
                var f = a("marker.line.width");
                f && a("marker.line.color"), a("marker.opacity"), _zt(t, r, i, a, {
                    prefix: "",
                    cLetter: "z"
                }), Cz.coerceSelectionMarkerOpacity(r, a);
            };
        });
        var Lz = ye((Hpr, eDe)=>{
            "use strict";
            var $Re = uo(), bzt = es().BADNUM, wzt = zv(), Tzt = km(), Azt = F0();
            function QRe(e) {
                return e && typeof e == "string";
            }
            eDe.exports = function(t, r) {
                var n = r._length, i = new Array(n), a;
                r.geojson ? a = function(c) {
                    return QRe(c) || $Re(c);
                } : a = QRe;
                for(var o = 0; o < n; o++){
                    var s = i[o] = {}, l = r.locations[o], u = r.z[o];
                    a(l) && $Re(u) ? (s.loc = l, s.z = u) : (s.loc = null, s.z = bzt), s.index = o;
                }
                return Tzt(i, r), wzt(t, r, {
                    vals: r.z,
                    containerStr: "",
                    cLetter: "z"
                }), Azt(i, r), i;
            };
        });
        var Pz = ye((Gpr, rDe)=>{
            "use strict";
            var Szt = xa(), Mzt = va(), IX = ao(), Ezt = Mu();
            function kzt(e, t) {
                t && tDe(e, t);
            }
            function tDe(e, t) {
                var r = t[0].trace, n = t[0].node3, i = n.selectAll(".choroplethlocation"), a = r.marker || {}, o = a.line || {}, s = Ezt.makeColorScaleFuncFromTrace(r);
                i.each(function(l) {
                    Szt.select(this).attr("fill", s(l.z)).call(Mzt.stroke, l.mlc || o.color).call(IX.dashLine, "", l.mlw || o.width || 0).style("opacity", a.opacity);
                }), IX.selectedPointStyle(i, r);
            }
            function Czt(e, t) {
                var r = t[0].node3, n = t[0].trace;
                n.selectedpoints ? IX.selectedPointStyle(r.selectAll(".choroplethlocation"), n) : tDe(e, t);
            }
            rDe.exports = {
                style: kzt,
                styleOnSelect: Czt
            };
        });
        var RX = ye((jpr, aDe)=>{
            "use strict";
            var Lzt = xa(), iDe = Mr(), J5 = nx(), Pzt = cz().getTopojsonFeatures, nDe = wg().findExtremes, Izt = Pz().style;
            function Rzt(e, t, r) {
                var n = t.layers.backplot.select(".choroplethlayer");
                iDe.makeTraceGroups(n, r, "trace choropleth").each(function(i) {
                    var a = Lzt.select(this), o = a.selectAll("path.choroplethlocation").data(iDe.identity);
                    o.enter().append("path").classed("choroplethlocation", !0), o.exit().remove(), Izt(e, i);
                });
            }
            function Dzt(e, t) {
                for(var r = e[0].trace, n = t[r.geo], i = n._subplot, a = r.locationmode, o = r._length, s = a === "geojson-id" ? J5.extractTraceFeature(e) : Pzt(r, i.topojson), l = [], u = [], c = 0; c < o; c++){
                    var f = e[c], h = a === "geojson-id" ? f.fOut : J5.locationToFeature(a, f.loc, s);
                    if (h) {
                        f.geojson = h, f.ct = h.properties.ct, f._polygons = J5.feature2polygons(h);
                        var d = J5.computeBbox(h);
                        l.push(d[0], d[2]), u.push(d[1], d[3]);
                    } else f.geojson = null;
                }
                if (n.fitbounds === "geojson" && a === "geojson-id") {
                    var v = J5.computeBbox(J5.getTraceGeojson(r));
                    l = [
                        v[0],
                        v[2]
                    ], u = [
                        v[1],
                        v[3]
                    ];
                }
                var x = {
                    padded: !0
                };
                r._extremes.lon = nDe(n.lonaxis._ax, l, x), r._extremes.lat = nDe(n.lataxis._ax, u, x);
            }
            aDe.exports = {
                calcGeoJSON: Dzt,
                plot: Rzt
            };
        });
        var Iz = ye((Wpr, oDe)=>{
            "use strict";
            var zzt = Qa(), Fzt = K5(), qzt = Mr().fillText;
            oDe.exports = function(t, r, n) {
                var i = t.cd, a = i[0].trace, o = t.subplot, s, l, u, c, f = [
                    r,
                    n
                ], h = [
                    r + 360,
                    n
                ];
                for(l = 0; l < i.length; l++)if (s = i[l], c = !1, s._polygons) {
                    for(u = 0; u < s._polygons.length; u++)s._polygons[u].contains(f) && (c = !c), s._polygons[u].contains(h) && (c = !c);
                    if (c) break;
                }
                if (!(!c || !s)) return t.x0 = t.x1 = t.xa.c2p(s.ct), t.y0 = t.y1 = t.ya.c2p(s.ct), t.index = s.index, t.location = s.loc, t.z = s.z, t.zLabel = zzt.tickText(o.mockAxis, o.mockAxis.c2l(s.z), "hover").text, t.hovertemplate = s.hovertemplate, Ozt(t, a, s), [
                    t
                ];
            };
            function Ozt(e, t, r) {
                if (!t.hovertemplate) {
                    var n = r.hi || t.hoverinfo, i = String(r.loc), a = n === "all" ? Fzt.hoverinfo.flags : n.split("+"), o = a.indexOf("name") !== -1, s = a.indexOf("location") !== -1, l = a.indexOf("z") !== -1, u = a.indexOf("text") !== -1, c = !o && s, f = [];
                    c ? e.nameOverride = i : (o && (e.nameOverride = t.name), s && f.push(i)), l && f.push(e.zLabel), u && qzt(r, t, f), e.extraText = f.join("<br>");
                }
            }
        });
        var Rz = ye((Zpr, sDe)=>{
            "use strict";
            sDe.exports = function(t, r, n, i, a) {
                t.location = r.location, t.z = r.z;
                var o = i[a];
                return o.fIn && o.fIn.properties && (t.properties = o.fIn.properties), t.ct = o.ct, t;
            };
        });
        var Dz = ye((Xpr, lDe)=>{
            "use strict";
            lDe.exports = function(t, r) {
                var n = t.cd, i = t.xaxis, a = t.yaxis, o = [], s, l, u, c, f;
                if (r === !1) for(s = 0; s < n.length; s++)n[s].selected = 0;
                else for(s = 0; s < n.length; s++)l = n[s], u = l.ct, u && (c = i.c2p(u), f = a.c2p(u), r.contains([
                    c,
                    f
                ], null, s, t) ? (o.push({
                    pointNumber: s,
                    lon: u[0],
                    lat: u[1]
                }), l.selected = 1) : l.selected = 0);
                return o;
            };
        });
        var cDe = ye((Ypr, uDe)=>{
            "use strict";
            uDe.exports = {
                attributes: K5(),
                supplyDefaults: JRe(),
                colorbar: M_(),
                calc: Lz(),
                calcGeoJSON: RX().calcGeoJSON,
                plot: RX().plot,
                style: Pz().style,
                styleOnSelect: Pz().styleOnSelect,
                hoverPoints: Iz(),
                eventData: Rz(),
                selectPoints: Dz(),
                moduleType: "trace",
                name: "choropleth",
                basePlotModule: PX(),
                categories: [
                    "geo",
                    "noOpacity",
                    "showLegend"
                ],
                meta: {}
            };
        });
        var hDe = ye((Kpr, fDe)=>{
            "use strict";
            fDe.exports = cDe();
        });
        var zz = ye((Jpr, vDe)=>{
            "use strict";
            var Bzt = ba(), s0 = Mr(), Nzt = oT();
            function Uzt(e, t, r, n) {
                var i = e.cd, a = i[0].t, o = i[0].trace, s = e.xa, l = e.ya, u = a.x, c = a.y, f = s.c2p(t), h = l.c2p(r), d = e.distance, v;
                if (a.tree) {
                    var x = s.p2c(f - d), b = s.p2c(f + d), p = l.p2c(h - d), E = l.p2c(h + d);
                    n === "x" ? v = a.tree.range(Math.min(x, b), Math.min(l._rl[0], l._rl[1]), Math.max(x, b), Math.max(l._rl[0], l._rl[1])) : v = a.tree.range(Math.min(x, b), Math.min(p, E), Math.max(x, b), Math.max(p, E));
                } else v = a.ids;
                var k, A, L, _, C, M, g, P, T, F = d;
                if (n === "x") {
                    var q = !!o.xperiodalignment, V = !!o.yperiodalignment;
                    for(C = 0; C < v.length; C++){
                        if (k = v[C], L = u[k], M = Math.abs(s.c2p(L) - f), q) {
                            var H = s.c2p(o._xStarts[k]), X = s.c2p(o._xEnds[k]);
                            M = f >= Math.min(H, X) && f <= Math.max(H, X) ? 0 : 1 / 0;
                        }
                        if (M < F) {
                            if (F = M, _ = c[k], g = l.c2p(_) - h, V) {
                                var G = l.c2p(o._yStarts[k]), N = l.c2p(o._yEnds[k]);
                                g = h >= Math.min(G, N) && h <= Math.max(G, N) ? 0 : 1 / 0;
                            }
                            T = Math.sqrt(M * M + g * g), A = v[C];
                        }
                    }
                } else for(C = v.length - 1; C > -1; C--)k = v[C], L = u[k], _ = c[k], M = s.c2p(L) - f, g = l.c2p(_) - h, P = Math.sqrt(M * M + g * g), P < F && (F = T = P, A = k);
                return e.index = A, e.distance = F, e.dxy = T, A === void 0 ? [
                    e
                ] : [
                    dDe(e, u, c, o)
                ];
            }
            function dDe(e, t, r, n) {
                var i = e.xa, a = e.ya, o = e.distance, s = e.dxy, l = e.index, u = {
                    pointNumber: l,
                    x: t[l],
                    y: r[l]
                };
                u.tx = s0.isArrayOrTypedArray(n.text) ? n.text[l] : n.text, u.htx = Array.isArray(n.hovertext) ? n.hovertext[l] : n.hovertext, u.data = Array.isArray(n.customdata) ? n.customdata[l] : n.customdata, u.tp = Array.isArray(n.textposition) ? n.textposition[l] : n.textposition;
                var c = n.textfont;
                c && (u.ts = s0.isArrayOrTypedArray(c.size) ? c.size[l] : c.size, u.tc = s0.isArrayOrTypedArray(c.color) ? c.color[l] : c.color, u.tf = Array.isArray(c.family) ? c.family[l] : c.family, u.tw = Array.isArray(c.weight) ? c.weight[l] : c.weight, u.ty = Array.isArray(c.style) ? c.style[l] : c.style, u.tv = Array.isArray(c.variant) ? c.variant[l] : c.variant);
                var f = n.marker;
                f && (u.ms = s0.isArrayOrTypedArray(f.size) ? f.size[l] : f.size, u.mo = s0.isArrayOrTypedArray(f.opacity) ? f.opacity[l] : f.opacity, u.mx = s0.isArrayOrTypedArray(f.symbol) ? f.symbol[l] : f.symbol, u.ma = s0.isArrayOrTypedArray(f.angle) ? f.angle[l] : f.angle, u.mc = s0.isArrayOrTypedArray(f.color) ? f.color[l] : f.color);
                var h = f && f.line;
                h && (u.mlc = Array.isArray(h.color) ? h.color[l] : h.color, u.mlw = s0.isArrayOrTypedArray(h.width) ? h.width[l] : h.width);
                var d = f && f.gradient;
                d && d.type !== "none" && (u.mgt = Array.isArray(d.type) ? d.type[l] : d.type, u.mgc = Array.isArray(d.color) ? d.color[l] : d.color);
                var v = i.c2p(u.x, !0), x = a.c2p(u.y, !0), b = u.mrc || 1, p = n.hoverlabel;
                p && (u.hbg = Array.isArray(p.bgcolor) ? p.bgcolor[l] : p.bgcolor, u.hbc = Array.isArray(p.bordercolor) ? p.bordercolor[l] : p.bordercolor, u.hts = s0.isArrayOrTypedArray(p.font.size) ? p.font.size[l] : p.font.size, u.htc = Array.isArray(p.font.color) ? p.font.color[l] : p.font.color, u.htf = Array.isArray(p.font.family) ? p.font.family[l] : p.font.family, u.hnl = s0.isArrayOrTypedArray(p.namelength) ? p.namelength[l] : p.namelength);
                var E = n.hoverinfo;
                E && (u.hi = Array.isArray(E) ? E[l] : E);
                var k = n.hovertemplate;
                k && (u.ht = Array.isArray(k) ? k[l] : k);
                var A = {};
                A[e.index] = u;
                var L = n._origX, _ = n._origY, C = s0.extendFlat({}, e, {
                    color: Nzt(n, u),
                    x0: v - b,
                    x1: v + b,
                    xLabelVal: L ? L[l] : u.x,
                    y0: x - b,
                    y1: x + b,
                    yLabelVal: _ ? _[l] : u.y,
                    cd: A,
                    distance: o,
                    spikeDistance: s,
                    hovertemplate: u.ht
                });
                return u.htx ? C.text = u.htx : u.tx ? C.text = u.tx : n.text && (C.text = n.text), s0.fillText(u, n, C), Bzt.getComponentMethod("errorbars", "hoverInfo")(u, n, C), C;
            }
            vDe.exports = {
                hoverPoints: Uzt,
                calcHover: dDe
            };
        });
        var sx = ye(($pr, gDe)=>{
            "use strict";
            var pDe = 20;
            gDe.exports = {
                TOO_MANY_POINTS: 1e5,
                SYMBOL_SDF_SIZE: 200,
                SYMBOL_SIZE: pDe,
                SYMBOL_STROKE: pDe / 20,
                DOT_RE: /-dot/,
                OPEN_RE: /-open/,
                DASHES: {
                    solid: [
                        1
                    ],
                    dot: [
                        1,
                        1
                    ],
                    dash: [
                        4,
                        1
                    ],
                    longdash: [
                        8,
                        1
                    ],
                    dashdot: [
                        4,
                        1,
                        1,
                        1
                    ],
                    longdashdot: [
                        8,
                        1,
                        1,
                        1
                    ]
                }
            };
        });
        var tk = ye((Qpr, xDe)=>{
            "use strict";
            var Vzt = vl(), Hzt = Su(), Gzt = Eg(), Af = Uc(), mDe = Oc().axisHoverFormat, yDe = Jl(), jzt = Y1(), DX = no().extendFlat, Wzt = Bu().overrideAll, Zzt = sx().DASHES, _De = Af.line, r1 = Af.marker, Xzt = r1.line, $5 = xDe.exports = Wzt({
                x: Af.x,
                x0: Af.x0,
                dx: Af.dx,
                y: Af.y,
                y0: Af.y0,
                dy: Af.dy,
                xperiod: Af.xperiod,
                yperiod: Af.yperiod,
                xperiod0: Af.xperiod0,
                yperiod0: Af.yperiod0,
                xperiodalignment: Af.xperiodalignment,
                yperiodalignment: Af.yperiodalignment,
                xhoverformat: mDe("x"),
                yhoverformat: mDe("y"),
                text: Af.text,
                hovertext: Af.hovertext,
                textposition: Af.textposition,
                textfont: Hzt({
                    noFontShadow: !0,
                    noFontLineposition: !0,
                    noFontTextcase: !0,
                    editType: "calc",
                    colorEditType: "style",
                    arrayOk: !0,
                    noNumericWeightValues: !0,
                    variantValues: [
                        "normal",
                        "small-caps"
                    ]
                }),
                mode: {
                    valType: "flaglist",
                    flags: [
                        "lines",
                        "markers",
                        "text"
                    ],
                    extras: [
                        "none"
                    ]
                },
                line: {
                    color: _De.color,
                    width: _De.width,
                    shape: {
                        valType: "enumerated",
                        values: [
                            "linear",
                            "hv",
                            "vh",
                            "hvh",
                            "vhv"
                        ],
                        dflt: "linear",
                        editType: "plot"
                    },
                    dash: {
                        valType: "enumerated",
                        values: jzt(Zzt),
                        dflt: "solid"
                    }
                },
                marker: DX({}, yDe("marker"), {
                    symbol: r1.symbol,
                    angle: r1.angle,
                    size: r1.size,
                    sizeref: r1.sizeref,
                    sizemin: r1.sizemin,
                    sizemode: r1.sizemode,
                    opacity: r1.opacity,
                    colorbar: r1.colorbar,
                    line: DX({}, yDe("marker.line"), {
                        width: Xzt.width
                    })
                }),
                connectgaps: Af.connectgaps,
                fill: DX({}, Af.fill, {
                    dflt: "none"
                }),
                fillcolor: Gzt(),
                selected: {
                    marker: Af.selected.marker,
                    textfont: Af.selected.textfont
                },
                unselected: {
                    marker: Af.unselected.marker,
                    textfont: Af.unselected.textfont
                },
                opacity: Vzt.opacity
            }, "calc", "nested");
            $5.x.editType = $5.y.editType = $5.x0.editType = $5.y0.editType = "calc+clearAxisTypes";
            $5.hovertemplate = Af.hovertemplate;
            $5.texttemplate = Af.texttemplate;
        });
        var Fz = ye((zX)=>{
            "use strict";
            var bDe = sx();
            zX.isOpenSymbol = function(e) {
                return typeof e == "string" ? bDe.OPEN_RE.test(e) : e % 200 > 100;
            };
            zX.isDotSymbol = function(e) {
                return typeof e == "string" ? bDe.DOT_RE.test(e) : e > 200;
            };
        });
        var ADe = ye((t0r, TDe)=>{
            "use strict";
            var wDe = Mr(), Yzt = ba(), Kzt = Fz(), Jzt = tk(), $zt = Sm(), qz = lu(), Qzt = K3(), eFt = Pg(), tFt = $p(), rFt = R0(), iFt = Ig(), nFt = D0();
            TDe.exports = function(t, r, n, i) {
                function a(d, v) {
                    return wDe.coerce(t, r, Jzt, d, v);
                }
                var o = t.marker ? Kzt.isOpenSymbol(t.marker.symbol) : !1, s = qz.isBubble(t), l = Qzt(t, r, i, a);
                if (!l) {
                    r.visible = !1;
                    return;
                }
                eFt(t, r, i, a), a("xhoverformat"), a("yhoverformat");
                var u = l < $zt.PTS_LINESONLY ? "lines+markers" : "lines";
                a("text"), a("hovertext"), a("hovertemplate"), a("mode", u), qz.hasMarkers(r) && (tFt(t, r, n, i, a, {
                    noAngleRef: !0,
                    noStandOff: !0
                }), a("marker.line.width", o || s ? 1 : 0)), qz.hasLines(r) && (a("connectgaps"), rFt(t, r, n, i, a), a("line.shape")), qz.hasText(r) && (a("texttemplate"), nFt(t, r, i, a, {
                    noFontShadow: !0,
                    noFontLineposition: !0,
                    noFontTextcase: !0
                }));
                var c = (r.line || {}).color, f = (r.marker || {}).color;
                a("fill"), r.fill !== "none" && iFt(t, r, n, a);
                var h = Yzt.getComponentMethod("errorbars", "supplyDefaults");
                h(t, r, c || f || n, {
                    axis: "y"
                }), h(t, r, c || f || n, {
                    axis: "x",
                    inherit: "y"
                }), wDe.coerceSelectionMarkerOpacity(r, a);
            };
        });
        var MDe = ye((r0r, SDe)=>{
            "use strict";
            var aFt = $P();
            SDe.exports = function(t, r, n) {
                var i = t.i;
                return "x" in t || (t.x = r._x[i]), "y" in t || (t.y = r._y[i]), aFt(t, r, n);
            };
        });
        var kDe = ye((i0r, EDe)=>{
            "use strict";
            function oFt(e, t, r, n, i) {
                for(var a = i + 1; n <= i;){
                    var o = n + i >>> 1, s = e[o], l = r !== void 0 ? r(s, t) : s - t;
                    l >= 0 ? (a = o, i = o - 1) : n = o + 1;
                }
                return a;
            }
            function sFt(e, t, r, n, i) {
                for(var a = i + 1; n <= i;){
                    var o = n + i >>> 1, s = e[o], l = r !== void 0 ? r(s, t) : s - t;
                    l > 0 ? (a = o, i = o - 1) : n = o + 1;
                }
                return a;
            }
            function lFt(e, t, r, n, i) {
                for(var a = n - 1; n <= i;){
                    var o = n + i >>> 1, s = e[o], l = r !== void 0 ? r(s, t) : s - t;
                    l < 0 ? (a = o, n = o + 1) : i = o - 1;
                }
                return a;
            }
            function uFt(e, t, r, n, i) {
                for(var a = n - 1; n <= i;){
                    var o = n + i >>> 1, s = e[o], l = r !== void 0 ? r(s, t) : s - t;
                    l <= 0 ? (a = o, n = o + 1) : i = o - 1;
                }
                return a;
            }
            function cFt(e, t, r, n, i) {
                for(; n <= i;){
                    var a = n + i >>> 1, o = e[a], s = r !== void 0 ? r(o, t) : o - t;
                    if (s === 0) return a;
                    s <= 0 ? n = a + 1 : i = a - 1;
                }
                return -1;
            }
            function rk(e, t, r, n, i, a) {
                return typeof r == "function" ? a(e, t, r, n === void 0 ? 0 : n | 0, i === void 0 ? e.length - 1 : i | 0) : a(e, t, void 0, r === void 0 ? 0 : r | 0, n === void 0 ? e.length - 1 : n | 0);
            }
            EDe.exports = {
                ge: function(e, t, r, n, i) {
                    return rk(e, t, r, n, i, oFt);
                },
                gt: function(e, t, r, n, i) {
                    return rk(e, t, r, n, i, sFt);
                },
                lt: function(e, t, r, n, i) {
                    return rk(e, t, r, n, i, lFt);
                },
                le: function(e, t, r, n, i) {
                    return rk(e, t, r, n, i, uFt);
                },
                eq: function(e, t, r, n, i) {
                    return rk(e, t, r, n, i, cFt);
                }
            };
        });
        var Zm = ye((n0r, LDe)=>{
            "use strict";
            LDe.exports = function(t, r, n) {
                var i = {}, a, o;
                if (typeof r == "string" && (r = CDe(r)), Array.isArray(r)) {
                    var s = {};
                    for(o = 0; o < r.length; o++)s[r[o]] = !0;
                    r = s;
                }
                for(a in r)r[a] = CDe(r[a]);
                var l = {};
                for(a in r){
                    var u = r[a];
                    if (Array.isArray(u)) for(o = 0; o < u.length; o++){
                        var c = u[o];
                        if (n && (l[c] = !0), c in t) {
                            if (i[a] = t[c], n) for(var f = o; f < u.length; f++)l[u[f]] = !0;
                            break;
                        }
                    }
                    else a in t && (r[a] && (i[a] = t[a]), n && (l[a] = !0));
                }
                if (n) for(a in t)l[a] || (i[a] = t[a]);
                return i;
            };
            var FX = {};
            function CDe(e) {
                return FX[e] ? FX[e] : (typeof e == "string" && (e = FX[e] = e.split(/\s*,\s*|\s+/)), e);
            }
        });
        var Q5 = ye((a0r, PDe)=>{
            "use strict";
            var fFt = Zm();
            PDe.exports = hFt;
            function hFt(e) {
                var t;
                return arguments.length > 1 && (e = arguments), typeof e == "string" ? e = e.split(/\s/).map(parseFloat) : typeof e == "number" && (e = [
                    e
                ]), e.length && typeof e[0] == "number" ? e.length === 1 ? t = {
                    width: e[0],
                    height: e[0],
                    x: 0,
                    y: 0
                } : e.length === 2 ? t = {
                    width: e[0],
                    height: e[1],
                    x: 0,
                    y: 0
                } : t = {
                    x: e[0],
                    y: e[1],
                    width: e[2] - e[0] || 0,
                    height: e[3] - e[1] || 0
                } : e && (e = fFt(e, {
                    left: "x l left Left",
                    top: "y t top Top",
                    width: "w width W Width",
                    height: "h height W Width",
                    bottom: "b bottom Bottom",
                    right: "r right Right"
                }), t = {
                    x: e.left || 0,
                    y: e.top || 0
                }, e.width == null ? e.right ? t.width = e.right - t.x : t.width = 0 : t.width = e.width, e.height == null ? e.bottom ? t.height = e.bottom - t.y : t.height = 0 : t.height = e.height), t;
            }
        });
        var j2 = ye((o0r, IDe)=>{
            "use strict";
            IDe.exports = dFt;
            function dFt(e, t) {
                if (!e || e.length == null) throw Error("Argument should be an array");
                t == null ? t = 1 : t = Math.floor(t);
                for(var r = Array(t * 2), n = 0; n < t; n++){
                    for(var i = -1 / 0, a = 1 / 0, o = n, s = e.length; o < s; o += t)e[o] > i && (i = e[o]), e[o] < a && (a = e[o]);
                    r[n] = a, r[t + n] = i;
                }
                return r;
            }
        });
        var DDe = ye((s0r, RDe)=>{
            RDe.exports = function() {
                for(var e = 0; e < arguments.length; e++)if (arguments[e] !== void 0) return arguments[e];
            };
        });
        var W2 = ye((l0r, FDe)=>{
            var zDe = HD();
            FDe.exports = vFt;
            function vFt(e, t, r) {
                if (!e) throw new TypeError("must specify data as first parameter");
                if (r = +(r || 0) | 0, Array.isArray(e) && e[0] && typeof e[0][0] == "number") {
                    var n = e[0].length, i = e.length * n, a, o, s, l;
                    (!t || typeof t == "string") && (t = new (zDe(t || "float32"))(i + r));
                    var u = t.length - r;
                    if (i !== u) throw new Error("source length " + i + " (" + n + "x" + e.length + ") does not match destination length " + u);
                    for(a = 0, s = r; a < e.length; a++)for(o = 0; o < n; o++)t[s++] = e[a][o] === null ? NaN : e[a][o];
                } else if (!t || typeof t == "string") {
                    var c = zDe(t || "float32");
                    if (Array.isArray(e) || t === "array") for(t = new c(e.length + r), a = 0, s = r, l = t.length; s < l; s++, a++)t[s] = e[a] === null ? NaN : e[a];
                    else r === 0 ? t = new c(e) : (t = new c(e.length + r), t.set(e, r));
                } else t.set(e, r);
                return t;
            }
        });
        var ODe = ye((u0r, qDe)=>{
            "use strict";
            qDe.exports = function(e) {
                var t = typeof e;
                return e !== null && (t === "object" || t === "function");
            };
        });
        var NDe = ye((c0r, BDe)=>{
            "use strict";
            BDe.exports = Math.log2 || function(e) {
                return Math.log(e) * Math.LOG2E;
            };
        });
        var ZDe = ye((f0r, WDe)=>{
            "use strict";
            var UDe = kDe(), VDe = VE(), pFt = Q5(), gFt = j2(), HDe = Zm(), qX = DDe(), mFt = W2(), yFt = ODe(), _Ft = HD(), GDe = NDe(), xFt = 1073741824;
            WDe.exports = function(t, r) {
                r || (r = {}), t = mFt(t, "float64"), r = HDe(r, {
                    bounds: "range bounds dataBox databox",
                    maxDepth: "depth maxDepth maxdepth level maxLevel maxlevel levels",
                    dtype: "type dtype format out dst output destination"
                });
                let n = qX(r.maxDepth, 255), i = qX(r.bounds, gFt(t, 2));
                i[0] === i[2] && i[2]++, i[1] === i[3] && i[3]++;
                let a = jDe(t, i), o = t.length >>> 1, s;
                r.dtype || (r.dtype = "array"), typeof r.dtype == "string" ? s = new (_Ft(r.dtype))(o) : r.dtype && (s = r.dtype, Array.isArray(s) && (s.length = o));
                for(let p = 0; p < o; ++p)s[p] = p;
                let l = [], u = [], c = [], f = [];
                d(0, 0, 1, s, 0, 1);
                let h = 0;
                for(let p = 0; p < l.length; p++){
                    let E = l[p];
                    if (s.set) s.set(E, h);
                    else for(let A = 0, L = E.length; A < L; A++)s[A + h] = E[A];
                    let k = h + l[p].length;
                    f[p] = [
                        h,
                        k
                    ], h = k;
                }
                return s.range = v, s;
                function d(p, E, k, A, L, _) {
                    if (!A.length) return null;
                    let C = l[L] || (l[L] = []), M = c[L] || (c[L] = []), g = u[L] || (u[L] = []), P = C.length;
                    if (L++, L > n || _ > xFt) {
                        for(let N = 0; N < A.length; N++)C.push(A[N]), M.push(_), g.push(null, null, null, null);
                        return P;
                    }
                    if (C.push(A[0]), M.push(_), A.length <= 1) return g.push(null, null, null, null), P;
                    let T = k * .5, F = p + T, q = E + T, V = [], H = [], X = [], G = [];
                    for(let N = 1, W = A.length; N < W; N++){
                        let re = A[N], ae = a[re * 2], _e = a[re * 2 + 1];
                        ae < F ? _e < q ? V.push(re) : H.push(re) : _e < q ? X.push(re) : G.push(re);
                    }
                    return _ <<= 2, g.push(d(p, E, T, V, L, _), d(p, q, T, H, L, _ + 1), d(F, E, T, X, L, _ + 2), d(F, q, T, G, L, _ + 3)), P;
                }
                function v(...p) {
                    let E;
                    if (yFt(p[p.length - 1])) {
                        let X = p.pop();
                        !p.length && (X.x != null || X.l != null || X.left != null) && (p = [
                            X
                        ], E = {}), E = HDe(X, {
                            level: "level maxLevel",
                            d: "d diam diameter r radius px pxSize pixel pixelSize maxD size minSize",
                            lod: "lod details ranges offsets"
                        });
                    } else E = {};
                    p.length || (p = i);
                    let k = pFt(...p), [A, L, _, C] = [
                        Math.min(k.x, k.x + k.width),
                        Math.min(k.y, k.y + k.height),
                        Math.max(k.x, k.x + k.width),
                        Math.max(k.y, k.y + k.height)
                    ], [M, g, P, T] = jDe([
                        A,
                        L,
                        _,
                        C
                    ], i), F = qX(E.level, l.length);
                    if (E.d != null) {
                        let X;
                        typeof E.d == "number" ? X = [
                            E.d,
                            E.d
                        ] : E.d.length && (X = E.d), F = Math.min(Math.max(Math.ceil(-GDe(Math.abs(X[0]) / (i[2] - i[0]))), Math.ceil(-GDe(Math.abs(X[1]) / (i[3] - i[1])))), F);
                    }
                    if (F = Math.min(F, l.length), E.lod) return x(M, g, P, T, F);
                    let q = [];
                    V(0, 0, 1, 0, 0, 1);
                    function V(X, G, N, W, re, ae) {
                        if (re === null || ae === null) return;
                        let _e = X + N, Me = G + N;
                        if (M > _e || g > Me || P < X || T < G || W >= F || re === ae) return;
                        let ke = l[W];
                        ae === void 0 && (ae = ke.length);
                        for(let Re = re; Re < ae; Re++){
                            let ce = ke[Re], Ge = t[ce * 2], nt = t[ce * 2 + 1];
                            Ge >= A && Ge <= _ && nt >= L && nt <= C && q.push(ce);
                        }
                        let ge = u[W], ie = ge[re * 4 + 0], Te = ge[re * 4 + 1], Ee = ge[re * 4 + 2], Ae = ge[re * 4 + 3], ze = H(ge, re + 1), Ce = N * .5, me = W + 1;
                        V(X, G, Ce, me, ie, Te || Ee || Ae || ze), V(X, G + Ce, Ce, me, Te, Ee || Ae || ze), V(X + Ce, G, Ce, me, Ee, Ae || ze), V(X + Ce, G + Ce, Ce, me, Ae, ze);
                    }
                    function H(X, G) {
                        let N = null, W = 0;
                        for(; N === null;)if (N = X[G * 4 + W], W++, W > X.length) return null;
                        return N;
                    }
                    return q;
                }
                function x(p, E, k, A, L) {
                    let _ = [];
                    for(let C = 0; C < L; C++){
                        let M = c[C], g = f[C][0], P = b(p, E, C), T = b(k, A, C), F = UDe.ge(M, P), q = UDe.gt(M, T, F, M.length - 1);
                        _[C] = [
                            F + g,
                            q + g
                        ];
                    }
                    return _;
                }
                function b(p, E, k) {
                    let A = 1, L = .5, _ = .5, C = .5;
                    for(let M = 0; M < k; M++)A <<= 2, A += p < L ? E < _ ? 0 : 1 : E < _ ? 2 : 3, C *= .5, L += p < L ? -C : C, _ += E < _ ? -C : C;
                    return A;
                }
            };
            function jDe(e, t) {
                let [r, n, i, a] = t, o = 1 / (i - r), s = 1 / (a - n), l = new Array(e.length);
                for(let u = 0, c = e.length / 2; u < c; u++)l[2 * u] = VDe((e[2 * u] - r) * o, 0, 1), l[2 * u + 1] = VDe((e[2 * u + 1] - n) * s, 0, 1);
                return l;
            }
        });
        var Oz = ye((h0r, XDe)=>{
            "use strict";
            XDe.exports = ZDe();
        });
        var OX = ye((d0r, YDe)=>{
            YDe.exports = bFt;
            function bFt(e) {
                var t = 0, r = 0, n = 0, i = 0;
                return e.map(function(a) {
                    a = a.slice();
                    var o = a[0], s = o.toUpperCase();
                    if (o != s) switch(a[0] = s, o){
                        case "a":
                            a[6] += n, a[7] += i;
                            break;
                        case "v":
                            a[1] += i;
                            break;
                        case "h":
                            a[1] += n;
                            break;
                        default:
                            for(var l = 1; l < a.length;)a[l++] += n, a[l++] += i;
                    }
                    switch(s){
                        case "Z":
                            n = t, i = r;
                            break;
                        case "H":
                            n = a[1];
                            break;
                        case "V":
                            i = a[1];
                            break;
                        case "M":
                            n = t = a[1], i = r = a[2];
                            break;
                        default:
                            n = a[a.length - 2], i = a[a.length - 1];
                    }
                    return a;
                });
            }
        });
        var $De = ye((Bz, JDe)=>{
            "use strict";
            Object.defineProperty(Bz, "__esModule", {
                value: !0
            });
            var wFt = function() {
                function e(t, r) {
                    var n = [], i = !0, a = !1, o = void 0;
                    try {
                        for(var s = t[Symbol.iterator](), l; !(i = (l = s.next()).done) && (n.push(l.value), !(r && n.length === r)); i = !0);
                    } catch (u) {
                        a = !0, o = u;
                    } finally{
                        try {
                            !i && s.return && s.return();
                        } finally{
                            if (a) throw o;
                        }
                    }
                    return n;
                }
                return function(t, r) {
                    if (Array.isArray(t)) return t;
                    if (Symbol.iterator in Object(t)) return e(t, r);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }(), ik = Math.PI * 2, BX = function(t, r, n, i, a, o, s) {
                var l = t.x, u = t.y;
                l *= r, u *= n;
                var c = i * l - a * u, f = a * l + i * u;
                return {
                    x: c + o,
                    y: f + s
                };
            }, TFt = function(t, r) {
                var n = r === 1.5707963267948966 ? .551915024494 : r === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(r / 4), i = Math.cos(t), a = Math.sin(t), o = Math.cos(t + r), s = Math.sin(t + r);
                return [
                    {
                        x: i - a * n,
                        y: a + i * n
                    },
                    {
                        x: o + s * n,
                        y: s - o * n
                    },
                    {
                        x: o,
                        y: s
                    }
                ];
            }, KDe = function(t, r, n, i) {
                var a = t * i - r * n < 0 ? -1 : 1, o = t * n + r * i;
                return o > 1 && (o = 1), o < -1 && (o = -1), a * Math.acos(o);
            }, AFt = function(t, r, n, i, a, o, s, l, u, c, f, h) {
                var d = Math.pow(a, 2), v = Math.pow(o, 2), x = Math.pow(f, 2), b = Math.pow(h, 2), p = d * v - d * b - v * x;
                p < 0 && (p = 0), p /= d * b + v * x, p = Math.sqrt(p) * (s === l ? -1 : 1);
                var E = p * a / o * h, k = p * -o / a * f, A = c * E - u * k + (t + n) / 2, L = u * E + c * k + (r + i) / 2, _ = (f - E) / a, C = (h - k) / o, M = (-f - E) / a, g = (-h - k) / o, P = KDe(1, 0, _, C), T = KDe(_, C, M, g);
                return l === 0 && T > 0 && (T -= ik), l === 1 && T < 0 && (T += ik), [
                    A,
                    L,
                    P,
                    T
                ];
            }, SFt = function(t) {
                var r = t.px, n = t.py, i = t.cx, a = t.cy, o = t.rx, s = t.ry, l = t.xAxisRotation, u = l === void 0 ? 0 : l, c = t.largeArcFlag, f = c === void 0 ? 0 : c, h = t.sweepFlag, d = h === void 0 ? 0 : h, v = [];
                if (o === 0 || s === 0) return [];
                var x = Math.sin(u * ik / 360), b = Math.cos(u * ik / 360), p = b * (r - i) / 2 + x * (n - a) / 2, E = -x * (r - i) / 2 + b * (n - a) / 2;
                if (p === 0 && E === 0) return [];
                o = Math.abs(o), s = Math.abs(s);
                var k = Math.pow(p, 2) / Math.pow(o, 2) + Math.pow(E, 2) / Math.pow(s, 2);
                k > 1 && (o *= Math.sqrt(k), s *= Math.sqrt(k));
                var A = AFt(r, n, i, a, o, s, f, d, x, b, p, E), L = wFt(A, 4), _ = L[0], C = L[1], M = L[2], g = L[3], P = Math.abs(g) / (ik / 4);
                Math.abs(1 - P) < 1e-7 && (P = 1);
                var T = Math.max(Math.ceil(P), 1);
                g /= T;
                for(var F = 0; F < T; F++)v.push(TFt(M, g)), M += g;
                return v.map(function(q) {
                    var V = BX(q[0], o, s, b, x, _, C), H = V.x, X = V.y, G = BX(q[1], o, s, b, x, _, C), N = G.x, W = G.y, re = BX(q[2], o, s, b, x, _, C), ae = re.x, _e = re.y;
                    return {
                        x1: H,
                        y1: X,
                        x2: N,
                        y2: W,
                        x: ae,
                        y: _e
                    };
                });
            };
            Bz.default = SFt;
            JDe.exports = Bz.default;
        });
        var tze = ye((v0r, eze)=>{
            "use strict";
            eze.exports = EFt;
            var MFt = $De();
            function EFt(e) {
                for(var t, r = [], n = 0, i = 0, a = 0, o = 0, s = null, l = null, u = 0, c = 0, f = 0, h = e.length; f < h; f++){
                    var d = e[f], v = d[0];
                    switch(v){
                        case "M":
                            a = d[1], o = d[2];
                            break;
                        case "A":
                            var x = MFt({
                                px: u,
                                py: c,
                                cx: d[6],
                                cy: d[7],
                                rx: d[1],
                                ry: d[2],
                                xAxisRotation: d[3],
                                largeArcFlag: d[4],
                                sweepFlag: d[5]
                            });
                            if (!x.length) continue;
                            for(var b = 0, p; b < x.length; b++)p = x[b], d = [
                                "C",
                                p.x1,
                                p.y1,
                                p.x2,
                                p.y2,
                                p.x,
                                p.y
                            ], b < x.length - 1 && r.push(d);
                            break;
                        case "S":
                            var E = u, k = c;
                            (t == "C" || t == "S") && (E += E - n, k += k - i), d = [
                                "C",
                                E,
                                k,
                                d[1],
                                d[2],
                                d[3],
                                d[4]
                            ];
                            break;
                        case "T":
                            t == "Q" || t == "T" ? (s = u * 2 - s, l = c * 2 - l) : (s = u, l = c), d = QDe(u, c, s, l, d[1], d[2]);
                            break;
                        case "Q":
                            s = d[1], l = d[2], d = QDe(u, c, d[1], d[2], d[3], d[4]);
                            break;
                        case "L":
                            d = Nz(u, c, d[1], d[2]);
                            break;
                        case "H":
                            d = Nz(u, c, d[1], c);
                            break;
                        case "V":
                            d = Nz(u, c, u, d[1]);
                            break;
                        case "Z":
                            d = Nz(u, c, a, o);
                            break;
                    }
                    t = v, u = d[d.length - 2], c = d[d.length - 1], d.length > 4 ? (n = d[d.length - 4], i = d[d.length - 3]) : (n = u, i = c), r.push(d);
                }
                return r;
            }
            function Nz(e, t, r, n) {
                return [
                    "C",
                    e,
                    t,
                    r,
                    n,
                    r,
                    n
                ];
            }
            function QDe(e, t, r, n, i, a) {
                return [
                    "C",
                    e / 3 + 2 / 3 * r,
                    t / 3 + 2 / 3 * n,
                    i / 3 + 2 / 3 * r,
                    a / 3 + 2 / 3 * n,
                    i,
                    a
                ];
            }
        });
        var NX = ye((p0r, rze)=>{
            "use strict";
            rze.exports = function(t) {
                return typeof t != "string" ? !1 : (t = t.trim(), !!(/^[mzlhvcsqta]\s*[-+.0-9][^mlhvzcsqta]+/i.test(t) && /[\dz]$/i.test(t) && t.length > 4));
            };
        });
        var aze = ye((g0r, nze)=>{
            "use strict";
            var kFt = XS(), CFt = OX(), LFt = tze(), PFt = NX(), ize = tE();
            nze.exports = IFt;
            function IFt(e) {
                if (Array.isArray(e) && e.length === 1 && typeof e[0] == "string" && (e = e[0]), typeof e == "string" && (ize(PFt(e), "String is not an SVG path."), e = kFt(e)), ize(Array.isArray(e), "Argument should be a string or an array of path segments."), e = CFt(e), e = LFt(e), !e.length) return [
                    0,
                    0,
                    0,
                    0
                ];
                for(var t = [
                    1 / 0,
                    1 / 0,
                    -1 / 0,
                    -1 / 0
                ], r = 0, n = e.length; r < n; r++)for(var i = e[r].slice(1), a = 0; a < i.length; a += 2)i[a + 0] < t[0] && (t[0] = i[a + 0]), i[a + 1] < t[1] && (t[1] = i[a + 1]), i[a + 0] > t[2] && (t[2] = i[a + 0]), i[a + 1] > t[3] && (t[3] = i[a + 1]);
                return t;
            }
        });
        var fze = ye((m0r, cze)=>{
            var Z2 = Math.PI, oze = uze(120);
            cze.exports = RFt;
            function RFt(e) {
                for(var t, r = [], n = 0, i = 0, a = 0, o = 0, s = null, l = null, u = 0, c = 0, f = 0, h = e.length; f < h; f++){
                    var d = e[f], v = d[0];
                    switch(v){
                        case "M":
                            a = d[1], o = d[2];
                            break;
                        case "A":
                            d = lze(u, c, d[1], d[2], uze(d[3]), d[4], d[5], d[6], d[7]), d.unshift("C"), d.length > 7 && (r.push(d.splice(0, 7)), d.unshift("C"));
                            break;
                        case "S":
                            var x = u, b = c;
                            (t == "C" || t == "S") && (x += x - n, b += b - i), d = [
                                "C",
                                x,
                                b,
                                d[1],
                                d[2],
                                d[3],
                                d[4]
                            ];
                            break;
                        case "T":
                            t == "Q" || t == "T" ? (s = u * 2 - s, l = c * 2 - l) : (s = u, l = c), d = sze(u, c, s, l, d[1], d[2]);
                            break;
                        case "Q":
                            s = d[1], l = d[2], d = sze(u, c, d[1], d[2], d[3], d[4]);
                            break;
                        case "L":
                            d = Uz(u, c, d[1], d[2]);
                            break;
                        case "H":
                            d = Uz(u, c, d[1], c);
                            break;
                        case "V":
                            d = Uz(u, c, u, d[1]);
                            break;
                        case "Z":
                            d = Uz(u, c, a, o);
                            break;
                    }
                    t = v, u = d[d.length - 2], c = d[d.length - 1], d.length > 4 ? (n = d[d.length - 4], i = d[d.length - 3]) : (n = u, i = c), r.push(d);
                }
                return r;
            }
            function Uz(e, t, r, n) {
                return [
                    "C",
                    e,
                    t,
                    r,
                    n,
                    r,
                    n
                ];
            }
            function sze(e, t, r, n, i, a) {
                return [
                    "C",
                    e / 3 + 2 / 3 * r,
                    t / 3 + 2 / 3 * n,
                    i / 3 + 2 / 3 * r,
                    a / 3 + 2 / 3 * n,
                    i,
                    a
                ];
            }
            function lze(e, t, r, n, i, a, o, s, l, u) {
                if (u) k = u[0], A = u[1], p = u[2], E = u[3];
                else {
                    var c = UX(e, t, -i);
                    e = c.x, t = c.y, c = UX(s, l, -i), s = c.x, l = c.y;
                    var f = (e - s) / 2, h = (t - l) / 2, d = f * f / (r * r) + h * h / (n * n);
                    d > 1 && (d = Math.sqrt(d), r = d * r, n = d * n);
                    var v = r * r, x = n * n, b = (a == o ? -1 : 1) * Math.sqrt(Math.abs((v * x - v * h * h - x * f * f) / (v * h * h + x * f * f)));
                    b == 1 / 0 && (b = 1);
                    var p = b * r * h / n + (e + s) / 2, E = b * -n * f / r + (t + l) / 2, k = Math.asin(((t - E) / n).toFixed(9)), A = Math.asin(((l - E) / n).toFixed(9));
                    k = e < p ? Z2 - k : k, A = s < p ? Z2 - A : A, k < 0 && (k = Z2 * 2 + k), A < 0 && (A = Z2 * 2 + A), o && k > A && (k = k - Z2 * 2), !o && A > k && (A = A - Z2 * 2);
                }
                if (Math.abs(A - k) > oze) {
                    var L = A, _ = s, C = l;
                    A = k + oze * (o && A > k ? 1 : -1), s = p + r * Math.cos(A), l = E + n * Math.sin(A);
                    var M = lze(s, l, r, n, i, 0, o, _, C, [
                        A,
                        L,
                        p,
                        E
                    ]);
                }
                var g = Math.tan((A - k) / 4), P = 4 / 3 * r * g, T = 4 / 3 * n * g, F = [
                    2 * e - (e + P * Math.sin(k)),
                    2 * t - (t - T * Math.cos(k)),
                    s + P * Math.sin(A),
                    l - T * Math.cos(A),
                    s,
                    l
                ];
                if (u) return F;
                M && (F = F.concat(M));
                for(var q = 0; q < F.length;){
                    var V = UX(F[q], F[q + 1], i);
                    F[q++] = V.x, F[q++] = V.y;
                }
                return F;
            }
            function UX(e, t, r) {
                return {
                    x: e * Math.cos(r) - t * Math.sin(r),
                    y: e * Math.sin(r) + t * Math.cos(r)
                };
            }
            function uze(e) {
                return e * (Z2 / 180);
            }
        });
        var dze = ye((y0r, hze)=>{
            var DFt = OX(), zFt = fze(), FFt = {
                M: "moveTo",
                C: "bezierCurveTo"
            };
            hze.exports = function(e, t) {
                e.beginPath(), zFt(DFt(t)).forEach(function(r) {
                    var n = r[0], i = r.slice(1);
                    e[FFt[n]].apply(e, i);
                }), e.closePath();
            };
        });
        var mze = ye((_0r, gze)=>{
            "use strict";
            var qFt = VE();
            gze.exports = OFt;
            var nk = 1e20;
            function OFt(e, t) {
                t || (t = {});
                var r = t.cutoff == null ? .25 : t.cutoff, n = t.radius == null ? 8 : t.radius, i = t.channel || 0, a, o, s, l, u, c, f, h, d, v, x;
                if (ArrayBuffer.isView(e) || Array.isArray(e)) {
                    if (!t.width || !t.height) throw Error("For raw data width and height should be provided by options");
                    a = t.width, o = t.height, l = e, t.stride ? c = t.stride : c = Math.floor(e.length / a / o);
                } else window.HTMLCanvasElement && e instanceof window.HTMLCanvasElement ? (h = e, f = h.getContext("2d"), a = h.width, o = h.height, d = f.getImageData(0, 0, a, o), l = d.data, c = 4) : window.CanvasRenderingContext2D && e instanceof window.CanvasRenderingContext2D ? (h = e.canvas, f = e, a = h.width, o = h.height, d = f.getImageData(0, 0, a, o), l = d.data, c = 4) : window.ImageData && e instanceof window.ImageData && (d = e, a = e.width, o = e.height, l = d.data, c = 4);
                if (s = Math.max(a, o), window.Uint8ClampedArray && l instanceof window.Uint8ClampedArray || window.Uint8Array && l instanceof window.Uint8Array) for(u = l, l = Array(a * o), v = 0, x = u.length; v < x; v++)l[v] = u[v * c + i] / 255;
                else if (c !== 1) throw Error("Raw data can have only 1 value per pixel");
                var b = Array(a * o), p = Array(a * o), E = Array(s), k = Array(s), A = Array(s + 1), L = Array(s);
                for(v = 0, x = a * o; v < x; v++){
                    var _ = l[v];
                    b[v] = _ === 1 ? 0 : _ === 0 ? nk : Math.pow(Math.max(0, .5 - _), 2), p[v] = _ === 1 ? nk : _ === 0 ? 0 : Math.pow(Math.max(0, _ - .5), 2);
                }
                vze(b, a, o, E, k, L, A), vze(p, a, o, E, k, L, A);
                var C = window.Float32Array ? new Float32Array(a * o) : new Array(a * o);
                for(v = 0, x = a * o; v < x; v++)C[v] = qFt(1 - ((b[v] - p[v]) / n + r), 0, 1);
                return C;
            }
            function vze(e, t, r, n, i, a, o) {
                for(var s = 0; s < t; s++){
                    for(var l = 0; l < r; l++)n[l] = e[l * t + s];
                    for(pze(n, i, a, o, r), l = 0; l < r; l++)e[l * t + s] = i[l];
                }
                for(l = 0; l < r; l++){
                    for(s = 0; s < t; s++)n[s] = e[l * t + s];
                    for(pze(n, i, a, o, t), s = 0; s < t; s++)e[l * t + s] = Math.sqrt(i[s]);
                }
            }
            function pze(e, t, r, n, i) {
                r[0] = 0, n[0] = -nk, n[1] = +nk;
                for(var a = 1, o = 0; a < i; a++){
                    for(var s = (e[a] + a * a - (e[r[o]] + r[o] * r[o])) / (2 * a - 2 * r[o]); s <= n[o];)o--, s = (e[a] + a * a - (e[r[o]] + r[o] * r[o])) / (2 * a - 2 * r[o]);
                    o++, r[o] = a, n[o] = s, n[o + 1] = +nk;
                }
                for(a = 0, o = 0; a < i; a++){
                    for(; n[o + 1] < a;)o++;
                    t[a] = (a - r[o]) * (a - r[o]) + e[r[o]];
                }
            }
        });
        var _ze = ye((x0r, yze)=>{
            "use strict";
            var BFt = aze(), NFt = XS(), UFt = dze(), VFt = NX(), HFt = mze(), VX = document.createElement("canvas"), hp = VX.getContext("2d");
            yze.exports = GFt;
            function GFt(e, t) {
                if (!VFt(e)) throw Error("Argument should be valid svg path string");
                t || (t = {});
                var r, n;
                t.shape ? (r = t.shape[0], n = t.shape[1]) : (r = VX.width = t.w || t.width || 200, n = VX.height = t.h || t.height || 200);
                var i = Math.min(r, n), a = t.stroke || 0, o = t.viewbox || t.viewBox || BFt(e), s = [
                    r / (o[2] - o[0]),
                    n / (o[3] - o[1])
                ], l = Math.min(s[0] || 0, s[1] || 0) / 2;
                if (hp.fillStyle = "black", hp.fillRect(0, 0, r, n), hp.fillStyle = "white", a && (typeof a != "number" && (a = 1), a > 0 ? hp.strokeStyle = "white" : hp.strokeStyle = "black", hp.lineWidth = Math.abs(a)), hp.translate(r * .5, n * .5), hp.scale(l, l), jFt()) {
                    var u = new Path2D(e);
                    hp.fill(u), a && hp.stroke(u);
                } else {
                    var c = NFt(e);
                    UFt(hp, c), hp.fill(), a && hp.stroke();
                }
                hp.setTransform(1, 0, 0, 1, 0, 0);
                var f = HFt(hp, {
                    cutoff: t.cutoff != null ? t.cutoff : .5,
                    radius: t.radius != null ? t.radius : i * .5
                });
                return f;
            }
            var Vz;
            function jFt() {
                if (Vz != null) return Vz;
                var e = document.createElement("canvas").getContext("2d");
                if (e.canvas.width = e.canvas.height = 1, !window.Path2D) return Vz = !1;
                var t = new Path2D("M0,0h1v1h-1v-1Z");
                e.fillStyle = "black", e.fill(t);
                var r = e.getImageData(0, 0, 1, 1);
                return Vz = r && r.data && r.data[3] === 255;
            }
        });
        var Y2 = ye((b0r, Lze)=>{
            "use strict";
            var Gz = uo(), WFt = _ze(), Hz = $_(), ZFt = ba(), rA = Mr(), Qf = rA.isArrayOrTypedArray, eA = ao(), xze = af(), bze = $y().formatColor, tA = lu(), XFt = S3(), GX = Fz(), ak = sx(), YFt = U1().DESELECTDIM, wze = {
                start: 1,
                left: 1,
                end: -1,
                right: -1,
                middle: 0,
                center: 0,
                bottom: 1,
                top: -1
            }, KFt = rp().appendArrayPointValue;
            function JFt(e, t) {
                var r, n = {
                    marker: void 0,
                    markerSel: void 0,
                    markerUnsel: void 0,
                    line: void 0,
                    fill: void 0,
                    errorX: void 0,
                    errorY: void 0,
                    text: void 0,
                    textSel: void 0,
                    textUnsel: void 0
                }, i = e._context.plotGlPixelRatio;
                if (t.visible !== !0) return n;
                if (tA.hasText(t) && (n.text = Cze(e, t), n.textSel = Aze(e, t, t.selected), n.textUnsel = Aze(e, t, t.unselected)), tA.hasMarkers(t) && (n.marker = WX(e, t), n.markerSel = jX(e, t, t.selected), n.markerUnsel = jX(e, t, t.unselected), !t.unselected && Qf(t.marker.opacity))) {
                    var a = t.marker.opacity;
                    for(n.markerUnsel.opacity = new Array(a.length), r = 0; r < a.length; r++)n.markerUnsel.opacity[r] = YFt * a[r];
                }
                if (tA.hasLines(t)) {
                    n.line = {
                        overlay: !0,
                        thickness: t.line.width * i,
                        color: t.line.color,
                        opacity: t.opacity
                    };
                    var o = (ak.DASHES[t.line.dash] || [
                        1
                    ]).slice();
                    for(r = 0; r < o.length; ++r)o[r] *= t.line.width * i;
                    n.line.dashes = o;
                }
                return t.error_x && t.error_x.visible && (n.errorX = Sze(t, t.error_x, i)), t.error_y && t.error_y.visible && (n.errorY = Sze(t, t.error_y, i)), t.fill && t.fill !== "none" && (n.fill = {
                    closed: !0,
                    fill: t.fillcolor,
                    thickness: 0
                }), n;
            }
            function Cze(e, t) {
                var r = e._fullLayout, n = t._length, i = t.textfont, a = t.textposition, o = Qf(a) ? a : [
                    a
                ], s = i.color, l = i.size, u = i.family, c = i.weight, f = i.style, h = i.variant, d = {}, v, x = e._context.plotGlPixelRatio, b = t.texttemplate;
                if (b) {
                    d.text = [];
                    var p = r._d3locale, E = Array.isArray(b), k = E ? Math.min(b.length, n) : n, A = E ? function(T) {
                        return b[T];
                    } : function() {
                        return b;
                    };
                    for(v = 0; v < k; v++){
                        var L = {
                            i: v
                        }, _ = t._module.formatLabels(L, t, r), C = {};
                        KFt(C, t, v);
                        var M = t._meta || {};
                        d.text.push(rA.texttemplateString(A(v), _, p, C, L, M));
                    }
                } else Qf(t.text) && t.text.length < n ? d.text = t.text.slice() : d.text = t.text;
                if (Qf(d.text)) for(v = d.text.length; v < n; v++)d.text[v] = "";
                for(d.opacity = t.opacity, d.font = {}, d.align = [], d.baseline = [], v = 0; v < o.length; v++){
                    var g = o[v].split(/\s+/);
                    switch(g[1]){
                        case "left":
                            d.align.push("right");
                            break;
                        case "right":
                            d.align.push("left");
                            break;
                        default:
                            d.align.push(g[1]);
                    }
                    switch(g[0]){
                        case "top":
                            d.baseline.push("bottom");
                            break;
                        case "bottom":
                            d.baseline.push("top");
                            break;
                        default:
                            d.baseline.push(g[0]);
                    }
                }
                if (Qf(s)) for(d.color = new Array(n), v = 0; v < n; v++)d.color[v] = s[v];
                else d.color = s;
                if (Qf(l) || Array.isArray(u) || Qf(c) || Array.isArray(f) || Array.isArray(h)) for(d.font = new Array(n), v = 0; v < n; v++){
                    var P = d.font[v] = {};
                    P.size = (rA.isTypedArray(l) ? l[v] : Qf(l) ? Gz(l[v]) ? l[v] : 0 : l) * x, P.family = Array.isArray(u) ? u[v] : u, P.weight = Tze(Qf(c) ? c[v] : c), P.style = Array.isArray(f) ? f[v] : f, P.variant = Array.isArray(h) ? h[v] : h;
                }
                else d.font = {
                    size: l * x,
                    family: u,
                    weight: Tze(c),
                    style: f,
                    variant: h
                };
                return d;
            }
            function Tze(e) {
                return e <= 1e3 ? e > 500 ? "bold" : "normal" : e;
            }
            function WX(e, t) {
                var r = t._length, n = t.marker, i = {}, a, o = Qf(n.symbol), s = Qf(n.angle), l = Qf(n.color), u = Qf(n.line.color), c = Qf(n.opacity), f = Qf(n.size), h = Qf(n.line.width), d;
                if (o || (d = GX.isOpenSymbol(n.symbol)), o || l || u || c || s) {
                    i.symbols = new Array(r), i.angles = new Array(r), i.colors = new Array(r), i.borderColors = new Array(r);
                    var v = n.symbol, x = n.angle, b = bze(n, n.opacity, r), p = bze(n.line, n.opacity, r);
                    if (!Qf(p[0])) {
                        var E = p;
                        for(p = Array(r), a = 0; a < r; a++)p[a] = E;
                    }
                    if (!Qf(b[0])) {
                        var k = b;
                        for(b = Array(r), a = 0; a < r; a++)b[a] = k;
                    }
                    if (!Qf(v)) {
                        var A = v;
                        for(v = Array(r), a = 0; a < r; a++)v[a] = A;
                    }
                    if (!Qf(x)) {
                        var L = x;
                        for(x = Array(r), a = 0; a < r; a++)x[a] = L;
                    }
                    for(i.symbols = v, i.angles = x, i.colors = b, i.borderColors = p, a = 0; a < r; a++)o && (d = GX.isOpenSymbol(n.symbol[a])), d && (p[a] = b[a].slice(), b[a] = b[a].slice(), b[a][3] = 0);
                    for(i.opacity = t.opacity, i.markers = new Array(r), a = 0; a < r; a++)i.markers[a] = kze({
                        mx: i.symbols[a],
                        ma: i.angles[a]
                    }, t);
                } else d ? (i.color = Hz(n.color, "uint8"), i.color[3] = 0, i.borderColor = Hz(n.color, "uint8")) : (i.color = Hz(n.color, "uint8"), i.borderColor = Hz(n.line.color, "uint8")), i.opacity = t.opacity * n.opacity, i.marker = kze({
                    mx: n.symbol,
                    ma: n.angle
                }, t);
                var _ = 1, C = XFt(t, _), M;
                if (f || h) {
                    var g = i.sizes = new Array(r), P = i.borderSizes = new Array(r), T = 0, F;
                    if (f) {
                        for(a = 0; a < r; a++)g[a] = C(n.size[a]), T += g[a];
                        F = T / r;
                    } else for(M = C(n.size), a = 0; a < r; a++)g[a] = M;
                    if (h) for(a = 0; a < r; a++)P[a] = n.line.width[a];
                    else for(M = n.line.width, a = 0; a < r; a++)P[a] = M;
                    i.sizeAvg = F;
                } else i.size = C(n && n.size || 10), i.borderSizes = C(n.line.width);
                return i;
            }
            function jX(e, t, r) {
                var n = t.marker, i = {};
                return r && (r.marker && r.marker.symbol ? i = WX(e, rA.extendFlat({}, n, r.marker)) : r.marker && (r.marker.size && (i.size = r.marker.size), r.marker.color && (i.colors = r.marker.color), r.marker.opacity !== void 0 && (i.opacity = r.marker.opacity))), i;
            }
            function Aze(e, t, r) {
                var n = {};
                if (!r) return n;
                if (r.textfont) {
                    var i = {
                        opacity: 1,
                        text: t.text,
                        texttemplate: t.texttemplate,
                        textposition: t.textposition,
                        textfont: rA.extendFlat({}, t.textfont)
                    };
                    r.textfont && rA.extendFlat(i.textfont, r.textfont), n = Cze(e, i);
                }
                return n;
            }
            function Sze(e, t, r) {
                var n = {
                    capSize: t.width * 2 * r,
                    lineWidth: t.thickness * r,
                    color: t.color
                };
                return t.copy_ystyle && (n = e.error_y), n;
            }
            var Mze = ak.SYMBOL_SDF_SIZE, X2 = ak.SYMBOL_SIZE, Eze = ak.SYMBOL_STROKE, HX = {}, $Ft = eA.symbolFuncs[0](X2 * .05);
            function kze(e, t) {
                var r = e.mx;
                if (r === "circle") return null;
                var n, i, a = eA.symbolNumber(r), o = eA.symbolFuncs[a % 100], s = !!eA.symbolNoDot[a % 100], l = !!eA.symbolNoFill[a % 100], u = GX.isDotSymbol(r);
                if (e.ma && (r += "_" + e.ma), HX[r]) return HX[r];
                var c = eA.getMarkerAngle(e, t);
                return u && !s ? n = o(X2 * 1.1, c) + $Ft : n = o(X2, c), i = WFt(n, {
                    w: Mze,
                    h: Mze,
                    viewBox: [
                        -X2,
                        -X2,
                        X2,
                        X2
                    ],
                    stroke: l ? Eze : -Eze
                }), HX[r] = i, i || null;
            }
            function QFt(e, t, r) {
                var n = r.length, i = n / 2, a, o;
                if (tA.hasLines(t) && i) {
                    if (t.line.shape === "hv") {
                        for(a = [], o = 0; o < i - 1; o++)isNaN(r[o * 2]) || isNaN(r[o * 2 + 1]) ? a.push(NaN, NaN, NaN, NaN) : (a.push(r[o * 2], r[o * 2 + 1]), !isNaN(r[o * 2 + 2]) && !isNaN(r[o * 2 + 3]) ? a.push(r[o * 2 + 2], r[o * 2 + 1]) : a.push(NaN, NaN));
                        a.push(r[n - 2], r[n - 1]);
                    } else if (t.line.shape === "hvh") {
                        for(a = [], o = 0; o < i - 1; o++)if (isNaN(r[o * 2]) || isNaN(r[o * 2 + 1]) || isNaN(r[o * 2 + 2]) || isNaN(r[o * 2 + 3])) !isNaN(r[o * 2]) && !isNaN(r[o * 2 + 1]) ? a.push(r[o * 2], r[o * 2 + 1]) : a.push(NaN, NaN), a.push(NaN, NaN);
                        else {
                            var s = (r[o * 2] + r[o * 2 + 2]) / 2;
                            a.push(r[o * 2], r[o * 2 + 1], s, r[o * 2 + 1], s, r[o * 2 + 3]);
                        }
                        a.push(r[n - 2], r[n - 1]);
                    } else if (t.line.shape === "vhv") {
                        for(a = [], o = 0; o < i - 1; o++)if (isNaN(r[o * 2]) || isNaN(r[o * 2 + 1]) || isNaN(r[o * 2 + 2]) || isNaN(r[o * 2 + 3])) !isNaN(r[o * 2]) && !isNaN(r[o * 2 + 1]) ? a.push(r[o * 2], r[o * 2 + 1]) : a.push(NaN, NaN), a.push(NaN, NaN);
                        else {
                            var l = (r[o * 2 + 1] + r[o * 2 + 3]) / 2;
                            a.push(r[o * 2], r[o * 2 + 1], r[o * 2], l, r[o * 2 + 2], l);
                        }
                        a.push(r[n - 2], r[n - 1]);
                    } else if (t.line.shape === "vh") {
                        for(a = [], o = 0; o < i - 1; o++)isNaN(r[o * 2]) || isNaN(r[o * 2 + 1]) ? a.push(NaN, NaN, NaN, NaN) : (a.push(r[o * 2], r[o * 2 + 1]), !isNaN(r[o * 2 + 2]) && !isNaN(r[o * 2 + 3]) ? a.push(r[o * 2], r[o * 2 + 3]) : a.push(NaN, NaN));
                        a.push(r[n - 2], r[n - 1]);
                    } else a = r;
                }
                var u = !1;
                for(o = 0; o < a.length; o++)if (isNaN(a[o])) {
                    u = !0;
                    break;
                }
                var c = u || a.length > ak.TOO_MANY_POINTS || tA.hasMarkers(t) ? "rect" : "round";
                if (u && t.connectgaps) {
                    var f = a[0], h = a[1];
                    for(o = 0; o < a.length; o += 2)isNaN(a[o]) || isNaN(a[o + 1]) ? (a[o] = f, a[o + 1] = h) : (f = a[o], h = a[o + 1]);
                }
                return {
                    join: c,
                    positions: a
                };
            }
            function e7t(e, t, r, n, i) {
                var a = ZFt.getComponentMethod("errorbars", "makeComputeError"), o = xze.getFromId(e, t.xaxis, "x"), s = xze.getFromId(e, t.yaxis, "y"), l = r.length / 2, u = {};
                function c(f, h) {
                    var d = h._id.charAt(0), v = t["error_" + d];
                    if (v && v.visible && (h.type === "linear" || h.type === "log")) {
                        for(var x = a(v), b = {
                            x: 0,
                            y: 1
                        }[d], p = {
                            x: [
                                0,
                                1,
                                2,
                                3
                            ],
                            y: [
                                2,
                                3,
                                0,
                                1
                            ]
                        }[d], E = new Float64Array(4 * l), k = 1 / 0, A = -1 / 0, L = 0, _ = 0; L < l; L++, _ += 4){
                            var C = f[L];
                            if (Gz(C)) {
                                var M = r[L * 2 + b], g = x(C, L), P = g[0], T = g[1];
                                if (Gz(P) && Gz(T)) {
                                    var F = C - P, q = C + T;
                                    E[_ + p[0]] = M - h.c2l(F), E[_ + p[1]] = h.c2l(q) - M, E[_ + p[2]] = 0, E[_ + p[3]] = 0, k = Math.min(k, C - P), A = Math.max(A, C + T);
                                }
                            }
                        }
                        u[d] = {
                            positions: r,
                            errors: E,
                            _bnds: [
                                k,
                                A
                            ]
                        };
                    }
                }
                return c(n, o), c(i, s), u;
            }
            function t7t(e, t, r, n) {
                var i = t._length, a = {}, o;
                if (tA.hasMarkers(t)) {
                    var s = r.font, l = r.align, u = r.baseline;
                    for(a.offset = new Array(i), o = 0; o < i; o++){
                        var c = n.sizes ? n.sizes[o] : n.size, f = Qf(s) ? s[o].size : s.size, h = Qf(l) ? l.length > 1 ? l[o] : l[0] : l, d = Qf(u) ? u.length > 1 ? u[o] : u[0] : u, v = wze[h], x = wze[d], b = c ? c / .8 + 1 : 0, p = -x * b - x * .5;
                        a.offset[o] = [
                            v * b / f,
                            p / f
                        ];
                    }
                }
                return a;
            }
            Lze.exports = {
                style: JFt,
                markerStyle: WX,
                markerSelection: jX,
                linePositions: QFt,
                errorBarPositions: e7t,
                textPosition: t7t
            };
        });
        var ZX = ye((w0r, Pze)=>{
            "use strict";
            var jz = Mr();
            Pze.exports = function(t, r) {
                var n = r._scene, i = {
                    count: 0,
                    dirty: !0,
                    lineOptions: [],
                    fillOptions: [],
                    markerOptions: [],
                    markerSelectedOptions: [],
                    markerUnselectedOptions: [],
                    errorXOptions: [],
                    errorYOptions: [],
                    textOptions: [],
                    textSelectedOptions: [],
                    textUnselectedOptions: [],
                    selectBatch: [],
                    unselectBatch: []
                }, a = {
                    fill2d: !1,
                    scatter2d: !1,
                    error2d: !1,
                    line2d: !1,
                    glText: !1,
                    select2d: !1
                };
                return r._scene || (n = r._scene = {}, n.init = function() {
                    jz.extendFlat(n, a, i);
                }, n.init(), n.update = function(s) {
                    var l = jz.repeat(s, n.count);
                    if (n.fill2d && n.fill2d.update(l), n.scatter2d && n.scatter2d.update(l), n.line2d && n.line2d.update(l), n.error2d && n.error2d.update(l.concat(l)), n.select2d && n.select2d.update(l), n.glText) for(var u = 0; u < n.count; u++)n.glText[u].update(s);
                }, n.draw = function() {
                    for(var s = n.count, l = n.fill2d, u = n.error2d, c = n.line2d, f = n.scatter2d, h = n.glText, d = n.select2d, v = n.selectBatch, x = n.unselectBatch, b = 0; b < s; b++){
                        if (l && n.fillOrder[b] && l.draw(n.fillOrder[b]), c && n.lineOptions[b] && c.draw(b), u && (n.errorXOptions[b] && u.draw(b), n.errorYOptions[b] && u.draw(b + s)), f && n.markerOptions[b]) {
                            if (x[b].length) {
                                var p = jz.repeat([], n.count);
                                p[b] = x[b], f.draw(p);
                            } else v[b].length || f.draw(b);
                        }
                        h[b] && n.textOptions[b] && h[b].render();
                    }
                    d && d.draw(v), n.dirty = !1;
                }, n.destroy = function() {
                    n.fill2d && n.fill2d.destroy && n.fill2d.destroy(), n.scatter2d && n.scatter2d.destroy && n.scatter2d.destroy(), n.error2d && n.error2d.destroy && n.error2d.destroy(), n.line2d && n.line2d.destroy && n.line2d.destroy(), n.select2d && n.select2d.destroy && n.select2d.destroy(), n.glText && n.glText.forEach(function(s) {
                        s.destroy && s.destroy();
                    }), n.lineOptions = null, n.fillOptions = null, n.markerOptions = null, n.markerSelectedOptions = null, n.markerUnselectedOptions = null, n.errorXOptions = null, n.errorYOptions = null, n.textOptions = null, n.textSelectedOptions = null, n.textUnselectedOptions = null, n.selectBatch = null, n.unselectBatch = null, r._scene = null;
                }), n.dirty || jz.extendFlat(n, i), n;
            };
        });
        var qze = ye((T0r, Fze)=>{
            "use strict";
            var r7t = Oz(), iA = Mr(), Ize = af(), i7t = wg().findExtremes, Rze = Rg(), XX = q0(), n7t = XX.calcMarkerSize, a7t = XX.calcAxisExpansion, o7t = XX.setFirstScatter, s7t = z0(), nA = Y2(), l7t = ZX(), Dze = es().BADNUM, u7t = sx().TOO_MANY_POINTS;
            Fze.exports = function(t, r) {
                var n = t._fullLayout, i = r._xA = Ize.getFromId(t, r.xaxis, "x"), a = r._yA = Ize.getFromId(t, r.yaxis, "y"), o = n._plots[r.xaxis + r.yaxis], s = r._length, l = s >= u7t, u = s * 2, c = {}, f, h = i.makeCalcdata(r, "x"), d = a.makeCalcdata(r, "y"), v = Rze(r, i, "x", h), x = Rze(r, a, "y", d), b = v.vals, p = x.vals;
                r._x = b, r._y = p, r.xperiodalignment && (r._origX = h, r._xStarts = v.starts, r._xEnds = v.ends), r.yperiodalignment && (r._origY = d, r._yStarts = x.starts, r._yEnds = x.ends);
                var E = new Array(u), k = new Array(s);
                for(f = 0; f < s; f++)E[f * 2] = b[f] === Dze ? NaN : b[f], E[f * 2 + 1] = p[f] === Dze ? NaN : p[f], k[f] = f;
                if (i.type === "log") for(f = 0; f < u; f += 2)E[f] = i.c2l(E[f]);
                if (a.type === "log") for(f = 1; f < u; f += 2)E[f] = a.c2l(E[f]);
                l && i.type !== "log" && a.type !== "log" ? c.tree = r7t(E) : c.ids = k, s7t(t, r);
                var A = c7t(t, o, r, E, b, p), L = l7t(t, o);
                o7t(n, r);
                var _;
                return l ? A.marker && (_ = A.marker.sizeAvg || Math.max(A.marker.size, 3)) : _ = n7t(r, s), a7t(t, r, i, a, b, p, _), A.errorX && zze(r, i, A.errorX), A.errorY && zze(r, a, A.errorY), A.fill && !L.fill2d && (L.fill2d = !0), A.marker && !L.scatter2d && (L.scatter2d = !0), A.line && !L.line2d && (L.line2d = !0), (A.errorX || A.errorY) && !L.error2d && (L.error2d = !0), A.text && !L.glText && (L.glText = !0), A.marker && (A.marker.snap = s), L.lineOptions.push(A.line), L.errorXOptions.push(A.errorX), L.errorYOptions.push(A.errorY), L.fillOptions.push(A.fill), L.markerOptions.push(A.marker), L.markerSelectedOptions.push(A.markerSel), L.markerUnselectedOptions.push(A.markerUnsel), L.textOptions.push(A.text), L.textSelectedOptions.push(A.textSel), L.textUnselectedOptions.push(A.textUnsel), L.selectBatch.push([]), L.unselectBatch.push([]), c._scene = L, c.index = L.count, c.x = b, c.y = p, c.positions = E, L.count++, [
                    {
                        x: !1,
                        y: !1,
                        t: c,
                        trace: r
                    }
                ];
            };
            function zze(e, t, r) {
                var n = e._extremes[t._id], i = i7t(t, r._bnds, {
                    padded: !0
                });
                n.min = n.min.concat(i.min), n.max = n.max.concat(i.max);
            }
            function c7t(e, t, r, n, i, a) {
                var o = nA.style(e, r);
                if (o.marker && (o.marker.positions = n), o.line && n.length > 1 && iA.extendFlat(o.line, nA.linePositions(e, r, n)), o.errorX || o.errorY) {
                    var s = nA.errorBarPositions(e, r, n, i, a);
                    o.errorX && iA.extendFlat(o.errorX, s.x), o.errorY && iA.extendFlat(o.errorY, s.y);
                }
                return o.text && (iA.extendFlat(o.text, {
                    positions: n
                }, nA.textPosition(e, r, o.text, o.marker)), iA.extendFlat(o.textSel, {
                    positions: n
                }, nA.textPosition(e, r, o.text, o.markerSel)), iA.extendFlat(o.textUnsel, {
                    positions: n
                }, nA.textPosition(e, r, o.text, o.markerUnsel))), o;
            }
        });
        var YX = ye((A0r, Bze)=>{
            "use strict";
            var Oze = Mr(), f7t = va(), h7t = U1().DESELECTDIM;
            function d7t(e) {
                var t = e[0], r = t.trace, n = t.t, i = n._scene, a = n.index, o = i.selectBatch[a], s = i.unselectBatch[a], l = i.textOptions[a], u = i.textSelectedOptions[a] || {}, c = i.textUnselectedOptions[a] || {}, f = Oze.extendFlat({}, l), h, d;
                if (o.length || s.length) {
                    var v = u.color, x = c.color, b = l.color, p = Oze.isArrayOrTypedArray(b);
                    for(f.color = new Array(r._length), h = 0; h < o.length; h++)d = o[h], f.color[d] = v || (p ? b[d] : b);
                    for(h = 0; h < s.length; h++){
                        d = s[h];
                        var E = p ? b[d] : b;
                        f.color[d] = x || (v ? E : f7t.addOpacity(E, h7t));
                    }
                }
                i.glText[a].update(f);
            }
            Bze.exports = {
                styleTextSelection: d7t
            };
        });
        var KX = ye((S0r, Uze)=>{
            "use strict";
            var Nze = lu(), v7t = YX().styleTextSelection;
            Uze.exports = function(t, r) {
                var n = t.cd, i = t.xaxis, a = t.yaxis, o = [], s = n[0].trace, l = n[0].t, u = s._length, c = l.x, f = l.y, h = l._scene, d = l.index;
                if (!h) return o;
                var v = Nze.hasText(s), x = Nze.hasMarkers(s), b = !x && !v;
                if (s.visible !== !0 || b) return o;
                var p = [], E = [];
                if (r !== !1 && !r.degenerate) for(var k = 0; k < u; k++)r.contains([
                    l.xpx[k],
                    l.ypx[k]
                ], !1, k, t) ? (p.push(k), o.push({
                    pointNumber: k,
                    x: i.c2d(c[k]),
                    y: a.c2d(f[k])
                })) : E.push(k);
                if (x) {
                    var A = h.scatter2d;
                    if (!p.length && !E.length) {
                        var L = new Array(h.count);
                        L[d] = h.markerOptions[d], A.update.apply(A, L);
                    } else if (!h.selectBatch[d].length && !h.unselectBatch[d].length) {
                        var _ = new Array(h.count);
                        _[d] = h.markerUnselectedOptions[d], A.update.apply(A, _);
                    }
                }
                return h.selectBatch[d] = p, h.unselectBatch[d] = E, v && v7t(n), o;
            };
        });
        var Hze = ye((M0r, Vze)=>{
            "use strict";
            var p7t = zz();
            Vze.exports = {
                moduleType: "trace",
                name: "scattergl",
                basePlotModule: Jf(),
                categories: [
                    "gl",
                    "regl",
                    "cartesian",
                    "symbols",
                    "errorBarsOK",
                    "showLegend",
                    "scatter-like"
                ],
                attributes: tk(),
                supplyDefaults: ADe(),
                crossTraceDefaults: $N(),
                colorbar: Kd(),
                formatLabels: MDe(),
                calc: qze(),
                hoverPoints: p7t.hoverPoints,
                selectPoints: KX(),
                meta: {}
            };
        });
        var jze = ye((E0r, Zz)=>{
            "use strict";
            var Wz = VE();
            Zz.exports = Gze;
            Zz.exports.to = Gze;
            Zz.exports.from = g7t;
            function Gze(e, t) {
                t == null && (t = !0);
                var r = e[0], n = e[1], i = e[2], a = e[3];
                a == null && (a = t ? 1 : 255), t && (r *= 255, n *= 255, i *= 255, a *= 255), r = Wz(r, 0, 255) & 255, n = Wz(n, 0, 255) & 255, i = Wz(i, 0, 255) & 255, a = Wz(a, 0, 255) & 255;
                var o = r * 16777216 + (n << 16) + (i << 8) + a;
                return o;
            }
            function g7t(e, t) {
                e = +e;
                var r = e >>> 24, n = (e & 16711680) >>> 16, i = (e & 65280) >>> 8, a = e & 255;
                return t === !1 ? [
                    r,
                    n,
                    i,
                    a
                ] : [
                    r / 255,
                    n / 255,
                    i / 255,
                    a / 255
                ];
            }
        });
        var bh = ye((k0r, Zze)=>{
            "use strict";
            var Wze = Object.getOwnPropertySymbols, m7t = Object.prototype.hasOwnProperty, y7t = Object.prototype.propertyIsEnumerable;
            function _7t(e) {
                if (e == null) throw new TypeError("Object.assign cannot be called with null or undefined");
                return Object(e);
            }
            function x7t() {
                try {
                    if (!Object.assign) return !1;
                    var e = new String("abc");
                    if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
                    for(var t = {}, r = 0; r < 10; r++)t["_" + String.fromCharCode(r)] = r;
                    var n = Object.getOwnPropertyNames(t).map(function(a) {
                        return t[a];
                    });
                    if (n.join("") !== "0123456789") return !1;
                    var i = {};
                    return "abcdefghijklmnopqrst".split("").forEach(function(a) {
                        i[a] = a;
                    }), Object.keys(Object.assign({}, i)).join("") === "abcdefghijklmnopqrst";
                } catch (a) {
                    return !1;
                }
            }
            Zze.exports = x7t() ? Object.assign : function(e, t) {
                for(var r, n = _7t(e), i, a = 1; a < arguments.length; a++){
                    r = Object(arguments[a]);
                    for(var o in r)m7t.call(r, o) && (n[o] = r[o]);
                    if (Wze) {
                        i = Wze(r);
                        for(var s = 0; s < i.length; s++)y7t.call(r, i[s]) && (n[i[s]] = r[i[s]]);
                    }
                }
                return n;
            };
        });
        var Yze = ye((C0r, Xze)=>{
            Xze.exports = function(e) {
                typeof e == "string" && (e = [
                    e
                ]);
                for(var t = [].slice.call(arguments, 1), r = [], n = 0; n < e.length - 1; n++)r.push(e[n], t[n] || "");
                return r.push(e[n]), r.join("");
            };
        });
        var JX = ye((L0r, Kze)=>{
            "use strict";
            Kze.exports = function(t, r, n) {
                Array.isArray(n) || (n = [].slice.call(arguments, 2));
                for(var i = 0, a = n.length; i < a; i++){
                    var o = n[i];
                    for(var s in o)if (!(r[s] !== void 0 && !Array.isArray(r[s]) && t[s] === r[s]) && s in r) {
                        var l;
                        if (o[s] === !0) l = r[s];
                        else {
                            if (o[s] === !1) continue;
                            if (typeof o[s] == "function" && (l = o[s](r[s], t, r), l === void 0)) continue;
                        }
                        t[s] = l;
                    }
                }
                return t;
            };
        });
        var $ze = ye((P0r, Jze)=>{
            "use strict";
            Jze.exports = typeof navigator != "undefined" && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion));
        });
        var Xz = ye((I0r, aA)=>{
            "use strict";
            aA.exports = ok;
            aA.exports.float32 = aA.exports.float = ok;
            aA.exports.fract32 = aA.exports.fract = b7t;
            var Qze = new Float32Array(1);
            function b7t(e, t) {
                if (e.length) {
                    if (e instanceof Float32Array) return new Float32Array(e.length);
                    t instanceof Float32Array || (t = ok(e));
                    for(var r = 0, n = t.length; r < n; r++)t[r] = e[r] - t[r];
                    return t;
                }
                return ok(e - ok(e));
            }
            function ok(e) {
                return e.length ? e instanceof Float32Array ? e : new Float32Array(e) : (Qze[0] = e, Qze[0]);
            }
        });
        var QX = ye((R0r, rFe)=>{
            "use strict";
            function w7t(e, t) {
                var r = e == null ? null : typeof Symbol != "undefined" && e[Symbol.iterator] || e["@@iterator"];
                if (r != null) {
                    var n, i, a, o, s = [], l = !0, u = !1;
                    try {
                        if (a = (r = r.call(e)).next, t === 0) {
                            if (Object(r) !== r) return;
                            l = !1;
                        } else for(; !(l = (n = a.call(r)).done) && (s.push(n.value), s.length !== t); l = !0);
                    } catch (c) {
                        u = !0, i = c;
                    } finally{
                        try {
                            if (!l && r.return != null && (o = r.return(), Object(o) !== o)) return;
                        } finally{
                            if (u) throw i;
                        }
                    }
                    return s;
                }
            }
            function T7t(e, t) {
                return M7t(e) || w7t(e, t) || tFe(e, t) || C7t();
            }
            function A7t(e) {
                return S7t(e) || E7t(e) || tFe(e) || k7t();
            }
            function S7t(e) {
                if (Array.isArray(e)) return $X(e);
            }
            function M7t(e) {
                if (Array.isArray(e)) return e;
            }
            function E7t(e) {
                if (typeof Symbol != "undefined" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
            }
            function tFe(e, t) {
                if (e) {
                    if (typeof e == "string") return $X(e, t);
                    var r = Object.prototype.toString.call(e).slice(8, -1);
                    if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
                    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $X(e, t);
                }
            }
            function $X(e, t) {
                (t == null || t > e.length) && (t = e.length);
                for(var r = 0, n = new Array(t); r < t; r++)n[r] = e[r];
                return n;
            }
            function k7t() {
                throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            function C7t() {
                throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
            }
            var L7t = $_(), P7t = j2(), I7t = jze(), R7t = Oz(), K2 = bh(), Yz = Yze(), D7t = Zm(), z7t = JX(), F7t = W2(), eFe = $ze(), Kz = Xz(), q7t = Q5(), O7t = rv;
            function rv(e, t) {
                var r = this;
                if (!(this instanceof rv)) return new rv(e, t);
                typeof e == "function" ? (t || (t = {}), t.regl = e) : (t = e, e = null), t && t.length && (t.positions = t), e = t.regl;
                var n = e._gl, i, a = [], o = {}, s = [], l = [
                    null
                ], u = [
                    null
                ], c = 255, f = 100;
                this.tooManyColors = eFe, i = e.texture({
                    data: new Uint8Array(c * 4),
                    width: c,
                    height: 1,
                    type: "uint8",
                    format: "rgba",
                    wrapS: "clamp",
                    wrapT: "clamp",
                    mag: "nearest",
                    min: "nearest"
                }), K2(this, {
                    regl: e,
                    gl: n,
                    groups: s,
                    markerCache: u,
                    markerTextures: l,
                    palette: a,
                    paletteIds: o,
                    paletteTexture: i,
                    maxColors: c,
                    maxSize: f,
                    canvas: n.canvas
                }), this.update(t);
                var h = {
                    uniforms: {
                        constPointSize: !!t.constPointSize,
                        opacity: e.prop("opacity"),
                        paletteSize: function(b, p) {
                            return [
                                r.tooManyColors ? 0 : c,
                                i.height
                            ];
                        },
                        pixelRatio: e.context("pixelRatio"),
                        scale: e.prop("scale"),
                        scaleFract: e.prop("scaleFract"),
                        translate: e.prop("translate"),
                        translateFract: e.prop("translateFract"),
                        markerTexture: e.prop("markerTexture"),
                        paletteTexture: i
                    },
                    attributes: {
                        x: function(b, p) {
                            return p.xAttr || {
                                buffer: p.positionBuffer,
                                stride: 8,
                                offset: 0
                            };
                        },
                        y: function(b, p) {
                            return p.yAttr || {
                                buffer: p.positionBuffer,
                                stride: 8,
                                offset: 4
                            };
                        },
                        xFract: function(b, p) {
                            return p.xAttr ? {
                                constant: [
                                    0,
                                    0
                                ]
                            } : {
                                buffer: p.positionFractBuffer,
                                stride: 8,
                                offset: 0
                            };
                        },
                        yFract: function(b, p) {
                            return p.yAttr ? {
                                constant: [
                                    0,
                                    0
                                ]
                            } : {
                                buffer: p.positionFractBuffer,
                                stride: 8,
                                offset: 4
                            };
                        },
                        size: function(b, p) {
                            return p.size.length ? {
                                buffer: p.sizeBuffer,
                                stride: 2,
                                offset: 0
                            } : {
                                constant: [
                                    Math.round(p.size * 255 / r.maxSize)
                                ]
                            };
                        },
                        borderSize: function(b, p) {
                            return p.borderSize.length ? {
                                buffer: p.sizeBuffer,
                                stride: 2,
                                offset: 1
                            } : {
                                constant: [
                                    Math.round(p.borderSize * 255 / r.maxSize)
                                ]
                            };
                        },
                        colorId: function(b, p) {
                            return p.color.length ? {
                                buffer: p.colorBuffer,
                                stride: r.tooManyColors ? 8 : 4,
                                offset: 0
                            } : {
                                constant: r.tooManyColors ? a.slice(p.color * 4, p.color * 4 + 4) : [
                                    p.color
                                ]
                            };
                        },
                        borderColorId: function(b, p) {
                            return p.borderColor.length ? {
                                buffer: p.colorBuffer,
                                stride: r.tooManyColors ? 8 : 4,
                                offset: r.tooManyColors ? 4 : 2
                            } : {
                                constant: r.tooManyColors ? a.slice(p.borderColor * 4, p.borderColor * 4 + 4) : [
                                    p.borderColor
                                ]
                            };
                        },
                        isActive: function(b, p) {
                            return p.activation === !0 ? {
                                constant: [
                                    1
                                ]
                            } : p.activation ? p.activation : {
                                constant: [
                                    0
                                ]
                            };
                        }
                    },
                    blend: {
                        enable: !0,
                        color: [
                            0,
                            0,
                            0,
                            1
                        ],
                        func: {
                            srcRGB: "src alpha",
                            dstRGB: "one minus src alpha",
                            srcAlpha: "one minus dst alpha",
                            dstAlpha: "one"
                        }
                    },
                    scissor: {
                        enable: !0,
                        box: e.prop("viewport")
                    },
                    viewport: e.prop("viewport"),
                    stencil: {
                        enable: !1
                    },
                    depth: {
                        enable: !1
                    },
                    elements: e.prop("elements"),
                    count: e.prop("count"),
                    offset: e.prop("offset"),
                    primitive: "points"
                }, d = K2({}, h);
                d.frag = Yz([
                    `precision highp float;
#define GLSLIFY 1

uniform float opacity;
uniform sampler2D markerTexture;

varying vec4 fragColor, fragBorderColor;
varying float fragWidth, fragBorderColorLevel, fragColorLevel;

float smoothStep(float x, float y) {
  return 1.0 / (1.0 + exp(50.0*(x - y)));
}

void main() {
  float dist = texture2D(markerTexture, gl_PointCoord).r, delta = fragWidth;

  // max-distance alpha
  if (dist < 0.003) discard;

  // null-border case
  if (fragBorderColorLevel == fragColorLevel || fragBorderColor.a == 0.) {
    float colorAmt = smoothstep(.5 - delta, .5 + delta, dist);
    gl_FragColor = vec4(fragColor.rgb, colorAmt * fragColor.a * opacity);
  }
  else {
    float borderColorAmt = smoothstep(fragBorderColorLevel - delta, fragBorderColorLevel + delta, dist);
    float colorAmt = smoothstep(fragColorLevel - delta, fragColorLevel + delta, dist);

    vec4 color = fragBorderColor;
    color.a *= borderColorAmt;
    color = mix(color, fragColor, colorAmt);
    color.a *= opacity;

    gl_FragColor = color;
  }

}
`
                ]), d.vert = Yz([
                    `precision highp float;
#define GLSLIFY 1

attribute float x, y, xFract, yFract;
attribute float size, borderSize;
attribute vec4 colorId, borderColorId;
attribute float isActive;

// \`invariant\` effectively turns off optimizations for the position.
// We need this because -fast-math on M1 Macs is re-ordering
// floating point operations in a way that causes floating point
// precision limits to put points in the wrong locations.
invariant gl_Position;

uniform bool constPointSize;
uniform float pixelRatio;
uniform vec2 scale, scaleFract, translate, translateFract, paletteSize;
uniform sampler2D paletteTexture;

const float maxSize = 100.;
const float borderLevel = .5;

varying vec4 fragColor, fragBorderColor;
varying float fragPointSize, fragBorderRadius, fragWidth, fragBorderColorLevel, fragColorLevel;

float pointSizeScale = (constPointSize) ? 2. : pixelRatio;

bool isDirect = (paletteSize.x < 1.);

vec4 getColor(vec4 id) {
  return isDirect ? id / 255. : texture2D(paletteTexture,
    vec2(
      (id.x + .5) / paletteSize.x,
      (id.y + .5) / paletteSize.y
    )
  );
}

void main() {
  // ignore inactive points
  if (isActive == 0.) return;

  vec2 position = vec2(x, y);
  vec2 positionFract = vec2(xFract, yFract);

  vec4 color = getColor(colorId);
  vec4 borderColor = getColor(borderColorId);

  float size = size * maxSize / 255.;
  float borderSize = borderSize * maxSize / 255.;

  gl_PointSize = 2. * size * pointSizeScale;
  fragPointSize = size * pixelRatio;

  vec2 pos = (position + translate) * scale
      + (positionFract + translateFract) * scale
      + (position + translate) * scaleFract
      + (positionFract + translateFract) * scaleFract;

  gl_Position = vec4(pos * 2. - 1., 0., 1.);

  fragColor = color;
  fragBorderColor = borderColor;
  fragWidth = 1. / gl_PointSize;

  fragBorderColorLevel = clamp(borderLevel - borderLevel * borderSize / size, 0., 1.);
  fragColorLevel = clamp(borderLevel + (1. - borderLevel) * borderSize / size, 0., 1.);
}
`
                ]), this.drawMarker = e(d);
                var v = K2({}, h);
                v.frag = Yz([
                    `precision highp float;
#define GLSLIFY 1

varying vec4 fragColor, fragBorderColor;
varying float fragBorderRadius, fragWidth;

uniform float opacity;

float smoothStep(float edge0, float edge1, float x) {
	float t;
	t = clamp((x - edge0) / (edge1 - edge0), 0.0, 1.0);
	return t * t * (3.0 - 2.0 * t);
}

void main() {
	float radius, alpha = 1.0, delta = fragWidth;

	radius = length(2.0 * gl_PointCoord.xy - 1.0);

	if (radius > 1.0 + delta) {
		discard;
	}

	alpha -= smoothstep(1.0 - delta, 1.0 + delta, radius);

	float borderRadius = fragBorderRadius;
	float ratio = smoothstep(borderRadius - delta, borderRadius + delta, radius);
	vec4 color = mix(fragColor, fragBorderColor, ratio);
	color.a *= alpha * opacity;
	gl_FragColor = color;
}
`
                ]), v.vert = Yz([
                    `precision highp float;
#define GLSLIFY 1

attribute float x, y, xFract, yFract;
attribute float size, borderSize;
attribute vec4 colorId, borderColorId;
attribute float isActive;

// \`invariant\` effectively turns off optimizations for the position.
// We need this because -fast-math on M1 Macs is re-ordering
// floating point operations in a way that causes floating point
// precision limits to put points in the wrong locations.
invariant gl_Position;

uniform bool constPointSize;
uniform float pixelRatio;
uniform vec2 paletteSize, scale, scaleFract, translate, translateFract;
uniform sampler2D paletteTexture;

const float maxSize = 100.;

varying vec4 fragColor, fragBorderColor;
varying float fragBorderRadius, fragWidth;

float pointSizeScale = (constPointSize) ? 2. : pixelRatio;

bool isDirect = (paletteSize.x < 1.);

vec4 getColor(vec4 id) {
  return isDirect ? id / 255. : texture2D(paletteTexture,
    vec2(
      (id.x + .5) / paletteSize.x,
      (id.y + .5) / paletteSize.y
    )
  );
}

void main() {
  // ignore inactive points
  if (isActive == 0.) return;

  vec2 position = vec2(x, y);
  vec2 positionFract = vec2(xFract, yFract);

  vec4 color = getColor(colorId);
  vec4 borderColor = getColor(borderColorId);

  float size = size * maxSize / 255.;
  float borderSize = borderSize * maxSize / 255.;

  gl_PointSize = (size + borderSize) * pointSizeScale;

  vec2 pos = (position + translate) * scale
      + (positionFract + translateFract) * scale
      + (position + translate) * scaleFract
      + (positionFract + translateFract) * scaleFract;

  gl_Position = vec4(pos * 2. - 1., 0., 1.);

  fragBorderRadius = 1. - 2. * borderSize / (size + borderSize);
  fragColor = color;
  fragBorderColor = borderColor.a == 0. || borderSize == 0. ? vec4(color.rgb, 0.) : borderColor;
  fragWidth = 1. / gl_PointSize;
}
`
                ]), eFe && (v.frag = v.frag.replace("smoothstep", "smoothStep"), d.frag = d.frag.replace("smoothstep", "smoothStep")), this.drawCircle = e(v);
            }
            rv.defaults = {
                color: "black",
                borderColor: "transparent",
                borderSize: 0,
                size: 12,
                opacity: 1,
                marker: void 0,
                viewport: null,
                range: null,
                pixelSize: null,
                count: 0,
                offset: 0,
                bounds: null,
                positions: [],
                snap: 1e4
            };
            rv.prototype.render = function() {
                return arguments.length && this.update.apply(this, arguments), this.draw(), this;
            };
            rv.prototype.draw = function() {
                for(var e = this, t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                var i = this.groups;
                if (r.length === 1 && Array.isArray(r[0]) && (r[0][0] === null || Array.isArray(r[0][0])) && (r = r[0]), this.regl._refresh(), r.length) for(var a = 0; a < r.length; a++)this.drawItem(a, r[a]);
                else i.forEach(function(o, s) {
                    e.drawItem(s);
                });
                return this;
            };
            rv.prototype.drawItem = function(e, t) {
                var r = this.groups, n = r[e];
                if (typeof t == "number" && (e = t, n = r[t], t = null), !!(n && n.count && n.opacity)) {
                    n.activation[0] && this.drawCircle(this.getMarkerDrawOptions(0, n, t));
                    for(var i = [], a = 1; a < n.activation.length; a++)!n.activation[a] || n.activation[a] !== !0 && !n.activation[a].data.length || i.push.apply(i, A7t(this.getMarkerDrawOptions(a, n, t)));
                    i.length && this.drawMarker(i);
                }
            };
            rv.prototype.getMarkerDrawOptions = function(e, t, r) {
                var n = t.range, i = t.tree, a = t.viewport, o = t.activation, s = t.selectionBuffer, l = t.count, u = this.regl;
                if (!i) return r ? [
                    K2({}, t, {
                        markerTexture: this.markerTextures[e],
                        activation: o[e],
                        count: r.length,
                        elements: r,
                        offset: 0
                    })
                ] : [
                    K2({}, t, {
                        markerTexture: this.markerTextures[e],
                        activation: o[e],
                        offset: 0
                    })
                ];
                var c = [], f = i.range(n, {
                    lod: !0,
                    px: [
                        (n[2] - n[0]) / a.width,
                        (n[3] - n[1]) / a.height
                    ]
                });
                if (r) {
                    for(var h = o[e], d = h.data, v = new Uint8Array(l), x = 0; x < r.length; x++){
                        var b = r[x];
                        v[b] = d ? d[b] : 1;
                    }
                    s.subdata(v);
                }
                for(var p = f.length; p--;){
                    var E = T7t(f[p], 2), k = E[0], A = E[1];
                    c.push(K2({}, t, {
                        markerTexture: this.markerTextures[e],
                        activation: r ? s : o[e],
                        offset: k,
                        count: A - k
                    }));
                }
                return c;
            };
            rv.prototype.update = function() {
                for(var e = this, t = arguments.length, r = new Array(t), n = 0; n < t; n++)r[n] = arguments[n];
                if (r.length) {
                    r.length === 1 && Array.isArray(r[0]) && (r = r[0]);
                    var i = this.groups, a = this.gl, o = this.regl, s = this.maxSize, l = this.maxColors, u = this.palette;
                    this.groups = i = r.map(function(c, f) {
                        var h = i[f];
                        if (c === void 0) return h;
                        c === null ? c = {
                            positions: null
                        } : typeof c == "function" ? c = {
                            ondraw: c
                        } : typeof c[0] == "number" && (c = {
                            positions: c
                        }), c = D7t(c, {
                            positions: "positions data points",
                            snap: "snap cluster lod tree",
                            size: "sizes size radius",
                            borderSize: "borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline",
                            color: "colors color fill fill-color fillColor",
                            borderColor: "borderColors borderColor stroke stroke-color strokeColor",
                            marker: "markers marker shape",
                            range: "range dataBox databox",
                            viewport: "viewport viewPort viewBox viewbox",
                            opacity: "opacity alpha transparency",
                            bounds: "bound bounds boundaries limits",
                            tooManyColors: "tooManyColors palette paletteMode optimizePalette enablePalette"
                        }), c.positions === null && (c.positions = []), c.tooManyColors != null && (e.tooManyColors = c.tooManyColors), h || (i[f] = h = {
                            id: f,
                            scale: null,
                            translate: null,
                            scaleFract: null,
                            translateFract: null,
                            activation: [],
                            selectionBuffer: o.buffer({
                                data: new Uint8Array(0),
                                usage: "stream",
                                type: "uint8"
                            }),
                            sizeBuffer: o.buffer({
                                data: new Uint8Array(0),
                                usage: "dynamic",
                                type: "uint8"
                            }),
                            colorBuffer: o.buffer({
                                data: new Uint8Array(0),
                                usage: "dynamic",
                                type: "uint8"
                            }),
                            positionBuffer: o.buffer({
                                data: new Uint8Array(0),
                                usage: "dynamic",
                                type: "float"
                            }),
                            positionFractBuffer: o.buffer({
                                data: new Uint8Array(0),
                                usage: "dynamic",
                                type: "float"
                            })
                        }, c = K2({}, rv.defaults, c)), c.positions && !("marker" in c) && (c.marker = h.marker, delete h.marker), c.marker && !("positions" in c) && (c.positions = h.positions, delete h.positions);
                        var d = 0, v = 0;
                        if (z7t(h, c, [
                            {
                                snap: !0,
                                size: function(G, N) {
                                    return G == null && (G = rv.defaults.size), d += G && G.length ? 1 : 0, G;
                                },
                                borderSize: function(G, N) {
                                    return G == null && (G = rv.defaults.borderSize), d += G && G.length ? 1 : 0, G;
                                },
                                opacity: parseFloat,
                                color: function(G, N) {
                                    return G == null && (G = rv.defaults.color), G = e.updateColor(G), v++, G;
                                },
                                borderColor: function(G, N) {
                                    return G == null && (G = rv.defaults.borderColor), G = e.updateColor(G), v++, G;
                                },
                                bounds: function(G, N, W) {
                                    return "range" in W || (W.range = null), G;
                                },
                                positions: function(G, N, W) {
                                    var re = N.snap, ae = N.positionBuffer, _e = N.positionFractBuffer, Me = N.selectionBuffer;
                                    if (G.x || G.y) return G.x.length ? N.xAttr = {
                                        buffer: o.buffer(G.x),
                                        offset: 0,
                                        stride: 4,
                                        count: G.x.length
                                    } : N.xAttr = {
                                        buffer: G.x.buffer,
                                        offset: G.x.offset * 4 || 0,
                                        stride: (G.x.stride || 1) * 4,
                                        count: G.x.count
                                    }, G.y.length ? N.yAttr = {
                                        buffer: o.buffer(G.y),
                                        offset: 0,
                                        stride: 4,
                                        count: G.y.length
                                    } : N.yAttr = {
                                        buffer: G.y.buffer,
                                        offset: G.y.offset * 4 || 0,
                                        stride: (G.y.stride || 1) * 4,
                                        count: G.y.count
                                    }, N.count = Math.max(N.xAttr.count, N.yAttr.count), G;
                                    G = F7t(G, "float64");
                                    var ke = N.count = Math.floor(G.length / 2), ge = N.bounds = ke ? P7t(G, 2) : null;
                                    if (!W.range && !N.range && (delete N.range, W.range = ge), !W.marker && !N.marker && (delete N.marker, W.marker = null), re && (re === !0 || ke > re) ? N.tree = R7t(G, {
                                        bounds: ge
                                    }) : re && re.length && (N.tree = re), N.tree) {
                                        var ie = {
                                            primitive: "points",
                                            usage: "static",
                                            data: N.tree,
                                            type: "uint32"
                                        };
                                        N.elements ? N.elements(ie) : N.elements = o.elements(ie);
                                    }
                                    var Te = Kz.float32(G);
                                    ae({
                                        data: Te,
                                        usage: "dynamic"
                                    });
                                    var Ee = Kz.fract32(G, Te);
                                    return _e({
                                        data: Ee,
                                        usage: "dynamic"
                                    }), Me({
                                        data: new Uint8Array(ke),
                                        type: "uint8",
                                        usage: "stream"
                                    }), G;
                                }
                            },
                            {
                                marker: function(G, N, W) {
                                    var re = N.activation;
                                    if (re.forEach(function(Ee) {
                                        return Ee && Ee.destroy && Ee.destroy();
                                    }), re.length = 0, !G || typeof G[0] == "number") {
                                        var ae = e.addMarker(G);
                                        re[ae] = !0;
                                    } else {
                                        for(var _e = [], Me = 0, ke = Math.min(G.length, N.count); Me < ke; Me++){
                                            var ge = e.addMarker(G[Me]);
                                            _e[ge] || (_e[ge] = new Uint8Array(N.count)), _e[ge][Me] = 1;
                                        }
                                        for(var ie = 0; ie < _e.length; ie++)if (_e[ie]) {
                                            var Te = {
                                                data: _e[ie],
                                                type: "uint8",
                                                usage: "static"
                                            };
                                            re[ie] ? re[ie](Te) : re[ie] = o.buffer(Te), re[ie].data = _e[ie];
                                        }
                                    }
                                    return G;
                                },
                                range: function(G, N, W) {
                                    var re = N.bounds;
                                    if (re) return G || (G = re), N.scale = [
                                        1 / (G[2] - G[0]),
                                        1 / (G[3] - G[1])
                                    ], N.translate = [
                                        -G[0],
                                        -G[1]
                                    ], N.scaleFract = Kz.fract(N.scale), N.translateFract = Kz.fract(N.translate), G;
                                },
                                viewport: function(G) {
                                    var N = q7t(G || [
                                        a.drawingBufferWidth,
                                        a.drawingBufferHeight
                                    ]);
                                    return N;
                                }
                            }
                        ]), d) {
                            var x = h, b = x.count, p = x.size, E = x.borderSize, k = x.sizeBuffer, A = new Uint8Array(b * 2);
                            if (p.length || E.length) for(var L = 0; L < b; L++)A[L * 2] = Math.round((p[L] == null ? p : p[L]) * 255 / s), A[L * 2 + 1] = Math.round((E[L] == null ? E : E[L]) * 255 / s);
                            k({
                                data: A,
                                usage: "dynamic"
                            });
                        }
                        if (v) {
                            var _ = h, C = _.count, M = _.color, g = _.borderColor, P = _.colorBuffer, T;
                            if (e.tooManyColors) {
                                if (M.length || g.length) {
                                    T = new Uint8Array(C * 8);
                                    for(var F = 0; F < C; F++){
                                        var q = M[F];
                                        T[F * 8] = u[q * 4], T[F * 8 + 1] = u[q * 4 + 1], T[F * 8 + 2] = u[q * 4 + 2], T[F * 8 + 3] = u[q * 4 + 3];
                                        var V = g[F];
                                        T[F * 8 + 4] = u[V * 4], T[F * 8 + 5] = u[V * 4 + 1], T[F * 8 + 6] = u[V * 4 + 2], T[F * 8 + 7] = u[V * 4 + 3];
                                    }
                                }
                            } else if (M.length || g.length) {
                                T = new Uint8Array(C * 4 + 2);
                                for(var H = 0; H < C; H++)M[H] != null && (T[H * 4] = M[H] % l, T[H * 4 + 1] = Math.floor(M[H] / l)), g[H] != null && (T[H * 4 + 2] = g[H] % l, T[H * 4 + 3] = Math.floor(g[H] / l));
                            }
                            P({
                                data: T || new Uint8Array(0),
                                type: "uint8",
                                usage: "dynamic"
                            });
                        }
                        return h;
                    });
                }
            };
            rv.prototype.addMarker = function(e) {
                var t = this.markerTextures, r = this.regl, n = this.markerCache, i = e == null ? 0 : n.indexOf(e);
                if (i >= 0) return i;
                var a;
                if (e instanceof Uint8Array || e instanceof Uint8ClampedArray) a = e;
                else {
                    a = new Uint8Array(e.length);
                    for(var o = 0, s = e.length; o < s; o++)a[o] = e[o] * 255;
                }
                var l = Math.floor(Math.sqrt(a.length));
                return i = t.length, n.push(e), t.push(r.texture({
                    channels: 1,
                    data: a,
                    radius: l,
                    mag: "linear",
                    min: "linear"
                })), i;
            };
            rv.prototype.updateColor = function(e) {
                var t = this.paletteIds, r = this.palette, n = this.maxColors;
                Array.isArray(e) || (e = [
                    e
                ]);
                var i = [];
                if (typeof e[0] == "number") {
                    var a = [];
                    if (Array.isArray(e)) for(var o = 0; o < e.length; o += 4)a.push(e.slice(o, o + 4));
                    else for(var s = 0; s < e.length; s += 4)a.push(e.subarray(s, s + 4));
                    e = a;
                }
                for(var l = 0; l < e.length; l++){
                    var u = e[l];
                    u = L7t(u, "uint8");
                    var c = I7t(u, !1);
                    if (t[c] == null) {
                        var f = r.length;
                        t[c] = Math.floor(f / 4), r[f] = u[0], r[f + 1] = u[1], r[f + 2] = u[2], r[f + 3] = u[3];
                    }
                    i[l] = t[c];
                }
                return !this.tooManyColors && r.length > n * 4 && (this.tooManyColors = !0), this.updatePalette(r), i.length === 1 ? i[0] : i;
            };
            rv.prototype.updatePalette = function(e) {
                if (!this.tooManyColors) {
                    var t = this.maxColors, r = this.paletteTexture, n = Math.ceil(e.length * .25 / t);
                    if (n > 1) {
                        e = e.slice();
                        for(var i = e.length * .25 % t; i < n * t; i++)e.push(0, 0, 0, 0);
                    }
                    r.height < n && r.resize(t, n), r.subimage({
                        width: Math.min(e.length * .25, t),
                        height: n,
                        data: e
                    }, 0, 0);
                }
            };
            rv.prototype.destroy = function() {
                return this.groups.forEach(function(e) {
                    e.sizeBuffer.destroy(), e.positionBuffer.destroy(), e.positionFractBuffer.destroy(), e.colorBuffer.destroy(), e.activation.forEach(function(t) {
                        return t && t.destroy && t.destroy();
                    }), e.selectionBuffer.destroy(), e.elements && e.elements.destroy();
                }), this.groups.length = 0, this.paletteTexture.destroy(), this.markerTextures.forEach(function(e) {
                    return e && e.destroy && e.destroy();
                }), this;
            };
            var B7t = bh(), N7t = function(t, r) {
                var n = new O7t(t, r), i = n.render.bind(n);
                return B7t(i, {
                    render: i,
                    update: n.update.bind(n),
                    draw: n.draw.bind(n),
                    destroy: n.destroy.bind(n),
                    regl: n.regl,
                    gl: n.gl,
                    canvas: n.gl.canvas,
                    groups: n.groups,
                    markers: n.markerCache,
                    palette: n.palette
                }), i;
            };
            rFe.exports = N7t;
        });
        var sFe = ye((D0r, iY)=>{
            "use strict";
            iY.exports = Qz;
            iY.exports.default = Qz;
            function Qz(e, t, r) {
                r = r || 2;
                var n = t && t.length, i = n ? t[0] * r : e.length, a = nFe(e, 0, i, r, !0), o = [];
                if (!a || a.next === a.prev) return o;
                var s, l, u, c, f, h, d;
                if (n && (a = j7t(e, t, a, r)), e.length > 80 * r) {
                    s = u = e[0], l = c = e[1];
                    for(var v = r; v < i; v += r)f = e[v], h = e[v + 1], f < s && (s = f), h < l && (l = h), f > u && (u = f), h > c && (c = h);
                    d = Math.max(u - s, c - l), d = d !== 0 ? 32767 / d : 0;
                }
                return sk(a, o, r, s, l, d, 0), o;
            }
            function nFe(e, t, r, n, i) {
                var a, o;
                if (i === rY(e, t, r, n) > 0) for(a = t; a < r; a += n)o = iFe(a, e[a], e[a + 1], o);
                else for(a = r - n; a >= t; a -= n)o = iFe(a, e[a], e[a + 1], o);
                return o && eF(o, o.next) && (uk(o), o = o.next), o;
            }
            function J2(e, t) {
                if (!e) return e;
                t || (t = e);
                var r = e, n;
                do if (n = !1, !r.steiner && (eF(r, r.next) || eh(r.prev, r, r.next) === 0)) {
                    if (uk(r), r = t = r.prev, r === r.next) break;
                    n = !0;
                } else r = r.next;
                while (n || r !== t);
                return t;
            }
            function sk(e, t, r, n, i, a, o) {
                if (e) {
                    !o && a && K7t(e, n, i, a);
                    for(var s = e, l, u; e.prev !== e.next;){
                        if (l = e.prev, u = e.next, a ? V7t(e, n, i, a) : U7t(e)) {
                            t.push(l.i / r | 0), t.push(e.i / r | 0), t.push(u.i / r | 0), uk(e), e = u.next, s = u.next;
                            continue;
                        }
                        if (e = u, e === s) {
                            o ? o === 1 ? (e = H7t(J2(e), t, r), sk(e, t, r, n, i, a, 2)) : o === 2 && G7t(e, t, r, n, i, a) : sk(J2(e), t, r, n, i, a, 1);
                            break;
                        }
                    }
                }
            }
            function U7t(e) {
                var t = e.prev, r = e, n = e.next;
                if (eh(t, r, n) >= 0) return !1;
                for(var i = t.x, a = r.x, o = n.x, s = t.y, l = r.y, u = n.y, c = i < a ? i < o ? i : o : a < o ? a : o, f = s < l ? s < u ? s : u : l < u ? l : u, h = i > a ? i > o ? i : o : a > o ? a : o, d = s > l ? s > u ? s : u : l > u ? l : u, v = n.next; v !== t;){
                    if (v.x >= c && v.x <= h && v.y >= f && v.y <= d && oA(i, s, a, l, o, u, v.x, v.y) && eh(v.prev, v, v.next) >= 0) return !1;
                    v = v.next;
                }
                return !0;
            }
            function V7t(e, t, r, n) {
                var i = e.prev, a = e, o = e.next;
                if (eh(i, a, o) >= 0) return !1;
                for(var s = i.x, l = a.x, u = o.x, c = i.y, f = a.y, h = o.y, d = s < l ? s < u ? s : u : l < u ? l : u, v = c < f ? c < h ? c : h : f < h ? f : h, x = s > l ? s > u ? s : u : l > u ? l : u, b = c > f ? c > h ? c : h : f > h ? f : h, p = eY(d, v, t, r, n), E = eY(x, b, t, r, n), k = e.prevZ, A = e.nextZ; k && k.z >= p && A && A.z <= E;){
                    if (k.x >= d && k.x <= x && k.y >= v && k.y <= b && k !== i && k !== o && oA(s, c, l, f, u, h, k.x, k.y) && eh(k.prev, k, k.next) >= 0 || (k = k.prevZ, A.x >= d && A.x <= x && A.y >= v && A.y <= b && A !== i && A !== o && oA(s, c, l, f, u, h, A.x, A.y) && eh(A.prev, A, A.next) >= 0)) return !1;
                    A = A.nextZ;
                }
                for(; k && k.z >= p;){
                    if (k.x >= d && k.x <= x && k.y >= v && k.y <= b && k !== i && k !== o && oA(s, c, l, f, u, h, k.x, k.y) && eh(k.prev, k, k.next) >= 0) return !1;
                    k = k.prevZ;
                }
                for(; A && A.z <= E;){
                    if (A.x >= d && A.x <= x && A.y >= v && A.y <= b && A !== i && A !== o && oA(s, c, l, f, u, h, A.x, A.y) && eh(A.prev, A, A.next) >= 0) return !1;
                    A = A.nextZ;
                }
                return !0;
            }
            function H7t(e, t, r) {
                var n = e;
                do {
                    var i = n.prev, a = n.next.next;
                    !eF(i, a) && aFe(i, n, n.next, a) && lk(i, a) && lk(a, i) && (t.push(i.i / r | 0), t.push(n.i / r | 0), t.push(a.i / r | 0), uk(n), uk(n.next), n = e = a), n = n.next;
                }while (n !== e);
                return J2(n);
            }
            function G7t(e, t, r, n, i, a) {
                var o = e;
                do {
                    for(var s = o.next.next; s !== o.prev;){
                        if (o.i !== s.i && Q7t(o, s)) {
                            var l = oFe(o, s);
                            o = J2(o, o.next), l = J2(l, l.next), sk(o, t, r, n, i, a, 0), sk(l, t, r, n, i, a, 0);
                            return;
                        }
                        s = s.next;
                    }
                    o = o.next;
                }while (o !== e);
            }
            function j7t(e, t, r, n) {
                var i = [], a, o, s, l, u;
                for(a = 0, o = t.length; a < o; a++)s = t[a] * n, l = a < o - 1 ? t[a + 1] * n : e.length, u = nFe(e, s, l, n, !1), u === u.next && (u.steiner = !0), i.push($7t(u));
                for(i.sort(W7t), a = 0; a < i.length; a++)r = Z7t(i[a], r);
                return r;
            }
            function W7t(e, t) {
                return e.x - t.x;
            }
            function Z7t(e, t) {
                var r = X7t(e, t);
                if (!r) return t;
                var n = oFe(r, e);
                return J2(n, n.next), J2(r, r.next);
            }
            function X7t(e, t) {
                var r = t, n = e.x, i = e.y, a = -1 / 0, o;
                do {
                    if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
                        var s = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (s <= n && s > a && (a = s, o = r.x < r.next.x ? r : r.next, s === n)) return o;
                    }
                    r = r.next;
                }while (r !== t);
                if (!o) return null;
                var l = o, u = o.x, c = o.y, f = 1 / 0, h;
                r = o;
                do n >= r.x && r.x >= u && n !== r.x && oA(i < c ? n : a, i, u, c, i < c ? a : n, i, r.x, r.y) && (h = Math.abs(i - r.y) / (n - r.x), lk(r, e) && (h < f || h === f && (r.x > o.x || r.x === o.x && Y7t(o, r))) && (o = r, f = h)), r = r.next;
                while (r !== l);
                return o;
            }
            function Y7t(e, t) {
                return eh(e.prev, e, t.prev) < 0 && eh(t.next, e, e.next) < 0;
            }
            function K7t(e, t, r, n) {
                var i = e;
                do i.z === 0 && (i.z = eY(i.x, i.y, t, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== e);
                i.prevZ.nextZ = null, i.prevZ = null, J7t(i);
            }
            function J7t(e) {
                var t, r, n, i, a, o, s, l, u = 1;
                do {
                    for(r = e, e = null, a = null, o = 0; r;){
                        for(o++, n = r, s = 0, t = 0; t < u && (s++, n = n.nextZ, !!n); t++);
                        for(l = u; s > 0 || l > 0 && n;)s !== 0 && (l === 0 || !n || r.z <= n.z) ? (i = r, r = r.nextZ, s--) : (i = n, n = n.nextZ, l--), a ? a.nextZ = i : e = i, i.prevZ = a, a = i;
                        r = n;
                    }
                    a.nextZ = null, u *= 2;
                }while (o > 1);
                return e;
            }
            function eY(e, t, r, n, i) {
                return e = (e - r) * i | 0, t = (t - n) * i | 0, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, e | t << 1;
            }
            function $7t(e) {
                var t = e, r = e;
                do (t.x < r.x || t.x === r.x && t.y < r.y) && (r = t), t = t.next;
                while (t !== e);
                return r;
            }
            function oA(e, t, r, n, i, a, o, s) {
                return (i - o) * (t - s) >= (e - o) * (a - s) && (e - o) * (n - s) >= (r - o) * (t - s) && (r - o) * (a - s) >= (i - o) * (n - s);
            }
            function Q7t(e, t) {
                return e.next.i !== t.i && e.prev.i !== t.i && !e9t(e, t) && (lk(e, t) && lk(t, e) && t9t(e, t) && (eh(e.prev, e, t.prev) || eh(e, t.prev, t)) || eF(e, t) && eh(e.prev, e, e.next) > 0 && eh(t.prev, t, t.next) > 0);
            }
            function eh(e, t, r) {
                return (t.y - e.y) * (r.x - t.x) - (t.x - e.x) * (r.y - t.y);
            }
            function eF(e, t) {
                return e.x === t.x && e.y === t.y;
            }
            function aFe(e, t, r, n) {
                var i = $z(eh(e, t, r)), a = $z(eh(e, t, n)), o = $z(eh(r, n, e)), s = $z(eh(r, n, t));
                return !!(i !== a && o !== s || i === 0 && Jz(e, r, t) || a === 0 && Jz(e, n, t) || o === 0 && Jz(r, e, n) || s === 0 && Jz(r, t, n));
            }
            function Jz(e, t, r) {
                return t.x <= Math.max(e.x, r.x) && t.x >= Math.min(e.x, r.x) && t.y <= Math.max(e.y, r.y) && t.y >= Math.min(e.y, r.y);
            }
            function $z(e) {
                return e > 0 ? 1 : e < 0 ? -1 : 0;
            }
            function e9t(e, t) {
                var r = e;
                do {
                    if (r.i !== e.i && r.next.i !== e.i && r.i !== t.i && r.next.i !== t.i && aFe(r, r.next, e, t)) return !0;
                    r = r.next;
                }while (r !== e);
                return !1;
            }
            function lk(e, t) {
                return eh(e.prev, e, e.next) < 0 ? eh(e, t, e.next) >= 0 && eh(e, e.prev, t) >= 0 : eh(e, t, e.prev) < 0 || eh(e, e.next, t) < 0;
            }
            function t9t(e, t) {
                var r = e, n = !1, i = (e.x + t.x) / 2, a = (e.y + t.y) / 2;
                do r.y > a != r.next.y > a && r.next.y !== r.y && i < (r.next.x - r.x) * (a - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== e);
                return n;
            }
            function oFe(e, t) {
                var r = new tY(e.i, e.x, e.y), n = new tY(t.i, t.x, t.y), i = e.next, a = t.prev;
                return e.next = t, t.prev = e, r.next = i, i.prev = r, n.next = r, r.prev = n, a.next = n, n.prev = a, n;
            }
            function iFe(e, t, r, n) {
                var i = new tY(e, t, r);
                return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
            }
            function uk(e) {
                e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ);
            }
            function tY(e, t, r) {
                this.i = e, this.x = t, this.y = r, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
            }
            Qz.deviation = function(e, t, r, n) {
                var i = t && t.length, a = i ? t[0] * r : e.length, o = Math.abs(rY(e, 0, a, r));
                if (i) for(var s = 0, l = t.length; s < l; s++){
                    var u = t[s] * r, c = s < l - 1 ? t[s + 1] * r : e.length;
                    o -= Math.abs(rY(e, u, c, r));
                }
                var f = 0;
                for(s = 0; s < n.length; s += 3){
                    var h = n[s] * r, d = n[s + 1] * r, v = n[s + 2] * r;
                    f += Math.abs((e[h] - e[v]) * (e[d + 1] - e[h + 1]) - (e[h] - e[d]) * (e[v + 1] - e[h + 1]));
                }
                return o === 0 && f === 0 ? 0 : Math.abs((f - o) / o);
            };
            function rY(e, t, r, n) {
                for(var i = 0, a = t, o = r - n; a < r; a += n)i += (e[o] - e[a]) * (e[a + 1] + e[o + 1]), o = a;
                return i;
            }
            Qz.flatten = function(e) {
                for(var t = e[0][0].length, r = {
                    vertices: [],
                    holes: [],
                    dimensions: t
                }, n = 0, i = 0; i < e.length; i++){
                    for(var a = 0; a < e[i].length; a++)for(var o = 0; o < t; o++)r.vertices.push(e[i][a][o]);
                    i > 0 && (n += e[i - 1].length, r.holes.push(n));
                }
                return r;
            };
        });
        var uFe = ye((z0r, lFe)=>{
            "use strict";
            var r9t = j2();
            lFe.exports = i9t;
            function i9t(e, t, r) {
                if (!e || e.length == null) throw Error("Argument should be an array");
                t == null && (t = 1), r == null && (r = r9t(e, t));
                for(var n = 0; n < t; n++){
                    var i = r[t + n], a = r[n], o = n, s = e.length;
                    if (i === 1 / 0 && a === -1 / 0) for(o = n; o < s; o += t)e[o] = e[o] === i ? 1 : e[o] === a ? 0 : .5;
                    else if (i === 1 / 0) for(o = n; o < s; o += t)e[o] = e[o] === i ? 1 : 0;
                    else if (a === -1 / 0) for(o = n; o < s; o += t)e[o] = e[o] === a ? 0 : 1;
                    else {
                        var l = i - a;
                        for(o = n; o < s; o += t)isNaN(e[o]) || (e[o] = l === 0 ? .5 : (e[o] - a) / l);
                    }
                }
                return e;
            }
        });
        var fFe = ye((F0r, cFe)=>{
            "use strict";
            cFe.exports = function() {
                var e, t;
                if (typeof WeakMap != "function") return !1;
                try {
                    e = new WeakMap([
                        [
                            t = {},
                            "one"
                        ],
                        [
                            {},
                            "two"
                        ],
                        [
                            {},
                            "three"
                        ]
                    ]);
                } catch (r) {
                    return !1;
                }
                return !(String(e) !== "[object WeakMap]" || typeof e.set != "function" || e.set({}, 1) !== e || typeof e.delete != "function" || typeof e.has != "function" || e.get(t) !== "one");
            };
        });
        var dFe = ye((q0r, hFe)=>{
            "use strict";
            hFe.exports = function() {};
        });
        var lx = ye((O0r, vFe)=>{
            "use strict";
            var n9t = dFe()();
            vFe.exports = function(e) {
                return e !== n9t && e !== null;
            };
        });
        var nY = ye((B0r, gFe)=>{
            "use strict";
            var a9t = Object.create, o9t = Object.getPrototypeOf, pFe = {};
            gFe.exports = function() {
                var e = Object.setPrototypeOf, t = arguments[0] || a9t;
                return typeof e != "function" ? !1 : o9t(e(t(null), pFe)) === pFe;
            };
        });
        var aY = ye((N0r, mFe)=>{
            "use strict";
            var s9t = lx(), l9t = {
                function: !0,
                object: !0
            };
            mFe.exports = function(e) {
                return s9t(e) && l9t[typeof e] || !1;
            };
        });
        var i1 = ye((U0r, yFe)=>{
            "use strict";
            var u9t = lx();
            yFe.exports = function(e) {
                if (!u9t(e)) throw new TypeError("Cannot use null or undefined");
                return e;
            };
        });
        var xFe = ye((V0r, _Fe)=>{
            "use strict";
            var oY = Object.create, tF;
            nY()() || (tF = sY());
            _Fe.exports = function() {
                var e, t, r;
                return !tF || tF.level !== 1 ? oY : (e = {}, t = {}, r = {
                    configurable: !1,
                    enumerable: !1,
                    writable: !0,
                    value: void 0
                }, Object.getOwnPropertyNames(Object.prototype).forEach(function(n) {
                    if (n === "__proto__") {
                        t[n] = {
                            configurable: !0,
                            enumerable: !1,
                            writable: !0,
                            value: void 0
                        };
                        return;
                    }
                    t[n] = r;
                }), Object.defineProperties(e, t), Object.defineProperty(tF, "nullPolyfill", {
                    configurable: !1,
                    enumerable: !1,
                    writable: !1,
                    value: e
                }), function(n, i) {
                    return oY(n === null ? e : n, i);
                });
            }();
        });
        var sY = ye((H0r, bFe)=>{
            "use strict";
            var c9t = aY(), f9t = i1(), h9t = Object.prototype.isPrototypeOf, d9t = Object.defineProperty, v9t = {
                configurable: !0,
                enumerable: !1,
                writable: !0,
                value: void 0
            }, rF;
            rF = function(e, t) {
                if (f9t(e), t === null || c9t(t)) return e;
                throw new TypeError("Prototype must be null or an object");
            };
            bFe.exports = function(e) {
                var t, r;
                return e ? (e.level === 2 ? e.set ? (r = e.set, t = function(n, i) {
                    return r.call(rF(n, i), i), n;
                }) : t = function(n, i) {
                    return rF(n, i).__proto__ = i, n;
                } : t = function n(i, a) {
                    var o;
                    return rF(i, a), o = h9t.call(n.nullPolyfill, i), o && delete n.nullPolyfill.__proto__, a === null && (a = n.nullPolyfill), i.__proto__ = a, o && d9t(n.nullPolyfill, "__proto__", v9t), i;
                }, Object.defineProperty(t, "level", {
                    configurable: !1,
                    enumerable: !1,
                    writable: !1,
                    value: e.level
                })) : null;
            }(function() {
                var e = Object.create(null), t = {}, r, n = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__");
                if (n) {
                    try {
                        r = n.set, r.call(e, t);
                    } catch (i) {}
                    if (Object.getPrototypeOf(e) === t) return {
                        set: r,
                        level: 2
                    };
                }
                return e.__proto__ = t, Object.getPrototypeOf(e) === t ? {
                    level: 2
                } : (e = {}, e.__proto__ = t, Object.getPrototypeOf(e) === t ? {
                    level: 1
                } : !1);
            }());
            xFe();
        });
        var iF = ye((G0r, wFe)=>{
            "use strict";
            wFe.exports = nY()() ? Object.setPrototypeOf : sY();
        });
        var AFe = ye((j0r, TFe)=>{
            "use strict";
            var p9t = aY();
            TFe.exports = function(e) {
                if (!p9t(e)) throw new TypeError(e + " is not an Object");
                return e;
            };
        });
        var MFe = ye((W0r, SFe)=>{
            "use strict";
            var g9t = Object.create(null), m9t = Math.random;
            SFe.exports = function() {
                var e;
                do e = m9t().toString(36).slice(2);
                while (g9t[e]);
                return e;
            };
        });
        var $2 = ye((Z0r, EFe)=>{
            "use strict";
            var y9t = void 0;
            EFe.exports = function(e) {
                return e !== y9t && e !== null;
            };
        });
        var nF = ye((X0r, kFe)=>{
            "use strict";
            var _9t = $2(), x9t = {
                object: !0,
                function: !0,
                undefined: !0
            };
            kFe.exports = function(e) {
                return _9t(e) ? hasOwnProperty.call(x9t, typeof e) : !1;
            };
        });
        var LFe = ye((Y0r, CFe)=>{
            "use strict";
            var b9t = nF();
            CFe.exports = function(e) {
                if (!b9t(e)) return !1;
                try {
                    return e.constructor ? e.constructor.prototype === e : !1;
                } catch (t) {
                    return !1;
                }
            };
        });
        var IFe = ye((K0r, PFe)=>{
            "use strict";
            var w9t = LFe();
            PFe.exports = function(e) {
                if (typeof e != "function" || !hasOwnProperty.call(e, "length")) return !1;
                try {
                    if (typeof e.length != "number" || typeof e.call != "function" || typeof e.apply != "function") return !1;
                } catch (t) {
                    return !1;
                }
                return !w9t(e);
            };
        });
        var lY = ye((J0r, RFe)=>{
            "use strict";
            var T9t = IFe(), A9t = /^\s*class[\s{/}]/, S9t = Function.prototype.toString;
            RFe.exports = function(e) {
                return !(!T9t(e) || A9t.test(S9t.call(e)));
            };
        });
        var zFe = ye(($0r, DFe)=>{
            "use strict";
            DFe.exports = function() {
                var e = Object.assign, t;
                return typeof e != "function" ? !1 : (t = {
                    foo: "raz"
                }, e(t, {
                    bar: "dwa"
                }, {
                    trzy: "trzy"
                }), t.foo + t.bar + t.trzy === "razdwatrzy");
            };
        });
        var qFe = ye((Q0r, FFe)=>{
            "use strict";
            FFe.exports = function() {
                try {
                    return Object.keys("primitive"), !0;
                } catch (e) {
                    return !1;
                }
            };
        });
        var BFe = ye((egr, OFe)=>{
            "use strict";
            var M9t = lx(), E9t = Object.keys;
            OFe.exports = function(e) {
                return E9t(M9t(e) ? Object(e) : e);
            };
        });
        var UFe = ye((tgr, NFe)=>{
            "use strict";
            NFe.exports = qFe()() ? Object.keys : BFe();
        });
        var HFe = ye((rgr, VFe)=>{
            "use strict";
            var k9t = UFe(), C9t = i1(), L9t = Math.max;
            VFe.exports = function(e, t) {
                var r, n, i = L9t(arguments.length, 2), a;
                for(e = Object(C9t(e)), a = function(o) {
                    try {
                        e[o] = t[o];
                    } catch (s) {
                        r || (r = s);
                    }
                }, n = 1; n < i; ++n)t = arguments[n], k9t(t).forEach(a);
                if (r !== void 0) throw r;
                return e;
            };
        });
        var aF = ye((igr, GFe)=>{
            "use strict";
            GFe.exports = zFe()() ? Object.assign : HFe();
        });
        var uY = ye((ngr, jFe)=>{
            "use strict";
            var P9t = lx(), I9t = Array.prototype.forEach, R9t = Object.create, D9t = function(e, t) {
                var r;
                for(r in e)t[r] = e[r];
            };
            jFe.exports = function(e) {
                var t = R9t(null);
                return I9t.call(arguments, function(r) {
                    P9t(r) && D9t(Object(r), t);
                }), t;
            };
        });
        var ZFe = ye((agr, WFe)=>{
            "use strict";
            var cY = "razdwatrzy";
            WFe.exports = function() {
                return typeof cY.contains != "function" ? !1 : cY.contains("dwa") === !0 && cY.contains("foo") === !1;
            };
        });
        var YFe = ye((ogr, XFe)=>{
            "use strict";
            var z9t = String.prototype.indexOf;
            XFe.exports = function(e) {
                return z9t.call(this, e, arguments[1]) > -1;
            };
        });
        var fY = ye((sgr, KFe)=>{
            "use strict";
            KFe.exports = ZFe()() ? String.prototype.contains : YFe();
        });
        var n1 = ye((lgr, e7e)=>{
            "use strict";
            var oF = $2(), JFe = lY(), $Fe = aF(), QFe = uY(), ck = fY(), F9t = e7e.exports = function(e, t) {
                var r, n, i, a, o;
                return arguments.length < 2 || typeof e != "string" ? (a = t, t = e, e = null) : a = arguments[2], oF(e) ? (r = ck.call(e, "c"), n = ck.call(e, "e"), i = ck.call(e, "w")) : (r = i = !0, n = !1), o = {
                    value: t,
                    configurable: r,
                    enumerable: n,
                    writable: i
                }, a ? $Fe(QFe(a), o) : o;
            };
            F9t.gs = function(e, t, r) {
                var n, i, a, o;
                return typeof e != "string" ? (a = r, r = t, t = e, e = null) : a = arguments[3], oF(t) ? JFe(t) ? oF(r) ? JFe(r) || (a = r, r = void 0) : r = void 0 : (a = t, t = r = void 0) : t = void 0, oF(e) ? (n = ck.call(e, "c"), i = ck.call(e, "e")) : (n = !0, i = !1), o = {
                    get: t,
                    set: r,
                    configurable: n,
                    enumerable: i
                }, a ? $Fe(QFe(a), o) : o;
            };
        });
        var fk = ye((ugr, r7e)=>{
            "use strict";
            var t7e = Object.prototype.toString, q9t = t7e.call(function() {
                return arguments;
            }());
            r7e.exports = function(e) {
                return t7e.call(e) === q9t;
            };
        });
        var hk = ye((cgr, n7e)=>{
            "use strict";
            var i7e = Object.prototype.toString, O9t = i7e.call("");
            n7e.exports = function(e) {
                return typeof e == "string" || e && typeof e == "object" && (e instanceof String || i7e.call(e) === O9t) || !1;
            };
        });
        var o7e = ye((fgr, a7e)=>{
            "use strict";
            a7e.exports = function() {
                return typeof globalThis != "object" || !globalThis ? !1 : globalThis.Array === Array;
            };
        });
        var u7e = ye((hgr, l7e)=>{
            var s7e = function() {
                if (typeof self == "object" && self) return self;
                if (typeof window == "object" && window) return window;
                throw new Error("Unable to resolve global `this`");
            };
            l7e.exports = function() {
                if (this) return this;
                try {
                    Object.defineProperty(Object.prototype, "__global__", {
                        get: function() {
                            return this;
                        },
                        configurable: !0
                    });
                } catch (e) {
                    return s7e();
                }
                try {
                    return __global__ || s7e();
                } finally{
                    delete Object.prototype.__global__;
                }
            }();
        });
        var dk = ye((dgr, c7e)=>{
            "use strict";
            c7e.exports = o7e()() ? globalThis : u7e();
        });
        var h7e = ye((vgr, f7e)=>{
            "use strict";
            var B9t = dk(), hY = {
                object: !0,
                symbol: !0
            };
            f7e.exports = function() {
                var e = B9t.Symbol, t;
                if (typeof e != "function") return !1;
                t = e("test symbol");
                try {
                    String(t);
                } catch (r) {
                    return !1;
                }
                return !(!hY[typeof e.iterator] || !hY[typeof e.toPrimitive] || !hY[typeof e.toStringTag]);
            };
        });
        var v7e = ye((pgr, d7e)=>{
            "use strict";
            d7e.exports = function(e) {
                return e ? typeof e == "symbol" ? !0 : !e.constructor || e.constructor.name !== "Symbol" ? !1 : e[e.constructor.toStringTag] === "Symbol" : !1;
            };
        });
        var dY = ye((ggr, p7e)=>{
            "use strict";
            var N9t = v7e();
            p7e.exports = function(e) {
                if (!N9t(e)) throw new TypeError(e + " is not a symbol");
                return e;
            };
        });
        var x7e = ye((mgr, _7e)=>{
            "use strict";
            var g7e = n1(), U9t = Object.create, m7e = Object.defineProperty, V9t = Object.prototype, y7e = U9t(null);
            _7e.exports = function(e) {
                for(var t = 0, r, n; y7e[e + (t || "")];)++t;
                return e += t || "", y7e[e] = !0, r = "@@" + e, m7e(V9t, r, g7e.gs(null, function(i) {
                    n || (n = !0, m7e(this, r, g7e(i)), n = !1);
                })), r;
            };
        });
        var w7e = ye((ygr, b7e)=>{
            "use strict";
            var Qg = n1(), wh = dk().Symbol;
            b7e.exports = function(e) {
                return Object.defineProperties(e, {
                    hasInstance: Qg("", wh && wh.hasInstance || e("hasInstance")),
                    isConcatSpreadable: Qg("", wh && wh.isConcatSpreadable || e("isConcatSpreadable")),
                    iterator: Qg("", wh && wh.iterator || e("iterator")),
                    match: Qg("", wh && wh.match || e("match")),
                    replace: Qg("", wh && wh.replace || e("replace")),
                    search: Qg("", wh && wh.search || e("search")),
                    species: Qg("", wh && wh.species || e("species")),
                    split: Qg("", wh && wh.split || e("split")),
                    toPrimitive: Qg("", wh && wh.toPrimitive || e("toPrimitive")),
                    toStringTag: Qg("", wh && wh.toStringTag || e("toStringTag")),
                    unscopables: Qg("", wh && wh.unscopables || e("unscopables"))
                });
            };
        });
        var S7e = ye((_gr, A7e)=>{
            "use strict";
            var T7e = n1(), H9t = dY(), vk = Object.create(null);
            A7e.exports = function(e) {
                return Object.defineProperties(e, {
                    for: T7e(function(t) {
                        return vk[t] ? vk[t] : vk[t] = e(String(t));
                    }),
                    keyFor: T7e(function(t) {
                        var r;
                        H9t(t);
                        for(r in vk)if (vk[r] === t) return r;
                    })
                });
            };
        });
        var k7e = ye((xgr, E7e)=>{
            "use strict";
            var Xm = n1(), vY = dY(), sF = dk().Symbol, G9t = x7e(), j9t = w7e(), W9t = S7e(), Z9t = Object.create, pY = Object.defineProperties, lF = Object.defineProperty, Wv, sA, M7e;
            if (typeof sF == "function") try {
                String(sF()), M7e = !0;
            } catch (e) {}
            else sF = null;
            sA = function(t) {
                if (this instanceof sA) throw new TypeError("Symbol is not a constructor");
                return Wv(t);
            };
            E7e.exports = Wv = function e(t) {
                var r;
                if (this instanceof e) throw new TypeError("Symbol is not a constructor");
                return M7e ? sF(t) : (r = Z9t(sA.prototype), t = t === void 0 ? "" : String(t), pY(r, {
                    __description__: Xm("", t),
                    __name__: Xm("", G9t(t))
                }));
            };
            j9t(Wv);
            W9t(Wv);
            pY(sA.prototype, {
                constructor: Xm(Wv),
                toString: Xm("", function() {
                    return this.__name__;
                })
            });
            pY(Wv.prototype, {
                toString: Xm(function() {
                    return "Symbol (" + vY(this).__description__ + ")";
                }),
                valueOf: Xm(function() {
                    return vY(this);
                })
            });
            lF(Wv.prototype, Wv.toPrimitive, Xm("", function() {
                var e = vY(this);
                return typeof e == "symbol" ? e : e.toString();
            }));
            lF(Wv.prototype, Wv.toStringTag, Xm("c", "Symbol"));
            lF(sA.prototype, Wv.toStringTag, Xm("c", Wv.prototype[Wv.toStringTag]));
            lF(sA.prototype, Wv.toPrimitive, Xm("c", Wv.prototype[Wv.toPrimitive]));
        });
        var ux = ye((bgr, C7e)=>{
            "use strict";
            C7e.exports = h7e()() ? dk().Symbol : k7e();
        });
        var P7e = ye((wgr, L7e)=>{
            "use strict";
            var X9t = i1();
            L7e.exports = function() {
                return X9t(this).length = 0, this;
            };
        });
        var lA = ye((Tgr, I7e)=>{
            "use strict";
            I7e.exports = function(e) {
                if (typeof e != "function") throw new TypeError(e + " is not a function");
                return e;
            };
        });
        var D7e = ye((Agr, R7e)=>{
            "use strict";
            var Y9t = $2(), K9t = nF(), J9t = Object.prototype.toString;
            R7e.exports = function(e) {
                if (!Y9t(e)) return null;
                if (K9t(e)) {
                    var t = e.toString;
                    if (typeof t != "function" || t === J9t) return null;
                }
                try {
                    return "" + e;
                } catch (r) {
                    return null;
                }
            };
        });
        var F7e = ye((Sgr, z7e)=>{
            "use strict";
            z7e.exports = function(e) {
                try {
                    return e.toString();
                } catch (t) {
                    try {
                        return String(e);
                    } catch (r) {
                        return null;
                    }
                }
            };
        });
        var O7e = ye((Mgr, q7e)=>{
            "use strict";
            var $9t = F7e(), Q9t = /[\n\r\u2028\u2029]/g;
            q7e.exports = function(e) {
                var t = $9t(e);
                return t === null ? "<Non-coercible to string value>" : (t.length > 100 && (t = t.slice(0, 99) + "\u2026"), t = t.replace(Q9t, function(r) {
                    switch(r){
                        case `
`:
                            return "\\n";
                        case "\r":
                            return "\\r";
                        case "\u2028":
                            return "\\u2028";
                        case "\u2029":
                            return "\\u2029";
                        default:
                            throw new Error("Unexpected character");
                    }
                }), t);
            };
        });
        var gY = ye((Egr, U7e)=>{
            "use strict";
            var B7e = $2(), eqt = nF(), tqt = D7e(), rqt = O7e(), N7e = function(e, t) {
                return e.replace("%v", rqt(t));
            };
            U7e.exports = function(e, t, r) {
                if (!eqt(r)) throw new TypeError(N7e(t, e));
                if (!B7e(e)) {
                    if ("default" in r) return r.default;
                    if (r.isOptional) return null;
                }
                var n = tqt(r.errorMessage);
                throw B7e(n) || (n = t), new TypeError(N7e(n, e));
            };
        });
        var H7e = ye((kgr, V7e)=>{
            "use strict";
            var iqt = gY(), nqt = $2();
            V7e.exports = function(e) {
                return nqt(e) ? e : iqt(e, "Cannot use %v", arguments[1]);
            };
        });
        var j7e = ye((Cgr, G7e)=>{
            "use strict";
            var aqt = gY(), oqt = lY();
            G7e.exports = function(e) {
                return oqt(e) ? e : aqt(e, "%v is not a plain function", arguments[1]);
            };
        });
        var Z7e = ye((Lgr, W7e)=>{
            "use strict";
            W7e.exports = function() {
                var e = Array.from, t, r;
                return typeof e != "function" ? !1 : (t = [
                    "raz",
                    "dwa"
                ], r = e(t), !!(r && r !== t && r[1] === "dwa"));
            };
        });
        var Y7e = ye((Pgr, X7e)=>{
            "use strict";
            var sqt = Object.prototype.toString, lqt = RegExp.prototype.test.bind(/^[object [A-Za-z0-9]*Function]$/);
            X7e.exports = function(e) {
                return typeof e == "function" && lqt(sqt.call(e));
            };
        });
        var J7e = ye((Igr, K7e)=>{
            "use strict";
            K7e.exports = function() {
                var e = Math.sign;
                return typeof e != "function" ? !1 : e(10) === 1 && e(-20) === -1;
            };
        });
        var Q7e = ye((Rgr, $7e)=>{
            "use strict";
            $7e.exports = function(e) {
                return e = Number(e), isNaN(e) || e === 0 ? e : e > 0 ? 1 : -1;
            };
        });
        var t9e = ye((Dgr, e9e)=>{
            "use strict";
            e9e.exports = J7e()() ? Math.sign : Q7e();
        });
        var i9e = ye((zgr, r9e)=>{
            "use strict";
            var uqt = t9e(), cqt = Math.abs, fqt = Math.floor;
            r9e.exports = function(e) {
                return isNaN(e) ? 0 : (e = Number(e), e === 0 || !isFinite(e) ? e : uqt(e) * fqt(cqt(e)));
            };
        });
        var a9e = ye((Fgr, n9e)=>{
            "use strict";
            var hqt = i9e(), dqt = Math.max;
            n9e.exports = function(e) {
                return dqt(0, hqt(e));
            };
        });
        var u9e = ye((qgr, l9e)=>{
            "use strict";
            var vqt = ux().iterator, pqt = fk(), gqt = Y7e(), mqt = a9e(), o9e = lA(), yqt = i1(), _qt = lx(), xqt = hk(), s9e = Array.isArray, mY = Function.prototype.call, Q2 = {
                configurable: !0,
                enumerable: !0,
                writable: !0,
                value: null
            }, yY = Object.defineProperty;
            l9e.exports = function(e) {
                var t = arguments[1], r = arguments[2], n, i, a, o, s, l, u, c, f, h;
                if (e = Object(yqt(e)), _qt(t) && o9e(t), !this || this === Array || !gqt(this)) {
                    if (!t) {
                        if (pqt(e)) return s = e.length, s !== 1 ? Array.apply(null, e) : (o = new Array(1), o[0] = e[0], o);
                        if (s9e(e)) {
                            for(o = new Array(s = e.length), i = 0; i < s; ++i)o[i] = e[i];
                            return o;
                        }
                    }
                    o = [];
                } else n = this;
                if (!s9e(e)) {
                    if ((f = e[vqt]) !== void 0) {
                        for(u = o9e(f).call(e), n && (o = new n), c = u.next(), i = 0; !c.done;)h = t ? mY.call(t, r, c.value, i) : c.value, n ? (Q2.value = h, yY(o, i, Q2)) : o[i] = h, c = u.next(), ++i;
                        s = i;
                    } else if (xqt(e)) {
                        for(s = e.length, n && (o = new n), i = 0, a = 0; i < s; ++i)h = e[i], i + 1 < s && (l = h.charCodeAt(0), l >= 55296 && l <= 56319 && (h += e[++i])), h = t ? mY.call(t, r, h, a) : h, n ? (Q2.value = h, yY(o, a, Q2)) : o[a] = h, ++a;
                        s = a;
                    }
                }
                if (s === void 0) for(s = mqt(e.length), n && (o = new n(s)), i = 0; i < s; ++i)h = t ? mY.call(t, r, e[i], i) : e[i], n ? (Q2.value = h, yY(o, i, Q2)) : o[i] = h;
                return n && (Q2.value = null, o.length = s), o;
            };
        });
        var f9e = ye((Ogr, c9e)=>{
            "use strict";
            c9e.exports = Z7e()() ? Array.from : u9e();
        });
        var d9e = ye((Bgr, h9e)=>{
            "use strict";
            var bqt = f9e(), wqt = aF(), Tqt = i1();
            h9e.exports = function(e) {
                var t = Object(Tqt(e)), r = arguments[1], n = Object(arguments[2]);
                if (t !== e && !r) return t;
                var i = {};
                return r ? bqt(r, function(a) {
                    (n.ensure || a in e) && (i[a] = e[a]);
                }) : wqt(i, e), i;
            };
        });
        var g9e = ye((Ngr, p9e)=>{
            "use strict";
            var Aqt = lA(), Sqt = i1(), Mqt = Function.prototype.bind, v9e = Function.prototype.call, Eqt = Object.keys, kqt = Object.prototype.propertyIsEnumerable;
            p9e.exports = function(e, t) {
                return function(r, n) {
                    var i, a = arguments[2], o = arguments[3];
                    return r = Object(Sqt(r)), Aqt(n), i = Eqt(r), o && i.sort(typeof o == "function" ? Mqt.call(o, r) : void 0), typeof e != "function" && (e = i[e]), v9e.call(e, i, function(s, l) {
                        return kqt.call(r, s) ? v9e.call(n, a, r[s], s, r, l) : t;
                    });
                };
            };
        });
        var y9e = ye((Ugr, m9e)=>{
            "use strict";
            m9e.exports = g9e()("forEach");
        });
        var x9e = ye((Vgr, _9e)=>{
            "use strict";
            var Cqt = lA(), Lqt = y9e(), Pqt = Function.prototype.call;
            _9e.exports = function(e, t) {
                var r = {}, n = arguments[2];
                return Cqt(t), Lqt(e, function(i, a, o, s) {
                    r[a] = Pqt.call(t, n, i, a, o, s);
                }), r;
            };
        });
        var A9e = ye((Hgr, T9e)=>{
            "use strict";
            var Iqt = $2(), Rqt = H7e(), b9e = j7e(), Dqt = d9e(), zqt = uY(), Fqt = x9e(), qqt = Function.prototype.bind, Oqt = Object.defineProperty, Bqt = Object.prototype.hasOwnProperty, w9e;
            w9e = function(e, t, r) {
                var n = Rqt(t) && b9e(t.value), i;
                return i = Dqt(t), delete i.writable, delete i.value, i.get = function() {
                    return !r.overwriteDefinition && Bqt.call(this, e) ? n : (t.value = qqt.call(n, r.resolveContext ? r.resolveContext(this) : this), Oqt(this, e, t), this[e]);
                }, i;
            };
            T9e.exports = function(e) {
                var t = zqt(arguments[1]);
                return Iqt(t.resolveContext) && b9e(t.resolveContext), Fqt(e, function(r, n) {
                    return w9e(n, r, t);
                });
            };
        });
        var _Y = ye((Ggr, k9e)=>{
            "use strict";
            var Nqt = P7e(), Uqt = aF(), Vqt = lA(), Hqt = i1(), Op = n1(), Gqt = A9e(), S9e = ux(), M9e = Object.defineProperty, E9e = Object.defineProperties, pk;
            k9e.exports = pk = function(e, t) {
                if (!(this instanceof pk)) throw new TypeError("Constructor requires 'new'");
                E9e(this, {
                    __list__: Op("w", Hqt(e)),
                    __context__: Op("w", t),
                    __nextIndex__: Op("w", 0)
                }), t && (Vqt(t.on), t.on("_add", this._onAdd), t.on("_delete", this._onDelete), t.on("_clear", this._onClear));
            };
            delete pk.prototype.constructor;
            E9e(pk.prototype, Uqt({
                _next: Op(function() {
                    var e;
                    if (this.__list__) {
                        if (this.__redo__ && (e = this.__redo__.shift(), e !== void 0)) return e;
                        if (this.__nextIndex__ < this.__list__.length) return this.__nextIndex__++;
                        this._unBind();
                    }
                }),
                next: Op(function() {
                    return this._createResult(this._next());
                }),
                _createResult: Op(function(e) {
                    return e === void 0 ? {
                        done: !0,
                        value: void 0
                    } : {
                        done: !1,
                        value: this._resolve(e)
                    };
                }),
                _resolve: Op(function(e) {
                    return this.__list__[e];
                }),
                _unBind: Op(function() {
                    this.__list__ = null, delete this.__redo__, this.__context__ && (this.__context__.off("_add", this._onAdd), this.__context__.off("_delete", this._onDelete), this.__context__.off("_clear", this._onClear), this.__context__ = null);
                }),
                toString: Op(function() {
                    return "[object " + (this[S9e.toStringTag] || "Object") + "]";
                })
            }, Gqt({
                _onAdd: Op(function(e) {
                    if (!(e >= this.__nextIndex__)) {
                        if (++this.__nextIndex__, !this.__redo__) {
                            M9e(this, "__redo__", Op("c", [
                                e
                            ]));
                            return;
                        }
                        this.__redo__.forEach(function(t, r) {
                            t >= e && (this.__redo__[r] = ++t);
                        }, this), this.__redo__.push(e);
                    }
                }),
                _onDelete: Op(function(e) {
                    var t;
                    e >= this.__nextIndex__ || (--this.__nextIndex__, this.__redo__ && (t = this.__redo__.indexOf(e), t !== -1 && this.__redo__.splice(t, 1), this.__redo__.forEach(function(r, n) {
                        r > e && (this.__redo__[n] = --r);
                    }, this)));
                }),
                _onClear: Op(function() {
                    this.__redo__ && Nqt.call(this.__redo__), this.__nextIndex__ = 0;
                })
            })));
            M9e(pk.prototype, S9e.iterator, Op(function() {
                return this;
            }));
        });
        var R9e = ye((jgr, I9e)=>{
            "use strict";
            var C9e = iF(), L9e = fY(), xY = n1(), jqt = ux(), bY = _Y(), P9e = Object.defineProperty, uA;
            uA = I9e.exports = function(e, t) {
                if (!(this instanceof uA)) throw new TypeError("Constructor requires 'new'");
                bY.call(this, e), t ? L9e.call(t, "key+value") ? t = "key+value" : L9e.call(t, "key") ? t = "key" : t = "value" : t = "value", P9e(this, "__kind__", xY("", t));
            };
            C9e && C9e(uA, bY);
            delete uA.prototype.constructor;
            uA.prototype = Object.create(bY.prototype, {
                _resolve: xY(function(e) {
                    return this.__kind__ === "value" ? this.__list__[e] : this.__kind__ === "key+value" ? [
                        e,
                        this.__list__[e]
                    ] : e;
                })
            });
            P9e(uA.prototype, jqt.toStringTag, xY("c", "Array Iterator"));
        });
        var q9e = ye((Wgr, F9e)=>{
            "use strict";
            var D9e = iF(), uF = n1(), Wqt = ux(), wY = _Y(), z9e = Object.defineProperty, cA;
            cA = F9e.exports = function(e) {
                if (!(this instanceof cA)) throw new TypeError("Constructor requires 'new'");
                e = String(e), wY.call(this, e), z9e(this, "__length__", uF("", e.length));
            };
            D9e && D9e(cA, wY);
            delete cA.prototype.constructor;
            cA.prototype = Object.create(wY.prototype, {
                _next: uF(function() {
                    if (this.__list__) {
                        if (this.__nextIndex__ < this.__length__) return this.__nextIndex__++;
                        this._unBind();
                    }
                }),
                _resolve: uF(function(e) {
                    var t = this.__list__[e], r;
                    return this.__nextIndex__ === this.__length__ ? t : (r = t.charCodeAt(0), r >= 55296 && r <= 56319 ? t + this.__list__[this.__nextIndex__++] : t);
                })
            });
            z9e(cA.prototype, Wqt.toStringTag, uF("c", "String Iterator"));
        });
        var B9e = ye((Zgr, O9e)=>{
            "use strict";
            var Zqt = fk(), Xqt = lx(), Yqt = hk(), Kqt = ux().iterator, Jqt = Array.isArray;
            O9e.exports = function(e) {
                return Xqt(e) ? Jqt(e) || Yqt(e) || Zqt(e) ? !0 : typeof e[Kqt] == "function" : !1;
            };
        });
        var U9e = ye((Xgr, N9e)=>{
            "use strict";
            var $qt = B9e();
            N9e.exports = function(e) {
                if (!$qt(e)) throw new TypeError(e + " is not iterable");
                return e;
            };
        });
        var TY = ye((Ygr, G9e)=>{
            "use strict";
            var Qqt = fk(), eOt = hk(), V9e = R9e(), tOt = q9e(), rOt = U9e(), H9e = ux().iterator;
            G9e.exports = function(e) {
                return typeof rOt(e)[H9e] == "function" ? e[H9e]() : Qqt(e) ? new V9e(e) : eOt(e) ? new tOt(e) : new V9e(e);
            };
        });
        var W9e = ye((Kgr, j9e)=>{
            "use strict";
            var iOt = fk(), nOt = lA(), aOt = hk(), oOt = TY(), sOt = Array.isArray, AY = Function.prototype.call, lOt = Array.prototype.some;
            j9e.exports = function(e, t) {
                var r, n = arguments[2], i, a, o, s, l, u, c;
                if (sOt(e) || iOt(e) ? r = "array" : aOt(e) ? r = "string" : e = oOt(e), nOt(t), a = function() {
                    o = !0;
                }, r === "array") {
                    lOt.call(e, function(f) {
                        return AY.call(t, n, f, a), o;
                    });
                    return;
                }
                if (r === "string") {
                    for(l = e.length, s = 0; s < l && (u = e[s], s + 1 < l && (c = u.charCodeAt(0), c >= 55296 && c <= 56319 && (u += e[++s])), AY.call(t, n, u, a), !o); ++s);
                    return;
                }
                for(i = e.next(); !i.done;){
                    if (AY.call(t, n, i.value, a), o) return;
                    i = e.next();
                }
            };
        });
        var X9e = ye((Jgr, Z9e)=>{
            "use strict";
            Z9e.exports = function() {
                return typeof WeakMap != "function" ? !1 : Object.prototype.toString.call(new WeakMap) === "[object WeakMap]";
            }();
        });
        var J9e = ye(($gr, K9e)=>{
            "use strict";
            var uOt = lx(), fF = iF(), cF = AFe(), cOt = i1(), fOt = MFe(), a1 = n1(), hOt = TY(), dOt = W9e(), vOt = ux().toStringTag, Y9e = X9e(), pOt = Array.isArray, MY = Object.defineProperty, SY = Object.prototype.hasOwnProperty, gOt = Object.getPrototypeOf, cx;
            K9e.exports = cx = function() {
                var e = arguments[0], t;
                if (!(this instanceof cx)) throw new TypeError("Constructor requires 'new'");
                return t = Y9e && fF && WeakMap !== cx ? fF(new WeakMap, gOt(this)) : this, uOt(e) && (pOt(e) || (e = hOt(e))), MY(t, "__weakMapData__", a1("c", "$weakMap$" + fOt())), e && dOt(e, function(r) {
                    cOt(r), t.set(r[0], r[1]);
                }), t;
            };
            Y9e && (fF && fF(cx, WeakMap), cx.prototype = Object.create(WeakMap.prototype, {
                constructor: a1(cx)
            }));
            Object.defineProperties(cx.prototype, {
                delete: a1(function(e) {
                    return SY.call(cF(e), this.__weakMapData__) ? (delete e[this.__weakMapData__], !0) : !1;
                }),
                get: a1(function(e) {
                    if (SY.call(cF(e), this.__weakMapData__)) return e[this.__weakMapData__];
                }),
                has: a1(function(e) {
                    return SY.call(cF(e), this.__weakMapData__);
                }),
                set: a1(function(e, t) {
                    return MY(cF(e), this.__weakMapData__, a1("c", t)), this;
                }),
                toString: a1(function() {
                    return "[object WeakMap]";
                })
            });
            MY(cx.prototype, vOt, a1("c", "WeakMap"));
        });
        var EY = ye((Qgr, $9e)=>{
            "use strict";
            $9e.exports = fFe()() ? WeakMap : J9e();
        });
        var eqe = ye((emr, Q9e)=>{
            "use strict";
            Q9e.exports = function(e, t, r) {
                if (typeof Array.prototype.findIndex == "function") return e.findIndex(t, r);
                if (typeof t != "function") throw new TypeError("predicate must be a function");
                var n = Object(e), i = n.length;
                if (i === 0) return -1;
                for(var a = 0; a < i; a++)if (t.call(r, n[a], a, n)) return a;
                return -1;
            };
        });
        var LY = ye((tmr, iqe)=>{
            "use strict";
            var hF = $_(), mOt = j2(), CY = bh(), yOt = Zm(), _Ot = W2(), tqe = sFe(), xOt = uFe(), { float32: bOt, fract32: kY } = Xz(), wOt = EY(), rqe = Q5(), TOt = eqe(), AOt = `
precision highp float;

attribute vec2 aCoord, bCoord, aCoordFract, bCoordFract;
attribute vec4 color;
attribute float lineEnd, lineTop;

uniform vec2 scale, scaleFract, translate, translateFract;
uniform float thickness, pixelRatio, id, depth;
uniform vec4 viewport;

varying vec4 fragColor;
varying vec2 tangent;

vec2 project(vec2 position, vec2 positionFract, vec2 scale, vec2 scaleFract, vec2 translate, vec2 translateFract) {
	// the order is important
	return position * scale + translate
       + positionFract * scale + translateFract
       + position * scaleFract
       + positionFract * scaleFract;
}

void main() {
	float lineStart = 1. - lineEnd;
	float lineOffset = lineTop * 2. - 1.;

	vec2 diff = (bCoord + bCoordFract - aCoord - aCoordFract);
	tangent = normalize(diff * scale * viewport.zw);
	vec2 normal = vec2(-tangent.y, tangent.x);

	vec2 position = project(aCoord, aCoordFract, scale, scaleFract, translate, translateFract) * lineStart
		+ project(bCoord, bCoordFract, scale, scaleFract, translate, translateFract) * lineEnd

		+ thickness * normal * .5 * lineOffset / viewport.zw;

	gl_Position = vec4(position * 2.0 - 1.0, depth, 1);

	fragColor = color / 255.;
}
`, SOt = `
precision highp float;

uniform float dashLength, pixelRatio, thickness, opacity, id;
uniform sampler2D dashTexture;

varying vec4 fragColor;
varying vec2 tangent;

void main() {
	float alpha = 1.;

	float t = fract(dot(tangent, gl_FragCoord.xy) / dashLength) * .5 + .25;
	float dash = texture2D(dashTexture, vec2(t, .5)).r;

	gl_FragColor = fragColor;
	gl_FragColor.a *= alpha * opacity * dash;
}
`, MOt = `
precision highp float;

attribute vec2 position, positionFract;

uniform vec4 color;
uniform vec2 scale, scaleFract, translate, translateFract;
uniform float pixelRatio, id;
uniform vec4 viewport;
uniform float opacity;

varying vec4 fragColor;

const float MAX_LINES = 256.;

void main() {
	float depth = (MAX_LINES - 4. - id) / (MAX_LINES);

	vec2 position = position * scale + translate
       + positionFract * scale + translateFract
       + position * scaleFract
       + positionFract * scaleFract;

	gl_Position = vec4(position * 2.0 - 1.0, depth, 1);

	fragColor = color / 255.;
	fragColor.a *= opacity;
}
`, EOt = `
precision highp float;
varying vec4 fragColor;

void main() {
	gl_FragColor = fragColor;
}
`, kOt = `
precision highp float;

attribute vec2 aCoord, bCoord, nextCoord, prevCoord;
attribute vec4 aColor, bColor;
attribute float lineEnd, lineTop;

uniform vec2 scale, translate;
uniform float thickness, pixelRatio, id, depth;
uniform vec4 viewport;
uniform float miterLimit, miterMode;

varying vec4 fragColor;
varying vec4 startCutoff, endCutoff;
varying vec2 tangent;
varying vec2 startCoord, endCoord;
varying float enableStartMiter, enableEndMiter;

const float REVERSE_THRESHOLD = -.875;
const float MIN_DIFF = 1e-6;

// TODO: possible optimizations: avoid overcalculating all for vertices and calc just one instead
// TODO: precalculate dot products, normalize things beforehead etc.
// TODO: refactor to rectangular algorithm

float distToLine(vec2 p, vec2 a, vec2 b) {
	vec2 diff = b - a;
	vec2 perp = normalize(vec2(-diff.y, diff.x));
	return dot(p - a, perp);
}

bool isNaN( float val ){
  return ( val < 0.0 || 0.0 < val || val == 0.0 ) ? false : true;
}

void main() {
	vec2 aCoord = aCoord, bCoord = bCoord, prevCoord = prevCoord, nextCoord = nextCoord;

  vec2 adjustedScale;
  adjustedScale.x = (abs(scale.x) < MIN_DIFF) ? MIN_DIFF : scale.x;
  adjustedScale.y = (abs(scale.y) < MIN_DIFF) ? MIN_DIFF : scale.y;

  vec2 scaleRatio = adjustedScale * viewport.zw;
	vec2 normalWidth = thickness / scaleRatio;

	float lineStart = 1. - lineEnd;
	float lineBot = 1. - lineTop;

	fragColor = (lineStart * aColor + lineEnd * bColor) / 255.;

	if (isNaN(aCoord.x) || isNaN(aCoord.y) || isNaN(bCoord.x) || isNaN(bCoord.y)) return;

	if (aCoord == prevCoord) prevCoord = aCoord + normalize(bCoord - aCoord);
	if (bCoord == nextCoord) nextCoord = bCoord - normalize(bCoord - aCoord);


	vec2 prevDiff = aCoord - prevCoord;
	vec2 currDiff = bCoord - aCoord;
	vec2 nextDiff = nextCoord - bCoord;

	vec2 prevTangent = normalize(prevDiff * scaleRatio);
	vec2 currTangent = normalize(currDiff * scaleRatio);
	vec2 nextTangent = normalize(nextDiff * scaleRatio);

	vec2 prevNormal = vec2(-prevTangent.y, prevTangent.x);
	vec2 currNormal = vec2(-currTangent.y, currTangent.x);
	vec2 nextNormal = vec2(-nextTangent.y, nextTangent.x);

	vec2 startJoinDirection = normalize(prevTangent - currTangent);
	vec2 endJoinDirection = normalize(currTangent - nextTangent);

	// collapsed/unidirectional segment cases
	// FIXME: there should be more elegant solution
	vec2 prevTanDiff = abs(prevTangent - currTangent);
	vec2 nextTanDiff = abs(nextTangent - currTangent);
	if (max(prevTanDiff.x, prevTanDiff.y) < MIN_DIFF) {
		startJoinDirection = currNormal;
	}
	if (max(nextTanDiff.x, nextTanDiff.y) < MIN_DIFF) {
		endJoinDirection = currNormal;
	}
	if (aCoord == bCoord) {
		endJoinDirection = startJoinDirection;
		currNormal = prevNormal;
		currTangent = prevTangent;
	}

	tangent = currTangent;

	//calculate join shifts relative to normals
	float startJoinShift = dot(currNormal, startJoinDirection);
	float endJoinShift = dot(currNormal, endJoinDirection);

	float startMiterRatio = abs(1. / startJoinShift);
	float endMiterRatio = abs(1. / endJoinShift);

	vec2 startJoin = startJoinDirection * startMiterRatio;
	vec2 endJoin = endJoinDirection * endMiterRatio;

	vec2 startTopJoin, startBotJoin, endTopJoin, endBotJoin;
	startTopJoin = sign(startJoinShift) * startJoin * .5;
	startBotJoin = -startTopJoin;

	endTopJoin = sign(endJoinShift) * endJoin * .5;
	endBotJoin = -endTopJoin;

	vec2 aTopCoord = aCoord + normalWidth * startTopJoin;
	vec2 bTopCoord = bCoord + normalWidth * endTopJoin;
	vec2 aBotCoord = aCoord + normalWidth * startBotJoin;
	vec2 bBotCoord = bCoord + normalWidth * endBotJoin;

	//miter anti-clipping
	float baClipping = distToLine(bCoord, aCoord, aBotCoord) / dot(normalize(normalWidth * endBotJoin), normalize(normalWidth.yx * vec2(-startBotJoin.y, startBotJoin.x)));
	float abClipping = distToLine(aCoord, bCoord, bTopCoord) / dot(normalize(normalWidth * startBotJoin), normalize(normalWidth.yx * vec2(-endBotJoin.y, endBotJoin.x)));

	//prevent close to reverse direction switch
	bool prevReverse = dot(currTangent, prevTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, prevNormal)) * min(length(prevDiff), length(currDiff)) <  length(normalWidth * currNormal);
	bool nextReverse = dot(currTangent, nextTangent) <= REVERSE_THRESHOLD && abs(dot(currTangent, nextNormal)) * min(length(nextDiff), length(currDiff)) <  length(normalWidth * currNormal);

	if (prevReverse) {
		//make join rectangular
		vec2 miterShift = normalWidth * startJoinDirection * miterLimit * .5;
		float normalAdjust = 1. - min(miterLimit / startMiterRatio, 1.);
		aBotCoord = aCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;
		aTopCoord = aCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;
	}
	else if (!nextReverse && baClipping > 0. && baClipping < length(normalWidth * endBotJoin)) {
		//handle miter clipping
		bTopCoord -= normalWidth * endTopJoin;
		bTopCoord += normalize(endTopJoin * normalWidth) * baClipping;
	}

	if (nextReverse) {
		//make join rectangular
		vec2 miterShift = normalWidth * endJoinDirection * miterLimit * .5;
		float normalAdjust = 1. - min(miterLimit / endMiterRatio, 1.);
		bBotCoord = bCoord + miterShift - normalAdjust * normalWidth * currNormal * .5;
		bTopCoord = bCoord + miterShift + normalAdjust * normalWidth * currNormal * .5;
	}
	else if (!prevReverse && abClipping > 0. && abClipping < length(normalWidth * startBotJoin)) {
		//handle miter clipping
		aBotCoord -= normalWidth * startBotJoin;
		aBotCoord += normalize(startBotJoin * normalWidth) * abClipping;
	}

	vec2 aTopPosition = (aTopCoord) * adjustedScale + translate;
	vec2 aBotPosition = (aBotCoord) * adjustedScale + translate;

	vec2 bTopPosition = (bTopCoord) * adjustedScale + translate;
	vec2 bBotPosition = (bBotCoord) * adjustedScale + translate;

	//position is normalized 0..1 coord on the screen
	vec2 position = (aTopPosition * lineTop + aBotPosition * lineBot) * lineStart + (bTopPosition * lineTop + bBotPosition * lineBot) * lineEnd;

	startCoord = aCoord * scaleRatio + translate * viewport.zw + viewport.xy;
	endCoord = bCoord * scaleRatio + translate * viewport.zw + viewport.xy;

	gl_Position = vec4(position  * 2.0 - 1.0, depth, 1);

	enableStartMiter = step(dot(currTangent, prevTangent), .5);
	enableEndMiter = step(dot(currTangent, nextTangent), .5);

	//bevel miter cutoffs
	if (miterMode == 1.) {
		if (enableStartMiter == 1.) {
			vec2 startMiterWidth = vec2(startJoinDirection) * thickness * miterLimit * .5;
			startCutoff = vec4(aCoord, aCoord);
			startCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;
			startCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;
			startCutoff += viewport.xyxy;
			startCutoff += startMiterWidth.xyxy;
		}

		if (enableEndMiter == 1.) {
			vec2 endMiterWidth = vec2(endJoinDirection) * thickness * miterLimit * .5;
			endCutoff = vec4(bCoord, bCoord);
			endCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;
			endCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;
			endCutoff += viewport.xyxy;
			endCutoff += endMiterWidth.xyxy;
		}
	}

	//round miter cutoffs
	else if (miterMode == 2.) {
		if (enableStartMiter == 1.) {
			vec2 startMiterWidth = vec2(startJoinDirection) * thickness * abs(dot(startJoinDirection, currNormal)) * .5;
			startCutoff = vec4(aCoord, aCoord);
			startCutoff.zw += vec2(-startJoinDirection.y, startJoinDirection.x) / scaleRatio;
			startCutoff = startCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;
			startCutoff += viewport.xyxy;
			startCutoff += startMiterWidth.xyxy;
		}

		if (enableEndMiter == 1.) {
			vec2 endMiterWidth = vec2(endJoinDirection) * thickness * abs(dot(endJoinDirection, currNormal)) * .5;
			endCutoff = vec4(bCoord, bCoord);
			endCutoff.zw += vec2(-endJoinDirection.y, endJoinDirection.x)  / scaleRatio;
			endCutoff = endCutoff * scaleRatio.xyxy + translate.xyxy * viewport.zwzw;
			endCutoff += viewport.xyxy;
			endCutoff += endMiterWidth.xyxy;
		}
	}
}
`, COt = `
precision highp float;

uniform float dashLength, pixelRatio, thickness, opacity, id, miterMode;
uniform sampler2D dashTexture;

varying vec4 fragColor;
varying vec2 tangent;
varying vec4 startCutoff, endCutoff;
varying vec2 startCoord, endCoord;
varying float enableStartMiter, enableEndMiter;

float distToLine(vec2 p, vec2 a, vec2 b) {
	vec2 diff = b - a;
	vec2 perp = normalize(vec2(-diff.y, diff.x));
	return dot(p - a, perp);
}

void main() {
	float alpha = 1., distToStart, distToEnd;
	float cutoff = thickness * .5;

	//bevel miter
	if (miterMode == 1.) {
		if (enableStartMiter == 1.) {
			distToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);
			if (distToStart < -1.) {
				discard;
				return;
			}
			alpha *= min(max(distToStart + 1., 0.), 1.);
		}

		if (enableEndMiter == 1.) {
			distToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);
			if (distToEnd < -1.) {
				discard;
				return;
			}
			alpha *= min(max(distToEnd + 1., 0.), 1.);
		}
	}

	// round miter
	else if (miterMode == 2.) {
		if (enableStartMiter == 1.) {
			distToStart = distToLine(gl_FragCoord.xy, startCutoff.xy, startCutoff.zw);
			if (distToStart < 0.) {
				float radius = length(gl_FragCoord.xy - startCoord);

				if(radius > cutoff + .5) {
					discard;
					return;
				}

				alpha -= smoothstep(cutoff - .5, cutoff + .5, radius);
			}
		}

		if (enableEndMiter == 1.) {
			distToEnd = distToLine(gl_FragCoord.xy, endCutoff.xy, endCutoff.zw);
			if (distToEnd < 0.) {
				float radius = length(gl_FragCoord.xy - endCoord);

				if(radius > cutoff + .5) {
					discard;
					return;
				}

				alpha -= smoothstep(cutoff - .5, cutoff + .5, radius);
			}
		}
	}

	float t = fract(dot(tangent, gl_FragCoord.xy) / dashLength) * .5 + .25;
	float dash = texture2D(dashTexture, vec2(t, .5)).r;

	gl_FragColor = fragColor;
	gl_FragColor.a *= alpha * opacity * dash;
}
`;
            iqe.exports = uc;
            function uc(e, t) {
                if (!(this instanceof uc)) return new uc(e, t);
                if (typeof e == "function" ? (t || (t = {}), t.regl = e) : t = e, t.length && (t.positions = t), e = t.regl, !e.hasExtension("ANGLE_instanced_arrays")) throw Error("regl-error2d: `ANGLE_instanced_arrays` extension should be enabled");
                this.gl = e._gl, this.regl = e, this.passes = [], this.shaders = uc.shaders.has(e) ? uc.shaders.get(e) : uc.shaders.set(e, uc.createShaders(e)).get(e), this.update(t);
            }
            uc.dashMult = 2;
            uc.maxPatternLength = 256;
            uc.precisionThreshold = 3e6;
            uc.maxPoints = 1e4;
            uc.maxLines = 2048;
            uc.shaders = new wOt;
            uc.createShaders = function(e) {
                let t = e.buffer({
                    usage: "static",
                    type: "float",
                    data: [
                        0,
                        1,
                        0,
                        0,
                        1,
                        1,
                        1,
                        0
                    ]
                }), r = {
                    primitive: "triangle strip",
                    instances: e.prop("count"),
                    count: 4,
                    offset: 0,
                    uniforms: {
                        miterMode: (o, s)=>s.join === "round" ? 2 : 1,
                        miterLimit: e.prop("miterLimit"),
                        scale: e.prop("scale"),
                        scaleFract: e.prop("scaleFract"),
                        translateFract: e.prop("translateFract"),
                        translate: e.prop("translate"),
                        thickness: e.prop("thickness"),
                        dashTexture: e.prop("dashTexture"),
                        opacity: e.prop("opacity"),
                        pixelRatio: e.context("pixelRatio"),
                        id: e.prop("id"),
                        dashLength: e.prop("dashLength"),
                        viewport: (o, s)=>[
                                s.viewport.x,
                                s.viewport.y,
                                o.viewportWidth,
                                o.viewportHeight
                            ],
                        depth: e.prop("depth")
                    },
                    blend: {
                        enable: !0,
                        color: [
                            0,
                            0,
                            0,
                            0
                        ],
                        equation: {
                            rgb: "add",
                            alpha: "add"
                        },
                        func: {
                            srcRGB: "src alpha",
                            dstRGB: "one minus src alpha",
                            srcAlpha: "one minus dst alpha",
                            dstAlpha: "one"
                        }
                    },
                    depth: {
                        enable: (o, s)=>!s.overlay
                    },
                    stencil: {
                        enable: !1
                    },
                    scissor: {
                        enable: !0,
                        box: e.prop("viewport")
                    },
                    viewport: e.prop("viewport")
                }, n = e(CY({
                    vert: AOt,
                    frag: SOt,
                    attributes: {
                        lineEnd: {
                            buffer: t,
                            divisor: 0,
                            stride: 8,
                            offset: 0
                        },
                        lineTop: {
                            buffer: t,
                            divisor: 0,
                            stride: 8,
                            offset: 4
                        },
                        aCoord: {
                            buffer: e.prop("positionBuffer"),
                            stride: 8,
                            offset: 8,
                            divisor: 1
                        },
                        bCoord: {
                            buffer: e.prop("positionBuffer"),
                            stride: 8,
                            offset: 16,
                            divisor: 1
                        },
                        aCoordFract: {
                            buffer: e.prop("positionFractBuffer"),
                            stride: 8,
                            offset: 8,
                            divisor: 1
                        },
                        bCoordFract: {
                            buffer: e.prop("positionFractBuffer"),
                            stride: 8,
                            offset: 16,
                            divisor: 1
                        },
                        color: {
                            buffer: e.prop("colorBuffer"),
                            stride: 4,
                            offset: 0,
                            divisor: 1
                        }
                    }
                }, r)), i;
                try {
                    i = e(CY({
                        cull: {
                            enable: !0,
                            face: "back"
                        },
                        vert: kOt,
                        frag: COt,
                        attributes: {
                            lineEnd: {
                                buffer: t,
                                divisor: 0,
                                stride: 8,
                                offset: 0
                            },
                            lineTop: {
                                buffer: t,
                                divisor: 0,
                                stride: 8,
                                offset: 4
                            },
                            aColor: {
                                buffer: e.prop("colorBuffer"),
                                stride: 4,
                                offset: 0,
                                divisor: 1
                            },
                            bColor: {
                                buffer: e.prop("colorBuffer"),
                                stride: 4,
                                offset: 4,
                                divisor: 1
                            },
                            prevCoord: {
                                buffer: e.prop("positionBuffer"),
                                stride: 8,
                                offset: 0,
                                divisor: 1
                            },
                            aCoord: {
                                buffer: e.prop("positionBuffer"),
                                stride: 8,
                                offset: 8,
                                divisor: 1
                            },
                            bCoord: {
                                buffer: e.prop("positionBuffer"),
                                stride: 8,
                                offset: 16,
                                divisor: 1
                            },
                            nextCoord: {
                                buffer: e.prop("positionBuffer"),
                                stride: 8,
                                offset: 24,
                                divisor: 1
                            }
                        }
                    }, r));
                } catch (o) {
                    i = n;
                }
                return {
                    fill: e({
                        primitive: "triangle",
                        elements: (o, s)=>s.triangles,
                        offset: 0,
                        vert: MOt,
                        frag: EOt,
                        uniforms: {
                            scale: e.prop("scale"),
                            color: e.prop("fill"),
                            scaleFract: e.prop("scaleFract"),
                            translateFract: e.prop("translateFract"),
                            translate: e.prop("translate"),
                            opacity: e.prop("opacity"),
                            pixelRatio: e.context("pixelRatio"),
                            id: e.prop("id"),
                            viewport: (o, s)=>[
                                    s.viewport.x,
                                    s.viewport.y,
                                    o.viewportWidth,
                                    o.viewportHeight
                                ]
                        },
                        attributes: {
                            position: {
                                buffer: e.prop("positionBuffer"),
                                stride: 8,
                                offset: 8
                            },
                            positionFract: {
                                buffer: e.prop("positionFractBuffer"),
                                stride: 8,
                                offset: 8
                            }
                        },
                        blend: r.blend,
                        depth: {
                            enable: !1
                        },
                        scissor: r.scissor,
                        stencil: r.stencil,
                        viewport: r.viewport
                    }),
                    rect: n,
                    miter: i
                };
            };
            uc.defaults = {
                dashes: null,
                join: "miter",
                miterLimit: 1,
                thickness: 10,
                cap: "square",
                color: "black",
                opacity: 1,
                overlay: !1,
                viewport: null,
                range: null,
                close: !1,
                fill: null
            };
            uc.prototype.render = function(...e) {
                e.length && this.update(...e), this.draw();
            };
            uc.prototype.draw = function(...e) {
                return (e.length ? e : this.passes).forEach((t, r)=>{
                    if (t && Array.isArray(t)) return this.draw(...t);
                    typeof t == "number" && (t = this.passes[t]), t && t.count > 1 && t.opacity && (this.regl._refresh(), t.fill && t.triangles && t.triangles.length > 2 && this.shaders.fill(t), t.thickness && (t.scale[0] * t.viewport.width > uc.precisionThreshold || t.scale[1] * t.viewport.height > uc.precisionThreshold ? this.shaders.rect(t) : t.join === "rect" || !t.join && (t.thickness <= 2 || t.count >= uc.maxPoints) ? this.shaders.rect(t) : this.shaders.miter(t)));
                }), this;
            };
            uc.prototype.update = function(e) {
                if (!e) return;
                e.length != null ? typeof e[0] == "number" && (e = [
                    {
                        positions: e
                    }
                ]) : Array.isArray(e) || (e = [
                    e
                ]);
                let { regl: t, gl: r } = this;
                if (e.forEach((i, a)=>{
                    let o = this.passes[a];
                    if (i !== void 0) {
                        if (i === null) {
                            this.passes[a] = null;
                            return;
                        }
                        if (typeof i[0] == "number" && (i = {
                            positions: i
                        }), i = yOt(i, {
                            positions: "positions points data coords",
                            thickness: "thickness lineWidth lineWidths line-width linewidth width stroke-width strokewidth strokeWidth",
                            join: "lineJoin linejoin join type mode",
                            miterLimit: "miterlimit miterLimit",
                            dashes: "dash dashes dasharray dash-array dashArray",
                            color: "color colour stroke colors colours stroke-color strokeColor",
                            fill: "fill fill-color fillColor",
                            opacity: "alpha opacity",
                            overlay: "overlay crease overlap intersect",
                            close: "closed close closed-path closePath",
                            range: "range dataBox",
                            viewport: "viewport viewBox",
                            hole: "holes hole hollow",
                            splitNull: "splitNull"
                        }), o || (this.passes[a] = o = {
                            id: a,
                            scale: null,
                            scaleFract: null,
                            translate: null,
                            translateFract: null,
                            count: 0,
                            hole: [],
                            depth: 0,
                            dashLength: 1,
                            dashTexture: t.texture({
                                channels: 1,
                                data: new Uint8Array([
                                    255
                                ]),
                                width: 1,
                                height: 1,
                                mag: "linear",
                                min: "linear"
                            }),
                            colorBuffer: t.buffer({
                                usage: "dynamic",
                                type: "uint8",
                                data: new Uint8Array
                            }),
                            positionBuffer: t.buffer({
                                usage: "dynamic",
                                type: "float",
                                data: new Uint8Array
                            }),
                            positionFractBuffer: t.buffer({
                                usage: "dynamic",
                                type: "float",
                                data: new Uint8Array
                            })
                        }, i = CY({}, uc.defaults, i)), i.thickness != null && (o.thickness = parseFloat(i.thickness)), i.opacity != null && (o.opacity = parseFloat(i.opacity)), i.miterLimit != null && (o.miterLimit = parseFloat(i.miterLimit)), i.overlay != null && (o.overlay = !!i.overlay, a < uc.maxLines && (o.depth = 2 * (uc.maxLines - 1 - a % uc.maxLines) / uc.maxLines - 1)), i.join != null && (o.join = i.join), i.hole != null && (o.hole = i.hole), i.fill != null && (o.fill = i.fill ? hF(i.fill, "uint8") : null), i.viewport != null && (o.viewport = rqe(i.viewport)), o.viewport || (o.viewport = rqe([
                            r.drawingBufferWidth,
                            r.drawingBufferHeight
                        ])), i.close != null && (o.close = i.close), i.positions === null && (i.positions = []), i.positions) {
                            let u, c;
                            if (i.positions.x && i.positions.y) {
                                let v = i.positions.x, x = i.positions.y;
                                c = o.count = Math.max(v.length, x.length), u = new Float64Array(c * 2);
                                for(let b = 0; b < c; b++)u[b * 2] = v[b], u[b * 2 + 1] = x[b];
                            } else u = _Ot(i.positions, "float64"), c = o.count = Math.floor(u.length / 2);
                            let f = o.bounds = mOt(u, 2);
                            if (o.fill) {
                                let v = [], x = {}, b = 0;
                                for(let p = 0, E = 0, k = o.count; p < k; p++){
                                    let A = u[p * 2], L = u[p * 2 + 1];
                                    isNaN(A) || isNaN(L) || A == null || L == null ? (A = u[b * 2], L = u[b * 2 + 1], x[p] = b) : b = p, v[E++] = A, v[E++] = L;
                                }
                                if (i.splitNull) {
                                    o.count - 1 in x || (x[o.count] = o.count - 1);
                                    let p = Object.keys(x).map(Number).sort((L, _)=>L - _), E = [], k = 0, A = o.hole != null ? o.hole[0] : null;
                                    if (A != null) {
                                        let L = TOt(p, (_)=>_ >= A);
                                        p = p.slice(0, L), p.push(A);
                                    }
                                    for(let L = 0; L < p.length; L++){
                                        let _ = v.slice(k * 2, p[L] * 2).concat(A ? v.slice(A * 2) : []), C = (o.hole || []).map((g)=>g - A + (p[L] - k)), M = tqe(_, C);
                                        M = M.map((g)=>g + k + (g + k < p[L] ? 0 : A - p[L])), E.push(...M), k = p[L] + 1;
                                    }
                                    for(let L = 0, _ = E.length; L < _; L++)x[E[L]] != null && (E[L] = x[E[L]]);
                                    o.triangles = E;
                                } else {
                                    let p = tqe(v, o.hole || []);
                                    for(let E = 0, k = p.length; E < k; E++)x[p[E]] != null && (p[E] = x[p[E]]);
                                    o.triangles = p;
                                }
                            }
                            let h = new Float64Array(u);
                            xOt(h, 2, f);
                            let d = new Float64Array(c * 2 + 6);
                            o.close ? u[0] === u[c * 2 - 2] && u[1] === u[c * 2 - 1] ? (d[0] = h[c * 2 - 4], d[1] = h[c * 2 - 3]) : (d[0] = h[c * 2 - 2], d[1] = h[c * 2 - 1]) : (d[0] = h[0], d[1] = h[1]), d.set(h, 2), o.close ? u[0] === u[c * 2 - 2] && u[1] === u[c * 2 - 1] ? (d[c * 2 + 2] = h[2], d[c * 2 + 3] = h[3], o.count -= 1) : (d[c * 2 + 2] = h[0], d[c * 2 + 3] = h[1], d[c * 2 + 4] = h[2], d[c * 2 + 5] = h[3]) : (d[c * 2 + 2] = h[c * 2 - 2], d[c * 2 + 3] = h[c * 2 - 1], d[c * 2 + 4] = h[c * 2 - 2], d[c * 2 + 5] = h[c * 2 - 1]);
                            var s = bOt(d);
                            o.positionBuffer(s);
                            var l = kY(d, s);
                            o.positionFractBuffer(l);
                        }
                        if (i.range ? o.range = i.range : o.range || (o.range = o.bounds), (i.range || i.positions) && o.count) {
                            let u = o.bounds, c = u[2] - u[0], f = u[3] - u[1], h = o.range[2] - o.range[0], d = o.range[3] - o.range[1];
                            o.scale = [
                                c / h,
                                f / d
                            ], o.translate = [
                                -o.range[0] / h + u[0] / h || 0,
                                -o.range[1] / d + u[1] / d || 0
                            ], o.scaleFract = kY(o.scale), o.translateFract = kY(o.translate);
                        }
                        if (i.dashes) {
                            let u = 0, c;
                            if (!i.dashes || i.dashes.length < 2) u = 1, c = new Uint8Array([
                                255,
                                255,
                                255,
                                255,
                                255,
                                255,
                                255,
                                255
                            ]);
                            else {
                                u = 0;
                                for(let d = 0; d < i.dashes.length; ++d)u += i.dashes[d];
                                c = new Uint8Array(u * uc.dashMult);
                                let f = 0, h = 255;
                                for(let d = 0; d < 2; d++)for(let v = 0; v < i.dashes.length; ++v){
                                    for(let x = 0, b = i.dashes[v] * uc.dashMult * .5; x < b; ++x)c[f++] = h;
                                    h ^= 255;
                                }
                            }
                            o.dashLength = u, o.dashTexture({
                                channels: 1,
                                data: c,
                                width: c.length,
                                height: 1,
                                mag: "linear",
                                min: "linear"
                            }, 0, 0);
                        }
                        if (i.color) {
                            let u = o.count, c = i.color;
                            c || (c = "transparent");
                            let f = new Uint8Array(u * 4 + 4);
                            if (!Array.isArray(c) || typeof c[0] == "number") {
                                let h = hF(c, "uint8");
                                for(let d = 0; d < u + 1; d++)f.set(h, d * 4);
                            } else {
                                for(let h = 0; h < u; h++){
                                    let d = hF(c[h], "uint8");
                                    f.set(d, h * 4);
                                }
                                f.set(hF(c[0], "uint8"), u * 4);
                            }
                            o.colorBuffer({
                                usage: "dynamic",
                                type: "uint8",
                                data: f
                            });
                        }
                    }
                }), e.length < this.passes.length) {
                    for(let i = e.length; i < this.passes.length; i++){
                        let a = this.passes[i];
                        a && (a.colorBuffer.destroy(), a.positionBuffer.destroy(), a.dashTexture.destroy());
                    }
                    this.passes.length = e.length;
                }
                let n = [];
                for(let i = 0; i < this.passes.length; i++)this.passes[i] !== null && n.push(this.passes[i]);
                return this.passes = n, this;
            };
            uc.prototype.destroy = function() {
                return this.passes.forEach((e)=>{
                    e.colorBuffer.destroy(), e.positionBuffer.destroy(), e.dashTexture.destroy();
                }), this.passes.length = 0, this;
            };
        });
        var lqe = ye((rmr, sqe)=>{
            "use strict";
            var LOt = j2(), POt = $_(), IOt = JX(), ROt = Zm(), nqe = bh(), aqe = W2(), { float32: DOt, fract32: PY } = Xz();
            sqe.exports = zOt;
            var oqe = [
                [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ],
                [
                    1,
                    0,
                    0,
                    -1,
                    0,
                    0
                ],
                [
                    -1,
                    0,
                    0,
                    -1,
                    0,
                    0
                ],
                [
                    -1,
                    0,
                    0,
                    -1,
                    0,
                    0
                ],
                [
                    -1,
                    0,
                    0,
                    1,
                    0,
                    0
                ],
                [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ],
                [
                    1,
                    0,
                    -1,
                    0,
                    0,
                    1
                ],
                [
                    1,
                    0,
                    -1,
                    0,
                    0,
                    -1
                ],
                [
                    1,
                    0,
                    1,
                    0,
                    0,
                    -1
                ],
                [
                    1,
                    0,
                    1,
                    0,
                    0,
                    -1
                ],
                [
                    1,
                    0,
                    1,
                    0,
                    0,
                    1
                ],
                [
                    1,
                    0,
                    -1,
                    0,
                    0,
                    1
                ],
                [
                    -1,
                    0,
                    -1,
                    0,
                    0,
                    1
                ],
                [
                    -1,
                    0,
                    -1,
                    0,
                    0,
                    -1
                ],
                [
                    -1,
                    0,
                    1,
                    0,
                    0,
                    -1
                ],
                [
                    -1,
                    0,
                    1,
                    0,
                    0,
                    -1
                ],
                [
                    -1,
                    0,
                    1,
                    0,
                    0,
                    1
                ],
                [
                    -1,
                    0,
                    -1,
                    0,
                    0,
                    1
                ],
                [
                    0,
                    1,
                    1,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    1,
                    -1,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    -1,
                    -1,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    -1,
                    -1,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    1,
                    1,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    -1,
                    1,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    1,
                    0,
                    -1,
                    1,
                    0
                ],
                [
                    0,
                    1,
                    0,
                    -1,
                    -1,
                    0
                ],
                [
                    0,
                    1,
                    0,
                    1,
                    -1,
                    0
                ],
                [
                    0,
                    1,
                    0,
                    1,
                    1,
                    0
                ],
                [
                    0,
                    1,
                    0,
                    -1,
                    1,
                    0
                ],
                [
                    0,
                    1,
                    0,
                    1,
                    -1,
                    0
                ],
                [
                    0,
                    -1,
                    0,
                    -1,
                    1,
                    0
                ],
                [
                    0,
                    -1,
                    0,
                    -1,
                    -1,
                    0
                ],
                [
                    0,
                    -1,
                    0,
                    1,
                    -1,
                    0
                ],
                [
                    0,
                    -1,
                    0,
                    1,
                    1,
                    0
                ],
                [
                    0,
                    -1,
                    0,
                    -1,
                    1,
                    0
                ],
                [
                    0,
                    -1,
                    0,
                    1,
                    -1,
                    0
                ]
            ];
            function zOt(e, t) {
                if (typeof e == "function" ? (t || (t = {}), t.regl = e) : t = e, t.length && (t.positions = t), e = t.regl, !e.hasExtension("ANGLE_instanced_arrays")) throw Error("regl-error2d: `ANGLE_instanced_arrays` extension should be enabled");
                let r = e._gl, n, i, a, o, s, l, u = {
                    color: "black",
                    capSize: 5,
                    lineWidth: 1,
                    opacity: 1,
                    viewport: null,
                    range: null,
                    offset: 0,
                    count: 0,
                    bounds: null,
                    positions: [],
                    errors: []
                }, c = [];
                return o = e.buffer({
                    usage: "dynamic",
                    type: "uint8",
                    data: new Uint8Array(0)
                }), i = e.buffer({
                    usage: "dynamic",
                    type: "float",
                    data: new Uint8Array(0)
                }), a = e.buffer({
                    usage: "dynamic",
                    type: "float",
                    data: new Uint8Array(0)
                }), s = e.buffer({
                    usage: "dynamic",
                    type: "float",
                    data: new Uint8Array(0)
                }), l = e.buffer({
                    usage: "static",
                    type: "float",
                    data: oqe
                }), v(t), n = e({
                    vert: `
		precision highp float;

		attribute vec2 position, positionFract;
		attribute vec4 error;
		attribute vec4 color;

		attribute vec2 direction, lineOffset, capOffset;

		uniform vec4 viewport;
		uniform float lineWidth, capSize;
		uniform vec2 scale, scaleFract, translate, translateFract;

		varying vec4 fragColor;

		void main() {
			fragColor = color / 255.;

			vec2 pixelOffset = lineWidth * lineOffset + (capSize + lineWidth) * capOffset;

			vec2 dxy = -step(.5, direction.xy) * error.xz + step(direction.xy, vec2(-.5)) * error.yw;

			vec2 position = position + dxy;

			vec2 pos = (position + translate) * scale
				+ (positionFract + translateFract) * scale
				+ (position + translate) * scaleFract
				+ (positionFract + translateFract) * scaleFract;

			pos += pixelOffset / viewport.zw;

			gl_Position = vec4(pos * 2. - 1., 0, 1);
		}
		`,
                    frag: `
		precision highp float;

		varying vec4 fragColor;

		uniform float opacity;

		void main() {
			gl_FragColor = fragColor;
			gl_FragColor.a *= opacity;
		}
		`,
                    uniforms: {
                        range: e.prop("range"),
                        lineWidth: e.prop("lineWidth"),
                        capSize: e.prop("capSize"),
                        opacity: e.prop("opacity"),
                        scale: e.prop("scale"),
                        translate: e.prop("translate"),
                        scaleFract: e.prop("scaleFract"),
                        translateFract: e.prop("translateFract"),
                        viewport: (b, p)=>[
                                p.viewport.x,
                                p.viewport.y,
                                b.viewportWidth,
                                b.viewportHeight
                            ]
                    },
                    attributes: {
                        color: {
                            buffer: o,
                            offset: (b, p)=>p.offset * 4,
                            divisor: 1
                        },
                        position: {
                            buffer: i,
                            offset: (b, p)=>p.offset * 8,
                            divisor: 1
                        },
                        positionFract: {
                            buffer: a,
                            offset: (b, p)=>p.offset * 8,
                            divisor: 1
                        },
                        error: {
                            buffer: s,
                            offset: (b, p)=>p.offset * 16,
                            divisor: 1
                        },
                        direction: {
                            buffer: l,
                            stride: 24,
                            offset: 0
                        },
                        lineOffset: {
                            buffer: l,
                            stride: 24,
                            offset: 8
                        },
                        capOffset: {
                            buffer: l,
                            stride: 24,
                            offset: 16
                        }
                    },
                    primitive: "triangles",
                    blend: {
                        enable: !0,
                        color: [
                            0,
                            0,
                            0,
                            0
                        ],
                        equation: {
                            rgb: "add",
                            alpha: "add"
                        },
                        func: {
                            srcRGB: "src alpha",
                            dstRGB: "one minus src alpha",
                            srcAlpha: "one minus dst alpha",
                            dstAlpha: "one"
                        }
                    },
                    depth: {
                        enable: !1
                    },
                    scissor: {
                        enable: !0,
                        box: e.prop("viewport")
                    },
                    viewport: e.prop("viewport"),
                    stencil: !1,
                    instances: e.prop("count"),
                    count: oqe.length
                }), nqe(f, {
                    update: v,
                    draw: h,
                    destroy: x,
                    regl: e,
                    gl: r,
                    canvas: r.canvas,
                    groups: c
                }), f;
                function f(b) {
                    b ? v(b) : b === null && x(), h();
                }
                function h(b) {
                    if (typeof b == "number") return d(b);
                    b && !Array.isArray(b) && (b = [
                        b
                    ]), e._refresh(), c.forEach((p, E)=>{
                        if (p) {
                            if (b && (b[E] ? p.draw = !0 : p.draw = !1), !p.draw) {
                                p.draw = !0;
                                return;
                            }
                            d(E);
                        }
                    });
                }
                function d(b) {
                    typeof b == "number" && (b = c[b]), b != null && b && b.count && b.color && b.opacity && b.positions && b.positions.length > 1 && (b.scaleRatio = [
                        b.scale[0] * b.viewport.width,
                        b.scale[1] * b.viewport.height
                    ], n(b), b.after && b.after(b));
                }
                function v(b) {
                    if (!b) return;
                    b.length != null ? typeof b[0] == "number" && (b = [
                        {
                            positions: b
                        }
                    ]) : Array.isArray(b) || (b = [
                        b
                    ]);
                    let p = 0, E = 0;
                    if (f.groups = c = b.map((L, _)=>{
                        let C = c[_];
                        if (L) typeof L == "function" ? L = {
                            after: L
                        } : typeof L[0] == "number" && (L = {
                            positions: L
                        });
                        else return C;
                        return L = ROt(L, {
                            color: "color colors fill",
                            capSize: "capSize cap capsize cap-size",
                            lineWidth: "lineWidth line-width width line thickness",
                            opacity: "opacity alpha",
                            range: "range dataBox",
                            viewport: "viewport viewBox",
                            errors: "errors error",
                            positions: "positions position data points"
                        }), C || (c[_] = C = {
                            id: _,
                            scale: null,
                            translate: null,
                            scaleFract: null,
                            translateFract: null,
                            draw: !0
                        }, L = nqe({}, u, L)), IOt(C, L, [
                            {
                                lineWidth: (M)=>+M * .5,
                                capSize: (M)=>+M * .5,
                                opacity: parseFloat,
                                errors: (M)=>(M = aqe(M), E += M.length, M),
                                positions: (M, g)=>(M = aqe(M, "float64"), g.count = Math.floor(M.length / 2), g.bounds = LOt(M, 2), g.offset = p, p += g.count, M)
                            },
                            {
                                color: (M, g)=>{
                                    let P = g.count;
                                    if (M || (M = "transparent"), !Array.isArray(M) || typeof M[0] == "number") {
                                        let F = M;
                                        M = Array(P);
                                        for(let q = 0; q < P; q++)M[q] = F;
                                    }
                                    if (M.length < P) throw Error("Not enough colors");
                                    let T = new Uint8Array(P * 4);
                                    for(let F = 0; F < P; F++){
                                        let q = POt(M[F], "uint8");
                                        T.set(q, F * 4);
                                    }
                                    return T;
                                },
                                range: (M, g, P)=>{
                                    let T = g.bounds;
                                    return M || (M = T), g.scale = [
                                        1 / (M[2] - M[0]),
                                        1 / (M[3] - M[1])
                                    ], g.translate = [
                                        -M[0],
                                        -M[1]
                                    ], g.scaleFract = PY(g.scale), g.translateFract = PY(g.translate), M;
                                },
                                viewport: (M)=>{
                                    let g;
                                    return Array.isArray(M) ? g = {
                                        x: M[0],
                                        y: M[1],
                                        width: M[2] - M[0],
                                        height: M[3] - M[1]
                                    } : M ? (g = {
                                        x: M.x || M.left || 0,
                                        y: M.y || M.top || 0
                                    }, M.right ? g.width = M.right - g.x : g.width = M.w || M.width || 0, M.bottom ? g.height = M.bottom - g.y : g.height = M.h || M.height || 0) : g = {
                                        x: 0,
                                        y: 0,
                                        width: r.drawingBufferWidth,
                                        height: r.drawingBufferHeight
                                    }, g;
                                }
                            }
                        ]), C;
                    }), p || E) {
                        let L = c.reduce((g, P, T)=>g + (P ? P.count : 0), 0), _ = new Float64Array(L * 2), C = new Uint8Array(L * 4), M = new Float32Array(L * 4);
                        c.forEach((g, P)=>{
                            if (!g) return;
                            let { positions: T, count: F, offset: q, color: V, errors: H } = g;
                            F && (C.set(V, q * 4), M.set(H, q * 4), _.set(T, q * 2));
                        });
                        var k = DOt(_);
                        i(k);
                        var A = PY(_, k);
                        a(A), o(C), s(M);
                    }
                }
                function x() {
                    i.destroy(), a.destroy(), o.destroy(), s.destroy(), l.destroy();
                }
            }
        });
        var fqe = ye((imr, cqe)=>{
            var uqe = /[\'\"]/;
            cqe.exports = function(t) {
                return t ? (uqe.test(t.charAt(0)) && (t = t.substr(1)), uqe.test(t.charAt(t.length - 1)) && (t = t.substr(0, t.length - 1)), t) : "";
            };
        });
        var IY = ye(()=>{});
        var RY = ye(()=>{});
        var DY = ye(()=>{});
        var zY = ye(()=>{});
        var FY = ye(()=>{});
        var pqe = ye((vmr, vqe)=>{
            "use strict";
            function hqe(e, t) {
                if (typeof e != "string") return [
                    e
                ];
                var r = [
                    e
                ];
                typeof t == "string" || Array.isArray(t) ? t = {
                    brackets: t
                } : t || (t = {});
                var n = t.brackets ? Array.isArray(t.brackets) ? t.brackets : [
                    t.brackets
                ] : [
                    "{}",
                    "[]",
                    "()"
                ], i = t.escape || "___", a = !!t.flat;
                n.forEach(function(l) {
                    var u = new RegExp([
                        "\\",
                        l[0],
                        "[^\\",
                        l[0],
                        "\\",
                        l[1],
                        "]*\\",
                        l[1]
                    ].join("")), c = [];
                    function f(h, d, v) {
                        var x = r.push(h.slice(l[0].length, -l[1].length)) - 1;
                        return c.push(x), i + x + i;
                    }
                    r.forEach(function(h, d) {
                        for(var v, x = 0; h != v;)if (v = h, h = h.replace(u, f), x++ > 1e4) throw Error("References have circular dependency. Please, check them.");
                        r[d] = h;
                    }), c = c.reverse(), r = r.map(function(h) {
                        return c.forEach(function(d) {
                            h = h.replace(new RegExp("(\\" + i + d + "\\" + i + ")", "g"), l[0] + "$1" + l[1]);
                        }), h;
                    });
                });
                var o = new RegExp("\\" + i + "([0-9]+)\\" + i);
                function s(l, u, c) {
                    for(var f = [], h, d = 0; h = o.exec(l);){
                        if (d++ > 1e4) throw Error("Circular references in parenthesis");
                        f.push(l.slice(0, h.index)), f.push(s(u[h[1]], u)), l = l.slice(h.index + h[0].length);
                    }
                    return f.push(l), f;
                }
                return a ? r : s(r[0], r);
            }
            function dqe(e, t) {
                if (t && t.flat) {
                    var r = t && t.escape || "___", n = e[0], i;
                    if (!n) return "";
                    for(var a = new RegExp("\\" + r + "([0-9]+)\\" + r), o = 0; n != i;){
                        if (o++ > 1e4) throw Error("Circular references in " + e);
                        i = n, n = n.replace(a, s);
                    }
                    return n;
                }
                return e.reduce(function l(u, c) {
                    return Array.isArray(c) && (c = c.reduce(l, "")), u + c;
                }, "");
                function s(l, u) {
                    if (e[u] == null) throw Error("Reference " + u + "is undefined");
                    return e[u];
                }
            }
            function qY(e, t) {
                return Array.isArray(e) ? dqe(e, t) : hqe(e, t);
            }
            qY.parse = hqe;
            qY.stringify = dqe;
            vqe.exports = qY;
        });
        var yqe = ye((pmr, mqe)=>{
            "use strict";
            var gqe = pqe();
            mqe.exports = function(t, r, n) {
                if (t == null) throw Error("First argument should be a string");
                if (r == null) throw Error("Separator should be a string or a RegExp");
                n ? (typeof n == "string" || Array.isArray(n)) && (n = {
                    ignore: n
                }) : n = {}, n.escape == null && (n.escape = !0), n.ignore == null ? n.ignore = [
                    "[]",
                    "()",
                    "{}",
                    "<>",
                    '""',
                    "''",
                    "``",
                    "\u201C\u201D",
                    "\xAB\xBB"
                ] : (typeof n.ignore == "string" && (n.ignore = [
                    n.ignore
                ]), n.ignore = n.ignore.map(function(f) {
                    return f.length === 1 && (f = f + f), f;
                }));
                var i = gqe.parse(t, {
                    flat: !0,
                    brackets: n.ignore
                }), a = i[0], o = a.split(r);
                if (n.escape) {
                    for(var s = [], l = 0; l < o.length; l++){
                        var u = o[l], c = o[l + 1];
                        u[u.length - 1] === "\\" && u[u.length - 2] !== "\\" ? (s.push(u + r + c), l++) : s.push(u);
                    }
                    o = s;
                }
                for(var l = 0; l < o.length; l++)i[0] = o[l], o[l] = gqe.stringify(i, {
                    flat: !0
                });
                return o;
            };
        });
        var _qe = ye(()=>{});
        var OY = ye((ymr, xqe)=>{
            "use strict";
            var FOt = _qe();
            xqe.exports = {
                isSize: function(t) {
                    return /^[\d\.]/.test(t) || t.indexOf("/") !== -1 || FOt.indexOf(t) !== -1;
                }
            };
        });
        var Aqe = ye((_mr, Tqe)=>{
            "use strict";
            var qOt = fqe(), OOt = IY(), BOt = RY(), NOt = DY(), UOt = zY(), VOt = FY(), BY = yqe(), HOt = OY().isSize;
            Tqe.exports = wqe;
            var gk = wqe.cache = {};
            function wqe(e) {
                if (typeof e != "string") throw new Error("Font argument must be a string.");
                if (gk[e]) return gk[e];
                if (e === "") throw new Error("Cannot parse an empty string.");
                if (BOt.indexOf(e) !== -1) return gk[e] = {
                    system: e
                };
                for(var t = {
                    style: "normal",
                    variant: "normal",
                    weight: "normal",
                    stretch: "normal",
                    lineHeight: "normal",
                    size: "1rem",
                    family: [
                        "serif"
                    ]
                }, r = BY(e, /\s+/), n; n = r.shift();){
                    if (OOt.indexOf(n) !== -1) return [
                        "style",
                        "variant",
                        "weight",
                        "stretch"
                    ].forEach(function(a) {
                        t[a] = n;
                    }), gk[e] = t;
                    if (UOt.indexOf(n) !== -1) {
                        t.style = n;
                        continue;
                    }
                    if (n === "normal" || n === "small-caps") {
                        t.variant = n;
                        continue;
                    }
                    if (VOt.indexOf(n) !== -1) {
                        t.stretch = n;
                        continue;
                    }
                    if (NOt.indexOf(n) !== -1) {
                        t.weight = n;
                        continue;
                    }
                    if (HOt(n)) {
                        var i = BY(n, "/");
                        if (t.size = i[0], i[1] != null ? t.lineHeight = bqe(i[1]) : r[0] === "/" && (r.shift(), t.lineHeight = bqe(r.shift())), !r.length) throw new Error("Missing required font-family.");
                        return t.family = BY(r.join(" "), /\s*,\s*/).map(qOt), gk[e] = t;
                    }
                    throw new Error("Unknown or unsupported font token: " + n);
                }
                throw new Error("Missing required font-size.");
            }
            function bqe(e) {
                var t = parseFloat(e);
                return t.toString() === e ? t : e;
            }
        });
        var UY = ye((xmr, Sqe)=>{
            "use strict";
            var GOt = Zm(), jOt = OY().isSize, WOt = yk(IY()), ZOt = yk(RY()), XOt = yk(DY()), YOt = yk(zY()), KOt = yk(FY()), JOt = {
                normal: 1,
                "small-caps": 1
            }, $Ot = {
                serif: 1,
                "sans-serif": 1,
                monospace: 1,
                cursive: 1,
                fantasy: 1,
                "system-ui": 1
            }, NY = {
                style: "normal",
                variant: "normal",
                weight: "normal",
                stretch: "normal",
                size: "1rem",
                lineHeight: "normal",
                family: "serif"
            };
            Sqe.exports = function(t) {
                if (t = GOt(t, {
                    style: "style fontstyle fontStyle font-style slope distinction",
                    variant: "variant font-variant fontVariant fontvariant var capitalization",
                    weight: "weight w font-weight fontWeight fontweight",
                    stretch: "stretch font-stretch fontStretch fontstretch width",
                    size: "size s font-size fontSize fontsize height em emSize",
                    lineHeight: "lh line-height lineHeight lineheight leading",
                    family: "font family fontFamily font-family fontfamily type typeface face",
                    system: "system reserved default global"
                }), t.system) return t.system && mk(t.system, ZOt), t.system;
                if (mk(t.style, YOt), mk(t.variant, JOt), mk(t.weight, XOt), mk(t.stretch, KOt), t.size == null && (t.size = NY.size), typeof t.size == "number" && (t.size += "px"), !jOt) throw Error("Bad size value `" + t.size + "`");
                t.family || (t.family = NY.family), Array.isArray(t.family) && (t.family.length || (t.family = [
                    NY.family
                ]), t.family = t.family.map(function(n) {
                    return $Ot[n] ? n : '"' + n + '"';
                }).join(", "));
                var r = [];
                return r.push(t.style), t.variant !== t.style && r.push(t.variant), t.weight !== t.variant && t.weight !== t.style && r.push(t.weight), t.stretch !== t.weight && t.stretch !== t.variant && t.stretch !== t.style && r.push(t.stretch), r.push(t.size + (t.lineHeight == null || t.lineHeight === "normal" || t.lineHeight + "" == "1" ? "" : "/" + t.lineHeight)), r.push(t.family), r.filter(Boolean).join(" ");
            };
            function mk(e, t) {
                if (e && !t[e] && !WOt[e]) throw Error("Unknown keyword `" + e + "`");
                return e;
            }
            function yk(e) {
                for(var t = {}, r = 0; r < e.length; r++)t[e[r]] = 1;
                return t;
            }
        });
        var Eqe = ye((bmr, Mqe)=>{
            "use strict";
            Mqe.exports = {
                parse: Aqe(),
                stringify: UY()
            };
        });
        var GY = ye((VY, HY)=>{
            (function(e, t) {
                typeof VY == "object" && typeof HY != "undefined" ? HY.exports = t() : e.createREGL = t();
            })(VY, function() {
                "use strict";
                var e = function(At, Er) {
                    for(var Wr = Object.keys(Er), wi = 0; wi < Wr.length; ++wi)At[Wr[wi]] = Er[Wr[wi]];
                    return At;
                }, t = 0, r = 0, n = 5, i = 6;
                function a(At, Er) {
                    this.id = t++, this.type = At, this.data = Er;
                }
                function o(At) {
                    return At.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                }
                function s(At) {
                    if (At.length === 0) return [];
                    var Er = At.charAt(0), Wr = At.charAt(At.length - 1);
                    if (At.length > 1 && Er === Wr && (Er === '"' || Er === "'")) return [
                        '"' + o(At.substr(1, At.length - 2)) + '"'
                    ];
                    var wi = /\[(false|true|null|\d+|'[^']*'|"[^"]*")\]/.exec(At);
                    if (wi) return s(At.substr(0, wi.index)).concat(s(wi[1])).concat(s(At.substr(wi.index + wi[0].length)));
                    var Ui = At.split(".");
                    if (Ui.length === 1) return [
                        '"' + o(At) + '"'
                    ];
                    for(var Oi = [], Bi = 0; Bi < Ui.length; ++Bi)Oi = Oi.concat(s(Ui[Bi]));
                    return Oi;
                }
                function l(At) {
                    return "[" + s(At).join("][") + "]";
                }
                function u(At, Er) {
                    return new a(At, l(Er + ""));
                }
                function c(At) {
                    return typeof At == "function" && !At._reglType || At instanceof a;
                }
                function f(At, Er) {
                    if (typeof At == "function") return new a(r, At);
                    if (typeof At == "number" || typeof At == "boolean") return new a(n, At);
                    if (Array.isArray(At)) return new a(i, At.map(function(Wr, wi) {
                        return f(Wr, Er + "[" + wi + "]");
                    }));
                    if (At instanceof a) return At;
                }
                var h = {
                    DynamicVariable: a,
                    define: u,
                    isDynamic: c,
                    unbox: f,
                    accessor: l
                }, d = {
                    next: typeof requestAnimationFrame == "function" ? function(At) {
                        return requestAnimationFrame(At);
                    } : function(At) {
                        return setTimeout(At, 16);
                    },
                    cancel: typeof cancelAnimationFrame == "function" ? function(At) {
                        return cancelAnimationFrame(At);
                    } : clearTimeout
                }, v = typeof performance != "undefined" && performance.now ? function() {
                    return performance.now();
                } : function() {
                    return +new Date;
                };
                function x() {
                    var At = {
                        "": 0
                    }, Er = [
                        ""
                    ];
                    return {
                        id: function(Wr) {
                            var wi = At[Wr];
                            return wi || (wi = At[Wr] = Er.length, Er.push(Wr), wi);
                        },
                        str: function(Wr) {
                            return Er[Wr];
                        }
                    };
                }
                function b(At, Er, Wr) {
                    var wi = document.createElement("canvas");
                    e(wi.style, {
                        border: 0,
                        margin: 0,
                        padding: 0,
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%"
                    }), At.appendChild(wi), At === document.body && (wi.style.position = "absolute", e(At.style, {
                        margin: 0,
                        padding: 0
                    }));
                    function Ui() {
                        var cn = window.innerWidth, On = window.innerHeight;
                        if (At !== document.body) {
                            var Bn = wi.getBoundingClientRect();
                            cn = Bn.right - Bn.left, On = Bn.bottom - Bn.top;
                        }
                        wi.width = Wr * cn, wi.height = Wr * On;
                    }
                    var Oi;
                    At !== document.body && typeof ResizeObserver == "function" ? (Oi = new ResizeObserver(function() {
                        setTimeout(Ui);
                    }), Oi.observe(At)) : window.addEventListener("resize", Ui, !1);
                    function Bi() {
                        Oi ? Oi.disconnect() : window.removeEventListener("resize", Ui), At.removeChild(wi);
                    }
                    return Ui(), {
                        canvas: wi,
                        onDestroy: Bi
                    };
                }
                function p(At, Er) {
                    function Wr(wi) {
                        try {
                            return At.getContext(wi, Er);
                        } catch (Ui) {
                            return null;
                        }
                    }
                    return Wr("webgl") || Wr("experimental-webgl") || Wr("webgl-experimental");
                }
                function E(At) {
                    return typeof At.nodeName == "string" && typeof At.appendChild == "function" && typeof At.getBoundingClientRect == "function";
                }
                function k(At) {
                    return typeof At.drawArrays == "function" || typeof At.drawElements == "function";
                }
                function A(At) {
                    return typeof At == "string" ? At.split() : At;
                }
                function L(At) {
                    return typeof At == "string" ? document.querySelector(At) : At;
                }
                function _(At) {
                    var Er = At || {}, Wr, wi, Ui, Oi, Bi = {}, cn = [], On = [], Bn = typeof window == "undefined" ? 1 : window.devicePixelRatio, yn = !1, to = {}, Rn = function(Ai) {}, Dn = function() {};
                    if (typeof Er == "string" ? Wr = document.querySelector(Er) : typeof Er == "object" && (E(Er) ? Wr = Er : k(Er) ? (Oi = Er, Ui = Oi.canvas) : ("gl" in Er ? Oi = Er.gl : "canvas" in Er ? Ui = L(Er.canvas) : "container" in Er && (wi = L(Er.container)), "attributes" in Er && (Bi = Er.attributes), "extensions" in Er && (cn = A(Er.extensions)), "optionalExtensions" in Er && (On = A(Er.optionalExtensions)), "onDone" in Er && (Rn = Er.onDone), "profile" in Er && (yn = !!Er.profile), "pixelRatio" in Er && (Bn = +Er.pixelRatio), "cachedCode" in Er && (to = Er.cachedCode))), Wr && (Wr.nodeName.toLowerCase() === "canvas" ? Ui = Wr : wi = Wr), !Oi) {
                        if (!Ui) {
                            var fn = b(wi || document.body, Rn, Bn);
                            if (!fn) return null;
                            Ui = fn.canvas, Dn = fn.onDestroy;
                        }
                        Bi.premultipliedAlpha === void 0 && (Bi.premultipliedAlpha = !0), Oi = p(Ui, Bi);
                    }
                    return Oi ? {
                        gl: Oi,
                        canvas: Ui,
                        container: wi,
                        extensions: cn,
                        optionalExtensions: On,
                        pixelRatio: Bn,
                        profile: yn,
                        cachedCode: to,
                        onDone: Rn,
                        onDestroy: Dn
                    } : (Dn(), Rn("webgl not supported, try upgrading your browser or graphics drivers http://get.webgl.org"), null);
                }
                function C(At, Er) {
                    var Wr = {};
                    function wi(Bi) {
                        var cn = Bi.toLowerCase(), On;
                        try {
                            On = Wr[cn] = At.getExtension(cn);
                        } catch (Bn) {}
                        return !!On;
                    }
                    for(var Ui = 0; Ui < Er.extensions.length; ++Ui){
                        var Oi = Er.extensions[Ui];
                        if (!wi(Oi)) return Er.onDestroy(), Er.onDone('"' + Oi + '" extension is not supported by the current WebGL context, try upgrading your system or a different browser'), null;
                    }
                    return Er.optionalExtensions.forEach(wi), {
                        extensions: Wr,
                        restore: function() {
                            Object.keys(Wr).forEach(function(Bi) {
                                if (Wr[Bi] && !wi(Bi)) throw new Error("(regl): error restoring extension " + Bi);
                            });
                        }
                    };
                }
                function M(At, Er) {
                    for(var Wr = Array(At), wi = 0; wi < At; ++wi)Wr[wi] = Er(wi);
                    return Wr;
                }
                var g = 5120, P = 5121, T = 5122, F = 5123, q = 5124, V = 5125, H = 5126;
                function X(At) {
                    for(var Er = 16; Er <= 268435456; Er *= 16)if (At <= Er) return Er;
                    return 0;
                }
                function G(At) {
                    var Er, Wr;
                    return Er = (At > 65535) << 4, At >>>= Er, Wr = (At > 255) << 3, At >>>= Wr, Er |= Wr, Wr = (At > 15) << 2, At >>>= Wr, Er |= Wr, Wr = (At > 3) << 1, At >>>= Wr, Er |= Wr, Er | At >> 1;
                }
                function N() {
                    var At = M(8, function() {
                        return [];
                    });
                    function Er(Oi) {
                        var Bi = X(Oi), cn = At[G(Bi) >> 2];
                        return cn.length > 0 ? cn.pop() : new ArrayBuffer(Bi);
                    }
                    function Wr(Oi) {
                        At[G(Oi.byteLength) >> 2].push(Oi);
                    }
                    function wi(Oi, Bi) {
                        var cn = null;
                        switch(Oi){
                            case g:
                                cn = new Int8Array(Er(Bi), 0, Bi);
                                break;
                            case P:
                                cn = new Uint8Array(Er(Bi), 0, Bi);
                                break;
                            case T:
                                cn = new Int16Array(Er(2 * Bi), 0, Bi);
                                break;
                            case F:
                                cn = new Uint16Array(Er(2 * Bi), 0, Bi);
                                break;
                            case q:
                                cn = new Int32Array(Er(4 * Bi), 0, Bi);
                                break;
                            case V:
                                cn = new Uint32Array(Er(4 * Bi), 0, Bi);
                                break;
                            case H:
                                cn = new Float32Array(Er(4 * Bi), 0, Bi);
                                break;
                            default:
                                return null;
                        }
                        return cn.length !== Bi ? cn.subarray(0, Bi) : cn;
                    }
                    function Ui(Oi) {
                        Wr(Oi.buffer);
                    }
                    return {
                        alloc: Er,
                        free: Wr,
                        allocType: wi,
                        freeType: Ui
                    };
                }
                var W = N();
                W.zero = N();
                var re = 3408, ae = 3410, _e = 3411, Me = 3412, ke = 3413, ge = 3414, ie = 3415, Te = 33901, Ee = 33902, Ae = 3379, ze = 3386, Ce = 34921, me = 36347, Re = 36348, ce = 35661, Ge = 35660, nt = 34930, ct = 36349, qt = 34076, rt = 34024, ot = 7936, Rt = 7937, kt = 7938, Ct = 35724, Yt = 34047, xr = 36063, er = 34852, Ke = 3553, xt = 34067, bt = 34069, Lt = 33984, St = 6408, Et = 5126, dt = 5121, Ht = 36160, $t = 36053, fr = 36064, _r = 16384, Br = function(At, Er) {
                    var Wr = 1;
                    Er.ext_texture_filter_anisotropic && (Wr = At.getParameter(Yt));
                    var wi = 1, Ui = 1;
                    Er.webgl_draw_buffers && (wi = At.getParameter(er), Ui = At.getParameter(xr));
                    var Oi = !!Er.oes_texture_float;
                    if (Oi) {
                        var Bi = At.createTexture();
                        At.bindTexture(Ke, Bi), At.texImage2D(Ke, 0, St, 1, 1, 0, St, Et, null);
                        var cn = At.createFramebuffer();
                        if (At.bindFramebuffer(Ht, cn), At.framebufferTexture2D(Ht, fr, Ke, Bi, 0), At.bindTexture(Ke, null), At.checkFramebufferStatus(Ht) !== $t) Oi = !1;
                        else {
                            At.viewport(0, 0, 1, 1), At.clearColor(1, 0, 0, 1), At.clear(_r);
                            var On = W.allocType(Et, 4);
                            At.readPixels(0, 0, 1, 1, St, Et, On), At.getError() ? Oi = !1 : (At.deleteFramebuffer(cn), At.deleteTexture(Bi), Oi = On[0] === 1), W.freeType(On);
                        }
                    }
                    var Bn = typeof navigator != "undefined" && (/MSIE/.test(navigator.userAgent) || /Trident\//.test(navigator.appVersion) || /Edge/.test(navigator.userAgent)), yn = !0;
                    if (!Bn) {
                        var to = At.createTexture(), Rn = W.allocType(dt, 36);
                        At.activeTexture(Lt), At.bindTexture(xt, to), At.texImage2D(bt, 0, St, 3, 3, 0, St, dt, Rn), W.freeType(Rn), At.bindTexture(xt, null), At.deleteTexture(to), yn = !At.getError();
                    }
                    return {
                        colorBits: [
                            At.getParameter(ae),
                            At.getParameter(_e),
                            At.getParameter(Me),
                            At.getParameter(ke)
                        ],
                        depthBits: At.getParameter(ge),
                        stencilBits: At.getParameter(ie),
                        subpixelBits: At.getParameter(re),
                        extensions: Object.keys(Er).filter(function(Dn) {
                            return !!Er[Dn];
                        }),
                        maxAnisotropic: Wr,
                        maxDrawbuffers: wi,
                        maxColorAttachments: Ui,
                        pointSizeDims: At.getParameter(Te),
                        lineWidthDims: At.getParameter(Ee),
                        maxViewportDims: At.getParameter(ze),
                        maxCombinedTextureUnits: At.getParameter(ce),
                        maxCubeMapSize: At.getParameter(qt),
                        maxRenderbufferSize: At.getParameter(rt),
                        maxTextureUnits: At.getParameter(nt),
                        maxTextureSize: At.getParameter(Ae),
                        maxAttributes: At.getParameter(Ce),
                        maxVertexUniforms: At.getParameter(me),
                        maxVertexTextureUnits: At.getParameter(Ge),
                        maxVaryingVectors: At.getParameter(Re),
                        maxFragmentUniforms: At.getParameter(ct),
                        glsl: At.getParameter(Ct),
                        renderer: At.getParameter(Rt),
                        vendor: At.getParameter(ot),
                        version: At.getParameter(kt),
                        readFloat: Oi,
                        npotTextureCube: yn
                    };
                }, Or = function(At) {
                    return At instanceof Uint8Array || At instanceof Uint16Array || At instanceof Uint32Array || At instanceof Int8Array || At instanceof Int16Array || At instanceof Int32Array || At instanceof Float32Array || At instanceof Float64Array || At instanceof Uint8ClampedArray;
                };
                function Nr(At) {
                    return !!At && typeof At == "object" && Array.isArray(At.shape) && Array.isArray(At.stride) && typeof At.offset == "number" && At.shape.length === At.stride.length && (Array.isArray(At.data) || Or(At.data));
                }
                var ut = function(At) {
                    return Object.keys(At).map(function(Er) {
                        return At[Er];
                    });
                }, Ne = {
                    shape: xe,
                    flatten: Le
                };
                function Ye(At, Er, Wr) {
                    for(var wi = 0; wi < Er; ++wi)Wr[wi] = At[wi];
                }
                function Ve(At, Er, Wr, wi) {
                    for(var Ui = 0, Oi = 0; Oi < Er; ++Oi)for(var Bi = At[Oi], cn = 0; cn < Wr; ++cn)wi[Ui++] = Bi[cn];
                }
                function Xe(At, Er, Wr, wi, Ui, Oi) {
                    for(var Bi = Oi, cn = 0; cn < Er; ++cn)for(var On = At[cn], Bn = 0; Bn < Wr; ++Bn)for(var yn = On[Bn], to = 0; to < wi; ++to)Ui[Bi++] = yn[to];
                }
                function ht(At, Er, Wr, wi, Ui) {
                    for(var Oi = 1, Bi = Wr + 1; Bi < Er.length; ++Bi)Oi *= Er[Bi];
                    var cn = Er[Wr];
                    if (Er.length - Wr === 4) {
                        var On = Er[Wr + 1], Bn = Er[Wr + 2], yn = Er[Wr + 3];
                        for(Bi = 0; Bi < cn; ++Bi)Xe(At[Bi], On, Bn, yn, wi, Ui), Ui += Oi;
                    } else for(Bi = 0; Bi < cn; ++Bi)ht(At[Bi], Er, Wr + 1, wi, Ui), Ui += Oi;
                }
                function Le(At, Er, Wr, wi) {
                    var Ui = 1;
                    if (Er.length) for(var Oi = 0; Oi < Er.length; ++Oi)Ui *= Er[Oi];
                    else Ui = 0;
                    var Bi = wi || W.allocType(Wr, Ui);
                    switch(Er.length){
                        case 0:
                            break;
                        case 1:
                            Ye(At, Er[0], Bi);
                            break;
                        case 2:
                            Ve(At, Er[0], Er[1], Bi);
                            break;
                        case 3:
                            Xe(At, Er[0], Er[1], Er[2], Bi, 0);
                            break;
                        default:
                            ht(At, Er, 0, Bi, 0);
                    }
                    return Bi;
                }
                function xe(At) {
                    for(var Er = [], Wr = At; Wr.length; Wr = Wr[0])Er.push(Wr.length);
                    return Er;
                }
                var Se = {
                    "[object Int8Array]": 5120,
                    "[object Int16Array]": 5122,
                    "[object Int32Array]": 5124,
                    "[object Uint8Array]": 5121,
                    "[object Uint8ClampedArray]": 5121,
                    "[object Uint16Array]": 5123,
                    "[object Uint32Array]": 5125,
                    "[object Float32Array]": 5126,
                    "[object Float64Array]": 5121,
                    "[object ArrayBuffer]": 5121
                }, lt = 5120, Gt = 5122, Vt = 5124, ar = 5121, Qr = 5123, ai = 5125, jr = 5126, ri = 5126, bi = {
                    int8: lt,
                    int16: Gt,
                    int32: Vt,
                    uint8: ar,
                    uint16: Qr,
                    uint32: ai,
                    float: jr,
                    float32: ri
                }, nn = 35048, Wi = 35040, Ni = {
                    dynamic: nn,
                    stream: Wi,
                    static: 35044
                }, _n = Ne.flatten, $i = Ne.shape, zn = 35044, Wn = 35040, It = 5121, ft = 5126, jt = [];
                jt[5120] = 1, jt[5122] = 2, jt[5124] = 4, jt[5121] = 1, jt[5123] = 2, jt[5125] = 4, jt[5126] = 4;
                function Zt(At) {
                    return Se[Object.prototype.toString.call(At)] | 0;
                }
                function yr(At, Er) {
                    for(var Wr = 0; Wr < Er.length; ++Wr)At[Wr] = Er[Wr];
                }
                function Fr(At, Er, Wr, wi, Ui, Oi, Bi) {
                    for(var cn = 0, On = 0; On < Wr; ++On)for(var Bn = 0; Bn < wi; ++Bn)At[cn++] = Er[Ui * On + Oi * Bn + Bi];
                }
                function Zr(At, Er, Wr, wi) {
                    var Ui = 0, Oi = {};
                    function Bi(Ai) {
                        this.id = Ui++, this.buffer = At.createBuffer(), this.type = Ai, this.usage = zn, this.byteLength = 0, this.dimension = 1, this.dtype = It, this.persistentData = null, Wr.profile && (this.stats = {
                            size: 0
                        });
                    }
                    Bi.prototype.bind = function() {
                        At.bindBuffer(this.type, this.buffer);
                    }, Bi.prototype.destroy = function() {
                        Rn(this);
                    };
                    var cn = [];
                    function On(Ai, ji) {
                        var Ln = cn.pop();
                        return Ln || (Ln = new Bi(Ai)), Ln.bind(), to(Ln, ji, Wn, 0, 1, !1), Ln;
                    }
                    function Bn(Ai) {
                        cn.push(Ai);
                    }
                    function yn(Ai, ji, Ln) {
                        Ai.byteLength = ji.byteLength, At.bufferData(Ai.type, ji, Ln);
                    }
                    function to(Ai, ji, Ln, Un, gn, ca) {
                        var Kn;
                        if (Ai.usage = Ln, Array.isArray(ji)) {
                            if (Ai.dtype = Un || ft, ji.length > 0) {
                                var Za;
                                if (Array.isArray(ji[0])) {
                                    Kn = $i(ji);
                                    for(var wn = 1, vn = 1; vn < Kn.length; ++vn)wn *= Kn[vn];
                                    Ai.dimension = wn, Za = _n(ji, Kn, Ai.dtype), yn(Ai, Za, Ln), ca ? Ai.persistentData = Za : W.freeType(Za);
                                } else if (typeof ji[0] == "number") {
                                    Ai.dimension = gn;
                                    var Aa = W.allocType(Ai.dtype, ji.length);
                                    yr(Aa, ji), yn(Ai, Aa, Ln), ca ? Ai.persistentData = Aa : W.freeType(Aa);
                                } else Or(ji[0]) && (Ai.dimension = ji[0].length, Ai.dtype = Un || Zt(ji[0]) || ft, Za = _n(ji, [
                                    ji.length,
                                    ji[0].length
                                ], Ai.dtype), yn(Ai, Za, Ln), ca ? Ai.persistentData = Za : W.freeType(Za));
                            }
                        } else if (Or(ji)) Ai.dtype = Un || Zt(ji), Ai.dimension = gn, yn(Ai, ji, Ln), ca && (Ai.persistentData = new Uint8Array(new Uint8Array(ji.buffer)));
                        else if (Nr(ji)) {
                            Kn = ji.shape;
                            var aa = ji.stride, Xn = ji.offset, Vn = 0, ma = 0, ro = 0, Ao = 0;
                            Kn.length === 1 ? (Vn = Kn[0], ma = 1, ro = aa[0], Ao = 0) : Kn.length === 2 && (Vn = Kn[0], ma = Kn[1], ro = aa[0], Ao = aa[1]), Ai.dtype = Un || Zt(ji.data) || ft, Ai.dimension = ma;
                            var Jn = W.allocType(Ai.dtype, Vn * ma);
                            Fr(Jn, ji.data, Vn, ma, ro, Ao, Xn), yn(Ai, Jn, Ln), ca ? Ai.persistentData = Jn : W.freeType(Jn);
                        } else ji instanceof ArrayBuffer && (Ai.dtype = It, Ai.dimension = gn, yn(Ai, ji, Ln), ca && (Ai.persistentData = new Uint8Array(new Uint8Array(ji))));
                    }
                    function Rn(Ai) {
                        Er.bufferCount--, wi(Ai);
                        var ji = Ai.buffer;
                        At.deleteBuffer(ji), Ai.buffer = null, delete Oi[Ai.id];
                    }
                    function Dn(Ai, ji, Ln, Un) {
                        Er.bufferCount++;
                        var gn = new Bi(ji);
                        Oi[gn.id] = gn;
                        function ca(wn) {
                            var vn = zn, Aa = null, aa = 0, Xn = 0, Vn = 1;
                            return Array.isArray(wn) || Or(wn) || Nr(wn) || wn instanceof ArrayBuffer ? Aa = wn : typeof wn == "number" ? aa = wn | 0 : wn && ("data" in wn && (Aa = wn.data), "usage" in wn && (vn = Ni[wn.usage]), "type" in wn && (Xn = bi[wn.type]), "dimension" in wn && (Vn = wn.dimension | 0), "length" in wn && (aa = wn.length | 0)), gn.bind(), Aa ? to(gn, Aa, vn, Xn, Vn, Un) : (aa && At.bufferData(gn.type, aa, vn), gn.dtype = Xn || It, gn.usage = vn, gn.dimension = Vn, gn.byteLength = aa), Wr.profile && (gn.stats.size = gn.byteLength * jt[gn.dtype]), ca;
                        }
                        function Kn(wn, vn) {
                            At.bufferSubData(gn.type, vn, wn);
                        }
                        function Za(wn, vn) {
                            var Aa = (vn || 0) | 0, aa;
                            if (gn.bind(), Or(wn) || wn instanceof ArrayBuffer) Kn(wn, Aa);
                            else if (Array.isArray(wn)) {
                                if (wn.length > 0) {
                                    if (typeof wn[0] == "number") {
                                        var Xn = W.allocType(gn.dtype, wn.length);
                                        yr(Xn, wn), Kn(Xn, Aa), W.freeType(Xn);
                                    } else if (Array.isArray(wn[0]) || Or(wn[0])) {
                                        aa = $i(wn);
                                        var Vn = _n(wn, aa, gn.dtype);
                                        Kn(Vn, Aa), W.freeType(Vn);
                                    }
                                }
                            } else if (Nr(wn)) {
                                aa = wn.shape;
                                var ma = wn.stride, ro = 0, Ao = 0, Jn = 0, Oa = 0;
                                aa.length === 1 ? (ro = aa[0], Ao = 1, Jn = ma[0], Oa = 0) : aa.length === 2 && (ro = aa[0], Ao = aa[1], Jn = ma[0], Oa = ma[1]);
                                var _o = Array.isArray(wn.data) ? gn.dtype : Zt(wn.data), Po = W.allocType(_o, ro * Ao);
                                Fr(Po, wn.data, ro, Ao, Jn, Oa, wn.offset), Kn(Po, Aa), W.freeType(Po);
                            }
                            return ca;
                        }
                        return Ln || ca(Ai), ca._reglType = "buffer", ca._buffer = gn, ca.subdata = Za, Wr.profile && (ca.stats = gn.stats), ca.destroy = function() {
                            Rn(gn);
                        }, ca;
                    }
                    function fn() {
                        ut(Oi).forEach(function(Ai) {
                            Ai.buffer = At.createBuffer(), At.bindBuffer(Ai.type, Ai.buffer), At.bufferData(Ai.type, Ai.persistentData || Ai.byteLength, Ai.usage);
                        });
                    }
                    return Wr.profile && (Er.getTotalBufferSize = function() {
                        var Ai = 0;
                        return Object.keys(Oi).forEach(function(ji) {
                            Ai += Oi[ji].stats.size;
                        }), Ai;
                    }), {
                        create: Dn,
                        createStream: On,
                        destroyStream: Bn,
                        clear: function() {
                            ut(Oi).forEach(Rn), cn.forEach(Rn);
                        },
                        getBuffer: function(Ai) {
                            return Ai && Ai._buffer instanceof Bi ? Ai._buffer : null;
                        },
                        restore: fn,
                        _initBuffer: to
                    };
                }
                var Vr = 0, gi = 0, Si = 1, Mi = 1, Pi = 4, Gi = 4, Ki = {
                    points: Vr,
                    point: gi,
                    lines: Si,
                    line: Mi,
                    triangles: Pi,
                    triangle: Gi,
                    "line loop": 2,
                    "line strip": 3,
                    "triangle strip": 5,
                    "triangle fan": 6
                }, ka = 0, jn = 1, la = 4, Fa = 5120, Ra = 5121, jo = 5122, oa = 5123, Sn = 5124, Ha = 5125, oo = 34963, xn = 35040, _t = 35044;
                function br(At, Er, Wr, wi) {
                    var Ui = {}, Oi = 0, Bi = {
                        uint8: Ra,
                        uint16: oa
                    };
                    Er.oes_element_index_uint && (Bi.uint32 = Ha);
                    function cn(fn) {
                        this.id = Oi++, Ui[this.id] = this, this.buffer = fn, this.primType = la, this.vertCount = 0, this.type = 0;
                    }
                    cn.prototype.bind = function() {
                        this.buffer.bind();
                    };
                    var On = [];
                    function Bn(fn) {
                        var Ai = On.pop();
                        return Ai || (Ai = new cn(Wr.create(null, oo, !0, !1)._buffer)), to(Ai, fn, xn, -1, -1, 0, 0), Ai;
                    }
                    function yn(fn) {
                        On.push(fn);
                    }
                    function to(fn, Ai, ji, Ln, Un, gn, ca) {
                        fn.buffer.bind();
                        var Kn;
                        if (Ai) {
                            var Za = ca;
                            !ca && (!Or(Ai) || Nr(Ai) && !Or(Ai.data)) && (Za = Er.oes_element_index_uint ? Ha : oa), Wr._initBuffer(fn.buffer, Ai, ji, Za, 3);
                        } else At.bufferData(oo, gn, ji), fn.buffer.dtype = Kn || Ra, fn.buffer.usage = ji, fn.buffer.dimension = 3, fn.buffer.byteLength = gn;
                        if (Kn = ca, !ca) {
                            switch(fn.buffer.dtype){
                                case Ra:
                                case Fa:
                                    Kn = Ra;
                                    break;
                                case oa:
                                case jo:
                                    Kn = oa;
                                    break;
                                case Ha:
                                case Sn:
                                    Kn = Ha;
                                    break;
                                default:
                            }
                            fn.buffer.dtype = Kn;
                        }
                        fn.type = Kn;
                        var wn = Un;
                        wn < 0 && (wn = fn.buffer.byteLength, Kn === oa ? wn >>= 1 : Kn === Ha && (wn >>= 2)), fn.vertCount = wn;
                        var vn = Ln;
                        if (Ln < 0) {
                            vn = la;
                            var Aa = fn.buffer.dimension;
                            Aa === 1 && (vn = ka), Aa === 2 && (vn = jn), Aa === 3 && (vn = la);
                        }
                        fn.primType = vn;
                    }
                    function Rn(fn) {
                        wi.elementsCount--, delete Ui[fn.id], fn.buffer.destroy(), fn.buffer = null;
                    }
                    function Dn(fn, Ai) {
                        var ji = Wr.create(null, oo, !0), Ln = new cn(ji._buffer);
                        wi.elementsCount++;
                        function Un(gn) {
                            if (!gn) ji(), Ln.primType = la, Ln.vertCount = 0, Ln.type = Ra;
                            else if (typeof gn == "number") ji(gn), Ln.primType = la, Ln.vertCount = gn | 0, Ln.type = Ra;
                            else {
                                var ca = null, Kn = _t, Za = -1, wn = -1, vn = 0, Aa = 0;
                                Array.isArray(gn) || Or(gn) || Nr(gn) ? ca = gn : ("data" in gn && (ca = gn.data), "usage" in gn && (Kn = Ni[gn.usage]), "primitive" in gn && (Za = Ki[gn.primitive]), "count" in gn && (wn = gn.count | 0), "type" in gn && (Aa = Bi[gn.type]), "length" in gn ? vn = gn.length | 0 : (vn = wn, Aa === oa || Aa === jo ? vn *= 2 : (Aa === Ha || Aa === Sn) && (vn *= 4))), to(Ln, ca, Kn, Za, wn, vn, Aa);
                            }
                            return Un;
                        }
                        return Un(fn), Un._reglType = "elements", Un._elements = Ln, Un.subdata = function(gn, ca) {
                            return ji.subdata(gn, ca), Un;
                        }, Un.destroy = function() {
                            Rn(Ln);
                        }, Un;
                    }
                    return {
                        create: Dn,
                        createStream: Bn,
                        destroyStream: yn,
                        getElements: function(fn) {
                            return typeof fn == "function" && fn._elements instanceof cn ? fn._elements : null;
                        },
                        clear: function() {
                            ut(Ui).forEach(Rn);
                        }
                    };
                }
                var Hr = new Float32Array(1), ti = new Uint32Array(Hr.buffer), zi = 5123;
                function Yi(At) {
                    for(var Er = W.allocType(zi, At.length), Wr = 0; Wr < At.length; ++Wr)if (isNaN(At[Wr])) Er[Wr] = 65535;
                    else if (At[Wr] === 1 / 0) Er[Wr] = 31744;
                    else if (At[Wr] === -1 / 0) Er[Wr] = 64512;
                    else {
                        Hr[0] = At[Wr];
                        var wi = ti[0], Ui = wi >>> 31 << 15, Oi = (wi << 1 >>> 24) - 127, Bi = wi >> 13 & 1023;
                        if (Oi < -24) Er[Wr] = Ui;
                        else if (Oi < -14) {
                            var cn = -14 - Oi;
                            Er[Wr] = Ui + (Bi + 1024 >> cn);
                        } else Oi > 15 ? Er[Wr] = Ui + 31744 : Er[Wr] = Ui + (Oi + 15 << 10) + Bi;
                    }
                    return Er;
                }
                function an(At) {
                    return Array.isArray(At) || Or(At);
                }
                var hi = 34467, Ji = 3553, ua = 34067, Fn = 34069, Sa = 6408, go = 6406, Oo = 6407, ho = 6409, Mo = 6410, xo = 32854, zs = 32855, ks = 36194, Zs = 32819, Xs = 32820, wl = 33635, os = 34042, cl = 6402, Cs = 34041, ml = 35904, Ys = 35906, Hs = 36193, Eo = 33776, fs = 33777, Ql = 33778, Hu = 33779, fc = 35986, ms = 35987, on = 34798, fa = 35840, Qu = 35841, Rl = 35842, vo = 35843, Zl = 36196, Ks = 5121, Xl = 5123, Ec = 5125, Zn = 5126, ko = 10242, Co = 10243, Tl = 10497, uf = 33071, So = 33648, cf = 10240, rh = 10241, Al = 9728, Hc = 9729, eu = 9984, Ls = 9985, mu = 9986, kc = 9987, Of = 33170, Gc = 4352, vd = 4353, Bf = 4354, ss = 34046, ff = 3317, ih = 37440, Vl = 37441, Js = 37443, hc = 37444, Cc = 33984, ws = [
                    eu,
                    mu,
                    Ls,
                    kc
                ], $s = [
                    0,
                    ho,
                    Mo,
                    Oo,
                    Sa
                ], hs = {};
                hs[ho] = hs[go] = hs[cl] = 1, hs[Cs] = hs[Mo] = 2, hs[Oo] = hs[ml] = 3, hs[Sa] = hs[Ys] = 4;
                function Ms(At) {
                    return "[object " + At + "]";
                }
                var dc = Ms("HTMLCanvasElement"), Sl = Ms("OffscreenCanvas"), ec = Ms("CanvasRenderingContext2D"), Ps = Ms("ImageBitmap"), ov = Ms("HTMLImageElement"), wo = Ms("HTMLVideoElement"), Od = Object.keys(Se).concat([
                    dc,
                    Sl,
                    ec,
                    Ps,
                    ov,
                    wo
                ]), $o = [];
                $o[Ks] = 1, $o[Zn] = 4, $o[Hs] = 2, $o[Xl] = 2, $o[Ec] = 4;
                var Ja = [];
                Ja[xo] = 2, Ja[zs] = 2, Ja[ks] = 2, Ja[Cs] = 4, Ja[Eo] = .5, Ja[fs] = .5, Ja[Ql] = 1, Ja[Hu] = 1, Ja[fc] = .5, Ja[ms] = 1, Ja[on] = 1, Ja[fa] = .5, Ja[Qu] = .25, Ja[Rl] = .5, Ja[vo] = .25, Ja[Zl] = .5;
                function Ef(At) {
                    return Array.isArray(At) && (At.length === 0 || typeof At[0] == "number");
                }
                function tc(At) {
                    if (!Array.isArray(At)) return !1;
                    var Er = At.length;
                    return !(Er === 0 || !an(At[0]));
                }
                function uu(At) {
                    return Object.prototype.toString.call(At);
                }
                function Mh(At) {
                    return uu(At) === dc;
                }
                function jc(At) {
                    return uu(At) === Sl;
                }
                function kf(At) {
                    return uu(At) === ec;
                }
                function Ml(At) {
                    return uu(At) === Ps;
                }
                function Yh(At) {
                    return uu(At) === ov;
                }
                function Eh(At) {
                    return uu(At) === wo;
                }
                function nh(At) {
                    if (!At) return !1;
                    var Er = uu(At);
                    return Od.indexOf(Er) >= 0 ? !0 : Ef(At) || tc(At) || Nr(At);
                }
                function hf(At) {
                    return Se[Object.prototype.toString.call(At)] | 0;
                }
                function kh(At, Er) {
                    var Wr = Er.length;
                    switch(At.type){
                        case Ks:
                        case Xl:
                        case Ec:
                        case Zn:
                            var wi = W.allocType(At.type, Wr);
                            wi.set(Er), At.data = wi;
                            break;
                        case Hs:
                            At.data = Yi(Er);
                            break;
                        default:
                    }
                }
                function Kh(At, Er) {
                    return W.allocType(At.type === Hs ? Zn : At.type, Er);
                }
                function rc(At, Er) {
                    At.type === Hs ? (At.data = Yi(Er), W.freeType(Er)) : At.data = Er;
                }
                function ah(At, Er, Wr, wi, Ui, Oi) {
                    for(var Bi = At.width, cn = At.height, On = At.channels, Bn = Bi * cn * On, yn = Kh(At, Bn), to = 0, Rn = 0; Rn < cn; ++Rn)for(var Dn = 0; Dn < Bi; ++Dn)for(var fn = 0; fn < On; ++fn)yn[to++] = Er[Wr * Dn + wi * Rn + Ui * fn + Oi];
                    rc(At, yn);
                }
                function Wc(At, Er, Wr, wi, Ui, Oi) {
                    var Bi;
                    if (typeof Ja[At] != "undefined" ? Bi = Ja[At] : Bi = hs[At] * $o[Er], Oi && (Bi *= 6), Ui) {
                        for(var cn = 0, On = Wr; On >= 1;)cn += Bi * On * On, On /= 2;
                        return cn;
                    } else return Bi * Wr * wi;
                }
                function df(At, Er, Wr, wi, Ui, Oi, Bi) {
                    var cn = {
                        "don't care": Gc,
                        "dont care": Gc,
                        nice: Bf,
                        fast: vd
                    }, On = {
                        repeat: Tl,
                        clamp: uf,
                        mirror: So
                    }, Bn = {
                        nearest: Al,
                        linear: Hc
                    }, yn = e({
                        mipmap: kc,
                        "nearest mipmap nearest": eu,
                        "linear mipmap nearest": Ls,
                        "nearest mipmap linear": mu,
                        "linear mipmap linear": kc
                    }, Bn), to = {
                        none: 0,
                        browser: hc
                    }, Rn = {
                        uint8: Ks,
                        rgba4: Zs,
                        rgb565: wl,
                        "rgb5 a1": Xs
                    }, Dn = {
                        alpha: go,
                        luminance: ho,
                        "luminance alpha": Mo,
                        rgb: Oo,
                        rgba: Sa,
                        rgba4: xo,
                        "rgb5 a1": zs,
                        rgb565: ks
                    }, fn = {};
                    Er.ext_srgb && (Dn.srgb = ml, Dn.srgba = Ys), Er.oes_texture_float && (Rn.float32 = Rn.float = Zn), Er.oes_texture_half_float && (Rn.float16 = Rn["half float"] = Hs), Er.webgl_depth_texture && (e(Dn, {
                        depth: cl,
                        "depth stencil": Cs
                    }), e(Rn, {
                        uint16: Xl,
                        uint32: Ec,
                        "depth stencil": os
                    })), Er.webgl_compressed_texture_s3tc && e(fn, {
                        "rgb s3tc dxt1": Eo,
                        "rgba s3tc dxt1": fs,
                        "rgba s3tc dxt3": Ql,
                        "rgba s3tc dxt5": Hu
                    }), Er.webgl_compressed_texture_atc && e(fn, {
                        "rgb atc": fc,
                        "rgba atc explicit alpha": ms,
                        "rgba atc interpolated alpha": on
                    }), Er.webgl_compressed_texture_pvrtc && e(fn, {
                        "rgb pvrtc 4bppv1": fa,
                        "rgb pvrtc 2bppv1": Qu,
                        "rgba pvrtc 4bppv1": Rl,
                        "rgba pvrtc 2bppv1": vo
                    }), Er.webgl_compressed_texture_etc1 && (fn["rgb etc1"] = Zl);
                    var Ai = Array.prototype.slice.call(At.getParameter(hi));
                    Object.keys(fn).forEach(function(de) {
                        var Ie = fn[de];
                        Ai.indexOf(Ie) >= 0 && (Dn[de] = Ie);
                    });
                    var ji = Object.keys(Dn);
                    Wr.textureFormats = ji;
                    var Ln = [];
                    Object.keys(Dn).forEach(function(de) {
                        var Ie = Dn[de];
                        Ln[Ie] = de;
                    });
                    var Un = [];
                    Object.keys(Rn).forEach(function(de) {
                        var Ie = Rn[de];
                        Un[Ie] = de;
                    });
                    var gn = [];
                    Object.keys(Bn).forEach(function(de) {
                        var Ie = Bn[de];
                        gn[Ie] = de;
                    });
                    var ca = [];
                    Object.keys(yn).forEach(function(de) {
                        var Ie = yn[de];
                        ca[Ie] = de;
                    });
                    var Kn = [];
                    Object.keys(On).forEach(function(de) {
                        var Ie = On[de];
                        Kn[Ie] = de;
                    });
                    var Za = ji.reduce(function(de, Ie) {
                        var $e = Dn[Ie];
                        return $e === ho || $e === go || $e === ho || $e === Mo || $e === cl || $e === Cs || Er.ext_srgb && ($e === ml || $e === Ys) ? de[$e] = $e : $e === zs || Ie.indexOf("rgba") >= 0 ? de[$e] = Sa : de[$e] = Oo, de;
                    }, {});
                    function wn() {
                        this.internalformat = Sa, this.format = Sa, this.type = Ks, this.compressed = !1, this.premultiplyAlpha = !1, this.flipY = !1, this.unpackAlignment = 1, this.colorSpace = hc, this.width = 0, this.height = 0, this.channels = 0;
                    }
                    function vn(de, Ie) {
                        de.internalformat = Ie.internalformat, de.format = Ie.format, de.type = Ie.type, de.compressed = Ie.compressed, de.premultiplyAlpha = Ie.premultiplyAlpha, de.flipY = Ie.flipY, de.unpackAlignment = Ie.unpackAlignment, de.colorSpace = Ie.colorSpace, de.width = Ie.width, de.height = Ie.height, de.channels = Ie.channels;
                    }
                    function Aa(de, Ie) {
                        if (!(typeof Ie != "object" || !Ie)) {
                            if ("premultiplyAlpha" in Ie && (de.premultiplyAlpha = Ie.premultiplyAlpha), "flipY" in Ie && (de.flipY = Ie.flipY), "alignment" in Ie && (de.unpackAlignment = Ie.alignment), "colorSpace" in Ie && (de.colorSpace = to[Ie.colorSpace]), "type" in Ie) {
                                var $e = Ie.type;
                                de.type = Rn[$e];
                            }
                            var pt = de.width, Kt = de.height, ir = de.channels, Jt = !1;
                            "shape" in Ie ? (pt = Ie.shape[0], Kt = Ie.shape[1], Ie.shape.length === 3 && (ir = Ie.shape[2], Jt = !0)) : ("radius" in Ie && (pt = Kt = Ie.radius), "width" in Ie && (pt = Ie.width), "height" in Ie && (Kt = Ie.height), "channels" in Ie && (ir = Ie.channels, Jt = !0)), de.width = pt | 0, de.height = Kt | 0, de.channels = ir | 0;
                            var vt = !1;
                            if ("format" in Ie) {
                                var Pt = Ie.format, Wt = de.internalformat = Dn[Pt];
                                de.format = Za[Wt], Pt in Rn && ("type" in Ie || (de.type = Rn[Pt])), Pt in fn && (de.compressed = !0), vt = !0;
                            }
                            !Jt && vt ? de.channels = hs[de.format] : Jt && !vt && de.channels !== $s[de.format] && (de.format = de.internalformat = $s[de.channels]);
                        }
                    }
                    function aa(de) {
                        At.pixelStorei(ih, de.flipY), At.pixelStorei(Vl, de.premultiplyAlpha), At.pixelStorei(Js, de.colorSpace), At.pixelStorei(ff, de.unpackAlignment);
                    }
                    function Xn() {
                        wn.call(this), this.xOffset = 0, this.yOffset = 0, this.data = null, this.needsFree = !1, this.element = null, this.needsCopy = !1;
                    }
                    function Vn(de, Ie) {
                        var $e = null;
                        if (nh(Ie) ? $e = Ie : Ie && (Aa(de, Ie), "x" in Ie && (de.xOffset = Ie.x | 0), "y" in Ie && (de.yOffset = Ie.y | 0), nh(Ie.data) && ($e = Ie.data)), Ie.copy) {
                            var pt = Ui.viewportWidth, Kt = Ui.viewportHeight;
                            de.width = de.width || pt - de.xOffset, de.height = de.height || Kt - de.yOffset, de.needsCopy = !0;
                        } else if (!$e) de.width = de.width || 1, de.height = de.height || 1, de.channels = de.channels || 4;
                        else if (Or($e)) de.channels = de.channels || 4, de.data = $e, !("type" in Ie) && de.type === Ks && (de.type = hf($e));
                        else if (Ef($e)) de.channels = de.channels || 4, kh(de, $e), de.alignment = 1, de.needsFree = !0;
                        else if (Nr($e)) {
                            var ir = $e.data;
                            !Array.isArray(ir) && de.type === Ks && (de.type = hf(ir));
                            var Jt = $e.shape, vt = $e.stride, Pt, Wt, rr, dr, pr, kr;
                            Jt.length === 3 ? (rr = Jt[2], kr = vt[2]) : (rr = 1, kr = 1), Pt = Jt[0], Wt = Jt[1], dr = vt[0], pr = vt[1], de.alignment = 1, de.width = Pt, de.height = Wt, de.channels = rr, de.format = de.internalformat = $s[rr], de.needsFree = !0, ah(de, ir, dr, pr, kr, $e.offset);
                        } else if (Mh($e) || jc($e) || kf($e)) Mh($e) || jc($e) ? de.element = $e : de.element = $e.canvas, de.width = de.element.width, de.height = de.element.height, de.channels = 4;
                        else if (Ml($e)) de.element = $e, de.width = $e.width, de.height = $e.height, de.channels = 4;
                        else if (Yh($e)) de.element = $e, de.width = $e.naturalWidth, de.height = $e.naturalHeight, de.channels = 4;
                        else if (Eh($e)) de.element = $e, de.width = $e.videoWidth, de.height = $e.videoHeight, de.channels = 4;
                        else if (tc($e)) {
                            var Ar = de.width || $e[0].length, gr = de.height || $e.length, Cr = de.channels;
                            an($e[0][0]) ? Cr = Cr || $e[0][0].length : Cr = Cr || 1;
                            for(var cr = Ne.shape($e), Gr = 1, ei = 0; ei < cr.length; ++ei)Gr *= cr[ei];
                            var yi = Kh(de, Gr);
                            Ne.flatten($e, cr, "", yi), rc(de, yi), de.alignment = 1, de.width = Ar, de.height = gr, de.channels = Cr, de.format = de.internalformat = $s[Cr], de.needsFree = !0;
                        }
                        de.type === Zn || de.type;
                    }
                    function ma(de, Ie, $e) {
                        var pt = de.element, Kt = de.data, ir = de.internalformat, Jt = de.format, vt = de.type, Pt = de.width, Wt = de.height;
                        aa(de), pt ? At.texImage2D(Ie, $e, Jt, Jt, vt, pt) : de.compressed ? At.compressedTexImage2D(Ie, $e, ir, Pt, Wt, 0, Kt) : de.needsCopy ? (wi(), At.copyTexImage2D(Ie, $e, Jt, de.xOffset, de.yOffset, Pt, Wt, 0)) : At.texImage2D(Ie, $e, Jt, Pt, Wt, 0, Jt, vt, Kt || null);
                    }
                    function ro(de, Ie, $e, pt, Kt) {
                        var ir = de.element, Jt = de.data, vt = de.internalformat, Pt = de.format, Wt = de.type, rr = de.width, dr = de.height;
                        aa(de), ir ? At.texSubImage2D(Ie, Kt, $e, pt, Pt, Wt, ir) : de.compressed ? At.compressedTexSubImage2D(Ie, Kt, $e, pt, vt, rr, dr, Jt) : de.needsCopy ? (wi(), At.copyTexSubImage2D(Ie, Kt, $e, pt, de.xOffset, de.yOffset, rr, dr)) : At.texSubImage2D(Ie, Kt, $e, pt, rr, dr, Pt, Wt, Jt);
                    }
                    var Ao = [];
                    function Jn() {
                        return Ao.pop() || new Xn;
                    }
                    function Oa(de) {
                        de.needsFree && W.freeType(de.data), Xn.call(de), Ao.push(de);
                    }
                    function _o() {
                        wn.call(this), this.genMipmaps = !1, this.mipmapHint = Gc, this.mipmask = 0, this.images = Array(16);
                    }
                    function Po(de, Ie, $e) {
                        var pt = de.images[0] = Jn();
                        de.mipmask = 1, pt.width = de.width = Ie, pt.height = de.height = $e, pt.channels = de.channels = 4;
                    }
                    function Jo(de, Ie) {
                        var $e = null;
                        if (nh(Ie)) $e = de.images[0] = Jn(), vn($e, de), Vn($e, Ie), de.mipmask = 1;
                        else if (Aa(de, Ie), Array.isArray(Ie.mipmap)) for(var pt = Ie.mipmap, Kt = 0; Kt < pt.length; ++Kt)$e = de.images[Kt] = Jn(), vn($e, de), $e.width >>= Kt, $e.height >>= Kt, Vn($e, pt[Kt]), de.mipmask |= 1 << Kt;
                        else $e = de.images[0] = Jn(), vn($e, de), Vn($e, Ie), de.mipmask = 1;
                        vn(de, de.images[0]), de.compressed && (de.internalformat === Eo || de.internalformat === fs || de.internalformat === Ql || de.internalformat);
                    }
                    function Yl(de, Ie) {
                        for(var $e = de.images, pt = 0; pt < $e.length; ++pt){
                            if (!$e[pt]) return;
                            ma($e[pt], Ie, pt);
                        }
                    }
                    var $c = [];
                    function xs() {
                        var de = $c.pop() || new _o;
                        wn.call(de), de.mipmask = 0;
                        for(var Ie = 0; Ie < 16; ++Ie)de.images[Ie] = null;
                        return de;
                    }
                    function Qc(de) {
                        for(var Ie = de.images, $e = 0; $e < Ie.length; ++$e)Ie[$e] && Oa(Ie[$e]), Ie[$e] = null;
                        $c.push(de);
                    }
                    function El() {
                        this.minFilter = Al, this.magFilter = Al, this.wrapS = uf, this.wrapT = uf, this.anisotropic = 1, this.genMipmaps = !1, this.mipmapHint = Gc;
                    }
                    function bc(de, Ie) {
                        if ("min" in Ie) {
                            var $e = Ie.min;
                            de.minFilter = yn[$e], ws.indexOf(de.minFilter) >= 0 && !("faces" in Ie) && (de.genMipmaps = !0);
                        }
                        if ("mag" in Ie) {
                            var pt = Ie.mag;
                            de.magFilter = Bn[pt];
                        }
                        var Kt = de.wrapS, ir = de.wrapT;
                        if ("wrap" in Ie) {
                            var Jt = Ie.wrap;
                            typeof Jt == "string" ? Kt = ir = On[Jt] : Array.isArray(Jt) && (Kt = On[Jt[0]], ir = On[Jt[1]]);
                        } else {
                            if ("wrapS" in Ie) {
                                var vt = Ie.wrapS;
                                Kt = On[vt];
                            }
                            if ("wrapT" in Ie) {
                                var Pt = Ie.wrapT;
                                ir = On[Pt];
                            }
                        }
                        if (de.wrapS = Kt, de.wrapT = ir, "anisotropic" in Ie) {
                            var Wt = Ie.anisotropic;
                            de.anisotropic = Ie.anisotropic;
                        }
                        if ("mipmap" in Ie) {
                            var rr = !1;
                            switch(typeof Ie.mipmap){
                                case "string":
                                    de.mipmapHint = cn[Ie.mipmap], de.genMipmaps = !0, rr = !0;
                                    break;
                                case "boolean":
                                    rr = de.genMipmaps = Ie.mipmap;
                                    break;
                                case "object":
                                    de.genMipmaps = !1, rr = !0;
                                    break;
                                default:
                            }
                            rr && !("min" in Ie) && (de.minFilter = eu);
                        }
                    }
                    function wc(de, Ie) {
                        At.texParameteri(Ie, rh, de.minFilter), At.texParameteri(Ie, cf, de.magFilter), At.texParameteri(Ie, ko, de.wrapS), At.texParameteri(Ie, Co, de.wrapT), Er.ext_texture_filter_anisotropic && At.texParameteri(Ie, ss, de.anisotropic), de.genMipmaps && (At.hint(Of, de.mipmapHint), At.generateMipmap(Ie));
                    }
                    var yf = 0, Gl = {}, Fc = Wr.maxTextureUnits, ef = Array(Fc).map(function() {
                        return null;
                    });
                    function ls(de) {
                        wn.call(this), this.mipmask = 0, this.internalformat = Sa, this.id = yf++, this.refCount = 1, this.target = de, this.texture = At.createTexture(), this.unit = -1, this.bindCount = 0, this.texInfo = new El, Bi.profile && (this.stats = {
                            size: 0
                        });
                    }
                    function _f(de) {
                        At.activeTexture(Cc), At.bindTexture(de.target, de.texture);
                    }
                    function ns() {
                        var de = ef[0];
                        de ? At.bindTexture(de.target, de.texture) : At.bindTexture(Ji, null);
                    }
                    function Y1(de) {
                        var Ie = de.texture, $e = de.unit, pt = de.target;
                        $e >= 0 && (At.activeTexture(Cc + $e), At.bindTexture(pt, null), ef[$e] = null), At.deleteTexture(Ie), de.texture = null, de.params = null, de.pixels = null, de.refCount = 0, delete Gl[de.id], Oi.textureCount--;
                    }
                    e(ls.prototype, {
                        bind: function() {
                            var de = this;
                            de.bindCount += 1;
                            var Ie = de.unit;
                            if (Ie < 0) {
                                for(var $e = 0; $e < Fc; ++$e){
                                    var pt = ef[$e];
                                    if (pt) {
                                        if (pt.bindCount > 0) continue;
                                        pt.unit = -1;
                                    }
                                    ef[$e] = de, Ie = $e;
                                    break;
                                }
                                Bi.profile && Oi.maxTextureUnits < Ie + 1 && (Oi.maxTextureUnits = Ie + 1), de.unit = Ie, At.activeTexture(Cc + Ie), At.bindTexture(de.target, de.texture);
                            }
                            return Ie;
                        },
                        unbind: function() {
                            this.bindCount -= 1;
                        },
                        decRef: function() {
                            --this.refCount <= 0 && Y1(this);
                        }
                    });
                    function z(de, Ie) {
                        var $e = new ls(Ji);
                        Gl[$e.id] = $e, Oi.textureCount++;
                        function pt(Jt, vt) {
                            var Pt = $e.texInfo;
                            El.call(Pt);
                            var Wt = xs();
                            return typeof Jt == "number" ? typeof vt == "number" ? Po(Wt, Jt | 0, vt | 0) : Po(Wt, Jt | 0, Jt | 0) : Jt ? (bc(Pt, Jt), Jo(Wt, Jt)) : Po(Wt, 1, 1), Pt.genMipmaps && (Wt.mipmask = (Wt.width << 1) - 1), $e.mipmask = Wt.mipmask, vn($e, Wt), $e.internalformat = Wt.internalformat, pt.width = Wt.width, pt.height = Wt.height, _f($e), Yl(Wt, Ji), wc(Pt, Ji), ns(), Qc(Wt), Bi.profile && ($e.stats.size = Wc($e.internalformat, $e.type, Wt.width, Wt.height, Pt.genMipmaps, !1)), pt.format = Ln[$e.internalformat], pt.type = Un[$e.type], pt.mag = gn[Pt.magFilter], pt.min = ca[Pt.minFilter], pt.wrapS = Kn[Pt.wrapS], pt.wrapT = Kn[Pt.wrapT], pt;
                        }
                        function Kt(Jt, vt, Pt, Wt) {
                            var rr = vt | 0, dr = Pt | 0, pr = Wt | 0, kr = Jn();
                            return vn(kr, $e), kr.width = 0, kr.height = 0, Vn(kr, Jt), kr.width = kr.width || ($e.width >> pr) - rr, kr.height = kr.height || ($e.height >> pr) - dr, _f($e), ro(kr, Ji, rr, dr, pr), ns(), Oa(kr), pt;
                        }
                        function ir(Jt, vt) {
                            var Pt = Jt | 0, Wt = vt | 0 || Pt;
                            if (Pt === $e.width && Wt === $e.height) return pt;
                            pt.width = $e.width = Pt, pt.height = $e.height = Wt, _f($e);
                            for(var rr = 0; $e.mipmask >> rr; ++rr){
                                var dr = Pt >> rr, pr = Wt >> rr;
                                if (!dr || !pr) break;
                                At.texImage2D(Ji, rr, $e.format, dr, pr, 0, $e.format, $e.type, null);
                            }
                            return ns(), Bi.profile && ($e.stats.size = Wc($e.internalformat, $e.type, Pt, Wt, !1, !1)), pt;
                        }
                        return pt(de, Ie), pt.subimage = Kt, pt.resize = ir, pt._reglType = "texture2d", pt._texture = $e, Bi.profile && (pt.stats = $e.stats), pt.destroy = function() {
                            $e.decRef();
                        }, pt;
                    }
                    function K(de, Ie, $e, pt, Kt, ir) {
                        var Jt = new ls(ua);
                        Gl[Jt.id] = Jt, Oi.cubeCount++;
                        var vt = new Array(6);
                        function Pt(dr, pr, kr, Ar, gr, Cr) {
                            var cr, Gr = Jt.texInfo;
                            for(El.call(Gr), cr = 0; cr < 6; ++cr)vt[cr] = xs();
                            if (typeof dr == "number" || !dr) {
                                var ei = dr | 0 || 1;
                                for(cr = 0; cr < 6; ++cr)Po(vt[cr], ei, ei);
                            } else if (typeof dr == "object") {
                                if (pr) Jo(vt[0], dr), Jo(vt[1], pr), Jo(vt[2], kr), Jo(vt[3], Ar), Jo(vt[4], gr), Jo(vt[5], Cr);
                                else if (bc(Gr, dr), Aa(Jt, dr), "faces" in dr) {
                                    var yi = dr.faces;
                                    for(cr = 0; cr < 6; ++cr)vn(vt[cr], Jt), Jo(vt[cr], yi[cr]);
                                } else for(cr = 0; cr < 6; ++cr)Jo(vt[cr], dr);
                            }
                            for(vn(Jt, vt[0]), Gr.genMipmaps ? Jt.mipmask = (vt[0].width << 1) - 1 : Jt.mipmask = vt[0].mipmask, Jt.internalformat = vt[0].internalformat, Pt.width = vt[0].width, Pt.height = vt[0].height, _f(Jt), cr = 0; cr < 6; ++cr)Yl(vt[cr], Fn + cr);
                            for(wc(Gr, ua), ns(), Bi.profile && (Jt.stats.size = Wc(Jt.internalformat, Jt.type, Pt.width, Pt.height, Gr.genMipmaps, !0)), Pt.format = Ln[Jt.internalformat], Pt.type = Un[Jt.type], Pt.mag = gn[Gr.magFilter], Pt.min = ca[Gr.minFilter], Pt.wrapS = Kn[Gr.wrapS], Pt.wrapT = Kn[Gr.wrapT], cr = 0; cr < 6; ++cr)Qc(vt[cr]);
                            return Pt;
                        }
                        function Wt(dr, pr, kr, Ar, gr) {
                            var Cr = kr | 0, cr = Ar | 0, Gr = gr | 0, ei = Jn();
                            return vn(ei, Jt), ei.width = 0, ei.height = 0, Vn(ei, pr), ei.width = ei.width || (Jt.width >> Gr) - Cr, ei.height = ei.height || (Jt.height >> Gr) - cr, _f(Jt), ro(ei, Fn + dr, Cr, cr, Gr), ns(), Oa(ei), Pt;
                        }
                        function rr(dr) {
                            var pr = dr | 0;
                            if (pr !== Jt.width) {
                                Pt.width = Jt.width = pr, Pt.height = Jt.height = pr, _f(Jt);
                                for(var kr = 0; kr < 6; ++kr)for(var Ar = 0; Jt.mipmask >> Ar; ++Ar)At.texImage2D(Fn + kr, Ar, Jt.format, pr >> Ar, pr >> Ar, 0, Jt.format, Jt.type, null);
                                return ns(), Bi.profile && (Jt.stats.size = Wc(Jt.internalformat, Jt.type, Pt.width, Pt.height, !1, !0)), Pt;
                            }
                        }
                        return Pt(de, Ie, $e, pt, Kt, ir), Pt.subimage = Wt, Pt.resize = rr, Pt._reglType = "textureCube", Pt._texture = Jt, Bi.profile && (Pt.stats = Jt.stats), Pt.destroy = function() {
                            Jt.decRef();
                        }, Pt;
                    }
                    function O() {
                        for(var de = 0; de < Fc; ++de)At.activeTexture(Cc + de), At.bindTexture(Ji, null), ef[de] = null;
                        ut(Gl).forEach(Y1), Oi.cubeCount = 0, Oi.textureCount = 0;
                    }
                    Bi.profile && (Oi.getTotalTextureSize = function() {
                        var de = 0;
                        return Object.keys(Gl).forEach(function(Ie) {
                            de += Gl[Ie].stats.size;
                        }), de;
                    });
                    function $() {
                        for(var de = 0; de < Fc; ++de){
                            var Ie = ef[de];
                            Ie && (Ie.bindCount = 0, Ie.unit = -1, ef[de] = null);
                        }
                        ut(Gl).forEach(function($e) {
                            $e.texture = At.createTexture(), At.bindTexture($e.target, $e.texture);
                            for(var pt = 0; pt < 32; ++pt)if ($e.mipmask & 1 << pt) {
                                if ($e.target === Ji) At.texImage2D(Ji, pt, $e.internalformat, $e.width >> pt, $e.height >> pt, 0, $e.internalformat, $e.type, null);
                                else for(var Kt = 0; Kt < 6; ++Kt)At.texImage2D(Fn + Kt, pt, $e.internalformat, $e.width >> pt, $e.height >> pt, 0, $e.internalformat, $e.type, null);
                            }
                            wc($e.texInfo, $e.target);
                        });
                    }
                    function pe() {
                        for(var de = 0; de < Fc; ++de){
                            var Ie = ef[de];
                            Ie && (Ie.bindCount = 0, Ie.unit = -1, ef[de] = null), At.activeTexture(Cc + de), At.bindTexture(Ji, null), At.bindTexture(ua, null);
                        }
                    }
                    return {
                        create2D: z,
                        createCube: K,
                        clear: O,
                        getTexture: function(de) {
                            return null;
                        },
                        restore: $,
                        refresh: pe
                    };
                }
                var Cu = 36161, Nf = 32854, Zc = 32855, ds = 36194, Ch = 33189, Bd = 36168, Jh = 34041, Cf = 35907, pd = 34836, Lu = 34842, $h = 34843, tu = [];
                tu[Nf] = 2, tu[Zc] = 2, tu[ds] = 2, tu[Ch] = 2, tu[Bd] = 1, tu[Jh] = 4, tu[Cf] = 4, tu[pd] = 16, tu[Lu] = 8, tu[$h] = 6;
                function Pu(At, Er, Wr) {
                    return tu[At] * Er * Wr;
                }
                var Lc = function(At, Er, Wr, wi, Ui) {
                    var Oi = {
                        rgba4: Nf,
                        rgb565: ds,
                        "rgb5 a1": Zc,
                        depth: Ch,
                        stencil: Bd,
                        "depth stencil": Jh
                    };
                    Er.ext_srgb && (Oi.srgba = Cf), Er.ext_color_buffer_half_float && (Oi.rgba16f = Lu, Oi.rgb16f = $h), Er.webgl_color_buffer_float && (Oi.rgba32f = pd);
                    var Bi = [];
                    Object.keys(Oi).forEach(function(Dn) {
                        var fn = Oi[Dn];
                        Bi[fn] = Dn;
                    });
                    var cn = 0, On = {};
                    function Bn(Dn) {
                        this.id = cn++, this.refCount = 1, this.renderbuffer = Dn, this.format = Nf, this.width = 0, this.height = 0, Ui.profile && (this.stats = {
                            size: 0
                        });
                    }
                    Bn.prototype.decRef = function() {
                        --this.refCount <= 0 && yn(this);
                    };
                    function yn(Dn) {
                        var fn = Dn.renderbuffer;
                        At.bindRenderbuffer(Cu, null), At.deleteRenderbuffer(fn), Dn.renderbuffer = null, Dn.refCount = 0, delete On[Dn.id], wi.renderbufferCount--;
                    }
                    function to(Dn, fn) {
                        var Ai = new Bn(At.createRenderbuffer());
                        On[Ai.id] = Ai, wi.renderbufferCount++;
                        function ji(Un, gn) {
                            var ca = 0, Kn = 0, Za = Nf;
                            if (typeof Un == "object" && Un) {
                                var wn = Un;
                                if ("shape" in wn) {
                                    var vn = wn.shape;
                                    ca = vn[0] | 0, Kn = vn[1] | 0;
                                } else "radius" in wn && (ca = Kn = wn.radius | 0), "width" in wn && (ca = wn.width | 0), "height" in wn && (Kn = wn.height | 0);
                                "format" in wn && (Za = Oi[wn.format]);
                            } else typeof Un == "number" ? (ca = Un | 0, typeof gn == "number" ? Kn = gn | 0 : Kn = ca) : Un || (ca = Kn = 1);
                            if (!(ca === Ai.width && Kn === Ai.height && Za === Ai.format)) return ji.width = Ai.width = ca, ji.height = Ai.height = Kn, Ai.format = Za, At.bindRenderbuffer(Cu, Ai.renderbuffer), At.renderbufferStorage(Cu, Za, ca, Kn), Ui.profile && (Ai.stats.size = Pu(Ai.format, Ai.width, Ai.height)), ji.format = Bi[Ai.format], ji;
                        }
                        function Ln(Un, gn) {
                            var ca = Un | 0, Kn = gn | 0 || ca;
                            return ca === Ai.width && Kn === Ai.height || (ji.width = Ai.width = ca, ji.height = Ai.height = Kn, At.bindRenderbuffer(Cu, Ai.renderbuffer), At.renderbufferStorage(Cu, Ai.format, ca, Kn), Ui.profile && (Ai.stats.size = Pu(Ai.format, Ai.width, Ai.height))), ji;
                        }
                        return ji(Dn, fn), ji.resize = Ln, ji._reglType = "renderbuffer", ji._renderbuffer = Ai, Ui.profile && (ji.stats = Ai.stats), ji.destroy = function() {
                            Ai.decRef();
                        }, ji;
                    }
                    Ui.profile && (wi.getTotalRenderbufferSize = function() {
                        var Dn = 0;
                        return Object.keys(On).forEach(function(fn) {
                            Dn += On[fn].stats.size;
                        }), Dn;
                    });
                    function Rn() {
                        ut(On).forEach(function(Dn) {
                            Dn.renderbuffer = At.createRenderbuffer(), At.bindRenderbuffer(Cu, Dn.renderbuffer), At.renderbufferStorage(Cu, Dn.format, Dn.width, Dn.height);
                        }), At.bindRenderbuffer(Cu, null);
                    }
                    return {
                        create: to,
                        clear: function() {
                            ut(On).forEach(yn);
                        },
                        restore: Rn
                    };
                }, fl = 36160, Xc = 36161, ic = 3553, yu = 34069, Qs = 36064, Qh = 36096, gd = 36128, Gu = 33306, Pc = 36053, vc = 36193, sv = 5121, Lf = 5126, Uf = 6407, Iu = 6408, oh = [];
                oh[Iu] = 4, oh[Uf] = 3;
                var ru = [];
                ru[sv] = 1, ru[Lf] = 4, ru[vc] = 2;
                function vf(At, Er, Wr, wi, Ui, Oi) {
                    var Bi = {
                        cur: null,
                        next: null,
                        dirty: !1,
                        setFBO: null
                    }, cn = [
                        "rgba"
                    ], On = [
                        "rgba4",
                        "rgb565",
                        "rgb5 a1"
                    ];
                    Er.ext_srgb && On.push("srgba"), Er.ext_color_buffer_half_float && On.push("rgba16f", "rgb16f"), Er.webgl_color_buffer_float && On.push("rgba32f");
                    var Bn = [
                        "uint8"
                    ];
                    Er.oes_texture_half_float && Bn.push("half float", "float16"), Er.oes_texture_float && Bn.push("float", "float32");
                    function yn(Xn, Vn, ma) {
                        this.target = Xn, this.texture = Vn, this.renderbuffer = ma;
                        var ro = 0, Ao = 0;
                        Vn ? (ro = Vn.width, Ao = Vn.height) : ma && (ro = ma.width, Ao = ma.height), this.width = ro, this.height = Ao;
                    }
                    function to(Xn) {
                        Xn && (Xn.texture && Xn.texture._texture.decRef(), Xn.renderbuffer && Xn.renderbuffer._renderbuffer.decRef());
                    }
                    function Rn(Xn, Vn, ma) {
                        if (Xn) {
                            if (Xn.texture) {
                                var ro = Xn.texture._texture, Ao = Math.max(1, ro.width), Jn = Math.max(1, ro.height);
                                ro.refCount += 1;
                            } else {
                                var Oa = Xn.renderbuffer._renderbuffer;
                                Oa.refCount += 1;
                            }
                        }
                    }
                    function Dn(Xn, Vn) {
                        Vn && (Vn.texture ? At.framebufferTexture2D(fl, Xn, Vn.target, Vn.texture._texture.texture, 0) : At.framebufferRenderbuffer(fl, Xn, Xc, Vn.renderbuffer._renderbuffer.renderbuffer));
                    }
                    function fn(Xn) {
                        var Vn = ic, ma = null, ro = null, Ao = Xn;
                        typeof Xn == "object" && (Ao = Xn.data, "target" in Xn && (Vn = Xn.target | 0));
                        var Jn = Ao._reglType;
                        return Jn === "texture2d" || Jn === "textureCube" ? ma = Ao : Jn === "renderbuffer" && (ro = Ao, Vn = Xc), new yn(Vn, ma, ro);
                    }
                    function Ai(Xn, Vn, ma, ro, Ao) {
                        if (ma) {
                            var Jn = wi.create2D({
                                width: Xn,
                                height: Vn,
                                format: ro,
                                type: Ao
                            });
                            return Jn._texture.refCount = 0, new yn(ic, Jn, null);
                        } else {
                            var Oa = Ui.create({
                                width: Xn,
                                height: Vn,
                                format: ro
                            });
                            return Oa._renderbuffer.refCount = 0, new yn(Xc, null, Oa);
                        }
                    }
                    function ji(Xn) {
                        return Xn && (Xn.texture || Xn.renderbuffer);
                    }
                    function Ln(Xn, Vn, ma) {
                        Xn && (Xn.texture ? Xn.texture.resize(Vn, ma) : Xn.renderbuffer && Xn.renderbuffer.resize(Vn, ma), Xn.width = Vn, Xn.height = ma);
                    }
                    var Un = 0, gn = {};
                    function ca() {
                        this.id = Un++, gn[this.id] = this, this.framebuffer = At.createFramebuffer(), this.width = 0, this.height = 0, this.colorAttachments = [], this.depthAttachment = null, this.stencilAttachment = null, this.depthStencilAttachment = null;
                    }
                    function Kn(Xn) {
                        Xn.colorAttachments.forEach(to), to(Xn.depthAttachment), to(Xn.stencilAttachment), to(Xn.depthStencilAttachment);
                    }
                    function Za(Xn) {
                        var Vn = Xn.framebuffer;
                        At.deleteFramebuffer(Vn), Xn.framebuffer = null, Oi.framebufferCount--, delete gn[Xn.id];
                    }
                    function wn(Xn) {
                        var Vn;
                        At.bindFramebuffer(fl, Xn.framebuffer);
                        var ma = Xn.colorAttachments;
                        for(Vn = 0; Vn < ma.length; ++Vn)Dn(Qs + Vn, ma[Vn]);
                        for(Vn = ma.length; Vn < Wr.maxColorAttachments; ++Vn)At.framebufferTexture2D(fl, Qs + Vn, ic, null, 0);
                        At.framebufferTexture2D(fl, Gu, ic, null, 0), At.framebufferTexture2D(fl, Qh, ic, null, 0), At.framebufferTexture2D(fl, gd, ic, null, 0), Dn(Qh, Xn.depthAttachment), Dn(gd, Xn.stencilAttachment), Dn(Gu, Xn.depthStencilAttachment);
                        var ro = At.checkFramebufferStatus(fl);
                        At.isContextLost(), At.bindFramebuffer(fl, Bi.next ? Bi.next.framebuffer : null), Bi.cur = Bi.next, At.getError();
                    }
                    function vn(Xn, Vn) {
                        var ma = new ca;
                        Oi.framebufferCount++;
                        function ro(Jn, Oa) {
                            var _o, Po = 0, Jo = 0, Yl = !0, $c = !0, xs = null, Qc = !0, El = "rgba", bc = "uint8", wc = 1, yf = null, Gl = null, Fc = null, ef = !1;
                            if (typeof Jn == "number") Po = Jn | 0, Jo = Oa | 0 || Po;
                            else if (!Jn) Po = Jo = 1;
                            else {
                                var ls = Jn;
                                if ("shape" in ls) {
                                    var _f = ls.shape;
                                    Po = _f[0], Jo = _f[1];
                                } else "radius" in ls && (Po = Jo = ls.radius), "width" in ls && (Po = ls.width), "height" in ls && (Jo = ls.height);
                                ("color" in ls || "colors" in ls) && (xs = ls.color || ls.colors, Array.isArray(xs)), xs || ("colorCount" in ls && (wc = ls.colorCount | 0), "colorTexture" in ls && (Qc = !!ls.colorTexture, El = "rgba4"), "colorType" in ls && (bc = ls.colorType, Qc || (bc === "half float" || bc === "float16" ? El = "rgba16f" : (bc === "float" || bc === "float32") && (El = "rgba32f"))), "colorFormat" in ls && (El = ls.colorFormat, cn.indexOf(El) >= 0 ? Qc = !0 : On.indexOf(El) >= 0 && (Qc = !1))), ("depthTexture" in ls || "depthStencilTexture" in ls) && (ef = !!(ls.depthTexture || ls.depthStencilTexture)), "depth" in ls && (typeof ls.depth == "boolean" ? Yl = ls.depth : (yf = ls.depth, $c = !1)), "stencil" in ls && (typeof ls.stencil == "boolean" ? $c = ls.stencil : (Gl = ls.stencil, Yl = !1)), "depthStencil" in ls && (typeof ls.depthStencil == "boolean" ? Yl = $c = ls.depthStencil : (Fc = ls.depthStencil, Yl = !1, $c = !1));
                            }
                            var ns = null, Y1 = null, z = null, K = null;
                            if (Array.isArray(xs)) ns = xs.map(fn);
                            else if (xs) ns = [
                                fn(xs)
                            ];
                            else for(ns = new Array(wc), _o = 0; _o < wc; ++_o)ns[_o] = Ai(Po, Jo, Qc, El, bc);
                            Po = Po || ns[0].width, Jo = Jo || ns[0].height, yf ? Y1 = fn(yf) : Yl && !$c && (Y1 = Ai(Po, Jo, ef, "depth", "uint32")), Gl ? z = fn(Gl) : $c && !Yl && (z = Ai(Po, Jo, !1, "stencil", "uint8")), Fc ? K = fn(Fc) : !yf && !Gl && $c && Yl && (K = Ai(Po, Jo, ef, "depth stencil", "depth stencil"));
                            var O = null;
                            for(_o = 0; _o < ns.length; ++_o)if (Rn(ns[_o], Po, Jo), ns[_o] && ns[_o].texture) {
                                var $ = oh[ns[_o].texture._texture.format] * ru[ns[_o].texture._texture.type];
                                O === null && (O = $);
                            }
                            return Rn(Y1, Po, Jo), Rn(z, Po, Jo), Rn(K, Po, Jo), Kn(ma), ma.width = Po, ma.height = Jo, ma.colorAttachments = ns, ma.depthAttachment = Y1, ma.stencilAttachment = z, ma.depthStencilAttachment = K, ro.color = ns.map(ji), ro.depth = ji(Y1), ro.stencil = ji(z), ro.depthStencil = ji(K), ro.width = ma.width, ro.height = ma.height, wn(ma), ro;
                        }
                        function Ao(Jn, Oa) {
                            var _o = Math.max(Jn | 0, 1), Po = Math.max(Oa | 0 || _o, 1);
                            if (_o === ma.width && Po === ma.height) return ro;
                            for(var Jo = ma.colorAttachments, Yl = 0; Yl < Jo.length; ++Yl)Ln(Jo[Yl], _o, Po);
                            return Ln(ma.depthAttachment, _o, Po), Ln(ma.stencilAttachment, _o, Po), Ln(ma.depthStencilAttachment, _o, Po), ma.width = ro.width = _o, ma.height = ro.height = Po, wn(ma), ro;
                        }
                        return ro(Xn, Vn), e(ro, {
                            resize: Ao,
                            _reglType: "framebuffer",
                            _framebuffer: ma,
                            destroy: function() {
                                Za(ma), Kn(ma);
                            },
                            use: function(Jn) {
                                Bi.setFBO({
                                    framebuffer: ro
                                }, Jn);
                            }
                        });
                    }
                    function Aa(Xn) {
                        var Vn = Array(6);
                        function ma(Ao) {
                            var Jn, Oa = {
                                color: null
                            }, _o = 0, Po = null, Jo = "rgba", Yl = "uint8", $c = 1;
                            if (typeof Ao == "number") _o = Ao | 0;
                            else if (!Ao) _o = 1;
                            else {
                                var xs = Ao;
                                if ("shape" in xs) {
                                    var Qc = xs.shape;
                                    _o = Qc[0];
                                } else "radius" in xs && (_o = xs.radius | 0), "width" in xs ? (_o = xs.width | 0, xs) : "height" in xs && (_o = xs.height | 0);
                                ("color" in xs || "colors" in xs) && (Po = xs.color || xs.colors, Array.isArray(Po)), Po || ("colorCount" in xs && ($c = xs.colorCount | 0), "colorType" in xs && (Yl = xs.colorType), "colorFormat" in xs && (Jo = xs.colorFormat)), "depth" in xs && (Oa.depth = xs.depth), "stencil" in xs && (Oa.stencil = xs.stencil), "depthStencil" in xs && (Oa.depthStencil = xs.depthStencil);
                            }
                            var El;
                            if (Po) {
                                if (Array.isArray(Po)) for(El = [], Jn = 0; Jn < Po.length; ++Jn)El[Jn] = Po[Jn];
                                else El = [
                                    Po
                                ];
                            } else {
                                El = Array($c);
                                var bc = {
                                    radius: _o,
                                    format: Jo,
                                    type: Yl
                                };
                                for(Jn = 0; Jn < $c; ++Jn)El[Jn] = wi.createCube(bc);
                            }
                            for(Oa.color = Array(El.length), Jn = 0; Jn < El.length; ++Jn){
                                var wc = El[Jn];
                                _o = _o || wc.width, Oa.color[Jn] = {
                                    target: yu,
                                    data: El[Jn]
                                };
                            }
                            for(Jn = 0; Jn < 6; ++Jn){
                                for(var yf = 0; yf < El.length; ++yf)Oa.color[yf].target = yu + Jn;
                                Jn > 0 && (Oa.depth = Vn[0].depth, Oa.stencil = Vn[0].stencil, Oa.depthStencil = Vn[0].depthStencil), Vn[Jn] ? Vn[Jn](Oa) : Vn[Jn] = vn(Oa);
                            }
                            return e(ma, {
                                width: _o,
                                height: _o,
                                color: El
                            });
                        }
                        function ro(Ao) {
                            var Jn, Oa = Ao | 0;
                            if (Oa === ma.width) return ma;
                            var _o = ma.color;
                            for(Jn = 0; Jn < _o.length; ++Jn)_o[Jn].resize(Oa);
                            for(Jn = 0; Jn < 6; ++Jn)Vn[Jn].resize(Oa);
                            return ma.width = ma.height = Oa, ma;
                        }
                        return ma(Xn), e(ma, {
                            faces: Vn,
                            resize: ro,
                            _reglType: "framebufferCube",
                            destroy: function() {
                                Vn.forEach(function(Ao) {
                                    Ao.destroy();
                                });
                            }
                        });
                    }
                    function aa() {
                        Bi.cur = null, Bi.next = null, Bi.dirty = !0, ut(gn).forEach(function(Xn) {
                            Xn.framebuffer = At.createFramebuffer(), wn(Xn);
                        });
                    }
                    return e(Bi, {
                        getFramebuffer: function(Xn) {
                            if (typeof Xn == "function" && Xn._reglType === "framebuffer") {
                                var Vn = Xn._framebuffer;
                                if (Vn instanceof ca) return Vn;
                            }
                            return null;
                        },
                        create: vn,
                        createCube: Aa,
                        clear: function() {
                            ut(gn).forEach(Za);
                        },
                        restore: aa
                    });
                }
                var md = 5126, sh = 34962, Fs = 34963;
                function _u() {
                    this.state = 0, this.x = 0, this.y = 0, this.z = 0, this.w = 0, this.buffer = null, this.size = 0, this.normalized = !1, this.type = md, this.offset = 0, this.stride = 0, this.divisor = 0;
                }
                function xu(At, Er, Wr, wi, Ui, Oi, Bi) {
                    for(var cn = Wr.maxAttributes, On = new Array(cn), Bn = 0; Bn < cn; ++Bn)On[Bn] = new _u;
                    var yn = 0, to = {}, Rn = {
                        Record: _u,
                        scope: {},
                        state: On,
                        currentVAO: null,
                        targetVAO: null,
                        restore: fn() ? Kn : function() {},
                        createVAO: Za,
                        getVAO: ji,
                        destroyBuffer: Dn,
                        setVAO: fn() ? Ln : Un,
                        clear: fn() ? gn : function() {}
                    };
                    function Dn(wn) {
                        for(var vn = 0; vn < On.length; ++vn){
                            var Aa = On[vn];
                            Aa.buffer === wn && (At.disableVertexAttribArray(vn), Aa.buffer = null);
                        }
                    }
                    function fn() {
                        return Er.oes_vertex_array_object;
                    }
                    function Ai() {
                        return Er.angle_instanced_arrays;
                    }
                    function ji(wn) {
                        return typeof wn == "function" && wn._vao ? wn._vao : null;
                    }
                    function Ln(wn) {
                        if (wn !== Rn.currentVAO) {
                            var vn = fn();
                            wn ? vn.bindVertexArrayOES(wn.vao) : vn.bindVertexArrayOES(null), Rn.currentVAO = wn;
                        }
                    }
                    function Un(wn) {
                        if (wn !== Rn.currentVAO) {
                            if (wn) wn.bindAttrs();
                            else {
                                for(var vn = Ai(), Aa = 0; Aa < On.length; ++Aa){
                                    var aa = On[Aa];
                                    aa.buffer ? (At.enableVertexAttribArray(Aa), aa.buffer.bind(), At.vertexAttribPointer(Aa, aa.size, aa.type, aa.normalized, aa.stride, aa.offfset), vn && aa.divisor && vn.vertexAttribDivisorANGLE(Aa, aa.divisor)) : (At.disableVertexAttribArray(Aa), At.vertexAttrib4f(Aa, aa.x, aa.y, aa.z, aa.w));
                                }
                                Bi.elements ? At.bindBuffer(Fs, Bi.elements.buffer.buffer) : At.bindBuffer(Fs, null);
                            }
                            Rn.currentVAO = wn;
                        }
                    }
                    function gn() {
                        ut(to).forEach(function(wn) {
                            wn.destroy();
                        });
                    }
                    function ca() {
                        this.id = ++yn, this.attributes = [], this.elements = null, this.ownsElements = !1, this.count = 0, this.offset = 0, this.instances = -1, this.primitive = 4;
                        var wn = fn();
                        wn ? this.vao = wn.createVertexArrayOES() : this.vao = null, to[this.id] = this, this.buffers = [];
                    }
                    ca.prototype.bindAttrs = function() {
                        for(var wn = Ai(), vn = this.attributes, Aa = 0; Aa < vn.length; ++Aa){
                            var aa = vn[Aa];
                            aa.buffer ? (At.enableVertexAttribArray(Aa), At.bindBuffer(sh, aa.buffer.buffer), At.vertexAttribPointer(Aa, aa.size, aa.type, aa.normalized, aa.stride, aa.offset), wn && aa.divisor && wn.vertexAttribDivisorANGLE(Aa, aa.divisor)) : (At.disableVertexAttribArray(Aa), At.vertexAttrib4f(Aa, aa.x, aa.y, aa.z, aa.w));
                        }
                        for(var Xn = vn.length; Xn < cn; ++Xn)At.disableVertexAttribArray(Xn);
                        var Vn = Oi.getElements(this.elements);
                        Vn ? At.bindBuffer(Fs, Vn.buffer.buffer) : At.bindBuffer(Fs, null);
                    }, ca.prototype.refresh = function() {
                        var wn = fn();
                        wn && (wn.bindVertexArrayOES(this.vao), this.bindAttrs(), Rn.currentVAO = null, wn.bindVertexArrayOES(null));
                    }, ca.prototype.destroy = function() {
                        if (this.vao) {
                            var wn = fn();
                            this === Rn.currentVAO && (Rn.currentVAO = null, wn.bindVertexArrayOES(null)), wn.deleteVertexArrayOES(this.vao), this.vao = null;
                        }
                        this.ownsElements && (this.elements.destroy(), this.elements = null, this.ownsElements = !1), to[this.id] && (delete to[this.id], wi.vaoCount -= 1);
                    };
                    function Kn() {
                        var wn = fn();
                        wn && ut(to).forEach(function(vn) {
                            vn.refresh();
                        });
                    }
                    function Za(wn) {
                        var vn = new ca;
                        wi.vaoCount += 1;
                        function Aa(aa) {
                            var Xn;
                            if (Array.isArray(aa)) Xn = aa, vn.elements && vn.ownsElements && vn.elements.destroy(), vn.elements = null, vn.ownsElements = !1, vn.offset = 0, vn.count = 0, vn.instances = -1, vn.primitive = 4;
                            else {
                                if (aa.elements) {
                                    var Vn = aa.elements;
                                    vn.ownsElements ? typeof Vn == "function" && Vn._reglType === "elements" ? (vn.elements.destroy(), vn.ownsElements = !1) : (vn.elements(Vn), vn.ownsElements = !1) : Oi.getElements(aa.elements) ? (vn.elements = aa.elements, vn.ownsElements = !1) : (vn.elements = Oi.create(aa.elements), vn.ownsElements = !0);
                                } else vn.elements = null, vn.ownsElements = !1;
                                Xn = aa.attributes, vn.offset = 0, vn.count = -1, vn.instances = -1, vn.primitive = 4, vn.elements && (vn.count = vn.elements._elements.vertCount, vn.primitive = vn.elements._elements.primType), "offset" in aa && (vn.offset = aa.offset | 0), "count" in aa && (vn.count = aa.count | 0), "instances" in aa && (vn.instances = aa.instances | 0), "primitive" in aa && (vn.primitive = Ki[aa.primitive]);
                            }
                            var ma = {}, ro = vn.attributes;
                            ro.length = Xn.length;
                            for(var Ao = 0; Ao < Xn.length; ++Ao){
                                var Jn = Xn[Ao], Oa = ro[Ao] = new _u, _o = Jn.data || Jn;
                                if (Array.isArray(_o) || Or(_o) || Nr(_o)) {
                                    var Po;
                                    vn.buffers[Ao] && (Po = vn.buffers[Ao], Or(_o) && Po._buffer.byteLength >= _o.byteLength ? Po.subdata(_o) : (Po.destroy(), vn.buffers[Ao] = null)), vn.buffers[Ao] || (Po = vn.buffers[Ao] = Ui.create(Jn, sh, !1, !0)), Oa.buffer = Ui.getBuffer(Po), Oa.size = Oa.buffer.dimension | 0, Oa.normalized = !1, Oa.type = Oa.buffer.dtype, Oa.offset = 0, Oa.stride = 0, Oa.divisor = 0, Oa.state = 1, ma[Ao] = 1;
                                } else Ui.getBuffer(Jn) ? (Oa.buffer = Ui.getBuffer(Jn), Oa.size = Oa.buffer.dimension | 0, Oa.normalized = !1, Oa.type = Oa.buffer.dtype, Oa.offset = 0, Oa.stride = 0, Oa.divisor = 0, Oa.state = 1) : Ui.getBuffer(Jn.buffer) ? (Oa.buffer = Ui.getBuffer(Jn.buffer), Oa.size = (+Jn.size || Oa.buffer.dimension) | 0, Oa.normalized = !!Jn.normalized || !1, "type" in Jn ? Oa.type = bi[Jn.type] : Oa.type = Oa.buffer.dtype, Oa.offset = (Jn.offset || 0) | 0, Oa.stride = (Jn.stride || 0) | 0, Oa.divisor = (Jn.divisor || 0) | 0, Oa.state = 1) : "x" in Jn && (Oa.x = +Jn.x || 0, Oa.y = +Jn.y || 0, Oa.z = +Jn.z || 0, Oa.w = +Jn.w || 0, Oa.state = 2);
                            }
                            for(var Jo = 0; Jo < vn.buffers.length; ++Jo)!ma[Jo] && vn.buffers[Jo] && (vn.buffers[Jo].destroy(), vn.buffers[Jo] = null);
                            return vn.refresh(), Aa;
                        }
                        return Aa.destroy = function() {
                            for(var aa = 0; aa < vn.buffers.length; ++aa)vn.buffers[aa] && vn.buffers[aa].destroy();
                            vn.buffers.length = 0, vn.ownsElements && (vn.elements.destroy(), vn.elements = null, vn.ownsElements = !1), vn.destroy();
                        }, Aa._vao = vn, Aa._reglType = "vao", Aa(wn);
                    }
                    return Rn;
                }
                var Lh = 35632, Is = 35633, Pf = 35718, Ic = 35721;
                function ju(At, Er, Wr, wi) {
                    var Ui = {}, Oi = {};
                    function Bi(Ai, ji, Ln, Un) {
                        this.name = Ai, this.id = ji, this.location = Ln, this.info = Un;
                    }
                    function cn(Ai, ji) {
                        for(var Ln = 0; Ln < Ai.length; ++Ln)if (Ai[Ln].id === ji.id) {
                            Ai[Ln].location = ji.location;
                            return;
                        }
                        Ai.push(ji);
                    }
                    function On(Ai, ji, Ln) {
                        var Un = Ai === Lh ? Ui : Oi, gn = Un[ji];
                        if (!gn) {
                            var ca = Er.str(ji);
                            gn = At.createShader(Ai), At.shaderSource(gn, ca), At.compileShader(gn), Un[ji] = gn;
                        }
                        return gn;
                    }
                    var Bn = {}, yn = [], to = 0;
                    function Rn(Ai, ji) {
                        this.id = to++, this.fragId = Ai, this.vertId = ji, this.program = null, this.uniforms = [], this.attributes = [], this.refCount = 1, wi.profile && (this.stats = {
                            uniformsCount: 0,
                            attributesCount: 0
                        });
                    }
                    function Dn(Ai, ji, Ln) {
                        var Un, gn, ca = On(Lh, Ai.fragId), Kn = On(Is, Ai.vertId), Za = Ai.program = At.createProgram();
                        if (At.attachShader(Za, ca), At.attachShader(Za, Kn), Ln) for(Un = 0; Un < Ln.length; ++Un){
                            var wn = Ln[Un];
                            At.bindAttribLocation(Za, wn[0], wn[1]);
                        }
                        At.linkProgram(Za);
                        var vn = At.getProgramParameter(Za, Pf);
                        wi.profile && (Ai.stats.uniformsCount = vn);
                        var Aa = Ai.uniforms;
                        for(Un = 0; Un < vn; ++Un)if (gn = At.getActiveUniform(Za, Un), gn) {
                            if (gn.size > 1) for(var aa = 0; aa < gn.size; ++aa){
                                var Xn = gn.name.replace("[0]", "[" + aa + "]");
                                cn(Aa, new Bi(Xn, Er.id(Xn), At.getUniformLocation(Za, Xn), gn));
                            }
                            else cn(Aa, new Bi(gn.name, Er.id(gn.name), At.getUniformLocation(Za, gn.name), gn));
                        }
                        var Vn = At.getProgramParameter(Za, Ic);
                        wi.profile && (Ai.stats.attributesCount = Vn);
                        var ma = Ai.attributes;
                        for(Un = 0; Un < Vn; ++Un)gn = At.getActiveAttrib(Za, Un), gn && cn(ma, new Bi(gn.name, Er.id(gn.name), At.getAttribLocation(Za, gn.name), gn));
                    }
                    wi.profile && (Wr.getMaxUniformsCount = function() {
                        var Ai = 0;
                        return yn.forEach(function(ji) {
                            ji.stats.uniformsCount > Ai && (Ai = ji.stats.uniformsCount);
                        }), Ai;
                    }, Wr.getMaxAttributesCount = function() {
                        var Ai = 0;
                        return yn.forEach(function(ji) {
                            ji.stats.attributesCount > Ai && (Ai = ji.stats.attributesCount);
                        }), Ai;
                    });
                    function fn() {
                        Ui = {}, Oi = {};
                        for(var Ai = 0; Ai < yn.length; ++Ai)Dn(yn[Ai], null, yn[Ai].attributes.map(function(ji) {
                            return [
                                ji.location,
                                ji.name
                            ];
                        }));
                    }
                    return {
                        clear: function() {
                            var Ai = At.deleteShader.bind(At);
                            ut(Ui).forEach(Ai), Ui = {}, ut(Oi).forEach(Ai), Oi = {}, yn.forEach(function(ji) {
                                At.deleteProgram(ji.program);
                            }), yn.length = 0, Bn = {}, Wr.shaderCount = 0;
                        },
                        program: function(Ai, ji, Ln, Un) {
                            var gn = Bn[ji];
                            gn || (gn = Bn[ji] = {});
                            var ca = gn[Ai];
                            if (ca && (ca.refCount++, !Un)) return ca;
                            var Kn = new Rn(ji, Ai);
                            return Wr.shaderCount++, Dn(Kn, Ln, Un), ca || (gn[Ai] = Kn), yn.push(Kn), e(Kn, {
                                destroy: function() {
                                    if (Kn.refCount--, Kn.refCount <= 0) {
                                        At.deleteProgram(Kn.program);
                                        var Za = yn.indexOf(Kn);
                                        yn.splice(Za, 1), Wr.shaderCount--;
                                    }
                                    gn[Kn.vertId].refCount <= 0 && (At.deleteShader(Oi[Kn.vertId]), delete Oi[Kn.vertId], delete Bn[Kn.fragId][Kn.vertId]), Object.keys(Bn[Kn.fragId]).length || (At.deleteShader(Ui[Kn.fragId]), delete Ui[Kn.fragId], delete Bn[Kn.fragId]);
                                }
                            });
                        },
                        restore: fn,
                        shader: On,
                        frag: -1,
                        vert: -1
                    };
                }
                var Vf = 6408, pc = 5121, pf = 3333, Ph = 5126;
                function Dl(At, Er, Wr, wi, Ui, Oi, Bi) {
                    function cn(yn) {
                        var to;
                        Er.next === null ? to = pc : to = Er.next.colorAttachments[0].texture._texture.type;
                        var Rn = 0, Dn = 0, fn = wi.framebufferWidth, Ai = wi.framebufferHeight, ji = null;
                        Or(yn) ? ji = yn : yn && (Rn = yn.x | 0, Dn = yn.y | 0, fn = (yn.width || wi.framebufferWidth - Rn) | 0, Ai = (yn.height || wi.framebufferHeight - Dn) | 0, ji = yn.data || null), Wr();
                        var Ln = fn * Ai * 4;
                        return ji || (to === pc ? ji = new Uint8Array(Ln) : to === Ph && (ji = ji || new Float32Array(Ln))), At.pixelStorei(pf, 4), At.readPixels(Rn, Dn, fn, Ai, Vf, to, ji), ji;
                    }
                    function On(yn) {
                        var to;
                        return Er.setFBO({
                            framebuffer: yn.framebuffer
                        }, function() {
                            to = cn(yn);
                        }), to;
                    }
                    function Bn(yn) {
                        return !yn || !("framebuffer" in yn) ? cn(yn) : On(yn);
                    }
                    return Bn;
                }
                var Ih = 0, Wu = "";
                function Rc(At) {
                    return iu(gc(nc(At)));
                }
                function gc(At) {
                    return gt(Ti(gf(At), At.length * 8));
                }
                function hl(At, Er) {
                    var Wr = gf(At);
                    Wr.length > 16 && (Wr = Ti(Wr, At.length * 8));
                    for(var wi = Array(16), Ui = Array(16), Oi = 0; Oi < 16; Oi++)wi[Oi] = Wr[Oi] ^ 909522486, Ui[Oi] = Wr[Oi] ^ 1549556828;
                    var Bi = Ti(wi.concat(gf(Er)), 512 + Er.length * 8);
                    return gt(Ti(Ui.concat(Bi), 768));
                }
                function iu(At) {
                    for(var Er = Ih ? "0123456789ABCDEF" : "0123456789abcdef", Wr = "", wi, Ui = 0; Ui < At.length; Ui++)wi = At.charCodeAt(Ui), Wr += Er.charAt(wi >>> 4 & 15) + Er.charAt(wi & 15);
                    return Wr;
                }
                function mc(At) {
                    for(var Er = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Wr = "", wi = At.length, Ui = 0; Ui < wi; Ui += 3)for(var Oi = At.charCodeAt(Ui) << 16 | (Ui + 1 < wi ? At.charCodeAt(Ui + 1) << 8 : 0) | (Ui + 2 < wi ? At.charCodeAt(Ui + 2) : 0), Bi = 0; Bi < 4; Bi++)Ui * 8 + Bi * 6 > At.length * 8 ? Wr += Wu : Wr += Er.charAt(Oi >>> 6 * (3 - Bi) & 63);
                    return Wr;
                }
                function Yc(At, Er) {
                    var Wr = Er.length, wi = Array(), Ui, Oi, Bi, cn, On = Array(Math.ceil(At.length / 2));
                    for(Ui = 0; Ui < On.length; Ui++)On[Ui] = At.charCodeAt(Ui * 2) << 8 | At.charCodeAt(Ui * 2 + 1);
                    for(; On.length > 0;){
                        for(cn = Array(), Bi = 0, Ui = 0; Ui < On.length; Ui++)Bi = (Bi << 16) + On[Ui], Oi = Math.floor(Bi / Wr), Bi -= Oi * Wr, (cn.length > 0 || Oi > 0) && (cn[cn.length] = Oi);
                        wi[wi.length] = Bi, On = cn;
                    }
                    var Bn = "";
                    for(Ui = wi.length - 1; Ui >= 0; Ui--)Bn += Er.charAt(wi[Ui]);
                    var yn = Math.ceil(At.length * 8 / (Math.log(Er.length) / Math.log(2)));
                    for(Ui = Bn.length; Ui < yn; Ui++)Bn = Er[0] + Bn;
                    return Bn;
                }
                function nc(At) {
                    for(var Er = "", Wr = -1, wi, Ui; ++Wr < At.length;)wi = At.charCodeAt(Wr), Ui = Wr + 1 < At.length ? At.charCodeAt(Wr + 1) : 0, 55296 <= wi && wi <= 56319 && 56320 <= Ui && Ui <= 57343 && (wi = 65536 + ((wi & 1023) << 10) + (Ui & 1023), Wr++), wi <= 127 ? Er += String.fromCharCode(wi) : wi <= 2047 ? Er += String.fromCharCode(192 | wi >>> 6 & 31, 128 | wi & 63) : wi <= 65535 ? Er += String.fromCharCode(224 | wi >>> 12 & 15, 128 | wi >>> 6 & 63, 128 | wi & 63) : wi <= 2097151 && (Er += String.fromCharCode(240 | wi >>> 18 & 7, 128 | wi >>> 12 & 63, 128 | wi >>> 6 & 63, 128 | wi & 63));
                    return Er;
                }
                function gf(At) {
                    for(var Er = Array(At.length >> 2), Wr = 0; Wr < Er.length; Wr++)Er[Wr] = 0;
                    for(var Wr = 0; Wr < At.length * 8; Wr += 8)Er[Wr >> 5] |= (At.charCodeAt(Wr / 8) & 255) << 24 - Wr % 32;
                    return Er;
                }
                function gt(At) {
                    for(var Er = "", Wr = 0; Wr < At.length * 32; Wr += 8)Er += String.fromCharCode(At[Wr >> 5] >>> 24 - Wr % 32 & 255);
                    return Er;
                }
                function Bt(At, Er) {
                    return At >>> Er | At << 32 - Er;
                }
                function wr(At, Er) {
                    return At >>> Er;
                }
                function vr(At, Er, Wr) {
                    return At & Er ^ ~At & Wr;
                }
                function Ur(At, Er, Wr) {
                    return At & Er ^ At & Wr ^ Er & Wr;
                }
                function fi(At) {
                    return Bt(At, 2) ^ Bt(At, 13) ^ Bt(At, 22);
                }
                function xi(At) {
                    return Bt(At, 6) ^ Bt(At, 11) ^ Bt(At, 25);
                }
                function Fi(At) {
                    return Bt(At, 7) ^ Bt(At, 18) ^ wr(At, 3);
                }
                function Xi(At) {
                    return Bt(At, 17) ^ Bt(At, 19) ^ wr(At, 10);
                }
                var hn = new Array(1116352408, 1899447441, -1245643825, -373957723, 961987163, 1508970993, -1841331548, -1424204075, -670586216, 310598401, 607225278, 1426881987, 1925078388, -2132889090, -1680079193, -1046744716, -459576895, -272742522, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, -1740746414, -1473132947, -1341970488, -1084653625, -958395405, -710438585, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, -2117940946, -1838011259, -1564481375, -1474664885, -1035236496, -949202525, -778901479, -694614492, -200395387, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, -2067236844, -1933114872, -1866530822, -1538233109, -1090935817, -965641998);
                function Ti(At, Er) {
                    var Wr = new Array(1779033703, -1150833019, 1013904242, -1521486534, 1359893119, -1694144372, 528734635, 1541459225), wi = new Array(64), Ui, Oi, Bi, cn, On, Bn, yn, to, Rn, Dn, fn, Ai;
                    for(At[Er >> 5] |= 128 << 24 - Er % 32, At[(Er + 64 >> 9 << 4) + 15] = Er, Rn = 0; Rn < At.length; Rn += 16){
                        for(Ui = Wr[0], Oi = Wr[1], Bi = Wr[2], cn = Wr[3], On = Wr[4], Bn = Wr[5], yn = Wr[6], to = Wr[7], Dn = 0; Dn < 64; Dn++)Dn < 16 ? wi[Dn] = At[Dn + Rn] : wi[Dn] = qi(qi(qi(Xi(wi[Dn - 2]), wi[Dn - 7]), Fi(wi[Dn - 15])), wi[Dn - 16]), fn = qi(qi(qi(qi(to, xi(On)), vr(On, Bn, yn)), hn[Dn]), wi[Dn]), Ai = qi(fi(Ui), Ur(Ui, Oi, Bi)), to = yn, yn = Bn, Bn = On, On = qi(cn, fn), cn = Bi, Bi = Oi, Oi = Ui, Ui = qi(fn, Ai);
                        Wr[0] = qi(Ui, Wr[0]), Wr[1] = qi(Oi, Wr[1]), Wr[2] = qi(Bi, Wr[2]), Wr[3] = qi(cn, Wr[3]), Wr[4] = qi(On, Wr[4]), Wr[5] = qi(Bn, Wr[5]), Wr[6] = qi(yn, Wr[6]), Wr[7] = qi(to, Wr[7]);
                    }
                    return Wr;
                }
                function qi(At, Er) {
                    var Wr = (At & 65535) + (Er & 65535), wi = (At >> 16) + (Er >> 16) + (Wr >> 16);
                    return wi << 16 | Wr & 65535;
                }
                function Ii(At) {
                    return Array.prototype.slice.call(At);
                }
                function mi(At) {
                    return Ii(At).join("");
                }
                function Pn(At) {
                    var Er = At && At.cache, Wr = 0, wi = [], Ui = [], Oi = [];
                    function Bi(fn, Ai) {
                        var ji = Ai && Ai.stable;
                        if (!ji) {
                            for(var Ln = 0; Ln < Ui.length; ++Ln)if (Ui[Ln] === fn && !Oi[Ln]) return wi[Ln];
                        }
                        var Un = "g" + Wr++;
                        return wi.push(Un), Ui.push(fn), Oi.push(ji), Un;
                    }
                    function cn() {
                        var fn = [];
                        function Ai() {
                            fn.push.apply(fn, Ii(arguments));
                        }
                        var ji = [];
                        function Ln() {
                            var Un = "v" + Wr++;
                            return ji.push(Un), arguments.length > 0 && (fn.push(Un, "="), fn.push.apply(fn, Ii(arguments)), fn.push(";")), Un;
                        }
                        return e(Ai, {
                            def: Ln,
                            toString: function() {
                                return mi([
                                    ji.length > 0 ? "var " + ji.join(",") + ";" : "",
                                    mi(fn)
                                ]);
                            }
                        });
                    }
                    function On() {
                        var fn = cn(), Ai = cn(), ji = fn.toString, Ln = Ai.toString;
                        function Un(gn, ca) {
                            Ai(gn, ca, "=", fn.def(gn, ca), ";");
                        }
                        return e(function() {
                            fn.apply(fn, Ii(arguments));
                        }, {
                            def: fn.def,
                            entry: fn,
                            exit: Ai,
                            save: Un,
                            set: function(gn, ca, Kn) {
                                Un(gn, ca), fn(gn, ca, "=", Kn, ";");
                            },
                            toString: function() {
                                return ji() + Ln();
                            }
                        });
                    }
                    function Bn() {
                        var fn = mi(arguments), Ai = On(), ji = On(), Ln = Ai.toString, Un = ji.toString;
                        return e(Ai, {
                            then: function() {
                                return Ai.apply(Ai, Ii(arguments)), this;
                            },
                            else: function() {
                                return ji.apply(ji, Ii(arguments)), this;
                            },
                            toString: function() {
                                var gn = Un();
                                return gn && (gn = "else{" + gn + "}"), mi([
                                    "if(",
                                    fn,
                                    "){",
                                    Ln(),
                                    "}",
                                    gn
                                ]);
                            }
                        });
                    }
                    var yn = cn(), to = {};
                    function Rn(fn, Ai) {
                        var ji = [];
                        function Ln() {
                            var Za = "a" + ji.length;
                            return ji.push(Za), Za;
                        }
                        Ai = Ai || 0;
                        for(var Un = 0; Un < Ai; ++Un)Ln();
                        var gn = On(), ca = gn.toString, Kn = to[fn] = e(gn, {
                            arg: Ln,
                            toString: function() {
                                return mi([
                                    "function(",
                                    ji.join(),
                                    "){",
                                    ca(),
                                    "}"
                                ]);
                            }
                        });
                        return Kn;
                    }
                    function Dn() {
                        var fn = [
                            '"use strict";',
                            yn,
                            "return {"
                        ];
                        Object.keys(to).forEach(function(Un) {
                            fn.push('"', Un, '":', to[Un].toString(), ",");
                        }), fn.push("}");
                        var Ai = mi(fn).replace(/;/g, `;
`).replace(/}/g, `}
`).replace(/{/g, `{
`), ji;
                        if (Er && (ji = Rc(Ai), Er[ji])) return Er[ji].apply(null, Ui);
                        var Ln = Function.apply(null, wi.concat(Ai));
                        return Er && (Er[ji] = Ln), Ln.apply(null, Ui);
                    }
                    return {
                        global: yn,
                        link: Bi,
                        block: cn,
                        proc: Rn,
                        scope: On,
                        cond: Bn,
                        compile: Dn
                    };
                }
                var Ma = "xyzw".split(""), Ta = 5121, Ea = 1, qa = 2, Cn = 0, sn = 1, Ua = 2, mo = 3, Xo = 4, Ts = 5, Qo = 6, ys = "dither", Bo = "blend.enable", yl = "blend.color", Gs = "blend.equation", Rs = "blend.func", ia = "depth.enable", Ka = "depth.func", vs = "depth.range", Ko = "depth.mask", nu = "colorMask", Ru = "cull.enable", ac = "cull.face", mf = "frontFace", bu = "lineWidth", Kc = "polygonOffset.enable", Du = "polygonOffset.offset", Dc = "sample.alpha", Da = "sample.enable", eo = "sample.coverage", Jc = "stencil.enable", yc = "stencil.mask", _c = "stencil.func", le = "stencil.opFront", w = "stencil.opBack", B = "scissor.enable", Q = "scissor.box", ee = "viewport", se = "profile", qe = "framebuffer", je = "vert", it = "frag", yt = "elements", Ot = "primitive", Nt = "count", hr = "offset", Sr = "instances", he = "vao", be = "Width", Pe = "Height", Oe = qe + be, Je = qe + Pe, He = ee + be, et = ee + Pe, Mt = "drawingBuffer", Dt = Mt + be, Ut = Mt + Pe, tr = [
                    Rs,
                    Gs,
                    _c,
                    le,
                    w,
                    eo,
                    ee,
                    Q,
                    Du
                ], mr = 34962, Rr = 34963, zr = 2884, Xr = 3042, di = 3024, Li = 2960, Ci = 2929, Qi = 3089, Mn = 32823, pa = 32926, ea = 32928, Ga = 5126, To = 35664, Wa = 35665, co = 35666, Ro = 5124, Ds = 35667, As = 35668, yo = 35669, po = 35670, _l = 35671, Hl = 35672, Zu = 35673, cu = 35674, el = 35675, au = 35676, zc = 35678, zl = 35680, Fl = 4, Z = 1028, oe = 1029, we = 2304, Be = 2305, Ue = 32775, We = 32776, wt = 519, tt = 7680, zt = 0, or = 1, lr = 32774, Dr = 513, Ir = 36160, oi = 36064, ui = {
                    0: 0,
                    1: 1,
                    zero: 0,
                    one: 1,
                    "src color": 768,
                    "one minus src color": 769,
                    "src alpha": 770,
                    "one minus src alpha": 771,
                    "dst color": 774,
                    "one minus dst color": 775,
                    "dst alpha": 772,
                    "one minus dst alpha": 773,
                    "constant color": 32769,
                    "one minus constant color": 32770,
                    "constant alpha": 32771,
                    "one minus constant alpha": 32772,
                    "src alpha saturate": 776
                }, qr = {
                    never: 512,
                    less: 513,
                    "<": 513,
                    equal: 514,
                    "=": 514,
                    "==": 514,
                    "===": 514,
                    lequal: 515,
                    "<=": 515,
                    greater: 516,
                    ">": 516,
                    notequal: 517,
                    "!=": 517,
                    "!==": 517,
                    gequal: 518,
                    ">=": 518,
                    always: 519
                }, Kr = {
                    0: 0,
                    zero: 0,
                    keep: 7680,
                    replace: 7681,
                    increment: 7682,
                    decrement: 7683,
                    "increment wrap": 34055,
                    "decrement wrap": 34056,
                    invert: 5386
                }, ii = {
                    cw: we,
                    ccw: Be
                };
                function vi(At) {
                    return Array.isArray(At) || Or(At) || Nr(At);
                }
                function ci(At) {
                    return At.sort(function(Er, Wr) {
                        return Er === ee ? -1 : Wr === ee ? 1 : Er < Wr ? -1 : 1;
                    });
                }
                function Jr(At, Er, Wr, wi) {
                    this.thisDep = At, this.contextDep = Er, this.propDep = Wr, this.append = wi;
                }
                function un(At) {
                    return At && !(At.thisDep || At.contextDep || At.propDep);
                }
                function dn(At) {
                    return new Jr(!1, !1, !1, At);
                }
                function En(At, Er) {
                    var Wr = At.type;
                    if (Wr === Cn) {
                        var wi = At.data.length;
                        return new Jr(!0, wi >= 1, wi >= 2, Er);
                    } else if (Wr === Xo) {
                        var Ui = At.data;
                        return new Jr(Ui.thisDep, Ui.contextDep, Ui.propDep, Er);
                    } else {
                        if (Wr === Ts) return new Jr(!1, !1, !1, Er);
                        if (Wr === Qo) {
                            for(var Oi = !1, Bi = !1, cn = !1, On = 0; On < At.data.length; ++On){
                                var Bn = At.data[On];
                                if (Bn.type === sn) cn = !0;
                                else if (Bn.type === Ua) Bi = !0;
                                else if (Bn.type === mo) Oi = !0;
                                else if (Bn.type === Cn) {
                                    Oi = !0;
                                    var yn = Bn.data;
                                    yn >= 1 && (Bi = !0), yn >= 2 && (cn = !0);
                                } else Bn.type === Xo && (Oi = Oi || Bn.data.thisDep, Bi = Bi || Bn.data.contextDep, cn = cn || Bn.data.propDep);
                            }
                            return new Jr(Oi, Bi, cn, Er);
                        } else return new Jr(Wr === mo, Wr === Ua, Wr === sn, Er);
                    }
                }
                var Nn = new Jr(!1, !1, !1, function() {});
                function ga(At, Er, Wr, wi, Ui, Oi, Bi, cn, On, Bn, yn, to, Rn, Dn, fn, Ai) {
                    var ji = Bn.Record, Ln = {
                        add: 32774,
                        subtract: 32778,
                        "reverse subtract": 32779
                    };
                    Wr.ext_blend_minmax && (Ln.min = Ue, Ln.max = We);
                    var Un = Wr.angle_instanced_arrays, gn = Wr.webgl_draw_buffers, ca = Wr.oes_vertex_array_object, Kn = {
                        dirty: !0,
                        profile: Ai.profile
                    }, Za = {}, wn = [], vn = {}, Aa = {};
                    function aa(vt) {
                        return vt.replace(".", "_");
                    }
                    function Xn(vt, Pt, Wt) {
                        var rr = aa(vt);
                        wn.push(vt), Za[rr] = Kn[rr] = !!Wt, vn[rr] = Pt;
                    }
                    function Vn(vt, Pt, Wt) {
                        var rr = aa(vt);
                        wn.push(vt), Array.isArray(Wt) ? (Kn[rr] = Wt.slice(), Za[rr] = Wt.slice()) : Kn[rr] = Za[rr] = Wt, Aa[rr] = Pt;
                    }
                    function ma(vt) {
                        return !!isNaN(vt);
                    }
                    Xn(ys, di), Xn(Bo, Xr), Vn(yl, "blendColor", [
                        0,
                        0,
                        0,
                        0
                    ]), Vn(Gs, "blendEquationSeparate", [
                        lr,
                        lr
                    ]), Vn(Rs, "blendFuncSeparate", [
                        or,
                        zt,
                        or,
                        zt
                    ]), Xn(ia, Ci, !0), Vn(Ka, "depthFunc", Dr), Vn(vs, "depthRange", [
                        0,
                        1
                    ]), Vn(Ko, "depthMask", !0), Vn(nu, nu, [
                        !0,
                        !0,
                        !0,
                        !0
                    ]), Xn(Ru, zr), Vn(ac, "cullFace", oe), Vn(mf, mf, Be), Vn(bu, bu, 1), Xn(Kc, Mn), Vn(Du, "polygonOffset", [
                        0,
                        0
                    ]), Xn(Dc, pa), Xn(Da, ea), Vn(eo, "sampleCoverage", [
                        1,
                        !1
                    ]), Xn(Jc, Li), Vn(yc, "stencilMask", -1), Vn(_c, "stencilFunc", [
                        wt,
                        0,
                        -1
                    ]), Vn(le, "stencilOpSeparate", [
                        Z,
                        tt,
                        tt,
                        tt
                    ]), Vn(w, "stencilOpSeparate", [
                        oe,
                        tt,
                        tt,
                        tt
                    ]), Xn(B, Qi), Vn(Q, "scissor", [
                        0,
                        0,
                        At.drawingBufferWidth,
                        At.drawingBufferHeight
                    ]), Vn(ee, ee, [
                        0,
                        0,
                        At.drawingBufferWidth,
                        At.drawingBufferHeight
                    ]);
                    var ro = {
                        gl: At,
                        context: Rn,
                        strings: Er,
                        next: Za,
                        current: Kn,
                        draw: to,
                        elements: Oi,
                        buffer: Ui,
                        shader: yn,
                        attributes: Bn.state,
                        vao: Bn,
                        uniforms: On,
                        framebuffer: cn,
                        extensions: Wr,
                        timer: Dn,
                        isBufferArgs: vi
                    }, Ao = {
                        primTypes: Ki,
                        compareFuncs: qr,
                        blendFuncs: ui,
                        blendEquations: Ln,
                        stencilOps: Kr,
                        glTypes: bi,
                        orientationType: ii
                    };
                    gn && (Ao.backBuffer = [
                        oe
                    ], Ao.drawBuffer = M(wi.maxDrawbuffers, function(vt) {
                        return vt === 0 ? [
                            0
                        ] : M(vt, function(Pt) {
                            return oi + Pt;
                        });
                    }));
                    var Jn = 0;
                    function Oa() {
                        var vt = Pn({
                            cache: fn
                        }), Pt = vt.link, Wt = vt.global;
                        vt.id = Jn++, vt.batchId = "0";
                        var rr = Pt(ro), dr = vt.shared = {
                            props: "a0"
                        };
                        Object.keys(ro).forEach(function(Cr) {
                            dr[Cr] = Wt.def(rr, ".", Cr);
                        });
                        var pr = vt.next = {}, kr = vt.current = {};
                        Object.keys(Aa).forEach(function(Cr) {
                            Array.isArray(Kn[Cr]) && (pr[Cr] = Wt.def(dr.next, ".", Cr), kr[Cr] = Wt.def(dr.current, ".", Cr));
                        });
                        var Ar = vt.constants = {};
                        Object.keys(Ao).forEach(function(Cr) {
                            Ar[Cr] = Wt.def(JSON.stringify(Ao[Cr]));
                        }), vt.invoke = function(Cr, cr) {
                            switch(cr.type){
                                case Cn:
                                    var Gr = [
                                        "this",
                                        dr.context,
                                        dr.props,
                                        vt.batchId
                                    ];
                                    return Cr.def(Pt(cr.data), ".call(", Gr.slice(0, Math.max(cr.data.length + 1, 4)), ")");
                                case sn:
                                    return Cr.def(dr.props, cr.data);
                                case Ua:
                                    return Cr.def(dr.context, cr.data);
                                case mo:
                                    return Cr.def("this", cr.data);
                                case Xo:
                                    return cr.data.append(vt, Cr), cr.data.ref;
                                case Ts:
                                    return cr.data.toString();
                                case Qo:
                                    return cr.data.map(function(ei) {
                                        return vt.invoke(Cr, ei);
                                    });
                            }
                        }, vt.attribCache = {};
                        var gr = {};
                        return vt.scopeAttrib = function(Cr) {
                            var cr = Er.id(Cr);
                            if (cr in gr) return gr[cr];
                            var Gr = Bn.scope[cr];
                            Gr || (Gr = Bn.scope[cr] = new ji);
                            var ei = gr[cr] = Pt(Gr);
                            return ei;
                        }, vt;
                    }
                    function _o(vt) {
                        var Pt = vt.static, Wt = vt.dynamic, rr;
                        if (se in Pt) {
                            var dr = !!Pt[se];
                            rr = dn(function(kr, Ar) {
                                return dr;
                            }), rr.enable = dr;
                        } else if (se in Wt) {
                            var pr = Wt[se];
                            rr = En(pr, function(kr, Ar) {
                                return kr.invoke(Ar, pr);
                            });
                        }
                        return rr;
                    }
                    function Po(vt, Pt) {
                        var Wt = vt.static, rr = vt.dynamic;
                        if (qe in Wt) {
                            var dr = Wt[qe];
                            return dr ? (dr = cn.getFramebuffer(dr), dn(function(kr, Ar) {
                                var gr = kr.link(dr), Cr = kr.shared;
                                Ar.set(Cr.framebuffer, ".next", gr);
                                var cr = Cr.context;
                                return Ar.set(cr, "." + Oe, gr + ".width"), Ar.set(cr, "." + Je, gr + ".height"), gr;
                            })) : dn(function(kr, Ar) {
                                var gr = kr.shared;
                                Ar.set(gr.framebuffer, ".next", "null");
                                var Cr = gr.context;
                                return Ar.set(Cr, "." + Oe, Cr + "." + Dt), Ar.set(Cr, "." + Je, Cr + "." + Ut), "null";
                            });
                        } else if (qe in rr) {
                            var pr = rr[qe];
                            return En(pr, function(kr, Ar) {
                                var gr = kr.invoke(Ar, pr), Cr = kr.shared, cr = Cr.framebuffer, Gr = Ar.def(cr, ".getFramebuffer(", gr, ")");
                                Ar.set(cr, ".next", Gr);
                                var ei = Cr.context;
                                return Ar.set(ei, "." + Oe, Gr + "?" + Gr + ".width:" + ei + "." + Dt), Ar.set(ei, "." + Je, Gr + "?" + Gr + ".height:" + ei + "." + Ut), Gr;
                            });
                        } else return null;
                    }
                    function Jo(vt, Pt, Wt) {
                        var rr = vt.static, dr = vt.dynamic;
                        function pr(gr) {
                            if (gr in rr) {
                                var Cr = rr[gr], cr = !0, Gr = Cr.x | 0, ei = Cr.y | 0, yi, tn;
                                return "width" in Cr ? yi = Cr.width | 0 : cr = !1, "height" in Cr ? tn = Cr.height | 0 : cr = !1, new Jr(!cr && Pt && Pt.thisDep, !cr && Pt && Pt.contextDep, !cr && Pt && Pt.propDep, function(Qn, qn) {
                                    var rn = Qn.shared.context, bn = yi;
                                    "width" in Cr || (bn = qn.def(rn, ".", Oe, "-", Gr));
                                    var mn = tn;
                                    return "height" in Cr || (mn = qn.def(rn, ".", Je, "-", ei)), [
                                        Gr,
                                        ei,
                                        bn,
                                        mn
                                    ];
                                });
                            } else if (gr in dr) {
                                var Ri = dr[gr], ln = En(Ri, function(Qn, qn) {
                                    var rn = Qn.invoke(qn, Ri), bn = Qn.shared.context, mn = qn.def(rn, ".x|0"), Gn = qn.def(rn, ".y|0"), da = qn.def('"width" in ', rn, "?", rn, ".width|0:", "(", bn, ".", Oe, "-", mn, ")"), No = qn.def('"height" in ', rn, "?", rn, ".height|0:", "(", bn, ".", Je, "-", Gn, ")");
                                    return [
                                        mn,
                                        Gn,
                                        da,
                                        No
                                    ];
                                });
                                return Pt && (ln.thisDep = ln.thisDep || Pt.thisDep, ln.contextDep = ln.contextDep || Pt.contextDep, ln.propDep = ln.propDep || Pt.propDep), ln;
                            } else return Pt ? new Jr(Pt.thisDep, Pt.contextDep, Pt.propDep, function(Qn, qn) {
                                var rn = Qn.shared.context;
                                return [
                                    0,
                                    0,
                                    qn.def(rn, ".", Oe),
                                    qn.def(rn, ".", Je)
                                ];
                            }) : null;
                        }
                        var kr = pr(ee);
                        if (kr) {
                            var Ar = kr;
                            kr = new Jr(kr.thisDep, kr.contextDep, kr.propDep, function(gr, Cr) {
                                var cr = Ar.append(gr, Cr), Gr = gr.shared.context;
                                return Cr.set(Gr, "." + He, cr[2]), Cr.set(Gr, "." + et, cr[3]), cr;
                            });
                        }
                        return {
                            viewport: kr,
                            scissor_box: pr(Q)
                        };
                    }
                    function Yl(vt, Pt) {
                        var Wt = vt.static, rr = typeof Wt[it] == "string" && typeof Wt[je] == "string";
                        if (rr) {
                            if (Object.keys(Pt.dynamic).length > 0) return null;
                            var dr = Pt.static, pr = Object.keys(dr);
                            if (pr.length > 0 && typeof dr[pr[0]] == "number") {
                                for(var kr = [], Ar = 0; Ar < pr.length; ++Ar)kr.push([
                                    dr[pr[Ar]] | 0,
                                    pr[Ar]
                                ]);
                                return kr;
                            }
                        }
                        return null;
                    }
                    function $c(vt, Pt, Wt) {
                        var rr = vt.static, dr = vt.dynamic;
                        function pr(cr) {
                            if (cr in rr) {
                                var Gr = Er.id(rr[cr]), ei = dn(function() {
                                    return Gr;
                                });
                                return ei.id = Gr, ei;
                            } else if (cr in dr) {
                                var yi = dr[cr];
                                return En(yi, function(tn, Ri) {
                                    var ln = tn.invoke(Ri, yi), Qn = Ri.def(tn.shared.strings, ".id(", ln, ")");
                                    return Qn;
                                });
                            }
                            return null;
                        }
                        var kr = pr(it), Ar = pr(je), gr = null, Cr;
                        return un(kr) && un(Ar) ? (gr = yn.program(Ar.id, kr.id, null, Wt), Cr = dn(function(cr, Gr) {
                            return cr.link(gr);
                        })) : Cr = new Jr(kr && kr.thisDep || Ar && Ar.thisDep, kr && kr.contextDep || Ar && Ar.contextDep, kr && kr.propDep || Ar && Ar.propDep, function(cr, Gr) {
                            var ei = cr.shared.shader, yi;
                            kr ? yi = kr.append(cr, Gr) : yi = Gr.def(ei, ".", it);
                            var tn;
                            Ar ? tn = Ar.append(cr, Gr) : tn = Gr.def(ei, ".", je);
                            var Ri = ei + ".program(" + tn + "," + yi;
                            return Gr.def(Ri + ")");
                        }), {
                            frag: kr,
                            vert: Ar,
                            progVar: Cr,
                            program: gr
                        };
                    }
                    function xs(vt, Pt) {
                        var Wt = vt.static, rr = vt.dynamic, dr = {}, pr = !1;
                        function kr() {
                            if (he in Wt) {
                                var qn = Wt[he];
                                return qn !== null && Bn.getVAO(qn) === null && (qn = Bn.createVAO(qn)), pr = !0, dr.vao = qn, dn(function(bn) {
                                    var mn = Bn.getVAO(qn);
                                    return mn ? bn.link(mn) : "null";
                                });
                            } else if (he in rr) {
                                pr = !0;
                                var rn = rr[he];
                                return En(rn, function(bn, mn) {
                                    var Gn = bn.invoke(mn, rn);
                                    return mn.def(bn.shared.vao + ".getVAO(" + Gn + ")");
                                });
                            }
                            return null;
                        }
                        var Ar = kr(), gr = !1;
                        function Cr() {
                            if (yt in Wt) {
                                var qn = Wt[yt];
                                if (dr.elements = qn, vi(qn)) {
                                    var rn = dr.elements = Oi.create(qn, !0);
                                    qn = Oi.getElements(rn), gr = !0;
                                } else qn && (qn = Oi.getElements(qn), gr = !0);
                                var bn = dn(function(Gn, da) {
                                    if (qn) {
                                        var No = Gn.link(qn);
                                        return Gn.ELEMENTS = No, No;
                                    }
                                    return Gn.ELEMENTS = null, null;
                                });
                                return bn.value = qn, bn;
                            } else if (yt in rr) {
                                gr = !0;
                                var mn = rr[yt];
                                return En(mn, function(Gn, da) {
                                    var No = Gn.shared, Do = No.isBufferArgs, ps = No.elements, fo = Gn.invoke(da, mn), as = da.def("null"), tl = da.def(Do, "(", fo, ")"), zu = Gn.cond(tl).then(as, "=", ps, ".createStream(", fo, ");").else(as, "=", ps, ".getElements(", fo, ");");
                                    return da.entry(zu), da.exit(Gn.cond(tl).then(ps, ".destroyStream(", as, ");")), Gn.ELEMENTS = as, as;
                                });
                            } else if (pr) return new Jr(Ar.thisDep, Ar.contextDep, Ar.propDep, function(Gn, da) {
                                return da.def(Gn.shared.vao + ".currentVAO?" + Gn.shared.elements + ".getElements(" + Gn.shared.vao + ".currentVAO.elements):null");
                            });
                            return null;
                        }
                        var cr = Cr();
                        function Gr() {
                            if (Ot in Wt) {
                                var qn = Wt[Ot];
                                return dr.primitive = qn, dn(function(bn, mn) {
                                    return Ki[qn];
                                });
                            } else if (Ot in rr) {
                                var rn = rr[Ot];
                                return En(rn, function(bn, mn) {
                                    var Gn = bn.constants.primTypes, da = bn.invoke(mn, rn);
                                    return mn.def(Gn, "[", da, "]");
                                });
                            } else {
                                if (gr) return un(cr) ? cr.value ? dn(function(bn, mn) {
                                    return mn.def(bn.ELEMENTS, ".primType");
                                }) : dn(function() {
                                    return Fl;
                                }) : new Jr(cr.thisDep, cr.contextDep, cr.propDep, function(bn, mn) {
                                    var Gn = bn.ELEMENTS;
                                    return mn.def(Gn, "?", Gn, ".primType:", Fl);
                                });
                                if (pr) return new Jr(Ar.thisDep, Ar.contextDep, Ar.propDep, function(bn, mn) {
                                    return mn.def(bn.shared.vao + ".currentVAO?" + bn.shared.vao + ".currentVAO.primitive:" + Fl);
                                });
                            }
                            return null;
                        }
                        function ei(qn, rn) {
                            if (qn in Wt) {
                                var bn = Wt[qn] | 0;
                                return rn ? dr.offset = bn : dr.instances = bn, dn(function(Gn, da) {
                                    return rn && (Gn.OFFSET = bn), bn;
                                });
                            } else if (qn in rr) {
                                var mn = rr[qn];
                                return En(mn, function(Gn, da) {
                                    var No = Gn.invoke(da, mn);
                                    return rn && (Gn.OFFSET = No), No;
                                });
                            } else if (rn) {
                                if (gr) return dn(function(Gn, da) {
                                    return Gn.OFFSET = 0, 0;
                                });
                                if (pr) return new Jr(Ar.thisDep, Ar.contextDep, Ar.propDep, function(Gn, da) {
                                    return da.def(Gn.shared.vao + ".currentVAO?" + Gn.shared.vao + ".currentVAO.offset:0");
                                });
                            } else if (pr) return new Jr(Ar.thisDep, Ar.contextDep, Ar.propDep, function(Gn, da) {
                                return da.def(Gn.shared.vao + ".currentVAO?" + Gn.shared.vao + ".currentVAO.instances:-1");
                            });
                            return null;
                        }
                        var yi = ei(hr, !0);
                        function tn() {
                            if (Nt in Wt) {
                                var qn = Wt[Nt] | 0;
                                return dr.count = qn, dn(function() {
                                    return qn;
                                });
                            } else if (Nt in rr) {
                                var rn = rr[Nt];
                                return En(rn, function(da, No) {
                                    var Do = da.invoke(No, rn);
                                    return Do;
                                });
                            } else if (gr) {
                                if (un(cr)) {
                                    if (cr) return yi ? new Jr(yi.thisDep, yi.contextDep, yi.propDep, function(da, No) {
                                        var Do = No.def(da.ELEMENTS, ".vertCount-", da.OFFSET);
                                        return Do;
                                    }) : dn(function(da, No) {
                                        return No.def(da.ELEMENTS, ".vertCount");
                                    });
                                    var bn = dn(function() {
                                        return -1;
                                    });
                                    return bn;
                                } else {
                                    var mn = new Jr(cr.thisDep || yi.thisDep, cr.contextDep || yi.contextDep, cr.propDep || yi.propDep, function(da, No) {
                                        var Do = da.ELEMENTS;
                                        return da.OFFSET ? No.def(Do, "?", Do, ".vertCount-", da.OFFSET, ":-1") : No.def(Do, "?", Do, ".vertCount:-1");
                                    });
                                    return mn;
                                }
                            } else if (pr) {
                                var Gn = new Jr(Ar.thisDep, Ar.contextDep, Ar.propDep, function(da, No) {
                                    return No.def(da.shared.vao, ".currentVAO?", da.shared.vao, ".currentVAO.count:-1");
                                });
                                return Gn;
                            }
                            return null;
                        }
                        var Ri = Gr(), ln = tn(), Qn = ei(Sr, !1);
                        return {
                            elements: cr,
                            primitive: Ri,
                            count: ln,
                            instances: Qn,
                            offset: yi,
                            vao: Ar,
                            vaoActive: pr,
                            elementsActive: gr,
                            static: dr
                        };
                    }
                    function Qc(vt, Pt) {
                        var Wt = vt.static, rr = vt.dynamic, dr = {};
                        return wn.forEach(function(pr) {
                            var kr = aa(pr);
                            function Ar(gr, Cr) {
                                if (pr in Wt) {
                                    var cr = gr(Wt[pr]);
                                    dr[kr] = dn(function() {
                                        return cr;
                                    });
                                } else if (pr in rr) {
                                    var Gr = rr[pr];
                                    dr[kr] = En(Gr, function(ei, yi) {
                                        return Cr(ei, yi, ei.invoke(yi, Gr));
                                    });
                                }
                            }
                            switch(pr){
                                case Ru:
                                case Bo:
                                case ys:
                                case Jc:
                                case ia:
                                case B:
                                case Kc:
                                case Dc:
                                case Da:
                                case Ko:
                                    return Ar(function(gr) {
                                        return gr;
                                    }, function(gr, Cr, cr) {
                                        return cr;
                                    });
                                case Ka:
                                    return Ar(function(gr) {
                                        return qr[gr];
                                    }, function(gr, Cr, cr) {
                                        var Gr = gr.constants.compareFuncs;
                                        return Cr.def(Gr, "[", cr, "]");
                                    });
                                case vs:
                                    return Ar(function(gr) {
                                        return gr;
                                    }, function(gr, Cr, cr) {
                                        var Gr = Cr.def("+", cr, "[0]"), ei = Cr.def("+", cr, "[1]");
                                        return [
                                            Gr,
                                            ei
                                        ];
                                    });
                                case Rs:
                                    return Ar(function(gr) {
                                        var Cr = "srcRGB" in gr ? gr.srcRGB : gr.src, cr = "srcAlpha" in gr ? gr.srcAlpha : gr.src, Gr = "dstRGB" in gr ? gr.dstRGB : gr.dst, ei = "dstAlpha" in gr ? gr.dstAlpha : gr.dst;
                                        return [
                                            ui[Cr],
                                            ui[Gr],
                                            ui[cr],
                                            ui[ei]
                                        ];
                                    }, function(gr, Cr, cr) {
                                        var Gr = gr.constants.blendFuncs;
                                        function ei(rn, bn) {
                                            var mn = Cr.def('"', rn, bn, '" in ', cr, "?", cr, ".", rn, bn, ":", cr, ".", rn);
                                            return mn;
                                        }
                                        var yi = ei("src", "RGB"), tn = ei("dst", "RGB"), Ri = Cr.def(Gr, "[", yi, "]"), ln = Cr.def(Gr, "[", ei("src", "Alpha"), "]"), Qn = Cr.def(Gr, "[", tn, "]"), qn = Cr.def(Gr, "[", ei("dst", "Alpha"), "]");
                                        return [
                                            Ri,
                                            Qn,
                                            ln,
                                            qn
                                        ];
                                    });
                                case Gs:
                                    return Ar(function(gr) {
                                        if (typeof gr == "string") return [
                                            Ln[gr],
                                            Ln[gr]
                                        ];
                                        if (typeof gr == "object") return [
                                            Ln[gr.rgb],
                                            Ln[gr.alpha]
                                        ];
                                    }, function(gr, Cr, cr) {
                                        var Gr = gr.constants.blendEquations, ei = Cr.def(), yi = Cr.def(), tn = gr.cond("typeof ", cr, '==="string"');
                                        return tn.then(ei, "=", yi, "=", Gr, "[", cr, "];"), tn.else(ei, "=", Gr, "[", cr, ".rgb];", yi, "=", Gr, "[", cr, ".alpha];"), Cr(tn), [
                                            ei,
                                            yi
                                        ];
                                    });
                                case yl:
                                    return Ar(function(gr) {
                                        return M(4, function(Cr) {
                                            return +gr[Cr];
                                        });
                                    }, function(gr, Cr, cr) {
                                        return M(4, function(Gr) {
                                            return Cr.def("+", cr, "[", Gr, "]");
                                        });
                                    });
                                case yc:
                                    return Ar(function(gr) {
                                        return gr | 0;
                                    }, function(gr, Cr, cr) {
                                        return Cr.def(cr, "|0");
                                    });
                                case _c:
                                    return Ar(function(gr) {
                                        var Cr = gr.cmp || "keep", cr = gr.ref || 0, Gr = "mask" in gr ? gr.mask : -1;
                                        return [
                                            qr[Cr],
                                            cr,
                                            Gr
                                        ];
                                    }, function(gr, Cr, cr) {
                                        var Gr = gr.constants.compareFuncs, ei = Cr.def('"cmp" in ', cr, "?", Gr, "[", cr, ".cmp]", ":", tt), yi = Cr.def(cr, ".ref|0"), tn = Cr.def('"mask" in ', cr, "?", cr, ".mask|0:-1");
                                        return [
                                            ei,
                                            yi,
                                            tn
                                        ];
                                    });
                                case le:
                                case w:
                                    return Ar(function(gr) {
                                        var Cr = gr.fail || "keep", cr = gr.zfail || "keep", Gr = gr.zpass || "keep";
                                        return [
                                            pr === w ? oe : Z,
                                            Kr[Cr],
                                            Kr[cr],
                                            Kr[Gr]
                                        ];
                                    }, function(gr, Cr, cr) {
                                        var Gr = gr.constants.stencilOps;
                                        function ei(yi) {
                                            return Cr.def('"', yi, '" in ', cr, "?", Gr, "[", cr, ".", yi, "]:", tt);
                                        }
                                        return [
                                            pr === w ? oe : Z,
                                            ei("fail"),
                                            ei("zfail"),
                                            ei("zpass")
                                        ];
                                    });
                                case Du:
                                    return Ar(function(gr) {
                                        var Cr = gr.factor | 0, cr = gr.units | 0;
                                        return [
                                            Cr,
                                            cr
                                        ];
                                    }, function(gr, Cr, cr) {
                                        var Gr = Cr.def(cr, ".factor|0"), ei = Cr.def(cr, ".units|0");
                                        return [
                                            Gr,
                                            ei
                                        ];
                                    });
                                case ac:
                                    return Ar(function(gr) {
                                        var Cr = 0;
                                        return gr === "front" ? Cr = Z : gr === "back" && (Cr = oe), Cr;
                                    }, function(gr, Cr, cr) {
                                        return Cr.def(cr, '==="front"?', Z, ":", oe);
                                    });
                                case bu:
                                    return Ar(function(gr) {
                                        return gr;
                                    }, function(gr, Cr, cr) {
                                        return cr;
                                    });
                                case mf:
                                    return Ar(function(gr) {
                                        return ii[gr];
                                    }, function(gr, Cr, cr) {
                                        return Cr.def(cr + '==="cw"?' + we + ":" + Be);
                                    });
                                case nu:
                                    return Ar(function(gr) {
                                        return gr.map(function(Cr) {
                                            return !!Cr;
                                        });
                                    }, function(gr, Cr, cr) {
                                        return M(4, function(Gr) {
                                            return "!!" + cr + "[" + Gr + "]";
                                        });
                                    });
                                case eo:
                                    return Ar(function(gr) {
                                        var Cr = "value" in gr ? gr.value : 1, cr = !!gr.invert;
                                        return [
                                            Cr,
                                            cr
                                        ];
                                    }, function(gr, Cr, cr) {
                                        var Gr = Cr.def('"value" in ', cr, "?+", cr, ".value:1"), ei = Cr.def("!!", cr, ".invert");
                                        return [
                                            Gr,
                                            ei
                                        ];
                                    });
                            }
                        }), dr;
                    }
                    function El(vt, Pt) {
                        var Wt = vt.static, rr = vt.dynamic, dr = {};
                        return Object.keys(Wt).forEach(function(pr) {
                            var kr = Wt[pr], Ar;
                            if (typeof kr == "number" || typeof kr == "boolean") Ar = dn(function() {
                                return kr;
                            });
                            else if (typeof kr == "function") {
                                var gr = kr._reglType;
                                gr === "texture2d" || gr === "textureCube" ? Ar = dn(function(Cr) {
                                    return Cr.link(kr);
                                }) : (gr === "framebuffer" || gr === "framebufferCube") && (Ar = dn(function(Cr) {
                                    return Cr.link(kr.color[0]);
                                }));
                            } else an(kr) && (Ar = dn(function(Cr) {
                                var cr = Cr.global.def("[", M(kr.length, function(Gr) {
                                    return kr[Gr];
                                }), "]");
                                return cr;
                            }));
                            Ar.value = kr, dr[pr] = Ar;
                        }), Object.keys(rr).forEach(function(pr) {
                            var kr = rr[pr];
                            dr[pr] = En(kr, function(Ar, gr) {
                                return Ar.invoke(gr, kr);
                            });
                        }), dr;
                    }
                    function bc(vt, Pt) {
                        var Wt = vt.static, rr = vt.dynamic, dr = {};
                        return Object.keys(Wt).forEach(function(pr) {
                            var kr = Wt[pr], Ar = Er.id(pr), gr = new ji;
                            if (vi(kr)) gr.state = Ea, gr.buffer = Ui.getBuffer(Ui.create(kr, mr, !1, !0)), gr.type = 0;
                            else {
                                var Cr = Ui.getBuffer(kr);
                                if (Cr) gr.state = Ea, gr.buffer = Cr, gr.type = 0;
                                else if ("constant" in kr) {
                                    var cr = kr.constant;
                                    gr.buffer = "null", gr.state = qa, typeof cr == "number" ? gr.x = cr : Ma.forEach(function(Qn, qn) {
                                        qn < cr.length && (gr[Qn] = cr[qn]);
                                    });
                                } else {
                                    vi(kr.buffer) ? Cr = Ui.getBuffer(Ui.create(kr.buffer, mr, !1, !0)) : Cr = Ui.getBuffer(kr.buffer);
                                    var Gr = kr.offset | 0, ei = kr.stride | 0, yi = kr.size | 0, tn = !!kr.normalized, Ri = 0;
                                    "type" in kr && (Ri = bi[kr.type]);
                                    var ln = kr.divisor | 0;
                                    gr.buffer = Cr, gr.state = Ea, gr.size = yi, gr.normalized = tn, gr.type = Ri || Cr.dtype, gr.offset = Gr, gr.stride = ei, gr.divisor = ln;
                                }
                            }
                            dr[pr] = dn(function(Qn, qn) {
                                var rn = Qn.attribCache;
                                if (Ar in rn) return rn[Ar];
                                var bn = {
                                    isStream: !1
                                };
                                return Object.keys(gr).forEach(function(mn) {
                                    bn[mn] = gr[mn];
                                }), gr.buffer && (bn.buffer = Qn.link(gr.buffer), bn.type = bn.type || bn.buffer + ".dtype"), rn[Ar] = bn, bn;
                            });
                        }), Object.keys(rr).forEach(function(pr) {
                            var kr = rr[pr];
                            function Ar(gr, Cr) {
                                var cr = gr.invoke(Cr, kr), Gr = gr.shared, ei = gr.constants, yi = Gr.isBufferArgs, tn = Gr.buffer, Ri = {
                                    isStream: Cr.def(!1)
                                }, ln = new ji;
                                ln.state = Ea, Object.keys(ln).forEach(function(bn) {
                                    Ri[bn] = Cr.def("" + ln[bn]);
                                });
                                var Qn = Ri.buffer, qn = Ri.type;
                                Cr("if(", yi, "(", cr, ")){", Ri.isStream, "=true;", Qn, "=", tn, ".createStream(", mr, ",", cr, ");", qn, "=", Qn, ".dtype;", "}else{", Qn, "=", tn, ".getBuffer(", cr, ");", "if(", Qn, "){", qn, "=", Qn, ".dtype;", '}else if("constant" in ', cr, "){", Ri.state, "=", qa, ";", "if(typeof " + cr + '.constant === "number"){', Ri[Ma[0]], "=", cr, ".constant;", Ma.slice(1).map(function(bn) {
                                    return Ri[bn];
                                }).join("="), "=0;", "}else{", Ma.map(function(bn, mn) {
                                    return Ri[bn] + "=" + cr + ".constant.length>" + mn + "?" + cr + ".constant[" + mn + "]:0;";
                                }).join(""), "}}else{", "if(", yi, "(", cr, ".buffer)){", Qn, "=", tn, ".createStream(", mr, ",", cr, ".buffer);", "}else{", Qn, "=", tn, ".getBuffer(", cr, ".buffer);", "}", qn, '="type" in ', cr, "?", ei.glTypes, "[", cr, ".type]:", Qn, ".dtype;", Ri.normalized, "=!!", cr, ".normalized;");
                                function rn(bn) {
                                    Cr(Ri[bn], "=", cr, ".", bn, "|0;");
                                }
                                return rn("size"), rn("offset"), rn("stride"), rn("divisor"), Cr("}}"), Cr.exit("if(", Ri.isStream, "){", tn, ".destroyStream(", Qn, ");", "}"), Ri;
                            }
                            dr[pr] = En(kr, Ar);
                        }), dr;
                    }
                    function wc(vt) {
                        var Pt = vt.static, Wt = vt.dynamic, rr = {};
                        return Object.keys(Pt).forEach(function(dr) {
                            var pr = Pt[dr];
                            rr[dr] = dn(function(kr, Ar) {
                                return typeof pr == "number" || typeof pr == "boolean" ? "" + pr : kr.link(pr);
                            });
                        }), Object.keys(Wt).forEach(function(dr) {
                            var pr = Wt[dr];
                            rr[dr] = En(pr, function(kr, Ar) {
                                return kr.invoke(Ar, pr);
                            });
                        }), rr;
                    }
                    function yf(vt, Pt, Wt, rr, dr) {
                        var pr = vt.static, kr = vt.dynamic, Ar = Yl(vt, Pt), gr = Po(vt, dr), Cr = Jo(vt, gr, dr), cr = xs(vt, dr), Gr = Qc(vt, dr), ei = $c(vt, dr, Ar);
                        function yi(rn) {
                            var bn = Cr[rn];
                            bn && (Gr[rn] = bn);
                        }
                        yi(ee), yi(aa(Q));
                        var tn = Object.keys(Gr).length > 0, Ri = {
                            framebuffer: gr,
                            draw: cr,
                            shader: ei,
                            state: Gr,
                            dirty: tn,
                            scopeVAO: null,
                            drawVAO: null,
                            useVAO: !1,
                            attributes: {}
                        };
                        if (Ri.profile = _o(vt, dr), Ri.uniforms = El(Wt, dr), Ri.drawVAO = Ri.scopeVAO = cr.vao, !Ri.drawVAO && ei.program && !Ar && Wr.angle_instanced_arrays && cr.static.elements) {
                            var ln = !0, Qn = ei.program.attributes.map(function(rn) {
                                var bn = Pt.static[rn];
                                return ln = ln && !!bn, bn;
                            });
                            if (ln && Qn.length > 0) {
                                var qn = Bn.getVAO(Bn.createVAO({
                                    attributes: Qn,
                                    elements: cr.static.elements
                                }));
                                Ri.drawVAO = new Jr(null, null, null, function(rn, bn) {
                                    return rn.link(qn);
                                }), Ri.useVAO = !0;
                            }
                        }
                        return Ar ? Ri.useVAO = !0 : Ri.attributes = bc(Pt, dr), Ri.context = wc(rr, dr), Ri;
                    }
                    function Gl(vt, Pt, Wt) {
                        var rr = vt.shared, dr = rr.context, pr = vt.scope();
                        Object.keys(Wt).forEach(function(kr) {
                            Pt.save(dr, "." + kr);
                            var Ar = Wt[kr], gr = Ar.append(vt, Pt);
                            Array.isArray(gr) ? pr(dr, ".", kr, "=[", gr.join(), "];") : pr(dr, ".", kr, "=", gr, ";");
                        }), Pt(pr);
                    }
                    function Fc(vt, Pt, Wt, rr) {
                        var dr = vt.shared, pr = dr.gl, kr = dr.framebuffer, Ar;
                        gn && (Ar = Pt.def(dr.extensions, ".webgl_draw_buffers"));
                        var gr = vt.constants, Cr = gr.drawBuffer, cr = gr.backBuffer, Gr;
                        Wt ? Gr = Wt.append(vt, Pt) : Gr = Pt.def(kr, ".next"), rr || Pt("if(", Gr, "!==", kr, ".cur){"), Pt("if(", Gr, "){", pr, ".bindFramebuffer(", Ir, ",", Gr, ".framebuffer);"), gn && Pt(Ar, ".drawBuffersWEBGL(", Cr, "[", Gr, ".colorAttachments.length]);"), Pt("}else{", pr, ".bindFramebuffer(", Ir, ",null);"), gn && Pt(Ar, ".drawBuffersWEBGL(", cr, ");"), Pt("}", kr, ".cur=", Gr, ";"), rr || Pt("}");
                    }
                    function ef(vt, Pt, Wt) {
                        var rr = vt.shared, dr = rr.gl, pr = vt.current, kr = vt.next, Ar = rr.current, gr = rr.next, Cr = vt.cond(Ar, ".dirty");
                        wn.forEach(function(cr) {
                            var Gr = aa(cr);
                            if (!(Gr in Wt.state)) {
                                var ei, yi;
                                if (Gr in kr) {
                                    ei = kr[Gr], yi = pr[Gr];
                                    var tn = M(Kn[Gr].length, function(ln) {
                                        return Cr.def(ei, "[", ln, "]");
                                    });
                                    Cr(vt.cond(tn.map(function(ln, Qn) {
                                        return ln + "!==" + yi + "[" + Qn + "]";
                                    }).join("||")).then(dr, ".", Aa[Gr], "(", tn, ");", tn.map(function(ln, Qn) {
                                        return yi + "[" + Qn + "]=" + ln;
                                    }).join(";"), ";"));
                                } else {
                                    ei = Cr.def(gr, ".", Gr);
                                    var Ri = vt.cond(ei, "!==", Ar, ".", Gr);
                                    Cr(Ri), Gr in vn ? Ri(vt.cond(ei).then(dr, ".enable(", vn[Gr], ");").else(dr, ".disable(", vn[Gr], ");"), Ar, ".", Gr, "=", ei, ";") : Ri(dr, ".", Aa[Gr], "(", ei, ");", Ar, ".", Gr, "=", ei, ";");
                                }
                            }
                        }), Object.keys(Wt.state).length === 0 && Cr(Ar, ".dirty=false;"), Pt(Cr);
                    }
                    function ls(vt, Pt, Wt, rr) {
                        var dr = vt.shared, pr = vt.current, kr = dr.current, Ar = dr.gl, gr;
                        ci(Object.keys(Wt)).forEach(function(Cr) {
                            var cr = Wt[Cr];
                            if (!(rr && !rr(cr))) {
                                var Gr = cr.append(vt, Pt);
                                if (vn[Cr]) {
                                    var ei = vn[Cr];
                                    un(cr) ? (gr = vt.link(Gr, {
                                        stable: !0
                                    }), Pt(vt.cond(gr).then(Ar, ".enable(", ei, ");").else(Ar, ".disable(", ei, ");")), Pt(kr, ".", Cr, "=", gr, ";")) : (Pt(vt.cond(Gr).then(Ar, ".enable(", ei, ");").else(Ar, ".disable(", ei, ");")), Pt(kr, ".", Cr, "=", Gr, ";"));
                                } else if (an(Gr)) {
                                    var yi = pr[Cr];
                                    Pt(Ar, ".", Aa[Cr], "(", Gr, ");", Gr.map(function(tn, Ri) {
                                        return yi + "[" + Ri + "]=" + tn;
                                    }).join(";"), ";");
                                } else un(cr) ? (gr = vt.link(Gr, {
                                    stable: !0
                                }), Pt(Ar, ".", Aa[Cr], "(", gr, ");", kr, ".", Cr, "=", gr, ";")) : Pt(Ar, ".", Aa[Cr], "(", Gr, ");", kr, ".", Cr, "=", Gr, ";");
                            }
                        });
                    }
                    function _f(vt, Pt) {
                        Un && (vt.instancing = Pt.def(vt.shared.extensions, ".angle_instanced_arrays"));
                    }
                    function ns(vt, Pt, Wt, rr, dr) {
                        var pr = vt.shared, kr = vt.stats, Ar = pr.current, gr = pr.timer, Cr = Wt.profile;
                        function cr() {
                            return typeof performance == "undefined" ? "Date.now()" : "performance.now()";
                        }
                        var Gr, ei;
                        function yi(rn) {
                            Gr = Pt.def(), rn(Gr, "=", cr(), ";"), typeof dr == "string" ? rn(kr, ".count+=", dr, ";") : rn(kr, ".count++;"), Dn && (rr ? (ei = Pt.def(), rn(ei, "=", gr, ".getNumPendingQueries();")) : rn(gr, ".beginQuery(", kr, ");"));
                        }
                        function tn(rn) {
                            rn(kr, ".cpuTime+=", cr(), "-", Gr, ";"), Dn && (rr ? rn(gr, ".pushScopeStats(", ei, ",", gr, ".getNumPendingQueries(),", kr, ");") : rn(gr, ".endQuery();"));
                        }
                        function Ri(rn) {
                            var bn = Pt.def(Ar, ".profile");
                            Pt(Ar, ".profile=", rn, ";"), Pt.exit(Ar, ".profile=", bn, ";");
                        }
                        var ln;
                        if (Cr) {
                            if (un(Cr)) {
                                Cr.enable ? (yi(Pt), tn(Pt.exit), Ri("true")) : Ri("false");
                                return;
                            }
                            ln = Cr.append(vt, Pt), Ri(ln);
                        } else ln = Pt.def(Ar, ".profile");
                        var Qn = vt.block();
                        yi(Qn), Pt("if(", ln, "){", Qn, "}");
                        var qn = vt.block();
                        tn(qn), Pt.exit("if(", ln, "){", qn, "}");
                    }
                    function Y1(vt, Pt, Wt, rr, dr) {
                        var pr = vt.shared;
                        function kr(gr) {
                            switch(gr){
                                case To:
                                case Ds:
                                case _l:
                                    return 2;
                                case Wa:
                                case As:
                                case Hl:
                                    return 3;
                                case co:
                                case yo:
                                case Zu:
                                    return 4;
                                default:
                                    return 1;
                            }
                        }
                        function Ar(gr, Cr, cr) {
                            var Gr = pr.gl, ei = Pt.def(gr, ".location"), yi = Pt.def(pr.attributes, "[", ei, "]"), tn = cr.state, Ri = cr.buffer, ln = [
                                cr.x,
                                cr.y,
                                cr.z,
                                cr.w
                            ], Qn = [
                                "buffer",
                                "normalized",
                                "offset",
                                "stride"
                            ];
                            function qn() {
                                Pt("if(!", yi, ".buffer){", Gr, ".enableVertexAttribArray(", ei, ");}");
                                var bn = cr.type, mn;
                                if (cr.size ? mn = Pt.def(cr.size, "||", Cr) : mn = Cr, Pt("if(", yi, ".type!==", bn, "||", yi, ".size!==", mn, "||", Qn.map(function(da) {
                                    return yi + "." + da + "!==" + cr[da];
                                }).join("||"), "){", Gr, ".bindBuffer(", mr, ",", Ri, ".buffer);", Gr, ".vertexAttribPointer(", [
                                    ei,
                                    mn,
                                    bn,
                                    cr.normalized,
                                    cr.stride,
                                    cr.offset
                                ], ");", yi, ".type=", bn, ";", yi, ".size=", mn, ";", Qn.map(function(da) {
                                    return yi + "." + da + "=" + cr[da] + ";";
                                }).join(""), "}"), Un) {
                                    var Gn = cr.divisor;
                                    Pt("if(", yi, ".divisor!==", Gn, "){", vt.instancing, ".vertexAttribDivisorANGLE(", [
                                        ei,
                                        Gn
                                    ], ");", yi, ".divisor=", Gn, ";}");
                                }
                            }
                            function rn() {
                                Pt("if(", yi, ".buffer){", Gr, ".disableVertexAttribArray(", ei, ");", yi, ".buffer=null;", "}if(", Ma.map(function(bn, mn) {
                                    return yi + "." + bn + "!==" + ln[mn];
                                }).join("||"), "){", Gr, ".vertexAttrib4f(", ei, ",", ln, ");", Ma.map(function(bn, mn) {
                                    return yi + "." + bn + "=" + ln[mn] + ";";
                                }).join(""), "}");
                            }
                            tn === Ea ? qn() : tn === qa ? rn() : (Pt("if(", tn, "===", Ea, "){"), qn(), Pt("}else{"), rn(), Pt("}"));
                        }
                        rr.forEach(function(gr) {
                            var Cr = gr.name, cr = Wt.attributes[Cr], Gr;
                            if (cr) {
                                if (!dr(cr)) return;
                                Gr = cr.append(vt, Pt);
                            } else {
                                if (!dr(Nn)) return;
                                var ei = vt.scopeAttrib(Cr);
                                Gr = {}, Object.keys(new ji).forEach(function(yi) {
                                    Gr[yi] = Pt.def(ei, ".", yi);
                                });
                            }
                            Ar(vt.link(gr), kr(gr.info.type), Gr);
                        });
                    }
                    function z(vt, Pt, Wt, rr, dr, pr) {
                        for(var kr = vt.shared, Ar = kr.gl, gr, Cr = 0; Cr < rr.length; ++Cr){
                            var cr = rr[Cr], Gr = cr.name, ei = cr.info.type, yi = Wt.uniforms[Gr], tn = vt.link(cr), Ri = tn + ".location", ln;
                            if (yi) {
                                if (!dr(yi)) continue;
                                if (un(yi)) {
                                    var Qn = yi.value;
                                    if (ei === zc || ei === zl) {
                                        var qn = vt.link(Qn._texture || Qn.color[0]._texture);
                                        Pt(Ar, ".uniform1i(", Ri, ",", qn + ".bind());"), Pt.exit(qn, ".unbind();");
                                    } else if (ei === cu || ei === el || ei === au) {
                                        var rn = vt.global.def("new Float32Array([" + Array.prototype.slice.call(Qn) + "])"), bn = 2;
                                        ei === el ? bn = 3 : ei === au && (bn = 4), Pt(Ar, ".uniformMatrix", bn, "fv(", Ri, ",false,", rn, ");");
                                    } else {
                                        switch(ei){
                                            case Ga:
                                                gr = "1f";
                                                break;
                                            case To:
                                                gr = "2f";
                                                break;
                                            case Wa:
                                                gr = "3f";
                                                break;
                                            case co:
                                                gr = "4f";
                                                break;
                                            case po:
                                                gr = "1i";
                                                break;
                                            case Ro:
                                                gr = "1i";
                                                break;
                                            case _l:
                                                gr = "2i";
                                                break;
                                            case Ds:
                                                gr = "2i";
                                                break;
                                            case Hl:
                                                gr = "3i";
                                                break;
                                            case As:
                                                gr = "3i";
                                                break;
                                            case Zu:
                                                gr = "4i";
                                                break;
                                            case yo:
                                                gr = "4i";
                                                break;
                                        }
                                        Pt(Ar, ".uniform", gr, "(", Ri, ",", an(Qn) ? Array.prototype.slice.call(Qn) : Qn, ");");
                                    }
                                    continue;
                                } else ln = yi.append(vt, Pt);
                            } else {
                                if (!dr(Nn)) continue;
                                ln = Pt.def(kr.uniforms, "[", Er.id(Gr), "]");
                            }
                            ei === zc ? Pt("if(", ln, "&&", ln, '._reglType==="framebuffer"){', ln, "=", ln, ".color[0];", "}") : ei === zl && Pt("if(", ln, "&&", ln, '._reglType==="framebufferCube"){', ln, "=", ln, ".color[0];", "}");
                            var mn = 1;
                            switch(ei){
                                case zc:
                                case zl:
                                    var Gn = Pt.def(ln, "._texture");
                                    Pt(Ar, ".uniform1i(", Ri, ",", Gn, ".bind());"), Pt.exit(Gn, ".unbind();");
                                    continue;
                                case Ro:
                                case po:
                                    gr = "1i";
                                    break;
                                case Ds:
                                case _l:
                                    gr = "2i", mn = 2;
                                    break;
                                case As:
                                case Hl:
                                    gr = "3i", mn = 3;
                                    break;
                                case yo:
                                case Zu:
                                    gr = "4i", mn = 4;
                                    break;
                                case Ga:
                                    gr = "1f";
                                    break;
                                case To:
                                    gr = "2f", mn = 2;
                                    break;
                                case Wa:
                                    gr = "3f", mn = 3;
                                    break;
                                case co:
                                    gr = "4f", mn = 4;
                                    break;
                                case cu:
                                    gr = "Matrix2fv";
                                    break;
                                case el:
                                    gr = "Matrix3fv";
                                    break;
                                case au:
                                    gr = "Matrix4fv";
                                    break;
                            }
                            if (gr.charAt(0) === "M") {
                                Pt(Ar, ".uniform", gr, "(", Ri, ",");
                                var da = Math.pow(ei - cu + 2, 2), No = vt.global.def("new Float32Array(", da, ")");
                                Array.isArray(ln) ? Pt("false,(", M(da, function(tl) {
                                    return No + "[" + tl + "]=" + ln[tl];
                                }), ",", No, ")") : Pt("false,(Array.isArray(", ln, ")||", ln, " instanceof Float32Array)?", ln, ":(", M(da, function(tl) {
                                    return No + "[" + tl + "]=" + ln + "[" + tl + "]";
                                }), ",", No, ")"), Pt(");");
                            } else if (mn > 1) {
                                for(var Do = [], ps = [], fo = 0; fo < mn; ++fo)Array.isArray(ln) ? ps.push(ln[fo]) : ps.push(Pt.def(ln + "[" + fo + "]")), pr && Do.push(Pt.def());
                                pr && Pt("if(!", vt.batchId, "||", Do.map(function(tl, zu) {
                                    return tl + "!==" + ps[zu];
                                }).join("||"), "){", Do.map(function(tl, zu) {
                                    return tl + "=" + ps[zu] + ";";
                                }).join("")), Pt(Ar, ".uniform", gr, "(", Ri, ",", ps.join(","), ");"), pr && Pt("}");
                            } else {
                                if (pr) {
                                    var as = Pt.def();
                                    Pt("if(!", vt.batchId, "||", as, "!==", ln, "){", as, "=", ln, ";");
                                }
                                Pt(Ar, ".uniform", gr, "(", Ri, ",", ln, ");"), pr && Pt("}");
                            }
                        }
                    }
                    function K(vt, Pt, Wt, rr) {
                        var dr = vt.shared, pr = dr.gl, kr = dr.draw, Ar = rr.draw;
                        function gr() {
                            var mn = Ar.elements, Gn, da = Pt;
                            return mn ? ((mn.contextDep && rr.contextDynamic || mn.propDep) && (da = Wt), Gn = mn.append(vt, da), Ar.elementsActive && da("if(" + Gn + ")" + pr + ".bindBuffer(" + Rr + "," + Gn + ".buffer.buffer);")) : (Gn = da.def(), da(Gn, "=", kr, ".", yt, ";", "if(", Gn, "){", pr, ".bindBuffer(", Rr, ",", Gn, ".buffer.buffer);}", "else if(", dr.vao, ".currentVAO){", Gn, "=", vt.shared.elements + ".getElements(" + dr.vao, ".currentVAO.elements);", ca ? "" : "if(" + Gn + ")" + pr + ".bindBuffer(" + Rr + "," + Gn + ".buffer.buffer);", "}")), Gn;
                        }
                        function Cr() {
                            var mn = Ar.count, Gn, da = Pt;
                            return mn ? ((mn.contextDep && rr.contextDynamic || mn.propDep) && (da = Wt), Gn = mn.append(vt, da)) : Gn = da.def(kr, ".", Nt), Gn;
                        }
                        var cr = gr();
                        function Gr(mn) {
                            var Gn = Ar[mn];
                            return Gn ? Gn.contextDep && rr.contextDynamic || Gn.propDep ? Gn.append(vt, Wt) : Gn.append(vt, Pt) : Pt.def(kr, ".", mn);
                        }
                        var ei = Gr(Ot), yi = Gr(hr), tn = Cr();
                        if (typeof tn == "number") {
                            if (tn === 0) return;
                        } else Wt("if(", tn, "){"), Wt.exit("}");
                        var Ri, ln;
                        Un && (Ri = Gr(Sr), ln = vt.instancing);
                        var Qn = cr + ".type", qn = Ar.elements && un(Ar.elements) && !Ar.vaoActive;
                        function rn() {
                            function mn() {
                                Wt(ln, ".drawElementsInstancedANGLE(", [
                                    ei,
                                    tn,
                                    Qn,
                                    yi + "<<((" + Qn + "-" + Ta + ")>>1)",
                                    Ri
                                ], ");");
                            }
                            function Gn() {
                                Wt(ln, ".drawArraysInstancedANGLE(", [
                                    ei,
                                    yi,
                                    tn,
                                    Ri
                                ], ");");
                            }
                            cr && cr !== "null" ? qn ? mn() : (Wt("if(", cr, "){"), mn(), Wt("}else{"), Gn(), Wt("}")) : Gn();
                        }
                        function bn() {
                            function mn() {
                                Wt(pr + ".drawElements(" + [
                                    ei,
                                    tn,
                                    Qn,
                                    yi + "<<((" + Qn + "-" + Ta + ")>>1)"
                                ] + ");");
                            }
                            function Gn() {
                                Wt(pr + ".drawArrays(" + [
                                    ei,
                                    yi,
                                    tn
                                ] + ");");
                            }
                            cr && cr !== "null" ? qn ? mn() : (Wt("if(", cr, "){"), mn(), Wt("}else{"), Gn(), Wt("}")) : Gn();
                        }
                        Un && (typeof Ri != "number" || Ri >= 0) ? typeof Ri == "string" ? (Wt("if(", Ri, ">0){"), rn(), Wt("}else if(", Ri, "<0){"), bn(), Wt("}")) : rn() : bn();
                    }
                    function O(vt, Pt, Wt, rr, dr) {
                        var pr = Oa(), kr = pr.proc("body", dr);
                        return Un && (pr.instancing = kr.def(pr.shared.extensions, ".angle_instanced_arrays")), vt(pr, kr, Wt, rr), pr.compile().body;
                    }
                    function $(vt, Pt, Wt, rr) {
                        _f(vt, Pt), Wt.useVAO ? Wt.drawVAO ? Pt(vt.shared.vao, ".setVAO(", Wt.drawVAO.append(vt, Pt), ");") : Pt(vt.shared.vao, ".setVAO(", vt.shared.vao, ".targetVAO);") : (Pt(vt.shared.vao, ".setVAO(null);"), Y1(vt, Pt, Wt, rr.attributes, function() {
                            return !0;
                        })), z(vt, Pt, Wt, rr.uniforms, function() {
                            return !0;
                        }, !1), K(vt, Pt, Pt, Wt);
                    }
                    function pe(vt, Pt) {
                        var Wt = vt.proc("draw", 1);
                        _f(vt, Wt), Gl(vt, Wt, Pt.context), Fc(vt, Wt, Pt.framebuffer), ef(vt, Wt, Pt), ls(vt, Wt, Pt.state), ns(vt, Wt, Pt, !1, !0);
                        var rr = Pt.shader.progVar.append(vt, Wt);
                        if (Wt(vt.shared.gl, ".useProgram(", rr, ".program);"), Pt.shader.program) $(vt, Wt, Pt, Pt.shader.program);
                        else {
                            Wt(vt.shared.vao, ".setVAO(null);");
                            var dr = vt.global.def("{}"), pr = Wt.def(rr, ".id"), kr = Wt.def(dr, "[", pr, "]");
                            Wt(vt.cond(kr).then(kr, ".call(this,a0);").else(kr, "=", dr, "[", pr, "]=", vt.link(function(Ar) {
                                return O($, vt, Pt, Ar, 1);
                            }), "(", rr, ");", kr, ".call(this,a0);"));
                        }
                        Object.keys(Pt.state).length > 0 && Wt(vt.shared.current, ".dirty=true;"), vt.shared.vao && Wt(vt.shared.vao, ".setVAO(null);");
                    }
                    function de(vt, Pt, Wt, rr) {
                        vt.batchId = "a1", _f(vt, Pt);
                        function dr() {
                            return !0;
                        }
                        Y1(vt, Pt, Wt, rr.attributes, dr), z(vt, Pt, Wt, rr.uniforms, dr, !1), K(vt, Pt, Pt, Wt);
                    }
                    function Ie(vt, Pt, Wt, rr) {
                        _f(vt, Pt);
                        var dr = Wt.contextDep, pr = Pt.def(), kr = "a0", Ar = "a1", gr = Pt.def();
                        vt.shared.props = gr, vt.batchId = pr;
                        var Cr = vt.scope(), cr = vt.scope();
                        Pt(Cr.entry, "for(", pr, "=0;", pr, "<", Ar, ";++", pr, "){", gr, "=", kr, "[", pr, "];", cr, "}", Cr.exit);
                        function Gr(Qn) {
                            return Qn.contextDep && dr || Qn.propDep;
                        }
                        function ei(Qn) {
                            return !Gr(Qn);
                        }
                        if (Wt.needsContext && Gl(vt, cr, Wt.context), Wt.needsFramebuffer && Fc(vt, cr, Wt.framebuffer), ls(vt, cr, Wt.state, Gr), Wt.profile && Gr(Wt.profile) && ns(vt, cr, Wt, !1, !0), rr) Wt.useVAO ? Wt.drawVAO ? Gr(Wt.drawVAO) ? cr(vt.shared.vao, ".setVAO(", Wt.drawVAO.append(vt, cr), ");") : Cr(vt.shared.vao, ".setVAO(", Wt.drawVAO.append(vt, Cr), ");") : Cr(vt.shared.vao, ".setVAO(", vt.shared.vao, ".targetVAO);") : (Cr(vt.shared.vao, ".setVAO(null);"), Y1(vt, Cr, Wt, rr.attributes, ei), Y1(vt, cr, Wt, rr.attributes, Gr)), z(vt, Cr, Wt, rr.uniforms, ei, !1), z(vt, cr, Wt, rr.uniforms, Gr, !0), K(vt, Cr, cr, Wt);
                        else {
                            var yi = vt.global.def("{}"), tn = Wt.shader.progVar.append(vt, cr), Ri = cr.def(tn, ".id"), ln = cr.def(yi, "[", Ri, "]");
                            cr(vt.shared.gl, ".useProgram(", tn, ".program);", "if(!", ln, "){", ln, "=", yi, "[", Ri, "]=", vt.link(function(Qn) {
                                return O(de, vt, Wt, Qn, 2);
                            }), "(", tn, ");}", ln, ".call(this,a0[", pr, "],", pr, ");");
                        }
                    }
                    function $e(vt, Pt) {
                        var Wt = vt.proc("batch", 2);
                        vt.batchId = "0", _f(vt, Wt);
                        var rr = !1, dr = !0;
                        Object.keys(Pt.context).forEach(function(yi) {
                            rr = rr || Pt.context[yi].propDep;
                        }), rr || (Gl(vt, Wt, Pt.context), dr = !1);
                        var pr = Pt.framebuffer, kr = !1;
                        pr ? (pr.propDep ? rr = kr = !0 : pr.contextDep && rr && (kr = !0), kr || Fc(vt, Wt, pr)) : Fc(vt, Wt, null), Pt.state.viewport && Pt.state.viewport.propDep && (rr = !0);
                        function Ar(yi) {
                            return yi.contextDep && rr || yi.propDep;
                        }
                        ef(vt, Wt, Pt), ls(vt, Wt, Pt.state, function(yi) {
                            return !Ar(yi);
                        }), (!Pt.profile || !Ar(Pt.profile)) && ns(vt, Wt, Pt, !1, "a1"), Pt.contextDep = rr, Pt.needsContext = dr, Pt.needsFramebuffer = kr;
                        var gr = Pt.shader.progVar;
                        if (gr.contextDep && rr || gr.propDep) Ie(vt, Wt, Pt, null);
                        else {
                            var Cr = gr.append(vt, Wt);
                            if (Wt(vt.shared.gl, ".useProgram(", Cr, ".program);"), Pt.shader.program) Ie(vt, Wt, Pt, Pt.shader.program);
                            else {
                                Wt(vt.shared.vao, ".setVAO(null);");
                                var cr = vt.global.def("{}"), Gr = Wt.def(Cr, ".id"), ei = Wt.def(cr, "[", Gr, "]");
                                Wt(vt.cond(ei).then(ei, ".call(this,a0,a1);").else(ei, "=", cr, "[", Gr, "]=", vt.link(function(yi) {
                                    return O(Ie, vt, Pt, yi, 2);
                                }), "(", Cr, ");", ei, ".call(this,a0,a1);"));
                            }
                        }
                        Object.keys(Pt.state).length > 0 && Wt(vt.shared.current, ".dirty=true;"), vt.shared.vao && Wt(vt.shared.vao, ".setVAO(null);");
                    }
                    function pt(vt, Pt) {
                        var Wt = vt.proc("scope", 3);
                        vt.batchId = "a2";
                        var rr = vt.shared, dr = rr.current;
                        if (Gl(vt, Wt, Pt.context), Pt.framebuffer && Pt.framebuffer.append(vt, Wt), ci(Object.keys(Pt.state)).forEach(function(Ar) {
                            var gr = Pt.state[Ar], Cr = gr.append(vt, Wt);
                            an(Cr) ? Cr.forEach(function(cr, Gr) {
                                ma(cr) ? Wt.set(vt.next[Ar], "[" + Gr + "]", cr) : Wt.set(vt.next[Ar], "[" + Gr + "]", vt.link(cr, {
                                    stable: !0
                                }));
                            }) : un(gr) ? Wt.set(rr.next, "." + Ar, vt.link(Cr, {
                                stable: !0
                            })) : Wt.set(rr.next, "." + Ar, Cr);
                        }), ns(vt, Wt, Pt, !0, !0), [
                            yt,
                            hr,
                            Nt,
                            Sr,
                            Ot
                        ].forEach(function(Ar) {
                            var gr = Pt.draw[Ar];
                            if (gr) {
                                var Cr = gr.append(vt, Wt);
                                ma(Cr) ? Wt.set(rr.draw, "." + Ar, Cr) : Wt.set(rr.draw, "." + Ar, vt.link(Cr), {
                                    stable: !0
                                });
                            }
                        }), Object.keys(Pt.uniforms).forEach(function(Ar) {
                            var gr = Pt.uniforms[Ar].append(vt, Wt);
                            Array.isArray(gr) && (gr = "[" + gr.map(function(Cr) {
                                return ma(Cr) ? Cr : vt.link(Cr, {
                                    stable: !0
                                });
                            }) + "]"), Wt.set(rr.uniforms, "[" + vt.link(Er.id(Ar), {
                                stable: !0
                            }) + "]", gr);
                        }), Object.keys(Pt.attributes).forEach(function(Ar) {
                            var gr = Pt.attributes[Ar].append(vt, Wt), Cr = vt.scopeAttrib(Ar);
                            Object.keys(new ji).forEach(function(cr) {
                                Wt.set(Cr, "." + cr, gr[cr]);
                            });
                        }), Pt.scopeVAO) {
                            var pr = Pt.scopeVAO.append(vt, Wt);
                            ma(pr) ? Wt.set(rr.vao, ".targetVAO", pr) : Wt.set(rr.vao, ".targetVAO", vt.link(pr, {
                                stable: !0
                            }));
                        }
                        function kr(Ar) {
                            var gr = Pt.shader[Ar];
                            if (gr) {
                                var Cr = gr.append(vt, Wt);
                                ma(Cr) ? Wt.set(rr.shader, "." + Ar, Cr) : Wt.set(rr.shader, "." + Ar, vt.link(Cr, {
                                    stable: !0
                                }));
                            }
                        }
                        kr(je), kr(it), Object.keys(Pt.state).length > 0 && (Wt(dr, ".dirty=true;"), Wt.exit(dr, ".dirty=true;")), Wt("a1(", vt.shared.context, ",a0,", vt.batchId, ");");
                    }
                    function Kt(vt) {
                        if (!(typeof vt != "object" || an(vt))) {
                            for(var Pt = Object.keys(vt), Wt = 0; Wt < Pt.length; ++Wt)if (h.isDynamic(vt[Pt[Wt]])) return !0;
                            return !1;
                        }
                    }
                    function ir(vt, Pt, Wt) {
                        var rr = Pt.static[Wt];
                        if (!rr || !Kt(rr)) return;
                        var dr = vt.global, pr = Object.keys(rr), kr = !1, Ar = !1, gr = !1, Cr = vt.global.def("{}");
                        pr.forEach(function(Gr) {
                            var ei = rr[Gr];
                            if (h.isDynamic(ei)) {
                                typeof ei == "function" && (ei = rr[Gr] = h.unbox(ei));
                                var yi = En(ei, null);
                                kr = kr || yi.thisDep, gr = gr || yi.propDep, Ar = Ar || yi.contextDep;
                            } else {
                                switch(dr(Cr, ".", Gr, "="), typeof ei){
                                    case "number":
                                        dr(ei);
                                        break;
                                    case "string":
                                        dr('"', ei, '"');
                                        break;
                                    case "object":
                                        Array.isArray(ei) && dr("[", ei.join(), "]");
                                        break;
                                    default:
                                        dr(vt.link(ei));
                                        break;
                                }
                                dr(";");
                            }
                        });
                        function cr(Gr, ei) {
                            pr.forEach(function(yi) {
                                var tn = rr[yi];
                                if (h.isDynamic(tn)) {
                                    var Ri = Gr.invoke(ei, tn);
                                    ei(Cr, ".", yi, "=", Ri, ";");
                                }
                            });
                        }
                        Pt.dynamic[Wt] = new h.DynamicVariable(Xo, {
                            thisDep: kr,
                            contextDep: Ar,
                            propDep: gr,
                            ref: Cr,
                            append: cr
                        }), delete Pt.static[Wt];
                    }
                    function Jt(vt, Pt, Wt, rr, dr) {
                        var pr = Oa();
                        pr.stats = pr.link(dr), Object.keys(Pt.static).forEach(function(Ar) {
                            ir(pr, Pt, Ar);
                        }), tr.forEach(function(Ar) {
                            ir(pr, vt, Ar);
                        });
                        var kr = yf(vt, Pt, Wt, rr, pr);
                        return kr.shader.program && (kr.shader.program.attributes.sort(function(Ar, gr) {
                            return Ar.name < gr.name ? -1 : 1;
                        }), kr.shader.program.uniforms.sort(function(Ar, gr) {
                            return Ar.name < gr.name ? -1 : 1;
                        })), pe(pr, kr), pt(pr, kr), $e(pr, kr), e(pr.compile(), {
                            destroy: function() {
                                kr.shader.program.destroy();
                            }
                        });
                    }
                    return {
                        next: Za,
                        current: Kn,
                        procs: function() {
                            var vt = Oa(), Pt = vt.proc("poll"), Wt = vt.proc("refresh"), rr = vt.block();
                            Pt(rr), Wt(rr);
                            var dr = vt.shared, pr = dr.gl, kr = dr.next, Ar = dr.current;
                            rr(Ar, ".dirty=false;"), Fc(vt, Pt), Fc(vt, Wt, null, !0);
                            var gr;
                            Un && (gr = vt.link(Un)), Wr.oes_vertex_array_object && Wt(vt.link(Wr.oes_vertex_array_object), ".bindVertexArrayOES(null);");
                            var Cr = Wt.def(dr.attributes), cr = Wt.def(0), Gr = vt.cond(cr, ".buffer");
                            Gr.then(pr, ".enableVertexAttribArray(i);", pr, ".bindBuffer(", mr, ",", cr, ".buffer.buffer);", pr, ".vertexAttribPointer(i,", cr, ".size,", cr, ".type,", cr, ".normalized,", cr, ".stride,", cr, ".offset);").else(pr, ".disableVertexAttribArray(i);", pr, ".vertexAttrib4f(i,", cr, ".x,", cr, ".y,", cr, ".z,", cr, ".w);", cr, ".buffer=null;");
                            var ei = vt.link(wi.maxAttributes, {
                                stable: !0
                            });
                            return Wt("for(var i=0;i<", ei, ";++i){", cr, "=", Cr, "[i];", Gr, "}"), Un && Wt("for(var i=0;i<", ei, ";++i){", gr, ".vertexAttribDivisorANGLE(i,", Cr, "[i].divisor);", "}"), Wt(vt.shared.vao, ".currentVAO=null;", vt.shared.vao, ".setVAO(", vt.shared.vao, ".targetVAO);"), Object.keys(vn).forEach(function(yi) {
                                var tn = vn[yi], Ri = rr.def(kr, ".", yi), ln = vt.block();
                                ln("if(", Ri, "){", pr, ".enable(", tn, ")}else{", pr, ".disable(", tn, ")}", Ar, ".", yi, "=", Ri, ";"), Wt(ln), Pt("if(", Ri, "!==", Ar, ".", yi, "){", ln, "}");
                            }), Object.keys(Aa).forEach(function(yi) {
                                var tn = Aa[yi], Ri = Kn[yi], ln, Qn, qn = vt.block();
                                if (qn(pr, ".", tn, "("), an(Ri)) {
                                    var rn = Ri.length;
                                    ln = vt.global.def(kr, ".", yi), Qn = vt.global.def(Ar, ".", yi), qn(M(rn, function(bn) {
                                        return ln + "[" + bn + "]";
                                    }), ");", M(rn, function(bn) {
                                        return Qn + "[" + bn + "]=" + ln + "[" + bn + "];";
                                    }).join("")), Pt("if(", M(rn, function(bn) {
                                        return ln + "[" + bn + "]!==" + Qn + "[" + bn + "]";
                                    }).join("||"), "){", qn, "}");
                                } else ln = rr.def(kr, ".", yi), Qn = rr.def(Ar, ".", yi), qn(ln, ");", Ar, ".", yi, "=", ln, ";"), Pt("if(", ln, "!==", Qn, "){", qn, "}");
                                Wt(qn);
                            }), vt.compile();
                        }(),
                        compile: Jt
                    };
                }
                function ya() {
                    return {
                        vaoCount: 0,
                        bufferCount: 0,
                        elementsCount: 0,
                        framebufferCount: 0,
                        shaderCount: 0,
                        textureCount: 0,
                        cubeCount: 0,
                        renderbufferCount: 0,
                        maxTextureUnits: 0
                    };
                }
                var so = 34918, wa = 34919, io = 35007, Ss = function(At, Er) {
                    if (!Er.ext_disjoint_timer_query) return null;
                    var Wr = [];
                    function wi() {
                        return Wr.pop() || Er.ext_disjoint_timer_query.createQueryEXT();
                    }
                    function Ui(Ln) {
                        Wr.push(Ln);
                    }
                    var Oi = [];
                    function Bi(Ln) {
                        var Un = wi();
                        Er.ext_disjoint_timer_query.beginQueryEXT(io, Un), Oi.push(Un), Dn(Oi.length - 1, Oi.length, Ln);
                    }
                    function cn() {
                        Er.ext_disjoint_timer_query.endQueryEXT(io);
                    }
                    function On() {
                        this.startQueryIndex = -1, this.endQueryIndex = -1, this.sum = 0, this.stats = null;
                    }
                    var Bn = [];
                    function yn() {
                        return Bn.pop() || new On;
                    }
                    function to(Ln) {
                        Bn.push(Ln);
                    }
                    var Rn = [];
                    function Dn(Ln, Un, gn) {
                        var ca = yn();
                        ca.startQueryIndex = Ln, ca.endQueryIndex = Un, ca.sum = 0, ca.stats = gn, Rn.push(ca);
                    }
                    var fn = [], Ai = [];
                    function ji() {
                        var Ln, Un, gn = Oi.length;
                        if (gn !== 0) {
                            Ai.length = Math.max(Ai.length, gn + 1), fn.length = Math.max(fn.length, gn + 1), fn[0] = 0, Ai[0] = 0;
                            var ca = 0;
                            for(Ln = 0, Un = 0; Un < Oi.length; ++Un){
                                var Kn = Oi[Un];
                                Er.ext_disjoint_timer_query.getQueryObjectEXT(Kn, wa) ? (ca += Er.ext_disjoint_timer_query.getQueryObjectEXT(Kn, so), Ui(Kn)) : Oi[Ln++] = Kn, fn[Un + 1] = ca, Ai[Un + 1] = Ln;
                            }
                            for(Oi.length = Ln, Ln = 0, Un = 0; Un < Rn.length; ++Un){
                                var Za = Rn[Un], wn = Za.startQueryIndex, vn = Za.endQueryIndex;
                                Za.sum += fn[vn] - fn[wn];
                                var Aa = Ai[wn], aa = Ai[vn];
                                aa === Aa ? (Za.stats.gpuTime += Za.sum / 1e6, to(Za)) : (Za.startQueryIndex = Aa, Za.endQueryIndex = aa, Rn[Ln++] = Za);
                            }
                            Rn.length = Ln;
                        }
                    }
                    return {
                        beginQuery: Bi,
                        endQuery: cn,
                        pushScopeStats: Dn,
                        update: ji,
                        getNumPendingQueries: function() {
                            return Oi.length;
                        },
                        clear: function() {
                            Wr.push.apply(Wr, Oi);
                            for(var Ln = 0; Ln < Wr.length; Ln++)Er.ext_disjoint_timer_query.deleteQueryEXT(Wr[Ln]);
                            Oi.length = 0, Wr.length = 0;
                        },
                        restore: function() {
                            Oi.length = 0, Wr.length = 0;
                        }
                    };
                }, _s = 16384, Ns = 256, pn = 1024, za = 34962, Lo = "webglcontextlost", Fo = "webglcontextrestored", js = 1, xl = 2, fu = 3;
                function dl(At, Er) {
                    for(var Wr = 0; Wr < At.length; ++Wr)if (At[Wr] === Er) return Wr;
                    return -1;
                }
                function xc(At) {
                    var Er = _(At);
                    if (!Er) return null;
                    var Wr = Er.gl, wi = Wr.getContextAttributes(), Ui = Wr.isContextLost(), Oi = C(Wr, Er);
                    if (!Oi) return null;
                    var Bi = x(), cn = ya(), On = Er.cachedCode || {}, Bn = Oi.extensions, yn = Ss(Wr, Bn), to = v(), Rn = Wr.drawingBufferWidth, Dn = Wr.drawingBufferHeight, fn = {
                        tick: 0,
                        time: 0,
                        viewportWidth: Rn,
                        viewportHeight: Dn,
                        framebufferWidth: Rn,
                        framebufferHeight: Dn,
                        drawingBufferWidth: Rn,
                        drawingBufferHeight: Dn,
                        pixelRatio: Er.pixelRatio
                    }, Ai = {}, ji = {
                        elements: null,
                        primitive: 4,
                        count: -1,
                        offset: 0,
                        instances: -1
                    }, Ln = Br(Wr, Bn), Un = Zr(Wr, cn, Er, Kn), gn = br(Wr, Bn, Un, cn), ca = xu(Wr, Bn, Ln, cn, Un, gn, ji);
                    function Kn(O) {
                        return ca.destroyBuffer(O);
                    }
                    var Za = ju(Wr, Bi, cn, Er), wn = df(Wr, Bn, Ln, function() {
                        aa.procs.poll();
                    }, fn, cn, Er), vn = Lc(Wr, Bn, Ln, cn, Er), Aa = vf(Wr, Bn, Ln, wn, vn, cn), aa = ga(Wr, Bi, Bn, Ln, Un, gn, wn, Aa, Ai, ca, Za, ji, fn, yn, On, Er), Xn = Dl(Wr, Aa, aa.procs.poll, fn, wi, Bn, Ln), Vn = aa.next, ma = Wr.canvas, ro = [], Ao = [], Jn = [], Oa = [
                        Er.onDestroy
                    ], _o = null;
                    function Po() {
                        if (ro.length === 0) {
                            yn && yn.update(), _o = null;
                            return;
                        }
                        _o = d.next(Po), ef();
                        for(var O = ro.length - 1; O >= 0; --O){
                            var $ = ro[O];
                            $ && $(fn, null, 0);
                        }
                        Wr.flush(), yn && yn.update();
                    }
                    function Jo() {
                        !_o && ro.length > 0 && (_o = d.next(Po));
                    }
                    function Yl() {
                        _o && (d.cancel(Po), _o = null);
                    }
                    function $c(O) {
                        O.preventDefault(), Ui = !0, Yl(), Ao.forEach(function($) {
                            $();
                        });
                    }
                    function xs(O) {
                        Wr.getError(), Ui = !1, Oi.restore(), Za.restore(), Un.restore(), wn.restore(), vn.restore(), Aa.restore(), ca.restore(), yn && yn.restore(), aa.procs.refresh(), Jo(), Jn.forEach(function($) {
                            $();
                        });
                    }
                    ma && (ma.addEventListener(Lo, $c, !1), ma.addEventListener(Fo, xs, !1));
                    function Qc() {
                        ro.length = 0, Yl(), ma && (ma.removeEventListener(Lo, $c), ma.removeEventListener(Fo, xs)), Za.clear(), Aa.clear(), vn.clear(), ca.clear(), wn.clear(), gn.clear(), Un.clear(), yn && yn.clear(), Oa.forEach(function(O) {
                            O();
                        });
                    }
                    function El(O) {
                        function $(pr) {
                            var kr = e({}, pr);
                            delete kr.uniforms, delete kr.attributes, delete kr.context, delete kr.vao, "stencil" in kr && kr.stencil.op && (kr.stencil.opBack = kr.stencil.opFront = kr.stencil.op, delete kr.stencil.op);
                            function Ar(gr) {
                                if (gr in kr) {
                                    var Cr = kr[gr];
                                    delete kr[gr], Object.keys(Cr).forEach(function(cr) {
                                        kr[gr + "." + cr] = Cr[cr];
                                    });
                                }
                            }
                            return Ar("blend"), Ar("depth"), Ar("cull"), Ar("stencil"), Ar("polygonOffset"), Ar("scissor"), Ar("sample"), "vao" in pr && (kr.vao = pr.vao), kr;
                        }
                        function pe(pr, kr) {
                            var Ar = {}, gr = {};
                            return Object.keys(pr).forEach(function(Cr) {
                                var cr = pr[Cr];
                                if (h.isDynamic(cr)) {
                                    gr[Cr] = h.unbox(cr, Cr);
                                    return;
                                } else if (kr && Array.isArray(cr)) {
                                    for(var Gr = 0; Gr < cr.length; ++Gr)if (h.isDynamic(cr[Gr])) {
                                        gr[Cr] = h.unbox(cr, Cr);
                                        return;
                                    }
                                }
                                Ar[Cr] = cr;
                            }), {
                                dynamic: gr,
                                static: Ar
                            };
                        }
                        var de = pe(O.context || {}, !0), Ie = pe(O.uniforms || {}, !0), $e = pe(O.attributes || {}, !1), pt = pe($(O), !1), Kt = {
                            gpuTime: 0,
                            cpuTime: 0,
                            count: 0
                        }, ir = aa.compile(pt, $e, Ie, de, Kt), Jt = ir.draw, vt = ir.batch, Pt = ir.scope, Wt = [];
                        function rr(pr) {
                            for(; Wt.length < pr;)Wt.push(null);
                            return Wt;
                        }
                        function dr(pr, kr) {
                            var Ar;
                            if (typeof pr == "function") return Pt.call(this, null, pr, 0);
                            if (typeof kr == "function") {
                                if (typeof pr == "number") for(Ar = 0; Ar < pr; ++Ar)Pt.call(this, null, kr, Ar);
                                else if (Array.isArray(pr)) for(Ar = 0; Ar < pr.length; ++Ar)Pt.call(this, pr[Ar], kr, Ar);
                                else return Pt.call(this, pr, kr, 0);
                            } else if (typeof pr == "number") {
                                if (pr > 0) return vt.call(this, rr(pr | 0), pr | 0);
                            } else if (Array.isArray(pr)) {
                                if (pr.length) return vt.call(this, pr, pr.length);
                            } else return Jt.call(this, pr);
                        }
                        return e(dr, {
                            stats: Kt,
                            destroy: function() {
                                ir.destroy();
                            }
                        });
                    }
                    var bc = Aa.setFBO = El({
                        framebuffer: h.define.call(null, js, "framebuffer")
                    });
                    function wc(O, $) {
                        var pe = 0;
                        aa.procs.poll();
                        var de = $.color;
                        de && (Wr.clearColor(+de[0] || 0, +de[1] || 0, +de[2] || 0, +de[3] || 0), pe |= _s), "depth" in $ && (Wr.clearDepth(+$.depth), pe |= Ns), "stencil" in $ && (Wr.clearStencil($.stencil | 0), pe |= pn), Wr.clear(pe);
                    }
                    function yf(O) {
                        if ("framebuffer" in O) {
                            if (O.framebuffer && O.framebuffer_reglType === "framebufferCube") for(var $ = 0; $ < 6; ++$)bc(e({
                                framebuffer: O.framebuffer.faces[$]
                            }, O), wc);
                            else bc(O, wc);
                        } else wc(null, O);
                    }
                    function Gl(O) {
                        ro.push(O);
                        function $() {
                            var pe = dl(ro, O);
                            function de() {
                                var Ie = dl(ro, de);
                                ro[Ie] = ro[ro.length - 1], ro.length -= 1, ro.length <= 0 && Yl();
                            }
                            ro[pe] = de;
                        }
                        return Jo(), {
                            cancel: $
                        };
                    }
                    function Fc() {
                        var O = Vn.viewport, $ = Vn.scissor_box;
                        O[0] = O[1] = $[0] = $[1] = 0, fn.viewportWidth = fn.framebufferWidth = fn.drawingBufferWidth = O[2] = $[2] = Wr.drawingBufferWidth, fn.viewportHeight = fn.framebufferHeight = fn.drawingBufferHeight = O[3] = $[3] = Wr.drawingBufferHeight;
                    }
                    function ef() {
                        fn.tick += 1, fn.time = _f(), Fc(), aa.procs.poll();
                    }
                    function ls() {
                        wn.refresh(), Fc(), aa.procs.refresh(), yn && yn.update();
                    }
                    function _f() {
                        return (v() - to) / 1e3;
                    }
                    ls();
                    function ns(O, $) {
                        var pe;
                        switch(O){
                            case "frame":
                                return Gl($);
                            case "lost":
                                pe = Ao;
                                break;
                            case "restore":
                                pe = Jn;
                                break;
                            case "destroy":
                                pe = Oa;
                                break;
                            default:
                        }
                        return pe.push($), {
                            cancel: function() {
                                for(var de = 0; de < pe.length; ++de)if (pe[de] === $) {
                                    pe[de] = pe[pe.length - 1], pe.pop();
                                    return;
                                }
                            }
                        };
                    }
                    function Y1() {
                        return On;
                    }
                    function z(O) {
                        Object.entries(O).forEach(function($) {
                            On[$[0]] = $[1];
                        });
                    }
                    var K = e(El, {
                        clear: yf,
                        prop: h.define.bind(null, js),
                        context: h.define.bind(null, xl),
                        this: h.define.bind(null, fu),
                        draw: El({}),
                        buffer: function(O) {
                            return Un.create(O, za, !1, !1);
                        },
                        elements: function(O) {
                            return gn.create(O, !1);
                        },
                        texture: wn.create2D,
                        cube: wn.createCube,
                        renderbuffer: vn.create,
                        framebuffer: Aa.create,
                        framebufferCube: Aa.createCube,
                        vao: ca.createVAO,
                        attributes: wi,
                        frame: Gl,
                        on: ns,
                        limits: Ln,
                        hasExtension: function(O) {
                            return Ln.extensions.indexOf(O.toLowerCase()) >= 0;
                        },
                        read: Xn,
                        destroy: Qc,
                        _gl: Wr,
                        _refresh: ls,
                        poll: function() {
                            ef(), yn && yn.update();
                        },
                        now: _f,
                        stats: cn,
                        getCachedCode: Y1,
                        preloadCachedCode: z
                    });
                    return Er.onDone(null, K), K;
                }
                return xc;
            });
        });
        var Iqe = ye((wmr, Pqe)=>{
            "use strict";
            var QOt = Zm();
            Pqe.exports = function(t) {
                if (t ? typeof t == "string" && (t = {
                    container: t
                }) : t = {}, Cqe(t) ? t = {
                    container: t
                } : eBt(t) ? t = {
                    container: t
                } : tBt(t) ? t = {
                    gl: t
                } : t = QOt(t, {
                    container: "container target element el canvas holder parent parentNode wrapper use ref root node",
                    gl: "gl context webgl glContext",
                    attrs: "attributes attrs contextAttributes",
                    pixelRatio: "pixelRatio pxRatio px ratio pxratio pixelratio",
                    width: "w width",
                    height: "h height"
                }, !0), t.pixelRatio || (t.pixelRatio = window.pixelRatio || 1), t.gl) return t.gl;
                if (t.canvas && (t.container = t.canvas.parentNode), t.container) {
                    if (typeof t.container == "string") {
                        var r = document.querySelector(t.container);
                        if (!r) throw Error("Element " + t.container + " is not found");
                        t.container = r;
                    }
                    Cqe(t.container) ? (t.canvas = t.container, t.container = t.canvas.parentNode) : t.canvas || (t.canvas = Lqe(), t.container.appendChild(t.canvas), kqe(t));
                } else if (!t.canvas) {
                    if (typeof document != "undefined") t.container = document.body || document.documentElement, t.canvas = Lqe(), t.container.appendChild(t.canvas), kqe(t);
                    else throw Error("Not DOM environment. Use headless-gl.");
                }
                return t.gl || [
                    "webgl",
                    "experimental-webgl",
                    "webgl-experimental"
                ].some(function(n) {
                    try {
                        t.gl = t.canvas.getContext(n, t.attrs);
                    } catch (i) {}
                    return t.gl;
                }), t.gl;
            };
            function kqe(e) {
                if (e.container) {
                    if (e.container == document.body) document.body.style.width || (e.canvas.width = e.width || e.pixelRatio * window.innerWidth), document.body.style.height || (e.canvas.height = e.height || e.pixelRatio * window.innerHeight);
                    else {
                        var t = e.container.getBoundingClientRect();
                        e.canvas.width = e.width || t.right - t.left, e.canvas.height = e.height || t.bottom - t.top;
                    }
                }
            }
            function Cqe(e) {
                return typeof e.getContext == "function" && "width" in e && "height" in e;
            }
            function eBt(e) {
                return typeof e.nodeName == "string" && typeof e.appendChild == "function" && typeof e.getBoundingClientRect == "function";
            }
            function tBt(e) {
                return typeof e.drawArrays == "function" || typeof e.drawElements == "function";
            }
            function Lqe() {
                var e = document.createElement("canvas");
                return e.style.position = "absolute", e.style.top = 0, e.style.left = 0, e;
            }
        });
        var Dqe = ye((Tmr, Rqe)=>{
            "use strict";
            var rBt = UY(), iBt = [
                32,
                126
            ];
            Rqe.exports = nBt;
            function nBt(e) {
                e = e || {};
                var t = e.shape ? e.shape : e.canvas ? [
                    e.canvas.width,
                    e.canvas.height
                ] : [
                    512,
                    512
                ], r = e.canvas || document.createElement("canvas"), n = e.font, i = typeof e.step == "number" ? [
                    e.step,
                    e.step
                ] : e.step || [
                    32,
                    32
                ], a = e.chars || iBt;
                if (n && typeof n != "string" && (n = rBt(n)), !Array.isArray(a)) a = String(a).split("");
                else if (a.length === 2 && typeof a[0] == "number" && typeof a[1] == "number") {
                    for(var o = [], s = a[0], l = 0; s <= a[1]; s++)o[l++] = String.fromCharCode(s);
                    a = o;
                }
                t = t.slice(), r.width = t[0], r.height = t[1];
                var u = r.getContext("2d");
                u.fillStyle = "#000", u.fillRect(0, 0, r.width, r.height), u.font = n, u.textAlign = "center", u.textBaseline = "middle", u.fillStyle = "#fff";
                for(var c = i[0] / 2, f = i[1] / 2, s = 0; s < a.length; s++)u.fillText(a[s], c, f), (c += i[0]) > t[0] - i[0] / 2 && (c = i[0] / 2, f += i[1]);
                return r;
            }
        });
        var WY = ye((Th)=>{
            "use strict";
            "use restrict";
            var jY = 32;
            Th.INT_BITS = jY;
            Th.INT_MAX = 2147483647;
            Th.INT_MIN = -1 << jY - 1;
            Th.sign = function(e) {
                return (e > 0) - (e < 0);
            };
            Th.abs = function(e) {
                var t = e >> jY - 1;
                return (e ^ t) - t;
            };
            Th.min = function(e, t) {
                return t ^ (e ^ t) & -(e < t);
            };
            Th.max = function(e, t) {
                return e ^ (e ^ t) & -(e < t);
            };
            Th.isPow2 = function(e) {
                return !(e & e - 1) && !!e;
            };
            Th.log2 = function(e) {
                var t, r;
                return t = (e > 65535) << 4, e >>>= t, r = (e > 255) << 3, e >>>= r, t |= r, r = (e > 15) << 2, e >>>= r, t |= r, r = (e > 3) << 1, e >>>= r, t |= r, t | e >> 1;
            };
            Th.log10 = function(e) {
                return e >= 1e9 ? 9 : e >= 1e8 ? 8 : e >= 1e7 ? 7 : e >= 1e6 ? 6 : e >= 1e5 ? 5 : e >= 1e4 ? 4 : e >= 1e3 ? 3 : e >= 100 ? 2 : e >= 10 ? 1 : 0;
            };
            Th.popCount = function(e) {
                return e = e - (e >>> 1 & 1431655765), e = (e & 858993459) + (e >>> 2 & 858993459), (e + (e >>> 4) & 252645135) * 16843009 >>> 24;
            };
            function zqe(e) {
                var t = 32;
                return e &= -e, e && t--, e & 65535 && (t -= 16), e & 16711935 && (t -= 8), e & 252645135 && (t -= 4), e & 858993459 && (t -= 2), e & 1431655765 && (t -= 1), t;
            }
            Th.countTrailingZeros = zqe;
            Th.nextPow2 = function(e) {
                return e += e === 0, --e, e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e + 1;
            };
            Th.prevPow2 = function(e) {
                return e |= e >>> 1, e |= e >>> 2, e |= e >>> 4, e |= e >>> 8, e |= e >>> 16, e - (e >>> 1);
            };
            Th.parity = function(e) {
                return e ^= e >>> 16, e ^= e >>> 8, e ^= e >>> 4, e &= 15, 27030 >>> e & 1;
            };
            var _k = new Array(256);
            (function(e) {
                for(var t = 0; t < 256; ++t){
                    var r = t, n = t, i = 7;
                    for(r >>>= 1; r; r >>>= 1)n <<= 1, n |= r & 1, --i;
                    e[t] = n << i & 255;
                }
            })(_k);
            Th.reverse = function(e) {
                return _k[e & 255] << 24 | _k[e >>> 8 & 255] << 16 | _k[e >>> 16 & 255] << 8 | _k[e >>> 24 & 255];
            };
            Th.interleave2 = function(e, t) {
                return e &= 65535, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, t &= 65535, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, e | t << 1;
            };
            Th.deinterleave2 = function(e, t) {
                return e = e >>> t & 1431655765, e = (e | e >>> 1) & 858993459, e = (e | e >>> 2) & 252645135, e = (e | e >>> 4) & 16711935, e = (e | e >>> 16) & 65535, e << 16 >> 16;
            };
            Th.interleave3 = function(e, t, r) {
                return e &= 1023, e = (e | e << 16) & 4278190335, e = (e | e << 8) & 251719695, e = (e | e << 4) & 3272356035, e = (e | e << 2) & 1227133513, t &= 1023, t = (t | t << 16) & 4278190335, t = (t | t << 8) & 251719695, t = (t | t << 4) & 3272356035, t = (t | t << 2) & 1227133513, e |= t << 1, r &= 1023, r = (r | r << 16) & 4278190335, r = (r | r << 8) & 251719695, r = (r | r << 4) & 3272356035, r = (r | r << 2) & 1227133513, e | r << 2;
            };
            Th.deinterleave3 = function(e, t) {
                return e = e >>> t & 1227133513, e = (e | e >>> 2) & 3272356035, e = (e | e >>> 4) & 251719695, e = (e | e >>> 8) & 4278190335, e = (e | e >>> 16) & 1023, e << 22 >> 22;
            };
            Th.nextCombination = function(e) {
                var t = e | e - 1;
                return t + 1 | (~t & -~t) - 1 >>> zqe(e) + 1;
            };
        });
        var Oqe = ye((Smr, qqe)=>{
            "use strict";
            function Fqe(e, t, r) {
                var n = e[r] | 0;
                if (n <= 0) return [];
                var i = new Array(n), a;
                if (r === e.length - 1) for(a = 0; a < n; ++a)i[a] = t;
                else for(a = 0; a < n; ++a)i[a] = Fqe(e, t, r + 1);
                return i;
            }
            function aBt(e, t) {
                var r, n;
                for(r = new Array(e), n = 0; n < e; ++n)r[n] = t;
                return r;
            }
            function oBt(e, t) {
                switch(typeof t == "undefined" && (t = 0), typeof e){
                    case "number":
                        if (e > 0) return aBt(e | 0, t);
                        break;
                    case "object":
                        if (typeof e.length == "number") return Fqe(e, t, 0);
                        break;
                }
                return [];
            }
            qqe.exports = oBt;
        });
        var Qqe = ye((Wl)=>{
            "use strict";
            var fx = WY(), Av = Oqe(), Bqe = u2().Buffer;
            window.__TYPEDARRAY_POOL || (window.__TYPEDARRAY_POOL = {
                UINT8: Av([
                    32,
                    0
                ]),
                UINT16: Av([
                    32,
                    0
                ]),
                UINT32: Av([
                    32,
                    0
                ]),
                BIGUINT64: Av([
                    32,
                    0
                ]),
                INT8: Av([
                    32,
                    0
                ]),
                INT16: Av([
                    32,
                    0
                ]),
                INT32: Av([
                    32,
                    0
                ]),
                BIGINT64: Av([
                    32,
                    0
                ]),
                FLOAT: Av([
                    32,
                    0
                ]),
                DOUBLE: Av([
                    32,
                    0
                ]),
                DATA: Av([
                    32,
                    0
                ]),
                UINT8C: Av([
                    32,
                    0
                ]),
                BUFFER: Av([
                    32,
                    0
                ])
            });
            var sBt = typeof Uint8ClampedArray != "undefined", lBt = typeof BigUint64Array != "undefined", uBt = typeof BigInt64Array != "undefined", Xh = window.__TYPEDARRAY_POOL;
            Xh.UINT8C || (Xh.UINT8C = Av([
                32,
                0
            ]));
            Xh.BIGUINT64 || (Xh.BIGUINT64 = Av([
                32,
                0
            ]));
            Xh.BIGINT64 || (Xh.BIGINT64 = Av([
                32,
                0
            ]));
            Xh.BUFFER || (Xh.BUFFER = Av([
                32,
                0
            ]));
            var dF = Xh.DATA, vF = Xh.BUFFER;
            Wl.free = function(t) {
                if (Bqe.isBuffer(t)) vF[fx.log2(t.length)].push(t);
                else {
                    if (Object.prototype.toString.call(t) !== "[object ArrayBuffer]" && (t = t.buffer), !t) return;
                    var r = t.length || t.byteLength, n = fx.log2(r) | 0;
                    dF[n].push(t);
                }
            };
            function Nqe(e) {
                if (e) {
                    var t = e.length || e.byteLength, r = fx.log2(t);
                    dF[r].push(e);
                }
            }
            function cBt(e) {
                Nqe(e.buffer);
            }
            Wl.freeUint8 = Wl.freeUint16 = Wl.freeUint32 = Wl.freeBigUint64 = Wl.freeInt8 = Wl.freeInt16 = Wl.freeInt32 = Wl.freeBigInt64 = Wl.freeFloat32 = Wl.freeFloat = Wl.freeFloat64 = Wl.freeDouble = Wl.freeUint8Clamped = Wl.freeDataView = cBt;
            Wl.freeArrayBuffer = Nqe;
            Wl.freeBuffer = function(t) {
                vF[fx.log2(t.length)].push(t);
            };
            Wl.malloc = function(t, r) {
                if (r === void 0 || r === "arraybuffer") return Bp(t);
                switch(r){
                    case "uint8":
                        return ZY(t);
                    case "uint16":
                        return Uqe(t);
                    case "uint32":
                        return Vqe(t);
                    case "int8":
                        return Hqe(t);
                    case "int16":
                        return Gqe(t);
                    case "int32":
                        return jqe(t);
                    case "float":
                    case "float32":
                        return Wqe(t);
                    case "double":
                    case "float64":
                        return Zqe(t);
                    case "uint8_clamped":
                        return Xqe(t);
                    case "bigint64":
                        return Kqe(t);
                    case "biguint64":
                        return Yqe(t);
                    case "buffer":
                        return $qe(t);
                    case "data":
                    case "dataview":
                        return Jqe(t);
                    default:
                        return null;
                }
                return null;
            };
            function Bp(t) {
                var t = fx.nextPow2(t), r = fx.log2(t), n = dF[r];
                return n.length > 0 ? n.pop() : new ArrayBuffer(t);
            }
            Wl.mallocArrayBuffer = Bp;
            function ZY(e) {
                return new Uint8Array(Bp(e), 0, e);
            }
            Wl.mallocUint8 = ZY;
            function Uqe(e) {
                return new Uint16Array(Bp(2 * e), 0, e);
            }
            Wl.mallocUint16 = Uqe;
            function Vqe(e) {
                return new Uint32Array(Bp(4 * e), 0, e);
            }
            Wl.mallocUint32 = Vqe;
            function Hqe(e) {
                return new Int8Array(Bp(e), 0, e);
            }
            Wl.mallocInt8 = Hqe;
            function Gqe(e) {
                return new Int16Array(Bp(2 * e), 0, e);
            }
            Wl.mallocInt16 = Gqe;
            function jqe(e) {
                return new Int32Array(Bp(4 * e), 0, e);
            }
            Wl.mallocInt32 = jqe;
            function Wqe(e) {
                return new Float32Array(Bp(4 * e), 0, e);
            }
            Wl.mallocFloat32 = Wl.mallocFloat = Wqe;
            function Zqe(e) {
                return new Float64Array(Bp(8 * e), 0, e);
            }
            Wl.mallocFloat64 = Wl.mallocDouble = Zqe;
            function Xqe(e) {
                return sBt ? new Uint8ClampedArray(Bp(e), 0, e) : ZY(e);
            }
            Wl.mallocUint8Clamped = Xqe;
            function Yqe(e) {
                return lBt ? new BigUint64Array(Bp(8 * e), 0, e) : null;
            }
            Wl.mallocBigUint64 = Yqe;
            function Kqe(e) {
                return uBt ? new BigInt64Array(Bp(8 * e), 0, e) : null;
            }
            Wl.mallocBigInt64 = Kqe;
            function Jqe(e) {
                return new DataView(Bp(e), 0, e);
            }
            Wl.mallocDataView = Jqe;
            function $qe(e) {
                e = fx.nextPow2(e);
                var t = fx.log2(e), r = vF[t];
                return r.length > 0 ? r.pop() : new Bqe(e);
            }
            Wl.mallocBuffer = $qe;
            Wl.clearCache = function() {
                for(var t = 0; t < 32; ++t)Xh.UINT8[t].length = 0, Xh.UINT16[t].length = 0, Xh.UINT32[t].length = 0, Xh.INT8[t].length = 0, Xh.INT16[t].length = 0, Xh.INT32[t].length = 0, Xh.FLOAT[t].length = 0, Xh.DOUBLE[t].length = 0, Xh.BIGUINT64[t].length = 0, Xh.BIGINT64[t].length = 0, Xh.UINT8C[t].length = 0, dF[t].length = 0, vF[t].length = 0;
            };
        });
        var tOe = ye((Emr, eOe)=>{
            "use strict";
            var fBt = Object.prototype.toString;
            eOe.exports = function(e) {
                var t;
                return fBt.call(e) === "[object Object]" && (t = Object.getPrototypeOf(e), t === null || t === Object.getPrototypeOf({}));
            };
        });
        var XY = ye((kmr, rOe)=>{
            rOe.exports = function(t, r) {
                r || (r = [
                    0,
                    ""
                ]), t = String(t);
                var n = parseFloat(t, 10);
                return r[0] = n, r[1] = t.match(/[\d.\-\+]*\s*(.*)/)[1] || "", r;
            };
        });
        var aOe = ye((Cmr, nOe)=>{
            "use strict";
            var hBt = XY();
            nOe.exports = iOe;
            var xk = 96;
            function YY(e, t) {
                var r = hBt(getComputedStyle(e).getPropertyValue(t));
                return r[0] * iOe(r[1], e);
            }
            function dBt(e, t) {
                var r = document.createElement("div");
                r.style["font-size"] = "128" + e, t.appendChild(r);
                var n = YY(r, "font-size") / 128;
                return t.removeChild(r), n;
            }
            function iOe(e, t) {
                switch(t = t || document.body, e = (e || "px").trim().toLowerCase(), (t === window || t === document) && (t = document.body), e){
                    case "%":
                        return t.clientHeight / 100;
                    case "ch":
                    case "ex":
                        return dBt(e, t);
                    case "em":
                        return YY(t, "font-size");
                    case "rem":
                        return YY(document.body, "font-size");
                    case "vw":
                        return window.innerWidth / 100;
                    case "vh":
                        return window.innerHeight / 100;
                    case "vmin":
                        return Math.min(window.innerWidth, window.innerHeight) / 100;
                    case "vmax":
                        return Math.max(window.innerWidth, window.innerHeight) / 100;
                    case "in":
                        return xk;
                    case "cm":
                        return xk / 2.54;
                    case "mm":
                        return xk / 25.4;
                    case "pt":
                        return xk / 72;
                    case "pc":
                        return xk / 6;
                }
                return 1;
            }
        });
        var lOe = ye((Lmr, sOe)=>{
            "use strict";
            sOe.exports = mF;
            var vBt = mF.canvas = document.createElement("canvas"), pF = vBt.getContext("2d"), oOe = gF([
                32,
                126
            ]);
            mF.createPairs = gF;
            mF.ascii = oOe;
            function mF(e, t) {
                Array.isArray(e) && (e = e.join(", "));
                var r = {}, n, i = 16, a = .05;
                t && (t.length === 2 && typeof t[0] == "number" ? n = gF(t) : Array.isArray(t) ? n = t : (t.o ? n = gF(t.o) : t.pairs && (n = t.pairs), t.fontSize && (i = t.fontSize), t.threshold != null && (a = t.threshold))), n || (n = oOe), pF.font = i + "px " + e;
                for(var o = 0; o < n.length; o++){
                    var s = n[o], l = pF.measureText(s[0]).width + pF.measureText(s[1]).width, u = pF.measureText(s).width;
                    if (Math.abs(l - u) > i * a) {
                        var c = (u - l) / i;
                        r[s] = c * 1e3;
                    }
                }
                return r;
            }
            function gF(e) {
                for(var t = [], r = e[0]; r <= e[1]; r++)for(var n = String.fromCharCode(r), i = e[0]; i < e[1]; i++){
                    var a = String.fromCharCode(i), o = n + a;
                    t.push(o);
                }
                return t;
            }
        });
        var hOe = ye((Pmr, fOe)=>{
            "use strict";
            fOe.exports = hx;
            hx.canvas = document.createElement("canvas");
            hx.cache = {};
            function hx(o, t) {
                t || (t = {}), (typeof o == "string" || Array.isArray(o)) && (t.family = o);
                var r = Array.isArray(t.family) ? t.family.join(", ") : t.family;
                if (!r) throw Error("`family` must be defined");
                var n = t.size || t.fontSize || t.em || 48, i = t.weight || t.fontWeight || "", a = t.style || t.fontStyle || "", o = [
                    a,
                    i,
                    n
                ].join(" ") + "px " + r, s = t.origin || "top";
                if (hx.cache[r] && n <= hx.cache[r].em) return uOe(hx.cache[r], s);
                var l = t.canvas || hx.canvas, u = l.getContext("2d"), c = {
                    upper: t.upper !== void 0 ? t.upper : "H",
                    lower: t.lower !== void 0 ? t.lower : "x",
                    descent: t.descent !== void 0 ? t.descent : "p",
                    ascent: t.ascent !== void 0 ? t.ascent : "h",
                    tittle: t.tittle !== void 0 ? t.tittle : "i",
                    overshoot: t.overshoot !== void 0 ? t.overshoot : "O"
                }, f = Math.ceil(n * 1.5);
                l.height = f, l.width = f * .5, u.font = o;
                var h = "H", d = {
                    top: 0
                };
                u.clearRect(0, 0, f, f), u.textBaseline = "top", u.fillStyle = "black", u.fillText(h, 0, 0);
                var v = Ym(u.getImageData(0, 0, f, f));
                u.clearRect(0, 0, f, f), u.textBaseline = "bottom", u.fillText(h, 0, f);
                var x = Ym(u.getImageData(0, 0, f, f));
                d.lineHeight = d.bottom = f - x + v, u.clearRect(0, 0, f, f), u.textBaseline = "alphabetic", u.fillText(h, 0, f);
                var b = Ym(u.getImageData(0, 0, f, f)), p = f - b - 1 + v;
                d.baseline = d.alphabetic = p, u.clearRect(0, 0, f, f), u.textBaseline = "middle", u.fillText(h, 0, f * .5);
                var E = Ym(u.getImageData(0, 0, f, f));
                d.median = d.middle = f - E - 1 + v - f * .5, u.clearRect(0, 0, f, f), u.textBaseline = "hanging", u.fillText(h, 0, f * .5);
                var k = Ym(u.getImageData(0, 0, f, f));
                d.hanging = f - k - 1 + v - f * .5, u.clearRect(0, 0, f, f), u.textBaseline = "ideographic", u.fillText(h, 0, f);
                var A = Ym(u.getImageData(0, 0, f, f));
                if (d.ideographic = f - A - 1 + v, c.upper && (u.clearRect(0, 0, f, f), u.textBaseline = "top", u.fillText(c.upper, 0, 0), d.upper = Ym(u.getImageData(0, 0, f, f)), d.capHeight = d.baseline - d.upper), c.lower && (u.clearRect(0, 0, f, f), u.textBaseline = "top", u.fillText(c.lower, 0, 0), d.lower = Ym(u.getImageData(0, 0, f, f)), d.xHeight = d.baseline - d.lower), c.tittle && (u.clearRect(0, 0, f, f), u.textBaseline = "top", u.fillText(c.tittle, 0, 0), d.tittle = Ym(u.getImageData(0, 0, f, f))), c.ascent && (u.clearRect(0, 0, f, f), u.textBaseline = "top", u.fillText(c.ascent, 0, 0), d.ascent = Ym(u.getImageData(0, 0, f, f))), c.descent && (u.clearRect(0, 0, f, f), u.textBaseline = "top", u.fillText(c.descent, 0, 0), d.descent = cOe(u.getImageData(0, 0, f, f))), c.overshoot) {
                    u.clearRect(0, 0, f, f), u.textBaseline = "top", u.fillText(c.overshoot, 0, 0);
                    var L = cOe(u.getImageData(0, 0, f, f));
                    d.overshoot = L - p;
                }
                for(var _ in d)d[_] /= n;
                return d.em = n, hx.cache[r] = d, uOe(d, s);
            }
            function uOe(e, t) {
                var r = {};
                typeof t == "string" && (t = e[t]);
                for(var n in e)n !== "em" && (r[n] = e[n] - t);
                return r;
            }
            function Ym(e) {
                for(var t = e.height, r = e.data, n = 3; n < r.length; n += 4)if (r[n] !== 0) return Math.floor((n - 3) * .25 / t);
            }
            function cOe(e) {
                for(var t = e.height, r = e.data, n = r.length - 1; n > 0; n -= 4)if (r[n] !== 0) return Math.floor((n - 3) * .25 / t);
            }
        });
        var gOe = ye((Imr, pOe)=>{
            "use strict";
            var fA = Eqe(), pBt = Zm(), gBt = GY(), mBt = Iqe(), yBt = EY(), KY = $_(), _Bt = Dqe(), dx = Qqe(), xBt = Q5(), bBt = tOe(), wBt = XY(), TBt = aOe(), ABt = lOe(), SBt = bh(), MBt = hOe(), EBt = W2(), kBt = WY(), dOe = kBt.nextPow2, vOe = new yBt, _F = !1;
            document.body && (yF = document.body.appendChild(document.createElement("div")), yF.style.font = "italic small-caps bold condensed 16px/2 cursive", getComputedStyle(yF).fontStretch && (_F = !0), document.body.removeChild(yF));
            var yF, Vu = function(t) {
                CBt(t) ? (t = {
                    regl: t
                }, this.gl = t.regl._gl) : this.gl = mBt(t), this.shader = vOe.get(this.gl), this.shader ? this.regl = this.shader.regl : this.regl = t.regl || gBt({
                    gl: this.gl
                }), this.charBuffer = this.regl.buffer({
                    type: "uint8",
                    usage: "stream"
                }), this.sizeBuffer = this.regl.buffer({
                    type: "float",
                    usage: "stream"
                }), this.shader || (this.shader = this.createShader(), vOe.set(this.gl, this.shader)), this.batch = [], this.fontSize = [], this.font = [], this.fontAtlas = [], this.draw = this.shader.draw.bind(this), this.render = function() {
                    this.regl._refresh(), this.draw(this.batch);
                }, this.canvas = this.gl.canvas, this.update(bBt(t) ? t : {});
            };
            Vu.prototype.createShader = function() {
                var t = this.regl, r = t({
                    blend: {
                        enable: !0,
                        color: [
                            0,
                            0,
                            0,
                            1
                        ],
                        func: {
                            srcRGB: "src alpha",
                            dstRGB: "one minus src alpha",
                            srcAlpha: "one minus dst alpha",
                            dstAlpha: "one"
                        }
                    },
                    stencil: {
                        enable: !1
                    },
                    depth: {
                        enable: !1
                    },
                    count: t.prop("count"),
                    offset: t.prop("offset"),
                    attributes: {
                        charOffset: {
                            offset: 4,
                            stride: 8,
                            buffer: t.this("sizeBuffer")
                        },
                        width: {
                            offset: 0,
                            stride: 8,
                            buffer: t.this("sizeBuffer")
                        },
                        char: t.this("charBuffer"),
                        position: t.this("position")
                    },
                    uniforms: {
                        atlasSize: function(i, a) {
                            return [
                                a.atlas.width,
                                a.atlas.height
                            ];
                        },
                        atlasDim: function(i, a) {
                            return [
                                a.atlas.cols,
                                a.atlas.rows
                            ];
                        },
                        atlas: function(i, a) {
                            return a.atlas.texture;
                        },
                        charStep: function(i, a) {
                            return a.atlas.step;
                        },
                        em: function(i, a) {
                            return a.atlas.em;
                        },
                        color: t.prop("color"),
                        opacity: t.prop("opacity"),
                        viewport: t.this("viewportArray"),
                        scale: t.this("scale"),
                        align: t.prop("align"),
                        baseline: t.prop("baseline"),
                        translate: t.this("translate"),
                        positionOffset: t.prop("positionOffset")
                    },
                    primitive: "points",
                    viewport: t.this("viewport"),
                    vert: `
			precision highp float;
			attribute float width, charOffset, char;
			attribute vec2 position;
			uniform float fontSize, charStep, em, align, baseline;
			uniform vec4 viewport;
			uniform vec4 color;
			uniform vec2 atlasSize, atlasDim, scale, translate, positionOffset;
			varying vec2 charCoord, charId;
			varying float charWidth;
			varying vec4 fontColor;
			void main () {
				vec2 offset = floor(em * (vec2(align + charOffset, baseline)
					+ vec2(positionOffset.x, -positionOffset.y)))
					/ (viewport.zw * scale.xy);

				vec2 position = (position + translate) * scale;
				position += offset * scale;

				charCoord = position * viewport.zw + viewport.xy;

				gl_Position = vec4(position * 2. - 1., 0, 1);

				gl_PointSize = charStep;

				charId.x = mod(char, atlasDim.x);
				charId.y = floor(char / atlasDim.x);

				charWidth = width * em;

				fontColor = color / 255.;
			}`,
                    frag: `
			precision highp float;
			uniform float fontSize, charStep, opacity;
			uniform vec2 atlasSize;
			uniform vec4 viewport;
			uniform sampler2D atlas;
			varying vec4 fontColor;
			varying vec2 charCoord, charId;
			varying float charWidth;

			float lightness(vec4 color) {
				return color.r * 0.299 + color.g * 0.587 + color.b * 0.114;
			}

			void main () {
				vec2 uv = gl_FragCoord.xy - charCoord + charStep * .5;
				float halfCharStep = floor(charStep * .5 + .5);

				// invert y and shift by 1px (FF expecially needs that)
				uv.y = charStep - uv.y;

				// ignore points outside of character bounding box
				float halfCharWidth = ceil(charWidth * .5);
				if (floor(uv.x) > halfCharStep + halfCharWidth ||
					floor(uv.x) < halfCharStep - halfCharWidth) return;

				uv += charId * charStep;
				uv = uv / atlasSize;

				vec4 color = fontColor;
				vec4 mask = texture2D(atlas, uv);

				float maskY = lightness(mask);
				// float colorY = lightness(color);
				color.a *= maskY;
				color.a *= opacity;

				// color.a += .1;

				// antialiasing, see yiq color space y-channel formula
				// color.rgb += (1. - color.rgb) * (1. - mask.rgb);

				gl_FragColor = color;
			}`
                }), n = {};
                return {
                    regl: t,
                    draw: r,
                    atlas: n
                };
            };
            Vu.prototype.update = function(t) {
                var r = this;
                if (typeof t == "string") t = {
                    text: t
                };
                else if (!t) return;
                t = pBt(t, {
                    position: "position positions coord coords coordinates",
                    font: "font fontFace fontface typeface cssFont css-font family fontFamily",
                    fontSize: "fontSize fontsize size font-size",
                    text: "text texts chars characters value values symbols",
                    align: "align alignment textAlign textbaseline",
                    baseline: "baseline textBaseline textbaseline",
                    direction: "dir direction textDirection",
                    color: "color colour fill fill-color fillColor textColor textcolor",
                    kerning: "kerning kern",
                    range: "range dataBox",
                    viewport: "vp viewport viewBox viewbox viewPort",
                    opacity: "opacity alpha transparency visible visibility opaque",
                    offset: "offset positionOffset padding shift indent indentation"
                }, !0), t.opacity != null && (Array.isArray(t.opacity) ? this.opacity = t.opacity.map(function(ke) {
                    return parseFloat(ke);
                }) : this.opacity = parseFloat(t.opacity)), t.viewport != null && (this.viewport = xBt(t.viewport), this.viewportArray = [
                    this.viewport.x,
                    this.viewport.y,
                    this.viewport.width,
                    this.viewport.height
                ]), this.viewport == null && (this.viewport = {
                    x: 0,
                    y: 0,
                    width: this.gl.drawingBufferWidth,
                    height: this.gl.drawingBufferHeight
                }, this.viewportArray = [
                    this.viewport.x,
                    this.viewport.y,
                    this.viewport.width,
                    this.viewport.height
                ]), t.kerning != null && (this.kerning = t.kerning), t.offset != null && (typeof t.offset == "number" && (t.offset = [
                    t.offset,
                    0
                ]), this.positionOffset = EBt(t.offset)), t.direction && (this.direction = t.direction), t.range && (this.range = t.range, this.scale = [
                    1 / (t.range[2] - t.range[0]),
                    1 / (t.range[3] - t.range[1])
                ], this.translate = [
                    -t.range[0],
                    -t.range[1]
                ]), t.scale && (this.scale = t.scale), t.translate && (this.translate = t.translate), this.scale || (this.scale = [
                    1 / this.viewport.width,
                    1 / this.viewport.height
                ]), this.translate || (this.translate = [
                    0,
                    0
                ]), !this.font.length && !t.font && (t.font = Vu.baseFontSize + "px sans-serif");
                var n = !1, i = !1;
                if (t.font && (Array.isArray(t.font) ? t.font : [
                    t.font
                ]).forEach(function(ke, ge) {
                    if (typeof ke == "string") try {
                        ke = fA.parse(ke);
                    } catch (Ge) {
                        ke = fA.parse(Vu.baseFontSize + "px " + ke);
                    }
                    else {
                        var ie = ke.style, Te = ke.weight, Ee = ke.stretch, Ae = ke.variant;
                        ke = fA.parse(fA.stringify(ke)), ie && (ke.style = ie), Te && (ke.weight = Te), Ee && (ke.stretch = Ee), Ae && (ke.variant = Ae);
                    }
                    var ze = fA.stringify({
                        size: Vu.baseFontSize,
                        family: ke.family,
                        stretch: _F ? ke.stretch : void 0,
                        variant: ke.variant,
                        weight: ke.weight,
                        style: ke.style
                    }), Ce = wBt(ke.size), me = Math.round(Ce[0] * TBt(Ce[1]));
                    if (me !== r.fontSize[ge] && (i = !0, r.fontSize[ge] = me), (!r.font[ge] || ze != r.font[ge].baseString) && (n = !0, r.font[ge] = Vu.fonts[ze], !r.font[ge])) {
                        var Re = ke.family.join(", "), ce = [
                            ke.style
                        ];
                        ke.style != ke.variant && ce.push(ke.variant), ke.variant != ke.weight && ce.push(ke.weight), _F && ke.weight != ke.stretch && ce.push(ke.stretch), r.font[ge] = {
                            baseString: ze,
                            family: Re,
                            weight: ke.weight,
                            stretch: ke.stretch,
                            style: ke.style,
                            variant: ke.variant,
                            width: {},
                            kerning: {},
                            metrics: MBt(Re, {
                                origin: "top",
                                fontSize: Vu.baseFontSize,
                                fontStyle: ce.join(" ")
                            })
                        }, Vu.fonts[ze] = r.font[ge];
                    }
                }), (n || i) && this.font.forEach(function(ke, ge) {
                    var ie = fA.stringify({
                        size: r.fontSize[ge],
                        family: ke.family,
                        stretch: _F ? ke.stretch : void 0,
                        variant: ke.variant,
                        weight: ke.weight,
                        style: ke.style
                    });
                    if (r.fontAtlas[ge] = r.shader.atlas[ie], !r.fontAtlas[ge]) {
                        var Te = ke.metrics;
                        r.shader.atlas[ie] = r.fontAtlas[ge] = {
                            fontString: ie,
                            step: Math.ceil(r.fontSize[ge] * Te.bottom * .5) * 2,
                            em: r.fontSize[ge],
                            cols: 0,
                            rows: 0,
                            height: 0,
                            width: 0,
                            chars: [],
                            ids: {},
                            texture: r.regl.texture()
                        };
                    }
                    t.text == null && (t.text = r.text);
                }), typeof t.text == "string" && t.position && t.position.length > 2) {
                    for(var a = Array(t.position.length * .5), o = 0; o < a.length; o++)a[o] = t.text;
                    t.text = a;
                }
                var s;
                if (t.text != null || n) {
                    if (this.textOffsets = [
                        0
                    ], Array.isArray(t.text)) {
                        this.count = t.text[0].length, this.counts = [
                            this.count
                        ];
                        for(var l = 1; l < t.text.length; l++)this.textOffsets[l] = this.textOffsets[l - 1] + t.text[l - 1].length, this.count += t.text[l].length, this.counts.push(t.text[l].length);
                        this.text = t.text.join("");
                    } else this.text = t.text, this.count = this.text.length, this.counts = [
                        this.count
                    ];
                    s = [], this.font.forEach(function(ke, ge) {
                        Vu.atlasContext.font = ke.baseString;
                        for(var ie = r.fontAtlas[ge], Te = 0; Te < r.text.length; Te++){
                            var Ee = r.text.charAt(Te);
                            if (ie.ids[Ee] == null && (ie.ids[Ee] = ie.chars.length, ie.chars.push(Ee), s.push(Ee)), ke.width[Ee] == null && (ke.width[Ee] = Vu.atlasContext.measureText(Ee).width / Vu.baseFontSize, r.kerning)) {
                                var Ae = [];
                                for(var ze in ke.width)Ae.push(ze + Ee, Ee + ze);
                                SBt(ke.kerning, ABt(ke.family, {
                                    pairs: Ae
                                }));
                            }
                        }
                    });
                }
                if (t.position) {
                    if (t.position.length > 2) {
                        for(var u = !t.position[0].length, c = dx.mallocFloat(this.count * 2), f = 0, h = 0; f < this.counts.length; f++){
                            var d = this.counts[f];
                            if (u) for(var v = 0; v < d; v++)c[h++] = t.position[f * 2], c[h++] = t.position[f * 2 + 1];
                            else for(var x = 0; x < d; x++)c[h++] = t.position[f][0], c[h++] = t.position[f][1];
                        }
                        this.position.call ? this.position({
                            type: "float",
                            data: c
                        }) : this.position = this.regl.buffer({
                            type: "float",
                            data: c
                        }), dx.freeFloat(c);
                    } else this.position.destroy && this.position.destroy(), this.position = {
                        constant: t.position
                    };
                }
                if (t.text || n) {
                    var b = dx.mallocUint8(this.count), p = dx.mallocFloat(this.count * 2);
                    this.textWidth = [];
                    for(var E = 0, k = 0; E < this.counts.length; E++){
                        for(var A = this.counts[E], L = this.font[E] || this.font[0], _ = this.fontAtlas[E] || this.fontAtlas[0], C = 0; C < A; C++){
                            var M = this.text.charAt(k), g = this.text.charAt(k - 1);
                            if (b[k] = _.ids[M], p[k * 2] = L.width[M], C) {
                                var P = p[k * 2 - 2], T = p[k * 2], F = p[k * 2 - 1], q = F + P * .5 + T * .5;
                                if (this.kerning) {
                                    var V = L.kerning[g + M];
                                    V && (q += V * .001);
                                }
                                p[k * 2 + 1] = q;
                            } else p[k * 2 + 1] = p[k * 2] * .5;
                            k++;
                        }
                        this.textWidth.push(p.length ? p[k * 2 - 2] * .5 + p[k * 2 - 1] : 0);
                    }
                    t.align || (t.align = this.align), this.charBuffer({
                        data: b,
                        type: "uint8",
                        usage: "stream"
                    }), this.sizeBuffer({
                        data: p,
                        type: "float",
                        usage: "stream"
                    }), dx.freeUint8(b), dx.freeFloat(p), s.length && this.font.forEach(function(ke, ge) {
                        var ie = r.fontAtlas[ge], Te = ie.step, Ee = Math.floor(Vu.maxAtlasSize / Te), Ae = Math.min(Ee, ie.chars.length), ze = Math.ceil(ie.chars.length / Ae), Ce = dOe(Ae * Te), me = dOe(ze * Te);
                        ie.width = Ce, ie.height = me, ie.rows = ze, ie.cols = Ae, ie.em && ie.texture({
                            data: _Bt({
                                canvas: Vu.atlasCanvas,
                                font: ie.fontString,
                                chars: ie.chars,
                                shape: [
                                    Ce,
                                    me
                                ],
                                step: [
                                    Te,
                                    Te
                                ]
                            })
                        });
                    });
                }
                if (t.align && (this.align = t.align, this.alignOffset = this.textWidth.map(function(ke, ge) {
                    var ie = Array.isArray(r.align) ? r.align.length > 1 ? r.align[ge] : r.align[0] : r.align;
                    if (typeof ie == "number") return ie;
                    switch(ie){
                        case "right":
                        case "end":
                            return -ke;
                        case "center":
                        case "centre":
                        case "middle":
                            return -ke * .5;
                    }
                    return 0;
                })), this.baseline == null && t.baseline == null && (t.baseline = 0), t.baseline != null && (this.baseline = t.baseline, Array.isArray(this.baseline) || (this.baseline = [
                    this.baseline
                ]), this.baselineOffset = this.baseline.map(function(ke, ge) {
                    var ie = (r.font[ge] || r.font[0]).metrics, Te = 0;
                    return Te += ie.bottom * .5, typeof ke == "number" ? Te += ke - ie.baseline : Te += -ie[ke], Te *= -1, Te;
                })), t.color != null) {
                    if (t.color || (t.color = "transparent"), typeof t.color == "string" || !isNaN(t.color)) this.color = KY(t.color, "uint8");
                    else {
                        var H;
                        if (typeof t.color[0] == "number" && t.color.length > this.counts.length) {
                            var X = t.color.length;
                            H = dx.mallocUint8(X);
                            for(var G = (t.color.subarray || t.color.slice).bind(t.color), N = 0; N < X; N += 4)H.set(KY(G(N, N + 4), "uint8"), N);
                        } else {
                            var W = t.color.length;
                            H = dx.mallocUint8(W * 4);
                            for(var re = 0; re < W; re++)H.set(KY(t.color[re] || 0, "uint8"), re * 4);
                        }
                        this.color = H;
                    }
                }
                if (t.position || t.text || t.color || t.baseline || t.align || t.font || t.offset || t.opacity) {
                    var ae = this.color.length > 4 || this.baselineOffset.length > 1 || this.align && this.align.length > 1 || this.fontAtlas.length > 1 || this.positionOffset.length > 2;
                    if (ae) {
                        var _e = Math.max(this.position.length * .5 || 0, this.color.length * .25 || 0, this.baselineOffset.length || 0, this.alignOffset.length || 0, this.font.length || 0, this.opacity.length || 0, this.positionOffset.length * .5 || 0);
                        this.batch = Array(_e);
                        for(var Me = 0; Me < this.batch.length; Me++)this.batch[Me] = {
                            count: this.counts.length > 1 ? this.counts[Me] : this.counts[0],
                            offset: this.textOffsets.length > 1 ? this.textOffsets[Me] : this.textOffsets[0],
                            color: this.color ? this.color.length <= 4 ? this.color : this.color.subarray(Me * 4, Me * 4 + 4) : [
                                0,
                                0,
                                0,
                                255
                            ],
                            opacity: Array.isArray(this.opacity) ? this.opacity[Me] : this.opacity,
                            baseline: this.baselineOffset[Me] != null ? this.baselineOffset[Me] : this.baselineOffset[0],
                            align: this.align ? this.alignOffset[Me] != null ? this.alignOffset[Me] : this.alignOffset[0] : 0,
                            atlas: this.fontAtlas[Me] || this.fontAtlas[0],
                            positionOffset: this.positionOffset.length > 2 ? this.positionOffset.subarray(Me * 2, Me * 2 + 2) : this.positionOffset
                        };
                    } else this.count ? this.batch = [
                        {
                            count: this.count,
                            offset: 0,
                            color: this.color || [
                                0,
                                0,
                                0,
                                255
                            ],
                            opacity: Array.isArray(this.opacity) ? this.opacity[0] : this.opacity,
                            baseline: this.baselineOffset[0],
                            align: this.alignOffset ? this.alignOffset[0] : 0,
                            atlas: this.fontAtlas[0],
                            positionOffset: this.positionOffset
                        }
                    ] : this.batch = [];
                }
            };
            Vu.prototype.destroy = function() {};
            Vu.prototype.kerning = !0;
            Vu.prototype.position = {
                constant: new Float32Array(2)
            };
            Vu.prototype.translate = null;
            Vu.prototype.scale = null;
            Vu.prototype.font = null;
            Vu.prototype.text = "";
            Vu.prototype.positionOffset = [
                0,
                0
            ];
            Vu.prototype.opacity = 1;
            Vu.prototype.color = new Uint8Array([
                0,
                0,
                0,
                255
            ]);
            Vu.prototype.alignOffset = [
                0,
                0
            ];
            Vu.maxAtlasSize = 1024;
            Vu.atlasCanvas = document.createElement("canvas");
            Vu.atlasContext = Vu.atlasCanvas.getContext("2d", {
                alpha: !1
            });
            Vu.baseFontSize = 64;
            Vu.fonts = {};
            function CBt(e) {
                return typeof e == "function" && e._gl && e.prop && e.texture && e.buffer;
            }
            pOe.exports = Vu;
        });
        var xF = ye((Rmr, mOe)=>{
            "use strict";
            var LBt = pZ(), PBt = GY();
            mOe.exports = function(t, r, n) {
                var i = t._fullLayout, a = !0;
                return i._glcanvas.each(function(o) {
                    if (o.regl) {
                        o.regl.preloadCachedCode(n);
                        return;
                    }
                    if (!(o.pick && !i._has("parcoords"))) {
                        try {
                            o.regl = PBt({
                                canvas: this,
                                attributes: {
                                    antialias: !o.pick,
                                    preserveDrawingBuffer: !0
                                },
                                pixelRatio: t._context.plotGlPixelRatio || window.devicePixelRatio,
                                extensions: r || [],
                                cachedCode: n || {}
                            });
                        } catch (s) {
                            a = !1;
                        }
                        o.regl || (a = !1), a && this.addEventListener("webglcontextlost", function(s) {
                            t && t.emit && t.emit("plotly_webglcontextlost", {
                                event: s,
                                layer: o.key
                            });
                        }, !1);
                    }
                }), a || LBt({
                    container: i._glcontainer.node()
                }), a;
            };
        });
        var QY = ye(($Y, wOe)=>{
            "use strict";
            var yOe = QX(), _Oe = LY(), IBt = lqe(), xOe = gOe(), JY = Mr(), RBt = Sg().selectMode, DBt = xF(), zBt = lu(), FBt = hU(), qBt = YX().styleTextSelection, bOe = {};
            function OBt(e, t, r, n) {
                var i = e._size, a = e.width * n, o = e.height * n, s = i.l * n, l = i.b * n, u = i.r * n, c = i.t * n, f = i.w * n, h = i.h * n;
                return [
                    s + t.domain[0] * f,
                    l + r.domain[0] * h,
                    a - u - (1 - t.domain[1]) * f,
                    o - c - (1 - r.domain[1]) * h
                ];
            }
            var $Y = wOe.exports = function(t, r, n) {
                if (n.length) {
                    var i = t._fullLayout, a = r._scene, o = r.xaxis, s = r.yaxis, l, u;
                    if (a) {
                        var c = DBt(t, [
                            "ANGLE_instanced_arrays",
                            "OES_element_index_uint"
                        ], bOe);
                        if (!c) {
                            a.init();
                            return;
                        }
                        var f = a.count, h = i._glcanvas.data()[0].regl;
                        if (FBt(t, r, n), a.dirty) {
                            if ((a.line2d || a.error2d) && !(a.scatter2d || a.fill2d || a.glText) && h.clear({}), a.error2d === !0 && (a.error2d = IBt(h)), a.line2d === !0 && (a.line2d = _Oe(h)), a.scatter2d === !0 && (a.scatter2d = yOe(h)), a.fill2d === !0 && (a.fill2d = _Oe(h)), a.glText === !0) for(a.glText = new Array(f), l = 0; l < f; l++)a.glText[l] = new xOe(h);
                            if (a.glText) {
                                if (f > a.glText.length) {
                                    var d = f - a.glText.length;
                                    for(l = 0; l < d; l++)a.glText.push(new xOe(h));
                                } else if (f < a.glText.length) {
                                    var v = a.glText.length - f, x = a.glText.splice(f, v);
                                    x.forEach(function(W) {
                                        W.destroy();
                                    });
                                }
                                for(l = 0; l < f; l++)a.glText[l].update(a.textOptions[l]);
                            }
                            if (a.line2d && (a.line2d.update(a.lineOptions), a.lineOptions = a.lineOptions.map(function(W) {
                                if (W && W.positions) {
                                    for(var re = W.positions, ae = 0; ae < re.length && (isNaN(re[ae]) || isNaN(re[ae + 1]));)ae += 2;
                                    for(var _e = re.length - 2; _e > ae && (isNaN(re[_e]) || isNaN(re[_e + 1]));)_e -= 2;
                                    W.positions = re.slice(ae, _e + 2);
                                }
                                return W;
                            }), a.line2d.update(a.lineOptions)), a.error2d) {
                                var b = (a.errorXOptions || []).concat(a.errorYOptions || []);
                                a.error2d.update(b);
                            }
                            a.scatter2d && a.scatter2d.update(a.markerOptions), a.fillOrder = JY.repeat(null, f), a.fill2d && (a.fillOptions = a.fillOptions.map(function(W, re) {
                                var ae = n[re];
                                if (!(!W || !ae || !ae[0] || !ae[0].trace)) {
                                    var _e = ae[0], Me = _e.trace, ke = _e.t, ge = a.lineOptions[re], ie, Te, Ee = [];
                                    Me._ownfill && Ee.push(re), Me._nexttrace && Ee.push(re + 1), Ee.length && (a.fillOrder[re] = Ee);
                                    var Ae = [], ze = ge && ge.positions || ke.positions, Ce, me;
                                    if (Me.fill === "tozeroy") {
                                        for(Ce = 0; Ce < ze.length && isNaN(ze[Ce + 1]);)Ce += 2;
                                        for(me = ze.length - 2; me > Ce && isNaN(ze[me + 1]);)me -= 2;
                                        ze[Ce + 1] !== 0 && (Ae = [
                                            ze[Ce],
                                            0
                                        ]), Ae = Ae.concat(ze.slice(Ce, me + 2)), ze[me + 1] !== 0 && (Ae = Ae.concat([
                                            ze[me],
                                            0
                                        ]));
                                    } else if (Me.fill === "tozerox") {
                                        for(Ce = 0; Ce < ze.length && isNaN(ze[Ce]);)Ce += 2;
                                        for(me = ze.length - 2; me > Ce && isNaN(ze[me]);)me -= 2;
                                        ze[Ce] !== 0 && (Ae = [
                                            0,
                                            ze[Ce + 1]
                                        ]), Ae = Ae.concat(ze.slice(Ce, me + 2)), ze[me] !== 0 && (Ae = Ae.concat([
                                            0,
                                            ze[me + 1]
                                        ]));
                                    } else if (Me.fill === "toself" || Me.fill === "tonext") {
                                        for(Ae = [], ie = 0, W.splitNull = !0, Te = 0; Te < ze.length; Te += 2)(isNaN(ze[Te]) || isNaN(ze[Te + 1])) && (Ae = Ae.concat(ze.slice(ie, Te)), Ae.push(ze[ie], ze[ie + 1]), Ae.push(null, null), ie = Te + 2);
                                        Ae = Ae.concat(ze.slice(ie)), ie && Ae.push(ze[ie], ze[ie + 1]);
                                    } else {
                                        var Re = Me._nexttrace;
                                        if (Re) {
                                            var ce = a.lineOptions[re + 1];
                                            if (ce) {
                                                var Ge = ce.positions;
                                                if (Me.fill === "tonexty") {
                                                    for(Ae = ze.slice(), re = Math.floor(Ge.length / 2); re--;){
                                                        var nt = Ge[re * 2], ct = Ge[re * 2 + 1];
                                                        isNaN(nt) || isNaN(ct) || Ae.push(nt, ct);
                                                    }
                                                    W.fill = Re.fillcolor;
                                                }
                                            }
                                        }
                                    }
                                    if (Me._prevtrace && Me._prevtrace.fill === "tonext") {
                                        var qt = a.lineOptions[re - 1].positions, rt = Ae.length / 2;
                                        ie = rt;
                                        var ot = [
                                            ie
                                        ];
                                        for(Te = 0; Te < qt.length; Te += 2)(isNaN(qt[Te]) || isNaN(qt[Te + 1])) && (ot.push(Te / 2 + rt + 1), ie = Te + 2);
                                        Ae = Ae.concat(qt), W.hole = ot;
                                    }
                                    return W.fillmode = Me.fill, W.opacity = Me.opacity, W.positions = Ae, W;
                                }
                            }), a.fill2d.update(a.fillOptions));
                        }
                        var p = i.dragmode, E = RBt(p), k = i.clickmode.indexOf("select") > -1;
                        for(l = 0; l < f; l++){
                            var A = n[l][0], L = A.trace, _ = A.t, C = _.index, M = L._length, g = _.x, P = _.y;
                            if (L.selectedpoints || E || k) {
                                if (E || (E = !0), L.selectedpoints) {
                                    var T = a.selectBatch[C] = JY.selIndices2selPoints(L), F = {};
                                    for(u = 0; u < T.length; u++)F[T[u]] = 1;
                                    var q = [];
                                    for(u = 0; u < M; u++)F[u] || q.push(u);
                                    a.unselectBatch[C] = q;
                                }
                                var V = _.xpx = new Array(M), H = _.ypx = new Array(M);
                                for(u = 0; u < M; u++)V[u] = o.c2p(g[u]), H[u] = s.c2p(P[u]);
                            } else _.xpx = _.ypx = null;
                        }
                        if (E) {
                            if (a.select2d || (a.select2d = yOe(i._glcanvas.data()[1].regl)), a.scatter2d) {
                                var X = new Array(f);
                                for(l = 0; l < f; l++)X[l] = a.selectBatch[l].length || a.unselectBatch[l].length ? a.markerUnselectedOptions[l] : {};
                                a.scatter2d.update(X);
                            }
                            a.select2d && (a.select2d.update(a.markerOptions), a.select2d.update(a.markerSelectedOptions)), a.glText && n.forEach(function(W) {
                                var re = ((W || [])[0] || {}).trace || {};
                                zBt.hasText(re) && qBt(W);
                            });
                        } else a.scatter2d && a.scatter2d.update(a.markerOptions);
                        var G = {
                            viewport: OBt(i, o, s, t._context.plotGlPixelRatio),
                            range: [
                                (o._rl || o.range)[0],
                                (s._rl || s.range)[0],
                                (o._rl || o.range)[1],
                                (s._rl || s.range)[1]
                            ]
                        }, N = JY.repeat(G, a.count);
                        a.fill2d && a.fill2d.update(N), a.line2d && a.line2d.update(N), a.error2d && a.error2d.update(N.concat(N)), a.scatter2d && a.scatter2d.update(N), a.select2d && a.select2d.update(N), a.glText && a.glText.forEach(function(W) {
                            W.update(G);
                        });
                    }
                }
            };
            $Y.reglPrecompiled = bOe;
        });
        var SOe = ye((Dmr, AOe)=>{
            "use strict";
            var TOe = Hze();
            TOe.plot = QY();
            AOe.exports = TOe;
        });
        var EOe = ye((zmr, MOe)=>{
            "use strict";
            MOe.exports = SOe();
        });
        var eK = ye((Fmr, POe)=>{
            "use strict";
            var BBt = Uc(), LOe = Jl(), kOe = Oc().axisHoverFormat, NBt = Wo().hovertemplateAttrs, bk = tk(), UBt = ad().idRegex, VBt = Vs().templatedArray, hA = no().extendFlat, o1 = BBt.marker, HBt = o1.line, GBt = hA(LOe("marker.line", {
                editTypeOverride: "calc"
            }), {
                width: hA({}, HBt.width, {
                    editType: "calc"
                }),
                editType: "calc"
            }), bF = hA(LOe("marker"), {
                symbol: o1.symbol,
                angle: o1.angle,
                size: hA({}, o1.size, {
                    editType: "markerSize"
                }),
                sizeref: o1.sizeref,
                sizemin: o1.sizemin,
                sizemode: o1.sizemode,
                opacity: o1.opacity,
                colorbar: o1.colorbar,
                line: GBt,
                editType: "calc"
            });
            bF.color.editType = bF.cmin.editType = bF.cmax.editType = "style";
            function COe(e) {
                return {
                    valType: "info_array",
                    freeLength: !0,
                    editType: "calc",
                    items: {
                        valType: "subplotid",
                        regex: UBt[e],
                        editType: "plot"
                    }
                };
            }
            POe.exports = {
                dimensions: VBt("dimension", {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    label: {
                        valType: "string",
                        editType: "calc"
                    },
                    values: {
                        valType: "data_array",
                        editType: "calc+clearAxisTypes"
                    },
                    axis: {
                        type: {
                            valType: "enumerated",
                            values: [
                                "linear",
                                "log",
                                "date",
                                "category"
                            ],
                            editType: "calc+clearAxisTypes"
                        },
                        matches: {
                            valType: "boolean",
                            dflt: !1,
                            editType: "calc"
                        },
                        editType: "calc+clearAxisTypes"
                    },
                    editType: "calc+clearAxisTypes"
                }),
                text: hA({}, bk.text, {}),
                hovertext: hA({}, bk.hovertext, {}),
                hovertemplate: NBt(),
                xhoverformat: kOe("x"),
                yhoverformat: kOe("y"),
                marker: bF,
                xaxes: COe("x"),
                yaxes: COe("y"),
                diagonal: {
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    },
                    editType: "calc"
                },
                showupperhalf: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc"
                },
                showlowerhalf: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc"
                },
                selected: {
                    marker: bk.selected.marker,
                    editType: "calc"
                },
                unselected: {
                    marker: bk.unselected.marker,
                    editType: "calc"
                },
                opacity: bk.opacity
            };
        });
        var wF = ye((qmr, IOe)=>{
            "use strict";
            IOe.exports = function(e, t, r, n) {
                n || (n = 1 / 0);
                var i, a;
                for(i = 0; i < t.length; i++)a = t[i], a.visible && (n = Math.min(n, a[r].length));
                for(n === 1 / 0 && (n = 0), e._length = n, i = 0; i < t.length; i++)a = t[i], a.visible && (a._length = n);
                return n;
            };
        });
        var zOe = ye((Omr, DOe)=>{
            "use strict";
            var tK = Mr(), jBt = Zd(), ROe = eK(), WBt = lu(), ZBt = $p(), XBt = wF(), YBt = Fz().isOpenSymbol;
            DOe.exports = function(t, r, n, i) {
                function a(d, v) {
                    return tK.coerce(t, r, ROe, d, v);
                }
                var o = jBt(t, r, {
                    name: "dimensions",
                    handleItemDefaults: KBt
                }), s = a("diagonal.visible"), l = a("showupperhalf"), u = a("showlowerhalf"), c = XBt(r, o, "values");
                if (!c || !s && !l && !u) {
                    r.visible = !1;
                    return;
                }
                a("text"), a("hovertext"), a("hovertemplate"), a("xhoverformat"), a("yhoverformat"), ZBt(t, r, n, i, a, {
                    noAngleRef: !0,
                    noStandOff: !0
                });
                var f = YBt(r.marker.symbol), h = WBt.isBubble(r);
                a("marker.line.width", f || h ? 1 : 0), JBt(t, r, i, a), tK.coerceSelectionMarkerOpacity(r, a);
            };
            function KBt(e, t) {
                function r(i, a) {
                    return tK.coerce(e, t, ROe.dimensions, i, a);
                }
                r("label");
                var n = r("values");
                n && n.length ? r("visible") : t.visible = !1, r("axis.type"), r("axis.matches");
            }
            function JBt(e, t, r, n) {
                var i = t.dimensions, a = i.length, o = t.showupperhalf, s = t.showlowerhalf, l = t.diagonal.visible, u, c, f = new Array(a), h = new Array(a);
                for(u = 0; u < a; u++){
                    var d = u ? u + 1 : "";
                    f[u] = "x" + d, h[u] = "y" + d;
                }
                var v = n("xaxes", f), x = n("yaxes", h), b = t._diag = new Array(a);
                t._xaxes = {}, t._yaxes = {};
                var p = [], E = [];
                function k(F, q, V, H) {
                    if (F) {
                        var X = F.charAt(0), G = r._splomAxes[X];
                        if (t["_" + X + "axes"][F] = 1, H.push(F), !(F in G)) {
                            var N = G[F] = {};
                            V && (N.label = V.label || "", V.visible && V.axis && (V.axis.type && (N.type = V.axis.type), V.axis.matches && (N.matches = q)));
                        }
                    }
                }
                var A = !l && !s, L = !l && !o;
                for(t._axesDim = {}, u = 0; u < a; u++){
                    var _ = i[u], C = u === 0, M = u === a - 1, g = C && A || M && L ? void 0 : v[u], P = C && L || M && A ? void 0 : x[u];
                    k(g, P, _, p), k(P, g, _, E), b[u] = [
                        g,
                        P
                    ], t._axesDim[g] = u, t._axesDim[P] = u;
                }
                for(u = 0; u < p.length; u++)for(c = 0; c < E.length; c++){
                    var T = p[u] + E[c];
                    (u > c && o || u < c && s || u === c && (l || !s || !o)) && (r._splomSubplots[T] = 1);
                }
                (!s || !l && o && s) && (r._splomGridDflt.xside = "bottom", r._splomGridDflt.yside = "left");
            }
        });
        var OOe = ye((Bmr, qOe)=>{
            "use strict";
            var FOe = Mr();
            qOe.exports = function(t, r) {
                var n = t._fullLayout, i = r.uid, a = n._splomScenes;
                a || (a = n._splomScenes = {});
                var o = {
                    dirty: !0,
                    selectBatch: [],
                    unselectBatch: []
                }, s = {
                    matrix: !1,
                    selectBatch: [],
                    unselectBatch: []
                }, l = a[r.uid];
                return l || (l = a[i] = FOe.extendFlat({}, o, s), l.draw = function() {
                    l.matrix && l.matrix.draw && (l.selectBatch.length || l.unselectBatch.length ? l.matrix.draw(l.unselectBatch, l.selectBatch) : l.matrix.draw()), l.dirty = !1;
                }, l.destroy = function() {
                    l.matrix && l.matrix.destroy && l.matrix.destroy(), l.matrixOptions = null, l.selectBatch = null, l.unselectBatch = null, l = null;
                }), l.dirty || FOe.extendFlat(l, o), l;
            };
        });
        var UOe = ye((Nmr, NOe)=>{
            "use strict";
            var rK = Mr(), TF = af(), $Bt = q0().calcMarkerSize, QBt = q0().calcAxisExpansion, eNt = z0(), BOe = Y2().markerSelection, tNt = Y2().markerStyle, rNt = OOe(), iNt = es().BADNUM, nNt = sx().TOO_MANY_POINTS;
            NOe.exports = function(t, r) {
                var n = r.dimensions, i = r._length, a = {}, o = a.cdata = [], s = a.data = [], l = r._visibleDims = [], u, c, f, h, d;
                function v(k, A) {
                    for(var L = k.makeCalcdata({
                        v: A.values,
                        vcalendar: r.calendar
                    }, "v"), _ = 0; _ < L.length; _++)L[_] = L[_] === iNt ? NaN : L[_];
                    o.push(L), s.push(k.type === "log" ? rK.simpleMap(L, k.c2l) : L);
                }
                for(u = 0; u < n.length; u++)if (f = n[u], f.visible) {
                    if (h = TF.getFromId(t, r._diag[u][0]), d = TF.getFromId(t, r._diag[u][1]), h && d && h.type !== d.type) {
                        rK.log("Skipping splom dimension " + u + " with conflicting axis types");
                        continue;
                    }
                    h ? (v(h, f), d && d.type === "category" && (d._categories = h._categories.slice())) : v(d, f), l.push(u);
                }
                eNt(t, r), rK.extendFlat(a, tNt(t, r));
                var x = o.length, b = x * i > nNt, p;
                for(b ? p = a.sizeAvg || Math.max(a.size, 3) : p = $Bt(r, i), c = 0; c < l.length; c++)u = l[c], f = n[u], h = TF.getFromId(t, r._diag[u][0]) || {}, d = TF.getFromId(t, r._diag[u][1]) || {}, QBt(t, r, h, d, o[c], o[c], p);
                var E = rNt(t, r);
                return E.matrix || (E.matrix = !0), E.matrixOptions = a, E.selectedOptions = BOe(t, r, r.selected), E.unselectedOptions = BOe(t, r, r.unselected), [
                    {
                        x: !1,
                        y: !1,
                        t: {},
                        trace: r
                    }
                ];
            };
        });
        var HOe = ye((VOe, wk)=>{
            (function() {
                var e, t, r, n, i, a;
                typeof performance != "undefined" && performance !== null && performance.now ? wk.exports = function() {
                    return performance.now();
                } : Date.now ? (wk.exports = function() {
                    return Date.now() - r;
                }, r = Date.now()) : (wk.exports = function() {
                    return new Date().getTime() - r;
                }, r = new Date().getTime());
            }).call(VOe);
        });
        var jOe = ye((Umr, MF)=>{
            var aNt = HOe(), s1 = window, AF = [
                "moz",
                "webkit"
            ], vA = "AnimationFrame", pA = s1["request" + vA], Tk = s1["cancel" + vA] || s1["cancelRequest" + vA];
            for(dA = 0; !pA && dA < AF.length; dA++)pA = s1[AF[dA] + "Request" + vA], Tk = s1[AF[dA] + "Cancel" + vA] || s1[AF[dA] + "CancelRequest" + vA];
            var dA;
            (!pA || !Tk) && (SF = 0, iK = 0, vx = [], GOe = 1e3 / 60, pA = function(e) {
                if (vx.length === 0) {
                    var t = aNt(), r = Math.max(0, GOe - (t - SF));
                    SF = r + t, setTimeout(function() {
                        var n = vx.slice(0);
                        vx.length = 0;
                        for(var i = 0; i < n.length; i++)if (!n[i].cancelled) try {
                            n[i].callback(SF);
                        } catch (a) {
                            setTimeout(function() {
                                throw a;
                            }, 0);
                        }
                    }, Math.round(r));
                }
                return vx.push({
                    handle: ++iK,
                    callback: e,
                    cancelled: !1
                }), iK;
            }, Tk = function(e) {
                for(var t = 0; t < vx.length; t++)vx[t].handle === e && (vx[t].cancelled = !0);
            });
            var SF, iK, vx, GOe;
            MF.exports = function(e) {
                return pA.call(s1, e);
            };
            MF.exports.cancel = function() {
                Tk.apply(s1, arguments);
            };
            MF.exports.polyfill = function(e) {
                e || (e = s1), e.requestAnimationFrame = pA, e.cancelAnimationFrame = Tk;
            };
        });
        var ZOe = ye((Vmr, WOe)=>{
            WOe.exports = function(t, r) {
                var n = typeof t == "number", i = typeof r == "number";
                n && !i ? (r = t, t = 0) : !n && !i && (t = 0, r = 0), t = t | 0, r = r | 0;
                var a = r - t;
                if (a < 0) throw new Error("array length must be positive");
                for(var o = new Array(a), s = 0, l = t; s < a; s++, l++)o[s] = l;
                return o;
            };
        });
        var JOe = ye((Hmr, KOe)=>{
            "use strict";
            var oNt = QX(), sNt = Zm(), lNt = j2(), XOe = jOe(), uNt = ZOe(), nK = Q5(), cNt = W2();
            KOe.exports = px;
            function px(e, t) {
                if (!(this instanceof px)) return new px(e, t);
                this.traces = [], this.passes = {}, this.regl = e, this.scatter = oNt(e), this.canvas = this.scatter.canvas;
            }
            px.prototype.render = function(...e) {
                return e.length && this.update(...e), this.regl.attributes.preserveDrawingBuffer ? this.draw() : (this.dirty ? this.planned == null && (this.planned = XOe(()=>{
                    this.draw(), this.dirty = !0, this.planned = null;
                })) : (this.draw(), this.dirty = !0, XOe(()=>{
                    this.dirty = !1;
                })), this);
            };
            px.prototype.update = function(...e) {
                if (!e.length) return;
                for(let n = 0; n < e.length; n++)this.updateItem(n, e[n]);
                this.traces = this.traces.filter(Boolean);
                let t = [], r = 0;
                for(let n = 0; n < this.traces.length; n++){
                    let i = this.traces[n], a = this.traces[n].passes;
                    for(let o = 0; o < a.length; o++)t.push(this.passes[a[o]]);
                    i.passOffset = r, r += i.passes.length;
                }
                return this.scatter.update(...t), this;
            };
            px.prototype.updateItem = function(e, t) {
                let { regl: r } = this;
                if (t === null) return this.traces[e] = null, this;
                if (!t) return this;
                let n = sNt(t, {
                    data: "data items columns rows values dimensions samples x",
                    snap: "snap cluster",
                    size: "sizes size radius",
                    color: "colors color fill fill-color fillColor",
                    opacity: "opacity alpha transparency opaque",
                    borderSize: "borderSizes borderSize border-size bordersize borderWidth borderWidths border-width borderwidth stroke-width strokeWidth strokewidth outline",
                    borderColor: "borderColors borderColor bordercolor stroke stroke-color strokeColor",
                    marker: "markers marker shape",
                    range: "range ranges databox dataBox",
                    viewport: "viewport viewBox viewbox",
                    domain: "domain domains area areas",
                    padding: "pad padding paddings pads margin margins",
                    transpose: "transpose transposed",
                    diagonal: "diagonal diag showDiagonal",
                    upper: "upper up top upperhalf upperHalf showupperhalf showUpper showUpperHalf",
                    lower: "lower low bottom lowerhalf lowerHalf showlowerhalf showLowerHalf showLower"
                }), i = this.traces[e] || (this.traces[e] = {
                    id: e,
                    buffer: r.buffer({
                        usage: "dynamic",
                        type: "float",
                        data: new Uint8Array
                    }),
                    color: "black",
                    marker: null,
                    size: 12,
                    borderColor: "transparent",
                    borderSize: 1,
                    viewport: nK([
                        r._gl.drawingBufferWidth,
                        r._gl.drawingBufferHeight
                    ]),
                    padding: [
                        0,
                        0,
                        0,
                        0
                    ],
                    opacity: 1,
                    diagonal: !0,
                    upper: !0,
                    lower: !0
                });
                if (n.color != null && (i.color = n.color), n.size != null && (i.size = n.size), n.marker != null && (i.marker = n.marker), n.borderColor != null && (i.borderColor = n.borderColor), n.borderSize != null && (i.borderSize = n.borderSize), n.opacity != null && (i.opacity = n.opacity), n.viewport && (i.viewport = nK(n.viewport)), n.diagonal != null && (i.diagonal = n.diagonal), n.upper != null && (i.upper = n.upper), n.lower != null && (i.lower = n.lower), n.data) {
                    i.buffer(cNt(n.data)), i.columns = n.data.length, i.count = n.data[0].length, i.bounds = [];
                    for(let x = 0; x < i.columns; x++)i.bounds[x] = lNt(n.data[x], 1);
                }
                let a;
                n.range && (i.range = n.range, a = i.range && typeof i.range[0] != "number"), n.domain && (i.domain = n.domain);
                let o = !1;
                n.padding != null && (Array.isArray(n.padding) && n.padding.length === i.columns && typeof n.padding[n.padding.length - 1] == "number" ? (i.padding = n.padding.map(YOe), o = !0) : i.padding = YOe(n.padding));
                let s = i.columns, l = i.count, u = i.viewport.width, c = i.viewport.height, f = i.viewport.x, h = i.viewport.y, d = u / s, v = c / s;
                i.passes = [];
                for(let x = 0; x < s; x++)for(let b = 0; b < s; b++){
                    if (!i.diagonal && b === x || !i.upper && x > b || !i.lower && x < b) continue;
                    let p = fNt(i.id, x, b), E = this.passes[p] || (this.passes[p] = {});
                    if (n.data && (n.transpose ? E.positions = {
                        x: {
                            buffer: i.buffer,
                            offset: b,
                            count: l,
                            stride: s
                        },
                        y: {
                            buffer: i.buffer,
                            offset: x,
                            count: l,
                            stride: s
                        }
                    } : E.positions = {
                        x: {
                            buffer: i.buffer,
                            offset: b * l,
                            count: l
                        },
                        y: {
                            buffer: i.buffer,
                            offset: x * l,
                            count: l
                        }
                    }, E.bounds = EF(i.bounds, x, b)), n.domain || n.viewport || n.data) {
                        let k = o ? EF(i.padding, x, b) : i.padding;
                        if (i.domain) {
                            let [A, L, _, C] = EF(i.domain, x, b);
                            E.viewport = [
                                f + A * u + k[0],
                                h + L * c + k[1],
                                f + _ * u - k[2],
                                h + C * c - k[3]
                            ];
                        } else E.viewport = [
                            f + b * d + d * k[0],
                            h + x * v + v * k[1],
                            f + (b + 1) * d - d * k[2],
                            h + (x + 1) * v - v * k[3]
                        ];
                    }
                    n.color && (E.color = i.color), n.size && (E.size = i.size), n.marker && (E.marker = i.marker), n.borderSize && (E.borderSize = i.borderSize), n.borderColor && (E.borderColor = i.borderColor), n.opacity && (E.opacity = i.opacity), n.range && (E.range = a ? EF(i.range, x, b) : i.range || E.bounds), i.passes.push(p);
                }
                return this;
            };
            px.prototype.draw = function(...e) {
                if (!e.length) this.scatter.draw();
                else {
                    let t = [];
                    for(let r = 0; r < e.length; r++)if (typeof e[r] == "number") {
                        let { passes: n, passOffset: i } = this.traces[e[r]];
                        t.push(...uNt(i, i + n.length));
                    } else if (e[r].length) {
                        let n = e[r], { passes: i, passOffset: a } = this.traces[r];
                        i = i.map((o, s)=>{
                            t[a + s] = n;
                        });
                    }
                    this.scatter.draw(...t);
                }
                return this;
            };
            px.prototype.destroy = function() {
                return this.traces.forEach((e)=>{
                    e.buffer && e.buffer.destroy && e.buffer.destroy();
                }), this.traces = null, this.passes = null, this.scatter.destroy(), this;
            };
            function fNt(e, t, r) {
                let n = e.id != null ? e.id : e, i = t, a = r;
                return n << 16 | (i & 255) << 8 | a & 255;
            }
            function EF(e, t, r) {
                let n, i, a, o, s, l, u, c, f = e[t], h = e[r];
                return f.length > 2 ? (n = f[0], a = f[2], i = f[1], o = f[3]) : f.length ? (n = i = f[0], a = o = f[1]) : (n = f.x, i = f.y, a = f.x + f.width, o = f.y + f.height), h.length > 2 ? (s = h[0], u = h[2], l = h[1], c = h[3]) : h.length ? (s = l = h[0], u = c = h[1]) : (s = h.x, l = h.y, u = h.x + h.width, c = h.y + h.height), [
                    s,
                    i,
                    u,
                    o
                ];
            }
            function YOe(e) {
                if (typeof e == "number") return [
                    e,
                    e,
                    e,
                    e
                ];
                if (e.length === 2) return [
                    e[0],
                    e[1],
                    e[0],
                    e[1]
                ];
                {
                    let t = nK(e);
                    return [
                        t.x,
                        t.y,
                        t.x + t.width,
                        t.y + t.height
                    ];
                }
            }
        });
        var QOe = ye((Gmr, $Oe)=>{
            "use strict";
            var hNt = JOe(), aK = Mr(), kF = af(), dNt = Sg().selectMode;
            $Oe.exports = function(t, r, n) {
                if (n.length) for(var i = 0; i < n.length; i++)vNt(t, n[i][0]);
            };
            function vNt(e, t) {
                var r = e._fullLayout, n = r._size, i = t.trace, a = t.t, o = r._splomScenes[i.uid], s = o.matrixOptions, l = s.cdata, u = r._glcanvas.data()[0].regl, c = r.dragmode, f, h, d, v, x;
                if (l.length !== 0) {
                    s.lower = i.showupperhalf, s.upper = i.showlowerhalf, s.diagonal = i.diagonal.visible;
                    var b = i._visibleDims, p = l.length, E = o.viewOpts = {};
                    for(E.ranges = new Array(p), E.domains = new Array(p), x = 0; x < b.length; x++){
                        d = b[x];
                        var k = E.ranges[x] = new Array(4), A = E.domains[x] = new Array(4);
                        f = kF.getFromId(e, i._diag[d][0]), f && (k[0] = f._rl[0], k[2] = f._rl[1], A[0] = f.domain[0], A[2] = f.domain[1]), h = kF.getFromId(e, i._diag[d][1]), h && (k[1] = h._rl[0], k[3] = h._rl[1], A[1] = h.domain[0], A[3] = h.domain[1]);
                    }
                    var L = e._context.plotGlPixelRatio, _ = n.l * L, C = n.b * L, M = n.w * L, g = n.h * L;
                    E.viewport = [
                        _,
                        C,
                        M + _,
                        g + C
                    ], o.matrix === !0 && (o.matrix = hNt(u));
                    var P = r.clickmode.indexOf("select") > -1, T = dNt(c) || !!i.selectedpoints || P, F = !0;
                    if (T) {
                        var q = i._length;
                        if (i.selectedpoints) {
                            o.selectBatch = i.selectedpoints;
                            var V = i.selectedpoints, H = {};
                            for(d = 0; d < V.length; d++)H[V[d]] = !0;
                            var X = [];
                            for(d = 0; d < q; d++)H[d] || X.push(d);
                            o.unselectBatch = X;
                        }
                        var G = a.xpx = new Array(p), N = a.ypx = new Array(p);
                        for(x = 0; x < b.length; x++){
                            if (d = b[x], f = kF.getFromId(e, i._diag[d][0]), f) for(G[x] = new Array(q), v = 0; v < q; v++)G[x][v] = f.c2p(l[x][v]);
                            if (h = kF.getFromId(e, i._diag[d][1]), h) for(N[x] = new Array(q), v = 0; v < q; v++)N[x][v] = h.c2p(l[x][v]);
                        }
                        if (o.selectBatch.length || o.unselectBatch.length) {
                            var W = aK.extendFlat({}, s, o.unselectedOptions, E), re = aK.extendFlat({}, s, o.selectedOptions, E);
                            o.matrix.update(W, re), F = !1;
                        }
                    } else a.xpx = a.ypx = null;
                    if (F) {
                        var ae = aK.extendFlat({}, s, E);
                        o.matrix.update(ae, null);
                    }
                }
            }
        });
        var oK = ye((eBe)=>{
            "use strict";
            eBe.getDimIndex = function(t, r) {
                for(var n = r._id, i = n.charAt(0), a = {
                    x: 0,
                    y: 1
                }[i], o = t._visibleDims, s = 0; s < o.length; s++){
                    var l = o[s];
                    if (t._diag[l][a] === n) return s;
                }
                return !1;
            };
        });
        var aBe = ye((Wmr, nBe)=>{
            "use strict";
            var tBe = oK(), pNt = zz().calcHover, rBe = Qa().getFromId, gNt = no().extendFlat;
            function mNt(e, t, r, n, i) {
                i || (i = {});
                var a = (n || "").charAt(0) === "x", o = (n || "").charAt(0) === "y", s = iBe(e, t, r);
                if ((a || o) && i.hoversubplots === "axis" && s[0]) for(var l = (a ? e.xa : e.ya)._subplotsWith, u = i.gd, c = gNt({}, e), f = 0; f < l.length; f++){
                    var h = l[f];
                    if (h !== e.xa._id + e.ya._id) {
                        o ? c.xa = rBe(u, h, "x") : c.ya = rBe(u, h, "y");
                        var d = a || o, v = iBe(c, t, r, d);
                        s = s.concat(v);
                    }
                }
                return s;
            }
            function iBe(e, t, r, n) {
                var i = e.cd, a = i[0].trace, o = e.scene, s = o.matrixOptions.cdata, l = e.xa, u = e.ya, c = l.c2p(t), f = u.c2p(r), h = e.distance, d = tBe.getDimIndex(a, l), v = tBe.getDimIndex(a, u);
                if (d === !1 || v === !1) return [
                    e
                ];
                for(var x = s[d], b = s[v], p, E, k = h, A = 0; A < x.length; A++)if (!(n && A !== e.index)) {
                    var L = x[A], _ = b[A], C = l.c2p(L) - c, M = u.c2p(_) - f, g = Math.sqrt(C * C + M * M);
                    (n || g < k) && (k = E = g, p = A);
                }
                return e.index = p, e.distance = k, e.dxy = E, p === void 0 ? [
                    e
                ] : [
                    pNt(e, x, b, a)
                ];
            }
            nBe.exports = {
                hoverPoints: mNt
            };
        });
        var fBe = ye((Zmr, cBe)=>{
            "use strict";
            var uBe = Mr(), oBe = uBe.pushUnique, sBe = lu(), lBe = oK();
            cBe.exports = function(t, r) {
                var n = t.cd, i = n[0].trace, a = n[0].t, o = t.scene, s = o.matrixOptions.cdata, l = t.xaxis, u = t.yaxis, c = [];
                if (!o) return c;
                var f = !sBe.hasMarkers(i) && !sBe.hasText(i);
                if (i.visible !== !0 || f) return c;
                var h = lBe.getDimIndex(i, l), d = lBe.getDimIndex(i, u);
                if (h === !1 || d === !1) return c;
                var v = a.xpx[h], x = a.ypx[d], b = s[h], p = s[d], E = (t.scene.selectBatch || []).slice(), k = [];
                if (r !== !1 && !r.degenerate) for(var A = 0; A < b.length; A++)r.contains([
                    v[A],
                    x[A]
                ], null, A, t) ? (c.push({
                    pointNumber: A,
                    x: b[A],
                    y: p[A]
                }), oBe(E, A)) : E.indexOf(A) !== -1 ? oBe(E, A) : k.push(A);
                var L = o.matrixOptions;
                return !E.length && !k.length ? o.matrix.update(L, null) : !o.selectBatch.length && !o.unselectBatch.length && o.matrix.update(o.unselectedOptions, uBe.extendFlat({}, L, o.selectedOptions, o.viewOpts)), o.selectBatch = E, o.unselectBatch = k, c;
            };
        });
        var vBe = ye((Xmr, dBe)=>{
            "use strict";
            var hBe = Mr(), yNt = z0(), _Nt = Y2().markerStyle;
            dBe.exports = function(t, r) {
                var n = r.trace, i = t._fullLayout._splomScenes[n.uid];
                if (i) {
                    yNt(t, n), hBe.extendFlat(i.matrixOptions, _Nt(t, n));
                    var a = hBe.extendFlat({}, i.matrixOptions, i.viewOpts);
                    i.matrix.update(a, null);
                }
            };
        });
        var gBe = ye((Ymr, pBe)=>{
            "use strict";
            var xNt = ba(), bNt = nV();
            pBe.exports = {
                moduleType: "trace",
                name: "splom",
                categories: [
                    "gl",
                    "regl",
                    "cartesian",
                    "symbols",
                    "showLegend",
                    "scatter-like"
                ],
                attributes: eK(),
                supplyDefaults: zOe(),
                colorbar: Kd(),
                calc: UOe(),
                plot: QOe(),
                hoverPoints: aBe().hoverPoints,
                selectPoints: fBe(),
                editStyle: vBe(),
                meta: {}
            };
            xNt.register(bNt);
        });
        var wBe = ye((Kmr, bBe)=>{
            "use strict";
            var wNt = LY(), TNt = ba(), ANt = xF(), SNt = kd().getModuleCalcData, gx = Jf(), mBe = af().getFromId, yBe = Qa().shouldShowZeroLine, _Be = "splom", xBe = {};
            function MNt(e) {
                var t = e._fullLayout, r = TNt.getModule(_Be), n = SNt(e.calcdata, r)[0], i = ANt(e, [
                    "ANGLE_instanced_arrays",
                    "OES_element_index_uint"
                ], xBe);
                i && (t._hasOnlyLargeSploms && sK(e), r.plot(e, {}, n));
            }
            function ENt(e) {
                var t = e.calcdata, r = e._fullLayout;
                r._hasOnlyLargeSploms && sK(e);
                for(var n = 0; n < t.length; n++){
                    var i = t[n][0], a = i.trace, o = r._splomScenes[a.uid];
                    a.type === "splom" && o && o.matrix && kNt(e, a, o);
                }
            }
            function kNt(e, t, r) {
                for(var n = r.matrixOptions.data.length, i = t._visibleDims, a = r.viewOpts.ranges = new Array(n), o = 0; o < i.length; o++){
                    var s = i[o], l = a[o] = new Array(4), u = mBe(e, t._diag[s][0]);
                    u && (l[0] = u.r2l(u.range[0]), l[2] = u.r2l(u.range[1]));
                    var c = mBe(e, t._diag[s][1]);
                    c && (l[1] = c.r2l(c.range[0]), l[3] = c.r2l(c.range[1]));
                }
                r.selectBatch.length || r.unselectBatch.length ? r.matrix.update({
                    ranges: a
                }, {
                    ranges: a
                }) : r.matrix.update({
                    ranges: a
                });
            }
            function sK(e) {
                var t = e._fullLayout, r = t._glcanvas.data()[0].regl, n = t._splomGrid;
                n || (n = t._splomGrid = wNt(r)), n.update(CNt(e));
            }
            function CNt(e) {
                var t = e._context.plotGlPixelRatio, r = e._fullLayout, n = r._size, i = [
                    0,
                    0,
                    r.width * t,
                    r.height * t
                ], a = {}, o;
                function s(_, C, M, g, P, T) {
                    M *= t, g *= t, P *= t, T *= t;
                    var F = C[_ + "color"], q = C[_ + "width"], V = String(F + q);
                    V in a ? a[V].data.push(NaN, NaN, M, g, P, T) : a[V] = {
                        data: [
                            M,
                            g,
                            P,
                            T
                        ],
                        join: "rect",
                        thickness: q * t,
                        color: F,
                        viewport: i,
                        range: i,
                        overlay: !1
                    };
                }
                for(o in r._splomSubplots){
                    var l = r._plots[o], u = l.xaxis, c = l.yaxis, f = u._gridVals, h = c._gridVals, d = u._offset, v = u._length, x = c._length, b = n.b + c.domain[0] * n.h, p = -c._m, E = -p * c.r2l(c.range[0], c.calendar), k, A;
                    if (u.showgrid) for(o = 0; o < f.length; o++)k = d + u.l2p(f[o].x), s("grid", u, k, b, k, b + x);
                    if (c.showgrid) for(o = 0; o < h.length; o++)A = b + E + p * h[o].x, s("grid", c, d, A, d + v, A);
                    yBe(e, u, c) && (k = d + u.l2p(0), s("zeroline", u, k, b, k, b + x)), yBe(e, c, u) && (A = b + E + 0, s("zeroline", c, d, A, d + v, A));
                }
                var L = [];
                for(o in a)L.push(a[o]);
                return L;
            }
            function LNt(e, t, r, n) {
                var i = {}, a;
                if (n._splomScenes) {
                    for(a = 0; a < e.length; a++){
                        var o = e[a];
                        o.type === "splom" && (i[o.uid] = 1);
                    }
                    for(a = 0; a < r.length; a++){
                        var s = r[a];
                        if (!i[s.uid]) {
                            var l = n._splomScenes[s.uid];
                            l && l.destroy && l.destroy(), n._splomScenes[s.uid] = null, delete n._splomScenes[s.uid];
                        }
                    }
                }
                Object.keys(n._splomScenes || {}).length === 0 && delete n._splomScenes, n._splomGrid && !t._hasOnlyLargeSploms && n._hasOnlyLargeSploms && (n._splomGrid.destroy(), n._splomGrid = null, delete n._splomGrid), gx.clean(e, t, r, n);
            }
            bBe.exports = {
                name: _Be,
                attr: gx.attr,
                attrRegex: gx.attrRegex,
                layoutAttributes: gx.layoutAttributes,
                supplyLayoutDefaults: gx.supplyLayoutDefaults,
                drawFramework: gx.drawFramework,
                plot: MNt,
                drag: ENt,
                updateGrid: sK,
                clean: LNt,
                updateFx: gx.updateFx,
                toSVG: gx.toSVG,
                reglPrecompiled: xBe
            };
        });
        var SBe = ye((Jmr, ABe)=>{
            "use strict";
            var TBe = gBe();
            TBe.basePlotModule = wBe(), ABe.exports = TBe;
        });
        var EBe = ye(($mr, MBe)=>{
            "use strict";
            MBe.exports = SBe();
        });
        var cK = ye((Qmr, kBe)=>{
            "use strict";
            var PNt = Jl(), lK = Cd(), uK = Su(), INt = Ju().attributes, CF = no().extendFlat, RNt = Vs().templatedArray;
            kBe.exports = {
                domain: INt({
                    name: "parcoords",
                    trace: !0,
                    editType: "plot"
                }),
                labelangle: {
                    valType: "angle",
                    dflt: 0,
                    editType: "plot"
                },
                labelside: {
                    valType: "enumerated",
                    values: [
                        "top",
                        "bottom"
                    ],
                    dflt: "top",
                    editType: "plot"
                },
                labelfont: uK({
                    editType: "plot"
                }),
                tickfont: uK({
                    autoShadowDflt: !0,
                    editType: "plot"
                }),
                rangefont: uK({
                    editType: "plot"
                }),
                dimensions: RNt("dimension", {
                    label: {
                        valType: "string",
                        editType: "plot"
                    },
                    tickvals: CF({}, lK.tickvals, {
                        editType: "plot"
                    }),
                    ticktext: CF({}, lK.ticktext, {
                        editType: "plot"
                    }),
                    tickformat: CF({}, lK.tickformat, {
                        editType: "plot"
                    }),
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    range: {
                        valType: "info_array",
                        items: [
                            {
                                valType: "number",
                                editType: "plot"
                            },
                            {
                                valType: "number",
                                editType: "plot"
                            }
                        ],
                        editType: "plot"
                    },
                    constraintrange: {
                        valType: "info_array",
                        freeLength: !0,
                        dimensions: "1-2",
                        items: [
                            {
                                valType: "any",
                                editType: "plot"
                            },
                            {
                                valType: "any",
                                editType: "plot"
                            }
                        ],
                        editType: "plot"
                    },
                    multiselect: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "plot"
                    },
                    values: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    editType: "calc"
                }),
                line: CF({
                    editType: "calc"
                }, PNt("line", {
                    colorscaleDflt: "Viridis",
                    autoColorDflt: !1,
                    editTypeOverride: "calc"
                })),
                unselected: {
                    line: {
                        color: {
                            valType: "color",
                            dflt: "#7f7f7f",
                            editType: "plot"
                        },
                        opacity: {
                            valType: "number",
                            min: 0,
                            max: 1,
                            dflt: "auto",
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    editType: "plot"
                }
            };
        });
        var Ak = ye((eyr, CBe)=>{
            "use strict";
            CBe.exports = {
                maxDimensionCount: 60,
                overdrag: 45,
                verticalPadding: 2,
                tickDistance: 50,
                canvasPixelRatio: 1,
                blockLineCount: 5e3,
                layers: [
                    "contextLineLayer",
                    "focusLineLayer",
                    "pickLineLayer"
                ],
                axisTitleOffset: 28,
                axisExtentOffset: 10,
                bar: {
                    width: 4,
                    captureWidth: 10,
                    fillColor: "magenta",
                    fillOpacity: 1,
                    snapDuration: 150,
                    snapRatio: .25,
                    snapClose: .01,
                    strokeOpacity: 1,
                    strokeWidth: 1,
                    handleHeight: 8,
                    handleOpacity: 1,
                    handleOverlap: 0
                },
                cn: {
                    axisExtentText: "axis-extent-text",
                    parcoordsLineLayers: "parcoords-line-layers",
                    parcoordsLineLayer: "parcoords-lines",
                    parcoords: "parcoords",
                    parcoordsControlView: "parcoords-control-view",
                    yAxis: "y-axis",
                    axisOverlays: "axis-overlays",
                    axis: "axis",
                    axisHeading: "axis-heading",
                    axisTitle: "axis-title",
                    axisExtent: "axis-extent",
                    axisExtentTop: "axis-extent-top",
                    axisExtentTopText: "axis-extent-top-text",
                    axisExtentBottom: "axis-extent-bottom",
                    axisExtentBottomText: "axis-extent-bottom-text",
                    axisBrush: "axis-brush"
                },
                id: {
                    filterBarPattern: "filter-bar-pattern"
                }
            };
        });
        var Km = ye((tyr, PBe)=>{
            "use strict";
            var DNt = OS();
            function LBe(e) {
                return [
                    e
                ];
            }
            PBe.exports = {
                keyFun: function(e) {
                    return e.key;
                },
                repeat: LBe,
                descend: DNt,
                wrap: LBe,
                unwrap: function(e) {
                    return e[0];
                }
            };
        });
        var dK = ye((ryr, VBe)=>{
            "use strict";
            var th = Ak(), em = xa(), zNt = Km().keyFun, LF = Km().repeat, gA = Mr().sorterAsc, FNt = Mr().strTranslate, IBe = th.bar.snapRatio;
            function RBe(e, t) {
                return e * (1 - IBe) + t * IBe;
            }
            var DBe = th.bar.snapClose;
            function qNt(e, t) {
                return e * (1 - DBe) + t * DBe;
            }
            function IF(e, t, r, n) {
                if (ONt(r, n)) return r;
                var i = e ? -1 : 1, a = 0, o = t.length - 1;
                if (i < 0) {
                    var s = a;
                    a = o, o = s;
                }
                for(var l = t[a], u = l, c = a; i * c < i * o; c += i){
                    var f = c + i, h = t[f];
                    if (i * r < i * qNt(l, h)) return RBe(l, u);
                    if (i * r < i * h || f === o) return RBe(h, l);
                    u = l, l = h;
                }
            }
            function ONt(e, t) {
                for(var r = 0; r < t.length; r++)if (e >= t[r][0] && e <= t[r][1]) return !0;
                return !1;
            }
            function BNt(e) {
                e.attr("x", -th.bar.captureWidth / 2).attr("width", th.bar.captureWidth);
            }
            function NNt(e) {
                e.attr("visibility", "visible").style("visibility", "visible").attr("fill", "yellow").attr("opacity", 0);
            }
            function UNt(e) {
                if (!e.brush.filterSpecified) return "0," + e.height;
                for(var t = zBe(e.brush.filter.getConsolidated(), e.height), r = [
                    0
                ], n, i, a, o = t.length ? t[0][0] : null, s = 0; s < t.length; s++)n = t[s], i = n[1] - n[0], r.push(o), r.push(i), a = s + 1, a < t.length && (o = t[a][0] - n[1]);
                return r.push(e.height), r;
            }
            function zBe(e, t) {
                return e.map(function(r) {
                    return r.map(function(n) {
                        return Math.max(0, n * t);
                    }).sort(gA);
                });
            }
            function VNt(e, t) {
                var r = th.bar.handleHeight;
                if (!(t > e[1] + r || t < e[0] - r)) return t >= .9 * e[1] + .1 * e[0] ? "n" : t <= .9 * e[0] + .1 * e[1] ? "s" : "ns";
            }
            function FBe() {
                em.select(document.body).style("cursor", null);
            }
            function hK(e) {
                e.attr("stroke-dasharray", UNt);
            }
            function PF(e, t) {
                var r = em.select(e).selectAll(".highlight, .highlight-shadow"), n = t ? r.transition().duration(th.bar.snapDuration).each("end", t) : r;
                hK(n);
            }
            function qBe(e, t) {
                var r = e.brush, n = r.filterSpecified, i = NaN, a = {}, o;
                if (n) {
                    var s = e.height, l = r.filter.getConsolidated(), u = zBe(l, s), c = NaN, f = NaN, h = NaN;
                    for(o = 0; o <= u.length; o++){
                        var d = u[o];
                        if (d && d[0] <= t && t <= d[1]) {
                            c = o;
                            break;
                        } else if (f = o ? o - 1 : NaN, d && d[0] > t) {
                            h = o;
                            break;
                        }
                    }
                    if (i = c, isNaN(i) && (isNaN(f) || isNaN(h) ? i = isNaN(f) ? h : f : i = t - u[f][1] < u[h][0] - t ? f : h), !isNaN(i)) {
                        var v = u[i], x = VNt(v, t);
                        x && (a.interval = l[i], a.intervalPix = v, a.region = x);
                    }
                }
                if (e.ordinal && !a.region) {
                    var b = e.unitTickvals, p = e.unitToPaddedPx.invert(t);
                    for(o = 0; o < b.length; o++){
                        var E = [
                            b[Math.max(o - 1, 0)] * .25 + b[o] * .75,
                            b[Math.min(o + 1, b.length - 1)] * .25 + b[o] * .75
                        ];
                        if (p >= E[0] && p <= E[1]) {
                            a.clickableOrdinalRange = E;
                            break;
                        }
                    }
                }
                return a;
            }
            function HNt(e, t) {
                em.event.sourceEvent.stopPropagation();
                var r = t.height - em.mouse(e)[1] - 2 * th.verticalPadding, n = t.unitToPaddedPx.invert(r), i = t.brush, a = qBe(t, r), o = a.interval, s = i.svgBrush;
                if (s.wasDragged = !1, s.grabbingBar = a.region === "ns", s.grabbingBar) {
                    var l = o.map(t.unitToPaddedPx);
                    s.grabPoint = r - l[0] - th.verticalPadding, s.barLength = l[1] - l[0];
                }
                s.clickableOrdinalRange = a.clickableOrdinalRange, s.stayingIntervals = t.multiselect && i.filterSpecified ? i.filter.getConsolidated() : [], o && (s.stayingIntervals = s.stayingIntervals.filter(function(u) {
                    return u[0] !== o[0] && u[1] !== o[1];
                })), s.startExtent = a.region ? o[a.region === "s" ? 1 : 0] : n, t.parent.inBrushDrag = !0, s.brushStartCallback();
            }
            function OBe(e, t) {
                em.event.sourceEvent.stopPropagation();
                var r = t.height - em.mouse(e)[1] - 2 * th.verticalPadding, n = t.brush.svgBrush;
                n.wasDragged = !0, n._dragging = !0, n.grabbingBar ? n.newExtent = [
                    r - n.grabPoint,
                    r + n.barLength - n.grabPoint
                ].map(t.unitToPaddedPx.invert) : n.newExtent = [
                    n.startExtent,
                    t.unitToPaddedPx.invert(r)
                ].sort(gA), t.brush.filterSpecified = !0, n.extent = n.stayingIntervals.concat([
                    n.newExtent
                ]), n.brushCallback(t), PF(e.parentNode);
            }
            function GNt(e, t) {
                var r = t.brush, n = r.filter, i = r.svgBrush;
                i._dragging || (BBe(e, t), OBe(e, t), t.brush.svgBrush.wasDragged = !1), i._dragging = !1;
                var a = em.event;
                a.sourceEvent.stopPropagation();
                var o = i.grabbingBar;
                if (i.grabbingBar = !1, i.grabLocation = void 0, t.parent.inBrushDrag = !1, FBe(), !i.wasDragged) {
                    i.wasDragged = void 0, i.clickableOrdinalRange ? r.filterSpecified && t.multiselect ? i.extent.push(i.clickableOrdinalRange) : (i.extent = [
                        i.clickableOrdinalRange
                    ], r.filterSpecified = !0) : o ? (i.extent = i.stayingIntervals, i.extent.length === 0 && fK(r)) : fK(r), i.brushCallback(t), PF(e.parentNode), i.brushEndCallback(r.filterSpecified ? n.getConsolidated() : []);
                    return;
                }
                var s = function() {
                    n.set(n.getConsolidated());
                };
                if (t.ordinal) {
                    var l = t.unitTickvals;
                    l[l.length - 1] < l[0] && l.reverse(), i.newExtent = [
                        IF(0, l, i.newExtent[0], i.stayingIntervals),
                        IF(1, l, i.newExtent[1], i.stayingIntervals)
                    ];
                    var u = i.newExtent[1] > i.newExtent[0];
                    i.extent = i.stayingIntervals.concat(u ? [
                        i.newExtent
                    ] : []), i.extent.length || fK(r), i.brushCallback(t), u ? PF(e.parentNode, s) : (s(), PF(e.parentNode));
                } else s();
                i.brushEndCallback(r.filterSpecified ? n.getConsolidated() : []);
            }
            function BBe(e, t) {
                var r = t.height - em.mouse(e)[1] - 2 * th.verticalPadding, n = qBe(t, r), i = "crosshair";
                n.clickableOrdinalRange ? i = "pointer" : n.region && (i = n.region + "-resize"), em.select(document.body).style("cursor", i);
            }
            function jNt(e) {
                e.on("mousemove", function(t) {
                    em.event.preventDefault(), t.parent.inBrushDrag || BBe(this, t);
                }).on("mouseleave", function(t) {
                    t.parent.inBrushDrag || FBe();
                }).call(em.behavior.drag().on("dragstart", function(t) {
                    HNt(this, t);
                }).on("drag", function(t) {
                    OBe(this, t);
                }).on("dragend", function(t) {
                    GNt(this, t);
                }));
            }
            function NBe(e, t) {
                return e[0] - t[0];
            }
            function WNt(e, t, r) {
                var n = r._context.staticPlot, i = e.selectAll(".background").data(LF);
                i.enter().append("rect").classed("background", !0).call(BNt).call(NNt).style("pointer-events", n ? "none" : "auto").attr("transform", FNt(0, th.verticalPadding)), i.call(jNt).attr("height", function(s) {
                    return s.height - th.verticalPadding;
                });
                var a = e.selectAll(".highlight-shadow").data(LF);
                a.enter().append("line").classed("highlight-shadow", !0).attr("x", -th.bar.width / 2).attr("stroke-width", th.bar.width + th.bar.strokeWidth).attr("stroke", t).attr("opacity", th.bar.strokeOpacity).attr("stroke-linecap", "butt"), a.attr("y1", function(s) {
                    return s.height;
                }).call(hK);
                var o = e.selectAll(".highlight").data(LF);
                o.enter().append("line").classed("highlight", !0).attr("x", -th.bar.width / 2).attr("stroke-width", th.bar.width - th.bar.strokeWidth).attr("stroke", th.bar.fillColor).attr("opacity", th.bar.fillOpacity).attr("stroke-linecap", "butt"), o.attr("y1", function(s) {
                    return s.height;
                }).call(hK);
            }
            function ZNt(e, t, r) {
                var n = e.selectAll("." + th.cn.axisBrush).data(LF, zNt);
                n.enter().append("g").classed(th.cn.axisBrush, !0), WNt(n, t, r);
            }
            function XNt(e) {
                return e.svgBrush.extent.map(function(t) {
                    return t.slice();
                });
            }
            function fK(e) {
                e.filterSpecified = !1, e.svgBrush.extent = [
                    [
                        -1 / 0,
                        1 / 0
                    ]
                ];
            }
            function YNt(e) {
                return function(r) {
                    var n = r.brush, i = XNt(n), a = i.slice();
                    n.filter.set(a), e();
                };
            }
            function UBe(e) {
                for(var t = e.slice(), r = [], n, i = t.shift(); i;){
                    for(n = i.slice(); (i = t.shift()) && i[0] <= n[1];)n[1] = Math.max(n[1], i[1]);
                    r.push(n);
                }
                return r.length === 1 && r[0][0] > r[0][1] && (r = []), r;
            }
            function KNt() {
                var e = [], t, r;
                return {
                    set: function(n) {
                        e = n.map(function(i) {
                            return i.slice().sort(gA);
                        }).sort(NBe), e.length === 1 && e[0][0] === -1 / 0 && e[0][1] === 1 / 0 && (e = [
                            [
                                0,
                                -1
                            ]
                        ]), t = UBe(e), r = e.reduce(function(i, a) {
                            return [
                                Math.min(i[0], a[0]),
                                Math.max(i[1], a[1])
                            ];
                        }, [
                            1 / 0,
                            -1 / 0
                        ]);
                    },
                    get: function() {
                        return e.slice();
                    },
                    getConsolidated: function() {
                        return t;
                    },
                    getBounds: function() {
                        return r;
                    }
                };
            }
            function JNt(e, t, r, n, i, a) {
                var o = KNt();
                return o.set(r), {
                    filter: o,
                    filterSpecified: t,
                    svgBrush: {
                        extent: [],
                        brushStartCallback: n,
                        brushCallback: YNt(i),
                        brushEndCallback: a
                    }
                };
            }
            function $Nt(e, t) {
                if (Array.isArray(e[0]) ? (e = e.map(function(n) {
                    return n.sort(gA);
                }), t.multiselect ? e = UBe(e.sort(NBe)) : e = [
                    e[0]
                ]) : e = [
                    e.sort(gA)
                ], t.tickvals) {
                    var r = t.tickvals.slice().sort(gA);
                    if (e = e.map(function(n) {
                        var i = [
                            IF(0, r, n[0], []),
                            IF(1, r, n[1], [])
                        ];
                        if (i[1] > i[0]) return i;
                    }).filter(function(n) {
                        return n;
                    }), !e.length) return;
                }
                return e.length > 1 ? e : e[0];
            }
            VBe.exports = {
                makeBrush: JNt,
                ensureAxisBrush: ZNt,
                cleanRanges: $Nt
            };
        });
        var jBe = ye((iyr, GBe)=>{
            "use strict";
            var mx = Mr(), QNt = Dv().hasColorscale, eUt = Uh(), tUt = Ju().defaults, rUt = Zd(), iUt = Qa(), HBe = cK(), nUt = dK(), vK = Ak().maxDimensionCount, aUt = wF();
            function oUt(e, t, r, n, i) {
                var a = i("line.color", r);
                if (QNt(e, "line") && mx.isArrayOrTypedArray(a)) {
                    if (a.length) return i("line.colorscale"), eUt(e, t, n, i, {
                        prefix: "line.",
                        cLetter: "c"
                    }), a.length;
                    t.line.color = r;
                }
                return 1 / 0;
            }
            function sUt(e, t, r, n) {
                function i(u, c) {
                    return mx.coerce(e, t, HBe.dimensions, u, c);
                }
                var a = i("values"), o = i("visible");
                if (a && a.length || (o = t.visible = !1), o) {
                    i("label"), i("tickvals"), i("ticktext"), i("tickformat");
                    var s = i("range");
                    t._ax = {
                        _id: "y",
                        type: "linear",
                        showexponent: "all",
                        exponentformat: "B",
                        range: s
                    }, iUt.setConvert(t._ax, n.layout), i("multiselect");
                    var l = i("constraintrange");
                    l && (t.constraintrange = nUt.cleanRanges(l, t));
                }
            }
            GBe.exports = function(t, r, n, i) {
                function a(c, f) {
                    return mx.coerce(t, r, HBe, c, f);
                }
                var o = t.dimensions;
                Array.isArray(o) && o.length > vK && (mx.log("parcoords traces support up to " + vK + " dimensions at the moment"), o.splice(vK));
                var s = rUt(t, r, {
                    name: "dimensions",
                    layout: i,
                    handleItemDefaults: sUt
                }), l = oUt(t, r, n, i, a);
                tUt(r, i, a), (!Array.isArray(s) || !s.length) && (r.visible = !1), aUt(r, s, "values", l);
                var u = mx.extendFlat({}, i.font, {
                    size: Math.round(i.font.size / 1.2)
                });
                mx.coerceFont(a, "labelfont", u), mx.coerceFont(a, "tickfont", u, {
                    autoShadowDflt: !0
                }), mx.coerceFont(a, "rangefont", u), a("labelangle"), a("labelside"), a("unselected.line.color"), a("unselected.line.opacity");
            };
        });
        var ZBe = ye((nyr, WBe)=>{
            "use strict";
            var lUt = Mr().isArrayOrTypedArray, pK = Mu(), uUt = Km().wrap;
            WBe.exports = function(t, r) {
                var n, i;
                return pK.hasColorscale(r, "line") && lUt(r.line.color) ? (n = r.line.color, i = pK.extractOpts(r.line).colorscale, pK.calc(t, r, {
                    vals: n,
                    containerStr: "line",
                    cLetter: "c"
                })) : (n = cUt(r._length), i = [
                    [
                        0,
                        r.line.color
                    ],
                    [
                        1,
                        r.line.color
                    ]
                ]), uUt({
                    lineColor: n,
                    cscale: i
                });
            };
            function cUt(e) {
                for(var t = new Array(e), r = 0; r < e; r++)t[r] = .5;
                return t;
            }
        });
        function fUt(e) {
            var c, f;
            var t, r = [], n = 1, i;
            if (typeof e == "number") return {
                space: "rgb",
                values: [
                    e >>> 16,
                    (e & 65280) >>> 8,
                    e & 255
                ],
                alpha: 1
            };
            if (typeof e == "number") return {
                space: "rgb",
                values: [
                    e >>> 16,
                    (e & 65280) >>> 8,
                    e & 255
                ],
                alpha: 1
            };
            if (e = String(e).toLowerCase(), gK.default[e]) r = gK.default[e].slice(), i = "rgb";
            else if (e === "transparent") n = 0, i = "rgb", r = [
                0,
                0,
                0
            ];
            else if (e[0] === "#") {
                var a = e.slice(1), o = a.length, s = o <= 4;
                n = 1, s ? (r = [
                    parseInt(a[0] + a[0], 16),
                    parseInt(a[1] + a[1], 16),
                    parseInt(a[2] + a[2], 16)
                ], o === 4 && (n = parseInt(a[3] + a[3], 16) / 255)) : (r = [
                    parseInt(a[0] + a[1], 16),
                    parseInt(a[2] + a[3], 16),
                    parseInt(a[4] + a[5], 16)
                ], o === 8 && (n = parseInt(a[6] + a[7], 16) / 255)), r[0] || (r[0] = 0), r[1] || (r[1] = 0), r[2] || (r[2] = 0), i = "rgb";
            } else if (t = /^((?:rgba?|hs[lvb]a?|hwba?|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms|oklch|oklab|color))\s*\(([^\)]*)\)/.exec(e)) {
                var l = t[1];
                i = l.replace(/a$/, "");
                var u = i === "cmyk" ? 4 : i === "gray" ? 1 : 3;
                r = t[2].trim().split(/\s*[,\/]\s*|\s+/), i === "color" && (i = r.shift()), r = r.map(function(h, d) {
                    if (h[h.length - 1] === "%") return h = parseFloat(h) / 100, d === 3 ? h : i === "rgb" ? h * 255 : i[0] === "h" || i[0] === "l" && !d ? h * 100 : i === "lab" ? h * 125 : i === "lch" ? d < 2 ? h * 150 : h * 360 : i[0] === "o" && !d ? h : i === "oklab" ? h * .4 : i === "oklch" ? d < 2 ? h * .4 : h * 360 : h;
                    if (i[d] === "h" || d === 2 && i[i.length - 1] === "h") {
                        if (XBe[h] !== void 0) return XBe[h];
                        if (h.endsWith("deg")) return parseFloat(h);
                        if (h.endsWith("turn")) return parseFloat(h) * 360;
                        if (h.endsWith("grad")) return parseFloat(h) * 360 / 400;
                        if (h.endsWith("rad")) return parseFloat(h) * 180 / Math.PI;
                    }
                    return h === "none" ? 0 : parseFloat(h);
                }), n = r.length > u ? r.pop() : 1;
            } else /[0-9](?:\s|\/|,)/.test(e) && (r = e.match(/([0-9]+)/g).map(function(h) {
                return parseFloat(h);
            }), i = ((f = (c = e.match(/([a-z])/ig)) == null ? void 0 : c.join("")) == null ? void 0 : f.toLowerCase()) || "rgb");
            return {
                space: i,
                values: r,
                alpha: n
            };
        }
        var gK, YBe, XBe, KBe = Ll(()=>{
            gK = YQe(rZ(), 1), YBe = fUt, XBe = {
                red: 0,
                orange: 60,
                yellow: 120,
                green: 180,
                blue: 240,
                purple: 300
            };
        });
        var Sk, mK = Ll(()=>{
            Sk = {
                name: "rgb",
                min: [
                    0,
                    0,
                    0
                ],
                max: [
                    255,
                    255,
                    255
                ],
                channel: [
                    "red",
                    "green",
                    "blue"
                ],
                alias: [
                    "RGB"
                ]
            };
        });
        var RF, JBe = Ll(()=>{
            mK();
            RF = {
                name: "hsl",
                min: [
                    0,
                    0,
                    0
                ],
                max: [
                    360,
                    100,
                    100
                ],
                channel: [
                    "hue",
                    "saturation",
                    "lightness"
                ],
                alias: [
                    "HSL"
                ],
                rgb: function(e) {
                    var t = e[0] / 360, r = e[1] / 100, n = e[2] / 100, i, a, o, s, l, u = 0;
                    if (r === 0) return l = n * 255, [
                        l,
                        l,
                        l
                    ];
                    for(a = n < .5 ? n * (1 + r) : n + r - n * r, i = 2 * n - a, s = [
                        0,
                        0,
                        0
                    ]; u < 3;)o = t + 1 / 3 * -(u - 1), o < 0 ? o++ : o > 1 && o--, l = 6 * o < 1 ? i + (a - i) * 6 * o : 2 * o < 1 ? a : 3 * o < 2 ? i + (a - i) * (2 / 3 - o) * 6 : i, s[u++] = l * 255;
                    return s;
                }
            };
            Sk.hsl = function(e) {
                var t = e[0] / 255, r = e[1] / 255, n = e[2] / 255, i = Math.min(t, r, n), a = Math.max(t, r, n), o = a - i, s, l, u;
                return a === i ? s = 0 : t === a ? s = (r - n) / o : r === a ? s = 2 + (n - t) / o : n === a && (s = 4 + (t - r) / o), s = Math.min(s * 60, 360), s < 0 && (s += 360), u = (i + a) / 2, a === i ? l = 0 : u <= .5 ? l = o / (a + i) : l = o / (2 - a - i), [
                    s,
                    l * 100,
                    u * 100
                ];
            };
        });
        var QBe = {};
        QQ(QBe, {
            default: ()=>$Be
        });
        function $Be(e) {
            Array.isArray(e) && e.raw && (e = String.raw(...arguments)), e instanceof Number && (e = +e);
            var t, r, n, i = YBe(e);
            if (!i.space) return [];
            let a = i.space[0] === "h" ? RF.min : Sk.min, o = i.space[0] === "h" ? RF.max : Sk.max;
            return t = Array(3), t[0] = Math.min(Math.max(i.values[0], a[0]), o[0]), t[1] = Math.min(Math.max(i.values[1], a[1]), o[1]), t[2] = Math.min(Math.max(i.values[2], a[2]), o[2]), i.space[0] === "h" && (t = RF.rgb(t)), t.push(Math.min(Math.max(i.alpha, 0), 1)), t;
        }
        var eNe = Ll(()=>{
            KBe();
            mK();
            JBe();
        });
        var yK = ye((DF)=>{
            "use strict";
            var hUt = Mr().isTypedArray;
            DF.convertTypedArray = function(e) {
                return hUt(e) ? Array.prototype.slice.call(e) : e;
            };
            DF.isOrdinal = function(e) {
                return !!e.tickvals;
            };
            DF.isVisible = function(e) {
                return e.visible || !("visible" in e);
            };
        });
        var cNe = ye((dyr, uNe)=>{
            "use strict";
            var dUt = [
                "precision highp float;",
                "",
                "varying vec4 fragColor;",
                "",
                "attribute vec4 p01_04, p05_08, p09_12, p13_16,",
                "               p17_20, p21_24, p25_28, p29_32,",
                "               p33_36, p37_40, p41_44, p45_48,",
                "               p49_52, p53_56, p57_60, colors;",
                "",
                "uniform mat4 dim0A, dim1A, dim0B, dim1B, dim0C, dim1C, dim0D, dim1D,",
                "             loA, hiA, loB, hiB, loC, hiC, loD, hiD;",
                "",
                "uniform vec2 resolution, viewBoxPos, viewBoxSize;",
                "uniform float maskHeight;",
                "uniform float drwLayer; // 0: context, 1: focus, 2: pick",
                "uniform vec4 contextColor;",
                "uniform sampler2D maskTexture, palette;",
                "",
                "bool isPick    = (drwLayer > 1.5);",
                "bool isContext = (drwLayer < 0.5);",
                "",
                "const vec4 ZEROS = vec4(0.0, 0.0, 0.0, 0.0);",
                "const vec4 UNITS = vec4(1.0, 1.0, 1.0, 1.0);",
                "",
                "float val(mat4 p, mat4 v) {",
                "    return dot(matrixCompMult(p, v) * UNITS, UNITS);",
                "}",
                "",
                "float axisY(float ratio, mat4 A, mat4 B, mat4 C, mat4 D) {",
                "    float y1 = val(A, dim0A) + val(B, dim0B) + val(C, dim0C) + val(D, dim0D);",
                "    float y2 = val(A, dim1A) + val(B, dim1B) + val(C, dim1C) + val(D, dim1D);",
                "    return y1 * (1.0 - ratio) + y2 * ratio;",
                "}",
                "",
                "int iMod(int a, int b) {",
                "    return a - b * (a / b);",
                "}",
                "",
                "bool fOutside(float p, float lo, float hi) {",
                "    return (lo < hi) && (lo > p || p > hi);",
                "}",
                "",
                "bool vOutside(vec4 p, vec4 lo, vec4 hi) {",
                "    return (",
                "        fOutside(p[0], lo[0], hi[0]) ||",
                "        fOutside(p[1], lo[1], hi[1]) ||",
                "        fOutside(p[2], lo[2], hi[2]) ||",
                "        fOutside(p[3], lo[3], hi[3])",
                "    );",
                "}",
                "",
                "bool mOutside(mat4 p, mat4 lo, mat4 hi) {",
                "    return (",
                "        vOutside(p[0], lo[0], hi[0]) ||",
                "        vOutside(p[1], lo[1], hi[1]) ||",
                "        vOutside(p[2], lo[2], hi[2]) ||",
                "        vOutside(p[3], lo[3], hi[3])",
                "    );",
                "}",
                "",
                "bool outsideBoundingBox(mat4 A, mat4 B, mat4 C, mat4 D) {",
                "    return mOutside(A, loA, hiA) ||",
                "           mOutside(B, loB, hiB) ||",
                "           mOutside(C, loC, hiC) ||",
                "           mOutside(D, loD, hiD);",
                "}",
                "",
                "bool outsideRasterMask(mat4 A, mat4 B, mat4 C, mat4 D) {",
                "    mat4 pnts[4];",
                "    pnts[0] = A;",
                "    pnts[1] = B;",
                "    pnts[2] = C;",
                "    pnts[3] = D;",
                "",
                "    for(int i = 0; i < 4; ++i) {",
                "        for(int j = 0; j < 4; ++j) {",
                "            for(int k = 0; k < 4; ++k) {",
                "                if(0 == iMod(",
                "                    int(255.0 * texture2D(maskTexture,",
                "                        vec2(",
                "                            (float(i * 2 + j / 2) + 0.5) / 8.0,",
                "                            (pnts[i][j][k] * (maskHeight - 1.0) + 1.0) / maskHeight",
                "                        ))[3]",
                "                    ) / int(pow(2.0, float(iMod(j * 4 + k, 8)))),",
                "                    2",
                "                )) return true;",
                "            }",
                "        }",
                "    }",
                "    return false;",
                "}",
                "",
                "vec4 position(bool isContext, float v, mat4 A, mat4 B, mat4 C, mat4 D) {",
                "    float x = 0.5 * sign(v) + 0.5;",
                "    float y = axisY(x, A, B, C, D);",
                "    float z = 1.0 - abs(v);",
                "",
                "    z += isContext ? 0.0 : 2.0 * float(",
                "        outsideBoundingBox(A, B, C, D) ||",
                "        outsideRasterMask(A, B, C, D)",
                "    );",
                "",
                "    return vec4(",
                "        2.0 * (vec2(x, y) * viewBoxSize + viewBoxPos) / resolution - 1.0,",
                "        z,",
                "        1.0",
                "    );",
                "}",
                "",
                "void main() {",
                "    mat4 A = mat4(p01_04, p05_08, p09_12, p13_16);",
                "    mat4 B = mat4(p17_20, p21_24, p25_28, p29_32);",
                "    mat4 C = mat4(p33_36, p37_40, p41_44, p45_48);",
                "    mat4 D = mat4(p49_52, p53_56, p57_60, ZEROS);",
                "",
                "    float v = colors[3];",
                "",
                "    gl_Position = position(isContext, v, A, B, C, D);",
                "",
                "    fragColor =",
                "        isContext ? vec4(contextColor) :",
                "        isPick ? vec4(colors.rgb, 1.0) : texture2D(palette, vec2(abs(v), 0.5));",
                "}"
            ].join(`
`), vUt = [
                "precision highp float;",
                "",
                "varying vec4 fragColor;",
                "",
                "void main() {",
                "    gl_FragColor = fragColor;",
                "}"
            ].join(`
`), Mk = Ak().maxDimensionCount, oNe = Mr(), tNe = 1e-6, zF = 2048, pUt = new Uint8Array(4), rNe = new Uint8Array(4), iNe = {
                shape: [
                    256,
                    1
                ],
                format: "rgba",
                type: "uint8",
                mag: "nearest",
                min: "nearest"
            };
            function gUt(e) {
                e.read({
                    x: 0,
                    y: 0,
                    width: 1,
                    height: 1,
                    data: pUt
                });
            }
            function sNe(e, t, r, n, i) {
                var a = e._gl;
                a.enable(a.SCISSOR_TEST), a.scissor(t, r, n, i), e.clear({
                    color: [
                        0,
                        0,
                        0,
                        0
                    ],
                    depth: 1
                });
            }
            function mUt(e, t, r, n, i, a) {
                var o = a.key;
                function s(l) {
                    var u = Math.min(n, i - l * n);
                    l === 0 && (window.cancelAnimationFrame(r.currentRafs[o]), delete r.currentRafs[o], sNe(e, a.scissorX, a.scissorY, a.scissorWidth, a.viewBoxSize[1])), !r.clearOnly && (a.count = 2 * u, a.offset = 2 * l * n, t(a), l * n + u < i && (r.currentRafs[o] = window.requestAnimationFrame(function() {
                        s(l + 1);
                    })), r.drawCompleted = !1);
                }
                r.drawCompleted || (gUt(e), r.drawCompleted = !0), s(0);
            }
            function yUt(e) {
                return Math.max(tNe, Math.min(1 - tNe, e));
            }
            function _Ut(e, t) {
                for(var r = new Array(256), n = 0; n < 256; n++)r[n] = e(n / 255).concat(t);
                return r;
            }
            function _K(e, t) {
                return (e >>> 8 * t) % 256 / 255;
            }
            function xUt(e, t, r) {
                for(var n = new Array(e * (Mk + 4)), i = 0, a = 0; a < e; a++){
                    for(var o = 0; o < Mk; o++)n[i++] = o < t.length ? t[o].paddedUnitValues[a] : .5;
                    n[i++] = _K(a, 2), n[i++] = _K(a, 1), n[i++] = _K(a, 0), n[i++] = yUt(r[a]);
                }
                return n;
            }
            function bUt(e, t, r) {
                for(var n = new Array(t * 8), i = 0, a = 0; a < t; a++)for(var o = 0; o < 2; o++)for(var s = 0; s < 4; s++){
                    var l = e * 4 + s, u = r[a * 64 + l];
                    l === 63 && o === 0 && (u *= -1), n[i++] = u;
                }
                return n;
            }
            function nNe(e) {
                var t = "0" + e;
                return t.substr(t.length - 2);
            }
            function lNe(e) {
                return e < Mk ? "p" + nNe(e + 1) + "_" + nNe(e + 4) : "colors";
            }
            function wUt(e, t, r) {
                for(var n = 0; n <= Mk; n += 4)e[lNe(n)](bUt(n / 4, t, r));
            }
            function TUt(e) {
                for(var t = {}, r = 0; r <= Mk; r += 4)t[lNe(r)] = e.buffer({
                    usage: "dynamic",
                    type: "float",
                    data: new Uint8Array(0)
                });
                return t;
            }
            function AUt(e, t, r, n, i, a, o, s, l, u, c, f, h, d) {
                for(var v = [
                    [],
                    []
                ], x = 0; x < 64; x++)v[0][x] = x === i ? 1 : 0, v[1][x] = x === a ? 1 : 0;
                o *= d, s *= d, l *= d, u *= d;
                var b = e.lines.canvasOverdrag * d, p = e.domain, E = e.canvasWidth * d, k = e.canvasHeight * d, A = e.pad.l * d, L = e.pad.b * d, _ = e.layoutHeight * d, C = e.layoutWidth * d, M = e.deselectedLines.color, g = e.deselectedLines.opacity, P = oNe.extendFlat({
                    key: c,
                    resolution: [
                        E,
                        k
                    ],
                    viewBoxPos: [
                        o + b,
                        s
                    ],
                    viewBoxSize: [
                        l,
                        u
                    ],
                    i0: i,
                    i1: a,
                    dim0A: v[0].slice(0, 16),
                    dim0B: v[0].slice(16, 32),
                    dim0C: v[0].slice(32, 48),
                    dim0D: v[0].slice(48, 64),
                    dim1A: v[1].slice(0, 16),
                    dim1B: v[1].slice(16, 32),
                    dim1C: v[1].slice(32, 48),
                    dim1D: v[1].slice(48, 64),
                    drwLayer: f,
                    contextColor: [
                        M[0] / 255,
                        M[1] / 255,
                        M[2] / 255,
                        g !== "auto" ? M[3] * g : Math.max(1 / 255, Math.pow(1 / e.lines.color.length, 1 / 3))
                    ],
                    scissorX: (n === t ? 0 : o + b) + (A - b) + C * p.x[0],
                    scissorWidth: (n === r ? E - o + b : l + .5) + (n === t ? o + b : 0),
                    scissorY: s + L + _ * p.y[0],
                    scissorHeight: u,
                    viewportX: A - b + C * p.x[0],
                    viewportY: L + _ * p.y[0],
                    viewportWidth: E,
                    viewportHeight: k
                }, h);
                return P;
            }
            function aNe(e) {
                var t = zF - 1, r = Math.max(0, Math.floor(e[0] * t), 0), n = Math.min(t, Math.ceil(e[1] * t), t);
                return [
                    Math.min(r, n),
                    Math.max(r, n)
                ];
            }
            uNe.exports = function(e, t) {
                var r = t.context, n = t.pick, i = t.regl, a = i._gl, o = a.getParameter(a.ALIASED_LINE_WIDTH_RANGE), s = Math.max(o[0], Math.min(o[1], t.viewModel.plotGlPixelRatio)), l = {
                    currentRafs: {},
                    drawCompleted: !0,
                    clearOnly: !1
                }, u, c, f, h, d = TUt(i), v, x = i.texture(iNe), b = [];
                E(t);
                var p = i({
                    profile: !1,
                    blend: {
                        enable: r,
                        func: {
                            srcRGB: "src alpha",
                            dstRGB: "one minus src alpha",
                            srcAlpha: 1,
                            dstAlpha: 1
                        },
                        equation: {
                            rgb: "add",
                            alpha: "add"
                        },
                        color: [
                            0,
                            0,
                            0,
                            0
                        ]
                    },
                    depth: {
                        enable: !r,
                        mask: !0,
                        func: "less",
                        range: [
                            0,
                            1
                        ]
                    },
                    cull: {
                        enable: !0,
                        face: "back"
                    },
                    scissor: {
                        enable: !0,
                        box: {
                            x: i.prop("scissorX"),
                            y: i.prop("scissorY"),
                            width: i.prop("scissorWidth"),
                            height: i.prop("scissorHeight")
                        }
                    },
                    viewport: {
                        x: i.prop("viewportX"),
                        y: i.prop("viewportY"),
                        width: i.prop("viewportWidth"),
                        height: i.prop("viewportHeight")
                    },
                    dither: !1,
                    vert: dUt,
                    frag: vUt,
                    primitive: "lines",
                    lineWidth: s,
                    attributes: d,
                    uniforms: {
                        resolution: i.prop("resolution"),
                        viewBoxPos: i.prop("viewBoxPos"),
                        viewBoxSize: i.prop("viewBoxSize"),
                        dim0A: i.prop("dim0A"),
                        dim1A: i.prop("dim1A"),
                        dim0B: i.prop("dim0B"),
                        dim1B: i.prop("dim1B"),
                        dim0C: i.prop("dim0C"),
                        dim1C: i.prop("dim1C"),
                        dim0D: i.prop("dim0D"),
                        dim1D: i.prop("dim1D"),
                        loA: i.prop("loA"),
                        hiA: i.prop("hiA"),
                        loB: i.prop("loB"),
                        hiB: i.prop("hiB"),
                        loC: i.prop("loC"),
                        hiC: i.prop("hiC"),
                        loD: i.prop("loD"),
                        hiD: i.prop("hiD"),
                        palette: x,
                        contextColor: i.prop("contextColor"),
                        maskTexture: i.prop("maskTexture"),
                        drwLayer: i.prop("drwLayer"),
                        maskHeight: i.prop("maskHeight")
                    },
                    offset: i.prop("offset"),
                    count: i.prop("count")
                });
                function E(M) {
                    u = M.model, c = M.viewModel, f = c.dimensions.slice(), h = f[0] ? f[0].values.length : 0;
                    var g = u.lines, P = n ? g.color.map(function(F, q) {
                        return q / g.color.length;
                    }) : g.color, T = xUt(h, f, P);
                    wUt(d, h, T), !r && !n && (x = i.texture(oNe.extendFlat({
                        data: _Ut(u.unitToColor, 255)
                    }, iNe)));
                }
                function k(M) {
                    var g, P, T, F = [
                        [],
                        []
                    ];
                    for(T = 0; T < 64; T++){
                        var q = !M && T < f.length ? f[T].brush.filter.getBounds() : [
                            -1 / 0,
                            1 / 0
                        ];
                        F[0][T] = q[0], F[1][T] = q[1];
                    }
                    var V = zF * 8, H = new Array(V);
                    for(g = 0; g < V; g++)H[g] = 255;
                    if (!M) for(g = 0; g < f.length; g++){
                        var X = g % 8, G = (g - X) / 8, N = Math.pow(2, X), W = f[g], re = W.brush.filter.get();
                        if (!(re.length < 2)) {
                            var ae = aNe(re[0])[1];
                            for(P = 1; P < re.length; P++){
                                var _e = aNe(re[P]);
                                for(T = ae + 1; T < _e[0]; T++)H[T * 8 + G] &= ~N;
                                ae = Math.max(ae, _e[1]);
                            }
                        }
                    }
                    var Me = {
                        shape: [
                            8,
                            zF
                        ],
                        format: "alpha",
                        type: "uint8",
                        mag: "nearest",
                        min: "nearest",
                        data: H
                    };
                    return v ? v(Me) : v = i.texture(Me), {
                        maskTexture: v,
                        maskHeight: zF,
                        loA: F[0].slice(0, 16),
                        loB: F[0].slice(16, 32),
                        loC: F[0].slice(32, 48),
                        loD: F[0].slice(48, 64),
                        hiA: F[1].slice(0, 16),
                        hiB: F[1].slice(16, 32),
                        hiC: F[1].slice(32, 48),
                        hiD: F[1].slice(48, 64)
                    };
                }
                function A(M, g, P) {
                    var T = M.length, F, q, V, H = 1 / 0, X = -1 / 0;
                    for(F = 0; F < T; F++)M[F].dim0.canvasX < H && (H = M[F].dim0.canvasX, q = F), M[F].dim1.canvasX > X && (X = M[F].dim1.canvasX, V = F);
                    T === 0 && sNe(i, 0, 0, u.canvasWidth, u.canvasHeight);
                    var G = k(r);
                    for(F = 0; F < T; F++){
                        var N = M[F], W = N.dim0.crossfilterDimensionIndex, re = N.dim1.crossfilterDimensionIndex, ae = N.canvasX, _e = N.canvasY, Me = ae + N.panelSizeX, ke = N.plotGlPixelRatio;
                        if (g || !b[W] || b[W][0] !== ae || b[W][1] !== Me) {
                            b[W] = [
                                ae,
                                Me
                            ];
                            var ge = AUt(u, q, V, F, W, re, ae, _e, N.panelSizeX, N.panelSizeY, N.dim0.crossfilterDimensionIndex, r ? 0 : n ? 2 : 1, G, ke);
                            l.clearOnly = P;
                            var ie = g ? u.lines.blockLineCount : h;
                            mUt(i, p, l, ie, h, ge);
                        }
                    }
                }
                function L(M, g) {
                    return i.read({
                        x: M,
                        y: g,
                        width: 1,
                        height: 1,
                        data: rNe
                    }), rNe;
                }
                function _(M, g, P, T) {
                    var F = new Uint8Array(4 * P * T);
                    return i.read({
                        x: M,
                        y: g,
                        width: P,
                        height: T,
                        data: F
                    }), F;
                }
                function C() {
                    e.style["pointer-events"] = "none", x.destroy(), v && v.destroy();
                    for(var M in d)d[M].destroy();
                }
                return {
                    render: A,
                    readPixel: L,
                    readPixels: _,
                    destroy: C,
                    update: E
                };
            };
        });
        var ANe = ye((vyr, TNe)=>{
            "use strict";
            var zd = xa(), l1 = Mr(), xK = l1.isArrayOrTypedArray, gNe = l1.numberFormat, mNe = (eNe(), B1(QBe)).default, yNe = Qa(), SUt = l1.strRotate, Jm = l1.strTranslate, MUt = Pl(), FF = ao(), fNe = Mu(), TK = Km(), tg = TK.keyFun, $m = TK.repeat, _Ne = TK.unwrap, mA = yK(), ll = Ak(), xNe = dK(), EUt = cNe();
            function hNe(e, t, r) {
                return l1.aggNums(e, null, t, r);
            }
            function bNe(e, t) {
                return AK(hNe(Math.min, e, t), hNe(Math.max, e, t));
            }
            function qF(e) {
                var t = e.range;
                return t ? AK(t[0], t[1]) : bNe(e.values, e._length);
            }
            function AK(e, t) {
                return (isNaN(e) || !isFinite(e)) && (e = 0), (isNaN(t) || !isFinite(t)) && (t = 0), e === t && (e === 0 ? (e -= 1, t += 1) : (e *= .9, t *= 1.1)), [
                    e,
                    t
                ];
            }
            function kUt(e, t) {
                return t ? function(r, n) {
                    var i = t[n];
                    return i == null ? e(r) : i;
                } : e;
            }
            function CUt(e, t, r, n, i) {
                var a = qF(r);
                return n ? zd.scale.ordinal().domain(n.map(kUt(gNe(r.tickformat), i))).range(n.map(function(o) {
                    var s = (o - a[0]) / (a[1] - a[0]);
                    return e - t + s * (2 * t - e);
                })) : zd.scale.linear().domain(a).range([
                    e - t,
                    t
                ]);
            }
            function LUt(e, t) {
                return zd.scale.linear().range([
                    t,
                    e - t
                ]);
            }
            function PUt(e, t) {
                return zd.scale.linear().domain(qF(e)).range([
                    t,
                    1 - t
                ]);
            }
            function IUt(e) {
                if (e.tickvals) {
                    var t = qF(e);
                    return zd.scale.ordinal().domain(e.tickvals).range(e.tickvals.map(function(r) {
                        return (r - t[0]) / (t[1] - t[0]);
                    }));
                }
            }
            function RUt(e) {
                var t = e.map(function(a) {
                    return a[0];
                }), r = e.map(function(a) {
                    var o = mNe(a[1]);
                    return zd.rgb("rgb(" + o[0] + "," + o[1] + "," + o[2] + ")");
                }), n = function(a) {
                    return function(o) {
                        return o[a];
                    };
                }, i = "rgb".split("").map(function(a) {
                    return zd.scale.linear().clamp(!0).domain(t).range(r.map(n(a)));
                });
                return function(a) {
                    return i.map(function(o) {
                        return o(a);
                    });
                };
            }
            function wK(e) {
                return e.dimensions.some(function(t) {
                    return t.brush.filterSpecified;
                });
            }
            function DUt(e, t, r) {
                var n = _Ne(t), i = n.trace, a = mA.convertTypedArray(n.lineColor), o = i.line, s = {
                    color: mNe(i.unselected.line.color),
                    opacity: i.unselected.line.opacity
                }, l = fNe.extractOpts(o), u = l.reversescale ? fNe.flipScale(n.cscale) : n.cscale, c = i.domain, f = i.dimensions, h = e.width, d = i.labelangle, v = i.labelside, x = i.labelfont, b = i.tickfont, p = i.rangefont, E = l1.extendDeepNoArrays({}, o, {
                    color: a.map(zd.scale.linear().domain(qF({
                        values: a,
                        range: [
                            l.min,
                            l.max
                        ],
                        _length: i._length
                    }))),
                    blockLineCount: ll.blockLineCount,
                    canvasOverdrag: ll.overdrag * ll.canvasPixelRatio
                }), k = Math.floor(h * (c.x[1] - c.x[0])), A = Math.floor(e.height * (c.y[1] - c.y[0])), L = e.margin || {
                    l: 80,
                    r: 80,
                    t: 100,
                    b: 80
                }, _ = k, C = A;
                return {
                    key: r,
                    colCount: f.filter(mA.isVisible).length,
                    dimensions: f,
                    tickDistance: ll.tickDistance,
                    unitToColor: RUt(u),
                    lines: E,
                    deselectedLines: s,
                    labelAngle: d,
                    labelSide: v,
                    labelFont: x,
                    tickFont: b,
                    rangeFont: p,
                    layoutWidth: h,
                    layoutHeight: e.height,
                    domain: c,
                    translateX: c.x[0] * h,
                    translateY: e.height - c.y[1] * e.height,
                    pad: L,
                    canvasWidth: _ * ll.canvasPixelRatio + 2 * E.canvasOverdrag,
                    canvasHeight: C * ll.canvasPixelRatio,
                    width: _,
                    height: C,
                    canvasPixelRatio: ll.canvasPixelRatio
                };
            }
            function zUt(e, t, r) {
                var n = r.width, i = r.height, a = r.dimensions, o = r.canvasPixelRatio, s = function(h) {
                    return n * h / Math.max(1, r.colCount - 1);
                }, l = ll.verticalPadding / i, u = LUt(i, ll.verticalPadding), c = {
                    key: r.key,
                    xScale: s,
                    model: r,
                    inBrushDrag: !1
                }, f = {};
                return c.dimensions = a.filter(mA.isVisible).map(function(h, d) {
                    var v = PUt(h, l), x = f[h.label];
                    f[h.label] = (x || 0) + 1;
                    var b = h.label + (x ? "__" + x : ""), p = h.constraintrange, E = p && p.length;
                    E && !xK(p[0]) && (p = [
                        p
                    ]);
                    var k = E ? p.map(function(q) {
                        return q.map(v);
                    }) : [
                        [
                            -1 / 0,
                            1 / 0
                        ]
                    ], A = function() {
                        var q = c;
                        q.focusLayer && q.focusLayer.render(q.panels, !0);
                        var V = wK(q);
                        !e.contextShown() && V ? (q.contextLayer && q.contextLayer.render(q.panels, !0), e.contextShown(!0)) : e.contextShown() && !V && (q.contextLayer && q.contextLayer.render(q.panels, !0, !0), e.contextShown(!1));
                    }, L = h.values;
                    L.length > h._length && (L = L.slice(0, h._length));
                    var _ = h.tickvals, C;
                    function M(q, V) {
                        return {
                            val: q,
                            text: C[V]
                        };
                    }
                    function g(q, V) {
                        return q.val - V.val;
                    }
                    if (xK(_) && _.length) {
                        l1.isTypedArray(_) && (_ = Array.from(_)), C = h.ticktext, !xK(C) || !C.length ? C = _.map(gNe(h.tickformat)) : C.length > _.length ? C = C.slice(0, _.length) : _.length > C.length && (_ = _.slice(0, C.length));
                        for(var P = 1; P < _.length; P++)if (_[P] < _[P - 1]) {
                            for(var T = _.map(M).sort(g), F = 0; F < _.length; F++)_[F] = T[F].val, C[F] = T[F].text;
                            break;
                        }
                    } else _ = void 0;
                    return L = mA.convertTypedArray(L), {
                        key: b,
                        label: h.label,
                        tickFormat: h.tickformat,
                        tickvals: _,
                        ticktext: C,
                        ordinal: mA.isOrdinal(h),
                        multiselect: h.multiselect,
                        xIndex: d,
                        crossfilterDimensionIndex: d,
                        visibleIndex: h._index,
                        height: i,
                        values: L,
                        paddedUnitValues: L.map(v),
                        unitTickvals: _ && _.map(v),
                        xScale: s,
                        x: s(d),
                        canvasX: s(d) * o,
                        unitToPaddedPx: u,
                        domainScale: CUt(i, ll.verticalPadding, h, _, C),
                        ordinalScale: IUt(h),
                        parent: c,
                        model: r,
                        brush: xNe.makeBrush(e, E, k, function() {
                            e.linePickActive(!1);
                        }, A, function(q) {
                            if (c.focusLayer.render(c.panels, !0), c.pickLayer && c.pickLayer.render(c.panels, !0), e.linePickActive(!0), t && t.filterChanged) {
                                var V = v.invert, H = q.map(function(X) {
                                    return X.map(V).sort(l1.sorterAsc);
                                }).sort(function(X, G) {
                                    return X[0] - G[0];
                                });
                                t.filterChanged(c.key, h._index, H);
                            }
                        })
                    };
                }), c;
            }
            function dNe(e) {
                e.classed(ll.cn.axisExtentText, !0).attr("text-anchor", "middle").style("cursor", "default");
            }
            function FUt() {
                var e = !0, t = !1;
                return {
                    linePickActive: function(r) {
                        return arguments.length ? e = !!r : e;
                    },
                    contextShown: function(r) {
                        return arguments.length ? t = !!r : t;
                    }
                };
            }
            function vNe(e, t) {
                var r = t === "top" ? 1 : -1, n = e * Math.PI / 180, i = Math.sin(n), a = Math.cos(n);
                return {
                    dir: r,
                    dx: i,
                    dy: a,
                    degrees: e
                };
            }
            function bK(e, t, r) {
                for(var n = t.panels || (t.panels = []), i = e.data(), a = 0; a < i.length - 1; a++){
                    var o = n[a] || (n[a] = {}), s = i[a], l = i[a + 1];
                    o.dim0 = s, o.dim1 = l, o.canvasX = s.canvasX, o.panelSizeX = l.canvasX - s.canvasX, o.panelSizeY = t.model.canvasHeight, o.y = 0, o.canvasY = 0, o.plotGlPixelRatio = r;
                }
            }
            function qUt(e) {
                for(var t = 0; t < e.length; t++)for(var r = 0; r < e[t].length; r++)for(var n = e[t][r].trace, i = n.dimensions, a = 0; a < i.length; a++){
                    var o = i[a].values, s = i[a]._ax;
                    s && (s.range ? s.range = AK(s.range[0], s.range[1]) : s.range = bNe(o, n._length), s.dtick || (s.dtick = .01 * (Math.abs(s.range[1] - s.range[0]) || 1)), s.tickformat = i[a].tickformat, yNe.calcTicks(s), s.cleanRange());
                }
            }
            function wNe(e, t) {
                return yNe.tickText(e._ax, t, !1).text;
            }
            function pNe(e, t) {
                if (e.ordinal) return "";
                var r = e.domainScale.domain(), n = r[t ? r.length - 1 : 0];
                return wNe(e.model.dimensions[e.visibleIndex], n);
            }
            TNe.exports = function(t, r, n, i) {
                var a = t._context.staticPlot, o = t._fullLayout, s = o._toppaper, l = o._glcontainer, u = t._context.plotGlPixelRatio, c = t._fullLayout.paper_bgcolor;
                qUt(r);
                var f = FUt(), h = r.filter(function(F) {
                    return _Ne(F).trace.visible;
                }).map(DUt.bind(0, n)).map(zUt.bind(0, f, i));
                l.each(function(F, q) {
                    return l1.extendFlat(F, h[q]);
                });
                var d = l.selectAll(".gl-canvas").each(function(F) {
                    F.viewModel = h[0], F.viewModel.plotGlPixelRatio = u, F.viewModel.paperColor = c, F.model = F.viewModel ? F.viewModel.model : null;
                }), v = null, x = d.filter(function(F) {
                    return F.pick;
                });
                x.style("pointer-events", a ? "none" : "auto").on("mousemove", function(F) {
                    if (f.linePickActive() && F.lineLayer && i && i.hover) {
                        var q = zd.event, V = this.width, H = this.height, X = zd.mouse(this), G = X[0], N = X[1];
                        if (G < 0 || N < 0 || G >= V || N >= H) return;
                        var W = F.lineLayer.readPixel(G, H - 1 - N), re = W[3] !== 0, ae = re ? W[2] + 256 * (W[1] + 256 * W[0]) : null, _e = {
                            x: G,
                            y: N,
                            clientX: q.clientX,
                            clientY: q.clientY,
                            dataIndex: F.model.key,
                            curveNumber: ae
                        };
                        ae !== v && (re ? i.hover(_e) : i.unhover && i.unhover(_e), v = ae);
                    }
                }), d.style("opacity", function(F) {
                    return F.pick ? 0 : 1;
                }), s.style("background", "rgba(255, 255, 255, 0)");
                var b = s.selectAll("." + ll.cn.parcoords).data(h, tg);
                b.exit().remove(), b.enter().append("g").classed(ll.cn.parcoords, !0).style("shape-rendering", "crispEdges").style("pointer-events", "none"), b.attr("transform", function(F) {
                    return Jm(F.model.translateX, F.model.translateY);
                });
                var p = b.selectAll("." + ll.cn.parcoordsControlView).data($m, tg);
                p.enter().append("g").classed(ll.cn.parcoordsControlView, !0), p.attr("transform", function(F) {
                    return Jm(F.model.pad.l, F.model.pad.t);
                });
                var E = p.selectAll("." + ll.cn.yAxis).data(function(F) {
                    return F.dimensions;
                }, tg);
                E.enter().append("g").classed(ll.cn.yAxis, !0), p.each(function(F) {
                    bK(E, F, u);
                }), d.each(function(F) {
                    if (F.viewModel) {
                        !F.lineLayer || i ? F.lineLayer = EUt(this, F) : F.lineLayer.update(F), (F.key || F.key === 0) && (F.viewModel[F.key] = F.lineLayer);
                        var q = !F.context || i;
                        F.lineLayer.render(F.viewModel.panels, q);
                    }
                }), E.attr("transform", function(F) {
                    return Jm(F.xScale(F.xIndex), 0);
                }), E.call(zd.behavior.drag().origin(function(F) {
                    return F;
                }).on("drag", function(F) {
                    var q = F.parent;
                    f.linePickActive(!1), F.x = Math.max(-ll.overdrag, Math.min(F.model.width + ll.overdrag, zd.event.x)), F.canvasX = F.x * F.model.canvasPixelRatio, E.sort(function(V, H) {
                        return V.x - H.x;
                    }).each(function(V, H) {
                        V.xIndex = H, V.x = F === V ? V.x : V.xScale(V.xIndex), V.canvasX = V.x * V.model.canvasPixelRatio;
                    }), bK(E, q, u), E.filter(function(V) {
                        return Math.abs(F.xIndex - V.xIndex) !== 0;
                    }).attr("transform", function(V) {
                        return Jm(V.xScale(V.xIndex), 0);
                    }), zd.select(this).attr("transform", Jm(F.x, 0)), E.each(function(V, H, X) {
                        X === F.parent.key && (q.dimensions[H] = V);
                    }), q.contextLayer && q.contextLayer.render(q.panels, !1, !wK(q)), q.focusLayer.render && q.focusLayer.render(q.panels);
                }).on("dragend", function(F) {
                    var q = F.parent;
                    F.x = F.xScale(F.xIndex), F.canvasX = F.x * F.model.canvasPixelRatio, bK(E, q, u), zd.select(this).attr("transform", function(V) {
                        return Jm(V.x, 0);
                    }), q.contextLayer && q.contextLayer.render(q.panels, !1, !wK(q)), q.focusLayer && q.focusLayer.render(q.panels), q.pickLayer && q.pickLayer.render(q.panels, !0), f.linePickActive(!0), i && i.axesMoved && i.axesMoved(q.key, q.dimensions.map(function(V) {
                        return V.crossfilterDimensionIndex;
                    }));
                })), E.exit().remove();
                var k = E.selectAll("." + ll.cn.axisOverlays).data($m, tg);
                k.enter().append("g").classed(ll.cn.axisOverlays, !0), k.selectAll("." + ll.cn.axis).remove();
                var A = k.selectAll("." + ll.cn.axis).data($m, tg);
                A.enter().append("g").classed(ll.cn.axis, !0), A.each(function(F) {
                    var q = F.model.height / F.model.tickDistance, V = F.domainScale, H = V.domain();
                    zd.select(this).call(zd.svg.axis().orient("left").tickSize(4).outerTickSize(2).ticks(q, F.tickFormat).tickValues(F.ordinal ? H : null).tickFormat(function(X) {
                        return mA.isOrdinal(F) ? X : wNe(F.model.dimensions[F.visibleIndex], X);
                    }).scale(V)), FF.font(A.selectAll("text"), F.model.tickFont);
                }), A.selectAll(".domain, .tick>line").attr("fill", "none").attr("stroke", "black").attr("stroke-opacity", .25).attr("stroke-width", "1px"), A.selectAll("text").style("cursor", "default");
                var L = k.selectAll("." + ll.cn.axisHeading).data($m, tg);
                L.enter().append("g").classed(ll.cn.axisHeading, !0);
                var _ = L.selectAll("." + ll.cn.axisTitle).data($m, tg);
                _.enter().append("text").classed(ll.cn.axisTitle, !0).attr("text-anchor", "middle").style("cursor", "ew-resize").style("pointer-events", a ? "none" : "auto"), _.text(function(F) {
                    return F.label;
                }).each(function(F) {
                    var q = zd.select(this);
                    FF.font(q, F.model.labelFont), MUt.convertToTspans(q, t);
                }).attr("transform", function(F) {
                    var q = vNe(F.model.labelAngle, F.model.labelSide), V = ll.axisTitleOffset;
                    return (q.dir > 0 ? "" : Jm(0, 2 * V + F.model.height)) + SUt(q.degrees) + Jm(-V * q.dx, -V * q.dy);
                }).attr("text-anchor", function(F) {
                    var q = vNe(F.model.labelAngle, F.model.labelSide), V = Math.abs(q.dx), H = Math.abs(q.dy);
                    return 2 * V > H ? q.dir * q.dx < 0 ? "start" : "end" : "middle";
                });
                var C = k.selectAll("." + ll.cn.axisExtent).data($m, tg);
                C.enter().append("g").classed(ll.cn.axisExtent, !0);
                var M = C.selectAll("." + ll.cn.axisExtentTop).data($m, tg);
                M.enter().append("g").classed(ll.cn.axisExtentTop, !0), M.attr("transform", Jm(0, -ll.axisExtentOffset));
                var g = M.selectAll("." + ll.cn.axisExtentTopText).data($m, tg);
                g.enter().append("text").classed(ll.cn.axisExtentTopText, !0).call(dNe), g.text(function(F) {
                    return pNe(F, !0);
                }).each(function(F) {
                    FF.font(zd.select(this), F.model.rangeFont);
                });
                var P = C.selectAll("." + ll.cn.axisExtentBottom).data($m, tg);
                P.enter().append("g").classed(ll.cn.axisExtentBottom, !0), P.attr("transform", function(F) {
                    return Jm(0, F.model.height + ll.axisExtentOffset);
                });
                var T = P.selectAll("." + ll.cn.axisExtentBottomText).data($m, tg);
                T.enter().append("text").classed(ll.cn.axisExtentBottomText, !0).attr("dy", "0.75em").call(dNe), T.text(function(F) {
                    return pNe(F, !1);
                }).each(function(F) {
                    FF.font(zd.select(this), F.model.rangeFont);
                }), xNe.ensureAxisBrush(k, c, t);
            };
        });
        var MK = ye((SK, kNe)=>{
            "use strict";
            var OUt = ANe(), BUt = xF(), SNe = yK().isVisible, ENe = {};
            function MNe(e, t, r) {
                var n = t.indexOf(r), i = e.indexOf(n);
                return i === -1 && (i += t.length), i;
            }
            function NUt(e, t) {
                return function(n, i) {
                    return MNe(e, t, n) - MNe(e, t, i);
                };
            }
            var SK = kNe.exports = function(t, r) {
                var n = t._fullLayout, i = BUt(t, [], ENe);
                if (i) {
                    var a = {}, o = {}, s = {}, l = {}, u = n._size;
                    r.forEach(function(v, x) {
                        var b = v[0].trace;
                        s[x] = b.index;
                        var p = l[x] = b.index;
                        a[x] = t.data[p].dimensions, o[x] = t.data[p].dimensions.slice();
                    });
                    var c = function(v, x, b) {
                        var p = o[v][x], E = b.map(function(M) {
                            return M.slice();
                        }), k = "dimensions[" + x + "].constraintrange", A = n._tracePreGUI[t._fullData[s[v]]._fullInput.uid];
                        if (A[k] === void 0) {
                            var L = p.constraintrange;
                            A[k] = L || null;
                        }
                        var _ = t._fullData[s[v]].dimensions[x];
                        E.length ? (E.length === 1 && (E = E[0]), p.constraintrange = E, _.constraintrange = E.slice(), E = [
                            E
                        ]) : (delete p.constraintrange, delete _.constraintrange, E = null);
                        var C = {};
                        C[k] = E, t.emit("plotly_restyle", [
                            C,
                            [
                                l[v]
                            ]
                        ]);
                    }, f = function(v) {
                        t.emit("plotly_hover", v);
                    }, h = function(v) {
                        t.emit("plotly_unhover", v);
                    }, d = function(v, x) {
                        var b = NUt(x, o[v].filter(SNe));
                        a[v].sort(b), o[v].filter(function(p) {
                            return !SNe(p);
                        }).sort(function(p) {
                            return o[v].indexOf(p);
                        }).forEach(function(p) {
                            a[v].splice(a[v].indexOf(p), 1), a[v].splice(o[v].indexOf(p), 0, p);
                        }), t.emit("plotly_restyle", [
                            {
                                dimensions: [
                                    a[v]
                                ]
                            },
                            [
                                l[v]
                            ]
                        ]);
                    };
                    OUt(t, r, {
                        width: u.w,
                        height: u.h,
                        margin: {
                            t: u.t,
                            r: u.r,
                            b: u.b,
                            l: u.l
                        }
                    }, {
                        filterChanged: c,
                        hover: f,
                        unhover: h,
                        axesMoved: d
                    });
                }
            };
            SK.reglPrecompiled = ENe;
        });
        var LNe = ye((Ek)=>{
            "use strict";
            var CNe = xa(), UUt = kd().getModuleCalcData, VUt = MK(), HUt = Zp();
            Ek.name = "parcoords";
            Ek.plot = function(e) {
                var t = UUt(e.calcdata, "parcoords")[0];
                t.length && VUt(e, t);
            };
            Ek.clean = function(e, t, r, n) {
                var i = n._has && n._has("parcoords"), a = t._has && t._has("parcoords");
                i && !a && (n._paperdiv.selectAll(".parcoords").remove(), n._glimages.selectAll("*").remove());
            };
            Ek.toSVG = function(e) {
                var t = e._fullLayout._glimages, r = CNe.select(e).selectAll(".svg-container"), n = r.filter(function(a, o) {
                    return o === r.size() - 1;
                }).selectAll(".gl-canvas-context, .gl-canvas-focus");
                function i() {
                    var a = this, o = a.toDataURL("image/png"), s = t.append("svg:image");
                    s.attr({
                        xmlns: HUt.svg,
                        "xlink:href": o,
                        preserveAspectRatio: "none",
                        x: 0,
                        y: 0,
                        width: a.style.width,
                        height: a.style.height
                    });
                }
                n.each(i), window.setTimeout(function() {
                    CNe.selectAll("#filterBarPattern").attr("id", "filterBarPattern");
                }, 60);
            };
        });
        var INe = ye((gyr, PNe)=>{
            "use strict";
            PNe.exports = {
                attributes: cK(),
                supplyDefaults: jBe(),
                calc: ZBe(),
                colorbar: {
                    container: "line",
                    min: "cmin",
                    max: "cmax"
                },
                moduleType: "trace",
                name: "parcoords",
                basePlotModule: LNe(),
                categories: [
                    "gl",
                    "regl",
                    "noOpacity",
                    "noHover"
                ],
                meta: {}
            };
        });
        var zNe = ye((myr, DNe)=>{
            "use strict";
            var RNe = INe();
            RNe.plot = MK();
            DNe.exports = RNe;
        });
        var qNe = ye((yyr, FNe)=>{
            "use strict";
            FNe.exports = zNe();
        });
        var EK = ye((_yr, UNe)=>{
            "use strict";
            var BNe = no().extendFlat, GUt = vl(), ONe = Su(), jUt = Jl(), NNe = Wo().hovertemplateAttrs, WUt = Ju().attributes, ZUt = BNe({
                editType: "calc"
            }, jUt("line", {
                editTypeOverride: "calc"
            }), {
                shape: {
                    valType: "enumerated",
                    values: [
                        "linear",
                        "hspline"
                    ],
                    dflt: "linear",
                    editType: "plot"
                },
                hovertemplate: NNe({
                    editType: "plot",
                    arrayOk: !1
                }, {
                    keys: [
                        "count",
                        "probability"
                    ]
                })
            });
            UNe.exports = {
                domain: WUt({
                    name: "parcats",
                    trace: !0,
                    editType: "calc"
                }),
                hoverinfo: BNe({}, GUt.hoverinfo, {
                    flags: [
                        "count",
                        "probability"
                    ],
                    editType: "plot",
                    arrayOk: !1
                }),
                hoveron: {
                    valType: "enumerated",
                    values: [
                        "category",
                        "color",
                        "dimension"
                    ],
                    dflt: "category",
                    editType: "plot"
                },
                hovertemplate: NNe({
                    editType: "plot",
                    arrayOk: !1
                }, {
                    keys: [
                        "count",
                        "probability",
                        "category",
                        "categorycount",
                        "colorcount",
                        "bandcolorcount"
                    ]
                }),
                arrangement: {
                    valType: "enumerated",
                    values: [
                        "perpendicular",
                        "freeform",
                        "fixed"
                    ],
                    dflt: "perpendicular",
                    editType: "plot"
                },
                bundlecolors: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "plot"
                },
                sortpaths: {
                    valType: "enumerated",
                    values: [
                        "forward",
                        "backward"
                    ],
                    dflt: "forward",
                    editType: "plot"
                },
                labelfont: ONe({
                    editType: "calc"
                }),
                tickfont: ONe({
                    autoShadowDflt: !0,
                    editType: "calc"
                }),
                dimensions: {
                    _isLinkedToArray: "dimension",
                    label: {
                        valType: "string",
                        editType: "calc"
                    },
                    categoryorder: {
                        valType: "enumerated",
                        values: [
                            "trace",
                            "category ascending",
                            "category descending",
                            "array"
                        ],
                        dflt: "trace",
                        editType: "calc"
                    },
                    categoryarray: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    ticktext: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    values: {
                        valType: "data_array",
                        dflt: [],
                        editType: "calc"
                    },
                    displayindex: {
                        valType: "integer",
                        editType: "calc"
                    },
                    editType: "calc",
                    visible: {
                        valType: "boolean",
                        dflt: !0,
                        editType: "calc"
                    }
                },
                line: ZUt,
                counts: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    arrayOk: !0,
                    editType: "calc"
                },
                customdata: void 0,
                hoverlabel: void 0,
                ids: void 0,
                legend: void 0,
                legendgroup: void 0,
                legendrank: void 0,
                opacity: void 0,
                selectedpoints: void 0,
                showlegend: void 0
            };
        });
        var GNe = ye((xyr, HNe)=>{
            "use strict";
            var yA = Mr(), XUt = Dv().hasColorscale, YUt = Uh(), KUt = Ju().defaults, JUt = Zd(), VNe = EK(), $Ut = wF(), QUt = vv().isTypedArraySpec;
            function eVt(e, t, r, n, i) {
                i("line.shape"), i("line.hovertemplate");
                var a = i("line.color", n.colorway[0]);
                if (XUt(e, "line") && yA.isArrayOrTypedArray(a)) {
                    if (a.length) return i("line.colorscale"), YUt(e, t, n, i, {
                        prefix: "line.",
                        cLetter: "c"
                    }), a.length;
                    t.line.color = r;
                }
                return 1 / 0;
            }
            function tVt(e, t) {
                function r(u, c) {
                    return yA.coerce(e, t, VNe.dimensions, u, c);
                }
                var n = r("values"), i = r("visible");
                if (n && n.length || (i = t.visible = !1), i) {
                    r("label"), r("displayindex", t._index);
                    var a = e.categoryarray, o = yA.isArrayOrTypedArray(a) && a.length > 0 || QUt(a), s;
                    o && (s = "array");
                    var l = r("categoryorder", s);
                    l === "array" ? (r("categoryarray"), r("ticktext")) : (delete e.categoryarray, delete e.ticktext), !o && l === "array" && (t.categoryorder = "trace");
                }
            }
            HNe.exports = function(t, r, n, i) {
                function a(u, c) {
                    return yA.coerce(t, r, VNe, u, c);
                }
                var o = JUt(t, r, {
                    name: "dimensions",
                    handleItemDefaults: tVt
                }), s = eVt(t, r, n, i, a);
                KUt(r, i, a), (!Array.isArray(o) || !o.length) && (r.visible = !1), $Ut(r, o, "values", s), a("hoveron"), a("hovertemplate"), a("arrangement"), a("bundlecolors"), a("sortpaths"), a("counts");
                var l = i.font;
                yA.coerceFont(a, "labelfont", l, {
                    overrideDflt: {
                        size: Math.round(l.size)
                    }
                }), yA.coerceFont(a, "tickfont", l, {
                    autoShadowDflt: !0,
                    overrideDflt: {
                        size: Math.round(l.size / 1.2)
                    }
                });
            };
        });
        var WNe = ye((byr, jNe)=>{
            "use strict";
            var rVt = Km().wrap, iVt = Dv().hasColorscale, nVt = zv(), aVt = jq(), oVt = ao(), kk = Mr(), sVt = uo();
            jNe.exports = function(t, r) {
                var n = kk.filterVisible(r.dimensions);
                if (n.length === 0) return [];
                var i = n.map(function(g) {
                    var P;
                    if (g.categoryorder === "trace") P = null;
                    else if (g.categoryorder === "array") P = g.categoryarray;
                    else {
                        P = aVt(g.values);
                        for(var T = !0, F = 0; F < P.length; F++)if (!sVt(P[F])) {
                            T = !1;
                            break;
                        }
                        P.sort(T ? kk.sorterAsc : void 0), g.categoryorder === "category descending" && (P = P.reverse());
                    }
                    return vVt(g.values, P);
                }), a, o, s;
                kk.isArrayOrTypedArray(r.counts) ? a = r.counts : a = [
                    r.counts
                ], pVt(n), n.forEach(function(g, P) {
                    gVt(g, i[P]);
                });
                var l = r.line, u;
                l ? (iVt(r, "line") && nVt(t, r, {
                    vals: r.line.color,
                    containerStr: "line",
                    cLetter: "c"
                }), u = oVt.tryColorscale(l)) : u = kk.identity;
                function c(g) {
                    var P, T;
                    return kk.isArrayOrTypedArray(l.color) ? (P = l.color[g % l.color.length], T = P) : P = l.color, {
                        color: u(P),
                        rawColor: T
                    };
                }
                var f = n[0].values.length, h = {}, d = i.map(function(g) {
                    return g.inds;
                });
                s = 0;
                var v, x;
                for(v = 0; v < f; v++){
                    var b = [];
                    for(x = 0; x < d.length; x++)b.push(d[x][v]);
                    o = a[v % a.length], s += o;
                    var p = c(v), E = b + "-" + p.rawColor;
                    h[E] === void 0 && (h[E] = hVt(b, p.color, p.rawColor)), dVt(h[E], v, o);
                }
                var k = n.map(function(g, P) {
                    return uVt(P, g._index, g._displayindex, g.label, s);
                });
                for(v = 0; v < f; v++)for(o = a[v % a.length], x = 0; x < k.length; x++){
                    var A = k[x].containerInd, L = i[x].inds[v], _ = k[x].categories;
                    if (_[L] === void 0) {
                        var C = r.dimensions[A]._categoryarray[L], M = r.dimensions[A]._ticktext[L];
                        _[L] = cVt(x, L, C, M);
                    }
                    fVt(_[L], v, o);
                }
                return rVt(lVt(k, h, s));
            };
            function lVt(e, t, r) {
                var n = e.map(function(i) {
                    return i.categories.length;
                }).reduce(function(i, a) {
                    return Math.max(i, a);
                });
                return {
                    dimensions: e,
                    paths: t,
                    trace: void 0,
                    maxCats: n,
                    count: r
                };
            }
            function uVt(e, t, r, n, i) {
                return {
                    dimensionInd: e,
                    containerInd: t,
                    displayInd: r,
                    dimensionLabel: n,
                    count: i,
                    categories: [],
                    dragX: null
                };
            }
            function cVt(e, t, r, n) {
                return {
                    dimensionInd: e,
                    categoryInd: t,
                    categoryValue: r,
                    displayInd: t,
                    categoryLabel: n,
                    valueInds: [],
                    count: 0,
                    dragY: null
                };
            }
            function fVt(e, t, r) {
                e.valueInds.push(t), e.count += r;
            }
            function hVt(e, t, r) {
                return {
                    categoryInds: e,
                    color: t,
                    rawColor: r,
                    valueInds: [],
                    count: 0
                };
            }
            function dVt(e, t, r) {
                e.valueInds.push(t), e.count += r;
            }
            function vVt(e, t) {
                t == null ? t = [] : t = t.map(function(u) {
                    return u;
                });
                var r = {}, n = {}, i = [];
                t.forEach(function(u, c) {
                    r[u] = 0, n[u] = c;
                });
                for(var a = 0; a < e.length; a++){
                    var o = e[a], s;
                    r[o] === void 0 ? (r[o] = 1, s = t.push(o) - 1, n[o] = s) : (r[o]++, s = n[o]), i.push(s);
                }
                var l = t.map(function(u) {
                    return r[u];
                });
                return {
                    uniqueValues: t,
                    uniqueCounts: l,
                    inds: i
                };
            }
            function pVt(e) {
                var t = e.map(function(n) {
                    return n.displayindex;
                }), r;
                if (mVt(t)) for(r = 0; r < e.length; r++)e[r]._displayindex = e[r].displayindex;
                else for(r = 0; r < e.length; r++)e[r]._displayindex = r;
            }
            function gVt(e, t) {
                e._categoryarray = t.uniqueValues, e.ticktext === null || e.ticktext === void 0 ? e._ticktext = [] : e._ticktext = e.ticktext.slice();
                for(var r = e._ticktext.length; r < t.uniqueValues.length; r++)e._ticktext.push(t.uniqueValues[r]);
            }
            function mVt(e) {
                for(var t = new Array(e.length), r = 0; r < e.length; r++){
                    if (e[r] < 0 || e[r] >= e.length || t[e[r]] !== void 0) return !1;
                    t[e[r]] = !0;
                }
                return !0;
            }
        });
        var tUe = ye((wyr, eUe)=>{
            "use strict";
            var ul = xa(), yVt = (R2(), B1(I2)).interpolateNumber, _Vt = OP(), Pk = Nc(), yx = Mr(), Ck = yx.strTranslate, ZNe = ao(), kK = id(), xVt = Pl();
            function bVt(e, t, r, n) {
                var i = t._context.staticPlot, a = e.map(FVt.bind(0, t, r)), o = n.selectAll("g.parcatslayer").data([
                    null
                ]);
                o.enter().append("g").attr("class", "parcatslayer").style("pointer-events", i ? "none" : "all");
                var s = o.selectAll("g.trace.parcats").data(a, u1), l = s.enter().append("g").attr("class", "trace parcats");
                s.attr("transform", function(E) {
                    return Ck(E.x, E.y);
                }), l.append("g").attr("class", "paths");
                var u = s.select("g.paths"), c = u.selectAll("path.path").data(function(E) {
                    return E.paths;
                }, u1);
                c.attr("fill", function(E) {
                    return E.model.color;
                });
                var f = c.enter().append("path").attr("class", "path").attr("stroke-opacity", 0).attr("fill", function(E) {
                    return E.model.color;
                }).attr("fill-opacity", 0);
                PK(f), c.attr("d", function(E) {
                    return E.svgD;
                }), f.empty() || c.sort(CK), c.exit().remove(), c.on("mouseover", wVt).on("mouseout", TVt).on("click", AVt), l.append("g").attr("class", "dimensions");
                var h = s.select("g.dimensions"), d = h.selectAll("g.dimension").data(function(E) {
                    return E.dimensions;
                }, u1);
                d.enter().append("g").attr("class", "dimension"), d.attr("transform", function(E) {
                    return Ck(E.x, 0);
                }), d.exit().remove();
                var v = d.selectAll("g.category").data(function(E) {
                    return E.categories;
                }, u1), x = v.enter().append("g").attr("class", "category");
                v.attr("transform", function(E) {
                    return Ck(0, E.y);
                }), x.append("rect").attr("class", "catrect").attr("pointer-events", "none"), v.select("rect.catrect").attr("fill", "none").attr("width", function(E) {
                    return E.width;
                }).attr("height", function(E) {
                    return E.height;
                }), YNe(x);
                var b = v.selectAll("rect.bandrect").data(function(E) {
                    return E.bands;
                }, u1);
                b.each(function() {
                    yx.raiseToTop(this);
                }), b.attr("fill", function(E) {
                    return E.color;
                });
                var p = b.enter().append("rect").attr("class", "bandrect").attr("stroke-opacity", 0).attr("fill", function(E) {
                    return E.color;
                }).attr("fill-opacity", 0);
                b.attr("fill", function(E) {
                    return E.color;
                }).attr("width", function(E) {
                    return E.width;
                }).attr("height", function(E) {
                    return E.height;
                }).attr("y", function(E) {
                    return E.y;
                }).attr("cursor", function(E) {
                    return E.parcatsViewModel.arrangement === "fixed" ? "default" : E.parcatsViewModel.arrangement === "perpendicular" ? "ns-resize" : "move";
                }), RK(p), b.exit().remove(), x.append("text").attr("class", "catlabel").attr("pointer-events", "none"), v.select("text.catlabel").attr("text-anchor", function(E) {
                    return Lk(E) ? "start" : "end";
                }).attr("alignment-baseline", "middle").style("fill", "rgb(0, 0, 0)").attr("x", function(E) {
                    return Lk(E) ? E.width + 5 : -5;
                }).attr("y", function(E) {
                    return E.height / 2;
                }).text(function(E) {
                    return E.model.categoryLabel;
                }).each(function(E) {
                    ZNe.font(ul.select(this), E.parcatsViewModel.categorylabelfont), xVt.convertToTspans(ul.select(this), t);
                }), x.append("text").attr("class", "dimlabel"), v.select("text.dimlabel").attr("text-anchor", "middle").attr("alignment-baseline", "baseline").attr("cursor", function(E) {
                    return E.parcatsViewModel.arrangement === "fixed" ? "default" : "ew-resize";
                }).attr("x", function(E) {
                    return E.width / 2;
                }).attr("y", -5).text(function(E, k) {
                    return k === 0 ? E.parcatsViewModel.model.dimensions[E.model.dimensionInd].dimensionLabel : null;
                }).each(function(E) {
                    ZNe.font(ul.select(this), E.parcatsViewModel.labelfont);
                }), v.selectAll("rect.bandrect").on("mouseover", PVt).on("mouseout", IVt), v.exit().remove(), d.call(ul.behavior.drag().origin(function(E) {
                    return {
                        x: E.x,
                        y: 0
                    };
                }).on("dragstart", RVt).on("drag", DVt).on("dragend", zVt)), s.each(function(E) {
                    E.traceSelection = ul.select(this), E.pathSelection = ul.select(this).selectAll("g.paths").selectAll("path.path"), E.dimensionSelection = ul.select(this).selectAll("g.dimensions").selectAll("g.dimension");
                }), s.exit().remove();
            }
            eUe.exports = function(e, t, r, n) {
                bVt(r, e, n, t);
            };
            function u1(e) {
                return e.key;
            }
            function Lk(e) {
                var t = e.parcatsViewModel.dimensions.length, r = e.parcatsViewModel.dimensions[t - 1].model.dimensionInd;
                return e.model.dimensionInd === r;
            }
            function CK(e, t) {
                return e.model.rawColor > t.model.rawColor ? 1 : e.model.rawColor < t.model.rawColor ? -1 : 0;
            }
            function wVt(e) {
                if (!e.parcatsViewModel.dragDimension && e.parcatsViewModel.hoverinfoItems.indexOf("skip") === -1) {
                    yx.raiseToTop(this), IK(ul.select(this));
                    var t = Ik(e), r = LK(e);
                    if (e.parcatsViewModel.graphDiv.emit("plotly_hover", {
                        points: t,
                        event: ul.event,
                        constraints: r
                    }), e.parcatsViewModel.hoverinfoItems.indexOf("none") === -1) {
                        var n = ul.mouse(this)[0], i = e.parcatsViewModel.graphDiv, a = e.parcatsViewModel.trace, o = i._fullLayout, s = o._paperdiv.node().getBoundingClientRect(), l = e.parcatsViewModel.graphDiv.getBoundingClientRect(), u, c, f;
                        for(f = 0; f < e.leftXs.length - 1; f++)if (e.leftXs[f] + e.dimWidths[f] - 2 <= n && n <= e.leftXs[f + 1] + 2) {
                            var h = e.parcatsViewModel.dimensions[f], d = e.parcatsViewModel.dimensions[f + 1];
                            u = (h.x + h.width + d.x) / 2, c = (e.topYs[f] + e.topYs[f + 1] + e.height) / 2;
                            break;
                        }
                        var v = e.parcatsViewModel.x + u, x = e.parcatsViewModel.y + c, b = kK.mostReadable(e.model.color, [
                            "black",
                            "white"
                        ]), p = e.model.count, E = p / e.parcatsViewModel.model.count, k = {
                            countLabel: p,
                            probabilityLabel: E.toFixed(3)
                        }, A = [];
                        e.parcatsViewModel.hoverinfoItems.indexOf("count") !== -1 && A.push([
                            "Count:",
                            k.countLabel
                        ].join(" ")), e.parcatsViewModel.hoverinfoItems.indexOf("probability") !== -1 && A.push([
                            "P:",
                            k.probabilityLabel
                        ].join(" "));
                        var L = A.join("<br>"), _ = ul.mouse(i)[0];
                        Pk.loneHover({
                            trace: a,
                            x: v - s.left + l.left,
                            y: x - s.top + l.top,
                            text: L,
                            color: e.model.color,
                            borderColor: "black",
                            fontFamily: 'Monaco, "Courier New", monospace',
                            fontSize: 10,
                            fontColor: b,
                            idealAlign: _ < v ? "right" : "left",
                            hovertemplate: (a.line || {}).hovertemplate,
                            hovertemplateLabels: k,
                            eventData: [
                                {
                                    data: a._input,
                                    fullData: a,
                                    count: p,
                                    probability: E
                                }
                            ]
                        }, {
                            container: o._hoverlayer.node(),
                            outerContainer: o._paper.node(),
                            gd: i
                        });
                    }
                }
            }
            function TVt(e) {
                if (!e.parcatsViewModel.dragDimension && (PK(ul.select(this)), Pk.loneUnhover(e.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node()), e.parcatsViewModel.pathSelection.sort(CK), e.parcatsViewModel.hoverinfoItems.indexOf("skip") === -1)) {
                    var t = Ik(e), r = LK(e);
                    e.parcatsViewModel.graphDiv.emit("plotly_unhover", {
                        points: t,
                        event: ul.event,
                        constraints: r
                    });
                }
            }
            function Ik(e) {
                for(var t = [], r = JNe(e.parcatsViewModel), n = 0; n < e.model.valueInds.length; n++){
                    var i = e.model.valueInds[n];
                    t.push({
                        curveNumber: r,
                        pointNumber: i
                    });
                }
                return t;
            }
            function LK(e) {
                for(var t = {}, r = e.parcatsViewModel.model.dimensions, n = 0; n < r.length; n++){
                    var i = r[n], a = i.categories[e.model.categoryInds[n]];
                    t[i.containerInd] = a.categoryValue;
                }
                return e.model.rawColor !== void 0 && (t.color = e.model.rawColor), t;
            }
            function AVt(e) {
                if (e.parcatsViewModel.hoverinfoItems.indexOf("skip") === -1) {
                    var t = Ik(e), r = LK(e);
                    e.parcatsViewModel.graphDiv.emit("plotly_click", {
                        points: t,
                        event: ul.event,
                        constraints: r
                    });
                }
            }
            function PK(e) {
                e.attr("fill", function(t) {
                    return t.model.color;
                }).attr("fill-opacity", .6).attr("stroke", "lightgray").attr("stroke-width", .2).attr("stroke-opacity", 1);
            }
            function IK(e) {
                e.attr("fill-opacity", .8).attr("stroke", function(t) {
                    return kK.mostReadable(t.model.color, [
                        "black",
                        "white"
                    ]);
                }).attr("stroke-width", .3);
            }
            function SVt(e) {
                e.select("rect.catrect").attr("stroke", "black").attr("stroke-width", 2.5);
            }
            function YNe(e) {
                e.select("rect.catrect").attr("stroke", "black").attr("stroke-width", 1).attr("stroke-opacity", 1);
            }
            function MVt(e) {
                e.attr("stroke", "black").attr("stroke-width", 1.5);
            }
            function RK(e) {
                e.attr("stroke", "black").attr("stroke-width", .2).attr("stroke-opacity", 1).attr("fill-opacity", 1);
            }
            function OF(e) {
                var t = e.parcatsViewModel.pathSelection, r = e.categoryViewModel.model.dimensionInd, n = e.categoryViewModel.model.categoryInd;
                return t.filter(function(i) {
                    return i.model.categoryInds[r] === n && i.model.color === e.color;
                });
            }
            function EVt(e) {
                var t = ul.select(e.parentNode).selectAll("rect.bandrect");
                t.each(function(r) {
                    var n = OF(r);
                    IK(n), n.each(function() {
                        yx.raiseToTop(this);
                    });
                }), SVt(ul.select(e.parentNode));
            }
            function kVt(e) {
                var t = ul.select(e).datum(), r = OF(t);
                IK(r), r.each(function() {
                    yx.raiseToTop(this);
                }), ul.select(e.parentNode).selectAll("rect.bandrect").filter(function(n) {
                    return n.color === t.color;
                }).each(function() {
                    yx.raiseToTop(this), MVt(ul.select(this));
                });
            }
            function DK(e, t, r) {
                var n = ul.select(e).datum(), i = n.categoryViewModel.model, a = n.parcatsViewModel.graphDiv, o = ul.select(e.parentNode).selectAll("rect.bandrect"), s = [];
                o.each(function(u) {
                    var c = OF(u);
                    c.each(function(f) {
                        Array.prototype.push.apply(s, Ik(f));
                    });
                });
                var l = {};
                l[i.dimensionInd] = i.categoryValue, a.emit(t, {
                    points: s,
                    event: r,
                    constraints: l
                });
            }
            function zK(e, t, r) {
                var n = ul.select(e).datum(), i = n.categoryViewModel.model, a = n.parcatsViewModel.graphDiv, o = OF(n), s = [];
                o.each(function(u) {
                    Array.prototype.push.apply(s, Ik(u));
                });
                var l = {};
                l[i.dimensionInd] = i.categoryValue, n.rawColor !== void 0 && (l.color = n.rawColor), a.emit(t, {
                    points: s,
                    event: r,
                    constraints: l
                });
            }
            function KNe(e, t, r) {
                e._fullLayout._calcInverseTransform(e);
                var n = e._fullLayout._invScaleX, i = e._fullLayout._invScaleY, a = ul.select(r.parentNode).select("rect.catrect"), o = a.node().getBoundingClientRect(), s = a.datum(), l = s.parcatsViewModel, u = l.model.dimensions[s.model.dimensionInd], c = l.trace, f = o.top + o.height / 2, h, d;
                l.dimensions.length > 1 && u.displayInd === l.dimensions.length - 1 ? (h = o.left, d = "left") : (h = o.left + o.width, d = "right");
                var v = s.model.count, x = s.model.categoryLabel, b = v / s.parcatsViewModel.model.count, p = {
                    countLabel: v,
                    categoryLabel: x,
                    probabilityLabel: b.toFixed(3)
                }, E = [];
                s.parcatsViewModel.hoverinfoItems.indexOf("count") !== -1 && E.push([
                    "Count:",
                    p.countLabel
                ].join(" ")), s.parcatsViewModel.hoverinfoItems.indexOf("probability") !== -1 && E.push([
                    "P(" + p.categoryLabel + "):",
                    p.probabilityLabel
                ].join(" "));
                var k = E.join("<br>");
                return {
                    trace: c,
                    x: n * (h - t.left),
                    y: i * (f - t.top),
                    text: k,
                    color: "lightgray",
                    borderColor: "black",
                    fontFamily: 'Monaco, "Courier New", monospace',
                    fontSize: 12,
                    fontColor: "black",
                    idealAlign: d,
                    hovertemplate: c.hovertemplate,
                    hovertemplateLabels: p,
                    eventData: [
                        {
                            data: c._input,
                            fullData: c,
                            count: v,
                            category: x,
                            probability: b
                        }
                    ]
                };
            }
            function CVt(e, t, r) {
                var n = [];
                return ul.select(r.parentNode.parentNode).selectAll("g.category").select("rect.catrect").each(function() {
                    var i = this;
                    n.push(KNe(e, t, i));
                }), n;
            }
            function LVt(e, t, r) {
                e._fullLayout._calcInverseTransform(e);
                var n = e._fullLayout._invScaleX, i = e._fullLayout._invScaleY, a = r.getBoundingClientRect(), o = ul.select(r).datum(), s = o.categoryViewModel, l = s.parcatsViewModel, u = l.model.dimensions[s.model.dimensionInd], c = l.trace, f = a.y + a.height / 2, h, d;
                l.dimensions.length > 1 && u.displayInd === l.dimensions.length - 1 ? (h = a.left, d = "left") : (h = a.left + a.width, d = "right");
                var v = s.model.categoryLabel, x = o.parcatsViewModel.model.count, b = 0;
                o.categoryViewModel.bands.forEach(function(P) {
                    P.color === o.color && (b += P.count);
                });
                var p = s.model.count, E = 0;
                l.pathSelection.each(function(P) {
                    P.model.color === o.color && (E += P.model.count);
                });
                var k = b / x, A = b / E, L = b / p, _ = {
                    countLabel: b,
                    categoryLabel: v,
                    probabilityLabel: k.toFixed(3)
                }, C = [];
                s.parcatsViewModel.hoverinfoItems.indexOf("count") !== -1 && C.push([
                    "Count:",
                    _.countLabel
                ].join(" ")), s.parcatsViewModel.hoverinfoItems.indexOf("probability") !== -1 && (C.push("P(color \u2229 " + v + "): " + _.probabilityLabel), C.push("P(" + v + " | color): " + A.toFixed(3)), C.push("P(color | " + v + "): " + L.toFixed(3)));
                var M = C.join("<br>"), g = kK.mostReadable(o.color, [
                    "black",
                    "white"
                ]);
                return {
                    trace: c,
                    x: n * (h - t.left),
                    y: i * (f - t.top),
                    text: M,
                    color: o.color,
                    borderColor: "black",
                    fontFamily: 'Monaco, "Courier New", monospace',
                    fontColor: g,
                    fontSize: 10,
                    idealAlign: d,
                    hovertemplate: c.hovertemplate,
                    hovertemplateLabels: _,
                    eventData: [
                        {
                            data: c._input,
                            fullData: c,
                            category: v,
                            count: x,
                            probability: k,
                            categorycount: p,
                            colorcount: E,
                            bandcolorcount: b
                        }
                    ]
                };
            }
            function PVt(e) {
                if (!e.parcatsViewModel.dragDimension && e.parcatsViewModel.hoverinfoItems.indexOf("skip") === -1) {
                    var t = ul.mouse(this)[1];
                    if (t < -1) return;
                    var r = e.parcatsViewModel.graphDiv, n = r._fullLayout, i = n._paperdiv.node().getBoundingClientRect(), a = e.parcatsViewModel.hoveron, o = this;
                    if (a === "color" ? (kVt(o), zK(o, "plotly_hover", ul.event)) : (EVt(o), DK(o, "plotly_hover", ul.event)), e.parcatsViewModel.hoverinfoItems.indexOf("none") === -1) {
                        var s;
                        a === "category" ? s = KNe(r, i, o) : a === "color" ? s = LVt(r, i, o) : a === "dimension" && (s = CVt(r, i, o)), s && Pk.loneHover(s, {
                            container: n._hoverlayer.node(),
                            outerContainer: n._paper.node(),
                            gd: r
                        });
                    }
                }
            }
            function IVt(e) {
                var t = e.parcatsViewModel;
                if (!t.dragDimension && (PK(t.pathSelection), YNe(t.dimensionSelection.selectAll("g.category")), RK(t.dimensionSelection.selectAll("g.category").selectAll("rect.bandrect")), Pk.loneUnhover(t.graphDiv._fullLayout._hoverlayer.node()), t.pathSelection.sort(CK), t.hoverinfoItems.indexOf("skip") === -1)) {
                    var r = e.parcatsViewModel.hoveron, n = this;
                    r === "color" ? zK(n, "plotly_unhover", ul.event) : DK(n, "plotly_unhover", ul.event);
                }
            }
            function RVt(e) {
                e.parcatsViewModel.arrangement !== "fixed" && (e.dragDimensionDisplayInd = e.model.displayInd, e.initialDragDimensionDisplayInds = e.parcatsViewModel.model.dimensions.map(function(t) {
                    return t.displayInd;
                }), e.dragHasMoved = !1, e.dragCategoryDisplayInd = null, ul.select(this).selectAll("g.category").select("rect.catrect").each(function(t) {
                    var r = ul.mouse(this)[0], n = ul.mouse(this)[1];
                    -2 <= r && r <= t.width + 2 && -2 <= n && n <= t.height + 2 && (e.dragCategoryDisplayInd = t.model.displayInd, e.initialDragCategoryDisplayInds = e.model.categories.map(function(i) {
                        return i.displayInd;
                    }), t.model.dragY = t.y, yx.raiseToTop(this.parentNode), ul.select(this.parentNode).selectAll("rect.bandrect").each(function(i) {
                        i.y < n && n <= i.y + i.height && (e.potentialClickBand = this);
                    }));
                }), e.parcatsViewModel.dragDimension = e, Pk.loneUnhover(e.parcatsViewModel.graphDiv._fullLayout._hoverlayer.node()));
            }
            function DVt(e) {
                if (e.parcatsViewModel.arrangement !== "fixed" && (e.dragHasMoved = !0, e.dragDimensionDisplayInd !== null)) {
                    var t = e.dragDimensionDisplayInd, r = t - 1, n = t + 1, i = e.parcatsViewModel.dimensions[t];
                    if (e.dragCategoryDisplayInd !== null) {
                        var a = i.categories[e.dragCategoryDisplayInd];
                        a.model.dragY += ul.event.dy;
                        var o = a.model.dragY, s = a.model.displayInd, l = i.categories, u = l[s - 1], c = l[s + 1];
                        u !== void 0 && o < u.y + u.height / 2 && (a.model.displayInd = u.model.displayInd, u.model.displayInd = s), c !== void 0 && o + a.height > c.y + c.height / 2 && (a.model.displayInd = c.model.displayInd, c.model.displayInd = s), e.dragCategoryDisplayInd = a.model.displayInd;
                    }
                    if (e.dragCategoryDisplayInd === null || e.parcatsViewModel.arrangement === "freeform") {
                        i.model.dragX = ul.event.x;
                        var f = e.parcatsViewModel.dimensions[r], h = e.parcatsViewModel.dimensions[n];
                        f !== void 0 && i.model.dragX < f.x + f.width && (i.model.displayInd = f.model.displayInd, f.model.displayInd = t), h !== void 0 && i.model.dragX + i.width > h.x && (i.model.displayInd = h.model.displayInd, h.model.displayInd = e.dragDimensionDisplayInd), e.dragDimensionDisplayInd = i.model.displayInd;
                    }
                    qK(e.parcatsViewModel), FK(e.parcatsViewModel), QNe(e.parcatsViewModel), $Ne(e.parcatsViewModel);
                }
            }
            function zVt(e) {
                if (e.parcatsViewModel.arrangement !== "fixed" && e.dragDimensionDisplayInd !== null) {
                    ul.select(this).selectAll("text").attr("font-weight", "normal");
                    var t = {}, r = JNe(e.parcatsViewModel), n = e.parcatsViewModel.model.dimensions.map(function(h) {
                        return h.displayInd;
                    }), i = e.initialDragDimensionDisplayInds.some(function(h, d) {
                        return h !== n[d];
                    });
                    i && n.forEach(function(h, d) {
                        var v = e.parcatsViewModel.model.dimensions[d].containerInd;
                        t["dimensions[" + v + "].displayindex"] = h;
                    });
                    var a = !1;
                    if (e.dragCategoryDisplayInd !== null) {
                        var o = e.model.categories.map(function(h) {
                            return h.displayInd;
                        });
                        if (a = e.initialDragCategoryDisplayInds.some(function(h, d) {
                            return h !== o[d];
                        }), a) {
                            var s = e.model.categories.slice().sort(function(h, d) {
                                return h.displayInd - d.displayInd;
                            }), l = s.map(function(h) {
                                return h.categoryValue;
                            }), u = s.map(function(h) {
                                return h.categoryLabel;
                            });
                            t["dimensions[" + e.model.containerInd + "].categoryarray"] = [
                                l
                            ], t["dimensions[" + e.model.containerInd + "].ticktext"] = [
                                u
                            ], t["dimensions[" + e.model.containerInd + "].categoryorder"] = "array";
                        }
                    }
                    if (e.parcatsViewModel.hoverinfoItems.indexOf("skip") === -1 && !e.dragHasMoved && e.potentialClickBand && (e.parcatsViewModel.hoveron === "color" ? zK(e.potentialClickBand, "plotly_click", ul.event.sourceEvent) : DK(e.potentialClickBand, "plotly_click", ul.event.sourceEvent)), e.model.dragX = null, e.dragCategoryDisplayInd !== null) {
                        var c = e.parcatsViewModel.dimensions[e.dragDimensionDisplayInd].categories[e.dragCategoryDisplayInd];
                        c.model.dragY = null, e.dragCategoryDisplayInd = null;
                    }
                    e.dragDimensionDisplayInd = null, e.parcatsViewModel.dragDimension = null, e.dragHasMoved = null, e.potentialClickBand = null, qK(e.parcatsViewModel), FK(e.parcatsViewModel);
                    var f = ul.transition().duration(300).ease("cubic-in-out");
                    f.each(function() {
                        QNe(e.parcatsViewModel, !0), $Ne(e.parcatsViewModel, !0);
                    }).each("end", function() {
                        (i || a) && _Vt.restyle(e.parcatsViewModel.graphDiv, t, [
                            r
                        ]);
                    });
                }
            }
            function JNe(e) {
                for(var t, r = e.graphDiv._fullData, n = 0; n < r.length; n++)if (e.key === r[n].uid) {
                    t = n;
                    break;
                }
                return t;
            }
            function $Ne(e, t) {
                t === void 0 && (t = !1);
                function r(n) {
                    return t ? n.transition() : n;
                }
                e.pathSelection.data(function(n) {
                    return n.paths;
                }, u1), r(e.pathSelection).attr("d", function(n) {
                    return n.svgD;
                });
            }
            function QNe(e, t) {
                t === void 0 && (t = !1);
                function r(l) {
                    return t ? l.transition() : l;
                }
                e.dimensionSelection.data(function(l) {
                    return l.dimensions;
                }, u1);
                var n = e.dimensionSelection.selectAll("g.category").data(function(l) {
                    return l.categories;
                }, u1);
                r(e.dimensionSelection).attr("transform", function(l) {
                    return Ck(l.x, 0);
                }), r(n).attr("transform", function(l) {
                    return Ck(0, l.y);
                });
                var i = n.select(".dimlabel");
                i.text(function(l, u) {
                    return u === 0 ? l.parcatsViewModel.model.dimensions[l.model.dimensionInd].dimensionLabel : null;
                });
                var a = n.select(".catlabel");
                a.attr("text-anchor", function(l) {
                    return Lk(l) ? "start" : "end";
                }).attr("x", function(l) {
                    return Lk(l) ? l.width + 5 : -5;
                }).each(function(l) {
                    var u, c;
                    Lk(l) ? (u = l.width + 5, c = "start") : (u = -5, c = "end"), ul.select(this).selectAll("tspan").attr("x", u).attr("text-anchor", c);
                });
                var o = n.selectAll("rect.bandrect").data(function(l) {
                    return l.bands;
                }, u1), s = o.enter().append("rect").attr("class", "bandrect").attr("cursor", "move").attr("stroke-opacity", 0).attr("fill", function(l) {
                    return l.color;
                }).attr("fill-opacity", 0);
                o.attr("fill", function(l) {
                    return l.color;
                }).attr("width", function(l) {
                    return l.width;
                }).attr("height", function(l) {
                    return l.height;
                }).attr("y", function(l) {
                    return l.y;
                }), RK(s), o.each(function() {
                    yx.raiseToTop(this);
                }), o.exit().remove();
            }
            function FVt(e, t, r) {
                var n = r[0], i = t.margin || {
                    l: 80,
                    r: 80,
                    t: 100,
                    b: 80
                }, a = n.trace, o = a.domain, s = t.width, l = t.height, u = Math.floor(s * (o.x[1] - o.x[0])), c = Math.floor(l * (o.y[1] - o.y[0])), f = o.x[0] * s + i.l, h = t.height - o.y[1] * t.height + i.t, d = a.line.shape, v;
                a.hoverinfo === "all" ? v = [
                    "count",
                    "probability"
                ] : v = (a.hoverinfo || "").split("+");
                var x = {
                    trace: a,
                    key: a.uid,
                    model: n,
                    x: f,
                    y: h,
                    width: u,
                    height: c,
                    hoveron: a.hoveron,
                    hoverinfoItems: v,
                    arrangement: a.arrangement,
                    bundlecolors: a.bundlecolors,
                    sortpaths: a.sortpaths,
                    labelfont: a.labelfont,
                    categorylabelfont: a.tickfont,
                    pathShape: d,
                    dragDimension: null,
                    margin: i,
                    paths: [],
                    dimensions: [],
                    graphDiv: e,
                    traceSelection: null,
                    pathSelection: null,
                    dimensionSelection: null
                };
                return n.dimensions && (qK(x), FK(x)), x;
            }
            function XNe(e, t, r, n, i) {
                var a = [], o = [], s, l;
                for(l = 0; l < r.length - 1; l++)s = yVt(r[l] + e[l], e[l + 1]), a.push(s(i)), o.push(s(1 - i));
                var u = "M " + e[0] + "," + t[0];
                for(u += "l" + r[0] + ",0 ", l = 1; l < r.length; l++)u += "C" + a[l - 1] + "," + t[l - 1] + " " + o[l - 1] + "," + t[l] + " " + e[l] + "," + t[l], u += "l" + r[l] + ",0 ";
                for(u += "l0," + n + " ", u += "l -" + r[r.length - 1] + ",0 ", l = r.length - 2; l >= 0; l--)u += "C" + o[l] + "," + (t[l + 1] + n) + " " + a[l] + "," + (t[l] + n) + " " + (e[l] + r[l]) + "," + (t[l] + n), u += "l-" + r[l] + ",0 ";
                return u += "Z", u;
            }
            function FK(e) {
                var t = e.dimensions, r = e.model, n = t.map(function(q) {
                    return q.categories.map(function(V) {
                        return V.y;
                    });
                }), i = e.model.dimensions.map(function(q) {
                    return q.categories.map(function(V) {
                        return V.displayInd;
                    });
                }), a = e.model.dimensions.map(function(q) {
                    return q.displayInd;
                }), o = e.dimensions.map(function(q) {
                    return q.model.dimensionInd;
                }), s = t.map(function(q) {
                    return q.x;
                }), l = t.map(function(q) {
                    return q.width;
                }), u = [];
                for(var c in r.paths)r.paths.hasOwnProperty(c) && u.push(r.paths[c]);
                function f(q) {
                    var V = q.categoryInds.map(function(X, G) {
                        return i[G][X];
                    }), H = o.map(function(X) {
                        return V[X];
                    });
                    return H;
                }
                u.sort(function(q, V) {
                    var H = f(q), X = f(V);
                    return e.sortpaths === "backward" && (H.reverse(), X.reverse()), H.push(q.valueInds[0]), X.push(V.valueInds[0]), e.bundlecolors && (H.unshift(q.rawColor), X.unshift(V.rawColor)), H < X ? -1 : H > X ? 1 : 0;
                });
                for(var h = new Array(u.length), d = t[0].model.count, v = t[0].categories.map(function(q) {
                    return q.height;
                }).reduce(function(q, V) {
                    return q + V;
                }), x = 0; x < u.length; x++){
                    var b = u[x], p;
                    d > 0 ? p = v * (b.count / d) : p = 0;
                    for(var E = new Array(n.length), k = 0; k < b.categoryInds.length; k++){
                        var A = b.categoryInds[k], L = i[k][A], _ = a[k];
                        E[_] = n[_][L], n[_][L] += p;
                        var C = e.dimensions[_].categories[L], M = C.bands.length, g = C.bands[M - 1];
                        if (g === void 0 || b.rawColor !== g.rawColor) {
                            var P = g === void 0 ? 0 : g.y + g.height;
                            C.bands.push({
                                key: P,
                                color: b.color,
                                rawColor: b.rawColor,
                                height: p,
                                width: C.width,
                                count: b.count,
                                y: P,
                                categoryViewModel: C,
                                parcatsViewModel: e
                            });
                        } else {
                            var T = C.bands[M - 1];
                            T.height += p, T.count += b.count;
                        }
                    }
                    var F;
                    e.pathShape === "hspline" ? F = XNe(s, E, l, p, .5) : F = XNe(s, E, l, p, 0), h[x] = {
                        key: b.valueInds[0],
                        model: b,
                        height: p,
                        leftXs: s,
                        topYs: E,
                        dimWidths: l,
                        svgD: F,
                        parcatsViewModel: e
                    };
                }
                e.paths = h;
            }
            function qK(e) {
                var t = e.model.dimensions.map(function(o) {
                    return {
                        displayInd: o.displayInd,
                        dimensionInd: o.dimensionInd
                    };
                });
                t.sort(function(o, s) {
                    return o.displayInd - s.displayInd;
                });
                var r = [];
                for(var n in t){
                    var i = t[n].dimensionInd, a = e.model.dimensions[i];
                    r.push(qVt(e, a));
                }
                e.dimensions = r;
            }
            function qVt(e, t) {
                var r = 40, n = 16, i = e.model.dimensions.length, a = t.displayInd, o, s, l;
                i > 1 ? o = (e.width - 2 * r - n) / (i - 1) : o = 0, s = r, l = s + o * a;
                var u = [], c = e.model.maxCats, f = t.categories.length, h = 8, d = t.count, v = e.height - h * (c - 1), x, b, p, E, k, A = (c - f) * h / 2, L = t.categories.map(function(_) {
                    return {
                        displayInd: _.displayInd,
                        categoryInd: _.categoryInd
                    };
                });
                for(L.sort(function(_, C) {
                    return _.displayInd - C.displayInd;
                }), k = 0; k < f; k++)E = L[k].categoryInd, b = t.categories[E], d > 0 ? x = b.count / d * v : x = 0, p = {
                    key: b.valueInds[0],
                    model: b,
                    width: n,
                    height: x,
                    y: b.dragY !== null ? b.dragY : A,
                    bands: [],
                    parcatsViewModel: e
                }, A = A + x + h, u.push(p);
                return {
                    key: t.dimensionInd,
                    x: t.dragX !== null ? t.dragX : l,
                    y: 0,
                    width: n,
                    model: t,
                    categories: u,
                    parcatsViewModel: e,
                    dragCategoryDisplayInd: null,
                    dragDimensionDisplayInd: null,
                    initialDragDimensionDisplayInds: null,
                    initialDragCategoryDisplayInds: null,
                    dragHasMoved: null,
                    potentialClickBand: null
                };
            }
        });
        var OK = ye((Tyr, rUe)=>{
            "use strict";
            var OVt = tUe();
            rUe.exports = function(t, r, n, i) {
                var a = t._fullLayout, o = a._paper, s = a._size;
                OVt(t, o, r, {
                    width: s.w,
                    height: s.h,
                    margin: {
                        t: s.t,
                        r: s.r,
                        b: s.b,
                        l: s.l
                    }
                }, n, i);
            };
        });
        var nUe = ye((BF)=>{
            "use strict";
            var BVt = kd().getModuleCalcData, NVt = OK(), iUe = "parcats";
            BF.name = iUe;
            BF.plot = function(e, t, r, n) {
                var i = BVt(e.calcdata, iUe);
                if (i.length) {
                    var a = i[0];
                    NVt(e, a, r, n);
                }
            };
            BF.clean = function(e, t, r, n) {
                var i = n._has && n._has("parcats"), a = t._has && t._has("parcats");
                i && !a && n._paperdiv.selectAll(".parcats").remove();
            };
        });
        var oUe = ye((Syr, aUe)=>{
            "use strict";
            aUe.exports = {
                attributes: EK(),
                supplyDefaults: GNe(),
                calc: WNe(),
                plot: OK(),
                colorbar: {
                    container: "line",
                    min: "cmin",
                    max: "cmax"
                },
                moduleType: "trace",
                name: "parcats",
                basePlotModule: nUe(),
                categories: [
                    "noOpacity"
                ],
                meta: {}
            };
        });
        var lUe = ye((Myr, sUe)=>{
            "use strict";
            sUe.exports = oUe();
        });
        var c1 = ye((Eyr, pUe)=>{
            "use strict";
            var UVt = Y1(), uUe = "1.13.4", dUe = '\xA9 <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', cUe = [
                '\xA9 <a target="_blank" href="https://carto.com/">Carto</a>',
                dUe
            ].join(" "), fUe = [
                'Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>',
                'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>',
                "|",
                'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors',
                'under <a target="_blank" href="https://www.openstreetmap.org/copyright">ODbL</a>'
            ].join(" "), VVt = [
                'Map tiles by <a target="_blank" href="https://stamen.com">Stamen Design</a>',
                'under <a target="_blank" href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>',
                "|",
                'Data by <a target="_blank" href="https://openstreetmap.org">OpenStreetMap</a> contributors',
                'under <a target="_blank" href="https://creativecommons.org/licenses/by-sa/3.0">CC BY SA</a>'
            ].join(" "), vUe = {
                "open-street-map": {
                    id: "osm",
                    version: 8,
                    sources: {
                        "plotly-osm-tiles": {
                            type: "raster",
                            attribution: dUe,
                            tiles: [
                                "https://a.tile.openstreetmap.org/{z}/{x}/{y}.png",
                                "https://b.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            ],
                            tileSize: 256
                        }
                    },
                    layers: [
                        {
                            id: "plotly-osm-tiles",
                            type: "raster",
                            source: "plotly-osm-tiles",
                            minzoom: 0,
                            maxzoom: 22
                        }
                    ],
                    glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                },
                "white-bg": {
                    id: "white-bg",
                    version: 8,
                    sources: {},
                    layers: [
                        {
                            id: "white-bg",
                            type: "background",
                            paint: {
                                "background-color": "#FFFFFF"
                            },
                            minzoom: 0,
                            maxzoom: 22
                        }
                    ],
                    glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                },
                "carto-positron": {
                    id: "carto-positron",
                    version: 8,
                    sources: {
                        "plotly-carto-positron": {
                            type: "raster",
                            attribution: cUe,
                            tiles: [
                                "https://cartodb-basemaps-c.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
                            ],
                            tileSize: 256
                        }
                    },
                    layers: [
                        {
                            id: "plotly-carto-positron",
                            type: "raster",
                            source: "plotly-carto-positron",
                            minzoom: 0,
                            maxzoom: 22
                        }
                    ],
                    glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                },
                "carto-darkmatter": {
                    id: "carto-darkmatter",
                    version: 8,
                    sources: {
                        "plotly-carto-darkmatter": {
                            type: "raster",
                            attribution: cUe,
                            tiles: [
                                "https://cartodb-basemaps-c.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png"
                            ],
                            tileSize: 256
                        }
                    },
                    layers: [
                        {
                            id: "plotly-carto-darkmatter",
                            type: "raster",
                            source: "plotly-carto-darkmatter",
                            minzoom: 0,
                            maxzoom: 22
                        }
                    ],
                    glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                },
                "stamen-terrain": {
                    id: "stamen-terrain",
                    version: 8,
                    sources: {
                        "plotly-stamen-terrain": {
                            type: "raster",
                            attribution: fUe,
                            tiles: [
                                "https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}.png?api_key="
                            ],
                            tileSize: 256
                        }
                    },
                    layers: [
                        {
                            id: "plotly-stamen-terrain",
                            type: "raster",
                            source: "plotly-stamen-terrain",
                            minzoom: 0,
                            maxzoom: 22
                        }
                    ],
                    glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                },
                "stamen-toner": {
                    id: "stamen-toner",
                    version: 8,
                    sources: {
                        "plotly-stamen-toner": {
                            type: "raster",
                            attribution: fUe,
                            tiles: [
                                "https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}.png?api_key="
                            ],
                            tileSize: 256
                        }
                    },
                    layers: [
                        {
                            id: "plotly-stamen-toner",
                            type: "raster",
                            source: "plotly-stamen-toner",
                            minzoom: 0,
                            maxzoom: 22
                        }
                    ],
                    glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                },
                "stamen-watercolor": {
                    id: "stamen-watercolor",
                    version: 8,
                    sources: {
                        "plotly-stamen-watercolor": {
                            type: "raster",
                            attribution: VVt,
                            tiles: [
                                "https://tiles.stadiamaps.com/tiles/stamen_watercolor/{z}/{x}/{y}.jpg?api_key="
                            ],
                            tileSize: 256
                        }
                    },
                    layers: [
                        {
                            id: "plotly-stamen-watercolor",
                            type: "raster",
                            source: "plotly-stamen-watercolor",
                            minzoom: 0,
                            maxzoom: 22
                        }
                    ],
                    glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                }
            }, hUe = UVt(vUe);
            pUe.exports = {
                requiredVersion: uUe,
                styleUrlPrefix: "mapbox://styles/mapbox/",
                styleUrlSuffix: "v9",
                styleValuesMapbox: [
                    "basic",
                    "streets",
                    "outdoors",
                    "light",
                    "dark",
                    "satellite",
                    "satellite-streets"
                ],
                styleValueDflt: "basic",
                stylesNonMapbox: vUe,
                styleValuesNonMapbox: hUe,
                traceLayerPrefix: "plotly-trace-layer-",
                layoutLayerPrefix: "plotly-layout-layer-",
                wrongVersionErrorMsg: [
                    "Your custom plotly.js bundle is not using the correct mapbox-gl version",
                    "Please install @plotly/mapbox-gl@" + uUe + "."
                ].join(`
`),
                noAccessTokenErrorMsg: [
                    "Missing Mapbox access token.",
                    "Mapbox trace type require a Mapbox access token to be registered.",
                    "For example:",
                    "  Plotly.newPlot(gd, data, layout, { mapboxAccessToken: 'my-access-token' });",
                    "More info here: https://www.mapbox.com/help/define-access-token/"
                ].join(`
`),
                missingStyleErrorMsg: [
                    "No valid mapbox style found, please set `mapbox.style` to one of:",
                    hUe.join(", "),
                    "or register a Mapbox access token to use a Mapbox-served style."
                ].join(`
`),
                multipleTokensErrorMsg: [
                    "Set multiple mapbox access token across different mapbox subplot,",
                    "using first token found as mapbox-gl does not allow multipleaccess tokens on the same page."
                ].join(`
`),
                mapOnErrorMsg: "Mapbox error.",
                mapboxLogo: {
                    path0: "m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z",
                    path1: "M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z",
                    path2: "M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z",
                    polygon: "11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34"
                },
                styleRules: {
                    map: "overflow:hidden;position:relative;",
                    "missing-css": "display:none;",
                    canary: "background-color:salmon;",
                    "ctrl-bottom-left": "position: absolute; pointer-events: none; z-index: 2; bottom: 0; left: 0;",
                    "ctrl-bottom-right": "position: absolute; pointer-events: none; z-index: 2; right: 0; bottom: 0;",
                    ctrl: "clear: both; pointer-events: auto; transform: translate(0, 0);",
                    "ctrl-attrib.mapboxgl-compact .mapboxgl-ctrl-attrib-inner": "display: none;",
                    "ctrl-attrib.mapboxgl-compact:hover .mapboxgl-ctrl-attrib-inner": "display: block; margin-top:2px",
                    "ctrl-attrib.mapboxgl-compact:hover": "padding: 2px 24px 2px 4px; visibility: visible; margin-top: 6px;",
                    "ctrl-attrib.mapboxgl-compact::after": `content: ""; cursor: pointer; position: absolute; background-image: url('data:image/svg+xml;charset=utf-8,%3Csvg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"%3E %3Cpath fill="%23333333" fill-rule="evenodd" d="M4,10a6,6 0 1,0 12,0a6,6 0 1,0 -12,0 M9,7a1,1 0 1,0 2,0a1,1 0 1,0 -2,0 M9,10a1,1 0 1,1 2,0l0,3a1,1 0 1,1 -2,0"/%3E %3C/svg%3E'); background-color: rgba(255, 255, 255, 0.5); width: 24px; height: 24px; box-sizing: border-box; border-radius: 12px;`,
                    "ctrl-attrib.mapboxgl-compact": "min-height: 20px; padding: 0; margin: 10px; position: relative; background-color: #fff; border-radius: 3px 12px 12px 3px;",
                    "ctrl-bottom-right > .mapboxgl-ctrl-attrib.mapboxgl-compact::after": "bottom: 0; right: 0",
                    "ctrl-bottom-left > .mapboxgl-ctrl-attrib.mapboxgl-compact::after": "bottom: 0; left: 0",
                    "ctrl-bottom-left .mapboxgl-ctrl": "margin: 0 0 10px 10px; float: left;",
                    "ctrl-bottom-right .mapboxgl-ctrl": "margin: 0 10px 10px 0; float: right;",
                    "ctrl-attrib": "color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px",
                    "ctrl-attrib a": "color: rgba(0, 0, 0, 0.75); text-decoration: none; font-size: 12px",
                    "ctrl-attrib a:hover": "color: inherit; text-decoration: underline;",
                    "ctrl-attrib .mapbox-improve-map": "font-weight: bold; margin-left: 2px;",
                    "attrib-empty": "display: none;",
                    "ctrl-logo": `display:block; width: 21px; height: 21px; background-image: url('data:image/svg+xml;charset=utf-8,%3C?xml version="1.0" encoding="utf-8"?%3E %3Csvg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 21 21" style="enable-background:new 0 0 21 21;" xml:space="preserve"%3E%3Cg transform="translate(0,0.01)"%3E%3Cpath d="m 10.5,1.24 c -5.11,0 -9.25,4.15 -9.25,9.25 0,5.1 4.15,9.25 9.25,9.25 5.1,0 9.25,-4.15 9.25,-9.25 0,-5.11 -4.14,-9.25 -9.25,-9.25 z m 4.39,11.53 c -1.93,1.93 -4.78,2.31 -6.7,2.31 -0.7,0 -1.41,-0.05 -2.1,-0.16 0,0 -1.02,-5.64 2.14,-8.81 0.83,-0.83 1.95,-1.28 3.13,-1.28 1.27,0 2.49,0.51 3.39,1.42 1.84,1.84 1.89,4.75 0.14,6.52 z" style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3Cpath d="M 10.5,-0.01 C 4.7,-0.01 0,4.7 0,10.49 c 0,5.79 4.7,10.5 10.5,10.5 5.8,0 10.5,-4.7 10.5,-10.5 C 20.99,4.7 16.3,-0.01 10.5,-0.01 Z m 0,19.75 c -5.11,0 -9.25,-4.15 -9.25,-9.25 0,-5.1 4.14,-9.26 9.25,-9.26 5.11,0 9.25,4.15 9.25,9.25 0,5.13 -4.14,9.26 -9.25,9.26 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpath d="M 14.74,6.25 C 12.9,4.41 9.98,4.35 8.23,6.1 5.07,9.27 6.09,14.91 6.09,14.91 c 0,0 5.64,1.02 8.81,-2.14 C 16.64,11 16.59,8.09 14.74,6.25 Z m -2.27,4.09 -0.91,1.87 -0.9,-1.87 -1.86,-0.91 1.86,-0.9 0.9,-1.87 0.91,1.87 1.86,0.9 z" style="opacity:0.35;enable-background:new" class="st1"/%3E%3Cpolygon points="11.56,12.21 10.66,10.34 8.8,9.43 10.66,8.53 11.56,6.66 12.47,8.53 14.33,9.43 12.47,10.34 " style="opacity:0.9;fill:%23ffffff;enable-background:new" class="st0"/%3E%3C/g%3E%3C/svg%3E')`
                }
            };
        });
        var Rk = ye((kyr, _Ue)=>{
            "use strict";
            var gUe = Mr(), mUe = va().defaultLine, HVt = Ju().attributes, GVt = Su(), jVt = Uc().textposition, WVt = Bu().overrideAll, ZVt = Vs().templatedArray, BK = c1(), yUe = GVt({
                noFontVariant: !0,
                noFontShadow: !0,
                noFontLineposition: !0,
                noFontTextcase: !0
            });
            yUe.family.dflt = "Open Sans Regular, Arial Unicode MS Regular";
            var XVt = _Ue.exports = WVt({
                _arrayAttrRegexps: [
                    gUe.counterRegex("mapbox", ".layers", !0)
                ],
                domain: HVt({
                    name: "mapbox"
                }),
                accesstoken: {
                    valType: "string",
                    noBlank: !0,
                    strict: !0
                },
                style: {
                    valType: "any",
                    values: BK.styleValuesMapbox.concat(BK.styleValuesNonMapbox),
                    dflt: BK.styleValueDflt
                },
                center: {
                    lon: {
                        valType: "number",
                        dflt: 0
                    },
                    lat: {
                        valType: "number",
                        dflt: 0
                    }
                },
                zoom: {
                    valType: "number",
                    dflt: 1
                },
                bearing: {
                    valType: "number",
                    dflt: 0
                },
                pitch: {
                    valType: "number",
                    dflt: 0
                },
                bounds: {
                    west: {
                        valType: "number"
                    },
                    east: {
                        valType: "number"
                    },
                    south: {
                        valType: "number"
                    },
                    north: {
                        valType: "number"
                    }
                },
                layers: ZVt("layer", {
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    sourcetype: {
                        valType: "enumerated",
                        values: [
                            "geojson",
                            "vector",
                            "raster",
                            "image"
                        ],
                        dflt: "geojson"
                    },
                    source: {
                        valType: "any"
                    },
                    sourcelayer: {
                        valType: "string",
                        dflt: ""
                    },
                    sourceattribution: {
                        valType: "string"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "circle",
                            "line",
                            "fill",
                            "symbol",
                            "raster"
                        ],
                        dflt: "circle"
                    },
                    coordinates: {
                        valType: "any"
                    },
                    below: {
                        valType: "string"
                    },
                    color: {
                        valType: "color",
                        dflt: mUe
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1
                    },
                    minzoom: {
                        valType: "number",
                        min: 0,
                        max: 24,
                        dflt: 0
                    },
                    maxzoom: {
                        valType: "number",
                        min: 0,
                        max: 24,
                        dflt: 24
                    },
                    circle: {
                        radius: {
                            valType: "number",
                            dflt: 15
                        }
                    },
                    line: {
                        width: {
                            valType: "number",
                            dflt: 2
                        },
                        dash: {
                            valType: "data_array"
                        }
                    },
                    fill: {
                        outlinecolor: {
                            valType: "color",
                            dflt: mUe
                        }
                    },
                    symbol: {
                        icon: {
                            valType: "string",
                            dflt: "marker"
                        },
                        iconsize: {
                            valType: "number",
                            dflt: 10
                        },
                        text: {
                            valType: "string",
                            dflt: ""
                        },
                        placement: {
                            valType: "enumerated",
                            values: [
                                "point",
                                "line",
                                "line-center"
                            ],
                            dflt: "point"
                        },
                        textfont: yUe,
                        textposition: gUe.extendFlat({}, jVt, {
                            arrayOk: !1
                        })
                    }
                })
            }, "plot", "from-root");
            XVt.uirevision = {
                valType: "any",
                editType: "none"
            };
        });
        var NF = ye((Cyr, wUe)=>{
            "use strict";
            var YVt = Wo().hovertemplateAttrs, KVt = Wo().texttemplateAttrs, JVt = Eg(), Dk = H2(), _A = Uc(), xUe = Rk(), $Vt = vl(), QVt = Jl(), ew = no().extendFlat, eHt = Bu().overrideAll, tHt = Rk(), bUe = Dk.line, xA = Dk.marker;
            wUe.exports = eHt({
                lon: Dk.lon,
                lat: Dk.lat,
                cluster: {
                    enabled: {
                        valType: "boolean"
                    },
                    maxzoom: ew({}, tHt.layers.maxzoom, {}),
                    step: {
                        valType: "number",
                        arrayOk: !0,
                        dflt: -1,
                        min: -1
                    },
                    size: {
                        valType: "number",
                        arrayOk: !0,
                        dflt: 20,
                        min: 0
                    },
                    color: {
                        valType: "color",
                        arrayOk: !0
                    },
                    opacity: ew({}, xA.opacity, {
                        dflt: 1
                    })
                },
                mode: ew({}, _A.mode, {
                    dflt: "markers"
                }),
                text: ew({}, _A.text, {}),
                texttemplate: KVt({
                    editType: "plot"
                }, {
                    keys: [
                        "lat",
                        "lon",
                        "text"
                    ]
                }),
                hovertext: ew({}, _A.hovertext, {}),
                line: {
                    color: bUe.color,
                    width: bUe.width
                },
                connectgaps: _A.connectgaps,
                marker: ew({
                    symbol: {
                        valType: "string",
                        dflt: "circle",
                        arrayOk: !0
                    },
                    angle: {
                        valType: "number",
                        dflt: "auto",
                        arrayOk: !0
                    },
                    allowoverlap: {
                        valType: "boolean",
                        dflt: !1
                    },
                    opacity: xA.opacity,
                    size: xA.size,
                    sizeref: xA.sizeref,
                    sizemin: xA.sizemin,
                    sizemode: xA.sizemode
                }, QVt("marker")),
                fill: Dk.fill,
                fillcolor: JVt(),
                textfont: xUe.layers.symbol.textfont,
                textposition: xUe.layers.symbol.textposition,
                below: {
                    valType: "string"
                },
                selected: {
                    marker: _A.selected.marker
                },
                unselected: {
                    marker: _A.unselected.marker
                },
                hoverinfo: ew({}, $Vt.hoverinfo, {
                    flags: [
                        "lon",
                        "lat",
                        "text",
                        "name"
                    ]
                }),
                hovertemplate: YVt()
            }, "calc", "nested");
        });
        var NK = ye((Lyr, TUe)=>{
            "use strict";
            var rHt = [
                "Metropolis Black Italic",
                "Metropolis Black",
                "Metropolis Bold Italic",
                "Metropolis Bold",
                "Metropolis Extra Bold Italic",
                "Metropolis Extra Bold",
                "Metropolis Extra Light Italic",
                "Metropolis Extra Light",
                "Metropolis Light Italic",
                "Metropolis Light",
                "Metropolis Medium Italic",
                "Metropolis Medium",
                "Metropolis Regular Italic",
                "Metropolis Regular",
                "Metropolis Semi Bold Italic",
                "Metropolis Semi Bold",
                "Metropolis Thin Italic",
                "Metropolis Thin",
                "Open Sans Bold Italic",
                "Open Sans Bold",
                "Open Sans Extrabold Italic",
                "Open Sans Extrabold",
                "Open Sans Italic",
                "Open Sans Light Italic",
                "Open Sans Light",
                "Open Sans Regular",
                "Open Sans Semibold Italic",
                "Open Sans Semibold",
                "Klokantech Noto Sans Bold",
                "Klokantech Noto Sans CJK Bold",
                "Klokantech Noto Sans CJK Regular",
                "Klokantech Noto Sans Italic",
                "Klokantech Noto Sans Regular"
            ];
            TUe.exports = {
                isSupportedFont: function(e) {
                    return rHt.indexOf(e) !== -1;
                }
            };
        });
        var MUe = ye((Pyr, SUe)=>{
            "use strict";
            var zk = Mr(), UK = lu(), iHt = $p(), nHt = R0(), aHt = D0(), oHt = Ig(), AUe = NF(), sHt = NK().isSupportedFont;
            SUe.exports = function(t, r, n, i) {
                function a(p, E) {
                    return zk.coerce(t, r, AUe, p, E);
                }
                function o(p, E) {
                    return zk.coerce2(t, r, AUe, p, E);
                }
                var s = lHt(t, r, a);
                if (!s) {
                    r.visible = !1;
                    return;
                }
                if (a("text"), a("texttemplate"), a("hovertext"), a("hovertemplate"), a("mode"), a("below"), UK.hasMarkers(r)) {
                    iHt(t, r, n, i, a, {
                        noLine: !0,
                        noAngle: !0
                    }), a("marker.allowoverlap"), a("marker.angle");
                    var l = r.marker;
                    l.symbol !== "circle" && (zk.isArrayOrTypedArray(l.size) && (l.size = l.size[0]), zk.isArrayOrTypedArray(l.color) && (l.color = l.color[0]));
                }
                UK.hasLines(r) && (nHt(t, r, n, i, a, {
                    noDash: !0
                }), a("connectgaps"));
                var u = o("cluster.maxzoom"), c = o("cluster.step"), f = o("cluster.color", r.marker && r.marker.color || n), h = o("cluster.size"), d = o("cluster.opacity"), v = u !== !1 || c !== !1 || f !== !1 || h !== !1 || d !== !1, x = a("cluster.enabled", v);
                if (x || UK.hasText(r)) {
                    var b = i.font.family;
                    aHt(t, r, i, a, {
                        noSelect: !0,
                        noFontVariant: !0,
                        noFontShadow: !0,
                        noFontLineposition: !0,
                        noFontTextcase: !0,
                        font: {
                            family: sHt(b) ? b : "Open Sans Regular",
                            weight: i.font.weight,
                            style: i.font.style,
                            size: i.font.size,
                            color: i.font.color
                        }
                    });
                }
                a("fill"), r.fill !== "none" && oHt(t, r, n, a), zk.coerceSelectionMarkerOpacity(r, a);
            };
            function lHt(e, t, r) {
                var n = r("lon") || [], i = r("lat") || [], a = Math.min(n.length, i.length);
                return t._length = a, a;
            }
        });
        var VK = ye((Iyr, kUe)=>{
            "use strict";
            var EUe = Qa();
            kUe.exports = function(t, r, n) {
                var i = {}, a = n[r.subplot]._subplot, o = a.mockAxis, s = t.lonlat;
                return i.lonLabel = EUe.tickText(o, o.c2l(s[0]), !0).text, i.latLabel = EUe.tickText(o, o.c2l(s[1]), !0).text, i;
            };
        });
        var HK = ye((Ryr, LUe)=>{
            "use strict";
            var CUe = Mr();
            LUe.exports = function(t, r) {
                var n = t.split(" "), i = n[0], a = n[1], o = CUe.isArrayOrTypedArray(r) ? CUe.mean(r) : r, s = .5 + o / 100, l = 1.5 + o / 100, u = [
                    "",
                    ""
                ], c = [
                    0,
                    0
                ];
                switch(i){
                    case "top":
                        u[0] = "top", c[1] = -l;
                        break;
                    case "bottom":
                        u[0] = "bottom", c[1] = l;
                        break;
                }
                switch(a){
                    case "left":
                        u[1] = "right", c[0] = -s;
                        break;
                    case "right":
                        u[1] = "left", c[0] = s;
                        break;
                }
                var f;
                return u[0] && u[1] ? f = u.join("-") : u[0] ? f = u[0] : u[1] ? f = u[1] : f = "center", {
                    anchor: f,
                    offset: c
                };
            };
        });
        var FUe = ye((Dyr, zUe)=>{
            "use strict";
            var RUe = uo(), iv = Mr(), uHt = es().BADNUM, VF = rx(), PUe = Mu(), cHt = ao(), fHt = S3(), HF = lu(), hHt = NK().isSupportedFont, dHt = HK(), vHt = rp().appendArrayPointValue, pHt = Pl().NEWLINES, gHt = Pl().BR_TAG_ALL;
            zUe.exports = function(t, r) {
                var n = r[0].trace, i = n.visible === !0 && n._length !== 0, a = n.fill !== "none", o = HF.hasLines(n), s = HF.hasMarkers(n), l = HF.hasText(n), u = s && n.marker.symbol === "circle", c = s && n.marker.symbol !== "circle", f = n.cluster && n.cluster.enabled, h = UF("fill"), d = UF("line"), v = UF("circle"), x = UF("symbol"), b = {
                    fill: h,
                    line: d,
                    circle: v,
                    symbol: x
                };
                if (!i) return b;
                var p;
                if ((a || o) && (p = VF.calcTraceToLineCoords(r)), a && (h.geojson = VF.makePolygon(p), h.layout.visibility = "visible", iv.extendFlat(h.paint, {
                    "fill-color": n.fillcolor
                })), o && (d.geojson = VF.makeLine(p), d.layout.visibility = "visible", iv.extendFlat(d.paint, {
                    "line-width": n.line.width,
                    "line-color": n.line.color,
                    "line-opacity": n.opacity
                })), u) {
                    var E = mHt(r);
                    v.geojson = E.geojson, v.layout.visibility = "visible", f && (v.filter = [
                        "!",
                        [
                            "has",
                            "point_count"
                        ]
                    ], b.cluster = {
                        type: "circle",
                        filter: [
                            "has",
                            "point_count"
                        ],
                        layout: {
                            visibility: "visible"
                        },
                        paint: {
                            "circle-color": jK(n.cluster.color, n.cluster.step),
                            "circle-radius": jK(n.cluster.size, n.cluster.step),
                            "circle-opacity": jK(n.cluster.opacity, n.cluster.step)
                        }
                    }, b.clusterCount = {
                        type: "symbol",
                        filter: [
                            "has",
                            "point_count"
                        ],
                        paint: {},
                        layout: {
                            "text-field": "{point_count_abbreviated}",
                            "text-font": IUe(n),
                            "text-size": 12
                        }
                    }), iv.extendFlat(v.paint, {
                        "circle-color": E.mcc,
                        "circle-radius": E.mrc,
                        "circle-opacity": E.mo
                    });
                }
                if (u && f && (v.filter = [
                    "!",
                    [
                        "has",
                        "point_count"
                    ]
                ]), (c || l) && (x.geojson = yHt(r, t), iv.extendFlat(x.layout, {
                    visibility: "visible",
                    "icon-image": "{symbol}-15",
                    "text-field": "{text}"
                }), c && (iv.extendFlat(x.layout, {
                    "icon-size": n.marker.size / 10
                }), "angle" in n.marker && n.marker.angle !== "auto" && iv.extendFlat(x.layout, {
                    "icon-rotate": {
                        type: "identity",
                        property: "angle"
                    },
                    "icon-rotation-alignment": "map"
                }), x.layout["icon-allow-overlap"] = n.marker.allowoverlap, iv.extendFlat(x.paint, {
                    "icon-opacity": n.opacity * n.marker.opacity,
                    "icon-color": n.marker.color
                })), l)) {
                    var k = (n.marker || {}).size, A = dHt(n.textposition, k);
                    iv.extendFlat(x.layout, {
                        "text-size": n.textfont.size,
                        "text-anchor": A.anchor,
                        "text-offset": A.offset,
                        "text-font": IUe(n)
                    }), iv.extendFlat(x.paint, {
                        "text-color": n.textfont.color,
                        "text-opacity": n.opacity
                    });
                }
                return b;
            };
            function UF(e) {
                return {
                    type: e,
                    geojson: VF.makeBlank(),
                    layout: {
                        visibility: "none"
                    },
                    filter: null,
                    paint: {}
                };
            }
            function mHt(e) {
                var t = e[0].trace, r = t.marker, n = t.selectedpoints, i = iv.isArrayOrTypedArray(r.color), a = iv.isArrayOrTypedArray(r.size), o = iv.isArrayOrTypedArray(r.opacity), s;
                function l(k) {
                    return t.opacity * k;
                }
                function u(k) {
                    return k / 2;
                }
                var c;
                i && (PUe.hasColorscale(t, "marker") ? c = PUe.makeColorScaleFuncFromTrace(r) : c = iv.identity);
                var f;
                a && (f = fHt(t));
                var h;
                o && (h = function(k) {
                    var A = RUe(k) ? +iv.constrain(k, 0, 1) : 0;
                    return l(A);
                });
                var d = [];
                for(s = 0; s < e.length; s++){
                    var v = e[s], x = v.lonlat;
                    if (!DUe(x)) {
                        var b = {};
                        c && (b.mcc = v.mcc = c(v.mc)), f && (b.mrc = v.mrc = f(v.ms)), h && (b.mo = h(v.mo)), n && (b.selected = v.selected || 0), d.push({
                            type: "Feature",
                            id: s + 1,
                            geometry: {
                                type: "Point",
                                coordinates: x
                            },
                            properties: b
                        });
                    }
                }
                var p;
                if (n) for(p = cHt.makeSelectedPointStyleFns(t), s = 0; s < d.length; s++){
                    var E = d[s].properties;
                    p.selectedOpacityFn && (E.mo = l(p.selectedOpacityFn(E))), p.selectedColorFn && (E.mcc = p.selectedColorFn(E)), p.selectedSizeFn && (E.mrc = p.selectedSizeFn(E));
                }
                return {
                    geojson: {
                        type: "FeatureCollection",
                        features: d
                    },
                    mcc: i || p && p.selectedColorFn ? {
                        type: "identity",
                        property: "mcc"
                    } : r.color,
                    mrc: a || p && p.selectedSizeFn ? {
                        type: "identity",
                        property: "mrc"
                    } : u(r.size),
                    mo: o || p && p.selectedOpacityFn ? {
                        type: "identity",
                        property: "mo"
                    } : l(r.opacity)
                };
            }
            function yHt(e, t) {
                for(var r = t._fullLayout, n = e[0].trace, i = n.marker || {}, a = i.symbol, o = i.angle, s = a !== "circle" ? GK(a) : GF, l = o !== "auto" ? GK(o, !0) : GF, u = HF.hasText(n) ? GK(n.text) : GF, c = [], f = 0; f < e.length; f++){
                    var h = e[f];
                    if (!DUe(h.lonlat)) {
                        var d = n.texttemplate, v;
                        if (d) {
                            var x = Array.isArray(d) ? d[f] || "" : d, b = n._module.formatLabels(h, n, r), p = {};
                            vHt(p, n, h.i);
                            var E = n._meta || {};
                            v = iv.texttemplateString(x, b, r._d3locale, p, h, E);
                        } else v = u(f);
                        v && (v = v.replace(pHt, "").replace(gHt, `
`)), c.push({
                            type: "Feature",
                            geometry: {
                                type: "Point",
                                coordinates: h.lonlat
                            },
                            properties: {
                                symbol: s(f),
                                angle: l(f),
                                text: v
                            }
                        });
                    }
                }
                return {
                    type: "FeatureCollection",
                    features: c
                };
            }
            function GK(e, t) {
                return iv.isArrayOrTypedArray(e) ? t ? function(r) {
                    return RUe(e[r]) ? +e[r] : 0;
                } : function(r) {
                    return e[r];
                } : e ? function() {
                    return e;
                } : GF;
            }
            function GF() {
                return "";
            }
            function DUe(e) {
                return e[0] === uHt;
            }
            function jK(e, t) {
                var r;
                if (iv.isArrayOrTypedArray(e) && iv.isArrayOrTypedArray(t)) {
                    r = [
                        "step",
                        [
                            "get",
                            "point_count"
                        ],
                        e[0]
                    ];
                    for(var n = 1; n < e.length; n++)r.push(t[n - 1], e[n]);
                } else r = e;
                return r;
            }
            function IUe(e) {
                var t = e.textfont, r = t.family, n = t.style, i = t.weight, a = r.split(" "), o = a[a.length - 1] === "Italic";
                o && a.pop(), o = o || n === "italic";
                var s = a.join(" ");
                i === "bold" && a.indexOf("Bold") === -1 ? s += " Bold" : i <= 1e3 && (a[0] === "Metropolis" ? (s = "Metropolis", i > 850 ? s += " Black" : i > 750 ? s += " Extra Bold" : i > 650 ? s += " Bold" : i > 550 ? s += " Semi Bold" : i > 450 ? s += " Medium" : i > 350 ? s += " Regular" : i > 250 ? s += " Light" : i > 150 ? s += " Extra Light" : s += " Thin") : a.slice(0, 2).join(" ") === "Open Sans" ? (s = "Open Sans", i > 750 ? s += " Extrabold" : i > 650 ? s += " Bold" : i > 550 ? s += " Semibold" : i > 350 ? s += " Regular" : s += " Light") : a.slice(0, 3).join(" ") === "Klokantech Noto Sans" && (s = "Klokantech Noto Sans", a[3] === "CJK" && (s += " CJK"), s += i > 500 ? " Bold" : " Regular")), o && (s += " Italic"), s === "Open Sans Regular Italic" ? s = "Open Sans Italic" : s === "Open Sans Regular Bold" ? s = "Open Sans Bold" : s === "Open Sans Regular Bold Italic" ? s = "Open Sans Bold Italic" : s === "Klokantech Noto Sans Regular Italic" && (s = "Klokantech Noto Sans Italic"), hHt(s) || (s = r);
                var l = s.split(", ");
                return l;
            }
        });
        var NUe = ye((zyr, BUe)=>{
            "use strict";
            var _Ht = Mr(), qUe = FUe(), bA = c1().traceLayerPrefix, rg = {
                cluster: [
                    "cluster",
                    "clusterCount",
                    "circle"
                ],
                nonCluster: [
                    "fill",
                    "line",
                    "circle",
                    "symbol"
                ]
            };
            function OUe(e, t, r, n) {
                this.type = "scattermapbox", this.subplot = e, this.uid = t, this.clusterEnabled = r, this.isHidden = n, this.sourceIds = {
                    fill: "source-" + t + "-fill",
                    line: "source-" + t + "-line",
                    circle: "source-" + t + "-circle",
                    symbol: "source-" + t + "-symbol",
                    cluster: "source-" + t + "-circle",
                    clusterCount: "source-" + t + "-circle"
                }, this.layerIds = {
                    fill: bA + t + "-fill",
                    line: bA + t + "-line",
                    circle: bA + t + "-circle",
                    symbol: bA + t + "-symbol",
                    cluster: bA + t + "-cluster",
                    clusterCount: bA + t + "-cluster-count"
                }, this.below = null;
            }
            var Fk = OUe.prototype;
            Fk.addSource = function(e, t, r) {
                var n = {
                    type: "geojson",
                    data: t.geojson
                };
                r && r.enabled && _Ht.extendFlat(n, {
                    cluster: !0,
                    clusterMaxZoom: r.maxzoom
                });
                var i = this.subplot.map.getSource(this.sourceIds[e]);
                i ? i.setData(t.geojson) : this.subplot.map.addSource(this.sourceIds[e], n);
            };
            Fk.setSourceData = function(e, t) {
                this.subplot.map.getSource(this.sourceIds[e]).setData(t.geojson);
            };
            Fk.addLayer = function(e, t, r) {
                var n = {
                    type: t.type,
                    id: this.layerIds[e],
                    source: this.sourceIds[e],
                    layout: t.layout,
                    paint: t.paint
                };
                t.filter && (n.filter = t.filter);
                for(var i = this.layerIds[e], a, o = this.subplot.getMapLayers(), s = 0; s < o.length; s++)if (o[s].id === i) {
                    a = !0;
                    break;
                }
                a ? (this.subplot.setOptions(i, "setLayoutProperty", n.layout), n.layout.visibility === "visible" && this.subplot.setOptions(i, "setPaintProperty", n.paint)) : this.subplot.addLayer(n, r);
            };
            Fk.update = function(t) {
                var r = t[0].trace, n = this.subplot, i = n.map, a = qUe(n.gd, t), o = n.belowLookup["trace-" + this.uid], s = !!(r.cluster && r.cluster.enabled), l = !!this.clusterEnabled, u = this;
                function c(k) {
                    k || u.addSource("circle", a.circle, r.cluster);
                    for(var A = rg.cluster, L = 0; L < A.length; L++){
                        var _ = A[L], C = a[_];
                        u.addLayer(_, C, o);
                    }
                }
                function f(k) {
                    for(var A = rg.cluster, L = A.length - 1; L >= 0; L--){
                        var _ = A[L];
                        i.removeLayer(u.layerIds[_]);
                    }
                    k || i.removeSource(u.sourceIds.circle);
                }
                function h(k) {
                    for(var A = rg.nonCluster, L = 0; L < A.length; L++){
                        var _ = A[L], C = a[_];
                        k || u.addSource(_, C), u.addLayer(_, C, o);
                    }
                }
                function d(k) {
                    for(var A = rg.nonCluster, L = A.length - 1; L >= 0; L--){
                        var _ = A[L];
                        i.removeLayer(u.layerIds[_]), k || i.removeSource(u.sourceIds[_]);
                    }
                }
                function v(k) {
                    l ? f(k) : d(k);
                }
                function x(k) {
                    s ? c(k) : h(k);
                }
                function b() {
                    for(var k = s ? rg.cluster : rg.nonCluster, A = 0; A < k.length; A++){
                        var L = k[A], _ = a[L];
                        _ && (n.setOptions(u.layerIds[L], "setLayoutProperty", _.layout), _.layout.visibility === "visible" && (L !== "cluster" && u.setSourceData(L, _), n.setOptions(u.layerIds[L], "setPaintProperty", _.paint)));
                    }
                }
                var p = this.isHidden, E = r.visible !== !0;
                E ? p || v() : p ? E || x() : l !== s ? (v(), x()) : (this.below !== o && (v(!0), x(!0)), b()), this.clusterEnabled = s, this.isHidden = E, this.below = o, t[0].trace._glTrace = this;
            };
            Fk.dispose = function() {
                for(var t = this.subplot.map, r = this.clusterEnabled ? rg.cluster : rg.nonCluster, n = r.length - 1; n >= 0; n--){
                    var i = r[n];
                    t.removeLayer(this.layerIds[i]), t.removeSource(this.sourceIds[i]);
                }
            };
            BUe.exports = function(t, r) {
                var n = r[0].trace, i = n.cluster && n.cluster.enabled, a = n.visible !== !0, o = new OUe(t, n.uid, i, a), s = qUe(t.gd, r), l = o.below = t.belowLookup["trace-" + n.uid], u, c, f;
                if (i) for(o.addSource("circle", s.circle, n.cluster), u = 0; u < rg.cluster.length; u++)c = rg.cluster[u], f = s[c], o.addLayer(c, f, l);
                else for(u = 0; u < rg.nonCluster.length; u++)c = rg.nonCluster[u], f = s[c], o.addSource(c, f, n.cluster), o.addLayer(c, f, l);
                return r[0].trace._glTrace = o, o;
            };
        });
        var jF = ye((Fyr, VUe)=>{
            "use strict";
            var xHt = Nc(), WK = Mr(), bHt = oT(), wHt = WK.fillText, THt = es().BADNUM, AHt = c1().traceLayerPrefix;
            function SHt(e, t, r) {
                var n = e.cd, i = n[0].trace, a = e.xa, o = e.ya, s = e.subplot, l = [], u = AHt + i.uid + "-circle", c = i.cluster && i.cluster.enabled;
                if (c) {
                    var f = s.map.queryRenderedFeatures(null, {
                        layers: [
                            u
                        ]
                    });
                    l = f.map(function(M) {
                        return M.id;
                    });
                }
                var h = t >= 0 ? Math.floor((t + 180) / 360) : Math.ceil((t - 180) / 360), d = h * 360, v = t - d;
                function x(M) {
                    var g = M.lonlat;
                    if (g[0] === THt || c && l.indexOf(M.i + 1) === -1) return 1 / 0;
                    var P = WK.modHalf(g[0], 360), T = g[1], F = s.project([
                        P,
                        T
                    ]), q = F.x - a.c2p([
                        v,
                        T
                    ]), V = F.y - o.c2p([
                        P,
                        r
                    ]), H = Math.max(3, M.mrc || 0);
                    return Math.max(Math.sqrt(q * q + V * V) - H, 1 - 3 / H);
                }
                if (xHt.getClosest(n, x, e), e.index !== !1) {
                    var b = n[e.index], p = b.lonlat, E = [
                        WK.modHalf(p[0], 360) + d,
                        p[1]
                    ], k = a.c2p(E), A = o.c2p(E), L = b.mrc || 1;
                    e.x0 = k - L, e.x1 = k + L, e.y0 = A - L, e.y1 = A + L;
                    var _ = {};
                    _[i.subplot] = {
                        _subplot: s
                    };
                    var C = i._module.formatLabels(b, i, _);
                    return e.lonLabel = C.lonLabel, e.latLabel = C.latLabel, e.color = bHt(i, b), e.extraText = UUe(i, b, n[0].t.labels), e.hovertemplate = i.hovertemplate, [
                        e
                    ];
                }
            }
            function UUe(e, t, r) {
                if (e.hovertemplate) return;
                var n = t.hi || e.hoverinfo, i = n.split("+"), a = i.indexOf("all") !== -1, o = i.indexOf("lon") !== -1, s = i.indexOf("lat") !== -1, l = t.lonlat, u = [];
                function c(f) {
                    return f + "\xB0";
                }
                return a || o && s ? u.push("(" + c(l[1]) + ", " + c(l[0]) + ")") : o ? u.push(r.lon + c(l[0])) : s && u.push(r.lat + c(l[1])), (a || i.indexOf("text") !== -1) && wHt(t, e, u), u.join("<br>");
            }
            VUe.exports = {
                hoverPoints: SHt,
                getExtraText: UUe
            };
        });
        var GUe = ye((qyr, HUe)=>{
            "use strict";
            HUe.exports = function(t, r) {
                return t.lon = r.lon, t.lat = r.lat, t;
            };
        });
        var WUe = ye((Oyr, jUe)=>{
            "use strict";
            var MHt = Mr(), EHt = lu(), kHt = es().BADNUM;
            jUe.exports = function(t, r) {
                var n = t.cd, i = t.xaxis, a = t.yaxis, o = [], s = n[0].trace, l;
                if (!EHt.hasMarkers(s)) return [];
                if (r === !1) for(l = 0; l < n.length; l++)n[l].selected = 0;
                else for(l = 0; l < n.length; l++){
                    var u = n[l], c = u.lonlat;
                    if (c[0] !== kHt) {
                        var f = [
                            MHt.modHalf(c[0], 360),
                            c[1]
                        ], h = [
                            i.c2p(f),
                            a.c2p(f)
                        ];
                        r.contains(h, null, l, t) ? (o.push({
                            pointNumber: l,
                            lon: c[0],
                            lat: c[1]
                        }), u.selected = 1) : u.selected = 0;
                    }
                }
                return o;
            };
        });
        var YK = ye((ZK, XK)=>{
            (function(e, t) {
                typeof ZK == "object" && typeof XK != "undefined" ? XK.exports = t() : (e = e || self, e.mapboxgl = t());
            })(ZK, function() {
                "use strict";
                var e, t, r;
                function n(i, a) {
                    if (!e) e = a;
                    else if (!t) t = a;
                    else {
                        var o = "var sharedChunk = {}; (" + e + ")(sharedChunk); (" + t + ")(sharedChunk);", s = {};
                        e(s), r = a(s), typeof window != "undefined" && (r.workerUrl = window.URL.createObjectURL(new Blob([
                            o
                        ], {
                            type: "text/javascript"
                        })));
                    }
                }
                return n([
                    "exports"
                ], function(i) {
                    "use strict";
                    function a(m, y) {
                        return y = {
                            exports: {}
                        }, m(y, y.exports), y.exports;
                    }
                    var o = "1.13.4", s = l;
                    function l(m, y, I, U) {
                        this.cx = 3 * m, this.bx = 3 * (I - m) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * y, this.by = 3 * (U - y) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = m, this.p1y = U, this.p2x = I, this.p2y = U;
                    }
                    l.prototype.sampleCurveX = function(m) {
                        return ((this.ax * m + this.bx) * m + this.cx) * m;
                    }, l.prototype.sampleCurveY = function(m) {
                        return ((this.ay * m + this.by) * m + this.cy) * m;
                    }, l.prototype.sampleCurveDerivativeX = function(m) {
                        return (3 * this.ax * m + 2 * this.bx) * m + this.cx;
                    }, l.prototype.solveCurveX = function(m, y) {
                        typeof y == "undefined" && (y = 1e-6);
                        var I, U, J, ne, fe;
                        for(J = m, fe = 0; fe < 8; fe++){
                            if (ne = this.sampleCurveX(J) - m, Math.abs(ne) < y) return J;
                            var Fe = this.sampleCurveDerivativeX(J);
                            if (Math.abs(Fe) < 1e-6) break;
                            J = J - ne / Fe;
                        }
                        if (I = 0, U = 1, J = m, J < I) return I;
                        if (J > U) return U;
                        for(; I < U;){
                            if (ne = this.sampleCurveX(J), Math.abs(ne - m) < y) return J;
                            m > ne ? I = J : U = J, J = (U - I) * .5 + I;
                        }
                        return J;
                    }, l.prototype.solve = function(m, y) {
                        return this.sampleCurveY(this.solveCurveX(m, y));
                    };
                    var u = c;
                    function c(m, y) {
                        this.x = m, this.y = y;
                    }
                    c.prototype = {
                        clone: function() {
                            return new c(this.x, this.y);
                        },
                        add: function(m) {
                            return this.clone()._add(m);
                        },
                        sub: function(m) {
                            return this.clone()._sub(m);
                        },
                        multByPoint: function(m) {
                            return this.clone()._multByPoint(m);
                        },
                        divByPoint: function(m) {
                            return this.clone()._divByPoint(m);
                        },
                        mult: function(m) {
                            return this.clone()._mult(m);
                        },
                        div: function(m) {
                            return this.clone()._div(m);
                        },
                        rotate: function(m) {
                            return this.clone()._rotate(m);
                        },
                        rotateAround: function(m, y) {
                            return this.clone()._rotateAround(m, y);
                        },
                        matMult: function(m) {
                            return this.clone()._matMult(m);
                        },
                        unit: function() {
                            return this.clone()._unit();
                        },
                        perp: function() {
                            return this.clone()._perp();
                        },
                        round: function() {
                            return this.clone()._round();
                        },
                        mag: function() {
                            return Math.sqrt(this.x * this.x + this.y * this.y);
                        },
                        equals: function(m) {
                            return this.x === m.x && this.y === m.y;
                        },
                        dist: function(m) {
                            return Math.sqrt(this.distSqr(m));
                        },
                        distSqr: function(m) {
                            var y = m.x - this.x, I = m.y - this.y;
                            return y * y + I * I;
                        },
                        angle: function() {
                            return Math.atan2(this.y, this.x);
                        },
                        angleTo: function(m) {
                            return Math.atan2(this.y - m.y, this.x - m.x);
                        },
                        angleWith: function(m) {
                            return this.angleWithSep(m.x, m.y);
                        },
                        angleWithSep: function(m, y) {
                            return Math.atan2(this.x * y - this.y * m, this.x * m + this.y * y);
                        },
                        _matMult: function(m) {
                            var y = m[0] * this.x + m[1] * this.y, I = m[2] * this.x + m[3] * this.y;
                            return this.x = y, this.y = I, this;
                        },
                        _add: function(m) {
                            return this.x += m.x, this.y += m.y, this;
                        },
                        _sub: function(m) {
                            return this.x -= m.x, this.y -= m.y, this;
                        },
                        _mult: function(m) {
                            return this.x *= m, this.y *= m, this;
                        },
                        _div: function(m) {
                            return this.x /= m, this.y /= m, this;
                        },
                        _multByPoint: function(m) {
                            return this.x *= m.x, this.y *= m.y, this;
                        },
                        _divByPoint: function(m) {
                            return this.x /= m.x, this.y /= m.y, this;
                        },
                        _unit: function() {
                            return this._div(this.mag()), this;
                        },
                        _perp: function() {
                            var m = this.y;
                            return this.y = this.x, this.x = -m, this;
                        },
                        _rotate: function(m) {
                            var y = Math.cos(m), I = Math.sin(m), U = y * this.x - I * this.y, J = I * this.x + y * this.y;
                            return this.x = U, this.y = J, this;
                        },
                        _rotateAround: function(m, y) {
                            var I = Math.cos(m), U = Math.sin(m), J = y.x + I * (this.x - y.x) - U * (this.y - y.y), ne = y.y + U * (this.x - y.x) + I * (this.y - y.y);
                            return this.x = J, this.y = ne, this;
                        },
                        _round: function() {
                            return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                        }
                    }, c.convert = function(m) {
                        return m instanceof c ? m : Array.isArray(m) ? new c(m[0], m[1]) : m;
                    };
                    var f = typeof self != "undefined" ? self : {};
                    function h(m, y) {
                        if (Array.isArray(m)) {
                            if (!Array.isArray(y) || m.length !== y.length) return !1;
                            for(var I = 0; I < m.length; I++)if (!h(m[I], y[I])) return !1;
                            return !0;
                        }
                        if (typeof m == "object" && m !== null && y !== null) {
                            if (typeof y != "object") return !1;
                            var U = Object.keys(m);
                            if (U.length !== Object.keys(y).length) return !1;
                            for(var J in m)if (!h(m[J], y[J])) return !1;
                            return !0;
                        }
                        return m === y;
                    }
                    var d = Math.pow(2, 53) - 1;
                    function v(m) {
                        if (m <= 0) return 0;
                        if (m >= 1) return 1;
                        var y = m * m, I = y * m;
                        return 4 * (m < .5 ? I : 3 * (m - y) + I - .75);
                    }
                    function x(m, y, I, U) {
                        var J = new s(m, y, I, U);
                        return function(ne) {
                            return J.solve(ne);
                        };
                    }
                    var b = x(.25, .1, .25, 1);
                    function p(m, y, I) {
                        return Math.min(I, Math.max(y, m));
                    }
                    function E(m, y, I) {
                        var U = I - y, J = ((m - y) % U + U) % U + y;
                        return J === y ? I : J;
                    }
                    function k(m, y, I) {
                        if (!m.length) return I(null, []);
                        var U = m.length, J = new Array(m.length), ne = null;
                        m.forEach(function(fe, Fe) {
                            y(fe, function(Qe, st) {
                                Qe && (ne = Qe), J[Fe] = st, --U === 0 && I(ne, J);
                            });
                        });
                    }
                    function A(m) {
                        var y = [];
                        for(var I in m)y.push(m[I]);
                        return y;
                    }
                    function L(m, y) {
                        var I = [];
                        for(var U in m)U in y || I.push(U);
                        return I;
                    }
                    function _(m) {
                        for(var y = [], I = arguments.length - 1; I-- > 0;)y[I] = arguments[I + 1];
                        for(var U = 0, J = y; U < J.length; U += 1){
                            var ne = J[U];
                            for(var fe in ne)m[fe] = ne[fe];
                        }
                        return m;
                    }
                    function C(m, y) {
                        for(var I = {}, U = 0; U < y.length; U++){
                            var J = y[U];
                            J in m && (I[J] = m[J]);
                        }
                        return I;
                    }
                    var M = 1;
                    function g() {
                        return M++;
                    }
                    function P() {
                        function m(y) {
                            return y ? (y ^ Math.random() * 16 >> y / 4).toString(16) : ([
                                1e7
                            ] + -[
                                1e3
                            ] + -4000 + -8000 + -100000000000).replace(/[018]/g, m);
                        }
                        return m();
                    }
                    function T(m) {
                        return m <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(m) / Math.LN2));
                    }
                    function F(m) {
                        return m ? /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(m) : !1;
                    }
                    function q(m, y) {
                        m.forEach(function(I) {
                            y[I] && (y[I] = y[I].bind(y));
                        });
                    }
                    function V(m, y) {
                        return m.indexOf(y, m.length - y.length) !== -1;
                    }
                    function H(m, y, I) {
                        var U = {};
                        for(var J in m)U[J] = y.call(I || this, m[J], J, m);
                        return U;
                    }
                    function X(m, y, I) {
                        var U = {};
                        for(var J in m)y.call(I || this, m[J], J, m) && (U[J] = m[J]);
                        return U;
                    }
                    function G(m) {
                        return Array.isArray(m) ? m.map(G) : typeof m == "object" && m ? H(m, G) : m;
                    }
                    function N(m, y) {
                        for(var I = 0; I < m.length; I++)if (y.indexOf(m[I]) >= 0) return !0;
                        return !1;
                    }
                    var W = {};
                    function re(m) {
                        W[m] || (typeof console != "undefined" && console.warn(m), W[m] = !0);
                    }
                    function ae(m, y, I) {
                        return (I.y - m.y) * (y.x - m.x) > (y.y - m.y) * (I.x - m.x);
                    }
                    function _e(m) {
                        for(var y = 0, I = 0, U = m.length, J = U - 1, ne = void 0, fe = void 0; I < U; J = I++)ne = m[I], fe = m[J], y += (fe.x - ne.x) * (ne.y + fe.y);
                        return y;
                    }
                    function Me(m) {
                        var y = m[0], I = m[1], U = m[2];
                        return I += 90, I *= Math.PI / 180, U *= Math.PI / 180, {
                            x: y * Math.cos(I) * Math.sin(U),
                            y: y * Math.sin(I) * Math.sin(U),
                            z: y * Math.cos(U)
                        };
                    }
                    function ke() {
                        return typeof WorkerGlobalScope != "undefined" && typeof self != "undefined" && self instanceof WorkerGlobalScope;
                    }
                    function ge(m) {
                        var y = /(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, I = {};
                        if (m.replace(y, function(J, ne, fe, Fe) {
                            var Qe = fe || Fe;
                            return I[ne] = Qe ? Qe.toLowerCase() : !0, "";
                        }), I["max-age"]) {
                            var U = parseInt(I["max-age"], 10);
                            isNaN(U) ? delete I["max-age"] : I["max-age"] = U;
                        }
                        return I;
                    }
                    var ie = null;
                    function Te(m) {
                        if (ie == null) {
                            var y = m.navigator ? m.navigator.userAgent : null;
                            ie = !!m.safari || !!(y && (/\b(iPad|iPhone|iPod)\b/.test(y) || y.match("Safari") && !y.match("Chrome")));
                        }
                        return ie;
                    }
                    function Ee(m) {
                        try {
                            var y = f[m];
                            return y.setItem("_mapbox_test_", 1), y.removeItem("_mapbox_test_"), !0;
                        } catch (I) {
                            return !1;
                        }
                    }
                    function Ae(m) {
                        return f.btoa(encodeURIComponent(m).replace(/%([0-9A-F]{2})/g, function(y, I) {
                            return String.fromCharCode(+("0x" + I));
                        }));
                    }
                    function ze(m) {
                        return decodeURIComponent(f.atob(m).split("").map(function(y) {
                            return "%" + ("00" + y.charCodeAt(0).toString(16)).slice(-2);
                        }).join(""));
                    }
                    var Ce = f.performance && f.performance.now ? f.performance.now.bind(f.performance) : Date.now.bind(Date), me = f.requestAnimationFrame || f.mozRequestAnimationFrame || f.webkitRequestAnimationFrame || f.msRequestAnimationFrame, Re = f.cancelAnimationFrame || f.mozCancelAnimationFrame || f.webkitCancelAnimationFrame || f.msCancelAnimationFrame, ce, Ge, nt = {
                        now: Ce,
                        frame: function(y) {
                            var I = me(y);
                            return {
                                cancel: function() {
                                    return Re(I);
                                }
                            };
                        },
                        getImageData: function(y, I) {
                            I === void 0 && (I = 0);
                            var U = f.document.createElement("canvas"), J = U.getContext("2d");
                            if (!J) throw new Error("failed to create canvas 2d context");
                            return U.width = y.width, U.height = y.height, J.drawImage(y, 0, 0, y.width, y.height), J.getImageData(-I, -I, y.width + 2 * I, y.height + 2 * I);
                        },
                        resolveURL: function(y) {
                            return ce || (ce = f.document.createElement("a")), ce.href = y, ce.href;
                        },
                        hardwareConcurrency: f.navigator && f.navigator.hardwareConcurrency || 4,
                        get devicePixelRatio () {
                            return f.devicePixelRatio;
                        },
                        get prefersReducedMotion () {
                            return f.matchMedia ? (Ge == null && (Ge = f.matchMedia("(prefers-reduced-motion: reduce)")), Ge.matches) : !1;
                        }
                    }, ct = {
                        API_URL: "https://api.mapbox.com",
                        get EVENTS_URL () {
                            return this.API_URL ? this.API_URL.indexOf("https://api.mapbox.cn") === 0 ? "https://events.mapbox.cn/events/v2" : this.API_URL.indexOf("https://api.mapbox.com") === 0 ? "https://events.mapbox.com/events/v2" : null : null;
                        },
                        FEEDBACK_URL: "https://apps.mapbox.com/feedback",
                        REQUIRE_ACCESS_TOKEN: !0,
                        ACCESS_TOKEN: null,
                        MAX_PARALLEL_IMAGE_REQUESTS: 16
                    }, qt = {
                        supported: !1,
                        testSupport: Ct
                    }, rt, ot = !1, Rt, kt = !1;
                    f.document && (Rt = f.document.createElement("img"), Rt.onload = function() {
                        rt && Yt(rt), rt = null, kt = !0;
                    }, Rt.onerror = function() {
                        ot = !0, rt = null;
                    }, Rt.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
                    function Ct(m) {
                        ot || !Rt || (kt ? Yt(m) : rt = m);
                    }
                    function Yt(m) {
                        var y = m.createTexture();
                        m.bindTexture(m.TEXTURE_2D, y);
                        try {
                            if (m.texImage2D(m.TEXTURE_2D, 0, m.RGBA, m.RGBA, m.UNSIGNED_BYTE, Rt), m.isContextLost()) return;
                            qt.supported = !0;
                        } catch (I) {}
                        m.deleteTexture(y), ot = !0;
                    }
                    var xr = "01";
                    function er() {
                        for(var m = "1", y = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ", I = "", U = 0; U < 10; U++)I += y[Math.floor(Math.random() * 62)];
                        var J = 43200000, ne = [
                            m,
                            xr,
                            I
                        ].join(""), fe = Date.now() + J;
                        return {
                            token: ne,
                            tokenExpiresAt: fe
                        };
                    }
                    var Ke = function(y, I) {
                        this._transformRequestFn = y, this._customAccessToken = I, this._createSkuToken();
                    };
                    Ke.prototype._createSkuToken = function() {
                        var y = er();
                        this._skuToken = y.token, this._skuTokenExpiresAt = y.tokenExpiresAt;
                    }, Ke.prototype._isSkuTokenExpired = function() {
                        return Date.now() > this._skuTokenExpiresAt;
                    }, Ke.prototype.transformRequest = function(y, I) {
                        return this._transformRequestFn ? this._transformRequestFn(y, I) || {
                            url: y
                        } : {
                            url: y
                        };
                    }, Ke.prototype.normalizeStyleURL = function(y, I) {
                        if (!xt(y)) return y;
                        var U = Ht(y);
                        return U.path = "/styles/v1" + U.path, this._makeAPIURL(U, this._customAccessToken || I);
                    }, Ke.prototype.normalizeGlyphsURL = function(y, I) {
                        if (!xt(y)) return y;
                        var U = Ht(y);
                        return U.path = "/fonts/v1" + U.path, this._makeAPIURL(U, this._customAccessToken || I);
                    }, Ke.prototype.normalizeSourceURL = function(y, I) {
                        if (!xt(y)) return y;
                        var U = Ht(y);
                        return U.path = "/v4/" + U.authority + ".json", U.params.push("secure"), this._makeAPIURL(U, this._customAccessToken || I);
                    }, Ke.prototype.normalizeSpriteURL = function(y, I, U, J) {
                        var ne = Ht(y);
                        return xt(y) ? (ne.path = "/styles/v1" + ne.path + "/sprite" + I + U, this._makeAPIURL(ne, this._customAccessToken || J)) : (ne.path += "" + I + U, $t(ne));
                    }, Ke.prototype.normalizeTileURL = function(y, I) {
                        if (this._isSkuTokenExpired() && this._createSkuToken(), y && !xt(y)) return y;
                        var U = Ht(y), J = /(\.(png|jpg)\d*)(?=$)/, ne = /^.+\/v4\//, fe = nt.devicePixelRatio >= 2 || I === 512 ? "@2x" : "", Fe = qt.supported ? ".webp" : "$1";
                        U.path = U.path.replace(J, "" + fe + Fe), U.path = U.path.replace(ne, "/"), U.path = "/v4" + U.path;
                        var Qe = this._customAccessToken || Et(U.params) || ct.ACCESS_TOKEN;
                        return ct.REQUIRE_ACCESS_TOKEN && Qe && this._skuToken && U.params.push("sku=" + this._skuToken), this._makeAPIURL(U, Qe);
                    }, Ke.prototype.canonicalizeTileURL = function(y, I) {
                        var U = "/v4/", J = /\.[\w]+$/, ne = Ht(y);
                        if (!ne.path.match(/(^\/v4\/)/) || !ne.path.match(J)) return y;
                        var fe = "mapbox://tiles/";
                        fe += ne.path.replace(U, "");
                        var Fe = ne.params;
                        return I && (Fe = Fe.filter(function(Qe) {
                            return !Qe.match(/^access_token=/);
                        })), Fe.length && (fe += "?" + Fe.join("&")), fe;
                    }, Ke.prototype.canonicalizeTileset = function(y, I) {
                        for(var U = I ? xt(I) : !1, J = [], ne = 0, fe = y.tiles || []; ne < fe.length; ne += 1){
                            var Fe = fe[ne];
                            Lt(Fe) ? J.push(this.canonicalizeTileURL(Fe, U)) : J.push(Fe);
                        }
                        return J;
                    }, Ke.prototype._makeAPIURL = function(y, I) {
                        var U = "See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes", J = Ht(ct.API_URL);
                        if (y.protocol = J.protocol, y.authority = J.authority, y.protocol === "http") {
                            var ne = y.params.indexOf("secure");
                            ne >= 0 && y.params.splice(ne, 1);
                        }
                        if (J.path !== "/" && (y.path = "" + J.path + y.path), !ct.REQUIRE_ACCESS_TOKEN) return $t(y);
                        if (I = I || ct.ACCESS_TOKEN, !I) throw new Error("An API access token is required to use Mapbox GL. " + U);
                        if (I[0] === "s") throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). " + U);
                        return y.params = y.params.filter(function(fe) {
                            return fe.indexOf("access_token") === -1;
                        }), y.params.push("access_token=" + I), $t(y);
                    };
                    function xt(m) {
                        return m.indexOf("mapbox:") === 0;
                    }
                    var bt = /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
                    function Lt(m) {
                        return bt.test(m);
                    }
                    function St(m) {
                        return m.indexOf("sku=") > 0 && Lt(m);
                    }
                    function Et(m) {
                        for(var y = 0, I = m; y < I.length; y += 1){
                            var U = I[y], J = U.match(/^access_token=(.*)$/);
                            if (J) return J[1];
                        }
                        return null;
                    }
                    var dt = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
                    function Ht(m) {
                        var y = m.match(dt);
                        if (!y) throw new Error("Unable to parse URL object");
                        return {
                            protocol: y[1],
                            authority: y[2],
                            path: y[3] || "/",
                            params: y[4] ? y[4].split("&") : []
                        };
                    }
                    function $t(m) {
                        var y = m.params.length ? "?" + m.params.join("&") : "";
                        return m.protocol + "://" + m.authority + m.path + y;
                    }
                    var fr = "mapbox.eventData";
                    function _r(m) {
                        if (!m) return null;
                        var y = m.split(".");
                        if (!y || y.length !== 3) return null;
                        try {
                            var I = JSON.parse(ze(y[1]));
                            return I;
                        } catch (U) {
                            return null;
                        }
                    }
                    var Br = function(y) {
                        this.type = y, this.anonId = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
                    };
                    Br.prototype.getStorageKey = function(y) {
                        var I = _r(ct.ACCESS_TOKEN), U = "";
                        return I && I.u ? U = Ae(I.u) : U = ct.ACCESS_TOKEN || "", y ? fr + "." + y + ":" + U : fr + ":" + U;
                    }, Br.prototype.fetchEventData = function() {
                        var y = Ee("localStorage"), I = this.getStorageKey(), U = this.getStorageKey("uuid");
                        if (y) try {
                            var J = f.localStorage.getItem(I);
                            J && (this.eventData = JSON.parse(J));
                            var ne = f.localStorage.getItem(U);
                            ne && (this.anonId = ne);
                        } catch (fe) {
                            re("Unable to read from LocalStorage");
                        }
                    }, Br.prototype.saveEventData = function() {
                        var y = Ee("localStorage"), I = this.getStorageKey(), U = this.getStorageKey("uuid");
                        if (y) try {
                            f.localStorage.setItem(U, this.anonId), Object.keys(this.eventData).length >= 1 && f.localStorage.setItem(I, JSON.stringify(this.eventData));
                        } catch (J) {
                            re("Unable to write to LocalStorage");
                        }
                    }, Br.prototype.processRequests = function(y) {}, Br.prototype.postEvent = function(y, I, U, J) {
                        var ne = this;
                        if (ct.EVENTS_URL) {
                            var fe = Ht(ct.EVENTS_URL);
                            fe.params.push("access_token=" + (J || ct.ACCESS_TOKEN || ""));
                            var Fe = {
                                event: this.type,
                                created: new Date(y).toISOString(),
                                sdkIdentifier: "mapbox-gl-js",
                                sdkVersion: o,
                                skuId: xr,
                                userId: this.anonId
                            }, Qe = I ? _(Fe, I) : Fe, st = {
                                url: $t(fe),
                                headers: {
                                    "Content-Type": "text/plain"
                                },
                                body: JSON.stringify([
                                    Qe
                                ])
                            };
                            this.pendingRequest = Vr(st, function(mt) {
                                ne.pendingRequest = null, U(mt), ne.saveEventData(), ne.processRequests(J);
                            });
                        }
                    }, Br.prototype.queueRequest = function(y, I) {
                        this.queue.push(y), this.processRequests(I);
                    };
                    var Or = function(m) {
                        function y() {
                            m.call(this, "map.load"), this.success = {}, this.skuToken = "";
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.postMapLoadEvent = function(U, J, ne, fe) {
                            this.skuToken = ne, (ct.EVENTS_URL && fe || ct.ACCESS_TOKEN && Array.isArray(U) && U.some(function(Fe) {
                                return xt(Fe) || Lt(Fe);
                            })) && this.queueRequest({
                                id: J,
                                timestamp: Date.now()
                            }, fe);
                        }, y.prototype.processRequests = function(U) {
                            var J = this;
                            if (!(this.pendingRequest || this.queue.length === 0)) {
                                var ne = this.queue.shift(), fe = ne.id, Fe = ne.timestamp;
                                fe && this.success[fe] || (this.anonId || this.fetchEventData(), F(this.anonId) || (this.anonId = P()), this.postEvent(Fe, {
                                    skuToken: this.skuToken
                                }, function(Qe) {
                                    Qe || fe && (J.success[fe] = !0);
                                }, U));
                            }
                        }, y;
                    }(Br), Nr = function(m) {
                        function y(I) {
                            m.call(this, "appUserTurnstile"), this._customAccessToken = I;
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.postTurnstileEvent = function(U, J) {
                            ct.EVENTS_URL && ct.ACCESS_TOKEN && Array.isArray(U) && U.some(function(ne) {
                                return xt(ne) || Lt(ne);
                            }) && this.queueRequest(Date.now(), J);
                        }, y.prototype.processRequests = function(U) {
                            var J = this;
                            if (!(this.pendingRequest || this.queue.length === 0)) {
                                (!this.anonId || !this.eventData.lastSuccess || !this.eventData.tokenU) && this.fetchEventData();
                                var ne = _r(ct.ACCESS_TOKEN), fe = ne ? ne.u : ct.ACCESS_TOKEN, Fe = fe !== this.eventData.tokenU;
                                F(this.anonId) || (this.anonId = P(), Fe = !0);
                                var Qe = this.queue.shift();
                                if (this.eventData.lastSuccess) {
                                    var st = new Date(this.eventData.lastSuccess), mt = new Date(Qe), Xt = (Qe - this.eventData.lastSuccess) / 86400000;
                                    Fe = Fe || Xt >= 1 || Xt < -1 || st.getDate() !== mt.getDate();
                                } else Fe = !0;
                                if (!Fe) return this.processRequests();
                                this.postEvent(Qe, {
                                    "enabled.telemetry": !1
                                }, function(ur) {
                                    ur || (J.eventData.lastSuccess = Qe, J.eventData.tokenU = fe);
                                }, U);
                            }
                        }, y;
                    }(Br), ut = new Nr, Ne = ut.postTurnstileEvent.bind(ut), Ye = new Or, Ve = Ye.postMapLoadEvent.bind(Ye), Xe = "mapbox-tiles", ht = 500, Le = 50, xe = 420000, Se;
                    function lt() {
                        f.caches && !Se && (Se = f.caches.open(Xe));
                    }
                    var Gt;
                    function Vt(m, y) {
                        if (Gt === void 0) try {
                            new Response(new ReadableStream), Gt = !0;
                        } catch (I) {
                            Gt = !1;
                        }
                        Gt ? y(m.body) : m.blob().then(y);
                    }
                    function ar(m, y, I) {
                        if (lt(), !!Se) {
                            var U = {
                                status: y.status,
                                statusText: y.statusText,
                                headers: new f.Headers
                            };
                            y.headers.forEach(function(fe, Fe) {
                                return U.headers.set(Fe, fe);
                            });
                            var J = ge(y.headers.get("Cache-Control") || "");
                            if (!J["no-store"]) {
                                J["max-age"] && U.headers.set("Expires", new Date(I + J["max-age"] * 1e3).toUTCString());
                                var ne = new Date(U.headers.get("Expires")).getTime() - I;
                                ne < xe || Vt(y, function(fe) {
                                    var Fe = new f.Response(fe, U);
                                    lt(), Se && Se.then(function(Qe) {
                                        return Qe.put(Qr(m.url), Fe);
                                    }).catch(function(Qe) {
                                        return re(Qe.message);
                                    });
                                });
                            }
                        }
                    }
                    function Qr(m) {
                        var y = m.indexOf("?");
                        return y < 0 ? m : m.slice(0, y);
                    }
                    function ai(m, y) {
                        if (lt(), !Se) return y(null);
                        var I = Qr(m.url);
                        Se.then(function(U) {
                            U.match(I).then(function(J) {
                                var ne = jr(J);
                                U.delete(I), ne && U.put(I, J.clone()), y(null, J, ne);
                            }).catch(y);
                        }).catch(y);
                    }
                    function jr(m) {
                        if (!m) return !1;
                        var y = new Date(m.headers.get("Expires") || 0), I = ge(m.headers.get("Cache-Control") || "");
                        return y > Date.now() && !I["no-cache"];
                    }
                    var ri = 1 / 0;
                    function bi(m) {
                        ri++, ri > Le && (m.getActor().send("enforceCacheSizeLimit", ht), ri = 0);
                    }
                    function nn(m) {
                        lt(), Se && Se.then(function(y) {
                            y.keys().then(function(I) {
                                for(var U = 0; U < I.length - m; U++)y.delete(I[U]);
                            });
                        });
                    }
                    function Wi(m) {
                        var y = f.caches.delete(Xe);
                        m && y.catch(m).then(function() {
                            return m();
                        });
                    }
                    function Ni(m, y) {
                        ht = m, Le = y;
                    }
                    var _n;
                    function $i() {
                        return _n == null && (_n = f.OffscreenCanvas && new f.OffscreenCanvas(1, 1).getContext("2d") && typeof f.createImageBitmap == "function"), _n;
                    }
                    var zn = {
                        Unknown: "Unknown",
                        Style: "Style",
                        Source: "Source",
                        Tile: "Tile",
                        Glyphs: "Glyphs",
                        SpriteImage: "SpriteImage",
                        SpriteJSON: "SpriteJSON",
                        Image: "Image"
                    };
                    typeof Object.freeze == "function" && Object.freeze(zn);
                    var Wn = function(m) {
                        function y(I, U, J) {
                            U === 401 && Lt(J) && (I += ": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"), m.call(this, I), this.status = U, this.url = J, this.name = this.constructor.name, this.message = I;
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.toString = function() {
                            return this.name + ": " + this.message + " (" + this.status + "): " + this.url;
                        }, y;
                    }(Error), It = ke() ? function() {
                        return self.worker && self.worker.referrer;
                    } : function() {
                        return (f.location.protocol === "blob:" ? f.parent : f).location.href;
                    }, ft = function(m) {
                        return /^file:/.test(m) || /^file:/.test(It()) && !/^\w+:/.test(m);
                    };
                    function jt(m, y) {
                        var I = new f.AbortController, U = new f.Request(m.url, {
                            method: m.method || "GET",
                            body: m.body,
                            credentials: m.credentials,
                            headers: m.headers,
                            referrer: It(),
                            signal: I.signal
                        }), J = !1, ne = !1, fe = St(U.url);
                        m.type === "json" && U.headers.set("Accept", "application/json");
                        var Fe = function(st, mt, Xt) {
                            if (!ne) {
                                if (st && st.message !== "SecurityError" && re(st), mt && Xt) return Qe(mt);
                                var ur = Date.now();
                                f.fetch(U).then(function(nr) {
                                    if (nr.ok) {
                                        var Lr = fe ? nr.clone() : null;
                                        return Qe(nr, Lr, ur);
                                    } else return y(new Wn(nr.statusText, nr.status, m.url));
                                }).catch(function(nr) {
                                    nr.code !== 20 && y(new Error(nr.message));
                                });
                            }
                        }, Qe = function(st, mt, Xt) {
                            (m.type === "arrayBuffer" ? st.arrayBuffer() : m.type === "json" ? st.json() : st.text()).then(function(ur) {
                                ne || (mt && Xt && ar(U, mt, Xt), J = !0, y(null, ur, st.headers.get("Cache-Control"), st.headers.get("Expires")));
                            }).catch(function(ur) {
                                ne || y(new Error(ur.message));
                            });
                        };
                        return fe ? ai(U, Fe) : Fe(null, null), {
                            cancel: function() {
                                ne = !0, J || I.abort();
                            }
                        };
                    }
                    function Zt(m, y) {
                        var I = new f.XMLHttpRequest;
                        I.open(m.method || "GET", m.url, !0), m.type === "arrayBuffer" && (I.responseType = "arraybuffer");
                        for(var U in m.headers)I.setRequestHeader(U, m.headers[U]);
                        return m.type === "json" && (I.responseType = "text", I.setRequestHeader("Accept", "application/json")), I.withCredentials = m.credentials === "include", I.onerror = function() {
                            y(new Error(I.statusText));
                        }, I.onload = function() {
                            if ((I.status >= 200 && I.status < 300 || I.status === 0) && I.response !== null) {
                                var J = I.response;
                                if (m.type === "json") try {
                                    J = JSON.parse(I.response);
                                } catch (ne) {
                                    return y(ne);
                                }
                                y(null, J, I.getResponseHeader("Cache-Control"), I.getResponseHeader("Expires"));
                            } else y(new Wn(I.statusText, I.status, m.url));
                        }, I.send(m.body), {
                            cancel: function() {
                                return I.abort();
                            }
                        };
                    }
                    var yr = function(m, y) {
                        if (!ft(m.url)) {
                            if (f.fetch && f.Request && f.AbortController && f.Request.prototype.hasOwnProperty("signal")) return jt(m, y);
                            if (ke() && self.worker && self.worker.actor) {
                                var I = !0;
                                return self.worker.actor.send("getResource", m, y, void 0, I);
                            }
                        }
                        return Zt(m, y);
                    }, Fr = function(m, y) {
                        return yr(_(m, {
                            type: "json"
                        }), y);
                    }, Zr = function(m, y) {
                        return yr(_(m, {
                            type: "arrayBuffer"
                        }), y);
                    }, Vr = function(m, y) {
                        return yr(_(m, {
                            method: "POST"
                        }), y);
                    };
                    function gi(m) {
                        var y = f.document.createElement("a");
                        return y.href = m, y.protocol === f.document.location.protocol && y.host === f.document.location.host;
                    }
                    var Si = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
                    function Mi(m, y, I, U) {
                        var J = new f.Image, ne = f.URL;
                        J.onload = function() {
                            y(null, J), ne.revokeObjectURL(J.src), J.onload = null, f.requestAnimationFrame(function() {
                                J.src = Si;
                            });
                        }, J.onerror = function() {
                            return y(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                        };
                        var fe = new f.Blob([
                            new Uint8Array(m)
                        ], {
                            type: "image/png"
                        });
                        J.cacheControl = I, J.expires = U, J.src = m.byteLength ? ne.createObjectURL(fe) : Si;
                    }
                    function Pi(m, y) {
                        var I = new f.Blob([
                            new Uint8Array(m)
                        ], {
                            type: "image/png"
                        });
                        f.createImageBitmap(I).then(function(U) {
                            y(null, U);
                        }).catch(function(U) {
                            y(new Error("Could not load image because of " + U.message + ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                        });
                    }
                    var Gi, Ki, ka = function() {
                        Gi = [], Ki = 0;
                    };
                    ka();
                    var jn = function(m, y) {
                        if (qt.supported && (m.headers || (m.headers = {}), m.headers.accept = "image/webp,*/*"), Ki >= ct.MAX_PARALLEL_IMAGE_REQUESTS) {
                            var I = {
                                requestParameters: m,
                                callback: y,
                                cancelled: !1,
                                cancel: function() {
                                    this.cancelled = !0;
                                }
                            };
                            return Gi.push(I), I;
                        }
                        Ki++;
                        var U = !1, J = function() {
                            if (!U) for(U = !0, Ki--; Gi.length && Ki < ct.MAX_PARALLEL_IMAGE_REQUESTS;){
                                var fe = Gi.shift(), Fe = fe.requestParameters, Qe = fe.callback, st = fe.cancelled;
                                st || (fe.cancel = jn(Fe, Qe).cancel);
                            }
                        }, ne = Zr(m, function(fe, Fe, Qe, st) {
                            J(), fe ? y(fe) : Fe && ($i() ? Pi(Fe, y) : Mi(Fe, y, Qe, st));
                        });
                        return {
                            cancel: function() {
                                ne.cancel(), J();
                            }
                        };
                    }, la = function(m, y) {
                        var I = f.document.createElement("video");
                        I.muted = !0, I.onloadstart = function() {
                            y(null, I);
                        };
                        for(var U = 0; U < m.length; U++){
                            var J = f.document.createElement("source");
                            gi(m[U]) || (I.crossOrigin = "Anonymous"), J.src = m[U], I.appendChild(J);
                        }
                        return {
                            cancel: function() {}
                        };
                    };
                    function Fa(m, y, I) {
                        var U = I[m] && I[m].indexOf(y) !== -1;
                        U || (I[m] = I[m] || [], I[m].push(y));
                    }
                    function Ra(m, y, I) {
                        if (I && I[m]) {
                            var U = I[m].indexOf(y);
                            U !== -1 && I[m].splice(U, 1);
                        }
                    }
                    var jo = function(y, I) {
                        I === void 0 && (I = {}), _(this, I), this.type = y;
                    }, oa = function(m) {
                        function y(I, U) {
                            U === void 0 && (U = {}), m.call(this, "error", _({
                                error: I
                            }, U));
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y;
                    }(jo), Sn = function() {};
                    Sn.prototype.on = function(y, I) {
                        return this._listeners = this._listeners || {}, Fa(y, I, this._listeners), this;
                    }, Sn.prototype.off = function(y, I) {
                        return Ra(y, I, this._listeners), Ra(y, I, this._oneTimeListeners), this;
                    }, Sn.prototype.once = function(y, I) {
                        return this._oneTimeListeners = this._oneTimeListeners || {}, Fa(y, I, this._oneTimeListeners), this;
                    }, Sn.prototype.fire = function(y, I) {
                        typeof y == "string" && (y = new jo(y, I || {}));
                        var U = y.type;
                        if (this.listens(U)) {
                            y.target = this;
                            for(var J = this._listeners && this._listeners[U] ? this._listeners[U].slice() : [], ne = 0, fe = J; ne < fe.length; ne += 1){
                                var Fe = fe[ne];
                                Fe.call(this, y);
                            }
                            for(var Qe = this._oneTimeListeners && this._oneTimeListeners[U] ? this._oneTimeListeners[U].slice() : [], st = 0, mt = Qe; st < mt.length; st += 1){
                                var Xt = mt[st];
                                Ra(U, Xt, this._oneTimeListeners), Xt.call(this, y);
                            }
                            var ur = this._eventedParent;
                            ur && (_(y, typeof this._eventedParentData == "function" ? this._eventedParentData() : this._eventedParentData), ur.fire(y));
                        } else y instanceof oa && console.error(y.error);
                        return this;
                    }, Sn.prototype.listens = function(y) {
                        return this._listeners && this._listeners[y] && this._listeners[y].length > 0 || this._oneTimeListeners && this._oneTimeListeners[y] && this._oneTimeListeners[y].length > 0 || this._eventedParent && this._eventedParent.listens(y);
                    }, Sn.prototype.setEventedParent = function(y, I) {
                        return this._eventedParent = y, this._eventedParentData = I, this;
                    };
                    var Ha = 8, oo = {
                        version: {
                            required: !0,
                            type: "enum",
                            values: [
                                8
                            ]
                        },
                        name: {
                            type: "string"
                        },
                        metadata: {
                            type: "*"
                        },
                        center: {
                            type: "array",
                            value: "number"
                        },
                        zoom: {
                            type: "number"
                        },
                        bearing: {
                            type: "number",
                            default: 0,
                            period: 360,
                            units: "degrees"
                        },
                        pitch: {
                            type: "number",
                            default: 0,
                            units: "degrees"
                        },
                        light: {
                            type: "light"
                        },
                        sources: {
                            required: !0,
                            type: "sources"
                        },
                        sprite: {
                            type: "string"
                        },
                        glyphs: {
                            type: "string"
                        },
                        transition: {
                            type: "transition"
                        },
                        layers: {
                            required: !0,
                            type: "array",
                            value: "layer"
                        }
                    }, xn = {
                        "*": {
                            type: "source"
                        }
                    }, _t = [
                        "source_vector",
                        "source_raster",
                        "source_raster_dem",
                        "source_geojson",
                        "source_video",
                        "source_image"
                    ], br = {
                        type: {
                            required: !0,
                            type: "enum",
                            values: {
                                vector: {}
                            }
                        },
                        url: {
                            type: "string"
                        },
                        tiles: {
                            type: "array",
                            value: "string"
                        },
                        bounds: {
                            type: "array",
                            value: "number",
                            length: 4,
                            default: [
                                -180,
                                -85.051129,
                                180,
                                85.051129
                            ]
                        },
                        scheme: {
                            type: "enum",
                            values: {
                                xyz: {},
                                tms: {}
                            },
                            default: "xyz"
                        },
                        minzoom: {
                            type: "number",
                            default: 0
                        },
                        maxzoom: {
                            type: "number",
                            default: 22
                        },
                        attribution: {
                            type: "string"
                        },
                        promoteId: {
                            type: "promoteId"
                        },
                        volatile: {
                            type: "boolean",
                            default: !1
                        },
                        "*": {
                            type: "*"
                        }
                    }, Hr = {
                        type: {
                            required: !0,
                            type: "enum",
                            values: {
                                raster: {}
                            }
                        },
                        url: {
                            type: "string"
                        },
                        tiles: {
                            type: "array",
                            value: "string"
                        },
                        bounds: {
                            type: "array",
                            value: "number",
                            length: 4,
                            default: [
                                -180,
                                -85.051129,
                                180,
                                85.051129
                            ]
                        },
                        minzoom: {
                            type: "number",
                            default: 0
                        },
                        maxzoom: {
                            type: "number",
                            default: 22
                        },
                        tileSize: {
                            type: "number",
                            default: 512,
                            units: "pixels"
                        },
                        scheme: {
                            type: "enum",
                            values: {
                                xyz: {},
                                tms: {}
                            },
                            default: "xyz"
                        },
                        attribution: {
                            type: "string"
                        },
                        volatile: {
                            type: "boolean",
                            default: !1
                        },
                        "*": {
                            type: "*"
                        }
                    }, ti = {
                        type: {
                            required: !0,
                            type: "enum",
                            values: {
                                "raster-dem": {}
                            }
                        },
                        url: {
                            type: "string"
                        },
                        tiles: {
                            type: "array",
                            value: "string"
                        },
                        bounds: {
                            type: "array",
                            value: "number",
                            length: 4,
                            default: [
                                -180,
                                -85.051129,
                                180,
                                85.051129
                            ]
                        },
                        minzoom: {
                            type: "number",
                            default: 0
                        },
                        maxzoom: {
                            type: "number",
                            default: 22
                        },
                        tileSize: {
                            type: "number",
                            default: 512,
                            units: "pixels"
                        },
                        attribution: {
                            type: "string"
                        },
                        encoding: {
                            type: "enum",
                            values: {
                                terrarium: {},
                                mapbox: {}
                            },
                            default: "mapbox"
                        },
                        volatile: {
                            type: "boolean",
                            default: !1
                        },
                        "*": {
                            type: "*"
                        }
                    }, zi = {
                        type: {
                            required: !0,
                            type: "enum",
                            values: {
                                geojson: {}
                            }
                        },
                        data: {
                            type: "*"
                        },
                        maxzoom: {
                            type: "number",
                            default: 18
                        },
                        attribution: {
                            type: "string"
                        },
                        buffer: {
                            type: "number",
                            default: 128,
                            maximum: 512,
                            minimum: 0
                        },
                        filter: {
                            type: "*"
                        },
                        tolerance: {
                            type: "number",
                            default: .375
                        },
                        cluster: {
                            type: "boolean",
                            default: !1
                        },
                        clusterRadius: {
                            type: "number",
                            default: 50,
                            minimum: 0
                        },
                        clusterMaxZoom: {
                            type: "number"
                        },
                        clusterMinPoints: {
                            type: "number"
                        },
                        clusterProperties: {
                            type: "*"
                        },
                        lineMetrics: {
                            type: "boolean",
                            default: !1
                        },
                        generateId: {
                            type: "boolean",
                            default: !1
                        },
                        promoteId: {
                            type: "promoteId"
                        }
                    }, Yi = {
                        type: {
                            required: !0,
                            type: "enum",
                            values: {
                                video: {}
                            }
                        },
                        urls: {
                            required: !0,
                            type: "array",
                            value: "string"
                        },
                        coordinates: {
                            required: !0,
                            type: "array",
                            length: 4,
                            value: {
                                type: "array",
                                length: 2,
                                value: "number"
                            }
                        }
                    }, an = {
                        type: {
                            required: !0,
                            type: "enum",
                            values: {
                                image: {}
                            }
                        },
                        url: {
                            required: !0,
                            type: "string"
                        },
                        coordinates: {
                            required: !0,
                            type: "array",
                            length: 4,
                            value: {
                                type: "array",
                                length: 2,
                                value: "number"
                            }
                        }
                    }, hi = {
                        id: {
                            type: "string",
                            required: !0
                        },
                        type: {
                            type: "enum",
                            values: {
                                fill: {},
                                line: {},
                                symbol: {},
                                circle: {},
                                heatmap: {},
                                "fill-extrusion": {},
                                raster: {},
                                hillshade: {},
                                background: {}
                            },
                            required: !0
                        },
                        metadata: {
                            type: "*"
                        },
                        source: {
                            type: "string"
                        },
                        "source-layer": {
                            type: "string"
                        },
                        minzoom: {
                            type: "number",
                            minimum: 0,
                            maximum: 24
                        },
                        maxzoom: {
                            type: "number",
                            minimum: 0,
                            maximum: 24
                        },
                        filter: {
                            type: "filter"
                        },
                        layout: {
                            type: "layout"
                        },
                        paint: {
                            type: "paint"
                        }
                    }, Ji = [
                        "layout_fill",
                        "layout_line",
                        "layout_circle",
                        "layout_heatmap",
                        "layout_fill-extrusion",
                        "layout_symbol",
                        "layout_raster",
                        "layout_hillshade",
                        "layout_background"
                    ], ua = {
                        visibility: {
                            type: "enum",
                            values: {
                                visible: {},
                                none: {}
                            },
                            default: "visible",
                            "property-type": "constant"
                        }
                    }, Fn = {
                        "fill-sort-key": {
                            type: "number",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        visibility: {
                            type: "enum",
                            values: {
                                visible: {},
                                none: {}
                            },
                            default: "visible",
                            "property-type": "constant"
                        }
                    }, Sa = {
                        "circle-sort-key": {
                            type: "number",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        visibility: {
                            type: "enum",
                            values: {
                                visible: {},
                                none: {}
                            },
                            default: "visible",
                            "property-type": "constant"
                        }
                    }, go = {
                        visibility: {
                            type: "enum",
                            values: {
                                visible: {},
                                none: {}
                            },
                            default: "visible",
                            "property-type": "constant"
                        }
                    }, Oo = {
                        "line-cap": {
                            type: "enum",
                            values: {
                                butt: {},
                                round: {},
                                square: {}
                            },
                            default: "butt",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "line-join": {
                            type: "enum",
                            values: {
                                bevel: {},
                                round: {},
                                miter: {}
                            },
                            default: "miter",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "line-miter-limit": {
                            type: "number",
                            default: 2,
                            requires: [
                                {
                                    "line-join": "miter"
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "line-round-limit": {
                            type: "number",
                            default: 1.05,
                            requires: [
                                {
                                    "line-join": "round"
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "line-sort-key": {
                            type: "number",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        visibility: {
                            type: "enum",
                            values: {
                                visible: {},
                                none: {}
                            },
                            default: "visible",
                            "property-type": "constant"
                        }
                    }, ho = {
                        "symbol-placement": {
                            type: "enum",
                            values: {
                                point: {},
                                line: {},
                                "line-center": {}
                            },
                            default: "point",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "symbol-spacing": {
                            type: "number",
                            default: 250,
                            minimum: 1,
                            units: "pixels",
                            requires: [
                                {
                                    "symbol-placement": "line"
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "symbol-avoid-edges": {
                            type: "boolean",
                            default: !1,
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "symbol-sort-key": {
                            type: "number",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "symbol-z-order": {
                            type: "enum",
                            values: {
                                auto: {},
                                "viewport-y": {},
                                source: {}
                            },
                            default: "auto",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "icon-allow-overlap": {
                            type: "boolean",
                            default: !1,
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "icon-ignore-placement": {
                            type: "boolean",
                            default: !1,
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "icon-optional": {
                            type: "boolean",
                            default: !1,
                            requires: [
                                "icon-image",
                                "text-field"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "icon-rotation-alignment": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {},
                                auto: {}
                            },
                            default: "auto",
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "icon-size": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            units: "factor of the original icon size",
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "icon-text-fit": {
                            type: "enum",
                            values: {
                                none: {},
                                width: {},
                                height: {},
                                both: {}
                            },
                            default: "none",
                            requires: [
                                "icon-image",
                                "text-field"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "icon-text-fit-padding": {
                            type: "array",
                            value: "number",
                            length: 4,
                            default: [
                                0,
                                0,
                                0,
                                0
                            ],
                            units: "pixels",
                            requires: [
                                "icon-image",
                                "text-field",
                                {
                                    "icon-text-fit": [
                                        "both",
                                        "width",
                                        "height"
                                    ]
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "icon-image": {
                            type: "resolvedImage",
                            tokens: !0,
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "icon-rotate": {
                            type: "number",
                            default: 0,
                            period: 360,
                            units: "degrees",
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "icon-padding": {
                            type: "number",
                            default: 2,
                            minimum: 0,
                            units: "pixels",
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "icon-keep-upright": {
                            type: "boolean",
                            default: !1,
                            requires: [
                                "icon-image",
                                {
                                    "icon-rotation-alignment": "map"
                                },
                                {
                                    "symbol-placement": [
                                        "line",
                                        "line-center"
                                    ]
                                }
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "icon-offset": {
                            type: "array",
                            value: "number",
                            length: 2,
                            default: [
                                0,
                                0
                            ],
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "icon-anchor": {
                            type: "enum",
                            values: {
                                center: {},
                                left: {},
                                right: {},
                                top: {},
                                bottom: {},
                                "top-left": {},
                                "top-right": {},
                                "bottom-left": {},
                                "bottom-right": {}
                            },
                            default: "center",
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "icon-pitch-alignment": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {},
                                auto: {}
                            },
                            default: "auto",
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-pitch-alignment": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {},
                                auto: {}
                            },
                            default: "auto",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-rotation-alignment": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {},
                                auto: {}
                            },
                            default: "auto",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-field": {
                            type: "formatted",
                            default: "",
                            tokens: !0,
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-font": {
                            type: "array",
                            value: "string",
                            default: [
                                "Open Sans Regular",
                                "Arial Unicode MS Regular"
                            ],
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-size": {
                            type: "number",
                            default: 16,
                            minimum: 0,
                            units: "pixels",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-max-width": {
                            type: "number",
                            default: 10,
                            minimum: 0,
                            units: "ems",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-line-height": {
                            type: "number",
                            default: 1.2,
                            units: "ems",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-letter-spacing": {
                            type: "number",
                            default: 0,
                            units: "ems",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-justify": {
                            type: "enum",
                            values: {
                                auto: {},
                                left: {},
                                center: {},
                                right: {}
                            },
                            default: "center",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-radial-offset": {
                            type: "number",
                            units: "ems",
                            default: 0,
                            requires: [
                                "text-field"
                            ],
                            "property-type": "data-driven",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            }
                        },
                        "text-variable-anchor": {
                            type: "array",
                            value: "enum",
                            values: {
                                center: {},
                                left: {},
                                right: {},
                                top: {},
                                bottom: {},
                                "top-left": {},
                                "top-right": {},
                                "bottom-left": {},
                                "bottom-right": {}
                            },
                            requires: [
                                "text-field",
                                {
                                    "symbol-placement": [
                                        "point"
                                    ]
                                }
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-anchor": {
                            type: "enum",
                            values: {
                                center: {},
                                left: {},
                                right: {},
                                top: {},
                                bottom: {},
                                "top-left": {},
                                "top-right": {},
                                "bottom-left": {},
                                "bottom-right": {}
                            },
                            default: "center",
                            requires: [
                                "text-field",
                                {
                                    "!": "text-variable-anchor"
                                }
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-max-angle": {
                            type: "number",
                            default: 45,
                            units: "degrees",
                            requires: [
                                "text-field",
                                {
                                    "symbol-placement": [
                                        "line",
                                        "line-center"
                                    ]
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-writing-mode": {
                            type: "array",
                            value: "enum",
                            values: {
                                horizontal: {},
                                vertical: {}
                            },
                            requires: [
                                "text-field",
                                {
                                    "symbol-placement": [
                                        "point"
                                    ]
                                }
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-rotate": {
                            type: "number",
                            default: 0,
                            period: 360,
                            units: "degrees",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-padding": {
                            type: "number",
                            default: 2,
                            minimum: 0,
                            units: "pixels",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-keep-upright": {
                            type: "boolean",
                            default: !0,
                            requires: [
                                "text-field",
                                {
                                    "text-rotation-alignment": "map"
                                },
                                {
                                    "symbol-placement": [
                                        "line",
                                        "line-center"
                                    ]
                                }
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-transform": {
                            type: "enum",
                            values: {
                                none: {},
                                uppercase: {},
                                lowercase: {}
                            },
                            default: "none",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-offset": {
                            type: "array",
                            value: "number",
                            units: "ems",
                            length: 2,
                            default: [
                                0,
                                0
                            ],
                            requires: [
                                "text-field",
                                {
                                    "!": "text-radial-offset"
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-allow-overlap": {
                            type: "boolean",
                            default: !1,
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-ignore-placement": {
                            type: "boolean",
                            default: !1,
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-optional": {
                            type: "boolean",
                            default: !1,
                            requires: [
                                "text-field",
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        visibility: {
                            type: "enum",
                            values: {
                                visible: {},
                                none: {}
                            },
                            default: "visible",
                            "property-type": "constant"
                        }
                    }, Mo = {
                        visibility: {
                            type: "enum",
                            values: {
                                visible: {},
                                none: {}
                            },
                            default: "visible",
                            "property-type": "constant"
                        }
                    }, xo = {
                        visibility: {
                            type: "enum",
                            values: {
                                visible: {},
                                none: {}
                            },
                            default: "visible",
                            "property-type": "constant"
                        }
                    }, zs = {
                        type: "array",
                        value: "*"
                    }, ks = {
                        type: "enum",
                        values: {
                            "==": {},
                            "!=": {},
                            ">": {},
                            ">=": {},
                            "<": {},
                            "<=": {},
                            in: {},
                            "!in": {},
                            all: {},
                            any: {},
                            none: {},
                            has: {},
                            "!has": {},
                            within: {}
                        }
                    }, Zs = {
                        type: "enum",
                        values: {
                            Point: {},
                            LineString: {},
                            Polygon: {}
                        }
                    }, Xs = {
                        type: "array",
                        minimum: 0,
                        maximum: 24,
                        value: [
                            "number",
                            "color"
                        ],
                        length: 2
                    }, wl = {
                        type: "array",
                        value: "*",
                        minimum: 1
                    }, os = {
                        anchor: {
                            type: "enum",
                            default: "viewport",
                            values: {
                                map: {},
                                viewport: {}
                            },
                            "property-type": "data-constant",
                            transition: !1,
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            }
                        },
                        position: {
                            type: "array",
                            default: [
                                1.15,
                                210,
                                30
                            ],
                            length: 3,
                            value: "number",
                            "property-type": "data-constant",
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            }
                        },
                        color: {
                            type: "color",
                            "property-type": "data-constant",
                            default: "#ffffff",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            transition: !0
                        },
                        intensity: {
                            type: "number",
                            "property-type": "data-constant",
                            default: .5,
                            minimum: 0,
                            maximum: 1,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            transition: !0
                        }
                    }, cl = [
                        "paint_fill",
                        "paint_line",
                        "paint_circle",
                        "paint_heatmap",
                        "paint_fill-extrusion",
                        "paint_symbol",
                        "paint_raster",
                        "paint_hillshade",
                        "paint_background"
                    ], Cs = {
                        "fill-antialias": {
                            type: "boolean",
                            default: !0,
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "fill-opacity": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "fill-color": {
                            type: "color",
                            default: "#000000",
                            transition: !0,
                            requires: [
                                {
                                    "!": "fill-pattern"
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "fill-outline-color": {
                            type: "color",
                            transition: !0,
                            requires: [
                                {
                                    "!": "fill-pattern"
                                },
                                {
                                    "fill-antialias": !0
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "fill-translate": {
                            type: "array",
                            value: "number",
                            length: 2,
                            default: [
                                0,
                                0
                            ],
                            transition: !0,
                            units: "pixels",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "fill-translate-anchor": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {}
                            },
                            default: "map",
                            requires: [
                                "fill-translate"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "fill-pattern": {
                            type: "resolvedImage",
                            transition: !0,
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "cross-faded-data-driven"
                        }
                    }, ml = {
                        "line-opacity": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "line-color": {
                            type: "color",
                            default: "#000000",
                            transition: !0,
                            requires: [
                                {
                                    "!": "line-pattern"
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "line-translate": {
                            type: "array",
                            value: "number",
                            length: 2,
                            default: [
                                0,
                                0
                            ],
                            transition: !0,
                            units: "pixels",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "line-translate-anchor": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {}
                            },
                            default: "map",
                            requires: [
                                "line-translate"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "line-width": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            transition: !0,
                            units: "pixels",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "line-gap-width": {
                            type: "number",
                            default: 0,
                            minimum: 0,
                            transition: !0,
                            units: "pixels",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "line-offset": {
                            type: "number",
                            default: 0,
                            transition: !0,
                            units: "pixels",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "line-blur": {
                            type: "number",
                            default: 0,
                            minimum: 0,
                            transition: !0,
                            units: "pixels",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "line-dasharray": {
                            type: "array",
                            value: "number",
                            minimum: 0,
                            transition: !0,
                            units: "line widths",
                            requires: [
                                {
                                    "!": "line-pattern"
                                }
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "cross-faded"
                        },
                        "line-pattern": {
                            type: "resolvedImage",
                            transition: !0,
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "cross-faded-data-driven"
                        },
                        "line-gradient": {
                            type: "color",
                            transition: !1,
                            requires: [
                                {
                                    "!": "line-dasharray"
                                },
                                {
                                    "!": "line-pattern"
                                },
                                {
                                    source: "geojson",
                                    has: {
                                        lineMetrics: !0
                                    }
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "line-progress"
                                ]
                            },
                            "property-type": "color-ramp"
                        }
                    }, Ys = {
                        "circle-radius": {
                            type: "number",
                            default: 5,
                            minimum: 0,
                            transition: !0,
                            units: "pixels",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "circle-color": {
                            type: "color",
                            default: "#000000",
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "circle-blur": {
                            type: "number",
                            default: 0,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "circle-opacity": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "circle-translate": {
                            type: "array",
                            value: "number",
                            length: 2,
                            default: [
                                0,
                                0
                            ],
                            transition: !0,
                            units: "pixels",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "circle-translate-anchor": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {}
                            },
                            default: "map",
                            requires: [
                                "circle-translate"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "circle-pitch-scale": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {}
                            },
                            default: "map",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "circle-pitch-alignment": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {}
                            },
                            default: "viewport",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "circle-stroke-width": {
                            type: "number",
                            default: 0,
                            minimum: 0,
                            transition: !0,
                            units: "pixels",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "circle-stroke-color": {
                            type: "color",
                            default: "#000000",
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "circle-stroke-opacity": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        }
                    }, Hs = {
                        "heatmap-radius": {
                            type: "number",
                            default: 30,
                            minimum: 1,
                            transition: !0,
                            units: "pixels",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "heatmap-weight": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            transition: !1,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "heatmap-intensity": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "heatmap-color": {
                            type: "color",
                            default: [
                                "interpolate",
                                [
                                    "linear"
                                ],
                                [
                                    "heatmap-density"
                                ],
                                0,
                                "rgba(0, 0, 255, 0)",
                                .1,
                                "royalblue",
                                .3,
                                "cyan",
                                .5,
                                "lime",
                                .7,
                                "yellow",
                                1,
                                "red"
                            ],
                            transition: !1,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "heatmap-density"
                                ]
                            },
                            "property-type": "color-ramp"
                        },
                        "heatmap-opacity": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        }
                    }, Eo = {
                        "icon-opacity": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "icon-color": {
                            type: "color",
                            default: "#000000",
                            transition: !0,
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "icon-halo-color": {
                            type: "color",
                            default: "rgba(0, 0, 0, 0)",
                            transition: !0,
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "icon-halo-width": {
                            type: "number",
                            default: 0,
                            minimum: 0,
                            transition: !0,
                            units: "pixels",
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "icon-halo-blur": {
                            type: "number",
                            default: 0,
                            minimum: 0,
                            transition: !0,
                            units: "pixels",
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "icon-translate": {
                            type: "array",
                            value: "number",
                            length: 2,
                            default: [
                                0,
                                0
                            ],
                            transition: !0,
                            units: "pixels",
                            requires: [
                                "icon-image"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "icon-translate-anchor": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {}
                            },
                            default: "map",
                            requires: [
                                "icon-image",
                                "icon-translate"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-opacity": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-color": {
                            type: "color",
                            default: "#000000",
                            transition: !0,
                            overridable: !0,
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-halo-color": {
                            type: "color",
                            default: "rgba(0, 0, 0, 0)",
                            transition: !0,
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-halo-width": {
                            type: "number",
                            default: 0,
                            minimum: 0,
                            transition: !0,
                            units: "pixels",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-halo-blur": {
                            type: "number",
                            default: 0,
                            minimum: 0,
                            transition: !0,
                            units: "pixels",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom",
                                    "feature",
                                    "feature-state"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        "text-translate": {
                            type: "array",
                            value: "number",
                            length: 2,
                            default: [
                                0,
                                0
                            ],
                            transition: !0,
                            units: "pixels",
                            requires: [
                                "text-field"
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "text-translate-anchor": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {}
                            },
                            default: "map",
                            requires: [
                                "text-field",
                                "text-translate"
                            ],
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        }
                    }, fs = {
                        "raster-opacity": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "raster-hue-rotate": {
                            type: "number",
                            default: 0,
                            period: 360,
                            transition: !0,
                            units: "degrees",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "raster-brightness-min": {
                            type: "number",
                            default: 0,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "raster-brightness-max": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "raster-saturation": {
                            type: "number",
                            default: 0,
                            minimum: -1,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "raster-contrast": {
                            type: "number",
                            default: 0,
                            minimum: -1,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "raster-resampling": {
                            type: "enum",
                            values: {
                                linear: {},
                                nearest: {}
                            },
                            default: "linear",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "raster-fade-duration": {
                            type: "number",
                            default: 300,
                            minimum: 0,
                            transition: !1,
                            units: "milliseconds",
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        }
                    }, Ql = {
                        "hillshade-illumination-direction": {
                            type: "number",
                            default: 335,
                            minimum: 0,
                            maximum: 359,
                            transition: !1,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "hillshade-illumination-anchor": {
                            type: "enum",
                            values: {
                                map: {},
                                viewport: {}
                            },
                            default: "viewport",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "hillshade-exaggeration": {
                            type: "number",
                            default: .5,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "hillshade-shadow-color": {
                            type: "color",
                            default: "#000000",
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "hillshade-highlight-color": {
                            type: "color",
                            default: "#FFFFFF",
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "hillshade-accent-color": {
                            type: "color",
                            default: "#000000",
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        }
                    }, Hu = {
                        "background-color": {
                            type: "color",
                            default: "#000000",
                            transition: !0,
                            requires: [
                                {
                                    "!": "background-pattern"
                                }
                            ],
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        },
                        "background-pattern": {
                            type: "resolvedImage",
                            transition: !0,
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "cross-faded"
                        },
                        "background-opacity": {
                            type: "number",
                            default: 1,
                            minimum: 0,
                            maximum: 1,
                            transition: !0,
                            expression: {
                                interpolated: !0,
                                parameters: [
                                    "zoom"
                                ]
                            },
                            "property-type": "data-constant"
                        }
                    }, fc = {
                        duration: {
                            type: "number",
                            default: 300,
                            minimum: 0,
                            units: "milliseconds"
                        },
                        delay: {
                            type: "number",
                            default: 0,
                            minimum: 0,
                            units: "milliseconds"
                        }
                    }, ms = {
                        "*": {
                            type: "string"
                        }
                    }, on = {
                        $version: Ha,
                        $root: oo,
                        sources: xn,
                        source: _t,
                        source_vector: br,
                        source_raster: Hr,
                        source_raster_dem: ti,
                        source_geojson: zi,
                        source_video: Yi,
                        source_image: an,
                        layer: hi,
                        layout: Ji,
                        layout_background: ua,
                        layout_fill: Fn,
                        layout_circle: Sa,
                        layout_heatmap: go,
                        "layout_fill-extrusion": {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_line: Oo,
                        layout_symbol: ho,
                        layout_raster: Mo,
                        layout_hillshade: xo,
                        filter: zs,
                        filter_operator: ks,
                        geometry_type: Zs,
                        function: {
                            expression: {
                                type: "expression"
                            },
                            stops: {
                                type: "array",
                                value: "function_stop"
                            },
                            base: {
                                type: "number",
                                default: 1,
                                minimum: 0
                            },
                            property: {
                                type: "string",
                                default: "$zoom"
                            },
                            type: {
                                type: "enum",
                                values: {
                                    identity: {},
                                    exponential: {},
                                    interval: {},
                                    categorical: {}
                                },
                                default: "exponential"
                            },
                            colorSpace: {
                                type: "enum",
                                values: {
                                    rgb: {},
                                    lab: {},
                                    hcl: {}
                                },
                                default: "rgb"
                            },
                            default: {
                                type: "*",
                                required: !1
                            }
                        },
                        function_stop: Xs,
                        expression: wl,
                        light: os,
                        paint: cl,
                        paint_fill: Cs,
                        "paint_fill-extrusion": {
                            "fill-extrusion-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "fill-extrusion-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "fill-extrusion-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            },
                            "fill-extrusion-height": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "meters",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-base": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "meters",
                                transition: !0,
                                requires: [
                                    "fill-extrusion-height"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-vertical-gradient": {
                                type: "boolean",
                                default: !0,
                                transition: !1,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_line: ml,
                        paint_circle: Ys,
                        paint_heatmap: Hs,
                        paint_symbol: Eo,
                        paint_raster: fs,
                        paint_hillshade: Ql,
                        paint_background: Hu,
                        transition: fc,
                        "property-type": {
                            "data-driven": {
                                type: "property-type"
                            },
                            "cross-faded": {
                                type: "property-type"
                            },
                            "cross-faded-data-driven": {
                                type: "property-type"
                            },
                            "color-ramp": {
                                type: "property-type"
                            },
                            "data-constant": {
                                type: "property-type"
                            },
                            constant: {
                                type: "property-type"
                            }
                        },
                        promoteId: ms
                    }, fa = function(y, I, U, J) {
                        this.message = (y ? y + ": " : "") + U, J && (this.identifier = J), I != null && I.__line__ && (this.line = I.__line__);
                    };
                    function Qu(m) {
                        var y = m.key, I = m.value;
                        return I ? [
                            new fa(y, I, "constants have been deprecated as of v8")
                        ] : [];
                    }
                    function Rl(m) {
                        for(var y = [], I = arguments.length - 1; I-- > 0;)y[I] = arguments[I + 1];
                        for(var U = 0, J = y; U < J.length; U += 1){
                            var ne = J[U];
                            for(var fe in ne)m[fe] = ne[fe];
                        }
                        return m;
                    }
                    function vo(m) {
                        return m instanceof Number || m instanceof String || m instanceof Boolean ? m.valueOf() : m;
                    }
                    function Zl(m) {
                        if (Array.isArray(m)) return m.map(Zl);
                        if (m instanceof Object && !(m instanceof Number || m instanceof String || m instanceof Boolean)) {
                            var y = {};
                            for(var I in m)y[I] = Zl(m[I]);
                            return y;
                        }
                        return vo(m);
                    }
                    var Ks = function(m) {
                        function y(I, U) {
                            m.call(this, U), this.message = U, this.key = I;
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y;
                    }(Error), Xl = function(y, I) {
                        I === void 0 && (I = []), this.parent = y, this.bindings = {};
                        for(var U = 0, J = I; U < J.length; U += 1){
                            var ne = J[U], fe = ne[0], Fe = ne[1];
                            this.bindings[fe] = Fe;
                        }
                    };
                    Xl.prototype.concat = function(y) {
                        return new Xl(this, y);
                    }, Xl.prototype.get = function(y) {
                        if (this.bindings[y]) return this.bindings[y];
                        if (this.parent) return this.parent.get(y);
                        throw new Error(y + " not found in scope.");
                    }, Xl.prototype.has = function(y) {
                        return this.bindings[y] ? !0 : this.parent ? this.parent.has(y) : !1;
                    };
                    var Ec = {
                        kind: "null"
                    }, Zn = {
                        kind: "number"
                    }, ko = {
                        kind: "string"
                    }, Co = {
                        kind: "boolean"
                    }, Tl = {
                        kind: "color"
                    }, uf = {
                        kind: "object"
                    }, So = {
                        kind: "value"
                    }, cf = {
                        kind: "error"
                    }, rh = {
                        kind: "collator"
                    }, Al = {
                        kind: "formatted"
                    }, Hc = {
                        kind: "resolvedImage"
                    };
                    function eu(m, y) {
                        return {
                            kind: "array",
                            itemType: m,
                            N: y
                        };
                    }
                    function Ls(m) {
                        if (m.kind === "array") {
                            var y = Ls(m.itemType);
                            return typeof m.N == "number" ? "array<" + y + ", " + m.N + ">" : m.itemType.kind === "value" ? "array" : "array<" + y + ">";
                        } else return m.kind;
                    }
                    var mu = [
                        Ec,
                        Zn,
                        ko,
                        Co,
                        Tl,
                        Al,
                        uf,
                        eu(So),
                        Hc
                    ];
                    function kc(m, y) {
                        if (y.kind === "error") return null;
                        if (m.kind === "array") {
                            if (y.kind === "array" && (y.N === 0 && y.itemType.kind === "value" || !kc(m.itemType, y.itemType)) && (typeof m.N != "number" || m.N === y.N)) return null;
                        } else {
                            if (m.kind === y.kind) return null;
                            if (m.kind === "value") for(var I = 0, U = mu; I < U.length; I += 1){
                                var J = U[I];
                                if (!kc(J, y)) return null;
                            }
                        }
                        return "Expected " + Ls(m) + " but found " + Ls(y) + " instead.";
                    }
                    function Of(m, y) {
                        return y.some(function(I) {
                            return I.kind === m.kind;
                        });
                    }
                    function Gc(m, y) {
                        return y.some(function(I) {
                            return I === "null" ? m === null : I === "array" ? Array.isArray(m) : I === "object" ? m && !Array.isArray(m) && typeof m == "object" : I === typeof m;
                        });
                    }
                    var vd = a(function(m, y) {
                        var I = {
                            transparent: [
                                0,
                                0,
                                0,
                                0
                            ],
                            aliceblue: [
                                240,
                                248,
                                255,
                                1
                            ],
                            antiquewhite: [
                                250,
                                235,
                                215,
                                1
                            ],
                            aqua: [
                                0,
                                255,
                                255,
                                1
                            ],
                            aquamarine: [
                                127,
                                255,
                                212,
                                1
                            ],
                            azure: [
                                240,
                                255,
                                255,
                                1
                            ],
                            beige: [
                                245,
                                245,
                                220,
                                1
                            ],
                            bisque: [
                                255,
                                228,
                                196,
                                1
                            ],
                            black: [
                                0,
                                0,
                                0,
                                1
                            ],
                            blanchedalmond: [
                                255,
                                235,
                                205,
                                1
                            ],
                            blue: [
                                0,
                                0,
                                255,
                                1
                            ],
                            blueviolet: [
                                138,
                                43,
                                226,
                                1
                            ],
                            brown: [
                                165,
                                42,
                                42,
                                1
                            ],
                            burlywood: [
                                222,
                                184,
                                135,
                                1
                            ],
                            cadetblue: [
                                95,
                                158,
                                160,
                                1
                            ],
                            chartreuse: [
                                127,
                                255,
                                0,
                                1
                            ],
                            chocolate: [
                                210,
                                105,
                                30,
                                1
                            ],
                            coral: [
                                255,
                                127,
                                80,
                                1
                            ],
                            cornflowerblue: [
                                100,
                                149,
                                237,
                                1
                            ],
                            cornsilk: [
                                255,
                                248,
                                220,
                                1
                            ],
                            crimson: [
                                220,
                                20,
                                60,
                                1
                            ],
                            cyan: [
                                0,
                                255,
                                255,
                                1
                            ],
                            darkblue: [
                                0,
                                0,
                                139,
                                1
                            ],
                            darkcyan: [
                                0,
                                139,
                                139,
                                1
                            ],
                            darkgoldenrod: [
                                184,
                                134,
                                11,
                                1
                            ],
                            darkgray: [
                                169,
                                169,
                                169,
                                1
                            ],
                            darkgreen: [
                                0,
                                100,
                                0,
                                1
                            ],
                            darkgrey: [
                                169,
                                169,
                                169,
                                1
                            ],
                            darkkhaki: [
                                189,
                                183,
                                107,
                                1
                            ],
                            darkmagenta: [
                                139,
                                0,
                                139,
                                1
                            ],
                            darkolivegreen: [
                                85,
                                107,
                                47,
                                1
                            ],
                            darkorange: [
                                255,
                                140,
                                0,
                                1
                            ],
                            darkorchid: [
                                153,
                                50,
                                204,
                                1
                            ],
                            darkred: [
                                139,
                                0,
                                0,
                                1
                            ],
                            darksalmon: [
                                233,
                                150,
                                122,
                                1
                            ],
                            darkseagreen: [
                                143,
                                188,
                                143,
                                1
                            ],
                            darkslateblue: [
                                72,
                                61,
                                139,
                                1
                            ],
                            darkslategray: [
                                47,
                                79,
                                79,
                                1
                            ],
                            darkslategrey: [
                                47,
                                79,
                                79,
                                1
                            ],
                            darkturquoise: [
                                0,
                                206,
                                209,
                                1
                            ],
                            darkviolet: [
                                148,
                                0,
                                211,
                                1
                            ],
                            deeppink: [
                                255,
                                20,
                                147,
                                1
                            ],
                            deepskyblue: [
                                0,
                                191,
                                255,
                                1
                            ],
                            dimgray: [
                                105,
                                105,
                                105,
                                1
                            ],
                            dimgrey: [
                                105,
                                105,
                                105,
                                1
                            ],
                            dodgerblue: [
                                30,
                                144,
                                255,
                                1
                            ],
                            firebrick: [
                                178,
                                34,
                                34,
                                1
                            ],
                            floralwhite: [
                                255,
                                250,
                                240,
                                1
                            ],
                            forestgreen: [
                                34,
                                139,
                                34,
                                1
                            ],
                            fuchsia: [
                                255,
                                0,
                                255,
                                1
                            ],
                            gainsboro: [
                                220,
                                220,
                                220,
                                1
                            ],
                            ghostwhite: [
                                248,
                                248,
                                255,
                                1
                            ],
                            gold: [
                                255,
                                215,
                                0,
                                1
                            ],
                            goldenrod: [
                                218,
                                165,
                                32,
                                1
                            ],
                            gray: [
                                128,
                                128,
                                128,
                                1
                            ],
                            green: [
                                0,
                                128,
                                0,
                                1
                            ],
                            greenyellow: [
                                173,
                                255,
                                47,
                                1
                            ],
                            grey: [
                                128,
                                128,
                                128,
                                1
                            ],
                            honeydew: [
                                240,
                                255,
                                240,
                                1
                            ],
                            hotpink: [
                                255,
                                105,
                                180,
                                1
                            ],
                            indianred: [
                                205,
                                92,
                                92,
                                1
                            ],
                            indigo: [
                                75,
                                0,
                                130,
                                1
                            ],
                            ivory: [
                                255,
                                255,
                                240,
                                1
                            ],
                            khaki: [
                                240,
                                230,
                                140,
                                1
                            ],
                            lavender: [
                                230,
                                230,
                                250,
                                1
                            ],
                            lavenderblush: [
                                255,
                                240,
                                245,
                                1
                            ],
                            lawngreen: [
                                124,
                                252,
                                0,
                                1
                            ],
                            lemonchiffon: [
                                255,
                                250,
                                205,
                                1
                            ],
                            lightblue: [
                                173,
                                216,
                                230,
                                1
                            ],
                            lightcoral: [
                                240,
                                128,
                                128,
                                1
                            ],
                            lightcyan: [
                                224,
                                255,
                                255,
                                1
                            ],
                            lightgoldenrodyellow: [
                                250,
                                250,
                                210,
                                1
                            ],
                            lightgray: [
                                211,
                                211,
                                211,
                                1
                            ],
                            lightgreen: [
                                144,
                                238,
                                144,
                                1
                            ],
                            lightgrey: [
                                211,
                                211,
                                211,
                                1
                            ],
                            lightpink: [
                                255,
                                182,
                                193,
                                1
                            ],
                            lightsalmon: [
                                255,
                                160,
                                122,
                                1
                            ],
                            lightseagreen: [
                                32,
                                178,
                                170,
                                1
                            ],
                            lightskyblue: [
                                135,
                                206,
                                250,
                                1
                            ],
                            lightslategray: [
                                119,
                                136,
                                153,
                                1
                            ],
                            lightslategrey: [
                                119,
                                136,
                                153,
                                1
                            ],
                            lightsteelblue: [
                                176,
                                196,
                                222,
                                1
                            ],
                            lightyellow: [
                                255,
                                255,
                                224,
                                1
                            ],
                            lime: [
                                0,
                                255,
                                0,
                                1
                            ],
                            limegreen: [
                                50,
                                205,
                                50,
                                1
                            ],
                            linen: [
                                250,
                                240,
                                230,
                                1
                            ],
                            magenta: [
                                255,
                                0,
                                255,
                                1
                            ],
                            maroon: [
                                128,
                                0,
                                0,
                                1
                            ],
                            mediumaquamarine: [
                                102,
                                205,
                                170,
                                1
                            ],
                            mediumblue: [
                                0,
                                0,
                                205,
                                1
                            ],
                            mediumorchid: [
                                186,
                                85,
                                211,
                                1
                            ],
                            mediumpurple: [
                                147,
                                112,
                                219,
                                1
                            ],
                            mediumseagreen: [
                                60,
                                179,
                                113,
                                1
                            ],
                            mediumslateblue: [
                                123,
                                104,
                                238,
                                1
                            ],
                            mediumspringgreen: [
                                0,
                                250,
                                154,
                                1
                            ],
                            mediumturquoise: [
                                72,
                                209,
                                204,
                                1
                            ],
                            mediumvioletred: [
                                199,
                                21,
                                133,
                                1
                            ],
                            midnightblue: [
                                25,
                                25,
                                112,
                                1
                            ],
                            mintcream: [
                                245,
                                255,
                                250,
                                1
                            ],
                            mistyrose: [
                                255,
                                228,
                                225,
                                1
                            ],
                            moccasin: [
                                255,
                                228,
                                181,
                                1
                            ],
                            navajowhite: [
                                255,
                                222,
                                173,
                                1
                            ],
                            navy: [
                                0,
                                0,
                                128,
                                1
                            ],
                            oldlace: [
                                253,
                                245,
                                230,
                                1
                            ],
                            olive: [
                                128,
                                128,
                                0,
                                1
                            ],
                            olivedrab: [
                                107,
                                142,
                                35,
                                1
                            ],
                            orange: [
                                255,
                                165,
                                0,
                                1
                            ],
                            orangered: [
                                255,
                                69,
                                0,
                                1
                            ],
                            orchid: [
                                218,
                                112,
                                214,
                                1
                            ],
                            palegoldenrod: [
                                238,
                                232,
                                170,
                                1
                            ],
                            palegreen: [
                                152,
                                251,
                                152,
                                1
                            ],
                            paleturquoise: [
                                175,
                                238,
                                238,
                                1
                            ],
                            palevioletred: [
                                219,
                                112,
                                147,
                                1
                            ],
                            papayawhip: [
                                255,
                                239,
                                213,
                                1
                            ],
                            peachpuff: [
                                255,
                                218,
                                185,
                                1
                            ],
                            peru: [
                                205,
                                133,
                                63,
                                1
                            ],
                            pink: [
                                255,
                                192,
                                203,
                                1
                            ],
                            plum: [
                                221,
                                160,
                                221,
                                1
                            ],
                            powderblue: [
                                176,
                                224,
                                230,
                                1
                            ],
                            purple: [
                                128,
                                0,
                                128,
                                1
                            ],
                            rebeccapurple: [
                                102,
                                51,
                                153,
                                1
                            ],
                            red: [
                                255,
                                0,
                                0,
                                1
                            ],
                            rosybrown: [
                                188,
                                143,
                                143,
                                1
                            ],
                            royalblue: [
                                65,
                                105,
                                225,
                                1
                            ],
                            saddlebrown: [
                                139,
                                69,
                                19,
                                1
                            ],
                            salmon: [
                                250,
                                128,
                                114,
                                1
                            ],
                            sandybrown: [
                                244,
                                164,
                                96,
                                1
                            ],
                            seagreen: [
                                46,
                                139,
                                87,
                                1
                            ],
                            seashell: [
                                255,
                                245,
                                238,
                                1
                            ],
                            sienna: [
                                160,
                                82,
                                45,
                                1
                            ],
                            silver: [
                                192,
                                192,
                                192,
                                1
                            ],
                            skyblue: [
                                135,
                                206,
                                235,
                                1
                            ],
                            slateblue: [
                                106,
                                90,
                                205,
                                1
                            ],
                            slategray: [
                                112,
                                128,
                                144,
                                1
                            ],
                            slategrey: [
                                112,
                                128,
                                144,
                                1
                            ],
                            snow: [
                                255,
                                250,
                                250,
                                1
                            ],
                            springgreen: [
                                0,
                                255,
                                127,
                                1
                            ],
                            steelblue: [
                                70,
                                130,
                                180,
                                1
                            ],
                            tan: [
                                210,
                                180,
                                140,
                                1
                            ],
                            teal: [
                                0,
                                128,
                                128,
                                1
                            ],
                            thistle: [
                                216,
                                191,
                                216,
                                1
                            ],
                            tomato: [
                                255,
                                99,
                                71,
                                1
                            ],
                            turquoise: [
                                64,
                                224,
                                208,
                                1
                            ],
                            violet: [
                                238,
                                130,
                                238,
                                1
                            ],
                            wheat: [
                                245,
                                222,
                                179,
                                1
                            ],
                            white: [
                                255,
                                255,
                                255,
                                1
                            ],
                            whitesmoke: [
                                245,
                                245,
                                245,
                                1
                            ],
                            yellow: [
                                255,
                                255,
                                0,
                                1
                            ],
                            yellowgreen: [
                                154,
                                205,
                                50,
                                1
                            ]
                        };
                        function U(st) {
                            return st = Math.round(st), st < 0 ? 0 : st > 255 ? 255 : st;
                        }
                        function J(st) {
                            return st < 0 ? 0 : st > 1 ? 1 : st;
                        }
                        function ne(st) {
                            return st[st.length - 1] === "%" ? U(parseFloat(st) / 100 * 255) : U(parseInt(st));
                        }
                        function fe(st) {
                            return st[st.length - 1] === "%" ? J(parseFloat(st) / 100) : J(parseFloat(st));
                        }
                        function Fe(st, mt, Xt) {
                            return Xt < 0 ? Xt += 1 : Xt > 1 && (Xt -= 1), Xt * 6 < 1 ? st + (mt - st) * Xt * 6 : Xt * 2 < 1 ? mt : Xt * 3 < 2 ? st + (mt - st) * (2 / 3 - Xt) * 6 : st;
                        }
                        function Qe(st) {
                            var mt = st.replace(/ /g, "").toLowerCase();
                            if (mt in I) return I[mt].slice();
                            if (mt[0] === "#") {
                                if (mt.length === 4) {
                                    var Xt = parseInt(mt.substr(1), 16);
                                    return Xt >= 0 && Xt <= 4095 ? [
                                        (Xt & 3840) >> 4 | (Xt & 3840) >> 8,
                                        Xt & 240 | (Xt & 240) >> 4,
                                        Xt & 15 | (Xt & 15) << 4,
                                        1
                                    ] : null;
                                } else if (mt.length === 7) {
                                    var Xt = parseInt(mt.substr(1), 16);
                                    return Xt >= 0 && Xt <= 16777215 ? [
                                        (Xt & 16711680) >> 16,
                                        (Xt & 65280) >> 8,
                                        Xt & 255,
                                        1
                                    ] : null;
                                }
                                return null;
                            }
                            var ur = mt.indexOf("("), nr = mt.indexOf(")");
                            if (ur !== -1 && nr + 1 === mt.length) {
                                var Lr = mt.substr(0, ur), Yr = mt.substr(ur + 1, nr - (ur + 1)).split(","), _i = 1;
                                switch(Lr){
                                    case "rgba":
                                        if (Yr.length !== 4) return null;
                                        _i = fe(Yr.pop());
                                    case "rgb":
                                        return Yr.length !== 3 ? null : [
                                            ne(Yr[0]),
                                            ne(Yr[1]),
                                            ne(Yr[2]),
                                            _i
                                        ];
                                    case "hsla":
                                        if (Yr.length !== 4) return null;
                                        _i = fe(Yr.pop());
                                    case "hsl":
                                        if (Yr.length !== 3) return null;
                                        var si = (parseFloat(Yr[0]) % 360 + 360) % 360 / 360, Hi = fe(Yr[1]), Ei = fe(Yr[2]), Vi = Ei <= .5 ? Ei * (Hi + 1) : Ei + Hi - Ei * Hi, en = Ei * 2 - Vi;
                                        return [
                                            U(Fe(en, Vi, si + 1 / 3) * 255),
                                            U(Fe(en, Vi, si) * 255),
                                            U(Fe(en, Vi, si - 1 / 3) * 255),
                                            _i
                                        ];
                                    default:
                                        return null;
                                }
                            }
                            return null;
                        }
                        try {
                            y.parseCSSColor = Qe;
                        } catch (st) {}
                    }), Bf = vd.parseCSSColor, ss = function(y, I, U, J) {
                        J === void 0 && (J = 1), this.r = y, this.g = I, this.b = U, this.a = J;
                    };
                    ss.parse = function(y) {
                        if (y) {
                            if (y instanceof ss) return y;
                            if (typeof y == "string") {
                                var I = Bf(y);
                                if (I) return new ss(I[0] / 255 * I[3], I[1] / 255 * I[3], I[2] / 255 * I[3], I[3]);
                            }
                        }
                    }, ss.prototype.toString = function() {
                        var y = this.toArray(), I = y[0], U = y[1], J = y[2], ne = y[3];
                        return "rgba(" + Math.round(I) + "," + Math.round(U) + "," + Math.round(J) + "," + ne + ")";
                    }, ss.prototype.toArray = function() {
                        var y = this, I = y.r, U = y.g, J = y.b, ne = y.a;
                        return ne === 0 ? [
                            0,
                            0,
                            0,
                            0
                        ] : [
                            I * 255 / ne,
                            U * 255 / ne,
                            J * 255 / ne,
                            ne
                        ];
                    }, ss.black = new ss(0, 0, 0, 1), ss.white = new ss(1, 1, 1, 1), ss.transparent = new ss(0, 0, 0, 0), ss.red = new ss(1, 0, 0, 1);
                    var ff = function(y, I, U) {
                        y ? this.sensitivity = I ? "variant" : "case" : this.sensitivity = I ? "accent" : "base", this.locale = U, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                            sensitivity: this.sensitivity,
                            usage: "search"
                        });
                    };
                    ff.prototype.compare = function(y, I) {
                        return this.collator.compare(y, I);
                    }, ff.prototype.resolvedLocale = function() {
                        return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
                    };
                    var ih = function(y, I, U, J, ne) {
                        this.text = y, this.image = I, this.scale = U, this.fontStack = J, this.textColor = ne;
                    }, Vl = function(y) {
                        this.sections = y;
                    };
                    Vl.fromString = function(y) {
                        return new Vl([
                            new ih(y, null, null, null, null)
                        ]);
                    }, Vl.prototype.isEmpty = function() {
                        return this.sections.length === 0 ? !0 : !this.sections.some(function(y) {
                            return y.text.length !== 0 || y.image && y.image.name.length !== 0;
                        });
                    }, Vl.factory = function(y) {
                        return y instanceof Vl ? y : Vl.fromString(y);
                    }, Vl.prototype.toString = function() {
                        return this.sections.length === 0 ? "" : this.sections.map(function(y) {
                            return y.text;
                        }).join("");
                    }, Vl.prototype.serialize = function() {
                        for(var y = [
                            "format"
                        ], I = 0, U = this.sections; I < U.length; I += 1){
                            var J = U[I];
                            if (J.image) {
                                y.push([
                                    "image",
                                    J.image.name
                                ]);
                                continue;
                            }
                            y.push(J.text);
                            var ne = {};
                            J.fontStack && (ne["text-font"] = [
                                "literal",
                                J.fontStack.split(",")
                            ]), J.scale && (ne["font-scale"] = J.scale), J.textColor && (ne["text-color"] = [
                                "rgba"
                            ].concat(J.textColor.toArray())), y.push(ne);
                        }
                        return y;
                    };
                    var Js = function(y) {
                        this.name = y.name, this.available = y.available;
                    };
                    Js.prototype.toString = function() {
                        return this.name;
                    }, Js.fromString = function(y) {
                        return y ? new Js({
                            name: y,
                            available: !1
                        }) : null;
                    }, Js.prototype.serialize = function() {
                        return [
                            "image",
                            this.name
                        ];
                    };
                    function hc(m, y, I, U) {
                        if (!(typeof m == "number" && m >= 0 && m <= 255 && typeof y == "number" && y >= 0 && y <= 255 && typeof I == "number" && I >= 0 && I <= 255)) {
                            var J = typeof U == "number" ? [
                                m,
                                y,
                                I,
                                U
                            ] : [
                                m,
                                y,
                                I
                            ];
                            return "Invalid rgba value [" + J.join(", ") + "]: 'r', 'g', and 'b' must be between 0 and 255.";
                        }
                        return typeof U == "undefined" || typeof U == "number" && U >= 0 && U <= 1 ? null : "Invalid rgba value [" + [
                            m,
                            y,
                            I,
                            U
                        ].join(", ") + "]: 'a' must be between 0 and 1.";
                    }
                    function Cc(m) {
                        if (m === null) return !0;
                        if (typeof m == "string") return !0;
                        if (typeof m == "boolean") return !0;
                        if (typeof m == "number") return !0;
                        if (m instanceof ss) return !0;
                        if (m instanceof ff) return !0;
                        if (m instanceof Vl) return !0;
                        if (m instanceof Js) return !0;
                        if (Array.isArray(m)) {
                            for(var y = 0, I = m; y < I.length; y += 1){
                                var U = I[y];
                                if (!Cc(U)) return !1;
                            }
                            return !0;
                        } else if (typeof m == "object") {
                            for(var J in m)if (!Cc(m[J])) return !1;
                            return !0;
                        } else return !1;
                    }
                    function ws(m) {
                        if (m === null) return Ec;
                        if (typeof m == "string") return ko;
                        if (typeof m == "boolean") return Co;
                        if (typeof m == "number") return Zn;
                        if (m instanceof ss) return Tl;
                        if (m instanceof ff) return rh;
                        if (m instanceof Vl) return Al;
                        if (m instanceof Js) return Hc;
                        if (Array.isArray(m)) {
                            for(var y = m.length, I, U = 0, J = m; U < J.length; U += 1){
                                var ne = J[U], fe = ws(ne);
                                if (!I) I = fe;
                                else {
                                    if (I === fe) continue;
                                    I = So;
                                    break;
                                }
                            }
                            return eu(I || So, y);
                        } else return uf;
                    }
                    function $s(m) {
                        var y = typeof m;
                        return m === null ? "" : y === "string" || y === "number" || y === "boolean" ? String(m) : m instanceof ss || m instanceof Vl || m instanceof Js ? m.toString() : JSON.stringify(m);
                    }
                    var hs = function(y, I) {
                        this.type = y, this.value = I;
                    };
                    hs.parse = function(y, I) {
                        if (y.length !== 2) return I.error("'literal' expression requires exactly one argument, but found " + (y.length - 1) + " instead.");
                        if (!Cc(y[1])) return I.error("invalid value");
                        var U = y[1], J = ws(U), ne = I.expectedType;
                        return J.kind === "array" && J.N === 0 && ne && ne.kind === "array" && (typeof ne.N != "number" || ne.N === 0) && (J = ne), new hs(J, U);
                    }, hs.prototype.evaluate = function() {
                        return this.value;
                    }, hs.prototype.eachChild = function() {}, hs.prototype.outputDefined = function() {
                        return !0;
                    }, hs.prototype.serialize = function() {
                        return this.type.kind === "array" || this.type.kind === "object" ? [
                            "literal",
                            this.value
                        ] : this.value instanceof ss ? [
                            "rgba"
                        ].concat(this.value.toArray()) : this.value instanceof Vl ? this.value.serialize() : this.value;
                    };
                    var Ms = function(y) {
                        this.name = "ExpressionEvaluationError", this.message = y;
                    };
                    Ms.prototype.toJSON = function() {
                        return this.message;
                    };
                    var dc = {
                        string: ko,
                        number: Zn,
                        boolean: Co,
                        object: uf
                    }, Sl = function(y, I) {
                        this.type = y, this.args = I;
                    };
                    Sl.parse = function(y, I) {
                        if (y.length < 2) return I.error("Expected at least one argument.");
                        var U = 1, J, ne = y[0];
                        if (ne === "array") {
                            var fe;
                            if (y.length > 2) {
                                var Fe = y[1];
                                if (typeof Fe != "string" || !(Fe in dc) || Fe === "object") return I.error('The item type argument of "array" must be one of string, number, boolean', 1);
                                fe = dc[Fe], U++;
                            } else fe = So;
                            var Qe;
                            if (y.length > 3) {
                                if (y[2] !== null && (typeof y[2] != "number" || y[2] < 0 || y[2] !== Math.floor(y[2]))) return I.error('The length argument to "array" must be a positive integer literal', 2);
                                Qe = y[2], U++;
                            }
                            J = eu(fe, Qe);
                        } else J = dc[ne];
                        for(var st = []; U < y.length; U++){
                            var mt = I.parse(y[U], U, So);
                            if (!mt) return null;
                            st.push(mt);
                        }
                        return new Sl(J, st);
                    }, Sl.prototype.evaluate = function(y) {
                        for(var I = 0; I < this.args.length; I++){
                            var U = this.args[I].evaluate(y), J = kc(this.type, ws(U));
                            if (J) {
                                if (I === this.args.length - 1) throw new Ms("Expected value to be of type " + Ls(this.type) + ", but found " + Ls(ws(U)) + " instead.");
                            } else return U;
                        }
                        return null;
                    }, Sl.prototype.eachChild = function(y) {
                        this.args.forEach(y);
                    }, Sl.prototype.outputDefined = function() {
                        return this.args.every(function(y) {
                            return y.outputDefined();
                        });
                    }, Sl.prototype.serialize = function() {
                        var y = this.type, I = [
                            y.kind
                        ];
                        if (y.kind === "array") {
                            var U = y.itemType;
                            if (U.kind === "string" || U.kind === "number" || U.kind === "boolean") {
                                I.push(U.kind);
                                var J = y.N;
                                (typeof J == "number" || this.args.length > 1) && I.push(J);
                            }
                        }
                        return I.concat(this.args.map(function(ne) {
                            return ne.serialize();
                        }));
                    };
                    var ec = function(y) {
                        this.type = Al, this.sections = y;
                    };
                    ec.parse = function(y, I) {
                        if (y.length < 2) return I.error("Expected at least one argument.");
                        var U = y[1];
                        if (!Array.isArray(U) && typeof U == "object") return I.error("First argument must be an image or text section.");
                        for(var J = [], ne = !1, fe = 1; fe <= y.length - 1; ++fe){
                            var Fe = y[fe];
                            if (ne && typeof Fe == "object" && !Array.isArray(Fe)) {
                                ne = !1;
                                var Qe = null;
                                if (Fe["font-scale"] && (Qe = I.parse(Fe["font-scale"], 1, Zn), !Qe)) return null;
                                var st = null;
                                if (Fe["text-font"] && (st = I.parse(Fe["text-font"], 1, eu(ko)), !st)) return null;
                                var mt = null;
                                if (Fe["text-color"] && (mt = I.parse(Fe["text-color"], 1, Tl), !mt)) return null;
                                var Xt = J[J.length - 1];
                                Xt.scale = Qe, Xt.font = st, Xt.textColor = mt;
                            } else {
                                var ur = I.parse(y[fe], 1, So);
                                if (!ur) return null;
                                var nr = ur.type.kind;
                                if (nr !== "string" && nr !== "value" && nr !== "null" && nr !== "resolvedImage") return I.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                                ne = !0, J.push({
                                    content: ur,
                                    scale: null,
                                    font: null,
                                    textColor: null
                                });
                            }
                        }
                        return new ec(J);
                    }, ec.prototype.evaluate = function(y) {
                        var I = function(U) {
                            var J = U.content.evaluate(y);
                            return ws(J) === Hc ? new ih("", J, null, null, null) : new ih($s(J), null, U.scale ? U.scale.evaluate(y) : null, U.font ? U.font.evaluate(y).join(",") : null, U.textColor ? U.textColor.evaluate(y) : null);
                        };
                        return new Vl(this.sections.map(I));
                    }, ec.prototype.eachChild = function(y) {
                        for(var I = 0, U = this.sections; I < U.length; I += 1){
                            var J = U[I];
                            y(J.content), J.scale && y(J.scale), J.font && y(J.font), J.textColor && y(J.textColor);
                        }
                    }, ec.prototype.outputDefined = function() {
                        return !1;
                    }, ec.prototype.serialize = function() {
                        for(var y = [
                            "format"
                        ], I = 0, U = this.sections; I < U.length; I += 1){
                            var J = U[I];
                            y.push(J.content.serialize());
                            var ne = {};
                            J.scale && (ne["font-scale"] = J.scale.serialize()), J.font && (ne["text-font"] = J.font.serialize()), J.textColor && (ne["text-color"] = J.textColor.serialize()), y.push(ne);
                        }
                        return y;
                    };
                    var Ps = function(y) {
                        this.type = Hc, this.input = y;
                    };
                    Ps.parse = function(y, I) {
                        if (y.length !== 2) return I.error("Expected two arguments.");
                        var U = I.parse(y[1], 1, ko);
                        return U ? new Ps(U) : I.error("No image name provided.");
                    }, Ps.prototype.evaluate = function(y) {
                        var I = this.input.evaluate(y), U = Js.fromString(I);
                        return U && y.availableImages && (U.available = y.availableImages.indexOf(I) > -1), U;
                    }, Ps.prototype.eachChild = function(y) {
                        y(this.input);
                    }, Ps.prototype.outputDefined = function() {
                        return !1;
                    }, Ps.prototype.serialize = function() {
                        return [
                            "image",
                            this.input.serialize()
                        ];
                    };
                    var ov = {
                        "to-boolean": Co,
                        "to-color": Tl,
                        "to-number": Zn,
                        "to-string": ko
                    }, wo = function(y, I) {
                        this.type = y, this.args = I;
                    };
                    wo.parse = function(y, I) {
                        if (y.length < 2) return I.error("Expected at least one argument.");
                        var U = y[0];
                        if ((U === "to-boolean" || U === "to-string") && y.length !== 2) return I.error("Expected one argument.");
                        for(var J = ov[U], ne = [], fe = 1; fe < y.length; fe++){
                            var Fe = I.parse(y[fe], fe, So);
                            if (!Fe) return null;
                            ne.push(Fe);
                        }
                        return new wo(J, ne);
                    }, wo.prototype.evaluate = function(y) {
                        if (this.type.kind === "boolean") return !!this.args[0].evaluate(y);
                        if (this.type.kind === "color") {
                            for(var I, U, J = 0, ne = this.args; J < ne.length; J += 1){
                                var fe = ne[J];
                                if (I = fe.evaluate(y), U = null, I instanceof ss) return I;
                                if (typeof I == "string") {
                                    var Fe = y.parseColor(I);
                                    if (Fe) return Fe;
                                } else if (Array.isArray(I) && (I.length < 3 || I.length > 4 ? U = "Invalid rbga value " + JSON.stringify(I) + ": expected an array containing either three or four numeric values." : U = hc(I[0], I[1], I[2], I[3]), !U)) return new ss(I[0] / 255, I[1] / 255, I[2] / 255, I[3]);
                            }
                            throw new Ms(U || "Could not parse color from value '" + (typeof I == "string" ? I : String(JSON.stringify(I))) + "'");
                        } else if (this.type.kind === "number") {
                            for(var Qe = null, st = 0, mt = this.args; st < mt.length; st += 1){
                                var Xt = mt[st];
                                if (Qe = Xt.evaluate(y), Qe === null) return 0;
                                var ur = Number(Qe);
                                if (!isNaN(ur)) return ur;
                            }
                            throw new Ms("Could not convert " + JSON.stringify(Qe) + " to number.");
                        } else return this.type.kind === "formatted" ? Vl.fromString($s(this.args[0].evaluate(y))) : this.type.kind === "resolvedImage" ? Js.fromString($s(this.args[0].evaluate(y))) : $s(this.args[0].evaluate(y));
                    }, wo.prototype.eachChild = function(y) {
                        this.args.forEach(y);
                    }, wo.prototype.outputDefined = function() {
                        return this.args.every(function(y) {
                            return y.outputDefined();
                        });
                    }, wo.prototype.serialize = function() {
                        if (this.type.kind === "formatted") return new ec([
                            {
                                content: this.args[0],
                                scale: null,
                                font: null,
                                textColor: null
                            }
                        ]).serialize();
                        if (this.type.kind === "resolvedImage") return new Ps(this.args[0]).serialize();
                        var y = [
                            "to-" + this.type.kind
                        ];
                        return this.eachChild(function(I) {
                            y.push(I.serialize());
                        }), y;
                    };
                    var Od = [
                        "Unknown",
                        "Point",
                        "LineString",
                        "Polygon"
                    ], $o = function() {
                        this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
                    };
                    $o.prototype.id = function() {
                        return this.feature && "id" in this.feature ? this.feature.id : null;
                    }, $o.prototype.geometryType = function() {
                        return this.feature ? typeof this.feature.type == "number" ? Od[this.feature.type] : this.feature.type : null;
                    }, $o.prototype.geometry = function() {
                        return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
                    }, $o.prototype.canonicalID = function() {
                        return this.canonical;
                    }, $o.prototype.properties = function() {
                        return this.feature && this.feature.properties || {};
                    }, $o.prototype.parseColor = function(y) {
                        var I = this._parseColorCache[y];
                        return I || (I = this._parseColorCache[y] = ss.parse(y)), I;
                    };
                    var Ja = function(y, I, U, J) {
                        this.name = y, this.type = I, this._evaluate = U, this.args = J;
                    };
                    Ja.prototype.evaluate = function(y) {
                        return this._evaluate(y, this.args);
                    }, Ja.prototype.eachChild = function(y) {
                        this.args.forEach(y);
                    }, Ja.prototype.outputDefined = function() {
                        return !1;
                    }, Ja.prototype.serialize = function() {
                        return [
                            this.name
                        ].concat(this.args.map(function(y) {
                            return y.serialize();
                        }));
                    }, Ja.parse = function(y, I) {
                        var U, J = y[0], ne = Ja.definitions[J];
                        if (!ne) return I.error('Unknown expression "' + J + '". If you wanted a literal array, use ["literal", [...]].', 0);
                        for(var fe = Array.isArray(ne) ? ne[0] : ne.type, Fe = Array.isArray(ne) ? [
                            [
                                ne[1],
                                ne[2]
                            ]
                        ] : ne.overloads, Qe = Fe.filter(function(Na) {
                            var ja = Na[0];
                            return !Array.isArray(ja) || ja.length === y.length - 1;
                        }), st = null, mt = 0, Xt = Qe; mt < Xt.length; mt += 1){
                            var ur = Xt[mt], nr = ur[0], Lr = ur[1];
                            st = new fl(I.registry, I.path, null, I.scope);
                            for(var Yr = [], _i = !1, si = 1; si < y.length; si++){
                                var Hi = y[si], Ei = Array.isArray(nr) ? nr[si - 1] : nr.type, Vi = st.parse(Hi, 1 + Yr.length, Ei);
                                if (!Vi) {
                                    _i = !0;
                                    break;
                                }
                                Yr.push(Vi);
                            }
                            if (!_i) {
                                if (Array.isArray(nr) && nr.length !== Yr.length) {
                                    st.error("Expected " + nr.length + " arguments, but found " + Yr.length + " instead.");
                                    continue;
                                }
                                for(var en = 0; en < Yr.length; en++){
                                    var An = Array.isArray(nr) ? nr[en] : nr.type, ra = Yr[en];
                                    st.concat(en + 1).checkSubtype(An, ra.type);
                                }
                                if (st.errors.length === 0) return new Ja(J, fe, Lr, Yr);
                            }
                        }
                        if (Qe.length === 1) (U = I.errors).push.apply(U, st.errors);
                        else {
                            for(var $n = Qe.length ? Qe : Fe, Ba = $n.map(function(Na) {
                                var ja = Na[0];
                                return Ef(ja);
                            }).join(" | "), _a = [], Pa = 1; Pa < y.length; Pa++){
                                var qo = I.parse(y[Pa], 1 + _a.length);
                                if (!qo) return null;
                                _a.push(Ls(qo.type));
                            }
                            I.error("Expected arguments of type " + Ba + ", but found (" + _a.join(", ") + ") instead.");
                        }
                        return null;
                    }, Ja.register = function(y, I) {
                        Ja.definitions = I;
                        for(var U in I)y[U] = Ja;
                    };
                    function Ef(m) {
                        return Array.isArray(m) ? "(" + m.map(Ls).join(", ") + ")" : "(" + Ls(m.type) + "...)";
                    }
                    var tc = function(y, I, U) {
                        this.type = rh, this.locale = U, this.caseSensitive = y, this.diacriticSensitive = I;
                    };
                    tc.parse = function(y, I) {
                        if (y.length !== 2) return I.error("Expected one argument.");
                        var U = y[1];
                        if (typeof U != "object" || Array.isArray(U)) return I.error("Collator options argument must be an object.");
                        var J = I.parse(U["case-sensitive"] === void 0 ? !1 : U["case-sensitive"], 1, Co);
                        if (!J) return null;
                        var ne = I.parse(U["diacritic-sensitive"] === void 0 ? !1 : U["diacritic-sensitive"], 1, Co);
                        if (!ne) return null;
                        var fe = null;
                        return U.locale && (fe = I.parse(U.locale, 1, ko), !fe) ? null : new tc(J, ne, fe);
                    }, tc.prototype.evaluate = function(y) {
                        return new ff(this.caseSensitive.evaluate(y), this.diacriticSensitive.evaluate(y), this.locale ? this.locale.evaluate(y) : null);
                    }, tc.prototype.eachChild = function(y) {
                        y(this.caseSensitive), y(this.diacriticSensitive), this.locale && y(this.locale);
                    }, tc.prototype.outputDefined = function() {
                        return !1;
                    }, tc.prototype.serialize = function() {
                        var y = {};
                        return y["case-sensitive"] = this.caseSensitive.serialize(), y["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (y.locale = this.locale.serialize()), [
                            "collator",
                            y
                        ];
                    };
                    var uu = 8192;
                    function Mh(m, y) {
                        m[0] = Math.min(m[0], y[0]), m[1] = Math.min(m[1], y[1]), m[2] = Math.max(m[2], y[0]), m[3] = Math.max(m[3], y[1]);
                    }
                    function jc(m) {
                        return (180 + m) / 360;
                    }
                    function kf(m) {
                        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + m * Math.PI / 360))) / 360;
                    }
                    function Ml(m, y) {
                        return !(m[0] <= y[0] || m[2] >= y[2] || m[1] <= y[1] || m[3] >= y[3]);
                    }
                    function Yh(m, y) {
                        var I = jc(m[0]), U = kf(m[1]), J = Math.pow(2, y.z);
                        return [
                            Math.round(I * J * uu),
                            Math.round(U * J * uu)
                        ];
                    }
                    function Eh(m, y, I) {
                        var U = m[0] - y[0], J = m[1] - y[1], ne = m[0] - I[0], fe = m[1] - I[1];
                        return U * fe - ne * J === 0 && U * ne <= 0 && J * fe <= 0;
                    }
                    function nh(m, y, I) {
                        return y[1] > m[1] != I[1] > m[1] && m[0] < (I[0] - y[0]) * (m[1] - y[1]) / (I[1] - y[1]) + y[0];
                    }
                    function hf(m, y) {
                        for(var I = !1, U = 0, J = y.length; U < J; U++)for(var ne = y[U], fe = 0, Fe = ne.length; fe < Fe - 1; fe++){
                            if (Eh(m, ne[fe], ne[fe + 1])) return !1;
                            nh(m, ne[fe], ne[fe + 1]) && (I = !I);
                        }
                        return I;
                    }
                    function kh(m, y) {
                        for(var I = 0; I < y.length; I++)if (hf(m, y[I])) return !0;
                        return !1;
                    }
                    function Kh(m, y) {
                        return m[0] * y[1] - m[1] * y[0];
                    }
                    function rc(m, y, I, U) {
                        var J = m[0] - I[0], ne = m[1] - I[1], fe = y[0] - I[0], Fe = y[1] - I[1], Qe = U[0] - I[0], st = U[1] - I[1], mt = J * st - Qe * ne, Xt = fe * st - Qe * Fe;
                        return mt > 0 && Xt < 0 || mt < 0 && Xt > 0;
                    }
                    function ah(m, y, I, U) {
                        var J = [
                            y[0] - m[0],
                            y[1] - m[1]
                        ], ne = [
                            U[0] - I[0],
                            U[1] - I[1]
                        ];
                        return Kh(ne, J) === 0 ? !1 : !!(rc(m, y, I, U) && rc(I, U, m, y));
                    }
                    function Wc(m, y, I) {
                        for(var U = 0, J = I; U < J.length; U += 1)for(var ne = J[U], fe = 0; fe < ne.length - 1; ++fe)if (ah(m, y, ne[fe], ne[fe + 1])) return !0;
                        return !1;
                    }
                    function df(m, y) {
                        for(var I = 0; I < m.length; ++I)if (!hf(m[I], y)) return !1;
                        for(var U = 0; U < m.length - 1; ++U)if (Wc(m[U], m[U + 1], y)) return !1;
                        return !0;
                    }
                    function Cu(m, y) {
                        for(var I = 0; I < y.length; I++)if (df(m, y[I])) return !0;
                        return !1;
                    }
                    function Nf(m, y, I) {
                        for(var U = [], J = 0; J < m.length; J++){
                            for(var ne = [], fe = 0; fe < m[J].length; fe++){
                                var Fe = Yh(m[J][fe], I);
                                Mh(y, Fe), ne.push(Fe);
                            }
                            U.push(ne);
                        }
                        return U;
                    }
                    function Zc(m, y, I) {
                        for(var U = [], J = 0; J < m.length; J++){
                            var ne = Nf(m[J], y, I);
                            U.push(ne);
                        }
                        return U;
                    }
                    function ds(m, y, I, U) {
                        if (m[0] < I[0] || m[0] > I[2]) {
                            var J = U * .5, ne = m[0] - I[0] > J ? -U : I[0] - m[0] > J ? U : 0;
                            ne === 0 && (ne = m[0] - I[2] > J ? -U : I[2] - m[0] > J ? U : 0), m[0] += ne;
                        }
                        Mh(y, m);
                    }
                    function Ch(m) {
                        m[0] = m[1] = 1 / 0, m[2] = m[3] = -1 / 0;
                    }
                    function Bd(m, y, I, U) {
                        for(var J = Math.pow(2, U.z) * uu, ne = [
                            U.x * uu,
                            U.y * uu
                        ], fe = [], Fe = 0, Qe = m; Fe < Qe.length; Fe += 1)for(var st = Qe[Fe], mt = 0, Xt = st; mt < Xt.length; mt += 1){
                            var ur = Xt[mt], nr = [
                                ur.x + ne[0],
                                ur.y + ne[1]
                            ];
                            ds(nr, y, I, J), fe.push(nr);
                        }
                        return fe;
                    }
                    function Jh(m, y, I, U) {
                        for(var J = Math.pow(2, U.z) * uu, ne = [
                            U.x * uu,
                            U.y * uu
                        ], fe = [], Fe = 0, Qe = m; Fe < Qe.length; Fe += 1){
                            for(var st = Qe[Fe], mt = [], Xt = 0, ur = st; Xt < ur.length; Xt += 1){
                                var nr = ur[Xt], Lr = [
                                    nr.x + ne[0],
                                    nr.y + ne[1]
                                ];
                                Mh(y, Lr), mt.push(Lr);
                            }
                            fe.push(mt);
                        }
                        if (y[2] - y[0] <= J / 2) {
                            Ch(y);
                            for(var Yr = 0, _i = fe; Yr < _i.length; Yr += 1)for(var si = _i[Yr], Hi = 0, Ei = si; Hi < Ei.length; Hi += 1){
                                var Vi = Ei[Hi];
                                ds(Vi, y, I, J);
                            }
                        }
                        return fe;
                    }
                    function Cf(m, y) {
                        var I = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], U = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], J = m.canonicalID();
                        if (y.type === "Polygon") {
                            var ne = Nf(y.coordinates, U, J), fe = Bd(m.geometry(), I, U, J);
                            if (!Ml(I, U)) return !1;
                            for(var Fe = 0, Qe = fe; Fe < Qe.length; Fe += 1){
                                var st = Qe[Fe];
                                if (!hf(st, ne)) return !1;
                            }
                        }
                        if (y.type === "MultiPolygon") {
                            var mt = Zc(y.coordinates, U, J), Xt = Bd(m.geometry(), I, U, J);
                            if (!Ml(I, U)) return !1;
                            for(var ur = 0, nr = Xt; ur < nr.length; ur += 1){
                                var Lr = nr[ur];
                                if (!kh(Lr, mt)) return !1;
                            }
                        }
                        return !0;
                    }
                    function pd(m, y) {
                        var I = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], U = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], J = m.canonicalID();
                        if (y.type === "Polygon") {
                            var ne = Nf(y.coordinates, U, J), fe = Jh(m.geometry(), I, U, J);
                            if (!Ml(I, U)) return !1;
                            for(var Fe = 0, Qe = fe; Fe < Qe.length; Fe += 1){
                                var st = Qe[Fe];
                                if (!df(st, ne)) return !1;
                            }
                        }
                        if (y.type === "MultiPolygon") {
                            var mt = Zc(y.coordinates, U, J), Xt = Jh(m.geometry(), I, U, J);
                            if (!Ml(I, U)) return !1;
                            for(var ur = 0, nr = Xt; ur < nr.length; ur += 1){
                                var Lr = nr[ur];
                                if (!Cu(Lr, mt)) return !1;
                            }
                        }
                        return !0;
                    }
                    var Lu = function(y, I) {
                        this.type = Co, this.geojson = y, this.geometries = I;
                    };
                    Lu.parse = function(y, I) {
                        if (y.length !== 2) return I.error("'within' expression requires exactly one argument, but found " + (y.length - 1) + " instead.");
                        if (Cc(y[1])) {
                            var U = y[1];
                            if (U.type === "FeatureCollection") for(var J = 0; J < U.features.length; ++J){
                                var ne = U.features[J].geometry.type;
                                if (ne === "Polygon" || ne === "MultiPolygon") return new Lu(U, U.features[J].geometry);
                            }
                            else if (U.type === "Feature") {
                                var fe = U.geometry.type;
                                if (fe === "Polygon" || fe === "MultiPolygon") return new Lu(U, U.geometry);
                            } else if (U.type === "Polygon" || U.type === "MultiPolygon") return new Lu(U, U);
                        }
                        return I.error("'within' expression requires valid geojson object that contains polygon geometry type.");
                    }, Lu.prototype.evaluate = function(y) {
                        if (y.geometry() != null && y.canonicalID() != null) {
                            if (y.geometryType() === "Point") return Cf(y, this.geometries);
                            if (y.geometryType() === "LineString") return pd(y, this.geometries);
                        }
                        return !1;
                    }, Lu.prototype.eachChild = function() {}, Lu.prototype.outputDefined = function() {
                        return !0;
                    }, Lu.prototype.serialize = function() {
                        return [
                            "within",
                            this.geojson
                        ];
                    };
                    function $h(m) {
                        if (m instanceof Ja) {
                            if (m.name === "get" && m.args.length === 1) return !1;
                            if (m.name === "feature-state") return !1;
                            if (m.name === "has" && m.args.length === 1) return !1;
                            if (m.name === "properties" || m.name === "geometry-type" || m.name === "id") return !1;
                            if (/^filter-/.test(m.name)) return !1;
                        }
                        if (m instanceof Lu) return !1;
                        var y = !0;
                        return m.eachChild(function(I) {
                            y && !$h(I) && (y = !1);
                        }), y;
                    }
                    function tu(m) {
                        if (m instanceof Ja && m.name === "feature-state") return !1;
                        var y = !0;
                        return m.eachChild(function(I) {
                            y && !tu(I) && (y = !1);
                        }), y;
                    }
                    function Pu(m, y) {
                        if (m instanceof Ja && y.indexOf(m.name) >= 0) return !1;
                        var I = !0;
                        return m.eachChild(function(U) {
                            I && !Pu(U, y) && (I = !1);
                        }), I;
                    }
                    var Lc = function(y, I) {
                        this.type = I.type, this.name = y, this.boundExpression = I;
                    };
                    Lc.parse = function(y, I) {
                        if (y.length !== 2 || typeof y[1] != "string") return I.error("'var' expression requires exactly one string literal argument.");
                        var U = y[1];
                        return I.scope.has(U) ? new Lc(U, I.scope.get(U)) : I.error('Unknown variable "' + U + '". Make sure "' + U + '" has been bound in an enclosing "let" expression before using it.', 1);
                    }, Lc.prototype.evaluate = function(y) {
                        return this.boundExpression.evaluate(y);
                    }, Lc.prototype.eachChild = function() {}, Lc.prototype.outputDefined = function() {
                        return !1;
                    }, Lc.prototype.serialize = function() {
                        return [
                            "var",
                            this.name
                        ];
                    };
                    var fl = function(y, I, U, J, ne) {
                        I === void 0 && (I = []), J === void 0 && (J = new Xl), ne === void 0 && (ne = []), this.registry = y, this.path = I, this.key = I.map(function(fe) {
                            return "[" + fe + "]";
                        }).join(""), this.scope = J, this.errors = ne, this.expectedType = U;
                    };
                    fl.prototype.parse = function(y, I, U, J, ne) {
                        return ne === void 0 && (ne = {}), I ? this.concat(I, U, J)._parse(y, ne) : this._parse(y, ne);
                    }, fl.prototype._parse = function(y, I) {
                        (y === null || typeof y == "string" || typeof y == "boolean" || typeof y == "number") && (y = [
                            "literal",
                            y
                        ]);
                        function U(mt, Xt, ur) {
                            return ur === "assert" ? new Sl(Xt, [
                                mt
                            ]) : ur === "coerce" ? new wo(Xt, [
                                mt
                            ]) : mt;
                        }
                        if (Array.isArray(y)) {
                            if (y.length === 0) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                            var J = y[0];
                            if (typeof J != "string") return this.error("Expression name must be a string, but found " + typeof J + ' instead. If you wanted a literal array, use ["literal", [...]].', 0), null;
                            var ne = this.registry[J];
                            if (ne) {
                                var fe = ne.parse(y, this);
                                if (!fe) return null;
                                if (this.expectedType) {
                                    var Fe = this.expectedType, Qe = fe.type;
                                    if ((Fe.kind === "string" || Fe.kind === "number" || Fe.kind === "boolean" || Fe.kind === "object" || Fe.kind === "array") && Qe.kind === "value") fe = U(fe, Fe, I.typeAnnotation || "assert");
                                    else if ((Fe.kind === "color" || Fe.kind === "formatted" || Fe.kind === "resolvedImage") && (Qe.kind === "value" || Qe.kind === "string")) fe = U(fe, Fe, I.typeAnnotation || "coerce");
                                    else if (this.checkSubtype(Fe, Qe)) return null;
                                }
                                if (!(fe instanceof hs) && fe.type.kind !== "resolvedImage" && Xc(fe)) {
                                    var st = new $o;
                                    try {
                                        fe = new hs(fe.type, fe.evaluate(st));
                                    } catch (mt) {
                                        return this.error(mt.message), null;
                                    }
                                }
                                return fe;
                            }
                            return this.error('Unknown expression "' + J + '". If you wanted a literal array, use ["literal", [...]].', 0);
                        } else return typeof y == "undefined" ? this.error("'undefined' value invalid. Use null instead.") : typeof y == "object" ? this.error('Bare objects invalid. Use ["literal", {...}] instead.') : this.error("Expected an array, but found " + typeof y + " instead.");
                    }, fl.prototype.concat = function(y, I, U) {
                        var J = typeof y == "number" ? this.path.concat(y) : this.path, ne = U ? this.scope.concat(U) : this.scope;
                        return new fl(this.registry, J, I || null, ne, this.errors);
                    }, fl.prototype.error = function(y) {
                        for(var I = [], U = arguments.length - 1; U-- > 0;)I[U] = arguments[U + 1];
                        var J = "" + this.key + I.map(function(ne) {
                            return "[" + ne + "]";
                        }).join("");
                        this.errors.push(new Ks(J, y));
                    }, fl.prototype.checkSubtype = function(y, I) {
                        var U = kc(y, I);
                        return U && this.error(U), U;
                    };
                    function Xc(m) {
                        if (m instanceof Lc) return Xc(m.boundExpression);
                        if (m instanceof Ja && m.name === "error") return !1;
                        if (m instanceof tc) return !1;
                        if (m instanceof Lu) return !1;
                        var y = m instanceof wo || m instanceof Sl, I = !0;
                        return m.eachChild(function(U) {
                            y ? I = I && Xc(U) : I = I && U instanceof hs;
                        }), I ? $h(m) && Pu(m, [
                            "zoom",
                            "heatmap-density",
                            "line-progress",
                            "accumulated",
                            "is-supported-script"
                        ]) : !1;
                    }
                    function ic(m, y) {
                        for(var I = m.length - 1, U = 0, J = I, ne = 0, fe, Fe; U <= J;)if (ne = Math.floor((U + J) / 2), fe = m[ne], Fe = m[ne + 1], fe <= y) {
                            if (ne === I || y < Fe) return ne;
                            U = ne + 1;
                        } else if (fe > y) J = ne - 1;
                        else throw new Ms("Input is not a number.");
                        return 0;
                    }
                    var yu = function(y, I, U) {
                        this.type = y, this.input = I, this.labels = [], this.outputs = [];
                        for(var J = 0, ne = U; J < ne.length; J += 1){
                            var fe = ne[J], Fe = fe[0], Qe = fe[1];
                            this.labels.push(Fe), this.outputs.push(Qe);
                        }
                    };
                    yu.parse = function(y, I) {
                        if (y.length - 1 < 4) return I.error("Expected at least 4 arguments, but found only " + (y.length - 1) + ".");
                        if ((y.length - 1) % 2 !== 0) return I.error("Expected an even number of arguments.");
                        var U = I.parse(y[1], 1, Zn);
                        if (!U) return null;
                        var J = [], ne = null;
                        I.expectedType && I.expectedType.kind !== "value" && (ne = I.expectedType);
                        for(var fe = 1; fe < y.length; fe += 2){
                            var Fe = fe === 1 ? -1 / 0 : y[fe], Qe = y[fe + 1], st = fe, mt = fe + 1;
                            if (typeof Fe != "number") return I.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', st);
                            if (J.length && J[J.length - 1][0] >= Fe) return I.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', st);
                            var Xt = I.parse(Qe, mt, ne);
                            if (!Xt) return null;
                            ne = ne || Xt.type, J.push([
                                Fe,
                                Xt
                            ]);
                        }
                        return new yu(ne, U, J);
                    }, yu.prototype.evaluate = function(y) {
                        var I = this.labels, U = this.outputs;
                        if (I.length === 1) return U[0].evaluate(y);
                        var J = this.input.evaluate(y);
                        if (J <= I[0]) return U[0].evaluate(y);
                        var ne = I.length;
                        if (J >= I[ne - 1]) return U[ne - 1].evaluate(y);
                        var fe = ic(I, J);
                        return U[fe].evaluate(y);
                    }, yu.prototype.eachChild = function(y) {
                        y(this.input);
                        for(var I = 0, U = this.outputs; I < U.length; I += 1){
                            var J = U[I];
                            y(J);
                        }
                    }, yu.prototype.outputDefined = function() {
                        return this.outputs.every(function(y) {
                            return y.outputDefined();
                        });
                    }, yu.prototype.serialize = function() {
                        for(var y = [
                            "step",
                            this.input.serialize()
                        ], I = 0; I < this.labels.length; I++)I > 0 && y.push(this.labels[I]), y.push(this.outputs[I].serialize());
                        return y;
                    };
                    function Qs(m, y, I) {
                        return m * (1 - I) + y * I;
                    }
                    function Qh(m, y, I) {
                        return new ss(Qs(m.r, y.r, I), Qs(m.g, y.g, I), Qs(m.b, y.b, I), Qs(m.a, y.a, I));
                    }
                    function gd(m, y, I) {
                        return m.map(function(U, J) {
                            return Qs(U, y[J], I);
                        });
                    }
                    var Gu = Object.freeze({
                        __proto__: null,
                        number: Qs,
                        color: Qh,
                        array: gd
                    }), Pc = .95047, vc = 1, sv = 1.08883, Lf = 4 / 29, Uf = 6 / 29, Iu = 3 * Uf * Uf, oh = Uf * Uf * Uf, ru = Math.PI / 180, vf = 180 / Math.PI;
                    function md(m) {
                        return m > oh ? Math.pow(m, 1 / 3) : m / Iu + Lf;
                    }
                    function sh(m) {
                        return m > Uf ? m * m * m : Iu * (m - Lf);
                    }
                    function Fs(m) {
                        return 255 * (m <= .0031308 ? 12.92 * m : 1.055 * Math.pow(m, 1 / 2.4) - .055);
                    }
                    function _u(m) {
                        return m /= 255, m <= .04045 ? m / 12.92 : Math.pow((m + .055) / 1.055, 2.4);
                    }
                    function xu(m) {
                        var y = _u(m.r), I = _u(m.g), U = _u(m.b), J = md((.4124564 * y + .3575761 * I + .1804375 * U) / Pc), ne = md((.2126729 * y + .7151522 * I + .072175 * U) / vc), fe = md((.0193339 * y + .119192 * I + .9503041 * U) / sv);
                        return {
                            l: 116 * ne - 16,
                            a: 500 * (J - ne),
                            b: 200 * (ne - fe),
                            alpha: m.a
                        };
                    }
                    function Lh(m) {
                        var y = (m.l + 16) / 116, I = isNaN(m.a) ? y : y + m.a / 500, U = isNaN(m.b) ? y : y - m.b / 200;
                        return y = vc * sh(y), I = Pc * sh(I), U = sv * sh(U), new ss(Fs(3.2404542 * I - 1.5371385 * y - .4985314 * U), Fs(-0.969266 * I + 1.8760108 * y + .041556 * U), Fs(.0556434 * I - .2040259 * y + 1.0572252 * U), m.alpha);
                    }
                    function Is(m, y, I) {
                        return {
                            l: Qs(m.l, y.l, I),
                            a: Qs(m.a, y.a, I),
                            b: Qs(m.b, y.b, I),
                            alpha: Qs(m.alpha, y.alpha, I)
                        };
                    }
                    function Pf(m) {
                        var y = xu(m), I = y.l, U = y.a, J = y.b, ne = Math.atan2(J, U) * vf;
                        return {
                            h: ne < 0 ? ne + 360 : ne,
                            c: Math.sqrt(U * U + J * J),
                            l: I,
                            alpha: m.a
                        };
                    }
                    function Ic(m) {
                        var y = m.h * ru, I = m.c, U = m.l;
                        return Lh({
                            l: U,
                            a: Math.cos(y) * I,
                            b: Math.sin(y) * I,
                            alpha: m.alpha
                        });
                    }
                    function ju(m, y, I) {
                        var U = y - m;
                        return m + I * (U > 180 || U < -180 ? U - 360 * Math.round(U / 360) : U);
                    }
                    function Vf(m, y, I) {
                        return {
                            h: ju(m.h, y.h, I),
                            c: Qs(m.c, y.c, I),
                            l: Qs(m.l, y.l, I),
                            alpha: Qs(m.alpha, y.alpha, I)
                        };
                    }
                    var pc = {
                        forward: xu,
                        reverse: Lh,
                        interpolate: Is
                    }, pf = {
                        forward: Pf,
                        reverse: Ic,
                        interpolate: Vf
                    }, Ph = Object.freeze({
                        __proto__: null,
                        lab: pc,
                        hcl: pf
                    }), Dl = function(y, I, U, J, ne) {
                        this.type = y, this.operator = I, this.interpolation = U, this.input = J, this.labels = [], this.outputs = [];
                        for(var fe = 0, Fe = ne; fe < Fe.length; fe += 1){
                            var Qe = Fe[fe], st = Qe[0], mt = Qe[1];
                            this.labels.push(st), this.outputs.push(mt);
                        }
                    };
                    Dl.interpolationFactor = function(y, I, U, J) {
                        var ne = 0;
                        if (y.name === "exponential") ne = Ih(I, y.base, U, J);
                        else if (y.name === "linear") ne = Ih(I, 1, U, J);
                        else if (y.name === "cubic-bezier") {
                            var fe = y.controlPoints, Fe = new s(fe[0], fe[1], fe[2], fe[3]);
                            ne = Fe.solve(Ih(I, 1, U, J));
                        }
                        return ne;
                    }, Dl.parse = function(y, I) {
                        var U = y[0], J = y[1], ne = y[2], fe = y.slice(3);
                        if (!Array.isArray(J) || J.length === 0) return I.error("Expected an interpolation type expression.", 1);
                        if (J[0] === "linear") J = {
                            name: "linear"
                        };
                        else if (J[0] === "exponential") {
                            var Fe = J[1];
                            if (typeof Fe != "number") return I.error("Exponential interpolation requires a numeric base.", 1, 1);
                            J = {
                                name: "exponential",
                                base: Fe
                            };
                        } else if (J[0] === "cubic-bezier") {
                            var Qe = J.slice(1);
                            if (Qe.length !== 4 || Qe.some(function(si) {
                                return typeof si != "number" || si < 0 || si > 1;
                            })) return I.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                            J = {
                                name: "cubic-bezier",
                                controlPoints: Qe
                            };
                        } else return I.error("Unknown interpolation type " + String(J[0]), 1, 0);
                        if (y.length - 1 < 4) return I.error("Expected at least 4 arguments, but found only " + (y.length - 1) + ".");
                        if ((y.length - 1) % 2 !== 0) return I.error("Expected an even number of arguments.");
                        if (ne = I.parse(ne, 2, Zn), !ne) return null;
                        var st = [], mt = null;
                        U === "interpolate-hcl" || U === "interpolate-lab" ? mt = Tl : I.expectedType && I.expectedType.kind !== "value" && (mt = I.expectedType);
                        for(var Xt = 0; Xt < fe.length; Xt += 2){
                            var ur = fe[Xt], nr = fe[Xt + 1], Lr = Xt + 3, Yr = Xt + 4;
                            if (typeof ur != "number") return I.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', Lr);
                            if (st.length && st[st.length - 1][0] >= ur) return I.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', Lr);
                            var _i = I.parse(nr, Yr, mt);
                            if (!_i) return null;
                            mt = mt || _i.type, st.push([
                                ur,
                                _i
                            ]);
                        }
                        return mt.kind !== "number" && mt.kind !== "color" && !(mt.kind === "array" && mt.itemType.kind === "number" && typeof mt.N == "number") ? I.error("Type " + Ls(mt) + " is not interpolatable.") : new Dl(mt, U, J, ne, st);
                    }, Dl.prototype.evaluate = function(y) {
                        var I = this.labels, U = this.outputs;
                        if (I.length === 1) return U[0].evaluate(y);
                        var J = this.input.evaluate(y);
                        if (J <= I[0]) return U[0].evaluate(y);
                        var ne = I.length;
                        if (J >= I[ne - 1]) return U[ne - 1].evaluate(y);
                        var fe = ic(I, J), Fe = I[fe], Qe = I[fe + 1], st = Dl.interpolationFactor(this.interpolation, J, Fe, Qe), mt = U[fe].evaluate(y), Xt = U[fe + 1].evaluate(y);
                        return this.operator === "interpolate" ? Gu[this.type.kind.toLowerCase()](mt, Xt, st) : this.operator === "interpolate-hcl" ? pf.reverse(pf.interpolate(pf.forward(mt), pf.forward(Xt), st)) : pc.reverse(pc.interpolate(pc.forward(mt), pc.forward(Xt), st));
                    }, Dl.prototype.eachChild = function(y) {
                        y(this.input);
                        for(var I = 0, U = this.outputs; I < U.length; I += 1){
                            var J = U[I];
                            y(J);
                        }
                    }, Dl.prototype.outputDefined = function() {
                        return this.outputs.every(function(y) {
                            return y.outputDefined();
                        });
                    }, Dl.prototype.serialize = function() {
                        var y;
                        this.interpolation.name === "linear" ? y = [
                            "linear"
                        ] : this.interpolation.name === "exponential" ? this.interpolation.base === 1 ? y = [
                            "linear"
                        ] : y = [
                            "exponential",
                            this.interpolation.base
                        ] : y = [
                            "cubic-bezier"
                        ].concat(this.interpolation.controlPoints);
                        for(var I = [
                            this.operator,
                            y,
                            this.input.serialize()
                        ], U = 0; U < this.labels.length; U++)I.push(this.labels[U], this.outputs[U].serialize());
                        return I;
                    };
                    function Ih(m, y, I, U) {
                        var J = U - I, ne = m - I;
                        return J === 0 ? 0 : y === 1 ? ne / J : (Math.pow(y, ne) - 1) / (Math.pow(y, J) - 1);
                    }
                    var Wu = function(y, I) {
                        this.type = y, this.args = I;
                    };
                    Wu.parse = function(y, I) {
                        if (y.length < 2) return I.error("Expectected at least one argument.");
                        var U = null, J = I.expectedType;
                        J && J.kind !== "value" && (U = J);
                        for(var ne = [], fe = 0, Fe = y.slice(1); fe < Fe.length; fe += 1){
                            var Qe = Fe[fe], st = I.parse(Qe, 1 + ne.length, U, void 0, {
                                typeAnnotation: "omit"
                            });
                            if (!st) return null;
                            U = U || st.type, ne.push(st);
                        }
                        var mt = J && ne.some(function(Xt) {
                            return kc(J, Xt.type);
                        });
                        return mt ? new Wu(So, ne) : new Wu(U, ne);
                    }, Wu.prototype.evaluate = function(y) {
                        for(var I = null, U = 0, J, ne = 0, fe = this.args; ne < fe.length; ne += 1){
                            var Fe = fe[ne];
                            if (U++, I = Fe.evaluate(y), I && I instanceof Js && !I.available && (J || (J = I.name), I = null, U === this.args.length && (I = J)), I !== null) break;
                        }
                        return I;
                    }, Wu.prototype.eachChild = function(y) {
                        this.args.forEach(y);
                    }, Wu.prototype.outputDefined = function() {
                        return this.args.every(function(y) {
                            return y.outputDefined();
                        });
                    }, Wu.prototype.serialize = function() {
                        var y = [
                            "coalesce"
                        ];
                        return this.eachChild(function(I) {
                            y.push(I.serialize());
                        }), y;
                    };
                    var Rc = function(y, I) {
                        this.type = I.type, this.bindings = [].concat(y), this.result = I;
                    };
                    Rc.prototype.evaluate = function(y) {
                        return this.result.evaluate(y);
                    }, Rc.prototype.eachChild = function(y) {
                        for(var I = 0, U = this.bindings; I < U.length; I += 1){
                            var J = U[I];
                            y(J[1]);
                        }
                        y(this.result);
                    }, Rc.parse = function(y, I) {
                        if (y.length < 4) return I.error("Expected at least 3 arguments, but found " + (y.length - 1) + " instead.");
                        for(var U = [], J = 1; J < y.length - 1; J += 2){
                            var ne = y[J];
                            if (typeof ne != "string") return I.error("Expected string, but found " + typeof ne + " instead.", J);
                            if (/[^a-zA-Z0-9_]/.test(ne)) return I.error("Variable names must contain only alphanumeric characters or '_'.", J);
                            var fe = I.parse(y[J + 1], J + 1);
                            if (!fe) return null;
                            U.push([
                                ne,
                                fe
                            ]);
                        }
                        var Fe = I.parse(y[y.length - 1], y.length - 1, I.expectedType, U);
                        return Fe ? new Rc(U, Fe) : null;
                    }, Rc.prototype.outputDefined = function() {
                        return this.result.outputDefined();
                    }, Rc.prototype.serialize = function() {
                        for(var y = [
                            "let"
                        ], I = 0, U = this.bindings; I < U.length; I += 1){
                            var J = U[I], ne = J[0], fe = J[1];
                            y.push(ne, fe.serialize());
                        }
                        return y.push(this.result.serialize()), y;
                    };
                    var gc = function(y, I, U) {
                        this.type = y, this.index = I, this.input = U;
                    };
                    gc.parse = function(y, I) {
                        if (y.length !== 3) return I.error("Expected 2 arguments, but found " + (y.length - 1) + " instead.");
                        var U = I.parse(y[1], 1, Zn), J = I.parse(y[2], 2, eu(I.expectedType || So));
                        if (!U || !J) return null;
                        var ne = J.type;
                        return new gc(ne.itemType, U, J);
                    }, gc.prototype.evaluate = function(y) {
                        var I = this.index.evaluate(y), U = this.input.evaluate(y);
                        if (I < 0) throw new Ms("Array index out of bounds: " + I + " < 0.");
                        if (I >= U.length) throw new Ms("Array index out of bounds: " + I + " > " + (U.length - 1) + ".");
                        if (I !== Math.floor(I)) throw new Ms("Array index must be an integer, but found " + I + " instead.");
                        return U[I];
                    }, gc.prototype.eachChild = function(y) {
                        y(this.index), y(this.input);
                    }, gc.prototype.outputDefined = function() {
                        return !1;
                    }, gc.prototype.serialize = function() {
                        return [
                            "at",
                            this.index.serialize(),
                            this.input.serialize()
                        ];
                    };
                    var hl = function(y, I) {
                        this.type = Co, this.needle = y, this.haystack = I;
                    };
                    hl.parse = function(y, I) {
                        if (y.length !== 3) return I.error("Expected 2 arguments, but found " + (y.length - 1) + " instead.");
                        var U = I.parse(y[1], 1, So), J = I.parse(y[2], 2, So);
                        return !U || !J ? null : Of(U.type, [
                            Co,
                            ko,
                            Zn,
                            Ec,
                            So
                        ]) ? new hl(U, J) : I.error("Expected first argument to be of type boolean, string, number or null, but found " + Ls(U.type) + " instead");
                    }, hl.prototype.evaluate = function(y) {
                        var I = this.needle.evaluate(y), U = this.haystack.evaluate(y);
                        if (!U) return !1;
                        if (!Gc(I, [
                            "boolean",
                            "string",
                            "number",
                            "null"
                        ])) throw new Ms("Expected first argument to be of type boolean, string, number or null, but found " + Ls(ws(I)) + " instead.");
                        if (!Gc(U, [
                            "string",
                            "array"
                        ])) throw new Ms("Expected second argument to be of type array or string, but found " + Ls(ws(U)) + " instead.");
                        return U.indexOf(I) >= 0;
                    }, hl.prototype.eachChild = function(y) {
                        y(this.needle), y(this.haystack);
                    }, hl.prototype.outputDefined = function() {
                        return !0;
                    }, hl.prototype.serialize = function() {
                        return [
                            "in",
                            this.needle.serialize(),
                            this.haystack.serialize()
                        ];
                    };
                    var iu = function(y, I, U) {
                        this.type = Zn, this.needle = y, this.haystack = I, this.fromIndex = U;
                    };
                    iu.parse = function(y, I) {
                        if (y.length <= 2 || y.length >= 5) return I.error("Expected 3 or 4 arguments, but found " + (y.length - 1) + " instead.");
                        var U = I.parse(y[1], 1, So), J = I.parse(y[2], 2, So);
                        if (!U || !J) return null;
                        if (!Of(U.type, [
                            Co,
                            ko,
                            Zn,
                            Ec,
                            So
                        ])) return I.error("Expected first argument to be of type boolean, string, number or null, but found " + Ls(U.type) + " instead");
                        if (y.length === 4) {
                            var ne = I.parse(y[3], 3, Zn);
                            return ne ? new iu(U, J, ne) : null;
                        } else return new iu(U, J);
                    }, iu.prototype.evaluate = function(y) {
                        var I = this.needle.evaluate(y), U = this.haystack.evaluate(y);
                        if (!Gc(I, [
                            "boolean",
                            "string",
                            "number",
                            "null"
                        ])) throw new Ms("Expected first argument to be of type boolean, string, number or null, but found " + Ls(ws(I)) + " instead.");
                        if (!Gc(U, [
                            "string",
                            "array"
                        ])) throw new Ms("Expected second argument to be of type array or string, but found " + Ls(ws(U)) + " instead.");
                        if (this.fromIndex) {
                            var J = this.fromIndex.evaluate(y);
                            return U.indexOf(I, J);
                        }
                        return U.indexOf(I);
                    }, iu.prototype.eachChild = function(y) {
                        y(this.needle), y(this.haystack), this.fromIndex && y(this.fromIndex);
                    }, iu.prototype.outputDefined = function() {
                        return !1;
                    }, iu.prototype.serialize = function() {
                        if (this.fromIndex != null && this.fromIndex !== void 0) {
                            var y = this.fromIndex.serialize();
                            return [
                                "index-of",
                                this.needle.serialize(),
                                this.haystack.serialize(),
                                y
                            ];
                        }
                        return [
                            "index-of",
                            this.needle.serialize(),
                            this.haystack.serialize()
                        ];
                    };
                    var mc = function(y, I, U, J, ne, fe) {
                        this.inputType = y, this.type = I, this.input = U, this.cases = J, this.outputs = ne, this.otherwise = fe;
                    };
                    mc.parse = function(y, I) {
                        if (y.length < 5) return I.error("Expected at least 4 arguments, but found only " + (y.length - 1) + ".");
                        if (y.length % 2 !== 1) return I.error("Expected an even number of arguments.");
                        var U, J;
                        I.expectedType && I.expectedType.kind !== "value" && (J = I.expectedType);
                        for(var ne = {}, fe = [], Fe = 2; Fe < y.length - 1; Fe += 2){
                            var Qe = y[Fe], st = y[Fe + 1];
                            Array.isArray(Qe) || (Qe = [
                                Qe
                            ]);
                            var mt = I.concat(Fe);
                            if (Qe.length === 0) return mt.error("Expected at least one branch label.");
                            for(var Xt = 0, ur = Qe; Xt < ur.length; Xt += 1){
                                var nr = ur[Xt];
                                if (typeof nr != "number" && typeof nr != "string") return mt.error("Branch labels must be numbers or strings.");
                                if (typeof nr == "number" && Math.abs(nr) > Number.MAX_SAFE_INTEGER) return mt.error("Branch labels must be integers no larger than " + Number.MAX_SAFE_INTEGER + ".");
                                if (typeof nr == "number" && Math.floor(nr) !== nr) return mt.error("Numeric branch labels must be integer values.");
                                if (!U) U = ws(nr);
                                else if (mt.checkSubtype(U, ws(nr))) return null;
                                if (typeof ne[String(nr)] != "undefined") return mt.error("Branch labels must be unique.");
                                ne[String(nr)] = fe.length;
                            }
                            var Lr = I.parse(st, Fe, J);
                            if (!Lr) return null;
                            J = J || Lr.type, fe.push(Lr);
                        }
                        var Yr = I.parse(y[1], 1, So);
                        if (!Yr) return null;
                        var _i = I.parse(y[y.length - 1], y.length - 1, J);
                        return !_i || Yr.type.kind !== "value" && I.concat(1).checkSubtype(U, Yr.type) ? null : new mc(U, J, Yr, ne, fe, _i);
                    }, mc.prototype.evaluate = function(y) {
                        var I = this.input.evaluate(y), U = ws(I) === this.inputType && this.outputs[this.cases[I]] || this.otherwise;
                        return U.evaluate(y);
                    }, mc.prototype.eachChild = function(y) {
                        y(this.input), this.outputs.forEach(y), y(this.otherwise);
                    }, mc.prototype.outputDefined = function() {
                        return this.outputs.every(function(y) {
                            return y.outputDefined();
                        }) && this.otherwise.outputDefined();
                    }, mc.prototype.serialize = function() {
                        for(var y = this, I = [
                            "match",
                            this.input.serialize()
                        ], U = Object.keys(this.cases).sort(), J = [], ne = {}, fe = 0, Fe = U; fe < Fe.length; fe += 1){
                            var Qe = Fe[fe], st = ne[this.cases[Qe]];
                            st === void 0 ? (ne[this.cases[Qe]] = J.length, J.push([
                                this.cases[Qe],
                                [
                                    Qe
                                ]
                            ])) : J[st][1].push(Qe);
                        }
                        for(var mt = function(Yr) {
                            return y.inputType.kind === "number" ? Number(Yr) : Yr;
                        }, Xt = 0, ur = J; Xt < ur.length; Xt += 1){
                            var nr = ur[Xt], st = nr[0], Lr = nr[1];
                            Lr.length === 1 ? I.push(mt(Lr[0])) : I.push(Lr.map(mt)), I.push(this.outputs[outputIndex$1].serialize());
                        }
                        return I.push(this.otherwise.serialize()), I;
                    };
                    var Yc = function(y, I, U) {
                        this.type = y, this.branches = I, this.otherwise = U;
                    };
                    Yc.parse = function(y, I) {
                        if (y.length < 4) return I.error("Expected at least 3 arguments, but found only " + (y.length - 1) + ".");
                        if (y.length % 2 !== 0) return I.error("Expected an odd number of arguments.");
                        var U;
                        I.expectedType && I.expectedType.kind !== "value" && (U = I.expectedType);
                        for(var J = [], ne = 1; ne < y.length - 1; ne += 2){
                            var fe = I.parse(y[ne], ne, Co);
                            if (!fe) return null;
                            var Fe = I.parse(y[ne + 1], ne + 1, U);
                            if (!Fe) return null;
                            J.push([
                                fe,
                                Fe
                            ]), U = U || Fe.type;
                        }
                        var Qe = I.parse(y[y.length - 1], y.length - 1, U);
                        return Qe ? new Yc(U, J, Qe) : null;
                    }, Yc.prototype.evaluate = function(y) {
                        for(var I = 0, U = this.branches; I < U.length; I += 1){
                            var J = U[I], ne = J[0], fe = J[1];
                            if (ne.evaluate(y)) return fe.evaluate(y);
                        }
                        return this.otherwise.evaluate(y);
                    }, Yc.prototype.eachChild = function(y) {
                        for(var I = 0, U = this.branches; I < U.length; I += 1){
                            var J = U[I], ne = J[0], fe = J[1];
                            y(ne), y(fe);
                        }
                        y(this.otherwise);
                    }, Yc.prototype.outputDefined = function() {
                        return this.branches.every(function(y) {
                            var I = y[0], U = y[1];
                            return U.outputDefined();
                        }) && this.otherwise.outputDefined();
                    }, Yc.prototype.serialize = function() {
                        var y = [
                            "case"
                        ];
                        return this.eachChild(function(I) {
                            y.push(I.serialize());
                        }), y;
                    };
                    var nc = function(y, I, U, J) {
                        this.type = y, this.input = I, this.beginIndex = U, this.endIndex = J;
                    };
                    nc.parse = function(y, I) {
                        if (y.length <= 2 || y.length >= 5) return I.error("Expected 3 or 4 arguments, but found " + (y.length - 1) + " instead.");
                        var U = I.parse(y[1], 1, So), J = I.parse(y[2], 2, Zn);
                        if (!U || !J) return null;
                        if (!Of(U.type, [
                            eu(So),
                            ko,
                            So
                        ])) return I.error("Expected first argument to be of type array or string, but found " + Ls(U.type) + " instead");
                        if (y.length === 4) {
                            var ne = I.parse(y[3], 3, Zn);
                            return ne ? new nc(U.type, U, J, ne) : null;
                        } else return new nc(U.type, U, J);
                    }, nc.prototype.evaluate = function(y) {
                        var I = this.input.evaluate(y), U = this.beginIndex.evaluate(y);
                        if (!Gc(I, [
                            "string",
                            "array"
                        ])) throw new Ms("Expected first argument to be of type array or string, but found " + Ls(ws(I)) + " instead.");
                        if (this.endIndex) {
                            var J = this.endIndex.evaluate(y);
                            return I.slice(U, J);
                        }
                        return I.slice(U);
                    }, nc.prototype.eachChild = function(y) {
                        y(this.input), y(this.beginIndex), this.endIndex && y(this.endIndex);
                    }, nc.prototype.outputDefined = function() {
                        return !1;
                    }, nc.prototype.serialize = function() {
                        if (this.endIndex != null && this.endIndex !== void 0) {
                            var y = this.endIndex.serialize();
                            return [
                                "slice",
                                this.input.serialize(),
                                this.beginIndex.serialize(),
                                y
                            ];
                        }
                        return [
                            "slice",
                            this.input.serialize(),
                            this.beginIndex.serialize()
                        ];
                    };
                    function gf(m, y) {
                        return m === "==" || m === "!=" ? y.kind === "boolean" || y.kind === "string" || y.kind === "number" || y.kind === "null" || y.kind === "value" : y.kind === "string" || y.kind === "number" || y.kind === "value";
                    }
                    function gt(m, y, I) {
                        return y === I;
                    }
                    function Bt(m, y, I) {
                        return y !== I;
                    }
                    function wr(m, y, I) {
                        return y < I;
                    }
                    function vr(m, y, I) {
                        return y > I;
                    }
                    function Ur(m, y, I) {
                        return y <= I;
                    }
                    function fi(m, y, I) {
                        return y >= I;
                    }
                    function xi(m, y, I, U) {
                        return U.compare(y, I) === 0;
                    }
                    function Fi(m, y, I, U) {
                        return !xi(m, y, I, U);
                    }
                    function Xi(m, y, I, U) {
                        return U.compare(y, I) < 0;
                    }
                    function hn(m, y, I, U) {
                        return U.compare(y, I) > 0;
                    }
                    function Ti(m, y, I, U) {
                        return U.compare(y, I) <= 0;
                    }
                    function qi(m, y, I, U) {
                        return U.compare(y, I) >= 0;
                    }
                    function Ii(m, y, I) {
                        var U = m !== "==" && m !== "!=";
                        return function() {
                            function J(ne, fe, Fe) {
                                this.type = Co, this.lhs = ne, this.rhs = fe, this.collator = Fe, this.hasUntypedArgument = ne.type.kind === "value" || fe.type.kind === "value";
                            }
                            return J.parse = function(fe, Fe) {
                                if (fe.length !== 3 && fe.length !== 4) return Fe.error("Expected two or three arguments.");
                                var Qe = fe[0], st = Fe.parse(fe[1], 1, So);
                                if (!st) return null;
                                if (!gf(Qe, st.type)) return Fe.concat(1).error('"' + Qe + `" comparisons are not supported for type '` + Ls(st.type) + "'.");
                                var mt = Fe.parse(fe[2], 2, So);
                                if (!mt) return null;
                                if (!gf(Qe, mt.type)) return Fe.concat(2).error('"' + Qe + `" comparisons are not supported for type '` + Ls(mt.type) + "'.");
                                if (st.type.kind !== mt.type.kind && st.type.kind !== "value" && mt.type.kind !== "value") return Fe.error("Cannot compare types '" + Ls(st.type) + "' and '" + Ls(mt.type) + "'.");
                                U && (st.type.kind === "value" && mt.type.kind !== "value" ? st = new Sl(mt.type, [
                                    st
                                ]) : st.type.kind !== "value" && mt.type.kind === "value" && (mt = new Sl(st.type, [
                                    mt
                                ])));
                                var Xt = null;
                                if (fe.length === 4) {
                                    if (st.type.kind !== "string" && mt.type.kind !== "string" && st.type.kind !== "value" && mt.type.kind !== "value") return Fe.error("Cannot use collator to compare non-string types.");
                                    if (Xt = Fe.parse(fe[3], 3, rh), !Xt) return null;
                                }
                                return new J(st, mt, Xt);
                            }, J.prototype.evaluate = function(fe) {
                                var Fe = this.lhs.evaluate(fe), Qe = this.rhs.evaluate(fe);
                                if (U && this.hasUntypedArgument) {
                                    var st = ws(Fe), mt = ws(Qe);
                                    if (st.kind !== mt.kind || !(st.kind === "string" || st.kind === "number")) throw new Ms('Expected arguments for "' + m + '" to be (string, string) or (number, number), but found (' + st.kind + ", " + mt.kind + ") instead.");
                                }
                                if (this.collator && !U && this.hasUntypedArgument) {
                                    var Xt = ws(Fe), ur = ws(Qe);
                                    if (Xt.kind !== "string" || ur.kind !== "string") return y(fe, Fe, Qe);
                                }
                                return this.collator ? I(fe, Fe, Qe, this.collator.evaluate(fe)) : y(fe, Fe, Qe);
                            }, J.prototype.eachChild = function(fe) {
                                fe(this.lhs), fe(this.rhs), this.collator && fe(this.collator);
                            }, J.prototype.outputDefined = function() {
                                return !0;
                            }, J.prototype.serialize = function() {
                                var fe = [
                                    m
                                ];
                                return this.eachChild(function(Fe) {
                                    fe.push(Fe.serialize());
                                }), fe;
                            }, J;
                        }();
                    }
                    var mi = Ii("==", gt, xi), Pn = Ii("!=", Bt, Fi), Ma = Ii("<", wr, Xi), Ta = Ii(">", vr, hn), Ea = Ii("<=", Ur, Ti), qa = Ii(">=", fi, qi), Cn = function(y, I, U, J, ne) {
                        this.type = ko, this.number = y, this.locale = I, this.currency = U, this.minFractionDigits = J, this.maxFractionDigits = ne;
                    };
                    Cn.parse = function(y, I) {
                        if (y.length !== 3) return I.error("Expected two arguments.");
                        var U = I.parse(y[1], 1, Zn);
                        if (!U) return null;
                        var J = y[2];
                        if (typeof J != "object" || Array.isArray(J)) return I.error("NumberFormat options argument must be an object.");
                        var ne = null;
                        if (J.locale && (ne = I.parse(J.locale, 1, ko), !ne)) return null;
                        var fe = null;
                        if (J.currency && (fe = I.parse(J.currency, 1, ko), !fe)) return null;
                        var Fe = null;
                        if (J["min-fraction-digits"] && (Fe = I.parse(J["min-fraction-digits"], 1, Zn), !Fe)) return null;
                        var Qe = null;
                        return J["max-fraction-digits"] && (Qe = I.parse(J["max-fraction-digits"], 1, Zn), !Qe) ? null : new Cn(U, ne, fe, Fe, Qe);
                    }, Cn.prototype.evaluate = function(y) {
                        return new Intl.NumberFormat(this.locale ? this.locale.evaluate(y) : [], {
                            style: this.currency ? "currency" : "decimal",
                            currency: this.currency ? this.currency.evaluate(y) : void 0,
                            minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(y) : void 0,
                            maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(y) : void 0
                        }).format(this.number.evaluate(y));
                    }, Cn.prototype.eachChild = function(y) {
                        y(this.number), this.locale && y(this.locale), this.currency && y(this.currency), this.minFractionDigits && y(this.minFractionDigits), this.maxFractionDigits && y(this.maxFractionDigits);
                    }, Cn.prototype.outputDefined = function() {
                        return !1;
                    }, Cn.prototype.serialize = function() {
                        var y = {};
                        return this.locale && (y.locale = this.locale.serialize()), this.currency && (y.currency = this.currency.serialize()), this.minFractionDigits && (y["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (y["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                            "number-format",
                            this.number.serialize(),
                            y
                        ];
                    };
                    var sn = function(y) {
                        this.type = Zn, this.input = y;
                    };
                    sn.parse = function(y, I) {
                        if (y.length !== 2) return I.error("Expected 1 argument, but found " + (y.length - 1) + " instead.");
                        var U = I.parse(y[1], 1);
                        return U ? U.type.kind !== "array" && U.type.kind !== "string" && U.type.kind !== "value" ? I.error("Expected argument of type string or array, but found " + Ls(U.type) + " instead.") : new sn(U) : null;
                    }, sn.prototype.evaluate = function(y) {
                        var I = this.input.evaluate(y);
                        if (typeof I == "string") return I.length;
                        if (Array.isArray(I)) return I.length;
                        throw new Ms("Expected value to be of type string or array, but found " + Ls(ws(I)) + " instead.");
                    }, sn.prototype.eachChild = function(y) {
                        y(this.input);
                    }, sn.prototype.outputDefined = function() {
                        return !1;
                    }, sn.prototype.serialize = function() {
                        var y = [
                            "length"
                        ];
                        return this.eachChild(function(I) {
                            y.push(I.serialize());
                        }), y;
                    };
                    var Ua = {
                        "==": mi,
                        "!=": Pn,
                        ">": Ta,
                        "<": Ma,
                        ">=": qa,
                        "<=": Ea,
                        array: Sl,
                        at: gc,
                        boolean: Sl,
                        case: Yc,
                        coalesce: Wu,
                        collator: tc,
                        format: ec,
                        image: Ps,
                        in: hl,
                        "index-of": iu,
                        interpolate: Dl,
                        "interpolate-hcl": Dl,
                        "interpolate-lab": Dl,
                        length: sn,
                        let: Rc,
                        literal: hs,
                        match: mc,
                        number: Sl,
                        "number-format": Cn,
                        object: Sl,
                        slice: nc,
                        step: yu,
                        string: Sl,
                        "to-boolean": wo,
                        "to-color": wo,
                        "to-number": wo,
                        "to-string": wo,
                        var: Lc,
                        within: Lu
                    };
                    function mo(m, y) {
                        var I = y[0], U = y[1], J = y[2], ne = y[3];
                        I = I.evaluate(m), U = U.evaluate(m), J = J.evaluate(m);
                        var fe = ne ? ne.evaluate(m) : 1, Fe = hc(I, U, J, fe);
                        if (Fe) throw new Ms(Fe);
                        return new ss(I / 255 * fe, U / 255 * fe, J / 255 * fe, fe);
                    }
                    function Xo(m, y) {
                        return m in y;
                    }
                    function Ts(m, y) {
                        var I = y[m];
                        return typeof I == "undefined" ? null : I;
                    }
                    function Qo(m, y, I, U) {
                        for(; I <= U;){
                            var J = I + U >> 1;
                            if (y[J] === m) return !0;
                            y[J] > m ? U = J - 1 : I = J + 1;
                        }
                        return !1;
                    }
                    function ys(m) {
                        return {
                            type: m
                        };
                    }
                    Ja.register(Ua, {
                        error: [
                            cf,
                            [
                                ko
                            ],
                            function(m, y) {
                                var I = y[0];
                                throw new Ms(I.evaluate(m));
                            }
                        ],
                        typeof: [
                            ko,
                            [
                                So
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Ls(ws(I.evaluate(m)));
                            }
                        ],
                        "to-rgba": [
                            eu(Zn, 4),
                            [
                                Tl
                            ],
                            function(m, y) {
                                var I = y[0];
                                return I.evaluate(m).toArray();
                            }
                        ],
                        rgb: [
                            Tl,
                            [
                                Zn,
                                Zn,
                                Zn
                            ],
                            mo
                        ],
                        rgba: [
                            Tl,
                            [
                                Zn,
                                Zn,
                                Zn,
                                Zn
                            ],
                            mo
                        ],
                        has: {
                            type: Co,
                            overloads: [
                                [
                                    [
                                        ko
                                    ],
                                    function(m, y) {
                                        var I = y[0];
                                        return Xo(I.evaluate(m), m.properties());
                                    }
                                ],
                                [
                                    [
                                        ko,
                                        uf
                                    ],
                                    function(m, y) {
                                        var I = y[0], U = y[1];
                                        return Xo(I.evaluate(m), U.evaluate(m));
                                    }
                                ]
                            ]
                        },
                        get: {
                            type: So,
                            overloads: [
                                [
                                    [
                                        ko
                                    ],
                                    function(m, y) {
                                        var I = y[0];
                                        return Ts(I.evaluate(m), m.properties());
                                    }
                                ],
                                [
                                    [
                                        ko,
                                        uf
                                    ],
                                    function(m, y) {
                                        var I = y[0], U = y[1];
                                        return Ts(I.evaluate(m), U.evaluate(m));
                                    }
                                ]
                            ]
                        },
                        "feature-state": [
                            So,
                            [
                                ko
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Ts(I.evaluate(m), m.featureState || {});
                            }
                        ],
                        properties: [
                            uf,
                            [],
                            function(m) {
                                return m.properties();
                            }
                        ],
                        "geometry-type": [
                            ko,
                            [],
                            function(m) {
                                return m.geometryType();
                            }
                        ],
                        id: [
                            So,
                            [],
                            function(m) {
                                return m.id();
                            }
                        ],
                        zoom: [
                            Zn,
                            [],
                            function(m) {
                                return m.globals.zoom;
                            }
                        ],
                        "heatmap-density": [
                            Zn,
                            [],
                            function(m) {
                                return m.globals.heatmapDensity || 0;
                            }
                        ],
                        "line-progress": [
                            Zn,
                            [],
                            function(m) {
                                return m.globals.lineProgress || 0;
                            }
                        ],
                        accumulated: [
                            So,
                            [],
                            function(m) {
                                return m.globals.accumulated === void 0 ? null : m.globals.accumulated;
                            }
                        ],
                        "+": [
                            Zn,
                            ys(Zn),
                            function(m, y) {
                                for(var I = 0, U = 0, J = y; U < J.length; U += 1){
                                    var ne = J[U];
                                    I += ne.evaluate(m);
                                }
                                return I;
                            }
                        ],
                        "*": [
                            Zn,
                            ys(Zn),
                            function(m, y) {
                                for(var I = 1, U = 0, J = y; U < J.length; U += 1){
                                    var ne = J[U];
                                    I *= ne.evaluate(m);
                                }
                                return I;
                            }
                        ],
                        "-": {
                            type: Zn,
                            overloads: [
                                [
                                    [
                                        Zn,
                                        Zn
                                    ],
                                    function(m, y) {
                                        var I = y[0], U = y[1];
                                        return I.evaluate(m) - U.evaluate(m);
                                    }
                                ],
                                [
                                    [
                                        Zn
                                    ],
                                    function(m, y) {
                                        var I = y[0];
                                        return -I.evaluate(m);
                                    }
                                ]
                            ]
                        },
                        "/": [
                            Zn,
                            [
                                Zn,
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0], U = y[1];
                                return I.evaluate(m) / U.evaluate(m);
                            }
                        ],
                        "%": [
                            Zn,
                            [
                                Zn,
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0], U = y[1];
                                return I.evaluate(m) % U.evaluate(m);
                            }
                        ],
                        ln2: [
                            Zn,
                            [],
                            function() {
                                return Math.LN2;
                            }
                        ],
                        pi: [
                            Zn,
                            [],
                            function() {
                                return Math.PI;
                            }
                        ],
                        e: [
                            Zn,
                            [],
                            function() {
                                return Math.E;
                            }
                        ],
                        "^": [
                            Zn,
                            [
                                Zn,
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0], U = y[1];
                                return Math.pow(I.evaluate(m), U.evaluate(m));
                            }
                        ],
                        sqrt: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.sqrt(I.evaluate(m));
                            }
                        ],
                        log10: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.log(I.evaluate(m)) / Math.LN10;
                            }
                        ],
                        ln: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.log(I.evaluate(m));
                            }
                        ],
                        log2: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.log(I.evaluate(m)) / Math.LN2;
                            }
                        ],
                        sin: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.sin(I.evaluate(m));
                            }
                        ],
                        cos: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.cos(I.evaluate(m));
                            }
                        ],
                        tan: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.tan(I.evaluate(m));
                            }
                        ],
                        asin: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.asin(I.evaluate(m));
                            }
                        ],
                        acos: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.acos(I.evaluate(m));
                            }
                        ],
                        atan: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.atan(I.evaluate(m));
                            }
                        ],
                        min: [
                            Zn,
                            ys(Zn),
                            function(m, y) {
                                return Math.min.apply(Math, y.map(function(I) {
                                    return I.evaluate(m);
                                }));
                            }
                        ],
                        max: [
                            Zn,
                            ys(Zn),
                            function(m, y) {
                                return Math.max.apply(Math, y.map(function(I) {
                                    return I.evaluate(m);
                                }));
                            }
                        ],
                        abs: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.abs(I.evaluate(m));
                            }
                        ],
                        round: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0], U = I.evaluate(m);
                                return U < 0 ? -Math.round(-U) : Math.round(U);
                            }
                        ],
                        floor: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.floor(I.evaluate(m));
                            }
                        ],
                        ceil: [
                            Zn,
                            [
                                Zn
                            ],
                            function(m, y) {
                                var I = y[0];
                                return Math.ceil(I.evaluate(m));
                            }
                        ],
                        "filter-==": [
                            Co,
                            [
                                ko,
                                So
                            ],
                            function(m, y) {
                                var I = y[0], U = y[1];
                                return m.properties()[I.value] === U.value;
                            }
                        ],
                        "filter-id-==": [
                            Co,
                            [
                                So
                            ],
                            function(m, y) {
                                var I = y[0];
                                return m.id() === I.value;
                            }
                        ],
                        "filter-type-==": [
                            Co,
                            [
                                ko
                            ],
                            function(m, y) {
                                var I = y[0];
                                return m.geometryType() === I.value;
                            }
                        ],
                        "filter-<": [
                            Co,
                            [
                                ko,
                                So
                            ],
                            function(m, y) {
                                var I = y[0], U = y[1], J = m.properties()[I.value], ne = U.value;
                                return typeof J == typeof ne && J < ne;
                            }
                        ],
                        "filter-id-<": [
                            Co,
                            [
                                So
                            ],
                            function(m, y) {
                                var I = y[0], U = m.id(), J = I.value;
                                return typeof U == typeof J && U < J;
                            }
                        ],
                        "filter->": [
                            Co,
                            [
                                ko,
                                So
                            ],
                            function(m, y) {
                                var I = y[0], U = y[1], J = m.properties()[I.value], ne = U.value;
                                return typeof J == typeof ne && J > ne;
                            }
                        ],
                        "filter-id->": [
                            Co,
                            [
                                So
                            ],
                            function(m, y) {
                                var I = y[0], U = m.id(), J = I.value;
                                return typeof U == typeof J && U > J;
                            }
                        ],
                        "filter-<=": [
                            Co,
                            [
                                ko,
                                So
                            ],
                            function(m, y) {
                                var I = y[0], U = y[1], J = m.properties()[I.value], ne = U.value;
                                return typeof J == typeof ne && J <= ne;
                            }
                        ],
                        "filter-id-<=": [
                            Co,
                            [
                                So
                            ],
                            function(m, y) {
                                var I = y[0], U = m.id(), J = I.value;
                                return typeof U == typeof J && U <= J;
                            }
                        ],
                        "filter->=": [
                            Co,
                            [
                                ko,
                                So
                            ],
                            function(m, y) {
                                var I = y[0], U = y[1], J = m.properties()[I.value], ne = U.value;
                                return typeof J == typeof ne && J >= ne;
                            }
                        ],
                        "filter-id->=": [
                            Co,
                            [
                                So
                            ],
                            function(m, y) {
                                var I = y[0], U = m.id(), J = I.value;
                                return typeof U == typeof J && U >= J;
                            }
                        ],
                        "filter-has": [
                            Co,
                            [
                                So
                            ],
                            function(m, y) {
                                var I = y[0];
                                return I.value in m.properties();
                            }
                        ],
                        "filter-has-id": [
                            Co,
                            [],
                            function(m) {
                                return m.id() !== null && m.id() !== void 0;
                            }
                        ],
                        "filter-type-in": [
                            Co,
                            [
                                eu(ko)
                            ],
                            function(m, y) {
                                var I = y[0];
                                return I.value.indexOf(m.geometryType()) >= 0;
                            }
                        ],
                        "filter-id-in": [
                            Co,
                            [
                                eu(So)
                            ],
                            function(m, y) {
                                var I = y[0];
                                return I.value.indexOf(m.id()) >= 0;
                            }
                        ],
                        "filter-in-small": [
                            Co,
                            [
                                ko,
                                eu(So)
                            ],
                            function(m, y) {
                                var I = y[0], U = y[1];
                                return U.value.indexOf(m.properties()[I.value]) >= 0;
                            }
                        ],
                        "filter-in-large": [
                            Co,
                            [
                                ko,
                                eu(So)
                            ],
                            function(m, y) {
                                var I = y[0], U = y[1];
                                return Qo(m.properties()[I.value], U.value, 0, U.value.length - 1);
                            }
                        ],
                        all: {
                            type: Co,
                            overloads: [
                                [
                                    [
                                        Co,
                                        Co
                                    ],
                                    function(m, y) {
                                        var I = y[0], U = y[1];
                                        return I.evaluate(m) && U.evaluate(m);
                                    }
                                ],
                                [
                                    ys(Co),
                                    function(m, y) {
                                        for(var I = 0, U = y; I < U.length; I += 1){
                                            var J = U[I];
                                            if (!J.evaluate(m)) return !1;
                                        }
                                        return !0;
                                    }
                                ]
                            ]
                        },
                        any: {
                            type: Co,
                            overloads: [
                                [
                                    [
                                        Co,
                                        Co
                                    ],
                                    function(m, y) {
                                        var I = y[0], U = y[1];
                                        return I.evaluate(m) || U.evaluate(m);
                                    }
                                ],
                                [
                                    ys(Co),
                                    function(m, y) {
                                        for(var I = 0, U = y; I < U.length; I += 1){
                                            var J = U[I];
                                            if (J.evaluate(m)) return !0;
                                        }
                                        return !1;
                                    }
                                ]
                            ]
                        },
                        "!": [
                            Co,
                            [
                                Co
                            ],
                            function(m, y) {
                                var I = y[0];
                                return !I.evaluate(m);
                            }
                        ],
                        "is-supported-script": [
                            Co,
                            [
                                ko
                            ],
                            function(m, y) {
                                var I = y[0], U = m.globals && m.globals.isSupportedScript;
                                return U ? U(I.evaluate(m)) : !0;
                            }
                        ],
                        upcase: [
                            ko,
                            [
                                ko
                            ],
                            function(m, y) {
                                var I = y[0];
                                return I.evaluate(m).toUpperCase();
                            }
                        ],
                        downcase: [
                            ko,
                            [
                                ko
                            ],
                            function(m, y) {
                                var I = y[0];
                                return I.evaluate(m).toLowerCase();
                            }
                        ],
                        concat: [
                            ko,
                            ys(So),
                            function(m, y) {
                                return y.map(function(I) {
                                    return $s(I.evaluate(m));
                                }).join("");
                            }
                        ],
                        "resolved-locale": [
                            ko,
                            [
                                rh
                            ],
                            function(m, y) {
                                var I = y[0];
                                return I.evaluate(m).resolvedLocale();
                            }
                        ]
                    });
                    function Bo(m) {
                        return {
                            result: "success",
                            value: m
                        };
                    }
                    function yl(m) {
                        return {
                            result: "error",
                            value: m
                        };
                    }
                    function Gs(m) {
                        return m["property-type"] === "data-driven" || m["property-type"] === "cross-faded-data-driven";
                    }
                    function Rs(m) {
                        return !!m.expression && m.expression.parameters.indexOf("zoom") > -1;
                    }
                    function ia(m) {
                        return !!m.expression && m.expression.interpolated;
                    }
                    function Ka(m) {
                        return m instanceof Number ? "number" : m instanceof String ? "string" : m instanceof Boolean ? "boolean" : Array.isArray(m) ? "array" : m === null ? "null" : typeof m;
                    }
                    function vs(m) {
                        return typeof m == "object" && m !== null && !Array.isArray(m);
                    }
                    function Ko(m) {
                        return m;
                    }
                    function nu(m, y) {
                        var I = y.type === "color", U = m.stops && typeof m.stops[0][0] == "object", J = U || m.property !== void 0, ne = U || !J, fe = m.type || (ia(y) ? "exponential" : "interval");
                        if (I && (m = Rl({}, m), m.stops && (m.stops = m.stops.map(function($n) {
                            return [
                                $n[0],
                                ss.parse($n[1])
                            ];
                        })), m.default ? m.default = ss.parse(m.default) : m.default = ss.parse(y.default)), m.colorSpace && m.colorSpace !== "rgb" && !Ph[m.colorSpace]) throw new Error("Unknown color space: " + m.colorSpace);
                        var Fe, Qe, st;
                        if (fe === "exponential") Fe = bu;
                        else if (fe === "interval") Fe = mf;
                        else if (fe === "categorical") {
                            Fe = ac, Qe = Object.create(null);
                            for(var mt = 0, Xt = m.stops; mt < Xt.length; mt += 1){
                                var ur = Xt[mt];
                                Qe[ur[0]] = ur[1];
                            }
                            st = typeof m.stops[0][0];
                        } else if (fe === "identity") Fe = Kc;
                        else throw new Error('Unknown function type "' + fe + '"');
                        if (U) {
                            for(var nr = {}, Lr = [], Yr = 0; Yr < m.stops.length; Yr++){
                                var _i = m.stops[Yr], si = _i[0].zoom;
                                nr[si] === void 0 && (nr[si] = {
                                    zoom: si,
                                    type: m.type,
                                    property: m.property,
                                    default: m.default,
                                    stops: []
                                }, Lr.push(si)), nr[si].stops.push([
                                    _i[0].value,
                                    _i[1]
                                ]);
                            }
                            for(var Hi = [], Ei = 0, Vi = Lr; Ei < Vi.length; Ei += 1){
                                var en = Vi[Ei];
                                Hi.push([
                                    nr[en].zoom,
                                    nu(nr[en], y)
                                ]);
                            }
                            var An = {
                                name: "linear"
                            };
                            return {
                                kind: "composite",
                                interpolationType: An,
                                interpolationFactor: Dl.interpolationFactor.bind(void 0, An),
                                zoomStops: Hi.map(function($n) {
                                    return $n[0];
                                }),
                                evaluate: function(Ba, _a) {
                                    var Pa = Ba.zoom;
                                    return bu({
                                        stops: Hi,
                                        base: m.base
                                    }, y, Pa).evaluate(Pa, _a);
                                }
                            };
                        } else if (ne) {
                            var ra = fe === "exponential" ? {
                                name: "exponential",
                                base: m.base !== void 0 ? m.base : 1
                            } : null;
                            return {
                                kind: "camera",
                                interpolationType: ra,
                                interpolationFactor: Dl.interpolationFactor.bind(void 0, ra),
                                zoomStops: m.stops.map(function($n) {
                                    return $n[0];
                                }),
                                evaluate: function($n) {
                                    var Ba = $n.zoom;
                                    return Fe(m, y, Ba, Qe, st);
                                }
                            };
                        } else return {
                            kind: "source",
                            evaluate: function(Ba, _a) {
                                var Pa = _a && _a.properties ? _a.properties[m.property] : void 0;
                                return Pa === void 0 ? Ru(m.default, y.default) : Fe(m, y, Pa, Qe, st);
                            }
                        };
                    }
                    function Ru(m, y, I) {
                        if (m !== void 0) return m;
                        if (y !== void 0) return y;
                        if (I !== void 0) return I;
                    }
                    function ac(m, y, I, U, J) {
                        var ne = typeof I === J ? U[I] : void 0;
                        return Ru(ne, m.default, y.default);
                    }
                    function mf(m, y, I) {
                        if (Ka(I) !== "number") return Ru(m.default, y.default);
                        var U = m.stops.length;
                        if (U === 1 || I <= m.stops[0][0]) return m.stops[0][1];
                        if (I >= m.stops[U - 1][0]) return m.stops[U - 1][1];
                        var J = ic(m.stops.map(function(ne) {
                            return ne[0];
                        }), I);
                        return m.stops[J][1];
                    }
                    function bu(m, y, I) {
                        var U = m.base !== void 0 ? m.base : 1;
                        if (Ka(I) !== "number") return Ru(m.default, y.default);
                        var J = m.stops.length;
                        if (J === 1 || I <= m.stops[0][0]) return m.stops[0][1];
                        if (I >= m.stops[J - 1][0]) return m.stops[J - 1][1];
                        var ne = ic(m.stops.map(function(Xt) {
                            return Xt[0];
                        }), I), fe = Du(I, U, m.stops[ne][0], m.stops[ne + 1][0]), Fe = m.stops[ne][1], Qe = m.stops[ne + 1][1], st = Gu[y.type] || Ko;
                        if (m.colorSpace && m.colorSpace !== "rgb") {
                            var mt = Ph[m.colorSpace];
                            st = function(Xt, ur) {
                                return mt.reverse(mt.interpolate(mt.forward(Xt), mt.forward(ur), fe));
                            };
                        }
                        return typeof Fe.evaluate == "function" ? {
                            evaluate: function() {
                                for(var ur = [], nr = arguments.length; nr--;)ur[nr] = arguments[nr];
                                var Lr = Fe.evaluate.apply(void 0, ur), Yr = Qe.evaluate.apply(void 0, ur);
                                if (!(Lr === void 0 || Yr === void 0)) return st(Lr, Yr, fe);
                            }
                        } : st(Fe, Qe, fe);
                    }
                    function Kc(m, y, I) {
                        return y.type === "color" ? I = ss.parse(I) : y.type === "formatted" ? I = Vl.fromString(I.toString()) : y.type === "resolvedImage" ? I = Js.fromString(I.toString()) : Ka(I) !== y.type && (y.type !== "enum" || !y.values[I]) && (I = void 0), Ru(I, m.default, y.default);
                    }
                    function Du(m, y, I, U) {
                        var J = U - I, ne = m - I;
                        return J === 0 ? 0 : y === 1 ? ne / J : (Math.pow(y, ne) - 1) / (Math.pow(y, J) - 1);
                    }
                    var Dc = function(y, I) {
                        this.expression = y, this._warningHistory = {}, this._evaluator = new $o, this._defaultValue = I ? ee(I) : null, this._enumValues = I && I.type === "enum" ? I.values : null;
                    };
                    Dc.prototype.evaluateWithoutErrorHandling = function(y, I, U, J, ne, fe) {
                        return this._evaluator.globals = y, this._evaluator.feature = I, this._evaluator.featureState = U, this._evaluator.canonical = J, this._evaluator.availableImages = ne || null, this._evaluator.formattedSection = fe, this.expression.evaluate(this._evaluator);
                    }, Dc.prototype.evaluate = function(y, I, U, J, ne, fe) {
                        this._evaluator.globals = y, this._evaluator.feature = I || null, this._evaluator.featureState = U || null, this._evaluator.canonical = J, this._evaluator.availableImages = ne || null, this._evaluator.formattedSection = fe || null;
                        try {
                            var Fe = this.expression.evaluate(this._evaluator);
                            if (Fe == null || typeof Fe == "number" && Fe !== Fe) return this._defaultValue;
                            if (this._enumValues && !(Fe in this._enumValues)) throw new Ms("Expected value to be one of " + Object.keys(this._enumValues).map(function(Qe) {
                                return JSON.stringify(Qe);
                            }).join(", ") + ", but found " + JSON.stringify(Fe) + " instead.");
                            return Fe;
                        } catch (Qe) {
                            return this._warningHistory[Qe.message] || (this._warningHistory[Qe.message] = !0, typeof console != "undefined" && console.warn(Qe.message)), this._defaultValue;
                        }
                    };
                    function Da(m) {
                        return Array.isArray(m) && m.length > 0 && typeof m[0] == "string" && m[0] in Ua;
                    }
                    function eo(m, y) {
                        var I = new fl(Ua, [], y ? Q(y) : void 0), U = I.parse(m, void 0, void 0, void 0, y && y.type === "string" ? {
                            typeAnnotation: "coerce"
                        } : void 0);
                        return U ? Bo(new Dc(U, y)) : yl(I.errors);
                    }
                    var Jc = function(y, I) {
                        this.kind = y, this._styleExpression = I, this.isStateDependent = y !== "constant" && !tu(I.expression);
                    };
                    Jc.prototype.evaluateWithoutErrorHandling = function(y, I, U, J, ne, fe) {
                        return this._styleExpression.evaluateWithoutErrorHandling(y, I, U, J, ne, fe);
                    }, Jc.prototype.evaluate = function(y, I, U, J, ne, fe) {
                        return this._styleExpression.evaluate(y, I, U, J, ne, fe);
                    };
                    var yc = function(y, I, U, J) {
                        this.kind = y, this.zoomStops = U, this._styleExpression = I, this.isStateDependent = y !== "camera" && !tu(I.expression), this.interpolationType = J;
                    };
                    yc.prototype.evaluateWithoutErrorHandling = function(y, I, U, J, ne, fe) {
                        return this._styleExpression.evaluateWithoutErrorHandling(y, I, U, J, ne, fe);
                    }, yc.prototype.evaluate = function(y, I, U, J, ne, fe) {
                        return this._styleExpression.evaluate(y, I, U, J, ne, fe);
                    }, yc.prototype.interpolationFactor = function(y, I, U) {
                        return this.interpolationType ? Dl.interpolationFactor(this.interpolationType, y, I, U) : 0;
                    };
                    function _c(m, y) {
                        if (m = eo(m, y), m.result === "error") return m;
                        var I = m.value.expression, U = $h(I);
                        if (!U && !Gs(y)) return yl([
                            new Ks("", "data expressions not supported")
                        ]);
                        var J = Pu(I, [
                            "zoom"
                        ]);
                        if (!J && !Rs(y)) return yl([
                            new Ks("", "zoom expressions not supported")
                        ]);
                        var ne = B(I);
                        if (!ne && !J) return yl([
                            new Ks("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
                        ]);
                        if (ne instanceof Ks) return yl([
                            ne
                        ]);
                        if (ne instanceof Dl && !ia(y)) return yl([
                            new Ks("", '"interpolate" expressions cannot be used with this property')
                        ]);
                        if (!ne) return Bo(U ? new Jc("constant", m.value) : new Jc("source", m.value));
                        var fe = ne instanceof Dl ? ne.interpolation : void 0;
                        return Bo(U ? new yc("camera", m.value, ne.labels, fe) : new yc("composite", m.value, ne.labels, fe));
                    }
                    var le = function(y, I) {
                        this._parameters = y, this._specification = I, Rl(this, nu(this._parameters, this._specification));
                    };
                    le.deserialize = function(y) {
                        return new le(y._parameters, y._specification);
                    }, le.serialize = function(y) {
                        return {
                            _parameters: y._parameters,
                            _specification: y._specification
                        };
                    };
                    function w(m, y) {
                        if (vs(m)) return new le(m, y);
                        if (Da(m)) {
                            var I = _c(m, y);
                            if (I.result === "error") throw new Error(I.value.map(function(J) {
                                return J.key + ": " + J.message;
                            }).join(", "));
                            return I.value;
                        } else {
                            var U = m;
                            return typeof m == "string" && y.type === "color" && (U = ss.parse(m)), {
                                kind: "constant",
                                evaluate: function() {
                                    return U;
                                }
                            };
                        }
                    }
                    function B(m) {
                        var y = null;
                        if (m instanceof Rc) y = B(m.result);
                        else if (m instanceof Wu) for(var I = 0, U = m.args; I < U.length; I += 1){
                            var J = U[I];
                            if (y = B(J), y) break;
                        }
                        else (m instanceof yu || m instanceof Dl) && m.input instanceof Ja && m.input.name === "zoom" && (y = m);
                        return y instanceof Ks || m.eachChild(function(ne) {
                            var fe = B(ne);
                            fe instanceof Ks ? y = fe : !y && fe ? y = new Ks("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : y && fe && y !== fe && (y = new Ks("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                        }), y;
                    }
                    function Q(m) {
                        var y = {
                            color: Tl,
                            string: ko,
                            number: Zn,
                            enum: ko,
                            boolean: Co,
                            formatted: Al,
                            resolvedImage: Hc
                        };
                        return m.type === "array" ? eu(y[m.value] || So, m.length) : y[m.type];
                    }
                    function ee(m) {
                        return m.type === "color" && vs(m.default) ? new ss(0, 0, 0, 0) : m.type === "color" ? ss.parse(m.default) || null : m.default === void 0 ? null : m.default;
                    }
                    function se(m) {
                        var y = m.key, I = m.value, U = m.valueSpec || {}, J = m.objectElementValidators || {}, ne = m.style, fe = m.styleSpec, Fe = [], Qe = Ka(I);
                        if (Qe !== "object") return [
                            new fa(y, I, "object expected, " + Qe + " found")
                        ];
                        for(var st in I){
                            var mt = st.split(".")[0], Xt = U[mt] || U["*"], ur = void 0;
                            if (J[mt]) ur = J[mt];
                            else if (U[mt]) ur = Wa;
                            else if (J["*"]) ur = J["*"];
                            else if (U["*"]) ur = Wa;
                            else {
                                Fe.push(new fa(y, I[st], 'unknown property "' + st + '"'));
                                continue;
                            }
                            Fe = Fe.concat(ur({
                                key: (y && y + ".") + st,
                                value: I[st],
                                valueSpec: Xt,
                                style: ne,
                                styleSpec: fe,
                                object: I,
                                objectKey: st
                            }, I));
                        }
                        for(var nr in U)J[nr] || U[nr].required && U[nr].default === void 0 && I[nr] === void 0 && Fe.push(new fa(y, I, 'missing required property "' + nr + '"'));
                        return Fe;
                    }
                    function qe(m) {
                        var y = m.value, I = m.valueSpec, U = m.style, J = m.styleSpec, ne = m.key, fe = m.arrayElementValidator || Wa;
                        if (Ka(y) !== "array") return [
                            new fa(ne, y, "array expected, " + Ka(y) + " found")
                        ];
                        if (I.length && y.length !== I.length) return [
                            new fa(ne, y, "array length " + I.length + " expected, length " + y.length + " found")
                        ];
                        if (I["min-length"] && y.length < I["min-length"]) return [
                            new fa(ne, y, "array length at least " + I["min-length"] + " expected, length " + y.length + " found")
                        ];
                        var Fe = {
                            type: I.value,
                            values: I.values
                        };
                        J.$version < 7 && (Fe.function = I.function), Ka(I.value) === "object" && (Fe = I.value);
                        for(var Qe = [], st = 0; st < y.length; st++)Qe = Qe.concat(fe({
                            array: y,
                            arrayIndex: st,
                            value: y[st],
                            valueSpec: Fe,
                            style: U,
                            styleSpec: J,
                            key: ne + "[" + st + "]"
                        }));
                        return Qe;
                    }
                    function je(m) {
                        var y = m.key, I = m.value, U = m.valueSpec, J = Ka(I);
                        return J === "number" && I !== I && (J = "NaN"), J !== "number" ? [
                            new fa(y, I, "number expected, " + J + " found")
                        ] : "minimum" in U && I < U.minimum ? [
                            new fa(y, I, I + " is less than the minimum value " + U.minimum)
                        ] : "maximum" in U && I > U.maximum ? [
                            new fa(y, I, I + " is greater than the maximum value " + U.maximum)
                        ] : [];
                    }
                    function it(m) {
                        var y = m.valueSpec, I = vo(m.value.type), U, J = {}, ne, fe, Fe = I !== "categorical" && m.value.property === void 0, Qe = !Fe, st = Ka(m.value.stops) === "array" && Ka(m.value.stops[0]) === "array" && Ka(m.value.stops[0][0]) === "object", mt = se({
                            key: m.key,
                            value: m.value,
                            valueSpec: m.styleSpec.function,
                            style: m.style,
                            styleSpec: m.styleSpec,
                            objectElementValidators: {
                                stops: Xt,
                                default: Lr
                            }
                        });
                        return I === "identity" && Fe && mt.push(new fa(m.key, m.value, 'missing required property "property"')), I !== "identity" && !m.value.stops && mt.push(new fa(m.key, m.value, 'missing required property "stops"')), I === "exponential" && m.valueSpec.expression && !ia(m.valueSpec) && mt.push(new fa(m.key, m.value, "exponential functions not supported")), m.styleSpec.$version >= 8 && (Qe && !Gs(m.valueSpec) ? mt.push(new fa(m.key, m.value, "property functions not supported")) : Fe && !Rs(m.valueSpec) && mt.push(new fa(m.key, m.value, "zoom functions not supported"))), (I === "categorical" || st) && m.value.property === void 0 && mt.push(new fa(m.key, m.value, '"property" property is required')), mt;
                        function Xt(Yr) {
                            if (I === "identity") return [
                                new fa(Yr.key, Yr.value, 'identity function may not have a "stops" property')
                            ];
                            var _i = [], si = Yr.value;
                            return _i = _i.concat(qe({
                                key: Yr.key,
                                value: si,
                                valueSpec: Yr.valueSpec,
                                style: Yr.style,
                                styleSpec: Yr.styleSpec,
                                arrayElementValidator: ur
                            })), Ka(si) === "array" && si.length === 0 && _i.push(new fa(Yr.key, si, "array must have at least one stop")), _i;
                        }
                        function ur(Yr) {
                            var _i = [], si = Yr.value, Hi = Yr.key;
                            if (Ka(si) !== "array") return [
                                new fa(Hi, si, "array expected, " + Ka(si) + " found")
                            ];
                            if (si.length !== 2) return [
                                new fa(Hi, si, "array length 2 expected, length " + si.length + " found")
                            ];
                            if (st) {
                                if (Ka(si[0]) !== "object") return [
                                    new fa(Hi, si, "object expected, " + Ka(si[0]) + " found")
                                ];
                                if (si[0].zoom === void 0) return [
                                    new fa(Hi, si, "object stop key must have zoom")
                                ];
                                if (si[0].value === void 0) return [
                                    new fa(Hi, si, "object stop key must have value")
                                ];
                                if (fe && fe > vo(si[0].zoom)) return [
                                    new fa(Hi, si[0].zoom, "stop zoom values must appear in ascending order")
                                ];
                                vo(si[0].zoom) !== fe && (fe = vo(si[0].zoom), ne = void 0, J = {}), _i = _i.concat(se({
                                    key: Hi + "[0]",
                                    value: si[0],
                                    valueSpec: {
                                        zoom: {}
                                    },
                                    style: Yr.style,
                                    styleSpec: Yr.styleSpec,
                                    objectElementValidators: {
                                        zoom: je,
                                        value: nr
                                    }
                                }));
                            } else _i = _i.concat(nr({
                                key: Hi + "[0]",
                                value: si[0],
                                valueSpec: {},
                                style: Yr.style,
                                styleSpec: Yr.styleSpec
                            }, si));
                            return Da(Zl(si[1])) ? _i.concat([
                                new fa(Hi + "[1]", si[1], "expressions are not allowed in function stops.")
                            ]) : _i.concat(Wa({
                                key: Hi + "[1]",
                                value: si[1],
                                valueSpec: y,
                                style: Yr.style,
                                styleSpec: Yr.styleSpec
                            }));
                        }
                        function nr(Yr, _i) {
                            var si = Ka(Yr.value), Hi = vo(Yr.value), Ei = Yr.value !== null ? Yr.value : _i;
                            if (!U) U = si;
                            else if (si !== U) return [
                                new fa(Yr.key, Ei, si + " stop domain type must match previous stop domain type " + U)
                            ];
                            if (si !== "number" && si !== "string" && si !== "boolean") return [
                                new fa(Yr.key, Ei, "stop domain value must be a number, string, or boolean")
                            ];
                            if (si !== "number" && I !== "categorical") {
                                var Vi = "number expected, " + si + " found";
                                return Gs(y) && I === void 0 && (Vi += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                                    new fa(Yr.key, Ei, Vi)
                                ];
                            }
                            return I === "categorical" && si === "number" && (!isFinite(Hi) || Math.floor(Hi) !== Hi) ? [
                                new fa(Yr.key, Ei, "integer expected, found " + Hi)
                            ] : I !== "categorical" && si === "number" && ne !== void 0 && Hi < ne ? [
                                new fa(Yr.key, Ei, "stop domain values must appear in ascending order")
                            ] : (ne = Hi, I === "categorical" && Hi in J ? [
                                new fa(Yr.key, Ei, "stop domain values must be unique")
                            ] : (J[Hi] = !0, []));
                        }
                        function Lr(Yr) {
                            return Wa({
                                key: Yr.key,
                                value: Yr.value,
                                valueSpec: y,
                                style: Yr.style,
                                styleSpec: Yr.styleSpec
                            });
                        }
                    }
                    function yt(m) {
                        var y = (m.expressionContext === "property" ? _c : eo)(Zl(m.value), m.valueSpec);
                        if (y.result === "error") return y.value.map(function(U) {
                            return new fa("" + m.key + U.key, m.value, U.message);
                        });
                        var I = y.value.expression || y.value._styleExpression.expression;
                        if (m.expressionContext === "property" && m.propertyKey === "text-font" && !I.outputDefined()) return [
                            new fa(m.key, m.value, 'Invalid data expression for "' + m.propertyKey + '". Output values must be contained as literals within the expression.')
                        ];
                        if (m.expressionContext === "property" && m.propertyType === "layout" && !tu(I)) return [
                            new fa(m.key, m.value, '"feature-state" data expressions are not supported with layout properties.')
                        ];
                        if (m.expressionContext === "filter" && !tu(I)) return [
                            new fa(m.key, m.value, '"feature-state" data expressions are not supported with filters.')
                        ];
                        if (m.expressionContext && m.expressionContext.indexOf("cluster") === 0) {
                            if (!Pu(I, [
                                "zoom",
                                "feature-state"
                            ])) return [
                                new fa(m.key, m.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                            ];
                            if (m.expressionContext === "cluster-initial" && !$h(I)) return [
                                new fa(m.key, m.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                            ];
                        }
                        return [];
                    }
                    function Ot(m) {
                        var y = m.value, I = m.key, U = Ka(y);
                        return U !== "boolean" ? [
                            new fa(I, y, "boolean expected, " + U + " found")
                        ] : [];
                    }
                    function Nt(m) {
                        var y = m.key, I = m.value, U = Ka(I);
                        return U !== "string" ? [
                            new fa(y, I, "color expected, " + U + " found")
                        ] : Bf(I) === null ? [
                            new fa(y, I, 'color expected, "' + I + '" found')
                        ] : [];
                    }
                    function hr(m) {
                        var y = m.key, I = m.value, U = m.valueSpec, J = [];
                        return Array.isArray(U.values) ? U.values.indexOf(vo(I)) === -1 && J.push(new fa(y, I, "expected one of [" + U.values.join(", ") + "], " + JSON.stringify(I) + " found")) : Object.keys(U.values).indexOf(vo(I)) === -1 && J.push(new fa(y, I, "expected one of [" + Object.keys(U.values).join(", ") + "], " + JSON.stringify(I) + " found")), J;
                    }
                    function Sr(m) {
                        if (m === !0 || m === !1) return !0;
                        if (!Array.isArray(m) || m.length === 0) return !1;
                        switch(m[0]){
                            case "has":
                                return m.length >= 2 && m[1] !== "$id" && m[1] !== "$type";
                            case "in":
                                return m.length >= 3 && (typeof m[1] != "string" || Array.isArray(m[2]));
                            case "!in":
                            case "!has":
                            case "none":
                                return !1;
                            case "==":
                            case "!=":
                            case ">":
                            case ">=":
                            case "<":
                            case "<=":
                                return m.length !== 3 || Array.isArray(m[1]) || Array.isArray(m[2]);
                            case "any":
                            case "all":
                                for(var y = 0, I = m.slice(1); y < I.length; y += 1){
                                    var U = I[y];
                                    if (!Sr(U) && typeof U != "boolean") return !1;
                                }
                                return !0;
                            default:
                                return !0;
                        }
                    }
                    var he = {
                        type: "boolean",
                        default: !1,
                        transition: !1,
                        "property-type": "data-driven",
                        expression: {
                            interpolated: !1,
                            parameters: [
                                "zoom",
                                "feature"
                            ]
                        }
                    };
                    function be(m) {
                        if (m == null) return {
                            filter: function() {
                                return !0;
                            },
                            needGeometry: !1
                        };
                        Sr(m) || (m = Je(m));
                        var y = eo(m, he);
                        if (y.result === "error") throw new Error(y.value.map(function(U) {
                            return U.key + ": " + U.message;
                        }).join(", "));
                        var I = Oe(m);
                        return {
                            filter: function(U, J, ne) {
                                return y.value.evaluate(U, J, {}, ne);
                            },
                            needGeometry: I
                        };
                    }
                    function Pe(m, y) {
                        return m < y ? -1 : m > y ? 1 : 0;
                    }
                    function Oe(m) {
                        if (!Array.isArray(m)) return !1;
                        if (m[0] === "within") return !0;
                        for(var y = 1; y < m.length; y++)if (Oe(m[y])) return !0;
                        return !1;
                    }
                    function Je(m) {
                        if (!m) return !0;
                        var y = m[0];
                        if (m.length <= 1) return y !== "any";
                        var I = y === "==" ? He(m[1], m[2], "==") : y === "!=" ? Ut(He(m[1], m[2], "==")) : y === "<" || y === ">" || y === "<=" || y === ">=" ? He(m[1], m[2], y) : y === "any" ? et(m.slice(1)) : y === "all" ? [
                            "all"
                        ].concat(m.slice(1).map(Je)) : y === "none" ? [
                            "all"
                        ].concat(m.slice(1).map(Je).map(Ut)) : y === "in" ? Mt(m[1], m.slice(2)) : y === "!in" ? Ut(Mt(m[1], m.slice(2))) : y === "has" ? Dt(m[1]) : y === "!has" ? Ut(Dt(m[1])) : y === "within" ? m : !0;
                        return I;
                    }
                    function He(m, y, I) {
                        switch(m){
                            case "$type":
                                return [
                                    "filter-type-" + I,
                                    y
                                ];
                            case "$id":
                                return [
                                    "filter-id-" + I,
                                    y
                                ];
                            default:
                                return [
                                    "filter-" + I,
                                    m,
                                    y
                                ];
                        }
                    }
                    function et(m) {
                        return [
                            "any"
                        ].concat(m.map(Je));
                    }
                    function Mt(m, y) {
                        if (y.length === 0) return !1;
                        switch(m){
                            case "$type":
                                return [
                                    "filter-type-in",
                                    [
                                        "literal",
                                        y
                                    ]
                                ];
                            case "$id":
                                return [
                                    "filter-id-in",
                                    [
                                        "literal",
                                        y
                                    ]
                                ];
                            default:
                                return y.length > 200 && !y.some(function(I) {
                                    return typeof I != typeof y[0];
                                }) ? [
                                    "filter-in-large",
                                    m,
                                    [
                                        "literal",
                                        y.sort(Pe)
                                    ]
                                ] : [
                                    "filter-in-small",
                                    m,
                                    [
                                        "literal",
                                        y
                                    ]
                                ];
                        }
                    }
                    function Dt(m) {
                        switch(m){
                            case "$type":
                                return !0;
                            case "$id":
                                return [
                                    "filter-has-id"
                                ];
                            default:
                                return [
                                    "filter-has",
                                    m
                                ];
                        }
                    }
                    function Ut(m) {
                        return [
                            "!",
                            m
                        ];
                    }
                    function tr(m) {
                        return Sr(Zl(m.value)) ? yt(Rl({}, m, {
                            expressionContext: "filter",
                            valueSpec: {
                                value: "boolean"
                            }
                        })) : mr(m);
                    }
                    function mr(m) {
                        var y = m.value, I = m.key;
                        if (Ka(y) !== "array") return [
                            new fa(I, y, "array expected, " + Ka(y) + " found")
                        ];
                        var U = m.styleSpec, J, ne = [];
                        if (y.length < 1) return [
                            new fa(I, y, "filter array must have at least 1 element")
                        ];
                        switch(ne = ne.concat(hr({
                            key: I + "[0]",
                            value: y[0],
                            valueSpec: U.filter_operator,
                            style: m.style,
                            styleSpec: m.styleSpec
                        })), vo(y[0])){
                            case "<":
                            case "<=":
                            case ">":
                            case ">=":
                                y.length >= 2 && vo(y[1]) === "$type" && ne.push(new fa(I, y, '"$type" cannot be use with operator "' + y[0] + '"'));
                            case "==":
                            case "!=":
                                y.length !== 3 && ne.push(new fa(I, y, 'filter array for operator "' + y[0] + '" must have 3 elements'));
                            case "in":
                            case "!in":
                                y.length >= 2 && (J = Ka(y[1]), J !== "string" && ne.push(new fa(I + "[1]", y[1], "string expected, " + J + " found")));
                                for(var fe = 2; fe < y.length; fe++)J = Ka(y[fe]), vo(y[1]) === "$type" ? ne = ne.concat(hr({
                                    key: I + "[" + fe + "]",
                                    value: y[fe],
                                    valueSpec: U.geometry_type,
                                    style: m.style,
                                    styleSpec: m.styleSpec
                                })) : J !== "string" && J !== "number" && J !== "boolean" && ne.push(new fa(I + "[" + fe + "]", y[fe], "string, number, or boolean expected, " + J + " found"));
                                break;
                            case "any":
                            case "all":
                            case "none":
                                for(var Fe = 1; Fe < y.length; Fe++)ne = ne.concat(mr({
                                    key: I + "[" + Fe + "]",
                                    value: y[Fe],
                                    style: m.style,
                                    styleSpec: m.styleSpec
                                }));
                                break;
                            case "has":
                            case "!has":
                                J = Ka(y[1]), y.length !== 2 ? ne.push(new fa(I, y, 'filter array for "' + y[0] + '" operator must have 2 elements')) : J !== "string" && ne.push(new fa(I + "[1]", y[1], "string expected, " + J + " found"));
                                break;
                            case "within":
                                J = Ka(y[1]), y.length !== 2 ? ne.push(new fa(I, y, 'filter array for "' + y[0] + '" operator must have 2 elements')) : J !== "object" && ne.push(new fa(I + "[1]", y[1], "object expected, " + J + " found"));
                                break;
                        }
                        return ne;
                    }
                    function Rr(m, y) {
                        var I = m.key, U = m.style, J = m.styleSpec, ne = m.value, fe = m.objectKey, Fe = J[y + "_" + m.layerType];
                        if (!Fe) return [];
                        var Qe = fe.match(/^(.*)-transition$/);
                        if (y === "paint" && Qe && Fe[Qe[1]] && Fe[Qe[1]].transition) return Wa({
                            key: I,
                            value: ne,
                            valueSpec: J.transition,
                            style: U,
                            styleSpec: J
                        });
                        var st = m.valueSpec || Fe[fe];
                        if (!st) return [
                            new fa(I, ne, 'unknown property "' + fe + '"')
                        ];
                        var mt;
                        if (Ka(ne) === "string" && Gs(st) && !st.tokens && (mt = /^{([^}]+)}$/.exec(ne))) return [
                            new fa(I, ne, '"' + fe + '" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": ' + JSON.stringify(mt[1]) + " }`.")
                        ];
                        var Xt = [];
                        return m.layerType === "symbol" && (fe === "text-field" && U && !U.glyphs && Xt.push(new fa(I, ne, 'use of "text-field" requires a style "glyphs" property')), fe === "text-font" && vs(Zl(ne)) && vo(ne.type) === "identity" && Xt.push(new fa(I, ne, '"text-font" does not support identity functions'))), Xt.concat(Wa({
                            key: m.key,
                            value: ne,
                            valueSpec: st,
                            style: U,
                            styleSpec: J,
                            expressionContext: "property",
                            propertyType: y,
                            propertyKey: fe
                        }));
                    }
                    function zr(m) {
                        return Rr(m, "paint");
                    }
                    function Xr(m) {
                        return Rr(m, "layout");
                    }
                    function di(m) {
                        var y = [], I = m.value, U = m.key, J = m.style, ne = m.styleSpec;
                        !I.type && !I.ref && y.push(new fa(U, I, 'either "type" or "ref" is required'));
                        var fe = vo(I.type), Fe = vo(I.ref);
                        if (I.id) for(var Qe = vo(I.id), st = 0; st < m.arrayIndex; st++){
                            var mt = J.layers[st];
                            vo(mt.id) === Qe && y.push(new fa(U, I.id, 'duplicate layer id "' + I.id + '", previously used at line ' + mt.id.__line__));
                        }
                        if ("ref" in I) {
                            [
                                "type",
                                "source",
                                "source-layer",
                                "filter",
                                "layout"
                            ].forEach(function(Lr) {
                                Lr in I && y.push(new fa(U, I[Lr], '"' + Lr + '" is prohibited for ref layers'));
                            });
                            var Xt;
                            J.layers.forEach(function(Lr) {
                                vo(Lr.id) === Fe && (Xt = Lr);
                            }), Xt ? Xt.ref ? y.push(new fa(U, I.ref, "ref cannot reference another ref layer")) : fe = vo(Xt.type) : y.push(new fa(U, I.ref, 'ref layer "' + Fe + '" not found'));
                        } else if (fe !== "background") {
                            if (!I.source) y.push(new fa(U, I, 'missing required property "source"'));
                            else {
                                var ur = J.sources && J.sources[I.source], nr = ur && vo(ur.type);
                                ur ? nr === "vector" && fe === "raster" ? y.push(new fa(U, I.source, 'layer "' + I.id + '" requires a raster source')) : nr === "raster" && fe !== "raster" ? y.push(new fa(U, I.source, 'layer "' + I.id + '" requires a vector source')) : nr === "vector" && !I["source-layer"] ? y.push(new fa(U, I, 'layer "' + I.id + '" must specify a "source-layer"')) : nr === "raster-dem" && fe !== "hillshade" ? y.push(new fa(U, I.source, "raster-dem source can only be used with layer type 'hillshade'.")) : fe === "line" && I.paint && I.paint["line-gradient"] && (nr !== "geojson" || !ur.lineMetrics) && y.push(new fa(U, I, 'layer "' + I.id + '" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')) : y.push(new fa(U, I.source, 'source "' + I.source + '" not found'));
                            }
                        }
                        return y = y.concat(se({
                            key: U,
                            value: I,
                            valueSpec: ne.layer,
                            style: m.style,
                            styleSpec: m.styleSpec,
                            objectElementValidators: {
                                "*": function() {
                                    return [];
                                },
                                type: function() {
                                    return Wa({
                                        key: U + ".type",
                                        value: I.type,
                                        valueSpec: ne.layer.type,
                                        style: m.style,
                                        styleSpec: m.styleSpec,
                                        object: I,
                                        objectKey: "type"
                                    });
                                },
                                filter: tr,
                                layout: function(Yr) {
                                    return se({
                                        layer: I,
                                        key: Yr.key,
                                        value: Yr.value,
                                        style: Yr.style,
                                        styleSpec: Yr.styleSpec,
                                        objectElementValidators: {
                                            "*": function(si) {
                                                return Xr(Rl({
                                                    layerType: fe
                                                }, si));
                                            }
                                        }
                                    });
                                },
                                paint: function(Yr) {
                                    return se({
                                        layer: I,
                                        key: Yr.key,
                                        value: Yr.value,
                                        style: Yr.style,
                                        styleSpec: Yr.styleSpec,
                                        objectElementValidators: {
                                            "*": function(si) {
                                                return zr(Rl({
                                                    layerType: fe
                                                }, si));
                                            }
                                        }
                                    });
                                }
                            }
                        })), y;
                    }
                    function Li(m) {
                        var y = m.value, I = m.key, U = Ka(y);
                        return U !== "string" ? [
                            new fa(I, y, "string expected, " + U + " found")
                        ] : [];
                    }
                    var Ci = {
                        promoteId: Mn
                    };
                    function Qi(m) {
                        var y = m.value, I = m.key, U = m.styleSpec, J = m.style;
                        if (!y.type) return [
                            new fa(I, y, '"type" is required')
                        ];
                        var ne = vo(y.type), fe;
                        switch(ne){
                            case "vector":
                            case "raster":
                            case "raster-dem":
                                return fe = se({
                                    key: I,
                                    value: y,
                                    valueSpec: U["source_" + ne.replace("-", "_")],
                                    style: m.style,
                                    styleSpec: U,
                                    objectElementValidators: Ci
                                }), fe;
                            case "geojson":
                                if (fe = se({
                                    key: I,
                                    value: y,
                                    valueSpec: U.source_geojson,
                                    style: J,
                                    styleSpec: U,
                                    objectElementValidators: Ci
                                }), y.cluster) for(var Fe in y.clusterProperties){
                                    var Qe = y.clusterProperties[Fe], st = Qe[0], mt = Qe[1], Xt = typeof st == "string" ? [
                                        st,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            Fe
                                        ]
                                    ] : st;
                                    fe.push.apply(fe, yt({
                                        key: I + "." + Fe + ".map",
                                        value: mt,
                                        expressionContext: "cluster-map"
                                    })), fe.push.apply(fe, yt({
                                        key: I + "." + Fe + ".reduce",
                                        value: Xt,
                                        expressionContext: "cluster-reduce"
                                    }));
                                }
                                return fe;
                            case "video":
                                return se({
                                    key: I,
                                    value: y,
                                    valueSpec: U.source_video,
                                    style: J,
                                    styleSpec: U
                                });
                            case "image":
                                return se({
                                    key: I,
                                    value: y,
                                    valueSpec: U.source_image,
                                    style: J,
                                    styleSpec: U
                                });
                            case "canvas":
                                return [
                                    new fa(I, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                                ];
                            default:
                                return hr({
                                    key: I + ".type",
                                    value: y.type,
                                    valueSpec: {
                                        values: [
                                            "vector",
                                            "raster",
                                            "raster-dem",
                                            "geojson",
                                            "video",
                                            "image"
                                        ]
                                    },
                                    style: J,
                                    styleSpec: U
                                });
                        }
                    }
                    function Mn(m) {
                        var y = m.key, I = m.value;
                        if (Ka(I) === "string") return Li({
                            key: y,
                            value: I
                        });
                        var U = [];
                        for(var J in I)U.push.apply(U, Li({
                            key: y + "." + J,
                            value: I[J]
                        }));
                        return U;
                    }
                    function pa(m) {
                        var y = m.value, I = m.styleSpec, U = I.light, J = m.style, ne = [], fe = Ka(y);
                        if (y === void 0) return ne;
                        if (fe !== "object") return ne = ne.concat([
                            new fa("light", y, "object expected, " + fe + " found")
                        ]), ne;
                        for(var Fe in y){
                            var Qe = Fe.match(/^(.*)-transition$/);
                            Qe && U[Qe[1]] && U[Qe[1]].transition ? ne = ne.concat(Wa({
                                key: Fe,
                                value: y[Fe],
                                valueSpec: I.transition,
                                style: J,
                                styleSpec: I
                            })) : U[Fe] ? ne = ne.concat(Wa({
                                key: Fe,
                                value: y[Fe],
                                valueSpec: U[Fe],
                                style: J,
                                styleSpec: I
                            })) : ne = ne.concat([
                                new fa(Fe, y[Fe], 'unknown property "' + Fe + '"')
                            ]);
                        }
                        return ne;
                    }
                    function ea(m) {
                        return Li(m).length === 0 ? [] : yt(m);
                    }
                    function Ga(m) {
                        return Li(m).length === 0 ? [] : yt(m);
                    }
                    var To = {
                        "*": function() {
                            return [];
                        },
                        array: qe,
                        boolean: Ot,
                        number: je,
                        color: Nt,
                        constants: Qu,
                        enum: hr,
                        filter: tr,
                        function: it,
                        layer: di,
                        object: se,
                        source: Qi,
                        light: pa,
                        string: Li,
                        formatted: ea,
                        resolvedImage: Ga
                    };
                    function Wa(m) {
                        var y = m.value, I = m.valueSpec, U = m.styleSpec;
                        if (I.expression && vs(vo(y))) return it(m);
                        if (I.expression && Da(Zl(y))) return yt(m);
                        if (I.type && To[I.type]) return To[I.type](m);
                        var J = se(Rl({}, m, {
                            valueSpec: I.type ? U[I.type] : I
                        }));
                        return J;
                    }
                    function co(m) {
                        var y = m.value, I = m.key, U = Li(m);
                        return U.length || (y.indexOf("{fontstack}") === -1 && U.push(new fa(I, y, '"glyphs" url must include a "{fontstack}" token')), y.indexOf("{range}") === -1 && U.push(new fa(I, y, '"glyphs" url must include a "{range}" token'))), U;
                    }
                    function Ro(m, y) {
                        y === void 0 && (y = on);
                        var I = [];
                        return I = I.concat(Wa({
                            key: "",
                            value: m,
                            valueSpec: y.$root,
                            styleSpec: y,
                            style: m,
                            objectElementValidators: {
                                glyphs: co,
                                "*": function() {
                                    return [];
                                }
                            }
                        })), m.constants && (I = I.concat(Qu({
                            key: "constants",
                            value: m.constants,
                            style: m,
                            styleSpec: y
                        }))), Ds(I);
                    }
                    Ro.source = As(Qi), Ro.light = As(pa), Ro.layer = As(di), Ro.filter = As(tr), Ro.paintProperty = As(zr), Ro.layoutProperty = As(Xr);
                    function Ds(m) {
                        return [].concat(m).sort(function(y, I) {
                            return y.line - I.line;
                        });
                    }
                    function As(m) {
                        return function() {
                            for(var y = [], I = arguments.length; I--;)y[I] = arguments[I];
                            return Ds(m.apply(this, y));
                        };
                    }
                    var yo = Ro, po = yo.light, _l = yo.paintProperty, Hl = yo.layoutProperty;
                    function Zu(m, y) {
                        var I = !1;
                        if (y && y.length) for(var U = 0, J = y; U < J.length; U += 1){
                            var ne = J[U];
                            m.fire(new oa(new Error(ne.message))), I = !0;
                        }
                        return I;
                    }
                    var cu = au, el = 3;
                    function au(m, y, I) {
                        var U = this.cells = [];
                        if (m instanceof ArrayBuffer) {
                            this.arrayBuffer = m;
                            var J = new Int32Array(this.arrayBuffer);
                            m = J[0], y = J[1], I = J[2], this.d = y + 2 * I;
                            for(var ne = 0; ne < this.d * this.d; ne++){
                                var fe = J[el + ne], Fe = J[el + ne + 1];
                                U.push(fe === Fe ? null : J.subarray(fe, Fe));
                            }
                            var Qe = J[el + U.length], st = J[el + U.length + 1];
                            this.keys = J.subarray(Qe, st), this.bboxes = J.subarray(st), this.insert = this._insertReadonly;
                        } else {
                            this.d = y + 2 * I;
                            for(var mt = 0; mt < this.d * this.d; mt++)U.push([]);
                            this.keys = [], this.bboxes = [];
                        }
                        this.n = y, this.extent = m, this.padding = I, this.scale = y / m, this.uid = 0;
                        var Xt = I / y * m;
                        this.min = -Xt, this.max = m + Xt;
                    }
                    au.prototype.insert = function(m, y, I, U, J) {
                        this._forEachCell(y, I, U, J, this._insertCell, this.uid++), this.keys.push(m), this.bboxes.push(y), this.bboxes.push(I), this.bboxes.push(U), this.bboxes.push(J);
                    }, au.prototype._insertReadonly = function() {
                        throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
                    }, au.prototype._insertCell = function(m, y, I, U, J, ne) {
                        this.cells[J].push(ne);
                    }, au.prototype.query = function(m, y, I, U, J) {
                        var ne = this.min, fe = this.max;
                        if (m <= ne && y <= ne && fe <= I && fe <= U && !J) return Array.prototype.slice.call(this.keys);
                        var Fe = [], Qe = {};
                        return this._forEachCell(m, y, I, U, this._queryCell, Fe, Qe, J), Fe;
                    }, au.prototype._queryCell = function(m, y, I, U, J, ne, fe, Fe) {
                        var Qe = this.cells[J];
                        if (Qe !== null) for(var st = this.keys, mt = this.bboxes, Xt = 0; Xt < Qe.length; Xt++){
                            var ur = Qe[Xt];
                            if (fe[ur] === void 0) {
                                var nr = ur * 4;
                                (Fe ? Fe(mt[nr + 0], mt[nr + 1], mt[nr + 2], mt[nr + 3]) : m <= mt[nr + 2] && y <= mt[nr + 3] && I >= mt[nr + 0] && U >= mt[nr + 1]) ? (fe[ur] = !0, ne.push(st[ur])) : fe[ur] = !1;
                            }
                        }
                    }, au.prototype._forEachCell = function(m, y, I, U, J, ne, fe, Fe) {
                        for(var Qe = this._convertToCellCoord(m), st = this._convertToCellCoord(y), mt = this._convertToCellCoord(I), Xt = this._convertToCellCoord(U), ur = Qe; ur <= mt; ur++)for(var nr = st; nr <= Xt; nr++){
                            var Lr = this.d * nr + ur;
                            if (!(Fe && !Fe(this._convertFromCellCoord(ur), this._convertFromCellCoord(nr), this._convertFromCellCoord(ur + 1), this._convertFromCellCoord(nr + 1))) && J.call(this, m, y, I, U, Lr, ne, fe, Fe)) return;
                        }
                    }, au.prototype._convertFromCellCoord = function(m) {
                        return (m - this.padding) / this.scale;
                    }, au.prototype._convertToCellCoord = function(m) {
                        return Math.max(0, Math.min(this.d - 1, Math.floor(m * this.scale) + this.padding));
                    }, au.prototype.toArrayBuffer = function() {
                        if (this.arrayBuffer) return this.arrayBuffer;
                        for(var m = this.cells, y = el + this.cells.length + 1 + 1, I = 0, U = 0; U < this.cells.length; U++)I += this.cells[U].length;
                        var J = new Int32Array(y + I + this.keys.length + this.bboxes.length);
                        J[0] = this.extent, J[1] = this.n, J[2] = this.padding;
                        for(var ne = y, fe = 0; fe < m.length; fe++){
                            var Fe = m[fe];
                            J[el + fe] = ne, J.set(Fe, ne), ne += Fe.length;
                        }
                        return J[el + m.length] = ne, J.set(this.keys, ne), ne += this.keys.length, J[el + m.length + 1] = ne, J.set(this.bboxes, ne), ne += this.bboxes.length, J.buffer;
                    };
                    var zc = f.ImageData, zl = f.ImageBitmap, Fl = {};
                    function Z(m, y, I) {
                        I === void 0 && (I = {}), Object.defineProperty(y, "_classRegistryKey", {
                            value: m,
                            writeable: !1
                        }), Fl[m] = {
                            klass: y,
                            omit: I.omit || [],
                            shallow: I.shallow || []
                        };
                    }
                    Z("Object", Object), cu.serialize = function(y, I) {
                        var U = y.toArrayBuffer();
                        return I && I.push(U), {
                            buffer: U
                        };
                    }, cu.deserialize = function(y) {
                        return new cu(y.buffer);
                    }, Z("Grid", cu), Z("Color", ss), Z("Error", Error), Z("ResolvedImage", Js), Z("StylePropertyFunction", le), Z("StyleExpression", Dc, {
                        omit: [
                            "_evaluator"
                        ]
                    }), Z("ZoomDependentExpression", yc), Z("ZoomConstantExpression", Jc), Z("CompoundExpression", Ja, {
                        omit: [
                            "_evaluate"
                        ]
                    });
                    for(var oe in Ua)Ua[oe]._classRegistryKey || Z("Expression_" + oe, Ua[oe]);
                    function we(m) {
                        return m && typeof ArrayBuffer != "undefined" && (m instanceof ArrayBuffer || m.constructor && m.constructor.name === "ArrayBuffer");
                    }
                    function Be(m) {
                        return zl && m instanceof zl;
                    }
                    function Ue(m, y) {
                        if (m == null || typeof m == "boolean" || typeof m == "number" || typeof m == "string" || m instanceof Boolean || m instanceof Number || m instanceof String || m instanceof Date || m instanceof RegExp) return m;
                        if (we(m) || Be(m)) return y && y.push(m), m;
                        if (ArrayBuffer.isView(m)) {
                            var I = m;
                            return y && y.push(I.buffer), I;
                        }
                        if (m instanceof zc) return y && y.push(m.data.buffer), m;
                        if (Array.isArray(m)) {
                            for(var U = [], J = 0, ne = m; J < ne.length; J += 1){
                                var fe = ne[J];
                                U.push(Ue(fe, y));
                            }
                            return U;
                        }
                        if (typeof m == "object") {
                            var Fe = m.constructor, Qe = Fe._classRegistryKey;
                            if (!Qe) throw new Error("can't serialize object of unregistered class");
                            var st = Fe.serialize ? Fe.serialize(m, y) : {};
                            if (!Fe.serialize) {
                                for(var mt in m)if (m.hasOwnProperty(mt) && !(Fl[Qe].omit.indexOf(mt) >= 0)) {
                                    var Xt = m[mt];
                                    st[mt] = Fl[Qe].shallow.indexOf(mt) >= 0 ? Xt : Ue(Xt, y);
                                }
                                m instanceof Error && (st.message = m.message);
                            }
                            if (st.$name) throw new Error("$name property is reserved for worker serialization logic.");
                            return Qe !== "Object" && (st.$name = Qe), st;
                        }
                        throw new Error("can't serialize object of type " + typeof m);
                    }
                    function We(m) {
                        if (m == null || typeof m == "boolean" || typeof m == "number" || typeof m == "string" || m instanceof Boolean || m instanceof Number || m instanceof String || m instanceof Date || m instanceof RegExp || we(m) || Be(m) || ArrayBuffer.isView(m) || m instanceof zc) return m;
                        if (Array.isArray(m)) return m.map(We);
                        if (typeof m == "object") {
                            var y = m.$name || "Object", I = Fl[y], U = I.klass;
                            if (!U) throw new Error("can't deserialize unregistered class " + y);
                            if (U.deserialize) return U.deserialize(m);
                            for(var J = Object.create(U.prototype), ne = 0, fe = Object.keys(m); ne < fe.length; ne += 1){
                                var Fe = fe[ne];
                                if (Fe !== "$name") {
                                    var Qe = m[Fe];
                                    J[Fe] = Fl[y].shallow.indexOf(Fe) >= 0 ? Qe : We(Qe);
                                }
                            }
                            return J;
                        }
                        throw new Error("can't deserialize object of type " + typeof m);
                    }
                    var wt = function() {
                        this.first = !0;
                    };
                    wt.prototype.update = function(y, I) {
                        var U = Math.floor(y);
                        return this.first ? (this.first = !1, this.lastIntegerZoom = U, this.lastIntegerZoomTime = 0, this.lastZoom = y, this.lastFloorZoom = U, !0) : (this.lastFloorZoom > U ? (this.lastIntegerZoom = U + 1, this.lastIntegerZoomTime = I) : this.lastFloorZoom < U && (this.lastIntegerZoom = U, this.lastIntegerZoomTime = I), y !== this.lastZoom ? (this.lastZoom = y, this.lastFloorZoom = U, !0) : !1);
                    };
                    var tt = {
                        "Latin-1 Supplement": function(m) {
                            return m >= 128 && m <= 255;
                        },
                        Arabic: function(m) {
                            return m >= 1536 && m <= 1791;
                        },
                        "Arabic Supplement": function(m) {
                            return m >= 1872 && m <= 1919;
                        },
                        "Arabic Extended-A": function(m) {
                            return m >= 2208 && m <= 2303;
                        },
                        "Hangul Jamo": function(m) {
                            return m >= 4352 && m <= 4607;
                        },
                        "Unified Canadian Aboriginal Syllabics": function(m) {
                            return m >= 5120 && m <= 5759;
                        },
                        Khmer: function(m) {
                            return m >= 6016 && m <= 6143;
                        },
                        "Unified Canadian Aboriginal Syllabics Extended": function(m) {
                            return m >= 6320 && m <= 6399;
                        },
                        "General Punctuation": function(m) {
                            return m >= 8192 && m <= 8303;
                        },
                        "Letterlike Symbols": function(m) {
                            return m >= 8448 && m <= 8527;
                        },
                        "Number Forms": function(m) {
                            return m >= 8528 && m <= 8591;
                        },
                        "Miscellaneous Technical": function(m) {
                            return m >= 8960 && m <= 9215;
                        },
                        "Control Pictures": function(m) {
                            return m >= 9216 && m <= 9279;
                        },
                        "Optical Character Recognition": function(m) {
                            return m >= 9280 && m <= 9311;
                        },
                        "Enclosed Alphanumerics": function(m) {
                            return m >= 9312 && m <= 9471;
                        },
                        "Geometric Shapes": function(m) {
                            return m >= 9632 && m <= 9727;
                        },
                        "Miscellaneous Symbols": function(m) {
                            return m >= 9728 && m <= 9983;
                        },
                        "Miscellaneous Symbols and Arrows": function(m) {
                            return m >= 11008 && m <= 11263;
                        },
                        "CJK Radicals Supplement": function(m) {
                            return m >= 11904 && m <= 12031;
                        },
                        "Kangxi Radicals": function(m) {
                            return m >= 12032 && m <= 12255;
                        },
                        "Ideographic Description Characters": function(m) {
                            return m >= 12272 && m <= 12287;
                        },
                        "CJK Symbols and Punctuation": function(m) {
                            return m >= 12288 && m <= 12351;
                        },
                        Hiragana: function(m) {
                            return m >= 12352 && m <= 12447;
                        },
                        Katakana: function(m) {
                            return m >= 12448 && m <= 12543;
                        },
                        Bopomofo: function(m) {
                            return m >= 12544 && m <= 12591;
                        },
                        "Hangul Compatibility Jamo": function(m) {
                            return m >= 12592 && m <= 12687;
                        },
                        Kanbun: function(m) {
                            return m >= 12688 && m <= 12703;
                        },
                        "Bopomofo Extended": function(m) {
                            return m >= 12704 && m <= 12735;
                        },
                        "CJK Strokes": function(m) {
                            return m >= 12736 && m <= 12783;
                        },
                        "Katakana Phonetic Extensions": function(m) {
                            return m >= 12784 && m <= 12799;
                        },
                        "Enclosed CJK Letters and Months": function(m) {
                            return m >= 12800 && m <= 13055;
                        },
                        "CJK Compatibility": function(m) {
                            return m >= 13056 && m <= 13311;
                        },
                        "CJK Unified Ideographs Extension A": function(m) {
                            return m >= 13312 && m <= 19903;
                        },
                        "Yijing Hexagram Symbols": function(m) {
                            return m >= 19904 && m <= 19967;
                        },
                        "CJK Unified Ideographs": function(m) {
                            return m >= 19968 && m <= 40959;
                        },
                        "Yi Syllables": function(m) {
                            return m >= 40960 && m <= 42127;
                        },
                        "Yi Radicals": function(m) {
                            return m >= 42128 && m <= 42191;
                        },
                        "Hangul Jamo Extended-A": function(m) {
                            return m >= 43360 && m <= 43391;
                        },
                        "Hangul Syllables": function(m) {
                            return m >= 44032 && m <= 55215;
                        },
                        "Hangul Jamo Extended-B": function(m) {
                            return m >= 55216 && m <= 55295;
                        },
                        "Private Use Area": function(m) {
                            return m >= 57344 && m <= 63743;
                        },
                        "CJK Compatibility Ideographs": function(m) {
                            return m >= 63744 && m <= 64255;
                        },
                        "Arabic Presentation Forms-A": function(m) {
                            return m >= 64336 && m <= 65023;
                        },
                        "Vertical Forms": function(m) {
                            return m >= 65040 && m <= 65055;
                        },
                        "CJK Compatibility Forms": function(m) {
                            return m >= 65072 && m <= 65103;
                        },
                        "Small Form Variants": function(m) {
                            return m >= 65104 && m <= 65135;
                        },
                        "Arabic Presentation Forms-B": function(m) {
                            return m >= 65136 && m <= 65279;
                        },
                        "Halfwidth and Fullwidth Forms": function(m) {
                            return m >= 65280 && m <= 65519;
                        }
                    };
                    function zt(m) {
                        for(var y = 0, I = m; y < I.length; y += 1){
                            var U = I[y];
                            if (Ir(U.charCodeAt(0))) return !0;
                        }
                        return !1;
                    }
                    function or(m) {
                        for(var y = 0, I = m; y < I.length; y += 1){
                            var U = I[y];
                            if (!lr(U.charCodeAt(0))) return !1;
                        }
                        return !0;
                    }
                    function lr(m) {
                        return !(tt.Arabic(m) || tt["Arabic Supplement"](m) || tt["Arabic Extended-A"](m) || tt["Arabic Presentation Forms-A"](m) || tt["Arabic Presentation Forms-B"](m));
                    }
                    function Dr(m) {
                        return m < 11904 ? !1 : !!(tt["Bopomofo Extended"](m) || tt.Bopomofo(m) || tt["CJK Compatibility Forms"](m) || tt["CJK Compatibility Ideographs"](m) || tt["CJK Compatibility"](m) || tt["CJK Radicals Supplement"](m) || tt["CJK Strokes"](m) || tt["CJK Symbols and Punctuation"](m) || tt["CJK Unified Ideographs Extension A"](m) || tt["CJK Unified Ideographs"](m) || tt["Enclosed CJK Letters and Months"](m) || tt["Halfwidth and Fullwidth Forms"](m) || tt.Hiragana(m) || tt["Ideographic Description Characters"](m) || tt["Kangxi Radicals"](m) || tt["Katakana Phonetic Extensions"](m) || tt.Katakana(m) || tt["Vertical Forms"](m) || tt["Yi Radicals"](m) || tt["Yi Syllables"](m));
                    }
                    function Ir(m) {
                        return m === 746 || m === 747 ? !0 : m < 4352 ? !1 : !!(tt["Bopomofo Extended"](m) || tt.Bopomofo(m) || tt["CJK Compatibility Forms"](m) && !(m >= 65097 && m <= 65103) || tt["CJK Compatibility Ideographs"](m) || tt["CJK Compatibility"](m) || tt["CJK Radicals Supplement"](m) || tt["CJK Strokes"](m) || tt["CJK Symbols and Punctuation"](m) && !(m >= 12296 && m <= 12305) && !(m >= 12308 && m <= 12319) && m !== 12336 || tt["CJK Unified Ideographs Extension A"](m) || tt["CJK Unified Ideographs"](m) || tt["Enclosed CJK Letters and Months"](m) || tt["Hangul Compatibility Jamo"](m) || tt["Hangul Jamo Extended-A"](m) || tt["Hangul Jamo Extended-B"](m) || tt["Hangul Jamo"](m) || tt["Hangul Syllables"](m) || tt.Hiragana(m) || tt["Ideographic Description Characters"](m) || tt.Kanbun(m) || tt["Kangxi Radicals"](m) || tt["Katakana Phonetic Extensions"](m) || tt.Katakana(m) && m !== 12540 || tt["Halfwidth and Fullwidth Forms"](m) && m !== 65288 && m !== 65289 && m !== 65293 && !(m >= 65306 && m <= 65310) && m !== 65339 && m !== 65341 && m !== 65343 && !(m >= 65371 && m <= 65503) && m !== 65507 && !(m >= 65512 && m <= 65519) || tt["Small Form Variants"](m) && !(m >= 65112 && m <= 65118) && !(m >= 65123 && m <= 65126) || tt["Unified Canadian Aboriginal Syllabics"](m) || tt["Unified Canadian Aboriginal Syllabics Extended"](m) || tt["Vertical Forms"](m) || tt["Yijing Hexagram Symbols"](m) || tt["Yi Syllables"](m) || tt["Yi Radicals"](m));
                    }
                    function oi(m) {
                        return !!(tt["Latin-1 Supplement"](m) && (m === 167 || m === 169 || m === 174 || m === 177 || m === 188 || m === 189 || m === 190 || m === 215 || m === 247) || tt["General Punctuation"](m) && (m === 8214 || m === 8224 || m === 8225 || m === 8240 || m === 8241 || m === 8251 || m === 8252 || m === 8258 || m === 8263 || m === 8264 || m === 8265 || m === 8273) || tt["Letterlike Symbols"](m) || tt["Number Forms"](m) || tt["Miscellaneous Technical"](m) && (m >= 8960 && m <= 8967 || m >= 8972 && m <= 8991 || m >= 8996 && m <= 9e3 || m === 9003 || m >= 9085 && m <= 9114 || m >= 9150 && m <= 9165 || m === 9167 || m >= 9169 && m <= 9179 || m >= 9186 && m <= 9215) || tt["Control Pictures"](m) && m !== 9251 || tt["Optical Character Recognition"](m) || tt["Enclosed Alphanumerics"](m) || tt["Geometric Shapes"](m) || tt["Miscellaneous Symbols"](m) && !(m >= 9754 && m <= 9759) || tt["Miscellaneous Symbols and Arrows"](m) && (m >= 11026 && m <= 11055 || m >= 11088 && m <= 11097 || m >= 11192 && m <= 11243) || tt["CJK Symbols and Punctuation"](m) || tt.Katakana(m) || tt["Private Use Area"](m) || tt["CJK Compatibility Forms"](m) || tt["Small Form Variants"](m) || tt["Halfwidth and Fullwidth Forms"](m) || m === 8734 || m === 8756 || m === 8757 || m >= 9984 && m <= 10087 || m >= 10102 && m <= 10131 || m === 65532 || m === 65533);
                    }
                    function ui(m) {
                        return !(Ir(m) || oi(m));
                    }
                    function qr(m) {
                        return tt.Arabic(m) || tt["Arabic Supplement"](m) || tt["Arabic Extended-A"](m) || tt["Arabic Presentation Forms-A"](m) || tt["Arabic Presentation Forms-B"](m);
                    }
                    function Kr(m) {
                        return m >= 1424 && m <= 2303 || tt["Arabic Presentation Forms-A"](m) || tt["Arabic Presentation Forms-B"](m);
                    }
                    function ii(m, y) {
                        return !(!y && Kr(m) || m >= 2304 && m <= 3583 || m >= 3840 && m <= 4255 || tt.Khmer(m));
                    }
                    function vi(m) {
                        for(var y = 0, I = m; y < I.length; y += 1){
                            var U = I[y];
                            if (Kr(U.charCodeAt(0))) return !0;
                        }
                        return !1;
                    }
                    function ci(m, y) {
                        for(var I = 0, U = m; I < U.length; I += 1){
                            var J = U[I];
                            if (!ii(J.charCodeAt(0), y)) return !1;
                        }
                        return !0;
                    }
                    var Jr = {
                        unavailable: "unavailable",
                        deferred: "deferred",
                        loading: "loading",
                        loaded: "loaded",
                        error: "error"
                    }, un = null, dn = Jr.unavailable, En = null, Nn = function(m) {
                        m && typeof m == "string" && m.indexOf("NetworkError") > -1 && (dn = Jr.error), un && un(m);
                    };
                    function ga() {
                        ya.fire(new jo("pluginStateChange", {
                            pluginStatus: dn,
                            pluginURL: En
                        }));
                    }
                    var ya = new Sn, so = function() {
                        return dn;
                    }, wa = function(m) {
                        return m({
                            pluginStatus: dn,
                            pluginURL: En
                        }), ya.on("pluginStateChange", m), m;
                    }, io = function(m, y, I) {
                        if (I === void 0 && (I = !1), dn === Jr.deferred || dn === Jr.loading || dn === Jr.loaded) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                        En = nt.resolveURL(m), dn = Jr.deferred, un = y, ga(), I || Ss();
                    }, Ss = function() {
                        if (dn !== Jr.deferred || !En) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
                        dn = Jr.loading, ga(), En && Zr({
                            url: En
                        }, function(m) {
                            m ? Nn(m) : (dn = Jr.loaded, ga());
                        });
                    }, _s = {
                        applyArabicShaping: null,
                        processBidirectionalText: null,
                        processStyledBidirectionalText: null,
                        isLoaded: function() {
                            return dn === Jr.loaded || _s.applyArabicShaping != null;
                        },
                        isLoading: function() {
                            return dn === Jr.loading;
                        },
                        setState: function(y) {
                            dn = y.pluginStatus, En = y.pluginURL;
                        },
                        isParsed: function() {
                            return _s.applyArabicShaping != null && _s.processBidirectionalText != null && _s.processStyledBidirectionalText != null;
                        },
                        getPluginURL: function() {
                            return En;
                        }
                    }, Ns = function() {
                        !_s.isLoading() && !_s.isLoaded() && so() === "deferred" && Ss();
                    }, pn = function(y, I) {
                        this.zoom = y, I ? (this.now = I.now, this.fadeDuration = I.fadeDuration, this.zoomHistory = I.zoomHistory, this.transition = I.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new wt, this.transition = {});
                    };
                    pn.prototype.isSupportedScript = function(y) {
                        return ci(y, _s.isLoaded());
                    }, pn.prototype.crossFadingFactor = function() {
                        return this.fadeDuration === 0 ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
                    }, pn.prototype.getCrossfadeParameters = function() {
                        var y = this.zoom, I = y - Math.floor(y), U = this.crossFadingFactor();
                        return y > this.zoomHistory.lastIntegerZoom ? {
                            fromScale: 2,
                            toScale: 1,
                            t: I + (1 - I) * U
                        } : {
                            fromScale: .5,
                            toScale: 1,
                            t: 1 - (1 - U) * I
                        };
                    };
                    var za = function(y, I) {
                        this.property = y, this.value = I, this.expression = w(I === void 0 ? y.specification.default : I, y.specification);
                    };
                    za.prototype.isDataDriven = function() {
                        return this.expression.kind === "source" || this.expression.kind === "composite";
                    }, za.prototype.possiblyEvaluate = function(y, I, U) {
                        return this.property.possiblyEvaluate(this, y, I, U);
                    };
                    var Lo = function(y) {
                        this.property = y, this.value = new za(y, void 0);
                    };
                    Lo.prototype.transitioned = function(y, I) {
                        return new js(this.property, this.value, I, _({}, y.transition, this.transition), y.now);
                    }, Lo.prototype.untransitioned = function() {
                        return new js(this.property, this.value, null, {}, 0);
                    };
                    var Fo = function(y) {
                        this._properties = y, this._values = Object.create(y.defaultTransitionablePropertyValues);
                    };
                    Fo.prototype.getValue = function(y) {
                        return G(this._values[y].value.value);
                    }, Fo.prototype.setValue = function(y, I) {
                        this._values.hasOwnProperty(y) || (this._values[y] = new Lo(this._values[y].property)), this._values[y].value = new za(this._values[y].property, I === null ? void 0 : G(I));
                    }, Fo.prototype.getTransition = function(y) {
                        return G(this._values[y].transition);
                    }, Fo.prototype.setTransition = function(y, I) {
                        this._values.hasOwnProperty(y) || (this._values[y] = new Lo(this._values[y].property)), this._values[y].transition = G(I) || void 0;
                    }, Fo.prototype.serialize = function() {
                        for(var y = {}, I = 0, U = Object.keys(this._values); I < U.length; I += 1){
                            var J = U[I], ne = this.getValue(J);
                            ne !== void 0 && (y[J] = ne);
                            var fe = this.getTransition(J);
                            fe !== void 0 && (y[J + "-transition"] = fe);
                        }
                        return y;
                    }, Fo.prototype.transitioned = function(y, I) {
                        for(var U = new xl(this._properties), J = 0, ne = Object.keys(this._values); J < ne.length; J += 1){
                            var fe = ne[J];
                            U._values[fe] = this._values[fe].transitioned(y, I._values[fe]);
                        }
                        return U;
                    }, Fo.prototype.untransitioned = function() {
                        for(var y = new xl(this._properties), I = 0, U = Object.keys(this._values); I < U.length; I += 1){
                            var J = U[I];
                            y._values[J] = this._values[J].untransitioned();
                        }
                        return y;
                    };
                    var js = function(y, I, U, J, ne) {
                        this.property = y, this.value = I, this.begin = ne + J.delay || 0, this.end = this.begin + J.duration || 0, y.specification.transition && (J.delay || J.duration) && (this.prior = U);
                    };
                    js.prototype.possiblyEvaluate = function(y, I, U) {
                        var J = y.now || 0, ne = this.value.possiblyEvaluate(y, I, U), fe = this.prior;
                        if (fe) {
                            if (J > this.end) return this.prior = null, ne;
                            if (this.value.isDataDriven()) return this.prior = null, ne;
                            if (J < this.begin) return fe.possiblyEvaluate(y, I, U);
                            var Fe = (J - this.begin) / (this.end - this.begin);
                            return this.property.interpolate(fe.possiblyEvaluate(y, I, U), ne, v(Fe));
                        } else return ne;
                    };
                    var xl = function(y) {
                        this._properties = y, this._values = Object.create(y.defaultTransitioningPropertyValues);
                    };
                    xl.prototype.possiblyEvaluate = function(y, I, U) {
                        for(var J = new xc(this._properties), ne = 0, fe = Object.keys(this._values); ne < fe.length; ne += 1){
                            var Fe = fe[ne];
                            J._values[Fe] = this._values[Fe].possiblyEvaluate(y, I, U);
                        }
                        return J;
                    }, xl.prototype.hasTransition = function() {
                        for(var y = 0, I = Object.keys(this._values); y < I.length; y += 1){
                            var U = I[y];
                            if (this._values[U].prior) return !0;
                        }
                        return !1;
                    };
                    var fu = function(y) {
                        this._properties = y, this._values = Object.create(y.defaultPropertyValues);
                    };
                    fu.prototype.getValue = function(y) {
                        return G(this._values[y].value);
                    }, fu.prototype.setValue = function(y, I) {
                        this._values[y] = new za(this._values[y].property, I === null ? void 0 : G(I));
                    }, fu.prototype.serialize = function() {
                        for(var y = {}, I = 0, U = Object.keys(this._values); I < U.length; I += 1){
                            var J = U[I], ne = this.getValue(J);
                            ne !== void 0 && (y[J] = ne);
                        }
                        return y;
                    }, fu.prototype.possiblyEvaluate = function(y, I, U) {
                        for(var J = new xc(this._properties), ne = 0, fe = Object.keys(this._values); ne < fe.length; ne += 1){
                            var Fe = fe[ne];
                            J._values[Fe] = this._values[Fe].possiblyEvaluate(y, I, U);
                        }
                        return J;
                    };
                    var dl = function(y, I, U) {
                        this.property = y, this.value = I, this.parameters = U;
                    };
                    dl.prototype.isConstant = function() {
                        return this.value.kind === "constant";
                    }, dl.prototype.constantOr = function(y) {
                        return this.value.kind === "constant" ? this.value.value : y;
                    }, dl.prototype.evaluate = function(y, I, U, J) {
                        return this.property.evaluate(this.value, this.parameters, y, I, U, J);
                    };
                    var xc = function(y) {
                        this._properties = y, this._values = Object.create(y.defaultPossiblyEvaluatedValues);
                    };
                    xc.prototype.get = function(y) {
                        return this._values[y];
                    };
                    var At = function(y) {
                        this.specification = y;
                    };
                    At.prototype.possiblyEvaluate = function(y, I) {
                        return y.expression.evaluate(I);
                    }, At.prototype.interpolate = function(y, I, U) {
                        var J = Gu[this.specification.type];
                        return J ? J(y, I, U) : y;
                    };
                    var Er = function(y, I) {
                        this.specification = y, this.overrides = I;
                    };
                    Er.prototype.possiblyEvaluate = function(y, I, U, J) {
                        return y.expression.kind === "constant" || y.expression.kind === "camera" ? new dl(this, {
                            kind: "constant",
                            value: y.expression.evaluate(I, null, {}, U, J)
                        }, I) : new dl(this, y.expression, I);
                    }, Er.prototype.interpolate = function(y, I, U) {
                        if (y.value.kind !== "constant" || I.value.kind !== "constant") return y;
                        if (y.value.value === void 0 || I.value.value === void 0) return new dl(this, {
                            kind: "constant",
                            value: void 0
                        }, y.parameters);
                        var J = Gu[this.specification.type];
                        return J ? new dl(this, {
                            kind: "constant",
                            value: J(y.value.value, I.value.value, U)
                        }, y.parameters) : y;
                    }, Er.prototype.evaluate = function(y, I, U, J, ne, fe) {
                        return y.kind === "constant" ? y.value : y.evaluate(I, U, J, ne, fe);
                    };
                    var Wr = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.possiblyEvaluate = function(U, J, ne, fe) {
                            if (U.value === void 0) return new dl(this, {
                                kind: "constant",
                                value: void 0
                            }, J);
                            if (U.expression.kind === "constant") {
                                var Fe = U.expression.evaluate(J, null, {}, ne, fe), Qe = U.property.specification.type === "resolvedImage", st = Qe && typeof Fe != "string" ? Fe.name : Fe, mt = this._calculate(st, st, st, J);
                                return new dl(this, {
                                    kind: "constant",
                                    value: mt
                                }, J);
                            } else if (U.expression.kind === "camera") {
                                var Xt = this._calculate(U.expression.evaluate({
                                    zoom: J.zoom - 1
                                }), U.expression.evaluate({
                                    zoom: J.zoom
                                }), U.expression.evaluate({
                                    zoom: J.zoom + 1
                                }), J);
                                return new dl(this, {
                                    kind: "constant",
                                    value: Xt
                                }, J);
                            } else return new dl(this, U.expression, J);
                        }, y.prototype.evaluate = function(U, J, ne, fe, Fe, Qe) {
                            if (U.kind === "source") {
                                var st = U.evaluate(J, ne, fe, Fe, Qe);
                                return this._calculate(st, st, st, J);
                            } else return U.kind === "composite" ? this._calculate(U.evaluate({
                                zoom: Math.floor(J.zoom) - 1
                            }, ne, fe), U.evaluate({
                                zoom: Math.floor(J.zoom)
                            }, ne, fe), U.evaluate({
                                zoom: Math.floor(J.zoom) + 1
                            }, ne, fe), J) : U.value;
                        }, y.prototype._calculate = function(U, J, ne, fe) {
                            var Fe = fe.zoom;
                            return Fe > fe.zoomHistory.lastIntegerZoom ? {
                                from: U,
                                to: J
                            } : {
                                from: ne,
                                to: J
                            };
                        }, y.prototype.interpolate = function(U) {
                            return U;
                        }, y;
                    }(Er), wi = function(y) {
                        this.specification = y;
                    };
                    wi.prototype.possiblyEvaluate = function(y, I, U, J) {
                        if (y.value !== void 0) {
                            if (y.expression.kind === "constant") {
                                var ne = y.expression.evaluate(I, null, {}, U, J);
                                return this._calculate(ne, ne, ne, I);
                            } else return this._calculate(y.expression.evaluate(new pn(Math.floor(I.zoom - 1), I)), y.expression.evaluate(new pn(Math.floor(I.zoom), I)), y.expression.evaluate(new pn(Math.floor(I.zoom + 1), I)), I);
                        }
                    }, wi.prototype._calculate = function(y, I, U, J) {
                        var ne = J.zoom;
                        return ne > J.zoomHistory.lastIntegerZoom ? {
                            from: y,
                            to: I
                        } : {
                            from: U,
                            to: I
                        };
                    }, wi.prototype.interpolate = function(y) {
                        return y;
                    };
                    var Ui = function(y) {
                        this.specification = y;
                    };
                    Ui.prototype.possiblyEvaluate = function(y, I, U, J) {
                        return !!y.expression.evaluate(I, null, {}, U, J);
                    }, Ui.prototype.interpolate = function() {
                        return !1;
                    };
                    var Oi = function(y) {
                        this.properties = y, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                        for(var I in y){
                            var U = y[I];
                            U.specification.overridable && this.overridableProperties.push(I);
                            var J = this.defaultPropertyValues[I] = new za(U, void 0), ne = this.defaultTransitionablePropertyValues[I] = new Lo(U);
                            this.defaultTransitioningPropertyValues[I] = ne.untransitioned(), this.defaultPossiblyEvaluatedValues[I] = J.possiblyEvaluate({});
                        }
                    };
                    Z("DataDrivenProperty", Er), Z("DataConstantProperty", At), Z("CrossFadedDataDrivenProperty", Wr), Z("CrossFadedProperty", wi), Z("ColorRampProperty", Ui);
                    var Bi = "-transition", cn = function(m) {
                        function y(I, U) {
                            if (m.call(this), this.id = I.id, this.type = I.type, this._featureFilter = {
                                filter: function() {
                                    return !0;
                                },
                                needGeometry: !1
                            }, I.type !== "custom" && (I, this.metadata = I.metadata, this.minzoom = I.minzoom, this.maxzoom = I.maxzoom, I.type !== "background" && (this.source = I.source, this.sourceLayer = I["source-layer"], this.filter = I.filter), U.layout && (this._unevaluatedLayout = new fu(U.layout)), U.paint)) {
                                this._transitionablePaint = new Fo(U.paint);
                                for(var J in I.paint)this.setPaintProperty(J, I.paint[J], {
                                    validate: !1
                                });
                                for(var ne in I.layout)this.setLayoutProperty(ne, I.layout[ne], {
                                    validate: !1
                                });
                                this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new xc(U.paint);
                            }
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.getCrossfadeParameters = function() {
                            return this._crossfadeParameters;
                        }, y.prototype.getLayoutProperty = function(U) {
                            return U === "visibility" ? this.visibility : this._unevaluatedLayout.getValue(U);
                        }, y.prototype.setLayoutProperty = function(U, J, ne) {
                            if (ne === void 0 && (ne = {}), J != null) {
                                var fe = "layers." + this.id + ".layout." + U;
                                if (this._validate(Hl, fe, U, J, ne)) return;
                            }
                            if (U === "visibility") {
                                this.visibility = J;
                                return;
                            }
                            this._unevaluatedLayout.setValue(U, J);
                        }, y.prototype.getPaintProperty = function(U) {
                            return V(U, Bi) ? this._transitionablePaint.getTransition(U.slice(0, -Bi.length)) : this._transitionablePaint.getValue(U);
                        }, y.prototype.setPaintProperty = function(U, J, ne) {
                            if (ne === void 0 && (ne = {}), J != null) {
                                var fe = "layers." + this.id + ".paint." + U;
                                if (this._validate(_l, fe, U, J, ne)) return !1;
                            }
                            if (V(U, Bi)) return this._transitionablePaint.setTransition(U.slice(0, -Bi.length), J || void 0), !1;
                            var Fe = this._transitionablePaint._values[U], Qe = Fe.property.specification["property-type"] === "cross-faded-data-driven", st = Fe.value.isDataDriven(), mt = Fe.value;
                            this._transitionablePaint.setValue(U, J), this._handleSpecialPaintPropertyUpdate(U);
                            var Xt = this._transitionablePaint._values[U].value, ur = Xt.isDataDriven();
                            return ur || st || Qe || this._handleOverridablePaintPropertyUpdate(U, mt, Xt);
                        }, y.prototype._handleSpecialPaintPropertyUpdate = function(U) {}, y.prototype._handleOverridablePaintPropertyUpdate = function(U, J, ne) {
                            return !1;
                        }, y.prototype.isHidden = function(U) {
                            return this.minzoom && U < this.minzoom || this.maxzoom && U >= this.maxzoom ? !0 : this.visibility === "none";
                        }, y.prototype.updateTransitions = function(U) {
                            this._transitioningPaint = this._transitionablePaint.transitioned(U, this._transitioningPaint);
                        }, y.prototype.hasTransition = function() {
                            return this._transitioningPaint.hasTransition();
                        }, y.prototype.recalculate = function(U, J) {
                            U.getCrossfadeParameters && (this._crossfadeParameters = U.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(U, void 0, J)), this.paint = this._transitioningPaint.possiblyEvaluate(U, void 0, J);
                        }, y.prototype.serialize = function() {
                            var U = {
                                id: this.id,
                                type: this.type,
                                source: this.source,
                                "source-layer": this.sourceLayer,
                                metadata: this.metadata,
                                minzoom: this.minzoom,
                                maxzoom: this.maxzoom,
                                filter: this.filter,
                                layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                                paint: this._transitionablePaint && this._transitionablePaint.serialize()
                            };
                            return this.visibility && (U.layout = U.layout || {}, U.layout.visibility = this.visibility), X(U, function(J, ne) {
                                return J !== void 0 && !(ne === "layout" && !Object.keys(J).length) && !(ne === "paint" && !Object.keys(J).length);
                            });
                        }, y.prototype._validate = function(U, J, ne, fe, Fe) {
                            return Fe === void 0 && (Fe = {}), Fe && Fe.validate === !1 ? !1 : Zu(this, U.call(yo, {
                                key: J,
                                layerType: this.type,
                                objectKey: ne,
                                value: fe,
                                styleSpec: on,
                                style: {
                                    glyphs: !0,
                                    sprite: !0
                                }
                            }));
                        }, y.prototype.is3D = function() {
                            return !1;
                        }, y.prototype.isTileClipped = function() {
                            return !1;
                        }, y.prototype.hasOffscreenPass = function() {
                            return !1;
                        }, y.prototype.resize = function() {}, y.prototype.isStateDependent = function() {
                            for(var U in this.paint._values){
                                var J = this.paint.get(U);
                                if (!(!(J instanceof dl) || !Gs(J.property.specification)) && (J.value.kind === "source" || J.value.kind === "composite") && J.value.isStateDependent) return !0;
                            }
                            return !1;
                        }, y;
                    }(Sn), On = {
                        Int8: Int8Array,
                        Uint8: Uint8Array,
                        Int16: Int16Array,
                        Uint16: Uint16Array,
                        Int32: Int32Array,
                        Uint32: Uint32Array,
                        Float32: Float32Array
                    }, Bn = function(y, I) {
                        this._structArray = y, this._pos1 = I * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
                    }, yn = 128, to = 5, Rn = function() {
                        this.isTransferred = !1, this.capacity = -1, this.resize(0);
                    };
                    Rn.serialize = function(y, I) {
                        return y._trim(), I && (y.isTransferred = !0, I.push(y.arrayBuffer)), {
                            length: y.length,
                            arrayBuffer: y.arrayBuffer
                        };
                    }, Rn.deserialize = function(y) {
                        var I = Object.create(this.prototype);
                        return I.arrayBuffer = y.arrayBuffer, I.length = y.length, I.capacity = y.arrayBuffer.byteLength / I.bytesPerElement, I._refreshViews(), I;
                    }, Rn.prototype._trim = function() {
                        this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
                    }, Rn.prototype.clear = function() {
                        this.length = 0;
                    }, Rn.prototype.resize = function(y) {
                        this.reserve(y), this.length = y;
                    }, Rn.prototype.reserve = function(y) {
                        if (y > this.capacity) {
                            this.capacity = Math.max(y, Math.floor(this.capacity * to), yn), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                            var I = this.uint8;
                            this._refreshViews(), I && this.uint8.set(I);
                        }
                    }, Rn.prototype._refreshViews = function() {
                        throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
                    };
                    function Dn(m, y) {
                        y === void 0 && (y = 1);
                        var I = 0, U = 0, J = m.map(function(fe) {
                            var Fe = fn(fe.type), Qe = I = Ai(I, Math.max(y, Fe)), st = fe.components || 1;
                            return U = Math.max(U, Fe), I += Fe * st, {
                                name: fe.name,
                                type: fe.type,
                                components: st,
                                offset: Qe
                            };
                        }), ne = Ai(I, Math.max(U, y));
                        return {
                            members: J,
                            size: ne,
                            alignment: y
                        };
                    }
                    function fn(m) {
                        return On[m].BYTES_PER_ELEMENT;
                    }
                    function Ai(m, y) {
                        return Math.ceil(m / y) * y;
                    }
                    var ji = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J) {
                            var ne = this.length;
                            return this.resize(ne + 1), this.emplace(ne, U, J);
                        }, y.prototype.emplace = function(U, J, ne) {
                            var fe = U * 2;
                            return this.int16[fe + 0] = J, this.int16[fe + 1] = ne, U;
                        }, y;
                    }(Rn);
                    ji.prototype.bytesPerElement = 4, Z("StructArrayLayout2i4", ji);
                    var Ln = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe) {
                            var Fe = this.length;
                            return this.resize(Fe + 1), this.emplace(Fe, U, J, ne, fe);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe) {
                            var Qe = U * 4;
                            return this.int16[Qe + 0] = J, this.int16[Qe + 1] = ne, this.int16[Qe + 2] = fe, this.int16[Qe + 3] = Fe, U;
                        }, y;
                    }(Rn);
                    Ln.prototype.bytesPerElement = 8, Z("StructArrayLayout4i8", Ln);
                    var Un = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe, Fe, Qe) {
                            var st = this.length;
                            return this.resize(st + 1), this.emplace(st, U, J, ne, fe, Fe, Qe);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe, Qe, st) {
                            var mt = U * 6;
                            return this.int16[mt + 0] = J, this.int16[mt + 1] = ne, this.int16[mt + 2] = fe, this.int16[mt + 3] = Fe, this.int16[mt + 4] = Qe, this.int16[mt + 5] = st, U;
                        }, y;
                    }(Rn);
                    Un.prototype.bytesPerElement = 12, Z("StructArrayLayout2i4i12", Un);
                    var gn = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe, Fe, Qe) {
                            var st = this.length;
                            return this.resize(st + 1), this.emplace(st, U, J, ne, fe, Fe, Qe);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe, Qe, st) {
                            var mt = U * 4, Xt = U * 8;
                            return this.int16[mt + 0] = J, this.int16[mt + 1] = ne, this.uint8[Xt + 4] = fe, this.uint8[Xt + 5] = Fe, this.uint8[Xt + 6] = Qe, this.uint8[Xt + 7] = st, U;
                        }, y;
                    }(Rn);
                    gn.prototype.bytesPerElement = 8, Z("StructArrayLayout2i4ub8", gn);
                    var ca = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J) {
                            var ne = this.length;
                            return this.resize(ne + 1), this.emplace(ne, U, J);
                        }, y.prototype.emplace = function(U, J, ne) {
                            var fe = U * 2;
                            return this.float32[fe + 0] = J, this.float32[fe + 1] = ne, U;
                        }, y;
                    }(Rn);
                    ca.prototype.bytesPerElement = 8, Z("StructArrayLayout2f8", ca);
                    var Kn = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe, Fe, Qe, st, mt, Xt, ur) {
                            var nr = this.length;
                            return this.resize(nr + 1), this.emplace(nr, U, J, ne, fe, Fe, Qe, st, mt, Xt, ur);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr) {
                            var Lr = U * 10;
                            return this.uint16[Lr + 0] = J, this.uint16[Lr + 1] = ne, this.uint16[Lr + 2] = fe, this.uint16[Lr + 3] = Fe, this.uint16[Lr + 4] = Qe, this.uint16[Lr + 5] = st, this.uint16[Lr + 6] = mt, this.uint16[Lr + 7] = Xt, this.uint16[Lr + 8] = ur, this.uint16[Lr + 9] = nr, U;
                        }, y;
                    }(Rn);
                    Kn.prototype.bytesPerElement = 20, Z("StructArrayLayout10ui20", Kn);
                    var Za = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr) {
                            var Yr = this.length;
                            return this.resize(Yr + 1), this.emplace(Yr, U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr, Yr) {
                            var _i = U * 12;
                            return this.int16[_i + 0] = J, this.int16[_i + 1] = ne, this.int16[_i + 2] = fe, this.int16[_i + 3] = Fe, this.uint16[_i + 4] = Qe, this.uint16[_i + 5] = st, this.uint16[_i + 6] = mt, this.uint16[_i + 7] = Xt, this.int16[_i + 8] = ur, this.int16[_i + 9] = nr, this.int16[_i + 10] = Lr, this.int16[_i + 11] = Yr, U;
                        }, y;
                    }(Rn);
                    Za.prototype.bytesPerElement = 24, Z("StructArrayLayout4i4ui4i24", Za);
                    var wn = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne) {
                            var fe = this.length;
                            return this.resize(fe + 1), this.emplace(fe, U, J, ne);
                        }, y.prototype.emplace = function(U, J, ne, fe) {
                            var Fe = U * 3;
                            return this.float32[Fe + 0] = J, this.float32[Fe + 1] = ne, this.float32[Fe + 2] = fe, U;
                        }, y;
                    }(Rn);
                    wn.prototype.bytesPerElement = 12, Z("StructArrayLayout3f12", wn);
                    var vn = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U) {
                            var J = this.length;
                            return this.resize(J + 1), this.emplace(J, U);
                        }, y.prototype.emplace = function(U, J) {
                            var ne = U * 1;
                            return this.uint32[ne + 0] = J, U;
                        }, y;
                    }(Rn);
                    vn.prototype.bytesPerElement = 4, Z("StructArrayLayout1ul4", vn);
                    var Aa = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe, Fe, Qe, st, mt, Xt) {
                            var ur = this.length;
                            return this.resize(ur + 1), this.emplace(ur, U, J, ne, fe, Fe, Qe, st, mt, Xt);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe, Qe, st, mt, Xt, ur) {
                            var nr = U * 10, Lr = U * 5;
                            return this.int16[nr + 0] = J, this.int16[nr + 1] = ne, this.int16[nr + 2] = fe, this.int16[nr + 3] = Fe, this.int16[nr + 4] = Qe, this.int16[nr + 5] = st, this.uint32[Lr + 3] = mt, this.uint16[nr + 8] = Xt, this.uint16[nr + 9] = ur, U;
                        }, y;
                    }(Rn);
                    Aa.prototype.bytesPerElement = 20, Z("StructArrayLayout6i1ul2ui20", Aa);
                    var aa = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe, Fe, Qe) {
                            var st = this.length;
                            return this.resize(st + 1), this.emplace(st, U, J, ne, fe, Fe, Qe);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe, Qe, st) {
                            var mt = U * 6;
                            return this.int16[mt + 0] = J, this.int16[mt + 1] = ne, this.int16[mt + 2] = fe, this.int16[mt + 3] = Fe, this.int16[mt + 4] = Qe, this.int16[mt + 5] = st, U;
                        }, y;
                    }(Rn);
                    aa.prototype.bytesPerElement = 12, Z("StructArrayLayout2i2i2i12", aa);
                    var Xn = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe, Fe) {
                            var Qe = this.length;
                            return this.resize(Qe + 1), this.emplace(Qe, U, J, ne, fe, Fe);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe, Qe) {
                            var st = U * 4, mt = U * 8;
                            return this.float32[st + 0] = J, this.float32[st + 1] = ne, this.float32[st + 2] = fe, this.int16[mt + 6] = Fe, this.int16[mt + 7] = Qe, U;
                        }, y;
                    }(Rn);
                    Xn.prototype.bytesPerElement = 16, Z("StructArrayLayout2f1f2i16", Xn);
                    var Vn = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe) {
                            var Fe = this.length;
                            return this.resize(Fe + 1), this.emplace(Fe, U, J, ne, fe);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe) {
                            var Qe = U * 12, st = U * 3;
                            return this.uint8[Qe + 0] = J, this.uint8[Qe + 1] = ne, this.float32[st + 1] = fe, this.float32[st + 2] = Fe, U;
                        }, y;
                    }(Rn);
                    Vn.prototype.bytesPerElement = 12, Z("StructArrayLayout2ub2f12", Vn);
                    var ma = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne) {
                            var fe = this.length;
                            return this.resize(fe + 1), this.emplace(fe, U, J, ne);
                        }, y.prototype.emplace = function(U, J, ne, fe) {
                            var Fe = U * 3;
                            return this.uint16[Fe + 0] = J, this.uint16[Fe + 1] = ne, this.uint16[Fe + 2] = fe, U;
                        }, y;
                    }(Rn);
                    ma.prototype.bytesPerElement = 6, Z("StructArrayLayout3ui6", ma);
                    var ro = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr, Yr, _i, si, Hi, Ei) {
                            var Vi = this.length;
                            return this.resize(Vi + 1), this.emplace(Vi, U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr, Yr, _i, si, Hi, Ei);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr, Yr, _i, si, Hi, Ei, Vi) {
                            var en = U * 24, An = U * 12, ra = U * 48;
                            return this.int16[en + 0] = J, this.int16[en + 1] = ne, this.uint16[en + 2] = fe, this.uint16[en + 3] = Fe, this.uint32[An + 2] = Qe, this.uint32[An + 3] = st, this.uint32[An + 4] = mt, this.uint16[en + 10] = Xt, this.uint16[en + 11] = ur, this.uint16[en + 12] = nr, this.float32[An + 7] = Lr, this.float32[An + 8] = Yr, this.uint8[ra + 36] = _i, this.uint8[ra + 37] = si, this.uint8[ra + 38] = Hi, this.uint32[An + 10] = Ei, this.int16[en + 22] = Vi, U;
                        }, y;
                    }(Rn);
                    ro.prototype.bytesPerElement = 48, Z("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", ro);
                    var Ao = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr, Yr, _i, si, Hi, Ei, Vi, en, An, ra, $n, Ba, _a, Pa, qo, Na, ja) {
                            var us = this.length;
                            return this.resize(us + 1), this.emplace(us, U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr, Yr, _i, si, Hi, Ei, Vi, en, An, ra, $n, Ba, _a, Pa, qo, Na, ja);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr, Yr, _i, si, Hi, Ei, Vi, en, An, ra, $n, Ba, _a, Pa, qo, Na, ja, us) {
                            var zo = U * 34, rl = U * 17;
                            return this.int16[zo + 0] = J, this.int16[zo + 1] = ne, this.int16[zo + 2] = fe, this.int16[zo + 3] = Fe, this.int16[zo + 4] = Qe, this.int16[zo + 5] = st, this.int16[zo + 6] = mt, this.int16[zo + 7] = Xt, this.uint16[zo + 8] = ur, this.uint16[zo + 9] = nr, this.uint16[zo + 10] = Lr, this.uint16[zo + 11] = Yr, this.uint16[zo + 12] = _i, this.uint16[zo + 13] = si, this.uint16[zo + 14] = Hi, this.uint16[zo + 15] = Ei, this.uint16[zo + 16] = Vi, this.uint16[zo + 17] = en, this.uint16[zo + 18] = An, this.uint16[zo + 19] = ra, this.uint16[zo + 20] = $n, this.uint16[zo + 21] = Ba, this.uint16[zo + 22] = _a, this.uint32[rl + 12] = Pa, this.float32[rl + 13] = qo, this.float32[rl + 14] = Na, this.float32[rl + 15] = ja, this.float32[rl + 16] = us, U;
                        }, y;
                    }(Rn);
                    Ao.prototype.bytesPerElement = 68, Z("StructArrayLayout8i15ui1ul4f68", Ao);
                    var Jn = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U) {
                            var J = this.length;
                            return this.resize(J + 1), this.emplace(J, U);
                        }, y.prototype.emplace = function(U, J) {
                            var ne = U * 1;
                            return this.float32[ne + 0] = J, U;
                        }, y;
                    }(Rn);
                    Jn.prototype.bytesPerElement = 4, Z("StructArrayLayout1f4", Jn);
                    var Oa = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne) {
                            var fe = this.length;
                            return this.resize(fe + 1), this.emplace(fe, U, J, ne);
                        }, y.prototype.emplace = function(U, J, ne, fe) {
                            var Fe = U * 3;
                            return this.int16[Fe + 0] = J, this.int16[Fe + 1] = ne, this.int16[Fe + 2] = fe, U;
                        }, y;
                    }(Rn);
                    Oa.prototype.bytesPerElement = 6, Z("StructArrayLayout3i6", Oa);
                    var _o = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne) {
                            var fe = this.length;
                            return this.resize(fe + 1), this.emplace(fe, U, J, ne);
                        }, y.prototype.emplace = function(U, J, ne, fe) {
                            var Fe = U * 2, Qe = U * 4;
                            return this.uint32[Fe + 0] = J, this.uint16[Qe + 2] = ne, this.uint16[Qe + 3] = fe, U;
                        }, y;
                    }(Rn);
                    _o.prototype.bytesPerElement = 8, Z("StructArrayLayout1ul2ui8", _o);
                    var Po = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J) {
                            var ne = this.length;
                            return this.resize(ne + 1), this.emplace(ne, U, J);
                        }, y.prototype.emplace = function(U, J, ne) {
                            var fe = U * 2;
                            return this.uint16[fe + 0] = J, this.uint16[fe + 1] = ne, U;
                        }, y;
                    }(Rn);
                    Po.prototype.bytesPerElement = 4, Z("StructArrayLayout2ui4", Po);
                    var Jo = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U) {
                            var J = this.length;
                            return this.resize(J + 1), this.emplace(J, U);
                        }, y.prototype.emplace = function(U, J) {
                            var ne = U * 1;
                            return this.uint16[ne + 0] = J, U;
                        }, y;
                    }(Rn);
                    Jo.prototype.bytesPerElement = 2, Z("StructArrayLayout1ui2", Jo);
                    var Yl = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._refreshViews = function() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }, y.prototype.emplaceBack = function(U, J, ne, fe) {
                            var Fe = this.length;
                            return this.resize(Fe + 1), this.emplace(Fe, U, J, ne, fe);
                        }, y.prototype.emplace = function(U, J, ne, fe, Fe) {
                            var Qe = U * 4;
                            return this.float32[Qe + 0] = J, this.float32[Qe + 1] = ne, this.float32[Qe + 2] = fe, this.float32[Qe + 3] = Fe, U;
                        }, y;
                    }(Rn);
                    Yl.prototype.bytesPerElement = 16, Z("StructArrayLayout4f16", Yl);
                    var $c = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y;
                        var I = {
                            anchorPointX: {
                                configurable: !0
                            },
                            anchorPointY: {
                                configurable: !0
                            },
                            x1: {
                                configurable: !0
                            },
                            y1: {
                                configurable: !0
                            },
                            x2: {
                                configurable: !0
                            },
                            y2: {
                                configurable: !0
                            },
                            featureIndex: {
                                configurable: !0
                            },
                            sourceLayerIndex: {
                                configurable: !0
                            },
                            bucketIndex: {
                                configurable: !0
                            },
                            anchorPoint: {
                                configurable: !0
                            }
                        };
                        return I.anchorPointX.get = function() {
                            return this._structArray.int16[this._pos2 + 0];
                        }, I.anchorPointY.get = function() {
                            return this._structArray.int16[this._pos2 + 1];
                        }, I.x1.get = function() {
                            return this._structArray.int16[this._pos2 + 2];
                        }, I.y1.get = function() {
                            return this._structArray.int16[this._pos2 + 3];
                        }, I.x2.get = function() {
                            return this._structArray.int16[this._pos2 + 4];
                        }, I.y2.get = function() {
                            return this._structArray.int16[this._pos2 + 5];
                        }, I.featureIndex.get = function() {
                            return this._structArray.uint32[this._pos4 + 3];
                        }, I.sourceLayerIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 8];
                        }, I.bucketIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 9];
                        }, I.anchorPoint.get = function() {
                            return new u(this.anchorPointX, this.anchorPointY);
                        }, Object.defineProperties(y.prototype, I), y;
                    }(Bn);
                    $c.prototype.size = 20;
                    var xs = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.get = function(U) {
                            return new $c(this, U);
                        }, y;
                    }(Aa);
                    Z("CollisionBoxArray", xs);
                    var Qc = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y;
                        var I = {
                            anchorX: {
                                configurable: !0
                            },
                            anchorY: {
                                configurable: !0
                            },
                            glyphStartIndex: {
                                configurable: !0
                            },
                            numGlyphs: {
                                configurable: !0
                            },
                            vertexStartIndex: {
                                configurable: !0
                            },
                            lineStartIndex: {
                                configurable: !0
                            },
                            lineLength: {
                                configurable: !0
                            },
                            segment: {
                                configurable: !0
                            },
                            lowerSize: {
                                configurable: !0
                            },
                            upperSize: {
                                configurable: !0
                            },
                            lineOffsetX: {
                                configurable: !0
                            },
                            lineOffsetY: {
                                configurable: !0
                            },
                            writingMode: {
                                configurable: !0
                            },
                            placedOrientation: {
                                configurable: !0
                            },
                            hidden: {
                                configurable: !0
                            },
                            crossTileID: {
                                configurable: !0
                            },
                            associatedIconIndex: {
                                configurable: !0
                            }
                        };
                        return I.anchorX.get = function() {
                            return this._structArray.int16[this._pos2 + 0];
                        }, I.anchorY.get = function() {
                            return this._structArray.int16[this._pos2 + 1];
                        }, I.glyphStartIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 2];
                        }, I.numGlyphs.get = function() {
                            return this._structArray.uint16[this._pos2 + 3];
                        }, I.vertexStartIndex.get = function() {
                            return this._structArray.uint32[this._pos4 + 2];
                        }, I.lineStartIndex.get = function() {
                            return this._structArray.uint32[this._pos4 + 3];
                        }, I.lineLength.get = function() {
                            return this._structArray.uint32[this._pos4 + 4];
                        }, I.segment.get = function() {
                            return this._structArray.uint16[this._pos2 + 10];
                        }, I.lowerSize.get = function() {
                            return this._structArray.uint16[this._pos2 + 11];
                        }, I.upperSize.get = function() {
                            return this._structArray.uint16[this._pos2 + 12];
                        }, I.lineOffsetX.get = function() {
                            return this._structArray.float32[this._pos4 + 7];
                        }, I.lineOffsetY.get = function() {
                            return this._structArray.float32[this._pos4 + 8];
                        }, I.writingMode.get = function() {
                            return this._structArray.uint8[this._pos1 + 36];
                        }, I.placedOrientation.get = function() {
                            return this._structArray.uint8[this._pos1 + 37];
                        }, I.placedOrientation.set = function(U) {
                            this._structArray.uint8[this._pos1 + 37] = U;
                        }, I.hidden.get = function() {
                            return this._structArray.uint8[this._pos1 + 38];
                        }, I.hidden.set = function(U) {
                            this._structArray.uint8[this._pos1 + 38] = U;
                        }, I.crossTileID.get = function() {
                            return this._structArray.uint32[this._pos4 + 10];
                        }, I.crossTileID.set = function(U) {
                            this._structArray.uint32[this._pos4 + 10] = U;
                        }, I.associatedIconIndex.get = function() {
                            return this._structArray.int16[this._pos2 + 22];
                        }, Object.defineProperties(y.prototype, I), y;
                    }(Bn);
                    Qc.prototype.size = 48;
                    var El = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.get = function(U) {
                            return new Qc(this, U);
                        }, y;
                    }(ro);
                    Z("PlacedSymbolArray", El);
                    var bc = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y;
                        var I = {
                            anchorX: {
                                configurable: !0
                            },
                            anchorY: {
                                configurable: !0
                            },
                            rightJustifiedTextSymbolIndex: {
                                configurable: !0
                            },
                            centerJustifiedTextSymbolIndex: {
                                configurable: !0
                            },
                            leftJustifiedTextSymbolIndex: {
                                configurable: !0
                            },
                            verticalPlacedTextSymbolIndex: {
                                configurable: !0
                            },
                            placedIconSymbolIndex: {
                                configurable: !0
                            },
                            verticalPlacedIconSymbolIndex: {
                                configurable: !0
                            },
                            key: {
                                configurable: !0
                            },
                            textBoxStartIndex: {
                                configurable: !0
                            },
                            textBoxEndIndex: {
                                configurable: !0
                            },
                            verticalTextBoxStartIndex: {
                                configurable: !0
                            },
                            verticalTextBoxEndIndex: {
                                configurable: !0
                            },
                            iconBoxStartIndex: {
                                configurable: !0
                            },
                            iconBoxEndIndex: {
                                configurable: !0
                            },
                            verticalIconBoxStartIndex: {
                                configurable: !0
                            },
                            verticalIconBoxEndIndex: {
                                configurable: !0
                            },
                            featureIndex: {
                                configurable: !0
                            },
                            numHorizontalGlyphVertices: {
                                configurable: !0
                            },
                            numVerticalGlyphVertices: {
                                configurable: !0
                            },
                            numIconVertices: {
                                configurable: !0
                            },
                            numVerticalIconVertices: {
                                configurable: !0
                            },
                            useRuntimeCollisionCircles: {
                                configurable: !0
                            },
                            crossTileID: {
                                configurable: !0
                            },
                            textBoxScale: {
                                configurable: !0
                            },
                            textOffset0: {
                                configurable: !0
                            },
                            textOffset1: {
                                configurable: !0
                            },
                            collisionCircleDiameter: {
                                configurable: !0
                            }
                        };
                        return I.anchorX.get = function() {
                            return this._structArray.int16[this._pos2 + 0];
                        }, I.anchorY.get = function() {
                            return this._structArray.int16[this._pos2 + 1];
                        }, I.rightJustifiedTextSymbolIndex.get = function() {
                            return this._structArray.int16[this._pos2 + 2];
                        }, I.centerJustifiedTextSymbolIndex.get = function() {
                            return this._structArray.int16[this._pos2 + 3];
                        }, I.leftJustifiedTextSymbolIndex.get = function() {
                            return this._structArray.int16[this._pos2 + 4];
                        }, I.verticalPlacedTextSymbolIndex.get = function() {
                            return this._structArray.int16[this._pos2 + 5];
                        }, I.placedIconSymbolIndex.get = function() {
                            return this._structArray.int16[this._pos2 + 6];
                        }, I.verticalPlacedIconSymbolIndex.get = function() {
                            return this._structArray.int16[this._pos2 + 7];
                        }, I.key.get = function() {
                            return this._structArray.uint16[this._pos2 + 8];
                        }, I.textBoxStartIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 9];
                        }, I.textBoxEndIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 10];
                        }, I.verticalTextBoxStartIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 11];
                        }, I.verticalTextBoxEndIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 12];
                        }, I.iconBoxStartIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 13];
                        }, I.iconBoxEndIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 14];
                        }, I.verticalIconBoxStartIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 15];
                        }, I.verticalIconBoxEndIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 16];
                        }, I.featureIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 17];
                        }, I.numHorizontalGlyphVertices.get = function() {
                            return this._structArray.uint16[this._pos2 + 18];
                        }, I.numVerticalGlyphVertices.get = function() {
                            return this._structArray.uint16[this._pos2 + 19];
                        }, I.numIconVertices.get = function() {
                            return this._structArray.uint16[this._pos2 + 20];
                        }, I.numVerticalIconVertices.get = function() {
                            return this._structArray.uint16[this._pos2 + 21];
                        }, I.useRuntimeCollisionCircles.get = function() {
                            return this._structArray.uint16[this._pos2 + 22];
                        }, I.crossTileID.get = function() {
                            return this._structArray.uint32[this._pos4 + 12];
                        }, I.crossTileID.set = function(U) {
                            this._structArray.uint32[this._pos4 + 12] = U;
                        }, I.textBoxScale.get = function() {
                            return this._structArray.float32[this._pos4 + 13];
                        }, I.textOffset0.get = function() {
                            return this._structArray.float32[this._pos4 + 14];
                        }, I.textOffset1.get = function() {
                            return this._structArray.float32[this._pos4 + 15];
                        }, I.collisionCircleDiameter.get = function() {
                            return this._structArray.float32[this._pos4 + 16];
                        }, Object.defineProperties(y.prototype, I), y;
                    }(Bn);
                    bc.prototype.size = 68;
                    var wc = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.get = function(U) {
                            return new bc(this, U);
                        }, y;
                    }(Ao);
                    Z("SymbolInstanceArray", wc);
                    var yf = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.getoffsetX = function(U) {
                            return this.float32[U * 1 + 0];
                        }, y;
                    }(Jn);
                    Z("GlyphOffsetArray", yf);
                    var Gl = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.getx = function(U) {
                            return this.int16[U * 3 + 0];
                        }, y.prototype.gety = function(U) {
                            return this.int16[U * 3 + 1];
                        }, y.prototype.gettileUnitDistanceFromAnchor = function(U) {
                            return this.int16[U * 3 + 2];
                        }, y;
                    }(Oa);
                    Z("SymbolLineVertexArray", Gl);
                    var Fc = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y;
                        var I = {
                            featureIndex: {
                                configurable: !0
                            },
                            sourceLayerIndex: {
                                configurable: !0
                            },
                            bucketIndex: {
                                configurable: !0
                            }
                        };
                        return I.featureIndex.get = function() {
                            return this._structArray.uint32[this._pos4 + 0];
                        }, I.sourceLayerIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 2];
                        }, I.bucketIndex.get = function() {
                            return this._structArray.uint16[this._pos2 + 3];
                        }, Object.defineProperties(y.prototype, I), y;
                    }(Bn);
                    Fc.prototype.size = 8;
                    var ef = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.get = function(U) {
                            return new Fc(this, U);
                        }, y;
                    }(_o);
                    Z("FeatureIndexArray", ef);
                    var ls = Dn([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), _f = ls.members, ns = function(y) {
                        y === void 0 && (y = []), this.segments = y;
                    };
                    ns.prototype.prepareSegment = function(y, I, U, J) {
                        var ne = this.segments[this.segments.length - 1];
                        return y > ns.MAX_VERTEX_ARRAY_LENGTH && re("Max vertices per segment is " + ns.MAX_VERTEX_ARRAY_LENGTH + ": bucket requested " + y), (!ne || ne.vertexLength + y > ns.MAX_VERTEX_ARRAY_LENGTH || ne.sortKey !== J) && (ne = {
                            vertexOffset: I.length,
                            primitiveOffset: U.length,
                            vertexLength: 0,
                            primitiveLength: 0
                        }, J !== void 0 && (ne.sortKey = J), this.segments.push(ne)), ne;
                    }, ns.prototype.get = function() {
                        return this.segments;
                    }, ns.prototype.destroy = function() {
                        for(var y = 0, I = this.segments; y < I.length; y += 1){
                            var U = I[y];
                            for(var J in U.vaos)U.vaos[J].destroy();
                        }
                    }, ns.simpleSegment = function(y, I, U, J) {
                        return new ns([
                            {
                                vertexOffset: y,
                                primitiveOffset: I,
                                vertexLength: U,
                                primitiveLength: J,
                                vaos: {},
                                sortKey: 0
                            }
                        ]);
                    }, ns.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, Z("SegmentVector", ns);
                    function Y1(m, y) {
                        return m = p(Math.floor(m), 0, 255), y = p(Math.floor(y), 0, 255), 256 * m + y;
                    }
                    var z = Dn([
                        {
                            name: "a_pattern_from",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pattern_to",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixel_ratio_from",
                            components: 1,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixel_ratio_to",
                            components: 1,
                            type: "Uint16"
                        }
                    ]), K = a(function(m) {
                        function y(I, U) {
                            var J, ne, fe, Fe, Qe, st, mt, Xt;
                            for(J = I.length & 3, ne = I.length - J, fe = U, Qe = 3432918353, st = 461845907, Xt = 0; Xt < ne;)mt = I.charCodeAt(Xt) & 255 | (I.charCodeAt(++Xt) & 255) << 8 | (I.charCodeAt(++Xt) & 255) << 16 | (I.charCodeAt(++Xt) & 255) << 24, ++Xt, mt = (mt & 65535) * Qe + (((mt >>> 16) * Qe & 65535) << 16) & 4294967295, mt = mt << 15 | mt >>> 17, mt = (mt & 65535) * st + (((mt >>> 16) * st & 65535) << 16) & 4294967295, fe ^= mt, fe = fe << 13 | fe >>> 19, Fe = (fe & 65535) * 5 + (((fe >>> 16) * 5 & 65535) << 16) & 4294967295, fe = (Fe & 65535) + 27492 + (((Fe >>> 16) + 58964 & 65535) << 16);
                            switch(mt = 0, J){
                                case 3:
                                    mt ^= (I.charCodeAt(Xt + 2) & 255) << 16;
                                case 2:
                                    mt ^= (I.charCodeAt(Xt + 1) & 255) << 8;
                                case 1:
                                    mt ^= I.charCodeAt(Xt) & 255, mt = (mt & 65535) * Qe + (((mt >>> 16) * Qe & 65535) << 16) & 4294967295, mt = mt << 15 | mt >>> 17, mt = (mt & 65535) * st + (((mt >>> 16) * st & 65535) << 16) & 4294967295, fe ^= mt;
                            }
                            return fe ^= I.length, fe ^= fe >>> 16, fe = (fe & 65535) * 2246822507 + (((fe >>> 16) * 2246822507 & 65535) << 16) & 4294967295, fe ^= fe >>> 13, fe = (fe & 65535) * 3266489909 + (((fe >>> 16) * 3266489909 & 65535) << 16) & 4294967295, fe ^= fe >>> 16, fe >>> 0;
                        }
                        m.exports = y;
                    }), O = a(function(m) {
                        function y(I, U) {
                            for(var J = I.length, ne = U ^ J, fe = 0, Fe; J >= 4;)Fe = I.charCodeAt(fe) & 255 | (I.charCodeAt(++fe) & 255) << 8 | (I.charCodeAt(++fe) & 255) << 16 | (I.charCodeAt(++fe) & 255) << 24, Fe = (Fe & 65535) * 1540483477 + (((Fe >>> 16) * 1540483477 & 65535) << 16), Fe ^= Fe >>> 24, Fe = (Fe & 65535) * 1540483477 + (((Fe >>> 16) * 1540483477 & 65535) << 16), ne = (ne & 65535) * 1540483477 + (((ne >>> 16) * 1540483477 & 65535) << 16) ^ Fe, J -= 4, ++fe;
                            switch(J){
                                case 3:
                                    ne ^= (I.charCodeAt(fe + 2) & 255) << 16;
                                case 2:
                                    ne ^= (I.charCodeAt(fe + 1) & 255) << 8;
                                case 1:
                                    ne ^= I.charCodeAt(fe) & 255, ne = (ne & 65535) * 1540483477 + (((ne >>> 16) * 1540483477 & 65535) << 16);
                            }
                            return ne ^= ne >>> 13, ne = (ne & 65535) * 1540483477 + (((ne >>> 16) * 1540483477 & 65535) << 16), ne ^= ne >>> 15, ne >>> 0;
                        }
                        m.exports = y;
                    }), $ = K, pe = K, de = O;
                    $.murmur3 = pe, $.murmur2 = de;
                    var Ie = function() {
                        this.ids = [], this.positions = [], this.indexed = !1;
                    };
                    Ie.prototype.add = function(y, I, U, J) {
                        this.ids.push(pt(y)), this.positions.push(I, U, J);
                    }, Ie.prototype.getPositions = function(y) {
                        for(var I = pt(y), U = 0, J = this.ids.length - 1; U < J;){
                            var ne = U + J >> 1;
                            this.ids[ne] >= I ? J = ne : U = ne + 1;
                        }
                        for(var fe = []; this.ids[U] === I;){
                            var Fe = this.positions[3 * U], Qe = this.positions[3 * U + 1], st = this.positions[3 * U + 2];
                            fe.push({
                                index: Fe,
                                start: Qe,
                                end: st
                            }), U++;
                        }
                        return fe;
                    }, Ie.serialize = function(y, I) {
                        var U = new Float64Array(y.ids), J = new Uint32Array(y.positions);
                        return Kt(U, J, 0, U.length - 1), I && I.push(U.buffer, J.buffer), {
                            ids: U,
                            positions: J
                        };
                    }, Ie.deserialize = function(y) {
                        var I = new Ie;
                        return I.ids = y.ids, I.positions = y.positions, I.indexed = !0, I;
                    };
                    var $e = Math.pow(2, 53) - 1;
                    function pt(m) {
                        var y = +m;
                        return !isNaN(y) && y <= $e ? y : $(String(m));
                    }
                    function Kt(m, y, I, U) {
                        for(; I < U;){
                            for(var J = m[I + U >> 1], ne = I - 1, fe = U + 1;;){
                                do ne++;
                                while (m[ne] < J);
                                do fe--;
                                while (m[fe] > J);
                                if (ne >= fe) break;
                                ir(m, ne, fe), ir(y, 3 * ne, 3 * fe), ir(y, 3 * ne + 1, 3 * fe + 1), ir(y, 3 * ne + 2, 3 * fe + 2);
                            }
                            fe - I < U - fe ? (Kt(m, y, I, fe), I = fe + 1) : (Kt(m, y, fe + 1, U), U = fe);
                        }
                    }
                    function ir(m, y, I) {
                        var U = m[y];
                        m[y] = m[I], m[I] = U;
                    }
                    Z("FeaturePositionMap", Ie);
                    var Jt = function(y, I) {
                        this.gl = y.gl, this.location = I;
                    }, vt = function(m) {
                        function y(I, U) {
                            m.call(this, I, U), this.current = 0;
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.set = function(U) {
                            this.current !== U && (this.current = U, this.gl.uniform1i(this.location, U));
                        }, y;
                    }(Jt), Pt = function(m) {
                        function y(I, U) {
                            m.call(this, I, U), this.current = 0;
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.set = function(U) {
                            this.current !== U && (this.current = U, this.gl.uniform1f(this.location, U));
                        }, y;
                    }(Jt), Wt = function(m) {
                        function y(I, U) {
                            m.call(this, I, U), this.current = [
                                0,
                                0
                            ];
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.set = function(U) {
                            (U[0] !== this.current[0] || U[1] !== this.current[1]) && (this.current = U, this.gl.uniform2f(this.location, U[0], U[1]));
                        }, y;
                    }(Jt), rr = function(m) {
                        function y(I, U) {
                            m.call(this, I, U), this.current = [
                                0,
                                0,
                                0
                            ];
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.set = function(U) {
                            (U[0] !== this.current[0] || U[1] !== this.current[1] || U[2] !== this.current[2]) && (this.current = U, this.gl.uniform3f(this.location, U[0], U[1], U[2]));
                        }, y;
                    }(Jt), dr = function(m) {
                        function y(I, U) {
                            m.call(this, I, U), this.current = [
                                0,
                                0,
                                0,
                                0
                            ];
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.set = function(U) {
                            (U[0] !== this.current[0] || U[1] !== this.current[1] || U[2] !== this.current[2] || U[3] !== this.current[3]) && (this.current = U, this.gl.uniform4f(this.location, U[0], U[1], U[2], U[3]));
                        }, y;
                    }(Jt), pr = function(m) {
                        function y(I, U) {
                            m.call(this, I, U), this.current = ss.transparent;
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.set = function(U) {
                            (U.r !== this.current.r || U.g !== this.current.g || U.b !== this.current.b || U.a !== this.current.a) && (this.current = U, this.gl.uniform4f(this.location, U.r, U.g, U.b, U.a));
                        }, y;
                    }(Jt), kr = new Float32Array(16), Ar = function(m) {
                        function y(I, U) {
                            m.call(this, I, U), this.current = kr;
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.set = function(U) {
                            if (U[12] !== this.current[12] || U[0] !== this.current[0]) {
                                this.current = U, this.gl.uniformMatrix4fv(this.location, !1, U);
                                return;
                            }
                            for(var J = 1; J < 16; J++)if (U[J] !== this.current[J]) {
                                this.current = U, this.gl.uniformMatrix4fv(this.location, !1, U);
                                break;
                            }
                        }, y;
                    }(Jt);
                    function gr(m) {
                        return [
                            Y1(255 * m.r, 255 * m.g),
                            Y1(255 * m.b, 255 * m.a)
                        ];
                    }
                    var Cr = function(y, I, U) {
                        this.value = y, this.uniformNames = I.map(function(J) {
                            return "u_" + J;
                        }), this.type = U;
                    };
                    Cr.prototype.setUniform = function(y, I, U) {
                        y.set(U.constantOr(this.value));
                    }, Cr.prototype.getBinding = function(y, I, U) {
                        return this.type === "color" ? new pr(y, I) : new Pt(y, I);
                    };
                    var cr = function(y, I) {
                        this.uniformNames = I.map(function(U) {
                            return "u_" + U;
                        }), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
                    };
                    cr.prototype.setConstantPatternPositions = function(y, I) {
                        this.pixelRatioFrom = I.pixelRatio, this.pixelRatioTo = y.pixelRatio, this.patternFrom = I.tlbr, this.patternTo = y.tlbr;
                    }, cr.prototype.setUniform = function(y, I, U, J) {
                        var ne = J === "u_pattern_to" ? this.patternTo : J === "u_pattern_from" ? this.patternFrom : J === "u_pixel_ratio_to" ? this.pixelRatioTo : J === "u_pixel_ratio_from" ? this.pixelRatioFrom : null;
                        ne && y.set(ne);
                    }, cr.prototype.getBinding = function(y, I, U) {
                        return U.substr(0, 9) === "u_pattern" ? new dr(y, I) : new Pt(y, I);
                    };
                    var Gr = function(y, I, U, J) {
                        this.expression = y, this.type = U, this.maxValue = 0, this.paintVertexAttributes = I.map(function(ne) {
                            return {
                                name: "a_" + ne,
                                type: "Float32",
                                components: U === "color" ? 2 : 1,
                                offset: 0
                            };
                        }), this.paintVertexArray = new J;
                    };
                    Gr.prototype.populatePaintArray = function(y, I, U, J, ne) {
                        var fe = this.paintVertexArray.length, Fe = this.expression.evaluate(new pn(0), I, {}, J, [], ne);
                        this.paintVertexArray.resize(y), this._setPaintValue(fe, y, Fe);
                    }, Gr.prototype.updatePaintArray = function(y, I, U, J) {
                        var ne = this.expression.evaluate({
                            zoom: 0
                        }, U, J);
                        this._setPaintValue(y, I, ne);
                    }, Gr.prototype._setPaintValue = function(y, I, U) {
                        if (this.type === "color") for(var J = gr(U), ne = y; ne < I; ne++)this.paintVertexArray.emplace(ne, J[0], J[1]);
                        else {
                            for(var fe = y; fe < I; fe++)this.paintVertexArray.emplace(fe, U);
                            this.maxValue = Math.max(this.maxValue, Math.abs(U));
                        }
                    }, Gr.prototype.upload = function(y) {
                        this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = y.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                    }, Gr.prototype.destroy = function() {
                        this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                    };
                    var ei = function(y, I, U, J, ne, fe) {
                        this.expression = y, this.uniformNames = I.map(function(Fe) {
                            return "u_" + Fe + "_t";
                        }), this.type = U, this.useIntegerZoom = J, this.zoom = ne, this.maxValue = 0, this.paintVertexAttributes = I.map(function(Fe) {
                            return {
                                name: "a_" + Fe,
                                type: "Float32",
                                components: U === "color" ? 4 : 2,
                                offset: 0
                            };
                        }), this.paintVertexArray = new fe;
                    };
                    ei.prototype.populatePaintArray = function(y, I, U, J, ne) {
                        var fe = this.expression.evaluate(new pn(this.zoom), I, {}, J, [], ne), Fe = this.expression.evaluate(new pn(this.zoom + 1), I, {}, J, [], ne), Qe = this.paintVertexArray.length;
                        this.paintVertexArray.resize(y), this._setPaintValue(Qe, y, fe, Fe);
                    }, ei.prototype.updatePaintArray = function(y, I, U, J) {
                        var ne = this.expression.evaluate({
                            zoom: this.zoom
                        }, U, J), fe = this.expression.evaluate({
                            zoom: this.zoom + 1
                        }, U, J);
                        this._setPaintValue(y, I, ne, fe);
                    }, ei.prototype._setPaintValue = function(y, I, U, J) {
                        if (this.type === "color") for(var ne = gr(U), fe = gr(J), Fe = y; Fe < I; Fe++)this.paintVertexArray.emplace(Fe, ne[0], ne[1], fe[0], fe[1]);
                        else {
                            for(var Qe = y; Qe < I; Qe++)this.paintVertexArray.emplace(Qe, U, J);
                            this.maxValue = Math.max(this.maxValue, Math.abs(U), Math.abs(J));
                        }
                    }, ei.prototype.upload = function(y) {
                        this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = y.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                    }, ei.prototype.destroy = function() {
                        this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                    }, ei.prototype.setUniform = function(y, I) {
                        var U = this.useIntegerZoom ? Math.floor(I.zoom) : I.zoom, J = p(this.expression.interpolationFactor(U, this.zoom, this.zoom + 1), 0, 1);
                        y.set(J);
                    }, ei.prototype.getBinding = function(y, I, U) {
                        return new Pt(y, I);
                    };
                    var yi = function(y, I, U, J, ne, fe) {
                        this.expression = y, this.type = I, this.useIntegerZoom = U, this.zoom = J, this.layerId = fe, this.zoomInPaintVertexArray = new ne, this.zoomOutPaintVertexArray = new ne;
                    };
                    yi.prototype.populatePaintArray = function(y, I, U) {
                        var J = this.zoomInPaintVertexArray.length;
                        this.zoomInPaintVertexArray.resize(y), this.zoomOutPaintVertexArray.resize(y), this._setPaintValues(J, y, I.patterns && I.patterns[this.layerId], U);
                    }, yi.prototype.updatePaintArray = function(y, I, U, J, ne) {
                        this._setPaintValues(y, I, U.patterns && U.patterns[this.layerId], ne);
                    }, yi.prototype._setPaintValues = function(y, I, U, J) {
                        if (!(!J || !U)) {
                            var ne = U.min, fe = U.mid, Fe = U.max, Qe = J[ne], st = J[fe], mt = J[Fe];
                            if (!(!Qe || !st || !mt)) for(var Xt = y; Xt < I; Xt++)this.zoomInPaintVertexArray.emplace(Xt, st.tl[0], st.tl[1], st.br[0], st.br[1], Qe.tl[0], Qe.tl[1], Qe.br[0], Qe.br[1], st.pixelRatio, Qe.pixelRatio), this.zoomOutPaintVertexArray.emplace(Xt, st.tl[0], st.tl[1], st.br[0], st.br[1], mt.tl[0], mt.tl[1], mt.br[0], mt.br[1], st.pixelRatio, mt.pixelRatio);
                        }
                    }, yi.prototype.upload = function(y) {
                        this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = y.createVertexBuffer(this.zoomInPaintVertexArray, z.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = y.createVertexBuffer(this.zoomOutPaintVertexArray, z.members, this.expression.isStateDependent));
                    }, yi.prototype.destroy = function() {
                        this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
                    };
                    var tn = function(y, I, U) {
                        this.binders = {}, this._buffers = [];
                        var J = [];
                        for(var ne in y.paint._values)if (U(ne)) {
                            var fe = y.paint.get(ne);
                            if (!(!(fe instanceof dl) || !Gs(fe.property.specification))) {
                                var Fe = ln(ne, y.type), Qe = fe.value, st = fe.property.specification.type, mt = fe.property.useIntegerZoom, Xt = fe.property.specification["property-type"], ur = Xt === "cross-faded" || Xt === "cross-faded-data-driven";
                                if (Qe.kind === "constant") this.binders[ne] = ur ? new cr(Qe.value, Fe) : new Cr(Qe.value, Fe, st), J.push("/u_" + ne);
                                else if (Qe.kind === "source" || ur) {
                                    var nr = qn(ne, st, "source");
                                    this.binders[ne] = ur ? new yi(Qe, st, mt, I, nr, y.id) : new Gr(Qe, Fe, st, nr), J.push("/a_" + ne);
                                } else {
                                    var Lr = qn(ne, st, "composite");
                                    this.binders[ne] = new ei(Qe, Fe, st, mt, I, Lr), J.push("/z_" + ne);
                                }
                            }
                        }
                        this.cacheKey = J.sort().join("");
                    };
                    tn.prototype.getMaxValue = function(y) {
                        var I = this.binders[y];
                        return I instanceof Gr || I instanceof ei ? I.maxValue : 0;
                    }, tn.prototype.populatePaintArrays = function(y, I, U, J, ne) {
                        for(var fe in this.binders){
                            var Fe = this.binders[fe];
                            (Fe instanceof Gr || Fe instanceof ei || Fe instanceof yi) && Fe.populatePaintArray(y, I, U, J, ne);
                        }
                    }, tn.prototype.setConstantPatternPositions = function(y, I) {
                        for(var U in this.binders){
                            var J = this.binders[U];
                            J instanceof cr && J.setConstantPatternPositions(y, I);
                        }
                    }, tn.prototype.updatePaintArrays = function(y, I, U, J, ne) {
                        var fe = !1;
                        for(var Fe in y)for(var Qe = I.getPositions(Fe), st = 0, mt = Qe; st < mt.length; st += 1){
                            var Xt = mt[st], ur = U.feature(Xt.index);
                            for(var nr in this.binders){
                                var Lr = this.binders[nr];
                                if ((Lr instanceof Gr || Lr instanceof ei || Lr instanceof yi) && Lr.expression.isStateDependent === !0) {
                                    var Yr = J.paint.get(nr);
                                    Lr.expression = Yr.value, Lr.updatePaintArray(Xt.start, Xt.end, ur, y[Fe], ne), fe = !0;
                                }
                            }
                        }
                        return fe;
                    }, tn.prototype.defines = function() {
                        var y = [];
                        for(var I in this.binders){
                            var U = this.binders[I];
                            (U instanceof Cr || U instanceof cr) && y.push.apply(y, U.uniformNames.map(function(J) {
                                return "#define HAS_UNIFORM_" + J;
                            }));
                        }
                        return y;
                    }, tn.prototype.getBinderAttributes = function() {
                        var y = [];
                        for(var I in this.binders){
                            var U = this.binders[I];
                            if (U instanceof Gr || U instanceof ei) for(var J = 0; J < U.paintVertexAttributes.length; J++)y.push(U.paintVertexAttributes[J].name);
                            else if (U instanceof yi) for(var ne = 0; ne < z.members.length; ne++)y.push(z.members[ne].name);
                        }
                        return y;
                    }, tn.prototype.getBinderUniforms = function() {
                        var y = [];
                        for(var I in this.binders){
                            var U = this.binders[I];
                            if (U instanceof Cr || U instanceof cr || U instanceof ei) for(var J = 0, ne = U.uniformNames; J < ne.length; J += 1){
                                var fe = ne[J];
                                y.push(fe);
                            }
                        }
                        return y;
                    }, tn.prototype.getPaintVertexBuffers = function() {
                        return this._buffers;
                    }, tn.prototype.getUniforms = function(y, I) {
                        var U = [];
                        for(var J in this.binders){
                            var ne = this.binders[J];
                            if (ne instanceof Cr || ne instanceof cr || ne instanceof ei) for(var fe = 0, Fe = ne.uniformNames; fe < Fe.length; fe += 1){
                                var Qe = Fe[fe];
                                if (I[Qe]) {
                                    var st = ne.getBinding(y, I[Qe], Qe);
                                    U.push({
                                        name: Qe,
                                        property: J,
                                        binding: st
                                    });
                                }
                            }
                        }
                        return U;
                    }, tn.prototype.setUniforms = function(y, I, U, J) {
                        for(var ne = 0, fe = I; ne < fe.length; ne += 1){
                            var Fe = fe[ne], Qe = Fe.name, st = Fe.property, mt = Fe.binding;
                            this.binders[st].setUniform(mt, J, U.get(st), Qe);
                        }
                    }, tn.prototype.updatePaintBuffers = function(y) {
                        this._buffers = [];
                        for(var I in this.binders){
                            var U = this.binders[I];
                            if (y && U instanceof yi) {
                                var J = y.fromScale === 2 ? U.zoomInPaintVertexBuffer : U.zoomOutPaintVertexBuffer;
                                J && this._buffers.push(J);
                            } else (U instanceof Gr || U instanceof ei) && U.paintVertexBuffer && this._buffers.push(U.paintVertexBuffer);
                        }
                    }, tn.prototype.upload = function(y) {
                        for(var I in this.binders){
                            var U = this.binders[I];
                            (U instanceof Gr || U instanceof ei || U instanceof yi) && U.upload(y);
                        }
                        this.updatePaintBuffers();
                    }, tn.prototype.destroy = function() {
                        for(var y in this.binders){
                            var I = this.binders[y];
                            (I instanceof Gr || I instanceof ei || I instanceof yi) && I.destroy();
                        }
                    };
                    var Ri = function(y, I, U) {
                        U === void 0 && (U = function() {
                            return !0;
                        }), this.programConfigurations = {};
                        for(var J = 0, ne = y; J < ne.length; J += 1){
                            var fe = ne[J];
                            this.programConfigurations[fe.id] = new tn(fe, I, U);
                        }
                        this.needsUpload = !1, this._featureMap = new Ie, this._bufferOffset = 0;
                    };
                    Ri.prototype.populatePaintArrays = function(y, I, U, J, ne, fe) {
                        for(var Fe in this.programConfigurations)this.programConfigurations[Fe].populatePaintArrays(y, I, J, ne, fe);
                        I.id !== void 0 && this._featureMap.add(I.id, U, this._bufferOffset, y), this._bufferOffset = y, this.needsUpload = !0;
                    }, Ri.prototype.updatePaintArrays = function(y, I, U, J) {
                        for(var ne = 0, fe = U; ne < fe.length; ne += 1){
                            var Fe = fe[ne];
                            this.needsUpload = this.programConfigurations[Fe.id].updatePaintArrays(y, this._featureMap, I, Fe, J) || this.needsUpload;
                        }
                    }, Ri.prototype.get = function(y) {
                        return this.programConfigurations[y];
                    }, Ri.prototype.upload = function(y) {
                        if (this.needsUpload) {
                            for(var I in this.programConfigurations)this.programConfigurations[I].upload(y);
                            this.needsUpload = !1;
                        }
                    }, Ri.prototype.destroy = function() {
                        for(var y in this.programConfigurations)this.programConfigurations[y].destroy();
                    };
                    function ln(m, y) {
                        var I = {
                            "text-opacity": [
                                "opacity"
                            ],
                            "icon-opacity": [
                                "opacity"
                            ],
                            "text-color": [
                                "fill_color"
                            ],
                            "icon-color": [
                                "fill_color"
                            ],
                            "text-halo-color": [
                                "halo_color"
                            ],
                            "icon-halo-color": [
                                "halo_color"
                            ],
                            "text-halo-blur": [
                                "halo_blur"
                            ],
                            "icon-halo-blur": [
                                "halo_blur"
                            ],
                            "text-halo-width": [
                                "halo_width"
                            ],
                            "icon-halo-width": [
                                "halo_width"
                            ],
                            "line-gap-width": [
                                "gapwidth"
                            ],
                            "line-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ],
                            "fill-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ],
                            "fill-extrusion-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ]
                        };
                        return I[m] || [
                            m.replace(y + "-", "").replace(/-/g, "_")
                        ];
                    }
                    function Qn(m) {
                        var y = {
                            "line-pattern": {
                                source: Kn,
                                composite: Kn
                            },
                            "fill-pattern": {
                                source: Kn,
                                composite: Kn
                            },
                            "fill-extrusion-pattern": {
                                source: Kn,
                                composite: Kn
                            }
                        };
                        return y[m];
                    }
                    function qn(m, y, I) {
                        var U = {
                            color: {
                                source: ca,
                                composite: Yl
                            },
                            number: {
                                source: Jn,
                                composite: ca
                            }
                        }, J = Qn(m);
                        return J && J[I] || U[y][I];
                    }
                    Z("ConstantBinder", Cr), Z("CrossFadedConstantBinder", cr), Z("SourceExpressionBinder", Gr), Z("CrossFadedCompositeBinder", yi), Z("CompositeExpressionBinder", ei), Z("ProgramConfiguration", tn, {
                        omit: [
                            "_buffers"
                        ]
                    }), Z("ProgramConfigurationSet", Ri);
                    var rn = 8192, bn = 15, mn = Math.pow(2, bn - 1) - 1, Gn = -mn - 1;
                    function da(m) {
                        for(var y = rn / m.extent, I = m.loadGeometry(), U = 0; U < I.length; U++)for(var J = I[U], ne = 0; ne < J.length; ne++){
                            var fe = J[ne], Fe = Math.round(fe.x * y), Qe = Math.round(fe.y * y);
                            fe.x = p(Fe, Gn, mn), fe.y = p(Qe, Gn, mn), (Fe < fe.x || Fe > fe.x + 1 || Qe < fe.y || Qe > fe.y + 1) && re("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                        }
                        return I;
                    }
                    function No(m, y) {
                        return {
                            type: m.type,
                            id: m.id,
                            properties: m.properties,
                            geometry: y ? da(m) : []
                        };
                    }
                    function Do(m, y, I, U, J) {
                        m.emplaceBack(y * 2 + (U + 1) / 2, I * 2 + (J + 1) / 2);
                    }
                    var ps = function(y) {
                        this.zoom = y.zoom, this.overscaling = y.overscaling, this.layers = y.layers, this.layerIds = this.layers.map(function(I) {
                            return I.id;
                        }), this.index = y.index, this.hasPattern = !1, this.layoutVertexArray = new ji, this.indexArray = new ma, this.segments = new ns, this.programConfigurations = new Ri(y.layers, y.zoom), this.stateDependentLayerIds = this.layers.filter(function(I) {
                            return I.isStateDependent();
                        }).map(function(I) {
                            return I.id;
                        });
                    };
                    ps.prototype.populate = function(y, I, U) {
                        var J = this.layers[0], ne = [], fe = null;
                        J.type === "circle" && (fe = J.layout.get("circle-sort-key"));
                        for(var Fe = 0, Qe = y; Fe < Qe.length; Fe += 1){
                            var st = Qe[Fe], mt = st.feature, Xt = st.id, ur = st.index, nr = st.sourceLayerIndex, Lr = this.layers[0]._featureFilter.needGeometry, Yr = No(mt, Lr);
                            if (this.layers[0]._featureFilter.filter(new pn(this.zoom), Yr, U)) {
                                var _i = fe ? fe.evaluate(Yr, {}, U) : void 0, si = {
                                    id: Xt,
                                    properties: mt.properties,
                                    type: mt.type,
                                    sourceLayerIndex: nr,
                                    index: ur,
                                    geometry: Lr ? Yr.geometry : da(mt),
                                    patterns: {},
                                    sortKey: _i
                                };
                                ne.push(si);
                            }
                        }
                        fe && ne.sort(function(_a, Pa) {
                            return _a.sortKey - Pa.sortKey;
                        });
                        for(var Hi = 0, Ei = ne; Hi < Ei.length; Hi += 1){
                            var Vi = Ei[Hi], en = Vi, An = en.geometry, ra = en.index, $n = en.sourceLayerIndex, Ba = y[ra].feature;
                            this.addFeature(Vi, An, ra, U), I.featureIndex.insert(Ba, An, ra, $n, this.index);
                        }
                    }, ps.prototype.update = function(y, I, U) {
                        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(y, I, this.stateDependentLayers, U);
                    }, ps.prototype.isEmpty = function() {
                        return this.layoutVertexArray.length === 0;
                    }, ps.prototype.uploadPending = function() {
                        return !this.uploaded || this.programConfigurations.needsUpload;
                    }, ps.prototype.upload = function(y) {
                        this.uploaded || (this.layoutVertexBuffer = y.createVertexBuffer(this.layoutVertexArray, _f), this.indexBuffer = y.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(y), this.uploaded = !0;
                    }, ps.prototype.destroy = function() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                    }, ps.prototype.addFeature = function(y, I, U, J) {
                        for(var ne = 0, fe = I; ne < fe.length; ne += 1)for(var Fe = fe[ne], Qe = 0, st = Fe; Qe < st.length; Qe += 1){
                            var mt = st[Qe], Xt = mt.x, ur = mt.y;
                            if (!(Xt < 0 || Xt >= rn || ur < 0 || ur >= rn)) {
                                var nr = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, y.sortKey), Lr = nr.vertexLength;
                                Do(this.layoutVertexArray, Xt, ur, -1, -1), Do(this.layoutVertexArray, Xt, ur, 1, -1), Do(this.layoutVertexArray, Xt, ur, 1, 1), Do(this.layoutVertexArray, Xt, ur, -1, 1), this.indexArray.emplaceBack(Lr, Lr + 1, Lr + 2), this.indexArray.emplaceBack(Lr, Lr + 3, Lr + 2), nr.vertexLength += 4, nr.primitiveLength += 2;
                            }
                        }
                        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, y, U, {}, J);
                    }, Z("CircleBucket", ps, {
                        omit: [
                            "layers"
                        ]
                    });
                    function fo(m, y) {
                        for(var I = 0; I < m.length; I++)if (_d(y, m[I])) return !0;
                        for(var U = 0; U < y.length; U++)if (_d(m, y[U])) return !0;
                        return !!Ev(m, y);
                    }
                    function as(m, y, I) {
                        return !!(_d(m, y) || Yv(y, m, I));
                    }
                    function tl(m, y) {
                        if (m.length === 1) return vp(y, m[0]);
                        for(var I = 0; I < y.length; I++)for(var U = y[I], J = 0; J < U.length; J++)if (_d(m, U[J])) return !0;
                        for(var ne = 0; ne < m.length; ne++)if (vp(y, m[ne])) return !0;
                        for(var fe = 0; fe < y.length; fe++)if (Ev(m, y[fe])) return !0;
                        return !1;
                    }
                    function zu(m, y, I) {
                        for(var U = 0; U < y.length; U++){
                            var J = y[U];
                            if (m.length >= 3) {
                                for(var ne = 0; ne < J.length; ne++)if (_d(m, J[ne])) return !0;
                            }
                            if (Mv(m, J, I)) return !0;
                        }
                        return !1;
                    }
                    function Mv(m, y, I) {
                        if (m.length > 1) {
                            if (Ev(m, y)) return !0;
                            for(var U = 0; U < y.length; U++)if (Yv(y[U], m, I)) return !0;
                        }
                        for(var J = 0; J < m.length; J++)if (Yv(m[J], y, I)) return !0;
                        return !1;
                    }
                    function Ev(m, y) {
                        if (m.length === 0 || y.length === 0) return !1;
                        for(var I = 0; I < m.length - 1; I++)for(var U = m[I], J = m[I + 1], ne = 0; ne < y.length - 1; ne++){
                            var fe = y[ne], Fe = y[ne + 1];
                            if (yd(U, J, fe, Fe)) return !0;
                        }
                        return !1;
                    }
                    function yd(m, y, I, U) {
                        return ae(m, I, U) !== ae(y, I, U) && ae(m, y, I) !== ae(m, y, U);
                    }
                    function Yv(m, y, I) {
                        var U = I * I;
                        if (y.length === 1) return m.distSqr(y[0]) < U;
                        for(var J = 1; J < y.length; J++){
                            var ne = y[J - 1], fe = y[J];
                            if (cg(m, ne, fe) < U) return !0;
                        }
                        return !1;
                    }
                    function cg(m, y, I) {
                        var U = y.distSqr(I);
                        if (U === 0) return m.distSqr(y);
                        var J = ((m.x - y.x) * (I.x - y.x) + (m.y - y.y) * (I.y - y.y)) / U;
                        return J < 0 ? m.distSqr(y) : J > 1 ? m.distSqr(I) : m.distSqr(I.sub(y)._mult(J)._add(y));
                    }
                    function vp(m, y) {
                        for(var I = !1, U, J, ne, fe = 0; fe < m.length; fe++){
                            U = m[fe];
                            for(var Fe = 0, Qe = U.length - 1; Fe < U.length; Qe = Fe++)J = U[Fe], ne = U[Qe], J.y > y.y != ne.y > y.y && y.x < (ne.x - J.x) * (y.y - J.y) / (ne.y - J.y) + J.x && (I = !I);
                        }
                        return I;
                    }
                    function _d(m, y) {
                        for(var I = !1, U = 0, J = m.length - 1; U < m.length; J = U++){
                            var ne = m[U], fe = m[J];
                            ne.y > y.y != fe.y > y.y && y.x < (fe.x - ne.x) * (y.y - ne.y) / (fe.y - ne.y) + ne.x && (I = !I);
                        }
                        return I;
                    }
                    function pp(m, y, I, U, J) {
                        for(var ne = 0, fe = m; ne < fe.length; ne += 1){
                            var Fe = fe[ne];
                            if (y <= Fe.x && I <= Fe.y && U >= Fe.x && J >= Fe.y) return !0;
                        }
                        var Qe = [
                            new u(y, I),
                            new u(y, J),
                            new u(U, J),
                            new u(U, I)
                        ];
                        if (m.length > 2) for(var st = 0, mt = Qe; st < mt.length; st += 1){
                            var Xt = mt[st];
                            if (_d(m, Xt)) return !0;
                        }
                        for(var ur = 0; ur < m.length - 1; ur++){
                            var nr = m[ur], Lr = m[ur + 1];
                            if (Nd(nr, Lr, Qe)) return !0;
                        }
                        return !1;
                    }
                    function Nd(m, y, I) {
                        var U = I[0], J = I[2];
                        if (m.x < U.x && y.x < U.x || m.x > J.x && y.x > J.x || m.y < U.y && y.y < U.y || m.y > J.y && y.y > J.y) return !1;
                        var ne = ae(m, y, I[0]);
                        return ne !== ae(m, y, I[1]) || ne !== ae(m, y, I[2]) || ne !== ae(m, y, I[3]);
                    }
                    function xd(m, y, I) {
                        var U = y.paint.get(m).value;
                        return U.kind === "constant" ? U.value : I.programConfigurations.get(y.id).getMaxValue(m);
                    }
                    function kv(m) {
                        return Math.sqrt(m[0] * m[0] + m[1] * m[1]);
                    }
                    function Kv(m, y, I, U, J) {
                        if (!y[0] && !y[1]) return m;
                        var ne = u.convert(y)._mult(J);
                        I === "viewport" && ne._rotate(-U);
                        for(var fe = [], Fe = 0; Fe < m.length; Fe++){
                            var Qe = m[Fe];
                            fe.push(Qe.sub(ne));
                        }
                        return fe;
                    }
                    var Cv = new Oi({
                        "circle-sort-key": new Er(on.layout_circle["circle-sort-key"])
                    }), ny = new Oi({
                        "circle-radius": new Er(on.paint_circle["circle-radius"]),
                        "circle-color": new Er(on.paint_circle["circle-color"]),
                        "circle-blur": new Er(on.paint_circle["circle-blur"]),
                        "circle-opacity": new Er(on.paint_circle["circle-opacity"]),
                        "circle-translate": new At(on.paint_circle["circle-translate"]),
                        "circle-translate-anchor": new At(on.paint_circle["circle-translate-anchor"]),
                        "circle-pitch-scale": new At(on.paint_circle["circle-pitch-scale"]),
                        "circle-pitch-alignment": new At(on.paint_circle["circle-pitch-alignment"]),
                        "circle-stroke-width": new Er(on.paint_circle["circle-stroke-width"]),
                        "circle-stroke-color": new Er(on.paint_circle["circle-stroke-color"]),
                        "circle-stroke-opacity": new Er(on.paint_circle["circle-stroke-opacity"])
                    }), fg = {
                        paint: ny,
                        layout: Cv
                    }, Hf = typeof Float32Array != "undefined" ? Float32Array : Array;
                    Math.hypot || (Math.hypot = function() {
                        for(var m = arguments, y = 0, I = arguments.length; I--;)y += m[I] * m[I];
                        return Math.sqrt(y);
                    });
                    function hg() {
                        var m = new Hf(4);
                        return Hf != Float32Array && (m[1] = 0, m[2] = 0), m[0] = 1, m[3] = 1, m;
                    }
                    function ay(m, y, I) {
                        var U = y[0], J = y[1], ne = y[2], fe = y[3], Fe = Math.sin(I), Qe = Math.cos(I);
                        return m[0] = U * Qe + ne * Fe, m[1] = J * Qe + fe * Fe, m[2] = U * -Fe + ne * Qe, m[3] = J * -Fe + fe * Qe, m;
                    }
                    function Rh() {
                        var m = new Hf(9);
                        return Hf != Float32Array && (m[1] = 0, m[2] = 0, m[3] = 0, m[5] = 0, m[6] = 0, m[7] = 0), m[0] = 1, m[4] = 1, m[8] = 1, m;
                    }
                    function rm(m, y) {
                        var I = Math.sin(y), U = Math.cos(y);
                        return m[0] = U, m[1] = I, m[2] = 0, m[3] = -I, m[4] = U, m[5] = 0, m[6] = 0, m[7] = 0, m[8] = 1, m;
                    }
                    function w1() {
                        var m = new Hf(16);
                        return Hf != Float32Array && (m[1] = 0, m[2] = 0, m[3] = 0, m[4] = 0, m[6] = 0, m[7] = 0, m[8] = 0, m[9] = 0, m[11] = 0, m[12] = 0, m[13] = 0, m[14] = 0), m[0] = 1, m[5] = 1, m[10] = 1, m[15] = 1, m;
                    }
                    function T1(m) {
                        var y = new Hf(16);
                        return y[0] = m[0], y[1] = m[1], y[2] = m[2], y[3] = m[3], y[4] = m[4], y[5] = m[5], y[6] = m[6], y[7] = m[7], y[8] = m[8], y[9] = m[9], y[10] = m[10], y[11] = m[11], y[12] = m[12], y[13] = m[13], y[14] = m[14], y[15] = m[15], y;
                    }
                    function oy(m) {
                        return m[0] = 1, m[1] = 0, m[2] = 0, m[3] = 0, m[4] = 0, m[5] = 1, m[6] = 0, m[7] = 0, m[8] = 0, m[9] = 0, m[10] = 1, m[11] = 0, m[12] = 0, m[13] = 0, m[14] = 0, m[15] = 1, m;
                    }
                    function im(m, y) {
                        var I = y[0], U = y[1], J = y[2], ne = y[3], fe = y[4], Fe = y[5], Qe = y[6], st = y[7], mt = y[8], Xt = y[9], ur = y[10], nr = y[11], Lr = y[12], Yr = y[13], _i = y[14], si = y[15], Hi = I * Fe - U * fe, Ei = I * Qe - J * fe, Vi = I * st - ne * fe, en = U * Qe - J * Fe, An = U * st - ne * Fe, ra = J * st - ne * Qe, $n = mt * Yr - Xt * Lr, Ba = mt * _i - ur * Lr, _a = mt * si - nr * Lr, Pa = Xt * _i - ur * Yr, qo = Xt * si - nr * Yr, Na = ur * si - nr * _i, ja = Hi * Na - Ei * qo + Vi * Pa + en * _a - An * Ba + ra * $n;
                        return ja ? (ja = 1 / ja, m[0] = (Fe * Na - Qe * qo + st * Pa) * ja, m[1] = (J * qo - U * Na - ne * Pa) * ja, m[2] = (Yr * ra - _i * An + si * en) * ja, m[3] = (ur * An - Xt * ra - nr * en) * ja, m[4] = (Qe * _a - fe * Na - st * Ba) * ja, m[5] = (I * Na - J * _a + ne * Ba) * ja, m[6] = (_i * Vi - Lr * ra - si * Ei) * ja, m[7] = (mt * ra - ur * Vi + nr * Ei) * ja, m[8] = (fe * qo - Fe * _a + st * $n) * ja, m[9] = (U * _a - I * qo - ne * $n) * ja, m[10] = (Lr * An - Yr * Vi + si * Hi) * ja, m[11] = (Xt * Vi - mt * An - nr * Hi) * ja, m[12] = (Fe * Ba - fe * Pa - Qe * $n) * ja, m[13] = (I * Pa - U * Ba + J * $n) * ja, m[14] = (Yr * Ei - Lr * en - _i * Hi) * ja, m[15] = (mt * en - Xt * Ei + ur * Hi) * ja, m) : null;
                    }
                    function nm(m, y, I) {
                        var U = y[0], J = y[1], ne = y[2], fe = y[3], Fe = y[4], Qe = y[5], st = y[6], mt = y[7], Xt = y[8], ur = y[9], nr = y[10], Lr = y[11], Yr = y[12], _i = y[13], si = y[14], Hi = y[15], Ei = I[0], Vi = I[1], en = I[2], An = I[3];
                        return m[0] = Ei * U + Vi * Fe + en * Xt + An * Yr, m[1] = Ei * J + Vi * Qe + en * ur + An * _i, m[2] = Ei * ne + Vi * st + en * nr + An * si, m[3] = Ei * fe + Vi * mt + en * Lr + An * Hi, Ei = I[4], Vi = I[5], en = I[6], An = I[7], m[4] = Ei * U + Vi * Fe + en * Xt + An * Yr, m[5] = Ei * J + Vi * Qe + en * ur + An * _i, m[6] = Ei * ne + Vi * st + en * nr + An * si, m[7] = Ei * fe + Vi * mt + en * Lr + An * Hi, Ei = I[8], Vi = I[9], en = I[10], An = I[11], m[8] = Ei * U + Vi * Fe + en * Xt + An * Yr, m[9] = Ei * J + Vi * Qe + en * ur + An * _i, m[10] = Ei * ne + Vi * st + en * nr + An * si, m[11] = Ei * fe + Vi * mt + en * Lr + An * Hi, Ei = I[12], Vi = I[13], en = I[14], An = I[15], m[12] = Ei * U + Vi * Fe + en * Xt + An * Yr, m[13] = Ei * J + Vi * Qe + en * ur + An * _i, m[14] = Ei * ne + Vi * st + en * nr + An * si, m[15] = Ei * fe + Vi * mt + en * Lr + An * Hi, m;
                    }
                    function Fu(m, y, I) {
                        var U = I[0], J = I[1], ne = I[2], fe, Fe, Qe, st, mt, Xt, ur, nr, Lr, Yr, _i, si;
                        return y === m ? (m[12] = y[0] * U + y[4] * J + y[8] * ne + y[12], m[13] = y[1] * U + y[5] * J + y[9] * ne + y[13], m[14] = y[2] * U + y[6] * J + y[10] * ne + y[14], m[15] = y[3] * U + y[7] * J + y[11] * ne + y[15]) : (fe = y[0], Fe = y[1], Qe = y[2], st = y[3], mt = y[4], Xt = y[5], ur = y[6], nr = y[7], Lr = y[8], Yr = y[9], _i = y[10], si = y[11], m[0] = fe, m[1] = Fe, m[2] = Qe, m[3] = st, m[4] = mt, m[5] = Xt, m[6] = ur, m[7] = nr, m[8] = Lr, m[9] = Yr, m[10] = _i, m[11] = si, m[12] = fe * U + mt * J + Lr * ne + y[12], m[13] = Fe * U + Xt * J + Yr * ne + y[13], m[14] = Qe * U + ur * J + _i * ne + y[14], m[15] = st * U + nr * J + si * ne + y[15]), m;
                    }
                    function kl(m, y, I) {
                        var U = I[0], J = I[1], ne = I[2];
                        return m[0] = y[0] * U, m[1] = y[1] * U, m[2] = y[2] * U, m[3] = y[3] * U, m[4] = y[4] * J, m[5] = y[5] * J, m[6] = y[6] * J, m[7] = y[7] * J, m[8] = y[8] * ne, m[9] = y[9] * ne, m[10] = y[10] * ne, m[11] = y[11] * ne, m[12] = y[12], m[13] = y[13], m[14] = y[14], m[15] = y[15], m;
                    }
                    function bd(m, y, I) {
                        var U = Math.sin(I), J = Math.cos(I), ne = y[4], fe = y[5], Fe = y[6], Qe = y[7], st = y[8], mt = y[9], Xt = y[10], ur = y[11];
                        return y !== m && (m[0] = y[0], m[1] = y[1], m[2] = y[2], m[3] = y[3], m[12] = y[12], m[13] = y[13], m[14] = y[14], m[15] = y[15]), m[4] = ne * J + st * U, m[5] = fe * J + mt * U, m[6] = Fe * J + Xt * U, m[7] = Qe * J + ur * U, m[8] = st * J - ne * U, m[9] = mt * J - fe * U, m[10] = Xt * J - Fe * U, m[11] = ur * J - Qe * U, m;
                    }
                    function sy(m, y, I) {
                        var U = Math.sin(I), J = Math.cos(I), ne = y[0], fe = y[1], Fe = y[2], Qe = y[3], st = y[4], mt = y[5], Xt = y[6], ur = y[7];
                        return y !== m && (m[8] = y[8], m[9] = y[9], m[10] = y[10], m[11] = y[11], m[12] = y[12], m[13] = y[13], m[14] = y[14], m[15] = y[15]), m[0] = ne * J + st * U, m[1] = fe * J + mt * U, m[2] = Fe * J + Xt * U, m[3] = Qe * J + ur * U, m[4] = st * J - ne * U, m[5] = mt * J - fe * U, m[6] = Xt * J - Fe * U, m[7] = ur * J - Qe * U, m;
                    }
                    function A1(m, y, I, U, J) {
                        var ne = 1 / Math.tan(y / 2), fe;
                        return m[0] = ne / I, m[1] = 0, m[2] = 0, m[3] = 0, m[4] = 0, m[5] = ne, m[6] = 0, m[7] = 0, m[8] = 0, m[9] = 0, m[11] = -1, m[12] = 0, m[13] = 0, m[15] = 0, J != null && J !== 1 / 0 ? (fe = 1 / (U - J), m[10] = (J + U) * fe, m[14] = 2 * J * U * fe) : (m[10] = -1, m[14] = -2 * U), m;
                    }
                    function Kl(m, y, I, U, J, ne, fe) {
                        var Fe = 1 / (y - I), Qe = 1 / (U - J), st = 1 / (ne - fe);
                        return m[0] = -2 * Fe, m[1] = 0, m[2] = 0, m[3] = 0, m[4] = 0, m[5] = -2 * Qe, m[6] = 0, m[7] = 0, m[8] = 0, m[9] = 0, m[10] = 2 * st, m[11] = 0, m[12] = (y + I) * Fe, m[13] = (J + U) * Qe, m[14] = (fe + ne) * st, m[15] = 1, m;
                    }
                    var Nx = nm;
                    function am() {
                        var m = new Hf(3);
                        return Hf != Float32Array && (m[0] = 0, m[1] = 0, m[2] = 0), m;
                    }
                    function Mw(m) {
                        var y = new Hf(3);
                        return y[0] = m[0], y[1] = m[1], y[2] = m[2], y;
                    }
                    function Lv(m, y, I) {
                        return m[0] = y[0] + I[0], m[1] = y[1] + I[1], m[2] = y[2] + I[2], m;
                    }
                    function om(m, y, I) {
                        return m[0] = y[0] - I[0], m[1] = y[1] - I[1], m[2] = y[2] - I[2], m;
                    }
                    function Ew(m, y, I) {
                        return m[0] = y[0] * I, m[1] = y[1] * I, m[2] = y[2] * I, m;
                    }
                    function Ux(m, y) {
                        var I = y[0], U = y[1], J = y[2], ne = I * I + U * U + J * J;
                        return ne > 0 && (ne = 1 / Math.sqrt(ne)), m[0] = y[0] * ne, m[1] = y[1] * ne, m[2] = y[2] * ne, m;
                    }
                    function P9(m, y) {
                        return m[0] * y[0] + m[1] * y[1] + m[2] * y[2];
                    }
                    function I9(m, y, I) {
                        var U = y[0], J = y[1], ne = y[2], fe = I[0], Fe = I[1], Qe = I[2];
                        return m[0] = J * Qe - ne * Fe, m[1] = ne * fe - U * Qe, m[2] = U * Fe - J * fe, m;
                    }
                    function R9(m, y, I) {
                        var U = y[0], J = y[1], ne = y[2];
                        return m[0] = U * I[0] + J * I[3] + ne * I[6], m[1] = U * I[1] + J * I[4] + ne * I[7], m[2] = U * I[2] + J * I[5] + ne * I[8], m;
                    }
                    var D9 = om, mQ = function() {
                        var m = am();
                        return function(y, I, U, J, ne, fe) {
                            var Fe, Qe;
                            for(I || (I = 3), U || (U = 0), J ? Qe = Math.min(J * I + U, y.length) : Qe = y.length, Fe = U; Fe < Qe; Fe += I)m[0] = y[Fe], m[1] = y[Fe + 1], m[2] = y[Fe + 2], ne(m, m, fe), y[Fe] = m[0], y[Fe + 1] = m[1], y[Fe + 2] = m[2];
                            return y;
                        };
                    }();
                    function z9() {
                        var m = new Hf(4);
                        return Hf != Float32Array && (m[0] = 0, m[1] = 0, m[2] = 0, m[3] = 0), m;
                    }
                    function F9(m, y, I) {
                        return m[0] = y[0] * I, m[1] = y[1] * I, m[2] = y[2] * I, m[3] = y[3] * I, m;
                    }
                    function q9(m, y) {
                        return m[0] * y[0] + m[1] * y[1] + m[2] * y[2] + m[3] * y[3];
                    }
                    function ly(m, y, I) {
                        var U = y[0], J = y[1], ne = y[2], fe = y[3];
                        return m[0] = I[0] * U + I[4] * J + I[8] * ne + I[12] * fe, m[1] = I[1] * U + I[5] * J + I[9] * ne + I[13] * fe, m[2] = I[2] * U + I[6] * J + I[10] * ne + I[14] * fe, m[3] = I[3] * U + I[7] * J + I[11] * ne + I[15] * fe, m;
                    }
                    var Vx = function() {
                        var m = z9();
                        return function(y, I, U, J, ne, fe) {
                            var Fe, Qe;
                            for(I || (I = 4), U || (U = 0), J ? Qe = Math.min(J * I + U, y.length) : Qe = y.length, Fe = U; Fe < Qe; Fe += I)m[0] = y[Fe], m[1] = y[Fe + 1], m[2] = y[Fe + 2], m[3] = y[Fe + 3], ne(m, m, fe), y[Fe] = m[0], y[Fe + 1] = m[1], y[Fe + 2] = m[2], y[Fe + 3] = m[3];
                            return y;
                        };
                    }();
                    function cC() {
                        var m = new Hf(2);
                        return Hf != Float32Array && (m[0] = 0, m[1] = 0), m;
                    }
                    function eS(m) {
                        var y = m[0], I = m[1];
                        return y * y + I * I;
                    }
                    var tS = eS, yQ = function() {
                        var m = cC();
                        return function(y, I, U, J, ne, fe) {
                            var Fe, Qe;
                            for(I || (I = 2), U || (U = 0), J ? Qe = Math.min(J * I + U, y.length) : Qe = y.length, Fe = U; Fe < Qe; Fe += I)m[0] = y[Fe], m[1] = y[Fe + 1], ne(m, m, fe), y[Fe] = m[0], y[Fe + 1] = m[1];
                            return y;
                        };
                    }(), O9 = function(m) {
                        function y(I) {
                            m.call(this, I, fg);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.createBucket = function(U) {
                            return new ps(U);
                        }, y.prototype.queryRadius = function(U) {
                            var J = U;
                            return xd("circle-radius", this, J) + xd("circle-stroke-width", this, J) + kv(this.paint.get("circle-translate"));
                        }, y.prototype.queryIntersectsFeature = function(U, J, ne, fe, Fe, Qe, st, mt) {
                            for(var Xt = Kv(U, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), Qe.angle, st), ur = this.paint.get("circle-radius").evaluate(J, ne), nr = this.paint.get("circle-stroke-width").evaluate(J, ne), Lr = ur + nr, Yr = this.paint.get("circle-pitch-alignment") === "map", _i = Yr ? Xt : hC(Xt, mt), si = Yr ? Lr * st : Lr, Hi = 0, Ei = fe; Hi < Ei.length; Hi += 1)for(var Vi = Ei[Hi], en = 0, An = Vi; en < An.length; en += 1){
                                var ra = An[en], $n = Yr ? ra : fC(ra, mt), Ba = si, _a = ly([], [
                                    ra.x,
                                    ra.y,
                                    0,
                                    1
                                ], mt);
                                if (this.paint.get("circle-pitch-scale") === "viewport" && this.paint.get("circle-pitch-alignment") === "map" ? Ba *= _a[3] / Qe.cameraToCenterDistance : this.paint.get("circle-pitch-scale") === "map" && this.paint.get("circle-pitch-alignment") === "viewport" && (Ba *= Qe.cameraToCenterDistance / _a[3]), as(_i, $n, Ba)) return !0;
                            }
                            return !1;
                        }, y;
                    }(cn);
                    function fC(m, y) {
                        var I = ly([], [
                            m.x,
                            m.y,
                            0,
                            1
                        ], y);
                        return new u(I[0] / I[3], I[1] / I[3]);
                    }
                    function hC(m, y) {
                        return m.map(function(I) {
                            return fC(I, y);
                        });
                    }
                    var rS = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y;
                    }(ps);
                    Z("HeatmapBucket", rS, {
                        omit: [
                            "layers"
                        ]
                    });
                    function wd(m, y, I, U) {
                        var J = y.width, ne = y.height;
                        if (!U) U = new Uint8Array(J * ne * I);
                        else if (U instanceof Uint8ClampedArray) U = new Uint8Array(U.buffer);
                        else if (U.length !== J * ne * I) throw new RangeError("mismatched image size");
                        return m.width = J, m.height = ne, m.data = U, m;
                    }
                    function kw(m, y, I) {
                        var U = y.width, J = y.height;
                        if (!(U === m.width && J === m.height)) {
                            var ne = wd({}, {
                                width: U,
                                height: J
                            }, I);
                            Cw(m, ne, {
                                x: 0,
                                y: 0
                            }, {
                                x: 0,
                                y: 0
                            }, {
                                width: Math.min(m.width, U),
                                height: Math.min(m.height, J)
                            }, I), m.width = U, m.height = J, m.data = ne.data;
                        }
                    }
                    function Cw(m, y, I, U, J, ne) {
                        if (J.width === 0 || J.height === 0) return y;
                        if (J.width > m.width || J.height > m.height || I.x > m.width - J.width || I.y > m.height - J.height) throw new RangeError("out of range source coordinates for image copy");
                        if (J.width > y.width || J.height > y.height || U.x > y.width - J.width || U.y > y.height - J.height) throw new RangeError("out of range destination coordinates for image copy");
                        for(var fe = m.data, Fe = y.data, Qe = 0; Qe < J.height; Qe++)for(var st = ((I.y + Qe) * m.width + I.x) * ne, mt = ((U.y + Qe) * y.width + U.x) * ne, Xt = 0; Xt < J.width * ne; Xt++)Fe[mt + Xt] = fe[st + Xt];
                        return y;
                    }
                    var Pv = function(y, I) {
                        wd(this, y, 1, I);
                    };
                    Pv.prototype.resize = function(y) {
                        kw(this, y, 1);
                    }, Pv.prototype.clone = function() {
                        return new Pv({
                            width: this.width,
                            height: this.height
                        }, new Uint8Array(this.data));
                    }, Pv.copy = function(y, I, U, J, ne) {
                        Cw(y, I, U, J, ne, 1);
                    };
                    var lh = function(y, I) {
                        wd(this, y, 4, I);
                    };
                    lh.prototype.resize = function(y) {
                        kw(this, y, 4);
                    }, lh.prototype.replace = function(y, I) {
                        I ? this.data.set(y) : y instanceof Uint8ClampedArray ? this.data = new Uint8Array(y.buffer) : this.data = y;
                    }, lh.prototype.clone = function() {
                        return new lh({
                            width: this.width,
                            height: this.height
                        }, new Uint8Array(this.data));
                    }, lh.copy = function(y, I, U, J, ne) {
                        Cw(y, I, U, J, ne, 4);
                    }, Z("AlphaImage", Pv), Z("RGBAImage", lh);
                    var Hx = new Oi({
                        "heatmap-radius": new Er(on.paint_heatmap["heatmap-radius"]),
                        "heatmap-weight": new Er(on.paint_heatmap["heatmap-weight"]),
                        "heatmap-intensity": new At(on.paint_heatmap["heatmap-intensity"]),
                        "heatmap-color": new Ui(on.paint_heatmap["heatmap-color"]),
                        "heatmap-opacity": new At(on.paint_heatmap["heatmap-opacity"])
                    }), S1 = {
                        paint: Hx
                    };
                    function Gx(m) {
                        var y = {}, I = m.resolution || 256, U = m.clips ? m.clips.length : 1, J = m.image || new lh({
                            width: I,
                            height: U
                        }), ne = function(Hi, Ei, Vi) {
                            y[m.evaluationKey] = Vi;
                            var en = m.expression.evaluate(y);
                            J.data[Hi + Ei + 0] = Math.floor(en.r * 255 / en.a), J.data[Hi + Ei + 1] = Math.floor(en.g * 255 / en.a), J.data[Hi + Ei + 2] = Math.floor(en.b * 255 / en.a), J.data[Hi + Ei + 3] = Math.floor(en.a * 255);
                        };
                        if (m.clips) for(var st = 0, mt = 0; st < U; ++st, mt += I * 4)for(var Xt = 0, ur = 0; Xt < I; Xt++, ur += 4){
                            var nr = Xt / (I - 1), Lr = m.clips[st], Yr = Lr.start, _i = Lr.end, si = Yr * (1 - nr) + _i * nr;
                            ne(mt, ur, si);
                        }
                        else for(var fe = 0, Fe = 0; fe < I; fe++, Fe += 4){
                            var Qe = fe / (I - 1);
                            ne(0, Fe, Qe);
                        }
                        return J;
                    }
                    var Lw = function(m) {
                        function y(I) {
                            m.call(this, I, S1), this._updateColorRamp();
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.createBucket = function(U) {
                            return new rS(U);
                        }, y.prototype._handleSpecialPaintPropertyUpdate = function(U) {
                            U === "heatmap-color" && this._updateColorRamp();
                        }, y.prototype._updateColorRamp = function() {
                            var U = this._transitionablePaint._values["heatmap-color"].value.expression;
                            this.colorRamp = Gx({
                                expression: U,
                                evaluationKey: "heatmapDensity",
                                image: this.colorRamp
                            }), this.colorRampTexture = null;
                        }, y.prototype.resize = function() {
                            this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                        }, y.prototype.queryRadius = function() {
                            return 0;
                        }, y.prototype.queryIntersectsFeature = function() {
                            return !1;
                        }, y.prototype.hasOffscreenPass = function() {
                            return this.paint.get("heatmap-opacity") !== 0 && this.visibility !== "none";
                        }, y;
                    }(cn), B9 = new Oi({
                        "hillshade-illumination-direction": new At(on.paint_hillshade["hillshade-illumination-direction"]),
                        "hillshade-illumination-anchor": new At(on.paint_hillshade["hillshade-illumination-anchor"]),
                        "hillshade-exaggeration": new At(on.paint_hillshade["hillshade-exaggeration"]),
                        "hillshade-shadow-color": new At(on.paint_hillshade["hillshade-shadow-color"]),
                        "hillshade-highlight-color": new At(on.paint_hillshade["hillshade-highlight-color"]),
                        "hillshade-accent-color": new At(on.paint_hillshade["hillshade-accent-color"])
                    }), N9 = {
                        paint: B9
                    }, dC = function(m) {
                        function y(I) {
                            m.call(this, I, N9);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.hasOffscreenPass = function() {
                            return this.paint.get("hillshade-exaggeration") !== 0 && this.visibility !== "none";
                        }, y;
                    }(cn), vC = Dn([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), U9 = vC.members, Pw = M1, pC = M1;
                    function M1(m, y, I) {
                        I = I || 2;
                        var U = y && y.length, J = U ? y[0] * I : m.length, ne = Iw(m, 0, J, I, !0), fe = [];
                        if (!ne || ne.next === ne.prev) return fe;
                        var Fe, Qe, st, mt, Xt, ur, nr;
                        if (U && (ne = lm(m, y, ne, I)), m.length > 80 * I) {
                            Fe = st = m[0], Qe = mt = m[1];
                            for(var Lr = I; Lr < J; Lr += I)Xt = m[Lr], ur = m[Lr + 1], Xt < Fe && (Fe = Xt), ur < Qe && (Qe = ur), Xt > st && (st = Xt), ur > mt && (mt = ur);
                            nr = Math.max(st - Fe, mt - Qe), nr = nr !== 0 ? 1 / nr : 0;
                        }
                        return jx(ne, fe, I, Fe, Qe, nr), fe;
                    }
                    function Iw(m, y, I, U, J) {
                        var ne, fe;
                        if (J === uS(m, y, I, U) > 0) for(ne = y; ne < I; ne += U)fe = xC(ne, m[ne], m[ne + 1], fe);
                        else for(ne = I - U; ne >= y; ne -= U)fe = xC(ne, m[ne], m[ne + 1], fe);
                        return fe && Zx(fe, fe.next) && (Kx(fe), fe = fe.next), fe;
                    }
                    function sm(m, y) {
                        if (!m) return m;
                        y || (y = m);
                        var I = m, U;
                        do if (U = !1, !I.steiner && (Zx(I, I.next) || tf(I.prev, I, I.next) === 0)) {
                            if (Kx(I), I = y = I.prev, I === I.next) break;
                            U = !0;
                        } else I = I.next;
                        while (U || I !== y);
                        return y;
                    }
                    function jx(m, y, I, U, J, ne, fe) {
                        if (m) {
                            !fe && ne && Rw(m, U, J, ne);
                            for(var Fe = m, Qe, st; m.prev !== m.next;){
                                if (Qe = m.prev, st = m.next, ne ? mC(m, U, J, ne) : gC(m)) {
                                    y.push(Qe.i / I), y.push(m.i / I), y.push(st.i / I), Kx(m), m = st.next, Fe = st.next;
                                    continue;
                                }
                                if (m = st, m === Fe) {
                                    fe ? fe === 1 ? (m = Wx(sm(m), y, I), jx(m, y, I, U, J, ne, 2)) : fe === 2 && v0(m, y, I, U, J, ne) : jx(sm(m), y, I, U, J, ne, 1);
                                    break;
                                }
                            }
                        }
                    }
                    function gC(m) {
                        var y = m.prev, I = m, U = m.next;
                        if (tf(y, I, U) >= 0) return !1;
                        for(var J = m.next.next; J !== m.prev;){
                            if (um(y.x, y.y, I.x, I.y, U.x, U.y, J.x, J.y) && tf(J.prev, J, J.next) >= 0) return !1;
                            J = J.next;
                        }
                        return !0;
                    }
                    function mC(m, y, I, U) {
                        var J = m.prev, ne = m, fe = m.next;
                        if (tf(J, ne, fe) >= 0) return !1;
                        for(var Fe = J.x < ne.x ? J.x < fe.x ? J.x : fe.x : ne.x < fe.x ? ne.x : fe.x, Qe = J.y < ne.y ? J.y < fe.y ? J.y : fe.y : ne.y < fe.y ? ne.y : fe.y, st = J.x > ne.x ? J.x > fe.x ? J.x : fe.x : ne.x > fe.x ? ne.x : fe.x, mt = J.y > ne.y ? J.y > fe.y ? J.y : fe.y : ne.y > fe.y ? ne.y : fe.y, Xt = aS(Fe, Qe, y, I, U), ur = aS(st, mt, y, I, U), nr = m.prevZ, Lr = m.nextZ; nr && nr.z >= Xt && Lr && Lr.z <= ur;){
                            if (nr !== m.prev && nr !== m.next && um(J.x, J.y, ne.x, ne.y, fe.x, fe.y, nr.x, nr.y) && tf(nr.prev, nr, nr.next) >= 0 || (nr = nr.prevZ, Lr !== m.prev && Lr !== m.next && um(J.x, J.y, ne.x, ne.y, fe.x, fe.y, Lr.x, Lr.y) && tf(Lr.prev, Lr, Lr.next) >= 0)) return !1;
                            Lr = Lr.nextZ;
                        }
                        for(; nr && nr.z >= Xt;){
                            if (nr !== m.prev && nr !== m.next && um(J.x, J.y, ne.x, ne.y, fe.x, fe.y, nr.x, nr.y) && tf(nr.prev, nr, nr.next) >= 0) return !1;
                            nr = nr.prevZ;
                        }
                        for(; Lr && Lr.z <= ur;){
                            if (Lr !== m.prev && Lr !== m.next && um(J.x, J.y, ne.x, ne.y, fe.x, fe.y, Lr.x, Lr.y) && tf(Lr.prev, Lr, Lr.next) >= 0) return !1;
                            Lr = Lr.nextZ;
                        }
                        return !0;
                    }
                    function Wx(m, y, I) {
                        var U = m;
                        do {
                            var J = U.prev, ne = U.next.next;
                            !Zx(J, ne) && Dw(J, U, U.next, ne) && Yx(J, ne) && Yx(ne, J) && (y.push(J.i / I), y.push(U.i / I), y.push(ne.i / I), Kx(U), Kx(U.next), U = m = ne), U = U.next;
                        }while (U !== m);
                        return sm(U);
                    }
                    function v0(m, y, I, U, J, ne) {
                        var fe = m;
                        do {
                            for(var Fe = fe.next.next; Fe !== fe.prev;){
                                if (fe.i !== Fe.i && E1(fe, Fe)) {
                                    var Qe = sS(fe, Fe);
                                    fe = sm(fe, fe.next), Qe = sm(Qe, Qe.next), jx(fe, y, I, U, J, ne), jx(Qe, y, I, U, J, ne);
                                    return;
                                }
                                Fe = Fe.next;
                            }
                            fe = fe.next;
                        }while (fe !== m);
                    }
                    function lm(m, y, I, U) {
                        var J = [], ne, fe, Fe, Qe, st;
                        for(ne = 0, fe = y.length; ne < fe; ne++)Fe = y[ne] * U, Qe = ne < fe - 1 ? y[ne + 1] * U : m.length, st = Iw(m, Fe, Qe, U, !1), st === st.next && (st.steiner = !0), J.push(oS(st));
                        for(J.sort(yC), ne = 0; ne < J.length; ne++)iS(J[ne], I), I = sm(I, I.next);
                        return I;
                    }
                    function yC(m, y) {
                        return m.x - y.x;
                    }
                    function iS(m, y) {
                        if (y = V9(m, y), y) {
                            var I = sS(y, m);
                            sm(y, y.next), sm(I, I.next);
                        }
                    }
                    function V9(m, y) {
                        var I = y, U = m.x, J = m.y, ne = -1 / 0, fe;
                        do {
                            if (J <= I.y && J >= I.next.y && I.next.y !== I.y) {
                                var Fe = I.x + (J - I.y) * (I.next.x - I.x) / (I.next.y - I.y);
                                if (Fe <= U && Fe > ne) {
                                    if (ne = Fe, Fe === U) {
                                        if (J === I.y) return I;
                                        if (J === I.next.y) return I.next;
                                    }
                                    fe = I.x < I.next.x ? I : I.next;
                                }
                            }
                            I = I.next;
                        }while (I !== y);
                        if (!fe) return null;
                        if (U === ne) return fe;
                        var Qe = fe, st = fe.x, mt = fe.y, Xt = 1 / 0, ur;
                        I = fe;
                        do U >= I.x && I.x >= st && U !== I.x && um(J < mt ? U : ne, J, st, mt, J < mt ? ne : U, J, I.x, I.y) && (ur = Math.abs(J - I.y) / (U - I.x), Yx(I, m) && (ur < Xt || ur === Xt && (I.x > fe.x || I.x === fe.x && H9(fe, I))) && (fe = I, Xt = ur)), I = I.next;
                        while (I !== Qe);
                        return fe;
                    }
                    function H9(m, y) {
                        return tf(m.prev, m, y.prev) < 0 && tf(y.next, m, m.next) < 0;
                    }
                    function Rw(m, y, I, U) {
                        var J = m;
                        do J.z === null && (J.z = aS(J.x, J.y, y, I, U)), J.prevZ = J.prev, J.nextZ = J.next, J = J.next;
                        while (J !== m);
                        J.prevZ.nextZ = null, J.prevZ = null, nS(J);
                    }
                    function nS(m) {
                        var y, I, U, J, ne, fe, Fe, Qe, st = 1;
                        do {
                            for(I = m, m = null, ne = null, fe = 0; I;){
                                for(fe++, U = I, Fe = 0, y = 0; y < st && (Fe++, U = U.nextZ, !!U); y++);
                                for(Qe = st; Fe > 0 || Qe > 0 && U;)Fe !== 0 && (Qe === 0 || !U || I.z <= U.z) ? (J = I, I = I.nextZ, Fe--) : (J = U, U = U.nextZ, Qe--), ne ? ne.nextZ = J : m = J, J.prevZ = ne, ne = J;
                                I = U;
                            }
                            ne.nextZ = null, st *= 2;
                        }while (fe > 1);
                        return m;
                    }
                    function aS(m, y, I, U, J) {
                        return m = 32767 * (m - I) * J, y = 32767 * (y - U) * J, m = (m | m << 8) & 16711935, m = (m | m << 4) & 252645135, m = (m | m << 2) & 858993459, m = (m | m << 1) & 1431655765, y = (y | y << 8) & 16711935, y = (y | y << 4) & 252645135, y = (y | y << 2) & 858993459, y = (y | y << 1) & 1431655765, m | y << 1;
                    }
                    function oS(m) {
                        var y = m, I = m;
                        do (y.x < I.x || y.x === I.x && y.y < I.y) && (I = y), y = y.next;
                        while (y !== m);
                        return I;
                    }
                    function um(m, y, I, U, J, ne, fe, Fe) {
                        return (J - fe) * (y - Fe) - (m - fe) * (ne - Fe) >= 0 && (m - fe) * (U - Fe) - (I - fe) * (y - Fe) >= 0 && (I - fe) * (ne - Fe) - (J - fe) * (U - Fe) >= 0;
                    }
                    function E1(m, y) {
                        return m.next.i !== y.i && m.prev.i !== y.i && !_C(m, y) && (Yx(m, y) && Yx(y, m) && G9(m, y) && (tf(m.prev, m, y.prev) || tf(m, y.prev, y)) || Zx(m, y) && tf(m.prev, m, m.next) > 0 && tf(y.prev, y, y.next) > 0);
                    }
                    function tf(m, y, I) {
                        return (y.y - m.y) * (I.x - y.x) - (y.x - m.x) * (I.y - y.y);
                    }
                    function Zx(m, y) {
                        return m.x === y.x && m.y === y.y;
                    }
                    function Dw(m, y, I, U) {
                        var J = uy(tf(m, y, I)), ne = uy(tf(m, y, U)), fe = uy(tf(I, U, m)), Fe = uy(tf(I, U, y));
                        return !!(J !== ne && fe !== Fe || J === 0 && Xx(m, I, y) || ne === 0 && Xx(m, U, y) || fe === 0 && Xx(I, m, U) || Fe === 0 && Xx(I, y, U));
                    }
                    function Xx(m, y, I) {
                        return y.x <= Math.max(m.x, I.x) && y.x >= Math.min(m.x, I.x) && y.y <= Math.max(m.y, I.y) && y.y >= Math.min(m.y, I.y);
                    }
                    function uy(m) {
                        return m > 0 ? 1 : m < 0 ? -1 : 0;
                    }
                    function _C(m, y) {
                        var I = m;
                        do {
                            if (I.i !== m.i && I.next.i !== m.i && I.i !== y.i && I.next.i !== y.i && Dw(I, I.next, m, y)) return !0;
                            I = I.next;
                        }while (I !== m);
                        return !1;
                    }
                    function Yx(m, y) {
                        return tf(m.prev, m, m.next) < 0 ? tf(m, y, m.next) >= 0 && tf(m, m.prev, y) >= 0 : tf(m, y, m.prev) < 0 || tf(m, m.next, y) < 0;
                    }
                    function G9(m, y) {
                        var I = m, U = !1, J = (m.x + y.x) / 2, ne = (m.y + y.y) / 2;
                        do I.y > ne != I.next.y > ne && I.next.y !== I.y && J < (I.next.x - I.x) * (ne - I.y) / (I.next.y - I.y) + I.x && (U = !U), I = I.next;
                        while (I !== m);
                        return U;
                    }
                    function sS(m, y) {
                        var I = new lS(m.i, m.x, m.y), U = new lS(y.i, y.x, y.y), J = m.next, ne = y.prev;
                        return m.next = y, y.prev = m, I.next = J, J.prev = I, U.next = I, I.prev = U, ne.next = U, U.prev = ne, U;
                    }
                    function xC(m, y, I, U) {
                        var J = new lS(m, y, I);
                        return U ? (J.next = U.next, J.prev = U, U.next.prev = J, U.next = J) : (J.prev = J, J.next = J), J;
                    }
                    function Kx(m) {
                        m.next.prev = m.prev, m.prev.next = m.next, m.prevZ && (m.prevZ.nextZ = m.nextZ), m.nextZ && (m.nextZ.prevZ = m.prevZ);
                    }
                    function lS(m, y, I) {
                        this.i = m, this.x = y, this.y = I, this.prev = null, this.next = null, this.z = null, this.prevZ = null, this.nextZ = null, this.steiner = !1;
                    }
                    M1.deviation = function(m, y, I, U) {
                        var J = y && y.length, ne = J ? y[0] * I : m.length, fe = Math.abs(uS(m, 0, ne, I));
                        if (J) for(var Fe = 0, Qe = y.length; Fe < Qe; Fe++){
                            var st = y[Fe] * I, mt = Fe < Qe - 1 ? y[Fe + 1] * I : m.length;
                            fe -= Math.abs(uS(m, st, mt, I));
                        }
                        var Xt = 0;
                        for(Fe = 0; Fe < U.length; Fe += 3){
                            var ur = U[Fe] * I, nr = U[Fe + 1] * I, Lr = U[Fe + 2] * I;
                            Xt += Math.abs((m[ur] - m[Lr]) * (m[nr + 1] - m[ur + 1]) - (m[ur] - m[nr]) * (m[Lr + 1] - m[ur + 1]));
                        }
                        return fe === 0 && Xt === 0 ? 0 : Math.abs((Xt - fe) / fe);
                    };
                    function uS(m, y, I, U) {
                        for(var J = 0, ne = y, fe = I - U; ne < I; ne += U)J += (m[fe] - m[ne]) * (m[ne + 1] + m[fe + 1]), fe = ne;
                        return J;
                    }
                    M1.flatten = function(m) {
                        for(var y = m[0][0].length, I = {
                            vertices: [],
                            holes: [],
                            dimensions: y
                        }, U = 0, J = 0; J < m.length; J++){
                            for(var ne = 0; ne < m[J].length; ne++)for(var fe = 0; fe < y; fe++)I.vertices.push(m[J][ne][fe]);
                            J > 0 && (U += m[J - 1].length, I.holes.push(U));
                        }
                        return I;
                    }, Pw.default = pC;
                    function cS(m, y, I, U, J) {
                        dg(m, y, I || 0, U || m.length - 1, J || bC);
                    }
                    function dg(m, y, I, U, J) {
                        for(; U > I;){
                            if (U - I > 600) {
                                var ne = U - I + 1, fe = y - I + 1, Fe = Math.log(ne), Qe = .5 * Math.exp(2 * Fe / 3), st = .5 * Math.sqrt(Fe * Qe * (ne - Qe) / ne) * (fe - ne / 2 < 0 ? -1 : 1), mt = Math.max(I, Math.floor(y - fe * Qe / ne + st)), Xt = Math.min(U, Math.floor(y + (ne - fe) * Qe / ne + st));
                                dg(m, y, mt, Xt, J);
                            }
                            var ur = m[y], nr = I, Lr = U;
                            for(k1(m, I, y), J(m[U], ur) > 0 && k1(m, I, U); nr < Lr;){
                                for(k1(m, nr, Lr), nr++, Lr--; J(m[nr], ur) < 0;)nr++;
                                for(; J(m[Lr], ur) > 0;)Lr--;
                            }
                            J(m[I], ur) === 0 ? k1(m, I, Lr) : (Lr++, k1(m, Lr, U)), Lr <= y && (I = Lr + 1), y <= Lr && (U = Lr - 1);
                        }
                    }
                    function k1(m, y, I) {
                        var U = m[y];
                        m[y] = m[I], m[I] = U;
                    }
                    function bC(m, y) {
                        return m < y ? -1 : m > y ? 1 : 0;
                    }
                    function zw(m, y) {
                        var I = m.length;
                        if (I <= 1) return [
                            m
                        ];
                        for(var U = [], J, ne, fe = 0; fe < I; fe++){
                            var Fe = _e(m[fe]);
                            Fe !== 0 && (m[fe].area = Math.abs(Fe), ne === void 0 && (ne = Fe < 0), ne === Fe < 0 ? (J && U.push(J), J = [
                                m[fe]
                            ]) : J.push(m[fe]));
                        }
                        if (J && U.push(J), y > 1) for(var Qe = 0; Qe < U.length; Qe++)U[Qe].length <= y || (cS(U[Qe], y, 1, U[Qe].length - 1, wC), U[Qe] = U[Qe].slice(0, y));
                        return U;
                    }
                    function wC(m, y) {
                        return y.area - m.area;
                    }
                    function Fw(m, y, I) {
                        for(var U = I.patternDependencies, J = !1, ne = 0, fe = y; ne < fe.length; ne += 1){
                            var Fe = fe[ne], Qe = Fe.paint.get(m + "-pattern");
                            Qe.isConstant() || (J = !0);
                            var st = Qe.constantOr(null);
                            st && (J = !0, U[st.to] = !0, U[st.from] = !0);
                        }
                        return J;
                    }
                    function Jx(m, y, I, U, J) {
                        for(var ne = J.patternDependencies, fe = 0, Fe = y; fe < Fe.length; fe += 1){
                            var Qe = Fe[fe], st = Qe.paint.get(m + "-pattern"), mt = st.value;
                            if (mt.kind !== "constant") {
                                var Xt = mt.evaluate({
                                    zoom: U - 1
                                }, I, {}, J.availableImages), ur = mt.evaluate({
                                    zoom: U
                                }, I, {}, J.availableImages), nr = mt.evaluate({
                                    zoom: U + 1
                                }, I, {}, J.availableImages);
                                Xt = Xt && Xt.name ? Xt.name : Xt, ur = ur && ur.name ? ur.name : ur, nr = nr && nr.name ? nr.name : nr, ne[Xt] = !0, ne[ur] = !0, ne[nr] = !0, I.patterns[Qe.id] = {
                                    min: Xt,
                                    mid: ur,
                                    max: nr
                                };
                            }
                        }
                        return I;
                    }
                    var $x = 500, gp = function(y) {
                        this.zoom = y.zoom, this.overscaling = y.overscaling, this.layers = y.layers, this.layerIds = this.layers.map(function(I) {
                            return I.id;
                        }), this.index = y.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new ji, this.indexArray = new ma, this.indexArray2 = new Po, this.programConfigurations = new Ri(y.layers, y.zoom), this.segments = new ns, this.segments2 = new ns, this.stateDependentLayerIds = this.layers.filter(function(I) {
                            return I.isStateDependent();
                        }).map(function(I) {
                            return I.id;
                        });
                    };
                    gp.prototype.populate = function(y, I, U) {
                        this.hasPattern = Fw("fill", this.layers, I);
                        for(var J = this.layers[0].layout.get("fill-sort-key"), ne = [], fe = 0, Fe = y; fe < Fe.length; fe += 1){
                            var Qe = Fe[fe], st = Qe.feature, mt = Qe.id, Xt = Qe.index, ur = Qe.sourceLayerIndex, nr = this.layers[0]._featureFilter.needGeometry, Lr = No(st, nr);
                            if (this.layers[0]._featureFilter.filter(new pn(this.zoom), Lr, U)) {
                                var Yr = J ? J.evaluate(Lr, {}, U, I.availableImages) : void 0, _i = {
                                    id: mt,
                                    properties: st.properties,
                                    type: st.type,
                                    sourceLayerIndex: ur,
                                    index: Xt,
                                    geometry: nr ? Lr.geometry : da(st),
                                    patterns: {},
                                    sortKey: Yr
                                };
                                ne.push(_i);
                            }
                        }
                        J && ne.sort(function(_a, Pa) {
                            return _a.sortKey - Pa.sortKey;
                        });
                        for(var si = 0, Hi = ne; si < Hi.length; si += 1){
                            var Ei = Hi[si], Vi = Ei, en = Vi.geometry, An = Vi.index, ra = Vi.sourceLayerIndex;
                            if (this.hasPattern) {
                                var $n = Jx("fill", this.layers, Ei, this.zoom, I);
                                this.patternFeatures.push($n);
                            } else this.addFeature(Ei, en, An, U, {});
                            var Ba = y[An].feature;
                            I.featureIndex.insert(Ba, en, An, ra, this.index);
                        }
                    }, gp.prototype.update = function(y, I, U) {
                        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(y, I, this.stateDependentLayers, U);
                    }, gp.prototype.addFeatures = function(y, I, U) {
                        for(var J = 0, ne = this.patternFeatures; J < ne.length; J += 1){
                            var fe = ne[J];
                            this.addFeature(fe, fe.geometry, fe.index, I, U);
                        }
                    }, gp.prototype.isEmpty = function() {
                        return this.layoutVertexArray.length === 0;
                    }, gp.prototype.uploadPending = function() {
                        return !this.uploaded || this.programConfigurations.needsUpload;
                    }, gp.prototype.upload = function(y) {
                        this.uploaded || (this.layoutVertexBuffer = y.createVertexBuffer(this.layoutVertexArray, U9), this.indexBuffer = y.createIndexBuffer(this.indexArray), this.indexBuffer2 = y.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(y), this.uploaded = !0;
                    }, gp.prototype.destroy = function() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
                    }, gp.prototype.addFeature = function(y, I, U, J, ne) {
                        for(var fe = 0, Fe = zw(I, $x); fe < Fe.length; fe += 1){
                            for(var Qe = Fe[fe], st = 0, mt = 0, Xt = Qe; mt < Xt.length; mt += 1){
                                var ur = Xt[mt];
                                st += ur.length;
                            }
                            for(var nr = this.segments.prepareSegment(st, this.layoutVertexArray, this.indexArray), Lr = nr.vertexLength, Yr = [], _i = [], si = 0, Hi = Qe; si < Hi.length; si += 1){
                                var Ei = Hi[si];
                                if (Ei.length !== 0) {
                                    Ei !== Qe[0] && _i.push(Yr.length / 2);
                                    var Vi = this.segments2.prepareSegment(Ei.length, this.layoutVertexArray, this.indexArray2), en = Vi.vertexLength;
                                    this.layoutVertexArray.emplaceBack(Ei[0].x, Ei[0].y), this.indexArray2.emplaceBack(en + Ei.length - 1, en), Yr.push(Ei[0].x), Yr.push(Ei[0].y);
                                    for(var An = 1; An < Ei.length; An++)this.layoutVertexArray.emplaceBack(Ei[An].x, Ei[An].y), this.indexArray2.emplaceBack(en + An - 1, en + An), Yr.push(Ei[An].x), Yr.push(Ei[An].y);
                                    Vi.vertexLength += Ei.length, Vi.primitiveLength += Ei.length;
                                }
                            }
                            for(var ra = Pw(Yr, _i), $n = 0; $n < ra.length; $n += 3)this.indexArray.emplaceBack(Lr + ra[$n], Lr + ra[$n + 1], Lr + ra[$n + 2]);
                            nr.vertexLength += st, nr.primitiveLength += ra.length / 3;
                        }
                        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, y, U, ne, J);
                    }, Z("FillBucket", gp, {
                        omit: [
                            "layers",
                            "patternFeatures"
                        ]
                    });
                    var fS = new Oi({
                        "fill-sort-key": new Er(on.layout_fill["fill-sort-key"])
                    }), TC = new Oi({
                        "fill-antialias": new At(on.paint_fill["fill-antialias"]),
                        "fill-opacity": new Er(on.paint_fill["fill-opacity"]),
                        "fill-color": new Er(on.paint_fill["fill-color"]),
                        "fill-outline-color": new Er(on.paint_fill["fill-outline-color"]),
                        "fill-translate": new At(on.paint_fill["fill-translate"]),
                        "fill-translate-anchor": new At(on.paint_fill["fill-translate-anchor"]),
                        "fill-pattern": new Wr(on.paint_fill["fill-pattern"])
                    }), Jv = {
                        paint: TC,
                        layout: fS
                    }, Qx = function(m) {
                        function y(I) {
                            m.call(this, I, Jv);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.recalculate = function(U, J) {
                            m.prototype.recalculate.call(this, U, J);
                            var ne = this.paint._values["fill-outline-color"];
                            ne.value.kind === "constant" && ne.value.value === void 0 && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                        }, y.prototype.createBucket = function(U) {
                            return new gp(U);
                        }, y.prototype.queryRadius = function() {
                            return kv(this.paint.get("fill-translate"));
                        }, y.prototype.queryIntersectsFeature = function(U, J, ne, fe, Fe, Qe, st) {
                            var mt = Kv(U, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), Qe.angle, st);
                            return tl(mt, fe);
                        }, y.prototype.isTileClipped = function() {
                            return !0;
                        }, y;
                    }(cn), AC = Dn([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_normal_ed",
                            components: 4,
                            type: "Int16"
                        }
                    ], 4), SC = AC.members, hS = cy;
                    function cy(m, y, I, U, J) {
                        this.properties = {}, this.extent = I, this.type = 0, this._pbf = m, this._geometry = -1, this._keys = U, this._values = J, m.readFields(MC, this, y);
                    }
                    function MC(m, y, I) {
                        m == 1 ? y.id = I.readVarint() : m == 2 ? EC(I, y) : m == 3 ? y.type = I.readVarint() : m == 4 && (y._geometry = I.pos);
                    }
                    function EC(m, y) {
                        for(var I = m.readVarint() + m.pos; m.pos < I;){
                            var U = y._keys[m.readVarint()], J = y._values[m.readVarint()];
                            y.properties[U] = J;
                        }
                    }
                    cy.types = [
                        "Unknown",
                        "Point",
                        "LineString",
                        "Polygon"
                    ], cy.prototype.loadGeometry = function() {
                        var m = this._pbf;
                        m.pos = this._geometry;
                        for(var y = m.readVarint() + m.pos, I = 1, U = 0, J = 0, ne = 0, fe = [], Fe; m.pos < y;){
                            if (U <= 0) {
                                var Qe = m.readVarint();
                                I = Qe & 7, U = Qe >> 3;
                            }
                            if (U--, I === 1 || I === 2) J += m.readSVarint(), ne += m.readSVarint(), I === 1 && (Fe && fe.push(Fe), Fe = []), Fe.push(new u(J, ne));
                            else if (I === 7) Fe && Fe.push(Fe[0].clone());
                            else throw new Error("unknown command " + I);
                        }
                        return Fe && fe.push(Fe), fe;
                    }, cy.prototype.bbox = function() {
                        var m = this._pbf;
                        m.pos = this._geometry;
                        for(var y = m.readVarint() + m.pos, I = 1, U = 0, J = 0, ne = 0, fe = 1 / 0, Fe = -1 / 0, Qe = 1 / 0, st = -1 / 0; m.pos < y;){
                            if (U <= 0) {
                                var mt = m.readVarint();
                                I = mt & 7, U = mt >> 3;
                            }
                            if (U--, I === 1 || I === 2) J += m.readSVarint(), ne += m.readSVarint(), J < fe && (fe = J), J > Fe && (Fe = J), ne < Qe && (Qe = ne), ne > st && (st = ne);
                            else if (I !== 7) throw new Error("unknown command " + I);
                        }
                        return [
                            fe,
                            Qe,
                            Fe,
                            st
                        ];
                    }, cy.prototype.toGeoJSON = function(m, y, I) {
                        var U = this.extent * Math.pow(2, I), J = this.extent * m, ne = this.extent * y, fe = this.loadGeometry(), Fe = cy.types[this.type], Qe, st;
                        function mt(nr) {
                            for(var Lr = 0; Lr < nr.length; Lr++){
                                var Yr = nr[Lr], _i = 180 - (Yr.y + ne) * 360 / U;
                                nr[Lr] = [
                                    (Yr.x + J) * 360 / U - 180,
                                    360 / Math.PI * Math.atan(Math.exp(_i * Math.PI / 180)) - 90
                                ];
                            }
                        }
                        switch(this.type){
                            case 1:
                                var Xt = [];
                                for(Qe = 0; Qe < fe.length; Qe++)Xt[Qe] = fe[Qe][0];
                                fe = Xt, mt(fe);
                                break;
                            case 2:
                                for(Qe = 0; Qe < fe.length; Qe++)mt(fe[Qe]);
                                break;
                            case 3:
                                for(fe = j9(fe), Qe = 0; Qe < fe.length; Qe++)for(st = 0; st < fe[Qe].length; st++)mt(fe[Qe][st]);
                                break;
                        }
                        fe.length === 1 ? fe = fe[0] : Fe = "Multi" + Fe;
                        var ur = {
                            type: "Feature",
                            geometry: {
                                type: Fe,
                                coordinates: fe
                            },
                            properties: this.properties
                        };
                        return "id" in this && (ur.id = this.id), ur;
                    };
                    function j9(m) {
                        var y = m.length;
                        if (y <= 1) return [
                            m
                        ];
                        for(var I = [], U, J, ne = 0; ne < y; ne++){
                            var fe = kC(m[ne]);
                            fe !== 0 && (J === void 0 && (J = fe < 0), J === fe < 0 ? (U && I.push(U), U = [
                                m[ne]
                            ]) : U.push(m[ne]));
                        }
                        return U && I.push(U), I;
                    }
                    function kC(m) {
                        for(var y = 0, I = 0, U = m.length, J = U - 1, ne, fe; I < U; J = I++)ne = m[I], fe = m[J], y += (fe.x - ne.x) * (ne.y + fe.y);
                        return y;
                    }
                    var vg = dS;
                    function dS(m, y) {
                        this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = m, this._keys = [], this._values = [], this._features = [], m.readFields(CC, this, y), this.length = this._features.length;
                    }
                    function CC(m, y, I) {
                        m === 15 ? y.version = I.readVarint() : m === 1 ? y.name = I.readString() : m === 5 ? y.extent = I.readVarint() : m === 2 ? y._features.push(I.pos) : m === 3 ? y._keys.push(I.readString()) : m === 4 && y._values.push(LC(I));
                    }
                    function LC(m) {
                        for(var y = null, I = m.readVarint() + m.pos; m.pos < I;){
                            var U = m.readVarint() >> 3;
                            y = U === 1 ? m.readString() : U === 2 ? m.readFloat() : U === 3 ? m.readDouble() : U === 4 ? m.readVarint64() : U === 5 ? m.readVarint() : U === 6 ? m.readSVarint() : U === 7 ? m.readBoolean() : null;
                        }
                        return y;
                    }
                    dS.prototype.feature = function(m) {
                        if (m < 0 || m >= this._features.length) throw new Error("feature index out of bounds");
                        this._pbf.pos = this._features[m];
                        var y = this._pbf.readVarint() + this._pbf.pos;
                        return new hS(this._pbf, y, this.extent, this._keys, this._values);
                    };
                    var PC = W9;
                    function W9(m, y) {
                        this.layers = m.readFields(Z9, {}, y);
                    }
                    function Z9(m, y, I) {
                        if (m === 3) {
                            var U = new vg(I, I.readVarint() + I.pos);
                            U.length && (y[U.name] = U);
                        }
                    }
                    var IC = PC, C1 = hS, RC = vg, pg = {
                        VectorTile: IC,
                        VectorTileFeature: C1,
                        VectorTileLayer: RC
                    }, DC = pg.VectorTileFeature.types, qw = 500, L1 = Math.pow(2, 13);
                    function cm(m, y, I, U, J, ne, fe, Fe) {
                        m.emplaceBack(y, I, Math.floor(U * L1) * 2 + fe, J * L1 * 2, ne * L1 * 2, Math.round(Fe));
                    }
                    var Hp = function(y) {
                        this.zoom = y.zoom, this.overscaling = y.overscaling, this.layers = y.layers, this.layerIds = this.layers.map(function(I) {
                            return I.id;
                        }), this.index = y.index, this.hasPattern = !1, this.layoutVertexArray = new Un, this.indexArray = new ma, this.programConfigurations = new Ri(y.layers, y.zoom), this.segments = new ns, this.stateDependentLayerIds = this.layers.filter(function(I) {
                            return I.isStateDependent();
                        }).map(function(I) {
                            return I.id;
                        });
                    };
                    Hp.prototype.populate = function(y, I, U) {
                        this.features = [], this.hasPattern = Fw("fill-extrusion", this.layers, I);
                        for(var J = 0, ne = y; J < ne.length; J += 1){
                            var fe = ne[J], Fe = fe.feature, Qe = fe.id, st = fe.index, mt = fe.sourceLayerIndex, Xt = this.layers[0]._featureFilter.needGeometry, ur = No(Fe, Xt);
                            if (this.layers[0]._featureFilter.filter(new pn(this.zoom), ur, U)) {
                                var nr = {
                                    id: Qe,
                                    sourceLayerIndex: mt,
                                    index: st,
                                    geometry: Xt ? ur.geometry : da(Fe),
                                    properties: Fe.properties,
                                    type: Fe.type,
                                    patterns: {}
                                };
                                this.hasPattern ? this.features.push(Jx("fill-extrusion", this.layers, nr, this.zoom, I)) : this.addFeature(nr, nr.geometry, st, U, {}), I.featureIndex.insert(Fe, nr.geometry, st, mt, this.index, !0);
                            }
                        }
                    }, Hp.prototype.addFeatures = function(y, I, U) {
                        for(var J = 0, ne = this.features; J < ne.length; J += 1){
                            var fe = ne[J], Fe = fe.geometry;
                            this.addFeature(fe, Fe, fe.index, I, U);
                        }
                    }, Hp.prototype.update = function(y, I, U) {
                        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(y, I, this.stateDependentLayers, U);
                    }, Hp.prototype.isEmpty = function() {
                        return this.layoutVertexArray.length === 0;
                    }, Hp.prototype.uploadPending = function() {
                        return !this.uploaded || this.programConfigurations.needsUpload;
                    }, Hp.prototype.upload = function(y) {
                        this.uploaded || (this.layoutVertexBuffer = y.createVertexBuffer(this.layoutVertexArray, SC), this.indexBuffer = y.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(y), this.uploaded = !0;
                    }, Hp.prototype.destroy = function() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                    }, Hp.prototype.addFeature = function(y, I, U, J, ne) {
                        for(var fe = 0, Fe = zw(I, qw); fe < Fe.length; fe += 1){
                            for(var Qe = Fe[fe], st = 0, mt = 0, Xt = Qe; mt < Xt.length; mt += 1){
                                var ur = Xt[mt];
                                st += ur.length;
                            }
                            for(var nr = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray), Lr = 0, Yr = Qe; Lr < Yr.length; Lr += 1){
                                var _i = Yr[Lr];
                                if (_i.length !== 0 && !Y9(_i)) for(var si = 0, Hi = 0; Hi < _i.length; Hi++){
                                    var Ei = _i[Hi];
                                    if (Hi >= 1) {
                                        var Vi = _i[Hi - 1];
                                        if (!X9(Ei, Vi)) {
                                            nr.vertexLength + 4 > ns.MAX_VERTEX_ARRAY_LENGTH && (nr = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                            var en = Ei.sub(Vi)._perp()._unit(), An = Vi.dist(Ei);
                                            si + An > 32768 && (si = 0), cm(this.layoutVertexArray, Ei.x, Ei.y, en.x, en.y, 0, 0, si), cm(this.layoutVertexArray, Ei.x, Ei.y, en.x, en.y, 0, 1, si), si += An, cm(this.layoutVertexArray, Vi.x, Vi.y, en.x, en.y, 0, 0, si), cm(this.layoutVertexArray, Vi.x, Vi.y, en.x, en.y, 0, 1, si);
                                            var ra = nr.vertexLength;
                                            this.indexArray.emplaceBack(ra, ra + 2, ra + 1), this.indexArray.emplaceBack(ra + 1, ra + 2, ra + 3), nr.vertexLength += 4, nr.primitiveLength += 2;
                                        }
                                    }
                                }
                            }
                            if (nr.vertexLength + st > ns.MAX_VERTEX_ARRAY_LENGTH && (nr = this.segments.prepareSegment(st, this.layoutVertexArray, this.indexArray)), DC[y.type] === "Polygon") {
                                for(var $n = [], Ba = [], _a = nr.vertexLength, Pa = 0, qo = Qe; Pa < qo.length; Pa += 1){
                                    var Na = qo[Pa];
                                    if (Na.length !== 0) {
                                        Na !== Qe[0] && Ba.push($n.length / 2);
                                        for(var ja = 0; ja < Na.length; ja++){
                                            var us = Na[ja];
                                            cm(this.layoutVertexArray, us.x, us.y, 0, 0, 1, 1, 0), $n.push(us.x), $n.push(us.y);
                                        }
                                    }
                                }
                                for(var zo = Pw($n, Ba), rl = 0; rl < zo.length; rl += 3)this.indexArray.emplaceBack(_a + zo[rl], _a + zo[rl + 2], _a + zo[rl + 1]);
                                nr.primitiveLength += zo.length / 3, nr.vertexLength += st;
                            }
                        }
                        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, y, U, ne, J);
                    }, Z("FillExtrusionBucket", Hp, {
                        omit: [
                            "layers",
                            "features"
                        ]
                    });
                    function X9(m, y) {
                        return m.x === y.x && (m.x < 0 || m.x > rn) || m.y === y.y && (m.y < 0 || m.y > rn);
                    }
                    function Y9(m) {
                        return m.every(function(y) {
                            return y.x < 0;
                        }) || m.every(function(y) {
                            return y.x > rn;
                        }) || m.every(function(y) {
                            return y.y < 0;
                        }) || m.every(function(y) {
                            return y.y > rn;
                        });
                    }
                    var P1 = new Oi({
                        "fill-extrusion-opacity": new At(on["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                        "fill-extrusion-color": new Er(on["paint_fill-extrusion"]["fill-extrusion-color"]),
                        "fill-extrusion-translate": new At(on["paint_fill-extrusion"]["fill-extrusion-translate"]),
                        "fill-extrusion-translate-anchor": new At(on["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                        "fill-extrusion-pattern": new Wr(on["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                        "fill-extrusion-height": new Er(on["paint_fill-extrusion"]["fill-extrusion-height"]),
                        "fill-extrusion-base": new Er(on["paint_fill-extrusion"]["fill-extrusion-base"]),
                        "fill-extrusion-vertical-gradient": new At(on["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                    }), ed = {
                        paint: P1
                    }, fm = function(m) {
                        function y(I) {
                            m.call(this, I, ed);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.createBucket = function(U) {
                            return new Hp(U);
                        }, y.prototype.queryRadius = function() {
                            return kv(this.paint.get("fill-extrusion-translate"));
                        }, y.prototype.is3D = function() {
                            return !0;
                        }, y.prototype.queryIntersectsFeature = function(U, J, ne, fe, Fe, Qe, st, mt) {
                            var Xt = Kv(U, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), Qe.angle, st), ur = this.paint.get("fill-extrusion-height").evaluate(J, ne), nr = this.paint.get("fill-extrusion-base").evaluate(J, ne), Lr = K9(Xt, mt, Qe, 0), Yr = pS(fe, nr, ur, mt), _i = Yr[0], si = Yr[1];
                            return zC(_i, si, Lr);
                        }, y;
                    }(cn);
                    function fy(m, y) {
                        return m.x * y.x + m.y * y.y;
                    }
                    function vS(m, y) {
                        if (m.length === 1) {
                            for(var I = 0, U = y[I++], J; !J || U.equals(J);)if (J = y[I++], !J) return 1 / 0;
                            for(; I < y.length; I++){
                                var ne = y[I], fe = m[0], Fe = J.sub(U), Qe = ne.sub(U), st = fe.sub(U), mt = fy(Fe, Fe), Xt = fy(Fe, Qe), ur = fy(Qe, Qe), nr = fy(st, Fe), Lr = fy(st, Qe), Yr = mt * ur - Xt * Xt, _i = (ur * nr - Xt * Lr) / Yr, si = (mt * Lr - Xt * nr) / Yr, Hi = 1 - _i - si, Ei = U.z * Hi + J.z * _i + ne.z * si;
                                if (isFinite(Ei)) return Ei;
                            }
                            return 1 / 0;
                        } else {
                            for(var Vi = 1 / 0, en = 0, An = y; en < An.length; en += 1){
                                var ra = An[en];
                                Vi = Math.min(Vi, ra.z);
                            }
                            return Vi;
                        }
                    }
                    function zC(m, y, I) {
                        var U = 1 / 0;
                        tl(I, y) && (U = vS(I, y[0]));
                        for(var J = 0; J < y.length; J++)for(var ne = y[J], fe = m[J], Fe = 0; Fe < ne.length - 1; Fe++){
                            var Qe = ne[Fe], st = ne[Fe + 1], mt = fe[Fe], Xt = fe[Fe + 1], ur = [
                                Qe,
                                st,
                                Xt,
                                mt,
                                Qe
                            ];
                            fo(I, ur) && (U = Math.min(U, vS(I, ur)));
                        }
                        return U === 1 / 0 ? !1 : U;
                    }
                    function pS(m, y, I, U) {
                        for(var J = [], ne = [], fe = U[8] * y, Fe = U[9] * y, Qe = U[10] * y, st = U[11] * y, mt = U[8] * I, Xt = U[9] * I, ur = U[10] * I, nr = U[11] * I, Lr = 0, Yr = m; Lr < Yr.length; Lr += 1){
                            for(var _i = Yr[Lr], si = [], Hi = [], Ei = 0, Vi = _i; Ei < Vi.length; Ei += 1){
                                var en = Vi[Ei], An = en.x, ra = en.y, $n = U[0] * An + U[4] * ra + U[12], Ba = U[1] * An + U[5] * ra + U[13], _a = U[2] * An + U[6] * ra + U[14], Pa = U[3] * An + U[7] * ra + U[15], qo = $n + fe, Na = Ba + Fe, ja = _a + Qe, us = Pa + st, zo = $n + mt, rl = Ba + Xt, su = _a + ur, il = Pa + nr, nl = new u(qo / us, Na / us);
                                nl.z = ja / us, si.push(nl);
                                var Ws = new u(zo / il, rl / il);
                                Ws.z = su / il, Hi.push(Ws);
                            }
                            J.push(si), ne.push(Hi);
                        }
                        return [
                            J,
                            ne
                        ];
                    }
                    function K9(m, y, I, U) {
                        for(var J = [], ne = 0, fe = m; ne < fe.length; ne += 1){
                            var Fe = fe[ne], Qe = [
                                Fe.x,
                                Fe.y,
                                U,
                                1
                            ];
                            ly(Qe, Qe, y), J.push(new u(Qe[0] / Qe[3], Qe[1] / Qe[3]));
                        }
                        return J;
                    }
                    var FC = Dn([
                        {
                            name: "a_pos_normal",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_data",
                            components: 4,
                            type: "Uint8"
                        }
                    ], 4), qC = FC.members, J9 = Dn([
                        {
                            name: "a_uv_x",
                            components: 1,
                            type: "Float32"
                        },
                        {
                            name: "a_split_index",
                            components: 1,
                            type: "Float32"
                        }
                    ]), OC = J9.members, gS = pg.VectorTileFeature.types, Ow = 63, BC = Math.cos(37.5 * (Math.PI / 180)), eb = 15, mS = 20, NC = 15, Bw = 0.5, tb = Math.pow(2, NC - 1) / Bw, Gf = function(y) {
                        var I = this;
                        this.zoom = y.zoom, this.overscaling = y.overscaling, this.layers = y.layers, this.layerIds = this.layers.map(function(U) {
                            return U.id;
                        }), this.index = y.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach(function(U) {
                            I.gradients[U.id] = {};
                        }), this.layoutVertexArray = new gn, this.layoutVertexArray2 = new ca, this.indexArray = new ma, this.programConfigurations = new Ri(y.layers, y.zoom), this.segments = new ns, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter(function(U) {
                            return U.isStateDependent();
                        }).map(function(U) {
                            return U.id;
                        });
                    };
                    Gf.prototype.populate = function(y, I, U) {
                        this.hasPattern = Fw("line", this.layers, I);
                        for(var J = this.layers[0].layout.get("line-sort-key"), ne = [], fe = 0, Fe = y; fe < Fe.length; fe += 1){
                            var Qe = Fe[fe], st = Qe.feature, mt = Qe.id, Xt = Qe.index, ur = Qe.sourceLayerIndex, nr = this.layers[0]._featureFilter.needGeometry, Lr = No(st, nr);
                            if (this.layers[0]._featureFilter.filter(new pn(this.zoom), Lr, U)) {
                                var Yr = J ? J.evaluate(Lr, {}, U) : void 0, _i = {
                                    id: mt,
                                    properties: st.properties,
                                    type: st.type,
                                    sourceLayerIndex: ur,
                                    index: Xt,
                                    geometry: nr ? Lr.geometry : da(st),
                                    patterns: {},
                                    sortKey: Yr
                                };
                                ne.push(_i);
                            }
                        }
                        J && ne.sort(function(_a, Pa) {
                            return _a.sortKey - Pa.sortKey;
                        });
                        for(var si = 0, Hi = ne; si < Hi.length; si += 1){
                            var Ei = Hi[si], Vi = Ei, en = Vi.geometry, An = Vi.index, ra = Vi.sourceLayerIndex;
                            if (this.hasPattern) {
                                var $n = Jx("line", this.layers, Ei, this.zoom, I);
                                this.patternFeatures.push($n);
                            } else this.addFeature(Ei, en, An, U, {});
                            var Ba = y[An].feature;
                            I.featureIndex.insert(Ba, en, An, ra, this.index);
                        }
                    }, Gf.prototype.update = function(y, I, U) {
                        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(y, I, this.stateDependentLayers, U);
                    }, Gf.prototype.addFeatures = function(y, I, U) {
                        for(var J = 0, ne = this.patternFeatures; J < ne.length; J += 1){
                            var fe = ne[J];
                            this.addFeature(fe, fe.geometry, fe.index, I, U);
                        }
                    }, Gf.prototype.isEmpty = function() {
                        return this.layoutVertexArray.length === 0;
                    }, Gf.prototype.uploadPending = function() {
                        return !this.uploaded || this.programConfigurations.needsUpload;
                    }, Gf.prototype.upload = function(y) {
                        this.uploaded || (this.layoutVertexArray2.length !== 0 && (this.layoutVertexBuffer2 = y.createVertexBuffer(this.layoutVertexArray2, OC)), this.layoutVertexBuffer = y.createVertexBuffer(this.layoutVertexArray, qC), this.indexBuffer = y.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(y), this.uploaded = !0;
                    }, Gf.prototype.destroy = function() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                    }, Gf.prototype.lineFeatureClips = function(y) {
                        if (y.properties && y.properties.hasOwnProperty("mapbox_clip_start") && y.properties.hasOwnProperty("mapbox_clip_end")) {
                            var I = +y.properties.mapbox_clip_start, U = +y.properties.mapbox_clip_end;
                            return {
                                start: I,
                                end: U
                            };
                        }
                    }, Gf.prototype.addFeature = function(y, I, U, J, ne) {
                        var fe = this.layers[0].layout, Fe = fe.get("line-join").evaluate(y, {}), Qe = fe.get("line-cap"), st = fe.get("line-miter-limit"), mt = fe.get("line-round-limit");
                        this.lineClips = this.lineFeatureClips(y);
                        for(var Xt = 0, ur = I; Xt < ur.length; Xt += 1){
                            var nr = ur[Xt];
                            this.addLine(nr, y, Fe, Qe, st, mt);
                        }
                        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, y, U, ne, J);
                    }, Gf.prototype.addLine = function(y, I, U, J, ne, fe) {
                        if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                            this.lineClipsArray.push(this.lineClips);
                            for(var Fe = 0; Fe < y.length - 1; Fe++)this.totalDistance += y[Fe].dist(y[Fe + 1]);
                            this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                        }
                        for(var Qe = gS[I.type] === "Polygon", st = y.length; st >= 2 && y[st - 1].equals(y[st - 2]);)st--;
                        for(var mt = 0; mt < st - 1 && y[mt].equals(y[mt + 1]);)mt++;
                        if (!(st < (Qe ? 3 : 2))) {
                            U === "bevel" && (ne = 1.05);
                            var Xt = this.overscaling <= 16 ? eb * rn / (512 * this.overscaling) : 0, ur = this.segments.prepareSegment(st * 10, this.layoutVertexArray, this.indexArray), nr, Lr = void 0, Yr = void 0, _i = void 0, si = void 0;
                            this.e1 = this.e2 = -1, Qe && (nr = y[st - 2], si = y[mt].sub(nr)._unit()._perp());
                            for(var Hi = mt; Hi < st; Hi++)if (Yr = Hi === st - 1 ? Qe ? y[mt + 1] : void 0 : y[Hi + 1], !(Yr && y[Hi].equals(Yr))) {
                                si && (_i = si), nr && (Lr = nr), nr = y[Hi], si = Yr ? Yr.sub(nr)._unit()._perp() : _i, _i = _i || si;
                                var Ei = _i.add(si);
                                (Ei.x !== 0 || Ei.y !== 0) && Ei._unit();
                                var Vi = _i.x * si.x + _i.y * si.y, en = Ei.x * si.x + Ei.y * si.y, An = en !== 0 ? 1 / en : 1 / 0, ra = 2 * Math.sqrt(2 - 2 * en), $n = en < BC && Lr && Yr, Ba = _i.x * si.y - _i.y * si.x > 0;
                                if ($n && Hi > mt) {
                                    var _a = nr.dist(Lr);
                                    if (_a > 2 * Xt) {
                                        var Pa = nr.sub(nr.sub(Lr)._mult(Xt / _a)._round());
                                        this.updateDistance(Lr, Pa), this.addCurrentVertex(Pa, _i, 0, 0, ur), Lr = Pa;
                                    }
                                }
                                var qo = Lr && Yr, Na = qo ? U : Qe ? "butt" : J;
                                if (qo && Na === "round" && (An < fe ? Na = "miter" : An <= 2 && (Na = "fakeround")), Na === "miter" && An > ne && (Na = "bevel"), Na === "bevel" && (An > 2 && (Na = "flipbevel"), An < ne && (Na = "miter")), Lr && this.updateDistance(Lr, nr), Na === "miter") Ei._mult(An), this.addCurrentVertex(nr, Ei, 0, 0, ur);
                                else if (Na === "flipbevel") {
                                    if (An > 100) Ei = si.mult(-1);
                                    else {
                                        var ja = An * _i.add(si).mag() / _i.sub(si).mag();
                                        Ei._perp()._mult(ja * (Ba ? -1 : 1));
                                    }
                                    this.addCurrentVertex(nr, Ei, 0, 0, ur), this.addCurrentVertex(nr, Ei.mult(-1), 0, 0, ur);
                                } else if (Na === "bevel" || Na === "fakeround") {
                                    var us = -Math.sqrt(An * An - 1), zo = Ba ? us : 0, rl = Ba ? 0 : us;
                                    if (Lr && this.addCurrentVertex(nr, _i, zo, rl, ur), Na === "fakeround") for(var su = Math.round(ra * 180 / Math.PI / mS), il = 1; il < su; il++){
                                        var nl = il / su;
                                        if (nl !== .5) {
                                            var Ws = nl - .5, Au = 1.0904 + Vi * (-3.2452 + Vi * (3.55645 - Vi * 1.43519)), Ou = .848013 + Vi * (-1.06021 + Vi * .215638);
                                            nl = nl + nl * Ws * (nl - 1) * (Au * Ws * Ws + Ou);
                                        }
                                        var nf = si.sub(_i)._mult(nl)._add(_i)._unit()._mult(Ba ? -1 : 1);
                                        this.addHalfVertex(nr, nf.x, nf.y, !1, Ba, 0, ur);
                                    }
                                    Yr && this.addCurrentVertex(nr, si, -zo, -rl, ur);
                                } else if (Na === "butt") this.addCurrentVertex(nr, Ei, 0, 0, ur);
                                else if (Na === "square") {
                                    var bf = Lr ? 1 : -1;
                                    this.addCurrentVertex(nr, Ei, bf, bf, ur);
                                } else Na === "round" && (Lr && (this.addCurrentVertex(nr, _i, 0, 0, ur), this.addCurrentVertex(nr, _i, 1, 1, ur, !0)), Yr && (this.addCurrentVertex(nr, si, -1, -1, ur, !0), this.addCurrentVertex(nr, si, 0, 0, ur)));
                                if ($n && Hi < st - 1) {
                                    var qh = nr.dist(Yr);
                                    if (qh > 2 * Xt) {
                                        var Zf = nr.add(Yr.sub(nr)._mult(Xt / qh)._round());
                                        this.updateDistance(nr, Zf), this.addCurrentVertex(Zf, si, 0, 0, ur), nr = Zf;
                                    }
                                }
                            }
                        }
                    }, Gf.prototype.addCurrentVertex = function(y, I, U, J, ne, fe) {
                        fe === void 0 && (fe = !1);
                        var Fe = I.x + I.y * U, Qe = I.y - I.x * U, st = -I.x + I.y * J, mt = -I.y - I.x * J;
                        this.addHalfVertex(y, Fe, Qe, fe, !1, U, ne), this.addHalfVertex(y, st, mt, fe, !0, -J, ne), this.distance > tb / 2 && this.totalDistance === 0 && (this.distance = 0, this.addCurrentVertex(y, I, U, J, ne, fe));
                    }, Gf.prototype.addHalfVertex = function(y, I, U, J, ne, fe, Fe) {
                        var Qe = y.x, st = y.y, mt = this.lineClips ? this.scaledDistance * (tb - 1) : this.scaledDistance, Xt = mt * Bw;
                        if (this.layoutVertexArray.emplaceBack((Qe << 1) + (J ? 1 : 0), (st << 1) + (ne ? 1 : 0), Math.round(Ow * I) + 128, Math.round(Ow * U) + 128, (fe === 0 ? 0 : fe < 0 ? -1 : 1) + 1 | (Xt & 63) << 2, Xt >> 6), this.lineClips) {
                            var ur = this.scaledDistance - this.lineClips.start, nr = this.lineClips.end - this.lineClips.start, Lr = ur / nr;
                            this.layoutVertexArray2.emplaceBack(Lr, this.lineClipsArray.length);
                        }
                        var Yr = Fe.vertexLength++;
                        this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, Yr), Fe.primitiveLength++), ne ? this.e2 = Yr : this.e1 = Yr;
                    }, Gf.prototype.updateScaledDistance = function() {
                        this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
                    }, Gf.prototype.updateDistance = function(y, I) {
                        this.distance += y.dist(I), this.updateScaledDistance();
                    }, Z("LineBucket", Gf, {
                        omit: [
                            "layers",
                            "patternFeatures"
                        ]
                    });
                    var yS = new Oi({
                        "line-cap": new At(on.layout_line["line-cap"]),
                        "line-join": new Er(on.layout_line["line-join"]),
                        "line-miter-limit": new At(on.layout_line["line-miter-limit"]),
                        "line-round-limit": new At(on.layout_line["line-round-limit"]),
                        "line-sort-key": new Er(on.layout_line["line-sort-key"])
                    }), _S = new Oi({
                        "line-opacity": new Er(on.paint_line["line-opacity"]),
                        "line-color": new Er(on.paint_line["line-color"]),
                        "line-translate": new At(on.paint_line["line-translate"]),
                        "line-translate-anchor": new At(on.paint_line["line-translate-anchor"]),
                        "line-width": new Er(on.paint_line["line-width"]),
                        "line-gap-width": new Er(on.paint_line["line-gap-width"]),
                        "line-offset": new Er(on.paint_line["line-offset"]),
                        "line-blur": new Er(on.paint_line["line-blur"]),
                        "line-dasharray": new wi(on.paint_line["line-dasharray"]),
                        "line-pattern": new Wr(on.paint_line["line-pattern"]),
                        "line-gradient": new Ui(on.paint_line["line-gradient"])
                    }), Nw = {
                        paint: _S,
                        layout: yS
                    }, $9 = function(m) {
                        function y() {
                            m.apply(this, arguments);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.possiblyEvaluate = function(U, J) {
                            return J = new pn(Math.floor(J.zoom), {
                                now: J.now,
                                fadeDuration: J.fadeDuration,
                                zoomHistory: J.zoomHistory,
                                transition: J.transition
                            }), m.prototype.possiblyEvaluate.call(this, U, J);
                        }, y.prototype.evaluate = function(U, J, ne, fe) {
                            return J = _({}, J, {
                                zoom: Math.floor(J.zoom)
                            }), m.prototype.evaluate.call(this, U, J, ne, fe);
                        }, y;
                    }(Er), R = new $9(Nw.paint.properties["line-width"].specification);
                    R.useIntegerZoom = !0;
                    var S = function(m) {
                        function y(I) {
                            m.call(this, I, Nw), this.gradientVersion = 0;
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype._handleSpecialPaintPropertyUpdate = function(U) {
                            if (U === "line-gradient") {
                                var J = this._transitionablePaint._values["line-gradient"].value.expression;
                                this.stepInterpolant = J._styleExpression.expression instanceof yu, this.gradientVersion = (this.gradientVersion + 1) % d;
                            }
                        }, y.prototype.gradientExpression = function() {
                            return this._transitionablePaint._values["line-gradient"].value.expression;
                        }, y.prototype.recalculate = function(U, J) {
                            m.prototype.recalculate.call(this, U, J), this.paint._values["line-floorwidth"] = R.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, U);
                        }, y.prototype.createBucket = function(U) {
                            return new Gf(U);
                        }, y.prototype.queryRadius = function(U) {
                            var J = U, ne = D(xd("line-width", this, J), xd("line-gap-width", this, J)), fe = xd("line-offset", this, J);
                            return ne / 2 + Math.abs(fe) + kv(this.paint.get("line-translate"));
                        }, y.prototype.queryIntersectsFeature = function(U, J, ne, fe, Fe, Qe, st) {
                            var mt = Kv(U, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), Qe.angle, st), Xt = st / 2 * D(this.paint.get("line-width").evaluate(J, ne), this.paint.get("line-gap-width").evaluate(J, ne)), ur = this.paint.get("line-offset").evaluate(J, ne);
                            return ur && (fe = j(fe, ur * st)), zu(mt, fe, Xt);
                        }, y.prototype.isTileClipped = function() {
                            return !0;
                        }, y;
                    }(cn);
                    function D(m, y) {
                        return y > 0 ? y + 2 * m : m;
                    }
                    function j(m, y) {
                        for(var I = [], U = new u(0, 0), J = 0; J < m.length; J++){
                            for(var ne = m[J], fe = [], Fe = 0; Fe < ne.length; Fe++){
                                var Qe = ne[Fe - 1], st = ne[Fe], mt = ne[Fe + 1], Xt = Fe === 0 ? U : st.sub(Qe)._unit()._perp(), ur = Fe === ne.length - 1 ? U : mt.sub(st)._unit()._perp(), nr = Xt._add(ur)._unit(), Lr = nr.x * ur.x + nr.y * ur.y;
                                nr._mult(1 / Lr), fe.push(nr._mult(y)._add(st));
                            }
                            I.push(fe);
                        }
                        return I;
                    }
                    var te = Dn([
                        {
                            name: "a_pos_offset",
                            components: 4,
                            type: "Int16"
                        },
                        {
                            name: "a_data",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixeloffset",
                            components: 4,
                            type: "Int16"
                        }
                    ], 4), ue = Dn([
                        {
                            name: "a_projected_pos",
                            components: 3,
                            type: "Float32"
                        }
                    ], 4), ve = Dn([
                        {
                            name: "a_fade_opacity",
                            components: 1,
                            type: "Uint32"
                        }
                    ], 4), De = Dn([
                        {
                            name: "a_placed",
                            components: 2,
                            type: "Uint8"
                        },
                        {
                            name: "a_shift",
                            components: 2,
                            type: "Float32"
                        }
                    ]), Ze = Dn([
                        {
                            type: "Int16",
                            name: "anchorPointX"
                        },
                        {
                            type: "Int16",
                            name: "anchorPointY"
                        },
                        {
                            type: "Int16",
                            name: "x1"
                        },
                        {
                            type: "Int16",
                            name: "y1"
                        },
                        {
                            type: "Int16",
                            name: "x2"
                        },
                        {
                            type: "Int16",
                            name: "y2"
                        },
                        {
                            type: "Uint32",
                            name: "featureIndex"
                        },
                        {
                            type: "Uint16",
                            name: "sourceLayerIndex"
                        },
                        {
                            type: "Uint16",
                            name: "bucketIndex"
                        }
                    ]), at = Dn([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_anchor_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_extrude",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), Tt = Dn([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Float32"
                        },
                        {
                            name: "a_radius",
                            components: 1,
                            type: "Float32"
                        },
                        {
                            name: "a_flags",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), Ft = Dn([
                        {
                            name: "triangle",
                            components: 3,
                            type: "Uint16"
                        }
                    ]), Qt = Dn([
                        {
                            type: "Int16",
                            name: "anchorX"
                        },
                        {
                            type: "Int16",
                            name: "anchorY"
                        },
                        {
                            type: "Uint16",
                            name: "glyphStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "numGlyphs"
                        },
                        {
                            type: "Uint32",
                            name: "vertexStartIndex"
                        },
                        {
                            type: "Uint32",
                            name: "lineStartIndex"
                        },
                        {
                            type: "Uint32",
                            name: "lineLength"
                        },
                        {
                            type: "Uint16",
                            name: "segment"
                        },
                        {
                            type: "Uint16",
                            name: "lowerSize"
                        },
                        {
                            type: "Uint16",
                            name: "upperSize"
                        },
                        {
                            type: "Float32",
                            name: "lineOffsetX"
                        },
                        {
                            type: "Float32",
                            name: "lineOffsetY"
                        },
                        {
                            type: "Uint8",
                            name: "writingMode"
                        },
                        {
                            type: "Uint8",
                            name: "placedOrientation"
                        },
                        {
                            type: "Uint8",
                            name: "hidden"
                        },
                        {
                            type: "Uint32",
                            name: "crossTileID"
                        },
                        {
                            type: "Int16",
                            name: "associatedIconIndex"
                        }
                    ]), sr = Dn([
                        {
                            type: "Int16",
                            name: "anchorX"
                        },
                        {
                            type: "Int16",
                            name: "anchorY"
                        },
                        {
                            type: "Int16",
                            name: "rightJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "centerJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "leftJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "verticalPlacedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "placedIconSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "verticalPlacedIconSymbolIndex"
                        },
                        {
                            type: "Uint16",
                            name: "key"
                        },
                        {
                            type: "Uint16",
                            name: "textBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "textBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalTextBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalTextBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "iconBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "iconBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalIconBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalIconBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "featureIndex"
                        },
                        {
                            type: "Uint16",
                            name: "numHorizontalGlyphVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numVerticalGlyphVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numIconVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numVerticalIconVertices"
                        },
                        {
                            type: "Uint16",
                            name: "useRuntimeCollisionCircles"
                        },
                        {
                            type: "Uint32",
                            name: "crossTileID"
                        },
                        {
                            type: "Float32",
                            name: "textBoxScale"
                        },
                        {
                            type: "Float32",
                            components: 2,
                            name: "textOffset"
                        },
                        {
                            type: "Float32",
                            name: "collisionCircleDiameter"
                        }
                    ]), Tr = Dn([
                        {
                            type: "Float32",
                            name: "offsetX"
                        }
                    ]), Pr = Dn([
                        {
                            type: "Int16",
                            name: "x"
                        },
                        {
                            type: "Int16",
                            name: "y"
                        },
                        {
                            type: "Int16",
                            name: "tileUnitDistanceFromAnchor"
                        }
                    ]);
                    function $r(m, y, I) {
                        var U = y.layout.get("text-transform").evaluate(I, {});
                        return U === "uppercase" ? m = m.toLocaleUpperCase() : U === "lowercase" && (m = m.toLocaleLowerCase()), _s.applyArabicShaping && (m = _s.applyArabicShaping(m)), m;
                    }
                    function ni(m, y, I) {
                        return m.sections.forEach(function(U) {
                            U.text = $r(U.text, y, I);
                        }), m;
                    }
                    function Di(m) {
                        var y = {}, I = {}, U = [], J = 0;
                        function ne(si) {
                            U.push(m[si]), J++;
                        }
                        function fe(si, Hi, Ei) {
                            var Vi = I[si];
                            return delete I[si], I[Hi] = Vi, U[Vi].geometry[0].pop(), U[Vi].geometry[0] = U[Vi].geometry[0].concat(Ei[0]), Vi;
                        }
                        function Fe(si, Hi, Ei) {
                            var Vi = y[Hi];
                            return delete y[Hi], y[si] = Vi, U[Vi].geometry[0].shift(), U[Vi].geometry[0] = Ei[0].concat(U[Vi].geometry[0]), Vi;
                        }
                        function Qe(si, Hi, Ei) {
                            var Vi = Ei ? Hi[0][Hi[0].length - 1] : Hi[0][0];
                            return si + ":" + Vi.x + ":" + Vi.y;
                        }
                        for(var st = 0; st < m.length; st++){
                            var mt = m[st], Xt = mt.geometry, ur = mt.text ? mt.text.toString() : null;
                            if (!ur) {
                                ne(st);
                                continue;
                            }
                            var nr = Qe(ur, Xt), Lr = Qe(ur, Xt, !0);
                            if (nr in I && Lr in y && I[nr] !== y[Lr]) {
                                var Yr = Fe(nr, Lr, Xt), _i = fe(nr, Lr, U[Yr].geometry);
                                delete y[nr], delete I[Lr], I[Qe(ur, U[_i].geometry, !0)] = _i, U[Yr].geometry = null;
                            } else nr in I ? fe(nr, Lr, Xt) : Lr in y ? Fe(nr, Lr, Xt) : (ne(st), y[nr] = J - 1, I[Lr] = J - 1);
                        }
                        return U.filter(function(si) {
                            return si.geometry;
                        });
                    }
                    var pi = {
                        "!": "\uFE15",
                        "#": "\uFF03",
                        $: "\uFF04",
                        "%": "\uFF05",
                        "&": "\uFF06",
                        "(": "\uFE35",
                        ")": "\uFE36",
                        "*": "\uFF0A",
                        "+": "\uFF0B",
                        ",": "\uFE10",
                        "-": "\uFE32",
                        ".": "\u30FB",
                        "/": "\uFF0F",
                        ":": "\uFE13",
                        ";": "\uFE14",
                        "<": "\uFE3F",
                        "=": "\uFF1D",
                        ">": "\uFE40",
                        "?": "\uFE16",
                        "@": "\uFF20",
                        "[": "\uFE47",
                        "\\": "\uFF3C",
                        "]": "\uFE48",
                        "^": "\uFF3E",
                        _: "\uFE33",
                        "`": "\uFF40",
                        "{": "\uFE37",
                        "|": "\u2015",
                        "}": "\uFE38",
                        "~": "\uFF5E",
                        "\xA2": "\uFFE0",
                        "\xA3": "\uFFE1",
                        "\xA5": "\uFFE5",
                        "\xA6": "\uFFE4",
                        "\xAC": "\uFFE2",
                        "\xAF": "\uFFE3",
                        "\u2013": "\uFE32",
                        "\u2014": "\uFE31",
                        "\u2018": "\uFE43",
                        "\u2019": "\uFE44",
                        "\u201C": "\uFE41",
                        "\u201D": "\uFE42",
                        "\u2026": "\uFE19",
                        "\u2027": "\u30FB",
                        "\u20A9": "\uFFE6",
                        "\u3001": "\uFE11",
                        "\u3002": "\uFE12",
                        "\u3008": "\uFE3F",
                        "\u3009": "\uFE40",
                        "\u300A": "\uFE3D",
                        "\u300B": "\uFE3E",
                        "\u300C": "\uFE41",
                        "\u300D": "\uFE42",
                        "\u300E": "\uFE43",
                        "\u300F": "\uFE44",
                        "\u3010": "\uFE3B",
                        "\u3011": "\uFE3C",
                        "\u3014": "\uFE39",
                        "\u3015": "\uFE3A",
                        "\u3016": "\uFE17",
                        "\u3017": "\uFE18",
                        "\uFF01": "\uFE15",
                        "\uFF08": "\uFE35",
                        "\uFF09": "\uFE36",
                        "\uFF0C": "\uFE10",
                        "\uFF0D": "\uFE32",
                        "\uFF0E": "\u30FB",
                        "\uFF1A": "\uFE13",
                        "\uFF1B": "\uFE14",
                        "\uFF1C": "\uFE3F",
                        "\uFF1E": "\uFE40",
                        "\uFF1F": "\uFE16",
                        "\uFF3B": "\uFE47",
                        "\uFF3D": "\uFE48",
                        "\uFF3F": "\uFE33",
                        "\uFF5B": "\uFE37",
                        "\uFF5C": "\u2015",
                        "\uFF5D": "\uFE38",
                        "\uFF5F": "\uFE35",
                        "\uFF60": "\uFE36",
                        "\uFF61": "\uFE12",
                        "\uFF62": "\uFE41",
                        "\uFF63": "\uFE42"
                    };
                    function ki(m) {
                        for(var y = "", I = 0; I < m.length; I++){
                            var U = m.charCodeAt(I + 1) || null, J = m.charCodeAt(I - 1) || null, ne = (!U || !ui(U) || pi[m[I + 1]]) && (!J || !ui(J) || pi[m[I - 1]]);
                            ne && pi[m[I]] ? y += pi[m[I]] : y += m[I];
                        }
                        return y;
                    }
                    var Zi = 24, ta = function(m, y, I, U, J) {
                        var ne, fe, Fe = J * 8 - U - 1, Qe = (1 << Fe) - 1, st = Qe >> 1, mt = -7, Xt = I ? J - 1 : 0, ur = I ? -1 : 1, nr = m[y + Xt];
                        for(Xt += ur, ne = nr & (1 << -mt) - 1, nr >>= -mt, mt += Fe; mt > 0; ne = ne * 256 + m[y + Xt], Xt += ur, mt -= 8);
                        for(fe = ne & (1 << -mt) - 1, ne >>= -mt, mt += U; mt > 0; fe = fe * 256 + m[y + Xt], Xt += ur, mt -= 8);
                        if (ne === 0) ne = 1 - st;
                        else {
                            if (ne === Qe) return fe ? NaN : (nr ? -1 : 1) * (1 / 0);
                            fe = fe + Math.pow(2, U), ne = ne - st;
                        }
                        return (nr ? -1 : 1) * fe * Math.pow(2, ne - U);
                    }, Va = function(m, y, I, U, J, ne) {
                        var fe, Fe, Qe, st = ne * 8 - J - 1, mt = (1 << st) - 1, Xt = mt >> 1, ur = J === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, nr = U ? 0 : ne - 1, Lr = U ? 1 : -1, Yr = y < 0 || y === 0 && 1 / y < 0 ? 1 : 0;
                        for(y = Math.abs(y), isNaN(y) || y === 1 / 0 ? (Fe = isNaN(y) ? 1 : 0, fe = mt) : (fe = Math.floor(Math.log(y) / Math.LN2), y * (Qe = Math.pow(2, -fe)) < 1 && (fe--, Qe *= 2), fe + Xt >= 1 ? y += ur / Qe : y += ur * Math.pow(2, 1 - Xt), y * Qe >= 2 && (fe++, Qe /= 2), fe + Xt >= mt ? (Fe = 0, fe = mt) : fe + Xt >= 1 ? (Fe = (y * Qe - 1) * Math.pow(2, J), fe = fe + Xt) : (Fe = y * Math.pow(2, Xt - 1) * Math.pow(2, J), fe = 0)); J >= 8; m[I + nr] = Fe & 255, nr += Lr, Fe /= 256, J -= 8);
                        for(fe = fe << J | Fe, st += J; st > 0; m[I + nr] = fe & 255, nr += Lr, fe /= 256, st -= 8);
                        m[I + nr - Lr] |= Yr * 128;
                    }, Io = {
                        read: ta,
                        write: Va
                    }, La = Hn;
                    function Hn(m) {
                        this.buf = ArrayBuffer.isView && ArrayBuffer.isView(m) ? m : new Uint8Array(m || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
                    }
                    Hn.Varint = 0, Hn.Fixed64 = 1, Hn.Bytes = 2, Hn.Fixed32 = 5;
                    var lo = 4294967296, $a = 1 / lo, Xa = 12, Tn = typeof TextDecoder == "undefined" ? null : new TextDecoder("utf8");
                    Hn.prototype = {
                        destroy: function() {
                            this.buf = null;
                        },
                        readFields: function(m, y, I) {
                            for(I = I || this.length; this.pos < I;){
                                var U = this.readVarint(), J = U >> 3, ne = this.pos;
                                this.type = U & 7, m(J, y, this), this.pos === ne && this.skip(U);
                            }
                            return y;
                        },
                        readMessage: function(m, y) {
                            return this.readFields(m, y, this.readVarint() + this.pos);
                        },
                        readFixed32: function() {
                            var m = Dh(this.buf, this.pos);
                            return this.pos += 4, m;
                        },
                        readSFixed32: function() {
                            var m = Iv(this.buf, this.pos);
                            return this.pos += 4, m;
                        },
                        readFixed64: function() {
                            var m = Dh(this.buf, this.pos) + Dh(this.buf, this.pos + 4) * lo;
                            return this.pos += 8, m;
                        },
                        readSFixed64: function() {
                            var m = Dh(this.buf, this.pos) + Iv(this.buf, this.pos + 4) * lo;
                            return this.pos += 8, m;
                        },
                        readFloat: function() {
                            var m = Io.read(this.buf, this.pos, !0, 23, 4);
                            return this.pos += 4, m;
                        },
                        readDouble: function() {
                            var m = Io.read(this.buf, this.pos, !0, 52, 8);
                            return this.pos += 8, m;
                        },
                        readVarint: function(m) {
                            var y = this.buf, I, U;
                            return U = y[this.pos++], I = U & 127, U < 128 || (U = y[this.pos++], I |= (U & 127) << 7, U < 128) || (U = y[this.pos++], I |= (U & 127) << 14, U < 128) || (U = y[this.pos++], I |= (U & 127) << 21, U < 128) ? I : (U = y[this.pos], I |= (U & 15) << 28, bo(I, m, this));
                        },
                        readVarint64: function() {
                            return this.readVarint(!0);
                        },
                        readSVarint: function() {
                            var m = this.readVarint();
                            return m % 2 === 1 ? (m + 1) / -2 : m / 2;
                        },
                        readBoolean: function() {
                            return !!this.readVarint();
                        },
                        readString: function() {
                            var m = this.readVarint() + this.pos, y = this.pos;
                            return this.pos = m, m - y >= Xa && Tn ? Cl(this.buf, y, m) : lv(this.buf, y, m);
                        },
                        readBytes: function() {
                            var m = this.readVarint() + this.pos, y = this.buf.subarray(this.pos, m);
                            return this.pos = m, y;
                        },
                        readPackedVarint: function(m, y) {
                            if (this.type !== Hn.Bytes) return m.push(this.readVarint(y));
                            var I = Ya(this);
                            for(m = m || []; this.pos < I;)m.push(this.readVarint(y));
                            return m;
                        },
                        readPackedSVarint: function(m) {
                            if (this.type !== Hn.Bytes) return m.push(this.readSVarint());
                            var y = Ya(this);
                            for(m = m || []; this.pos < y;)m.push(this.readSVarint());
                            return m;
                        },
                        readPackedBoolean: function(m) {
                            if (this.type !== Hn.Bytes) return m.push(this.readBoolean());
                            var y = Ya(this);
                            for(m = m || []; this.pos < y;)m.push(this.readBoolean());
                            return m;
                        },
                        readPackedFloat: function(m) {
                            if (this.type !== Hn.Bytes) return m.push(this.readFloat());
                            var y = Ya(this);
                            for(m = m || []; this.pos < y;)m.push(this.readFloat());
                            return m;
                        },
                        readPackedDouble: function(m) {
                            if (this.type !== Hn.Bytes) return m.push(this.readDouble());
                            var y = Ya(this);
                            for(m = m || []; this.pos < y;)m.push(this.readDouble());
                            return m;
                        },
                        readPackedFixed32: function(m) {
                            if (this.type !== Hn.Bytes) return m.push(this.readFixed32());
                            var y = Ya(this);
                            for(m = m || []; this.pos < y;)m.push(this.readFixed32());
                            return m;
                        },
                        readPackedSFixed32: function(m) {
                            if (this.type !== Hn.Bytes) return m.push(this.readSFixed32());
                            var y = Ya(this);
                            for(m = m || []; this.pos < y;)m.push(this.readSFixed32());
                            return m;
                        },
                        readPackedFixed64: function(m) {
                            if (this.type !== Hn.Bytes) return m.push(this.readFixed64());
                            var y = Ya(this);
                            for(m = m || []; this.pos < y;)m.push(this.readFixed64());
                            return m;
                        },
                        readPackedSFixed64: function(m) {
                            if (this.type !== Hn.Bytes) return m.push(this.readSFixed64());
                            var y = Ya(this);
                            for(m = m || []; this.pos < y;)m.push(this.readSFixed64());
                            return m;
                        },
                        skip: function(m) {
                            var y = m & 7;
                            if (y === Hn.Varint) for(; this.buf[this.pos++] > 127;);
                            else if (y === Hn.Bytes) this.pos = this.readVarint() + this.pos;
                            else if (y === Hn.Fixed32) this.pos += 4;
                            else if (y === Hn.Fixed64) this.pos += 8;
                            else throw new Error("Unimplemented type: " + y);
                        },
                        writeTag: function(m, y) {
                            this.writeVarint(m << 3 | y);
                        },
                        realloc: function(m) {
                            for(var y = this.length || 16; y < this.pos + m;)y *= 2;
                            if (y !== this.length) {
                                var I = new Uint8Array(y);
                                I.set(this.buf), this.buf = I, this.length = y;
                            }
                        },
                        finish: function() {
                            return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                        },
                        writeFixed32: function(m) {
                            this.realloc(4), xf(this.buf, m, this.pos), this.pos += 4;
                        },
                        writeSFixed32: function(m) {
                            this.realloc(4), xf(this.buf, m, this.pos), this.pos += 4;
                        },
                        writeFixed64: function(m) {
                            this.realloc(8), xf(this.buf, m & -1, this.pos), xf(this.buf, Math.floor(m * $a), this.pos + 4), this.pos += 8;
                        },
                        writeSFixed64: function(m) {
                            this.realloc(8), xf(this.buf, m & -1, this.pos), xf(this.buf, Math.floor(m * $a), this.pos + 4), this.pos += 8;
                        },
                        writeVarint: function(m) {
                            if (m = +m || 0, m > 268435455 || m < 0) {
                                wu(m, this);
                                return;
                            }
                            this.realloc(4), this.buf[this.pos++] = m & 127 | (m > 127 ? 128 : 0), !(m <= 127) && (this.buf[this.pos++] = (m >>>= 7) & 127 | (m > 127 ? 128 : 0), !(m <= 127) && (this.buf[this.pos++] = (m >>>= 7) & 127 | (m > 127 ? 128 : 0), !(m <= 127) && (this.buf[this.pos++] = m >>> 7 & 127)));
                        },
                        writeSVarint: function(m) {
                            this.writeVarint(m < 0 ? -m * 2 - 1 : m * 2);
                        },
                        writeBoolean: function(m) {
                            this.writeVarint(!!m);
                        },
                        writeString: function(m) {
                            m = String(m), this.realloc(m.length * 4), this.pos++;
                            var y = this.pos;
                            this.pos = qu(this.buf, m, this.pos);
                            var I = this.pos - y;
                            I >= 128 && $v(y, I, this), this.pos = y - 1, this.writeVarint(I), this.pos += I;
                        },
                        writeFloat: function(m) {
                            this.realloc(4), Io.write(this.buf, m, this.pos, !0, 23, 4), this.pos += 4;
                        },
                        writeDouble: function(m) {
                            this.realloc(8), Io.write(this.buf, m, this.pos, !0, 52, 8), this.pos += 8;
                        },
                        writeBytes: function(m) {
                            var y = m.length;
                            this.writeVarint(y), this.realloc(y);
                            for(var I = 0; I < y; I++)this.buf[this.pos++] = m[I];
                        },
                        writeRawMessage: function(m, y) {
                            this.pos++;
                            var I = this.pos;
                            m(y, this);
                            var U = this.pos - I;
                            U >= 128 && $v(I, U, this), this.pos = I - 1, this.writeVarint(U), this.pos += U;
                        },
                        writeMessage: function(m, y, I) {
                            this.writeTag(m, Hn.Bytes), this.writeRawMessage(y, I);
                        },
                        writePackedVarint: function(m, y) {
                            y.length && this.writeMessage(m, td, y);
                        },
                        writePackedSVarint: function(m, y) {
                            y.length && this.writeMessage(m, ch, y);
                        },
                        writePackedBoolean: function(m, y) {
                            y.length && this.writeMessage(m, Hd, y);
                        },
                        writePackedFloat: function(m, y) {
                            y.length && this.writeMessage(m, Ud, y);
                        },
                        writePackedDouble: function(m, y) {
                            y.length && this.writeMessage(m, Vd, y);
                        },
                        writePackedFixed32: function(m, y) {
                            y.length && this.writeMessage(m, rf, y);
                        },
                        writePackedSFixed32: function(m, y) {
                            y.length && this.writeMessage(m, fh, y);
                        },
                        writePackedFixed64: function(m, y) {
                            y.length && this.writeMessage(m, Td, y);
                        },
                        writePackedSFixed64: function(m, y) {
                            y.length && this.writeMessage(m, rd, y);
                        },
                        writeBytesField: function(m, y) {
                            this.writeTag(m, Hn.Bytes), this.writeBytes(y);
                        },
                        writeFixed32Field: function(m, y) {
                            this.writeTag(m, Hn.Fixed32), this.writeFixed32(y);
                        },
                        writeSFixed32Field: function(m, y) {
                            this.writeTag(m, Hn.Fixed32), this.writeSFixed32(y);
                        },
                        writeFixed64Field: function(m, y) {
                            this.writeTag(m, Hn.Fixed64), this.writeFixed64(y);
                        },
                        writeSFixed64Field: function(m, y) {
                            this.writeTag(m, Hn.Fixed64), this.writeSFixed64(y);
                        },
                        writeVarintField: function(m, y) {
                            this.writeTag(m, Hn.Varint), this.writeVarint(y);
                        },
                        writeSVarintField: function(m, y) {
                            this.writeTag(m, Hn.Varint), this.writeSVarint(y);
                        },
                        writeStringField: function(m, y) {
                            this.writeTag(m, Hn.Bytes), this.writeString(y);
                        },
                        writeFloatField: function(m, y) {
                            this.writeTag(m, Hn.Fixed32), this.writeFloat(y);
                        },
                        writeDoubleField: function(m, y) {
                            this.writeTag(m, Hn.Fixed64), this.writeDouble(y);
                        },
                        writeBooleanField: function(m, y) {
                            this.writeVarintField(m, !!y);
                        }
                    };
                    function bo(m, y, I) {
                        var U = I.buf, J, ne;
                        if (ne = U[I.pos++], J = (ne & 112) >> 4, ne < 128 || (ne = U[I.pos++], J |= (ne & 127) << 3, ne < 128) || (ne = U[I.pos++], J |= (ne & 127) << 10, ne < 128) || (ne = U[I.pos++], J |= (ne & 127) << 17, ne < 128) || (ne = U[I.pos++], J |= (ne & 127) << 24, ne < 128) || (ne = U[I.pos++], J |= (ne & 1) << 31, ne < 128)) return Uo(m, J, y);
                        throw new Error("Expected varint not more than 10 bytes");
                    }
                    function Ya(m) {
                        return m.type === Hn.Bytes ? m.readVarint() + m.pos : m.pos + 1;
                    }
                    function Uo(m, y, I) {
                        return I ? y * 4294967296 + (m >>> 0) : (y >>> 0) * 4294967296 + (m >>> 0);
                    }
                    function wu(m, y) {
                        var I, U;
                        if (m >= 0 ? (I = m % 4294967296 | 0, U = m / 4294967296 | 0) : (I = ~(-m % 4294967296), U = ~(-m / 4294967296), I ^ 4294967295 ? I = I + 1 | 0 : (I = 0, U = U + 1 | 0)), m >= 18446744073709552e3 || m < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                        y.realloc(10), hu(I, U, y), uh(U, y);
                    }
                    function hu(m, y, I) {
                        I.buf[I.pos++] = m & 127 | 128, m >>>= 7, I.buf[I.pos++] = m & 127 | 128, m >>>= 7, I.buf[I.pos++] = m & 127 | 128, m >>>= 7, I.buf[I.pos++] = m & 127 | 128, m >>>= 7, I.buf[I.pos] = m & 127;
                    }
                    function uh(m, y) {
                        var I = (m & 7) << 4;
                        y.buf[y.pos++] |= I | ((m >>>= 3) ? 128 : 0), m && (y.buf[y.pos++] = m & 127 | ((m >>>= 7) ? 128 : 0), m && (y.buf[y.pos++] = m & 127 | ((m >>>= 7) ? 128 : 0), m && (y.buf[y.pos++] = m & 127 | ((m >>>= 7) ? 128 : 0), m && (y.buf[y.pos++] = m & 127 | ((m >>>= 7) ? 128 : 0), m && (y.buf[y.pos++] = m & 127)))));
                    }
                    function $v(m, y, I) {
                        var U = y <= 16383 ? 1 : y <= 2097151 ? 2 : y <= 268435455 ? 3 : Math.floor(Math.log(y) / (Math.LN2 * 7));
                        I.realloc(U);
                        for(var J = I.pos - 1; J >= m; J--)I.buf[J + U] = I.buf[J];
                    }
                    function td(m, y) {
                        for(var I = 0; I < m.length; I++)y.writeVarint(m[I]);
                    }
                    function ch(m, y) {
                        for(var I = 0; I < m.length; I++)y.writeSVarint(m[I]);
                    }
                    function Ud(m, y) {
                        for(var I = 0; I < m.length; I++)y.writeFloat(m[I]);
                    }
                    function Vd(m, y) {
                        for(var I = 0; I < m.length; I++)y.writeDouble(m[I]);
                    }
                    function Hd(m, y) {
                        for(var I = 0; I < m.length; I++)y.writeBoolean(m[I]);
                    }
                    function rf(m, y) {
                        for(var I = 0; I < m.length; I++)y.writeFixed32(m[I]);
                    }
                    function fh(m, y) {
                        for(var I = 0; I < m.length; I++)y.writeSFixed32(m[I]);
                    }
                    function Td(m, y) {
                        for(var I = 0; I < m.length; I++)y.writeFixed64(m[I]);
                    }
                    function rd(m, y) {
                        for(var I = 0; I < m.length; I++)y.writeSFixed64(m[I]);
                    }
                    function Dh(m, y) {
                        return (m[y] | m[y + 1] << 8 | m[y + 2] << 16) + m[y + 3] * 16777216;
                    }
                    function xf(m, y, I) {
                        m[I] = y, m[I + 1] = y >>> 8, m[I + 2] = y >>> 16, m[I + 3] = y >>> 24;
                    }
                    function Iv(m, y) {
                        return (m[y] | m[y + 1] << 8 | m[y + 2] << 16) + (m[y + 3] << 24);
                    }
                    function lv(m, y, I) {
                        for(var U = "", J = y; J < I;){
                            var ne = m[J], fe = null, Fe = ne > 239 ? 4 : ne > 223 ? 3 : ne > 191 ? 2 : 1;
                            if (J + Fe > I) break;
                            var Qe, st, mt;
                            Fe === 1 ? ne < 128 && (fe = ne) : Fe === 2 ? (Qe = m[J + 1], (Qe & 192) === 128 && (fe = (ne & 31) << 6 | Qe & 63, fe <= 127 && (fe = null))) : Fe === 3 ? (Qe = m[J + 1], st = m[J + 2], (Qe & 192) === 128 && (st & 192) === 128 && (fe = (ne & 15) << 12 | (Qe & 63) << 6 | st & 63, (fe <= 2047 || fe >= 55296 && fe <= 57343) && (fe = null))) : Fe === 4 && (Qe = m[J + 1], st = m[J + 2], mt = m[J + 3], (Qe & 192) === 128 && (st & 192) === 128 && (mt & 192) === 128 && (fe = (ne & 15) << 18 | (Qe & 63) << 12 | (st & 63) << 6 | mt & 63, (fe <= 65535 || fe >= 1114112) && (fe = null))), fe === null ? (fe = 65533, Fe = 1) : fe > 65535 && (fe -= 65536, U += String.fromCharCode(fe >>> 10 & 1023 | 55296), fe = 56320 | fe & 1023), U += String.fromCharCode(fe), J += Fe;
                        }
                        return U;
                    }
                    function Cl(m, y, I) {
                        return Tn.decode(m.subarray(y, I));
                    }
                    function qu(m, y, I) {
                        for(var U = 0, J, ne; U < y.length; U++){
                            if (J = y.charCodeAt(U), J > 55295 && J < 57344) {
                                if (ne) {
                                    if (J < 56320) {
                                        m[I++] = 239, m[I++] = 191, m[I++] = 189, ne = J;
                                        continue;
                                    } else J = ne - 55296 << 10 | J - 56320 | 65536, ne = null;
                                } else {
                                    J > 56319 || U + 1 === y.length ? (m[I++] = 239, m[I++] = 191, m[I++] = 189) : ne = J;
                                    continue;
                                }
                            } else ne && (m[I++] = 239, m[I++] = 191, m[I++] = 189, ne = null);
                            J < 128 ? m[I++] = J : (J < 2048 ? m[I++] = J >> 6 | 192 : (J < 65536 ? m[I++] = J >> 12 | 224 : (m[I++] = J >> 18 | 240, m[I++] = J >> 12 & 63 | 128), m[I++] = J >> 6 & 63 | 128), m[I++] = J & 63 | 128);
                        }
                        return I;
                    }
                    var Tu = 3;
                    function Rv(m, y, I) {
                        m === 1 && I.readMessage(qc, y);
                    }
                    function qc(m, y, I) {
                        if (m === 3) {
                            var U = I.readMessage(I1, {}), J = U.id, ne = U.bitmap, fe = U.width, Fe = U.height, Qe = U.left, st = U.top, mt = U.advance;
                            y.push({
                                id: J,
                                bitmap: new Pv({
                                    width: fe + 2 * Tu,
                                    height: Fe + 2 * Tu
                                }, ne),
                                metrics: {
                                    width: fe,
                                    height: Fe,
                                    left: Qe,
                                    top: st,
                                    advance: mt
                                }
                            });
                        }
                    }
                    function I1(m, y, I) {
                        m === 1 ? y.id = I.readVarint() : m === 2 ? y.bitmap = I.readBytes() : m === 3 ? y.width = I.readVarint() : m === 4 ? y.height = I.readVarint() : m === 5 ? y.left = I.readSVarint() : m === 6 ? y.top = I.readSVarint() : m === 7 && (y.advance = I.readVarint());
                    }
                    function p0(m) {
                        return new La(m).readFields(Rv, []);
                    }
                    var Gp = Tu;
                    function Qv(m) {
                        for(var y = 0, I = 0, U = 0, J = m; U < J.length; U += 1){
                            var ne = J[U];
                            y += ne.w * ne.h, I = Math.max(I, ne.w);
                        }
                        m.sort(function(_i, si) {
                            return si.h - _i.h;
                        });
                        for(var fe = Math.max(Math.ceil(Math.sqrt(y / .95)), I), Fe = [
                            {
                                x: 0,
                                y: 0,
                                w: fe,
                                h: 1 / 0
                            }
                        ], Qe = 0, st = 0, mt = 0, Xt = m; mt < Xt.length; mt += 1)for(var ur = Xt[mt], nr = Fe.length - 1; nr >= 0; nr--){
                            var Lr = Fe[nr];
                            if (!(ur.w > Lr.w || ur.h > Lr.h)) {
                                if (ur.x = Lr.x, ur.y = Lr.y, st = Math.max(st, ur.y + ur.h), Qe = Math.max(Qe, ur.x + ur.w), ur.w === Lr.w && ur.h === Lr.h) {
                                    var Yr = Fe.pop();
                                    nr < Fe.length && (Fe[nr] = Yr);
                                } else ur.h === Lr.h ? (Lr.x += ur.w, Lr.w -= ur.w) : ur.w === Lr.w ? (Lr.y += ur.h, Lr.h -= ur.h) : (Fe.push({
                                    x: Lr.x + ur.w,
                                    y: Lr.y,
                                    w: Lr.w - ur.w,
                                    h: ur.h
                                }), Lr.y += ur.h, Lr.h -= ur.h);
                                break;
                            }
                        }
                        return {
                            w: Qe,
                            h: st,
                            fill: y / (Qe * st) || 0
                        };
                    }
                    var oc = 1, If = function(y, I) {
                        var U = I.pixelRatio, J = I.version, ne = I.stretchX, fe = I.stretchY, Fe = I.content;
                        this.paddedRect = y, this.pixelRatio = U, this.stretchX = ne, this.stretchY = fe, this.content = Fe, this.version = J;
                    }, ep = {
                        tl: {
                            configurable: !0
                        },
                        br: {
                            configurable: !0
                        },
                        tlbr: {
                            configurable: !0
                        },
                        displaySize: {
                            configurable: !0
                        }
                    };
                    ep.tl.get = function() {
                        return [
                            this.paddedRect.x + oc,
                            this.paddedRect.y + oc
                        ];
                    }, ep.br.get = function() {
                        return [
                            this.paddedRect.x + this.paddedRect.w - oc,
                            this.paddedRect.y + this.paddedRect.h - oc
                        ];
                    }, ep.tlbr.get = function() {
                        return this.tl.concat(this.br);
                    }, ep.displaySize.get = function() {
                        return [
                            (this.paddedRect.w - oc * 2) / this.pixelRatio,
                            (this.paddedRect.h - oc * 2) / this.pixelRatio
                        ];
                    }, Object.defineProperties(If.prototype, ep);
                    var gg = function(y, I) {
                        var U = {}, J = {};
                        this.haveRenderCallbacks = [];
                        var ne = [];
                        this.addImages(y, U, ne), this.addImages(I, J, ne);
                        var fe = Qv(ne), Fe = fe.w, Qe = fe.h, st = new lh({
                            width: Fe || 1,
                            height: Qe || 1
                        });
                        for(var mt in y){
                            var Xt = y[mt], ur = U[mt].paddedRect;
                            lh.copy(Xt.data, st, {
                                x: 0,
                                y: 0
                            }, {
                                x: ur.x + oc,
                                y: ur.y + oc
                            }, Xt.data);
                        }
                        for(var nr in I){
                            var Lr = I[nr], Yr = J[nr].paddedRect, _i = Yr.x + oc, si = Yr.y + oc, Hi = Lr.data.width, Ei = Lr.data.height;
                            lh.copy(Lr.data, st, {
                                x: 0,
                                y: 0
                            }, {
                                x: _i,
                                y: si
                            }, Lr.data), lh.copy(Lr.data, st, {
                                x: 0,
                                y: Ei - 1
                            }, {
                                x: _i,
                                y: si - 1
                            }, {
                                width: Hi,
                                height: 1
                            }), lh.copy(Lr.data, st, {
                                x: 0,
                                y: 0
                            }, {
                                x: _i,
                                y: si + Ei
                            }, {
                                width: Hi,
                                height: 1
                            }), lh.copy(Lr.data, st, {
                                x: Hi - 1,
                                y: 0
                            }, {
                                x: _i - 1,
                                y: si
                            }, {
                                width: 1,
                                height: Ei
                            }), lh.copy(Lr.data, st, {
                                x: 0,
                                y: 0
                            }, {
                                x: _i + Hi,
                                y: si
                            }, {
                                width: 1,
                                height: Ei
                            });
                        }
                        this.image = st, this.iconPositions = U, this.patternPositions = J;
                    };
                    gg.prototype.addImages = function(y, I, U) {
                        for(var J in y){
                            var ne = y[J], fe = {
                                x: 0,
                                y: 0,
                                w: ne.data.width + 2 * oc,
                                h: ne.data.height + 2 * oc
                            };
                            U.push(fe), I[J] = new If(fe, ne), ne.hasRenderCallback && this.haveRenderCallbacks.push(J);
                        }
                    }, gg.prototype.patchUpdatedImages = function(y, I) {
                        y.dispatchRenderCallbacks(this.haveRenderCallbacks);
                        for(var U in y.updatedImages)this.patchUpdatedImage(this.iconPositions[U], y.getImage(U), I), this.patchUpdatedImage(this.patternPositions[U], y.getImage(U), I);
                    }, gg.prototype.patchUpdatedImage = function(y, I, U) {
                        if (!(!y || !I) && y.version !== I.version) {
                            y.version = I.version;
                            var J = y.tl, ne = J[0], fe = J[1];
                            U.update(I.data, void 0, {
                                x: ne,
                                y: fe
                            });
                        }
                    }, Z("ImagePosition", If), Z("ImageAtlas", gg);
                    var uv = {
                        horizontal: 1,
                        vertical: 2,
                        horizontalOnly: 3
                    }, R1 = -17;
                    function xS(m) {
                        for(var y = 0, I = m; y < I.length; y += 1){
                            var U = I[y];
                            if (U.positionedGlyphs.length !== 0) return !1;
                        }
                        return !0;
                    }
                    var Uw = 57344, g0 = 63743, hy = function() {
                        this.scale = 1, this.fontStack = "", this.imageName = null;
                    };
                    hy.forText = function(y, I) {
                        var U = new hy;
                        return U.scale = y || 1, U.fontStack = I, U;
                    }, hy.forImage = function(y) {
                        var I = new hy;
                        return I.imageName = y, I;
                    };
                    var zh = function() {
                        this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
                    };
                    zh.fromFeature = function(y, I) {
                        for(var U = new zh, J = 0; J < y.sections.length; J++){
                            var ne = y.sections[J];
                            ne.image ? U.addImageSection(ne) : U.addTextSection(ne, I);
                        }
                        return U;
                    }, zh.prototype.length = function() {
                        return this.text.length;
                    }, zh.prototype.getSection = function(y) {
                        return this.sections[this.sectionIndex[y]];
                    }, zh.prototype.getSectionIndex = function(y) {
                        return this.sectionIndex[y];
                    }, zh.prototype.getCharCode = function(y) {
                        return this.text.charCodeAt(y);
                    }, zh.prototype.verticalizePunctuation = function() {
                        this.text = ki(this.text);
                    }, zh.prototype.trim = function() {
                        for(var y = 0, I = 0; I < this.text.length && m0[this.text.charCodeAt(I)]; I++)y++;
                        for(var U = this.text.length, J = this.text.length - 1; J >= 0 && J >= y && m0[this.text.charCodeAt(J)]; J--)U--;
                        this.text = this.text.substring(y, U), this.sectionIndex = this.sectionIndex.slice(y, U);
                    }, zh.prototype.substring = function(y, I) {
                        var U = new zh;
                        return U.text = this.text.substring(y, I), U.sectionIndex = this.sectionIndex.slice(y, I), U.sections = this.sections, U;
                    }, zh.prototype.toString = function() {
                        return this.text;
                    }, zh.prototype.getMaxScale = function() {
                        var y = this;
                        return this.sectionIndex.reduce(function(I, U) {
                            return Math.max(I, y.sections[U].scale);
                        }, 0);
                    }, zh.prototype.addTextSection = function(y, I) {
                        this.text += y.text, this.sections.push(hy.forText(y.scale, y.fontStack || I));
                        for(var U = this.sections.length - 1, J = 0; J < y.text.length; ++J)this.sectionIndex.push(U);
                    }, zh.prototype.addImageSection = function(y) {
                        var I = y.image ? y.image.name : "";
                        if (I.length === 0) {
                            re("Can't add FormattedSection with an empty image.");
                            return;
                        }
                        var U = this.getNextImageSectionCharCode();
                        if (!U) {
                            re("Reached maximum number of images " + (g0 - Uw + 2));
                            return;
                        }
                        this.text += String.fromCharCode(U), this.sections.push(hy.forImage(I)), this.sectionIndex.push(this.sections.length - 1);
                    }, zh.prototype.getNextImageSectionCharCode = function() {
                        return this.imageSectionID ? this.imageSectionID >= g0 ? null : ++this.imageSectionID : (this.imageSectionID = Uw, this.imageSectionID);
                    };
                    function Q9(m, y) {
                        for(var I = [], U = m.text, J = 0, ne = 0, fe = y; ne < fe.length; ne += 1){
                            var Fe = fe[ne];
                            I.push(m.substring(J, Fe)), J = Fe;
                        }
                        return J < U.length && I.push(m.substring(J, U.length)), I;
                    }
                    function Vw(m, y, I, U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr, Yr) {
                        var _i = zh.fromFeature(m, J);
                        Xt === uv.vertical && _i.verticalizePunctuation();
                        var si, Hi = _s.processBidirectionalText, Ei = _s.processStyledBidirectionalText;
                        if (Hi && _i.sections.length === 1) {
                            si = [];
                            for(var Vi = Hi(_i.toString(), Hw(_i, st, ne, y, U, nr, Lr)), en = 0, An = Vi; en < An.length; en += 1){
                                var ra = An[en], $n = new zh;
                                $n.text = ra, $n.sections = _i.sections;
                                for(var Ba = 0; Ba < ra.length; Ba++)$n.sectionIndex.push(0);
                                si.push($n);
                            }
                        } else if (Ei) {
                            si = [];
                            for(var _a = Ei(_i.text, _i.sectionIndex, Hw(_i, st, ne, y, U, nr, Lr)), Pa = 0, qo = _a; Pa < qo.length; Pa += 1){
                                var Na = qo[Pa], ja = new zh;
                                ja.text = Na[0], ja.sectionIndex = Na[1], ja.sections = _i.sections, si.push(ja);
                            }
                        } else si = Q9(_i, Hw(_i, st, ne, y, U, nr, Lr));
                        var us = [], zo = {
                            positionedLines: us,
                            text: _i.toString(),
                            top: mt[1],
                            bottom: mt[1],
                            left: mt[0],
                            right: mt[0],
                            writingMode: Xt,
                            iconsInText: !1,
                            verticalizable: !1
                        };
                        return rq(zo, y, I, U, si, fe, Fe, Qe, Xt, st, ur, Yr), xS(us) ? !1 : zo;
                    }
                    var m0 = {};
                    m0[9] = !0, m0[10] = !0, m0[11] = !0, m0[12] = !0, m0[13] = !0, m0[32] = !0;
                    var cv = {};
                    cv[10] = !0, cv[32] = !0, cv[38] = !0, cv[40] = !0, cv[41] = !0, cv[43] = !0, cv[45] = !0, cv[47] = !0, cv[173] = !0, cv[183] = !0, cv[8203] = !0, cv[8208] = !0, cv[8211] = !0, cv[8231] = !0;
                    function UC(m, y, I, U, J, ne) {
                        if (y.imageName) {
                            var Qe = U[y.imageName];
                            return Qe ? Qe.displaySize[0] * y.scale * Zi / ne + J : 0;
                        } else {
                            var fe = I[y.fontStack], Fe = fe && fe[m];
                            return Fe ? Fe.metrics.advance * y.scale + J : 0;
                        }
                    }
                    function eq(m, y, I, U, J, ne) {
                        for(var fe = 0, Fe = 0; Fe < m.length(); Fe++){
                            var Qe = m.getSection(Fe);
                            fe += UC(m.getCharCode(Fe), Qe, U, J, y, ne);
                        }
                        var st = Math.max(1, Math.ceil(fe / I));
                        return fe / st;
                    }
                    function VC(m, y, I, U) {
                        var J = Math.pow(m - y, 2);
                        return U ? m < y ? J / 2 : J * 2 : J + Math.abs(I) * I;
                    }
                    function tq(m, y, I) {
                        var U = 0;
                        return m === 10 && (U -= 1e4), I && (U += 150), (m === 40 || m === 65288) && (U += 50), (y === 41 || y === 65289) && (U += 50), U;
                    }
                    function mp(m, y, I, U, J, ne) {
                        for(var fe = null, Fe = VC(y, I, J, ne), Qe = 0, st = U; Qe < st.length; Qe += 1){
                            var mt = st[Qe], Xt = y - mt.x, ur = VC(Xt, I, J, ne) + mt.badness;
                            ur <= Fe && (fe = mt, Fe = ur);
                        }
                        return {
                            index: m,
                            x: y,
                            priorBreak: fe,
                            badness: Fe
                        };
                    }
                    function rb(m) {
                        return m ? rb(m.priorBreak).concat(m.index) : [];
                    }
                    function Hw(m, y, I, U, J, ne, fe) {
                        if (ne !== "point") return [];
                        if (!m) return [];
                        for(var Fe = [], Qe = eq(m, y, I, U, J, fe), st = m.text.indexOf("\u200B") >= 0, mt = 0, Xt = 0; Xt < m.length(); Xt++){
                            var ur = m.getSection(Xt), nr = m.getCharCode(Xt);
                            if (m0[nr] || (mt += UC(nr, ur, U, J, y, fe)), Xt < m.length() - 1) {
                                var Lr = Dr(nr);
                                (cv[nr] || Lr || ur.imageName) && Fe.push(mp(Xt + 1, mt, Qe, Fe, tq(nr, m.getCharCode(Xt + 1), Lr && st), !1));
                            }
                        }
                        return rb(mp(m.length(), mt, Qe, Fe, 0, !0));
                    }
                    function bS(m) {
                        var y = .5, I = .5;
                        switch(m){
                            case "right":
                            case "top-right":
                            case "bottom-right":
                                y = 1;
                                break;
                            case "left":
                            case "top-left":
                            case "bottom-left":
                                y = 0;
                                break;
                        }
                        switch(m){
                            case "bottom":
                            case "bottom-right":
                            case "bottom-left":
                                I = 1;
                                break;
                            case "top":
                            case "top-right":
                            case "top-left":
                                I = 0;
                                break;
                        }
                        return {
                            horizontalAlign: y,
                            verticalAlign: I
                        };
                    }
                    function rq(m, y, I, U, J, ne, fe, Fe, Qe, st, mt, Xt) {
                        for(var ur = 0, nr = R1, Lr = 0, Yr = 0, _i = Fe === "right" ? 1 : Fe === "left" ? 0 : .5, si = 0, Hi = 0, Ei = J; Hi < Ei.length; Hi += 1){
                            var Vi = Ei[Hi];
                            Vi.trim();
                            var en = Vi.getMaxScale(), An = (en - 1) * Zi, ra = {
                                positionedGlyphs: [],
                                lineOffset: 0
                            };
                            m.positionedLines[si] = ra;
                            var $n = ra.positionedGlyphs, Ba = 0;
                            if (!Vi.length()) {
                                nr += ne, ++si;
                                continue;
                            }
                            for(var _a = 0; _a < Vi.length(); _a++){
                                var Pa = Vi.getSection(_a), qo = Vi.getSectionIndex(_a), Na = Vi.getCharCode(_a), ja = 0, us = null, zo = null, rl = null, su = Zi, il = !(Qe === uv.horizontal || !mt && !Ir(Na) || mt && (m0[Na] || qr(Na)));
                                if (Pa.imageName) {
                                    var nf = U[Pa.imageName];
                                    if (!nf) continue;
                                    rl = Pa.imageName, m.iconsInText = m.iconsInText || !0, zo = nf.paddedRect;
                                    var bf = nf.displaySize;
                                    Pa.scale = Pa.scale * Zi / Xt, us = {
                                        width: bf[0],
                                        height: bf[1],
                                        left: oc,
                                        top: -Gp,
                                        advance: il ? bf[1] : bf[0]
                                    };
                                    var qh = Zi - bf[1] * Pa.scale;
                                    ja = An + qh, su = us.advance;
                                    var Zf = il ? bf[0] * Pa.scale - Zi * en : bf[1] * Pa.scale - Zi * en;
                                    Zf > 0 && Zf > Ba && (Ba = Zf);
                                } else {
                                    var nl = I[Pa.fontStack], Ws = nl && nl[Na];
                                    if (Ws && Ws.rect) zo = Ws.rect, us = Ws.metrics;
                                    else {
                                        var Au = y[Pa.fontStack], Ou = Au && Au[Na];
                                        if (!Ou) continue;
                                        us = Ou.metrics;
                                    }
                                    ja = (en - Pa.scale) * Zi;
                                }
                                il ? (m.verticalizable = !0, $n.push({
                                    glyph: Na,
                                    imageName: rl,
                                    x: ur,
                                    y: nr + ja,
                                    vertical: il,
                                    scale: Pa.scale,
                                    fontStack: Pa.fontStack,
                                    sectionIndex: qo,
                                    metrics: us,
                                    rect: zo
                                }), ur += su * Pa.scale + st) : ($n.push({
                                    glyph: Na,
                                    imageName: rl,
                                    x: ur,
                                    y: nr + ja,
                                    vertical: il,
                                    scale: Pa.scale,
                                    fontStack: Pa.fontStack,
                                    sectionIndex: qo,
                                    metrics: us,
                                    rect: zo
                                }), ur += us.advance * Pa.scale + st);
                            }
                            if ($n.length !== 0) {
                                var jd = ur - st;
                                Lr = Math.max(jd, Lr), iq($n, 0, $n.length - 1, _i, Ba);
                            }
                            ur = 0;
                            var Wd = ne * en + Ba;
                            ra.lineOffset = Math.max(Ba, An), nr += Wd, Yr = Math.max(Wd, Yr), ++si;
                        }
                        var Oh = nr - R1, fv = bS(fe), hv = fv.horizontalAlign, hh = fv.verticalAlign;
                        Ad(m.positionedLines, _i, hv, hh, Lr, Yr, ne, Oh, J.length), m.top += -hh * Oh, m.bottom = m.top + Oh, m.left += -hv * Lr, m.right = m.left + Lr;
                    }
                    function iq(m, y, I, U, J) {
                        if (!(!U && !J)) for(var ne = m[I], fe = ne.metrics.advance * ne.scale, Fe = (m[I].x + fe) * U, Qe = y; Qe <= I; Qe++)m[Qe].x -= Fe, m[Qe].y += J;
                    }
                    function Ad(m, y, I, U, J, ne, fe, Fe, Qe) {
                        var st = (y - I) * J, mt = 0;
                        ne !== fe ? mt = -Fe * U - R1 : mt = (-U * Qe + .5) * fe;
                        for(var Xt = 0, ur = m; Xt < ur.length; Xt += 1)for(var nr = ur[Xt], Lr = 0, Yr = nr.positionedGlyphs; Lr < Yr.length; Lr += 1){
                            var _i = Yr[Lr];
                            _i.x += st, _i.y += mt;
                        }
                    }
                    function tp(m, y, I) {
                        var U = bS(I), J = U.horizontalAlign, ne = U.verticalAlign, fe = y[0], Fe = y[1], Qe = fe - m.displaySize[0] * J, st = Qe + m.displaySize[0], mt = Fe - m.displaySize[1] * ne, Xt = mt + m.displaySize[1];
                        return {
                            image: m,
                            top: mt,
                            bottom: Xt,
                            left: Qe,
                            right: st
                        };
                    }
                    function hm(m, y, I, U, J, ne) {
                        var fe = m.image, Fe;
                        if (fe.content) {
                            var Qe = fe.content, st = fe.pixelRatio || 1;
                            Fe = [
                                Qe[0] / st,
                                Qe[1] / st,
                                fe.displaySize[0] - Qe[2] / st,
                                fe.displaySize[1] - Qe[3] / st
                            ];
                        }
                        var mt = y.left * ne, Xt = y.right * ne, ur, nr, Lr, Yr;
                        I === "width" || I === "both" ? (Yr = J[0] + mt - U[3], nr = J[0] + Xt + U[1]) : (Yr = J[0] + (mt + Xt - fe.displaySize[0]) / 2, nr = Yr + fe.displaySize[0]);
                        var _i = y.top * ne, si = y.bottom * ne;
                        return I === "height" || I === "both" ? (ur = J[1] + _i - U[0], Lr = J[1] + si + U[2]) : (ur = J[1] + (_i + si - fe.displaySize[1]) / 2, Lr = ur + fe.displaySize[1]), {
                            image: fe,
                            top: ur,
                            right: nr,
                            bottom: Lr,
                            left: Yr,
                            collisionPadding: Fe
                        };
                    }
                    var Gd = function(m) {
                        function y(I, U, J, ne) {
                            m.call(this, I, U), this.angle = J, ne !== void 0 && (this.segment = ne);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.clone = function() {
                            return new y(this.x, this.y, this.angle, this.segment);
                        }, y;
                    }(u);
                    Z("Anchor", Gd);
                    var Sd = 128;
                    function yp(m, y) {
                        var I = y.expression;
                        if (I.kind === "constant") {
                            var U = I.evaluate(new pn(m + 1));
                            return {
                                kind: "constant",
                                layoutSize: U
                            };
                        } else {
                            if (I.kind === "source") return {
                                kind: "source"
                            };
                            for(var J = I.zoomStops, ne = I.interpolationType, fe = 0; fe < J.length && J[fe] <= m;)fe++;
                            fe = Math.max(0, fe - 1);
                            for(var Fe = fe; Fe < J.length && J[Fe] < m + 1;)Fe++;
                            Fe = Math.min(J.length - 1, Fe);
                            var Qe = J[fe], st = J[Fe];
                            if (I.kind === "composite") return {
                                kind: "composite",
                                minZoom: Qe,
                                maxZoom: st,
                                interpolationType: ne
                            };
                            var mt = I.evaluate(new pn(Qe)), Xt = I.evaluate(new pn(st));
                            return {
                                kind: "camera",
                                minZoom: Qe,
                                maxZoom: st,
                                minSize: mt,
                                maxSize: Xt,
                                interpolationType: ne
                            };
                        }
                    }
                    function _Q(m, y, I) {
                        var U = y.uSize, J = y.uSizeT, ne = I.lowerSize, fe = I.upperSize;
                        return m.kind === "source" ? ne / Sd : m.kind === "composite" ? Qs(ne / Sd, fe / Sd, J) : U;
                    }
                    function xQ(m, y) {
                        var I = 0, U = 0;
                        if (m.kind === "constant") U = m.layoutSize;
                        else if (m.kind !== "source") {
                            var J = m.interpolationType, ne = m.minZoom, fe = m.maxZoom, Fe = J ? p(Dl.interpolationFactor(J, y, ne, fe), 0, 1) : 0;
                            m.kind === "camera" ? U = Qs(m.minSize, m.maxSize, Fe) : I = Fe;
                        }
                        return {
                            uSizeT: I,
                            uSize: U
                        };
                    }
                    var iQe = Object.freeze({
                        __proto__: null,
                        getSizeData: yp,
                        evaluateSizeForFeature: _Q,
                        evaluateSizeForZoom: xQ,
                        SIZE_PACK_FACTOR: Sd
                    });
                    function bQ(m, y, I, U, J) {
                        if (y.segment === void 0) return !0;
                        for(var ne = y, fe = y.segment + 1, Fe = 0; Fe > -I / 2;){
                            if (fe--, fe < 0) return !1;
                            Fe -= m[fe].dist(ne), ne = m[fe];
                        }
                        Fe += m[fe].dist(m[fe + 1]), fe++;
                        for(var Qe = [], st = 0; Fe < I / 2;){
                            var mt = m[fe - 1], Xt = m[fe], ur = m[fe + 1];
                            if (!ur) return !1;
                            var nr = mt.angleTo(Xt) - Xt.angleTo(ur);
                            for(nr = Math.abs((nr + 3 * Math.PI) % (Math.PI * 2) - Math.PI), Qe.push({
                                distance: Fe,
                                angleDelta: nr
                            }), st += nr; Fe - Qe[0].distance > U;)st -= Qe.shift().angleDelta;
                            if (st > J) return !1;
                            fe++, Fe += Xt.dist(ur);
                        }
                        return !0;
                    }
                    function wQ(m) {
                        for(var y = 0, I = 0; I < m.length - 1; I++)y += m[I].dist(m[I + 1]);
                        return y;
                    }
                    function TQ(m, y, I) {
                        return m ? 0.6 * y * I : 0;
                    }
                    function AQ(m, y) {
                        return Math.max(m ? m.right - m.left : 0, y ? y.right - y.left : 0);
                    }
                    function nQe(m, y, I, U, J, ne) {
                        for(var fe = TQ(I, J, ne), Fe = AQ(I, U) * ne, Qe = 0, st = wQ(m) / 2, mt = 0; mt < m.length - 1; mt++){
                            var Xt = m[mt], ur = m[mt + 1], nr = Xt.dist(ur);
                            if (Qe + nr > st) {
                                var Lr = (st - Qe) / nr, Yr = Qs(Xt.x, ur.x, Lr), _i = Qs(Xt.y, ur.y, Lr), si = new Gd(Yr, _i, ur.angleTo(Xt), mt);
                                return si._round(), !fe || bQ(m, si, Fe, fe, y) ? si : void 0;
                            }
                            Qe += nr;
                        }
                    }
                    function aQe(m, y, I, U, J, ne, fe, Fe, Qe) {
                        var st = TQ(U, ne, fe), mt = AQ(U, J), Xt = mt * fe, ur = m[0].x === 0 || m[0].x === Qe || m[0].y === 0 || m[0].y === Qe;
                        y - Xt < y / 4 && (y = Xt + y / 4);
                        var nr = ne * 2, Lr = ur ? y / 2 * Fe % y : (mt / 2 + nr) * fe * Fe % y;
                        return SQ(m, Lr, y, st, I, Xt, ur, !1, Qe);
                    }
                    function SQ(m, y, I, U, J, ne, fe, Fe, Qe) {
                        for(var st = ne / 2, mt = wQ(m), Xt = 0, ur = y - I, nr = [], Lr = 0; Lr < m.length - 1; Lr++){
                            for(var Yr = m[Lr], _i = m[Lr + 1], si = Yr.dist(_i), Hi = _i.angleTo(Yr); ur + I < Xt + si;){
                                ur += I;
                                var Ei = (ur - Xt) / si, Vi = Qs(Yr.x, _i.x, Ei), en = Qs(Yr.y, _i.y, Ei);
                                if (Vi >= 0 && Vi < Qe && en >= 0 && en < Qe && ur - st >= 0 && ur + st <= mt) {
                                    var An = new Gd(Vi, en, Hi, Lr);
                                    An._round(), (!U || bQ(m, An, ne, U, J)) && nr.push(An);
                                }
                            }
                            Xt += si;
                        }
                        return !Fe && !nr.length && !fe && (nr = SQ(m, Xt / 2, I, U, J, ne, fe, !0, Qe)), nr;
                    }
                    function MQ(m, y, I, U, J) {
                        for(var ne = [], fe = 0; fe < m.length; fe++)for(var Fe = m[fe], Qe = void 0, st = 0; st < Fe.length - 1; st++){
                            var mt = Fe[st], Xt = Fe[st + 1];
                            mt.x < y && Xt.x < y || (mt.x < y ? mt = new u(y, mt.y + (Xt.y - mt.y) * ((y - mt.x) / (Xt.x - mt.x)))._round() : Xt.x < y && (Xt = new u(y, mt.y + (Xt.y - mt.y) * ((y - mt.x) / (Xt.x - mt.x)))._round()), !(mt.y < I && Xt.y < I) && (mt.y < I ? mt = new u(mt.x + (Xt.x - mt.x) * ((I - mt.y) / (Xt.y - mt.y)), I)._round() : Xt.y < I && (Xt = new u(mt.x + (Xt.x - mt.x) * ((I - mt.y) / (Xt.y - mt.y)), I)._round()), !(mt.x >= U && Xt.x >= U) && (mt.x >= U ? mt = new u(U, mt.y + (Xt.y - mt.y) * ((U - mt.x) / (Xt.x - mt.x)))._round() : Xt.x >= U && (Xt = new u(U, mt.y + (Xt.y - mt.y) * ((U - mt.x) / (Xt.x - mt.x)))._round()), !(mt.y >= J && Xt.y >= J) && (mt.y >= J ? mt = new u(mt.x + (Xt.x - mt.x) * ((J - mt.y) / (Xt.y - mt.y)), J)._round() : Xt.y >= J && (Xt = new u(mt.x + (Xt.x - mt.x) * ((J - mt.y) / (Xt.y - mt.y)), J)._round()), (!Qe || !mt.equals(Qe[Qe.length - 1])) && (Qe = [
                                mt
                            ], ne.push(Qe)), Qe.push(Xt)))));
                        }
                        return ne;
                    }
                    var Gw = oc;
                    function EQ(m, y, I, U) {
                        var J = [], ne = m.image, fe = ne.pixelRatio, Fe = ne.paddedRect.w - 2 * Gw, Qe = ne.paddedRect.h - 2 * Gw, st = m.right - m.left, mt = m.bottom - m.top, Xt = ne.stretchX || [
                            [
                                0,
                                Fe
                            ]
                        ], ur = ne.stretchY || [
                            [
                                0,
                                Qe
                            ]
                        ], nr = function(nl, Ws) {
                            return nl + Ws[1] - Ws[0];
                        }, Lr = Xt.reduce(nr, 0), Yr = ur.reduce(nr, 0), _i = Fe - Lr, si = Qe - Yr, Hi = 0, Ei = Lr, Vi = 0, en = Yr, An = 0, ra = _i, $n = 0, Ba = si;
                        if (ne.content && U) {
                            var _a = ne.content;
                            Hi = HC(Xt, 0, _a[0]), Vi = HC(ur, 0, _a[1]), Ei = HC(Xt, _a[0], _a[2]), en = HC(ur, _a[1], _a[3]), An = _a[0] - Hi, $n = _a[1] - Vi, ra = _a[2] - _a[0] - Ei, Ba = _a[3] - _a[1] - en;
                        }
                        var Pa = function(nl, Ws, Au, Ou) {
                            var nf = GC(nl.stretch - Hi, Ei, st, m.left), bf = jC(nl.fixed - An, ra, nl.stretch, Lr), qh = GC(Ws.stretch - Vi, en, mt, m.top), Zf = jC(Ws.fixed - $n, Ba, Ws.stretch, Yr), jd = GC(Au.stretch - Hi, Ei, st, m.left), Wd = jC(Au.fixed - An, ra, Au.stretch, Lr), Oh = GC(Ou.stretch - Vi, en, mt, m.top), fv = jC(Ou.fixed - $n, Ba, Ou.stretch, Yr), hv = new u(nf, qh), hh = new u(jd, qh), dv = new u(jd, Oh), _p = new u(nf, Oh), py = new u(bf / fe, Zf / fe), F1 = new u(Wd / fe, fv / fe), q1 = y * Math.PI / 180;
                            if (q1) {
                                var O1 = Math.sin(q1), $w = Math.cos(q1), y0 = [
                                    $w,
                                    -O1,
                                    O1,
                                    $w
                                ];
                                hv._matMult(y0), hh._matMult(y0), _p._matMult(y0), dv._matMult(y0);
                            }
                            var JC = nl.stretch + nl.fixed, fq = Au.stretch + Au.fixed, $C = Ws.stretch + Ws.fixed, hq = Ou.stretch + Ou.fixed, jp = {
                                x: ne.paddedRect.x + Gw + JC,
                                y: ne.paddedRect.y + Gw + $C,
                                w: fq - JC,
                                h: hq - $C
                            }, Qw = ra / fe / st, QC = Ba / fe / mt;
                            return {
                                tl: hv,
                                tr: hh,
                                bl: _p,
                                br: dv,
                                tex: jp,
                                writingMode: void 0,
                                glyphOffset: [
                                    0,
                                    0
                                ],
                                sectionIndex: 0,
                                pixelOffsetTL: py,
                                pixelOffsetBR: F1,
                                minFontScaleX: Qw,
                                minFontScaleY: QC,
                                isSDF: I
                            };
                        };
                        if (!U || !ne.stretchX && !ne.stretchY) J.push(Pa({
                            fixed: 0,
                            stretch: -1
                        }, {
                            fixed: 0,
                            stretch: -1
                        }, {
                            fixed: 0,
                            stretch: Fe + 1
                        }, {
                            fixed: 0,
                            stretch: Qe + 1
                        }));
                        else for(var qo = kQ(Xt, _i, Lr), Na = kQ(ur, si, Yr), ja = 0; ja < qo.length - 1; ja++)for(var us = qo[ja], zo = qo[ja + 1], rl = 0; rl < Na.length - 1; rl++){
                            var su = Na[rl], il = Na[rl + 1];
                            J.push(Pa(us, su, zo, il));
                        }
                        return J;
                    }
                    function HC(m, y, I) {
                        for(var U = 0, J = 0, ne = m; J < ne.length; J += 1){
                            var fe = ne[J];
                            U += Math.max(y, Math.min(I, fe[1])) - Math.max(y, Math.min(I, fe[0]));
                        }
                        return U;
                    }
                    function kQ(m, y, I) {
                        for(var U = [
                            {
                                fixed: -Gw,
                                stretch: 0
                            }
                        ], J = 0, ne = m; J < ne.length; J += 1){
                            var fe = ne[J], Fe = fe[0], Qe = fe[1], st = U[U.length - 1];
                            U.push({
                                fixed: Fe - st.stretch,
                                stretch: st.stretch
                            }), U.push({
                                fixed: Fe - st.stretch,
                                stretch: st.stretch + (Qe - Fe)
                            });
                        }
                        return U.push({
                            fixed: y + Gw,
                            stretch: I
                        }), U;
                    }
                    function GC(m, y, I, U) {
                        return m / y * I + U;
                    }
                    function jC(m, y, I, U) {
                        return m - y * I / U;
                    }
                    function oQe(m, y, I, U, J, ne, fe, Fe) {
                        for(var Qe = U.layout.get("text-rotate").evaluate(ne, {}) * Math.PI / 180, st = [], mt = 0, Xt = y.positionedLines; mt < Xt.length; mt += 1)for(var ur = Xt[mt], nr = 0, Lr = ur.positionedGlyphs; nr < Lr.length; nr += 1){
                            var Yr = Lr[nr];
                            if (Yr.rect) {
                                var _i = Yr.rect || {}, si = 1, Hi = Gp + si, Ei = !0, Vi = 1, en = 0, An = (J || Fe) && Yr.vertical, ra = Yr.metrics.advance * Yr.scale / 2;
                                if (Fe && y.verticalizable) {
                                    var $n = (Yr.scale - 1) * Zi, Ba = (Zi - Yr.metrics.width * Yr.scale) / 2;
                                    en = ur.lineOffset / 2 - (Yr.imageName ? -Ba : $n);
                                }
                                if (Yr.imageName) {
                                    var _a = fe[Yr.imageName];
                                    Ei = _a.sdf, Vi = _a.pixelRatio, Hi = oc / Vi;
                                }
                                var Pa = J ? [
                                    Yr.x + ra,
                                    Yr.y
                                ] : [
                                    0,
                                    0
                                ], qo = J ? [
                                    0,
                                    0
                                ] : [
                                    Yr.x + ra + I[0],
                                    Yr.y + I[1] - en
                                ], Na = [
                                    0,
                                    0
                                ];
                                An && (Na = qo, qo = [
                                    0,
                                    0
                                ]);
                                var ja = (Yr.metrics.left - Hi) * Yr.scale - ra + qo[0], us = (-Yr.metrics.top - Hi) * Yr.scale + qo[1], zo = ja + _i.w * Yr.scale / Vi, rl = us + _i.h * Yr.scale / Vi, su = new u(ja, us), il = new u(zo, us), nl = new u(ja, rl), Ws = new u(zo, rl);
                                if (An) {
                                    var Au = new u(-ra, ra - R1), Ou = -Math.PI / 2, nf = Zi / 2 - ra, bf = Yr.imageName ? nf : 0, qh = new u(5 - R1 - nf, -bf), Zf = new (Function.prototype.bind.apply(u, [
                                        null
                                    ].concat(Na)));
                                    su._rotateAround(Ou, Au)._add(qh)._add(Zf), il._rotateAround(Ou, Au)._add(qh)._add(Zf), nl._rotateAround(Ou, Au)._add(qh)._add(Zf), Ws._rotateAround(Ou, Au)._add(qh)._add(Zf);
                                }
                                if (Qe) {
                                    var jd = Math.sin(Qe), Wd = Math.cos(Qe), Oh = [
                                        Wd,
                                        -jd,
                                        jd,
                                        Wd
                                    ];
                                    su._matMult(Oh), il._matMult(Oh), nl._matMult(Oh), Ws._matMult(Oh);
                                }
                                var fv = new u(0, 0), hv = new u(0, 0), hh = 0, dv = 0;
                                st.push({
                                    tl: su,
                                    tr: il,
                                    bl: nl,
                                    br: Ws,
                                    tex: _i,
                                    writingMode: y.writingMode,
                                    glyphOffset: Pa,
                                    sectionIndex: Yr.sectionIndex,
                                    isSDF: Ei,
                                    pixelOffsetTL: fv,
                                    pixelOffsetBR: hv,
                                    minFontScaleX: hh,
                                    minFontScaleY: dv
                                });
                            }
                        }
                        return st;
                    }
                    var WC = function(y, I, U, J, ne, fe, Fe, Qe, st, mt) {
                        if (this.boxStartIndex = y.length, st) {
                            var Xt = fe.top, ur = fe.bottom, nr = fe.collisionPadding;
                            nr && (Xt -= nr[1], ur += nr[3]);
                            var Lr = ur - Xt;
                            Lr > 0 && (Lr = Math.max(10, Lr), this.circleDiameter = Lr);
                        } else {
                            var Yr = fe.top * Fe - Qe, _i = fe.bottom * Fe + Qe, si = fe.left * Fe - Qe, Hi = fe.right * Fe + Qe, Ei = fe.collisionPadding;
                            if (Ei && (si -= Ei[0] * Fe, Yr -= Ei[1] * Fe, Hi += Ei[2] * Fe, _i += Ei[3] * Fe), mt) {
                                var Vi = new u(si, Yr), en = new u(Hi, Yr), An = new u(si, _i), ra = new u(Hi, _i), $n = mt * Math.PI / 180;
                                Vi._rotate($n), en._rotate($n), An._rotate($n), ra._rotate($n), si = Math.min(Vi.x, en.x, An.x, ra.x), Hi = Math.max(Vi.x, en.x, An.x, ra.x), Yr = Math.min(Vi.y, en.y, An.y, ra.y), _i = Math.max(Vi.y, en.y, An.y, ra.y);
                            }
                            y.emplaceBack(I.x, I.y, si, Yr, Hi, _i, U, J, ne);
                        }
                        this.boxEndIndex = y.length;
                    }, jw = function(y, I) {
                        if (y === void 0 && (y = []), I === void 0 && (I = sQe), this.data = y, this.length = this.data.length, this.compare = I, this.length > 0) for(var U = (this.length >> 1) - 1; U >= 0; U--)this._down(U);
                    };
                    jw.prototype.push = function(y) {
                        this.data.push(y), this.length++, this._up(this.length - 1);
                    }, jw.prototype.pop = function() {
                        if (this.length !== 0) {
                            var y = this.data[0], I = this.data.pop();
                            return this.length--, this.length > 0 && (this.data[0] = I, this._down(0)), y;
                        }
                    }, jw.prototype.peek = function() {
                        return this.data[0];
                    }, jw.prototype._up = function(y) {
                        for(var I = this, U = I.data, J = I.compare, ne = U[y]; y > 0;){
                            var fe = y - 1 >> 1, Fe = U[fe];
                            if (J(ne, Fe) >= 0) break;
                            U[y] = Fe, y = fe;
                        }
                        U[y] = ne;
                    }, jw.prototype._down = function(y) {
                        for(var I = this, U = I.data, J = I.compare, ne = this.length >> 1, fe = U[y]; y < ne;){
                            var Fe = (y << 1) + 1, Qe = U[Fe], st = Fe + 1;
                            if (st < this.length && J(U[st], Qe) < 0 && (Fe = st, Qe = U[st]), J(Qe, fe) >= 0) break;
                            U[y] = Qe, y = Fe;
                        }
                        U[y] = fe;
                    };
                    function sQe(m, y) {
                        return m < y ? -1 : m > y ? 1 : 0;
                    }
                    function lQe(m, y, I) {
                        y === void 0 && (y = 1), I === void 0 && (I = !1);
                        for(var U = 1 / 0, J = 1 / 0, ne = -1 / 0, fe = -1 / 0, Fe = m[0], Qe = 0; Qe < Fe.length; Qe++){
                            var st = Fe[Qe];
                            (!Qe || st.x < U) && (U = st.x), (!Qe || st.y < J) && (J = st.y), (!Qe || st.x > ne) && (ne = st.x), (!Qe || st.y > fe) && (fe = st.y);
                        }
                        var mt = ne - U, Xt = fe - J, ur = Math.min(mt, Xt), nr = ur / 2, Lr = new jw([], uQe);
                        if (ur === 0) return new u(U, J);
                        for(var Yr = U; Yr < ne; Yr += ur)for(var _i = J; _i < fe; _i += ur)Lr.push(new Ww(Yr + nr, _i + nr, nr, m));
                        for(var si = fQe(m), Hi = Lr.length; Lr.length;){
                            var Ei = Lr.pop();
                            (Ei.d > si.d || !si.d) && (si = Ei, I && console.log("found best %d after %d probes", Math.round(1e4 * Ei.d) / 1e4, Hi)), !(Ei.max - si.d <= y) && (nr = Ei.h / 2, Lr.push(new Ww(Ei.p.x - nr, Ei.p.y - nr, nr, m)), Lr.push(new Ww(Ei.p.x + nr, Ei.p.y - nr, nr, m)), Lr.push(new Ww(Ei.p.x - nr, Ei.p.y + nr, nr, m)), Lr.push(new Ww(Ei.p.x + nr, Ei.p.y + nr, nr, m)), Hi += 4);
                        }
                        return I && (console.log("num probes: " + Hi), console.log("best distance: " + si.d)), si.p;
                    }
                    function uQe(m, y) {
                        return y.max - m.max;
                    }
                    function Ww(m, y, I, U) {
                        this.p = new u(m, y), this.h = I, this.d = cQe(this.p, U), this.max = this.d + this.h * Math.SQRT2;
                    }
                    function cQe(m, y) {
                        for(var I = !1, U = 1 / 0, J = 0; J < y.length; J++)for(var ne = y[J], fe = 0, Fe = ne.length, Qe = Fe - 1; fe < Fe; Qe = fe++){
                            var st = ne[fe], mt = ne[Qe];
                            st.y > m.y != mt.y > m.y && m.x < (mt.x - st.x) * (m.y - st.y) / (mt.y - st.y) + st.x && (I = !I), U = Math.min(U, cg(m, st, mt));
                        }
                        return (I ? 1 : -1) * Math.sqrt(U);
                    }
                    function fQe(m) {
                        for(var y = 0, I = 0, U = 0, J = m[0], ne = 0, fe = J.length, Fe = fe - 1; ne < fe; Fe = ne++){
                            var Qe = J[ne], st = J[Fe], mt = Qe.x * st.y - st.x * Qe.y;
                            I += (Qe.x + st.x) * mt, U += (Qe.y + st.y) * mt, y += mt * 3;
                        }
                        return new Ww(I / y, U / y, 0, m);
                    }
                    var Zw = 7, nq = Number.POSITIVE_INFINITY;
                    function CQ(m, y) {
                        function I(J, ne) {
                            var fe = 0, Fe = 0;
                            ne < 0 && (ne = 0);
                            var Qe = ne / Math.sqrt(2);
                            switch(J){
                                case "top-right":
                                case "top-left":
                                    Fe = Qe - Zw;
                                    break;
                                case "bottom-right":
                                case "bottom-left":
                                    Fe = -Qe + Zw;
                                    break;
                                case "bottom":
                                    Fe = -ne + Zw;
                                    break;
                                case "top":
                                    Fe = ne - Zw;
                                    break;
                            }
                            switch(J){
                                case "top-right":
                                case "bottom-right":
                                    fe = -Qe;
                                    break;
                                case "top-left":
                                case "bottom-left":
                                    fe = Qe;
                                    break;
                                case "left":
                                    fe = ne;
                                    break;
                                case "right":
                                    fe = -ne;
                                    break;
                            }
                            return [
                                fe,
                                Fe
                            ];
                        }
                        function U(J, ne, fe) {
                            var Fe = 0, Qe = 0;
                            switch(ne = Math.abs(ne), fe = Math.abs(fe), J){
                                case "top-right":
                                case "top-left":
                                case "top":
                                    Qe = fe - Zw;
                                    break;
                                case "bottom-right":
                                case "bottom-left":
                                case "bottom":
                                    Qe = -fe + Zw;
                                    break;
                            }
                            switch(J){
                                case "top-right":
                                case "bottom-right":
                                case "right":
                                    Fe = -ne;
                                    break;
                                case "top-left":
                                case "bottom-left":
                                case "left":
                                    Fe = ne;
                                    break;
                            }
                            return [
                                Fe,
                                Qe
                            ];
                        }
                        return y[1] !== nq ? U(m, y[0], y[1]) : I(m, y[0]);
                    }
                    function hQe(m, y, I, U, J, ne, fe) {
                        m.createArrays();
                        var Fe = 512 * m.overscaling;
                        m.tilePixelRatio = rn / Fe, m.compareText = {}, m.iconsNeedLinear = !1;
                        var Qe = m.layers[0].layout, st = m.layers[0]._unevaluatedLayout._values, mt = {};
                        if (m.textSizeData.kind === "composite") {
                            var Xt = m.textSizeData, ur = Xt.minZoom, nr = Xt.maxZoom;
                            mt.compositeTextSizes = [
                                st["text-size"].possiblyEvaluate(new pn(ur), fe),
                                st["text-size"].possiblyEvaluate(new pn(nr), fe)
                            ];
                        }
                        if (m.iconSizeData.kind === "composite") {
                            var Lr = m.iconSizeData, Yr = Lr.minZoom, _i = Lr.maxZoom;
                            mt.compositeIconSizes = [
                                st["icon-size"].possiblyEvaluate(new pn(Yr), fe),
                                st["icon-size"].possiblyEvaluate(new pn(_i), fe)
                            ];
                        }
                        mt.layoutTextSize = st["text-size"].possiblyEvaluate(new pn(m.zoom + 1), fe), mt.layoutIconSize = st["icon-size"].possiblyEvaluate(new pn(m.zoom + 1), fe), mt.textMaxSize = st["text-size"].possiblyEvaluate(new pn(18));
                        for(var si = Qe.get("text-line-height") * Zi, Hi = Qe.get("text-rotation-alignment") === "map" && Qe.get("symbol-placement") !== "point", Ei = Qe.get("text-keep-upright"), Vi = Qe.get("text-size"), en = function() {
                            var $n = ra[An], Ba = Qe.get("text-font").evaluate($n, {}, fe).join(","), _a = Vi.evaluate($n, {}, fe), Pa = mt.layoutTextSize.evaluate($n, {}, fe), qo = mt.layoutIconSize.evaluate($n, {}, fe), Na = {
                                horizontal: {},
                                vertical: void 0
                            }, ja = $n.text, us = [
                                0,
                                0
                            ];
                            if (ja) {
                                var zo = ja.toString(), rl = Qe.get("text-letter-spacing").evaluate($n, {}, fe) * Zi, su = or(zo) ? rl : 0, il = Qe.get("text-anchor").evaluate($n, {}, fe), nl = Qe.get("text-variable-anchor");
                                if (!nl) {
                                    var Ws = Qe.get("text-radial-offset").evaluate($n, {}, fe);
                                    Ws ? us = CQ(il, [
                                        Ws * Zi,
                                        nq
                                    ]) : us = Qe.get("text-offset").evaluate($n, {}, fe).map(function(py) {
                                        return py * Zi;
                                    });
                                }
                                var Au = Hi ? "center" : Qe.get("text-justify").evaluate($n, {}, fe), Ou = Qe.get("symbol-placement"), nf = Ou === "point" ? Qe.get("text-max-width").evaluate($n, {}, fe) * Zi : 0, bf = function() {
                                    m.allowVerticalPlacement && zt(zo) && (Na.vertical = Vw(ja, y, I, J, Ba, nf, si, il, "left", su, us, uv.vertical, !0, Ou, Pa, _a));
                                };
                                if (!Hi && nl) {
                                    for(var qh = Au === "auto" ? nl.map(function(py) {
                                        return aq(py);
                                    }) : [
                                        Au
                                    ], Zf = !1, jd = 0; jd < qh.length; jd++){
                                        var Wd = qh[jd];
                                        if (!Na.horizontal[Wd]) {
                                            if (Zf) Na.horizontal[Wd] = Na.horizontal[0];
                                            else {
                                                var Oh = Vw(ja, y, I, J, Ba, nf, si, "center", Wd, su, us, uv.horizontal, !1, Ou, Pa, _a);
                                                Oh && (Na.horizontal[Wd] = Oh, Zf = Oh.positionedLines.length === 1);
                                            }
                                        }
                                    }
                                    bf();
                                } else {
                                    Au === "auto" && (Au = aq(il));
                                    var fv = Vw(ja, y, I, J, Ba, nf, si, il, Au, su, us, uv.horizontal, !1, Ou, Pa, _a);
                                    fv && (Na.horizontal[Au] = fv), bf(), zt(zo) && Hi && Ei && (Na.vertical = Vw(ja, y, I, J, Ba, nf, si, il, Au, su, us, uv.vertical, !1, Ou, Pa, _a));
                                }
                            }
                            var hv = void 0, hh = !1;
                            if ($n.icon && $n.icon.name) {
                                var dv = U[$n.icon.name];
                                dv && (hv = tp(J[$n.icon.name], Qe.get("icon-offset").evaluate($n, {}, fe), Qe.get("icon-anchor").evaluate($n, {}, fe)), hh = dv.sdf, m.sdfIcons === void 0 ? m.sdfIcons = dv.sdf : m.sdfIcons !== dv.sdf && re("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (dv.pixelRatio !== m.pixelRatio || Qe.get("icon-rotate").constantOr(1) !== 0) && (m.iconsNeedLinear = !0));
                            }
                            var _p = PQ(Na.horizontal) || Na.vertical;
                            m.iconsInText = _p ? _p.iconsInText : !1, (_p || hv) && dQe(m, $n, Na, hv, U, mt, Pa, qo, us, hh, fe);
                        }, An = 0, ra = m.features; An < ra.length; An += 1)en();
                        ne && m.generateCollisionDebugBuffers();
                    }
                    function aq(m) {
                        switch(m){
                            case "right":
                            case "top-right":
                            case "bottom-right":
                                return "right";
                            case "left":
                            case "top-left":
                            case "bottom-left":
                                return "left";
                        }
                        return "center";
                    }
                    function dQe(m, y, I, U, J, ne, fe, Fe, Qe, st, mt) {
                        var Xt = ne.textMaxSize.evaluate(y, {});
                        Xt === void 0 && (Xt = fe);
                        var ur = m.layers[0].layout, nr = ur.get("icon-offset").evaluate(y, {}, mt), Lr = PQ(I.horizontal), Yr = 24, _i = fe / Yr, si = m.tilePixelRatio * _i, Hi = m.tilePixelRatio * Xt / Yr, Ei = m.tilePixelRatio * Fe, Vi = m.tilePixelRatio * ur.get("symbol-spacing"), en = ur.get("text-padding") * m.tilePixelRatio, An = ur.get("icon-padding") * m.tilePixelRatio, ra = ur.get("text-max-angle") / 180 * Math.PI, $n = ur.get("text-rotation-alignment") === "map" && ur.get("symbol-placement") !== "point", Ba = ur.get("icon-rotation-alignment") === "map" && ur.get("symbol-placement") !== "point", _a = ur.get("symbol-placement"), Pa = Vi / 2, qo = ur.get("icon-text-fit"), Na;
                        U && qo !== "none" && (m.allowVerticalPlacement && I.vertical && (Na = hm(U, I.vertical, qo, ur.get("icon-text-fit-padding"), nr, _i)), Lr && (U = hm(U, Lr, qo, ur.get("icon-text-fit-padding"), nr, _i)));
                        var ja = function($w, y0) {
                            y0.x < 0 || y0.x >= rn || y0.y < 0 || y0.y >= rn || vQe(m, y0, $w, I, U, J, Na, m.layers[0], m.collisionBoxArray, y.index, y.sourceLayerIndex, m.index, si, en, $n, Qe, Ei, An, Ba, nr, y, ne, st, mt, fe);
                        };
                        if (_a === "line") for(var us = 0, zo = MQ(y.geometry, 0, 0, rn, rn); us < zo.length; us += 1)for(var rl = zo[us], su = aQe(rl, Vi, ra, I.vertical || Lr, U, Yr, Hi, m.overscaling, rn), il = 0, nl = su; il < nl.length; il += 1){
                            var Ws = nl[il], Au = Lr;
                            (!Au || !pQe(m, Au.text, Pa, Ws)) && ja(rl, Ws);
                        }
                        else if (_a === "line-center") for(var Ou = 0, nf = y.geometry; Ou < nf.length; Ou += 1){
                            var bf = nf[Ou];
                            if (bf.length > 1) {
                                var qh = nQe(bf, ra, I.vertical || Lr, U, Yr, Hi);
                                qh && ja(bf, qh);
                            }
                        }
                        else if (y.type === "Polygon") for(var Zf = 0, jd = zw(y.geometry, 0); Zf < jd.length; Zf += 1){
                            var Wd = jd[Zf], Oh = lQe(Wd, 16);
                            ja(Wd[0], new Gd(Oh.x, Oh.y, 0));
                        }
                        else if (y.type === "LineString") for(var fv = 0, hv = y.geometry; fv < hv.length; fv += 1){
                            var hh = hv[fv];
                            ja(hh, new Gd(hh[0].x, hh[0].y, 0));
                        }
                        else if (y.type === "Point") for(var dv = 0, _p = y.geometry; dv < _p.length; dv += 1)for(var py = _p[dv], F1 = 0, q1 = py; F1 < q1.length; F1 += 1){
                            var O1 = q1[F1];
                            ja([
                                O1
                            ], new Gd(O1.x, O1.y, 0));
                        }
                    }
                    var wS = 255, D1 = wS * Sd;
                    function LQ(m, y, I, U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr) {
                        var Yr = oQe(y, I, Fe, J, ne, fe, U, m.allowVerticalPlacement), _i = m.textSizeData, si = null;
                        _i.kind === "source" ? (si = [
                            Sd * J.layout.get("text-size").evaluate(fe, {})
                        ], si[0] > D1 && re(m.layerIds[0] + ': Value for "text-size" is >= ' + wS + '. Reduce your "text-size".')) : _i.kind === "composite" && (si = [
                            Sd * nr.compositeTextSizes[0].evaluate(fe, {}, Lr),
                            Sd * nr.compositeTextSizes[1].evaluate(fe, {}, Lr)
                        ], (si[0] > D1 || si[1] > D1) && re(m.layerIds[0] + ': Value for "text-size" is >= ' + wS + '. Reduce your "text-size".')), m.addSymbols(m.text, Yr, si, Fe, ne, fe, st, y, Qe.lineStartIndex, Qe.lineLength, ur, Lr);
                        for(var Hi = 0, Ei = mt; Hi < Ei.length; Hi += 1){
                            var Vi = Ei[Hi];
                            Xt[Vi] = m.text.placedSymbolArray.length - 1;
                        }
                        return Yr.length * 4;
                    }
                    function PQ(m) {
                        for(var y in m)return m[y];
                        return null;
                    }
                    function vQe(m, y, I, U, J, ne, fe, Fe, Qe, st, mt, Xt, ur, nr, Lr, Yr, _i, si, Hi, Ei, Vi, en, An, ra, $n) {
                        var Ba, _a = m.addToLineVertexArray(y, I), Pa, qo, Na, ja, us = 0, zo = 0, rl = 0, su = 0, il = -1, nl = -1, Ws = {}, Au = $(""), Ou = 0, nf = 0;
                        if (Fe._unevaluatedLayout.getValue("text-radial-offset") === void 0 ? (Ba = Fe.layout.get("text-offset").evaluate(Vi, {}, ra).map(function(SS) {
                            return SS * Zi;
                        }), Ou = Ba[0], nf = Ba[1]) : (Ou = Fe.layout.get("text-radial-offset").evaluate(Vi, {}, ra) * Zi, nf = nq), m.allowVerticalPlacement && U.vertical) {
                            var bf = Fe.layout.get("text-rotate").evaluate(Vi, {}, ra), qh = bf + 90, Zf = U.vertical;
                            Na = new WC(Qe, y, st, mt, Xt, Zf, ur, nr, Lr, qh), fe && (ja = new WC(Qe, y, st, mt, Xt, fe, _i, si, Lr, qh));
                        }
                        if (J) {
                            var jd = Fe.layout.get("icon-rotate").evaluate(Vi, {}), Wd = Fe.layout.get("icon-text-fit") !== "none", Oh = EQ(J, jd, An, Wd), fv = fe ? EQ(fe, jd, An, Wd) : void 0;
                            qo = new WC(Qe, y, st, mt, Xt, J, _i, si, !1, jd), us = Oh.length * 4;
                            var hv = m.iconSizeData, hh = null;
                            hv.kind === "source" ? (hh = [
                                Sd * Fe.layout.get("icon-size").evaluate(Vi, {})
                            ], hh[0] > D1 && re(m.layerIds[0] + ': Value for "icon-size" is >= ' + wS + '. Reduce your "icon-size".')) : hv.kind === "composite" && (hh = [
                                Sd * en.compositeIconSizes[0].evaluate(Vi, {}, ra),
                                Sd * en.compositeIconSizes[1].evaluate(Vi, {}, ra)
                            ], (hh[0] > D1 || hh[1] > D1) && re(m.layerIds[0] + ': Value for "icon-size" is >= ' + wS + '. Reduce your "icon-size".')), m.addSymbols(m.icon, Oh, hh, Ei, Hi, Vi, !1, y, _a.lineStartIndex, _a.lineLength, -1, ra), il = m.icon.placedSymbolArray.length - 1, fv && (zo = fv.length * 4, m.addSymbols(m.icon, fv, hh, Ei, Hi, Vi, uv.vertical, y, _a.lineStartIndex, _a.lineLength, -1, ra), nl = m.icon.placedSymbolArray.length - 1);
                        }
                        for(var dv in U.horizontal){
                            var _p = U.horizontal[dv];
                            if (!Pa) {
                                Au = $(_p.text);
                                var py = Fe.layout.get("text-rotate").evaluate(Vi, {}, ra);
                                Pa = new WC(Qe, y, st, mt, Xt, _p, ur, nr, Lr, py);
                            }
                            var F1 = _p.positionedLines.length === 1;
                            if (rl += LQ(m, y, _p, ne, Fe, Lr, Vi, Yr, _a, U.vertical ? uv.horizontal : uv.horizontalOnly, F1 ? Object.keys(U.horizontal) : [
                                dv
                            ], Ws, il, en, ra), F1) break;
                        }
                        U.vertical && (su += LQ(m, y, U.vertical, ne, Fe, Lr, Vi, Yr, _a, uv.vertical, [
                            "vertical"
                        ], Ws, nl, en, ra));
                        var q1 = Pa ? Pa.boxStartIndex : m.collisionBoxArray.length, O1 = Pa ? Pa.boxEndIndex : m.collisionBoxArray.length, $w = Na ? Na.boxStartIndex : m.collisionBoxArray.length, y0 = Na ? Na.boxEndIndex : m.collisionBoxArray.length, JC = qo ? qo.boxStartIndex : m.collisionBoxArray.length, fq = qo ? qo.boxEndIndex : m.collisionBoxArray.length, $C = ja ? ja.boxStartIndex : m.collisionBoxArray.length, hq = ja ? ja.boxEndIndex : m.collisionBoxArray.length, jp = -1, Qw = function(SS, ZQ) {
                            return SS && SS.circleDiameter ? Math.max(SS.circleDiameter, ZQ) : ZQ;
                        };
                        jp = Qw(Pa, jp), jp = Qw(Na, jp), jp = Qw(qo, jp), jp = Qw(ja, jp);
                        var QC = jp > -1 ? 1 : 0;
                        QC && (jp *= $n / Zi), m.glyphOffsetArray.length >= ou.MAX_GLYPHS && re("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), Vi.sortKey !== void 0 && m.addToSortKeyRanges(m.symbolInstances.length, Vi.sortKey), m.symbolInstances.emplaceBack(y.x, y.y, Ws.right >= 0 ? Ws.right : -1, Ws.center >= 0 ? Ws.center : -1, Ws.left >= 0 ? Ws.left : -1, Ws.vertical || -1, il, nl, Au, q1, O1, $w, y0, JC, fq, $C, hq, st, rl, su, us, zo, QC, 0, ur, Ou, nf, jp);
                    }
                    function pQe(m, y, I, U) {
                        var J = m.compareText;
                        if (!(y in J)) J[y] = [];
                        else for(var ne = J[y], fe = ne.length - 1; fe >= 0; fe--)if (U.dist(ne[fe]) < I) return !0;
                        return J[y].push(U), !1;
                    }
                    var gQe = pg.VectorTileFeature.types, mQe = [
                        {
                            name: "a_fade_opacity",
                            components: 1,
                            type: "Uint8",
                            offset: 0
                        }
                    ];
                    function ZC(m, y, I, U, J, ne, fe, Fe, Qe, st, mt, Xt, ur) {
                        var nr = Fe ? Math.min(D1, Math.round(Fe[0])) : 0, Lr = Fe ? Math.min(D1, Math.round(Fe[1])) : 0;
                        m.emplaceBack(y, I, Math.round(U * 32), Math.round(J * 32), ne, fe, (nr << 1) + (Qe ? 1 : 0), Lr, st * 16, mt * 16, Xt * 256, ur * 256);
                    }
                    function oq(m, y, I) {
                        m.emplaceBack(y.x, y.y, I), m.emplaceBack(y.x, y.y, I), m.emplaceBack(y.x, y.y, I), m.emplaceBack(y.x, y.y, I);
                    }
                    function yQe(m) {
                        for(var y = 0, I = m.sections; y < I.length; y += 1){
                            var U = I[y];
                            if (vi(U.text)) return !0;
                        }
                        return !1;
                    }
                    var Xw = function(y) {
                        this.layoutVertexArray = new Za, this.indexArray = new ma, this.programConfigurations = y, this.segments = new ns, this.dynamicLayoutVertexArray = new wn, this.opacityVertexArray = new vn, this.placedSymbolArray = new El;
                    };
                    Xw.prototype.isEmpty = function() {
                        return this.layoutVertexArray.length === 0 && this.indexArray.length === 0 && this.dynamicLayoutVertexArray.length === 0 && this.opacityVertexArray.length === 0;
                    }, Xw.prototype.upload = function(y, I, U, J) {
                        this.isEmpty() || (U && (this.layoutVertexBuffer = y.createVertexBuffer(this.layoutVertexArray, te.members), this.indexBuffer = y.createIndexBuffer(this.indexArray, I), this.dynamicLayoutVertexBuffer = y.createVertexBuffer(this.dynamicLayoutVertexArray, ue.members, !0), this.opacityVertexBuffer = y.createVertexBuffer(this.opacityVertexArray, mQe, !0), this.opacityVertexBuffer.itemSize = 1), (U || J) && this.programConfigurations.upload(y));
                    }, Xw.prototype.destroy = function() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
                    }, Z("SymbolBuffers", Xw);
                    var TS = function(y, I, U) {
                        this.layoutVertexArray = new y, this.layoutAttributes = I, this.indexArray = new U, this.segments = new ns, this.collisionVertexArray = new Vn;
                    };
                    TS.prototype.upload = function(y) {
                        this.layoutVertexBuffer = y.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = y.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = y.createVertexBuffer(this.collisionVertexArray, De.members, !0);
                    }, TS.prototype.destroy = function() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
                    }, Z("CollisionBuffers", TS);
                    var ou = function(y) {
                        this.collisionBoxArray = y.collisionBoxArray, this.zoom = y.zoom, this.overscaling = y.overscaling, this.layers = y.layers, this.layerIds = this.layers.map(function(Qe) {
                            return Qe.id;
                        }), this.index = y.index, this.pixelRatio = y.pixelRatio, this.sourceLayerIndex = y.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = oy([]), this.placementViewportMatrix = oy([]);
                        var I = this.layers[0], U = I._unevaluatedLayout._values;
                        this.textSizeData = yp(this.zoom, U["text-size"]), this.iconSizeData = yp(this.zoom, U["icon-size"]);
                        var J = this.layers[0].layout, ne = J.get("symbol-sort-key"), fe = J.get("symbol-z-order");
                        this.canOverlap = J.get("text-allow-overlap") || J.get("icon-allow-overlap") || J.get("text-ignore-placement") || J.get("icon-ignore-placement"), this.sortFeaturesByKey = fe !== "viewport-y" && ne.constantOr(1) !== void 0;
                        var Fe = fe === "viewport-y" || fe === "auto" && !this.sortFeaturesByKey;
                        this.sortFeaturesByY = Fe && this.canOverlap, J.get("symbol-placement") === "point" && (this.writingModes = J.get("text-writing-mode").map(function(Qe) {
                            return uv[Qe];
                        })), this.stateDependentLayerIds = this.layers.filter(function(Qe) {
                            return Qe.isStateDependent();
                        }).map(function(Qe) {
                            return Qe.id;
                        }), this.sourceID = y.sourceID;
                    };
                    ou.prototype.createArrays = function() {
                        this.text = new Xw(new Ri(this.layers, this.zoom, function(y) {
                            return /^text/.test(y);
                        })), this.icon = new Xw(new Ri(this.layers, this.zoom, function(y) {
                            return /^icon/.test(y);
                        })), this.glyphOffsetArray = new yf, this.lineVertexArray = new Gl, this.symbolInstances = new wc;
                    }, ou.prototype.calculateGlyphDependencies = function(y, I, U, J, ne) {
                        for(var fe = 0; fe < y.length; fe++)if (I[y.charCodeAt(fe)] = !0, (U || J) && ne) {
                            var Fe = pi[y.charAt(fe)];
                            Fe && (I[Fe.charCodeAt(0)] = !0);
                        }
                    }, ou.prototype.populate = function(y, I, U) {
                        var J = this.layers[0], ne = J.layout, fe = ne.get("text-font"), Fe = ne.get("text-field"), Qe = ne.get("icon-image"), st = (Fe.value.kind !== "constant" || Fe.value.value instanceof Vl && !Fe.value.value.isEmpty() || Fe.value.value.toString().length > 0) && (fe.value.kind !== "constant" || fe.value.value.length > 0), mt = Qe.value.kind !== "constant" || !!Qe.value.value || Object.keys(Qe.parameters).length > 0, Xt = ne.get("symbol-sort-key");
                        if (this.features = [], !(!st && !mt)) {
                            for(var ur = I.iconDependencies, nr = I.glyphDependencies, Lr = I.availableImages, Yr = new pn(this.zoom), _i = 0, si = y; _i < si.length; _i += 1){
                                var Hi = si[_i], Ei = Hi.feature, Vi = Hi.id, en = Hi.index, An = Hi.sourceLayerIndex, ra = J._featureFilter.needGeometry, $n = No(Ei, ra);
                                if (J._featureFilter.filter(Yr, $n, U)) {
                                    ra || ($n.geometry = da(Ei));
                                    var Ba = void 0;
                                    if (st) {
                                        var _a = J.getValueAndResolveTokens("text-field", $n, U, Lr), Pa = Vl.factory(_a);
                                        yQe(Pa) && (this.hasRTLText = !0), (!this.hasRTLText || so() === "unavailable" || this.hasRTLText && _s.isParsed()) && (Ba = ni(Pa, J, $n));
                                    }
                                    var qo = void 0;
                                    if (mt) {
                                        var Na = J.getValueAndResolveTokens("icon-image", $n, U, Lr);
                                        Na instanceof Js ? qo = Na : qo = Js.fromString(Na);
                                    }
                                    if (!(!Ba && !qo)) {
                                        var ja = this.sortFeaturesByKey ? Xt.evaluate($n, {}, U) : void 0, us = {
                                            id: Vi,
                                            text: Ba,
                                            icon: qo,
                                            index: en,
                                            sourceLayerIndex: An,
                                            geometry: $n.geometry,
                                            properties: Ei.properties,
                                            type: gQe[Ei.type],
                                            sortKey: ja
                                        };
                                        if (this.features.push(us), qo && (ur[qo.name] = !0), Ba) {
                                            var zo = fe.evaluate($n, {}, U).join(","), rl = ne.get("text-rotation-alignment") === "map" && ne.get("symbol-placement") !== "point";
                                            this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(uv.vertical) >= 0;
                                            for(var su = 0, il = Ba.sections; su < il.length; su += 1){
                                                var nl = il[su];
                                                if (nl.image) ur[nl.image.name] = !0;
                                                else {
                                                    var Ws = zt(Ba.toString()), Au = nl.fontStack || zo, Ou = nr[Au] = nr[Au] || {};
                                                    this.calculateGlyphDependencies(nl.text, Ou, rl, this.allowVerticalPlacement, Ws);
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            ne.get("symbol-placement") === "line" && (this.features = Di(this.features)), this.sortFeaturesByKey && this.features.sort(function(nf, bf) {
                                return nf.sortKey - bf.sortKey;
                            });
                        }
                    }, ou.prototype.update = function(y, I, U) {
                        this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(y, I, this.layers, U), this.icon.programConfigurations.updatePaintArrays(y, I, this.layers, U));
                    }, ou.prototype.isEmpty = function() {
                        return this.symbolInstances.length === 0 && !this.hasRTLText;
                    }, ou.prototype.uploadPending = function() {
                        return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
                    }, ou.prototype.upload = function(y) {
                        !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(y), this.iconCollisionBox.upload(y)), this.text.upload(y, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(y, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
                    }, ou.prototype.destroyDebugData = function() {
                        this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
                    }, ou.prototype.destroy = function() {
                        this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
                    }, ou.prototype.addToLineVertexArray = function(y, I) {
                        var U = this.lineVertexArray.length;
                        if (y.segment !== void 0) {
                            for(var J = y.dist(I[y.segment + 1]), ne = y.dist(I[y.segment]), fe = {}, Fe = y.segment + 1; Fe < I.length; Fe++)fe[Fe] = {
                                x: I[Fe].x,
                                y: I[Fe].y,
                                tileUnitDistanceFromAnchor: J
                            }, Fe < I.length - 1 && (J += I[Fe + 1].dist(I[Fe]));
                            for(var Qe = y.segment || 0; Qe >= 0; Qe--)fe[Qe] = {
                                x: I[Qe].x,
                                y: I[Qe].y,
                                tileUnitDistanceFromAnchor: ne
                            }, Qe > 0 && (ne += I[Qe - 1].dist(I[Qe]));
                            for(var st = 0; st < I.length; st++){
                                var mt = fe[st];
                                this.lineVertexArray.emplaceBack(mt.x, mt.y, mt.tileUnitDistanceFromAnchor);
                            }
                        }
                        return {
                            lineStartIndex: U,
                            lineLength: this.lineVertexArray.length - U
                        };
                    }, ou.prototype.addSymbols = function(y, I, U, J, ne, fe, Fe, Qe, st, mt, Xt, ur) {
                        for(var nr = y.indexArray, Lr = y.layoutVertexArray, Yr = y.segments.prepareSegment(4 * I.length, Lr, nr, this.canOverlap ? fe.sortKey : void 0), _i = this.glyphOffsetArray.length, si = Yr.vertexLength, Hi = this.allowVerticalPlacement && Fe === uv.vertical ? Math.PI / 2 : 0, Ei = fe.text && fe.text.sections, Vi = 0; Vi < I.length; Vi++){
                            var en = I[Vi], An = en.tl, ra = en.tr, $n = en.bl, Ba = en.br, _a = en.tex, Pa = en.pixelOffsetTL, qo = en.pixelOffsetBR, Na = en.minFontScaleX, ja = en.minFontScaleY, us = en.glyphOffset, zo = en.isSDF, rl = en.sectionIndex, su = Yr.vertexLength, il = us[1];
                            ZC(Lr, Qe.x, Qe.y, An.x, il + An.y, _a.x, _a.y, U, zo, Pa.x, Pa.y, Na, ja), ZC(Lr, Qe.x, Qe.y, ra.x, il + ra.y, _a.x + _a.w, _a.y, U, zo, qo.x, Pa.y, Na, ja), ZC(Lr, Qe.x, Qe.y, $n.x, il + $n.y, _a.x, _a.y + _a.h, U, zo, Pa.x, qo.y, Na, ja), ZC(Lr, Qe.x, Qe.y, Ba.x, il + Ba.y, _a.x + _a.w, _a.y + _a.h, U, zo, qo.x, qo.y, Na, ja), oq(y.dynamicLayoutVertexArray, Qe, Hi), nr.emplaceBack(su, su + 1, su + 2), nr.emplaceBack(su + 1, su + 2, su + 3), Yr.vertexLength += 4, Yr.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(us[0]), (Vi === I.length - 1 || rl !== I[Vi + 1].sectionIndex) && y.programConfigurations.populatePaintArrays(Lr.length, fe, fe.index, {}, ur, Ei && Ei[rl]);
                        }
                        y.placedSymbolArray.emplaceBack(Qe.x, Qe.y, _i, this.glyphOffsetArray.length - _i, si, st, mt, Qe.segment, U ? U[0] : 0, U ? U[1] : 0, J[0], J[1], Fe, 0, !1, 0, Xt);
                    }, ou.prototype._addCollisionDebugVertex = function(y, I, U, J, ne, fe) {
                        return I.emplaceBack(0, 0), y.emplaceBack(U.x, U.y, J, ne, Math.round(fe.x), Math.round(fe.y));
                    }, ou.prototype.addCollisionDebugVertices = function(y, I, U, J, ne, fe, Fe) {
                        var Qe = ne.segments.prepareSegment(4, ne.layoutVertexArray, ne.indexArray), st = Qe.vertexLength, mt = ne.layoutVertexArray, Xt = ne.collisionVertexArray, ur = Fe.anchorX, nr = Fe.anchorY;
                        this._addCollisionDebugVertex(mt, Xt, fe, ur, nr, new u(y, I)), this._addCollisionDebugVertex(mt, Xt, fe, ur, nr, new u(U, I)), this._addCollisionDebugVertex(mt, Xt, fe, ur, nr, new u(U, J)), this._addCollisionDebugVertex(mt, Xt, fe, ur, nr, new u(y, J)), Qe.vertexLength += 4;
                        var Lr = ne.indexArray;
                        Lr.emplaceBack(st, st + 1), Lr.emplaceBack(st + 1, st + 2), Lr.emplaceBack(st + 2, st + 3), Lr.emplaceBack(st + 3, st), Qe.primitiveLength += 4;
                    }, ou.prototype.addDebugCollisionBoxes = function(y, I, U, J) {
                        for(var ne = y; ne < I; ne++){
                            var fe = this.collisionBoxArray.get(ne), Fe = fe.x1, Qe = fe.y1, st = fe.x2, mt = fe.y2;
                            this.addCollisionDebugVertices(Fe, Qe, st, mt, J ? this.textCollisionBox : this.iconCollisionBox, fe.anchorPoint, U);
                        }
                    }, ou.prototype.generateCollisionDebugBuffers = function() {
                        this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new TS(aa, at.members, Po), this.iconCollisionBox = new TS(aa, at.members, Po);
                        for(var y = 0; y < this.symbolInstances.length; y++){
                            var I = this.symbolInstances.get(y);
                            this.addDebugCollisionBoxes(I.textBoxStartIndex, I.textBoxEndIndex, I, !0), this.addDebugCollisionBoxes(I.verticalTextBoxStartIndex, I.verticalTextBoxEndIndex, I, !0), this.addDebugCollisionBoxes(I.iconBoxStartIndex, I.iconBoxEndIndex, I, !1), this.addDebugCollisionBoxes(I.verticalIconBoxStartIndex, I.verticalIconBoxEndIndex, I, !1);
                        }
                    }, ou.prototype._deserializeCollisionBoxesForSymbol = function(y, I, U, J, ne, fe, Fe, Qe, st) {
                        for(var mt = {}, Xt = I; Xt < U; Xt++){
                            var ur = y.get(Xt);
                            mt.textBox = {
                                x1: ur.x1,
                                y1: ur.y1,
                                x2: ur.x2,
                                y2: ur.y2,
                                anchorPointX: ur.anchorPointX,
                                anchorPointY: ur.anchorPointY
                            }, mt.textFeatureIndex = ur.featureIndex;
                            break;
                        }
                        for(var nr = J; nr < ne; nr++){
                            var Lr = y.get(nr);
                            mt.verticalTextBox = {
                                x1: Lr.x1,
                                y1: Lr.y1,
                                x2: Lr.x2,
                                y2: Lr.y2,
                                anchorPointX: Lr.anchorPointX,
                                anchorPointY: Lr.anchorPointY
                            }, mt.verticalTextFeatureIndex = Lr.featureIndex;
                            break;
                        }
                        for(var Yr = fe; Yr < Fe; Yr++){
                            var _i = y.get(Yr);
                            mt.iconBox = {
                                x1: _i.x1,
                                y1: _i.y1,
                                x2: _i.x2,
                                y2: _i.y2,
                                anchorPointX: _i.anchorPointX,
                                anchorPointY: _i.anchorPointY
                            }, mt.iconFeatureIndex = _i.featureIndex;
                            break;
                        }
                        for(var si = Qe; si < st; si++){
                            var Hi = y.get(si);
                            mt.verticalIconBox = {
                                x1: Hi.x1,
                                y1: Hi.y1,
                                x2: Hi.x2,
                                y2: Hi.y2,
                                anchorPointX: Hi.anchorPointX,
                                anchorPointY: Hi.anchorPointY
                            }, mt.verticalIconFeatureIndex = Hi.featureIndex;
                            break;
                        }
                        return mt;
                    }, ou.prototype.deserializeCollisionBoxes = function(y) {
                        this.collisionArrays = [];
                        for(var I = 0; I < this.symbolInstances.length; I++){
                            var U = this.symbolInstances.get(I);
                            this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(y, U.textBoxStartIndex, U.textBoxEndIndex, U.verticalTextBoxStartIndex, U.verticalTextBoxEndIndex, U.iconBoxStartIndex, U.iconBoxEndIndex, U.verticalIconBoxStartIndex, U.verticalIconBoxEndIndex));
                        }
                    }, ou.prototype.hasTextData = function() {
                        return this.text.segments.get().length > 0;
                    }, ou.prototype.hasIconData = function() {
                        return this.icon.segments.get().length > 0;
                    }, ou.prototype.hasDebugData = function() {
                        return this.textCollisionBox && this.iconCollisionBox;
                    }, ou.prototype.hasTextCollisionBoxData = function() {
                        return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
                    }, ou.prototype.hasIconCollisionBoxData = function() {
                        return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
                    }, ou.prototype.addIndicesForPlacedSymbol = function(y, I) {
                        for(var U = y.placedSymbolArray.get(I), J = U.vertexStartIndex + U.numGlyphs * 4, ne = U.vertexStartIndex; ne < J; ne += 4)y.indexArray.emplaceBack(ne, ne + 1, ne + 2), y.indexArray.emplaceBack(ne + 1, ne + 2, ne + 3);
                    }, ou.prototype.getSortedSymbolIndexes = function(y) {
                        if (this.sortedAngle === y && this.symbolInstanceIndexes !== void 0) return this.symbolInstanceIndexes;
                        for(var I = Math.sin(y), U = Math.cos(y), J = [], ne = [], fe = [], Fe = 0; Fe < this.symbolInstances.length; ++Fe){
                            fe.push(Fe);
                            var Qe = this.symbolInstances.get(Fe);
                            J.push(Math.round(I * Qe.anchorX + U * Qe.anchorY) | 0), ne.push(Qe.featureIndex);
                        }
                        return fe.sort(function(st, mt) {
                            return J[st] - J[mt] || ne[mt] - ne[st];
                        }), fe;
                    }, ou.prototype.addToSortKeyRanges = function(y, I) {
                        var U = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                        U && U.sortKey === I ? U.symbolInstanceEnd = y + 1 : this.sortKeyRanges.push({
                            sortKey: I,
                            symbolInstanceStart: y,
                            symbolInstanceEnd: y + 1
                        });
                    }, ou.prototype.sortFeatures = function(y) {
                        var I = this;
                        if (this.sortFeaturesByY && this.sortedAngle !== y && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                            this.symbolInstanceIndexes = this.getSortedSymbolIndexes(y), this.sortedAngle = y, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                            for(var U = 0, J = this.symbolInstanceIndexes; U < J.length; U += 1){
                                var ne = J[U], fe = this.symbolInstances.get(ne);
                                this.featureSortOrder.push(fe.featureIndex), [
                                    fe.rightJustifiedTextSymbolIndex,
                                    fe.centerJustifiedTextSymbolIndex,
                                    fe.leftJustifiedTextSymbolIndex
                                ].forEach(function(Fe, Qe, st) {
                                    Fe >= 0 && st.indexOf(Fe) === Qe && I.addIndicesForPlacedSymbol(I.text, Fe);
                                }), fe.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, fe.verticalPlacedTextSymbolIndex), fe.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, fe.placedIconSymbolIndex), fe.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, fe.verticalPlacedIconSymbolIndex);
                            }
                            this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                        }
                    }, Z("SymbolBucket", ou, {
                        omit: [
                            "layers",
                            "collisionBoxArray",
                            "features",
                            "compareText"
                        ]
                    }), ou.MAX_GLYPHS = 65535, ou.addDynamicAttributes = oq;
                    function _Qe(m, y) {
                        return y.replace(/{([^{}]+)}/g, function(I, U) {
                            return U in m ? String(m[U]) : "";
                        });
                    }
                    var xQe = new Oi({
                        "symbol-placement": new At(on.layout_symbol["symbol-placement"]),
                        "symbol-spacing": new At(on.layout_symbol["symbol-spacing"]),
                        "symbol-avoid-edges": new At(on.layout_symbol["symbol-avoid-edges"]),
                        "symbol-sort-key": new Er(on.layout_symbol["symbol-sort-key"]),
                        "symbol-z-order": new At(on.layout_symbol["symbol-z-order"]),
                        "icon-allow-overlap": new At(on.layout_symbol["icon-allow-overlap"]),
                        "icon-ignore-placement": new At(on.layout_symbol["icon-ignore-placement"]),
                        "icon-optional": new At(on.layout_symbol["icon-optional"]),
                        "icon-rotation-alignment": new At(on.layout_symbol["icon-rotation-alignment"]),
                        "icon-size": new Er(on.layout_symbol["icon-size"]),
                        "icon-text-fit": new At(on.layout_symbol["icon-text-fit"]),
                        "icon-text-fit-padding": new At(on.layout_symbol["icon-text-fit-padding"]),
                        "icon-image": new Er(on.layout_symbol["icon-image"]),
                        "icon-rotate": new Er(on.layout_symbol["icon-rotate"]),
                        "icon-padding": new At(on.layout_symbol["icon-padding"]),
                        "icon-keep-upright": new At(on.layout_symbol["icon-keep-upright"]),
                        "icon-offset": new Er(on.layout_symbol["icon-offset"]),
                        "icon-anchor": new Er(on.layout_symbol["icon-anchor"]),
                        "icon-pitch-alignment": new At(on.layout_symbol["icon-pitch-alignment"]),
                        "text-pitch-alignment": new At(on.layout_symbol["text-pitch-alignment"]),
                        "text-rotation-alignment": new At(on.layout_symbol["text-rotation-alignment"]),
                        "text-field": new Er(on.layout_symbol["text-field"]),
                        "text-font": new Er(on.layout_symbol["text-font"]),
                        "text-size": new Er(on.layout_symbol["text-size"]),
                        "text-max-width": new Er(on.layout_symbol["text-max-width"]),
                        "text-line-height": new At(on.layout_symbol["text-line-height"]),
                        "text-letter-spacing": new Er(on.layout_symbol["text-letter-spacing"]),
                        "text-justify": new Er(on.layout_symbol["text-justify"]),
                        "text-radial-offset": new Er(on.layout_symbol["text-radial-offset"]),
                        "text-variable-anchor": new At(on.layout_symbol["text-variable-anchor"]),
                        "text-anchor": new Er(on.layout_symbol["text-anchor"]),
                        "text-max-angle": new At(on.layout_symbol["text-max-angle"]),
                        "text-writing-mode": new At(on.layout_symbol["text-writing-mode"]),
                        "text-rotate": new Er(on.layout_symbol["text-rotate"]),
                        "text-padding": new At(on.layout_symbol["text-padding"]),
                        "text-keep-upright": new At(on.layout_symbol["text-keep-upright"]),
                        "text-transform": new Er(on.layout_symbol["text-transform"]),
                        "text-offset": new Er(on.layout_symbol["text-offset"]),
                        "text-allow-overlap": new At(on.layout_symbol["text-allow-overlap"]),
                        "text-ignore-placement": new At(on.layout_symbol["text-ignore-placement"]),
                        "text-optional": new At(on.layout_symbol["text-optional"])
                    }), bQe = new Oi({
                        "icon-opacity": new Er(on.paint_symbol["icon-opacity"]),
                        "icon-color": new Er(on.paint_symbol["icon-color"]),
                        "icon-halo-color": new Er(on.paint_symbol["icon-halo-color"]),
                        "icon-halo-width": new Er(on.paint_symbol["icon-halo-width"]),
                        "icon-halo-blur": new Er(on.paint_symbol["icon-halo-blur"]),
                        "icon-translate": new At(on.paint_symbol["icon-translate"]),
                        "icon-translate-anchor": new At(on.paint_symbol["icon-translate-anchor"]),
                        "text-opacity": new Er(on.paint_symbol["text-opacity"]),
                        "text-color": new Er(on.paint_symbol["text-color"], {
                            runtimeType: Tl,
                            getOverride: function(m) {
                                return m.textColor;
                            },
                            hasOverride: function(m) {
                                return !!m.textColor;
                            }
                        }),
                        "text-halo-color": new Er(on.paint_symbol["text-halo-color"]),
                        "text-halo-width": new Er(on.paint_symbol["text-halo-width"]),
                        "text-halo-blur": new Er(on.paint_symbol["text-halo-blur"]),
                        "text-translate": new At(on.paint_symbol["text-translate"]),
                        "text-translate-anchor": new At(on.paint_symbol["text-translate-anchor"])
                    }), sq = {
                        paint: bQe,
                        layout: xQe
                    }, Yw = function(y) {
                        this.type = y.property.overrides ? y.property.overrides.runtimeType : Ec, this.defaultValue = y;
                    };
                    Yw.prototype.evaluate = function(y) {
                        if (y.formattedSection) {
                            var I = this.defaultValue.property.overrides;
                            if (I && I.hasOverride(y.formattedSection)) return I.getOverride(y.formattedSection);
                        }
                        return y.feature && y.featureState ? this.defaultValue.evaluate(y.feature, y.featureState) : this.defaultValue.property.specification.default;
                    }, Yw.prototype.eachChild = function(y) {
                        if (!this.defaultValue.isConstant()) {
                            var I = this.defaultValue.value;
                            y(I._styleExpression.expression);
                        }
                    }, Yw.prototype.outputDefined = function() {
                        return !1;
                    }, Yw.prototype.serialize = function() {
                        return null;
                    }, Z("FormatSectionOverride", Yw, {
                        omit: [
                            "defaultValue"
                        ]
                    });
                    var wQe = function(m) {
                        function y(I) {
                            m.call(this, I, sq);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.recalculate = function(U, J) {
                            if (m.prototype.recalculate.call(this, U, J), this.layout.get("icon-rotation-alignment") === "auto" && (this.layout.get("symbol-placement") !== "point" ? this.layout._values["icon-rotation-alignment"] = "map" : this.layout._values["icon-rotation-alignment"] = "viewport"), this.layout.get("text-rotation-alignment") === "auto" && (this.layout.get("symbol-placement") !== "point" ? this.layout._values["text-rotation-alignment"] = "map" : this.layout._values["text-rotation-alignment"] = "viewport"), this.layout.get("text-pitch-alignment") === "auto" && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), this.layout.get("icon-pitch-alignment") === "auto" && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), this.layout.get("symbol-placement") === "point") {
                                var ne = this.layout.get("text-writing-mode");
                                if (ne) {
                                    for(var fe = [], Fe = 0, Qe = ne; Fe < Qe.length; Fe += 1){
                                        var st = Qe[Fe];
                                        fe.indexOf(st) < 0 && fe.push(st);
                                    }
                                    this.layout._values["text-writing-mode"] = fe;
                                } else this.layout._values["text-writing-mode"] = [
                                    "horizontal"
                                ];
                            }
                            this._setPaintOverrides();
                        }, y.prototype.getValueAndResolveTokens = function(U, J, ne, fe) {
                            var Fe = this.layout.get(U).evaluate(J, {}, ne, fe), Qe = this._unevaluatedLayout._values[U];
                            return !Qe.isDataDriven() && !Da(Qe.value) && Fe ? _Qe(J.properties, Fe) : Fe;
                        }, y.prototype.createBucket = function(U) {
                            return new ou(U);
                        }, y.prototype.queryRadius = function() {
                            return 0;
                        }, y.prototype.queryIntersectsFeature = function() {
                            return !1;
                        }, y.prototype._setPaintOverrides = function() {
                            for(var U = 0, J = sq.paint.overridableProperties; U < J.length; U += 1){
                                var ne = J[U];
                                if (y.hasPaintOverride(this.layout, ne)) {
                                    var fe = this.paint.get(ne), Fe = new Yw(fe), Qe = new Dc(Fe, fe.property.specification), st = null;
                                    fe.value.kind === "constant" || fe.value.kind === "source" ? st = new Jc("source", Qe) : st = new yc("composite", Qe, fe.value.zoomStops, fe.value._interpolationType), this.paint._values[ne] = new dl(fe.property, st, fe.parameters);
                                }
                            }
                        }, y.prototype._handleOverridablePaintPropertyUpdate = function(U, J, ne) {
                            return !this.layout || J.isDataDriven() || ne.isDataDriven() ? !1 : y.hasPaintOverride(this.layout, U);
                        }, y.hasPaintOverride = function(U, J) {
                            var ne = U.get("text-field"), fe = sq.paint.properties[J], Fe = !1, Qe = function(Xt) {
                                for(var ur = 0, nr = Xt; ur < nr.length; ur += 1){
                                    var Lr = nr[ur];
                                    if (fe.overrides && fe.overrides.hasOverride(Lr)) {
                                        Fe = !0;
                                        return;
                                    }
                                }
                            };
                            if (ne.value.kind === "constant" && ne.value.value instanceof Vl) Qe(ne.value.value.sections);
                            else if (ne.value.kind === "source") {
                                var st = function(Xt) {
                                    if (!Fe) {
                                        if (Xt instanceof hs && ws(Xt.value) === Al) {
                                            var ur = Xt.value;
                                            Qe(ur.sections);
                                        } else Xt instanceof ec ? Qe(Xt.sections) : Xt.eachChild(st);
                                    }
                                }, mt = ne.value;
                                mt._styleExpression && st(mt._styleExpression.expression);
                            }
                            return Fe;
                        }, y;
                    }(cn), TQe = new Oi({
                        "background-color": new At(on.paint_background["background-color"]),
                        "background-pattern": new wi(on.paint_background["background-pattern"]),
                        "background-opacity": new At(on.paint_background["background-opacity"])
                    }), AQe = {
                        paint: TQe
                    }, SQe = function(m) {
                        function y(I) {
                            m.call(this, I, AQe);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y;
                    }(cn), MQe = new Oi({
                        "raster-opacity": new At(on.paint_raster["raster-opacity"]),
                        "raster-hue-rotate": new At(on.paint_raster["raster-hue-rotate"]),
                        "raster-brightness-min": new At(on.paint_raster["raster-brightness-min"]),
                        "raster-brightness-max": new At(on.paint_raster["raster-brightness-max"]),
                        "raster-saturation": new At(on.paint_raster["raster-saturation"]),
                        "raster-contrast": new At(on.paint_raster["raster-contrast"]),
                        "raster-resampling": new At(on.paint_raster["raster-resampling"]),
                        "raster-fade-duration": new At(on.paint_raster["raster-fade-duration"])
                    }), EQe = {
                        paint: MQe
                    }, kQe = function(m) {
                        function y(I) {
                            m.call(this, I, EQe);
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y;
                    }(cn);
                    function CQe(m) {
                        var y = [], I = m.id;
                        return I === void 0 && y.push({
                            message: "layers." + I + ': missing required property "id"'
                        }), m.render === void 0 && y.push({
                            message: "layers." + I + ': missing required method "render"'
                        }), m.renderingMode && m.renderingMode !== "2d" && m.renderingMode !== "3d" && y.push({
                            message: "layers." + I + ': property "renderingMode" must be either "2d" or "3d"'
                        }), y;
                    }
                    var LQe = function(m) {
                        function y(I) {
                            m.call(this, I, {}), this.implementation = I;
                        }
                        return m && (y.__proto__ = m), y.prototype = Object.create(m && m.prototype), y.prototype.constructor = y, y.prototype.is3D = function() {
                            return this.implementation.renderingMode === "3d";
                        }, y.prototype.hasOffscreenPass = function() {
                            return this.implementation.prerender !== void 0;
                        }, y.prototype.recalculate = function() {}, y.prototype.updateTransitions = function() {}, y.prototype.hasTransition = function() {}, y.prototype.serialize = function() {}, y.prototype.onAdd = function(U) {
                            this.implementation.onAdd && this.implementation.onAdd(U, U.painter.context.gl);
                        }, y.prototype.onRemove = function(U) {
                            this.implementation.onRemove && this.implementation.onRemove(U, U.painter.context.gl);
                        }, y;
                    }(cn), PQe = {
                        circle: O9,
                        heatmap: Lw,
                        hillshade: dC,
                        fill: Qx,
                        "fill-extrusion": fm,
                        line: S,
                        symbol: wQe,
                        background: SQe,
                        raster: kQe
                    };
                    function IQe(m) {
                        return m.type === "custom" ? new LQe(m) : new PQe[m.type](m);
                    }
                    var IQ = f.HTMLImageElement, RQ = f.HTMLCanvasElement, DQ = f.HTMLVideoElement, zQ = f.ImageData, XC = f.ImageBitmap, ib = function(y, I, U, J) {
                        this.context = y, this.format = U, this.texture = y.gl.createTexture(), this.update(I, J);
                    };
                    ib.prototype.update = function(y, I, U) {
                        var J = y.width, ne = y.height, fe = (!this.size || this.size[0] !== J || this.size[1] !== ne) && !U, Fe = this, Qe = Fe.context, st = Qe.gl;
                        if (this.useMipmap = !!(I && I.useMipmap), st.bindTexture(st.TEXTURE_2D, this.texture), Qe.pixelStoreUnpackFlipY.set(!1), Qe.pixelStoreUnpack.set(1), Qe.pixelStoreUnpackPremultiplyAlpha.set(this.format === st.RGBA && (!I || I.premultiply !== !1)), fe) this.size = [
                            J,
                            ne
                        ], y instanceof IQ || y instanceof RQ || y instanceof DQ || y instanceof zQ || XC && y instanceof XC ? st.texImage2D(st.TEXTURE_2D, 0, this.format, this.format, st.UNSIGNED_BYTE, y) : st.texImage2D(st.TEXTURE_2D, 0, this.format, J, ne, 0, this.format, st.UNSIGNED_BYTE, y.data);
                        else {
                            var mt = U || {
                                x: 0,
                                y: 0
                            }, Xt = mt.x, ur = mt.y;
                            y instanceof IQ || y instanceof RQ || y instanceof DQ || y instanceof zQ || XC && y instanceof XC ? st.texSubImage2D(st.TEXTURE_2D, 0, Xt, ur, st.RGBA, st.UNSIGNED_BYTE, y) : st.texSubImage2D(st.TEXTURE_2D, 0, Xt, ur, J, ne, st.RGBA, st.UNSIGNED_BYTE, y.data);
                        }
                        this.useMipmap && this.isSizePowerOfTwo() && st.generateMipmap(st.TEXTURE_2D);
                    }, ib.prototype.bind = function(y, I, U) {
                        var J = this, ne = J.context, fe = ne.gl;
                        fe.bindTexture(fe.TEXTURE_2D, this.texture), U === fe.LINEAR_MIPMAP_NEAREST && !this.isSizePowerOfTwo() && (U = fe.LINEAR), y !== this.filter && (fe.texParameteri(fe.TEXTURE_2D, fe.TEXTURE_MAG_FILTER, y), fe.texParameteri(fe.TEXTURE_2D, fe.TEXTURE_MIN_FILTER, U || y), this.filter = y), I !== this.wrap && (fe.texParameteri(fe.TEXTURE_2D, fe.TEXTURE_WRAP_S, I), fe.texParameteri(fe.TEXTURE_2D, fe.TEXTURE_WRAP_T, I), this.wrap = I);
                    }, ib.prototype.isSizePowerOfTwo = function() {
                        return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 === 0;
                    }, ib.prototype.destroy = function() {
                        var y = this.context, I = y.gl;
                        I.deleteTexture(this.texture), this.texture = null;
                    };
                    var lq = function(y) {
                        var I = this;
                        this._callback = y, this._triggered = !1, typeof MessageChannel != "undefined" && (this._channel = new MessageChannel, this._channel.port2.onmessage = function() {
                            I._triggered = !1, I._callback();
                        });
                    };
                    lq.prototype.trigger = function() {
                        var y = this;
                        this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(function() {
                            y._triggered = !1, y._callback();
                        }, 0));
                    }, lq.prototype.remove = function() {
                        delete this._channel, this._callback = function() {};
                    };
                    var Kw = function(y, I, U) {
                        this.target = y, this.parent = I, this.mapId = U, this.callbacks = {}, this.tasks = {}, this.taskQueue = [], this.cancelCallbacks = {}, q([
                            "receive",
                            "process"
                        ], this), this.invoker = new lq(this.process), this.target.addEventListener("message", this.receive, !1), this.globalScope = ke() ? y : f;
                    };
                    Kw.prototype.send = function(y, I, U, J, ne) {
                        var fe = this;
                        ne === void 0 && (ne = !1);
                        var Fe = Math.round(Math.random() * 1e18).toString(36).substring(0, 10);
                        U && (this.callbacks[Fe] = U);
                        var Qe = Te(this.globalScope) ? void 0 : [];
                        return this.target.postMessage({
                            id: Fe,
                            type: y,
                            hasCallback: !!U,
                            targetMapId: J,
                            mustQueue: ne,
                            sourceMapId: this.mapId,
                            data: Ue(I, Qe)
                        }, Qe), {
                            cancel: function() {
                                U && delete fe.callbacks[Fe], fe.target.postMessage({
                                    id: Fe,
                                    type: "<cancel>",
                                    targetMapId: J,
                                    sourceMapId: fe.mapId
                                });
                            }
                        };
                    }, Kw.prototype.receive = function(y) {
                        var I = y.data, U = I.id;
                        if (U && !(I.targetMapId && this.mapId !== I.targetMapId)) {
                            if (I.type === "<cancel>") {
                                delete this.tasks[U];
                                var J = this.cancelCallbacks[U];
                                delete this.cancelCallbacks[U], J && J();
                            } else ke() || I.mustQueue ? (this.tasks[U] = I, this.taskQueue.push(U), this.invoker.trigger()) : this.processTask(U, I);
                        }
                    }, Kw.prototype.process = function() {
                        if (this.taskQueue.length) {
                            var y = this.taskQueue.shift(), I = this.tasks[y];
                            delete this.tasks[y], this.taskQueue.length && this.invoker.trigger(), I && this.processTask(y, I);
                        }
                    }, Kw.prototype.processTask = function(y, I) {
                        var U = this;
                        if (I.type === "<response>") {
                            var J = this.callbacks[y];
                            delete this.callbacks[y], J && (I.error ? J(We(I.error)) : J(null, We(I.data)));
                        } else {
                            var ne = !1, fe = Te(this.globalScope) ? void 0 : [], Fe = I.hasCallback ? function(ur, nr) {
                                ne = !0, delete U.cancelCallbacks[y], U.target.postMessage({
                                    id: y,
                                    type: "<response>",
                                    sourceMapId: U.mapId,
                                    error: ur ? Ue(ur) : null,
                                    data: Ue(nr, fe)
                                }, fe);
                            } : function(ur) {
                                ne = !0;
                            }, Qe = null, st = We(I.data);
                            if (this.parent[I.type]) Qe = this.parent[I.type](I.sourceMapId, st, Fe);
                            else if (this.parent.getWorkerSource) {
                                var mt = I.type.split("."), Xt = this.parent.getWorkerSource(I.sourceMapId, mt[0], st.source);
                                Qe = Xt[mt[1]](st, Fe);
                            } else Fe(new Error("Could not find function " + I.type));
                            !ne && Qe && Qe.cancel && (this.cancelCallbacks[y] = Qe.cancel);
                        }
                    }, Kw.prototype.remove = function() {
                        this.invoker.remove(), this.target.removeEventListener("message", this.receive, !1);
                    };
                    function RQe(m, y, I) {
                        y = Math.pow(2, I) - y - 1;
                        var U = FQ(m * 256, y * 256, I), J = FQ((m + 1) * 256, (y + 1) * 256, I);
                        return U[0] + "," + U[1] + "," + J[0] + "," + J[1];
                    }
                    function FQ(m, y, I) {
                        var U = 2 * Math.PI * 6378137 / 256 / Math.pow(2, I), J = m * U - 2 * Math.PI * 6378137 / 2, ne = y * U - 2 * Math.PI * 6378137 / 2;
                        return [
                            J,
                            ne
                        ];
                    }
                    var jf = function(y, I) {
                        y && (I ? this.setSouthWest(y).setNorthEast(I) : y.length === 4 ? this.setSouthWest([
                            y[0],
                            y[1]
                        ]).setNorthEast([
                            y[2],
                            y[3]
                        ]) : this.setSouthWest(y[0]).setNorthEast(y[1]));
                    };
                    jf.prototype.setNorthEast = function(y) {
                        return this._ne = y instanceof sc ? new sc(y.lng, y.lat) : sc.convert(y), this;
                    }, jf.prototype.setSouthWest = function(y) {
                        return this._sw = y instanceof sc ? new sc(y.lng, y.lat) : sc.convert(y), this;
                    }, jf.prototype.extend = function(y) {
                        var I = this._sw, U = this._ne, J, ne;
                        if (y instanceof sc) J = y, ne = y;
                        else if (y instanceof jf) {
                            if (J = y._sw, ne = y._ne, !J || !ne) return this;
                        } else {
                            if (Array.isArray(y)) {
                                if (y.length === 4 || y.every(Array.isArray)) {
                                    var fe = y;
                                    return this.extend(jf.convert(fe));
                                } else {
                                    var Fe = y;
                                    return this.extend(sc.convert(Fe));
                                }
                            }
                            return this;
                        }
                        return !I && !U ? (this._sw = new sc(J.lng, J.lat), this._ne = new sc(ne.lng, ne.lat)) : (I.lng = Math.min(J.lng, I.lng), I.lat = Math.min(J.lat, I.lat), U.lng = Math.max(ne.lng, U.lng), U.lat = Math.max(ne.lat, U.lat)), this;
                    }, jf.prototype.getCenter = function() {
                        return new sc((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
                    }, jf.prototype.getSouthWest = function() {
                        return this._sw;
                    }, jf.prototype.getNorthEast = function() {
                        return this._ne;
                    }, jf.prototype.getNorthWest = function() {
                        return new sc(this.getWest(), this.getNorth());
                    }, jf.prototype.getSouthEast = function() {
                        return new sc(this.getEast(), this.getSouth());
                    }, jf.prototype.getWest = function() {
                        return this._sw.lng;
                    }, jf.prototype.getSouth = function() {
                        return this._sw.lat;
                    }, jf.prototype.getEast = function() {
                        return this._ne.lng;
                    }, jf.prototype.getNorth = function() {
                        return this._ne.lat;
                    }, jf.prototype.toArray = function() {
                        return [
                            this._sw.toArray(),
                            this._ne.toArray()
                        ];
                    }, jf.prototype.toString = function() {
                        return "LngLatBounds(" + this._sw.toString() + ", " + this._ne.toString() + ")";
                    }, jf.prototype.isEmpty = function() {
                        return !(this._sw && this._ne);
                    }, jf.prototype.contains = function(y) {
                        var I = sc.convert(y), U = I.lng, J = I.lat, ne = this._sw.lat <= J && J <= this._ne.lat, fe = this._sw.lng <= U && U <= this._ne.lng;
                        return this._sw.lng > this._ne.lng && (fe = this._sw.lng >= U && U >= this._ne.lng), ne && fe;
                    }, jf.convert = function(y) {
                        return !y || y instanceof jf ? y : new jf(y);
                    };
                    var qQ = 63710088e-1, sc = function(y, I) {
                        if (isNaN(y) || isNaN(I)) throw new Error("Invalid LngLat object: (" + y + ", " + I + ")");
                        if (this.lng = +y, this.lat = +I, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
                    };
                    sc.prototype.wrap = function() {
                        return new sc(E(this.lng, -180, 180), this.lat);
                    }, sc.prototype.toArray = function() {
                        return [
                            this.lng,
                            this.lat
                        ];
                    }, sc.prototype.toString = function() {
                        return "LngLat(" + this.lng + ", " + this.lat + ")";
                    }, sc.prototype.distanceTo = function(y) {
                        var I = Math.PI / 180, U = this.lat * I, J = y.lat * I, ne = Math.sin(U) * Math.sin(J) + Math.cos(U) * Math.cos(J) * Math.cos((y.lng - this.lng) * I), fe = qQ * Math.acos(Math.min(ne, 1));
                        return fe;
                    }, sc.prototype.toBounds = function(y) {
                        y === void 0 && (y = 0);
                        var I = 40075017, U = 360 * y / I, J = U / Math.cos(Math.PI / 180 * this.lat);
                        return new jf(new sc(this.lng - J, this.lat - U), new sc(this.lng + J, this.lat + U));
                    }, sc.convert = function(y) {
                        if (y instanceof sc) return y;
                        if (Array.isArray(y) && (y.length === 2 || y.length === 3)) return new sc(Number(y[0]), Number(y[1]));
                        if (!Array.isArray(y) && typeof y == "object" && y !== null) return new sc(Number("lng" in y ? y.lng : y.lon), Number(y.lat));
                        throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
                    };
                    var OQ = 2 * Math.PI * qQ;
                    function BQ(m) {
                        return OQ * Math.cos(m * Math.PI / 180);
                    }
                    function NQ(m) {
                        return (180 + m) / 360;
                    }
                    function UQ(m) {
                        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + m * Math.PI / 360))) / 360;
                    }
                    function VQ(m, y) {
                        return m / BQ(y);
                    }
                    function DQe(m) {
                        return m * 360 - 180;
                    }
                    function uq(m) {
                        var y = 180 - m * 360;
                        return 360 / Math.PI * Math.atan(Math.exp(y * Math.PI / 180)) - 90;
                    }
                    function zQe(m, y) {
                        return m * BQ(uq(y));
                    }
                    function FQe(m) {
                        return 1 / Math.cos(m * Math.PI / 180);
                    }
                    var nb = function(y, I, U) {
                        U === void 0 && (U = 0), this.x = +y, this.y = +I, this.z = +U;
                    };
                    nb.fromLngLat = function(y, I) {
                        I === void 0 && (I = 0);
                        var U = sc.convert(y);
                        return new nb(NQ(U.lng), UQ(U.lat), VQ(I, U.lat));
                    }, nb.prototype.toLngLat = function() {
                        return new sc(DQe(this.x), uq(this.y));
                    }, nb.prototype.toAltitude = function() {
                        return zQe(this.z, this.y);
                    }, nb.prototype.meterInMercatorCoordinateUnits = function() {
                        return 1 / OQ * FQe(uq(this.y));
                    };
                    var ab = function(y, I, U) {
                        this.z = y, this.x = I, this.y = U, this.key = AS(0, y, y, I, U);
                    };
                    ab.prototype.equals = function(y) {
                        return this.z === y.z && this.x === y.x && this.y === y.y;
                    }, ab.prototype.url = function(y, I) {
                        var U = RQe(this.x, this.y, this.z), J = qQe(this.z, this.x, this.y);
                        return y[(this.x + this.y) % y.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace("{z}", String(this.z)).replace("{x}", String(this.x)).replace("{y}", String(I === "tms" ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", J).replace("{bbox-epsg-3857}", U);
                    }, ab.prototype.getTilePoint = function(y) {
                        var I = Math.pow(2, this.z);
                        return new u((y.x * I - this.x) * rn, (y.y * I - this.y) * rn);
                    }, ab.prototype.toString = function() {
                        return this.z + "/" + this.x + "/" + this.y;
                    };
                    var HQ = function(y, I) {
                        this.wrap = y, this.canonical = I, this.key = AS(y, I.z, I.z, I.x, I.y);
                    }, Wf = function(y, I, U, J, ne) {
                        this.overscaledZ = y, this.wrap = I, this.canonical = new ab(U, +J, +ne), this.key = AS(I, y, U, J, ne);
                    };
                    Wf.prototype.equals = function(y) {
                        return this.overscaledZ === y.overscaledZ && this.wrap === y.wrap && this.canonical.equals(y.canonical);
                    }, Wf.prototype.scaledTo = function(y) {
                        var I = this.canonical.z - y;
                        return y > this.canonical.z ? new Wf(y, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Wf(y, this.wrap, y, this.canonical.x >> I, this.canonical.y >> I);
                    }, Wf.prototype.calculateScaledKey = function(y, I) {
                        var U = this.canonical.z - y;
                        return y > this.canonical.z ? AS(this.wrap * +I, y, this.canonical.z, this.canonical.x, this.canonical.y) : AS(this.wrap * +I, y, y, this.canonical.x >> U, this.canonical.y >> U);
                    }, Wf.prototype.isChildOf = function(y) {
                        if (y.wrap !== this.wrap) return !1;
                        var I = this.canonical.z - y.canonical.z;
                        return y.overscaledZ === 0 || y.overscaledZ < this.overscaledZ && y.canonical.x === this.canonical.x >> I && y.canonical.y === this.canonical.y >> I;
                    }, Wf.prototype.children = function(y) {
                        if (this.overscaledZ >= y) return [
                            new Wf(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                        ];
                        var I = this.canonical.z + 1, U = this.canonical.x * 2, J = this.canonical.y * 2;
                        return [
                            new Wf(I, this.wrap, I, U, J),
                            new Wf(I, this.wrap, I, U + 1, J),
                            new Wf(I, this.wrap, I, U, J + 1),
                            new Wf(I, this.wrap, I, U + 1, J + 1)
                        ];
                    }, Wf.prototype.isLessThan = function(y) {
                        return this.wrap < y.wrap ? !0 : this.wrap > y.wrap ? !1 : this.overscaledZ < y.overscaledZ ? !0 : this.overscaledZ > y.overscaledZ ? !1 : this.canonical.x < y.canonical.x ? !0 : this.canonical.x > y.canonical.x ? !1 : this.canonical.y < y.canonical.y;
                    }, Wf.prototype.wrapped = function() {
                        return new Wf(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
                    }, Wf.prototype.unwrapTo = function(y) {
                        return new Wf(this.overscaledZ, y, this.canonical.z, this.canonical.x, this.canonical.y);
                    }, Wf.prototype.overscaleFactor = function() {
                        return Math.pow(2, this.overscaledZ - this.canonical.z);
                    }, Wf.prototype.toUnwrapped = function() {
                        return new HQ(this.wrap, this.canonical);
                    }, Wf.prototype.toString = function() {
                        return this.overscaledZ + "/" + this.canonical.x + "/" + this.canonical.y;
                    }, Wf.prototype.getTilePoint = function(y) {
                        return this.canonical.getTilePoint(new nb(y.x - this.wrap, y.y));
                    };
                    function AS(m, y, I, U, J) {
                        m *= 2, m < 0 && (m = m * -1 - 1);
                        var ne = 1 << I;
                        return (ne * ne * m + ne * J + U).toString(36) + I.toString(36) + y.toString(36);
                    }
                    function qQe(m, y, I) {
                        for(var U = "", J, ne = m; ne > 0; ne--)J = 1 << ne - 1, U += (y & J ? 1 : 0) + (I & J ? 2 : 0);
                        return U;
                    }
                    Z("CanonicalTileID", ab), Z("OverscaledTileID", Wf, {
                        omit: [
                            "posMatrix"
                        ]
                    });
                    var dy = function(y, I, U) {
                        if (this.uid = y, I.height !== I.width) throw new RangeError("DEM tiles must be square");
                        if (U && U !== "mapbox" && U !== "terrarium") return re('"' + U + '" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');
                        this.stride = I.height;
                        var J = this.dim = I.height - 2;
                        this.data = new Uint32Array(I.data.buffer), this.encoding = U || "mapbox";
                        for(var ne = 0; ne < J; ne++)this.data[this._idx(-1, ne)] = this.data[this._idx(0, ne)], this.data[this._idx(J, ne)] = this.data[this._idx(J - 1, ne)], this.data[this._idx(ne, -1)] = this.data[this._idx(ne, 0)], this.data[this._idx(ne, J)] = this.data[this._idx(ne, J - 1)];
                        this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(J, -1)] = this.data[this._idx(J - 1, 0)], this.data[this._idx(-1, J)] = this.data[this._idx(0, J - 1)], this.data[this._idx(J, J)] = this.data[this._idx(J - 1, J - 1)];
                    };
                    dy.prototype.get = function(y, I) {
                        var U = new Uint8Array(this.data.buffer), J = this._idx(y, I) * 4, ne = this.encoding === "terrarium" ? this._unpackTerrarium : this._unpackMapbox;
                        return ne(U[J], U[J + 1], U[J + 2]);
                    }, dy.prototype.getUnpackVector = function() {
                        return this.encoding === "terrarium" ? [
                            256,
                            1,
                            1 / 256,
                            32768
                        ] : [
                            6553.6,
                            25.6,
                            .1,
                            1e4
                        ];
                    }, dy.prototype._idx = function(y, I) {
                        if (y < -1 || y >= this.dim + 1 || I < -1 || I >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                        return (I + 1) * this.stride + (y + 1);
                    }, dy.prototype._unpackMapbox = function(y, I, U) {
                        return (y * 65536 + I * 256 + U) / 10 - 1e4;
                    }, dy.prototype._unpackTerrarium = function(y, I, U) {
                        return y * 256 + I + U / 256 - 32768;
                    }, dy.prototype.getPixels = function() {
                        return new lh({
                            width: this.stride,
                            height: this.stride
                        }, new Uint8Array(this.data.buffer));
                    }, dy.prototype.backfillBorder = function(y, I, U) {
                        if (this.dim !== y.dim) throw new Error("dem dimension mismatch");
                        var J = I * this.dim, ne = I * this.dim + this.dim, fe = U * this.dim, Fe = U * this.dim + this.dim;
                        switch(I){
                            case -1:
                                J = ne - 1;
                                break;
                            case 1:
                                ne = J + 1;
                                break;
                        }
                        switch(U){
                            case -1:
                                fe = Fe - 1;
                                break;
                            case 1:
                                Fe = fe + 1;
                                break;
                        }
                        for(var Qe = -I * this.dim, st = -U * this.dim, mt = fe; mt < Fe; mt++)for(var Xt = J; Xt < ne; Xt++)this.data[this._idx(Xt, mt)] = y.data[this._idx(Xt + Qe, mt + st)];
                    }, Z("DEMData", dy);
                    function OQe(m, y) {
                        var I = {};
                        if (!y) return I;
                        for(var U = function() {
                            var fe = ne[J], Fe = fe.layerIds.map(function(Xt) {
                                return y.getLayer(Xt);
                            }).filter(Boolean);
                            if (Fe.length !== 0) {
                                fe.layers = Fe, fe.stateDependentLayerIds && (fe.stateDependentLayers = fe.stateDependentLayerIds.map(function(Xt) {
                                    return Fe.filter(function(ur) {
                                        return ur.id === Xt;
                                    })[0];
                                }));
                                for(var Qe = 0, st = Fe; Qe < st.length; Qe += 1){
                                    var mt = st[Qe];
                                    I[mt.id] = fe;
                                }
                            }
                        }, J = 0, ne = m; J < ne.length; J += 1)U();
                        return I;
                    }
                    var YC = function(y) {
                        this._stringToNumber = {}, this._numberToString = [];
                        for(var I = 0; I < y.length; I++){
                            var U = y[I];
                            this._stringToNumber[U] = I, this._numberToString[I] = U;
                        }
                    };
                    YC.prototype.encode = function(y) {
                        return this._stringToNumber[y];
                    }, YC.prototype.decode = function(y) {
                        return this._numberToString[y];
                    };
                    var KC = function(y, I, U, J, ne) {
                        this.type = "Feature", this._vectorTileFeature = y, y._z = I, y._x = U, y._y = J, this.properties = y.properties, this.id = ne;
                    }, cq = {
                        geometry: {
                            configurable: !0
                        }
                    };
                    cq.geometry.get = function() {
                        return this._geometry === void 0 && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
                    }, cq.geometry.set = function(m) {
                        this._geometry = m;
                    }, KC.prototype.toJSON = function() {
                        var y = {
                            geometry: this.geometry
                        };
                        for(var I in this)I === "_geometry" || I === "_vectorTileFeature" || (y[I] = this[I]);
                        return y;
                    }, Object.defineProperties(KC.prototype, cq);
                    var Jw = function() {
                        this.state = {}, this.stateChanges = {}, this.deletedStates = {};
                    };
                    Jw.prototype.updateState = function(y, I, U) {
                        var J = String(I);
                        if (this.stateChanges[y] = this.stateChanges[y] || {}, this.stateChanges[y][J] = this.stateChanges[y][J] || {}, _(this.stateChanges[y][J], U), this.deletedStates[y] === null) {
                            this.deletedStates[y] = {};
                            for(var ne in this.state[y])ne !== J && (this.deletedStates[y][ne] = null);
                        } else {
                            var fe = this.deletedStates[y] && this.deletedStates[y][J] === null;
                            if (fe) {
                                this.deletedStates[y][J] = {};
                                for(var Fe in this.state[y][J])U[Fe] || (this.deletedStates[y][J][Fe] = null);
                            } else for(var Qe in U){
                                var st = this.deletedStates[y] && this.deletedStates[y][J] && this.deletedStates[y][J][Qe] === null;
                                st && delete this.deletedStates[y][J][Qe];
                            }
                        }
                    }, Jw.prototype.removeFeatureState = function(y, I, U) {
                        var J = this.deletedStates[y] === null;
                        if (!J) {
                            var ne = String(I);
                            if (this.deletedStates[y] = this.deletedStates[y] || {}, U && I !== void 0) this.deletedStates[y][ne] !== null && (this.deletedStates[y][ne] = this.deletedStates[y][ne] || {}, this.deletedStates[y][ne][U] = null);
                            else if (I !== void 0) {
                                var fe = this.stateChanges[y] && this.stateChanges[y][ne];
                                if (fe) {
                                    this.deletedStates[y][ne] = {};
                                    for(U in this.stateChanges[y][ne])this.deletedStates[y][ne][U] = null;
                                } else this.deletedStates[y][ne] = null;
                            } else this.deletedStates[y] = null;
                        }
                    }, Jw.prototype.getState = function(y, I) {
                        var U = String(I), J = this.state[y] || {}, ne = this.stateChanges[y] || {}, fe = _({}, J[U], ne[U]);
                        if (this.deletedStates[y] === null) return {};
                        if (this.deletedStates[y]) {
                            var Fe = this.deletedStates[y][I];
                            if (Fe === null) return {};
                            for(var Qe in Fe)delete fe[Qe];
                        }
                        return fe;
                    }, Jw.prototype.initializeTileState = function(y, I) {
                        y.setFeatureState(this.state, I);
                    }, Jw.prototype.coalesceChanges = function(y, I) {
                        var U = {};
                        for(var J in this.stateChanges){
                            this.state[J] = this.state[J] || {};
                            var ne = {};
                            for(var fe in this.stateChanges[J])this.state[J][fe] || (this.state[J][fe] = {}), _(this.state[J][fe], this.stateChanges[J][fe]), ne[fe] = this.state[J][fe];
                            U[J] = ne;
                        }
                        for(var Fe in this.deletedStates){
                            this.state[Fe] = this.state[Fe] || {};
                            var Qe = {};
                            if (this.deletedStates[Fe] === null) for(var st in this.state[Fe])Qe[st] = {}, this.state[Fe][st] = {};
                            else for(var mt in this.deletedStates[Fe]){
                                var Xt = this.deletedStates[Fe][mt] === null;
                                if (Xt) this.state[Fe][mt] = {};
                                else for(var ur = 0, nr = Object.keys(this.deletedStates[Fe][mt]); ur < nr.length; ur += 1){
                                    var Lr = nr[ur];
                                    delete this.state[Fe][mt][Lr];
                                }
                                Qe[mt] = this.state[Fe][mt];
                            }
                            U[Fe] = U[Fe] || {}, _(U[Fe], Qe);
                        }
                        if (this.stateChanges = {}, this.deletedStates = {}, Object.keys(U).length !== 0) for(var Yr in y){
                            var _i = y[Yr];
                            _i.setFeatureState(U, I);
                        }
                    };
                    var vy = function(y, I) {
                        this.tileID = y, this.x = y.canonical.x, this.y = y.canonical.y, this.z = y.canonical.z, this.grid = new cu(rn, 16, 0), this.grid3D = new cu(rn, 16, 0), this.featureIndexArray = new ef, this.promoteId = I;
                    };
                    vy.prototype.insert = function(y, I, U, J, ne, fe) {
                        var Fe = this.featureIndexArray.length;
                        this.featureIndexArray.emplaceBack(U, J, ne);
                        for(var Qe = fe ? this.grid3D : this.grid, st = 0; st < I.length; st++){
                            for(var mt = I[st], Xt = [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ], ur = 0; ur < mt.length; ur++){
                                var nr = mt[ur];
                                Xt[0] = Math.min(Xt[0], nr.x), Xt[1] = Math.min(Xt[1], nr.y), Xt[2] = Math.max(Xt[2], nr.x), Xt[3] = Math.max(Xt[3], nr.y);
                            }
                            Xt[0] < rn && Xt[1] < rn && Xt[2] >= 0 && Xt[3] >= 0 && Qe.insert(Fe, Xt[0], Xt[1], Xt[2], Xt[3]);
                        }
                    }, vy.prototype.loadVTLayers = function() {
                        return this.vtLayers || (this.vtLayers = new pg.VectorTile(new La(this.rawTileData)).layers, this.sourceLayerCoder = new YC(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                            "_geojsonTileLayer"
                        ])), this.vtLayers;
                    }, vy.prototype.query = function(y, I, U, J) {
                        var ne = this;
                        this.loadVTLayers();
                        for(var fe = y.params || {}, Fe = rn / y.tileSize / y.scale, Qe = be(fe.filter), st = y.queryGeometry, mt = y.queryPadding * Fe, Xt = jQ(st), ur = this.grid.query(Xt.minX - mt, Xt.minY - mt, Xt.maxX + mt, Xt.maxY + mt), nr = jQ(y.cameraQueryGeometry), Lr = this.grid3D.query(nr.minX - mt, nr.minY - mt, nr.maxX + mt, nr.maxY + mt, function(An, ra, $n, Ba) {
                            return pp(y.cameraQueryGeometry, An - mt, ra - mt, $n + mt, Ba + mt);
                        }), Yr = 0, _i = Lr; Yr < _i.length; Yr += 1){
                            var si = _i[Yr];
                            ur.push(si);
                        }
                        ur.sort(BQe);
                        for(var Hi = {}, Ei, Vi = function(An) {
                            var ra = ur[An];
                            if (ra !== Ei) {
                                Ei = ra;
                                var $n = ne.featureIndexArray.get(ra), Ba = null;
                                ne.loadMatchingFeature(Hi, $n.bucketIndex, $n.sourceLayerIndex, $n.featureIndex, Qe, fe.layers, fe.availableImages, I, U, J, function(_a, Pa, qo) {
                                    return Ba || (Ba = da(_a)), Pa.queryIntersectsFeature(st, _a, qo, Ba, ne.z, y.transform, Fe, y.pixelPosMatrix);
                                });
                            }
                        }, en = 0; en < ur.length; en++)Vi(en);
                        return Hi;
                    }, vy.prototype.loadMatchingFeature = function(y, I, U, J, ne, fe, Fe, Qe, st, mt, Xt) {
                        var ur = this.bucketLayerIDs[I];
                        if (!(fe && !N(fe, ur))) {
                            var nr = this.sourceLayerCoder.decode(U), Lr = this.vtLayers[nr], Yr = Lr.feature(J);
                            if (ne.needGeometry) {
                                var _i = No(Yr, !0);
                                if (!ne.filter(new pn(this.tileID.overscaledZ), _i, this.tileID.canonical)) return;
                            } else if (!ne.filter(new pn(this.tileID.overscaledZ), Yr)) return;
                            for(var si = this.getId(Yr, nr), Hi = 0; Hi < ur.length; Hi++){
                                var Ei = ur[Hi];
                                if (!(fe && fe.indexOf(Ei) < 0)) {
                                    var Vi = Qe[Ei];
                                    if (Vi) {
                                        var en = {};
                                        si !== void 0 && mt && (en = mt.getState(Vi.sourceLayer || "_geojsonTileLayer", si));
                                        var An = _({}, st[Ei]);
                                        An.paint = GQ(An.paint, Vi.paint, Yr, en, Fe), An.layout = GQ(An.layout, Vi.layout, Yr, en, Fe);
                                        var ra = !Xt || Xt(Yr, Vi, en);
                                        if (ra) {
                                            var $n = new KC(Yr, this.z, this.x, this.y, si);
                                            $n.layer = An;
                                            var Ba = y[Ei];
                                            Ba === void 0 && (Ba = y[Ei] = []), Ba.push({
                                                featureIndex: J,
                                                feature: $n,
                                                intersectionZ: ra
                                            });
                                        }
                                    }
                                }
                            }
                        }
                    }, vy.prototype.lookupSymbolFeatures = function(y, I, U, J, ne, fe, Fe, Qe) {
                        var st = {};
                        this.loadVTLayers();
                        for(var mt = be(ne), Xt = 0, ur = y; Xt < ur.length; Xt += 1){
                            var nr = ur[Xt];
                            this.loadMatchingFeature(st, U, J, nr, mt, fe, Fe, Qe, I);
                        }
                        return st;
                    }, vy.prototype.hasLayer = function(y) {
                        for(var I = 0, U = this.bucketLayerIDs; I < U.length; I += 1)for(var J = U[I], ne = 0, fe = J; ne < fe.length; ne += 1){
                            var Fe = fe[ne];
                            if (y === Fe) return !0;
                        }
                        return !1;
                    }, vy.prototype.getId = function(y, I) {
                        var U = y.id;
                        if (this.promoteId) {
                            var J = typeof this.promoteId == "string" ? this.promoteId : this.promoteId[I];
                            U = y.properties[J], typeof U == "boolean" && (U = Number(U));
                        }
                        return U;
                    }, Z("FeatureIndex", vy, {
                        omit: [
                            "rawTileData",
                            "sourceLayerCoder"
                        ]
                    });
                    function GQ(m, y, I, U, J) {
                        return H(m, function(ne, fe) {
                            var Fe = y instanceof xc ? y.get(fe) : null;
                            return Fe && Fe.evaluate ? Fe.evaluate(I, U, J) : Fe;
                        });
                    }
                    function jQ(m) {
                        for(var y = 1 / 0, I = 1 / 0, U = -1 / 0, J = -1 / 0, ne = 0, fe = m; ne < fe.length; ne += 1){
                            var Fe = fe[ne];
                            y = Math.min(y, Fe.x), I = Math.min(I, Fe.y), U = Math.max(U, Fe.x), J = Math.max(J, Fe.y);
                        }
                        return {
                            minX: y,
                            minY: I,
                            maxX: U,
                            maxY: J
                        };
                    }
                    function BQe(m, y) {
                        return y - m;
                    }
                    var NQe = 3e4, Fh = function(y, I) {
                        this.tileID = y, this.uid = g(), this.uses = 0, this.tileSize = I, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.expiredRequestCount = 0, this.state = "loading";
                    };
                    Fh.prototype.registerFadeDuration = function(y) {
                        var I = y + this.timeAdded;
                        I < nt.now() || this.fadeEndTime && I < this.fadeEndTime || (this.fadeEndTime = I);
                    }, Fh.prototype.wasRequested = function() {
                        return this.state === "errored" || this.state === "loaded" || this.state === "reloading";
                    }, Fh.prototype.loadVectorData = function(y, I, U) {
                        if (this.hasData() && this.unloadVectorData(), this.state = "loaded", !y) {
                            this.collisionBoxArray = new xs;
                            return;
                        }
                        y.featureIndex && (this.latestFeatureIndex = y.featureIndex, y.rawTileData ? (this.latestRawTileData = y.rawTileData, this.latestFeatureIndex.rawTileData = y.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = y.collisionBoxArray, this.buckets = OQe(y.buckets, I.style), this.hasSymbolBuckets = !1;
                        for(var J in this.buckets){
                            var ne = this.buckets[J];
                            if (ne instanceof ou) {
                                if (this.hasSymbolBuckets = !0, U) ne.justReloaded = !0;
                                else break;
                            }
                        }
                        if (this.hasRTLText = !1, this.hasSymbolBuckets) for(var fe in this.buckets){
                            var Fe = this.buckets[fe];
                            if (Fe instanceof ou && Fe.hasRTLText) {
                                this.hasRTLText = !0, Ns();
                                break;
                            }
                        }
                        this.queryPadding = 0;
                        for(var Qe in this.buckets){
                            var st = this.buckets[Qe];
                            this.queryPadding = Math.max(this.queryPadding, I.style.getLayer(Qe).queryRadius(st));
                        }
                        y.imageAtlas && (this.imageAtlas = y.imageAtlas), y.glyphAtlasImage && (this.glyphAtlasImage = y.glyphAtlasImage);
                    }, Fh.prototype.unloadVectorData = function() {
                        for(var y in this.buckets)this.buckets[y].destroy();
                        this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
                    }, Fh.prototype.getBucket = function(y) {
                        return this.buckets[y.id];
                    }, Fh.prototype.upload = function(y) {
                        for(var I in this.buckets){
                            var U = this.buckets[I];
                            U.uploadPending() && U.upload(y);
                        }
                        var J = y.gl;
                        this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new ib(y, this.imageAtlas.image, J.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new ib(y, this.glyphAtlasImage, J.ALPHA), this.glyphAtlasImage = null);
                    }, Fh.prototype.prepare = function(y) {
                        this.imageAtlas && this.imageAtlas.patchUpdatedImages(y, this.imageAtlasTexture);
                    }, Fh.prototype.queryRenderedFeatures = function(y, I, U, J, ne, fe, Fe, Qe, st, mt) {
                        return !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData ? {} : this.latestFeatureIndex.query({
                            queryGeometry: J,
                            cameraQueryGeometry: ne,
                            scale: fe,
                            tileSize: this.tileSize,
                            pixelPosMatrix: mt,
                            transform: Qe,
                            params: Fe,
                            queryPadding: this.queryPadding * st
                        }, y, I, U);
                    }, Fh.prototype.querySourceFeatures = function(y, I) {
                        var U = this.latestFeatureIndex;
                        if (!(!U || !U.rawTileData)) {
                            var J = U.loadVTLayers(), ne = I ? I.sourceLayer : "", fe = J._geojsonTileLayer || J[ne];
                            if (fe) for(var Fe = be(I && I.filter), Qe = this.tileID.canonical, st = Qe.z, mt = Qe.x, Xt = Qe.y, ur = {
                                z: st,
                                x: mt,
                                y: Xt
                            }, nr = 0; nr < fe.length; nr++){
                                var Lr = fe.feature(nr);
                                if (Fe.needGeometry) {
                                    var Yr = No(Lr, !0);
                                    if (!Fe.filter(new pn(this.tileID.overscaledZ), Yr, this.tileID.canonical)) continue;
                                } else if (!Fe.filter(new pn(this.tileID.overscaledZ), Lr)) continue;
                                var _i = U.getId(Lr, ne), si = new KC(Lr, st, mt, Xt, _i);
                                si.tile = ur, y.push(si);
                            }
                        }
                    }, Fh.prototype.hasData = function() {
                        return this.state === "loaded" || this.state === "reloading" || this.state === "expired";
                    }, Fh.prototype.patternsLoaded = function() {
                        return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
                    }, Fh.prototype.setExpiryData = function(y) {
                        var I = this.expirationTime;
                        if (y.cacheControl) {
                            var U = ge(y.cacheControl);
                            U["max-age"] && (this.expirationTime = Date.now() + U["max-age"] * 1e3);
                        } else y.expires && (this.expirationTime = new Date(y.expires).getTime());
                        if (this.expirationTime) {
                            var J = Date.now(), ne = !1;
                            if (this.expirationTime > J) ne = !1;
                            else if (!I) ne = !0;
                            else if (this.expirationTime < I) ne = !0;
                            else {
                                var fe = this.expirationTime - I;
                                fe ? this.expirationTime = J + Math.max(fe, NQe) : ne = !0;
                            }
                            ne ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                        }
                    }, Fh.prototype.getExpiryTimeout = function() {
                        if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - new Date().getTime(), Math.pow(2, 31) - 1);
                    }, Fh.prototype.setFeatureState = function(y, I) {
                        if (!(!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || Object.keys(y).length === 0)) {
                            var U = this.latestFeatureIndex.loadVTLayers();
                            for(var J in this.buckets)if (I.style.hasLayer(J)) {
                                var ne = this.buckets[J], fe = ne.layers[0].sourceLayer || "_geojsonTileLayer", Fe = U[fe], Qe = y[fe];
                                if (!(!Fe || !Qe || Object.keys(Qe).length === 0)) {
                                    ne.update(Qe, Fe, this.imageAtlas && this.imageAtlas.patternPositions || {});
                                    var st = I && I.style && I.style.getLayer(J);
                                    st && (this.queryPadding = Math.max(this.queryPadding, st.queryRadius(ne)));
                                }
                            }
                        }
                    }, Fh.prototype.holdingForFade = function() {
                        return this.symbolFadeHoldUntil !== void 0;
                    }, Fh.prototype.symbolFadeFinished = function() {
                        return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < nt.now();
                    }, Fh.prototype.clearFadeHold = function() {
                        this.symbolFadeHoldUntil = void 0;
                    }, Fh.prototype.setHoldDuration = function(y) {
                        this.symbolFadeHoldUntil = nt.now() + y;
                    }, Fh.prototype.setDependencies = function(y, I) {
                        for(var U = {}, J = 0, ne = I; J < ne.length; J += 1){
                            var fe = ne[J];
                            U[fe] = !0;
                        }
                        this.dependencies[y] = U;
                    }, Fh.prototype.hasDependency = function(y, I) {
                        for(var U = 0, J = y; U < J.length; U += 1){
                            var ne = J[U], fe = this.dependencies[ne];
                            if (fe) for(var Fe = 0, Qe = I; Fe < Qe.length; Fe += 1){
                                var st = Qe[Fe];
                                if (fe[st]) return !0;
                            }
                        }
                        return !1;
                    };
                    var UQe = [
                        "type",
                        "source",
                        "source-layer",
                        "minzoom",
                        "maxzoom",
                        "filter",
                        "layout"
                    ], z1 = f.performance, WQ = function(y) {
                        this._marks = {
                            start: [
                                y.url,
                                "start"
                            ].join("#"),
                            end: [
                                y.url,
                                "end"
                            ].join("#"),
                            measure: y.url.toString()
                        }, z1.mark(this._marks.start);
                    };
                    WQ.prototype.finish = function() {
                        z1.mark(this._marks.end);
                        var y = z1.getEntriesByName(this._marks.measure);
                        return y.length === 0 && (z1.measure(this._marks.measure, this._marks.start, this._marks.end), y = z1.getEntriesByName(this._marks.measure), z1.clearMarks(this._marks.start), z1.clearMarks(this._marks.end), z1.clearMeasures(this._marks.measure)), y;
                    }, i.Actor = Kw, i.AlphaImage = Pv, i.CanonicalTileID = ab, i.CollisionBoxArray = xs, i.Color = ss, i.DEMData = dy, i.DataConstantProperty = At, i.DictionaryCoder = YC, i.EXTENT = rn, i.ErrorEvent = oa, i.EvaluationParameters = pn, i.Event = jo, i.Evented = Sn, i.FeatureIndex = vy, i.FillBucket = gp, i.FillExtrusionBucket = Hp, i.ImageAtlas = gg, i.ImagePosition = If, i.LineBucket = Gf, i.LngLat = sc, i.LngLatBounds = jf, i.MercatorCoordinate = nb, i.ONE_EM = Zi, i.OverscaledTileID = Wf, i.Point = u, i.Point$1 = u, i.Properties = Oi, i.Protobuf = La, i.RGBAImage = lh, i.RequestManager = Ke, i.RequestPerformance = WQ, i.ResourceType = zn, i.SegmentVector = ns, i.SourceFeatureState = Jw, i.StructArrayLayout1ui2 = Jo, i.StructArrayLayout2f1f2i16 = Xn, i.StructArrayLayout2i4 = ji, i.StructArrayLayout3ui6 = ma, i.StructArrayLayout4i8 = Ln, i.SymbolBucket = ou, i.Texture = ib, i.Tile = Fh, i.Transitionable = Fo, i.Uniform1f = Pt, i.Uniform1i = vt, i.Uniform2f = Wt, i.Uniform3f = rr, i.Uniform4f = dr, i.UniformColor = pr, i.UniformMatrix4f = Ar, i.UnwrappedTileID = HQ, i.ValidationError = fa, i.WritingMode = uv, i.ZoomHistory = wt, i.add = Lv, i.addDynamicAttributes = oq, i.asyncAll = k, i.bezier = x, i.bindAll = q, i.browser = nt, i.cacheEntryPossiblyAdded = bi, i.clamp = p, i.clearTileCache = Wi, i.clipLine = MQ, i.clone = T1, i.clone$1 = G, i.clone$2 = Mw, i.collisionCircleLayout = Tt, i.config = ct, i.create = w1, i.create$1 = Rh, i.create$2 = hg, i.createCommonjsModule = a, i.createExpression = eo, i.createLayout = Dn, i.createStyleLayer = IQe, i.cross = I9, i.deepEqual = h, i.dot = P9, i.dot$1 = q9, i.ease = b, i.emitValidationErrors = Zu, i.endsWith = V, i.enforceCacheSizeLimit = nn, i.evaluateSizeForFeature = _Q, i.evaluateSizeForZoom = xQ, i.evaluateVariableOffset = CQ, i.evented = ya, i.extend = _, i.featureFilter = be, i.filterObject = X, i.fromRotation = rm, i.getAnchorAlignment = bS, i.getAnchorJustification = aq, i.getArrayBuffer = Zr, i.getImage = jn, i.getJSON = Fr, i.getRTLTextPluginStatus = so, i.getReferrer = It, i.getVideo = la, i.identity = oy, i.invert = im, i.isChar = tt, i.isMapboxURL = xt, i.keysDifference = L, i.makeRequest = yr, i.mapObject = H, i.mercatorXfromLng = NQ, i.mercatorYfromLat = UQ, i.mercatorZfromAltitude = VQ, i.mul = Nx, i.multiply = nm, i.mvt = pg, i.nextPowerOfTwo = T, i.normalize = Ux, i.number = Qs, i.offscreenCanvasSupported = $i, i.ortho = Kl, i.parseGlyphPBF = p0, i.pbf = La, i.performSymbolLayout = hQe, i.perspective = A1, i.pick = C, i.plugin = _s, i.polygonIntersectsPolygon = fo, i.postMapLoadEvent = Ve, i.postTurnstileEvent = Ne, i.potpack = Qv, i.refProperties = UQe, i.register = Z, i.registerForPluginStateChange = wa, i.renderColorRamp = Gx, i.rotate = ay, i.rotateX = bd, i.rotateZ = sy, i.scale = kl, i.scale$1 = F9, i.scale$2 = Ew, i.setCacheLimits = Ni, i.setRTLTextPlugin = io, i.sphericalToCartesian = Me, i.sqrLen = tS, i.styleSpec = on, i.sub = D9, i.symbolSize = iQe, i.transformMat3 = R9, i.transformMat4 = ly, i.translate = Fu, i.triggerPluginCompletionEvent = Nn, i.uniqueId = g, i.validateCustomStyleLayer = CQe, i.validateLight = po, i.validateStyle = yo, i.values = A, i.vectorTile = pg, i.version = o, i.warnOnce = re, i.webpSupported = qt, i.window = f, i.wrap = E;
                }), n([
                    "./shared"
                ], function(i) {
                    "use strict";
                    function a(It) {
                        var ft = typeof It;
                        if (ft === "number" || ft === "boolean" || ft === "string" || It === void 0 || It === null) return JSON.stringify(It);
                        if (Array.isArray(It)) {
                            for(var jt = "[", Zt = 0, yr = It; Zt < yr.length; Zt += 1){
                                var Fr = yr[Zt];
                                jt += a(Fr) + ",";
                            }
                            return jt + "]";
                        }
                        for(var Zr = Object.keys(It).sort(), Vr = "{", gi = 0; gi < Zr.length; gi++)Vr += JSON.stringify(Zr[gi]) + ":" + a(It[Zr[gi]]) + ",";
                        return Vr + "}";
                    }
                    function o(It) {
                        for(var ft = "", jt = 0, Zt = i.refProperties; jt < Zt.length; jt += 1){
                            var yr = Zt[jt];
                            ft += "/" + a(It[yr]);
                        }
                        return ft;
                    }
                    function s(It, ft) {
                        for(var jt = {}, Zt = 0; Zt < It.length; Zt++){
                            var yr = ft && ft[It[Zt].id] || o(It[Zt]);
                            ft && (ft[It[Zt].id] = yr);
                            var Fr = jt[yr];
                            Fr || (Fr = jt[yr] = []), Fr.push(It[Zt]);
                        }
                        var Zr = [];
                        for(var Vr in jt)Zr.push(jt[Vr]);
                        return Zr;
                    }
                    var l = function(ft) {
                        this.keyCache = {}, ft && this.replace(ft);
                    };
                    l.prototype.replace = function(ft) {
                        this._layerConfigs = {}, this._layers = {}, this.update(ft, []);
                    }, l.prototype.update = function(ft, jt) {
                        for(var Zt = this, yr = 0, Fr = ft; yr < Fr.length; yr += 1){
                            var Zr = Fr[yr];
                            this._layerConfigs[Zr.id] = Zr;
                            var Vr = this._layers[Zr.id] = i.createStyleLayer(Zr);
                            Vr._featureFilter = i.featureFilter(Vr.filter), this.keyCache[Zr.id] && delete this.keyCache[Zr.id];
                        }
                        for(var gi = 0, Si = jt; gi < Si.length; gi += 1){
                            var Mi = Si[gi];
                            delete this.keyCache[Mi], delete this._layerConfigs[Mi], delete this._layers[Mi];
                        }
                        this.familiesBySource = {};
                        for(var Pi = s(i.values(this._layerConfigs), this.keyCache), Gi = 0, Ki = Pi; Gi < Ki.length; Gi += 1){
                            var ka = Ki[Gi], jn = ka.map(function(Sn) {
                                return Zt._layers[Sn.id];
                            }), la = jn[0];
                            if (la.visibility !== "none") {
                                var Fa = la.source || "", Ra = this.familiesBySource[Fa];
                                Ra || (Ra = this.familiesBySource[Fa] = {});
                                var jo = la.sourceLayer || "_geojsonTileLayer", oa = Ra[jo];
                                oa || (oa = Ra[jo] = []), oa.push(jn);
                            }
                        }
                    };
                    var u = 1, c = function(ft) {
                        var jt = {}, Zt = [];
                        for(var yr in ft){
                            var Fr = ft[yr], Zr = jt[yr] = {};
                            for(var Vr in Fr){
                                var gi = Fr[+Vr];
                                if (!(!gi || gi.bitmap.width === 0 || gi.bitmap.height === 0)) {
                                    var Si = {
                                        x: 0,
                                        y: 0,
                                        w: gi.bitmap.width + 2 * u,
                                        h: gi.bitmap.height + 2 * u
                                    };
                                    Zt.push(Si), Zr[Vr] = {
                                        rect: Si,
                                        metrics: gi.metrics
                                    };
                                }
                            }
                        }
                        var Mi = i.potpack(Zt), Pi = Mi.w, Gi = Mi.h, Ki = new i.AlphaImage({
                            width: Pi || 1,
                            height: Gi || 1
                        });
                        for(var ka in ft){
                            var jn = ft[ka];
                            for(var la in jn){
                                var Fa = jn[+la];
                                if (!(!Fa || Fa.bitmap.width === 0 || Fa.bitmap.height === 0)) {
                                    var Ra = jt[ka][la].rect;
                                    i.AlphaImage.copy(Fa.bitmap, Ki, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: Ra.x + u,
                                        y: Ra.y + u
                                    }, Fa.bitmap);
                                }
                            }
                        }
                        this.image = Ki, this.positions = jt;
                    };
                    i.register("GlyphAtlas", c);
                    var f = function(ft) {
                        this.tileID = new i.OverscaledTileID(ft.tileID.overscaledZ, ft.tileID.wrap, ft.tileID.canonical.z, ft.tileID.canonical.x, ft.tileID.canonical.y), this.uid = ft.uid, this.zoom = ft.zoom, this.pixelRatio = ft.pixelRatio, this.tileSize = ft.tileSize, this.source = ft.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = ft.showCollisionBoxes, this.collectResourceTiming = !!ft.collectResourceTiming, this.returnDependencies = !!ft.returnDependencies, this.promoteId = ft.promoteId;
                    };
                    f.prototype.parse = function(ft, jt, Zt, yr, Fr) {
                        var Zr = this;
                        this.status = "parsing", this.data = ft, this.collisionBoxArray = new i.CollisionBoxArray;
                        var Vr = new i.DictionaryCoder(Object.keys(ft.layers).sort()), gi = new i.FeatureIndex(this.tileID, this.promoteId);
                        gi.bucketLayerIDs = [];
                        var Si = {}, Mi = {
                            featureIndex: gi,
                            iconDependencies: {},
                            patternDependencies: {},
                            glyphDependencies: {},
                            availableImages: Zt
                        }, Pi = jt.familiesBySource[this.source];
                        for(var Gi in Pi){
                            var Ki = ft.layers[Gi];
                            if (Ki) {
                                Ki.version === 1 && i.warnOnce('Vector tile source "' + this.source + '" layer "' + Gi + '" does not use vector tile spec v2 and therefore may have some rendering errors.');
                                for(var ka = Vr.encode(Gi), jn = [], la = 0; la < Ki.length; la++){
                                    var Fa = Ki.feature(la), Ra = gi.getId(Fa, Gi);
                                    jn.push({
                                        feature: Fa,
                                        id: Ra,
                                        index: la,
                                        sourceLayerIndex: ka
                                    });
                                }
                                for(var jo = 0, oa = Pi[Gi]; jo < oa.length; jo += 1){
                                    var Sn = oa[jo], Ha = Sn[0];
                                    if (!(Ha.minzoom && this.zoom < Math.floor(Ha.minzoom)) && !(Ha.maxzoom && this.zoom >= Ha.maxzoom) && Ha.visibility !== "none") {
                                        h(Sn, this.zoom, Zt);
                                        var oo = Si[Ha.id] = Ha.createBucket({
                                            index: gi.bucketLayerIDs.length,
                                            layers: Sn,
                                            zoom: this.zoom,
                                            pixelRatio: this.pixelRatio,
                                            overscaling: this.overscaling,
                                            collisionBoxArray: this.collisionBoxArray,
                                            sourceLayerIndex: ka,
                                            sourceID: this.source
                                        });
                                        oo.populate(jn, Mi, this.tileID.canonical), gi.bucketLayerIDs.push(Sn.map(function(hi) {
                                            return hi.id;
                                        }));
                                    }
                                }
                            }
                        }
                        var xn, _t, br, Hr, ti = i.mapObject(Mi.glyphDependencies, function(hi) {
                            return Object.keys(hi).map(Number);
                        });
                        Object.keys(ti).length ? yr.send("getGlyphs", {
                            uid: this.uid,
                            stacks: ti
                        }, function(hi, Ji) {
                            xn || (xn = hi, _t = Ji, an.call(Zr));
                        }) : _t = {};
                        var zi = Object.keys(Mi.iconDependencies);
                        zi.length ? yr.send("getImages", {
                            icons: zi,
                            source: this.source,
                            tileID: this.tileID,
                            type: "icons"
                        }, function(hi, Ji) {
                            xn || (xn = hi, br = Ji, an.call(Zr));
                        }) : br = {};
                        var Yi = Object.keys(Mi.patternDependencies);
                        Yi.length ? yr.send("getImages", {
                            icons: Yi,
                            source: this.source,
                            tileID: this.tileID,
                            type: "patterns"
                        }, function(hi, Ji) {
                            xn || (xn = hi, Hr = Ji, an.call(Zr));
                        }) : Hr = {}, an.call(this);
                        function an() {
                            if (xn) return Fr(xn);
                            if (_t && br && Hr) {
                                var hi = new c(_t), Ji = new i.ImageAtlas(br, Hr);
                                for(var ua in Si){
                                    var Fn = Si[ua];
                                    Fn instanceof i.SymbolBucket ? (h(Fn.layers, this.zoom, Zt), i.performSymbolLayout(Fn, _t, hi.positions, br, Ji.iconPositions, this.showCollisionBoxes, this.tileID.canonical)) : Fn.hasPattern && (Fn instanceof i.LineBucket || Fn instanceof i.FillBucket || Fn instanceof i.FillExtrusionBucket) && (h(Fn.layers, this.zoom, Zt), Fn.addFeatures(Mi, this.tileID.canonical, Ji.patternPositions));
                                }
                                this.status = "done", Fr(null, {
                                    buckets: i.values(Si).filter(function(Sa) {
                                        return !Sa.isEmpty();
                                    }),
                                    featureIndex: gi,
                                    collisionBoxArray: this.collisionBoxArray,
                                    glyphAtlasImage: hi.image,
                                    imageAtlas: Ji,
                                    glyphMap: this.returnDependencies ? _t : null,
                                    iconMap: this.returnDependencies ? br : null,
                                    glyphPositions: this.returnDependencies ? hi.positions : null
                                });
                            }
                        }
                    };
                    function h(It, ft, jt) {
                        for(var Zt = new i.EvaluationParameters(ft), yr = 0, Fr = It; yr < Fr.length; yr += 1){
                            var Zr = Fr[yr];
                            Zr.recalculate(Zt, jt);
                        }
                    }
                    function d(It, ft) {
                        var jt = i.getArrayBuffer(It.request, function(Zt, yr, Fr, Zr) {
                            Zt ? ft(Zt) : yr && ft(null, {
                                vectorTile: new i.vectorTile.VectorTile(new i.pbf(yr)),
                                rawData: yr,
                                cacheControl: Fr,
                                expires: Zr
                            });
                        });
                        return function() {
                            jt.cancel(), ft();
                        };
                    }
                    var v = function(ft, jt, Zt, yr) {
                        this.actor = ft, this.layerIndex = jt, this.availableImages = Zt, this.loadVectorData = yr || d, this.loading = {}, this.loaded = {};
                    };
                    v.prototype.loadTile = function(ft, jt) {
                        var Zt = this, yr = ft.uid;
                        this.loading || (this.loading = {});
                        var Fr = ft && ft.request && ft.request.collectResourceTiming ? new i.RequestPerformance(ft.request) : !1, Zr = this.loading[yr] = new f(ft);
                        Zr.abort = this.loadVectorData(ft, function(Vr, gi) {
                            if (delete Zt.loading[yr], Vr || !gi) return Zr.status = "done", Zt.loaded[yr] = Zr, jt(Vr);
                            var Si = gi.rawData, Mi = {};
                            gi.expires && (Mi.expires = gi.expires), gi.cacheControl && (Mi.cacheControl = gi.cacheControl);
                            var Pi = {};
                            if (Fr) {
                                var Gi = Fr.finish();
                                Gi && (Pi.resourceTiming = JSON.parse(JSON.stringify(Gi)));
                            }
                            Zr.vectorTile = gi.vectorTile, Zr.parse(gi.vectorTile, Zt.layerIndex, Zt.availableImages, Zt.actor, function(Ki, ka) {
                                if (Ki || !ka) return jt(Ki);
                                jt(null, i.extend({
                                    rawTileData: Si.slice(0)
                                }, ka, Mi, Pi));
                            }), Zt.loaded = Zt.loaded || {}, Zt.loaded[yr] = Zr;
                        });
                    }, v.prototype.reloadTile = function(ft, jt) {
                        var Zt = this, yr = this.loaded, Fr = ft.uid, Zr = this;
                        if (yr && yr[Fr]) {
                            var Vr = yr[Fr];
                            Vr.showCollisionBoxes = ft.showCollisionBoxes;
                            var gi = function(Si, Mi) {
                                var Pi = Vr.reloadCallback;
                                Pi && (delete Vr.reloadCallback, Vr.parse(Vr.vectorTile, Zr.layerIndex, Zt.availableImages, Zr.actor, Pi)), jt(Si, Mi);
                            };
                            Vr.status === "parsing" ? Vr.reloadCallback = gi : Vr.status === "done" && (Vr.vectorTile ? Vr.parse(Vr.vectorTile, this.layerIndex, this.availableImages, this.actor, gi) : gi());
                        }
                    }, v.prototype.abortTile = function(ft, jt) {
                        var Zt = this.loading, yr = ft.uid;
                        Zt && Zt[yr] && Zt[yr].abort && (Zt[yr].abort(), delete Zt[yr]), jt();
                    }, v.prototype.removeTile = function(ft, jt) {
                        var Zt = this.loaded, yr = ft.uid;
                        Zt && Zt[yr] && delete Zt[yr], jt();
                    };
                    var x = i.window.ImageBitmap, b = function() {
                        this.loaded = {};
                    };
                    b.prototype.loadTile = function(ft, jt) {
                        var Zt = ft.uid, yr = ft.encoding, Fr = ft.rawImageData, Zr = x && Fr instanceof x ? this.getImageData(Fr) : Fr, Vr = new i.DEMData(Zt, Zr, yr);
                        this.loaded = this.loaded || {}, this.loaded[Zt] = Vr, jt(null, Vr);
                    }, b.prototype.getImageData = function(ft) {
                        (!this.offscreenCanvas || !this.offscreenCanvasContext) && (this.offscreenCanvas = new OffscreenCanvas(ft.width, ft.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d")), this.offscreenCanvas.width = ft.width, this.offscreenCanvas.height = ft.height, this.offscreenCanvasContext.drawImage(ft, 0, 0, ft.width, ft.height);
                        var jt = this.offscreenCanvasContext.getImageData(-1, -1, ft.width + 2, ft.height + 2);
                        return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), new i.RGBAImage({
                            width: jt.width,
                            height: jt.height
                        }, jt.data);
                    }, b.prototype.removeTile = function(ft) {
                        var jt = this.loaded, Zt = ft.uid;
                        jt && jt[Zt] && delete jt[Zt];
                    };
                    var p = E;
                    function E(It, ft) {
                        var jt = It && It.type, Zt;
                        if (jt === "FeatureCollection") for(Zt = 0; Zt < It.features.length; Zt++)E(It.features[Zt], ft);
                        else if (jt === "GeometryCollection") for(Zt = 0; Zt < It.geometries.length; Zt++)E(It.geometries[Zt], ft);
                        else if (jt === "Feature") E(It.geometry, ft);
                        else if (jt === "Polygon") k(It.coordinates, ft);
                        else if (jt === "MultiPolygon") for(Zt = 0; Zt < It.coordinates.length; Zt++)k(It.coordinates[Zt], ft);
                        return It;
                    }
                    function k(It, ft) {
                        if (It.length !== 0) {
                            A(It[0], ft);
                            for(var jt = 1; jt < It.length; jt++)A(It[jt], !ft);
                        }
                    }
                    function A(It, ft) {
                        for(var jt = 0, Zt = 0, yr = It.length, Fr = yr - 1; Zt < yr; Fr = Zt++)jt += (It[Zt][0] - It[Fr][0]) * (It[Fr][1] + It[Zt][1]);
                        jt >= 0 != !!ft && It.reverse();
                    }
                    var L = i.vectorTile.VectorTileFeature.prototype.toGeoJSON, _ = function(ft) {
                        this._feature = ft, this.extent = i.EXTENT, this.type = ft.type, this.properties = ft.tags, "id" in ft && !isNaN(ft.id) && (this.id = parseInt(ft.id, 10));
                    };
                    _.prototype.loadGeometry = function() {
                        if (this._feature.type === 1) {
                            for(var ft = [], jt = 0, Zt = this._feature.geometry; jt < Zt.length; jt += 1){
                                var yr = Zt[jt];
                                ft.push([
                                    new i.Point$1(yr[0], yr[1])
                                ]);
                            }
                            return ft;
                        } else {
                            for(var Fr = [], Zr = 0, Vr = this._feature.geometry; Zr < Vr.length; Zr += 1){
                                for(var gi = Vr[Zr], Si = [], Mi = 0, Pi = gi; Mi < Pi.length; Mi += 1){
                                    var Gi = Pi[Mi];
                                    Si.push(new i.Point$1(Gi[0], Gi[1]));
                                }
                                Fr.push(Si);
                            }
                            return Fr;
                        }
                    }, _.prototype.toGeoJSON = function(ft, jt, Zt) {
                        return L.call(this, ft, jt, Zt);
                    };
                    var C = function(ft) {
                        this.layers = {
                            _geojsonTileLayer: this
                        }, this.name = "_geojsonTileLayer", this.extent = i.EXTENT, this.length = ft.length, this._features = ft;
                    };
                    C.prototype.feature = function(ft) {
                        return new _(this._features[ft]);
                    };
                    var M = i.vectorTile.VectorTileFeature, g = P;
                    function P(It, ft) {
                        this.options = ft || {}, this.features = It, this.length = It.length;
                    }
                    P.prototype.feature = function(It) {
                        return new T(this.features[It], this.options.extent);
                    };
                    function T(It, ft) {
                        this.id = typeof It.id == "number" ? It.id : void 0, this.type = It.type, this.rawGeometry = It.type === 1 ? [
                            It.geometry
                        ] : It.geometry, this.properties = It.tags, this.extent = ft || 4096;
                    }
                    T.prototype.loadGeometry = function() {
                        var It = this.rawGeometry;
                        this.geometry = [];
                        for(var ft = 0; ft < It.length; ft++){
                            for(var jt = It[ft], Zt = [], yr = 0; yr < jt.length; yr++)Zt.push(new i.Point$1(jt[yr][0], jt[yr][1]));
                            this.geometry.push(Zt);
                        }
                        return this.geometry;
                    }, T.prototype.bbox = function() {
                        this.geometry || this.loadGeometry();
                        for(var It = this.geometry, ft = 1 / 0, jt = -1 / 0, Zt = 1 / 0, yr = -1 / 0, Fr = 0; Fr < It.length; Fr++)for(var Zr = It[Fr], Vr = 0; Vr < Zr.length; Vr++){
                            var gi = Zr[Vr];
                            ft = Math.min(ft, gi.x), jt = Math.max(jt, gi.x), Zt = Math.min(Zt, gi.y), yr = Math.max(yr, gi.y);
                        }
                        return [
                            ft,
                            Zt,
                            jt,
                            yr
                        ];
                    }, T.prototype.toGeoJSON = M.prototype.toGeoJSON;
                    var F = X, q = X, V = G, H = g;
                    function X(It) {
                        var ft = new i.pbf;
                        return N(It, ft), ft.finish();
                    }
                    function G(It, ft) {
                        ft = ft || {};
                        var jt = {};
                        for(var Zt in It)jt[Zt] = new g(It[Zt].features, ft), jt[Zt].name = Zt, jt[Zt].version = ft.version, jt[Zt].extent = ft.extent;
                        return X({
                            layers: jt
                        });
                    }
                    function N(It, ft) {
                        for(var jt in It.layers)ft.writeMessage(3, W, It.layers[jt]);
                    }
                    function W(It, ft) {
                        ft.writeVarintField(15, It.version || 1), ft.writeStringField(1, It.name || ""), ft.writeVarintField(5, It.extent || 4096);
                        var jt, Zt = {
                            keys: [],
                            values: [],
                            keycache: {},
                            valuecache: {}
                        };
                        for(jt = 0; jt < It.length; jt++)Zt.feature = It.feature(jt), ft.writeMessage(2, re, Zt);
                        var yr = Zt.keys;
                        for(jt = 0; jt < yr.length; jt++)ft.writeStringField(3, yr[jt]);
                        var Fr = Zt.values;
                        for(jt = 0; jt < Fr.length; jt++)ft.writeMessage(4, ge, Fr[jt]);
                    }
                    function re(It, ft) {
                        var jt = It.feature;
                        jt.id !== void 0 && ft.writeVarintField(1, jt.id), ft.writeMessage(2, ae, It), ft.writeVarintField(3, jt.type), ft.writeMessage(4, ke, jt);
                    }
                    function ae(It, ft) {
                        var jt = It.feature, Zt = It.keys, yr = It.values, Fr = It.keycache, Zr = It.valuecache;
                        for(var Vr in jt.properties){
                            var gi = Fr[Vr];
                            typeof gi == "undefined" && (Zt.push(Vr), gi = Zt.length - 1, Fr[Vr] = gi), ft.writeVarint(gi);
                            var Si = jt.properties[Vr], Mi = typeof Si;
                            Mi !== "string" && Mi !== "boolean" && Mi !== "number" && (Si = JSON.stringify(Si));
                            var Pi = Mi + ":" + Si, Gi = Zr[Pi];
                            typeof Gi == "undefined" && (yr.push(Si), Gi = yr.length - 1, Zr[Pi] = Gi), ft.writeVarint(Gi);
                        }
                    }
                    function _e(It, ft) {
                        return (ft << 3) + (It & 7);
                    }
                    function Me(It) {
                        return It << 1 ^ It >> 31;
                    }
                    function ke(It, ft) {
                        for(var jt = It.loadGeometry(), Zt = It.type, yr = 0, Fr = 0, Zr = jt.length, Vr = 0; Vr < Zr; Vr++){
                            var gi = jt[Vr], Si = 1;
                            Zt === 1 && (Si = gi.length), ft.writeVarint(_e(1, Si));
                            for(var Mi = Zt === 3 ? gi.length - 1 : gi.length, Pi = 0; Pi < Mi; Pi++){
                                Pi === 1 && Zt !== 1 && ft.writeVarint(_e(2, Mi - 1));
                                var Gi = gi[Pi].x - yr, Ki = gi[Pi].y - Fr;
                                ft.writeVarint(Me(Gi)), ft.writeVarint(Me(Ki)), yr += Gi, Fr += Ki;
                            }
                            Zt === 3 && ft.writeVarint(_e(7, 1));
                        }
                    }
                    function ge(It, ft) {
                        var jt = typeof It;
                        jt === "string" ? ft.writeStringField(1, It) : jt === "boolean" ? ft.writeBooleanField(7, It) : jt === "number" && (It % 1 !== 0 ? ft.writeDoubleField(3, It) : It < 0 ? ft.writeSVarintField(6, It) : ft.writeVarintField(5, It));
                    }
                    F.fromVectorTileJs = q, F.fromGeojsonVt = V, F.GeoJSONWrapper = H;
                    function ie(It, ft, jt, Zt, yr, Fr) {
                        if (!(yr - Zt <= jt)) {
                            var Zr = Zt + yr >> 1;
                            Te(It, ft, Zr, Zt, yr, Fr % 2), ie(It, ft, jt, Zt, Zr - 1, Fr + 1), ie(It, ft, jt, Zr + 1, yr, Fr + 1);
                        }
                    }
                    function Te(It, ft, jt, Zt, yr, Fr) {
                        for(; yr > Zt;){
                            if (yr - Zt > 600) {
                                var Zr = yr - Zt + 1, Vr = jt - Zt + 1, gi = Math.log(Zr), Si = .5 * Math.exp(2 * gi / 3), Mi = .5 * Math.sqrt(gi * Si * (Zr - Si) / Zr) * (Vr - Zr / 2 < 0 ? -1 : 1), Pi = Math.max(Zt, Math.floor(jt - Vr * Si / Zr + Mi)), Gi = Math.min(yr, Math.floor(jt + (Zr - Vr) * Si / Zr + Mi));
                                Te(It, ft, jt, Pi, Gi, Fr);
                            }
                            var Ki = ft[2 * jt + Fr], ka = Zt, jn = yr;
                            for(Ee(It, ft, Zt, jt), ft[2 * yr + Fr] > Ki && Ee(It, ft, Zt, yr); ka < jn;){
                                for(Ee(It, ft, ka, jn), ka++, jn--; ft[2 * ka + Fr] < Ki;)ka++;
                                for(; ft[2 * jn + Fr] > Ki;)jn--;
                            }
                            ft[2 * Zt + Fr] === Ki ? Ee(It, ft, Zt, jn) : (jn++, Ee(It, ft, jn, yr)), jn <= jt && (Zt = jn + 1), jt <= jn && (yr = jn - 1);
                        }
                    }
                    function Ee(It, ft, jt, Zt) {
                        Ae(It, jt, Zt), Ae(ft, 2 * jt, 2 * Zt), Ae(ft, 2 * jt + 1, 2 * Zt + 1);
                    }
                    function Ae(It, ft, jt) {
                        var Zt = It[ft];
                        It[ft] = It[jt], It[jt] = Zt;
                    }
                    function ze(It, ft, jt, Zt, yr, Fr, Zr) {
                        for(var Vr = [
                            0,
                            It.length - 1,
                            0
                        ], gi = [], Si, Mi; Vr.length;){
                            var Pi = Vr.pop(), Gi = Vr.pop(), Ki = Vr.pop();
                            if (Gi - Ki <= Zr) {
                                for(var ka = Ki; ka <= Gi; ka++)Si = ft[2 * ka], Mi = ft[2 * ka + 1], Si >= jt && Si <= yr && Mi >= Zt && Mi <= Fr && gi.push(It[ka]);
                                continue;
                            }
                            var jn = Math.floor((Ki + Gi) / 2);
                            Si = ft[2 * jn], Mi = ft[2 * jn + 1], Si >= jt && Si <= yr && Mi >= Zt && Mi <= Fr && gi.push(It[jn]);
                            var la = (Pi + 1) % 2;
                            (Pi === 0 ? jt <= Si : Zt <= Mi) && (Vr.push(Ki), Vr.push(jn - 1), Vr.push(la)), (Pi === 0 ? yr >= Si : Fr >= Mi) && (Vr.push(jn + 1), Vr.push(Gi), Vr.push(la));
                        }
                        return gi;
                    }
                    function Ce(It, ft, jt, Zt, yr, Fr) {
                        for(var Zr = [
                            0,
                            It.length - 1,
                            0
                        ], Vr = [], gi = yr * yr; Zr.length;){
                            var Si = Zr.pop(), Mi = Zr.pop(), Pi = Zr.pop();
                            if (Mi - Pi <= Fr) {
                                for(var Gi = Pi; Gi <= Mi; Gi++)me(ft[2 * Gi], ft[2 * Gi + 1], jt, Zt) <= gi && Vr.push(It[Gi]);
                                continue;
                            }
                            var Ki = Math.floor((Pi + Mi) / 2), ka = ft[2 * Ki], jn = ft[2 * Ki + 1];
                            me(ka, jn, jt, Zt) <= gi && Vr.push(It[Ki]);
                            var la = (Si + 1) % 2;
                            (Si === 0 ? jt - yr <= ka : Zt - yr <= jn) && (Zr.push(Pi), Zr.push(Ki - 1), Zr.push(la)), (Si === 0 ? jt + yr >= ka : Zt + yr >= jn) && (Zr.push(Ki + 1), Zr.push(Mi), Zr.push(la));
                        }
                        return Vr;
                    }
                    function me(It, ft, jt, Zt) {
                        var yr = It - jt, Fr = ft - Zt;
                        return yr * yr + Fr * Fr;
                    }
                    var Re = function(It) {
                        return It[0];
                    }, ce = function(It) {
                        return It[1];
                    }, Ge = function(ft, jt, Zt, yr, Fr) {
                        jt === void 0 && (jt = Re), Zt === void 0 && (Zt = ce), yr === void 0 && (yr = 64), Fr === void 0 && (Fr = Float64Array), this.nodeSize = yr, this.points = ft;
                        for(var Zr = ft.length < 65536 ? Uint16Array : Uint32Array, Vr = this.ids = new Zr(ft.length), gi = this.coords = new Fr(ft.length * 2), Si = 0; Si < ft.length; Si++)Vr[Si] = Si, gi[2 * Si] = jt(ft[Si]), gi[2 * Si + 1] = Zt(ft[Si]);
                        ie(Vr, gi, yr, 0, Vr.length - 1, 0);
                    };
                    Ge.prototype.range = function(ft, jt, Zt, yr) {
                        return ze(this.ids, this.coords, ft, jt, Zt, yr, this.nodeSize);
                    }, Ge.prototype.within = function(ft, jt, Zt) {
                        return Ce(this.ids, this.coords, ft, jt, Zt, this.nodeSize);
                    };
                    var nt = {
                        minZoom: 0,
                        maxZoom: 16,
                        minPoints: 2,
                        radius: 40,
                        extent: 512,
                        nodeSize: 64,
                        log: !1,
                        generateId: !1,
                        reduce: null,
                        map: function(It) {
                            return It;
                        }
                    }, ct = function(ft) {
                        this.options = er(Object.create(nt), ft), this.trees = new Array(this.options.maxZoom + 1);
                    };
                    ct.prototype.load = function(ft) {
                        var jt = this.options, Zt = jt.log, yr = jt.minZoom, Fr = jt.maxZoom, Zr = jt.nodeSize;
                        Zt && console.time("total time");
                        var Vr = "prepare " + ft.length + " points";
                        Zt && console.time(Vr), this.points = ft;
                        for(var gi = [], Si = 0; Si < ft.length; Si++)ft[Si].geometry && gi.push(rt(ft[Si], Si));
                        this.trees[Fr + 1] = new Ge(gi, Ke, xt, Zr, Float32Array), Zt && console.timeEnd(Vr);
                        for(var Mi = Fr; Mi >= yr; Mi--){
                            var Pi = +Date.now();
                            gi = this._cluster(gi, Mi), this.trees[Mi] = new Ge(gi, Ke, xt, Zr, Float32Array), Zt && console.log("z%d: %d clusters in %dms", Mi, gi.length, +Date.now() - Pi);
                        }
                        return Zt && console.timeEnd("total time"), this;
                    }, ct.prototype.getClusters = function(ft, jt) {
                        var Zt = ((ft[0] + 180) % 360 + 360) % 360 - 180, yr = Math.max(-90, Math.min(90, ft[1])), Fr = ft[2] === 180 ? 180 : ((ft[2] + 180) % 360 + 360) % 360 - 180, Zr = Math.max(-90, Math.min(90, ft[3]));
                        if (ft[2] - ft[0] >= 360) Zt = -180, Fr = 180;
                        else if (Zt > Fr) {
                            var Vr = this.getClusters([
                                Zt,
                                yr,
                                180,
                                Zr
                            ], jt), gi = this.getClusters([
                                -180,
                                yr,
                                Fr,
                                Zr
                            ], jt);
                            return Vr.concat(gi);
                        }
                        for(var Si = this.trees[this._limitZoom(jt)], Mi = Si.range(kt(Zt), Ct(Zr), kt(Fr), Ct(yr)), Pi = [], Gi = 0, Ki = Mi; Gi < Ki.length; Gi += 1){
                            var ka = Ki[Gi], jn = Si.points[ka];
                            Pi.push(jn.numPoints ? ot(jn) : this.points[jn.index]);
                        }
                        return Pi;
                    }, ct.prototype.getChildren = function(ft) {
                        var jt = this._getOriginId(ft), Zt = this._getOriginZoom(ft), yr = "No cluster with the specified id.", Fr = this.trees[Zt];
                        if (!Fr) throw new Error(yr);
                        var Zr = Fr.points[jt];
                        if (!Zr) throw new Error(yr);
                        for(var Vr = this.options.radius / (this.options.extent * Math.pow(2, Zt - 1)), gi = Fr.within(Zr.x, Zr.y, Vr), Si = [], Mi = 0, Pi = gi; Mi < Pi.length; Mi += 1){
                            var Gi = Pi[Mi], Ki = Fr.points[Gi];
                            Ki.parentId === ft && Si.push(Ki.numPoints ? ot(Ki) : this.points[Ki.index]);
                        }
                        if (Si.length === 0) throw new Error(yr);
                        return Si;
                    }, ct.prototype.getLeaves = function(ft, jt, Zt) {
                        jt = jt || 10, Zt = Zt || 0;
                        var yr = [];
                        return this._appendLeaves(yr, ft, jt, Zt, 0), yr;
                    }, ct.prototype.getTile = function(ft, jt, Zt) {
                        var yr = this.trees[this._limitZoom(ft)], Fr = Math.pow(2, ft), Zr = this.options, Vr = Zr.extent, gi = Zr.radius, Si = gi / Vr, Mi = (Zt - Si) / Fr, Pi = (Zt + 1 + Si) / Fr, Gi = {
                            features: []
                        };
                        return this._addTileFeatures(yr.range((jt - Si) / Fr, Mi, (jt + 1 + Si) / Fr, Pi), yr.points, jt, Zt, Fr, Gi), jt === 0 && this._addTileFeatures(yr.range(1 - Si / Fr, Mi, 1, Pi), yr.points, Fr, Zt, Fr, Gi), jt === Fr - 1 && this._addTileFeatures(yr.range(0, Mi, Si / Fr, Pi), yr.points, -1, Zt, Fr, Gi), Gi.features.length ? Gi : null;
                    }, ct.prototype.getClusterExpansionZoom = function(ft) {
                        for(var jt = this._getOriginZoom(ft) - 1; jt <= this.options.maxZoom;){
                            var Zt = this.getChildren(ft);
                            if (jt++, Zt.length !== 1) break;
                            ft = Zt[0].properties.cluster_id;
                        }
                        return jt;
                    }, ct.prototype._appendLeaves = function(ft, jt, Zt, yr, Fr) {
                        for(var Zr = this.getChildren(jt), Vr = 0, gi = Zr; Vr < gi.length; Vr += 1){
                            var Si = gi[Vr], Mi = Si.properties;
                            if (Mi && Mi.cluster ? Fr + Mi.point_count <= yr ? Fr += Mi.point_count : Fr = this._appendLeaves(ft, Mi.cluster_id, Zt, yr, Fr) : Fr < yr ? Fr++ : ft.push(Si), ft.length === Zt) break;
                        }
                        return Fr;
                    }, ct.prototype._addTileFeatures = function(ft, jt, Zt, yr, Fr, Zr) {
                        for(var Vr = 0, gi = ft; Vr < gi.length; Vr += 1){
                            var Si = gi[Vr], Mi = jt[Si], Pi = Mi.numPoints, Gi = {
                                type: 1,
                                geometry: [
                                    [
                                        Math.round(this.options.extent * (Mi.x * Fr - Zt)),
                                        Math.round(this.options.extent * (Mi.y * Fr - yr))
                                    ]
                                ],
                                tags: Pi ? Rt(Mi) : this.points[Mi.index].properties
                            }, Ki = void 0;
                            Pi ? Ki = Mi.id : this.options.generateId ? Ki = Mi.index : this.points[Mi.index].id && (Ki = this.points[Mi.index].id), Ki !== void 0 && (Gi.id = Ki), Zr.features.push(Gi);
                        }
                    }, ct.prototype._limitZoom = function(ft) {
                        return Math.max(this.options.minZoom, Math.min(+ft, this.options.maxZoom + 1));
                    }, ct.prototype._cluster = function(ft, jt) {
                        for(var Zt = [], yr = this.options, Fr = yr.radius, Zr = yr.extent, Vr = yr.reduce, gi = yr.minPoints, Si = Fr / (Zr * Math.pow(2, jt)), Mi = 0; Mi < ft.length; Mi++){
                            var Pi = ft[Mi];
                            if (!(Pi.zoom <= jt)) {
                                Pi.zoom = jt;
                                for(var Gi = this.trees[jt + 1], Ki = Gi.within(Pi.x, Pi.y, Si), ka = Pi.numPoints || 1, jn = ka, la = 0, Fa = Ki; la < Fa.length; la += 1){
                                    var Ra = Fa[la], jo = Gi.points[Ra];
                                    jo.zoom > jt && (jn += jo.numPoints || 1);
                                }
                                if (jn >= gi) {
                                    for(var oa = Pi.x * ka, Sn = Pi.y * ka, Ha = Vr && ka > 1 ? this._map(Pi, !0) : null, oo = (Mi << 5) + (jt + 1) + this.points.length, xn = 0, _t = Ki; xn < _t.length; xn += 1){
                                        var br = _t[xn], Hr = Gi.points[br];
                                        if (!(Hr.zoom <= jt)) {
                                            Hr.zoom = jt;
                                            var ti = Hr.numPoints || 1;
                                            oa += Hr.x * ti, Sn += Hr.y * ti, Hr.parentId = oo, Vr && (Ha || (Ha = this._map(Pi, !0)), Vr(Ha, this._map(Hr)));
                                        }
                                    }
                                    Pi.parentId = oo, Zt.push(qt(oa / jn, Sn / jn, oo, jn, Ha));
                                } else if (Zt.push(Pi), jn > 1) for(var zi = 0, Yi = Ki; zi < Yi.length; zi += 1){
                                    var an = Yi[zi], hi = Gi.points[an];
                                    hi.zoom <= jt || (hi.zoom = jt, Zt.push(hi));
                                }
                            }
                        }
                        return Zt;
                    }, ct.prototype._getOriginId = function(ft) {
                        return ft - this.points.length >> 5;
                    }, ct.prototype._getOriginZoom = function(ft) {
                        return (ft - this.points.length) % 32;
                    }, ct.prototype._map = function(ft, jt) {
                        if (ft.numPoints) return jt ? er({}, ft.properties) : ft.properties;
                        var Zt = this.points[ft.index].properties, yr = this.options.map(Zt);
                        return jt && yr === Zt ? er({}, yr) : yr;
                    };
                    function qt(It, ft, jt, Zt, yr) {
                        return {
                            x: It,
                            y: ft,
                            zoom: 1 / 0,
                            id: jt,
                            parentId: -1,
                            numPoints: Zt,
                            properties: yr
                        };
                    }
                    function rt(It, ft) {
                        var jt = It.geometry.coordinates, Zt = jt[0], yr = jt[1];
                        return {
                            x: kt(Zt),
                            y: Ct(yr),
                            zoom: 1 / 0,
                            index: ft,
                            parentId: -1
                        };
                    }
                    function ot(It) {
                        return {
                            type: "Feature",
                            id: It.id,
                            properties: Rt(It),
                            geometry: {
                                type: "Point",
                                coordinates: [
                                    Yt(It.x),
                                    xr(It.y)
                                ]
                            }
                        };
                    }
                    function Rt(It) {
                        var ft = It.numPoints, jt = ft >= 1e4 ? Math.round(ft / 1e3) + "k" : ft >= 1e3 ? Math.round(ft / 100) / 10 + "k" : ft;
                        return er(er({}, It.properties), {
                            cluster: !0,
                            cluster_id: It.id,
                            point_count: ft,
                            point_count_abbreviated: jt
                        });
                    }
                    function kt(It) {
                        return It / 360 + .5;
                    }
                    function Ct(It) {
                        var ft = Math.sin(It * Math.PI / 180), jt = .5 - .25 * Math.log((1 + ft) / (1 - ft)) / Math.PI;
                        return jt < 0 ? 0 : jt > 1 ? 1 : jt;
                    }
                    function Yt(It) {
                        return (It - .5) * 360;
                    }
                    function xr(It) {
                        var ft = (180 - It * 360) * Math.PI / 180;
                        return 360 * Math.atan(Math.exp(ft)) / Math.PI - 90;
                    }
                    function er(It, ft) {
                        for(var jt in ft)It[jt] = ft[jt];
                        return It;
                    }
                    function Ke(It) {
                        return It.x;
                    }
                    function xt(It) {
                        return It.y;
                    }
                    function bt(It, ft, jt, Zt) {
                        for(var yr = Zt, Fr = jt - ft >> 1, Zr = jt - ft, Vr, gi = It[ft], Si = It[ft + 1], Mi = It[jt], Pi = It[jt + 1], Gi = ft + 3; Gi < jt; Gi += 3){
                            var Ki = Lt(It[Gi], It[Gi + 1], gi, Si, Mi, Pi);
                            if (Ki > yr) Vr = Gi, yr = Ki;
                            else if (Ki === yr) {
                                var ka = Math.abs(Gi - Fr);
                                ka < Zr && (Vr = Gi, Zr = ka);
                            }
                        }
                        yr > Zt && (Vr - ft > 3 && bt(It, ft, Vr, Zt), It[Vr + 2] = yr, jt - Vr > 3 && bt(It, Vr, jt, Zt));
                    }
                    function Lt(It, ft, jt, Zt, yr, Fr) {
                        var Zr = yr - jt, Vr = Fr - Zt;
                        if (Zr !== 0 || Vr !== 0) {
                            var gi = ((It - jt) * Zr + (ft - Zt) * Vr) / (Zr * Zr + Vr * Vr);
                            gi > 1 ? (jt = yr, Zt = Fr) : gi > 0 && (jt += Zr * gi, Zt += Vr * gi);
                        }
                        return Zr = It - jt, Vr = ft - Zt, Zr * Zr + Vr * Vr;
                    }
                    function St(It, ft, jt, Zt) {
                        var yr = {
                            id: typeof It == "undefined" ? null : It,
                            type: ft,
                            geometry: jt,
                            tags: Zt,
                            minX: 1 / 0,
                            minY: 1 / 0,
                            maxX: -1 / 0,
                            maxY: -1 / 0
                        };
                        return Et(yr), yr;
                    }
                    function Et(It) {
                        var ft = It.geometry, jt = It.type;
                        if (jt === "Point" || jt === "MultiPoint" || jt === "LineString") dt(It, ft);
                        else if (jt === "Polygon" || jt === "MultiLineString") for(var Zt = 0; Zt < ft.length; Zt++)dt(It, ft[Zt]);
                        else if (jt === "MultiPolygon") for(Zt = 0; Zt < ft.length; Zt++)for(var yr = 0; yr < ft[Zt].length; yr++)dt(It, ft[Zt][yr]);
                    }
                    function dt(It, ft) {
                        for(var jt = 0; jt < ft.length; jt += 3)It.minX = Math.min(It.minX, ft[jt]), It.minY = Math.min(It.minY, ft[jt + 1]), It.maxX = Math.max(It.maxX, ft[jt]), It.maxY = Math.max(It.maxY, ft[jt + 1]);
                    }
                    function Ht(It, ft) {
                        var jt = [];
                        if (It.type === "FeatureCollection") for(var Zt = 0; Zt < It.features.length; Zt++)$t(jt, It.features[Zt], ft, Zt);
                        else It.type === "Feature" ? $t(jt, It, ft) : $t(jt, {
                            geometry: It
                        }, ft);
                        return jt;
                    }
                    function $t(It, ft, jt, Zt) {
                        if (ft.geometry) {
                            var yr = ft.geometry.coordinates, Fr = ft.geometry.type, Zr = Math.pow(jt.tolerance / ((1 << jt.maxZoom) * jt.extent), 2), Vr = [], gi = ft.id;
                            if (jt.promoteId ? gi = ft.properties[jt.promoteId] : jt.generateId && (gi = Zt || 0), Fr === "Point") fr(yr, Vr);
                            else if (Fr === "MultiPoint") for(var Si = 0; Si < yr.length; Si++)fr(yr[Si], Vr);
                            else if (Fr === "LineString") _r(yr, Vr, Zr, !1);
                            else if (Fr === "MultiLineString") {
                                if (jt.lineMetrics) {
                                    for(Si = 0; Si < yr.length; Si++)Vr = [], _r(yr[Si], Vr, Zr, !1), It.push(St(gi, "LineString", Vr, ft.properties));
                                    return;
                                } else Br(yr, Vr, Zr, !1);
                            } else if (Fr === "Polygon") Br(yr, Vr, Zr, !0);
                            else if (Fr === "MultiPolygon") for(Si = 0; Si < yr.length; Si++){
                                var Mi = [];
                                Br(yr[Si], Mi, Zr, !0), Vr.push(Mi);
                            }
                            else if (Fr === "GeometryCollection") {
                                for(Si = 0; Si < ft.geometry.geometries.length; Si++)$t(It, {
                                    id: gi,
                                    geometry: ft.geometry.geometries[Si],
                                    properties: ft.properties
                                }, jt, Zt);
                                return;
                            } else throw new Error("Input data is not a valid GeoJSON object.");
                            It.push(St(gi, Fr, Vr, ft.properties));
                        }
                    }
                    function fr(It, ft) {
                        ft.push(Or(It[0])), ft.push(Nr(It[1])), ft.push(0);
                    }
                    function _r(It, ft, jt, Zt) {
                        for(var yr, Fr, Zr = 0, Vr = 0; Vr < It.length; Vr++){
                            var gi = Or(It[Vr][0]), Si = Nr(It[Vr][1]);
                            ft.push(gi), ft.push(Si), ft.push(0), Vr > 0 && (Zt ? Zr += (yr * Si - gi * Fr) / 2 : Zr += Math.sqrt(Math.pow(gi - yr, 2) + Math.pow(Si - Fr, 2))), yr = gi, Fr = Si;
                        }
                        var Mi = ft.length - 3;
                        ft[2] = 1, bt(ft, 0, Mi, jt), ft[Mi + 2] = 1, ft.size = Math.abs(Zr), ft.start = 0, ft.end = ft.size;
                    }
                    function Br(It, ft, jt, Zt) {
                        for(var yr = 0; yr < It.length; yr++){
                            var Fr = [];
                            _r(It[yr], Fr, jt, Zt), ft.push(Fr);
                        }
                    }
                    function Or(It) {
                        return It / 360 + .5;
                    }
                    function Nr(It) {
                        var ft = Math.sin(It * Math.PI / 180), jt = .5 - .25 * Math.log((1 + ft) / (1 - ft)) / Math.PI;
                        return jt < 0 ? 0 : jt > 1 ? 1 : jt;
                    }
                    function ut(It, ft, jt, Zt, yr, Fr, Zr, Vr) {
                        if (jt /= ft, Zt /= ft, Fr >= jt && Zr < Zt) return It;
                        if (Zr < jt || Fr >= Zt) return null;
                        for(var gi = [], Si = 0; Si < It.length; Si++){
                            var Mi = It[Si], Pi = Mi.geometry, Gi = Mi.type, Ki = yr === 0 ? Mi.minX : Mi.minY, ka = yr === 0 ? Mi.maxX : Mi.maxY;
                            if (Ki >= jt && ka < Zt) {
                                gi.push(Mi);
                                continue;
                            } else if (ka < jt || Ki >= Zt) continue;
                            var jn = [];
                            if (Gi === "Point" || Gi === "MultiPoint") Ne(Pi, jn, jt, Zt, yr);
                            else if (Gi === "LineString") Ye(Pi, jn, jt, Zt, yr, !1, Vr.lineMetrics);
                            else if (Gi === "MultiLineString") Xe(Pi, jn, jt, Zt, yr, !1);
                            else if (Gi === "Polygon") Xe(Pi, jn, jt, Zt, yr, !0);
                            else if (Gi === "MultiPolygon") for(var la = 0; la < Pi.length; la++){
                                var Fa = [];
                                Xe(Pi[la], Fa, jt, Zt, yr, !0), Fa.length && jn.push(Fa);
                            }
                            if (jn.length) {
                                if (Vr.lineMetrics && Gi === "LineString") {
                                    for(la = 0; la < jn.length; la++)gi.push(St(Mi.id, Gi, jn[la], Mi.tags));
                                    continue;
                                }
                                (Gi === "LineString" || Gi === "MultiLineString") && (jn.length === 1 ? (Gi = "LineString", jn = jn[0]) : Gi = "MultiLineString"), (Gi === "Point" || Gi === "MultiPoint") && (Gi = jn.length === 3 ? "Point" : "MultiPoint"), gi.push(St(Mi.id, Gi, jn, Mi.tags));
                            }
                        }
                        return gi.length ? gi : null;
                    }
                    function Ne(It, ft, jt, Zt, yr) {
                        for(var Fr = 0; Fr < It.length; Fr += 3){
                            var Zr = It[Fr + yr];
                            Zr >= jt && Zr <= Zt && (ft.push(It[Fr]), ft.push(It[Fr + 1]), ft.push(It[Fr + 2]));
                        }
                    }
                    function Ye(It, ft, jt, Zt, yr, Fr, Zr) {
                        for(var Vr = Ve(It), gi = yr === 0 ? Le : xe, Si = It.start, Mi, Pi, Gi = 0; Gi < It.length - 3; Gi += 3){
                            var Ki = It[Gi], ka = It[Gi + 1], jn = It[Gi + 2], la = It[Gi + 3], Fa = It[Gi + 4], Ra = yr === 0 ? Ki : ka, jo = yr === 0 ? la : Fa, oa = !1;
                            Zr && (Mi = Math.sqrt(Math.pow(Ki - la, 2) + Math.pow(ka - Fa, 2))), Ra < jt ? jo > jt && (Pi = gi(Vr, Ki, ka, la, Fa, jt), Zr && (Vr.start = Si + Mi * Pi)) : Ra > Zt ? jo < Zt && (Pi = gi(Vr, Ki, ka, la, Fa, Zt), Zr && (Vr.start = Si + Mi * Pi)) : ht(Vr, Ki, ka, jn), jo < jt && Ra >= jt && (Pi = gi(Vr, Ki, ka, la, Fa, jt), oa = !0), jo > Zt && Ra <= Zt && (Pi = gi(Vr, Ki, ka, la, Fa, Zt), oa = !0), !Fr && oa && (Zr && (Vr.end = Si + Mi * Pi), ft.push(Vr), Vr = Ve(It)), Zr && (Si += Mi);
                        }
                        var Sn = It.length - 3;
                        Ki = It[Sn], ka = It[Sn + 1], jn = It[Sn + 2], Ra = yr === 0 ? Ki : ka, Ra >= jt && Ra <= Zt && ht(Vr, Ki, ka, jn), Sn = Vr.length - 3, Fr && Sn >= 3 && (Vr[Sn] !== Vr[0] || Vr[Sn + 1] !== Vr[1]) && ht(Vr, Vr[0], Vr[1], Vr[2]), Vr.length && ft.push(Vr);
                    }
                    function Ve(It) {
                        var ft = [];
                        return ft.size = It.size, ft.start = It.start, ft.end = It.end, ft;
                    }
                    function Xe(It, ft, jt, Zt, yr, Fr) {
                        for(var Zr = 0; Zr < It.length; Zr++)Ye(It[Zr], ft, jt, Zt, yr, Fr, !1);
                    }
                    function ht(It, ft, jt, Zt) {
                        It.push(ft), It.push(jt), It.push(Zt);
                    }
                    function Le(It, ft, jt, Zt, yr, Fr) {
                        var Zr = (Fr - ft) / (Zt - ft);
                        return It.push(Fr), It.push(jt + (yr - jt) * Zr), It.push(1), Zr;
                    }
                    function xe(It, ft, jt, Zt, yr, Fr) {
                        var Zr = (Fr - jt) / (yr - jt);
                        return It.push(ft + (Zt - ft) * Zr), It.push(Fr), It.push(1), Zr;
                    }
                    function Se(It, ft) {
                        var jt = ft.buffer / ft.extent, Zt = It, yr = ut(It, 1, -1 - jt, jt, 0, -1, 2, ft), Fr = ut(It, 1, 1 - jt, 2 + jt, 0, -1, 2, ft);
                        return (yr || Fr) && (Zt = ut(It, 1, -jt, 1 + jt, 0, -1, 2, ft) || [], yr && (Zt = lt(yr, 1).concat(Zt)), Fr && (Zt = Zt.concat(lt(Fr, -1)))), Zt;
                    }
                    function lt(It, ft) {
                        for(var jt = [], Zt = 0; Zt < It.length; Zt++){
                            var yr = It[Zt], Fr = yr.type, Zr;
                            if (Fr === "Point" || Fr === "MultiPoint" || Fr === "LineString") Zr = Gt(yr.geometry, ft);
                            else if (Fr === "MultiLineString" || Fr === "Polygon") {
                                Zr = [];
                                for(var Vr = 0; Vr < yr.geometry.length; Vr++)Zr.push(Gt(yr.geometry[Vr], ft));
                            } else if (Fr === "MultiPolygon") for(Zr = [], Vr = 0; Vr < yr.geometry.length; Vr++){
                                for(var gi = [], Si = 0; Si < yr.geometry[Vr].length; Si++)gi.push(Gt(yr.geometry[Vr][Si], ft));
                                Zr.push(gi);
                            }
                            jt.push(St(yr.id, Fr, Zr, yr.tags));
                        }
                        return jt;
                    }
                    function Gt(It, ft) {
                        var jt = [];
                        jt.size = It.size, It.start !== void 0 && (jt.start = It.start, jt.end = It.end);
                        for(var Zt = 0; Zt < It.length; Zt += 3)jt.push(It[Zt] + ft, It[Zt + 1], It[Zt + 2]);
                        return jt;
                    }
                    function Vt(It, ft) {
                        if (It.transformed) return It;
                        var jt = 1 << It.z, Zt = It.x, yr = It.y, Fr, Zr, Vr;
                        for(Fr = 0; Fr < It.features.length; Fr++){
                            var gi = It.features[Fr], Si = gi.geometry, Mi = gi.type;
                            if (gi.geometry = [], Mi === 1) for(Zr = 0; Zr < Si.length; Zr += 2)gi.geometry.push(ar(Si[Zr], Si[Zr + 1], ft, jt, Zt, yr));
                            else for(Zr = 0; Zr < Si.length; Zr++){
                                var Pi = [];
                                for(Vr = 0; Vr < Si[Zr].length; Vr += 2)Pi.push(ar(Si[Zr][Vr], Si[Zr][Vr + 1], ft, jt, Zt, yr));
                                gi.geometry.push(Pi);
                            }
                        }
                        return It.transformed = !0, It;
                    }
                    function ar(It, ft, jt, Zt, yr, Fr) {
                        return [
                            Math.round(jt * (It * Zt - yr)),
                            Math.round(jt * (ft * Zt - Fr))
                        ];
                    }
                    function Qr(It, ft, jt, Zt, yr) {
                        for(var Fr = ft === yr.maxZoom ? 0 : yr.tolerance / ((1 << ft) * yr.extent), Zr = {
                            features: [],
                            numPoints: 0,
                            numSimplified: 0,
                            numFeatures: 0,
                            source: null,
                            x: jt,
                            y: Zt,
                            z: ft,
                            transformed: !1,
                            minX: 2,
                            minY: 1,
                            maxX: -1,
                            maxY: 0
                        }, Vr = 0; Vr < It.length; Vr++){
                            Zr.numFeatures++, ai(Zr, It[Vr], Fr, yr);
                            var gi = It[Vr].minX, Si = It[Vr].minY, Mi = It[Vr].maxX, Pi = It[Vr].maxY;
                            gi < Zr.minX && (Zr.minX = gi), Si < Zr.minY && (Zr.minY = Si), Mi > Zr.maxX && (Zr.maxX = Mi), Pi > Zr.maxY && (Zr.maxY = Pi);
                        }
                        return Zr;
                    }
                    function ai(It, ft, jt, Zt) {
                        var yr = ft.geometry, Fr = ft.type, Zr = [];
                        if (Fr === "Point" || Fr === "MultiPoint") for(var Vr = 0; Vr < yr.length; Vr += 3)Zr.push(yr[Vr]), Zr.push(yr[Vr + 1]), It.numPoints++, It.numSimplified++;
                        else if (Fr === "LineString") jr(Zr, yr, It, jt, !1, !1);
                        else if (Fr === "MultiLineString" || Fr === "Polygon") for(Vr = 0; Vr < yr.length; Vr++)jr(Zr, yr[Vr], It, jt, Fr === "Polygon", Vr === 0);
                        else if (Fr === "MultiPolygon") for(var gi = 0; gi < yr.length; gi++){
                            var Si = yr[gi];
                            for(Vr = 0; Vr < Si.length; Vr++)jr(Zr, Si[Vr], It, jt, !0, Vr === 0);
                        }
                        if (Zr.length) {
                            var Mi = ft.tags || null;
                            if (Fr === "LineString" && Zt.lineMetrics) {
                                Mi = {};
                                for(var Pi in ft.tags)Mi[Pi] = ft.tags[Pi];
                                Mi.mapbox_clip_start = yr.start / yr.size, Mi.mapbox_clip_end = yr.end / yr.size;
                            }
                            var Gi = {
                                geometry: Zr,
                                type: Fr === "Polygon" || Fr === "MultiPolygon" ? 3 : Fr === "LineString" || Fr === "MultiLineString" ? 2 : 1,
                                tags: Mi
                            };
                            ft.id !== null && (Gi.id = ft.id), It.features.push(Gi);
                        }
                    }
                    function jr(It, ft, jt, Zt, yr, Fr) {
                        var Zr = Zt * Zt;
                        if (Zt > 0 && ft.size < (yr ? Zr : Zt)) {
                            jt.numPoints += ft.length / 3;
                            return;
                        }
                        for(var Vr = [], gi = 0; gi < ft.length; gi += 3)(Zt === 0 || ft[gi + 2] > Zr) && (jt.numSimplified++, Vr.push(ft[gi]), Vr.push(ft[gi + 1])), jt.numPoints++;
                        yr && ri(Vr, Fr), It.push(Vr);
                    }
                    function ri(It, ft) {
                        for(var jt = 0, Zt = 0, yr = It.length, Fr = yr - 2; Zt < yr; Fr = Zt, Zt += 2)jt += (It[Zt] - It[Fr]) * (It[Zt + 1] + It[Fr + 1]);
                        if (jt > 0 === ft) for(Zt = 0, yr = It.length; Zt < yr / 2; Zt += 2){
                            var Zr = It[Zt], Vr = It[Zt + 1];
                            It[Zt] = It[yr - 2 - Zt], It[Zt + 1] = It[yr - 1 - Zt], It[yr - 2 - Zt] = Zr, It[yr - 1 - Zt] = Vr;
                        }
                    }
                    function bi(It, ft) {
                        return new nn(It, ft);
                    }
                    function nn(It, ft) {
                        ft = this.options = Ni(Object.create(this.options), ft);
                        var jt = ft.debug;
                        if (jt && console.time("preprocess data"), ft.maxZoom < 0 || ft.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                        if (ft.promoteId && ft.generateId) throw new Error("promoteId and generateId cannot be used together.");
                        var Zt = Ht(It, ft);
                        this.tiles = {}, this.tileCoords = [], jt && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", ft.indexMaxZoom, ft.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), Zt = Se(Zt, ft), Zt.length && this.splitTile(Zt, 0, 0, 0), jt && (Zt.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
                    }
                    nn.prototype.options = {
                        maxZoom: 14,
                        indexMaxZoom: 5,
                        indexMaxPoints: 1e5,
                        tolerance: 3,
                        extent: 4096,
                        buffer: 64,
                        lineMetrics: !1,
                        promoteId: null,
                        generateId: !1,
                        debug: 0
                    }, nn.prototype.splitTile = function(It, ft, jt, Zt, yr, Fr, Zr) {
                        for(var Vr = [
                            It,
                            ft,
                            jt,
                            Zt
                        ], gi = this.options, Si = gi.debug; Vr.length;){
                            Zt = Vr.pop(), jt = Vr.pop(), ft = Vr.pop(), It = Vr.pop();
                            var Mi = 1 << ft, Pi = Wi(ft, jt, Zt), Gi = this.tiles[Pi];
                            if (!Gi && (Si > 1 && console.time("creation"), Gi = this.tiles[Pi] = Qr(It, ft, jt, Zt, gi), this.tileCoords.push({
                                z: ft,
                                x: jt,
                                y: Zt
                            }), Si)) {
                                Si > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", ft, jt, Zt, Gi.numFeatures, Gi.numPoints, Gi.numSimplified), console.timeEnd("creation"));
                                var Ki = "z" + ft;
                                this.stats[Ki] = (this.stats[Ki] || 0) + 1, this.total++;
                            }
                            if (Gi.source = It, yr) {
                                if (ft === gi.maxZoom || ft === yr) continue;
                                var ka = 1 << yr - ft;
                                if (jt !== Math.floor(Fr / ka) || Zt !== Math.floor(Zr / ka)) continue;
                            } else if (ft === gi.indexMaxZoom || Gi.numPoints <= gi.indexMaxPoints) continue;
                            if (Gi.source = null, It.length !== 0) {
                                Si > 1 && console.time("clipping");
                                var jn = .5 * gi.buffer / gi.extent, la = .5 - jn, Fa = .5 + jn, Ra = 1 + jn, jo, oa, Sn, Ha, oo, xn;
                                jo = oa = Sn = Ha = null, oo = ut(It, Mi, jt - jn, jt + Fa, 0, Gi.minX, Gi.maxX, gi), xn = ut(It, Mi, jt + la, jt + Ra, 0, Gi.minX, Gi.maxX, gi), It = null, oo && (jo = ut(oo, Mi, Zt - jn, Zt + Fa, 1, Gi.minY, Gi.maxY, gi), oa = ut(oo, Mi, Zt + la, Zt + Ra, 1, Gi.minY, Gi.maxY, gi), oo = null), xn && (Sn = ut(xn, Mi, Zt - jn, Zt + Fa, 1, Gi.minY, Gi.maxY, gi), Ha = ut(xn, Mi, Zt + la, Zt + Ra, 1, Gi.minY, Gi.maxY, gi), xn = null), Si > 1 && console.timeEnd("clipping"), Vr.push(jo || [], ft + 1, jt * 2, Zt * 2), Vr.push(oa || [], ft + 1, jt * 2, Zt * 2 + 1), Vr.push(Sn || [], ft + 1, jt * 2 + 1, Zt * 2), Vr.push(Ha || [], ft + 1, jt * 2 + 1, Zt * 2 + 1);
                            }
                        }
                    }, nn.prototype.getTile = function(It, ft, jt) {
                        var Zt = this.options, yr = Zt.extent, Fr = Zt.debug;
                        if (It < 0 || It > 24) return null;
                        var Zr = 1 << It;
                        ft = (ft % Zr + Zr) % Zr;
                        var Vr = Wi(It, ft, jt);
                        if (this.tiles[Vr]) return Vt(this.tiles[Vr], yr);
                        Fr > 1 && console.log("drilling down to z%d-%d-%d", It, ft, jt);
                        for(var gi = It, Si = ft, Mi = jt, Pi; !Pi && gi > 0;)gi--, Si = Math.floor(Si / 2), Mi = Math.floor(Mi / 2), Pi = this.tiles[Wi(gi, Si, Mi)];
                        return !Pi || !Pi.source ? null : (Fr > 1 && console.log("found parent tile z%d-%d-%d", gi, Si, Mi), Fr > 1 && console.time("drilling down"), this.splitTile(Pi.source, gi, Si, Mi, It, ft, jt), Fr > 1 && console.timeEnd("drilling down"), this.tiles[Vr] ? Vt(this.tiles[Vr], yr) : null);
                    };
                    function Wi(It, ft, jt) {
                        return ((1 << It) * jt + ft) * 32 + It;
                    }
                    function Ni(It, ft) {
                        for(var jt in ft)It[jt] = ft[jt];
                        return It;
                    }
                    function _n(It, ft) {
                        var jt = It.tileID.canonical;
                        if (!this._geoJSONIndex) return ft(null, null);
                        var Zt = this._geoJSONIndex.getTile(jt.z, jt.x, jt.y);
                        if (!Zt) return ft(null, null);
                        var yr = new C(Zt.features), Fr = F(yr);
                        (Fr.byteOffset !== 0 || Fr.byteLength !== Fr.buffer.byteLength) && (Fr = new Uint8Array(Fr)), ft(null, {
                            vectorTile: yr,
                            rawData: Fr.buffer
                        });
                    }
                    var $i = function(It) {
                        function ft(jt, Zt, yr, Fr) {
                            It.call(this, jt, Zt, yr, _n), Fr && (this.loadGeoJSON = Fr);
                        }
                        return It && (ft.__proto__ = It), ft.prototype = Object.create(It && It.prototype), ft.prototype.constructor = ft, ft.prototype.loadData = function(Zt, yr) {
                            this._pendingCallback && this._pendingCallback(null, {
                                abandoned: !0
                            }), this._pendingCallback = yr, this._pendingLoadDataParams = Zt, this._state && this._state !== "Idle" ? this._state = "NeedsLoadData" : (this._state = "Coalescing", this._loadData());
                        }, ft.prototype._loadData = function() {
                            var Zt = this;
                            if (!(!this._pendingCallback || !this._pendingLoadDataParams)) {
                                var yr = this._pendingCallback, Fr = this._pendingLoadDataParams;
                                delete this._pendingCallback, delete this._pendingLoadDataParams;
                                var Zr = Fr && Fr.request && Fr.request.collectResourceTiming ? new i.RequestPerformance(Fr.request) : !1;
                                this.loadGeoJSON(Fr, function(Vr, gi) {
                                    if (Vr || !gi) return yr(Vr);
                                    if (typeof gi != "object") return yr(new Error("Input data given to '" + Fr.source + "' is not a valid GeoJSON object."));
                                    p(gi, !0);
                                    try {
                                        if (Fr.filter) {
                                            var Si = i.createExpression(Fr.filter, {
                                                type: "boolean",
                                                "property-type": "data-driven",
                                                overridable: !1,
                                                transition: !1
                                            });
                                            if (Si.result === "error") throw new Error(Si.value.map(function(Ki) {
                                                return Ki.key + ": " + Ki.message;
                                            }).join(", "));
                                            var Mi = gi.features.filter(function(Ki) {
                                                return Si.value.evaluate({
                                                    zoom: 0
                                                }, Ki);
                                            });
                                            gi = {
                                                type: "FeatureCollection",
                                                features: Mi
                                            };
                                        }
                                        Zt._geoJSONIndex = Fr.cluster ? new ct(zn(Fr)).load(gi.features) : bi(gi, Fr.geojsonVtOptions);
                                    } catch (Ki) {
                                        return yr(Ki);
                                    }
                                    Zt.loaded = {};
                                    var Pi = {};
                                    if (Zr) {
                                        var Gi = Zr.finish();
                                        Gi && (Pi.resourceTiming = {}, Pi.resourceTiming[Fr.source] = JSON.parse(JSON.stringify(Gi)));
                                    }
                                    yr(null, Pi);
                                });
                            }
                        }, ft.prototype.coalesce = function() {
                            this._state === "Coalescing" ? this._state = "Idle" : this._state === "NeedsLoadData" && (this._state = "Coalescing", this._loadData());
                        }, ft.prototype.reloadTile = function(Zt, yr) {
                            var Fr = this.loaded, Zr = Zt.uid;
                            return Fr && Fr[Zr] ? It.prototype.reloadTile.call(this, Zt, yr) : this.loadTile(Zt, yr);
                        }, ft.prototype.loadGeoJSON = function(Zt, yr) {
                            if (Zt.request) i.getJSON(Zt.request, yr);
                            else if (typeof Zt.data == "string") try {
                                return yr(null, JSON.parse(Zt.data));
                            } catch (Fr) {
                                return yr(new Error("Input data given to '" + Zt.source + "' is not a valid GeoJSON object."));
                            }
                            else return yr(new Error("Input data given to '" + Zt.source + "' is not a valid GeoJSON object."));
                        }, ft.prototype.removeSource = function(Zt, yr) {
                            this._pendingCallback && this._pendingCallback(null, {
                                abandoned: !0
                            }), yr();
                        }, ft.prototype.getClusterExpansionZoom = function(Zt, yr) {
                            try {
                                yr(null, this._geoJSONIndex.getClusterExpansionZoom(Zt.clusterId));
                            } catch (Fr) {
                                yr(Fr);
                            }
                        }, ft.prototype.getClusterChildren = function(Zt, yr) {
                            try {
                                yr(null, this._geoJSONIndex.getChildren(Zt.clusterId));
                            } catch (Fr) {
                                yr(Fr);
                            }
                        }, ft.prototype.getClusterLeaves = function(Zt, yr) {
                            try {
                                yr(null, this._geoJSONIndex.getLeaves(Zt.clusterId, Zt.limit, Zt.offset));
                            } catch (Fr) {
                                yr(Fr);
                            }
                        }, ft;
                    }(v);
                    function zn(It) {
                        var ft = It.superclusterOptions, jt = It.clusterProperties;
                        if (!jt || !ft) return ft;
                        for(var Zt = {}, yr = {}, Fr = {
                            accumulated: null,
                            zoom: 0
                        }, Zr = {
                            properties: null
                        }, Vr = Object.keys(jt), gi = 0, Si = Vr; gi < Si.length; gi += 1){
                            var Mi = Si[gi], Pi = jt[Mi], Gi = Pi[0], Ki = Pi[1], ka = i.createExpression(Ki), jn = i.createExpression(typeof Gi == "string" ? [
                                Gi,
                                [
                                    "accumulated"
                                ],
                                [
                                    "get",
                                    Mi
                                ]
                            ] : Gi);
                            Zt[Mi] = ka.value, yr[Mi] = jn.value;
                        }
                        return ft.map = function(la) {
                            Zr.properties = la;
                            for(var Fa = {}, Ra = 0, jo = Vr; Ra < jo.length; Ra += 1){
                                var oa = jo[Ra];
                                Fa[oa] = Zt[oa].evaluate(Fr, Zr);
                            }
                            return Fa;
                        }, ft.reduce = function(la, Fa) {
                            Zr.properties = Fa;
                            for(var Ra = 0, jo = Vr; Ra < jo.length; Ra += 1){
                                var oa = jo[Ra];
                                Fr.accumulated = la[oa], la[oa] = yr[oa].evaluate(Fr, Zr);
                            }
                        }, ft;
                    }
                    var Wn = function(ft) {
                        var jt = this;
                        this.self = ft, this.actor = new i.Actor(ft, this), this.layerIndexes = {}, this.availableImages = {}, this.workerSourceTypes = {
                            vector: v,
                            geojson: $i
                        }, this.workerSources = {}, this.demWorkerSources = {}, this.self.registerWorkerSource = function(Zt, yr) {
                            if (jt.workerSourceTypes[Zt]) throw new Error('Worker source with name "' + Zt + '" already registered.');
                            jt.workerSourceTypes[Zt] = yr;
                        }, this.self.registerRTLTextPlugin = function(Zt) {
                            if (i.plugin.isParsed()) throw new Error("RTL text plugin already registered.");
                            i.plugin.applyArabicShaping = Zt.applyArabicShaping, i.plugin.processBidirectionalText = Zt.processBidirectionalText, i.plugin.processStyledBidirectionalText = Zt.processStyledBidirectionalText;
                        };
                    };
                    return Wn.prototype.setReferrer = function(ft, jt) {
                        this.referrer = jt;
                    }, Wn.prototype.setImages = function(ft, jt, Zt) {
                        this.availableImages[ft] = jt;
                        for(var yr in this.workerSources[ft]){
                            var Fr = this.workerSources[ft][yr];
                            for(var Zr in Fr)Fr[Zr].availableImages = jt;
                        }
                        Zt();
                    }, Wn.prototype.setLayers = function(ft, jt, Zt) {
                        this.getLayerIndex(ft).replace(jt), Zt();
                    }, Wn.prototype.updateLayers = function(ft, jt, Zt) {
                        this.getLayerIndex(ft).update(jt.layers, jt.removedIds), Zt();
                    }, Wn.prototype.loadTile = function(ft, jt, Zt) {
                        this.getWorkerSource(ft, jt.type, jt.source).loadTile(jt, Zt);
                    }, Wn.prototype.loadDEMTile = function(ft, jt, Zt) {
                        this.getDEMWorkerSource(ft, jt.source).loadTile(jt, Zt);
                    }, Wn.prototype.reloadTile = function(ft, jt, Zt) {
                        this.getWorkerSource(ft, jt.type, jt.source).reloadTile(jt, Zt);
                    }, Wn.prototype.abortTile = function(ft, jt, Zt) {
                        this.getWorkerSource(ft, jt.type, jt.source).abortTile(jt, Zt);
                    }, Wn.prototype.removeTile = function(ft, jt, Zt) {
                        this.getWorkerSource(ft, jt.type, jt.source).removeTile(jt, Zt);
                    }, Wn.prototype.removeDEMTile = function(ft, jt) {
                        this.getDEMWorkerSource(ft, jt.source).removeTile(jt);
                    }, Wn.prototype.removeSource = function(ft, jt, Zt) {
                        if (!(!this.workerSources[ft] || !this.workerSources[ft][jt.type] || !this.workerSources[ft][jt.type][jt.source])) {
                            var yr = this.workerSources[ft][jt.type][jt.source];
                            delete this.workerSources[ft][jt.type][jt.source], yr.removeSource !== void 0 ? yr.removeSource(jt, Zt) : Zt();
                        }
                    }, Wn.prototype.loadWorkerSource = function(ft, jt, Zt) {
                        try {
                            this.self.importScripts(jt.url), Zt();
                        } catch (yr) {
                            Zt(yr.toString());
                        }
                    }, Wn.prototype.syncRTLPluginState = function(ft, jt, Zt) {
                        try {
                            i.plugin.setState(jt);
                            var yr = i.plugin.getPluginURL();
                            if (i.plugin.isLoaded() && !i.plugin.isParsed() && yr != null) {
                                this.self.importScripts(yr);
                                var Fr = i.plugin.isParsed(), Zr = Fr ? void 0 : new Error("RTL Text Plugin failed to import scripts from " + yr);
                                Zt(Zr, Fr);
                            }
                        } catch (Vr) {
                            Zt(Vr.toString());
                        }
                    }, Wn.prototype.getAvailableImages = function(ft) {
                        var jt = this.availableImages[ft];
                        return jt || (jt = []), jt;
                    }, Wn.prototype.getLayerIndex = function(ft) {
                        var jt = this.layerIndexes[ft];
                        return jt || (jt = this.layerIndexes[ft] = new l), jt;
                    }, Wn.prototype.getWorkerSource = function(ft, jt, Zt) {
                        var yr = this;
                        if (this.workerSources[ft] || (this.workerSources[ft] = {}), this.workerSources[ft][jt] || (this.workerSources[ft][jt] = {}), !this.workerSources[ft][jt][Zt]) {
                            var Fr = {
                                send: function(Zr, Vr, gi) {
                                    yr.actor.send(Zr, Vr, gi, ft);
                                }
                            };
                            this.workerSources[ft][jt][Zt] = new this.workerSourceTypes[jt](Fr, this.getLayerIndex(ft), this.getAvailableImages(ft));
                        }
                        return this.workerSources[ft][jt][Zt];
                    }, Wn.prototype.getDEMWorkerSource = function(ft, jt) {
                        return this.demWorkerSources[ft] || (this.demWorkerSources[ft] = {}), this.demWorkerSources[ft][jt] || (this.demWorkerSources[ft][jt] = new b), this.demWorkerSources[ft][jt];
                    }, Wn.prototype.enforceCacheSizeLimit = function(ft, jt) {
                        i.enforceCacheSizeLimit(jt);
                    }, typeof WorkerGlobalScope != "undefined" && typeof self != "undefined" && self instanceof WorkerGlobalScope && (self.worker = new Wn(self)), Wn;
                }), n([
                    "./shared"
                ], function(i) {
                    "use strict";
                    var a = i.createCommonjsModule(function(Y1) {
                        Y1.exports ? Y1.exports = z : window && (window.mapboxgl = window.mapboxgl || {}, window.mapboxgl.supported = z, window.mapboxgl.notSupportedReason = K);
                        function z(rr) {
                            return !K(rr);
                        }
                        function K(rr) {
                            if (!O()) return "not a browser";
                            if (!$()) return "insufficent Array support";
                            if (!pe()) return "insufficient Function support";
                            if (!de()) return "insufficient Object support";
                            if (!Ie()) return "insufficient JSON support";
                            if (!$e()) return "insufficient worker support";
                            if (!pt()) return "insufficient Uint8ClampedArray support";
                            if (!Kt()) return "insufficient ArrayBuffer support";
                            if (!ir()) return "insufficient Canvas/getImageData support";
                            if (!vt(rr && rr.failIfMajorPerformanceCaveat)) return "insufficient WebGL support";
                        }
                        function O() {
                            return typeof window != "undefined" && typeof document != "undefined";
                        }
                        function $() {
                            return Array.prototype && Array.prototype.every && Array.prototype.filter && Array.prototype.forEach && Array.prototype.indexOf && Array.prototype.lastIndexOf && Array.prototype.map && Array.prototype.some && Array.prototype.reduce && Array.prototype.reduceRight && Array.isArray;
                        }
                        function pe() {
                            return Function.prototype && Function.prototype.bind;
                        }
                        function de() {
                            return Object.keys && Object.create && Object.getPrototypeOf && Object.getOwnPropertyNames && Object.isSealed && Object.isFrozen && Object.isExtensible && Object.getOwnPropertyDescriptor && Object.defineProperty && Object.defineProperties && Object.seal && Object.freeze && Object.preventExtensions;
                        }
                        function Ie() {
                            return "JSON" in window && "parse" in JSON && "stringify" in JSON;
                        }
                        function $e() {
                            if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                            var rr = new Blob([
                                ""
                            ], {
                                type: "text/javascript"
                            }), dr = URL.createObjectURL(rr), pr, kr;
                            try {
                                kr = new Worker(dr), pr = !0;
                            } catch (Ar) {
                                pr = !1;
                            }
                            return kr && kr.terminate(), URL.revokeObjectURL(dr), pr;
                        }
                        function pt() {
                            return "Uint8ClampedArray" in window;
                        }
                        function Kt() {
                            return ArrayBuffer.isView;
                        }
                        function ir() {
                            var rr = document.createElement("canvas");
                            rr.width = rr.height = 1;
                            var dr = rr.getContext("2d");
                            if (!dr) return !1;
                            var pr = dr.getImageData(0, 0, 1, 1);
                            return pr && pr.width === rr.width;
                        }
                        var Jt = {};
                        function vt(rr) {
                            return Jt[rr] === void 0 && (Jt[rr] = Wt(rr)), Jt[rr];
                        }
                        z.webGLContextAttributes = {
                            antialias: !1,
                            alpha: !0,
                            stencil: !0,
                            depth: !0
                        };
                        function Pt(rr) {
                            var dr = document.createElement("canvas"), pr = Object.create(z.webGLContextAttributes);
                            return pr.failIfMajorPerformanceCaveat = rr, dr.probablySupportsContext ? dr.probablySupportsContext("webgl", pr) || dr.probablySupportsContext("experimental-webgl", pr) : dr.supportsContext ? dr.supportsContext("webgl", pr) || dr.supportsContext("experimental-webgl", pr) : dr.getContext("webgl", pr) || dr.getContext("experimental-webgl", pr);
                        }
                        function Wt(rr) {
                            var dr = Pt(rr);
                            if (!dr) return !1;
                            var pr = dr.createShader(dr.VERTEX_SHADER);
                            return !pr || dr.isContextLost() ? !1 : (dr.shaderSource(pr, "void main() {}"), dr.compileShader(pr), dr.getShaderParameter(pr, dr.COMPILE_STATUS) === !0);
                        }
                    }), o = {};
                    o.create = function(Y1, z, K) {
                        var O = i.window.document.createElement(Y1);
                        return z !== void 0 && (O.className = z), K && K.appendChild(O), O;
                    }, o.createNS = function(Y1, z) {
                        var K = i.window.document.createElementNS(Y1, z);
                        return K;
                    };
                    var s = i.window.document && i.window.document.documentElement.style;
                    function l(Y1) {
                        if (!s) return Y1[0];
                        for(var z = 0; z < Y1.length; z++)if (Y1[z] in s) return Y1[z];
                        return Y1[0];
                    }
                    var u = l([
                        "userSelect",
                        "MozUserSelect",
                        "WebkitUserSelect",
                        "msUserSelect"
                    ]), c;
                    o.disableDrag = function() {
                        s && u && (c = s[u], s[u] = "none");
                    }, o.enableDrag = function() {
                        s && u && (s[u] = c);
                    };
                    var f = l([
                        "transform",
                        "WebkitTransform"
                    ]);
                    o.setTransform = function(Y1, z) {
                        Y1.style[f] = z;
                    };
                    var h = !1;
                    try {
                        var d = Object.defineProperty({}, "passive", {
                            get: function() {
                                h = !0;
                            }
                        });
                        i.window.addEventListener("test", d, d), i.window.removeEventListener("test", d, d);
                    } catch (Y1) {
                        h = !1;
                    }
                    o.addEventListener = function(Y1, z, K, O) {
                        O === void 0 && (O = {}), "passive" in O && h ? Y1.addEventListener(z, K, O) : Y1.addEventListener(z, K, O.capture);
                    }, o.removeEventListener = function(Y1, z, K, O) {
                        O === void 0 && (O = {}), "passive" in O && h ? Y1.removeEventListener(z, K, O) : Y1.removeEventListener(z, K, O.capture);
                    };
                    var v = function(Y1) {
                        Y1.preventDefault(), Y1.stopPropagation(), i.window.removeEventListener("click", v, !0);
                    };
                    o.suppressClick = function() {
                        i.window.addEventListener("click", v, !0), i.window.setTimeout(function() {
                            i.window.removeEventListener("click", v, !0);
                        }, 0);
                    }, o.mousePos = function(Y1, z) {
                        var K = Y1.getBoundingClientRect();
                        return new i.Point(z.clientX - K.left - Y1.clientLeft, z.clientY - K.top - Y1.clientTop);
                    }, o.touchPos = function(Y1, z) {
                        for(var K = Y1.getBoundingClientRect(), O = [], $ = 0; $ < z.length; $++)O.push(new i.Point(z[$].clientX - K.left - Y1.clientLeft, z[$].clientY - K.top - Y1.clientTop));
                        return O;
                    }, o.mouseButton = function(Y1) {
                        return typeof i.window.InstallTrigger != "undefined" && Y1.button === 2 && Y1.ctrlKey && i.window.navigator.platform.toUpperCase().indexOf("MAC") >= 0 ? 0 : Y1.button;
                    }, o.remove = function(Y1) {
                        Y1.parentNode && Y1.parentNode.removeChild(Y1);
                    };
                    function x(Y1, z, K) {
                        var O, $, pe, de = i.browser.devicePixelRatio > 1 ? "@2x" : "", Ie = i.getJSON(z.transformRequest(z.normalizeSpriteURL(Y1, de, ".json"), i.ResourceType.SpriteJSON), function(Kt, ir) {
                            Ie = null, pe || (pe = Kt, O = ir, pt());
                        }), $e = i.getImage(z.transformRequest(z.normalizeSpriteURL(Y1, de, ".png"), i.ResourceType.SpriteImage), function(Kt, ir) {
                            $e = null, pe || (pe = Kt, $ = ir, pt());
                        });
                        function pt() {
                            if (pe) K(pe);
                            else if (O && $) {
                                var Kt = i.browser.getImageData($), ir = {};
                                for(var Jt in O){
                                    var vt = O[Jt], Pt = vt.width, Wt = vt.height, rr = vt.x, dr = vt.y, pr = vt.sdf, kr = vt.pixelRatio, Ar = vt.stretchX, gr = vt.stretchY, Cr = vt.content, cr = new i.RGBAImage({
                                        width: Pt,
                                        height: Wt
                                    });
                                    i.RGBAImage.copy(Kt, cr, {
                                        x: rr,
                                        y: dr
                                    }, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        width: Pt,
                                        height: Wt
                                    }), ir[Jt] = {
                                        data: cr,
                                        pixelRatio: kr,
                                        sdf: pr,
                                        stretchX: Ar,
                                        stretchY: gr,
                                        content: Cr
                                    };
                                }
                                K(null, ir);
                            }
                        }
                        return {
                            cancel: function() {
                                Ie && (Ie.cancel(), Ie = null), $e && ($e.cancel(), $e = null);
                            }
                        };
                    }
                    function b(Y1) {
                        var z = Y1.userImage;
                        if (z && z.render) {
                            var K = z.render();
                            if (K) return Y1.data.replace(new Uint8Array(z.data.buffer)), !0;
                        }
                        return !1;
                    }
                    var p = 1, E = function(Y1) {
                        function z() {
                            Y1.call(this), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new i.RGBAImage({
                                width: 1,
                                height: 1
                            }), this.dirty = !0;
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.isLoaded = function() {
                            return this.loaded;
                        }, z.prototype.setLoaded = function(O) {
                            if (this.loaded !== O && (this.loaded = O, O)) {
                                for(var $ = 0, pe = this.requestors; $ < pe.length; $ += 1){
                                    var de = pe[$], Ie = de.ids, $e = de.callback;
                                    this._notify(Ie, $e);
                                }
                                this.requestors = [];
                            }
                        }, z.prototype.getImage = function(O) {
                            return this.images[O];
                        }, z.prototype.addImage = function(O, $) {
                            this._validate(O, $) && (this.images[O] = $);
                        }, z.prototype._validate = function(O, $) {
                            var pe = !0;
                            return this._validateStretch($.stretchX, $.data && $.data.width) || (this.fire(new i.ErrorEvent(new Error('Image "' + O + '" has invalid "stretchX" value'))), pe = !1), this._validateStretch($.stretchY, $.data && $.data.height) || (this.fire(new i.ErrorEvent(new Error('Image "' + O + '" has invalid "stretchY" value'))), pe = !1), this._validateContent($.content, $) || (this.fire(new i.ErrorEvent(new Error('Image "' + O + '" has invalid "content" value'))), pe = !1), pe;
                        }, z.prototype._validateStretch = function(O, $) {
                            if (!O) return !0;
                            for(var pe = 0, de = 0, Ie = O; de < Ie.length; de += 1){
                                var $e = Ie[de];
                                if ($e[0] < pe || $e[1] < $e[0] || $ < $e[1]) return !1;
                                pe = $e[1];
                            }
                            return !0;
                        }, z.prototype._validateContent = function(O, $) {
                            return O ? !(O.length !== 4 || O[0] < 0 || $.data.width < O[0] || O[1] < 0 || $.data.height < O[1] || O[2] < 0 || $.data.width < O[2] || O[3] < 0 || $.data.height < O[3] || O[2] < O[0] || O[3] < O[1]) : !0;
                        }, z.prototype.updateImage = function(O, $) {
                            var pe = this.images[O];
                            $.version = pe.version + 1, this.images[O] = $, this.updatedImages[O] = !0;
                        }, z.prototype.removeImage = function(O) {
                            var $ = this.images[O];
                            delete this.images[O], delete this.patterns[O], $.userImage && $.userImage.onRemove && $.userImage.onRemove();
                        }, z.prototype.listImages = function() {
                            return Object.keys(this.images);
                        }, z.prototype.getImages = function(O, $) {
                            var pe = !0;
                            if (!this.isLoaded()) for(var de = 0, Ie = O; de < Ie.length; de += 1){
                                var $e = Ie[de];
                                this.images[$e] || (pe = !1);
                            }
                            this.isLoaded() || pe ? this._notify(O, $) : this.requestors.push({
                                ids: O,
                                callback: $
                            });
                        }, z.prototype._notify = function(O, $) {
                            for(var pe = {}, de = 0, Ie = O; de < Ie.length; de += 1){
                                var $e = Ie[de];
                                this.images[$e] || this.fire(new i.Event("styleimagemissing", {
                                    id: $e
                                }));
                                var pt = this.images[$e];
                                pt ? pe[$e] = {
                                    data: pt.data.clone(),
                                    pixelRatio: pt.pixelRatio,
                                    sdf: pt.sdf,
                                    version: pt.version,
                                    stretchX: pt.stretchX,
                                    stretchY: pt.stretchY,
                                    content: pt.content,
                                    hasRenderCallback: !!(pt.userImage && pt.userImage.render)
                                } : i.warnOnce('Image "' + $e + '" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');
                            }
                            $(null, pe);
                        }, z.prototype.getPixelSize = function() {
                            var O = this.atlasImage, $ = O.width, pe = O.height;
                            return {
                                width: $,
                                height: pe
                            };
                        }, z.prototype.getPattern = function(O) {
                            var $ = this.patterns[O], pe = this.getImage(O);
                            if (!pe) return null;
                            if ($ && $.position.version === pe.version) return $.position;
                            if ($) $.position.version = pe.version;
                            else {
                                var de = pe.data.width + p * 2, Ie = pe.data.height + p * 2, $e = {
                                    w: de,
                                    h: Ie,
                                    x: 0,
                                    y: 0
                                }, pt = new i.ImagePosition($e, pe);
                                this.patterns[O] = {
                                    bin: $e,
                                    position: pt
                                };
                            }
                            return this._updatePatternAtlas(), this.patterns[O].position;
                        }, z.prototype.bind = function(O) {
                            var $ = O.gl;
                            this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new i.Texture(O, this.atlasImage, $.RGBA), this.atlasTexture.bind($.LINEAR, $.CLAMP_TO_EDGE);
                        }, z.prototype._updatePatternAtlas = function() {
                            var O = [];
                            for(var $ in this.patterns)O.push(this.patterns[$].bin);
                            var pe = i.potpack(O), de = pe.w, Ie = pe.h, $e = this.atlasImage;
                            $e.resize({
                                width: de || 1,
                                height: Ie || 1
                            });
                            for(var pt in this.patterns){
                                var Kt = this.patterns[pt], ir = Kt.bin, Jt = ir.x + p, vt = ir.y + p, Pt = this.images[pt].data, Wt = Pt.width, rr = Pt.height;
                                i.RGBAImage.copy(Pt, $e, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Jt,
                                    y: vt
                                }, {
                                    width: Wt,
                                    height: rr
                                }), i.RGBAImage.copy(Pt, $e, {
                                    x: 0,
                                    y: rr - 1
                                }, {
                                    x: Jt,
                                    y: vt - 1
                                }, {
                                    width: Wt,
                                    height: 1
                                }), i.RGBAImage.copy(Pt, $e, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Jt,
                                    y: vt + rr
                                }, {
                                    width: Wt,
                                    height: 1
                                }), i.RGBAImage.copy(Pt, $e, {
                                    x: Wt - 1,
                                    y: 0
                                }, {
                                    x: Jt - 1,
                                    y: vt
                                }, {
                                    width: 1,
                                    height: rr
                                }), i.RGBAImage.copy(Pt, $e, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Jt + Wt,
                                    y: vt
                                }, {
                                    width: 1,
                                    height: rr
                                });
                            }
                            this.dirty = !0;
                        }, z.prototype.beginFrame = function() {
                            this.callbackDispatchedThisFrame = {};
                        }, z.prototype.dispatchRenderCallbacks = function(O) {
                            for(var $ = 0, pe = O; $ < pe.length; $ += 1){
                                var de = pe[$];
                                if (!this.callbackDispatchedThisFrame[de]) {
                                    this.callbackDispatchedThisFrame[de] = !0;
                                    var Ie = this.images[de], $e = b(Ie);
                                    $e && this.updateImage(de, Ie);
                                }
                            }
                        }, z;
                    }(i.Evented);
                    function k(Y1, z, K, O, $) {
                        var pe = z * 256, de = pe + 255, Ie = O.transformRequest(O.normalizeGlyphsURL(K).replace("{fontstack}", Y1).replace("{range}", pe + "-" + de), i.ResourceType.Glyphs);
                        i.getArrayBuffer(Ie, function($e, pt) {
                            if ($e) $($e);
                            else if (pt) {
                                for(var Kt = {}, ir = 0, Jt = i.parseGlyphPBF(pt); ir < Jt.length; ir += 1){
                                    var vt = Jt[ir];
                                    Kt[vt.id] = vt;
                                }
                                $(null, Kt);
                            }
                        });
                    }
                    var A = C, L = C, _ = 1e20;
                    function C(Y1, z, K, O, $, pe) {
                        this.fontSize = Y1 || 24, this.buffer = z === void 0 ? 3 : z, this.cutoff = O || .25, this.fontFamily = $ || "sans-serif", this.fontWeight = pe || "normal", this.radius = K || 8;
                        var de = this.size = this.fontSize + this.buffer * 2;
                        this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = de, this.ctx = this.canvas.getContext("2d"), this.ctx.font = this.fontWeight + " " + this.fontSize + "px " + this.fontFamily, this.ctx.textBaseline = "middle", this.ctx.fillStyle = "black", this.gridOuter = new Float64Array(de * de), this.gridInner = new Float64Array(de * de), this.f = new Float64Array(de), this.d = new Float64Array(de), this.z = new Float64Array(de + 1), this.v = new Int16Array(de), this.middle = Math.round(de / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1));
                    }
                    C.prototype.draw = function(Y1) {
                        this.ctx.clearRect(0, 0, this.size, this.size), this.ctx.fillText(Y1, this.buffer, this.middle);
                        for(var z = this.ctx.getImageData(0, 0, this.size, this.size), K = new Uint8ClampedArray(this.size * this.size), O = 0; O < this.size * this.size; O++){
                            var $ = z.data[O * 4 + 3] / 255;
                            this.gridOuter[O] = $ === 1 ? 0 : $ === 0 ? _ : Math.pow(Math.max(0, .5 - $), 2), this.gridInner[O] = $ === 1 ? _ : $ === 0 ? 0 : Math.pow(Math.max(0, $ - .5), 2);
                        }
                        for(M(this.gridOuter, this.size, this.size, this.f, this.d, this.v, this.z), M(this.gridInner, this.size, this.size, this.f, this.d, this.v, this.z), O = 0; O < this.size * this.size; O++){
                            var pe = this.gridOuter[O] - this.gridInner[O];
                            K[O] = Math.max(0, Math.min(255, Math.round(255 - 255 * (pe / this.radius + this.cutoff))));
                        }
                        return K;
                    };
                    function M(Y1, z, K, O, $, pe, de) {
                        for(var Ie = 0; Ie < z; Ie++){
                            for(var $e = 0; $e < K; $e++)O[$e] = Y1[$e * z + Ie];
                            for(g(O, $, pe, de, K), $e = 0; $e < K; $e++)Y1[$e * z + Ie] = $[$e];
                        }
                        for($e = 0; $e < K; $e++){
                            for(Ie = 0; Ie < z; Ie++)O[Ie] = Y1[$e * z + Ie];
                            for(g(O, $, pe, de, z), Ie = 0; Ie < z; Ie++)Y1[$e * z + Ie] = Math.sqrt($[Ie]);
                        }
                    }
                    function g(Y1, z, K, O, $) {
                        K[0] = 0, O[0] = -_, O[1] = +_;
                        for(var pe = 1, de = 0; pe < $; pe++){
                            for(var Ie = (Y1[pe] + pe * pe - (Y1[K[de]] + K[de] * K[de])) / (2 * pe - 2 * K[de]); Ie <= O[de];)de--, Ie = (Y1[pe] + pe * pe - (Y1[K[de]] + K[de] * K[de])) / (2 * pe - 2 * K[de]);
                            de++, K[de] = pe, O[de] = Ie, O[de + 1] = +_;
                        }
                        for(pe = 0, de = 0; pe < $; pe++){
                            for(; O[de + 1] < pe;)de++;
                            z[pe] = (pe - K[de]) * (pe - K[de]) + Y1[K[de]];
                        }
                    }
                    A.default = L;
                    var P = function(z, K) {
                        this.requestManager = z, this.localIdeographFontFamily = K, this.entries = {};
                    };
                    P.prototype.setURL = function(z) {
                        this.url = z;
                    }, P.prototype.getGlyphs = function(z, K) {
                        var O = this, $ = [];
                        for(var pe in z)for(var de = 0, Ie = z[pe]; de < Ie.length; de += 1){
                            var $e = Ie[de];
                            $.push({
                                stack: pe,
                                id: $e
                            });
                        }
                        i.asyncAll($, function(pt, Kt) {
                            var ir = pt.stack, Jt = pt.id, vt = O.entries[ir];
                            vt || (vt = O.entries[ir] = {
                                glyphs: {},
                                requests: {},
                                ranges: {}
                            });
                            var Pt = vt.glyphs[Jt];
                            if (Pt !== void 0) {
                                Kt(null, {
                                    stack: ir,
                                    id: Jt,
                                    glyph: Pt
                                });
                                return;
                            }
                            if (Pt = O._tinySDF(vt, ir, Jt), Pt) {
                                vt.glyphs[Jt] = Pt, Kt(null, {
                                    stack: ir,
                                    id: Jt,
                                    glyph: Pt
                                });
                                return;
                            }
                            var Wt = Math.floor(Jt / 256);
                            if (Wt * 256 > 65535) {
                                Kt(new Error("glyphs > 65535 not supported"));
                                return;
                            }
                            if (vt.ranges[Wt]) {
                                Kt(null, {
                                    stack: ir,
                                    id: Jt,
                                    glyph: Pt
                                });
                                return;
                            }
                            var rr = vt.requests[Wt];
                            rr || (rr = vt.requests[Wt] = [], P.loadGlyphRange(ir, Wt, O.url, O.requestManager, function(dr, pr) {
                                if (pr) {
                                    for(var kr in pr)O._doesCharSupportLocalGlyph(+kr) || (vt.glyphs[+kr] = pr[+kr]);
                                    vt.ranges[Wt] = !0;
                                }
                                for(var Ar = 0, gr = rr; Ar < gr.length; Ar += 1){
                                    var Cr = gr[Ar];
                                    Cr(dr, pr);
                                }
                                delete vt.requests[Wt];
                            })), rr.push(function(dr, pr) {
                                dr ? Kt(dr) : pr && Kt(null, {
                                    stack: ir,
                                    id: Jt,
                                    glyph: pr[Jt] || null
                                });
                            });
                        }, function(pt, Kt) {
                            if (pt) K(pt);
                            else if (Kt) {
                                for(var ir = {}, Jt = 0, vt = Kt; Jt < vt.length; Jt += 1){
                                    var Pt = vt[Jt], Wt = Pt.stack, rr = Pt.id, dr = Pt.glyph;
                                    (ir[Wt] || (ir[Wt] = {}))[rr] = dr && {
                                        id: dr.id,
                                        bitmap: dr.bitmap.clone(),
                                        metrics: dr.metrics
                                    };
                                }
                                K(null, ir);
                            }
                        });
                    }, P.prototype._doesCharSupportLocalGlyph = function(z) {
                        return !!this.localIdeographFontFamily && (i.isChar["CJK Unified Ideographs"](z) || i.isChar["Hangul Syllables"](z) || i.isChar.Hiragana(z) || i.isChar.Katakana(z));
                    }, P.prototype._tinySDF = function(z, K, O) {
                        var $ = this.localIdeographFontFamily;
                        if ($ && this._doesCharSupportLocalGlyph(O)) {
                            var pe = z.tinySDF;
                            if (!pe) {
                                var de = "400";
                                /bold/i.test(K) ? de = "900" : /medium/i.test(K) ? de = "500" : /light/i.test(K) && (de = "200"), pe = z.tinySDF = new P.TinySDF(24, 3, 8, .25, $, de);
                            }
                            return {
                                id: O,
                                bitmap: new i.AlphaImage({
                                    width: 30,
                                    height: 30
                                }, pe.draw(String.fromCharCode(O))),
                                metrics: {
                                    width: 24,
                                    height: 24,
                                    left: 0,
                                    top: -8,
                                    advance: 24
                                }
                            };
                        }
                    }, P.loadGlyphRange = k, P.TinySDF = A;
                    var T = function() {
                        this.specification = i.styleSpec.light.position;
                    };
                    T.prototype.possiblyEvaluate = function(z, K) {
                        return i.sphericalToCartesian(z.expression.evaluate(K));
                    }, T.prototype.interpolate = function(z, K, O) {
                        return {
                            x: i.number(z.x, K.x, O),
                            y: i.number(z.y, K.y, O),
                            z: i.number(z.z, K.z, O)
                        };
                    };
                    var F = new i.Properties({
                        anchor: new i.DataConstantProperty(i.styleSpec.light.anchor),
                        position: new T,
                        color: new i.DataConstantProperty(i.styleSpec.light.color),
                        intensity: new i.DataConstantProperty(i.styleSpec.light.intensity)
                    }), q = "-transition", V = function(Y1) {
                        function z(K) {
                            Y1.call(this), this._transitionable = new i.Transitionable(F), this.setLight(K), this._transitioning = this._transitionable.untransitioned();
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getLight = function() {
                            return this._transitionable.serialize();
                        }, z.prototype.setLight = function(O, $) {
                            if ($ === void 0 && ($ = {}), !this._validate(i.validateLight, O, $)) for(var pe in O){
                                var de = O[pe];
                                i.endsWith(pe, q) ? this._transitionable.setTransition(pe.slice(0, -q.length), de) : this._transitionable.setValue(pe, de);
                            }
                        }, z.prototype.updateTransitions = function(O) {
                            this._transitioning = this._transitionable.transitioned(O, this._transitioning);
                        }, z.prototype.hasTransition = function() {
                            return this._transitioning.hasTransition();
                        }, z.prototype.recalculate = function(O) {
                            this.properties = this._transitioning.possiblyEvaluate(O);
                        }, z.prototype._validate = function(O, $, pe) {
                            return pe && pe.validate === !1 ? !1 : i.emitValidationErrors(this, O.call(i.validateStyle, i.extend({
                                value: $,
                                style: {
                                    glyphs: !0,
                                    sprite: !0
                                },
                                styleSpec: i.styleSpec
                            })));
                        }, z;
                    }(i.Evented), H = function(z, K) {
                        this.width = z, this.height = K, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
                    };
                    H.prototype.getDash = function(z, K) {
                        var O = z.join(",") + String(K);
                        return this.dashEntry[O] || (this.dashEntry[O] = this.addDash(z, K)), this.dashEntry[O];
                    }, H.prototype.getDashRanges = function(z, K, O) {
                        var $ = z.length % 2 === 1, pe = [], de = $ ? -z[z.length - 1] * O : 0, Ie = z[0] * O, $e = !0;
                        pe.push({
                            left: de,
                            right: Ie,
                            isDash: $e,
                            zeroLength: z[0] === 0
                        });
                        for(var pt = z[0], Kt = 1; Kt < z.length; Kt++){
                            $e = !$e;
                            var ir = z[Kt];
                            de = pt * O, pt += ir, Ie = pt * O, pe.push({
                                left: de,
                                right: Ie,
                                isDash: $e,
                                zeroLength: ir === 0
                            });
                        }
                        return pe;
                    }, H.prototype.addRoundDash = function(z, K, O) {
                        for(var $ = K / 2, pe = -O; pe <= O; pe++)for(var de = this.nextRow + O + pe, Ie = this.width * de, $e = 0, pt = z[$e], Kt = 0; Kt < this.width; Kt++){
                            Kt / pt.right > 1 && (pt = z[++$e]);
                            var ir = Math.abs(Kt - pt.left), Jt = Math.abs(Kt - pt.right), vt = Math.min(ir, Jt), Pt = void 0, Wt = pe / O * ($ + 1);
                            if (pt.isDash) {
                                var rr = $ - Math.abs(Wt);
                                Pt = Math.sqrt(vt * vt + rr * rr);
                            } else Pt = $ - Math.sqrt(vt * vt + Wt * Wt);
                            this.data[Ie + Kt] = Math.max(0, Math.min(255, Pt + 128));
                        }
                    }, H.prototype.addRegularDash = function(z) {
                        for(var K = z.length - 1; K >= 0; --K){
                            var O = z[K], $ = z[K + 1];
                            O.zeroLength ? z.splice(K, 1) : $ && $.isDash === O.isDash && ($.left = O.left, z.splice(K, 1));
                        }
                        var pe = z[0], de = z[z.length - 1];
                        pe.isDash === de.isDash && (pe.left = de.left - this.width, de.right = pe.right + this.width);
                        for(var Ie = this.width * this.nextRow, $e = 0, pt = z[$e], Kt = 0; Kt < this.width; Kt++){
                            Kt / pt.right > 1 && (pt = z[++$e]);
                            var ir = Math.abs(Kt - pt.left), Jt = Math.abs(Kt - pt.right), vt = Math.min(ir, Jt), Pt = pt.isDash ? vt : -vt;
                            this.data[Ie + Kt] = Math.max(0, Math.min(255, Pt + 128));
                        }
                    }, H.prototype.addDash = function(z, K) {
                        var O = K ? 7 : 0, $ = 2 * O + 1;
                        if (this.nextRow + $ > this.height) return i.warnOnce("LineAtlas out of space"), null;
                        for(var pe = 0, de = 0; de < z.length; de++)pe += z[de];
                        if (pe !== 0) {
                            var Ie = this.width / pe, $e = this.getDashRanges(z, this.width, Ie);
                            K ? this.addRoundDash($e, Ie, O) : this.addRegularDash($e);
                        }
                        var pt = {
                            y: (this.nextRow + O + .5) / this.height,
                            height: 2 * O / this.height,
                            width: pe
                        };
                        return this.nextRow += $, this.dirty = !0, pt;
                    }, H.prototype.bind = function(z) {
                        var K = z.gl;
                        this.texture ? (K.bindTexture(K.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, K.texSubImage2D(K.TEXTURE_2D, 0, 0, 0, this.width, this.height, K.ALPHA, K.UNSIGNED_BYTE, this.data))) : (this.texture = K.createTexture(), K.bindTexture(K.TEXTURE_2D, this.texture), K.texParameteri(K.TEXTURE_2D, K.TEXTURE_WRAP_S, K.REPEAT), K.texParameteri(K.TEXTURE_2D, K.TEXTURE_WRAP_T, K.REPEAT), K.texParameteri(K.TEXTURE_2D, K.TEXTURE_MIN_FILTER, K.LINEAR), K.texParameteri(K.TEXTURE_2D, K.TEXTURE_MAG_FILTER, K.LINEAR), K.texImage2D(K.TEXTURE_2D, 0, K.ALPHA, this.width, this.height, 0, K.ALPHA, K.UNSIGNED_BYTE, this.data));
                    };
                    var X = function Y1(z, K) {
                        this.workerPool = z, this.actors = [], this.currentActor = 0, this.id = i.uniqueId();
                        for(var O = this.workerPool.acquire(this.id), $ = 0; $ < O.length; $++){
                            var pe = O[$], de = new Y1.Actor(pe, K, this.id);
                            de.name = "Worker " + $, this.actors.push(de);
                        }
                    };
                    X.prototype.broadcast = function(z, K, O) {
                        O = O || function() {}, i.asyncAll(this.actors, function($, pe) {
                            $.send(z, K, pe);
                        }, O);
                    }, X.prototype.getActor = function() {
                        return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
                    }, X.prototype.remove = function() {
                        this.actors.forEach(function(z) {
                            z.remove();
                        }), this.actors = [], this.workerPool.release(this.id);
                    }, X.Actor = i.Actor;
                    function G(Y1, z, K) {
                        var O = function($, pe) {
                            if ($) return K($);
                            if (pe) {
                                var de = i.pick(i.extend(pe, Y1), [
                                    "tiles",
                                    "minzoom",
                                    "maxzoom",
                                    "attribution",
                                    "mapbox_logo",
                                    "bounds",
                                    "scheme",
                                    "tileSize",
                                    "encoding"
                                ]);
                                pe.vector_layers && (de.vectorLayers = pe.vector_layers, de.vectorLayerIds = de.vectorLayers.map(function(Ie) {
                                    return Ie.id;
                                })), de.tiles = z.canonicalizeTileset(de, Y1.url), K(null, de);
                            }
                        };
                        return Y1.url ? i.getJSON(z.transformRequest(z.normalizeSourceURL(Y1.url), i.ResourceType.Source), O) : i.browser.frame(function() {
                            return O(null, Y1);
                        });
                    }
                    var N = function(z, K, O) {
                        this.bounds = i.LngLatBounds.convert(this.validateBounds(z)), this.minzoom = K || 0, this.maxzoom = O || 24;
                    };
                    N.prototype.validateBounds = function(z) {
                        return !Array.isArray(z) || z.length !== 4 ? [
                            -180,
                            -90,
                            180,
                            90
                        ] : [
                            Math.max(-180, z[0]),
                            Math.max(-90, z[1]),
                            Math.min(180, z[2]),
                            Math.min(90, z[3])
                        ];
                    }, N.prototype.contains = function(z) {
                        var K = Math.pow(2, z.z), O = {
                            minX: Math.floor(i.mercatorXfromLng(this.bounds.getWest()) * K),
                            minY: Math.floor(i.mercatorYfromLat(this.bounds.getNorth()) * K),
                            maxX: Math.ceil(i.mercatorXfromLng(this.bounds.getEast()) * K),
                            maxY: Math.ceil(i.mercatorYfromLat(this.bounds.getSouth()) * K)
                        }, $ = z.x >= O.minX && z.x < O.maxX && z.y >= O.minY && z.y < O.maxY;
                        return $;
                    };
                    var W = function(Y1) {
                        function z(K, O, $, pe) {
                            if (Y1.call(this), this.id = K, this.dispatcher = $, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, i.extend(this, i.pick(O, [
                                "url",
                                "scheme",
                                "tileSize",
                                "promoteId"
                            ])), this._options = i.extend({
                                type: "vector"
                            }, O), this._collectResourceTiming = O.collectResourceTiming, this.tileSize !== 512) throw new Error("vector tile sources must have a tileSize of 512");
                            this.setEventedParent(pe);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.load = function() {
                            var O = this;
                            this._loaded = !1, this.fire(new i.Event("dataloading", {
                                dataType: "source"
                            })), this._tileJSONRequest = G(this._options, this.map._requestManager, function($, pe) {
                                O._tileJSONRequest = null, O._loaded = !0, $ ? O.fire(new i.ErrorEvent($)) : pe && (i.extend(O, pe), pe.bounds && (O.tileBounds = new N(pe.bounds, O.minzoom, O.maxzoom)), i.postTurnstileEvent(pe.tiles, O.map._requestManager._customAccessToken), i.postMapLoadEvent(pe.tiles, O.map._getMapId(), O.map._requestManager._skuToken, O.map._requestManager._customAccessToken), O.fire(new i.Event("data", {
                                    dataType: "source",
                                    sourceDataType: "metadata"
                                })), O.fire(new i.Event("data", {
                                    dataType: "source",
                                    sourceDataType: "content"
                                })));
                            });
                        }, z.prototype.loaded = function() {
                            return this._loaded;
                        }, z.prototype.hasTile = function(O) {
                            return !this.tileBounds || this.tileBounds.contains(O.canonical);
                        }, z.prototype.onAdd = function(O) {
                            this.map = O, this.load();
                        }, z.prototype.setSourceProperty = function(O) {
                            this._tileJSONRequest && this._tileJSONRequest.cancel(), O();
                            var $ = this.map.style.sourceCaches[this.id];
                            $.clearTiles(), this.load();
                        }, z.prototype.setTiles = function(O) {
                            var $ = this;
                            return this.setSourceProperty(function() {
                                $._options.tiles = O;
                            }), this;
                        }, z.prototype.setUrl = function(O) {
                            var $ = this;
                            return this.setSourceProperty(function() {
                                $.url = O, $._options.url = O;
                            }), this;
                        }, z.prototype.onRemove = function() {
                            this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                        }, z.prototype.serialize = function() {
                            return i.extend({}, this._options);
                        }, z.prototype.loadTile = function(O, $) {
                            var pe = this.map._requestManager.normalizeTileURL(O.tileID.canonical.url(this.tiles, this.scheme)), de = {
                                request: this.map._requestManager.transformRequest(pe, i.ResourceType.Tile),
                                uid: O.uid,
                                tileID: O.tileID,
                                zoom: O.tileID.overscaledZ,
                                tileSize: this.tileSize * O.tileID.overscaleFactor(),
                                type: this.type,
                                source: this.id,
                                pixelRatio: i.browser.devicePixelRatio,
                                showCollisionBoxes: this.map.showCollisionBoxes,
                                promoteId: this.promoteId
                            };
                            de.request.collectResourceTiming = this._collectResourceTiming, !O.actor || O.state === "expired" ? (O.actor = this.dispatcher.getActor(), O.request = O.actor.send("loadTile", de, Ie.bind(this))) : O.state === "loading" ? O.reloadCallback = $ : O.request = O.actor.send("reloadTile", de, Ie.bind(this));
                            function Ie($e, pt) {
                                if (delete O.request, O.aborted) return $(null);
                                if ($e && $e.status !== 404) return $($e);
                                pt && pt.resourceTiming && (O.resourceTiming = pt.resourceTiming), this.map._refreshExpiredTiles && pt && O.setExpiryData(pt), O.loadVectorData(pt, this.map.painter), i.cacheEntryPossiblyAdded(this.dispatcher), $(null), O.reloadCallback && (this.loadTile(O, O.reloadCallback), O.reloadCallback = null);
                            }
                        }, z.prototype.abortTile = function(O) {
                            O.request && (O.request.cancel(), delete O.request), O.actor && O.actor.send("abortTile", {
                                uid: O.uid,
                                type: this.type,
                                source: this.id
                            }, void 0);
                        }, z.prototype.unloadTile = function(O) {
                            O.unloadVectorData(), O.actor && O.actor.send("removeTile", {
                                uid: O.uid,
                                type: this.type,
                                source: this.id
                            }, void 0);
                        }, z.prototype.hasTransition = function() {
                            return !1;
                        }, z;
                    }(i.Evented), re = function(Y1) {
                        function z(K, O, $, pe) {
                            Y1.call(this), this.id = K, this.dispatcher = $, this.setEventedParent(pe), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = i.extend({
                                type: "raster"
                            }, O), i.extend(this, i.pick(O, [
                                "url",
                                "scheme",
                                "tileSize"
                            ]));
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.load = function() {
                            var O = this;
                            this._loaded = !1, this.fire(new i.Event("dataloading", {
                                dataType: "source"
                            })), this._tileJSONRequest = G(this._options, this.map._requestManager, function($, pe) {
                                O._tileJSONRequest = null, O._loaded = !0, $ ? O.fire(new i.ErrorEvent($)) : pe && (i.extend(O, pe), pe.bounds && (O.tileBounds = new N(pe.bounds, O.minzoom, O.maxzoom)), i.postTurnstileEvent(pe.tiles), i.postMapLoadEvent(pe.tiles, O.map._getMapId(), O.map._requestManager._skuToken), O.fire(new i.Event("data", {
                                    dataType: "source",
                                    sourceDataType: "metadata"
                                })), O.fire(new i.Event("data", {
                                    dataType: "source",
                                    sourceDataType: "content"
                                })));
                            });
                        }, z.prototype.loaded = function() {
                            return this._loaded;
                        }, z.prototype.onAdd = function(O) {
                            this.map = O, this.load();
                        }, z.prototype.onRemove = function() {
                            this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                        }, z.prototype.serialize = function() {
                            return i.extend({}, this._options);
                        }, z.prototype.hasTile = function(O) {
                            return !this.tileBounds || this.tileBounds.contains(O.canonical);
                        }, z.prototype.loadTile = function(O, $) {
                            var pe = this, de = this.map._requestManager.normalizeTileURL(O.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
                            O.request = i.getImage(this.map._requestManager.transformRequest(de, i.ResourceType.Tile), function(Ie, $e) {
                                if (delete O.request, O.aborted) O.state = "unloaded", $(null);
                                else if (Ie) O.state = "errored", $(Ie);
                                else if ($e) {
                                    pe.map._refreshExpiredTiles && O.setExpiryData($e), delete $e.cacheControl, delete $e.expires;
                                    var pt = pe.map.painter.context, Kt = pt.gl;
                                    O.texture = pe.map.painter.getTileTexture($e.width), O.texture ? O.texture.update($e, {
                                        useMipmap: !0
                                    }) : (O.texture = new i.Texture(pt, $e, Kt.RGBA, {
                                        useMipmap: !0
                                    }), O.texture.bind(Kt.LINEAR, Kt.CLAMP_TO_EDGE, Kt.LINEAR_MIPMAP_NEAREST), pt.extTextureFilterAnisotropic && Kt.texParameterf(Kt.TEXTURE_2D, pt.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, pt.extTextureFilterAnisotropicMax)), O.state = "loaded", i.cacheEntryPossiblyAdded(pe.dispatcher), $(null);
                                }
                            });
                        }, z.prototype.abortTile = function(O, $) {
                            O.request && (O.request.cancel(), delete O.request), $();
                        }, z.prototype.unloadTile = function(O, $) {
                            O.texture && this.map.painter.saveTileTexture(O.texture), $();
                        }, z.prototype.hasTransition = function() {
                            return !1;
                        }, z;
                    }(i.Evented), ae = function(Y1) {
                        function z(K, O, $, pe) {
                            Y1.call(this, K, O, $, pe), this.type = "raster-dem", this.maxzoom = 22, this._options = i.extend({
                                type: "raster-dem"
                            }, O), this.encoding = O.encoding || "mapbox";
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.serialize = function() {
                            return {
                                type: "raster-dem",
                                url: this.url,
                                tileSize: this.tileSize,
                                tiles: this.tiles,
                                bounds: this.bounds,
                                encoding: this.encoding
                            };
                        }, z.prototype.loadTile = function(O, $) {
                            var pe = this.map._requestManager.normalizeTileURL(O.tileID.canonical.url(this.tiles, this.scheme), this.tileSize);
                            O.request = i.getImage(this.map._requestManager.transformRequest(pe, i.ResourceType.Tile), de.bind(this)), O.neighboringTiles = this._getNeighboringTiles(O.tileID);
                            function de($e, pt) {
                                if (delete O.request, O.aborted) O.state = "unloaded", $(null);
                                else if ($e) O.state = "errored", $($e);
                                else if (pt) {
                                    this.map._refreshExpiredTiles && O.setExpiryData(pt), delete pt.cacheControl, delete pt.expires;
                                    var Kt = i.window.ImageBitmap && pt instanceof i.window.ImageBitmap && i.offscreenCanvasSupported(), ir = Kt ? pt : i.browser.getImageData(pt, 1), Jt = {
                                        uid: O.uid,
                                        coord: O.tileID,
                                        source: this.id,
                                        rawImageData: ir,
                                        encoding: this.encoding
                                    };
                                    (!O.actor || O.state === "expired") && (O.actor = this.dispatcher.getActor(), O.actor.send("loadDEMTile", Jt, Ie.bind(this)));
                                }
                            }
                            function Ie($e, pt) {
                                $e && (O.state = "errored", $($e)), pt && (O.dem = pt, O.needsHillshadePrepare = !0, O.state = "loaded", $(null));
                            }
                        }, z.prototype._getNeighboringTiles = function(O) {
                            var $ = O.canonical, pe = Math.pow(2, $.z), de = ($.x - 1 + pe) % pe, Ie = $.x === 0 ? O.wrap - 1 : O.wrap, $e = ($.x + 1 + pe) % pe, pt = $.x + 1 === pe ? O.wrap + 1 : O.wrap, Kt = {};
                            return Kt[new i.OverscaledTileID(O.overscaledZ, Ie, $.z, de, $.y).key] = {
                                backfilled: !1
                            }, Kt[new i.OverscaledTileID(O.overscaledZ, pt, $.z, $e, $.y).key] = {
                                backfilled: !1
                            }, $.y > 0 && (Kt[new i.OverscaledTileID(O.overscaledZ, Ie, $.z, de, $.y - 1).key] = {
                                backfilled: !1
                            }, Kt[new i.OverscaledTileID(O.overscaledZ, O.wrap, $.z, $.x, $.y - 1).key] = {
                                backfilled: !1
                            }, Kt[new i.OverscaledTileID(O.overscaledZ, pt, $.z, $e, $.y - 1).key] = {
                                backfilled: !1
                            }), $.y + 1 < pe && (Kt[new i.OverscaledTileID(O.overscaledZ, Ie, $.z, de, $.y + 1).key] = {
                                backfilled: !1
                            }, Kt[new i.OverscaledTileID(O.overscaledZ, O.wrap, $.z, $.x, $.y + 1).key] = {
                                backfilled: !1
                            }, Kt[new i.OverscaledTileID(O.overscaledZ, pt, $.z, $e, $.y + 1).key] = {
                                backfilled: !1
                            }), Kt;
                        }, z.prototype.unloadTile = function(O) {
                            O.demTexture && this.map.painter.saveTileTexture(O.demTexture), O.fbo && (O.fbo.destroy(), delete O.fbo), O.dem && delete O.dem, delete O.neighboringTiles, O.state = "unloaded", O.actor && O.actor.send("removeDEMTile", {
                                uid: O.uid,
                                source: this.id
                            });
                        }, z;
                    }(re), _e = function(Y1) {
                        function z(K, O, $, pe) {
                            Y1.call(this), this.id = K, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._loaded = !1, this.actor = $.getActor(), this.setEventedParent(pe), this._data = O.data, this._options = i.extend({}, O), this._collectResourceTiming = O.collectResourceTiming, this._resourceTiming = [], O.maxzoom !== void 0 && (this.maxzoom = O.maxzoom), O.type && (this.type = O.type), O.attribution && (this.attribution = O.attribution), this.promoteId = O.promoteId;
                            var de = i.EXTENT / this.tileSize;
                            this.workerOptions = i.extend({
                                source: this.id,
                                cluster: O.cluster || !1,
                                geojsonVtOptions: {
                                    buffer: (O.buffer !== void 0 ? O.buffer : 128) * de,
                                    tolerance: (O.tolerance !== void 0 ? O.tolerance : .375) * de,
                                    extent: i.EXTENT,
                                    maxZoom: this.maxzoom,
                                    lineMetrics: O.lineMetrics || !1,
                                    generateId: O.generateId || !1
                                },
                                superclusterOptions: {
                                    maxZoom: O.clusterMaxZoom !== void 0 ? Math.min(O.clusterMaxZoom, this.maxzoom - 1) : this.maxzoom - 1,
                                    minPoints: Math.max(2, O.clusterMinPoints || 2),
                                    extent: i.EXTENT,
                                    radius: (O.clusterRadius || 50) * de,
                                    log: !1,
                                    generateId: O.generateId || !1
                                },
                                clusterProperties: O.clusterProperties,
                                filter: O.filter
                            }, O.workerOptions);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.load = function() {
                            var O = this;
                            this.fire(new i.Event("dataloading", {
                                dataType: "source"
                            })), this._updateWorkerData(function($) {
                                if ($) {
                                    O.fire(new i.ErrorEvent($));
                                    return;
                                }
                                var pe = {
                                    dataType: "source",
                                    sourceDataType: "metadata"
                                };
                                O._collectResourceTiming && O._resourceTiming && O._resourceTiming.length > 0 && (pe.resourceTiming = O._resourceTiming, O._resourceTiming = []), O.fire(new i.Event("data", pe));
                            });
                        }, z.prototype.onAdd = function(O) {
                            this.map = O, this.load();
                        }, z.prototype.setData = function(O) {
                            var $ = this;
                            return this._data = O, this.fire(new i.Event("dataloading", {
                                dataType: "source"
                            })), this._updateWorkerData(function(pe) {
                                if (pe) {
                                    $.fire(new i.ErrorEvent(pe));
                                    return;
                                }
                                var de = {
                                    dataType: "source",
                                    sourceDataType: "content"
                                };
                                $._collectResourceTiming && $._resourceTiming && $._resourceTiming.length > 0 && (de.resourceTiming = $._resourceTiming, $._resourceTiming = []), $.fire(new i.Event("data", de));
                            }), this;
                        }, z.prototype.getClusterExpansionZoom = function(O, $) {
                            return this.actor.send("geojson.getClusterExpansionZoom", {
                                clusterId: O,
                                source: this.id
                            }, $), this;
                        }, z.prototype.getClusterChildren = function(O, $) {
                            return this.actor.send("geojson.getClusterChildren", {
                                clusterId: O,
                                source: this.id
                            }, $), this;
                        }, z.prototype.getClusterLeaves = function(O, $, pe, de) {
                            return this.actor.send("geojson.getClusterLeaves", {
                                source: this.id,
                                clusterId: O,
                                limit: $,
                                offset: pe
                            }, de), this;
                        }, z.prototype._updateWorkerData = function(O) {
                            var $ = this;
                            this._loaded = !1;
                            var pe = i.extend({}, this.workerOptions), de = this._data;
                            typeof de == "string" ? (pe.request = this.map._requestManager.transformRequest(i.browser.resolveURL(de), i.ResourceType.Source), pe.request.collectResourceTiming = this._collectResourceTiming) : pe.data = JSON.stringify(de), this.actor.send(this.type + ".loadData", pe, function(Ie, $e) {
                                $._removed || $e && $e.abandoned || ($._loaded = !0, $e && $e.resourceTiming && $e.resourceTiming[$.id] && ($._resourceTiming = $e.resourceTiming[$.id].slice(0)), $.actor.send($.type + ".coalesce", {
                                    source: pe.source
                                }, null), O(Ie));
                            });
                        }, z.prototype.loaded = function() {
                            return this._loaded;
                        }, z.prototype.loadTile = function(O, $) {
                            var pe = this, de = O.actor ? "reloadTile" : "loadTile";
                            O.actor = this.actor;
                            var Ie = {
                                type: this.type,
                                uid: O.uid,
                                tileID: O.tileID,
                                zoom: O.tileID.overscaledZ,
                                maxZoom: this.maxzoom,
                                tileSize: this.tileSize,
                                source: this.id,
                                pixelRatio: i.browser.devicePixelRatio,
                                showCollisionBoxes: this.map.showCollisionBoxes,
                                promoteId: this.promoteId
                            };
                            O.request = this.actor.send(de, Ie, function($e, pt) {
                                return delete O.request, O.unloadVectorData(), O.aborted ? $(null) : $e ? $($e) : (O.loadVectorData(pt, pe.map.painter, de === "reloadTile"), $(null));
                            });
                        }, z.prototype.abortTile = function(O) {
                            O.request && (O.request.cancel(), delete O.request), O.aborted = !0;
                        }, z.prototype.unloadTile = function(O) {
                            O.unloadVectorData(), this.actor.send("removeTile", {
                                uid: O.uid,
                                type: this.type,
                                source: this.id
                            });
                        }, z.prototype.onRemove = function() {
                            this._removed = !0, this.actor.send("removeSource", {
                                type: this.type,
                                source: this.id
                            });
                        }, z.prototype.serialize = function() {
                            return i.extend({}, this._options, {
                                type: this.type,
                                data: this._data
                            });
                        }, z.prototype.hasTransition = function() {
                            return !1;
                        }, z;
                    }(i.Evented), Me = i.createLayout([
                        {
                            name: "a_pos",
                            type: "Int16",
                            components: 2
                        },
                        {
                            name: "a_texture_pos",
                            type: "Int16",
                            components: 2
                        }
                    ]), ke = function(Y1) {
                        function z(K, O, $, pe) {
                            Y1.call(this), this.id = K, this.dispatcher = $, this.coordinates = O.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(pe), this.options = O;
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.load = function(O, $) {
                            var pe = this;
                            this._loaded = !1, this.fire(new i.Event("dataloading", {
                                dataType: "source"
                            })), this.url = this.options.url, i.getImage(this.map._requestManager.transformRequest(this.url, i.ResourceType.Image), function(de, Ie) {
                                pe._loaded = !0, de ? pe.fire(new i.ErrorEvent(de)) : Ie && (pe.image = Ie, O && (pe.coordinates = O), $ && $(), pe._finishLoading());
                            });
                        }, z.prototype.loaded = function() {
                            return this._loaded;
                        }, z.prototype.updateImage = function(O) {
                            var $ = this;
                            return !this.image || !O.url ? this : (this.options.url = O.url, this.load(O.coordinates, function() {
                                $.texture = null;
                            }), this);
                        }, z.prototype._finishLoading = function() {
                            this.map && (this.setCoordinates(this.coordinates), this.fire(new i.Event("data", {
                                dataType: "source",
                                sourceDataType: "metadata"
                            })));
                        }, z.prototype.onAdd = function(O) {
                            this.map = O, this.load();
                        }, z.prototype.setCoordinates = function(O) {
                            var $ = this;
                            this.coordinates = O;
                            var pe = O.map(i.MercatorCoordinate.fromLngLat);
                            this.tileID = ge(pe), this.minzoom = this.maxzoom = this.tileID.z;
                            var de = pe.map(function(Ie) {
                                return $.tileID.getTilePoint(Ie)._round();
                            });
                            return this._boundsArray = new i.StructArrayLayout4i8, this._boundsArray.emplaceBack(de[0].x, de[0].y, 0, 0), this._boundsArray.emplaceBack(de[1].x, de[1].y, i.EXTENT, 0), this._boundsArray.emplaceBack(de[3].x, de[3].y, 0, i.EXTENT), this._boundsArray.emplaceBack(de[2].x, de[2].y, i.EXTENT, i.EXTENT), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new i.Event("data", {
                                dataType: "source",
                                sourceDataType: "content"
                            })), this;
                        }, z.prototype.prepare = function() {
                            if (!(Object.keys(this.tiles).length === 0 || !this.image)) {
                                var O = this.map.painter.context, $ = O.gl;
                                this.boundsBuffer || (this.boundsBuffer = O.createVertexBuffer(this._boundsArray, Me.members)), this.boundsSegments || (this.boundsSegments = i.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new i.Texture(O, this.image, $.RGBA), this.texture.bind($.LINEAR, $.CLAMP_TO_EDGE));
                                for(var pe in this.tiles){
                                    var de = this.tiles[pe];
                                    de.state !== "loaded" && (de.state = "loaded", de.texture = this.texture);
                                }
                            }
                        }, z.prototype.loadTile = function(O, $) {
                            this.tileID && this.tileID.equals(O.tileID.canonical) ? (this.tiles[String(O.tileID.wrap)] = O, O.buckets = {}, $(null)) : (O.state = "errored", $(null));
                        }, z.prototype.serialize = function() {
                            return {
                                type: "image",
                                url: this.options.url,
                                coordinates: this.coordinates
                            };
                        }, z.prototype.hasTransition = function() {
                            return !1;
                        }, z;
                    }(i.Evented);
                    function ge(Y1) {
                        for(var z = 1 / 0, K = 1 / 0, O = -1 / 0, $ = -1 / 0, pe = 0, de = Y1; pe < de.length; pe += 1){
                            var Ie = de[pe];
                            z = Math.min(z, Ie.x), K = Math.min(K, Ie.y), O = Math.max(O, Ie.x), $ = Math.max($, Ie.y);
                        }
                        var $e = O - z, pt = $ - K, Kt = Math.max($e, pt), ir = Math.max(0, Math.floor(-Math.log(Kt) / Math.LN2)), Jt = Math.pow(2, ir);
                        return new i.CanonicalTileID(ir, Math.floor((z + O) / 2 * Jt), Math.floor((K + $) / 2 * Jt));
                    }
                    var ie = function(Y1) {
                        function z(K, O, $, pe) {
                            Y1.call(this, K, O, $, pe), this.roundZoom = !0, this.type = "video", this.options = O;
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.load = function() {
                            var O = this;
                            this._loaded = !1;
                            var $ = this.options;
                            this.urls = [];
                            for(var pe = 0, de = $.urls; pe < de.length; pe += 1){
                                var Ie = de[pe];
                                this.urls.push(this.map._requestManager.transformRequest(Ie, i.ResourceType.Source).url);
                            }
                            i.getVideo(this.urls, function($e, pt) {
                                O._loaded = !0, $e ? O.fire(new i.ErrorEvent($e)) : pt && (O.video = pt, O.video.loop = !0, O.video.addEventListener("playing", function() {
                                    O.map.triggerRepaint();
                                }), O.map && O.video.play(), O._finishLoading());
                            });
                        }, z.prototype.pause = function() {
                            this.video && this.video.pause();
                        }, z.prototype.play = function() {
                            this.video && this.video.play();
                        }, z.prototype.seek = function(O) {
                            if (this.video) {
                                var $ = this.video.seekable;
                                O < $.start(0) || O > $.end(0) ? this.fire(new i.ErrorEvent(new i.ValidationError("sources." + this.id, null, "Playback for this video can be set only between the " + $.start(0) + " and " + $.end(0) + "-second mark."))) : this.video.currentTime = O;
                            }
                        }, z.prototype.getVideo = function() {
                            return this.video;
                        }, z.prototype.onAdd = function(O) {
                            this.map || (this.map = O, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                        }, z.prototype.prepare = function() {
                            if (!(Object.keys(this.tiles).length === 0 || this.video.readyState < 2)) {
                                var O = this.map.painter.context, $ = O.gl;
                                this.boundsBuffer || (this.boundsBuffer = O.createVertexBuffer(this._boundsArray, Me.members)), this.boundsSegments || (this.boundsSegments = i.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind($.LINEAR, $.CLAMP_TO_EDGE), $.texSubImage2D($.TEXTURE_2D, 0, 0, 0, $.RGBA, $.UNSIGNED_BYTE, this.video)) : (this.texture = new i.Texture(O, this.video, $.RGBA), this.texture.bind($.LINEAR, $.CLAMP_TO_EDGE));
                                for(var pe in this.tiles){
                                    var de = this.tiles[pe];
                                    de.state !== "loaded" && (de.state = "loaded", de.texture = this.texture);
                                }
                            }
                        }, z.prototype.serialize = function() {
                            return {
                                type: "video",
                                urls: this.urls,
                                coordinates: this.coordinates
                            };
                        }, z.prototype.hasTransition = function() {
                            return this.video && !this.video.paused;
                        }, z;
                    }(ke), Te = function(Y1) {
                        function z(K, O, $, pe) {
                            Y1.call(this, K, O, $, pe), O.coordinates ? (!Array.isArray(O.coordinates) || O.coordinates.length !== 4 || O.coordinates.some(function(de) {
                                return !Array.isArray(de) || de.length !== 2 || de.some(function(Ie) {
                                    return typeof Ie != "number";
                                });
                            })) && this.fire(new i.ErrorEvent(new i.ValidationError("sources." + K, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new i.ErrorEvent(new i.ValidationError("sources." + K, null, 'missing required property "coordinates"'))), O.animate && typeof O.animate != "boolean" && this.fire(new i.ErrorEvent(new i.ValidationError("sources." + K, null, 'optional "animate" property must be a boolean value'))), O.canvas ? typeof O.canvas != "string" && !(O.canvas instanceof i.window.HTMLCanvasElement) && this.fire(new i.ErrorEvent(new i.ValidationError("sources." + K, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new i.ErrorEvent(new i.ValidationError("sources." + K, null, 'missing required property "canvas"'))), this.options = O, this.animate = O.animate !== void 0 ? O.animate : !0;
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.load = function() {
                            if (this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof i.window.HTMLCanvasElement ? this.options.canvas : i.window.document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions()) {
                                this.fire(new i.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero.")));
                                return;
                            }
                            this.play = function() {
                                this._playing = !0, this.map.triggerRepaint();
                            }, this.pause = function() {
                                this._playing && (this.prepare(), this._playing = !1);
                            }, this._finishLoading();
                        }, z.prototype.getCanvas = function() {
                            return this.canvas;
                        }, z.prototype.onAdd = function(O) {
                            this.map = O, this.load(), this.canvas && this.animate && this.play();
                        }, z.prototype.onRemove = function() {
                            this.pause();
                        }, z.prototype.prepare = function() {
                            var O = !1;
                            if (this.canvas.width !== this.width && (this.width = this.canvas.width, O = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, O = !0), !this._hasInvalidDimensions() && Object.keys(this.tiles).length !== 0) {
                                var $ = this.map.painter.context, pe = $.gl;
                                this.boundsBuffer || (this.boundsBuffer = $.createVertexBuffer(this._boundsArray, Me.members)), this.boundsSegments || (this.boundsSegments = i.SegmentVector.simpleSegment(0, 0, 4, 2)), this.texture ? (O || this._playing) && this.texture.update(this.canvas, {
                                    premultiply: !0
                                }) : this.texture = new i.Texture($, this.canvas, pe.RGBA, {
                                    premultiply: !0
                                });
                                for(var de in this.tiles){
                                    var Ie = this.tiles[de];
                                    Ie.state !== "loaded" && (Ie.state = "loaded", Ie.texture = this.texture);
                                }
                            }
                        }, z.prototype.serialize = function() {
                            return {
                                type: "canvas",
                                coordinates: this.coordinates
                            };
                        }, z.prototype.hasTransition = function() {
                            return this._playing;
                        }, z.prototype._hasInvalidDimensions = function() {
                            for(var O = 0, $ = [
                                this.canvas.width,
                                this.canvas.height
                            ]; O < $.length; O += 1){
                                var pe = $[O];
                                if (isNaN(pe) || pe <= 0) return !0;
                            }
                            return !1;
                        }, z;
                    }(ke), Ee = {
                        vector: W,
                        raster: re,
                        "raster-dem": ae,
                        geojson: _e,
                        video: ie,
                        image: ke,
                        canvas: Te
                    }, Ae = function(Y1, z, K, O) {
                        var $ = new Ee[z.type](Y1, z, K, O);
                        if ($.id !== Y1) throw new Error("Expected Source id to be " + Y1 + " instead of " + $.id);
                        return i.bindAll([
                            "load",
                            "abort",
                            "unload",
                            "serialize",
                            "prepare"
                        ], $), $;
                    }, ze = function(Y1) {
                        return Ee[Y1];
                    }, Ce = function(Y1, z) {
                        Ee[Y1] = z;
                    };
                    function me(Y1, z) {
                        var K = i.identity([]);
                        return i.translate(K, K, [
                            1,
                            1,
                            0
                        ]), i.scale(K, K, [
                            Y1.width * .5,
                            Y1.height * .5,
                            1
                        ]), i.multiply(K, K, Y1.calculatePosMatrix(z.toUnwrapped()));
                    }
                    function Re(Y1, z, K) {
                        if (Y1) for(var O = 0, $ = Y1; O < $.length; O += 1){
                            var pe = $[O], de = z[pe];
                            if (de && de.source === K && de.type === "fill-extrusion") return !0;
                        }
                        else for(var Ie in z){
                            var $e = z[Ie];
                            if ($e.source === K && $e.type === "fill-extrusion") return !0;
                        }
                        return !1;
                    }
                    function ce(Y1, z, K, O, $, pe) {
                        var de = Re($ && $.layers, z, Y1.id), Ie = pe.maxPitchScaleFactor(), $e = Y1.tilesIn(O, Ie, de);
                        $e.sort(ct);
                        for(var pt = [], Kt = 0, ir = $e; Kt < ir.length; Kt += 1){
                            var Jt = ir[Kt];
                            pt.push({
                                wrappedTileID: Jt.tileID.wrapped().key,
                                queryResults: Jt.tile.queryRenderedFeatures(z, K, Y1._state, Jt.queryGeometry, Jt.cameraQueryGeometry, Jt.scale, $, pe, Ie, me(Y1.transform, Jt.tileID))
                            });
                        }
                        var vt = qt(pt);
                        for(var Pt in vt)vt[Pt].forEach(function(Wt) {
                            var rr = Wt.feature, dr = Y1.getFeatureState(rr.layer["source-layer"], rr.id);
                            rr.source = rr.layer.source, rr.layer["source-layer"] && (rr.sourceLayer = rr.layer["source-layer"]), rr.state = dr;
                        });
                        return vt;
                    }
                    function Ge(Y1, z, K, O, $, pe, de) {
                        for(var Ie = {}, $e = pe.queryRenderedSymbols(O), pt = [], Kt = 0, ir = Object.keys($e).map(Number); Kt < ir.length; Kt += 1){
                            var Jt = ir[Kt];
                            pt.push(de[Jt]);
                        }
                        pt.sort(ct);
                        for(var vt = function() {
                            var pr = Wt[Pt], kr = pr.featureIndex.lookupSymbolFeatures($e[pr.bucketInstanceId], z, pr.bucketIndex, pr.sourceLayerIndex, $.filter, $.layers, $.availableImages, Y1);
                            for(var Ar in kr){
                                var gr = Ie[Ar] = Ie[Ar] || [], Cr = kr[Ar];
                                Cr.sort(function(yi, tn) {
                                    var Ri = pr.featureSortOrder;
                                    if (Ri) {
                                        var ln = Ri.indexOf(yi.featureIndex), Qn = Ri.indexOf(tn.featureIndex);
                                        return Qn - ln;
                                    } else return tn.featureIndex - yi.featureIndex;
                                });
                                for(var cr = 0, Gr = Cr; cr < Gr.length; cr += 1){
                                    var ei = Gr[cr];
                                    gr.push(ei);
                                }
                            }
                        }, Pt = 0, Wt = pt; Pt < Wt.length; Pt += 1)vt();
                        var rr = function(pr) {
                            Ie[pr].forEach(function(kr) {
                                var Ar = kr.feature, gr = Y1[pr], Cr = K[gr.source], cr = Cr.getFeatureState(Ar.layer["source-layer"], Ar.id);
                                Ar.source = Ar.layer.source, Ar.layer["source-layer"] && (Ar.sourceLayer = Ar.layer["source-layer"]), Ar.state = cr;
                            });
                        };
                        for(var dr in Ie)rr(dr);
                        return Ie;
                    }
                    function nt(Y1, z) {
                        for(var K = Y1.getRenderableIds().map(function($e) {
                            return Y1.getTileByID($e);
                        }), O = [], $ = {}, pe = 0; pe < K.length; pe++){
                            var de = K[pe], Ie = de.tileID.canonical.key;
                            $[Ie] || ($[Ie] = !0, de.querySourceFeatures(O, z));
                        }
                        return O;
                    }
                    function ct(Y1, z) {
                        var K = Y1.tileID, O = z.tileID;
                        return K.overscaledZ - O.overscaledZ || K.canonical.y - O.canonical.y || K.wrap - O.wrap || K.canonical.x - O.canonical.x;
                    }
                    function qt(Y1) {
                        for(var z = {}, K = {}, O = 0, $ = Y1; O < $.length; O += 1){
                            var pe = $[O], de = pe.queryResults, Ie = pe.wrappedTileID, $e = K[Ie] = K[Ie] || {};
                            for(var pt in de)for(var Kt = de[pt], ir = $e[pt] = $e[pt] || {}, Jt = z[pt] = z[pt] || [], vt = 0, Pt = Kt; vt < Pt.length; vt += 1){
                                var Wt = Pt[vt];
                                ir[Wt.featureIndex] || (ir[Wt.featureIndex] = !0, Jt.push(Wt));
                            }
                        }
                        return z;
                    }
                    var rt = function(z, K) {
                        this.max = z, this.onRemove = K, this.reset();
                    };
                    rt.prototype.reset = function() {
                        for(var z in this.data)for(var K = 0, O = this.data[z]; K < O.length; K += 1){
                            var $ = O[K];
                            $.timeout && clearTimeout($.timeout), this.onRemove($.value);
                        }
                        return this.data = {}, this.order = [], this;
                    }, rt.prototype.add = function(z, K, O) {
                        var $ = this, pe = z.wrapped().key;
                        this.data[pe] === void 0 && (this.data[pe] = []);
                        var de = {
                            value: K,
                            timeout: void 0
                        };
                        if (O !== void 0 && (de.timeout = setTimeout(function() {
                            $.remove(z, de);
                        }, O)), this.data[pe].push(de), this.order.push(pe), this.order.length > this.max) {
                            var Ie = this._getAndRemoveByKey(this.order[0]);
                            Ie && this.onRemove(Ie);
                        }
                        return this;
                    }, rt.prototype.has = function(z) {
                        return z.wrapped().key in this.data;
                    }, rt.prototype.getAndRemove = function(z) {
                        return this.has(z) ? this._getAndRemoveByKey(z.wrapped().key) : null;
                    }, rt.prototype._getAndRemoveByKey = function(z) {
                        var K = this.data[z].shift();
                        return K.timeout && clearTimeout(K.timeout), this.data[z].length === 0 && delete this.data[z], this.order.splice(this.order.indexOf(z), 1), K.value;
                    }, rt.prototype.getByKey = function(z) {
                        var K = this.data[z];
                        return K ? K[0].value : null;
                    }, rt.prototype.get = function(z) {
                        if (!this.has(z)) return null;
                        var K = this.data[z.wrapped().key][0];
                        return K.value;
                    }, rt.prototype.remove = function(z, K) {
                        if (!this.has(z)) return this;
                        var O = z.wrapped().key, $ = K === void 0 ? 0 : this.data[O].indexOf(K), pe = this.data[O][$];
                        return this.data[O].splice($, 1), pe.timeout && clearTimeout(pe.timeout), this.data[O].length === 0 && delete this.data[O], this.onRemove(pe.value), this.order.splice(this.order.indexOf(O), 1), this;
                    }, rt.prototype.setMaxSize = function(z) {
                        for(this.max = z; this.order.length > this.max;){
                            var K = this._getAndRemoveByKey(this.order[0]);
                            K && this.onRemove(K);
                        }
                        return this;
                    }, rt.prototype.filter = function(z) {
                        var K = [];
                        for(var O in this.data)for(var $ = 0, pe = this.data[O]; $ < pe.length; $ += 1){
                            var de = pe[$];
                            z(de.value) || K.push(de);
                        }
                        for(var Ie = 0, $e = K; Ie < $e.length; Ie += 1){
                            var pt = $e[Ie];
                            this.remove(pt.value.tileID, pt);
                        }
                    };
                    var ot = function(z, K, O) {
                        this.context = z;
                        var $ = z.gl;
                        this.buffer = $.createBuffer(), this.dynamicDraw = !!O, this.context.unbindVAO(), z.bindElementBuffer.set(this.buffer), $.bufferData($.ELEMENT_ARRAY_BUFFER, K.arrayBuffer, this.dynamicDraw ? $.DYNAMIC_DRAW : $.STATIC_DRAW), this.dynamicDraw || delete K.arrayBuffer;
                    };
                    ot.prototype.bind = function() {
                        this.context.bindElementBuffer.set(this.buffer);
                    }, ot.prototype.updateData = function(z) {
                        var K = this.context.gl;
                        this.context.unbindVAO(), this.bind(), K.bufferSubData(K.ELEMENT_ARRAY_BUFFER, 0, z.arrayBuffer);
                    }, ot.prototype.destroy = function() {
                        var z = this.context.gl;
                        this.buffer && (z.deleteBuffer(this.buffer), delete this.buffer);
                    };
                    var Rt = {
                        Int8: "BYTE",
                        Uint8: "UNSIGNED_BYTE",
                        Int16: "SHORT",
                        Uint16: "UNSIGNED_SHORT",
                        Int32: "INT",
                        Uint32: "UNSIGNED_INT",
                        Float32: "FLOAT"
                    }, kt = function(z, K, O, $) {
                        this.length = K.length, this.attributes = O, this.itemSize = K.bytesPerElement, this.dynamicDraw = $, this.context = z;
                        var pe = z.gl;
                        this.buffer = pe.createBuffer(), z.bindVertexBuffer.set(this.buffer), pe.bufferData(pe.ARRAY_BUFFER, K.arrayBuffer, this.dynamicDraw ? pe.DYNAMIC_DRAW : pe.STATIC_DRAW), this.dynamicDraw || delete K.arrayBuffer;
                    };
                    kt.prototype.bind = function() {
                        this.context.bindVertexBuffer.set(this.buffer);
                    }, kt.prototype.updateData = function(z) {
                        var K = this.context.gl;
                        this.bind(), K.bufferSubData(K.ARRAY_BUFFER, 0, z.arrayBuffer);
                    }, kt.prototype.enableAttributes = function(z, K) {
                        for(var O = 0; O < this.attributes.length; O++){
                            var $ = this.attributes[O], pe = K.attributes[$.name];
                            pe !== void 0 && z.enableVertexAttribArray(pe);
                        }
                    }, kt.prototype.setVertexAttribPointers = function(z, K, O) {
                        for(var $ = 0; $ < this.attributes.length; $++){
                            var pe = this.attributes[$], de = K.attributes[pe.name];
                            de !== void 0 && z.vertexAttribPointer(de, pe.components, z[Rt[pe.type]], !1, this.itemSize, pe.offset + this.itemSize * (O || 0));
                        }
                    }, kt.prototype.destroy = function() {
                        var z = this.context.gl;
                        this.buffer && (z.deleteBuffer(this.buffer), delete this.buffer);
                    };
                    var Ct = function(z) {
                        this.gl = z.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
                    };
                    Ct.prototype.get = function() {
                        return this.current;
                    }, Ct.prototype.set = function(z) {}, Ct.prototype.getDefault = function() {
                        return this.default;
                    }, Ct.prototype.setDefault = function() {
                        this.set(this.default);
                    };
                    var Yt = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return i.Color.transparent;
                        }, z.prototype.set = function(O) {
                            var $ = this.current;
                            O.r === $.r && O.g === $.g && O.b === $.b && O.a === $.a && !this.dirty || (this.gl.clearColor(O.r, O.g, O.b, O.a), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), xr = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return 1;
                        }, z.prototype.set = function(O) {
                            O === this.current && !this.dirty || (this.gl.clearDepth(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), er = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return 0;
                        }, z.prototype.set = function(O) {
                            O === this.current && !this.dirty || (this.gl.clearStencil(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Ke = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return [
                                !0,
                                !0,
                                !0,
                                !0
                            ];
                        }, z.prototype.set = function(O) {
                            var $ = this.current;
                            O[0] === $[0] && O[1] === $[1] && O[2] === $[2] && O[3] === $[3] && !this.dirty || (this.gl.colorMask(O[0], O[1], O[2], O[3]), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), xt = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return !0;
                        }, z.prototype.set = function(O) {
                            O === this.current && !this.dirty || (this.gl.depthMask(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), bt = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return 255;
                        }, z.prototype.set = function(O) {
                            O === this.current && !this.dirty || (this.gl.stencilMask(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Lt = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return {
                                func: this.gl.ALWAYS,
                                ref: 0,
                                mask: 255
                            };
                        }, z.prototype.set = function(O) {
                            var $ = this.current;
                            O.func === $.func && O.ref === $.ref && O.mask === $.mask && !this.dirty || (this.gl.stencilFunc(O.func, O.ref, O.mask), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), St = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            var O = this.gl;
                            return [
                                O.KEEP,
                                O.KEEP,
                                O.KEEP
                            ];
                        }, z.prototype.set = function(O) {
                            var $ = this.current;
                            O[0] === $[0] && O[1] === $[1] && O[2] === $[2] && !this.dirty || (this.gl.stencilOp(O[0], O[1], O[2]), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Et = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return !1;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                O ? $.enable($.STENCIL_TEST) : $.disable($.STENCIL_TEST), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), dt = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return [
                                0,
                                1
                            ];
                        }, z.prototype.set = function(O) {
                            var $ = this.current;
                            O[0] === $[0] && O[1] === $[1] && !this.dirty || (this.gl.depthRange(O[0], O[1]), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Ht = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return !1;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                O ? $.enable($.DEPTH_TEST) : $.disable($.DEPTH_TEST), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), $t = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return this.gl.LESS;
                        }, z.prototype.set = function(O) {
                            O === this.current && !this.dirty || (this.gl.depthFunc(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), fr = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return !1;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                O ? $.enable($.BLEND) : $.disable($.BLEND), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), _r = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            var O = this.gl;
                            return [
                                O.ONE,
                                O.ZERO
                            ];
                        }, z.prototype.set = function(O) {
                            var $ = this.current;
                            O[0] === $[0] && O[1] === $[1] && !this.dirty || (this.gl.blendFunc(O[0], O[1]), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Br = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return i.Color.transparent;
                        }, z.prototype.set = function(O) {
                            var $ = this.current;
                            O.r === $.r && O.g === $.g && O.b === $.b && O.a === $.a && !this.dirty || (this.gl.blendColor(O.r, O.g, O.b, O.a), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Or = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return this.gl.FUNC_ADD;
                        }, z.prototype.set = function(O) {
                            O === this.current && !this.dirty || (this.gl.blendEquation(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Nr = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return !1;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                O ? $.enable($.CULL_FACE) : $.disable($.CULL_FACE), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), ut = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return this.gl.BACK;
                        }, z.prototype.set = function(O) {
                            O === this.current && !this.dirty || (this.gl.cullFace(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Ne = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return this.gl.CCW;
                        }, z.prototype.set = function(O) {
                            O === this.current && !this.dirty || (this.gl.frontFace(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Ye = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return null;
                        }, z.prototype.set = function(O) {
                            O === this.current && !this.dirty || (this.gl.useProgram(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Ve = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return this.gl.TEXTURE0;
                        }, z.prototype.set = function(O) {
                            O === this.current && !this.dirty || (this.gl.activeTexture(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Xe = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            var O = this.gl;
                            return [
                                0,
                                0,
                                O.drawingBufferWidth,
                                O.drawingBufferHeight
                            ];
                        }, z.prototype.set = function(O) {
                            var $ = this.current;
                            O[0] === $[0] && O[1] === $[1] && O[2] === $[2] && O[3] === $[3] && !this.dirty || (this.gl.viewport(O[0], O[1], O[2], O[3]), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), ht = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return null;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                $.bindFramebuffer($.FRAMEBUFFER, O), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), Le = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return null;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                $.bindRenderbuffer($.RENDERBUFFER, O), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), xe = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return null;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                $.bindTexture($.TEXTURE_2D, O), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), Se = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return null;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                $.bindBuffer($.ARRAY_BUFFER, O), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), lt = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return null;
                        }, z.prototype.set = function(O) {
                            var $ = this.gl;
                            $.bindBuffer($.ELEMENT_ARRAY_BUFFER, O), this.current = O, this.dirty = !1;
                        }, z;
                    }(Ct), Gt = function(Y1) {
                        function z(K) {
                            Y1.call(this, K), this.vao = K.extVertexArrayObject;
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return null;
                        }, z.prototype.set = function(O) {
                            !this.vao || O === this.current && !this.dirty || (this.vao.bindVertexArrayOES(O), this.current = O, this.dirty = !1);
                        }, z;
                    }(Ct), Vt = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return 4;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                $.pixelStorei($.UNPACK_ALIGNMENT, O), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), ar = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return !1;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                $.pixelStorei($.UNPACK_PREMULTIPLY_ALPHA_WEBGL, O), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), Qr = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return !1;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                var $ = this.gl;
                                $.pixelStorei($.UNPACK_FLIP_Y_WEBGL, O), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(Ct), ai = function(Y1) {
                        function z(K, O) {
                            Y1.call(this, K), this.context = K, this.parent = O;
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getDefault = function() {
                            return null;
                        }, z;
                    }(Ct), jr = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.setDirty = function() {
                            this.dirty = !0;
                        }, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                this.context.bindFramebuffer.set(this.parent);
                                var $ = this.gl;
                                $.framebufferTexture2D($.FRAMEBUFFER, $.COLOR_ATTACHMENT0, $.TEXTURE_2D, O, 0), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(ai), ri = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.set = function(O) {
                            if (!(O === this.current && !this.dirty)) {
                                this.context.bindFramebuffer.set(this.parent);
                                var $ = this.gl;
                                $.framebufferRenderbuffer($.FRAMEBUFFER, $.DEPTH_ATTACHMENT, $.RENDERBUFFER, O), this.current = O, this.dirty = !1;
                            }
                        }, z;
                    }(ai), bi = function(z, K, O, $) {
                        this.context = z, this.width = K, this.height = O;
                        var pe = z.gl, de = this.framebuffer = pe.createFramebuffer();
                        this.colorAttachment = new jr(z, de), $ && (this.depthAttachment = new ri(z, de));
                    };
                    bi.prototype.destroy = function() {
                        var z = this.context.gl, K = this.colorAttachment.get();
                        if (K && z.deleteTexture(K), this.depthAttachment) {
                            var O = this.depthAttachment.get();
                            O && z.deleteRenderbuffer(O);
                        }
                        z.deleteFramebuffer(this.framebuffer);
                    };
                    var nn = 519, Wi = function(z, K, O) {
                        this.func = z, this.mask = K, this.range = O;
                    };
                    Wi.ReadOnly = !1, Wi.ReadWrite = !0, Wi.disabled = new Wi(nn, Wi.ReadOnly, [
                        0,
                        1
                    ]);
                    var Ni = 519, _n = 7680, $i = function(z, K, O, $, pe, de) {
                        this.test = z, this.ref = K, this.mask = O, this.fail = $, this.depthFail = pe, this.pass = de;
                    };
                    $i.disabled = new $i({
                        func: Ni,
                        mask: 0
                    }, 0, 0, _n, _n, _n);
                    var zn = 0, Wn = 1, It = 771, ft = function(z, K, O) {
                        this.blendFunction = z, this.blendColor = K, this.mask = O;
                    };
                    ft.Replace = [
                        Wn,
                        zn
                    ], ft.disabled = new ft(ft.Replace, i.Color.transparent, [
                        !1,
                        !1,
                        !1,
                        !1
                    ]), ft.unblended = new ft(ft.Replace, i.Color.transparent, [
                        !0,
                        !0,
                        !0,
                        !0
                    ]), ft.alphaBlended = new ft([
                        Wn,
                        It
                    ], i.Color.transparent, [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                    var jt = 1029, Zt = 2305, yr = function(z, K, O) {
                        this.enable = z, this.mode = K, this.frontFace = O;
                    };
                    yr.disabled = new yr(!1, jt, Zt), yr.backCCW = new yr(!0, jt, Zt);
                    var Fr = function(z) {
                        this.gl = z, this.extVertexArrayObject = this.gl.getExtension("OES_vertex_array_object"), this.clearColor = new Yt(this), this.clearDepth = new xr(this), this.clearStencil = new er(this), this.colorMask = new Ke(this), this.depthMask = new xt(this), this.stencilMask = new bt(this), this.stencilFunc = new Lt(this), this.stencilOp = new St(this), this.stencilTest = new Et(this), this.depthRange = new dt(this), this.depthTest = new Ht(this), this.depthFunc = new $t(this), this.blend = new fr(this), this.blendFunc = new _r(this), this.blendColor = new Br(this), this.blendEquation = new Or(this), this.cullFace = new Nr(this), this.cullFaceSide = new ut(this), this.frontFace = new Ne(this), this.program = new Ye(this), this.activeTexture = new Ve(this), this.viewport = new Xe(this), this.bindFramebuffer = new ht(this), this.bindRenderbuffer = new Le(this), this.bindTexture = new xe(this), this.bindVertexBuffer = new Se(this), this.bindElementBuffer = new lt(this), this.bindVertexArrayOES = this.extVertexArrayObject && new Gt(this), this.pixelStoreUnpack = new Vt(this), this.pixelStoreUnpackPremultiplyAlpha = new ar(this), this.pixelStoreUnpackFlipY = new Qr(this), this.extTextureFilterAnisotropic = z.getExtension("EXT_texture_filter_anisotropic") || z.getExtension("MOZ_EXT_texture_filter_anisotropic") || z.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = z.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.extTextureHalfFloat = z.getExtension("OES_texture_half_float"), this.extTextureHalfFloat && (z.getExtension("OES_texture_half_float_linear"), this.extRenderToTextureHalfFloat = z.getExtension("EXT_color_buffer_half_float")), this.extTimerQuery = z.getExtension("EXT_disjoint_timer_query"), this.maxTextureSize = z.getParameter(z.MAX_TEXTURE_SIZE);
                    };
                    Fr.prototype.setDefault = function() {
                        this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
                    }, Fr.prototype.setDirty = function() {
                        this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.extVertexArrayObject && (this.bindVertexArrayOES.dirty = !0), this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
                    }, Fr.prototype.createIndexBuffer = function(z, K) {
                        return new ot(this, z, K);
                    }, Fr.prototype.createVertexBuffer = function(z, K, O) {
                        return new kt(this, z, K, O);
                    }, Fr.prototype.createRenderbuffer = function(z, K, O) {
                        var $ = this.gl, pe = $.createRenderbuffer();
                        return this.bindRenderbuffer.set(pe), $.renderbufferStorage($.RENDERBUFFER, z, K, O), this.bindRenderbuffer.set(null), pe;
                    }, Fr.prototype.createFramebuffer = function(z, K, O) {
                        return new bi(this, z, K, O);
                    }, Fr.prototype.clear = function(z) {
                        var K = z.color, O = z.depth, $ = this.gl, pe = 0;
                        K && (pe |= $.COLOR_BUFFER_BIT, this.clearColor.set(K), this.colorMask.set([
                            !0,
                            !0,
                            !0,
                            !0
                        ])), typeof O != "undefined" && (pe |= $.DEPTH_BUFFER_BIT, this.depthRange.set([
                            0,
                            1
                        ]), this.clearDepth.set(O), this.depthMask.set(!0)), $.clear(pe);
                    }, Fr.prototype.setCullFace = function(z) {
                        z.enable === !1 ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(z.mode), this.frontFace.set(z.frontFace));
                    }, Fr.prototype.setDepthMode = function(z) {
                        z.func === this.gl.ALWAYS && !z.mask ? this.depthTest.set(!1) : (this.depthTest.set(!0), this.depthFunc.set(z.func), this.depthMask.set(z.mask), this.depthRange.set(z.range));
                    }, Fr.prototype.setStencilMode = function(z) {
                        z.test.func === this.gl.ALWAYS && !z.mask ? this.stencilTest.set(!1) : (this.stencilTest.set(!0), this.stencilMask.set(z.mask), this.stencilOp.set([
                            z.fail,
                            z.depthFail,
                            z.pass
                        ]), this.stencilFunc.set({
                            func: z.test.func,
                            ref: z.ref,
                            mask: z.test.mask
                        }));
                    }, Fr.prototype.setColorMode = function(z) {
                        i.deepEqual(z.blendFunction, ft.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(z.blendFunction), this.blendColor.set(z.blendColor)), this.colorMask.set(z.mask);
                    }, Fr.prototype.unbindVAO = function() {
                        this.extVertexArrayObject && this.bindVertexArrayOES.set(null);
                    };
                    var Zr = function(Y1) {
                        function z(K, O, $) {
                            var pe = this;
                            Y1.call(this), this.id = K, this.dispatcher = $, this.on("data", function(de) {
                                de.dataType === "source" && de.sourceDataType === "metadata" && (pe._sourceLoaded = !0), pe._sourceLoaded && !pe._paused && de.dataType === "source" && de.sourceDataType === "content" && (pe.reload(), pe.transform && pe.update(pe.transform));
                            }), this.on("error", function() {
                                pe._sourceErrored = !0;
                            }), this._source = Ae(K, O, $, this), this._tiles = {}, this._cache = new rt(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new i.SourceFeatureState;
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.onAdd = function(O) {
                            this.map = O, this._maxTileCacheSize = O ? O._maxTileCacheSize : null, this._source && this._source.onAdd && this._source.onAdd(O);
                        }, z.prototype.onRemove = function(O) {
                            this._source && this._source.onRemove && this._source.onRemove(O);
                        }, z.prototype.loaded = function() {
                            if (this._sourceErrored) return !0;
                            if (!this._sourceLoaded || !this._source.loaded()) return !1;
                            for(var O in this._tiles){
                                var $ = this._tiles[O];
                                if ($.state !== "loaded" && $.state !== "errored") return !1;
                            }
                            return !0;
                        }, z.prototype.getSource = function() {
                            return this._source;
                        }, z.prototype.pause = function() {
                            this._paused = !0;
                        }, z.prototype.resume = function() {
                            if (this._paused) {
                                var O = this._shouldReloadOnResume;
                                this._paused = !1, this._shouldReloadOnResume = !1, O && this.reload(), this.transform && this.update(this.transform);
                            }
                        }, z.prototype._loadTile = function(O, $) {
                            return this._source.loadTile(O, $);
                        }, z.prototype._unloadTile = function(O) {
                            if (this._source.unloadTile) return this._source.unloadTile(O, function() {});
                        }, z.prototype._abortTile = function(O) {
                            if (this._source.abortTile) return this._source.abortTile(O, function() {});
                        }, z.prototype.serialize = function() {
                            return this._source.serialize();
                        }, z.prototype.prepare = function(O) {
                            this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                            for(var $ in this._tiles){
                                var pe = this._tiles[$];
                                pe.upload(O), pe.prepare(this.map.style.imageManager);
                            }
                        }, z.prototype.getIds = function() {
                            return i.values(this._tiles).map(function(O) {
                                return O.tileID;
                            }).sort(Vr).map(function(O) {
                                return O.key;
                            });
                        }, z.prototype.getRenderableIds = function(O) {
                            var $ = this, pe = [];
                            for(var de in this._tiles)this._isIdRenderable(de, O) && pe.push(this._tiles[de]);
                            return O ? pe.sort(function(Ie, $e) {
                                var pt = Ie.tileID, Kt = $e.tileID, ir = new i.Point(pt.canonical.x, pt.canonical.y)._rotate($.transform.angle), Jt = new i.Point(Kt.canonical.x, Kt.canonical.y)._rotate($.transform.angle);
                                return pt.overscaledZ - Kt.overscaledZ || Jt.y - ir.y || Jt.x - ir.x;
                            }).map(function(Ie) {
                                return Ie.tileID.key;
                            }) : pe.map(function(Ie) {
                                return Ie.tileID;
                            }).sort(Vr).map(function(Ie) {
                                return Ie.key;
                            });
                        }, z.prototype.hasRenderableParent = function(O) {
                            var $ = this.findLoadedParent(O, 0);
                            return $ ? this._isIdRenderable($.tileID.key) : !1;
                        }, z.prototype._isIdRenderable = function(O, $) {
                            return this._tiles[O] && this._tiles[O].hasData() && !this._coveredTiles[O] && ($ || !this._tiles[O].holdingForFade());
                        }, z.prototype.reload = function() {
                            if (this._paused) {
                                this._shouldReloadOnResume = !0;
                                return;
                            }
                            this._cache.reset();
                            for(var O in this._tiles)this._tiles[O].state !== "errored" && this._reloadTile(O, "reloading");
                        }, z.prototype._reloadTile = function(O, $) {
                            var pe = this._tiles[O];
                            pe && (pe.state !== "loading" && (pe.state = $), this._loadTile(pe, this._tileLoaded.bind(this, pe, O, $)));
                        }, z.prototype._tileLoaded = function(O, $, pe, de) {
                            if (de) {
                                O.state = "errored", de.status !== 404 ? this._source.fire(new i.ErrorEvent(de, {
                                    tile: O
                                })) : this.update(this.transform);
                                return;
                            }
                            O.timeAdded = i.browser.now(), pe === "expired" && (O.refreshedUponExpiration = !0), this._setTileReloadTimer($, O), this.getSource().type === "raster-dem" && O.dem && this._backfillDEM(O), this._state.initializeTileState(O, this.map ? this.map.painter : null), this._source.fire(new i.Event("data", {
                                dataType: "source",
                                tile: O,
                                coord: O.tileID
                            }));
                        }, z.prototype._backfillDEM = function(O) {
                            for(var $ = this.getRenderableIds(), pe = 0; pe < $.length; pe++){
                                var de = $[pe];
                                if (O.neighboringTiles && O.neighboringTiles[de]) {
                                    var Ie = this.getTileByID(de);
                                    $e(O, Ie), $e(Ie, O);
                                }
                            }
                            function $e(pt, Kt) {
                                pt.needsHillshadePrepare = !0;
                                var ir = Kt.tileID.canonical.x - pt.tileID.canonical.x, Jt = Kt.tileID.canonical.y - pt.tileID.canonical.y, vt = Math.pow(2, pt.tileID.canonical.z), Pt = Kt.tileID.key;
                                ir === 0 && Jt === 0 || Math.abs(Jt) > 1 || (Math.abs(ir) > 1 && (Math.abs(ir + vt) === 1 ? ir += vt : Math.abs(ir - vt) === 1 && (ir -= vt)), !(!Kt.dem || !pt.dem) && (pt.dem.backfillBorder(Kt.dem, ir, Jt), pt.neighboringTiles && pt.neighboringTiles[Pt] && (pt.neighboringTiles[Pt].backfilled = !0)));
                            }
                        }, z.prototype.getTile = function(O) {
                            return this.getTileByID(O.key);
                        }, z.prototype.getTileByID = function(O) {
                            return this._tiles[O];
                        }, z.prototype._retainLoadedChildren = function(O, $, pe, de) {
                            for(var Ie in this._tiles){
                                var $e = this._tiles[Ie];
                                if (!(de[Ie] || !$e.hasData() || $e.tileID.overscaledZ <= $ || $e.tileID.overscaledZ > pe)) {
                                    for(var pt = $e.tileID; $e && $e.tileID.overscaledZ > $ + 1;){
                                        var Kt = $e.tileID.scaledTo($e.tileID.overscaledZ - 1);
                                        $e = this._tiles[Kt.key], $e && $e.hasData() && (pt = Kt);
                                    }
                                    for(var ir = pt; ir.overscaledZ > $;)if (ir = ir.scaledTo(ir.overscaledZ - 1), O[ir.key]) {
                                        de[pt.key] = pt;
                                        break;
                                    }
                                }
                            }
                        }, z.prototype.findLoadedParent = function(O, $) {
                            if (O.key in this._loadedParentTiles) {
                                var pe = this._loadedParentTiles[O.key];
                                return pe && pe.tileID.overscaledZ >= $ ? pe : null;
                            }
                            for(var de = O.overscaledZ - 1; de >= $; de--){
                                var Ie = O.scaledTo(de), $e = this._getLoadedTile(Ie);
                                if ($e) return $e;
                            }
                        }, z.prototype._getLoadedTile = function(O) {
                            var $ = this._tiles[O.key];
                            if ($ && $.hasData()) return $;
                            var pe = this._cache.getByKey(O.wrapped().key);
                            return pe;
                        }, z.prototype.updateCacheSize = function(O) {
                            var $ = Math.ceil(O.width / this._source.tileSize) + 1, pe = Math.ceil(O.height / this._source.tileSize) + 1, de = $ * pe, Ie = 5, $e = Math.floor(de * Ie), pt = typeof this._maxTileCacheSize == "number" ? Math.min(this._maxTileCacheSize, $e) : $e;
                            this._cache.setMaxSize(pt);
                        }, z.prototype.handleWrapJump = function(O) {
                            var $ = this._prevLng === void 0 ? O : this._prevLng, pe = O - $, de = pe / 360, Ie = Math.round(de);
                            if (this._prevLng = O, Ie) {
                                var $e = {};
                                for(var pt in this._tiles){
                                    var Kt = this._tiles[pt];
                                    Kt.tileID = Kt.tileID.unwrapTo(Kt.tileID.wrap + Ie), $e[Kt.tileID.key] = Kt;
                                }
                                this._tiles = $e;
                                for(var ir in this._timers)clearTimeout(this._timers[ir]), delete this._timers[ir];
                                for(var Jt in this._tiles){
                                    var vt = this._tiles[Jt];
                                    this._setTileReloadTimer(Jt, vt);
                                }
                            }
                        }, z.prototype.update = function(O) {
                            var $ = this;
                            if (this.transform = O, !(!this._sourceLoaded || this._paused)) {
                                this.updateCacheSize(O), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {};
                                var pe;
                                this.used ? this._source.tileID ? pe = O.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(yi) {
                                    return new i.OverscaledTileID(yi.canonical.z, yi.wrap, yi.canonical.z, yi.canonical.x, yi.canonical.y);
                                }) : (pe = O.coveringTiles({
                                    tileSize: this._source.tileSize,
                                    minzoom: this._source.minzoom,
                                    maxzoom: this._source.maxzoom,
                                    roundZoom: this._source.roundZoom,
                                    reparseOverscaled: this._source.reparseOverscaled
                                }), this._source.hasTile && (pe = pe.filter(function(yi) {
                                    return $._source.hasTile(yi);
                                }))) : pe = [];
                                var de = O.coveringZoomLevel(this._source), Ie = Math.max(de - z.maxOverzooming, this._source.minzoom), $e = Math.max(de + z.maxUnderzooming, this._source.minzoom), pt = this._updateRetainedTiles(pe, de);
                                if (gi(this._source.type)) {
                                    for(var Kt = {}, ir = {}, Jt = Object.keys(pt), vt = 0, Pt = Jt; vt < Pt.length; vt += 1){
                                        var Wt = Pt[vt], rr = pt[Wt], dr = this._tiles[Wt];
                                        if (!(!dr || dr.fadeEndTime && dr.fadeEndTime <= i.browser.now())) {
                                            var pr = this.findLoadedParent(rr, Ie);
                                            pr && (this._addTile(pr.tileID), Kt[pr.tileID.key] = pr.tileID), ir[Wt] = rr;
                                        }
                                    }
                                    this._retainLoadedChildren(ir, de, $e, pt);
                                    for(var kr in Kt)pt[kr] || (this._coveredTiles[kr] = !0, pt[kr] = Kt[kr]);
                                }
                                for(var Ar in pt)this._tiles[Ar].clearFadeHold();
                                for(var gr = i.keysDifference(this._tiles, pt), Cr = 0, cr = gr; Cr < cr.length; Cr += 1){
                                    var Gr = cr[Cr], ei = this._tiles[Gr];
                                    ei.hasSymbolBuckets && !ei.holdingForFade() ? ei.setHoldDuration(this.map._fadeDuration) : (!ei.hasSymbolBuckets || ei.symbolFadeFinished()) && this._removeTile(Gr);
                                }
                                this._updateLoadedParentTileCache();
                            }
                        }, z.prototype.releaseSymbolFadeTiles = function() {
                            for(var O in this._tiles)this._tiles[O].holdingForFade() && this._removeTile(O);
                        }, z.prototype._updateRetainedTiles = function(O, $) {
                            for(var pe = {}, de = {}, Ie = Math.max($ - z.maxOverzooming, this._source.minzoom), $e = Math.max($ + z.maxUnderzooming, this._source.minzoom), pt = {}, Kt = 0, ir = O; Kt < ir.length; Kt += 1){
                                var Jt = ir[Kt], vt = this._addTile(Jt);
                                pe[Jt.key] = Jt, !vt.hasData() && $ < this._source.maxzoom && (pt[Jt.key] = Jt);
                            }
                            this._retainLoadedChildren(pt, $, $e, pe);
                            for(var Pt = 0, Wt = O; Pt < Wt.length; Pt += 1){
                                var rr = Wt[Pt], dr = this._tiles[rr.key];
                                if (!dr.hasData()) {
                                    if ($ + 1 > this._source.maxzoom) {
                                        var pr = rr.children(this._source.maxzoom)[0], kr = this.getTile(pr);
                                        if (kr && kr.hasData()) {
                                            pe[pr.key] = pr;
                                            continue;
                                        }
                                    } else {
                                        var Ar = rr.children(this._source.maxzoom);
                                        if (pe[Ar[0].key] && pe[Ar[1].key] && pe[Ar[2].key] && pe[Ar[3].key]) continue;
                                    }
                                    for(var gr = dr.wasRequested(), Cr = rr.overscaledZ - 1; Cr >= Ie; --Cr){
                                        var cr = rr.scaledTo(Cr);
                                        if (de[cr.key] || (de[cr.key] = !0, dr = this.getTile(cr), !dr && gr && (dr = this._addTile(cr)), dr && (pe[cr.key] = cr, gr = dr.wasRequested(), dr.hasData()))) break;
                                    }
                                }
                            }
                            return pe;
                        }, z.prototype._updateLoadedParentTileCache = function() {
                            this._loadedParentTiles = {};
                            for(var O in this._tiles){
                                for(var $ = [], pe = void 0, de = this._tiles[O].tileID; de.overscaledZ > 0;){
                                    if (de.key in this._loadedParentTiles) {
                                        pe = this._loadedParentTiles[de.key];
                                        break;
                                    }
                                    $.push(de.key);
                                    var Ie = de.scaledTo(de.overscaledZ - 1);
                                    if (pe = this._getLoadedTile(Ie), pe) break;
                                    de = Ie;
                                }
                                for(var $e = 0, pt = $; $e < pt.length; $e += 1){
                                    var Kt = pt[$e];
                                    this._loadedParentTiles[Kt] = pe;
                                }
                            }
                        }, z.prototype._addTile = function(O) {
                            var $ = this._tiles[O.key];
                            if ($) return $;
                            $ = this._cache.getAndRemove(O), $ && (this._setTileReloadTimer(O.key, $), $.tileID = O, this._state.initializeTileState($, this.map ? this.map.painter : null), this._cacheTimers[O.key] && (clearTimeout(this._cacheTimers[O.key]), delete this._cacheTimers[O.key], this._setTileReloadTimer(O.key, $)));
                            var pe = !!$;
                            return pe || ($ = new i.Tile(O, this._source.tileSize * O.overscaleFactor()), this._loadTile($, this._tileLoaded.bind(this, $, O.key, $.state))), $ ? ($.uses++, this._tiles[O.key] = $, pe || this._source.fire(new i.Event("dataloading", {
                                tile: $,
                                coord: $.tileID,
                                dataType: "source"
                            })), $) : null;
                        }, z.prototype._setTileReloadTimer = function(O, $) {
                            var pe = this;
                            O in this._timers && (clearTimeout(this._timers[O]), delete this._timers[O]);
                            var de = $.getExpiryTimeout();
                            de && (this._timers[O] = setTimeout(function() {
                                pe._reloadTile(O, "expired"), delete pe._timers[O];
                            }, de));
                        }, z.prototype._removeTile = function(O) {
                            var $ = this._tiles[O];
                            $ && ($.uses--, delete this._tiles[O], this._timers[O] && (clearTimeout(this._timers[O]), delete this._timers[O]), !($.uses > 0) && ($.hasData() && $.state !== "reloading" ? this._cache.add($.tileID, $, $.getExpiryTimeout()) : ($.aborted = !0, this._abortTile($), this._unloadTile($))));
                        }, z.prototype.clearTiles = function() {
                            this._shouldReloadOnResume = !1, this._paused = !1;
                            for(var O in this._tiles)this._removeTile(O);
                            this._cache.reset();
                        }, z.prototype.tilesIn = function(O, $, pe) {
                            var de = this, Ie = [], $e = this.transform;
                            if (!$e) return Ie;
                            for(var pt = pe ? $e.getCameraQueryGeometry(O) : O, Kt = O.map(function(Cr) {
                                return $e.pointCoordinate(Cr);
                            }), ir = pt.map(function(Cr) {
                                return $e.pointCoordinate(Cr);
                            }), Jt = this.getIds(), vt = 1 / 0, Pt = 1 / 0, Wt = -1 / 0, rr = -1 / 0, dr = 0, pr = ir; dr < pr.length; dr += 1){
                                var kr = pr[dr];
                                vt = Math.min(vt, kr.x), Pt = Math.min(Pt, kr.y), Wt = Math.max(Wt, kr.x), rr = Math.max(rr, kr.y);
                            }
                            for(var Ar = function(Cr) {
                                var cr = de._tiles[Jt[Cr]];
                                if (!cr.holdingForFade()) {
                                    var Gr = cr.tileID, ei = Math.pow(2, $e.zoom - cr.tileID.overscaledZ), yi = $ * cr.queryPadding * i.EXTENT / cr.tileSize / ei, tn = [
                                        Gr.getTilePoint(new i.MercatorCoordinate(vt, Pt)),
                                        Gr.getTilePoint(new i.MercatorCoordinate(Wt, rr))
                                    ];
                                    if (tn[0].x - yi < i.EXTENT && tn[0].y - yi < i.EXTENT && tn[1].x + yi >= 0 && tn[1].y + yi >= 0) {
                                        var Ri = Kt.map(function(Qn) {
                                            return Gr.getTilePoint(Qn);
                                        }), ln = ir.map(function(Qn) {
                                            return Gr.getTilePoint(Qn);
                                        });
                                        Ie.push({
                                            tile: cr,
                                            tileID: Gr,
                                            queryGeometry: Ri,
                                            cameraQueryGeometry: ln,
                                            scale: ei
                                        });
                                    }
                                }
                            }, gr = 0; gr < Jt.length; gr++)Ar(gr);
                            return Ie;
                        }, z.prototype.getVisibleCoordinates = function(O) {
                            for(var $ = this, pe = this.getRenderableIds(O).map(function(pt) {
                                return $._tiles[pt].tileID;
                            }), de = 0, Ie = pe; de < Ie.length; de += 1){
                                var $e = Ie[de];
                                $e.posMatrix = this.transform.calculatePosMatrix($e.toUnwrapped());
                            }
                            return pe;
                        }, z.prototype.hasTransition = function() {
                            if (this._source.hasTransition()) return !0;
                            if (gi(this._source.type)) for(var O in this._tiles){
                                var $ = this._tiles[O];
                                if ($.fadeEndTime !== void 0 && $.fadeEndTime >= i.browser.now()) return !0;
                            }
                            return !1;
                        }, z.prototype.setFeatureState = function(O, $, pe) {
                            O = O || "_geojsonTileLayer", this._state.updateState(O, $, pe);
                        }, z.prototype.removeFeatureState = function(O, $, pe) {
                            O = O || "_geojsonTileLayer", this._state.removeFeatureState(O, $, pe);
                        }, z.prototype.getFeatureState = function(O, $) {
                            return O = O || "_geojsonTileLayer", this._state.getState(O, $);
                        }, z.prototype.setDependencies = function(O, $, pe) {
                            var de = this._tiles[O];
                            de && de.setDependencies($, pe);
                        }, z.prototype.reloadTilesForDependencies = function(O, $) {
                            for(var pe in this._tiles){
                                var de = this._tiles[pe];
                                de.hasDependency(O, $) && this._reloadTile(pe, "reloading");
                            }
                            this._cache.filter(function(Ie) {
                                return !Ie.hasDependency(O, $);
                            });
                        }, z;
                    }(i.Evented);
                    Zr.maxOverzooming = 10, Zr.maxUnderzooming = 3;
                    function Vr(Y1, z) {
                        var K = Math.abs(Y1.wrap * 2) - +(Y1.wrap < 0), O = Math.abs(z.wrap * 2) - +(z.wrap < 0);
                        return Y1.overscaledZ - z.overscaledZ || O - K || z.canonical.y - Y1.canonical.y || z.canonical.x - Y1.canonical.x;
                    }
                    function gi(Y1) {
                        return Y1 === "raster" || Y1 === "image" || Y1 === "video";
                    }
                    function Si() {
                        return new i.window.Worker(ns.workerUrl);
                    }
                    var Mi = "mapboxgl_preloaded_worker_pool", Pi = function() {
                        this.active = {};
                    };
                    Pi.prototype.acquire = function(z) {
                        if (!this.workers) for(this.workers = []; this.workers.length < Pi.workerCount;)this.workers.push(new Si);
                        return this.active[z] = !0, this.workers.slice();
                    }, Pi.prototype.release = function(z) {
                        delete this.active[z], this.numActive() === 0 && (this.workers.forEach(function(K) {
                            K.terminate();
                        }), this.workers = null);
                    }, Pi.prototype.isPreloaded = function() {
                        return !!this.active[Mi];
                    }, Pi.prototype.numActive = function() {
                        return Object.keys(this.active).length;
                    };
                    var Gi = Math.floor(i.browser.hardwareConcurrency / 2);
                    Pi.workerCount = Math.max(Math.min(Gi, 6), 1);
                    var Ki;
                    function ka() {
                        return Ki || (Ki = new Pi), Ki;
                    }
                    function jn() {
                        var Y1 = ka();
                        Y1.acquire(Mi);
                    }
                    function la() {
                        var Y1 = Ki;
                        Y1 && (Y1.isPreloaded() && Y1.numActive() === 1 ? (Y1.release(Mi), Ki = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
                    }
                    function Fa(Y1, z) {
                        var K = {};
                        for(var O in Y1)O !== "ref" && (K[O] = Y1[O]);
                        return i.refProperties.forEach(function($) {
                            $ in z && (K[$] = z[$]);
                        }), K;
                    }
                    function Ra(Y1) {
                        Y1 = Y1.slice();
                        for(var z = Object.create(null), K = 0; K < Y1.length; K++)z[Y1[K].id] = Y1[K];
                        for(var O = 0; O < Y1.length; O++)"ref" in Y1[O] && (Y1[O] = Fa(Y1[O], z[Y1[O].ref]));
                        return Y1;
                    }
                    function jo() {
                        var Y1 = {}, z = i.styleSpec.$version;
                        for(var K in i.styleSpec.$root){
                            var O = i.styleSpec.$root[K];
                            if (O.required) {
                                var $ = null;
                                K === "version" ? $ = z : O.type === "array" ? $ = [] : $ = {}, $ != null && (Y1[K] = $);
                            }
                        }
                        return Y1;
                    }
                    var oa = {
                        setStyle: "setStyle",
                        addLayer: "addLayer",
                        removeLayer: "removeLayer",
                        setPaintProperty: "setPaintProperty",
                        setLayoutProperty: "setLayoutProperty",
                        setFilter: "setFilter",
                        addSource: "addSource",
                        removeSource: "removeSource",
                        setGeoJSONSourceData: "setGeoJSONSourceData",
                        setLayerZoomRange: "setLayerZoomRange",
                        setLayerProperty: "setLayerProperty",
                        setCenter: "setCenter",
                        setZoom: "setZoom",
                        setBearing: "setBearing",
                        setPitch: "setPitch",
                        setSprite: "setSprite",
                        setGlyphs: "setGlyphs",
                        setTransition: "setTransition",
                        setLight: "setLight"
                    };
                    function Sn(Y1, z, K) {
                        K.push({
                            command: oa.addSource,
                            args: [
                                Y1,
                                z[Y1]
                            ]
                        });
                    }
                    function Ha(Y1, z, K) {
                        z.push({
                            command: oa.removeSource,
                            args: [
                                Y1
                            ]
                        }), K[Y1] = !0;
                    }
                    function oo(Y1, z, K, O) {
                        Ha(Y1, K, O), Sn(Y1, z, K);
                    }
                    function xn(Y1, z, K) {
                        var O;
                        for(O in Y1[K])if (Y1[K].hasOwnProperty(O) && O !== "data" && !i.deepEqual(Y1[K][O], z[K][O])) return !1;
                        for(O in z[K])if (z[K].hasOwnProperty(O) && O !== "data" && !i.deepEqual(Y1[K][O], z[K][O])) return !1;
                        return !0;
                    }
                    function _t(Y1, z, K, O) {
                        Y1 = Y1 || {}, z = z || {};
                        var $;
                        for($ in Y1)Y1.hasOwnProperty($) && (z.hasOwnProperty($) || Ha($, K, O));
                        for($ in z)z.hasOwnProperty($) && (Y1.hasOwnProperty($) ? i.deepEqual(Y1[$], z[$]) || (Y1[$].type === "geojson" && z[$].type === "geojson" && xn(Y1, z, $) ? K.push({
                            command: oa.setGeoJSONSourceData,
                            args: [
                                $,
                                z[$].data
                            ]
                        }) : oo($, z, K, O)) : Sn($, z, K));
                    }
                    function br(Y1, z, K, O, $, pe) {
                        Y1 = Y1 || {}, z = z || {};
                        var de;
                        for(de in Y1)Y1.hasOwnProperty(de) && (i.deepEqual(Y1[de], z[de]) || K.push({
                            command: pe,
                            args: [
                                O,
                                de,
                                z[de],
                                $
                            ]
                        }));
                        for(de in z)!z.hasOwnProperty(de) || Y1.hasOwnProperty(de) || i.deepEqual(Y1[de], z[de]) || K.push({
                            command: pe,
                            args: [
                                O,
                                de,
                                z[de],
                                $
                            ]
                        });
                    }
                    function Hr(Y1) {
                        return Y1.id;
                    }
                    function ti(Y1, z) {
                        return Y1[z.id] = z, Y1;
                    }
                    function zi(Y1, z, K) {
                        Y1 = Y1 || [], z = z || [];
                        var O = Y1.map(Hr), $ = z.map(Hr), pe = Y1.reduce(ti, {}), de = z.reduce(ti, {}), Ie = O.slice(), $e = Object.create(null), pt, Kt, ir, Jt, vt, Pt, Wt;
                        for(pt = 0, Kt = 0; pt < O.length; pt++)ir = O[pt], de.hasOwnProperty(ir) ? Kt++ : (K.push({
                            command: oa.removeLayer,
                            args: [
                                ir
                            ]
                        }), Ie.splice(Ie.indexOf(ir, Kt), 1));
                        for(pt = 0, Kt = 0; pt < $.length; pt++)ir = $[$.length - 1 - pt], Ie[Ie.length - 1 - pt] !== ir && (pe.hasOwnProperty(ir) ? (K.push({
                            command: oa.removeLayer,
                            args: [
                                ir
                            ]
                        }), Ie.splice(Ie.lastIndexOf(ir, Ie.length - Kt), 1)) : Kt++, Pt = Ie[Ie.length - pt], K.push({
                            command: oa.addLayer,
                            args: [
                                de[ir],
                                Pt
                            ]
                        }), Ie.splice(Ie.length - pt, 0, ir), $e[ir] = !0);
                        for(pt = 0; pt < $.length; pt++)if (ir = $[pt], Jt = pe[ir], vt = de[ir], !($e[ir] || i.deepEqual(Jt, vt))) {
                            if (!i.deepEqual(Jt.source, vt.source) || !i.deepEqual(Jt["source-layer"], vt["source-layer"]) || !i.deepEqual(Jt.type, vt.type)) {
                                K.push({
                                    command: oa.removeLayer,
                                    args: [
                                        ir
                                    ]
                                }), Pt = Ie[Ie.lastIndexOf(ir) + 1], K.push({
                                    command: oa.addLayer,
                                    args: [
                                        vt,
                                        Pt
                                    ]
                                });
                                continue;
                            }
                            br(Jt.layout, vt.layout, K, ir, null, oa.setLayoutProperty), br(Jt.paint, vt.paint, K, ir, null, oa.setPaintProperty), i.deepEqual(Jt.filter, vt.filter) || K.push({
                                command: oa.setFilter,
                                args: [
                                    ir,
                                    vt.filter
                                ]
                            }), (!i.deepEqual(Jt.minzoom, vt.minzoom) || !i.deepEqual(Jt.maxzoom, vt.maxzoom)) && K.push({
                                command: oa.setLayerZoomRange,
                                args: [
                                    ir,
                                    vt.minzoom,
                                    vt.maxzoom
                                ]
                            });
                            for(Wt in Jt)Jt.hasOwnProperty(Wt) && (Wt === "layout" || Wt === "paint" || Wt === "filter" || Wt === "metadata" || Wt === "minzoom" || Wt === "maxzoom" || (Wt.indexOf("paint.") === 0 ? br(Jt[Wt], vt[Wt], K, ir, Wt.slice(6), oa.setPaintProperty) : i.deepEqual(Jt[Wt], vt[Wt]) || K.push({
                                command: oa.setLayerProperty,
                                args: [
                                    ir,
                                    Wt,
                                    vt[Wt]
                                ]
                            })));
                            for(Wt in vt)!vt.hasOwnProperty(Wt) || Jt.hasOwnProperty(Wt) || Wt === "layout" || Wt === "paint" || Wt === "filter" || Wt === "metadata" || Wt === "minzoom" || Wt === "maxzoom" || (Wt.indexOf("paint.") === 0 ? br(Jt[Wt], vt[Wt], K, ir, Wt.slice(6), oa.setPaintProperty) : i.deepEqual(Jt[Wt], vt[Wt]) || K.push({
                                command: oa.setLayerProperty,
                                args: [
                                    ir,
                                    Wt,
                                    vt[Wt]
                                ]
                            }));
                        }
                    }
                    function Yi(Y1, z) {
                        if (!Y1) return [
                            {
                                command: oa.setStyle,
                                args: [
                                    z
                                ]
                            }
                        ];
                        var K = [];
                        try {
                            if (!i.deepEqual(Y1.version, z.version)) return [
                                {
                                    command: oa.setStyle,
                                    args: [
                                        z
                                    ]
                                }
                            ];
                            i.deepEqual(Y1.center, z.center) || K.push({
                                command: oa.setCenter,
                                args: [
                                    z.center
                                ]
                            }), i.deepEqual(Y1.zoom, z.zoom) || K.push({
                                command: oa.setZoom,
                                args: [
                                    z.zoom
                                ]
                            }), i.deepEqual(Y1.bearing, z.bearing) || K.push({
                                command: oa.setBearing,
                                args: [
                                    z.bearing
                                ]
                            }), i.deepEqual(Y1.pitch, z.pitch) || K.push({
                                command: oa.setPitch,
                                args: [
                                    z.pitch
                                ]
                            }), i.deepEqual(Y1.sprite, z.sprite) || K.push({
                                command: oa.setSprite,
                                args: [
                                    z.sprite
                                ]
                            }), i.deepEqual(Y1.glyphs, z.glyphs) || K.push({
                                command: oa.setGlyphs,
                                args: [
                                    z.glyphs
                                ]
                            }), i.deepEqual(Y1.transition, z.transition) || K.push({
                                command: oa.setTransition,
                                args: [
                                    z.transition
                                ]
                            }), i.deepEqual(Y1.light, z.light) || K.push({
                                command: oa.setLight,
                                args: [
                                    z.light
                                ]
                            });
                            var O = {}, $ = [];
                            _t(Y1.sources, z.sources, $, O);
                            var pe = [];
                            Y1.layers && Y1.layers.forEach(function(de) {
                                O[de.source] ? K.push({
                                    command: oa.removeLayer,
                                    args: [
                                        de.id
                                    ]
                                }) : pe.push(de);
                            }), K = K.concat($), zi(pe, z.layers, K);
                        } catch (de) {
                            console.warn("Unable to compute style diff:", de), K = [
                                {
                                    command: oa.setStyle,
                                    args: [
                                        z
                                    ]
                                }
                            ];
                        }
                        return K;
                    }
                    var an = function(z, K) {
                        this.reset(z, K);
                    };
                    an.prototype.reset = function(z, K) {
                        this.points = z || [], this._distances = [
                            0
                        ];
                        for(var O = 1; O < this.points.length; O++)this._distances[O] = this._distances[O - 1] + this.points[O].dist(this.points[O - 1]);
                        this.length = this._distances[this._distances.length - 1], this.padding = Math.min(K || 0, this.length * .5), this.paddedLength = this.length - this.padding * 2;
                    }, an.prototype.lerp = function(z) {
                        if (this.points.length === 1) return this.points[0];
                        z = i.clamp(z, 0, 1);
                        for(var K = 1, O = this._distances[K], $ = z * this.paddedLength + this.padding; O < $ && K < this._distances.length;)O = this._distances[++K];
                        var pe = K - 1, de = this._distances[pe], Ie = O - de, $e = Ie > 0 ? ($ - de) / Ie : 0;
                        return this.points[pe].mult(1 - $e).add(this.points[K].mult($e));
                    };
                    var hi = function(z, K, O) {
                        var $ = this.boxCells = [], pe = this.circleCells = [];
                        this.xCellCount = Math.ceil(z / O), this.yCellCount = Math.ceil(K / O);
                        for(var de = 0; de < this.xCellCount * this.yCellCount; de++)$.push([]), pe.push([]);
                        this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = z, this.height = K, this.xScale = this.xCellCount / z, this.yScale = this.yCellCount / K, this.boxUid = 0, this.circleUid = 0;
                    };
                    hi.prototype.keysLength = function() {
                        return this.boxKeys.length + this.circleKeys.length;
                    }, hi.prototype.insert = function(z, K, O, $, pe) {
                        this._forEachCell(K, O, $, pe, this._insertBoxCell, this.boxUid++), this.boxKeys.push(z), this.bboxes.push(K), this.bboxes.push(O), this.bboxes.push($), this.bboxes.push(pe);
                    }, hi.prototype.insertCircle = function(z, K, O, $) {
                        this._forEachCell(K - $, O - $, K + $, O + $, this._insertCircleCell, this.circleUid++), this.circleKeys.push(z), this.circles.push(K), this.circles.push(O), this.circles.push($);
                    }, hi.prototype._insertBoxCell = function(z, K, O, $, pe, de) {
                        this.boxCells[pe].push(de);
                    }, hi.prototype._insertCircleCell = function(z, K, O, $, pe, de) {
                        this.circleCells[pe].push(de);
                    }, hi.prototype._query = function(z, K, O, $, pe, de) {
                        if (O < 0 || z > this.width || $ < 0 || K > this.height) return pe ? !1 : [];
                        var Ie = [];
                        if (z <= 0 && K <= 0 && this.width <= O && this.height <= $) {
                            if (pe) return !0;
                            for(var $e = 0; $e < this.boxKeys.length; $e++)Ie.push({
                                key: this.boxKeys[$e],
                                x1: this.bboxes[$e * 4],
                                y1: this.bboxes[$e * 4 + 1],
                                x2: this.bboxes[$e * 4 + 2],
                                y2: this.bboxes[$e * 4 + 3]
                            });
                            for(var pt = 0; pt < this.circleKeys.length; pt++){
                                var Kt = this.circles[pt * 3], ir = this.circles[pt * 3 + 1], Jt = this.circles[pt * 3 + 2];
                                Ie.push({
                                    key: this.circleKeys[pt],
                                    x1: Kt - Jt,
                                    y1: ir - Jt,
                                    x2: Kt + Jt,
                                    y2: ir + Jt
                                });
                            }
                            return de ? Ie.filter(de) : Ie;
                        } else {
                            var vt = {
                                hitTest: pe,
                                seenUids: {
                                    box: {},
                                    circle: {}
                                }
                            };
                            return this._forEachCell(z, K, O, $, this._queryCell, Ie, vt, de), pe ? Ie.length > 0 : Ie;
                        }
                    }, hi.prototype._queryCircle = function(z, K, O, $, pe) {
                        var de = z - O, Ie = z + O, $e = K - O, pt = K + O;
                        if (Ie < 0 || de > this.width || pt < 0 || $e > this.height) return $ ? !1 : [];
                        var Kt = [], ir = {
                            hitTest: $,
                            circle: {
                                x: z,
                                y: K,
                                radius: O
                            },
                            seenUids: {
                                box: {},
                                circle: {}
                            }
                        };
                        return this._forEachCell(de, $e, Ie, pt, this._queryCellCircle, Kt, ir, pe), $ ? Kt.length > 0 : Kt;
                    }, hi.prototype.query = function(z, K, O, $, pe) {
                        return this._query(z, K, O, $, !1, pe);
                    }, hi.prototype.hitTest = function(z, K, O, $, pe) {
                        return this._query(z, K, O, $, !0, pe);
                    }, hi.prototype.hitTestCircle = function(z, K, O, $) {
                        return this._queryCircle(z, K, O, !0, $);
                    }, hi.prototype._queryCell = function(z, K, O, $, pe, de, Ie, $e) {
                        var pt = Ie.seenUids, Kt = this.boxCells[pe];
                        if (Kt !== null) for(var ir = this.bboxes, Jt = 0, vt = Kt; Jt < vt.length; Jt += 1){
                            var Pt = vt[Jt];
                            if (!pt.box[Pt]) {
                                pt.box[Pt] = !0;
                                var Wt = Pt * 4;
                                if (z <= ir[Wt + 2] && K <= ir[Wt + 3] && O >= ir[Wt + 0] && $ >= ir[Wt + 1] && (!$e || $e(this.boxKeys[Pt]))) {
                                    if (Ie.hitTest) return de.push(!0), !0;
                                    de.push({
                                        key: this.boxKeys[Pt],
                                        x1: ir[Wt],
                                        y1: ir[Wt + 1],
                                        x2: ir[Wt + 2],
                                        y2: ir[Wt + 3]
                                    });
                                }
                            }
                        }
                        var rr = this.circleCells[pe];
                        if (rr !== null) for(var dr = this.circles, pr = 0, kr = rr; pr < kr.length; pr += 1){
                            var Ar = kr[pr];
                            if (!pt.circle[Ar]) {
                                pt.circle[Ar] = !0;
                                var gr = Ar * 3;
                                if (this._circleAndRectCollide(dr[gr], dr[gr + 1], dr[gr + 2], z, K, O, $) && (!$e || $e(this.circleKeys[Ar]))) {
                                    if (Ie.hitTest) return de.push(!0), !0;
                                    var Cr = dr[gr], cr = dr[gr + 1], Gr = dr[gr + 2];
                                    de.push({
                                        key: this.circleKeys[Ar],
                                        x1: Cr - Gr,
                                        y1: cr - Gr,
                                        x2: Cr + Gr,
                                        y2: cr + Gr
                                    });
                                }
                            }
                        }
                    }, hi.prototype._queryCellCircle = function(z, K, O, $, pe, de, Ie, $e) {
                        var pt = Ie.circle, Kt = Ie.seenUids, ir = this.boxCells[pe];
                        if (ir !== null) for(var Jt = this.bboxes, vt = 0, Pt = ir; vt < Pt.length; vt += 1){
                            var Wt = Pt[vt];
                            if (!Kt.box[Wt]) {
                                Kt.box[Wt] = !0;
                                var rr = Wt * 4;
                                if (this._circleAndRectCollide(pt.x, pt.y, pt.radius, Jt[rr + 0], Jt[rr + 1], Jt[rr + 2], Jt[rr + 3]) && (!$e || $e(this.boxKeys[Wt]))) return de.push(!0), !0;
                            }
                        }
                        var dr = this.circleCells[pe];
                        if (dr !== null) for(var pr = this.circles, kr = 0, Ar = dr; kr < Ar.length; kr += 1){
                            var gr = Ar[kr];
                            if (!Kt.circle[gr]) {
                                Kt.circle[gr] = !0;
                                var Cr = gr * 3;
                                if (this._circlesCollide(pr[Cr], pr[Cr + 1], pr[Cr + 2], pt.x, pt.y, pt.radius) && (!$e || $e(this.circleKeys[gr]))) return de.push(!0), !0;
                            }
                        }
                    }, hi.prototype._forEachCell = function(z, K, O, $, pe, de, Ie, $e) {
                        for(var pt = this._convertToXCellCoord(z), Kt = this._convertToYCellCoord(K), ir = this._convertToXCellCoord(O), Jt = this._convertToYCellCoord($), vt = pt; vt <= ir; vt++)for(var Pt = Kt; Pt <= Jt; Pt++){
                            var Wt = this.xCellCount * Pt + vt;
                            if (pe.call(this, z, K, O, $, Wt, de, Ie, $e)) return;
                        }
                    }, hi.prototype._convertToXCellCoord = function(z) {
                        return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(z * this.xScale)));
                    }, hi.prototype._convertToYCellCoord = function(z) {
                        return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(z * this.yScale)));
                    }, hi.prototype._circlesCollide = function(z, K, O, $, pe, de) {
                        var Ie = $ - z, $e = pe - K, pt = O + de;
                        return pt * pt > Ie * Ie + $e * $e;
                    }, hi.prototype._circleAndRectCollide = function(z, K, O, $, pe, de, Ie) {
                        var $e = (de - $) / 2, pt = Math.abs(z - ($ + $e));
                        if (pt > $e + O) return !1;
                        var Kt = (Ie - pe) / 2, ir = Math.abs(K - (pe + Kt));
                        if (ir > Kt + O) return !1;
                        if (pt <= $e || ir <= Kt) return !0;
                        var Jt = pt - $e, vt = ir - Kt;
                        return Jt * Jt + vt * vt <= O * O;
                    };
                    function Ji(Y1, z, K, O, $) {
                        var pe = i.create();
                        return z ? (i.scale(pe, pe, [
                            1 / $,
                            1 / $,
                            1
                        ]), K || i.rotateZ(pe, pe, O.angle)) : i.multiply(pe, O.labelPlaneMatrix, Y1), pe;
                    }
                    function ua(Y1, z, K, O, $) {
                        if (z) {
                            var pe = i.clone(Y1);
                            return i.scale(pe, pe, [
                                $,
                                $,
                                1
                            ]), K || i.rotateZ(pe, pe, -O.angle), pe;
                        } else return O.glCoordMatrix;
                    }
                    function Fn(Y1, z) {
                        var K = [
                            Y1.x,
                            Y1.y,
                            0,
                            1
                        ];
                        wl(K, K, z);
                        var O = K[3];
                        return {
                            point: new i.Point(K[0] / O, K[1] / O),
                            signedDistanceFromCamera: O
                        };
                    }
                    function Sa(Y1, z) {
                        return .5 + .5 * (Y1 / z);
                    }
                    function go(Y1, z) {
                        var K = Y1[0] / Y1[3], O = Y1[1] / Y1[3], $ = K >= -z[0] && K <= z[0] && O >= -z[1] && O <= z[1];
                        return $;
                    }
                    function Oo(Y1, z, K, O, $, pe, de, Ie) {
                        var $e = O ? Y1.textSizeData : Y1.iconSizeData, pt = i.evaluateSizeForZoom($e, K.transform.zoom), Kt = [
                            256 / K.width * 2 + 1,
                            256 / K.height * 2 + 1
                        ], ir = O ? Y1.text.dynamicLayoutVertexArray : Y1.icon.dynamicLayoutVertexArray;
                        ir.clear();
                        for(var Jt = Y1.lineVertexArray, vt = O ? Y1.text.placedSymbolArray : Y1.icon.placedSymbolArray, Pt = K.transform.width / K.transform.height, Wt = !1, rr = 0; rr < vt.length; rr++){
                            var dr = vt.get(rr);
                            if (dr.hidden || dr.writingMode === i.WritingMode.vertical && !Wt) {
                                Xs(dr.numGlyphs, ir);
                                continue;
                            }
                            Wt = !1;
                            var pr = [
                                dr.anchorX,
                                dr.anchorY,
                                0,
                                1
                            ];
                            if (i.transformMat4(pr, pr, z), !go(pr, Kt)) {
                                Xs(dr.numGlyphs, ir);
                                continue;
                            }
                            var kr = pr[3], Ar = Sa(K.transform.cameraToCenterDistance, kr), gr = i.evaluateSizeForFeature($e, pt, dr), Cr = de ? gr / Ar : gr * Ar, cr = new i.Point(dr.anchorX, dr.anchorY), Gr = Fn(cr, $).point, ei = {}, yi = xo(dr, Cr, !1, Ie, z, $, pe, Y1.glyphOffsetArray, Jt, ir, Gr, cr, ei, Pt);
                            Wt = yi.useVertical, (yi.notEnoughRoom || Wt || yi.needsFlipping && xo(dr, Cr, !0, Ie, z, $, pe, Y1.glyphOffsetArray, Jt, ir, Gr, cr, ei, Pt).notEnoughRoom) && Xs(dr.numGlyphs, ir);
                        }
                        O ? Y1.text.dynamicLayoutVertexBuffer.updateData(ir) : Y1.icon.dynamicLayoutVertexBuffer.updateData(ir);
                    }
                    function ho(Y1, z, K, O, $, pe, de, Ie, $e, pt, Kt) {
                        var ir = Ie.glyphStartIndex + Ie.numGlyphs, Jt = Ie.lineStartIndex, vt = Ie.lineStartIndex + Ie.lineLength, Pt = z.getoffsetX(Ie.glyphStartIndex), Wt = z.getoffsetX(ir - 1), rr = ks(Y1 * Pt, K, O, $, pe, de, Ie.segment, Jt, vt, $e, pt, Kt);
                        if (!rr) return null;
                        var dr = ks(Y1 * Wt, K, O, $, pe, de, Ie.segment, Jt, vt, $e, pt, Kt);
                        return dr ? {
                            first: rr,
                            last: dr
                        } : null;
                    }
                    function Mo(Y1, z, K, O) {
                        if (Y1 === i.WritingMode.horizontal) {
                            var $ = Math.abs(K.y - z.y), pe = Math.abs(K.x - z.x) * O;
                            if ($ > pe) return {
                                useVertical: !0
                            };
                        }
                        return (Y1 === i.WritingMode.vertical ? z.y < K.y : z.x > K.x) ? {
                            needsFlipping: !0
                        } : null;
                    }
                    function xo(Y1, z, K, O, $, pe, de, Ie, $e, pt, Kt, ir, Jt, vt) {
                        var Pt = z / 24, Wt = Y1.lineOffsetX * Pt, rr = Y1.lineOffsetY * Pt, dr;
                        if (Y1.numGlyphs > 1) {
                            var pr = Y1.glyphStartIndex + Y1.numGlyphs, kr = Y1.lineStartIndex, Ar = Y1.lineStartIndex + Y1.lineLength, gr = ho(Pt, Ie, Wt, rr, K, Kt, ir, Y1, $e, pe, Jt);
                            if (!gr) return {
                                notEnoughRoom: !0
                            };
                            var Cr = Fn(gr.first.point, de).point, cr = Fn(gr.last.point, de).point;
                            if (O && !K) {
                                var Gr = Mo(Y1.writingMode, Cr, cr, vt);
                                if (Gr) return Gr;
                            }
                            dr = [
                                gr.first
                            ];
                            for(var ei = Y1.glyphStartIndex + 1; ei < pr - 1; ei++)dr.push(ks(Pt * Ie.getoffsetX(ei), Wt, rr, K, Kt, ir, Y1.segment, kr, Ar, $e, pe, Jt));
                            dr.push(gr.last);
                        } else {
                            if (O && !K) {
                                var yi = Fn(ir, $).point, tn = Y1.lineStartIndex + Y1.segment + 1, Ri = new i.Point($e.getx(tn), $e.gety(tn)), ln = Fn(Ri, $), Qn = ln.signedDistanceFromCamera > 0 ? ln.point : zs(ir, Ri, yi, 1, $), qn = Mo(Y1.writingMode, yi, Qn, vt);
                                if (qn) return qn;
                            }
                            var rn = ks(Pt * Ie.getoffsetX(Y1.glyphStartIndex), Wt, rr, K, Kt, ir, Y1.segment, Y1.lineStartIndex, Y1.lineStartIndex + Y1.lineLength, $e, pe, Jt);
                            if (!rn) return {
                                notEnoughRoom: !0
                            };
                            dr = [
                                rn
                            ];
                        }
                        for(var bn = 0, mn = dr; bn < mn.length; bn += 1){
                            var Gn = mn[bn];
                            i.addDynamicAttributes(pt, Gn.point, Gn.angle);
                        }
                        return {};
                    }
                    function zs(Y1, z, K, O, $) {
                        var pe = Fn(Y1.add(Y1.sub(z)._unit()), $).point, de = K.sub(pe);
                        return K.add(de._mult(O / de.mag()));
                    }
                    function ks(Y1, z, K, O, $, pe, de, Ie, $e, pt, Kt, ir) {
                        var Jt = O ? Y1 - z : Y1 + z, vt = Jt > 0 ? 1 : -1, Pt = 0;
                        O && (vt *= -1, Pt = Math.PI), vt < 0 && (Pt += Math.PI);
                        for(var Wt = vt > 0 ? Ie + de : Ie + de + 1, rr = $, dr = $, pr = 0, kr = 0, Ar = Math.abs(Jt), gr = []; pr + kr <= Ar;){
                            if (Wt += vt, Wt < Ie || Wt >= $e) return null;
                            if (dr = rr, gr.push(rr), rr = ir[Wt], rr === void 0) {
                                var Cr = new i.Point(pt.getx(Wt), pt.gety(Wt)), cr = Fn(Cr, Kt);
                                if (cr.signedDistanceFromCamera > 0) rr = ir[Wt] = cr.point;
                                else {
                                    var Gr = Wt - vt, ei = pr === 0 ? pe : new i.Point(pt.getx(Gr), pt.gety(Gr));
                                    rr = zs(ei, Cr, dr, Ar - pr + 1, Kt);
                                }
                            }
                            pr += kr, kr = dr.dist(rr);
                        }
                        var yi = (Ar - pr) / kr, tn = rr.sub(dr), Ri = tn.mult(yi)._add(dr);
                        Ri._add(tn._unit()._perp()._mult(K * vt));
                        var ln = Pt + Math.atan2(rr.y - dr.y, rr.x - dr.x);
                        return gr.push(Ri), {
                            point: Ri,
                            angle: ln,
                            path: gr
                        };
                    }
                    var Zs = new Float32Array([
                        -1 / 0,
                        -1 / 0,
                        0,
                        -1 / 0,
                        -1 / 0,
                        0,
                        -1 / 0,
                        -1 / 0,
                        0,
                        -1 / 0,
                        -1 / 0,
                        0
                    ]);
                    function Xs(Y1, z) {
                        for(var K = 0; K < Y1; K++){
                            var O = z.length;
                            z.resize(O + 4), z.float32.set(Zs, O * 3);
                        }
                    }
                    function wl(Y1, z, K) {
                        var O = z[0], $ = z[1];
                        return Y1[0] = K[0] * O + K[4] * $ + K[12], Y1[1] = K[1] * O + K[5] * $ + K[13], Y1[3] = K[3] * O + K[7] * $ + K[15], Y1;
                    }
                    var os = 100, cl = function(z, K, O) {
                        K === void 0 && (K = new hi(z.width + 2 * os, z.height + 2 * os, 25)), O === void 0 && (O = new hi(z.width + 2 * os, z.height + 2 * os, 25)), this.transform = z, this.grid = K, this.ignoredGrid = O, this.pitchfactor = Math.cos(z._pitch) * z.cameraToCenterDistance, this.screenRightBoundary = z.width + os, this.screenBottomBoundary = z.height + os, this.gridRightBoundary = z.width + 2 * os, this.gridBottomBoundary = z.height + 2 * os;
                    };
                    cl.prototype.placeCollisionBox = function(z, K, O, $, pe) {
                        var de = this.projectAndGetPerspectiveRatio($, z.anchorPointX, z.anchorPointY), Ie = O * de.perspectiveRatio, $e = z.x1 * Ie + de.point.x, pt = z.y1 * Ie + de.point.y, Kt = z.x2 * Ie + de.point.x, ir = z.y2 * Ie + de.point.y;
                        return !this.isInsideGrid($e, pt, Kt, ir) || !K && this.grid.hitTest($e, pt, Kt, ir, pe) ? {
                            box: [],
                            offscreen: !1
                        } : {
                            box: [
                                $e,
                                pt,
                                Kt,
                                ir
                            ],
                            offscreen: this.isOffscreen($e, pt, Kt, ir)
                        };
                    }, cl.prototype.placeCollisionCircles = function(z, K, O, $, pe, de, Ie, $e, pt, Kt, ir, Jt, vt) {
                        var Pt = [], Wt = new i.Point(K.anchorX, K.anchorY), rr = Fn(Wt, de), dr = Sa(this.transform.cameraToCenterDistance, rr.signedDistanceFromCamera), pr = Kt ? pe / dr : pe * dr, kr = pr / i.ONE_EM, Ar = Fn(Wt, Ie).point, gr = {}, Cr = K.lineOffsetX * kr, cr = K.lineOffsetY * kr, Gr = ho(kr, $, Cr, cr, !1, Ar, Wt, K, O, Ie, gr), ei = !1, yi = !1, tn = !0;
                        if (Gr) {
                            for(var Ri = Jt * .5 * dr + vt, ln = new i.Point(-os, -os), Qn = new i.Point(this.screenRightBoundary, this.screenBottomBoundary), qn = new an, rn = Gr.first, bn = Gr.last, mn = [], Gn = rn.path.length - 1; Gn >= 1; Gn--)mn.push(rn.path[Gn]);
                            for(var da = 1; da < bn.path.length; da++)mn.push(bn.path[da]);
                            var No = Ri * 2.5;
                            if ($e) {
                                var Do = mn.map(function(Cv) {
                                    return Fn(Cv, $e);
                                });
                                Do.some(function(Cv) {
                                    return Cv.signedDistanceFromCamera <= 0;
                                }) ? mn = [] : mn = Do.map(function(Cv) {
                                    return Cv.point;
                                });
                            }
                            var ps = [];
                            if (mn.length > 0) {
                                for(var fo = mn[0].clone(), as = mn[0].clone(), tl = 1; tl < mn.length; tl++)fo.x = Math.min(fo.x, mn[tl].x), fo.y = Math.min(fo.y, mn[tl].y), as.x = Math.max(as.x, mn[tl].x), as.y = Math.max(as.y, mn[tl].y);
                                fo.x >= ln.x && as.x <= Qn.x && fo.y >= ln.y && as.y <= Qn.y ? ps = [
                                    mn
                                ] : as.x < ln.x || fo.x > Qn.x || as.y < ln.y || fo.y > Qn.y ? ps = [] : ps = i.clipLine([
                                    mn
                                ], ln.x, ln.y, Qn.x, Qn.y);
                            }
                            for(var zu = 0, Mv = ps; zu < Mv.length; zu += 1){
                                var Ev = Mv[zu];
                                qn.reset(Ev, Ri * .25);
                                var yd = 0;
                                qn.length <= .5 * Ri ? yd = 1 : yd = Math.ceil(qn.paddedLength / No) + 1;
                                for(var Yv = 0; Yv < yd; Yv++){
                                    var cg = Yv / Math.max(yd - 1, 1), vp = qn.lerp(cg), _d = vp.x + os, pp = vp.y + os;
                                    Pt.push(_d, pp, Ri, 0);
                                    var Nd = _d - Ri, xd = pp - Ri, kv = _d + Ri, Kv = pp + Ri;
                                    if (tn = tn && this.isOffscreen(Nd, xd, kv, Kv), yi = yi || this.isInsideGrid(Nd, xd, kv, Kv), !z && this.grid.hitTestCircle(_d, pp, Ri, ir) && (ei = !0, !pt)) return {
                                        circles: [],
                                        offscreen: !1,
                                        collisionDetected: ei
                                    };
                                }
                            }
                        }
                        return {
                            circles: !pt && ei || !yi ? [] : Pt,
                            offscreen: tn,
                            collisionDetected: ei
                        };
                    }, cl.prototype.queryRenderedSymbols = function(z) {
                        if (z.length === 0 || this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0) return {};
                        for(var K = [], O = 1 / 0, $ = 1 / 0, pe = -1 / 0, de = -1 / 0, Ie = 0, $e = z; Ie < $e.length; Ie += 1){
                            var pt = $e[Ie], Kt = new i.Point(pt.x + os, pt.y + os);
                            O = Math.min(O, Kt.x), $ = Math.min($, Kt.y), pe = Math.max(pe, Kt.x), de = Math.max(de, Kt.y), K.push(Kt);
                        }
                        for(var ir = this.grid.query(O, $, pe, de).concat(this.ignoredGrid.query(O, $, pe, de)), Jt = {}, vt = {}, Pt = 0, Wt = ir; Pt < Wt.length; Pt += 1){
                            var rr = Wt[Pt], dr = rr.key;
                            if (Jt[dr.bucketInstanceId] === void 0 && (Jt[dr.bucketInstanceId] = {}), !Jt[dr.bucketInstanceId][dr.featureIndex]) {
                                var pr = [
                                    new i.Point(rr.x1, rr.y1),
                                    new i.Point(rr.x2, rr.y1),
                                    new i.Point(rr.x2, rr.y2),
                                    new i.Point(rr.x1, rr.y2)
                                ];
                                i.polygonIntersectsPolygon(K, pr) && (Jt[dr.bucketInstanceId][dr.featureIndex] = !0, vt[dr.bucketInstanceId] === void 0 && (vt[dr.bucketInstanceId] = []), vt[dr.bucketInstanceId].push(dr.featureIndex));
                            }
                        }
                        return vt;
                    }, cl.prototype.insertCollisionBox = function(z, K, O, $, pe) {
                        var de = K ? this.ignoredGrid : this.grid, Ie = {
                            bucketInstanceId: O,
                            featureIndex: $,
                            collisionGroupID: pe
                        };
                        de.insert(Ie, z[0], z[1], z[2], z[3]);
                    }, cl.prototype.insertCollisionCircles = function(z, K, O, $, pe) {
                        for(var de = K ? this.ignoredGrid : this.grid, Ie = {
                            bucketInstanceId: O,
                            featureIndex: $,
                            collisionGroupID: pe
                        }, $e = 0; $e < z.length; $e += 4)de.insertCircle(Ie, z[$e], z[$e + 1], z[$e + 2]);
                    }, cl.prototype.projectAndGetPerspectiveRatio = function(z, K, O) {
                        var $ = [
                            K,
                            O,
                            0,
                            1
                        ];
                        wl($, $, z);
                        var pe = new i.Point(($[0] / $[3] + 1) / 2 * this.transform.width + os, (-$[1] / $[3] + 1) / 2 * this.transform.height + os);
                        return {
                            point: pe,
                            perspectiveRatio: .5 + .5 * (this.transform.cameraToCenterDistance / $[3])
                        };
                    }, cl.prototype.isOffscreen = function(z, K, O, $) {
                        return O < os || z >= this.screenRightBoundary || $ < os || K > this.screenBottomBoundary;
                    }, cl.prototype.isInsideGrid = function(z, K, O, $) {
                        return O >= 0 && z < this.gridRightBoundary && $ >= 0 && K < this.gridBottomBoundary;
                    }, cl.prototype.getViewportMatrix = function() {
                        var z = i.identity([]);
                        return i.translate(z, z, [
                            -os,
                            -os,
                            0
                        ]), z;
                    };
                    function Cs(Y1, z, K) {
                        return z * (i.EXTENT / (Y1.tileSize * Math.pow(2, K - Y1.tileID.overscaledZ)));
                    }
                    var ml = function(z, K, O, $) {
                        z ? this.opacity = Math.max(0, Math.min(1, z.opacity + (z.placed ? K : -K))) : this.opacity = $ && O ? 1 : 0, this.placed = O;
                    };
                    ml.prototype.isHidden = function() {
                        return this.opacity === 0 && !this.placed;
                    };
                    var Ys = function(z, K, O, $, pe) {
                        this.text = new ml(z ? z.text : null, K, O, pe), this.icon = new ml(z ? z.icon : null, K, $, pe);
                    };
                    Ys.prototype.isHidden = function() {
                        return this.text.isHidden() && this.icon.isHidden();
                    };
                    var Hs = function(z, K, O) {
                        this.text = z, this.icon = K, this.skipFade = O;
                    }, Eo = function() {
                        this.invProjMatrix = i.create(), this.viewportMatrix = i.create(), this.circles = [];
                    }, fs = function(z, K, O, $, pe) {
                        this.bucketInstanceId = z, this.featureIndex = K, this.sourceLayerIndex = O, this.bucketIndex = $, this.tileID = pe;
                    }, Ql = function(z) {
                        this.crossSourceCollisions = z, this.maxGroupID = 0, this.collisionGroups = {};
                    };
                    Ql.prototype.get = function(z) {
                        if (this.crossSourceCollisions) return {
                            ID: 0,
                            predicate: null
                        };
                        if (!this.collisionGroups[z]) {
                            var K = ++this.maxGroupID;
                            this.collisionGroups[z] = {
                                ID: K,
                                predicate: function(O) {
                                    return O.collisionGroupID === K;
                                }
                            };
                        }
                        return this.collisionGroups[z];
                    };
                    function Hu(Y1, z, K, O, $) {
                        var pe = i.getAnchorAlignment(Y1), de = pe.horizontalAlign, Ie = pe.verticalAlign, $e = -(de - .5) * z, pt = -(Ie - .5) * K, Kt = i.evaluateVariableOffset(Y1, O);
                        return new i.Point($e + Kt[0] * $, pt + Kt[1] * $);
                    }
                    function fc(Y1, z, K, O, $, pe) {
                        var de = Y1.x1, Ie = Y1.x2, $e = Y1.y1, pt = Y1.y2, Kt = Y1.anchorPointX, ir = Y1.anchorPointY, Jt = new i.Point(z, K);
                        return O && Jt._rotate($ ? pe : -pe), {
                            x1: de + Jt.x,
                            y1: $e + Jt.y,
                            x2: Ie + Jt.x,
                            y2: pt + Jt.y,
                            anchorPointX: Kt,
                            anchorPointY: ir
                        };
                    }
                    var ms = function(z, K, O, $) {
                        this.transform = z.clone(), this.collisionIndex = new cl(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = K, this.retainedQueryData = {}, this.collisionGroups = new Ql(O), this.collisionCircleArrays = {}, this.prevPlacement = $, $ && ($.prevPlacement = void 0), this.placedOrientations = {};
                    };
                    ms.prototype.getBucketParts = function(z, K, O, $) {
                        var pe = O.getBucket(K), de = O.latestFeatureIndex;
                        if (!(!pe || !de || K.id !== pe.layerIds[0])) {
                            var Ie = O.collisionBoxArray, $e = pe.layers[0].layout, pt = Math.pow(2, this.transform.zoom - O.tileID.overscaledZ), Kt = O.tileSize / i.EXTENT, ir = this.transform.calculatePosMatrix(O.tileID.toUnwrapped()), Jt = $e.get("text-pitch-alignment") === "map", vt = $e.get("text-rotation-alignment") === "map", Pt = Cs(O, 1, this.transform.zoom), Wt = Ji(ir, Jt, vt, this.transform, Pt), rr = null;
                            if (Jt) {
                                var dr = ua(ir, Jt, vt, this.transform, Pt);
                                rr = i.multiply([], this.transform.labelPlaneMatrix, dr);
                            }
                            this.retainedQueryData[pe.bucketInstanceId] = new fs(pe.bucketInstanceId, de, pe.sourceLayerIndex, pe.index, O.tileID);
                            var pr = {
                                bucket: pe,
                                layout: $e,
                                posMatrix: ir,
                                textLabelPlaneMatrix: Wt,
                                labelToScreenMatrix: rr,
                                scale: pt,
                                textPixelRatio: Kt,
                                holdingForFade: O.holdingForFade(),
                                collisionBoxArray: Ie,
                                partiallyEvaluatedTextSize: i.evaluateSizeForZoom(pe.textSizeData, this.transform.zoom),
                                collisionGroup: this.collisionGroups.get(pe.sourceID)
                            };
                            if ($) for(var kr = 0, Ar = pe.sortKeyRanges; kr < Ar.length; kr += 1){
                                var gr = Ar[kr], Cr = gr.sortKey, cr = gr.symbolInstanceStart, Gr = gr.symbolInstanceEnd;
                                z.push({
                                    sortKey: Cr,
                                    symbolInstanceStart: cr,
                                    symbolInstanceEnd: Gr,
                                    parameters: pr
                                });
                            }
                            else z.push({
                                symbolInstanceStart: 0,
                                symbolInstanceEnd: pe.symbolInstances.length,
                                parameters: pr
                            });
                        }
                    }, ms.prototype.attemptAnchorPlacement = function(z, K, O, $, pe, de, Ie, $e, pt, Kt, ir, Jt, vt, Pt, Wt) {
                        var rr = [
                            Jt.textOffset0,
                            Jt.textOffset1
                        ], dr = Hu(z, O, $, rr, pe), pr = this.collisionIndex.placeCollisionBox(fc(K, dr.x, dr.y, de, Ie, this.transform.angle), ir, $e, pt, Kt.predicate);
                        if (Wt) {
                            var kr = this.collisionIndex.placeCollisionBox(fc(Wt, dr.x, dr.y, de, Ie, this.transform.angle), ir, $e, pt, Kt.predicate);
                            if (kr.box.length === 0) return;
                        }
                        if (pr.box.length > 0) {
                            var Ar;
                            return this.prevPlacement && this.prevPlacement.variableOffsets[Jt.crossTileID] && this.prevPlacement.placements[Jt.crossTileID] && this.prevPlacement.placements[Jt.crossTileID].text && (Ar = this.prevPlacement.variableOffsets[Jt.crossTileID].anchor), this.variableOffsets[Jt.crossTileID] = {
                                textOffset: rr,
                                width: O,
                                height: $,
                                anchor: z,
                                textBoxScale: pe,
                                prevAnchor: Ar
                            }, this.markUsedJustification(vt, z, Jt, Pt), vt.allowVerticalPlacement && (this.markUsedOrientation(vt, Pt, Jt), this.placedOrientations[Jt.crossTileID] = Pt), {
                                shift: dr,
                                placedGlyphBoxes: pr
                            };
                        }
                    }, ms.prototype.placeLayerBucketPart = function(z, K, O) {
                        var $ = this, pe = z.parameters, de = pe.bucket, Ie = pe.layout, $e = pe.posMatrix, pt = pe.textLabelPlaneMatrix, Kt = pe.labelToScreenMatrix, ir = pe.textPixelRatio, Jt = pe.holdingForFade, vt = pe.collisionBoxArray, Pt = pe.partiallyEvaluatedTextSize, Wt = pe.collisionGroup, rr = Ie.get("text-optional"), dr = Ie.get("icon-optional"), pr = Ie.get("text-allow-overlap"), kr = Ie.get("icon-allow-overlap"), Ar = Ie.get("text-rotation-alignment") === "map", gr = Ie.get("text-pitch-alignment") === "map", Cr = Ie.get("icon-text-fit") !== "none", cr = Ie.get("symbol-z-order") === "viewport-y", Gr = pr && (kr || !de.hasIconData() || dr), ei = kr && (pr || !de.hasTextData() || rr);
                        !de.collisionArrays && vt && de.deserializeCollisionBoxes(vt);
                        var yi = function(rn, bn) {
                            if (!K[rn.crossTileID]) {
                                if (Jt) {
                                    $.placements[rn.crossTileID] = new Hs(!1, !1, !1);
                                    return;
                                }
                                var mn = !1, Gn = !1, da = !0, No = null, Do = {
                                    box: null,
                                    offscreen: null
                                }, ps = {
                                    box: null,
                                    offscreen: null
                                }, fo = null, as = null, tl = null, zu = 0, Mv = 0, Ev = 0;
                                bn.textFeatureIndex ? zu = bn.textFeatureIndex : rn.useRuntimeCollisionCircles && (zu = rn.featureIndex), bn.verticalTextFeatureIndex && (Mv = bn.verticalTextFeatureIndex);
                                var yd = bn.textBox;
                                if (yd) {
                                    var Yv = function(Fu) {
                                        var kl = i.WritingMode.horizontal;
                                        if (de.allowVerticalPlacement && !Fu && $.prevPlacement) {
                                            var bd = $.prevPlacement.placedOrientations[rn.crossTileID];
                                            bd && ($.placedOrientations[rn.crossTileID] = bd, kl = bd, $.markUsedOrientation(de, kl, rn));
                                        }
                                        return kl;
                                    }, cg = function(Fu, kl) {
                                        if (de.allowVerticalPlacement && rn.numVerticalGlyphVertices > 0 && bn.verticalTextBox) for(var bd = 0, sy = de.writingModes; bd < sy.length; bd += 1){
                                            var A1 = sy[bd];
                                            if (A1 === i.WritingMode.vertical ? (Do = kl(), ps = Do) : Do = Fu(), Do && Do.box && Do.box.length) break;
                                        }
                                        else Do = Fu();
                                    };
                                    if (Ie.get("text-variable-anchor")) {
                                        var Nd = Ie.get("text-variable-anchor");
                                        if ($.prevPlacement && $.prevPlacement.variableOffsets[rn.crossTileID]) {
                                            var xd = $.prevPlacement.variableOffsets[rn.crossTileID];
                                            Nd.indexOf(xd.anchor) > 0 && (Nd = Nd.filter(function(Fu) {
                                                return Fu !== xd.anchor;
                                            }), Nd.unshift(xd.anchor));
                                        }
                                        var kv = function(Fu, kl, bd) {
                                            for(var sy = Fu.x2 - Fu.x1, A1 = Fu.y2 - Fu.y1, Kl = rn.textBoxScale, Nx = Cr && !kr ? kl : null, am = {
                                                box: [],
                                                offscreen: !1
                                            }, Mw = pr ? Nd.length * 2 : Nd.length, Lv = 0; Lv < Mw; ++Lv){
                                                var om = Nd[Lv % Nd.length], Ew = Lv >= Nd.length, Ux = $.attemptAnchorPlacement(om, Fu, sy, A1, Kl, Ar, gr, ir, $e, Wt, Ew, rn, de, bd, Nx);
                                                if (Ux && (am = Ux.placedGlyphBoxes, am && am.box && am.box.length)) {
                                                    mn = !0, No = Ux.shift;
                                                    break;
                                                }
                                            }
                                            return am;
                                        }, Kv = function() {
                                            return kv(yd, bn.iconBox, i.WritingMode.horizontal);
                                        }, Cv = function() {
                                            var Fu = bn.verticalTextBox, kl = Do && Do.box && Do.box.length;
                                            return de.allowVerticalPlacement && !kl && rn.numVerticalGlyphVertices > 0 && Fu ? kv(Fu, bn.verticalIconBox, i.WritingMode.vertical) : {
                                                box: null,
                                                offscreen: null
                                            };
                                        };
                                        cg(Kv, Cv), Do && (mn = Do.box, da = Do.offscreen);
                                        var ny = Yv(Do && Do.box);
                                        if (!mn && $.prevPlacement) {
                                            var fg = $.prevPlacement.variableOffsets[rn.crossTileID];
                                            fg && ($.variableOffsets[rn.crossTileID] = fg, $.markUsedJustification(de, fg.anchor, rn, ny));
                                        }
                                    } else {
                                        var vp = function(Fu, kl) {
                                            var bd = $.collisionIndex.placeCollisionBox(Fu, pr, ir, $e, Wt.predicate);
                                            return bd && bd.box && bd.box.length && ($.markUsedOrientation(de, kl, rn), $.placedOrientations[rn.crossTileID] = kl), bd;
                                        }, _d = function() {
                                            return vp(yd, i.WritingMode.horizontal);
                                        }, pp = function() {
                                            var Fu = bn.verticalTextBox;
                                            return de.allowVerticalPlacement && rn.numVerticalGlyphVertices > 0 && Fu ? vp(Fu, i.WritingMode.vertical) : {
                                                box: null,
                                                offscreen: null
                                            };
                                        };
                                        cg(_d, pp), Yv(Do && Do.box && Do.box.length);
                                    }
                                }
                                if (fo = Do, mn = fo && fo.box && fo.box.length > 0, da = fo && fo.offscreen, rn.useRuntimeCollisionCircles) {
                                    var Hf = de.text.placedSymbolArray.get(rn.centerJustifiedTextSymbolIndex), hg = i.evaluateSizeForFeature(de.textSizeData, Pt, Hf), ay = Ie.get("text-padding"), Rh = rn.collisionCircleDiameter;
                                    as = $.collisionIndex.placeCollisionCircles(pr, Hf, de.lineVertexArray, de.glyphOffsetArray, hg, $e, pt, Kt, O, gr, Wt.predicate, Rh, ay), mn = pr || as.circles.length > 0 && !as.collisionDetected, da = da && as.offscreen;
                                }
                                if (bn.iconFeatureIndex && (Ev = bn.iconFeatureIndex), bn.iconBox) {
                                    var rm = function(Fu) {
                                        var kl = Cr && No ? fc(Fu, No.x, No.y, Ar, gr, $.transform.angle) : Fu;
                                        return $.collisionIndex.placeCollisionBox(kl, kr, ir, $e, Wt.predicate);
                                    };
                                    ps && ps.box && ps.box.length && bn.verticalIconBox ? (tl = rm(bn.verticalIconBox), Gn = tl.box.length > 0) : (tl = rm(bn.iconBox), Gn = tl.box.length > 0), da = da && tl.offscreen;
                                }
                                var w1 = rr || rn.numHorizontalGlyphVertices === 0 && rn.numVerticalGlyphVertices === 0, T1 = dr || rn.numIconVertices === 0;
                                if (!w1 && !T1 ? Gn = mn = Gn && mn : T1 ? w1 || (Gn = Gn && mn) : mn = Gn && mn, mn && fo && fo.box && (ps && ps.box && Mv ? $.collisionIndex.insertCollisionBox(fo.box, Ie.get("text-ignore-placement"), de.bucketInstanceId, Mv, Wt.ID) : $.collisionIndex.insertCollisionBox(fo.box, Ie.get("text-ignore-placement"), de.bucketInstanceId, zu, Wt.ID)), Gn && tl && $.collisionIndex.insertCollisionBox(tl.box, Ie.get("icon-ignore-placement"), de.bucketInstanceId, Ev, Wt.ID), as && (mn && $.collisionIndex.insertCollisionCircles(as.circles, Ie.get("text-ignore-placement"), de.bucketInstanceId, zu, Wt.ID), O)) {
                                    var oy = de.bucketInstanceId, im = $.collisionCircleArrays[oy];
                                    im === void 0 && (im = $.collisionCircleArrays[oy] = new Eo);
                                    for(var nm = 0; nm < as.circles.length; nm += 4)im.circles.push(as.circles[nm + 0]), im.circles.push(as.circles[nm + 1]), im.circles.push(as.circles[nm + 2]), im.circles.push(as.collisionDetected ? 1 : 0);
                                }
                                $.placements[rn.crossTileID] = new Hs(mn || Gr, Gn || ei, da || de.justReloaded), K[rn.crossTileID] = !0;
                            }
                        };
                        if (cr) for(var tn = de.getSortedSymbolIndexes(this.transform.angle), Ri = tn.length - 1; Ri >= 0; --Ri){
                            var ln = tn[Ri];
                            yi(de.symbolInstances.get(ln), de.collisionArrays[ln]);
                        }
                        else for(var Qn = z.symbolInstanceStart; Qn < z.symbolInstanceEnd; Qn++)yi(de.symbolInstances.get(Qn), de.collisionArrays[Qn]);
                        if (O && de.bucketInstanceId in this.collisionCircleArrays) {
                            var qn = this.collisionCircleArrays[de.bucketInstanceId];
                            i.invert(qn.invProjMatrix, $e), qn.viewportMatrix = this.collisionIndex.getViewportMatrix();
                        }
                        de.justReloaded = !1;
                    }, ms.prototype.markUsedJustification = function(z, K, O, $) {
                        var pe = {
                            left: O.leftJustifiedTextSymbolIndex,
                            center: O.centerJustifiedTextSymbolIndex,
                            right: O.rightJustifiedTextSymbolIndex
                        }, de;
                        $ === i.WritingMode.vertical ? de = O.verticalPlacedTextSymbolIndex : de = pe[i.getAnchorJustification(K)];
                        for(var Ie = [
                            O.leftJustifiedTextSymbolIndex,
                            O.centerJustifiedTextSymbolIndex,
                            O.rightJustifiedTextSymbolIndex,
                            O.verticalPlacedTextSymbolIndex
                        ], $e = 0, pt = Ie; $e < pt.length; $e += 1){
                            var Kt = pt[$e];
                            Kt >= 0 && (de >= 0 && Kt !== de ? z.text.placedSymbolArray.get(Kt).crossTileID = 0 : z.text.placedSymbolArray.get(Kt).crossTileID = O.crossTileID);
                        }
                    }, ms.prototype.markUsedOrientation = function(z, K, O) {
                        for(var $ = K === i.WritingMode.horizontal || K === i.WritingMode.horizontalOnly ? K : 0, pe = K === i.WritingMode.vertical ? K : 0, de = [
                            O.leftJustifiedTextSymbolIndex,
                            O.centerJustifiedTextSymbolIndex,
                            O.rightJustifiedTextSymbolIndex
                        ], Ie = 0, $e = de; Ie < $e.length; Ie += 1){
                            var pt = $e[Ie];
                            z.text.placedSymbolArray.get(pt).placedOrientation = $;
                        }
                        O.verticalPlacedTextSymbolIndex && (z.text.placedSymbolArray.get(O.verticalPlacedTextSymbolIndex).placedOrientation = pe);
                    }, ms.prototype.commit = function(z) {
                        this.commitTime = z, this.zoomAtLastRecencyCheck = this.transform.zoom;
                        var K = this.prevPlacement, O = !1;
                        this.prevZoomAdjustment = K ? K.zoomAdjustment(this.transform.zoom) : 0;
                        var $ = K ? K.symbolFadeChange(z) : 1, pe = K ? K.opacities : {}, de = K ? K.variableOffsets : {}, Ie = K ? K.placedOrientations : {};
                        for(var $e in this.placements){
                            var pt = this.placements[$e], Kt = pe[$e];
                            Kt ? (this.opacities[$e] = new Ys(Kt, $, pt.text, pt.icon), O = O || pt.text !== Kt.text.placed || pt.icon !== Kt.icon.placed) : (this.opacities[$e] = new Ys(null, $, pt.text, pt.icon, pt.skipFade), O = O || pt.text || pt.icon);
                        }
                        for(var ir in pe){
                            var Jt = pe[ir];
                            if (!this.opacities[ir]) {
                                var vt = new Ys(Jt, $, !1, !1);
                                vt.isHidden() || (this.opacities[ir] = vt, O = O || Jt.text.placed || Jt.icon.placed);
                            }
                        }
                        for(var Pt in de)!this.variableOffsets[Pt] && this.opacities[Pt] && !this.opacities[Pt].isHidden() && (this.variableOffsets[Pt] = de[Pt]);
                        for(var Wt in Ie)!this.placedOrientations[Wt] && this.opacities[Wt] && !this.opacities[Wt].isHidden() && (this.placedOrientations[Wt] = Ie[Wt]);
                        O ? this.lastPlacementChangeTime = z : typeof this.lastPlacementChangeTime != "number" && (this.lastPlacementChangeTime = K ? K.lastPlacementChangeTime : z);
                    }, ms.prototype.updateLayerOpacities = function(z, K) {
                        for(var O = {}, $ = 0, pe = K; $ < pe.length; $ += 1){
                            var de = pe[$], Ie = de.getBucket(z);
                            Ie && de.latestFeatureIndex && z.id === Ie.layerIds[0] && this.updateBucketOpacities(Ie, O, de.collisionBoxArray);
                        }
                    }, ms.prototype.updateBucketOpacities = function(z, K, O) {
                        var $ = this;
                        z.hasTextData() && z.text.opacityVertexArray.clear(), z.hasIconData() && z.icon.opacityVertexArray.clear(), z.hasIconCollisionBoxData() && z.iconCollisionBox.collisionVertexArray.clear(), z.hasTextCollisionBoxData() && z.textCollisionBox.collisionVertexArray.clear();
                        var pe = z.layers[0].layout, de = new Ys(null, 0, !1, !1, !0), Ie = pe.get("text-allow-overlap"), $e = pe.get("icon-allow-overlap"), pt = pe.get("text-variable-anchor"), Kt = pe.get("text-rotation-alignment") === "map", ir = pe.get("text-pitch-alignment") === "map", Jt = pe.get("icon-text-fit") !== "none", vt = new Ys(null, 0, Ie && ($e || !z.hasIconData() || pe.get("icon-optional")), $e && (Ie || !z.hasTextData() || pe.get("text-optional")), !0);
                        !z.collisionArrays && O && (z.hasIconCollisionBoxData() || z.hasTextCollisionBoxData()) && z.deserializeCollisionBoxes(O);
                        for(var Pt = function(pr, kr, Ar) {
                            for(var gr = 0; gr < kr / 4; gr++)pr.opacityVertexArray.emplaceBack(Ar);
                        }, Wt = function(pr) {
                            var kr = z.symbolInstances.get(pr), Ar = kr.numHorizontalGlyphVertices, gr = kr.numVerticalGlyphVertices, Cr = kr.crossTileID, cr = K[Cr], Gr = $.opacities[Cr];
                            cr ? Gr = de : Gr || (Gr = vt, $.opacities[Cr] = Gr), K[Cr] = !0;
                            var ei = Ar > 0 || gr > 0, yi = kr.numIconVertices > 0, tn = $.placedOrientations[kr.crossTileID], Ri = tn === i.WritingMode.vertical, ln = tn === i.WritingMode.horizontal || tn === i.WritingMode.horizontalOnly;
                            if (ei) {
                                var Qn = Ec(Gr.text), qn = Ri ? Zn : Qn;
                                Pt(z.text, Ar, qn);
                                var rn = ln ? Zn : Qn;
                                Pt(z.text, gr, rn);
                                var bn = Gr.text.isHidden();
                                [
                                    kr.rightJustifiedTextSymbolIndex,
                                    kr.centerJustifiedTextSymbolIndex,
                                    kr.leftJustifiedTextSymbolIndex
                                ].forEach(function(Ev) {
                                    Ev >= 0 && (z.text.placedSymbolArray.get(Ev).hidden = bn || Ri ? 1 : 0);
                                }), kr.verticalPlacedTextSymbolIndex >= 0 && (z.text.placedSymbolArray.get(kr.verticalPlacedTextSymbolIndex).hidden = bn || ln ? 1 : 0);
                                var mn = $.variableOffsets[kr.crossTileID];
                                mn && $.markUsedJustification(z, mn.anchor, kr, tn);
                                var Gn = $.placedOrientations[kr.crossTileID];
                                Gn && ($.markUsedJustification(z, "left", kr, Gn), $.markUsedOrientation(z, Gn, kr));
                            }
                            if (yi) {
                                var da = Ec(Gr.icon), No = !(Jt && kr.verticalPlacedIconSymbolIndex && Ri);
                                if (kr.placedIconSymbolIndex >= 0) {
                                    var Do = No ? da : Zn;
                                    Pt(z.icon, kr.numIconVertices, Do), z.icon.placedSymbolArray.get(kr.placedIconSymbolIndex).hidden = Gr.icon.isHidden();
                                }
                                if (kr.verticalPlacedIconSymbolIndex >= 0) {
                                    var ps = No ? Zn : da;
                                    Pt(z.icon, kr.numVerticalIconVertices, ps), z.icon.placedSymbolArray.get(kr.verticalPlacedIconSymbolIndex).hidden = Gr.icon.isHidden();
                                }
                            }
                            if (z.hasIconCollisionBoxData() || z.hasTextCollisionBoxData()) {
                                var fo = z.collisionArrays[pr];
                                if (fo) {
                                    var as = new i.Point(0, 0);
                                    if (fo.textBox || fo.verticalTextBox) {
                                        var tl = !0;
                                        if (pt) {
                                            var zu = $.variableOffsets[Cr];
                                            zu ? (as = Hu(zu.anchor, zu.width, zu.height, zu.textOffset, zu.textBoxScale), Kt && as._rotate(ir ? $.transform.angle : -$.transform.angle)) : tl = !1;
                                        }
                                        fo.textBox && on(z.textCollisionBox.collisionVertexArray, Gr.text.placed, !tl || Ri, as.x, as.y), fo.verticalTextBox && on(z.textCollisionBox.collisionVertexArray, Gr.text.placed, !tl || ln, as.x, as.y);
                                    }
                                    var Mv = !!(!ln && fo.verticalIconBox);
                                    fo.iconBox && on(z.iconCollisionBox.collisionVertexArray, Gr.icon.placed, Mv, Jt ? as.x : 0, Jt ? as.y : 0), fo.verticalIconBox && on(z.iconCollisionBox.collisionVertexArray, Gr.icon.placed, !Mv, Jt ? as.x : 0, Jt ? as.y : 0);
                                }
                            }
                        }, rr = 0; rr < z.symbolInstances.length; rr++)Wt(rr);
                        if (z.sortFeatures(this.transform.angle), this.retainedQueryData[z.bucketInstanceId] && (this.retainedQueryData[z.bucketInstanceId].featureSortOrder = z.featureSortOrder), z.hasTextData() && z.text.opacityVertexBuffer && z.text.opacityVertexBuffer.updateData(z.text.opacityVertexArray), z.hasIconData() && z.icon.opacityVertexBuffer && z.icon.opacityVertexBuffer.updateData(z.icon.opacityVertexArray), z.hasIconCollisionBoxData() && z.iconCollisionBox.collisionVertexBuffer && z.iconCollisionBox.collisionVertexBuffer.updateData(z.iconCollisionBox.collisionVertexArray), z.hasTextCollisionBoxData() && z.textCollisionBox.collisionVertexBuffer && z.textCollisionBox.collisionVertexBuffer.updateData(z.textCollisionBox.collisionVertexArray), z.bucketInstanceId in this.collisionCircleArrays) {
                            var dr = this.collisionCircleArrays[z.bucketInstanceId];
                            z.placementInvProjMatrix = dr.invProjMatrix, z.placementViewportMatrix = dr.viewportMatrix, z.collisionCircleArray = dr.circles, delete this.collisionCircleArrays[z.bucketInstanceId];
                        }
                    }, ms.prototype.symbolFadeChange = function(z) {
                        return this.fadeDuration === 0 ? 1 : (z - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
                    }, ms.prototype.zoomAdjustment = function(z) {
                        return Math.max(0, (this.transform.zoom - z) / 1.5);
                    }, ms.prototype.hasTransitions = function(z) {
                        return this.stale || z - this.lastPlacementChangeTime < this.fadeDuration;
                    }, ms.prototype.stillRecent = function(z, K) {
                        var O = this.zoomAtLastRecencyCheck === K ? 1 - this.zoomAdjustment(K) : 1;
                        return this.zoomAtLastRecencyCheck = K, this.commitTime + this.fadeDuration * O > z;
                    }, ms.prototype.setStale = function() {
                        this.stale = !0;
                    };
                    function on(Y1, z, K, O, $) {
                        Y1.emplaceBack(z ? 1 : 0, K ? 1 : 0, O || 0, $ || 0), Y1.emplaceBack(z ? 1 : 0, K ? 1 : 0, O || 0, $ || 0), Y1.emplaceBack(z ? 1 : 0, K ? 1 : 0, O || 0, $ || 0), Y1.emplaceBack(z ? 1 : 0, K ? 1 : 0, O || 0, $ || 0);
                    }
                    var fa = Math.pow(2, 25), Qu = Math.pow(2, 24), Rl = Math.pow(2, 17), vo = Math.pow(2, 16), Zl = Math.pow(2, 9), Ks = Math.pow(2, 8), Xl = Math.pow(2, 1);
                    function Ec(Y1) {
                        if (Y1.opacity === 0 && !Y1.placed) return 0;
                        if (Y1.opacity === 1 && Y1.placed) return 4294967295;
                        var z = Y1.placed ? 1 : 0, K = Math.floor(Y1.opacity * 127);
                        return K * fa + z * Qu + K * Rl + z * vo + K * Zl + z * Ks + K * Xl + z;
                    }
                    var Zn = 0, ko = function(z) {
                        this._sortAcrossTiles = z.layout.get("symbol-z-order") !== "viewport-y" && z.layout.get("symbol-sort-key").constantOr(1) !== void 0, this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
                    };
                    ko.prototype.continuePlacement = function(z, K, O, $, pe) {
                        for(var de = this._bucketParts; this._currentTileIndex < z.length;){
                            var Ie = z[this._currentTileIndex];
                            if (K.getBucketParts(de, $, Ie, this._sortAcrossTiles), this._currentTileIndex++, pe()) return !0;
                        }
                        for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, de.sort(function(pt, Kt) {
                            return pt.sortKey - Kt.sortKey;
                        })); this._currentPartIndex < de.length;){
                            var $e = de[this._currentPartIndex];
                            if (K.placeLayerBucketPart($e, this._seenCrossTileIDs, O), this._currentPartIndex++, pe()) return !0;
                        }
                        return !1;
                    };
                    var Co = function(z, K, O, $, pe, de, Ie) {
                        this.placement = new ms(z, pe, de, Ie), this._currentPlacementIndex = K.length - 1, this._forceFullPlacement = O, this._showCollisionBoxes = $, this._done = !1;
                    };
                    Co.prototype.isDone = function() {
                        return this._done;
                    }, Co.prototype.continuePlacement = function(z, K, O) {
                        for(var $ = this, pe = i.browser.now(), de = function() {
                            var ir = i.browser.now() - pe;
                            return $._forceFullPlacement ? !1 : ir > 2;
                        }; this._currentPlacementIndex >= 0;){
                            var Ie = z[this._currentPlacementIndex], $e = K[Ie], pt = this.placement.collisionIndex.transform.zoom;
                            if ($e.type === "symbol" && (!$e.minzoom || $e.minzoom <= pt) && (!$e.maxzoom || $e.maxzoom > pt)) {
                                this._inProgressLayer || (this._inProgressLayer = new ko($e));
                                var Kt = this._inProgressLayer.continuePlacement(O[$e.source], this.placement, this._showCollisionBoxes, $e, de);
                                if (Kt) return;
                                delete this._inProgressLayer;
                            }
                            this._currentPlacementIndex--;
                        }
                        this._done = !0;
                    }, Co.prototype.commit = function(z) {
                        return this.placement.commit(z), this.placement;
                    };
                    var Tl = 512 / i.EXTENT / 2, uf = function(z, K, O) {
                        this.tileID = z, this.indexedSymbolInstances = {}, this.bucketInstanceId = O;
                        for(var $ = 0; $ < K.length; $++){
                            var pe = K.get($), de = pe.key;
                            this.indexedSymbolInstances[de] || (this.indexedSymbolInstances[de] = []), this.indexedSymbolInstances[de].push({
                                crossTileID: pe.crossTileID,
                                coord: this.getScaledCoordinates(pe, z)
                            });
                        }
                    };
                    uf.prototype.getScaledCoordinates = function(z, K) {
                        var O = K.canonical.z - this.tileID.canonical.z, $ = Tl / Math.pow(2, O);
                        return {
                            x: Math.floor((K.canonical.x * i.EXTENT + z.anchorX) * $),
                            y: Math.floor((K.canonical.y * i.EXTENT + z.anchorY) * $)
                        };
                    }, uf.prototype.findMatches = function(z, K, O) {
                        for(var $ = this.tileID.canonical.z < K.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - K.canonical.z), pe = 0; pe < z.length; pe++){
                            var de = z.get(pe);
                            if (!de.crossTileID) {
                                var Ie = this.indexedSymbolInstances[de.key];
                                if (Ie) for(var $e = this.getScaledCoordinates(de, K), pt = 0, Kt = Ie; pt < Kt.length; pt += 1){
                                    var ir = Kt[pt];
                                    if (Math.abs(ir.coord.x - $e.x) <= $ && Math.abs(ir.coord.y - $e.y) <= $ && !O[ir.crossTileID]) {
                                        O[ir.crossTileID] = !0, de.crossTileID = ir.crossTileID;
                                        break;
                                    }
                                }
                            }
                        }
                    };
                    var So = function() {
                        this.maxCrossTileID = 0;
                    };
                    So.prototype.generate = function() {
                        return ++this.maxCrossTileID;
                    };
                    var cf = function() {
                        this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
                    };
                    cf.prototype.handleWrapJump = function(z) {
                        var K = Math.round((z - this.lng) / 360);
                        if (K !== 0) for(var O in this.indexes){
                            var $ = this.indexes[O], pe = {};
                            for(var de in $){
                                var Ie = $[de];
                                Ie.tileID = Ie.tileID.unwrapTo(Ie.tileID.wrap + K), pe[Ie.tileID.key] = Ie;
                            }
                            this.indexes[O] = pe;
                        }
                        this.lng = z;
                    }, cf.prototype.addBucket = function(z, K, O) {
                        if (this.indexes[z.overscaledZ] && this.indexes[z.overscaledZ][z.key]) {
                            if (this.indexes[z.overscaledZ][z.key].bucketInstanceId === K.bucketInstanceId) return !1;
                            this.removeBucketCrossTileIDs(z.overscaledZ, this.indexes[z.overscaledZ][z.key]);
                        }
                        for(var $ = 0; $ < K.symbolInstances.length; $++){
                            var pe = K.symbolInstances.get($);
                            pe.crossTileID = 0;
                        }
                        this.usedCrossTileIDs[z.overscaledZ] || (this.usedCrossTileIDs[z.overscaledZ] = {});
                        var de = this.usedCrossTileIDs[z.overscaledZ];
                        for(var Ie in this.indexes){
                            var $e = this.indexes[Ie];
                            if (Number(Ie) > z.overscaledZ) for(var pt in $e){
                                var Kt = $e[pt];
                                Kt.tileID.isChildOf(z) && Kt.findMatches(K.symbolInstances, z, de);
                            }
                            else {
                                var ir = z.scaledTo(Number(Ie)), Jt = $e[ir.key];
                                Jt && Jt.findMatches(K.symbolInstances, z, de);
                            }
                        }
                        for(var vt = 0; vt < K.symbolInstances.length; vt++){
                            var Pt = K.symbolInstances.get(vt);
                            Pt.crossTileID || (Pt.crossTileID = O.generate(), de[Pt.crossTileID] = !0);
                        }
                        return this.indexes[z.overscaledZ] === void 0 && (this.indexes[z.overscaledZ] = {}), this.indexes[z.overscaledZ][z.key] = new uf(z, K.symbolInstances, K.bucketInstanceId), !0;
                    }, cf.prototype.removeBucketCrossTileIDs = function(z, K) {
                        for(var O in K.indexedSymbolInstances)for(var $ = 0, pe = K.indexedSymbolInstances[O]; $ < pe.length; $ += 1){
                            var de = pe[$];
                            delete this.usedCrossTileIDs[z][de.crossTileID];
                        }
                    }, cf.prototype.removeStaleBuckets = function(z) {
                        var K = !1;
                        for(var O in this.indexes){
                            var $ = this.indexes[O];
                            for(var pe in $)z[$[pe].bucketInstanceId] || (this.removeBucketCrossTileIDs(O, $[pe]), delete $[pe], K = !0);
                        }
                        return K;
                    };
                    var rh = function() {
                        this.layerIndexes = {}, this.crossTileIDs = new So, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
                    };
                    rh.prototype.addLayer = function(z, K, O) {
                        var $ = this.layerIndexes[z.id];
                        $ === void 0 && ($ = this.layerIndexes[z.id] = new cf);
                        var pe = !1, de = {};
                        $.handleWrapJump(O);
                        for(var Ie = 0, $e = K; Ie < $e.length; Ie += 1){
                            var pt = $e[Ie], Kt = pt.getBucket(z);
                            !Kt || z.id !== Kt.layerIds[0] || (Kt.bucketInstanceId || (Kt.bucketInstanceId = ++this.maxBucketInstanceId), $.addBucket(pt.tileID, Kt, this.crossTileIDs) && (pe = !0), de[Kt.bucketInstanceId] = !0);
                        }
                        return $.removeStaleBuckets(de) && (pe = !0), pe;
                    }, rh.prototype.pruneUnusedLayers = function(z) {
                        var K = {};
                        z.forEach(function($) {
                            K[$] = !0;
                        });
                        for(var O in this.layerIndexes)K[O] || delete this.layerIndexes[O];
                    };
                    var Al = function(Y1, z) {
                        return i.emitValidationErrors(Y1, z && z.filter(function(K) {
                            return K.identifier !== "source.canvas";
                        }));
                    }, Hc = i.pick(oa, [
                        "addLayer",
                        "removeLayer",
                        "setPaintProperty",
                        "setLayoutProperty",
                        "setFilter",
                        "addSource",
                        "removeSource",
                        "setLayerZoomRange",
                        "setLight",
                        "setTransition",
                        "setGeoJSONSourceData"
                    ]), eu = i.pick(oa, [
                        "setCenter",
                        "setZoom",
                        "setBearing",
                        "setPitch"
                    ]), Ls = jo(), mu = function(Y1) {
                        function z(K, O) {
                            var $ = this;
                            O === void 0 && (O = {}), Y1.call(this), this.map = K, this.dispatcher = new X(ka(), this), this.imageManager = new E, this.imageManager.setEventedParent(this), this.glyphManager = new P(K._requestManager, O.localIdeographFontFamily), this.lineAtlas = new H(256, 512), this.crossTileSymbolIndex = new rh, this._layers = {}, this._serializedLayers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new i.ZoomHistory, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("setReferrer", i.getReferrer());
                            var pe = this;
                            this._rtlTextPluginCallback = z.registerForPluginStateChange(function(de) {
                                var Ie = {
                                    pluginStatus: de.pluginStatus,
                                    pluginURL: de.pluginURL
                                };
                                pe.dispatcher.broadcast("syncRTLPluginState", Ie, function($e, pt) {
                                    if (i.triggerPluginCompletionEvent($e), pt) {
                                        var Kt = pt.every(function(Jt) {
                                            return Jt;
                                        });
                                        if (Kt) for(var ir in pe.sourceCaches)pe.sourceCaches[ir].reload();
                                    }
                                });
                            }), this.on("data", function(de) {
                                if (!(de.dataType !== "source" || de.sourceDataType !== "metadata")) {
                                    var Ie = $.sourceCaches[de.sourceId];
                                    if (Ie) {
                                        var $e = Ie.getSource();
                                        if (!(!$e || !$e.vectorLayerIds)) for(var pt in $._layers){
                                            var Kt = $._layers[pt];
                                            Kt.source === $e.id && $._validateLayer(Kt);
                                        }
                                    }
                                }
                            });
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.loadURL = function(O, $) {
                            var pe = this;
                            $ === void 0 && ($ = {}), this.fire(new i.Event("dataloading", {
                                dataType: "style"
                            }));
                            var de = typeof $.validate == "boolean" ? $.validate : !i.isMapboxURL(O);
                            O = this.map._requestManager.normalizeStyleURL(O, $.accessToken);
                            var Ie = this.map._requestManager.transformRequest(O, i.ResourceType.Style);
                            this._request = i.getJSON(Ie, function($e, pt) {
                                pe._request = null, $e ? pe.fire(new i.ErrorEvent($e)) : pt && pe._load(pt, de);
                            });
                        }, z.prototype.loadJSON = function(O, $) {
                            var pe = this;
                            $ === void 0 && ($ = {}), this.fire(new i.Event("dataloading", {
                                dataType: "style"
                            })), this._request = i.browser.frame(function() {
                                pe._request = null, pe._load(O, $.validate !== !1);
                            });
                        }, z.prototype.loadEmpty = function() {
                            this.fire(new i.Event("dataloading", {
                                dataType: "style"
                            })), this._load(Ls, !1);
                        }, z.prototype._load = function(O, $) {
                            if (!($ && Al(this, i.validateStyle(O)))) {
                                this._loaded = !0, this.stylesheet = O;
                                for(var pe in O.sources)this.addSource(pe, O.sources[pe], {
                                    validate: !1
                                });
                                O.sprite ? this._loadSprite(O.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(O.glyphs);
                                var de = Ra(this.stylesheet.layers);
                                this._order = de.map(function(Kt) {
                                    return Kt.id;
                                }), this._layers = {}, this._serializedLayers = {};
                                for(var Ie = 0, $e = de; Ie < $e.length; Ie += 1){
                                    var pt = $e[Ie];
                                    pt = i.createStyleLayer(pt), pt.setEventedParent(this, {
                                        layer: {
                                            id: pt.id
                                        }
                                    }), this._layers[pt.id] = pt, this._serializedLayers[pt.id] = pt.serialize();
                                }
                                this.dispatcher.broadcast("setLayers", this._serializeLayers(this._order)), this.light = new V(this.stylesheet.light), this.fire(new i.Event("data", {
                                    dataType: "style"
                                })), this.fire(new i.Event("style.load"));
                            }
                        }, z.prototype._loadSprite = function(O) {
                            var $ = this;
                            this._spriteRequest = x(O, this.map._requestManager, function(pe, de) {
                                if ($._spriteRequest = null, pe) $.fire(new i.ErrorEvent(pe));
                                else if (de) for(var Ie in de)$.imageManager.addImage(Ie, de[Ie]);
                                $.imageManager.setLoaded(!0), $._availableImages = $.imageManager.listImages(), $.dispatcher.broadcast("setImages", $._availableImages), $.fire(new i.Event("data", {
                                    dataType: "style"
                                }));
                            });
                        }, z.prototype._validateLayer = function(O) {
                            var $ = this.sourceCaches[O.source];
                            if ($) {
                                var pe = O.sourceLayer;
                                if (pe) {
                                    var de = $.getSource();
                                    (de.type === "geojson" || de.vectorLayerIds && de.vectorLayerIds.indexOf(pe) === -1) && this.fire(new i.ErrorEvent(new Error('Source layer "' + pe + '" does not exist on source "' + de.id + '" as specified by style layer "' + O.id + '"')));
                                }
                            }
                        }, z.prototype.loaded = function() {
                            if (!this._loaded || Object.keys(this._updatedSources).length) return !1;
                            for(var O in this.sourceCaches)if (!this.sourceCaches[O].loaded()) return !1;
                            return !!this.imageManager.isLoaded();
                        }, z.prototype._serializeLayers = function(O) {
                            for(var $ = [], pe = 0, de = O; pe < de.length; pe += 1){
                                var Ie = de[pe], $e = this._layers[Ie];
                                $e.type !== "custom" && $.push($e.serialize());
                            }
                            return $;
                        }, z.prototype.hasTransitions = function() {
                            if (this.light && this.light.hasTransition()) return !0;
                            for(var O in this.sourceCaches)if (this.sourceCaches[O].hasTransition()) return !0;
                            for(var $ in this._layers)if (this._layers[$].hasTransition()) return !0;
                            return !1;
                        }, z.prototype._checkLoaded = function() {
                            if (!this._loaded) throw new Error("Style is not done loading");
                        }, z.prototype.update = function(O) {
                            if (this._loaded) {
                                var $ = this._changed;
                                if (this._changed) {
                                    var pe = Object.keys(this._updatedLayers), de = Object.keys(this._removedLayers);
                                    (pe.length || de.length) && this._updateWorkerLayers(pe, de);
                                    for(var Ie in this._updatedSources){
                                        var $e = this._updatedSources[Ie];
                                        $e === "reload" ? this._reloadSource(Ie) : $e === "clear" && this._clearSource(Ie);
                                    }
                                    this._updateTilesForChangedImages();
                                    for(var pt in this._updatedPaintProps)this._layers[pt].updateTransitions(O);
                                    this.light.updateTransitions(O), this._resetUpdates();
                                }
                                var Kt = {};
                                for(var ir in this.sourceCaches){
                                    var Jt = this.sourceCaches[ir];
                                    Kt[ir] = Jt.used, Jt.used = !1;
                                }
                                for(var vt = 0, Pt = this._order; vt < Pt.length; vt += 1){
                                    var Wt = Pt[vt], rr = this._layers[Wt];
                                    rr.recalculate(O, this._availableImages), !rr.isHidden(O.zoom) && rr.source && (this.sourceCaches[rr.source].used = !0);
                                }
                                for(var dr in Kt){
                                    var pr = this.sourceCaches[dr];
                                    Kt[dr] !== pr.used && pr.fire(new i.Event("data", {
                                        sourceDataType: "visibility",
                                        dataType: "source",
                                        sourceId: dr
                                    }));
                                }
                                this.light.recalculate(O), this.z = O.zoom, $ && this.fire(new i.Event("data", {
                                    dataType: "style"
                                }));
                            }
                        }, z.prototype._updateTilesForChangedImages = function() {
                            var O = Object.keys(this._changedImages);
                            if (O.length) {
                                for(var $ in this.sourceCaches)this.sourceCaches[$].reloadTilesForDependencies([
                                    "icons",
                                    "patterns"
                                ], O);
                                this._changedImages = {};
                            }
                        }, z.prototype._updateWorkerLayers = function(O, $) {
                            this.dispatcher.broadcast("updateLayers", {
                                layers: this._serializeLayers(O),
                                removedIds: $
                            });
                        }, z.prototype._resetUpdates = function() {
                            this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {};
                        }, z.prototype.setState = function(O) {
                            var $ = this;
                            if (this._checkLoaded(), Al(this, i.validateStyle(O))) return !1;
                            O = i.clone$1(O), O.layers = Ra(O.layers);
                            var pe = Yi(this.serialize(), O).filter(function(Ie) {
                                return !(Ie.command in eu);
                            });
                            if (pe.length === 0) return !1;
                            var de = pe.filter(function(Ie) {
                                return !(Ie.command in Hc);
                            });
                            if (de.length > 0) throw new Error("Unimplemented: " + de.map(function(Ie) {
                                return Ie.command;
                            }).join(", ") + ".");
                            return pe.forEach(function(Ie) {
                                Ie.command !== "setTransition" && $[Ie.command].apply($, Ie.args);
                            }), this.stylesheet = O, !0;
                        }, z.prototype.addImage = function(O, $) {
                            if (this.getImage(O)) return this.fire(new i.ErrorEvent(new Error("An image with this name already exists.")));
                            this.imageManager.addImage(O, $), this._afterImageUpdated(O);
                        }, z.prototype.updateImage = function(O, $) {
                            this.imageManager.updateImage(O, $);
                        }, z.prototype.getImage = function(O) {
                            return this.imageManager.getImage(O);
                        }, z.prototype.removeImage = function(O) {
                            if (!this.getImage(O)) return this.fire(new i.ErrorEvent(new Error("No image with this name exists.")));
                            this.imageManager.removeImage(O), this._afterImageUpdated(O);
                        }, z.prototype._afterImageUpdated = function(O) {
                            this._availableImages = this.imageManager.listImages(), this._changedImages[O] = !0, this._changed = !0, this.dispatcher.broadcast("setImages", this._availableImages), this.fire(new i.Event("data", {
                                dataType: "style"
                            }));
                        }, z.prototype.listImages = function() {
                            return this._checkLoaded(), this.imageManager.listImages();
                        }, z.prototype.addSource = function(O, $, pe) {
                            var de = this;
                            if (pe === void 0 && (pe = {}), this._checkLoaded(), this.sourceCaches[O] !== void 0) throw new Error("There is already a source with this ID");
                            if (!$.type) throw new Error("The type property must be defined, but only the following properties were given: " + Object.keys($).join(", ") + ".");
                            var Ie = [
                                "vector",
                                "raster",
                                "geojson",
                                "video",
                                "image"
                            ], $e = Ie.indexOf($.type) >= 0;
                            if (!($e && this._validate(i.validateStyle.source, "sources." + O, $, null, pe))) {
                                this.map && this.map._collectResourceTiming && ($.collectResourceTiming = !0);
                                var pt = this.sourceCaches[O] = new Zr(O, $, this.dispatcher);
                                pt.style = this, pt.setEventedParent(this, function() {
                                    return {
                                        isSourceLoaded: de.loaded(),
                                        source: pt.serialize(),
                                        sourceId: O
                                    };
                                }), pt.onAdd(this.map), this._changed = !0;
                            }
                        }, z.prototype.removeSource = function(O) {
                            if (this._checkLoaded(), this.sourceCaches[O] === void 0) throw new Error("There is no source with this ID");
                            for(var $ in this._layers)if (this._layers[$].source === O) return this.fire(new i.ErrorEvent(new Error('Source "' + O + '" cannot be removed while layer "' + $ + '" is using it.')));
                            var pe = this.sourceCaches[O];
                            delete this.sourceCaches[O], delete this._updatedSources[O], pe.fire(new i.Event("data", {
                                sourceDataType: "metadata",
                                dataType: "source",
                                sourceId: O
                            })), pe.setEventedParent(null), pe.clearTiles(), pe.onRemove && pe.onRemove(this.map), this._changed = !0;
                        }, z.prototype.setGeoJSONSourceData = function(O, $) {
                            this._checkLoaded();
                            var pe = this.sourceCaches[O].getSource();
                            pe.setData($), this._changed = !0;
                        }, z.prototype.getSource = function(O) {
                            return this.sourceCaches[O] && this.sourceCaches[O].getSource();
                        }, z.prototype.addLayer = function(O, $, pe) {
                            pe === void 0 && (pe = {}), this._checkLoaded();
                            var de = O.id;
                            if (this.getLayer(de)) {
                                this.fire(new i.ErrorEvent(new Error('Layer with id "' + de + '" already exists on this map')));
                                return;
                            }
                            var Ie;
                            if (O.type === "custom") {
                                if (Al(this, i.validateCustomStyleLayer(O))) return;
                                Ie = i.createStyleLayer(O);
                            } else {
                                if (typeof O.source == "object" && (this.addSource(de, O.source), O = i.clone$1(O), O = i.extend(O, {
                                    source: de
                                })), this._validate(i.validateStyle.layer, "layers." + de, O, {
                                    arrayIndex: -1
                                }, pe)) return;
                                Ie = i.createStyleLayer(O), this._validateLayer(Ie), Ie.setEventedParent(this, {
                                    layer: {
                                        id: de
                                    }
                                }), this._serializedLayers[Ie.id] = Ie.serialize();
                            }
                            var $e = $ ? this._order.indexOf($) : this._order.length;
                            if ($ && $e === -1) {
                                this.fire(new i.ErrorEvent(new Error('Layer with id "' + $ + '" does not exist on this map.')));
                                return;
                            }
                            if (this._order.splice($e, 0, de), this._layerOrderChanged = !0, this._layers[de] = Ie, this._removedLayers[de] && Ie.source && Ie.type !== "custom") {
                                var pt = this._removedLayers[de];
                                delete this._removedLayers[de], pt.type !== Ie.type ? this._updatedSources[Ie.source] = "clear" : (this._updatedSources[Ie.source] = "reload", this.sourceCaches[Ie.source].pause());
                            }
                            this._updateLayer(Ie), Ie.onAdd && Ie.onAdd(this.map);
                        }, z.prototype.moveLayer = function(O, $) {
                            this._checkLoaded(), this._changed = !0;
                            var pe = this._layers[O];
                            if (!pe) {
                                this.fire(new i.ErrorEvent(new Error("The layer '" + O + "' does not exist in the map's style and cannot be moved.")));
                                return;
                            }
                            if (O !== $) {
                                var de = this._order.indexOf(O);
                                this._order.splice(de, 1);
                                var Ie = $ ? this._order.indexOf($) : this._order.length;
                                if ($ && Ie === -1) {
                                    this.fire(new i.ErrorEvent(new Error('Layer with id "' + $ + '" does not exist on this map.')));
                                    return;
                                }
                                this._order.splice(Ie, 0, O), this._layerOrderChanged = !0;
                            }
                        }, z.prototype.removeLayer = function(O) {
                            this._checkLoaded();
                            var $ = this._layers[O];
                            if (!$) {
                                this.fire(new i.ErrorEvent(new Error("The layer '" + O + "' does not exist in the map's style and cannot be removed.")));
                                return;
                            }
                            $.setEventedParent(null);
                            var pe = this._order.indexOf(O);
                            this._order.splice(pe, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[O] = $, delete this._layers[O], delete this._serializedLayers[O], delete this._updatedLayers[O], delete this._updatedPaintProps[O], $.onRemove && $.onRemove(this.map);
                        }, z.prototype.getLayer = function(O) {
                            return this._layers[O];
                        }, z.prototype.hasLayer = function(O) {
                            return O in this._layers;
                        }, z.prototype.setLayerZoomRange = function(O, $, pe) {
                            this._checkLoaded();
                            var de = this.getLayer(O);
                            if (!de) {
                                this.fire(new i.ErrorEvent(new Error("The layer '" + O + "' does not exist in the map's style and cannot have zoom extent.")));
                                return;
                            }
                            de.minzoom === $ && de.maxzoom === pe || ($ != null && (de.minzoom = $), pe != null && (de.maxzoom = pe), this._updateLayer(de));
                        }, z.prototype.setFilter = function(O, $, pe) {
                            pe === void 0 && (pe = {}), this._checkLoaded();
                            var de = this.getLayer(O);
                            if (!de) {
                                this.fire(new i.ErrorEvent(new Error("The layer '" + O + "' does not exist in the map's style and cannot be filtered.")));
                                return;
                            }
                            if (!i.deepEqual(de.filter, $)) {
                                if ($ == null) {
                                    de.filter = void 0, this._updateLayer(de);
                                    return;
                                }
                                this._validate(i.validateStyle.filter, "layers." + de.id + ".filter", $, null, pe) || (de.filter = i.clone$1($), this._updateLayer(de));
                            }
                        }, z.prototype.getFilter = function(O) {
                            return i.clone$1(this.getLayer(O).filter);
                        }, z.prototype.setLayoutProperty = function(O, $, pe, de) {
                            de === void 0 && (de = {}), this._checkLoaded();
                            var Ie = this.getLayer(O);
                            if (!Ie) {
                                this.fire(new i.ErrorEvent(new Error("The layer '" + O + "' does not exist in the map's style and cannot be styled.")));
                                return;
                            }
                            i.deepEqual(Ie.getLayoutProperty($), pe) || (Ie.setLayoutProperty($, pe, de), this._updateLayer(Ie));
                        }, z.prototype.getLayoutProperty = function(O, $) {
                            var pe = this.getLayer(O);
                            if (!pe) {
                                this.fire(new i.ErrorEvent(new Error("The layer '" + O + "' does not exist in the map's style.")));
                                return;
                            }
                            return pe.getLayoutProperty($);
                        }, z.prototype.setPaintProperty = function(O, $, pe, de) {
                            de === void 0 && (de = {}), this._checkLoaded();
                            var Ie = this.getLayer(O);
                            if (!Ie) {
                                this.fire(new i.ErrorEvent(new Error("The layer '" + O + "' does not exist in the map's style and cannot be styled.")));
                                return;
                            }
                            if (!i.deepEqual(Ie.getPaintProperty($), pe)) {
                                var $e = Ie.setPaintProperty($, pe, de);
                                $e && this._updateLayer(Ie), this._changed = !0, this._updatedPaintProps[O] = !0;
                            }
                        }, z.prototype.getPaintProperty = function(O, $) {
                            return this.getLayer(O).getPaintProperty($);
                        }, z.prototype.setFeatureState = function(O, $) {
                            this._checkLoaded();
                            var pe = O.source, de = O.sourceLayer, Ie = this.sourceCaches[pe];
                            if (Ie === void 0) {
                                this.fire(new i.ErrorEvent(new Error("The source '" + pe + "' does not exist in the map's style.")));
                                return;
                            }
                            var $e = Ie.getSource().type;
                            if ($e === "geojson" && de) {
                                this.fire(new i.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                                return;
                            }
                            if ($e === "vector" && !de) {
                                this.fire(new i.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                return;
                            }
                            O.id === void 0 && this.fire(new i.ErrorEvent(new Error("The feature id parameter must be provided."))), Ie.setFeatureState(de, O.id, $);
                        }, z.prototype.removeFeatureState = function(O, $) {
                            this._checkLoaded();
                            var pe = O.source, de = this.sourceCaches[pe];
                            if (de === void 0) {
                                this.fire(new i.ErrorEvent(new Error("The source '" + pe + "' does not exist in the map's style.")));
                                return;
                            }
                            var Ie = de.getSource().type, $e = Ie === "vector" ? O.sourceLayer : void 0;
                            if (Ie === "vector" && !$e) {
                                this.fire(new i.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                return;
                            }
                            if ($ && typeof O.id != "string" && typeof O.id != "number") {
                                this.fire(new i.ErrorEvent(new Error("A feature id is required to remove its specific state property.")));
                                return;
                            }
                            de.removeFeatureState($e, O.id, $);
                        }, z.prototype.getFeatureState = function(O) {
                            this._checkLoaded();
                            var $ = O.source, pe = O.sourceLayer, de = this.sourceCaches[$];
                            if (de === void 0) {
                                this.fire(new i.ErrorEvent(new Error("The source '" + $ + "' does not exist in the map's style.")));
                                return;
                            }
                            var Ie = de.getSource().type;
                            if (Ie === "vector" && !pe) {
                                this.fire(new i.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                return;
                            }
                            return O.id === void 0 && this.fire(new i.ErrorEvent(new Error("The feature id parameter must be provided."))), de.getFeatureState(pe, O.id);
                        }, z.prototype.getTransition = function() {
                            return i.extend({
                                duration: 300,
                                delay: 0
                            }, this.stylesheet && this.stylesheet.transition);
                        }, z.prototype.serialize = function() {
                            return i.filterObject({
                                version: this.stylesheet.version,
                                name: this.stylesheet.name,
                                metadata: this.stylesheet.metadata,
                                light: this.stylesheet.light,
                                center: this.stylesheet.center,
                                zoom: this.stylesheet.zoom,
                                bearing: this.stylesheet.bearing,
                                pitch: this.stylesheet.pitch,
                                sprite: this.stylesheet.sprite,
                                glyphs: this.stylesheet.glyphs,
                                transition: this.stylesheet.transition,
                                sources: i.mapObject(this.sourceCaches, function(O) {
                                    return O.serialize();
                                }),
                                layers: this._serializeLayers(this._order)
                            }, function(O) {
                                return O !== void 0;
                            });
                        }, z.prototype._updateLayer = function(O) {
                            this._updatedLayers[O.id] = !0, O.source && !this._updatedSources[O.source] && this.sourceCaches[O.source].getSource().type !== "raster" && (this._updatedSources[O.source] = "reload", this.sourceCaches[O.source].pause()), this._changed = !0;
                        }, z.prototype._flattenAndSortRenderedFeatures = function(O) {
                            for(var $ = this, pe = function(ln) {
                                return $._layers[ln].type === "fill-extrusion";
                            }, de = {}, Ie = [], $e = this._order.length - 1; $e >= 0; $e--){
                                var pt = this._order[$e];
                                if (pe(pt)) {
                                    de[pt] = $e;
                                    for(var Kt = 0, ir = O; Kt < ir.length; Kt += 1){
                                        var Jt = ir[Kt], vt = Jt[pt];
                                        if (vt) for(var Pt = 0, Wt = vt; Pt < Wt.length; Pt += 1){
                                            var rr = Wt[Pt];
                                            Ie.push(rr);
                                        }
                                    }
                                }
                            }
                            Ie.sort(function(ln, Qn) {
                                return Qn.intersectionZ - ln.intersectionZ;
                            });
                            for(var dr = [], pr = this._order.length - 1; pr >= 0; pr--){
                                var kr = this._order[pr];
                                if (pe(kr)) for(var Ar = Ie.length - 1; Ar >= 0; Ar--){
                                    var gr = Ie[Ar].feature;
                                    if (de[gr.layer.id] < pr) break;
                                    dr.push(gr), Ie.pop();
                                }
                                else for(var Cr = 0, cr = O; Cr < cr.length; Cr += 1){
                                    var Gr = cr[Cr], ei = Gr[kr];
                                    if (ei) for(var yi = 0, tn = ei; yi < tn.length; yi += 1){
                                        var Ri = tn[yi];
                                        dr.push(Ri.feature);
                                    }
                                }
                            }
                            return dr;
                        }, z.prototype.queryRenderedFeatures = function(O, $, pe) {
                            $ && $.filter && this._validate(i.validateStyle.filter, "queryRenderedFeatures.filter", $.filter, null, $);
                            var de = {};
                            if ($ && $.layers) {
                                if (!Array.isArray($.layers)) return this.fire(new i.ErrorEvent(new Error("parameters.layers must be an Array."))), [];
                                for(var Ie = 0, $e = $.layers; Ie < $e.length; Ie += 1){
                                    var pt = $e[Ie], Kt = this._layers[pt];
                                    if (!Kt) return this.fire(new i.ErrorEvent(new Error("The layer '" + pt + "' does not exist in the map's style and cannot be queried for features."))), [];
                                    de[Kt.source] = !0;
                                }
                            }
                            var ir = [];
                            $.availableImages = this._availableImages;
                            for(var Jt in this.sourceCaches)$.layers && !de[Jt] || ir.push(ce(this.sourceCaches[Jt], this._layers, this._serializedLayers, O, $, pe));
                            return this.placement && ir.push(Ge(this._layers, this._serializedLayers, this.sourceCaches, O, $, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(ir);
                        }, z.prototype.querySourceFeatures = function(O, $) {
                            $ && $.filter && this._validate(i.validateStyle.filter, "querySourceFeatures.filter", $.filter, null, $);
                            var pe = this.sourceCaches[O];
                            return pe ? nt(pe, $) : [];
                        }, z.prototype.addSourceType = function(O, $, pe) {
                            if (z.getSourceType(O)) return pe(new Error('A source type called "' + O + '" already exists.'));
                            if (z.setSourceType(O, $), !$.workerSourceURL) return pe(null, null);
                            this.dispatcher.broadcast("loadWorkerSource", {
                                name: O,
                                url: $.workerSourceURL
                            }, pe);
                        }, z.prototype.getLight = function() {
                            return this.light.getLight();
                        }, z.prototype.setLight = function(O, $) {
                            $ === void 0 && ($ = {}), this._checkLoaded();
                            var pe = this.light.getLight(), de = !1;
                            for(var Ie in O)if (!i.deepEqual(O[Ie], pe[Ie])) {
                                de = !0;
                                break;
                            }
                            if (de) {
                                var $e = {
                                    now: i.browser.now(),
                                    transition: i.extend({
                                        duration: 300,
                                        delay: 0
                                    }, this.stylesheet.transition)
                                };
                                this.light.setLight(O, $), this.light.updateTransitions($e);
                            }
                        }, z.prototype._validate = function(O, $, pe, de, Ie) {
                            return Ie === void 0 && (Ie = {}), Ie && Ie.validate === !1 ? !1 : Al(this, O.call(i.validateStyle, i.extend({
                                key: $,
                                style: this.serialize(),
                                value: pe,
                                styleSpec: i.styleSpec
                            }, de)));
                        }, z.prototype._remove = function() {
                            this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), i.evented.off("pluginStateChange", this._rtlTextPluginCallback);
                            for(var O in this._layers){
                                var $ = this._layers[O];
                                $.setEventedParent(null);
                            }
                            for(var pe in this.sourceCaches)this.sourceCaches[pe].clearTiles(), this.sourceCaches[pe].setEventedParent(null);
                            this.imageManager.setEventedParent(null), this.setEventedParent(null), this.dispatcher.remove();
                        }, z.prototype._clearSource = function(O) {
                            this.sourceCaches[O].clearTiles();
                        }, z.prototype._reloadSource = function(O) {
                            this.sourceCaches[O].resume(), this.sourceCaches[O].reload();
                        }, z.prototype._updateSources = function(O) {
                            for(var $ in this.sourceCaches)this.sourceCaches[$].update(O);
                        }, z.prototype._generateCollisionBoxes = function() {
                            for(var O in this.sourceCaches)this._reloadSource(O);
                        }, z.prototype._updatePlacement = function(O, $, pe, de, Ie) {
                            Ie === void 0 && (Ie = !1);
                            for(var $e = !1, pt = !1, Kt = {}, ir = 0, Jt = this._order; ir < Jt.length; ir += 1){
                                var vt = Jt[ir], Pt = this._layers[vt];
                                if (Pt.type === "symbol") {
                                    if (!Kt[Pt.source]) {
                                        var Wt = this.sourceCaches[Pt.source];
                                        Kt[Pt.source] = Wt.getRenderableIds(!0).map(function(Cr) {
                                            return Wt.getTileByID(Cr);
                                        }).sort(function(Cr, cr) {
                                            return cr.tileID.overscaledZ - Cr.tileID.overscaledZ || (Cr.tileID.isLessThan(cr.tileID) ? -1 : 1);
                                        });
                                    }
                                    var rr = this.crossTileSymbolIndex.addLayer(Pt, Kt[Pt.source], O.center.lng);
                                    $e = $e || rr;
                                }
                            }
                            if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), Ie = Ie || this._layerOrderChanged || pe === 0, (Ie || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(i.browser.now(), O.zoom)) && (this.pauseablePlacement = new Co(O, this._order, Ie, $, pe, de, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, Kt), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(i.browser.now()), pt = !0), $e && this.pauseablePlacement.placement.setStale()), pt || $e) for(var dr = 0, pr = this._order; dr < pr.length; dr += 1){
                                var kr = pr[dr], Ar = this._layers[kr];
                                Ar.type === "symbol" && this.placement.updateLayerOpacities(Ar, Kt[Ar.source]);
                            }
                            var gr = !this.pauseablePlacement.isDone() || this.placement.hasTransitions(i.browser.now());
                            return gr;
                        }, z.prototype._releaseSymbolFadeTiles = function() {
                            for(var O in this.sourceCaches)this.sourceCaches[O].releaseSymbolFadeTiles();
                        }, z.prototype.getImages = function(O, $, pe) {
                            this.imageManager.getImages($.icons, pe), this._updateTilesForChangedImages();
                            var de = this.sourceCaches[$.source];
                            de && de.setDependencies($.tileID.key, $.type, $.icons);
                        }, z.prototype.getGlyphs = function(O, $, pe) {
                            this.glyphManager.getGlyphs($.stacks, pe);
                        }, z.prototype.getResource = function(O, $, pe) {
                            return i.makeRequest($, pe);
                        }, z;
                    }(i.Evented);
                    mu.getSourceType = ze, mu.setSourceType = Ce, mu.registerForPluginStateChange = i.registerForPluginStateChange;
                    var kc = i.createLayout([
                        {
                            name: "a_pos",
                            type: "Int16",
                            components: 2
                        }
                    ]), Of = `#ifdef GL_ES
precision mediump float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif`, Gc = `#ifdef GL_ES
precision highp float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
vec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0
);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}`, vd = `uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Bf = "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}", ss = `uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, ff = "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}", ih = `varying vec3 v_data;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define mediump float radius
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define highp vec4 stroke_color
#pragma mapbox: define mediump float stroke_width
#pragma mapbox: define lowp float stroke_opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize mediump float radius
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize highp vec4 stroke_color
#pragma mapbox: initialize mediump float stroke_width
#pragma mapbox: initialize lowp float stroke_opacity
vec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Vl = `uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define mediump float radius
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define highp vec4 stroke_color
#pragma mapbox: define mediump float stroke_width
#pragma mapbox: define lowp float stroke_opacity
void main(void) {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize mediump float radius
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize highp vec4 stroke_color
#pragma mapbox: initialize mediump float stroke_width
#pragma mapbox: initialize lowp float stroke_opacity
vec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}`, Js = "void main() {gl_FragColor=vec4(1.0);}", hc = "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}", Cc = `uniform highp float u_intensity;varying vec2 v_extrude;
#pragma mapbox: define highp float weight
#define GAUSS_COEF 0.3989422804014327
void main() {
#pragma mapbox: initialize highp float weight
float d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, ws = `uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;
#pragma mapbox: define highp float weight
#pragma mapbox: define mediump float radius
const highp float ZERO=1.0/255.0/16.0;
#define GAUSS_COEF 0.3989422804014327
void main(void) {
#pragma mapbox: initialize highp float weight
#pragma mapbox: initialize mediump float radius
vec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}`, $s = `uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(0.0);
#endif
}`, hs = "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}", Ms = "varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", dc = "attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}", Sl = "varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", ec = "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}", Ps = "uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", ov = "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,0,1);}", wo = `#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float opacity
gl_FragColor=color*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Od = `attribute vec2 a_pos;uniform mat4 u_matrix;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float opacity
gl_Position=u_matrix*vec4(a_pos,0,1);}`, $o = `varying vec2 v_pos;
#pragma mapbox: define highp vec4 outline_color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 outline_color
#pragma mapbox: initialize lowp float opacity
float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Ja = `attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;
#pragma mapbox: define highp vec4 outline_color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 outline_color
#pragma mapbox: initialize lowp float opacity
gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}`, Ef = `uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, tc = `uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}`, uu = `uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Mh = `uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}`, jc = `varying vec4 v_color;void main() {gl_FragColor=v_color;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, kf = `uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;
#pragma mapbox: define highp float base
#pragma mapbox: define highp float height
#pragma mapbox: define highp vec4 color
void main() {
#pragma mapbox: initialize highp float base
#pragma mapbox: initialize highp float height
#pragma mapbox: initialize highp vec4 color
vec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}`, Ml = `uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;
#pragma mapbox: define lowp float base
#pragma mapbox: define lowp float height
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float base
#pragma mapbox: initialize lowp float height
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Yh = `uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;
#pragma mapbox: define lowp float base
#pragma mapbox: define lowp float height
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float base
#pragma mapbox: initialize lowp float height
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0
? a_pos
: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}`, Eh = `#ifdef GL_ES
precision highp float;
#endif
uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, nh = "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}", hf = `uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;
#define PI 3.141592653589793
void main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, kh = "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}", Kh = `uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, rc = `
#define scale 0.015873016
attribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float width
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float width
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}`, ah = `uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Wc = `
#define scale 0.015873016
attribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float width
void main() {
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float width
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}`, df = `uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Cu = `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
attribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define mediump float width
#pragma mapbox: define lowp float floorwidth
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize lowp float floorwidth
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}`, Nf = `uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float width
#pragma mapbox: define lowp float floorwidth
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize lowp float floorwidth
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Zc = `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
attribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float width
#pragma mapbox: define lowp float floorwidth
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize lowp float floorwidth
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}`, ds = `uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Ch = "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}", Bd = `uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize lowp float opacity
lowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, Jh = `const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize lowp float opacity
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}`, Cf = `#define SDF_PX 8.0
uniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
float EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, pd = `const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}`, Lu = `#define SDF_PX 8.0
#define SDF 1.0
#define ICON 0.0
uniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
float fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
return;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, $h = `const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}`, tu = Is(Of, Gc), Pu = Is(vd, Bf), Lc = Is(ss, ff), fl = Is(ih, Vl), Xc = Is(Js, hc), ic = Is(Cc, ws), yu = Is($s, hs), Qs = Is(Ms, dc), Qh = Is(Sl, ec), gd = Is(Ps, ov), Gu = Is(wo, Od), Pc = Is($o, Ja), vc = Is(Ef, tc), sv = Is(uu, Mh), Lf = Is(jc, kf), Uf = Is(Ml, Yh), Iu = Is(Eh, nh), oh = Is(hf, kh), ru = Is(Kh, rc), vf = Is(ah, Wc), md = Is(df, Cu), sh = Is(Nf, Zc), Fs = Is(ds, Ch), _u = Is(Bd, Jh), xu = Is(Cf, pd), Lh = Is(Lu, $h);
                    function Is(Y1, z) {
                        var K = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, O = z.match(/attribute ([\w]+) ([\w]+)/g), $ = Y1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), pe = z.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), de = pe ? pe.concat($) : $, Ie = {};
                        return Y1 = Y1.replace(K, function($e, pt, Kt, ir, Jt) {
                            return Ie[Jt] = !0, pt === "define" ? `
#ifndef HAS_UNIFORM_u_` + Jt + `
varying ` + Kt + " " + ir + " " + Jt + `;
#else
uniform ` + Kt + " " + ir + " u_" + Jt + `;
#endif
` : `
#ifdef HAS_UNIFORM_u_` + Jt + `
    ` + Kt + " " + ir + " " + Jt + " = u_" + Jt + `;
#endif
`;
                        }), z = z.replace(K, function($e, pt, Kt, ir, Jt) {
                            var vt = ir === "float" ? "vec2" : "vec4", Pt = Jt.match(/color/) ? "color" : vt;
                            return Ie[Jt] ? pt === "define" ? `
#ifndef HAS_UNIFORM_u_` + Jt + `
uniform lowp float u_` + Jt + `_t;
attribute ` + Kt + " " + vt + " a_" + Jt + `;
varying ` + Kt + " " + ir + " " + Jt + `;
#else
uniform ` + Kt + " " + ir + " u_" + Jt + `;
#endif
` : Pt === "vec4" ? `
#ifndef HAS_UNIFORM_u_` + Jt + `
    ` + Jt + " = a_" + Jt + `;
#else
    ` + Kt + " " + ir + " " + Jt + " = u_" + Jt + `;
#endif
` : `
#ifndef HAS_UNIFORM_u_` + Jt + `
    ` + Jt + " = unpack_mix_" + Pt + "(a_" + Jt + ", u_" + Jt + `_t);
#else
    ` + Kt + " " + ir + " " + Jt + " = u_" + Jt + `;
#endif
` : pt === "define" ? `
#ifndef HAS_UNIFORM_u_` + Jt + `
uniform lowp float u_` + Jt + `_t;
attribute ` + Kt + " " + vt + " a_" + Jt + `;
#else
uniform ` + Kt + " " + ir + " u_" + Jt + `;
#endif
` : Pt === "vec4" ? `
#ifndef HAS_UNIFORM_u_` + Jt + `
    ` + Kt + " " + ir + " " + Jt + " = a_" + Jt + `;
#else
    ` + Kt + " " + ir + " " + Jt + " = u_" + Jt + `;
#endif
` : `
#ifndef HAS_UNIFORM_u_` + Jt + `
    ` + Kt + " " + ir + " " + Jt + " = unpack_mix_" + Pt + "(a_" + Jt + ", u_" + Jt + `_t);
#else
    ` + Kt + " " + ir + " " + Jt + " = u_" + Jt + `;
#endif
`;
                        }), {
                            fragmentSource: Y1,
                            vertexSource: z,
                            staticAttributes: O,
                            staticUniforms: de
                        };
                    }
                    var Pf = Object.freeze({
                        __proto__: null,
                        prelude: tu,
                        background: Pu,
                        backgroundPattern: Lc,
                        circle: fl,
                        clippingMask: Xc,
                        heatmap: ic,
                        heatmapTexture: yu,
                        collisionBox: Qs,
                        collisionCircle: Qh,
                        debug: gd,
                        fill: Gu,
                        fillOutline: Pc,
                        fillOutlinePattern: vc,
                        fillPattern: sv,
                        fillExtrusion: Lf,
                        fillExtrusionPattern: Uf,
                        hillshadePrepare: Iu,
                        hillshade: oh,
                        line: ru,
                        lineGradient: vf,
                        linePattern: md,
                        lineSDF: sh,
                        raster: Fs,
                        symbolIcon: _u,
                        symbolSDF: xu,
                        symbolTextAndIcon: Lh
                    }), Ic = function() {
                        this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
                    };
                    Ic.prototype.bind = function(z, K, O, $, pe, de, Ie, $e) {
                        this.context = z;
                        for(var pt = this.boundPaintVertexBuffers.length !== $.length, Kt = 0; !pt && Kt < $.length; Kt++)this.boundPaintVertexBuffers[Kt] !== $[Kt] && (pt = !0);
                        var ir = !this.vao || this.boundProgram !== K || this.boundLayoutVertexBuffer !== O || pt || this.boundIndexBuffer !== pe || this.boundVertexOffset !== de || this.boundDynamicVertexBuffer !== Ie || this.boundDynamicVertexBuffer2 !== $e;
                        !z.extVertexArrayObject || ir ? this.freshBind(K, O, $, pe, de, Ie, $e) : (z.bindVertexArrayOES.set(this.vao), Ie && Ie.bind(), pe && pe.dynamicDraw && pe.bind(), $e && $e.bind());
                    }, Ic.prototype.freshBind = function(z, K, O, $, pe, de, Ie) {
                        var $e, pt = z.numAttributes, Kt = this.context, ir = Kt.gl;
                        if (Kt.extVertexArrayObject) this.vao && this.destroy(), this.vao = Kt.extVertexArrayObject.createVertexArrayOES(), Kt.bindVertexArrayOES.set(this.vao), $e = 0, this.boundProgram = z, this.boundLayoutVertexBuffer = K, this.boundPaintVertexBuffers = O, this.boundIndexBuffer = $, this.boundVertexOffset = pe, this.boundDynamicVertexBuffer = de, this.boundDynamicVertexBuffer2 = Ie;
                        else {
                            $e = Kt.currentNumAttributes || 0;
                            for(var Jt = pt; Jt < $e; Jt++)ir.disableVertexAttribArray(Jt);
                        }
                        K.enableAttributes(ir, z);
                        for(var vt = 0, Pt = O; vt < Pt.length; vt += 1){
                            var Wt = Pt[vt];
                            Wt.enableAttributes(ir, z);
                        }
                        de && de.enableAttributes(ir, z), Ie && Ie.enableAttributes(ir, z), K.bind(), K.setVertexAttribPointers(ir, z, pe);
                        for(var rr = 0, dr = O; rr < dr.length; rr += 1){
                            var pr = dr[rr];
                            pr.bind(), pr.setVertexAttribPointers(ir, z, pe);
                        }
                        de && (de.bind(), de.setVertexAttribPointers(ir, z, pe)), $ && $.bind(), Ie && (Ie.bind(), Ie.setVertexAttribPointers(ir, z, pe)), Kt.currentNumAttributes = pt;
                    }, Ic.prototype.destroy = function() {
                        this.vao && (this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao), this.vao = null);
                    };
                    function ju(Y1) {
                        for(var z = [], K = 0; K < Y1.length; K++)if (Y1[K] !== null) {
                            var O = Y1[K].split(" ");
                            z.push(O.pop());
                        }
                        return z;
                    }
                    var Vf = function(z, K, O, $, pe, de) {
                        var Ie = z.gl;
                        this.program = Ie.createProgram();
                        for(var $e = ju(O.staticAttributes), pt = $ ? $.getBinderAttributes() : [], Kt = $e.concat(pt), ir = O.staticUniforms ? ju(O.staticUniforms) : [], Jt = $ ? $.getBinderUniforms() : [], vt = ir.concat(Jt), Pt = [], Wt = 0, rr = vt; Wt < rr.length; Wt += 1){
                            var dr = rr[Wt];
                            Pt.indexOf(dr) < 0 && Pt.push(dr);
                        }
                        var pr = $ ? $.defines() : [];
                        de && pr.push("#define OVERDRAW_INSPECTOR;");
                        var kr = pr.concat(tu.fragmentSource, O.fragmentSource).join(`
`), Ar = pr.concat(tu.vertexSource, O.vertexSource).join(`
`), gr = Ie.createShader(Ie.FRAGMENT_SHADER);
                        if (Ie.isContextLost()) {
                            this.failedToCreate = !0;
                            return;
                        }
                        Ie.shaderSource(gr, kr), Ie.compileShader(gr), Ie.attachShader(this.program, gr);
                        var Cr = Ie.createShader(Ie.VERTEX_SHADER);
                        if (Ie.isContextLost()) {
                            this.failedToCreate = !0;
                            return;
                        }
                        Ie.shaderSource(Cr, Ar), Ie.compileShader(Cr), Ie.attachShader(this.program, Cr), this.attributes = {};
                        var cr = {};
                        this.numAttributes = Kt.length;
                        for(var Gr = 0; Gr < this.numAttributes; Gr++)Kt[Gr] && (Ie.bindAttribLocation(this.program, Gr, Kt[Gr]), this.attributes[Kt[Gr]] = Gr);
                        Ie.linkProgram(this.program), Ie.deleteShader(Cr), Ie.deleteShader(gr);
                        for(var ei = 0; ei < Pt.length; ei++){
                            var yi = Pt[ei];
                            if (yi && !cr[yi]) {
                                var tn = Ie.getUniformLocation(this.program, yi);
                                tn && (cr[yi] = tn);
                            }
                        }
                        this.fixedUniforms = pe(z, cr), this.binderUniforms = $ ? $.getUniforms(z, cr) : [];
                    };
                    Vf.prototype.draw = function(z, K, O, $, pe, de, Ie, $e, pt, Kt, ir, Jt, vt, Pt, Wt, rr) {
                        var dr, pr = z.gl;
                        if (!this.failedToCreate) {
                            z.program.set(this.program), z.setDepthMode(O), z.setStencilMode($), z.setColorMode(pe), z.setCullFace(de);
                            for(var kr in this.fixedUniforms)this.fixedUniforms[kr].set(Ie[kr]);
                            Pt && Pt.setUniforms(z, this.binderUniforms, Jt, {
                                zoom: vt
                            });
                            for(var Ar = (dr = {}, dr[pr.LINES] = 2, dr[pr.TRIANGLES] = 3, dr[pr.LINE_STRIP] = 1, dr)[K], gr = 0, Cr = ir.get(); gr < Cr.length; gr += 1){
                                var cr = Cr[gr], Gr = cr.vaos || (cr.vaos = {}), ei = Gr[$e] || (Gr[$e] = new Ic);
                                ei.bind(z, this, pt, Pt ? Pt.getPaintVertexBuffers() : [], Kt, cr.vertexOffset, Wt, rr), pr.drawElements(K, cr.primitiveLength * Ar, pr.UNSIGNED_SHORT, cr.primitiveOffset * Ar * 2);
                            }
                        }
                    };
                    function pc(Y1, z, K) {
                        var O = 1 / Cs(K, 1, z.transform.tileZoom), $ = Math.pow(2, K.tileID.overscaledZ), pe = K.tileSize * Math.pow(2, z.transform.tileZoom) / $, de = pe * (K.tileID.canonical.x + K.tileID.wrap * $), Ie = pe * K.tileID.canonical.y;
                        return {
                            u_image: 0,
                            u_texsize: K.imageAtlasTexture.size,
                            u_scale: [
                                O,
                                Y1.fromScale,
                                Y1.toScale
                            ],
                            u_fade: Y1.t,
                            u_pixel_coord_upper: [
                                de >> 16,
                                Ie >> 16
                            ],
                            u_pixel_coord_lower: [
                                de & 65535,
                                Ie & 65535
                            ]
                        };
                    }
                    function pf(Y1, z, K, O) {
                        var $ = K.imageManager.getPattern(Y1.from.toString()), pe = K.imageManager.getPattern(Y1.to.toString()), de = K.imageManager.getPixelSize(), Ie = de.width, $e = de.height, pt = Math.pow(2, O.tileID.overscaledZ), Kt = O.tileSize * Math.pow(2, K.transform.tileZoom) / pt, ir = Kt * (O.tileID.canonical.x + O.tileID.wrap * pt), Jt = Kt * O.tileID.canonical.y;
                        return {
                            u_image: 0,
                            u_pattern_tl_a: $.tl,
                            u_pattern_br_a: $.br,
                            u_pattern_tl_b: pe.tl,
                            u_pattern_br_b: pe.br,
                            u_texsize: [
                                Ie,
                                $e
                            ],
                            u_mix: z.t,
                            u_pattern_size_a: $.displaySize,
                            u_pattern_size_b: pe.displaySize,
                            u_scale_a: z.fromScale,
                            u_scale_b: z.toScale,
                            u_tile_units_to_pixels: 1 / Cs(O, 1, K.transform.tileZoom),
                            u_pixel_coord_upper: [
                                ir >> 16,
                                Jt >> 16
                            ],
                            u_pixel_coord_lower: [
                                ir & 65535,
                                Jt & 65535
                            ]
                        };
                    }
                    var Ph = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_lightpos: new i.Uniform3f(Y1, z.u_lightpos),
                            u_lightintensity: new i.Uniform1f(Y1, z.u_lightintensity),
                            u_lightcolor: new i.Uniform3f(Y1, z.u_lightcolor),
                            u_vertical_gradient: new i.Uniform1f(Y1, z.u_vertical_gradient),
                            u_opacity: new i.Uniform1f(Y1, z.u_opacity)
                        };
                    }, Dl = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_lightpos: new i.Uniform3f(Y1, z.u_lightpos),
                            u_lightintensity: new i.Uniform1f(Y1, z.u_lightintensity),
                            u_lightcolor: new i.Uniform3f(Y1, z.u_lightcolor),
                            u_vertical_gradient: new i.Uniform1f(Y1, z.u_vertical_gradient),
                            u_height_factor: new i.Uniform1f(Y1, z.u_height_factor),
                            u_image: new i.Uniform1i(Y1, z.u_image),
                            u_texsize: new i.Uniform2f(Y1, z.u_texsize),
                            u_pixel_coord_upper: new i.Uniform2f(Y1, z.u_pixel_coord_upper),
                            u_pixel_coord_lower: new i.Uniform2f(Y1, z.u_pixel_coord_lower),
                            u_scale: new i.Uniform3f(Y1, z.u_scale),
                            u_fade: new i.Uniform1f(Y1, z.u_fade),
                            u_opacity: new i.Uniform1f(Y1, z.u_opacity)
                        };
                    }, Ih = function(Y1, z, K, O) {
                        var $ = z.style.light, pe = $.properties.get("position"), de = [
                            pe.x,
                            pe.y,
                            pe.z
                        ], Ie = i.create$1();
                        $.properties.get("anchor") === "viewport" && i.fromRotation(Ie, -z.transform.angle), i.transformMat3(de, de, Ie);
                        var $e = $.properties.get("color");
                        return {
                            u_matrix: Y1,
                            u_lightpos: de,
                            u_lightintensity: $.properties.get("intensity"),
                            u_lightcolor: [
                                $e.r,
                                $e.g,
                                $e.b
                            ],
                            u_vertical_gradient: +K,
                            u_opacity: O
                        };
                    }, Wu = function(Y1, z, K, O, $, pe, de) {
                        return i.extend(Ih(Y1, z, K, O), pc(pe, z, de), {
                            u_height_factor: -Math.pow(2, $.overscaledZ) / de.tileSize / 8
                        });
                    }, Rc = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix)
                        };
                    }, gc = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_image: new i.Uniform1i(Y1, z.u_image),
                            u_texsize: new i.Uniform2f(Y1, z.u_texsize),
                            u_pixel_coord_upper: new i.Uniform2f(Y1, z.u_pixel_coord_upper),
                            u_pixel_coord_lower: new i.Uniform2f(Y1, z.u_pixel_coord_lower),
                            u_scale: new i.Uniform3f(Y1, z.u_scale),
                            u_fade: new i.Uniform1f(Y1, z.u_fade)
                        };
                    }, hl = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_world: new i.Uniform2f(Y1, z.u_world)
                        };
                    }, iu = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_world: new i.Uniform2f(Y1, z.u_world),
                            u_image: new i.Uniform1i(Y1, z.u_image),
                            u_texsize: new i.Uniform2f(Y1, z.u_texsize),
                            u_pixel_coord_upper: new i.Uniform2f(Y1, z.u_pixel_coord_upper),
                            u_pixel_coord_lower: new i.Uniform2f(Y1, z.u_pixel_coord_lower),
                            u_scale: new i.Uniform3f(Y1, z.u_scale),
                            u_fade: new i.Uniform1f(Y1, z.u_fade)
                        };
                    }, mc = function(Y1) {
                        return {
                            u_matrix: Y1
                        };
                    }, Yc = function(Y1, z, K, O) {
                        return i.extend(mc(Y1), pc(K, z, O));
                    }, nc = function(Y1, z) {
                        return {
                            u_matrix: Y1,
                            u_world: z
                        };
                    }, gf = function(Y1, z, K, O, $) {
                        return i.extend(Yc(Y1, z, K, O), {
                            u_world: $
                        });
                    }, gt = function(Y1, z) {
                        return {
                            u_camera_to_center_distance: new i.Uniform1f(Y1, z.u_camera_to_center_distance),
                            u_scale_with_map: new i.Uniform1i(Y1, z.u_scale_with_map),
                            u_pitch_with_map: new i.Uniform1i(Y1, z.u_pitch_with_map),
                            u_extrude_scale: new i.Uniform2f(Y1, z.u_extrude_scale),
                            u_device_pixel_ratio: new i.Uniform1f(Y1, z.u_device_pixel_ratio),
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix)
                        };
                    }, Bt = function(Y1, z, K, O) {
                        var $ = Y1.transform, pe, de;
                        if (O.paint.get("circle-pitch-alignment") === "map") {
                            var Ie = Cs(K, 1, $.zoom);
                            pe = !0, de = [
                                Ie,
                                Ie
                            ];
                        } else pe = !1, de = $.pixelsToGLUnits;
                        return {
                            u_camera_to_center_distance: $.cameraToCenterDistance,
                            u_scale_with_map: +(O.paint.get("circle-pitch-scale") === "map"),
                            u_matrix: Y1.translatePosMatrix(z.posMatrix, K, O.paint.get("circle-translate"), O.paint.get("circle-translate-anchor")),
                            u_pitch_with_map: +pe,
                            u_device_pixel_ratio: i.browser.devicePixelRatio,
                            u_extrude_scale: de
                        };
                    }, wr = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_camera_to_center_distance: new i.Uniform1f(Y1, z.u_camera_to_center_distance),
                            u_pixels_to_tile_units: new i.Uniform1f(Y1, z.u_pixels_to_tile_units),
                            u_extrude_scale: new i.Uniform2f(Y1, z.u_extrude_scale),
                            u_overscale_factor: new i.Uniform1f(Y1, z.u_overscale_factor)
                        };
                    }, vr = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_inv_matrix: new i.UniformMatrix4f(Y1, z.u_inv_matrix),
                            u_camera_to_center_distance: new i.Uniform1f(Y1, z.u_camera_to_center_distance),
                            u_viewport_size: new i.Uniform2f(Y1, z.u_viewport_size)
                        };
                    }, Ur = function(Y1, z, K) {
                        var O = Cs(K, 1, z.zoom), $ = Math.pow(2, z.zoom - K.tileID.overscaledZ), pe = K.tileID.overscaleFactor();
                        return {
                            u_matrix: Y1,
                            u_camera_to_center_distance: z.cameraToCenterDistance,
                            u_pixels_to_tile_units: O,
                            u_extrude_scale: [
                                z.pixelsToGLUnits[0] / (O * $),
                                z.pixelsToGLUnits[1] / (O * $)
                            ],
                            u_overscale_factor: pe
                        };
                    }, fi = function(Y1, z, K) {
                        return {
                            u_matrix: Y1,
                            u_inv_matrix: z,
                            u_camera_to_center_distance: K.cameraToCenterDistance,
                            u_viewport_size: [
                                K.width,
                                K.height
                            ]
                        };
                    }, xi = function(Y1, z) {
                        return {
                            u_color: new i.UniformColor(Y1, z.u_color),
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_overlay: new i.Uniform1i(Y1, z.u_overlay),
                            u_overlay_scale: new i.Uniform1f(Y1, z.u_overlay_scale)
                        };
                    }, Fi = function(Y1, z, K) {
                        return K === void 0 && (K = 1), {
                            u_matrix: Y1,
                            u_color: z,
                            u_overlay: 0,
                            u_overlay_scale: K
                        };
                    }, Xi = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix)
                        };
                    }, hn = function(Y1) {
                        return {
                            u_matrix: Y1
                        };
                    }, Ti = function(Y1, z) {
                        return {
                            u_extrude_scale: new i.Uniform1f(Y1, z.u_extrude_scale),
                            u_intensity: new i.Uniform1f(Y1, z.u_intensity),
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix)
                        };
                    }, qi = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_world: new i.Uniform2f(Y1, z.u_world),
                            u_image: new i.Uniform1i(Y1, z.u_image),
                            u_color_ramp: new i.Uniform1i(Y1, z.u_color_ramp),
                            u_opacity: new i.Uniform1f(Y1, z.u_opacity)
                        };
                    }, Ii = function(Y1, z, K, O) {
                        return {
                            u_matrix: Y1,
                            u_extrude_scale: Cs(z, 1, K),
                            u_intensity: O
                        };
                    }, mi = function(Y1, z, K, O) {
                        var $ = i.create();
                        i.ortho($, 0, Y1.width, Y1.height, 0, 0, 1);
                        var pe = Y1.context.gl;
                        return {
                            u_matrix: $,
                            u_world: [
                                pe.drawingBufferWidth,
                                pe.drawingBufferHeight
                            ],
                            u_image: K,
                            u_color_ramp: O,
                            u_opacity: z.paint.get("heatmap-opacity")
                        };
                    }, Pn = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_image: new i.Uniform1i(Y1, z.u_image),
                            u_latrange: new i.Uniform2f(Y1, z.u_latrange),
                            u_light: new i.Uniform2f(Y1, z.u_light),
                            u_shadow: new i.UniformColor(Y1, z.u_shadow),
                            u_highlight: new i.UniformColor(Y1, z.u_highlight),
                            u_accent: new i.UniformColor(Y1, z.u_accent)
                        };
                    }, Ma = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_image: new i.Uniform1i(Y1, z.u_image),
                            u_dimension: new i.Uniform2f(Y1, z.u_dimension),
                            u_zoom: new i.Uniform1f(Y1, z.u_zoom),
                            u_unpack: new i.Uniform4f(Y1, z.u_unpack)
                        };
                    }, Ta = function(Y1, z, K) {
                        var O = K.paint.get("hillshade-shadow-color"), $ = K.paint.get("hillshade-highlight-color"), pe = K.paint.get("hillshade-accent-color"), de = K.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                        K.paint.get("hillshade-illumination-anchor") === "viewport" && (de -= Y1.transform.angle);
                        var Ie = !Y1.options.moving;
                        return {
                            u_matrix: Y1.transform.calculatePosMatrix(z.tileID.toUnwrapped(), Ie),
                            u_image: 0,
                            u_latrange: qa(Y1, z.tileID),
                            u_light: [
                                K.paint.get("hillshade-exaggeration"),
                                de
                            ],
                            u_shadow: O,
                            u_highlight: $,
                            u_accent: pe
                        };
                    }, Ea = function(Y1, z) {
                        var K = z.stride, O = i.create();
                        return i.ortho(O, 0, i.EXTENT, -i.EXTENT, 0, 0, 1), i.translate(O, O, [
                            0,
                            -i.EXTENT,
                            0
                        ]), {
                            u_matrix: O,
                            u_image: 1,
                            u_dimension: [
                                K,
                                K
                            ],
                            u_zoom: Y1.overscaledZ,
                            u_unpack: z.getUnpackVector()
                        };
                    };
                    function qa(Y1, z) {
                        var K = Math.pow(2, z.canonical.z), O = z.canonical.y;
                        return [
                            new i.MercatorCoordinate(0, O / K).toLngLat().lat,
                            new i.MercatorCoordinate(0, (O + 1) / K).toLngLat().lat
                        ];
                    }
                    var Cn = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_ratio: new i.Uniform1f(Y1, z.u_ratio),
                            u_device_pixel_ratio: new i.Uniform1f(Y1, z.u_device_pixel_ratio),
                            u_units_to_pixels: new i.Uniform2f(Y1, z.u_units_to_pixels)
                        };
                    }, sn = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_ratio: new i.Uniform1f(Y1, z.u_ratio),
                            u_device_pixel_ratio: new i.Uniform1f(Y1, z.u_device_pixel_ratio),
                            u_units_to_pixels: new i.Uniform2f(Y1, z.u_units_to_pixels),
                            u_image: new i.Uniform1i(Y1, z.u_image),
                            u_image_height: new i.Uniform1f(Y1, z.u_image_height)
                        };
                    }, Ua = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_texsize: new i.Uniform2f(Y1, z.u_texsize),
                            u_ratio: new i.Uniform1f(Y1, z.u_ratio),
                            u_device_pixel_ratio: new i.Uniform1f(Y1, z.u_device_pixel_ratio),
                            u_image: new i.Uniform1i(Y1, z.u_image),
                            u_units_to_pixels: new i.Uniform2f(Y1, z.u_units_to_pixels),
                            u_scale: new i.Uniform3f(Y1, z.u_scale),
                            u_fade: new i.Uniform1f(Y1, z.u_fade)
                        };
                    }, mo = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_ratio: new i.Uniform1f(Y1, z.u_ratio),
                            u_device_pixel_ratio: new i.Uniform1f(Y1, z.u_device_pixel_ratio),
                            u_units_to_pixels: new i.Uniform2f(Y1, z.u_units_to_pixels),
                            u_patternscale_a: new i.Uniform2f(Y1, z.u_patternscale_a),
                            u_patternscale_b: new i.Uniform2f(Y1, z.u_patternscale_b),
                            u_sdfgamma: new i.Uniform1f(Y1, z.u_sdfgamma),
                            u_image: new i.Uniform1i(Y1, z.u_image),
                            u_tex_y_a: new i.Uniform1f(Y1, z.u_tex_y_a),
                            u_tex_y_b: new i.Uniform1f(Y1, z.u_tex_y_b),
                            u_mix: new i.Uniform1f(Y1, z.u_mix)
                        };
                    }, Xo = function(Y1, z, K) {
                        var O = Y1.transform;
                        return {
                            u_matrix: yl(Y1, z, K),
                            u_ratio: 1 / Cs(z, 1, O.zoom),
                            u_device_pixel_ratio: i.browser.devicePixelRatio,
                            u_units_to_pixels: [
                                1 / O.pixelsToGLUnits[0],
                                1 / O.pixelsToGLUnits[1]
                            ]
                        };
                    }, Ts = function(Y1, z, K, O) {
                        return i.extend(Xo(Y1, z, K), {
                            u_image: 0,
                            u_image_height: O
                        });
                    }, Qo = function(Y1, z, K, O) {
                        var $ = Y1.transform, pe = Bo(z, $);
                        return {
                            u_matrix: yl(Y1, z, K),
                            u_texsize: z.imageAtlasTexture.size,
                            u_ratio: 1 / Cs(z, 1, $.zoom),
                            u_device_pixel_ratio: i.browser.devicePixelRatio,
                            u_image: 0,
                            u_scale: [
                                pe,
                                O.fromScale,
                                O.toScale
                            ],
                            u_fade: O.t,
                            u_units_to_pixels: [
                                1 / $.pixelsToGLUnits[0],
                                1 / $.pixelsToGLUnits[1]
                            ]
                        };
                    }, ys = function(Y1, z, K, O, $) {
                        var pe = Y1.transform, de = Y1.lineAtlas, Ie = Bo(z, pe), $e = K.layout.get("line-cap") === "round", pt = de.getDash(O.from, $e), Kt = de.getDash(O.to, $e), ir = pt.width * $.fromScale, Jt = Kt.width * $.toScale;
                        return i.extend(Xo(Y1, z, K), {
                            u_patternscale_a: [
                                Ie / ir,
                                -pt.height / 2
                            ],
                            u_patternscale_b: [
                                Ie / Jt,
                                -Kt.height / 2
                            ],
                            u_sdfgamma: de.width / (Math.min(ir, Jt) * 256 * i.browser.devicePixelRatio) / 2,
                            u_image: 0,
                            u_tex_y_a: pt.y,
                            u_tex_y_b: Kt.y,
                            u_mix: $.t
                        });
                    };
                    function Bo(Y1, z) {
                        return 1 / Cs(Y1, 1, z.tileZoom);
                    }
                    function yl(Y1, z, K) {
                        return Y1.translatePosMatrix(z.tileID.posMatrix, z, K.paint.get("line-translate"), K.paint.get("line-translate-anchor"));
                    }
                    var Gs = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_tl_parent: new i.Uniform2f(Y1, z.u_tl_parent),
                            u_scale_parent: new i.Uniform1f(Y1, z.u_scale_parent),
                            u_buffer_scale: new i.Uniform1f(Y1, z.u_buffer_scale),
                            u_fade_t: new i.Uniform1f(Y1, z.u_fade_t),
                            u_opacity: new i.Uniform1f(Y1, z.u_opacity),
                            u_image0: new i.Uniform1i(Y1, z.u_image0),
                            u_image1: new i.Uniform1i(Y1, z.u_image1),
                            u_brightness_low: new i.Uniform1f(Y1, z.u_brightness_low),
                            u_brightness_high: new i.Uniform1f(Y1, z.u_brightness_high),
                            u_saturation_factor: new i.Uniform1f(Y1, z.u_saturation_factor),
                            u_contrast_factor: new i.Uniform1f(Y1, z.u_contrast_factor),
                            u_spin_weights: new i.Uniform3f(Y1, z.u_spin_weights)
                        };
                    }, Rs = function(Y1, z, K, O, $) {
                        return {
                            u_matrix: Y1,
                            u_tl_parent: z,
                            u_scale_parent: K,
                            u_buffer_scale: 1,
                            u_fade_t: O.mix,
                            u_opacity: O.opacity * $.paint.get("raster-opacity"),
                            u_image0: 0,
                            u_image1: 1,
                            u_brightness_low: $.paint.get("raster-brightness-min"),
                            u_brightness_high: $.paint.get("raster-brightness-max"),
                            u_saturation_factor: vs($.paint.get("raster-saturation")),
                            u_contrast_factor: Ka($.paint.get("raster-contrast")),
                            u_spin_weights: ia($.paint.get("raster-hue-rotate"))
                        };
                    };
                    function ia(Y1) {
                        Y1 *= Math.PI / 180;
                        var z = Math.sin(Y1), K = Math.cos(Y1);
                        return [
                            (2 * K + 1) / 3,
                            (-Math.sqrt(3) * z - K + 1) / 3,
                            (Math.sqrt(3) * z - K + 1) / 3
                        ];
                    }
                    function Ka(Y1) {
                        return Y1 > 0 ? 1 / (1 - Y1) : 1 + Y1;
                    }
                    function vs(Y1) {
                        return Y1 > 0 ? 1 - 1 / (1.001 - Y1) : -Y1;
                    }
                    var Ko = function(Y1, z) {
                        return {
                            u_is_size_zoom_constant: new i.Uniform1i(Y1, z.u_is_size_zoom_constant),
                            u_is_size_feature_constant: new i.Uniform1i(Y1, z.u_is_size_feature_constant),
                            u_size_t: new i.Uniform1f(Y1, z.u_size_t),
                            u_size: new i.Uniform1f(Y1, z.u_size),
                            u_camera_to_center_distance: new i.Uniform1f(Y1, z.u_camera_to_center_distance),
                            u_pitch: new i.Uniform1f(Y1, z.u_pitch),
                            u_rotate_symbol: new i.Uniform1i(Y1, z.u_rotate_symbol),
                            u_aspect_ratio: new i.Uniform1f(Y1, z.u_aspect_ratio),
                            u_fade_change: new i.Uniform1f(Y1, z.u_fade_change),
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_label_plane_matrix: new i.UniformMatrix4f(Y1, z.u_label_plane_matrix),
                            u_coord_matrix: new i.UniformMatrix4f(Y1, z.u_coord_matrix),
                            u_is_text: new i.Uniform1i(Y1, z.u_is_text),
                            u_pitch_with_map: new i.Uniform1i(Y1, z.u_pitch_with_map),
                            u_texsize: new i.Uniform2f(Y1, z.u_texsize),
                            u_texture: new i.Uniform1i(Y1, z.u_texture)
                        };
                    }, nu = function(Y1, z) {
                        return {
                            u_is_size_zoom_constant: new i.Uniform1i(Y1, z.u_is_size_zoom_constant),
                            u_is_size_feature_constant: new i.Uniform1i(Y1, z.u_is_size_feature_constant),
                            u_size_t: new i.Uniform1f(Y1, z.u_size_t),
                            u_size: new i.Uniform1f(Y1, z.u_size),
                            u_camera_to_center_distance: new i.Uniform1f(Y1, z.u_camera_to_center_distance),
                            u_pitch: new i.Uniform1f(Y1, z.u_pitch),
                            u_rotate_symbol: new i.Uniform1i(Y1, z.u_rotate_symbol),
                            u_aspect_ratio: new i.Uniform1f(Y1, z.u_aspect_ratio),
                            u_fade_change: new i.Uniform1f(Y1, z.u_fade_change),
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_label_plane_matrix: new i.UniformMatrix4f(Y1, z.u_label_plane_matrix),
                            u_coord_matrix: new i.UniformMatrix4f(Y1, z.u_coord_matrix),
                            u_is_text: new i.Uniform1i(Y1, z.u_is_text),
                            u_pitch_with_map: new i.Uniform1i(Y1, z.u_pitch_with_map),
                            u_texsize: new i.Uniform2f(Y1, z.u_texsize),
                            u_texture: new i.Uniform1i(Y1, z.u_texture),
                            u_gamma_scale: new i.Uniform1f(Y1, z.u_gamma_scale),
                            u_device_pixel_ratio: new i.Uniform1f(Y1, z.u_device_pixel_ratio),
                            u_is_halo: new i.Uniform1i(Y1, z.u_is_halo)
                        };
                    }, Ru = function(Y1, z) {
                        return {
                            u_is_size_zoom_constant: new i.Uniform1i(Y1, z.u_is_size_zoom_constant),
                            u_is_size_feature_constant: new i.Uniform1i(Y1, z.u_is_size_feature_constant),
                            u_size_t: new i.Uniform1f(Y1, z.u_size_t),
                            u_size: new i.Uniform1f(Y1, z.u_size),
                            u_camera_to_center_distance: new i.Uniform1f(Y1, z.u_camera_to_center_distance),
                            u_pitch: new i.Uniform1f(Y1, z.u_pitch),
                            u_rotate_symbol: new i.Uniform1i(Y1, z.u_rotate_symbol),
                            u_aspect_ratio: new i.Uniform1f(Y1, z.u_aspect_ratio),
                            u_fade_change: new i.Uniform1f(Y1, z.u_fade_change),
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_label_plane_matrix: new i.UniformMatrix4f(Y1, z.u_label_plane_matrix),
                            u_coord_matrix: new i.UniformMatrix4f(Y1, z.u_coord_matrix),
                            u_is_text: new i.Uniform1i(Y1, z.u_is_text),
                            u_pitch_with_map: new i.Uniform1i(Y1, z.u_pitch_with_map),
                            u_texsize: new i.Uniform2f(Y1, z.u_texsize),
                            u_texsize_icon: new i.Uniform2f(Y1, z.u_texsize_icon),
                            u_texture: new i.Uniform1i(Y1, z.u_texture),
                            u_texture_icon: new i.Uniform1i(Y1, z.u_texture_icon),
                            u_gamma_scale: new i.Uniform1f(Y1, z.u_gamma_scale),
                            u_device_pixel_ratio: new i.Uniform1f(Y1, z.u_device_pixel_ratio),
                            u_is_halo: new i.Uniform1i(Y1, z.u_is_halo)
                        };
                    }, ac = function(Y1, z, K, O, $, pe, de, Ie, $e, pt) {
                        var Kt = $.transform;
                        return {
                            u_is_size_zoom_constant: +(Y1 === "constant" || Y1 === "source"),
                            u_is_size_feature_constant: +(Y1 === "constant" || Y1 === "camera"),
                            u_size_t: z ? z.uSizeT : 0,
                            u_size: z ? z.uSize : 0,
                            u_camera_to_center_distance: Kt.cameraToCenterDistance,
                            u_pitch: Kt.pitch / 360 * 2 * Math.PI,
                            u_rotate_symbol: +K,
                            u_aspect_ratio: Kt.width / Kt.height,
                            u_fade_change: $.options.fadeDuration ? $.symbolFadeChange : 1,
                            u_matrix: pe,
                            u_label_plane_matrix: de,
                            u_coord_matrix: Ie,
                            u_is_text: +$e,
                            u_pitch_with_map: +O,
                            u_texsize: pt,
                            u_texture: 0
                        };
                    }, mf = function(Y1, z, K, O, $, pe, de, Ie, $e, pt, Kt) {
                        var ir = $.transform;
                        return i.extend(ac(Y1, z, K, O, $, pe, de, Ie, $e, pt), {
                            u_gamma_scale: O ? Math.cos(ir._pitch) * ir.cameraToCenterDistance : 1,
                            u_device_pixel_ratio: i.browser.devicePixelRatio,
                            u_is_halo: +Kt
                        });
                    }, bu = function(Y1, z, K, O, $, pe, de, Ie, $e, pt) {
                        return i.extend(mf(Y1, z, K, O, $, pe, de, Ie, !0, $e, !0), {
                            u_texsize_icon: pt,
                            u_texture_icon: 1
                        });
                    }, Kc = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_opacity: new i.Uniform1f(Y1, z.u_opacity),
                            u_color: new i.UniformColor(Y1, z.u_color)
                        };
                    }, Du = function(Y1, z) {
                        return {
                            u_matrix: new i.UniformMatrix4f(Y1, z.u_matrix),
                            u_opacity: new i.Uniform1f(Y1, z.u_opacity),
                            u_image: new i.Uniform1i(Y1, z.u_image),
                            u_pattern_tl_a: new i.Uniform2f(Y1, z.u_pattern_tl_a),
                            u_pattern_br_a: new i.Uniform2f(Y1, z.u_pattern_br_a),
                            u_pattern_tl_b: new i.Uniform2f(Y1, z.u_pattern_tl_b),
                            u_pattern_br_b: new i.Uniform2f(Y1, z.u_pattern_br_b),
                            u_texsize: new i.Uniform2f(Y1, z.u_texsize),
                            u_mix: new i.Uniform1f(Y1, z.u_mix),
                            u_pattern_size_a: new i.Uniform2f(Y1, z.u_pattern_size_a),
                            u_pattern_size_b: new i.Uniform2f(Y1, z.u_pattern_size_b),
                            u_scale_a: new i.Uniform1f(Y1, z.u_scale_a),
                            u_scale_b: new i.Uniform1f(Y1, z.u_scale_b),
                            u_pixel_coord_upper: new i.Uniform2f(Y1, z.u_pixel_coord_upper),
                            u_pixel_coord_lower: new i.Uniform2f(Y1, z.u_pixel_coord_lower),
                            u_tile_units_to_pixels: new i.Uniform1f(Y1, z.u_tile_units_to_pixels)
                        };
                    }, Dc = function(Y1, z, K) {
                        return {
                            u_matrix: Y1,
                            u_opacity: z,
                            u_color: K
                        };
                    }, Da = function(Y1, z, K, O, $, pe) {
                        return i.extend(pf(O, pe, K, $), {
                            u_matrix: Y1,
                            u_opacity: z
                        });
                    }, eo = {
                        fillExtrusion: Ph,
                        fillExtrusionPattern: Dl,
                        fill: Rc,
                        fillPattern: gc,
                        fillOutline: hl,
                        fillOutlinePattern: iu,
                        circle: gt,
                        collisionBox: wr,
                        collisionCircle: vr,
                        debug: xi,
                        clippingMask: Xi,
                        heatmap: Ti,
                        heatmapTexture: qi,
                        hillshade: Pn,
                        hillshadePrepare: Ma,
                        line: Cn,
                        lineGradient: sn,
                        linePattern: Ua,
                        lineSDF: mo,
                        raster: Gs,
                        symbolIcon: Ko,
                        symbolSDF: nu,
                        symbolTextAndIcon: Ru,
                        background: Kc,
                        backgroundPattern: Du
                    }, Jc;
                    function yc(Y1, z, K, O, $, pe, de) {
                        for(var Ie = Y1.context, $e = Ie.gl, pt = Y1.useProgram("collisionBox"), Kt = [], ir = 0, Jt = 0, vt = 0; vt < O.length; vt++){
                            var Pt = O[vt], Wt = z.getTile(Pt), rr = Wt.getBucket(K);
                            if (rr) {
                                var dr = Pt.posMatrix;
                                ($[0] !== 0 || $[1] !== 0) && (dr = Y1.translatePosMatrix(Pt.posMatrix, Wt, $, pe));
                                var pr = de ? rr.textCollisionBox : rr.iconCollisionBox, kr = rr.collisionCircleArray;
                                if (kr.length > 0) {
                                    var Ar = i.create(), gr = dr;
                                    i.mul(Ar, rr.placementInvProjMatrix, Y1.transform.glCoordMatrix), i.mul(Ar, Ar, rr.placementViewportMatrix), Kt.push({
                                        circleArray: kr,
                                        circleOffset: Jt,
                                        transform: gr,
                                        invTransform: Ar
                                    }), ir += kr.length / 4, Jt = ir;
                                }
                                pr && pt.draw(Ie, $e.LINES, Wi.disabled, $i.disabled, Y1.colorModeForRenderPass(), yr.disabled, Ur(dr, Y1.transform, Wt), K.id, pr.layoutVertexBuffer, pr.indexBuffer, pr.segments, null, Y1.transform.zoom, null, null, pr.collisionVertexBuffer);
                            }
                        }
                        if (!(!de || !Kt.length)) {
                            var Cr = Y1.useProgram("collisionCircle"), cr = new i.StructArrayLayout2f1f2i16;
                            cr.resize(ir * 4), cr._trim();
                            for(var Gr = 0, ei = 0, yi = Kt; ei < yi.length; ei += 1)for(var tn = yi[ei], Ri = 0; Ri < tn.circleArray.length / 4; Ri++){
                                var ln = Ri * 4, Qn = tn.circleArray[ln + 0], qn = tn.circleArray[ln + 1], rn = tn.circleArray[ln + 2], bn = tn.circleArray[ln + 3];
                                cr.emplace(Gr++, Qn, qn, rn, bn, 0), cr.emplace(Gr++, Qn, qn, rn, bn, 1), cr.emplace(Gr++, Qn, qn, rn, bn, 2), cr.emplace(Gr++, Qn, qn, rn, bn, 3);
                            }
                            (!Jc || Jc.length < ir * 2) && (Jc = _c(ir));
                            for(var mn = Ie.createIndexBuffer(Jc, !0), Gn = Ie.createVertexBuffer(cr, i.collisionCircleLayout.members, !0), da = 0, No = Kt; da < No.length; da += 1){
                                var Do = No[da], ps = fi(Do.transform, Do.invTransform, Y1.transform);
                                Cr.draw(Ie, $e.TRIANGLES, Wi.disabled, $i.disabled, Y1.colorModeForRenderPass(), yr.disabled, ps, K.id, Gn, mn, i.SegmentVector.simpleSegment(0, Do.circleOffset * 2, Do.circleArray.length, Do.circleArray.length / 2), null, Y1.transform.zoom, null, null, null);
                            }
                            Gn.destroy(), mn.destroy();
                        }
                    }
                    function _c(Y1) {
                        var z = Y1 * 2, K = new i.StructArrayLayout3ui6;
                        K.resize(z), K._trim();
                        for(var O = 0; O < z; O++){
                            var $ = O * 6;
                            K.uint16[$ + 0] = O * 4 + 0, K.uint16[$ + 1] = O * 4 + 1, K.uint16[$ + 2] = O * 4 + 2, K.uint16[$ + 3] = O * 4 + 2, K.uint16[$ + 4] = O * 4 + 3, K.uint16[$ + 5] = O * 4 + 0;
                        }
                        return K;
                    }
                    var le = i.identity(new Float32Array(16));
                    function w(Y1, z, K, O, $) {
                        if (Y1.renderPass === "translucent") {
                            var pe = $i.disabled, de = Y1.colorModeForRenderPass(), Ie = K.layout.get("text-variable-anchor");
                            Ie && Q(O, Y1, K, z, K.layout.get("text-rotation-alignment"), K.layout.get("text-pitch-alignment"), $), K.paint.get("icon-opacity").constantOr(1) !== 0 && qe(Y1, z, K, O, !1, K.paint.get("icon-translate"), K.paint.get("icon-translate-anchor"), K.layout.get("icon-rotation-alignment"), K.layout.get("icon-pitch-alignment"), K.layout.get("icon-keep-upright"), pe, de), K.paint.get("text-opacity").constantOr(1) !== 0 && qe(Y1, z, K, O, !0, K.paint.get("text-translate"), K.paint.get("text-translate-anchor"), K.layout.get("text-rotation-alignment"), K.layout.get("text-pitch-alignment"), K.layout.get("text-keep-upright"), pe, de), z.map.showCollisionBoxes && (yc(Y1, z, K, O, K.paint.get("text-translate"), K.paint.get("text-translate-anchor"), !0), yc(Y1, z, K, O, K.paint.get("icon-translate"), K.paint.get("icon-translate-anchor"), !1));
                        }
                    }
                    function B(Y1, z, K, O, $, pe) {
                        var de = i.getAnchorAlignment(Y1), Ie = de.horizontalAlign, $e = de.verticalAlign, pt = -(Ie - .5) * z, Kt = -($e - .5) * K, ir = i.evaluateVariableOffset(Y1, O);
                        return new i.Point((pt / $ + ir[0]) * pe, (Kt / $ + ir[1]) * pe);
                    }
                    function Q(Y1, z, K, O, $, pe, de) {
                        for(var Ie = z.transform, $e = $ === "map", pt = pe === "map", Kt = 0, ir = Y1; Kt < ir.length; Kt += 1){
                            var Jt = ir[Kt], vt = O.getTile(Jt), Pt = vt.getBucket(K);
                            if (!(!Pt || !Pt.text || !Pt.text.segments.get().length)) {
                                var Wt = Pt.textSizeData, rr = i.evaluateSizeForZoom(Wt, Ie.zoom), dr = Cs(vt, 1, z.transform.zoom), pr = Ji(Jt.posMatrix, pt, $e, z.transform, dr), kr = K.layout.get("icon-text-fit") !== "none" && Pt.hasIconData();
                                if (rr) {
                                    var Ar = Math.pow(2, Ie.zoom - vt.tileID.overscaledZ);
                                    ee(Pt, $e, pt, de, i.symbolSize, Ie, pr, Jt.posMatrix, Ar, rr, kr);
                                }
                            }
                        }
                    }
                    function ee(Y1, z, K, O, $, pe, de, Ie, $e, pt, Kt) {
                        var ir = Y1.text.placedSymbolArray, Jt = Y1.text.dynamicLayoutVertexArray, vt = Y1.icon.dynamicLayoutVertexArray, Pt = {};
                        Jt.clear();
                        for(var Wt = 0; Wt < ir.length; Wt++){
                            var rr = ir.get(Wt), dr = Y1.allowVerticalPlacement && !rr.placedOrientation, pr = !rr.hidden && rr.crossTileID && !dr ? O[rr.crossTileID] : null;
                            if (!pr) Xs(rr.numGlyphs, Jt);
                            else {
                                var kr = new i.Point(rr.anchorX, rr.anchorY), Ar = Fn(kr, K ? Ie : de), gr = Sa(pe.cameraToCenterDistance, Ar.signedDistanceFromCamera), Cr = $.evaluateSizeForFeature(Y1.textSizeData, pt, rr) * gr / i.ONE_EM;
                                K && (Cr *= Y1.tilePixelRatio / $e);
                                for(var cr = pr.width, Gr = pr.height, ei = pr.anchor, yi = pr.textOffset, tn = pr.textBoxScale, Ri = B(ei, cr, Gr, yi, tn, Cr), ln = K ? Fn(kr.add(Ri), de).point : Ar.point.add(z ? Ri.rotate(-pe.angle) : Ri), Qn = Y1.allowVerticalPlacement && rr.placedOrientation === i.WritingMode.vertical ? Math.PI / 2 : 0, qn = 0; qn < rr.numGlyphs; qn++)i.addDynamicAttributes(Jt, ln, Qn);
                                Kt && rr.associatedIconIndex >= 0 && (Pt[rr.associatedIconIndex] = {
                                    shiftedAnchor: ln,
                                    angle: Qn
                                });
                            }
                        }
                        if (Kt) {
                            vt.clear();
                            for(var rn = Y1.icon.placedSymbolArray, bn = 0; bn < rn.length; bn++){
                                var mn = rn.get(bn);
                                if (mn.hidden) Xs(mn.numGlyphs, vt);
                                else {
                                    var Gn = Pt[bn];
                                    if (!Gn) Xs(mn.numGlyphs, vt);
                                    else for(var da = 0; da < mn.numGlyphs; da++)i.addDynamicAttributes(vt, Gn.shiftedAnchor, Gn.angle);
                                }
                            }
                            Y1.icon.dynamicLayoutVertexBuffer.updateData(vt);
                        }
                        Y1.text.dynamicLayoutVertexBuffer.updateData(Jt);
                    }
                    function se(Y1, z, K) {
                        return K.iconsInText && z ? "symbolTextAndIcon" : Y1 ? "symbolSDF" : "symbolIcon";
                    }
                    function qe(Y1, z, K, O, $, pe, de, Ie, $e, pt, Kt, ir) {
                        for(var Jt = Y1.context, vt = Jt.gl, Pt = Y1.transform, Wt = Ie === "map", rr = $e === "map", dr = Wt && K.layout.get("symbol-placement") !== "point", pr = Wt && !rr && !dr, kr = K.layout.get("symbol-sort-key").constantOr(1) !== void 0, Ar = !1, gr = Y1.depthModeForSublayer(0, Wi.ReadOnly), Cr = K.layout.get("text-variable-anchor"), cr = [], Gr = 0, ei = O; Gr < ei.length; Gr += 1){
                            var yi = ei[Gr], tn = z.getTile(yi), Ri = tn.getBucket(K);
                            if (Ri) {
                                var ln = $ ? Ri.text : Ri.icon;
                                if (!(!ln || !ln.segments.get().length)) {
                                    var Qn = ln.programConfigurations.get(K.id), qn = $ || Ri.sdfIcons, rn = $ ? Ri.textSizeData : Ri.iconSizeData, bn = rr || Pt.pitch !== 0, mn = Y1.useProgram(se(qn, $, Ri), Qn), Gn = i.evaluateSizeForZoom(rn, Pt.zoom), da = void 0, No = [
                                        0,
                                        0
                                    ], Do = void 0, ps = void 0, fo = null, as = void 0;
                                    if ($) {
                                        if (Do = tn.glyphAtlasTexture, ps = vt.LINEAR, da = tn.glyphAtlasTexture.size, Ri.iconsInText) {
                                            No = tn.imageAtlasTexture.size, fo = tn.imageAtlasTexture;
                                            var tl = rn.kind === "composite" || rn.kind === "camera";
                                            as = bn || Y1.options.rotating || Y1.options.zooming || tl ? vt.LINEAR : vt.NEAREST;
                                        }
                                    } else {
                                        var zu = K.layout.get("icon-size").constantOr(0) !== 1 || Ri.iconsNeedLinear;
                                        Do = tn.imageAtlasTexture, ps = qn || Y1.options.rotating || Y1.options.zooming || zu || bn ? vt.LINEAR : vt.NEAREST, da = tn.imageAtlasTexture.size;
                                    }
                                    var Mv = Cs(tn, 1, Y1.transform.zoom), Ev = Ji(yi.posMatrix, rr, Wt, Y1.transform, Mv), yd = ua(yi.posMatrix, rr, Wt, Y1.transform, Mv), Yv = Cr && Ri.hasTextData(), cg = K.layout.get("icon-text-fit") !== "none" && Yv && Ri.hasIconData();
                                    dr && Oo(Ri, yi.posMatrix, Y1, $, Ev, yd, rr, pt);
                                    var vp = Y1.translatePosMatrix(yi.posMatrix, tn, pe, de), _d = dr || $ && Cr || cg ? le : Ev, pp = Y1.translatePosMatrix(yd, tn, pe, de, !0), Nd = qn && K.paint.get($ ? "text-halo-width" : "icon-halo-width").constantOr(1) !== 0, xd = void 0;
                                    qn ? Ri.iconsInText ? xd = bu(rn.kind, Gn, pr, rr, Y1, vp, _d, pp, da, No) : xd = mf(rn.kind, Gn, pr, rr, Y1, vp, _d, pp, $, da, !0) : xd = ac(rn.kind, Gn, pr, rr, Y1, vp, _d, pp, $, da);
                                    var kv = {
                                        program: mn,
                                        buffers: ln,
                                        uniformValues: xd,
                                        atlasTexture: Do,
                                        atlasTextureIcon: fo,
                                        atlasInterpolation: ps,
                                        atlasInterpolationIcon: as,
                                        isSDF: qn,
                                        hasHalo: Nd
                                    };
                                    if (kr && Ri.canOverlap) {
                                        Ar = !0;
                                        for(var Kv = ln.segments.get(), Cv = 0, ny = Kv; Cv < ny.length; Cv += 1){
                                            var fg = ny[Cv];
                                            cr.push({
                                                segments: new i.SegmentVector([
                                                    fg
                                                ]),
                                                sortKey: fg.sortKey,
                                                state: kv
                                            });
                                        }
                                    } else cr.push({
                                        segments: ln.segments,
                                        sortKey: 0,
                                        state: kv
                                    });
                                }
                            }
                        }
                        Ar && cr.sort(function(w1, T1) {
                            return w1.sortKey - T1.sortKey;
                        });
                        for(var Hf = 0, hg = cr; Hf < hg.length; Hf += 1){
                            var ay = hg[Hf], Rh = ay.state;
                            if (Jt.activeTexture.set(vt.TEXTURE0), Rh.atlasTexture.bind(Rh.atlasInterpolation, vt.CLAMP_TO_EDGE), Rh.atlasTextureIcon && (Jt.activeTexture.set(vt.TEXTURE1), Rh.atlasTextureIcon && Rh.atlasTextureIcon.bind(Rh.atlasInterpolationIcon, vt.CLAMP_TO_EDGE)), Rh.isSDF) {
                                var rm = Rh.uniformValues;
                                Rh.hasHalo && (rm.u_is_halo = 1, je(Rh.buffers, ay.segments, K, Y1, Rh.program, gr, Kt, ir, rm)), rm.u_is_halo = 0;
                            }
                            je(Rh.buffers, ay.segments, K, Y1, Rh.program, gr, Kt, ir, Rh.uniformValues);
                        }
                    }
                    function je(Y1, z, K, O, $, pe, de, Ie, $e) {
                        var pt = O.context, Kt = pt.gl;
                        $.draw(pt, Kt.TRIANGLES, pe, de, Ie, yr.disabled, $e, K.id, Y1.layoutVertexBuffer, Y1.indexBuffer, z, K.paint, O.transform.zoom, Y1.programConfigurations.get(K.id), Y1.dynamicLayoutVertexBuffer, Y1.opacityVertexBuffer);
                    }
                    function it(Y1, z, K, O) {
                        if (Y1.renderPass === "translucent") {
                            var $ = K.paint.get("circle-opacity"), pe = K.paint.get("circle-stroke-width"), de = K.paint.get("circle-stroke-opacity"), Ie = K.layout.get("circle-sort-key").constantOr(1) !== void 0;
                            if (!($.constantOr(1) === 0 && (pe.constantOr(1) === 0 || de.constantOr(1) === 0))) {
                                for(var $e = Y1.context, pt = $e.gl, Kt = Y1.depthModeForSublayer(0, Wi.ReadOnly), ir = $i.disabled, Jt = Y1.colorModeForRenderPass(), vt = [], Pt = 0; Pt < O.length; Pt++){
                                    var Wt = O[Pt], rr = z.getTile(Wt), dr = rr.getBucket(K);
                                    if (dr) {
                                        var pr = dr.programConfigurations.get(K.id), kr = Y1.useProgram("circle", pr), Ar = dr.layoutVertexBuffer, gr = dr.indexBuffer, Cr = Bt(Y1, Wt, rr, K), cr = {
                                            programConfiguration: pr,
                                            program: kr,
                                            layoutVertexBuffer: Ar,
                                            indexBuffer: gr,
                                            uniformValues: Cr
                                        };
                                        if (Ie) for(var Gr = dr.segments.get(), ei = 0, yi = Gr; ei < yi.length; ei += 1){
                                            var tn = yi[ei];
                                            vt.push({
                                                segments: new i.SegmentVector([
                                                    tn
                                                ]),
                                                sortKey: tn.sortKey,
                                                state: cr
                                            });
                                        }
                                        else vt.push({
                                            segments: dr.segments,
                                            sortKey: 0,
                                            state: cr
                                        });
                                    }
                                }
                                Ie && vt.sort(function(Do, ps) {
                                    return Do.sortKey - ps.sortKey;
                                });
                                for(var Ri = 0, ln = vt; Ri < ln.length; Ri += 1){
                                    var Qn = ln[Ri], qn = Qn.state, rn = qn.programConfiguration, bn = qn.program, mn = qn.layoutVertexBuffer, Gn = qn.indexBuffer, da = qn.uniformValues, No = Qn.segments;
                                    bn.draw($e, pt.TRIANGLES, Kt, ir, Jt, yr.disabled, da, K.id, mn, Gn, No, K.paint, Y1.transform.zoom, rn);
                                }
                            }
                        }
                    }
                    function yt(Y1, z, K, O) {
                        if (K.paint.get("heatmap-opacity") !== 0) {
                            if (Y1.renderPass === "offscreen") {
                                var $ = Y1.context, pe = $.gl, de = $i.disabled, Ie = new ft([
                                    pe.ONE,
                                    pe.ONE
                                ], i.Color.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                Ot($, Y1, K), $.clear({
                                    color: i.Color.transparent
                                });
                                for(var $e = 0; $e < O.length; $e++){
                                    var pt = O[$e];
                                    if (!z.hasRenderableParent(pt)) {
                                        var Kt = z.getTile(pt), ir = Kt.getBucket(K);
                                        if (ir) {
                                            var Jt = ir.programConfigurations.get(K.id), vt = Y1.useProgram("heatmap", Jt), Pt = Y1.transform, Wt = Pt.zoom;
                                            vt.draw($, pe.TRIANGLES, Wi.disabled, de, Ie, yr.disabled, Ii(pt.posMatrix, Kt, Wt, K.paint.get("heatmap-intensity")), K.id, ir.layoutVertexBuffer, ir.indexBuffer, ir.segments, K.paint, Y1.transform.zoom, Jt);
                                        }
                                    }
                                }
                                $.viewport.set([
                                    0,
                                    0,
                                    Y1.width,
                                    Y1.height
                                ]);
                            } else Y1.renderPass === "translucent" && (Y1.context.setColorMode(Y1.colorModeForRenderPass()), hr(Y1, K));
                        }
                    }
                    function Ot(Y1, z, K) {
                        var O = Y1.gl;
                        Y1.activeTexture.set(O.TEXTURE1), Y1.viewport.set([
                            0,
                            0,
                            z.width / 4,
                            z.height / 4
                        ]);
                        var $ = K.heatmapFbo;
                        if ($) O.bindTexture(O.TEXTURE_2D, $.colorAttachment.get()), Y1.bindFramebuffer.set($.framebuffer);
                        else {
                            var pe = O.createTexture();
                            O.bindTexture(O.TEXTURE_2D, pe), O.texParameteri(O.TEXTURE_2D, O.TEXTURE_WRAP_S, O.CLAMP_TO_EDGE), O.texParameteri(O.TEXTURE_2D, O.TEXTURE_WRAP_T, O.CLAMP_TO_EDGE), O.texParameteri(O.TEXTURE_2D, O.TEXTURE_MIN_FILTER, O.LINEAR), O.texParameteri(O.TEXTURE_2D, O.TEXTURE_MAG_FILTER, O.LINEAR), $ = K.heatmapFbo = Y1.createFramebuffer(z.width / 4, z.height / 4, !1), Nt(Y1, z, pe, $);
                        }
                    }
                    function Nt(Y1, z, K, O) {
                        var $ = Y1.gl, pe = Y1.extRenderToTextureHalfFloat ? Y1.extTextureHalfFloat.HALF_FLOAT_OES : $.UNSIGNED_BYTE;
                        $.texImage2D($.TEXTURE_2D, 0, $.RGBA, z.width / 4, z.height / 4, 0, $.RGBA, pe, null), O.colorAttachment.set(K);
                    }
                    function hr(Y1, z) {
                        var K = Y1.context, O = K.gl, $ = z.heatmapFbo;
                        if ($) {
                            K.activeTexture.set(O.TEXTURE0), O.bindTexture(O.TEXTURE_2D, $.colorAttachment.get()), K.activeTexture.set(O.TEXTURE1);
                            var pe = z.colorRampTexture;
                            pe || (pe = z.colorRampTexture = new i.Texture(K, z.colorRamp, O.RGBA)), pe.bind(O.LINEAR, O.CLAMP_TO_EDGE), Y1.useProgram("heatmapTexture").draw(K, O.TRIANGLES, Wi.disabled, $i.disabled, Y1.colorModeForRenderPass(), yr.disabled, mi(Y1, z, 0, 1), z.id, Y1.viewportBuffer, Y1.quadTriangleIndexBuffer, Y1.viewportSegments, z.paint, Y1.transform.zoom);
                        }
                    }
                    function Sr(Y1, z, K, O) {
                        if (Y1.renderPass === "translucent") {
                            var $ = K.paint.get("line-opacity"), pe = K.paint.get("line-width");
                            if (!($.constantOr(1) === 0 || pe.constantOr(1) === 0)) for(var de = Y1.depthModeForSublayer(0, Wi.ReadOnly), Ie = Y1.colorModeForRenderPass(), $e = K.paint.get("line-dasharray"), pt = K.paint.get("line-pattern"), Kt = pt.constantOr(1), ir = K.paint.get("line-gradient"), Jt = K.getCrossfadeParameters(), vt = Kt ? "linePattern" : $e ? "lineSDF" : ir ? "lineGradient" : "line", Pt = Y1.context, Wt = Pt.gl, rr = !0, dr = 0, pr = O; dr < pr.length; dr += 1){
                                var kr = pr[dr], Ar = z.getTile(kr);
                                if (!(Kt && !Ar.patternsLoaded())) {
                                    var gr = Ar.getBucket(K);
                                    if (gr) {
                                        var Cr = gr.programConfigurations.get(K.id), cr = Y1.context.program.get(), Gr = Y1.useProgram(vt, Cr), ei = rr || Gr.program !== cr, yi = pt.constantOr(null);
                                        if (yi && Ar.imageAtlas) {
                                            var tn = Ar.imageAtlas, Ri = tn.patternPositions[yi.to.toString()], ln = tn.patternPositions[yi.from.toString()];
                                            Ri && ln && Cr.setConstantPatternPositions(Ri, ln);
                                        }
                                        var Qn = Kt ? Qo(Y1, Ar, K, Jt) : $e ? ys(Y1, Ar, K, $e, Jt) : ir ? Ts(Y1, Ar, K, gr.lineClipsArray.length) : Xo(Y1, Ar, K);
                                        if (Kt) Pt.activeTexture.set(Wt.TEXTURE0), Ar.imageAtlasTexture.bind(Wt.LINEAR, Wt.CLAMP_TO_EDGE), Cr.updatePaintBuffers(Jt);
                                        else if ($e && (ei || Y1.lineAtlas.dirty)) Pt.activeTexture.set(Wt.TEXTURE0), Y1.lineAtlas.bind(Pt);
                                        else if (ir) {
                                            var qn = gr.gradients[K.id], rn = qn.texture;
                                            if (K.gradientVersion !== qn.version) {
                                                var bn = 256;
                                                if (K.stepInterpolant) {
                                                    var mn = z.getSource().maxzoom, Gn = kr.canonical.z === mn ? Math.ceil(1 << Y1.transform.maxZoom - kr.canonical.z) : 1, da = gr.maxLineLength / i.EXTENT, No = 1024, Do = da * No * Gn;
                                                    bn = i.clamp(i.nextPowerOfTwo(Do), 256, Pt.maxTextureSize);
                                                }
                                                qn.gradient = i.renderColorRamp({
                                                    expression: K.gradientExpression(),
                                                    evaluationKey: "lineProgress",
                                                    resolution: bn,
                                                    image: qn.gradient || void 0,
                                                    clips: gr.lineClipsArray
                                                }), qn.texture ? qn.texture.update(qn.gradient) : qn.texture = new i.Texture(Pt, qn.gradient, Wt.RGBA), qn.version = K.gradientVersion, rn = qn.texture;
                                            }
                                            Pt.activeTexture.set(Wt.TEXTURE0), rn.bind(K.stepInterpolant ? Wt.NEAREST : Wt.LINEAR, Wt.CLAMP_TO_EDGE);
                                        }
                                        Gr.draw(Pt, Wt.TRIANGLES, de, Y1.stencilModeForClipping(kr), Ie, yr.disabled, Qn, K.id, gr.layoutVertexBuffer, gr.indexBuffer, gr.segments, K.paint, Y1.transform.zoom, Cr, gr.layoutVertexBuffer2), rr = !1;
                                    }
                                }
                            }
                        }
                    }
                    function he(Y1, z, K, O) {
                        var $ = K.paint.get("fill-color"), pe = K.paint.get("fill-opacity");
                        if (pe.constantOr(1) !== 0) {
                            var de = Y1.colorModeForRenderPass(), Ie = K.paint.get("fill-pattern"), $e = Y1.opaquePassEnabledForLayer() && !Ie.constantOr(1) && $.constantOr(i.Color.transparent).a === 1 && pe.constantOr(0) === 1 ? "opaque" : "translucent";
                            if (Y1.renderPass === $e) {
                                var pt = Y1.depthModeForSublayer(1, Y1.renderPass === "opaque" ? Wi.ReadWrite : Wi.ReadOnly);
                                be(Y1, z, K, O, pt, de, !1);
                            }
                            if (Y1.renderPass === "translucent" && K.paint.get("fill-antialias")) {
                                var Kt = Y1.depthModeForSublayer(K.getPaintProperty("fill-outline-color") ? 2 : 0, Wi.ReadOnly);
                                be(Y1, z, K, O, Kt, de, !0);
                            }
                        }
                    }
                    function be(Y1, z, K, O, $, pe, de) {
                        var Ie = Y1.context.gl, $e = K.paint.get("fill-pattern"), pt = $e && $e.constantOr(1), Kt = K.getCrossfadeParameters(), ir, Jt, vt, Pt, Wt;
                        de ? (Jt = pt && !K.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", ir = Ie.LINES) : (Jt = pt ? "fillPattern" : "fill", ir = Ie.TRIANGLES);
                        for(var rr = 0, dr = O; rr < dr.length; rr += 1){
                            var pr = dr[rr], kr = z.getTile(pr);
                            if (!(pt && !kr.patternsLoaded())) {
                                var Ar = kr.getBucket(K);
                                if (Ar) {
                                    var gr = Ar.programConfigurations.get(K.id), Cr = Y1.useProgram(Jt, gr);
                                    pt && (Y1.context.activeTexture.set(Ie.TEXTURE0), kr.imageAtlasTexture.bind(Ie.LINEAR, Ie.CLAMP_TO_EDGE), gr.updatePaintBuffers(Kt));
                                    var cr = $e.constantOr(null);
                                    if (cr && kr.imageAtlas) {
                                        var Gr = kr.imageAtlas, ei = Gr.patternPositions[cr.to.toString()], yi = Gr.patternPositions[cr.from.toString()];
                                        ei && yi && gr.setConstantPatternPositions(ei, yi);
                                    }
                                    var tn = Y1.translatePosMatrix(pr.posMatrix, kr, K.paint.get("fill-translate"), K.paint.get("fill-translate-anchor"));
                                    if (!de) Pt = Ar.indexBuffer, Wt = Ar.segments, vt = pt ? Yc(tn, Y1, Kt, kr) : mc(tn);
                                    else {
                                        Pt = Ar.indexBuffer2, Wt = Ar.segments2;
                                        var Ri = [
                                            Ie.drawingBufferWidth,
                                            Ie.drawingBufferHeight
                                        ];
                                        vt = Jt === "fillOutlinePattern" && pt ? gf(tn, Y1, Kt, kr, Ri) : nc(tn, Ri);
                                    }
                                    Cr.draw(Y1.context, ir, $, Y1.stencilModeForClipping(pr), pe, yr.disabled, vt, K.id, Ar.layoutVertexBuffer, Pt, Wt, K.paint, Y1.transform.zoom, gr);
                                }
                            }
                        }
                    }
                    function Pe(Y1, z, K, O) {
                        var $ = K.paint.get("fill-extrusion-opacity");
                        if ($ !== 0 && Y1.renderPass === "translucent") {
                            var pe = new Wi(Y1.context.gl.LEQUAL, Wi.ReadWrite, Y1.depthRangeFor3D);
                            if ($ === 1 && !K.paint.get("fill-extrusion-pattern").constantOr(1)) {
                                var de = Y1.colorModeForRenderPass();
                                Oe(Y1, z, K, O, pe, $i.disabled, de);
                            } else Oe(Y1, z, K, O, pe, $i.disabled, ft.disabled), Oe(Y1, z, K, O, pe, Y1.stencilModeFor3D(), Y1.colorModeForRenderPass());
                        }
                    }
                    function Oe(Y1, z, K, O, $, pe, de) {
                        for(var Ie = Y1.context, $e = Ie.gl, pt = K.paint.get("fill-extrusion-pattern"), Kt = pt.constantOr(1), ir = K.getCrossfadeParameters(), Jt = K.paint.get("fill-extrusion-opacity"), vt = 0, Pt = O; vt < Pt.length; vt += 1){
                            var Wt = Pt[vt], rr = z.getTile(Wt), dr = rr.getBucket(K);
                            if (dr) {
                                var pr = dr.programConfigurations.get(K.id), kr = Y1.useProgram(Kt ? "fillExtrusionPattern" : "fillExtrusion", pr);
                                Kt && (Y1.context.activeTexture.set($e.TEXTURE0), rr.imageAtlasTexture.bind($e.LINEAR, $e.CLAMP_TO_EDGE), pr.updatePaintBuffers(ir));
                                var Ar = pt.constantOr(null);
                                if (Ar && rr.imageAtlas) {
                                    var gr = rr.imageAtlas, Cr = gr.patternPositions[Ar.to.toString()], cr = gr.patternPositions[Ar.from.toString()];
                                    Cr && cr && pr.setConstantPatternPositions(Cr, cr);
                                }
                                var Gr = Y1.translatePosMatrix(Wt.posMatrix, rr, K.paint.get("fill-extrusion-translate"), K.paint.get("fill-extrusion-translate-anchor")), ei = K.paint.get("fill-extrusion-vertical-gradient"), yi = Kt ? Wu(Gr, Y1, ei, Jt, Wt, ir, rr) : Ih(Gr, Y1, ei, Jt);
                                kr.draw(Ie, Ie.gl.TRIANGLES, $, pe, de, yr.backCCW, yi, K.id, dr.layoutVertexBuffer, dr.indexBuffer, dr.segments, K.paint, Y1.transform.zoom, pr);
                            }
                        }
                    }
                    function Je(Y1, z, K, O) {
                        if (!(Y1.renderPass !== "offscreen" && Y1.renderPass !== "translucent")) {
                            for(var $ = Y1.context, pe = Y1.depthModeForSublayer(0, Wi.ReadOnly), de = Y1.colorModeForRenderPass(), Ie = Y1.renderPass === "translucent" ? Y1.stencilConfigForOverlap(O) : [
                                {},
                                O
                            ], $e = Ie[0], pt = Ie[1], Kt = 0, ir = pt; Kt < ir.length; Kt += 1){
                                var Jt = ir[Kt], vt = z.getTile(Jt);
                                vt.needsHillshadePrepare && Y1.renderPass === "offscreen" ? et(Y1, vt, K, pe, $i.disabled, de) : Y1.renderPass === "translucent" && He(Y1, vt, K, pe, $e[Jt.overscaledZ], de);
                            }
                            $.viewport.set([
                                0,
                                0,
                                Y1.width,
                                Y1.height
                            ]);
                        }
                    }
                    function He(Y1, z, K, O, $, pe) {
                        var de = Y1.context, Ie = de.gl, $e = z.fbo;
                        if ($e) {
                            var pt = Y1.useProgram("hillshade");
                            de.activeTexture.set(Ie.TEXTURE0), Ie.bindTexture(Ie.TEXTURE_2D, $e.colorAttachment.get());
                            var Kt = Ta(Y1, z, K);
                            pt.draw(de, Ie.TRIANGLES, O, $, pe, yr.disabled, Kt, K.id, Y1.rasterBoundsBuffer, Y1.quadTriangleIndexBuffer, Y1.rasterBoundsSegments);
                        }
                    }
                    function et(Y1, z, K, O, $, pe) {
                        var de = Y1.context, Ie = de.gl, $e = z.dem;
                        if ($e && $e.data) {
                            var pt = $e.dim, Kt = $e.stride, ir = $e.getPixels();
                            if (de.activeTexture.set(Ie.TEXTURE1), de.pixelStoreUnpackPremultiplyAlpha.set(!1), z.demTexture = z.demTexture || Y1.getTileTexture(Kt), z.demTexture) {
                                var Jt = z.demTexture;
                                Jt.update(ir, {
                                    premultiply: !1
                                }), Jt.bind(Ie.NEAREST, Ie.CLAMP_TO_EDGE);
                            } else z.demTexture = new i.Texture(de, ir, Ie.RGBA, {
                                premultiply: !1
                            }), z.demTexture.bind(Ie.NEAREST, Ie.CLAMP_TO_EDGE);
                            de.activeTexture.set(Ie.TEXTURE0);
                            var vt = z.fbo;
                            if (!vt) {
                                var Pt = new i.Texture(de, {
                                    width: pt,
                                    height: pt,
                                    data: null
                                }, Ie.RGBA);
                                Pt.bind(Ie.LINEAR, Ie.CLAMP_TO_EDGE), vt = z.fbo = de.createFramebuffer(pt, pt, !0), vt.colorAttachment.set(Pt.texture);
                            }
                            de.bindFramebuffer.set(vt.framebuffer), de.viewport.set([
                                0,
                                0,
                                pt,
                                pt
                            ]), Y1.useProgram("hillshadePrepare").draw(de, Ie.TRIANGLES, O, $, pe, yr.disabled, Ea(z.tileID, $e), K.id, Y1.rasterBoundsBuffer, Y1.quadTriangleIndexBuffer, Y1.rasterBoundsSegments), z.needsHillshadePrepare = !1;
                        }
                    }
                    function Mt(Y1, z, K, O) {
                        if (Y1.renderPass === "translucent" && K.paint.get("raster-opacity") !== 0 && O.length) for(var $ = Y1.context, pe = $.gl, de = z.getSource(), Ie = Y1.useProgram("raster"), $e = Y1.colorModeForRenderPass(), pt = de instanceof ke ? [
                            {},
                            O
                        ] : Y1.stencilConfigForOverlap(O), Kt = pt[0], ir = pt[1], Jt = ir[ir.length - 1].overscaledZ, vt = !Y1.options.moving, Pt = 0, Wt = ir; Pt < Wt.length; Pt += 1){
                            var rr = Wt[Pt], dr = Y1.depthModeForSublayer(rr.overscaledZ - Jt, K.paint.get("raster-opacity") === 1 ? Wi.ReadWrite : Wi.ReadOnly, pe.LESS), pr = z.getTile(rr), kr = Y1.transform.calculatePosMatrix(rr.toUnwrapped(), vt);
                            pr.registerFadeDuration(K.paint.get("raster-fade-duration"));
                            var Ar = z.findLoadedParent(rr, 0), gr = Dt(pr, Ar, z, K, Y1.transform), Cr = void 0, cr = void 0, Gr = K.paint.get("raster-resampling") === "nearest" ? pe.NEAREST : pe.LINEAR;
                            $.activeTexture.set(pe.TEXTURE0), pr.texture.bind(Gr, pe.CLAMP_TO_EDGE, pe.LINEAR_MIPMAP_NEAREST), $.activeTexture.set(pe.TEXTURE1), Ar ? (Ar.texture.bind(Gr, pe.CLAMP_TO_EDGE, pe.LINEAR_MIPMAP_NEAREST), Cr = Math.pow(2, Ar.tileID.overscaledZ - pr.tileID.overscaledZ), cr = [
                                pr.tileID.canonical.x * Cr % 1,
                                pr.tileID.canonical.y * Cr % 1
                            ]) : pr.texture.bind(Gr, pe.CLAMP_TO_EDGE, pe.LINEAR_MIPMAP_NEAREST);
                            var ei = Rs(kr, cr || [
                                0,
                                0
                            ], Cr || 1, gr, K);
                            de instanceof ke ? Ie.draw($, pe.TRIANGLES, dr, $i.disabled, $e, yr.disabled, ei, K.id, de.boundsBuffer, Y1.quadTriangleIndexBuffer, de.boundsSegments) : Ie.draw($, pe.TRIANGLES, dr, Kt[rr.overscaledZ], $e, yr.disabled, ei, K.id, Y1.rasterBoundsBuffer, Y1.quadTriangleIndexBuffer, Y1.rasterBoundsSegments);
                        }
                    }
                    function Dt(Y1, z, K, O, $) {
                        var pe = O.paint.get("raster-fade-duration");
                        if (pe > 0) {
                            var de = i.browser.now(), Ie = (de - Y1.timeAdded) / pe, $e = z ? (de - z.timeAdded) / pe : -1, pt = K.getSource(), Kt = $.coveringZoomLevel({
                                tileSize: pt.tileSize,
                                roundZoom: pt.roundZoom
                            }), ir = !z || Math.abs(z.tileID.overscaledZ - Kt) > Math.abs(Y1.tileID.overscaledZ - Kt), Jt = ir && Y1.refreshedUponExpiration ? 1 : i.clamp(ir ? Ie : 1 - $e, 0, 1);
                            return Y1.refreshedUponExpiration && Ie >= 1 && (Y1.refreshedUponExpiration = !1), z ? {
                                opacity: 1,
                                mix: 1 - Jt
                            } : {
                                opacity: Jt,
                                mix: 0
                            };
                        } else return {
                            opacity: 1,
                            mix: 0
                        };
                    }
                    function Ut(Y1, z, K) {
                        var O = K.paint.get("background-color"), $ = K.paint.get("background-opacity");
                        if ($ !== 0) {
                            var pe = Y1.context, de = pe.gl, Ie = Y1.transform, $e = Ie.tileSize, pt = K.paint.get("background-pattern");
                            if (!Y1.isPatternMissing(pt)) {
                                var Kt = !pt && O.a === 1 && $ === 1 && Y1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                                if (Y1.renderPass === Kt) {
                                    var ir = $i.disabled, Jt = Y1.depthModeForSublayer(0, Kt === "opaque" ? Wi.ReadWrite : Wi.ReadOnly), vt = Y1.colorModeForRenderPass(), Pt = Y1.useProgram(pt ? "backgroundPattern" : "background"), Wt = Ie.coveringTiles({
                                        tileSize: $e
                                    });
                                    pt && (pe.activeTexture.set(de.TEXTURE0), Y1.imageManager.bind(Y1.context));
                                    for(var rr = K.getCrossfadeParameters(), dr = 0, pr = Wt; dr < pr.length; dr += 1){
                                        var kr = pr[dr], Ar = Y1.transform.calculatePosMatrix(kr.toUnwrapped()), gr = pt ? Da(Ar, $, Y1, pt, {
                                            tileID: kr,
                                            tileSize: $e
                                        }, rr) : Dc(Ar, $, O);
                                        Pt.draw(pe, de.TRIANGLES, Jt, ir, vt, yr.disabled, gr, K.id, Y1.tileExtentBuffer, Y1.quadTriangleIndexBuffer, Y1.tileExtentSegments);
                                    }
                                }
                            }
                        }
                    }
                    var tr = new i.Color(1, 0, 0, 1), mr = new i.Color(0, 1, 0, 1), Rr = new i.Color(0, 0, 1, 1), zr = new i.Color(1, 0, 1, 1), Xr = new i.Color(0, 1, 1, 1);
                    function di(Y1) {
                        var z = Y1.transform.padding, K = 3;
                        Ci(Y1, Y1.transform.height - (z.top || 0), K, tr), Ci(Y1, z.bottom || 0, K, mr), Qi(Y1, z.left || 0, K, Rr), Qi(Y1, Y1.transform.width - (z.right || 0), K, zr);
                        var O = Y1.transform.centerPoint;
                        Li(Y1, O.x, Y1.transform.height - O.y, Xr);
                    }
                    function Li(Y1, z, K, O) {
                        var $ = 20, pe = 2;
                        Mn(Y1, z - pe / 2, K - $ / 2, pe, $, O), Mn(Y1, z - $ / 2, K - pe / 2, $, pe, O);
                    }
                    function Ci(Y1, z, K, O) {
                        Mn(Y1, 0, z + K / 2, Y1.transform.width, K, O);
                    }
                    function Qi(Y1, z, K, O) {
                        Mn(Y1, z - K / 2, 0, K, Y1.transform.height, O);
                    }
                    function Mn(Y1, z, K, O, $, pe) {
                        var de = Y1.context, Ie = de.gl;
                        Ie.enable(Ie.SCISSOR_TEST), Ie.scissor(z * i.browser.devicePixelRatio, K * i.browser.devicePixelRatio, O * i.browser.devicePixelRatio, $ * i.browser.devicePixelRatio), de.clear({
                            color: pe
                        }), Ie.disable(Ie.SCISSOR_TEST);
                    }
                    function pa(Y1, z, K) {
                        for(var O = 0; O < K.length; O++)ea(Y1, z, K[O]);
                    }
                    function ea(Y1, z, K) {
                        var O = Y1.context, $ = O.gl, pe = K.posMatrix, de = Y1.useProgram("debug"), Ie = Wi.disabled, $e = $i.disabled, pt = Y1.colorModeForRenderPass(), Kt = "$debug";
                        O.activeTexture.set($.TEXTURE0), Y1.emptyTexture.bind($.LINEAR, $.CLAMP_TO_EDGE), de.draw(O, $.LINE_STRIP, Ie, $e, pt, yr.disabled, Fi(pe, i.Color.red), Kt, Y1.debugBuffer, Y1.tileBorderIndexBuffer, Y1.debugSegments);
                        var ir = z.getTileByID(K.key).latestRawTileData, Jt = ir && ir.byteLength || 0, vt = Math.floor(Jt / 1024), Pt = z.getTile(K).tileSize, Wt = 512 / Math.min(Pt, 512) * (K.overscaledZ / Y1.transform.zoom) * .5, rr = K.canonical.toString();
                        K.overscaledZ !== K.canonical.z && (rr += " => " + K.overscaledZ);
                        var dr = rr + " " + vt + "kb";
                        Ga(Y1, dr), de.draw(O, $.TRIANGLES, Ie, $e, ft.alphaBlended, yr.disabled, Fi(pe, i.Color.transparent, Wt), Kt, Y1.debugBuffer, Y1.quadTriangleIndexBuffer, Y1.debugSegments);
                    }
                    function Ga(Y1, z) {
                        Y1.initDebugOverlayCanvas();
                        var K = Y1.debugOverlayCanvas, O = Y1.context.gl, $ = Y1.debugOverlayCanvas.getContext("2d");
                        $.clearRect(0, 0, K.width, K.height), $.shadowColor = "white", $.shadowBlur = 2, $.lineWidth = 1.5, $.strokeStyle = "white", $.textBaseline = "top", $.font = "bold 36px Open Sans, sans-serif", $.fillText(z, 5, 5), $.strokeText(z, 5, 5), Y1.debugOverlayTexture.update(K), Y1.debugOverlayTexture.bind(O.LINEAR, O.CLAMP_TO_EDGE);
                    }
                    function To(Y1, z, K) {
                        var O = Y1.context, $ = K.implementation;
                        if (Y1.renderPass === "offscreen") {
                            var pe = $.prerender;
                            pe && (Y1.setCustomLayerDefaults(), O.setColorMode(Y1.colorModeForRenderPass()), pe.call($, O.gl, Y1.transform.customLayerMatrix()), O.setDirty(), Y1.setBaseState());
                        } else if (Y1.renderPass === "translucent") {
                            Y1.setCustomLayerDefaults(), O.setColorMode(Y1.colorModeForRenderPass()), O.setStencilMode($i.disabled);
                            var de = $.renderingMode === "3d" ? new Wi(Y1.context.gl.LEQUAL, Wi.ReadWrite, Y1.depthRangeFor3D) : Y1.depthModeForSublayer(0, Wi.ReadOnly);
                            O.setDepthMode(de), $.render(O.gl, Y1.transform.customLayerMatrix()), O.setDirty(), Y1.setBaseState(), O.bindFramebuffer.set(null);
                        }
                    }
                    var Wa = {
                        symbol: w,
                        circle: it,
                        heatmap: yt,
                        line: Sr,
                        fill: he,
                        "fill-extrusion": Pe,
                        hillshade: Je,
                        raster: Mt,
                        background: Ut,
                        debug: pa,
                        custom: To
                    }, co = function(z, K) {
                        this.context = new Fr(z), this.transform = K, this._tileTextures = {}, this.setup(), this.numSublayers = Zr.maxUnderzooming + Zr.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new rh, this.gpuTimers = {};
                    };
                    co.prototype.resize = function(z, K) {
                        if (this.width = z * i.browser.devicePixelRatio, this.height = K * i.browser.devicePixelRatio, this.context.viewport.set([
                            0,
                            0,
                            this.width,
                            this.height
                        ]), this.style) for(var O = 0, $ = this.style._order; O < $.length; O += 1){
                            var pe = $[O];
                            this.style._layers[pe].resize();
                        }
                    }, co.prototype.setup = function() {
                        var z = this.context, K = new i.StructArrayLayout2i4;
                        K.emplaceBack(0, 0), K.emplaceBack(i.EXTENT, 0), K.emplaceBack(0, i.EXTENT), K.emplaceBack(i.EXTENT, i.EXTENT), this.tileExtentBuffer = z.createVertexBuffer(K, kc.members), this.tileExtentSegments = i.SegmentVector.simpleSegment(0, 0, 4, 2);
                        var O = new i.StructArrayLayout2i4;
                        O.emplaceBack(0, 0), O.emplaceBack(i.EXTENT, 0), O.emplaceBack(0, i.EXTENT), O.emplaceBack(i.EXTENT, i.EXTENT), this.debugBuffer = z.createVertexBuffer(O, kc.members), this.debugSegments = i.SegmentVector.simpleSegment(0, 0, 4, 5);
                        var $ = new i.StructArrayLayout4i8;
                        $.emplaceBack(0, 0, 0, 0), $.emplaceBack(i.EXTENT, 0, i.EXTENT, 0), $.emplaceBack(0, i.EXTENT, 0, i.EXTENT), $.emplaceBack(i.EXTENT, i.EXTENT, i.EXTENT, i.EXTENT), this.rasterBoundsBuffer = z.createVertexBuffer($, Me.members), this.rasterBoundsSegments = i.SegmentVector.simpleSegment(0, 0, 4, 2);
                        var pe = new i.StructArrayLayout2i4;
                        pe.emplaceBack(0, 0), pe.emplaceBack(1, 0), pe.emplaceBack(0, 1), pe.emplaceBack(1, 1), this.viewportBuffer = z.createVertexBuffer(pe, kc.members), this.viewportSegments = i.SegmentVector.simpleSegment(0, 0, 4, 2);
                        var de = new i.StructArrayLayout1ui2;
                        de.emplaceBack(0), de.emplaceBack(1), de.emplaceBack(3), de.emplaceBack(2), de.emplaceBack(0), this.tileBorderIndexBuffer = z.createIndexBuffer(de);
                        var Ie = new i.StructArrayLayout3ui6;
                        Ie.emplaceBack(0, 1, 2), Ie.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = z.createIndexBuffer(Ie), this.emptyTexture = new i.Texture(z, {
                            width: 1,
                            height: 1,
                            data: new Uint8Array([
                                0,
                                0,
                                0,
                                0
                            ])
                        }, z.gl.RGBA);
                        var $e = this.context.gl;
                        this.stencilClearMode = new $i({
                            func: $e.ALWAYS,
                            mask: 0
                        }, 0, 255, $e.ZERO, $e.ZERO, $e.ZERO);
                    }, co.prototype.clearStencil = function() {
                        var z = this.context, K = z.gl;
                        this.nextStencilID = 1, this.currentStencilSource = void 0;
                        var O = i.create();
                        i.ortho(O, 0, this.width, this.height, 0, 0, 1), i.scale(O, O, [
                            K.drawingBufferWidth,
                            K.drawingBufferHeight,
                            0
                        ]), this.useProgram("clippingMask").draw(z, K.TRIANGLES, Wi.disabled, this.stencilClearMode, ft.disabled, yr.disabled, hn(O), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
                    }, co.prototype._renderTileClippingMasks = function(z, K) {
                        if (!(this.currentStencilSource === z.source || !z.isTileClipped() || !K || !K.length)) {
                            this.currentStencilSource = z.source;
                            var O = this.context, $ = O.gl;
                            this.nextStencilID + K.length > 256 && this.clearStencil(), O.setColorMode(ft.disabled), O.setDepthMode(Wi.disabled);
                            var pe = this.useProgram("clippingMask");
                            this._tileClippingMaskIDs = {};
                            for(var de = 0, Ie = K; de < Ie.length; de += 1){
                                var $e = Ie[de], pt = this._tileClippingMaskIDs[$e.key] = this.nextStencilID++;
                                pe.draw(O, $.TRIANGLES, Wi.disabled, new $i({
                                    func: $.ALWAYS,
                                    mask: 0
                                }, pt, 255, $.KEEP, $.KEEP, $.REPLACE), ft.disabled, yr.disabled, hn($e.posMatrix), "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                            }
                        }
                    }, co.prototype.stencilModeFor3D = function() {
                        this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                        var z = this.nextStencilID++, K = this.context.gl;
                        return new $i({
                            func: K.NOTEQUAL,
                            mask: 255
                        }, z, 255, K.KEEP, K.KEEP, K.REPLACE);
                    }, co.prototype.stencilModeForClipping = function(z) {
                        var K = this.context.gl;
                        return new $i({
                            func: K.EQUAL,
                            mask: 255
                        }, this._tileClippingMaskIDs[z.key], 0, K.KEEP, K.KEEP, K.REPLACE);
                    }, co.prototype.stencilConfigForOverlap = function(z) {
                        var K, O = this.context.gl, $ = z.sort(function(pt, Kt) {
                            return Kt.overscaledZ - pt.overscaledZ;
                        }), pe = $[$.length - 1].overscaledZ, de = $[0].overscaledZ - pe + 1;
                        if (de > 1) {
                            this.currentStencilSource = void 0, this.nextStencilID + de > 256 && this.clearStencil();
                            for(var Ie = {}, $e = 0; $e < de; $e++)Ie[$e + pe] = new $i({
                                func: O.GEQUAL,
                                mask: 255
                            }, $e + this.nextStencilID, 255, O.KEEP, O.KEEP, O.REPLACE);
                            return this.nextStencilID += de, [
                                Ie,
                                $
                            ];
                        }
                        return [
                            (K = {}, K[pe] = $i.disabled, K),
                            $
                        ];
                    }, co.prototype.colorModeForRenderPass = function() {
                        var z = this.context.gl;
                        if (this._showOverdrawInspector) {
                            var K = 8, O = 1 / K;
                            return new ft([
                                z.CONSTANT_COLOR,
                                z.ONE
                            ], new i.Color(O, O, O, 0), [
                                !0,
                                !0,
                                !0,
                                !0
                            ]);
                        } else return this.renderPass === "opaque" ? ft.unblended : ft.alphaBlended;
                    }, co.prototype.depthModeForSublayer = function(z, K, O) {
                        if (!this.opaquePassEnabledForLayer()) return Wi.disabled;
                        var $ = 1 - ((1 + this.currentLayer) * this.numSublayers + z) * this.depthEpsilon;
                        return new Wi(O || this.context.gl.LEQUAL, K, [
                            $,
                            $
                        ]);
                    }, co.prototype.opaquePassEnabledForLayer = function() {
                        return this.currentLayer < this.opaquePassCutoff;
                    }, co.prototype.render = function(z, K) {
                        var O = this;
                        this.style = z, this.options = K, this.lineAtlas = z.lineAtlas, this.imageManager = z.imageManager, this.glyphManager = z.glyphManager, this.symbolFadeChange = z.placement.symbolFadeChange(i.browser.now()), this.imageManager.beginFrame();
                        var $ = this.style._order, pe = this.style.sourceCaches;
                        for(var de in pe){
                            var Ie = pe[de];
                            Ie.used && Ie.prepare(this.context);
                        }
                        var $e = {}, pt = {}, Kt = {};
                        for(var ir in pe){
                            var Jt = pe[ir];
                            $e[ir] = Jt.getVisibleCoordinates(), pt[ir] = $e[ir].slice().reverse(), Kt[ir] = Jt.getVisibleCoordinates(!0).reverse();
                        }
                        this.opaquePassCutoff = 1 / 0;
                        for(var vt = 0; vt < $.length; vt++){
                            var Pt = $[vt];
                            if (this.style._layers[Pt].is3D()) {
                                this.opaquePassCutoff = vt;
                                break;
                            }
                        }
                        this.renderPass = "offscreen";
                        for(var Wt = 0, rr = $; Wt < rr.length; Wt += 1){
                            var dr = rr[Wt], pr = this.style._layers[dr];
                            if (!(!pr.hasOffscreenPass() || pr.isHidden(this.transform.zoom))) {
                                var kr = pt[pr.source];
                                pr.type !== "custom" && !kr.length || this.renderLayer(this, pe[pr.source], pr, kr);
                            }
                        }
                        for(this.context.bindFramebuffer.set(null), this.context.clear({
                            color: K.showOverdrawInspector ? i.Color.black : i.Color.transparent,
                            depth: 1
                        }), this.clearStencil(), this._showOverdrawInspector = K.showOverdrawInspector, this.depthRangeFor3D = [
                            0,
                            1 - (z._order.length + 2) * this.numSublayers * this.depthEpsilon
                        ], this.renderPass = "opaque", this.currentLayer = $.length - 1; this.currentLayer >= 0; this.currentLayer--){
                            var Ar = this.style._layers[$[this.currentLayer]], gr = pe[Ar.source], Cr = $e[Ar.source];
                            this._renderTileClippingMasks(Ar, Cr), this.renderLayer(this, gr, Ar, Cr);
                        }
                        for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < $.length; this.currentLayer++){
                            var cr = this.style._layers[$[this.currentLayer]], Gr = pe[cr.source], ei = (cr.type === "symbol" ? Kt : pt)[cr.source];
                            this._renderTileClippingMasks(cr, $e[cr.source]), this.renderLayer(this, Gr, cr, ei);
                        }
                        if (this.options.showTileBoundaries) {
                            var yi, tn, Ri = i.values(this.style._layers);
                            Ri.forEach(function(ln) {
                                ln.source && !ln.isHidden(O.transform.zoom) && (ln.source !== (tn && tn.id) && (tn = O.style.sourceCaches[ln.source]), (!yi || yi.getSource().maxzoom < tn.getSource().maxzoom) && (yi = tn));
                            }), yi && Wa.debug(this, yi, yi.getVisibleCoordinates());
                        }
                        this.options.showPadding && di(this), this.context.setDefault();
                    }, co.prototype.renderLayer = function(z, K, O, $) {
                        O.isHidden(this.transform.zoom) || O.type !== "background" && O.type !== "custom" && !$.length || (this.id = O.id, this.gpuTimingStart(O), Wa[O.type](z, K, O, $, this.style.placement.variableOffsets), this.gpuTimingEnd());
                    }, co.prototype.gpuTimingStart = function(z) {
                        if (this.options.gpuTiming) {
                            var K = this.context.extTimerQuery, O = this.gpuTimers[z.id];
                            O || (O = this.gpuTimers[z.id] = {
                                calls: 0,
                                cpuTime: 0,
                                query: K.createQueryEXT()
                            }), O.calls++, K.beginQueryEXT(K.TIME_ELAPSED_EXT, O.query);
                        }
                    }, co.prototype.gpuTimingEnd = function() {
                        if (this.options.gpuTiming) {
                            var z = this.context.extTimerQuery;
                            z.endQueryEXT(z.TIME_ELAPSED_EXT);
                        }
                    }, co.prototype.collectGpuTimers = function() {
                        var z = this.gpuTimers;
                        return this.gpuTimers = {}, z;
                    }, co.prototype.queryGpuTimers = function(z) {
                        var K = {};
                        for(var O in z){
                            var $ = z[O], pe = this.context.extTimerQuery, de = pe.getQueryObjectEXT($.query, pe.QUERY_RESULT_EXT) / 1000000;
                            pe.deleteQueryEXT($.query), K[O] = de;
                        }
                        return K;
                    }, co.prototype.translatePosMatrix = function(z, K, O, $, pe) {
                        if (!O[0] && !O[1]) return z;
                        var de = pe ? $ === "map" ? this.transform.angle : 0 : $ === "viewport" ? -this.transform.angle : 0;
                        if (de) {
                            var Ie = Math.sin(de), $e = Math.cos(de);
                            O = [
                                O[0] * $e - O[1] * Ie,
                                O[0] * Ie + O[1] * $e
                            ];
                        }
                        var pt = [
                            pe ? O[0] : Cs(K, O[0], this.transform.zoom),
                            pe ? O[1] : Cs(K, O[1], this.transform.zoom),
                            0
                        ], Kt = new Float32Array(16);
                        return i.translate(Kt, z, pt), Kt;
                    }, co.prototype.saveTileTexture = function(z) {
                        var K = this._tileTextures[z.size[0]];
                        K ? K.push(z) : this._tileTextures[z.size[0]] = [
                            z
                        ];
                    }, co.prototype.getTileTexture = function(z) {
                        var K = this._tileTextures[z];
                        return K && K.length > 0 ? K.pop() : null;
                    }, co.prototype.isPatternMissing = function(z) {
                        if (!z) return !1;
                        if (!z.from || !z.to) return !0;
                        var K = this.imageManager.getPattern(z.from.toString()), O = this.imageManager.getPattern(z.to.toString());
                        return !K || !O;
                    }, co.prototype.useProgram = function(z, K) {
                        this.cache = this.cache || {};
                        var O = "" + z + (K ? K.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "");
                        return this.cache[O] || (this.cache[O] = new Vf(this.context, z, Pf[z], K, eo[z], this._showOverdrawInspector)), this.cache[O];
                    }, co.prototype.setCustomLayerDefaults = function() {
                        this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
                    }, co.prototype.setBaseState = function() {
                        var z = this.context.gl;
                        this.context.cullFace.set(!1), this.context.viewport.set([
                            0,
                            0,
                            this.width,
                            this.height
                        ]), this.context.blendEquation.set(z.FUNC_ADD);
                    }, co.prototype.initDebugOverlayCanvas = function() {
                        if (this.debugOverlayCanvas == null) {
                            this.debugOverlayCanvas = i.window.document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512;
                            var z = this.context.gl;
                            this.debugOverlayTexture = new i.Texture(this.context, this.debugOverlayCanvas, z.RGBA);
                        }
                    }, co.prototype.destroy = function() {
                        this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy();
                    };
                    var Ro = function(z, K) {
                        this.points = z, this.planes = K;
                    };
                    Ro.fromInvProjectionMatrix = function(z, K, O) {
                        var $ = [
                            [
                                -1,
                                1,
                                -1,
                                1
                            ],
                            [
                                1,
                                1,
                                -1,
                                1
                            ],
                            [
                                1,
                                -1,
                                -1,
                                1
                            ],
                            [
                                -1,
                                -1,
                                -1,
                                1
                            ],
                            [
                                -1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                -1,
                                1,
                                1
                            ],
                            [
                                -1,
                                -1,
                                1,
                                1
                            ]
                        ], pe = Math.pow(2, O), de = $.map(function(pt) {
                            return i.transformMat4([], pt, z);
                        }).map(function(pt) {
                            return i.scale$1([], pt, 1 / pt[3] / K * pe);
                        }), Ie = [
                            [
                                0,
                                1,
                                2
                            ],
                            [
                                6,
                                5,
                                4
                            ],
                            [
                                0,
                                3,
                                7
                            ],
                            [
                                2,
                                1,
                                5
                            ],
                            [
                                3,
                                2,
                                6
                            ],
                            [
                                0,
                                4,
                                5
                            ]
                        ], $e = Ie.map(function(pt) {
                            var Kt = i.sub([], de[pt[0]], de[pt[1]]), ir = i.sub([], de[pt[2]], de[pt[1]]), Jt = i.normalize([], i.cross([], Kt, ir)), vt = -i.dot(Jt, de[pt[1]]);
                            return Jt.concat(vt);
                        });
                        return new Ro(de, $e);
                    };
                    var Ds = function(z, K) {
                        this.min = z, this.max = K, this.center = i.scale$2([], i.add([], this.min, this.max), .5);
                    };
                    Ds.prototype.quadrant = function(z) {
                        for(var K = [
                            z % 2 === 0,
                            z < 2
                        ], O = i.clone$2(this.min), $ = i.clone$2(this.max), pe = 0; pe < K.length; pe++)O[pe] = K[pe] ? this.min[pe] : this.center[pe], $[pe] = K[pe] ? this.center[pe] : this.max[pe];
                        return $[2] = this.max[2], new Ds(O, $);
                    }, Ds.prototype.distanceX = function(z) {
                        var K = Math.max(Math.min(this.max[0], z[0]), this.min[0]);
                        return K - z[0];
                    }, Ds.prototype.distanceY = function(z) {
                        var K = Math.max(Math.min(this.max[1], z[1]), this.min[1]);
                        return K - z[1];
                    }, Ds.prototype.intersects = function(z) {
                        for(var K = [
                            [
                                this.min[0],
                                this.min[1],
                                0,
                                1
                            ],
                            [
                                this.max[0],
                                this.min[1],
                                0,
                                1
                            ],
                            [
                                this.max[0],
                                this.max[1],
                                0,
                                1
                            ],
                            [
                                this.min[0],
                                this.max[1],
                                0,
                                1
                            ]
                        ], O = !0, $ = 0; $ < z.planes.length; $++){
                            for(var pe = z.planes[$], de = 0, Ie = 0; Ie < K.length; Ie++)de += i.dot$1(pe, K[Ie]) >= 0;
                            if (de === 0) return 0;
                            de !== K.length && (O = !1);
                        }
                        if (O) return 2;
                        for(var $e = 0; $e < 3; $e++){
                            for(var pt = Number.MAX_VALUE, Kt = -Number.MAX_VALUE, ir = 0; ir < z.points.length; ir++){
                                var Jt = z.points[ir][$e] - this.min[$e];
                                pt = Math.min(pt, Jt), Kt = Math.max(Kt, Jt);
                            }
                            if (Kt < 0 || pt > this.max[$e] - this.min[$e]) return 0;
                        }
                        return 1;
                    };
                    var As = function(z, K, O, $) {
                        if (z === void 0 && (z = 0), K === void 0 && (K = 0), O === void 0 && (O = 0), $ === void 0 && ($ = 0), isNaN(z) || z < 0 || isNaN(K) || K < 0 || isNaN(O) || O < 0 || isNaN($) || $ < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                        this.top = z, this.bottom = K, this.left = O, this.right = $;
                    };
                    As.prototype.interpolate = function(z, K, O) {
                        return K.top != null && z.top != null && (this.top = i.number(z.top, K.top, O)), K.bottom != null && z.bottom != null && (this.bottom = i.number(z.bottom, K.bottom, O)), K.left != null && z.left != null && (this.left = i.number(z.left, K.left, O)), K.right != null && z.right != null && (this.right = i.number(z.right, K.right, O)), this;
                    }, As.prototype.getCenter = function(z, K) {
                        var O = i.clamp((this.left + z - this.right) / 2, 0, z), $ = i.clamp((this.top + K - this.bottom) / 2, 0, K);
                        return new i.Point(O, $);
                    }, As.prototype.equals = function(z) {
                        return this.top === z.top && this.bottom === z.bottom && this.left === z.left && this.right === z.right;
                    }, As.prototype.clone = function() {
                        return new As(this.top, this.bottom, this.left, this.right);
                    }, As.prototype.toJSON = function() {
                        return {
                            top: this.top,
                            bottom: this.bottom,
                            left: this.left,
                            right: this.right
                        };
                    };
                    var yo = function(z, K, O, $, pe) {
                        this.tileSize = 512, this.maxValidLatitude = 85.051129, this._renderWorldCopies = pe === void 0 ? !0 : pe, this._minZoom = z || 0, this._maxZoom = K || 22, this._minPitch = O == null ? 0 : O, this._maxPitch = $ == null ? 60 : $, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new i.LngLat(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new As, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
                    }, po = {
                        minZoom: {
                            configurable: !0
                        },
                        maxZoom: {
                            configurable: !0
                        },
                        minPitch: {
                            configurable: !0
                        },
                        maxPitch: {
                            configurable: !0
                        },
                        renderWorldCopies: {
                            configurable: !0
                        },
                        worldSize: {
                            configurable: !0
                        },
                        centerOffset: {
                            configurable: !0
                        },
                        size: {
                            configurable: !0
                        },
                        bearing: {
                            configurable: !0
                        },
                        pitch: {
                            configurable: !0
                        },
                        fov: {
                            configurable: !0
                        },
                        zoom: {
                            configurable: !0
                        },
                        center: {
                            configurable: !0
                        },
                        padding: {
                            configurable: !0
                        },
                        centerPoint: {
                            configurable: !0
                        },
                        unmodified: {
                            configurable: !0
                        },
                        point: {
                            configurable: !0
                        }
                    };
                    yo.prototype.clone = function() {
                        var z = new yo(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
                        return z.tileSize = this.tileSize, z.latRange = this.latRange, z.width = this.width, z.height = this.height, z._center = this._center, z.zoom = this.zoom, z.angle = this.angle, z._fov = this._fov, z._pitch = this._pitch, z._unmodified = this._unmodified, z._edgeInsets = this._edgeInsets.clone(), z._calcMatrices(), z;
                    }, po.minZoom.get = function() {
                        return this._minZoom;
                    }, po.minZoom.set = function(Y1) {
                        this._minZoom !== Y1 && (this._minZoom = Y1, this.zoom = Math.max(this.zoom, Y1));
                    }, po.maxZoom.get = function() {
                        return this._maxZoom;
                    }, po.maxZoom.set = function(Y1) {
                        this._maxZoom !== Y1 && (this._maxZoom = Y1, this.zoom = Math.min(this.zoom, Y1));
                    }, po.minPitch.get = function() {
                        return this._minPitch;
                    }, po.minPitch.set = function(Y1) {
                        this._minPitch !== Y1 && (this._minPitch = Y1, this.pitch = Math.max(this.pitch, Y1));
                    }, po.maxPitch.get = function() {
                        return this._maxPitch;
                    }, po.maxPitch.set = function(Y1) {
                        this._maxPitch !== Y1 && (this._maxPitch = Y1, this.pitch = Math.min(this.pitch, Y1));
                    }, po.renderWorldCopies.get = function() {
                        return this._renderWorldCopies;
                    }, po.renderWorldCopies.set = function(Y1) {
                        Y1 === void 0 ? Y1 = !0 : Y1 === null && (Y1 = !1), this._renderWorldCopies = Y1;
                    }, po.worldSize.get = function() {
                        return this.tileSize * this.scale;
                    }, po.centerOffset.get = function() {
                        return this.centerPoint._sub(this.size._div(2));
                    }, po.size.get = function() {
                        return new i.Point(this.width, this.height);
                    }, po.bearing.get = function() {
                        return -this.angle / Math.PI * 180;
                    }, po.bearing.set = function(Y1) {
                        var z = -i.wrap(Y1, -180, 180) * Math.PI / 180;
                        this.angle !== z && (this._unmodified = !1, this.angle = z, this._calcMatrices(), this.rotationMatrix = i.create$2(), i.rotate(this.rotationMatrix, this.rotationMatrix, this.angle));
                    }, po.pitch.get = function() {
                        return this._pitch / Math.PI * 180;
                    }, po.pitch.set = function(Y1) {
                        var z = i.clamp(Y1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                        this._pitch !== z && (this._unmodified = !1, this._pitch = z, this._calcMatrices());
                    }, po.fov.get = function() {
                        return this._fov / Math.PI * 180;
                    }, po.fov.set = function(Y1) {
                        Y1 = Math.max(.01, Math.min(60, Y1)), this._fov !== Y1 && (this._unmodified = !1, this._fov = Y1 / 180 * Math.PI, this._calcMatrices());
                    }, po.zoom.get = function() {
                        return this._zoom;
                    }, po.zoom.set = function(Y1) {
                        var z = Math.min(Math.max(Y1, this.minZoom), this.maxZoom);
                        this._zoom !== z && (this._unmodified = !1, this._zoom = z, this.scale = this.zoomScale(z), this.tileZoom = Math.floor(z), this.zoomFraction = z - this.tileZoom, this._constrain(), this._calcMatrices());
                    }, po.center.get = function() {
                        return this._center;
                    }, po.center.set = function(Y1) {
                        Y1.lat === this._center.lat && Y1.lng === this._center.lng || (this._unmodified = !1, this._center = Y1, this._constrain(), this._calcMatrices());
                    }, po.padding.get = function() {
                        return this._edgeInsets.toJSON();
                    }, po.padding.set = function(Y1) {
                        this._edgeInsets.equals(Y1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, Y1, 1), this._calcMatrices());
                    }, po.centerPoint.get = function() {
                        return this._edgeInsets.getCenter(this.width, this.height);
                    }, yo.prototype.isPaddingEqual = function(z) {
                        return this._edgeInsets.equals(z);
                    }, yo.prototype.interpolatePadding = function(z, K, O) {
                        this._unmodified = !1, this._edgeInsets.interpolate(z, K, O), this._constrain(), this._calcMatrices();
                    }, yo.prototype.coveringZoomLevel = function(z) {
                        var K = (z.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / z.tileSize));
                        return Math.max(0, K);
                    }, yo.prototype.getVisibleUnwrappedCoordinates = function(z) {
                        var K = [
                            new i.UnwrappedTileID(0, z)
                        ];
                        if (this._renderWorldCopies) for(var O = this.pointCoordinate(new i.Point(0, 0)), $ = this.pointCoordinate(new i.Point(this.width, 0)), pe = this.pointCoordinate(new i.Point(this.width, this.height)), de = this.pointCoordinate(new i.Point(0, this.height)), Ie = Math.floor(Math.min(O.x, $.x, pe.x, de.x)), $e = Math.floor(Math.max(O.x, $.x, pe.x, de.x)), pt = 1, Kt = Ie - pt; Kt <= $e + pt; Kt++)Kt !== 0 && K.push(new i.UnwrappedTileID(Kt, z));
                        return K;
                    }, yo.prototype.coveringTiles = function(z) {
                        var K = this.coveringZoomLevel(z), O = K;
                        if (z.minzoom !== void 0 && K < z.minzoom) return [];
                        z.maxzoom !== void 0 && K > z.maxzoom && (K = z.maxzoom);
                        var $ = i.MercatorCoordinate.fromLngLat(this.center), pe = Math.pow(2, K), de = [
                            pe * $.x,
                            pe * $.y,
                            0
                        ], Ie = Ro.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, K), $e = z.minzoom || 0;
                        this.pitch <= 60 && this._edgeInsets.top < .1 && ($e = K);
                        var pt = 3, Kt = function(Ri) {
                            return {
                                aabb: new Ds([
                                    Ri * pe,
                                    0,
                                    0
                                ], [
                                    (Ri + 1) * pe,
                                    pe,
                                    0
                                ]),
                                zoom: 0,
                                x: 0,
                                y: 0,
                                wrap: Ri,
                                fullyVisible: !1
                            };
                        }, ir = [], Jt = [], vt = K, Pt = z.reparseOverscaled ? O : K;
                        if (this._renderWorldCopies) for(var Wt = 1; Wt <= 3; Wt++)ir.push(Kt(-Wt)), ir.push(Kt(Wt));
                        for(ir.push(Kt(0)); ir.length > 0;){
                            var rr = ir.pop(), dr = rr.x, pr = rr.y, kr = rr.fullyVisible;
                            if (!kr) {
                                var Ar = rr.aabb.intersects(Ie);
                                if (Ar === 0) continue;
                                kr = Ar === 2;
                            }
                            var gr = rr.aabb.distanceX(de), Cr = rr.aabb.distanceY(de), cr = Math.max(Math.abs(gr), Math.abs(Cr)), Gr = pt + (1 << vt - rr.zoom) - 2;
                            if (rr.zoom === vt || cr > Gr && rr.zoom >= $e) {
                                Jt.push({
                                    tileID: new i.OverscaledTileID(rr.zoom === vt ? Pt : rr.zoom, rr.wrap, rr.zoom, dr, pr),
                                    distanceSq: i.sqrLen([
                                        de[0] - .5 - dr,
                                        de[1] - .5 - pr
                                    ])
                                });
                                continue;
                            }
                            for(var ei = 0; ei < 4; ei++){
                                var yi = (dr << 1) + ei % 2, tn = (pr << 1) + (ei >> 1);
                                ir.push({
                                    aabb: rr.aabb.quadrant(ei),
                                    zoom: rr.zoom + 1,
                                    x: yi,
                                    y: tn,
                                    wrap: rr.wrap,
                                    fullyVisible: kr
                                });
                            }
                        }
                        return Jt.sort(function(Ri, ln) {
                            return Ri.distanceSq - ln.distanceSq;
                        }).map(function(Ri) {
                            return Ri.tileID;
                        });
                    }, yo.prototype.resize = function(z, K) {
                        this.width = z, this.height = K, this.pixelsToGLUnits = [
                            2 / z,
                            -2 / K
                        ], this._constrain(), this._calcMatrices();
                    }, po.unmodified.get = function() {
                        return this._unmodified;
                    }, yo.prototype.zoomScale = function(z) {
                        return Math.pow(2, z);
                    }, yo.prototype.scaleZoom = function(z) {
                        return Math.log(z) / Math.LN2;
                    }, yo.prototype.project = function(z) {
                        var K = i.clamp(z.lat, -this.maxValidLatitude, this.maxValidLatitude);
                        return new i.Point(i.mercatorXfromLng(z.lng) * this.worldSize, i.mercatorYfromLat(K) * this.worldSize);
                    }, yo.prototype.unproject = function(z) {
                        return new i.MercatorCoordinate(z.x / this.worldSize, z.y / this.worldSize).toLngLat();
                    }, po.point.get = function() {
                        return this.project(this.center);
                    }, yo.prototype.setLocationAtPoint = function(z, K) {
                        var O = this.pointCoordinate(K), $ = this.pointCoordinate(this.centerPoint), pe = this.locationCoordinate(z), de = new i.MercatorCoordinate(pe.x - (O.x - $.x), pe.y - (O.y - $.y));
                        this.center = this.coordinateLocation(de), this._renderWorldCopies && (this.center = this.center.wrap());
                    }, yo.prototype.locationPoint = function(z) {
                        return this.coordinatePoint(this.locationCoordinate(z));
                    }, yo.prototype.pointLocation = function(z) {
                        return this.coordinateLocation(this.pointCoordinate(z));
                    }, yo.prototype.locationCoordinate = function(z) {
                        return i.MercatorCoordinate.fromLngLat(z);
                    }, yo.prototype.coordinateLocation = function(z) {
                        return z.toLngLat();
                    }, yo.prototype.pointCoordinate = function(z) {
                        var K = 0, O = [
                            z.x,
                            z.y,
                            0,
                            1
                        ], $ = [
                            z.x,
                            z.y,
                            1,
                            1
                        ];
                        i.transformMat4(O, O, this.pixelMatrixInverse), i.transformMat4($, $, this.pixelMatrixInverse);
                        var pe = O[3], de = $[3], Ie = O[0] / pe, $e = $[0] / de, pt = O[1] / pe, Kt = $[1] / de, ir = O[2] / pe, Jt = $[2] / de, vt = ir === Jt ? 0 : (K - ir) / (Jt - ir);
                        return new i.MercatorCoordinate(i.number(Ie, $e, vt) / this.worldSize, i.number(pt, Kt, vt) / this.worldSize);
                    }, yo.prototype.coordinatePoint = function(z) {
                        var K = [
                            z.x * this.worldSize,
                            z.y * this.worldSize,
                            0,
                            1
                        ];
                        return i.transformMat4(K, K, this.pixelMatrix), new i.Point(K[0] / K[3], K[1] / K[3]);
                    }, yo.prototype.getBounds = function() {
                        return new i.LngLatBounds().extend(this.pointLocation(new i.Point(0, 0))).extend(this.pointLocation(new i.Point(this.width, 0))).extend(this.pointLocation(new i.Point(this.width, this.height))).extend(this.pointLocation(new i.Point(0, this.height)));
                    }, yo.prototype.getMaxBounds = function() {
                        return !this.latRange || this.latRange.length !== 2 || !this.lngRange || this.lngRange.length !== 2 ? null : new i.LngLatBounds([
                            this.lngRange[0],
                            this.latRange[0]
                        ], [
                            this.lngRange[1],
                            this.latRange[1]
                        ]);
                    }, yo.prototype.setMaxBounds = function(z) {
                        z ? (this.lngRange = [
                            z.getWest(),
                            z.getEast()
                        ], this.latRange = [
                            z.getSouth(),
                            z.getNorth()
                        ], this._constrain()) : (this.lngRange = null, this.latRange = [
                            -this.maxValidLatitude,
                            this.maxValidLatitude
                        ]);
                    }, yo.prototype.calculatePosMatrix = function(z, K) {
                        K === void 0 && (K = !1);
                        var O = z.key, $ = K ? this._alignedPosMatrixCache : this._posMatrixCache;
                        if ($[O]) return $[O];
                        var pe = z.canonical, de = this.worldSize / this.zoomScale(pe.z), Ie = pe.x + Math.pow(2, pe.z) * z.wrap, $e = i.identity(new Float64Array(16));
                        return i.translate($e, $e, [
                            Ie * de,
                            pe.y * de,
                            0
                        ]), i.scale($e, $e, [
                            de / i.EXTENT,
                            de / i.EXTENT,
                            1
                        ]), i.multiply($e, K ? this.alignedProjMatrix : this.projMatrix, $e), $[O] = new Float32Array($e), $[O];
                    }, yo.prototype.customLayerMatrix = function() {
                        return this.mercatorMatrix.slice();
                    }, yo.prototype._constrain = function() {
                        if (!(!this.center || !this.width || !this.height || this._constraining)) {
                            this._constraining = !0;
                            var z = -90, K = 90, O = -180, $ = 180, pe, de, Ie, $e, pt = this.size, Kt = this._unmodified;
                            if (this.latRange) {
                                var ir = this.latRange;
                                z = i.mercatorYfromLat(ir[1]) * this.worldSize, K = i.mercatorYfromLat(ir[0]) * this.worldSize, pe = K - z < pt.y ? pt.y / (K - z) : 0;
                            }
                            if (this.lngRange) {
                                var Jt = this.lngRange;
                                O = i.mercatorXfromLng(Jt[0]) * this.worldSize, $ = i.mercatorXfromLng(Jt[1]) * this.worldSize, de = $ - O < pt.x ? pt.x / ($ - O) : 0;
                            }
                            var vt = this.point, Pt = Math.max(de || 0, pe || 0);
                            if (Pt) {
                                this.center = this.unproject(new i.Point(de ? ($ + O) / 2 : vt.x, pe ? (K + z) / 2 : vt.y)), this.zoom += this.scaleZoom(Pt), this._unmodified = Kt, this._constraining = !1;
                                return;
                            }
                            if (this.latRange) {
                                var Wt = vt.y, rr = pt.y / 2;
                                Wt - rr < z && ($e = z + rr), Wt + rr > K && ($e = K - rr);
                            }
                            if (this.lngRange) {
                                var dr = vt.x, pr = pt.x / 2;
                                dr - pr < O && (Ie = O + pr), dr + pr > $ && (Ie = $ - pr);
                            }
                            (Ie !== void 0 || $e !== void 0) && (this.center = this.unproject(new i.Point(Ie !== void 0 ? Ie : vt.x, $e !== void 0 ? $e : vt.y))), this._unmodified = Kt, this._constraining = !1;
                        }
                    }, yo.prototype._calcMatrices = function() {
                        if (this.height) {
                            var z = this._fov / 2, K = this.centerOffset;
                            this.cameraToCenterDistance = .5 / Math.tan(z) * this.height;
                            var O = Math.PI / 2 + this._pitch, $ = this._fov * (.5 + K.y / this.height), pe = Math.sin($) * this.cameraToCenterDistance / Math.sin(i.clamp(Math.PI - O - $, .01, Math.PI - .01)), de = this.point, Ie = de.x, $e = de.y, pt = Math.cos(Math.PI / 2 - this._pitch) * pe + this.cameraToCenterDistance, Kt = pt * 1.01, ir = this.height / 50, Jt = new Float64Array(16);
                            i.perspective(Jt, this._fov, this.width / this.height, ir, Kt), Jt[8] = -K.x * 2 / this.width, Jt[9] = K.y * 2 / this.height, i.scale(Jt, Jt, [
                                1,
                                -1,
                                1
                            ]), i.translate(Jt, Jt, [
                                0,
                                0,
                                -this.cameraToCenterDistance
                            ]), i.rotateX(Jt, Jt, this._pitch), i.rotateZ(Jt, Jt, this.angle), i.translate(Jt, Jt, [
                                -Ie,
                                -$e,
                                0
                            ]), this.mercatorMatrix = i.scale([], Jt, [
                                this.worldSize,
                                this.worldSize,
                                this.worldSize
                            ]), i.scale(Jt, Jt, [
                                1,
                                1,
                                i.mercatorZfromAltitude(1, this.center.lat) * this.worldSize,
                                1
                            ]), this.projMatrix = Jt, this.invProjMatrix = i.invert([], this.projMatrix);
                            var vt = this.width % 2 / 2, Pt = this.height % 2 / 2, Wt = Math.cos(this.angle), rr = Math.sin(this.angle), dr = Ie - Math.round(Ie) + Wt * vt + rr * Pt, pr = $e - Math.round($e) + Wt * Pt + rr * vt, kr = new Float64Array(Jt);
                            if (i.translate(kr, kr, [
                                dr > .5 ? dr - 1 : dr,
                                pr > .5 ? pr - 1 : pr,
                                0
                            ]), this.alignedProjMatrix = kr, Jt = i.create(), i.scale(Jt, Jt, [
                                this.width / 2,
                                -this.height / 2,
                                1
                            ]), i.translate(Jt, Jt, [
                                1,
                                -1,
                                0
                            ]), this.labelPlaneMatrix = Jt, Jt = i.create(), i.scale(Jt, Jt, [
                                1,
                                -1,
                                1
                            ]), i.translate(Jt, Jt, [
                                -1,
                                -1,
                                0
                            ]), i.scale(Jt, Jt, [
                                2 / this.width,
                                2 / this.height,
                                1
                            ]), this.glCoordMatrix = Jt, this.pixelMatrix = i.multiply(new Float64Array(16), this.labelPlaneMatrix, this.projMatrix), Jt = i.invert(new Float64Array(16), this.pixelMatrix), !Jt) throw new Error("failed to invert matrix");
                            this.pixelMatrixInverse = Jt, this._posMatrixCache = {}, this._alignedPosMatrixCache = {};
                        }
                    }, yo.prototype.maxPitchScaleFactor = function() {
                        if (!this.pixelMatrixInverse) return 1;
                        var z = this.pointCoordinate(new i.Point(0, 0)), K = [
                            z.x * this.worldSize,
                            z.y * this.worldSize,
                            0,
                            1
                        ], O = i.transformMat4(K, K, this.pixelMatrix);
                        return O[3] / this.cameraToCenterDistance;
                    }, yo.prototype.getCameraPoint = function() {
                        var z = this._pitch, K = Math.tan(z) * (this.cameraToCenterDistance || 1);
                        return this.centerPoint.add(new i.Point(0, K));
                    }, yo.prototype.getCameraQueryGeometry = function(z) {
                        var K = this.getCameraPoint();
                        if (z.length === 1) return [
                            z[0],
                            K
                        ];
                        for(var O = K.x, $ = K.y, pe = K.x, de = K.y, Ie = 0, $e = z; Ie < $e.length; Ie += 1){
                            var pt = $e[Ie];
                            O = Math.min(O, pt.x), $ = Math.min($, pt.y), pe = Math.max(pe, pt.x), de = Math.max(de, pt.y);
                        }
                        return [
                            new i.Point(O, $),
                            new i.Point(pe, $),
                            new i.Point(pe, de),
                            new i.Point(O, de),
                            new i.Point(O, $)
                        ];
                    }, Object.defineProperties(yo.prototype, po);
                    function _l(Y1, z) {
                        var K = !1, O = null, $ = function() {
                            O = null, K && (Y1(), O = setTimeout($, z), K = !1);
                        };
                        return function() {
                            return K = !0, O || $(), O;
                        };
                    }
                    var Hl = function(z) {
                        this._hashName = z && encodeURIComponent(z), i.bindAll([
                            "_getCurrentHash",
                            "_onHashChange",
                            "_updateHash"
                        ], this), this._updateHash = _l(this._updateHashUnthrottled.bind(this), 300);
                    };
                    Hl.prototype.addTo = function(z) {
                        return this._map = z, i.window.addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
                    }, Hl.prototype.remove = function() {
                        return i.window.removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), delete this._map, this;
                    }, Hl.prototype.getHashString = function(z) {
                        var K = this._map.getCenter(), O = Math.round(this._map.getZoom() * 100) / 100, $ = Math.ceil((O * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), pe = Math.pow(10, $), de = Math.round(K.lng * pe) / pe, Ie = Math.round(K.lat * pe) / pe, $e = this._map.getBearing(), pt = this._map.getPitch(), Kt = "";
                        if (z ? Kt += "/" + de + "/" + Ie + "/" + O : Kt += O + "/" + Ie + "/" + de, ($e || pt) && (Kt += "/" + Math.round($e * 10) / 10), pt && (Kt += "/" + Math.round(pt)), this._hashName) {
                            var ir = this._hashName, Jt = !1, vt = i.window.location.hash.slice(1).split("&").map(function(Pt) {
                                var Wt = Pt.split("=")[0];
                                return Wt === ir ? (Jt = !0, Wt + "=" + Kt) : Pt;
                            }).filter(function(Pt) {
                                return Pt;
                            });
                            return Jt || vt.push(ir + "=" + Kt), "#" + vt.join("&");
                        }
                        return "#" + Kt;
                    }, Hl.prototype._getCurrentHash = function() {
                        var z = this, K = i.window.location.hash.replace("#", "");
                        if (this._hashName) {
                            var O;
                            return K.split("&").map(function($) {
                                return $.split("=");
                            }).forEach(function($) {
                                $[0] === z._hashName && (O = $);
                            }), (O && O[1] || "").split("/");
                        }
                        return K.split("/");
                    }, Hl.prototype._onHashChange = function() {
                        var z = this._getCurrentHash();
                        if (z.length >= 3 && !z.some(function(O) {
                            return isNaN(O);
                        })) {
                            var K = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(z[3] || 0) : this._map.getBearing();
                            return this._map.jumpTo({
                                center: [
                                    +z[2],
                                    +z[1]
                                ],
                                zoom: +z[0],
                                bearing: K,
                                pitch: +(z[4] || 0)
                            }), !0;
                        }
                        return !1;
                    }, Hl.prototype._updateHashUnthrottled = function() {
                        var z = i.window.location.href.replace(/(#.+)?$/, this.getHashString());
                        try {
                            i.window.history.replaceState(i.window.history.state, null, z);
                        } catch (K) {}
                    };
                    var Zu = {
                        linearity: .3,
                        easing: i.bezier(0, 0, .3, 1)
                    }, cu = i.extend({
                        deceleration: 2500,
                        maxSpeed: 1400
                    }, Zu), el = i.extend({
                        deceleration: 20,
                        maxSpeed: 1400
                    }, Zu), au = i.extend({
                        deceleration: 1e3,
                        maxSpeed: 360
                    }, Zu), zc = i.extend({
                        deceleration: 1e3,
                        maxSpeed: 90
                    }, Zu), zl = function(z) {
                        this._map = z, this.clear();
                    };
                    zl.prototype.clear = function() {
                        this._inertiaBuffer = [];
                    }, zl.prototype.record = function(z) {
                        this._drainInertiaBuffer(), this._inertiaBuffer.push({
                            time: i.browser.now(),
                            settings: z
                        });
                    }, zl.prototype._drainInertiaBuffer = function() {
                        for(var z = this._inertiaBuffer, K = i.browser.now(), O = 160; z.length > 0 && K - z[0].time > O;)z.shift();
                    }, zl.prototype._onMoveEnd = function(z) {
                        if (this._drainInertiaBuffer(), !(this._inertiaBuffer.length < 2)) {
                            for(var K = {
                                zoom: 0,
                                bearing: 0,
                                pitch: 0,
                                pan: new i.Point(0, 0),
                                pinchAround: void 0,
                                around: void 0
                            }, O = 0, $ = this._inertiaBuffer; O < $.length; O += 1){
                                var pe = $[O], de = pe.settings;
                                K.zoom += de.zoomDelta || 0, K.bearing += de.bearingDelta || 0, K.pitch += de.pitchDelta || 0, de.panDelta && K.pan._add(de.panDelta), de.around && (K.around = de.around), de.pinchAround && (K.pinchAround = de.pinchAround);
                            }
                            var Ie = this._inertiaBuffer[this._inertiaBuffer.length - 1], $e = Ie.time - this._inertiaBuffer[0].time, pt = {};
                            if (K.pan.mag()) {
                                var Kt = Z(K.pan.mag(), $e, i.extend({}, cu, z || {}));
                                pt.offset = K.pan.mult(Kt.amount / K.pan.mag()), pt.center = this._map.transform.center, Fl(pt, Kt);
                            }
                            if (K.zoom) {
                                var ir = Z(K.zoom, $e, el);
                                pt.zoom = this._map.transform.zoom + ir.amount, Fl(pt, ir);
                            }
                            if (K.bearing) {
                                var Jt = Z(K.bearing, $e, au);
                                pt.bearing = this._map.transform.bearing + i.clamp(Jt.amount, -179, 179), Fl(pt, Jt);
                            }
                            if (K.pitch) {
                                var vt = Z(K.pitch, $e, zc);
                                pt.pitch = this._map.transform.pitch + vt.amount, Fl(pt, vt);
                            }
                            if (pt.zoom || pt.bearing) {
                                var Pt = K.pinchAround === void 0 ? K.around : K.pinchAround;
                                pt.around = Pt ? this._map.unproject(Pt) : this._map.getCenter();
                            }
                            return this.clear(), i.extend(pt, {
                                noMoveStart: !0
                            });
                        }
                    };
                    function Fl(Y1, z) {
                        (!Y1.duration || Y1.duration < z.duration) && (Y1.duration = z.duration, Y1.easing = z.easing);
                    }
                    function Z(Y1, z, K) {
                        var O = K.maxSpeed, $ = K.linearity, pe = K.deceleration, de = i.clamp(Y1 * $ / (z / 1e3), -O, O), Ie = Math.abs(de) / (pe * $);
                        return {
                            easing: K.easing,
                            duration: Ie * 1e3,
                            amount: de * (Ie / 2)
                        };
                    }
                    var oe = function(Y1) {
                        function z(O, $, pe, de) {
                            de === void 0 && (de = {});
                            var Ie = o.mousePos($.getCanvasContainer(), pe), $e = $.unproject(Ie);
                            Y1.call(this, O, i.extend({
                                point: Ie,
                                lngLat: $e,
                                originalEvent: pe
                            }, de)), this._defaultPrevented = !1, this.target = $;
                        }
                        Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z;
                        var K = {
                            defaultPrevented: {
                                configurable: !0
                            }
                        };
                        return z.prototype.preventDefault = function() {
                            this._defaultPrevented = !0;
                        }, K.defaultPrevented.get = function() {
                            return this._defaultPrevented;
                        }, Object.defineProperties(z.prototype, K), z;
                    }(i.Event), we = function(Y1) {
                        function z(O, $, pe) {
                            var de = O === "touchend" ? pe.changedTouches : pe.touches, Ie = o.touchPos($.getCanvasContainer(), de), $e = Ie.map(function(ir) {
                                return $.unproject(ir);
                            }), pt = Ie.reduce(function(ir, Jt, vt, Pt) {
                                return ir.add(Jt.div(Pt.length));
                            }, new i.Point(0, 0)), Kt = $.unproject(pt);
                            Y1.call(this, O, {
                                points: Ie,
                                point: pt,
                                lngLats: $e,
                                lngLat: Kt,
                                originalEvent: pe
                            }), this._defaultPrevented = !1;
                        }
                        Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z;
                        var K = {
                            defaultPrevented: {
                                configurable: !0
                            }
                        };
                        return z.prototype.preventDefault = function() {
                            this._defaultPrevented = !0;
                        }, K.defaultPrevented.get = function() {
                            return this._defaultPrevented;
                        }, Object.defineProperties(z.prototype, K), z;
                    }(i.Event), Be = function(Y1) {
                        function z(O, $, pe) {
                            Y1.call(this, O, {
                                originalEvent: pe
                            }), this._defaultPrevented = !1;
                        }
                        Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z;
                        var K = {
                            defaultPrevented: {
                                configurable: !0
                            }
                        };
                        return z.prototype.preventDefault = function() {
                            this._defaultPrevented = !0;
                        }, K.defaultPrevented.get = function() {
                            return this._defaultPrevented;
                        }, Object.defineProperties(z.prototype, K), z;
                    }(i.Event), Ue = function(z, K) {
                        this._map = z, this._clickTolerance = K.clickTolerance;
                    };
                    Ue.prototype.reset = function() {
                        delete this._mousedownPos;
                    }, Ue.prototype.wheel = function(z) {
                        return this._firePreventable(new Be(z.type, this._map, z));
                    }, Ue.prototype.mousedown = function(z, K) {
                        return this._mousedownPos = K, this._firePreventable(new oe(z.type, this._map, z));
                    }, Ue.prototype.mouseup = function(z) {
                        this._map.fire(new oe(z.type, this._map, z));
                    }, Ue.prototype.click = function(z, K) {
                        this._mousedownPos && this._mousedownPos.dist(K) >= this._clickTolerance || this._map.fire(new oe(z.type, this._map, z));
                    }, Ue.prototype.dblclick = function(z) {
                        return this._firePreventable(new oe(z.type, this._map, z));
                    }, Ue.prototype.mouseover = function(z) {
                        this._map.fire(new oe(z.type, this._map, z));
                    }, Ue.prototype.mouseout = function(z) {
                        this._map.fire(new oe(z.type, this._map, z));
                    }, Ue.prototype.touchstart = function(z) {
                        return this._firePreventable(new we(z.type, this._map, z));
                    }, Ue.prototype.touchmove = function(z) {
                        this._map.fire(new we(z.type, this._map, z));
                    }, Ue.prototype.touchend = function(z) {
                        this._map.fire(new we(z.type, this._map, z));
                    }, Ue.prototype.touchcancel = function(z) {
                        this._map.fire(new we(z.type, this._map, z));
                    }, Ue.prototype._firePreventable = function(z) {
                        if (this._map.fire(z), z.defaultPrevented) return {};
                    }, Ue.prototype.isEnabled = function() {
                        return !0;
                    }, Ue.prototype.isActive = function() {
                        return !1;
                    }, Ue.prototype.enable = function() {}, Ue.prototype.disable = function() {};
                    var We = function(z) {
                        this._map = z;
                    };
                    We.prototype.reset = function() {
                        this._delayContextMenu = !1, delete this._contextMenuEvent;
                    }, We.prototype.mousemove = function(z) {
                        this._map.fire(new oe(z.type, this._map, z));
                    }, We.prototype.mousedown = function() {
                        this._delayContextMenu = !0;
                    }, We.prototype.mouseup = function() {
                        this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new oe("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
                    }, We.prototype.contextmenu = function(z) {
                        this._delayContextMenu ? this._contextMenuEvent = z : this._map.fire(new oe(z.type, this._map, z)), this._map.listens("contextmenu") && z.preventDefault();
                    }, We.prototype.isEnabled = function() {
                        return !0;
                    }, We.prototype.isActive = function() {
                        return !1;
                    }, We.prototype.enable = function() {}, We.prototype.disable = function() {};
                    var wt = function(z, K) {
                        this._map = z, this._el = z.getCanvasContainer(), this._container = z.getContainer(), this._clickTolerance = K.clickTolerance || 1;
                    };
                    wt.prototype.isEnabled = function() {
                        return !!this._enabled;
                    }, wt.prototype.isActive = function() {
                        return !!this._active;
                    }, wt.prototype.enable = function() {
                        this.isEnabled() || (this._enabled = !0);
                    }, wt.prototype.disable = function() {
                        this.isEnabled() && (this._enabled = !1);
                    }, wt.prototype.mousedown = function(z, K) {
                        this.isEnabled() && z.shiftKey && z.button === 0 && (o.disableDrag(), this._startPos = this._lastPos = K, this._active = !0);
                    }, wt.prototype.mousemoveWindow = function(z, K) {
                        if (this._active) {
                            var O = K;
                            if (!(this._lastPos.equals(O) || !this._box && O.dist(this._startPos) < this._clickTolerance)) {
                                var $ = this._startPos;
                                this._lastPos = O, this._box || (this._box = o.create("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", z));
                                var pe = Math.min($.x, O.x), de = Math.max($.x, O.x), Ie = Math.min($.y, O.y), $e = Math.max($.y, O.y);
                                o.setTransform(this._box, "translate(" + pe + "px," + Ie + "px)"), this._box.style.width = de - pe + "px", this._box.style.height = $e - Ie + "px";
                            }
                        }
                    }, wt.prototype.mouseupWindow = function(z, K) {
                        var O = this;
                        if (this._active && z.button === 0) {
                            var $ = this._startPos, pe = K;
                            if (this.reset(), o.suppressClick(), $.x === pe.x && $.y === pe.y) this._fireEvent("boxzoomcancel", z);
                            else return this._map.fire(new i.Event("boxzoomend", {
                                originalEvent: z
                            })), {
                                cameraAnimation: function(de) {
                                    return de.fitScreenCoordinates($, pe, O._map.getBearing(), {
                                        linear: !0
                                    });
                                }
                            };
                        }
                    }, wt.prototype.keydown = function(z) {
                        this._active && z.keyCode === 27 && (this.reset(), this._fireEvent("boxzoomcancel", z));
                    }, wt.prototype.reset = function() {
                        this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (o.remove(this._box), this._box = null), o.enableDrag(), delete this._startPos, delete this._lastPos;
                    }, wt.prototype._fireEvent = function(z, K) {
                        return this._map.fire(new i.Event(z, {
                            originalEvent: K
                        }));
                    };
                    function tt(Y1, z) {
                        for(var K = {}, O = 0; O < Y1.length; O++)K[Y1[O].identifier] = z[O];
                        return K;
                    }
                    function zt(Y1) {
                        for(var z = new i.Point(0, 0), K = 0, O = Y1; K < O.length; K += 1){
                            var $ = O[K];
                            z._add($);
                        }
                        return z.div(Y1.length);
                    }
                    var or = 500, lr = 500, Dr = 30, Ir = function(z) {
                        this.reset(), this.numTouches = z.numTouches;
                    };
                    Ir.prototype.reset = function() {
                        delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
                    }, Ir.prototype.touchstart = function(z, K, O) {
                        (this.centroid || O.length > this.numTouches) && (this.aborted = !0), !this.aborted && (this.startTime === void 0 && (this.startTime = z.timeStamp), O.length === this.numTouches && (this.centroid = zt(K), this.touches = tt(O, K)));
                    }, Ir.prototype.touchmove = function(z, K, O) {
                        if (!(this.aborted || !this.centroid)) {
                            var $ = tt(O, K);
                            for(var pe in this.touches){
                                var de = this.touches[pe], Ie = $[pe];
                                (!Ie || Ie.dist(de) > Dr) && (this.aborted = !0);
                            }
                        }
                    }, Ir.prototype.touchend = function(z, K, O) {
                        if ((!this.centroid || z.timeStamp - this.startTime > lr) && (this.aborted = !0), O.length === 0) {
                            var $ = !this.aborted && this.centroid;
                            if (this.reset(), $) return $;
                        }
                    };
                    var oi = function(z) {
                        this.singleTap = new Ir(z), this.numTaps = z.numTaps, this.reset();
                    };
                    oi.prototype.reset = function() {
                        this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
                    }, oi.prototype.touchstart = function(z, K, O) {
                        this.singleTap.touchstart(z, K, O);
                    }, oi.prototype.touchmove = function(z, K, O) {
                        this.singleTap.touchmove(z, K, O);
                    }, oi.prototype.touchend = function(z, K, O) {
                        var $ = this.singleTap.touchend(z, K, O);
                        if ($) {
                            var pe = z.timeStamp - this.lastTime < or, de = !this.lastTap || this.lastTap.dist($) < Dr;
                            if ((!pe || !de) && this.reset(), this.count++, this.lastTime = z.timeStamp, this.lastTap = $, this.count === this.numTaps) return this.reset(), $;
                        }
                    };
                    var ui = function() {
                        this._zoomIn = new oi({
                            numTouches: 1,
                            numTaps: 2
                        }), this._zoomOut = new oi({
                            numTouches: 2,
                            numTaps: 1
                        }), this.reset();
                    };
                    ui.prototype.reset = function() {
                        this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
                    }, ui.prototype.touchstart = function(z, K, O) {
                        this._zoomIn.touchstart(z, K, O), this._zoomOut.touchstart(z, K, O);
                    }, ui.prototype.touchmove = function(z, K, O) {
                        this._zoomIn.touchmove(z, K, O), this._zoomOut.touchmove(z, K, O);
                    }, ui.prototype.touchend = function(z, K, O) {
                        var $ = this, pe = this._zoomIn.touchend(z, K, O), de = this._zoomOut.touchend(z, K, O);
                        if (pe) return this._active = !0, z.preventDefault(), setTimeout(function() {
                            return $.reset();
                        }, 0), {
                            cameraAnimation: function(Ie) {
                                return Ie.easeTo({
                                    duration: 300,
                                    zoom: Ie.getZoom() + 1,
                                    around: Ie.unproject(pe)
                                }, {
                                    originalEvent: z
                                });
                            }
                        };
                        if (de) return this._active = !0, z.preventDefault(), setTimeout(function() {
                            return $.reset();
                        }, 0), {
                            cameraAnimation: function(Ie) {
                                return Ie.easeTo({
                                    duration: 300,
                                    zoom: Ie.getZoom() - 1,
                                    around: Ie.unproject(de)
                                }, {
                                    originalEvent: z
                                });
                            }
                        };
                    }, ui.prototype.touchcancel = function() {
                        this.reset();
                    }, ui.prototype.enable = function() {
                        this._enabled = !0;
                    }, ui.prototype.disable = function() {
                        this._enabled = !1, this.reset();
                    }, ui.prototype.isEnabled = function() {
                        return this._enabled;
                    }, ui.prototype.isActive = function() {
                        return this._active;
                    };
                    var qr = 0, Kr = 2, ii = {};
                    ii[qr] = 1, ii[Kr] = 2;
                    function vi(Y1, z) {
                        var K = ii[z];
                        return Y1.buttons === void 0 || (Y1.buttons & K) !== K;
                    }
                    var ci = function(z) {
                        this.reset(), this._clickTolerance = z.clickTolerance || 1;
                    };
                    ci.prototype.reset = function() {
                        this._active = !1, this._moved = !1, delete this._lastPoint, delete this._eventButton;
                    }, ci.prototype._correctButton = function(z, K) {
                        return !1;
                    }, ci.prototype._move = function(z, K) {
                        return {};
                    }, ci.prototype.mousedown = function(z, K) {
                        if (!this._lastPoint) {
                            var O = o.mouseButton(z);
                            this._correctButton(z, O) && (this._lastPoint = K, this._eventButton = O);
                        }
                    }, ci.prototype.mousemoveWindow = function(z, K) {
                        var O = this._lastPoint;
                        if (O) {
                            if (z.preventDefault(), vi(z, this._eventButton)) {
                                this.reset();
                                return;
                            }
                            if (!(!this._moved && K.dist(O) < this._clickTolerance)) return this._moved = !0, this._lastPoint = K, this._move(O, K);
                        }
                    }, ci.prototype.mouseupWindow = function(z) {
                        if (this._lastPoint) {
                            var K = o.mouseButton(z);
                            K === this._eventButton && (this._moved && o.suppressClick(), this.reset());
                        }
                    }, ci.prototype.enable = function() {
                        this._enabled = !0;
                    }, ci.prototype.disable = function() {
                        this._enabled = !1, this.reset();
                    }, ci.prototype.isEnabled = function() {
                        return this._enabled;
                    }, ci.prototype.isActive = function() {
                        return this._active;
                    };
                    var Jr = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.mousedown = function(O, $) {
                            Y1.prototype.mousedown.call(this, O, $), this._lastPoint && (this._active = !0);
                        }, z.prototype._correctButton = function(O, $) {
                            return $ === qr && !O.ctrlKey;
                        }, z.prototype._move = function(O, $) {
                            return {
                                around: $,
                                panDelta: $.sub(O)
                            };
                        }, z;
                    }(ci), un = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype._correctButton = function(O, $) {
                            return $ === qr && O.ctrlKey || $ === Kr;
                        }, z.prototype._move = function(O, $) {
                            var pe = .8, de = ($.x - O.x) * pe;
                            if (de) return this._active = !0, {
                                bearingDelta: de
                            };
                        }, z.prototype.contextmenu = function(O) {
                            O.preventDefault();
                        }, z;
                    }(ci), dn = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype._correctButton = function(O, $) {
                            return $ === qr && O.ctrlKey || $ === Kr;
                        }, z.prototype._move = function(O, $) {
                            var pe = -0.5, de = ($.y - O.y) * pe;
                            if (de) return this._active = !0, {
                                pitchDelta: de
                            };
                        }, z.prototype.contextmenu = function(O) {
                            O.preventDefault();
                        }, z;
                    }(ci), En = function(z) {
                        this._minTouches = 1, this._clickTolerance = z.clickTolerance || 1, this.reset();
                    };
                    En.prototype.reset = function() {
                        this._active = !1, this._touches = {}, this._sum = new i.Point(0, 0);
                    }, En.prototype.touchstart = function(z, K, O) {
                        return this._calculateTransform(z, K, O);
                    }, En.prototype.touchmove = function(z, K, O) {
                        if (!(!this._active || O.length < this._minTouches)) return z.preventDefault(), this._calculateTransform(z, K, O);
                    }, En.prototype.touchend = function(z, K, O) {
                        this._calculateTransform(z, K, O), this._active && O.length < this._minTouches && this.reset();
                    }, En.prototype.touchcancel = function() {
                        this.reset();
                    }, En.prototype._calculateTransform = function(z, K, O) {
                        O.length > 0 && (this._active = !0);
                        var $ = tt(O, K), pe = new i.Point(0, 0), de = new i.Point(0, 0), Ie = 0;
                        for(var $e in $){
                            var pt = $[$e], Kt = this._touches[$e];
                            Kt && (pe._add(pt), de._add(pt.sub(Kt)), Ie++, $[$e] = pt);
                        }
                        if (this._touches = $, !(Ie < this._minTouches || !de.mag())) {
                            var ir = de.div(Ie);
                            if (this._sum._add(ir), !(this._sum.mag() < this._clickTolerance)) {
                                var Jt = pe.div(Ie);
                                return {
                                    around: Jt,
                                    panDelta: ir
                                };
                            }
                        }
                    }, En.prototype.enable = function() {
                        this._enabled = !0;
                    }, En.prototype.disable = function() {
                        this._enabled = !1, this.reset();
                    }, En.prototype.isEnabled = function() {
                        return this._enabled;
                    }, En.prototype.isActive = function() {
                        return this._active;
                    };
                    var Nn = function() {
                        this.reset();
                    };
                    Nn.prototype.reset = function() {
                        this._active = !1, delete this._firstTwoTouches;
                    }, Nn.prototype._start = function(z) {}, Nn.prototype._move = function(z, K, O) {
                        return {};
                    }, Nn.prototype.touchstart = function(z, K, O) {
                        this._firstTwoTouches || O.length < 2 || (this._firstTwoTouches = [
                            O[0].identifier,
                            O[1].identifier
                        ], this._start([
                            K[0],
                            K[1]
                        ]));
                    }, Nn.prototype.touchmove = function(z, K, O) {
                        if (this._firstTwoTouches) {
                            z.preventDefault();
                            var $ = this._firstTwoTouches, pe = $[0], de = $[1], Ie = ga(O, K, pe), $e = ga(O, K, de);
                            if (!(!Ie || !$e)) {
                                var pt = this._aroundCenter ? null : Ie.add($e).div(2);
                                return this._move([
                                    Ie,
                                    $e
                                ], pt, z);
                            }
                        }
                    }, Nn.prototype.touchend = function(z, K, O) {
                        if (this._firstTwoTouches) {
                            var $ = this._firstTwoTouches, pe = $[0], de = $[1], Ie = ga(O, K, pe), $e = ga(O, K, de);
                            Ie && $e || (this._active && o.suppressClick(), this.reset());
                        }
                    }, Nn.prototype.touchcancel = function() {
                        this.reset();
                    }, Nn.prototype.enable = function(z) {
                        this._enabled = !0, this._aroundCenter = !!z && z.around === "center";
                    }, Nn.prototype.disable = function() {
                        this._enabled = !1, this.reset();
                    }, Nn.prototype.isEnabled = function() {
                        return this._enabled;
                    }, Nn.prototype.isActive = function() {
                        return this._active;
                    };
                    function ga(Y1, z, K) {
                        for(var O = 0; O < Y1.length; O++)if (Y1[O].identifier === K) return z[O];
                    }
                    var ya = .1;
                    function so(Y1, z) {
                        return Math.log(Y1 / z) / Math.LN2;
                    }
                    var wa = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.reset = function() {
                            Y1.prototype.reset.call(this), delete this._distance, delete this._startDistance;
                        }, z.prototype._start = function(O) {
                            this._startDistance = this._distance = O[0].dist(O[1]);
                        }, z.prototype._move = function(O, $) {
                            var pe = this._distance;
                            if (this._distance = O[0].dist(O[1]), !(!this._active && Math.abs(so(this._distance, this._startDistance)) < ya)) return this._active = !0, {
                                zoomDelta: so(this._distance, pe),
                                pinchAround: $
                            };
                        }, z;
                    }(Nn), io = 25;
                    function Ss(Y1, z) {
                        return Y1.angleWith(z) * 180 / Math.PI;
                    }
                    var _s = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.reset = function() {
                            Y1.prototype.reset.call(this), delete this._minDiameter, delete this._startVector, delete this._vector;
                        }, z.prototype._start = function(O) {
                            this._startVector = this._vector = O[0].sub(O[1]), this._minDiameter = O[0].dist(O[1]);
                        }, z.prototype._move = function(O, $) {
                            var pe = this._vector;
                            if (this._vector = O[0].sub(O[1]), !(!this._active && this._isBelowThreshold(this._vector))) return this._active = !0, {
                                bearingDelta: Ss(this._vector, pe),
                                pinchAround: $
                            };
                        }, z.prototype._isBelowThreshold = function(O) {
                            this._minDiameter = Math.min(this._minDiameter, O.mag());
                            var $ = Math.PI * this._minDiameter, pe = io / $ * 360, de = Ss(O, this._startVector);
                            return Math.abs(de) < pe;
                        }, z;
                    }(Nn);
                    function Ns(Y1) {
                        return Math.abs(Y1.y) > Math.abs(Y1.x);
                    }
                    var pn = 100, za = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.reset = function() {
                            Y1.prototype.reset.call(this), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
                        }, z.prototype._start = function(O) {
                            this._lastPoints = O, Ns(O[0].sub(O[1])) && (this._valid = !1);
                        }, z.prototype._move = function(O, $, pe) {
                            var de = O[0].sub(this._lastPoints[0]), Ie = O[1].sub(this._lastPoints[1]);
                            if (this._valid = this.gestureBeginsVertically(de, Ie, pe.timeStamp), !!this._valid) {
                                this._lastPoints = O, this._active = !0;
                                var $e = (de.y + Ie.y) / 2, pt = -0.5;
                                return {
                                    pitchDelta: $e * pt
                                };
                            }
                        }, z.prototype.gestureBeginsVertically = function(O, $, pe) {
                            if (this._valid !== void 0) return this._valid;
                            var de = 2, Ie = O.mag() >= de, $e = $.mag() >= de;
                            if (!(!Ie && !$e)) {
                                if (!Ie || !$e) return this._firstMove === void 0 && (this._firstMove = pe), pe - this._firstMove < pn ? void 0 : !1;
                                var pt = O.y > 0 == $.y > 0;
                                return Ns(O) && Ns($) && pt;
                            }
                        }, z;
                    }(Nn), Lo = {
                        panStep: 100,
                        bearingStep: 15,
                        pitchStep: 10
                    }, Fo = function() {
                        var z = Lo;
                        this._panStep = z.panStep, this._bearingStep = z.bearingStep, this._pitchStep = z.pitchStep, this._rotationDisabled = !1;
                    };
                    Fo.prototype.reset = function() {
                        this._active = !1;
                    }, Fo.prototype.keydown = function(z) {
                        var K = this;
                        if (!(z.altKey || z.ctrlKey || z.metaKey)) {
                            var O = 0, $ = 0, pe = 0, de = 0, Ie = 0;
                            switch(z.keyCode){
                                case 61:
                                case 107:
                                case 171:
                                case 187:
                                    O = 1;
                                    break;
                                case 189:
                                case 109:
                                case 173:
                                    O = -1;
                                    break;
                                case 37:
                                    z.shiftKey ? $ = -1 : (z.preventDefault(), de = -1);
                                    break;
                                case 39:
                                    z.shiftKey ? $ = 1 : (z.preventDefault(), de = 1);
                                    break;
                                case 38:
                                    z.shiftKey ? pe = 1 : (z.preventDefault(), Ie = -1);
                                    break;
                                case 40:
                                    z.shiftKey ? pe = -1 : (z.preventDefault(), Ie = 1);
                                    break;
                                default:
                                    return;
                            }
                            return this._rotationDisabled && ($ = 0, pe = 0), {
                                cameraAnimation: function($e) {
                                    var pt = $e.getZoom();
                                    $e.easeTo({
                                        duration: 300,
                                        easeId: "keyboardHandler",
                                        easing: js,
                                        zoom: O ? Math.round(pt) + O * (z.shiftKey ? 2 : 1) : pt,
                                        bearing: $e.getBearing() + $ * K._bearingStep,
                                        pitch: $e.getPitch() + pe * K._pitchStep,
                                        offset: [
                                            -de * K._panStep,
                                            -Ie * K._panStep
                                        ],
                                        center: $e.getCenter()
                                    }, {
                                        originalEvent: z
                                    });
                                }
                            };
                        }
                    }, Fo.prototype.enable = function() {
                        this._enabled = !0;
                    }, Fo.prototype.disable = function() {
                        this._enabled = !1, this.reset();
                    }, Fo.prototype.isEnabled = function() {
                        return this._enabled;
                    }, Fo.prototype.isActive = function() {
                        return this._active;
                    }, Fo.prototype.disableRotation = function() {
                        this._rotationDisabled = !0;
                    }, Fo.prototype.enableRotation = function() {
                        this._rotationDisabled = !1;
                    };
                    function js(Y1) {
                        return Y1 * (2 - Y1);
                    }
                    var xl = 4.000244140625, fu = 0.01, dl = 1 / 450, xc = 2, At = function(z, K) {
                        this._map = z, this._el = z.getCanvasContainer(), this._handler = K, this._delta = 0, this._defaultZoomRate = fu, this._wheelZoomRate = dl, i.bindAll([
                            "_onTimeout"
                        ], this);
                    };
                    At.prototype.setZoomRate = function(z) {
                        this._defaultZoomRate = z;
                    }, At.prototype.setWheelZoomRate = function(z) {
                        this._wheelZoomRate = z;
                    }, At.prototype.isEnabled = function() {
                        return !!this._enabled;
                    }, At.prototype.isActive = function() {
                        return !!this._active || this._finishTimeout !== void 0;
                    }, At.prototype.isZooming = function() {
                        return !!this._zooming;
                    }, At.prototype.enable = function(z) {
                        this.isEnabled() || (this._enabled = !0, this._aroundCenter = z && z.around === "center");
                    }, At.prototype.disable = function() {
                        this.isEnabled() && (this._enabled = !1);
                    }, At.prototype.wheel = function(z) {
                        if (this.isEnabled()) {
                            var K = z.deltaMode === i.window.WheelEvent.DOM_DELTA_LINE ? z.deltaY * 40 : z.deltaY, O = i.browser.now(), $ = O - (this._lastWheelEventTime || 0);
                            this._lastWheelEventTime = O, K !== 0 && K % xl === 0 ? this._type = "wheel" : K !== 0 && Math.abs(K) < 4 ? this._type = "trackpad" : $ > 400 ? (this._type = null, this._lastValue = K, this._timeout = setTimeout(this._onTimeout, 40, z)) : this._type || (this._type = Math.abs($ * K) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, K += this._lastValue)), z.shiftKey && K && (K = K / 4), this._type && (this._lastWheelEvent = z, this._delta -= K, this._active || this._start(z)), z.preventDefault();
                        }
                    }, At.prototype._onTimeout = function(z) {
                        this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(z);
                    }, At.prototype._start = function(z) {
                        if (this._delta) {
                            this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                            var K = o.mousePos(this._el, z);
                            this._around = i.LngLat.convert(this._aroundCenter ? this._map.getCenter() : this._map.unproject(K)), this._aroundPoint = this._map.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
                        }
                    }, At.prototype.renderFrame = function() {
                        var z = this;
                        if (this._frameId && (this._frameId = null, !!this.isActive())) {
                            var K = this._map.transform;
                            if (this._delta !== 0) {
                                var O = this._type === "wheel" && Math.abs(this._delta) > xl ? this._wheelZoomRate : this._defaultZoomRate, $ = xc / (1 + Math.exp(-Math.abs(this._delta * O)));
                                this._delta < 0 && $ !== 0 && ($ = 1 / $);
                                var pe = typeof this._targetZoom == "number" ? K.zoomScale(this._targetZoom) : K.scale;
                                this._targetZoom = Math.min(K.maxZoom, Math.max(K.minZoom, K.scaleZoom(pe * $))), this._type === "wheel" && (this._startZoom = K.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                            }
                            var de = typeof this._targetZoom == "number" ? this._targetZoom : K.zoom, Ie = this._startZoom, $e = this._easing, pt = !1, Kt;
                            if (this._type === "wheel" && Ie && $e) {
                                var ir = Math.min((i.browser.now() - this._lastWheelEventTime) / 200, 1), Jt = $e(ir);
                                Kt = i.number(Ie, de, Jt), ir < 1 ? this._frameId || (this._frameId = !0) : pt = !0;
                            } else Kt = de, pt = !0;
                            return this._active = !0, pt && (this._active = !1, this._finishTimeout = setTimeout(function() {
                                z._zooming = !1, z._handler._triggerRenderFrame(), delete z._targetZoom, delete z._finishTimeout;
                            }, 200)), {
                                noInertia: !0,
                                needsRenderFrame: !pt,
                                zoomDelta: Kt - K.zoom,
                                around: this._aroundPoint,
                                originalEvent: this._lastWheelEvent
                            };
                        }
                    }, At.prototype._smoothOutEasing = function(z) {
                        var K = i.ease;
                        if (this._prevEase) {
                            var O = this._prevEase, $ = (i.browser.now() - O.start) / O.duration, pe = O.easing($ + .01) - O.easing($), de = .27 / Math.sqrt(pe * pe + 1e-4) * .01, Ie = Math.sqrt(0.0729 - de * de);
                            K = i.bezier(de, Ie, .25, 1);
                        }
                        return this._prevEase = {
                            start: i.browser.now(),
                            duration: z,
                            easing: K
                        }, K;
                    }, At.prototype.reset = function() {
                        this._active = !1;
                    };
                    var Er = function(z, K) {
                        this._clickZoom = z, this._tapZoom = K;
                    };
                    Er.prototype.enable = function() {
                        this._clickZoom.enable(), this._tapZoom.enable();
                    }, Er.prototype.disable = function() {
                        this._clickZoom.disable(), this._tapZoom.disable();
                    }, Er.prototype.isEnabled = function() {
                        return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
                    }, Er.prototype.isActive = function() {
                        return this._clickZoom.isActive() || this._tapZoom.isActive();
                    };
                    var Wr = function() {
                        this.reset();
                    };
                    Wr.prototype.reset = function() {
                        this._active = !1;
                    }, Wr.prototype.dblclick = function(z, K) {
                        return z.preventDefault(), {
                            cameraAnimation: function(O) {
                                O.easeTo({
                                    duration: 300,
                                    zoom: O.getZoom() + (z.shiftKey ? -1 : 1),
                                    around: O.unproject(K)
                                }, {
                                    originalEvent: z
                                });
                            }
                        };
                    }, Wr.prototype.enable = function() {
                        this._enabled = !0;
                    }, Wr.prototype.disable = function() {
                        this._enabled = !1, this.reset();
                    }, Wr.prototype.isEnabled = function() {
                        return this._enabled;
                    }, Wr.prototype.isActive = function() {
                        return this._active;
                    };
                    var wi = function() {
                        this._tap = new oi({
                            numTouches: 1,
                            numTaps: 1
                        }), this.reset();
                    };
                    wi.prototype.reset = function() {
                        this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, this._tap.reset();
                    }, wi.prototype.touchstart = function(z, K, O) {
                        this._swipePoint || (this._tapTime && z.timeStamp - this._tapTime > or && this.reset(), this._tapTime ? O.length > 0 && (this._swipePoint = K[0], this._swipeTouch = O[0].identifier) : this._tap.touchstart(z, K, O));
                    }, wi.prototype.touchmove = function(z, K, O) {
                        if (!this._tapTime) this._tap.touchmove(z, K, O);
                        else if (this._swipePoint) {
                            if (O[0].identifier !== this._swipeTouch) return;
                            var $ = K[0], pe = $.y - this._swipePoint.y;
                            return this._swipePoint = $, z.preventDefault(), this._active = !0, {
                                zoomDelta: pe / 128
                            };
                        }
                    }, wi.prototype.touchend = function(z, K, O) {
                        if (this._tapTime) this._swipePoint && O.length === 0 && this.reset();
                        else {
                            var $ = this._tap.touchend(z, K, O);
                            $ && (this._tapTime = z.timeStamp);
                        }
                    }, wi.prototype.touchcancel = function() {
                        this.reset();
                    }, wi.prototype.enable = function() {
                        this._enabled = !0;
                    }, wi.prototype.disable = function() {
                        this._enabled = !1, this.reset();
                    }, wi.prototype.isEnabled = function() {
                        return this._enabled;
                    }, wi.prototype.isActive = function() {
                        return this._active;
                    };
                    var Ui = function(z, K, O) {
                        this._el = z, this._mousePan = K, this._touchPan = O;
                    };
                    Ui.prototype.enable = function(z) {
                        this._inertiaOptions = z || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
                    }, Ui.prototype.disable = function() {
                        this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
                    }, Ui.prototype.isEnabled = function() {
                        return this._mousePan.isEnabled() && this._touchPan.isEnabled();
                    }, Ui.prototype.isActive = function() {
                        return this._mousePan.isActive() || this._touchPan.isActive();
                    };
                    var Oi = function(z, K, O) {
                        this._pitchWithRotate = z.pitchWithRotate, this._mouseRotate = K, this._mousePitch = O;
                    };
                    Oi.prototype.enable = function() {
                        this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
                    }, Oi.prototype.disable = function() {
                        this._mouseRotate.disable(), this._mousePitch.disable();
                    }, Oi.prototype.isEnabled = function() {
                        return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
                    }, Oi.prototype.isActive = function() {
                        return this._mouseRotate.isActive() || this._mousePitch.isActive();
                    };
                    var Bi = function(z, K, O, $) {
                        this._el = z, this._touchZoom = K, this._touchRotate = O, this._tapDragZoom = $, this._rotationDisabled = !1, this._enabled = !0;
                    };
                    Bi.prototype.enable = function(z) {
                        this._touchZoom.enable(z), this._rotationDisabled || this._touchRotate.enable(z), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
                    }, Bi.prototype.disable = function() {
                        this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
                    }, Bi.prototype.isEnabled = function() {
                        return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
                    }, Bi.prototype.isActive = function() {
                        return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
                    }, Bi.prototype.disableRotation = function() {
                        this._rotationDisabled = !0, this._touchRotate.disable();
                    }, Bi.prototype.enableRotation = function() {
                        this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
                    };
                    var cn = function(Y1) {
                        return Y1.zoom || Y1.drag || Y1.pitch || Y1.rotate;
                    }, On = function(Y1) {
                        function z() {
                            Y1.apply(this, arguments);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z;
                    }(i.Event);
                    function Bn(Y1) {
                        return Y1.panDelta && Y1.panDelta.mag() || Y1.zoomDelta || Y1.bearingDelta || Y1.pitchDelta;
                    }
                    var yn = function(z, K) {
                        this._map = z, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new zl(z), this._bearingSnap = K.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(K), i.bindAll([
                            "handleEvent",
                            "handleWindowEvent"
                        ], this);
                        var O = this._el;
                        this._listeners = [
                            [
                                O,
                                "touchstart",
                                {
                                    passive: !0
                                }
                            ],
                            [
                                O,
                                "touchmove",
                                {
                                    passive: !1
                                }
                            ],
                            [
                                O,
                                "touchend",
                                void 0
                            ],
                            [
                                O,
                                "touchcancel",
                                void 0
                            ],
                            [
                                O,
                                "mousedown",
                                void 0
                            ],
                            [
                                O,
                                "mousemove",
                                void 0
                            ],
                            [
                                O,
                                "mouseup",
                                void 0
                            ],
                            [
                                i.window.document,
                                "mousemove",
                                {
                                    capture: !0
                                }
                            ],
                            [
                                i.window.document,
                                "mouseup",
                                void 0
                            ],
                            [
                                O,
                                "mouseover",
                                void 0
                            ],
                            [
                                O,
                                "mouseout",
                                void 0
                            ],
                            [
                                O,
                                "dblclick",
                                void 0
                            ],
                            [
                                O,
                                "click",
                                void 0
                            ],
                            [
                                O,
                                "keydown",
                                {
                                    capture: !1
                                }
                            ],
                            [
                                O,
                                "keyup",
                                void 0
                            ],
                            [
                                O,
                                "wheel",
                                {
                                    passive: !1
                                }
                            ],
                            [
                                O,
                                "contextmenu",
                                void 0
                            ],
                            [
                                i.window,
                                "blur",
                                void 0
                            ]
                        ];
                        for(var $ = 0, pe = this._listeners; $ < pe.length; $ += 1){
                            var de = pe[$], Ie = de[0], $e = de[1], pt = de[2];
                            o.addEventListener(Ie, $e, Ie === i.window.document ? this.handleWindowEvent : this.handleEvent, pt);
                        }
                    };
                    yn.prototype.destroy = function() {
                        for(var z = 0, K = this._listeners; z < K.length; z += 1){
                            var O = K[z], $ = O[0], pe = O[1], de = O[2];
                            o.removeEventListener($, pe, $ === i.window.document ? this.handleWindowEvent : this.handleEvent, de);
                        }
                    }, yn.prototype._addDefaultHandlers = function(z) {
                        var K = this._map, O = K.getCanvasContainer();
                        this._add("mapEvent", new Ue(K, z));
                        var $ = K.boxZoom = new wt(K, z);
                        this._add("boxZoom", $);
                        var pe = new ui, de = new Wr;
                        K.doubleClickZoom = new Er(de, pe), this._add("tapZoom", pe), this._add("clickZoom", de);
                        var Ie = new wi;
                        this._add("tapDragZoom", Ie);
                        var $e = K.touchPitch = new za;
                        this._add("touchPitch", $e);
                        var pt = new un(z), Kt = new dn(z);
                        K.dragRotate = new Oi(z, pt, Kt), this._add("mouseRotate", pt, [
                            "mousePitch"
                        ]), this._add("mousePitch", Kt, [
                            "mouseRotate"
                        ]);
                        var ir = new Jr(z), Jt = new En(z);
                        K.dragPan = new Ui(O, ir, Jt), this._add("mousePan", ir), this._add("touchPan", Jt, [
                            "touchZoom",
                            "touchRotate"
                        ]);
                        var vt = new _s, Pt = new wa;
                        K.touchZoomRotate = new Bi(O, Pt, vt, Ie), this._add("touchRotate", vt, [
                            "touchPan",
                            "touchZoom"
                        ]), this._add("touchZoom", Pt, [
                            "touchPan",
                            "touchRotate"
                        ]);
                        var Wt = K.scrollZoom = new At(K, this);
                        this._add("scrollZoom", Wt, [
                            "mousePan"
                        ]);
                        var rr = K.keyboard = new Fo;
                        this._add("keyboard", rr), this._add("blockableMapEvent", new We(K));
                        for(var dr = 0, pr = [
                            "boxZoom",
                            "doubleClickZoom",
                            "tapDragZoom",
                            "touchPitch",
                            "dragRotate",
                            "dragPan",
                            "touchZoomRotate",
                            "scrollZoom",
                            "keyboard"
                        ]; dr < pr.length; dr += 1){
                            var kr = pr[dr];
                            z.interactive && z[kr] && K[kr].enable(z[kr]);
                        }
                    }, yn.prototype._add = function(z, K, O) {
                        this._handlers.push({
                            handlerName: z,
                            handler: K,
                            allowed: O
                        }), this._handlersById[z] = K;
                    }, yn.prototype.stop = function(z) {
                        if (!this._updatingCamera) {
                            for(var K = 0, O = this._handlers; K < O.length; K += 1){
                                var $ = O[K], pe = $.handler;
                                pe.reset();
                            }
                            this._inertia.clear(), this._fireEvents({}, {}, z), this._changes = [];
                        }
                    }, yn.prototype.isActive = function() {
                        for(var z = 0, K = this._handlers; z < K.length; z += 1){
                            var O = K[z], $ = O.handler;
                            if ($.isActive()) return !0;
                        }
                        return !1;
                    }, yn.prototype.isZooming = function() {
                        return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
                    }, yn.prototype.isRotating = function() {
                        return !!this._eventsInProgress.rotate;
                    }, yn.prototype.isMoving = function() {
                        return !!cn(this._eventsInProgress) || this.isZooming();
                    }, yn.prototype._blockedByActive = function(z, K, O) {
                        for(var $ in z)if ($ !== O && (!K || K.indexOf($) < 0)) return !0;
                        return !1;
                    }, yn.prototype.handleWindowEvent = function(z) {
                        this.handleEvent(z, z.type + "Window");
                    }, yn.prototype._getMapTouches = function(z) {
                        for(var K = [], O = 0, $ = z; O < $.length; O += 1){
                            var pe = $[O], de = pe.target;
                            this._el.contains(de) && K.push(pe);
                        }
                        return K;
                    }, yn.prototype.handleEvent = function(z, K) {
                        if (z.type === "blur") {
                            this.stop(!0);
                            return;
                        }
                        this._updatingCamera = !0;
                        for(var O = z.type === "renderFrame" ? void 0 : z, $ = {
                            needsRenderFrame: !1
                        }, pe = {}, de = {}, Ie = z.touches ? this._getMapTouches(z.touches) : void 0, $e = Ie ? o.touchPos(this._el, Ie) : o.mousePos(this._el, z), pt = 0, Kt = this._handlers; pt < Kt.length; pt += 1){
                            var ir = Kt[pt], Jt = ir.handlerName, vt = ir.handler, Pt = ir.allowed;
                            if (vt.isEnabled()) {
                                var Wt = void 0;
                                this._blockedByActive(de, Pt, Jt) ? vt.reset() : vt[K || z.type] && (Wt = vt[K || z.type](z, $e, Ie), this.mergeHandlerResult($, pe, Wt, Jt, O), Wt && Wt.needsRenderFrame && this._triggerRenderFrame()), (Wt || vt.isActive()) && (de[Jt] = vt);
                            }
                        }
                        var rr = {};
                        for(var dr in this._previousActiveHandlers)de[dr] || (rr[dr] = O);
                        this._previousActiveHandlers = de, (Object.keys(rr).length || Bn($)) && (this._changes.push([
                            $,
                            pe,
                            rr
                        ]), this._triggerRenderFrame()), (Object.keys(de).length || Bn($)) && this._map._stop(!0), this._updatingCamera = !1;
                        var pr = $.cameraAnimation;
                        pr && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], pr(this._map));
                    }, yn.prototype.mergeHandlerResult = function(z, K, O, $, pe) {
                        if (O) {
                            i.extend(z, O);
                            var de = {
                                handlerName: $,
                                originalEvent: O.originalEvent || pe
                            };
                            O.zoomDelta !== void 0 && (K.zoom = de), O.panDelta !== void 0 && (K.drag = de), O.pitchDelta !== void 0 && (K.pitch = de), O.bearingDelta !== void 0 && (K.rotate = de);
                        }
                    }, yn.prototype._applyChanges = function() {
                        for(var z = {}, K = {}, O = {}, $ = 0, pe = this._changes; $ < pe.length; $ += 1){
                            var de = pe[$], Ie = de[0], $e = de[1], pt = de[2];
                            Ie.panDelta && (z.panDelta = (z.panDelta || new i.Point(0, 0))._add(Ie.panDelta)), Ie.zoomDelta && (z.zoomDelta = (z.zoomDelta || 0) + Ie.zoomDelta), Ie.bearingDelta && (z.bearingDelta = (z.bearingDelta || 0) + Ie.bearingDelta), Ie.pitchDelta && (z.pitchDelta = (z.pitchDelta || 0) + Ie.pitchDelta), Ie.around !== void 0 && (z.around = Ie.around), Ie.pinchAround !== void 0 && (z.pinchAround = Ie.pinchAround), Ie.noInertia && (z.noInertia = Ie.noInertia), i.extend(K, $e), i.extend(O, pt);
                        }
                        this._updateMapTransform(z, K, O), this._changes = [];
                    }, yn.prototype._updateMapTransform = function(z, K, O) {
                        var $ = this._map, pe = $.transform;
                        if (!Bn(z)) return this._fireEvents(K, O, !0);
                        var de = z.panDelta, Ie = z.zoomDelta, $e = z.bearingDelta, pt = z.pitchDelta, Kt = z.around, ir = z.pinchAround;
                        ir !== void 0 && (Kt = ir), $._stop(!0), Kt = Kt || $.transform.centerPoint;
                        var Jt = pe.pointLocation(de ? Kt.sub(de) : Kt);
                        $e && (pe.bearing += $e), pt && (pe.pitch += pt), Ie && (pe.zoom += Ie), pe.setLocationAtPoint(Jt, Kt), this._map._update(), z.noInertia || this._inertia.record(z), this._fireEvents(K, O, !0);
                    }, yn.prototype._fireEvents = function(z, K, O) {
                        var $ = this, pe = cn(this._eventsInProgress), de = cn(z), Ie = {};
                        for(var $e in z){
                            var pt = z[$e], Kt = pt.originalEvent;
                            this._eventsInProgress[$e] || (Ie[$e + "start"] = Kt), this._eventsInProgress[$e] = z[$e];
                        }
                        !pe && de && this._fireEvent("movestart", de.originalEvent);
                        for(var ir in Ie)this._fireEvent(ir, Ie[ir]);
                        de && this._fireEvent("move", de.originalEvent);
                        for(var Jt in z){
                            var vt = z[Jt], Pt = vt.originalEvent;
                            this._fireEvent(Jt, Pt);
                        }
                        var Wt = {}, rr;
                        for(var dr in this._eventsInProgress){
                            var pr = this._eventsInProgress[dr], kr = pr.handlerName, Ar = pr.originalEvent;
                            this._handlersById[kr].isActive() || (delete this._eventsInProgress[dr], rr = K[kr] || Ar, Wt[dr + "end"] = rr);
                        }
                        for(var gr in Wt)this._fireEvent(gr, Wt[gr]);
                        var Cr = cn(this._eventsInProgress);
                        if (O && (pe || de) && !Cr) {
                            this._updatingCamera = !0;
                            var cr = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), Gr = function(ei) {
                                return ei !== 0 && -$._bearingSnap < ei && ei < $._bearingSnap;
                            };
                            cr ? (Gr(cr.bearing || this._map.getBearing()) && (cr.bearing = 0), this._map.easeTo(cr, {
                                originalEvent: rr
                            })) : (this._map.fire(new i.Event("moveend", {
                                originalEvent: rr
                            })), Gr(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                        }
                    }, yn.prototype._fireEvent = function(z, K) {
                        this._map.fire(new i.Event(z, K ? {
                            originalEvent: K
                        } : {}));
                    }, yn.prototype._requestFrame = function() {
                        var z = this;
                        return this._map.triggerRepaint(), this._map._renderTaskQueue.add(function(K) {
                            delete z._frameId, z.handleEvent(new On("renderFrame", {
                                timeStamp: K
                            })), z._applyChanges();
                        });
                    }, yn.prototype._triggerRenderFrame = function() {
                        this._frameId === void 0 && (this._frameId = this._requestFrame());
                    };
                    var to = function(Y1) {
                        function z(K, O) {
                            Y1.call(this), this._moving = !1, this._zooming = !1, this.transform = K, this._bearingSnap = O.bearingSnap, i.bindAll([
                                "_renderFrameCallback"
                            ], this);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.getCenter = function() {
                            return new i.LngLat(this.transform.center.lng, this.transform.center.lat);
                        }, z.prototype.setCenter = function(O, $) {
                            return this.jumpTo({
                                center: O
                            }, $);
                        }, z.prototype.panBy = function(O, $, pe) {
                            return O = i.Point.convert(O).mult(-1), this.panTo(this.transform.center, i.extend({
                                offset: O
                            }, $), pe);
                        }, z.prototype.panTo = function(O, $, pe) {
                            return this.easeTo(i.extend({
                                center: O
                            }, $), pe);
                        }, z.prototype.getZoom = function() {
                            return this.transform.zoom;
                        }, z.prototype.setZoom = function(O, $) {
                            return this.jumpTo({
                                zoom: O
                            }, $), this;
                        }, z.prototype.zoomTo = function(O, $, pe) {
                            return this.easeTo(i.extend({
                                zoom: O
                            }, $), pe);
                        }, z.prototype.zoomIn = function(O, $) {
                            return this.zoomTo(this.getZoom() + 1, O, $), this;
                        }, z.prototype.zoomOut = function(O, $) {
                            return this.zoomTo(this.getZoom() - 1, O, $), this;
                        }, z.prototype.getBearing = function() {
                            return this.transform.bearing;
                        }, z.prototype.setBearing = function(O, $) {
                            return this.jumpTo({
                                bearing: O
                            }, $), this;
                        }, z.prototype.getPadding = function() {
                            return this.transform.padding;
                        }, z.prototype.setPadding = function(O, $) {
                            return this.jumpTo({
                                padding: O
                            }, $), this;
                        }, z.prototype.rotateTo = function(O, $, pe) {
                            return this.easeTo(i.extend({
                                bearing: O
                            }, $), pe);
                        }, z.prototype.resetNorth = function(O, $) {
                            return this.rotateTo(0, i.extend({
                                duration: 1e3
                            }, O), $), this;
                        }, z.prototype.resetNorthPitch = function(O, $) {
                            return this.easeTo(i.extend({
                                bearing: 0,
                                pitch: 0,
                                duration: 1e3
                            }, O), $), this;
                        }, z.prototype.snapToNorth = function(O, $) {
                            return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(O, $) : this;
                        }, z.prototype.getPitch = function() {
                            return this.transform.pitch;
                        }, z.prototype.setPitch = function(O, $) {
                            return this.jumpTo({
                                pitch: O
                            }, $), this;
                        }, z.prototype.cameraForBounds = function(O, $) {
                            O = i.LngLatBounds.convert(O);
                            var pe = $ && $.bearing || 0;
                            return this._cameraForBoxAndBearing(O.getNorthWest(), O.getSouthEast(), pe, $);
                        }, z.prototype._cameraForBoxAndBearing = function(O, $, pe, de) {
                            var Ie = {
                                top: 0,
                                bottom: 0,
                                right: 0,
                                left: 0
                            };
                            if (de = i.extend({
                                padding: Ie,
                                offset: [
                                    0,
                                    0
                                ],
                                maxZoom: this.transform.maxZoom
                            }, de), typeof de.padding == "number") {
                                var $e = de.padding;
                                de.padding = {
                                    top: $e,
                                    bottom: $e,
                                    right: $e,
                                    left: $e
                                };
                            }
                            de.padding = i.extend(Ie, de.padding);
                            var pt = this.transform, Kt = pt.padding, ir = pt.project(i.LngLat.convert(O)), Jt = pt.project(i.LngLat.convert($)), vt = ir.rotate(-pe * Math.PI / 180), Pt = Jt.rotate(-pe * Math.PI / 180), Wt = new i.Point(Math.max(vt.x, Pt.x), Math.max(vt.y, Pt.y)), rr = new i.Point(Math.min(vt.x, Pt.x), Math.min(vt.y, Pt.y)), dr = Wt.sub(rr), pr = (pt.width - (Kt.left + Kt.right + de.padding.left + de.padding.right)) / dr.x, kr = (pt.height - (Kt.top + Kt.bottom + de.padding.top + de.padding.bottom)) / dr.y;
                            if (kr < 0 || pr < 0) {
                                i.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                                return;
                            }
                            var Ar = Math.min(pt.scaleZoom(pt.scale * Math.min(pr, kr)), de.maxZoom), gr = typeof de.offset.x == "number" ? new i.Point(de.offset.x, de.offset.y) : i.Point.convert(de.offset), Cr = (de.padding.left - de.padding.right) / 2, cr = (de.padding.top - de.padding.bottom) / 2, Gr = new i.Point(Cr, cr), ei = Gr.rotate(pe * Math.PI / 180), yi = gr.add(ei), tn = yi.mult(pt.scale / pt.zoomScale(Ar)), Ri = pt.unproject(ir.add(Jt).div(2).sub(tn));
                            return {
                                center: Ri,
                                zoom: Ar,
                                bearing: pe
                            };
                        }, z.prototype.fitBounds = function(O, $, pe) {
                            return this._fitInternal(this.cameraForBounds(O, $), $, pe);
                        }, z.prototype.fitScreenCoordinates = function(O, $, pe, de, Ie) {
                            return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(i.Point.convert(O)), this.transform.pointLocation(i.Point.convert($)), pe, de), de, Ie);
                        }, z.prototype._fitInternal = function(O, $, pe) {
                            return O ? ($ = i.extend(O, $), delete $.padding, $.linear ? this.easeTo($, pe) : this.flyTo($, pe)) : this;
                        }, z.prototype.jumpTo = function(O, $) {
                            this.stop();
                            var pe = this.transform, de = !1, Ie = !1, $e = !1;
                            return "zoom" in O && pe.zoom !== +O.zoom && (de = !0, pe.zoom = +O.zoom), O.center !== void 0 && (pe.center = i.LngLat.convert(O.center)), "bearing" in O && pe.bearing !== +O.bearing && (Ie = !0, pe.bearing = +O.bearing), "pitch" in O && pe.pitch !== +O.pitch && ($e = !0, pe.pitch = +O.pitch), O.padding != null && !pe.isPaddingEqual(O.padding) && (pe.padding = O.padding), this.fire(new i.Event("movestart", $)).fire(new i.Event("move", $)), de && this.fire(new i.Event("zoomstart", $)).fire(new i.Event("zoom", $)).fire(new i.Event("zoomend", $)), Ie && this.fire(new i.Event("rotatestart", $)).fire(new i.Event("rotate", $)).fire(new i.Event("rotateend", $)), $e && this.fire(new i.Event("pitchstart", $)).fire(new i.Event("pitch", $)).fire(new i.Event("pitchend", $)), this.fire(new i.Event("moveend", $));
                        }, z.prototype.easeTo = function(O, $) {
                            var pe = this;
                            this._stop(!1, O.easeId), O = i.extend({
                                offset: [
                                    0,
                                    0
                                ],
                                duration: 500,
                                easing: i.ease
                            }, O), (O.animate === !1 || !O.essential && i.browser.prefersReducedMotion) && (O.duration = 0);
                            var de = this.transform, Ie = this.getZoom(), $e = this.getBearing(), pt = this.getPitch(), Kt = this.getPadding(), ir = "zoom" in O ? +O.zoom : Ie, Jt = "bearing" in O ? this._normalizeBearing(O.bearing, $e) : $e, vt = "pitch" in O ? +O.pitch : pt, Pt = "padding" in O ? O.padding : de.padding, Wt = i.Point.convert(O.offset), rr = de.centerPoint.add(Wt), dr = de.pointLocation(rr), pr = i.LngLat.convert(O.center || dr);
                            this._normalizeCenter(pr);
                            var kr = de.project(dr), Ar = de.project(pr).sub(kr), gr = de.zoomScale(ir - Ie), Cr, cr;
                            O.around && (Cr = i.LngLat.convert(O.around), cr = de.locationPoint(Cr));
                            var Gr = {
                                moving: this._moving,
                                zooming: this._zooming,
                                rotating: this._rotating,
                                pitching: this._pitching
                            };
                            return this._zooming = this._zooming || ir !== Ie, this._rotating = this._rotating || $e !== Jt, this._pitching = this._pitching || vt !== pt, this._padding = !de.isPaddingEqual(Pt), this._easeId = O.easeId, this._prepareEase($, O.noMoveStart, Gr), this._ease(function(ei) {
                                if (pe._zooming && (de.zoom = i.number(Ie, ir, ei)), pe._rotating && (de.bearing = i.number($e, Jt, ei)), pe._pitching && (de.pitch = i.number(pt, vt, ei)), pe._padding && (de.interpolatePadding(Kt, Pt, ei), rr = de.centerPoint.add(Wt)), Cr) de.setLocationAtPoint(Cr, cr);
                                else {
                                    var yi = de.zoomScale(de.zoom - Ie), tn = ir > Ie ? Math.min(2, gr) : Math.max(.5, gr), Ri = Math.pow(tn, 1 - ei), ln = de.unproject(kr.add(Ar.mult(ei * Ri)).mult(yi));
                                    de.setLocationAtPoint(de.renderWorldCopies ? ln.wrap() : ln, rr);
                                }
                                pe._fireMoveEvents($);
                            }, function(ei) {
                                pe._afterEase($, ei);
                            }, O), this;
                        }, z.prototype._prepareEase = function(O, $, pe) {
                            pe === void 0 && (pe = {}), this._moving = !0, !$ && !pe.moving && this.fire(new i.Event("movestart", O)), this._zooming && !pe.zooming && this.fire(new i.Event("zoomstart", O)), this._rotating && !pe.rotating && this.fire(new i.Event("rotatestart", O)), this._pitching && !pe.pitching && this.fire(new i.Event("pitchstart", O));
                        }, z.prototype._fireMoveEvents = function(O) {
                            this.fire(new i.Event("move", O)), this._zooming && this.fire(new i.Event("zoom", O)), this._rotating && this.fire(new i.Event("rotate", O)), this._pitching && this.fire(new i.Event("pitch", O));
                        }, z.prototype._afterEase = function(O, $) {
                            if (!(this._easeId && $ && this._easeId === $)) {
                                delete this._easeId;
                                var pe = this._zooming, de = this._rotating, Ie = this._pitching;
                                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, pe && this.fire(new i.Event("zoomend", O)), de && this.fire(new i.Event("rotateend", O)), Ie && this.fire(new i.Event("pitchend", O)), this.fire(new i.Event("moveend", O));
                            }
                        }, z.prototype.flyTo = function(O, $) {
                            var pe = this;
                            if (!O.essential && i.browser.prefersReducedMotion) {
                                var de = i.pick(O, [
                                    "center",
                                    "zoom",
                                    "bearing",
                                    "pitch",
                                    "around"
                                ]);
                                return this.jumpTo(de, $);
                            }
                            this.stop(), O = i.extend({
                                offset: [
                                    0,
                                    0
                                ],
                                speed: 1.2,
                                curve: 1.42,
                                easing: i.ease
                            }, O);
                            var Ie = this.transform, $e = this.getZoom(), pt = this.getBearing(), Kt = this.getPitch(), ir = this.getPadding(), Jt = "zoom" in O ? i.clamp(+O.zoom, Ie.minZoom, Ie.maxZoom) : $e, vt = "bearing" in O ? this._normalizeBearing(O.bearing, pt) : pt, Pt = "pitch" in O ? +O.pitch : Kt, Wt = "padding" in O ? O.padding : Ie.padding, rr = Ie.zoomScale(Jt - $e), dr = i.Point.convert(O.offset), pr = Ie.centerPoint.add(dr), kr = Ie.pointLocation(pr), Ar = i.LngLat.convert(O.center || kr);
                            this._normalizeCenter(Ar);
                            var gr = Ie.project(kr), Cr = Ie.project(Ar).sub(gr), cr = O.curve, Gr = Math.max(Ie.width, Ie.height), ei = Gr / rr, yi = Cr.mag();
                            if ("minZoom" in O) {
                                var tn = i.clamp(Math.min(O.minZoom, $e, Jt), Ie.minZoom, Ie.maxZoom), Ri = Gr / Ie.zoomScale(tn - $e);
                                cr = Math.sqrt(Ri / yi * 2);
                            }
                            var ln = cr * cr;
                            function Qn(fo) {
                                var as = (ei * ei - Gr * Gr + (fo ? -1 : 1) * ln * ln * yi * yi) / (2 * (fo ? ei : Gr) * ln * yi);
                                return Math.log(Math.sqrt(as * as + 1) - as);
                            }
                            function qn(fo) {
                                return (Math.exp(fo) - Math.exp(-fo)) / 2;
                            }
                            function rn(fo) {
                                return (Math.exp(fo) + Math.exp(-fo)) / 2;
                            }
                            function bn(fo) {
                                return qn(fo) / rn(fo);
                            }
                            var mn = Qn(0), Gn = function(fo) {
                                return rn(mn) / rn(mn + cr * fo);
                            }, da = function(fo) {
                                return Gr * ((rn(mn) * bn(mn + cr * fo) - qn(mn)) / ln) / yi;
                            }, No = (Qn(1) - mn) / cr;
                            if (Math.abs(yi) < 1e-6 || !isFinite(No)) {
                                if (Math.abs(Gr - ei) < 1e-6) return this.easeTo(O, $);
                                var Do = ei < Gr ? -1 : 1;
                                No = Math.abs(Math.log(ei / Gr)) / cr, da = function() {
                                    return 0;
                                }, Gn = function(fo) {
                                    return Math.exp(Do * cr * fo);
                                };
                            }
                            if ("duration" in O) O.duration = +O.duration;
                            else {
                                var ps = "screenSpeed" in O ? +O.screenSpeed / cr : +O.speed;
                                O.duration = 1e3 * No / ps;
                            }
                            return O.maxDuration && O.duration > O.maxDuration && (O.duration = 0), this._zooming = !0, this._rotating = pt !== vt, this._pitching = Pt !== Kt, this._padding = !Ie.isPaddingEqual(Wt), this._prepareEase($, !1), this._ease(function(fo) {
                                var as = fo * No, tl = 1 / Gn(as);
                                Ie.zoom = fo === 1 ? Jt : $e + Ie.scaleZoom(tl), pe._rotating && (Ie.bearing = i.number(pt, vt, fo)), pe._pitching && (Ie.pitch = i.number(Kt, Pt, fo)), pe._padding && (Ie.interpolatePadding(ir, Wt, fo), pr = Ie.centerPoint.add(dr));
                                var zu = fo === 1 ? Ar : Ie.unproject(gr.add(Cr.mult(da(as))).mult(tl));
                                Ie.setLocationAtPoint(Ie.renderWorldCopies ? zu.wrap() : zu, pr), pe._fireMoveEvents($);
                            }, function() {
                                return pe._afterEase($);
                            }, O), this;
                        }, z.prototype.isEasing = function() {
                            return !!this._easeFrameId;
                        }, z.prototype.stop = function() {
                            return this._stop();
                        }, z.prototype._stop = function(O, $) {
                            if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                                var pe = this._onEaseEnd;
                                delete this._onEaseEnd, pe.call(this, $);
                            }
                            if (!O) {
                                var de = this.handlers;
                                de && de.stop(!1);
                            }
                            return this;
                        }, z.prototype._ease = function(O, $, pe) {
                            pe.animate === !1 || pe.duration === 0 ? (O(1), $()) : (this._easeStart = i.browser.now(), this._easeOptions = pe, this._onEaseFrame = O, this._onEaseEnd = $, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
                        }, z.prototype._renderFrameCallback = function() {
                            var O = Math.min((i.browser.now() - this._easeStart) / this._easeOptions.duration, 1);
                            this._onEaseFrame(this._easeOptions.easing(O)), O < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                        }, z.prototype._normalizeBearing = function(O, $) {
                            O = i.wrap(O, -180, 180);
                            var pe = Math.abs(O - $);
                            return Math.abs(O - 360 - $) < pe && (O -= 360), Math.abs(O + 360 - $) < pe && (O += 360), O;
                        }, z.prototype._normalizeCenter = function(O) {
                            var $ = this.transform;
                            if (!(!$.renderWorldCopies || $.lngRange)) {
                                var pe = O.lng - $.center.lng;
                                O.lng += pe > 180 ? -360 : pe < -180 ? 360 : 0;
                            }
                        }, z;
                    }(i.Evented), Rn = function(z) {
                        z === void 0 && (z = {}), this.options = z, i.bindAll([
                            "_toggleAttribution",
                            "_updateEditLink",
                            "_updateData",
                            "_updateCompact"
                        ], this);
                    };
                    Rn.prototype.getDefaultPosition = function() {
                        return "bottom-right";
                    }, Rn.prototype.onAdd = function(z) {
                        var K = this.options && this.options.compact;
                        return this._map = z, this._container = o.create("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = o.create("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = o.create("div", "mapboxgl-ctrl-attrib-inner", this._container), this._innerContainer.setAttribute("role", "list"), K && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), K === void 0 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
                    }, Rn.prototype.onRemove = function() {
                        o.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
                    }, Rn.prototype._setElementTitle = function(z, K) {
                        var O = this._map._getUIString("AttributionControl." + K);
                        z.title = O, z.setAttribute("aria-label", O);
                    }, Rn.prototype._toggleAttribution = function() {
                        this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-pressed", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-pressed", "true"));
                    }, Rn.prototype._updateEditLink = function() {
                        var z = this._editLink;
                        z || (z = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                        var K = [
                            {
                                key: "owner",
                                value: this.styleOwner
                            },
                            {
                                key: "id",
                                value: this.styleId
                            },
                            {
                                key: "access_token",
                                value: this._map._requestManager._customAccessToken || i.config.ACCESS_TOKEN
                            }
                        ];
                        if (z) {
                            var O = K.reduce(function($, pe, de) {
                                return pe.value && ($ += pe.key + "=" + pe.value + (de < K.length - 1 ? "&" : "")), $;
                            }, "?");
                            z.href = i.config.FEEDBACK_URL + "/" + O + (this._map._hash ? this._map._hash.getHashString(!0) : ""), z.rel = "noopener nofollow", this._setElementTitle(z, "MapFeedback");
                        }
                    }, Rn.prototype._updateData = function(z) {
                        z && (z.sourceDataType === "metadata" || z.sourceDataType === "visibility" || z.dataType === "style") && (this._updateAttributions(), this._updateEditLink());
                    }, Rn.prototype._updateAttributions = function() {
                        if (this._map.style) {
                            var z = [];
                            if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? z = z.concat(this.options.customAttribution.map(function($e) {
                                return typeof $e != "string" ? "" : $e;
                            })) : typeof this.options.customAttribution == "string" && z.push(this.options.customAttribution)), this._map.style.stylesheet) {
                                var K = this._map.style.stylesheet;
                                this.styleOwner = K.owner, this.styleId = K.id;
                            }
                            var O = this._map.style.sourceCaches;
                            for(var $ in O){
                                var pe = O[$];
                                if (pe.used) {
                                    var de = pe.getSource();
                                    de.attribution && z.indexOf(de.attribution) < 0 && z.push(de.attribution);
                                }
                            }
                            z.sort(function($e, pt) {
                                return $e.length - pt.length;
                            }), z = z.filter(function($e, pt) {
                                for(var Kt = pt + 1; Kt < z.length; Kt++)if (z[Kt].indexOf($e) >= 0) return !1;
                                return !0;
                            });
                            var Ie = z.join(" | ");
                            Ie !== this._attribHTML && (this._attribHTML = Ie, z.length ? (this._innerContainer.innerHTML = Ie, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
                        }
                    }, Rn.prototype._updateCompact = function() {
                        this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
                    };
                    var Dn = function() {
                        i.bindAll([
                            "_updateLogo"
                        ], this), i.bindAll([
                            "_updateCompact"
                        ], this);
                    };
                    Dn.prototype.onAdd = function(z) {
                        this._map = z, this._container = o.create("div", "mapboxgl-ctrl");
                        var K = o.create("a", "mapboxgl-ctrl-logo");
                        return K.target = "_blank", K.rel = "noopener nofollow", K.href = "https://www.mapbox.com/", K.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), K.setAttribute("rel", "noopener nofollow"), this._container.appendChild(K), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
                    }, Dn.prototype.onRemove = function() {
                        o.remove(this._container), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
                    }, Dn.prototype.getDefaultPosition = function() {
                        return "bottom-left";
                    }, Dn.prototype._updateLogo = function(z) {
                        (!z || z.sourceDataType === "metadata") && (this._container.style.display = this._logoRequired() ? "block" : "none");
                    }, Dn.prototype._logoRequired = function() {
                        if (this._map.style) {
                            var z = this._map.style.sourceCaches;
                            for(var K in z){
                                var O = z[K].getSource();
                                if (O.mapbox_logo) return !0;
                            }
                            return !1;
                        }
                    }, Dn.prototype._updateCompact = function() {
                        var z = this._container.children;
                        if (z.length) {
                            var K = z[0];
                            this._map.getCanvasContainer().offsetWidth < 250 ? K.classList.add("mapboxgl-compact") : K.classList.remove("mapboxgl-compact");
                        }
                    };
                    var fn = function() {
                        this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
                    };
                    fn.prototype.add = function(z) {
                        var K = ++this._id, O = this._queue;
                        return O.push({
                            callback: z,
                            id: K,
                            cancelled: !1
                        }), K;
                    }, fn.prototype.remove = function(z) {
                        for(var K = this._currentlyRunning, O = K ? this._queue.concat(K) : this._queue, $ = 0, pe = O; $ < pe.length; $ += 1){
                            var de = pe[$];
                            if (de.id === z) {
                                de.cancelled = !0;
                                return;
                            }
                        }
                    }, fn.prototype.run = function(z) {
                        z === void 0 && (z = 0);
                        var K = this._currentlyRunning = this._queue;
                        this._queue = [];
                        for(var O = 0, $ = K; O < $.length; O += 1){
                            var pe = $[O];
                            if (!pe.cancelled && (pe.callback(z), this._cleared)) break;
                        }
                        this._cleared = !1, this._currentlyRunning = !1;
                    }, fn.prototype.clear = function() {
                        this._currentlyRunning && (this._cleared = !0), this._queue = [];
                    };
                    var Ai = {
                        "AttributionControl.ToggleAttribution": "Toggle attribution",
                        "AttributionControl.MapFeedback": "Map feedback",
                        "FullscreenControl.Enter": "Enter fullscreen",
                        "FullscreenControl.Exit": "Exit fullscreen",
                        "GeolocateControl.FindMyLocation": "Find my location",
                        "GeolocateControl.LocationNotAvailable": "Location not available",
                        "LogoControl.Title": "Mapbox logo",
                        "NavigationControl.ResetBearing": "Reset bearing to north",
                        "NavigationControl.ZoomIn": "Zoom in",
                        "NavigationControl.ZoomOut": "Zoom out",
                        "ScaleControl.Feet": "ft",
                        "ScaleControl.Meters": "m",
                        "ScaleControl.Kilometers": "km",
                        "ScaleControl.Miles": "mi",
                        "ScaleControl.NauticalMiles": "nm"
                    }, ji = i.window.HTMLImageElement, Ln = i.window.HTMLElement, Un = i.window.ImageBitmap, gn = -2, ca = 22, Kn = 0, Za = 60, wn = {
                        center: [
                            0,
                            0
                        ],
                        zoom: 0,
                        bearing: 0,
                        pitch: 0,
                        minZoom: gn,
                        maxZoom: ca,
                        minPitch: Kn,
                        maxPitch: Za,
                        interactive: !0,
                        scrollZoom: !0,
                        boxZoom: !0,
                        dragRotate: !0,
                        dragPan: !0,
                        keyboard: !0,
                        doubleClickZoom: !0,
                        touchZoomRotate: !0,
                        touchPitch: !0,
                        bearingSnap: 7,
                        clickTolerance: 3,
                        pitchWithRotate: !0,
                        hash: !1,
                        attributionControl: !0,
                        failIfMajorPerformanceCaveat: !1,
                        preserveDrawingBuffer: !1,
                        trackResize: !0,
                        renderWorldCopies: !0,
                        refreshExpiredTiles: !0,
                        maxTileCacheSize: null,
                        localIdeographFontFamily: "sans-serif",
                        transformRequest: null,
                        accessToken: null,
                        fadeDuration: 300,
                        crossSourceCollisions: !0
                    }, vn = function(Y1) {
                        function z(O) {
                            var $ = this;
                            if (O = i.extend({}, wn, O), O.minZoom != null && O.maxZoom != null && O.minZoom > O.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                            if (O.minPitch != null && O.maxPitch != null && O.minPitch > O.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                            if (O.minPitch != null && O.minPitch < Kn) throw new Error("minPitch must be greater than or equal to " + Kn);
                            if (O.maxPitch != null && O.maxPitch > Za) throw new Error("maxPitch must be less than or equal to " + Za);
                            var pe = new yo(O.minZoom, O.maxZoom, O.minPitch, O.maxPitch, O.renderWorldCopies);
                            if (Y1.call(this, pe, O), this._interactive = O.interactive, this._maxTileCacheSize = O.maxTileCacheSize, this._failIfMajorPerformanceCaveat = O.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = O.preserveDrawingBuffer, this._antialias = O.antialias, this._trackResize = O.trackResize, this._bearingSnap = O.bearingSnap, this._refreshExpiredTiles = O.refreshExpiredTiles, this._fadeDuration = O.fadeDuration, this._crossSourceCollisions = O.crossSourceCollisions, this._crossFadingFactor = 1, this._collectResourceTiming = O.collectResourceTiming, this._renderTaskQueue = new fn, this._controls = [], this._mapId = i.uniqueId(), this._locale = i.extend({}, Ai, O.locale), this._clickTolerance = O.clickTolerance, this._requestManager = new i.RequestManager(O.transformRequest, O.accessToken), typeof O.container == "string") {
                                if (this._container = i.window.document.getElementById(O.container), !this._container) throw new Error("Container '" + O.container + "' not found.");
                            } else if (O.container instanceof Ln) this._container = O.container;
                            else throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                            if (O.maxBounds && this.setMaxBounds(O.maxBounds), i.bindAll([
                                "_onWindowOnline",
                                "_onWindowResize",
                                "_onMapScroll",
                                "_contextLost",
                                "_contextRestored"
                            ], this), this._setupContainer(), this._setupPainter(), this.painter === void 0) throw new Error("Failed to initialize WebGL.");
                            this.on("move", function() {
                                return $._update(!1);
                            }), this.on("moveend", function() {
                                return $._update(!1);
                            }), this.on("zoom", function() {
                                return $._update(!0);
                            }), typeof i.window != "undefined" && (i.window.addEventListener("online", this._onWindowOnline, !1), i.window.addEventListener("resize", this._onWindowResize, !1), i.window.addEventListener("orientationchange", this._onWindowResize, !1)), this.handlers = new yn(this, O);
                            var de = typeof O.hash == "string" && O.hash || void 0;
                            this._hash = O.hash && new Hl(de).addTo(this), (!this._hash || !this._hash._onHashChange()) && (this.jumpTo({
                                center: O.center,
                                zoom: O.zoom,
                                bearing: O.bearing,
                                pitch: O.pitch
                            }), O.bounds && (this.resize(), this.fitBounds(O.bounds, i.extend({}, O.fitBoundsOptions, {
                                duration: 0
                            })))), this.resize(), this._localIdeographFontFamily = O.localIdeographFontFamily, O.style && this.setStyle(O.style, {
                                localIdeographFontFamily: O.localIdeographFontFamily
                            }), O.attributionControl && this.addControl(new Rn({
                                customAttribution: O.customAttribution
                            })), this.addControl(new Dn, O.logoPosition), this.on("style.load", function() {
                                $.transform.unmodified && $.jumpTo($.style.stylesheet);
                            }), this.on("data", function(Ie) {
                                $._update(Ie.dataType === "style"), $.fire(new i.Event(Ie.dataType + "data", Ie));
                            }), this.on("dataloading", function(Ie) {
                                $.fire(new i.Event(Ie.dataType + "dataloading", Ie));
                            });
                        }
                        Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z;
                        var K = {
                            showTileBoundaries: {
                                configurable: !0
                            },
                            showPadding: {
                                configurable: !0
                            },
                            showCollisionBoxes: {
                                configurable: !0
                            },
                            showOverdrawInspector: {
                                configurable: !0
                            },
                            repaint: {
                                configurable: !0
                            },
                            vertices: {
                                configurable: !0
                            },
                            version: {
                                configurable: !0
                            }
                        };
                        return z.prototype._getMapId = function() {
                            return this._mapId;
                        }, z.prototype.addControl = function($, pe) {
                            if (pe === void 0 && ($.getDefaultPosition ? pe = $.getDefaultPosition() : pe = "top-right"), !$ || !$.onAdd) return this.fire(new i.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                            var de = $.onAdd(this);
                            this._controls.push($);
                            var Ie = this._controlPositions[pe];
                            return pe.indexOf("bottom") !== -1 ? Ie.insertBefore(de, Ie.firstChild) : Ie.appendChild(de), this;
                        }, z.prototype.removeControl = function($) {
                            if (!$ || !$.onRemove) return this.fire(new i.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                            var pe = this._controls.indexOf($);
                            return pe > -1 && this._controls.splice(pe, 1), $.onRemove(this), this;
                        }, z.prototype.hasControl = function($) {
                            return this._controls.indexOf($) > -1;
                        }, z.prototype.resize = function($) {
                            var pe = this._containerDimensions(), de = pe[0], Ie = pe[1];
                            this._resizeCanvas(de, Ie), this.transform.resize(de, Ie), this.painter.resize(de, Ie);
                            var $e = !this._moving;
                            return $e && (this.stop(), this.fire(new i.Event("movestart", $)).fire(new i.Event("move", $))), this.fire(new i.Event("resize", $)), $e && this.fire(new i.Event("moveend", $)), this;
                        }, z.prototype.getBounds = function() {
                            return this.transform.getBounds();
                        }, z.prototype.getMaxBounds = function() {
                            return this.transform.getMaxBounds();
                        }, z.prototype.setMaxBounds = function($) {
                            return this.transform.setMaxBounds(i.LngLatBounds.convert($)), this._update();
                        }, z.prototype.setMinZoom = function($) {
                            if ($ = $ == null ? gn : $, $ >= gn && $ <= this.transform.maxZoom) return this.transform.minZoom = $, this._update(), this.getZoom() < $ && this.setZoom($), this;
                            throw new Error("minZoom must be between " + gn + " and the current maxZoom, inclusive");
                        }, z.prototype.getMinZoom = function() {
                            return this.transform.minZoom;
                        }, z.prototype.setMaxZoom = function($) {
                            if ($ = $ == null ? ca : $, $ >= this.transform.minZoom) return this.transform.maxZoom = $, this._update(), this.getZoom() > $ && this.setZoom($), this;
                            throw new Error("maxZoom must be greater than the current minZoom");
                        }, z.prototype.getMaxZoom = function() {
                            return this.transform.maxZoom;
                        }, z.prototype.setMinPitch = function($) {
                            if ($ = $ == null ? Kn : $, $ < Kn) throw new Error("minPitch must be greater than or equal to " + Kn);
                            if ($ >= Kn && $ <= this.transform.maxPitch) return this.transform.minPitch = $, this._update(), this.getPitch() < $ && this.setPitch($), this;
                            throw new Error("minPitch must be between " + Kn + " and the current maxPitch, inclusive");
                        }, z.prototype.getMinPitch = function() {
                            return this.transform.minPitch;
                        }, z.prototype.setMaxPitch = function($) {
                            if ($ = $ == null ? Za : $, $ > Za) throw new Error("maxPitch must be less than or equal to " + Za);
                            if ($ >= this.transform.minPitch) return this.transform.maxPitch = $, this._update(), this.getPitch() > $ && this.setPitch($), this;
                            throw new Error("maxPitch must be greater than the current minPitch");
                        }, z.prototype.getMaxPitch = function() {
                            return this.transform.maxPitch;
                        }, z.prototype.getRenderWorldCopies = function() {
                            return this.transform.renderWorldCopies;
                        }, z.prototype.setRenderWorldCopies = function($) {
                            return this.transform.renderWorldCopies = $, this._update();
                        }, z.prototype.project = function($) {
                            return this.transform.locationPoint(i.LngLat.convert($));
                        }, z.prototype.unproject = function($) {
                            return this.transform.pointLocation(i.Point.convert($));
                        }, z.prototype.isMoving = function() {
                            return this._moving || this.handlers.isMoving();
                        }, z.prototype.isZooming = function() {
                            return this._zooming || this.handlers.isZooming();
                        }, z.prototype.isRotating = function() {
                            return this._rotating || this.handlers.isRotating();
                        }, z.prototype._createDelegatedListener = function($, pe, de) {
                            var Ie = this, $e;
                            if ($ === "mouseenter" || $ === "mouseover") {
                                var pt = !1, Kt = function(rr) {
                                    var dr = Ie.getLayer(pe) ? Ie.queryRenderedFeatures(rr.point, {
                                        layers: [
                                            pe
                                        ]
                                    }) : [];
                                    dr.length ? pt || (pt = !0, de.call(Ie, new oe($, Ie, rr.originalEvent, {
                                        features: dr
                                    }))) : pt = !1;
                                }, ir = function() {
                                    pt = !1;
                                };
                                return {
                                    layer: pe,
                                    listener: de,
                                    delegates: {
                                        mousemove: Kt,
                                        mouseout: ir
                                    }
                                };
                            } else if ($ === "mouseleave" || $ === "mouseout") {
                                var Jt = !1, vt = function(rr) {
                                    var dr = Ie.getLayer(pe) ? Ie.queryRenderedFeatures(rr.point, {
                                        layers: [
                                            pe
                                        ]
                                    }) : [];
                                    dr.length ? Jt = !0 : Jt && (Jt = !1, de.call(Ie, new oe($, Ie, rr.originalEvent)));
                                }, Pt = function(rr) {
                                    Jt && (Jt = !1, de.call(Ie, new oe($, Ie, rr.originalEvent)));
                                };
                                return {
                                    layer: pe,
                                    listener: de,
                                    delegates: {
                                        mousemove: vt,
                                        mouseout: Pt
                                    }
                                };
                            } else {
                                var Wt = function(rr) {
                                    var dr = Ie.getLayer(pe) ? Ie.queryRenderedFeatures(rr.point, {
                                        layers: [
                                            pe
                                        ]
                                    }) : [];
                                    dr.length && (rr.features = dr, de.call(Ie, rr), delete rr.features);
                                };
                                return {
                                    layer: pe,
                                    listener: de,
                                    delegates: ($e = {}, $e[$] = Wt, $e)
                                };
                            }
                        }, z.prototype.on = function($, pe, de) {
                            if (de === void 0) return Y1.prototype.on.call(this, $, pe);
                            var Ie = this._createDelegatedListener($, pe, de);
                            this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[$] = this._delegatedListeners[$] || [], this._delegatedListeners[$].push(Ie);
                            for(var $e in Ie.delegates)this.on($e, Ie.delegates[$e]);
                            return this;
                        }, z.prototype.once = function($, pe, de) {
                            if (de === void 0) return Y1.prototype.once.call(this, $, pe);
                            var Ie = this._createDelegatedListener($, pe, de);
                            for(var $e in Ie.delegates)this.once($e, Ie.delegates[$e]);
                            return this;
                        }, z.prototype.off = function($, pe, de) {
                            var Ie = this;
                            if (de === void 0) return Y1.prototype.off.call(this, $, pe);
                            var $e = function(pt) {
                                for(var Kt = pt[$], ir = 0; ir < Kt.length; ir++){
                                    var Jt = Kt[ir];
                                    if (Jt.layer === pe && Jt.listener === de) {
                                        for(var vt in Jt.delegates)Ie.off(vt, Jt.delegates[vt]);
                                        return Kt.splice(ir, 1), Ie;
                                    }
                                }
                            };
                            return this._delegatedListeners && this._delegatedListeners[$] && $e(this._delegatedListeners), this;
                        }, z.prototype.queryRenderedFeatures = function($, pe) {
                            if (!this.style) return [];
                            pe === void 0 && $ !== void 0 && !($ instanceof i.Point) && !Array.isArray($) && (pe = $, $ = void 0), pe = pe || {}, $ = $ || [
                                [
                                    0,
                                    0
                                ],
                                [
                                    this.transform.width,
                                    this.transform.height
                                ]
                            ];
                            var de;
                            if ($ instanceof i.Point || typeof $[0] == "number") de = [
                                i.Point.convert($)
                            ];
                            else {
                                var Ie = i.Point.convert($[0]), $e = i.Point.convert($[1]);
                                de = [
                                    Ie,
                                    new i.Point($e.x, Ie.y),
                                    $e,
                                    new i.Point(Ie.x, $e.y),
                                    Ie
                                ];
                            }
                            return this.style.queryRenderedFeatures(de, pe, this.transform);
                        }, z.prototype.querySourceFeatures = function($, pe) {
                            return this.style.querySourceFeatures($, pe);
                        }, z.prototype.setStyle = function($, pe) {
                            return pe = i.extend({}, {
                                localIdeographFontFamily: this._localIdeographFontFamily
                            }, pe), pe.diff !== !1 && pe.localIdeographFontFamily === this._localIdeographFontFamily && this.style && $ ? (this._diffStyle($, pe), this) : (this._localIdeographFontFamily = pe.localIdeographFontFamily, this._updateStyle($, pe));
                        }, z.prototype._getUIString = function($) {
                            var pe = this._locale[$];
                            if (pe == null) throw new Error("Missing UI string '" + $ + "'");
                            return pe;
                        }, z.prototype._updateStyle = function($, pe) {
                            if (this.style && (this.style.setEventedParent(null), this.style._remove()), $) this.style = new mu(this, pe || {});
                            else return delete this.style, this;
                            return this.style.setEventedParent(this, {
                                style: this.style
                            }), typeof $ == "string" ? this.style.loadURL($) : this.style.loadJSON($), this;
                        }, z.prototype._lazyInitEmptyStyle = function() {
                            this.style || (this.style = new mu(this, {}), this.style.setEventedParent(this, {
                                style: this.style
                            }), this.style.loadEmpty());
                        }, z.prototype._diffStyle = function($, pe) {
                            var de = this;
                            if (typeof $ == "string") {
                                var Ie = this._requestManager.normalizeStyleURL($), $e = this._requestManager.transformRequest(Ie, i.ResourceType.Style);
                                i.getJSON($e, function(pt, Kt) {
                                    pt ? de.fire(new i.ErrorEvent(pt)) : Kt && de._updateDiff(Kt, pe);
                                });
                            } else typeof $ == "object" && this._updateDiff($, pe);
                        }, z.prototype._updateDiff = function($, pe) {
                            try {
                                this.style.setState($) && this._update(!0);
                            } catch (de) {
                                i.warnOnce("Unable to perform style diff: " + (de.message || de.error || de) + ".  Rebuilding the style from scratch."), this._updateStyle($, pe);
                            }
                        }, z.prototype.getStyle = function() {
                            if (this.style) return this.style.serialize();
                        }, z.prototype.isStyleLoaded = function() {
                            return this.style ? this.style.loaded() : i.warnOnce("There is no style added to the map.");
                        }, z.prototype.addSource = function($, pe) {
                            return this._lazyInitEmptyStyle(), this.style.addSource($, pe), this._update(!0);
                        }, z.prototype.isSourceLoaded = function($) {
                            var pe = this.style && this.style.sourceCaches[$];
                            if (pe === void 0) {
                                this.fire(new i.ErrorEvent(new Error("There is no source with ID '" + $ + "'")));
                                return;
                            }
                            return pe.loaded();
                        }, z.prototype.areTilesLoaded = function() {
                            var $ = this.style && this.style.sourceCaches;
                            for(var pe in $){
                                var de = $[pe], Ie = de._tiles;
                                for(var $e in Ie){
                                    var pt = Ie[$e];
                                    if (!(pt.state === "loaded" || pt.state === "errored")) return !1;
                                }
                            }
                            return !0;
                        }, z.prototype.addSourceType = function($, pe, de) {
                            return this._lazyInitEmptyStyle(), this.style.addSourceType($, pe, de);
                        }, z.prototype.removeSource = function($) {
                            return this.style.removeSource($), this._update(!0);
                        }, z.prototype.getSource = function($) {
                            return this.style.getSource($);
                        }, z.prototype.addImage = function($, pe, de) {
                            de === void 0 && (de = {});
                            var Ie = de.pixelRatio;
                            Ie === void 0 && (Ie = 1);
                            var $e = de.sdf;
                            $e === void 0 && ($e = !1);
                            var pt = de.stretchX, Kt = de.stretchY, ir = de.content;
                            this._lazyInitEmptyStyle();
                            var Jt = 0;
                            if (pe instanceof ji || Un && pe instanceof Un) {
                                var vt = i.browser.getImageData(pe), Pt = vt.width, Wt = vt.height, rr = vt.data;
                                this.style.addImage($, {
                                    data: new i.RGBAImage({
                                        width: Pt,
                                        height: Wt
                                    }, rr),
                                    pixelRatio: Ie,
                                    stretchX: pt,
                                    stretchY: Kt,
                                    content: ir,
                                    sdf: $e,
                                    version: Jt
                                });
                            } else {
                                if (pe.width === void 0 || pe.height === void 0) return this.fire(new i.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                var dr = pe.width, pr = pe.height, kr = pe.data, Ar = pe;
                                this.style.addImage($, {
                                    data: new i.RGBAImage({
                                        width: dr,
                                        height: pr
                                    }, new Uint8Array(kr)),
                                    pixelRatio: Ie,
                                    stretchX: pt,
                                    stretchY: Kt,
                                    content: ir,
                                    sdf: $e,
                                    version: Jt,
                                    userImage: Ar
                                }), Ar.onAdd && Ar.onAdd(this, $);
                            }
                        }, z.prototype.updateImage = function($, pe) {
                            var de = this.style.getImage($);
                            if (!de) return this.fire(new i.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                            var Ie = pe instanceof ji || Un && pe instanceof Un ? i.browser.getImageData(pe) : pe, $e = Ie.width, pt = Ie.height, Kt = Ie.data;
                            if ($e === void 0 || pt === void 0) return this.fire(new i.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                            if ($e !== de.data.width || pt !== de.data.height) return this.fire(new i.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                            var ir = !(pe instanceof ji || Un && pe instanceof Un);
                            de.data.replace(Kt, ir), this.style.updateImage($, de);
                        }, z.prototype.hasImage = function($) {
                            return $ ? !!this.style.getImage($) : (this.fire(new i.ErrorEvent(new Error("Missing required image id"))), !1);
                        }, z.prototype.removeImage = function($) {
                            this.style.removeImage($);
                        }, z.prototype.loadImage = function($, pe) {
                            i.getImage(this._requestManager.transformRequest($, i.ResourceType.Image), pe);
                        }, z.prototype.listImages = function() {
                            return this.style.listImages();
                        }, z.prototype.addLayer = function($, pe) {
                            return this._lazyInitEmptyStyle(), this.style.addLayer($, pe), this._update(!0);
                        }, z.prototype.moveLayer = function($, pe) {
                            return this.style.moveLayer($, pe), this._update(!0);
                        }, z.prototype.removeLayer = function($) {
                            return this.style.removeLayer($), this._update(!0);
                        }, z.prototype.getLayer = function($) {
                            return this.style.getLayer($);
                        }, z.prototype.setLayerZoomRange = function($, pe, de) {
                            return this.style.setLayerZoomRange($, pe, de), this._update(!0);
                        }, z.prototype.setFilter = function($, pe, de) {
                            return de === void 0 && (de = {}), this.style.setFilter($, pe, de), this._update(!0);
                        }, z.prototype.getFilter = function($) {
                            return this.style.getFilter($);
                        }, z.prototype.setPaintProperty = function($, pe, de, Ie) {
                            return Ie === void 0 && (Ie = {}), this.style.setPaintProperty($, pe, de, Ie), this._update(!0);
                        }, z.prototype.getPaintProperty = function($, pe) {
                            return this.style.getPaintProperty($, pe);
                        }, z.prototype.setLayoutProperty = function($, pe, de, Ie) {
                            return Ie === void 0 && (Ie = {}), this.style.setLayoutProperty($, pe, de, Ie), this._update(!0);
                        }, z.prototype.getLayoutProperty = function($, pe) {
                            return this.style.getLayoutProperty($, pe);
                        }, z.prototype.setLight = function($, pe) {
                            return pe === void 0 && (pe = {}), this._lazyInitEmptyStyle(), this.style.setLight($, pe), this._update(!0);
                        }, z.prototype.getLight = function() {
                            return this.style.getLight();
                        }, z.prototype.setFeatureState = function($, pe) {
                            return this.style.setFeatureState($, pe), this._update();
                        }, z.prototype.removeFeatureState = function($, pe) {
                            return this.style.removeFeatureState($, pe), this._update();
                        }, z.prototype.getFeatureState = function($) {
                            return this.style.getFeatureState($);
                        }, z.prototype.getContainer = function() {
                            return this._container;
                        }, z.prototype.getCanvasContainer = function() {
                            return this._canvasContainer;
                        }, z.prototype.getCanvas = function() {
                            return this._canvas;
                        }, z.prototype._containerDimensions = function() {
                            var $ = 0, pe = 0;
                            return this._container && ($ = this._container.clientWidth || 400, pe = this._container.clientHeight || 300), [
                                $,
                                pe
                            ];
                        }, z.prototype._detectMissingCSS = function() {
                            var $ = i.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color");
                            $ !== "rgb(250, 128, 114)" && i.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                        }, z.prototype._setupContainer = function() {
                            var $ = this._container;
                            $.classList.add("mapboxgl-map");
                            var pe = this._missingCSSCanary = o.create("div", "mapboxgl-canary", $);
                            pe.style.visibility = "hidden", this._detectMissingCSS();
                            var de = this._canvasContainer = o.create("div", "mapboxgl-canvas-container", $);
                            this._interactive && de.classList.add("mapboxgl-interactive"), this._canvas = o.create("canvas", "mapboxgl-canvas", de), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", "0"), this._canvas.setAttribute("aria-label", "Map"), this._canvas.setAttribute("role", "region");
                            var Ie = this._containerDimensions();
                            this._resizeCanvas(Ie[0], Ie[1]);
                            var $e = this._controlContainer = o.create("div", "mapboxgl-control-container", $), pt = this._controlPositions = {};
                            [
                                "top-left",
                                "top-right",
                                "bottom-left",
                                "bottom-right"
                            ].forEach(function(Kt) {
                                pt[Kt] = o.create("div", "mapboxgl-ctrl-" + Kt, $e);
                            }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                        }, z.prototype._resizeCanvas = function($, pe) {
                            var de = i.browser.devicePixelRatio || 1;
                            this._canvas.width = de * $, this._canvas.height = de * pe, this._canvas.style.width = $ + "px", this._canvas.style.height = pe + "px";
                        }, z.prototype._setupPainter = function() {
                            var $ = i.extend({}, a.webGLContextAttributes, {
                                failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                                preserveDrawingBuffer: this._preserveDrawingBuffer,
                                antialias: this._antialias || !1
                            }), pe = this._canvas.getContext("webgl", $) || this._canvas.getContext("experimental-webgl", $);
                            if (!pe) {
                                this.fire(new i.ErrorEvent(new Error("Failed to initialize WebGL")));
                                return;
                            }
                            this.painter = new co(pe, this.transform), i.webpSupported.testSupport(pe);
                        }, z.prototype._contextLost = function($) {
                            $.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new i.Event("webglcontextlost", {
                                originalEvent: $
                            }));
                        }, z.prototype._contextRestored = function($) {
                            this._setupPainter(), this.resize(), this._update(), this.fire(new i.Event("webglcontextrestored", {
                                originalEvent: $
                            }));
                        }, z.prototype._onMapScroll = function($) {
                            if ($.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                        }, z.prototype.loaded = function() {
                            return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                        }, z.prototype._update = function($) {
                            return this.style ? (this._styleDirty = this._styleDirty || $, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                        }, z.prototype._requestRenderFrame = function($) {
                            return this._update(), this._renderTaskQueue.add($);
                        }, z.prototype._cancelRenderFrame = function($) {
                            this._renderTaskQueue.remove($);
                        }, z.prototype._render = function($) {
                            var pe = this, de, Ie = 0, $e = this.painter.context.extTimerQuery;
                            if (this.listens("gpu-timing-frame") && (de = $e.createQueryEXT(), $e.beginQueryEXT($e.TIME_ELAPSED_EXT, de), Ie = i.browser.now()), this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run($), !this._removed) {
                                var pt = !1;
                                if (this.style && this._styleDirty) {
                                    this._styleDirty = !1;
                                    var Kt = this.transform.zoom, ir = i.browser.now();
                                    this.style.zoomHistory.update(Kt, ir);
                                    var Jt = new i.EvaluationParameters(Kt, {
                                        now: ir,
                                        fadeDuration: this._fadeDuration,
                                        zoomHistory: this.style.zoomHistory,
                                        transition: this.style.getTransition()
                                    }), vt = Jt.crossFadingFactor();
                                    (vt !== 1 || vt !== this._crossFadingFactor) && (pt = !0, this._crossFadingFactor = vt), this.style.update(Jt);
                                }
                                if (this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, this._fadeDuration, this._crossSourceCollisions), this.painter.render(this.style, {
                                    showTileBoundaries: this.showTileBoundaries,
                                    showOverdrawInspector: this._showOverdrawInspector,
                                    rotating: this.isRotating(),
                                    zooming: this.isZooming(),
                                    moving: this.isMoving(),
                                    fadeDuration: this._fadeDuration,
                                    showPadding: this.showPadding,
                                    gpuTiming: !!this.listens("gpu-timing-layer")
                                }), this.fire(new i.Event("render")), this.loaded() && !this._loaded && (this._loaded = !0, this.fire(new i.Event("load"))), this.style && (this.style.hasTransitions() || pt) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), this.listens("gpu-timing-frame")) {
                                    var Pt = i.browser.now() - Ie;
                                    $e.endQueryEXT($e.TIME_ELAPSED_EXT, de), setTimeout(function() {
                                        var dr = $e.getQueryObjectEXT(de, $e.QUERY_RESULT_EXT) / 1e6;
                                        $e.deleteQueryEXT(de), pe.fire(new i.Event("gpu-timing-frame", {
                                            cpuTime: Pt,
                                            gpuTime: dr
                                        }));
                                    }, 50);
                                }
                                if (this.listens("gpu-timing-layer")) {
                                    var Wt = this.painter.collectGpuTimers();
                                    setTimeout(function() {
                                        var dr = pe.painter.queryGpuTimers(Wt);
                                        pe.fire(new i.Event("gpu-timing-layer", {
                                            layerTimes: dr
                                        }));
                                    }, 50);
                                }
                                var rr = this._sourcesDirty || this._styleDirty || this._placementDirty;
                                return rr || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new i.Event("idle")), this._loaded && !this._fullyLoaded && !rr && (this._fullyLoaded = !0), this;
                            }
                        }, z.prototype.remove = function() {
                            this._hash && this._hash.remove();
                            for(var $ = 0, pe = this._controls; $ < pe.length; $ += 1){
                                var de = pe[$];
                                de.onRemove(this);
                            }
                            this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), typeof i.window != "undefined" && (i.window.removeEventListener("resize", this._onWindowResize, !1), i.window.removeEventListener("orientationchange", this._onWindowResize, !1), i.window.removeEventListener("online", this._onWindowOnline, !1));
                            var Ie = this.painter.context.gl.getExtension("WEBGL_lose_context");
                            Ie && Ie.loseContext && Ie.loseContext(), Aa(this._canvasContainer), Aa(this._controlContainer), Aa(this._missingCSSCanary), this._container.classList.remove("mapboxgl-map"), this._removed = !0, this.fire(new i.Event("remove"));
                        }, z.prototype.triggerRepaint = function() {
                            var $ = this;
                            this.style && !this._frame && (this._frame = i.browser.frame(function(pe) {
                                $._frame = null, $._render(pe);
                            }));
                        }, z.prototype._onWindowOnline = function() {
                            this._update();
                        }, z.prototype._onWindowResize = function($) {
                            this._trackResize && this.resize({
                                originalEvent: $
                            })._update();
                        }, K.showTileBoundaries.get = function() {
                            return !!this._showTileBoundaries;
                        }, K.showTileBoundaries.set = function(O) {
                            this._showTileBoundaries !== O && (this._showTileBoundaries = O, this._update());
                        }, K.showPadding.get = function() {
                            return !!this._showPadding;
                        }, K.showPadding.set = function(O) {
                            this._showPadding !== O && (this._showPadding = O, this._update());
                        }, K.showCollisionBoxes.get = function() {
                            return !!this._showCollisionBoxes;
                        }, K.showCollisionBoxes.set = function(O) {
                            this._showCollisionBoxes !== O && (this._showCollisionBoxes = O, O ? this.style._generateCollisionBoxes() : this._update());
                        }, K.showOverdrawInspector.get = function() {
                            return !!this._showOverdrawInspector;
                        }, K.showOverdrawInspector.set = function(O) {
                            this._showOverdrawInspector !== O && (this._showOverdrawInspector = O, this._update());
                        }, K.repaint.get = function() {
                            return !!this._repaint;
                        }, K.repaint.set = function(O) {
                            this._repaint !== O && (this._repaint = O, this.triggerRepaint());
                        }, K.vertices.get = function() {
                            return !!this._vertices;
                        }, K.vertices.set = function(O) {
                            this._vertices = O, this._update();
                        }, z.prototype._setCacheLimits = function($, pe) {
                            i.setCacheLimits($, pe);
                        }, K.version.get = function() {
                            return i.version;
                        }, Object.defineProperties(z.prototype, K), z;
                    }(to);
                    function Aa(Y1) {
                        Y1.parentNode && Y1.parentNode.removeChild(Y1);
                    }
                    var aa = {
                        showCompass: !0,
                        showZoom: !0,
                        visualizePitch: !1
                    }, Xn = function(z) {
                        var K = this;
                        this.options = i.extend({}, aa, z), this._container = o.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", function(O) {
                            return O.preventDefault();
                        }), this.options.showZoom && (i.bindAll([
                            "_setButtonTitle",
                            "_updateZoomButtons"
                        ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", function(O) {
                            return K._map.zoomIn({}, {
                                originalEvent: O
                            });
                        }), o.create("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", !0), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", function(O) {
                            return K._map.zoomOut({}, {
                                originalEvent: O
                            });
                        }), o.create("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", !0)), this.options.showCompass && (i.bindAll([
                            "_rotateCompassArrow"
                        ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", function(O) {
                            K.options.visualizePitch ? K._map.resetNorthPitch({}, {
                                originalEvent: O
                            }) : K._map.resetNorth({}, {
                                originalEvent: O
                            });
                        }), this._compassIcon = o.create("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", !0));
                    };
                    Xn.prototype._updateZoomButtons = function() {
                        var z = this._map.getZoom(), K = z === this._map.getMaxZoom(), O = z === this._map.getMinZoom();
                        this._zoomInButton.disabled = K, this._zoomOutButton.disabled = O, this._zoomInButton.setAttribute("aria-disabled", K.toString()), this._zoomOutButton.setAttribute("aria-disabled", O.toString());
                    }, Xn.prototype._rotateCompassArrow = function() {
                        var z = this.options.visualizePitch ? "scale(" + 1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5) + ") rotateX(" + this._map.transform.pitch + "deg) rotateZ(" + this._map.transform.angle * (180 / Math.PI) + "deg)" : "rotate(" + this._map.transform.angle * (180 / Math.PI) + "deg)";
                        this._compassIcon.style.transform = z;
                    }, Xn.prototype.onAdd = function(z) {
                        return this._map = z, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Vn(this._map, this._compass, this.options.visualizePitch)), this._container;
                    }, Xn.prototype.onRemove = function() {
                        o.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
                    }, Xn.prototype._createButton = function(z, K) {
                        var O = o.create("button", z, this._container);
                        return O.type = "button", O.addEventListener("click", K), O;
                    }, Xn.prototype._setButtonTitle = function(z, K) {
                        var O = this._map._getUIString("NavigationControl." + K);
                        z.title = O, z.setAttribute("aria-label", O);
                    };
                    var Vn = function(z, K, O) {
                        O === void 0 && (O = !1), this._clickTolerance = 10, this.element = K, this.mouseRotate = new un({
                            clickTolerance: z.dragRotate._mouseRotate._clickTolerance
                        }), this.map = z, O && (this.mousePitch = new dn({
                            clickTolerance: z.dragRotate._mousePitch._clickTolerance
                        })), i.bindAll([
                            "mousedown",
                            "mousemove",
                            "mouseup",
                            "touchstart",
                            "touchmove",
                            "touchend",
                            "reset"
                        ], this), o.addEventListener(K, "mousedown", this.mousedown), o.addEventListener(K, "touchstart", this.touchstart, {
                            passive: !1
                        }), o.addEventListener(K, "touchmove", this.touchmove), o.addEventListener(K, "touchend", this.touchend), o.addEventListener(K, "touchcancel", this.reset);
                    };
                    Vn.prototype.down = function(z, K) {
                        this.mouseRotate.mousedown(z, K), this.mousePitch && this.mousePitch.mousedown(z, K), o.disableDrag();
                    }, Vn.prototype.move = function(z, K) {
                        var O = this.map, $ = this.mouseRotate.mousemoveWindow(z, K);
                        if ($ && $.bearingDelta && O.setBearing(O.getBearing() + $.bearingDelta), this.mousePitch) {
                            var pe = this.mousePitch.mousemoveWindow(z, K);
                            pe && pe.pitchDelta && O.setPitch(O.getPitch() + pe.pitchDelta);
                        }
                    }, Vn.prototype.off = function() {
                        var z = this.element;
                        o.removeEventListener(z, "mousedown", this.mousedown), o.removeEventListener(z, "touchstart", this.touchstart, {
                            passive: !1
                        }), o.removeEventListener(z, "touchmove", this.touchmove), o.removeEventListener(z, "touchend", this.touchend), o.removeEventListener(z, "touchcancel", this.reset), this.offTemp();
                    }, Vn.prototype.offTemp = function() {
                        o.enableDrag(), o.removeEventListener(i.window, "mousemove", this.mousemove), o.removeEventListener(i.window, "mouseup", this.mouseup);
                    }, Vn.prototype.mousedown = function(z) {
                        this.down(i.extend({}, z, {
                            ctrlKey: !0,
                            preventDefault: function() {
                                return z.preventDefault();
                            }
                        }), o.mousePos(this.element, z)), o.addEventListener(i.window, "mousemove", this.mousemove), o.addEventListener(i.window, "mouseup", this.mouseup);
                    }, Vn.prototype.mousemove = function(z) {
                        this.move(z, o.mousePos(this.element, z));
                    }, Vn.prototype.mouseup = function(z) {
                        this.mouseRotate.mouseupWindow(z), this.mousePitch && this.mousePitch.mouseupWindow(z), this.offTemp();
                    }, Vn.prototype.touchstart = function(z) {
                        z.targetTouches.length !== 1 ? this.reset() : (this._startPos = this._lastPos = o.touchPos(this.element, z.targetTouches)[0], this.down({
                            type: "mousedown",
                            button: 0,
                            ctrlKey: !0,
                            preventDefault: function() {
                                return z.preventDefault();
                            }
                        }, this._startPos));
                    }, Vn.prototype.touchmove = function(z) {
                        z.targetTouches.length !== 1 ? this.reset() : (this._lastPos = o.touchPos(this.element, z.targetTouches)[0], this.move({
                            preventDefault: function() {
                                return z.preventDefault();
                            }
                        }, this._lastPos));
                    }, Vn.prototype.touchend = function(z) {
                        z.targetTouches.length === 0 && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
                    }, Vn.prototype.reset = function() {
                        this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                    };
                    function ma(Y1, z, K) {
                        if (Y1 = new i.LngLat(Y1.lng, Y1.lat), z) {
                            var O = new i.LngLat(Y1.lng - 360, Y1.lat), $ = new i.LngLat(Y1.lng + 360, Y1.lat), pe = K.locationPoint(Y1).distSqr(z);
                            K.locationPoint(O).distSqr(z) < pe ? Y1 = O : K.locationPoint($).distSqr(z) < pe && (Y1 = $);
                        }
                        for(; Math.abs(Y1.lng - K.center.lng) > 180;){
                            var de = K.locationPoint(Y1);
                            if (de.x >= 0 && de.y >= 0 && de.x <= K.width && de.y <= K.height) break;
                            Y1.lng > K.center.lng ? Y1.lng -= 360 : Y1.lng += 360;
                        }
                        return Y1;
                    }
                    var ro = {
                        center: "translate(-50%,-50%)",
                        top: "translate(-50%,0)",
                        "top-left": "translate(0,0)",
                        "top-right": "translate(-100%,0)",
                        bottom: "translate(-50%,-100%)",
                        "bottom-left": "translate(0,-100%)",
                        "bottom-right": "translate(-100%,-100%)",
                        left: "translate(0,-50%)",
                        right: "translate(-100%,-50%)"
                    };
                    function Ao(Y1, z, K) {
                        var O = Y1.classList;
                        for(var $ in ro)O.remove("mapboxgl-" + K + "-anchor-" + $);
                        O.add("mapboxgl-" + K + "-anchor-" + z);
                    }
                    var Jn = function(Y1) {
                        function z(K, O) {
                            if (Y1.call(this), (K instanceof i.window.HTMLElement || O) && (K = i.extend({
                                element: K
                            }, O)), i.bindAll([
                                "_update",
                                "_onMove",
                                "_onUp",
                                "_addDragHandler",
                                "_onMapClick",
                                "_onKeyPress"
                            ], this), this._anchor = K && K.anchor || "center", this._color = K && K.color || "#3FB1CE", this._scale = K && K.scale || 1, this._draggable = K && K.draggable || !1, this._clickTolerance = K && K.clickTolerance || 0, this._isDragging = !1, this._state = "inactive", this._rotation = K && K.rotation || 0, this._rotationAlignment = K && K.rotationAlignment || "auto", this._pitchAlignment = K && K.pitchAlignment && K.pitchAlignment !== "auto" ? K.pitchAlignment : this._rotationAlignment, !K || !K.element) {
                                this._defaultMarker = !0, this._element = o.create("div"), this._element.setAttribute("aria-label", "Map marker");
                                var $ = o.createNS("http://www.w3.org/2000/svg", "svg"), pe = 41, de = 27;
                                $.setAttributeNS(null, "display", "block"), $.setAttributeNS(null, "height", pe + "px"), $.setAttributeNS(null, "width", de + "px"), $.setAttributeNS(null, "viewBox", "0 0 " + de + " " + pe);
                                var Ie = o.createNS("http://www.w3.org/2000/svg", "g");
                                Ie.setAttributeNS(null, "stroke", "none"), Ie.setAttributeNS(null, "stroke-width", "1"), Ie.setAttributeNS(null, "fill", "none"), Ie.setAttributeNS(null, "fill-rule", "evenodd");
                                var $e = o.createNS("http://www.w3.org/2000/svg", "g");
                                $e.setAttributeNS(null, "fill-rule", "nonzero");
                                var pt = o.createNS("http://www.w3.org/2000/svg", "g");
                                pt.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), pt.setAttributeNS(null, "fill", "#000000");
                                for(var Kt = [
                                    {
                                        rx: "10.5",
                                        ry: "5.25002273"
                                    },
                                    {
                                        rx: "10.5",
                                        ry: "5.25002273"
                                    },
                                    {
                                        rx: "9.5",
                                        ry: "4.77275007"
                                    },
                                    {
                                        rx: "8.5",
                                        ry: "4.29549936"
                                    },
                                    {
                                        rx: "7.5",
                                        ry: "3.81822308"
                                    },
                                    {
                                        rx: "6.5",
                                        ry: "3.34094679"
                                    },
                                    {
                                        rx: "5.5",
                                        ry: "2.86367051"
                                    },
                                    {
                                        rx: "4.5",
                                        ry: "2.38636864"
                                    }
                                ], ir = 0, Jt = Kt; ir < Jt.length; ir += 1){
                                    var vt = Jt[ir], Pt = o.createNS("http://www.w3.org/2000/svg", "ellipse");
                                    Pt.setAttributeNS(null, "opacity", "0.04"), Pt.setAttributeNS(null, "cx", "10.5"), Pt.setAttributeNS(null, "cy", "5.80029008"), Pt.setAttributeNS(null, "rx", vt.rx), Pt.setAttributeNS(null, "ry", vt.ry), pt.appendChild(Pt);
                                }
                                var Wt = o.createNS("http://www.w3.org/2000/svg", "g");
                                Wt.setAttributeNS(null, "fill", this._color);
                                var rr = o.createNS("http://www.w3.org/2000/svg", "path");
                                rr.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), Wt.appendChild(rr);
                                var dr = o.createNS("http://www.w3.org/2000/svg", "g");
                                dr.setAttributeNS(null, "opacity", "0.25"), dr.setAttributeNS(null, "fill", "#000000");
                                var pr = o.createNS("http://www.w3.org/2000/svg", "path");
                                pr.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), dr.appendChild(pr);
                                var kr = o.createNS("http://www.w3.org/2000/svg", "g");
                                kr.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), kr.setAttributeNS(null, "fill", "#FFFFFF");
                                var Ar = o.createNS("http://www.w3.org/2000/svg", "g");
                                Ar.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                                var gr = o.createNS("http://www.w3.org/2000/svg", "circle");
                                gr.setAttributeNS(null, "fill", "#000000"), gr.setAttributeNS(null, "opacity", "0.25"), gr.setAttributeNS(null, "cx", "5.5"), gr.setAttributeNS(null, "cy", "5.5"), gr.setAttributeNS(null, "r", "5.4999962");
                                var Cr = o.createNS("http://www.w3.org/2000/svg", "circle");
                                Cr.setAttributeNS(null, "fill", "#FFFFFF"), Cr.setAttributeNS(null, "cx", "5.5"), Cr.setAttributeNS(null, "cy", "5.5"), Cr.setAttributeNS(null, "r", "5.4999962"), Ar.appendChild(gr), Ar.appendChild(Cr), $e.appendChild(pt), $e.appendChild(Wt), $e.appendChild(dr), $e.appendChild(kr), $e.appendChild(Ar), $.appendChild($e), $.setAttributeNS(null, "height", pe * this._scale + "px"), $.setAttributeNS(null, "width", de * this._scale + "px"), this._element.appendChild($), this._offset = i.Point.convert(K && K.offset || [
                                    0,
                                    -14
                                ]);
                            } else this._element = K.element, this._offset = i.Point.convert(K && K.offset || [
                                0,
                                0
                            ]);
                            this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", function(cr) {
                                cr.preventDefault();
                            }), this._element.addEventListener("mousedown", function(cr) {
                                cr.preventDefault();
                            }), Ao(this._element, this._anchor, "marker"), this._popup = null;
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.addTo = function(O) {
                            return this.remove(), this._map = O, O.getCanvasContainer().appendChild(this._element), O.on("move", this._update), O.on("moveend", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
                        }, z.prototype.remove = function() {
                            return this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), o.remove(this._element), this._popup && this._popup.remove(), this;
                        }, z.prototype.getLngLat = function() {
                            return this._lngLat;
                        }, z.prototype.setLngLat = function(O) {
                            return this._lngLat = i.LngLat.convert(O), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
                        }, z.prototype.getElement = function() {
                            return this._element;
                        }, z.prototype.setPopup = function(O) {
                            if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), O) {
                                if (!("offset" in O.options)) {
                                    var $ = 38.1, pe = 13.5, de = Math.sqrt(Math.pow(pe, 2) / 2);
                                    O.options.offset = this._defaultMarker ? {
                                        top: [
                                            0,
                                            0
                                        ],
                                        "top-left": [
                                            0,
                                            0
                                        ],
                                        "top-right": [
                                            0,
                                            0
                                        ],
                                        bottom: [
                                            0,
                                            -$
                                        ],
                                        "bottom-left": [
                                            de,
                                            ($ - pe + de) * -1
                                        ],
                                        "bottom-right": [
                                            -de,
                                            ($ - pe + de) * -1
                                        ],
                                        left: [
                                            pe,
                                            ($ - pe) * -1
                                        ],
                                        right: [
                                            -pe,
                                            ($ - pe) * -1
                                        ]
                                    } : this._offset;
                                }
                                this._popup = O, this._lngLat && this._popup.setLngLat(this._lngLat), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                            }
                            return this;
                        }, z.prototype._onKeyPress = function(O) {
                            var $ = O.code, pe = O.charCode || O.keyCode;
                            ($ === "Space" || $ === "Enter" || pe === 32 || pe === 13) && this.togglePopup();
                        }, z.prototype._onMapClick = function(O) {
                            var $ = O.originalEvent.target, pe = this._element;
                            this._popup && ($ === pe || pe.contains($)) && this.togglePopup();
                        }, z.prototype.getPopup = function() {
                            return this._popup;
                        }, z.prototype.togglePopup = function() {
                            var O = this._popup;
                            if (O) O.isOpen() ? O.remove() : O.addTo(this._map);
                            else return this;
                            return this;
                        }, z.prototype._update = function(O) {
                            if (this._map) {
                                this._map.transform.renderWorldCopies && (this._lngLat = ma(this._lngLat, this._pos, this._map.transform)), this._pos = this._map.project(this._lngLat)._add(this._offset);
                                var $ = "";
                                this._rotationAlignment === "viewport" || this._rotationAlignment === "auto" ? $ = "rotateZ(" + this._rotation + "deg)" : this._rotationAlignment === "map" && ($ = "rotateZ(" + (this._rotation - this._map.getBearing()) + "deg)");
                                var pe = "";
                                this._pitchAlignment === "viewport" || this._pitchAlignment === "auto" ? pe = "rotateX(0deg)" : this._pitchAlignment === "map" && (pe = "rotateX(" + this._map.getPitch() + "deg)"), (!O || O.type === "moveend") && (this._pos = this._pos.round()), o.setTransform(this._element, ro[this._anchor] + " translate(" + this._pos.x + "px, " + this._pos.y + "px) " + pe + " " + $);
                            }
                        }, z.prototype.getOffset = function() {
                            return this._offset;
                        }, z.prototype.setOffset = function(O) {
                            return this._offset = i.Point.convert(O), this._update(), this;
                        }, z.prototype._onMove = function(O) {
                            if (!this._isDragging) {
                                var $ = this._clickTolerance || this._map._clickTolerance;
                                this._isDragging = O.point.dist(this._pointerdownPos) >= $;
                            }
                            this._isDragging && (this._pos = O.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", this._state === "pending" && (this._state = "active", this.fire(new i.Event("dragstart"))), this.fire(new i.Event("drag")));
                        }, z.prototype._onUp = function() {
                            this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), this._state === "active" && this.fire(new i.Event("dragend")), this._state = "inactive";
                        }, z.prototype._addDragHandler = function(O) {
                            this._element.contains(O.originalEvent.target) && (O.preventDefault(), this._positionDelta = O.point.sub(this._pos).add(this._offset), this._pointerdownPos = O.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                        }, z.prototype.setDraggable = function(O) {
                            return this._draggable = !!O, this._map && (O ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
                        }, z.prototype.isDraggable = function() {
                            return this._draggable;
                        }, z.prototype.setRotation = function(O) {
                            return this._rotation = O || 0, this._update(), this;
                        }, z.prototype.getRotation = function() {
                            return this._rotation;
                        }, z.prototype.setRotationAlignment = function(O) {
                            return this._rotationAlignment = O || "auto", this._update(), this;
                        }, z.prototype.getRotationAlignment = function() {
                            return this._rotationAlignment;
                        }, z.prototype.setPitchAlignment = function(O) {
                            return this._pitchAlignment = O && O !== "auto" ? O : this._rotationAlignment, this._update(), this;
                        }, z.prototype.getPitchAlignment = function() {
                            return this._pitchAlignment;
                        }, z;
                    }(i.Evented), Oa = {
                        positionOptions: {
                            enableHighAccuracy: !1,
                            maximumAge: 0,
                            timeout: 6e3
                        },
                        fitBoundsOptions: {
                            maxZoom: 15
                        },
                        trackUserLocation: !1,
                        showAccuracyCircle: !0,
                        showUserLocation: !0
                    }, _o;
                    function Po(Y1) {
                        _o !== void 0 ? Y1(_o) : i.window.navigator.permissions !== void 0 ? i.window.navigator.permissions.query({
                            name: "geolocation"
                        }).then(function(z) {
                            _o = z.state !== "denied", Y1(_o);
                        }) : (_o = !!i.window.navigator.geolocation, Y1(_o));
                    }
                    var Jo = 0, Yl = !1, $c = function(Y1) {
                        function z(K) {
                            Y1.call(this), this.options = i.extend({}, Oa, K), i.bindAll([
                                "_onSuccess",
                                "_onError",
                                "_onZoom",
                                "_finish",
                                "_setupUI",
                                "_updateCamera",
                                "_updateMarker"
                            ], this);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.onAdd = function(O) {
                            return this._map = O, this._container = o.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), Po(this._setupUI), this._container;
                        }, z.prototype.onRemove = function() {
                            this._geolocationWatchID !== void 0 && (i.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), o.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, Jo = 0, Yl = !1;
                        }, z.prototype._isOutOfMapMaxBounds = function(O) {
                            var $ = this._map.getMaxBounds(), pe = O.coords;
                            return $ && (pe.longitude < $.getWest() || pe.longitude > $.getEast() || pe.latitude < $.getSouth() || pe.latitude > $.getNorth());
                        }, z.prototype._setErrorState = function() {
                            switch(this._watchState){
                                case "WAITING_ACTIVE":
                                    this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                    break;
                                case "ACTIVE_LOCK":
                                    this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                                    break;
                                case "BACKGROUND":
                                    this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                                    break;
                            }
                        }, z.prototype._onSuccess = function(O) {
                            if (this._map) {
                                if (this._isOutOfMapMaxBounds(O)) {
                                    this._setErrorState(), this.fire(new i.Event("outofmaxbounds", O)), this._updateMarker(), this._finish();
                                    return;
                                }
                                if (this.options.trackUserLocation) switch(this._lastKnownPosition = O, this._watchState){
                                    case "WAITING_ACTIVE":
                                    case "ACTIVE_LOCK":
                                    case "ACTIVE_ERROR":
                                        this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                        break;
                                    case "BACKGROUND":
                                    case "BACKGROUND_ERROR":
                                        this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                        break;
                                }
                                this.options.showUserLocation && this._watchState !== "OFF" && this._updateMarker(O), (!this.options.trackUserLocation || this._watchState === "ACTIVE_LOCK") && this._updateCamera(O), this.options.showUserLocation && this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"), this.fire(new i.Event("geolocate", O)), this._finish();
                            }
                        }, z.prototype._updateCamera = function(O) {
                            var $ = new i.LngLat(O.coords.longitude, O.coords.latitude), pe = O.coords.accuracy, de = this._map.getBearing(), Ie = i.extend({
                                bearing: de
                            }, this.options.fitBoundsOptions);
                            this._map.fitBounds($.toBounds(pe), Ie, {
                                geolocateSource: !0
                            });
                        }, z.prototype._updateMarker = function(O) {
                            if (O) {
                                var $ = new i.LngLat(O.coords.longitude, O.coords.latitude);
                                this._accuracyCircleMarker.setLngLat($).addTo(this._map), this._userLocationDotMarker.setLngLat($).addTo(this._map), this._accuracy = O.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                            } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                        }, z.prototype._updateCircleRadius = function() {
                            var O = this._map._container.clientHeight / 2, $ = this._map.unproject([
                                0,
                                O
                            ]), pe = this._map.unproject([
                                1,
                                O
                            ]), de = $.distanceTo(pe), Ie = Math.ceil(2 * this._accuracy / de);
                            this._circleElement.style.width = Ie + "px", this._circleElement.style.height = Ie + "px";
                        }, z.prototype._onZoom = function() {
                            this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                        }, z.prototype._onError = function(O) {
                            if (this._map) {
                                if (this.options.trackUserLocation) {
                                    if (O.code === 1) {
                                        this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                        var $ = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                        this._geolocateButton.title = $, this._geolocateButton.setAttribute("aria-label", $), this._geolocationWatchID !== void 0 && this._clearWatch();
                                    } else {
                                        if (O.code === 3 && Yl) return;
                                        this._setErrorState();
                                    }
                                }
                                this._watchState !== "OFF" && this.options.showUserLocation && this._dotElement.classList.add("mapboxgl-user-location-dot-stale"), this.fire(new i.Event("error", O)), this._finish();
                            }
                        }, z.prototype._finish = function() {
                            this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                        }, z.prototype._setupUI = function(O) {
                            var $ = this;
                            if (this._container.addEventListener("contextmenu", function(Ie) {
                                return Ie.preventDefault();
                            }), this._geolocateButton = o.create("button", "mapboxgl-ctrl-geolocate", this._container), o.create("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", !0), this._geolocateButton.type = "button", O === !1) {
                                i.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");
                                var pe = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.disabled = !0, this._geolocateButton.title = pe, this._geolocateButton.setAttribute("aria-label", pe);
                            } else {
                                var de = this._map._getUIString("GeolocateControl.FindMyLocation");
                                this._geolocateButton.title = de, this._geolocateButton.setAttribute("aria-label", de);
                            }
                            this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = o.create("div", "mapboxgl-user-location-dot"), this._userLocationDotMarker = new Jn(this._dotElement), this._circleElement = o.create("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new Jn({
                                element: this._circleElement,
                                pitchAlignment: "map"
                            }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", function(Ie) {
                                var $e = Ie.originalEvent && Ie.originalEvent.type === "resize";
                                !Ie.geolocateSource && $._watchState === "ACTIVE_LOCK" && !$e && ($._watchState = "BACKGROUND", $._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), $._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), $.fire(new i.Event("trackuserlocationend")));
                            });
                        }, z.prototype.trigger = function() {
                            if (!this._setup) return i.warnOnce("Geolocate control triggered before added to a map"), !1;
                            if (this.options.trackUserLocation) {
                                switch(this._watchState){
                                    case "OFF":
                                        this._watchState = "WAITING_ACTIVE", this.fire(new i.Event("trackuserlocationstart"));
                                        break;
                                    case "WAITING_ACTIVE":
                                    case "ACTIVE_LOCK":
                                    case "ACTIVE_ERROR":
                                    case "BACKGROUND_ERROR":
                                        Jo--, Yl = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new i.Event("trackuserlocationend"));
                                        break;
                                    case "BACKGROUND":
                                        this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new i.Event("trackuserlocationstart"));
                                        break;
                                }
                                switch(this._watchState){
                                    case "WAITING_ACTIVE":
                                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                        break;
                                    case "ACTIVE_LOCK":
                                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                        break;
                                    case "ACTIVE_ERROR":
                                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                        break;
                                    case "BACKGROUND":
                                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                        break;
                                    case "BACKGROUND_ERROR":
                                        this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                                        break;
                                }
                                if (this._watchState === "OFF" && this._geolocationWatchID !== void 0) this._clearWatch();
                                else if (this._geolocationWatchID === void 0) {
                                    this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), Jo++;
                                    var O;
                                    Jo > 1 ? (O = {
                                        maximumAge: 6e5,
                                        timeout: 0
                                    }, Yl = !0) : (O = this.options.positionOptions, Yl = !1), this._geolocationWatchID = i.window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, O);
                                }
                            } else i.window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                            return !0;
                        }, z.prototype._clearWatch = function() {
                            i.window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                        }, z;
                    }(i.Evented), xs = {
                        maxWidth: 100,
                        unit: "metric"
                    }, Qc = function(z) {
                        this.options = i.extend({}, xs, z), i.bindAll([
                            "_onMove",
                            "setUnit"
                        ], this);
                    };
                    Qc.prototype.getDefaultPosition = function() {
                        return "bottom-left";
                    }, Qc.prototype._onMove = function() {
                        El(this._map, this._container, this.options);
                    }, Qc.prototype.onAdd = function(z) {
                        return this._map = z, this._container = o.create("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", z.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
                    }, Qc.prototype.onRemove = function() {
                        o.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
                    }, Qc.prototype.setUnit = function(z) {
                        this.options.unit = z, El(this._map, this._container, this.options);
                    };
                    function El(Y1, z, K) {
                        var O = K && K.maxWidth || 100, $ = Y1._container.clientHeight / 2, pe = Y1.unproject([
                            0,
                            $
                        ]), de = Y1.unproject([
                            O,
                            $
                        ]), Ie = pe.distanceTo(de);
                        if (K && K.unit === "imperial") {
                            var $e = 3.2808 * Ie;
                            if ($e > 5280) {
                                var pt = $e / 5280;
                                bc(z, O, pt, Y1._getUIString("ScaleControl.Miles"));
                            } else bc(z, O, $e, Y1._getUIString("ScaleControl.Feet"));
                        } else if (K && K.unit === "nautical") {
                            var Kt = Ie / 1852;
                            bc(z, O, Kt, Y1._getUIString("ScaleControl.NauticalMiles"));
                        } else Ie >= 1e3 ? bc(z, O, Ie / 1e3, Y1._getUIString("ScaleControl.Kilometers")) : bc(z, O, Ie, Y1._getUIString("ScaleControl.Meters"));
                    }
                    function bc(Y1, z, K, O) {
                        var $ = yf(K), pe = $ / K;
                        Y1.style.width = z * pe + "px", Y1.innerHTML = $ + "&nbsp;" + O;
                    }
                    function wc(Y1) {
                        var z = Math.pow(10, Math.ceil(-Math.log(Y1) / Math.LN10));
                        return Math.round(Y1 * z) / z;
                    }
                    function yf(Y1) {
                        var z = Math.pow(10, ("" + Math.floor(Y1)).length - 1), K = Y1 / z;
                        return K = K >= 10 ? 10 : K >= 5 ? 5 : K >= 3 ? 3 : K >= 2 ? 2 : K >= 1 ? 1 : wc(K), z * K;
                    }
                    var Gl = function(z) {
                        this._fullscreen = !1, z && z.container && (z.container instanceof i.window.HTMLElement ? this._container = z.container : i.warnOnce("Full screen control 'container' must be a DOM element.")), i.bindAll([
                            "_onClickFullscreen",
                            "_changeIcon"
                        ], this), "onfullscreenchange" in i.window.document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in i.window.document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in i.window.document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in i.window.document && (this._fullscreenchange = "MSFullscreenChange");
                    };
                    Gl.prototype.onAdd = function(z) {
                        return this._map = z, this._container || (this._container = this._map.getContainer()), this._controlContainer = o.create("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", i.warnOnce("This device does not support fullscreen mode.")), this._controlContainer;
                    }, Gl.prototype.onRemove = function() {
                        o.remove(this._controlContainer), this._map = null, i.window.document.removeEventListener(this._fullscreenchange, this._changeIcon);
                    }, Gl.prototype._checkFullscreenSupport = function() {
                        return !!(i.window.document.fullscreenEnabled || i.window.document.mozFullScreenEnabled || i.window.document.msFullscreenEnabled || i.window.document.webkitFullscreenEnabled);
                    }, Gl.prototype._setupUI = function() {
                        var z = this._fullscreenButton = o.create("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                        o.create("span", "mapboxgl-ctrl-icon", z).setAttribute("aria-hidden", !0), z.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), i.window.document.addEventListener(this._fullscreenchange, this._changeIcon);
                    }, Gl.prototype._updateTitle = function() {
                        var z = this._getTitle();
                        this._fullscreenButton.setAttribute("aria-label", z), this._fullscreenButton.title = z;
                    }, Gl.prototype._getTitle = function() {
                        return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                    }, Gl.prototype._isFullscreen = function() {
                        return this._fullscreen;
                    }, Gl.prototype._changeIcon = function() {
                        var z = i.window.document.fullscreenElement || i.window.document.mozFullScreenElement || i.window.document.webkitFullscreenElement || i.window.document.msFullscreenElement;
                        z === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                    }, Gl.prototype._onClickFullscreen = function() {
                        this._isFullscreen() ? i.window.document.exitFullscreen ? i.window.document.exitFullscreen() : i.window.document.mozCancelFullScreen ? i.window.document.mozCancelFullScreen() : i.window.document.msExitFullscreen ? i.window.document.msExitFullscreen() : i.window.document.webkitCancelFullScreen && i.window.document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                    };
                    var Fc = {
                        closeButton: !0,
                        closeOnClick: !0,
                        focusAfterOpen: !0,
                        className: "",
                        maxWidth: "240px"
                    }, ef = [
                        "a[href]",
                        "[tabindex]:not([tabindex='-1'])",
                        "[contenteditable]:not([contenteditable='false'])",
                        "button:not([disabled])",
                        "input:not([disabled])",
                        "select:not([disabled])",
                        "textarea:not([disabled])"
                    ].join(", "), ls = function(Y1) {
                        function z(K) {
                            Y1.call(this), this.options = i.extend(Object.create(Fc), K), i.bindAll([
                                "_update",
                                "_onClose",
                                "remove",
                                "_onMouseMove",
                                "_onMouseUp",
                                "_onDrag"
                            ], this);
                        }
                        return Y1 && (z.__proto__ = Y1), z.prototype = Object.create(Y1 && Y1.prototype), z.prototype.constructor = z, z.prototype.addTo = function(O) {
                            return this._map && this.remove(), this._map = O, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")) : this._map.on("move", this._update), this.fire(new i.Event("open")), this;
                        }, z.prototype.isOpen = function() {
                            return !!this._map;
                        }, z.prototype.remove = function() {
                            return this._content && o.remove(this._content), this._container && (o.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), delete this._map), this.fire(new i.Event("close")), this;
                        }, z.prototype.getLngLat = function() {
                            return this._lngLat;
                        }, z.prototype.setLngLat = function(O) {
                            return this._lngLat = i.LngLat.convert(O), this._pos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                        }, z.prototype.trackPointer = function() {
                            return this._trackPointer = !0, this._pos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("mapboxgl-popup-track-pointer"), this._map._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                        }, z.prototype.getElement = function() {
                            return this._container;
                        }, z.prototype.setText = function(O) {
                            return this.setDOMContent(i.window.document.createTextNode(O));
                        }, z.prototype.setHTML = function(O) {
                            var $ = i.window.document.createDocumentFragment(), pe = i.window.document.createElement("body"), de;
                            for(pe.innerHTML = O; de = pe.firstChild, !!de;)$.appendChild(de);
                            return this.setDOMContent($);
                        }, z.prototype.getMaxWidth = function() {
                            return this._container && this._container.style.maxWidth;
                        }, z.prototype.setMaxWidth = function(O) {
                            return this.options.maxWidth = O, this._update(), this;
                        }, z.prototype.setDOMContent = function(O) {
                            if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                            else this._content = o.create("div", "mapboxgl-popup-content", this._container);
                            return this._content.appendChild(O), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
                        }, z.prototype.addClassName = function(O) {
                            this._container && this._container.classList.add(O);
                        }, z.prototype.removeClassName = function(O) {
                            this._container && this._container.classList.remove(O);
                        }, z.prototype.setOffset = function(O) {
                            return this.options.offset = O, this._update(), this;
                        }, z.prototype.toggleClassName = function(O) {
                            if (this._container) return this._container.classList.toggle(O);
                        }, z.prototype._createCloseButton = function() {
                            this.options.closeButton && (this._closeButton = o.create("button", "mapboxgl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.setAttribute("aria-label", "Close popup"), this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
                        }, z.prototype._onMouseUp = function(O) {
                            this._update(O.point);
                        }, z.prototype._onMouseMove = function(O) {
                            this._update(O.point);
                        }, z.prototype._onDrag = function(O) {
                            this._update(O.point);
                        }, z.prototype._update = function(O) {
                            var $ = this, pe = this._lngLat || this._trackPointer;
                            if (!(!this._map || !pe || !this._content) && (this._container || (this._container = o.create("div", "mapboxgl-popup", this._map.getContainer()), this._tip = o.create("div", "mapboxgl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className && this.options.className.split(" ").forEach(function(vt) {
                                return $._container.classList.add(vt);
                            }), this._trackPointer && this._container.classList.add("mapboxgl-popup-track-pointer")), this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._map.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = ma(this._lngLat, this._pos, this._map.transform)), !(this._trackPointer && !O))) {
                                var de = this._pos = this._trackPointer && O ? O : this._map.project(this._lngLat), Ie = this.options.anchor, $e = _f(this.options.offset);
                                if (!Ie) {
                                    var pt = this._container.offsetWidth, Kt = this._container.offsetHeight, ir;
                                    de.y + $e.bottom.y < Kt ? ir = [
                                        "top"
                                    ] : de.y > this._map.transform.height - Kt ? ir = [
                                        "bottom"
                                    ] : ir = [], de.x < pt / 2 ? ir.push("left") : de.x > this._map.transform.width - pt / 2 && ir.push("right"), ir.length === 0 ? Ie = "bottom" : Ie = ir.join("-");
                                }
                                var Jt = de.add($e[Ie]).round();
                                o.setTransform(this._container, ro[Ie] + " translate(" + Jt.x + "px," + Jt.y + "px)"), Ao(this._container, Ie, "popup");
                            }
                        }, z.prototype._focusFirstElement = function() {
                            if (!(!this.options.focusAfterOpen || !this._container)) {
                                var O = this._container.querySelector(ef);
                                O && O.focus();
                            }
                        }, z.prototype._onClose = function() {
                            this.remove();
                        }, z;
                    }(i.Evented);
                    function _f(Y1) {
                        if (Y1) {
                            if (typeof Y1 == "number") {
                                var z = Math.round(Math.sqrt(.5 * Math.pow(Y1, 2)));
                                return {
                                    center: new i.Point(0, 0),
                                    top: new i.Point(0, Y1),
                                    "top-left": new i.Point(z, z),
                                    "top-right": new i.Point(-z, z),
                                    bottom: new i.Point(0, -Y1),
                                    "bottom-left": new i.Point(z, -z),
                                    "bottom-right": new i.Point(-z, -z),
                                    left: new i.Point(Y1, 0),
                                    right: new i.Point(-Y1, 0)
                                };
                            } else if (Y1 instanceof i.Point || Array.isArray(Y1)) {
                                var K = i.Point.convert(Y1);
                                return {
                                    center: K,
                                    top: K,
                                    "top-left": K,
                                    "top-right": K,
                                    bottom: K,
                                    "bottom-left": K,
                                    "bottom-right": K,
                                    left: K,
                                    right: K
                                };
                            } else return {
                                center: i.Point.convert(Y1.center || [
                                    0,
                                    0
                                ]),
                                top: i.Point.convert(Y1.top || [
                                    0,
                                    0
                                ]),
                                "top-left": i.Point.convert(Y1["top-left"] || [
                                    0,
                                    0
                                ]),
                                "top-right": i.Point.convert(Y1["top-right"] || [
                                    0,
                                    0
                                ]),
                                bottom: i.Point.convert(Y1.bottom || [
                                    0,
                                    0
                                ]),
                                "bottom-left": i.Point.convert(Y1["bottom-left"] || [
                                    0,
                                    0
                                ]),
                                "bottom-right": i.Point.convert(Y1["bottom-right"] || [
                                    0,
                                    0
                                ]),
                                left: i.Point.convert(Y1.left || [
                                    0,
                                    0
                                ]),
                                right: i.Point.convert(Y1.right || [
                                    0,
                                    0
                                ])
                            };
                        } else return _f(new i.Point(0, 0));
                    }
                    var ns = {
                        version: i.version,
                        supported: a,
                        setRTLTextPlugin: i.setRTLTextPlugin,
                        getRTLTextPluginStatus: i.getRTLTextPluginStatus,
                        Map: vn,
                        NavigationControl: Xn,
                        GeolocateControl: $c,
                        AttributionControl: Rn,
                        ScaleControl: Qc,
                        FullscreenControl: Gl,
                        Popup: ls,
                        Marker: Jn,
                        Style: mu,
                        LngLat: i.LngLat,
                        LngLatBounds: i.LngLatBounds,
                        Point: i.Point,
                        MercatorCoordinate: i.MercatorCoordinate,
                        Evented: i.Evented,
                        config: i.config,
                        prewarm: jn,
                        clearPrewarmedResources: la,
                        get accessToken () {
                            return i.config.ACCESS_TOKEN;
                        },
                        set accessToken (Y){
                            i.config.ACCESS_TOKEN = Y;
                        },
                        get baseApiUrl () {
                            return i.config.API_URL;
                        },
                        set baseApiUrl (Y){
                            i.config.API_URL = Y;
                        },
                        get workerCount () {
                            return Pi.workerCount;
                        },
                        set workerCount (Y){
                            Pi.workerCount = Y;
                        },
                        get maxParallelImageRequests () {
                            return i.config.MAX_PARALLEL_IMAGE_REQUESTS;
                        },
                        set maxParallelImageRequests (Y){
                            i.config.MAX_PARALLEL_IMAGE_REQUESTS = Y;
                        },
                        clearStorage: function(z) {
                            i.clearTileCache(z);
                        },
                        workerUrl: ""
                    };
                    return ns;
                }), r;
            });
        });
        var JUe = ye((Byr, KUe)=>{
            "use strict";
            var tw = Mr(), CHt = Pl().sanitizeHTML, LHt = HK(), ZUe = c1();
            function XUe(e, t) {
                this.subplot = e, this.uid = e.uid + "-" + t, this.index = t, this.idSource = "source-" + this.uid, this.idLayer = ZUe.layoutLayerPrefix + this.uid, this.sourceType = null, this.source = null, this.layerType = null, this.below = null, this.visible = !1;
            }
            var ig = XUe.prototype;
            ig.update = function(t) {
                this.visible ? this.needsNewImage(t) ? this.updateImage(t) : this.needsNewSource(t) ? (this.removeLayer(), this.updateSource(t), this.updateLayer(t)) : this.needsNewLayer(t) ? this.updateLayer(t) : this.updateStyle(t) : (this.updateSource(t), this.updateLayer(t)), this.visible = WF(t);
            };
            ig.needsNewImage = function(e) {
                var t = this.subplot.map;
                return t.getSource(this.idSource) && this.sourceType === "image" && e.sourcetype === "image" && (this.source !== e.source || JSON.stringify(this.coordinates) !== JSON.stringify(e.coordinates));
            };
            ig.needsNewSource = function(e) {
                return this.sourceType !== e.sourcetype || JSON.stringify(this.source) !== JSON.stringify(e.source) || this.layerType !== e.type;
            };
            ig.needsNewLayer = function(e) {
                return this.layerType !== e.type || this.below !== this.subplot.belowLookup["layout-" + this.index];
            };
            ig.lookupBelow = function() {
                return this.subplot.belowLookup["layout-" + this.index];
            };
            ig.updateImage = function(e) {
                var t = this.subplot.map;
                t.getSource(this.idSource).updateImage({
                    url: e.source,
                    coordinates: e.coordinates
                });
                var r = this.findFollowingMapboxLayerId(this.lookupBelow());
                r !== null && this.subplot.map.moveLayer(this.idLayer, r);
            };
            ig.updateSource = function(e) {
                var t = this.subplot.map;
                if (t.getSource(this.idSource) && t.removeSource(this.idSource), this.sourceType = e.sourcetype, this.source = e.source, !!WF(e)) {
                    var r = PHt(e);
                    t.addSource(this.idSource, r);
                }
            };
            ig.findFollowingMapboxLayerId = function(e) {
                if (e === "traces") for(var t = this.subplot.getMapLayers(), r = 0; r < t.length; r++){
                    var n = t[r].id;
                    if (typeof n == "string" && n.indexOf(ZUe.traceLayerPrefix) === 0) {
                        e = n;
                        break;
                    }
                }
                return e;
            };
            ig.updateLayer = function(e) {
                var t = this.subplot, r = YUe(e), n = this.lookupBelow(), i = this.findFollowingMapboxLayerId(n);
                this.removeLayer(), WF(e) && t.addLayer({
                    id: this.idLayer,
                    source: this.idSource,
                    "source-layer": e.sourcelayer || "",
                    type: e.type,
                    minzoom: e.minzoom,
                    maxzoom: e.maxzoom,
                    layout: r.layout,
                    paint: r.paint
                }, i), this.layerType = e.type, this.below = n;
            };
            ig.updateStyle = function(e) {
                if (WF(e)) {
                    var t = YUe(e);
                    this.subplot.setOptions(this.idLayer, "setLayoutProperty", t.layout), this.subplot.setOptions(this.idLayer, "setPaintProperty", t.paint);
                }
            };
            ig.removeLayer = function() {
                var e = this.subplot.map;
                e.getLayer(this.idLayer) && e.removeLayer(this.idLayer);
            };
            ig.dispose = function() {
                var e = this.subplot.map;
                e.getLayer(this.idLayer) && e.removeLayer(this.idLayer), e.getSource(this.idSource) && e.removeSource(this.idSource);
            };
            function WF(e) {
                if (!e.visible) return !1;
                var t = e.source;
                if (Array.isArray(t) && t.length > 0) {
                    for(var r = 0; r < t.length; r++)if (typeof t[r] != "string" || t[r].length === 0) return !1;
                    return !0;
                }
                return tw.isPlainObject(t) || typeof t == "string" && t.length > 0;
            }
            function YUe(e) {
                var t = {}, r = {};
                switch(e.type){
                    case "circle":
                        tw.extendFlat(r, {
                            "circle-radius": e.circle.radius,
                            "circle-color": e.color,
                            "circle-opacity": e.opacity
                        });
                        break;
                    case "line":
                        tw.extendFlat(r, {
                            "line-width": e.line.width,
                            "line-color": e.color,
                            "line-opacity": e.opacity,
                            "line-dasharray": e.line.dash
                        });
                        break;
                    case "fill":
                        tw.extendFlat(r, {
                            "fill-color": e.color,
                            "fill-outline-color": e.fill.outlinecolor,
                            "fill-opacity": e.opacity
                        });
                        break;
                    case "symbol":
                        var n = e.symbol, i = LHt(n.textposition, n.iconsize);
                        tw.extendFlat(t, {
                            "icon-image": n.icon + "-15",
                            "icon-size": n.iconsize / 10,
                            "text-field": n.text,
                            "text-size": n.textfont.size,
                            "text-anchor": i.anchor,
                            "text-offset": i.offset,
                            "symbol-placement": n.placement
                        }), tw.extendFlat(r, {
                            "icon-color": e.color,
                            "text-color": n.textfont.color,
                            "text-opacity": e.opacity
                        });
                        break;
                    case "raster":
                        tw.extendFlat(r, {
                            "raster-fade-duration": 0,
                            "raster-opacity": e.opacity
                        });
                        break;
                }
                return {
                    layout: t,
                    paint: r
                };
            }
            function PHt(e) {
                var t = e.sourcetype, r = e.source, n = {
                    type: t
                }, i;
                return t === "geojson" ? i = "data" : t === "vector" ? i = typeof r == "string" ? "url" : "tiles" : t === "raster" ? (i = "tiles", n.tileSize = 256) : t === "image" && (i = "url", n.coordinates = e.coordinates), n[i] = r, e.sourceattribution && (n.attribution = CHt(e.sourceattribution)), n;
            }
            KUe.exports = function(t, r, n) {
                var i = new XUe(t, r);
                return i.update(n), i;
            };
        });
        var oVe = ye((Nyr, aVe)=>{
            "use strict";
            var KK = YK(), JK = Mr(), tVe = nx(), $Ue = ba(), IHt = Qa(), RHt = gv(), ZF = Nc(), rVe = Sg(), DHt = rVe.drawMode, zHt = rVe.selectMode, FHt = wf().prepSelect, qHt = wf().clearOutline, OHt = wf().clearSelectionsCache, BHt = wf().selectOnClick, _x = c1(), NHt = JUe();
            function iVe(e, t) {
                this.id = t, this.gd = e;
                var r = e._fullLayout, n = e._context;
                this.container = r._glcontainer.node(), this.isStatic = n.staticPlot, this.uid = r._uid + "-" + this.id, this.div = null, this.xaxis = null, this.yaxis = null, this.createFramework(r), this.map = null, this.accessToken = null, this.styleObj = null, this.traceHash = {}, this.layerList = [], this.belowLookup = {}, this.dragging = !1, this.wheeling = !1;
            }
            var Ah = iVe.prototype;
            Ah.plot = function(e, t, r) {
                var n = this, i = t[n.id];
                n.map && i.accesstoken !== n.accessToken && (n.map.remove(), n.map = null, n.styleObj = null, n.traceHash = {}, n.layerList = []);
                var a;
                n.map ? a = new Promise(function(o, s) {
                    n.updateMap(e, t, o, s);
                }) : a = new Promise(function(o, s) {
                    n.createMap(e, t, o, s);
                }), r.push(a);
            };
            Ah.createMap = function(e, t, r, n) {
                var i = this, a = t[i.id], o = i.styleObj = nVe(a.style, t);
                i.accessToken = a.accesstoken;
                var s = a.bounds, l = s ? [
                    [
                        s.west,
                        s.south
                    ],
                    [
                        s.east,
                        s.north
                    ]
                ] : null, u = i.map = new KK.Map({
                    container: i.div,
                    style: o.style,
                    center: $K(a.center),
                    zoom: a.zoom,
                    bearing: a.bearing,
                    pitch: a.pitch,
                    maxBounds: l,
                    interactive: !i.isStatic,
                    preserveDrawingBuffer: i.isStatic,
                    doubleClickZoom: !1,
                    boxZoom: !1,
                    attributionControl: !1
                }).addControl(new KK.AttributionControl({
                    compact: !0
                }));
                u._canvas.style.left = "0px", u._canvas.style.top = "0px", i.rejectOnError(n), i.isStatic || i.initFx(e, t);
                var c = [];
                c.push(new Promise(function(f) {
                    u.once("load", f);
                })), c = c.concat(tVe.fetchTraceGeoData(e)), Promise.all(c).then(function() {
                    i.fillBelowLookup(e, t), i.updateData(e), i.updateLayout(t), i.resolveOnRender(r);
                }).catch(n);
            };
            Ah.updateMap = function(e, t, r, n) {
                var i = this, a = i.map, o = t[this.id];
                i.rejectOnError(n);
                var s = [], l = nVe(o.style, t);
                JSON.stringify(i.styleObj) !== JSON.stringify(l) && (i.styleObj = l, a.setStyle(l.style), i.traceHash = {}, s.push(new Promise(function(u) {
                    a.once("styledata", u);
                }))), s = s.concat(tVe.fetchTraceGeoData(e)), Promise.all(s).then(function() {
                    i.fillBelowLookup(e, t), i.updateData(e), i.updateLayout(t), i.resolveOnRender(r);
                }).catch(n);
            };
            Ah.fillBelowLookup = function(e, t) {
                var r = t[this.id], n = r.layers, i, a, o = this.belowLookup = {}, s = !1;
                for(i = 0; i < e.length; i++){
                    var l = e[i][0].trace, u = l._module;
                    typeof l.below == "string" ? a = l.below : u.getBelow && (a = u.getBelow(l, this)), a === "" && (s = !0), o["trace-" + l.uid] = a || "";
                }
                for(i = 0; i < n.length; i++){
                    var c = n[i];
                    typeof c.below == "string" ? a = c.below : s ? a = "traces" : a = "", o["layout-" + i] = a;
                }
                var f = {}, h, d;
                for(h in o)a = o[h], f[a] ? f[a].push(h) : f[a] = [
                    h
                ];
                for(a in f){
                    var v = f[a];
                    if (v.length > 1) for(i = 0; i < v.length; i++)h = v[i], h.indexOf("trace-") === 0 ? (d = h.split("trace-")[1], this.traceHash[d] && (this.traceHash[d].below = null)) : h.indexOf("layout-") === 0 && (d = h.split("layout-")[1], this.layerList[d] && (this.layerList[d].below = null));
                }
            };
            var QUe = {
                choroplethmapbox: 0,
                densitymapbox: 1,
                scattermapbox: 2
            };
            Ah.updateData = function(e) {
                var t = this.traceHash, r, n, i, a, o = e.slice().sort(function(f, h) {
                    return QUe[f[0].trace.type] - QUe[h[0].trace.type];
                });
                for(i = 0; i < o.length; i++){
                    var s = o[i];
                    n = s[0].trace, r = t[n.uid];
                    var l = !1;
                    r && (r.type === n.type ? (r.update(s), l = !0) : r.dispose()), !l && n._module && (t[n.uid] = n._module.plot(this, s));
                }
                var u = Object.keys(t);
                e: for(i = 0; i < u.length; i++){
                    var c = u[i];
                    for(a = 0; a < e.length; a++)if (n = e[a][0].trace, c === n.uid) continue e;
                    r = t[c], r.dispose(), delete t[c];
                }
            };
            Ah.updateLayout = function(e) {
                var t = this.map, r = e[this.id];
                !this.dragging && !this.wheeling && (t.setCenter($K(r.center)), t.setZoom(r.zoom), t.setBearing(r.bearing), t.setPitch(r.pitch)), this.updateLayers(e), this.updateFramework(e), this.updateFx(e), this.map.resize(), this.gd._context._scrollZoom.mapbox ? t.scrollZoom.enable() : t.scrollZoom.disable();
            };
            Ah.resolveOnRender = function(e) {
                var t = this.map;
                t.on("render", function r() {
                    t.loaded() && (t.off("render", r), setTimeout(e, 10));
                });
            };
            Ah.rejectOnError = function(e) {
                var t = this.map;
                function r() {
                    e(new Error(_x.mapOnErrorMsg));
                }
                t.once("error", r), t.once("style.error", r), t.once("source.error", r), t.once("tile.error", r), t.once("layer.error", r);
            };
            Ah.createFramework = function(e) {
                var t = this, r = t.div = document.createElement("div");
                r.id = t.uid, r.style.position = "absolute", t.container.appendChild(r), t.xaxis = {
                    _id: "x",
                    c2p: function(n) {
                        return t.project(n).x;
                    }
                }, t.yaxis = {
                    _id: "y",
                    c2p: function(n) {
                        return t.project(n).y;
                    }
                }, t.updateFramework(e), t.mockAxis = {
                    type: "linear",
                    showexponent: "all",
                    exponentformat: "B"
                }, IHt.setConvert(t.mockAxis, e);
            };
            Ah.initFx = function(e, t) {
                var r = this, n = r.gd, i = r.map;
                i.on("moveend", function(s) {
                    if (r.map) {
                        var l = n._fullLayout;
                        if (s.originalEvent || r.wheeling) {
                            var u = l[r.id];
                            $Ue.call("_storeDirectGUIEdit", n.layout, l._preGUI, r.getViewEdits(u));
                            var c = r.getView();
                            u._input.center = u.center = c.center, u._input.zoom = u.zoom = c.zoom, u._input.bearing = u.bearing = c.bearing, u._input.pitch = u.pitch = c.pitch, n.emit("plotly_relayout", r.getViewEditsWithDerived(c));
                        }
                        s.originalEvent && s.originalEvent.type === "mouseup" ? r.dragging = !1 : r.wheeling && (r.wheeling = !1), l._rehover && l._rehover();
                    }
                }), i.on("wheel", function() {
                    r.wheeling = !0;
                }), i.on("mousemove", function(s) {
                    var l = r.div.getBoundingClientRect(), u = [
                        s.originalEvent.offsetX,
                        s.originalEvent.offsetY
                    ];
                    s.target.getBoundingClientRect = function() {
                        return l;
                    }, r.xaxis.p2c = function() {
                        return i.unproject(u).lng;
                    }, r.yaxis.p2c = function() {
                        return i.unproject(u).lat;
                    }, n._fullLayout._rehover = function() {
                        n._fullLayout._hoversubplot === r.id && n._fullLayout[r.id] && ZF.hover(n, s, r.id);
                    }, ZF.hover(n, s, r.id), n._fullLayout._hoversubplot = r.id;
                });
                function a() {
                    ZF.loneUnhover(t._hoverlayer);
                }
                i.on("dragstart", function() {
                    r.dragging = !0, a();
                }), i.on("zoomstart", a), i.on("mouseout", function() {
                    n._fullLayout._hoversubplot = null;
                });
                function o() {
                    var s = r.getView();
                    n.emit("plotly_relayouting", r.getViewEditsWithDerived(s));
                }
                i.on("drag", o), i.on("zoom", o), i.on("dblclick", function() {
                    var s = n._fullLayout[r.id];
                    $Ue.call("_storeDirectGUIEdit", n.layout, n._fullLayout._preGUI, r.getViewEdits(s));
                    var l = r.viewInitial;
                    i.setCenter($K(l.center)), i.setZoom(l.zoom), i.setBearing(l.bearing), i.setPitch(l.pitch);
                    var u = r.getView();
                    s._input.center = s.center = u.center, s._input.zoom = s.zoom = u.zoom, s._input.bearing = s.bearing = u.bearing, s._input.pitch = s.pitch = u.pitch, n.emit("plotly_doubleclick", null), n.emit("plotly_relayout", r.getViewEditsWithDerived(u));
                }), r.clearOutline = function() {
                    OHt(r.dragOptions), qHt(r.dragOptions.gd);
                }, r.onClickInPanFn = function(s) {
                    return function(l) {
                        var u = n._fullLayout.clickmode;
                        u.indexOf("select") > -1 && BHt(l.originalEvent, n, [
                            r.xaxis
                        ], [
                            r.yaxis
                        ], r.id, s), u.indexOf("event") > -1 && ZF.click(n, l.originalEvent);
                    };
                };
            };
            Ah.updateFx = function(e) {
                var t = this, r = t.map, n = t.gd;
                if (t.isStatic) return;
                function i(l) {
                    var u = t.map.unproject(l);
                    return [
                        u.lng,
                        u.lat
                    ];
                }
                var a = e.dragmode, o;
                o = function(l, u) {
                    if (u.isRect) {
                        var c = l.range = {};
                        c[t.id] = [
                            i([
                                u.xmin,
                                u.ymin
                            ]),
                            i([
                                u.xmax,
                                u.ymax
                            ])
                        ];
                    } else {
                        var f = l.lassoPoints = {};
                        f[t.id] = u.map(i);
                    }
                };
                var s = t.dragOptions;
                t.dragOptions = JK.extendDeep(s || {}, {
                    dragmode: e.dragmode,
                    element: t.div,
                    gd: n,
                    plotinfo: {
                        id: t.id,
                        domain: e[t.id].domain,
                        xaxis: t.xaxis,
                        yaxis: t.yaxis,
                        fillRangeItems: o
                    },
                    xaxes: [
                        t.xaxis
                    ],
                    yaxes: [
                        t.yaxis
                    ],
                    subplot: t.id
                }), r.off("click", t.onClickInPanHandler), zHt(a) || DHt(a) ? (r.dragPan.disable(), r.on("zoomstart", t.clearOutline), t.dragOptions.prepFn = function(l, u, c) {
                    FHt(l, u, c, t.dragOptions, a);
                }, RHt.init(t.dragOptions)) : (r.dragPan.enable(), r.off("zoomstart", t.clearOutline), t.div.onmousedown = null, t.div.ontouchstart = null, t.div.removeEventListener("touchstart", t.div._ontouchstart), t.onClickInPanHandler = t.onClickInPanFn(t.dragOptions), r.on("click", t.onClickInPanHandler));
            };
            Ah.updateFramework = function(e) {
                var t = e[this.id].domain, r = e._size, n = this.div.style;
                n.width = r.w * (t.x[1] - t.x[0]) + "px", n.height = r.h * (t.y[1] - t.y[0]) + "px", n.left = r.l + t.x[0] * r.w + "px", n.top = r.t + (1 - t.y[1]) * r.h + "px", this.xaxis._offset = r.l + t.x[0] * r.w, this.xaxis._length = r.w * (t.x[1] - t.x[0]), this.yaxis._offset = r.t + (1 - t.y[1]) * r.h, this.yaxis._length = r.h * (t.y[1] - t.y[0]);
            };
            Ah.updateLayers = function(e) {
                var t = e[this.id], r = t.layers, n = this.layerList, i;
                if (r.length !== n.length) {
                    for(i = 0; i < n.length; i++)n[i].dispose();
                    for(n = this.layerList = [], i = 0; i < r.length; i++)n.push(NHt(this, i, r[i]));
                } else for(i = 0; i < r.length; i++)n[i].update(r[i]);
            };
            Ah.destroy = function() {
                this.map && (this.map.remove(), this.map = null, this.container.removeChild(this.div));
            };
            Ah.toImage = function() {
                return this.map.stop(), this.map.getCanvas().toDataURL();
            };
            Ah.setOptions = function(e, t, r) {
                for(var n in r)this.map[t](e, n, r[n]);
            };
            Ah.getMapLayers = function() {
                return this.map.getStyle().layers;
            };
            Ah.addLayer = function(e, t) {
                var r = this.map;
                if (typeof t == "string") {
                    if (t === "") {
                        r.addLayer(e, t);
                        return;
                    }
                    for(var n = this.getMapLayers(), i = 0; i < n.length; i++)if (t === n[i].id) {
                        r.addLayer(e, t);
                        return;
                    }
                    JK.warn([
                        "Trying to add layer with *below* value",
                        t,
                        "referencing a layer that does not exist",
                        "or that does not yet exist."
                    ].join(" "));
                }
                r.addLayer(e);
            };
            Ah.project = function(e) {
                return this.map.project(new KK.LngLat(e[0], e[1]));
            };
            Ah.getView = function() {
                var e = this.map, t = e.getCenter(), r = t.lng, n = t.lat, i = {
                    lon: r,
                    lat: n
                }, a = e.getCanvas(), o = parseInt(a.style.width), s = parseInt(a.style.height);
                return {
                    center: i,
                    zoom: e.getZoom(),
                    bearing: e.getBearing(),
                    pitch: e.getPitch(),
                    _derived: {
                        coordinates: [
                            e.unproject([
                                0,
                                0
                            ]).toArray(),
                            e.unproject([
                                o,
                                0
                            ]).toArray(),
                            e.unproject([
                                o,
                                s
                            ]).toArray(),
                            e.unproject([
                                0,
                                s
                            ]).toArray()
                        ]
                    }
                };
            };
            Ah.getViewEdits = function(e) {
                for(var t = this.id, r = [
                    "center",
                    "zoom",
                    "bearing",
                    "pitch"
                ], n = {}, i = 0; i < r.length; i++){
                    var a = r[i];
                    n[t + "." + a] = e[a];
                }
                return n;
            };
            Ah.getViewEditsWithDerived = function(e) {
                var t = this.id, r = this.getViewEdits(e);
                return r[t + "._derived"] = e._derived, r;
            };
            function nVe(e, t) {
                var r = {};
                if (JK.isPlainObject(e)) r.id = e.id, r.style = e;
                else if (typeof e == "string") {
                    if (r.id = e, _x.styleValuesMapbox.indexOf(e) !== -1) r.style = eVe(e);
                    else if (_x.stylesNonMapbox[e]) {
                        r.style = _x.stylesNonMapbox[e];
                        var n = r.style.sources["plotly-" + e], i = n ? n.tiles : void 0;
                        i && i[0] && i[0].slice(-9) === "?api_key=" && (i[0] += t._mapboxAccessToken);
                    } else r.style = e;
                } else r.id = _x.styleValueDflt, r.style = eVe(_x.styleValueDflt);
                return r.transition = {
                    duration: 0,
                    delay: 0
                }, r;
            }
            function eVe(e) {
                return _x.styleUrlPrefix + e + "-" + _x.styleUrlSuffix;
            }
            function $K(e) {
                return [
                    e.lon,
                    e.lat
                ];
            }
            aVe.exports = iVe;
        });
        var uVe = ye((Uyr, lVe)=>{
            "use strict";
            var QK = Mr(), UHt = C_(), VHt = Zd(), sVe = Rk();
            lVe.exports = function(t, r, n) {
                UHt(t, r, n, {
                    type: "mapbox",
                    attributes: sVe,
                    handleDefaults: HHt,
                    partition: "y",
                    accessToken: r._mapboxAccessToken
                });
            };
            function HHt(e, t, r, n) {
                r("accesstoken", n.accessToken), r("style"), r("center.lon"), r("center.lat"), r("zoom"), r("bearing"), r("pitch");
                var i = r("bounds.west"), a = r("bounds.east"), o = r("bounds.south"), s = r("bounds.north");
                (i === void 0 || a === void 0 || o === void 0 || s === void 0) && delete t.bounds, VHt(e, t, {
                    name: "layers",
                    handleItemDefaults: GHt
                }), t._input = e;
            }
            function GHt(e, t) {
                function r(l, u) {
                    return QK.coerce(e, t, sVe.layers, l, u);
                }
                var n = r("visible");
                if (n) {
                    var i = r("sourcetype"), a = i === "raster" || i === "image";
                    r("source"), r("sourceattribution"), i === "vector" && r("sourcelayer"), i === "image" && r("coordinates");
                    var o;
                    a && (o = "raster");
                    var s = r("type", o);
                    a && s !== "raster" && (s = t.type = "raster", QK.log("Source types *raster* and *image* must drawn *raster* layer type.")), r("below"), r("color"), r("opacity"), r("minzoom"), r("maxzoom"), s === "circle" && r("circle.radius"), s === "line" && (r("line.width"), r("line.dash")), s === "fill" && r("fill.outlinecolor"), s === "symbol" && (r("symbol.icon"), r("symbol.iconsize"), r("symbol.text"), QK.coerceFont(r, "symbol.textfont", void 0, {
                        noFontVariant: !0,
                        noFontShadow: !0,
                        noFontLineposition: !0,
                        noFontTextcase: !0
                    }), r("symbol.textposition"), r("symbol.placement"));
                }
            }
        });
        var XF = ye((Np)=>{
            "use strict";
            var cVe = YK(), tm = Mr(), eJ = tm.strTranslate, jHt = tm.strScale, WHt = kd().getSubplotCalcData, ZHt = Zp(), XHt = xa(), fVe = ao(), YHt = Pl(), KHt = oVe(), xx = "mapbox", Qm = Np.constants = c1();
            Np.name = xx;
            Np.attr = "subplot";
            Np.idRoot = xx;
            Np.idRegex = Np.attrRegex = tm.counterRegex(xx);
            var JHt = [
                "mapbox subplots and traces are deprecated!",
                "Please consider switching to `map` subplots and traces.",
                "Learn more at: https://plotly.com/python/maplibre-migration/",
                "as well as https://plotly.com/javascript/maplibre-migration/"
            ].join(" ");
            Np.attributes = {
                subplot: {
                    valType: "subplotid",
                    dflt: "mapbox",
                    editType: "calc"
                }
            };
            Np.layoutAttributes = Rk();
            Np.supplyLayoutDefaults = uVe();
            var hVe = !0;
            Np.plot = function(t) {
                hVe && (hVe = !1, tm.warn(JHt));
                var r = t._fullLayout, n = t.calcdata, i = r._subplots[xx];
                if (cVe.version !== Qm.requiredVersion) throw new Error(Qm.wrongVersionErrorMsg);
                var a = $Ht(t, i);
                cVe.accessToken = a;
                for(var o = 0; o < i.length; o++){
                    var s = i[o], l = WHt(n, xx, s), u = r[s], c = u._subplot;
                    c || (c = new KHt(t, s), r[s]._subplot = c), c.viewInitial || (c.viewInitial = {
                        center: tm.extendFlat({}, u.center),
                        zoom: u.zoom,
                        bearing: u.bearing,
                        pitch: u.pitch
                    }), c.plot(l, r, t._promises);
                }
            };
            Np.clean = function(e, t, r, n) {
                for(var i = n._subplots[xx] || [], a = 0; a < i.length; a++){
                    var o = i[a];
                    !t[o] && n[o]._subplot && n[o]._subplot.destroy();
                }
            };
            Np.toSVG = function(e) {
                for(var t = e._fullLayout, r = t._subplots[xx], n = t._size, i = 0; i < r.length; i++){
                    var a = t[r[i]], o = a.domain, s = a._subplot, l = s.toImage("png"), u = t._glimages.append("svg:image");
                    u.attr({
                        xmlns: ZHt.svg,
                        "xlink:href": l,
                        x: n.l + n.w * o.x[0],
                        y: n.t + n.h * (1 - o.y[1]),
                        width: n.w * (o.x[1] - o.x[0]),
                        height: n.h * (o.y[1] - o.y[0]),
                        preserveAspectRatio: "none"
                    });
                    var c = XHt.select(a._subplot.div), f = c.select(".mapboxgl-ctrl-logo").node().offsetParent === null;
                    if (!f) {
                        var h = t._glimages.append("g");
                        h.attr("transform", eJ(n.l + n.w * o.x[0] + 10, n.t + n.h * (1 - o.y[0]) - 31)), h.append("path").attr("d", Qm.mapboxLogo.path0).style({
                            opacity: .9,
                            fill: "#ffffff",
                            "enable-background": "new"
                        }), h.append("path").attr("d", Qm.mapboxLogo.path1).style("opacity", .35).style("enable-background", "new"), h.append("path").attr("d", Qm.mapboxLogo.path2).style("opacity", .35).style("enable-background", "new"), h.append("polygon").attr("points", Qm.mapboxLogo.polygon).style({
                            opacity: .9,
                            fill: "#ffffff",
                            "enable-background": "new"
                        });
                    }
                    var d = c.select(".mapboxgl-ctrl-attrib").text().replace("Improve this map", ""), v = t._glimages.append("g"), x = v.append("text");
                    x.text(d).classed("static-attribution", !0).attr({
                        "font-size": 12,
                        "font-family": "Arial",
                        color: "rgba(0, 0, 0, 0.75)",
                        "text-anchor": "end",
                        "data-unformatted": d
                    });
                    var b = fVe.bBox(x.node()), p = n.w * (o.x[1] - o.x[0]);
                    if (b.width > p / 2) {
                        var E = d.split("|").join("<br>");
                        x.text(E).attr("data-unformatted", E).call(YHt.convertToTspans, e), b = fVe.bBox(x.node());
                    }
                    x.attr("transform", eJ(-3, -b.height + 8)), v.insert("rect", ".static-attribution").attr({
                        x: -b.width - 6,
                        y: -b.height - 3,
                        width: b.width + 6,
                        height: b.height + 3,
                        fill: "rgba(255, 255, 255, 0.75)"
                    });
                    var k = 1;
                    b.width + 6 > p && (k = p / (b.width + 6));
                    var A = [
                        n.l + n.w * o.x[1],
                        n.t + n.h * (1 - o.y[0])
                    ];
                    v.attr("transform", eJ(A[0], A[1]) + jHt(k));
                }
            };
            function $Ht(e, t) {
                var r = e._fullLayout, n = e._context;
                if (n.mapboxAccessToken === "") return "";
                for(var i = [], a = [], o = !1, s = !1, l = 0; l < t.length; l++){
                    var u = r[t[l]], c = u.accesstoken;
                    dVe(u.style) && (c ? tm.pushUnique(i, c) : (dVe(u._input.style) && (tm.error("Uses Mapbox map style, but did not set an access token."), o = !0), s = !0)), c && tm.pushUnique(a, c);
                }
                if (s) {
                    var f = o ? Qm.noAccessTokenErrorMsg : Qm.missingStyleErrorMsg;
                    throw tm.error(f), new Error(f);
                }
                return i.length ? (i.length > 1 && tm.warn(Qm.multipleTokensErrorMsg), i[0]) : (a.length && tm.log([
                    "Listed mapbox access token(s)",
                    a.join(","),
                    "but did not use a Mapbox map style, ignoring token(s)."
                ].join(" ")), "");
            }
            function dVe(e) {
                return typeof e == "string" && (Qm.styleValuesMapbox.indexOf(e) !== -1 || e.indexOf("mapbox://") === 0 || e.indexOf("stamen") === 0);
            }
            Np.updateFx = function(e) {
                for(var t = e._fullLayout, r = t._subplots[xx], n = 0; n < r.length; n++){
                    var i = t[r[n]]._subplot;
                    i.updateFx(t);
                }
            };
        });
        var pVe = ye((Gyr, vVe)=>{
            "use strict";
            var Hyr = [
                "*scattermapbox* trace is deprecated!",
                "Please consider switching to the *scattermap* trace type and `map` subplots.",
                "Learn more at: https://plotly.com/python/maplibre-migration/",
                "as well as https://plotly.com/javascript/maplibre-migration/"
            ].join(" ");
            vVe.exports = {
                attributes: NF(),
                supplyDefaults: MUe(),
                colorbar: Kd(),
                formatLabels: VK(),
                calc: lz(),
                plot: NUe(),
                hoverPoints: jF().hoverPoints,
                eventData: GUe(),
                selectPoints: WUe(),
                styleOnSelect: function(e, t) {
                    if (t) {
                        var r = t[0].trace;
                        r._glTrace.update(t);
                    }
                },
                moduleType: "trace",
                name: "scattermapbox",
                basePlotModule: XF(),
                categories: [
                    "mapbox",
                    "gl",
                    "symbols",
                    "showLegend",
                    "scatter-like"
                ],
                meta: {}
            };
        });
        var mVe = ye((jyr, gVe)=>{
            "use strict";
            gVe.exports = pVe();
        });
        var tJ = ye((Wyr, yVe)=>{
            "use strict";
            var f1 = K5(), QHt = Jl(), eGt = Wo().hovertemplateAttrs, tGt = vl(), bx = no().extendFlat;
            yVe.exports = bx({
                locations: {
                    valType: "data_array",
                    editType: "calc"
                },
                z: {
                    valType: "data_array",
                    editType: "calc"
                },
                geojson: {
                    valType: "any",
                    editType: "calc"
                },
                featureidkey: bx({}, f1.featureidkey, {}),
                below: {
                    valType: "string",
                    editType: "plot"
                },
                text: f1.text,
                hovertext: f1.hovertext,
                marker: {
                    line: {
                        color: bx({}, f1.marker.line.color, {
                            editType: "plot"
                        }),
                        width: bx({}, f1.marker.line.width, {
                            editType: "plot"
                        }),
                        editType: "calc"
                    },
                    opacity: bx({}, f1.marker.opacity, {
                        editType: "plot"
                    }),
                    editType: "calc"
                },
                selected: {
                    marker: {
                        opacity: bx({}, f1.selected.marker.opacity, {
                            editType: "plot"
                        }),
                        editType: "plot"
                    },
                    editType: "plot"
                },
                unselected: {
                    marker: {
                        opacity: bx({}, f1.unselected.marker.opacity, {
                            editType: "plot"
                        }),
                        editType: "plot"
                    },
                    editType: "plot"
                },
                hoverinfo: f1.hoverinfo,
                hovertemplate: eGt({}, {
                    keys: [
                        "properties"
                    ]
                }),
                showlegend: bx({}, tGt.showlegend, {
                    dflt: !1
                })
            }, QHt("", {
                cLetter: "z",
                editTypeOverride: "calc"
            }));
        });
        var xVe = ye((Zyr, _Ve)=>{
            "use strict";
            var qk = Mr(), rGt = Uh(), iGt = tJ();
            _Ve.exports = function(t, r, n, i) {
                function a(c, f) {
                    return qk.coerce(t, r, iGt, c, f);
                }
                var o = a("locations"), s = a("z"), l = a("geojson");
                if (!qk.isArrayOrTypedArray(o) || !o.length || !qk.isArrayOrTypedArray(s) || !s.length || !(typeof l == "string" && l !== "" || qk.isPlainObject(l))) {
                    r.visible = !1;
                    return;
                }
                a("featureidkey"), r._length = Math.min(o.length, s.length), a("below"), a("text"), a("hovertext"), a("hovertemplate");
                var u = a("marker.line.width");
                u && a("marker.line.color"), a("marker.opacity"), rGt(t, r, i, a, {
                    prefix: "",
                    cLetter: "z"
                }), qk.coerceSelectionMarkerOpacity(r, a);
            };
        });
        var rJ = ye((Xyr, TVe)=>{
            "use strict";
            var nGt = uo(), h1 = Mr(), aGt = Mu(), oGt = ao(), sGt = rx().makeBlank, bVe = nx();
            function lGt(e) {
                var t = e[0].trace, r = t.visible === !0 && t._length !== 0, n = {
                    layout: {
                        visibility: "none"
                    },
                    paint: {}
                }, i = {
                    layout: {
                        visibility: "none"
                    },
                    paint: {}
                }, a = t._opts = {
                    fill: n,
                    line: i,
                    geojson: sGt()
                };
                if (!r) return a;
                var o = bVe.extractTraceFeature(e);
                if (!o) return a;
                var s = aGt.makeColorScaleFuncFromTrace(t), l = t.marker, u = l.line || {}, c;
                h1.isArrayOrTypedArray(l.opacity) && (c = function(E) {
                    var k = E.mo;
                    return nGt(k) ? +h1.constrain(k, 0, 1) : 0;
                });
                var f;
                h1.isArrayOrTypedArray(u.color) && (f = function(E) {
                    return E.mlc;
                });
                var h;
                h1.isArrayOrTypedArray(u.width) && (h = function(E) {
                    return E.mlw;
                });
                for(var d = 0; d < e.length; d++){
                    var v = e[d], x = v.fOut;
                    if (x) {
                        var b = x.properties;
                        b.fc = s(v.z), c && (b.mo = c(v)), f && (b.mlc = f(v)), h && (b.mlw = h(v)), v.ct = b.ct, v._polygons = bVe.feature2polygons(x);
                    }
                }
                var p = c ? {
                    type: "identity",
                    property: "mo"
                } : l.opacity;
                return h1.extendFlat(n.paint, {
                    "fill-color": {
                        type: "identity",
                        property: "fc"
                    },
                    "fill-opacity": p
                }), h1.extendFlat(i.paint, {
                    "line-color": f ? {
                        type: "identity",
                        property: "mlc"
                    } : u.color,
                    "line-width": h ? {
                        type: "identity",
                        property: "mlw"
                    } : u.width,
                    "line-opacity": p
                }), n.layout.visibility = "visible", i.layout.visibility = "visible", a.geojson = {
                    type: "FeatureCollection",
                    features: o
                }, wVe(e), a;
            }
            function wVe(e) {
                var t = e[0].trace, r = t._opts, n;
                if (t.selectedpoints) {
                    for(var i = oGt.makeSelectedPointStyleFns(t), a = 0; a < e.length; a++){
                        var o = e[a];
                        o.fOut && (o.fOut.properties.mo2 = i.selectedOpacityFn(o));
                    }
                    n = {
                        type: "identity",
                        property: "mo2"
                    };
                } else n = h1.isArrayOrTypedArray(t.marker.opacity) ? {
                    type: "identity",
                    property: "mo"
                } : t.marker.opacity;
                return h1.extendFlat(r.fill.paint, {
                    "fill-opacity": n
                }), h1.extendFlat(r.line.paint, {
                    "line-opacity": n
                }), r;
            }
            TVe.exports = {
                convert: lGt,
                convertOnSelect: wVe
            };
        });
        var kVe = ye((Yyr, EVe)=>{
            "use strict";
            var SVe = rJ().convert, uGt = rJ().convertOnSelect, AVe = c1().traceLayerPrefix;
            function MVe(e, t) {
                this.type = "choroplethmapbox", this.subplot = e, this.uid = t, this.sourceId = "source-" + t, this.layerList = [
                    [
                        "fill",
                        AVe + t + "-fill"
                    ],
                    [
                        "line",
                        AVe + t + "-line"
                    ]
                ], this.below = null;
            }
            var wA = MVe.prototype;
            wA.update = function(e) {
                this._update(SVe(e)), e[0].trace._glTrace = this;
            };
            wA.updateOnSelect = function(e) {
                this._update(uGt(e));
            };
            wA._update = function(e) {
                var t = this.subplot, r = this.layerList, n = t.belowLookup["trace-" + this.uid];
                t.map.getSource(this.sourceId).setData(e.geojson), n !== this.below && (this._removeLayers(), this._addLayers(e, n), this.below = n);
                for(var i = 0; i < r.length; i++){
                    var a = r[i], o = a[0], s = a[1], l = e[o];
                    t.setOptions(s, "setLayoutProperty", l.layout), l.layout.visibility === "visible" && t.setOptions(s, "setPaintProperty", l.paint);
                }
            };
            wA._addLayers = function(e, t) {
                for(var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++){
                    var o = n[a], s = o[0], l = e[s];
                    r.addLayer({
                        type: s,
                        id: o[1],
                        source: i,
                        layout: l.layout,
                        paint: l.paint
                    }, t);
                }
            };
            wA._removeLayers = function() {
                for(var e = this.subplot.map, t = this.layerList, r = t.length - 1; r >= 0; r--)e.removeLayer(t[r][1]);
            };
            wA.dispose = function() {
                var e = this.subplot.map;
                this._removeLayers(), e.removeSource(this.sourceId);
            };
            EVe.exports = function(t, r) {
                var n = r[0].trace, i = new MVe(t, n.uid), a = i.sourceId, o = SVe(r), s = i.below = t.belowLookup["trace-" + n.uid];
                return t.map.addSource(a, {
                    type: "geojson",
                    data: o.geojson
                }), i._addLayers(o, s), r[0].trace._glTrace = i, i;
            };
        });
        var LVe = ye((Jyr, CVe)=>{
            "use strict";
            var Kyr = [
                "*choroplethmapbox* trace is deprecated!",
                "Please consider switching to the *choroplethmap* trace type and `map` subplots.",
                "Learn more at: https://plotly.com/python/maplibre-migration/",
                "as well as https://plotly.com/javascript/maplibre-migration/"
            ].join(" ");
            CVe.exports = {
                attributes: tJ(),
                supplyDefaults: xVe(),
                colorbar: M_(),
                calc: Lz(),
                plot: kVe(),
                hoverPoints: Iz(),
                eventData: Rz(),
                selectPoints: Dz(),
                styleOnSelect: function(e, t) {
                    if (t) {
                        var r = t[0].trace;
                        r._glTrace.updateOnSelect(t);
                    }
                },
                getBelow: function(e, t) {
                    for(var r = t.getMapLayers(), n = r.length - 2; n >= 0; n--){
                        var i = r[n].id;
                        if (typeof i == "string" && i.indexOf("water") === 0) {
                            for(var a = n + 1; a < r.length; a++)if (i = r[a].id, typeof i == "string" && i.indexOf("plotly-") === -1) return i;
                        }
                    }
                },
                moduleType: "trace",
                name: "choroplethmapbox",
                basePlotModule: XF(),
                categories: [
                    "mapbox",
                    "gl",
                    "noOpacity",
                    "showLegend"
                ],
                meta: {
                    hr_name: "choropleth_mapbox"
                }
            };
        });
        var IVe = ye(($yr, PVe)=>{
            "use strict";
            PVe.exports = LVe();
        });
        var nJ = ye((Qyr, DVe)=>{
            "use strict";
            var cGt = Jl(), fGt = Wo().hovertemplateAttrs, RVe = vl(), YF = NF(), iJ = no().extendFlat;
            DVe.exports = iJ({
                lon: YF.lon,
                lat: YF.lat,
                z: {
                    valType: "data_array",
                    editType: "calc"
                },
                radius: {
                    valType: "number",
                    editType: "plot",
                    arrayOk: !0,
                    min: 1,
                    dflt: 30
                },
                below: {
                    valType: "string",
                    editType: "plot"
                },
                text: YF.text,
                hovertext: YF.hovertext,
                hoverinfo: iJ({}, RVe.hoverinfo, {
                    flags: [
                        "lon",
                        "lat",
                        "z",
                        "text",
                        "name"
                    ]
                }),
                hovertemplate: fGt(),
                showlegend: iJ({}, RVe.showlegend, {
                    dflt: !1
                })
            }, cGt("", {
                cLetter: "z",
                editTypeOverride: "calc"
            }));
        });
        var FVe = ye((e1r, zVe)=>{
            "use strict";
            var hGt = Mr(), dGt = Uh(), vGt = nJ();
            zVe.exports = function(t, r, n, i) {
                function a(u, c) {
                    return hGt.coerce(t, r, vGt, u, c);
                }
                var o = a("lon") || [], s = a("lat") || [], l = Math.min(o.length, s.length);
                if (!l) {
                    r.visible = !1;
                    return;
                }
                r._length = l, a("z"), a("radius"), a("below"), a("text"), a("hovertext"), a("hovertemplate"), dGt(t, r, i, a, {
                    prefix: "",
                    cLetter: "z"
                });
            };
        });
        var BVe = ye((t1r, OVe)=>{
            "use strict";
            var aJ = uo(), pGt = Mr().isArrayOrTypedArray, oJ = es().BADNUM, gGt = zv(), qVe = Mr()._;
            OVe.exports = function(t, r) {
                for(var n = r._length, i = new Array(n), a = r.z, o = pGt(a) && a.length, s = 0; s < n; s++){
                    var l = i[s] = {}, u = r.lon[s], c = r.lat[s];
                    if (l.lonlat = aJ(u) && aJ(c) ? [
                        +u,
                        +c
                    ] : [
                        oJ,
                        oJ
                    ], o) {
                        var f = a[s];
                        l.z = aJ(f) ? f : oJ;
                    }
                }
                return gGt(t, r, {
                    vals: o ? a : [
                        0,
                        1
                    ],
                    containerStr: "",
                    cLetter: "z"
                }), n && (i[0].t = {
                    labels: {
                        lat: qVe(t, "lat:") + " ",
                        lon: qVe(t, "lon:") + " "
                    }
                }), i;
            };
        });
        var GVe = ye((r1r, HVe)=>{
            "use strict";
            var mGt = uo(), sJ = Mr(), NVe = va(), UVe = Mu(), VVe = es().BADNUM, yGt = rx().makeBlank;
            HVe.exports = function(t) {
                var r = t[0].trace, n = r.visible === !0 && r._length !== 0, i = {
                    layout: {
                        visibility: "none"
                    },
                    paint: {}
                }, a = r._opts = {
                    heatmap: i,
                    geojson: yGt()
                };
                if (!n) return a;
                var o = [], s, l = r.z, u = r.radius, c = sJ.isArrayOrTypedArray(l) && l.length, f = sJ.isArrayOrTypedArray(u);
                for(s = 0; s < t.length; s++){
                    var h = t[s], d = h.lonlat;
                    if (d[0] !== VVe) {
                        var v = {};
                        if (c) {
                            var x = h.z;
                            v.z = x !== VVe ? x : 0;
                        }
                        f && (v.r = mGt(u[s]) && u[s] > 0 ? +u[s] : 0), o.push({
                            type: "Feature",
                            geometry: {
                                type: "Point",
                                coordinates: d
                            },
                            properties: v
                        });
                    }
                }
                var b = UVe.extractOpts(r), p = b.reversescale ? UVe.flipScale(b.colorscale) : b.colorscale, E = p[0][1], k = NVe.opacity(E) < 1 ? E : NVe.addOpacity(E, 0), A = [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "heatmap-density"
                    ],
                    0,
                    k
                ];
                for(s = 1; s < p.length; s++)A.push(p[s][0], p[s][1]);
                var L = [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "get",
                        "z"
                    ],
                    b.min,
                    0,
                    b.max,
                    1
                ];
                return sJ.extendFlat(a.heatmap.paint, {
                    "heatmap-weight": c ? L : 1 / (b.max - b.min),
                    "heatmap-color": A,
                    "heatmap-radius": f ? {
                        type: "identity",
                        property: "r"
                    } : r.radius,
                    "heatmap-opacity": r.opacity
                }), a.geojson = {
                    type: "FeatureCollection",
                    features: o
                }, a.heatmap.layout.visibility = "visible", a;
            };
        });
        var XVe = ye((i1r, ZVe)=>{
            "use strict";
            var jVe = GVe(), _Gt = c1().traceLayerPrefix;
            function WVe(e, t) {
                this.type = "densitymapbox", this.subplot = e, this.uid = t, this.sourceId = "source-" + t, this.layerList = [
                    [
                        "heatmap",
                        _Gt + t + "-heatmap"
                    ]
                ], this.below = null;
            }
            var KF = WVe.prototype;
            KF.update = function(e) {
                var t = this.subplot, r = this.layerList, n = jVe(e), i = t.belowLookup["trace-" + this.uid];
                t.map.getSource(this.sourceId).setData(n.geojson), i !== this.below && (this._removeLayers(), this._addLayers(n, i), this.below = i);
                for(var a = 0; a < r.length; a++){
                    var o = r[a], s = o[0], l = o[1], u = n[s];
                    t.setOptions(l, "setLayoutProperty", u.layout), u.layout.visibility === "visible" && t.setOptions(l, "setPaintProperty", u.paint);
                }
            };
            KF._addLayers = function(e, t) {
                for(var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++){
                    var o = n[a], s = o[0], l = e[s];
                    r.addLayer({
                        type: s,
                        id: o[1],
                        source: i,
                        layout: l.layout,
                        paint: l.paint
                    }, t);
                }
            };
            KF._removeLayers = function() {
                for(var e = this.subplot.map, t = this.layerList, r = t.length - 1; r >= 0; r--)e.removeLayer(t[r][1]);
            };
            KF.dispose = function() {
                var e = this.subplot.map;
                this._removeLayers(), e.removeSource(this.sourceId);
            };
            ZVe.exports = function(t, r) {
                var n = r[0].trace, i = new WVe(t, n.uid), a = i.sourceId, o = jVe(r), s = i.below = t.belowLookup["trace-" + n.uid];
                return t.map.addSource(a, {
                    type: "geojson",
                    data: o.geojson
                }), i._addLayers(o, s), i;
            };
        });
        var KVe = ye((n1r, YVe)=>{
            "use strict";
            var xGt = Qa(), bGt = jF().hoverPoints, wGt = jF().getExtraText;
            YVe.exports = function(t, r, n) {
                var i = bGt(t, r, n);
                if (i) {
                    var a = i[0], o = a.cd, s = o[0].trace, l = o[a.index];
                    if (delete a.color, "z" in l) {
                        var u = a.subplot.mockAxis;
                        a.z = l.z, a.zLabel = xGt.tickText(u, u.c2l(l.z), "hover").text;
                    }
                    return a.extraText = wGt(s, l, o[0].t.labels), [
                        a
                    ];
                }
            };
        });
        var $Ve = ye((a1r, JVe)=>{
            "use strict";
            JVe.exports = function(t, r) {
                return t.lon = r.lon, t.lat = r.lat, t.z = r.z, t;
            };
        });
        var eHe = ye((s1r, QVe)=>{
            "use strict";
            var o1r = [
                "*densitymapbox* trace is deprecated!",
                "Please consider switching to the *densitymap* trace type and `map` subplots.",
                "Learn more at: https://plotly.com/python/maplibre-migration/",
                "as well as https://plotly.com/javascript/maplibre-migration/"
            ].join(" ");
            QVe.exports = {
                attributes: nJ(),
                supplyDefaults: FVe(),
                colorbar: M_(),
                formatLabels: VK(),
                calc: BVe(),
                plot: XVe(),
                hoverPoints: KVe(),
                eventData: $Ve(),
                getBelow: function(e, t) {
                    for(var r = t.getMapLayers(), n = 0; n < r.length; n++){
                        var i = r[n], a = i.id;
                        if (i.type === "symbol" && typeof a == "string" && a.indexOf("plotly-") === -1) return a;
                    }
                },
                moduleType: "trace",
                name: "densitymapbox",
                basePlotModule: XF(),
                categories: [
                    "mapbox",
                    "gl",
                    "showLegend"
                ],
                meta: {
                    hr_name: "density_mapbox"
                }
            };
        });
        var rHe = ye((l1r, tHe)=>{
            "use strict";
            tHe.exports = eHe();
        });
        var nHe = ye((u1r, iHe)=>{
            iHe.exports = {
                version: 8,
                name: "orto",
                metadata: {
                    "maputnik:renderer": "mlgljs"
                },
                center: [
                    1.537786,
                    41.837539
                ],
                zoom: 12,
                bearing: 0,
                pitch: 0,
                light: {
                    anchor: "viewport",
                    color: "white",
                    intensity: .4,
                    position: [
                        1.15,
                        45,
                        30
                    ]
                },
                sources: {
                    ortoEsri: {
                        type: "raster",
                        tiles: [
                            "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                        ],
                        tileSize: 256,
                        maxzoom: 18,
                        attribution: "ESRI &copy; <a href='http://www.esri.com'>ESRI</a>"
                    },
                    ortoInstaMaps: {
                        type: "raster",
                        tiles: [
                            "https://tilemaps.icgc.cat/mapfactory/wmts/orto_8_12/CAT3857/{z}/{x}/{y}.png"
                        ],
                        tileSize: 256,
                        maxzoom: 13
                    },
                    ortoICGC: {
                        type: "raster",
                        tiles: [
                            "https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.jpeg"
                        ],
                        tileSize: 256,
                        minzoom: 13.1,
                        maxzoom: 20
                    },
                    openmaptiles: {
                        type: "vector",
                        url: "https://geoserveis.icgc.cat/contextmaps/basemap.json"
                    }
                },
                sprite: "https://geoserveis.icgc.cat/contextmaps/sprites/sprite@1",
                glyphs: "https://geoserveis.icgc.cat/contextmaps/glyphs/{fontstack}/{range}.pbf",
                layers: [
                    {
                        id: "background",
                        type: "background",
                        paint: {
                            "background-color": "#F4F9F4"
                        }
                    },
                    {
                        id: "ortoEsri",
                        type: "raster",
                        source: "ortoEsri",
                        maxzoom: 16,
                        layout: {
                            visibility: "visible"
                        }
                    },
                    {
                        id: "ortoICGC",
                        type: "raster",
                        source: "ortoICGC",
                        minzoom: 13.1,
                        maxzoom: 19,
                        layout: {
                            visibility: "visible"
                        }
                    },
                    {
                        id: "ortoInstaMaps",
                        type: "raster",
                        source: "ortoInstaMaps",
                        maxzoom: 13,
                        layout: {
                            visibility: "visible"
                        }
                    },
                    {
                        id: "waterway_tunnel",
                        type: "line",
                        source: "openmaptiles",
                        "source-layer": "waterway",
                        minzoom: 14,
                        filter: [
                            "all",
                            [
                                "in",
                                "class",
                                "river",
                                "stream",
                                "canal"
                            ],
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ]
                        ],
                        layout: {
                            "line-cap": "round"
                        },
                        paint: {
                            "line-color": "#a0c8f0",
                            "line-width": {
                                base: 1.3,
                                stops: [
                                    [
                                        13,
                                        .5
                                    ],
                                    [
                                        20,
                                        6
                                    ]
                                ]
                            },
                            "line-dasharray": [
                                2,
                                4
                            ]
                        }
                    },
                    {
                        id: "waterway-other",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849382550.77"
                        },
                        source: "openmaptiles",
                        "source-layer": "waterway",
                        filter: [
                            "!in",
                            "class",
                            "canal",
                            "river",
                            "stream"
                        ],
                        layout: {
                            "line-cap": "round"
                        },
                        paint: {
                            "line-color": "#a0c8f0",
                            "line-width": {
                                base: 1.3,
                                stops: [
                                    [
                                        13,
                                        .5
                                    ],
                                    [
                                        20,
                                        2
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "waterway-stream-canal",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849382550.77"
                        },
                        source: "openmaptiles",
                        "source-layer": "waterway",
                        filter: [
                            "all",
                            [
                                "in",
                                "class",
                                "canal",
                                "stream"
                            ],
                            [
                                "!=",
                                "brunnel",
                                "tunnel"
                            ]
                        ],
                        layout: {
                            "line-cap": "round"
                        },
                        paint: {
                            "line-color": "#a0c8f0",
                            "line-width": {
                                base: 1.3,
                                stops: [
                                    [
                                        13,
                                        .5
                                    ],
                                    [
                                        20,
                                        6
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "waterway-river",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849382550.77"
                        },
                        source: "openmaptiles",
                        "source-layer": "waterway",
                        filter: [
                            "all",
                            [
                                "==",
                                "class",
                                "river"
                            ],
                            [
                                "!=",
                                "brunnel",
                                "tunnel"
                            ]
                        ],
                        layout: {
                            "line-cap": "round"
                        },
                        paint: {
                            "line-color": "#a0c8f0",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        10,
                                        .8
                                    ],
                                    [
                                        20,
                                        4
                                    ]
                                ]
                            },
                            "line-opacity": .5
                        }
                    },
                    {
                        id: "water-offset",
                        type: "fill",
                        metadata: {
                            "mapbox:group": "1444849382550.77"
                        },
                        source: "openmaptiles",
                        "source-layer": "water",
                        maxzoom: 8,
                        filter: [
                            "==",
                            "$type",
                            "Polygon"
                        ],
                        layout: {
                            visibility: "visible"
                        },
                        paint: {
                            "fill-opacity": 0,
                            "fill-color": "#a0c8f0",
                            "fill-translate": {
                                base: 1,
                                stops: [
                                    [
                                        6,
                                        [
                                            2,
                                            0
                                        ]
                                    ],
                                    [
                                        8,
                                        [
                                            0,
                                            0
                                        ]
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "water",
                        type: "fill",
                        metadata: {
                            "mapbox:group": "1444849382550.77"
                        },
                        source: "openmaptiles",
                        "source-layer": "water",
                        layout: {
                            visibility: "visible"
                        },
                        paint: {
                            "fill-color": "hsl(210, 67%, 85%)",
                            "fill-opacity": 0
                        }
                    },
                    {
                        id: "water-pattern",
                        type: "fill",
                        metadata: {
                            "mapbox:group": "1444849382550.77"
                        },
                        source: "openmaptiles",
                        "source-layer": "water",
                        layout: {
                            visibility: "visible"
                        },
                        paint: {
                            "fill-translate": [
                                0,
                                2.5
                            ],
                            "fill-pattern": "wave",
                            "fill-opacity": 1
                        }
                    },
                    {
                        id: "landcover-ice-shelf",
                        type: "fill",
                        metadata: {
                            "mapbox:group": "1444849382550.77"
                        },
                        source: "openmaptiles",
                        "source-layer": "landcover",
                        filter: [
                            "==",
                            "subclass",
                            "ice_shelf"
                        ],
                        layout: {
                            visibility: "visible"
                        },
                        paint: {
                            "fill-color": "#fff",
                            "fill-opacity": {
                                base: 1,
                                stops: [
                                    [
                                        0,
                                        .9
                                    ],
                                    [
                                        10,
                                        .3
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "tunnel-service-track-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "service",
                                "track"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#cfcdca",
                            "line-dasharray": [
                                .5,
                                .25
                            ],
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        15,
                                        1
                                    ],
                                    [
                                        16,
                                        4
                                    ],
                                    [
                                        20,
                                        11
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "tunnel-minor-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "==",
                                "class",
                                "minor"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#cfcdca",
                            "line-opacity": {
                                stops: [
                                    [
                                        12,
                                        0
                                    ],
                                    [
                                        12.5,
                                        1
                                    ]
                                ]
                            },
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        12,
                                        .5
                                    ],
                                    [
                                        13,
                                        1
                                    ],
                                    [
                                        14,
                                        4
                                    ],
                                    [
                                        20,
                                        15
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "tunnel-secondary-tertiary-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "secondary",
                                "tertiary"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-opacity": 1,
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        8,
                                        1.5
                                    ],
                                    [
                                        20,
                                        17
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "tunnel-trunk-primary-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "primary",
                                "trunk"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        5,
                                        .4
                                    ],
                                    [
                                        6,
                                        .6
                                    ],
                                    [
                                        7,
                                        1.5
                                    ],
                                    [
                                        20,
                                        22
                                    ]
                                ]
                            },
                            "line-opacity": .7
                        }
                    },
                    {
                        id: "tunnel-motorway-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "==",
                                "class",
                                "motorway"
                            ]
                        ],
                        layout: {
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-dasharray": [
                                .5,
                                .25
                            ],
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        5,
                                        .4
                                    ],
                                    [
                                        6,
                                        .6
                                    ],
                                    [
                                        7,
                                        1.5
                                    ],
                                    [
                                        20,
                                        22
                                    ]
                                ]
                            },
                            "line-opacity": .5
                        }
                    },
                    {
                        id: "tunnel-path",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "==",
                                    "brunnel",
                                    "tunnel"
                                ],
                                [
                                    "==",
                                    "class",
                                    "path"
                                ]
                            ]
                        ],
                        paint: {
                            "line-color": "#cba",
                            "line-dasharray": [
                                1.5,
                                .75
                            ],
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        15,
                                        1.2
                                    ],
                                    [
                                        20,
                                        4
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "tunnel-service-track",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "service",
                                "track"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fff",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        15.5,
                                        0
                                    ],
                                    [
                                        16,
                                        2
                                    ],
                                    [
                                        20,
                                        7.5
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "tunnel-minor",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "==",
                                "class",
                                "minor_road"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fff",
                            "line-opacity": 1,
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        13.5,
                                        0
                                    ],
                                    [
                                        14,
                                        2.5
                                    ],
                                    [
                                        20,
                                        11.5
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "tunnel-secondary-tertiary",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "secondary",
                                "tertiary"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fff4c6",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        6.5,
                                        0
                                    ],
                                    [
                                        7,
                                        .5
                                    ],
                                    [
                                        20,
                                        10
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "tunnel-trunk-primary",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "primary",
                                "trunk"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fff4c6",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        6.5,
                                        0
                                    ],
                                    [
                                        7,
                                        .5
                                    ],
                                    [
                                        20,
                                        18
                                    ]
                                ]
                            },
                            "line-opacity": .5
                        }
                    },
                    {
                        id: "tunnel-motorway",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "==",
                                "class",
                                "motorway"
                            ]
                        ],
                        layout: {
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#ffdaa6",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        6.5,
                                        0
                                    ],
                                    [
                                        7,
                                        .5
                                    ],
                                    [
                                        20,
                                        18
                                    ]
                                ]
                            },
                            "line-opacity": .5
                        }
                    },
                    {
                        id: "tunnel-railway",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849354174.1904"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "tunnel"
                            ],
                            [
                                "==",
                                "class",
                                "rail"
                            ]
                        ],
                        paint: {
                            "line-color": "#bbb",
                            "line-width": {
                                base: 1.4,
                                stops: [
                                    [
                                        14,
                                        .4
                                    ],
                                    [
                                        15,
                                        .75
                                    ],
                                    [
                                        20,
                                        2
                                    ]
                                ]
                            },
                            "line-dasharray": [
                                2,
                                2
                            ]
                        }
                    },
                    {
                        id: "ferry",
                        type: "line",
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "in",
                                "class",
                                "ferry"
                            ]
                        ],
                        layout: {
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "rgba(108, 159, 182, 1)",
                            "line-width": 1.1,
                            "line-dasharray": [
                                2,
                                2
                            ]
                        }
                    },
                    {
                        id: "aeroway-taxiway-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "aeroway",
                        minzoom: 12,
                        filter: [
                            "all",
                            [
                                "in",
                                "class",
                                "taxiway"
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "rgba(153, 153, 153, 1)",
                            "line-width": {
                                base: 1.5,
                                stops: [
                                    [
                                        11,
                                        2
                                    ],
                                    [
                                        17,
                                        12
                                    ]
                                ]
                            },
                            "line-opacity": 1
                        }
                    },
                    {
                        id: "aeroway-runway-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "aeroway",
                        minzoom: 12,
                        filter: [
                            "all",
                            [
                                "in",
                                "class",
                                "runway"
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "rgba(153, 153, 153, 1)",
                            "line-width": {
                                base: 1.5,
                                stops: [
                                    [
                                        11,
                                        5
                                    ],
                                    [
                                        17,
                                        55
                                    ]
                                ]
                            },
                            "line-opacity": 1
                        }
                    },
                    {
                        id: "aeroway-taxiway",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "aeroway",
                        minzoom: 4,
                        filter: [
                            "all",
                            [
                                "in",
                                "class",
                                "taxiway"
                            ],
                            [
                                "==",
                                "$type",
                                "LineString"
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "rgba(255, 255, 255, 1)",
                            "line-width": {
                                base: 1.5,
                                stops: [
                                    [
                                        11,
                                        1
                                    ],
                                    [
                                        17,
                                        10
                                    ]
                                ]
                            },
                            "line-opacity": {
                                base: 1,
                                stops: [
                                    [
                                        11,
                                        0
                                    ],
                                    [
                                        12,
                                        1
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "aeroway-runway",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "aeroway",
                        minzoom: 4,
                        filter: [
                            "all",
                            [
                                "in",
                                "class",
                                "runway"
                            ],
                            [
                                "==",
                                "$type",
                                "LineString"
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "rgba(255, 255, 255, 1)",
                            "line-width": {
                                base: 1.5,
                                stops: [
                                    [
                                        11,
                                        4
                                    ],
                                    [
                                        17,
                                        50
                                    ]
                                ]
                            },
                            "line-opacity": {
                                base: 1,
                                stops: [
                                    [
                                        11,
                                        0
                                    ],
                                    [
                                        12,
                                        1
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-motorway-link-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 12,
                        filter: [
                            "all",
                            [
                                "!in",
                                "brunnel",
                                "bridge",
                                "tunnel"
                            ],
                            [
                                "==",
                                "class",
                                "motorway_link"
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-opacity": 1,
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        12,
                                        1
                                    ],
                                    [
                                        13,
                                        3
                                    ],
                                    [
                                        14,
                                        4
                                    ],
                                    [
                                        20,
                                        15
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-link-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 13,
                        filter: [
                            "all",
                            [
                                "!in",
                                "brunnel",
                                "bridge",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "primary_link",
                                "secondary_link",
                                "tertiary_link",
                                "trunk_link"
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-opacity": 1,
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        12,
                                        1
                                    ],
                                    [
                                        13,
                                        3
                                    ],
                                    [
                                        14,
                                        4
                                    ],
                                    [
                                        20,
                                        15
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-minor-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "!=",
                                    "brunnel",
                                    "tunnel"
                                ],
                                [
                                    "in",
                                    "class",
                                    "minor",
                                    "service",
                                    "track"
                                ]
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#cfcdca",
                            "line-opacity": {
                                stops: [
                                    [
                                        12,
                                        0
                                    ],
                                    [
                                        12.5,
                                        0
                                    ]
                                ]
                            },
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        12,
                                        .5
                                    ],
                                    [
                                        13,
                                        1
                                    ],
                                    [
                                        14,
                                        4
                                    ],
                                    [
                                        20,
                                        15
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-secondary-tertiary-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "!in",
                                "brunnel",
                                "bridge",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "secondary",
                                "tertiary"
                            ]
                        ],
                        layout: {
                            "line-cap": "butt",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-opacity": .5,
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        8,
                                        1.5
                                    ],
                                    [
                                        20,
                                        17
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-primary-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 5,
                        filter: [
                            "all",
                            [
                                "!in",
                                "brunnel",
                                "bridge",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "primary"
                            ]
                        ],
                        layout: {
                            "line-cap": "butt",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-opacity": {
                                stops: [
                                    [
                                        7,
                                        0
                                    ],
                                    [
                                        8,
                                        .6
                                    ]
                                ]
                            },
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        7,
                                        0
                                    ],
                                    [
                                        8,
                                        .6
                                    ],
                                    [
                                        9,
                                        1.5
                                    ],
                                    [
                                        20,
                                        22
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-trunk-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 5,
                        filter: [
                            "all",
                            [
                                "!in",
                                "brunnel",
                                "bridge",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "trunk"
                            ]
                        ],
                        layout: {
                            "line-cap": "butt",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-opacity": {
                                stops: [
                                    [
                                        5,
                                        0
                                    ],
                                    [
                                        6,
                                        .5
                                    ]
                                ]
                            },
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        5,
                                        0
                                    ],
                                    [
                                        6,
                                        .6
                                    ],
                                    [
                                        7,
                                        1.5
                                    ],
                                    [
                                        20,
                                        22
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-motorway-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 4,
                        filter: [
                            "all",
                            [
                                "!in",
                                "brunnel",
                                "bridge",
                                "tunnel"
                            ],
                            [
                                "==",
                                "class",
                                "motorway"
                            ]
                        ],
                        layout: {
                            "line-cap": "butt",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        4,
                                        0
                                    ],
                                    [
                                        5,
                                        .4
                                    ],
                                    [
                                        6,
                                        .6
                                    ],
                                    [
                                        7,
                                        1.5
                                    ],
                                    [
                                        20,
                                        22
                                    ]
                                ]
                            },
                            "line-opacity": {
                                stops: [
                                    [
                                        4,
                                        0
                                    ],
                                    [
                                        5,
                                        .5
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-path",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "!in",
                                    "brunnel",
                                    "bridge",
                                    "tunnel"
                                ],
                                [
                                    "==",
                                    "class",
                                    "path"
                                ]
                            ]
                        ],
                        paint: {
                            "line-color": "#cba",
                            "line-dasharray": [
                                1.5,
                                .75
                            ],
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        15,
                                        1.2
                                    ],
                                    [
                                        20,
                                        4
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-motorway-link",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 12,
                        filter: [
                            "all",
                            [
                                "!in",
                                "brunnel",
                                "bridge",
                                "tunnel"
                            ],
                            [
                                "==",
                                "class",
                                "motorway_link"
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fc8",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        12.5,
                                        0
                                    ],
                                    [
                                        13,
                                        1.5
                                    ],
                                    [
                                        14,
                                        2.5
                                    ],
                                    [
                                        20,
                                        11.5
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-link",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 13,
                        filter: [
                            "all",
                            [
                                "!in",
                                "brunnel",
                                "bridge",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "primary_link",
                                "secondary_link",
                                "tertiary_link",
                                "trunk_link"
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#fea",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        12.5,
                                        0
                                    ],
                                    [
                                        13,
                                        1.5
                                    ],
                                    [
                                        14,
                                        2.5
                                    ],
                                    [
                                        20,
                                        11.5
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-minor",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "!=",
                                    "brunnel",
                                    "tunnel"
                                ],
                                [
                                    "in",
                                    "class",
                                    "minor",
                                    "service",
                                    "track"
                                ]
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fff",
                            "line-opacity": .5,
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        13.5,
                                        0
                                    ],
                                    [
                                        14,
                                        2.5
                                    ],
                                    [
                                        20,
                                        11.5
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "highway-secondary-tertiary",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "!in",
                                "brunnel",
                                "bridge",
                                "tunnel"
                            ],
                            [
                                "in",
                                "class",
                                "secondary",
                                "tertiary"
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#fea",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        6.5,
                                        0
                                    ],
                                    [
                                        8,
                                        .5
                                    ],
                                    [
                                        20,
                                        13
                                    ]
                                ]
                            },
                            "line-opacity": .5
                        }
                    },
                    {
                        id: "highway-primary",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "!in",
                                    "brunnel",
                                    "bridge",
                                    "tunnel"
                                ],
                                [
                                    "in",
                                    "class",
                                    "primary"
                                ]
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#fea",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        8.5,
                                        0
                                    ],
                                    [
                                        9,
                                        .5
                                    ],
                                    [
                                        20,
                                        18
                                    ]
                                ]
                            },
                            "line-opacity": 0
                        }
                    },
                    {
                        id: "highway-trunk",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "!in",
                                    "brunnel",
                                    "bridge",
                                    "tunnel"
                                ],
                                [
                                    "in",
                                    "class",
                                    "trunk"
                                ]
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#fea",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        6.5,
                                        0
                                    ],
                                    [
                                        7,
                                        .5
                                    ],
                                    [
                                        20,
                                        18
                                    ]
                                ]
                            },
                            "line-opacity": .5
                        }
                    },
                    {
                        id: "highway-motorway",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 5,
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "!in",
                                    "brunnel",
                                    "bridge",
                                    "tunnel"
                                ],
                                [
                                    "==",
                                    "class",
                                    "motorway"
                                ]
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round",
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "#fc8",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        6.5,
                                        0
                                    ],
                                    [
                                        7,
                                        .5
                                    ],
                                    [
                                        20,
                                        18
                                    ]
                                ]
                            },
                            "line-opacity": .5
                        }
                    },
                    {
                        id: "railway-transit",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "==",
                                    "class",
                                    "transit"
                                ],
                                [
                                    "!in",
                                    "brunnel",
                                    "tunnel"
                                ]
                            ]
                        ],
                        layout: {
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "hsla(0, 0%, 73%, 0.77)",
                            "line-width": {
                                base: 1.4,
                                stops: [
                                    [
                                        14,
                                        .4
                                    ],
                                    [
                                        20,
                                        1
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "railway-transit-hatching",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "==",
                                    "class",
                                    "transit"
                                ],
                                [
                                    "!in",
                                    "brunnel",
                                    "tunnel"
                                ]
                            ]
                        ],
                        layout: {
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "hsla(0, 0%, 73%, 0.68)",
                            "line-dasharray": [
                                .2,
                                8
                            ],
                            "line-width": {
                                base: 1.4,
                                stops: [
                                    [
                                        14.5,
                                        0
                                    ],
                                    [
                                        15,
                                        2
                                    ],
                                    [
                                        20,
                                        6
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "railway-service",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "==",
                                    "class",
                                    "rail"
                                ],
                                [
                                    "has",
                                    "service"
                                ]
                            ]
                        ],
                        paint: {
                            "line-color": "hsla(0, 0%, 73%, 0.77)",
                            "line-width": {
                                base: 1.4,
                                stops: [
                                    [
                                        14,
                                        .4
                                    ],
                                    [
                                        20,
                                        1
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "railway-service-hatching",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "==",
                                    "class",
                                    "rail"
                                ],
                                [
                                    "has",
                                    "service"
                                ]
                            ]
                        ],
                        layout: {
                            visibility: "visible"
                        },
                        paint: {
                            "line-color": "hsla(0, 0%, 73%, 0.68)",
                            "line-dasharray": [
                                .2,
                                8
                            ],
                            "line-width": {
                                base: 1.4,
                                stops: [
                                    [
                                        14.5,
                                        0
                                    ],
                                    [
                                        15,
                                        2
                                    ],
                                    [
                                        20,
                                        6
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "railway",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "!has",
                                    "service"
                                ],
                                [
                                    "!in",
                                    "brunnel",
                                    "bridge",
                                    "tunnel"
                                ],
                                [
                                    "==",
                                    "class",
                                    "rail"
                                ]
                            ]
                        ],
                        paint: {
                            "line-color": "#bbb",
                            "line-width": {
                                base: 1.4,
                                stops: [
                                    [
                                        14,
                                        .4
                                    ],
                                    [
                                        15,
                                        .75
                                    ],
                                    [
                                        20,
                                        2
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "railway-hatching",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849345966.4436"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "!has",
                                    "service"
                                ],
                                [
                                    "!in",
                                    "brunnel",
                                    "bridge",
                                    "tunnel"
                                ],
                                [
                                    "==",
                                    "class",
                                    "rail"
                                ]
                            ]
                        ],
                        paint: {
                            "line-color": "#bbb",
                            "line-dasharray": [
                                .2,
                                8
                            ],
                            "line-width": {
                                base: 1.4,
                                stops: [
                                    [
                                        14.5,
                                        0
                                    ],
                                    [
                                        15,
                                        3
                                    ],
                                    [
                                        20,
                                        8
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-motorway-link-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "==",
                                "class",
                                "motorway_link"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-opacity": 1,
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        12,
                                        1
                                    ],
                                    [
                                        13,
                                        3
                                    ],
                                    [
                                        14,
                                        4
                                    ],
                                    [
                                        20,
                                        15
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-link-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "in",
                                "class",
                                "primary_link",
                                "secondary_link",
                                "tertiary_link",
                                "trunk_link"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-opacity": 1,
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        12,
                                        1
                                    ],
                                    [
                                        13,
                                        3
                                    ],
                                    [
                                        14,
                                        4
                                    ],
                                    [
                                        20,
                                        15
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-secondary-tertiary-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "in",
                                "class",
                                "secondary",
                                "tertiary"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-opacity": 1,
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        8,
                                        1.5
                                    ],
                                    [
                                        20,
                                        28
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-trunk-primary-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "in",
                                "class",
                                "primary",
                                "trunk"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "hsl(28, 76%, 67%)",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        5,
                                        .4
                                    ],
                                    [
                                        6,
                                        .6
                                    ],
                                    [
                                        7,
                                        1.5
                                    ],
                                    [
                                        20,
                                        26
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-motorway-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "==",
                                "class",
                                "motorway"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#e9ac77",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        5,
                                        .4
                                    ],
                                    [
                                        6,
                                        .6
                                    ],
                                    [
                                        7,
                                        1.5
                                    ],
                                    [
                                        20,
                                        22
                                    ]
                                ]
                            },
                            "line-opacity": .5
                        }
                    },
                    {
                        id: "bridge-path-casing",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "==",
                                    "brunnel",
                                    "bridge"
                                ],
                                [
                                    "==",
                                    "class",
                                    "path"
                                ]
                            ]
                        ],
                        paint: {
                            "line-color": "#f8f4f0",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        15,
                                        1.2
                                    ],
                                    [
                                        20,
                                        18
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-path",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "all",
                                [
                                    "==",
                                    "brunnel",
                                    "bridge"
                                ],
                                [
                                    "==",
                                    "class",
                                    "path"
                                ]
                            ]
                        ],
                        paint: {
                            "line-color": "#cba",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        15,
                                        1.2
                                    ],
                                    [
                                        20,
                                        4
                                    ]
                                ]
                            },
                            "line-dasharray": [
                                1.5,
                                .75
                            ]
                        }
                    },
                    {
                        id: "bridge-motorway-link",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "==",
                                "class",
                                "motorway_link"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fc8",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        12.5,
                                        0
                                    ],
                                    [
                                        13,
                                        1.5
                                    ],
                                    [
                                        14,
                                        2.5
                                    ],
                                    [
                                        20,
                                        11.5
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-link",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "in",
                                "class",
                                "primary_link",
                                "secondary_link",
                                "tertiary_link",
                                "trunk_link"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fea",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        12.5,
                                        0
                                    ],
                                    [
                                        13,
                                        1.5
                                    ],
                                    [
                                        14,
                                        2.5
                                    ],
                                    [
                                        20,
                                        11.5
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-secondary-tertiary",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "in",
                                "class",
                                "secondary",
                                "tertiary"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fea",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        6.5,
                                        0
                                    ],
                                    [
                                        7,
                                        .5
                                    ],
                                    [
                                        20,
                                        20
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-trunk-primary",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "in",
                                "class",
                                "primary",
                                "trunk"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fea",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        6.5,
                                        0
                                    ],
                                    [
                                        7,
                                        .5
                                    ],
                                    [
                                        20,
                                        18
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-motorway",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "==",
                                "class",
                                "motorway"
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#fc8",
                            "line-width": {
                                base: 1.2,
                                stops: [
                                    [
                                        6.5,
                                        0
                                    ],
                                    [
                                        7,
                                        .5
                                    ],
                                    [
                                        20,
                                        18
                                    ]
                                ]
                            },
                            "line-opacity": .5
                        }
                    },
                    {
                        id: "bridge-railway",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "==",
                                "class",
                                "rail"
                            ]
                        ],
                        paint: {
                            "line-color": "#bbb",
                            "line-width": {
                                base: 1.4,
                                stops: [
                                    [
                                        14,
                                        .4
                                    ],
                                    [
                                        15,
                                        .75
                                    ],
                                    [
                                        20,
                                        2
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "bridge-railway-hatching",
                        type: "line",
                        metadata: {
                            "mapbox:group": "1444849334699.1902"
                        },
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        filter: [
                            "all",
                            [
                                "==",
                                "brunnel",
                                "bridge"
                            ],
                            [
                                "==",
                                "class",
                                "rail"
                            ]
                        ],
                        paint: {
                            "line-color": "#bbb",
                            "line-dasharray": [
                                .2,
                                8
                            ],
                            "line-width": {
                                base: 1.4,
                                stops: [
                                    [
                                        14.5,
                                        0
                                    ],
                                    [
                                        15,
                                        3
                                    ],
                                    [
                                        20,
                                        8
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "cablecar",
                        type: "line",
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 13,
                        filter: [
                            "==",
                            "class",
                            "cable_car"
                        ],
                        layout: {
                            visibility: "visible",
                            "line-cap": "round"
                        },
                        paint: {
                            "line-color": "hsl(0, 0%, 70%)",
                            "line-width": {
                                base: 1,
                                stops: [
                                    [
                                        11,
                                        1
                                    ],
                                    [
                                        19,
                                        2.5
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "cablecar-dash",
                        type: "line",
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 13,
                        filter: [
                            "==",
                            "class",
                            "cable_car"
                        ],
                        layout: {
                            visibility: "visible",
                            "line-cap": "round"
                        },
                        paint: {
                            "line-color": "hsl(0, 0%, 70%)",
                            "line-width": {
                                base: 1,
                                stops: [
                                    [
                                        11,
                                        3
                                    ],
                                    [
                                        19,
                                        5.5
                                    ]
                                ]
                            },
                            "line-dasharray": [
                                2,
                                3
                            ]
                        }
                    },
                    {
                        id: "boundary-land-level-4",
                        type: "line",
                        source: "openmaptiles",
                        "source-layer": "boundary",
                        filter: [
                            "all",
                            [
                                ">=",
                                "admin_level",
                                4
                            ],
                            [
                                "<=",
                                "admin_level",
                                8
                            ],
                            [
                                "!=",
                                "maritime",
                                1
                            ]
                        ],
                        layout: {
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "#9e9cab",
                            "line-dasharray": [
                                3,
                                1,
                                1,
                                1
                            ],
                            "line-width": {
                                base: 1.4,
                                stops: [
                                    [
                                        4,
                                        .4
                                    ],
                                    [
                                        5,
                                        1
                                    ],
                                    [
                                        12,
                                        3
                                    ]
                                ]
                            },
                            "line-opacity": .6
                        }
                    },
                    {
                        id: "boundary-land-level-2",
                        type: "line",
                        source: "openmaptiles",
                        "source-layer": "boundary",
                        filter: [
                            "all",
                            [
                                "==",
                                "admin_level",
                                2
                            ],
                            [
                                "!=",
                                "maritime",
                                1
                            ],
                            [
                                "!=",
                                "disputed",
                                1
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "hsl(248, 7%, 66%)",
                            "line-width": {
                                base: 1,
                                stops: [
                                    [
                                        0,
                                        .6
                                    ],
                                    [
                                        4,
                                        1.4
                                    ],
                                    [
                                        5,
                                        2
                                    ],
                                    [
                                        12,
                                        2
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "boundary-land-disputed",
                        type: "line",
                        source: "openmaptiles",
                        "source-layer": "boundary",
                        filter: [
                            "all",
                            [
                                "!=",
                                "maritime",
                                1
                            ],
                            [
                                "==",
                                "disputed",
                                1
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "hsl(248, 7%, 70%)",
                            "line-dasharray": [
                                1,
                                3
                            ],
                            "line-width": {
                                base: 1,
                                stops: [
                                    [
                                        0,
                                        .6
                                    ],
                                    [
                                        4,
                                        1.4
                                    ],
                                    [
                                        5,
                                        2
                                    ],
                                    [
                                        12,
                                        8
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "boundary-water",
                        type: "line",
                        source: "openmaptiles",
                        "source-layer": "boundary",
                        filter: [
                            "all",
                            [
                                "in",
                                "admin_level",
                                2,
                                4
                            ],
                            [
                                "==",
                                "maritime",
                                1
                            ]
                        ],
                        layout: {
                            "line-cap": "round",
                            "line-join": "round"
                        },
                        paint: {
                            "line-color": "rgba(154, 189, 214, 1)",
                            "line-width": {
                                base: 1,
                                stops: [
                                    [
                                        0,
                                        .6
                                    ],
                                    [
                                        4,
                                        1
                                    ],
                                    [
                                        5,
                                        1
                                    ],
                                    [
                                        12,
                                        1
                                    ]
                                ]
                            },
                            "line-opacity": {
                                stops: [
                                    [
                                        6,
                                        0
                                    ],
                                    [
                                        10,
                                        0
                                    ]
                                ]
                            }
                        }
                    },
                    {
                        id: "waterway-name",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "waterway",
                        minzoom: 13,
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "has",
                                "name"
                            ]
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Italic"
                            ],
                            "text-size": 14,
                            "text-field": "{name:latin} {name:nonlatin}",
                            "text-max-width": 5,
                            "text-rotation-alignment": "map",
                            "symbol-placement": "line",
                            "text-letter-spacing": .2,
                            "symbol-spacing": 350
                        },
                        paint: {
                            "text-color": "#74aee9",
                            "text-halo-width": 1.5,
                            "text-halo-color": "rgba(255,255,255,0.7)"
                        }
                    },
                    {
                        id: "water-name-lakeline",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "water_name",
                        filter: [
                            "==",
                            "$type",
                            "LineString"
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Italic"
                            ],
                            "text-size": 14,
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-max-width": 5,
                            "text-rotation-alignment": "map",
                            "symbol-placement": "line",
                            "symbol-spacing": 350,
                            "text-letter-spacing": .2
                        },
                        paint: {
                            "text-color": "#74aee9",
                            "text-halo-width": 1.5,
                            "text-halo-color": "rgba(255,255,255,0.7)"
                        }
                    },
                    {
                        id: "water-name-ocean",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "water_name",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "Point"
                            ],
                            [
                                "==",
                                "class",
                                "ocean"
                            ]
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Italic"
                            ],
                            "text-size": 14,
                            "text-field": "{name:latin}",
                            "text-max-width": 5,
                            "text-rotation-alignment": "map",
                            "symbol-placement": "point",
                            "symbol-spacing": 350,
                            "text-letter-spacing": .2
                        },
                        paint: {
                            "text-color": "#74aee9",
                            "text-halo-width": 1.5,
                            "text-halo-color": "rgba(255,255,255,0.7)"
                        }
                    },
                    {
                        id: "water-name-other",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "water_name",
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "Point"
                            ],
                            [
                                "!in",
                                "class",
                                "ocean"
                            ]
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Italic"
                            ],
                            "text-size": {
                                stops: [
                                    [
                                        0,
                                        10
                                    ],
                                    [
                                        6,
                                        14
                                    ]
                                ]
                            },
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-max-width": 5,
                            "text-rotation-alignment": "map",
                            "symbol-placement": "point",
                            "symbol-spacing": 350,
                            "text-letter-spacing": .2,
                            visibility: "visible"
                        },
                        paint: {
                            "text-color": "#74aee9",
                            "text-halo-width": 1.5,
                            "text-halo-color": "rgba(255,255,255,0.7)"
                        }
                    },
                    {
                        id: "poi-level-3",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "poi",
                        minzoom: 16,
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "Point"
                            ],
                            [
                                ">=",
                                "rank",
                                25
                            ]
                        ],
                        layout: {
                            "text-padding": 2,
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-anchor": "top",
                            "icon-image": "{class}_11",
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-offset": [
                                0,
                                .6
                            ],
                            "text-size": 12,
                            "text-max-width": 9
                        },
                        paint: {
                            "text-halo-blur": .5,
                            "text-color": "#666",
                            "text-halo-width": 1,
                            "text-halo-color": "#ffffff"
                        }
                    },
                    {
                        id: "poi-level-2",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "poi",
                        minzoom: 15,
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "Point"
                            ],
                            [
                                "<=",
                                "rank",
                                24
                            ],
                            [
                                ">=",
                                "rank",
                                15
                            ]
                        ],
                        layout: {
                            "text-padding": 2,
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-anchor": "top",
                            "icon-image": "{class}_11",
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-offset": [
                                0,
                                .6
                            ],
                            "text-size": 12,
                            "text-max-width": 9
                        },
                        paint: {
                            "text-halo-blur": .5,
                            "text-color": "#666",
                            "text-halo-width": 1,
                            "text-halo-color": "#ffffff"
                        }
                    },
                    {
                        id: "poi-level-1",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "poi",
                        minzoom: 14,
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "Point"
                            ],
                            [
                                "<=",
                                "rank",
                                14
                            ],
                            [
                                "has",
                                "name"
                            ]
                        ],
                        layout: {
                            "text-padding": 2,
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-anchor": "top",
                            "icon-image": "{class}_11",
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-offset": [
                                0,
                                .6
                            ],
                            "text-size": 11,
                            "text-max-width": 9
                        },
                        paint: {
                            "text-halo-blur": .5,
                            "text-color": "rgba(191, 228, 172, 1)",
                            "text-halo-width": 1,
                            "text-halo-color": "rgba(30, 29, 29, 1)"
                        }
                    },
                    {
                        id: "poi-railway",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "poi",
                        minzoom: 13,
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "Point"
                            ],
                            [
                                "has",
                                "name"
                            ],
                            [
                                "==",
                                "class",
                                "railway"
                            ],
                            [
                                "==",
                                "subclass",
                                "station"
                            ]
                        ],
                        layout: {
                            "text-padding": 2,
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-anchor": "top",
                            "icon-image": "{class}_11",
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-offset": [
                                0,
                                .6
                            ],
                            "text-size": 12,
                            "text-max-width": 9,
                            "icon-optional": !1,
                            "icon-ignore-placement": !1,
                            "icon-allow-overlap": !1,
                            "text-ignore-placement": !1,
                            "text-allow-overlap": !1,
                            "text-optional": !0
                        },
                        paint: {
                            "text-halo-blur": .5,
                            "text-color": "#666",
                            "text-halo-width": 1,
                            "text-halo-color": "#ffffff"
                        }
                    },
                    {
                        id: "road_oneway",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 15,
                        filter: [
                            "all",
                            [
                                "==",
                                "oneway",
                                1
                            ],
                            [
                                "in",
                                "class",
                                "motorway",
                                "trunk",
                                "primary",
                                "secondary",
                                "tertiary",
                                "minor",
                                "service"
                            ]
                        ],
                        layout: {
                            "symbol-placement": "line",
                            "icon-image": "oneway",
                            "symbol-spacing": 75,
                            "icon-padding": 2,
                            "icon-rotation-alignment": "map",
                            "icon-rotate": 90,
                            "icon-size": {
                                stops: [
                                    [
                                        15,
                                        .5
                                    ],
                                    [
                                        19,
                                        1
                                    ]
                                ]
                            }
                        },
                        paint: {
                            "icon-opacity": .5
                        }
                    },
                    {
                        id: "road_oneway_opposite",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "transportation",
                        minzoom: 15,
                        filter: [
                            "all",
                            [
                                "==",
                                "oneway",
                                -1
                            ],
                            [
                                "in",
                                "class",
                                "motorway",
                                "trunk",
                                "primary",
                                "secondary",
                                "tertiary",
                                "minor",
                                "service"
                            ]
                        ],
                        layout: {
                            "symbol-placement": "line",
                            "icon-image": "oneway",
                            "symbol-spacing": 75,
                            "icon-padding": 2,
                            "icon-rotation-alignment": "map",
                            "icon-rotate": -90,
                            "icon-size": {
                                stops: [
                                    [
                                        15,
                                        .5
                                    ],
                                    [
                                        19,
                                        1
                                    ]
                                ]
                            }
                        },
                        paint: {
                            "icon-opacity": .5
                        }
                    },
                    {
                        id: "highway-name-path",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "transportation_name",
                        minzoom: 15.5,
                        filter: [
                            "==",
                            "class",
                            "path"
                        ],
                        layout: {
                            "text-size": {
                                base: 1,
                                stops: [
                                    [
                                        13,
                                        12
                                    ],
                                    [
                                        14,
                                        13
                                    ]
                                ]
                            },
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-field": "{name:latin} {name:nonlatin}",
                            "symbol-placement": "line",
                            "text-rotation-alignment": "map"
                        },
                        paint: {
                            "text-halo-color": "#f8f4f0",
                            "text-color": "hsl(30, 23%, 62%)",
                            "text-halo-width": .5
                        }
                    },
                    {
                        id: "highway-name-minor",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "transportation_name",
                        minzoom: 15,
                        filter: [
                            "all",
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "in",
                                "class",
                                "minor",
                                "service",
                                "track"
                            ]
                        ],
                        layout: {
                            "text-size": {
                                base: 1,
                                stops: [
                                    [
                                        13,
                                        12
                                    ],
                                    [
                                        14,
                                        13
                                    ]
                                ]
                            },
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-field": "{name:latin} {name:nonlatin}",
                            "symbol-placement": "line",
                            "text-rotation-alignment": "map"
                        },
                        paint: {
                            "text-halo-blur": .5,
                            "text-color": "#765",
                            "text-halo-width": 1
                        }
                    },
                    {
                        id: "highway-name-major",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "transportation_name",
                        minzoom: 12.2,
                        filter: [
                            "in",
                            "class",
                            "primary",
                            "secondary",
                            "tertiary",
                            "trunk"
                        ],
                        layout: {
                            "text-size": {
                                base: 1,
                                stops: [
                                    [
                                        13,
                                        12
                                    ],
                                    [
                                        14,
                                        13
                                    ]
                                ]
                            },
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-field": "{name:latin} {name:nonlatin}",
                            "symbol-placement": "line",
                            "text-rotation-alignment": "map"
                        },
                        paint: {
                            "text-halo-blur": .5,
                            "text-color": "#765",
                            "text-halo-width": 1
                        }
                    },
                    {
                        id: "highway-shield",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "transportation_name",
                        minzoom: 8,
                        filter: [
                            "all",
                            [
                                "<=",
                                "ref_length",
                                6
                            ],
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "!in",
                                "network",
                                "us-interstate",
                                "us-highway",
                                "us-state"
                            ]
                        ],
                        layout: {
                            "text-size": 10,
                            "icon-image": "road_{ref_length}",
                            "icon-rotation-alignment": "viewport",
                            "symbol-spacing": 200,
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "symbol-placement": {
                                base: 1,
                                stops: [
                                    [
                                        10,
                                        "point"
                                    ],
                                    [
                                        11,
                                        "line"
                                    ]
                                ]
                            },
                            "text-rotation-alignment": "viewport",
                            "icon-size": 1,
                            "text-field": "{ref}"
                        },
                        paint: {
                            "text-opacity": 1,
                            "text-color": "rgba(20, 19, 19, 1)",
                            "text-halo-color": "rgba(230, 221, 221, 0)",
                            "text-halo-width": 2,
                            "icon-color": "rgba(183, 18, 18, 1)",
                            "icon-opacity": .3,
                            "icon-halo-color": "rgba(183, 55, 55, 0)"
                        }
                    },
                    {
                        id: "highway-shield-us-interstate",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "transportation_name",
                        minzoom: 7,
                        filter: [
                            "all",
                            [
                                "<=",
                                "ref_length",
                                6
                            ],
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "in",
                                "network",
                                "us-interstate"
                            ]
                        ],
                        layout: {
                            "text-size": 10,
                            "icon-image": "{network}_{ref_length}",
                            "icon-rotation-alignment": "viewport",
                            "symbol-spacing": 200,
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "symbol-placement": {
                                base: 1,
                                stops: [
                                    [
                                        7,
                                        "point"
                                    ],
                                    [
                                        7,
                                        "line"
                                    ],
                                    [
                                        8,
                                        "line"
                                    ]
                                ]
                            },
                            "text-rotation-alignment": "viewport",
                            "icon-size": 1,
                            "text-field": "{ref}"
                        },
                        paint: {
                            "text-color": "rgba(0, 0, 0, 1)"
                        }
                    },
                    {
                        id: "highway-shield-us-other",
                        type: "symbol",
                        source: "openmaptiles",
                        "source-layer": "transportation_name",
                        minzoom: 9,
                        filter: [
                            "all",
                            [
                                "<=",
                                "ref_length",
                                6
                            ],
                            [
                                "==",
                                "$type",
                                "LineString"
                            ],
                            [
                                "in",
                                "network",
                                "us-highway",
                                "us-state"
                            ]
                        ],
                        layout: {
                            "text-size": 10,
                            "icon-image": "{network}_{ref_length}",
                            "icon-rotation-alignment": "viewport",
                            "symbol-spacing": 200,
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "symbol-placement": {
                                base: 1,
                                stops: [
                                    [
                                        10,
                                        "point"
                                    ],
                                    [
                                        11,
                                        "line"
                                    ]
                                ]
                            },
                            "text-rotation-alignment": "viewport",
                            "icon-size": 1,
                            "text-field": "{ref}"
                        },
                        paint: {
                            "text-color": "rgba(0, 0, 0, 1)"
                        }
                    },
                    {
                        id: "place-other",
                        type: "symbol",
                        metadata: {
                            "mapbox:group": "1444849242106.713"
                        },
                        source: "openmaptiles",
                        "source-layer": "place",
                        minzoom: 12,
                        filter: [
                            "!in",
                            "class",
                            "city",
                            "town",
                            "village",
                            "country",
                            "continent"
                        ],
                        layout: {
                            "text-letter-spacing": .1,
                            "text-size": {
                                base: 1.2,
                                stops: [
                                    [
                                        12,
                                        10
                                    ],
                                    [
                                        15,
                                        14
                                    ]
                                ]
                            },
                            "text-font": [
                                "Noto Sans Bold"
                            ],
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-transform": "uppercase",
                            "text-max-width": 9,
                            visibility: "visible"
                        },
                        paint: {
                            "text-color": "rgba(255,255,255,1)",
                            "text-halo-width": 1.2,
                            "text-halo-color": "rgba(57, 28, 28, 1)"
                        }
                    },
                    {
                        id: "place-village",
                        type: "symbol",
                        metadata: {
                            "mapbox:group": "1444849242106.713"
                        },
                        source: "openmaptiles",
                        "source-layer": "place",
                        minzoom: 10,
                        filter: [
                            "==",
                            "class",
                            "village"
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-size": {
                                base: 1.2,
                                stops: [
                                    [
                                        10,
                                        12
                                    ],
                                    [
                                        15,
                                        16
                                    ]
                                ]
                            },
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-max-width": 8,
                            visibility: "visible"
                        },
                        paint: {
                            "text-color": "rgba(255, 255, 255, 1)",
                            "text-halo-width": 1.2,
                            "text-halo-color": "rgba(10, 9, 9, 0.8)"
                        }
                    },
                    {
                        id: "place-town",
                        type: "symbol",
                        metadata: {
                            "mapbox:group": "1444849242106.713"
                        },
                        source: "openmaptiles",
                        "source-layer": "place",
                        filter: [
                            "==",
                            "class",
                            "town"
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-size": {
                                base: 1.2,
                                stops: [
                                    [
                                        10,
                                        14
                                    ],
                                    [
                                        15,
                                        24
                                    ]
                                ]
                            },
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-max-width": 8,
                            visibility: "visible"
                        },
                        paint: {
                            "text-color": "rgba(255, 255, 255, 1)",
                            "text-halo-width": 1.2,
                            "text-halo-color": "rgba(22, 22, 22, 0.8)"
                        }
                    },
                    {
                        id: "place-city",
                        type: "symbol",
                        metadata: {
                            "mapbox:group": "1444849242106.713"
                        },
                        source: "openmaptiles",
                        "source-layer": "place",
                        filter: [
                            "all",
                            [
                                "!=",
                                "capital",
                                2
                            ],
                            [
                                "==",
                                "class",
                                "city"
                            ]
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-size": {
                                base: 1.2,
                                stops: [
                                    [
                                        7,
                                        14
                                    ],
                                    [
                                        11,
                                        24
                                    ]
                                ]
                            },
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-max-width": 8,
                            visibility: "visible"
                        },
                        paint: {
                            "text-color": "rgba(0, 0, 0, 1)",
                            "text-halo-width": 1.2,
                            "text-halo-color": "rgba(255,255,255,0.8)"
                        }
                    },
                    {
                        id: "place-city-capital",
                        type: "symbol",
                        metadata: {
                            "mapbox:group": "1444849242106.713"
                        },
                        source: "openmaptiles",
                        "source-layer": "place",
                        filter: [
                            "all",
                            [
                                "==",
                                "capital",
                                2
                            ],
                            [
                                "==",
                                "class",
                                "city"
                            ]
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Regular"
                            ],
                            "text-size": {
                                base: 1.2,
                                stops: [
                                    [
                                        7,
                                        14
                                    ],
                                    [
                                        11,
                                        24
                                    ]
                                ]
                            },
                            "text-field": `{name:latin}
{name:nonlatin}`,
                            "text-max-width": 8,
                            "icon-image": "star_11",
                            "text-offset": [
                                .4,
                                0
                            ],
                            "icon-size": .8,
                            "text-anchor": "left",
                            visibility: "visible"
                        },
                        paint: {
                            "text-color": "#333",
                            "text-halo-width": 1.2,
                            "text-halo-color": "rgba(255,255,255,0.8)"
                        }
                    },
                    {
                        id: "place-country-other",
                        type: "symbol",
                        metadata: {
                            "mapbox:group": "1444849242106.713"
                        },
                        source: "openmaptiles",
                        "source-layer": "place",
                        filter: [
                            "all",
                            [
                                "==",
                                "class",
                                "country"
                            ],
                            [
                                ">=",
                                "rank",
                                3
                            ],
                            [
                                "!has",
                                "iso_a2"
                            ]
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Italic"
                            ],
                            "text-field": "{name:latin}",
                            "text-size": {
                                stops: [
                                    [
                                        3,
                                        11
                                    ],
                                    [
                                        7,
                                        17
                                    ]
                                ]
                            },
                            "text-transform": "uppercase",
                            "text-max-width": 6.25,
                            visibility: "visible"
                        },
                        paint: {
                            "text-halo-blur": 1,
                            "text-color": "#334",
                            "text-halo-width": 2,
                            "text-halo-color": "rgba(255,255,255,0.8)"
                        }
                    },
                    {
                        id: "place-country-3",
                        type: "symbol",
                        metadata: {
                            "mapbox:group": "1444849242106.713"
                        },
                        source: "openmaptiles",
                        "source-layer": "place",
                        filter: [
                            "all",
                            [
                                "==",
                                "class",
                                "country"
                            ],
                            [
                                ">=",
                                "rank",
                                3
                            ],
                            [
                                "has",
                                "iso_a2"
                            ]
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Bold"
                            ],
                            "text-field": "{name:latin}",
                            "text-size": {
                                stops: [
                                    [
                                        3,
                                        11
                                    ],
                                    [
                                        7,
                                        17
                                    ]
                                ]
                            },
                            "text-transform": "uppercase",
                            "text-max-width": 6.25,
                            visibility: "visible"
                        },
                        paint: {
                            "text-halo-blur": 1,
                            "text-color": "#334",
                            "text-halo-width": 2,
                            "text-halo-color": "rgba(255,255,255,0.8)"
                        }
                    },
                    {
                        id: "place-country-2",
                        type: "symbol",
                        metadata: {
                            "mapbox:group": "1444849242106.713"
                        },
                        source: "openmaptiles",
                        "source-layer": "place",
                        filter: [
                            "all",
                            [
                                "==",
                                "class",
                                "country"
                            ],
                            [
                                "==",
                                "rank",
                                2
                            ],
                            [
                                "has",
                                "iso_a2"
                            ]
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Bold"
                            ],
                            "text-field": "{name:latin}",
                            "text-size": {
                                stops: [
                                    [
                                        2,
                                        11
                                    ],
                                    [
                                        5,
                                        17
                                    ]
                                ]
                            },
                            "text-transform": "uppercase",
                            "text-max-width": 6.25,
                            visibility: "visible"
                        },
                        paint: {
                            "text-halo-blur": 1,
                            "text-color": "#334",
                            "text-halo-width": 2,
                            "text-halo-color": "rgba(255,255,255,0.8)"
                        }
                    },
                    {
                        id: "place-country-1",
                        type: "symbol",
                        metadata: {
                            "mapbox:group": "1444849242106.713"
                        },
                        source: "openmaptiles",
                        "source-layer": "place",
                        filter: [
                            "all",
                            [
                                "==",
                                "class",
                                "country"
                            ],
                            [
                                "==",
                                "rank",
                                1
                            ],
                            [
                                "has",
                                "iso_a2"
                            ]
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Bold"
                            ],
                            "text-field": "{name:latin}",
                            "text-size": {
                                stops: [
                                    [
                                        1,
                                        11
                                    ],
                                    [
                                        4,
                                        17
                                    ]
                                ]
                            },
                            "text-transform": "uppercase",
                            "text-max-width": 6.25,
                            visibility: "visible"
                        },
                        paint: {
                            "text-halo-blur": 1,
                            "text-color": "#334",
                            "text-halo-width": 2,
                            "text-halo-color": "rgba(255,255,255,0.8)"
                        }
                    },
                    {
                        id: "place-continent",
                        type: "symbol",
                        metadata: {
                            "mapbox:group": "1444849242106.713"
                        },
                        source: "openmaptiles",
                        "source-layer": "place",
                        maxzoom: 1,
                        filter: [
                            "==",
                            "class",
                            "continent"
                        ],
                        layout: {
                            "text-font": [
                                "Noto Sans Bold"
                            ],
                            "text-field": "{name:latin}",
                            "text-size": 14,
                            "text-max-width": 6.25,
                            "text-transform": "uppercase",
                            visibility: "visible"
                        },
                        paint: {
                            "text-halo-blur": 1,
                            "text-color": "#334",
                            "text-halo-width": 2,
                            "text-halo-color": "rgba(255,255,255,0.8)"
                        }
                    }
                ],
                id: "qebnlkra6"
            };
        });
        var oHe = ye((c1r, aHe)=>{
            aHe.exports = {
                version: 8,
                name: "orto",
                metadata: {},
                center: [
                    1.537786,
                    41.837539
                ],
                zoom: 12,
                bearing: 0,
                pitch: 0,
                light: {
                    anchor: "viewport",
                    color: "white",
                    intensity: .4,
                    position: [
                        1.15,
                        45,
                        30
                    ]
                },
                sources: {
                    ortoEsri: {
                        type: "raster",
                        tiles: [
                            "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                        ],
                        tileSize: 256,
                        maxzoom: 18,
                        attribution: "ESRI &copy; <a href='http://www.esri.com'>ESRI</a>"
                    },
                    ortoInstaMaps: {
                        type: "raster",
                        tiles: [
                            "https://tilemaps.icgc.cat/mapfactory/wmts/orto_8_12/CAT3857/{z}/{x}/{y}.png"
                        ],
                        tileSize: 256,
                        maxzoom: 13
                    },
                    ortoICGC: {
                        type: "raster",
                        tiles: [
                            "https://geoserveis.icgc.cat/icc_mapesmultibase/noutm/wmts/orto/GRID3857/{z}/{x}/{y}.jpeg"
                        ],
                        tileSize: 256,
                        minzoom: 13.1,
                        maxzoom: 20
                    },
                    openmaptiles: {
                        type: "vector",
                        url: "https://geoserveis.icgc.cat/contextmaps/basemap.json"
                    }
                },
                sprite: "https://geoserveis.icgc.cat/contextmaps/sprites/sprite@1",
                glyphs: "https://geoserveis.icgc.cat/contextmaps/glyphs/{fontstack}/{range}.pbf",
                layers: [
                    {
                        id: "background",
                        type: "background",
                        paint: {
                            "background-color": "#F4F9F4"
                        }
                    },
                    {
                        id: "ortoEsri",
                        type: "raster",
                        source: "ortoEsri",
                        maxzoom: 16,
                        layout: {
                            visibility: "visible"
                        }
                    },
                    {
                        id: "ortoICGC",
                        type: "raster",
                        source: "ortoICGC",
                        minzoom: 13.1,
                        maxzoom: 19,
                        layout: {
                            visibility: "visible"
                        }
                    },
                    {
                        id: "ortoInstaMaps",
                        type: "raster",
                        source: "ortoInstaMaps",
                        maxzoom: 13,
                        layout: {
                            visibility: "visible"
                        }
                    }
                ]
            };
        });
        var wx = ye((f1r, fHe)=>{
            "use strict";
            var TGt = Y1(), AGt = nHe(), SGt = oHe(), MGt = '\xA9 <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', sHe = "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json", lHe = "https://basemaps.cartocdn.com/gl/dark-matter-gl-style/style.json", JF = "https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json", EGt = "https://basemaps.cartocdn.com/gl/positron-nolabels-gl-style/style.json", kGt = "https://basemaps.cartocdn.com/gl/dark-matter-nolabels-gl-style/style.json", CGt = "https://basemaps.cartocdn.com/gl/voyager-nolabels-gl-style/style.json", cHe = {
                basic: JF,
                streets: JF,
                outdoors: JF,
                light: sHe,
                dark: lHe,
                satellite: SGt,
                "satellite-streets": AGt,
                "open-street-map": {
                    id: "osm",
                    version: 8,
                    sources: {
                        "plotly-osm-tiles": {
                            type: "raster",
                            attribution: MGt,
                            tiles: [
                                "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                            ],
                            tileSize: 256
                        }
                    },
                    layers: [
                        {
                            id: "plotly-osm-tiles",
                            type: "raster",
                            source: "plotly-osm-tiles",
                            minzoom: 0,
                            maxzoom: 22
                        }
                    ],
                    glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                },
                "white-bg": {
                    id: "white-bg",
                    version: 8,
                    sources: {},
                    layers: [
                        {
                            id: "white-bg",
                            type: "background",
                            paint: {
                                "background-color": "#FFFFFF"
                            },
                            minzoom: 0,
                            maxzoom: 22
                        }
                    ],
                    glyphs: "https://fonts.openmaptiles.org/{fontstack}/{range}.pbf"
                },
                "carto-positron": sHe,
                "carto-darkmatter": lHe,
                "carto-voyager": JF,
                "carto-positron-nolabels": EGt,
                "carto-darkmatter-nolabels": kGt,
                "carto-voyager-nolabels": CGt
            }, uHe = TGt(cHe);
            fHe.exports = {
                styleValueDflt: "basic",
                stylesMap: cHe,
                styleValuesMap: uHe,
                traceLayerPrefix: "plotly-trace-layer-",
                layoutLayerPrefix: "plotly-layout-layer-",
                missingStyleErrorMsg: [
                    "No valid maplibre style found, please set `map.style` to one of:",
                    uHe.join(", "),
                    "or use a tile service."
                ].join(`
`),
                mapOnErrorMsg: "Map error."
            };
        });
        var Ok = ye((h1r, gHe)=>{
            "use strict";
            var hHe = Mr(), dHe = va().defaultLine, LGt = Ju().attributes, PGt = Su(), IGt = Uc().textposition, RGt = Bu().overrideAll, DGt = Vs().templatedArray, vHe = wx(), pHe = PGt({
                noFontVariant: !0,
                noFontShadow: !0,
                noFontLineposition: !0,
                noFontTextcase: !0
            });
            pHe.family.dflt = "Open Sans Regular, Arial Unicode MS Regular";
            var zGt = gHe.exports = RGt({
                _arrayAttrRegexps: [
                    hHe.counterRegex("map", ".layers", !0)
                ],
                domain: LGt({
                    name: "map"
                }),
                style: {
                    valType: "any",
                    values: vHe.styleValuesMap,
                    dflt: vHe.styleValueDflt
                },
                center: {
                    lon: {
                        valType: "number",
                        dflt: 0
                    },
                    lat: {
                        valType: "number",
                        dflt: 0
                    }
                },
                zoom: {
                    valType: "number",
                    dflt: 1
                },
                bearing: {
                    valType: "number",
                    dflt: 0
                },
                pitch: {
                    valType: "number",
                    dflt: 0
                },
                bounds: {
                    west: {
                        valType: "number"
                    },
                    east: {
                        valType: "number"
                    },
                    south: {
                        valType: "number"
                    },
                    north: {
                        valType: "number"
                    }
                },
                layers: DGt("layer", {
                    visible: {
                        valType: "boolean",
                        dflt: !0
                    },
                    sourcetype: {
                        valType: "enumerated",
                        values: [
                            "geojson",
                            "vector",
                            "raster",
                            "image"
                        ],
                        dflt: "geojson"
                    },
                    source: {
                        valType: "any"
                    },
                    sourcelayer: {
                        valType: "string",
                        dflt: ""
                    },
                    sourceattribution: {
                        valType: "string"
                    },
                    type: {
                        valType: "enumerated",
                        values: [
                            "circle",
                            "line",
                            "fill",
                            "symbol",
                            "raster"
                        ],
                        dflt: "circle"
                    },
                    coordinates: {
                        valType: "any"
                    },
                    below: {
                        valType: "string"
                    },
                    color: {
                        valType: "color",
                        dflt: dHe
                    },
                    opacity: {
                        valType: "number",
                        min: 0,
                        max: 1,
                        dflt: 1
                    },
                    minzoom: {
                        valType: "number",
                        min: 0,
                        max: 24,
                        dflt: 0
                    },
                    maxzoom: {
                        valType: "number",
                        min: 0,
                        max: 24,
                        dflt: 24
                    },
                    circle: {
                        radius: {
                            valType: "number",
                            dflt: 15
                        }
                    },
                    line: {
                        width: {
                            valType: "number",
                            dflt: 2
                        },
                        dash: {
                            valType: "data_array"
                        }
                    },
                    fill: {
                        outlinecolor: {
                            valType: "color",
                            dflt: dHe
                        }
                    },
                    symbol: {
                        icon: {
                            valType: "string",
                            dflt: "marker"
                        },
                        iconsize: {
                            valType: "number",
                            dflt: 10
                        },
                        text: {
                            valType: "string",
                            dflt: ""
                        },
                        placement: {
                            valType: "enumerated",
                            values: [
                                "point",
                                "line",
                                "line-center"
                            ],
                            dflt: "point"
                        },
                        textfont: pHe,
                        textposition: hHe.extendFlat({}, IGt, {
                            arrayOk: !1
                        })
                    }
                })
            }, "plot", "from-root");
            zGt.uirevision = {
                valType: "any",
                editType: "none"
            };
        });
        var $F = ye((d1r, _He)=>{
            "use strict";
            var FGt = Wo().hovertemplateAttrs, qGt = Wo().texttemplateAttrs, OGt = Eg(), Bk = H2(), TA = Uc(), mHe = Ok(), BGt = vl(), NGt = Jl(), rw = no().extendFlat, UGt = Bu().overrideAll, VGt = Ok(), yHe = Bk.line, AA = Bk.marker;
            _He.exports = UGt({
                lon: Bk.lon,
                lat: Bk.lat,
                cluster: {
                    enabled: {
                        valType: "boolean"
                    },
                    maxzoom: rw({}, VGt.layers.maxzoom, {}),
                    step: {
                        valType: "number",
                        arrayOk: !0,
                        dflt: -1,
                        min: -1
                    },
                    size: {
                        valType: "number",
                        arrayOk: !0,
                        dflt: 20,
                        min: 0
                    },
                    color: {
                        valType: "color",
                        arrayOk: !0
                    },
                    opacity: rw({}, AA.opacity, {
                        dflt: 1
                    })
                },
                mode: rw({}, TA.mode, {
                    dflt: "markers"
                }),
                text: rw({}, TA.text, {}),
                texttemplate: qGt({
                    editType: "plot"
                }, {
                    keys: [
                        "lat",
                        "lon",
                        "text"
                    ]
                }),
                hovertext: rw({}, TA.hovertext, {}),
                line: {
                    color: yHe.color,
                    width: yHe.width
                },
                connectgaps: TA.connectgaps,
                marker: rw({
                    symbol: {
                        valType: "string",
                        dflt: "circle",
                        arrayOk: !0
                    },
                    angle: {
                        valType: "number",
                        dflt: "auto",
                        arrayOk: !0
                    },
                    allowoverlap: {
                        valType: "boolean",
                        dflt: !1
                    },
                    opacity: AA.opacity,
                    size: AA.size,
                    sizeref: AA.sizeref,
                    sizemin: AA.sizemin,
                    sizemode: AA.sizemode
                }, NGt("marker")),
                fill: Bk.fill,
                fillcolor: OGt(),
                textfont: mHe.layers.symbol.textfont,
                textposition: mHe.layers.symbol.textposition,
                below: {
                    valType: "string"
                },
                selected: {
                    marker: TA.selected.marker
                },
                unselected: {
                    marker: TA.unselected.marker
                },
                hoverinfo: rw({}, BGt.hoverinfo, {
                    flags: [
                        "lon",
                        "lat",
                        "text",
                        "name"
                    ]
                }),
                hovertemplate: FGt()
            }, "calc", "nested");
        });
        var lJ = ye((v1r, xHe)=>{
            "use strict";
            var HGt = [
                "Metropolis Black Italic",
                "Metropolis Black",
                "Metropolis Bold Italic",
                "Metropolis Bold",
                "Metropolis Extra Bold Italic",
                "Metropolis Extra Bold",
                "Metropolis Extra Light Italic",
                "Metropolis Extra Light",
                "Metropolis Light Italic",
                "Metropolis Light",
                "Metropolis Medium Italic",
                "Metropolis Medium",
                "Metropolis Regular Italic",
                "Metropolis Regular",
                "Metropolis Semi Bold Italic",
                "Metropolis Semi Bold",
                "Metropolis Thin Italic",
                "Metropolis Thin",
                "Open Sans Bold Italic",
                "Open Sans Bold",
                "Open Sans Extrabold Italic",
                "Open Sans Extrabold",
                "Open Sans Italic",
                "Open Sans Light Italic",
                "Open Sans Light",
                "Open Sans Regular",
                "Open Sans Semibold Italic",
                "Open Sans Semibold",
                "Klokantech Noto Sans Bold",
                "Klokantech Noto Sans CJK Bold",
                "Klokantech Noto Sans CJK Regular",
                "Klokantech Noto Sans Italic",
                "Klokantech Noto Sans Regular"
            ];
            xHe.exports = {
                isSupportedFont: function(e) {
                    return HGt.indexOf(e) !== -1;
                }
            };
        });
        var THe = ye((p1r, wHe)=>{
            "use strict";
            var Nk = Mr(), uJ = lu(), GGt = $p(), jGt = R0(), WGt = D0(), ZGt = Ig(), bHe = $F(), XGt = lJ().isSupportedFont;
            wHe.exports = function(t, r, n, i) {
                function a(p, E) {
                    return Nk.coerce(t, r, bHe, p, E);
                }
                function o(p, E) {
                    return Nk.coerce2(t, r, bHe, p, E);
                }
                var s = YGt(t, r, a);
                if (!s) {
                    r.visible = !1;
                    return;
                }
                if (a("text"), a("texttemplate"), a("hovertext"), a("hovertemplate"), a("mode"), a("below"), uJ.hasMarkers(r)) {
                    GGt(t, r, n, i, a, {
                        noLine: !0,
                        noAngle: !0
                    }), a("marker.allowoverlap"), a("marker.angle");
                    var l = r.marker;
                    l.symbol !== "circle" && (Nk.isArrayOrTypedArray(l.size) && (l.size = l.size[0]), Nk.isArrayOrTypedArray(l.color) && (l.color = l.color[0]));
                }
                uJ.hasLines(r) && (jGt(t, r, n, i, a, {
                    noDash: !0
                }), a("connectgaps"));
                var u = o("cluster.maxzoom"), c = o("cluster.step"), f = o("cluster.color", r.marker && r.marker.color || n), h = o("cluster.size"), d = o("cluster.opacity"), v = u !== !1 || c !== !1 || f !== !1 || h !== !1 || d !== !1, x = a("cluster.enabled", v);
                if (x || uJ.hasText(r)) {
                    var b = i.font.family;
                    WGt(t, r, i, a, {
                        noSelect: !0,
                        noFontVariant: !0,
                        noFontShadow: !0,
                        noFontLineposition: !0,
                        noFontTextcase: !0,
                        font: {
                            family: XGt(b) ? b : "Open Sans Regular",
                            weight: i.font.weight,
                            style: i.font.style,
                            size: i.font.size,
                            color: i.font.color
                        }
                    });
                }
                a("fill"), r.fill !== "none" && ZGt(t, r, n, a), Nk.coerceSelectionMarkerOpacity(r, a);
            };
            function YGt(e, t, r) {
                var n = r("lon") || [], i = r("lat") || [], a = Math.min(n.length, i.length);
                return t._length = a, a;
            }
        });
        var cJ = ye((g1r, SHe)=>{
            "use strict";
            var AHe = Qa();
            SHe.exports = function(t, r, n) {
                var i = {}, a = n[r.subplot]._subplot, o = a.mockAxis, s = t.lonlat;
                return i.lonLabel = AHe.tickText(o, o.c2l(s[0]), !0).text, i.latLabel = AHe.tickText(o, o.c2l(s[1]), !0).text, i;
            };
        });
        var fJ = ye((m1r, EHe)=>{
            "use strict";
            var MHe = Mr();
            EHe.exports = function(t, r) {
                var n = t.split(" "), i = n[0], a = n[1], o = MHe.isArrayOrTypedArray(r) ? MHe.mean(r) : r, s = .5 + o / 100, l = 1.5 + o / 100, u = [
                    "",
                    ""
                ], c = [
                    0,
                    0
                ];
                switch(i){
                    case "top":
                        u[0] = "top", c[1] = -l;
                        break;
                    case "bottom":
                        u[0] = "bottom", c[1] = l;
                        break;
                }
                switch(a){
                    case "left":
                        u[1] = "right", c[0] = -s;
                        break;
                    case "right":
                        u[1] = "left", c[0] = s;
                        break;
                }
                var f;
                return u[0] && u[1] ? f = u.join("-") : u[0] ? f = u[0] : u[1] ? f = u[1] : f = "center", {
                    anchor: f,
                    offset: c
                };
            };
        });
        var RHe = ye((y1r, IHe)=>{
            "use strict";
            var LHe = uo(), nv = Mr(), KGt = es().BADNUM, e7 = rx(), kHe = Mu(), JGt = ao(), $Gt = S3(), t7 = lu(), QGt = lJ().isSupportedFont, ejt = fJ(), tjt = rp().appendArrayPointValue, rjt = Pl().NEWLINES, ijt = Pl().BR_TAG_ALL;
            IHe.exports = function(t, r) {
                var n = r[0].trace, i = n.visible === !0 && n._length !== 0, a = n.fill !== "none", o = t7.hasLines(n), s = t7.hasMarkers(n), l = t7.hasText(n), u = s && n.marker.symbol === "circle", c = s && n.marker.symbol !== "circle", f = n.cluster && n.cluster.enabled, h = QF("fill"), d = QF("line"), v = QF("circle"), x = QF("symbol"), b = {
                    fill: h,
                    line: d,
                    circle: v,
                    symbol: x
                };
                if (!i) return b;
                var p;
                if ((a || o) && (p = e7.calcTraceToLineCoords(r)), a && (h.geojson = e7.makePolygon(p), h.layout.visibility = "visible", nv.extendFlat(h.paint, {
                    "fill-color": n.fillcolor
                })), o && (d.geojson = e7.makeLine(p), d.layout.visibility = "visible", nv.extendFlat(d.paint, {
                    "line-width": n.line.width,
                    "line-color": n.line.color,
                    "line-opacity": n.opacity
                })), u) {
                    var E = njt(r);
                    v.geojson = E.geojson, v.layout.visibility = "visible", f && (v.filter = [
                        "!",
                        [
                            "has",
                            "point_count"
                        ]
                    ], b.cluster = {
                        type: "circle",
                        filter: [
                            "has",
                            "point_count"
                        ],
                        layout: {
                            visibility: "visible"
                        },
                        paint: {
                            "circle-color": dJ(n.cluster.color, n.cluster.step),
                            "circle-radius": dJ(n.cluster.size, n.cluster.step),
                            "circle-opacity": dJ(n.cluster.opacity, n.cluster.step)
                        }
                    }, b.clusterCount = {
                        type: "symbol",
                        filter: [
                            "has",
                            "point_count"
                        ],
                        paint: {},
                        layout: {
                            "text-field": "{point_count_abbreviated}",
                            "text-font": CHe(n),
                            "text-size": 12
                        }
                    }), nv.extendFlat(v.paint, {
                        "circle-color": E.mcc,
                        "circle-radius": E.mrc,
                        "circle-opacity": E.mo
                    });
                }
                if (u && f && (v.filter = [
                    "!",
                    [
                        "has",
                        "point_count"
                    ]
                ]), (c || l) && (x.geojson = ajt(r, t), nv.extendFlat(x.layout, {
                    visibility: "visible",
                    "icon-image": "{symbol}-15",
                    "text-field": "{text}"
                }), c && (nv.extendFlat(x.layout, {
                    "icon-size": n.marker.size / 10
                }), "angle" in n.marker && n.marker.angle !== "auto" && nv.extendFlat(x.layout, {
                    "icon-rotate": {
                        type: "identity",
                        property: "angle"
                    },
                    "icon-rotation-alignment": "map"
                }), x.layout["icon-allow-overlap"] = n.marker.allowoverlap, nv.extendFlat(x.paint, {
                    "icon-opacity": n.opacity * n.marker.opacity,
                    "icon-color": n.marker.color
                })), l)) {
                    var k = (n.marker || {}).size, A = ejt(n.textposition, k);
                    nv.extendFlat(x.layout, {
                        "text-size": n.textfont.size,
                        "text-anchor": A.anchor,
                        "text-offset": A.offset,
                        "text-font": CHe(n)
                    }), nv.extendFlat(x.paint, {
                        "text-color": n.textfont.color,
                        "text-opacity": n.opacity
                    });
                }
                return b;
            };
            function QF(e) {
                return {
                    type: e,
                    geojson: e7.makeBlank(),
                    layout: {
                        visibility: "none"
                    },
                    filter: null,
                    paint: {}
                };
            }
            function njt(e) {
                var t = e[0].trace, r = t.marker, n = t.selectedpoints, i = nv.isArrayOrTypedArray(r.color), a = nv.isArrayOrTypedArray(r.size), o = nv.isArrayOrTypedArray(r.opacity), s;
                function l(k) {
                    return t.opacity * k;
                }
                function u(k) {
                    return k / 2;
                }
                var c;
                i && (kHe.hasColorscale(t, "marker") ? c = kHe.makeColorScaleFuncFromTrace(r) : c = nv.identity);
                var f;
                a && (f = $Gt(t));
                var h;
                o && (h = function(k) {
                    var A = LHe(k) ? +nv.constrain(k, 0, 1) : 0;
                    return l(A);
                });
                var d = [];
                for(s = 0; s < e.length; s++){
                    var v = e[s], x = v.lonlat;
                    if (!PHe(x)) {
                        var b = {};
                        c && (b.mcc = v.mcc = c(v.mc)), f && (b.mrc = v.mrc = f(v.ms)), h && (b.mo = h(v.mo)), n && (b.selected = v.selected || 0), d.push({
                            type: "Feature",
                            id: s + 1,
                            geometry: {
                                type: "Point",
                                coordinates: x
                            },
                            properties: b
                        });
                    }
                }
                var p;
                if (n) for(p = JGt.makeSelectedPointStyleFns(t), s = 0; s < d.length; s++){
                    var E = d[s].properties;
                    p.selectedOpacityFn && (E.mo = l(p.selectedOpacityFn(E))), p.selectedColorFn && (E.mcc = p.selectedColorFn(E)), p.selectedSizeFn && (E.mrc = p.selectedSizeFn(E));
                }
                return {
                    geojson: {
                        type: "FeatureCollection",
                        features: d
                    },
                    mcc: i || p && p.selectedColorFn ? {
                        type: "identity",
                        property: "mcc"
                    } : r.color,
                    mrc: a || p && p.selectedSizeFn ? {
                        type: "identity",
                        property: "mrc"
                    } : u(r.size),
                    mo: o || p && p.selectedOpacityFn ? {
                        type: "identity",
                        property: "mo"
                    } : l(r.opacity)
                };
            }
            function ajt(e, t) {
                for(var r = t._fullLayout, n = e[0].trace, i = n.marker || {}, a = i.symbol, o = i.angle, s = a !== "circle" ? hJ(a) : r7, l = o !== "auto" ? hJ(o, !0) : r7, u = t7.hasText(n) ? hJ(n.text) : r7, c = [], f = 0; f < e.length; f++){
                    var h = e[f];
                    if (!PHe(h.lonlat)) {
                        var d = n.texttemplate, v;
                        if (d) {
                            var x = Array.isArray(d) ? d[f] || "" : d, b = n._module.formatLabels(h, n, r), p = {};
                            tjt(p, n, h.i);
                            var E = n._meta || {};
                            v = nv.texttemplateString(x, b, r._d3locale, p, h, E);
                        } else v = u(f);
                        v && (v = v.replace(rjt, "").replace(ijt, `
`)), c.push({
                            type: "Feature",
                            geometry: {
                                type: "Point",
                                coordinates: h.lonlat
                            },
                            properties: {
                                symbol: s(f),
                                angle: l(f),
                                text: v
                            }
                        });
                    }
                }
                return {
                    type: "FeatureCollection",
                    features: c
                };
            }
            function hJ(e, t) {
                return nv.isArrayOrTypedArray(e) ? t ? function(r) {
                    return LHe(e[r]) ? +e[r] : 0;
                } : function(r) {
                    return e[r];
                } : e ? function() {
                    return e;
                } : r7;
            }
            function r7() {
                return "";
            }
            function PHe(e) {
                return e[0] === KGt;
            }
            function dJ(e, t) {
                var r;
                if (nv.isArrayOrTypedArray(e) && nv.isArrayOrTypedArray(t)) {
                    r = [
                        "step",
                        [
                            "get",
                            "point_count"
                        ],
                        e[0]
                    ];
                    for(var n = 1; n < e.length; n++)r.push(t[n - 1], e[n]);
                } else r = e;
                return r;
            }
            function CHe(e) {
                var t = e.textfont, r = t.family, n = t.style, i = t.weight, a = r.split(" "), o = a[a.length - 1] === "Italic";
                o && a.pop(), o = o || n === "italic";
                var s = a.join(" ");
                i === "bold" && a.indexOf("Bold") === -1 ? s += " Bold" : i <= 1e3 && (a[0] === "Metropolis" ? (s = "Metropolis", i > 850 ? s += " Black" : i > 750 ? s += " Extra Bold" : i > 650 ? s += " Bold" : i > 550 ? s += " Semi Bold" : i > 450 ? s += " Medium" : i > 350 ? s += " Regular" : i > 250 ? s += " Light" : i > 150 ? s += " Extra Light" : s += " Thin") : a.slice(0, 2).join(" ") === "Open Sans" ? (s = "Open Sans", i > 750 ? s += " Extrabold" : i > 650 ? s += " Bold" : i > 550 ? s += " Semibold" : i > 350 ? s += " Regular" : s += " Light") : a.slice(0, 3).join(" ") === "Klokantech Noto Sans" && (s = "Klokantech Noto Sans", a[3] === "CJK" && (s += " CJK"), s += i > 500 ? " Bold" : " Regular")), o && (s += " Italic"), s === "Open Sans Regular Italic" ? s = "Open Sans Italic" : s === "Open Sans Regular Bold" ? s = "Open Sans Bold" : s === "Open Sans Regular Bold Italic" ? s = "Open Sans Bold Italic" : s === "Klokantech Noto Sans Regular Italic" && (s = "Klokantech Noto Sans Italic"), QGt(s) || (s = r);
                var l = s.split(", ");
                return l;
            }
        });
        var qHe = ye((_1r, FHe)=>{
            "use strict";
            var ojt = Mr(), DHe = RHe(), SA = wx().traceLayerPrefix, ng = {
                cluster: [
                    "cluster",
                    "clusterCount",
                    "circle"
                ],
                nonCluster: [
                    "fill",
                    "line",
                    "circle",
                    "symbol"
                ]
            };
            function zHe(e, t, r, n) {
                this.type = "scattermap", this.subplot = e, this.uid = t, this.clusterEnabled = r, this.isHidden = n, this.sourceIds = {
                    fill: "source-" + t + "-fill",
                    line: "source-" + t + "-line",
                    circle: "source-" + t + "-circle",
                    symbol: "source-" + t + "-symbol",
                    cluster: "source-" + t + "-circle",
                    clusterCount: "source-" + t + "-circle"
                }, this.layerIds = {
                    fill: SA + t + "-fill",
                    line: SA + t + "-line",
                    circle: SA + t + "-circle",
                    symbol: SA + t + "-symbol",
                    cluster: SA + t + "-cluster",
                    clusterCount: SA + t + "-cluster-count"
                }, this.below = null;
            }
            var Uk = zHe.prototype;
            Uk.addSource = function(e, t, r) {
                var n = {
                    type: "geojson",
                    data: t.geojson
                };
                r && r.enabled && ojt.extendFlat(n, {
                    cluster: !0,
                    clusterMaxZoom: r.maxzoom
                });
                var i = this.subplot.map.getSource(this.sourceIds[e]);
                i ? i.setData(t.geojson) : this.subplot.map.addSource(this.sourceIds[e], n);
            };
            Uk.setSourceData = function(e, t) {
                this.subplot.map.getSource(this.sourceIds[e]).setData(t.geojson);
            };
            Uk.addLayer = function(e, t, r) {
                var n = {
                    type: t.type,
                    id: this.layerIds[e],
                    source: this.sourceIds[e],
                    layout: t.layout,
                    paint: t.paint
                };
                t.filter && (n.filter = t.filter);
                for(var i = this.layerIds[e], a, o = this.subplot.getMapLayers(), s = 0; s < o.length; s++)if (o[s].id === i) {
                    a = !0;
                    break;
                }
                a ? (this.subplot.setOptions(i, "setLayoutProperty", n.layout), n.layout.visibility === "visible" && this.subplot.setOptions(i, "setPaintProperty", n.paint)) : this.subplot.addLayer(n, r);
            };
            Uk.update = function(t) {
                var r = t[0].trace, n = this.subplot, i = n.map, a = DHe(n.gd, t), o = n.belowLookup["trace-" + this.uid], s = !!(r.cluster && r.cluster.enabled), l = !!this.clusterEnabled, u = this;
                function c(k) {
                    k || u.addSource("circle", a.circle, r.cluster);
                    for(var A = ng.cluster, L = 0; L < A.length; L++){
                        var _ = A[L], C = a[_];
                        u.addLayer(_, C, o);
                    }
                }
                function f(k) {
                    for(var A = ng.cluster, L = A.length - 1; L >= 0; L--){
                        var _ = A[L];
                        i.removeLayer(u.layerIds[_]);
                    }
                    k || i.removeSource(u.sourceIds.circle);
                }
                function h(k) {
                    for(var A = ng.nonCluster, L = 0; L < A.length; L++){
                        var _ = A[L], C = a[_];
                        k || u.addSource(_, C), u.addLayer(_, C, o);
                    }
                }
                function d(k) {
                    for(var A = ng.nonCluster, L = A.length - 1; L >= 0; L--){
                        var _ = A[L];
                        i.removeLayer(u.layerIds[_]), k || i.removeSource(u.sourceIds[_]);
                    }
                }
                function v(k) {
                    l ? f(k) : d(k);
                }
                function x(k) {
                    s ? c(k) : h(k);
                }
                function b() {
                    for(var k = s ? ng.cluster : ng.nonCluster, A = 0; A < k.length; A++){
                        var L = k[A], _ = a[L];
                        _ && (n.setOptions(u.layerIds[L], "setLayoutProperty", _.layout), _.layout.visibility === "visible" && (L !== "cluster" && u.setSourceData(L, _), n.setOptions(u.layerIds[L], "setPaintProperty", _.paint)));
                    }
                }
                var p = this.isHidden, E = r.visible !== !0;
                E ? p || v() : p ? E || x() : l !== s ? (v(), x()) : (this.below !== o && (v(!0), x(!0)), b()), this.clusterEnabled = s, this.isHidden = E, this.below = o, t[0].trace._glTrace = this;
            };
            Uk.dispose = function() {
                for(var t = this.subplot.map, r = this.clusterEnabled ? ng.cluster : ng.nonCluster, n = r.length - 1; n >= 0; n--){
                    var i = r[n];
                    t.removeLayer(this.layerIds[i]), t.removeSource(this.sourceIds[i]);
                }
            };
            FHe.exports = function(t, r) {
                var n = r[0].trace, i = n.cluster && n.cluster.enabled, a = n.visible !== !0, o = new zHe(t, n.uid, i, a), s = DHe(t.gd, r), l = o.below = t.belowLookup["trace-" + n.uid], u, c, f;
                if (i) for(o.addSource("circle", s.circle, n.cluster), u = 0; u < ng.cluster.length; u++)c = ng.cluster[u], f = s[c], o.addLayer(c, f, l);
                else for(u = 0; u < ng.nonCluster.length; u++)c = ng.nonCluster[u], f = s[c], o.addSource(c, f, n.cluster), o.addLayer(c, f, l);
                return r[0].trace._glTrace = o, o;
            };
        });
        var i7 = ye((x1r, BHe)=>{
            "use strict";
            var sjt = Nc(), vJ = Mr(), ljt = oT(), ujt = vJ.fillText, cjt = es().BADNUM, fjt = wx().traceLayerPrefix;
            function hjt(e, t, r) {
                var n = e.cd, i = n[0].trace, a = e.xa, o = e.ya, s = e.subplot, l = [], u = fjt + i.uid + "-circle", c = i.cluster && i.cluster.enabled;
                if (c) {
                    var f = s.map.queryRenderedFeatures(null, {
                        layers: [
                            u
                        ]
                    });
                    l = f.map(function(M) {
                        return M.id;
                    });
                }
                var h = t >= 0 ? Math.floor((t + 180) / 360) : Math.ceil((t - 180) / 360), d = h * 360, v = t - d;
                function x(M) {
                    var g = M.lonlat;
                    if (g[0] === cjt || c && l.indexOf(M.i + 1) === -1) return 1 / 0;
                    var P = vJ.modHalf(g[0], 360), T = g[1], F = s.project([
                        P,
                        T
                    ]), q = F.x - a.c2p([
                        v,
                        T
                    ]), V = F.y - o.c2p([
                        P,
                        r
                    ]), H = Math.max(3, M.mrc || 0);
                    return Math.max(Math.sqrt(q * q + V * V) - H, 1 - 3 / H);
                }
                if (sjt.getClosest(n, x, e), e.index !== !1) {
                    var b = n[e.index], p = b.lonlat, E = [
                        vJ.modHalf(p[0], 360) + d,
                        p[1]
                    ], k = a.c2p(E), A = o.c2p(E), L = b.mrc || 1;
                    e.x0 = k - L, e.x1 = k + L, e.y0 = A - L, e.y1 = A + L;
                    var _ = {};
                    _[i.subplot] = {
                        _subplot: s
                    };
                    var C = i._module.formatLabels(b, i, _);
                    return e.lonLabel = C.lonLabel, e.latLabel = C.latLabel, e.color = ljt(i, b), e.extraText = OHe(i, b, n[0].t.labels), e.hovertemplate = i.hovertemplate, [
                        e
                    ];
                }
            }
            function OHe(e, t, r) {
                if (e.hovertemplate) return;
                var n = t.hi || e.hoverinfo, i = n.split("+"), a = i.indexOf("all") !== -1, o = i.indexOf("lon") !== -1, s = i.indexOf("lat") !== -1, l = t.lonlat, u = [];
                function c(f) {
                    return f + "\xB0";
                }
                return a || o && s ? u.push("(" + c(l[1]) + ", " + c(l[0]) + ")") : o ? u.push(r.lon + c(l[0])) : s && u.push(r.lat + c(l[1])), (a || i.indexOf("text") !== -1) && ujt(t, e, u), u.join("<br>");
            }
            BHe.exports = {
                hoverPoints: hjt,
                getExtraText: OHe
            };
        });
        var UHe = ye((b1r, NHe)=>{
            "use strict";
            NHe.exports = function(t, r) {
                return t.lon = r.lon, t.lat = r.lat, t;
            };
        });
        var HHe = ye((w1r, VHe)=>{
            "use strict";
            var djt = Mr(), vjt = lu(), pjt = es().BADNUM;
            VHe.exports = function(t, r) {
                var n = t.cd, i = t.xaxis, a = t.yaxis, o = [], s = n[0].trace, l;
                if (!vjt.hasMarkers(s)) return [];
                if (r === !1) for(l = 0; l < n.length; l++)n[l].selected = 0;
                else for(l = 0; l < n.length; l++){
                    var u = n[l], c = u.lonlat;
                    if (c[0] !== pjt) {
                        var f = [
                            djt.modHalf(c[0], 360),
                            c[1]
                        ], h = [
                            i.c2p(f),
                            a.c2p(f)
                        ];
                        r.contains(h, null, l, t) ? (o.push({
                            pointNumber: l,
                            lon: c[0],
                            lat: c[1]
                        }), u.selected = 1) : u.selected = 0;
                    }
                }
                return o;
            };
        });
        var jHe = ye((pJ, gJ)=>{
            (function(e, t) {
                typeof pJ == "object" && typeof gJ != "undefined" ? gJ.exports = t() : (e = typeof globalThis != "undefined" ? globalThis : e || self, e.maplibregl = t());
            })(pJ, function() {
                "use strict";
                var e = {}, t = {};
                function r(i, a, o) {
                    if (t[i] = o, i === "index") {
                        var s = "var sharedModule = {}; (" + t.shared + ")(sharedModule); (" + t.worker + ")(sharedModule);", l = {};
                        return t.shared(l), t.index(e, l), typeof window != "undefined" && e.setWorkerUrl(window.URL.createObjectURL(new Blob([
                            s
                        ], {
                            type: "text/javascript"
                        }))), e;
                    }
                }
                r("shared", [
                    "exports"
                ], function(i) {
                    "use strict";
                    function a(R, S, D, j) {
                        return new (D || (D = Promise))(function(te, ue) {
                            function ve(at) {
                                try {
                                    Ze(j.next(at));
                                } catch (Tt) {
                                    ue(Tt);
                                }
                            }
                            function De(at) {
                                try {
                                    Ze(j.throw(at));
                                } catch (Tt) {
                                    ue(Tt);
                                }
                            }
                            function Ze(at) {
                                var Tt;
                                at.done ? te(at.value) : (Tt = at.value, Tt instanceof D ? Tt : new D(function(Ft) {
                                    Ft(Tt);
                                })).then(ve, De);
                            }
                            Ze((j = j.apply(R, S || [])).next());
                        });
                    }
                    function o(R) {
                        return R && R.__esModule && Object.prototype.hasOwnProperty.call(R, "default") ? R.default : R;
                    }
                    typeof SuppressedError == "function" && SuppressedError;
                    var s = l;
                    function l(R, S) {
                        this.x = R, this.y = S;
                    }
                    l.prototype = {
                        clone: function() {
                            return new l(this.x, this.y);
                        },
                        add: function(R) {
                            return this.clone()._add(R);
                        },
                        sub: function(R) {
                            return this.clone()._sub(R);
                        },
                        multByPoint: function(R) {
                            return this.clone()._multByPoint(R);
                        },
                        divByPoint: function(R) {
                            return this.clone()._divByPoint(R);
                        },
                        mult: function(R) {
                            return this.clone()._mult(R);
                        },
                        div: function(R) {
                            return this.clone()._div(R);
                        },
                        rotate: function(R) {
                            return this.clone()._rotate(R);
                        },
                        rotateAround: function(R, S) {
                            return this.clone()._rotateAround(R, S);
                        },
                        matMult: function(R) {
                            return this.clone()._matMult(R);
                        },
                        unit: function() {
                            return this.clone()._unit();
                        },
                        perp: function() {
                            return this.clone()._perp();
                        },
                        round: function() {
                            return this.clone()._round();
                        },
                        mag: function() {
                            return Math.sqrt(this.x * this.x + this.y * this.y);
                        },
                        equals: function(R) {
                            return this.x === R.x && this.y === R.y;
                        },
                        dist: function(R) {
                            return Math.sqrt(this.distSqr(R));
                        },
                        distSqr: function(R) {
                            var S = R.x - this.x, D = R.y - this.y;
                            return S * S + D * D;
                        },
                        angle: function() {
                            return Math.atan2(this.y, this.x);
                        },
                        angleTo: function(R) {
                            return Math.atan2(this.y - R.y, this.x - R.x);
                        },
                        angleWith: function(R) {
                            return this.angleWithSep(R.x, R.y);
                        },
                        angleWithSep: function(R, S) {
                            return Math.atan2(this.x * S - this.y * R, this.x * R + this.y * S);
                        },
                        _matMult: function(R) {
                            var S = R[2] * this.x + R[3] * this.y;
                            return this.x = R[0] * this.x + R[1] * this.y, this.y = S, this;
                        },
                        _add: function(R) {
                            return this.x += R.x, this.y += R.y, this;
                        },
                        _sub: function(R) {
                            return this.x -= R.x, this.y -= R.y, this;
                        },
                        _mult: function(R) {
                            return this.x *= R, this.y *= R, this;
                        },
                        _div: function(R) {
                            return this.x /= R, this.y /= R, this;
                        },
                        _multByPoint: function(R) {
                            return this.x *= R.x, this.y *= R.y, this;
                        },
                        _divByPoint: function(R) {
                            return this.x /= R.x, this.y /= R.y, this;
                        },
                        _unit: function() {
                            return this._div(this.mag()), this;
                        },
                        _perp: function() {
                            var R = this.y;
                            return this.y = this.x, this.x = -R, this;
                        },
                        _rotate: function(R) {
                            var S = Math.cos(R), D = Math.sin(R), j = D * this.x + S * this.y;
                            return this.x = S * this.x - D * this.y, this.y = j, this;
                        },
                        _rotateAround: function(R, S) {
                            var D = Math.cos(R), j = Math.sin(R), te = S.y + j * (this.x - S.x) + D * (this.y - S.y);
                            return this.x = S.x + D * (this.x - S.x) - j * (this.y - S.y), this.y = te, this;
                        },
                        _round: function() {
                            return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                        }
                    }, l.convert = function(R) {
                        return R instanceof l ? R : Array.isArray(R) ? new l(R[0], R[1]) : R;
                    };
                    var u = o(s), c = f;
                    function f(R, S, D, j) {
                        this.cx = 3 * R, this.bx = 3 * (D - R) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * S, this.by = 3 * (j - S) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = R, this.p1y = S, this.p2x = D, this.p2y = j;
                    }
                    f.prototype = {
                        sampleCurveX: function(R) {
                            return ((this.ax * R + this.bx) * R + this.cx) * R;
                        },
                        sampleCurveY: function(R) {
                            return ((this.ay * R + this.by) * R + this.cy) * R;
                        },
                        sampleCurveDerivativeX: function(R) {
                            return (3 * this.ax * R + 2 * this.bx) * R + this.cx;
                        },
                        solveCurveX: function(R, S) {
                            if (S === void 0 && (S = 1e-6), R < 0) return 0;
                            if (R > 1) return 1;
                            for(var D = R, j = 0; j < 8; j++){
                                var te = this.sampleCurveX(D) - R;
                                if (Math.abs(te) < S) return D;
                                var ue = this.sampleCurveDerivativeX(D);
                                if (Math.abs(ue) < 1e-6) break;
                                D -= te / ue;
                            }
                            var ve = 0, De = 1;
                            for(D = R, j = 0; j < 20 && (te = this.sampleCurveX(D), !(Math.abs(te - R) < S)); j++)R > te ? ve = D : De = D, D = .5 * (De - ve) + ve;
                            return D;
                        },
                        solve: function(R, S) {
                            return this.sampleCurveY(this.solveCurveX(R, S));
                        }
                    };
                    var h = o(c);
                    let d, v;
                    function x() {
                        return d == null && (d = typeof OffscreenCanvas != "undefined" && new OffscreenCanvas(1, 1).getContext("2d") && typeof createImageBitmap == "function"), d;
                    }
                    function b() {
                        if (v == null && (v = !1, x())) {
                            let S = new OffscreenCanvas(5, 5).getContext("2d", {
                                willReadFrequently: !0
                            });
                            if (S) {
                                for(let j = 0; j < 25; j++){
                                    let te = 4 * j;
                                    S.fillStyle = `rgb(${te},${te + 1},${te + 2})`, S.fillRect(j % 5, Math.floor(j / 5), 1, 1);
                                }
                                let D = S.getImageData(0, 0, 5, 5).data;
                                for(let j = 0; j < 100; j++)if (j % 4 != 3 && D[j] !== j) {
                                    v = !0;
                                    break;
                                }
                            }
                        }
                        return v || !1;
                    }
                    function p(R, S, D, j) {
                        let te = new h(R, S, D, j);
                        return (ue)=>te.solve(ue);
                    }
                    let E = p(.25, .1, .25, 1);
                    function k(R, S, D) {
                        return Math.min(D, Math.max(S, R));
                    }
                    function A(R, S, D) {
                        let j = D - S, te = ((R - S) % j + j) % j + S;
                        return te === S ? D : te;
                    }
                    function L(R, ...S) {
                        for (let D of S)for(let j in D)R[j] = D[j];
                        return R;
                    }
                    let _ = 1;
                    function C(R, S, D) {
                        let j = {};
                        for(let te in R)j[te] = S.call(this, R[te], te, R);
                        return j;
                    }
                    function M(R, S, D) {
                        let j = {};
                        for(let te in R)S.call(this, R[te], te, R) && (j[te] = R[te]);
                        return j;
                    }
                    function g(R) {
                        return Array.isArray(R) ? R.map(g) : typeof R == "object" && R ? C(R, g) : R;
                    }
                    let P = {};
                    function T(R) {
                        P[R] || (typeof console != "undefined" && console.warn(R), P[R] = !0);
                    }
                    function F(R, S, D) {
                        return (D.y - R.y) * (S.x - R.x) > (S.y - R.y) * (D.x - R.x);
                    }
                    function q(R) {
                        return typeof WorkerGlobalScope != "undefined" && R !== void 0 && R instanceof WorkerGlobalScope;
                    }
                    let V = null;
                    function H(R) {
                        return typeof ImageBitmap != "undefined" && R instanceof ImageBitmap;
                    }
                    let X = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
                    function G(R, S, D, j, te) {
                        return a(this, void 0, void 0, function*() {
                            if (typeof VideoFrame == "undefined") throw new Error("VideoFrame not supported");
                            let ue = new VideoFrame(R, {
                                timestamp: 0
                            });
                            try {
                                let ve = ue == null ? void 0 : ue.format;
                                if (!ve || !ve.startsWith("BGR") && !ve.startsWith("RGB")) throw new Error(`Unrecognized format ${ve}`);
                                let De = ve.startsWith("BGR"), Ze = new Uint8ClampedArray(j * te * 4);
                                if (yield ue.copyTo(Ze, function(at, Tt, Ft, Qt, sr) {
                                    let Tr = 4 * Math.max(-Tt, 0), Pr = (Math.max(0, Ft) - Ft) * Qt * 4 + Tr, $r = 4 * Qt, ni = Math.max(0, Tt), Di = Math.max(0, Ft);
                                    return {
                                        rect: {
                                            x: ni,
                                            y: Di,
                                            width: Math.min(at.width, Tt + Qt) - ni,
                                            height: Math.min(at.height, Ft + sr) - Di
                                        },
                                        layout: [
                                            {
                                                offset: Pr,
                                                stride: $r
                                            }
                                        ]
                                    };
                                }(R, S, D, j, te)), De) for(let at = 0; at < Ze.length; at += 4){
                                    let Tt = Ze[at];
                                    Ze[at] = Ze[at + 2], Ze[at + 2] = Tt;
                                }
                                return Ze;
                            } finally{
                                ue.close();
                            }
                        });
                    }
                    let N, W, re = "AbortError";
                    function ae() {
                        return new Error(re);
                    }
                    let _e = {
                        MAX_PARALLEL_IMAGE_REQUESTS: 16,
                        MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
                        MAX_TILE_CACHE_ZOOM_LEVELS: 5,
                        REGISTERED_PROTOCOLS: {},
                        WORKER_URL: ""
                    };
                    function Me(R) {
                        return _e.REGISTERED_PROTOCOLS[R.substring(0, R.indexOf("://"))];
                    }
                    let ke = "global-dispatcher";
                    class ge extends Error {
                        constructor(S, D, j, te){
                            super(`AJAXError: ${D} (${S}): ${j}`), this.status = S, this.statusText = D, this.url = j, this.body = te;
                        }
                    }
                    let ie = ()=>q(self) ? self.worker && self.worker.referrer : (window.location.protocol === "blob:" ? window.parent : window).location.href, Te = function(R, S) {
                        if (/:\/\//.test(R.url) && !/^https?:|^file:/.test(R.url)) {
                            let j = Me(R.url);
                            if (j) return j(R, S);
                            if (q(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                type: "GR",
                                data: R,
                                targetMapId: ke
                            }, S);
                        }
                        if (!(/^file:/.test(D = R.url) || /^file:/.test(ie()) && !/^\w+:/.test(D))) {
                            if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(j, te) {
                                return a(this, void 0, void 0, function*() {
                                    let ue = new Request(j.url, {
                                        method: j.method || "GET",
                                        body: j.body,
                                        credentials: j.credentials,
                                        headers: j.headers,
                                        cache: j.cache,
                                        referrer: ie(),
                                        signal: te.signal
                                    });
                                    j.type !== "json" || ue.headers.has("Accept") || ue.headers.set("Accept", "application/json");
                                    let ve = yield fetch(ue);
                                    if (!ve.ok) {
                                        let at = yield ve.blob();
                                        throw new ge(ve.status, ve.statusText, j.url, at);
                                    }
                                    let De;
                                    De = j.type === "arrayBuffer" || j.type === "image" ? ve.arrayBuffer() : j.type === "json" ? ve.json() : ve.text();
                                    let Ze = yield De;
                                    if (te.signal.aborted) throw ae();
                                    return {
                                        data: Ze,
                                        cacheControl: ve.headers.get("Cache-Control"),
                                        expires: ve.headers.get("Expires")
                                    };
                                });
                            }(R, S);
                            if (q(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                type: "GR",
                                data: R,
                                mustQueue: !0,
                                targetMapId: ke
                            }, S);
                        }
                        var D;
                        return function(j, te) {
                            return new Promise((ue, ve)=>{
                                var De;
                                let Ze = new XMLHttpRequest;
                                Ze.open(j.method || "GET", j.url, !0), j.type !== "arrayBuffer" && j.type !== "image" || (Ze.responseType = "arraybuffer");
                                for(let at in j.headers)Ze.setRequestHeader(at, j.headers[at]);
                                j.type === "json" && (Ze.responseType = "text", !((De = j.headers) === null || De === void 0) && De.Accept || Ze.setRequestHeader("Accept", "application/json")), Ze.withCredentials = j.credentials === "include", Ze.onerror = ()=>{
                                    ve(new Error(Ze.statusText));
                                }, Ze.onload = ()=>{
                                    if (!te.signal.aborted) {
                                        if ((Ze.status >= 200 && Ze.status < 300 || Ze.status === 0) && Ze.response !== null) {
                                            let at = Ze.response;
                                            if (j.type === "json") try {
                                                at = JSON.parse(Ze.response);
                                            } catch (Tt) {
                                                return void ve(Tt);
                                            }
                                            ue({
                                                data: at,
                                                cacheControl: Ze.getResponseHeader("Cache-Control"),
                                                expires: Ze.getResponseHeader("Expires")
                                            });
                                        } else {
                                            let at = new Blob([
                                                Ze.response
                                            ], {
                                                type: Ze.getResponseHeader("Content-Type")
                                            });
                                            ve(new ge(Ze.status, Ze.statusText, j.url, at));
                                        }
                                    }
                                }, te.signal.addEventListener("abort", ()=>{
                                    Ze.abort(), ve(ae());
                                }), Ze.send(j.body);
                            });
                        }(R, S);
                    };
                    function Ee(R) {
                        if (!R || R.indexOf("://") <= 0 || R.indexOf("data:image/") === 0 || R.indexOf("blob:") === 0) return !0;
                        let S = new URL(R), D = window.location;
                        return S.protocol === D.protocol && S.host === D.host;
                    }
                    function Ae(R, S, D) {
                        D[R] && D[R].indexOf(S) !== -1 || (D[R] = D[R] || [], D[R].push(S));
                    }
                    function ze(R, S, D) {
                        if (D && D[R]) {
                            let j = D[R].indexOf(S);
                            j !== -1 && D[R].splice(j, 1);
                        }
                    }
                    class Ce {
                        constructor(S, D = {}){
                            L(this, D), this.type = S;
                        }
                    }
                    class me extends Ce {
                        constructor(S, D = {}){
                            super("error", L({
                                error: S
                            }, D));
                        }
                    }
                    class Re {
                        on(S, D) {
                            return this._listeners = this._listeners || {}, Ae(S, D, this._listeners), this;
                        }
                        off(S, D) {
                            return ze(S, D, this._listeners), ze(S, D, this._oneTimeListeners), this;
                        }
                        once(S, D) {
                            return D ? (this._oneTimeListeners = this._oneTimeListeners || {}, Ae(S, D, this._oneTimeListeners), this) : new Promise((j)=>this.once(S, j));
                        }
                        fire(S, D) {
                            typeof S == "string" && (S = new Ce(S, D || {}));
                            let j = S.type;
                            if (this.listens(j)) {
                                S.target = this;
                                let te = this._listeners && this._listeners[j] ? this._listeners[j].slice() : [];
                                for (let De of te)De.call(this, S);
                                let ue = this._oneTimeListeners && this._oneTimeListeners[j] ? this._oneTimeListeners[j].slice() : [];
                                for (let De of ue)ze(j, De, this._oneTimeListeners), De.call(this, S);
                                let ve = this._eventedParent;
                                ve && (L(S, typeof this._eventedParentData == "function" ? this._eventedParentData() : this._eventedParentData), ve.fire(S));
                            } else S instanceof me && console.error(S.error);
                            return this;
                        }
                        listens(S) {
                            return this._listeners && this._listeners[S] && this._listeners[S].length > 0 || this._oneTimeListeners && this._oneTimeListeners[S] && this._oneTimeListeners[S].length > 0 || this._eventedParent && this._eventedParent.listens(S);
                        }
                        setEventedParent(S, D) {
                            return this._eventedParent = S, this._eventedParentData = D, this;
                        }
                    }
                    var ce = {
                        $version: 8,
                        $root: {
                            version: {
                                required: !0,
                                type: "enum",
                                values: [
                                    8
                                ]
                            },
                            name: {
                                type: "string"
                            },
                            metadata: {
                                type: "*"
                            },
                            center: {
                                type: "array",
                                value: "number"
                            },
                            zoom: {
                                type: "number"
                            },
                            bearing: {
                                type: "number",
                                default: 0,
                                period: 360,
                                units: "degrees"
                            },
                            pitch: {
                                type: "number",
                                default: 0,
                                units: "degrees"
                            },
                            light: {
                                type: "light"
                            },
                            sky: {
                                type: "sky"
                            },
                            projection: {
                                type: "projection"
                            },
                            terrain: {
                                type: "terrain"
                            },
                            sources: {
                                required: !0,
                                type: "sources"
                            },
                            sprite: {
                                type: "sprite"
                            },
                            glyphs: {
                                type: "string"
                            },
                            transition: {
                                type: "transition"
                            },
                            layers: {
                                required: !0,
                                type: "array",
                                value: "layer"
                            }
                        },
                        sources: {
                            "*": {
                                type: "source"
                            }
                        },
                        source: [
                            "source_vector",
                            "source_raster",
                            "source_raster_dem",
                            "source_geojson",
                            "source_video",
                            "source_image"
                        ],
                        source_vector: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    vector: {}
                                }
                            },
                            url: {
                                type: "string"
                            },
                            tiles: {
                                type: "array",
                                value: "string"
                            },
                            bounds: {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    -180,
                                    -85.051129,
                                    180,
                                    85.051129
                                ]
                            },
                            scheme: {
                                type: "enum",
                                values: {
                                    xyz: {},
                                    tms: {}
                                },
                                default: "xyz"
                            },
                            minzoom: {
                                type: "number",
                                default: 0
                            },
                            maxzoom: {
                                type: "number",
                                default: 22
                            },
                            attribution: {
                                type: "string"
                            },
                            promoteId: {
                                type: "promoteId"
                            },
                            volatile: {
                                type: "boolean",
                                default: !1
                            },
                            "*": {
                                type: "*"
                            }
                        },
                        source_raster: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    raster: {}
                                }
                            },
                            url: {
                                type: "string"
                            },
                            tiles: {
                                type: "array",
                                value: "string"
                            },
                            bounds: {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    -180,
                                    -85.051129,
                                    180,
                                    85.051129
                                ]
                            },
                            minzoom: {
                                type: "number",
                                default: 0
                            },
                            maxzoom: {
                                type: "number",
                                default: 22
                            },
                            tileSize: {
                                type: "number",
                                default: 512,
                                units: "pixels"
                            },
                            scheme: {
                                type: "enum",
                                values: {
                                    xyz: {},
                                    tms: {}
                                },
                                default: "xyz"
                            },
                            attribution: {
                                type: "string"
                            },
                            volatile: {
                                type: "boolean",
                                default: !1
                            },
                            "*": {
                                type: "*"
                            }
                        },
                        source_raster_dem: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    "raster-dem": {}
                                }
                            },
                            url: {
                                type: "string"
                            },
                            tiles: {
                                type: "array",
                                value: "string"
                            },
                            bounds: {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    -180,
                                    -85.051129,
                                    180,
                                    85.051129
                                ]
                            },
                            minzoom: {
                                type: "number",
                                default: 0
                            },
                            maxzoom: {
                                type: "number",
                                default: 22
                            },
                            tileSize: {
                                type: "number",
                                default: 512,
                                units: "pixels"
                            },
                            attribution: {
                                type: "string"
                            },
                            encoding: {
                                type: "enum",
                                values: {
                                    terrarium: {},
                                    mapbox: {},
                                    custom: {}
                                },
                                default: "mapbox"
                            },
                            redFactor: {
                                type: "number",
                                default: 1
                            },
                            blueFactor: {
                                type: "number",
                                default: 1
                            },
                            greenFactor: {
                                type: "number",
                                default: 1
                            },
                            baseShift: {
                                type: "number",
                                default: 0
                            },
                            volatile: {
                                type: "boolean",
                                default: !1
                            },
                            "*": {
                                type: "*"
                            }
                        },
                        source_geojson: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    geojson: {}
                                }
                            },
                            data: {
                                required: !0,
                                type: "*"
                            },
                            maxzoom: {
                                type: "number",
                                default: 18
                            },
                            attribution: {
                                type: "string"
                            },
                            buffer: {
                                type: "number",
                                default: 128,
                                maximum: 512,
                                minimum: 0
                            },
                            filter: {
                                type: "*"
                            },
                            tolerance: {
                                type: "number",
                                default: .375
                            },
                            cluster: {
                                type: "boolean",
                                default: !1
                            },
                            clusterRadius: {
                                type: "number",
                                default: 50,
                                minimum: 0
                            },
                            clusterMaxZoom: {
                                type: "number"
                            },
                            clusterMinPoints: {
                                type: "number"
                            },
                            clusterProperties: {
                                type: "*"
                            },
                            lineMetrics: {
                                type: "boolean",
                                default: !1
                            },
                            generateId: {
                                type: "boolean",
                                default: !1
                            },
                            promoteId: {
                                type: "promoteId"
                            }
                        },
                        source_video: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    video: {}
                                }
                            },
                            urls: {
                                required: !0,
                                type: "array",
                                value: "string"
                            },
                            coordinates: {
                                required: !0,
                                type: "array",
                                length: 4,
                                value: {
                                    type: "array",
                                    length: 2,
                                    value: "number"
                                }
                            }
                        },
                        source_image: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    image: {}
                                }
                            },
                            url: {
                                required: !0,
                                type: "string"
                            },
                            coordinates: {
                                required: !0,
                                type: "array",
                                length: 4,
                                value: {
                                    type: "array",
                                    length: 2,
                                    value: "number"
                                }
                            }
                        },
                        layer: {
                            id: {
                                type: "string",
                                required: !0
                            },
                            type: {
                                type: "enum",
                                values: {
                                    fill: {},
                                    line: {},
                                    symbol: {},
                                    circle: {},
                                    heatmap: {},
                                    "fill-extrusion": {},
                                    raster: {},
                                    hillshade: {},
                                    background: {}
                                },
                                required: !0
                            },
                            metadata: {
                                type: "*"
                            },
                            source: {
                                type: "string"
                            },
                            "source-layer": {
                                type: "string"
                            },
                            minzoom: {
                                type: "number",
                                minimum: 0,
                                maximum: 24
                            },
                            maxzoom: {
                                type: "number",
                                minimum: 0,
                                maximum: 24
                            },
                            filter: {
                                type: "filter"
                            },
                            layout: {
                                type: "layout"
                            },
                            paint: {
                                type: "paint"
                            }
                        },
                        layout: [
                            "layout_fill",
                            "layout_line",
                            "layout_circle",
                            "layout_heatmap",
                            "layout_fill-extrusion",
                            "layout_symbol",
                            "layout_raster",
                            "layout_hillshade",
                            "layout_background"
                        ],
                        layout_background: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_fill: {
                            "fill-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_circle: {
                            "circle-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_heatmap: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        "layout_fill-extrusion": {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_line: {
                            "line-cap": {
                                type: "enum",
                                values: {
                                    butt: {},
                                    round: {},
                                    square: {}
                                },
                                default: "butt",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-join": {
                                type: "enum",
                                values: {
                                    bevel: {},
                                    round: {},
                                    miter: {}
                                },
                                default: "miter",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-miter-limit": {
                                type: "number",
                                default: 2,
                                requires: [
                                    {
                                        "line-join": "miter"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-round-limit": {
                                type: "number",
                                default: 1.05,
                                requires: [
                                    {
                                        "line-join": "round"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_symbol: {
                            "symbol-placement": {
                                type: "enum",
                                values: {
                                    point: {},
                                    line: {},
                                    "line-center": {}
                                },
                                default: "point",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "symbol-spacing": {
                                type: "number",
                                default: 250,
                                minimum: 1,
                                units: "pixels",
                                requires: [
                                    {
                                        "symbol-placement": "line"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "symbol-avoid-edges": {
                                type: "boolean",
                                default: !1,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "symbol-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "symbol-z-order": {
                                type: "enum",
                                values: {
                                    auto: {},
                                    "viewport-y": {},
                                    source: {}
                                },
                                default: "auto",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-allow-overlap": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image",
                                    {
                                        "!": "icon-overlap"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-overlap": {
                                type: "enum",
                                values: {
                                    never: {},
                                    always: {},
                                    cooperative: {}
                                },
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-ignore-placement": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-optional": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image",
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-rotation-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-size": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                units: "factor of the original icon size",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-text-fit": {
                                type: "enum",
                                values: {
                                    none: {},
                                    width: {},
                                    height: {},
                                    both: {}
                                },
                                default: "none",
                                requires: [
                                    "icon-image",
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-text-fit-padding": {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                units: "pixels",
                                requires: [
                                    "icon-image",
                                    "text-field",
                                    {
                                        "icon-text-fit": [
                                            "both",
                                            "width",
                                            "height"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-image": {
                                type: "resolvedImage",
                                tokens: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-rotate": {
                                type: "number",
                                default: 0,
                                period: 360,
                                units: "degrees",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-padding": {
                                type: "padding",
                                default: [
                                    2
                                ],
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-keep-upright": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image",
                                    {
                                        "icon-rotation-alignment": "map"
                                    },
                                    {
                                        "symbol-placement": [
                                            "line",
                                            "line-center"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-offset": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-anchor": {
                                type: "enum",
                                values: {
                                    center: {},
                                    left: {},
                                    right: {},
                                    top: {},
                                    bottom: {},
                                    "top-left": {},
                                    "top-right": {},
                                    "bottom-left": {},
                                    "bottom-right": {}
                                },
                                default: "center",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-pitch-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-pitch-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-rotation-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    "viewport-glyph": {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-field": {
                                type: "formatted",
                                default: "",
                                tokens: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-font": {
                                type: "array",
                                value: "string",
                                default: [
                                    "Open Sans Regular",
                                    "Arial Unicode MS Regular"
                                ],
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-size": {
                                type: "number",
                                default: 16,
                                minimum: 0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-max-width": {
                                type: "number",
                                default: 10,
                                minimum: 0,
                                units: "ems",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-line-height": {
                                type: "number",
                                default: 1.2,
                                units: "ems",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-letter-spacing": {
                                type: "number",
                                default: 0,
                                units: "ems",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-justify": {
                                type: "enum",
                                values: {
                                    auto: {},
                                    left: {},
                                    center: {},
                                    right: {}
                                },
                                default: "center",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-radial-offset": {
                                type: "number",
                                units: "ems",
                                default: 0,
                                requires: [
                                    "text-field"
                                ],
                                "property-type": "data-driven",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                }
                            },
                            "text-variable-anchor": {
                                type: "array",
                                value: "enum",
                                values: {
                                    center: {},
                                    left: {},
                                    right: {},
                                    top: {},
                                    bottom: {},
                                    "top-left": {},
                                    "top-right": {},
                                    "bottom-left": {},
                                    "bottom-right": {}
                                },
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "point"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-variable-anchor-offset": {
                                type: "variableAnchorOffsetCollection",
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "point"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-anchor": {
                                type: "enum",
                                values: {
                                    center: {},
                                    left: {},
                                    right: {},
                                    top: {},
                                    bottom: {},
                                    "top-left": {},
                                    "top-right": {},
                                    "bottom-left": {},
                                    "bottom-right": {}
                                },
                                default: "center",
                                requires: [
                                    "text-field",
                                    {
                                        "!": "text-variable-anchor"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-max-angle": {
                                type: "number",
                                default: 45,
                                units: "degrees",
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "line",
                                            "line-center"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-writing-mode": {
                                type: "array",
                                value: "enum",
                                values: {
                                    horizontal: {},
                                    vertical: {}
                                },
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "point"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-rotate": {
                                type: "number",
                                default: 0,
                                period: 360,
                                units: "degrees",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-padding": {
                                type: "number",
                                default: 2,
                                minimum: 0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-keep-upright": {
                                type: "boolean",
                                default: !0,
                                requires: [
                                    "text-field",
                                    {
                                        "text-rotation-alignment": "map"
                                    },
                                    {
                                        "symbol-placement": [
                                            "line",
                                            "line-center"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-transform": {
                                type: "enum",
                                values: {
                                    none: {},
                                    uppercase: {},
                                    lowercase: {}
                                },
                                default: "none",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-offset": {
                                type: "array",
                                value: "number",
                                units: "ems",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                requires: [
                                    "text-field",
                                    {
                                        "!": "text-radial-offset"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-allow-overlap": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "text-field",
                                    {
                                        "!": "text-overlap"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-overlap": {
                                type: "enum",
                                values: {
                                    never: {},
                                    always: {},
                                    cooperative: {}
                                },
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-ignore-placement": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-optional": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "text-field",
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_raster: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        layout_hillshade: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                "property-type": "constant"
                            }
                        },
                        filter: {
                            type: "array",
                            value: "*"
                        },
                        filter_operator: {
                            type: "enum",
                            values: {
                                "==": {},
                                "!=": {},
                                ">": {},
                                ">=": {},
                                "<": {},
                                "<=": {},
                                in: {},
                                "!in": {},
                                all: {},
                                any: {},
                                none: {},
                                has: {},
                                "!has": {}
                            }
                        },
                        geometry_type: {
                            type: "enum",
                            values: {
                                Point: {},
                                LineString: {},
                                Polygon: {}
                            }
                        },
                        function: {
                            expression: {
                                type: "expression"
                            },
                            stops: {
                                type: "array",
                                value: "function_stop"
                            },
                            base: {
                                type: "number",
                                default: 1,
                                minimum: 0
                            },
                            property: {
                                type: "string",
                                default: "$zoom"
                            },
                            type: {
                                type: "enum",
                                values: {
                                    identity: {},
                                    exponential: {},
                                    interval: {},
                                    categorical: {}
                                },
                                default: "exponential"
                            },
                            colorSpace: {
                                type: "enum",
                                values: {
                                    rgb: {},
                                    lab: {},
                                    hcl: {}
                                },
                                default: "rgb"
                            },
                            default: {
                                type: "*",
                                required: !1
                            }
                        },
                        function_stop: {
                            type: "array",
                            minimum: 0,
                            maximum: 24,
                            value: [
                                "number",
                                "color"
                            ],
                            length: 2
                        },
                        expression: {
                            type: "array",
                            value: "*",
                            minimum: 1
                        },
                        light: {
                            anchor: {
                                type: "enum",
                                default: "viewport",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                "property-type": "data-constant",
                                transition: !1,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                }
                            },
                            position: {
                                type: "array",
                                default: [
                                    1.15,
                                    210,
                                    30
                                ],
                                length: 3,
                                value: "number",
                                "property-type": "data-constant",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                }
                            },
                            color: {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#ffffff",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            intensity: {
                                type: "number",
                                "property-type": "data-constant",
                                default: .5,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            }
                        },
                        sky: {
                            "sky-color": {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#88C6FC",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "horizon-color": {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#ffffff",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "fog-color": {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#ffffff",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "fog-ground-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .5,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "horizon-fog-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .8,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "sky-horizon-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .8,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "atmosphere-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .8,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            }
                        },
                        terrain: {
                            source: {
                                type: "string",
                                required: !0
                            },
                            exaggeration: {
                                type: "number",
                                minimum: 0,
                                default: 1
                            }
                        },
                        projection: {
                            type: {
                                type: "enum",
                                default: "mercator",
                                values: {
                                    mercator: {},
                                    globe: {}
                                }
                            }
                        },
                        paint: [
                            "paint_fill",
                            "paint_line",
                            "paint_circle",
                            "paint_heatmap",
                            "paint_fill-extrusion",
                            "paint_symbol",
                            "paint_raster",
                            "paint_hillshade",
                            "paint_background"
                        ],
                        paint_fill: {
                            "fill-antialias": {
                                type: "boolean",
                                default: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "fill-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-outline-color": {
                                type: "color",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "fill-pattern"
                                    },
                                    {
                                        "fill-antialias": !0
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "fill-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            }
                        },
                        "paint_fill-extrusion": {
                            "fill-extrusion-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "fill-extrusion-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "fill-extrusion-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            },
                            "fill-extrusion-height": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "meters",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-base": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "meters",
                                transition: !0,
                                requires: [
                                    "fill-extrusion-height"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-vertical-gradient": {
                                type: "boolean",
                                default: !0,
                                transition: !1,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_line: {
                            "line-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "line-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "line-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-width": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-gap-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-offset": {
                                type: "number",
                                default: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-blur": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-dasharray": {
                                type: "array",
                                value: "number",
                                minimum: 0,
                                transition: !0,
                                units: "line widths",
                                requires: [
                                    {
                                        "!": "line-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "cross-faded"
                            },
                            "line-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            },
                            "line-gradient": {
                                type: "color",
                                transition: !1,
                                requires: [
                                    {
                                        "!": "line-dasharray"
                                    },
                                    {
                                        "!": "line-pattern"
                                    },
                                    {
                                        source: "geojson",
                                        has: {
                                            lineMetrics: !0
                                        }
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "line-progress"
                                    ]
                                },
                                "property-type": "color-ramp"
                            }
                        },
                        paint_circle: {
                            "circle-radius": {
                                type: "number",
                                default: 5,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-blur": {
                                type: "number",
                                default: 0,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "circle-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-pitch-scale": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-pitch-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "viewport",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-stroke-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-stroke-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-stroke-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            }
                        },
                        paint_heatmap: {
                            "heatmap-radius": {
                                type: "number",
                                default: 30,
                                minimum: 1,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "heatmap-weight": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "heatmap-intensity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "heatmap-color": {
                                type: "color",
                                default: [
                                    "interpolate",
                                    [
                                        "linear"
                                    ],
                                    [
                                        "heatmap-density"
                                    ],
                                    0,
                                    "rgba(0, 0, 255, 0)",
                                    .1,
                                    "royalblue",
                                    .3,
                                    "cyan",
                                    .5,
                                    "lime",
                                    .7,
                                    "yellow",
                                    1,
                                    "red"
                                ],
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "heatmap-density"
                                    ]
                                },
                                "property-type": "color-ramp"
                            },
                            "heatmap-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_symbol: {
                            "icon-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-halo-color": {
                                type: "color",
                                default: "rgba(0, 0, 0, 0)",
                                transition: !0,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-halo-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-halo-blur": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "icon-image",
                                    "icon-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                overridable: !0,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-halo-color": {
                                type: "color",
                                default: "rgba(0, 0, 0, 0)",
                                transition: !0,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-halo-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-halo-blur": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "text-field",
                                    "text-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_raster: {
                            "raster-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-hue-rotate": {
                                type: "number",
                                default: 0,
                                period: 360,
                                transition: !0,
                                units: "degrees",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-brightness-min": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-brightness-max": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-saturation": {
                                type: "number",
                                default: 0,
                                minimum: -1,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-contrast": {
                                type: "number",
                                default: 0,
                                minimum: -1,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-resampling": {
                                type: "enum",
                                values: {
                                    linear: {},
                                    nearest: {}
                                },
                                default: "linear",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-fade-duration": {
                                type: "number",
                                default: 300,
                                minimum: 0,
                                transition: !1,
                                units: "milliseconds",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_hillshade: {
                            "hillshade-illumination-direction": {
                                type: "number",
                                default: 335,
                                minimum: 0,
                                maximum: 359,
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-illumination-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "viewport",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-exaggeration": {
                                type: "number",
                                default: .5,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-shadow-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-highlight-color": {
                                type: "color",
                                default: "#FFFFFF",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-accent-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_background: {
                            "background-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "background-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "background-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "cross-faded"
                            },
                            "background-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        transition: {
                            duration: {
                                type: "number",
                                default: 300,
                                minimum: 0,
                                units: "milliseconds"
                            },
                            delay: {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "milliseconds"
                            }
                        },
                        "property-type": {
                            "data-driven": {
                                type: "property-type"
                            },
                            "cross-faded": {
                                type: "property-type"
                            },
                            "cross-faded-data-driven": {
                                type: "property-type"
                            },
                            "color-ramp": {
                                type: "property-type"
                            },
                            "data-constant": {
                                type: "property-type"
                            },
                            constant: {
                                type: "property-type"
                            }
                        },
                        promoteId: {
                            "*": {
                                type: "string"
                            }
                        }
                    };
                    let Ge = [
                        "type",
                        "source",
                        "source-layer",
                        "minzoom",
                        "maxzoom",
                        "filter",
                        "layout"
                    ];
                    function nt(R, S) {
                        let D = {};
                        for(let j in R)j !== "ref" && (D[j] = R[j]);
                        return Ge.forEach((j)=>{
                            j in S && (D[j] = S[j]);
                        }), D;
                    }
                    function ct(R, S) {
                        if (Array.isArray(R)) {
                            if (!Array.isArray(S) || R.length !== S.length) return !1;
                            for(let D = 0; D < R.length; D++)if (!ct(R[D], S[D])) return !1;
                            return !0;
                        }
                        if (typeof R == "object" && R !== null && S !== null) {
                            if (typeof S != "object" || Object.keys(R).length !== Object.keys(S).length) return !1;
                            for(let D in R)if (!ct(R[D], S[D])) return !1;
                            return !0;
                        }
                        return R === S;
                    }
                    function qt(R, S) {
                        R.push(S);
                    }
                    function rt(R, S, D) {
                        qt(D, {
                            command: "addSource",
                            args: [
                                R,
                                S[R]
                            ]
                        });
                    }
                    function ot(R, S, D) {
                        qt(S, {
                            command: "removeSource",
                            args: [
                                R
                            ]
                        }), D[R] = !0;
                    }
                    function Rt(R, S, D, j) {
                        ot(R, D, j), rt(R, S, D);
                    }
                    function kt(R, S, D) {
                        let j;
                        for(j in R[D])if (Object.prototype.hasOwnProperty.call(R[D], j) && j !== "data" && !ct(R[D][j], S[D][j])) return !1;
                        for(j in S[D])if (Object.prototype.hasOwnProperty.call(S[D], j) && j !== "data" && !ct(R[D][j], S[D][j])) return !1;
                        return !0;
                    }
                    function Ct(R, S, D, j, te, ue) {
                        R = R || {}, S = S || {};
                        for(let ve in R)Object.prototype.hasOwnProperty.call(R, ve) && (ct(R[ve], S[ve]) || D.push({
                            command: ue,
                            args: [
                                j,
                                ve,
                                S[ve],
                                te
                            ]
                        }));
                        for(let ve in S)Object.prototype.hasOwnProperty.call(S, ve) && !Object.prototype.hasOwnProperty.call(R, ve) && (ct(R[ve], S[ve]) || D.push({
                            command: ue,
                            args: [
                                j,
                                ve,
                                S[ve],
                                te
                            ]
                        }));
                    }
                    function Yt(R) {
                        return R.id;
                    }
                    function xr(R, S) {
                        return R[S.id] = S, R;
                    }
                    class er {
                        constructor(S, D, j, te){
                            this.message = (S ? `${S}: ` : "") + j, te && (this.identifier = te), D != null && D.__line__ && (this.line = D.__line__);
                        }
                    }
                    function Ke(R, ...S) {
                        for (let D of S)for(let j in D)R[j] = D[j];
                        return R;
                    }
                    class xt extends Error {
                        constructor(S, D){
                            super(D), this.message = D, this.key = S;
                        }
                    }
                    class bt {
                        constructor(S, D = []){
                            this.parent = S, this.bindings = {};
                            for (let [j, te] of D)this.bindings[j] = te;
                        }
                        concat(S) {
                            return new bt(this, S);
                        }
                        get(S) {
                            if (this.bindings[S]) return this.bindings[S];
                            if (this.parent) return this.parent.get(S);
                            throw new Error(`${S} not found in scope.`);
                        }
                        has(S) {
                            return !!this.bindings[S] || !!this.parent && this.parent.has(S);
                        }
                    }
                    let Lt = {
                        kind: "null"
                    }, St = {
                        kind: "number"
                    }, Et = {
                        kind: "string"
                    }, dt = {
                        kind: "boolean"
                    }, Ht = {
                        kind: "color"
                    }, $t = {
                        kind: "object"
                    }, fr = {
                        kind: "value"
                    }, _r = {
                        kind: "collator"
                    }, Br = {
                        kind: "formatted"
                    }, Or = {
                        kind: "padding"
                    }, Nr = {
                        kind: "resolvedImage"
                    }, ut = {
                        kind: "variableAnchorOffsetCollection"
                    };
                    function Ne(R, S) {
                        return {
                            kind: "array",
                            itemType: R,
                            N: S
                        };
                    }
                    function Ye(R) {
                        if (R.kind === "array") {
                            let S = Ye(R.itemType);
                            return typeof R.N == "number" ? `array<${S}, ${R.N}>` : R.itemType.kind === "value" ? "array" : `array<${S}>`;
                        }
                        return R.kind;
                    }
                    let Ve = [
                        Lt,
                        St,
                        Et,
                        dt,
                        Ht,
                        Br,
                        $t,
                        Ne(fr),
                        Or,
                        Nr,
                        ut
                    ];
                    function Xe(R, S) {
                        if (S.kind === "error") return null;
                        if (R.kind === "array") {
                            if (S.kind === "array" && (S.N === 0 && S.itemType.kind === "value" || !Xe(R.itemType, S.itemType)) && (typeof R.N != "number" || R.N === S.N)) return null;
                        } else {
                            if (R.kind === S.kind) return null;
                            if (R.kind === "value") {
                                for (let D of Ve)if (!Xe(D, S)) return null;
                            }
                        }
                        return `Expected ${Ye(R)} but found ${Ye(S)} instead.`;
                    }
                    function ht(R, S) {
                        return S.some((D)=>D.kind === R.kind);
                    }
                    function Le(R, S) {
                        return S.some((D)=>D === "null" ? R === null : D === "array" ? Array.isArray(R) : D === "object" ? R && !Array.isArray(R) && typeof R == "object" : D === typeof R);
                    }
                    function xe(R, S) {
                        return R.kind === "array" && S.kind === "array" ? R.itemType.kind === S.itemType.kind && typeof R.N == "number" : R.kind === S.kind;
                    }
                    let Se = .96422, lt = .82521, Gt = 4 / 29, Vt = 6 / 29, ar = 3 * Vt * Vt, Qr = Vt * Vt * Vt, ai = Math.PI / 180, jr = 180 / Math.PI;
                    function ri(R) {
                        return (R %= 360) < 0 && (R += 360), R;
                    }
                    function bi([R, S, D, j]) {
                        let te, ue, ve = Wi((.2225045 * (R = nn(R)) + .7168786 * (S = nn(S)) + .0606169 * (D = nn(D))) / 1);
                        R === S && S === D ? te = ue = ve : (te = Wi((.4360747 * R + .3850649 * S + .1430804 * D) / Se), ue = Wi((.0139322 * R + .0971045 * S + .7141733 * D) / lt));
                        let De = 116 * ve - 16;
                        return [
                            De < 0 ? 0 : De,
                            500 * (te - ve),
                            200 * (ve - ue),
                            j
                        ];
                    }
                    function nn(R) {
                        return R <= .04045 ? R / 12.92 : Math.pow((R + .055) / 1.055, 2.4);
                    }
                    function Wi(R) {
                        return R > Qr ? Math.pow(R, 1 / 3) : R / ar + Gt;
                    }
                    function Ni([R, S, D, j]) {
                        let te = (R + 16) / 116, ue = isNaN(S) ? te : te + S / 500, ve = isNaN(D) ? te : te - D / 200;
                        return te = 1 * $i(te), ue = Se * $i(ue), ve = lt * $i(ve), [
                            _n(3.1338561 * ue - 1.6168667 * te - .4906146 * ve),
                            _n(-0.9787684 * ue + 1.9161415 * te + .033454 * ve),
                            _n(.0719453 * ue - .2289914 * te + 1.4052427 * ve),
                            j
                        ];
                    }
                    function _n(R) {
                        return (R = R <= .00304 ? 12.92 * R : 1.055 * Math.pow(R, 1 / 2.4) - .055) < 0 ? 0 : R > 1 ? 1 : R;
                    }
                    function $i(R) {
                        return R > Vt ? R * R * R : ar * (R - Gt);
                    }
                    function zn(R) {
                        return parseInt(R.padEnd(2, R), 16) / 255;
                    }
                    function Wn(R, S) {
                        return It(S ? R / 100 : R, 0, 1);
                    }
                    function It(R, S, D) {
                        return Math.min(Math.max(S, R), D);
                    }
                    function ft(R) {
                        return !R.some(Number.isNaN);
                    }
                    let jt = {
                        aliceblue: [
                            240,
                            248,
                            255
                        ],
                        antiquewhite: [
                            250,
                            235,
                            215
                        ],
                        aqua: [
                            0,
                            255,
                            255
                        ],
                        aquamarine: [
                            127,
                            255,
                            212
                        ],
                        azure: [
                            240,
                            255,
                            255
                        ],
                        beige: [
                            245,
                            245,
                            220
                        ],
                        bisque: [
                            255,
                            228,
                            196
                        ],
                        black: [
                            0,
                            0,
                            0
                        ],
                        blanchedalmond: [
                            255,
                            235,
                            205
                        ],
                        blue: [
                            0,
                            0,
                            255
                        ],
                        blueviolet: [
                            138,
                            43,
                            226
                        ],
                        brown: [
                            165,
                            42,
                            42
                        ],
                        burlywood: [
                            222,
                            184,
                            135
                        ],
                        cadetblue: [
                            95,
                            158,
                            160
                        ],
                        chartreuse: [
                            127,
                            255,
                            0
                        ],
                        chocolate: [
                            210,
                            105,
                            30
                        ],
                        coral: [
                            255,
                            127,
                            80
                        ],
                        cornflowerblue: [
                            100,
                            149,
                            237
                        ],
                        cornsilk: [
                            255,
                            248,
                            220
                        ],
                        crimson: [
                            220,
                            20,
                            60
                        ],
                        cyan: [
                            0,
                            255,
                            255
                        ],
                        darkblue: [
                            0,
                            0,
                            139
                        ],
                        darkcyan: [
                            0,
                            139,
                            139
                        ],
                        darkgoldenrod: [
                            184,
                            134,
                            11
                        ],
                        darkgray: [
                            169,
                            169,
                            169
                        ],
                        darkgreen: [
                            0,
                            100,
                            0
                        ],
                        darkgrey: [
                            169,
                            169,
                            169
                        ],
                        darkkhaki: [
                            189,
                            183,
                            107
                        ],
                        darkmagenta: [
                            139,
                            0,
                            139
                        ],
                        darkolivegreen: [
                            85,
                            107,
                            47
                        ],
                        darkorange: [
                            255,
                            140,
                            0
                        ],
                        darkorchid: [
                            153,
                            50,
                            204
                        ],
                        darkred: [
                            139,
                            0,
                            0
                        ],
                        darksalmon: [
                            233,
                            150,
                            122
                        ],
                        darkseagreen: [
                            143,
                            188,
                            143
                        ],
                        darkslateblue: [
                            72,
                            61,
                            139
                        ],
                        darkslategray: [
                            47,
                            79,
                            79
                        ],
                        darkslategrey: [
                            47,
                            79,
                            79
                        ],
                        darkturquoise: [
                            0,
                            206,
                            209
                        ],
                        darkviolet: [
                            148,
                            0,
                            211
                        ],
                        deeppink: [
                            255,
                            20,
                            147
                        ],
                        deepskyblue: [
                            0,
                            191,
                            255
                        ],
                        dimgray: [
                            105,
                            105,
                            105
                        ],
                        dimgrey: [
                            105,
                            105,
                            105
                        ],
                        dodgerblue: [
                            30,
                            144,
                            255
                        ],
                        firebrick: [
                            178,
                            34,
                            34
                        ],
                        floralwhite: [
                            255,
                            250,
                            240
                        ],
                        forestgreen: [
                            34,
                            139,
                            34
                        ],
                        fuchsia: [
                            255,
                            0,
                            255
                        ],
                        gainsboro: [
                            220,
                            220,
                            220
                        ],
                        ghostwhite: [
                            248,
                            248,
                            255
                        ],
                        gold: [
                            255,
                            215,
                            0
                        ],
                        goldenrod: [
                            218,
                            165,
                            32
                        ],
                        gray: [
                            128,
                            128,
                            128
                        ],
                        green: [
                            0,
                            128,
                            0
                        ],
                        greenyellow: [
                            173,
                            255,
                            47
                        ],
                        grey: [
                            128,
                            128,
                            128
                        ],
                        honeydew: [
                            240,
                            255,
                            240
                        ],
                        hotpink: [
                            255,
                            105,
                            180
                        ],
                        indianred: [
                            205,
                            92,
                            92
                        ],
                        indigo: [
                            75,
                            0,
                            130
                        ],
                        ivory: [
                            255,
                            255,
                            240
                        ],
                        khaki: [
                            240,
                            230,
                            140
                        ],
                        lavender: [
                            230,
                            230,
                            250
                        ],
                        lavenderblush: [
                            255,
                            240,
                            245
                        ],
                        lawngreen: [
                            124,
                            252,
                            0
                        ],
                        lemonchiffon: [
                            255,
                            250,
                            205
                        ],
                        lightblue: [
                            173,
                            216,
                            230
                        ],
                        lightcoral: [
                            240,
                            128,
                            128
                        ],
                        lightcyan: [
                            224,
                            255,
                            255
                        ],
                        lightgoldenrodyellow: [
                            250,
                            250,
                            210
                        ],
                        lightgray: [
                            211,
                            211,
                            211
                        ],
                        lightgreen: [
                            144,
                            238,
                            144
                        ],
                        lightgrey: [
                            211,
                            211,
                            211
                        ],
                        lightpink: [
                            255,
                            182,
                            193
                        ],
                        lightsalmon: [
                            255,
                            160,
                            122
                        ],
                        lightseagreen: [
                            32,
                            178,
                            170
                        ],
                        lightskyblue: [
                            135,
                            206,
                            250
                        ],
                        lightslategray: [
                            119,
                            136,
                            153
                        ],
                        lightslategrey: [
                            119,
                            136,
                            153
                        ],
                        lightsteelblue: [
                            176,
                            196,
                            222
                        ],
                        lightyellow: [
                            255,
                            255,
                            224
                        ],
                        lime: [
                            0,
                            255,
                            0
                        ],
                        limegreen: [
                            50,
                            205,
                            50
                        ],
                        linen: [
                            250,
                            240,
                            230
                        ],
                        magenta: [
                            255,
                            0,
                            255
                        ],
                        maroon: [
                            128,
                            0,
                            0
                        ],
                        mediumaquamarine: [
                            102,
                            205,
                            170
                        ],
                        mediumblue: [
                            0,
                            0,
                            205
                        ],
                        mediumorchid: [
                            186,
                            85,
                            211
                        ],
                        mediumpurple: [
                            147,
                            112,
                            219
                        ],
                        mediumseagreen: [
                            60,
                            179,
                            113
                        ],
                        mediumslateblue: [
                            123,
                            104,
                            238
                        ],
                        mediumspringgreen: [
                            0,
                            250,
                            154
                        ],
                        mediumturquoise: [
                            72,
                            209,
                            204
                        ],
                        mediumvioletred: [
                            199,
                            21,
                            133
                        ],
                        midnightblue: [
                            25,
                            25,
                            112
                        ],
                        mintcream: [
                            245,
                            255,
                            250
                        ],
                        mistyrose: [
                            255,
                            228,
                            225
                        ],
                        moccasin: [
                            255,
                            228,
                            181
                        ],
                        navajowhite: [
                            255,
                            222,
                            173
                        ],
                        navy: [
                            0,
                            0,
                            128
                        ],
                        oldlace: [
                            253,
                            245,
                            230
                        ],
                        olive: [
                            128,
                            128,
                            0
                        ],
                        olivedrab: [
                            107,
                            142,
                            35
                        ],
                        orange: [
                            255,
                            165,
                            0
                        ],
                        orangered: [
                            255,
                            69,
                            0
                        ],
                        orchid: [
                            218,
                            112,
                            214
                        ],
                        palegoldenrod: [
                            238,
                            232,
                            170
                        ],
                        palegreen: [
                            152,
                            251,
                            152
                        ],
                        paleturquoise: [
                            175,
                            238,
                            238
                        ],
                        palevioletred: [
                            219,
                            112,
                            147
                        ],
                        papayawhip: [
                            255,
                            239,
                            213
                        ],
                        peachpuff: [
                            255,
                            218,
                            185
                        ],
                        peru: [
                            205,
                            133,
                            63
                        ],
                        pink: [
                            255,
                            192,
                            203
                        ],
                        plum: [
                            221,
                            160,
                            221
                        ],
                        powderblue: [
                            176,
                            224,
                            230
                        ],
                        purple: [
                            128,
                            0,
                            128
                        ],
                        rebeccapurple: [
                            102,
                            51,
                            153
                        ],
                        red: [
                            255,
                            0,
                            0
                        ],
                        rosybrown: [
                            188,
                            143,
                            143
                        ],
                        royalblue: [
                            65,
                            105,
                            225
                        ],
                        saddlebrown: [
                            139,
                            69,
                            19
                        ],
                        salmon: [
                            250,
                            128,
                            114
                        ],
                        sandybrown: [
                            244,
                            164,
                            96
                        ],
                        seagreen: [
                            46,
                            139,
                            87
                        ],
                        seashell: [
                            255,
                            245,
                            238
                        ],
                        sienna: [
                            160,
                            82,
                            45
                        ],
                        silver: [
                            192,
                            192,
                            192
                        ],
                        skyblue: [
                            135,
                            206,
                            235
                        ],
                        slateblue: [
                            106,
                            90,
                            205
                        ],
                        slategray: [
                            112,
                            128,
                            144
                        ],
                        slategrey: [
                            112,
                            128,
                            144
                        ],
                        snow: [
                            255,
                            250,
                            250
                        ],
                        springgreen: [
                            0,
                            255,
                            127
                        ],
                        steelblue: [
                            70,
                            130,
                            180
                        ],
                        tan: [
                            210,
                            180,
                            140
                        ],
                        teal: [
                            0,
                            128,
                            128
                        ],
                        thistle: [
                            216,
                            191,
                            216
                        ],
                        tomato: [
                            255,
                            99,
                            71
                        ],
                        turquoise: [
                            64,
                            224,
                            208
                        ],
                        violet: [
                            238,
                            130,
                            238
                        ],
                        wheat: [
                            245,
                            222,
                            179
                        ],
                        white: [
                            255,
                            255,
                            255
                        ],
                        whitesmoke: [
                            245,
                            245,
                            245
                        ],
                        yellow: [
                            255,
                            255,
                            0
                        ],
                        yellowgreen: [
                            154,
                            205,
                            50
                        ]
                    };
                    class Zt {
                        constructor(S, D, j, te = 1, ue = !0){
                            this.r = S, this.g = D, this.b = j, this.a = te, ue || (this.r *= te, this.g *= te, this.b *= te, te || this.overwriteGetter("rgb", [
                                S,
                                D,
                                j,
                                te
                            ]));
                        }
                        static parse(S) {
                            if (S instanceof Zt) return S;
                            if (typeof S != "string") return;
                            let D = function(j) {
                                if ((j = j.toLowerCase().trim()) === "transparent") return [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                let te = jt[j];
                                if (te) {
                                    let [ve, De, Ze] = te;
                                    return [
                                        ve / 255,
                                        De / 255,
                                        Ze / 255,
                                        1
                                    ];
                                }
                                if (j.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(j)) {
                                    let ve = j.length < 6 ? 1 : 2, De = 1;
                                    return [
                                        zn(j.slice(De, De += ve)),
                                        zn(j.slice(De, De += ve)),
                                        zn(j.slice(De, De += ve)),
                                        zn(j.slice(De, De + ve) || "ff")
                                    ];
                                }
                                if (j.startsWith("rgb")) {
                                    let ve = j.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                    if (ve) {
                                        let [De, Ze, at, Tt, Ft, Qt, sr, Tr, Pr, $r, ni, Di] = ve, pi = [
                                            Tt || " ",
                                            sr || " ",
                                            $r
                                        ].join("");
                                        if (pi === "  " || pi === "  /" || pi === ",," || pi === ",,,") {
                                            let ki = [
                                                at,
                                                Qt,
                                                Pr
                                            ].join(""), Zi = ki === "%%%" ? 100 : ki === "" ? 255 : 0;
                                            if (Zi) {
                                                let ta = [
                                                    It(+Ze / Zi, 0, 1),
                                                    It(+Ft / Zi, 0, 1),
                                                    It(+Tr / Zi, 0, 1),
                                                    ni ? Wn(+ni, Di) : 1
                                                ];
                                                if (ft(ta)) return ta;
                                            }
                                        }
                                        return;
                                    }
                                }
                                let ue = j.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                if (ue) {
                                    let [ve, De, Ze, at, Tt, Ft, Qt, sr, Tr] = ue, Pr = [
                                        Ze || " ",
                                        Tt || " ",
                                        Qt
                                    ].join("");
                                    if (Pr === "  " || Pr === "  /" || Pr === ",," || Pr === ",,,") {
                                        let $r = [
                                            +De,
                                            It(+at, 0, 100),
                                            It(+Ft, 0, 100),
                                            sr ? Wn(+sr, Tr) : 1
                                        ];
                                        if (ft($r)) return function([ni, Di, pi, ki]) {
                                            function Zi(ta) {
                                                let Va = (ta + ni / 30) % 12, Io = Di * Math.min(pi, 1 - pi);
                                                return pi - Io * Math.max(-1, Math.min(Va - 3, 9 - Va, 1));
                                            }
                                            return ni = ri(ni), Di /= 100, pi /= 100, [
                                                Zi(0),
                                                Zi(8),
                                                Zi(4),
                                                ki
                                            ];
                                        }($r);
                                    }
                                }
                            }(S);
                            return D ? new Zt(...D, !1) : void 0;
                        }
                        get rgb() {
                            let { r: S, g: D, b: j, a: te } = this, ue = te || 1 / 0;
                            return this.overwriteGetter("rgb", [
                                S / ue,
                                D / ue,
                                j / ue,
                                te
                            ]);
                        }
                        get hcl() {
                            return this.overwriteGetter("hcl", function(S) {
                                let [D, j, te, ue] = bi(S), ve = Math.sqrt(j * j + te * te);
                                return [
                                    Math.round(1e4 * ve) ? ri(Math.atan2(te, j) * jr) : NaN,
                                    ve,
                                    D,
                                    ue
                                ];
                            }(this.rgb));
                        }
                        get lab() {
                            return this.overwriteGetter("lab", bi(this.rgb));
                        }
                        overwriteGetter(S, D) {
                            return Object.defineProperty(this, S, {
                                value: D
                            }), D;
                        }
                        toString() {
                            let [S, D, j, te] = this.rgb;
                            return `rgba(${[
                                S,
                                D,
                                j
                            ].map((ue)=>Math.round(255 * ue)).join(",")},${te})`;
                        }
                    }
                    Zt.black = new Zt(0, 0, 0, 1), Zt.white = new Zt(1, 1, 1, 1), Zt.transparent = new Zt(0, 0, 0, 0), Zt.red = new Zt(1, 0, 0, 1);
                    class yr {
                        constructor(S, D, j){
                            this.sensitivity = S ? D ? "variant" : "case" : D ? "accent" : "base", this.locale = j, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                                sensitivity: this.sensitivity,
                                usage: "search"
                            });
                        }
                        compare(S, D) {
                            return this.collator.compare(S, D);
                        }
                        resolvedLocale() {
                            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
                        }
                    }
                    class Fr {
                        constructor(S, D, j, te, ue){
                            this.text = S, this.image = D, this.scale = j, this.fontStack = te, this.textColor = ue;
                        }
                    }
                    class Zr {
                        constructor(S){
                            this.sections = S;
                        }
                        static fromString(S) {
                            return new Zr([
                                new Fr(S, null, null, null, null)
                            ]);
                        }
                        isEmpty() {
                            return this.sections.length === 0 || !this.sections.some((S)=>S.text.length !== 0 || S.image && S.image.name.length !== 0);
                        }
                        static factory(S) {
                            return S instanceof Zr ? S : Zr.fromString(S);
                        }
                        toString() {
                            return this.sections.length === 0 ? "" : this.sections.map((S)=>S.text).join("");
                        }
                    }
                    class Vr {
                        constructor(S){
                            this.values = S.slice();
                        }
                        static parse(S) {
                            if (S instanceof Vr) return S;
                            if (typeof S == "number") return new Vr([
                                S,
                                S,
                                S,
                                S
                            ]);
                            if (Array.isArray(S) && !(S.length < 1 || S.length > 4)) {
                                for (let D of S)if (typeof D != "number") return;
                                switch(S.length){
                                    case 1:
                                        S = [
                                            S[0],
                                            S[0],
                                            S[0],
                                            S[0]
                                        ];
                                        break;
                                    case 2:
                                        S = [
                                            S[0],
                                            S[1],
                                            S[0],
                                            S[1]
                                        ];
                                        break;
                                    case 3:
                                        S = [
                                            S[0],
                                            S[1],
                                            S[2],
                                            S[1]
                                        ];
                                }
                                return new Vr(S);
                            }
                        }
                        toString() {
                            return JSON.stringify(this.values);
                        }
                    }
                    let gi = new Set([
                        "center",
                        "left",
                        "right",
                        "top",
                        "bottom",
                        "top-left",
                        "top-right",
                        "bottom-left",
                        "bottom-right"
                    ]);
                    class Si {
                        constructor(S){
                            this.values = S.slice();
                        }
                        static parse(S) {
                            if (S instanceof Si) return S;
                            if (Array.isArray(S) && !(S.length < 1) && S.length % 2 == 0) {
                                for(let D = 0; D < S.length; D += 2){
                                    let j = S[D], te = S[D + 1];
                                    if (typeof j != "string" || !gi.has(j) || !Array.isArray(te) || te.length !== 2 || typeof te[0] != "number" || typeof te[1] != "number") return;
                                }
                                return new Si(S);
                            }
                        }
                        toString() {
                            return JSON.stringify(this.values);
                        }
                    }
                    class Mi {
                        constructor(S){
                            this.name = S.name, this.available = S.available;
                        }
                        toString() {
                            return this.name;
                        }
                        static fromString(S) {
                            return S ? new Mi({
                                name: S,
                                available: !1
                            }) : null;
                        }
                    }
                    function Pi(R, S, D, j) {
                        return typeof R == "number" && R >= 0 && R <= 255 && typeof S == "number" && S >= 0 && S <= 255 && typeof D == "number" && D >= 0 && D <= 255 ? j === void 0 || typeof j == "number" && j >= 0 && j <= 1 ? null : `Invalid rgba value [${[
                            R,
                            S,
                            D,
                            j
                        ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${(typeof j == "number" ? [
                            R,
                            S,
                            D,
                            j
                        ] : [
                            R,
                            S,
                            D
                        ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
                    }
                    function Gi(R) {
                        if (R === null || typeof R == "string" || typeof R == "boolean" || typeof R == "number" || R instanceof Zt || R instanceof yr || R instanceof Zr || R instanceof Vr || R instanceof Si || R instanceof Mi) return !0;
                        if (Array.isArray(R)) {
                            for (let S of R)if (!Gi(S)) return !1;
                            return !0;
                        }
                        if (typeof R == "object") {
                            for(let S in R)if (!Gi(R[S])) return !1;
                            return !0;
                        }
                        return !1;
                    }
                    function Ki(R) {
                        if (R === null) return Lt;
                        if (typeof R == "string") return Et;
                        if (typeof R == "boolean") return dt;
                        if (typeof R == "number") return St;
                        if (R instanceof Zt) return Ht;
                        if (R instanceof yr) return _r;
                        if (R instanceof Zr) return Br;
                        if (R instanceof Vr) return Or;
                        if (R instanceof Si) return ut;
                        if (R instanceof Mi) return Nr;
                        if (Array.isArray(R)) {
                            let S = R.length, D;
                            for (let j of R){
                                let te = Ki(j);
                                if (D) {
                                    if (D === te) continue;
                                    D = fr;
                                    break;
                                }
                                D = te;
                            }
                            return Ne(D || fr, S);
                        }
                        return $t;
                    }
                    function ka(R) {
                        let S = typeof R;
                        return R === null ? "" : S === "string" || S === "number" || S === "boolean" ? String(R) : R instanceof Zt || R instanceof Zr || R instanceof Vr || R instanceof Si || R instanceof Mi ? R.toString() : JSON.stringify(R);
                    }
                    class jn {
                        constructor(S, D){
                            this.type = S, this.value = D;
                        }
                        static parse(S, D) {
                            if (S.length !== 2) return D.error(`'literal' expression requires exactly one argument, but found ${S.length - 1} instead.`);
                            if (!Gi(S[1])) return D.error("invalid value");
                            let j = S[1], te = Ki(j), ue = D.expectedType;
                            return te.kind !== "array" || te.N !== 0 || !ue || ue.kind !== "array" || typeof ue.N == "number" && ue.N !== 0 || (te = ue), new jn(te, j);
                        }
                        evaluate() {
                            return this.value;
                        }
                        eachChild() {}
                        outputDefined() {
                            return !0;
                        }
                    }
                    class la {
                        constructor(S){
                            this.name = "ExpressionEvaluationError", this.message = S;
                        }
                        toJSON() {
                            return this.message;
                        }
                    }
                    let Fa = {
                        string: Et,
                        number: St,
                        boolean: dt,
                        object: $t
                    };
                    class Ra {
                        constructor(S, D){
                            this.type = S, this.args = D;
                        }
                        static parse(S, D) {
                            if (S.length < 2) return D.error("Expected at least one argument.");
                            let j, te = 1, ue = S[0];
                            if (ue === "array") {
                                let De, Ze;
                                if (S.length > 2) {
                                    let at = S[1];
                                    if (typeof at != "string" || !(at in Fa) || at === "object") return D.error('The item type argument of "array" must be one of string, number, boolean', 1);
                                    De = Fa[at], te++;
                                } else De = fr;
                                if (S.length > 3) {
                                    if (S[2] !== null && (typeof S[2] != "number" || S[2] < 0 || S[2] !== Math.floor(S[2]))) return D.error('The length argument to "array" must be a positive integer literal', 2);
                                    Ze = S[2], te++;
                                }
                                j = Ne(De, Ze);
                            } else {
                                if (!Fa[ue]) throw new Error(`Types doesn't contain name = ${ue}`);
                                j = Fa[ue];
                            }
                            let ve = [];
                            for(; te < S.length; te++){
                                let De = D.parse(S[te], te, fr);
                                if (!De) return null;
                                ve.push(De);
                            }
                            return new Ra(j, ve);
                        }
                        evaluate(S) {
                            for(let D = 0; D < this.args.length; D++){
                                let j = this.args[D].evaluate(S);
                                if (!Xe(this.type, Ki(j))) return j;
                                if (D === this.args.length - 1) throw new la(`Expected value to be of type ${Ye(this.type)}, but found ${Ye(Ki(j))} instead.`);
                            }
                            throw new Error;
                        }
                        eachChild(S) {
                            this.args.forEach(S);
                        }
                        outputDefined() {
                            return this.args.every((S)=>S.outputDefined());
                        }
                    }
                    let jo = {
                        "to-boolean": dt,
                        "to-color": Ht,
                        "to-number": St,
                        "to-string": Et
                    };
                    class oa {
                        constructor(S, D){
                            this.type = S, this.args = D;
                        }
                        static parse(S, D) {
                            if (S.length < 2) return D.error("Expected at least one argument.");
                            let j = S[0];
                            if (!jo[j]) throw new Error(`Can't parse ${j} as it is not part of the known types`);
                            if ((j === "to-boolean" || j === "to-string") && S.length !== 2) return D.error("Expected one argument.");
                            let te = jo[j], ue = [];
                            for(let ve = 1; ve < S.length; ve++){
                                let De = D.parse(S[ve], ve, fr);
                                if (!De) return null;
                                ue.push(De);
                            }
                            return new oa(te, ue);
                        }
                        evaluate(S) {
                            switch(this.type.kind){
                                case "boolean":
                                    return !!this.args[0].evaluate(S);
                                case "color":
                                    {
                                        let D, j;
                                        for (let te of this.args){
                                            if (D = te.evaluate(S), j = null, D instanceof Zt) return D;
                                            if (typeof D == "string") {
                                                let ue = S.parseColor(D);
                                                if (ue) return ue;
                                            } else if (Array.isArray(D) && (j = D.length < 3 || D.length > 4 ? `Invalid rbga value ${JSON.stringify(D)}: expected an array containing either three or four numeric values.` : Pi(D[0], D[1], D[2], D[3]), !j)) return new Zt(D[0] / 255, D[1] / 255, D[2] / 255, D[3]);
                                        }
                                        throw new la(j || `Could not parse color from value '${typeof D == "string" ? D : JSON.stringify(D)}'`);
                                    }
                                case "padding":
                                    {
                                        let D;
                                        for (let j of this.args){
                                            D = j.evaluate(S);
                                            let te = Vr.parse(D);
                                            if (te) return te;
                                        }
                                        throw new la(`Could not parse padding from value '${typeof D == "string" ? D : JSON.stringify(D)}'`);
                                    }
                                case "variableAnchorOffsetCollection":
                                    {
                                        let D;
                                        for (let j of this.args){
                                            D = j.evaluate(S);
                                            let te = Si.parse(D);
                                            if (te) return te;
                                        }
                                        throw new la(`Could not parse variableAnchorOffsetCollection from value '${typeof D == "string" ? D : JSON.stringify(D)}'`);
                                    }
                                case "number":
                                    {
                                        let D = null;
                                        for (let j of this.args){
                                            if (D = j.evaluate(S), D === null) return 0;
                                            let te = Number(D);
                                            if (!isNaN(te)) return te;
                                        }
                                        throw new la(`Could not convert ${JSON.stringify(D)} to number.`);
                                    }
                                case "formatted":
                                    return Zr.fromString(ka(this.args[0].evaluate(S)));
                                case "resolvedImage":
                                    return Mi.fromString(ka(this.args[0].evaluate(S)));
                                default:
                                    return ka(this.args[0].evaluate(S));
                            }
                        }
                        eachChild(S) {
                            this.args.forEach(S);
                        }
                        outputDefined() {
                            return this.args.every((S)=>S.outputDefined());
                        }
                    }
                    let Sn = [
                        "Unknown",
                        "Point",
                        "LineString",
                        "Polygon"
                    ];
                    class Ha {
                        constructor(){
                            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null;
                        }
                        id() {
                            return this.feature && "id" in this.feature ? this.feature.id : null;
                        }
                        geometryType() {
                            return this.feature ? typeof this.feature.type == "number" ? Sn[this.feature.type] : this.feature.type : null;
                        }
                        geometry() {
                            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
                        }
                        canonicalID() {
                            return this.canonical;
                        }
                        properties() {
                            return this.feature && this.feature.properties || {};
                        }
                        parseColor(S) {
                            let D = this._parseColorCache[S];
                            return D || (D = this._parseColorCache[S] = Zt.parse(S)), D;
                        }
                    }
                    class oo {
                        constructor(S, D, j = [], te, ue = new bt, ve = []){
                            this.registry = S, this.path = j, this.key = j.map((De)=>`[${De}]`).join(""), this.scope = ue, this.errors = ve, this.expectedType = te, this._isConstant = D;
                        }
                        parse(S, D, j, te, ue = {}) {
                            return D ? this.concat(D, j, te)._parse(S, ue) : this._parse(S, ue);
                        }
                        _parse(S, D) {
                            function j(te, ue, ve) {
                                return ve === "assert" ? new Ra(ue, [
                                    te
                                ]) : ve === "coerce" ? new oa(ue, [
                                    te
                                ]) : te;
                            }
                            if (S !== null && typeof S != "string" && typeof S != "boolean" && typeof S != "number" || (S = [
                                "literal",
                                S
                            ]), Array.isArray(S)) {
                                if (S.length === 0) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                                let te = S[0];
                                if (typeof te != "string") return this.error(`Expression name must be a string, but found ${typeof te} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                                let ue = this.registry[te];
                                if (ue) {
                                    let ve = ue.parse(S, this);
                                    if (!ve) return null;
                                    if (this.expectedType) {
                                        let De = this.expectedType, Ze = ve.type;
                                        if (De.kind !== "string" && De.kind !== "number" && De.kind !== "boolean" && De.kind !== "object" && De.kind !== "array" || Ze.kind !== "value") {
                                            if (De.kind !== "color" && De.kind !== "formatted" && De.kind !== "resolvedImage" || Ze.kind !== "value" && Ze.kind !== "string") {
                                                if (De.kind !== "padding" || Ze.kind !== "value" && Ze.kind !== "number" && Ze.kind !== "array") {
                                                    if (De.kind !== "variableAnchorOffsetCollection" || Ze.kind !== "value" && Ze.kind !== "array") {
                                                        if (this.checkSubtype(De, Ze)) return null;
                                                    } else ve = j(ve, De, D.typeAnnotation || "coerce");
                                                } else ve = j(ve, De, D.typeAnnotation || "coerce");
                                            } else ve = j(ve, De, D.typeAnnotation || "coerce");
                                        } else ve = j(ve, De, D.typeAnnotation || "assert");
                                    }
                                    if (!(ve instanceof jn) && ve.type.kind !== "resolvedImage" && this._isConstant(ve)) {
                                        let De = new Ha;
                                        try {
                                            ve = new jn(ve.type, ve.evaluate(De));
                                        } catch (Ze) {
                                            return this.error(Ze.message), null;
                                        }
                                    }
                                    return ve;
                                }
                                return this.error(`Unknown expression "${te}". If you wanted a literal array, use ["literal", [...]].`, 0);
                            }
                            return this.error(S === void 0 ? "'undefined' value invalid. Use null instead." : typeof S == "object" ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof S} instead.`);
                        }
                        concat(S, D, j) {
                            let te = typeof S == "number" ? this.path.concat(S) : this.path, ue = j ? this.scope.concat(j) : this.scope;
                            return new oo(this.registry, this._isConstant, te, D || null, ue, this.errors);
                        }
                        error(S, ...D) {
                            let j = `${this.key}${D.map((te)=>`[${te}]`).join("")}`;
                            this.errors.push(new xt(j, S));
                        }
                        checkSubtype(S, D) {
                            let j = Xe(S, D);
                            return j && this.error(j), j;
                        }
                    }
                    class xn {
                        constructor(S, D){
                            this.type = D.type, this.bindings = [].concat(S), this.result = D;
                        }
                        evaluate(S) {
                            return this.result.evaluate(S);
                        }
                        eachChild(S) {
                            for (let D of this.bindings)S(D[1]);
                            S(this.result);
                        }
                        static parse(S, D) {
                            if (S.length < 4) return D.error(`Expected at least 3 arguments, but found ${S.length - 1} instead.`);
                            let j = [];
                            for(let ue = 1; ue < S.length - 1; ue += 2){
                                let ve = S[ue];
                                if (typeof ve != "string") return D.error(`Expected string, but found ${typeof ve} instead.`, ue);
                                if (/[^a-zA-Z0-9_]/.test(ve)) return D.error("Variable names must contain only alphanumeric characters or '_'.", ue);
                                let De = D.parse(S[ue + 1], ue + 1);
                                if (!De) return null;
                                j.push([
                                    ve,
                                    De
                                ]);
                            }
                            let te = D.parse(S[S.length - 1], S.length - 1, D.expectedType, j);
                            return te ? new xn(j, te) : null;
                        }
                        outputDefined() {
                            return this.result.outputDefined();
                        }
                    }
                    class _t {
                        constructor(S, D){
                            this.type = D.type, this.name = S, this.boundExpression = D;
                        }
                        static parse(S, D) {
                            if (S.length !== 2 || typeof S[1] != "string") return D.error("'var' expression requires exactly one string literal argument.");
                            let j = S[1];
                            return D.scope.has(j) ? new _t(j, D.scope.get(j)) : D.error(`Unknown variable "${j}". Make sure "${j}" has been bound in an enclosing "let" expression before using it.`, 1);
                        }
                        evaluate(S) {
                            return this.boundExpression.evaluate(S);
                        }
                        eachChild() {}
                        outputDefined() {
                            return !1;
                        }
                    }
                    class br {
                        constructor(S, D, j){
                            this.type = S, this.index = D, this.input = j;
                        }
                        static parse(S, D) {
                            if (S.length !== 3) return D.error(`Expected 2 arguments, but found ${S.length - 1} instead.`);
                            let j = D.parse(S[1], 1, St), te = D.parse(S[2], 2, Ne(D.expectedType || fr));
                            return j && te ? new br(te.type.itemType, j, te) : null;
                        }
                        evaluate(S) {
                            let D = this.index.evaluate(S), j = this.input.evaluate(S);
                            if (D < 0) throw new la(`Array index out of bounds: ${D} < 0.`);
                            if (D >= j.length) throw new la(`Array index out of bounds: ${D} > ${j.length - 1}.`);
                            if (D !== Math.floor(D)) throw new la(`Array index must be an integer, but found ${D} instead.`);
                            return j[D];
                        }
                        eachChild(S) {
                            S(this.index), S(this.input);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Hr {
                        constructor(S, D){
                            this.type = dt, this.needle = S, this.haystack = D;
                        }
                        static parse(S, D) {
                            if (S.length !== 3) return D.error(`Expected 2 arguments, but found ${S.length - 1} instead.`);
                            let j = D.parse(S[1], 1, fr), te = D.parse(S[2], 2, fr);
                            return j && te ? ht(j.type, [
                                dt,
                                Et,
                                St,
                                Lt,
                                fr
                            ]) ? new Hr(j, te) : D.error(`Expected first argument to be of type boolean, string, number or null, but found ${Ye(j.type)} instead`) : null;
                        }
                        evaluate(S) {
                            let D = this.needle.evaluate(S), j = this.haystack.evaluate(S);
                            if (!j) return !1;
                            if (!Le(D, [
                                "boolean",
                                "string",
                                "number",
                                "null"
                            ])) throw new la(`Expected first argument to be of type boolean, string, number or null, but found ${Ye(Ki(D))} instead.`);
                            if (!Le(j, [
                                "string",
                                "array"
                            ])) throw new la(`Expected second argument to be of type array or string, but found ${Ye(Ki(j))} instead.`);
                            return j.indexOf(D) >= 0;
                        }
                        eachChild(S) {
                            S(this.needle), S(this.haystack);
                        }
                        outputDefined() {
                            return !0;
                        }
                    }
                    class ti {
                        constructor(S, D, j){
                            this.type = St, this.needle = S, this.haystack = D, this.fromIndex = j;
                        }
                        static parse(S, D) {
                            if (S.length <= 2 || S.length >= 5) return D.error(`Expected 3 or 4 arguments, but found ${S.length - 1} instead.`);
                            let j = D.parse(S[1], 1, fr), te = D.parse(S[2], 2, fr);
                            if (!j || !te) return null;
                            if (!ht(j.type, [
                                dt,
                                Et,
                                St,
                                Lt,
                                fr
                            ])) return D.error(`Expected first argument to be of type boolean, string, number or null, but found ${Ye(j.type)} instead`);
                            if (S.length === 4) {
                                let ue = D.parse(S[3], 3, St);
                                return ue ? new ti(j, te, ue) : null;
                            }
                            return new ti(j, te);
                        }
                        evaluate(S) {
                            let D = this.needle.evaluate(S), j = this.haystack.evaluate(S);
                            if (!Le(D, [
                                "boolean",
                                "string",
                                "number",
                                "null"
                            ])) throw new la(`Expected first argument to be of type boolean, string, number or null, but found ${Ye(Ki(D))} instead.`);
                            let te;
                            if (this.fromIndex && (te = this.fromIndex.evaluate(S)), Le(j, [
                                "string"
                            ])) {
                                let ue = j.indexOf(D, te);
                                return ue === -1 ? -1 : [
                                    ...j.slice(0, ue)
                                ].length;
                            }
                            if (Le(j, [
                                "array"
                            ])) return j.indexOf(D, te);
                            throw new la(`Expected second argument to be of type array or string, but found ${Ye(Ki(j))} instead.`);
                        }
                        eachChild(S) {
                            S(this.needle), S(this.haystack), this.fromIndex && S(this.fromIndex);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class zi {
                        constructor(S, D, j, te, ue, ve){
                            this.inputType = S, this.type = D, this.input = j, this.cases = te, this.outputs = ue, this.otherwise = ve;
                        }
                        static parse(S, D) {
                            if (S.length < 5) return D.error(`Expected at least 4 arguments, but found only ${S.length - 1}.`);
                            if (S.length % 2 != 1) return D.error("Expected an even number of arguments.");
                            let j, te;
                            D.expectedType && D.expectedType.kind !== "value" && (te = D.expectedType);
                            let ue = {}, ve = [];
                            for(let at = 2; at < S.length - 1; at += 2){
                                let Tt = S[at], Ft = S[at + 1];
                                Array.isArray(Tt) || (Tt = [
                                    Tt
                                ]);
                                let Qt = D.concat(at);
                                if (Tt.length === 0) return Qt.error("Expected at least one branch label.");
                                for (let Tr of Tt){
                                    if (typeof Tr != "number" && typeof Tr != "string") return Qt.error("Branch labels must be numbers or strings.");
                                    if (typeof Tr == "number" && Math.abs(Tr) > Number.MAX_SAFE_INTEGER) return Qt.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                                    if (typeof Tr == "number" && Math.floor(Tr) !== Tr) return Qt.error("Numeric branch labels must be integer values.");
                                    if (j) {
                                        if (Qt.checkSubtype(j, Ki(Tr))) return null;
                                    } else j = Ki(Tr);
                                    if (ue[String(Tr)] !== void 0) return Qt.error("Branch labels must be unique.");
                                    ue[String(Tr)] = ve.length;
                                }
                                let sr = D.parse(Ft, at, te);
                                if (!sr) return null;
                                te = te || sr.type, ve.push(sr);
                            }
                            let De = D.parse(S[1], 1, fr);
                            if (!De) return null;
                            let Ze = D.parse(S[S.length - 1], S.length - 1, te);
                            return Ze ? De.type.kind !== "value" && D.concat(1).checkSubtype(j, De.type) ? null : new zi(j, te, De, ue, ve, Ze) : null;
                        }
                        evaluate(S) {
                            let D = this.input.evaluate(S);
                            return (Ki(D) === this.inputType && this.outputs[this.cases[D]] || this.otherwise).evaluate(S);
                        }
                        eachChild(S) {
                            S(this.input), this.outputs.forEach(S), S(this.otherwise);
                        }
                        outputDefined() {
                            return this.outputs.every((S)=>S.outputDefined()) && this.otherwise.outputDefined();
                        }
                    }
                    class Yi {
                        constructor(S, D, j){
                            this.type = S, this.branches = D, this.otherwise = j;
                        }
                        static parse(S, D) {
                            if (S.length < 4) return D.error(`Expected at least 3 arguments, but found only ${S.length - 1}.`);
                            if (S.length % 2 != 0) return D.error("Expected an odd number of arguments.");
                            let j;
                            D.expectedType && D.expectedType.kind !== "value" && (j = D.expectedType);
                            let te = [];
                            for(let ve = 1; ve < S.length - 1; ve += 2){
                                let De = D.parse(S[ve], ve, dt);
                                if (!De) return null;
                                let Ze = D.parse(S[ve + 1], ve + 1, j);
                                if (!Ze) return null;
                                te.push([
                                    De,
                                    Ze
                                ]), j = j || Ze.type;
                            }
                            let ue = D.parse(S[S.length - 1], S.length - 1, j);
                            if (!ue) return null;
                            if (!j) throw new Error("Can't infer output type");
                            return new Yi(j, te, ue);
                        }
                        evaluate(S) {
                            for (let [D, j] of this.branches)if (D.evaluate(S)) return j.evaluate(S);
                            return this.otherwise.evaluate(S);
                        }
                        eachChild(S) {
                            for (let [D, j] of this.branches)S(D), S(j);
                            S(this.otherwise);
                        }
                        outputDefined() {
                            return this.branches.every(([S, D])=>D.outputDefined()) && this.otherwise.outputDefined();
                        }
                    }
                    class an {
                        constructor(S, D, j, te){
                            this.type = S, this.input = D, this.beginIndex = j, this.endIndex = te;
                        }
                        static parse(S, D) {
                            if (S.length <= 2 || S.length >= 5) return D.error(`Expected 3 or 4 arguments, but found ${S.length - 1} instead.`);
                            let j = D.parse(S[1], 1, fr), te = D.parse(S[2], 2, St);
                            if (!j || !te) return null;
                            if (!ht(j.type, [
                                Ne(fr),
                                Et,
                                fr
                            ])) return D.error(`Expected first argument to be of type array or string, but found ${Ye(j.type)} instead`);
                            if (S.length === 4) {
                                let ue = D.parse(S[3], 3, St);
                                return ue ? new an(j.type, j, te, ue) : null;
                            }
                            return new an(j.type, j, te);
                        }
                        evaluate(S) {
                            let D = this.input.evaluate(S), j = this.beginIndex.evaluate(S), te;
                            if (this.endIndex && (te = this.endIndex.evaluate(S)), Le(D, [
                                "string"
                            ])) return [
                                ...D
                            ].slice(j, te).join("");
                            if (Le(D, [
                                "array"
                            ])) return D.slice(j, te);
                            throw new la(`Expected first argument to be of type array or string, but found ${Ye(Ki(D))} instead.`);
                        }
                        eachChild(S) {
                            S(this.input), S(this.beginIndex), this.endIndex && S(this.endIndex);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    function hi(R, S) {
                        let D = R.length - 1, j, te, ue = 0, ve = D, De = 0;
                        for(; ue <= ve;)if (De = Math.floor((ue + ve) / 2), j = R[De], te = R[De + 1], j <= S) {
                            if (De === D || S < te) return De;
                            ue = De + 1;
                        } else {
                            if (!(j > S)) throw new la("Input is not a number.");
                            ve = De - 1;
                        }
                        return 0;
                    }
                    class Ji {
                        constructor(S, D, j){
                            this.type = S, this.input = D, this.labels = [], this.outputs = [];
                            for (let [te, ue] of j)this.labels.push(te), this.outputs.push(ue);
                        }
                        static parse(S, D) {
                            if (S.length - 1 < 4) return D.error(`Expected at least 4 arguments, but found only ${S.length - 1}.`);
                            if ((S.length - 1) % 2 != 0) return D.error("Expected an even number of arguments.");
                            let j = D.parse(S[1], 1, St);
                            if (!j) return null;
                            let te = [], ue = null;
                            D.expectedType && D.expectedType.kind !== "value" && (ue = D.expectedType);
                            for(let ve = 1; ve < S.length; ve += 2){
                                let De = ve === 1 ? -1 / 0 : S[ve], Ze = S[ve + 1], at = ve, Tt = ve + 1;
                                if (typeof De != "number") return D.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', at);
                                if (te.length && te[te.length - 1][0] >= De) return D.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', at);
                                let Ft = D.parse(Ze, Tt, ue);
                                if (!Ft) return null;
                                ue = ue || Ft.type, te.push([
                                    De,
                                    Ft
                                ]);
                            }
                            return new Ji(ue, j, te);
                        }
                        evaluate(S) {
                            let D = this.labels, j = this.outputs;
                            if (D.length === 1) return j[0].evaluate(S);
                            let te = this.input.evaluate(S);
                            if (te <= D[0]) return j[0].evaluate(S);
                            let ue = D.length;
                            return te >= D[ue - 1] ? j[ue - 1].evaluate(S) : j[hi(D, te)].evaluate(S);
                        }
                        eachChild(S) {
                            S(this.input);
                            for (let D of this.outputs)S(D);
                        }
                        outputDefined() {
                            return this.outputs.every((S)=>S.outputDefined());
                        }
                    }
                    function ua(R) {
                        return R && R.__esModule && Object.prototype.hasOwnProperty.call(R, "default") ? R.default : R;
                    }
                    var Fn = Sa;
                    function Sa(R, S, D, j) {
                        this.cx = 3 * R, this.bx = 3 * (D - R) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * S, this.by = 3 * (j - S) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = R, this.p1y = S, this.p2x = D, this.p2y = j;
                    }
                    Sa.prototype = {
                        sampleCurveX: function(R) {
                            return ((this.ax * R + this.bx) * R + this.cx) * R;
                        },
                        sampleCurveY: function(R) {
                            return ((this.ay * R + this.by) * R + this.cy) * R;
                        },
                        sampleCurveDerivativeX: function(R) {
                            return (3 * this.ax * R + 2 * this.bx) * R + this.cx;
                        },
                        solveCurveX: function(R, S) {
                            if (S === void 0 && (S = 1e-6), R < 0) return 0;
                            if (R > 1) return 1;
                            for(var D = R, j = 0; j < 8; j++){
                                var te = this.sampleCurveX(D) - R;
                                if (Math.abs(te) < S) return D;
                                var ue = this.sampleCurveDerivativeX(D);
                                if (Math.abs(ue) < 1e-6) break;
                                D -= te / ue;
                            }
                            var ve = 0, De = 1;
                            for(D = R, j = 0; j < 20 && (te = this.sampleCurveX(D), !(Math.abs(te - R) < S)); j++)R > te ? ve = D : De = D, D = .5 * (De - ve) + ve;
                            return D;
                        },
                        solve: function(R, S) {
                            return this.sampleCurveY(this.solveCurveX(R, S));
                        }
                    };
                    var go = ua(Fn);
                    function Oo(R, S, D) {
                        return R + D * (S - R);
                    }
                    function ho(R, S, D) {
                        return R.map((j, te)=>Oo(j, S[te], D));
                    }
                    let Mo = {
                        number: Oo,
                        color: function(R, S, D, j = "rgb") {
                            switch(j){
                                case "rgb":
                                    {
                                        let [te, ue, ve, De] = ho(R.rgb, S.rgb, D);
                                        return new Zt(te, ue, ve, De, !1);
                                    }
                                case "hcl":
                                    {
                                        let [te, ue, ve, De] = R.hcl, [Ze, at, Tt, Ft] = S.hcl, Qt, sr;
                                        if (isNaN(te) || isNaN(Ze)) isNaN(te) ? isNaN(Ze) ? Qt = NaN : (Qt = Ze, ve !== 1 && ve !== 0 || (sr = at)) : (Qt = te, Tt !== 1 && Tt !== 0 || (sr = ue));
                                        else {
                                            let Di = Ze - te;
                                            Ze > te && Di > 180 ? Di -= 360 : Ze < te && te - Ze > 180 && (Di += 360), Qt = te + D * Di;
                                        }
                                        let [Tr, Pr, $r, ni] = function([Di, pi, ki, Zi]) {
                                            return Di = isNaN(Di) ? 0 : Di * ai, Ni([
                                                ki,
                                                Math.cos(Di) * pi,
                                                Math.sin(Di) * pi,
                                                Zi
                                            ]);
                                        }([
                                            Qt,
                                            sr != null ? sr : Oo(ue, at, D),
                                            Oo(ve, Tt, D),
                                            Oo(De, Ft, D)
                                        ]);
                                        return new Zt(Tr, Pr, $r, ni, !1);
                                    }
                                case "lab":
                                    {
                                        let [te, ue, ve, De] = Ni(ho(R.lab, S.lab, D));
                                        return new Zt(te, ue, ve, De, !1);
                                    }
                            }
                        },
                        array: ho,
                        padding: function(R, S, D) {
                            return new Vr(ho(R.values, S.values, D));
                        },
                        variableAnchorOffsetCollection: function(R, S, D) {
                            let j = R.values, te = S.values;
                            if (j.length !== te.length) throw new la(`Cannot interpolate values of different length. from: ${R.toString()}, to: ${S.toString()}`);
                            let ue = [];
                            for(let ve = 0; ve < j.length; ve += 2){
                                if (j[ve] !== te[ve]) throw new la(`Cannot interpolate values containing mismatched anchors. from[${ve}]: ${j[ve]}, to[${ve}]: ${te[ve]}`);
                                ue.push(j[ve]);
                                let [De, Ze] = j[ve + 1], [at, Tt] = te[ve + 1];
                                ue.push([
                                    Oo(De, at, D),
                                    Oo(Ze, Tt, D)
                                ]);
                            }
                            return new Si(ue);
                        }
                    };
                    class xo {
                        constructor(S, D, j, te, ue){
                            this.type = S, this.operator = D, this.interpolation = j, this.input = te, this.labels = [], this.outputs = [];
                            for (let [ve, De] of ue)this.labels.push(ve), this.outputs.push(De);
                        }
                        static interpolationFactor(S, D, j, te) {
                            let ue = 0;
                            if (S.name === "exponential") ue = zs(D, S.base, j, te);
                            else if (S.name === "linear") ue = zs(D, 1, j, te);
                            else if (S.name === "cubic-bezier") {
                                let ve = S.controlPoints;
                                ue = new go(ve[0], ve[1], ve[2], ve[3]).solve(zs(D, 1, j, te));
                            }
                            return ue;
                        }
                        static parse(S, D) {
                            let [j, te, ue, ...ve] = S;
                            if (!Array.isArray(te) || te.length === 0) return D.error("Expected an interpolation type expression.", 1);
                            if (te[0] === "linear") te = {
                                name: "linear"
                            };
                            else if (te[0] === "exponential") {
                                let at = te[1];
                                if (typeof at != "number") return D.error("Exponential interpolation requires a numeric base.", 1, 1);
                                te = {
                                    name: "exponential",
                                    base: at
                                };
                            } else {
                                if (te[0] !== "cubic-bezier") return D.error(`Unknown interpolation type ${String(te[0])}`, 1, 0);
                                {
                                    let at = te.slice(1);
                                    if (at.length !== 4 || at.some((Tt)=>typeof Tt != "number" || Tt < 0 || Tt > 1)) return D.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                                    te = {
                                        name: "cubic-bezier",
                                        controlPoints: at
                                    };
                                }
                            }
                            if (S.length - 1 < 4) return D.error(`Expected at least 4 arguments, but found only ${S.length - 1}.`);
                            if ((S.length - 1) % 2 != 0) return D.error("Expected an even number of arguments.");
                            if (ue = D.parse(ue, 2, St), !ue) return null;
                            let De = [], Ze = null;
                            j === "interpolate-hcl" || j === "interpolate-lab" ? Ze = Ht : D.expectedType && D.expectedType.kind !== "value" && (Ze = D.expectedType);
                            for(let at = 0; at < ve.length; at += 2){
                                let Tt = ve[at], Ft = ve[at + 1], Qt = at + 3, sr = at + 4;
                                if (typeof Tt != "number") return D.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', Qt);
                                if (De.length && De[De.length - 1][0] >= Tt) return D.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', Qt);
                                let Tr = D.parse(Ft, sr, Ze);
                                if (!Tr) return null;
                                Ze = Ze || Tr.type, De.push([
                                    Tt,
                                    Tr
                                ]);
                            }
                            return xe(Ze, St) || xe(Ze, Ht) || xe(Ze, Or) || xe(Ze, ut) || xe(Ze, Ne(St)) ? new xo(Ze, j, te, ue, De) : D.error(`Type ${Ye(Ze)} is not interpolatable.`);
                        }
                        evaluate(S) {
                            let D = this.labels, j = this.outputs;
                            if (D.length === 1) return j[0].evaluate(S);
                            let te = this.input.evaluate(S);
                            if (te <= D[0]) return j[0].evaluate(S);
                            let ue = D.length;
                            if (te >= D[ue - 1]) return j[ue - 1].evaluate(S);
                            let ve = hi(D, te), De = xo.interpolationFactor(this.interpolation, te, D[ve], D[ve + 1]), Ze = j[ve].evaluate(S), at = j[ve + 1].evaluate(S);
                            switch(this.operator){
                                case "interpolate":
                                    return Mo[this.type.kind](Ze, at, De);
                                case "interpolate-hcl":
                                    return Mo.color(Ze, at, De, "hcl");
                                case "interpolate-lab":
                                    return Mo.color(Ze, at, De, "lab");
                            }
                        }
                        eachChild(S) {
                            S(this.input);
                            for (let D of this.outputs)S(D);
                        }
                        outputDefined() {
                            return this.outputs.every((S)=>S.outputDefined());
                        }
                    }
                    function zs(R, S, D, j) {
                        let te = j - D, ue = R - D;
                        return te === 0 ? 0 : S === 1 ? ue / te : (Math.pow(S, ue) - 1) / (Math.pow(S, te) - 1);
                    }
                    class ks {
                        constructor(S, D){
                            this.type = S, this.args = D;
                        }
                        static parse(S, D) {
                            if (S.length < 2) return D.error("Expectected at least one argument.");
                            let j = null, te = D.expectedType;
                            te && te.kind !== "value" && (j = te);
                            let ue = [];
                            for (let De of S.slice(1)){
                                let Ze = D.parse(De, 1 + ue.length, j, void 0, {
                                    typeAnnotation: "omit"
                                });
                                if (!Ze) return null;
                                j = j || Ze.type, ue.push(Ze);
                            }
                            if (!j) throw new Error("No output type");
                            let ve = te && ue.some((De)=>Xe(te, De.type));
                            return new ks(ve ? fr : j, ue);
                        }
                        evaluate(S) {
                            let D, j = null, te = 0;
                            for (let ue of this.args)if (te++, j = ue.evaluate(S), j && j instanceof Mi && !j.available && (D || (D = j.name), j = null, te === this.args.length && (j = D)), j !== null) break;
                            return j;
                        }
                        eachChild(S) {
                            this.args.forEach(S);
                        }
                        outputDefined() {
                            return this.args.every((S)=>S.outputDefined());
                        }
                    }
                    function Zs(R, S) {
                        return R === "==" || R === "!=" ? S.kind === "boolean" || S.kind === "string" || S.kind === "number" || S.kind === "null" || S.kind === "value" : S.kind === "string" || S.kind === "number" || S.kind === "value";
                    }
                    function Xs(R, S, D, j) {
                        return j.compare(S, D) === 0;
                    }
                    function wl(R, S, D) {
                        let j = R !== "==" && R !== "!=";
                        return class GHe {
                            constructor(ue, ve, De){
                                this.type = dt, this.lhs = ue, this.rhs = ve, this.collator = De, this.hasUntypedArgument = ue.type.kind === "value" || ve.type.kind === "value";
                            }
                            static parse(ue, ve) {
                                if (ue.length !== 3 && ue.length !== 4) return ve.error("Expected two or three arguments.");
                                let De = ue[0], Ze = ve.parse(ue[1], 1, fr);
                                if (!Ze) return null;
                                if (!Zs(De, Ze.type)) return ve.concat(1).error(`"${De}" comparisons are not supported for type '${Ye(Ze.type)}'.`);
                                let at = ve.parse(ue[2], 2, fr);
                                if (!at) return null;
                                if (!Zs(De, at.type)) return ve.concat(2).error(`"${De}" comparisons are not supported for type '${Ye(at.type)}'.`);
                                if (Ze.type.kind !== at.type.kind && Ze.type.kind !== "value" && at.type.kind !== "value") return ve.error(`Cannot compare types '${Ye(Ze.type)}' and '${Ye(at.type)}'.`);
                                j && (Ze.type.kind === "value" && at.type.kind !== "value" ? Ze = new Ra(at.type, [
                                    Ze
                                ]) : Ze.type.kind !== "value" && at.type.kind === "value" && (at = new Ra(Ze.type, [
                                    at
                                ])));
                                let Tt = null;
                                if (ue.length === 4) {
                                    if (Ze.type.kind !== "string" && at.type.kind !== "string" && Ze.type.kind !== "value" && at.type.kind !== "value") return ve.error("Cannot use collator to compare non-string types.");
                                    if (Tt = ve.parse(ue[3], 3, _r), !Tt) return null;
                                }
                                return new GHe(Ze, at, Tt);
                            }
                            evaluate(ue) {
                                let ve = this.lhs.evaluate(ue), De = this.rhs.evaluate(ue);
                                if (j && this.hasUntypedArgument) {
                                    let Ze = Ki(ve), at = Ki(De);
                                    if (Ze.kind !== at.kind || Ze.kind !== "string" && Ze.kind !== "number") throw new la(`Expected arguments for "${R}" to be (string, string) or (number, number), but found (${Ze.kind}, ${at.kind}) instead.`);
                                }
                                if (this.collator && !j && this.hasUntypedArgument) {
                                    let Ze = Ki(ve), at = Ki(De);
                                    if (Ze.kind !== "string" || at.kind !== "string") return S(ue, ve, De);
                                }
                                return this.collator ? D(ue, ve, De, this.collator.evaluate(ue)) : S(ue, ve, De);
                            }
                            eachChild(ue) {
                                ue(this.lhs), ue(this.rhs), this.collator && ue(this.collator);
                            }
                            outputDefined() {
                                return !0;
                            }
                        };
                    }
                    let os = wl("==", function(R, S, D) {
                        return S === D;
                    }, Xs), cl = wl("!=", function(R, S, D) {
                        return S !== D;
                    }, function(R, S, D, j) {
                        return !Xs(0, S, D, j);
                    }), Cs = wl("<", function(R, S, D) {
                        return S < D;
                    }, function(R, S, D, j) {
                        return j.compare(S, D) < 0;
                    }), ml = wl(">", function(R, S, D) {
                        return S > D;
                    }, function(R, S, D, j) {
                        return j.compare(S, D) > 0;
                    }), Ys = wl("<=", function(R, S, D) {
                        return S <= D;
                    }, function(R, S, D, j) {
                        return j.compare(S, D) <= 0;
                    }), Hs = wl(">=", function(R, S, D) {
                        return S >= D;
                    }, function(R, S, D, j) {
                        return j.compare(S, D) >= 0;
                    });
                    class Eo {
                        constructor(S, D, j){
                            this.type = _r, this.locale = j, this.caseSensitive = S, this.diacriticSensitive = D;
                        }
                        static parse(S, D) {
                            if (S.length !== 2) return D.error("Expected one argument.");
                            let j = S[1];
                            if (typeof j != "object" || Array.isArray(j)) return D.error("Collator options argument must be an object.");
                            let te = D.parse(j["case-sensitive"] !== void 0 && j["case-sensitive"], 1, dt);
                            if (!te) return null;
                            let ue = D.parse(j["diacritic-sensitive"] !== void 0 && j["diacritic-sensitive"], 1, dt);
                            if (!ue) return null;
                            let ve = null;
                            return j.locale && (ve = D.parse(j.locale, 1, Et), !ve) ? null : new Eo(te, ue, ve);
                        }
                        evaluate(S) {
                            return new yr(this.caseSensitive.evaluate(S), this.diacriticSensitive.evaluate(S), this.locale ? this.locale.evaluate(S) : null);
                        }
                        eachChild(S) {
                            S(this.caseSensitive), S(this.diacriticSensitive), this.locale && S(this.locale);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class fs {
                        constructor(S, D, j, te, ue){
                            this.type = Et, this.number = S, this.locale = D, this.currency = j, this.minFractionDigits = te, this.maxFractionDigits = ue;
                        }
                        static parse(S, D) {
                            if (S.length !== 3) return D.error("Expected two arguments.");
                            let j = D.parse(S[1], 1, St);
                            if (!j) return null;
                            let te = S[2];
                            if (typeof te != "object" || Array.isArray(te)) return D.error("NumberFormat options argument must be an object.");
                            let ue = null;
                            if (te.locale && (ue = D.parse(te.locale, 1, Et), !ue)) return null;
                            let ve = null;
                            if (te.currency && (ve = D.parse(te.currency, 1, Et), !ve)) return null;
                            let De = null;
                            if (te["min-fraction-digits"] && (De = D.parse(te["min-fraction-digits"], 1, St), !De)) return null;
                            let Ze = null;
                            return te["max-fraction-digits"] && (Ze = D.parse(te["max-fraction-digits"], 1, St), !Ze) ? null : new fs(j, ue, ve, De, Ze);
                        }
                        evaluate(S) {
                            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(S) : [], {
                                style: this.currency ? "currency" : "decimal",
                                currency: this.currency ? this.currency.evaluate(S) : void 0,
                                minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(S) : void 0,
                                maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(S) : void 0
                            }).format(this.number.evaluate(S));
                        }
                        eachChild(S) {
                            S(this.number), this.locale && S(this.locale), this.currency && S(this.currency), this.minFractionDigits && S(this.minFractionDigits), this.maxFractionDigits && S(this.maxFractionDigits);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Ql {
                        constructor(S){
                            this.type = Br, this.sections = S;
                        }
                        static parse(S, D) {
                            if (S.length < 2) return D.error("Expected at least one argument.");
                            let j = S[1];
                            if (!Array.isArray(j) && typeof j == "object") return D.error("First argument must be an image or text section.");
                            let te = [], ue = !1;
                            for(let ve = 1; ve <= S.length - 1; ++ve){
                                let De = S[ve];
                                if (ue && typeof De == "object" && !Array.isArray(De)) {
                                    ue = !1;
                                    let Ze = null;
                                    if (De["font-scale"] && (Ze = D.parse(De["font-scale"], 1, St), !Ze)) return null;
                                    let at = null;
                                    if (De["text-font"] && (at = D.parse(De["text-font"], 1, Ne(Et)), !at)) return null;
                                    let Tt = null;
                                    if (De["text-color"] && (Tt = D.parse(De["text-color"], 1, Ht), !Tt)) return null;
                                    let Ft = te[te.length - 1];
                                    Ft.scale = Ze, Ft.font = at, Ft.textColor = Tt;
                                } else {
                                    let Ze = D.parse(S[ve], 1, fr);
                                    if (!Ze) return null;
                                    let at = Ze.type.kind;
                                    if (at !== "string" && at !== "value" && at !== "null" && at !== "resolvedImage") return D.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                                    ue = !0, te.push({
                                        content: Ze,
                                        scale: null,
                                        font: null,
                                        textColor: null
                                    });
                                }
                            }
                            return new Ql(te);
                        }
                        evaluate(S) {
                            return new Zr(this.sections.map((D)=>{
                                let j = D.content.evaluate(S);
                                return Ki(j) === Nr ? new Fr("", j, null, null, null) : new Fr(ka(j), null, D.scale ? D.scale.evaluate(S) : null, D.font ? D.font.evaluate(S).join(",") : null, D.textColor ? D.textColor.evaluate(S) : null);
                            }));
                        }
                        eachChild(S) {
                            for (let D of this.sections)S(D.content), D.scale && S(D.scale), D.font && S(D.font), D.textColor && S(D.textColor);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Hu {
                        constructor(S){
                            this.type = Nr, this.input = S;
                        }
                        static parse(S, D) {
                            if (S.length !== 2) return D.error("Expected two arguments.");
                            let j = D.parse(S[1], 1, Et);
                            return j ? new Hu(j) : D.error("No image name provided.");
                        }
                        evaluate(S) {
                            let D = this.input.evaluate(S), j = Mi.fromString(D);
                            return j && S.availableImages && (j.available = S.availableImages.indexOf(D) > -1), j;
                        }
                        eachChild(S) {
                            S(this.input);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class fc {
                        constructor(S){
                            this.type = St, this.input = S;
                        }
                        static parse(S, D) {
                            if (S.length !== 2) return D.error(`Expected 1 argument, but found ${S.length - 1} instead.`);
                            let j = D.parse(S[1], 1);
                            return j ? j.type.kind !== "array" && j.type.kind !== "string" && j.type.kind !== "value" ? D.error(`Expected argument of type string or array, but found ${Ye(j.type)} instead.`) : new fc(j) : null;
                        }
                        evaluate(S) {
                            let D = this.input.evaluate(S);
                            if (typeof D == "string") return [
                                ...D
                            ].length;
                            if (Array.isArray(D)) return D.length;
                            throw new la(`Expected value to be of type string or array, but found ${Ye(Ki(D))} instead.`);
                        }
                        eachChild(S) {
                            S(this.input);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    let ms = 8192;
                    function on(R, S) {
                        let D = (180 + R[0]) / 360, j = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + R[1] * Math.PI / 360))) / 360, te = Math.pow(2, S.z);
                        return [
                            Math.round(D * te * ms),
                            Math.round(j * te * ms)
                        ];
                    }
                    function fa(R, S) {
                        let D = Math.pow(2, S.z);
                        var j, te;
                        return [
                            (te = (R[0] / ms + S.x) / D, 360 * te - 180),
                            (j = (R[1] / ms + S.y) / D, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * j) * Math.PI / 180)) - 90)
                        ];
                    }
                    function Qu(R, S) {
                        R[0] = Math.min(R[0], S[0]), R[1] = Math.min(R[1], S[1]), R[2] = Math.max(R[2], S[0]), R[3] = Math.max(R[3], S[1]);
                    }
                    function Rl(R, S) {
                        return !(R[0] <= S[0] || R[2] >= S[2] || R[1] <= S[1] || R[3] >= S[3]);
                    }
                    function vo(R, S, D) {
                        let j = R[0] - S[0], te = R[1] - S[1], ue = R[0] - D[0], ve = R[1] - D[1];
                        return j * ve - ue * te == 0 && j * ue <= 0 && te * ve <= 0;
                    }
                    function Zl(R, S, D, j) {
                        var te, ue;
                        return (te = [
                            j[0] - D[0],
                            j[1] - D[1]
                        ])[0] * (ue = [
                            S[0] - R[0],
                            S[1] - R[1]
                        ])[1] - te[1] * ue[0] != 0 && !(!Co(R, S, D, j) || !Co(D, j, R, S));
                    }
                    function Ks(R, S, D) {
                        for (let j of D)for(let te = 0; te < j.length - 1; ++te)if (Zl(R, S, j[te], j[te + 1])) return !0;
                        return !1;
                    }
                    function Xl(R, S, D = !1) {
                        let j = !1;
                        for (let De of S)for(let Ze = 0; Ze < De.length - 1; Ze++){
                            if (vo(R, De[Ze], De[Ze + 1])) return D;
                            (ue = De[Ze])[1] > (te = R)[1] != (ve = De[Ze + 1])[1] > te[1] && te[0] < (ve[0] - ue[0]) * (te[1] - ue[1]) / (ve[1] - ue[1]) + ue[0] && (j = !j);
                        }
                        var te, ue, ve;
                        return j;
                    }
                    function Ec(R, S) {
                        for (let D of S)if (Xl(R, D)) return !0;
                        return !1;
                    }
                    function Zn(R, S) {
                        for (let D of R)if (!Xl(D, S)) return !1;
                        for(let D = 0; D < R.length - 1; ++D)if (Ks(R[D], R[D + 1], S)) return !1;
                        return !0;
                    }
                    function ko(R, S) {
                        for (let D of S)if (Zn(R, D)) return !0;
                        return !1;
                    }
                    function Co(R, S, D, j) {
                        let te = j[0] - D[0], ue = j[1] - D[1], ve = (R[0] - D[0]) * ue - te * (R[1] - D[1]), De = (S[0] - D[0]) * ue - te * (S[1] - D[1]);
                        return ve > 0 && De < 0 || ve < 0 && De > 0;
                    }
                    function Tl(R, S, D) {
                        let j = [];
                        for(let te = 0; te < R.length; te++){
                            let ue = [];
                            for(let ve = 0; ve < R[te].length; ve++){
                                let De = on(R[te][ve], D);
                                Qu(S, De), ue.push(De);
                            }
                            j.push(ue);
                        }
                        return j;
                    }
                    function uf(R, S, D) {
                        let j = [];
                        for(let te = 0; te < R.length; te++){
                            let ue = Tl(R[te], S, D);
                            j.push(ue);
                        }
                        return j;
                    }
                    function So(R, S, D, j) {
                        if (R[0] < D[0] || R[0] > D[2]) {
                            let te = .5 * j, ue = R[0] - D[0] > te ? -j : D[0] - R[0] > te ? j : 0;
                            ue === 0 && (ue = R[0] - D[2] > te ? -j : D[2] - R[0] > te ? j : 0), R[0] += ue;
                        }
                        Qu(S, R);
                    }
                    function cf(R, S, D, j) {
                        let te = Math.pow(2, j.z) * ms, ue = [
                            j.x * ms,
                            j.y * ms
                        ], ve = [];
                        for (let De of R)for (let Ze of De){
                            let at = [
                                Ze.x + ue[0],
                                Ze.y + ue[1]
                            ];
                            So(at, S, D, te), ve.push(at);
                        }
                        return ve;
                    }
                    function rh(R, S, D, j) {
                        let te = Math.pow(2, j.z) * ms, ue = [
                            j.x * ms,
                            j.y * ms
                        ], ve = [];
                        for (let Ze of R){
                            let at = [];
                            for (let Tt of Ze){
                                let Ft = [
                                    Tt.x + ue[0],
                                    Tt.y + ue[1]
                                ];
                                Qu(S, Ft), at.push(Ft);
                            }
                            ve.push(at);
                        }
                        if (S[2] - S[0] <= te / 2) {
                            (De = S)[0] = De[1] = 1 / 0, De[2] = De[3] = -1 / 0;
                            for (let Ze of ve)for (let at of Ze)So(at, S, D, te);
                        }
                        var De;
                        return ve;
                    }
                    class Al {
                        constructor(S, D){
                            this.type = dt, this.geojson = S, this.geometries = D;
                        }
                        static parse(S, D) {
                            if (S.length !== 2) return D.error(`'within' expression requires exactly one argument, but found ${S.length - 1} instead.`);
                            if (Gi(S[1])) {
                                let j = S[1];
                                if (j.type === "FeatureCollection") {
                                    let te = [];
                                    for (let ue of j.features){
                                        let { type: ve, coordinates: De } = ue.geometry;
                                        ve === "Polygon" && te.push(De), ve === "MultiPolygon" && te.push(...De);
                                    }
                                    if (te.length) return new Al(j, {
                                        type: "MultiPolygon",
                                        coordinates: te
                                    });
                                } else if (j.type === "Feature") {
                                    let te = j.geometry.type;
                                    if (te === "Polygon" || te === "MultiPolygon") return new Al(j, j.geometry);
                                } else if (j.type === "Polygon" || j.type === "MultiPolygon") return new Al(j, j);
                            }
                            return D.error("'within' expression requires valid geojson object that contains polygon geometry type.");
                        }
                        evaluate(S) {
                            if (S.geometry() != null && S.canonicalID() != null) {
                                if (S.geometryType() === "Point") return function(D, j) {
                                    let te = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], ue = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], ve = D.canonicalID();
                                    if (j.type === "Polygon") {
                                        let De = Tl(j.coordinates, ue, ve), Ze = cf(D.geometry(), te, ue, ve);
                                        if (!Rl(te, ue)) return !1;
                                        for (let at of Ze)if (!Xl(at, De)) return !1;
                                    }
                                    if (j.type === "MultiPolygon") {
                                        let De = uf(j.coordinates, ue, ve), Ze = cf(D.geometry(), te, ue, ve);
                                        if (!Rl(te, ue)) return !1;
                                        for (let at of Ze)if (!Ec(at, De)) return !1;
                                    }
                                    return !0;
                                }(S, this.geometries);
                                if (S.geometryType() === "LineString") return function(D, j) {
                                    let te = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], ue = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], ve = D.canonicalID();
                                    if (j.type === "Polygon") {
                                        let De = Tl(j.coordinates, ue, ve), Ze = rh(D.geometry(), te, ue, ve);
                                        if (!Rl(te, ue)) return !1;
                                        for (let at of Ze)if (!Zn(at, De)) return !1;
                                    }
                                    if (j.type === "MultiPolygon") {
                                        let De = uf(j.coordinates, ue, ve), Ze = rh(D.geometry(), te, ue, ve);
                                        if (!Rl(te, ue)) return !1;
                                        for (let at of Ze)if (!ko(at, De)) return !1;
                                    }
                                    return !0;
                                }(S, this.geometries);
                            }
                            return !1;
                        }
                        eachChild() {}
                        outputDefined() {
                            return !0;
                        }
                    }
                    let Hc = class {
                        constructor(R = [], S = (D, j)=>D < j ? -1 : D > j ? 1 : 0){
                            if (this.data = R, this.length = this.data.length, this.compare = S, this.length > 0) for(let D = (this.length >> 1) - 1; D >= 0; D--)this._down(D);
                        }
                        push(R) {
                            this.data.push(R), this._up(this.length++);
                        }
                        pop() {
                            if (this.length === 0) return;
                            let R = this.data[0], S = this.data.pop();
                            return --this.length > 0 && (this.data[0] = S, this._down(0)), R;
                        }
                        peek() {
                            return this.data[0];
                        }
                        _up(R) {
                            let { data: S, compare: D } = this, j = S[R];
                            for(; R > 0;){
                                let te = R - 1 >> 1, ue = S[te];
                                if (D(j, ue) >= 0) break;
                                S[R] = ue, R = te;
                            }
                            S[R] = j;
                        }
                        _down(R) {
                            let { data: S, compare: D } = this, j = this.length >> 1, te = S[R];
                            for(; R < j;){
                                let ue = 1 + (R << 1), ve = ue + 1;
                                if (ve < this.length && D(S[ve], S[ue]) < 0 && (ue = ve), D(S[ue], te) >= 0) break;
                                S[R] = S[ue], R = ue;
                            }
                            S[R] = te;
                        }
                    };
                    function eu(R, S, D, j, te) {
                        Ls(R, S, D, j || R.length - 1, te || kc);
                    }
                    function Ls(R, S, D, j, te) {
                        for(; j > D;){
                            if (j - D > 600) {
                                var ue = j - D + 1, ve = S - D + 1, De = Math.log(ue), Ze = .5 * Math.exp(2 * De / 3), at = .5 * Math.sqrt(De * Ze * (ue - Ze) / ue) * (ve - ue / 2 < 0 ? -1 : 1);
                                Ls(R, S, Math.max(D, Math.floor(S - ve * Ze / ue + at)), Math.min(j, Math.floor(S + (ue - ve) * Ze / ue + at)), te);
                            }
                            var Tt = R[S], Ft = D, Qt = j;
                            for(mu(R, D, S), te(R[j], Tt) > 0 && mu(R, D, j); Ft < Qt;){
                                for(mu(R, Ft, Qt), Ft++, Qt--; te(R[Ft], Tt) < 0;)Ft++;
                                for(; te(R[Qt], Tt) > 0;)Qt--;
                            }
                            te(R[D], Tt) === 0 ? mu(R, D, Qt) : mu(R, ++Qt, j), Qt <= S && (D = Qt + 1), S <= Qt && (j = Qt - 1);
                        }
                    }
                    function mu(R, S, D) {
                        var j = R[S];
                        R[S] = R[D], R[D] = j;
                    }
                    function kc(R, S) {
                        return R < S ? -1 : R > S ? 1 : 0;
                    }
                    function Of(R, S) {
                        if (R.length <= 1) return [
                            R
                        ];
                        let D = [], j, te;
                        for (let ue of R){
                            let ve = vd(ue);
                            ve !== 0 && (ue.area = Math.abs(ve), te === void 0 && (te = ve < 0), te === ve < 0 ? (j && D.push(j), j = [
                                ue
                            ]) : j.push(ue));
                        }
                        if (j && D.push(j), S > 1) for(let ue = 0; ue < D.length; ue++)D[ue].length <= S || (eu(D[ue], S, 1, D[ue].length - 1, Gc), D[ue] = D[ue].slice(0, S));
                        return D;
                    }
                    function Gc(R, S) {
                        return S.area - R.area;
                    }
                    function vd(R) {
                        let S = 0;
                        for(let D, j, te = 0, ue = R.length, ve = ue - 1; te < ue; ve = te++)D = R[te], j = R[ve], S += (j.x - D.x) * (D.y + j.y);
                        return S;
                    }
                    let Bf = 1 / 298.257223563, ss = Bf * (2 - Bf), ff = Math.PI / 180;
                    class ih {
                        constructor(S){
                            let D = 6378.137 * ff * 1e3, j = Math.cos(S * ff), te = 1 / (1 - ss * (1 - j * j)), ue = Math.sqrt(te);
                            this.kx = D * ue * j, this.ky = D * ue * te * (1 - ss);
                        }
                        distance(S, D) {
                            let j = this.wrap(S[0] - D[0]) * this.kx, te = (S[1] - D[1]) * this.ky;
                            return Math.sqrt(j * j + te * te);
                        }
                        pointOnLine(S, D) {
                            let j, te, ue, ve, De = 1 / 0;
                            for(let Ze = 0; Ze < S.length - 1; Ze++){
                                let at = S[Ze][0], Tt = S[Ze][1], Ft = this.wrap(S[Ze + 1][0] - at) * this.kx, Qt = (S[Ze + 1][1] - Tt) * this.ky, sr = 0;
                                Ft === 0 && Qt === 0 || (sr = (this.wrap(D[0] - at) * this.kx * Ft + (D[1] - Tt) * this.ky * Qt) / (Ft * Ft + Qt * Qt), sr > 1 ? (at = S[Ze + 1][0], Tt = S[Ze + 1][1]) : sr > 0 && (at += Ft / this.kx * sr, Tt += Qt / this.ky * sr)), Ft = this.wrap(D[0] - at) * this.kx, Qt = (D[1] - Tt) * this.ky;
                                let Tr = Ft * Ft + Qt * Qt;
                                Tr < De && (De = Tr, j = at, te = Tt, ue = Ze, ve = sr);
                            }
                            return {
                                point: [
                                    j,
                                    te
                                ],
                                index: ue,
                                t: Math.max(0, Math.min(1, ve))
                            };
                        }
                        wrap(S) {
                            for(; S < -180;)S += 360;
                            for(; S > 180;)S -= 360;
                            return S;
                        }
                    }
                    function Vl(R, S) {
                        return S[0] - R[0];
                    }
                    function Js(R) {
                        return R[1] - R[0] + 1;
                    }
                    function hc(R, S) {
                        return R[1] >= R[0] && R[1] < S;
                    }
                    function Cc(R, S) {
                        if (R[0] > R[1]) return [
                            null,
                            null
                        ];
                        let D = Js(R);
                        if (S) {
                            if (D === 2) return [
                                R,
                                null
                            ];
                            let te = Math.floor(D / 2);
                            return [
                                [
                                    R[0],
                                    R[0] + te
                                ],
                                [
                                    R[0] + te,
                                    R[1]
                                ]
                            ];
                        }
                        if (D === 1) return [
                            R,
                            null
                        ];
                        let j = Math.floor(D / 2) - 1;
                        return [
                            [
                                R[0],
                                R[0] + j
                            ],
                            [
                                R[0] + j + 1,
                                R[1]
                            ]
                        ];
                    }
                    function ws(R, S) {
                        if (!hc(S, R.length)) return [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ];
                        let D = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ];
                        for(let j = S[0]; j <= S[1]; ++j)Qu(D, R[j]);
                        return D;
                    }
                    function $s(R) {
                        let S = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ];
                        for (let D of R)for (let j of D)Qu(S, j);
                        return S;
                    }
                    function hs(R) {
                        return R[0] !== -1 / 0 && R[1] !== -1 / 0 && R[2] !== 1 / 0 && R[3] !== 1 / 0;
                    }
                    function Ms(R, S, D) {
                        if (!hs(R) || !hs(S)) return NaN;
                        let j = 0, te = 0;
                        return R[2] < S[0] && (j = S[0] - R[2]), R[0] > S[2] && (j = R[0] - S[2]), R[1] > S[3] && (te = R[1] - S[3]), R[3] < S[1] && (te = S[1] - R[3]), D.distance([
                            0,
                            0
                        ], [
                            j,
                            te
                        ]);
                    }
                    function dc(R, S, D) {
                        let j = D.pointOnLine(S, R);
                        return D.distance(R, j.point);
                    }
                    function Sl(R, S, D, j, te) {
                        let ue = Math.min(dc(R, [
                            D,
                            j
                        ], te), dc(S, [
                            D,
                            j
                        ], te)), ve = Math.min(dc(D, [
                            R,
                            S
                        ], te), dc(j, [
                            R,
                            S
                        ], te));
                        return Math.min(ue, ve);
                    }
                    function ec(R, S, D, j, te) {
                        if (!hc(S, R.length) || !hc(j, D.length)) return 1 / 0;
                        let ue = 1 / 0;
                        for(let ve = S[0]; ve < S[1]; ++ve){
                            let De = R[ve], Ze = R[ve + 1];
                            for(let at = j[0]; at < j[1]; ++at){
                                let Tt = D[at], Ft = D[at + 1];
                                if (Zl(De, Ze, Tt, Ft)) return 0;
                                ue = Math.min(ue, Sl(De, Ze, Tt, Ft, te));
                            }
                        }
                        return ue;
                    }
                    function Ps(R, S, D, j, te) {
                        if (!hc(S, R.length) || !hc(j, D.length)) return NaN;
                        let ue = 1 / 0;
                        for(let ve = S[0]; ve <= S[1]; ++ve)for(let De = j[0]; De <= j[1]; ++De)if (ue = Math.min(ue, te.distance(R[ve], D[De])), ue === 0) return ue;
                        return ue;
                    }
                    function ov(R, S, D) {
                        if (Xl(R, S, !0)) return 0;
                        let j = 1 / 0;
                        for (let te of S){
                            let ue = te[0], ve = te[te.length - 1];
                            if (ue !== ve && (j = Math.min(j, dc(R, [
                                ve,
                                ue
                            ], D)), j === 0)) return j;
                            let De = D.pointOnLine(te, R);
                            if (j = Math.min(j, D.distance(R, De.point)), j === 0) return j;
                        }
                        return j;
                    }
                    function wo(R, S, D, j) {
                        if (!hc(S, R.length)) return NaN;
                        for(let ue = S[0]; ue <= S[1]; ++ue)if (Xl(R[ue], D, !0)) return 0;
                        let te = 1 / 0;
                        for(let ue = S[0]; ue < S[1]; ++ue){
                            let ve = R[ue], De = R[ue + 1];
                            for (let Ze of D)for(let at = 0, Tt = Ze.length, Ft = Tt - 1; at < Tt; Ft = at++){
                                let Qt = Ze[Ft], sr = Ze[at];
                                if (Zl(ve, De, Qt, sr)) return 0;
                                te = Math.min(te, Sl(ve, De, Qt, sr, j));
                            }
                        }
                        return te;
                    }
                    function Od(R, S) {
                        for (let D of R)for (let j of D)if (Xl(j, S, !0)) return !0;
                        return !1;
                    }
                    function $o(R, S, D, j = 1 / 0) {
                        let te = $s(R), ue = $s(S);
                        if (j !== 1 / 0 && Ms(te, ue, D) >= j) return j;
                        if (Rl(te, ue)) {
                            if (Od(R, S)) return 0;
                        } else if (Od(S, R)) return 0;
                        let ve = 1 / 0;
                        for (let De of R)for(let Ze = 0, at = De.length, Tt = at - 1; Ze < at; Tt = Ze++){
                            let Ft = De[Tt], Qt = De[Ze];
                            for (let sr of S)for(let Tr = 0, Pr = sr.length, $r = Pr - 1; Tr < Pr; $r = Tr++){
                                let ni = sr[$r], Di = sr[Tr];
                                if (Zl(Ft, Qt, ni, Di)) return 0;
                                ve = Math.min(ve, Sl(Ft, Qt, ni, Di, D));
                            }
                        }
                        return ve;
                    }
                    function Ja(R, S, D, j, te, ue) {
                        if (!ue) return;
                        let ve = Ms(ws(j, ue), te, D);
                        ve < S && R.push([
                            ve,
                            ue,
                            [
                                0,
                                0
                            ]
                        ]);
                    }
                    function Ef(R, S, D, j, te, ue, ve) {
                        if (!ue || !ve) return;
                        let De = Ms(ws(j, ue), ws(te, ve), D);
                        De < S && R.push([
                            De,
                            ue,
                            ve
                        ]);
                    }
                    function tc(R, S, D, j, te = 1 / 0) {
                        let ue = Math.min(j.distance(R[0], D[0][0]), te);
                        if (ue === 0) return ue;
                        let ve = new Hc([
                            [
                                0,
                                [
                                    0,
                                    R.length - 1
                                ],
                                [
                                    0,
                                    0
                                ]
                            ]
                        ], Vl), De = $s(D);
                        for(; ve.length > 0;){
                            let Ze = ve.pop();
                            if (Ze[0] >= ue) continue;
                            let at = Ze[1], Tt = S ? 50 : 100;
                            if (Js(at) <= Tt) {
                                if (!hc(at, R.length)) return NaN;
                                if (S) {
                                    let Ft = wo(R, at, D, j);
                                    if (isNaN(Ft) || Ft === 0) return Ft;
                                    ue = Math.min(ue, Ft);
                                } else for(let Ft = at[0]; Ft <= at[1]; ++Ft){
                                    let Qt = ov(R[Ft], D, j);
                                    if (ue = Math.min(ue, Qt), ue === 0) return 0;
                                }
                            } else {
                                let Ft = Cc(at, S);
                                Ja(ve, ue, j, R, De, Ft[0]), Ja(ve, ue, j, R, De, Ft[1]);
                            }
                        }
                        return ue;
                    }
                    function uu(R, S, D, j, te, ue = 1 / 0) {
                        let ve = Math.min(ue, te.distance(R[0], D[0]));
                        if (ve === 0) return ve;
                        let De = new Hc([
                            [
                                0,
                                [
                                    0,
                                    R.length - 1
                                ],
                                [
                                    0,
                                    D.length - 1
                                ]
                            ]
                        ], Vl);
                        for(; De.length > 0;){
                            let Ze = De.pop();
                            if (Ze[0] >= ve) continue;
                            let at = Ze[1], Tt = Ze[2], Ft = S ? 50 : 100, Qt = j ? 50 : 100;
                            if (Js(at) <= Ft && Js(Tt) <= Qt) {
                                if (!hc(at, R.length) && hc(Tt, D.length)) return NaN;
                                let sr;
                                if (S && j) sr = ec(R, at, D, Tt, te), ve = Math.min(ve, sr);
                                else if (S && !j) {
                                    let Tr = R.slice(at[0], at[1] + 1);
                                    for(let Pr = Tt[0]; Pr <= Tt[1]; ++Pr)if (sr = dc(D[Pr], Tr, te), ve = Math.min(ve, sr), ve === 0) return ve;
                                } else if (!S && j) {
                                    let Tr = D.slice(Tt[0], Tt[1] + 1);
                                    for(let Pr = at[0]; Pr <= at[1]; ++Pr)if (sr = dc(R[Pr], Tr, te), ve = Math.min(ve, sr), ve === 0) return ve;
                                } else sr = Ps(R, at, D, Tt, te), ve = Math.min(ve, sr);
                            } else {
                                let sr = Cc(at, S), Tr = Cc(Tt, j);
                                Ef(De, ve, te, R, D, sr[0], Tr[0]), Ef(De, ve, te, R, D, sr[0], Tr[1]), Ef(De, ve, te, R, D, sr[1], Tr[0]), Ef(De, ve, te, R, D, sr[1], Tr[1]);
                            }
                        }
                        return ve;
                    }
                    function Mh(R) {
                        return R.type === "MultiPolygon" ? R.coordinates.map((S)=>({
                                type: "Polygon",
                                coordinates: S
                            })) : R.type === "MultiLineString" ? R.coordinates.map((S)=>({
                                type: "LineString",
                                coordinates: S
                            })) : R.type === "MultiPoint" ? R.coordinates.map((S)=>({
                                type: "Point",
                                coordinates: S
                            })) : [
                            R
                        ];
                    }
                    class jc {
                        constructor(S, D){
                            this.type = St, this.geojson = S, this.geometries = D;
                        }
                        static parse(S, D) {
                            if (S.length !== 2) return D.error(`'distance' expression requires exactly one argument, but found ${S.length - 1} instead.`);
                            if (Gi(S[1])) {
                                let j = S[1];
                                if (j.type === "FeatureCollection") return new jc(j, j.features.map((te)=>Mh(te.geometry)).flat());
                                if (j.type === "Feature") return new jc(j, Mh(j.geometry));
                                if ("type" in j && "coordinates" in j) return new jc(j, Mh(j));
                            }
                            return D.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
                        }
                        evaluate(S) {
                            if (S.geometry() != null && S.canonicalID() != null) {
                                if (S.geometryType() === "Point") return function(D, j) {
                                    let te = D.geometry(), ue = te.flat().map((Ze)=>fa([
                                            Ze.x,
                                            Ze.y
                                        ], D.canonical));
                                    if (te.length === 0) return NaN;
                                    let ve = new ih(ue[0][1]), De = 1 / 0;
                                    for (let Ze of j){
                                        switch(Ze.type){
                                            case "Point":
                                                De = Math.min(De, uu(ue, !1, [
                                                    Ze.coordinates
                                                ], !1, ve, De));
                                                break;
                                            case "LineString":
                                                De = Math.min(De, uu(ue, !1, Ze.coordinates, !0, ve, De));
                                                break;
                                            case "Polygon":
                                                De = Math.min(De, tc(ue, !1, Ze.coordinates, ve, De));
                                        }
                                        if (De === 0) return De;
                                    }
                                    return De;
                                }(S, this.geometries);
                                if (S.geometryType() === "LineString") return function(D, j) {
                                    let te = D.geometry(), ue = te.flat().map((Ze)=>fa([
                                            Ze.x,
                                            Ze.y
                                        ], D.canonical));
                                    if (te.length === 0) return NaN;
                                    let ve = new ih(ue[0][1]), De = 1 / 0;
                                    for (let Ze of j){
                                        switch(Ze.type){
                                            case "Point":
                                                De = Math.min(De, uu(ue, !0, [
                                                    Ze.coordinates
                                                ], !1, ve, De));
                                                break;
                                            case "LineString":
                                                De = Math.min(De, uu(ue, !0, Ze.coordinates, !0, ve, De));
                                                break;
                                            case "Polygon":
                                                De = Math.min(De, tc(ue, !0, Ze.coordinates, ve, De));
                                        }
                                        if (De === 0) return De;
                                    }
                                    return De;
                                }(S, this.geometries);
                                if (S.geometryType() === "Polygon") return function(D, j) {
                                    let te = D.geometry();
                                    if (te.length === 0 || te[0].length === 0) return NaN;
                                    let ue = Of(te, 0).map((Ze)=>Ze.map((at)=>at.map((Tt)=>fa([
                                                    Tt.x,
                                                    Tt.y
                                                ], D.canonical)))), ve = new ih(ue[0][0][0][1]), De = 1 / 0;
                                    for (let Ze of j)for (let at of ue){
                                        switch(Ze.type){
                                            case "Point":
                                                De = Math.min(De, tc([
                                                    Ze.coordinates
                                                ], !1, at, ve, De));
                                                break;
                                            case "LineString":
                                                De = Math.min(De, tc(Ze.coordinates, !0, at, ve, De));
                                                break;
                                            case "Polygon":
                                                De = Math.min(De, $o(at, Ze.coordinates, ve, De));
                                        }
                                        if (De === 0) return De;
                                    }
                                    return De;
                                }(S, this.geometries);
                            }
                            return NaN;
                        }
                        eachChild() {}
                        outputDefined() {
                            return !0;
                        }
                    }
                    let kf = {
                        "==": os,
                        "!=": cl,
                        ">": ml,
                        "<": Cs,
                        ">=": Hs,
                        "<=": Ys,
                        array: Ra,
                        at: br,
                        boolean: Ra,
                        case: Yi,
                        coalesce: ks,
                        collator: Eo,
                        format: Ql,
                        image: Hu,
                        in: Hr,
                        "index-of": ti,
                        interpolate: xo,
                        "interpolate-hcl": xo,
                        "interpolate-lab": xo,
                        length: fc,
                        let: xn,
                        literal: jn,
                        match: zi,
                        number: Ra,
                        "number-format": fs,
                        object: Ra,
                        slice: an,
                        step: Ji,
                        string: Ra,
                        "to-boolean": oa,
                        "to-color": oa,
                        "to-number": oa,
                        "to-string": oa,
                        var: _t,
                        within: Al,
                        distance: jc
                    };
                    class Ml {
                        constructor(S, D, j, te){
                            this.name = S, this.type = D, this._evaluate = j, this.args = te;
                        }
                        evaluate(S) {
                            return this._evaluate(S, this.args);
                        }
                        eachChild(S) {
                            this.args.forEach(S);
                        }
                        outputDefined() {
                            return !1;
                        }
                        static parse(S, D) {
                            let j = S[0], te = Ml.definitions[j];
                            if (!te) return D.error(`Unknown expression "${j}". If you wanted a literal array, use ["literal", [...]].`, 0);
                            let ue = Array.isArray(te) ? te[0] : te.type, ve = Array.isArray(te) ? [
                                [
                                    te[1],
                                    te[2]
                                ]
                            ] : te.overloads, De = ve.filter(([at])=>!Array.isArray(at) || at.length === S.length - 1), Ze = null;
                            for (let [at, Tt] of De){
                                Ze = new oo(D.registry, kh, D.path, null, D.scope);
                                let Ft = [], Qt = !1;
                                for(let sr = 1; sr < S.length; sr++){
                                    let Tr = S[sr], Pr = Array.isArray(at) ? at[sr - 1] : at.type, $r = Ze.parse(Tr, 1 + Ft.length, Pr);
                                    if (!$r) {
                                        Qt = !0;
                                        break;
                                    }
                                    Ft.push($r);
                                }
                                if (!Qt) {
                                    if (Array.isArray(at) && at.length !== Ft.length) Ze.error(`Expected ${at.length} arguments, but found ${Ft.length} instead.`);
                                    else {
                                        for(let sr = 0; sr < Ft.length; sr++){
                                            let Tr = Array.isArray(at) ? at[sr] : at.type, Pr = Ft[sr];
                                            Ze.concat(sr + 1).checkSubtype(Tr, Pr.type);
                                        }
                                        if (Ze.errors.length === 0) return new Ml(j, ue, Tt, Ft);
                                    }
                                }
                            }
                            if (De.length === 1) D.errors.push(...Ze.errors);
                            else {
                                let at = (De.length ? De : ve).map(([Ft])=>{
                                    var Qt;
                                    return Qt = Ft, Array.isArray(Qt) ? `(${Qt.map(Ye).join(", ")})` : `(${Ye(Qt.type)}...)`;
                                }).join(" | "), Tt = [];
                                for(let Ft = 1; Ft < S.length; Ft++){
                                    let Qt = D.parse(S[Ft], 1 + Tt.length);
                                    if (!Qt) return null;
                                    Tt.push(Ye(Qt.type));
                                }
                                D.error(`Expected arguments of type ${at}, but found (${Tt.join(", ")}) instead.`);
                            }
                            return null;
                        }
                        static register(S, D) {
                            Ml.definitions = D;
                            for(let j in D)S[j] = Ml;
                        }
                    }
                    function Yh(R, [S, D, j, te]) {
                        S = S.evaluate(R), D = D.evaluate(R), j = j.evaluate(R);
                        let ue = te ? te.evaluate(R) : 1, ve = Pi(S, D, j, ue);
                        if (ve) throw new la(ve);
                        return new Zt(S / 255, D / 255, j / 255, ue, !1);
                    }
                    function Eh(R, S) {
                        return R in S;
                    }
                    function nh(R, S) {
                        let D = S[R];
                        return D === void 0 ? null : D;
                    }
                    function hf(R) {
                        return {
                            type: R
                        };
                    }
                    function kh(R) {
                        if (R instanceof _t) return kh(R.boundExpression);
                        if (R instanceof Ml && R.name === "error" || R instanceof Eo || R instanceof Al || R instanceof jc) return !1;
                        let S = R instanceof oa || R instanceof Ra, D = !0;
                        return R.eachChild((j)=>{
                            D = S ? D && kh(j) : D && j instanceof jn;
                        }), !!D && Kh(R) && ah(R, [
                            "zoom",
                            "heatmap-density",
                            "line-progress",
                            "accumulated",
                            "is-supported-script"
                        ]);
                    }
                    function Kh(R) {
                        if (R instanceof Ml && (R.name === "get" && R.args.length === 1 || R.name === "feature-state" || R.name === "has" && R.args.length === 1 || R.name === "properties" || R.name === "geometry-type" || R.name === "id" || /^filter-/.test(R.name)) || R instanceof Al || R instanceof jc) return !1;
                        let S = !0;
                        return R.eachChild((D)=>{
                            S && !Kh(D) && (S = !1);
                        }), S;
                    }
                    function rc(R) {
                        if (R instanceof Ml && R.name === "feature-state") return !1;
                        let S = !0;
                        return R.eachChild((D)=>{
                            S && !rc(D) && (S = !1);
                        }), S;
                    }
                    function ah(R, S) {
                        if (R instanceof Ml && S.indexOf(R.name) >= 0) return !1;
                        let D = !0;
                        return R.eachChild((j)=>{
                            D && !ah(j, S) && (D = !1);
                        }), D;
                    }
                    function Wc(R) {
                        return {
                            result: "success",
                            value: R
                        };
                    }
                    function df(R) {
                        return {
                            result: "error",
                            value: R
                        };
                    }
                    function Cu(R) {
                        return R["property-type"] === "data-driven" || R["property-type"] === "cross-faded-data-driven";
                    }
                    function Nf(R) {
                        return !!R.expression && R.expression.parameters.indexOf("zoom") > -1;
                    }
                    function Zc(R) {
                        return !!R.expression && R.expression.interpolated;
                    }
                    function ds(R) {
                        return R instanceof Number ? "number" : R instanceof String ? "string" : R instanceof Boolean ? "boolean" : Array.isArray(R) ? "array" : R === null ? "null" : typeof R;
                    }
                    function Ch(R) {
                        return typeof R == "object" && R !== null && !Array.isArray(R);
                    }
                    function Bd(R) {
                        return R;
                    }
                    function Jh(R, S) {
                        let D = S.type === "color", j = R.stops && typeof R.stops[0][0] == "object", te = j || !(j || R.property !== void 0), ue = R.type || (Zc(S) ? "exponential" : "interval");
                        if (D || S.type === "padding") {
                            let Tt = D ? Zt.parse : Vr.parse;
                            (R = Ke({}, R)).stops && (R.stops = R.stops.map((Ft)=>[
                                    Ft[0],
                                    Tt(Ft[1])
                                ])), R.default = Tt(R.default ? R.default : S.default);
                        }
                        if (R.colorSpace && (ve = R.colorSpace) !== "rgb" && ve !== "hcl" && ve !== "lab") throw new Error(`Unknown color space: "${R.colorSpace}"`);
                        var ve;
                        let De, Ze, at;
                        if (ue === "exponential") De = $h;
                        else if (ue === "interval") De = Lu;
                        else if (ue === "categorical") {
                            De = pd, Ze = Object.create(null);
                            for (let Tt of R.stops)Ze[Tt[0]] = Tt[1];
                            at = typeof R.stops[0][0];
                        } else {
                            if (ue !== "identity") throw new Error(`Unknown function type "${ue}"`);
                            De = tu;
                        }
                        if (j) {
                            let Tt = {}, Ft = [];
                            for(let Tr = 0; Tr < R.stops.length; Tr++){
                                let Pr = R.stops[Tr], $r = Pr[0].zoom;
                                Tt[$r] === void 0 && (Tt[$r] = {
                                    zoom: $r,
                                    type: R.type,
                                    property: R.property,
                                    default: R.default,
                                    stops: []
                                }, Ft.push($r)), Tt[$r].stops.push([
                                    Pr[0].value,
                                    Pr[1]
                                ]);
                            }
                            let Qt = [];
                            for (let Tr of Ft)Qt.push([
                                Tt[Tr].zoom,
                                Jh(Tt[Tr], S)
                            ]);
                            let sr = {
                                name: "linear"
                            };
                            return {
                                kind: "composite",
                                interpolationType: sr,
                                interpolationFactor: xo.interpolationFactor.bind(void 0, sr),
                                zoomStops: Qt.map((Tr)=>Tr[0]),
                                evaluate: ({ zoom: Tr }, Pr)=>$h({
                                        stops: Qt,
                                        base: R.base
                                    }, S, Tr).evaluate(Tr, Pr)
                            };
                        }
                        if (te) {
                            let Tt = ue === "exponential" ? {
                                name: "exponential",
                                base: R.base !== void 0 ? R.base : 1
                            } : null;
                            return {
                                kind: "camera",
                                interpolationType: Tt,
                                interpolationFactor: xo.interpolationFactor.bind(void 0, Tt),
                                zoomStops: R.stops.map((Ft)=>Ft[0]),
                                evaluate: ({ zoom: Ft })=>De(R, S, Ft, Ze, at)
                            };
                        }
                        return {
                            kind: "source",
                            evaluate (Tt, Ft) {
                                let Qt = Ft && Ft.properties ? Ft.properties[R.property] : void 0;
                                return Qt === void 0 ? Cf(R.default, S.default) : De(R, S, Qt, Ze, at);
                            }
                        };
                    }
                    function Cf(R, S, D) {
                        return R !== void 0 ? R : S !== void 0 ? S : D !== void 0 ? D : void 0;
                    }
                    function pd(R, S, D, j, te) {
                        return Cf(typeof D === te ? j[D] : void 0, R.default, S.default);
                    }
                    function Lu(R, S, D) {
                        if (ds(D) !== "number") return Cf(R.default, S.default);
                        let j = R.stops.length;
                        if (j === 1 || D <= R.stops[0][0]) return R.stops[0][1];
                        if (D >= R.stops[j - 1][0]) return R.stops[j - 1][1];
                        let te = hi(R.stops.map((ue)=>ue[0]), D);
                        return R.stops[te][1];
                    }
                    function $h(R, S, D) {
                        let j = R.base !== void 0 ? R.base : 1;
                        if (ds(D) !== "number") return Cf(R.default, S.default);
                        let te = R.stops.length;
                        if (te === 1 || D <= R.stops[0][0]) return R.stops[0][1];
                        if (D >= R.stops[te - 1][0]) return R.stops[te - 1][1];
                        let ue = hi(R.stops.map((Tt)=>Tt[0]), D), ve = function(Tt, Ft, Qt, sr) {
                            let Tr = sr - Qt, Pr = Tt - Qt;
                            return Tr === 0 ? 0 : Ft === 1 ? Pr / Tr : (Math.pow(Ft, Pr) - 1) / (Math.pow(Ft, Tr) - 1);
                        }(D, j, R.stops[ue][0], R.stops[ue + 1][0]), De = R.stops[ue][1], Ze = R.stops[ue + 1][1], at = Mo[S.type] || Bd;
                        return typeof De.evaluate == "function" ? {
                            evaluate (...Tt) {
                                let Ft = De.evaluate.apply(void 0, Tt), Qt = Ze.evaluate.apply(void 0, Tt);
                                if (Ft !== void 0 && Qt !== void 0) return at(Ft, Qt, ve, R.colorSpace);
                            }
                        } : at(De, Ze, ve, R.colorSpace);
                    }
                    function tu(R, S, D) {
                        switch(S.type){
                            case "color":
                                D = Zt.parse(D);
                                break;
                            case "formatted":
                                D = Zr.fromString(D.toString());
                                break;
                            case "resolvedImage":
                                D = Mi.fromString(D.toString());
                                break;
                            case "padding":
                                D = Vr.parse(D);
                                break;
                            default:
                                ds(D) === S.type || S.type === "enum" && S.values[D] || (D = void 0);
                        }
                        return Cf(D, R.default, S.default);
                    }
                    Ml.register(kf, {
                        error: [
                            {
                                kind: "error"
                            },
                            [
                                Et
                            ],
                            (R, [S])=>{
                                throw new la(S.evaluate(R));
                            }
                        ],
                        typeof: [
                            Et,
                            [
                                fr
                            ],
                            (R, [S])=>Ye(Ki(S.evaluate(R)))
                        ],
                        "to-rgba": [
                            Ne(St, 4),
                            [
                                Ht
                            ],
                            (R, [S])=>{
                                let [D, j, te, ue] = S.evaluate(R).rgb;
                                return [
                                    255 * D,
                                    255 * j,
                                    255 * te,
                                    ue
                                ];
                            }
                        ],
                        rgb: [
                            Ht,
                            [
                                St,
                                St,
                                St
                            ],
                            Yh
                        ],
                        rgba: [
                            Ht,
                            [
                                St,
                                St,
                                St,
                                St
                            ],
                            Yh
                        ],
                        has: {
                            type: dt,
                            overloads: [
                                [
                                    [
                                        Et
                                    ],
                                    (R, [S])=>Eh(S.evaluate(R), R.properties())
                                ],
                                [
                                    [
                                        Et,
                                        $t
                                    ],
                                    (R, [S, D])=>Eh(S.evaluate(R), D.evaluate(R))
                                ]
                            ]
                        },
                        get: {
                            type: fr,
                            overloads: [
                                [
                                    [
                                        Et
                                    ],
                                    (R, [S])=>nh(S.evaluate(R), R.properties())
                                ],
                                [
                                    [
                                        Et,
                                        $t
                                    ],
                                    (R, [S, D])=>nh(S.evaluate(R), D.evaluate(R))
                                ]
                            ]
                        },
                        "feature-state": [
                            fr,
                            [
                                Et
                            ],
                            (R, [S])=>nh(S.evaluate(R), R.featureState || {})
                        ],
                        properties: [
                            $t,
                            [],
                            (R)=>R.properties()
                        ],
                        "geometry-type": [
                            Et,
                            [],
                            (R)=>R.geometryType()
                        ],
                        id: [
                            fr,
                            [],
                            (R)=>R.id()
                        ],
                        zoom: [
                            St,
                            [],
                            (R)=>R.globals.zoom
                        ],
                        "heatmap-density": [
                            St,
                            [],
                            (R)=>R.globals.heatmapDensity || 0
                        ],
                        "line-progress": [
                            St,
                            [],
                            (R)=>R.globals.lineProgress || 0
                        ],
                        accumulated: [
                            fr,
                            [],
                            (R)=>R.globals.accumulated === void 0 ? null : R.globals.accumulated
                        ],
                        "+": [
                            St,
                            hf(St),
                            (R, S)=>{
                                let D = 0;
                                for (let j of S)D += j.evaluate(R);
                                return D;
                            }
                        ],
                        "*": [
                            St,
                            hf(St),
                            (R, S)=>{
                                let D = 1;
                                for (let j of S)D *= j.evaluate(R);
                                return D;
                            }
                        ],
                        "-": {
                            type: St,
                            overloads: [
                                [
                                    [
                                        St,
                                        St
                                    ],
                                    (R, [S, D])=>S.evaluate(R) - D.evaluate(R)
                                ],
                                [
                                    [
                                        St
                                    ],
                                    (R, [S])=>-S.evaluate(R)
                                ]
                            ]
                        },
                        "/": [
                            St,
                            [
                                St,
                                St
                            ],
                            (R, [S, D])=>S.evaluate(R) / D.evaluate(R)
                        ],
                        "%": [
                            St,
                            [
                                St,
                                St
                            ],
                            (R, [S, D])=>S.evaluate(R) % D.evaluate(R)
                        ],
                        ln2: [
                            St,
                            [],
                            ()=>Math.LN2
                        ],
                        pi: [
                            St,
                            [],
                            ()=>Math.PI
                        ],
                        e: [
                            St,
                            [],
                            ()=>Math.E
                        ],
                        "^": [
                            St,
                            [
                                St,
                                St
                            ],
                            (R, [S, D])=>Math.pow(S.evaluate(R), D.evaluate(R))
                        ],
                        sqrt: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.sqrt(S.evaluate(R))
                        ],
                        log10: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.log(S.evaluate(R)) / Math.LN10
                        ],
                        ln: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.log(S.evaluate(R))
                        ],
                        log2: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.log(S.evaluate(R)) / Math.LN2
                        ],
                        sin: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.sin(S.evaluate(R))
                        ],
                        cos: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.cos(S.evaluate(R))
                        ],
                        tan: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.tan(S.evaluate(R))
                        ],
                        asin: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.asin(S.evaluate(R))
                        ],
                        acos: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.acos(S.evaluate(R))
                        ],
                        atan: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.atan(S.evaluate(R))
                        ],
                        min: [
                            St,
                            hf(St),
                            (R, S)=>Math.min(...S.map((D)=>D.evaluate(R)))
                        ],
                        max: [
                            St,
                            hf(St),
                            (R, S)=>Math.max(...S.map((D)=>D.evaluate(R)))
                        ],
                        abs: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.abs(S.evaluate(R))
                        ],
                        round: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>{
                                let D = S.evaluate(R);
                                return D < 0 ? -Math.round(-D) : Math.round(D);
                            }
                        ],
                        floor: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.floor(S.evaluate(R))
                        ],
                        ceil: [
                            St,
                            [
                                St
                            ],
                            (R, [S])=>Math.ceil(S.evaluate(R))
                        ],
                        "filter-==": [
                            dt,
                            [
                                Et,
                                fr
                            ],
                            (R, [S, D])=>R.properties()[S.value] === D.value
                        ],
                        "filter-id-==": [
                            dt,
                            [
                                fr
                            ],
                            (R, [S])=>R.id() === S.value
                        ],
                        "filter-type-==": [
                            dt,
                            [
                                Et
                            ],
                            (R, [S])=>R.geometryType() === S.value
                        ],
                        "filter-<": [
                            dt,
                            [
                                Et,
                                fr
                            ],
                            (R, [S, D])=>{
                                let j = R.properties()[S.value], te = D.value;
                                return typeof j == typeof te && j < te;
                            }
                        ],
                        "filter-id-<": [
                            dt,
                            [
                                fr
                            ],
                            (R, [S])=>{
                                let D = R.id(), j = S.value;
                                return typeof D == typeof j && D < j;
                            }
                        ],
                        "filter->": [
                            dt,
                            [
                                Et,
                                fr
                            ],
                            (R, [S, D])=>{
                                let j = R.properties()[S.value], te = D.value;
                                return typeof j == typeof te && j > te;
                            }
                        ],
                        "filter-id->": [
                            dt,
                            [
                                fr
                            ],
                            (R, [S])=>{
                                let D = R.id(), j = S.value;
                                return typeof D == typeof j && D > j;
                            }
                        ],
                        "filter-<=": [
                            dt,
                            [
                                Et,
                                fr
                            ],
                            (R, [S, D])=>{
                                let j = R.properties()[S.value], te = D.value;
                                return typeof j == typeof te && j <= te;
                            }
                        ],
                        "filter-id-<=": [
                            dt,
                            [
                                fr
                            ],
                            (R, [S])=>{
                                let D = R.id(), j = S.value;
                                return typeof D == typeof j && D <= j;
                            }
                        ],
                        "filter->=": [
                            dt,
                            [
                                Et,
                                fr
                            ],
                            (R, [S, D])=>{
                                let j = R.properties()[S.value], te = D.value;
                                return typeof j == typeof te && j >= te;
                            }
                        ],
                        "filter-id->=": [
                            dt,
                            [
                                fr
                            ],
                            (R, [S])=>{
                                let D = R.id(), j = S.value;
                                return typeof D == typeof j && D >= j;
                            }
                        ],
                        "filter-has": [
                            dt,
                            [
                                fr
                            ],
                            (R, [S])=>S.value in R.properties()
                        ],
                        "filter-has-id": [
                            dt,
                            [],
                            (R)=>R.id() !== null && R.id() !== void 0
                        ],
                        "filter-type-in": [
                            dt,
                            [
                                Ne(Et)
                            ],
                            (R, [S])=>S.value.indexOf(R.geometryType()) >= 0
                        ],
                        "filter-id-in": [
                            dt,
                            [
                                Ne(fr)
                            ],
                            (R, [S])=>S.value.indexOf(R.id()) >= 0
                        ],
                        "filter-in-small": [
                            dt,
                            [
                                Et,
                                Ne(fr)
                            ],
                            (R, [S, D])=>D.value.indexOf(R.properties()[S.value]) >= 0
                        ],
                        "filter-in-large": [
                            dt,
                            [
                                Et,
                                Ne(fr)
                            ],
                            (R, [S, D])=>(function(j, te, ue, ve) {
                                    for(; ue <= ve;){
                                        let De = ue + ve >> 1;
                                        if (te[De] === j) return !0;
                                        te[De] > j ? ve = De - 1 : ue = De + 1;
                                    }
                                    return !1;
                                })(R.properties()[S.value], D.value, 0, D.value.length - 1)
                        ],
                        all: {
                            type: dt,
                            overloads: [
                                [
                                    [
                                        dt,
                                        dt
                                    ],
                                    (R, [S, D])=>S.evaluate(R) && D.evaluate(R)
                                ],
                                [
                                    hf(dt),
                                    (R, S)=>{
                                        for (let D of S)if (!D.evaluate(R)) return !1;
                                        return !0;
                                    }
                                ]
                            ]
                        },
                        any: {
                            type: dt,
                            overloads: [
                                [
                                    [
                                        dt,
                                        dt
                                    ],
                                    (R, [S, D])=>S.evaluate(R) || D.evaluate(R)
                                ],
                                [
                                    hf(dt),
                                    (R, S)=>{
                                        for (let D of S)if (D.evaluate(R)) return !0;
                                        return !1;
                                    }
                                ]
                            ]
                        },
                        "!": [
                            dt,
                            [
                                dt
                            ],
                            (R, [S])=>!S.evaluate(R)
                        ],
                        "is-supported-script": [
                            dt,
                            [
                                Et
                            ],
                            (R, [S])=>{
                                let D = R.globals && R.globals.isSupportedScript;
                                return !D || D(S.evaluate(R));
                            }
                        ],
                        upcase: [
                            Et,
                            [
                                Et
                            ],
                            (R, [S])=>S.evaluate(R).toUpperCase()
                        ],
                        downcase: [
                            Et,
                            [
                                Et
                            ],
                            (R, [S])=>S.evaluate(R).toLowerCase()
                        ],
                        concat: [
                            Et,
                            hf(fr),
                            (R, S)=>S.map((D)=>ka(D.evaluate(R))).join("")
                        ],
                        "resolved-locale": [
                            Et,
                            [
                                _r
                            ],
                            (R, [S])=>S.evaluate(R).resolvedLocale()
                        ]
                    });
                    class Pu {
                        constructor(S, D){
                            var j;
                            this.expression = S, this._warningHistory = {}, this._evaluator = new Ha, this._defaultValue = D ? (j = D).type === "color" && Ch(j.default) ? new Zt(0, 0, 0, 0) : j.type === "color" ? Zt.parse(j.default) || null : j.type === "padding" ? Vr.parse(j.default) || null : j.type === "variableAnchorOffsetCollection" ? Si.parse(j.default) || null : j.default === void 0 ? null : j.default : null, this._enumValues = D && D.type === "enum" ? D.values : null;
                        }
                        evaluateWithoutErrorHandling(S, D, j, te, ue, ve) {
                            return this._evaluator.globals = S, this._evaluator.feature = D, this._evaluator.featureState = j, this._evaluator.canonical = te, this._evaluator.availableImages = ue || null, this._evaluator.formattedSection = ve, this.expression.evaluate(this._evaluator);
                        }
                        evaluate(S, D, j, te, ue, ve) {
                            this._evaluator.globals = S, this._evaluator.feature = D || null, this._evaluator.featureState = j || null, this._evaluator.canonical = te, this._evaluator.availableImages = ue || null, this._evaluator.formattedSection = ve || null;
                            try {
                                let De = this.expression.evaluate(this._evaluator);
                                if (De == null || typeof De == "number" && De != De) return this._defaultValue;
                                if (this._enumValues && !(De in this._enumValues)) throw new la(`Expected value to be one of ${Object.keys(this._enumValues).map((Ze)=>JSON.stringify(Ze)).join(", ")}, but found ${JSON.stringify(De)} instead.`);
                                return De;
                            } catch (De) {
                                return this._warningHistory[De.message] || (this._warningHistory[De.message] = !0, typeof console != "undefined" && console.warn(De.message)), this._defaultValue;
                            }
                        }
                    }
                    function Lc(R) {
                        return Array.isArray(R) && R.length > 0 && typeof R[0] == "string" && R[0] in kf;
                    }
                    function fl(R, S) {
                        let D = new oo(kf, kh, [], S ? function(te) {
                            let ue = {
                                color: Ht,
                                string: Et,
                                number: St,
                                enum: Et,
                                boolean: dt,
                                formatted: Br,
                                padding: Or,
                                resolvedImage: Nr,
                                variableAnchorOffsetCollection: ut
                            };
                            return te.type === "array" ? Ne(ue[te.value] || fr, te.length) : ue[te.type];
                        }(S) : void 0), j = D.parse(R, void 0, void 0, void 0, S && S.type === "string" ? {
                            typeAnnotation: "coerce"
                        } : void 0);
                        return j ? Wc(new Pu(j, S)) : df(D.errors);
                    }
                    class Xc {
                        constructor(S, D){
                            this.kind = S, this._styleExpression = D, this.isStateDependent = S !== "constant" && !rc(D.expression);
                        }
                        evaluateWithoutErrorHandling(S, D, j, te, ue, ve) {
                            return this._styleExpression.evaluateWithoutErrorHandling(S, D, j, te, ue, ve);
                        }
                        evaluate(S, D, j, te, ue, ve) {
                            return this._styleExpression.evaluate(S, D, j, te, ue, ve);
                        }
                    }
                    class ic {
                        constructor(S, D, j, te){
                            this.kind = S, this.zoomStops = j, this._styleExpression = D, this.isStateDependent = S !== "camera" && !rc(D.expression), this.interpolationType = te;
                        }
                        evaluateWithoutErrorHandling(S, D, j, te, ue, ve) {
                            return this._styleExpression.evaluateWithoutErrorHandling(S, D, j, te, ue, ve);
                        }
                        evaluate(S, D, j, te, ue, ve) {
                            return this._styleExpression.evaluate(S, D, j, te, ue, ve);
                        }
                        interpolationFactor(S, D, j) {
                            return this.interpolationType ? xo.interpolationFactor(this.interpolationType, S, D, j) : 0;
                        }
                    }
                    function yu(R, S) {
                        let D = fl(R, S);
                        if (D.result === "error") return D;
                        let j = D.value.expression, te = Kh(j);
                        if (!te && !Cu(S)) return df([
                            new xt("", "data expressions not supported")
                        ]);
                        let ue = ah(j, [
                            "zoom"
                        ]);
                        if (!ue && !Nf(S)) return df([
                            new xt("", "zoom expressions not supported")
                        ]);
                        let ve = Qh(j);
                        return ve || ue ? ve instanceof xt ? df([
                            ve
                        ]) : ve instanceof xo && !Zc(S) ? df([
                            new xt("", '"interpolate" expressions cannot be used with this property')
                        ]) : Wc(ve ? new ic(te ? "camera" : "composite", D.value, ve.labels, ve instanceof xo ? ve.interpolation : void 0) : new Xc(te ? "constant" : "source", D.value)) : df([
                            new xt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
                        ]);
                    }
                    class Qs {
                        constructor(S, D){
                            this._parameters = S, this._specification = D, Ke(this, Jh(this._parameters, this._specification));
                        }
                        static deserialize(S) {
                            return new Qs(S._parameters, S._specification);
                        }
                        static serialize(S) {
                            return {
                                _parameters: S._parameters,
                                _specification: S._specification
                            };
                        }
                    }
                    function Qh(R) {
                        let S = null;
                        if (R instanceof xn) S = Qh(R.result);
                        else if (R instanceof ks) {
                            for (let D of R.args)if (S = Qh(D), S) break;
                        } else (R instanceof Ji || R instanceof xo) && R.input instanceof Ml && R.input.name === "zoom" && (S = R);
                        return S instanceof xt || R.eachChild((D)=>{
                            let j = Qh(D);
                            j instanceof xt ? S = j : !S && j ? S = new xt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : S && j && S !== j && (S = new xt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                        }), S;
                    }
                    function gd(R) {
                        if (R === !0 || R === !1) return !0;
                        if (!Array.isArray(R) || R.length === 0) return !1;
                        switch(R[0]){
                            case "has":
                                return R.length >= 2 && R[1] !== "$id" && R[1] !== "$type";
                            case "in":
                                return R.length >= 3 && (typeof R[1] != "string" || Array.isArray(R[2]));
                            case "!in":
                            case "!has":
                            case "none":
                                return !1;
                            case "==":
                            case "!=":
                            case ">":
                            case ">=":
                            case "<":
                            case "<=":
                                return R.length !== 3 || Array.isArray(R[1]) || Array.isArray(R[2]);
                            case "any":
                            case "all":
                                for (let S of R.slice(1))if (!gd(S) && typeof S != "boolean") return !1;
                                return !0;
                            default:
                                return !0;
                        }
                    }
                    let Gu = {
                        type: "boolean",
                        default: !1,
                        transition: !1,
                        "property-type": "data-driven",
                        expression: {
                            interpolated: !1,
                            parameters: [
                                "zoom",
                                "feature"
                            ]
                        }
                    };
                    function Pc(R) {
                        if (R == null) return {
                            filter: ()=>!0,
                            needGeometry: !1
                        };
                        gd(R) || (R = Lf(R));
                        let S = fl(R, Gu);
                        if (S.result === "error") throw new Error(S.value.map((D)=>`${D.key}: ${D.message}`).join(", "));
                        return {
                            filter: (D, j, te)=>S.value.evaluate(D, j, {}, te),
                            needGeometry: sv(R)
                        };
                    }
                    function vc(R, S) {
                        return R < S ? -1 : R > S ? 1 : 0;
                    }
                    function sv(R) {
                        if (!Array.isArray(R)) return !1;
                        if (R[0] === "within" || R[0] === "distance") return !0;
                        for(let S = 1; S < R.length; S++)if (sv(R[S])) return !0;
                        return !1;
                    }
                    function Lf(R) {
                        if (!R) return !0;
                        let S = R[0];
                        var D;
                        return R.length <= 1 ? S !== "any" : S === "==" ? Uf(R[1], R[2], "==") : S === "!=" ? ru(Uf(R[1], R[2], "==")) : S === "<" || S === ">" || S === "<=" || S === ">=" ? Uf(R[1], R[2], S) : S === "any" ? (D = R.slice(1), [
                            "any"
                        ].concat(D.map(Lf))) : S === "all" ? [
                            "all"
                        ].concat(R.slice(1).map(Lf)) : S === "none" ? [
                            "all"
                        ].concat(R.slice(1).map(Lf).map(ru)) : S === "in" ? Iu(R[1], R.slice(2)) : S === "!in" ? ru(Iu(R[1], R.slice(2))) : S === "has" ? oh(R[1]) : S !== "!has" || ru(oh(R[1]));
                    }
                    function Uf(R, S, D) {
                        switch(R){
                            case "$type":
                                return [
                                    `filter-type-${D}`,
                                    S
                                ];
                            case "$id":
                                return [
                                    `filter-id-${D}`,
                                    S
                                ];
                            default:
                                return [
                                    `filter-${D}`,
                                    R,
                                    S
                                ];
                        }
                    }
                    function Iu(R, S) {
                        if (S.length === 0) return !1;
                        switch(R){
                            case "$type":
                                return [
                                    "filter-type-in",
                                    [
                                        "literal",
                                        S
                                    ]
                                ];
                            case "$id":
                                return [
                                    "filter-id-in",
                                    [
                                        "literal",
                                        S
                                    ]
                                ];
                            default:
                                return S.length > 200 && !S.some((D)=>typeof D != typeof S[0]) ? [
                                    "filter-in-large",
                                    R,
                                    [
                                        "literal",
                                        S.sort(vc)
                                    ]
                                ] : [
                                    "filter-in-small",
                                    R,
                                    [
                                        "literal",
                                        S
                                    ]
                                ];
                        }
                    }
                    function oh(R) {
                        switch(R){
                            case "$type":
                                return !0;
                            case "$id":
                                return [
                                    "filter-has-id"
                                ];
                            default:
                                return [
                                    "filter-has",
                                    R
                                ];
                        }
                    }
                    function ru(R) {
                        return [
                            "!",
                            R
                        ];
                    }
                    function vf(R) {
                        let S = typeof R;
                        if (S === "number" || S === "boolean" || S === "string" || R == null) return JSON.stringify(R);
                        if (Array.isArray(R)) {
                            let te = "[";
                            for (let ue of R)te += `${vf(ue)},`;
                            return `${te}]`;
                        }
                        let D = Object.keys(R).sort(), j = "{";
                        for(let te = 0; te < D.length; te++)j += `${JSON.stringify(D[te])}:${vf(R[D[te]])},`;
                        return `${j}}`;
                    }
                    function md(R) {
                        let S = "";
                        for (let D of Ge)S += `/${vf(R[D])}`;
                        return S;
                    }
                    function sh(R) {
                        let S = R.value;
                        return S ? [
                            new er(R.key, S, "constants have been deprecated as of v8")
                        ] : [];
                    }
                    function Fs(R) {
                        return R instanceof Number || R instanceof String || R instanceof Boolean ? R.valueOf() : R;
                    }
                    function _u(R) {
                        if (Array.isArray(R)) return R.map(_u);
                        if (R instanceof Object && !(R instanceof Number || R instanceof String || R instanceof Boolean)) {
                            let S = {};
                            for(let D in R)S[D] = _u(R[D]);
                            return S;
                        }
                        return Fs(R);
                    }
                    function xu(R) {
                        let S = R.key, D = R.value, j = R.valueSpec || {}, te = R.objectElementValidators || {}, ue = R.style, ve = R.styleSpec, De = R.validateSpec, Ze = [], at = ds(D);
                        if (at !== "object") return [
                            new er(S, D, `object expected, ${at} found`)
                        ];
                        for(let Tt in D){
                            let Ft = Tt.split(".")[0], Qt = j[Ft] || j["*"], sr;
                            if (te[Ft]) sr = te[Ft];
                            else if (j[Ft]) sr = De;
                            else if (te["*"]) sr = te["*"];
                            else {
                                if (!j["*"]) {
                                    Ze.push(new er(S, D[Tt], `unknown property "${Tt}"`));
                                    continue;
                                }
                                sr = De;
                            }
                            Ze = Ze.concat(sr({
                                key: (S && `${S}.`) + Tt,
                                value: D[Tt],
                                valueSpec: Qt,
                                style: ue,
                                styleSpec: ve,
                                object: D,
                                objectKey: Tt,
                                validateSpec: De
                            }, D));
                        }
                        for(let Tt in j)te[Tt] || j[Tt].required && j[Tt].default === void 0 && D[Tt] === void 0 && Ze.push(new er(S, D, `missing required property "${Tt}"`));
                        return Ze;
                    }
                    function Lh(R) {
                        let S = R.value, D = R.valueSpec, j = R.style, te = R.styleSpec, ue = R.key, ve = R.arrayElementValidator || R.validateSpec;
                        if (ds(S) !== "array") return [
                            new er(ue, S, `array expected, ${ds(S)} found`)
                        ];
                        if (D.length && S.length !== D.length) return [
                            new er(ue, S, `array length ${D.length} expected, length ${S.length} found`)
                        ];
                        if (D["min-length"] && S.length < D["min-length"]) return [
                            new er(ue, S, `array length at least ${D["min-length"]} expected, length ${S.length} found`)
                        ];
                        let De = {
                            type: D.value,
                            values: D.values
                        };
                        te.$version < 7 && (De.function = D.function), ds(D.value) === "object" && (De = D.value);
                        let Ze = [];
                        for(let at = 0; at < S.length; at++)Ze = Ze.concat(ve({
                            array: S,
                            arrayIndex: at,
                            value: S[at],
                            valueSpec: De,
                            validateSpec: R.validateSpec,
                            style: j,
                            styleSpec: te,
                            key: `${ue}[${at}]`
                        }));
                        return Ze;
                    }
                    function Is(R) {
                        let S = R.key, D = R.value, j = R.valueSpec, te = ds(D);
                        return te === "number" && D != D && (te = "NaN"), te !== "number" ? [
                            new er(S, D, `number expected, ${te} found`)
                        ] : "minimum" in j && D < j.minimum ? [
                            new er(S, D, `${D} is less than the minimum value ${j.minimum}`)
                        ] : "maximum" in j && D > j.maximum ? [
                            new er(S, D, `${D} is greater than the maximum value ${j.maximum}`)
                        ] : [];
                    }
                    function Pf(R) {
                        let S = R.valueSpec, D = Fs(R.value.type), j, te, ue, ve = {}, De = D !== "categorical" && R.value.property === void 0, Ze = !De, at = ds(R.value.stops) === "array" && ds(R.value.stops[0]) === "array" && ds(R.value.stops[0][0]) === "object", Tt = xu({
                            key: R.key,
                            value: R.value,
                            valueSpec: R.styleSpec.function,
                            validateSpec: R.validateSpec,
                            style: R.style,
                            styleSpec: R.styleSpec,
                            objectElementValidators: {
                                stops: function(sr) {
                                    if (D === "identity") return [
                                        new er(sr.key, sr.value, 'identity function may not have a "stops" property')
                                    ];
                                    let Tr = [], Pr = sr.value;
                                    return Tr = Tr.concat(Lh({
                                        key: sr.key,
                                        value: Pr,
                                        valueSpec: sr.valueSpec,
                                        validateSpec: sr.validateSpec,
                                        style: sr.style,
                                        styleSpec: sr.styleSpec,
                                        arrayElementValidator: Ft
                                    })), ds(Pr) === "array" && Pr.length === 0 && Tr.push(new er(sr.key, Pr, "array must have at least one stop")), Tr;
                                },
                                default: function(sr) {
                                    return sr.validateSpec({
                                        key: sr.key,
                                        value: sr.value,
                                        valueSpec: S,
                                        validateSpec: sr.validateSpec,
                                        style: sr.style,
                                        styleSpec: sr.styleSpec
                                    });
                                }
                            }
                        });
                        return D === "identity" && De && Tt.push(new er(R.key, R.value, 'missing required property "property"')), D === "identity" || R.value.stops || Tt.push(new er(R.key, R.value, 'missing required property "stops"')), D === "exponential" && R.valueSpec.expression && !Zc(R.valueSpec) && Tt.push(new er(R.key, R.value, "exponential functions not supported")), R.styleSpec.$version >= 8 && (Ze && !Cu(R.valueSpec) ? Tt.push(new er(R.key, R.value, "property functions not supported")) : De && !Nf(R.valueSpec) && Tt.push(new er(R.key, R.value, "zoom functions not supported"))), D !== "categorical" && !at || R.value.property !== void 0 || Tt.push(new er(R.key, R.value, '"property" property is required')), Tt;
                        function Ft(sr) {
                            let Tr = [], Pr = sr.value, $r = sr.key;
                            if (ds(Pr) !== "array") return [
                                new er($r, Pr, `array expected, ${ds(Pr)} found`)
                            ];
                            if (Pr.length !== 2) return [
                                new er($r, Pr, `array length 2 expected, length ${Pr.length} found`)
                            ];
                            if (at) {
                                if (ds(Pr[0]) !== "object") return [
                                    new er($r, Pr, `object expected, ${ds(Pr[0])} found`)
                                ];
                                if (Pr[0].zoom === void 0) return [
                                    new er($r, Pr, "object stop key must have zoom")
                                ];
                                if (Pr[0].value === void 0) return [
                                    new er($r, Pr, "object stop key must have value")
                                ];
                                if (ue && ue > Fs(Pr[0].zoom)) return [
                                    new er($r, Pr[0].zoom, "stop zoom values must appear in ascending order")
                                ];
                                Fs(Pr[0].zoom) !== ue && (ue = Fs(Pr[0].zoom), te = void 0, ve = {}), Tr = Tr.concat(xu({
                                    key: `${$r}[0]`,
                                    value: Pr[0],
                                    valueSpec: {
                                        zoom: {}
                                    },
                                    validateSpec: sr.validateSpec,
                                    style: sr.style,
                                    styleSpec: sr.styleSpec,
                                    objectElementValidators: {
                                        zoom: Is,
                                        value: Qt
                                    }
                                }));
                            } else Tr = Tr.concat(Qt({
                                key: `${$r}[0]`,
                                value: Pr[0],
                                valueSpec: {},
                                validateSpec: sr.validateSpec,
                                style: sr.style,
                                styleSpec: sr.styleSpec
                            }, Pr));
                            return Lc(_u(Pr[1])) ? Tr.concat([
                                new er(`${$r}[1]`, Pr[1], "expressions are not allowed in function stops.")
                            ]) : Tr.concat(sr.validateSpec({
                                key: `${$r}[1]`,
                                value: Pr[1],
                                valueSpec: S,
                                validateSpec: sr.validateSpec,
                                style: sr.style,
                                styleSpec: sr.styleSpec
                            }));
                        }
                        function Qt(sr, Tr) {
                            let Pr = ds(sr.value), $r = Fs(sr.value), ni = sr.value !== null ? sr.value : Tr;
                            if (j) {
                                if (Pr !== j) return [
                                    new er(sr.key, ni, `${Pr} stop domain type must match previous stop domain type ${j}`)
                                ];
                            } else j = Pr;
                            if (Pr !== "number" && Pr !== "string" && Pr !== "boolean") return [
                                new er(sr.key, ni, "stop domain value must be a number, string, or boolean")
                            ];
                            if (Pr !== "number" && D !== "categorical") {
                                let Di = `number expected, ${Pr} found`;
                                return Cu(S) && D === void 0 && (Di += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                                    new er(sr.key, ni, Di)
                                ];
                            }
                            return D !== "categorical" || Pr !== "number" || isFinite($r) && Math.floor($r) === $r ? D !== "categorical" && Pr === "number" && te !== void 0 && $r < te ? [
                                new er(sr.key, ni, "stop domain values must appear in ascending order")
                            ] : (te = $r, D === "categorical" && $r in ve ? [
                                new er(sr.key, ni, "stop domain values must be unique")
                            ] : (ve[$r] = !0, [])) : [
                                new er(sr.key, ni, `integer expected, found ${$r}`)
                            ];
                        }
                    }
                    function Ic(R) {
                        let S = (R.expressionContext === "property" ? yu : fl)(_u(R.value), R.valueSpec);
                        if (S.result === "error") return S.value.map((j)=>new er(`${R.key}${j.key}`, R.value, j.message));
                        let D = S.value.expression || S.value._styleExpression.expression;
                        if (R.expressionContext === "property" && R.propertyKey === "text-font" && !D.outputDefined()) return [
                            new er(R.key, R.value, `Invalid data expression for "${R.propertyKey}". Output values must be contained as literals within the expression.`)
                        ];
                        if (R.expressionContext === "property" && R.propertyType === "layout" && !rc(D)) return [
                            new er(R.key, R.value, '"feature-state" data expressions are not supported with layout properties.')
                        ];
                        if (R.expressionContext === "filter" && !rc(D)) return [
                            new er(R.key, R.value, '"feature-state" data expressions are not supported with filters.')
                        ];
                        if (R.expressionContext && R.expressionContext.indexOf("cluster") === 0) {
                            if (!ah(D, [
                                "zoom",
                                "feature-state"
                            ])) return [
                                new er(R.key, R.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                            ];
                            if (R.expressionContext === "cluster-initial" && !Kh(D)) return [
                                new er(R.key, R.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                            ];
                        }
                        return [];
                    }
                    function ju(R) {
                        let S = R.key, D = R.value, j = R.valueSpec, te = [];
                        return Array.isArray(j.values) ? j.values.indexOf(Fs(D)) === -1 && te.push(new er(S, D, `expected one of [${j.values.join(", ")}], ${JSON.stringify(D)} found`)) : Object.keys(j.values).indexOf(Fs(D)) === -1 && te.push(new er(S, D, `expected one of [${Object.keys(j.values).join(", ")}], ${JSON.stringify(D)} found`)), te;
                    }
                    function Vf(R) {
                        return gd(_u(R.value)) ? Ic(Ke({}, R, {
                            expressionContext: "filter",
                            valueSpec: {
                                value: "boolean"
                            }
                        })) : pc(R);
                    }
                    function pc(R) {
                        let S = R.value, D = R.key;
                        if (ds(S) !== "array") return [
                            new er(D, S, `array expected, ${ds(S)} found`)
                        ];
                        let j = R.styleSpec, te, ue = [];
                        if (S.length < 1) return [
                            new er(D, S, "filter array must have at least 1 element")
                        ];
                        switch(ue = ue.concat(ju({
                            key: `${D}[0]`,
                            value: S[0],
                            valueSpec: j.filter_operator,
                            style: R.style,
                            styleSpec: R.styleSpec
                        })), Fs(S[0])){
                            case "<":
                            case "<=":
                            case ">":
                            case ">=":
                                S.length >= 2 && Fs(S[1]) === "$type" && ue.push(new er(D, S, `"$type" cannot be use with operator "${S[0]}"`));
                            case "==":
                            case "!=":
                                S.length !== 3 && ue.push(new er(D, S, `filter array for operator "${S[0]}" must have 3 elements`));
                            case "in":
                            case "!in":
                                S.length >= 2 && (te = ds(S[1]), te !== "string" && ue.push(new er(`${D}[1]`, S[1], `string expected, ${te} found`)));
                                for(let ve = 2; ve < S.length; ve++)te = ds(S[ve]), Fs(S[1]) === "$type" ? ue = ue.concat(ju({
                                    key: `${D}[${ve}]`,
                                    value: S[ve],
                                    valueSpec: j.geometry_type,
                                    style: R.style,
                                    styleSpec: R.styleSpec
                                })) : te !== "string" && te !== "number" && te !== "boolean" && ue.push(new er(`${D}[${ve}]`, S[ve], `string, number, or boolean expected, ${te} found`));
                                break;
                            case "any":
                            case "all":
                            case "none":
                                for(let ve = 1; ve < S.length; ve++)ue = ue.concat(pc({
                                    key: `${D}[${ve}]`,
                                    value: S[ve],
                                    style: R.style,
                                    styleSpec: R.styleSpec
                                }));
                                break;
                            case "has":
                            case "!has":
                                te = ds(S[1]), S.length !== 2 ? ue.push(new er(D, S, `filter array for "${S[0]}" operator must have 2 elements`)) : te !== "string" && ue.push(new er(`${D}[1]`, S[1], `string expected, ${te} found`));
                        }
                        return ue;
                    }
                    function pf(R, S) {
                        let D = R.key, j = R.validateSpec, te = R.style, ue = R.styleSpec, ve = R.value, De = R.objectKey, Ze = ue[`${S}_${R.layerType}`];
                        if (!Ze) return [];
                        let at = De.match(/^(.*)-transition$/);
                        if (S === "paint" && at && Ze[at[1]] && Ze[at[1]].transition) return j({
                            key: D,
                            value: ve,
                            valueSpec: ue.transition,
                            style: te,
                            styleSpec: ue
                        });
                        let Tt = R.valueSpec || Ze[De];
                        if (!Tt) return [
                            new er(D, ve, `unknown property "${De}"`)
                        ];
                        let Ft;
                        if (ds(ve) === "string" && Cu(Tt) && !Tt.tokens && (Ft = /^{([^}]+)}$/.exec(ve))) return [
                            new er(D, ve, `"${De}" does not support interpolation syntax
Use an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(Ft[1])} }\`.`)
                        ];
                        let Qt = [];
                        return R.layerType === "symbol" && (De === "text-field" && te && !te.glyphs && Qt.push(new er(D, ve, 'use of "text-field" requires a style "glyphs" property')), De === "text-font" && Ch(_u(ve)) && Fs(ve.type) === "identity" && Qt.push(new er(D, ve, '"text-font" does not support identity functions'))), Qt.concat(j({
                            key: R.key,
                            value: ve,
                            valueSpec: Tt,
                            style: te,
                            styleSpec: ue,
                            expressionContext: "property",
                            propertyType: S,
                            propertyKey: De
                        }));
                    }
                    function Ph(R) {
                        return pf(R, "paint");
                    }
                    function Dl(R) {
                        return pf(R, "layout");
                    }
                    function Ih(R) {
                        let S = [], D = R.value, j = R.key, te = R.style, ue = R.styleSpec;
                        D.type || D.ref || S.push(new er(j, D, 'either "type" or "ref" is required'));
                        let ve = Fs(D.type), De = Fs(D.ref);
                        if (D.id) {
                            let Ze = Fs(D.id);
                            for(let at = 0; at < R.arrayIndex; at++){
                                let Tt = te.layers[at];
                                Fs(Tt.id) === Ze && S.push(new er(j, D.id, `duplicate layer id "${D.id}", previously used at line ${Tt.id.__line__}`));
                            }
                        }
                        if ("ref" in D) {
                            let Ze;
                            [
                                "type",
                                "source",
                                "source-layer",
                                "filter",
                                "layout"
                            ].forEach((at)=>{
                                at in D && S.push(new er(j, D[at], `"${at}" is prohibited for ref layers`));
                            }), te.layers.forEach((at)=>{
                                Fs(at.id) === De && (Ze = at);
                            }), Ze ? Ze.ref ? S.push(new er(j, D.ref, "ref cannot reference another ref layer")) : ve = Fs(Ze.type) : S.push(new er(j, D.ref, `ref layer "${De}" not found`));
                        } else if (ve !== "background") {
                            if (D.source) {
                                let Ze = te.sources && te.sources[D.source], at = Ze && Fs(Ze.type);
                                Ze ? at === "vector" && ve === "raster" ? S.push(new er(j, D.source, `layer "${D.id}" requires a raster source`)) : at !== "raster-dem" && ve === "hillshade" ? S.push(new er(j, D.source, `layer "${D.id}" requires a raster-dem source`)) : at === "raster" && ve !== "raster" ? S.push(new er(j, D.source, `layer "${D.id}" requires a vector source`)) : at !== "vector" || D["source-layer"] ? at === "raster-dem" && ve !== "hillshade" ? S.push(new er(j, D.source, "raster-dem source can only be used with layer type 'hillshade'.")) : ve !== "line" || !D.paint || !D.paint["line-gradient"] || at === "geojson" && Ze.lineMetrics || S.push(new er(j, D, `layer "${D.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : S.push(new er(j, D, `layer "${D.id}" must specify a "source-layer"`)) : S.push(new er(j, D.source, `source "${D.source}" not found`));
                            } else S.push(new er(j, D, 'missing required property "source"'));
                        }
                        return S = S.concat(xu({
                            key: j,
                            value: D,
                            valueSpec: ue.layer,
                            style: R.style,
                            styleSpec: R.styleSpec,
                            validateSpec: R.validateSpec,
                            objectElementValidators: {
                                "*": ()=>[],
                                type: ()=>R.validateSpec({
                                        key: `${j}.type`,
                                        value: D.type,
                                        valueSpec: ue.layer.type,
                                        style: R.style,
                                        styleSpec: R.styleSpec,
                                        validateSpec: R.validateSpec,
                                        object: D,
                                        objectKey: "type"
                                    }),
                                filter: Vf,
                                layout: (Ze)=>xu({
                                        layer: D,
                                        key: Ze.key,
                                        value: Ze.value,
                                        style: Ze.style,
                                        styleSpec: Ze.styleSpec,
                                        validateSpec: Ze.validateSpec,
                                        objectElementValidators: {
                                            "*": (at)=>Dl(Ke({
                                                    layerType: ve
                                                }, at))
                                        }
                                    }),
                                paint: (Ze)=>xu({
                                        layer: D,
                                        key: Ze.key,
                                        value: Ze.value,
                                        style: Ze.style,
                                        styleSpec: Ze.styleSpec,
                                        validateSpec: Ze.validateSpec,
                                        objectElementValidators: {
                                            "*": (at)=>Ph(Ke({
                                                    layerType: ve
                                                }, at))
                                        }
                                    })
                            }
                        })), S;
                    }
                    function Wu(R) {
                        let S = R.value, D = R.key, j = ds(S);
                        return j !== "string" ? [
                            new er(D, S, `string expected, ${j} found`)
                        ] : [];
                    }
                    let Rc = {
                        promoteId: function({ key: R, value: S }) {
                            if (ds(S) === "string") return Wu({
                                key: R,
                                value: S
                            });
                            {
                                let D = [];
                                for(let j in S)D.push(...Wu({
                                    key: `${R}.${j}`,
                                    value: S[j]
                                }));
                                return D;
                            }
                        }
                    };
                    function gc(R) {
                        let S = R.value, D = R.key, j = R.styleSpec, te = R.style, ue = R.validateSpec;
                        if (!S.type) return [
                            new er(D, S, '"type" is required')
                        ];
                        let ve = Fs(S.type), De;
                        switch(ve){
                            case "vector":
                            case "raster":
                                return De = xu({
                                    key: D,
                                    value: S,
                                    valueSpec: j[`source_${ve.replace("-", "_")}`],
                                    style: R.style,
                                    styleSpec: j,
                                    objectElementValidators: Rc,
                                    validateSpec: ue
                                }), De;
                            case "raster-dem":
                                return De = function(Ze) {
                                    var at;
                                    let Tt = (at = Ze.sourceName) !== null && at !== void 0 ? at : "", Ft = Ze.value, Qt = Ze.styleSpec, sr = Qt.source_raster_dem, Tr = Ze.style, Pr = [], $r = ds(Ft);
                                    if (Ft === void 0) return Pr;
                                    if ($r !== "object") return Pr.push(new er("source_raster_dem", Ft, `object expected, ${$r} found`)), Pr;
                                    let ni = Fs(Ft.encoding) === "custom", Di = [
                                        "redFactor",
                                        "greenFactor",
                                        "blueFactor",
                                        "baseShift"
                                    ], pi = Ze.value.encoding ? `"${Ze.value.encoding}"` : "Default";
                                    for(let ki in Ft)!ni && Di.includes(ki) ? Pr.push(new er(ki, Ft[ki], `In "${Tt}": "${ki}" is only valid when "encoding" is set to "custom". ${pi} encoding found`)) : sr[ki] ? Pr = Pr.concat(Ze.validateSpec({
                                        key: ki,
                                        value: Ft[ki],
                                        valueSpec: sr[ki],
                                        validateSpec: Ze.validateSpec,
                                        style: Tr,
                                        styleSpec: Qt
                                    })) : Pr.push(new er(ki, Ft[ki], `unknown property "${ki}"`));
                                    return Pr;
                                }({
                                    sourceName: D,
                                    value: S,
                                    style: R.style,
                                    styleSpec: j,
                                    validateSpec: ue
                                }), De;
                            case "geojson":
                                if (De = xu({
                                    key: D,
                                    value: S,
                                    valueSpec: j.source_geojson,
                                    style: te,
                                    styleSpec: j,
                                    validateSpec: ue,
                                    objectElementValidators: Rc
                                }), S.cluster) for(let Ze in S.clusterProperties){
                                    let [at, Tt] = S.clusterProperties[Ze], Ft = typeof at == "string" ? [
                                        at,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            Ze
                                        ]
                                    ] : at;
                                    De.push(...Ic({
                                        key: `${D}.${Ze}.map`,
                                        value: Tt,
                                        validateSpec: ue,
                                        expressionContext: "cluster-map"
                                    })), De.push(...Ic({
                                        key: `${D}.${Ze}.reduce`,
                                        value: Ft,
                                        validateSpec: ue,
                                        expressionContext: "cluster-reduce"
                                    }));
                                }
                                return De;
                            case "video":
                                return xu({
                                    key: D,
                                    value: S,
                                    valueSpec: j.source_video,
                                    style: te,
                                    validateSpec: ue,
                                    styleSpec: j
                                });
                            case "image":
                                return xu({
                                    key: D,
                                    value: S,
                                    valueSpec: j.source_image,
                                    style: te,
                                    validateSpec: ue,
                                    styleSpec: j
                                });
                            case "canvas":
                                return [
                                    new er(D, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                                ];
                            default:
                                return ju({
                                    key: `${D}.type`,
                                    value: S.type,
                                    valueSpec: {
                                        values: [
                                            "vector",
                                            "raster",
                                            "raster-dem",
                                            "geojson",
                                            "video",
                                            "image"
                                        ]
                                    },
                                    style: te,
                                    validateSpec: ue,
                                    styleSpec: j
                                });
                        }
                    }
                    function hl(R) {
                        let S = R.value, D = R.styleSpec, j = D.light, te = R.style, ue = [], ve = ds(S);
                        if (S === void 0) return ue;
                        if (ve !== "object") return ue = ue.concat([
                            new er("light", S, `object expected, ${ve} found`)
                        ]), ue;
                        for(let De in S){
                            let Ze = De.match(/^(.*)-transition$/);
                            ue = ue.concat(Ze && j[Ze[1]] && j[Ze[1]].transition ? R.validateSpec({
                                key: De,
                                value: S[De],
                                valueSpec: D.transition,
                                validateSpec: R.validateSpec,
                                style: te,
                                styleSpec: D
                            }) : j[De] ? R.validateSpec({
                                key: De,
                                value: S[De],
                                valueSpec: j[De],
                                validateSpec: R.validateSpec,
                                style: te,
                                styleSpec: D
                            }) : [
                                new er(De, S[De], `unknown property "${De}"`)
                            ]);
                        }
                        return ue;
                    }
                    function iu(R) {
                        let S = R.value, D = R.styleSpec, j = D.sky, te = R.style, ue = ds(S);
                        if (S === void 0) return [];
                        if (ue !== "object") return [
                            new er("sky", S, `object expected, ${ue} found`)
                        ];
                        let ve = [];
                        for(let De in S)ve = ve.concat(j[De] ? R.validateSpec({
                            key: De,
                            value: S[De],
                            valueSpec: j[De],
                            style: te,
                            styleSpec: D
                        }) : [
                            new er(De, S[De], `unknown property "${De}"`)
                        ]);
                        return ve;
                    }
                    function mc(R) {
                        let S = R.value, D = R.styleSpec, j = D.terrain, te = R.style, ue = [], ve = ds(S);
                        if (S === void 0) return ue;
                        if (ve !== "object") return ue = ue.concat([
                            new er("terrain", S, `object expected, ${ve} found`)
                        ]), ue;
                        for(let De in S)ue = ue.concat(j[De] ? R.validateSpec({
                            key: De,
                            value: S[De],
                            valueSpec: j[De],
                            validateSpec: R.validateSpec,
                            style: te,
                            styleSpec: D
                        }) : [
                            new er(De, S[De], `unknown property "${De}"`)
                        ]);
                        return ue;
                    }
                    function Yc(R) {
                        let S = [], D = R.value, j = R.key;
                        if (Array.isArray(D)) {
                            let te = [], ue = [];
                            for(let ve in D)D[ve].id && te.includes(D[ve].id) && S.push(new er(j, D, `all the sprites' ids must be unique, but ${D[ve].id} is duplicated`)), te.push(D[ve].id), D[ve].url && ue.includes(D[ve].url) && S.push(new er(j, D, `all the sprites' URLs must be unique, but ${D[ve].url} is duplicated`)), ue.push(D[ve].url), S = S.concat(xu({
                                key: `${j}[${ve}]`,
                                value: D[ve],
                                valueSpec: {
                                    id: {
                                        type: "string",
                                        required: !0
                                    },
                                    url: {
                                        type: "string",
                                        required: !0
                                    }
                                },
                                validateSpec: R.validateSpec
                            }));
                            return S;
                        }
                        return Wu({
                            key: j,
                            value: D
                        });
                    }
                    let nc = {
                        "*": ()=>[],
                        array: Lh,
                        boolean: function(R) {
                            let S = R.value, D = R.key, j = ds(S);
                            return j !== "boolean" ? [
                                new er(D, S, `boolean expected, ${j} found`)
                            ] : [];
                        },
                        number: Is,
                        color: function(R) {
                            let S = R.key, D = R.value, j = ds(D);
                            return j !== "string" ? [
                                new er(S, D, `color expected, ${j} found`)
                            ] : Zt.parse(String(D)) ? [] : [
                                new er(S, D, `color expected, "${D}" found`)
                            ];
                        },
                        constants: sh,
                        enum: ju,
                        filter: Vf,
                        function: Pf,
                        layer: Ih,
                        object: xu,
                        source: gc,
                        light: hl,
                        sky: iu,
                        terrain: mc,
                        projection: function(R) {
                            let S = R.value, D = R.styleSpec, j = D.projection, te = R.style, ue = ds(S);
                            if (S === void 0) return [];
                            if (ue !== "object") return [
                                new er("projection", S, `object expected, ${ue} found`)
                            ];
                            let ve = [];
                            for(let De in S)ve = ve.concat(j[De] ? R.validateSpec({
                                key: De,
                                value: S[De],
                                valueSpec: j[De],
                                style: te,
                                styleSpec: D
                            }) : [
                                new er(De, S[De], `unknown property "${De}"`)
                            ]);
                            return ve;
                        },
                        string: Wu,
                        formatted: function(R) {
                            return Wu(R).length === 0 ? [] : Ic(R);
                        },
                        resolvedImage: function(R) {
                            return Wu(R).length === 0 ? [] : Ic(R);
                        },
                        padding: function(R) {
                            let S = R.key, D = R.value;
                            if (ds(D) === "array") {
                                if (D.length < 1 || D.length > 4) return [
                                    new er(S, D, `padding requires 1 to 4 values; ${D.length} values found`)
                                ];
                                let j = {
                                    type: "number"
                                }, te = [];
                                for(let ue = 0; ue < D.length; ue++)te = te.concat(R.validateSpec({
                                    key: `${S}[${ue}]`,
                                    value: D[ue],
                                    validateSpec: R.validateSpec,
                                    valueSpec: j
                                }));
                                return te;
                            }
                            return Is({
                                key: S,
                                value: D,
                                valueSpec: {}
                            });
                        },
                        variableAnchorOffsetCollection: function(R) {
                            let S = R.key, D = R.value, j = ds(D), te = R.styleSpec;
                            if (j !== "array" || D.length < 1 || D.length % 2 != 0) return [
                                new er(S, D, "variableAnchorOffsetCollection requires a non-empty array of even length")
                            ];
                            let ue = [];
                            for(let ve = 0; ve < D.length; ve += 2)ue = ue.concat(ju({
                                key: `${S}[${ve}]`,
                                value: D[ve],
                                valueSpec: te.layout_symbol["text-anchor"]
                            })), ue = ue.concat(Lh({
                                key: `${S}[${ve + 1}]`,
                                value: D[ve + 1],
                                valueSpec: {
                                    length: 2,
                                    value: "number"
                                },
                                validateSpec: R.validateSpec,
                                style: R.style,
                                styleSpec: te
                            }));
                            return ue;
                        },
                        sprite: Yc
                    };
                    function gf(R) {
                        let S = R.value, D = R.valueSpec, j = R.styleSpec;
                        return R.validateSpec = gf, D.expression && Ch(Fs(S)) ? Pf(R) : D.expression && Lc(_u(S)) ? Ic(R) : D.type && nc[D.type] ? nc[D.type](R) : xu(Ke({}, R, {
                            valueSpec: D.type ? j[D.type] : D
                        }));
                    }
                    function gt(R) {
                        let S = R.value, D = R.key, j = Wu(R);
                        return j.length || (S.indexOf("{fontstack}") === -1 && j.push(new er(D, S, '"glyphs" url must include a "{fontstack}" token')), S.indexOf("{range}") === -1 && j.push(new er(D, S, '"glyphs" url must include a "{range}" token'))), j;
                    }
                    function Bt(R, S = ce) {
                        let D = [];
                        return D = D.concat(gf({
                            key: "",
                            value: R,
                            valueSpec: S.$root,
                            styleSpec: S,
                            style: R,
                            validateSpec: gf,
                            objectElementValidators: {
                                glyphs: gt,
                                "*": ()=>[]
                            }
                        })), R.constants && (D = D.concat(sh({
                            key: "constants",
                            value: R.constants,
                            style: R,
                            styleSpec: S,
                            validateSpec: gf
                        }))), vr(D);
                    }
                    function wr(R) {
                        return function(S) {
                            return R($Q(JQ({}, S), {
                                validateSpec: gf
                            }));
                        };
                    }
                    function vr(R) {
                        return [].concat(R).sort((S, D)=>S.line - D.line);
                    }
                    function Ur(R) {
                        return function(...S) {
                            return vr(R.apply(this, S));
                        };
                    }
                    Bt.source = Ur(wr(gc)), Bt.sprite = Ur(wr(Yc)), Bt.glyphs = Ur(wr(gt)), Bt.light = Ur(wr(hl)), Bt.sky = Ur(wr(iu)), Bt.terrain = Ur(wr(mc)), Bt.layer = Ur(wr(Ih)), Bt.filter = Ur(wr(Vf)), Bt.paintProperty = Ur(wr(Ph)), Bt.layoutProperty = Ur(wr(Dl));
                    let fi = Bt, xi = fi.light, Fi = fi.sky, Xi = fi.paintProperty, hn = fi.layoutProperty;
                    function Ti(R, S) {
                        let D = !1;
                        if (S && S.length) for (let j of S)R.fire(new me(new Error(j.message))), D = !0;
                        return D;
                    }
                    class qi {
                        constructor(S, D, j){
                            let te = this.cells = [];
                            if (S instanceof ArrayBuffer) {
                                this.arrayBuffer = S;
                                let ve = new Int32Array(this.arrayBuffer);
                                S = ve[0], this.d = (D = ve[1]) + 2 * (j = ve[2]);
                                for(let Ze = 0; Ze < this.d * this.d; Ze++){
                                    let at = ve[3 + Ze], Tt = ve[3 + Ze + 1];
                                    te.push(at === Tt ? null : ve.subarray(at, Tt));
                                }
                                let De = ve[3 + te.length + 1];
                                this.keys = ve.subarray(ve[3 + te.length], De), this.bboxes = ve.subarray(De), this.insert = this._insertReadonly;
                            } else {
                                this.d = D + 2 * j;
                                for(let ve = 0; ve < this.d * this.d; ve++)te.push([]);
                                this.keys = [], this.bboxes = [];
                            }
                            this.n = D, this.extent = S, this.padding = j, this.scale = D / S, this.uid = 0;
                            let ue = j / D * S;
                            this.min = -ue, this.max = S + ue;
                        }
                        insert(S, D, j, te, ue) {
                            this._forEachCell(D, j, te, ue, this._insertCell, this.uid++, void 0, void 0), this.keys.push(S), this.bboxes.push(D), this.bboxes.push(j), this.bboxes.push(te), this.bboxes.push(ue);
                        }
                        _insertReadonly() {
                            throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
                        }
                        _insertCell(S, D, j, te, ue, ve) {
                            this.cells[ue].push(ve);
                        }
                        query(S, D, j, te, ue) {
                            let ve = this.min, De = this.max;
                            if (S <= ve && D <= ve && De <= j && De <= te && !ue) return Array.prototype.slice.call(this.keys);
                            {
                                let Ze = [];
                                return this._forEachCell(S, D, j, te, this._queryCell, Ze, {}, ue), Ze;
                            }
                        }
                        _queryCell(S, D, j, te, ue, ve, De, Ze) {
                            let at = this.cells[ue];
                            if (at !== null) {
                                let Tt = this.keys, Ft = this.bboxes;
                                for(let Qt = 0; Qt < at.length; Qt++){
                                    let sr = at[Qt];
                                    if (De[sr] === void 0) {
                                        let Tr = 4 * sr;
                                        (Ze ? Ze(Ft[Tr + 0], Ft[Tr + 1], Ft[Tr + 2], Ft[Tr + 3]) : S <= Ft[Tr + 2] && D <= Ft[Tr + 3] && j >= Ft[Tr + 0] && te >= Ft[Tr + 1]) ? (De[sr] = !0, ve.push(Tt[sr])) : De[sr] = !1;
                                    }
                                }
                            }
                        }
                        _forEachCell(S, D, j, te, ue, ve, De, Ze) {
                            let at = this._convertToCellCoord(S), Tt = this._convertToCellCoord(D), Ft = this._convertToCellCoord(j), Qt = this._convertToCellCoord(te);
                            for(let sr = at; sr <= Ft; sr++)for(let Tr = Tt; Tr <= Qt; Tr++){
                                let Pr = this.d * Tr + sr;
                                if ((!Ze || Ze(this._convertFromCellCoord(sr), this._convertFromCellCoord(Tr), this._convertFromCellCoord(sr + 1), this._convertFromCellCoord(Tr + 1))) && ue.call(this, S, D, j, te, Pr, ve, De, Ze)) return;
                            }
                        }
                        _convertFromCellCoord(S) {
                            return (S - this.padding) / this.scale;
                        }
                        _convertToCellCoord(S) {
                            return Math.max(0, Math.min(this.d - 1, Math.floor(S * this.scale) + this.padding));
                        }
                        toArrayBuffer() {
                            if (this.arrayBuffer) return this.arrayBuffer;
                            let S = this.cells, D = 3 + this.cells.length + 1 + 1, j = 0;
                            for(let ve = 0; ve < this.cells.length; ve++)j += this.cells[ve].length;
                            let te = new Int32Array(D + j + this.keys.length + this.bboxes.length);
                            te[0] = this.extent, te[1] = this.n, te[2] = this.padding;
                            let ue = D;
                            for(let ve = 0; ve < S.length; ve++){
                                let De = S[ve];
                                te[3 + ve] = ue, te.set(De, ue), ue += De.length;
                            }
                            return te[3 + S.length] = ue, te.set(this.keys, ue), ue += this.keys.length, te[3 + S.length + 1] = ue, te.set(this.bboxes, ue), ue += this.bboxes.length, te.buffer;
                        }
                        static serialize(S, D) {
                            let j = S.toArrayBuffer();
                            return D && D.push(j), {
                                buffer: j
                            };
                        }
                        static deserialize(S) {
                            return new qi(S.buffer);
                        }
                    }
                    let Ii = {};
                    function mi(R, S, D = {}) {
                        if (Ii[R]) throw new Error(`${R} is already registered.`);
                        Object.defineProperty(S, "_classRegistryKey", {
                            value: R,
                            writeable: !1
                        }), Ii[R] = {
                            klass: S,
                            omit: D.omit || [],
                            shallow: D.shallow || []
                        };
                    }
                    mi("Object", Object), mi("TransferableGridIndex", qi), mi("Color", Zt), mi("Error", Error), mi("AJAXError", ge), mi("ResolvedImage", Mi), mi("StylePropertyFunction", Qs), mi("StyleExpression", Pu, {
                        omit: [
                            "_evaluator"
                        ]
                    }), mi("ZoomDependentExpression", ic), mi("ZoomConstantExpression", Xc), mi("CompoundExpression", Ml, {
                        omit: [
                            "_evaluate"
                        ]
                    });
                    for(let R in kf)kf[R]._classRegistryKey || mi(`Expression_${R}`, kf[R]);
                    function Pn(R) {
                        return R && typeof ArrayBuffer != "undefined" && (R instanceof ArrayBuffer || R.constructor && R.constructor.name === "ArrayBuffer");
                    }
                    function Ma(R) {
                        return R.$name || R.constructor._classRegistryKey;
                    }
                    function Ta(R) {
                        return !function(S) {
                            if (S === null || typeof S != "object") return !1;
                            let D = Ma(S);
                            return !(!D || D === "Object");
                        }(R) && (R == null || typeof R == "boolean" || typeof R == "number" || typeof R == "string" || R instanceof Boolean || R instanceof Number || R instanceof String || R instanceof Date || R instanceof RegExp || R instanceof Blob || R instanceof Error || Pn(R) || H(R) || ArrayBuffer.isView(R) || R instanceof ImageData);
                    }
                    function Ea(R, S) {
                        if (Ta(R)) return (Pn(R) || H(R)) && S && S.push(R), ArrayBuffer.isView(R) && S && S.push(R.buffer), R instanceof ImageData && S && S.push(R.data.buffer), R;
                        if (Array.isArray(R)) {
                            let ue = [];
                            for (let ve of R)ue.push(Ea(ve, S));
                            return ue;
                        }
                        if (typeof R != "object") throw new Error("can't serialize object of type " + typeof R);
                        let D = Ma(R);
                        if (!D) throw new Error(`can't serialize object of unregistered class ${R.constructor.name}`);
                        if (!Ii[D]) throw new Error(`${D} is not registered.`);
                        let { klass: j } = Ii[D], te = j.serialize ? j.serialize(R, S) : {};
                        if (j.serialize) {
                            if (S && te === S[S.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
                        } else {
                            for(let ue in R){
                                if (!R.hasOwnProperty(ue) || Ii[D].omit.indexOf(ue) >= 0) continue;
                                let ve = R[ue];
                                te[ue] = Ii[D].shallow.indexOf(ue) >= 0 ? ve : Ea(ve, S);
                            }
                            R instanceof Error && (te.message = R.message);
                        }
                        if (te.$name) throw new Error("$name property is reserved for worker serialization logic.");
                        return D !== "Object" && (te.$name = D), te;
                    }
                    function qa(R) {
                        if (Ta(R)) return R;
                        if (Array.isArray(R)) return R.map(qa);
                        if (typeof R != "object") throw new Error("can't deserialize object of type " + typeof R);
                        let S = Ma(R) || "Object";
                        if (!Ii[S]) throw new Error(`can't deserialize unregistered class ${S}`);
                        let { klass: D } = Ii[S];
                        if (!D) throw new Error(`can't deserialize unregistered class ${S}`);
                        if (D.deserialize) return D.deserialize(R);
                        let j = Object.create(D.prototype);
                        for (let te of Object.keys(R)){
                            if (te === "$name") continue;
                            let ue = R[te];
                            j[te] = Ii[S].shallow.indexOf(te) >= 0 ? ue : qa(ue);
                        }
                        return j;
                    }
                    class Cn {
                        constructor(){
                            this.first = !0;
                        }
                        update(S, D) {
                            let j = Math.floor(S);
                            return this.first ? (this.first = !1, this.lastIntegerZoom = j, this.lastIntegerZoomTime = 0, this.lastZoom = S, this.lastFloorZoom = j, !0) : (this.lastFloorZoom > j ? (this.lastIntegerZoom = j + 1, this.lastIntegerZoomTime = D) : this.lastFloorZoom < j && (this.lastIntegerZoom = j, this.lastIntegerZoomTime = D), S !== this.lastZoom && (this.lastZoom = S, this.lastFloorZoom = j, !0));
                        }
                    }
                    let sn = {
                        "Latin-1 Supplement": (R)=>R >= 128 && R <= 255,
                        "Hangul Jamo": (R)=>R >= 4352 && R <= 4607,
                        Khmer: (R)=>R >= 6016 && R <= 6143,
                        "General Punctuation": (R)=>R >= 8192 && R <= 8303,
                        "Letterlike Symbols": (R)=>R >= 8448 && R <= 8527,
                        "Number Forms": (R)=>R >= 8528 && R <= 8591,
                        "Miscellaneous Technical": (R)=>R >= 8960 && R <= 9215,
                        "Control Pictures": (R)=>R >= 9216 && R <= 9279,
                        "Optical Character Recognition": (R)=>R >= 9280 && R <= 9311,
                        "Enclosed Alphanumerics": (R)=>R >= 9312 && R <= 9471,
                        "Geometric Shapes": (R)=>R >= 9632 && R <= 9727,
                        "Miscellaneous Symbols": (R)=>R >= 9728 && R <= 9983,
                        "Miscellaneous Symbols and Arrows": (R)=>R >= 11008 && R <= 11263,
                        "Ideographic Description Characters": (R)=>R >= 12272 && R <= 12287,
                        "CJK Symbols and Punctuation": (R)=>R >= 12288 && R <= 12351,
                        Katakana: (R)=>R >= 12448 && R <= 12543,
                        Kanbun: (R)=>R >= 12688 && R <= 12703,
                        "CJK Strokes": (R)=>R >= 12736 && R <= 12783,
                        "Enclosed CJK Letters and Months": (R)=>R >= 12800 && R <= 13055,
                        "CJK Compatibility": (R)=>R >= 13056 && R <= 13311,
                        "Yijing Hexagram Symbols": (R)=>R >= 19904 && R <= 19967,
                        "Private Use Area": (R)=>R >= 57344 && R <= 63743,
                        "Vertical Forms": (R)=>R >= 65040 && R <= 65055,
                        "CJK Compatibility Forms": (R)=>R >= 65072 && R <= 65103,
                        "Small Form Variants": (R)=>R >= 65104 && R <= 65135,
                        "Halfwidth and Fullwidth Forms": (R)=>R >= 65280 && R <= 65519
                    };
                    function Ua(R) {
                        for (let S of R)if (Bo(S.charCodeAt(0))) return !0;
                        return !1;
                    }
                    function mo(R) {
                        for (let S of R)if (!Qo(S.charCodeAt(0))) return !1;
                        return !0;
                    }
                    function Xo(R) {
                        let S = R.map((D)=>{
                            try {
                                return new RegExp(`\\p{sc=${D}}`, "u").source;
                            } catch (j) {
                                return null;
                            }
                        }).filter((D)=>D);
                        return new RegExp(S.join("|"), "u");
                    }
                    let Ts = Xo([
                        "Arab",
                        "Dupl",
                        "Mong",
                        "Ougr",
                        "Syrc"
                    ]);
                    function Qo(R) {
                        return !Ts.test(String.fromCodePoint(R));
                    }
                    let ys = Xo([
                        "Bopo",
                        "Hani",
                        "Hira",
                        "Kana",
                        "Kits",
                        "Nshu",
                        "Tang",
                        "Yiii"
                    ]);
                    function Bo(R) {
                        return !(R !== 746 && R !== 747 && (R < 4352 || !(sn["CJK Compatibility Forms"](R) && !(R >= 65097 && R <= 65103) || sn["CJK Compatibility"](R) || sn["CJK Strokes"](R) || !(!sn["CJK Symbols and Punctuation"](R) || R >= 12296 && R <= 12305 || R >= 12308 && R <= 12319 || R === 12336) || sn["Enclosed CJK Letters and Months"](R) || sn["Ideographic Description Characters"](R) || sn.Kanbun(R) || sn.Katakana(R) && R !== 12540 || !(!sn["Halfwidth and Fullwidth Forms"](R) || R === 65288 || R === 65289 || R === 65293 || R >= 65306 && R <= 65310 || R === 65339 || R === 65341 || R === 65343 || R >= 65371 && R <= 65503 || R === 65507 || R >= 65512 && R <= 65519) || !(!sn["Small Form Variants"](R) || R >= 65112 && R <= 65118 || R >= 65123 && R <= 65126) || sn["Vertical Forms"](R) || sn["Yijing Hexagram Symbols"](R) || new RegExp("\\p{sc=Cans}", "u").test(String.fromCodePoint(R)) || new RegExp("\\p{sc=Hang}", "u").test(String.fromCodePoint(R)) || ys.test(String.fromCodePoint(R)))));
                    }
                    function yl(R) {
                        return !(Bo(R) || function(S) {
                            return !!(sn["Latin-1 Supplement"](S) && (S === 167 || S === 169 || S === 174 || S === 177 || S === 188 || S === 189 || S === 190 || S === 215 || S === 247) || sn["General Punctuation"](S) && (S === 8214 || S === 8224 || S === 8225 || S === 8240 || S === 8241 || S === 8251 || S === 8252 || S === 8258 || S === 8263 || S === 8264 || S === 8265 || S === 8273) || sn["Letterlike Symbols"](S) || sn["Number Forms"](S) || sn["Miscellaneous Technical"](S) && (S >= 8960 && S <= 8967 || S >= 8972 && S <= 8991 || S >= 8996 && S <= 9e3 || S === 9003 || S >= 9085 && S <= 9114 || S >= 9150 && S <= 9165 || S === 9167 || S >= 9169 && S <= 9179 || S >= 9186 && S <= 9215) || sn["Control Pictures"](S) && S !== 9251 || sn["Optical Character Recognition"](S) || sn["Enclosed Alphanumerics"](S) || sn["Geometric Shapes"](S) || sn["Miscellaneous Symbols"](S) && !(S >= 9754 && S <= 9759) || sn["Miscellaneous Symbols and Arrows"](S) && (S >= 11026 && S <= 11055 || S >= 11088 && S <= 11097 || S >= 11192 && S <= 11243) || sn["CJK Symbols and Punctuation"](S) || sn.Katakana(S) || sn["Private Use Area"](S) || sn["CJK Compatibility Forms"](S) || sn["Small Form Variants"](S) || sn["Halfwidth and Fullwidth Forms"](S) || S === 8734 || S === 8756 || S === 8757 || S >= 9984 && S <= 10087 || S >= 10102 && S <= 10131 || S === 65532 || S === 65533);
                        }(R));
                    }
                    let Gs = Xo([
                        "Adlm",
                        "Arab",
                        "Armi",
                        "Avst",
                        "Chrs",
                        "Cprt",
                        "Egyp",
                        "Elym",
                        "Gara",
                        "Hatr",
                        "Hebr",
                        "Hung",
                        "Khar",
                        "Lydi",
                        "Mand",
                        "Mani",
                        "Mend",
                        "Merc",
                        "Mero",
                        "Narb",
                        "Nbat",
                        "Nkoo",
                        "Orkh",
                        "Palm",
                        "Phli",
                        "Phlp",
                        "Phnx",
                        "Prti",
                        "Rohg",
                        "Samr",
                        "Sarb",
                        "Sogo",
                        "Syrc",
                        "Thaa",
                        "Todr",
                        "Yezi"
                    ]);
                    function Rs(R) {
                        return Gs.test(String.fromCodePoint(R));
                    }
                    function ia(R, S) {
                        return !(!S && Rs(R) || R >= 2304 && R <= 3583 || R >= 3840 && R <= 4255 || sn.Khmer(R));
                    }
                    function Ka(R) {
                        for (let S of R)if (Rs(S.charCodeAt(0))) return !0;
                        return !1;
                    }
                    let vs = new class {
                        constructor(){
                            this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null;
                        }
                        setState(R) {
                            this.pluginStatus = R.pluginStatus, this.pluginURL = R.pluginURL;
                        }
                        getState() {
                            return {
                                pluginStatus: this.pluginStatus,
                                pluginURL: this.pluginURL
                            };
                        }
                        setMethods(R) {
                            this.applyArabicShaping = R.applyArabicShaping, this.processBidirectionalText = R.processBidirectionalText, this.processStyledBidirectionalText = R.processStyledBidirectionalText;
                        }
                        isParsed() {
                            return this.applyArabicShaping != null && this.processBidirectionalText != null && this.processStyledBidirectionalText != null;
                        }
                        getPluginURL() {
                            return this.pluginURL;
                        }
                        getRTLTextPluginStatus() {
                            return this.pluginStatus;
                        }
                    };
                    class Ko {
                        constructor(S, D){
                            this.zoom = S, D ? (this.now = D.now, this.fadeDuration = D.fadeDuration, this.zoomHistory = D.zoomHistory, this.transition = D.transition) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Cn, this.transition = {});
                        }
                        isSupportedScript(S) {
                            return function(D, j) {
                                for (let te of D)if (!ia(te.charCodeAt(0), j)) return !1;
                                return !0;
                            }(S, vs.getRTLTextPluginStatus() === "loaded");
                        }
                        crossFadingFactor() {
                            return this.fadeDuration === 0 ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
                        }
                        getCrossfadeParameters() {
                            let S = this.zoom, D = S - Math.floor(S), j = this.crossFadingFactor();
                            return S > this.zoomHistory.lastIntegerZoom ? {
                                fromScale: 2,
                                toScale: 1,
                                t: D + (1 - D) * j
                            } : {
                                fromScale: .5,
                                toScale: 1,
                                t: 1 - (1 - j) * D
                            };
                        }
                    }
                    class nu {
                        constructor(S, D){
                            this.property = S, this.value = D, this.expression = function(j, te) {
                                if (Ch(j)) return new Qs(j, te);
                                if (Lc(j)) {
                                    let ue = yu(j, te);
                                    if (ue.result === "error") throw new Error(ue.value.map((ve)=>`${ve.key}: ${ve.message}`).join(", "));
                                    return ue.value;
                                }
                                {
                                    let ue = j;
                                    return te.type === "color" && typeof j == "string" ? ue = Zt.parse(j) : te.type !== "padding" || typeof j != "number" && !Array.isArray(j) ? te.type === "variableAnchorOffsetCollection" && Array.isArray(j) && (ue = Si.parse(j)) : ue = Vr.parse(j), {
                                        kind: "constant",
                                        evaluate: ()=>ue
                                    };
                                }
                            }(D === void 0 ? S.specification.default : D, S.specification);
                        }
                        isDataDriven() {
                            return this.expression.kind === "source" || this.expression.kind === "composite";
                        }
                        possiblyEvaluate(S, D, j) {
                            return this.property.possiblyEvaluate(this, S, D, j);
                        }
                    }
                    class Ru {
                        constructor(S){
                            this.property = S, this.value = new nu(S, void 0);
                        }
                        transitioned(S, D) {
                            return new mf(this.property, this.value, D, L({}, S.transition, this.transition), S.now);
                        }
                        untransitioned() {
                            return new mf(this.property, this.value, null, {}, 0);
                        }
                    }
                    class ac {
                        constructor(S){
                            this._properties = S, this._values = Object.create(S.defaultTransitionablePropertyValues);
                        }
                        getValue(S) {
                            return g(this._values[S].value.value);
                        }
                        setValue(S, D) {
                            Object.prototype.hasOwnProperty.call(this._values, S) || (this._values[S] = new Ru(this._values[S].property)), this._values[S].value = new nu(this._values[S].property, D === null ? void 0 : g(D));
                        }
                        getTransition(S) {
                            return g(this._values[S].transition);
                        }
                        setTransition(S, D) {
                            Object.prototype.hasOwnProperty.call(this._values, S) || (this._values[S] = new Ru(this._values[S].property)), this._values[S].transition = g(D) || void 0;
                        }
                        serialize() {
                            let S = {};
                            for (let D of Object.keys(this._values)){
                                let j = this.getValue(D);
                                j !== void 0 && (S[D] = j);
                                let te = this.getTransition(D);
                                te !== void 0 && (S[`${D}-transition`] = te);
                            }
                            return S;
                        }
                        transitioned(S, D) {
                            let j = new bu(this._properties);
                            for (let te of Object.keys(this._values))j._values[te] = this._values[te].transitioned(S, D._values[te]);
                            return j;
                        }
                        untransitioned() {
                            let S = new bu(this._properties);
                            for (let D of Object.keys(this._values))S._values[D] = this._values[D].untransitioned();
                            return S;
                        }
                    }
                    class mf {
                        constructor(S, D, j, te, ue){
                            this.property = S, this.value = D, this.begin = ue + te.delay || 0, this.end = this.begin + te.duration || 0, S.specification.transition && (te.delay || te.duration) && (this.prior = j);
                        }
                        possiblyEvaluate(S, D, j) {
                            let te = S.now || 0, ue = this.value.possiblyEvaluate(S, D, j), ve = this.prior;
                            if (ve) {
                                if (te > this.end) return this.prior = null, ue;
                                if (this.value.isDataDriven()) return this.prior = null, ue;
                                if (te < this.begin) return ve.possiblyEvaluate(S, D, j);
                                {
                                    let De = (te - this.begin) / (this.end - this.begin);
                                    return this.property.interpolate(ve.possiblyEvaluate(S, D, j), ue, function(Ze) {
                                        if (Ze <= 0) return 0;
                                        if (Ze >= 1) return 1;
                                        let at = Ze * Ze, Tt = at * Ze;
                                        return 4 * (Ze < .5 ? Tt : 3 * (Ze - at) + Tt - .75);
                                    }(De));
                                }
                            }
                            return ue;
                        }
                    }
                    class bu {
                        constructor(S){
                            this._properties = S, this._values = Object.create(S.defaultTransitioningPropertyValues);
                        }
                        possiblyEvaluate(S, D, j) {
                            let te = new Dc(this._properties);
                            for (let ue of Object.keys(this._values))te._values[ue] = this._values[ue].possiblyEvaluate(S, D, j);
                            return te;
                        }
                        hasTransition() {
                            for (let S of Object.keys(this._values))if (this._values[S].prior) return !0;
                            return !1;
                        }
                    }
                    class Kc {
                        constructor(S){
                            this._properties = S, this._values = Object.create(S.defaultPropertyValues);
                        }
                        hasValue(S) {
                            return this._values[S].value !== void 0;
                        }
                        getValue(S) {
                            return g(this._values[S].value);
                        }
                        setValue(S, D) {
                            this._values[S] = new nu(this._values[S].property, D === null ? void 0 : g(D));
                        }
                        serialize() {
                            let S = {};
                            for (let D of Object.keys(this._values)){
                                let j = this.getValue(D);
                                j !== void 0 && (S[D] = j);
                            }
                            return S;
                        }
                        possiblyEvaluate(S, D, j) {
                            let te = new Dc(this._properties);
                            for (let ue of Object.keys(this._values))te._values[ue] = this._values[ue].possiblyEvaluate(S, D, j);
                            return te;
                        }
                    }
                    class Du {
                        constructor(S, D, j){
                            this.property = S, this.value = D, this.parameters = j;
                        }
                        isConstant() {
                            return this.value.kind === "constant";
                        }
                        constantOr(S) {
                            return this.value.kind === "constant" ? this.value.value : S;
                        }
                        evaluate(S, D, j, te) {
                            return this.property.evaluate(this.value, this.parameters, S, D, j, te);
                        }
                    }
                    class Dc {
                        constructor(S){
                            this._properties = S, this._values = Object.create(S.defaultPossiblyEvaluatedValues);
                        }
                        get(S) {
                            return this._values[S];
                        }
                    }
                    class Da {
                        constructor(S){
                            this.specification = S;
                        }
                        possiblyEvaluate(S, D) {
                            if (S.isDataDriven()) throw new Error("Value should not be data driven");
                            return S.expression.evaluate(D);
                        }
                        interpolate(S, D, j) {
                            let te = Mo[this.specification.type];
                            return te ? te(S, D, j) : S;
                        }
                    }
                    class eo {
                        constructor(S, D){
                            this.specification = S, this.overrides = D;
                        }
                        possiblyEvaluate(S, D, j, te) {
                            return new Du(this, S.expression.kind === "constant" || S.expression.kind === "camera" ? {
                                kind: "constant",
                                value: S.expression.evaluate(D, null, {}, j, te)
                            } : S.expression, D);
                        }
                        interpolate(S, D, j) {
                            if (S.value.kind !== "constant" || D.value.kind !== "constant") return S;
                            if (S.value.value === void 0 || D.value.value === void 0) return new Du(this, {
                                kind: "constant",
                                value: void 0
                            }, S.parameters);
                            let te = Mo[this.specification.type];
                            if (te) {
                                let ue = te(S.value.value, D.value.value, j);
                                return new Du(this, {
                                    kind: "constant",
                                    value: ue
                                }, S.parameters);
                            }
                            return S;
                        }
                        evaluate(S, D, j, te, ue, ve) {
                            return S.kind === "constant" ? S.value : S.evaluate(D, j, te, ue, ve);
                        }
                    }
                    class Jc extends eo {
                        possiblyEvaluate(S, D, j, te) {
                            if (S.value === void 0) return new Du(this, {
                                kind: "constant",
                                value: void 0
                            }, D);
                            if (S.expression.kind === "constant") {
                                let ue = S.expression.evaluate(D, null, {}, j, te), ve = S.property.specification.type === "resolvedImage" && typeof ue != "string" ? ue.name : ue, De = this._calculate(ve, ve, ve, D);
                                return new Du(this, {
                                    kind: "constant",
                                    value: De
                                }, D);
                            }
                            if (S.expression.kind === "camera") {
                                let ue = this._calculate(S.expression.evaluate({
                                    zoom: D.zoom - 1
                                }), S.expression.evaluate({
                                    zoom: D.zoom
                                }), S.expression.evaluate({
                                    zoom: D.zoom + 1
                                }), D);
                                return new Du(this, {
                                    kind: "constant",
                                    value: ue
                                }, D);
                            }
                            return new Du(this, S.expression, D);
                        }
                        evaluate(S, D, j, te, ue, ve) {
                            if (S.kind === "source") {
                                let De = S.evaluate(D, j, te, ue, ve);
                                return this._calculate(De, De, De, D);
                            }
                            return S.kind === "composite" ? this._calculate(S.evaluate({
                                zoom: Math.floor(D.zoom) - 1
                            }, j, te), S.evaluate({
                                zoom: Math.floor(D.zoom)
                            }, j, te), S.evaluate({
                                zoom: Math.floor(D.zoom) + 1
                            }, j, te), D) : S.value;
                        }
                        _calculate(S, D, j, te) {
                            return te.zoom > te.zoomHistory.lastIntegerZoom ? {
                                from: S,
                                to: D
                            } : {
                                from: j,
                                to: D
                            };
                        }
                        interpolate(S) {
                            return S;
                        }
                    }
                    class yc {
                        constructor(S){
                            this.specification = S;
                        }
                        possiblyEvaluate(S, D, j, te) {
                            if (S.value !== void 0) {
                                if (S.expression.kind === "constant") {
                                    let ue = S.expression.evaluate(D, null, {}, j, te);
                                    return this._calculate(ue, ue, ue, D);
                                }
                                return this._calculate(S.expression.evaluate(new Ko(Math.floor(D.zoom - 1), D)), S.expression.evaluate(new Ko(Math.floor(D.zoom), D)), S.expression.evaluate(new Ko(Math.floor(D.zoom + 1), D)), D);
                            }
                        }
                        _calculate(S, D, j, te) {
                            return te.zoom > te.zoomHistory.lastIntegerZoom ? {
                                from: S,
                                to: D
                            } : {
                                from: j,
                                to: D
                            };
                        }
                        interpolate(S) {
                            return S;
                        }
                    }
                    class _c {
                        constructor(S){
                            this.specification = S;
                        }
                        possiblyEvaluate(S, D, j, te) {
                            return !!S.expression.evaluate(D, null, {}, j, te);
                        }
                        interpolate() {
                            return !1;
                        }
                    }
                    class le {
                        constructor(S){
                            this.properties = S, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                            for(let D in S){
                                let j = S[D];
                                j.specification.overridable && this.overridableProperties.push(D);
                                let te = this.defaultPropertyValues[D] = new nu(j, void 0), ue = this.defaultTransitionablePropertyValues[D] = new Ru(j);
                                this.defaultTransitioningPropertyValues[D] = ue.untransitioned(), this.defaultPossiblyEvaluatedValues[D] = te.possiblyEvaluate({});
                            }
                        }
                    }
                    mi("DataDrivenProperty", eo), mi("DataConstantProperty", Da), mi("CrossFadedDataDrivenProperty", Jc), mi("CrossFadedProperty", yc), mi("ColorRampProperty", _c);
                    let w = "-transition";
                    class B extends Re {
                        constructor(S, D){
                            if (super(), this.id = S.id, this.type = S.type, this._featureFilter = {
                                filter: ()=>!0,
                                needGeometry: !1
                            }, S.type !== "custom" && (this.metadata = S.metadata, this.minzoom = S.minzoom, this.maxzoom = S.maxzoom, S.type !== "background" && (this.source = S.source, this.sourceLayer = S["source-layer"], this.filter = S.filter), D.layout && (this._unevaluatedLayout = new Kc(D.layout)), D.paint)) {
                                this._transitionablePaint = new ac(D.paint);
                                for(let j in S.paint)this.setPaintProperty(j, S.paint[j], {
                                    validate: !1
                                });
                                for(let j in S.layout)this.setLayoutProperty(j, S.layout[j], {
                                    validate: !1
                                });
                                this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new Dc(D.paint);
                            }
                        }
                        getCrossfadeParameters() {
                            return this._crossfadeParameters;
                        }
                        getLayoutProperty(S) {
                            return S === "visibility" ? this.visibility : this._unevaluatedLayout.getValue(S);
                        }
                        setLayoutProperty(S, D, j = {}) {
                            D != null && this._validate(hn, `layers.${this.id}.layout.${S}`, S, D, j) || (S !== "visibility" ? this._unevaluatedLayout.setValue(S, D) : this.visibility = D);
                        }
                        getPaintProperty(S) {
                            return S.endsWith(w) ? this._transitionablePaint.getTransition(S.slice(0, -11)) : this._transitionablePaint.getValue(S);
                        }
                        setPaintProperty(S, D, j = {}) {
                            if (D != null && this._validate(Xi, `layers.${this.id}.paint.${S}`, S, D, j)) return !1;
                            if (S.endsWith(w)) return this._transitionablePaint.setTransition(S.slice(0, -11), D || void 0), !1;
                            {
                                let te = this._transitionablePaint._values[S], ue = te.property.specification["property-type"] === "cross-faded-data-driven", ve = te.value.isDataDriven(), De = te.value;
                                this._transitionablePaint.setValue(S, D), this._handleSpecialPaintPropertyUpdate(S);
                                let Ze = this._transitionablePaint._values[S].value;
                                return Ze.isDataDriven() || ve || ue || this._handleOverridablePaintPropertyUpdate(S, De, Ze);
                            }
                        }
                        _handleSpecialPaintPropertyUpdate(S) {}
                        _handleOverridablePaintPropertyUpdate(S, D, j) {
                            return !1;
                        }
                        isHidden(S) {
                            return !!(this.minzoom && S < this.minzoom) || !!(this.maxzoom && S >= this.maxzoom) || this.visibility === "none";
                        }
                        updateTransitions(S) {
                            this._transitioningPaint = this._transitionablePaint.transitioned(S, this._transitioningPaint);
                        }
                        hasTransition() {
                            return this._transitioningPaint.hasTransition();
                        }
                        recalculate(S, D) {
                            S.getCrossfadeParameters && (this._crossfadeParameters = S.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(S, void 0, D)), this.paint = this._transitioningPaint.possiblyEvaluate(S, void 0, D);
                        }
                        serialize() {
                            let S = {
                                id: this.id,
                                type: this.type,
                                source: this.source,
                                "source-layer": this.sourceLayer,
                                metadata: this.metadata,
                                minzoom: this.minzoom,
                                maxzoom: this.maxzoom,
                                filter: this.filter,
                                layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                                paint: this._transitionablePaint && this._transitionablePaint.serialize()
                            };
                            return this.visibility && (S.layout = S.layout || {}, S.layout.visibility = this.visibility), M(S, (D, j)=>!(D === void 0 || j === "layout" && !Object.keys(D).length || j === "paint" && !Object.keys(D).length));
                        }
                        _validate(S, D, j, te, ue = {}) {
                            return (!ue || ue.validate !== !1) && Ti(this, S.call(fi, {
                                key: D,
                                layerType: this.type,
                                objectKey: j,
                                value: te,
                                styleSpec: ce,
                                style: {
                                    glyphs: !0,
                                    sprite: !0
                                }
                            }));
                        }
                        is3D() {
                            return !1;
                        }
                        isTileClipped() {
                            return !1;
                        }
                        hasOffscreenPass() {
                            return !1;
                        }
                        resize() {}
                        isStateDependent() {
                            for(let S in this.paint._values){
                                let D = this.paint.get(S);
                                if (D instanceof Du && Cu(D.property.specification) && (D.value.kind === "source" || D.value.kind === "composite") && D.value.isStateDependent) return !0;
                            }
                            return !1;
                        }
                    }
                    let Q = {
                        Int8: Int8Array,
                        Uint8: Uint8Array,
                        Int16: Int16Array,
                        Uint16: Uint16Array,
                        Int32: Int32Array,
                        Uint32: Uint32Array,
                        Float32: Float32Array
                    };
                    class ee {
                        constructor(S, D){
                            this._structArray = S, this._pos1 = D * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
                        }
                    }
                    class se {
                        constructor(){
                            this.isTransferred = !1, this.capacity = -1, this.resize(0);
                        }
                        static serialize(S, D) {
                            return S._trim(), D && (S.isTransferred = !0, D.push(S.arrayBuffer)), {
                                length: S.length,
                                arrayBuffer: S.arrayBuffer
                            };
                        }
                        static deserialize(S) {
                            let D = Object.create(this.prototype);
                            return D.arrayBuffer = S.arrayBuffer, D.length = S.length, D.capacity = S.arrayBuffer.byteLength / D.bytesPerElement, D._refreshViews(), D;
                        }
                        _trim() {
                            this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
                        }
                        clear() {
                            this.length = 0;
                        }
                        resize(S) {
                            this.reserve(S), this.length = S;
                        }
                        reserve(S) {
                            if (S > this.capacity) {
                                this.capacity = Math.max(S, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                                let D = this.uint8;
                                this._refreshViews(), D && this.uint8.set(D);
                            }
                        }
                        _refreshViews() {
                            throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
                        }
                    }
                    function qe(R, S = 1) {
                        let D = 0, j = 0;
                        return {
                            members: R.map((te)=>{
                                let ue = Q[te.type].BYTES_PER_ELEMENT, ve = D = je(D, Math.max(S, ue)), De = te.components || 1;
                                return j = Math.max(j, ue), D += ue * De, {
                                    name: te.name,
                                    type: te.type,
                                    components: De,
                                    offset: ve
                                };
                            }),
                            size: je(D, Math.max(j, S)),
                            alignment: S
                        };
                    }
                    function je(R, S) {
                        return Math.ceil(R / S) * S;
                    }
                    class it extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D) {
                            let j = this.length;
                            return this.resize(j + 1), this.emplace(j, S, D);
                        }
                        emplace(S, D, j) {
                            let te = 2 * S;
                            return this.int16[te + 0] = D, this.int16[te + 1] = j, S;
                        }
                    }
                    it.prototype.bytesPerElement = 4, mi("StructArrayLayout2i4", it);
                    class yt extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j) {
                            let te = this.length;
                            return this.resize(te + 1), this.emplace(te, S, D, j);
                        }
                        emplace(S, D, j, te) {
                            let ue = 3 * S;
                            return this.int16[ue + 0] = D, this.int16[ue + 1] = j, this.int16[ue + 2] = te, S;
                        }
                    }
                    yt.prototype.bytesPerElement = 6, mi("StructArrayLayout3i6", yt);
                    class Ot extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te) {
                            let ue = this.length;
                            return this.resize(ue + 1), this.emplace(ue, S, D, j, te);
                        }
                        emplace(S, D, j, te, ue) {
                            let ve = 4 * S;
                            return this.int16[ve + 0] = D, this.int16[ve + 1] = j, this.int16[ve + 2] = te, this.int16[ve + 3] = ue, S;
                        }
                    }
                    Ot.prototype.bytesPerElement = 8, mi("StructArrayLayout4i8", Ot);
                    class Nt extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te, ue, ve) {
                            let De = this.length;
                            return this.resize(De + 1), this.emplace(De, S, D, j, te, ue, ve);
                        }
                        emplace(S, D, j, te, ue, ve, De) {
                            let Ze = 6 * S;
                            return this.int16[Ze + 0] = D, this.int16[Ze + 1] = j, this.int16[Ze + 2] = te, this.int16[Ze + 3] = ue, this.int16[Ze + 4] = ve, this.int16[Ze + 5] = De, S;
                        }
                    }
                    Nt.prototype.bytesPerElement = 12, mi("StructArrayLayout2i4i12", Nt);
                    class hr extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te, ue, ve) {
                            let De = this.length;
                            return this.resize(De + 1), this.emplace(De, S, D, j, te, ue, ve);
                        }
                        emplace(S, D, j, te, ue, ve, De) {
                            let Ze = 4 * S, at = 8 * S;
                            return this.int16[Ze + 0] = D, this.int16[Ze + 1] = j, this.uint8[at + 4] = te, this.uint8[at + 5] = ue, this.uint8[at + 6] = ve, this.uint8[at + 7] = De, S;
                        }
                    }
                    hr.prototype.bytesPerElement = 8, mi("StructArrayLayout2i4ub8", hr);
                    class Sr extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D) {
                            let j = this.length;
                            return this.resize(j + 1), this.emplace(j, S, D);
                        }
                        emplace(S, D, j) {
                            let te = 2 * S;
                            return this.float32[te + 0] = D, this.float32[te + 1] = j, S;
                        }
                    }
                    Sr.prototype.bytesPerElement = 8, mi("StructArrayLayout2f8", Sr);
                    class he extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te, ue, ve, De, Ze, at, Tt) {
                            let Ft = this.length;
                            return this.resize(Ft + 1), this.emplace(Ft, S, D, j, te, ue, ve, De, Ze, at, Tt);
                        }
                        emplace(S, D, j, te, ue, ve, De, Ze, at, Tt, Ft) {
                            let Qt = 10 * S;
                            return this.uint16[Qt + 0] = D, this.uint16[Qt + 1] = j, this.uint16[Qt + 2] = te, this.uint16[Qt + 3] = ue, this.uint16[Qt + 4] = ve, this.uint16[Qt + 5] = De, this.uint16[Qt + 6] = Ze, this.uint16[Qt + 7] = at, this.uint16[Qt + 8] = Tt, this.uint16[Qt + 9] = Ft, S;
                        }
                    }
                    he.prototype.bytesPerElement = 20, mi("StructArrayLayout10ui20", he);
                    class be extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt) {
                            let sr = this.length;
                            return this.resize(sr + 1), this.emplace(sr, S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt);
                        }
                        emplace(S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt, sr) {
                            let Tr = 12 * S;
                            return this.int16[Tr + 0] = D, this.int16[Tr + 1] = j, this.int16[Tr + 2] = te, this.int16[Tr + 3] = ue, this.uint16[Tr + 4] = ve, this.uint16[Tr + 5] = De, this.uint16[Tr + 6] = Ze, this.uint16[Tr + 7] = at, this.int16[Tr + 8] = Tt, this.int16[Tr + 9] = Ft, this.int16[Tr + 10] = Qt, this.int16[Tr + 11] = sr, S;
                        }
                    }
                    be.prototype.bytesPerElement = 24, mi("StructArrayLayout4i4ui4i24", be);
                    class Pe extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j) {
                            let te = this.length;
                            return this.resize(te + 1), this.emplace(te, S, D, j);
                        }
                        emplace(S, D, j, te) {
                            let ue = 3 * S;
                            return this.float32[ue + 0] = D, this.float32[ue + 1] = j, this.float32[ue + 2] = te, S;
                        }
                    }
                    Pe.prototype.bytesPerElement = 12, mi("StructArrayLayout3f12", Pe);
                    class Oe extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
                        }
                        emplaceBack(S) {
                            let D = this.length;
                            return this.resize(D + 1), this.emplace(D, S);
                        }
                        emplace(S, D) {
                            return this.uint32[1 * S + 0] = D, S;
                        }
                    }
                    Oe.prototype.bytesPerElement = 4, mi("StructArrayLayout1ul4", Oe);
                    class Je extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te, ue, ve, De, Ze, at) {
                            let Tt = this.length;
                            return this.resize(Tt + 1), this.emplace(Tt, S, D, j, te, ue, ve, De, Ze, at);
                        }
                        emplace(S, D, j, te, ue, ve, De, Ze, at, Tt) {
                            let Ft = 10 * S, Qt = 5 * S;
                            return this.int16[Ft + 0] = D, this.int16[Ft + 1] = j, this.int16[Ft + 2] = te, this.int16[Ft + 3] = ue, this.int16[Ft + 4] = ve, this.int16[Ft + 5] = De, this.uint32[Qt + 3] = Ze, this.uint16[Ft + 8] = at, this.uint16[Ft + 9] = Tt, S;
                        }
                    }
                    Je.prototype.bytesPerElement = 20, mi("StructArrayLayout6i1ul2ui20", Je);
                    class He extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te, ue, ve) {
                            let De = this.length;
                            return this.resize(De + 1), this.emplace(De, S, D, j, te, ue, ve);
                        }
                        emplace(S, D, j, te, ue, ve, De) {
                            let Ze = 6 * S;
                            return this.int16[Ze + 0] = D, this.int16[Ze + 1] = j, this.int16[Ze + 2] = te, this.int16[Ze + 3] = ue, this.int16[Ze + 4] = ve, this.int16[Ze + 5] = De, S;
                        }
                    }
                    He.prototype.bytesPerElement = 12, mi("StructArrayLayout2i2i2i12", He);
                    class et extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te, ue) {
                            let ve = this.length;
                            return this.resize(ve + 1), this.emplace(ve, S, D, j, te, ue);
                        }
                        emplace(S, D, j, te, ue, ve) {
                            let De = 4 * S, Ze = 8 * S;
                            return this.float32[De + 0] = D, this.float32[De + 1] = j, this.float32[De + 2] = te, this.int16[Ze + 6] = ue, this.int16[Ze + 7] = ve, S;
                        }
                    }
                    et.prototype.bytesPerElement = 16, mi("StructArrayLayout2f1f2i16", et);
                    class Mt extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te, ue, ve) {
                            let De = this.length;
                            return this.resize(De + 1), this.emplace(De, S, D, j, te, ue, ve);
                        }
                        emplace(S, D, j, te, ue, ve, De) {
                            let Ze = 16 * S, at = 4 * S, Tt = 8 * S;
                            return this.uint8[Ze + 0] = D, this.uint8[Ze + 1] = j, this.float32[at + 1] = te, this.float32[at + 2] = ue, this.int16[Tt + 6] = ve, this.int16[Tt + 7] = De, S;
                        }
                    }
                    Mt.prototype.bytesPerElement = 16, mi("StructArrayLayout2ub2f2i16", Mt);
                    class Dt extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j) {
                            let te = this.length;
                            return this.resize(te + 1), this.emplace(te, S, D, j);
                        }
                        emplace(S, D, j, te) {
                            let ue = 3 * S;
                            return this.uint16[ue + 0] = D, this.uint16[ue + 1] = j, this.uint16[ue + 2] = te, S;
                        }
                    }
                    Dt.prototype.bytesPerElement = 6, mi("StructArrayLayout3ui6", Dt);
                    class Ut extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt, sr, Tr, Pr, $r, ni) {
                            let Di = this.length;
                            return this.resize(Di + 1), this.emplace(Di, S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt, sr, Tr, Pr, $r, ni);
                        }
                        emplace(S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt, sr, Tr, Pr, $r, ni, Di) {
                            let pi = 24 * S, ki = 12 * S, Zi = 48 * S;
                            return this.int16[pi + 0] = D, this.int16[pi + 1] = j, this.uint16[pi + 2] = te, this.uint16[pi + 3] = ue, this.uint32[ki + 2] = ve, this.uint32[ki + 3] = De, this.uint32[ki + 4] = Ze, this.uint16[pi + 10] = at, this.uint16[pi + 11] = Tt, this.uint16[pi + 12] = Ft, this.float32[ki + 7] = Qt, this.float32[ki + 8] = sr, this.uint8[Zi + 36] = Tr, this.uint8[Zi + 37] = Pr, this.uint8[Zi + 38] = $r, this.uint32[ki + 10] = ni, this.int16[pi + 22] = Di, S;
                        }
                    }
                    Ut.prototype.bytesPerElement = 48, mi("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Ut);
                    class tr extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt, sr, Tr, Pr, $r, ni, Di, pi, ki, Zi, ta, Va, Io, La, Hn, lo, $a) {
                            let Xa = this.length;
                            return this.resize(Xa + 1), this.emplace(Xa, S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt, sr, Tr, Pr, $r, ni, Di, pi, ki, Zi, ta, Va, Io, La, Hn, lo, $a);
                        }
                        emplace(S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt, sr, Tr, Pr, $r, ni, Di, pi, ki, Zi, ta, Va, Io, La, Hn, lo, $a, Xa) {
                            let Tn = 32 * S, bo = 16 * S;
                            return this.int16[Tn + 0] = D, this.int16[Tn + 1] = j, this.int16[Tn + 2] = te, this.int16[Tn + 3] = ue, this.int16[Tn + 4] = ve, this.int16[Tn + 5] = De, this.int16[Tn + 6] = Ze, this.int16[Tn + 7] = at, this.uint16[Tn + 8] = Tt, this.uint16[Tn + 9] = Ft, this.uint16[Tn + 10] = Qt, this.uint16[Tn + 11] = sr, this.uint16[Tn + 12] = Tr, this.uint16[Tn + 13] = Pr, this.uint16[Tn + 14] = $r, this.uint16[Tn + 15] = ni, this.uint16[Tn + 16] = Di, this.uint16[Tn + 17] = pi, this.uint16[Tn + 18] = ki, this.uint16[Tn + 19] = Zi, this.uint16[Tn + 20] = ta, this.uint16[Tn + 21] = Va, this.uint16[Tn + 22] = Io, this.uint32[bo + 12] = La, this.float32[bo + 13] = Hn, this.float32[bo + 14] = lo, this.uint16[Tn + 30] = $a, this.uint16[Tn + 31] = Xa, S;
                        }
                    }
                    tr.prototype.bytesPerElement = 64, mi("StructArrayLayout8i15ui1ul2f2ui64", tr);
                    class mr extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(S) {
                            let D = this.length;
                            return this.resize(D + 1), this.emplace(D, S);
                        }
                        emplace(S, D) {
                            return this.float32[1 * S + 0] = D, S;
                        }
                    }
                    mr.prototype.bytesPerElement = 4, mi("StructArrayLayout1f4", mr);
                    class Rr extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j) {
                            let te = this.length;
                            return this.resize(te + 1), this.emplace(te, S, D, j);
                        }
                        emplace(S, D, j, te) {
                            let ue = 3 * S;
                            return this.uint16[6 * S + 0] = D, this.float32[ue + 1] = j, this.float32[ue + 2] = te, S;
                        }
                    }
                    Rr.prototype.bytesPerElement = 12, mi("StructArrayLayout1ui2f12", Rr);
                    class zr extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j) {
                            let te = this.length;
                            return this.resize(te + 1), this.emplace(te, S, D, j);
                        }
                        emplace(S, D, j, te) {
                            let ue = 4 * S;
                            return this.uint32[2 * S + 0] = D, this.uint16[ue + 2] = j, this.uint16[ue + 3] = te, S;
                        }
                    }
                    zr.prototype.bytesPerElement = 8, mi("StructArrayLayout1ul2ui8", zr);
                    class Xr extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D) {
                            let j = this.length;
                            return this.resize(j + 1), this.emplace(j, S, D);
                        }
                        emplace(S, D, j) {
                            let te = 2 * S;
                            return this.uint16[te + 0] = D, this.uint16[te + 1] = j, S;
                        }
                    }
                    Xr.prototype.bytesPerElement = 4, mi("StructArrayLayout2ui4", Xr);
                    class di extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(S) {
                            let D = this.length;
                            return this.resize(D + 1), this.emplace(D, S);
                        }
                        emplace(S, D) {
                            return this.uint16[1 * S + 0] = D, S;
                        }
                    }
                    di.prototype.bytesPerElement = 2, mi("StructArrayLayout1ui2", di);
                    class Li extends se {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(S, D, j, te) {
                            let ue = this.length;
                            return this.resize(ue + 1), this.emplace(ue, S, D, j, te);
                        }
                        emplace(S, D, j, te, ue) {
                            let ve = 4 * S;
                            return this.float32[ve + 0] = D, this.float32[ve + 1] = j, this.float32[ve + 2] = te, this.float32[ve + 3] = ue, S;
                        }
                    }
                    Li.prototype.bytesPerElement = 16, mi("StructArrayLayout4f16", Li);
                    class Ci extends ee {
                        get anchorPointX() {
                            return this._structArray.int16[this._pos2 + 0];
                        }
                        get anchorPointY() {
                            return this._structArray.int16[this._pos2 + 1];
                        }
                        get x1() {
                            return this._structArray.int16[this._pos2 + 2];
                        }
                        get y1() {
                            return this._structArray.int16[this._pos2 + 3];
                        }
                        get x2() {
                            return this._structArray.int16[this._pos2 + 4];
                        }
                        get y2() {
                            return this._structArray.int16[this._pos2 + 5];
                        }
                        get featureIndex() {
                            return this._structArray.uint32[this._pos4 + 3];
                        }
                        get sourceLayerIndex() {
                            return this._structArray.uint16[this._pos2 + 8];
                        }
                        get bucketIndex() {
                            return this._structArray.uint16[this._pos2 + 9];
                        }
                        get anchorPoint() {
                            return new u(this.anchorPointX, this.anchorPointY);
                        }
                    }
                    Ci.prototype.size = 20;
                    class Qi extends Je {
                        get(S) {
                            return new Ci(this, S);
                        }
                    }
                    mi("CollisionBoxArray", Qi);
                    class Mn extends ee {
                        get anchorX() {
                            return this._structArray.int16[this._pos2 + 0];
                        }
                        get anchorY() {
                            return this._structArray.int16[this._pos2 + 1];
                        }
                        get glyphStartIndex() {
                            return this._structArray.uint16[this._pos2 + 2];
                        }
                        get numGlyphs() {
                            return this._structArray.uint16[this._pos2 + 3];
                        }
                        get vertexStartIndex() {
                            return this._structArray.uint32[this._pos4 + 2];
                        }
                        get lineStartIndex() {
                            return this._structArray.uint32[this._pos4 + 3];
                        }
                        get lineLength() {
                            return this._structArray.uint32[this._pos4 + 4];
                        }
                        get segment() {
                            return this._structArray.uint16[this._pos2 + 10];
                        }
                        get lowerSize() {
                            return this._structArray.uint16[this._pos2 + 11];
                        }
                        get upperSize() {
                            return this._structArray.uint16[this._pos2 + 12];
                        }
                        get lineOffsetX() {
                            return this._structArray.float32[this._pos4 + 7];
                        }
                        get lineOffsetY() {
                            return this._structArray.float32[this._pos4 + 8];
                        }
                        get writingMode() {
                            return this._structArray.uint8[this._pos1 + 36];
                        }
                        get placedOrientation() {
                            return this._structArray.uint8[this._pos1 + 37];
                        }
                        set placedOrientation(S) {
                            this._structArray.uint8[this._pos1 + 37] = S;
                        }
                        get hidden() {
                            return this._structArray.uint8[this._pos1 + 38];
                        }
                        set hidden(S) {
                            this._structArray.uint8[this._pos1 + 38] = S;
                        }
                        get crossTileID() {
                            return this._structArray.uint32[this._pos4 + 10];
                        }
                        set crossTileID(S) {
                            this._structArray.uint32[this._pos4 + 10] = S;
                        }
                        get associatedIconIndex() {
                            return this._structArray.int16[this._pos2 + 22];
                        }
                    }
                    Mn.prototype.size = 48;
                    class pa extends Ut {
                        get(S) {
                            return new Mn(this, S);
                        }
                    }
                    mi("PlacedSymbolArray", pa);
                    class ea extends ee {
                        get anchorX() {
                            return this._structArray.int16[this._pos2 + 0];
                        }
                        get anchorY() {
                            return this._structArray.int16[this._pos2 + 1];
                        }
                        get rightJustifiedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 2];
                        }
                        get centerJustifiedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 3];
                        }
                        get leftJustifiedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 4];
                        }
                        get verticalPlacedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 5];
                        }
                        get placedIconSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 6];
                        }
                        get verticalPlacedIconSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 7];
                        }
                        get key() {
                            return this._structArray.uint16[this._pos2 + 8];
                        }
                        get textBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 9];
                        }
                        get textBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 10];
                        }
                        get verticalTextBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 11];
                        }
                        get verticalTextBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 12];
                        }
                        get iconBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 13];
                        }
                        get iconBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 14];
                        }
                        get verticalIconBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 15];
                        }
                        get verticalIconBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 16];
                        }
                        get featureIndex() {
                            return this._structArray.uint16[this._pos2 + 17];
                        }
                        get numHorizontalGlyphVertices() {
                            return this._structArray.uint16[this._pos2 + 18];
                        }
                        get numVerticalGlyphVertices() {
                            return this._structArray.uint16[this._pos2 + 19];
                        }
                        get numIconVertices() {
                            return this._structArray.uint16[this._pos2 + 20];
                        }
                        get numVerticalIconVertices() {
                            return this._structArray.uint16[this._pos2 + 21];
                        }
                        get useRuntimeCollisionCircles() {
                            return this._structArray.uint16[this._pos2 + 22];
                        }
                        get crossTileID() {
                            return this._structArray.uint32[this._pos4 + 12];
                        }
                        set crossTileID(S) {
                            this._structArray.uint32[this._pos4 + 12] = S;
                        }
                        get textBoxScale() {
                            return this._structArray.float32[this._pos4 + 13];
                        }
                        get collisionCircleDiameter() {
                            return this._structArray.float32[this._pos4 + 14];
                        }
                        get textAnchorOffsetStartIndex() {
                            return this._structArray.uint16[this._pos2 + 30];
                        }
                        get textAnchorOffsetEndIndex() {
                            return this._structArray.uint16[this._pos2 + 31];
                        }
                    }
                    ea.prototype.size = 64;
                    class Ga extends tr {
                        get(S) {
                            return new ea(this, S);
                        }
                    }
                    mi("SymbolInstanceArray", Ga);
                    class To extends mr {
                        getoffsetX(S) {
                            return this.float32[1 * S + 0];
                        }
                    }
                    mi("GlyphOffsetArray", To);
                    class Wa extends yt {
                        getx(S) {
                            return this.int16[3 * S + 0];
                        }
                        gety(S) {
                            return this.int16[3 * S + 1];
                        }
                        gettileUnitDistanceFromAnchor(S) {
                            return this.int16[3 * S + 2];
                        }
                    }
                    mi("SymbolLineVertexArray", Wa);
                    class co extends ee {
                        get textAnchor() {
                            return this._structArray.uint16[this._pos2 + 0];
                        }
                        get textOffset0() {
                            return this._structArray.float32[this._pos4 + 1];
                        }
                        get textOffset1() {
                            return this._structArray.float32[this._pos4 + 2];
                        }
                    }
                    co.prototype.size = 12;
                    class Ro extends Rr {
                        get(S) {
                            return new co(this, S);
                        }
                    }
                    mi("TextAnchorOffsetArray", Ro);
                    class Ds extends ee {
                        get featureIndex() {
                            return this._structArray.uint32[this._pos4 + 0];
                        }
                        get sourceLayerIndex() {
                            return this._structArray.uint16[this._pos2 + 2];
                        }
                        get bucketIndex() {
                            return this._structArray.uint16[this._pos2 + 3];
                        }
                    }
                    Ds.prototype.size = 8;
                    class As extends zr {
                        get(S) {
                            return new Ds(this, S);
                        }
                    }
                    mi("FeatureIndexArray", As);
                    class yo extends it {
                    }
                    class po extends it {
                    }
                    class _l extends it {
                    }
                    class Hl extends Nt {
                    }
                    class Zu extends hr {
                    }
                    class cu extends Sr {
                    }
                    class el extends he {
                    }
                    class au extends be {
                    }
                    class zc extends Pe {
                    }
                    class zl extends Oe {
                    }
                    class Fl extends He {
                    }
                    class Z extends Mt {
                    }
                    class oe extends Dt {
                    }
                    class we extends Xr {
                    }
                    let Be = qe([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), { members: Ue } = Be;
                    class We {
                        constructor(S = []){
                            this.segments = S;
                        }
                        prepareSegment(S, D, j, te) {
                            let ue = this.segments[this.segments.length - 1];
                            return S > We.MAX_VERTEX_ARRAY_LENGTH && T(`Max vertices per segment is ${We.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${S}`), (!ue || ue.vertexLength + S > We.MAX_VERTEX_ARRAY_LENGTH || ue.sortKey !== te) && (ue = {
                                vertexOffset: D.length,
                                primitiveOffset: j.length,
                                vertexLength: 0,
                                primitiveLength: 0
                            }, te !== void 0 && (ue.sortKey = te), this.segments.push(ue)), ue;
                        }
                        get() {
                            return this.segments;
                        }
                        destroy() {
                            for (let S of this.segments)for(let D in S.vaos)S.vaos[D].destroy();
                        }
                        static simpleSegment(S, D, j, te) {
                            return new We([
                                {
                                    vertexOffset: S,
                                    primitiveOffset: D,
                                    vertexLength: j,
                                    primitiveLength: te,
                                    vaos: {},
                                    sortKey: 0
                                }
                            ]);
                        }
                    }
                    function wt(R, S) {
                        return 256 * (R = k(Math.floor(R), 0, 255)) + k(Math.floor(S), 0, 255);
                    }
                    We.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, mi("SegmentVector", We);
                    let tt = qe([
                        {
                            name: "a_pattern_from",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pattern_to",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixel_ratio_from",
                            components: 1,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixel_ratio_to",
                            components: 1,
                            type: "Uint16"
                        }
                    ]);
                    var zt = {
                        exports: {}
                    }, or = {
                        exports: {}
                    };
                    or.exports = function(R, S) {
                        var D, j, te, ue, ve, De, Ze, at;
                        for(j = R.length - (D = 3 & R.length), te = S, ve = 3432918353, De = 461845907, at = 0; at < j;)Ze = 255 & R.charCodeAt(at) | (255 & R.charCodeAt(++at)) << 8 | (255 & R.charCodeAt(++at)) << 16 | (255 & R.charCodeAt(++at)) << 24, ++at, te = 27492 + (65535 & (ue = 5 * (65535 & (te = (te ^= Ze = (65535 & (Ze = (Ze = (65535 & Ze) * ve + (((Ze >>> 16) * ve & 65535) << 16) & 4294967295) << 15 | Ze >>> 17)) * De + (((Ze >>> 16) * De & 65535) << 16) & 4294967295) << 13 | te >>> 19)) + ((5 * (te >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (ue >>> 16) & 65535) << 16);
                        switch(Ze = 0, D){
                            case 3:
                                Ze ^= (255 & R.charCodeAt(at + 2)) << 16;
                            case 2:
                                Ze ^= (255 & R.charCodeAt(at + 1)) << 8;
                            case 1:
                                te ^= Ze = (65535 & (Ze = (Ze = (65535 & (Ze ^= 255 & R.charCodeAt(at))) * ve + (((Ze >>> 16) * ve & 65535) << 16) & 4294967295) << 15 | Ze >>> 17)) * De + (((Ze >>> 16) * De & 65535) << 16) & 4294967295;
                        }
                        return te ^= R.length, te = 2246822507 * (65535 & (te ^= te >>> 16)) + ((2246822507 * (te >>> 16) & 65535) << 16) & 4294967295, te = 3266489909 * (65535 & (te ^= te >>> 13)) + ((3266489909 * (te >>> 16) & 65535) << 16) & 4294967295, (te ^= te >>> 16) >>> 0;
                    };
                    var lr = or.exports, Dr = {
                        exports: {}
                    };
                    Dr.exports = function(R, S) {
                        for(var D, j = R.length, te = S ^ j, ue = 0; j >= 4;)D = 1540483477 * (65535 & (D = 255 & R.charCodeAt(ue) | (255 & R.charCodeAt(++ue)) << 8 | (255 & R.charCodeAt(++ue)) << 16 | (255 & R.charCodeAt(++ue)) << 24)) + ((1540483477 * (D >>> 16) & 65535) << 16), te = 1540483477 * (65535 & te) + ((1540483477 * (te >>> 16) & 65535) << 16) ^ (D = 1540483477 * (65535 & (D ^= D >>> 24)) + ((1540483477 * (D >>> 16) & 65535) << 16)), j -= 4, ++ue;
                        switch(j){
                            case 3:
                                te ^= (255 & R.charCodeAt(ue + 2)) << 16;
                            case 2:
                                te ^= (255 & R.charCodeAt(ue + 1)) << 8;
                            case 1:
                                te = 1540483477 * (65535 & (te ^= 255 & R.charCodeAt(ue))) + ((1540483477 * (te >>> 16) & 65535) << 16);
                        }
                        return te = 1540483477 * (65535 & (te ^= te >>> 13)) + ((1540483477 * (te >>> 16) & 65535) << 16), (te ^= te >>> 15) >>> 0;
                    };
                    var Ir = lr, oi = Dr.exports;
                    zt.exports = Ir, zt.exports.murmur3 = Ir, zt.exports.murmur2 = oi;
                    var ui = o(zt.exports);
                    class qr {
                        constructor(){
                            this.ids = [], this.positions = [], this.indexed = !1;
                        }
                        add(S, D, j, te) {
                            this.ids.push(Kr(S)), this.positions.push(D, j, te);
                        }
                        getPositions(S) {
                            if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                            let D = Kr(S), j = 0, te = this.ids.length - 1;
                            for(; j < te;){
                                let ve = j + te >> 1;
                                this.ids[ve] >= D ? te = ve : j = ve + 1;
                            }
                            let ue = [];
                            for(; this.ids[j] === D;)ue.push({
                                index: this.positions[3 * j],
                                start: this.positions[3 * j + 1],
                                end: this.positions[3 * j + 2]
                            }), j++;
                            return ue;
                        }
                        static serialize(S, D) {
                            let j = new Float64Array(S.ids), te = new Uint32Array(S.positions);
                            return ii(j, te, 0, j.length - 1), D && D.push(j.buffer, te.buffer), {
                                ids: j,
                                positions: te
                            };
                        }
                        static deserialize(S) {
                            let D = new qr;
                            return D.ids = S.ids, D.positions = S.positions, D.indexed = !0, D;
                        }
                    }
                    function Kr(R) {
                        let S = +R;
                        return !isNaN(S) && S <= Number.MAX_SAFE_INTEGER ? S : ui(String(R));
                    }
                    function ii(R, S, D, j) {
                        for(; D < j;){
                            let te = R[D + j >> 1], ue = D - 1, ve = j + 1;
                            for(;;){
                                do ue++;
                                while (R[ue] < te);
                                do ve--;
                                while (R[ve] > te);
                                if (ue >= ve) break;
                                vi(R, ue, ve), vi(S, 3 * ue, 3 * ve), vi(S, 3 * ue + 1, 3 * ve + 1), vi(S, 3 * ue + 2, 3 * ve + 2);
                            }
                            ve - D < j - ve ? (ii(R, S, D, ve), D = ve + 1) : (ii(R, S, ve + 1, j), j = ve);
                        }
                    }
                    function vi(R, S, D) {
                        let j = R[S];
                        R[S] = R[D], R[D] = j;
                    }
                    mi("FeaturePositionMap", qr);
                    class ci {
                        constructor(S, D){
                            this.gl = S.gl, this.location = D;
                        }
                    }
                    class Jr extends ci {
                        constructor(S, D){
                            super(S, D), this.current = 0;
                        }
                        set(S) {
                            this.current !== S && (this.current = S, this.gl.uniform1f(this.location, S));
                        }
                    }
                    class un extends ci {
                        constructor(S, D){
                            super(S, D), this.current = [
                                0,
                                0,
                                0,
                                0
                            ];
                        }
                        set(S) {
                            S[0] === this.current[0] && S[1] === this.current[1] && S[2] === this.current[2] && S[3] === this.current[3] || (this.current = S, this.gl.uniform4f(this.location, S[0], S[1], S[2], S[3]));
                        }
                    }
                    class dn extends ci {
                        constructor(S, D){
                            super(S, D), this.current = Zt.transparent;
                        }
                        set(S) {
                            S.r === this.current.r && S.g === this.current.g && S.b === this.current.b && S.a === this.current.a || (this.current = S, this.gl.uniform4f(this.location, S.r, S.g, S.b, S.a));
                        }
                    }
                    let En = new Float32Array(16);
                    function Nn(R) {
                        return [
                            wt(255 * R.r, 255 * R.g),
                            wt(255 * R.b, 255 * R.a)
                        ];
                    }
                    class ga {
                        constructor(S, D, j){
                            this.value = S, this.uniformNames = D.map((te)=>`u_${te}`), this.type = j;
                        }
                        setUniform(S, D, j) {
                            S.set(j.constantOr(this.value));
                        }
                        getBinding(S, D, j) {
                            return this.type === "color" ? new dn(S, D) : new Jr(S, D);
                        }
                    }
                    class ya {
                        constructor(S, D){
                            this.uniformNames = D.map((j)=>`u_${j}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
                        }
                        setConstantPatternPositions(S, D) {
                            this.pixelRatioFrom = D.pixelRatio, this.pixelRatioTo = S.pixelRatio, this.patternFrom = D.tlbr, this.patternTo = S.tlbr;
                        }
                        setUniform(S, D, j, te) {
                            let ue = te === "u_pattern_to" ? this.patternTo : te === "u_pattern_from" ? this.patternFrom : te === "u_pixel_ratio_to" ? this.pixelRatioTo : te === "u_pixel_ratio_from" ? this.pixelRatioFrom : null;
                            ue && S.set(ue);
                        }
                        getBinding(S, D, j) {
                            return j.substr(0, 9) === "u_pattern" ? new un(S, D) : new Jr(S, D);
                        }
                    }
                    class so {
                        constructor(S, D, j, te){
                            this.expression = S, this.type = j, this.maxValue = 0, this.paintVertexAttributes = D.map((ue)=>({
                                    name: `a_${ue}`,
                                    type: "Float32",
                                    components: j === "color" ? 2 : 1,
                                    offset: 0
                                })), this.paintVertexArray = new te;
                        }
                        populatePaintArray(S, D, j, te, ue) {
                            let ve = this.paintVertexArray.length, De = this.expression.evaluate(new Ko(0), D, {}, te, [], ue);
                            this.paintVertexArray.resize(S), this._setPaintValue(ve, S, De);
                        }
                        updatePaintArray(S, D, j, te) {
                            let ue = this.expression.evaluate({
                                zoom: 0
                            }, j, te);
                            this._setPaintValue(S, D, ue);
                        }
                        _setPaintValue(S, D, j) {
                            if (this.type === "color") {
                                let te = Nn(j);
                                for(let ue = S; ue < D; ue++)this.paintVertexArray.emplace(ue, te[0], te[1]);
                            } else {
                                for(let te = S; te < D; te++)this.paintVertexArray.emplace(te, j);
                                this.maxValue = Math.max(this.maxValue, Math.abs(j));
                            }
                        }
                        upload(S) {
                            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = S.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                        }
                        destroy() {
                            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                        }
                    }
                    class wa {
                        constructor(S, D, j, te, ue, ve){
                            this.expression = S, this.uniformNames = D.map((De)=>`u_${De}_t`), this.type = j, this.useIntegerZoom = te, this.zoom = ue, this.maxValue = 0, this.paintVertexAttributes = D.map((De)=>({
                                    name: `a_${De}`,
                                    type: "Float32",
                                    components: j === "color" ? 4 : 2,
                                    offset: 0
                                })), this.paintVertexArray = new ve;
                        }
                        populatePaintArray(S, D, j, te, ue) {
                            let ve = this.expression.evaluate(new Ko(this.zoom), D, {}, te, [], ue), De = this.expression.evaluate(new Ko(this.zoom + 1), D, {}, te, [], ue), Ze = this.paintVertexArray.length;
                            this.paintVertexArray.resize(S), this._setPaintValue(Ze, S, ve, De);
                        }
                        updatePaintArray(S, D, j, te) {
                            let ue = this.expression.evaluate({
                                zoom: this.zoom
                            }, j, te), ve = this.expression.evaluate({
                                zoom: this.zoom + 1
                            }, j, te);
                            this._setPaintValue(S, D, ue, ve);
                        }
                        _setPaintValue(S, D, j, te) {
                            if (this.type === "color") {
                                let ue = Nn(j), ve = Nn(te);
                                for(let De = S; De < D; De++)this.paintVertexArray.emplace(De, ue[0], ue[1], ve[0], ve[1]);
                            } else {
                                for(let ue = S; ue < D; ue++)this.paintVertexArray.emplace(ue, j, te);
                                this.maxValue = Math.max(this.maxValue, Math.abs(j), Math.abs(te));
                            }
                        }
                        upload(S) {
                            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = S.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                        }
                        destroy() {
                            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                        }
                        setUniform(S, D) {
                            let j = this.useIntegerZoom ? Math.floor(D.zoom) : D.zoom, te = k(this.expression.interpolationFactor(j, this.zoom, this.zoom + 1), 0, 1);
                            S.set(te);
                        }
                        getBinding(S, D, j) {
                            return new Jr(S, D);
                        }
                    }
                    class io {
                        constructor(S, D, j, te, ue, ve){
                            this.expression = S, this.type = D, this.useIntegerZoom = j, this.zoom = te, this.layerId = ve, this.zoomInPaintVertexArray = new ue, this.zoomOutPaintVertexArray = new ue;
                        }
                        populatePaintArray(S, D, j) {
                            let te = this.zoomInPaintVertexArray.length;
                            this.zoomInPaintVertexArray.resize(S), this.zoomOutPaintVertexArray.resize(S), this._setPaintValues(te, S, D.patterns && D.patterns[this.layerId], j);
                        }
                        updatePaintArray(S, D, j, te, ue) {
                            this._setPaintValues(S, D, j.patterns && j.patterns[this.layerId], ue);
                        }
                        _setPaintValues(S, D, j, te) {
                            if (!te || !j) return;
                            let { min: ue, mid: ve, max: De } = j, Ze = te[ue], at = te[ve], Tt = te[De];
                            if (Ze && at && Tt) for(let Ft = S; Ft < D; Ft++)this.zoomInPaintVertexArray.emplace(Ft, at.tl[0], at.tl[1], at.br[0], at.br[1], Ze.tl[0], Ze.tl[1], Ze.br[0], Ze.br[1], at.pixelRatio, Ze.pixelRatio), this.zoomOutPaintVertexArray.emplace(Ft, at.tl[0], at.tl[1], at.br[0], at.br[1], Tt.tl[0], Tt.tl[1], Tt.br[0], Tt.br[1], at.pixelRatio, Tt.pixelRatio);
                        }
                        upload(S) {
                            this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer && (this.zoomInPaintVertexBuffer = S.createVertexBuffer(this.zoomInPaintVertexArray, tt.members, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = S.createVertexBuffer(this.zoomOutPaintVertexArray, tt.members, this.expression.isStateDependent));
                        }
                        destroy() {
                            this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
                        }
                    }
                    class Ss {
                        constructor(S, D, j){
                            this.binders = {}, this._buffers = [];
                            let te = [];
                            for(let ue in S.paint._values){
                                if (!j(ue)) continue;
                                let ve = S.paint.get(ue);
                                if (!(ve instanceof Du && Cu(ve.property.specification))) continue;
                                let De = Ns(ue, S.type), Ze = ve.value, at = ve.property.specification.type, Tt = ve.property.useIntegerZoom, Ft = ve.property.specification["property-type"], Qt = Ft === "cross-faded" || Ft === "cross-faded-data-driven";
                                if (Ze.kind === "constant") this.binders[ue] = Qt ? new ya(Ze.value, De) : new ga(Ze.value, De, at), te.push(`/u_${ue}`);
                                else if (Ze.kind === "source" || Qt) {
                                    let sr = pn(ue, at, "source");
                                    this.binders[ue] = Qt ? new io(Ze, at, Tt, D, sr, S.id) : new so(Ze, De, at, sr), te.push(`/a_${ue}`);
                                } else {
                                    let sr = pn(ue, at, "composite");
                                    this.binders[ue] = new wa(Ze, De, at, Tt, D, sr), te.push(`/z_${ue}`);
                                }
                            }
                            this.cacheKey = te.sort().join("");
                        }
                        getMaxValue(S) {
                            let D = this.binders[S];
                            return D instanceof so || D instanceof wa ? D.maxValue : 0;
                        }
                        populatePaintArrays(S, D, j, te, ue) {
                            for(let ve in this.binders){
                                let De = this.binders[ve];
                                (De instanceof so || De instanceof wa || De instanceof io) && De.populatePaintArray(S, D, j, te, ue);
                            }
                        }
                        setConstantPatternPositions(S, D) {
                            for(let j in this.binders){
                                let te = this.binders[j];
                                te instanceof ya && te.setConstantPatternPositions(S, D);
                            }
                        }
                        updatePaintArrays(S, D, j, te, ue) {
                            let ve = !1;
                            for(let De in S){
                                let Ze = D.getPositions(De);
                                for (let at of Ze){
                                    let Tt = j.feature(at.index);
                                    for(let Ft in this.binders){
                                        let Qt = this.binders[Ft];
                                        if ((Qt instanceof so || Qt instanceof wa || Qt instanceof io) && Qt.expression.isStateDependent === !0) {
                                            let sr = te.paint.get(Ft);
                                            Qt.expression = sr.value, Qt.updatePaintArray(at.start, at.end, Tt, S[De], ue), ve = !0;
                                        }
                                    }
                                }
                            }
                            return ve;
                        }
                        defines() {
                            let S = [];
                            for(let D in this.binders){
                                let j = this.binders[D];
                                (j instanceof ga || j instanceof ya) && S.push(...j.uniformNames.map((te)=>`#define HAS_UNIFORM_${te}`));
                            }
                            return S;
                        }
                        getBinderAttributes() {
                            let S = [];
                            for(let D in this.binders){
                                let j = this.binders[D];
                                if (j instanceof so || j instanceof wa) for(let te = 0; te < j.paintVertexAttributes.length; te++)S.push(j.paintVertexAttributes[te].name);
                                else if (j instanceof io) for(let te = 0; te < tt.members.length; te++)S.push(tt.members[te].name);
                            }
                            return S;
                        }
                        getBinderUniforms() {
                            let S = [];
                            for(let D in this.binders){
                                let j = this.binders[D];
                                if (j instanceof ga || j instanceof ya || j instanceof wa) for (let te of j.uniformNames)S.push(te);
                            }
                            return S;
                        }
                        getPaintVertexBuffers() {
                            return this._buffers;
                        }
                        getUniforms(S, D) {
                            let j = [];
                            for(let te in this.binders){
                                let ue = this.binders[te];
                                if (ue instanceof ga || ue instanceof ya || ue instanceof wa) {
                                    for (let ve of ue.uniformNames)if (D[ve]) {
                                        let De = ue.getBinding(S, D[ve], ve);
                                        j.push({
                                            name: ve,
                                            property: te,
                                            binding: De
                                        });
                                    }
                                }
                            }
                            return j;
                        }
                        setUniforms(S, D, j, te) {
                            for (let { name: ue, property: ve, binding: De } of D)this.binders[ve].setUniform(De, te, j.get(ve), ue);
                        }
                        updatePaintBuffers(S) {
                            this._buffers = [];
                            for(let D in this.binders){
                                let j = this.binders[D];
                                if (S && j instanceof io) {
                                    let te = S.fromScale === 2 ? j.zoomInPaintVertexBuffer : j.zoomOutPaintVertexBuffer;
                                    te && this._buffers.push(te);
                                } else (j instanceof so || j instanceof wa) && j.paintVertexBuffer && this._buffers.push(j.paintVertexBuffer);
                            }
                        }
                        upload(S) {
                            for(let D in this.binders){
                                let j = this.binders[D];
                                (j instanceof so || j instanceof wa || j instanceof io) && j.upload(S);
                            }
                            this.updatePaintBuffers();
                        }
                        destroy() {
                            for(let S in this.binders){
                                let D = this.binders[S];
                                (D instanceof so || D instanceof wa || D instanceof io) && D.destroy();
                            }
                        }
                    }
                    class _s {
                        constructor(S, D, j = ()=>!0){
                            this.programConfigurations = {};
                            for (let te of S)this.programConfigurations[te.id] = new Ss(te, D, j);
                            this.needsUpload = !1, this._featureMap = new qr, this._bufferOffset = 0;
                        }
                        populatePaintArrays(S, D, j, te, ue, ve) {
                            for(let De in this.programConfigurations)this.programConfigurations[De].populatePaintArrays(S, D, te, ue, ve);
                            D.id !== void 0 && this._featureMap.add(D.id, j, this._bufferOffset, S), this._bufferOffset = S, this.needsUpload = !0;
                        }
                        updatePaintArrays(S, D, j, te) {
                            for (let ue of j)this.needsUpload = this.programConfigurations[ue.id].updatePaintArrays(S, this._featureMap, D, ue, te) || this.needsUpload;
                        }
                        get(S) {
                            return this.programConfigurations[S];
                        }
                        upload(S) {
                            if (this.needsUpload) {
                                for(let D in this.programConfigurations)this.programConfigurations[D].upload(S);
                                this.needsUpload = !1;
                            }
                        }
                        destroy() {
                            for(let S in this.programConfigurations)this.programConfigurations[S].destroy();
                        }
                    }
                    function Ns(R, S) {
                        return ({
                            "text-opacity": [
                                "opacity"
                            ],
                            "icon-opacity": [
                                "opacity"
                            ],
                            "text-color": [
                                "fill_color"
                            ],
                            "icon-color": [
                                "fill_color"
                            ],
                            "text-halo-color": [
                                "halo_color"
                            ],
                            "icon-halo-color": [
                                "halo_color"
                            ],
                            "text-halo-blur": [
                                "halo_blur"
                            ],
                            "icon-halo-blur": [
                                "halo_blur"
                            ],
                            "text-halo-width": [
                                "halo_width"
                            ],
                            "icon-halo-width": [
                                "halo_width"
                            ],
                            "line-gap-width": [
                                "gapwidth"
                            ],
                            "line-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ],
                            "fill-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ],
                            "fill-extrusion-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ]
                        })[R] || [
                            R.replace(`${S}-`, "").replace(/-/g, "_")
                        ];
                    }
                    function pn(R, S, D) {
                        let j = {
                            color: {
                                source: Sr,
                                composite: Li
                            },
                            number: {
                                source: mr,
                                composite: Sr
                            }
                        }, te = function(ue) {
                            return ({
                                "line-pattern": {
                                    source: el,
                                    composite: el
                                },
                                "fill-pattern": {
                                    source: el,
                                    composite: el
                                },
                                "fill-extrusion-pattern": {
                                    source: el,
                                    composite: el
                                }
                            })[ue];
                        }(R);
                        return te && te[D] || j[S][D];
                    }
                    mi("ConstantBinder", ga), mi("CrossFadedConstantBinder", ya), mi("SourceExpressionBinder", so), mi("CrossFadedCompositeBinder", io), mi("CompositeExpressionBinder", wa), mi("ProgramConfiguration", Ss, {
                        omit: [
                            "_buffers"
                        ]
                    }), mi("ProgramConfigurationSet", _s);
                    let za = 8192, Lo = Math.pow(2, 14) - 1, Fo = -Lo - 1;
                    function js(R) {
                        let S = za / R.extent, D = R.loadGeometry();
                        for(let j = 0; j < D.length; j++){
                            let te = D[j];
                            for(let ue = 0; ue < te.length; ue++){
                                let ve = te[ue], De = Math.round(ve.x * S), Ze = Math.round(ve.y * S);
                                ve.x = k(De, Fo, Lo), ve.y = k(Ze, Fo, Lo), (De < ve.x || De > ve.x + 1 || Ze < ve.y || Ze > ve.y + 1) && T("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                            }
                        }
                        return D;
                    }
                    function xl(R, S) {
                        return {
                            type: R.type,
                            id: R.id,
                            properties: R.properties,
                            geometry: S ? js(R) : []
                        };
                    }
                    function fu(R, S, D, j, te) {
                        R.emplaceBack(2 * S + (j + 1) / 2, 2 * D + (te + 1) / 2);
                    }
                    class dl {
                        constructor(S){
                            this.zoom = S.zoom, this.overscaling = S.overscaling, this.layers = S.layers, this.layerIds = this.layers.map((D)=>D.id), this.index = S.index, this.hasPattern = !1, this.layoutVertexArray = new po, this.indexArray = new oe, this.segments = new We, this.programConfigurations = new _s(S.layers, S.zoom), this.stateDependentLayerIds = this.layers.filter((D)=>D.isStateDependent()).map((D)=>D.id);
                        }
                        populate(S, D, j) {
                            let te = this.layers[0], ue = [], ve = null, De = !1;
                            te.type === "circle" && (ve = te.layout.get("circle-sort-key"), De = !ve.isConstant());
                            for (let { feature: Ze, id: at, index: Tt, sourceLayerIndex: Ft } of S){
                                let Qt = this.layers[0]._featureFilter.needGeometry, sr = xl(Ze, Qt);
                                if (!this.layers[0]._featureFilter.filter(new Ko(this.zoom), sr, j)) continue;
                                let Tr = De ? ve.evaluate(sr, {}, j) : void 0, Pr = {
                                    id: at,
                                    properties: Ze.properties,
                                    type: Ze.type,
                                    sourceLayerIndex: Ft,
                                    index: Tt,
                                    geometry: Qt ? sr.geometry : js(Ze),
                                    patterns: {},
                                    sortKey: Tr
                                };
                                ue.push(Pr);
                            }
                            De && ue.sort((Ze, at)=>Ze.sortKey - at.sortKey);
                            for (let Ze of ue){
                                let { geometry: at, index: Tt, sourceLayerIndex: Ft } = Ze, Qt = S[Tt].feature;
                                this.addFeature(Ze, at, Tt, j), D.featureIndex.insert(Qt, at, Tt, Ft, this.index);
                            }
                        }
                        update(S, D, j) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(S, D, this.stateDependentLayers, j);
                        }
                        isEmpty() {
                            return this.layoutVertexArray.length === 0;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(S) {
                            this.uploaded || (this.layoutVertexBuffer = S.createVertexBuffer(this.layoutVertexArray, Ue), this.indexBuffer = S.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(S), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }
                        addFeature(S, D, j, te) {
                            for (let ue of D)for (let ve of ue){
                                let De = ve.x, Ze = ve.y;
                                if (De < 0 || De >= za || Ze < 0 || Ze >= za) continue;
                                let at = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, S.sortKey), Tt = at.vertexLength;
                                fu(this.layoutVertexArray, De, Ze, -1, -1), fu(this.layoutVertexArray, De, Ze, 1, -1), fu(this.layoutVertexArray, De, Ze, 1, 1), fu(this.layoutVertexArray, De, Ze, -1, 1), this.indexArray.emplaceBack(Tt, Tt + 1, Tt + 2), this.indexArray.emplaceBack(Tt, Tt + 3, Tt + 2), at.vertexLength += 4, at.primitiveLength += 2;
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, S, j, {}, te);
                        }
                    }
                    function xc(R, S) {
                        for(let D = 0; D < R.length; D++)if (On(S, R[D])) return !0;
                        for(let D = 0; D < S.length; D++)if (On(R, S[D])) return !0;
                        return !!wi(R, S);
                    }
                    function At(R, S, D) {
                        return !!On(R, S) || !!Oi(S, R, D);
                    }
                    function Er(R, S) {
                        if (R.length === 1) return cn(S, R[0]);
                        for(let D = 0; D < S.length; D++){
                            let j = S[D];
                            for(let te = 0; te < j.length; te++)if (On(R, j[te])) return !0;
                        }
                        for(let D = 0; D < R.length; D++)if (cn(S, R[D])) return !0;
                        for(let D = 0; D < S.length; D++)if (wi(R, S[D])) return !0;
                        return !1;
                    }
                    function Wr(R, S, D) {
                        if (R.length > 1) {
                            if (wi(R, S)) return !0;
                            for(let j = 0; j < S.length; j++)if (Oi(S[j], R, D)) return !0;
                        }
                        for(let j = 0; j < R.length; j++)if (Oi(R[j], S, D)) return !0;
                        return !1;
                    }
                    function wi(R, S) {
                        if (R.length === 0 || S.length === 0) return !1;
                        for(let D = 0; D < R.length - 1; D++){
                            let j = R[D], te = R[D + 1];
                            for(let ue = 0; ue < S.length - 1; ue++)if (Ui(j, te, S[ue], S[ue + 1])) return !0;
                        }
                        return !1;
                    }
                    function Ui(R, S, D, j) {
                        return F(R, D, j) !== F(S, D, j) && F(R, S, D) !== F(R, S, j);
                    }
                    function Oi(R, S, D) {
                        let j = D * D;
                        if (S.length === 1) return R.distSqr(S[0]) < j;
                        for(let te = 1; te < S.length; te++)if (Bi(R, S[te - 1], S[te]) < j) return !0;
                        return !1;
                    }
                    function Bi(R, S, D) {
                        let j = S.distSqr(D);
                        if (j === 0) return R.distSqr(S);
                        let te = ((R.x - S.x) * (D.x - S.x) + (R.y - S.y) * (D.y - S.y)) / j;
                        return R.distSqr(te < 0 ? S : te > 1 ? D : D.sub(S)._mult(te)._add(S));
                    }
                    function cn(R, S) {
                        let D, j, te, ue = !1;
                        for(let ve = 0; ve < R.length; ve++){
                            D = R[ve];
                            for(let De = 0, Ze = D.length - 1; De < D.length; Ze = De++)j = D[De], te = D[Ze], j.y > S.y != te.y > S.y && S.x < (te.x - j.x) * (S.y - j.y) / (te.y - j.y) + j.x && (ue = !ue);
                        }
                        return ue;
                    }
                    function On(R, S) {
                        let D = !1;
                        for(let j = 0, te = R.length - 1; j < R.length; te = j++){
                            let ue = R[j], ve = R[te];
                            ue.y > S.y != ve.y > S.y && S.x < (ve.x - ue.x) * (S.y - ue.y) / (ve.y - ue.y) + ue.x && (D = !D);
                        }
                        return D;
                    }
                    function Bn(R, S, D) {
                        let j = D[0], te = D[2];
                        if (R.x < j.x && S.x < j.x || R.x > te.x && S.x > te.x || R.y < j.y && S.y < j.y || R.y > te.y && S.y > te.y) return !1;
                        let ue = F(R, S, D[0]);
                        return ue !== F(R, S, D[1]) || ue !== F(R, S, D[2]) || ue !== F(R, S, D[3]);
                    }
                    function yn(R, S, D) {
                        let j = S.paint.get(R).value;
                        return j.kind === "constant" ? j.value : D.programConfigurations.get(S.id).getMaxValue(R);
                    }
                    function to(R) {
                        return Math.sqrt(R[0] * R[0] + R[1] * R[1]);
                    }
                    function Rn(R, S, D, j, te) {
                        if (!S[0] && !S[1]) return R;
                        let ue = u.convert(S)._mult(te);
                        D === "viewport" && ue._rotate(-j);
                        let ve = [];
                        for(let De = 0; De < R.length; De++)ve.push(R[De].sub(ue));
                        return ve;
                    }
                    let Dn, fn;
                    mi("CircleBucket", dl, {
                        omit: [
                            "layers"
                        ]
                    });
                    var Ai = {
                        get paint () {
                            return fn = fn || new le({
                                "circle-radius": new eo(ce.paint_circle["circle-radius"]),
                                "circle-color": new eo(ce.paint_circle["circle-color"]),
                                "circle-blur": new eo(ce.paint_circle["circle-blur"]),
                                "circle-opacity": new eo(ce.paint_circle["circle-opacity"]),
                                "circle-translate": new Da(ce.paint_circle["circle-translate"]),
                                "circle-translate-anchor": new Da(ce.paint_circle["circle-translate-anchor"]),
                                "circle-pitch-scale": new Da(ce.paint_circle["circle-pitch-scale"]),
                                "circle-pitch-alignment": new Da(ce.paint_circle["circle-pitch-alignment"]),
                                "circle-stroke-width": new eo(ce.paint_circle["circle-stroke-width"]),
                                "circle-stroke-color": new eo(ce.paint_circle["circle-stroke-color"]),
                                "circle-stroke-opacity": new eo(ce.paint_circle["circle-stroke-opacity"])
                            });
                        },
                        get layout () {
                            return Dn = Dn || new le({
                                "circle-sort-key": new eo(ce.layout_circle["circle-sort-key"])
                            });
                        }
                    }, ji = 1e-6, Ln = typeof Float32Array != "undefined" ? Float32Array : Array;
                    function Un(R) {
                        return R[0] = 1, R[1] = 0, R[2] = 0, R[3] = 0, R[4] = 0, R[5] = 1, R[6] = 0, R[7] = 0, R[8] = 0, R[9] = 0, R[10] = 1, R[11] = 0, R[12] = 0, R[13] = 0, R[14] = 0, R[15] = 1, R;
                    }
                    function gn(R, S, D) {
                        var j = S[0], te = S[1], ue = S[2], ve = S[3], De = S[4], Ze = S[5], at = S[6], Tt = S[7], Ft = S[8], Qt = S[9], sr = S[10], Tr = S[11], Pr = S[12], $r = S[13], ni = S[14], Di = S[15], pi = D[0], ki = D[1], Zi = D[2], ta = D[3];
                        return R[0] = pi * j + ki * De + Zi * Ft + ta * Pr, R[1] = pi * te + ki * Ze + Zi * Qt + ta * $r, R[2] = pi * ue + ki * at + Zi * sr + ta * ni, R[3] = pi * ve + ki * Tt + Zi * Tr + ta * Di, R[4] = (pi = D[4]) * j + (ki = D[5]) * De + (Zi = D[6]) * Ft + (ta = D[7]) * Pr, R[5] = pi * te + ki * Ze + Zi * Qt + ta * $r, R[6] = pi * ue + ki * at + Zi * sr + ta * ni, R[7] = pi * ve + ki * Tt + Zi * Tr + ta * Di, R[8] = (pi = D[8]) * j + (ki = D[9]) * De + (Zi = D[10]) * Ft + (ta = D[11]) * Pr, R[9] = pi * te + ki * Ze + Zi * Qt + ta * $r, R[10] = pi * ue + ki * at + Zi * sr + ta * ni, R[11] = pi * ve + ki * Tt + Zi * Tr + ta * Di, R[12] = (pi = D[12]) * j + (ki = D[13]) * De + (Zi = D[14]) * Ft + (ta = D[15]) * Pr, R[13] = pi * te + ki * Ze + Zi * Qt + ta * $r, R[14] = pi * ue + ki * at + Zi * sr + ta * ni, R[15] = pi * ve + ki * Tt + Zi * Tr + ta * Di, R;
                    }
                    Math.hypot || (Math.hypot = function() {
                        for(var R = 0, S = arguments.length; S--;)R += arguments[S] * arguments[S];
                        return Math.sqrt(R);
                    });
                    var ca, Kn = gn;
                    function Za(R, S, D) {
                        var j = S[0], te = S[1], ue = S[2], ve = S[3];
                        return R[0] = D[0] * j + D[4] * te + D[8] * ue + D[12] * ve, R[1] = D[1] * j + D[5] * te + D[9] * ue + D[13] * ve, R[2] = D[2] * j + D[6] * te + D[10] * ue + D[14] * ve, R[3] = D[3] * j + D[7] * te + D[11] * ue + D[15] * ve, R;
                    }
                    ca = new Ln(4), Ln != Float32Array && (ca[0] = 0, ca[1] = 0, ca[2] = 0, ca[3] = 0);
                    class wn extends B {
                        constructor(S){
                            super(S, Ai);
                        }
                        createBucket(S) {
                            return new dl(S);
                        }
                        queryRadius(S) {
                            let D = S;
                            return yn("circle-radius", this, D) + yn("circle-stroke-width", this, D) + to(this.paint.get("circle-translate"));
                        }
                        queryIntersectsFeature(S, D, j, te, ue, ve, De, Ze) {
                            let at = Rn(S, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), ve.angle, De), Tt = this.paint.get("circle-radius").evaluate(D, j) + this.paint.get("circle-stroke-width").evaluate(D, j), Ft = this.paint.get("circle-pitch-alignment") === "map", Qt = Ft ? at : function(Tr, Pr) {
                                return Tr.map(($r)=>vn($r, Pr));
                            }(at, Ze), sr = Ft ? Tt * De : Tt;
                            for (let Tr of te)for (let Pr of Tr){
                                let $r = Ft ? Pr : vn(Pr, Ze), ni = sr, Di = Za([], [
                                    Pr.x,
                                    Pr.y,
                                    0,
                                    1
                                ], Ze);
                                if (this.paint.get("circle-pitch-scale") === "viewport" && this.paint.get("circle-pitch-alignment") === "map" ? ni *= Di[3] / ve.cameraToCenterDistance : this.paint.get("circle-pitch-scale") === "map" && this.paint.get("circle-pitch-alignment") === "viewport" && (ni *= ve.cameraToCenterDistance / Di[3]), At(Qt, $r, ni)) return !0;
                            }
                            return !1;
                        }
                    }
                    function vn(R, S) {
                        let D = Za([], [
                            R.x,
                            R.y,
                            0,
                            1
                        ], S);
                        return new u(D[0] / D[3], D[1] / D[3]);
                    }
                    class Aa extends dl {
                    }
                    let aa;
                    mi("HeatmapBucket", Aa, {
                        omit: [
                            "layers"
                        ]
                    });
                    var Xn = {
                        get paint () {
                            return aa = aa || new le({
                                "heatmap-radius": new eo(ce.paint_heatmap["heatmap-radius"]),
                                "heatmap-weight": new eo(ce.paint_heatmap["heatmap-weight"]),
                                "heatmap-intensity": new Da(ce.paint_heatmap["heatmap-intensity"]),
                                "heatmap-color": new _c(ce.paint_heatmap["heatmap-color"]),
                                "heatmap-opacity": new Da(ce.paint_heatmap["heatmap-opacity"])
                            });
                        }
                    };
                    function Vn(R, { width: S, height: D }, j, te) {
                        if (te) {
                            if (te instanceof Uint8ClampedArray) te = new Uint8Array(te.buffer);
                            else if (te.length !== S * D * j) throw new RangeError(`mismatched image size. expected: ${te.length} but got: ${S * D * j}`);
                        } else te = new Uint8Array(S * D * j);
                        return R.width = S, R.height = D, R.data = te, R;
                    }
                    function ma(R, { width: S, height: D }, j) {
                        if (S === R.width && D === R.height) return;
                        let te = Vn({}, {
                            width: S,
                            height: D
                        }, j);
                        ro(R, te, {
                            x: 0,
                            y: 0
                        }, {
                            x: 0,
                            y: 0
                        }, {
                            width: Math.min(R.width, S),
                            height: Math.min(R.height, D)
                        }, j), R.width = S, R.height = D, R.data = te.data;
                    }
                    function ro(R, S, D, j, te, ue) {
                        if (te.width === 0 || te.height === 0) return S;
                        if (te.width > R.width || te.height > R.height || D.x > R.width - te.width || D.y > R.height - te.height) throw new RangeError("out of range source coordinates for image copy");
                        if (te.width > S.width || te.height > S.height || j.x > S.width - te.width || j.y > S.height - te.height) throw new RangeError("out of range destination coordinates for image copy");
                        let ve = R.data, De = S.data;
                        if (ve === De) throw new Error("srcData equals dstData, so image is already copied");
                        for(let Ze = 0; Ze < te.height; Ze++){
                            let at = ((D.y + Ze) * R.width + D.x) * ue, Tt = ((j.y + Ze) * S.width + j.x) * ue;
                            for(let Ft = 0; Ft < te.width * ue; Ft++)De[Tt + Ft] = ve[at + Ft];
                        }
                        return S;
                    }
                    class Ao {
                        constructor(S, D){
                            Vn(this, S, 1, D);
                        }
                        resize(S) {
                            ma(this, S, 1);
                        }
                        clone() {
                            return new Ao({
                                width: this.width,
                                height: this.height
                            }, new Uint8Array(this.data));
                        }
                        static copy(S, D, j, te, ue) {
                            ro(S, D, j, te, ue, 1);
                        }
                    }
                    class Jn {
                        constructor(S, D){
                            Vn(this, S, 4, D);
                        }
                        resize(S) {
                            ma(this, S, 4);
                        }
                        replace(S, D) {
                            D ? this.data.set(S) : this.data = S instanceof Uint8ClampedArray ? new Uint8Array(S.buffer) : S;
                        }
                        clone() {
                            return new Jn({
                                width: this.width,
                                height: this.height
                            }, new Uint8Array(this.data));
                        }
                        static copy(S, D, j, te, ue) {
                            ro(S, D, j, te, ue, 4);
                        }
                    }
                    function Oa(R) {
                        let S = {}, D = R.resolution || 256, j = R.clips ? R.clips.length : 1, te = R.image || new Jn({
                            width: D,
                            height: j
                        });
                        if (Math.log(D) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${D}`);
                        let ue = (ve, De, Ze)=>{
                            S[R.evaluationKey] = Ze;
                            let at = R.expression.evaluate(S);
                            te.data[ve + De + 0] = Math.floor(255 * at.r / at.a), te.data[ve + De + 1] = Math.floor(255 * at.g / at.a), te.data[ve + De + 2] = Math.floor(255 * at.b / at.a), te.data[ve + De + 3] = Math.floor(255 * at.a);
                        };
                        if (R.clips) for(let ve = 0, De = 0; ve < j; ++ve, De += 4 * D)for(let Ze = 0, at = 0; Ze < D; Ze++, at += 4){
                            let Tt = Ze / (D - 1), { start: Ft, end: Qt } = R.clips[ve];
                            ue(De, at, Ft * (1 - Tt) + Qt * Tt);
                        }
                        else for(let ve = 0, De = 0; ve < D; ve++, De += 4)ue(0, De, ve / (D - 1));
                        return te;
                    }
                    mi("AlphaImage", Ao), mi("RGBAImage", Jn);
                    let _o = "big-fb";
                    class Po extends B {
                        createBucket(S) {
                            return new Aa(S);
                        }
                        constructor(S){
                            super(S, Xn), this.heatmapFbos = new Map, this._updateColorRamp();
                        }
                        _handleSpecialPaintPropertyUpdate(S) {
                            S === "heatmap-color" && this._updateColorRamp();
                        }
                        _updateColorRamp() {
                            this.colorRamp = Oa({
                                expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                                evaluationKey: "heatmapDensity",
                                image: this.colorRamp
                            }), this.colorRampTexture = null;
                        }
                        resize() {
                            this.heatmapFbos.has(_o) && this.heatmapFbos.delete(_o);
                        }
                        queryRadius() {
                            return 0;
                        }
                        queryIntersectsFeature() {
                            return !1;
                        }
                        hasOffscreenPass() {
                            return this.paint.get("heatmap-opacity") !== 0 && this.visibility !== "none";
                        }
                    }
                    let Jo;
                    var Yl = {
                        get paint () {
                            return Jo = Jo || new le({
                                "hillshade-illumination-direction": new Da(ce.paint_hillshade["hillshade-illumination-direction"]),
                                "hillshade-illumination-anchor": new Da(ce.paint_hillshade["hillshade-illumination-anchor"]),
                                "hillshade-exaggeration": new Da(ce.paint_hillshade["hillshade-exaggeration"]),
                                "hillshade-shadow-color": new Da(ce.paint_hillshade["hillshade-shadow-color"]),
                                "hillshade-highlight-color": new Da(ce.paint_hillshade["hillshade-highlight-color"]),
                                "hillshade-accent-color": new Da(ce.paint_hillshade["hillshade-accent-color"])
                            });
                        }
                    };
                    class $c extends B {
                        constructor(S){
                            super(S, Yl);
                        }
                        hasOffscreenPass() {
                            return this.paint.get("hillshade-exaggeration") !== 0 && this.visibility !== "none";
                        }
                    }
                    let xs = qe([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), { members: Qc } = xs;
                    function El(R, S, D = 2) {
                        let j = S && S.length, te = j ? S[0] * D : R.length, ue = bc(R, 0, te, D, !0), ve = [];
                        if (!ue || ue.next === ue.prev) return ve;
                        let De, Ze, at;
                        if (j && (ue = function(Tt, Ft, Qt, sr) {
                            let Tr = [];
                            for(let Pr = 0, $r = Ft.length; Pr < $r; Pr++){
                                let ni = bc(Tt, Ft[Pr] * sr, Pr < $r - 1 ? Ft[Pr + 1] * sr : Tt.length, sr, !1);
                                ni === ni.next && (ni.steiner = !0), Tr.push(K(ni));
                            }
                            Tr.sort(_f);
                            for(let Pr = 0; Pr < Tr.length; Pr++)Qt = ns(Tr[Pr], Qt);
                            return Qt;
                        }(R, S, ue, D)), R.length > 80 * D) {
                            De = 1 / 0, Ze = 1 / 0;
                            let Tt = -1 / 0, Ft = -1 / 0;
                            for(let Qt = D; Qt < te; Qt += D){
                                let sr = R[Qt], Tr = R[Qt + 1];
                                sr < De && (De = sr), Tr < Ze && (Ze = Tr), sr > Tt && (Tt = sr), Tr > Ft && (Ft = Tr);
                            }
                            at = Math.max(Tt - De, Ft - Ze), at = at !== 0 ? 32767 / at : 0;
                        }
                        return yf(ue, ve, D, De, Ze, at, 0), ve;
                    }
                    function bc(R, S, D, j, te) {
                        let ue;
                        if (te === function(ve, De, Ze, at) {
                            let Tt = 0;
                            for(let Ft = De, Qt = Ze - at; Ft < Ze; Ft += at)Tt += (ve[Qt] - ve[Ft]) * (ve[Ft + 1] + ve[Qt + 1]), Qt = Ft;
                            return Tt;
                        }(R, S, D, j) > 0) for(let ve = S; ve < D; ve += j)ue = Jt(ve / j | 0, R[ve], R[ve + 1], ue);
                        else for(let ve = D - j; ve >= S; ve -= j)ue = Jt(ve / j | 0, R[ve], R[ve + 1], ue);
                        return ue && de(ue, ue.next) && (vt(ue), ue = ue.next), ue;
                    }
                    function wc(R, S) {
                        if (!R) return R;
                        S || (S = R);
                        let D, j = R;
                        do if (D = !1, j.steiner || !de(j, j.next) && pe(j.prev, j, j.next) !== 0) j = j.next;
                        else {
                            if (vt(j), j = S = j.prev, j === j.next) break;
                            D = !0;
                        }
                        while (D || j !== S);
                        return S;
                    }
                    function yf(R, S, D, j, te, ue, ve) {
                        if (!R) return;
                        !ve && ue && function(Ze, at, Tt, Ft) {
                            let Qt = Ze;
                            do Qt.z === 0 && (Qt.z = z(Qt.x, Qt.y, at, Tt, Ft)), Qt.prevZ = Qt.prev, Qt.nextZ = Qt.next, Qt = Qt.next;
                            while (Qt !== Ze);
                            Qt.prevZ.nextZ = null, Qt.prevZ = null, function(sr) {
                                let Tr, Pr = 1;
                                do {
                                    let $r, ni = sr;
                                    sr = null;
                                    let Di = null;
                                    for(Tr = 0; ni;){
                                        Tr++;
                                        let pi = ni, ki = 0;
                                        for(let ta = 0; ta < Pr && (ki++, pi = pi.nextZ, pi); ta++);
                                        let Zi = Pr;
                                        for(; ki > 0 || Zi > 0 && pi;)ki !== 0 && (Zi === 0 || !pi || ni.z <= pi.z) ? ($r = ni, ni = ni.nextZ, ki--) : ($r = pi, pi = pi.nextZ, Zi--), Di ? Di.nextZ = $r : sr = $r, $r.prevZ = Di, Di = $r;
                                        ni = pi;
                                    }
                                    Di.nextZ = null, Pr *= 2;
                                }while (Tr > 1);
                            }(Qt);
                        }(R, j, te, ue);
                        let De = R;
                        for(; R.prev !== R.next;){
                            let Ze = R.prev, at = R.next;
                            if (ue ? Fc(R, j, te, ue) : Gl(R)) S.push(Ze.i, R.i, at.i), vt(R), R = at.next, De = at.next;
                            else if ((R = at) === De) {
                                ve ? ve === 1 ? yf(R = ef(wc(R), S), S, D, j, te, ue, 2) : ve === 2 && ls(R, S, D, j, te, ue) : yf(wc(R), S, D, j, te, ue, 1);
                                break;
                            }
                        }
                    }
                    function Gl(R) {
                        let S = R.prev, D = R, j = R.next;
                        if (pe(S, D, j) >= 0) return !1;
                        let te = S.x, ue = D.x, ve = j.x, De = S.y, Ze = D.y, at = j.y, Tt = te < ue ? te < ve ? te : ve : ue < ve ? ue : ve, Ft = De < Ze ? De < at ? De : at : Ze < at ? Ze : at, Qt = te > ue ? te > ve ? te : ve : ue > ve ? ue : ve, sr = De > Ze ? De > at ? De : at : Ze > at ? Ze : at, Tr = j.next;
                        for(; Tr !== S;){
                            if (Tr.x >= Tt && Tr.x <= Qt && Tr.y >= Ft && Tr.y <= sr && O(te, De, ue, Ze, ve, at, Tr.x, Tr.y) && pe(Tr.prev, Tr, Tr.next) >= 0) return !1;
                            Tr = Tr.next;
                        }
                        return !0;
                    }
                    function Fc(R, S, D, j) {
                        let te = R.prev, ue = R, ve = R.next;
                        if (pe(te, ue, ve) >= 0) return !1;
                        let De = te.x, Ze = ue.x, at = ve.x, Tt = te.y, Ft = ue.y, Qt = ve.y, sr = De < Ze ? De < at ? De : at : Ze < at ? Ze : at, Tr = Tt < Ft ? Tt < Qt ? Tt : Qt : Ft < Qt ? Ft : Qt, Pr = De > Ze ? De > at ? De : at : Ze > at ? Ze : at, $r = Tt > Ft ? Tt > Qt ? Tt : Qt : Ft > Qt ? Ft : Qt, ni = z(sr, Tr, S, D, j), Di = z(Pr, $r, S, D, j), pi = R.prevZ, ki = R.nextZ;
                        for(; pi && pi.z >= ni && ki && ki.z <= Di;){
                            if (pi.x >= sr && pi.x <= Pr && pi.y >= Tr && pi.y <= $r && pi !== te && pi !== ve && O(De, Tt, Ze, Ft, at, Qt, pi.x, pi.y) && pe(pi.prev, pi, pi.next) >= 0 || (pi = pi.prevZ, ki.x >= sr && ki.x <= Pr && ki.y >= Tr && ki.y <= $r && ki !== te && ki !== ve && O(De, Tt, Ze, Ft, at, Qt, ki.x, ki.y) && pe(ki.prev, ki, ki.next) >= 0)) return !1;
                            ki = ki.nextZ;
                        }
                        for(; pi && pi.z >= ni;){
                            if (pi.x >= sr && pi.x <= Pr && pi.y >= Tr && pi.y <= $r && pi !== te && pi !== ve && O(De, Tt, Ze, Ft, at, Qt, pi.x, pi.y) && pe(pi.prev, pi, pi.next) >= 0) return !1;
                            pi = pi.prevZ;
                        }
                        for(; ki && ki.z <= Di;){
                            if (ki.x >= sr && ki.x <= Pr && ki.y >= Tr && ki.y <= $r && ki !== te && ki !== ve && O(De, Tt, Ze, Ft, at, Qt, ki.x, ki.y) && pe(ki.prev, ki, ki.next) >= 0) return !1;
                            ki = ki.nextZ;
                        }
                        return !0;
                    }
                    function ef(R, S) {
                        let D = R;
                        do {
                            let j = D.prev, te = D.next.next;
                            !de(j, te) && Ie(j, D, D.next, te) && Kt(j, te) && Kt(te, j) && (S.push(j.i, D.i, te.i), vt(D), vt(D.next), D = R = te), D = D.next;
                        }while (D !== R);
                        return wc(D);
                    }
                    function ls(R, S, D, j, te, ue) {
                        let ve = R;
                        do {
                            let De = ve.next.next;
                            for(; De !== ve.prev;){
                                if (ve.i !== De.i && $(ve, De)) {
                                    let Ze = ir(ve, De);
                                    return ve = wc(ve, ve.next), Ze = wc(Ze, Ze.next), yf(ve, S, D, j, te, ue, 0), void yf(Ze, S, D, j, te, ue, 0);
                                }
                                De = De.next;
                            }
                            ve = ve.next;
                        }while (ve !== R);
                    }
                    function _f(R, S) {
                        return R.x - S.x;
                    }
                    function ns(R, S) {
                        let D = function(te, ue) {
                            let ve = ue, De = te.x, Ze = te.y, at, Tt = -1 / 0;
                            do {
                                if (Ze <= ve.y && Ze >= ve.next.y && ve.next.y !== ve.y) {
                                    let Pr = ve.x + (Ze - ve.y) * (ve.next.x - ve.x) / (ve.next.y - ve.y);
                                    if (Pr <= De && Pr > Tt && (Tt = Pr, at = ve.x < ve.next.x ? ve : ve.next, Pr === De)) return at;
                                }
                                ve = ve.next;
                            }while (ve !== ue);
                            if (!at) return null;
                            let Ft = at, Qt = at.x, sr = at.y, Tr = 1 / 0;
                            ve = at;
                            do {
                                if (De >= ve.x && ve.x >= Qt && De !== ve.x && O(Ze < sr ? De : Tt, Ze, Qt, sr, Ze < sr ? Tt : De, Ze, ve.x, ve.y)) {
                                    let Pr = Math.abs(Ze - ve.y) / (De - ve.x);
                                    Kt(ve, te) && (Pr < Tr || Pr === Tr && (ve.x > at.x || ve.x === at.x && Y1(at, ve))) && (at = ve, Tr = Pr);
                                }
                                ve = ve.next;
                            }while (ve !== Ft);
                            return at;
                        }(R, S);
                        if (!D) return S;
                        let j = ir(D, R);
                        return wc(j, j.next), wc(D, D.next);
                    }
                    function Y1(R, S) {
                        return pe(R.prev, R, S.prev) < 0 && pe(S.next, R, R.next) < 0;
                    }
                    function z(R, S, D, j, te) {
                        return (R = 1431655765 & ((R = 858993459 & ((R = 252645135 & ((R = 16711935 & ((R = (R - D) * te | 0) | R << 8)) | R << 4)) | R << 2)) | R << 1)) | (S = 1431655765 & ((S = 858993459 & ((S = 252645135 & ((S = 16711935 & ((S = (S - j) * te | 0) | S << 8)) | S << 4)) | S << 2)) | S << 1)) << 1;
                    }
                    function K(R) {
                        let S = R, D = R;
                        do (S.x < D.x || S.x === D.x && S.y < D.y) && (D = S), S = S.next;
                        while (S !== R);
                        return D;
                    }
                    function O(R, S, D, j, te, ue, ve, De) {
                        return (te - ve) * (S - De) >= (R - ve) * (ue - De) && (R - ve) * (j - De) >= (D - ve) * (S - De) && (D - ve) * (ue - De) >= (te - ve) * (j - De);
                    }
                    function $(R, S) {
                        return R.next.i !== S.i && R.prev.i !== S.i && !function(D, j) {
                            let te = D;
                            do {
                                if (te.i !== D.i && te.next.i !== D.i && te.i !== j.i && te.next.i !== j.i && Ie(te, te.next, D, j)) return !0;
                                te = te.next;
                            }while (te !== D);
                            return !1;
                        }(R, S) && (Kt(R, S) && Kt(S, R) && function(D, j) {
                            let te = D, ue = !1, ve = (D.x + j.x) / 2, De = (D.y + j.y) / 2;
                            do te.y > De != te.next.y > De && te.next.y !== te.y && ve < (te.next.x - te.x) * (De - te.y) / (te.next.y - te.y) + te.x && (ue = !ue), te = te.next;
                            while (te !== D);
                            return ue;
                        }(R, S) && (pe(R.prev, R, S.prev) || pe(R, S.prev, S)) || de(R, S) && pe(R.prev, R, R.next) > 0 && pe(S.prev, S, S.next) > 0);
                    }
                    function pe(R, S, D) {
                        return (S.y - R.y) * (D.x - S.x) - (S.x - R.x) * (D.y - S.y);
                    }
                    function de(R, S) {
                        return R.x === S.x && R.y === S.y;
                    }
                    function Ie(R, S, D, j) {
                        let te = pt(pe(R, S, D)), ue = pt(pe(R, S, j)), ve = pt(pe(D, j, R)), De = pt(pe(D, j, S));
                        return te !== ue && ve !== De || !(te !== 0 || !$e(R, D, S)) || !(ue !== 0 || !$e(R, j, S)) || !(ve !== 0 || !$e(D, R, j)) || !(De !== 0 || !$e(D, S, j));
                    }
                    function $e(R, S, D) {
                        return S.x <= Math.max(R.x, D.x) && S.x >= Math.min(R.x, D.x) && S.y <= Math.max(R.y, D.y) && S.y >= Math.min(R.y, D.y);
                    }
                    function pt(R) {
                        return R > 0 ? 1 : R < 0 ? -1 : 0;
                    }
                    function Kt(R, S) {
                        return pe(R.prev, R, R.next) < 0 ? pe(R, S, R.next) >= 0 && pe(R, R.prev, S) >= 0 : pe(R, S, R.prev) < 0 || pe(R, R.next, S) < 0;
                    }
                    function ir(R, S) {
                        let D = Pt(R.i, R.x, R.y), j = Pt(S.i, S.x, S.y), te = R.next, ue = S.prev;
                        return R.next = S, S.prev = R, D.next = te, te.prev = D, j.next = D, D.prev = j, ue.next = j, j.prev = ue, j;
                    }
                    function Jt(R, S, D, j) {
                        let te = Pt(R, S, D);
                        return j ? (te.next = j.next, te.prev = j, j.next.prev = te, j.next = te) : (te.prev = te, te.next = te), te;
                    }
                    function vt(R) {
                        R.next.prev = R.prev, R.prev.next = R.next, R.prevZ && (R.prevZ.nextZ = R.nextZ), R.nextZ && (R.nextZ.prevZ = R.prevZ);
                    }
                    function Pt(R, S, D) {
                        return {
                            i: R,
                            x: S,
                            y: D,
                            prev: null,
                            next: null,
                            z: 0,
                            prevZ: null,
                            nextZ: null,
                            steiner: !1
                        };
                    }
                    function Wt(R, S, D) {
                        let j = D.patternDependencies, te = !1;
                        for (let ue of S){
                            let ve = ue.paint.get(`${R}-pattern`);
                            ve.isConstant() || (te = !0);
                            let De = ve.constantOr(null);
                            De && (te = !0, j[De.to] = !0, j[De.from] = !0);
                        }
                        return te;
                    }
                    function rr(R, S, D, j, te) {
                        let ue = te.patternDependencies;
                        for (let ve of S){
                            let De = ve.paint.get(`${R}-pattern`).value;
                            if (De.kind !== "constant") {
                                let Ze = De.evaluate({
                                    zoom: j - 1
                                }, D, {}, te.availableImages), at = De.evaluate({
                                    zoom: j
                                }, D, {}, te.availableImages), Tt = De.evaluate({
                                    zoom: j + 1
                                }, D, {}, te.availableImages);
                                Ze = Ze && Ze.name ? Ze.name : Ze, at = at && at.name ? at.name : at, Tt = Tt && Tt.name ? Tt.name : Tt, ue[Ze] = !0, ue[at] = !0, ue[Tt] = !0, D.patterns[ve.id] = {
                                    min: Ze,
                                    mid: at,
                                    max: Tt
                                };
                            }
                        }
                        return D;
                    }
                    class dr {
                        constructor(S){
                            this.zoom = S.zoom, this.overscaling = S.overscaling, this.layers = S.layers, this.layerIds = this.layers.map((D)=>D.id), this.index = S.index, this.hasPattern = !1, this.patternFeatures = [], this.layoutVertexArray = new _l, this.indexArray = new oe, this.indexArray2 = new we, this.programConfigurations = new _s(S.layers, S.zoom), this.segments = new We, this.segments2 = new We, this.stateDependentLayerIds = this.layers.filter((D)=>D.isStateDependent()).map((D)=>D.id);
                        }
                        populate(S, D, j) {
                            this.hasPattern = Wt("fill", this.layers, D);
                            let te = this.layers[0].layout.get("fill-sort-key"), ue = !te.isConstant(), ve = [];
                            for (let { feature: De, id: Ze, index: at, sourceLayerIndex: Tt } of S){
                                let Ft = this.layers[0]._featureFilter.needGeometry, Qt = xl(De, Ft);
                                if (!this.layers[0]._featureFilter.filter(new Ko(this.zoom), Qt, j)) continue;
                                let sr = ue ? te.evaluate(Qt, {}, j, D.availableImages) : void 0, Tr = {
                                    id: Ze,
                                    properties: De.properties,
                                    type: De.type,
                                    sourceLayerIndex: Tt,
                                    index: at,
                                    geometry: Ft ? Qt.geometry : js(De),
                                    patterns: {},
                                    sortKey: sr
                                };
                                ve.push(Tr);
                            }
                            ue && ve.sort((De, Ze)=>De.sortKey - Ze.sortKey);
                            for (let De of ve){
                                let { geometry: Ze, index: at, sourceLayerIndex: Tt } = De;
                                if (this.hasPattern) {
                                    let Ft = rr("fill", this.layers, De, this.zoom, D);
                                    this.patternFeatures.push(Ft);
                                } else this.addFeature(De, Ze, at, j, {});
                                D.featureIndex.insert(S[at].feature, Ze, at, Tt, this.index);
                            }
                        }
                        update(S, D, j) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(S, D, this.stateDependentLayers, j);
                        }
                        addFeatures(S, D, j) {
                            for (let te of this.patternFeatures)this.addFeature(te, te.geometry, te.index, D, j);
                        }
                        isEmpty() {
                            return this.layoutVertexArray.length === 0;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(S) {
                            this.uploaded || (this.layoutVertexBuffer = S.createVertexBuffer(this.layoutVertexArray, Qc), this.indexBuffer = S.createIndexBuffer(this.indexArray), this.indexBuffer2 = S.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(S), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
                        }
                        addFeature(S, D, j, te, ue) {
                            for (let ve of Of(D, 500)){
                                let De = 0;
                                for (let sr of ve)De += sr.length;
                                let Ze = this.segments.prepareSegment(De, this.layoutVertexArray, this.indexArray), at = Ze.vertexLength, Tt = [], Ft = [];
                                for (let sr of ve){
                                    if (sr.length === 0) continue;
                                    sr !== ve[0] && Ft.push(Tt.length / 2);
                                    let Tr = this.segments2.prepareSegment(sr.length, this.layoutVertexArray, this.indexArray2), Pr = Tr.vertexLength;
                                    this.layoutVertexArray.emplaceBack(sr[0].x, sr[0].y), this.indexArray2.emplaceBack(Pr + sr.length - 1, Pr), Tt.push(sr[0].x), Tt.push(sr[0].y);
                                    for(let $r = 1; $r < sr.length; $r++)this.layoutVertexArray.emplaceBack(sr[$r].x, sr[$r].y), this.indexArray2.emplaceBack(Pr + $r - 1, Pr + $r), Tt.push(sr[$r].x), Tt.push(sr[$r].y);
                                    Tr.vertexLength += sr.length, Tr.primitiveLength += sr.length;
                                }
                                let Qt = El(Tt, Ft);
                                for(let sr = 0; sr < Qt.length; sr += 3)this.indexArray.emplaceBack(at + Qt[sr], at + Qt[sr + 1], at + Qt[sr + 2]);
                                Ze.vertexLength += De, Ze.primitiveLength += Qt.length / 3;
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, S, j, ue, te);
                        }
                    }
                    let pr, kr;
                    mi("FillBucket", dr, {
                        omit: [
                            "layers",
                            "patternFeatures"
                        ]
                    });
                    var Ar = {
                        get paint () {
                            return kr = kr || new le({
                                "fill-antialias": new Da(ce.paint_fill["fill-antialias"]),
                                "fill-opacity": new eo(ce.paint_fill["fill-opacity"]),
                                "fill-color": new eo(ce.paint_fill["fill-color"]),
                                "fill-outline-color": new eo(ce.paint_fill["fill-outline-color"]),
                                "fill-translate": new Da(ce.paint_fill["fill-translate"]),
                                "fill-translate-anchor": new Da(ce.paint_fill["fill-translate-anchor"]),
                                "fill-pattern": new Jc(ce.paint_fill["fill-pattern"])
                            });
                        },
                        get layout () {
                            return pr = pr || new le({
                                "fill-sort-key": new eo(ce.layout_fill["fill-sort-key"])
                            });
                        }
                    };
                    class gr extends B {
                        constructor(S){
                            super(S, Ar);
                        }
                        recalculate(S, D) {
                            super.recalculate(S, D);
                            let j = this.paint._values["fill-outline-color"];
                            j.value.kind === "constant" && j.value.value === void 0 && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                        }
                        createBucket(S) {
                            return new dr(S);
                        }
                        queryRadius() {
                            return to(this.paint.get("fill-translate"));
                        }
                        queryIntersectsFeature(S, D, j, te, ue, ve, De) {
                            return Er(Rn(S, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), ve.angle, De), te);
                        }
                        isTileClipped() {
                            return !0;
                        }
                    }
                    let Cr = qe([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_normal_ed",
                            components: 4,
                            type: "Int16"
                        }
                    ], 4), cr = qe([
                        {
                            name: "a_centroid",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), { members: Gr } = Cr;
                    var ei = {}, yi = s, tn = Ri;
                    function Ri(R, S, D, j, te) {
                        this.properties = {}, this.extent = D, this.type = 0, this._pbf = R, this._geometry = -1, this._keys = j, this._values = te, R.readFields(ln, this, S);
                    }
                    function ln(R, S, D) {
                        R == 1 ? S.id = D.readVarint() : R == 2 ? function(j, te) {
                            for(var ue = j.readVarint() + j.pos; j.pos < ue;){
                                var ve = te._keys[j.readVarint()], De = te._values[j.readVarint()];
                                te.properties[ve] = De;
                            }
                        }(D, S) : R == 3 ? S.type = D.readVarint() : R == 4 && (S._geometry = D.pos);
                    }
                    function Qn(R) {
                        for(var S, D, j = 0, te = 0, ue = R.length, ve = ue - 1; te < ue; ve = te++)j += ((D = R[ve]).x - (S = R[te]).x) * (S.y + D.y);
                        return j;
                    }
                    Ri.types = [
                        "Unknown",
                        "Point",
                        "LineString",
                        "Polygon"
                    ], Ri.prototype.loadGeometry = function() {
                        var R = this._pbf;
                        R.pos = this._geometry;
                        for(var S, D = R.readVarint() + R.pos, j = 1, te = 0, ue = 0, ve = 0, De = []; R.pos < D;){
                            if (te <= 0) {
                                var Ze = R.readVarint();
                                j = 7 & Ze, te = Ze >> 3;
                            }
                            if (te--, j === 1 || j === 2) ue += R.readSVarint(), ve += R.readSVarint(), j === 1 && (S && De.push(S), S = []), S.push(new yi(ue, ve));
                            else {
                                if (j !== 7) throw new Error("unknown command " + j);
                                S && S.push(S[0].clone());
                            }
                        }
                        return S && De.push(S), De;
                    }, Ri.prototype.bbox = function() {
                        var R = this._pbf;
                        R.pos = this._geometry;
                        for(var S = R.readVarint() + R.pos, D = 1, j = 0, te = 0, ue = 0, ve = 1 / 0, De = -1 / 0, Ze = 1 / 0, at = -1 / 0; R.pos < S;){
                            if (j <= 0) {
                                var Tt = R.readVarint();
                                D = 7 & Tt, j = Tt >> 3;
                            }
                            if (j--, D === 1 || D === 2) (te += R.readSVarint()) < ve && (ve = te), te > De && (De = te), (ue += R.readSVarint()) < Ze && (Ze = ue), ue > at && (at = ue);
                            else if (D !== 7) throw new Error("unknown command " + D);
                        }
                        return [
                            ve,
                            Ze,
                            De,
                            at
                        ];
                    }, Ri.prototype.toGeoJSON = function(R, S, D) {
                        var j, te, ue = this.extent * Math.pow(2, D), ve = this.extent * R, De = this.extent * S, Ze = this.loadGeometry(), at = Ri.types[this.type];
                        function Tt(sr) {
                            for(var Tr = 0; Tr < sr.length; Tr++){
                                var Pr = sr[Tr];
                                sr[Tr] = [
                                    360 * (Pr.x + ve) / ue - 180,
                                    360 / Math.PI * Math.atan(Math.exp((180 - 360 * (Pr.y + De) / ue) * Math.PI / 180)) - 90
                                ];
                            }
                        }
                        switch(this.type){
                            case 1:
                                var Ft = [];
                                for(j = 0; j < Ze.length; j++)Ft[j] = Ze[j][0];
                                Tt(Ze = Ft);
                                break;
                            case 2:
                                for(j = 0; j < Ze.length; j++)Tt(Ze[j]);
                                break;
                            case 3:
                                for(Ze = function(sr) {
                                    var Tr = sr.length;
                                    if (Tr <= 1) return [
                                        sr
                                    ];
                                    for(var Pr, $r, ni = [], Di = 0; Di < Tr; Di++){
                                        var pi = Qn(sr[Di]);
                                        pi !== 0 && ($r === void 0 && ($r = pi < 0), $r === pi < 0 ? (Pr && ni.push(Pr), Pr = [
                                            sr[Di]
                                        ]) : Pr.push(sr[Di]));
                                    }
                                    return Pr && ni.push(Pr), ni;
                                }(Ze), j = 0; j < Ze.length; j++)for(te = 0; te < Ze[j].length; te++)Tt(Ze[j][te]);
                        }
                        Ze.length === 1 ? Ze = Ze[0] : at = "Multi" + at;
                        var Qt = {
                            type: "Feature",
                            geometry: {
                                type: at,
                                coordinates: Ze
                            },
                            properties: this.properties
                        };
                        return "id" in this && (Qt.id = this.id), Qt;
                    };
                    var qn = tn, rn = bn;
                    function bn(R, S) {
                        this.version = 1, this.name = null, this.extent = 4096, this.length = 0, this._pbf = R, this._keys = [], this._values = [], this._features = [], R.readFields(mn, this, S), this.length = this._features.length;
                    }
                    function mn(R, S, D) {
                        R === 15 ? S.version = D.readVarint() : R === 1 ? S.name = D.readString() : R === 5 ? S.extent = D.readVarint() : R === 2 ? S._features.push(D.pos) : R === 3 ? S._keys.push(D.readString()) : R === 4 && S._values.push(function(j) {
                            for(var te = null, ue = j.readVarint() + j.pos; j.pos < ue;){
                                var ve = j.readVarint() >> 3;
                                te = ve === 1 ? j.readString() : ve === 2 ? j.readFloat() : ve === 3 ? j.readDouble() : ve === 4 ? j.readVarint64() : ve === 5 ? j.readVarint() : ve === 6 ? j.readSVarint() : ve === 7 ? j.readBoolean() : null;
                            }
                            return te;
                        }(D));
                    }
                    bn.prototype.feature = function(R) {
                        if (R < 0 || R >= this._features.length) throw new Error("feature index out of bounds");
                        this._pbf.pos = this._features[R];
                        var S = this._pbf.readVarint() + this._pbf.pos;
                        return new qn(this._pbf, S, this.extent, this._keys, this._values);
                    };
                    var Gn = rn;
                    function da(R, S, D) {
                        if (R === 3) {
                            var j = new Gn(D, D.readVarint() + D.pos);
                            j.length && (S[j.name] = j);
                        }
                    }
                    ei.VectorTile = function(R, S) {
                        this.layers = R.readFields(da, {}, S);
                    }, ei.VectorTileFeature = tn, ei.VectorTileLayer = rn;
                    let No = ei.VectorTileFeature.types, Do = Math.pow(2, 13);
                    function ps(R, S, D, j, te, ue, ve, De) {
                        R.emplaceBack(S, D, 2 * Math.floor(j * Do) + ve, te * Do * 2, ue * Do * 2, Math.round(De));
                    }
                    class fo {
                        constructor(S){
                            this.zoom = S.zoom, this.overscaling = S.overscaling, this.layers = S.layers, this.layerIds = this.layers.map((D)=>D.id), this.index = S.index, this.hasPattern = !1, this.layoutVertexArray = new Hl, this.centroidVertexArray = new yo, this.indexArray = new oe, this.programConfigurations = new _s(S.layers, S.zoom), this.segments = new We, this.stateDependentLayerIds = this.layers.filter((D)=>D.isStateDependent()).map((D)=>D.id);
                        }
                        populate(S, D, j) {
                            this.features = [], this.hasPattern = Wt("fill-extrusion", this.layers, D);
                            for (let { feature: te, id: ue, index: ve, sourceLayerIndex: De } of S){
                                let Ze = this.layers[0]._featureFilter.needGeometry, at = xl(te, Ze);
                                if (!this.layers[0]._featureFilter.filter(new Ko(this.zoom), at, j)) continue;
                                let Tt = {
                                    id: ue,
                                    sourceLayerIndex: De,
                                    index: ve,
                                    geometry: Ze ? at.geometry : js(te),
                                    properties: te.properties,
                                    type: te.type,
                                    patterns: {}
                                };
                                this.hasPattern ? this.features.push(rr("fill-extrusion", this.layers, Tt, this.zoom, D)) : this.addFeature(Tt, Tt.geometry, ve, j, {}), D.featureIndex.insert(te, Tt.geometry, ve, De, this.index, !0);
                            }
                        }
                        addFeatures(S, D, j) {
                            for (let te of this.features){
                                let { geometry: ue } = te;
                                this.addFeature(te, ue, te.index, D, j);
                            }
                        }
                        update(S, D, j) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(S, D, this.stateDependentLayers, j);
                        }
                        isEmpty() {
                            return this.layoutVertexArray.length === 0 && this.centroidVertexArray.length === 0;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(S) {
                            this.uploaded || (this.layoutVertexBuffer = S.createVertexBuffer(this.layoutVertexArray, Gr), this.centroidVertexBuffer = S.createVertexBuffer(this.centroidVertexArray, cr.members, !0), this.indexBuffer = S.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(S), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
                        }
                        addFeature(S, D, j, te, ue) {
                            for (let ve of Of(D, 500)){
                                let De = {
                                    x: 0,
                                    y: 0,
                                    vertexCount: 0
                                }, Ze = 0;
                                for (let Tr of ve)Ze += Tr.length;
                                let at = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray);
                                for (let Tr of ve){
                                    if (Tr.length === 0 || tl(Tr)) continue;
                                    let Pr = 0;
                                    for(let $r = 0; $r < Tr.length; $r++){
                                        let ni = Tr[$r];
                                        if ($r >= 1) {
                                            let Di = Tr[$r - 1];
                                            if (!as(ni, Di)) {
                                                at.vertexLength + 4 > We.MAX_VERTEX_ARRAY_LENGTH && (at = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                                let pi = ni.sub(Di)._perp()._unit(), ki = Di.dist(ni);
                                                Pr + ki > 32768 && (Pr = 0), ps(this.layoutVertexArray, ni.x, ni.y, pi.x, pi.y, 0, 0, Pr), ps(this.layoutVertexArray, ni.x, ni.y, pi.x, pi.y, 0, 1, Pr), De.x += 2 * ni.x, De.y += 2 * ni.y, De.vertexCount += 2, Pr += ki, ps(this.layoutVertexArray, Di.x, Di.y, pi.x, pi.y, 0, 0, Pr), ps(this.layoutVertexArray, Di.x, Di.y, pi.x, pi.y, 0, 1, Pr), De.x += 2 * Di.x, De.y += 2 * Di.y, De.vertexCount += 2;
                                                let Zi = at.vertexLength;
                                                this.indexArray.emplaceBack(Zi, Zi + 2, Zi + 1), this.indexArray.emplaceBack(Zi + 1, Zi + 2, Zi + 3), at.vertexLength += 4, at.primitiveLength += 2;
                                            }
                                        }
                                    }
                                }
                                if (at.vertexLength + Ze > We.MAX_VERTEX_ARRAY_LENGTH && (at = this.segments.prepareSegment(Ze, this.layoutVertexArray, this.indexArray)), No[S.type] !== "Polygon") continue;
                                let Tt = [], Ft = [], Qt = at.vertexLength;
                                for (let Tr of ve)if (Tr.length !== 0) {
                                    Tr !== ve[0] && Ft.push(Tt.length / 2);
                                    for(let Pr = 0; Pr < Tr.length; Pr++){
                                        let $r = Tr[Pr];
                                        ps(this.layoutVertexArray, $r.x, $r.y, 0, 0, 1, 1, 0), De.x += $r.x, De.y += $r.y, De.vertexCount += 1, Tt.push($r.x), Tt.push($r.y);
                                    }
                                }
                                let sr = El(Tt, Ft);
                                for(let Tr = 0; Tr < sr.length; Tr += 3)this.indexArray.emplaceBack(Qt + sr[Tr], Qt + sr[Tr + 2], Qt + sr[Tr + 1]);
                                at.primitiveLength += sr.length / 3, at.vertexLength += Ze;
                                for(let Tr = 0; Tr < De.vertexCount; Tr++){
                                    let Pr = Math.floor(De.x / De.vertexCount), $r = Math.floor(De.y / De.vertexCount);
                                    this.centroidVertexArray.emplaceBack(Pr, $r);
                                }
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, S, j, ue, te);
                        }
                    }
                    function as(R, S) {
                        return R.x === S.x && (R.x < 0 || R.x > za) || R.y === S.y && (R.y < 0 || R.y > za);
                    }
                    function tl(R) {
                        return R.every((S)=>S.x < 0) || R.every((S)=>S.x > za) || R.every((S)=>S.y < 0) || R.every((S)=>S.y > za);
                    }
                    let zu;
                    mi("FillExtrusionBucket", fo, {
                        omit: [
                            "layers",
                            "features"
                        ]
                    });
                    var Mv = {
                        get paint () {
                            return zu = zu || new le({
                                "fill-extrusion-opacity": new Da(ce["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                                "fill-extrusion-color": new eo(ce["paint_fill-extrusion"]["fill-extrusion-color"]),
                                "fill-extrusion-translate": new Da(ce["paint_fill-extrusion"]["fill-extrusion-translate"]),
                                "fill-extrusion-translate-anchor": new Da(ce["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                                "fill-extrusion-pattern": new Jc(ce["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                                "fill-extrusion-height": new eo(ce["paint_fill-extrusion"]["fill-extrusion-height"]),
                                "fill-extrusion-base": new eo(ce["paint_fill-extrusion"]["fill-extrusion-base"]),
                                "fill-extrusion-vertical-gradient": new Da(ce["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                            });
                        }
                    };
                    class Ev extends B {
                        constructor(S){
                            super(S, Mv);
                        }
                        createBucket(S) {
                            return new fo(S);
                        }
                        queryRadius() {
                            return to(this.paint.get("fill-extrusion-translate"));
                        }
                        is3D() {
                            return !0;
                        }
                        queryIntersectsFeature(S, D, j, te, ue, ve, De, Ze) {
                            let at = Rn(S, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), ve.angle, De), Tt = this.paint.get("fill-extrusion-height").evaluate(D, j), Ft = this.paint.get("fill-extrusion-base").evaluate(D, j), Qt = function(Tr, Pr, $r, ni) {
                                let Di = [];
                                for (let pi of Tr){
                                    let ki = [
                                        pi.x,
                                        pi.y,
                                        0,
                                        1
                                    ];
                                    Za(ki, ki, Pr), Di.push(new u(ki[0] / ki[3], ki[1] / ki[3]));
                                }
                                return Di;
                            }(at, Ze), sr = function(Tr, Pr, $r, ni) {
                                let Di = [], pi = [], ki = ni[8] * Pr, Zi = ni[9] * Pr, ta = ni[10] * Pr, Va = ni[11] * Pr, Io = ni[8] * $r, La = ni[9] * $r, Hn = ni[10] * $r, lo = ni[11] * $r;
                                for (let $a of Tr){
                                    let Xa = [], Tn = [];
                                    for (let bo of $a){
                                        let Ya = bo.x, Uo = bo.y, wu = ni[0] * Ya + ni[4] * Uo + ni[12], hu = ni[1] * Ya + ni[5] * Uo + ni[13], uh = ni[2] * Ya + ni[6] * Uo + ni[14], $v = ni[3] * Ya + ni[7] * Uo + ni[15], td = uh + ta, ch = $v + Va, Ud = wu + Io, Vd = hu + La, Hd = uh + Hn, rf = $v + lo, fh = new u((wu + ki) / ch, (hu + Zi) / ch);
                                        fh.z = td / ch, Xa.push(fh);
                                        let Td = new u(Ud / rf, Vd / rf);
                                        Td.z = Hd / rf, Tn.push(Td);
                                    }
                                    Di.push(Xa), pi.push(Tn);
                                }
                                return [
                                    Di,
                                    pi
                                ];
                            }(te, Ft, Tt, Ze);
                            return function(Tr, Pr, $r) {
                                let ni = 1 / 0;
                                Er($r, Pr) && (ni = Yv($r, Pr[0]));
                                for(let Di = 0; Di < Pr.length; Di++){
                                    let pi = Pr[Di], ki = Tr[Di];
                                    for(let Zi = 0; Zi < pi.length - 1; Zi++){
                                        let ta = pi[Zi], Va = [
                                            ta,
                                            pi[Zi + 1],
                                            ki[Zi + 1],
                                            ki[Zi],
                                            ta
                                        ];
                                        xc($r, Va) && (ni = Math.min(ni, Yv($r, Va)));
                                    }
                                }
                                return ni !== 1 / 0 && ni;
                            }(sr[0], sr[1], Qt);
                        }
                    }
                    function yd(R, S) {
                        return R.x * S.x + R.y * S.y;
                    }
                    function Yv(R, S) {
                        if (R.length === 1) {
                            let D = 0, j = S[D++], te;
                            for(; !te || j.equals(te);)if (te = S[D++], !te) return 1 / 0;
                            for(; D < S.length; D++){
                                let ue = S[D], ve = R[0], De = te.sub(j), Ze = ue.sub(j), at = ve.sub(j), Tt = yd(De, De), Ft = yd(De, Ze), Qt = yd(Ze, Ze), sr = yd(at, De), Tr = yd(at, Ze), Pr = Tt * Qt - Ft * Ft, $r = (Qt * sr - Ft * Tr) / Pr, ni = (Tt * Tr - Ft * sr) / Pr, Di = j.z * (1 - $r - ni) + te.z * $r + ue.z * ni;
                                if (isFinite(Di)) return Di;
                            }
                            return 1 / 0;
                        }
                        {
                            let D = 1 / 0;
                            for (let j of S)D = Math.min(D, j.z);
                            return D;
                        }
                    }
                    let cg = qe([
                        {
                            name: "a_pos_normal",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_data",
                            components: 4,
                            type: "Uint8"
                        }
                    ], 4), { members: vp } = cg, _d = qe([
                        {
                            name: "a_uv_x",
                            components: 1,
                            type: "Float32"
                        },
                        {
                            name: "a_split_index",
                            components: 1,
                            type: "Float32"
                        }
                    ]), { members: pp } = _d, Nd = ei.VectorTileFeature.types, xd = Math.cos(Math.PI / 180 * 37.5), kv = Math.pow(2, 14) / .5;
                    class Kv {
                        constructor(S){
                            this.zoom = S.zoom, this.overscaling = S.overscaling, this.layers = S.layers, this.layerIds = this.layers.map((D)=>D.id), this.index = S.index, this.hasPattern = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((D)=>{
                                this.gradients[D.id] = {};
                            }), this.layoutVertexArray = new Zu, this.layoutVertexArray2 = new cu, this.indexArray = new oe, this.programConfigurations = new _s(S.layers, S.zoom), this.segments = new We, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((D)=>D.isStateDependent()).map((D)=>D.id);
                        }
                        populate(S, D, j) {
                            this.hasPattern = Wt("line", this.layers, D);
                            let te = this.layers[0].layout.get("line-sort-key"), ue = !te.isConstant(), ve = [];
                            for (let { feature: De, id: Ze, index: at, sourceLayerIndex: Tt } of S){
                                let Ft = this.layers[0]._featureFilter.needGeometry, Qt = xl(De, Ft);
                                if (!this.layers[0]._featureFilter.filter(new Ko(this.zoom), Qt, j)) continue;
                                let sr = ue ? te.evaluate(Qt, {}, j) : void 0, Tr = {
                                    id: Ze,
                                    properties: De.properties,
                                    type: De.type,
                                    sourceLayerIndex: Tt,
                                    index: at,
                                    geometry: Ft ? Qt.geometry : js(De),
                                    patterns: {},
                                    sortKey: sr
                                };
                                ve.push(Tr);
                            }
                            ue && ve.sort((De, Ze)=>De.sortKey - Ze.sortKey);
                            for (let De of ve){
                                let { geometry: Ze, index: at, sourceLayerIndex: Tt } = De;
                                if (this.hasPattern) {
                                    let Ft = rr("line", this.layers, De, this.zoom, D);
                                    this.patternFeatures.push(Ft);
                                } else this.addFeature(De, Ze, at, j, {});
                                D.featureIndex.insert(S[at].feature, Ze, at, Tt, this.index);
                            }
                        }
                        update(S, D, j) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(S, D, this.stateDependentLayers, j);
                        }
                        addFeatures(S, D, j) {
                            for (let te of this.patternFeatures)this.addFeature(te, te.geometry, te.index, D, j);
                        }
                        isEmpty() {
                            return this.layoutVertexArray.length === 0;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(S) {
                            this.uploaded || (this.layoutVertexArray2.length !== 0 && (this.layoutVertexBuffer2 = S.createVertexBuffer(this.layoutVertexArray2, pp)), this.layoutVertexBuffer = S.createVertexBuffer(this.layoutVertexArray, vp), this.indexBuffer = S.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(S), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }
                        lineFeatureClips(S) {
                            if (S.properties && Object.prototype.hasOwnProperty.call(S.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(S.properties, "mapbox_clip_end")) return {
                                start: +S.properties.mapbox_clip_start,
                                end: +S.properties.mapbox_clip_end
                            };
                        }
                        addFeature(S, D, j, te, ue) {
                            let ve = this.layers[0].layout, De = ve.get("line-join").evaluate(S, {}), Ze = ve.get("line-cap"), at = ve.get("line-miter-limit"), Tt = ve.get("line-round-limit");
                            this.lineClips = this.lineFeatureClips(S);
                            for (let Ft of D)this.addLine(Ft, S, De, Ze, at, Tt);
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, S, j, ue, te);
                        }
                        addLine(S, D, j, te, ue, ve) {
                            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.lineClips) {
                                this.lineClipsArray.push(this.lineClips);
                                for(let ni = 0; ni < S.length - 1; ni++)this.totalDistance += S[ni].dist(S[ni + 1]);
                                this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                            }
                            let De = Nd[D.type] === "Polygon", Ze = S.length;
                            for(; Ze >= 2 && S[Ze - 1].equals(S[Ze - 2]);)Ze--;
                            let at = 0;
                            for(; at < Ze - 1 && S[at].equals(S[at + 1]);)at++;
                            if (Ze < (De ? 3 : 2)) return;
                            j === "bevel" && (ue = 1.05);
                            let Tt = this.overscaling <= 16 ? 15 * za / (512 * this.overscaling) : 0, Ft = this.segments.prepareSegment(10 * Ze, this.layoutVertexArray, this.indexArray), Qt, sr, Tr, Pr, $r;
                            this.e1 = this.e2 = -1, De && (Qt = S[Ze - 2], $r = S[at].sub(Qt)._unit()._perp());
                            for(let ni = at; ni < Ze; ni++){
                                if (Tr = ni === Ze - 1 ? De ? S[at + 1] : void 0 : S[ni + 1], Tr && S[ni].equals(Tr)) continue;
                                $r && (Pr = $r), Qt && (sr = Qt), Qt = S[ni], $r = Tr ? Tr.sub(Qt)._unit()._perp() : Pr, Pr = Pr || $r;
                                let Di = Pr.add($r);
                                Di.x === 0 && Di.y === 0 || Di._unit();
                                let pi = Pr.x * $r.x + Pr.y * $r.y, ki = Di.x * $r.x + Di.y * $r.y, Zi = ki !== 0 ? 1 / ki : 1 / 0, ta = 2 * Math.sqrt(2 - 2 * ki), Va = ki < xd && sr && Tr, Io = Pr.x * $r.y - Pr.y * $r.x > 0;
                                if (Va && ni > at) {
                                    let lo = Qt.dist(sr);
                                    if (lo > 2 * Tt) {
                                        let $a = Qt.sub(Qt.sub(sr)._mult(Tt / lo)._round());
                                        this.updateDistance(sr, $a), this.addCurrentVertex($a, Pr, 0, 0, Ft), sr = $a;
                                    }
                                }
                                let La = sr && Tr, Hn = La ? j : De ? "butt" : te;
                                if (La && Hn === "round" && (Zi < ve ? Hn = "miter" : Zi <= 2 && (Hn = "fakeround")), Hn === "miter" && Zi > ue && (Hn = "bevel"), Hn === "bevel" && (Zi > 2 && (Hn = "flipbevel"), Zi < ue && (Hn = "miter")), sr && this.updateDistance(sr, Qt), Hn === "miter") Di._mult(Zi), this.addCurrentVertex(Qt, Di, 0, 0, Ft);
                                else if (Hn === "flipbevel") {
                                    if (Zi > 100) Di = $r.mult(-1);
                                    else {
                                        let lo = Zi * Pr.add($r).mag() / Pr.sub($r).mag();
                                        Di._perp()._mult(lo * (Io ? -1 : 1));
                                    }
                                    this.addCurrentVertex(Qt, Di, 0, 0, Ft), this.addCurrentVertex(Qt, Di.mult(-1), 0, 0, Ft);
                                } else if (Hn === "bevel" || Hn === "fakeround") {
                                    let lo = -Math.sqrt(Zi * Zi - 1), $a = Io ? lo : 0, Xa = Io ? 0 : lo;
                                    if (sr && this.addCurrentVertex(Qt, Pr, $a, Xa, Ft), Hn === "fakeround") {
                                        let Tn = Math.round(180 * ta / Math.PI / 20);
                                        for(let bo = 1; bo < Tn; bo++){
                                            let Ya = bo / Tn;
                                            if (Ya !== .5) {
                                                let wu = Ya - .5;
                                                Ya += Ya * wu * (Ya - 1) * ((1.0904 + pi * (pi * (3.55645 - 1.43519 * pi) - 3.2452)) * wu * wu + (.848013 + pi * (.215638 * pi - 1.06021)));
                                            }
                                            let Uo = $r.sub(Pr)._mult(Ya)._add(Pr)._unit()._mult(Io ? -1 : 1);
                                            this.addHalfVertex(Qt, Uo.x, Uo.y, !1, Io, 0, Ft);
                                        }
                                    }
                                    Tr && this.addCurrentVertex(Qt, $r, -$a, -Xa, Ft);
                                } else if (Hn === "butt") this.addCurrentVertex(Qt, Di, 0, 0, Ft);
                                else if (Hn === "square") {
                                    let lo = sr ? 1 : -1;
                                    this.addCurrentVertex(Qt, Di, lo, lo, Ft);
                                } else Hn === "round" && (sr && (this.addCurrentVertex(Qt, Pr, 0, 0, Ft), this.addCurrentVertex(Qt, Pr, 1, 1, Ft, !0)), Tr && (this.addCurrentVertex(Qt, $r, -1, -1, Ft, !0), this.addCurrentVertex(Qt, $r, 0, 0, Ft)));
                                if (Va && ni < Ze - 1) {
                                    let lo = Qt.dist(Tr);
                                    if (lo > 2 * Tt) {
                                        let $a = Qt.add(Tr.sub(Qt)._mult(Tt / lo)._round());
                                        this.updateDistance(Qt, $a), this.addCurrentVertex($a, $r, 0, 0, Ft), Qt = $a;
                                    }
                                }
                            }
                        }
                        addCurrentVertex(S, D, j, te, ue, ve = !1) {
                            let De = D.y * te - D.x, Ze = -D.y - D.x * te;
                            this.addHalfVertex(S, D.x + D.y * j, D.y - D.x * j, ve, !1, j, ue), this.addHalfVertex(S, De, Ze, ve, !0, -te, ue), this.distance > kv / 2 && this.totalDistance === 0 && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(S, D, j, te, ue, ve));
                        }
                        addHalfVertex({ x: S, y: D }, j, te, ue, ve, De, Ze) {
                            let at = .5 * (this.lineClips ? this.scaledDistance * (kv - 1) : this.scaledDistance);
                            this.layoutVertexArray.emplaceBack((S << 1) + (ue ? 1 : 0), (D << 1) + (ve ? 1 : 0), Math.round(63 * j) + 128, Math.round(63 * te) + 128, 1 + (De === 0 ? 0 : De < 0 ? -1 : 1) | (63 & at) << 2, at >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                            let Tt = Ze.vertexLength++;
                            this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, Tt), Ze.primitiveLength++), ve ? this.e2 = Tt : this.e1 = Tt;
                        }
                        updateScaledDistance() {
                            this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
                        }
                        updateDistance(S, D) {
                            this.distance += S.dist(D), this.updateScaledDistance();
                        }
                    }
                    let Cv, ny;
                    mi("LineBucket", Kv, {
                        omit: [
                            "layers",
                            "patternFeatures"
                        ]
                    });
                    var fg = {
                        get paint () {
                            return ny = ny || new le({
                                "line-opacity": new eo(ce.paint_line["line-opacity"]),
                                "line-color": new eo(ce.paint_line["line-color"]),
                                "line-translate": new Da(ce.paint_line["line-translate"]),
                                "line-translate-anchor": new Da(ce.paint_line["line-translate-anchor"]),
                                "line-width": new eo(ce.paint_line["line-width"]),
                                "line-gap-width": new eo(ce.paint_line["line-gap-width"]),
                                "line-offset": new eo(ce.paint_line["line-offset"]),
                                "line-blur": new eo(ce.paint_line["line-blur"]),
                                "line-dasharray": new yc(ce.paint_line["line-dasharray"]),
                                "line-pattern": new Jc(ce.paint_line["line-pattern"]),
                                "line-gradient": new _c(ce.paint_line["line-gradient"])
                            });
                        },
                        get layout () {
                            return Cv = Cv || new le({
                                "line-cap": new Da(ce.layout_line["line-cap"]),
                                "line-join": new eo(ce.layout_line["line-join"]),
                                "line-miter-limit": new Da(ce.layout_line["line-miter-limit"]),
                                "line-round-limit": new Da(ce.layout_line["line-round-limit"]),
                                "line-sort-key": new eo(ce.layout_line["line-sort-key"])
                            });
                        }
                    };
                    class Hf extends eo {
                        possiblyEvaluate(S, D) {
                            return D = new Ko(Math.floor(D.zoom), {
                                now: D.now,
                                fadeDuration: D.fadeDuration,
                                zoomHistory: D.zoomHistory,
                                transition: D.transition
                            }), super.possiblyEvaluate(S, D);
                        }
                        evaluate(S, D, j, te) {
                            return D = L({}, D, {
                                zoom: Math.floor(D.zoom)
                            }), super.evaluate(S, D, j, te);
                        }
                    }
                    let hg;
                    class ay extends B {
                        constructor(S){
                            super(S, fg), this.gradientVersion = 0, hg || (hg = new Hf(fg.paint.properties["line-width"].specification), hg.useIntegerZoom = !0);
                        }
                        _handleSpecialPaintPropertyUpdate(S) {
                            if (S === "line-gradient") {
                                let D = this.gradientExpression();
                                this.stepInterpolant = !!function(j) {
                                    return j._styleExpression !== void 0;
                                }(D) && D._styleExpression.expression instanceof Ji, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                            }
                        }
                        gradientExpression() {
                            return this._transitionablePaint._values["line-gradient"].value.expression;
                        }
                        recalculate(S, D) {
                            super.recalculate(S, D), this.paint._values["line-floorwidth"] = hg.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, S);
                        }
                        createBucket(S) {
                            return new Kv(S);
                        }
                        queryRadius(S) {
                            let D = S, j = Rh(yn("line-width", this, D), yn("line-gap-width", this, D)), te = yn("line-offset", this, D);
                            return j / 2 + Math.abs(te) + to(this.paint.get("line-translate"));
                        }
                        queryIntersectsFeature(S, D, j, te, ue, ve, De) {
                            let Ze = Rn(S, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), ve.angle, De), at = De / 2 * Rh(this.paint.get("line-width").evaluate(D, j), this.paint.get("line-gap-width").evaluate(D, j)), Tt = this.paint.get("line-offset").evaluate(D, j);
                            return Tt && (te = function(Ft, Qt) {
                                let sr = [];
                                for(let Tr = 0; Tr < Ft.length; Tr++){
                                    let Pr = Ft[Tr], $r = [];
                                    for(let ni = 0; ni < Pr.length; ni++){
                                        let Di = Pr[ni - 1], pi = Pr[ni], ki = Pr[ni + 1], Zi = ni === 0 ? new u(0, 0) : pi.sub(Di)._unit()._perp(), ta = ni === Pr.length - 1 ? new u(0, 0) : ki.sub(pi)._unit()._perp(), Va = Zi._add(ta)._unit(), Io = Va.x * ta.x + Va.y * ta.y;
                                        Io !== 0 && Va._mult(1 / Io), $r.push(Va._mult(Qt)._add(pi));
                                    }
                                    sr.push($r);
                                }
                                return sr;
                            }(te, Tt * De)), function(Ft, Qt, sr) {
                                for(let Tr = 0; Tr < Qt.length; Tr++){
                                    let Pr = Qt[Tr];
                                    if (Ft.length >= 3) {
                                        for(let $r = 0; $r < Pr.length; $r++)if (On(Ft, Pr[$r])) return !0;
                                    }
                                    if (Wr(Ft, Pr, sr)) return !0;
                                }
                                return !1;
                            }(Ze, te, at);
                        }
                        isTileClipped() {
                            return !0;
                        }
                    }
                    function Rh(R, S) {
                        return S > 0 ? S + 2 * R : R;
                    }
                    let rm = qe([
                        {
                            name: "a_pos_offset",
                            components: 4,
                            type: "Int16"
                        },
                        {
                            name: "a_data",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixeloffset",
                            components: 4,
                            type: "Int16"
                        }
                    ], 4), w1 = qe([
                        {
                            name: "a_projected_pos",
                            components: 3,
                            type: "Float32"
                        }
                    ], 4);
                    qe([
                        {
                            name: "a_fade_opacity",
                            components: 1,
                            type: "Uint32"
                        }
                    ], 4);
                    let T1 = qe([
                        {
                            name: "a_placed",
                            components: 2,
                            type: "Uint8"
                        },
                        {
                            name: "a_shift",
                            components: 2,
                            type: "Float32"
                        },
                        {
                            name: "a_box_real",
                            components: 2,
                            type: "Int16"
                        }
                    ]);
                    qe([
                        {
                            type: "Int16",
                            name: "anchorPointX"
                        },
                        {
                            type: "Int16",
                            name: "anchorPointY"
                        },
                        {
                            type: "Int16",
                            name: "x1"
                        },
                        {
                            type: "Int16",
                            name: "y1"
                        },
                        {
                            type: "Int16",
                            name: "x2"
                        },
                        {
                            type: "Int16",
                            name: "y2"
                        },
                        {
                            type: "Uint32",
                            name: "featureIndex"
                        },
                        {
                            type: "Uint16",
                            name: "sourceLayerIndex"
                        },
                        {
                            type: "Uint16",
                            name: "bucketIndex"
                        }
                    ]);
                    let oy = qe([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_anchor_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_extrude",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), im = qe([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Float32"
                        },
                        {
                            name: "a_radius",
                            components: 1,
                            type: "Float32"
                        },
                        {
                            name: "a_flags",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4);
                    function nm(R, S, D) {
                        return R.sections.forEach((j)=>{
                            j.text = function(te, ue, ve) {
                                let De = ue.layout.get("text-transform").evaluate(ve, {});
                                return De === "uppercase" ? te = te.toLocaleUpperCase() : De === "lowercase" && (te = te.toLocaleLowerCase()), vs.applyArabicShaping && (te = vs.applyArabicShaping(te)), te;
                            }(j.text, S, D);
                        }), R;
                    }
                    qe([
                        {
                            name: "triangle",
                            components: 3,
                            type: "Uint16"
                        }
                    ]), qe([
                        {
                            type: "Int16",
                            name: "anchorX"
                        },
                        {
                            type: "Int16",
                            name: "anchorY"
                        },
                        {
                            type: "Uint16",
                            name: "glyphStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "numGlyphs"
                        },
                        {
                            type: "Uint32",
                            name: "vertexStartIndex"
                        },
                        {
                            type: "Uint32",
                            name: "lineStartIndex"
                        },
                        {
                            type: "Uint32",
                            name: "lineLength"
                        },
                        {
                            type: "Uint16",
                            name: "segment"
                        },
                        {
                            type: "Uint16",
                            name: "lowerSize"
                        },
                        {
                            type: "Uint16",
                            name: "upperSize"
                        },
                        {
                            type: "Float32",
                            name: "lineOffsetX"
                        },
                        {
                            type: "Float32",
                            name: "lineOffsetY"
                        },
                        {
                            type: "Uint8",
                            name: "writingMode"
                        },
                        {
                            type: "Uint8",
                            name: "placedOrientation"
                        },
                        {
                            type: "Uint8",
                            name: "hidden"
                        },
                        {
                            type: "Uint32",
                            name: "crossTileID"
                        },
                        {
                            type: "Int16",
                            name: "associatedIconIndex"
                        }
                    ]), qe([
                        {
                            type: "Int16",
                            name: "anchorX"
                        },
                        {
                            type: "Int16",
                            name: "anchorY"
                        },
                        {
                            type: "Int16",
                            name: "rightJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "centerJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "leftJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "verticalPlacedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "placedIconSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "verticalPlacedIconSymbolIndex"
                        },
                        {
                            type: "Uint16",
                            name: "key"
                        },
                        {
                            type: "Uint16",
                            name: "textBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "textBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalTextBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalTextBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "iconBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "iconBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalIconBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalIconBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "featureIndex"
                        },
                        {
                            type: "Uint16",
                            name: "numHorizontalGlyphVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numVerticalGlyphVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numIconVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numVerticalIconVertices"
                        },
                        {
                            type: "Uint16",
                            name: "useRuntimeCollisionCircles"
                        },
                        {
                            type: "Uint32",
                            name: "crossTileID"
                        },
                        {
                            type: "Float32",
                            name: "textBoxScale"
                        },
                        {
                            type: "Float32",
                            name: "collisionCircleDiameter"
                        },
                        {
                            type: "Uint16",
                            name: "textAnchorOffsetStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "textAnchorOffsetEndIndex"
                        }
                    ]), qe([
                        {
                            type: "Float32",
                            name: "offsetX"
                        }
                    ]), qe([
                        {
                            type: "Int16",
                            name: "x"
                        },
                        {
                            type: "Int16",
                            name: "y"
                        },
                        {
                            type: "Int16",
                            name: "tileUnitDistanceFromAnchor"
                        }
                    ]), qe([
                        {
                            type: "Uint16",
                            name: "textAnchor"
                        },
                        {
                            type: "Float32",
                            components: 2,
                            name: "textOffset"
                        }
                    ]);
                    let Fu = {
                        "!": "\uFE15",
                        "#": "\uFF03",
                        $: "\uFF04",
                        "%": "\uFF05",
                        "&": "\uFF06",
                        "(": "\uFE35",
                        ")": "\uFE36",
                        "*": "\uFF0A",
                        "+": "\uFF0B",
                        ",": "\uFE10",
                        "-": "\uFE32",
                        ".": "\u30FB",
                        "/": "\uFF0F",
                        ":": "\uFE13",
                        ";": "\uFE14",
                        "<": "\uFE3F",
                        "=": "\uFF1D",
                        ">": "\uFE40",
                        "?": "\uFE16",
                        "@": "\uFF20",
                        "[": "\uFE47",
                        "\\": "\uFF3C",
                        "]": "\uFE48",
                        "^": "\uFF3E",
                        _: "\uFE33",
                        "`": "\uFF40",
                        "{": "\uFE37",
                        "|": "\u2015",
                        "}": "\uFE38",
                        "~": "\uFF5E",
                        "\xA2": "\uFFE0",
                        "\xA3": "\uFFE1",
                        "\xA5": "\uFFE5",
                        "\xA6": "\uFFE4",
                        "\xAC": "\uFFE2",
                        "\xAF": "\uFFE3",
                        "\u2013": "\uFE32",
                        "\u2014": "\uFE31",
                        "\u2018": "\uFE43",
                        "\u2019": "\uFE44",
                        "\u201C": "\uFE41",
                        "\u201D": "\uFE42",
                        "\u2026": "\uFE19",
                        "\u2027": "\u30FB",
                        "\u20A9": "\uFFE6",
                        "\u3001": "\uFE11",
                        "\u3002": "\uFE12",
                        "\u3008": "\uFE3F",
                        "\u3009": "\uFE40",
                        "\u300A": "\uFE3D",
                        "\u300B": "\uFE3E",
                        "\u300C": "\uFE41",
                        "\u300D": "\uFE42",
                        "\u300E": "\uFE43",
                        "\u300F": "\uFE44",
                        "\u3010": "\uFE3B",
                        "\u3011": "\uFE3C",
                        "\u3014": "\uFE39",
                        "\u3015": "\uFE3A",
                        "\u3016": "\uFE17",
                        "\u3017": "\uFE18",
                        "\uFF01": "\uFE15",
                        "\uFF08": "\uFE35",
                        "\uFF09": "\uFE36",
                        "\uFF0C": "\uFE10",
                        "\uFF0D": "\uFE32",
                        "\uFF0E": "\u30FB",
                        "\uFF1A": "\uFE13",
                        "\uFF1B": "\uFE14",
                        "\uFF1C": "\uFE3F",
                        "\uFF1E": "\uFE40",
                        "\uFF1F": "\uFE16",
                        "\uFF3B": "\uFE47",
                        "\uFF3D": "\uFE48",
                        "\uFF3F": "\uFE33",
                        "\uFF5B": "\uFE37",
                        "\uFF5C": "\u2015",
                        "\uFF5D": "\uFE38",
                        "\uFF5F": "\uFE35",
                        "\uFF60": "\uFE36",
                        "\uFF61": "\uFE12",
                        "\uFF62": "\uFE41",
                        "\uFF63": "\uFE42"
                    };
                    var kl = 24, bd = Kl, sy = function(R, S, D, j, te) {
                        var ue, ve, De = 8 * te - j - 1, Ze = (1 << De) - 1, at = Ze >> 1, Tt = -7, Ft = D ? te - 1 : 0, Qt = D ? -1 : 1, sr = R[S + Ft];
                        for(Ft += Qt, ue = sr & (1 << -Tt) - 1, sr >>= -Tt, Tt += De; Tt > 0; ue = 256 * ue + R[S + Ft], Ft += Qt, Tt -= 8);
                        for(ve = ue & (1 << -Tt) - 1, ue >>= -Tt, Tt += j; Tt > 0; ve = 256 * ve + R[S + Ft], Ft += Qt, Tt -= 8);
                        if (ue === 0) ue = 1 - at;
                        else {
                            if (ue === Ze) return ve ? NaN : 1 / 0 * (sr ? -1 : 1);
                            ve += Math.pow(2, j), ue -= at;
                        }
                        return (sr ? -1 : 1) * ve * Math.pow(2, ue - j);
                    }, A1 = function(R, S, D, j, te, ue) {
                        var ve, De, Ze, at = 8 * ue - te - 1, Tt = (1 << at) - 1, Ft = Tt >> 1, Qt = te === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, sr = j ? 0 : ue - 1, Tr = j ? 1 : -1, Pr = S < 0 || S === 0 && 1 / S < 0 ? 1 : 0;
                        for(S = Math.abs(S), isNaN(S) || S === 1 / 0 ? (De = isNaN(S) ? 1 : 0, ve = Tt) : (ve = Math.floor(Math.log(S) / Math.LN2), S * (Ze = Math.pow(2, -ve)) < 1 && (ve--, Ze *= 2), (S += ve + Ft >= 1 ? Qt / Ze : Qt * Math.pow(2, 1 - Ft)) * Ze >= 2 && (ve++, Ze /= 2), ve + Ft >= Tt ? (De = 0, ve = Tt) : ve + Ft >= 1 ? (De = (S * Ze - 1) * Math.pow(2, te), ve += Ft) : (De = S * Math.pow(2, Ft - 1) * Math.pow(2, te), ve = 0)); te >= 8; R[D + sr] = 255 & De, sr += Tr, De /= 256, te -= 8);
                        for(ve = ve << te | De, at += te; at > 0; R[D + sr] = 255 & ve, sr += Tr, ve /= 256, at -= 8);
                        R[D + sr - Tr] |= 128 * Pr;
                    };
                    function Kl(R) {
                        this.buf = ArrayBuffer.isView && ArrayBuffer.isView(R) ? R : new Uint8Array(R || 0), this.pos = 0, this.type = 0, this.length = this.buf.length;
                    }
                    Kl.Varint = 0, Kl.Fixed64 = 1, Kl.Bytes = 2, Kl.Fixed32 = 5;
                    var Nx = 4294967296, am = 1 / Nx, Mw = typeof TextDecoder == "undefined" ? null : new TextDecoder("utf-8");
                    function Lv(R) {
                        return R.type === Kl.Bytes ? R.readVarint() + R.pos : R.pos + 1;
                    }
                    function om(R, S, D) {
                        return D ? 4294967296 * S + (R >>> 0) : 4294967296 * (S >>> 0) + (R >>> 0);
                    }
                    function Ew(R, S, D) {
                        var j = S <= 16383 ? 1 : S <= 2097151 ? 2 : S <= 268435455 ? 3 : Math.floor(Math.log(S) / (7 * Math.LN2));
                        D.realloc(j);
                        for(var te = D.pos - 1; te >= R; te--)D.buf[te + j] = D.buf[te];
                    }
                    function Ux(R, S) {
                        for(var D = 0; D < R.length; D++)S.writeVarint(R[D]);
                    }
                    function P9(R, S) {
                        for(var D = 0; D < R.length; D++)S.writeSVarint(R[D]);
                    }
                    function I9(R, S) {
                        for(var D = 0; D < R.length; D++)S.writeFloat(R[D]);
                    }
                    function R9(R, S) {
                        for(var D = 0; D < R.length; D++)S.writeDouble(R[D]);
                    }
                    function D9(R, S) {
                        for(var D = 0; D < R.length; D++)S.writeBoolean(R[D]);
                    }
                    function mQ(R, S) {
                        for(var D = 0; D < R.length; D++)S.writeFixed32(R[D]);
                    }
                    function z9(R, S) {
                        for(var D = 0; D < R.length; D++)S.writeSFixed32(R[D]);
                    }
                    function F9(R, S) {
                        for(var D = 0; D < R.length; D++)S.writeFixed64(R[D]);
                    }
                    function q9(R, S) {
                        for(var D = 0; D < R.length; D++)S.writeSFixed64(R[D]);
                    }
                    function ly(R, S) {
                        return (R[S] | R[S + 1] << 8 | R[S + 2] << 16) + 16777216 * R[S + 3];
                    }
                    function Vx(R, S, D) {
                        R[D] = S, R[D + 1] = S >>> 8, R[D + 2] = S >>> 16, R[D + 3] = S >>> 24;
                    }
                    function cC(R, S) {
                        return (R[S] | R[S + 1] << 8 | R[S + 2] << 16) + (R[S + 3] << 24);
                    }
                    Kl.prototype = {
                        destroy: function() {
                            this.buf = null;
                        },
                        readFields: function(R, S, D) {
                            for(D = D || this.length; this.pos < D;){
                                var j = this.readVarint(), te = j >> 3, ue = this.pos;
                                this.type = 7 & j, R(te, S, this), this.pos === ue && this.skip(j);
                            }
                            return S;
                        },
                        readMessage: function(R, S) {
                            return this.readFields(R, S, this.readVarint() + this.pos);
                        },
                        readFixed32: function() {
                            var R = ly(this.buf, this.pos);
                            return this.pos += 4, R;
                        },
                        readSFixed32: function() {
                            var R = cC(this.buf, this.pos);
                            return this.pos += 4, R;
                        },
                        readFixed64: function() {
                            var R = ly(this.buf, this.pos) + ly(this.buf, this.pos + 4) * Nx;
                            return this.pos += 8, R;
                        },
                        readSFixed64: function() {
                            var R = ly(this.buf, this.pos) + cC(this.buf, this.pos + 4) * Nx;
                            return this.pos += 8, R;
                        },
                        readFloat: function() {
                            var R = sy(this.buf, this.pos, !0, 23, 4);
                            return this.pos += 4, R;
                        },
                        readDouble: function() {
                            var R = sy(this.buf, this.pos, !0, 52, 8);
                            return this.pos += 8, R;
                        },
                        readVarint: function(R) {
                            var S, D, j = this.buf;
                            return S = 127 & (D = j[this.pos++]), D < 128 ? S : (S |= (127 & (D = j[this.pos++])) << 7, D < 128 ? S : (S |= (127 & (D = j[this.pos++])) << 14, D < 128 ? S : (S |= (127 & (D = j[this.pos++])) << 21, D < 128 ? S : function(te, ue, ve) {
                                var De, Ze, at = ve.buf;
                                if (De = (112 & (Ze = at[ve.pos++])) >> 4, Ze < 128 || (De |= (127 & (Ze = at[ve.pos++])) << 3, Ze < 128) || (De |= (127 & (Ze = at[ve.pos++])) << 10, Ze < 128) || (De |= (127 & (Ze = at[ve.pos++])) << 17, Ze < 128) || (De |= (127 & (Ze = at[ve.pos++])) << 24, Ze < 128) || (De |= (1 & (Ze = at[ve.pos++])) << 31, Ze < 128)) return om(te, De, ue);
                                throw new Error("Expected varint not more than 10 bytes");
                            }(S |= (15 & (D = j[this.pos])) << 28, R, this))));
                        },
                        readVarint64: function() {
                            return this.readVarint(!0);
                        },
                        readSVarint: function() {
                            var R = this.readVarint();
                            return R % 2 == 1 ? (R + 1) / -2 : R / 2;
                        },
                        readBoolean: function() {
                            return !!this.readVarint();
                        },
                        readString: function() {
                            var R = this.readVarint() + this.pos, S = this.pos;
                            return this.pos = R, R - S >= 12 && Mw ? function(D, j, te) {
                                return Mw.decode(D.subarray(j, te));
                            }(this.buf, S, R) : function(D, j, te) {
                                for(var ue = "", ve = j; ve < te;){
                                    var De, Ze, at, Tt = D[ve], Ft = null, Qt = Tt > 239 ? 4 : Tt > 223 ? 3 : Tt > 191 ? 2 : 1;
                                    if (ve + Qt > te) break;
                                    Qt === 1 ? Tt < 128 && (Ft = Tt) : Qt === 2 ? (192 & (De = D[ve + 1])) == 128 && (Ft = (31 & Tt) << 6 | 63 & De) <= 127 && (Ft = null) : Qt === 3 ? (Ze = D[ve + 2], (192 & (De = D[ve + 1])) == 128 && (192 & Ze) == 128 && ((Ft = (15 & Tt) << 12 | (63 & De) << 6 | 63 & Ze) <= 2047 || Ft >= 55296 && Ft <= 57343) && (Ft = null)) : Qt === 4 && (Ze = D[ve + 2], at = D[ve + 3], (192 & (De = D[ve + 1])) == 128 && (192 & Ze) == 128 && (192 & at) == 128 && ((Ft = (15 & Tt) << 18 | (63 & De) << 12 | (63 & Ze) << 6 | 63 & at) <= 65535 || Ft >= 1114112) && (Ft = null)), Ft === null ? (Ft = 65533, Qt = 1) : Ft > 65535 && (Ft -= 65536, ue += String.fromCharCode(Ft >>> 10 & 1023 | 55296), Ft = 56320 | 1023 & Ft), ue += String.fromCharCode(Ft), ve += Qt;
                                }
                                return ue;
                            }(this.buf, S, R);
                        },
                        readBytes: function() {
                            var R = this.readVarint() + this.pos, S = this.buf.subarray(this.pos, R);
                            return this.pos = R, S;
                        },
                        readPackedVarint: function(R, S) {
                            if (this.type !== Kl.Bytes) return R.push(this.readVarint(S));
                            var D = Lv(this);
                            for(R = R || []; this.pos < D;)R.push(this.readVarint(S));
                            return R;
                        },
                        readPackedSVarint: function(R) {
                            if (this.type !== Kl.Bytes) return R.push(this.readSVarint());
                            var S = Lv(this);
                            for(R = R || []; this.pos < S;)R.push(this.readSVarint());
                            return R;
                        },
                        readPackedBoolean: function(R) {
                            if (this.type !== Kl.Bytes) return R.push(this.readBoolean());
                            var S = Lv(this);
                            for(R = R || []; this.pos < S;)R.push(this.readBoolean());
                            return R;
                        },
                        readPackedFloat: function(R) {
                            if (this.type !== Kl.Bytes) return R.push(this.readFloat());
                            var S = Lv(this);
                            for(R = R || []; this.pos < S;)R.push(this.readFloat());
                            return R;
                        },
                        readPackedDouble: function(R) {
                            if (this.type !== Kl.Bytes) return R.push(this.readDouble());
                            var S = Lv(this);
                            for(R = R || []; this.pos < S;)R.push(this.readDouble());
                            return R;
                        },
                        readPackedFixed32: function(R) {
                            if (this.type !== Kl.Bytes) return R.push(this.readFixed32());
                            var S = Lv(this);
                            for(R = R || []; this.pos < S;)R.push(this.readFixed32());
                            return R;
                        },
                        readPackedSFixed32: function(R) {
                            if (this.type !== Kl.Bytes) return R.push(this.readSFixed32());
                            var S = Lv(this);
                            for(R = R || []; this.pos < S;)R.push(this.readSFixed32());
                            return R;
                        },
                        readPackedFixed64: function(R) {
                            if (this.type !== Kl.Bytes) return R.push(this.readFixed64());
                            var S = Lv(this);
                            for(R = R || []; this.pos < S;)R.push(this.readFixed64());
                            return R;
                        },
                        readPackedSFixed64: function(R) {
                            if (this.type !== Kl.Bytes) return R.push(this.readSFixed64());
                            var S = Lv(this);
                            for(R = R || []; this.pos < S;)R.push(this.readSFixed64());
                            return R;
                        },
                        skip: function(R) {
                            var S = 7 & R;
                            if (S === Kl.Varint) for(; this.buf[this.pos++] > 127;);
                            else if (S === Kl.Bytes) this.pos = this.readVarint() + this.pos;
                            else if (S === Kl.Fixed32) this.pos += 4;
                            else {
                                if (S !== Kl.Fixed64) throw new Error("Unimplemented type: " + S);
                                this.pos += 8;
                            }
                        },
                        writeTag: function(R, S) {
                            this.writeVarint(R << 3 | S);
                        },
                        realloc: function(R) {
                            for(var S = this.length || 16; S < this.pos + R;)S *= 2;
                            if (S !== this.length) {
                                var D = new Uint8Array(S);
                                D.set(this.buf), this.buf = D, this.length = S;
                            }
                        },
                        finish: function() {
                            return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                        },
                        writeFixed32: function(R) {
                            this.realloc(4), Vx(this.buf, R, this.pos), this.pos += 4;
                        },
                        writeSFixed32: function(R) {
                            this.realloc(4), Vx(this.buf, R, this.pos), this.pos += 4;
                        },
                        writeFixed64: function(R) {
                            this.realloc(8), Vx(this.buf, -1 & R, this.pos), Vx(this.buf, Math.floor(R * am), this.pos + 4), this.pos += 8;
                        },
                        writeSFixed64: function(R) {
                            this.realloc(8), Vx(this.buf, -1 & R, this.pos), Vx(this.buf, Math.floor(R * am), this.pos + 4), this.pos += 8;
                        },
                        writeVarint: function(R) {
                            (R = +R || 0) > 268435455 || R < 0 ? function(S, D) {
                                var j, te;
                                if (S >= 0 ? (j = S % 4294967296 | 0, te = S / 4294967296 | 0) : (te = ~(-S / 4294967296), 4294967295 ^ (j = ~(-S % 4294967296)) ? j = j + 1 | 0 : (j = 0, te = te + 1 | 0)), S >= 18446744073709552e3 || S < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                                D.realloc(10), function(ue, ve, De) {
                                    De.buf[De.pos++] = 127 & ue | 128, ue >>>= 7, De.buf[De.pos++] = 127 & ue | 128, ue >>>= 7, De.buf[De.pos++] = 127 & ue | 128, ue >>>= 7, De.buf[De.pos++] = 127 & ue | 128, De.buf[De.pos] = 127 & (ue >>>= 7);
                                }(j, 0, D), function(ue, ve) {
                                    var De = (7 & ue) << 4;
                                    ve.buf[ve.pos++] |= De | ((ue >>>= 3) ? 128 : 0), ue && (ve.buf[ve.pos++] = 127 & ue | ((ue >>>= 7) ? 128 : 0), ue && (ve.buf[ve.pos++] = 127 & ue | ((ue >>>= 7) ? 128 : 0), ue && (ve.buf[ve.pos++] = 127 & ue | ((ue >>>= 7) ? 128 : 0), ue && (ve.buf[ve.pos++] = 127 & ue | ((ue >>>= 7) ? 128 : 0), ue && (ve.buf[ve.pos++] = 127 & ue)))));
                                }(te, D);
                            }(R, this) : (this.realloc(4), this.buf[this.pos++] = 127 & R | (R > 127 ? 128 : 0), R <= 127 || (this.buf[this.pos++] = 127 & (R >>>= 7) | (R > 127 ? 128 : 0), R <= 127 || (this.buf[this.pos++] = 127 & (R >>>= 7) | (R > 127 ? 128 : 0), R <= 127 || (this.buf[this.pos++] = R >>> 7 & 127))));
                        },
                        writeSVarint: function(R) {
                            this.writeVarint(R < 0 ? 2 * -R - 1 : 2 * R);
                        },
                        writeBoolean: function(R) {
                            this.writeVarint(!!R);
                        },
                        writeString: function(R) {
                            R = String(R), this.realloc(4 * R.length), this.pos++;
                            var S = this.pos;
                            this.pos = function(j, te, ue) {
                                for(var ve, De, Ze = 0; Ze < te.length; Ze++){
                                    if ((ve = te.charCodeAt(Ze)) > 55295 && ve < 57344) {
                                        if (!De) {
                                            ve > 56319 || Ze + 1 === te.length ? (j[ue++] = 239, j[ue++] = 191, j[ue++] = 189) : De = ve;
                                            continue;
                                        }
                                        if (ve < 56320) {
                                            j[ue++] = 239, j[ue++] = 191, j[ue++] = 189, De = ve;
                                            continue;
                                        }
                                        ve = De - 55296 << 10 | ve - 56320 | 65536, De = null;
                                    } else De && (j[ue++] = 239, j[ue++] = 191, j[ue++] = 189, De = null);
                                    ve < 128 ? j[ue++] = ve : (ve < 2048 ? j[ue++] = ve >> 6 | 192 : (ve < 65536 ? j[ue++] = ve >> 12 | 224 : (j[ue++] = ve >> 18 | 240, j[ue++] = ve >> 12 & 63 | 128), j[ue++] = ve >> 6 & 63 | 128), j[ue++] = 63 & ve | 128);
                                }
                                return ue;
                            }(this.buf, R, this.pos);
                            var D = this.pos - S;
                            D >= 128 && Ew(S, D, this), this.pos = S - 1, this.writeVarint(D), this.pos += D;
                        },
                        writeFloat: function(R) {
                            this.realloc(4), A1(this.buf, R, this.pos, !0, 23, 4), this.pos += 4;
                        },
                        writeDouble: function(R) {
                            this.realloc(8), A1(this.buf, R, this.pos, !0, 52, 8), this.pos += 8;
                        },
                        writeBytes: function(R) {
                            var S = R.length;
                            this.writeVarint(S), this.realloc(S);
                            for(var D = 0; D < S; D++)this.buf[this.pos++] = R[D];
                        },
                        writeRawMessage: function(R, S) {
                            this.pos++;
                            var D = this.pos;
                            R(S, this);
                            var j = this.pos - D;
                            j >= 128 && Ew(D, j, this), this.pos = D - 1, this.writeVarint(j), this.pos += j;
                        },
                        writeMessage: function(R, S, D) {
                            this.writeTag(R, Kl.Bytes), this.writeRawMessage(S, D);
                        },
                        writePackedVarint: function(R, S) {
                            S.length && this.writeMessage(R, Ux, S);
                        },
                        writePackedSVarint: function(R, S) {
                            S.length && this.writeMessage(R, P9, S);
                        },
                        writePackedBoolean: function(R, S) {
                            S.length && this.writeMessage(R, D9, S);
                        },
                        writePackedFloat: function(R, S) {
                            S.length && this.writeMessage(R, I9, S);
                        },
                        writePackedDouble: function(R, S) {
                            S.length && this.writeMessage(R, R9, S);
                        },
                        writePackedFixed32: function(R, S) {
                            S.length && this.writeMessage(R, mQ, S);
                        },
                        writePackedSFixed32: function(R, S) {
                            S.length && this.writeMessage(R, z9, S);
                        },
                        writePackedFixed64: function(R, S) {
                            S.length && this.writeMessage(R, F9, S);
                        },
                        writePackedSFixed64: function(R, S) {
                            S.length && this.writeMessage(R, q9, S);
                        },
                        writeBytesField: function(R, S) {
                            this.writeTag(R, Kl.Bytes), this.writeBytes(S);
                        },
                        writeFixed32Field: function(R, S) {
                            this.writeTag(R, Kl.Fixed32), this.writeFixed32(S);
                        },
                        writeSFixed32Field: function(R, S) {
                            this.writeTag(R, Kl.Fixed32), this.writeSFixed32(S);
                        },
                        writeFixed64Field: function(R, S) {
                            this.writeTag(R, Kl.Fixed64), this.writeFixed64(S);
                        },
                        writeSFixed64Field: function(R, S) {
                            this.writeTag(R, Kl.Fixed64), this.writeSFixed64(S);
                        },
                        writeVarintField: function(R, S) {
                            this.writeTag(R, Kl.Varint), this.writeVarint(S);
                        },
                        writeSVarintField: function(R, S) {
                            this.writeTag(R, Kl.Varint), this.writeSVarint(S);
                        },
                        writeStringField: function(R, S) {
                            this.writeTag(R, Kl.Bytes), this.writeString(S);
                        },
                        writeFloatField: function(R, S) {
                            this.writeTag(R, Kl.Fixed32), this.writeFloat(S);
                        },
                        writeDoubleField: function(R, S) {
                            this.writeTag(R, Kl.Fixed64), this.writeDouble(S);
                        },
                        writeBooleanField: function(R, S) {
                            this.writeVarintField(R, !!S);
                        }
                    };
                    var eS = o(bd);
                    let tS = 3;
                    function yQ(R, S, D) {
                        R === 1 && D.readMessage(O9, S);
                    }
                    function O9(R, S, D) {
                        if (R === 3) {
                            let { id: j, bitmap: te, width: ue, height: ve, left: De, top: Ze, advance: at } = D.readMessage(fC, {});
                            S.push({
                                id: j,
                                bitmap: new Ao({
                                    width: ue + 2 * tS,
                                    height: ve + 2 * tS
                                }, te),
                                metrics: {
                                    width: ue,
                                    height: ve,
                                    left: De,
                                    top: Ze,
                                    advance: at
                                }
                            });
                        }
                    }
                    function fC(R, S, D) {
                        R === 1 ? S.id = D.readVarint() : R === 2 ? S.bitmap = D.readBytes() : R === 3 ? S.width = D.readVarint() : R === 4 ? S.height = D.readVarint() : R === 5 ? S.left = D.readSVarint() : R === 6 ? S.top = D.readSVarint() : R === 7 && (S.advance = D.readVarint());
                    }
                    let hC = tS;
                    function rS(R) {
                        let S = 0, D = 0;
                        for (let ve of R)S += ve.w * ve.h, D = Math.max(D, ve.w);
                        R.sort((ve, De)=>De.h - ve.h);
                        let j = [
                            {
                                x: 0,
                                y: 0,
                                w: Math.max(Math.ceil(Math.sqrt(S / .95)), D),
                                h: 1 / 0
                            }
                        ], te = 0, ue = 0;
                        for (let ve of R)for(let De = j.length - 1; De >= 0; De--){
                            let Ze = j[De];
                            if (!(ve.w > Ze.w || ve.h > Ze.h)) {
                                if (ve.x = Ze.x, ve.y = Ze.y, ue = Math.max(ue, ve.y + ve.h), te = Math.max(te, ve.x + ve.w), ve.w === Ze.w && ve.h === Ze.h) {
                                    let at = j.pop();
                                    De < j.length && (j[De] = at);
                                } else ve.h === Ze.h ? (Ze.x += ve.w, Ze.w -= ve.w) : ve.w === Ze.w ? (Ze.y += ve.h, Ze.h -= ve.h) : (j.push({
                                    x: Ze.x + ve.w,
                                    y: Ze.y,
                                    w: Ze.w - ve.w,
                                    h: ve.h
                                }), Ze.y += ve.h, Ze.h -= ve.h);
                                break;
                            }
                        }
                        return {
                            w: te,
                            h: ue,
                            fill: S / (te * ue) || 0
                        };
                    }
                    let wd = 1;
                    class kw {
                        constructor(S, { pixelRatio: D, version: j, stretchX: te, stretchY: ue, content: ve, textFitWidth: De, textFitHeight: Ze }){
                            this.paddedRect = S, this.pixelRatio = D, this.stretchX = te, this.stretchY = ue, this.content = ve, this.version = j, this.textFitWidth = De, this.textFitHeight = Ze;
                        }
                        get tl() {
                            return [
                                this.paddedRect.x + wd,
                                this.paddedRect.y + wd
                            ];
                        }
                        get br() {
                            return [
                                this.paddedRect.x + this.paddedRect.w - wd,
                                this.paddedRect.y + this.paddedRect.h - wd
                            ];
                        }
                        get tlbr() {
                            return this.tl.concat(this.br);
                        }
                        get displaySize() {
                            return [
                                (this.paddedRect.w - 2 * wd) / this.pixelRatio,
                                (this.paddedRect.h - 2 * wd) / this.pixelRatio
                            ];
                        }
                    }
                    class Cw {
                        constructor(S, D){
                            let j = {}, te = {};
                            this.haveRenderCallbacks = [];
                            let ue = [];
                            this.addImages(S, j, ue), this.addImages(D, te, ue);
                            let { w: ve, h: De } = rS(ue), Ze = new Jn({
                                width: ve || 1,
                                height: De || 1
                            });
                            for(let at in S){
                                let Tt = S[at], Ft = j[at].paddedRect;
                                Jn.copy(Tt.data, Ze, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Ft.x + wd,
                                    y: Ft.y + wd
                                }, Tt.data);
                            }
                            for(let at in D){
                                let Tt = D[at], Ft = te[at].paddedRect, Qt = Ft.x + wd, sr = Ft.y + wd, Tr = Tt.data.width, Pr = Tt.data.height;
                                Jn.copy(Tt.data, Ze, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Qt,
                                    y: sr
                                }, Tt.data), Jn.copy(Tt.data, Ze, {
                                    x: 0,
                                    y: Pr - 1
                                }, {
                                    x: Qt,
                                    y: sr - 1
                                }, {
                                    width: Tr,
                                    height: 1
                                }), Jn.copy(Tt.data, Ze, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Qt,
                                    y: sr + Pr
                                }, {
                                    width: Tr,
                                    height: 1
                                }), Jn.copy(Tt.data, Ze, {
                                    x: Tr - 1,
                                    y: 0
                                }, {
                                    x: Qt - 1,
                                    y: sr
                                }, {
                                    width: 1,
                                    height: Pr
                                }), Jn.copy(Tt.data, Ze, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: Qt + Tr,
                                    y: sr
                                }, {
                                    width: 1,
                                    height: Pr
                                });
                            }
                            this.image = Ze, this.iconPositions = j, this.patternPositions = te;
                        }
                        addImages(S, D, j) {
                            for(let te in S){
                                let ue = S[te], ve = {
                                    x: 0,
                                    y: 0,
                                    w: ue.data.width + 2 * wd,
                                    h: ue.data.height + 2 * wd
                                };
                                j.push(ve), D[te] = new kw(ve, ue), ue.hasRenderCallback && this.haveRenderCallbacks.push(te);
                            }
                        }
                        patchUpdatedImages(S, D) {
                            S.dispatchRenderCallbacks(this.haveRenderCallbacks);
                            for(let j in S.updatedImages)this.patchUpdatedImage(this.iconPositions[j], S.getImage(j), D), this.patchUpdatedImage(this.patternPositions[j], S.getImage(j), D);
                        }
                        patchUpdatedImage(S, D, j) {
                            if (!S || !D || S.version === D.version) return;
                            S.version = D.version;
                            let [te, ue] = S.tl;
                            j.update(D.data, void 0, {
                                x: te,
                                y: ue
                            });
                        }
                    }
                    var Pv;
                    mi("ImagePosition", kw), mi("ImageAtlas", Cw), i.ah = void 0, (Pv = i.ah || (i.ah = {}))[Pv.none = 0] = "none", Pv[Pv.horizontal = 1] = "horizontal", Pv[Pv.vertical = 2] = "vertical", Pv[Pv.horizontalOnly = 3] = "horizontalOnly";
                    let lh = -17;
                    class Hx {
                        constructor(){
                            this.scale = 1, this.fontStack = "", this.imageName = null;
                        }
                        static forText(S, D) {
                            let j = new Hx;
                            return j.scale = S || 1, j.fontStack = D, j;
                        }
                        static forImage(S) {
                            let D = new Hx;
                            return D.imageName = S, D;
                        }
                    }
                    class S1 {
                        constructor(){
                            this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
                        }
                        static fromFeature(S, D) {
                            let j = new S1;
                            for(let te = 0; te < S.sections.length; te++){
                                let ue = S.sections[te];
                                ue.image ? j.addImageSection(ue) : j.addTextSection(ue, D);
                            }
                            return j;
                        }
                        length() {
                            return this.text.length;
                        }
                        getSection(S) {
                            return this.sections[this.sectionIndex[S]];
                        }
                        getSectionIndex(S) {
                            return this.sectionIndex[S];
                        }
                        getCharCode(S) {
                            return this.text.charCodeAt(S);
                        }
                        verticalizePunctuation() {
                            this.text = function(S) {
                                let D = "";
                                for(let j = 0; j < S.length; j++){
                                    let te = S.charCodeAt(j + 1) || null, ue = S.charCodeAt(j - 1) || null;
                                    D += te && yl(te) && !Fu[S[j + 1]] || ue && yl(ue) && !Fu[S[j - 1]] || !Fu[S[j]] ? S[j] : Fu[S[j]];
                                }
                                return D;
                            }(this.text);
                        }
                        trim() {
                            let S = 0;
                            for(let j = 0; j < this.text.length && Lw[this.text.charCodeAt(j)]; j++)S++;
                            let D = this.text.length;
                            for(let j = this.text.length - 1; j >= 0 && j >= S && Lw[this.text.charCodeAt(j)]; j--)D--;
                            this.text = this.text.substring(S, D), this.sectionIndex = this.sectionIndex.slice(S, D);
                        }
                        substring(S, D) {
                            let j = new S1;
                            return j.text = this.text.substring(S, D), j.sectionIndex = this.sectionIndex.slice(S, D), j.sections = this.sections, j;
                        }
                        toString() {
                            return this.text;
                        }
                        getMaxScale() {
                            return this.sectionIndex.reduce((S, D)=>Math.max(S, this.sections[D].scale), 0);
                        }
                        addTextSection(S, D) {
                            this.text += S.text, this.sections.push(Hx.forText(S.scale, S.fontStack || D));
                            let j = this.sections.length - 1;
                            for(let te = 0; te < S.text.length; ++te)this.sectionIndex.push(j);
                        }
                        addImageSection(S) {
                            let D = S.image ? S.image.name : "";
                            if (D.length === 0) return void T("Can't add FormattedSection with an empty image.");
                            let j = this.getNextImageSectionCharCode();
                            j ? (this.text += String.fromCharCode(j), this.sections.push(Hx.forImage(D)), this.sectionIndex.push(this.sections.length - 1)) : T("Reached maximum number of images 6401");
                        }
                        getNextImageSectionCharCode() {
                            return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
                        }
                    }
                    function Gx(R, S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt, sr, Tr) {
                        let Pr = S1.fromFeature(R, te), $r;
                        Ft === i.ah.vertical && Pr.verticalizePunctuation();
                        let { processBidirectionalText: ni, processStyledBidirectionalText: Di } = vs;
                        if (ni && Pr.sections.length === 1) {
                            $r = [];
                            let Zi = ni(Pr.toString(), M1(Pr, at, ue, S, j, sr));
                            for (let ta of Zi){
                                let Va = new S1;
                                Va.text = ta, Va.sections = Pr.sections;
                                for(let Io = 0; Io < ta.length; Io++)Va.sectionIndex.push(0);
                                $r.push(Va);
                            }
                        } else if (Di) {
                            $r = [];
                            let Zi = Di(Pr.text, Pr.sectionIndex, M1(Pr, at, ue, S, j, sr));
                            for (let ta of Zi){
                                let Va = new S1;
                                Va.text = ta[0], Va.sectionIndex = ta[1], Va.sections = Pr.sections, $r.push(Va);
                            }
                        } else $r = function(Zi, ta) {
                            let Va = [], Io = Zi.text, La = 0;
                            for (let Hn of ta)Va.push(Zi.substring(La, Hn)), La = Hn;
                            return La < Io.length && Va.push(Zi.substring(La, Io.length)), Va;
                        }(Pr, M1(Pr, at, ue, S, j, sr));
                        let pi = [], ki = {
                            positionedLines: pi,
                            text: Pr.toString(),
                            top: Tt[1],
                            bottom: Tt[1],
                            left: Tt[0],
                            right: Tt[0],
                            writingMode: Ft,
                            iconsInText: !1,
                            verticalizable: !1
                        };
                        return function(Zi, ta, Va, Io, La, Hn, lo, $a, Xa, Tn, bo, Ya) {
                            let Uo = 0, wu = lh, hu = 0, uh = 0, $v = $a === "right" ? 1 : $a === "left" ? 0 : .5, td = 0;
                            for (let rf of La){
                                rf.trim();
                                let fh = rf.getMaxScale(), Td = (fh - 1) * kl, rd = {
                                    positionedGlyphs: [],
                                    lineOffset: 0
                                };
                                Zi.positionedLines[td] = rd;
                                let Dh = rd.positionedGlyphs, xf = 0;
                                if (!rf.length()) {
                                    wu += Hn, ++td;
                                    continue;
                                }
                                for(let lv = 0; lv < rf.length(); lv++){
                                    let Cl = rf.getSection(lv), qu = rf.getSectionIndex(lv), Tu = rf.getCharCode(lv), Rv = 0, qc = null, I1 = null, p0 = null, Gp = kl, Qv = !(Xa === i.ah.horizontal || !bo && !Bo(Tu) || bo && (Lw[Tu] || (ch = Tu, new RegExp("\\p{sc=Arab}", "u").test(String.fromCodePoint(ch)))));
                                    if (Cl.imageName) {
                                        let oc = Io[Cl.imageName];
                                        if (!oc) continue;
                                        p0 = Cl.imageName, Zi.iconsInText = Zi.iconsInText || !0, I1 = oc.paddedRect;
                                        let If = oc.displaySize;
                                        Cl.scale = Cl.scale * kl / Ya, qc = {
                                            width: If[0],
                                            height: If[1],
                                            left: wd,
                                            top: -hC,
                                            advance: Qv ? If[1] : If[0]
                                        }, Rv = Td + (kl - If[1] * Cl.scale), Gp = qc.advance;
                                        let ep = Qv ? If[0] * Cl.scale - kl * fh : If[1] * Cl.scale - kl * fh;
                                        ep > 0 && ep > xf && (xf = ep);
                                    } else {
                                        let oc = Va[Cl.fontStack], If = oc && oc[Tu];
                                        if (If && If.rect) I1 = If.rect, qc = If.metrics;
                                        else {
                                            let ep = ta[Cl.fontStack], gg = ep && ep[Tu];
                                            if (!gg) continue;
                                            qc = gg.metrics;
                                        }
                                        Rv = (fh - Cl.scale) * kl;
                                    }
                                    Qv ? (Zi.verticalizable = !0, Dh.push({
                                        glyph: Tu,
                                        imageName: p0,
                                        x: Uo,
                                        y: wu + Rv,
                                        vertical: Qv,
                                        scale: Cl.scale,
                                        fontStack: Cl.fontStack,
                                        sectionIndex: qu,
                                        metrics: qc,
                                        rect: I1
                                    }), Uo += Gp * Cl.scale + Tn) : (Dh.push({
                                        glyph: Tu,
                                        imageName: p0,
                                        x: Uo,
                                        y: wu + Rv,
                                        vertical: Qv,
                                        scale: Cl.scale,
                                        fontStack: Cl.fontStack,
                                        sectionIndex: qu,
                                        metrics: qc,
                                        rect: I1
                                    }), Uo += qc.advance * Cl.scale + Tn);
                                }
                                Dh.length !== 0 && (hu = Math.max(Uo - Tn, hu), sm(Dh, 0, Dh.length - 1, $v, xf)), Uo = 0;
                                let Iv = Hn * fh + xf;
                                rd.lineOffset = Math.max(xf, Td), wu += Iv, uh = Math.max(Iv, uh), ++td;
                            }
                            var ch;
                            let Ud = wu - lh, { horizontalAlign: Vd, verticalAlign: Hd } = Iw(lo);
                            (function(rf, fh, Td, rd, Dh, xf, Iv, lv, Cl) {
                                let qu = (fh - Td) * Dh, Tu = 0;
                                Tu = xf !== Iv ? -lv * rd - lh : (-rd * Cl + .5) * Iv;
                                for (let Rv of rf)for (let qc of Rv.positionedGlyphs)qc.x += qu, qc.y += Tu;
                            })(Zi.positionedLines, $v, Vd, Hd, hu, uh, Hn, Ud, La.length), Zi.top += -Hd * Ud, Zi.bottom = Zi.top + Ud, Zi.left += -Vd * hu, Zi.right = Zi.left + hu;
                        }(ki, S, D, j, $r, ve, De, Ze, Ft, at, Qt, Tr), !function(Zi) {
                            for (let ta of Zi)if (ta.positionedGlyphs.length !== 0) return !1;
                            return !0;
                        }(pi) && ki;
                    }
                    let Lw = {
                        9: !0,
                        10: !0,
                        11: !0,
                        12: !0,
                        13: !0,
                        32: !0
                    }, B9 = {
                        10: !0,
                        32: !0,
                        38: !0,
                        41: !0,
                        43: !0,
                        45: !0,
                        47: !0,
                        173: !0,
                        183: !0,
                        8203: !0,
                        8208: !0,
                        8211: !0,
                        8231: !0
                    }, N9 = {
                        40: !0
                    };
                    function dC(R, S, D, j, te, ue) {
                        if (S.imageName) {
                            let ve = j[S.imageName];
                            return ve ? ve.displaySize[0] * S.scale * kl / ue + te : 0;
                        }
                        {
                            let ve = D[S.fontStack], De = ve && ve[R];
                            return De ? De.metrics.advance * S.scale + te : 0;
                        }
                    }
                    function vC(R, S, D, j) {
                        let te = Math.pow(R - S, 2);
                        return j ? R < S ? te / 2 : 2 * te : te + Math.abs(D) * D;
                    }
                    function U9(R, S, D) {
                        let j = 0;
                        return R === 10 && (j -= 1e4), D && (j += 150), R !== 40 && R !== 65288 || (j += 50), S !== 41 && S !== 65289 || (j += 50), j;
                    }
                    function Pw(R, S, D, j, te, ue) {
                        let ve = null, De = vC(S, D, te, ue);
                        for (let Ze of j){
                            let at = vC(S - Ze.x, D, te, ue) + Ze.badness;
                            at <= De && (ve = Ze, De = at);
                        }
                        return {
                            index: R,
                            x: S,
                            priorBreak: ve,
                            badness: De
                        };
                    }
                    function pC(R) {
                        return R ? pC(R.priorBreak).concat(R.index) : [];
                    }
                    function M1(R, S, D, j, te, ue) {
                        if (!R) return [];
                        let ve = [], De = function(Ft, Qt, sr, Tr, Pr, $r) {
                            let ni = 0;
                            for(let Di = 0; Di < Ft.length(); Di++){
                                let pi = Ft.getSection(Di);
                                ni += dC(Ft.getCharCode(Di), pi, Tr, Pr, Qt, $r);
                            }
                            return ni / Math.max(1, Math.ceil(ni / sr));
                        }(R, S, D, j, te, ue), Ze = R.text.indexOf("\u200B") >= 0, at = 0;
                        for(let Ft = 0; Ft < R.length(); Ft++){
                            let Qt = R.getSection(Ft), sr = R.getCharCode(Ft);
                            if (Lw[sr] || (at += dC(sr, Qt, j, te, S, ue)), Ft < R.length() - 1) {
                                let Tr = !((Tt = sr) < 11904) && (!!sn["CJK Compatibility Forms"](Tt) || !!sn["CJK Compatibility"](Tt) || !!sn["CJK Strokes"](Tt) || !!sn["CJK Symbols and Punctuation"](Tt) || !!sn["Enclosed CJK Letters and Months"](Tt) || !!sn["Halfwidth and Fullwidth Forms"](Tt) || !!sn["Ideographic Description Characters"](Tt) || !!sn["Vertical Forms"](Tt) || ys.test(String.fromCodePoint(Tt)));
                                (B9[sr] || Tr || Qt.imageName || Ft !== R.length() - 2 && N9[R.getCharCode(Ft + 1)]) && ve.push(Pw(Ft + 1, at, De, ve, U9(sr, R.getCharCode(Ft + 1), Tr && Ze), !1));
                            }
                        }
                        var Tt;
                        return pC(Pw(R.length(), at, De, ve, 0, !0));
                    }
                    function Iw(R) {
                        let S = .5, D = .5;
                        switch(R){
                            case "right":
                            case "top-right":
                            case "bottom-right":
                                S = 1;
                                break;
                            case "left":
                            case "top-left":
                            case "bottom-left":
                                S = 0;
                        }
                        switch(R){
                            case "bottom":
                            case "bottom-right":
                            case "bottom-left":
                                D = 1;
                                break;
                            case "top":
                            case "top-right":
                            case "top-left":
                                D = 0;
                        }
                        return {
                            horizontalAlign: S,
                            verticalAlign: D
                        };
                    }
                    function sm(R, S, D, j, te) {
                        if (!j && !te) return;
                        let ue = R[D], ve = (R[D].x + ue.metrics.advance * ue.scale) * j;
                        for(let De = S; De <= D; De++)R[De].x -= ve, R[De].y += te;
                    }
                    function jx(R, S, D) {
                        let { horizontalAlign: j, verticalAlign: te } = Iw(D), ue = S[0] - R.displaySize[0] * j, ve = S[1] - R.displaySize[1] * te;
                        return {
                            image: R,
                            top: ve,
                            bottom: ve + R.displaySize[1],
                            left: ue,
                            right: ue + R.displaySize[0]
                        };
                    }
                    function gC(R) {
                        var S, D;
                        let j = R.left, te = R.top, ue = R.right - j, ve = R.bottom - te, De = (S = R.image.textFitWidth) !== null && S !== void 0 ? S : "stretchOrShrink", Ze = (D = R.image.textFitHeight) !== null && D !== void 0 ? D : "stretchOrShrink", at = (R.image.content[2] - R.image.content[0]) / (R.image.content[3] - R.image.content[1]);
                        if (Ze === "proportional") {
                            if (De === "stretchOnly" && ue / ve < at || De === "proportional") {
                                let Tt = Math.ceil(ve * at);
                                j *= Tt / ue, ue = Tt;
                            }
                        } else if (De === "proportional" && Ze === "stretchOnly" && at !== 0 && ue / ve > at) {
                            let Tt = Math.ceil(ue / at);
                            te *= Tt / ve, ve = Tt;
                        }
                        return {
                            x1: j,
                            y1: te,
                            x2: j + ue,
                            y2: te + ve
                        };
                    }
                    function mC(R, S, D, j, te, ue) {
                        let ve = R.image, De;
                        if (ve.content) {
                            let $r = ve.content, ni = ve.pixelRatio || 1;
                            De = [
                                $r[0] / ni,
                                $r[1] / ni,
                                ve.displaySize[0] - $r[2] / ni,
                                ve.displaySize[1] - $r[3] / ni
                            ];
                        }
                        let Ze = S.left * ue, at = S.right * ue, Tt, Ft, Qt, sr;
                        D === "width" || D === "both" ? (sr = te[0] + Ze - j[3], Ft = te[0] + at + j[1]) : (sr = te[0] + (Ze + at - ve.displaySize[0]) / 2, Ft = sr + ve.displaySize[0]);
                        let Tr = S.top * ue, Pr = S.bottom * ue;
                        return D === "height" || D === "both" ? (Tt = te[1] + Tr - j[0], Qt = te[1] + Pr + j[2]) : (Tt = te[1] + (Tr + Pr - ve.displaySize[1]) / 2, Qt = Tt + ve.displaySize[1]), {
                            image: ve,
                            top: Tt,
                            right: Ft,
                            bottom: Qt,
                            left: sr,
                            collisionPadding: De
                        };
                    }
                    let Wx = 255, v0 = 128, lm = Wx * v0;
                    function yC(R, S) {
                        let { expression: D } = S;
                        if (D.kind === "constant") return {
                            kind: "constant",
                            layoutSize: D.evaluate(new Ko(R + 1))
                        };
                        if (D.kind === "source") return {
                            kind: "source"
                        };
                        {
                            let { zoomStops: j, interpolationType: te } = D, ue = 0;
                            for(; ue < j.length && j[ue] <= R;)ue++;
                            ue = Math.max(0, ue - 1);
                            let ve = ue;
                            for(; ve < j.length && j[ve] < R + 1;)ve++;
                            ve = Math.min(j.length - 1, ve);
                            let De = j[ue], Ze = j[ve];
                            return D.kind === "composite" ? {
                                kind: "composite",
                                minZoom: De,
                                maxZoom: Ze,
                                interpolationType: te
                            } : {
                                kind: "camera",
                                minZoom: De,
                                maxZoom: Ze,
                                minSize: D.evaluate(new Ko(De)),
                                maxSize: D.evaluate(new Ko(Ze)),
                                interpolationType: te
                            };
                        }
                    }
                    function iS(R, S, D) {
                        let j = "never", te = R.get(S);
                        return te ? j = te : R.get(D) && (j = "always"), j;
                    }
                    let V9 = ei.VectorTileFeature.types, H9 = [
                        {
                            name: "a_fade_opacity",
                            components: 1,
                            type: "Uint8",
                            offset: 0
                        }
                    ];
                    function Rw(R, S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt) {
                        let sr = De ? Math.min(lm, Math.round(De[0])) : 0, Tr = De ? Math.min(lm, Math.round(De[1])) : 0;
                        R.emplaceBack(S, D, Math.round(32 * j), Math.round(32 * te), ue, ve, (sr << 1) + (Ze ? 1 : 0), Tr, 16 * at, 16 * Tt, 256 * Ft, 256 * Qt);
                    }
                    function nS(R, S, D) {
                        R.emplaceBack(S.x, S.y, D), R.emplaceBack(S.x, S.y, D), R.emplaceBack(S.x, S.y, D), R.emplaceBack(S.x, S.y, D);
                    }
                    function aS(R) {
                        for (let S of R.sections)if (Ka(S.text)) return !0;
                        return !1;
                    }
                    class oS {
                        constructor(S){
                            this.layoutVertexArray = new au, this.indexArray = new oe, this.programConfigurations = S, this.segments = new We, this.dynamicLayoutVertexArray = new zc, this.opacityVertexArray = new zl, this.hasVisibleVertices = !1, this.placedSymbolArray = new pa;
                        }
                        isEmpty() {
                            return this.layoutVertexArray.length === 0 && this.indexArray.length === 0 && this.dynamicLayoutVertexArray.length === 0 && this.opacityVertexArray.length === 0;
                        }
                        upload(S, D, j, te) {
                            this.isEmpty() || (j && (this.layoutVertexBuffer = S.createVertexBuffer(this.layoutVertexArray, rm.members), this.indexBuffer = S.createIndexBuffer(this.indexArray, D), this.dynamicLayoutVertexBuffer = S.createVertexBuffer(this.dynamicLayoutVertexArray, w1.members, !0), this.opacityVertexBuffer = S.createVertexBuffer(this.opacityVertexArray, H9, !0), this.opacityVertexBuffer.itemSize = 1), (j || te) && this.programConfigurations.upload(S));
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
                        }
                    }
                    mi("SymbolBuffers", oS);
                    class um {
                        constructor(S, D, j){
                            this.layoutVertexArray = new S, this.layoutAttributes = D, this.indexArray = new j, this.segments = new We, this.collisionVertexArray = new Z;
                        }
                        upload(S) {
                            this.layoutVertexBuffer = S.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = S.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = S.createVertexBuffer(this.collisionVertexArray, T1.members, !0);
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
                        }
                    }
                    mi("CollisionBuffers", um);
                    class E1 {
                        constructor(S){
                            this.collisionBoxArray = S.collisionBoxArray, this.zoom = S.zoom, this.overscaling = S.overscaling, this.layers = S.layers, this.layerIds = this.layers.map((ve)=>ve.id), this.index = S.index, this.pixelRatio = S.pixelRatio, this.sourceLayerIndex = S.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = Un([]), this.placementViewportMatrix = Un([]);
                            let D = this.layers[0]._unevaluatedLayout._values;
                            this.textSizeData = yC(this.zoom, D["text-size"]), this.iconSizeData = yC(this.zoom, D["icon-size"]);
                            let j = this.layers[0].layout, te = j.get("symbol-sort-key"), ue = j.get("symbol-z-order");
                            this.canOverlap = iS(j, "text-overlap", "text-allow-overlap") !== "never" || iS(j, "icon-overlap", "icon-allow-overlap") !== "never" || j.get("text-ignore-placement") || j.get("icon-ignore-placement"), this.sortFeaturesByKey = ue !== "viewport-y" && !te.isConstant(), this.sortFeaturesByY = (ue === "viewport-y" || ue === "auto" && !this.sortFeaturesByKey) && this.canOverlap, j.get("symbol-placement") === "point" && (this.writingModes = j.get("text-writing-mode").map((ve)=>i.ah[ve])), this.stateDependentLayerIds = this.layers.filter((ve)=>ve.isStateDependent()).map((ve)=>ve.id), this.sourceID = S.sourceID;
                        }
                        createArrays() {
                            this.text = new oS(new _s(this.layers, this.zoom, (S)=>/^text/.test(S))), this.icon = new oS(new _s(this.layers, this.zoom, (S)=>/^icon/.test(S))), this.glyphOffsetArray = new To, this.lineVertexArray = new Wa, this.symbolInstances = new Ga, this.textAnchorOffsets = new Ro;
                        }
                        calculateGlyphDependencies(S, D, j, te, ue) {
                            for(let ve = 0; ve < S.length; ve++)if (D[S.charCodeAt(ve)] = !0, (j || te) && ue) {
                                let De = Fu[S.charAt(ve)];
                                De && (D[De.charCodeAt(0)] = !0);
                            }
                        }
                        populate(S, D, j) {
                            let te = this.layers[0], ue = te.layout, ve = ue.get("text-font"), De = ue.get("text-field"), Ze = ue.get("icon-image"), at = (De.value.kind !== "constant" || De.value.value instanceof Zr && !De.value.value.isEmpty() || De.value.value.toString().length > 0) && (ve.value.kind !== "constant" || ve.value.value.length > 0), Tt = Ze.value.kind !== "constant" || !!Ze.value.value || Object.keys(Ze.parameters).length > 0, Ft = ue.get("symbol-sort-key");
                            if (this.features = [], !at && !Tt) return;
                            let Qt = D.iconDependencies, sr = D.glyphDependencies, Tr = D.availableImages, Pr = new Ko(this.zoom);
                            for (let { feature: $r, id: ni, index: Di, sourceLayerIndex: pi } of S){
                                let ki = te._featureFilter.needGeometry, Zi = xl($r, ki);
                                if (!te._featureFilter.filter(Pr, Zi, j)) continue;
                                let ta, Va;
                                if (ki || (Zi.geometry = js($r)), at) {
                                    let La = te.getValueAndResolveTokens("text-field", Zi, j, Tr), Hn = Zr.factory(La), lo = this.hasRTLText = this.hasRTLText || aS(Hn);
                                    (!lo || vs.getRTLTextPluginStatus() === "unavailable" || lo && vs.isParsed()) && (ta = nm(Hn, te, Zi));
                                }
                                if (Tt) {
                                    let La = te.getValueAndResolveTokens("icon-image", Zi, j, Tr);
                                    Va = La instanceof Mi ? La : Mi.fromString(La);
                                }
                                if (!ta && !Va) continue;
                                let Io = this.sortFeaturesByKey ? Ft.evaluate(Zi, {}, j) : void 0;
                                if (this.features.push({
                                    id: ni,
                                    text: ta,
                                    icon: Va,
                                    index: Di,
                                    sourceLayerIndex: pi,
                                    geometry: Zi.geometry,
                                    properties: $r.properties,
                                    type: V9[$r.type],
                                    sortKey: Io
                                }), Va && (Qt[Va.name] = !0), ta) {
                                    let La = ve.evaluate(Zi, {}, j).join(","), Hn = ue.get("text-rotation-alignment") !== "viewport" && ue.get("symbol-placement") !== "point";
                                    this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(i.ah.vertical) >= 0;
                                    for (let lo of ta.sections)if (lo.image) Qt[lo.image.name] = !0;
                                    else {
                                        let $a = Ua(ta.toString()), Xa = lo.fontStack || La, Tn = sr[Xa] = sr[Xa] || {};
                                        this.calculateGlyphDependencies(lo.text, Tn, Hn, this.allowVerticalPlacement, $a);
                                    }
                                }
                            }
                            ue.get("symbol-placement") === "line" && (this.features = function($r) {
                                let ni = {}, Di = {}, pi = [], ki = 0;
                                function Zi(La) {
                                    pi.push($r[La]), ki++;
                                }
                                function ta(La, Hn, lo) {
                                    let $a = Di[La];
                                    return delete Di[La], Di[Hn] = $a, pi[$a].geometry[0].pop(), pi[$a].geometry[0] = pi[$a].geometry[0].concat(lo[0]), $a;
                                }
                                function Va(La, Hn, lo) {
                                    let $a = ni[Hn];
                                    return delete ni[Hn], ni[La] = $a, pi[$a].geometry[0].shift(), pi[$a].geometry[0] = lo[0].concat(pi[$a].geometry[0]), $a;
                                }
                                function Io(La, Hn, lo) {
                                    let $a = lo ? Hn[0][Hn[0].length - 1] : Hn[0][0];
                                    return `${La}:${$a.x}:${$a.y}`;
                                }
                                for(let La = 0; La < $r.length; La++){
                                    let Hn = $r[La], lo = Hn.geometry, $a = Hn.text ? Hn.text.toString() : null;
                                    if (!$a) {
                                        Zi(La);
                                        continue;
                                    }
                                    let Xa = Io($a, lo), Tn = Io($a, lo, !0);
                                    if (Xa in Di && Tn in ni && Di[Xa] !== ni[Tn]) {
                                        let bo = Va(Xa, Tn, lo), Ya = ta(Xa, Tn, pi[bo].geometry);
                                        delete ni[Xa], delete Di[Tn], Di[Io($a, pi[Ya].geometry, !0)] = Ya, pi[bo].geometry = null;
                                    } else Xa in Di ? ta(Xa, Tn, lo) : Tn in ni ? Va(Xa, Tn, lo) : (Zi(La), ni[Xa] = ki - 1, Di[Tn] = ki - 1);
                                }
                                return pi.filter((La)=>La.geometry);
                            }(this.features)), this.sortFeaturesByKey && this.features.sort(($r, ni)=>$r.sortKey - ni.sortKey);
                        }
                        update(S, D, j) {
                            this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(S, D, this.layers, j), this.icon.programConfigurations.updatePaintArrays(S, D, this.layers, j));
                        }
                        isEmpty() {
                            return this.symbolInstances.length === 0 && !this.hasRTLText;
                        }
                        uploadPending() {
                            return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
                        }
                        upload(S) {
                            !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(S), this.iconCollisionBox.upload(S)), this.text.upload(S, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(S, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
                        }
                        destroyDebugData() {
                            this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
                        }
                        destroy() {
                            this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
                        }
                        addToLineVertexArray(S, D) {
                            let j = this.lineVertexArray.length;
                            if (S.segment !== void 0) {
                                let te = S.dist(D[S.segment + 1]), ue = S.dist(D[S.segment]), ve = {};
                                for(let De = S.segment + 1; De < D.length; De++)ve[De] = {
                                    x: D[De].x,
                                    y: D[De].y,
                                    tileUnitDistanceFromAnchor: te
                                }, De < D.length - 1 && (te += D[De + 1].dist(D[De]));
                                for(let De = S.segment || 0; De >= 0; De--)ve[De] = {
                                    x: D[De].x,
                                    y: D[De].y,
                                    tileUnitDistanceFromAnchor: ue
                                }, De > 0 && (ue += D[De - 1].dist(D[De]));
                                for(let De = 0; De < D.length; De++){
                                    let Ze = ve[De];
                                    this.lineVertexArray.emplaceBack(Ze.x, Ze.y, Ze.tileUnitDistanceFromAnchor);
                                }
                            }
                            return {
                                lineStartIndex: j,
                                lineLength: this.lineVertexArray.length - j
                            };
                        }
                        addSymbols(S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt) {
                            let sr = S.indexArray, Tr = S.layoutVertexArray, Pr = S.segments.prepareSegment(4 * D.length, Tr, sr, this.canOverlap ? ve.sortKey : void 0), $r = this.glyphOffsetArray.length, ni = Pr.vertexLength, Di = this.allowVerticalPlacement && De === i.ah.vertical ? Math.PI / 2 : 0, pi = ve.text && ve.text.sections;
                            for(let ki = 0; ki < D.length; ki++){
                                let { tl: Zi, tr: ta, bl: Va, br: Io, tex: La, pixelOffsetTL: Hn, pixelOffsetBR: lo, minFontScaleX: $a, minFontScaleY: Xa, glyphOffset: Tn, isSDF: bo, sectionIndex: Ya } = D[ki], Uo = Pr.vertexLength, wu = Tn[1];
                                Rw(Tr, Ze.x, Ze.y, Zi.x, wu + Zi.y, La.x, La.y, j, bo, Hn.x, Hn.y, $a, Xa), Rw(Tr, Ze.x, Ze.y, ta.x, wu + ta.y, La.x + La.w, La.y, j, bo, lo.x, Hn.y, $a, Xa), Rw(Tr, Ze.x, Ze.y, Va.x, wu + Va.y, La.x, La.y + La.h, j, bo, Hn.x, lo.y, $a, Xa), Rw(Tr, Ze.x, Ze.y, Io.x, wu + Io.y, La.x + La.w, La.y + La.h, j, bo, lo.x, lo.y, $a, Xa), nS(S.dynamicLayoutVertexArray, Ze, Di), sr.emplaceBack(Uo, Uo + 1, Uo + 2), sr.emplaceBack(Uo + 1, Uo + 2, Uo + 3), Pr.vertexLength += 4, Pr.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(Tn[0]), ki !== D.length - 1 && Ya === D[ki + 1].sectionIndex || S.programConfigurations.populatePaintArrays(Tr.length, ve, ve.index, {}, Qt, pi && pi[Ya]);
                            }
                            S.placedSymbolArray.emplaceBack(Ze.x, Ze.y, $r, this.glyphOffsetArray.length - $r, ni, at, Tt, Ze.segment, j ? j[0] : 0, j ? j[1] : 0, te[0], te[1], De, 0, !1, 0, Ft);
                        }
                        _addCollisionDebugVertex(S, D, j, te, ue, ve) {
                            return D.emplaceBack(0, 0), S.emplaceBack(j.x, j.y, te, ue, Math.round(ve.x), Math.round(ve.y));
                        }
                        addCollisionDebugVertices(S, D, j, te, ue, ve, De) {
                            let Ze = ue.segments.prepareSegment(4, ue.layoutVertexArray, ue.indexArray), at = Ze.vertexLength, Tt = ue.layoutVertexArray, Ft = ue.collisionVertexArray, Qt = De.anchorX, sr = De.anchorY;
                            this._addCollisionDebugVertex(Tt, Ft, ve, Qt, sr, new u(S, D)), this._addCollisionDebugVertex(Tt, Ft, ve, Qt, sr, new u(j, D)), this._addCollisionDebugVertex(Tt, Ft, ve, Qt, sr, new u(j, te)), this._addCollisionDebugVertex(Tt, Ft, ve, Qt, sr, new u(S, te)), Ze.vertexLength += 4;
                            let Tr = ue.indexArray;
                            Tr.emplaceBack(at, at + 1), Tr.emplaceBack(at + 1, at + 2), Tr.emplaceBack(at + 2, at + 3), Tr.emplaceBack(at + 3, at), Ze.primitiveLength += 4;
                        }
                        addDebugCollisionBoxes(S, D, j, te) {
                            for(let ue = S; ue < D; ue++){
                                let ve = this.collisionBoxArray.get(ue);
                                this.addCollisionDebugVertices(ve.x1, ve.y1, ve.x2, ve.y2, te ? this.textCollisionBox : this.iconCollisionBox, ve.anchorPoint, j);
                            }
                        }
                        generateCollisionDebugBuffers() {
                            this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new um(Fl, oy.members, we), this.iconCollisionBox = new um(Fl, oy.members, we);
                            for(let S = 0; S < this.symbolInstances.length; S++){
                                let D = this.symbolInstances.get(S);
                                this.addDebugCollisionBoxes(D.textBoxStartIndex, D.textBoxEndIndex, D, !0), this.addDebugCollisionBoxes(D.verticalTextBoxStartIndex, D.verticalTextBoxEndIndex, D, !0), this.addDebugCollisionBoxes(D.iconBoxStartIndex, D.iconBoxEndIndex, D, !1), this.addDebugCollisionBoxes(D.verticalIconBoxStartIndex, D.verticalIconBoxEndIndex, D, !1);
                            }
                        }
                        _deserializeCollisionBoxesForSymbol(S, D, j, te, ue, ve, De, Ze, at) {
                            let Tt = {};
                            for(let Ft = D; Ft < j; Ft++){
                                let Qt = S.get(Ft);
                                Tt.textBox = {
                                    x1: Qt.x1,
                                    y1: Qt.y1,
                                    x2: Qt.x2,
                                    y2: Qt.y2,
                                    anchorPointX: Qt.anchorPointX,
                                    anchorPointY: Qt.anchorPointY
                                }, Tt.textFeatureIndex = Qt.featureIndex;
                                break;
                            }
                            for(let Ft = te; Ft < ue; Ft++){
                                let Qt = S.get(Ft);
                                Tt.verticalTextBox = {
                                    x1: Qt.x1,
                                    y1: Qt.y1,
                                    x2: Qt.x2,
                                    y2: Qt.y2,
                                    anchorPointX: Qt.anchorPointX,
                                    anchorPointY: Qt.anchorPointY
                                }, Tt.verticalTextFeatureIndex = Qt.featureIndex;
                                break;
                            }
                            for(let Ft = ve; Ft < De; Ft++){
                                let Qt = S.get(Ft);
                                Tt.iconBox = {
                                    x1: Qt.x1,
                                    y1: Qt.y1,
                                    x2: Qt.x2,
                                    y2: Qt.y2,
                                    anchorPointX: Qt.anchorPointX,
                                    anchorPointY: Qt.anchorPointY
                                }, Tt.iconFeatureIndex = Qt.featureIndex;
                                break;
                            }
                            for(let Ft = Ze; Ft < at; Ft++){
                                let Qt = S.get(Ft);
                                Tt.verticalIconBox = {
                                    x1: Qt.x1,
                                    y1: Qt.y1,
                                    x2: Qt.x2,
                                    y2: Qt.y2,
                                    anchorPointX: Qt.anchorPointX,
                                    anchorPointY: Qt.anchorPointY
                                }, Tt.verticalIconFeatureIndex = Qt.featureIndex;
                                break;
                            }
                            return Tt;
                        }
                        deserializeCollisionBoxes(S) {
                            this.collisionArrays = [];
                            for(let D = 0; D < this.symbolInstances.length; D++){
                                let j = this.symbolInstances.get(D);
                                this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(S, j.textBoxStartIndex, j.textBoxEndIndex, j.verticalTextBoxStartIndex, j.verticalTextBoxEndIndex, j.iconBoxStartIndex, j.iconBoxEndIndex, j.verticalIconBoxStartIndex, j.verticalIconBoxEndIndex));
                            }
                        }
                        hasTextData() {
                            return this.text.segments.get().length > 0;
                        }
                        hasIconData() {
                            return this.icon.segments.get().length > 0;
                        }
                        hasDebugData() {
                            return this.textCollisionBox && this.iconCollisionBox;
                        }
                        hasTextCollisionBoxData() {
                            return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
                        }
                        hasIconCollisionBoxData() {
                            return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
                        }
                        addIndicesForPlacedSymbol(S, D) {
                            let j = S.placedSymbolArray.get(D), te = j.vertexStartIndex + 4 * j.numGlyphs;
                            for(let ue = j.vertexStartIndex; ue < te; ue += 4)S.indexArray.emplaceBack(ue, ue + 1, ue + 2), S.indexArray.emplaceBack(ue + 1, ue + 2, ue + 3);
                        }
                        getSortedSymbolIndexes(S) {
                            if (this.sortedAngle === S && this.symbolInstanceIndexes !== void 0) return this.symbolInstanceIndexes;
                            let D = Math.sin(S), j = Math.cos(S), te = [], ue = [], ve = [];
                            for(let De = 0; De < this.symbolInstances.length; ++De){
                                ve.push(De);
                                let Ze = this.symbolInstances.get(De);
                                te.push(0 | Math.round(D * Ze.anchorX + j * Ze.anchorY)), ue.push(Ze.featureIndex);
                            }
                            return ve.sort((De, Ze)=>te[De] - te[Ze] || ue[Ze] - ue[De]), ve;
                        }
                        addToSortKeyRanges(S, D) {
                            let j = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                            j && j.sortKey === D ? j.symbolInstanceEnd = S + 1 : this.sortKeyRanges.push({
                                sortKey: D,
                                symbolInstanceStart: S,
                                symbolInstanceEnd: S + 1
                            });
                        }
                        sortFeatures(S) {
                            if (this.sortFeaturesByY && this.sortedAngle !== S && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                                this.symbolInstanceIndexes = this.getSortedSymbolIndexes(S), this.sortedAngle = S, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                                for (let D of this.symbolInstanceIndexes){
                                    let j = this.symbolInstances.get(D);
                                    this.featureSortOrder.push(j.featureIndex), [
                                        j.rightJustifiedTextSymbolIndex,
                                        j.centerJustifiedTextSymbolIndex,
                                        j.leftJustifiedTextSymbolIndex
                                    ].forEach((te, ue, ve)=>{
                                        te >= 0 && ve.indexOf(te) === ue && this.addIndicesForPlacedSymbol(this.text, te);
                                    }), j.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, j.verticalPlacedTextSymbolIndex), j.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, j.placedIconSymbolIndex), j.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, j.verticalPlacedIconSymbolIndex);
                                }
                                this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                            }
                        }
                    }
                    let tf, Zx;
                    mi("SymbolBucket", E1, {
                        omit: [
                            "layers",
                            "collisionBoxArray",
                            "features",
                            "compareText"
                        ]
                    }), E1.MAX_GLYPHS = 65535, E1.addDynamicAttributes = nS;
                    var Dw = {
                        get paint () {
                            return Zx = Zx || new le({
                                "icon-opacity": new eo(ce.paint_symbol["icon-opacity"]),
                                "icon-color": new eo(ce.paint_symbol["icon-color"]),
                                "icon-halo-color": new eo(ce.paint_symbol["icon-halo-color"]),
                                "icon-halo-width": new eo(ce.paint_symbol["icon-halo-width"]),
                                "icon-halo-blur": new eo(ce.paint_symbol["icon-halo-blur"]),
                                "icon-translate": new Da(ce.paint_symbol["icon-translate"]),
                                "icon-translate-anchor": new Da(ce.paint_symbol["icon-translate-anchor"]),
                                "text-opacity": new eo(ce.paint_symbol["text-opacity"]),
                                "text-color": new eo(ce.paint_symbol["text-color"], {
                                    runtimeType: Ht,
                                    getOverride: (R)=>R.textColor,
                                    hasOverride: (R)=>!!R.textColor
                                }),
                                "text-halo-color": new eo(ce.paint_symbol["text-halo-color"]),
                                "text-halo-width": new eo(ce.paint_symbol["text-halo-width"]),
                                "text-halo-blur": new eo(ce.paint_symbol["text-halo-blur"]),
                                "text-translate": new Da(ce.paint_symbol["text-translate"]),
                                "text-translate-anchor": new Da(ce.paint_symbol["text-translate-anchor"])
                            });
                        },
                        get layout () {
                            return tf = tf || new le({
                                "symbol-placement": new Da(ce.layout_symbol["symbol-placement"]),
                                "symbol-spacing": new Da(ce.layout_symbol["symbol-spacing"]),
                                "symbol-avoid-edges": new Da(ce.layout_symbol["symbol-avoid-edges"]),
                                "symbol-sort-key": new eo(ce.layout_symbol["symbol-sort-key"]),
                                "symbol-z-order": new Da(ce.layout_symbol["symbol-z-order"]),
                                "icon-allow-overlap": new Da(ce.layout_symbol["icon-allow-overlap"]),
                                "icon-overlap": new Da(ce.layout_symbol["icon-overlap"]),
                                "icon-ignore-placement": new Da(ce.layout_symbol["icon-ignore-placement"]),
                                "icon-optional": new Da(ce.layout_symbol["icon-optional"]),
                                "icon-rotation-alignment": new Da(ce.layout_symbol["icon-rotation-alignment"]),
                                "icon-size": new eo(ce.layout_symbol["icon-size"]),
                                "icon-text-fit": new Da(ce.layout_symbol["icon-text-fit"]),
                                "icon-text-fit-padding": new Da(ce.layout_symbol["icon-text-fit-padding"]),
                                "icon-image": new eo(ce.layout_symbol["icon-image"]),
                                "icon-rotate": new eo(ce.layout_symbol["icon-rotate"]),
                                "icon-padding": new eo(ce.layout_symbol["icon-padding"]),
                                "icon-keep-upright": new Da(ce.layout_symbol["icon-keep-upright"]),
                                "icon-offset": new eo(ce.layout_symbol["icon-offset"]),
                                "icon-anchor": new eo(ce.layout_symbol["icon-anchor"]),
                                "icon-pitch-alignment": new Da(ce.layout_symbol["icon-pitch-alignment"]),
                                "text-pitch-alignment": new Da(ce.layout_symbol["text-pitch-alignment"]),
                                "text-rotation-alignment": new Da(ce.layout_symbol["text-rotation-alignment"]),
                                "text-field": new eo(ce.layout_symbol["text-field"]),
                                "text-font": new eo(ce.layout_symbol["text-font"]),
                                "text-size": new eo(ce.layout_symbol["text-size"]),
                                "text-max-width": new eo(ce.layout_symbol["text-max-width"]),
                                "text-line-height": new Da(ce.layout_symbol["text-line-height"]),
                                "text-letter-spacing": new eo(ce.layout_symbol["text-letter-spacing"]),
                                "text-justify": new eo(ce.layout_symbol["text-justify"]),
                                "text-radial-offset": new eo(ce.layout_symbol["text-radial-offset"]),
                                "text-variable-anchor": new Da(ce.layout_symbol["text-variable-anchor"]),
                                "text-variable-anchor-offset": new eo(ce.layout_symbol["text-variable-anchor-offset"]),
                                "text-anchor": new eo(ce.layout_symbol["text-anchor"]),
                                "text-max-angle": new Da(ce.layout_symbol["text-max-angle"]),
                                "text-writing-mode": new Da(ce.layout_symbol["text-writing-mode"]),
                                "text-rotate": new eo(ce.layout_symbol["text-rotate"]),
                                "text-padding": new Da(ce.layout_symbol["text-padding"]),
                                "text-keep-upright": new Da(ce.layout_symbol["text-keep-upright"]),
                                "text-transform": new eo(ce.layout_symbol["text-transform"]),
                                "text-offset": new eo(ce.layout_symbol["text-offset"]),
                                "text-allow-overlap": new Da(ce.layout_symbol["text-allow-overlap"]),
                                "text-overlap": new Da(ce.layout_symbol["text-overlap"]),
                                "text-ignore-placement": new Da(ce.layout_symbol["text-ignore-placement"]),
                                "text-optional": new Da(ce.layout_symbol["text-optional"])
                            });
                        }
                    };
                    class Xx {
                        constructor(S){
                            if (S.property.overrides === void 0) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                            this.type = S.property.overrides ? S.property.overrides.runtimeType : Lt, this.defaultValue = S;
                        }
                        evaluate(S) {
                            if (S.formattedSection) {
                                let D = this.defaultValue.property.overrides;
                                if (D && D.hasOverride(S.formattedSection)) return D.getOverride(S.formattedSection);
                            }
                            return S.feature && S.featureState ? this.defaultValue.evaluate(S.feature, S.featureState) : this.defaultValue.property.specification.default;
                        }
                        eachChild(S) {
                            this.defaultValue.isConstant() || S(this.defaultValue.value._styleExpression.expression);
                        }
                        outputDefined() {
                            return !1;
                        }
                        serialize() {
                            return null;
                        }
                    }
                    mi("FormatSectionOverride", Xx, {
                        omit: [
                            "defaultValue"
                        ]
                    });
                    class uy extends B {
                        constructor(S){
                            super(S, Dw);
                        }
                        recalculate(S, D) {
                            if (super.recalculate(S, D), this.layout.get("icon-rotation-alignment") === "auto" && (this.layout._values["icon-rotation-alignment"] = this.layout.get("symbol-placement") !== "point" ? "map" : "viewport"), this.layout.get("text-rotation-alignment") === "auto" && (this.layout._values["text-rotation-alignment"] = this.layout.get("symbol-placement") !== "point" ? "map" : "viewport"), this.layout.get("text-pitch-alignment") === "auto" && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment") === "map" ? "map" : "viewport"), this.layout.get("icon-pitch-alignment") === "auto" && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), this.layout.get("symbol-placement") === "point") {
                                let j = this.layout.get("text-writing-mode");
                                if (j) {
                                    let te = [];
                                    for (let ue of j)te.indexOf(ue) < 0 && te.push(ue);
                                    this.layout._values["text-writing-mode"] = te;
                                } else this.layout._values["text-writing-mode"] = [
                                    "horizontal"
                                ];
                            }
                            this._setPaintOverrides();
                        }
                        getValueAndResolveTokens(S, D, j, te) {
                            let ue = this.layout.get(S).evaluate(D, {}, j, te), ve = this._unevaluatedLayout._values[S];
                            return ve.isDataDriven() || Lc(ve.value) || !ue ? ue : function(De, Ze) {
                                return Ze.replace(/{([^{}]+)}/g, (at, Tt)=>De && Tt in De ? String(De[Tt]) : "");
                            }(D.properties, ue);
                        }
                        createBucket(S) {
                            return new E1(S);
                        }
                        queryRadius() {
                            return 0;
                        }
                        queryIntersectsFeature() {
                            throw new Error("Should take a different path in FeatureIndex");
                        }
                        _setPaintOverrides() {
                            for (let S of Dw.paint.overridableProperties){
                                if (!uy.hasPaintOverride(this.layout, S)) continue;
                                let D = this.paint.get(S), j = new Xx(D), te = new Pu(j, D.property.specification), ue = null;
                                ue = D.value.kind === "constant" || D.value.kind === "source" ? new Xc("source", te) : new ic("composite", te, D.value.zoomStops), this.paint._values[S] = new Du(D.property, ue, D.parameters);
                            }
                        }
                        _handleOverridablePaintPropertyUpdate(S, D, j) {
                            return !(!this.layout || D.isDataDriven() || j.isDataDriven()) && uy.hasPaintOverride(this.layout, S);
                        }
                        static hasPaintOverride(S, D) {
                            let j = S.get("text-field"), te = Dw.paint.properties[D], ue = !1, ve = (De)=>{
                                for (let Ze of De)if (te.overrides && te.overrides.hasOverride(Ze)) return void (ue = !0);
                            };
                            if (j.value.kind === "constant" && j.value.value instanceof Zr) ve(j.value.value.sections);
                            else if (j.value.kind === "source") {
                                let De = (at)=>{
                                    ue || (at instanceof jn && Ki(at.value) === Br ? ve(at.value.sections) : at instanceof Ql ? ve(at.sections) : at.eachChild(De));
                                }, Ze = j.value;
                                Ze._styleExpression && De(Ze._styleExpression.expression);
                            }
                            return ue;
                        }
                    }
                    let _C;
                    var Yx = {
                        get paint () {
                            return _C = _C || new le({
                                "background-color": new Da(ce.paint_background["background-color"]),
                                "background-pattern": new yc(ce.paint_background["background-pattern"]),
                                "background-opacity": new Da(ce.paint_background["background-opacity"])
                            });
                        }
                    };
                    class G9 extends B {
                        constructor(S){
                            super(S, Yx);
                        }
                    }
                    let sS;
                    var xC = {
                        get paint () {
                            return sS = sS || new le({
                                "raster-opacity": new Da(ce.paint_raster["raster-opacity"]),
                                "raster-hue-rotate": new Da(ce.paint_raster["raster-hue-rotate"]),
                                "raster-brightness-min": new Da(ce.paint_raster["raster-brightness-min"]),
                                "raster-brightness-max": new Da(ce.paint_raster["raster-brightness-max"]),
                                "raster-saturation": new Da(ce.paint_raster["raster-saturation"]),
                                "raster-contrast": new Da(ce.paint_raster["raster-contrast"]),
                                "raster-resampling": new Da(ce.paint_raster["raster-resampling"]),
                                "raster-fade-duration": new Da(ce.paint_raster["raster-fade-duration"])
                            });
                        }
                    };
                    class Kx extends B {
                        constructor(S){
                            super(S, xC);
                        }
                    }
                    class lS extends B {
                        constructor(S){
                            super(S, {}), this.onAdd = (D)=>{
                                this.implementation.onAdd && this.implementation.onAdd(D, D.painter.context.gl);
                            }, this.onRemove = (D)=>{
                                this.implementation.onRemove && this.implementation.onRemove(D, D.painter.context.gl);
                            }, this.implementation = S;
                        }
                        is3D() {
                            return this.implementation.renderingMode === "3d";
                        }
                        hasOffscreenPass() {
                            return this.implementation.prerender !== void 0;
                        }
                        recalculate() {}
                        updateTransitions() {}
                        hasTransition() {
                            return !1;
                        }
                        serialize() {
                            throw new Error("Custom layers cannot be serialized");
                        }
                    }
                    class uS {
                        constructor(S){
                            this._methodToThrottle = S, this._triggered = !1, typeof MessageChannel != "undefined" && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                                this._triggered = !1, this._methodToThrottle();
                            });
                        }
                        trigger() {
                            this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                                this._triggered = !1, this._methodToThrottle();
                            }, 0));
                        }
                        remove() {
                            delete this._channel, this._methodToThrottle = ()=>{};
                        }
                    }
                    let cS = 63710088e-1;
                    class dg {
                        constructor(S, D){
                            if (isNaN(S) || isNaN(D)) throw new Error(`Invalid LngLat object: (${S}, ${D})`);
                            if (this.lng = +S, this.lat = +D, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
                        }
                        wrap() {
                            return new dg(A(this.lng, -180, 180), this.lat);
                        }
                        toArray() {
                            return [
                                this.lng,
                                this.lat
                            ];
                        }
                        toString() {
                            return `LngLat(${this.lng}, ${this.lat})`;
                        }
                        distanceTo(S) {
                            let D = Math.PI / 180, j = this.lat * D, te = S.lat * D, ue = Math.sin(j) * Math.sin(te) + Math.cos(j) * Math.cos(te) * Math.cos((S.lng - this.lng) * D);
                            return cS * Math.acos(Math.min(ue, 1));
                        }
                        static convert(S) {
                            if (S instanceof dg) return S;
                            if (Array.isArray(S) && (S.length === 2 || S.length === 3)) return new dg(Number(S[0]), Number(S[1]));
                            if (!Array.isArray(S) && typeof S == "object" && S !== null) return new dg(Number("lng" in S ? S.lng : S.lon), Number(S.lat));
                            throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
                        }
                    }
                    let k1 = 2 * Math.PI * cS;
                    function bC(R) {
                        return k1 * Math.cos(R * Math.PI / 180);
                    }
                    function zw(R) {
                        return (180 + R) / 360;
                    }
                    function wC(R) {
                        return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + R * Math.PI / 360))) / 360;
                    }
                    function Fw(R, S) {
                        return R / bC(S);
                    }
                    function Jx(R) {
                        return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * R) * Math.PI / 180)) - 90;
                    }
                    class $x {
                        constructor(S, D, j = 0){
                            this.x = +S, this.y = +D, this.z = +j;
                        }
                        static fromLngLat(S, D = 0) {
                            let j = dg.convert(S);
                            return new $x(zw(j.lng), wC(j.lat), Fw(D, j.lat));
                        }
                        toLngLat() {
                            return new dg(360 * this.x - 180, Jx(this.y));
                        }
                        toAltitude() {
                            return this.z * bC(Jx(this.y));
                        }
                        meterInMercatorCoordinateUnits() {
                            var S;
                            return 1 / k1 * (S = Jx(this.y), 1 / Math.cos(S * Math.PI / 180));
                        }
                    }
                    function gp(R, S, D) {
                        var j = 2 * Math.PI * 6378137 / 256 / Math.pow(2, D);
                        return [
                            R * j - 2 * Math.PI * 6378137 / 2,
                            S * j - 2 * Math.PI * 6378137 / 2
                        ];
                    }
                    class fS {
                        constructor(S, D, j){
                            if (!function(te, ue, ve) {
                                return !(te < 0 || te > 25 || ve < 0 || ve >= Math.pow(2, te) || ue < 0 || ue >= Math.pow(2, te));
                            }(S, D, j)) throw new Error(`x=${D}, y=${j}, z=${S} outside of bounds. 0<=x<${Math.pow(2, S)}, 0<=y<${Math.pow(2, S)} 0<=z<=25 `);
                            this.z = S, this.x = D, this.y = j, this.key = Qx(0, S, S, D, j);
                        }
                        equals(S) {
                            return this.z === S.z && this.x === S.x && this.y === S.y;
                        }
                        url(S, D, j) {
                            let te = (ve = this.y, De = this.z, Ze = gp(256 * (ue = this.x), 256 * (ve = Math.pow(2, De) - ve - 1), De), at = gp(256 * (ue + 1), 256 * (ve + 1), De), Ze[0] + "," + Ze[1] + "," + at[0] + "," + at[1]);
                            var ue, ve, De, Ze, at;
                            let Tt = function(Ft, Qt, sr) {
                                let Tr, Pr = "";
                                for(let $r = Ft; $r > 0; $r--)Tr = 1 << $r - 1, Pr += (Qt & Tr ? 1 : 0) + (sr & Tr ? 2 : 0);
                                return Pr;
                            }(this.z, this.x, this.y);
                            return S[(this.x + this.y) % S.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String(j === "tms" ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, D > 1 ? "@2x" : "").replace(/{quadkey}/g, Tt).replace(/{bbox-epsg-3857}/g, te);
                        }
                        isChildOf(S) {
                            let D = this.z - S.z;
                            return D > 0 && S.x === this.x >> D && S.y === this.y >> D;
                        }
                        getTilePoint(S) {
                            let D = Math.pow(2, this.z);
                            return new u((S.x * D - this.x) * za, (S.y * D - this.y) * za);
                        }
                        toString() {
                            return `${this.z}/${this.x}/${this.y}`;
                        }
                    }
                    class TC {
                        constructor(S, D){
                            this.wrap = S, this.canonical = D, this.key = Qx(S, D.z, D.z, D.x, D.y);
                        }
                    }
                    class Jv {
                        constructor(S, D, j, te, ue){
                            if (S < j) throw new Error(`overscaledZ should be >= z; overscaledZ = ${S}; z = ${j}`);
                            this.overscaledZ = S, this.wrap = D, this.canonical = new fS(j, +te, +ue), this.key = Qx(D, S, j, te, ue);
                        }
                        clone() {
                            return new Jv(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
                        }
                        equals(S) {
                            return this.overscaledZ === S.overscaledZ && this.wrap === S.wrap && this.canonical.equals(S.canonical);
                        }
                        scaledTo(S) {
                            if (S > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${S}; overscaledZ = ${this.overscaledZ}`);
                            let D = this.canonical.z - S;
                            return S > this.canonical.z ? new Jv(S, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Jv(S, this.wrap, S, this.canonical.x >> D, this.canonical.y >> D);
                        }
                        calculateScaledKey(S, D) {
                            if (S > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${S}; overscaledZ = ${this.overscaledZ}`);
                            let j = this.canonical.z - S;
                            return S > this.canonical.z ? Qx(this.wrap * +D, S, this.canonical.z, this.canonical.x, this.canonical.y) : Qx(this.wrap * +D, S, S, this.canonical.x >> j, this.canonical.y >> j);
                        }
                        isChildOf(S) {
                            if (S.wrap !== this.wrap) return !1;
                            let D = this.canonical.z - S.canonical.z;
                            return S.overscaledZ === 0 || S.overscaledZ < this.overscaledZ && S.canonical.x === this.canonical.x >> D && S.canonical.y === this.canonical.y >> D;
                        }
                        children(S) {
                            if (this.overscaledZ >= S) return [
                                new Jv(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                            ];
                            let D = this.canonical.z + 1, j = 2 * this.canonical.x, te = 2 * this.canonical.y;
                            return [
                                new Jv(D, this.wrap, D, j, te),
                                new Jv(D, this.wrap, D, j + 1, te),
                                new Jv(D, this.wrap, D, j, te + 1),
                                new Jv(D, this.wrap, D, j + 1, te + 1)
                            ];
                        }
                        isLessThan(S) {
                            return this.wrap < S.wrap || !(this.wrap > S.wrap) && (this.overscaledZ < S.overscaledZ || !(this.overscaledZ > S.overscaledZ) && (this.canonical.x < S.canonical.x || !(this.canonical.x > S.canonical.x) && this.canonical.y < S.canonical.y));
                        }
                        wrapped() {
                            return new Jv(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
                        }
                        unwrapTo(S) {
                            return new Jv(this.overscaledZ, S, this.canonical.z, this.canonical.x, this.canonical.y);
                        }
                        overscaleFactor() {
                            return Math.pow(2, this.overscaledZ - this.canonical.z);
                        }
                        toUnwrapped() {
                            return new TC(this.wrap, this.canonical);
                        }
                        toString() {
                            return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
                        }
                        getTilePoint(S) {
                            return this.canonical.getTilePoint(new $x(S.x - this.wrap, S.y));
                        }
                    }
                    function Qx(R, S, D, j, te) {
                        (R *= 2) < 0 && (R = -1 * R - 1);
                        let ue = 1 << D;
                        return (ue * ue * R + ue * te + j).toString(36) + D.toString(36) + S.toString(36);
                    }
                    mi("CanonicalTileID", fS), mi("OverscaledTileID", Jv, {
                        omit: [
                            "posMatrix"
                        ]
                    });
                    class AC {
                        constructor(S, D, j, te = 1, ue = 1, ve = 1, De = 0){
                            if (this.uid = S, D.height !== D.width) throw new RangeError("DEM tiles must be square");
                            if (j && ![
                                "mapbox",
                                "terrarium",
                                "custom"
                            ].includes(j)) return void T(`"${j}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                            this.stride = D.height;
                            let Ze = this.dim = D.height - 2;
                            switch(this.data = new Uint32Array(D.data.buffer), j){
                                case "terrarium":
                                    this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                                    break;
                                case "custom":
                                    this.redFactor = te, this.greenFactor = ue, this.blueFactor = ve, this.baseShift = De;
                                    break;
                                default:
                                    this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                            }
                            for(let at = 0; at < Ze; at++)this.data[this._idx(-1, at)] = this.data[this._idx(0, at)], this.data[this._idx(Ze, at)] = this.data[this._idx(Ze - 1, at)], this.data[this._idx(at, -1)] = this.data[this._idx(at, 0)], this.data[this._idx(at, Ze)] = this.data[this._idx(at, Ze - 1)];
                            this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(Ze, -1)] = this.data[this._idx(Ze - 1, 0)], this.data[this._idx(-1, Ze)] = this.data[this._idx(0, Ze - 1)], this.data[this._idx(Ze, Ze)] = this.data[this._idx(Ze - 1, Ze - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                            for(let at = 0; at < Ze; at++)for(let Tt = 0; Tt < Ze; Tt++){
                                let Ft = this.get(at, Tt);
                                Ft > this.max && (this.max = Ft), Ft < this.min && (this.min = Ft);
                            }
                        }
                        get(S, D) {
                            let j = new Uint8Array(this.data.buffer), te = 4 * this._idx(S, D);
                            return this.unpack(j[te], j[te + 1], j[te + 2]);
                        }
                        getUnpackVector() {
                            return [
                                this.redFactor,
                                this.greenFactor,
                                this.blueFactor,
                                this.baseShift
                            ];
                        }
                        _idx(S, D) {
                            if (S < -1 || S >= this.dim + 1 || D < -1 || D >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                            return (D + 1) * this.stride + (S + 1);
                        }
                        unpack(S, D, j) {
                            return S * this.redFactor + D * this.greenFactor + j * this.blueFactor - this.baseShift;
                        }
                        getPixels() {
                            return new Jn({
                                width: this.stride,
                                height: this.stride
                            }, new Uint8Array(this.data.buffer));
                        }
                        backfillBorder(S, D, j) {
                            if (this.dim !== S.dim) throw new Error("dem dimension mismatch");
                            let te = D * this.dim, ue = D * this.dim + this.dim, ve = j * this.dim, De = j * this.dim + this.dim;
                            switch(D){
                                case -1:
                                    te = ue - 1;
                                    break;
                                case 1:
                                    ue = te + 1;
                            }
                            switch(j){
                                case -1:
                                    ve = De - 1;
                                    break;
                                case 1:
                                    De = ve + 1;
                            }
                            let Ze = -D * this.dim, at = -j * this.dim;
                            for(let Tt = ve; Tt < De; Tt++)for(let Ft = te; Ft < ue; Ft++)this.data[this._idx(Ft, Tt)] = S.data[this._idx(Ft + Ze, Tt + at)];
                        }
                    }
                    mi("DEMData", AC);
                    class SC {
                        constructor(S){
                            this._stringToNumber = {}, this._numberToString = [];
                            for(let D = 0; D < S.length; D++){
                                let j = S[D];
                                this._stringToNumber[j] = D, this._numberToString[D] = j;
                            }
                        }
                        encode(S) {
                            return this._stringToNumber[S];
                        }
                        decode(S) {
                            if (S >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${S} can't be >= this._numberToString.length ${this._numberToString.length}`);
                            return this._numberToString[S];
                        }
                    }
                    class hS {
                        constructor(S, D, j, te, ue){
                            this.type = "Feature", this._vectorTileFeature = S, S._z = D, S._x = j, S._y = te, this.properties = S.properties, this.id = ue;
                        }
                        get geometry() {
                            return this._geometry === void 0 && (this._geometry = this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x, this._vectorTileFeature._y, this._vectorTileFeature._z).geometry), this._geometry;
                        }
                        set geometry(S) {
                            this._geometry = S;
                        }
                        toJSON() {
                            let S = {
                                geometry: this.geometry
                            };
                            for(let D in this)D !== "_geometry" && D !== "_vectorTileFeature" && (S[D] = this[D]);
                            return S;
                        }
                    }
                    class cy {
                        constructor(S, D){
                            this.tileID = S, this.x = S.canonical.x, this.y = S.canonical.y, this.z = S.canonical.z, this.grid = new qi(za, 16, 0), this.grid3D = new qi(za, 16, 0), this.featureIndexArray = new As, this.promoteId = D;
                        }
                        insert(S, D, j, te, ue, ve) {
                            let De = this.featureIndexArray.length;
                            this.featureIndexArray.emplaceBack(j, te, ue);
                            let Ze = ve ? this.grid3D : this.grid;
                            for(let at = 0; at < D.length; at++){
                                let Tt = D[at], Ft = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ];
                                for(let Qt = 0; Qt < Tt.length; Qt++){
                                    let sr = Tt[Qt];
                                    Ft[0] = Math.min(Ft[0], sr.x), Ft[1] = Math.min(Ft[1], sr.y), Ft[2] = Math.max(Ft[2], sr.x), Ft[3] = Math.max(Ft[3], sr.y);
                                }
                                Ft[0] < za && Ft[1] < za && Ft[2] >= 0 && Ft[3] >= 0 && Ze.insert(De, Ft[0], Ft[1], Ft[2], Ft[3]);
                            }
                        }
                        loadVTLayers() {
                            return this.vtLayers || (this.vtLayers = new ei.VectorTile(new eS(this.rawTileData)).layers, this.sourceLayerCoder = new SC(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                                "_geojsonTileLayer"
                            ])), this.vtLayers;
                        }
                        query(S, D, j, te) {
                            this.loadVTLayers();
                            let ue = S.params || {}, ve = za / S.tileSize / S.scale, De = Pc(ue.filter), Ze = S.queryGeometry, at = S.queryPadding * ve, Tt = EC(Ze), Ft = this.grid.query(Tt.minX - at, Tt.minY - at, Tt.maxX + at, Tt.maxY + at), Qt = EC(S.cameraQueryGeometry), sr = this.grid3D.query(Qt.minX - at, Qt.minY - at, Qt.maxX + at, Qt.maxY + at, ($r, ni, Di, pi)=>(function(ki, Zi, ta, Va, Io) {
                                    for (let Hn of ki)if (Zi <= Hn.x && ta <= Hn.y && Va >= Hn.x && Io >= Hn.y) return !0;
                                    let La = [
                                        new u(Zi, ta),
                                        new u(Zi, Io),
                                        new u(Va, Io),
                                        new u(Va, ta)
                                    ];
                                    if (ki.length > 2) {
                                        for (let Hn of La)if (On(ki, Hn)) return !0;
                                    }
                                    for(let Hn = 0; Hn < ki.length - 1; Hn++)if (Bn(ki[Hn], ki[Hn + 1], La)) return !0;
                                    return !1;
                                })(S.cameraQueryGeometry, $r - at, ni - at, Di + at, pi + at));
                            for (let $r of sr)Ft.push($r);
                            Ft.sort(j9);
                            let Tr = {}, Pr;
                            for(let $r = 0; $r < Ft.length; $r++){
                                let ni = Ft[$r];
                                if (ni === Pr) continue;
                                Pr = ni;
                                let Di = this.featureIndexArray.get(ni), pi = null;
                                this.loadMatchingFeature(Tr, Di.bucketIndex, Di.sourceLayerIndex, Di.featureIndex, De, ue.layers, ue.availableImages, D, j, te, (ki, Zi, ta)=>(pi || (pi = js(ki)), Zi.queryIntersectsFeature(Ze, ki, ta, pi, this.z, S.transform, ve, S.pixelPosMatrix)));
                            }
                            return Tr;
                        }
                        loadMatchingFeature(S, D, j, te, ue, ve, De, Ze, at, Tt, Ft) {
                            let Qt = this.bucketLayerIDs[D];
                            if (ve && !function($r, ni) {
                                for(let Di = 0; Di < $r.length; Di++)if (ni.indexOf($r[Di]) >= 0) return !0;
                                return !1;
                            }(ve, Qt)) return;
                            let sr = this.sourceLayerCoder.decode(j), Tr = this.vtLayers[sr].feature(te);
                            if (ue.needGeometry) {
                                let $r = xl(Tr, !0);
                                if (!ue.filter(new Ko(this.tileID.overscaledZ), $r, this.tileID.canonical)) return;
                            } else if (!ue.filter(new Ko(this.tileID.overscaledZ), Tr)) return;
                            let Pr = this.getId(Tr, sr);
                            for(let $r = 0; $r < Qt.length; $r++){
                                let ni = Qt[$r];
                                if (ve && ve.indexOf(ni) < 0) continue;
                                let Di = Ze[ni];
                                if (!Di) continue;
                                let pi = {};
                                Pr && Tt && (pi = Tt.getState(Di.sourceLayer || "_geojsonTileLayer", Pr));
                                let ki = L({}, at[ni]);
                                ki.paint = MC(ki.paint, Di.paint, Tr, pi, De), ki.layout = MC(ki.layout, Di.layout, Tr, pi, De);
                                let Zi = !Ft || Ft(Tr, Di, pi);
                                if (!Zi) continue;
                                let ta = new hS(Tr, this.z, this.x, this.y, Pr);
                                ta.layer = ki;
                                let Va = S[ni];
                                Va === void 0 && (Va = S[ni] = []), Va.push({
                                    featureIndex: te,
                                    feature: ta,
                                    intersectionZ: Zi
                                });
                            }
                        }
                        lookupSymbolFeatures(S, D, j, te, ue, ve, De, Ze) {
                            let at = {};
                            this.loadVTLayers();
                            let Tt = Pc(ue);
                            for (let Ft of S)this.loadMatchingFeature(at, j, te, Ft, Tt, ve, De, Ze, D);
                            return at;
                        }
                        hasLayer(S) {
                            for (let D of this.bucketLayerIDs)for (let j of D)if (S === j) return !0;
                            return !1;
                        }
                        getId(S, D) {
                            let j = S.id;
                            return this.promoteId && (j = S.properties[typeof this.promoteId == "string" ? this.promoteId : this.promoteId[D]], typeof j == "boolean" && (j = Number(j))), j;
                        }
                    }
                    function MC(R, S, D, j, te) {
                        return C(R, (ue, ve)=>{
                            let De = S instanceof Dc ? S.get(ve) : null;
                            return De && De.evaluate ? De.evaluate(D, j, te) : De;
                        });
                    }
                    function EC(R) {
                        let S = 1 / 0, D = 1 / 0, j = -1 / 0, te = -1 / 0;
                        for (let ue of R)S = Math.min(S, ue.x), D = Math.min(D, ue.y), j = Math.max(j, ue.x), te = Math.max(te, ue.y);
                        return {
                            minX: S,
                            minY: D,
                            maxX: j,
                            maxY: te
                        };
                    }
                    function j9(R, S) {
                        return S - R;
                    }
                    function kC(R, S, D, j, te) {
                        let ue = [];
                        for(let ve = 0; ve < R.length; ve++){
                            let De = R[ve], Ze;
                            for(let at = 0; at < De.length - 1; at++){
                                let Tt = De[at], Ft = De[at + 1];
                                Tt.x < S && Ft.x < S || (Tt.x < S ? Tt = new u(S, Tt.y + (S - Tt.x) / (Ft.x - Tt.x) * (Ft.y - Tt.y))._round() : Ft.x < S && (Ft = new u(S, Tt.y + (S - Tt.x) / (Ft.x - Tt.x) * (Ft.y - Tt.y))._round()), Tt.y < D && Ft.y < D || (Tt.y < D ? Tt = new u(Tt.x + (D - Tt.y) / (Ft.y - Tt.y) * (Ft.x - Tt.x), D)._round() : Ft.y < D && (Ft = new u(Tt.x + (D - Tt.y) / (Ft.y - Tt.y) * (Ft.x - Tt.x), D)._round()), Tt.x >= j && Ft.x >= j || (Tt.x >= j ? Tt = new u(j, Tt.y + (j - Tt.x) / (Ft.x - Tt.x) * (Ft.y - Tt.y))._round() : Ft.x >= j && (Ft = new u(j, Tt.y + (j - Tt.x) / (Ft.x - Tt.x) * (Ft.y - Tt.y))._round()), Tt.y >= te && Ft.y >= te || (Tt.y >= te ? Tt = new u(Tt.x + (te - Tt.y) / (Ft.y - Tt.y) * (Ft.x - Tt.x), te)._round() : Ft.y >= te && (Ft = new u(Tt.x + (te - Tt.y) / (Ft.y - Tt.y) * (Ft.x - Tt.x), te)._round()), Ze && Tt.equals(Ze[Ze.length - 1]) || (Ze = [
                                    Tt
                                ], ue.push(Ze)), Ze.push(Ft)))));
                            }
                        }
                        return ue;
                    }
                    mi("FeatureIndex", cy, {
                        omit: [
                            "rawTileData",
                            "sourceLayerCoder"
                        ]
                    });
                    class vg extends u {
                        constructor(S, D, j, te){
                            super(S, D), this.angle = j, te !== void 0 && (this.segment = te);
                        }
                        clone() {
                            return new vg(this.x, this.y, this.angle, this.segment);
                        }
                    }
                    function dS(R, S, D, j, te) {
                        if (S.segment === void 0 || D === 0) return !0;
                        let ue = S, ve = S.segment + 1, De = 0;
                        for(; De > -D / 2;){
                            if (ve--, ve < 0) return !1;
                            De -= R[ve].dist(ue), ue = R[ve];
                        }
                        De += R[ve].dist(R[ve + 1]), ve++;
                        let Ze = [], at = 0;
                        for(; De < D / 2;){
                            let Tt = R[ve], Ft = R[ve + 1];
                            if (!Ft) return !1;
                            let Qt = R[ve - 1].angleTo(Tt) - Tt.angleTo(Ft);
                            for(Qt = Math.abs((Qt + 3 * Math.PI) % (2 * Math.PI) - Math.PI), Ze.push({
                                distance: De,
                                angleDelta: Qt
                            }), at += Qt; De - Ze[0].distance > j;)at -= Ze.shift().angleDelta;
                            if (at > te) return !1;
                            ve++, De += Tt.dist(Ft);
                        }
                        return !0;
                    }
                    function CC(R) {
                        let S = 0;
                        for(let D = 0; D < R.length - 1; D++)S += R[D].dist(R[D + 1]);
                        return S;
                    }
                    function LC(R, S, D) {
                        return R ? .6 * S * D : 0;
                    }
                    function PC(R, S) {
                        return Math.max(R ? R.right - R.left : 0, S ? S.right - S.left : 0);
                    }
                    function W9(R, S, D, j, te, ue) {
                        let ve = LC(D, te, ue), De = PC(D, j) * ue, Ze = 0, at = CC(R) / 2;
                        for(let Tt = 0; Tt < R.length - 1; Tt++){
                            let Ft = R[Tt], Qt = R[Tt + 1], sr = Ft.dist(Qt);
                            if (Ze + sr > at) {
                                let Tr = (at - Ze) / sr, Pr = Mo.number(Ft.x, Qt.x, Tr), $r = Mo.number(Ft.y, Qt.y, Tr), ni = new vg(Pr, $r, Qt.angleTo(Ft), Tt);
                                return ni._round(), !ve || dS(R, ni, De, ve, S) ? ni : void 0;
                            }
                            Ze += sr;
                        }
                    }
                    function Z9(R, S, D, j, te, ue, ve, De, Ze) {
                        let at = LC(j, ue, ve), Tt = PC(j, te), Ft = Tt * ve, Qt = R[0].x === 0 || R[0].x === Ze || R[0].y === 0 || R[0].y === Ze;
                        return S - Ft < S / 4 && (S = Ft + S / 4), IC(R, Qt ? S / 2 * De % S : (Tt / 2 + 2 * ue) * ve * De % S, S, at, D, Ft, Qt, !1, Ze);
                    }
                    function IC(R, S, D, j, te, ue, ve, De, Ze) {
                        let at = ue / 2, Tt = CC(R), Ft = 0, Qt = S - D, sr = [];
                        for(let Tr = 0; Tr < R.length - 1; Tr++){
                            let Pr = R[Tr], $r = R[Tr + 1], ni = Pr.dist($r), Di = $r.angleTo(Pr);
                            for(; Qt + D < Ft + ni;){
                                Qt += D;
                                let pi = (Qt - Ft) / ni, ki = Mo.number(Pr.x, $r.x, pi), Zi = Mo.number(Pr.y, $r.y, pi);
                                if (ki >= 0 && ki < Ze && Zi >= 0 && Zi < Ze && Qt - at >= 0 && Qt + at <= Tt) {
                                    let ta = new vg(ki, Zi, Di, Tr);
                                    ta._round(), j && !dS(R, ta, ue, j, te) || sr.push(ta);
                                }
                            }
                            Ft += ni;
                        }
                        return De || sr.length || ve || (sr = IC(R, Ft / 2, D, j, te, ue, ve, !0, Ze)), sr;
                    }
                    mi("Anchor", vg);
                    let C1 = wd;
                    function RC(R, S, D, j) {
                        let te = [], ue = R.image, ve = ue.pixelRatio, De = ue.paddedRect.w - 2 * C1, Ze = ue.paddedRect.h - 2 * C1, at = {
                            x1: R.left,
                            y1: R.top,
                            x2: R.right,
                            y2: R.bottom
                        }, Tt = ue.stretchX || [
                            [
                                0,
                                De
                            ]
                        ], Ft = ue.stretchY || [
                            [
                                0,
                                Ze
                            ]
                        ], Qt = (Tn, bo)=>Tn + bo[1] - bo[0], sr = Tt.reduce(Qt, 0), Tr = Ft.reduce(Qt, 0), Pr = De - sr, $r = Ze - Tr, ni = 0, Di = sr, pi = 0, ki = Tr, Zi = 0, ta = Pr, Va = 0, Io = $r;
                        if (ue.content && j) {
                            let Tn = ue.content, bo = Tn[2] - Tn[0], Ya = Tn[3] - Tn[1];
                            (ue.textFitWidth || ue.textFitHeight) && (at = gC(R)), ni = pg(Tt, 0, Tn[0]), pi = pg(Ft, 0, Tn[1]), Di = pg(Tt, Tn[0], Tn[2]), ki = pg(Ft, Tn[1], Tn[3]), Zi = Tn[0] - ni, Va = Tn[1] - pi, ta = bo - Di, Io = Ya - ki;
                        }
                        let La = at.x1, Hn = at.y1, lo = at.x2 - La, $a = at.y2 - Hn, Xa = (Tn, bo, Ya, Uo)=>{
                            let wu = qw(Tn.stretch - ni, Di, lo, La), hu = L1(Tn.fixed - Zi, ta, Tn.stretch, sr), uh = qw(bo.stretch - pi, ki, $a, Hn), $v = L1(bo.fixed - Va, Io, bo.stretch, Tr), td = qw(Ya.stretch - ni, Di, lo, La), ch = L1(Ya.fixed - Zi, ta, Ya.stretch, sr), Ud = qw(Uo.stretch - pi, ki, $a, Hn), Vd = L1(Uo.fixed - Va, Io, Uo.stretch, Tr), Hd = new u(wu, uh), rf = new u(td, uh), fh = new u(td, Ud), Td = new u(wu, Ud), rd = new u(hu / ve, $v / ve), Dh = new u(ch / ve, Vd / ve), xf = S * Math.PI / 180;
                            if (xf) {
                                let Cl = Math.sin(xf), qu = Math.cos(xf), Tu = [
                                    qu,
                                    -Cl,
                                    Cl,
                                    qu
                                ];
                                Hd._matMult(Tu), rf._matMult(Tu), Td._matMult(Tu), fh._matMult(Tu);
                            }
                            let Iv = Tn.stretch + Tn.fixed, lv = bo.stretch + bo.fixed;
                            return {
                                tl: Hd,
                                tr: rf,
                                bl: Td,
                                br: fh,
                                tex: {
                                    x: ue.paddedRect.x + C1 + Iv,
                                    y: ue.paddedRect.y + C1 + lv,
                                    w: Ya.stretch + Ya.fixed - Iv,
                                    h: Uo.stretch + Uo.fixed - lv
                                },
                                writingMode: void 0,
                                glyphOffset: [
                                    0,
                                    0
                                ],
                                sectionIndex: 0,
                                pixelOffsetTL: rd,
                                pixelOffsetBR: Dh,
                                minFontScaleX: ta / ve / lo,
                                minFontScaleY: Io / ve / $a,
                                isSDF: D
                            };
                        };
                        if (j && (ue.stretchX || ue.stretchY)) {
                            let Tn = DC(Tt, Pr, sr), bo = DC(Ft, $r, Tr);
                            for(let Ya = 0; Ya < Tn.length - 1; Ya++){
                                let Uo = Tn[Ya], wu = Tn[Ya + 1];
                                for(let hu = 0; hu < bo.length - 1; hu++)te.push(Xa(Uo, bo[hu], wu, bo[hu + 1]));
                            }
                        } else te.push(Xa({
                            fixed: 0,
                            stretch: -1
                        }, {
                            fixed: 0,
                            stretch: -1
                        }, {
                            fixed: 0,
                            stretch: De + 1
                        }, {
                            fixed: 0,
                            stretch: Ze + 1
                        }));
                        return te;
                    }
                    function pg(R, S, D) {
                        let j = 0;
                        for (let te of R)j += Math.max(S, Math.min(D, te[1])) - Math.max(S, Math.min(D, te[0]));
                        return j;
                    }
                    function DC(R, S, D) {
                        let j = [
                            {
                                fixed: -C1,
                                stretch: 0
                            }
                        ];
                        for (let [te, ue] of R){
                            let ve = j[j.length - 1];
                            j.push({
                                fixed: te - ve.stretch,
                                stretch: ve.stretch
                            }), j.push({
                                fixed: te - ve.stretch,
                                stretch: ve.stretch + (ue - te)
                            });
                        }
                        return j.push({
                            fixed: S + C1,
                            stretch: D
                        }), j;
                    }
                    function qw(R, S, D, j) {
                        return R / S * D + j;
                    }
                    function L1(R, S, D, j) {
                        return R - S * D / j;
                    }
                    class cm {
                        constructor(S, D, j, te, ue, ve, De, Ze, at, Tt){
                            var Ft;
                            if (this.boxStartIndex = S.length, at) {
                                let Qt = ve.top, sr = ve.bottom, Tr = ve.collisionPadding;
                                Tr && (Qt -= Tr[1], sr += Tr[3]);
                                let Pr = sr - Qt;
                                Pr > 0 && (Pr = Math.max(10, Pr), this.circleDiameter = Pr);
                            } else {
                                let Qt = !((Ft = ve.image) === null || Ft === void 0) && Ft.content && (ve.image.textFitWidth || ve.image.textFitHeight) ? gC(ve) : {
                                    x1: ve.left,
                                    y1: ve.top,
                                    x2: ve.right,
                                    y2: ve.bottom
                                };
                                Qt.y1 = Qt.y1 * De - Ze[0], Qt.y2 = Qt.y2 * De + Ze[2], Qt.x1 = Qt.x1 * De - Ze[3], Qt.x2 = Qt.x2 * De + Ze[1];
                                let sr = ve.collisionPadding;
                                if (sr && (Qt.x1 -= sr[0] * De, Qt.y1 -= sr[1] * De, Qt.x2 += sr[2] * De, Qt.y2 += sr[3] * De), Tt) {
                                    let Tr = new u(Qt.x1, Qt.y1), Pr = new u(Qt.x2, Qt.y1), $r = new u(Qt.x1, Qt.y2), ni = new u(Qt.x2, Qt.y2), Di = Tt * Math.PI / 180;
                                    Tr._rotate(Di), Pr._rotate(Di), $r._rotate(Di), ni._rotate(Di), Qt.x1 = Math.min(Tr.x, Pr.x, $r.x, ni.x), Qt.x2 = Math.max(Tr.x, Pr.x, $r.x, ni.x), Qt.y1 = Math.min(Tr.y, Pr.y, $r.y, ni.y), Qt.y2 = Math.max(Tr.y, Pr.y, $r.y, ni.y);
                                }
                                S.emplaceBack(D.x, D.y, Qt.x1, Qt.y1, Qt.x2, Qt.y2, j, te, ue);
                            }
                            this.boxEndIndex = S.length;
                        }
                    }
                    class Hp {
                        constructor(S = [], D = (j, te)=>j < te ? -1 : j > te ? 1 : 0){
                            if (this.data = S, this.length = this.data.length, this.compare = D, this.length > 0) for(let j = (this.length >> 1) - 1; j >= 0; j--)this._down(j);
                        }
                        push(S) {
                            this.data.push(S), this._up(this.length++);
                        }
                        pop() {
                            if (this.length === 0) return;
                            let S = this.data[0], D = this.data.pop();
                            return --this.length > 0 && (this.data[0] = D, this._down(0)), S;
                        }
                        peek() {
                            return this.data[0];
                        }
                        _up(S) {
                            let { data: D, compare: j } = this, te = D[S];
                            for(; S > 0;){
                                let ue = S - 1 >> 1, ve = D[ue];
                                if (j(te, ve) >= 0) break;
                                D[S] = ve, S = ue;
                            }
                            D[S] = te;
                        }
                        _down(S) {
                            let { data: D, compare: j } = this, te = this.length >> 1, ue = D[S];
                            for(; S < te;){
                                let ve = 1 + (S << 1), De = ve + 1;
                                if (De < this.length && j(D[De], D[ve]) < 0 && (ve = De), j(D[ve], ue) >= 0) break;
                                D[S] = D[ve], S = ve;
                            }
                            D[S] = ue;
                        }
                    }
                    function X9(R, S = 1, D = !1) {
                        let j = 1 / 0, te = 1 / 0, ue = -1 / 0, ve = -1 / 0, De = R[0];
                        for(let sr = 0; sr < De.length; sr++){
                            let Tr = De[sr];
                            (!sr || Tr.x < j) && (j = Tr.x), (!sr || Tr.y < te) && (te = Tr.y), (!sr || Tr.x > ue) && (ue = Tr.x), (!sr || Tr.y > ve) && (ve = Tr.y);
                        }
                        let Ze = Math.min(ue - j, ve - te), at = Ze / 2, Tt = new Hp([], Y9);
                        if (Ze === 0) return new u(j, te);
                        for(let sr = j; sr < ue; sr += Ze)for(let Tr = te; Tr < ve; Tr += Ze)Tt.push(new P1(sr + at, Tr + at, at, R));
                        let Ft = function(sr) {
                            let Tr = 0, Pr = 0, $r = 0, ni = sr[0];
                            for(let Di = 0, pi = ni.length, ki = pi - 1; Di < pi; ki = Di++){
                                let Zi = ni[Di], ta = ni[ki], Va = Zi.x * ta.y - ta.x * Zi.y;
                                Pr += (Zi.x + ta.x) * Va, $r += (Zi.y + ta.y) * Va, Tr += 3 * Va;
                            }
                            return new P1(Pr / Tr, $r / Tr, 0, sr);
                        }(R), Qt = Tt.length;
                        for(; Tt.length;){
                            let sr = Tt.pop();
                            (sr.d > Ft.d || !Ft.d) && (Ft = sr, D && console.log("found best %d after %d probes", Math.round(1e4 * sr.d) / 1e4, Qt)), sr.max - Ft.d <= S || (at = sr.h / 2, Tt.push(new P1(sr.p.x - at, sr.p.y - at, at, R)), Tt.push(new P1(sr.p.x + at, sr.p.y - at, at, R)), Tt.push(new P1(sr.p.x - at, sr.p.y + at, at, R)), Tt.push(new P1(sr.p.x + at, sr.p.y + at, at, R)), Qt += 4);
                        }
                        return D && (console.log(`num probes: ${Qt}`), console.log(`best distance: ${Ft.d}`)), Ft.p;
                    }
                    function Y9(R, S) {
                        return S.max - R.max;
                    }
                    function P1(R, S, D, j) {
                        this.p = new u(R, S), this.h = D, this.d = function(te, ue) {
                            let ve = !1, De = 1 / 0;
                            for(let Ze = 0; Ze < ue.length; Ze++){
                                let at = ue[Ze];
                                for(let Tt = 0, Ft = at.length, Qt = Ft - 1; Tt < Ft; Qt = Tt++){
                                    let sr = at[Tt], Tr = at[Qt];
                                    sr.y > te.y != Tr.y > te.y && te.x < (Tr.x - sr.x) * (te.y - sr.y) / (Tr.y - sr.y) + sr.x && (ve = !ve), De = Math.min(De, Bi(te, sr, Tr));
                                }
                            }
                            return (ve ? 1 : -1) * Math.sqrt(De);
                        }(this.p, j), this.max = this.d + this.h * Math.SQRT2;
                    }
                    var ed;
                    i.aq = void 0, (ed = i.aq || (i.aq = {}))[ed.center = 1] = "center", ed[ed.left = 2] = "left", ed[ed.right = 3] = "right", ed[ed.top = 4] = "top", ed[ed.bottom = 5] = "bottom", ed[ed["top-left"] = 6] = "top-left", ed[ed["top-right"] = 7] = "top-right", ed[ed["bottom-left"] = 8] = "bottom-left", ed[ed["bottom-right"] = 9] = "bottom-right";
                    let fm = 7, fy = Number.POSITIVE_INFINITY;
                    function vS(R, S) {
                        return S[1] !== fy ? function(D, j, te) {
                            let ue = 0, ve = 0;
                            switch(j = Math.abs(j), te = Math.abs(te), D){
                                case "top-right":
                                case "top-left":
                                case "top":
                                    ve = te - fm;
                                    break;
                                case "bottom-right":
                                case "bottom-left":
                                case "bottom":
                                    ve = -te + fm;
                            }
                            switch(D){
                                case "top-right":
                                case "bottom-right":
                                case "right":
                                    ue = -j;
                                    break;
                                case "top-left":
                                case "bottom-left":
                                case "left":
                                    ue = j;
                            }
                            return [
                                ue,
                                ve
                            ];
                        }(R, S[0], S[1]) : function(D, j) {
                            let te = 0, ue = 0;
                            j < 0 && (j = 0);
                            let ve = j / Math.SQRT2;
                            switch(D){
                                case "top-right":
                                case "top-left":
                                    ue = ve - fm;
                                    break;
                                case "bottom-right":
                                case "bottom-left":
                                    ue = -ve + fm;
                                    break;
                                case "bottom":
                                    ue = -j + fm;
                                    break;
                                case "top":
                                    ue = j - fm;
                            }
                            switch(D){
                                case "top-right":
                                case "bottom-right":
                                    te = -ve;
                                    break;
                                case "top-left":
                                case "bottom-left":
                                    te = ve;
                                    break;
                                case "left":
                                    te = j;
                                    break;
                                case "right":
                                    te = -j;
                            }
                            return [
                                te,
                                ue
                            ];
                        }(R, S[0]);
                    }
                    function zC(R, S, D) {
                        var j;
                        let te = R.layout, ue = (j = te.get("text-variable-anchor-offset")) === null || j === void 0 ? void 0 : j.evaluate(S, {}, D);
                        if (ue) {
                            let De = ue.values, Ze = [];
                            for(let at = 0; at < De.length; at += 2){
                                let Tt = Ze[at] = De[at], Ft = De[at + 1].map((Qt)=>Qt * kl);
                                Tt.startsWith("top") ? Ft[1] -= fm : Tt.startsWith("bottom") && (Ft[1] += fm), Ze[at + 1] = Ft;
                            }
                            return new Si(Ze);
                        }
                        let ve = te.get("text-variable-anchor");
                        if (ve) {
                            let De;
                            De = R._unevaluatedLayout.getValue("text-radial-offset") !== void 0 ? [
                                te.get("text-radial-offset").evaluate(S, {}, D) * kl,
                                fy
                            ] : te.get("text-offset").evaluate(S, {}, D).map((at)=>at * kl);
                            let Ze = [];
                            for (let at of ve)Ze.push(at, vS(at, De));
                            return new Si(Ze);
                        }
                        return null;
                    }
                    function pS(R) {
                        switch(R){
                            case "right":
                            case "top-right":
                            case "bottom-right":
                                return "right";
                            case "left":
                            case "top-left":
                            case "bottom-left":
                                return "left";
                        }
                        return "center";
                    }
                    function K9(R, S, D, j, te, ue, ve, De, Ze, at, Tt) {
                        let Ft = ue.textMaxSize.evaluate(S, {});
                        Ft === void 0 && (Ft = ve);
                        let Qt = R.layers[0].layout, sr = Qt.get("icon-offset").evaluate(S, {}, Tt), Tr = qC(D.horizontal), Pr = ve / 24, $r = R.tilePixelRatio * Pr, ni = R.tilePixelRatio * Ft / 24, Di = R.tilePixelRatio * De, pi = R.tilePixelRatio * Qt.get("symbol-spacing"), ki = Qt.get("text-padding") * R.tilePixelRatio, Zi = function(Tn, bo, Ya, Uo = 1) {
                            let wu = Tn.get("icon-padding").evaluate(bo, {}, Ya), hu = wu && wu.values;
                            return [
                                hu[0] * Uo,
                                hu[1] * Uo,
                                hu[2] * Uo,
                                hu[3] * Uo
                            ];
                        }(Qt, S, Tt, R.tilePixelRatio), ta = Qt.get("text-max-angle") / 180 * Math.PI, Va = Qt.get("text-rotation-alignment") !== "viewport" && Qt.get("symbol-placement") !== "point", Io = Qt.get("icon-rotation-alignment") === "map" && Qt.get("symbol-placement") !== "point", La = Qt.get("symbol-placement"), Hn = pi / 2, lo = Qt.get("icon-text-fit"), $a;
                        j && lo !== "none" && (R.allowVerticalPlacement && D.vertical && ($a = mC(j, D.vertical, lo, Qt.get("icon-text-fit-padding"), sr, Pr)), Tr && (j = mC(j, Tr, lo, Qt.get("icon-text-fit-padding"), sr, Pr)));
                        let Xa = (Tn, bo)=>{
                            bo.x < 0 || bo.x >= za || bo.y < 0 || bo.y >= za || function(Ya, Uo, wu, hu, uh, $v, td, ch, Ud, Vd, Hd, rf, fh, Td, rd, Dh, xf, Iv, lv, Cl, qu, Tu, Rv, qc, I1) {
                                let p0 = Ya.addToLineVertexArray(Uo, wu), Gp, Qv, oc, If, ep = 0, gg = 0, uv = 0, R1 = 0, xS = -1, Uw = -1, g0 = {}, hy = ui("");
                                if (Ya.allowVerticalPlacement && hu.vertical) {
                                    let Ad = ch.layout.get("text-rotate").evaluate(qu, {}, qc) + 90;
                                    oc = new cm(Ud, Uo, Vd, Hd, rf, hu.vertical, fh, Td, rd, Ad), td && (If = new cm(Ud, Uo, Vd, Hd, rf, td, xf, Iv, rd, Ad));
                                }
                                if (uh) {
                                    let Ad = ch.layout.get("icon-rotate").evaluate(qu, {}), tp = ch.layout.get("icon-text-fit") !== "none", hm = RC(uh, Ad, Rv, tp), Gd = td ? RC(td, Ad, Rv, tp) : void 0;
                                    Qv = new cm(Ud, Uo, Vd, Hd, rf, uh, xf, Iv, !1, Ad), ep = 4 * hm.length;
                                    let Sd = Ya.iconSizeData, yp = null;
                                    Sd.kind === "source" ? (yp = [
                                        v0 * ch.layout.get("icon-size").evaluate(qu, {})
                                    ], yp[0] > lm && T(`${Ya.layerIds[0]}: Value for "icon-size" is >= ${Wx}. Reduce your "icon-size".`)) : Sd.kind === "composite" && (yp = [
                                        v0 * Tu.compositeIconSizes[0].evaluate(qu, {}, qc),
                                        v0 * Tu.compositeIconSizes[1].evaluate(qu, {}, qc)
                                    ], (yp[0] > lm || yp[1] > lm) && T(`${Ya.layerIds[0]}: Value for "icon-size" is >= ${Wx}. Reduce your "icon-size".`)), Ya.addSymbols(Ya.icon, hm, yp, Cl, lv, qu, i.ah.none, Uo, p0.lineStartIndex, p0.lineLength, -1, qc), xS = Ya.icon.placedSymbolArray.length - 1, Gd && (gg = 4 * Gd.length, Ya.addSymbols(Ya.icon, Gd, yp, Cl, lv, qu, i.ah.vertical, Uo, p0.lineStartIndex, p0.lineLength, -1, qc), Uw = Ya.icon.placedSymbolArray.length - 1);
                                }
                                let zh = Object.keys(hu.horizontal);
                                for (let Ad of zh){
                                    let tp = hu.horizontal[Ad];
                                    if (!Gp) {
                                        hy = ui(tp.text);
                                        let Gd = ch.layout.get("text-rotate").evaluate(qu, {}, qc);
                                        Gp = new cm(Ud, Uo, Vd, Hd, rf, tp, fh, Td, rd, Gd);
                                    }
                                    let hm = tp.positionedLines.length === 1;
                                    if (uv += FC(Ya, Uo, tp, $v, ch, rd, qu, Dh, p0, hu.vertical ? i.ah.horizontal : i.ah.horizontalOnly, hm ? zh : [
                                        Ad
                                    ], g0, xS, Tu, qc), hm) break;
                                }
                                hu.vertical && (R1 += FC(Ya, Uo, hu.vertical, $v, ch, rd, qu, Dh, p0, i.ah.vertical, [
                                    "vertical"
                                ], g0, Uw, Tu, qc));
                                let Q9 = Gp ? Gp.boxStartIndex : Ya.collisionBoxArray.length, Vw = Gp ? Gp.boxEndIndex : Ya.collisionBoxArray.length, m0 = oc ? oc.boxStartIndex : Ya.collisionBoxArray.length, cv = oc ? oc.boxEndIndex : Ya.collisionBoxArray.length, UC = Qv ? Qv.boxStartIndex : Ya.collisionBoxArray.length, eq = Qv ? Qv.boxEndIndex : Ya.collisionBoxArray.length, VC = If ? If.boxStartIndex : Ya.collisionBoxArray.length, tq = If ? If.boxEndIndex : Ya.collisionBoxArray.length, mp = -1, rb = (Ad, tp)=>Ad && Ad.circleDiameter ? Math.max(Ad.circleDiameter, tp) : tp;
                                mp = rb(Gp, mp), mp = rb(oc, mp), mp = rb(Qv, mp), mp = rb(If, mp);
                                let Hw = mp > -1 ? 1 : 0;
                                Hw && (mp *= I1 / kl), Ya.glyphOffsetArray.length >= E1.MAX_GLYPHS && T("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), qu.sortKey !== void 0 && Ya.addToSortKeyRanges(Ya.symbolInstances.length, qu.sortKey);
                                let bS = zC(ch, qu, qc), [rq, iq] = function(Ad, tp) {
                                    let hm = Ad.length, Gd = tp == null ? void 0 : tp.values;
                                    if ((Gd == null ? void 0 : Gd.length) > 0) for(let Sd = 0; Sd < Gd.length; Sd += 2){
                                        let yp = Gd[Sd + 1];
                                        Ad.emplaceBack(i.aq[Gd[Sd]], yp[0], yp[1]);
                                    }
                                    return [
                                        hm,
                                        Ad.length
                                    ];
                                }(Ya.textAnchorOffsets, bS);
                                Ya.symbolInstances.emplaceBack(Uo.x, Uo.y, g0.right >= 0 ? g0.right : -1, g0.center >= 0 ? g0.center : -1, g0.left >= 0 ? g0.left : -1, g0.vertical || -1, xS, Uw, hy, Q9, Vw, m0, cv, UC, eq, VC, tq, Vd, uv, R1, ep, gg, Hw, 0, fh, mp, rq, iq);
                            }(R, bo, Tn, D, j, te, $a, R.layers[0], R.collisionBoxArray, S.index, S.sourceLayerIndex, R.index, $r, [
                                ki,
                                ki,
                                ki,
                                ki
                            ], Va, Ze, Di, Zi, Io, sr, S, ue, at, Tt, ve);
                        };
                        if (La === "line") for (let Tn of kC(S.geometry, 0, 0, za, za)){
                            let bo = Z9(Tn, pi, ta, D.vertical || Tr, j, 24, ni, R.overscaling, za);
                            for (let Ya of bo)Tr && J9(R, Tr.text, Hn, Ya) || Xa(Tn, Ya);
                        }
                        else if (La === "line-center") {
                            for (let Tn of S.geometry)if (Tn.length > 1) {
                                let bo = W9(Tn, ta, D.vertical || Tr, j, 24, ni);
                                bo && Xa(Tn, bo);
                            }
                        } else if (S.type === "Polygon") for (let Tn of Of(S.geometry, 0)){
                            let bo = X9(Tn, 16);
                            Xa(Tn[0], new vg(bo.x, bo.y, 0));
                        }
                        else if (S.type === "LineString") for (let Tn of S.geometry)Xa(Tn, new vg(Tn[0].x, Tn[0].y, 0));
                        else if (S.type === "Point") for (let Tn of S.geometry)for (let bo of Tn)Xa([
                            bo
                        ], new vg(bo.x, bo.y, 0));
                    }
                    function FC(R, S, D, j, te, ue, ve, De, Ze, at, Tt, Ft, Qt, sr, Tr) {
                        let Pr = function(Di, pi, ki, Zi, ta, Va, Io, La) {
                            let Hn = Zi.layout.get("text-rotate").evaluate(Va, {}) * Math.PI / 180, lo = [];
                            for (let $a of pi.positionedLines)for (let Xa of $a.positionedGlyphs){
                                if (!Xa.rect) continue;
                                let Tn = Xa.rect || {}, bo = hC + 1, Ya = !0, Uo = 1, wu = 0, hu = (ta || La) && Xa.vertical, uh = Xa.metrics.advance * Xa.scale / 2;
                                if (La && pi.verticalizable && (wu = $a.lineOffset / 2 - (Xa.imageName ? -(kl - Xa.metrics.width * Xa.scale) / 2 : (Xa.scale - 1) * kl)), Xa.imageName) {
                                    let Cl = Io[Xa.imageName];
                                    Ya = Cl.sdf, Uo = Cl.pixelRatio, bo = wd / Uo;
                                }
                                let $v = ta ? [
                                    Xa.x + uh,
                                    Xa.y
                                ] : [
                                    0,
                                    0
                                ], td = ta ? [
                                    0,
                                    0
                                ] : [
                                    Xa.x + uh + ki[0],
                                    Xa.y + ki[1] - wu
                                ], ch = [
                                    0,
                                    0
                                ];
                                hu && (ch = td, td = [
                                    0,
                                    0
                                ]);
                                let Ud = Xa.metrics.isDoubleResolution ? 2 : 1, Vd = (Xa.metrics.left - bo) * Xa.scale - uh + td[0], Hd = (-Xa.metrics.top - bo) * Xa.scale + td[1], rf = Vd + Tn.w / Ud * Xa.scale / Uo, fh = Hd + Tn.h / Ud * Xa.scale / Uo, Td = new u(Vd, Hd), rd = new u(rf, Hd), Dh = new u(Vd, fh), xf = new u(rf, fh);
                                if (hu) {
                                    let Cl = new u(-uh, uh - lh), qu = -Math.PI / 2, Tu = kl / 2 - uh, Rv = new u(5 - lh - Tu, -(Xa.imageName ? Tu : 0)), qc = new u(...ch);
                                    Td._rotateAround(qu, Cl)._add(Rv)._add(qc), rd._rotateAround(qu, Cl)._add(Rv)._add(qc), Dh._rotateAround(qu, Cl)._add(Rv)._add(qc), xf._rotateAround(qu, Cl)._add(Rv)._add(qc);
                                }
                                if (Hn) {
                                    let Cl = Math.sin(Hn), qu = Math.cos(Hn), Tu = [
                                        qu,
                                        -Cl,
                                        Cl,
                                        qu
                                    ];
                                    Td._matMult(Tu), rd._matMult(Tu), Dh._matMult(Tu), xf._matMult(Tu);
                                }
                                let Iv = new u(0, 0), lv = new u(0, 0);
                                lo.push({
                                    tl: Td,
                                    tr: rd,
                                    bl: Dh,
                                    br: xf,
                                    tex: Tn,
                                    writingMode: pi.writingMode,
                                    glyphOffset: $v,
                                    sectionIndex: Xa.sectionIndex,
                                    isSDF: Ya,
                                    pixelOffsetTL: Iv,
                                    pixelOffsetBR: lv,
                                    minFontScaleX: 0,
                                    minFontScaleY: 0
                                });
                            }
                            return lo;
                        }(0, D, De, te, ue, ve, j, R.allowVerticalPlacement), $r = R.textSizeData, ni = null;
                        $r.kind === "source" ? (ni = [
                            v0 * te.layout.get("text-size").evaluate(ve, {})
                        ], ni[0] > lm && T(`${R.layerIds[0]}: Value for "text-size" is >= ${Wx}. Reduce your "text-size".`)) : $r.kind === "composite" && (ni = [
                            v0 * sr.compositeTextSizes[0].evaluate(ve, {}, Tr),
                            v0 * sr.compositeTextSizes[1].evaluate(ve, {}, Tr)
                        ], (ni[0] > lm || ni[1] > lm) && T(`${R.layerIds[0]}: Value for "text-size" is >= ${Wx}. Reduce your "text-size".`)), R.addSymbols(R.text, Pr, ni, De, ue, ve, at, S, Ze.lineStartIndex, Ze.lineLength, Qt, Tr);
                        for (let Di of Tt)Ft[Di] = R.text.placedSymbolArray.length - 1;
                        return 4 * Pr.length;
                    }
                    function qC(R) {
                        for(let S in R)return R[S];
                        return null;
                    }
                    function J9(R, S, D, j) {
                        let te = R.compareText;
                        if (S in te) {
                            let ue = te[S];
                            for(let ve = ue.length - 1; ve >= 0; ve--)if (j.dist(ue[ve]) < D) return !0;
                        } else te[S] = [];
                        return te[S].push(j), !1;
                    }
                    let OC = [
                        Int8Array,
                        Uint8Array,
                        Uint8ClampedArray,
                        Int16Array,
                        Uint16Array,
                        Int32Array,
                        Uint32Array,
                        Float32Array,
                        Float64Array
                    ];
                    class gS {
                        static from(S) {
                            if (!(S instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                            let [D, j] = new Uint8Array(S, 0, 2);
                            if (D !== 219) throw new Error("Data does not appear to be in a KDBush format.");
                            let te = j >> 4;
                            if (te !== 1) throw new Error(`Got v${te} data when expected v1.`);
                            let ue = OC[15 & j];
                            if (!ue) throw new Error("Unrecognized array type.");
                            let [ve] = new Uint16Array(S, 2, 1), [De] = new Uint32Array(S, 4, 1);
                            return new gS(De, ve, ue, S);
                        }
                        constructor(S, D = 64, j = Float64Array, te){
                            if (isNaN(S) || S < 0) throw new Error(`Unpexpected numItems value: ${S}.`);
                            this.numItems = +S, this.nodeSize = Math.min(Math.max(+D, 2), 65535), this.ArrayType = j, this.IndexArrayType = S < 65536 ? Uint16Array : Uint32Array;
                            let ue = OC.indexOf(this.ArrayType), ve = 2 * S * this.ArrayType.BYTES_PER_ELEMENT, De = S * this.IndexArrayType.BYTES_PER_ELEMENT, Ze = (8 - De % 8) % 8;
                            if (ue < 0) throw new Error(`Unexpected typed array class: ${j}.`);
                            te && te instanceof ArrayBuffer ? (this.data = te, this.ids = new this.IndexArrayType(this.data, 8, S), this.coords = new this.ArrayType(this.data, 8 + De + Ze, 2 * S), this._pos = 2 * S, this._finished = !0) : (this.data = new ArrayBuffer(8 + ve + De + Ze), this.ids = new this.IndexArrayType(this.data, 8, S), this.coords = new this.ArrayType(this.data, 8 + De + Ze, 2 * S), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                                219,
                                16 + ue
                            ]), new Uint16Array(this.data, 2, 1)[0] = D, new Uint32Array(this.data, 4, 1)[0] = S);
                        }
                        add(S, D) {
                            let j = this._pos >> 1;
                            return this.ids[j] = j, this.coords[this._pos++] = S, this.coords[this._pos++] = D, j;
                        }
                        finish() {
                            let S = this._pos >> 1;
                            if (S !== this.numItems) throw new Error(`Added ${S} items when expected ${this.numItems}.`);
                            return Ow(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
                        }
                        range(S, D, j, te) {
                            if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                            let { ids: ue, coords: ve, nodeSize: De } = this, Ze = [
                                0,
                                ue.length - 1,
                                0
                            ], at = [];
                            for(; Ze.length;){
                                let Tt = Ze.pop() || 0, Ft = Ze.pop() || 0, Qt = Ze.pop() || 0;
                                if (Ft - Qt <= De) {
                                    for(let $r = Qt; $r <= Ft; $r++){
                                        let ni = ve[2 * $r], Di = ve[2 * $r + 1];
                                        ni >= S && ni <= j && Di >= D && Di <= te && at.push(ue[$r]);
                                    }
                                    continue;
                                }
                                let sr = Qt + Ft >> 1, Tr = ve[2 * sr], Pr = ve[2 * sr + 1];
                                Tr >= S && Tr <= j && Pr >= D && Pr <= te && at.push(ue[sr]), (Tt === 0 ? S <= Tr : D <= Pr) && (Ze.push(Qt), Ze.push(sr - 1), Ze.push(1 - Tt)), (Tt === 0 ? j >= Tr : te >= Pr) && (Ze.push(sr + 1), Ze.push(Ft), Ze.push(1 - Tt));
                            }
                            return at;
                        }
                        within(S, D, j) {
                            if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                            let { ids: te, coords: ue, nodeSize: ve } = this, De = [
                                0,
                                te.length - 1,
                                0
                            ], Ze = [], at = j * j;
                            for(; De.length;){
                                let Tt = De.pop() || 0, Ft = De.pop() || 0, Qt = De.pop() || 0;
                                if (Ft - Qt <= ve) {
                                    for(let $r = Qt; $r <= Ft; $r++)NC(ue[2 * $r], ue[2 * $r + 1], S, D) <= at && Ze.push(te[$r]);
                                    continue;
                                }
                                let sr = Qt + Ft >> 1, Tr = ue[2 * sr], Pr = ue[2 * sr + 1];
                                NC(Tr, Pr, S, D) <= at && Ze.push(te[sr]), (Tt === 0 ? S - j <= Tr : D - j <= Pr) && (De.push(Qt), De.push(sr - 1), De.push(1 - Tt)), (Tt === 0 ? S + j >= Tr : D + j >= Pr) && (De.push(sr + 1), De.push(Ft), De.push(1 - Tt));
                            }
                            return Ze;
                        }
                    }
                    function Ow(R, S, D, j, te, ue) {
                        if (te - j <= D) return;
                        let ve = j + te >> 1;
                        BC(R, S, ve, j, te, ue), Ow(R, S, D, j, ve - 1, 1 - ue), Ow(R, S, D, ve + 1, te, 1 - ue);
                    }
                    function BC(R, S, D, j, te, ue) {
                        for(; te > j;){
                            if (te - j > 600) {
                                let at = te - j + 1, Tt = D - j + 1, Ft = Math.log(at), Qt = .5 * Math.exp(2 * Ft / 3), sr = .5 * Math.sqrt(Ft * Qt * (at - Qt) / at) * (Tt - at / 2 < 0 ? -1 : 1);
                                BC(R, S, D, Math.max(j, Math.floor(D - Tt * Qt / at + sr)), Math.min(te, Math.floor(D + (at - Tt) * Qt / at + sr)), ue);
                            }
                            let ve = S[2 * D + ue], De = j, Ze = te;
                            for(eb(R, S, j, D), S[2 * te + ue] > ve && eb(R, S, j, te); De < Ze;){
                                for(eb(R, S, De, Ze), De++, Ze--; S[2 * De + ue] < ve;)De++;
                                for(; S[2 * Ze + ue] > ve;)Ze--;
                            }
                            S[2 * j + ue] === ve ? eb(R, S, j, Ze) : (Ze++, eb(R, S, Ze, te)), Ze <= D && (j = Ze + 1), D <= Ze && (te = Ze - 1);
                        }
                    }
                    function eb(R, S, D, j) {
                        mS(R, D, j), mS(S, 2 * D, 2 * j), mS(S, 2 * D + 1, 2 * j + 1);
                    }
                    function mS(R, S, D) {
                        let j = R[S];
                        R[S] = R[D], R[D] = j;
                    }
                    function NC(R, S, D, j) {
                        let te = R - D, ue = S - j;
                        return te * te + ue * ue;
                    }
                    var Bw;
                    i.bg = void 0, (Bw = i.bg || (i.bg = {})).create = "create", Bw.load = "load", Bw.fullLoad = "fullLoad";
                    let tb = null, Gf = [], yS = 1e3 / 60, _S = "loadTime", Nw = "fullLoadTime", $9 = {
                        mark (R) {
                            performance.mark(R);
                        },
                        frame (R) {
                            let S = R;
                            tb != null && Gf.push(S - tb), tb = S;
                        },
                        clearMetrics () {
                            tb = null, Gf = [], performance.clearMeasures(_S), performance.clearMeasures(Nw);
                            for(let R in i.bg)performance.clearMarks(i.bg[R]);
                        },
                        getPerformanceMetrics () {
                            performance.measure(_S, i.bg.create, i.bg.load), performance.measure(Nw, i.bg.create, i.bg.fullLoad);
                            let R = performance.getEntriesByName(_S)[0].duration, S = performance.getEntriesByName(Nw)[0].duration, D = Gf.length, j = 1 / (Gf.reduce((ue, ve)=>ue + ve, 0) / D / 1e3), te = Gf.filter((ue)=>ue > yS).reduce((ue, ve)=>ue + (ve - yS) / yS, 0);
                            return {
                                loadTime: R,
                                fullLoadTime: S,
                                fps: j,
                                percentDroppedFrames: te / (D + te) * 100,
                                totalFrames: D
                            };
                        }
                    };
                    i.$ = class extends Ot {
                    }, i.A = Ln, i.B = Fi, i.C = function(R) {
                        if (V == null) {
                            let S = R.navigator ? R.navigator.userAgent : null;
                            V = !!R.safari || !(!S || !(/\b(iPad|iPhone|iPod)\b/.test(S) || S.match("Safari") && !S.match("Chrome")));
                        }
                        return V;
                    }, i.D = Da, i.E = Re, i.F = class {
                        constructor(R, S){
                            this.target = R, this.mapId = S, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new uS(()=>this.process()), this.subscription = function(D, j, te, ue) {
                                return D.addEventListener(j, te, !1), {
                                    unsubscribe: ()=>{
                                        D.removeEventListener(j, te, !1);
                                    }
                                };
                            }(this.target, "message", (D)=>this.receive(D)), this.globalScope = q(self) ? R : window;
                        }
                        registerMessageHandler(R, S) {
                            this.messageHandlers[R] = S;
                        }
                        sendAsync(R, S) {
                            return new Promise((D, j)=>{
                                let te = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                                this.resolveRejects[te] = {
                                    resolve: D,
                                    reject: j
                                }, S && S.signal.addEventListener("abort", ()=>{
                                    delete this.resolveRejects[te];
                                    let De = {
                                        id: te,
                                        type: "<cancel>",
                                        origin: location.origin,
                                        targetMapId: R.targetMapId,
                                        sourceMapId: this.mapId
                                    };
                                    this.target.postMessage(De);
                                }, {
                                    once: !0
                                });
                                let ue = [], ve = Object.assign(Object.assign({}, R), {
                                    id: te,
                                    sourceMapId: this.mapId,
                                    origin: location.origin,
                                    data: Ea(R.data, ue)
                                });
                                this.target.postMessage(ve, {
                                    transfer: ue
                                });
                            });
                        }
                        receive(R) {
                            let S = R.data, D = S.id;
                            if (!(S.origin !== "file://" && location.origin !== "file://" && S.origin !== "resource://android" && location.origin !== "resource://android" && S.origin !== location.origin || S.targetMapId && this.mapId !== S.targetMapId)) {
                                if (S.type === "<cancel>") {
                                    delete this.tasks[D];
                                    let j = this.abortControllers[D];
                                    return delete this.abortControllers[D], void (j && j.abort());
                                }
                                if (q(self) || S.mustQueue) return this.tasks[D] = S, this.taskQueue.push(D), void this.invoker.trigger();
                                this.processTask(D, S);
                            }
                        }
                        process() {
                            if (this.taskQueue.length === 0) return;
                            let R = this.taskQueue.shift(), S = this.tasks[R];
                            delete this.tasks[R], this.taskQueue.length > 0 && this.invoker.trigger(), S && this.processTask(R, S);
                        }
                        processTask(R, S) {
                            return a(this, void 0, void 0, function*() {
                                if (S.type === "<response>") {
                                    let te = this.resolveRejects[R];
                                    return delete this.resolveRejects[R], te ? void (S.error ? te.reject(qa(S.error)) : te.resolve(qa(S.data))) : void 0;
                                }
                                if (!this.messageHandlers[S.type]) return void this.completeTask(R, new Error(`Could not find a registered handler for ${S.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
                                let D = qa(S.data), j = new AbortController;
                                this.abortControllers[R] = j;
                                try {
                                    let te = yield this.messageHandlers[S.type](S.sourceMapId, D, j);
                                    this.completeTask(R, null, te);
                                } catch (te) {
                                    this.completeTask(R, te);
                                }
                            });
                        }
                        completeTask(R, S, D) {
                            let j = [];
                            delete this.abortControllers[R];
                            let te = {
                                id: R,
                                type: "<response>",
                                sourceMapId: this.mapId,
                                origin: location.origin,
                                error: S ? Ea(S) : null,
                                data: Ea(D, j)
                            };
                            this.target.postMessage(te, {
                                transfer: j
                            });
                        }
                        remove() {
                            this.invoker.remove(), this.subscription.unsubscribe();
                        }
                    }, i.G = ke, i.H = function() {
                        var R = new Ln(16);
                        return Ln != Float32Array && (R[1] = 0, R[2] = 0, R[3] = 0, R[4] = 0, R[6] = 0, R[7] = 0, R[8] = 0, R[9] = 0, R[11] = 0, R[12] = 0, R[13] = 0, R[14] = 0), R[0] = 1, R[5] = 1, R[10] = 1, R[15] = 1, R;
                    }, i.I = kw, i.J = function(R, S, D) {
                        var j, te, ue, ve, De, Ze, at, Tt, Ft, Qt, sr, Tr, Pr = D[0], $r = D[1], ni = D[2];
                        return S === R ? (R[12] = S[0] * Pr + S[4] * $r + S[8] * ni + S[12], R[13] = S[1] * Pr + S[5] * $r + S[9] * ni + S[13], R[14] = S[2] * Pr + S[6] * $r + S[10] * ni + S[14], R[15] = S[3] * Pr + S[7] * $r + S[11] * ni + S[15]) : (te = S[1], ue = S[2], ve = S[3], De = S[4], Ze = S[5], at = S[6], Tt = S[7], Ft = S[8], Qt = S[9], sr = S[10], Tr = S[11], R[0] = j = S[0], R[1] = te, R[2] = ue, R[3] = ve, R[4] = De, R[5] = Ze, R[6] = at, R[7] = Tt, R[8] = Ft, R[9] = Qt, R[10] = sr, R[11] = Tr, R[12] = j * Pr + De * $r + Ft * ni + S[12], R[13] = te * Pr + Ze * $r + Qt * ni + S[13], R[14] = ue * Pr + at * $r + sr * ni + S[14], R[15] = ve * Pr + Tt * $r + Tr * ni + S[15]), R;
                    }, i.K = function(R, S, D) {
                        var j = D[0], te = D[1], ue = D[2];
                        return R[0] = S[0] * j, R[1] = S[1] * j, R[2] = S[2] * j, R[3] = S[3] * j, R[4] = S[4] * te, R[5] = S[5] * te, R[6] = S[6] * te, R[7] = S[7] * te, R[8] = S[8] * ue, R[9] = S[9] * ue, R[10] = S[10] * ue, R[11] = S[11] * ue, R[12] = S[12], R[13] = S[13], R[14] = S[14], R[15] = S[15], R;
                    }, i.L = gn, i.M = function(R, S) {
                        let D = {};
                        for(let j = 0; j < S.length; j++){
                            let te = S[j];
                            te in R && (D[te] = R[te]);
                        }
                        return D;
                    }, i.N = dg, i.O = zw, i.P = u, i.Q = wC, i.R = Jn, i.S = Jv, i.T = ac, i.U = x, i.V = b, i.W = G, i.X = za, i.Y = qe, i.Z = $x, i._ = a, i.a = _e, i.a$ = function(R, S) {
                        var D = R[0], j = R[1], te = R[2], ue = R[3], ve = R[4], De = R[5], Ze = R[6], at = R[7], Tt = R[8], Ft = R[9], Qt = R[10], sr = R[11], Tr = R[12], Pr = R[13], $r = R[14], ni = R[15], Di = S[0], pi = S[1], ki = S[2], Zi = S[3], ta = S[4], Va = S[5], Io = S[6], La = S[7], Hn = S[8], lo = S[9], $a = S[10], Xa = S[11], Tn = S[12], bo = S[13], Ya = S[14], Uo = S[15];
                        return Math.abs(D - Di) <= ji * Math.max(1, Math.abs(D), Math.abs(Di)) && Math.abs(j - pi) <= ji * Math.max(1, Math.abs(j), Math.abs(pi)) && Math.abs(te - ki) <= ji * Math.max(1, Math.abs(te), Math.abs(ki)) && Math.abs(ue - Zi) <= ji * Math.max(1, Math.abs(ue), Math.abs(Zi)) && Math.abs(ve - ta) <= ji * Math.max(1, Math.abs(ve), Math.abs(ta)) && Math.abs(De - Va) <= ji * Math.max(1, Math.abs(De), Math.abs(Va)) && Math.abs(Ze - Io) <= ji * Math.max(1, Math.abs(Ze), Math.abs(Io)) && Math.abs(at - La) <= ji * Math.max(1, Math.abs(at), Math.abs(La)) && Math.abs(Tt - Hn) <= ji * Math.max(1, Math.abs(Tt), Math.abs(Hn)) && Math.abs(Ft - lo) <= ji * Math.max(1, Math.abs(Ft), Math.abs(lo)) && Math.abs(Qt - $a) <= ji * Math.max(1, Math.abs(Qt), Math.abs($a)) && Math.abs(sr - Xa) <= ji * Math.max(1, Math.abs(sr), Math.abs(Xa)) && Math.abs(Tr - Tn) <= ji * Math.max(1, Math.abs(Tr), Math.abs(Tn)) && Math.abs(Pr - bo) <= ji * Math.max(1, Math.abs(Pr), Math.abs(bo)) && Math.abs($r - Ya) <= ji * Math.max(1, Math.abs($r), Math.abs(Ya)) && Math.abs(ni - Uo) <= ji * Math.max(1, Math.abs(ni), Math.abs(Uo));
                    }, i.a0 = We, i.a1 = fS, i.a2 = er, i.a3 = (R)=>{
                        let S = window.document.createElement("video");
                        return S.muted = !0, new Promise((D)=>{
                            S.onloadstart = ()=>{
                                D(S);
                            };
                            for (let j of R){
                                let te = window.document.createElement("source");
                                Ee(j) || (S.crossOrigin = "Anonymous"), te.src = j, S.appendChild(te);
                            }
                        });
                    }, i.a4 = function() {
                        return _++;
                    }, i.a5 = Qi, i.a6 = E1, i.a7 = Pc, i.a8 = xl, i.a9 = hS, i.aA = function(R) {
                        if (R.type === "custom") return new lS(R);
                        switch(R.type){
                            case "background":
                                return new G9(R);
                            case "circle":
                                return new wn(R);
                            case "fill":
                                return new gr(R);
                            case "fill-extrusion":
                                return new Ev(R);
                            case "heatmap":
                                return new Po(R);
                            case "hillshade":
                                return new $c(R);
                            case "line":
                                return new ay(R);
                            case "raster":
                                return new Kx(R);
                            case "symbol":
                                return new uy(R);
                        }
                    }, i.aB = g, i.aC = function(R, S) {
                        if (!R) return [
                            {
                                command: "setStyle",
                                args: [
                                    S
                                ]
                            }
                        ];
                        let D = [];
                        try {
                            if (!ct(R.version, S.version)) return [
                                {
                                    command: "setStyle",
                                    args: [
                                        S
                                    ]
                                }
                            ];
                            ct(R.center, S.center) || D.push({
                                command: "setCenter",
                                args: [
                                    S.center
                                ]
                            }), ct(R.zoom, S.zoom) || D.push({
                                command: "setZoom",
                                args: [
                                    S.zoom
                                ]
                            }), ct(R.bearing, S.bearing) || D.push({
                                command: "setBearing",
                                args: [
                                    S.bearing
                                ]
                            }), ct(R.pitch, S.pitch) || D.push({
                                command: "setPitch",
                                args: [
                                    S.pitch
                                ]
                            }), ct(R.sprite, S.sprite) || D.push({
                                command: "setSprite",
                                args: [
                                    S.sprite
                                ]
                            }), ct(R.glyphs, S.glyphs) || D.push({
                                command: "setGlyphs",
                                args: [
                                    S.glyphs
                                ]
                            }), ct(R.transition, S.transition) || D.push({
                                command: "setTransition",
                                args: [
                                    S.transition
                                ]
                            }), ct(R.light, S.light) || D.push({
                                command: "setLight",
                                args: [
                                    S.light
                                ]
                            }), ct(R.terrain, S.terrain) || D.push({
                                command: "setTerrain",
                                args: [
                                    S.terrain
                                ]
                            }), ct(R.sky, S.sky) || D.push({
                                command: "setSky",
                                args: [
                                    S.sky
                                ]
                            }), ct(R.projection, S.projection) || D.push({
                                command: "setProjection",
                                args: [
                                    S.projection
                                ]
                            });
                            let j = {}, te = [];
                            (function(ve, De, Ze, at) {
                                let Tt;
                                for(Tt in De = De || {}, ve = ve || {})Object.prototype.hasOwnProperty.call(ve, Tt) && (Object.prototype.hasOwnProperty.call(De, Tt) || ot(Tt, Ze, at));
                                for(Tt in De)Object.prototype.hasOwnProperty.call(De, Tt) && (Object.prototype.hasOwnProperty.call(ve, Tt) ? ct(ve[Tt], De[Tt]) || (ve[Tt].type === "geojson" && De[Tt].type === "geojson" && kt(ve, De, Tt) ? qt(Ze, {
                                    command: "setGeoJSONSourceData",
                                    args: [
                                        Tt,
                                        De[Tt].data
                                    ]
                                }) : Rt(Tt, De, Ze, at)) : rt(Tt, De, Ze));
                            })(R.sources, S.sources, te, j);
                            let ue = [];
                            R.layers && R.layers.forEach((ve)=>{
                                "source" in ve && j[ve.source] ? D.push({
                                    command: "removeLayer",
                                    args: [
                                        ve.id
                                    ]
                                }) : ue.push(ve);
                            }), D = D.concat(te), function(ve, De, Ze) {
                                De = De || [];
                                let at = (ve = ve || []).map(Yt), Tt = De.map(Yt), Ft = ve.reduce(xr, {}), Qt = De.reduce(xr, {}), sr = at.slice(), Tr = Object.create(null), Pr, $r, ni, Di, pi;
                                for(let ki = 0, Zi = 0; ki < at.length; ki++)Pr = at[ki], Object.prototype.hasOwnProperty.call(Qt, Pr) ? Zi++ : (qt(Ze, {
                                    command: "removeLayer",
                                    args: [
                                        Pr
                                    ]
                                }), sr.splice(sr.indexOf(Pr, Zi), 1));
                                for(let ki = 0, Zi = 0; ki < Tt.length; ki++)Pr = Tt[Tt.length - 1 - ki], sr[sr.length - 1 - ki] !== Pr && (Object.prototype.hasOwnProperty.call(Ft, Pr) ? (qt(Ze, {
                                    command: "removeLayer",
                                    args: [
                                        Pr
                                    ]
                                }), sr.splice(sr.lastIndexOf(Pr, sr.length - Zi), 1)) : Zi++, Di = sr[sr.length - ki], qt(Ze, {
                                    command: "addLayer",
                                    args: [
                                        Qt[Pr],
                                        Di
                                    ]
                                }), sr.splice(sr.length - ki, 0, Pr), Tr[Pr] = !0);
                                for(let ki = 0; ki < Tt.length; ki++)if (Pr = Tt[ki], $r = Ft[Pr], ni = Qt[Pr], !Tr[Pr] && !ct($r, ni)) {
                                    if (ct($r.source, ni.source) && ct($r["source-layer"], ni["source-layer"]) && ct($r.type, ni.type)) {
                                        for(pi in Ct($r.layout, ni.layout, Ze, Pr, null, "setLayoutProperty"), Ct($r.paint, ni.paint, Ze, Pr, null, "setPaintProperty"), ct($r.filter, ni.filter) || qt(Ze, {
                                            command: "setFilter",
                                            args: [
                                                Pr,
                                                ni.filter
                                            ]
                                        }), ct($r.minzoom, ni.minzoom) && ct($r.maxzoom, ni.maxzoom) || qt(Ze, {
                                            command: "setLayerZoomRange",
                                            args: [
                                                Pr,
                                                ni.minzoom,
                                                ni.maxzoom
                                            ]
                                        }), $r)Object.prototype.hasOwnProperty.call($r, pi) && pi !== "layout" && pi !== "paint" && pi !== "filter" && pi !== "metadata" && pi !== "minzoom" && pi !== "maxzoom" && (pi.indexOf("paint.") === 0 ? Ct($r[pi], ni[pi], Ze, Pr, pi.slice(6), "setPaintProperty") : ct($r[pi], ni[pi]) || qt(Ze, {
                                            command: "setLayerProperty",
                                            args: [
                                                Pr,
                                                pi,
                                                ni[pi]
                                            ]
                                        }));
                                        for(pi in ni)Object.prototype.hasOwnProperty.call(ni, pi) && !Object.prototype.hasOwnProperty.call($r, pi) && pi !== "layout" && pi !== "paint" && pi !== "filter" && pi !== "metadata" && pi !== "minzoom" && pi !== "maxzoom" && (pi.indexOf("paint.") === 0 ? Ct($r[pi], ni[pi], Ze, Pr, pi.slice(6), "setPaintProperty") : ct($r[pi], ni[pi]) || qt(Ze, {
                                            command: "setLayerProperty",
                                            args: [
                                                Pr,
                                                pi,
                                                ni[pi]
                                            ]
                                        }));
                                    } else qt(Ze, {
                                        command: "removeLayer",
                                        args: [
                                            Pr
                                        ]
                                    }), Di = sr[sr.lastIndexOf(Pr) + 1], qt(Ze, {
                                        command: "addLayer",
                                        args: [
                                            ni,
                                            Di
                                        ]
                                    });
                                }
                            }(ue, S.layers, D);
                        } catch (j) {
                            console.warn("Unable to compute style diff:", j), D = [
                                {
                                    command: "setStyle",
                                    args: [
                                        S
                                    ]
                                }
                            ];
                        }
                        return D;
                    }, i.aD = function(R) {
                        let S = [], D = R.id;
                        return D === void 0 && S.push({
                            message: `layers.${D}: missing required property "id"`
                        }), R.render === void 0 && S.push({
                            message: `layers.${D}: missing required method "render"`
                        }), R.renderingMode && R.renderingMode !== "2d" && R.renderingMode !== "3d" && S.push({
                            message: `layers.${D}: property "renderingMode" must be either "2d" or "3d"`
                        }), S;
                    }, i.aE = function R(S, D) {
                        if (Array.isArray(S)) {
                            if (!Array.isArray(D) || S.length !== D.length) return !1;
                            for(let j = 0; j < S.length; j++)if (!R(S[j], D[j])) return !1;
                            return !0;
                        }
                        if (typeof S == "object" && S !== null && D !== null) {
                            if (typeof D != "object" || Object.keys(S).length !== Object.keys(D).length) return !1;
                            for(let j in S)if (!R(S[j], D[j])) return !1;
                            return !0;
                        }
                        return S === D;
                    }, i.aF = C, i.aG = M, i.aH = class extends ci {
                        constructor(R, S){
                            super(R, S), this.current = 0;
                        }
                        set(R) {
                            this.current !== R && (this.current = R, this.gl.uniform1i(this.location, R));
                        }
                    }, i.aI = Jr, i.aJ = class extends ci {
                        constructor(R, S){
                            super(R, S), this.current = En;
                        }
                        set(R) {
                            if (R[12] !== this.current[12] || R[0] !== this.current[0]) return this.current = R, void this.gl.uniformMatrix4fv(this.location, !1, R);
                            for(let S = 1; S < 16; S++)if (R[S] !== this.current[S]) {
                                this.current = R, this.gl.uniformMatrix4fv(this.location, !1, R);
                                break;
                            }
                        }
                    }, i.aK = un, i.aL = dn, i.aM = Zt, i.aN = class extends ci {
                        constructor(R, S){
                            super(R, S), this.current = [
                                0,
                                0,
                                0
                            ];
                        }
                        set(R) {
                            R[0] === this.current[0] && R[1] === this.current[1] && R[2] === this.current[2] || (this.current = R, this.gl.uniform3f(this.location, R[0], R[1], R[2]));
                        }
                    }, i.aO = class extends ci {
                        constructor(R, S){
                            super(R, S), this.current = [
                                0,
                                0
                            ];
                        }
                        set(R) {
                            R[0] === this.current[0] && R[1] === this.current[1] || (this.current = R, this.gl.uniform2f(this.location, R[0], R[1]));
                        }
                    }, i.aP = function(R, S, D, j, te, ue, ve) {
                        var De = 1 / (S - D), Ze = 1 / (j - te), at = 1 / (ue - ve);
                        return R[0] = -2 * De, R[1] = 0, R[2] = 0, R[3] = 0, R[4] = 0, R[5] = -2 * Ze, R[6] = 0, R[7] = 0, R[8] = 0, R[9] = 0, R[10] = 2 * at, R[11] = 0, R[12] = (S + D) * De, R[13] = (te + j) * Ze, R[14] = (ve + ue) * at, R[15] = 1, R;
                    }, i.aQ = Kn, i.aR = class extends et {
                    }, i.aS = im, i.aT = class extends Dt {
                    }, i.aU = _o, i.aV = function(R) {
                        return R <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(R) / Math.LN2));
                    }, i.aW = Oa, i.aX = yo, i.aY = oe, i.aZ = class extends di {
                    }, i.a_ = function(R, S) {
                        return R[0] === S[0] && R[1] === S[1] && R[2] === S[2] && R[3] === S[3] && R[4] === S[4] && R[5] === S[5] && R[6] === S[6] && R[7] === S[7] && R[8] === S[8] && R[9] === S[9] && R[10] === S[10] && R[11] === S[11] && R[12] === S[12] && R[13] === S[13] && R[14] === S[14] && R[15] === S[15];
                    }, i.aa = function(R) {
                        let S = {};
                        if (R.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (D, j, te, ue)=>{
                            let ve = te || ue;
                            return S[j] = !ve || ve.toLowerCase(), "";
                        }), S["max-age"]) {
                            let D = parseInt(S["max-age"], 10);
                            isNaN(D) ? delete S["max-age"] : S["max-age"] = D;
                        }
                        return S;
                    }, i.ab = function(R, S) {
                        let D = [];
                        for(let j in R)j in S || D.push(j);
                        return D;
                    }, i.ac = k, i.ad = function(R, S, D) {
                        var j = Math.sin(D), te = Math.cos(D), ue = S[0], ve = S[1], De = S[2], Ze = S[3], at = S[4], Tt = S[5], Ft = S[6], Qt = S[7];
                        return S !== R && (R[8] = S[8], R[9] = S[9], R[10] = S[10], R[11] = S[11], R[12] = S[12], R[13] = S[13], R[14] = S[14], R[15] = S[15]), R[0] = ue * te + at * j, R[1] = ve * te + Tt * j, R[2] = De * te + Ft * j, R[3] = Ze * te + Qt * j, R[4] = at * te - ue * j, R[5] = Tt * te - ve * j, R[6] = Ft * te - De * j, R[7] = Qt * te - Ze * j, R;
                    }, i.ae = function(R) {
                        var S = new Ln(16);
                        return S[0] = R[0], S[1] = R[1], S[2] = R[2], S[3] = R[3], S[4] = R[4], S[5] = R[5], S[6] = R[6], S[7] = R[7], S[8] = R[8], S[9] = R[9], S[10] = R[10], S[11] = R[11], S[12] = R[12], S[13] = R[13], S[14] = R[14], S[15] = R[15], S;
                    }, i.af = Za, i.ag = function(R, S) {
                        let D = 0, j = 0;
                        if (R.kind === "constant") j = R.layoutSize;
                        else if (R.kind !== "source") {
                            let { interpolationType: te, minZoom: ue, maxZoom: ve } = R, De = te ? k(xo.interpolationFactor(te, S, ue, ve), 0, 1) : 0;
                            R.kind === "camera" ? j = Mo.number(R.minSize, R.maxSize, De) : D = De;
                        }
                        return {
                            uSizeT: D,
                            uSize: j
                        };
                    }, i.ai = function(R, { uSize: S, uSizeT: D }, { lowerSize: j, upperSize: te }) {
                        return R.kind === "source" ? j / v0 : R.kind === "composite" ? Mo.number(j / v0, te / v0, D) : S;
                    }, i.aj = nS, i.ak = function(R, S, D, j) {
                        let te = S.y - R.y, ue = S.x - R.x, ve = j.y - D.y, De = j.x - D.x, Ze = ve * ue - De * te;
                        if (Ze === 0) return null;
                        let at = (De * (R.y - D.y) - ve * (R.x - D.x)) / Ze;
                        return new u(R.x + at * ue, R.y + at * te);
                    }, i.al = kC, i.am = xc, i.an = Un, i.ao = function(R) {
                        let S = 1 / 0, D = 1 / 0, j = -1 / 0, te = -1 / 0;
                        for (let ue of R)S = Math.min(S, ue.x), D = Math.min(D, ue.y), j = Math.max(j, ue.x), te = Math.max(te, ue.y);
                        return [
                            S,
                            D,
                            j,
                            te
                        ];
                    }, i.ap = kl, i.ar = iS, i.as = function(R, S) {
                        var D = S[0], j = S[1], te = S[2], ue = S[3], ve = S[4], De = S[5], Ze = S[6], at = S[7], Tt = S[8], Ft = S[9], Qt = S[10], sr = S[11], Tr = S[12], Pr = S[13], $r = S[14], ni = S[15], Di = D * De - j * ve, pi = D * Ze - te * ve, ki = D * at - ue * ve, Zi = j * Ze - te * De, ta = j * at - ue * De, Va = te * at - ue * Ze, Io = Tt * Pr - Ft * Tr, La = Tt * $r - Qt * Tr, Hn = Tt * ni - sr * Tr, lo = Ft * $r - Qt * Pr, $a = Ft * ni - sr * Pr, Xa = Qt * ni - sr * $r, Tn = Di * Xa - pi * $a + ki * lo + Zi * Hn - ta * La + Va * Io;
                        return Tn ? (R[0] = (De * Xa - Ze * $a + at * lo) * (Tn = 1 / Tn), R[1] = (te * $a - j * Xa - ue * lo) * Tn, R[2] = (Pr * Va - $r * ta + ni * Zi) * Tn, R[3] = (Qt * ta - Ft * Va - sr * Zi) * Tn, R[4] = (Ze * Hn - ve * Xa - at * La) * Tn, R[5] = (D * Xa - te * Hn + ue * La) * Tn, R[6] = ($r * ki - Tr * Va - ni * pi) * Tn, R[7] = (Tt * Va - Qt * ki + sr * pi) * Tn, R[8] = (ve * $a - De * Hn + at * Io) * Tn, R[9] = (j * Hn - D * $a - ue * Io) * Tn, R[10] = (Tr * ta - Pr * ki + ni * Di) * Tn, R[11] = (Ft * ki - Tt * ta - sr * Di) * Tn, R[12] = (De * La - ve * lo - Ze * Io) * Tn, R[13] = (D * lo - j * La + te * Io) * Tn, R[14] = (Pr * pi - Tr * Zi - $r * Di) * Tn, R[15] = (Tt * Zi - Ft * pi + Qt * Di) * Tn, R) : null;
                    }, i.at = pS, i.au = Iw, i.av = gS, i.aw = function() {
                        let R = {}, S = ce.$version;
                        for(let D in ce.$root){
                            let j = ce.$root[D];
                            if (j.required) {
                                let te = null;
                                te = D === "version" ? S : j.type === "array" ? [] : {}, te != null && (R[D] = te);
                            }
                        }
                        return R;
                    }, i.ax = Cn, i.ay = ie, i.az = function(R) {
                        R = R.slice();
                        let S = Object.create(null);
                        for(let D = 0; D < R.length; D++)S[R[D].id] = R[D];
                        for(let D = 0; D < R.length; D++)"ref" in R[D] && (R[D] = nt(R[D], S[R[D].ref]));
                        return R;
                    }, i.b = H, i.b0 = function(R, S) {
                        return R[0] = S[0], R[1] = S[1], R[2] = S[2], R[3] = S[3], R[4] = S[4], R[5] = S[5], R[6] = S[6], R[7] = S[7], R[8] = S[8], R[9] = S[9], R[10] = S[10], R[11] = S[11], R[12] = S[12], R[13] = S[13], R[14] = S[14], R[15] = S[15], R;
                    }, i.b1 = function(R, S, D) {
                        return R[0] = S[0] * D[0], R[1] = S[1] * D[1], R[2] = S[2] * D[2], R[3] = S[3] * D[3], R;
                    }, i.b2 = function(R, S) {
                        return R[0] * S[0] + R[1] * S[1] + R[2] * S[2] + R[3] * S[3];
                    }, i.b3 = A, i.b4 = TC, i.b5 = Fw, i.b6 = function(R, S, D, j, te) {
                        var ue, ve = 1 / Math.tan(S / 2);
                        return R[0] = ve / D, R[1] = 0, R[2] = 0, R[3] = 0, R[4] = 0, R[5] = ve, R[6] = 0, R[7] = 0, R[8] = 0, R[9] = 0, R[11] = -1, R[12] = 0, R[13] = 0, R[15] = 0, te != null && te !== 1 / 0 ? (R[10] = (te + j) * (ue = 1 / (j - te)), R[14] = 2 * te * j * ue) : (R[10] = -1, R[14] = -2 * j), R;
                    }, i.b7 = function(R, S, D) {
                        var j = Math.sin(D), te = Math.cos(D), ue = S[4], ve = S[5], De = S[6], Ze = S[7], at = S[8], Tt = S[9], Ft = S[10], Qt = S[11];
                        return S !== R && (R[0] = S[0], R[1] = S[1], R[2] = S[2], R[3] = S[3], R[12] = S[12], R[13] = S[13], R[14] = S[14], R[15] = S[15]), R[4] = ue * te + at * j, R[5] = ve * te + Tt * j, R[6] = De * te + Ft * j, R[7] = Ze * te + Qt * j, R[8] = at * te - ue * j, R[9] = Tt * te - ve * j, R[10] = Ft * te - De * j, R[11] = Qt * te - Ze * j, R;
                    }, i.b8 = p, i.b9 = E, i.bA = bd, i.bB = function(R) {
                        return R.message === re;
                    }, i.bC = fl, i.bD = vs, i.ba = function(R) {
                        return R * Math.PI / 180;
                    }, i.bb = function(R, S) {
                        let { x: D, y: j } = $x.fromLngLat(S);
                        return !(R < 0 || R > 25 || j < 0 || j >= 1 || D < 0 || D >= 1);
                    }, i.bc = function(R, S) {
                        return R[0] = S[0], R[1] = 0, R[2] = 0, R[3] = 0, R[4] = 0, R[5] = S[1], R[6] = 0, R[7] = 0, R[8] = 0, R[9] = 0, R[10] = S[2], R[11] = 0, R[12] = 0, R[13] = 0, R[14] = 0, R[15] = 1, R;
                    }, i.bd = class extends yt {
                    }, i.be = cS, i.bf = $9, i.bh = ge, i.bi = function(R, S) {
                        _e.REGISTERED_PROTOCOLS[R] = S;
                    }, i.bj = function(R) {
                        delete _e.REGISTERED_PROTOCOLS[R];
                    }, i.bk = function(R, S) {
                        let D = {};
                        for(let te = 0; te < R.length; te++){
                            let ue = S && S[R[te].id] || md(R[te]);
                            S && (S[R[te].id] = ue);
                            let ve = D[ue];
                            ve || (ve = D[ue] = []), ve.push(R[te]);
                        }
                        let j = [];
                        for(let te in D)j.push(D[te]);
                        return j;
                    }, i.bl = mi, i.bm = SC, i.bn = cy, i.bo = Cw, i.bp = function(R) {
                        R.bucket.createArrays(), R.bucket.tilePixelRatio = za / (512 * R.bucket.overscaling), R.bucket.compareText = {}, R.bucket.iconsNeedLinear = !1;
                        let S = R.bucket.layers[0], D = S.layout, j = S._unevaluatedLayout._values, te = {
                            layoutIconSize: j["icon-size"].possiblyEvaluate(new Ko(R.bucket.zoom + 1), R.canonical),
                            layoutTextSize: j["text-size"].possiblyEvaluate(new Ko(R.bucket.zoom + 1), R.canonical),
                            textMaxSize: j["text-size"].possiblyEvaluate(new Ko(18))
                        };
                        if (R.bucket.textSizeData.kind === "composite") {
                            let { minZoom: at, maxZoom: Tt } = R.bucket.textSizeData;
                            te.compositeTextSizes = [
                                j["text-size"].possiblyEvaluate(new Ko(at), R.canonical),
                                j["text-size"].possiblyEvaluate(new Ko(Tt), R.canonical)
                            ];
                        }
                        if (R.bucket.iconSizeData.kind === "composite") {
                            let { minZoom: at, maxZoom: Tt } = R.bucket.iconSizeData;
                            te.compositeIconSizes = [
                                j["icon-size"].possiblyEvaluate(new Ko(at), R.canonical),
                                j["icon-size"].possiblyEvaluate(new Ko(Tt), R.canonical)
                            ];
                        }
                        let ue = D.get("text-line-height") * kl, ve = D.get("text-rotation-alignment") !== "viewport" && D.get("symbol-placement") !== "point", De = D.get("text-keep-upright"), Ze = D.get("text-size");
                        for (let at of R.bucket.features){
                            let Tt = D.get("text-font").evaluate(at, {}, R.canonical).join(","), Ft = Ze.evaluate(at, {}, R.canonical), Qt = te.layoutTextSize.evaluate(at, {}, R.canonical), sr = te.layoutIconSize.evaluate(at, {}, R.canonical), Tr = {
                                horizontal: {},
                                vertical: void 0
                            }, Pr = at.text, $r, ni = [
                                0,
                                0
                            ];
                            if (Pr) {
                                let ki = Pr.toString(), Zi = D.get("text-letter-spacing").evaluate(at, {}, R.canonical) * kl, ta = mo(ki) ? Zi : 0, Va = D.get("text-anchor").evaluate(at, {}, R.canonical), Io = zC(S, at, R.canonical);
                                if (!Io) {
                                    let $a = D.get("text-radial-offset").evaluate(at, {}, R.canonical);
                                    ni = $a ? vS(Va, [
                                        $a * kl,
                                        fy
                                    ]) : D.get("text-offset").evaluate(at, {}, R.canonical).map((Xa)=>Xa * kl);
                                }
                                let La = ve ? "center" : D.get("text-justify").evaluate(at, {}, R.canonical), Hn = D.get("symbol-placement") === "point" ? D.get("text-max-width").evaluate(at, {}, R.canonical) * kl : 1 / 0, lo = ()=>{
                                    R.bucket.allowVerticalPlacement && Ua(ki) && (Tr.vertical = Gx(Pr, R.glyphMap, R.glyphPositions, R.imagePositions, Tt, Hn, ue, Va, "left", ta, ni, i.ah.vertical, !0, Qt, Ft));
                                };
                                if (!ve && Io) {
                                    let $a = new Set;
                                    if (La === "auto") for(let Tn = 0; Tn < Io.values.length; Tn += 2)$a.add(pS(Io.values[Tn]));
                                    else $a.add(La);
                                    let Xa = !1;
                                    for (let Tn of $a)if (!Tr.horizontal[Tn]) {
                                        if (Xa) Tr.horizontal[Tn] = Tr.horizontal[0];
                                        else {
                                            let bo = Gx(Pr, R.glyphMap, R.glyphPositions, R.imagePositions, Tt, Hn, ue, "center", Tn, ta, ni, i.ah.horizontal, !1, Qt, Ft);
                                            bo && (Tr.horizontal[Tn] = bo, Xa = bo.positionedLines.length === 1);
                                        }
                                    }
                                    lo();
                                } else {
                                    La === "auto" && (La = pS(Va));
                                    let $a = Gx(Pr, R.glyphMap, R.glyphPositions, R.imagePositions, Tt, Hn, ue, Va, La, ta, ni, i.ah.horizontal, !1, Qt, Ft);
                                    $a && (Tr.horizontal[La] = $a), lo(), Ua(ki) && ve && De && (Tr.vertical = Gx(Pr, R.glyphMap, R.glyphPositions, R.imagePositions, Tt, Hn, ue, Va, La, ta, ni, i.ah.vertical, !1, Qt, Ft));
                                }
                            }
                            let Di = !1;
                            if (at.icon && at.icon.name) {
                                let ki = R.imageMap[at.icon.name];
                                ki && ($r = jx(R.imagePositions[at.icon.name], D.get("icon-offset").evaluate(at, {}, R.canonical), D.get("icon-anchor").evaluate(at, {}, R.canonical)), Di = !!ki.sdf, R.bucket.sdfIcons === void 0 ? R.bucket.sdfIcons = Di : R.bucket.sdfIcons !== Di && T("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (ki.pixelRatio !== R.bucket.pixelRatio || D.get("icon-rotate").constantOr(1) !== 0) && (R.bucket.iconsNeedLinear = !0));
                            }
                            let pi = qC(Tr.horizontal) || Tr.vertical;
                            R.bucket.iconsInText = !!pi && pi.iconsInText, (pi || $r) && K9(R.bucket, at, Tr, $r, R.imageMap, te, Qt, sr, ni, Di, R.canonical);
                        }
                        R.showCollisionBoxes && R.bucket.generateCollisionDebugBuffers();
                    }, i.bq = Kv, i.br = dr, i.bs = fo, i.bt = ei, i.bu = eS, i.bv = class {
                        constructor(R){
                            this._marks = {
                                start: [
                                    R.url,
                                    "start"
                                ].join("#"),
                                end: [
                                    R.url,
                                    "end"
                                ].join("#"),
                                measure: R.url.toString()
                            }, performance.mark(this._marks.start);
                        }
                        finish() {
                            performance.mark(this._marks.end);
                            let R = performance.getEntriesByName(this._marks.measure);
                            return R.length === 0 && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), R = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), R;
                        }
                    }, i.bw = function(R, S, D, j, te) {
                        return a(this, void 0, void 0, function*() {
                            if (b()) try {
                                return yield G(R, S, D, j, te);
                            } catch (ue) {}
                            return function(ue, ve, De, Ze, at) {
                                let Tt = ue.width, Ft = ue.height;
                                N && W || (N = new OffscreenCanvas(Tt, Ft), W = N.getContext("2d", {
                                    willReadFrequently: !0
                                })), N.width = Tt, N.height = Ft, W.drawImage(ue, 0, 0, Tt, Ft);
                                let Qt = W.getImageData(ve, De, Ze, at);
                                return W.clearRect(0, 0, Tt, Ft), Qt.data;
                            }(R, S, D, j, te);
                        });
                    }, i.bx = AC, i.by = o, i.bz = s, i.c = ae, i.d = (R)=>a(void 0, void 0, void 0, function*() {
                            if (R.byteLength === 0) return createImageBitmap(new ImageData(1, 1));
                            let S = new Blob([
                                new Uint8Array(R)
                            ], {
                                type: "image/png"
                            });
                            try {
                                return createImageBitmap(S);
                            } catch (D) {
                                throw new Error(`Could not load image because of ${D.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
                            }
                        }), i.e = L, i.f = (R)=>new Promise((S, D)=>{
                            let j = new Image;
                            j.onload = ()=>{
                                S(j), URL.revokeObjectURL(j.src), j.onload = null, window.requestAnimationFrame(()=>{
                                    j.src = X;
                                });
                            }, j.onerror = ()=>D(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                            let te = new Blob([
                                new Uint8Array(R)
                            ], {
                                type: "image/png"
                            });
                            j.src = R.byteLength ? URL.createObjectURL(te) : X;
                        }), i.g = Me, i.h = (R, S)=>Te(L(R, {
                            type: "json"
                        }), S), i.i = q, i.j = me, i.k = Ce, i.l = (R, S)=>Te(L(R, {
                            type: "arrayBuffer"
                        }), S), i.m = Te, i.n = function(R) {
                        return new eS(R).readFields(yQ, []);
                    }, i.o = Ao, i.p = rS, i.q = le, i.r = xi, i.s = Ee, i.t = Ti, i.u = fi, i.v = ce, i.w = T, i.x = function([R, S, D]) {
                        return S += 90, S *= Math.PI / 180, D *= Math.PI / 180, {
                            x: R * Math.cos(S) * Math.sin(D),
                            y: R * Math.sin(S) * Math.sin(D),
                            z: R * Math.cos(D)
                        };
                    }, i.y = Mo, i.z = Ko;
                }), r("worker", [
                    "./shared"
                ], function(i) {
                    "use strict";
                    class a {
                        constructor(Ne){
                            this.keyCache = {}, Ne && this.replace(Ne);
                        }
                        replace(Ne) {
                            this._layerConfigs = {}, this._layers = {}, this.update(Ne, []);
                        }
                        update(Ne, Ye) {
                            for (let Xe of Ne){
                                this._layerConfigs[Xe.id] = Xe;
                                let ht = this._layers[Xe.id] = i.aA(Xe);
                                ht._featureFilter = i.a7(ht.filter), this.keyCache[Xe.id] && delete this.keyCache[Xe.id];
                            }
                            for (let Xe of Ye)delete this.keyCache[Xe], delete this._layerConfigs[Xe], delete this._layers[Xe];
                            this.familiesBySource = {};
                            let Ve = i.bk(Object.values(this._layerConfigs), this.keyCache);
                            for (let Xe of Ve){
                                let ht = Xe.map((Vt)=>this._layers[Vt.id]), Le = ht[0];
                                if (Le.visibility === "none") continue;
                                let xe = Le.source || "", Se = this.familiesBySource[xe];
                                Se || (Se = this.familiesBySource[xe] = {});
                                let lt = Le.sourceLayer || "_geojsonTileLayer", Gt = Se[lt];
                                Gt || (Gt = Se[lt] = []), Gt.push(ht);
                            }
                        }
                    }
                    class o {
                        constructor(Ne){
                            let Ye = {}, Ve = [];
                            for(let xe in Ne){
                                let Se = Ne[xe], lt = Ye[xe] = {};
                                for(let Gt in Se){
                                    let Vt = Se[+Gt];
                                    if (!Vt || Vt.bitmap.width === 0 || Vt.bitmap.height === 0) continue;
                                    let ar = {
                                        x: 0,
                                        y: 0,
                                        w: Vt.bitmap.width + 2,
                                        h: Vt.bitmap.height + 2
                                    };
                                    Ve.push(ar), lt[Gt] = {
                                        rect: ar,
                                        metrics: Vt.metrics
                                    };
                                }
                            }
                            let { w: Xe, h: ht } = i.p(Ve), Le = new i.o({
                                width: Xe || 1,
                                height: ht || 1
                            });
                            for(let xe in Ne){
                                let Se = Ne[xe];
                                for(let lt in Se){
                                    let Gt = Se[+lt];
                                    if (!Gt || Gt.bitmap.width === 0 || Gt.bitmap.height === 0) continue;
                                    let Vt = Ye[xe][lt].rect;
                                    i.o.copy(Gt.bitmap, Le, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: Vt.x + 1,
                                        y: Vt.y + 1
                                    }, Gt.bitmap);
                                }
                            }
                            this.image = Le, this.positions = Ye;
                        }
                    }
                    i.bl("GlyphAtlas", o);
                    class s {
                        constructor(Ne){
                            this.tileID = new i.S(Ne.tileID.overscaledZ, Ne.tileID.wrap, Ne.tileID.canonical.z, Ne.tileID.canonical.x, Ne.tileID.canonical.y), this.uid = Ne.uid, this.zoom = Ne.zoom, this.pixelRatio = Ne.pixelRatio, this.tileSize = Ne.tileSize, this.source = Ne.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = Ne.showCollisionBoxes, this.collectResourceTiming = !!Ne.collectResourceTiming, this.returnDependencies = !!Ne.returnDependencies, this.promoteId = Ne.promoteId, this.inFlightDependencies = [];
                        }
                        parse(Ne, Ye, Ve, Xe) {
                            return i._(this, void 0, void 0, function*() {
                                this.status = "parsing", this.data = Ne, this.collisionBoxArray = new i.a5;
                                let ht = new i.bm(Object.keys(Ne.layers).sort()), Le = new i.bn(this.tileID, this.promoteId);
                                Le.bucketLayerIDs = [];
                                let xe = {}, Se = {
                                    featureIndex: Le,
                                    iconDependencies: {},
                                    patternDependencies: {},
                                    glyphDependencies: {},
                                    availableImages: Ve
                                }, lt = Ye.familiesBySource[this.source];
                                for(let _n in lt){
                                    let $i = Ne.layers[_n];
                                    if (!$i) continue;
                                    $i.version === 1 && i.w(`Vector tile source "${this.source}" layer "${_n}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                                    let zn = ht.encode(_n), Wn = [];
                                    for(let It = 0; It < $i.length; It++){
                                        let ft = $i.feature(It), jt = Le.getId(ft, _n);
                                        Wn.push({
                                            feature: ft,
                                            id: jt,
                                            index: It,
                                            sourceLayerIndex: zn
                                        });
                                    }
                                    for (let It of lt[_n]){
                                        let ft = It[0];
                                        ft.source !== this.source && i.w(`layer.source = ${ft.source} does not equal this.source = ${this.source}`), ft.minzoom && this.zoom < Math.floor(ft.minzoom) || ft.maxzoom && this.zoom >= ft.maxzoom || ft.visibility !== "none" && (l(It, this.zoom, Ve), (xe[ft.id] = ft.createBucket({
                                            index: Le.bucketLayerIDs.length,
                                            layers: It,
                                            zoom: this.zoom,
                                            pixelRatio: this.pixelRatio,
                                            overscaling: this.overscaling,
                                            collisionBoxArray: this.collisionBoxArray,
                                            sourceLayerIndex: zn,
                                            sourceID: this.source
                                        })).populate(Wn, Se, this.tileID.canonical), Le.bucketLayerIDs.push(It.map((jt)=>jt.id)));
                                    }
                                }
                                let Gt = i.aF(Se.glyphDependencies, (_n)=>Object.keys(_n).map(Number));
                                this.inFlightDependencies.forEach((_n)=>_n == null ? void 0 : _n.abort()), this.inFlightDependencies = [];
                                let Vt = Promise.resolve({});
                                if (Object.keys(Gt).length) {
                                    let _n = new AbortController;
                                    this.inFlightDependencies.push(_n), Vt = Xe.sendAsync({
                                        type: "GG",
                                        data: {
                                            stacks: Gt,
                                            source: this.source,
                                            tileID: this.tileID,
                                            type: "glyphs"
                                        }
                                    }, _n);
                                }
                                let ar = Object.keys(Se.iconDependencies), Qr = Promise.resolve({});
                                if (ar.length) {
                                    let _n = new AbortController;
                                    this.inFlightDependencies.push(_n), Qr = Xe.sendAsync({
                                        type: "GI",
                                        data: {
                                            icons: ar,
                                            source: this.source,
                                            tileID: this.tileID,
                                            type: "icons"
                                        }
                                    }, _n);
                                }
                                let ai = Object.keys(Se.patternDependencies), jr = Promise.resolve({});
                                if (ai.length) {
                                    let _n = new AbortController;
                                    this.inFlightDependencies.push(_n), jr = Xe.sendAsync({
                                        type: "GI",
                                        data: {
                                            icons: ai,
                                            source: this.source,
                                            tileID: this.tileID,
                                            type: "patterns"
                                        }
                                    }, _n);
                                }
                                let [ri, bi, nn] = yield Promise.all([
                                    Vt,
                                    Qr,
                                    jr
                                ]), Wi = new o(ri), Ni = new i.bo(bi, nn);
                                for(let _n in xe){
                                    let $i = xe[_n];
                                    $i instanceof i.a6 ? (l($i.layers, this.zoom, Ve), i.bp({
                                        bucket: $i,
                                        glyphMap: ri,
                                        glyphPositions: Wi.positions,
                                        imageMap: bi,
                                        imagePositions: Ni.iconPositions,
                                        showCollisionBoxes: this.showCollisionBoxes,
                                        canonical: this.tileID.canonical
                                    })) : $i.hasPattern && ($i instanceof i.bq || $i instanceof i.br || $i instanceof i.bs) && (l($i.layers, this.zoom, Ve), $i.addFeatures(Se, this.tileID.canonical, Ni.patternPositions));
                                }
                                return this.status = "done", {
                                    buckets: Object.values(xe).filter((_n)=>!_n.isEmpty()),
                                    featureIndex: Le,
                                    collisionBoxArray: this.collisionBoxArray,
                                    glyphAtlasImage: Wi.image,
                                    imageAtlas: Ni,
                                    glyphMap: this.returnDependencies ? ri : null,
                                    iconMap: this.returnDependencies ? bi : null,
                                    glyphPositions: this.returnDependencies ? Wi.positions : null
                                };
                            });
                        }
                    }
                    function l(ut, Ne, Ye) {
                        let Ve = new i.z(Ne);
                        for (let Xe of ut)Xe.recalculate(Ve, Ye);
                    }
                    class u {
                        constructor(Ne, Ye, Ve){
                            this.actor = Ne, this.layerIndex = Ye, this.availableImages = Ve, this.fetching = {}, this.loading = {}, this.loaded = {};
                        }
                        loadVectorTile(Ne, Ye) {
                            return i._(this, void 0, void 0, function*() {
                                let Ve = yield i.l(Ne.request, Ye);
                                try {
                                    return {
                                        vectorTile: new i.bt.VectorTile(new i.bu(Ve.data)),
                                        rawData: Ve.data,
                                        cacheControl: Ve.cacheControl,
                                        expires: Ve.expires
                                    };
                                } catch (Xe) {
                                    let ht = new Uint8Array(Ve.data), Le = `Unable to parse the tile at ${Ne.request.url}, `;
                                    throw Le += ht[0] === 31 && ht[1] === 139 ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${Xe.message}`, new Error(Le);
                                }
                            });
                        }
                        loadTile(Ne) {
                            return i._(this, void 0, void 0, function*() {
                                let Ye = Ne.uid, Ve = !!(Ne && Ne.request && Ne.request.collectResourceTiming) && new i.bv(Ne.request), Xe = new s(Ne);
                                this.loading[Ye] = Xe;
                                let ht = new AbortController;
                                Xe.abort = ht;
                                try {
                                    let Le = yield this.loadVectorTile(Ne, ht);
                                    if (delete this.loading[Ye], !Le) return null;
                                    let xe = Le.rawData, Se = {};
                                    Le.expires && (Se.expires = Le.expires), Le.cacheControl && (Se.cacheControl = Le.cacheControl);
                                    let lt = {};
                                    if (Ve) {
                                        let Vt = Ve.finish();
                                        Vt && (lt.resourceTiming = JSON.parse(JSON.stringify(Vt)));
                                    }
                                    Xe.vectorTile = Le.vectorTile;
                                    let Gt = Xe.parse(Le.vectorTile, this.layerIndex, this.availableImages, this.actor);
                                    this.loaded[Ye] = Xe, this.fetching[Ye] = {
                                        rawTileData: xe,
                                        cacheControl: Se,
                                        resourceTiming: lt
                                    };
                                    try {
                                        let Vt = yield Gt;
                                        return i.e({
                                            rawTileData: xe.slice(0)
                                        }, Vt, Se, lt);
                                    } finally{
                                        delete this.fetching[Ye];
                                    }
                                } catch (Le) {
                                    throw delete this.loading[Ye], Xe.status = "done", this.loaded[Ye] = Xe, Le;
                                }
                            });
                        }
                        reloadTile(Ne) {
                            return i._(this, void 0, void 0, function*() {
                                let Ye = Ne.uid;
                                if (!this.loaded || !this.loaded[Ye]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                                let Ve = this.loaded[Ye];
                                if (Ve.showCollisionBoxes = Ne.showCollisionBoxes, Ve.status === "parsing") {
                                    let Xe = yield Ve.parse(Ve.vectorTile, this.layerIndex, this.availableImages, this.actor), ht;
                                    if (this.fetching[Ye]) {
                                        let { rawTileData: Le, cacheControl: xe, resourceTiming: Se } = this.fetching[Ye];
                                        delete this.fetching[Ye], ht = i.e({
                                            rawTileData: Le.slice(0)
                                        }, Xe, xe, Se);
                                    } else ht = Xe;
                                    return ht;
                                }
                                if (Ve.status === "done" && Ve.vectorTile) return Ve.parse(Ve.vectorTile, this.layerIndex, this.availableImages, this.actor);
                            });
                        }
                        abortTile(Ne) {
                            return i._(this, void 0, void 0, function*() {
                                let Ye = this.loading, Ve = Ne.uid;
                                Ye && Ye[Ve] && Ye[Ve].abort && (Ye[Ve].abort.abort(), delete Ye[Ve]);
                            });
                        }
                        removeTile(Ne) {
                            return i._(this, void 0, void 0, function*() {
                                this.loaded && this.loaded[Ne.uid] && delete this.loaded[Ne.uid];
                            });
                        }
                    }
                    class c {
                        constructor(){
                            this.loaded = {};
                        }
                        loadTile(Ne) {
                            return i._(this, void 0, void 0, function*() {
                                let { uid: Ye, encoding: Ve, rawImageData: Xe, redFactor: ht, greenFactor: Le, blueFactor: xe, baseShift: Se } = Ne, lt = Xe.width + 2, Gt = Xe.height + 2, Vt = i.b(Xe) ? new i.R({
                                    width: lt,
                                    height: Gt
                                }, (yield i.bw(Xe, -1, -1, lt, Gt))) : Xe, ar = new i.bx(Ye, Vt, Ve, ht, Le, xe, Se);
                                return this.loaded = this.loaded || {}, this.loaded[Ye] = ar, ar;
                            });
                        }
                        removeTile(Ne) {
                            let Ye = this.loaded, Ve = Ne.uid;
                            Ye && Ye[Ve] && delete Ye[Ve];
                        }
                    }
                    function f(ut, Ne) {
                        if (ut.length !== 0) {
                            h(ut[0], Ne);
                            for(var Ye = 1; Ye < ut.length; Ye++)h(ut[Ye], !Ne);
                        }
                    }
                    function h(ut, Ne) {
                        for(var Ye = 0, Ve = 0, Xe = 0, ht = ut.length, Le = ht - 1; Xe < ht; Le = Xe++){
                            var xe = (ut[Xe][0] - ut[Le][0]) * (ut[Le][1] + ut[Xe][1]), Se = Ye + xe;
                            Ve += Math.abs(Ye) >= Math.abs(xe) ? Ye - Se + xe : xe - Se + Ye, Ye = Se;
                        }
                        Ye + Ve >= 0 != !!Ne && ut.reverse();
                    }
                    var d = i.by(function ut(Ne, Ye) {
                        var Ve, Xe = Ne && Ne.type;
                        if (Xe === "FeatureCollection") for(Ve = 0; Ve < Ne.features.length; Ve++)ut(Ne.features[Ve], Ye);
                        else if (Xe === "GeometryCollection") for(Ve = 0; Ve < Ne.geometries.length; Ve++)ut(Ne.geometries[Ve], Ye);
                        else if (Xe === "Feature") ut(Ne.geometry, Ye);
                        else if (Xe === "Polygon") f(Ne.coordinates, Ye);
                        else if (Xe === "MultiPolygon") for(Ve = 0; Ve < Ne.coordinates.length; Ve++)f(Ne.coordinates[Ve], Ye);
                        return Ne;
                    });
                    let v = i.bt.VectorTileFeature.prototype.toGeoJSON;
                    var x = {
                        exports: {}
                    }, b = i.bz, p = i.bt.VectorTileFeature, E = k;
                    function k(ut, Ne) {
                        this.options = Ne || {}, this.features = ut, this.length = ut.length;
                    }
                    function A(ut, Ne) {
                        this.id = typeof ut.id == "number" ? ut.id : void 0, this.type = ut.type, this.rawGeometry = ut.type === 1 ? [
                            ut.geometry
                        ] : ut.geometry, this.properties = ut.tags, this.extent = Ne || 4096;
                    }
                    k.prototype.feature = function(ut) {
                        return new A(this.features[ut], this.options.extent);
                    }, A.prototype.loadGeometry = function() {
                        var ut = this.rawGeometry;
                        this.geometry = [];
                        for(var Ne = 0; Ne < ut.length; Ne++){
                            for(var Ye = ut[Ne], Ve = [], Xe = 0; Xe < Ye.length; Xe++)Ve.push(new b(Ye[Xe][0], Ye[Xe][1]));
                            this.geometry.push(Ve);
                        }
                        return this.geometry;
                    }, A.prototype.bbox = function() {
                        this.geometry || this.loadGeometry();
                        for(var ut = this.geometry, Ne = 1 / 0, Ye = -1 / 0, Ve = 1 / 0, Xe = -1 / 0, ht = 0; ht < ut.length; ht++)for(var Le = ut[ht], xe = 0; xe < Le.length; xe++){
                            var Se = Le[xe];
                            Ne = Math.min(Ne, Se.x), Ye = Math.max(Ye, Se.x), Ve = Math.min(Ve, Se.y), Xe = Math.max(Xe, Se.y);
                        }
                        return [
                            Ne,
                            Ve,
                            Ye,
                            Xe
                        ];
                    }, A.prototype.toGeoJSON = p.prototype.toGeoJSON;
                    var L = i.bA, _ = E;
                    function C(ut) {
                        var Ne = new L;
                        return function(Ye, Ve) {
                            for(var Xe in Ye.layers)Ve.writeMessage(3, M, Ye.layers[Xe]);
                        }(ut, Ne), Ne.finish();
                    }
                    function M(ut, Ne) {
                        var Ye;
                        Ne.writeVarintField(15, ut.version || 1), Ne.writeStringField(1, ut.name || ""), Ne.writeVarintField(5, ut.extent || 4096);
                        var Ve = {
                            keys: [],
                            values: [],
                            keycache: {},
                            valuecache: {}
                        };
                        for(Ye = 0; Ye < ut.length; Ye++)Ve.feature = ut.feature(Ye), Ne.writeMessage(2, g, Ve);
                        var Xe = Ve.keys;
                        for(Ye = 0; Ye < Xe.length; Ye++)Ne.writeStringField(3, Xe[Ye]);
                        var ht = Ve.values;
                        for(Ye = 0; Ye < ht.length; Ye++)Ne.writeMessage(4, V, ht[Ye]);
                    }
                    function g(ut, Ne) {
                        var Ye = ut.feature;
                        Ye.id !== void 0 && Ne.writeVarintField(1, Ye.id), Ne.writeMessage(2, P, ut), Ne.writeVarintField(3, Ye.type), Ne.writeMessage(4, q, Ye);
                    }
                    function P(ut, Ne) {
                        var Ye = ut.feature, Ve = ut.keys, Xe = ut.values, ht = ut.keycache, Le = ut.valuecache;
                        for(var xe in Ye.properties){
                            var Se = Ye.properties[xe], lt = ht[xe];
                            if (Se !== null) {
                                lt === void 0 && (Ve.push(xe), ht[xe] = lt = Ve.length - 1), Ne.writeVarint(lt);
                                var Gt = typeof Se;
                                Gt !== "string" && Gt !== "boolean" && Gt !== "number" && (Se = JSON.stringify(Se));
                                var Vt = Gt + ":" + Se, ar = Le[Vt];
                                ar === void 0 && (Xe.push(Se), Le[Vt] = ar = Xe.length - 1), Ne.writeVarint(ar);
                            }
                        }
                    }
                    function T(ut, Ne) {
                        return (Ne << 3) + (7 & ut);
                    }
                    function F(ut) {
                        return ut << 1 ^ ut >> 31;
                    }
                    function q(ut, Ne) {
                        for(var Ye = ut.loadGeometry(), Ve = ut.type, Xe = 0, ht = 0, Le = Ye.length, xe = 0; xe < Le; xe++){
                            var Se = Ye[xe], lt = 1;
                            Ve === 1 && (lt = Se.length), Ne.writeVarint(T(1, lt));
                            for(var Gt = Ve === 3 ? Se.length - 1 : Se.length, Vt = 0; Vt < Gt; Vt++){
                                Vt === 1 && Ve !== 1 && Ne.writeVarint(T(2, Gt - 1));
                                var ar = Se[Vt].x - Xe, Qr = Se[Vt].y - ht;
                                Ne.writeVarint(F(ar)), Ne.writeVarint(F(Qr)), Xe += ar, ht += Qr;
                            }
                            Ve === 3 && Ne.writeVarint(T(7, 1));
                        }
                    }
                    function V(ut, Ne) {
                        var Ye = typeof ut;
                        Ye === "string" ? Ne.writeStringField(1, ut) : Ye === "boolean" ? Ne.writeBooleanField(7, ut) : Ye === "number" && (ut % 1 != 0 ? Ne.writeDoubleField(3, ut) : ut < 0 ? Ne.writeSVarintField(6, ut) : Ne.writeVarintField(5, ut));
                    }
                    x.exports = C, x.exports.fromVectorTileJs = C, x.exports.fromGeojsonVt = function(ut, Ne) {
                        Ne = Ne || {};
                        var Ye = {};
                        for(var Ve in ut)Ye[Ve] = new _(ut[Ve].features, Ne), Ye[Ve].name = Ve, Ye[Ve].version = Ne.version, Ye[Ve].extent = Ne.extent;
                        return C({
                            layers: Ye
                        });
                    }, x.exports.GeoJSONWrapper = _;
                    var H = i.by(x.exports);
                    let X = {
                        minZoom: 0,
                        maxZoom: 16,
                        minPoints: 2,
                        radius: 40,
                        extent: 512,
                        nodeSize: 64,
                        log: !1,
                        generateId: !1,
                        reduce: null,
                        map: (ut)=>ut
                    }, G = Math.fround || (N = new Float32Array(1), (ut)=>(N[0] = +ut, N[0]));
                    var N;
                    let W = 3, re = 5, ae = 6;
                    class _e {
                        constructor(Ne){
                            this.options = Object.assign(Object.create(X), Ne), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
                        }
                        load(Ne) {
                            let { log: Ye, minZoom: Ve, maxZoom: Xe } = this.options;
                            Ye && console.time("total time");
                            let ht = `prepare ${Ne.length} points`;
                            Ye && console.time(ht), this.points = Ne;
                            let Le = [];
                            for(let Se = 0; Se < Ne.length; Se++){
                                let lt = Ne[Se];
                                if (!lt.geometry) continue;
                                let [Gt, Vt] = lt.geometry.coordinates, ar = G(ge(Gt)), Qr = G(ie(Vt));
                                Le.push(ar, Qr, 1 / 0, Se, -1, 1), this.options.reduce && Le.push(0);
                            }
                            let xe = this.trees[Xe + 1] = this._createTree(Le);
                            Ye && console.timeEnd(ht);
                            for(let Se = Xe; Se >= Ve; Se--){
                                let lt = +Date.now();
                                xe = this.trees[Se] = this._createTree(this._cluster(xe, Se)), Ye && console.log("z%d: %d clusters in %dms", Se, xe.numItems, +Date.now() - lt);
                            }
                            return Ye && console.timeEnd("total time"), this;
                        }
                        getClusters(Ne, Ye) {
                            let Ve = ((Ne[0] + 180) % 360 + 360) % 360 - 180, Xe = Math.max(-90, Math.min(90, Ne[1])), ht = Ne[2] === 180 ? 180 : ((Ne[2] + 180) % 360 + 360) % 360 - 180, Le = Math.max(-90, Math.min(90, Ne[3]));
                            if (Ne[2] - Ne[0] >= 360) Ve = -180, ht = 180;
                            else if (Ve > ht) {
                                let Vt = this.getClusters([
                                    Ve,
                                    Xe,
                                    180,
                                    Le
                                ], Ye), ar = this.getClusters([
                                    -180,
                                    Xe,
                                    ht,
                                    Le
                                ], Ye);
                                return Vt.concat(ar);
                            }
                            let xe = this.trees[this._limitZoom(Ye)], Se = xe.range(ge(Ve), ie(Le), ge(ht), ie(Xe)), lt = xe.data, Gt = [];
                            for (let Vt of Se){
                                let ar = this.stride * Vt;
                                Gt.push(lt[ar + re] > 1 ? Me(lt, ar, this.clusterProps) : this.points[lt[ar + W]]);
                            }
                            return Gt;
                        }
                        getChildren(Ne) {
                            let Ye = this._getOriginId(Ne), Ve = this._getOriginZoom(Ne), Xe = "No cluster with the specified id.", ht = this.trees[Ve];
                            if (!ht) throw new Error(Xe);
                            let Le = ht.data;
                            if (Ye * this.stride >= Le.length) throw new Error(Xe);
                            let xe = this.options.radius / (this.options.extent * Math.pow(2, Ve - 1)), Se = ht.within(Le[Ye * this.stride], Le[Ye * this.stride + 1], xe), lt = [];
                            for (let Gt of Se){
                                let Vt = Gt * this.stride;
                                Le[Vt + 4] === Ne && lt.push(Le[Vt + re] > 1 ? Me(Le, Vt, this.clusterProps) : this.points[Le[Vt + W]]);
                            }
                            if (lt.length === 0) throw new Error(Xe);
                            return lt;
                        }
                        getLeaves(Ne, Ye, Ve) {
                            let Xe = [];
                            return this._appendLeaves(Xe, Ne, Ye = Ye || 10, Ve = Ve || 0, 0), Xe;
                        }
                        getTile(Ne, Ye, Ve) {
                            let Xe = this.trees[this._limitZoom(Ne)], ht = Math.pow(2, Ne), { extent: Le, radius: xe } = this.options, Se = xe / Le, lt = (Ve - Se) / ht, Gt = (Ve + 1 + Se) / ht, Vt = {
                                features: []
                            };
                            return this._addTileFeatures(Xe.range((Ye - Se) / ht, lt, (Ye + 1 + Se) / ht, Gt), Xe.data, Ye, Ve, ht, Vt), Ye === 0 && this._addTileFeatures(Xe.range(1 - Se / ht, lt, 1, Gt), Xe.data, ht, Ve, ht, Vt), Ye === ht - 1 && this._addTileFeatures(Xe.range(0, lt, Se / ht, Gt), Xe.data, -1, Ve, ht, Vt), Vt.features.length ? Vt : null;
                        }
                        getClusterExpansionZoom(Ne) {
                            let Ye = this._getOriginZoom(Ne) - 1;
                            for(; Ye <= this.options.maxZoom;){
                                let Ve = this.getChildren(Ne);
                                if (Ye++, Ve.length !== 1) break;
                                Ne = Ve[0].properties.cluster_id;
                            }
                            return Ye;
                        }
                        _appendLeaves(Ne, Ye, Ve, Xe, ht) {
                            let Le = this.getChildren(Ye);
                            for (let xe of Le){
                                let Se = xe.properties;
                                if (Se && Se.cluster ? ht + Se.point_count <= Xe ? ht += Se.point_count : ht = this._appendLeaves(Ne, Se.cluster_id, Ve, Xe, ht) : ht < Xe ? ht++ : Ne.push(xe), Ne.length === Ve) break;
                            }
                            return ht;
                        }
                        _createTree(Ne) {
                            let Ye = new i.av(Ne.length / this.stride | 0, this.options.nodeSize, Float32Array);
                            for(let Ve = 0; Ve < Ne.length; Ve += this.stride)Ye.add(Ne[Ve], Ne[Ve + 1]);
                            return Ye.finish(), Ye.data = Ne, Ye;
                        }
                        _addTileFeatures(Ne, Ye, Ve, Xe, ht, Le) {
                            for (let xe of Ne){
                                let Se = xe * this.stride, lt = Ye[Se + re] > 1, Gt, Vt, ar;
                                if (lt) Gt = ke(Ye, Se, this.clusterProps), Vt = Ye[Se], ar = Ye[Se + 1];
                                else {
                                    let jr = this.points[Ye[Se + W]];
                                    Gt = jr.properties;
                                    let [ri, bi] = jr.geometry.coordinates;
                                    Vt = ge(ri), ar = ie(bi);
                                }
                                let Qr = {
                                    type: 1,
                                    geometry: [
                                        [
                                            Math.round(this.options.extent * (Vt * ht - Ve)),
                                            Math.round(this.options.extent * (ar * ht - Xe))
                                        ]
                                    ],
                                    tags: Gt
                                }, ai;
                                ai = lt || this.options.generateId ? Ye[Se + W] : this.points[Ye[Se + W]].id, ai !== void 0 && (Qr.id = ai), Le.features.push(Qr);
                            }
                        }
                        _limitZoom(Ne) {
                            return Math.max(this.options.minZoom, Math.min(Math.floor(+Ne), this.options.maxZoom + 1));
                        }
                        _cluster(Ne, Ye) {
                            let { radius: Ve, extent: Xe, reduce: ht, minPoints: Le } = this.options, xe = Ve / (Xe * Math.pow(2, Ye)), Se = Ne.data, lt = [], Gt = this.stride;
                            for(let Vt = 0; Vt < Se.length; Vt += Gt){
                                if (Se[Vt + 2] <= Ye) continue;
                                Se[Vt + 2] = Ye;
                                let ar = Se[Vt], Qr = Se[Vt + 1], ai = Ne.within(Se[Vt], Se[Vt + 1], xe), jr = Se[Vt + re], ri = jr;
                                for (let bi of ai){
                                    let nn = bi * Gt;
                                    Se[nn + 2] > Ye && (ri += Se[nn + re]);
                                }
                                if (ri > jr && ri >= Le) {
                                    let bi, nn = ar * jr, Wi = Qr * jr, Ni = -1, _n = ((Vt / Gt | 0) << 5) + (Ye + 1) + this.points.length;
                                    for (let $i of ai){
                                        let zn = $i * Gt;
                                        if (Se[zn + 2] <= Ye) continue;
                                        Se[zn + 2] = Ye;
                                        let Wn = Se[zn + re];
                                        nn += Se[zn] * Wn, Wi += Se[zn + 1] * Wn, Se[zn + 4] = _n, ht && (bi || (bi = this._map(Se, Vt, !0), Ni = this.clusterProps.length, this.clusterProps.push(bi)), ht(bi, this._map(Se, zn)));
                                    }
                                    Se[Vt + 4] = _n, lt.push(nn / ri, Wi / ri, 1 / 0, _n, -1, ri), ht && lt.push(Ni);
                                } else {
                                    for(let bi = 0; bi < Gt; bi++)lt.push(Se[Vt + bi]);
                                    if (ri > 1) for (let bi of ai){
                                        let nn = bi * Gt;
                                        if (!(Se[nn + 2] <= Ye)) {
                                            Se[nn + 2] = Ye;
                                            for(let Wi = 0; Wi < Gt; Wi++)lt.push(Se[nn + Wi]);
                                        }
                                    }
                                }
                            }
                            return lt;
                        }
                        _getOriginId(Ne) {
                            return Ne - this.points.length >> 5;
                        }
                        _getOriginZoom(Ne) {
                            return (Ne - this.points.length) % 32;
                        }
                        _map(Ne, Ye, Ve) {
                            if (Ne[Ye + re] > 1) {
                                let Le = this.clusterProps[Ne[Ye + ae]];
                                return Ve ? Object.assign({}, Le) : Le;
                            }
                            let Xe = this.points[Ne[Ye + W]].properties, ht = this.options.map(Xe);
                            return Ve && ht === Xe ? Object.assign({}, ht) : ht;
                        }
                    }
                    function Me(ut, Ne, Ye) {
                        var Ve;
                        return {
                            type: "Feature",
                            id: ut[Ne + W],
                            properties: ke(ut, Ne, Ye),
                            geometry: {
                                type: "Point",
                                coordinates: [
                                    (Ve = ut[Ne], 360 * (Ve - .5)),
                                    Te(ut[Ne + 1])
                                ]
                            }
                        };
                    }
                    function ke(ut, Ne, Ye) {
                        let Ve = ut[Ne + re], Xe = Ve >= 1e4 ? `${Math.round(Ve / 1e3)}k` : Ve >= 1e3 ? Math.round(Ve / 100) / 10 + "k" : Ve, ht = ut[Ne + ae], Le = ht === -1 ? {} : Object.assign({}, Ye[ht]);
                        return Object.assign(Le, {
                            cluster: !0,
                            cluster_id: ut[Ne + W],
                            point_count: Ve,
                            point_count_abbreviated: Xe
                        });
                    }
                    function ge(ut) {
                        return ut / 360 + .5;
                    }
                    function ie(ut) {
                        let Ne = Math.sin(ut * Math.PI / 180), Ye = .5 - .25 * Math.log((1 + Ne) / (1 - Ne)) / Math.PI;
                        return Ye < 0 ? 0 : Ye > 1 ? 1 : Ye;
                    }
                    function Te(ut) {
                        let Ne = (180 - 360 * ut) * Math.PI / 180;
                        return 360 * Math.atan(Math.exp(Ne)) / Math.PI - 90;
                    }
                    function Ee(ut, Ne, Ye, Ve) {
                        let Xe = Ve, ht = Ne + (Ye - Ne >> 1), Le, xe = Ye - Ne, Se = ut[Ne], lt = ut[Ne + 1], Gt = ut[Ye], Vt = ut[Ye + 1];
                        for(let ar = Ne + 3; ar < Ye; ar += 3){
                            let Qr = Ae(ut[ar], ut[ar + 1], Se, lt, Gt, Vt);
                            if (Qr > Xe) Le = ar, Xe = Qr;
                            else if (Qr === Xe) {
                                let ai = Math.abs(ar - ht);
                                ai < xe && (Le = ar, xe = ai);
                            }
                        }
                        Xe > Ve && (Le - Ne > 3 && Ee(ut, Ne, Le, Ve), ut[Le + 2] = Xe, Ye - Le > 3 && Ee(ut, Le, Ye, Ve));
                    }
                    function Ae(ut, Ne, Ye, Ve, Xe, ht) {
                        let Le = Xe - Ye, xe = ht - Ve;
                        if (Le !== 0 || xe !== 0) {
                            let Se = ((ut - Ye) * Le + (Ne - Ve) * xe) / (Le * Le + xe * xe);
                            Se > 1 ? (Ye = Xe, Ve = ht) : Se > 0 && (Ye += Le * Se, Ve += xe * Se);
                        }
                        return Le = ut - Ye, xe = Ne - Ve, Le * Le + xe * xe;
                    }
                    function ze(ut, Ne, Ye, Ve) {
                        let Xe = {
                            id: ut == null ? null : ut,
                            type: Ne,
                            geometry: Ye,
                            tags: Ve,
                            minX: 1 / 0,
                            minY: 1 / 0,
                            maxX: -1 / 0,
                            maxY: -1 / 0
                        };
                        if (Ne === "Point" || Ne === "MultiPoint" || Ne === "LineString") Ce(Xe, Ye);
                        else if (Ne === "Polygon") Ce(Xe, Ye[0]);
                        else if (Ne === "MultiLineString") for (let ht of Ye)Ce(Xe, ht);
                        else if (Ne === "MultiPolygon") for (let ht of Ye)Ce(Xe, ht[0]);
                        return Xe;
                    }
                    function Ce(ut, Ne) {
                        for(let Ye = 0; Ye < Ne.length; Ye += 3)ut.minX = Math.min(ut.minX, Ne[Ye]), ut.minY = Math.min(ut.minY, Ne[Ye + 1]), ut.maxX = Math.max(ut.maxX, Ne[Ye]), ut.maxY = Math.max(ut.maxY, Ne[Ye + 1]);
                    }
                    function me(ut, Ne, Ye, Ve) {
                        if (!Ne.geometry) return;
                        let Xe = Ne.geometry.coordinates;
                        if (Xe && Xe.length === 0) return;
                        let ht = Ne.geometry.type, Le = Math.pow(Ye.tolerance / ((1 << Ye.maxZoom) * Ye.extent), 2), xe = [], Se = Ne.id;
                        if (Ye.promoteId ? Se = Ne.properties[Ye.promoteId] : Ye.generateId && (Se = Ve || 0), ht === "Point") Re(Xe, xe);
                        else if (ht === "MultiPoint") for (let lt of Xe)Re(lt, xe);
                        else if (ht === "LineString") ce(Xe, xe, Le, !1);
                        else if (ht === "MultiLineString") {
                            if (Ye.lineMetrics) {
                                for (let lt of Xe)xe = [], ce(lt, xe, Le, !1), ut.push(ze(Se, "LineString", xe, Ne.properties));
                                return;
                            }
                            Ge(Xe, xe, Le, !1);
                        } else if (ht === "Polygon") Ge(Xe, xe, Le, !0);
                        else {
                            if (ht !== "MultiPolygon") {
                                if (ht === "GeometryCollection") {
                                    for (let lt of Ne.geometry.geometries)me(ut, {
                                        id: Se,
                                        geometry: lt,
                                        properties: Ne.properties
                                    }, Ye, Ve);
                                    return;
                                }
                                throw new Error("Input data is not a valid GeoJSON object.");
                            }
                            for (let lt of Xe){
                                let Gt = [];
                                Ge(lt, Gt, Le, !0), xe.push(Gt);
                            }
                        }
                        ut.push(ze(Se, ht, xe, Ne.properties));
                    }
                    function Re(ut, Ne) {
                        Ne.push(nt(ut[0]), ct(ut[1]), 0);
                    }
                    function ce(ut, Ne, Ye, Ve) {
                        let Xe, ht, Le = 0;
                        for(let Se = 0; Se < ut.length; Se++){
                            let lt = nt(ut[Se][0]), Gt = ct(ut[Se][1]);
                            Ne.push(lt, Gt, 0), Se > 0 && (Le += Ve ? (Xe * Gt - lt * ht) / 2 : Math.sqrt(Math.pow(lt - Xe, 2) + Math.pow(Gt - ht, 2))), Xe = lt, ht = Gt;
                        }
                        let xe = Ne.length - 3;
                        Ne[2] = 1, Ee(Ne, 0, xe, Ye), Ne[xe + 2] = 1, Ne.size = Math.abs(Le), Ne.start = 0, Ne.end = Ne.size;
                    }
                    function Ge(ut, Ne, Ye, Ve) {
                        for(let Xe = 0; Xe < ut.length; Xe++){
                            let ht = [];
                            ce(ut[Xe], ht, Ye, Ve), Ne.push(ht);
                        }
                    }
                    function nt(ut) {
                        return ut / 360 + .5;
                    }
                    function ct(ut) {
                        let Ne = Math.sin(ut * Math.PI / 180), Ye = .5 - .25 * Math.log((1 + Ne) / (1 - Ne)) / Math.PI;
                        return Ye < 0 ? 0 : Ye > 1 ? 1 : Ye;
                    }
                    function qt(ut, Ne, Ye, Ve, Xe, ht, Le, xe) {
                        if (Ve /= Ne, ht >= (Ye /= Ne) && Le < Ve) return ut;
                        if (Le < Ye || ht >= Ve) return null;
                        let Se = [];
                        for (let lt of ut){
                            let Gt = lt.geometry, Vt = lt.type, ar = Xe === 0 ? lt.minX : lt.minY, Qr = Xe === 0 ? lt.maxX : lt.maxY;
                            if (ar >= Ye && Qr < Ve) {
                                Se.push(lt);
                                continue;
                            }
                            if (Qr < Ye || ar >= Ve) continue;
                            let ai = [];
                            if (Vt === "Point" || Vt === "MultiPoint") rt(Gt, ai, Ye, Ve, Xe);
                            else if (Vt === "LineString") ot(Gt, ai, Ye, Ve, Xe, !1, xe.lineMetrics);
                            else if (Vt === "MultiLineString") kt(Gt, ai, Ye, Ve, Xe, !1);
                            else if (Vt === "Polygon") kt(Gt, ai, Ye, Ve, Xe, !0);
                            else if (Vt === "MultiPolygon") for (let jr of Gt){
                                let ri = [];
                                kt(jr, ri, Ye, Ve, Xe, !0), ri.length && ai.push(ri);
                            }
                            if (ai.length) {
                                if (xe.lineMetrics && Vt === "LineString") {
                                    for (let jr of ai)Se.push(ze(lt.id, Vt, jr, lt.tags));
                                    continue;
                                }
                                Vt !== "LineString" && Vt !== "MultiLineString" || (ai.length === 1 ? (Vt = "LineString", ai = ai[0]) : Vt = "MultiLineString"), Vt !== "Point" && Vt !== "MultiPoint" || (Vt = ai.length === 3 ? "Point" : "MultiPoint"), Se.push(ze(lt.id, Vt, ai, lt.tags));
                            }
                        }
                        return Se.length ? Se : null;
                    }
                    function rt(ut, Ne, Ye, Ve, Xe) {
                        for(let ht = 0; ht < ut.length; ht += 3){
                            let Le = ut[ht + Xe];
                            Le >= Ye && Le <= Ve && Ct(Ne, ut[ht], ut[ht + 1], ut[ht + 2]);
                        }
                    }
                    function ot(ut, Ne, Ye, Ve, Xe, ht, Le) {
                        let xe = Rt(ut), Se = Xe === 0 ? Yt : xr, lt, Gt, Vt = ut.start;
                        for(let ri = 0; ri < ut.length - 3; ri += 3){
                            let bi = ut[ri], nn = ut[ri + 1], Wi = ut[ri + 2], Ni = ut[ri + 3], _n = ut[ri + 4], $i = Xe === 0 ? bi : nn, zn = Xe === 0 ? Ni : _n, Wn = !1;
                            Le && (lt = Math.sqrt(Math.pow(bi - Ni, 2) + Math.pow(nn - _n, 2))), $i < Ye ? zn > Ye && (Gt = Se(xe, bi, nn, Ni, _n, Ye), Le && (xe.start = Vt + lt * Gt)) : $i > Ve ? zn < Ve && (Gt = Se(xe, bi, nn, Ni, _n, Ve), Le && (xe.start = Vt + lt * Gt)) : Ct(xe, bi, nn, Wi), zn < Ye && $i >= Ye && (Gt = Se(xe, bi, nn, Ni, _n, Ye), Wn = !0), zn > Ve && $i <= Ve && (Gt = Se(xe, bi, nn, Ni, _n, Ve), Wn = !0), !ht && Wn && (Le && (xe.end = Vt + lt * Gt), Ne.push(xe), xe = Rt(ut)), Le && (Vt += lt);
                        }
                        let ar = ut.length - 3, Qr = ut[ar], ai = ut[ar + 1], jr = Xe === 0 ? Qr : ai;
                        jr >= Ye && jr <= Ve && Ct(xe, Qr, ai, ut[ar + 2]), ar = xe.length - 3, ht && ar >= 3 && (xe[ar] !== xe[0] || xe[ar + 1] !== xe[1]) && Ct(xe, xe[0], xe[1], xe[2]), xe.length && Ne.push(xe);
                    }
                    function Rt(ut) {
                        let Ne = [];
                        return Ne.size = ut.size, Ne.start = ut.start, Ne.end = ut.end, Ne;
                    }
                    function kt(ut, Ne, Ye, Ve, Xe, ht) {
                        for (let Le of ut)ot(Le, Ne, Ye, Ve, Xe, ht, !1);
                    }
                    function Ct(ut, Ne, Ye, Ve) {
                        ut.push(Ne, Ye, Ve);
                    }
                    function Yt(ut, Ne, Ye, Ve, Xe, ht) {
                        let Le = (ht - Ne) / (Ve - Ne);
                        return Ct(ut, ht, Ye + (Xe - Ye) * Le, 1), Le;
                    }
                    function xr(ut, Ne, Ye, Ve, Xe, ht) {
                        let Le = (ht - Ye) / (Xe - Ye);
                        return Ct(ut, Ne + (Ve - Ne) * Le, ht, 1), Le;
                    }
                    function er(ut, Ne) {
                        let Ye = [];
                        for(let Ve = 0; Ve < ut.length; Ve++){
                            let Xe = ut[Ve], ht = Xe.type, Le;
                            if (ht === "Point" || ht === "MultiPoint" || ht === "LineString") Le = Ke(Xe.geometry, Ne);
                            else if (ht === "MultiLineString" || ht === "Polygon") {
                                Le = [];
                                for (let xe of Xe.geometry)Le.push(Ke(xe, Ne));
                            } else if (ht === "MultiPolygon") {
                                Le = [];
                                for (let xe of Xe.geometry){
                                    let Se = [];
                                    for (let lt of xe)Se.push(Ke(lt, Ne));
                                    Le.push(Se);
                                }
                            }
                            Ye.push(ze(Xe.id, ht, Le, Xe.tags));
                        }
                        return Ye;
                    }
                    function Ke(ut, Ne) {
                        let Ye = [];
                        Ye.size = ut.size, ut.start !== void 0 && (Ye.start = ut.start, Ye.end = ut.end);
                        for(let Ve = 0; Ve < ut.length; Ve += 3)Ye.push(ut[Ve] + Ne, ut[Ve + 1], ut[Ve + 2]);
                        return Ye;
                    }
                    function xt(ut, Ne) {
                        if (ut.transformed) return ut;
                        let Ye = 1 << ut.z, Ve = ut.x, Xe = ut.y;
                        for (let ht of ut.features){
                            let Le = ht.geometry, xe = ht.type;
                            if (ht.geometry = [], xe === 1) for(let Se = 0; Se < Le.length; Se += 2)ht.geometry.push(bt(Le[Se], Le[Se + 1], Ne, Ye, Ve, Xe));
                            else for(let Se = 0; Se < Le.length; Se++){
                                let lt = [];
                                for(let Gt = 0; Gt < Le[Se].length; Gt += 2)lt.push(bt(Le[Se][Gt], Le[Se][Gt + 1], Ne, Ye, Ve, Xe));
                                ht.geometry.push(lt);
                            }
                        }
                        return ut.transformed = !0, ut;
                    }
                    function bt(ut, Ne, Ye, Ve, Xe, ht) {
                        return [
                            Math.round(Ye * (ut * Ve - Xe)),
                            Math.round(Ye * (Ne * Ve - ht))
                        ];
                    }
                    function Lt(ut, Ne, Ye, Ve, Xe) {
                        let ht = Ne === Xe.maxZoom ? 0 : Xe.tolerance / ((1 << Ne) * Xe.extent), Le = {
                            features: [],
                            numPoints: 0,
                            numSimplified: 0,
                            numFeatures: ut.length,
                            source: null,
                            x: Ye,
                            y: Ve,
                            z: Ne,
                            transformed: !1,
                            minX: 2,
                            minY: 1,
                            maxX: -1,
                            maxY: 0
                        };
                        for (let xe of ut)St(Le, xe, ht, Xe);
                        return Le;
                    }
                    function St(ut, Ne, Ye, Ve) {
                        let Xe = Ne.geometry, ht = Ne.type, Le = [];
                        if (ut.minX = Math.min(ut.minX, Ne.minX), ut.minY = Math.min(ut.minY, Ne.minY), ut.maxX = Math.max(ut.maxX, Ne.maxX), ut.maxY = Math.max(ut.maxY, Ne.maxY), ht === "Point" || ht === "MultiPoint") for(let xe = 0; xe < Xe.length; xe += 3)Le.push(Xe[xe], Xe[xe + 1]), ut.numPoints++, ut.numSimplified++;
                        else if (ht === "LineString") Et(Le, Xe, ut, Ye, !1, !1);
                        else if (ht === "MultiLineString" || ht === "Polygon") for(let xe = 0; xe < Xe.length; xe++)Et(Le, Xe[xe], ut, Ye, ht === "Polygon", xe === 0);
                        else if (ht === "MultiPolygon") for(let xe = 0; xe < Xe.length; xe++){
                            let Se = Xe[xe];
                            for(let lt = 0; lt < Se.length; lt++)Et(Le, Se[lt], ut, Ye, !0, lt === 0);
                        }
                        if (Le.length) {
                            let xe = Ne.tags || null;
                            if (ht === "LineString" && Ve.lineMetrics) {
                                xe = {};
                                for(let lt in Ne.tags)xe[lt] = Ne.tags[lt];
                                xe.mapbox_clip_start = Xe.start / Xe.size, xe.mapbox_clip_end = Xe.end / Xe.size;
                            }
                            let Se = {
                                geometry: Le,
                                type: ht === "Polygon" || ht === "MultiPolygon" ? 3 : ht === "LineString" || ht === "MultiLineString" ? 2 : 1,
                                tags: xe
                            };
                            Ne.id !== null && (Se.id = Ne.id), ut.features.push(Se);
                        }
                    }
                    function Et(ut, Ne, Ye, Ve, Xe, ht) {
                        let Le = Ve * Ve;
                        if (Ve > 0 && Ne.size < (Xe ? Le : Ve)) return void (Ye.numPoints += Ne.length / 3);
                        let xe = [];
                        for(let Se = 0; Se < Ne.length; Se += 3)(Ve === 0 || Ne[Se + 2] > Le) && (Ye.numSimplified++, xe.push(Ne[Se], Ne[Se + 1])), Ye.numPoints++;
                        Xe && function(Se, lt) {
                            let Gt = 0;
                            for(let Vt = 0, ar = Se.length, Qr = ar - 2; Vt < ar; Qr = Vt, Vt += 2)Gt += (Se[Vt] - Se[Qr]) * (Se[Vt + 1] + Se[Qr + 1]);
                            if (Gt > 0 === lt) for(let Vt = 0, ar = Se.length; Vt < ar / 2; Vt += 2){
                                let Qr = Se[Vt], ai = Se[Vt + 1];
                                Se[Vt] = Se[ar - 2 - Vt], Se[Vt + 1] = Se[ar - 1 - Vt], Se[ar - 2 - Vt] = Qr, Se[ar - 1 - Vt] = ai;
                            }
                        }(xe, ht), ut.push(xe);
                    }
                    let dt = {
                        maxZoom: 14,
                        indexMaxZoom: 5,
                        indexMaxPoints: 1e5,
                        tolerance: 3,
                        extent: 4096,
                        buffer: 64,
                        lineMetrics: !1,
                        promoteId: null,
                        generateId: !1,
                        debug: 0
                    };
                    class Ht {
                        constructor(Ne, Ye){
                            let Ve = (Ye = this.options = function(ht, Le) {
                                for(let xe in Le)ht[xe] = Le[xe];
                                return ht;
                            }(Object.create(dt), Ye)).debug;
                            if (Ve && console.time("preprocess data"), Ye.maxZoom < 0 || Ye.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                            if (Ye.promoteId && Ye.generateId) throw new Error("promoteId and generateId cannot be used together.");
                            let Xe = function(ht, Le) {
                                let xe = [];
                                if (ht.type === "FeatureCollection") for(let Se = 0; Se < ht.features.length; Se++)me(xe, ht.features[Se], Le, Se);
                                else me(xe, ht.type === "Feature" ? ht : {
                                    geometry: ht
                                }, Le);
                                return xe;
                            }(Ne, Ye);
                            this.tiles = {}, this.tileCoords = [], Ve && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", Ye.indexMaxZoom, Ye.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), Xe = function(ht, Le) {
                                let xe = Le.buffer / Le.extent, Se = ht, lt = qt(ht, 1, -1 - xe, xe, 0, -1, 2, Le), Gt = qt(ht, 1, 1 - xe, 2 + xe, 0, -1, 2, Le);
                                return (lt || Gt) && (Se = qt(ht, 1, -xe, 1 + xe, 0, -1, 2, Le) || [], lt && (Se = er(lt, 1).concat(Se)), Gt && (Se = Se.concat(er(Gt, -1)))), Se;
                            }(Xe, Ye), Xe.length && this.splitTile(Xe, 0, 0, 0), Ve && (Xe.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
                        }
                        splitTile(Ne, Ye, Ve, Xe, ht, Le, xe) {
                            let Se = [
                                Ne,
                                Ye,
                                Ve,
                                Xe
                            ], lt = this.options, Gt = lt.debug;
                            for(; Se.length;){
                                Xe = Se.pop(), Ve = Se.pop(), Ye = Se.pop(), Ne = Se.pop();
                                let Vt = 1 << Ye, ar = $t(Ye, Ve, Xe), Qr = this.tiles[ar];
                                if (!Qr && (Gt > 1 && console.time("creation"), Qr = this.tiles[ar] = Lt(Ne, Ye, Ve, Xe, lt), this.tileCoords.push({
                                    z: Ye,
                                    x: Ve,
                                    y: Xe
                                }), Gt)) {
                                    Gt > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", Ye, Ve, Xe, Qr.numFeatures, Qr.numPoints, Qr.numSimplified), console.timeEnd("creation"));
                                    let Wn = `z${Ye}`;
                                    this.stats[Wn] = (this.stats[Wn] || 0) + 1, this.total++;
                                }
                                if (Qr.source = Ne, ht == null) {
                                    if (Ye === lt.indexMaxZoom || Qr.numPoints <= lt.indexMaxPoints) continue;
                                } else {
                                    if (Ye === lt.maxZoom || Ye === ht) continue;
                                    if (ht != null) {
                                        let Wn = ht - Ye;
                                        if (Ve !== Le >> Wn || Xe !== xe >> Wn) continue;
                                    }
                                }
                                if (Qr.source = null, Ne.length === 0) continue;
                                Gt > 1 && console.time("clipping");
                                let ai = .5 * lt.buffer / lt.extent, jr = .5 - ai, ri = .5 + ai, bi = 1 + ai, nn = null, Wi = null, Ni = null, _n = null, $i = qt(Ne, Vt, Ve - ai, Ve + ri, 0, Qr.minX, Qr.maxX, lt), zn = qt(Ne, Vt, Ve + jr, Ve + bi, 0, Qr.minX, Qr.maxX, lt);
                                Ne = null, $i && (nn = qt($i, Vt, Xe - ai, Xe + ri, 1, Qr.minY, Qr.maxY, lt), Wi = qt($i, Vt, Xe + jr, Xe + bi, 1, Qr.minY, Qr.maxY, lt), $i = null), zn && (Ni = qt(zn, Vt, Xe - ai, Xe + ri, 1, Qr.minY, Qr.maxY, lt), _n = qt(zn, Vt, Xe + jr, Xe + bi, 1, Qr.minY, Qr.maxY, lt), zn = null), Gt > 1 && console.timeEnd("clipping"), Se.push(nn || [], Ye + 1, 2 * Ve, 2 * Xe), Se.push(Wi || [], Ye + 1, 2 * Ve, 2 * Xe + 1), Se.push(Ni || [], Ye + 1, 2 * Ve + 1, 2 * Xe), Se.push(_n || [], Ye + 1, 2 * Ve + 1, 2 * Xe + 1);
                            }
                        }
                        getTile(Ne, Ye, Ve) {
                            Ne = +Ne, Ye = +Ye, Ve = +Ve;
                            let Xe = this.options, { extent: ht, debug: Le } = Xe;
                            if (Ne < 0 || Ne > 24) return null;
                            let xe = 1 << Ne, Se = $t(Ne, Ye = Ye + xe & xe - 1, Ve);
                            if (this.tiles[Se]) return xt(this.tiles[Se], ht);
                            Le > 1 && console.log("drilling down to z%d-%d-%d", Ne, Ye, Ve);
                            let lt, Gt = Ne, Vt = Ye, ar = Ve;
                            for(; !lt && Gt > 0;)Gt--, Vt >>= 1, ar >>= 1, lt = this.tiles[$t(Gt, Vt, ar)];
                            return lt && lt.source ? (Le > 1 && (console.log("found parent tile z%d-%d-%d", Gt, Vt, ar), console.time("drilling down")), this.splitTile(lt.source, Gt, Vt, ar, Ne, Ye, Ve), Le > 1 && console.timeEnd("drilling down"), this.tiles[Se] ? xt(this.tiles[Se], ht) : null) : null;
                        }
                    }
                    function $t(ut, Ne, Ye) {
                        return 32 * ((1 << ut) * Ye + Ne) + ut;
                    }
                    function fr(ut, Ne) {
                        return Ne ? ut.properties[Ne] : ut.id;
                    }
                    function _r(ut, Ne) {
                        if (ut == null) return !0;
                        if (ut.type === "Feature") return fr(ut, Ne) != null;
                        if (ut.type === "FeatureCollection") {
                            let Ye = new Set;
                            for (let Ve of ut.features){
                                let Xe = fr(Ve, Ne);
                                if (Xe == null || Ye.has(Xe)) return !1;
                                Ye.add(Xe);
                            }
                            return !0;
                        }
                        return !1;
                    }
                    function Br(ut, Ne) {
                        let Ye = new Map;
                        if (ut != null) {
                            if (ut.type === "Feature") Ye.set(fr(ut, Ne), ut);
                            else for (let Ve of ut.features)Ye.set(fr(Ve, Ne), Ve);
                        }
                        return Ye;
                    }
                    class Or extends u {
                        constructor(){
                            super(...arguments), this._dataUpdateable = new Map;
                        }
                        loadVectorTile(Ne, Ye) {
                            return i._(this, void 0, void 0, function*() {
                                let Ve = Ne.tileID.canonical;
                                if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                                let Xe = this._geoJSONIndex.getTile(Ve.z, Ve.x, Ve.y);
                                if (!Xe) return null;
                                let ht = new class {
                                    constructor(xe){
                                        this.layers = {
                                            _geojsonTileLayer: this
                                        }, this.name = "_geojsonTileLayer", this.extent = i.X, this.length = xe.length, this._features = xe;
                                    }
                                    feature(xe) {
                                        return new class {
                                            constructor(Se){
                                                this._feature = Se, this.extent = i.X, this.type = Se.type, this.properties = Se.tags, "id" in Se && !isNaN(Se.id) && (this.id = parseInt(Se.id, 10));
                                            }
                                            loadGeometry() {
                                                if (this._feature.type === 1) {
                                                    let Se = [];
                                                    for (let lt of this._feature.geometry)Se.push([
                                                        new i.P(lt[0], lt[1])
                                                    ]);
                                                    return Se;
                                                }
                                                {
                                                    let Se = [];
                                                    for (let lt of this._feature.geometry){
                                                        let Gt = [];
                                                        for (let Vt of lt)Gt.push(new i.P(Vt[0], Vt[1]));
                                                        Se.push(Gt);
                                                    }
                                                    return Se;
                                                }
                                            }
                                            toGeoJSON(Se, lt, Gt) {
                                                return v.call(this, Se, lt, Gt);
                                            }
                                        }(this._features[xe]);
                                    }
                                }(Xe.features), Le = H(ht);
                                return Le.byteOffset === 0 && Le.byteLength === Le.buffer.byteLength || (Le = new Uint8Array(Le)), {
                                    vectorTile: ht,
                                    rawData: Le.buffer
                                };
                            });
                        }
                        loadData(Ne) {
                            return i._(this, void 0, void 0, function*() {
                                var Ye;
                                (Ye = this._pendingRequest) === null || Ye === void 0 || Ye.abort();
                                let Ve = !!(Ne && Ne.request && Ne.request.collectResourceTiming) && new i.bv(Ne.request);
                                this._pendingRequest = new AbortController;
                                try {
                                    this._pendingData = this.loadAndProcessGeoJSON(Ne, this._pendingRequest), this._geoJSONIndex = Ne.cluster ? new _e(function({ superclusterOptions: Le, clusterProperties: xe }) {
                                        if (!xe || !Le) return Le;
                                        let Se = {}, lt = {}, Gt = {
                                            accumulated: null,
                                            zoom: 0
                                        }, Vt = {
                                            properties: null
                                        }, ar = Object.keys(xe);
                                        for (let Qr of ar){
                                            let [ai, jr] = xe[Qr], ri = i.bC(jr), bi = i.bC(typeof ai == "string" ? [
                                                ai,
                                                [
                                                    "accumulated"
                                                ],
                                                [
                                                    "get",
                                                    Qr
                                                ]
                                            ] : ai);
                                            Se[Qr] = ri.value, lt[Qr] = bi.value;
                                        }
                                        return Le.map = (Qr)=>{
                                            Vt.properties = Qr;
                                            let ai = {};
                                            for (let jr of ar)ai[jr] = Se[jr].evaluate(Gt, Vt);
                                            return ai;
                                        }, Le.reduce = (Qr, ai)=>{
                                            Vt.properties = ai;
                                            for (let jr of ar)Gt.accumulated = Qr[jr], Qr[jr] = lt[jr].evaluate(Gt, Vt);
                                        }, Le;
                                    }(Ne)).load((yield this._pendingData).features) : (Xe = yield this._pendingData, new Ht(Xe, Ne.geojsonVtOptions)), this.loaded = {};
                                    let ht = {};
                                    if (Ve) {
                                        let Le = Ve.finish();
                                        Le && (ht.resourceTiming = {}, ht.resourceTiming[Ne.source] = JSON.parse(JSON.stringify(Le)));
                                    }
                                    return ht;
                                } catch (ht) {
                                    if (delete this._pendingRequest, i.bB(ht)) return {
                                        abandoned: !0
                                    };
                                    throw ht;
                                }
                                var Xe;
                            });
                        }
                        getData() {
                            return i._(this, void 0, void 0, function*() {
                                return this._pendingData;
                            });
                        }
                        reloadTile(Ne) {
                            let Ye = this.loaded;
                            return Ye && Ye[Ne.uid] ? super.reloadTile(Ne) : this.loadTile(Ne);
                        }
                        loadAndProcessGeoJSON(Ne, Ye) {
                            return i._(this, void 0, void 0, function*() {
                                let Ve = yield this.loadGeoJSON(Ne, Ye);
                                if (delete this._pendingRequest, typeof Ve != "object") throw new Error(`Input data given to '${Ne.source}' is not a valid GeoJSON object.`);
                                if (d(Ve, !0), Ne.filter) {
                                    let Xe = i.bC(Ne.filter, {
                                        type: "boolean",
                                        "property-type": "data-driven",
                                        overridable: !1,
                                        transition: !1
                                    });
                                    if (Xe.result === "error") throw new Error(Xe.value.map((Le)=>`${Le.key}: ${Le.message}`).join(", "));
                                    Ve = {
                                        type: "FeatureCollection",
                                        features: Ve.features.filter((Le)=>Xe.value.evaluate({
                                                zoom: 0
                                            }, Le))
                                    };
                                }
                                return Ve;
                            });
                        }
                        loadGeoJSON(Ne, Ye) {
                            return i._(this, void 0, void 0, function*() {
                                let { promoteId: Ve } = Ne;
                                if (Ne.request) {
                                    let Xe = yield i.h(Ne.request, Ye);
                                    return this._dataUpdateable = _r(Xe.data, Ve) ? Br(Xe.data, Ve) : void 0, Xe.data;
                                }
                                if (typeof Ne.data == "string") try {
                                    let Xe = JSON.parse(Ne.data);
                                    return this._dataUpdateable = _r(Xe, Ve) ? Br(Xe, Ve) : void 0, Xe;
                                } catch (Xe) {
                                    throw new Error(`Input data given to '${Ne.source}' is not a valid GeoJSON object.`);
                                }
                                if (!Ne.dataDiff) throw new Error(`Input data given to '${Ne.source}' is not a valid GeoJSON object.`);
                                if (!this._dataUpdateable) throw new Error(`Cannot update existing geojson data in ${Ne.source}`);
                                return function(Xe, ht, Le) {
                                    var xe, Se, lt, Gt;
                                    if (ht.removeAll && Xe.clear(), ht.remove) for (let Vt of ht.remove)Xe.delete(Vt);
                                    if (ht.add) for (let Vt of ht.add){
                                        let ar = fr(Vt, Le);
                                        ar != null && Xe.set(ar, Vt);
                                    }
                                    if (ht.update) for (let Vt of ht.update){
                                        let ar = Xe.get(Vt.id);
                                        if (ar == null) continue;
                                        let Qr = !Vt.removeAllProperties && (((xe = Vt.removeProperties) === null || xe === void 0 ? void 0 : xe.length) > 0 || ((Se = Vt.addOrUpdateProperties) === null || Se === void 0 ? void 0 : Se.length) > 0);
                                        if ((Vt.newGeometry || Vt.removeAllProperties || Qr) && (ar = Object.assign({}, ar), Xe.set(Vt.id, ar), Qr && (ar.properties = Object.assign({}, ar.properties))), Vt.newGeometry && (ar.geometry = Vt.newGeometry), Vt.removeAllProperties) ar.properties = {};
                                        else if (((lt = Vt.removeProperties) === null || lt === void 0 ? void 0 : lt.length) > 0) for (let ai of Vt.removeProperties)Object.prototype.hasOwnProperty.call(ar.properties, ai) && delete ar.properties[ai];
                                        if (((Gt = Vt.addOrUpdateProperties) === null || Gt === void 0 ? void 0 : Gt.length) > 0) for (let { key: ai, value: jr } of Vt.addOrUpdateProperties)ar.properties[ai] = jr;
                                    }
                                }(this._dataUpdateable, Ne.dataDiff, Ve), {
                                    type: "FeatureCollection",
                                    features: Array.from(this._dataUpdateable.values())
                                };
                            });
                        }
                        removeSource(Ne) {
                            return i._(this, void 0, void 0, function*() {
                                this._pendingRequest && this._pendingRequest.abort();
                            });
                        }
                        getClusterExpansionZoom(Ne) {
                            return this._geoJSONIndex.getClusterExpansionZoom(Ne.clusterId);
                        }
                        getClusterChildren(Ne) {
                            return this._geoJSONIndex.getChildren(Ne.clusterId);
                        }
                        getClusterLeaves(Ne) {
                            return this._geoJSONIndex.getLeaves(Ne.clusterId, Ne.limit, Ne.offset);
                        }
                    }
                    class Nr {
                        constructor(Ne){
                            this.self = Ne, this.actor = new i.F(Ne), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.self.registerWorkerSource = (Ye, Ve)=>{
                                if (this.externalWorkerSourceTypes[Ye]) throw new Error(`Worker source with name "${Ye}" already registered.`);
                                this.externalWorkerSourceTypes[Ye] = Ve;
                            }, this.self.addProtocol = i.bi, this.self.removeProtocol = i.bj, this.self.registerRTLTextPlugin = (Ye)=>{
                                if (i.bD.isParsed()) throw new Error("RTL text plugin already registered.");
                                i.bD.setMethods(Ye);
                            }, this.actor.registerMessageHandler("LDT", (Ye, Ve)=>this._getDEMWorkerSource(Ye, Ve.source).loadTile(Ve)), this.actor.registerMessageHandler("RDT", (Ye, Ve)=>i._(this, void 0, void 0, function*() {
                                    this._getDEMWorkerSource(Ye, Ve.source).removeTile(Ve);
                                })), this.actor.registerMessageHandler("GCEZ", (Ye, Ve)=>i._(this, void 0, void 0, function*() {
                                    return this._getWorkerSource(Ye, Ve.type, Ve.source).getClusterExpansionZoom(Ve);
                                })), this.actor.registerMessageHandler("GCC", (Ye, Ve)=>i._(this, void 0, void 0, function*() {
                                    return this._getWorkerSource(Ye, Ve.type, Ve.source).getClusterChildren(Ve);
                                })), this.actor.registerMessageHandler("GCL", (Ye, Ve)=>i._(this, void 0, void 0, function*() {
                                    return this._getWorkerSource(Ye, Ve.type, Ve.source).getClusterLeaves(Ve);
                                })), this.actor.registerMessageHandler("LD", (Ye, Ve)=>this._getWorkerSource(Ye, Ve.type, Ve.source).loadData(Ve)), this.actor.registerMessageHandler("GD", (Ye, Ve)=>this._getWorkerSource(Ye, Ve.type, Ve.source).getData()), this.actor.registerMessageHandler("LT", (Ye, Ve)=>this._getWorkerSource(Ye, Ve.type, Ve.source).loadTile(Ve)), this.actor.registerMessageHandler("RT", (Ye, Ve)=>this._getWorkerSource(Ye, Ve.type, Ve.source).reloadTile(Ve)), this.actor.registerMessageHandler("AT", (Ye, Ve)=>this._getWorkerSource(Ye, Ve.type, Ve.source).abortTile(Ve)), this.actor.registerMessageHandler("RMT", (Ye, Ve)=>this._getWorkerSource(Ye, Ve.type, Ve.source).removeTile(Ve)), this.actor.registerMessageHandler("RS", (Ye, Ve)=>i._(this, void 0, void 0, function*() {
                                    if (!this.workerSources[Ye] || !this.workerSources[Ye][Ve.type] || !this.workerSources[Ye][Ve.type][Ve.source]) return;
                                    let Xe = this.workerSources[Ye][Ve.type][Ve.source];
                                    delete this.workerSources[Ye][Ve.type][Ve.source], Xe.removeSource !== void 0 && Xe.removeSource(Ve);
                                })), this.actor.registerMessageHandler("RM", (Ye)=>i._(this, void 0, void 0, function*() {
                                    delete this.layerIndexes[Ye], delete this.availableImages[Ye], delete this.workerSources[Ye], delete this.demWorkerSources[Ye];
                                })), this.actor.registerMessageHandler("SR", (Ye, Ve)=>i._(this, void 0, void 0, function*() {
                                    this.referrer = Ve;
                                })), this.actor.registerMessageHandler("SRPS", (Ye, Ve)=>this._syncRTLPluginState(Ye, Ve)), this.actor.registerMessageHandler("IS", (Ye, Ve)=>i._(this, void 0, void 0, function*() {
                                    this.self.importScripts(Ve);
                                })), this.actor.registerMessageHandler("SI", (Ye, Ve)=>this._setImages(Ye, Ve)), this.actor.registerMessageHandler("UL", (Ye, Ve)=>i._(this, void 0, void 0, function*() {
                                    this._getLayerIndex(Ye).update(Ve.layers, Ve.removedIds);
                                })), this.actor.registerMessageHandler("SL", (Ye, Ve)=>i._(this, void 0, void 0, function*() {
                                    this._getLayerIndex(Ye).replace(Ve);
                                }));
                        }
                        _setImages(Ne, Ye) {
                            return i._(this, void 0, void 0, function*() {
                                this.availableImages[Ne] = Ye;
                                for(let Ve in this.workerSources[Ne]){
                                    let Xe = this.workerSources[Ne][Ve];
                                    for(let ht in Xe)Xe[ht].availableImages = Ye;
                                }
                            });
                        }
                        _syncRTLPluginState(Ne, Ye) {
                            return i._(this, void 0, void 0, function*() {
                                if (i.bD.isParsed()) return i.bD.getState();
                                if (Ye.pluginStatus !== "loading") return i.bD.setState(Ye), Ye;
                                let Ve = Ye.pluginURL;
                                if (this.self.importScripts(Ve), i.bD.isParsed()) {
                                    let Xe = {
                                        pluginStatus: "loaded",
                                        pluginURL: Ve
                                    };
                                    return i.bD.setState(Xe), Xe;
                                }
                                throw i.bD.setState({
                                    pluginStatus: "error",
                                    pluginURL: ""
                                }), new Error(`RTL Text Plugin failed to import scripts from ${Ve}`);
                            });
                        }
                        _getAvailableImages(Ne) {
                            let Ye = this.availableImages[Ne];
                            return Ye || (Ye = []), Ye;
                        }
                        _getLayerIndex(Ne) {
                            let Ye = this.layerIndexes[Ne];
                            return Ye || (Ye = this.layerIndexes[Ne] = new a), Ye;
                        }
                        _getWorkerSource(Ne, Ye, Ve) {
                            if (this.workerSources[Ne] || (this.workerSources[Ne] = {}), this.workerSources[Ne][Ye] || (this.workerSources[Ne][Ye] = {}), !this.workerSources[Ne][Ye][Ve]) {
                                let Xe = {
                                    sendAsync: (ht, Le)=>(ht.targetMapId = Ne, this.actor.sendAsync(ht, Le))
                                };
                                switch(Ye){
                                    case "vector":
                                        this.workerSources[Ne][Ye][Ve] = new u(Xe, this._getLayerIndex(Ne), this._getAvailableImages(Ne));
                                        break;
                                    case "geojson":
                                        this.workerSources[Ne][Ye][Ve] = new Or(Xe, this._getLayerIndex(Ne), this._getAvailableImages(Ne));
                                        break;
                                    default:
                                        this.workerSources[Ne][Ye][Ve] = new this.externalWorkerSourceTypes[Ye](Xe, this._getLayerIndex(Ne), this._getAvailableImages(Ne));
                                }
                            }
                            return this.workerSources[Ne][Ye][Ve];
                        }
                        _getDEMWorkerSource(Ne, Ye) {
                            return this.demWorkerSources[Ne] || (this.demWorkerSources[Ne] = {}), this.demWorkerSources[Ne][Ye] || (this.demWorkerSources[Ne][Ye] = new c), this.demWorkerSources[Ne][Ye];
                        }
                    }
                    return i.i(self) && (self.worker = new Nr(self)), Nr;
                }), r("index", [
                    "exports",
                    "./shared"
                ], function(i, a) {
                    "use strict";
                    var o = "4.7.1";
                    let s, l, u = {
                        now: typeof performance != "undefined" && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date),
                        frameAsync: (le)=>new Promise((w, B)=>{
                                let Q = requestAnimationFrame(w);
                                le.signal.addEventListener("abort", ()=>{
                                    cancelAnimationFrame(Q), B(a.c());
                                });
                            }),
                        getImageData (le, w = 0) {
                            return this.getImageCanvasContext(le).getImageData(-w, -w, le.width + 2 * w, le.height + 2 * w);
                        },
                        getImageCanvasContext (le) {
                            let w = window.document.createElement("canvas"), B = w.getContext("2d", {
                                willReadFrequently: !0
                            });
                            if (!B) throw new Error("failed to create canvas 2d context");
                            return w.width = le.width, w.height = le.height, B.drawImage(le, 0, 0, le.width, le.height), B;
                        },
                        resolveURL: (le)=>(s || (s = document.createElement("a")), s.href = le, s.href),
                        hardwareConcurrency: typeof navigator != "undefined" && navigator.hardwareConcurrency || 4,
                        get prefersReducedMotion () {
                            return !!matchMedia && (l == null && (l = matchMedia("(prefers-reduced-motion: reduce)")), l.matches);
                        }
                    };
                    class c {
                        static testProp(w) {
                            if (!c.docStyle) return w[0];
                            for(let B = 0; B < w.length; B++)if (w[B] in c.docStyle) return w[B];
                            return w[0];
                        }
                        static create(w, B, Q) {
                            let ee = window.document.createElement(w);
                            return B !== void 0 && (ee.className = B), Q && Q.appendChild(ee), ee;
                        }
                        static createNS(w, B) {
                            return window.document.createElementNS(w, B);
                        }
                        static disableDrag() {
                            c.docStyle && c.selectProp && (c.userSelect = c.docStyle[c.selectProp], c.docStyle[c.selectProp] = "none");
                        }
                        static enableDrag() {
                            c.docStyle && c.selectProp && (c.docStyle[c.selectProp] = c.userSelect);
                        }
                        static setTransform(w, B) {
                            w.style[c.transformProp] = B;
                        }
                        static addEventListener(w, B, Q, ee = {}) {
                            w.addEventListener(B, Q, "passive" in ee ? ee : ee.capture);
                        }
                        static removeEventListener(w, B, Q, ee = {}) {
                            w.removeEventListener(B, Q, "passive" in ee ? ee : ee.capture);
                        }
                        static suppressClickInternal(w) {
                            w.preventDefault(), w.stopPropagation(), window.removeEventListener("click", c.suppressClickInternal, !0);
                        }
                        static suppressClick() {
                            window.addEventListener("click", c.suppressClickInternal, !0), window.setTimeout(()=>{
                                window.removeEventListener("click", c.suppressClickInternal, !0);
                            }, 0);
                        }
                        static getScale(w) {
                            let B = w.getBoundingClientRect();
                            return {
                                x: B.width / w.offsetWidth || 1,
                                y: B.height / w.offsetHeight || 1,
                                boundingClientRect: B
                            };
                        }
                        static getPoint(w, B, Q) {
                            let ee = B.boundingClientRect;
                            return new a.P((Q.clientX - ee.left) / B.x - w.clientLeft, (Q.clientY - ee.top) / B.y - w.clientTop);
                        }
                        static mousePos(w, B) {
                            let Q = c.getScale(w);
                            return c.getPoint(w, Q, B);
                        }
                        static touchPos(w, B) {
                            let Q = [], ee = c.getScale(w);
                            for(let se = 0; se < B.length; se++)Q.push(c.getPoint(w, ee, B[se]));
                            return Q;
                        }
                        static mouseButton(w) {
                            return w.button;
                        }
                        static remove(w) {
                            w.parentNode && w.parentNode.removeChild(w);
                        }
                    }
                    c.docStyle = typeof window != "undefined" && window.document && window.document.documentElement.style, c.selectProp = c.testProp([
                        "userSelect",
                        "MozUserSelect",
                        "WebkitUserSelect",
                        "msUserSelect"
                    ]), c.transformProp = c.testProp([
                        "transform",
                        "WebkitTransform"
                    ]);
                    let f = {
                        supported: !1,
                        testSupport: function(le) {
                            !v && d && (x ? b(le) : h = le);
                        }
                    }, h, d, v = !1, x = !1;
                    function b(le) {
                        let w = le.createTexture();
                        le.bindTexture(le.TEXTURE_2D, w);
                        try {
                            if (le.texImage2D(le.TEXTURE_2D, 0, le.RGBA, le.RGBA, le.UNSIGNED_BYTE, d), le.isContextLost()) return;
                            f.supported = !0;
                        } catch (B) {}
                        le.deleteTexture(w), v = !0;
                    }
                    var p;
                    typeof document != "undefined" && (d = document.createElement("img"), d.onload = ()=>{
                        h && b(h), h = null, x = !0;
                    }, d.onerror = ()=>{
                        v = !0, h = null;
                    }, d.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(le) {
                        let w, B, Q, ee;
                        le.resetRequestQueue = ()=>{
                            w = [], B = 0, Q = 0, ee = {};
                        }, le.addThrottleControl = (it)=>{
                            let yt = Q++;
                            return ee[yt] = it, yt;
                        }, le.removeThrottleControl = (it)=>{
                            delete ee[it], qe();
                        }, le.getImage = (it, yt, Ot = !0)=>new Promise((Nt, hr)=>{
                                f.supported && (it.headers || (it.headers = {}), it.headers.accept = "image/webp,*/*"), a.e(it, {
                                    type: "image"
                                }), w.push({
                                    abortController: yt,
                                    requestParameters: it,
                                    supportImageRefresh: Ot,
                                    state: "queued",
                                    onError: (Sr)=>{
                                        hr(Sr);
                                    },
                                    onSuccess: (Sr)=>{
                                        Nt(Sr);
                                    }
                                }), qe();
                            });
                        let se = (it)=>a._(this, void 0, void 0, function*() {
                                it.state = "running";
                                let { requestParameters: yt, supportImageRefresh: Ot, onError: Nt, onSuccess: hr, abortController: Sr } = it, he = Ot === !1 && !a.i(self) && !a.g(yt.url) && (!yt.headers || Object.keys(yt.headers).reduce((Oe, Je)=>Oe && Je === "accept", !0));
                                B++;
                                let be = he ? je(yt, Sr) : a.m(yt, Sr);
                                try {
                                    let Oe = yield be;
                                    delete it.abortController, it.state = "completed", Oe.data instanceof HTMLImageElement || a.b(Oe.data) ? hr(Oe) : Oe.data && hr({
                                        data: yield (Pe = Oe.data, typeof createImageBitmap == "function" ? a.d(Pe) : a.f(Pe)),
                                        cacheControl: Oe.cacheControl,
                                        expires: Oe.expires
                                    });
                                } catch (Oe) {
                                    delete it.abortController, Nt(Oe);
                                } finally{
                                    B--, qe();
                                }
                                var Pe;
                            }), qe = ()=>{
                            let it = (()=>{
                                for (let yt of Object.keys(ee))if (ee[yt]()) return !0;
                                return !1;
                            })() ? a.a.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : a.a.MAX_PARALLEL_IMAGE_REQUESTS;
                            for(let yt = B; yt < it && w.length > 0; yt++){
                                let Ot = w.shift();
                                Ot.abortController.signal.aborted ? yt-- : se(Ot);
                            }
                        }, je = (it, yt)=>new Promise((Ot, Nt)=>{
                                let hr = new Image, Sr = it.url, he = it.credentials;
                                he && he === "include" ? hr.crossOrigin = "use-credentials" : (he && he === "same-origin" || !a.s(Sr)) && (hr.crossOrigin = "anonymous"), yt.signal.addEventListener("abort", ()=>{
                                    hr.src = "", Nt(a.c());
                                }), hr.fetchPriority = "high", hr.onload = ()=>{
                                    hr.onerror = hr.onload = null, Ot({
                                        data: hr
                                    });
                                }, hr.onerror = ()=>{
                                    hr.onerror = hr.onload = null, yt.signal.aborted || Nt(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                }, hr.src = Sr;
                            });
                    }(p || (p = {})), p.resetRequestQueue();
                    class E {
                        constructor(w){
                            this._transformRequestFn = w;
                        }
                        transformRequest(w, B) {
                            return this._transformRequestFn && this._transformRequestFn(w, B) || {
                                url: w
                            };
                        }
                        setTransformRequest(w) {
                            this._transformRequestFn = w;
                        }
                    }
                    function k(le) {
                        var w = new a.A(3);
                        return w[0] = le[0], w[1] = le[1], w[2] = le[2], w;
                    }
                    var A, L = function(le, w, B) {
                        return le[0] = w[0] - B[0], le[1] = w[1] - B[1], le[2] = w[2] - B[2], le;
                    };
                    A = new a.A(3), a.A != Float32Array && (A[0] = 0, A[1] = 0, A[2] = 0);
                    var _ = function(le) {
                        var w = le[0], B = le[1];
                        return w * w + B * B;
                    };
                    function C(le) {
                        let w = [];
                        if (typeof le == "string") w.push({
                            id: "default",
                            url: le
                        });
                        else if (le && le.length > 0) {
                            let B = [];
                            for (let { id: Q, url: ee } of le){
                                let se = `${Q}${ee}`;
                                B.indexOf(se) === -1 && (B.push(se), w.push({
                                    id: Q,
                                    url: ee
                                }));
                            }
                        }
                        return w;
                    }
                    function M(le, w, B) {
                        let Q = le.split("?");
                        return Q[0] += `${w}${B}`, Q.join("?");
                    }
                    (function() {
                        var le = new a.A(2);
                        a.A != Float32Array && (le[0] = 0, le[1] = 0);
                    })();
                    class g {
                        constructor(w, B, Q, ee){
                            this.context = w, this.format = Q, this.texture = w.gl.createTexture(), this.update(B, ee);
                        }
                        update(w, B, Q) {
                            let { width: ee, height: se } = w, qe = !(this.size && this.size[0] === ee && this.size[1] === se || Q), { context: je } = this, { gl: it } = je;
                            if (this.useMipmap = !!(B && B.useMipmap), it.bindTexture(it.TEXTURE_2D, this.texture), je.pixelStoreUnpackFlipY.set(!1), je.pixelStoreUnpack.set(1), je.pixelStoreUnpackPremultiplyAlpha.set(this.format === it.RGBA && (!B || B.premultiply !== !1)), qe) this.size = [
                                ee,
                                se
                            ], w instanceof HTMLImageElement || w instanceof HTMLCanvasElement || w instanceof HTMLVideoElement || w instanceof ImageData || a.b(w) ? it.texImage2D(it.TEXTURE_2D, 0, this.format, this.format, it.UNSIGNED_BYTE, w) : it.texImage2D(it.TEXTURE_2D, 0, this.format, ee, se, 0, this.format, it.UNSIGNED_BYTE, w.data);
                            else {
                                let { x: yt, y: Ot } = Q || {
                                    x: 0,
                                    y: 0
                                };
                                w instanceof HTMLImageElement || w instanceof HTMLCanvasElement || w instanceof HTMLVideoElement || w instanceof ImageData || a.b(w) ? it.texSubImage2D(it.TEXTURE_2D, 0, yt, Ot, it.RGBA, it.UNSIGNED_BYTE, w) : it.texSubImage2D(it.TEXTURE_2D, 0, yt, Ot, ee, se, it.RGBA, it.UNSIGNED_BYTE, w.data);
                            }
                            this.useMipmap && this.isSizePowerOfTwo() && it.generateMipmap(it.TEXTURE_2D);
                        }
                        bind(w, B, Q) {
                            let { context: ee } = this, { gl: se } = ee;
                            se.bindTexture(se.TEXTURE_2D, this.texture), Q !== se.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (Q = se.LINEAR), w !== this.filter && (se.texParameteri(se.TEXTURE_2D, se.TEXTURE_MAG_FILTER, w), se.texParameteri(se.TEXTURE_2D, se.TEXTURE_MIN_FILTER, Q || w), this.filter = w), B !== this.wrap && (se.texParameteri(se.TEXTURE_2D, se.TEXTURE_WRAP_S, B), se.texParameteri(se.TEXTURE_2D, se.TEXTURE_WRAP_T, B), this.wrap = B);
                        }
                        isSizePowerOfTwo() {
                            return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
                        }
                        destroy() {
                            let { gl: w } = this.context;
                            w.deleteTexture(this.texture), this.texture = null;
                        }
                    }
                    function P(le) {
                        let { userImage: w } = le;
                        return !!(w && w.render && w.render()) && (le.data.replace(new Uint8Array(w.data.buffer)), !0);
                    }
                    class T extends a.E {
                        constructor(){
                            super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new a.R({
                                width: 1,
                                height: 1
                            }), this.dirty = !0;
                        }
                        isLoaded() {
                            return this.loaded;
                        }
                        setLoaded(w) {
                            if (this.loaded !== w && (this.loaded = w, w)) {
                                for (let { ids: B, promiseResolve: Q } of this.requestors)Q(this._getImagesForIds(B));
                                this.requestors = [];
                            }
                        }
                        getImage(w) {
                            let B = this.images[w];
                            if (B && !B.data && B.spriteData) {
                                let Q = B.spriteData;
                                B.data = new a.R({
                                    width: Q.width,
                                    height: Q.height
                                }, Q.context.getImageData(Q.x, Q.y, Q.width, Q.height).data), B.spriteData = null;
                            }
                            return B;
                        }
                        addImage(w, B) {
                            if (this.images[w]) throw new Error(`Image id ${w} already exist, use updateImage instead`);
                            this._validate(w, B) && (this.images[w] = B);
                        }
                        _validate(w, B) {
                            let Q = !0, ee = B.data || B.spriteData;
                            return this._validateStretch(B.stretchX, ee && ee.width) || (this.fire(new a.j(new Error(`Image "${w}" has invalid "stretchX" value`))), Q = !1), this._validateStretch(B.stretchY, ee && ee.height) || (this.fire(new a.j(new Error(`Image "${w}" has invalid "stretchY" value`))), Q = !1), this._validateContent(B.content, B) || (this.fire(new a.j(new Error(`Image "${w}" has invalid "content" value`))), Q = !1), Q;
                        }
                        _validateStretch(w, B) {
                            if (!w) return !0;
                            let Q = 0;
                            for (let ee of w){
                                if (ee[0] < Q || ee[1] < ee[0] || B < ee[1]) return !1;
                                Q = ee[1];
                            }
                            return !0;
                        }
                        _validateContent(w, B) {
                            if (!w) return !0;
                            if (w.length !== 4) return !1;
                            let Q = B.spriteData, ee = Q && Q.width || B.data.width, se = Q && Q.height || B.data.height;
                            return !(w[0] < 0 || ee < w[0] || w[1] < 0 || se < w[1] || w[2] < 0 || ee < w[2] || w[3] < 0 || se < w[3] || w[2] < w[0] || w[3] < w[1]);
                        }
                        updateImage(w, B, Q = !0) {
                            let ee = this.getImage(w);
                            if (Q && (ee.data.width !== B.data.width || ee.data.height !== B.data.height)) throw new Error(`size mismatch between old image (${ee.data.width}x${ee.data.height}) and new image (${B.data.width}x${B.data.height}).`);
                            B.version = ee.version + 1, this.images[w] = B, this.updatedImages[w] = !0;
                        }
                        removeImage(w) {
                            let B = this.images[w];
                            delete this.images[w], delete this.patterns[w], B.userImage && B.userImage.onRemove && B.userImage.onRemove();
                        }
                        listImages() {
                            return Object.keys(this.images);
                        }
                        getImages(w) {
                            return new Promise((B, Q)=>{
                                let ee = !0;
                                if (!this.isLoaded()) for (let se of w)this.images[se] || (ee = !1);
                                this.isLoaded() || ee ? B(this._getImagesForIds(w)) : this.requestors.push({
                                    ids: w,
                                    promiseResolve: B
                                });
                            });
                        }
                        _getImagesForIds(w) {
                            let B = {};
                            for (let Q of w){
                                let ee = this.getImage(Q);
                                ee || (this.fire(new a.k("styleimagemissing", {
                                    id: Q
                                })), ee = this.getImage(Q)), ee ? B[Q] = {
                                    data: ee.data.clone(),
                                    pixelRatio: ee.pixelRatio,
                                    sdf: ee.sdf,
                                    version: ee.version,
                                    stretchX: ee.stretchX,
                                    stretchY: ee.stretchY,
                                    content: ee.content,
                                    textFitWidth: ee.textFitWidth,
                                    textFitHeight: ee.textFitHeight,
                                    hasRenderCallback: !!(ee.userImage && ee.userImage.render)
                                } : a.w(`Image "${Q}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                            }
                            return B;
                        }
                        getPixelSize() {
                            let { width: w, height: B } = this.atlasImage;
                            return {
                                width: w,
                                height: B
                            };
                        }
                        getPattern(w) {
                            let B = this.patterns[w], Q = this.getImage(w);
                            if (!Q) return null;
                            if (B && B.position.version === Q.version) return B.position;
                            if (B) B.position.version = Q.version;
                            else {
                                let ee = {
                                    w: Q.data.width + 2,
                                    h: Q.data.height + 2,
                                    x: 0,
                                    y: 0
                                }, se = new a.I(ee, Q);
                                this.patterns[w] = {
                                    bin: ee,
                                    position: se
                                };
                            }
                            return this._updatePatternAtlas(), this.patterns[w].position;
                        }
                        bind(w) {
                            let B = w.gl;
                            this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new g(w, this.atlasImage, B.RGBA), this.atlasTexture.bind(B.LINEAR, B.CLAMP_TO_EDGE);
                        }
                        _updatePatternAtlas() {
                            let w = [];
                            for(let se in this.patterns)w.push(this.patterns[se].bin);
                            let { w: B, h: Q } = a.p(w), ee = this.atlasImage;
                            ee.resize({
                                width: B || 1,
                                height: Q || 1
                            });
                            for(let se in this.patterns){
                                let { bin: qe } = this.patterns[se], je = qe.x + 1, it = qe.y + 1, yt = this.getImage(se).data, Ot = yt.width, Nt = yt.height;
                                a.R.copy(yt, ee, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: je,
                                    y: it
                                }, {
                                    width: Ot,
                                    height: Nt
                                }), a.R.copy(yt, ee, {
                                    x: 0,
                                    y: Nt - 1
                                }, {
                                    x: je,
                                    y: it - 1
                                }, {
                                    width: Ot,
                                    height: 1
                                }), a.R.copy(yt, ee, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: je,
                                    y: it + Nt
                                }, {
                                    width: Ot,
                                    height: 1
                                }), a.R.copy(yt, ee, {
                                    x: Ot - 1,
                                    y: 0
                                }, {
                                    x: je - 1,
                                    y: it
                                }, {
                                    width: 1,
                                    height: Nt
                                }), a.R.copy(yt, ee, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: je + Ot,
                                    y: it
                                }, {
                                    width: 1,
                                    height: Nt
                                });
                            }
                            this.dirty = !0;
                        }
                        beginFrame() {
                            this.callbackDispatchedThisFrame = {};
                        }
                        dispatchRenderCallbacks(w) {
                            for (let B of w){
                                if (this.callbackDispatchedThisFrame[B]) continue;
                                this.callbackDispatchedThisFrame[B] = !0;
                                let Q = this.getImage(B);
                                Q || a.w(`Image with ID: "${B}" was not found`), P(Q) && this.updateImage(B, Q);
                            }
                        }
                    }
                    let F = 1e20;
                    function q(le, w, B, Q, ee, se, qe, je, it) {
                        for(let yt = w; yt < w + Q; yt++)V(le, B * se + yt, se, ee, qe, je, it);
                        for(let yt = B; yt < B + ee; yt++)V(le, yt * se + w, 1, Q, qe, je, it);
                    }
                    function V(le, w, B, Q, ee, se, qe) {
                        se[0] = 0, qe[0] = -F, qe[1] = F, ee[0] = le[w];
                        for(let je = 1, it = 0, yt = 0; je < Q; je++){
                            ee[je] = le[w + je * B];
                            let Ot = je * je;
                            do {
                                let Nt = se[it];
                                yt = (ee[je] - ee[Nt] + Ot - Nt * Nt) / (je - Nt) / 2;
                            }while (yt <= qe[it] && --it > -1);
                            it++, se[it] = je, qe[it] = yt, qe[it + 1] = F;
                        }
                        for(let je = 0, it = 0; je < Q; je++){
                            for(; qe[it + 1] < je;)it++;
                            let yt = se[it], Ot = je - yt;
                            le[w + je * B] = ee[yt] + Ot * Ot;
                        }
                    }
                    class H {
                        constructor(w, B){
                            this.requestManager = w, this.localIdeographFontFamily = B, this.entries = {};
                        }
                        setURL(w) {
                            this.url = w;
                        }
                        getGlyphs(w) {
                            return a._(this, void 0, void 0, function*() {
                                let B = [];
                                for(let se in w)for (let qe of w[se])B.push(this._getAndCacheGlyphsPromise(se, qe));
                                let Q = yield Promise.all(B), ee = {};
                                for (let { stack: se, id: qe, glyph: je } of Q)ee[se] || (ee[se] = {}), ee[se][qe] = je && {
                                    id: je.id,
                                    bitmap: je.bitmap.clone(),
                                    metrics: je.metrics
                                };
                                return ee;
                            });
                        }
                        _getAndCacheGlyphsPromise(w, B) {
                            return a._(this, void 0, void 0, function*() {
                                let Q = this.entries[w];
                                Q || (Q = this.entries[w] = {
                                    glyphs: {},
                                    requests: {},
                                    ranges: {}
                                });
                                let ee = Q.glyphs[B];
                                if (ee !== void 0) return {
                                    stack: w,
                                    id: B,
                                    glyph: ee
                                };
                                if (ee = this._tinySDF(Q, w, B), ee) return Q.glyphs[B] = ee, {
                                    stack: w,
                                    id: B,
                                    glyph: ee
                                };
                                let se = Math.floor(B / 256);
                                if (256 * se > 65535) throw new Error("glyphs > 65535 not supported");
                                if (Q.ranges[se]) return {
                                    stack: w,
                                    id: B,
                                    glyph: ee
                                };
                                if (!this.url) throw new Error("glyphsUrl is not set");
                                if (!Q.requests[se]) {
                                    let je = H.loadGlyphRange(w, se, this.url, this.requestManager);
                                    Q.requests[se] = je;
                                }
                                let qe = yield Q.requests[se];
                                for(let je in qe)this._doesCharSupportLocalGlyph(+je) || (Q.glyphs[+je] = qe[+je]);
                                return Q.ranges[se] = !0, {
                                    stack: w,
                                    id: B,
                                    glyph: qe[B] || null
                                };
                            });
                        }
                        _doesCharSupportLocalGlyph(w) {
                            return !!this.localIdeographFontFamily && new RegExp("\\p{Ideo}|\\p{sc=Hang}|\\p{sc=Hira}|\\p{sc=Kana}", "u").test(String.fromCodePoint(w));
                        }
                        _tinySDF(w, B, Q) {
                            let ee = this.localIdeographFontFamily;
                            if (!ee || !this._doesCharSupportLocalGlyph(Q)) return;
                            let se = w.tinySDF;
                            if (!se) {
                                let je = "400";
                                /bold/i.test(B) ? je = "900" : /medium/i.test(B) ? je = "500" : /light/i.test(B) && (je = "200"), se = w.tinySDF = new H.TinySDF({
                                    fontSize: 48,
                                    buffer: 6,
                                    radius: 16,
                                    cutoff: .25,
                                    fontFamily: ee,
                                    fontWeight: je
                                });
                            }
                            let qe = se.draw(String.fromCharCode(Q));
                            return {
                                id: Q,
                                bitmap: new a.o({
                                    width: qe.width || 60,
                                    height: qe.height || 60
                                }, qe.data),
                                metrics: {
                                    width: qe.glyphWidth / 2 || 24,
                                    height: qe.glyphHeight / 2 || 24,
                                    left: qe.glyphLeft / 2 + .5 || 0,
                                    top: qe.glyphTop / 2 - 27.5 || -8,
                                    advance: qe.glyphAdvance / 2 || 24,
                                    isDoubleResolution: !0
                                }
                            };
                        }
                    }
                    H.loadGlyphRange = function(le, w, B, Q) {
                        return a._(this, void 0, void 0, function*() {
                            let ee = 256 * w, se = ee + 255, qe = Q.transformRequest(B.replace("{fontstack}", le).replace("{range}", `${ee}-${se}`), "Glyphs"), je = yield a.l(qe, new AbortController);
                            if (!je || !je.data) throw new Error(`Could not load glyph range. range: ${w}, ${ee}-${se}`);
                            let it = {};
                            for (let yt of a.n(je.data))it[yt.id] = yt;
                            return it;
                        });
                    }, H.TinySDF = class {
                        constructor({ fontSize: le = 24, buffer: w = 3, radius: B = 8, cutoff: Q = .25, fontFamily: ee = "sans-serif", fontWeight: se = "normal", fontStyle: qe = "normal" } = {}){
                            this.buffer = w, this.cutoff = Q, this.radius = B;
                            let je = this.size = le + 4 * w, it = this._createCanvas(je), yt = this.ctx = it.getContext("2d", {
                                willReadFrequently: !0
                            });
                            yt.font = `${qe} ${se} ${le}px ${ee}`, yt.textBaseline = "alphabetic", yt.textAlign = "left", yt.fillStyle = "black", this.gridOuter = new Float64Array(je * je), this.gridInner = new Float64Array(je * je), this.f = new Float64Array(je), this.z = new Float64Array(je + 1), this.v = new Uint16Array(je);
                        }
                        _createCanvas(le) {
                            let w = document.createElement("canvas");
                            return w.width = w.height = le, w;
                        }
                        draw(le) {
                            let { width: w, actualBoundingBoxAscent: B, actualBoundingBoxDescent: Q, actualBoundingBoxLeft: ee, actualBoundingBoxRight: se } = this.ctx.measureText(le), qe = Math.ceil(B), je = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(se - ee))), it = Math.min(this.size - this.buffer, qe + Math.ceil(Q)), yt = je + 2 * this.buffer, Ot = it + 2 * this.buffer, Nt = Math.max(yt * Ot, 0), hr = new Uint8ClampedArray(Nt), Sr = {
                                data: hr,
                                width: yt,
                                height: Ot,
                                glyphWidth: je,
                                glyphHeight: it,
                                glyphTop: qe,
                                glyphLeft: 0,
                                glyphAdvance: w
                            };
                            if (je === 0 || it === 0) return Sr;
                            let { ctx: he, buffer: be, gridInner: Pe, gridOuter: Oe } = this;
                            he.clearRect(be, be, je, it), he.fillText(le, be, be + qe);
                            let Je = he.getImageData(be, be, je, it);
                            Oe.fill(F, 0, Nt), Pe.fill(0, 0, Nt);
                            for(let He = 0; He < it; He++)for(let et = 0; et < je; et++){
                                let Mt = Je.data[4 * (He * je + et) + 3] / 255;
                                if (Mt === 0) continue;
                                let Dt = (He + be) * yt + et + be;
                                if (Mt === 1) Oe[Dt] = 0, Pe[Dt] = F;
                                else {
                                    let Ut = .5 - Mt;
                                    Oe[Dt] = Ut > 0 ? Ut * Ut : 0, Pe[Dt] = Ut < 0 ? Ut * Ut : 0;
                                }
                            }
                            q(Oe, 0, 0, yt, Ot, yt, this.f, this.v, this.z), q(Pe, be, be, je, it, yt, this.f, this.v, this.z);
                            for(let He = 0; He < Nt; He++){
                                let et = Math.sqrt(Oe[He]) - Math.sqrt(Pe[He]);
                                hr[He] = Math.round(255 - 255 * (et / this.radius + this.cutoff));
                            }
                            return Sr;
                        }
                    };
                    class X {
                        constructor(){
                            this.specification = a.v.light.position;
                        }
                        possiblyEvaluate(w, B) {
                            return a.x(w.expression.evaluate(B));
                        }
                        interpolate(w, B, Q) {
                            return {
                                x: a.y.number(w.x, B.x, Q),
                                y: a.y.number(w.y, B.y, Q),
                                z: a.y.number(w.z, B.z, Q)
                            };
                        }
                    }
                    let G;
                    class N extends a.E {
                        constructor(w){
                            super(), G = G || new a.q({
                                anchor: new a.D(a.v.light.anchor),
                                position: new X,
                                color: new a.D(a.v.light.color),
                                intensity: new a.D(a.v.light.intensity)
                            }), this._transitionable = new a.T(G), this.setLight(w), this._transitioning = this._transitionable.untransitioned();
                        }
                        getLight() {
                            return this._transitionable.serialize();
                        }
                        setLight(w, B = {}) {
                            if (!this._validate(a.r, w, B)) for(let Q in w){
                                let ee = w[Q];
                                Q.endsWith("-transition") ? this._transitionable.setTransition(Q.slice(0, -11), ee) : this._transitionable.setValue(Q, ee);
                            }
                        }
                        updateTransitions(w) {
                            this._transitioning = this._transitionable.transitioned(w, this._transitioning);
                        }
                        hasTransition() {
                            return this._transitioning.hasTransition();
                        }
                        recalculate(w) {
                            this.properties = this._transitioning.possiblyEvaluate(w);
                        }
                        _validate(w, B, Q) {
                            return (!Q || Q.validate !== !1) && a.t(this, w.call(a.u, {
                                value: B,
                                style: {
                                    glyphs: !0,
                                    sprite: !0
                                },
                                styleSpec: a.v
                            }));
                        }
                    }
                    let W = new a.q({
                        "sky-color": new a.D(a.v.sky["sky-color"]),
                        "horizon-color": new a.D(a.v.sky["horizon-color"]),
                        "fog-color": new a.D(a.v.sky["fog-color"]),
                        "fog-ground-blend": new a.D(a.v.sky["fog-ground-blend"]),
                        "horizon-fog-blend": new a.D(a.v.sky["horizon-fog-blend"]),
                        "sky-horizon-blend": new a.D(a.v.sky["sky-horizon-blend"]),
                        "atmosphere-blend": new a.D(a.v.sky["atmosphere-blend"])
                    });
                    class re extends a.E {
                        constructor(w){
                            super(), this._transitionable = new a.T(W), this.setSky(w), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new a.z(0));
                        }
                        setSky(w, B = {}) {
                            if (!this._validate(a.B, w, B)) {
                                w || (w = {
                                    "sky-color": "transparent",
                                    "horizon-color": "transparent",
                                    "fog-color": "transparent",
                                    "fog-ground-blend": 1,
                                    "atmosphere-blend": 0
                                });
                                for(let Q in w){
                                    let ee = w[Q];
                                    Q.endsWith("-transition") ? this._transitionable.setTransition(Q.slice(0, -11), ee) : this._transitionable.setValue(Q, ee);
                                }
                            }
                        }
                        getSky() {
                            return this._transitionable.serialize();
                        }
                        updateTransitions(w) {
                            this._transitioning = this._transitionable.transitioned(w, this._transitioning);
                        }
                        hasTransition() {
                            return this._transitioning.hasTransition();
                        }
                        recalculate(w) {
                            this.properties = this._transitioning.possiblyEvaluate(w);
                        }
                        _validate(w, B, Q = {}) {
                            return (Q == null ? void 0 : Q.validate) !== !1 && a.t(this, w.call(a.u, a.e({
                                value: B,
                                style: {
                                    glyphs: !0,
                                    sprite: !0
                                },
                                styleSpec: a.v
                            })));
                        }
                        calculateFogBlendOpacity(w) {
                            return w < 60 ? 0 : w < 70 ? (w - 60) / 10 : 1;
                        }
                    }
                    class ae {
                        constructor(w, B){
                            this.width = w, this.height = B, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
                        }
                        getDash(w, B) {
                            let Q = w.join(",") + String(B);
                            return this.dashEntry[Q] || (this.dashEntry[Q] = this.addDash(w, B)), this.dashEntry[Q];
                        }
                        getDashRanges(w, B, Q) {
                            let ee = [], se = w.length % 2 == 1 ? -w[w.length - 1] * Q : 0, qe = w[0] * Q, je = !0;
                            ee.push({
                                left: se,
                                right: qe,
                                isDash: je,
                                zeroLength: w[0] === 0
                            });
                            let it = w[0];
                            for(let yt = 1; yt < w.length; yt++){
                                je = !je;
                                let Ot = w[yt];
                                se = it * Q, it += Ot, qe = it * Q, ee.push({
                                    left: se,
                                    right: qe,
                                    isDash: je,
                                    zeroLength: Ot === 0
                                });
                            }
                            return ee;
                        }
                        addRoundDash(w, B, Q) {
                            let ee = B / 2;
                            for(let se = -Q; se <= Q; se++){
                                let qe = this.width * (this.nextRow + Q + se), je = 0, it = w[je];
                                for(let yt = 0; yt < this.width; yt++){
                                    yt / it.right > 1 && (it = w[++je]);
                                    let Ot = Math.abs(yt - it.left), Nt = Math.abs(yt - it.right), hr = Math.min(Ot, Nt), Sr, he = se / Q * (ee + 1);
                                    if (it.isDash) {
                                        let be = ee - Math.abs(he);
                                        Sr = Math.sqrt(hr * hr + be * be);
                                    } else Sr = ee - Math.sqrt(hr * hr + he * he);
                                    this.data[qe + yt] = Math.max(0, Math.min(255, Sr + 128));
                                }
                            }
                        }
                        addRegularDash(w) {
                            for(let je = w.length - 1; je >= 0; --je){
                                let it = w[je], yt = w[je + 1];
                                it.zeroLength ? w.splice(je, 1) : yt && yt.isDash === it.isDash && (yt.left = it.left, w.splice(je, 1));
                            }
                            let B = w[0], Q = w[w.length - 1];
                            B.isDash === Q.isDash && (B.left = Q.left - this.width, Q.right = B.right + this.width);
                            let ee = this.width * this.nextRow, se = 0, qe = w[se];
                            for(let je = 0; je < this.width; je++){
                                je / qe.right > 1 && (qe = w[++se]);
                                let it = Math.abs(je - qe.left), yt = Math.abs(je - qe.right), Ot = Math.min(it, yt);
                                this.data[ee + je] = Math.max(0, Math.min(255, (qe.isDash ? Ot : -Ot) + 128));
                            }
                        }
                        addDash(w, B) {
                            let Q = B ? 7 : 0, ee = 2 * Q + 1;
                            if (this.nextRow + ee > this.height) return a.w("LineAtlas out of space"), null;
                            let se = 0;
                            for(let je = 0; je < w.length; je++)se += w[je];
                            if (se !== 0) {
                                let je = this.width / se, it = this.getDashRanges(w, this.width, je);
                                B ? this.addRoundDash(it, je, Q) : this.addRegularDash(it);
                            }
                            let qe = {
                                y: (this.nextRow + Q + .5) / this.height,
                                height: 2 * Q / this.height,
                                width: se
                            };
                            return this.nextRow += ee, this.dirty = !0, qe;
                        }
                        bind(w) {
                            let B = w.gl;
                            this.texture ? (B.bindTexture(B.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, B.texSubImage2D(B.TEXTURE_2D, 0, 0, 0, this.width, this.height, B.ALPHA, B.UNSIGNED_BYTE, this.data))) : (this.texture = B.createTexture(), B.bindTexture(B.TEXTURE_2D, this.texture), B.texParameteri(B.TEXTURE_2D, B.TEXTURE_WRAP_S, B.REPEAT), B.texParameteri(B.TEXTURE_2D, B.TEXTURE_WRAP_T, B.REPEAT), B.texParameteri(B.TEXTURE_2D, B.TEXTURE_MIN_FILTER, B.LINEAR), B.texParameteri(B.TEXTURE_2D, B.TEXTURE_MAG_FILTER, B.LINEAR), B.texImage2D(B.TEXTURE_2D, 0, B.ALPHA, this.width, this.height, 0, B.ALPHA, B.UNSIGNED_BYTE, this.data));
                        }
                    }
                    let _e = "maplibre_preloaded_worker_pool";
                    class Me {
                        constructor(){
                            this.active = {};
                        }
                        acquire(w) {
                            if (!this.workers) for(this.workers = []; this.workers.length < Me.workerCount;)this.workers.push(new Worker(a.a.WORKER_URL));
                            return this.active[w] = !0, this.workers.slice();
                        }
                        release(w) {
                            delete this.active[w], this.numActive() === 0 && (this.workers.forEach((B)=>{
                                B.terminate();
                            }), this.workers = null);
                        }
                        isPreloaded() {
                            return !!this.active[_e];
                        }
                        numActive() {
                            return Object.keys(this.active).length;
                        }
                    }
                    let ke = Math.floor(u.hardwareConcurrency / 2), ge, ie;
                    function Te() {
                        return ge || (ge = new Me), ge;
                    }
                    Me.workerCount = a.C(globalThis) ? Math.max(Math.min(ke, 3), 1) : 1;
                    class Ee {
                        constructor(w, B){
                            this.workerPool = w, this.actors = [], this.currentActor = 0, this.id = B;
                            let Q = this.workerPool.acquire(B);
                            for(let ee = 0; ee < Q.length; ee++){
                                let se = new a.F(Q[ee], B);
                                se.name = `Worker ${ee}`, this.actors.push(se);
                            }
                            if (!this.actors.length) throw new Error("No actors found");
                        }
                        broadcast(w, B) {
                            let Q = [];
                            for (let ee of this.actors)Q.push(ee.sendAsync({
                                type: w,
                                data: B
                            }));
                            return Promise.all(Q);
                        }
                        getActor() {
                            return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
                        }
                        remove(w = !0) {
                            this.actors.forEach((B)=>{
                                B.remove();
                            }), this.actors = [], w && this.workerPool.release(this.id);
                        }
                        registerMessageHandler(w, B) {
                            for (let Q of this.actors)Q.registerMessageHandler(w, B);
                        }
                    }
                    function Ae() {
                        return ie || (ie = new Ee(Te(), a.G), ie.registerMessageHandler("GR", (le, w, B)=>a.m(w, B))), ie;
                    }
                    function ze(le, w) {
                        let B = a.H();
                        return a.J(B, B, [
                            1,
                            1,
                            0
                        ]), a.K(B, B, [
                            .5 * le.width,
                            .5 * le.height,
                            1
                        ]), a.L(B, B, le.calculatePosMatrix(w.toUnwrapped()));
                    }
                    function Ce(le, w, B, Q, ee, se) {
                        let qe = function(Nt, hr, Sr) {
                            if (Nt) for (let he of Nt){
                                let be = hr[he];
                                if (be && be.source === Sr && be.type === "fill-extrusion") return !0;
                            }
                            else for(let he in hr){
                                let be = hr[he];
                                if (be.source === Sr && be.type === "fill-extrusion") return !0;
                            }
                            return !1;
                        }(ee && ee.layers, w, le.id), je = se.maxPitchScaleFactor(), it = le.tilesIn(Q, je, qe);
                        it.sort(me);
                        let yt = [];
                        for (let Nt of it)yt.push({
                            wrappedTileID: Nt.tileID.wrapped().key,
                            queryResults: Nt.tile.queryRenderedFeatures(w, B, le._state, Nt.queryGeometry, Nt.cameraQueryGeometry, Nt.scale, ee, se, je, ze(le.transform, Nt.tileID))
                        });
                        let Ot = function(Nt) {
                            let hr = {}, Sr = {};
                            for (let he of Nt){
                                let be = he.queryResults, Pe = he.wrappedTileID, Oe = Sr[Pe] = Sr[Pe] || {};
                                for(let Je in be){
                                    let He = be[Je], et = Oe[Je] = Oe[Je] || {}, Mt = hr[Je] = hr[Je] || [];
                                    for (let Dt of He)et[Dt.featureIndex] || (et[Dt.featureIndex] = !0, Mt.push(Dt));
                                }
                            }
                            return hr;
                        }(yt);
                        for(let Nt in Ot)Ot[Nt].forEach((hr)=>{
                            let Sr = hr.feature, he = le.getFeatureState(Sr.layer["source-layer"], Sr.id);
                            Sr.source = Sr.layer.source, Sr.layer["source-layer"] && (Sr.sourceLayer = Sr.layer["source-layer"]), Sr.state = he;
                        });
                        return Ot;
                    }
                    function me(le, w) {
                        let B = le.tileID, Q = w.tileID;
                        return B.overscaledZ - Q.overscaledZ || B.canonical.y - Q.canonical.y || B.wrap - Q.wrap || B.canonical.x - Q.canonical.x;
                    }
                    function Re(le, w, B) {
                        return a._(this, void 0, void 0, function*() {
                            let Q = le;
                            if (le.url ? Q = (yield a.h(w.transformRequest(le.url, "Source"), B)).data : yield u.frameAsync(B), !Q) return null;
                            let ee = a.M(a.e(Q, le), [
                                "tiles",
                                "minzoom",
                                "maxzoom",
                                "attribution",
                                "bounds",
                                "scheme",
                                "tileSize",
                                "encoding"
                            ]);
                            return "vector_layers" in Q && Q.vector_layers && (ee.vectorLayerIds = Q.vector_layers.map((se)=>se.id)), ee;
                        });
                    }
                    class ce {
                        constructor(w, B){
                            w && (B ? this.setSouthWest(w).setNorthEast(B) : Array.isArray(w) && (w.length === 4 ? this.setSouthWest([
                                w[0],
                                w[1]
                            ]).setNorthEast([
                                w[2],
                                w[3]
                            ]) : this.setSouthWest(w[0]).setNorthEast(w[1])));
                        }
                        setNorthEast(w) {
                            return this._ne = w instanceof a.N ? new a.N(w.lng, w.lat) : a.N.convert(w), this;
                        }
                        setSouthWest(w) {
                            return this._sw = w instanceof a.N ? new a.N(w.lng, w.lat) : a.N.convert(w), this;
                        }
                        extend(w) {
                            let B = this._sw, Q = this._ne, ee, se;
                            if (w instanceof a.N) ee = w, se = w;
                            else {
                                if (!(w instanceof ce)) return Array.isArray(w) ? w.length === 4 || w.every(Array.isArray) ? this.extend(ce.convert(w)) : this.extend(a.N.convert(w)) : w && ("lng" in w || "lon" in w) && "lat" in w ? this.extend(a.N.convert(w)) : this;
                                if (ee = w._sw, se = w._ne, !ee || !se) return this;
                            }
                            return B || Q ? (B.lng = Math.min(ee.lng, B.lng), B.lat = Math.min(ee.lat, B.lat), Q.lng = Math.max(se.lng, Q.lng), Q.lat = Math.max(se.lat, Q.lat)) : (this._sw = new a.N(ee.lng, ee.lat), this._ne = new a.N(se.lng, se.lat)), this;
                        }
                        getCenter() {
                            return new a.N((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
                        }
                        getSouthWest() {
                            return this._sw;
                        }
                        getNorthEast() {
                            return this._ne;
                        }
                        getNorthWest() {
                            return new a.N(this.getWest(), this.getNorth());
                        }
                        getSouthEast() {
                            return new a.N(this.getEast(), this.getSouth());
                        }
                        getWest() {
                            return this._sw.lng;
                        }
                        getSouth() {
                            return this._sw.lat;
                        }
                        getEast() {
                            return this._ne.lng;
                        }
                        getNorth() {
                            return this._ne.lat;
                        }
                        toArray() {
                            return [
                                this._sw.toArray(),
                                this._ne.toArray()
                            ];
                        }
                        toString() {
                            return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
                        }
                        isEmpty() {
                            return !(this._sw && this._ne);
                        }
                        contains(w) {
                            let { lng: B, lat: Q } = a.N.convert(w), ee = this._sw.lng <= B && B <= this._ne.lng;
                            return this._sw.lng > this._ne.lng && (ee = this._sw.lng >= B && B >= this._ne.lng), this._sw.lat <= Q && Q <= this._ne.lat && ee;
                        }
                        static convert(w) {
                            return w instanceof ce ? w : w && new ce(w);
                        }
                        static fromLngLat(w, B = 0) {
                            let Q = 360 * B / 40075017, ee = Q / Math.cos(Math.PI / 180 * w.lat);
                            return new ce(new a.N(w.lng - ee, w.lat - Q), new a.N(w.lng + ee, w.lat + Q));
                        }
                        adjustAntiMeridian() {
                            let w = new a.N(this._sw.lng, this._sw.lat), B = new a.N(this._ne.lng, this._ne.lat);
                            return new ce(w, w.lng > B.lng ? new a.N(B.lng + 360, B.lat) : B);
                        }
                    }
                    class Ge {
                        constructor(w, B, Q){
                            this.bounds = ce.convert(this.validateBounds(w)), this.minzoom = B || 0, this.maxzoom = Q || 24;
                        }
                        validateBounds(w) {
                            return Array.isArray(w) && w.length === 4 ? [
                                Math.max(-180, w[0]),
                                Math.max(-90, w[1]),
                                Math.min(180, w[2]),
                                Math.min(90, w[3])
                            ] : [
                                -180,
                                -90,
                                180,
                                90
                            ];
                        }
                        contains(w) {
                            let B = Math.pow(2, w.z), Q = Math.floor(a.O(this.bounds.getWest()) * B), ee = Math.floor(a.Q(this.bounds.getNorth()) * B), se = Math.ceil(a.O(this.bounds.getEast()) * B), qe = Math.ceil(a.Q(this.bounds.getSouth()) * B);
                            return w.x >= Q && w.x < se && w.y >= ee && w.y < qe;
                        }
                    }
                    class nt extends a.E {
                        constructor(w, B, Q, ee){
                            if (super(), this.id = w, this.dispatcher = Q, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, a.e(this, a.M(B, [
                                "url",
                                "scheme",
                                "tileSize",
                                "promoteId"
                            ])), this._options = a.e({
                                type: "vector"
                            }, B), this._collectResourceTiming = B.collectResourceTiming, this.tileSize !== 512) throw new Error("vector tile sources must have a tileSize of 512");
                            this.setEventedParent(ee);
                        }
                        load() {
                            return a._(this, void 0, void 0, function*() {
                                this._loaded = !1, this.fire(new a.k("dataloading", {
                                    dataType: "source"
                                })), this._tileJSONRequest = new AbortController;
                                try {
                                    let w = yield Re(this._options, this.map._requestManager, this._tileJSONRequest);
                                    this._tileJSONRequest = null, this._loaded = !0, this.map.style.sourceCaches[this.id].clearTiles(), w && (a.e(this, w), w.bounds && (this.tileBounds = new Ge(w.bounds, this.minzoom, this.maxzoom)), this.fire(new a.k("data", {
                                        dataType: "source",
                                        sourceDataType: "metadata"
                                    })), this.fire(new a.k("data", {
                                        dataType: "source",
                                        sourceDataType: "content"
                                    })));
                                } catch (w) {
                                    this._tileJSONRequest = null, this.fire(new a.j(w));
                                }
                            });
                        }
                        loaded() {
                            return this._loaded;
                        }
                        hasTile(w) {
                            return !this.tileBounds || this.tileBounds.contains(w.canonical);
                        }
                        onAdd(w) {
                            this.map = w, this.load();
                        }
                        setSourceProperty(w) {
                            this._tileJSONRequest && this._tileJSONRequest.abort(), w(), this.load();
                        }
                        setTiles(w) {
                            return this.setSourceProperty(()=>{
                                this._options.tiles = w;
                            }), this;
                        }
                        setUrl(w) {
                            return this.setSourceProperty(()=>{
                                this.url = w, this._options.url = w;
                            }), this;
                        }
                        onRemove() {
                            this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
                        }
                        serialize() {
                            return a.e({}, this._options);
                        }
                        loadTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                let B = w.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), Q = {
                                    request: this.map._requestManager.transformRequest(B, "Tile"),
                                    uid: w.uid,
                                    tileID: w.tileID,
                                    zoom: w.tileID.overscaledZ,
                                    tileSize: this.tileSize * w.tileID.overscaleFactor(),
                                    type: this.type,
                                    source: this.id,
                                    pixelRatio: this.map.getPixelRatio(),
                                    showCollisionBoxes: this.map.showCollisionBoxes,
                                    promoteId: this.promoteId
                                };
                                Q.request.collectResourceTiming = this._collectResourceTiming;
                                let ee = "RT";
                                if (w.actor && w.state !== "expired") {
                                    if (w.state === "loading") return new Promise((se, qe)=>{
                                        w.reloadPromise = {
                                            resolve: se,
                                            reject: qe
                                        };
                                    });
                                } else w.actor = this.dispatcher.getActor(), ee = "LT";
                                w.abortController = new AbortController;
                                try {
                                    let se = yield w.actor.sendAsync({
                                        type: ee,
                                        data: Q
                                    }, w.abortController);
                                    if (delete w.abortController, w.aborted) return;
                                    this._afterTileLoadWorkerResponse(w, se);
                                } catch (se) {
                                    if (delete w.abortController, w.aborted) return;
                                    if (se && se.status !== 404) throw se;
                                    this._afterTileLoadWorkerResponse(w, null);
                                }
                            });
                        }
                        _afterTileLoadWorkerResponse(w, B) {
                            if (B && B.resourceTiming && (w.resourceTiming = B.resourceTiming), B && this.map._refreshExpiredTiles && w.setExpiryData(B), w.loadVectorData(B, this.map.painter), w.reloadPromise) {
                                let Q = w.reloadPromise;
                                w.reloadPromise = null, this.loadTile(w).then(Q.resolve).catch(Q.reject);
                            }
                        }
                        abortTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                w.abortController && (w.abortController.abort(), delete w.abortController), w.actor && (yield w.actor.sendAsync({
                                    type: "AT",
                                    data: {
                                        uid: w.uid,
                                        type: this.type,
                                        source: this.id
                                    }
                                }));
                            });
                        }
                        unloadTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                w.unloadVectorData(), w.actor && (yield w.actor.sendAsync({
                                    type: "RMT",
                                    data: {
                                        uid: w.uid,
                                        type: this.type,
                                        source: this.id
                                    }
                                }));
                            });
                        }
                        hasTransition() {
                            return !1;
                        }
                    }
                    class ct extends a.E {
                        constructor(w, B, Q, ee){
                            super(), this.id = w, this.dispatcher = Q, this.setEventedParent(ee), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = a.e({
                                type: "raster"
                            }, B), a.e(this, a.M(B, [
                                "url",
                                "scheme",
                                "tileSize"
                            ]));
                        }
                        load() {
                            return a._(this, void 0, void 0, function*() {
                                this._loaded = !1, this.fire(new a.k("dataloading", {
                                    dataType: "source"
                                })), this._tileJSONRequest = new AbortController;
                                try {
                                    let w = yield Re(this._options, this.map._requestManager, this._tileJSONRequest);
                                    this._tileJSONRequest = null, this._loaded = !0, w && (a.e(this, w), w.bounds && (this.tileBounds = new Ge(w.bounds, this.minzoom, this.maxzoom)), this.fire(new a.k("data", {
                                        dataType: "source",
                                        sourceDataType: "metadata"
                                    })), this.fire(new a.k("data", {
                                        dataType: "source",
                                        sourceDataType: "content"
                                    })));
                                } catch (w) {
                                    this._tileJSONRequest = null, this.fire(new a.j(w));
                                }
                            });
                        }
                        loaded() {
                            return this._loaded;
                        }
                        onAdd(w) {
                            this.map = w, this.load();
                        }
                        onRemove() {
                            this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
                        }
                        setSourceProperty(w) {
                            this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null), w(), this.load();
                        }
                        setTiles(w) {
                            return this.setSourceProperty(()=>{
                                this._options.tiles = w;
                            }), this;
                        }
                        setUrl(w) {
                            return this.setSourceProperty(()=>{
                                this.url = w, this._options.url = w;
                            }), this;
                        }
                        serialize() {
                            return a.e({}, this._options);
                        }
                        hasTile(w) {
                            return !this.tileBounds || this.tileBounds.contains(w.canonical);
                        }
                        loadTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                let B = w.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                                w.abortController = new AbortController;
                                try {
                                    let Q = yield p.getImage(this.map._requestManager.transformRequest(B, "Tile"), w.abortController, this.map._refreshExpiredTiles);
                                    if (delete w.abortController, w.aborted) return void (w.state = "unloaded");
                                    if (Q && Q.data) {
                                        this.map._refreshExpiredTiles && Q.cacheControl && Q.expires && w.setExpiryData({
                                            cacheControl: Q.cacheControl,
                                            expires: Q.expires
                                        });
                                        let ee = this.map.painter.context, se = ee.gl, qe = Q.data;
                                        w.texture = this.map.painter.getTileTexture(qe.width), w.texture ? w.texture.update(qe, {
                                            useMipmap: !0
                                        }) : (w.texture = new g(ee, qe, se.RGBA, {
                                            useMipmap: !0
                                        }), w.texture.bind(se.LINEAR, se.CLAMP_TO_EDGE, se.LINEAR_MIPMAP_NEAREST)), w.state = "loaded";
                                    }
                                } catch (Q) {
                                    if (delete w.abortController, w.aborted) w.state = "unloaded";
                                    else if (Q) throw w.state = "errored", Q;
                                }
                            });
                        }
                        abortTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                w.abortController && (w.abortController.abort(), delete w.abortController);
                            });
                        }
                        unloadTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                w.texture && this.map.painter.saveTileTexture(w.texture);
                            });
                        }
                        hasTransition() {
                            return !1;
                        }
                    }
                    class qt extends ct {
                        constructor(w, B, Q, ee){
                            super(w, B, Q, ee), this.type = "raster-dem", this.maxzoom = 22, this._options = a.e({
                                type: "raster-dem"
                            }, B), this.encoding = B.encoding || "mapbox", this.redFactor = B.redFactor, this.greenFactor = B.greenFactor, this.blueFactor = B.blueFactor, this.baseShift = B.baseShift;
                        }
                        loadTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                let B = w.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), Q = this.map._requestManager.transformRequest(B, "Tile");
                                w.neighboringTiles = this._getNeighboringTiles(w.tileID), w.abortController = new AbortController;
                                try {
                                    let ee = yield p.getImage(Q, w.abortController, this.map._refreshExpiredTiles);
                                    if (delete w.abortController, w.aborted) return void (w.state = "unloaded");
                                    if (ee && ee.data) {
                                        let se = ee.data;
                                        this.map._refreshExpiredTiles && ee.cacheControl && ee.expires && w.setExpiryData({
                                            cacheControl: ee.cacheControl,
                                            expires: ee.expires
                                        });
                                        let qe = a.b(se) && a.U() ? se : yield this.readImageNow(se), je = {
                                            type: this.type,
                                            uid: w.uid,
                                            source: this.id,
                                            rawImageData: qe,
                                            encoding: this.encoding,
                                            redFactor: this.redFactor,
                                            greenFactor: this.greenFactor,
                                            blueFactor: this.blueFactor,
                                            baseShift: this.baseShift
                                        };
                                        if (!w.actor || w.state === "expired") {
                                            w.actor = this.dispatcher.getActor();
                                            let it = yield w.actor.sendAsync({
                                                type: "LDT",
                                                data: je
                                            });
                                            w.dem = it, w.needsHillshadePrepare = !0, w.needsTerrainPrepare = !0, w.state = "loaded";
                                        }
                                    }
                                } catch (ee) {
                                    if (delete w.abortController, w.aborted) w.state = "unloaded";
                                    else if (ee) throw w.state = "errored", ee;
                                }
                            });
                        }
                        readImageNow(w) {
                            return a._(this, void 0, void 0, function*() {
                                if (typeof VideoFrame != "undefined" && a.V()) {
                                    let B = w.width + 2, Q = w.height + 2;
                                    try {
                                        return new a.R({
                                            width: B,
                                            height: Q
                                        }, (yield a.W(w, -1, -1, B, Q)));
                                    } catch (ee) {}
                                }
                                return u.getImageData(w, 1);
                            });
                        }
                        _getNeighboringTiles(w) {
                            let B = w.canonical, Q = Math.pow(2, B.z), ee = (B.x - 1 + Q) % Q, se = B.x === 0 ? w.wrap - 1 : w.wrap, qe = (B.x + 1 + Q) % Q, je = B.x + 1 === Q ? w.wrap + 1 : w.wrap, it = {};
                            return it[new a.S(w.overscaledZ, se, B.z, ee, B.y).key] = {
                                backfilled: !1
                            }, it[new a.S(w.overscaledZ, je, B.z, qe, B.y).key] = {
                                backfilled: !1
                            }, B.y > 0 && (it[new a.S(w.overscaledZ, se, B.z, ee, B.y - 1).key] = {
                                backfilled: !1
                            }, it[new a.S(w.overscaledZ, w.wrap, B.z, B.x, B.y - 1).key] = {
                                backfilled: !1
                            }, it[new a.S(w.overscaledZ, je, B.z, qe, B.y - 1).key] = {
                                backfilled: !1
                            }), B.y + 1 < Q && (it[new a.S(w.overscaledZ, se, B.z, ee, B.y + 1).key] = {
                                backfilled: !1
                            }, it[new a.S(w.overscaledZ, w.wrap, B.z, B.x, B.y + 1).key] = {
                                backfilled: !1
                            }, it[new a.S(w.overscaledZ, je, B.z, qe, B.y + 1).key] = {
                                backfilled: !1
                            }), it;
                        }
                        unloadTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                w.demTexture && this.map.painter.saveTileTexture(w.demTexture), w.fbo && (w.fbo.destroy(), delete w.fbo), w.dem && delete w.dem, delete w.neighboringTiles, w.state = "unloaded", w.actor && (yield w.actor.sendAsync({
                                    type: "RDT",
                                    data: {
                                        type: this.type,
                                        uid: w.uid,
                                        source: this.id
                                    }
                                }));
                            });
                        }
                    }
                    class rt extends a.E {
                        constructor(w, B, Q, ee){
                            super(), this.id = w, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._pendingLoads = 0, this.actor = Q.getActor(), this.setEventedParent(ee), this._data = B.data, this._options = a.e({}, B), this._collectResourceTiming = B.collectResourceTiming, B.maxzoom !== void 0 && (this.maxzoom = B.maxzoom), B.type && (this.type = B.type), B.attribution && (this.attribution = B.attribution), this.promoteId = B.promoteId;
                            let se = a.X / this.tileSize;
                            B.clusterMaxZoom !== void 0 && this.maxzoom <= B.clusterMaxZoom && a.w(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${B.clusterMaxZoom}".`), this.workerOptions = a.e({
                                source: this.id,
                                cluster: B.cluster || !1,
                                geojsonVtOptions: {
                                    buffer: (B.buffer !== void 0 ? B.buffer : 128) * se,
                                    tolerance: (B.tolerance !== void 0 ? B.tolerance : .375) * se,
                                    extent: a.X,
                                    maxZoom: this.maxzoom,
                                    lineMetrics: B.lineMetrics || !1,
                                    generateId: B.generateId || !1
                                },
                                superclusterOptions: {
                                    maxZoom: B.clusterMaxZoom !== void 0 ? B.clusterMaxZoom : this.maxzoom - 1,
                                    minPoints: Math.max(2, B.clusterMinPoints || 2),
                                    extent: a.X,
                                    radius: (B.clusterRadius || 50) * se,
                                    log: !1,
                                    generateId: B.generateId || !1
                                },
                                clusterProperties: B.clusterProperties,
                                filter: B.filter
                            }, B.workerOptions), typeof this.promoteId == "string" && (this.workerOptions.promoteId = this.promoteId);
                        }
                        load() {
                            return a._(this, void 0, void 0, function*() {
                                yield this._updateWorkerData();
                            });
                        }
                        onAdd(w) {
                            this.map = w, this.load();
                        }
                        setData(w) {
                            return this._data = w, this._updateWorkerData(), this;
                        }
                        updateData(w) {
                            return this._updateWorkerData(w), this;
                        }
                        getData() {
                            return a._(this, void 0, void 0, function*() {
                                let w = a.e({
                                    type: this.type
                                }, this.workerOptions);
                                return this.actor.sendAsync({
                                    type: "GD",
                                    data: w
                                });
                            });
                        }
                        setClusterOptions(w) {
                            return this.workerOptions.cluster = w.cluster, w && (w.clusterRadius !== void 0 && (this.workerOptions.superclusterOptions.radius = w.clusterRadius), w.clusterMaxZoom !== void 0 && (this.workerOptions.superclusterOptions.maxZoom = w.clusterMaxZoom)), this._updateWorkerData(), this;
                        }
                        getClusterExpansionZoom(w) {
                            return this.actor.sendAsync({
                                type: "GCEZ",
                                data: {
                                    type: this.type,
                                    clusterId: w,
                                    source: this.id
                                }
                            });
                        }
                        getClusterChildren(w) {
                            return this.actor.sendAsync({
                                type: "GCC",
                                data: {
                                    type: this.type,
                                    clusterId: w,
                                    source: this.id
                                }
                            });
                        }
                        getClusterLeaves(w, B, Q) {
                            return this.actor.sendAsync({
                                type: "GCL",
                                data: {
                                    type: this.type,
                                    source: this.id,
                                    clusterId: w,
                                    limit: B,
                                    offset: Q
                                }
                            });
                        }
                        _updateWorkerData(w) {
                            return a._(this, void 0, void 0, function*() {
                                let B = a.e({
                                    type: this.type
                                }, this.workerOptions);
                                w ? B.dataDiff = w : typeof this._data == "string" ? (B.request = this.map._requestManager.transformRequest(u.resolveURL(this._data), "Source"), B.request.collectResourceTiming = this._collectResourceTiming) : B.data = JSON.stringify(this._data), this._pendingLoads++, this.fire(new a.k("dataloading", {
                                    dataType: "source"
                                }));
                                try {
                                    let Q = yield this.actor.sendAsync({
                                        type: "LD",
                                        data: B
                                    });
                                    if (this._pendingLoads--, this._removed || Q.abandoned) return void this.fire(new a.k("dataabort", {
                                        dataType: "source"
                                    }));
                                    let ee = null;
                                    Q.resourceTiming && Q.resourceTiming[this.id] && (ee = Q.resourceTiming[this.id].slice(0));
                                    let se = {
                                        dataType: "source"
                                    };
                                    this._collectResourceTiming && ee && ee.length > 0 && a.e(se, {
                                        resourceTiming: ee
                                    }), this.fire(new a.k("data", Object.assign(Object.assign({}, se), {
                                        sourceDataType: "metadata"
                                    }))), this.fire(new a.k("data", Object.assign(Object.assign({}, se), {
                                        sourceDataType: "content"
                                    })));
                                } catch (Q) {
                                    if (this._pendingLoads--, this._removed) return void this.fire(new a.k("dataabort", {
                                        dataType: "source"
                                    }));
                                    this.fire(new a.j(Q));
                                }
                            });
                        }
                        loaded() {
                            return this._pendingLoads === 0;
                        }
                        loadTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                let B = w.actor ? "RT" : "LT";
                                w.actor = this.actor;
                                let Q = {
                                    type: this.type,
                                    uid: w.uid,
                                    tileID: w.tileID,
                                    zoom: w.tileID.overscaledZ,
                                    maxZoom: this.maxzoom,
                                    tileSize: this.tileSize,
                                    source: this.id,
                                    pixelRatio: this.map.getPixelRatio(),
                                    showCollisionBoxes: this.map.showCollisionBoxes,
                                    promoteId: this.promoteId
                                };
                                w.abortController = new AbortController;
                                let ee = yield this.actor.sendAsync({
                                    type: B,
                                    data: Q
                                }, w.abortController);
                                delete w.abortController, w.unloadVectorData(), w.aborted || w.loadVectorData(ee, this.map.painter, B === "RT");
                            });
                        }
                        abortTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                w.abortController && (w.abortController.abort(), delete w.abortController), w.aborted = !0;
                            });
                        }
                        unloadTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                w.unloadVectorData(), yield this.actor.sendAsync({
                                    type: "RMT",
                                    data: {
                                        uid: w.uid,
                                        type: this.type,
                                        source: this.id
                                    }
                                });
                            });
                        }
                        onRemove() {
                            this._removed = !0, this.actor.sendAsync({
                                type: "RS",
                                data: {
                                    type: this.type,
                                    source: this.id
                                }
                            });
                        }
                        serialize() {
                            return a.e({}, this._options, {
                                type: this.type,
                                data: this._data
                            });
                        }
                        hasTransition() {
                            return !1;
                        }
                    }
                    var ot = a.Y([
                        {
                            name: "a_pos",
                            type: "Int16",
                            components: 2
                        },
                        {
                            name: "a_texture_pos",
                            type: "Int16",
                            components: 2
                        }
                    ]);
                    class Rt extends a.E {
                        constructor(w, B, Q, ee){
                            super(), this.id = w, this.dispatcher = Q, this.coordinates = B.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(ee), this.options = B;
                        }
                        load(w) {
                            return a._(this, void 0, void 0, function*() {
                                this._loaded = !1, this.fire(new a.k("dataloading", {
                                    dataType: "source"
                                })), this.url = this.options.url, this._request = new AbortController;
                                try {
                                    let B = yield p.getImage(this.map._requestManager.transformRequest(this.url, "Image"), this._request);
                                    this._request = null, this._loaded = !0, B && B.data && (this.image = B.data, w && (this.coordinates = w), this._finishLoading());
                                } catch (B) {
                                    this._request = null, this._loaded = !0, this.fire(new a.j(B));
                                }
                            });
                        }
                        loaded() {
                            return this._loaded;
                        }
                        updateImage(w) {
                            return w.url ? (this._request && (this._request.abort(), this._request = null), this.options.url = w.url, this.load(w.coordinates).finally(()=>{
                                this.texture = null;
                            }), this) : this;
                        }
                        _finishLoading() {
                            this.map && (this.setCoordinates(this.coordinates), this.fire(new a.k("data", {
                                dataType: "source",
                                sourceDataType: "metadata"
                            })));
                        }
                        onAdd(w) {
                            this.map = w, this.load();
                        }
                        onRemove() {
                            this._request && (this._request.abort(), this._request = null);
                        }
                        setCoordinates(w) {
                            this.coordinates = w;
                            let B = w.map(a.Z.fromLngLat);
                            this.tileID = function(ee) {
                                let se = 1 / 0, qe = 1 / 0, je = -1 / 0, it = -1 / 0;
                                for (let hr of ee)se = Math.min(se, hr.x), qe = Math.min(qe, hr.y), je = Math.max(je, hr.x), it = Math.max(it, hr.y);
                                let yt = Math.max(je - se, it - qe), Ot = Math.max(0, Math.floor(-Math.log(yt) / Math.LN2)), Nt = Math.pow(2, Ot);
                                return new a.a1(Ot, Math.floor((se + je) / 2 * Nt), Math.floor((qe + it) / 2 * Nt));
                            }(B), this.minzoom = this.maxzoom = this.tileID.z;
                            let Q = B.map((ee)=>this.tileID.getTilePoint(ee)._round());
                            return this._boundsArray = new a.$, this._boundsArray.emplaceBack(Q[0].x, Q[0].y, 0, 0), this._boundsArray.emplaceBack(Q[1].x, Q[1].y, a.X, 0), this._boundsArray.emplaceBack(Q[3].x, Q[3].y, 0, a.X), this._boundsArray.emplaceBack(Q[2].x, Q[2].y, a.X, a.X), this.boundsBuffer && (this.boundsBuffer.destroy(), delete this.boundsBuffer), this.fire(new a.k("data", {
                                dataType: "source",
                                sourceDataType: "content"
                            })), this;
                        }
                        prepare() {
                            if (Object.keys(this.tiles).length === 0 || !this.image) return;
                            let w = this.map.painter.context, B = w.gl;
                            this.boundsBuffer || (this.boundsBuffer = w.createVertexBuffer(this._boundsArray, ot.members)), this.boundsSegments || (this.boundsSegments = a.a0.simpleSegment(0, 0, 4, 2)), this.texture || (this.texture = new g(w, this.image, B.RGBA), this.texture.bind(B.LINEAR, B.CLAMP_TO_EDGE));
                            let Q = !1;
                            for(let ee in this.tiles){
                                let se = this.tiles[ee];
                                se.state !== "loaded" && (se.state = "loaded", se.texture = this.texture, Q = !0);
                            }
                            Q && this.fire(new a.k("data", {
                                dataType: "source",
                                sourceDataType: "idle",
                                sourceId: this.id
                            }));
                        }
                        loadTile(w) {
                            return a._(this, void 0, void 0, function*() {
                                this.tileID && this.tileID.equals(w.tileID.canonical) ? (this.tiles[String(w.tileID.wrap)] = w, w.buckets = {}) : w.state = "errored";
                            });
                        }
                        serialize() {
                            return {
                                type: "image",
                                url: this.options.url,
                                coordinates: this.coordinates
                            };
                        }
                        hasTransition() {
                            return !1;
                        }
                    }
                    class kt extends Rt {
                        constructor(w, B, Q, ee){
                            super(w, B, Q, ee), this.roundZoom = !0, this.type = "video", this.options = B;
                        }
                        load() {
                            return a._(this, void 0, void 0, function*() {
                                this._loaded = !1;
                                let w = this.options;
                                this.urls = [];
                                for (let B of w.urls)this.urls.push(this.map._requestManager.transformRequest(B, "Source").url);
                                try {
                                    let B = yield a.a3(this.urls);
                                    if (this._loaded = !0, !B) return;
                                    this.video = B, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                                        this.map.triggerRepaint();
                                    }), this.map && this.video.play(), this._finishLoading();
                                } catch (B) {
                                    this.fire(new a.j(B));
                                }
                            });
                        }
                        pause() {
                            this.video && this.video.pause();
                        }
                        play() {
                            this.video && this.video.play();
                        }
                        seek(w) {
                            if (this.video) {
                                let B = this.video.seekable;
                                w < B.start(0) || w > B.end(0) ? this.fire(new a.j(new a.a2(`sources.${this.id}`, null, `Playback for this video can be set only between the ${B.start(0)} and ${B.end(0)}-second mark.`))) : this.video.currentTime = w;
                            }
                        }
                        getVideo() {
                            return this.video;
                        }
                        onAdd(w) {
                            this.map || (this.map = w, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                        }
                        prepare() {
                            if (Object.keys(this.tiles).length === 0 || this.video.readyState < 2) return;
                            let w = this.map.painter.context, B = w.gl;
                            this.boundsBuffer || (this.boundsBuffer = w.createVertexBuffer(this._boundsArray, ot.members)), this.boundsSegments || (this.boundsSegments = a.a0.simpleSegment(0, 0, 4, 2)), this.texture ? this.video.paused || (this.texture.bind(B.LINEAR, B.CLAMP_TO_EDGE), B.texSubImage2D(B.TEXTURE_2D, 0, 0, 0, B.RGBA, B.UNSIGNED_BYTE, this.video)) : (this.texture = new g(w, this.video, B.RGBA), this.texture.bind(B.LINEAR, B.CLAMP_TO_EDGE));
                            let Q = !1;
                            for(let ee in this.tiles){
                                let se = this.tiles[ee];
                                se.state !== "loaded" && (se.state = "loaded", se.texture = this.texture, Q = !0);
                            }
                            Q && this.fire(new a.k("data", {
                                dataType: "source",
                                sourceDataType: "idle",
                                sourceId: this.id
                            }));
                        }
                        serialize() {
                            return {
                                type: "video",
                                urls: this.urls,
                                coordinates: this.coordinates
                            };
                        }
                        hasTransition() {
                            return this.video && !this.video.paused;
                        }
                    }
                    class Ct extends Rt {
                        constructor(w, B, Q, ee){
                            super(w, B, Q, ee), B.coordinates ? Array.isArray(B.coordinates) && B.coordinates.length === 4 && !B.coordinates.some((se)=>!Array.isArray(se) || se.length !== 2 || se.some((qe)=>typeof qe != "number")) || this.fire(new a.j(new a.a2(`sources.${w}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new a.j(new a.a2(`sources.${w}`, null, 'missing required property "coordinates"'))), B.animate && typeof B.animate != "boolean" && this.fire(new a.j(new a.a2(`sources.${w}`, null, 'optional "animate" property must be a boolean value'))), B.canvas ? typeof B.canvas == "string" || B.canvas instanceof HTMLCanvasElement || this.fire(new a.j(new a.a2(`sources.${w}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new a.j(new a.a2(`sources.${w}`, null, 'missing required property "canvas"'))), this.options = B, this.animate = B.animate === void 0 || B.animate;
                        }
                        load() {
                            return a._(this, void 0, void 0, function*() {
                                this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new a.j(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                                    this._playing = !0, this.map.triggerRepaint();
                                }, this.pause = function() {
                                    this._playing && (this.prepare(), this._playing = !1);
                                }, this._finishLoading());
                            });
                        }
                        getCanvas() {
                            return this.canvas;
                        }
                        onAdd(w) {
                            this.map = w, this.load(), this.canvas && this.animate && this.play();
                        }
                        onRemove() {
                            this.pause();
                        }
                        prepare() {
                            let w = !1;
                            if (this.canvas.width !== this.width && (this.width = this.canvas.width, w = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, w = !0), this._hasInvalidDimensions() || Object.keys(this.tiles).length === 0) return;
                            let B = this.map.painter.context, Q = B.gl;
                            this.boundsBuffer || (this.boundsBuffer = B.createVertexBuffer(this._boundsArray, ot.members)), this.boundsSegments || (this.boundsSegments = a.a0.simpleSegment(0, 0, 4, 2)), this.texture ? (w || this._playing) && this.texture.update(this.canvas, {
                                premultiply: !0
                            }) : this.texture = new g(B, this.canvas, Q.RGBA, {
                                premultiply: !0
                            });
                            let ee = !1;
                            for(let se in this.tiles){
                                let qe = this.tiles[se];
                                qe.state !== "loaded" && (qe.state = "loaded", qe.texture = this.texture, ee = !0);
                            }
                            ee && this.fire(new a.k("data", {
                                dataType: "source",
                                sourceDataType: "idle",
                                sourceId: this.id
                            }));
                        }
                        serialize() {
                            return {
                                type: "canvas",
                                coordinates: this.coordinates
                            };
                        }
                        hasTransition() {
                            return this._playing;
                        }
                        _hasInvalidDimensions() {
                            for (let w of [
                                this.canvas.width,
                                this.canvas.height
                            ])if (isNaN(w) || w <= 0) return !0;
                            return !1;
                        }
                    }
                    let Yt = {}, xr = (le)=>{
                        switch(le){
                            case "geojson":
                                return rt;
                            case "image":
                                return Rt;
                            case "raster":
                                return ct;
                            case "raster-dem":
                                return qt;
                            case "vector":
                                return nt;
                            case "video":
                                return kt;
                            case "canvas":
                                return Ct;
                        }
                        return Yt[le];
                    }, er = "RTLPluginLoaded";
                    class Ke extends a.E {
                        constructor(){
                            super(...arguments), this.status = "unavailable", this.url = null, this.dispatcher = Ae();
                        }
                        _syncState(w) {
                            return this.status = w, this.dispatcher.broadcast("SRPS", {
                                pluginStatus: w,
                                pluginURL: this.url
                            }).catch((B)=>{
                                throw this.status = "error", B;
                            });
                        }
                        getRTLTextPluginStatus() {
                            return this.status;
                        }
                        clearRTLTextPlugin() {
                            this.status = "unavailable", this.url = null;
                        }
                        setRTLTextPlugin(w) {
                            return a._(this, arguments, void 0, function*(B, Q = !1) {
                                if (this.url) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                                if (this.url = u.resolveURL(B), !this.url) throw new Error(`requested url ${B} is invalid`);
                                if (this.status === "unavailable") {
                                    if (!Q) return this._requestImport();
                                    this.status = "deferred", this._syncState(this.status);
                                } else if (this.status === "requested") return this._requestImport();
                            });
                        }
                        _requestImport() {
                            return a._(this, void 0, void 0, function*() {
                                yield this._syncState("loading"), this.status = "loaded", this.fire(new a.k(er));
                            });
                        }
                        lazyLoad() {
                            this.status === "unavailable" ? this.status = "requested" : this.status === "deferred" && this._requestImport();
                        }
                    }
                    let xt = null;
                    function bt() {
                        return xt || (xt = new Ke), xt;
                    }
                    class Lt {
                        constructor(w, B){
                            this.timeAdded = 0, this.fadeEndTime = 0, this.tileID = w, this.uid = a.a4(), this.uses = 0, this.tileSize = B, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
                        }
                        registerFadeDuration(w) {
                            let B = w + this.timeAdded;
                            B < this.fadeEndTime || (this.fadeEndTime = B);
                        }
                        wasRequested() {
                            return this.state === "errored" || this.state === "loaded" || this.state === "reloading";
                        }
                        clearTextures(w) {
                            this.demTexture && w.saveTileTexture(this.demTexture), this.demTexture = null;
                        }
                        loadVectorData(w, B, Q) {
                            if (this.hasData() && this.unloadVectorData(), this.state = "loaded", w) {
                                w.featureIndex && (this.latestFeatureIndex = w.featureIndex, w.rawTileData ? (this.latestRawTileData = w.rawTileData, this.latestFeatureIndex.rawTileData = w.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = w.collisionBoxArray, this.buckets = function(ee, se) {
                                    let qe = {};
                                    if (!se) return qe;
                                    for (let je of ee){
                                        let it = je.layerIds.map((yt)=>se.getLayer(yt)).filter(Boolean);
                                        if (it.length !== 0) {
                                            je.layers = it, je.stateDependentLayerIds && (je.stateDependentLayers = je.stateDependentLayerIds.map((yt)=>it.filter((Ot)=>Ot.id === yt)[0]));
                                            for (let yt of it)qe[yt.id] = je;
                                        }
                                    }
                                    return qe;
                                }(w.buckets, B.style), this.hasSymbolBuckets = !1;
                                for(let ee in this.buckets){
                                    let se = this.buckets[ee];
                                    if (se instanceof a.a6) {
                                        if (this.hasSymbolBuckets = !0, !Q) break;
                                        se.justReloaded = !0;
                                    }
                                }
                                if (this.hasRTLText = !1, this.hasSymbolBuckets) for(let ee in this.buckets){
                                    let se = this.buckets[ee];
                                    if (se instanceof a.a6 && se.hasRTLText) {
                                        this.hasRTLText = !0, bt().lazyLoad();
                                        break;
                                    }
                                }
                                this.queryPadding = 0;
                                for(let ee in this.buckets){
                                    let se = this.buckets[ee];
                                    this.queryPadding = Math.max(this.queryPadding, B.style.getLayer(ee).queryRadius(se));
                                }
                                w.imageAtlas && (this.imageAtlas = w.imageAtlas), w.glyphAtlasImage && (this.glyphAtlasImage = w.glyphAtlasImage);
                            } else this.collisionBoxArray = new a.a5;
                        }
                        unloadVectorData() {
                            for(let w in this.buckets)this.buckets[w].destroy();
                            this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.latestFeatureIndex = null, this.state = "unloaded";
                        }
                        getBucket(w) {
                            return this.buckets[w.id];
                        }
                        upload(w) {
                            for(let Q in this.buckets){
                                let ee = this.buckets[Q];
                                ee.uploadPending() && ee.upload(w);
                            }
                            let B = w.gl;
                            this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new g(w, this.imageAtlas.image, B.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new g(w, this.glyphAtlasImage, B.ALPHA), this.glyphAtlasImage = null);
                        }
                        prepare(w) {
                            this.imageAtlas && this.imageAtlas.patchUpdatedImages(w, this.imageAtlasTexture);
                        }
                        queryRenderedFeatures(w, B, Q, ee, se, qe, je, it, yt, Ot) {
                            return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                                queryGeometry: ee,
                                cameraQueryGeometry: se,
                                scale: qe,
                                tileSize: this.tileSize,
                                pixelPosMatrix: Ot,
                                transform: it,
                                params: je,
                                queryPadding: this.queryPadding * yt
                            }, w, B, Q) : {};
                        }
                        querySourceFeatures(w, B) {
                            let Q = this.latestFeatureIndex;
                            if (!Q || !Q.rawTileData) return;
                            let ee = Q.loadVTLayers(), se = B && B.sourceLayer ? B.sourceLayer : "", qe = ee._geojsonTileLayer || ee[se];
                            if (!qe) return;
                            let je = a.a7(B && B.filter), { z: it, x: yt, y: Ot } = this.tileID.canonical, Nt = {
                                z: it,
                                x: yt,
                                y: Ot
                            };
                            for(let hr = 0; hr < qe.length; hr++){
                                let Sr = qe.feature(hr);
                                if (je.needGeometry) {
                                    let Pe = a.a8(Sr, !0);
                                    if (!je.filter(new a.z(this.tileID.overscaledZ), Pe, this.tileID.canonical)) continue;
                                } else if (!je.filter(new a.z(this.tileID.overscaledZ), Sr)) continue;
                                let he = Q.getId(Sr, se), be = new a.a9(Sr, it, yt, Ot, he);
                                be.tile = Nt, w.push(be);
                            }
                        }
                        hasData() {
                            return this.state === "loaded" || this.state === "reloading" || this.state === "expired";
                        }
                        patternsLoaded() {
                            return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
                        }
                        setExpiryData(w) {
                            let B = this.expirationTime;
                            if (w.cacheControl) {
                                let Q = a.aa(w.cacheControl);
                                Q["max-age"] && (this.expirationTime = Date.now() + 1e3 * Q["max-age"]);
                            } else w.expires && (this.expirationTime = new Date(w.expires).getTime());
                            if (this.expirationTime) {
                                let Q = Date.now(), ee = !1;
                                if (this.expirationTime > Q) ee = !1;
                                else if (B) {
                                    if (this.expirationTime < B) ee = !0;
                                    else {
                                        let se = this.expirationTime - B;
                                        se ? this.expirationTime = Q + Math.max(se, 3e4) : ee = !0;
                                    }
                                } else ee = !0;
                                ee ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                            }
                        }
                        getExpiryTimeout() {
                            if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - new Date().getTime(), Math.pow(2, 31) - 1);
                        }
                        setFeatureState(w, B) {
                            if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || Object.keys(w).length === 0) return;
                            let Q = this.latestFeatureIndex.loadVTLayers();
                            for(let ee in this.buckets){
                                if (!B.style.hasLayer(ee)) continue;
                                let se = this.buckets[ee], qe = se.layers[0].sourceLayer || "_geojsonTileLayer", je = Q[qe], it = w[qe];
                                if (!je || !it || Object.keys(it).length === 0) continue;
                                se.update(it, je, this.imageAtlas && this.imageAtlas.patternPositions || {});
                                let yt = B && B.style && B.style.getLayer(ee);
                                yt && (this.queryPadding = Math.max(this.queryPadding, yt.queryRadius(se)));
                            }
                        }
                        holdingForFade() {
                            return this.symbolFadeHoldUntil !== void 0;
                        }
                        symbolFadeFinished() {
                            return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < u.now();
                        }
                        clearFadeHold() {
                            this.symbolFadeHoldUntil = void 0;
                        }
                        setHoldDuration(w) {
                            this.symbolFadeHoldUntil = u.now() + w;
                        }
                        setDependencies(w, B) {
                            let Q = {};
                            for (let ee of B)Q[ee] = !0;
                            this.dependencies[w] = Q;
                        }
                        hasDependency(w, B) {
                            for (let Q of w){
                                let ee = this.dependencies[Q];
                                if (ee) {
                                    for (let se of B)if (ee[se]) return !0;
                                }
                            }
                            return !1;
                        }
                    }
                    class St {
                        constructor(w, B){
                            this.max = w, this.onRemove = B, this.reset();
                        }
                        reset() {
                            for(let w in this.data)for (let B of this.data[w])B.timeout && clearTimeout(B.timeout), this.onRemove(B.value);
                            return this.data = {}, this.order = [], this;
                        }
                        add(w, B, Q) {
                            let ee = w.wrapped().key;
                            this.data[ee] === void 0 && (this.data[ee] = []);
                            let se = {
                                value: B,
                                timeout: void 0
                            };
                            if (Q !== void 0 && (se.timeout = setTimeout(()=>{
                                this.remove(w, se);
                            }, Q)), this.data[ee].push(se), this.order.push(ee), this.order.length > this.max) {
                                let qe = this._getAndRemoveByKey(this.order[0]);
                                qe && this.onRemove(qe);
                            }
                            return this;
                        }
                        has(w) {
                            return w.wrapped().key in this.data;
                        }
                        getAndRemove(w) {
                            return this.has(w) ? this._getAndRemoveByKey(w.wrapped().key) : null;
                        }
                        _getAndRemoveByKey(w) {
                            let B = this.data[w].shift();
                            return B.timeout && clearTimeout(B.timeout), this.data[w].length === 0 && delete this.data[w], this.order.splice(this.order.indexOf(w), 1), B.value;
                        }
                        getByKey(w) {
                            let B = this.data[w];
                            return B ? B[0].value : null;
                        }
                        get(w) {
                            return this.has(w) ? this.data[w.wrapped().key][0].value : null;
                        }
                        remove(w, B) {
                            if (!this.has(w)) return this;
                            let Q = w.wrapped().key, ee = B === void 0 ? 0 : this.data[Q].indexOf(B), se = this.data[Q][ee];
                            return this.data[Q].splice(ee, 1), se.timeout && clearTimeout(se.timeout), this.data[Q].length === 0 && delete this.data[Q], this.onRemove(se.value), this.order.splice(this.order.indexOf(Q), 1), this;
                        }
                        setMaxSize(w) {
                            for(this.max = w; this.order.length > this.max;){
                                let B = this._getAndRemoveByKey(this.order[0]);
                                B && this.onRemove(B);
                            }
                            return this;
                        }
                        filter(w) {
                            let B = [];
                            for(let Q in this.data)for (let ee of this.data[Q])w(ee.value) || B.push(ee);
                            for (let Q of B)this.remove(Q.value.tileID, Q);
                        }
                    }
                    class Et {
                        constructor(){
                            this.state = {}, this.stateChanges = {}, this.deletedStates = {};
                        }
                        updateState(w, B, Q) {
                            let ee = String(B);
                            if (this.stateChanges[w] = this.stateChanges[w] || {}, this.stateChanges[w][ee] = this.stateChanges[w][ee] || {}, a.e(this.stateChanges[w][ee], Q), this.deletedStates[w] === null) {
                                this.deletedStates[w] = {};
                                for(let se in this.state[w])se !== ee && (this.deletedStates[w][se] = null);
                            } else if (this.deletedStates[w] && this.deletedStates[w][ee] === null) {
                                this.deletedStates[w][ee] = {};
                                for(let se in this.state[w][ee])Q[se] || (this.deletedStates[w][ee][se] = null);
                            } else for(let se in Q)this.deletedStates[w] && this.deletedStates[w][ee] && this.deletedStates[w][ee][se] === null && delete this.deletedStates[w][ee][se];
                        }
                        removeFeatureState(w, B, Q) {
                            if (this.deletedStates[w] === null) return;
                            let ee = String(B);
                            if (this.deletedStates[w] = this.deletedStates[w] || {}, Q && B !== void 0) this.deletedStates[w][ee] !== null && (this.deletedStates[w][ee] = this.deletedStates[w][ee] || {}, this.deletedStates[w][ee][Q] = null);
                            else if (B !== void 0) {
                                if (this.stateChanges[w] && this.stateChanges[w][ee]) for(Q in this.deletedStates[w][ee] = {}, this.stateChanges[w][ee])this.deletedStates[w][ee][Q] = null;
                                else this.deletedStates[w][ee] = null;
                            } else this.deletedStates[w] = null;
                        }
                        getState(w, B) {
                            let Q = String(B), ee = a.e({}, (this.state[w] || {})[Q], (this.stateChanges[w] || {})[Q]);
                            if (this.deletedStates[w] === null) return {};
                            if (this.deletedStates[w]) {
                                let se = this.deletedStates[w][B];
                                if (se === null) return {};
                                for(let qe in se)delete ee[qe];
                            }
                            return ee;
                        }
                        initializeTileState(w, B) {
                            w.setFeatureState(this.state, B);
                        }
                        coalesceChanges(w, B) {
                            let Q = {};
                            for(let ee in this.stateChanges){
                                this.state[ee] = this.state[ee] || {};
                                let se = {};
                                for(let qe in this.stateChanges[ee])this.state[ee][qe] || (this.state[ee][qe] = {}), a.e(this.state[ee][qe], this.stateChanges[ee][qe]), se[qe] = this.state[ee][qe];
                                Q[ee] = se;
                            }
                            for(let ee in this.deletedStates){
                                this.state[ee] = this.state[ee] || {};
                                let se = {};
                                if (this.deletedStates[ee] === null) for(let qe in this.state[ee])se[qe] = {}, this.state[ee][qe] = {};
                                else for(let qe in this.deletedStates[ee]){
                                    if (this.deletedStates[ee][qe] === null) this.state[ee][qe] = {};
                                    else for (let je of Object.keys(this.deletedStates[ee][qe]))delete this.state[ee][qe][je];
                                    se[qe] = this.state[ee][qe];
                                }
                                Q[ee] = Q[ee] || {}, a.e(Q[ee], se);
                            }
                            if (this.stateChanges = {}, this.deletedStates = {}, Object.keys(Q).length !== 0) for(let ee in w)w[ee].setFeatureState(Q, B);
                        }
                    }
                    class dt extends a.E {
                        constructor(w, B, Q){
                            super(), this.id = w, this.dispatcher = Q, this.on("data", (ee)=>this._dataHandler(ee)), this.on("dataloading", ()=>{
                                this._sourceErrored = !1;
                            }), this.on("error", ()=>{
                                this._sourceErrored = this._source.loaded();
                            }), this._source = ((ee, se, qe, je)=>{
                                let it = new (xr(se.type))(ee, se, qe, je);
                                if (it.id !== ee) throw new Error(`Expected Source id to be ${ee} instead of ${it.id}`);
                                return it;
                            })(w, B, Q, this), this._tiles = {}, this._cache = new St(0, (ee)=>this._unloadTile(ee)), this._timers = {}, this._cacheTimers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._loadedParentTiles = {}, this._coveredTiles = {}, this._state = new Et, this._didEmitContent = !1, this._updated = !1;
                        }
                        onAdd(w) {
                            this.map = w, this._maxTileCacheSize = w ? w._maxTileCacheSize : null, this._maxTileCacheZoomLevels = w ? w._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(w);
                        }
                        onRemove(w) {
                            this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(w);
                        }
                        loaded() {
                            if (this._sourceErrored) return !0;
                            if (!this._sourceLoaded || !this._source.loaded()) return !1;
                            if (!(this.used === void 0 && this.usedForTerrain === void 0 || this.used || this.usedForTerrain)) return !0;
                            if (!this._updated) return !1;
                            for(let w in this._tiles){
                                let B = this._tiles[w];
                                if (B.state !== "loaded" && B.state !== "errored") return !1;
                            }
                            return !0;
                        }
                        getSource() {
                            return this._source;
                        }
                        pause() {
                            this._paused = !0;
                        }
                        resume() {
                            if (!this._paused) return;
                            let w = this._shouldReloadOnResume;
                            this._paused = !1, this._shouldReloadOnResume = !1, w && this.reload(), this.transform && this.update(this.transform, this.terrain);
                        }
                        _loadTile(w, B, Q) {
                            return a._(this, void 0, void 0, function*() {
                                try {
                                    yield this._source.loadTile(w), this._tileLoaded(w, B, Q);
                                } catch (ee) {
                                    w.state = "errored", ee.status !== 404 ? this._source.fire(new a.j(ee, {
                                        tile: w
                                    })) : this.update(this.transform, this.terrain);
                                }
                            });
                        }
                        _unloadTile(w) {
                            this._source.unloadTile && this._source.unloadTile(w);
                        }
                        _abortTile(w) {
                            this._source.abortTile && this._source.abortTile(w), this._source.fire(new a.k("dataabort", {
                                tile: w,
                                coord: w.tileID,
                                dataType: "source"
                            }));
                        }
                        serialize() {
                            return this._source.serialize();
                        }
                        prepare(w) {
                            this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                            for(let B in this._tiles){
                                let Q = this._tiles[B];
                                Q.upload(w), Q.prepare(this.map.style.imageManager);
                            }
                        }
                        getIds() {
                            return Object.values(this._tiles).map((w)=>w.tileID).sort(Ht).map((w)=>w.key);
                        }
                        getRenderableIds(w) {
                            let B = [];
                            for(let Q in this._tiles)this._isIdRenderable(Q, w) && B.push(this._tiles[Q]);
                            return w ? B.sort((Q, ee)=>{
                                let se = Q.tileID, qe = ee.tileID, je = new a.P(se.canonical.x, se.canonical.y)._rotate(this.transform.angle), it = new a.P(qe.canonical.x, qe.canonical.y)._rotate(this.transform.angle);
                                return se.overscaledZ - qe.overscaledZ || it.y - je.y || it.x - je.x;
                            }).map((Q)=>Q.tileID.key) : B.map((Q)=>Q.tileID).sort(Ht).map((Q)=>Q.key);
                        }
                        hasRenderableParent(w) {
                            let B = this.findLoadedParent(w, 0);
                            return !!B && this._isIdRenderable(B.tileID.key);
                        }
                        _isIdRenderable(w, B) {
                            return this._tiles[w] && this._tiles[w].hasData() && !this._coveredTiles[w] && (B || !this._tiles[w].holdingForFade());
                        }
                        reload() {
                            if (this._paused) this._shouldReloadOnResume = !0;
                            else {
                                this._cache.reset();
                                for(let w in this._tiles)this._tiles[w].state !== "errored" && this._reloadTile(w, "reloading");
                            }
                        }
                        _reloadTile(w, B) {
                            return a._(this, void 0, void 0, function*() {
                                let Q = this._tiles[w];
                                Q && (Q.state !== "loading" && (Q.state = B), yield this._loadTile(Q, w, B));
                            });
                        }
                        _tileLoaded(w, B, Q) {
                            w.timeAdded = u.now(), Q === "expired" && (w.refreshedUponExpiration = !0), this._setTileReloadTimer(B, w), this.getSource().type === "raster-dem" && w.dem && this._backfillDEM(w), this._state.initializeTileState(w, this.map ? this.map.painter : null), w.aborted || this._source.fire(new a.k("data", {
                                dataType: "source",
                                tile: w,
                                coord: w.tileID
                            }));
                        }
                        _backfillDEM(w) {
                            let B = this.getRenderableIds();
                            for(let ee = 0; ee < B.length; ee++){
                                let se = B[ee];
                                if (w.neighboringTiles && w.neighboringTiles[se]) {
                                    let qe = this.getTileByID(se);
                                    Q(w, qe), Q(qe, w);
                                }
                            }
                            function Q(ee, se) {
                                ee.needsHillshadePrepare = !0, ee.needsTerrainPrepare = !0;
                                let qe = se.tileID.canonical.x - ee.tileID.canonical.x, je = se.tileID.canonical.y - ee.tileID.canonical.y, it = Math.pow(2, ee.tileID.canonical.z), yt = se.tileID.key;
                                qe === 0 && je === 0 || Math.abs(je) > 1 || (Math.abs(qe) > 1 && (Math.abs(qe + it) === 1 ? qe += it : Math.abs(qe - it) === 1 && (qe -= it)), se.dem && ee.dem && (ee.dem.backfillBorder(se.dem, qe, je), ee.neighboringTiles && ee.neighboringTiles[yt] && (ee.neighboringTiles[yt].backfilled = !0)));
                            }
                        }
                        getTile(w) {
                            return this.getTileByID(w.key);
                        }
                        getTileByID(w) {
                            return this._tiles[w];
                        }
                        _retainLoadedChildren(w, B, Q, ee) {
                            for(let se in this._tiles){
                                let qe = this._tiles[se];
                                if (ee[se] || !qe.hasData() || qe.tileID.overscaledZ <= B || qe.tileID.overscaledZ > Q) continue;
                                let je = qe.tileID;
                                for(; qe && qe.tileID.overscaledZ > B + 1;){
                                    let yt = qe.tileID.scaledTo(qe.tileID.overscaledZ - 1);
                                    qe = this._tiles[yt.key], qe && qe.hasData() && (je = yt);
                                }
                                let it = je;
                                for(; it.overscaledZ > B;)if (it = it.scaledTo(it.overscaledZ - 1), w[it.key]) {
                                    ee[je.key] = je;
                                    break;
                                }
                            }
                        }
                        findLoadedParent(w, B) {
                            if (w.key in this._loadedParentTiles) {
                                let Q = this._loadedParentTiles[w.key];
                                return Q && Q.tileID.overscaledZ >= B ? Q : null;
                            }
                            for(let Q = w.overscaledZ - 1; Q >= B; Q--){
                                let ee = w.scaledTo(Q), se = this._getLoadedTile(ee);
                                if (se) return se;
                            }
                        }
                        findLoadedSibling(w) {
                            return this._getLoadedTile(w);
                        }
                        _getLoadedTile(w) {
                            let B = this._tiles[w.key];
                            return B && B.hasData() ? B : this._cache.getByKey(w.wrapped().key);
                        }
                        updateCacheSize(w) {
                            let B = Math.ceil(w.width / this._source.tileSize) + 1, Q = Math.ceil(w.height / this._source.tileSize) + 1, ee = Math.floor(B * Q * (this._maxTileCacheZoomLevels === null ? a.a.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), se = typeof this._maxTileCacheSize == "number" ? Math.min(this._maxTileCacheSize, ee) : ee;
                            this._cache.setMaxSize(se);
                        }
                        handleWrapJump(w) {
                            let B = Math.round((w - (this._prevLng === void 0 ? w : this._prevLng)) / 360);
                            if (this._prevLng = w, B) {
                                let Q = {};
                                for(let ee in this._tiles){
                                    let se = this._tiles[ee];
                                    se.tileID = se.tileID.unwrapTo(se.tileID.wrap + B), Q[se.tileID.key] = se;
                                }
                                this._tiles = Q;
                                for(let ee in this._timers)clearTimeout(this._timers[ee]), delete this._timers[ee];
                                for(let ee in this._tiles)this._setTileReloadTimer(ee, this._tiles[ee]);
                            }
                        }
                        _updateCoveredAndRetainedTiles(w, B, Q, ee, se, qe) {
                            let je = {}, it = {}, yt = Object.keys(w), Ot = u.now();
                            for (let Nt of yt){
                                let hr = w[Nt], Sr = this._tiles[Nt];
                                if (!Sr || Sr.fadeEndTime !== 0 && Sr.fadeEndTime <= Ot) continue;
                                let he = this.findLoadedParent(hr, B), be = this.findLoadedSibling(hr), Pe = he || be || null;
                                Pe && (this._addTile(Pe.tileID), je[Pe.tileID.key] = Pe.tileID), it[Nt] = hr;
                            }
                            this._retainLoadedChildren(it, ee, Q, w);
                            for(let Nt in je)w[Nt] || (this._coveredTiles[Nt] = !0, w[Nt] = je[Nt]);
                            if (qe) {
                                let Nt = {}, hr = {};
                                for (let Sr of se)this._tiles[Sr.key].hasData() ? Nt[Sr.key] = Sr : hr[Sr.key] = Sr;
                                for(let Sr in hr){
                                    let he = hr[Sr].children(this._source.maxzoom);
                                    this._tiles[he[0].key] && this._tiles[he[1].key] && this._tiles[he[2].key] && this._tiles[he[3].key] && (Nt[he[0].key] = w[he[0].key] = he[0], Nt[he[1].key] = w[he[1].key] = he[1], Nt[he[2].key] = w[he[2].key] = he[2], Nt[he[3].key] = w[he[3].key] = he[3], delete hr[Sr]);
                                }
                                for(let Sr in hr){
                                    let he = hr[Sr], be = this.findLoadedParent(he, this._source.minzoom), Pe = this.findLoadedSibling(he), Oe = be || Pe || null;
                                    if (Oe) {
                                        Nt[Oe.tileID.key] = w[Oe.tileID.key] = Oe.tileID;
                                        for(let Je in Nt)Nt[Je].isChildOf(Oe.tileID) && delete Nt[Je];
                                    }
                                }
                                for(let Sr in this._tiles)Nt[Sr] || (this._coveredTiles[Sr] = !0);
                            }
                        }
                        update(w, B) {
                            if (!this._sourceLoaded || this._paused) return;
                            let Q;
                            this.transform = w, this.terrain = B, this.updateCacheSize(w), this.handleWrapJump(this.transform.center.lng), this._coveredTiles = {}, this.used || this.usedForTerrain ? this._source.tileID ? Q = w.getVisibleUnwrappedCoordinates(this._source.tileID).map((Ot)=>new a.S(Ot.canonical.z, Ot.wrap, Ot.canonical.z, Ot.canonical.x, Ot.canonical.y)) : (Q = w.coveringTiles({
                                tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                                minzoom: this._source.minzoom,
                                maxzoom: this._source.maxzoom,
                                roundZoom: !this.usedForTerrain && this._source.roundZoom,
                                reparseOverscaled: this._source.reparseOverscaled,
                                terrain: B
                            }), this._source.hasTile && (Q = Q.filter((Ot)=>this._source.hasTile(Ot)))) : Q = [];
                            let ee = w.coveringZoomLevel(this._source), se = Math.max(ee - dt.maxOverzooming, this._source.minzoom), qe = Math.max(ee + dt.maxUnderzooming, this._source.minzoom);
                            if (this.usedForTerrain) {
                                let Ot = {};
                                for (let Nt of Q)if (Nt.canonical.z > this._source.minzoom) {
                                    let hr = Nt.scaledTo(Nt.canonical.z - 1);
                                    Ot[hr.key] = hr;
                                    let Sr = Nt.scaledTo(Math.max(this._source.minzoom, Math.min(Nt.canonical.z, 5)));
                                    Ot[Sr.key] = Sr;
                                }
                                Q = Q.concat(Object.values(Ot));
                            }
                            let je = Q.length === 0 && !this._updated && this._didEmitContent;
                            this._updated = !0, je && this.fire(new a.k("data", {
                                sourceDataType: "idle",
                                dataType: "source",
                                sourceId: this.id
                            }));
                            let it = this._updateRetainedTiles(Q, ee);
                            $t(this._source.type) && this._updateCoveredAndRetainedTiles(it, se, qe, ee, Q, B);
                            for(let Ot in it)this._tiles[Ot].clearFadeHold();
                            let yt = a.ab(this._tiles, it);
                            for (let Ot of yt){
                                let Nt = this._tiles[Ot];
                                Nt.hasSymbolBuckets && !Nt.holdingForFade() ? Nt.setHoldDuration(this.map._fadeDuration) : Nt.hasSymbolBuckets && !Nt.symbolFadeFinished() || this._removeTile(Ot);
                            }
                            this._updateLoadedParentTileCache(), this._updateLoadedSiblingTileCache();
                        }
                        releaseSymbolFadeTiles() {
                            for(let w in this._tiles)this._tiles[w].holdingForFade() && this._removeTile(w);
                        }
                        _updateRetainedTiles(w, B) {
                            var Q;
                            let ee = {}, se = {}, qe = Math.max(B - dt.maxOverzooming, this._source.minzoom), je = Math.max(B + dt.maxUnderzooming, this._source.minzoom), it = {};
                            for (let yt of w){
                                let Ot = this._addTile(yt);
                                ee[yt.key] = yt, Ot.hasData() || B < this._source.maxzoom && (it[yt.key] = yt);
                            }
                            this._retainLoadedChildren(it, B, je, ee);
                            for (let yt of w){
                                let Ot = this._tiles[yt.key];
                                if (Ot.hasData()) continue;
                                if (B + 1 > this._source.maxzoom) {
                                    let hr = yt.children(this._source.maxzoom)[0], Sr = this.getTile(hr);
                                    if (Sr && Sr.hasData()) {
                                        ee[hr.key] = hr;
                                        continue;
                                    }
                                } else {
                                    let hr = yt.children(this._source.maxzoom);
                                    if (ee[hr[0].key] && ee[hr[1].key] && ee[hr[2].key] && ee[hr[3].key]) continue;
                                }
                                let Nt = Ot.wasRequested();
                                for(let hr = yt.overscaledZ - 1; hr >= qe; --hr){
                                    let Sr = yt.scaledTo(hr);
                                    if (se[Sr.key]) break;
                                    if (se[Sr.key] = !0, Ot = this.getTile(Sr), !Ot && Nt && (Ot = this._addTile(Sr)), Ot) {
                                        let he = Ot.hasData();
                                        if ((he || !(!((Q = this.map) === null || Q === void 0) && Q.cancelPendingTileRequestsWhileZooming) || Nt) && (ee[Sr.key] = Sr), Nt = Ot.wasRequested(), he) break;
                                    }
                                }
                            }
                            return ee;
                        }
                        _updateLoadedParentTileCache() {
                            this._loadedParentTiles = {};
                            for(let w in this._tiles){
                                let B = [], Q, ee = this._tiles[w].tileID;
                                for(; ee.overscaledZ > 0;){
                                    if (ee.key in this._loadedParentTiles) {
                                        Q = this._loadedParentTiles[ee.key];
                                        break;
                                    }
                                    B.push(ee.key);
                                    let se = ee.scaledTo(ee.overscaledZ - 1);
                                    if (Q = this._getLoadedTile(se), Q) break;
                                    ee = se;
                                }
                                for (let se of B)this._loadedParentTiles[se] = Q;
                            }
                        }
                        _updateLoadedSiblingTileCache() {
                            this._loadedSiblingTiles = {};
                            for(let w in this._tiles){
                                let B = this._tiles[w].tileID, Q = this._getLoadedTile(B);
                                this._loadedSiblingTiles[B.key] = Q;
                            }
                        }
                        _addTile(w) {
                            let B = this._tiles[w.key];
                            if (B) return B;
                            B = this._cache.getAndRemove(w), B && (this._setTileReloadTimer(w.key, B), B.tileID = w, this._state.initializeTileState(B, this.map ? this.map.painter : null), this._cacheTimers[w.key] && (clearTimeout(this._cacheTimers[w.key]), delete this._cacheTimers[w.key], this._setTileReloadTimer(w.key, B)));
                            let Q = B;
                            return B || (B = new Lt(w, this._source.tileSize * w.overscaleFactor()), this._loadTile(B, w.key, B.state)), B.uses++, this._tiles[w.key] = B, Q || this._source.fire(new a.k("dataloading", {
                                tile: B,
                                coord: B.tileID,
                                dataType: "source"
                            })), B;
                        }
                        _setTileReloadTimer(w, B) {
                            w in this._timers && (clearTimeout(this._timers[w]), delete this._timers[w]);
                            let Q = B.getExpiryTimeout();
                            Q && (this._timers[w] = setTimeout(()=>{
                                this._reloadTile(w, "expired"), delete this._timers[w];
                            }, Q));
                        }
                        _removeTile(w) {
                            let B = this._tiles[w];
                            B && (B.uses--, delete this._tiles[w], this._timers[w] && (clearTimeout(this._timers[w]), delete this._timers[w]), B.uses > 0 || (B.hasData() && B.state !== "reloading" ? this._cache.add(B.tileID, B, B.getExpiryTimeout()) : (B.aborted = !0, this._abortTile(B), this._unloadTile(B))));
                        }
                        _dataHandler(w) {
                            let B = w.sourceDataType;
                            w.dataType === "source" && B === "metadata" && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && w.dataType === "source" && B === "content" && (this.reload(), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0);
                        }
                        clearTiles() {
                            this._shouldReloadOnResume = !1, this._paused = !1;
                            for(let w in this._tiles)this._removeTile(w);
                            this._cache.reset();
                        }
                        tilesIn(w, B, Q) {
                            let ee = [], se = this.transform;
                            if (!se) return ee;
                            let qe = Q ? se.getCameraQueryGeometry(w) : w, je = w.map((he)=>se.pointCoordinate(he, this.terrain)), it = qe.map((he)=>se.pointCoordinate(he, this.terrain)), yt = this.getIds(), Ot = 1 / 0, Nt = 1 / 0, hr = -1 / 0, Sr = -1 / 0;
                            for (let he of it)Ot = Math.min(Ot, he.x), Nt = Math.min(Nt, he.y), hr = Math.max(hr, he.x), Sr = Math.max(Sr, he.y);
                            for(let he = 0; he < yt.length; he++){
                                let be = this._tiles[yt[he]];
                                if (be.holdingForFade()) continue;
                                let Pe = be.tileID, Oe = Math.pow(2, se.zoom - be.tileID.overscaledZ), Je = B * be.queryPadding * a.X / be.tileSize / Oe, He = [
                                    Pe.getTilePoint(new a.Z(Ot, Nt)),
                                    Pe.getTilePoint(new a.Z(hr, Sr))
                                ];
                                if (He[0].x - Je < a.X && He[0].y - Je < a.X && He[1].x + Je >= 0 && He[1].y + Je >= 0) {
                                    let et = je.map((Dt)=>Pe.getTilePoint(Dt)), Mt = it.map((Dt)=>Pe.getTilePoint(Dt));
                                    ee.push({
                                        tile: be,
                                        tileID: Pe,
                                        queryGeometry: et,
                                        cameraQueryGeometry: Mt,
                                        scale: Oe
                                    });
                                }
                            }
                            return ee;
                        }
                        getVisibleCoordinates(w) {
                            let B = this.getRenderableIds(w).map((Q)=>this._tiles[Q].tileID);
                            for (let Q of B)Q.posMatrix = this.transform.calculatePosMatrix(Q.toUnwrapped());
                            return B;
                        }
                        hasTransition() {
                            if (this._source.hasTransition()) return !0;
                            if ($t(this._source.type)) {
                                let w = u.now();
                                for(let B in this._tiles)if (this._tiles[B].fadeEndTime >= w) return !0;
                            }
                            return !1;
                        }
                        setFeatureState(w, B, Q) {
                            this._state.updateState(w = w || "_geojsonTileLayer", B, Q);
                        }
                        removeFeatureState(w, B, Q) {
                            this._state.removeFeatureState(w = w || "_geojsonTileLayer", B, Q);
                        }
                        getFeatureState(w, B) {
                            return this._state.getState(w = w || "_geojsonTileLayer", B);
                        }
                        setDependencies(w, B, Q) {
                            let ee = this._tiles[w];
                            ee && ee.setDependencies(B, Q);
                        }
                        reloadTilesForDependencies(w, B) {
                            for(let Q in this._tiles)this._tiles[Q].hasDependency(w, B) && this._reloadTile(Q, "reloading");
                            this._cache.filter((Q)=>!Q.hasDependency(w, B));
                        }
                    }
                    function Ht(le, w) {
                        let B = Math.abs(2 * le.wrap) - +(le.wrap < 0), Q = Math.abs(2 * w.wrap) - +(w.wrap < 0);
                        return le.overscaledZ - w.overscaledZ || Q - B || w.canonical.y - le.canonical.y || w.canonical.x - le.canonical.x;
                    }
                    function $t(le) {
                        return le === "raster" || le === "image" || le === "video";
                    }
                    dt.maxOverzooming = 10, dt.maxUnderzooming = 3;
                    class fr {
                        constructor(w, B){
                            this.reset(w, B);
                        }
                        reset(w, B) {
                            this.points = w || [], this._distances = [
                                0
                            ];
                            for(let Q = 1; Q < this.points.length; Q++)this._distances[Q] = this._distances[Q - 1] + this.points[Q].dist(this.points[Q - 1]);
                            this.length = this._distances[this._distances.length - 1], this.padding = Math.min(B || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
                        }
                        lerp(w) {
                            if (this.points.length === 1) return this.points[0];
                            w = a.ac(w, 0, 1);
                            let B = 1, Q = this._distances[B], ee = w * this.paddedLength + this.padding;
                            for(; Q < ee && B < this._distances.length;)Q = this._distances[++B];
                            let se = B - 1, qe = this._distances[se], je = Q - qe, it = je > 0 ? (ee - qe) / je : 0;
                            return this.points[se].mult(1 - it).add(this.points[B].mult(it));
                        }
                    }
                    function _r(le, w) {
                        let B = !0;
                        return le === "always" || le !== "never" && w !== "never" || (B = !1), B;
                    }
                    class Br {
                        constructor(w, B, Q){
                            let ee = this.boxCells = [], se = this.circleCells = [];
                            this.xCellCount = Math.ceil(w / Q), this.yCellCount = Math.ceil(B / Q);
                            for(let qe = 0; qe < this.xCellCount * this.yCellCount; qe++)ee.push([]), se.push([]);
                            this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = w, this.height = B, this.xScale = this.xCellCount / w, this.yScale = this.yCellCount / B, this.boxUid = 0, this.circleUid = 0;
                        }
                        keysLength() {
                            return this.boxKeys.length + this.circleKeys.length;
                        }
                        insert(w, B, Q, ee, se) {
                            this._forEachCell(B, Q, ee, se, this._insertBoxCell, this.boxUid++), this.boxKeys.push(w), this.bboxes.push(B), this.bboxes.push(Q), this.bboxes.push(ee), this.bboxes.push(se);
                        }
                        insertCircle(w, B, Q, ee) {
                            this._forEachCell(B - ee, Q - ee, B + ee, Q + ee, this._insertCircleCell, this.circleUid++), this.circleKeys.push(w), this.circles.push(B), this.circles.push(Q), this.circles.push(ee);
                        }
                        _insertBoxCell(w, B, Q, ee, se, qe) {
                            this.boxCells[se].push(qe);
                        }
                        _insertCircleCell(w, B, Q, ee, se, qe) {
                            this.circleCells[se].push(qe);
                        }
                        _query(w, B, Q, ee, se, qe, je) {
                            if (Q < 0 || w > this.width || ee < 0 || B > this.height) return [];
                            let it = [];
                            if (w <= 0 && B <= 0 && this.width <= Q && this.height <= ee) {
                                if (se) return [
                                    {
                                        key: null,
                                        x1: w,
                                        y1: B,
                                        x2: Q,
                                        y2: ee
                                    }
                                ];
                                for(let yt = 0; yt < this.boxKeys.length; yt++)it.push({
                                    key: this.boxKeys[yt],
                                    x1: this.bboxes[4 * yt],
                                    y1: this.bboxes[4 * yt + 1],
                                    x2: this.bboxes[4 * yt + 2],
                                    y2: this.bboxes[4 * yt + 3]
                                });
                                for(let yt = 0; yt < this.circleKeys.length; yt++){
                                    let Ot = this.circles[3 * yt], Nt = this.circles[3 * yt + 1], hr = this.circles[3 * yt + 2];
                                    it.push({
                                        key: this.circleKeys[yt],
                                        x1: Ot - hr,
                                        y1: Nt - hr,
                                        x2: Ot + hr,
                                        y2: Nt + hr
                                    });
                                }
                            } else this._forEachCell(w, B, Q, ee, this._queryCell, it, {
                                hitTest: se,
                                overlapMode: qe,
                                seenUids: {
                                    box: {},
                                    circle: {}
                                }
                            }, je);
                            return it;
                        }
                        query(w, B, Q, ee) {
                            return this._query(w, B, Q, ee, !1, null);
                        }
                        hitTest(w, B, Q, ee, se, qe) {
                            return this._query(w, B, Q, ee, !0, se, qe).length > 0;
                        }
                        hitTestCircle(w, B, Q, ee, se) {
                            let qe = w - Q, je = w + Q, it = B - Q, yt = B + Q;
                            if (je < 0 || qe > this.width || yt < 0 || it > this.height) return !1;
                            let Ot = [];
                            return this._forEachCell(qe, it, je, yt, this._queryCellCircle, Ot, {
                                hitTest: !0,
                                overlapMode: ee,
                                circle: {
                                    x: w,
                                    y: B,
                                    radius: Q
                                },
                                seenUids: {
                                    box: {},
                                    circle: {}
                                }
                            }, se), Ot.length > 0;
                        }
                        _queryCell(w, B, Q, ee, se, qe, je, it) {
                            let { seenUids: yt, hitTest: Ot, overlapMode: Nt } = je, hr = this.boxCells[se];
                            if (hr !== null) {
                                let he = this.bboxes;
                                for (let be of hr)if (!yt.box[be]) {
                                    yt.box[be] = !0;
                                    let Pe = 4 * be, Oe = this.boxKeys[be];
                                    if (w <= he[Pe + 2] && B <= he[Pe + 3] && Q >= he[Pe + 0] && ee >= he[Pe + 1] && (!it || it(Oe)) && (!Ot || !_r(Nt, Oe.overlapMode)) && (qe.push({
                                        key: Oe,
                                        x1: he[Pe],
                                        y1: he[Pe + 1],
                                        x2: he[Pe + 2],
                                        y2: he[Pe + 3]
                                    }), Ot)) return !0;
                                }
                            }
                            let Sr = this.circleCells[se];
                            if (Sr !== null) {
                                let he = this.circles;
                                for (let be of Sr)if (!yt.circle[be]) {
                                    yt.circle[be] = !0;
                                    let Pe = 3 * be, Oe = this.circleKeys[be];
                                    if (this._circleAndRectCollide(he[Pe], he[Pe + 1], he[Pe + 2], w, B, Q, ee) && (!it || it(Oe)) && (!Ot || !_r(Nt, Oe.overlapMode))) {
                                        let Je = he[Pe], He = he[Pe + 1], et = he[Pe + 2];
                                        if (qe.push({
                                            key: Oe,
                                            x1: Je - et,
                                            y1: He - et,
                                            x2: Je + et,
                                            y2: He + et
                                        }), Ot) return !0;
                                    }
                                }
                            }
                            return !1;
                        }
                        _queryCellCircle(w, B, Q, ee, se, qe, je, it) {
                            let { circle: yt, seenUids: Ot, overlapMode: Nt } = je, hr = this.boxCells[se];
                            if (hr !== null) {
                                let he = this.bboxes;
                                for (let be of hr)if (!Ot.box[be]) {
                                    Ot.box[be] = !0;
                                    let Pe = 4 * be, Oe = this.boxKeys[be];
                                    if (this._circleAndRectCollide(yt.x, yt.y, yt.radius, he[Pe + 0], he[Pe + 1], he[Pe + 2], he[Pe + 3]) && (!it || it(Oe)) && !_r(Nt, Oe.overlapMode)) return qe.push(!0), !0;
                                }
                            }
                            let Sr = this.circleCells[se];
                            if (Sr !== null) {
                                let he = this.circles;
                                for (let be of Sr)if (!Ot.circle[be]) {
                                    Ot.circle[be] = !0;
                                    let Pe = 3 * be, Oe = this.circleKeys[be];
                                    if (this._circlesCollide(he[Pe], he[Pe + 1], he[Pe + 2], yt.x, yt.y, yt.radius) && (!it || it(Oe)) && !_r(Nt, Oe.overlapMode)) return qe.push(!0), !0;
                                }
                            }
                        }
                        _forEachCell(w, B, Q, ee, se, qe, je, it) {
                            let yt = this._convertToXCellCoord(w), Ot = this._convertToYCellCoord(B), Nt = this._convertToXCellCoord(Q), hr = this._convertToYCellCoord(ee);
                            for(let Sr = yt; Sr <= Nt; Sr++)for(let he = Ot; he <= hr; he++)if (se.call(this, w, B, Q, ee, this.xCellCount * he + Sr, qe, je, it)) return;
                        }
                        _convertToXCellCoord(w) {
                            return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(w * this.xScale)));
                        }
                        _convertToYCellCoord(w) {
                            return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(w * this.yScale)));
                        }
                        _circlesCollide(w, B, Q, ee, se, qe) {
                            let je = ee - w, it = se - B, yt = Q + qe;
                            return yt * yt > je * je + it * it;
                        }
                        _circleAndRectCollide(w, B, Q, ee, se, qe, je) {
                            let it = (qe - ee) / 2, yt = Math.abs(w - (ee + it));
                            if (yt > it + Q) return !1;
                            let Ot = (je - se) / 2, Nt = Math.abs(B - (se + Ot));
                            if (Nt > Ot + Q) return !1;
                            if (yt <= it || Nt <= Ot) return !0;
                            let hr = yt - it, Sr = Nt - Ot;
                            return hr * hr + Sr * Sr <= Q * Q;
                        }
                    }
                    function Or(le, w, B, Q, ee) {
                        let se = a.H();
                        return w ? (a.K(se, se, [
                            1 / ee,
                            1 / ee,
                            1
                        ]), B || a.ad(se, se, Q.angle)) : a.L(se, Q.labelPlaneMatrix, le), se;
                    }
                    function Nr(le, w, B, Q, ee) {
                        if (w) {
                            let se = a.ae(le);
                            return a.K(se, se, [
                                ee,
                                ee,
                                1
                            ]), B || a.ad(se, se, -Q.angle), se;
                        }
                        return Q.glCoordMatrix;
                    }
                    function ut(le, w, B, Q) {
                        let ee;
                        Q ? (ee = [
                            le,
                            w,
                            Q(le, w),
                            1
                        ], a.af(ee, ee, B)) : (ee = [
                            le,
                            w,
                            0,
                            1
                        ], jr(ee, ee, B));
                        let se = ee[3];
                        return {
                            point: new a.P(ee[0] / se, ee[1] / se),
                            signedDistanceFromCamera: se,
                            isOccluded: !1
                        };
                    }
                    function Ne(le, w) {
                        return .5 + le / w * .5;
                    }
                    function Ye(le, w) {
                        return le.x >= -w[0] && le.x <= w[0] && le.y >= -w[1] && le.y <= w[1];
                    }
                    function Ve(le, w, B, Q, ee, se, qe, je, it, yt, Ot, Nt, hr, Sr, he) {
                        let be = Q ? le.textSizeData : le.iconSizeData, Pe = a.ag(be, B.transform.zoom), Oe = [
                            256 / B.width * 2 + 1,
                            256 / B.height * 2 + 1
                        ], Je = Q ? le.text.dynamicLayoutVertexArray : le.icon.dynamicLayoutVertexArray;
                        Je.clear();
                        let He = le.lineVertexArray, et = Q ? le.text.placedSymbolArray : le.icon.placedSymbolArray, Mt = B.transform.width / B.transform.height, Dt = !1;
                        for(let Ut = 0; Ut < et.length; Ut++){
                            let tr = et.get(Ut);
                            if (tr.hidden || tr.writingMode === a.ah.vertical && !Dt) {
                                ai(tr.numGlyphs, Je);
                                continue;
                            }
                            Dt = !1;
                            let mr = ut(tr.anchorX, tr.anchorY, w, he);
                            if (!Ye(mr.point, Oe)) {
                                ai(tr.numGlyphs, Je);
                                continue;
                            }
                            let Rr = Ne(B.transform.cameraToCenterDistance, mr.signedDistanceFromCamera), zr = a.ai(be, Pe, tr), Xr = qe ? zr / Rr : zr * Rr, di = {
                                getElevation: he,
                                labelPlaneMatrix: ee,
                                lineVertexArray: He,
                                pitchWithMap: qe,
                                projectionCache: {
                                    projections: {},
                                    offsets: {},
                                    cachedAnchorPoint: void 0,
                                    anyProjectionOccluded: !1
                                },
                                projection: yt,
                                tileAnchorPoint: new a.P(tr.anchorX, tr.anchorY),
                                unwrappedTileID: Ot,
                                width: Nt,
                                height: hr,
                                translation: Sr
                            }, Li = Le(di, tr, Xr, !1, je, w, se, le.glyphOffsetArray, Je, Mt, it);
                            Dt = Li.useVertical, (Li.notEnoughRoom || Dt || Li.needsFlipping && Le(di, tr, Xr, !0, je, w, se, le.glyphOffsetArray, Je, Mt, it).notEnoughRoom) && ai(tr.numGlyphs, Je);
                        }
                        Q ? le.text.dynamicLayoutVertexBuffer.updateData(Je) : le.icon.dynamicLayoutVertexBuffer.updateData(Je);
                    }
                    function Xe(le, w, B, Q, ee, se, qe, je) {
                        let it = se.glyphStartIndex + se.numGlyphs, yt = se.lineStartIndex, Ot = se.lineStartIndex + se.lineLength, Nt = w.getoffsetX(se.glyphStartIndex), hr = w.getoffsetX(it - 1), Sr = ar(le * Nt, B, Q, ee, se.segment, yt, Ot, je, qe);
                        if (!Sr) return null;
                        let he = ar(le * hr, B, Q, ee, se.segment, yt, Ot, je, qe);
                        return he ? je.projectionCache.anyProjectionOccluded ? null : {
                            first: Sr,
                            last: he
                        } : null;
                    }
                    function ht(le, w, B, Q) {
                        return le === a.ah.horizontal && Math.abs(B.y - w.y) > Math.abs(B.x - w.x) * Q ? {
                            useVertical: !0
                        } : (le === a.ah.vertical ? w.y < B.y : w.x > B.x) ? {
                            needsFlipping: !0
                        } : null;
                    }
                    function Le(le, w, B, Q, ee, se, qe, je, it, yt, Ot) {
                        let Nt = B / 24, hr = w.lineOffsetX * Nt, Sr = w.lineOffsetY * Nt, he;
                        if (w.numGlyphs > 1) {
                            let be = w.glyphStartIndex + w.numGlyphs, Pe = w.lineStartIndex, Oe = w.lineStartIndex + w.lineLength, Je = Xe(Nt, je, hr, Sr, Q, w, Ot, le);
                            if (!Je) return {
                                notEnoughRoom: !0
                            };
                            let He = ut(Je.first.point.x, Je.first.point.y, qe, le.getElevation).point, et = ut(Je.last.point.x, Je.last.point.y, qe, le.getElevation).point;
                            if (ee && !Q) {
                                let Mt = ht(w.writingMode, He, et, yt);
                                if (Mt) return Mt;
                            }
                            he = [
                                Je.first
                            ];
                            for(let Mt = w.glyphStartIndex + 1; Mt < be - 1; Mt++)he.push(ar(Nt * je.getoffsetX(Mt), hr, Sr, Q, w.segment, Pe, Oe, le, Ot));
                            he.push(Je.last);
                        } else {
                            if (ee && !Q) {
                                let Pe = ut(le.tileAnchorPoint.x, le.tileAnchorPoint.y, se, le.getElevation).point, Oe = w.lineStartIndex + w.segment + 1, Je = new a.P(le.lineVertexArray.getx(Oe), le.lineVertexArray.gety(Oe)), He = ut(Je.x, Je.y, se, le.getElevation), et = He.signedDistanceFromCamera > 0 ? He.point : function(Dt, Ut, tr, mr, Rr, zr) {
                                    return xe(Dt, Ut, tr, 1, Rr, zr);
                                }(le.tileAnchorPoint, Je, Pe, 0, se, le), Mt = ht(w.writingMode, Pe, et, yt);
                                if (Mt) return Mt;
                            }
                            let be = ar(Nt * je.getoffsetX(w.glyphStartIndex), hr, Sr, Q, w.segment, w.lineStartIndex, w.lineStartIndex + w.lineLength, le, Ot);
                            if (!be || le.projectionCache.anyProjectionOccluded) return {
                                notEnoughRoom: !0
                            };
                            he = [
                                be
                            ];
                        }
                        for (let be of he)a.aj(it, be.point, be.angle);
                        return {};
                    }
                    function xe(le, w, B, Q, ee, se) {
                        let qe = le.add(le.sub(w)._unit()), je = ee !== void 0 ? ut(qe.x, qe.y, ee, se.getElevation).point : lt(qe.x, qe.y, se).point, it = B.sub(je);
                        return B.add(it._mult(Q / it.mag()));
                    }
                    function Se(le, w, B) {
                        let Q = w.projectionCache;
                        if (Q.projections[le]) return Q.projections[le];
                        let ee = new a.P(w.lineVertexArray.getx(le), w.lineVertexArray.gety(le)), se = lt(ee.x, ee.y, w);
                        if (se.signedDistanceFromCamera > 0) return Q.projections[le] = se.point, Q.anyProjectionOccluded = Q.anyProjectionOccluded || se.isOccluded, se.point;
                        let qe = le - B.direction;
                        return function(je, it, yt, Ot, Nt) {
                            return xe(je, it, yt, Ot, void 0, Nt);
                        }(B.distanceFromAnchor === 0 ? w.tileAnchorPoint : new a.P(w.lineVertexArray.getx(qe), w.lineVertexArray.gety(qe)), ee, B.previousVertex, B.absOffsetX - B.distanceFromAnchor + 1, w);
                    }
                    function lt(le, w, B) {
                        let Q = le + B.translation[0], ee = w + B.translation[1], se;
                        return !B.pitchWithMap && B.projection.useSpecialProjectionForSymbols ? (se = B.projection.projectTileCoordinates(Q, ee, B.unwrappedTileID, B.getElevation), se.point.x = (.5 * se.point.x + .5) * B.width, se.point.y = (.5 * -se.point.y + .5) * B.height) : (se = ut(Q, ee, B.labelPlaneMatrix, B.getElevation), se.isOccluded = !1), se;
                    }
                    function Gt(le, w, B) {
                        return le._unit()._perp()._mult(w * B);
                    }
                    function Vt(le, w, B, Q, ee, se, qe, je, it) {
                        if (je.projectionCache.offsets[le]) return je.projectionCache.offsets[le];
                        let yt = B.add(w);
                        if (le + it.direction < Q || le + it.direction >= ee) return je.projectionCache.offsets[le] = yt, yt;
                        let Ot = Se(le + it.direction, je, it), Nt = Gt(Ot.sub(B), qe, it.direction), hr = B.add(Nt), Sr = Ot.add(Nt);
                        return je.projectionCache.offsets[le] = a.ak(se, yt, hr, Sr) || yt, je.projectionCache.offsets[le];
                    }
                    function ar(le, w, B, Q, ee, se, qe, je, it) {
                        let yt = Q ? le - w : le + w, Ot = yt > 0 ? 1 : -1, Nt = 0;
                        Q && (Ot *= -1, Nt = Math.PI), Ot < 0 && (Nt += Math.PI);
                        let hr, Sr = Ot > 0 ? se + ee : se + ee + 1;
                        je.projectionCache.cachedAnchorPoint ? hr = je.projectionCache.cachedAnchorPoint : (hr = lt(je.tileAnchorPoint.x, je.tileAnchorPoint.y, je).point, je.projectionCache.cachedAnchorPoint = hr);
                        let he, be, Pe = hr, Oe = hr, Je = 0, He = 0, et = Math.abs(yt), Mt = [], Dt;
                        for(; Je + He <= et;){
                            if (Sr += Ot, Sr < se || Sr >= qe) return null;
                            Je += He, Oe = Pe, be = he;
                            let mr = {
                                absOffsetX: et,
                                direction: Ot,
                                distanceFromAnchor: Je,
                                previousVertex: Oe
                            };
                            if (Pe = Se(Sr, je, mr), B === 0) Mt.push(Oe), Dt = Pe.sub(Oe);
                            else {
                                let Rr, zr = Pe.sub(Oe);
                                Rr = zr.mag() === 0 ? Gt(Se(Sr + Ot, je, mr).sub(Pe), B, Ot) : Gt(zr, B, Ot), be || (be = Oe.add(Rr)), he = Vt(Sr, Rr, Pe, se, qe, be, B, je, mr), Mt.push(be), Dt = he.sub(be);
                            }
                            He = Dt.mag();
                        }
                        let Ut = Dt._mult((et - Je) / He)._add(be || Oe), tr = Nt + Math.atan2(Pe.y - Oe.y, Pe.x - Oe.x);
                        return Mt.push(Ut), {
                            point: Ut,
                            angle: it ? tr : 0,
                            path: Mt
                        };
                    }
                    let Qr = new Float32Array([
                        -1 / 0,
                        -1 / 0,
                        0,
                        -1 / 0,
                        -1 / 0,
                        0,
                        -1 / 0,
                        -1 / 0,
                        0,
                        -1 / 0,
                        -1 / 0,
                        0
                    ]);
                    function ai(le, w) {
                        for(let B = 0; B < le; B++){
                            let Q = w.length;
                            w.resize(Q + 4), w.float32.set(Qr, 3 * Q);
                        }
                    }
                    function jr(le, w, B) {
                        let Q = w[0], ee = w[1];
                        return le[0] = B[0] * Q + B[4] * ee + B[12], le[1] = B[1] * Q + B[5] * ee + B[13], le[3] = B[3] * Q + B[7] * ee + B[15], le;
                    }
                    let ri = 100;
                    class bi {
                        constructor(w, B, Q = new Br(w.width + 200, w.height + 200, 25), ee = new Br(w.width + 200, w.height + 200, 25)){
                            this.transform = w, this.mapProjection = B, this.grid = Q, this.ignoredGrid = ee, this.pitchFactor = Math.cos(w._pitch) * w.cameraToCenterDistance, this.screenRightBoundary = w.width + ri, this.screenBottomBoundary = w.height + ri, this.gridRightBoundary = w.width + 200, this.gridBottomBoundary = w.height + 200, this.perspectiveRatioCutoff = .6;
                        }
                        placeCollisionBox(w, B, Q, ee, se, qe, je, it, yt, Ot, Nt) {
                            let hr = w.anchorPointX + it[0], Sr = w.anchorPointY + it[1], he = this.projectAndGetPerspectiveRatio(ee, hr, Sr, se, Ot), be = Q * he.perspectiveRatio, Pe;
                            if (qe || je) Pe = this._projectCollisionBox(w, be, ee, se, qe, je, it, he, Ot, Nt);
                            else {
                                let Mt = he.point.x + (Nt ? Nt.x * be : 0), Dt = he.point.y + (Nt ? Nt.y * be : 0);
                                Pe = {
                                    allPointsOccluded: !1,
                                    box: [
                                        Mt + w.x1 * be,
                                        Dt + w.y1 * be,
                                        Mt + w.x2 * be,
                                        Dt + w.y2 * be
                                    ]
                                };
                            }
                            let [Oe, Je, He, et] = Pe.box;
                            return this.mapProjection.useSpecialProjectionForSymbols && (qe ? Pe.allPointsOccluded : this.mapProjection.isOccluded(hr, Sr, se)) || he.perspectiveRatio < this.perspectiveRatioCutoff || !this.isInsideGrid(Oe, Je, He, et) || B !== "always" && this.grid.hitTest(Oe, Je, He, et, B, yt) ? {
                                box: [
                                    Oe,
                                    Je,
                                    He,
                                    et
                                ],
                                placeable: !1,
                                offscreen: !1
                            } : {
                                box: [
                                    Oe,
                                    Je,
                                    He,
                                    et
                                ],
                                placeable: !0,
                                offscreen: this.isOffscreen(Oe, Je, He, et)
                            };
                        }
                        placeCollisionCircles(w, B, Q, ee, se, qe, je, it, yt, Ot, Nt, hr, Sr, he, be, Pe) {
                            let Oe = [], Je = new a.P(B.anchorX, B.anchorY), He = this.getPerspectiveRatio(qe, Je.x, Je.y, je, Pe), et = (Nt ? se / He : se * He) / a.ap, Mt = {
                                getElevation: Pe,
                                labelPlaneMatrix: it,
                                lineVertexArray: Q,
                                pitchWithMap: Nt,
                                projectionCache: {
                                    projections: {},
                                    offsets: {},
                                    cachedAnchorPoint: void 0,
                                    anyProjectionOccluded: !1
                                },
                                projection: this.mapProjection,
                                tileAnchorPoint: Je,
                                unwrappedTileID: je,
                                width: this.transform.width,
                                height: this.transform.height,
                                translation: be
                            }, Dt = Xe(et, ee, B.lineOffsetX * et, B.lineOffsetY * et, !1, B, !1, Mt), Ut = !1, tr = !1, mr = !0;
                            if (Dt) {
                                let Rr = .5 * Sr * He + he, zr = new a.P(-100, -100), Xr = new a.P(this.screenRightBoundary, this.screenBottomBoundary), di = new fr, Li = Dt.first, Ci = Dt.last, Qi = [];
                                for(let ea = Li.path.length - 1; ea >= 1; ea--)Qi.push(Li.path[ea]);
                                for(let ea = 1; ea < Ci.path.length; ea++)Qi.push(Ci.path[ea]);
                                let Mn = 2.5 * Rr;
                                if (yt) {
                                    let ea = this.projectPathToScreenSpace(Qi, Mt, yt);
                                    Qi = ea.some((Ga)=>Ga.signedDistanceFromCamera <= 0) ? [] : ea.map((Ga)=>Ga.point);
                                }
                                let pa = [];
                                if (Qi.length > 0) {
                                    let ea = Qi[0].clone(), Ga = Qi[0].clone();
                                    for(let To = 1; To < Qi.length; To++)ea.x = Math.min(ea.x, Qi[To].x), ea.y = Math.min(ea.y, Qi[To].y), Ga.x = Math.max(Ga.x, Qi[To].x), Ga.y = Math.max(Ga.y, Qi[To].y);
                                    pa = ea.x >= zr.x && Ga.x <= Xr.x && ea.y >= zr.y && Ga.y <= Xr.y ? [
                                        Qi
                                    ] : Ga.x < zr.x || ea.x > Xr.x || Ga.y < zr.y || ea.y > Xr.y ? [] : a.al([
                                        Qi
                                    ], zr.x, zr.y, Xr.x, Xr.y);
                                }
                                for (let ea of pa){
                                    di.reset(ea, .25 * Rr);
                                    let Ga = 0;
                                    Ga = di.length <= .5 * Rr ? 1 : Math.ceil(di.paddedLength / Mn) + 1;
                                    for(let To = 0; To < Ga; To++){
                                        let Wa = To / Math.max(Ga - 1, 1), co = di.lerp(Wa), Ro = co.x + ri, Ds = co.y + ri;
                                        Oe.push(Ro, Ds, Rr, 0);
                                        let As = Ro - Rr, yo = Ds - Rr, po = Ro + Rr, _l = Ds + Rr;
                                        if (mr = mr && this.isOffscreen(As, yo, po, _l), tr = tr || this.isInsideGrid(As, yo, po, _l), w !== "always" && this.grid.hitTestCircle(Ro, Ds, Rr, w, hr) && (Ut = !0, !Ot)) return {
                                            circles: [],
                                            offscreen: !1,
                                            collisionDetected: Ut
                                        };
                                    }
                                }
                            }
                            return {
                                circles: !Ot && Ut || !tr || He < this.perspectiveRatioCutoff ? [] : Oe,
                                offscreen: mr,
                                collisionDetected: Ut
                            };
                        }
                        projectPathToScreenSpace(w, B, Q) {
                            return w.map((ee)=>ut(ee.x, ee.y, Q, B.getElevation));
                        }
                        queryRenderedSymbols(w) {
                            if (w.length === 0 || this.grid.keysLength() === 0 && this.ignoredGrid.keysLength() === 0) return {};
                            let B = [], Q = 1 / 0, ee = 1 / 0, se = -1 / 0, qe = -1 / 0;
                            for (let Ot of w){
                                let Nt = new a.P(Ot.x + ri, Ot.y + ri);
                                Q = Math.min(Q, Nt.x), ee = Math.min(ee, Nt.y), se = Math.max(se, Nt.x), qe = Math.max(qe, Nt.y), B.push(Nt);
                            }
                            let je = this.grid.query(Q, ee, se, qe).concat(this.ignoredGrid.query(Q, ee, se, qe)), it = {}, yt = {};
                            for (let Ot of je){
                                let Nt = Ot.key;
                                if (it[Nt.bucketInstanceId] === void 0 && (it[Nt.bucketInstanceId] = {}), it[Nt.bucketInstanceId][Nt.featureIndex]) continue;
                                let hr = [
                                    new a.P(Ot.x1, Ot.y1),
                                    new a.P(Ot.x2, Ot.y1),
                                    new a.P(Ot.x2, Ot.y2),
                                    new a.P(Ot.x1, Ot.y2)
                                ];
                                a.am(B, hr) && (it[Nt.bucketInstanceId][Nt.featureIndex] = !0, yt[Nt.bucketInstanceId] === void 0 && (yt[Nt.bucketInstanceId] = []), yt[Nt.bucketInstanceId].push(Nt.featureIndex));
                            }
                            return yt;
                        }
                        insertCollisionBox(w, B, Q, ee, se, qe) {
                            (Q ? this.ignoredGrid : this.grid).insert({
                                bucketInstanceId: ee,
                                featureIndex: se,
                                collisionGroupID: qe,
                                overlapMode: B
                            }, w[0], w[1], w[2], w[3]);
                        }
                        insertCollisionCircles(w, B, Q, ee, se, qe) {
                            let je = Q ? this.ignoredGrid : this.grid, it = {
                                bucketInstanceId: ee,
                                featureIndex: se,
                                collisionGroupID: qe,
                                overlapMode: B
                            };
                            for(let yt = 0; yt < w.length; yt += 4)je.insertCircle(it, w[yt], w[yt + 1], w[yt + 2]);
                        }
                        projectAndGetPerspectiveRatio(w, B, Q, ee, se) {
                            let qe;
                            se ? (qe = [
                                B,
                                Q,
                                se(B, Q),
                                1
                            ], a.af(qe, qe, w)) : (qe = [
                                B,
                                Q,
                                0,
                                1
                            ], jr(qe, qe, w));
                            let je = qe[3];
                            return {
                                point: new a.P((qe[0] / je + 1) / 2 * this.transform.width + ri, (-qe[1] / je + 1) / 2 * this.transform.height + ri),
                                perspectiveRatio: .5 + this.transform.cameraToCenterDistance / je * .5,
                                isOccluded: !1,
                                signedDistanceFromCamera: je
                            };
                        }
                        getPerspectiveRatio(w, B, Q, ee, se) {
                            let qe = this.mapProjection.useSpecialProjectionForSymbols ? this.mapProjection.projectTileCoordinates(B, Q, ee, se) : ut(B, Q, w, se);
                            return .5 + this.transform.cameraToCenterDistance / qe.signedDistanceFromCamera * .5;
                        }
                        isOffscreen(w, B, Q, ee) {
                            return Q < ri || w >= this.screenRightBoundary || ee < ri || B > this.screenBottomBoundary;
                        }
                        isInsideGrid(w, B, Q, ee) {
                            return Q >= 0 && w < this.gridRightBoundary && ee >= 0 && B < this.gridBottomBoundary;
                        }
                        getViewportMatrix() {
                            let w = a.an([]);
                            return a.J(w, w, [
                                -100,
                                -100,
                                0
                            ]), w;
                        }
                        _projectCollisionBox(w, B, Q, ee, se, qe, je, it, yt, Ot) {
                            let Nt = new a.P(1, 0), hr = new a.P(0, 1), Sr = new a.P(w.anchorPointX + je[0], w.anchorPointY + je[1]);
                            if (qe && !se) {
                                let mr = this.projectAndGetPerspectiveRatio(Q, Sr.x + 1, Sr.y, ee, yt).point.sub(it.point).unit(), Rr = Math.atan(mr.y / mr.x) + (mr.x < 0 ? Math.PI : 0), zr = Math.sin(Rr), Xr = Math.cos(Rr);
                                Nt = new a.P(Xr, zr), hr = new a.P(-zr, Xr);
                            } else if (!qe && se) {
                                let mr = -this.transform.angle, Rr = Math.sin(mr), zr = Math.cos(mr);
                                Nt = new a.P(zr, Rr), hr = new a.P(-Rr, zr);
                            }
                            let he = it.point, be = B;
                            if (se) {
                                he = Sr;
                                let mr = this.transform.zoom - Math.floor(this.transform.zoom);
                                be = Math.pow(2, -mr), be *= this.mapProjection.getPitchedTextCorrection(this.transform, Sr, ee), Ot || (be *= a.ac(.5 + it.signedDistanceFromCamera / this.transform.cameraToCenterDistance * .5, 0, 4));
                            }
                            Ot && (he = he.add(Nt.mult(Ot.x * be)).add(hr.mult(Ot.y * be)));
                            let Pe = w.x1 * be, Oe = w.x2 * be, Je = (Pe + Oe) / 2, He = w.y1 * be, et = w.y2 * be, Mt = (He + et) / 2, Dt = [
                                {
                                    offsetX: Pe,
                                    offsetY: He
                                },
                                {
                                    offsetX: Je,
                                    offsetY: He
                                },
                                {
                                    offsetX: Oe,
                                    offsetY: He
                                },
                                {
                                    offsetX: Oe,
                                    offsetY: Mt
                                },
                                {
                                    offsetX: Oe,
                                    offsetY: et
                                },
                                {
                                    offsetX: Je,
                                    offsetY: et
                                },
                                {
                                    offsetX: Pe,
                                    offsetY: et
                                },
                                {
                                    offsetX: Pe,
                                    offsetY: Mt
                                }
                            ], Ut = [];
                            for (let { offsetX: mr, offsetY: Rr } of Dt)Ut.push(new a.P(he.x + Nt.x * mr + hr.x * Rr, he.y + Nt.y * mr + hr.y * Rr));
                            let tr = !1;
                            if (se) {
                                let mr = Ut.map((Rr)=>this.projectAndGetPerspectiveRatio(Q, Rr.x, Rr.y, ee, yt));
                                tr = mr.some((Rr)=>!Rr.isOccluded), Ut = mr.map((Rr)=>Rr.point);
                            } else tr = !0;
                            return {
                                box: a.ao(Ut),
                                allPointsOccluded: !tr
                            };
                        }
                    }
                    function nn(le, w, B) {
                        return w * (a.X / (le.tileSize * Math.pow(2, B - le.tileID.overscaledZ)));
                    }
                    class Wi {
                        constructor(w, B, Q, ee){
                            this.opacity = w ? Math.max(0, Math.min(1, w.opacity + (w.placed ? B : -B))) : ee && Q ? 1 : 0, this.placed = Q;
                        }
                        isHidden() {
                            return this.opacity === 0 && !this.placed;
                        }
                    }
                    class Ni {
                        constructor(w, B, Q, ee, se){
                            this.text = new Wi(w ? w.text : null, B, Q, se), this.icon = new Wi(w ? w.icon : null, B, ee, se);
                        }
                        isHidden() {
                            return this.text.isHidden() && this.icon.isHidden();
                        }
                    }
                    class _n {
                        constructor(w, B, Q){
                            this.text = w, this.icon = B, this.skipFade = Q;
                        }
                    }
                    class $i {
                        constructor(){
                            this.invProjMatrix = a.H(), this.viewportMatrix = a.H(), this.circles = [];
                        }
                    }
                    class zn {
                        constructor(w, B, Q, ee, se){
                            this.bucketInstanceId = w, this.featureIndex = B, this.sourceLayerIndex = Q, this.bucketIndex = ee, this.tileID = se;
                        }
                    }
                    class Wn {
                        constructor(w){
                            this.crossSourceCollisions = w, this.maxGroupID = 0, this.collisionGroups = {};
                        }
                        get(w) {
                            if (this.crossSourceCollisions) return {
                                ID: 0,
                                predicate: null
                            };
                            if (!this.collisionGroups[w]) {
                                let B = ++this.maxGroupID;
                                this.collisionGroups[w] = {
                                    ID: B,
                                    predicate: (Q)=>Q.collisionGroupID === B
                                };
                            }
                            return this.collisionGroups[w];
                        }
                    }
                    function It(le, w, B, Q, ee) {
                        let { horizontalAlign: se, verticalAlign: qe } = a.au(le);
                        return new a.P(-(se - .5) * w + Q[0] * ee, -(qe - .5) * B + Q[1] * ee);
                    }
                    class ft {
                        constructor(w, B, Q, ee, se, qe){
                            this.transform = w.clone(), this.terrain = Q, this.collisionIndex = new bi(this.transform, B), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = ee, this.retainedQueryData = {}, this.collisionGroups = new Wn(se), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = qe, qe && (qe.prevPlacement = void 0), this.placedOrientations = {};
                        }
                        _getTerrainElevationFunc(w) {
                            let B = this.terrain;
                            return B ? (Q, ee)=>B.getElevation(w, Q, ee) : null;
                        }
                        getBucketParts(w, B, Q, ee) {
                            let se = Q.getBucket(B), qe = Q.latestFeatureIndex;
                            if (!se || !qe || B.id !== se.layerIds[0]) return;
                            let je = Q.collisionBoxArray, it = se.layers[0].layout, yt = se.layers[0].paint, Ot = Math.pow(2, this.transform.zoom - Q.tileID.overscaledZ), Nt = Q.tileSize / a.X, hr = Q.tileID.toUnwrapped(), Sr = this.transform.calculatePosMatrix(hr), he = it.get("text-pitch-alignment") === "map", be = it.get("text-rotation-alignment") === "map", Pe = nn(Q, 1, this.transform.zoom), Oe = this.collisionIndex.mapProjection.translatePosition(this.transform, Q, yt.get("text-translate"), yt.get("text-translate-anchor")), Je = this.collisionIndex.mapProjection.translatePosition(this.transform, Q, yt.get("icon-translate"), yt.get("icon-translate-anchor")), He = Or(Sr, he, be, this.transform, Pe), et = null;
                            if (he) {
                                let Dt = Nr(Sr, he, be, this.transform, Pe);
                                et = a.L([], this.transform.labelPlaneMatrix, Dt);
                            }
                            this.retainedQueryData[se.bucketInstanceId] = new zn(se.bucketInstanceId, qe, se.sourceLayerIndex, se.index, Q.tileID);
                            let Mt = {
                                bucket: se,
                                layout: it,
                                translationText: Oe,
                                translationIcon: Je,
                                posMatrix: Sr,
                                unwrappedTileID: hr,
                                textLabelPlaneMatrix: He,
                                labelToScreenMatrix: et,
                                scale: Ot,
                                textPixelRatio: Nt,
                                holdingForFade: Q.holdingForFade(),
                                collisionBoxArray: je,
                                partiallyEvaluatedTextSize: a.ag(se.textSizeData, this.transform.zoom),
                                collisionGroup: this.collisionGroups.get(se.sourceID)
                            };
                            if (ee) for (let Dt of se.sortKeyRanges){
                                let { sortKey: Ut, symbolInstanceStart: tr, symbolInstanceEnd: mr } = Dt;
                                w.push({
                                    sortKey: Ut,
                                    symbolInstanceStart: tr,
                                    symbolInstanceEnd: mr,
                                    parameters: Mt
                                });
                            }
                            else w.push({
                                symbolInstanceStart: 0,
                                symbolInstanceEnd: se.symbolInstances.length,
                                parameters: Mt
                            });
                        }
                        attemptAnchorPlacement(w, B, Q, ee, se, qe, je, it, yt, Ot, Nt, hr, Sr, he, be, Pe, Oe, Je, He) {
                            let et = a.aq[w.textAnchor], Mt = [
                                w.textOffset0,
                                w.textOffset1
                            ], Dt = It(et, Q, ee, Mt, se), Ut = this.collisionIndex.placeCollisionBox(B, hr, it, yt, Ot, je, qe, Pe, Nt.predicate, He, Dt);
                            if ((!Je || this.collisionIndex.placeCollisionBox(Je, hr, it, yt, Ot, je, qe, Oe, Nt.predicate, He, Dt).placeable) && Ut.placeable) {
                                let tr;
                                if (this.prevPlacement && this.prevPlacement.variableOffsets[Sr.crossTileID] && this.prevPlacement.placements[Sr.crossTileID] && this.prevPlacement.placements[Sr.crossTileID].text && (tr = this.prevPlacement.variableOffsets[Sr.crossTileID].anchor), Sr.crossTileID === 0) throw new Error("symbolInstance.crossTileID can't be 0");
                                return this.variableOffsets[Sr.crossTileID] = {
                                    textOffset: Mt,
                                    width: Q,
                                    height: ee,
                                    anchor: et,
                                    textBoxScale: se,
                                    prevAnchor: tr
                                }, this.markUsedJustification(he, et, Sr, be), he.allowVerticalPlacement && (this.markUsedOrientation(he, be, Sr), this.placedOrientations[Sr.crossTileID] = be), {
                                    shift: Dt,
                                    placedGlyphBoxes: Ut
                                };
                            }
                        }
                        placeLayerBucketPart(w, B, Q) {
                            let { bucket: ee, layout: se, translationText: qe, translationIcon: je, posMatrix: it, unwrappedTileID: yt, textLabelPlaneMatrix: Ot, labelToScreenMatrix: Nt, textPixelRatio: hr, holdingForFade: Sr, collisionBoxArray: he, partiallyEvaluatedTextSize: be, collisionGroup: Pe } = w.parameters, Oe = se.get("text-optional"), Je = se.get("icon-optional"), He = a.ar(se, "text-overlap", "text-allow-overlap"), et = He === "always", Mt = a.ar(se, "icon-overlap", "icon-allow-overlap"), Dt = Mt === "always", Ut = se.get("text-rotation-alignment") === "map", tr = se.get("text-pitch-alignment") === "map", mr = se.get("icon-text-fit") !== "none", Rr = se.get("symbol-z-order") === "viewport-y", zr = et && (Dt || !ee.hasIconData() || Je), Xr = Dt && (et || !ee.hasTextData() || Oe);
                            !ee.collisionArrays && he && ee.deserializeCollisionBoxes(he);
                            let di = this._getTerrainElevationFunc(this.retainedQueryData[ee.bucketInstanceId].tileID), Li = (Ci, Qi, Mn)=>{
                                var pa, ea;
                                if (B[Ci.crossTileID]) return;
                                if (Sr) return void (this.placements[Ci.crossTileID] = new _n(!1, !1, !1));
                                let Ga = !1, To = !1, Wa = !0, co = null, Ro = {
                                    box: null,
                                    placeable: !1,
                                    offscreen: null
                                }, Ds = {
                                    box: null,
                                    placeable: !1,
                                    offscreen: null
                                }, As = null, yo = null, po = null, _l = 0, Hl = 0, Zu = 0;
                                Qi.textFeatureIndex ? _l = Qi.textFeatureIndex : Ci.useRuntimeCollisionCircles && (_l = Ci.featureIndex), Qi.verticalTextFeatureIndex && (Hl = Qi.verticalTextFeatureIndex);
                                let cu = Qi.textBox;
                                if (cu) {
                                    let zl = (we)=>{
                                        let Be = a.ah.horizontal;
                                        if (ee.allowVerticalPlacement && !we && this.prevPlacement) {
                                            let Ue = this.prevPlacement.placedOrientations[Ci.crossTileID];
                                            Ue && (this.placedOrientations[Ci.crossTileID] = Ue, Be = Ue, this.markUsedOrientation(ee, Be, Ci));
                                        }
                                        return Be;
                                    }, Fl = (we, Be)=>{
                                        if (ee.allowVerticalPlacement && Ci.numVerticalGlyphVertices > 0 && Qi.verticalTextBox) {
                                            for (let Ue of ee.writingModes)if (Ue === a.ah.vertical ? (Ro = Be(), Ds = Ro) : Ro = we(), Ro && Ro.placeable) break;
                                        } else Ro = we();
                                    }, Z = Ci.textAnchorOffsetStartIndex, oe = Ci.textAnchorOffsetEndIndex;
                                    if (oe === Z) {
                                        let we = (Be, Ue)=>{
                                            let We = this.collisionIndex.placeCollisionBox(Be, He, hr, it, yt, tr, Ut, qe, Pe.predicate, di);
                                            return We && We.placeable && (this.markUsedOrientation(ee, Ue, Ci), this.placedOrientations[Ci.crossTileID] = Ue), We;
                                        };
                                        Fl(()=>we(cu, a.ah.horizontal), ()=>{
                                            let Be = Qi.verticalTextBox;
                                            return ee.allowVerticalPlacement && Ci.numVerticalGlyphVertices > 0 && Be ? we(Be, a.ah.vertical) : {
                                                box: null,
                                                offscreen: null
                                            };
                                        }), zl(Ro && Ro.placeable);
                                    } else {
                                        let we = a.aq[(ea = (pa = this.prevPlacement) === null || pa === void 0 ? void 0 : pa.variableOffsets[Ci.crossTileID]) === null || ea === void 0 ? void 0 : ea.anchor], Be = (We, wt, tt)=>{
                                            let zt = We.x2 - We.x1, or = We.y2 - We.y1, lr = Ci.textBoxScale, Dr = mr && Mt === "never" ? wt : null, Ir = null, oi = He === "never" ? 1 : 2, ui = "never";
                                            we && oi++;
                                            for(let qr = 0; qr < oi; qr++){
                                                for(let Kr = Z; Kr < oe; Kr++){
                                                    let ii = ee.textAnchorOffsets.get(Kr);
                                                    if (we && ii.textAnchor !== we) continue;
                                                    let vi = this.attemptAnchorPlacement(ii, We, zt, or, lr, Ut, tr, hr, it, yt, Pe, ui, Ci, ee, tt, qe, je, Dr, di);
                                                    if (vi && (Ir = vi.placedGlyphBoxes, Ir && Ir.placeable)) return Ga = !0, co = vi.shift, Ir;
                                                }
                                                we ? we = null : ui = He;
                                            }
                                            return Q && !Ir && (Ir = {
                                                box: this.collisionIndex.placeCollisionBox(cu, "always", hr, it, yt, tr, Ut, qe, Pe.predicate, di, new a.P(0, 0)).box,
                                                offscreen: !1,
                                                placeable: !1
                                            }), Ir;
                                        };
                                        Fl(()=>Be(cu, Qi.iconBox, a.ah.horizontal), ()=>{
                                            let We = Qi.verticalTextBox;
                                            return ee.allowVerticalPlacement && (!Ro || !Ro.placeable) && Ci.numVerticalGlyphVertices > 0 && We ? Be(We, Qi.verticalIconBox, a.ah.vertical) : {
                                                box: null,
                                                occluded: !0,
                                                offscreen: null
                                            };
                                        }), Ro && (Ga = Ro.placeable, Wa = Ro.offscreen);
                                        let Ue = zl(Ro && Ro.placeable);
                                        if (!Ga && this.prevPlacement) {
                                            let We = this.prevPlacement.variableOffsets[Ci.crossTileID];
                                            We && (this.variableOffsets[Ci.crossTileID] = We, this.markUsedJustification(ee, We.anchor, Ci, Ue));
                                        }
                                    }
                                }
                                if (As = Ro, Ga = As && As.placeable, Wa = As && As.offscreen, Ci.useRuntimeCollisionCircles) {
                                    let zl = ee.text.placedSymbolArray.get(Ci.centerJustifiedTextSymbolIndex), Fl = a.ai(ee.textSizeData, be, zl), Z = se.get("text-padding");
                                    yo = this.collisionIndex.placeCollisionCircles(He, zl, ee.lineVertexArray, ee.glyphOffsetArray, Fl, it, yt, Ot, Nt, Q, tr, Pe.predicate, Ci.collisionCircleDiameter, Z, qe, di), yo.circles.length && yo.collisionDetected && !Q && a.w("Collisions detected, but collision boxes are not shown"), Ga = et || yo.circles.length > 0 && !yo.collisionDetected, Wa = Wa && yo.offscreen;
                                }
                                if (Qi.iconFeatureIndex && (Zu = Qi.iconFeatureIndex), Qi.iconBox) {
                                    let zl = (Fl)=>this.collisionIndex.placeCollisionBox(Fl, Mt, hr, it, yt, tr, Ut, je, Pe.predicate, di, mr && co ? co : void 0);
                                    Ds && Ds.placeable && Qi.verticalIconBox ? (po = zl(Qi.verticalIconBox), To = po.placeable) : (po = zl(Qi.iconBox), To = po.placeable), Wa = Wa && po.offscreen;
                                }
                                let el = Oe || Ci.numHorizontalGlyphVertices === 0 && Ci.numVerticalGlyphVertices === 0, au = Je || Ci.numIconVertices === 0;
                                el || au ? au ? el || (To = To && Ga) : Ga = To && Ga : To = Ga = To && Ga;
                                let zc = To && po.placeable;
                                if (Ga && As.placeable && this.collisionIndex.insertCollisionBox(As.box, He, se.get("text-ignore-placement"), ee.bucketInstanceId, Ds && Ds.placeable && Hl ? Hl : _l, Pe.ID), zc && this.collisionIndex.insertCollisionBox(po.box, Mt, se.get("icon-ignore-placement"), ee.bucketInstanceId, Zu, Pe.ID), yo && Ga && this.collisionIndex.insertCollisionCircles(yo.circles, He, se.get("text-ignore-placement"), ee.bucketInstanceId, _l, Pe.ID), Q && this.storeCollisionData(ee.bucketInstanceId, Mn, Qi, As, po, yo), Ci.crossTileID === 0) throw new Error("symbolInstance.crossTileID can't be 0");
                                if (ee.bucketInstanceId === 0) throw new Error("bucket.bucketInstanceId can't be 0");
                                this.placements[Ci.crossTileID] = new _n(Ga || zr, To || Xr, Wa || ee.justReloaded), B[Ci.crossTileID] = !0;
                            };
                            if (Rr) {
                                if (w.symbolInstanceStart !== 0) throw new Error("bucket.bucketInstanceId should be 0");
                                let Ci = ee.getSortedSymbolIndexes(this.transform.angle);
                                for(let Qi = Ci.length - 1; Qi >= 0; --Qi){
                                    let Mn = Ci[Qi];
                                    Li(ee.symbolInstances.get(Mn), ee.collisionArrays[Mn], Mn);
                                }
                            } else for(let Ci = w.symbolInstanceStart; Ci < w.symbolInstanceEnd; Ci++)Li(ee.symbolInstances.get(Ci), ee.collisionArrays[Ci], Ci);
                            if (Q && ee.bucketInstanceId in this.collisionCircleArrays) {
                                let Ci = this.collisionCircleArrays[ee.bucketInstanceId];
                                a.as(Ci.invProjMatrix, it), Ci.viewportMatrix = this.collisionIndex.getViewportMatrix();
                            }
                            ee.justReloaded = !1;
                        }
                        storeCollisionData(w, B, Q, ee, se, qe) {
                            if (Q.textBox || Q.iconBox) {
                                let je, it;
                                this.collisionBoxArrays.has(w) ? je = this.collisionBoxArrays.get(w) : (je = new Map, this.collisionBoxArrays.set(w, je)), je.has(B) ? it = je.get(B) : (it = {
                                    text: null,
                                    icon: null
                                }, je.set(B, it)), Q.textBox && (it.text = ee.box), Q.iconBox && (it.icon = se.box);
                            }
                            if (qe) {
                                let je = this.collisionCircleArrays[w];
                                je === void 0 && (je = this.collisionCircleArrays[w] = new $i);
                                for(let it = 0; it < qe.circles.length; it += 4)je.circles.push(qe.circles[it + 0]), je.circles.push(qe.circles[it + 1]), je.circles.push(qe.circles[it + 2]), je.circles.push(qe.collisionDetected ? 1 : 0);
                            }
                        }
                        markUsedJustification(w, B, Q, ee) {
                            let se;
                            se = ee === a.ah.vertical ? Q.verticalPlacedTextSymbolIndex : ({
                                left: Q.leftJustifiedTextSymbolIndex,
                                center: Q.centerJustifiedTextSymbolIndex,
                                right: Q.rightJustifiedTextSymbolIndex
                            })[a.at(B)];
                            let qe = [
                                Q.leftJustifiedTextSymbolIndex,
                                Q.centerJustifiedTextSymbolIndex,
                                Q.rightJustifiedTextSymbolIndex,
                                Q.verticalPlacedTextSymbolIndex
                            ];
                            for (let je of qe)je >= 0 && (w.text.placedSymbolArray.get(je).crossTileID = se >= 0 && je !== se ? 0 : Q.crossTileID);
                        }
                        markUsedOrientation(w, B, Q) {
                            let ee = B === a.ah.horizontal || B === a.ah.horizontalOnly ? B : 0, se = B === a.ah.vertical ? B : 0, qe = [
                                Q.leftJustifiedTextSymbolIndex,
                                Q.centerJustifiedTextSymbolIndex,
                                Q.rightJustifiedTextSymbolIndex
                            ];
                            for (let je of qe)w.text.placedSymbolArray.get(je).placedOrientation = ee;
                            Q.verticalPlacedTextSymbolIndex && (w.text.placedSymbolArray.get(Q.verticalPlacedTextSymbolIndex).placedOrientation = se);
                        }
                        commit(w) {
                            this.commitTime = w, this.zoomAtLastRecencyCheck = this.transform.zoom;
                            let B = this.prevPlacement, Q = !1;
                            this.prevZoomAdjustment = B ? B.zoomAdjustment(this.transform.zoom) : 0;
                            let ee = B ? B.symbolFadeChange(w) : 1, se = B ? B.opacities : {}, qe = B ? B.variableOffsets : {}, je = B ? B.placedOrientations : {};
                            for(let it in this.placements){
                                let yt = this.placements[it], Ot = se[it];
                                Ot ? (this.opacities[it] = new Ni(Ot, ee, yt.text, yt.icon), Q = Q || yt.text !== Ot.text.placed || yt.icon !== Ot.icon.placed) : (this.opacities[it] = new Ni(null, ee, yt.text, yt.icon, yt.skipFade), Q = Q || yt.text || yt.icon);
                            }
                            for(let it in se){
                                let yt = se[it];
                                if (!this.opacities[it]) {
                                    let Ot = new Ni(yt, ee, !1, !1);
                                    Ot.isHidden() || (this.opacities[it] = Ot, Q = Q || yt.text.placed || yt.icon.placed);
                                }
                            }
                            for(let it in qe)this.variableOffsets[it] || !this.opacities[it] || this.opacities[it].isHidden() || (this.variableOffsets[it] = qe[it]);
                            for(let it in je)this.placedOrientations[it] || !this.opacities[it] || this.opacities[it].isHidden() || (this.placedOrientations[it] = je[it]);
                            if (B && B.lastPlacementChangeTime === void 0) throw new Error("Last placement time for previous placement is not defined");
                            Q ? this.lastPlacementChangeTime = w : typeof this.lastPlacementChangeTime != "number" && (this.lastPlacementChangeTime = B ? B.lastPlacementChangeTime : w);
                        }
                        updateLayerOpacities(w, B) {
                            let Q = {};
                            for (let ee of B){
                                let se = ee.getBucket(w);
                                se && ee.latestFeatureIndex && w.id === se.layerIds[0] && this.updateBucketOpacities(se, ee.tileID, Q, ee.collisionBoxArray);
                            }
                        }
                        updateBucketOpacities(w, B, Q, ee) {
                            w.hasTextData() && (w.text.opacityVertexArray.clear(), w.text.hasVisibleVertices = !1), w.hasIconData() && (w.icon.opacityVertexArray.clear(), w.icon.hasVisibleVertices = !1), w.hasIconCollisionBoxData() && w.iconCollisionBox.collisionVertexArray.clear(), w.hasTextCollisionBoxData() && w.textCollisionBox.collisionVertexArray.clear();
                            let se = w.layers[0], qe = se.layout, je = new Ni(null, 0, !1, !1, !0), it = qe.get("text-allow-overlap"), yt = qe.get("icon-allow-overlap"), Ot = se._unevaluatedLayout.hasValue("text-variable-anchor") || se._unevaluatedLayout.hasValue("text-variable-anchor-offset"), Nt = qe.get("text-rotation-alignment") === "map", hr = qe.get("text-pitch-alignment") === "map", Sr = qe.get("icon-text-fit") !== "none", he = new Ni(null, 0, it && (yt || !w.hasIconData() || qe.get("icon-optional")), yt && (it || !w.hasTextData() || qe.get("text-optional")), !0);
                            !w.collisionArrays && ee && (w.hasIconCollisionBoxData() || w.hasTextCollisionBoxData()) && w.deserializeCollisionBoxes(ee);
                            let be = (Oe, Je, He)=>{
                                for(let et = 0; et < Je / 4; et++)Oe.opacityVertexArray.emplaceBack(He);
                                Oe.hasVisibleVertices = Oe.hasVisibleVertices || He !== Pi;
                            }, Pe = this.collisionBoxArrays.get(w.bucketInstanceId);
                            for(let Oe = 0; Oe < w.symbolInstances.length; Oe++){
                                let Je = w.symbolInstances.get(Oe), { numHorizontalGlyphVertices: He, numVerticalGlyphVertices: et, crossTileID: Mt } = Je, Dt = this.opacities[Mt];
                                Q[Mt] ? Dt = je : Dt || (Dt = he, this.opacities[Mt] = Dt), Q[Mt] = !0;
                                let Ut = Je.numIconVertices > 0, tr = this.placedOrientations[Je.crossTileID], mr = tr === a.ah.vertical, Rr = tr === a.ah.horizontal || tr === a.ah.horizontalOnly;
                                if (He > 0 || et > 0) {
                                    let Xr = Mi(Dt.text);
                                    be(w.text, He, mr ? Pi : Xr), be(w.text, et, Rr ? Pi : Xr);
                                    let di = Dt.text.isHidden();
                                    [
                                        Je.rightJustifiedTextSymbolIndex,
                                        Je.centerJustifiedTextSymbolIndex,
                                        Je.leftJustifiedTextSymbolIndex
                                    ].forEach((Qi)=>{
                                        Qi >= 0 && (w.text.placedSymbolArray.get(Qi).hidden = di || mr ? 1 : 0);
                                    }), Je.verticalPlacedTextSymbolIndex >= 0 && (w.text.placedSymbolArray.get(Je.verticalPlacedTextSymbolIndex).hidden = di || Rr ? 1 : 0);
                                    let Li = this.variableOffsets[Je.crossTileID];
                                    Li && this.markUsedJustification(w, Li.anchor, Je, tr);
                                    let Ci = this.placedOrientations[Je.crossTileID];
                                    Ci && (this.markUsedJustification(w, "left", Je, Ci), this.markUsedOrientation(w, Ci, Je));
                                }
                                if (Ut) {
                                    let Xr = Mi(Dt.icon), di = !(Sr && Je.verticalPlacedIconSymbolIndex && mr);
                                    Je.placedIconSymbolIndex >= 0 && (be(w.icon, Je.numIconVertices, di ? Xr : Pi), w.icon.placedSymbolArray.get(Je.placedIconSymbolIndex).hidden = Dt.icon.isHidden()), Je.verticalPlacedIconSymbolIndex >= 0 && (be(w.icon, Je.numVerticalIconVertices, di ? Pi : Xr), w.icon.placedSymbolArray.get(Je.verticalPlacedIconSymbolIndex).hidden = Dt.icon.isHidden());
                                }
                                let zr = Pe && Pe.has(Oe) ? Pe.get(Oe) : {
                                    text: null,
                                    icon: null
                                };
                                if (w.hasIconCollisionBoxData() || w.hasTextCollisionBoxData()) {
                                    let Xr = w.collisionArrays[Oe];
                                    if (Xr) {
                                        let di = new a.P(0, 0);
                                        if (Xr.textBox || Xr.verticalTextBox) {
                                            let Li = !0;
                                            if (Ot) {
                                                let Ci = this.variableOffsets[Mt];
                                                Ci ? (di = It(Ci.anchor, Ci.width, Ci.height, Ci.textOffset, Ci.textBoxScale), Nt && di._rotate(hr ? this.transform.angle : -this.transform.angle)) : Li = !1;
                                            }
                                            if (Xr.textBox || Xr.verticalTextBox) {
                                                let Ci;
                                                Xr.textBox && (Ci = mr), Xr.verticalTextBox && (Ci = Rr), jt(w.textCollisionBox.collisionVertexArray, Dt.text.placed, !Li || Ci, zr.text, di.x, di.y);
                                            }
                                        }
                                        if (Xr.iconBox || Xr.verticalIconBox) {
                                            let Li = !!(!Rr && Xr.verticalIconBox), Ci;
                                            Xr.iconBox && (Ci = Li), Xr.verticalIconBox && (Ci = !Li), jt(w.iconCollisionBox.collisionVertexArray, Dt.icon.placed, Ci, zr.icon, Sr ? di.x : 0, Sr ? di.y : 0);
                                        }
                                    }
                                }
                            }
                            if (w.sortFeatures(this.transform.angle), this.retainedQueryData[w.bucketInstanceId] && (this.retainedQueryData[w.bucketInstanceId].featureSortOrder = w.featureSortOrder), w.hasTextData() && w.text.opacityVertexBuffer && w.text.opacityVertexBuffer.updateData(w.text.opacityVertexArray), w.hasIconData() && w.icon.opacityVertexBuffer && w.icon.opacityVertexBuffer.updateData(w.icon.opacityVertexArray), w.hasIconCollisionBoxData() && w.iconCollisionBox.collisionVertexBuffer && w.iconCollisionBox.collisionVertexBuffer.updateData(w.iconCollisionBox.collisionVertexArray), w.hasTextCollisionBoxData() && w.textCollisionBox.collisionVertexBuffer && w.textCollisionBox.collisionVertexBuffer.updateData(w.textCollisionBox.collisionVertexArray), w.text.opacityVertexArray.length !== w.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${w.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${w.text.layoutVertexArray.length}) / 4`);
                            if (w.icon.opacityVertexArray.length !== w.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${w.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${w.icon.layoutVertexArray.length}) / 4`);
                            if (w.bucketInstanceId in this.collisionCircleArrays) {
                                let Oe = this.collisionCircleArrays[w.bucketInstanceId];
                                w.placementInvProjMatrix = Oe.invProjMatrix, w.placementViewportMatrix = Oe.viewportMatrix, w.collisionCircleArray = Oe.circles, delete this.collisionCircleArrays[w.bucketInstanceId];
                            }
                        }
                        symbolFadeChange(w) {
                            return this.fadeDuration === 0 ? 1 : (w - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
                        }
                        zoomAdjustment(w) {
                            return Math.max(0, (this.transform.zoom - w) / 1.5);
                        }
                        hasTransitions(w) {
                            return this.stale || w - this.lastPlacementChangeTime < this.fadeDuration;
                        }
                        stillRecent(w, B) {
                            let Q = this.zoomAtLastRecencyCheck === B ? 1 - this.zoomAdjustment(B) : 1;
                            return this.zoomAtLastRecencyCheck = B, this.commitTime + this.fadeDuration * Q > w;
                        }
                        setStale() {
                            this.stale = !0;
                        }
                    }
                    function jt(le, w, B, Q, ee, se) {
                        Q && Q.length !== 0 || (Q = [
                            0,
                            0,
                            0,
                            0
                        ]);
                        let qe = Q[0] - ri, je = Q[1] - ri, it = Q[2] - ri, yt = Q[3] - ri;
                        le.emplaceBack(w ? 1 : 0, B ? 1 : 0, ee || 0, se || 0, qe, je), le.emplaceBack(w ? 1 : 0, B ? 1 : 0, ee || 0, se || 0, it, je), le.emplaceBack(w ? 1 : 0, B ? 1 : 0, ee || 0, se || 0, it, yt), le.emplaceBack(w ? 1 : 0, B ? 1 : 0, ee || 0, se || 0, qe, yt);
                    }
                    let Zt = Math.pow(2, 25), yr = Math.pow(2, 24), Fr = Math.pow(2, 17), Zr = Math.pow(2, 16), Vr = Math.pow(2, 9), gi = Math.pow(2, 8), Si = Math.pow(2, 1);
                    function Mi(le) {
                        if (le.opacity === 0 && !le.placed) return 0;
                        if (le.opacity === 1 && le.placed) return 4294967295;
                        let w = le.placed ? 1 : 0, B = Math.floor(127 * le.opacity);
                        return B * Zt + w * yr + B * Fr + w * Zr + B * Vr + w * gi + B * Si + w;
                    }
                    let Pi = 0;
                    function Gi() {
                        return {
                            isOccluded: (le, w, B)=>!1,
                            getPitchedTextCorrection: (le, w, B)=>1,
                            get useSpecialProjectionForSymbols () {
                                return !1;
                            },
                            projectTileCoordinates (le, w, B, Q) {
                                throw new Error("Not implemented.");
                            },
                            translatePosition: (le, w, B, Q)=>(function(ee, se, qe, je, it = !1) {
                                    if (!qe[0] && !qe[1]) return [
                                        0,
                                        0
                                    ];
                                    let yt = it ? je === "map" ? ee.angle : 0 : je === "viewport" ? -ee.angle : 0;
                                    if (yt) {
                                        let Ot = Math.sin(yt), Nt = Math.cos(yt);
                                        qe = [
                                            qe[0] * Nt - qe[1] * Ot,
                                            qe[0] * Ot + qe[1] * Nt
                                        ];
                                    }
                                    return [
                                        it ? qe[0] : nn(se, qe[0], ee.zoom),
                                        it ? qe[1] : nn(se, qe[1], ee.zoom)
                                    ];
                                })(le, w, B, Q),
                            getCircleRadiusCorrection: (le)=>1
                        };
                    }
                    class Ki {
                        constructor(w){
                            this._sortAcrossTiles = w.layout.get("symbol-z-order") !== "viewport-y" && !w.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
                        }
                        continuePlacement(w, B, Q, ee, se) {
                            let qe = this._bucketParts;
                            for(; this._currentTileIndex < w.length;)if (B.getBucketParts(qe, ee, w[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, se()) return !0;
                            for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, qe.sort((je, it)=>je.sortKey - it.sortKey)); this._currentPartIndex < qe.length;)if (B.placeLayerBucketPart(qe[this._currentPartIndex], this._seenCrossTileIDs, Q), this._currentPartIndex++, se()) return !0;
                            return !1;
                        }
                    }
                    class ka {
                        constructor(w, B, Q, ee, se, qe, je, it){
                            this.placement = new ft(w, Gi(), B, qe, je, it), this._currentPlacementIndex = Q.length - 1, this._forceFullPlacement = ee, this._showCollisionBoxes = se, this._done = !1;
                        }
                        isDone() {
                            return this._done;
                        }
                        continuePlacement(w, B, Q) {
                            let ee = u.now(), se = ()=>!this._forceFullPlacement && u.now() - ee > 2;
                            for(; this._currentPlacementIndex >= 0;){
                                let qe = B[w[this._currentPlacementIndex]], je = this.placement.collisionIndex.transform.zoom;
                                if (qe.type === "symbol" && (!qe.minzoom || qe.minzoom <= je) && (!qe.maxzoom || qe.maxzoom > je)) {
                                    if (this._inProgressLayer || (this._inProgressLayer = new Ki(qe)), this._inProgressLayer.continuePlacement(Q[qe.source], this.placement, this._showCollisionBoxes, qe, se)) return;
                                    delete this._inProgressLayer;
                                }
                                this._currentPlacementIndex--;
                            }
                            this._done = !0;
                        }
                        commit(w) {
                            return this.placement.commit(w), this.placement;
                        }
                    }
                    let jn = 512 / a.X / 2;
                    class la {
                        constructor(w, B, Q){
                            this.tileID = w, this.bucketInstanceId = Q, this._symbolsByKey = {};
                            let ee = new Map;
                            for(let se = 0; se < B.length; se++){
                                let qe = B.get(se), je = qe.key, it = ee.get(je);
                                it ? it.push(qe) : ee.set(je, [
                                    qe
                                ]);
                            }
                            for (let [se, qe] of ee){
                                let je = {
                                    positions: qe.map((it)=>({
                                            x: Math.floor(it.anchorX * jn),
                                            y: Math.floor(it.anchorY * jn)
                                        })),
                                    crossTileIDs: qe.map((it)=>it.crossTileID)
                                };
                                if (je.positions.length > 128) {
                                    let it = new a.av(je.positions.length, 16, Uint16Array);
                                    for (let { x: yt, y: Ot } of je.positions)it.add(yt, Ot);
                                    it.finish(), delete je.positions, je.index = it;
                                }
                                this._symbolsByKey[se] = je;
                            }
                        }
                        getScaledCoordinates(w, B) {
                            let { x: Q, y: ee, z: se } = this.tileID.canonical, { x: qe, y: je, z: it } = B.canonical, yt = jn / Math.pow(2, it - se), Ot = (je * a.X + w.anchorY) * yt, Nt = ee * a.X * jn;
                            return {
                                x: Math.floor((qe * a.X + w.anchorX) * yt - Q * a.X * jn),
                                y: Math.floor(Ot - Nt)
                            };
                        }
                        findMatches(w, B, Q) {
                            let ee = this.tileID.canonical.z < B.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - B.canonical.z);
                            for(let se = 0; se < w.length; se++){
                                let qe = w.get(se);
                                if (qe.crossTileID) continue;
                                let je = this._symbolsByKey[qe.key];
                                if (!je) continue;
                                let it = this.getScaledCoordinates(qe, B);
                                if (je.index) {
                                    let yt = je.index.range(it.x - ee, it.y - ee, it.x + ee, it.y + ee).sort();
                                    for (let Ot of yt){
                                        let Nt = je.crossTileIDs[Ot];
                                        if (!Q[Nt]) {
                                            Q[Nt] = !0, qe.crossTileID = Nt;
                                            break;
                                        }
                                    }
                                } else if (je.positions) for(let yt = 0; yt < je.positions.length; yt++){
                                    let Ot = je.positions[yt], Nt = je.crossTileIDs[yt];
                                    if (Math.abs(Ot.x - it.x) <= ee && Math.abs(Ot.y - it.y) <= ee && !Q[Nt]) {
                                        Q[Nt] = !0, qe.crossTileID = Nt;
                                        break;
                                    }
                                }
                            }
                        }
                        getCrossTileIDsLists() {
                            return Object.values(this._symbolsByKey).map(({ crossTileIDs: w })=>w);
                        }
                    }
                    class Fa {
                        constructor(){
                            this.maxCrossTileID = 0;
                        }
                        generate() {
                            return ++this.maxCrossTileID;
                        }
                    }
                    class Ra {
                        constructor(){
                            this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
                        }
                        handleWrapJump(w) {
                            let B = Math.round((w - this.lng) / 360);
                            if (B !== 0) for(let Q in this.indexes){
                                let ee = this.indexes[Q], se = {};
                                for(let qe in ee){
                                    let je = ee[qe];
                                    je.tileID = je.tileID.unwrapTo(je.tileID.wrap + B), se[je.tileID.key] = je;
                                }
                                this.indexes[Q] = se;
                            }
                            this.lng = w;
                        }
                        addBucket(w, B, Q) {
                            if (this.indexes[w.overscaledZ] && this.indexes[w.overscaledZ][w.key]) {
                                if (this.indexes[w.overscaledZ][w.key].bucketInstanceId === B.bucketInstanceId) return !1;
                                this.removeBucketCrossTileIDs(w.overscaledZ, this.indexes[w.overscaledZ][w.key]);
                            }
                            for(let se = 0; se < B.symbolInstances.length; se++)B.symbolInstances.get(se).crossTileID = 0;
                            this.usedCrossTileIDs[w.overscaledZ] || (this.usedCrossTileIDs[w.overscaledZ] = {});
                            let ee = this.usedCrossTileIDs[w.overscaledZ];
                            for(let se in this.indexes){
                                let qe = this.indexes[se];
                                if (Number(se) > w.overscaledZ) for(let je in qe){
                                    let it = qe[je];
                                    it.tileID.isChildOf(w) && it.findMatches(B.symbolInstances, w, ee);
                                }
                                else {
                                    let je = qe[w.scaledTo(Number(se)).key];
                                    je && je.findMatches(B.symbolInstances, w, ee);
                                }
                            }
                            for(let se = 0; se < B.symbolInstances.length; se++){
                                let qe = B.symbolInstances.get(se);
                                qe.crossTileID || (qe.crossTileID = Q.generate(), ee[qe.crossTileID] = !0);
                            }
                            return this.indexes[w.overscaledZ] === void 0 && (this.indexes[w.overscaledZ] = {}), this.indexes[w.overscaledZ][w.key] = new la(w, B.symbolInstances, B.bucketInstanceId), !0;
                        }
                        removeBucketCrossTileIDs(w, B) {
                            for (let Q of B.getCrossTileIDsLists())for (let ee of Q)delete this.usedCrossTileIDs[w][ee];
                        }
                        removeStaleBuckets(w) {
                            let B = !1;
                            for(let Q in this.indexes){
                                let ee = this.indexes[Q];
                                for(let se in ee)w[ee[se].bucketInstanceId] || (this.removeBucketCrossTileIDs(Q, ee[se]), delete ee[se], B = !0);
                            }
                            return B;
                        }
                    }
                    class jo {
                        constructor(){
                            this.layerIndexes = {}, this.crossTileIDs = new Fa, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
                        }
                        addLayer(w, B, Q) {
                            let ee = this.layerIndexes[w.id];
                            ee === void 0 && (ee = this.layerIndexes[w.id] = new Ra);
                            let se = !1, qe = {};
                            ee.handleWrapJump(Q);
                            for (let je of B){
                                let it = je.getBucket(w);
                                it && w.id === it.layerIds[0] && (it.bucketInstanceId || (it.bucketInstanceId = ++this.maxBucketInstanceId), ee.addBucket(je.tileID, it, this.crossTileIDs) && (se = !0), qe[it.bucketInstanceId] = !0);
                            }
                            return ee.removeStaleBuckets(qe) && (se = !0), se;
                        }
                        pruneUnusedLayers(w) {
                            let B = {};
                            w.forEach((Q)=>{
                                B[Q] = !0;
                            });
                            for(let Q in this.layerIndexes)B[Q] || delete this.layerIndexes[Q];
                        }
                    }
                    let oa = (le, w)=>a.t(le, w && w.filter((B)=>B.identifier !== "source.canvas")), Sn = a.aw();
                    class Ha extends a.E {
                        constructor(w, B = {}){
                            super(), this._rtlPluginLoaded = ()=>{
                                for(let Q in this.sourceCaches){
                                    let ee = this.sourceCaches[Q].getSource().type;
                                    ee !== "vector" && ee !== "geojson" || this.sourceCaches[Q].reload();
                                }
                            }, this.map = w, this.dispatcher = new Ee(Te(), w._getMapId()), this.dispatcher.registerMessageHandler("GG", (Q, ee)=>this.getGlyphs(Q, ee)), this.dispatcher.registerMessageHandler("GI", (Q, ee)=>this.getImages(Q, ee)), this.imageManager = new T, this.imageManager.setEventedParent(this), this.glyphManager = new H(w._requestManager, B.localIdeographFontFamily), this.lineAtlas = new ae(256, 512), this.crossTileSymbolIndex = new jo, this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.sourceCaches = {}, this.zoomHistory = new a.ax, this._loaded = !1, this._availableImages = [], this._resetUpdates(), this.dispatcher.broadcast("SR", a.ay()), bt().on(er, this._rtlPluginLoaded), this.on("data", (Q)=>{
                                if (Q.dataType !== "source" || Q.sourceDataType !== "metadata") return;
                                let ee = this.sourceCaches[Q.sourceId];
                                if (!ee) return;
                                let se = ee.getSource();
                                if (se && se.vectorLayerIds) for(let qe in this._layers){
                                    let je = this._layers[qe];
                                    je.source === se.id && this._validateLayer(je);
                                }
                            });
                        }
                        loadURL(w, B = {}, Q) {
                            this.fire(new a.k("dataloading", {
                                dataType: "style"
                            })), B.validate = typeof B.validate != "boolean" || B.validate;
                            let ee = this.map._requestManager.transformRequest(w, "Style");
                            this._loadStyleRequest = new AbortController;
                            let se = this._loadStyleRequest;
                            a.h(ee, this._loadStyleRequest).then((qe)=>{
                                this._loadStyleRequest = null, this._load(qe.data, B, Q);
                            }).catch((qe)=>{
                                this._loadStyleRequest = null, qe && !se.signal.aborted && this.fire(new a.j(qe));
                            });
                        }
                        loadJSON(w, B = {}, Q) {
                            this.fire(new a.k("dataloading", {
                                dataType: "style"
                            })), this._frameRequest = new AbortController, u.frameAsync(this._frameRequest).then(()=>{
                                this._frameRequest = null, B.validate = B.validate !== !1, this._load(w, B, Q);
                            }).catch(()=>{});
                        }
                        loadEmpty() {
                            this.fire(new a.k("dataloading", {
                                dataType: "style"
                            })), this._load(Sn, {
                                validate: !1
                            });
                        }
                        _load(w, B, Q) {
                            var ee;
                            let se = B.transformStyle ? B.transformStyle(Q, w) : w;
                            if (!B.validate || !oa(this, a.u(se))) {
                                this._loaded = !0, this.stylesheet = se;
                                for(let qe in se.sources)this.addSource(qe, se.sources[qe], {
                                    validate: !1
                                });
                                se.sprite ? this._loadSprite(se.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(se.glyphs), this._createLayers(), this.light = new N(this.stylesheet.light), this.sky = new re(this.stylesheet.sky), this.map.setTerrain((ee = this.stylesheet.terrain) !== null && ee !== void 0 ? ee : null), this.fire(new a.k("data", {
                                    dataType: "style"
                                })), this.fire(new a.k("style.load"));
                            }
                        }
                        _createLayers() {
                            let w = a.az(this.stylesheet.layers);
                            this.dispatcher.broadcast("SL", w), this._order = w.map((B)=>B.id), this._layers = {}, this._serializedLayers = null;
                            for (let B of w){
                                let Q = a.aA(B);
                                Q.setEventedParent(this, {
                                    layer: {
                                        id: B.id
                                    }
                                }), this._layers[B.id] = Q;
                            }
                        }
                        _loadSprite(w, B = !1, Q) {
                            let ee;
                            this.imageManager.setLoaded(!1), this._spriteRequest = new AbortController, (function(se, qe, je, it) {
                                return a._(this, void 0, void 0, function*() {
                                    let yt = C(se), Ot = je > 1 ? "@2x" : "", Nt = {}, hr = {};
                                    for (let { id: Sr, url: he } of yt){
                                        let be = qe.transformRequest(M(he, Ot, ".json"), "SpriteJSON");
                                        Nt[Sr] = a.h(be, it);
                                        let Pe = qe.transformRequest(M(he, Ot, ".png"), "SpriteImage");
                                        hr[Sr] = p.getImage(Pe, it);
                                    }
                                    return yield Promise.all([
                                        ...Object.values(Nt),
                                        ...Object.values(hr)
                                    ]), function(Sr, he) {
                                        return a._(this, void 0, void 0, function*() {
                                            let be = {};
                                            for(let Pe in Sr){
                                                be[Pe] = {};
                                                let Oe = u.getImageCanvasContext((yield he[Pe]).data), Je = (yield Sr[Pe]).data;
                                                for(let He in Je){
                                                    let { width: et, height: Mt, x: Dt, y: Ut, sdf: tr, pixelRatio: mr, stretchX: Rr, stretchY: zr, content: Xr, textFitWidth: di, textFitHeight: Li } = Je[He];
                                                    be[Pe][He] = {
                                                        data: null,
                                                        pixelRatio: mr,
                                                        sdf: tr,
                                                        stretchX: Rr,
                                                        stretchY: zr,
                                                        content: Xr,
                                                        textFitWidth: di,
                                                        textFitHeight: Li,
                                                        spriteData: {
                                                            width: et,
                                                            height: Mt,
                                                            x: Dt,
                                                            y: Ut,
                                                            context: Oe
                                                        }
                                                    };
                                                }
                                            }
                                            return be;
                                        });
                                    }(Nt, hr);
                                });
                            })(w, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((se)=>{
                                if (this._spriteRequest = null, se) for(let qe in se){
                                    this._spritesImagesIds[qe] = [];
                                    let je = this._spritesImagesIds[qe] ? this._spritesImagesIds[qe].filter((it)=>!(it in se)) : [];
                                    for (let it of je)this.imageManager.removeImage(it), this._changedImages[it] = !0;
                                    for(let it in se[qe]){
                                        let yt = qe === "default" ? it : `${qe}:${it}`;
                                        this._spritesImagesIds[qe].push(yt), yt in this.imageManager.images ? this.imageManager.updateImage(yt, se[qe][it], !1) : this.imageManager.addImage(yt, se[qe][it]), B && (this._changedImages[yt] = !0);
                                    }
                                }
                            }).catch((se)=>{
                                this._spriteRequest = null, ee = se, this.fire(new a.j(ee));
                            }).finally(()=>{
                                this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), B && (this._changed = !0), this.dispatcher.broadcast("SI", this._availableImages), this.fire(new a.k("data", {
                                    dataType: "style"
                                })), Q && Q(ee);
                            });
                        }
                        _unloadSprite() {
                            for (let w of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(w), this._changedImages[w] = !0;
                            this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new a.k("data", {
                                dataType: "style"
                            }));
                        }
                        _validateLayer(w) {
                            let B = this.sourceCaches[w.source];
                            if (!B) return;
                            let Q = w.sourceLayer;
                            if (!Q) return;
                            let ee = B.getSource();
                            (ee.type === "geojson" || ee.vectorLayerIds && ee.vectorLayerIds.indexOf(Q) === -1) && this.fire(new a.j(new Error(`Source layer "${Q}" does not exist on source "${ee.id}" as specified by style layer "${w.id}".`)));
                        }
                        loaded() {
                            if (!this._loaded || Object.keys(this._updatedSources).length) return !1;
                            for(let w in this.sourceCaches)if (!this.sourceCaches[w].loaded()) return !1;
                            return !!this.imageManager.isLoaded();
                        }
                        _serializeByIds(w, B = !1) {
                            let Q = this._serializedAllLayers();
                            if (!w || w.length === 0) return Object.values(B ? a.aB(Q) : Q);
                            let ee = [];
                            for (let se of w)if (Q[se]) {
                                let qe = B ? a.aB(Q[se]) : Q[se];
                                ee.push(qe);
                            }
                            return ee;
                        }
                        _serializedAllLayers() {
                            let w = this._serializedLayers;
                            if (w) return w;
                            w = this._serializedLayers = {};
                            let B = Object.keys(this._layers);
                            for (let Q of B){
                                let ee = this._layers[Q];
                                ee.type !== "custom" && (w[Q] = ee.serialize());
                            }
                            return w;
                        }
                        hasTransitions() {
                            if (this.light && this.light.hasTransition() || this.sky && this.sky.hasTransition()) return !0;
                            for(let w in this.sourceCaches)if (this.sourceCaches[w].hasTransition()) return !0;
                            for(let w in this._layers)if (this._layers[w].hasTransition()) return !0;
                            return !1;
                        }
                        _checkLoaded() {
                            if (!this._loaded) throw new Error("Style is not done loading.");
                        }
                        update(w) {
                            if (!this._loaded) return;
                            let B = this._changed;
                            if (B) {
                                let ee = Object.keys(this._updatedLayers), se = Object.keys(this._removedLayers);
                                (ee.length || se.length) && this._updateWorkerLayers(ee, se);
                                for(let qe in this._updatedSources){
                                    let je = this._updatedSources[qe];
                                    if (je === "reload") this._reloadSource(qe);
                                    else {
                                        if (je !== "clear") throw new Error(`Invalid action ${je}`);
                                        this._clearSource(qe);
                                    }
                                }
                                this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                                for(let qe in this._updatedPaintProps)this._layers[qe].updateTransitions(w);
                                this.light.updateTransitions(w), this.sky.updateTransitions(w), this._resetUpdates();
                            }
                            let Q = {};
                            for(let ee in this.sourceCaches){
                                let se = this.sourceCaches[ee];
                                Q[ee] = se.used, se.used = !1;
                            }
                            for (let ee of this._order){
                                let se = this._layers[ee];
                                se.recalculate(w, this._availableImages), !se.isHidden(w.zoom) && se.source && (this.sourceCaches[se.source].used = !0);
                            }
                            for(let ee in Q){
                                let se = this.sourceCaches[ee];
                                !!Q[ee] != !!se.used && se.fire(new a.k("data", {
                                    sourceDataType: "visibility",
                                    dataType: "source",
                                    sourceId: ee
                                }));
                            }
                            this.light.recalculate(w), this.sky.recalculate(w), this.z = w.zoom, B && this.fire(new a.k("data", {
                                dataType: "style"
                            }));
                        }
                        _updateTilesForChangedImages() {
                            let w = Object.keys(this._changedImages);
                            if (w.length) {
                                for(let B in this.sourceCaches)this.sourceCaches[B].reloadTilesForDependencies([
                                    "icons",
                                    "patterns"
                                ], w);
                                this._changedImages = {};
                            }
                        }
                        _updateTilesForChangedGlyphs() {
                            if (this._glyphsDidChange) {
                                for(let w in this.sourceCaches)this.sourceCaches[w].reloadTilesForDependencies([
                                    "glyphs"
                                ], [
                                    ""
                                ]);
                                this._glyphsDidChange = !1;
                            }
                        }
                        _updateWorkerLayers(w, B) {
                            this.dispatcher.broadcast("UL", {
                                layers: this._serializeByIds(w, !1),
                                removedIds: B
                            });
                        }
                        _resetUpdates() {
                            this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
                        }
                        setState(w, B = {}) {
                            var Q;
                            this._checkLoaded();
                            let ee = this.serialize();
                            if (w = B.transformStyle ? B.transformStyle(ee, w) : w, ((Q = B.validate) === null || Q === void 0 || Q) && oa(this, a.u(w))) return !1;
                            (w = a.aB(w)).layers = a.az(w.layers);
                            let se = a.aC(ee, w), qe = this._getOperationsToPerform(se);
                            if (qe.unimplemented.length > 0) throw new Error(`Unimplemented: ${qe.unimplemented.join(", ")}.`);
                            if (qe.operations.length === 0) return !1;
                            for (let je of qe.operations)je();
                            return this.stylesheet = w, this._serializedLayers = null, !0;
                        }
                        _getOperationsToPerform(w) {
                            let B = [], Q = [];
                            for (let ee of w)switch(ee.command){
                                case "setCenter":
                                case "setZoom":
                                case "setBearing":
                                case "setPitch":
                                    continue;
                                case "addLayer":
                                    B.push(()=>this.addLayer.apply(this, ee.args));
                                    break;
                                case "removeLayer":
                                    B.push(()=>this.removeLayer.apply(this, ee.args));
                                    break;
                                case "setPaintProperty":
                                    B.push(()=>this.setPaintProperty.apply(this, ee.args));
                                    break;
                                case "setLayoutProperty":
                                    B.push(()=>this.setLayoutProperty.apply(this, ee.args));
                                    break;
                                case "setFilter":
                                    B.push(()=>this.setFilter.apply(this, ee.args));
                                    break;
                                case "addSource":
                                    B.push(()=>this.addSource.apply(this, ee.args));
                                    break;
                                case "removeSource":
                                    B.push(()=>this.removeSource.apply(this, ee.args));
                                    break;
                                case "setLayerZoomRange":
                                    B.push(()=>this.setLayerZoomRange.apply(this, ee.args));
                                    break;
                                case "setLight":
                                    B.push(()=>this.setLight.apply(this, ee.args));
                                    break;
                                case "setGeoJSONSourceData":
                                    B.push(()=>this.setGeoJSONSourceData.apply(this, ee.args));
                                    break;
                                case "setGlyphs":
                                    B.push(()=>this.setGlyphs.apply(this, ee.args));
                                    break;
                                case "setSprite":
                                    B.push(()=>this.setSprite.apply(this, ee.args));
                                    break;
                                case "setSky":
                                    B.push(()=>this.setSky.apply(this, ee.args));
                                    break;
                                case "setTerrain":
                                    B.push(()=>this.map.setTerrain.apply(this, ee.args));
                                    break;
                                case "setTransition":
                                    B.push(()=>{});
                                    break;
                                default:
                                    Q.push(ee.command);
                            }
                            return {
                                operations: B,
                                unimplemented: Q
                            };
                        }
                        addImage(w, B) {
                            if (this.getImage(w)) return this.fire(new a.j(new Error(`An image named "${w}" already exists.`)));
                            this.imageManager.addImage(w, B), this._afterImageUpdated(w);
                        }
                        updateImage(w, B) {
                            this.imageManager.updateImage(w, B);
                        }
                        getImage(w) {
                            return this.imageManager.getImage(w);
                        }
                        removeImage(w) {
                            if (!this.getImage(w)) return this.fire(new a.j(new Error(`An image named "${w}" does not exist.`)));
                            this.imageManager.removeImage(w), this._afterImageUpdated(w);
                        }
                        _afterImageUpdated(w) {
                            this._availableImages = this.imageManager.listImages(), this._changedImages[w] = !0, this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new a.k("data", {
                                dataType: "style"
                            }));
                        }
                        listImages() {
                            return this._checkLoaded(), this.imageManager.listImages();
                        }
                        addSource(w, B, Q = {}) {
                            if (this._checkLoaded(), this.sourceCaches[w] !== void 0) throw new Error(`Source "${w}" already exists.`);
                            if (!B.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(B).join(", ")}.`);
                            if ([
                                "vector",
                                "raster",
                                "geojson",
                                "video",
                                "image"
                            ].indexOf(B.type) >= 0 && this._validate(a.u.source, `sources.${w}`, B, null, Q)) return;
                            this.map && this.map._collectResourceTiming && (B.collectResourceTiming = !0);
                            let ee = this.sourceCaches[w] = new dt(w, B, this.dispatcher);
                            ee.style = this, ee.setEventedParent(this, ()=>({
                                    isSourceLoaded: ee.loaded(),
                                    source: ee.serialize(),
                                    sourceId: w
                                })), ee.onAdd(this.map), this._changed = !0;
                        }
                        removeSource(w) {
                            if (this._checkLoaded(), this.sourceCaches[w] === void 0) throw new Error("There is no source with this ID");
                            for(let Q in this._layers)if (this._layers[Q].source === w) return this.fire(new a.j(new Error(`Source "${w}" cannot be removed while layer "${Q}" is using it.`)));
                            let B = this.sourceCaches[w];
                            delete this.sourceCaches[w], delete this._updatedSources[w], B.fire(new a.k("data", {
                                sourceDataType: "metadata",
                                dataType: "source",
                                sourceId: w
                            })), B.setEventedParent(null), B.onRemove(this.map), this._changed = !0;
                        }
                        setGeoJSONSourceData(w, B) {
                            if (this._checkLoaded(), this.sourceCaches[w] === void 0) throw new Error(`There is no source with this ID=${w}`);
                            let Q = this.sourceCaches[w].getSource();
                            if (Q.type !== "geojson") throw new Error(`geojsonSource.type is ${Q.type}, which is !== 'geojson`);
                            Q.setData(B), this._changed = !0;
                        }
                        getSource(w) {
                            return this.sourceCaches[w] && this.sourceCaches[w].getSource();
                        }
                        addLayer(w, B, Q = {}) {
                            this._checkLoaded();
                            let ee = w.id;
                            if (this.getLayer(ee)) return void this.fire(new a.j(new Error(`Layer "${ee}" already exists on this map.`)));
                            let se;
                            if (w.type === "custom") {
                                if (oa(this, a.aD(w))) return;
                                se = a.aA(w);
                            } else {
                                if ("source" in w && typeof w.source == "object" && (this.addSource(ee, w.source), w = a.aB(w), w = a.e(w, {
                                    source: ee
                                })), this._validate(a.u.layer, `layers.${ee}`, w, {
                                    arrayIndex: -1
                                }, Q)) return;
                                se = a.aA(w), this._validateLayer(se), se.setEventedParent(this, {
                                    layer: {
                                        id: ee
                                    }
                                });
                            }
                            let qe = B ? this._order.indexOf(B) : this._order.length;
                            if (B && qe === -1) this.fire(new a.j(new Error(`Cannot add layer "${ee}" before non-existing layer "${B}".`)));
                            else {
                                if (this._order.splice(qe, 0, ee), this._layerOrderChanged = !0, this._layers[ee] = se, this._removedLayers[ee] && se.source && se.type !== "custom") {
                                    let je = this._removedLayers[ee];
                                    delete this._removedLayers[ee], je.type !== se.type ? this._updatedSources[se.source] = "clear" : (this._updatedSources[se.source] = "reload", this.sourceCaches[se.source].pause());
                                }
                                this._updateLayer(se), se.onAdd && se.onAdd(this.map);
                            }
                        }
                        moveLayer(w, B) {
                            if (this._checkLoaded(), this._changed = !0, !this._layers[w]) return void this.fire(new a.j(new Error(`The layer '${w}' does not exist in the map's style and cannot be moved.`)));
                            if (w === B) return;
                            let Q = this._order.indexOf(w);
                            this._order.splice(Q, 1);
                            let ee = B ? this._order.indexOf(B) : this._order.length;
                            B && ee === -1 ? this.fire(new a.j(new Error(`Cannot move layer "${w}" before non-existing layer "${B}".`))) : (this._order.splice(ee, 0, w), this._layerOrderChanged = !0);
                        }
                        removeLayer(w) {
                            this._checkLoaded();
                            let B = this._layers[w];
                            if (!B) return void this.fire(new a.j(new Error(`Cannot remove non-existing layer "${w}".`)));
                            B.setEventedParent(null);
                            let Q = this._order.indexOf(w);
                            this._order.splice(Q, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[w] = B, delete this._layers[w], this._serializedLayers && delete this._serializedLayers[w], delete this._updatedLayers[w], delete this._updatedPaintProps[w], B.onRemove && B.onRemove(this.map);
                        }
                        getLayer(w) {
                            return this._layers[w];
                        }
                        getLayersOrder() {
                            return [
                                ...this._order
                            ];
                        }
                        hasLayer(w) {
                            return w in this._layers;
                        }
                        setLayerZoomRange(w, B, Q) {
                            this._checkLoaded();
                            let ee = this.getLayer(w);
                            ee ? ee.minzoom === B && ee.maxzoom === Q || (B != null && (ee.minzoom = B), Q != null && (ee.maxzoom = Q), this._updateLayer(ee)) : this.fire(new a.j(new Error(`Cannot set the zoom range of non-existing layer "${w}".`)));
                        }
                        setFilter(w, B, Q = {}) {
                            this._checkLoaded();
                            let ee = this.getLayer(w);
                            if (ee) {
                                if (!a.aE(ee.filter, B)) return B == null ? (ee.filter = void 0, void this._updateLayer(ee)) : void (this._validate(a.u.filter, `layers.${ee.id}.filter`, B, null, Q) || (ee.filter = a.aB(B), this._updateLayer(ee)));
                            } else this.fire(new a.j(new Error(`Cannot filter non-existing layer "${w}".`)));
                        }
                        getFilter(w) {
                            return a.aB(this.getLayer(w).filter);
                        }
                        setLayoutProperty(w, B, Q, ee = {}) {
                            this._checkLoaded();
                            let se = this.getLayer(w);
                            se ? a.aE(se.getLayoutProperty(B), Q) || (se.setLayoutProperty(B, Q, ee), this._updateLayer(se)) : this.fire(new a.j(new Error(`Cannot style non-existing layer "${w}".`)));
                        }
                        getLayoutProperty(w, B) {
                            let Q = this.getLayer(w);
                            if (Q) return Q.getLayoutProperty(B);
                            this.fire(new a.j(new Error(`Cannot get style of non-existing layer "${w}".`)));
                        }
                        setPaintProperty(w, B, Q, ee = {}) {
                            this._checkLoaded();
                            let se = this.getLayer(w);
                            se ? a.aE(se.getPaintProperty(B), Q) || (se.setPaintProperty(B, Q, ee) && this._updateLayer(se), this._changed = !0, this._updatedPaintProps[w] = !0, this._serializedLayers = null) : this.fire(new a.j(new Error(`Cannot style non-existing layer "${w}".`)));
                        }
                        getPaintProperty(w, B) {
                            return this.getLayer(w).getPaintProperty(B);
                        }
                        setFeatureState(w, B) {
                            this._checkLoaded();
                            let Q = w.source, ee = w.sourceLayer, se = this.sourceCaches[Q];
                            if (se === void 0) return void this.fire(new a.j(new Error(`The source '${Q}' does not exist in the map's style.`)));
                            let qe = se.getSource().type;
                            qe === "geojson" && ee ? this.fire(new a.j(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : qe !== "vector" || ee ? (w.id === void 0 && this.fire(new a.j(new Error("The feature id parameter must be provided."))), se.setFeatureState(ee, w.id, B)) : this.fire(new a.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
                        }
                        removeFeatureState(w, B) {
                            this._checkLoaded();
                            let Q = w.source, ee = this.sourceCaches[Q];
                            if (ee === void 0) return void this.fire(new a.j(new Error(`The source '${Q}' does not exist in the map's style.`)));
                            let se = ee.getSource().type, qe = se === "vector" ? w.sourceLayer : void 0;
                            se !== "vector" || qe ? B && typeof w.id != "string" && typeof w.id != "number" ? this.fire(new a.j(new Error("A feature id is required to remove its specific state property."))) : ee.removeFeatureState(qe, w.id, B) : this.fire(new a.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
                        }
                        getFeatureState(w) {
                            this._checkLoaded();
                            let B = w.source, Q = w.sourceLayer, ee = this.sourceCaches[B];
                            if (ee !== void 0) return ee.getSource().type !== "vector" || Q ? (w.id === void 0 && this.fire(new a.j(new Error("The feature id parameter must be provided."))), ee.getFeatureState(Q, w.id)) : void this.fire(new a.j(new Error("The sourceLayer parameter must be provided for vector source types.")));
                            this.fire(new a.j(new Error(`The source '${B}' does not exist in the map's style.`)));
                        }
                        getTransition() {
                            return a.e({
                                duration: 300,
                                delay: 0
                            }, this.stylesheet && this.stylesheet.transition);
                        }
                        serialize() {
                            if (!this._loaded) return;
                            let w = a.aF(this.sourceCaches, (se)=>se.serialize()), B = this._serializeByIds(this._order, !0), Q = this.map.getTerrain() || void 0, ee = this.stylesheet;
                            return a.aG({
                                version: ee.version,
                                name: ee.name,
                                metadata: ee.metadata,
                                light: ee.light,
                                sky: ee.sky,
                                center: ee.center,
                                zoom: ee.zoom,
                                bearing: ee.bearing,
                                pitch: ee.pitch,
                                sprite: ee.sprite,
                                glyphs: ee.glyphs,
                                transition: ee.transition,
                                sources: w,
                                layers: B,
                                terrain: Q
                            }, (se)=>se !== void 0);
                        }
                        _updateLayer(w) {
                            this._updatedLayers[w.id] = !0, w.source && !this._updatedSources[w.source] && this.sourceCaches[w.source].getSource().type !== "raster" && (this._updatedSources[w.source] = "reload", this.sourceCaches[w.source].pause()), this._serializedLayers = null, this._changed = !0;
                        }
                        _flattenAndSortRenderedFeatures(w) {
                            let B = (qe)=>this._layers[qe].type === "fill-extrusion", Q = {}, ee = [];
                            for(let qe = this._order.length - 1; qe >= 0; qe--){
                                let je = this._order[qe];
                                if (B(je)) {
                                    Q[je] = qe;
                                    for (let it of w){
                                        let yt = it[je];
                                        if (yt) for (let Ot of yt)ee.push(Ot);
                                    }
                                }
                            }
                            ee.sort((qe, je)=>je.intersectionZ - qe.intersectionZ);
                            let se = [];
                            for(let qe = this._order.length - 1; qe >= 0; qe--){
                                let je = this._order[qe];
                                if (B(je)) for(let it = ee.length - 1; it >= 0; it--){
                                    let yt = ee[it].feature;
                                    if (Q[yt.layer.id] < qe) break;
                                    se.push(yt), ee.pop();
                                }
                                else for (let it of w){
                                    let yt = it[je];
                                    if (yt) for (let Ot of yt)se.push(Ot.feature);
                                }
                            }
                            return se;
                        }
                        queryRenderedFeatures(w, B, Q) {
                            B && B.filter && this._validate(a.u.filter, "queryRenderedFeatures.filter", B.filter, null, B);
                            let ee = {};
                            if (B && B.layers) {
                                if (!Array.isArray(B.layers)) return this.fire(new a.j(new Error("parameters.layers must be an Array."))), [];
                                for (let je of B.layers){
                                    let it = this._layers[je];
                                    if (!it) return this.fire(new a.j(new Error(`The layer '${je}' does not exist in the map's style and cannot be queried for features.`))), [];
                                    ee[it.source] = !0;
                                }
                            }
                            let se = [];
                            B.availableImages = this._availableImages;
                            let qe = this._serializedAllLayers();
                            for(let je in this.sourceCaches)B.layers && !ee[je] || se.push(Ce(this.sourceCaches[je], this._layers, qe, w, B, Q));
                            return this.placement && se.push(function(je, it, yt, Ot, Nt, hr, Sr) {
                                let he = {}, be = hr.queryRenderedSymbols(Ot), Pe = [];
                                for (let Oe of Object.keys(be).map(Number))Pe.push(Sr[Oe]);
                                Pe.sort(me);
                                for (let Oe of Pe){
                                    let Je = Oe.featureIndex.lookupSymbolFeatures(be[Oe.bucketInstanceId], it, Oe.bucketIndex, Oe.sourceLayerIndex, Nt.filter, Nt.layers, Nt.availableImages, je);
                                    for(let He in Je){
                                        let et = he[He] = he[He] || [], Mt = Je[He];
                                        Mt.sort((Dt, Ut)=>{
                                            let tr = Oe.featureSortOrder;
                                            if (tr) {
                                                let mr = tr.indexOf(Dt.featureIndex);
                                                return tr.indexOf(Ut.featureIndex) - mr;
                                            }
                                            return Ut.featureIndex - Dt.featureIndex;
                                        });
                                        for (let Dt of Mt)et.push(Dt);
                                    }
                                }
                                for(let Oe in he)he[Oe].forEach((Je)=>{
                                    let He = Je.feature, et = yt[je[Oe].source].getFeatureState(He.layer["source-layer"], He.id);
                                    He.source = He.layer.source, He.layer["source-layer"] && (He.sourceLayer = He.layer["source-layer"]), He.state = et;
                                });
                                return he;
                            }(this._layers, qe, this.sourceCaches, w, B, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(se);
                        }
                        querySourceFeatures(w, B) {
                            B && B.filter && this._validate(a.u.filter, "querySourceFeatures.filter", B.filter, null, B);
                            let Q = this.sourceCaches[w];
                            return Q ? function(ee, se) {
                                let qe = ee.getRenderableIds().map((yt)=>ee.getTileByID(yt)), je = [], it = {};
                                for(let yt = 0; yt < qe.length; yt++){
                                    let Ot = qe[yt], Nt = Ot.tileID.canonical.key;
                                    it[Nt] || (it[Nt] = !0, Ot.querySourceFeatures(je, se));
                                }
                                return je;
                            }(Q, B) : [];
                        }
                        getLight() {
                            return this.light.getLight();
                        }
                        setLight(w, B = {}) {
                            this._checkLoaded();
                            let Q = this.light.getLight(), ee = !1;
                            for(let qe in w)if (!a.aE(w[qe], Q[qe])) {
                                ee = !0;
                                break;
                            }
                            if (!ee) return;
                            let se = {
                                now: u.now(),
                                transition: a.e({
                                    duration: 300,
                                    delay: 0
                                }, this.stylesheet.transition)
                            };
                            this.light.setLight(w, B), this.light.updateTransitions(se);
                        }
                        getSky() {
                            var w;
                            return (w = this.stylesheet) === null || w === void 0 ? void 0 : w.sky;
                        }
                        setSky(w, B = {}) {
                            let Q = this.getSky(), ee = !1;
                            if (!w && !Q) return;
                            if (w && !Q) ee = !0;
                            else if (!w && Q) ee = !0;
                            else for(let qe in w)if (!a.aE(w[qe], Q[qe])) {
                                ee = !0;
                                break;
                            }
                            if (!ee) return;
                            let se = {
                                now: u.now(),
                                transition: a.e({
                                    duration: 300,
                                    delay: 0
                                }, this.stylesheet.transition)
                            };
                            this.stylesheet.sky = w, this.sky.setSky(w, B), this.sky.updateTransitions(se);
                        }
                        _validate(w, B, Q, ee, se = {}) {
                            return (!se || se.validate !== !1) && oa(this, w.call(a.u, a.e({
                                key: B,
                                style: this.serialize(),
                                value: Q,
                                styleSpec: a.v
                            }, ee)));
                        }
                        _remove(w = !0) {
                            this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), bt().off(er, this._rtlPluginLoaded);
                            for(let B in this._layers)this._layers[B].setEventedParent(null);
                            for(let B in this.sourceCaches){
                                let Q = this.sourceCaches[B];
                                Q.setEventedParent(null), Q.onRemove(this.map);
                            }
                            this.imageManager.setEventedParent(null), this.setEventedParent(null), w && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(w);
                        }
                        _clearSource(w) {
                            this.sourceCaches[w].clearTiles();
                        }
                        _reloadSource(w) {
                            this.sourceCaches[w].resume(), this.sourceCaches[w].reload();
                        }
                        _updateSources(w) {
                            for(let B in this.sourceCaches)this.sourceCaches[B].update(w, this.map.terrain);
                        }
                        _generateCollisionBoxes() {
                            for(let w in this.sourceCaches)this._reloadSource(w);
                        }
                        _updatePlacement(w, B, Q, ee, se = !1) {
                            let qe = !1, je = !1, it = {};
                            for (let yt of this._order){
                                let Ot = this._layers[yt];
                                if (Ot.type !== "symbol") continue;
                                if (!it[Ot.source]) {
                                    let hr = this.sourceCaches[Ot.source];
                                    it[Ot.source] = hr.getRenderableIds(!0).map((Sr)=>hr.getTileByID(Sr)).sort((Sr, he)=>he.tileID.overscaledZ - Sr.tileID.overscaledZ || (Sr.tileID.isLessThan(he.tileID) ? -1 : 1));
                                }
                                let Nt = this.crossTileSymbolIndex.addLayer(Ot, it[Ot.source], w.center.lng);
                                qe = qe || Nt;
                            }
                            if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((se = se || this._layerOrderChanged || Q === 0) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(u.now(), w.zoom)) && (this.pauseablePlacement = new ka(w, this.map.terrain, this._order, se, B, Q, ee, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, it), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(u.now()), je = !0), qe && this.pauseablePlacement.placement.setStale()), je || qe) for (let yt of this._order){
                                let Ot = this._layers[yt];
                                Ot.type === "symbol" && this.placement.updateLayerOpacities(Ot, it[Ot.source]);
                            }
                            return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(u.now());
                        }
                        _releaseSymbolFadeTiles() {
                            for(let w in this.sourceCaches)this.sourceCaches[w].releaseSymbolFadeTiles();
                        }
                        getImages(w, B) {
                            return a._(this, void 0, void 0, function*() {
                                let Q = yield this.imageManager.getImages(B.icons);
                                this._updateTilesForChangedImages();
                                let ee = this.sourceCaches[B.source];
                                return ee && ee.setDependencies(B.tileID.key, B.type, B.icons), Q;
                            });
                        }
                        getGlyphs(w, B) {
                            return a._(this, void 0, void 0, function*() {
                                let Q = yield this.glyphManager.getGlyphs(B.stacks), ee = this.sourceCaches[B.source];
                                return ee && ee.setDependencies(B.tileID.key, B.type, [
                                    ""
                                ]), Q;
                            });
                        }
                        getGlyphsUrl() {
                            return this.stylesheet.glyphs || null;
                        }
                        setGlyphs(w, B = {}) {
                            this._checkLoaded(), w && this._validate(a.u.glyphs, "glyphs", w, null, B) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = w, this.glyphManager.entries = {}, this.glyphManager.setURL(w));
                        }
                        addSprite(w, B, Q = {}, ee) {
                            this._checkLoaded();
                            let se = [
                                {
                                    id: w,
                                    url: B
                                }
                            ], qe = [
                                ...C(this.stylesheet.sprite),
                                ...se
                            ];
                            this._validate(a.u.sprite, "sprite", qe, null, Q) || (this.stylesheet.sprite = qe, this._loadSprite(se, !0, ee));
                        }
                        removeSprite(w) {
                            this._checkLoaded();
                            let B = C(this.stylesheet.sprite);
                            if (B.find((Q)=>Q.id === w)) {
                                if (this._spritesImagesIds[w]) for (let Q of this._spritesImagesIds[w])this.imageManager.removeImage(Q), this._changedImages[Q] = !0;
                                B.splice(B.findIndex((Q)=>Q.id === w), 1), this.stylesheet.sprite = B.length > 0 ? B : void 0, delete this._spritesImagesIds[w], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new a.k("data", {
                                    dataType: "style"
                                }));
                            } else this.fire(new a.j(new Error(`Sprite "${w}" doesn't exists on this map.`)));
                        }
                        getSprite() {
                            return C(this.stylesheet.sprite);
                        }
                        setSprite(w, B = {}, Q) {
                            this._checkLoaded(), w && this._validate(a.u.sprite, "sprite", w, null, B) || (this.stylesheet.sprite = w, w ? this._loadSprite(w, !0, Q) : (this._unloadSprite(), Q && Q(null)));
                        }
                    }
                    var oo = a.Y([
                        {
                            name: "a_pos",
                            type: "Int16",
                            components: 2
                        }
                    ]);
                    let xn = {
                        prelude: _t(`#ifdef GL_ES
precision mediump float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
`, `#ifdef GL_ES
precision highp float;
#else
#if !defined(lowp)
#define lowp
#endif
#if !defined(mediump)
#define mediump
#endif
#if !defined(highp)
#define highp
#endif
#endif
vec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0
);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}
#ifdef TERRAIN3D
uniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;
#endif
const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {
#ifdef TERRAIN3D
highp float d=unpack(texture2D(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));
#else
return 1.0;
#endif
}float calculate_visibility(vec4 pos) {
#ifdef TERRAIN3D
vec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;
#else
return 1.0;
#endif
}float ele(vec2 pos) {
#ifdef TERRAIN3D
vec4 rgb=(texture2D(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;
#else
return 0.0;
#endif
}float get_elevation(vec2 pos) {
#ifdef TERRAIN3D
vec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;
#else
return 0.0;
#endif
}`),
                        background: _t(`uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
                        backgroundPattern: _t(`uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, "uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
                        circle: _t(`varying vec3 v_data;varying float v_visibility;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define mediump float radius
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define highp vec4 stroke_color
#pragma mapbox: define mediump float stroke_width
#pragma mapbox: define lowp float stroke_opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize mediump float radius
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize highp vec4 stroke_color
#pragma mapbox: initialize mediump float stroke_width
#pragma mapbox: initialize lowp float stroke_opacity
vec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;varying float v_visibility;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define mediump float radius
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define highp vec4 stroke_color
#pragma mapbox: define mediump float stroke_width
#pragma mapbox: define lowp float stroke_opacity
void main(void) {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize mediump float radius
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize highp vec4 stroke_color
#pragma mapbox: initialize mediump float stroke_width
#pragma mapbox: initialize lowp float stroke_opacity
vec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);float ele=get_elevation(circle_center);v_visibility=calculate_visibility(u_matrix*vec4(circle_center,ele,1.0));if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,ele,1);} else {gl_Position=u_matrix*vec4(circle_center,ele,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}`),
                        clippingMask: _t("void main() {gl_FragColor=vec4(1.0);}", "attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
                        heatmap: _t(`uniform highp float u_intensity;varying vec2 v_extrude;
#pragma mapbox: define highp float weight
#define GAUSS_COEF 0.3989422804014327
void main() {
#pragma mapbox: initialize highp float weight
float d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;
#pragma mapbox: define highp float weight
#pragma mapbox: define mediump float radius
const highp float ZERO=1.0/255.0/16.0;
#define GAUSS_COEF 0.3989422804014327
void main(void) {
#pragma mapbox: initialize highp float weight
#pragma mapbox: initialize mediump float radius
vec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,get_elevation(floor(a_pos*0.5)),1);gl_Position=u_matrix*pos;}`),
                        heatmapTexture: _t(`uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(0.0);
#endif
}`, "uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
                        collisionBox: _t("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}", "attribute vec2 a_anchor_pos;attribute vec2 a_placed;attribute vec2 a_box_real;uniform mat4 u_matrix;uniform vec2 u_pixel_extrude_scale;varying float v_placed;varying float v_notUsed;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
                        collisionCircle: _t("varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);gl_FragColor=color*alpha*opacity_t;}", "attribute vec2 a_pos;attribute float a_radius;attribute vec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;varying float v_radius;varying vec2 v_extrude;varying float v_perspective_ratio;varying float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos;float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=collision;gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
                        debug: _t("uniform highp vec4 u_color;uniform sampler2D u_overlay;varying vec2 v_uv;void main() {vec4 overlay_color=texture2D(u_overlay,v_uv);gl_FragColor=mix(u_color,overlay_color,overlay_color.a);}", "attribute vec2 a_pos;varying vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=u_matrix*vec4(a_pos*u_overlay_scale,get_elevation(a_pos),1);}"),
                        fill: _t(`#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float opacity
gl_FragColor=color*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `attribute vec2 a_pos;uniform mat4 u_matrix;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float opacity
gl_Position=u_matrix*vec4(a_pos,0,1);}`),
                        fillOutline: _t(`varying vec2 v_pos;
#pragma mapbox: define highp vec4 outline_color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 outline_color
#pragma mapbox: initialize lowp float opacity
float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;
#pragma mapbox: define highp vec4 outline_color
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 outline_color
#pragma mapbox: initialize lowp float opacity
gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}`),
                        fillOutlinePattern: _t(`uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}`),
                        fillPattern: _t(`#ifdef GL_ES
precision highp float;
#endif
uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}`),
                        fillExtrusion: _t(`varying vec4 v_color;void main() {gl_FragColor=v_color;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;
#ifdef TERRAIN3D
attribute vec2 a_centroid;
#endif
varying vec4 v_color;
#pragma mapbox: define highp float base
#pragma mapbox: define highp float height
#pragma mapbox: define highp vec4 color
void main() {
#pragma mapbox: initialize highp float base
#pragma mapbox: initialize highp float height
#pragma mapbox: initialize highp vec4 color
vec3 normal=a_normal_ed.xyz;
#ifdef TERRAIN3D
float height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);
#else
float height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;
#endif
base=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}`),
                        fillExtrusionPattern: _t(`uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;
#pragma mapbox: define lowp float base
#pragma mapbox: define lowp float height
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float base
#pragma mapbox: initialize lowp float height
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;
#ifdef TERRAIN3D
attribute vec2 a_centroid;
#endif
varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;
#pragma mapbox: define lowp float base
#pragma mapbox: define lowp float height
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float base
#pragma mapbox: initialize lowp float height
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;
#ifdef TERRAIN3D
float height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);
#else
float height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;
#endif
base=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0
? a_pos
: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}`),
                        hillshadePrepare: _t(`#ifdef GL_ES
precision highp float;
#endif
uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/pow(2.0,exaggeration+(19.2562-u_zoom));gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, "uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
                        hillshade: _t(`uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;
#define PI 3.141592653589793
void main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, "uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),
                        line: _t(`uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
attribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float width
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float width
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_width2=vec2(outset,inset);}`),
                        lineGradient: _t(`uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp vec2 v_uv;
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,v_uv);gl_FragColor=color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
attribute vec2 a_pos_normal;attribute vec4 a_data;attribute float a_uv_x;attribute float a_split_index;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp vec2 v_uv;
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float width
void main() {
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float width
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_width2=vec2(outset,inset);}`),
                        linePattern: _t(`#ifdef GL_ES
precision highp float;
#endif
uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
vec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
attribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;varying float v_width;
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define mediump float width
#pragma mapbox: define lowp float floorwidth
#pragma mapbox: define lowp vec4 pattern_from
#pragma mapbox: define lowp vec4 pattern_to
#pragma mapbox: define lowp float pixel_ratio_from
#pragma mapbox: define lowp float pixel_ratio_to
void main() {
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize lowp float floorwidth
#pragma mapbox: initialize mediump vec4 pattern_from
#pragma mapbox: initialize mediump vec4 pattern_to
#pragma mapbox: initialize lowp float pixel_ratio_from
#pragma mapbox: initialize lowp float pixel_ratio_to
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}`),
                        lineSDF: _t(`uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float width
#pragma mapbox: define lowp float floorwidth
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize lowp float floorwidth
float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `
#define scale 0.015873016
#define LINE_DISTANCE_SCALE 2.0
attribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;
#pragma mapbox: define highp vec4 color
#pragma mapbox: define lowp float blur
#pragma mapbox: define lowp float opacity
#pragma mapbox: define mediump float gapwidth
#pragma mapbox: define lowp float offset
#pragma mapbox: define mediump float width
#pragma mapbox: define lowp float floorwidth
void main() {
#pragma mapbox: initialize highp vec4 color
#pragma mapbox: initialize lowp float blur
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize mediump float gapwidth
#pragma mapbox: initialize lowp float offset
#pragma mapbox: initialize mediump float width
#pragma mapbox: initialize lowp float floorwidth
float ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;
#ifdef TERRAIN3D
v_gamma_scale=1.0;
#else
float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;
#endif
v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}`),
                        raster: _t(`uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, "uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
                        symbolIcon: _t(`uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize lowp float opacity
lowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec2 v_tex;varying float v_fade_opacity;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}
#pragma mapbox: define lowp float opacity
void main() {
#pragma mapbox: initialize lowp float opacity
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}`),
                        symbolSDF: _t(`#define SDF_PX 8.0
uniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
float EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}gl_FragColor=color*(alpha*opacity*fade_opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec2 v_data0;varying vec3 v_data1;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}`),
                        symbolTextAndIcon: _t(`#define SDF_PX 8.0
#define SDF 1.0
#define ICON 0.0
uniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
float fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
return;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);
#ifdef OVERDRAW_INSPECTOR
gl_FragColor=vec4(1.0);
#endif
}`, `attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;varying vec4 v_data0;varying vec4 v_data1;vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_matrix*vec4(posInTile,elevation,1.0);}
#pragma mapbox: define highp vec4 fill_color
#pragma mapbox: define highp vec4 halo_color
#pragma mapbox: define lowp float opacity
#pragma mapbox: define lowp float halo_width
#pragma mapbox: define lowp float halo_blur
void main() {
#pragma mapbox: initialize highp vec4 fill_color
#pragma mapbox: initialize highp vec4 halo_color
#pragma mapbox: initialize lowp float opacity
#pragma mapbox: initialize lowp float halo_width
#pragma mapbox: initialize lowp float halo_blur
vec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?
camera_to_anchor_distance/u_camera_to_center_distance :
u_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;vec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}`),
                        terrain: _t("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;varying vec2 v_texture_pos;varying float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture2D(u_texture,v_texture_pos);if (v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);gl_FragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {gl_FragColor=surface_color;}}", "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform mat4 u_fog_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;varying float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"),
                        terrainDepth: _t("varying float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {gl_FragColor=pack(v_depth);}", "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);v_depth=gl_Position.z/gl_Position.w;}"),
                        terrainCoords: _t("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;varying vec2 v_texture_pos;void main() {vec4 rgba=texture2D(u_texture,v_texture_pos);gl_FragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", "attribute vec3 a_pos3d;uniform mat4 u_matrix;uniform float u_ele_delta;varying vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=u_matrix*vec4(a_pos3d.xy,ele-ele_delta,1.0);}"),
                        sky: _t("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform float u_horizon;uniform float u_sky_horizon_blend;void main() {float y=gl_FragCoord.y;if (y > u_horizon) {float blend=y-u_horizon;if (blend < u_sky_horizon_blend) {gl_FragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {gl_FragColor=u_sky_color;}}}", "attribute vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}")
                    };
                    function _t(le, w) {
                        let B = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, Q = w.match(/attribute ([\w]+) ([\w]+)/g), ee = le.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), se = w.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), qe = se ? se.concat(ee) : ee, je = {};
                        return {
                            fragmentSource: le = le.replace(B, (it, yt, Ot, Nt, hr)=>(je[hr] = !0, yt === "define" ? `
#ifndef HAS_UNIFORM_u_${hr}
varying ${Ot} ${Nt} ${hr};
#else
uniform ${Ot} ${Nt} u_${hr};
#endif
` : `
#ifdef HAS_UNIFORM_u_${hr}
    ${Ot} ${Nt} ${hr} = u_${hr};
#endif
`)),
                            vertexSource: w = w.replace(B, (it, yt, Ot, Nt, hr)=>{
                                let Sr = Nt === "float" ? "vec2" : "vec4", he = hr.match(/color/) ? "color" : Sr;
                                return je[hr] ? yt === "define" ? `
#ifndef HAS_UNIFORM_u_${hr}
uniform lowp float u_${hr}_t;
attribute ${Ot} ${Sr} a_${hr};
varying ${Ot} ${Nt} ${hr};
#else
uniform ${Ot} ${Nt} u_${hr};
#endif
` : he === "vec4" ? `
#ifndef HAS_UNIFORM_u_${hr}
    ${hr} = a_${hr};
#else
    ${Ot} ${Nt} ${hr} = u_${hr};
#endif
` : `
#ifndef HAS_UNIFORM_u_${hr}
    ${hr} = unpack_mix_${he}(a_${hr}, u_${hr}_t);
#else
    ${Ot} ${Nt} ${hr} = u_${hr};
#endif
` : yt === "define" ? `
#ifndef HAS_UNIFORM_u_${hr}
uniform lowp float u_${hr}_t;
attribute ${Ot} ${Sr} a_${hr};
#else
uniform ${Ot} ${Nt} u_${hr};
#endif
` : he === "vec4" ? `
#ifndef HAS_UNIFORM_u_${hr}
    ${Ot} ${Nt} ${hr} = a_${hr};
#else
    ${Ot} ${Nt} ${hr} = u_${hr};
#endif
` : `
#ifndef HAS_UNIFORM_u_${hr}
    ${Ot} ${Nt} ${hr} = unpack_mix_${he}(a_${hr}, u_${hr}_t);
#else
    ${Ot} ${Nt} ${hr} = u_${hr};
#endif
`;
                            }),
                            staticAttributes: Q,
                            staticUniforms: qe
                        };
                    }
                    class br {
                        constructor(){
                            this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
                        }
                        bind(w, B, Q, ee, se, qe, je, it, yt) {
                            this.context = w;
                            let Ot = this.boundPaintVertexBuffers.length !== ee.length;
                            for(let Nt = 0; !Ot && Nt < ee.length; Nt++)this.boundPaintVertexBuffers[Nt] !== ee[Nt] && (Ot = !0);
                            !this.vao || this.boundProgram !== B || this.boundLayoutVertexBuffer !== Q || Ot || this.boundIndexBuffer !== se || this.boundVertexOffset !== qe || this.boundDynamicVertexBuffer !== je || this.boundDynamicVertexBuffer2 !== it || this.boundDynamicVertexBuffer3 !== yt ? this.freshBind(B, Q, ee, se, qe, je, it, yt) : (w.bindVertexArray.set(this.vao), je && je.bind(), se && se.dynamicDraw && se.bind(), it && it.bind(), yt && yt.bind());
                        }
                        freshBind(w, B, Q, ee, se, qe, je, it) {
                            let yt = w.numAttributes, Ot = this.context, Nt = Ot.gl;
                            this.vao && this.destroy(), this.vao = Ot.createVertexArray(), Ot.bindVertexArray.set(this.vao), this.boundProgram = w, this.boundLayoutVertexBuffer = B, this.boundPaintVertexBuffers = Q, this.boundIndexBuffer = ee, this.boundVertexOffset = se, this.boundDynamicVertexBuffer = qe, this.boundDynamicVertexBuffer2 = je, this.boundDynamicVertexBuffer3 = it, B.enableAttributes(Nt, w);
                            for (let hr of Q)hr.enableAttributes(Nt, w);
                            qe && qe.enableAttributes(Nt, w), je && je.enableAttributes(Nt, w), it && it.enableAttributes(Nt, w), B.bind(), B.setVertexAttribPointers(Nt, w, se);
                            for (let hr of Q)hr.bind(), hr.setVertexAttribPointers(Nt, w, se);
                            qe && (qe.bind(), qe.setVertexAttribPointers(Nt, w, se)), ee && ee.bind(), je && (je.bind(), je.setVertexAttribPointers(Nt, w, se)), it && (it.bind(), it.setVertexAttribPointers(Nt, w, se)), Ot.currentNumAttributes = yt;
                        }
                        destroy() {
                            this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
                        }
                    }
                    let Hr = (le, w, B, Q, ee)=>({
                            u_matrix: le,
                            u_texture: 0,
                            u_ele_delta: w,
                            u_fog_matrix: B,
                            u_fog_color: Q ? Q.properties.get("fog-color") : a.aM.white,
                            u_fog_ground_blend: Q ? Q.properties.get("fog-ground-blend") : 1,
                            u_fog_ground_blend_opacity: Q ? Q.calculateFogBlendOpacity(ee) : 0,
                            u_horizon_color: Q ? Q.properties.get("horizon-color") : a.aM.white,
                            u_horizon_fog_blend: Q ? Q.properties.get("horizon-fog-blend") : 1
                        });
                    function ti(le) {
                        let w = [];
                        for(let B = 0; B < le.length; B++){
                            if (le[B] === null) continue;
                            let Q = le[B].split(" ");
                            w.push(Q.pop());
                        }
                        return w;
                    }
                    class zi {
                        constructor(w, B, Q, ee, se, qe){
                            let je = w.gl;
                            this.program = je.createProgram();
                            let it = ti(B.staticAttributes), yt = Q ? Q.getBinderAttributes() : [], Ot = it.concat(yt), Nt = xn.prelude.staticUniforms ? ti(xn.prelude.staticUniforms) : [], hr = B.staticUniforms ? ti(B.staticUniforms) : [], Sr = Q ? Q.getBinderUniforms() : [], he = Nt.concat(hr).concat(Sr), be = [];
                            for (let Dt of he)be.indexOf(Dt) < 0 && be.push(Dt);
                            let Pe = Q ? Q.defines() : [];
                            se && Pe.push("#define OVERDRAW_INSPECTOR;"), qe && Pe.push("#define TERRAIN3D;");
                            let Oe = Pe.concat(xn.prelude.fragmentSource, B.fragmentSource).join(`
`), Je = Pe.concat(xn.prelude.vertexSource, B.vertexSource).join(`
`), He = je.createShader(je.FRAGMENT_SHADER);
                            if (je.isContextLost()) return void (this.failedToCreate = !0);
                            if (je.shaderSource(He, Oe), je.compileShader(He), !je.getShaderParameter(He, je.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${je.getShaderInfoLog(He)}`);
                            je.attachShader(this.program, He);
                            let et = je.createShader(je.VERTEX_SHADER);
                            if (je.isContextLost()) return void (this.failedToCreate = !0);
                            if (je.shaderSource(et, Je), je.compileShader(et), !je.getShaderParameter(et, je.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${je.getShaderInfoLog(et)}`);
                            je.attachShader(this.program, et), this.attributes = {};
                            let Mt = {};
                            this.numAttributes = Ot.length;
                            for(let Dt = 0; Dt < this.numAttributes; Dt++)Ot[Dt] && (je.bindAttribLocation(this.program, Dt, Ot[Dt]), this.attributes[Ot[Dt]] = Dt);
                            if (je.linkProgram(this.program), !je.getProgramParameter(this.program, je.LINK_STATUS)) throw new Error(`Program failed to link: ${je.getProgramInfoLog(this.program)}`);
                            je.deleteShader(et), je.deleteShader(He);
                            for(let Dt = 0; Dt < be.length; Dt++){
                                let Ut = be[Dt];
                                if (Ut && !Mt[Ut]) {
                                    let tr = je.getUniformLocation(this.program, Ut);
                                    tr && (Mt[Ut] = tr);
                                }
                            }
                            this.fixedUniforms = ee(w, Mt), this.terrainUniforms = ((Dt, Ut)=>({
                                    u_depth: new a.aH(Dt, Ut.u_depth),
                                    u_terrain: new a.aH(Dt, Ut.u_terrain),
                                    u_terrain_dim: new a.aI(Dt, Ut.u_terrain_dim),
                                    u_terrain_matrix: new a.aJ(Dt, Ut.u_terrain_matrix),
                                    u_terrain_unpack: new a.aK(Dt, Ut.u_terrain_unpack),
                                    u_terrain_exaggeration: new a.aI(Dt, Ut.u_terrain_exaggeration)
                                }))(w, Mt), this.binderUniforms = Q ? Q.getUniforms(w, Mt) : [];
                        }
                        draw(w, B, Q, ee, se, qe, je, it, yt, Ot, Nt, hr, Sr, he, be, Pe, Oe, Je) {
                            let He = w.gl;
                            if (this.failedToCreate) return;
                            if (w.program.set(this.program), w.setDepthMode(Q), w.setStencilMode(ee), w.setColorMode(se), w.setCullFace(qe), it) {
                                w.activeTexture.set(He.TEXTURE2), He.bindTexture(He.TEXTURE_2D, it.depthTexture), w.activeTexture.set(He.TEXTURE3), He.bindTexture(He.TEXTURE_2D, it.texture);
                                for(let Mt in this.terrainUniforms)this.terrainUniforms[Mt].set(it[Mt]);
                            }
                            for(let Mt in this.fixedUniforms)this.fixedUniforms[Mt].set(je[Mt]);
                            be && be.setUniforms(w, this.binderUniforms, Sr, {
                                zoom: he
                            });
                            let et = 0;
                            switch(B){
                                case He.LINES:
                                    et = 2;
                                    break;
                                case He.TRIANGLES:
                                    et = 3;
                                    break;
                                case He.LINE_STRIP:
                                    et = 1;
                            }
                            for (let Mt of hr.get()){
                                let Dt = Mt.vaos || (Mt.vaos = {});
                                (Dt[yt] || (Dt[yt] = new br)).bind(w, this, Ot, be ? be.getPaintVertexBuffers() : [], Nt, Mt.vertexOffset, Pe, Oe, Je), He.drawElements(B, Mt.primitiveLength * et, He.UNSIGNED_SHORT, Mt.primitiveOffset * et * 2);
                            }
                        }
                    }
                    function Yi(le, w, B) {
                        let Q = 1 / nn(B, 1, w.transform.tileZoom), ee = Math.pow(2, B.tileID.overscaledZ), se = B.tileSize * Math.pow(2, w.transform.tileZoom) / ee, qe = se * (B.tileID.canonical.x + B.tileID.wrap * ee), je = se * B.tileID.canonical.y;
                        return {
                            u_image: 0,
                            u_texsize: B.imageAtlasTexture.size,
                            u_scale: [
                                Q,
                                le.fromScale,
                                le.toScale
                            ],
                            u_fade: le.t,
                            u_pixel_coord_upper: [
                                qe >> 16,
                                je >> 16
                            ],
                            u_pixel_coord_lower: [
                                65535 & qe,
                                65535 & je
                            ]
                        };
                    }
                    let an = (le, w, B, Q)=>{
                        let ee = w.style.light, se = ee.properties.get("position"), qe = [
                            se.x,
                            se.y,
                            se.z
                        ], je = function() {
                            var yt = new a.A(9);
                            return a.A != Float32Array && (yt[1] = 0, yt[2] = 0, yt[3] = 0, yt[5] = 0, yt[6] = 0, yt[7] = 0), yt[0] = 1, yt[4] = 1, yt[8] = 1, yt;
                        }();
                        ee.properties.get("anchor") === "viewport" && function(yt, Ot) {
                            var Nt = Math.sin(Ot), hr = Math.cos(Ot);
                            yt[0] = hr, yt[1] = Nt, yt[2] = 0, yt[3] = -Nt, yt[4] = hr, yt[5] = 0, yt[6] = 0, yt[7] = 0, yt[8] = 1;
                        }(je, -w.transform.angle), function(yt, Ot, Nt) {
                            var hr = Ot[0], Sr = Ot[1], he = Ot[2];
                            yt[0] = hr * Nt[0] + Sr * Nt[3] + he * Nt[6], yt[1] = hr * Nt[1] + Sr * Nt[4] + he * Nt[7], yt[2] = hr * Nt[2] + Sr * Nt[5] + he * Nt[8];
                        }(qe, qe, je);
                        let it = ee.properties.get("color");
                        return {
                            u_matrix: le,
                            u_lightpos: qe,
                            u_lightintensity: ee.properties.get("intensity"),
                            u_lightcolor: [
                                it.r,
                                it.g,
                                it.b
                            ],
                            u_vertical_gradient: +B,
                            u_opacity: Q
                        };
                    }, hi = (le, w, B, Q, ee, se, qe)=>a.e(an(le, w, B, Q), Yi(se, w, qe), {
                            u_height_factor: -Math.pow(2, ee.overscaledZ) / qe.tileSize / 8
                        }), Ji = (le)=>({
                            u_matrix: le
                        }), ua = (le, w, B, Q)=>a.e(Ji(le), Yi(B, w, Q)), Fn = (le, w)=>({
                            u_matrix: le,
                            u_world: w
                        }), Sa = (le, w, B, Q, ee)=>a.e(ua(le, w, B, Q), {
                            u_world: ee
                        }), go = (le, w, B, Q)=>{
                        let ee = le.transform, se, qe;
                        if (Q.paint.get("circle-pitch-alignment") === "map") {
                            let je = nn(B, 1, ee.zoom);
                            se = !0, qe = [
                                je,
                                je
                            ];
                        } else se = !1, qe = ee.pixelsToGLUnits;
                        return {
                            u_camera_to_center_distance: ee.cameraToCenterDistance,
                            u_scale_with_map: +(Q.paint.get("circle-pitch-scale") === "map"),
                            u_matrix: le.translatePosMatrix(w.posMatrix, B, Q.paint.get("circle-translate"), Q.paint.get("circle-translate-anchor")),
                            u_pitch_with_map: +se,
                            u_device_pixel_ratio: le.pixelRatio,
                            u_extrude_scale: qe
                        };
                    }, Oo = (le, w, B)=>({
                            u_matrix: le,
                            u_inv_matrix: w,
                            u_camera_to_center_distance: B.cameraToCenterDistance,
                            u_viewport_size: [
                                B.width,
                                B.height
                            ]
                        }), ho = (le, w, B = 1)=>({
                            u_matrix: le,
                            u_color: w,
                            u_overlay: 0,
                            u_overlay_scale: B
                        }), Mo = (le)=>({
                            u_matrix: le
                        }), xo = (le, w, B, Q)=>({
                            u_matrix: le,
                            u_extrude_scale: nn(w, 1, B),
                            u_intensity: Q
                        }), zs = (le, w, B, Q)=>{
                        let ee = a.H();
                        a.aP(ee, 0, le.width, le.height, 0, 0, 1);
                        let se = le.context.gl;
                        return {
                            u_matrix: ee,
                            u_world: [
                                se.drawingBufferWidth,
                                se.drawingBufferHeight
                            ],
                            u_image: B,
                            u_color_ramp: Q,
                            u_opacity: w.paint.get("heatmap-opacity")
                        };
                    };
                    function ks(le, w) {
                        let B = Math.pow(2, w.canonical.z), Q = w.canonical.y;
                        return [
                            new a.Z(0, Q / B).toLngLat().lat,
                            new a.Z(0, (Q + 1) / B).toLngLat().lat
                        ];
                    }
                    let Zs = (le, w, B, Q)=>{
                        let ee = le.transform;
                        return {
                            u_matrix: Cs(le, w, B, Q),
                            u_ratio: 1 / nn(w, 1, ee.zoom),
                            u_device_pixel_ratio: le.pixelRatio,
                            u_units_to_pixels: [
                                1 / ee.pixelsToGLUnits[0],
                                1 / ee.pixelsToGLUnits[1]
                            ]
                        };
                    }, Xs = (le, w, B, Q, ee)=>a.e(Zs(le, w, B, ee), {
                            u_image: 0,
                            u_image_height: Q
                        }), wl = (le, w, B, Q, ee)=>{
                        let se = le.transform, qe = cl(w, se);
                        return {
                            u_matrix: Cs(le, w, B, ee),
                            u_texsize: w.imageAtlasTexture.size,
                            u_ratio: 1 / nn(w, 1, se.zoom),
                            u_device_pixel_ratio: le.pixelRatio,
                            u_image: 0,
                            u_scale: [
                                qe,
                                Q.fromScale,
                                Q.toScale
                            ],
                            u_fade: Q.t,
                            u_units_to_pixels: [
                                1 / se.pixelsToGLUnits[0],
                                1 / se.pixelsToGLUnits[1]
                            ]
                        };
                    }, os = (le, w, B, Q, ee, se)=>{
                        let qe = le.lineAtlas, je = cl(w, le.transform), it = B.layout.get("line-cap") === "round", yt = qe.getDash(Q.from, it), Ot = qe.getDash(Q.to, it), Nt = yt.width * ee.fromScale, hr = Ot.width * ee.toScale;
                        return a.e(Zs(le, w, B, se), {
                            u_patternscale_a: [
                                je / Nt,
                                -yt.height / 2
                            ],
                            u_patternscale_b: [
                                je / hr,
                                -Ot.height / 2
                            ],
                            u_sdfgamma: qe.width / (256 * Math.min(Nt, hr) * le.pixelRatio) / 2,
                            u_image: 0,
                            u_tex_y_a: yt.y,
                            u_tex_y_b: Ot.y,
                            u_mix: ee.t
                        });
                    };
                    function cl(le, w) {
                        return 1 / nn(le, 1, w.tileZoom);
                    }
                    function Cs(le, w, B, Q) {
                        return le.translatePosMatrix(Q ? Q.posMatrix : w.tileID.posMatrix, w, B.paint.get("line-translate"), B.paint.get("line-translate-anchor"));
                    }
                    let ml = (le, w, B, Q, ee)=>{
                        var se, qe;
                        return {
                            u_matrix: le,
                            u_tl_parent: w,
                            u_scale_parent: B,
                            u_buffer_scale: 1,
                            u_fade_t: Q.mix,
                            u_opacity: Q.opacity * ee.paint.get("raster-opacity"),
                            u_image0: 0,
                            u_image1: 1,
                            u_brightness_low: ee.paint.get("raster-brightness-min"),
                            u_brightness_high: ee.paint.get("raster-brightness-max"),
                            u_saturation_factor: (qe = ee.paint.get("raster-saturation"), qe > 0 ? 1 - 1 / (1.001 - qe) : -qe),
                            u_contrast_factor: (se = ee.paint.get("raster-contrast"), se > 0 ? 1 / (1 - se) : 1 + se),
                            u_spin_weights: Ys(ee.paint.get("raster-hue-rotate"))
                        };
                    };
                    function Ys(le) {
                        le *= Math.PI / 180;
                        let w = Math.sin(le), B = Math.cos(le);
                        return [
                            (2 * B + 1) / 3,
                            (-Math.sqrt(3) * w - B + 1) / 3,
                            (Math.sqrt(3) * w - B + 1) / 3
                        ];
                    }
                    let Hs = (le, w, B, Q, ee, se, qe, je, it, yt, Ot, Nt, hr, Sr)=>{
                        let he = qe.transform;
                        return {
                            u_is_size_zoom_constant: +(le === "constant" || le === "source"),
                            u_is_size_feature_constant: +(le === "constant" || le === "camera"),
                            u_size_t: w ? w.uSizeT : 0,
                            u_size: w ? w.uSize : 0,
                            u_camera_to_center_distance: he.cameraToCenterDistance,
                            u_pitch: he.pitch / 360 * 2 * Math.PI,
                            u_rotate_symbol: +B,
                            u_aspect_ratio: he.width / he.height,
                            u_fade_change: qe.options.fadeDuration ? qe.symbolFadeChange : 1,
                            u_matrix: je,
                            u_label_plane_matrix: it,
                            u_coord_matrix: yt,
                            u_is_text: +Nt,
                            u_pitch_with_map: +Q,
                            u_is_along_line: ee,
                            u_is_variable_anchor: se,
                            u_texsize: hr,
                            u_texture: 0,
                            u_translation: Ot,
                            u_pitched_scale: Sr
                        };
                    }, Eo = (le, w, B, Q, ee, se, qe, je, it, yt, Ot, Nt, hr, Sr, he)=>{
                        let be = qe.transform;
                        return a.e(Hs(le, w, B, Q, ee, se, qe, je, it, yt, Ot, Nt, hr, he), {
                            u_gamma_scale: Q ? Math.cos(be._pitch) * be.cameraToCenterDistance : 1,
                            u_device_pixel_ratio: qe.pixelRatio,
                            u_is_halo: +Sr
                        });
                    }, fs = (le, w, B, Q, ee, se, qe, je, it, yt, Ot, Nt, hr, Sr)=>a.e(Eo(le, w, B, Q, ee, se, qe, je, it, yt, Ot, !0, Nt, !0, Sr), {
                            u_texsize_icon: hr,
                            u_texture_icon: 1
                        }), Ql = (le, w, B)=>({
                            u_matrix: le,
                            u_opacity: w,
                            u_color: B
                        }), Hu = (le, w, B, Q, ee, se)=>a.e(function(qe, je, it, yt) {
                            let Ot = it.imageManager.getPattern(qe.from.toString()), Nt = it.imageManager.getPattern(qe.to.toString()), { width: hr, height: Sr } = it.imageManager.getPixelSize(), he = Math.pow(2, yt.tileID.overscaledZ), be = yt.tileSize * Math.pow(2, it.transform.tileZoom) / he, Pe = be * (yt.tileID.canonical.x + yt.tileID.wrap * he), Oe = be * yt.tileID.canonical.y;
                            return {
                                u_image: 0,
                                u_pattern_tl_a: Ot.tl,
                                u_pattern_br_a: Ot.br,
                                u_pattern_tl_b: Nt.tl,
                                u_pattern_br_b: Nt.br,
                                u_texsize: [
                                    hr,
                                    Sr
                                ],
                                u_mix: je.t,
                                u_pattern_size_a: Ot.displaySize,
                                u_pattern_size_b: Nt.displaySize,
                                u_scale_a: je.fromScale,
                                u_scale_b: je.toScale,
                                u_tile_units_to_pixels: 1 / nn(yt, 1, it.transform.tileZoom),
                                u_pixel_coord_upper: [
                                    Pe >> 16,
                                    Oe >> 16
                                ],
                                u_pixel_coord_lower: [
                                    65535 & Pe,
                                    65535 & Oe
                                ]
                            };
                        }(Q, se, B, ee), {
                            u_matrix: le,
                            u_opacity: w
                        }), fc = {
                        fillExtrusion: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_lightpos: new a.aN(le, w.u_lightpos),
                                u_lightintensity: new a.aI(le, w.u_lightintensity),
                                u_lightcolor: new a.aN(le, w.u_lightcolor),
                                u_vertical_gradient: new a.aI(le, w.u_vertical_gradient),
                                u_opacity: new a.aI(le, w.u_opacity)
                            }),
                        fillExtrusionPattern: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_lightpos: new a.aN(le, w.u_lightpos),
                                u_lightintensity: new a.aI(le, w.u_lightintensity),
                                u_lightcolor: new a.aN(le, w.u_lightcolor),
                                u_vertical_gradient: new a.aI(le, w.u_vertical_gradient),
                                u_height_factor: new a.aI(le, w.u_height_factor),
                                u_image: new a.aH(le, w.u_image),
                                u_texsize: new a.aO(le, w.u_texsize),
                                u_pixel_coord_upper: new a.aO(le, w.u_pixel_coord_upper),
                                u_pixel_coord_lower: new a.aO(le, w.u_pixel_coord_lower),
                                u_scale: new a.aN(le, w.u_scale),
                                u_fade: new a.aI(le, w.u_fade),
                                u_opacity: new a.aI(le, w.u_opacity)
                            }),
                        fill: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix)
                            }),
                        fillPattern: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_image: new a.aH(le, w.u_image),
                                u_texsize: new a.aO(le, w.u_texsize),
                                u_pixel_coord_upper: new a.aO(le, w.u_pixel_coord_upper),
                                u_pixel_coord_lower: new a.aO(le, w.u_pixel_coord_lower),
                                u_scale: new a.aN(le, w.u_scale),
                                u_fade: new a.aI(le, w.u_fade)
                            }),
                        fillOutline: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_world: new a.aO(le, w.u_world)
                            }),
                        fillOutlinePattern: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_world: new a.aO(le, w.u_world),
                                u_image: new a.aH(le, w.u_image),
                                u_texsize: new a.aO(le, w.u_texsize),
                                u_pixel_coord_upper: new a.aO(le, w.u_pixel_coord_upper),
                                u_pixel_coord_lower: new a.aO(le, w.u_pixel_coord_lower),
                                u_scale: new a.aN(le, w.u_scale),
                                u_fade: new a.aI(le, w.u_fade)
                            }),
                        circle: (le, w)=>({
                                u_camera_to_center_distance: new a.aI(le, w.u_camera_to_center_distance),
                                u_scale_with_map: new a.aH(le, w.u_scale_with_map),
                                u_pitch_with_map: new a.aH(le, w.u_pitch_with_map),
                                u_extrude_scale: new a.aO(le, w.u_extrude_scale),
                                u_device_pixel_ratio: new a.aI(le, w.u_device_pixel_ratio),
                                u_matrix: new a.aJ(le, w.u_matrix)
                            }),
                        collisionBox: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_pixel_extrude_scale: new a.aO(le, w.u_pixel_extrude_scale)
                            }),
                        collisionCircle: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_inv_matrix: new a.aJ(le, w.u_inv_matrix),
                                u_camera_to_center_distance: new a.aI(le, w.u_camera_to_center_distance),
                                u_viewport_size: new a.aO(le, w.u_viewport_size)
                            }),
                        debug: (le, w)=>({
                                u_color: new a.aL(le, w.u_color),
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_overlay: new a.aH(le, w.u_overlay),
                                u_overlay_scale: new a.aI(le, w.u_overlay_scale)
                            }),
                        clippingMask: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix)
                            }),
                        heatmap: (le, w)=>({
                                u_extrude_scale: new a.aI(le, w.u_extrude_scale),
                                u_intensity: new a.aI(le, w.u_intensity),
                                u_matrix: new a.aJ(le, w.u_matrix)
                            }),
                        heatmapTexture: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_world: new a.aO(le, w.u_world),
                                u_image: new a.aH(le, w.u_image),
                                u_color_ramp: new a.aH(le, w.u_color_ramp),
                                u_opacity: new a.aI(le, w.u_opacity)
                            }),
                        hillshade: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_image: new a.aH(le, w.u_image),
                                u_latrange: new a.aO(le, w.u_latrange),
                                u_light: new a.aO(le, w.u_light),
                                u_shadow: new a.aL(le, w.u_shadow),
                                u_highlight: new a.aL(le, w.u_highlight),
                                u_accent: new a.aL(le, w.u_accent)
                            }),
                        hillshadePrepare: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_image: new a.aH(le, w.u_image),
                                u_dimension: new a.aO(le, w.u_dimension),
                                u_zoom: new a.aI(le, w.u_zoom),
                                u_unpack: new a.aK(le, w.u_unpack)
                            }),
                        line: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_ratio: new a.aI(le, w.u_ratio),
                                u_device_pixel_ratio: new a.aI(le, w.u_device_pixel_ratio),
                                u_units_to_pixels: new a.aO(le, w.u_units_to_pixels)
                            }),
                        lineGradient: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_ratio: new a.aI(le, w.u_ratio),
                                u_device_pixel_ratio: new a.aI(le, w.u_device_pixel_ratio),
                                u_units_to_pixels: new a.aO(le, w.u_units_to_pixels),
                                u_image: new a.aH(le, w.u_image),
                                u_image_height: new a.aI(le, w.u_image_height)
                            }),
                        linePattern: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_texsize: new a.aO(le, w.u_texsize),
                                u_ratio: new a.aI(le, w.u_ratio),
                                u_device_pixel_ratio: new a.aI(le, w.u_device_pixel_ratio),
                                u_image: new a.aH(le, w.u_image),
                                u_units_to_pixels: new a.aO(le, w.u_units_to_pixels),
                                u_scale: new a.aN(le, w.u_scale),
                                u_fade: new a.aI(le, w.u_fade)
                            }),
                        lineSDF: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_ratio: new a.aI(le, w.u_ratio),
                                u_device_pixel_ratio: new a.aI(le, w.u_device_pixel_ratio),
                                u_units_to_pixels: new a.aO(le, w.u_units_to_pixels),
                                u_patternscale_a: new a.aO(le, w.u_patternscale_a),
                                u_patternscale_b: new a.aO(le, w.u_patternscale_b),
                                u_sdfgamma: new a.aI(le, w.u_sdfgamma),
                                u_image: new a.aH(le, w.u_image),
                                u_tex_y_a: new a.aI(le, w.u_tex_y_a),
                                u_tex_y_b: new a.aI(le, w.u_tex_y_b),
                                u_mix: new a.aI(le, w.u_mix)
                            }),
                        raster: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_tl_parent: new a.aO(le, w.u_tl_parent),
                                u_scale_parent: new a.aI(le, w.u_scale_parent),
                                u_buffer_scale: new a.aI(le, w.u_buffer_scale),
                                u_fade_t: new a.aI(le, w.u_fade_t),
                                u_opacity: new a.aI(le, w.u_opacity),
                                u_image0: new a.aH(le, w.u_image0),
                                u_image1: new a.aH(le, w.u_image1),
                                u_brightness_low: new a.aI(le, w.u_brightness_low),
                                u_brightness_high: new a.aI(le, w.u_brightness_high),
                                u_saturation_factor: new a.aI(le, w.u_saturation_factor),
                                u_contrast_factor: new a.aI(le, w.u_contrast_factor),
                                u_spin_weights: new a.aN(le, w.u_spin_weights)
                            }),
                        symbolIcon: (le, w)=>({
                                u_is_size_zoom_constant: new a.aH(le, w.u_is_size_zoom_constant),
                                u_is_size_feature_constant: new a.aH(le, w.u_is_size_feature_constant),
                                u_size_t: new a.aI(le, w.u_size_t),
                                u_size: new a.aI(le, w.u_size),
                                u_camera_to_center_distance: new a.aI(le, w.u_camera_to_center_distance),
                                u_pitch: new a.aI(le, w.u_pitch),
                                u_rotate_symbol: new a.aH(le, w.u_rotate_symbol),
                                u_aspect_ratio: new a.aI(le, w.u_aspect_ratio),
                                u_fade_change: new a.aI(le, w.u_fade_change),
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_label_plane_matrix: new a.aJ(le, w.u_label_plane_matrix),
                                u_coord_matrix: new a.aJ(le, w.u_coord_matrix),
                                u_is_text: new a.aH(le, w.u_is_text),
                                u_pitch_with_map: new a.aH(le, w.u_pitch_with_map),
                                u_is_along_line: new a.aH(le, w.u_is_along_line),
                                u_is_variable_anchor: new a.aH(le, w.u_is_variable_anchor),
                                u_texsize: new a.aO(le, w.u_texsize),
                                u_texture: new a.aH(le, w.u_texture),
                                u_translation: new a.aO(le, w.u_translation),
                                u_pitched_scale: new a.aI(le, w.u_pitched_scale)
                            }),
                        symbolSDF: (le, w)=>({
                                u_is_size_zoom_constant: new a.aH(le, w.u_is_size_zoom_constant),
                                u_is_size_feature_constant: new a.aH(le, w.u_is_size_feature_constant),
                                u_size_t: new a.aI(le, w.u_size_t),
                                u_size: new a.aI(le, w.u_size),
                                u_camera_to_center_distance: new a.aI(le, w.u_camera_to_center_distance),
                                u_pitch: new a.aI(le, w.u_pitch),
                                u_rotate_symbol: new a.aH(le, w.u_rotate_symbol),
                                u_aspect_ratio: new a.aI(le, w.u_aspect_ratio),
                                u_fade_change: new a.aI(le, w.u_fade_change),
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_label_plane_matrix: new a.aJ(le, w.u_label_plane_matrix),
                                u_coord_matrix: new a.aJ(le, w.u_coord_matrix),
                                u_is_text: new a.aH(le, w.u_is_text),
                                u_pitch_with_map: new a.aH(le, w.u_pitch_with_map),
                                u_is_along_line: new a.aH(le, w.u_is_along_line),
                                u_is_variable_anchor: new a.aH(le, w.u_is_variable_anchor),
                                u_texsize: new a.aO(le, w.u_texsize),
                                u_texture: new a.aH(le, w.u_texture),
                                u_gamma_scale: new a.aI(le, w.u_gamma_scale),
                                u_device_pixel_ratio: new a.aI(le, w.u_device_pixel_ratio),
                                u_is_halo: new a.aH(le, w.u_is_halo),
                                u_translation: new a.aO(le, w.u_translation),
                                u_pitched_scale: new a.aI(le, w.u_pitched_scale)
                            }),
                        symbolTextAndIcon: (le, w)=>({
                                u_is_size_zoom_constant: new a.aH(le, w.u_is_size_zoom_constant),
                                u_is_size_feature_constant: new a.aH(le, w.u_is_size_feature_constant),
                                u_size_t: new a.aI(le, w.u_size_t),
                                u_size: new a.aI(le, w.u_size),
                                u_camera_to_center_distance: new a.aI(le, w.u_camera_to_center_distance),
                                u_pitch: new a.aI(le, w.u_pitch),
                                u_rotate_symbol: new a.aH(le, w.u_rotate_symbol),
                                u_aspect_ratio: new a.aI(le, w.u_aspect_ratio),
                                u_fade_change: new a.aI(le, w.u_fade_change),
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_label_plane_matrix: new a.aJ(le, w.u_label_plane_matrix),
                                u_coord_matrix: new a.aJ(le, w.u_coord_matrix),
                                u_is_text: new a.aH(le, w.u_is_text),
                                u_pitch_with_map: new a.aH(le, w.u_pitch_with_map),
                                u_is_along_line: new a.aH(le, w.u_is_along_line),
                                u_is_variable_anchor: new a.aH(le, w.u_is_variable_anchor),
                                u_texsize: new a.aO(le, w.u_texsize),
                                u_texsize_icon: new a.aO(le, w.u_texsize_icon),
                                u_texture: new a.aH(le, w.u_texture),
                                u_texture_icon: new a.aH(le, w.u_texture_icon),
                                u_gamma_scale: new a.aI(le, w.u_gamma_scale),
                                u_device_pixel_ratio: new a.aI(le, w.u_device_pixel_ratio),
                                u_is_halo: new a.aH(le, w.u_is_halo),
                                u_translation: new a.aO(le, w.u_translation),
                                u_pitched_scale: new a.aI(le, w.u_pitched_scale)
                            }),
                        background: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_opacity: new a.aI(le, w.u_opacity),
                                u_color: new a.aL(le, w.u_color)
                            }),
                        backgroundPattern: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_opacity: new a.aI(le, w.u_opacity),
                                u_image: new a.aH(le, w.u_image),
                                u_pattern_tl_a: new a.aO(le, w.u_pattern_tl_a),
                                u_pattern_br_a: new a.aO(le, w.u_pattern_br_a),
                                u_pattern_tl_b: new a.aO(le, w.u_pattern_tl_b),
                                u_pattern_br_b: new a.aO(le, w.u_pattern_br_b),
                                u_texsize: new a.aO(le, w.u_texsize),
                                u_mix: new a.aI(le, w.u_mix),
                                u_pattern_size_a: new a.aO(le, w.u_pattern_size_a),
                                u_pattern_size_b: new a.aO(le, w.u_pattern_size_b),
                                u_scale_a: new a.aI(le, w.u_scale_a),
                                u_scale_b: new a.aI(le, w.u_scale_b),
                                u_pixel_coord_upper: new a.aO(le, w.u_pixel_coord_upper),
                                u_pixel_coord_lower: new a.aO(le, w.u_pixel_coord_lower),
                                u_tile_units_to_pixels: new a.aI(le, w.u_tile_units_to_pixels)
                            }),
                        terrain: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_texture: new a.aH(le, w.u_texture),
                                u_ele_delta: new a.aI(le, w.u_ele_delta),
                                u_fog_matrix: new a.aJ(le, w.u_fog_matrix),
                                u_fog_color: new a.aL(le, w.u_fog_color),
                                u_fog_ground_blend: new a.aI(le, w.u_fog_ground_blend),
                                u_fog_ground_blend_opacity: new a.aI(le, w.u_fog_ground_blend_opacity),
                                u_horizon_color: new a.aL(le, w.u_horizon_color),
                                u_horizon_fog_blend: new a.aI(le, w.u_horizon_fog_blend)
                            }),
                        terrainDepth: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_ele_delta: new a.aI(le, w.u_ele_delta)
                            }),
                        terrainCoords: (le, w)=>({
                                u_matrix: new a.aJ(le, w.u_matrix),
                                u_texture: new a.aH(le, w.u_texture),
                                u_terrain_coords_id: new a.aI(le, w.u_terrain_coords_id),
                                u_ele_delta: new a.aI(le, w.u_ele_delta)
                            }),
                        sky: (le, w)=>({
                                u_sky_color: new a.aL(le, w.u_sky_color),
                                u_horizon_color: new a.aL(le, w.u_horizon_color),
                                u_horizon: new a.aI(le, w.u_horizon),
                                u_sky_horizon_blend: new a.aI(le, w.u_sky_horizon_blend)
                            })
                    };
                    class ms {
                        constructor(w, B, Q){
                            this.context = w;
                            let ee = w.gl;
                            this.buffer = ee.createBuffer(), this.dynamicDraw = !!Q, this.context.unbindVAO(), w.bindElementBuffer.set(this.buffer), ee.bufferData(ee.ELEMENT_ARRAY_BUFFER, B.arrayBuffer, this.dynamicDraw ? ee.DYNAMIC_DRAW : ee.STATIC_DRAW), this.dynamicDraw || delete B.arrayBuffer;
                        }
                        bind() {
                            this.context.bindElementBuffer.set(this.buffer);
                        }
                        updateData(w) {
                            let B = this.context.gl;
                            if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                            this.context.unbindVAO(), this.bind(), B.bufferSubData(B.ELEMENT_ARRAY_BUFFER, 0, w.arrayBuffer);
                        }
                        destroy() {
                            this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
                        }
                    }
                    let on = {
                        Int8: "BYTE",
                        Uint8: "UNSIGNED_BYTE",
                        Int16: "SHORT",
                        Uint16: "UNSIGNED_SHORT",
                        Int32: "INT",
                        Uint32: "UNSIGNED_INT",
                        Float32: "FLOAT"
                    };
                    class fa {
                        constructor(w, B, Q, ee){
                            this.length = B.length, this.attributes = Q, this.itemSize = B.bytesPerElement, this.dynamicDraw = ee, this.context = w;
                            let se = w.gl;
                            this.buffer = se.createBuffer(), w.bindVertexBuffer.set(this.buffer), se.bufferData(se.ARRAY_BUFFER, B.arrayBuffer, this.dynamicDraw ? se.DYNAMIC_DRAW : se.STATIC_DRAW), this.dynamicDraw || delete B.arrayBuffer;
                        }
                        bind() {
                            this.context.bindVertexBuffer.set(this.buffer);
                        }
                        updateData(w) {
                            if (w.length !== this.length) throw new Error(`Length of new data is ${w.length}, which doesn't match current length of ${this.length}`);
                            let B = this.context.gl;
                            this.bind(), B.bufferSubData(B.ARRAY_BUFFER, 0, w.arrayBuffer);
                        }
                        enableAttributes(w, B) {
                            for(let Q = 0; Q < this.attributes.length; Q++){
                                let ee = B.attributes[this.attributes[Q].name];
                                ee !== void 0 && w.enableVertexAttribArray(ee);
                            }
                        }
                        setVertexAttribPointers(w, B, Q) {
                            for(let ee = 0; ee < this.attributes.length; ee++){
                                let se = this.attributes[ee], qe = B.attributes[se.name];
                                qe !== void 0 && w.vertexAttribPointer(qe, se.components, w[on[se.type]], !1, this.itemSize, se.offset + this.itemSize * (Q || 0));
                            }
                        }
                        destroy() {
                            this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
                        }
                    }
                    let Qu = new WeakMap;
                    function Rl(le) {
                        var w;
                        if (Qu.has(le)) return Qu.get(le);
                        {
                            let B = (w = le.getParameter(le.VERSION)) === null || w === void 0 ? void 0 : w.startsWith("WebGL 2.0");
                            return Qu.set(le, B), B;
                        }
                    }
                    class vo {
                        constructor(w){
                            this.gl = w.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
                        }
                        get() {
                            return this.current;
                        }
                        set(w) {}
                        getDefault() {
                            return this.default;
                        }
                        setDefault() {
                            this.set(this.default);
                        }
                    }
                    class Zl extends vo {
                        getDefault() {
                            return a.aM.transparent;
                        }
                        set(w) {
                            let B = this.current;
                            (w.r !== B.r || w.g !== B.g || w.b !== B.b || w.a !== B.a || this.dirty) && (this.gl.clearColor(w.r, w.g, w.b, w.a), this.current = w, this.dirty = !1);
                        }
                    }
                    class Ks extends vo {
                        getDefault() {
                            return 1;
                        }
                        set(w) {
                            (w !== this.current || this.dirty) && (this.gl.clearDepth(w), this.current = w, this.dirty = !1);
                        }
                    }
                    class Xl extends vo {
                        getDefault() {
                            return 0;
                        }
                        set(w) {
                            (w !== this.current || this.dirty) && (this.gl.clearStencil(w), this.current = w, this.dirty = !1);
                        }
                    }
                    class Ec extends vo {
                        getDefault() {
                            return [
                                !0,
                                !0,
                                !0,
                                !0
                            ];
                        }
                        set(w) {
                            let B = this.current;
                            (w[0] !== B[0] || w[1] !== B[1] || w[2] !== B[2] || w[3] !== B[3] || this.dirty) && (this.gl.colorMask(w[0], w[1], w[2], w[3]), this.current = w, this.dirty = !1);
                        }
                    }
                    class Zn extends vo {
                        getDefault() {
                            return !0;
                        }
                        set(w) {
                            (w !== this.current || this.dirty) && (this.gl.depthMask(w), this.current = w, this.dirty = !1);
                        }
                    }
                    class ko extends vo {
                        getDefault() {
                            return 255;
                        }
                        set(w) {
                            (w !== this.current || this.dirty) && (this.gl.stencilMask(w), this.current = w, this.dirty = !1);
                        }
                    }
                    class Co extends vo {
                        getDefault() {
                            return {
                                func: this.gl.ALWAYS,
                                ref: 0,
                                mask: 255
                            };
                        }
                        set(w) {
                            let B = this.current;
                            (w.func !== B.func || w.ref !== B.ref || w.mask !== B.mask || this.dirty) && (this.gl.stencilFunc(w.func, w.ref, w.mask), this.current = w, this.dirty = !1);
                        }
                    }
                    class Tl extends vo {
                        getDefault() {
                            let w = this.gl;
                            return [
                                w.KEEP,
                                w.KEEP,
                                w.KEEP
                            ];
                        }
                        set(w) {
                            let B = this.current;
                            (w[0] !== B[0] || w[1] !== B[1] || w[2] !== B[2] || this.dirty) && (this.gl.stencilOp(w[0], w[1], w[2]), this.current = w, this.dirty = !1);
                        }
                    }
                    class uf extends vo {
                        getDefault() {
                            return !1;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            w ? B.enable(B.STENCIL_TEST) : B.disable(B.STENCIL_TEST), this.current = w, this.dirty = !1;
                        }
                    }
                    class So extends vo {
                        getDefault() {
                            return [
                                0,
                                1
                            ];
                        }
                        set(w) {
                            let B = this.current;
                            (w[0] !== B[0] || w[1] !== B[1] || this.dirty) && (this.gl.depthRange(w[0], w[1]), this.current = w, this.dirty = !1);
                        }
                    }
                    class cf extends vo {
                        getDefault() {
                            return !1;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            w ? B.enable(B.DEPTH_TEST) : B.disable(B.DEPTH_TEST), this.current = w, this.dirty = !1;
                        }
                    }
                    class rh extends vo {
                        getDefault() {
                            return this.gl.LESS;
                        }
                        set(w) {
                            (w !== this.current || this.dirty) && (this.gl.depthFunc(w), this.current = w, this.dirty = !1);
                        }
                    }
                    class Al extends vo {
                        getDefault() {
                            return !1;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            w ? B.enable(B.BLEND) : B.disable(B.BLEND), this.current = w, this.dirty = !1;
                        }
                    }
                    class Hc extends vo {
                        getDefault() {
                            let w = this.gl;
                            return [
                                w.ONE,
                                w.ZERO
                            ];
                        }
                        set(w) {
                            let B = this.current;
                            (w[0] !== B[0] || w[1] !== B[1] || this.dirty) && (this.gl.blendFunc(w[0], w[1]), this.current = w, this.dirty = !1);
                        }
                    }
                    class eu extends vo {
                        getDefault() {
                            return a.aM.transparent;
                        }
                        set(w) {
                            let B = this.current;
                            (w.r !== B.r || w.g !== B.g || w.b !== B.b || w.a !== B.a || this.dirty) && (this.gl.blendColor(w.r, w.g, w.b, w.a), this.current = w, this.dirty = !1);
                        }
                    }
                    class Ls extends vo {
                        getDefault() {
                            return this.gl.FUNC_ADD;
                        }
                        set(w) {
                            (w !== this.current || this.dirty) && (this.gl.blendEquation(w), this.current = w, this.dirty = !1);
                        }
                    }
                    class mu extends vo {
                        getDefault() {
                            return !1;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            w ? B.enable(B.CULL_FACE) : B.disable(B.CULL_FACE), this.current = w, this.dirty = !1;
                        }
                    }
                    class kc extends vo {
                        getDefault() {
                            return this.gl.BACK;
                        }
                        set(w) {
                            (w !== this.current || this.dirty) && (this.gl.cullFace(w), this.current = w, this.dirty = !1);
                        }
                    }
                    class Of extends vo {
                        getDefault() {
                            return this.gl.CCW;
                        }
                        set(w) {
                            (w !== this.current || this.dirty) && (this.gl.frontFace(w), this.current = w, this.dirty = !1);
                        }
                    }
                    class Gc extends vo {
                        getDefault() {
                            return null;
                        }
                        set(w) {
                            (w !== this.current || this.dirty) && (this.gl.useProgram(w), this.current = w, this.dirty = !1);
                        }
                    }
                    class vd extends vo {
                        getDefault() {
                            return this.gl.TEXTURE0;
                        }
                        set(w) {
                            (w !== this.current || this.dirty) && (this.gl.activeTexture(w), this.current = w, this.dirty = !1);
                        }
                    }
                    class Bf extends vo {
                        getDefault() {
                            let w = this.gl;
                            return [
                                0,
                                0,
                                w.drawingBufferWidth,
                                w.drawingBufferHeight
                            ];
                        }
                        set(w) {
                            let B = this.current;
                            (w[0] !== B[0] || w[1] !== B[1] || w[2] !== B[2] || w[3] !== B[3] || this.dirty) && (this.gl.viewport(w[0], w[1], w[2], w[3]), this.current = w, this.dirty = !1);
                        }
                    }
                    class ss extends vo {
                        getDefault() {
                            return null;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            B.bindFramebuffer(B.FRAMEBUFFER, w), this.current = w, this.dirty = !1;
                        }
                    }
                    class ff extends vo {
                        getDefault() {
                            return null;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            B.bindRenderbuffer(B.RENDERBUFFER, w), this.current = w, this.dirty = !1;
                        }
                    }
                    class ih extends vo {
                        getDefault() {
                            return null;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            B.bindTexture(B.TEXTURE_2D, w), this.current = w, this.dirty = !1;
                        }
                    }
                    class Vl extends vo {
                        getDefault() {
                            return null;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            B.bindBuffer(B.ARRAY_BUFFER, w), this.current = w, this.dirty = !1;
                        }
                    }
                    class Js extends vo {
                        getDefault() {
                            return null;
                        }
                        set(w) {
                            let B = this.gl;
                            B.bindBuffer(B.ELEMENT_ARRAY_BUFFER, w), this.current = w, this.dirty = !1;
                        }
                    }
                    class hc extends vo {
                        getDefault() {
                            return null;
                        }
                        set(w) {
                            var B;
                            if (w === this.current && !this.dirty) return;
                            let Q = this.gl;
                            Rl(Q) ? Q.bindVertexArray(w) : (B = Q.getExtension("OES_vertex_array_object")) === null || B === void 0 || B.bindVertexArrayOES(w), this.current = w, this.dirty = !1;
                        }
                    }
                    class Cc extends vo {
                        getDefault() {
                            return 4;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            B.pixelStorei(B.UNPACK_ALIGNMENT, w), this.current = w, this.dirty = !1;
                        }
                    }
                    class ws extends vo {
                        getDefault() {
                            return !1;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            B.pixelStorei(B.UNPACK_PREMULTIPLY_ALPHA_WEBGL, w), this.current = w, this.dirty = !1;
                        }
                    }
                    class $s extends vo {
                        getDefault() {
                            return !1;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            let B = this.gl;
                            B.pixelStorei(B.UNPACK_FLIP_Y_WEBGL, w), this.current = w, this.dirty = !1;
                        }
                    }
                    class hs extends vo {
                        constructor(w, B){
                            super(w), this.context = w, this.parent = B;
                        }
                        getDefault() {
                            return null;
                        }
                    }
                    class Ms extends hs {
                        setDirty() {
                            this.dirty = !0;
                        }
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            this.context.bindFramebuffer.set(this.parent);
                            let B = this.gl;
                            B.framebufferTexture2D(B.FRAMEBUFFER, B.COLOR_ATTACHMENT0, B.TEXTURE_2D, w, 0), this.current = w, this.dirty = !1;
                        }
                    }
                    class dc extends hs {
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            this.context.bindFramebuffer.set(this.parent);
                            let B = this.gl;
                            B.framebufferRenderbuffer(B.FRAMEBUFFER, B.DEPTH_ATTACHMENT, B.RENDERBUFFER, w), this.current = w, this.dirty = !1;
                        }
                    }
                    class Sl extends hs {
                        set(w) {
                            if (w === this.current && !this.dirty) return;
                            this.context.bindFramebuffer.set(this.parent);
                            let B = this.gl;
                            B.framebufferRenderbuffer(B.FRAMEBUFFER, B.DEPTH_STENCIL_ATTACHMENT, B.RENDERBUFFER, w), this.current = w, this.dirty = !1;
                        }
                    }
                    class ec {
                        constructor(w, B, Q, ee, se){
                            this.context = w, this.width = B, this.height = Q;
                            let qe = w.gl, je = this.framebuffer = qe.createFramebuffer();
                            if (this.colorAttachment = new Ms(w, je), ee) this.depthAttachment = se ? new Sl(w, je) : new dc(w, je);
                            else if (se) throw new Error("Stencil cannot be set without depth");
                            if (qe.checkFramebufferStatus(qe.FRAMEBUFFER) !== qe.FRAMEBUFFER_COMPLETE) throw new Error("Framebuffer is not complete");
                        }
                        destroy() {
                            let w = this.context.gl, B = this.colorAttachment.get();
                            if (B && w.deleteTexture(B), this.depthAttachment) {
                                let Q = this.depthAttachment.get();
                                Q && w.deleteRenderbuffer(Q);
                            }
                            w.deleteFramebuffer(this.framebuffer);
                        }
                    }
                    class Ps {
                        constructor(w, B, Q){
                            this.blendFunction = w, this.blendColor = B, this.mask = Q;
                        }
                    }
                    Ps.Replace = [
                        1,
                        0
                    ], Ps.disabled = new Ps(Ps.Replace, a.aM.transparent, [
                        !1,
                        !1,
                        !1,
                        !1
                    ]), Ps.unblended = new Ps(Ps.Replace, a.aM.transparent, [
                        !0,
                        !0,
                        !0,
                        !0
                    ]), Ps.alphaBlended = new Ps([
                        1,
                        771
                    ], a.aM.transparent, [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                    class ov {
                        constructor(w){
                            var B, Q;
                            if (this.gl = w, this.clearColor = new Zl(this), this.clearDepth = new Ks(this), this.clearStencil = new Xl(this), this.colorMask = new Ec(this), this.depthMask = new Zn(this), this.stencilMask = new ko(this), this.stencilFunc = new Co(this), this.stencilOp = new Tl(this), this.stencilTest = new uf(this), this.depthRange = new So(this), this.depthTest = new cf(this), this.depthFunc = new rh(this), this.blend = new Al(this), this.blendFunc = new Hc(this), this.blendColor = new eu(this), this.blendEquation = new Ls(this), this.cullFace = new mu(this), this.cullFaceSide = new kc(this), this.frontFace = new Of(this), this.program = new Gc(this), this.activeTexture = new vd(this), this.viewport = new Bf(this), this.bindFramebuffer = new ss(this), this.bindRenderbuffer = new ff(this), this.bindTexture = new ih(this), this.bindVertexBuffer = new Vl(this), this.bindElementBuffer = new Js(this), this.bindVertexArray = new hc(this), this.pixelStoreUnpack = new Cc(this), this.pixelStoreUnpackPremultiplyAlpha = new ws(this), this.pixelStoreUnpackFlipY = new $s(this), this.extTextureFilterAnisotropic = w.getExtension("EXT_texture_filter_anisotropic") || w.getExtension("MOZ_EXT_texture_filter_anisotropic") || w.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = w.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = w.getParameter(w.MAX_TEXTURE_SIZE), Rl(w)) {
                                this.HALF_FLOAT = w.HALF_FLOAT;
                                let ee = w.getExtension("EXT_color_buffer_half_float");
                                this.RGBA16F = (B = w.RGBA16F) !== null && B !== void 0 ? B : ee == null ? void 0 : ee.RGBA16F_EXT, this.RGB16F = (Q = w.RGB16F) !== null && Q !== void 0 ? Q : ee == null ? void 0 : ee.RGB16F_EXT, w.getExtension("EXT_color_buffer_float");
                            } else {
                                w.getExtension("EXT_color_buffer_half_float"), w.getExtension("OES_texture_half_float_linear");
                                let ee = w.getExtension("OES_texture_half_float");
                                this.HALF_FLOAT = ee == null ? void 0 : ee.HALF_FLOAT_OES;
                            }
                        }
                        setDefault() {
                            this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
                        }
                        setDirty() {
                            this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
                        }
                        createIndexBuffer(w, B) {
                            return new ms(this, w, B);
                        }
                        createVertexBuffer(w, B, Q) {
                            return new fa(this, w, B, Q);
                        }
                        createRenderbuffer(w, B, Q) {
                            let ee = this.gl, se = ee.createRenderbuffer();
                            return this.bindRenderbuffer.set(se), ee.renderbufferStorage(ee.RENDERBUFFER, w, B, Q), this.bindRenderbuffer.set(null), se;
                        }
                        createFramebuffer(w, B, Q, ee) {
                            return new ec(this, w, B, Q, ee);
                        }
                        clear({ color: w, depth: B, stencil: Q }) {
                            let ee = this.gl, se = 0;
                            w && (se |= ee.COLOR_BUFFER_BIT, this.clearColor.set(w), this.colorMask.set([
                                !0,
                                !0,
                                !0,
                                !0
                            ])), B !== void 0 && (se |= ee.DEPTH_BUFFER_BIT, this.depthRange.set([
                                0,
                                1
                            ]), this.clearDepth.set(B), this.depthMask.set(!0)), Q !== void 0 && (se |= ee.STENCIL_BUFFER_BIT, this.clearStencil.set(Q), this.stencilMask.set(255)), ee.clear(se);
                        }
                        setCullFace(w) {
                            w.enable === !1 ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(w.mode), this.frontFace.set(w.frontFace));
                        }
                        setDepthMode(w) {
                            w.func !== this.gl.ALWAYS || w.mask ? (this.depthTest.set(!0), this.depthFunc.set(w.func), this.depthMask.set(w.mask), this.depthRange.set(w.range)) : this.depthTest.set(!1);
                        }
                        setStencilMode(w) {
                            w.test.func !== this.gl.ALWAYS || w.mask ? (this.stencilTest.set(!0), this.stencilMask.set(w.mask), this.stencilOp.set([
                                w.fail,
                                w.depthFail,
                                w.pass
                            ]), this.stencilFunc.set({
                                func: w.test.func,
                                ref: w.ref,
                                mask: w.test.mask
                            })) : this.stencilTest.set(!1);
                        }
                        setColorMode(w) {
                            a.aE(w.blendFunction, Ps.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(w.blendFunction), this.blendColor.set(w.blendColor)), this.colorMask.set(w.mask);
                        }
                        createVertexArray() {
                            var w;
                            return Rl(this.gl) ? this.gl.createVertexArray() : (w = this.gl.getExtension("OES_vertex_array_object")) === null || w === void 0 ? void 0 : w.createVertexArrayOES();
                        }
                        deleteVertexArray(w) {
                            var B;
                            return Rl(this.gl) ? this.gl.deleteVertexArray(w) : (B = this.gl.getExtension("OES_vertex_array_object")) === null || B === void 0 ? void 0 : B.deleteVertexArrayOES(w);
                        }
                        unbindVAO() {
                            this.bindVertexArray.set(null);
                        }
                    }
                    class wo {
                        constructor(w, B, Q){
                            this.func = w, this.mask = B, this.range = Q;
                        }
                    }
                    wo.ReadOnly = !1, wo.ReadWrite = !0, wo.disabled = new wo(519, wo.ReadOnly, [
                        0,
                        1
                    ]);
                    let Od = 7680;
                    class $o {
                        constructor(w, B, Q, ee, se, qe){
                            this.test = w, this.ref = B, this.mask = Q, this.fail = ee, this.depthFail = se, this.pass = qe;
                        }
                    }
                    $o.disabled = new $o({
                        func: 519,
                        mask: 0
                    }, 0, 0, Od, Od, Od);
                    class Ja {
                        constructor(w, B, Q){
                            this.enable = w, this.mode = B, this.frontFace = Q;
                        }
                    }
                    let Ef;
                    function tc(le, w, B, Q, ee) {
                        let se = le.context, qe = se.gl, je = le.useProgram("collisionBox"), it = [], yt = 0, Ot = 0;
                        for(let Oe = 0; Oe < Q.length; Oe++){
                            let Je = Q[Oe], He = w.getTile(Je).getBucket(B);
                            if (!He) continue;
                            let et = ee ? He.textCollisionBox : He.iconCollisionBox, Mt = He.collisionCircleArray;
                            if (Mt.length > 0) {
                                let Dt = a.H();
                                a.aQ(Dt, He.placementInvProjMatrix, le.transform.glCoordMatrix), a.aQ(Dt, Dt, He.placementViewportMatrix), it.push({
                                    circleArray: Mt,
                                    circleOffset: Ot,
                                    transform: Je.posMatrix,
                                    invTransform: Dt,
                                    coord: Je
                                }), yt += Mt.length / 4, Ot = yt;
                            }
                            et && je.draw(se, qe.LINES, wo.disabled, $o.disabled, le.colorModeForRenderPass(), Ja.disabled, {
                                u_matrix: Je.posMatrix,
                                u_pixel_extrude_scale: [
                                    1 / (Nt = le.transform).width,
                                    1 / Nt.height
                                ]
                            }, le.style.map.terrain && le.style.map.terrain.getTerrainData(Je), B.id, et.layoutVertexBuffer, et.indexBuffer, et.segments, null, le.transform.zoom, null, null, et.collisionVertexBuffer);
                        }
                        var Nt;
                        if (!ee || !it.length) return;
                        let hr = le.useProgram("collisionCircle"), Sr = new a.aR;
                        Sr.resize(4 * yt), Sr._trim();
                        let he = 0;
                        for (let Oe of it)for(let Je = 0; Je < Oe.circleArray.length / 4; Je++){
                            let He = 4 * Je, et = Oe.circleArray[He + 0], Mt = Oe.circleArray[He + 1], Dt = Oe.circleArray[He + 2], Ut = Oe.circleArray[He + 3];
                            Sr.emplace(he++, et, Mt, Dt, Ut, 0), Sr.emplace(he++, et, Mt, Dt, Ut, 1), Sr.emplace(he++, et, Mt, Dt, Ut, 2), Sr.emplace(he++, et, Mt, Dt, Ut, 3);
                        }
                        (!Ef || Ef.length < 2 * yt) && (Ef = function(Oe) {
                            let Je = 2 * Oe, He = new a.aT;
                            He.resize(Je), He._trim();
                            for(let et = 0; et < Je; et++){
                                let Mt = 6 * et;
                                He.uint16[Mt + 0] = 4 * et + 0, He.uint16[Mt + 1] = 4 * et + 1, He.uint16[Mt + 2] = 4 * et + 2, He.uint16[Mt + 3] = 4 * et + 2, He.uint16[Mt + 4] = 4 * et + 3, He.uint16[Mt + 5] = 4 * et + 0;
                            }
                            return He;
                        }(yt));
                        let be = se.createIndexBuffer(Ef, !0), Pe = se.createVertexBuffer(Sr, a.aS.members, !0);
                        for (let Oe of it){
                            let Je = Oo(Oe.transform, Oe.invTransform, le.transform);
                            hr.draw(se, qe.TRIANGLES, wo.disabled, $o.disabled, le.colorModeForRenderPass(), Ja.disabled, Je, le.style.map.terrain && le.style.map.terrain.getTerrainData(Oe.coord), B.id, Pe, be, a.a0.simpleSegment(0, 2 * Oe.circleOffset, Oe.circleArray.length, Oe.circleArray.length / 2), null, le.transform.zoom, null, null, null);
                        }
                        Pe.destroy(), be.destroy();
                    }
                    Ja.disabled = new Ja(!1, 1029, 2305), Ja.backCCW = new Ja(!0, 1029, 2305);
                    let uu = a.an(new Float32Array(16));
                    function Mh(le, w, B, Q, ee, se) {
                        let { horizontalAlign: qe, verticalAlign: je } = a.au(le);
                        return new a.P((-(qe - .5) * w / ee + Q[0]) * se, (-(je - .5) * B / ee + Q[1]) * se);
                    }
                    function jc(le, w, B, Q, ee, se) {
                        let qe = w.tileAnchorPoint.add(new a.P(w.translation[0], w.translation[1]));
                        if (w.pitchWithMap) {
                            let je = Q.mult(se);
                            B || (je = je.rotate(-ee));
                            let it = qe.add(je);
                            return ut(it.x, it.y, w.labelPlaneMatrix, w.getElevation).point;
                        }
                        if (B) {
                            let je = lt(w.tileAnchorPoint.x + 1, w.tileAnchorPoint.y, w).point.sub(le), it = Math.atan(je.y / je.x) + (je.x < 0 ? Math.PI : 0);
                            return le.add(Q.rotate(it));
                        }
                        return le.add(Q);
                    }
                    function kf(le, w, B, Q, ee, se, qe, je, it, yt, Ot, Nt, hr, Sr) {
                        let he = le.text.placedSymbolArray, be = le.text.dynamicLayoutVertexArray, Pe = le.icon.dynamicLayoutVertexArray, Oe = {};
                        be.clear();
                        for(let Je = 0; Je < he.length; Je++){
                            let He = he.get(Je), et = He.hidden || !He.crossTileID || le.allowVerticalPlacement && !He.placedOrientation ? null : Q[He.crossTileID];
                            if (et) {
                                let Mt = new a.P(He.anchorX, He.anchorY), Dt = {
                                    getElevation: Sr,
                                    width: ee.width,
                                    height: ee.height,
                                    labelPlaneMatrix: se,
                                    lineVertexArray: null,
                                    pitchWithMap: B,
                                    projection: Ot,
                                    projectionCache: null,
                                    tileAnchorPoint: Mt,
                                    translation: Nt,
                                    unwrappedTileID: hr
                                }, Ut = B ? ut(Mt.x, Mt.y, qe, Sr) : lt(Mt.x, Mt.y, Dt), tr = Ne(ee.cameraToCenterDistance, Ut.signedDistanceFromCamera), mr = a.ai(le.textSizeData, it, He) * tr / a.ap;
                                B && (mr *= le.tilePixelRatio / je);
                                let { width: Rr, height: zr, anchor: Xr, textOffset: di, textBoxScale: Li } = et, Ci = Mh(Xr, Rr, zr, di, Li, mr), Qi = Ot.getPitchedTextCorrection(ee, Mt.add(new a.P(Nt[0], Nt[1])), hr), Mn = jc(Ut.point, Dt, w, Ci, ee.angle, Qi), pa = le.allowVerticalPlacement && He.placedOrientation === a.ah.vertical ? Math.PI / 2 : 0;
                                for(let ea = 0; ea < He.numGlyphs; ea++)a.aj(be, Mn, pa);
                                yt && He.associatedIconIndex >= 0 && (Oe[He.associatedIconIndex] = {
                                    shiftedAnchor: Mn,
                                    angle: pa
                                });
                            } else ai(He.numGlyphs, be);
                        }
                        if (yt) {
                            Pe.clear();
                            let Je = le.icon.placedSymbolArray;
                            for(let He = 0; He < Je.length; He++){
                                let et = Je.get(He);
                                if (et.hidden) ai(et.numGlyphs, Pe);
                                else {
                                    let Mt = Oe[He];
                                    if (Mt) for(let Dt = 0; Dt < et.numGlyphs; Dt++)a.aj(Pe, Mt.shiftedAnchor, Mt.angle);
                                    else ai(et.numGlyphs, Pe);
                                }
                            }
                            le.icon.dynamicLayoutVertexBuffer.updateData(Pe);
                        }
                        le.text.dynamicLayoutVertexBuffer.updateData(be);
                    }
                    function Ml(le, w, B) {
                        return B.iconsInText && w ? "symbolTextAndIcon" : le ? "symbolSDF" : "symbolIcon";
                    }
                    function Yh(le, w, B, Q, ee, se, qe, je, it, yt, Ot, Nt) {
                        let hr = le.context, Sr = hr.gl, he = le.transform, be = Gi(), Pe = je === "map", Oe = it === "map", Je = je !== "viewport" && B.layout.get("symbol-placement") !== "point", He = Pe && !Oe && !Je, et = !Oe && Je, Mt = !B.layout.get("symbol-sort-key").isConstant(), Dt = !1, Ut = le.depthModeForSublayer(0, wo.ReadOnly), tr = B._unevaluatedLayout.hasValue("text-variable-anchor") || B._unevaluatedLayout.hasValue("text-variable-anchor-offset"), mr = [], Rr = be.getCircleRadiusCorrection(he);
                        for (let zr of Q){
                            let Xr = w.getTile(zr), di = Xr.getBucket(B);
                            if (!di) continue;
                            let Li = ee ? di.text : di.icon;
                            if (!Li || !Li.segments.get().length || !Li.hasVisibleVertices) continue;
                            let Ci = Li.programConfigurations.get(B.id), Qi = ee || di.sdfIcons, Mn = ee ? di.textSizeData : di.iconSizeData, pa = Oe || he.pitch !== 0, ea = le.useProgram(Ml(Qi, ee, di), Ci), Ga = a.ag(Mn, he.zoom), To = le.style.map.terrain && le.style.map.terrain.getTerrainData(zr), Wa, co, Ro, Ds, As = [
                                0,
                                0
                            ], yo = null;
                            if (ee) co = Xr.glyphAtlasTexture, Ro = Sr.LINEAR, Wa = Xr.glyphAtlasTexture.size, di.iconsInText && (As = Xr.imageAtlasTexture.size, yo = Xr.imageAtlasTexture, Ds = pa || le.options.rotating || le.options.zooming || Mn.kind === "composite" || Mn.kind === "camera" ? Sr.LINEAR : Sr.NEAREST);
                            else {
                                let We = B.layout.get("icon-size").constantOr(0) !== 1 || di.iconsNeedLinear;
                                co = Xr.imageAtlasTexture, Ro = Qi || le.options.rotating || le.options.zooming || We || pa ? Sr.LINEAR : Sr.NEAREST, Wa = Xr.imageAtlasTexture.size;
                            }
                            let po = nn(Xr, 1, le.transform.zoom), _l = et ? zr.posMatrix : uu, Hl = Or(_l, Oe, Pe, le.transform, po), Zu = Nr(_l, Oe, Pe, le.transform, po), cu = Nr(zr.posMatrix, Oe, Pe, le.transform, po), el = be.translatePosition(le.transform, Xr, se, qe), au = tr && di.hasTextData(), zc = B.layout.get("icon-text-fit") !== "none" && au && di.hasIconData();
                            if (Je) {
                                let We = le.style.map.terrain ? (tt, zt)=>le.style.map.terrain.getElevation(zr, tt, zt) : null, wt = B.layout.get("text-rotation-alignment") === "map";
                                Ve(di, zr.posMatrix, le, ee, Hl, cu, Oe, yt, wt, be, zr.toUnwrapped(), he.width, he.height, el, We);
                            }
                            let zl = zr.posMatrix, Fl = ee && tr || zc, Z = Je || Fl ? uu : Hl, oe = Zu, we = Qi && B.paint.get(ee ? "text-halo-width" : "icon-halo-width").constantOr(1) !== 0, Be;
                            Be = Qi ? di.iconsInText ? fs(Mn.kind, Ga, He, Oe, Je, Fl, le, zl, Z, oe, el, Wa, As, Rr) : Eo(Mn.kind, Ga, He, Oe, Je, Fl, le, zl, Z, oe, el, ee, Wa, !0, Rr) : Hs(Mn.kind, Ga, He, Oe, Je, Fl, le, zl, Z, oe, el, ee, Wa, Rr);
                            let Ue = {
                                program: ea,
                                buffers: Li,
                                uniformValues: Be,
                                atlasTexture: co,
                                atlasTextureIcon: yo,
                                atlasInterpolation: Ro,
                                atlasInterpolationIcon: Ds,
                                isSDF: Qi,
                                hasHalo: we
                            };
                            if (Mt && di.canOverlap) {
                                Dt = !0;
                                let We = Li.segments.get();
                                for (let wt of We)mr.push({
                                    segments: new a.a0([
                                        wt
                                    ]),
                                    sortKey: wt.sortKey,
                                    state: Ue,
                                    terrainData: To
                                });
                            } else mr.push({
                                segments: Li.segments,
                                sortKey: 0,
                                state: Ue,
                                terrainData: To
                            });
                        }
                        Dt && mr.sort((zr, Xr)=>zr.sortKey - Xr.sortKey);
                        for (let zr of mr){
                            let Xr = zr.state;
                            if (hr.activeTexture.set(Sr.TEXTURE0), Xr.atlasTexture.bind(Xr.atlasInterpolation, Sr.CLAMP_TO_EDGE), Xr.atlasTextureIcon && (hr.activeTexture.set(Sr.TEXTURE1), Xr.atlasTextureIcon && Xr.atlasTextureIcon.bind(Xr.atlasInterpolationIcon, Sr.CLAMP_TO_EDGE)), Xr.isSDF) {
                                let di = Xr.uniformValues;
                                Xr.hasHalo && (di.u_is_halo = 1, Eh(Xr.buffers, zr.segments, B, le, Xr.program, Ut, Ot, Nt, di, zr.terrainData)), di.u_is_halo = 0;
                            }
                            Eh(Xr.buffers, zr.segments, B, le, Xr.program, Ut, Ot, Nt, Xr.uniformValues, zr.terrainData);
                        }
                    }
                    function Eh(le, w, B, Q, ee, se, qe, je, it, yt) {
                        let Ot = Q.context;
                        ee.draw(Ot, Ot.gl.TRIANGLES, se, qe, je, Ja.disabled, it, yt, B.id, le.layoutVertexBuffer, le.indexBuffer, w, B.paint, Q.transform.zoom, le.programConfigurations.get(B.id), le.dynamicLayoutVertexBuffer, le.opacityVertexBuffer);
                    }
                    function nh(le, w, B, Q) {
                        let ee = le.context, se = ee.gl, qe = $o.disabled, je = new Ps([
                            se.ONE,
                            se.ONE
                        ], a.aM.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), it = w.getBucket(B);
                        if (!it) return;
                        let yt = Q.key, Ot = B.heatmapFbos.get(yt);
                        Ot || (Ot = kh(ee, w.tileSize, w.tileSize), B.heatmapFbos.set(yt, Ot)), ee.bindFramebuffer.set(Ot.framebuffer), ee.viewport.set([
                            0,
                            0,
                            w.tileSize,
                            w.tileSize
                        ]), ee.clear({
                            color: a.aM.transparent
                        });
                        let Nt = it.programConfigurations.get(B.id), hr = le.useProgram("heatmap", Nt), Sr = le.style.map.terrain.getTerrainData(Q);
                        hr.draw(ee, se.TRIANGLES, wo.disabled, qe, je, Ja.disabled, xo(Q.posMatrix, w, le.transform.zoom, B.paint.get("heatmap-intensity")), Sr, B.id, it.layoutVertexBuffer, it.indexBuffer, it.segments, B.paint, le.transform.zoom, Nt);
                    }
                    function hf(le, w, B) {
                        let Q = le.context, ee = Q.gl;
                        Q.setColorMode(le.colorModeForRenderPass());
                        let se = Kh(Q, w), qe = B.key, je = w.heatmapFbos.get(qe);
                        je && (Q.activeTexture.set(ee.TEXTURE0), ee.bindTexture(ee.TEXTURE_2D, je.colorAttachment.get()), Q.activeTexture.set(ee.TEXTURE1), se.bind(ee.LINEAR, ee.CLAMP_TO_EDGE), le.useProgram("heatmapTexture").draw(Q, ee.TRIANGLES, wo.disabled, $o.disabled, le.colorModeForRenderPass(), Ja.disabled, zs(le, w, 0, 1), null, w.id, le.rasterBoundsBuffer, le.quadTriangleIndexBuffer, le.rasterBoundsSegments, w.paint, le.transform.zoom), je.destroy(), w.heatmapFbos.delete(qe));
                    }
                    function kh(le, w, B) {
                        var Q, ee;
                        let se = le.gl, qe = se.createTexture();
                        se.bindTexture(se.TEXTURE_2D, qe), se.texParameteri(se.TEXTURE_2D, se.TEXTURE_WRAP_S, se.CLAMP_TO_EDGE), se.texParameteri(se.TEXTURE_2D, se.TEXTURE_WRAP_T, se.CLAMP_TO_EDGE), se.texParameteri(se.TEXTURE_2D, se.TEXTURE_MIN_FILTER, se.LINEAR), se.texParameteri(se.TEXTURE_2D, se.TEXTURE_MAG_FILTER, se.LINEAR);
                        let je = (Q = le.HALF_FLOAT) !== null && Q !== void 0 ? Q : se.UNSIGNED_BYTE, it = (ee = le.RGBA16F) !== null && ee !== void 0 ? ee : se.RGBA;
                        se.texImage2D(se.TEXTURE_2D, 0, it, w, B, 0, se.RGBA, je, null);
                        let yt = le.createFramebuffer(w, B, !1, !1);
                        return yt.colorAttachment.set(qe), yt;
                    }
                    function Kh(le, w) {
                        return w.colorRampTexture || (w.colorRampTexture = new g(le, w.colorRamp, le.gl.RGBA)), w.colorRampTexture;
                    }
                    function rc(le, w, B, Q, ee) {
                        if (!B || !Q || !Q.imageAtlas) return;
                        let se = Q.imageAtlas.patternPositions, qe = se[B.to.toString()], je = se[B.from.toString()];
                        if (!qe && je && (qe = je), !je && qe && (je = qe), !qe || !je) {
                            let it = ee.getPaintProperty(w);
                            qe = se[it], je = se[it];
                        }
                        qe && je && le.setConstantPatternPositions(qe, je);
                    }
                    function ah(le, w, B, Q, ee, se, qe) {
                        let je = le.context.gl, it = "fill-pattern", yt = B.paint.get(it), Ot = yt && yt.constantOr(1), Nt = B.getCrossfadeParameters(), hr, Sr, he, be, Pe;
                        qe ? (Sr = Ot && !B.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", hr = je.LINES) : (Sr = Ot ? "fillPattern" : "fill", hr = je.TRIANGLES);
                        let Oe = yt.constantOr(null);
                        for (let Je of Q){
                            let He = w.getTile(Je);
                            if (Ot && !He.patternsLoaded()) continue;
                            let et = He.getBucket(B);
                            if (!et) continue;
                            let Mt = et.programConfigurations.get(B.id), Dt = le.useProgram(Sr, Mt), Ut = le.style.map.terrain && le.style.map.terrain.getTerrainData(Je);
                            Ot && (le.context.activeTexture.set(je.TEXTURE0), He.imageAtlasTexture.bind(je.LINEAR, je.CLAMP_TO_EDGE), Mt.updatePaintBuffers(Nt)), rc(Mt, it, Oe, He, B);
                            let tr = Ut ? Je : null, mr = le.translatePosMatrix(tr ? tr.posMatrix : Je.posMatrix, He, B.paint.get("fill-translate"), B.paint.get("fill-translate-anchor"));
                            if (qe) {
                                be = et.indexBuffer2, Pe = et.segments2;
                                let Rr = [
                                    je.drawingBufferWidth,
                                    je.drawingBufferHeight
                                ];
                                he = Sr === "fillOutlinePattern" && Ot ? Sa(mr, le, Nt, He, Rr) : Fn(mr, Rr);
                            } else be = et.indexBuffer, Pe = et.segments, he = Ot ? ua(mr, le, Nt, He) : Ji(mr);
                            Dt.draw(le.context, hr, ee, le.stencilModeForClipping(Je), se, Ja.disabled, he, Ut, B.id, et.layoutVertexBuffer, be, Pe, B.paint, le.transform.zoom, Mt);
                        }
                    }
                    function Wc(le, w, B, Q, ee, se, qe) {
                        let je = le.context, it = je.gl, yt = "fill-extrusion-pattern", Ot = B.paint.get(yt), Nt = Ot.constantOr(1), hr = B.getCrossfadeParameters(), Sr = B.paint.get("fill-extrusion-opacity"), he = Ot.constantOr(null);
                        for (let be of Q){
                            let Pe = w.getTile(be), Oe = Pe.getBucket(B);
                            if (!Oe) continue;
                            let Je = le.style.map.terrain && le.style.map.terrain.getTerrainData(be), He = Oe.programConfigurations.get(B.id), et = le.useProgram(Nt ? "fillExtrusionPattern" : "fillExtrusion", He);
                            Nt && (le.context.activeTexture.set(it.TEXTURE0), Pe.imageAtlasTexture.bind(it.LINEAR, it.CLAMP_TO_EDGE), He.updatePaintBuffers(hr)), rc(He, yt, he, Pe, B);
                            let Mt = le.translatePosMatrix(be.posMatrix, Pe, B.paint.get("fill-extrusion-translate"), B.paint.get("fill-extrusion-translate-anchor")), Dt = B.paint.get("fill-extrusion-vertical-gradient"), Ut = Nt ? hi(Mt, le, Dt, Sr, be, hr, Pe) : an(Mt, le, Dt, Sr);
                            et.draw(je, je.gl.TRIANGLES, ee, se, qe, Ja.backCCW, Ut, Je, B.id, Oe.layoutVertexBuffer, Oe.indexBuffer, Oe.segments, B.paint, le.transform.zoom, He, le.style.map.terrain && Oe.centroidVertexBuffer);
                        }
                    }
                    function df(le, w, B, Q, ee, se, qe) {
                        let je = le.context, it = je.gl, yt = B.fbo;
                        if (!yt) return;
                        let Ot = le.useProgram("hillshade"), Nt = le.style.map.terrain && le.style.map.terrain.getTerrainData(w);
                        je.activeTexture.set(it.TEXTURE0), it.bindTexture(it.TEXTURE_2D, yt.colorAttachment.get()), Ot.draw(je, it.TRIANGLES, ee, se, qe, Ja.disabled, ((hr, Sr, he, be)=>{
                            let Pe = he.paint.get("hillshade-shadow-color"), Oe = he.paint.get("hillshade-highlight-color"), Je = he.paint.get("hillshade-accent-color"), He = he.paint.get("hillshade-illumination-direction") * (Math.PI / 180);
                            he.paint.get("hillshade-illumination-anchor") === "viewport" && (He -= hr.transform.angle);
                            let et = !hr.options.moving;
                            return {
                                u_matrix: be ? be.posMatrix : hr.transform.calculatePosMatrix(Sr.tileID.toUnwrapped(), et),
                                u_image: 0,
                                u_latrange: ks(0, Sr.tileID),
                                u_light: [
                                    he.paint.get("hillshade-exaggeration"),
                                    He
                                ],
                                u_shadow: Pe,
                                u_highlight: Oe,
                                u_accent: Je
                            };
                        })(le, B, Q, Nt ? w : null), Nt, Q.id, le.rasterBoundsBuffer, le.quadTriangleIndexBuffer, le.rasterBoundsSegments);
                    }
                    function Cu(le, w, B, Q, ee, se) {
                        let qe = le.context, je = qe.gl, it = w.dem;
                        if (it && it.data) {
                            let yt = it.dim, Ot = it.stride, Nt = it.getPixels();
                            if (qe.activeTexture.set(je.TEXTURE1), qe.pixelStoreUnpackPremultiplyAlpha.set(!1), w.demTexture = w.demTexture || le.getTileTexture(Ot), w.demTexture) {
                                let Sr = w.demTexture;
                                Sr.update(Nt, {
                                    premultiply: !1
                                }), Sr.bind(je.NEAREST, je.CLAMP_TO_EDGE);
                            } else w.demTexture = new g(qe, Nt, je.RGBA, {
                                premultiply: !1
                            }), w.demTexture.bind(je.NEAREST, je.CLAMP_TO_EDGE);
                            qe.activeTexture.set(je.TEXTURE0);
                            let hr = w.fbo;
                            if (!hr) {
                                let Sr = new g(qe, {
                                    width: yt,
                                    height: yt,
                                    data: null
                                }, je.RGBA);
                                Sr.bind(je.LINEAR, je.CLAMP_TO_EDGE), hr = w.fbo = qe.createFramebuffer(yt, yt, !0, !1), hr.colorAttachment.set(Sr.texture);
                            }
                            qe.bindFramebuffer.set(hr.framebuffer), qe.viewport.set([
                                0,
                                0,
                                yt,
                                yt
                            ]), le.useProgram("hillshadePrepare").draw(qe, je.TRIANGLES, Q, ee, se, Ja.disabled, ((Sr, he)=>{
                                let be = he.stride, Pe = a.H();
                                return a.aP(Pe, 0, a.X, -a.X, 0, 0, 1), a.J(Pe, Pe, [
                                    0,
                                    -a.X,
                                    0
                                ]), {
                                    u_matrix: Pe,
                                    u_image: 1,
                                    u_dimension: [
                                        be,
                                        be
                                    ],
                                    u_zoom: Sr.overscaledZ,
                                    u_unpack: he.getUnpackVector()
                                };
                            })(w.tileID, it), null, B.id, le.rasterBoundsBuffer, le.quadTriangleIndexBuffer, le.rasterBoundsSegments), w.needsHillshadePrepare = !1;
                        }
                    }
                    function Nf(le, w, B, Q, ee, se) {
                        let qe = Q.paint.get("raster-fade-duration");
                        if (!se && qe > 0) {
                            let je = u.now(), it = (je - le.timeAdded) / qe, yt = w ? (je - w.timeAdded) / qe : -1, Ot = B.getSource(), Nt = ee.coveringZoomLevel({
                                tileSize: Ot.tileSize,
                                roundZoom: Ot.roundZoom
                            }), hr = !w || Math.abs(w.tileID.overscaledZ - Nt) > Math.abs(le.tileID.overscaledZ - Nt), Sr = hr && le.refreshedUponExpiration ? 1 : a.ac(hr ? it : 1 - yt, 0, 1);
                            return le.refreshedUponExpiration && it >= 1 && (le.refreshedUponExpiration = !1), w ? {
                                opacity: 1,
                                mix: 1 - Sr
                            } : {
                                opacity: Sr,
                                mix: 0
                            };
                        }
                        return {
                            opacity: 1,
                            mix: 0
                        };
                    }
                    let Zc = new a.aM(1, 0, 0, 1), ds = new a.aM(0, 1, 0, 1), Ch = new a.aM(0, 0, 1, 1), Bd = new a.aM(1, 0, 1, 1), Jh = new a.aM(0, 1, 1, 1);
                    function Cf(le, w, B, Q) {
                        Lu(le, 0, w + B / 2, le.transform.width, B, Q);
                    }
                    function pd(le, w, B, Q) {
                        Lu(le, w - B / 2, 0, B, le.transform.height, Q);
                    }
                    function Lu(le, w, B, Q, ee, se) {
                        let qe = le.context, je = qe.gl;
                        je.enable(je.SCISSOR_TEST), je.scissor(w * le.pixelRatio, B * le.pixelRatio, Q * le.pixelRatio, ee * le.pixelRatio), qe.clear({
                            color: se
                        }), je.disable(je.SCISSOR_TEST);
                    }
                    function $h(le, w, B) {
                        let Q = le.context, ee = Q.gl, se = B.posMatrix, qe = le.useProgram("debug"), je = wo.disabled, it = $o.disabled, yt = le.colorModeForRenderPass(), Ot = "$debug", Nt = le.style.map.terrain && le.style.map.terrain.getTerrainData(B);
                        Q.activeTexture.set(ee.TEXTURE0);
                        let hr = w.getTileByID(B.key).latestRawTileData, Sr = Math.floor((hr && hr.byteLength || 0) / 1024), he = w.getTile(B).tileSize, be = 512 / Math.min(he, 512) * (B.overscaledZ / le.transform.zoom) * .5, Pe = B.canonical.toString();
                        B.overscaledZ !== B.canonical.z && (Pe += ` => ${B.overscaledZ}`), function(Oe, Je) {
                            Oe.initDebugOverlayCanvas();
                            let He = Oe.debugOverlayCanvas, et = Oe.context.gl, Mt = Oe.debugOverlayCanvas.getContext("2d");
                            Mt.clearRect(0, 0, He.width, He.height), Mt.shadowColor = "white", Mt.shadowBlur = 2, Mt.lineWidth = 1.5, Mt.strokeStyle = "white", Mt.textBaseline = "top", Mt.font = "bold 36px Open Sans, sans-serif", Mt.fillText(Je, 5, 5), Mt.strokeText(Je, 5, 5), Oe.debugOverlayTexture.update(He), Oe.debugOverlayTexture.bind(et.LINEAR, et.CLAMP_TO_EDGE);
                        }(le, `${Pe} ${Sr}kB`), qe.draw(Q, ee.TRIANGLES, je, it, Ps.alphaBlended, Ja.disabled, ho(se, a.aM.transparent, be), null, Ot, le.debugBuffer, le.quadTriangleIndexBuffer, le.debugSegments), qe.draw(Q, ee.LINE_STRIP, je, it, yt, Ja.disabled, ho(se, a.aM.red), Nt, Ot, le.debugBuffer, le.tileBorderIndexBuffer, le.debugSegments);
                    }
                    function tu(le, w, B) {
                        let Q = le.context, ee = Q.gl, se = le.colorModeForRenderPass(), qe = new wo(ee.LEQUAL, wo.ReadWrite, le.depthRangeFor3D), je = le.useProgram("terrain"), it = w.getTerrainMesh();
                        Q.bindFramebuffer.set(null), Q.viewport.set([
                            0,
                            0,
                            le.width,
                            le.height
                        ]);
                        for (let yt of B){
                            let Ot = le.renderToTexture.getTexture(yt), Nt = w.getTerrainData(yt.tileID);
                            Q.activeTexture.set(ee.TEXTURE0), ee.bindTexture(ee.TEXTURE_2D, Ot.texture);
                            let hr = le.transform.calculatePosMatrix(yt.tileID.toUnwrapped()), Sr = w.getMeshFrameDelta(le.transform.zoom), he = le.transform.calculateFogMatrix(yt.tileID.toUnwrapped()), be = Hr(hr, Sr, he, le.style.sky, le.transform.pitch);
                            je.draw(Q, ee.TRIANGLES, qe, $o.disabled, se, Ja.backCCW, be, Nt, "terrain", it.vertexBuffer, it.indexBuffer, it.segments);
                        }
                    }
                    class Pu {
                        constructor(w, B, Q){
                            this.vertexBuffer = w, this.indexBuffer = B, this.segments = Q;
                        }
                        destroy() {
                            this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
                        }
                    }
                    class Lc {
                        constructor(w, B){
                            this.context = new ov(w), this.transform = B, this._tileTextures = {}, this.terrainFacilitator = {
                                dirty: !0,
                                matrix: a.an(new Float64Array(16)),
                                renderTime: 0
                            }, this.setup(), this.numSublayers = dt.maxUnderzooming + dt.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new jo;
                        }
                        resize(w, B, Q) {
                            if (this.width = Math.floor(w * Q), this.height = Math.floor(B * Q), this.pixelRatio = Q, this.context.viewport.set([
                                0,
                                0,
                                this.width,
                                this.height
                            ]), this.style) for (let ee of this.style._order)this.style._layers[ee].resize();
                        }
                        setup() {
                            let w = this.context, B = new a.aX;
                            B.emplaceBack(0, 0), B.emplaceBack(a.X, 0), B.emplaceBack(0, a.X), B.emplaceBack(a.X, a.X), this.tileExtentBuffer = w.createVertexBuffer(B, oo.members), this.tileExtentSegments = a.a0.simpleSegment(0, 0, 4, 2);
                            let Q = new a.aX;
                            Q.emplaceBack(0, 0), Q.emplaceBack(a.X, 0), Q.emplaceBack(0, a.X), Q.emplaceBack(a.X, a.X), this.debugBuffer = w.createVertexBuffer(Q, oo.members), this.debugSegments = a.a0.simpleSegment(0, 0, 4, 5);
                            let ee = new a.$;
                            ee.emplaceBack(0, 0, 0, 0), ee.emplaceBack(a.X, 0, a.X, 0), ee.emplaceBack(0, a.X, 0, a.X), ee.emplaceBack(a.X, a.X, a.X, a.X), this.rasterBoundsBuffer = w.createVertexBuffer(ee, ot.members), this.rasterBoundsSegments = a.a0.simpleSegment(0, 0, 4, 2);
                            let se = new a.aX;
                            se.emplaceBack(0, 0), se.emplaceBack(1, 0), se.emplaceBack(0, 1), se.emplaceBack(1, 1), this.viewportBuffer = w.createVertexBuffer(se, oo.members), this.viewportSegments = a.a0.simpleSegment(0, 0, 4, 2);
                            let qe = new a.aZ;
                            qe.emplaceBack(0), qe.emplaceBack(1), qe.emplaceBack(3), qe.emplaceBack(2), qe.emplaceBack(0), this.tileBorderIndexBuffer = w.createIndexBuffer(qe);
                            let je = new a.aY;
                            je.emplaceBack(0, 1, 2), je.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = w.createIndexBuffer(je);
                            let it = this.context.gl;
                            this.stencilClearMode = new $o({
                                func: it.ALWAYS,
                                mask: 0
                            }, 0, 255, it.ZERO, it.ZERO, it.ZERO);
                        }
                        clearStencil() {
                            let w = this.context, B = w.gl;
                            this.nextStencilID = 1, this.currentStencilSource = void 0;
                            let Q = a.H();
                            a.aP(Q, 0, this.width, this.height, 0, 0, 1), a.K(Q, Q, [
                                B.drawingBufferWidth,
                                B.drawingBufferHeight,
                                0
                            ]), this.useProgram("clippingMask").draw(w, B.TRIANGLES, wo.disabled, this.stencilClearMode, Ps.disabled, Ja.disabled, Mo(Q), null, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
                        }
                        _renderTileClippingMasks(w, B) {
                            if (this.currentStencilSource === w.source || !w.isTileClipped() || !B || !B.length) return;
                            this.currentStencilSource = w.source;
                            let Q = this.context, ee = Q.gl;
                            this.nextStencilID + B.length > 256 && this.clearStencil(), Q.setColorMode(Ps.disabled), Q.setDepthMode(wo.disabled);
                            let se = this.useProgram("clippingMask");
                            this._tileClippingMaskIDs = {};
                            for (let qe of B){
                                let je = this._tileClippingMaskIDs[qe.key] = this.nextStencilID++, it = this.style.map.terrain && this.style.map.terrain.getTerrainData(qe);
                                se.draw(Q, ee.TRIANGLES, wo.disabled, new $o({
                                    func: ee.ALWAYS,
                                    mask: 0
                                }, je, 255, ee.KEEP, ee.KEEP, ee.REPLACE), Ps.disabled, Ja.disabled, Mo(qe.posMatrix), it, "$clipping", this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                            }
                        }
                        stencilModeFor3D() {
                            this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                            let w = this.nextStencilID++, B = this.context.gl;
                            return new $o({
                                func: B.NOTEQUAL,
                                mask: 255
                            }, w, 255, B.KEEP, B.KEEP, B.REPLACE);
                        }
                        stencilModeForClipping(w) {
                            let B = this.context.gl;
                            return new $o({
                                func: B.EQUAL,
                                mask: 255
                            }, this._tileClippingMaskIDs[w.key], 0, B.KEEP, B.KEEP, B.REPLACE);
                        }
                        stencilConfigForOverlap(w) {
                            let B = this.context.gl, Q = w.sort((qe, je)=>je.overscaledZ - qe.overscaledZ), ee = Q[Q.length - 1].overscaledZ, se = Q[0].overscaledZ - ee + 1;
                            if (se > 1) {
                                this.currentStencilSource = void 0, this.nextStencilID + se > 256 && this.clearStencil();
                                let qe = {};
                                for(let je = 0; je < se; je++)qe[je + ee] = new $o({
                                    func: B.GEQUAL,
                                    mask: 255
                                }, je + this.nextStencilID, 255, B.KEEP, B.KEEP, B.REPLACE);
                                return this.nextStencilID += se, [
                                    qe,
                                    Q
                                ];
                            }
                            return [
                                {
                                    [ee]: $o.disabled
                                },
                                Q
                            ];
                        }
                        colorModeForRenderPass() {
                            let w = this.context.gl;
                            return this._showOverdrawInspector ? new Ps([
                                w.CONSTANT_COLOR,
                                w.ONE
                            ], new a.aM(.125, .125, .125, 0), [
                                !0,
                                !0,
                                !0,
                                !0
                            ]) : this.renderPass === "opaque" ? Ps.unblended : Ps.alphaBlended;
                        }
                        depthModeForSublayer(w, B, Q) {
                            if (!this.opaquePassEnabledForLayer()) return wo.disabled;
                            let ee = 1 - ((1 + this.currentLayer) * this.numSublayers + w) * this.depthEpsilon;
                            return new wo(Q || this.context.gl.LEQUAL, B, [
                                ee,
                                ee
                            ]);
                        }
                        opaquePassEnabledForLayer() {
                            return this.currentLayer < this.opaquePassCutoff;
                        }
                        render(w, B) {
                            this.style = w, this.options = B, this.lineAtlas = w.lineAtlas, this.imageManager = w.imageManager, this.glyphManager = w.glyphManager, this.symbolFadeChange = w.placement.symbolFadeChange(u.now()), this.imageManager.beginFrame();
                            let Q = this.style._order, ee = this.style.sourceCaches, se = {}, qe = {}, je = {};
                            for(let it in ee){
                                let yt = ee[it];
                                yt.used && yt.prepare(this.context), se[it] = yt.getVisibleCoordinates(), qe[it] = se[it].slice().reverse(), je[it] = yt.getVisibleCoordinates(!0).reverse();
                            }
                            this.opaquePassCutoff = 1 / 0;
                            for(let it = 0; it < Q.length; it++)if (this.style._layers[Q[it]].is3D()) {
                                this.opaquePassCutoff = it;
                                break;
                            }
                            this.maybeDrawDepthAndCoords(!1), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = "offscreen";
                            for (let it of Q){
                                let yt = this.style._layers[it];
                                if (!yt.hasOffscreenPass() || yt.isHidden(this.transform.zoom)) continue;
                                let Ot = qe[yt.source];
                                (yt.type === "custom" || Ot.length) && this.renderLayer(this, ee[yt.source], yt, Ot);
                            }
                            if (this.context.bindFramebuffer.set(null), this.context.clear({
                                color: B.showOverdrawInspector ? a.aM.black : a.aM.transparent,
                                depth: 1
                            }), this.clearStencil(), this.style.sky && function(it, yt) {
                                let Ot = it.context, Nt = Ot.gl, hr = ((Oe, Je, He)=>({
                                        u_sky_color: Oe.properties.get("sky-color"),
                                        u_horizon_color: Oe.properties.get("horizon-color"),
                                        u_horizon: (Je.height / 2 + Je.getHorizon()) * He,
                                        u_sky_horizon_blend: Oe.properties.get("sky-horizon-blend") * Je.height / 2 * He
                                    }))(yt, it.style.map.transform, it.pixelRatio), Sr = new wo(Nt.LEQUAL, wo.ReadWrite, [
                                    0,
                                    1
                                ]), he = $o.disabled, be = it.colorModeForRenderPass(), Pe = it.useProgram("sky");
                                if (!yt.mesh) {
                                    let Oe = new a.aX;
                                    Oe.emplaceBack(-1, -1), Oe.emplaceBack(1, -1), Oe.emplaceBack(1, 1), Oe.emplaceBack(-1, 1);
                                    let Je = new a.aY;
                                    Je.emplaceBack(0, 1, 2), Je.emplaceBack(0, 2, 3), yt.mesh = new Pu(Ot.createVertexBuffer(Oe, oo.members), Ot.createIndexBuffer(Je), a.a0.simpleSegment(0, 0, Oe.length, Je.length));
                                }
                                Pe.draw(Ot, Nt.TRIANGLES, Sr, he, be, Ja.disabled, hr, void 0, "sky", yt.mesh.vertexBuffer, yt.mesh.indexBuffer, yt.mesh.segments);
                            }(this, this.style.sky), this._showOverdrawInspector = B.showOverdrawInspector, this.depthRangeFor3D = [
                                0,
                                1 - (w._order.length + 2) * this.numSublayers * this.depthEpsilon
                            ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = Q.length - 1; this.currentLayer >= 0; this.currentLayer--){
                                let it = this.style._layers[Q[this.currentLayer]], yt = ee[it.source], Ot = se[it.source];
                                this._renderTileClippingMasks(it, Ot), this.renderLayer(this, yt, it, Ot);
                            }
                            for(this.renderPass = "translucent", this.currentLayer = 0; this.currentLayer < Q.length; this.currentLayer++){
                                let it = this.style._layers[Q[this.currentLayer]], yt = ee[it.source];
                                if (this.renderToTexture && this.renderToTexture.renderLayer(it)) continue;
                                let Ot = (it.type === "symbol" ? je : qe)[it.source];
                                this._renderTileClippingMasks(it, se[it.source]), this.renderLayer(this, yt, it, Ot);
                            }
                            if (this.options.showTileBoundaries) {
                                let it = function(yt, Ot) {
                                    let Nt = null, hr = Object.values(yt._layers).flatMap((Pe)=>Pe.source && !Pe.isHidden(Ot) ? [
                                            yt.sourceCaches[Pe.source]
                                        ] : []), Sr = hr.filter((Pe)=>Pe.getSource().type === "vector"), he = hr.filter((Pe)=>Pe.getSource().type !== "vector"), be = (Pe)=>{
                                        (!Nt || Nt.getSource().maxzoom < Pe.getSource().maxzoom) && (Nt = Pe);
                                    };
                                    return Sr.forEach((Pe)=>be(Pe)), Nt || he.forEach((Pe)=>be(Pe)), Nt;
                                }(this.style, this.transform.zoom);
                                it && function(yt, Ot, Nt) {
                                    for(let hr = 0; hr < Nt.length; hr++)$h(yt, Ot, Nt[hr]);
                                }(this, it, it.getVisibleCoordinates());
                            }
                            this.options.showPadding && function(it) {
                                let yt = it.transform.padding;
                                Cf(it, it.transform.height - (yt.top || 0), 3, Zc), Cf(it, yt.bottom || 0, 3, ds), pd(it, yt.left || 0, 3, Ch), pd(it, it.transform.width - (yt.right || 0), 3, Bd);
                                let Ot = it.transform.centerPoint;
                                (function(Nt, hr, Sr, he) {
                                    Lu(Nt, hr - 1, Sr - 10, 2, 20, he), Lu(Nt, hr - 10, Sr - 1, 20, 2, he);
                                })(it, Ot.x, it.transform.height - Ot.y, Jh);
                            }(this), this.context.setDefault();
                        }
                        maybeDrawDepthAndCoords(w) {
                            if (!this.style || !this.style.map || !this.style.map.terrain) return;
                            let B = this.terrainFacilitator.matrix, Q = this.transform.modelViewProjectionMatrix, ee = this.terrainFacilitator.dirty;
                            ee || (ee = w ? !a.a_(B, Q) : !a.a$(B, Q)), ee || (ee = this.style.map.terrain.sourceCache.tilesAfterTime(this.terrainFacilitator.renderTime).length > 0), ee && (a.b0(B, Q), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(se, qe) {
                                let je = se.context, it = je.gl, yt = Ps.unblended, Ot = new wo(it.LEQUAL, wo.ReadWrite, [
                                    0,
                                    1
                                ]), Nt = qe.getTerrainMesh(), hr = qe.sourceCache.getRenderableTiles(), Sr = se.useProgram("terrainDepth");
                                je.bindFramebuffer.set(qe.getFramebuffer("depth").framebuffer), je.viewport.set([
                                    0,
                                    0,
                                    se.width / devicePixelRatio,
                                    se.height / devicePixelRatio
                                ]), je.clear({
                                    color: a.aM.transparent,
                                    depth: 1
                                });
                                for (let he of hr){
                                    let be = qe.getTerrainData(he.tileID), Pe = {
                                        u_matrix: se.transform.calculatePosMatrix(he.tileID.toUnwrapped()),
                                        u_ele_delta: qe.getMeshFrameDelta(se.transform.zoom)
                                    };
                                    Sr.draw(je, it.TRIANGLES, Ot, $o.disabled, yt, Ja.backCCW, Pe, be, "terrain", Nt.vertexBuffer, Nt.indexBuffer, Nt.segments);
                                }
                                je.bindFramebuffer.set(null), je.viewport.set([
                                    0,
                                    0,
                                    se.width,
                                    se.height
                                ]);
                            }(this, this.style.map.terrain), function(se, qe) {
                                let je = se.context, it = je.gl, yt = Ps.unblended, Ot = new wo(it.LEQUAL, wo.ReadWrite, [
                                    0,
                                    1
                                ]), Nt = qe.getTerrainMesh(), hr = qe.getCoordsTexture(), Sr = qe.sourceCache.getRenderableTiles(), he = se.useProgram("terrainCoords");
                                je.bindFramebuffer.set(qe.getFramebuffer("coords").framebuffer), je.viewport.set([
                                    0,
                                    0,
                                    se.width / devicePixelRatio,
                                    se.height / devicePixelRatio
                                ]), je.clear({
                                    color: a.aM.transparent,
                                    depth: 1
                                }), qe.coordsIndex = [];
                                for (let be of Sr){
                                    let Pe = qe.getTerrainData(be.tileID);
                                    je.activeTexture.set(it.TEXTURE0), it.bindTexture(it.TEXTURE_2D, hr.texture);
                                    let Oe = {
                                        u_matrix: se.transform.calculatePosMatrix(be.tileID.toUnwrapped()),
                                        u_terrain_coords_id: (255 - qe.coordsIndex.length) / 255,
                                        u_texture: 0,
                                        u_ele_delta: qe.getMeshFrameDelta(se.transform.zoom)
                                    };
                                    he.draw(je, it.TRIANGLES, Ot, $o.disabled, yt, Ja.backCCW, Oe, Pe, "terrain", Nt.vertexBuffer, Nt.indexBuffer, Nt.segments), qe.coordsIndex.push(be.tileID.key);
                                }
                                je.bindFramebuffer.set(null), je.viewport.set([
                                    0,
                                    0,
                                    se.width,
                                    se.height
                                ]);
                            }(this, this.style.map.terrain));
                        }
                        renderLayer(w, B, Q, ee) {
                            if (!Q.isHidden(this.transform.zoom) && (Q.type === "background" || Q.type === "custom" || (ee || []).length)) switch(this.id = Q.id, Q.type){
                                case "symbol":
                                    (function(se, qe, je, it, yt) {
                                        if (se.renderPass !== "translucent") return;
                                        let Ot = $o.disabled, Nt = se.colorModeForRenderPass();
                                        (je._unevaluatedLayout.hasValue("text-variable-anchor") || je._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(hr, Sr, he, be, Pe, Oe, Je, He, et) {
                                            let Mt = Sr.transform, Dt = Gi(), Ut = Pe === "map", tr = Oe === "map";
                                            for (let mr of hr){
                                                let Rr = be.getTile(mr), zr = Rr.getBucket(he);
                                                if (!zr || !zr.text || !zr.text.segments.get().length) continue;
                                                let Xr = a.ag(zr.textSizeData, Mt.zoom), di = nn(Rr, 1, Sr.transform.zoom), Li = Or(mr.posMatrix, tr, Ut, Sr.transform, di), Ci = he.layout.get("icon-text-fit") !== "none" && zr.hasIconData();
                                                if (Xr) {
                                                    let Qi = Math.pow(2, Mt.zoom - Rr.tileID.overscaledZ), Mn = Sr.style.map.terrain ? (ea, Ga)=>Sr.style.map.terrain.getElevation(mr, ea, Ga) : null, pa = Dt.translatePosition(Mt, Rr, Je, He);
                                                    kf(zr, Ut, tr, et, Mt, Li, mr.posMatrix, Qi, Xr, Ci, Dt, pa, mr.toUnwrapped(), Mn);
                                                }
                                            }
                                        }(it, se, je, qe, je.layout.get("text-rotation-alignment"), je.layout.get("text-pitch-alignment"), je.paint.get("text-translate"), je.paint.get("text-translate-anchor"), yt), je.paint.get("icon-opacity").constantOr(1) !== 0 && Yh(se, qe, je, it, !1, je.paint.get("icon-translate"), je.paint.get("icon-translate-anchor"), je.layout.get("icon-rotation-alignment"), je.layout.get("icon-pitch-alignment"), je.layout.get("icon-keep-upright"), Ot, Nt), je.paint.get("text-opacity").constantOr(1) !== 0 && Yh(se, qe, je, it, !0, je.paint.get("text-translate"), je.paint.get("text-translate-anchor"), je.layout.get("text-rotation-alignment"), je.layout.get("text-pitch-alignment"), je.layout.get("text-keep-upright"), Ot, Nt), qe.map.showCollisionBoxes && (tc(se, qe, je, it, !0), tc(se, qe, je, it, !1));
                                    })(w, B, Q, ee, this.style.placement.variableOffsets);
                                    break;
                                case "circle":
                                    (function(se, qe, je, it) {
                                        if (se.renderPass !== "translucent") return;
                                        let yt = je.paint.get("circle-opacity"), Ot = je.paint.get("circle-stroke-width"), Nt = je.paint.get("circle-stroke-opacity"), hr = !je.layout.get("circle-sort-key").isConstant();
                                        if (yt.constantOr(1) === 0 && (Ot.constantOr(1) === 0 || Nt.constantOr(1) === 0)) return;
                                        let Sr = se.context, he = Sr.gl, be = se.depthModeForSublayer(0, wo.ReadOnly), Pe = $o.disabled, Oe = se.colorModeForRenderPass(), Je = [];
                                        for(let He = 0; He < it.length; He++){
                                            let et = it[He], Mt = qe.getTile(et), Dt = Mt.getBucket(je);
                                            if (!Dt) continue;
                                            let Ut = Dt.programConfigurations.get(je.id), tr = se.useProgram("circle", Ut), mr = Dt.layoutVertexBuffer, Rr = Dt.indexBuffer, zr = se.style.map.terrain && se.style.map.terrain.getTerrainData(et), Xr = {
                                                programConfiguration: Ut,
                                                program: tr,
                                                layoutVertexBuffer: mr,
                                                indexBuffer: Rr,
                                                uniformValues: go(se, et, Mt, je),
                                                terrainData: zr
                                            };
                                            if (hr) {
                                                let di = Dt.segments.get();
                                                for (let Li of di)Je.push({
                                                    segments: new a.a0([
                                                        Li
                                                    ]),
                                                    sortKey: Li.sortKey,
                                                    state: Xr
                                                });
                                            } else Je.push({
                                                segments: Dt.segments,
                                                sortKey: 0,
                                                state: Xr
                                            });
                                        }
                                        hr && Je.sort((He, et)=>He.sortKey - et.sortKey);
                                        for (let He of Je){
                                            let { programConfiguration: et, program: Mt, layoutVertexBuffer: Dt, indexBuffer: Ut, uniformValues: tr, terrainData: mr } = He.state;
                                            Mt.draw(Sr, he.TRIANGLES, be, Pe, Oe, Ja.disabled, tr, mr, je.id, Dt, Ut, He.segments, je.paint, se.transform.zoom, et);
                                        }
                                    })(w, B, Q, ee);
                                    break;
                                case "heatmap":
                                    (function(se, qe, je, it) {
                                        if (je.paint.get("heatmap-opacity") === 0) return;
                                        let yt = se.context;
                                        if (se.style.map.terrain) {
                                            for (let Ot of it){
                                                let Nt = qe.getTile(Ot);
                                                qe.hasRenderableParent(Ot) || (se.renderPass === "offscreen" ? nh(se, Nt, je, Ot) : se.renderPass === "translucent" && hf(se, je, Ot));
                                            }
                                            yt.viewport.set([
                                                0,
                                                0,
                                                se.width,
                                                se.height
                                            ]);
                                        } else se.renderPass === "offscreen" ? function(Ot, Nt, hr, Sr) {
                                            let he = Ot.context, be = he.gl, Pe = $o.disabled, Oe = new Ps([
                                                be.ONE,
                                                be.ONE
                                            ], a.aM.transparent, [
                                                !0,
                                                !0,
                                                !0,
                                                !0
                                            ]);
                                            (function(Je, He, et) {
                                                let Mt = Je.gl;
                                                Je.activeTexture.set(Mt.TEXTURE1), Je.viewport.set([
                                                    0,
                                                    0,
                                                    He.width / 4,
                                                    He.height / 4
                                                ]);
                                                let Dt = et.heatmapFbos.get(a.aU);
                                                Dt ? (Mt.bindTexture(Mt.TEXTURE_2D, Dt.colorAttachment.get()), Je.bindFramebuffer.set(Dt.framebuffer)) : (Dt = kh(Je, He.width / 4, He.height / 4), et.heatmapFbos.set(a.aU, Dt));
                                            })(he, Ot, hr), he.clear({
                                                color: a.aM.transparent
                                            });
                                            for(let Je = 0; Je < Sr.length; Je++){
                                                let He = Sr[Je];
                                                if (Nt.hasRenderableParent(He)) continue;
                                                let et = Nt.getTile(He), Mt = et.getBucket(hr);
                                                if (!Mt) continue;
                                                let Dt = Mt.programConfigurations.get(hr.id), Ut = Ot.useProgram("heatmap", Dt), { zoom: tr } = Ot.transform;
                                                Ut.draw(he, be.TRIANGLES, wo.disabled, Pe, Oe, Ja.disabled, xo(He.posMatrix, et, tr, hr.paint.get("heatmap-intensity")), null, hr.id, Mt.layoutVertexBuffer, Mt.indexBuffer, Mt.segments, hr.paint, Ot.transform.zoom, Dt);
                                            }
                                            he.viewport.set([
                                                0,
                                                0,
                                                Ot.width,
                                                Ot.height
                                            ]);
                                        }(se, qe, je, it) : se.renderPass === "translucent" && function(Ot, Nt) {
                                            let hr = Ot.context, Sr = hr.gl;
                                            hr.setColorMode(Ot.colorModeForRenderPass());
                                            let he = Nt.heatmapFbos.get(a.aU);
                                            he && (hr.activeTexture.set(Sr.TEXTURE0), Sr.bindTexture(Sr.TEXTURE_2D, he.colorAttachment.get()), hr.activeTexture.set(Sr.TEXTURE1), Kh(hr, Nt).bind(Sr.LINEAR, Sr.CLAMP_TO_EDGE), Ot.useProgram("heatmapTexture").draw(hr, Sr.TRIANGLES, wo.disabled, $o.disabled, Ot.colorModeForRenderPass(), Ja.disabled, zs(Ot, Nt, 0, 1), null, Nt.id, Ot.viewportBuffer, Ot.quadTriangleIndexBuffer, Ot.viewportSegments, Nt.paint, Ot.transform.zoom));
                                        }(se, je);
                                    })(w, B, Q, ee);
                                    break;
                                case "line":
                                    (function(se, qe, je, it) {
                                        if (se.renderPass !== "translucent") return;
                                        let yt = je.paint.get("line-opacity"), Ot = je.paint.get("line-width");
                                        if (yt.constantOr(1) === 0 || Ot.constantOr(1) === 0) return;
                                        let Nt = se.depthModeForSublayer(0, wo.ReadOnly), hr = se.colorModeForRenderPass(), Sr = je.paint.get("line-dasharray"), he = je.paint.get("line-pattern"), be = he.constantOr(1), Pe = je.paint.get("line-gradient"), Oe = je.getCrossfadeParameters(), Je = be ? "linePattern" : Sr ? "lineSDF" : Pe ? "lineGradient" : "line", He = se.context, et = He.gl, Mt = !0;
                                        for (let Dt of it){
                                            let Ut = qe.getTile(Dt);
                                            if (be && !Ut.patternsLoaded()) continue;
                                            let tr = Ut.getBucket(je);
                                            if (!tr) continue;
                                            let mr = tr.programConfigurations.get(je.id), Rr = se.context.program.get(), zr = se.useProgram(Je, mr), Xr = Mt || zr.program !== Rr, di = se.style.map.terrain && se.style.map.terrain.getTerrainData(Dt), Li = he.constantOr(null);
                                            if (Li && Ut.imageAtlas) {
                                                let Mn = Ut.imageAtlas, pa = Mn.patternPositions[Li.to.toString()], ea = Mn.patternPositions[Li.from.toString()];
                                                pa && ea && mr.setConstantPatternPositions(pa, ea);
                                            }
                                            let Ci = di ? Dt : null, Qi = be ? wl(se, Ut, je, Oe, Ci) : Sr ? os(se, Ut, je, Sr, Oe, Ci) : Pe ? Xs(se, Ut, je, tr.lineClipsArray.length, Ci) : Zs(se, Ut, je, Ci);
                                            if (be) He.activeTexture.set(et.TEXTURE0), Ut.imageAtlasTexture.bind(et.LINEAR, et.CLAMP_TO_EDGE), mr.updatePaintBuffers(Oe);
                                            else if (Sr && (Xr || se.lineAtlas.dirty)) He.activeTexture.set(et.TEXTURE0), se.lineAtlas.bind(He);
                                            else if (Pe) {
                                                let Mn = tr.gradients[je.id], pa = Mn.texture;
                                                if (je.gradientVersion !== Mn.version) {
                                                    let ea = 256;
                                                    if (je.stepInterpolant) {
                                                        let Ga = qe.getSource().maxzoom, To = Dt.canonical.z === Ga ? Math.ceil(1 << se.transform.maxZoom - Dt.canonical.z) : 1;
                                                        ea = a.ac(a.aV(tr.maxLineLength / a.X * 1024 * To), 256, He.maxTextureSize);
                                                    }
                                                    Mn.gradient = a.aW({
                                                        expression: je.gradientExpression(),
                                                        evaluationKey: "lineProgress",
                                                        resolution: ea,
                                                        image: Mn.gradient || void 0,
                                                        clips: tr.lineClipsArray
                                                    }), Mn.texture ? Mn.texture.update(Mn.gradient) : Mn.texture = new g(He, Mn.gradient, et.RGBA), Mn.version = je.gradientVersion, pa = Mn.texture;
                                                }
                                                He.activeTexture.set(et.TEXTURE0), pa.bind(je.stepInterpolant ? et.NEAREST : et.LINEAR, et.CLAMP_TO_EDGE);
                                            }
                                            zr.draw(He, et.TRIANGLES, Nt, se.stencilModeForClipping(Dt), hr, Ja.disabled, Qi, di, je.id, tr.layoutVertexBuffer, tr.indexBuffer, tr.segments, je.paint, se.transform.zoom, mr, tr.layoutVertexBuffer2), Mt = !1;
                                        }
                                    })(w, B, Q, ee);
                                    break;
                                case "fill":
                                    (function(se, qe, je, it) {
                                        let yt = je.paint.get("fill-color"), Ot = je.paint.get("fill-opacity");
                                        if (Ot.constantOr(1) === 0) return;
                                        let Nt = se.colorModeForRenderPass(), hr = je.paint.get("fill-pattern"), Sr = se.opaquePassEnabledForLayer() && !hr.constantOr(1) && yt.constantOr(a.aM.transparent).a === 1 && Ot.constantOr(0) === 1 ? "opaque" : "translucent";
                                        if (se.renderPass === Sr) {
                                            let he = se.depthModeForSublayer(1, se.renderPass === "opaque" ? wo.ReadWrite : wo.ReadOnly);
                                            ah(se, qe, je, it, he, Nt, !1);
                                        }
                                        if (se.renderPass === "translucent" && je.paint.get("fill-antialias")) {
                                            let he = se.depthModeForSublayer(je.getPaintProperty("fill-outline-color") ? 2 : 0, wo.ReadOnly);
                                            ah(se, qe, je, it, he, Nt, !0);
                                        }
                                    })(w, B, Q, ee);
                                    break;
                                case "fill-extrusion":
                                    (function(se, qe, je, it) {
                                        let yt = je.paint.get("fill-extrusion-opacity");
                                        if (yt !== 0 && se.renderPass === "translucent") {
                                            let Ot = new wo(se.context.gl.LEQUAL, wo.ReadWrite, se.depthRangeFor3D);
                                            if (yt !== 1 || je.paint.get("fill-extrusion-pattern").constantOr(1)) Wc(se, qe, je, it, Ot, $o.disabled, Ps.disabled), Wc(se, qe, je, it, Ot, se.stencilModeFor3D(), se.colorModeForRenderPass());
                                            else {
                                                let Nt = se.colorModeForRenderPass();
                                                Wc(se, qe, je, it, Ot, $o.disabled, Nt);
                                            }
                                        }
                                    })(w, B, Q, ee);
                                    break;
                                case "hillshade":
                                    (function(se, qe, je, it) {
                                        if (se.renderPass !== "offscreen" && se.renderPass !== "translucent") return;
                                        let yt = se.context, Ot = se.depthModeForSublayer(0, wo.ReadOnly), Nt = se.colorModeForRenderPass(), [hr, Sr] = se.renderPass === "translucent" ? se.stencilConfigForOverlap(it) : [
                                            {},
                                            it
                                        ];
                                        for (let he of Sr){
                                            let be = qe.getTile(he);
                                            be.needsHillshadePrepare !== void 0 && be.needsHillshadePrepare && se.renderPass === "offscreen" ? Cu(se, be, je, Ot, $o.disabled, Nt) : se.renderPass === "translucent" && df(se, he, be, je, Ot, hr[he.overscaledZ], Nt);
                                        }
                                        yt.viewport.set([
                                            0,
                                            0,
                                            se.width,
                                            se.height
                                        ]);
                                    })(w, B, Q, ee);
                                    break;
                                case "raster":
                                    (function(se, qe, je, it) {
                                        if (se.renderPass !== "translucent" || je.paint.get("raster-opacity") === 0 || !it.length) return;
                                        let yt = se.context, Ot = yt.gl, Nt = qe.getSource(), hr = se.useProgram("raster"), Sr = se.colorModeForRenderPass(), [he, be] = Nt instanceof Rt ? [
                                            {},
                                            it
                                        ] : se.stencilConfigForOverlap(it), Pe = be[be.length - 1].overscaledZ, Oe = !se.options.moving;
                                        for (let Je of be){
                                            let He = se.depthModeForSublayer(Je.overscaledZ - Pe, je.paint.get("raster-opacity") === 1 ? wo.ReadWrite : wo.ReadOnly, Ot.LESS), et = qe.getTile(Je);
                                            et.registerFadeDuration(je.paint.get("raster-fade-duration"));
                                            let Mt = qe.findLoadedParent(Je, 0), Dt = qe.findLoadedSibling(Je), Ut = Nf(et, Mt || Dt || null, qe, je, se.transform, se.style.map.terrain), tr, mr, Rr = je.paint.get("raster-resampling") === "nearest" ? Ot.NEAREST : Ot.LINEAR;
                                            yt.activeTexture.set(Ot.TEXTURE0), et.texture.bind(Rr, Ot.CLAMP_TO_EDGE, Ot.LINEAR_MIPMAP_NEAREST), yt.activeTexture.set(Ot.TEXTURE1), Mt ? (Mt.texture.bind(Rr, Ot.CLAMP_TO_EDGE, Ot.LINEAR_MIPMAP_NEAREST), tr = Math.pow(2, Mt.tileID.overscaledZ - et.tileID.overscaledZ), mr = [
                                                et.tileID.canonical.x * tr % 1,
                                                et.tileID.canonical.y * tr % 1
                                            ]) : et.texture.bind(Rr, Ot.CLAMP_TO_EDGE, Ot.LINEAR_MIPMAP_NEAREST), et.texture.useMipmap && yt.extTextureFilterAnisotropic && se.transform.pitch > 20 && Ot.texParameterf(Ot.TEXTURE_2D, yt.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, yt.extTextureFilterAnisotropicMax);
                                            let zr = se.style.map.terrain && se.style.map.terrain.getTerrainData(Je), Xr = zr ? Je : null, di = Xr ? Xr.posMatrix : se.transform.calculatePosMatrix(Je.toUnwrapped(), Oe), Li = ml(di, mr || [
                                                0,
                                                0
                                            ], tr || 1, Ut, je);
                                            Nt instanceof Rt ? hr.draw(yt, Ot.TRIANGLES, He, $o.disabled, Sr, Ja.disabled, Li, zr, je.id, Nt.boundsBuffer, se.quadTriangleIndexBuffer, Nt.boundsSegments) : hr.draw(yt, Ot.TRIANGLES, He, he[Je.overscaledZ], Sr, Ja.disabled, Li, zr, je.id, se.rasterBoundsBuffer, se.quadTriangleIndexBuffer, se.rasterBoundsSegments);
                                        }
                                    })(w, B, Q, ee);
                                    break;
                                case "background":
                                    (function(se, qe, je, it) {
                                        let yt = je.paint.get("background-color"), Ot = je.paint.get("background-opacity");
                                        if (Ot === 0) return;
                                        let Nt = se.context, hr = Nt.gl, Sr = se.transform, he = Sr.tileSize, be = je.paint.get("background-pattern");
                                        if (se.isPatternMissing(be)) return;
                                        let Pe = !be && yt.a === 1 && Ot === 1 && se.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                                        if (se.renderPass !== Pe) return;
                                        let Oe = $o.disabled, Je = se.depthModeForSublayer(0, Pe === "opaque" ? wo.ReadWrite : wo.ReadOnly), He = se.colorModeForRenderPass(), et = se.useProgram(be ? "backgroundPattern" : "background"), Mt = it || Sr.coveringTiles({
                                            tileSize: he,
                                            terrain: se.style.map.terrain
                                        });
                                        be && (Nt.activeTexture.set(hr.TEXTURE0), se.imageManager.bind(se.context));
                                        let Dt = je.getCrossfadeParameters();
                                        for (let Ut of Mt){
                                            let tr = it ? Ut.posMatrix : se.transform.calculatePosMatrix(Ut.toUnwrapped()), mr = be ? Hu(tr, Ot, se, be, {
                                                tileID: Ut,
                                                tileSize: he
                                            }, Dt) : Ql(tr, Ot, yt), Rr = se.style.map.terrain && se.style.map.terrain.getTerrainData(Ut);
                                            et.draw(Nt, hr.TRIANGLES, Je, Oe, He, Ja.disabled, mr, Rr, je.id, se.tileExtentBuffer, se.quadTriangleIndexBuffer, se.tileExtentSegments);
                                        }
                                    })(w, 0, Q, ee);
                                    break;
                                case "custom":
                                    (function(se, qe, je) {
                                        let it = se.context, yt = je.implementation;
                                        if (se.renderPass === "offscreen") {
                                            let Ot = yt.prerender;
                                            Ot && (se.setCustomLayerDefaults(), it.setColorMode(se.colorModeForRenderPass()), Ot.call(yt, it.gl, se.transform.customLayerMatrix()), it.setDirty(), se.setBaseState());
                                        } else if (se.renderPass === "translucent") {
                                            se.setCustomLayerDefaults(), it.setColorMode(se.colorModeForRenderPass()), it.setStencilMode($o.disabled);
                                            let Ot = yt.renderingMode === "3d" ? new wo(se.context.gl.LEQUAL, wo.ReadWrite, se.depthRangeFor3D) : se.depthModeForSublayer(0, wo.ReadOnly);
                                            it.setDepthMode(Ot), yt.render(it.gl, se.transform.customLayerMatrix(), {
                                                farZ: se.transform.farZ,
                                                nearZ: se.transform.nearZ,
                                                fov: se.transform._fov,
                                                modelViewProjectionMatrix: se.transform.modelViewProjectionMatrix,
                                                projectionMatrix: se.transform.projectionMatrix
                                            }), it.setDirty(), se.setBaseState(), it.bindFramebuffer.set(null);
                                        }
                                    })(w, 0, Q);
                            }
                        }
                        translatePosMatrix(w, B, Q, ee, se) {
                            if (!Q[0] && !Q[1]) return w;
                            let qe = se ? ee === "map" ? this.transform.angle : 0 : ee === "viewport" ? -this.transform.angle : 0;
                            if (qe) {
                                let yt = Math.sin(qe), Ot = Math.cos(qe);
                                Q = [
                                    Q[0] * Ot - Q[1] * yt,
                                    Q[0] * yt + Q[1] * Ot
                                ];
                            }
                            let je = [
                                se ? Q[0] : nn(B, Q[0], this.transform.zoom),
                                se ? Q[1] : nn(B, Q[1], this.transform.zoom),
                                0
                            ], it = new Float32Array(16);
                            return a.J(it, w, je), it;
                        }
                        saveTileTexture(w) {
                            let B = this._tileTextures[w.size[0]];
                            B ? B.push(w) : this._tileTextures[w.size[0]] = [
                                w
                            ];
                        }
                        getTileTexture(w) {
                            let B = this._tileTextures[w];
                            return B && B.length > 0 ? B.pop() : null;
                        }
                        isPatternMissing(w) {
                            if (!w) return !1;
                            if (!w.from || !w.to) return !0;
                            let B = this.imageManager.getPattern(w.from.toString()), Q = this.imageManager.getPattern(w.to.toString());
                            return !B || !Q;
                        }
                        useProgram(w, B) {
                            this.cache = this.cache || {};
                            let Q = w + (B ? B.cacheKey : "") + (this._showOverdrawInspector ? "/overdraw" : "") + (this.style.map.terrain ? "/terrain" : "");
                            return this.cache[Q] || (this.cache[Q] = new zi(this.context, xn[w], B, fc[w], this._showOverdrawInspector, this.style.map.terrain)), this.cache[Q];
                        }
                        setCustomLayerDefaults() {
                            this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
                        }
                        setBaseState() {
                            let w = this.context.gl;
                            this.context.cullFace.set(!1), this.context.viewport.set([
                                0,
                                0,
                                this.width,
                                this.height
                            ]), this.context.blendEquation.set(w.FUNC_ADD);
                        }
                        initDebugOverlayCanvas() {
                            this.debugOverlayCanvas == null && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new g(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
                        }
                        destroy() {
                            this.debugOverlayTexture && this.debugOverlayTexture.destroy();
                        }
                        overLimit() {
                            let { drawingBufferWidth: w, drawingBufferHeight: B } = this.context.gl;
                            return this.width !== w || this.height !== B;
                        }
                    }
                    class fl {
                        constructor(w, B){
                            this.points = w, this.planes = B;
                        }
                        static fromInvProjectionMatrix(w, B, Q) {
                            let ee = Math.pow(2, Q), se = [
                                [
                                    -1,
                                    1,
                                    -1,
                                    1
                                ],
                                [
                                    1,
                                    1,
                                    -1,
                                    1
                                ],
                                [
                                    1,
                                    -1,
                                    -1,
                                    1
                                ],
                                [
                                    -1,
                                    -1,
                                    -1,
                                    1
                                ],
                                [
                                    -1,
                                    1,
                                    1,
                                    1
                                ],
                                [
                                    1,
                                    1,
                                    1,
                                    1
                                ],
                                [
                                    1,
                                    -1,
                                    1,
                                    1
                                ],
                                [
                                    -1,
                                    -1,
                                    1,
                                    1
                                ]
                            ].map((je)=>{
                                let it = 1 / (je = a.af([], je, w))[3] / B * ee;
                                return a.b1(je, je, [
                                    it,
                                    it,
                                    1 / je[3],
                                    it
                                ]);
                            }), qe = [
                                [
                                    0,
                                    1,
                                    2
                                ],
                                [
                                    6,
                                    5,
                                    4
                                ],
                                [
                                    0,
                                    3,
                                    7
                                ],
                                [
                                    2,
                                    1,
                                    5
                                ],
                                [
                                    3,
                                    2,
                                    6
                                ],
                                [
                                    0,
                                    4,
                                    5
                                ]
                            ].map((je)=>{
                                let it = function(hr, Sr) {
                                    var he = Sr[0], be = Sr[1], Pe = Sr[2], Oe = he * he + be * be + Pe * Pe;
                                    return Oe > 0 && (Oe = 1 / Math.sqrt(Oe)), hr[0] = Sr[0] * Oe, hr[1] = Sr[1] * Oe, hr[2] = Sr[2] * Oe, hr;
                                }([], function(hr, Sr, he) {
                                    var be = Sr[0], Pe = Sr[1], Oe = Sr[2], Je = he[0], He = he[1], et = he[2];
                                    return hr[0] = Pe * et - Oe * He, hr[1] = Oe * Je - be * et, hr[2] = be * He - Pe * Je, hr;
                                }([], L([], se[je[0]], se[je[1]]), L([], se[je[2]], se[je[1]]))), yt = -((Ot = it)[0] * (Nt = se[je[1]])[0] + Ot[1] * Nt[1] + Ot[2] * Nt[2]);
                                var Ot, Nt;
                                return it.concat(yt);
                            });
                            return new fl(se, qe);
                        }
                    }
                    class Xc {
                        constructor(w, B){
                            this.min = w, this.max = B, this.center = function(Q, ee, se) {
                                return Q[0] = .5 * ee[0], Q[1] = .5 * ee[1], Q[2] = .5 * ee[2], Q;
                            }([], function(Q, ee, se) {
                                return Q[0] = ee[0] + se[0], Q[1] = ee[1] + se[1], Q[2] = ee[2] + se[2], Q;
                            }([], this.min, this.max));
                        }
                        quadrant(w) {
                            let B = [
                                w % 2 == 0,
                                w < 2
                            ], Q = k(this.min), ee = k(this.max);
                            for(let se = 0; se < B.length; se++)Q[se] = B[se] ? this.min[se] : this.center[se], ee[se] = B[se] ? this.center[se] : this.max[se];
                            return ee[2] = this.max[2], new Xc(Q, ee);
                        }
                        distanceX(w) {
                            return Math.max(Math.min(this.max[0], w[0]), this.min[0]) - w[0];
                        }
                        distanceY(w) {
                            return Math.max(Math.min(this.max[1], w[1]), this.min[1]) - w[1];
                        }
                        intersects(w) {
                            let B = [
                                [
                                    this.min[0],
                                    this.min[1],
                                    this.min[2],
                                    1
                                ],
                                [
                                    this.max[0],
                                    this.min[1],
                                    this.min[2],
                                    1
                                ],
                                [
                                    this.max[0],
                                    this.max[1],
                                    this.min[2],
                                    1
                                ],
                                [
                                    this.min[0],
                                    this.max[1],
                                    this.min[2],
                                    1
                                ],
                                [
                                    this.min[0],
                                    this.min[1],
                                    this.max[2],
                                    1
                                ],
                                [
                                    this.max[0],
                                    this.min[1],
                                    this.max[2],
                                    1
                                ],
                                [
                                    this.max[0],
                                    this.max[1],
                                    this.max[2],
                                    1
                                ],
                                [
                                    this.min[0],
                                    this.max[1],
                                    this.max[2],
                                    1
                                ]
                            ], Q = !0;
                            for(let ee = 0; ee < w.planes.length; ee++){
                                let se = w.planes[ee], qe = 0;
                                for(let je = 0; je < B.length; je++)a.b2(se, B[je]) >= 0 && qe++;
                                if (qe === 0) return 0;
                                qe !== B.length && (Q = !1);
                            }
                            if (Q) return 2;
                            for(let ee = 0; ee < 3; ee++){
                                let se = Number.MAX_VALUE, qe = -Number.MAX_VALUE;
                                for(let je = 0; je < w.points.length; je++){
                                    let it = w.points[je][ee] - this.min[ee];
                                    se = Math.min(se, it), qe = Math.max(qe, it);
                                }
                                if (qe < 0 || se > this.max[ee] - this.min[ee]) return 0;
                            }
                            return 1;
                        }
                    }
                    class ic {
                        constructor(w = 0, B = 0, Q = 0, ee = 0){
                            if (isNaN(w) || w < 0 || isNaN(B) || B < 0 || isNaN(Q) || Q < 0 || isNaN(ee) || ee < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                            this.top = w, this.bottom = B, this.left = Q, this.right = ee;
                        }
                        interpolate(w, B, Q) {
                            return B.top != null && w.top != null && (this.top = a.y.number(w.top, B.top, Q)), B.bottom != null && w.bottom != null && (this.bottom = a.y.number(w.bottom, B.bottom, Q)), B.left != null && w.left != null && (this.left = a.y.number(w.left, B.left, Q)), B.right != null && w.right != null && (this.right = a.y.number(w.right, B.right, Q)), this;
                        }
                        getCenter(w, B) {
                            let Q = a.ac((this.left + w - this.right) / 2, 0, w), ee = a.ac((this.top + B - this.bottom) / 2, 0, B);
                            return new a.P(Q, ee);
                        }
                        equals(w) {
                            return this.top === w.top && this.bottom === w.bottom && this.left === w.left && this.right === w.right;
                        }
                        clone() {
                            return new ic(this.top, this.bottom, this.left, this.right);
                        }
                        toJSON() {
                            return {
                                top: this.top,
                                bottom: this.bottom,
                                left: this.left,
                                right: this.right
                            };
                        }
                    }
                    let yu = 85.051129;
                    class Qs {
                        constructor(w, B, Q, ee, se){
                            this.tileSize = 512, this._renderWorldCopies = se === void 0 || !!se, this._minZoom = w || 0, this._maxZoom = B || 22, this._minPitch = Q == null ? 0 : Q, this._maxPitch = ee == null ? 60 : ee, this.setMaxBounds(), this.width = 0, this.height = 0, this._center = new a.N(0, 0), this._elevation = 0, this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._unmodified = !0, this._edgeInsets = new ic, this._posMatrixCache = {}, this._alignedPosMatrixCache = {}, this._fogMatrixCache = {}, this.minElevationForCurrentTile = 0;
                        }
                        clone() {
                            let w = new Qs(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies);
                            return w.apply(this), w;
                        }
                        apply(w) {
                            this.tileSize = w.tileSize, this.latRange = w.latRange, this.lngRange = w.lngRange, this.width = w.width, this.height = w.height, this._center = w._center, this._elevation = w._elevation, this.minElevationForCurrentTile = w.minElevationForCurrentTile, this.zoom = w.zoom, this.angle = w.angle, this._fov = w._fov, this._pitch = w._pitch, this._unmodified = w._unmodified, this._edgeInsets = w._edgeInsets.clone(), this._calcMatrices();
                        }
                        get minZoom() {
                            return this._minZoom;
                        }
                        set minZoom(w) {
                            this._minZoom !== w && (this._minZoom = w, this.zoom = Math.max(this.zoom, w));
                        }
                        get maxZoom() {
                            return this._maxZoom;
                        }
                        set maxZoom(w) {
                            this._maxZoom !== w && (this._maxZoom = w, this.zoom = Math.min(this.zoom, w));
                        }
                        get minPitch() {
                            return this._minPitch;
                        }
                        set minPitch(w) {
                            this._minPitch !== w && (this._minPitch = w, this.pitch = Math.max(this.pitch, w));
                        }
                        get maxPitch() {
                            return this._maxPitch;
                        }
                        set maxPitch(w) {
                            this._maxPitch !== w && (this._maxPitch = w, this.pitch = Math.min(this.pitch, w));
                        }
                        get renderWorldCopies() {
                            return this._renderWorldCopies;
                        }
                        set renderWorldCopies(w) {
                            w === void 0 ? w = !0 : w === null && (w = !1), this._renderWorldCopies = w;
                        }
                        get worldSize() {
                            return this.tileSize * this.scale;
                        }
                        get centerOffset() {
                            return this.centerPoint._sub(this.size._div(2));
                        }
                        get size() {
                            return new a.P(this.width, this.height);
                        }
                        get bearing() {
                            return -this.angle / Math.PI * 180;
                        }
                        set bearing(w) {
                            let B = -a.b3(w, -180, 180) * Math.PI / 180;
                            this.angle !== B && (this._unmodified = !1, this.angle = B, this._calcMatrices(), this.rotationMatrix = function() {
                                var Q = new a.A(4);
                                return a.A != Float32Array && (Q[1] = 0, Q[2] = 0), Q[0] = 1, Q[3] = 1, Q;
                            }(), function(Q, ee, se) {
                                var qe = ee[0], je = ee[1], it = ee[2], yt = ee[3], Ot = Math.sin(se), Nt = Math.cos(se);
                                Q[0] = qe * Nt + it * Ot, Q[1] = je * Nt + yt * Ot, Q[2] = qe * -Ot + it * Nt, Q[3] = je * -Ot + yt * Nt;
                            }(this.rotationMatrix, this.rotationMatrix, this.angle));
                        }
                        get pitch() {
                            return this._pitch / Math.PI * 180;
                        }
                        set pitch(w) {
                            let B = a.ac(w, this.minPitch, this.maxPitch) / 180 * Math.PI;
                            this._pitch !== B && (this._unmodified = !1, this._pitch = B, this._calcMatrices());
                        }
                        get fov() {
                            return this._fov / Math.PI * 180;
                        }
                        set fov(w) {
                            w = Math.max(.01, Math.min(60, w)), this._fov !== w && (this._unmodified = !1, this._fov = w / 180 * Math.PI, this._calcMatrices());
                        }
                        get zoom() {
                            return this._zoom;
                        }
                        set zoom(w) {
                            let B = Math.min(Math.max(w, this.minZoom), this.maxZoom);
                            this._zoom !== B && (this._unmodified = !1, this._zoom = B, this.tileZoom = Math.max(0, Math.floor(B)), this.scale = this.zoomScale(B), this._constrain(), this._calcMatrices());
                        }
                        get center() {
                            return this._center;
                        }
                        set center(w) {
                            w.lat === this._center.lat && w.lng === this._center.lng || (this._unmodified = !1, this._center = w, this._constrain(), this._calcMatrices());
                        }
                        get elevation() {
                            return this._elevation;
                        }
                        set elevation(w) {
                            w !== this._elevation && (this._elevation = w, this._constrain(), this._calcMatrices());
                        }
                        get padding() {
                            return this._edgeInsets.toJSON();
                        }
                        set padding(w) {
                            this._edgeInsets.equals(w) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, w, 1), this._calcMatrices());
                        }
                        get centerPoint() {
                            return this._edgeInsets.getCenter(this.width, this.height);
                        }
                        isPaddingEqual(w) {
                            return this._edgeInsets.equals(w);
                        }
                        interpolatePadding(w, B, Q) {
                            this._unmodified = !1, this._edgeInsets.interpolate(w, B, Q), this._constrain(), this._calcMatrices();
                        }
                        coveringZoomLevel(w) {
                            let B = (w.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / w.tileSize));
                            return Math.max(0, B);
                        }
                        getVisibleUnwrappedCoordinates(w) {
                            let B = [
                                new a.b4(0, w)
                            ];
                            if (this._renderWorldCopies) {
                                let Q = this.pointCoordinate(new a.P(0, 0)), ee = this.pointCoordinate(new a.P(this.width, 0)), se = this.pointCoordinate(new a.P(this.width, this.height)), qe = this.pointCoordinate(new a.P(0, this.height)), je = Math.floor(Math.min(Q.x, ee.x, se.x, qe.x)), it = Math.floor(Math.max(Q.x, ee.x, se.x, qe.x)), yt = 1;
                                for(let Ot = je - yt; Ot <= it + yt; Ot++)Ot !== 0 && B.push(new a.b4(Ot, w));
                            }
                            return B;
                        }
                        coveringTiles(w) {
                            var B, Q;
                            let ee = this.coveringZoomLevel(w), se = ee;
                            if (w.minzoom !== void 0 && ee < w.minzoom) return [];
                            w.maxzoom !== void 0 && ee > w.maxzoom && (ee = w.maxzoom);
                            let qe = this.pointCoordinate(this.getCameraPoint()), je = a.Z.fromLngLat(this.center), it = Math.pow(2, ee), yt = [
                                it * qe.x,
                                it * qe.y,
                                0
                            ], Ot = [
                                it * je.x,
                                it * je.y,
                                0
                            ], Nt = fl.fromInvProjectionMatrix(this.invModelViewProjectionMatrix, this.worldSize, ee), hr = w.minzoom || 0;
                            !w.terrain && this.pitch <= 60 && this._edgeInsets.top < .1 && (hr = ee);
                            let Sr = w.terrain ? 2 / Math.min(this.tileSize, w.tileSize) * this.tileSize : 3, he = (He)=>({
                                    aabb: new Xc([
                                        He * it,
                                        0,
                                        0
                                    ], [
                                        (He + 1) * it,
                                        it,
                                        0
                                    ]),
                                    zoom: 0,
                                    x: 0,
                                    y: 0,
                                    wrap: He,
                                    fullyVisible: !1
                                }), be = [], Pe = [], Oe = ee, Je = w.reparseOverscaled ? se : ee;
                            if (this._renderWorldCopies) for(let He = 1; He <= 3; He++)be.push(he(-He)), be.push(he(He));
                            for(be.push(he(0)); be.length > 0;){
                                let He = be.pop(), et = He.x, Mt = He.y, Dt = He.fullyVisible;
                                if (!Dt) {
                                    let zr = He.aabb.intersects(Nt);
                                    if (zr === 0) continue;
                                    Dt = zr === 2;
                                }
                                let Ut = w.terrain ? yt : Ot, tr = He.aabb.distanceX(Ut), mr = He.aabb.distanceY(Ut), Rr = Math.max(Math.abs(tr), Math.abs(mr));
                                if (He.zoom === Oe || Rr > Sr + (1 << Oe - He.zoom) - 2 && He.zoom >= hr) {
                                    let zr = Oe - He.zoom, Xr = yt[0] - .5 - (et << zr), di = yt[1] - .5 - (Mt << zr);
                                    Pe.push({
                                        tileID: new a.S(He.zoom === Oe ? Je : He.zoom, He.wrap, He.zoom, et, Mt),
                                        distanceSq: _([
                                            Ot[0] - .5 - et,
                                            Ot[1] - .5 - Mt
                                        ]),
                                        tileDistanceToCamera: Math.sqrt(Xr * Xr + di * di)
                                    });
                                } else for(let zr = 0; zr < 4; zr++){
                                    let Xr = (et << 1) + zr % 2, di = (Mt << 1) + (zr >> 1), Li = He.zoom + 1, Ci = He.aabb.quadrant(zr);
                                    if (w.terrain) {
                                        let Qi = new a.S(Li, He.wrap, Li, Xr, di), Mn = w.terrain.getMinMaxElevation(Qi), pa = (B = Mn.minElevation) !== null && B !== void 0 ? B : this.elevation, ea = (Q = Mn.maxElevation) !== null && Q !== void 0 ? Q : this.elevation;
                                        Ci = new Xc([
                                            Ci.min[0],
                                            Ci.min[1],
                                            pa
                                        ], [
                                            Ci.max[0],
                                            Ci.max[1],
                                            ea
                                        ]);
                                    }
                                    be.push({
                                        aabb: Ci,
                                        zoom: Li,
                                        x: Xr,
                                        y: di,
                                        wrap: He.wrap,
                                        fullyVisible: Dt
                                    });
                                }
                            }
                            return Pe.sort((He, et)=>He.distanceSq - et.distanceSq).map((He)=>He.tileID);
                        }
                        resize(w, B) {
                            this.width = w, this.height = B, this.pixelsToGLUnits = [
                                2 / w,
                                -2 / B
                            ], this._constrain(), this._calcMatrices();
                        }
                        get unmodified() {
                            return this._unmodified;
                        }
                        zoomScale(w) {
                            return Math.pow(2, w);
                        }
                        scaleZoom(w) {
                            return Math.log(w) / Math.LN2;
                        }
                        project(w) {
                            let B = a.ac(w.lat, -85.051129, yu);
                            return new a.P(a.O(w.lng) * this.worldSize, a.Q(B) * this.worldSize);
                        }
                        unproject(w) {
                            return new a.Z(w.x / this.worldSize, w.y / this.worldSize).toLngLat();
                        }
                        get point() {
                            return this.project(this.center);
                        }
                        getCameraPosition() {
                            return {
                                lngLat: this.pointLocation(this.getCameraPoint()),
                                altitude: Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter + this.elevation
                            };
                        }
                        recalculateZoom(w) {
                            let B = this.elevation, Q = Math.cos(this._pitch) * this.cameraToCenterDistance / this._pixelPerMeter, ee = this.pointLocation(this.centerPoint, w), se = w.getElevationForLngLatZoom(ee, this.tileZoom);
                            if (!(this.elevation - se)) return;
                            let qe = Q + B - se, je = Math.cos(this._pitch) * this.cameraToCenterDistance / qe / a.b5(1, ee.lat), it = this.scaleZoom(je / this.tileSize);
                            this._elevation = se, this._center = ee, this.zoom = it;
                        }
                        setLocationAtPoint(w, B) {
                            let Q = this.pointCoordinate(B), ee = this.pointCoordinate(this.centerPoint), se = this.locationCoordinate(w), qe = new a.Z(se.x - (Q.x - ee.x), se.y - (Q.y - ee.y));
                            this.center = this.coordinateLocation(qe), this._renderWorldCopies && (this.center = this.center.wrap());
                        }
                        locationPoint(w, B) {
                            return B ? this.coordinatePoint(this.locationCoordinate(w), B.getElevationForLngLatZoom(w, this.tileZoom), this.pixelMatrix3D) : this.coordinatePoint(this.locationCoordinate(w));
                        }
                        pointLocation(w, B) {
                            return this.coordinateLocation(this.pointCoordinate(w, B));
                        }
                        locationCoordinate(w) {
                            return a.Z.fromLngLat(w);
                        }
                        coordinateLocation(w) {
                            return w && w.toLngLat();
                        }
                        pointCoordinate(w, B) {
                            if (B) {
                                let hr = B.pointCoordinate(w);
                                if (hr != null) return hr;
                            }
                            let Q = [
                                w.x,
                                w.y,
                                0,
                                1
                            ], ee = [
                                w.x,
                                w.y,
                                1,
                                1
                            ];
                            a.af(Q, Q, this.pixelMatrixInverse), a.af(ee, ee, this.pixelMatrixInverse);
                            let se = Q[3], qe = ee[3], je = Q[1] / se, it = ee[1] / qe, yt = Q[2] / se, Ot = ee[2] / qe, Nt = yt === Ot ? 0 : (0 - yt) / (Ot - yt);
                            return new a.Z(a.y.number(Q[0] / se, ee[0] / qe, Nt) / this.worldSize, a.y.number(je, it, Nt) / this.worldSize);
                        }
                        coordinatePoint(w, B = 0, Q = this.pixelMatrix) {
                            let ee = [
                                w.x * this.worldSize,
                                w.y * this.worldSize,
                                B,
                                1
                            ];
                            return a.af(ee, ee, Q), new a.P(ee[0] / ee[3], ee[1] / ee[3]);
                        }
                        getBounds() {
                            let w = Math.max(0, this.height / 2 - this.getHorizon());
                            return new ce().extend(this.pointLocation(new a.P(0, w))).extend(this.pointLocation(new a.P(this.width, w))).extend(this.pointLocation(new a.P(this.width, this.height))).extend(this.pointLocation(new a.P(0, this.height)));
                        }
                        getMaxBounds() {
                            return this.latRange && this.latRange.length === 2 && this.lngRange && this.lngRange.length === 2 ? new ce([
                                this.lngRange[0],
                                this.latRange[0]
                            ], [
                                this.lngRange[1],
                                this.latRange[1]
                            ]) : null;
                        }
                        getHorizon() {
                            return Math.tan(Math.PI / 2 - this._pitch) * this.cameraToCenterDistance * .85;
                        }
                        setMaxBounds(w) {
                            w ? (this.lngRange = [
                                w.getWest(),
                                w.getEast()
                            ], this.latRange = [
                                w.getSouth(),
                                w.getNorth()
                            ], this._constrain()) : (this.lngRange = null, this.latRange = [
                                -85.051129,
                                yu
                            ]);
                        }
                        calculateTileMatrix(w) {
                            let B = w.canonical, Q = this.worldSize / this.zoomScale(B.z), ee = B.x + Math.pow(2, B.z) * w.wrap, se = a.an(new Float64Array(16));
                            return a.J(se, se, [
                                ee * Q,
                                B.y * Q,
                                0
                            ]), a.K(se, se, [
                                Q / a.X,
                                Q / a.X,
                                1
                            ]), se;
                        }
                        calculatePosMatrix(w, B = !1) {
                            let Q = w.key, ee = B ? this._alignedPosMatrixCache : this._posMatrixCache;
                            if (ee[Q]) return ee[Q];
                            let se = this.calculateTileMatrix(w);
                            return a.L(se, B ? this.alignedModelViewProjectionMatrix : this.modelViewProjectionMatrix, se), ee[Q] = new Float32Array(se), ee[Q];
                        }
                        calculateFogMatrix(w) {
                            let B = w.key, Q = this._fogMatrixCache;
                            if (Q[B]) return Q[B];
                            let ee = this.calculateTileMatrix(w);
                            return a.L(ee, this.fogMatrix, ee), Q[B] = new Float32Array(ee), Q[B];
                        }
                        customLayerMatrix() {
                            return this.mercatorMatrix.slice();
                        }
                        getConstrained(w, B) {
                            B = a.ac(+B, this.minZoom, this.maxZoom);
                            let Q = {
                                center: new a.N(w.lng, w.lat),
                                zoom: B
                            }, ee = this.lngRange;
                            if (!this._renderWorldCopies && ee === null) {
                                let He = 179.9999999999;
                                ee = [
                                    -He,
                                    He
                                ];
                            }
                            let se = this.tileSize * this.zoomScale(Q.zoom), qe = 0, je = se, it = 0, yt = se, Ot = 0, Nt = 0, { x: hr, y: Sr } = this.size;
                            if (this.latRange) {
                                let He = this.latRange;
                                qe = a.Q(He[1]) * se, je = a.Q(He[0]) * se, je - qe < Sr && (Ot = Sr / (je - qe));
                            }
                            ee && (it = a.b3(a.O(ee[0]) * se, 0, se), yt = a.b3(a.O(ee[1]) * se, 0, se), yt < it && (yt += se), yt - it < hr && (Nt = hr / (yt - it)));
                            let { x: he, y: be } = this.project.call({
                                worldSize: se
                            }, w), Pe, Oe, Je = Math.max(Nt || 0, Ot || 0);
                            if (Je) {
                                let He = new a.P(Nt ? (yt + it) / 2 : he, Ot ? (je + qe) / 2 : be);
                                return Q.center = this.unproject.call({
                                    worldSize: se
                                }, He).wrap(), Q.zoom += this.scaleZoom(Je), Q;
                            }
                            if (this.latRange) {
                                let He = Sr / 2;
                                be - He < qe && (Oe = qe + He), be + He > je && (Oe = je - He);
                            }
                            if (ee) {
                                let He = (it + yt) / 2, et = he;
                                this._renderWorldCopies && (et = a.b3(he, He - se / 2, He + se / 2));
                                let Mt = hr / 2;
                                et - Mt < it && (Pe = it + Mt), et + Mt > yt && (Pe = yt - Mt);
                            }
                            if (Pe !== void 0 || Oe !== void 0) {
                                let He = new a.P(Pe != null ? Pe : he, Oe != null ? Oe : be);
                                Q.center = this.unproject.call({
                                    worldSize: se
                                }, He).wrap();
                            }
                            return Q;
                        }
                        _constrain() {
                            if (!this.center || !this.width || !this.height || this._constraining) return;
                            this._constraining = !0;
                            let w = this._unmodified, { center: B, zoom: Q } = this.getConstrained(this.center, this.zoom);
                            this.center = B, this.zoom = Q, this._unmodified = w, this._constraining = !1;
                        }
                        _calcMatrices() {
                            if (!this.height) return;
                            let w = this.centerOffset, B = this.point.x, Q = this.point.y;
                            this.cameraToCenterDistance = .5 / Math.tan(this._fov / 2) * this.height, this._pixelPerMeter = a.b5(1, this.center.lat) * this.worldSize;
                            let ee = a.an(new Float64Array(16));
                            a.K(ee, ee, [
                                this.width / 2,
                                -this.height / 2,
                                1
                            ]), a.J(ee, ee, [
                                1,
                                -1,
                                0
                            ]), this.labelPlaneMatrix = ee, ee = a.an(new Float64Array(16)), a.K(ee, ee, [
                                1,
                                -1,
                                1
                            ]), a.J(ee, ee, [
                                -1,
                                -1,
                                0
                            ]), a.K(ee, ee, [
                                2 / this.width,
                                2 / this.height,
                                1
                            ]), this.glCoordMatrix = ee;
                            let se = this.cameraToCenterDistance + this._elevation * this._pixelPerMeter / Math.cos(this._pitch), qe = Math.min(this.elevation, this.minElevationForCurrentTile), je = se - qe * this._pixelPerMeter / Math.cos(this._pitch), it = qe < 0 ? je : se, yt = Math.PI / 2 + this._pitch, Ot = this._fov * (.5 + w.y / this.height), Nt = Math.sin(Ot) * it / Math.sin(a.ac(Math.PI - yt - Ot, .01, Math.PI - .01)), hr = this.getHorizon(), Sr = 2 * Math.atan(hr / this.cameraToCenterDistance) * (.5 + w.y / (2 * hr)), he = Math.sin(Sr) * it / Math.sin(a.ac(Math.PI - yt - Sr, .01, Math.PI - .01)), be = Math.min(Nt, he);
                            this.farZ = 1.01 * (Math.cos(Math.PI / 2 - this._pitch) * be + it), this.nearZ = this.height / 50, ee = new Float64Array(16), a.b6(ee, this._fov, this.width / this.height, this.nearZ, this.farZ), ee[8] = 2 * -w.x / this.width, ee[9] = 2 * w.y / this.height, this.projectionMatrix = a.ae(ee), a.K(ee, ee, [
                                1,
                                -1,
                                1
                            ]), a.J(ee, ee, [
                                0,
                                0,
                                -this.cameraToCenterDistance
                            ]), a.b7(ee, ee, this._pitch), a.ad(ee, ee, this.angle), a.J(ee, ee, [
                                -B,
                                -Q,
                                0
                            ]), this.mercatorMatrix = a.K([], ee, [
                                this.worldSize,
                                this.worldSize,
                                this.worldSize
                            ]), a.K(ee, ee, [
                                1,
                                1,
                                this._pixelPerMeter
                            ]), this.pixelMatrix = a.L(new Float64Array(16), this.labelPlaneMatrix, ee), a.J(ee, ee, [
                                0,
                                0,
                                -this.elevation
                            ]), this.modelViewProjectionMatrix = ee, this.invModelViewProjectionMatrix = a.as([], ee), this.fogMatrix = new Float64Array(16), a.b6(this.fogMatrix, this._fov, this.width / this.height, se, this.farZ), this.fogMatrix[8] = 2 * -w.x / this.width, this.fogMatrix[9] = 2 * w.y / this.height, a.K(this.fogMatrix, this.fogMatrix, [
                                1,
                                -1,
                                1
                            ]), a.J(this.fogMatrix, this.fogMatrix, [
                                0,
                                0,
                                -this.cameraToCenterDistance
                            ]), a.b7(this.fogMatrix, this.fogMatrix, this._pitch), a.ad(this.fogMatrix, this.fogMatrix, this.angle), a.J(this.fogMatrix, this.fogMatrix, [
                                -B,
                                -Q,
                                0
                            ]), a.K(this.fogMatrix, this.fogMatrix, [
                                1,
                                1,
                                this._pixelPerMeter
                            ]), a.J(this.fogMatrix, this.fogMatrix, [
                                0,
                                0,
                                -this.elevation
                            ]), this.pixelMatrix3D = a.L(new Float64Array(16), this.labelPlaneMatrix, ee);
                            let Pe = this.width % 2 / 2, Oe = this.height % 2 / 2, Je = Math.cos(this.angle), He = Math.sin(this.angle), et = B - Math.round(B) + Je * Pe + He * Oe, Mt = Q - Math.round(Q) + Je * Oe + He * Pe, Dt = new Float64Array(ee);
                            if (a.J(Dt, Dt, [
                                et > .5 ? et - 1 : et,
                                Mt > .5 ? Mt - 1 : Mt,
                                0
                            ]), this.alignedModelViewProjectionMatrix = Dt, ee = a.as(new Float64Array(16), this.pixelMatrix), !ee) throw new Error("failed to invert matrix");
                            this.pixelMatrixInverse = ee, this._posMatrixCache = {}, this._alignedPosMatrixCache = {}, this._fogMatrixCache = {};
                        }
                        maxPitchScaleFactor() {
                            if (!this.pixelMatrixInverse) return 1;
                            let w = this.pointCoordinate(new a.P(0, 0)), B = [
                                w.x * this.worldSize,
                                w.y * this.worldSize,
                                0,
                                1
                            ];
                            return a.af(B, B, this.pixelMatrix)[3] / this.cameraToCenterDistance;
                        }
                        getCameraPoint() {
                            let w = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                            return this.centerPoint.add(new a.P(0, w));
                        }
                        getCameraQueryGeometry(w) {
                            let B = this.getCameraPoint();
                            if (w.length === 1) return [
                                w[0],
                                B
                            ];
                            {
                                let Q = B.x, ee = B.y, se = B.x, qe = B.y;
                                for (let je of w)Q = Math.min(Q, je.x), ee = Math.min(ee, je.y), se = Math.max(se, je.x), qe = Math.max(qe, je.y);
                                return [
                                    new a.P(Q, ee),
                                    new a.P(se, ee),
                                    new a.P(se, qe),
                                    new a.P(Q, qe),
                                    new a.P(Q, ee)
                                ];
                            }
                        }
                        lngLatToCameraDepth(w, B) {
                            let Q = this.locationCoordinate(w), ee = [
                                Q.x * this.worldSize,
                                Q.y * this.worldSize,
                                B,
                                1
                            ];
                            return a.af(ee, ee, this.modelViewProjectionMatrix), ee[2] / ee[3];
                        }
                    }
                    function Qh(le, w) {
                        let B, Q = !1, ee = null, se = null, qe = ()=>{
                            ee = null, Q && (le.apply(se, B), ee = setTimeout(qe, w), Q = !1);
                        };
                        return (...je)=>(Q = !0, se = this, B = je, ee || qe(), ee);
                    }
                    class gd {
                        constructor(w){
                            this._getCurrentHash = ()=>{
                                let B = window.location.hash.replace("#", "");
                                if (this._hashName) {
                                    let Q;
                                    return B.split("&").map((ee)=>ee.split("=")).forEach((ee)=>{
                                        ee[0] === this._hashName && (Q = ee);
                                    }), (Q && Q[1] || "").split("/");
                                }
                                return B.split("/");
                            }, this._onHashChange = ()=>{
                                let B = this._getCurrentHash();
                                if (B.length >= 3 && !B.some((Q)=>isNaN(Q))) {
                                    let Q = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(B[3] || 0) : this._map.getBearing();
                                    return this._map.jumpTo({
                                        center: [
                                            +B[2],
                                            +B[1]
                                        ],
                                        zoom: +B[0],
                                        bearing: Q,
                                        pitch: +(B[4] || 0)
                                    }), !0;
                                }
                                return !1;
                            }, this._updateHashUnthrottled = ()=>{
                                let B = window.location.href.replace(/(#.*)?$/, this.getHashString());
                                window.history.replaceState(window.history.state, null, B);
                            }, this._removeHash = ()=>{
                                let B = this._getCurrentHash();
                                if (B.length === 0) return;
                                let Q = B.join("/"), ee = Q;
                                ee.split("&").length > 0 && (ee = ee.split("&")[0]), this._hashName && (ee = `${this._hashName}=${Q}`);
                                let se = window.location.hash.replace(ee, "");
                                se.startsWith("#&") ? se = se.slice(0, 1) + se.slice(2) : se === "#" && (se = "");
                                let qe = window.location.href.replace(/(#.+)?$/, se);
                                qe = qe.replace("&&", "&"), window.history.replaceState(window.history.state, null, qe);
                            }, this._updateHash = Qh(this._updateHashUnthrottled, 300), this._hashName = w && encodeURIComponent(w);
                        }
                        addTo(w) {
                            return this._map = w, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
                        }
                        remove() {
                            return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
                        }
                        getHashString(w) {
                            let B = this._map.getCenter(), Q = Math.round(100 * this._map.getZoom()) / 100, ee = Math.ceil((Q * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), se = Math.pow(10, ee), qe = Math.round(B.lng * se) / se, je = Math.round(B.lat * se) / se, it = this._map.getBearing(), yt = this._map.getPitch(), Ot = "";
                            if (Ot += w ? `/${qe}/${je}/${Q}` : `${Q}/${je}/${qe}`, (it || yt) && (Ot += "/" + Math.round(10 * it) / 10), yt && (Ot += `/${Math.round(yt)}`), this._hashName) {
                                let Nt = this._hashName, hr = !1, Sr = window.location.hash.slice(1).split("&").map((he)=>{
                                    let be = he.split("=")[0];
                                    return be === Nt ? (hr = !0, `${be}=${Ot}`) : he;
                                }).filter((he)=>he);
                                return hr || Sr.push(`${Nt}=${Ot}`), `#${Sr.join("&")}`;
                            }
                            return `#${Ot}`;
                        }
                    }
                    let Gu = {
                        linearity: .3,
                        easing: a.b8(0, 0, .3, 1)
                    }, Pc = a.e({
                        deceleration: 2500,
                        maxSpeed: 1400
                    }, Gu), vc = a.e({
                        deceleration: 20,
                        maxSpeed: 1400
                    }, Gu), sv = a.e({
                        deceleration: 1e3,
                        maxSpeed: 360
                    }, Gu), Lf = a.e({
                        deceleration: 1e3,
                        maxSpeed: 90
                    }, Gu);
                    class Uf {
                        constructor(w){
                            this._map = w, this.clear();
                        }
                        clear() {
                            this._inertiaBuffer = [];
                        }
                        record(w) {
                            this._drainInertiaBuffer(), this._inertiaBuffer.push({
                                time: u.now(),
                                settings: w
                            });
                        }
                        _drainInertiaBuffer() {
                            let w = this._inertiaBuffer, B = u.now();
                            for(; w.length > 0 && B - w[0].time > 160;)w.shift();
                        }
                        _onMoveEnd(w) {
                            if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                            let B = {
                                zoom: 0,
                                bearing: 0,
                                pitch: 0,
                                pan: new a.P(0, 0),
                                pinchAround: void 0,
                                around: void 0
                            };
                            for (let { settings: se } of this._inertiaBuffer)B.zoom += se.zoomDelta || 0, B.bearing += se.bearingDelta || 0, B.pitch += se.pitchDelta || 0, se.panDelta && B.pan._add(se.panDelta), se.around && (B.around = se.around), se.pinchAround && (B.pinchAround = se.pinchAround);
                            let Q = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, ee = {};
                            if (B.pan.mag()) {
                                let se = oh(B.pan.mag(), Q, a.e({}, Pc, w || {}));
                                ee.offset = B.pan.mult(se.amount / B.pan.mag()), ee.center = this._map.transform.center, Iu(ee, se);
                            }
                            if (B.zoom) {
                                let se = oh(B.zoom, Q, vc);
                                ee.zoom = this._map.transform.zoom + se.amount, Iu(ee, se);
                            }
                            if (B.bearing) {
                                let se = oh(B.bearing, Q, sv);
                                ee.bearing = this._map.transform.bearing + a.ac(se.amount, -179, 179), Iu(ee, se);
                            }
                            if (B.pitch) {
                                let se = oh(B.pitch, Q, Lf);
                                ee.pitch = this._map.transform.pitch + se.amount, Iu(ee, se);
                            }
                            if (ee.zoom || ee.bearing) {
                                let se = B.pinchAround === void 0 ? B.around : B.pinchAround;
                                ee.around = se ? this._map.unproject(se) : this._map.getCenter();
                            }
                            return this.clear(), a.e(ee, {
                                noMoveStart: !0
                            });
                        }
                    }
                    function Iu(le, w) {
                        (!le.duration || le.duration < w.duration) && (le.duration = w.duration, le.easing = w.easing);
                    }
                    function oh(le, w, B) {
                        let { maxSpeed: Q, linearity: ee, deceleration: se } = B, qe = a.ac(le * ee / (w / 1e3), -Q, Q), je = Math.abs(qe) / (se * ee);
                        return {
                            easing: B.easing,
                            duration: 1e3 * je,
                            amount: qe * (je / 2)
                        };
                    }
                    class ru extends a.k {
                        preventDefault() {
                            this._defaultPrevented = !0;
                        }
                        get defaultPrevented() {
                            return this._defaultPrevented;
                        }
                        constructor(w, B, Q, ee = {}){
                            let se = c.mousePos(B.getCanvas(), Q), qe = B.unproject(se);
                            super(w, a.e({
                                point: se,
                                lngLat: qe,
                                originalEvent: Q
                            }, ee)), this._defaultPrevented = !1, this.target = B;
                        }
                    }
                    class vf extends a.k {
                        preventDefault() {
                            this._defaultPrevented = !0;
                        }
                        get defaultPrevented() {
                            return this._defaultPrevented;
                        }
                        constructor(w, B, Q){
                            let ee = w === "touchend" ? Q.changedTouches : Q.touches, se = c.touchPos(B.getCanvasContainer(), ee), qe = se.map((it)=>B.unproject(it)), je = se.reduce((it, yt, Ot, Nt)=>it.add(yt.div(Nt.length)), new a.P(0, 0));
                            super(w, {
                                points: se,
                                point: je,
                                lngLats: qe,
                                lngLat: B.unproject(je),
                                originalEvent: Q
                            }), this._defaultPrevented = !1;
                        }
                    }
                    class md extends a.k {
                        preventDefault() {
                            this._defaultPrevented = !0;
                        }
                        get defaultPrevented() {
                            return this._defaultPrevented;
                        }
                        constructor(w, B, Q){
                            super(w, {
                                originalEvent: Q
                            }), this._defaultPrevented = !1;
                        }
                    }
                    class sh {
                        constructor(w, B){
                            this._map = w, this._clickTolerance = B.clickTolerance;
                        }
                        reset() {
                            delete this._mousedownPos;
                        }
                        wheel(w) {
                            return this._firePreventable(new md(w.type, this._map, w));
                        }
                        mousedown(w, B) {
                            return this._mousedownPos = B, this._firePreventable(new ru(w.type, this._map, w));
                        }
                        mouseup(w) {
                            this._map.fire(new ru(w.type, this._map, w));
                        }
                        click(w, B) {
                            this._mousedownPos && this._mousedownPos.dist(B) >= this._clickTolerance || this._map.fire(new ru(w.type, this._map, w));
                        }
                        dblclick(w) {
                            return this._firePreventable(new ru(w.type, this._map, w));
                        }
                        mouseover(w) {
                            this._map.fire(new ru(w.type, this._map, w));
                        }
                        mouseout(w) {
                            this._map.fire(new ru(w.type, this._map, w));
                        }
                        touchstart(w) {
                            return this._firePreventable(new vf(w.type, this._map, w));
                        }
                        touchmove(w) {
                            this._map.fire(new vf(w.type, this._map, w));
                        }
                        touchend(w) {
                            this._map.fire(new vf(w.type, this._map, w));
                        }
                        touchcancel(w) {
                            this._map.fire(new vf(w.type, this._map, w));
                        }
                        _firePreventable(w) {
                            if (this._map.fire(w), w.defaultPrevented) return {};
                        }
                        isEnabled() {
                            return !0;
                        }
                        isActive() {
                            return !1;
                        }
                        enable() {}
                        disable() {}
                    }
                    class Fs {
                        constructor(w){
                            this._map = w;
                        }
                        reset() {
                            this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
                        }
                        mousemove(w) {
                            this._map.fire(new ru(w.type, this._map, w));
                        }
                        mousedown() {
                            this._delayContextMenu = !0, this._ignoreContextMenu = !1;
                        }
                        mouseup() {
                            this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new ru("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
                        }
                        contextmenu(w) {
                            this._delayContextMenu ? this._contextMenuEvent = w : this._ignoreContextMenu || this._map.fire(new ru(w.type, this._map, w)), this._map.listens("contextmenu") && w.preventDefault();
                        }
                        isEnabled() {
                            return !0;
                        }
                        isActive() {
                            return !1;
                        }
                        enable() {}
                        disable() {}
                    }
                    class _u {
                        constructor(w){
                            this._map = w;
                        }
                        get transform() {
                            return this._map._requestedCameraState || this._map.transform;
                        }
                        get center() {
                            return {
                                lng: this.transform.center.lng,
                                lat: this.transform.center.lat
                            };
                        }
                        get zoom() {
                            return this.transform.zoom;
                        }
                        get pitch() {
                            return this.transform.pitch;
                        }
                        get bearing() {
                            return this.transform.bearing;
                        }
                        unproject(w) {
                            return this.transform.pointLocation(a.P.convert(w), this._map.terrain);
                        }
                    }
                    class xu {
                        constructor(w, B){
                            this._map = w, this._tr = new _u(w), this._el = w.getCanvasContainer(), this._container = w.getContainer(), this._clickTolerance = B.clickTolerance || 1;
                        }
                        isEnabled() {
                            return !!this._enabled;
                        }
                        isActive() {
                            return !!this._active;
                        }
                        enable() {
                            this.isEnabled() || (this._enabled = !0);
                        }
                        disable() {
                            this.isEnabled() && (this._enabled = !1);
                        }
                        mousedown(w, B) {
                            this.isEnabled() && w.shiftKey && w.button === 0 && (c.disableDrag(), this._startPos = this._lastPos = B, this._active = !0);
                        }
                        mousemoveWindow(w, B) {
                            if (!this._active) return;
                            let Q = B;
                            if (this._lastPos.equals(Q) || !this._box && Q.dist(this._startPos) < this._clickTolerance) return;
                            let ee = this._startPos;
                            this._lastPos = Q, this._box || (this._box = c.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", w));
                            let se = Math.min(ee.x, Q.x), qe = Math.max(ee.x, Q.x), je = Math.min(ee.y, Q.y), it = Math.max(ee.y, Q.y);
                            c.setTransform(this._box, `translate(${se}px,${je}px)`), this._box.style.width = qe - se + "px", this._box.style.height = it - je + "px";
                        }
                        mouseupWindow(w, B) {
                            if (!this._active || w.button !== 0) return;
                            let Q = this._startPos, ee = B;
                            if (this.reset(), c.suppressClick(), Q.x !== ee.x || Q.y !== ee.y) return this._map.fire(new a.k("boxzoomend", {
                                originalEvent: w
                            })), {
                                cameraAnimation: (se)=>se.fitScreenCoordinates(Q, ee, this._tr.bearing, {
                                        linear: !0
                                    })
                            };
                            this._fireEvent("boxzoomcancel", w);
                        }
                        keydown(w) {
                            this._active && w.keyCode === 27 && (this.reset(), this._fireEvent("boxzoomcancel", w));
                        }
                        reset() {
                            this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (c.remove(this._box), this._box = null), c.enableDrag(), delete this._startPos, delete this._lastPos;
                        }
                        _fireEvent(w, B) {
                            return this._map.fire(new a.k(w, {
                                originalEvent: B
                            }));
                        }
                    }
                    function Lh(le, w) {
                        if (le.length !== w.length) throw new Error(`The number of touches and points are not equal - touches ${le.length}, points ${w.length}`);
                        let B = {};
                        for(let Q = 0; Q < le.length; Q++)B[le[Q].identifier] = w[Q];
                        return B;
                    }
                    class Is {
                        constructor(w){
                            this.reset(), this.numTouches = w.numTouches;
                        }
                        reset() {
                            delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
                        }
                        touchstart(w, B, Q) {
                            (this.centroid || Q.length > this.numTouches) && (this.aborted = !0), this.aborted || (this.startTime === void 0 && (this.startTime = w.timeStamp), Q.length === this.numTouches && (this.centroid = function(ee) {
                                let se = new a.P(0, 0);
                                for (let qe of ee)se._add(qe);
                                return se.div(ee.length);
                            }(B), this.touches = Lh(Q, B)));
                        }
                        touchmove(w, B, Q) {
                            if (this.aborted || !this.centroid) return;
                            let ee = Lh(Q, B);
                            for(let se in this.touches){
                                let qe = ee[se];
                                (!qe || qe.dist(this.touches[se]) > 30) && (this.aborted = !0);
                            }
                        }
                        touchend(w, B, Q) {
                            if ((!this.centroid || w.timeStamp - this.startTime > 500) && (this.aborted = !0), Q.length === 0) {
                                let ee = !this.aborted && this.centroid;
                                if (this.reset(), ee) return ee;
                            }
                        }
                    }
                    class Pf {
                        constructor(w){
                            this.singleTap = new Is(w), this.numTaps = w.numTaps, this.reset();
                        }
                        reset() {
                            this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
                        }
                        touchstart(w, B, Q) {
                            this.singleTap.touchstart(w, B, Q);
                        }
                        touchmove(w, B, Q) {
                            this.singleTap.touchmove(w, B, Q);
                        }
                        touchend(w, B, Q) {
                            let ee = this.singleTap.touchend(w, B, Q);
                            if (ee) {
                                let se = w.timeStamp - this.lastTime < 500, qe = !this.lastTap || this.lastTap.dist(ee) < 30;
                                if (se && qe || this.reset(), this.count++, this.lastTime = w.timeStamp, this.lastTap = ee, this.count === this.numTaps) return this.reset(), ee;
                            }
                        }
                    }
                    class Ic {
                        constructor(w){
                            this._tr = new _u(w), this._zoomIn = new Pf({
                                numTouches: 1,
                                numTaps: 2
                            }), this._zoomOut = new Pf({
                                numTouches: 2,
                                numTaps: 1
                            }), this.reset();
                        }
                        reset() {
                            this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
                        }
                        touchstart(w, B, Q) {
                            this._zoomIn.touchstart(w, B, Q), this._zoomOut.touchstart(w, B, Q);
                        }
                        touchmove(w, B, Q) {
                            this._zoomIn.touchmove(w, B, Q), this._zoomOut.touchmove(w, B, Q);
                        }
                        touchend(w, B, Q) {
                            let ee = this._zoomIn.touchend(w, B, Q), se = this._zoomOut.touchend(w, B, Q), qe = this._tr;
                            return ee ? (this._active = !0, w.preventDefault(), setTimeout(()=>this.reset(), 0), {
                                cameraAnimation: (je)=>je.easeTo({
                                        duration: 300,
                                        zoom: qe.zoom + 1,
                                        around: qe.unproject(ee)
                                    }, {
                                        originalEvent: w
                                    })
                            }) : se ? (this._active = !0, w.preventDefault(), setTimeout(()=>this.reset(), 0), {
                                cameraAnimation: (je)=>je.easeTo({
                                        duration: 300,
                                        zoom: qe.zoom - 1,
                                        around: qe.unproject(se)
                                    }, {
                                        originalEvent: w
                                    })
                            }) : void 0;
                        }
                        touchcancel() {
                            this.reset();
                        }
                        enable() {
                            this._enabled = !0;
                        }
                        disable() {
                            this._enabled = !1, this.reset();
                        }
                        isEnabled() {
                            return this._enabled;
                        }
                        isActive() {
                            return this._active;
                        }
                    }
                    class ju {
                        constructor(w){
                            this._enabled = !!w.enable, this._moveStateManager = w.moveStateManager, this._clickTolerance = w.clickTolerance || 1, this._moveFunction = w.move, this._activateOnStart = !!w.activateOnStart, w.assignEvents(this), this.reset();
                        }
                        reset(w) {
                            this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(w);
                        }
                        _move(...w) {
                            let B = this._moveFunction(...w);
                            if (B.bearingDelta || B.pitchDelta || B.around || B.panDelta) return this._active = !0, B;
                        }
                        dragStart(w, B) {
                            this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(w) && (this._moveStateManager.startMove(w), this._lastPoint = B.length ? B[0] : B, this._activateOnStart && this._lastPoint && (this._active = !0));
                        }
                        dragMove(w, B) {
                            if (!this.isEnabled()) return;
                            let Q = this._lastPoint;
                            if (!Q) return;
                            if (w.preventDefault(), !this._moveStateManager.isValidMoveEvent(w)) return void this.reset(w);
                            let ee = B.length ? B[0] : B;
                            return !this._moved && ee.dist(Q) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = ee, this._move(Q, ee));
                        }
                        dragEnd(w) {
                            this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(w) && (this._moved && c.suppressClick(), this.reset(w));
                        }
                        enable() {
                            this._enabled = !0;
                        }
                        disable() {
                            this._enabled = !1, this.reset();
                        }
                        isEnabled() {
                            return this._enabled;
                        }
                        isActive() {
                            return this._active;
                        }
                        getClickTolerance() {
                            return this._clickTolerance;
                        }
                    }
                    let Vf = {
                        0: 1,
                        2: 2
                    };
                    class pc {
                        constructor(w){
                            this._correctEvent = w.checkCorrectEvent;
                        }
                        startMove(w) {
                            let B = c.mouseButton(w);
                            this._eventButton = B;
                        }
                        endMove(w) {
                            delete this._eventButton;
                        }
                        isValidStartEvent(w) {
                            return this._correctEvent(w);
                        }
                        isValidMoveEvent(w) {
                            return !function(B, Q) {
                                let ee = Vf[Q];
                                return B.buttons === void 0 || (B.buttons & ee) !== ee;
                            }(w, this._eventButton);
                        }
                        isValidEndEvent(w) {
                            return c.mouseButton(w) === this._eventButton;
                        }
                    }
                    class pf {
                        constructor(){
                            this._firstTouch = void 0;
                        }
                        _isOneFingerTouch(w) {
                            return w.targetTouches.length === 1;
                        }
                        _isSameTouchEvent(w) {
                            return w.targetTouches[0].identifier === this._firstTouch;
                        }
                        startMove(w) {
                            this._firstTouch = w.targetTouches[0].identifier;
                        }
                        endMove(w) {
                            delete this._firstTouch;
                        }
                        isValidStartEvent(w) {
                            return this._isOneFingerTouch(w);
                        }
                        isValidMoveEvent(w) {
                            return this._isOneFingerTouch(w) && this._isSameTouchEvent(w);
                        }
                        isValidEndEvent(w) {
                            return this._isOneFingerTouch(w) && this._isSameTouchEvent(w);
                        }
                    }
                    let Ph = (le)=>{
                        le.mousedown = le.dragStart, le.mousemoveWindow = le.dragMove, le.mouseup = le.dragEnd, le.contextmenu = (w)=>{
                            w.preventDefault();
                        };
                    }, Dl = ({ enable: le, clickTolerance: w, bearingDegreesPerPixelMoved: B = .8 })=>{
                        let Q = new pc({
                            checkCorrectEvent: (ee)=>c.mouseButton(ee) === 0 && ee.ctrlKey || c.mouseButton(ee) === 2
                        });
                        return new ju({
                            clickTolerance: w,
                            move: (ee, se)=>({
                                    bearingDelta: (se.x - ee.x) * B
                                }),
                            moveStateManager: Q,
                            enable: le,
                            assignEvents: Ph
                        });
                    }, Ih = ({ enable: le, clickTolerance: w, pitchDegreesPerPixelMoved: B = -0.5 })=>{
                        let Q = new pc({
                            checkCorrectEvent: (ee)=>c.mouseButton(ee) === 0 && ee.ctrlKey || c.mouseButton(ee) === 2
                        });
                        return new ju({
                            clickTolerance: w,
                            move: (ee, se)=>({
                                    pitchDelta: (se.y - ee.y) * B
                                }),
                            moveStateManager: Q,
                            enable: le,
                            assignEvents: Ph
                        });
                    };
                    class Wu {
                        constructor(w, B){
                            this._clickTolerance = w.clickTolerance || 1, this._map = B, this.reset();
                        }
                        reset() {
                            this._active = !1, this._touches = {}, this._sum = new a.P(0, 0);
                        }
                        _shouldBePrevented(w) {
                            return w < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
                        }
                        touchstart(w, B, Q) {
                            return this._calculateTransform(w, B, Q);
                        }
                        touchmove(w, B, Q) {
                            if (this._active) {
                                if (!this._shouldBePrevented(Q.length)) return w.preventDefault(), this._calculateTransform(w, B, Q);
                                this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", w);
                            }
                        }
                        touchend(w, B, Q) {
                            this._calculateTransform(w, B, Q), this._active && this._shouldBePrevented(Q.length) && this.reset();
                        }
                        touchcancel() {
                            this.reset();
                        }
                        _calculateTransform(w, B, Q) {
                            Q.length > 0 && (this._active = !0);
                            let ee = Lh(Q, B), se = new a.P(0, 0), qe = new a.P(0, 0), je = 0;
                            for(let yt in ee){
                                let Ot = ee[yt], Nt = this._touches[yt];
                                Nt && (se._add(Ot), qe._add(Ot.sub(Nt)), je++, ee[yt] = Ot);
                            }
                            if (this._touches = ee, this._shouldBePrevented(je) || !qe.mag()) return;
                            let it = qe.div(je);
                            return this._sum._add(it), this._sum.mag() < this._clickTolerance ? void 0 : {
                                around: se.div(je),
                                panDelta: it
                            };
                        }
                        enable() {
                            this._enabled = !0;
                        }
                        disable() {
                            this._enabled = !1, this.reset();
                        }
                        isEnabled() {
                            return this._enabled;
                        }
                        isActive() {
                            return this._active;
                        }
                    }
                    class Rc {
                        constructor(){
                            this.reset();
                        }
                        reset() {
                            this._active = !1, delete this._firstTwoTouches;
                        }
                        touchstart(w, B, Q) {
                            this._firstTwoTouches || Q.length < 2 || (this._firstTwoTouches = [
                                Q[0].identifier,
                                Q[1].identifier
                            ], this._start([
                                B[0],
                                B[1]
                            ]));
                        }
                        touchmove(w, B, Q) {
                            if (!this._firstTwoTouches) return;
                            w.preventDefault();
                            let [ee, se] = this._firstTwoTouches, qe = gc(Q, B, ee), je = gc(Q, B, se);
                            if (!qe || !je) return;
                            let it = this._aroundCenter ? null : qe.add(je).div(2);
                            return this._move([
                                qe,
                                je
                            ], it, w);
                        }
                        touchend(w, B, Q) {
                            if (!this._firstTwoTouches) return;
                            let [ee, se] = this._firstTwoTouches, qe = gc(Q, B, ee), je = gc(Q, B, se);
                            qe && je || (this._active && c.suppressClick(), this.reset());
                        }
                        touchcancel() {
                            this.reset();
                        }
                        enable(w) {
                            this._enabled = !0, this._aroundCenter = !!w && w.around === "center";
                        }
                        disable() {
                            this._enabled = !1, this.reset();
                        }
                        isEnabled() {
                            return !!this._enabled;
                        }
                        isActive() {
                            return !!this._active;
                        }
                    }
                    function gc(le, w, B) {
                        for(let Q = 0; Q < le.length; Q++)if (le[Q].identifier === B) return w[Q];
                    }
                    function hl(le, w) {
                        return Math.log(le / w) / Math.LN2;
                    }
                    class iu extends Rc {
                        reset() {
                            super.reset(), delete this._distance, delete this._startDistance;
                        }
                        _start(w) {
                            this._startDistance = this._distance = w[0].dist(w[1]);
                        }
                        _move(w, B) {
                            let Q = this._distance;
                            if (this._distance = w[0].dist(w[1]), this._active || !(Math.abs(hl(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                                zoomDelta: hl(this._distance, Q),
                                pinchAround: B
                            };
                        }
                    }
                    function mc(le, w) {
                        return 180 * le.angleWith(w) / Math.PI;
                    }
                    class Yc extends Rc {
                        reset() {
                            super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
                        }
                        _start(w) {
                            this._startVector = this._vector = w[0].sub(w[1]), this._minDiameter = w[0].dist(w[1]);
                        }
                        _move(w, B, Q) {
                            let ee = this._vector;
                            if (this._vector = w[0].sub(w[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                                bearingDelta: mc(this._vector, ee),
                                pinchAround: B
                            };
                        }
                        _isBelowThreshold(w) {
                            this._minDiameter = Math.min(this._minDiameter, w.mag());
                            let B = 25 / (Math.PI * this._minDiameter) * 360, Q = mc(w, this._startVector);
                            return Math.abs(Q) < B;
                        }
                    }
                    function nc(le) {
                        return Math.abs(le.y) > Math.abs(le.x);
                    }
                    class gf extends Rc {
                        constructor(w){
                            super(), this._currentTouchCount = 0, this._map = w;
                        }
                        reset() {
                            super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
                        }
                        touchstart(w, B, Q) {
                            super.touchstart(w, B, Q), this._currentTouchCount = Q.length;
                        }
                        _start(w) {
                            this._lastPoints = w, nc(w[0].sub(w[1])) && (this._valid = !1);
                        }
                        _move(w, B, Q) {
                            if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
                            let ee = w[0].sub(this._lastPoints[0]), se = w[1].sub(this._lastPoints[1]);
                            return this._valid = this.gestureBeginsVertically(ee, se, Q.timeStamp), this._valid ? (this._lastPoints = w, this._active = !0, {
                                pitchDelta: (ee.y + se.y) / 2 * -0.5
                            }) : void 0;
                        }
                        gestureBeginsVertically(w, B, Q) {
                            if (this._valid !== void 0) return this._valid;
                            let ee = w.mag() >= 2, se = B.mag() >= 2;
                            if (!ee && !se) return;
                            if (!ee || !se) return this._firstMove === void 0 && (this._firstMove = Q), Q - this._firstMove < 100 && void 0;
                            let qe = w.y > 0 == B.y > 0;
                            return nc(w) && nc(B) && qe;
                        }
                    }
                    let gt = {
                        panStep: 100,
                        bearingStep: 15,
                        pitchStep: 10
                    };
                    class Bt {
                        constructor(w){
                            this._tr = new _u(w);
                            let B = gt;
                            this._panStep = B.panStep, this._bearingStep = B.bearingStep, this._pitchStep = B.pitchStep, this._rotationDisabled = !1;
                        }
                        reset() {
                            this._active = !1;
                        }
                        keydown(w) {
                            if (w.altKey || w.ctrlKey || w.metaKey) return;
                            let B = 0, Q = 0, ee = 0, se = 0, qe = 0;
                            switch(w.keyCode){
                                case 61:
                                case 107:
                                case 171:
                                case 187:
                                    B = 1;
                                    break;
                                case 189:
                                case 109:
                                case 173:
                                    B = -1;
                                    break;
                                case 37:
                                    w.shiftKey ? Q = -1 : (w.preventDefault(), se = -1);
                                    break;
                                case 39:
                                    w.shiftKey ? Q = 1 : (w.preventDefault(), se = 1);
                                    break;
                                case 38:
                                    w.shiftKey ? ee = 1 : (w.preventDefault(), qe = -1);
                                    break;
                                case 40:
                                    w.shiftKey ? ee = -1 : (w.preventDefault(), qe = 1);
                                    break;
                                default:
                                    return;
                            }
                            return this._rotationDisabled && (Q = 0, ee = 0), {
                                cameraAnimation: (je)=>{
                                    let it = this._tr;
                                    je.easeTo({
                                        duration: 300,
                                        easeId: "keyboardHandler",
                                        easing: wr,
                                        zoom: B ? Math.round(it.zoom) + B * (w.shiftKey ? 2 : 1) : it.zoom,
                                        bearing: it.bearing + Q * this._bearingStep,
                                        pitch: it.pitch + ee * this._pitchStep,
                                        offset: [
                                            -se * this._panStep,
                                            -qe * this._panStep
                                        ],
                                        center: it.center
                                    }, {
                                        originalEvent: w
                                    });
                                }
                            };
                        }
                        enable() {
                            this._enabled = !0;
                        }
                        disable() {
                            this._enabled = !1, this.reset();
                        }
                        isEnabled() {
                            return this._enabled;
                        }
                        isActive() {
                            return this._active;
                        }
                        disableRotation() {
                            this._rotationDisabled = !0;
                        }
                        enableRotation() {
                            this._rotationDisabled = !1;
                        }
                    }
                    function wr(le) {
                        return le * (2 - le);
                    }
                    let vr = 4.000244140625;
                    class Ur {
                        constructor(w, B){
                            this._onTimeout = (Q)=>{
                                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(Q);
                            }, this._map = w, this._tr = new _u(w), this._triggerRenderFrame = B, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = .0022222222222222222;
                        }
                        setZoomRate(w) {
                            this._defaultZoomRate = w;
                        }
                        setWheelZoomRate(w) {
                            this._wheelZoomRate = w;
                        }
                        isEnabled() {
                            return !!this._enabled;
                        }
                        isActive() {
                            return !!this._active || this._finishTimeout !== void 0;
                        }
                        isZooming() {
                            return !!this._zooming;
                        }
                        enable(w) {
                            this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!w && w.around === "center");
                        }
                        disable() {
                            this.isEnabled() && (this._enabled = !1);
                        }
                        _shouldBePrevented(w) {
                            return !!this._map.cooperativeGestures.isEnabled() && !(w.ctrlKey || this._map.cooperativeGestures.isBypassed(w));
                        }
                        wheel(w) {
                            if (!this.isEnabled()) return;
                            if (this._shouldBePrevented(w)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", w);
                            let B = w.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * w.deltaY : w.deltaY, Q = u.now(), ee = Q - (this._lastWheelEventTime || 0);
                            this._lastWheelEventTime = Q, B !== 0 && B % vr == 0 ? this._type = "wheel" : B !== 0 && Math.abs(B) < 4 ? this._type = "trackpad" : ee > 400 ? (this._type = null, this._lastValue = B, this._timeout = setTimeout(this._onTimeout, 40, w)) : this._type || (this._type = Math.abs(ee * B) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, B += this._lastValue)), w.shiftKey && B && (B /= 4), this._type && (this._lastWheelEvent = w, this._delta -= B, this._active || this._start(w)), w.preventDefault();
                        }
                        _start(w) {
                            if (!this._delta) return;
                            this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                            let B = c.mousePos(this._map.getCanvas(), w), Q = this._tr;
                            this._around = B.y > Q.transform.height / 2 - Q.transform.getHorizon() ? a.N.convert(this._aroundCenter ? Q.center : Q.unproject(B)) : a.N.convert(Q.center), this._aroundPoint = Q.transform.locationPoint(this._around), this._frameId || (this._frameId = !0, this._triggerRenderFrame());
                        }
                        renderFrame() {
                            if (!this._frameId || (this._frameId = null, !this.isActive())) return;
                            let w = this._tr.transform;
                            if (this._delta !== 0) {
                                let it = this._type === "wheel" && Math.abs(this._delta) > vr ? this._wheelZoomRate : this._defaultZoomRate, yt = 2 / (1 + Math.exp(-Math.abs(this._delta * it)));
                                this._delta < 0 && yt !== 0 && (yt = 1 / yt);
                                let Ot = typeof this._targetZoom == "number" ? w.zoomScale(this._targetZoom) : w.scale;
                                this._targetZoom = Math.min(w.maxZoom, Math.max(w.minZoom, w.scaleZoom(Ot * yt))), this._type === "wheel" && (this._startZoom = w.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                            }
                            let B = typeof this._targetZoom == "number" ? this._targetZoom : w.zoom, Q = this._startZoom, ee = this._easing, se, qe = !1, je = u.now() - this._lastWheelEventTime;
                            if (this._type === "wheel" && Q && ee && je) {
                                let it = Math.min(je / 200, 1), yt = ee(it);
                                se = a.y.number(Q, B, yt), it < 1 ? this._frameId || (this._frameId = !0) : qe = !0;
                            } else se = B, qe = !0;
                            return this._active = !0, qe && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                                this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                            }, 200)), {
                                noInertia: !0,
                                needsRenderFrame: !qe,
                                zoomDelta: se - w.zoom,
                                around: this._aroundPoint,
                                originalEvent: this._lastWheelEvent
                            };
                        }
                        _smoothOutEasing(w) {
                            let B = a.b9;
                            if (this._prevEase) {
                                let Q = this._prevEase, ee = (u.now() - Q.start) / Q.duration, se = Q.easing(ee + .01) - Q.easing(ee), qe = .27 / Math.sqrt(se * se + 1e-4) * .01, je = Math.sqrt(.0729 - qe * qe);
                                B = a.b8(qe, je, .25, 1);
                            }
                            return this._prevEase = {
                                start: u.now(),
                                duration: w,
                                easing: B
                            }, B;
                        }
                        reset() {
                            this._active = !1, this._zooming = !1, delete this._targetZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                        }
                    }
                    class fi {
                        constructor(w, B){
                            this._clickZoom = w, this._tapZoom = B;
                        }
                        enable() {
                            this._clickZoom.enable(), this._tapZoom.enable();
                        }
                        disable() {
                            this._clickZoom.disable(), this._tapZoom.disable();
                        }
                        isEnabled() {
                            return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
                        }
                        isActive() {
                            return this._clickZoom.isActive() || this._tapZoom.isActive();
                        }
                    }
                    class xi {
                        constructor(w){
                            this._tr = new _u(w), this.reset();
                        }
                        reset() {
                            this._active = !1;
                        }
                        dblclick(w, B) {
                            return w.preventDefault(), {
                                cameraAnimation: (Q)=>{
                                    Q.easeTo({
                                        duration: 300,
                                        zoom: this._tr.zoom + (w.shiftKey ? -1 : 1),
                                        around: this._tr.unproject(B)
                                    }, {
                                        originalEvent: w
                                    });
                                }
                            };
                        }
                        enable() {
                            this._enabled = !0;
                        }
                        disable() {
                            this._enabled = !1, this.reset();
                        }
                        isEnabled() {
                            return this._enabled;
                        }
                        isActive() {
                            return this._active;
                        }
                    }
                    class Fi {
                        constructor(){
                            this._tap = new Pf({
                                numTouches: 1,
                                numTaps: 1
                            }), this.reset();
                        }
                        reset() {
                            this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
                        }
                        touchstart(w, B, Q) {
                            if (!this._swipePoint) {
                                if (this._tapTime) {
                                    let ee = B[0], se = w.timeStamp - this._tapTime < 500, qe = this._tapPoint.dist(ee) < 30;
                                    se && qe ? Q.length > 0 && (this._swipePoint = ee, this._swipeTouch = Q[0].identifier) : this.reset();
                                } else this._tap.touchstart(w, B, Q);
                            }
                        }
                        touchmove(w, B, Q) {
                            if (this._tapTime) {
                                if (this._swipePoint) {
                                    if (Q[0].identifier !== this._swipeTouch) return;
                                    let ee = B[0], se = ee.y - this._swipePoint.y;
                                    return this._swipePoint = ee, w.preventDefault(), this._active = !0, {
                                        zoomDelta: se / 128
                                    };
                                }
                            } else this._tap.touchmove(w, B, Q);
                        }
                        touchend(w, B, Q) {
                            if (this._tapTime) this._swipePoint && Q.length === 0 && this.reset();
                            else {
                                let ee = this._tap.touchend(w, B, Q);
                                ee && (this._tapTime = w.timeStamp, this._tapPoint = ee);
                            }
                        }
                        touchcancel() {
                            this.reset();
                        }
                        enable() {
                            this._enabled = !0;
                        }
                        disable() {
                            this._enabled = !1, this.reset();
                        }
                        isEnabled() {
                            return this._enabled;
                        }
                        isActive() {
                            return this._active;
                        }
                    }
                    class Xi {
                        constructor(w, B, Q){
                            this._el = w, this._mousePan = B, this._touchPan = Q;
                        }
                        enable(w) {
                            this._inertiaOptions = w || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
                        }
                        disable() {
                            this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
                        }
                        isEnabled() {
                            return this._mousePan.isEnabled() && this._touchPan.isEnabled();
                        }
                        isActive() {
                            return this._mousePan.isActive() || this._touchPan.isActive();
                        }
                    }
                    class hn {
                        constructor(w, B, Q){
                            this._pitchWithRotate = w.pitchWithRotate, this._mouseRotate = B, this._mousePitch = Q;
                        }
                        enable() {
                            this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
                        }
                        disable() {
                            this._mouseRotate.disable(), this._mousePitch.disable();
                        }
                        isEnabled() {
                            return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
                        }
                        isActive() {
                            return this._mouseRotate.isActive() || this._mousePitch.isActive();
                        }
                    }
                    class Ti {
                        constructor(w, B, Q, ee){
                            this._el = w, this._touchZoom = B, this._touchRotate = Q, this._tapDragZoom = ee, this._rotationDisabled = !1, this._enabled = !0;
                        }
                        enable(w) {
                            this._touchZoom.enable(w), this._rotationDisabled || this._touchRotate.enable(w), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
                        }
                        disable() {
                            this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
                        }
                        isEnabled() {
                            return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
                        }
                        isActive() {
                            return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
                        }
                        disableRotation() {
                            this._rotationDisabled = !0, this._touchRotate.disable();
                        }
                        enableRotation() {
                            this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
                        }
                    }
                    class qi {
                        constructor(w, B){
                            this._bypassKey = navigator.userAgent.indexOf("Mac") !== -1 ? "metaKey" : "ctrlKey", this._map = w, this._options = B, this._enabled = !1;
                        }
                        isActive() {
                            return !1;
                        }
                        reset() {}
                        _setupUI() {
                            if (this._container) return;
                            let w = this._map.getCanvasContainer();
                            w.classList.add("maplibregl-cooperative-gestures"), this._container = c.create("div", "maplibregl-cooperative-gesture-screen", w);
                            let B = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
                            this._bypassKey === "metaKey" && (B = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
                            let Q = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), ee = document.createElement("div");
                            ee.className = "maplibregl-desktop-message", ee.textContent = B, this._container.appendChild(ee);
                            let se = document.createElement("div");
                            se.className = "maplibregl-mobile-message", se.textContent = Q, this._container.appendChild(se), this._container.setAttribute("aria-hidden", "true");
                        }
                        _destroyUI() {
                            this._container && (c.remove(this._container), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
                        }
                        enable() {
                            this._setupUI(), this._enabled = !0;
                        }
                        disable() {
                            this._enabled = !1, this._destroyUI();
                        }
                        isEnabled() {
                            return this._enabled;
                        }
                        isBypassed(w) {
                            return w[this._bypassKey];
                        }
                        notifyGestureBlocked(w, B) {
                            this._enabled && (this._map.fire(new a.k("cooperativegestureprevented", {
                                gestureType: w,
                                originalEvent: B
                            })), this._container.classList.add("maplibregl-show"), setTimeout(()=>{
                                this._container.classList.remove("maplibregl-show");
                            }, 100));
                        }
                    }
                    let Ii = (le)=>le.zoom || le.drag || le.pitch || le.rotate;
                    class mi extends a.k {
                    }
                    function Pn(le) {
                        return le.panDelta && le.panDelta.mag() || le.zoomDelta || le.bearingDelta || le.pitchDelta;
                    }
                    class Ma {
                        constructor(w, B){
                            this.handleWindowEvent = (ee)=>{
                                this.handleEvent(ee, `${ee.type}Window`);
                            }, this.handleEvent = (ee, se)=>{
                                if (ee.type === "blur") return void this.stop(!0);
                                this._updatingCamera = !0;
                                let qe = ee.type === "renderFrame" ? void 0 : ee, je = {
                                    needsRenderFrame: !1
                                }, it = {}, yt = {}, Ot = ee.touches, Nt = Ot ? this._getMapTouches(Ot) : void 0, hr = Nt ? c.touchPos(this._map.getCanvas(), Nt) : c.mousePos(this._map.getCanvas(), ee);
                                for (let { handlerName: be, handler: Pe, allowed: Oe } of this._handlers){
                                    if (!Pe.isEnabled()) continue;
                                    let Je;
                                    this._blockedByActive(yt, Oe, be) ? Pe.reset() : Pe[se || ee.type] && (Je = Pe[se || ee.type](ee, hr, Nt), this.mergeHandlerResult(je, it, Je, be, qe), Je && Je.needsRenderFrame && this._triggerRenderFrame()), (Je || Pe.isActive()) && (yt[be] = Pe);
                                }
                                let Sr = {};
                                for(let be in this._previousActiveHandlers)yt[be] || (Sr[be] = qe);
                                this._previousActiveHandlers = yt, (Object.keys(Sr).length || Pn(je)) && (this._changes.push([
                                    je,
                                    it,
                                    Sr
                                ]), this._triggerRenderFrame()), (Object.keys(yt).length || Pn(je)) && this._map._stop(!0), this._updatingCamera = !1;
                                let { cameraAnimation: he } = je;
                                he && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], he(this._map));
                            }, this._map = w, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Uf(w), this._bearingSnap = B.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(B);
                            let Q = this._el;
                            this._listeners = [
                                [
                                    Q,
                                    "touchstart",
                                    {
                                        passive: !0
                                    }
                                ],
                                [
                                    Q,
                                    "touchmove",
                                    {
                                        passive: !1
                                    }
                                ],
                                [
                                    Q,
                                    "touchend",
                                    void 0
                                ],
                                [
                                    Q,
                                    "touchcancel",
                                    void 0
                                ],
                                [
                                    Q,
                                    "mousedown",
                                    void 0
                                ],
                                [
                                    Q,
                                    "mousemove",
                                    void 0
                                ],
                                [
                                    Q,
                                    "mouseup",
                                    void 0
                                ],
                                [
                                    document,
                                    "mousemove",
                                    {
                                        capture: !0
                                    }
                                ],
                                [
                                    document,
                                    "mouseup",
                                    void 0
                                ],
                                [
                                    Q,
                                    "mouseover",
                                    void 0
                                ],
                                [
                                    Q,
                                    "mouseout",
                                    void 0
                                ],
                                [
                                    Q,
                                    "dblclick",
                                    void 0
                                ],
                                [
                                    Q,
                                    "click",
                                    void 0
                                ],
                                [
                                    Q,
                                    "keydown",
                                    {
                                        capture: !1
                                    }
                                ],
                                [
                                    Q,
                                    "keyup",
                                    void 0
                                ],
                                [
                                    Q,
                                    "wheel",
                                    {
                                        passive: !1
                                    }
                                ],
                                [
                                    Q,
                                    "contextmenu",
                                    void 0
                                ],
                                [
                                    window,
                                    "blur",
                                    void 0
                                ]
                            ];
                            for (let [ee, se, qe] of this._listeners)c.addEventListener(ee, se, ee === document ? this.handleWindowEvent : this.handleEvent, qe);
                        }
                        destroy() {
                            for (let [w, B, Q] of this._listeners)c.removeEventListener(w, B, w === document ? this.handleWindowEvent : this.handleEvent, Q);
                        }
                        _addDefaultHandlers(w) {
                            let B = this._map, Q = B.getCanvasContainer();
                            this._add("mapEvent", new sh(B, w));
                            let ee = B.boxZoom = new xu(B, w);
                            this._add("boxZoom", ee), w.interactive && w.boxZoom && ee.enable();
                            let se = B.cooperativeGestures = new qi(B, w.cooperativeGestures);
                            this._add("cooperativeGestures", se), w.cooperativeGestures && se.enable();
                            let qe = new Ic(B), je = new xi(B);
                            B.doubleClickZoom = new fi(je, qe), this._add("tapZoom", qe), this._add("clickZoom", je), w.interactive && w.doubleClickZoom && B.doubleClickZoom.enable();
                            let it = new Fi;
                            this._add("tapDragZoom", it);
                            let yt = B.touchPitch = new gf(B);
                            this._add("touchPitch", yt), w.interactive && w.touchPitch && B.touchPitch.enable(w.touchPitch);
                            let Ot = Dl(w), Nt = Ih(w);
                            B.dragRotate = new hn(w, Ot, Nt), this._add("mouseRotate", Ot, [
                                "mousePitch"
                            ]), this._add("mousePitch", Nt, [
                                "mouseRotate"
                            ]), w.interactive && w.dragRotate && B.dragRotate.enable();
                            let hr = (({ enable: Je, clickTolerance: He })=>{
                                let et = new pc({
                                    checkCorrectEvent: (Mt)=>c.mouseButton(Mt) === 0 && !Mt.ctrlKey
                                });
                                return new ju({
                                    clickTolerance: He,
                                    move: (Mt, Dt)=>({
                                            around: Dt,
                                            panDelta: Dt.sub(Mt)
                                        }),
                                    activateOnStart: !0,
                                    moveStateManager: et,
                                    enable: Je,
                                    assignEvents: Ph
                                });
                            })(w), Sr = new Wu(w, B);
                            B.dragPan = new Xi(Q, hr, Sr), this._add("mousePan", hr), this._add("touchPan", Sr, [
                                "touchZoom",
                                "touchRotate"
                            ]), w.interactive && w.dragPan && B.dragPan.enable(w.dragPan);
                            let he = new Yc, be = new iu;
                            B.touchZoomRotate = new Ti(Q, be, he, it), this._add("touchRotate", he, [
                                "touchPan",
                                "touchZoom"
                            ]), this._add("touchZoom", be, [
                                "touchPan",
                                "touchRotate"
                            ]), w.interactive && w.touchZoomRotate && B.touchZoomRotate.enable(w.touchZoomRotate);
                            let Pe = B.scrollZoom = new Ur(B, ()=>this._triggerRenderFrame());
                            this._add("scrollZoom", Pe, [
                                "mousePan"
                            ]), w.interactive && w.scrollZoom && B.scrollZoom.enable(w.scrollZoom);
                            let Oe = B.keyboard = new Bt(B);
                            this._add("keyboard", Oe), w.interactive && w.keyboard && B.keyboard.enable(), this._add("blockableMapEvent", new Fs(B));
                        }
                        _add(w, B, Q) {
                            this._handlers.push({
                                handlerName: w,
                                handler: B,
                                allowed: Q
                            }), this._handlersById[w] = B;
                        }
                        stop(w) {
                            if (!this._updatingCamera) {
                                for (let { handler: B } of this._handlers)B.reset();
                                this._inertia.clear(), this._fireEvents({}, {}, w), this._changes = [];
                            }
                        }
                        isActive() {
                            for (let { handler: w } of this._handlers)if (w.isActive()) return !0;
                            return !1;
                        }
                        isZooming() {
                            return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
                        }
                        isRotating() {
                            return !!this._eventsInProgress.rotate;
                        }
                        isMoving() {
                            return !!Ii(this._eventsInProgress) || this.isZooming();
                        }
                        _blockedByActive(w, B, Q) {
                            for(let ee in w)if (ee !== Q && (!B || B.indexOf(ee) < 0)) return !0;
                            return !1;
                        }
                        _getMapTouches(w) {
                            let B = [];
                            for (let Q of w)this._el.contains(Q.target) && B.push(Q);
                            return B;
                        }
                        mergeHandlerResult(w, B, Q, ee, se) {
                            if (!Q) return;
                            a.e(w, Q);
                            let qe = {
                                handlerName: ee,
                                originalEvent: Q.originalEvent || se
                            };
                            Q.zoomDelta !== void 0 && (B.zoom = qe), Q.panDelta !== void 0 && (B.drag = qe), Q.pitchDelta !== void 0 && (B.pitch = qe), Q.bearingDelta !== void 0 && (B.rotate = qe);
                        }
                        _applyChanges() {
                            let w = {}, B = {}, Q = {};
                            for (let [ee, se, qe] of this._changes)ee.panDelta && (w.panDelta = (w.panDelta || new a.P(0, 0))._add(ee.panDelta)), ee.zoomDelta && (w.zoomDelta = (w.zoomDelta || 0) + ee.zoomDelta), ee.bearingDelta && (w.bearingDelta = (w.bearingDelta || 0) + ee.bearingDelta), ee.pitchDelta && (w.pitchDelta = (w.pitchDelta || 0) + ee.pitchDelta), ee.around !== void 0 && (w.around = ee.around), ee.pinchAround !== void 0 && (w.pinchAround = ee.pinchAround), ee.noInertia && (w.noInertia = ee.noInertia), a.e(B, se), a.e(Q, qe);
                            this._updateMapTransform(w, B, Q), this._changes = [];
                        }
                        _updateMapTransform(w, B, Q) {
                            let ee = this._map, se = ee._getTransformForUpdate(), qe = ee.terrain;
                            if (!(Pn(w) || qe && this._terrainMovement)) return this._fireEvents(B, Q, !0);
                            let { panDelta: je, zoomDelta: it, bearingDelta: yt, pitchDelta: Ot, around: Nt, pinchAround: hr } = w;
                            hr !== void 0 && (Nt = hr), ee._stop(!0), Nt = Nt || ee.transform.centerPoint;
                            let Sr = se.pointLocation(je ? Nt.sub(je) : Nt);
                            yt && (se.bearing += yt), Ot && (se.pitch += Ot), it && (se.zoom += it), qe ? this._terrainMovement || !B.drag && !B.zoom ? B.drag && this._terrainMovement ? se.center = se.pointLocation(se.centerPoint.sub(je)) : se.setLocationAtPoint(Sr, Nt) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, se.setLocationAtPoint(Sr, Nt)) : se.setLocationAtPoint(Sr, Nt), ee._applyUpdatedTransform(se), this._map._update(), w.noInertia || this._inertia.record(w), this._fireEvents(B, Q, !0);
                        }
                        _fireEvents(w, B, Q) {
                            let ee = Ii(this._eventsInProgress), se = Ii(w), qe = {};
                            for(let Nt in w){
                                let { originalEvent: hr } = w[Nt];
                                this._eventsInProgress[Nt] || (qe[`${Nt}start`] = hr), this._eventsInProgress[Nt] = w[Nt];
                            }
                            !ee && se && this._fireEvent("movestart", se.originalEvent);
                            for(let Nt in qe)this._fireEvent(Nt, qe[Nt]);
                            se && this._fireEvent("move", se.originalEvent);
                            for(let Nt in w){
                                let { originalEvent: hr } = w[Nt];
                                this._fireEvent(Nt, hr);
                            }
                            let je = {}, it;
                            for(let Nt in this._eventsInProgress){
                                let { handlerName: hr, originalEvent: Sr } = this._eventsInProgress[Nt];
                                this._handlersById[hr].isActive() || (delete this._eventsInProgress[Nt], it = B[hr] || Sr, je[`${Nt}end`] = it);
                            }
                            for(let Nt in je)this._fireEvent(Nt, je[Nt]);
                            let yt = Ii(this._eventsInProgress), Ot = (ee || se) && !yt;
                            if (Ot && this._terrainMovement) {
                                this._map._elevationFreeze = !1, this._terrainMovement = !1;
                                let Nt = this._map._getTransformForUpdate();
                                Nt.recalculateZoom(this._map.terrain), this._map._applyUpdatedTransform(Nt);
                            }
                            if (Q && Ot) {
                                this._updatingCamera = !0;
                                let Nt = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), hr = (Sr)=>Sr !== 0 && -this._bearingSnap < Sr && Sr < this._bearingSnap;
                                !Nt || !Nt.essential && u.prefersReducedMotion ? (this._map.fire(new a.k("moveend", {
                                    originalEvent: it
                                })), hr(this._map.getBearing()) && this._map.resetNorth()) : (hr(Nt.bearing || this._map.getBearing()) && (Nt.bearing = 0), Nt.freezeElevation = !0, this._map.easeTo(Nt, {
                                    originalEvent: it
                                })), this._updatingCamera = !1;
                            }
                        }
                        _fireEvent(w, B) {
                            this._map.fire(new a.k(w, B ? {
                                originalEvent: B
                            } : {}));
                        }
                        _requestFrame() {
                            return this._map.triggerRepaint(), this._map._renderTaskQueue.add((w)=>{
                                delete this._frameId, this.handleEvent(new mi("renderFrame", {
                                    timeStamp: w
                                })), this._applyChanges();
                            });
                        }
                        _triggerRenderFrame() {
                            this._frameId === void 0 && (this._frameId = this._requestFrame());
                        }
                    }
                    class Ta extends a.E {
                        constructor(w, B){
                            super(), this._renderFrameCallback = ()=>{
                                let Q = Math.min((u.now() - this._easeStart) / this._easeOptions.duration, 1);
                                this._onEaseFrame(this._easeOptions.easing(Q)), Q < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                            }, this._moving = !1, this._zooming = !1, this.transform = w, this._bearingSnap = B.bearingSnap, this.on("moveend", ()=>{
                                delete this._requestedCameraState;
                            });
                        }
                        getCenter() {
                            return new a.N(this.transform.center.lng, this.transform.center.lat);
                        }
                        setCenter(w, B) {
                            return this.jumpTo({
                                center: w
                            }, B);
                        }
                        panBy(w, B, Q) {
                            return w = a.P.convert(w).mult(-1), this.panTo(this.transform.center, a.e({
                                offset: w
                            }, B), Q);
                        }
                        panTo(w, B, Q) {
                            return this.easeTo(a.e({
                                center: w
                            }, B), Q);
                        }
                        getZoom() {
                            return this.transform.zoom;
                        }
                        setZoom(w, B) {
                            return this.jumpTo({
                                zoom: w
                            }, B), this;
                        }
                        zoomTo(w, B, Q) {
                            return this.easeTo(a.e({
                                zoom: w
                            }, B), Q);
                        }
                        zoomIn(w, B) {
                            return this.zoomTo(this.getZoom() + 1, w, B), this;
                        }
                        zoomOut(w, B) {
                            return this.zoomTo(this.getZoom() - 1, w, B), this;
                        }
                        getBearing() {
                            return this.transform.bearing;
                        }
                        setBearing(w, B) {
                            return this.jumpTo({
                                bearing: w
                            }, B), this;
                        }
                        getPadding() {
                            return this.transform.padding;
                        }
                        setPadding(w, B) {
                            return this.jumpTo({
                                padding: w
                            }, B), this;
                        }
                        rotateTo(w, B, Q) {
                            return this.easeTo(a.e({
                                bearing: w
                            }, B), Q);
                        }
                        resetNorth(w, B) {
                            return this.rotateTo(0, a.e({
                                duration: 1e3
                            }, w), B), this;
                        }
                        resetNorthPitch(w, B) {
                            return this.easeTo(a.e({
                                bearing: 0,
                                pitch: 0,
                                duration: 1e3
                            }, w), B), this;
                        }
                        snapToNorth(w, B) {
                            return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(w, B) : this;
                        }
                        getPitch() {
                            return this.transform.pitch;
                        }
                        setPitch(w, B) {
                            return this.jumpTo({
                                pitch: w
                            }, B), this;
                        }
                        cameraForBounds(w, B) {
                            w = ce.convert(w).adjustAntiMeridian();
                            let Q = B && B.bearing || 0;
                            return this._cameraForBoxAndBearing(w.getNorthWest(), w.getSouthEast(), Q, B);
                        }
                        _cameraForBoxAndBearing(w, B, Q, ee) {
                            let se = {
                                top: 0,
                                bottom: 0,
                                right: 0,
                                left: 0
                            };
                            if (typeof (ee = a.e({
                                padding: se,
                                offset: [
                                    0,
                                    0
                                ],
                                maxZoom: this.transform.maxZoom
                            }, ee)).padding == "number") {
                                let zr = ee.padding;
                                ee.padding = {
                                    top: zr,
                                    bottom: zr,
                                    right: zr,
                                    left: zr
                                };
                            }
                            ee.padding = a.e(se, ee.padding);
                            let qe = this.transform, je = qe.padding, it = new ce(w, B), yt = qe.project(it.getNorthWest()), Ot = qe.project(it.getNorthEast()), Nt = qe.project(it.getSouthEast()), hr = qe.project(it.getSouthWest()), Sr = a.ba(-Q), he = yt.rotate(Sr), be = Ot.rotate(Sr), Pe = Nt.rotate(Sr), Oe = hr.rotate(Sr), Je = new a.P(Math.max(he.x, be.x, Oe.x, Pe.x), Math.max(he.y, be.y, Oe.y, Pe.y)), He = new a.P(Math.min(he.x, be.x, Oe.x, Pe.x), Math.min(he.y, be.y, Oe.y, Pe.y)), et = Je.sub(He), Mt = (qe.width - (je.left + je.right + ee.padding.left + ee.padding.right)) / et.x, Dt = (qe.height - (je.top + je.bottom + ee.padding.top + ee.padding.bottom)) / et.y;
                            if (Dt < 0 || Mt < 0) return void a.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                            let Ut = Math.min(qe.scaleZoom(qe.scale * Math.min(Mt, Dt)), ee.maxZoom), tr = a.P.convert(ee.offset), mr = new a.P((ee.padding.left - ee.padding.right) / 2, (ee.padding.top - ee.padding.bottom) / 2).rotate(a.ba(Q)), Rr = tr.add(mr).mult(qe.scale / qe.zoomScale(Ut));
                            return {
                                center: qe.unproject(yt.add(Nt).div(2).sub(Rr)),
                                zoom: Ut,
                                bearing: Q
                            };
                        }
                        fitBounds(w, B, Q) {
                            return this._fitInternal(this.cameraForBounds(w, B), B, Q);
                        }
                        fitScreenCoordinates(w, B, Q, ee, se) {
                            return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(a.P.convert(w)), this.transform.pointLocation(a.P.convert(B)), Q, ee), ee, se);
                        }
                        _fitInternal(w, B, Q) {
                            return w ? (delete (B = a.e(w, B)).padding, B.linear ? this.easeTo(B, Q) : this.flyTo(B, Q)) : this;
                        }
                        jumpTo(w, B) {
                            this.stop();
                            let Q = this._getTransformForUpdate(), ee = !1, se = !1, qe = !1;
                            return "zoom" in w && Q.zoom !== +w.zoom && (ee = !0, Q.zoom = +w.zoom), w.center !== void 0 && (Q.center = a.N.convert(w.center)), "bearing" in w && Q.bearing !== +w.bearing && (se = !0, Q.bearing = +w.bearing), "pitch" in w && Q.pitch !== +w.pitch && (qe = !0, Q.pitch = +w.pitch), w.padding == null || Q.isPaddingEqual(w.padding) || (Q.padding = w.padding), this._applyUpdatedTransform(Q), this.fire(new a.k("movestart", B)).fire(new a.k("move", B)), ee && this.fire(new a.k("zoomstart", B)).fire(new a.k("zoom", B)).fire(new a.k("zoomend", B)), se && this.fire(new a.k("rotatestart", B)).fire(new a.k("rotate", B)).fire(new a.k("rotateend", B)), qe && this.fire(new a.k("pitchstart", B)).fire(new a.k("pitch", B)).fire(new a.k("pitchend", B)), this.fire(new a.k("moveend", B));
                        }
                        calculateCameraOptionsFromTo(w, B, Q, ee = 0) {
                            let se = a.Z.fromLngLat(w, B), qe = a.Z.fromLngLat(Q, ee), je = qe.x - se.x, it = qe.y - se.y, yt = qe.z - se.z, Ot = Math.hypot(je, it, yt);
                            if (Ot === 0) throw new Error("Can't calculate camera options with same From and To");
                            let Nt = Math.hypot(je, it), hr = this.transform.scaleZoom(this.transform.cameraToCenterDistance / Ot / this.transform.tileSize), Sr = 180 * Math.atan2(je, -it) / Math.PI, he = 180 * Math.acos(Nt / Ot) / Math.PI;
                            return he = yt < 0 ? 90 - he : 90 + he, {
                                center: qe.toLngLat(),
                                zoom: hr,
                                pitch: he,
                                bearing: Sr
                            };
                        }
                        easeTo(w, B) {
                            var Q;
                            this._stop(!1, w.easeId), ((w = a.e({
                                offset: [
                                    0,
                                    0
                                ],
                                duration: 500,
                                easing: a.b9
                            }, w)).animate === !1 || !w.essential && u.prefersReducedMotion) && (w.duration = 0);
                            let ee = this._getTransformForUpdate(), se = ee.zoom, qe = ee.bearing, je = ee.pitch, it = ee.padding, yt = "bearing" in w ? this._normalizeBearing(w.bearing, qe) : qe, Ot = "pitch" in w ? +w.pitch : je, Nt = "padding" in w ? w.padding : ee.padding, hr = a.P.convert(w.offset), Sr = ee.centerPoint.add(hr), he = ee.pointLocation(Sr), { center: be, zoom: Pe } = ee.getConstrained(a.N.convert(w.center || he), (Q = w.zoom) !== null && Q !== void 0 ? Q : se);
                            this._normalizeCenter(be, ee);
                            let Oe = ee.project(he), Je = ee.project(be).sub(Oe), He = ee.zoomScale(Pe - se), et, Mt;
                            w.around && (et = a.N.convert(w.around), Mt = ee.locationPoint(et));
                            let Dt = {
                                moving: this._moving,
                                zooming: this._zooming,
                                rotating: this._rotating,
                                pitching: this._pitching
                            };
                            return this._zooming = this._zooming || Pe !== se, this._rotating = this._rotating || qe !== yt, this._pitching = this._pitching || Ot !== je, this._padding = !ee.isPaddingEqual(Nt), this._easeId = w.easeId, this._prepareEase(B, w.noMoveStart, Dt), this.terrain && this._prepareElevation(be), this._ease((Ut)=>{
                                if (this._zooming && (ee.zoom = a.y.number(se, Pe, Ut)), this._rotating && (ee.bearing = a.y.number(qe, yt, Ut)), this._pitching && (ee.pitch = a.y.number(je, Ot, Ut)), this._padding && (ee.interpolatePadding(it, Nt, Ut), Sr = ee.centerPoint.add(hr)), this.terrain && !w.freezeElevation && this._updateElevation(Ut), et) ee.setLocationAtPoint(et, Mt);
                                else {
                                    let tr = ee.zoomScale(ee.zoom - se), mr = Pe > se ? Math.min(2, He) : Math.max(.5, He), Rr = Math.pow(mr, 1 - Ut), zr = ee.unproject(Oe.add(Je.mult(Ut * Rr)).mult(tr));
                                    ee.setLocationAtPoint(ee.renderWorldCopies ? zr.wrap() : zr, Sr);
                                }
                                this._applyUpdatedTransform(ee), this._fireMoveEvents(B);
                            }, (Ut)=>{
                                this.terrain && w.freezeElevation && this._finalizeElevation(), this._afterEase(B, Ut);
                            }, w), this;
                        }
                        _prepareEase(w, B, Q = {}) {
                            this._moving = !0, B || Q.moving || this.fire(new a.k("movestart", w)), this._zooming && !Q.zooming && this.fire(new a.k("zoomstart", w)), this._rotating && !Q.rotating && this.fire(new a.k("rotatestart", w)), this._pitching && !Q.pitching && this.fire(new a.k("pitchstart", w));
                        }
                        _prepareElevation(w) {
                            this._elevationCenter = w, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(w, this.transform.tileZoom), this._elevationFreeze = !0;
                        }
                        _updateElevation(w) {
                            this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                            let B = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                            if (w < 1 && B !== this._elevationTarget) {
                                let Q = this._elevationTarget - this._elevationStart;
                                this._elevationStart += w * (Q - (B - (Q * w + this._elevationStart)) / (1 - w)), this._elevationTarget = B;
                            }
                            this.transform.elevation = a.y.number(this._elevationStart, this._elevationTarget, w);
                        }
                        _finalizeElevation() {
                            this._elevationFreeze = !1, this.transform.recalculateZoom(this.terrain);
                        }
                        _getTransformForUpdate() {
                            return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
                        }
                        _elevateCameraIfInsideTerrain(w) {
                            let B = w.getCameraPosition(), Q = this.terrain.getElevationForLngLatZoom(B.lngLat, w.zoom);
                            if (B.altitude < Q) {
                                let ee = this.calculateCameraOptionsFromTo(B.lngLat, Q, w.center, w.elevation);
                                return {
                                    pitch: ee.pitch,
                                    zoom: ee.zoom
                                };
                            }
                            return {};
                        }
                        _applyUpdatedTransform(w) {
                            let B = [];
                            if (this.terrain && B.push((ee)=>this._elevateCameraIfInsideTerrain(ee)), this.transformCameraUpdate && B.push((ee)=>this.transformCameraUpdate(ee)), !B.length) return;
                            let Q = w.clone();
                            for (let ee of B){
                                let se = Q.clone(), { center: qe, zoom: je, pitch: it, bearing: yt, elevation: Ot } = ee(se);
                                qe && (se.center = qe), je !== void 0 && (se.zoom = je), it !== void 0 && (se.pitch = it), yt !== void 0 && (se.bearing = yt), Ot !== void 0 && (se.elevation = Ot), Q.apply(se);
                            }
                            this.transform.apply(Q);
                        }
                        _fireMoveEvents(w) {
                            this.fire(new a.k("move", w)), this._zooming && this.fire(new a.k("zoom", w)), this._rotating && this.fire(new a.k("rotate", w)), this._pitching && this.fire(new a.k("pitch", w));
                        }
                        _afterEase(w, B) {
                            if (this._easeId && B && this._easeId === B) return;
                            delete this._easeId;
                            let Q = this._zooming, ee = this._rotating, se = this._pitching;
                            this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, Q && this.fire(new a.k("zoomend", w)), ee && this.fire(new a.k("rotateend", w)), se && this.fire(new a.k("pitchend", w)), this.fire(new a.k("moveend", w));
                        }
                        flyTo(w, B) {
                            var Q;
                            if (!w.essential && u.prefersReducedMotion) {
                                let Qi = a.M(w, [
                                    "center",
                                    "zoom",
                                    "bearing",
                                    "pitch",
                                    "around"
                                ]);
                                return this.jumpTo(Qi, B);
                            }
                            this.stop(), w = a.e({
                                offset: [
                                    0,
                                    0
                                ],
                                speed: 1.2,
                                curve: 1.42,
                                easing: a.b9
                            }, w);
                            let ee = this._getTransformForUpdate(), se = ee.zoom, qe = ee.bearing, je = ee.pitch, it = ee.padding, yt = "bearing" in w ? this._normalizeBearing(w.bearing, qe) : qe, Ot = "pitch" in w ? +w.pitch : je, Nt = "padding" in w ? w.padding : ee.padding, hr = a.P.convert(w.offset), Sr = ee.centerPoint.add(hr), he = ee.pointLocation(Sr), { center: be, zoom: Pe } = ee.getConstrained(a.N.convert(w.center || he), (Q = w.zoom) !== null && Q !== void 0 ? Q : se);
                            this._normalizeCenter(be, ee);
                            let Oe = ee.zoomScale(Pe - se), Je = ee.project(he), He = ee.project(be).sub(Je), et = w.curve, Mt = Math.max(ee.width, ee.height), Dt = Mt / Oe, Ut = He.mag();
                            if ("minZoom" in w) {
                                let Qi = a.ac(Math.min(w.minZoom, se, Pe), ee.minZoom, ee.maxZoom), Mn = Mt / ee.zoomScale(Qi - se);
                                et = Math.sqrt(Mn / Ut * 2);
                            }
                            let tr = et * et;
                            function mr(Qi) {
                                let Mn = (Dt * Dt - Mt * Mt + (Qi ? -1 : 1) * tr * tr * Ut * Ut) / (2 * (Qi ? Dt : Mt) * tr * Ut);
                                return Math.log(Math.sqrt(Mn * Mn + 1) - Mn);
                            }
                            function Rr(Qi) {
                                return (Math.exp(Qi) - Math.exp(-Qi)) / 2;
                            }
                            function zr(Qi) {
                                return (Math.exp(Qi) + Math.exp(-Qi)) / 2;
                            }
                            let Xr = mr(!1), di = function(Qi) {
                                return zr(Xr) / zr(Xr + et * Qi);
                            }, Li = function(Qi) {
                                var Mn;
                                return Mt * ((zr(Xr) * (Rr(Mn = Xr + et * Qi) / zr(Mn)) - Rr(Xr)) / tr) / Ut;
                            }, Ci = (mr(!0) - Xr) / et;
                            if (Math.abs(Ut) < 1e-6 || !isFinite(Ci)) {
                                if (Math.abs(Mt - Dt) < 1e-6) return this.easeTo(w, B);
                                let Qi = Dt < Mt ? -1 : 1;
                                Ci = Math.abs(Math.log(Dt / Mt)) / et, Li = ()=>0, di = (Mn)=>Math.exp(Qi * et * Mn);
                            }
                            return w.duration = "duration" in w ? +w.duration : 1e3 * Ci / ("screenSpeed" in w ? +w.screenSpeed / et : +w.speed), w.maxDuration && w.duration > w.maxDuration && (w.duration = 0), this._zooming = !0, this._rotating = qe !== yt, this._pitching = Ot !== je, this._padding = !ee.isPaddingEqual(Nt), this._prepareEase(B, !1), this.terrain && this._prepareElevation(be), this._ease((Qi)=>{
                                let Mn = Qi * Ci, pa = 1 / di(Mn);
                                ee.zoom = Qi === 1 ? Pe : se + ee.scaleZoom(pa), this._rotating && (ee.bearing = a.y.number(qe, yt, Qi)), this._pitching && (ee.pitch = a.y.number(je, Ot, Qi)), this._padding && (ee.interpolatePadding(it, Nt, Qi), Sr = ee.centerPoint.add(hr)), this.terrain && !w.freezeElevation && this._updateElevation(Qi);
                                let ea = Qi === 1 ? be : ee.unproject(Je.add(He.mult(Li(Mn))).mult(pa));
                                ee.setLocationAtPoint(ee.renderWorldCopies ? ea.wrap() : ea, Sr), this._applyUpdatedTransform(ee), this._fireMoveEvents(B);
                            }, ()=>{
                                this.terrain && w.freezeElevation && this._finalizeElevation(), this._afterEase(B);
                            }, w), this;
                        }
                        isEasing() {
                            return !!this._easeFrameId;
                        }
                        stop() {
                            return this._stop();
                        }
                        _stop(w, B) {
                            var Q;
                            if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                                let ee = this._onEaseEnd;
                                delete this._onEaseEnd, ee.call(this, B);
                            }
                            return w || (Q = this.handlers) === null || Q === void 0 || Q.stop(!1), this;
                        }
                        _ease(w, B, Q) {
                            Q.animate === !1 || Q.duration === 0 ? (w(1), B()) : (this._easeStart = u.now(), this._easeOptions = Q, this._onEaseFrame = w, this._onEaseEnd = B, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
                        }
                        _normalizeBearing(w, B) {
                            w = a.b3(w, -180, 180);
                            let Q = Math.abs(w - B);
                            return Math.abs(w - 360 - B) < Q && (w -= 360), Math.abs(w + 360 - B) < Q && (w += 360), w;
                        }
                        _normalizeCenter(w, B) {
                            if (!B.renderWorldCopies || B.lngRange) return;
                            let Q = w.lng - B.center.lng;
                            w.lng += Q > 180 ? -360 : Q < -180 ? 360 : 0;
                        }
                        queryTerrainElevation(w) {
                            return this.terrain ? this.terrain.getElevationForLngLatZoom(a.N.convert(w), this.transform.tileZoom) - this.transform.elevation : null;
                        }
                    }
                    let Ea = {
                        compact: !0,
                        customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
                    };
                    class qa {
                        constructor(w = Ea){
                            this._toggleAttribution = ()=>{
                                this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
                            }, this._updateData = (B)=>{
                                !B || B.sourceDataType !== "metadata" && B.sourceDataType !== "visibility" && B.dataType !== "style" && B.type !== "terrain" || this._updateAttributions();
                            }, this._updateCompact = ()=>{
                                this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? this._compact === !1 ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                            }, this._updateCompactMinimize = ()=>{
                                this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
                            }, this.options = w;
                        }
                        getDefaultPosition() {
                            return "bottom-right";
                        }
                        onAdd(w) {
                            return this._map = w, this._compact = this.options.compact, this._container = c.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = c.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = c.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
                        }
                        onRemove() {
                            c.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
                        }
                        _setElementTitle(w, B) {
                            let Q = this._map._getUIString(`AttributionControl.${B}`);
                            w.title = Q, w.setAttribute("aria-label", Q);
                        }
                        _updateAttributions() {
                            if (!this._map.style) return;
                            let w = [];
                            if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? w = w.concat(this.options.customAttribution.map((ee)=>typeof ee != "string" ? "" : ee)) : typeof this.options.customAttribution == "string" && w.push(this.options.customAttribution)), this._map.style.stylesheet) {
                                let ee = this._map.style.stylesheet;
                                this.styleOwner = ee.owner, this.styleId = ee.id;
                            }
                            let B = this._map.style.sourceCaches;
                            for(let ee in B){
                                let se = B[ee];
                                if (se.used || se.usedForTerrain) {
                                    let qe = se.getSource();
                                    qe.attribution && w.indexOf(qe.attribution) < 0 && w.push(qe.attribution);
                                }
                            }
                            w = w.filter((ee)=>String(ee).trim()), w.sort((ee, se)=>ee.length - se.length), w = w.filter((ee, se)=>{
                                for(let qe = se + 1; qe < w.length; qe++)if (w[qe].indexOf(ee) >= 0) return !1;
                                return !0;
                            });
                            let Q = w.join(" | ");
                            Q !== this._attribHTML && (this._attribHTML = Q, w.length ? (this._innerContainer.innerHTML = Q, this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
                        }
                    }
                    class Cn {
                        constructor(w = {}){
                            this._updateCompact = ()=>{
                                let B = this._container.children;
                                if (B.length) {
                                    let Q = B[0];
                                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? this._compact !== !1 && Q.classList.add("maplibregl-compact") : Q.classList.remove("maplibregl-compact");
                                }
                            }, this.options = w;
                        }
                        getDefaultPosition() {
                            return "bottom-left";
                        }
                        onAdd(w) {
                            this._map = w, this._compact = this.options && this.options.compact, this._container = c.create("div", "maplibregl-ctrl");
                            let B = c.create("a", "maplibregl-ctrl-logo");
                            return B.target = "_blank", B.rel = "noopener nofollow", B.href = "https://maplibre.org/", B.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), B.setAttribute("rel", "noopener nofollow"), this._container.appendChild(B), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
                        }
                        onRemove() {
                            c.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
                        }
                    }
                    class sn {
                        constructor(){
                            this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
                        }
                        add(w) {
                            let B = ++this._id;
                            return this._queue.push({
                                callback: w,
                                id: B,
                                cancelled: !1
                            }), B;
                        }
                        remove(w) {
                            let B = this._currentlyRunning, Q = B ? this._queue.concat(B) : this._queue;
                            for (let ee of Q)if (ee.id === w) return void (ee.cancelled = !0);
                        }
                        run(w = 0) {
                            if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                            let B = this._currentlyRunning = this._queue;
                            this._queue = [];
                            for (let Q of B)if (!Q.cancelled && (Q.callback(w), this._cleared)) break;
                            this._cleared = !1, this._currentlyRunning = !1;
                        }
                        clear() {
                            this._currentlyRunning && (this._cleared = !0), this._queue = [];
                        }
                    }
                    var Ua = a.Y([
                        {
                            name: "a_pos3d",
                            type: "Int16",
                            components: 3
                        }
                    ]);
                    class mo extends a.E {
                        constructor(w){
                            super(), this.sourceCache = w, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.deltaZoom = 1, w.usedForTerrain = !0, w.tileSize = this.tileSize * 2 ** this.deltaZoom;
                        }
                        destruct() {
                            this.sourceCache.usedForTerrain = !1, this.sourceCache.tileSize = null;
                        }
                        update(w, B) {
                            this.sourceCache.update(w, B), this._renderableTilesKeys = [];
                            let Q = {};
                            for (let ee of w.coveringTiles({
                                tileSize: this.tileSize,
                                minzoom: this.minzoom,
                                maxzoom: this.maxzoom,
                                reparseOverscaled: !1,
                                terrain: B
                            }))Q[ee.key] = !0, this._renderableTilesKeys.push(ee.key), this._tiles[ee.key] || (ee.posMatrix = new Float64Array(16), a.aP(ee.posMatrix, 0, a.X, 0, a.X, 0, 1), this._tiles[ee.key] = new Lt(ee, this.tileSize));
                            for(let ee in this._tiles)Q[ee] || delete this._tiles[ee];
                        }
                        freeRtt(w) {
                            for(let B in this._tiles){
                                let Q = this._tiles[B];
                                (!w || Q.tileID.equals(w) || Q.tileID.isChildOf(w) || w.isChildOf(Q.tileID)) && (Q.rtt = []);
                            }
                        }
                        getRenderableTiles() {
                            return this._renderableTilesKeys.map((w)=>this.getTileByID(w));
                        }
                        getTileByID(w) {
                            return this._tiles[w];
                        }
                        getTerrainCoords(w) {
                            let B = {};
                            for (let Q of this._renderableTilesKeys){
                                let ee = this._tiles[Q].tileID;
                                if (ee.canonical.equals(w.canonical)) {
                                    let se = w.clone();
                                    se.posMatrix = new Float64Array(16), a.aP(se.posMatrix, 0, a.X, 0, a.X, 0, 1), B[Q] = se;
                                } else if (ee.canonical.isChildOf(w.canonical)) {
                                    let se = w.clone();
                                    se.posMatrix = new Float64Array(16);
                                    let qe = ee.canonical.z - w.canonical.z, je = ee.canonical.x - (ee.canonical.x >> qe << qe), it = ee.canonical.y - (ee.canonical.y >> qe << qe), yt = a.X >> qe;
                                    a.aP(se.posMatrix, 0, yt, 0, yt, 0, 1), a.J(se.posMatrix, se.posMatrix, [
                                        -je * yt,
                                        -it * yt,
                                        0
                                    ]), B[Q] = se;
                                } else if (w.canonical.isChildOf(ee.canonical)) {
                                    let se = w.clone();
                                    se.posMatrix = new Float64Array(16);
                                    let qe = w.canonical.z - ee.canonical.z, je = w.canonical.x - (w.canonical.x >> qe << qe), it = w.canonical.y - (w.canonical.y >> qe << qe), yt = a.X >> qe;
                                    a.aP(se.posMatrix, 0, a.X, 0, a.X, 0, 1), a.J(se.posMatrix, se.posMatrix, [
                                        je * yt,
                                        it * yt,
                                        0
                                    ]), a.K(se.posMatrix, se.posMatrix, [
                                        1 / 2 ** qe,
                                        1 / 2 ** qe,
                                        0
                                    ]), B[Q] = se;
                                }
                            }
                            return B;
                        }
                        getSourceTile(w, B) {
                            let Q = this.sourceCache._source, ee = w.overscaledZ - this.deltaZoom;
                            if (ee > Q.maxzoom && (ee = Q.maxzoom), ee < Q.minzoom) return null;
                            this._sourceTileCache[w.key] || (this._sourceTileCache[w.key] = w.scaledTo(ee).key);
                            let se = this.sourceCache.getTileByID(this._sourceTileCache[w.key]);
                            if ((!se || !se.dem) && B) for(; ee >= Q.minzoom && (!se || !se.dem);)se = this.sourceCache.getTileByID(w.scaledTo(ee--).key);
                            return se;
                        }
                        tilesAfterTime(w = Date.now()) {
                            return Object.values(this._tiles).filter((B)=>B.timeAdded >= w);
                        }
                    }
                    class Xo {
                        constructor(w, B, Q){
                            this.painter = w, this.sourceCache = new mo(B), this.options = Q, this.exaggeration = typeof Q.exaggeration == "number" ? Q.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
                        }
                        getDEMElevation(w, B, Q, ee = a.X) {
                            var se;
                            if (!(B >= 0 && B < ee && Q >= 0 && Q < ee)) return 0;
                            let qe = this.getTerrainData(w), je = (se = qe.tile) === null || se === void 0 ? void 0 : se.dem;
                            if (!je) return 0;
                            let it = function(he, be, Pe) {
                                var Oe = be[0], Je = be[1];
                                return he[0] = Pe[0] * Oe + Pe[4] * Je + Pe[12], he[1] = Pe[1] * Oe + Pe[5] * Je + Pe[13], he;
                            }([], [
                                B / ee * a.X,
                                Q / ee * a.X
                            ], qe.u_terrain_matrix), yt = [
                                it[0] * je.dim,
                                it[1] * je.dim
                            ], Ot = Math.floor(yt[0]), Nt = Math.floor(yt[1]), hr = yt[0] - Ot, Sr = yt[1] - Nt;
                            return je.get(Ot, Nt) * (1 - hr) * (1 - Sr) + je.get(Ot + 1, Nt) * hr * (1 - Sr) + je.get(Ot, Nt + 1) * (1 - hr) * Sr + je.get(Ot + 1, Nt + 1) * hr * Sr;
                        }
                        getElevationForLngLatZoom(w, B) {
                            if (!a.bb(B, w.wrap())) return 0;
                            let { tileID: Q, mercatorX: ee, mercatorY: se } = this._getOverscaledTileIDFromLngLatZoom(w, B);
                            return this.getElevation(Q, ee % a.X, se % a.X, a.X);
                        }
                        getElevation(w, B, Q, ee = a.X) {
                            return this.getDEMElevation(w, B, Q, ee) * this.exaggeration;
                        }
                        getTerrainData(w) {
                            if (!this._emptyDemTexture) {
                                let ee = this.painter.context, se = new a.R({
                                    width: 1,
                                    height: 1
                                }, new Uint8Array(4));
                                this._emptyDepthTexture = new g(ee, se, ee.gl.RGBA, {
                                    premultiply: !1
                                }), this._emptyDemUnpack = [
                                    0,
                                    0,
                                    0,
                                    0
                                ], this._emptyDemTexture = new g(ee, new a.R({
                                    width: 1,
                                    height: 1
                                }), ee.gl.RGBA, {
                                    premultiply: !1
                                }), this._emptyDemTexture.bind(ee.gl.NEAREST, ee.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = a.an([]);
                            }
                            let B = this.sourceCache.getSourceTile(w, !0);
                            if (B && B.dem && (!B.demTexture || B.needsTerrainPrepare)) {
                                let ee = this.painter.context;
                                B.demTexture = this.painter.getTileTexture(B.dem.stride), B.demTexture ? B.demTexture.update(B.dem.getPixels(), {
                                    premultiply: !1
                                }) : B.demTexture = new g(ee, B.dem.getPixels(), ee.gl.RGBA, {
                                    premultiply: !1
                                }), B.demTexture.bind(ee.gl.NEAREST, ee.gl.CLAMP_TO_EDGE), B.needsTerrainPrepare = !1;
                            }
                            let Q = B && B + B.tileID.key + w.key;
                            if (Q && !this._demMatrixCache[Q]) {
                                let ee = this.sourceCache.sourceCache._source.maxzoom, se = w.canonical.z - B.tileID.canonical.z;
                                w.overscaledZ > w.canonical.z && (w.canonical.z >= ee ? se = w.canonical.z - ee : a.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                                let qe = w.canonical.x - (w.canonical.x >> se << se), je = w.canonical.y - (w.canonical.y >> se << se), it = a.bc(new Float64Array(16), [
                                    1 / (a.X << se),
                                    1 / (a.X << se),
                                    0
                                ]);
                                a.J(it, it, [
                                    qe * a.X,
                                    je * a.X,
                                    0
                                ]), this._demMatrixCache[w.key] = {
                                    matrix: it,
                                    coord: w
                                };
                            }
                            return {
                                u_depth: 2,
                                u_terrain: 3,
                                u_terrain_dim: B && B.dem && B.dem.dim || 1,
                                u_terrain_matrix: Q ? this._demMatrixCache[w.key].matrix : this._emptyDemMatrix,
                                u_terrain_unpack: B && B.dem && B.dem.getUnpackVector() || this._emptyDemUnpack,
                                u_terrain_exaggeration: this.exaggeration,
                                texture: (B && B.demTexture || this._emptyDemTexture).texture,
                                depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                                tile: B
                            };
                        }
                        getFramebuffer(w) {
                            let B = this.painter, Q = B.width / devicePixelRatio, ee = B.height / devicePixelRatio;
                            return !this._fbo || this._fbo.width === Q && this._fbo.height === ee || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new g(B.context, {
                                width: Q,
                                height: ee,
                                data: null
                            }, B.context.gl.RGBA, {
                                premultiply: !1
                            }), this._fboCoordsTexture.bind(B.context.gl.NEAREST, B.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new g(B.context, {
                                width: Q,
                                height: ee,
                                data: null
                            }, B.context.gl.RGBA, {
                                premultiply: !1
                            }), this._fboDepthTexture.bind(B.context.gl.NEAREST, B.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = B.context.createFramebuffer(Q, ee, !0, !1), this._fbo.depthAttachment.set(B.context.createRenderbuffer(B.context.gl.DEPTH_COMPONENT16, Q, ee))), this._fbo.colorAttachment.set(w === "coords" ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
                        }
                        getCoordsTexture() {
                            let w = this.painter.context;
                            if (this._coordsTexture) return this._coordsTexture;
                            let B = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                            for(let se = 0, qe = 0; se < this._coordsTextureSize; se++)for(let je = 0; je < this._coordsTextureSize; je++, qe += 4)B[qe + 0] = 255 & je, B[qe + 1] = 255 & se, B[qe + 2] = je >> 8 << 4 | se >> 8, B[qe + 3] = 0;
                            let Q = new a.R({
                                width: this._coordsTextureSize,
                                height: this._coordsTextureSize
                            }, new Uint8Array(B.buffer)), ee = new g(w, Q, w.gl.RGBA, {
                                premultiply: !1
                            });
                            return ee.bind(w.gl.NEAREST, w.gl.CLAMP_TO_EDGE), this._coordsTexture = ee, ee;
                        }
                        pointCoordinate(w) {
                            this.painter.maybeDrawDepthAndCoords(!0);
                            let B = new Uint8Array(4), Q = this.painter.context, ee = Q.gl, se = Math.round(w.x * this.painter.pixelRatio / devicePixelRatio), qe = Math.round(w.y * this.painter.pixelRatio / devicePixelRatio), je = Math.round(this.painter.height / devicePixelRatio);
                            Q.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), ee.readPixels(se, je - qe - 1, 1, 1, ee.RGBA, ee.UNSIGNED_BYTE, B), Q.bindFramebuffer.set(null);
                            let it = B[0] + (B[2] >> 4 << 8), yt = B[1] + ((15 & B[2]) << 8), Ot = this.coordsIndex[255 - B[3]], Nt = Ot && this.sourceCache.getTileByID(Ot);
                            if (!Nt) return null;
                            let hr = this._coordsTextureSize, Sr = (1 << Nt.tileID.canonical.z) * hr;
                            return new a.Z((Nt.tileID.canonical.x * hr + it) / Sr + Nt.tileID.wrap, (Nt.tileID.canonical.y * hr + yt) / Sr, this.getElevation(Nt.tileID, it, yt, hr));
                        }
                        depthAtPoint(w) {
                            let B = new Uint8Array(4), Q = this.painter.context, ee = Q.gl;
                            return Q.bindFramebuffer.set(this.getFramebuffer("depth").framebuffer), ee.readPixels(w.x, this.painter.height / devicePixelRatio - w.y - 1, 1, 1, ee.RGBA, ee.UNSIGNED_BYTE, B), Q.bindFramebuffer.set(null), (B[0] / 16777216 + B[1] / 65536 + B[2] / 256 + B[3]) / 256;
                        }
                        getTerrainMesh() {
                            if (this._mesh) return this._mesh;
                            let w = this.painter.context, B = new a.bd, Q = new a.aY, ee = this.meshSize, se = a.X / ee, qe = ee * ee;
                            for(let Nt = 0; Nt <= ee; Nt++)for(let hr = 0; hr <= ee; hr++)B.emplaceBack(hr * se, Nt * se, 0);
                            for(let Nt = 0; Nt < qe; Nt += ee + 1)for(let hr = 0; hr < ee; hr++)Q.emplaceBack(hr + Nt, ee + hr + Nt + 1, ee + hr + Nt + 2), Q.emplaceBack(hr + Nt, ee + hr + Nt + 2, hr + Nt + 1);
                            let je = B.length, it = je + 2 * (ee + 1);
                            for (let Nt of [
                                0,
                                1
                            ])for(let hr = 0; hr <= ee; hr++)for (let Sr of [
                                0,
                                1
                            ])B.emplaceBack(hr * se, Nt * a.X, Sr);
                            for(let Nt = 0; Nt < 2 * ee; Nt += 2)Q.emplaceBack(it + Nt, it + Nt + 1, it + Nt + 3), Q.emplaceBack(it + Nt, it + Nt + 3, it + Nt + 2), Q.emplaceBack(je + Nt, je + Nt + 3, je + Nt + 1), Q.emplaceBack(je + Nt, je + Nt + 2, je + Nt + 3);
                            let yt = B.length, Ot = yt + 2 * (ee + 1);
                            for (let Nt of [
                                0,
                                1
                            ])for(let hr = 0; hr <= ee; hr++)for (let Sr of [
                                0,
                                1
                            ])B.emplaceBack(Nt * a.X, hr * se, Sr);
                            for(let Nt = 0; Nt < 2 * ee; Nt += 2)Q.emplaceBack(yt + Nt, yt + Nt + 1, yt + Nt + 3), Q.emplaceBack(yt + Nt, yt + Nt + 3, yt + Nt + 2), Q.emplaceBack(Ot + Nt, Ot + Nt + 3, Ot + Nt + 1), Q.emplaceBack(Ot + Nt, Ot + Nt + 2, Ot + Nt + 3);
                            return this._mesh = new Pu(w.createVertexBuffer(B, Ua.members), w.createIndexBuffer(Q), a.a0.simpleSegment(0, 0, B.length, Q.length)), this._mesh;
                        }
                        getMeshFrameDelta(w) {
                            return 2 * Math.PI * a.be / Math.pow(2, w) / 5;
                        }
                        getMinTileElevationForLngLatZoom(w, B) {
                            var Q;
                            let { tileID: ee } = this._getOverscaledTileIDFromLngLatZoom(w, B);
                            return (Q = this.getMinMaxElevation(ee).minElevation) !== null && Q !== void 0 ? Q : 0;
                        }
                        getMinMaxElevation(w) {
                            let B = this.getTerrainData(w).tile, Q = {
                                minElevation: null,
                                maxElevation: null
                            };
                            return B && B.dem && (Q.minElevation = B.dem.min * this.exaggeration, Q.maxElevation = B.dem.max * this.exaggeration), Q;
                        }
                        _getOverscaledTileIDFromLngLatZoom(w, B) {
                            let Q = a.Z.fromLngLat(w.wrap()), ee = (1 << B) * a.X, se = Q.x * ee, qe = Q.y * ee, je = Math.floor(se / a.X), it = Math.floor(qe / a.X);
                            return {
                                tileID: new a.S(B, 0, B, je, it),
                                mercatorX: se,
                                mercatorY: qe
                            };
                        }
                    }
                    class Ts {
                        constructor(w, B, Q){
                            this._context = w, this._size = B, this._tileSize = Q, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
                        }
                        destruct() {
                            for (let w of this._objects)w.texture.destroy(), w.fbo.destroy();
                        }
                        _createObject(w) {
                            let B = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), Q = new g(this._context, {
                                width: this._tileSize,
                                height: this._tileSize,
                                data: null
                            }, this._context.gl.RGBA);
                            return Q.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), B.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), B.colorAttachment.set(Q.texture), {
                                id: w,
                                fbo: B,
                                texture: Q,
                                stamp: -1,
                                inUse: !1
                            };
                        }
                        getObjectForId(w) {
                            return this._objects[w];
                        }
                        useObject(w) {
                            w.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((B)=>w.id !== B), this._recentlyUsed.push(w.id);
                        }
                        stampObject(w) {
                            w.stamp = ++this._stamp;
                        }
                        getOrCreateFreeObject() {
                            for (let B of this._recentlyUsed)if (!this._objects[B].inUse) return this._objects[B];
                            if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                            let w = this._createObject(this._objects.length);
                            return this._objects.push(w), w;
                        }
                        freeObject(w) {
                            w.inUse = !1;
                        }
                        freeAllObjects() {
                            for (let w of this._objects)this.freeObject(w);
                        }
                        isFull() {
                            return !(this._objects.length < this._size) && this._objects.some((w)=>!w.inUse) === !1;
                        }
                    }
                    let Qo = {
                        background: !0,
                        fill: !0,
                        line: !0,
                        raster: !0,
                        hillshade: !0
                    };
                    class ys {
                        constructor(w, B){
                            this.painter = w, this.terrain = B, this.pool = new Ts(w.context, 30, B.sourceCache.tileSize * B.qualityFactor);
                        }
                        destruct() {
                            this.pool.destruct();
                        }
                        getTexture(w) {
                            return this.pool.getObjectForId(w.rtt[this._stacks.length - 1].id).texture;
                        }
                        prepareForRender(w, B) {
                            this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.sourceCache.getRenderableTiles(), this._renderableLayerIds = w._order.filter((Q)=>!w._layers[Q].isHidden(B)), this._coordsDescendingInv = {};
                            for(let Q in w.sourceCaches){
                                this._coordsDescendingInv[Q] = {};
                                let ee = w.sourceCaches[Q].getVisibleCoordinates();
                                for (let se of ee){
                                    let qe = this.terrain.sourceCache.getTerrainCoords(se);
                                    for(let je in qe)this._coordsDescendingInv[Q][je] || (this._coordsDescendingInv[Q][je] = []), this._coordsDescendingInv[Q][je].push(qe[je]);
                                }
                            }
                            this._coordsDescendingInvStr = {};
                            for (let Q of w._order){
                                let ee = w._layers[Q], se = ee.source;
                                if (Qo[ee.type] && !this._coordsDescendingInvStr[se]) {
                                    this._coordsDescendingInvStr[se] = {};
                                    for(let qe in this._coordsDescendingInv[se])this._coordsDescendingInvStr[se][qe] = this._coordsDescendingInv[se][qe].map((je)=>je.key).sort().join();
                                }
                            }
                            for (let Q of this._renderableTiles)for(let ee in this._coordsDescendingInvStr){
                                let se = this._coordsDescendingInvStr[ee][Q.tileID.key];
                                se && se !== Q.rttCoords[ee] && (Q.rtt = []);
                            }
                        }
                        renderLayer(w) {
                            if (w.isHidden(this.painter.transform.zoom)) return !1;
                            let B = w.type, Q = this.painter, ee = this._renderableLayerIds[this._renderableLayerIds.length - 1] === w.id;
                            if (Qo[B] && (this._prevType && Qo[this._prevType] || this._stacks.push([]), this._prevType = B, this._stacks[this._stacks.length - 1].push(w.id), !ee)) return !0;
                            if (Qo[this._prevType] || Qo[B] && ee) {
                                this._prevType = B;
                                let se = this._stacks.length - 1, qe = this._stacks[se] || [];
                                for (let je of this._renderableTiles){
                                    if (this.pool.isFull() && (tu(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(je), je.rtt[se]) {
                                        let yt = this.pool.getObjectForId(je.rtt[se].id);
                                        if (yt.stamp === je.rtt[se].stamp) {
                                            this.pool.useObject(yt);
                                            continue;
                                        }
                                    }
                                    let it = this.pool.getOrCreateFreeObject();
                                    this.pool.useObject(it), this.pool.stampObject(it), je.rtt[se] = {
                                        id: it.id,
                                        stamp: it.stamp
                                    }, Q.context.bindFramebuffer.set(it.fbo.framebuffer), Q.context.clear({
                                        color: a.aM.transparent,
                                        stencil: 0
                                    }), Q.currentStencilSource = void 0;
                                    for(let yt = 0; yt < qe.length; yt++){
                                        let Ot = Q.style._layers[qe[yt]], Nt = Ot.source ? this._coordsDescendingInv[Ot.source][je.tileID.key] : [
                                            je.tileID
                                        ];
                                        Q.context.viewport.set([
                                            0,
                                            0,
                                            it.fbo.width,
                                            it.fbo.height
                                        ]), Q._renderTileClippingMasks(Ot, Nt), Q.renderLayer(Q, Q.style.sourceCaches[Ot.source], Ot, Nt), Ot.source && (je.rttCoords[Ot.source] = this._coordsDescendingInvStr[Ot.source][je.tileID.key]);
                                    }
                                }
                                return tu(this.painter, this.terrain, this._rttTiles), this._rttTiles = [], this.pool.freeAllObjects(), Qo[B];
                            }
                            return !1;
                        }
                    }
                    let Bo = {
                        "AttributionControl.ToggleAttribution": "Toggle attribution",
                        "AttributionControl.MapFeedback": "Map feedback",
                        "FullscreenControl.Enter": "Enter fullscreen",
                        "FullscreenControl.Exit": "Exit fullscreen",
                        "GeolocateControl.FindMyLocation": "Find my location",
                        "GeolocateControl.LocationNotAvailable": "Location not available",
                        "LogoControl.Title": "MapLibre logo",
                        "Map.Title": "Map",
                        "Marker.Title": "Map marker",
                        "NavigationControl.ResetBearing": "Reset bearing to north",
                        "NavigationControl.ZoomIn": "Zoom in",
                        "NavigationControl.ZoomOut": "Zoom out",
                        "Popup.Close": "Close popup",
                        "ScaleControl.Feet": "ft",
                        "ScaleControl.Meters": "m",
                        "ScaleControl.Kilometers": "km",
                        "ScaleControl.Miles": "mi",
                        "ScaleControl.NauticalMiles": "nm",
                        "TerrainControl.Enable": "Enable terrain",
                        "TerrainControl.Disable": "Disable terrain",
                        "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
                        "CooperativeGesturesHandler.MacHelpText": "Use \u2318 + scroll to zoom the map",
                        "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
                    }, yl = o, Gs = {
                        hash: !1,
                        interactive: !0,
                        bearingSnap: 7,
                        attributionControl: Ea,
                        maplibreLogo: !1,
                        failIfMajorPerformanceCaveat: !1,
                        preserveDrawingBuffer: !1,
                        refreshExpiredTiles: !0,
                        scrollZoom: !0,
                        minZoom: -2,
                        maxZoom: 22,
                        minPitch: 0,
                        maxPitch: 60,
                        boxZoom: !0,
                        dragRotate: !0,
                        dragPan: !0,
                        keyboard: !0,
                        doubleClickZoom: !0,
                        touchZoomRotate: !0,
                        touchPitch: !0,
                        cooperativeGestures: !1,
                        trackResize: !0,
                        center: [
                            0,
                            0
                        ],
                        zoom: 0,
                        bearing: 0,
                        pitch: 0,
                        renderWorldCopies: !0,
                        maxTileCacheSize: null,
                        maxTileCacheZoomLevels: a.a.MAX_TILE_CACHE_ZOOM_LEVELS,
                        transformRequest: null,
                        transformCameraUpdate: null,
                        fadeDuration: 300,
                        crossSourceCollisions: !0,
                        clickTolerance: 3,
                        localIdeographFontFamily: "sans-serif",
                        pitchWithRotate: !0,
                        validateStyle: !0,
                        maxCanvasSize: [
                            4096,
                            4096
                        ],
                        cancelPendingTileRequestsWhileZooming: !0
                    }, Rs = (le)=>{
                        le.touchstart = le.dragStart, le.touchmoveWindow = le.dragMove, le.touchend = le.dragEnd;
                    }, ia = {
                        showCompass: !0,
                        showZoom: !0,
                        visualizePitch: !1
                    };
                    class Ka {
                        constructor(w, B, Q = !1){
                            this.mousedown = (qe)=>{
                                this.startMouse(a.e({}, qe, {
                                    ctrlKey: !0,
                                    preventDefault: ()=>qe.preventDefault()
                                }), c.mousePos(this.element, qe)), c.addEventListener(window, "mousemove", this.mousemove), c.addEventListener(window, "mouseup", this.mouseup);
                            }, this.mousemove = (qe)=>{
                                this.moveMouse(qe, c.mousePos(this.element, qe));
                            }, this.mouseup = (qe)=>{
                                this.mouseRotate.dragEnd(qe), this.mousePitch && this.mousePitch.dragEnd(qe), this.offTemp();
                            }, this.touchstart = (qe)=>{
                                qe.targetTouches.length !== 1 ? this.reset() : (this._startPos = this._lastPos = c.touchPos(this.element, qe.targetTouches)[0], this.startTouch(qe, this._startPos), c.addEventListener(window, "touchmove", this.touchmove, {
                                    passive: !1
                                }), c.addEventListener(window, "touchend", this.touchend));
                            }, this.touchmove = (qe)=>{
                                qe.targetTouches.length !== 1 ? this.reset() : (this._lastPos = c.touchPos(this.element, qe.targetTouches)[0], this.moveTouch(qe, this._lastPos));
                            }, this.touchend = (qe)=>{
                                qe.targetTouches.length === 0 && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
                            }, this.reset = ()=>{
                                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), this.touchRotate.reset(), this.touchPitch && this.touchPitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                            }, this._clickTolerance = 10;
                            let ee = w.dragRotate._mouseRotate.getClickTolerance(), se = w.dragRotate._mousePitch.getClickTolerance();
                            this.element = B, this.mouseRotate = Dl({
                                clickTolerance: ee,
                                enable: !0
                            }), this.touchRotate = (({ enable: qe, clickTolerance: je, bearingDegreesPerPixelMoved: it = .8 })=>{
                                let yt = new pf;
                                return new ju({
                                    clickTolerance: je,
                                    move: (Ot, Nt)=>({
                                            bearingDelta: (Nt.x - Ot.x) * it
                                        }),
                                    moveStateManager: yt,
                                    enable: qe,
                                    assignEvents: Rs
                                });
                            })({
                                clickTolerance: ee,
                                enable: !0
                            }), this.map = w, Q && (this.mousePitch = Ih({
                                clickTolerance: se,
                                enable: !0
                            }), this.touchPitch = (({ enable: qe, clickTolerance: je, pitchDegreesPerPixelMoved: it = -0.5 })=>{
                                let yt = new pf;
                                return new ju({
                                    clickTolerance: je,
                                    move: (Ot, Nt)=>({
                                            pitchDelta: (Nt.y - Ot.y) * it
                                        }),
                                    moveStateManager: yt,
                                    enable: qe,
                                    assignEvents: Rs
                                });
                            })({
                                clickTolerance: se,
                                enable: !0
                            })), c.addEventListener(B, "mousedown", this.mousedown), c.addEventListener(B, "touchstart", this.touchstart, {
                                passive: !1
                            }), c.addEventListener(B, "touchcancel", this.reset);
                        }
                        startMouse(w, B) {
                            this.mouseRotate.dragStart(w, B), this.mousePitch && this.mousePitch.dragStart(w, B), c.disableDrag();
                        }
                        startTouch(w, B) {
                            this.touchRotate.dragStart(w, B), this.touchPitch && this.touchPitch.dragStart(w, B), c.disableDrag();
                        }
                        moveMouse(w, B) {
                            let Q = this.map, { bearingDelta: ee } = this.mouseRotate.dragMove(w, B) || {};
                            if (ee && Q.setBearing(Q.getBearing() + ee), this.mousePitch) {
                                let { pitchDelta: se } = this.mousePitch.dragMove(w, B) || {};
                                se && Q.setPitch(Q.getPitch() + se);
                            }
                        }
                        moveTouch(w, B) {
                            let Q = this.map, { bearingDelta: ee } = this.touchRotate.dragMove(w, B) || {};
                            if (ee && Q.setBearing(Q.getBearing() + ee), this.touchPitch) {
                                let { pitchDelta: se } = this.touchPitch.dragMove(w, B) || {};
                                se && Q.setPitch(Q.getPitch() + se);
                            }
                        }
                        off() {
                            let w = this.element;
                            c.removeEventListener(w, "mousedown", this.mousedown), c.removeEventListener(w, "touchstart", this.touchstart, {
                                passive: !1
                            }), c.removeEventListener(window, "touchmove", this.touchmove, {
                                passive: !1
                            }), c.removeEventListener(window, "touchend", this.touchend), c.removeEventListener(w, "touchcancel", this.reset), this.offTemp();
                        }
                        offTemp() {
                            c.enableDrag(), c.removeEventListener(window, "mousemove", this.mousemove), c.removeEventListener(window, "mouseup", this.mouseup), c.removeEventListener(window, "touchmove", this.touchmove, {
                                passive: !1
                            }), c.removeEventListener(window, "touchend", this.touchend);
                        }
                    }
                    let vs;
                    function Ko(le, w, B) {
                        let Q = new a.N(le.lng, le.lat);
                        if (le = new a.N(le.lng, le.lat), w) {
                            let ee = new a.N(le.lng - 360, le.lat), se = new a.N(le.lng + 360, le.lat), qe = B.locationPoint(le).distSqr(w);
                            B.locationPoint(ee).distSqr(w) < qe ? le = ee : B.locationPoint(se).distSqr(w) < qe && (le = se);
                        }
                        for(; Math.abs(le.lng - B.center.lng) > 180;){
                            let ee = B.locationPoint(le);
                            if (ee.x >= 0 && ee.y >= 0 && ee.x <= B.width && ee.y <= B.height) break;
                            le.lng > B.center.lng ? le.lng -= 360 : le.lng += 360;
                        }
                        return le.lng !== Q.lng && B.locationPoint(le).y > B.height / 2 - B.getHorizon() ? le : Q;
                    }
                    let nu = {
                        center: "translate(-50%,-50%)",
                        top: "translate(-50%,0)",
                        "top-left": "translate(0,0)",
                        "top-right": "translate(-100%,0)",
                        bottom: "translate(-50%,-100%)",
                        "bottom-left": "translate(0,-100%)",
                        "bottom-right": "translate(-100%,-100%)",
                        left: "translate(0,-50%)",
                        right: "translate(-100%,-50%)"
                    };
                    function Ru(le, w, B) {
                        let Q = le.classList;
                        for(let ee in nu)Q.remove(`maplibregl-${B}-anchor-${ee}`);
                        Q.add(`maplibregl-${B}-anchor-${w}`);
                    }
                    class ac extends a.E {
                        constructor(w){
                            if (super(), this._onKeyPress = (B)=>{
                                let Q = B.code, ee = B.charCode || B.keyCode;
                                Q !== "Space" && Q !== "Enter" && ee !== 32 && ee !== 13 || this.togglePopup();
                            }, this._onMapClick = (B)=>{
                                let Q = B.originalEvent.target, ee = this._element;
                                this._popup && (Q === ee || ee.contains(Q)) && this.togglePopup();
                            }, this._update = (B)=>{
                                var Q;
                                if (!this._map) return;
                                let ee = this._map.loaded() && !this._map.isMoving();
                                ((B == null ? void 0 : B.type) === "terrain" || (B == null ? void 0 : B.type) === "render" && !ee) && this._map.once("render", this._update), this._lngLat = this._map.transform.renderWorldCopies ? Ko(this._lngLat, this._flatPos, this._map.transform) : (Q = this._lngLat) === null || Q === void 0 ? void 0 : Q.wrap(), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map.transform.locationPoint(this._lngLat)._add(this._offset));
                                let se = "";
                                this._rotationAlignment === "viewport" || this._rotationAlignment === "auto" ? se = `rotateZ(${this._rotation}deg)` : this._rotationAlignment === "map" && (se = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                                let qe = "";
                                this._pitchAlignment === "viewport" || this._pitchAlignment === "auto" ? qe = "rotateX(0deg)" : this._pitchAlignment === "map" && (qe = `rotateX(${this._map.getPitch()}deg)`), this._subpixelPositioning || B && B.type !== "moveend" || (this._pos = this._pos.round()), c.setTransform(this._element, `${nu[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${qe} ${se}`), u.frameAsync(new AbortController).then(()=>{
                                    this._updateOpacity(B && B.type === "moveend");
                                }).catch(()=>{});
                            }, this._onMove = (B)=>{
                                if (!this._isDragging) {
                                    let Q = this._clickTolerance || this._map._clickTolerance;
                                    this._isDragging = B.point.dist(this._pointerdownPos) >= Q;
                                }
                                this._isDragging && (this._pos = B.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", this._state === "pending" && (this._state = "active", this.fire(new a.k("dragstart"))), this.fire(new a.k("drag")));
                            }, this._onUp = ()=>{
                                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), this._state === "active" && this.fire(new a.k("dragend")), this._state = "inactive";
                            }, this._addDragHandler = (B)=>{
                                this._element.contains(B.originalEvent.target) && (B.preventDefault(), this._positionDelta = B.point.sub(this._pos).add(this._offset), this._pointerdownPos = B.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                            }, this._anchor = w && w.anchor || "center", this._color = w && w.color || "#3FB1CE", this._scale = w && w.scale || 1, this._draggable = w && w.draggable || !1, this._clickTolerance = w && w.clickTolerance || 0, this._subpixelPositioning = w && w.subpixelPositioning || !1, this._isDragging = !1, this._state = "inactive", this._rotation = w && w.rotation || 0, this._rotationAlignment = w && w.rotationAlignment || "auto", this._pitchAlignment = w && w.pitchAlignment && w.pitchAlignment !== "auto" ? w.pitchAlignment : this._rotationAlignment, this.setOpacity(), this.setOpacity(w == null ? void 0 : w.opacity, w == null ? void 0 : w.opacityWhenCovered), w && w.element) this._element = w.element, this._offset = a.P.convert(w && w.offset || [
                                0,
                                0
                            ]);
                            else {
                                this._defaultMarker = !0, this._element = c.create("div");
                                let B = c.createNS("http://www.w3.org/2000/svg", "svg"), Q = 41, ee = 27;
                                B.setAttributeNS(null, "display", "block"), B.setAttributeNS(null, "height", `${Q}px`), B.setAttributeNS(null, "width", `${ee}px`), B.setAttributeNS(null, "viewBox", `0 0 ${ee} ${Q}`);
                                let se = c.createNS("http://www.w3.org/2000/svg", "g");
                                se.setAttributeNS(null, "stroke", "none"), se.setAttributeNS(null, "stroke-width", "1"), se.setAttributeNS(null, "fill", "none"), se.setAttributeNS(null, "fill-rule", "evenodd");
                                let qe = c.createNS("http://www.w3.org/2000/svg", "g");
                                qe.setAttributeNS(null, "fill-rule", "nonzero");
                                let je = c.createNS("http://www.w3.org/2000/svg", "g");
                                je.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), je.setAttributeNS(null, "fill", "#000000");
                                let it = [
                                    {
                                        rx: "10.5",
                                        ry: "5.25002273"
                                    },
                                    {
                                        rx: "10.5",
                                        ry: "5.25002273"
                                    },
                                    {
                                        rx: "9.5",
                                        ry: "4.77275007"
                                    },
                                    {
                                        rx: "8.5",
                                        ry: "4.29549936"
                                    },
                                    {
                                        rx: "7.5",
                                        ry: "3.81822308"
                                    },
                                    {
                                        rx: "6.5",
                                        ry: "3.34094679"
                                    },
                                    {
                                        rx: "5.5",
                                        ry: "2.86367051"
                                    },
                                    {
                                        rx: "4.5",
                                        ry: "2.38636864"
                                    }
                                ];
                                for (let Oe of it){
                                    let Je = c.createNS("http://www.w3.org/2000/svg", "ellipse");
                                    Je.setAttributeNS(null, "opacity", "0.04"), Je.setAttributeNS(null, "cx", "10.5"), Je.setAttributeNS(null, "cy", "5.80029008"), Je.setAttributeNS(null, "rx", Oe.rx), Je.setAttributeNS(null, "ry", Oe.ry), je.appendChild(Je);
                                }
                                let yt = c.createNS("http://www.w3.org/2000/svg", "g");
                                yt.setAttributeNS(null, "fill", this._color);
                                let Ot = c.createNS("http://www.w3.org/2000/svg", "path");
                                Ot.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), yt.appendChild(Ot);
                                let Nt = c.createNS("http://www.w3.org/2000/svg", "g");
                                Nt.setAttributeNS(null, "opacity", "0.25"), Nt.setAttributeNS(null, "fill", "#000000");
                                let hr = c.createNS("http://www.w3.org/2000/svg", "path");
                                hr.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), Nt.appendChild(hr);
                                let Sr = c.createNS("http://www.w3.org/2000/svg", "g");
                                Sr.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), Sr.setAttributeNS(null, "fill", "#FFFFFF");
                                let he = c.createNS("http://www.w3.org/2000/svg", "g");
                                he.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                                let be = c.createNS("http://www.w3.org/2000/svg", "circle");
                                be.setAttributeNS(null, "fill", "#000000"), be.setAttributeNS(null, "opacity", "0.25"), be.setAttributeNS(null, "cx", "5.5"), be.setAttributeNS(null, "cy", "5.5"), be.setAttributeNS(null, "r", "5.4999962");
                                let Pe = c.createNS("http://www.w3.org/2000/svg", "circle");
                                Pe.setAttributeNS(null, "fill", "#FFFFFF"), Pe.setAttributeNS(null, "cx", "5.5"), Pe.setAttributeNS(null, "cy", "5.5"), Pe.setAttributeNS(null, "r", "5.4999962"), he.appendChild(be), he.appendChild(Pe), qe.appendChild(je), qe.appendChild(yt), qe.appendChild(Nt), qe.appendChild(Sr), qe.appendChild(he), B.appendChild(qe), B.setAttributeNS(null, "height", Q * this._scale + "px"), B.setAttributeNS(null, "width", ee * this._scale + "px"), this._element.appendChild(B), this._offset = a.P.convert(w && w.offset || [
                                    0,
                                    -14
                                ]);
                            }
                            if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (B)=>{
                                B.preventDefault();
                            }), this._element.addEventListener("mousedown", (B)=>{
                                B.preventDefault();
                            }), Ru(this._element, this._anchor, "marker"), w && w.className) for (let B of w.className.split(" "))this._element.classList.add(B);
                            this._popup = null;
                        }
                        addTo(w) {
                            return this.remove(), this._map = w, this._element.setAttribute("aria-label", w._getUIString("Marker.Title")), w.getCanvasContainer().appendChild(this._element), w.on("move", this._update), w.on("moveend", this._update), w.on("terrain", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
                        }
                        remove() {
                            return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), c.remove(this._element), this._popup && this._popup.remove(), this;
                        }
                        getLngLat() {
                            return this._lngLat;
                        }
                        setLngLat(w) {
                            return this._lngLat = a.N.convert(w), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
                        }
                        getElement() {
                            return this._element;
                        }
                        setPopup(w) {
                            if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), w) {
                                if (!("offset" in w.options)) {
                                    let ee = Math.abs(13.5) / Math.SQRT2;
                                    w.options.offset = this._defaultMarker ? {
                                        top: [
                                            0,
                                            0
                                        ],
                                        "top-left": [
                                            0,
                                            0
                                        ],
                                        "top-right": [
                                            0,
                                            0
                                        ],
                                        bottom: [
                                            0,
                                            -38.1
                                        ],
                                        "bottom-left": [
                                            ee,
                                            -1 * (24.6 + ee)
                                        ],
                                        "bottom-right": [
                                            -ee,
                                            -1 * (24.6 + ee)
                                        ],
                                        left: [
                                            13.5,
                                            -24.6
                                        ],
                                        right: [
                                            -13.5,
                                            -24.6
                                        ]
                                    } : this._offset;
                                }
                                this._popup = w, this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                            }
                            return this;
                        }
                        setSubpixelPositioning(w) {
                            return this._subpixelPositioning = w, this;
                        }
                        getPopup() {
                            return this._popup;
                        }
                        togglePopup() {
                            let w = this._popup;
                            return this._element.style.opacity === this._opacityWhenCovered ? this : w ? (w.isOpen() ? w.remove() : (w.setLngLat(this._lngLat), w.addTo(this._map)), this) : this;
                        }
                        _updateOpacity(w = !1) {
                            var B, Q;
                            if (!(!((B = this._map) === null || B === void 0) && B.terrain)) return void (this._element.style.opacity !== this._opacity && (this._element.style.opacity = this._opacity));
                            if (w) this._opacityTimeout = null;
                            else {
                                if (this._opacityTimeout) return;
                                this._opacityTimeout = setTimeout(()=>{
                                    this._opacityTimeout = null;
                                }, 100);
                            }
                            let ee = this._map, se = ee.terrain.depthAtPoint(this._pos), qe = ee.terrain.getElevationForLngLatZoom(this._lngLat, ee.transform.tileZoom);
                            if (ee.transform.lngLatToCameraDepth(this._lngLat, qe) - se < .006) return void (this._element.style.opacity = this._opacity);
                            let je = -this._offset.y / ee.transform._pixelPerMeter, it = Math.sin(ee.getPitch() * Math.PI / 180) * je, yt = ee.terrain.depthAtPoint(new a.P(this._pos.x, this._pos.y - this._offset.y)), Ot = ee.transform.lngLatToCameraDepth(this._lngLat, qe + it) - yt > .006;
                            !((Q = this._popup) === null || Q === void 0) && Q.isOpen() && Ot && this._popup.remove(), this._element.style.opacity = Ot ? this._opacityWhenCovered : this._opacity;
                        }
                        getOffset() {
                            return this._offset;
                        }
                        setOffset(w) {
                            return this._offset = a.P.convert(w), this._update(), this;
                        }
                        addClassName(w) {
                            this._element.classList.add(w);
                        }
                        removeClassName(w) {
                            this._element.classList.remove(w);
                        }
                        toggleClassName(w) {
                            return this._element.classList.toggle(w);
                        }
                        setDraggable(w) {
                            return this._draggable = !!w, this._map && (w ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
                        }
                        isDraggable() {
                            return this._draggable;
                        }
                        setRotation(w) {
                            return this._rotation = w || 0, this._update(), this;
                        }
                        getRotation() {
                            return this._rotation;
                        }
                        setRotationAlignment(w) {
                            return this._rotationAlignment = w || "auto", this._update(), this;
                        }
                        getRotationAlignment() {
                            return this._rotationAlignment;
                        }
                        setPitchAlignment(w) {
                            return this._pitchAlignment = w && w !== "auto" ? w : this._rotationAlignment, this._update(), this;
                        }
                        getPitchAlignment() {
                            return this._pitchAlignment;
                        }
                        setOpacity(w, B) {
                            return w === void 0 && B === void 0 && (this._opacity = "1", this._opacityWhenCovered = "0.2"), w !== void 0 && (this._opacity = w), B !== void 0 && (this._opacityWhenCovered = B), this._map && this._updateOpacity(!0), this;
                        }
                    }
                    let mf = {
                        positionOptions: {
                            enableHighAccuracy: !1,
                            maximumAge: 0,
                            timeout: 6e3
                        },
                        fitBoundsOptions: {
                            maxZoom: 15
                        },
                        trackUserLocation: !1,
                        showAccuracyCircle: !0,
                        showUserLocation: !0
                    }, bu = 0, Kc = !1, Du = {
                        maxWidth: 100,
                        unit: "metric"
                    };
                    function Dc(le, w, B) {
                        let Q = B && B.maxWidth || 100, ee = le._container.clientHeight / 2, se = le.unproject([
                            0,
                            ee
                        ]), qe = le.unproject([
                            Q,
                            ee
                        ]), je = se.distanceTo(qe);
                        if (B && B.unit === "imperial") {
                            let it = 3.2808 * je;
                            it > 5280 ? Da(w, Q, it / 5280, le._getUIString("ScaleControl.Miles")) : Da(w, Q, it, le._getUIString("ScaleControl.Feet"));
                        } else B && B.unit === "nautical" ? Da(w, Q, je / 1852, le._getUIString("ScaleControl.NauticalMiles")) : je >= 1e3 ? Da(w, Q, je / 1e3, le._getUIString("ScaleControl.Kilometers")) : Da(w, Q, je, le._getUIString("ScaleControl.Meters"));
                    }
                    function Da(le, w, B, Q) {
                        let ee = function(se) {
                            let qe = Math.pow(10, `${Math.floor(se)}`.length - 1), je = se / qe;
                            return je = je >= 10 ? 10 : je >= 5 ? 5 : je >= 3 ? 3 : je >= 2 ? 2 : je >= 1 ? 1 : function(it) {
                                let yt = Math.pow(10, Math.ceil(-Math.log(it) / Math.LN10));
                                return Math.round(it * yt) / yt;
                            }(je), qe * je;
                        }(B);
                        le.style.width = w * (ee / B) + "px", le.innerHTML = `${ee}&nbsp;${Q}`;
                    }
                    let eo = {
                        closeButton: !0,
                        closeOnClick: !0,
                        focusAfterOpen: !0,
                        className: "",
                        maxWidth: "240px",
                        subpixelPositioning: !1
                    }, Jc = [
                        "a[href]",
                        "[tabindex]:not([tabindex='-1'])",
                        "[contenteditable]:not([contenteditable='false'])",
                        "button:not([disabled])",
                        "input:not([disabled])",
                        "select:not([disabled])",
                        "textarea:not([disabled])"
                    ].join(", ");
                    function yc(le) {
                        if (le) {
                            if (typeof le == "number") {
                                let w = Math.round(Math.abs(le) / Math.SQRT2);
                                return {
                                    center: new a.P(0, 0),
                                    top: new a.P(0, le),
                                    "top-left": new a.P(w, w),
                                    "top-right": new a.P(-w, w),
                                    bottom: new a.P(0, -le),
                                    "bottom-left": new a.P(w, -w),
                                    "bottom-right": new a.P(-w, -w),
                                    left: new a.P(le, 0),
                                    right: new a.P(-le, 0)
                                };
                            }
                            if (le instanceof a.P || Array.isArray(le)) {
                                let w = a.P.convert(le);
                                return {
                                    center: w,
                                    top: w,
                                    "top-left": w,
                                    "top-right": w,
                                    bottom: w,
                                    "bottom-left": w,
                                    "bottom-right": w,
                                    left: w,
                                    right: w
                                };
                            }
                            return {
                                center: a.P.convert(le.center || [
                                    0,
                                    0
                                ]),
                                top: a.P.convert(le.top || [
                                    0,
                                    0
                                ]),
                                "top-left": a.P.convert(le["top-left"] || [
                                    0,
                                    0
                                ]),
                                "top-right": a.P.convert(le["top-right"] || [
                                    0,
                                    0
                                ]),
                                bottom: a.P.convert(le.bottom || [
                                    0,
                                    0
                                ]),
                                "bottom-left": a.P.convert(le["bottom-left"] || [
                                    0,
                                    0
                                ]),
                                "bottom-right": a.P.convert(le["bottom-right"] || [
                                    0,
                                    0
                                ]),
                                left: a.P.convert(le.left || [
                                    0,
                                    0
                                ]),
                                right: a.P.convert(le.right || [
                                    0,
                                    0
                                ])
                            };
                        }
                        return yc(new a.P(0, 0));
                    }
                    let _c = o;
                    i.AJAXError = a.bh, i.Evented = a.E, i.LngLat = a.N, i.MercatorCoordinate = a.Z, i.Point = a.P, i.addProtocol = a.bi, i.config = a.a, i.removeProtocol = a.bj, i.AttributionControl = qa, i.BoxZoomHandler = xu, i.CanvasSource = Ct, i.CooperativeGesturesHandler = qi, i.DoubleClickZoomHandler = fi, i.DragPanHandler = Xi, i.DragRotateHandler = hn, i.EdgeInsets = ic, i.FullscreenControl = class extends a.E {
                        constructor(le = {}){
                            super(), this._onFullscreenChange = ()=>{
                                var w;
                                let B = window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement;
                                for(; !((w = B == null ? void 0 : B.shadowRoot) === null || w === void 0) && w.fullscreenElement;)B = B.shadowRoot.fullscreenElement;
                                B === this._container !== this._fullscreen && this._handleFullscreenChange();
                            }, this._onClickFullscreen = ()=>{
                                this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                            }, this._fullscreen = !1, le && le.container && (le.container instanceof HTMLElement ? this._container = le.container : a.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
                        }
                        onAdd(le) {
                            return this._map = le, this._container || (this._container = this._map.getContainer()), this._controlContainer = c.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
                        }
                        onRemove() {
                            c.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
                        }
                        _setupUI() {
                            let le = this._fullscreenButton = c.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                            c.create("span", "maplibregl-ctrl-icon", le).setAttribute("aria-hidden", "true"), le.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
                        }
                        _updateTitle() {
                            let le = this._getTitle();
                            this._fullscreenButton.setAttribute("aria-label", le), this._fullscreenButton.title = le;
                        }
                        _getTitle() {
                            return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                        }
                        _isFullscreen() {
                            return this._fullscreen;
                        }
                        _handleFullscreenChange() {
                            this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new a.k("fullscreenstart")), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new a.k("fullscreenend")), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
                        }
                        _exitFullscreen() {
                            window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
                        }
                        _requestFullscreen() {
                            this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
                        }
                        _togglePseudoFullScreen() {
                            this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
                        }
                    }, i.GeoJSONSource = rt, i.GeolocateControl = class extends a.E {
                        constructor(le){
                            super(), this._onSuccess = (w)=>{
                                if (this._map) {
                                    if (this._isOutOfMapMaxBounds(w)) return this._setErrorState(), this.fire(new a.k("outofmaxbounds", w)), this._updateMarker(), void this._finish();
                                    if (this.options.trackUserLocation) switch(this._lastKnownPosition = w, this._watchState){
                                        case "WAITING_ACTIVE":
                                        case "ACTIVE_LOCK":
                                        case "ACTIVE_ERROR":
                                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                            break;
                                        case "BACKGROUND":
                                        case "BACKGROUND_ERROR":
                                            this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                            break;
                                        default:
                                            throw new Error(`Unexpected watchState ${this._watchState}`);
                                    }
                                    this.options.showUserLocation && this._watchState !== "OFF" && this._updateMarker(w), this.options.trackUserLocation && this._watchState !== "ACTIVE_LOCK" || this._updateCamera(w), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new a.k("geolocate", w)), this._finish();
                                }
                            }, this._updateCamera = (w)=>{
                                let B = new a.N(w.coords.longitude, w.coords.latitude), Q = w.coords.accuracy, ee = this._map.getBearing(), se = a.e({
                                    bearing: ee
                                }, this.options.fitBoundsOptions), qe = ce.fromLngLat(B, Q);
                                this._map.fitBounds(qe, se, {
                                    geolocateSource: !0
                                });
                            }, this._updateMarker = (w)=>{
                                if (w) {
                                    let B = new a.N(w.coords.longitude, w.coords.latitude);
                                    this._accuracyCircleMarker.setLngLat(B).addTo(this._map), this._userLocationDotMarker.setLngLat(B).addTo(this._map), this._accuracy = w.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                                } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                            }, this._onZoom = ()=>{
                                this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                            }, this._onError = (w)=>{
                                if (this._map) {
                                    if (this.options.trackUserLocation) {
                                        if (w.code === 1) {
                                            this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                            let B = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                            this._geolocateButton.title = B, this._geolocateButton.setAttribute("aria-label", B), this._geolocationWatchID !== void 0 && this._clearWatch();
                                        } else {
                                            if (w.code === 3 && Kc) return;
                                            this._setErrorState();
                                        }
                                    }
                                    this._watchState !== "OFF" && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new a.k("error", w)), this._finish();
                                }
                            }, this._finish = ()=>{
                                this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                            }, this._setupUI = ()=>{
                                this._map && (this._container.addEventListener("contextmenu", (w)=>w.preventDefault()), this._geolocateButton = c.create("button", "maplibregl-ctrl-geolocate", this._container), c.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", this._geolocateButton.disabled = !0);
                            }, this._finishSetupUI = (w)=>{
                                if (this._map) {
                                    if (w === !1) {
                                        a.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                                        let B = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                        this._geolocateButton.disabled = !0, this._geolocateButton.title = B, this._geolocateButton.setAttribute("aria-label", B);
                                    } else {
                                        let B = this._map._getUIString("GeolocateControl.FindMyLocation");
                                        this._geolocateButton.disabled = !1, this._geolocateButton.title = B, this._geolocateButton.setAttribute("aria-label", B);
                                    }
                                    this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = c.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new ac({
                                        element: this._dotElement
                                    }), this._circleElement = c.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new ac({
                                        element: this._circleElement,
                                        pitchAlignment: "map"
                                    }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (B)=>{
                                        B.geolocateSource || this._watchState !== "ACTIVE_LOCK" || B.originalEvent && B.originalEvent.type === "resize" || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new a.k("trackuserlocationend")), this.fire(new a.k("userlocationlostfocus")));
                                    });
                                }
                            }, this.options = a.e({}, mf, le);
                        }
                        onAdd(le) {
                            return this._map = le, this._container = c.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), (function() {
                                return a._(this, arguments, void 0, function*(w = !1) {
                                    if (vs !== void 0 && !w) return vs;
                                    if (window.navigator.permissions === void 0) return vs = !!window.navigator.geolocation, vs;
                                    try {
                                        vs = (yield window.navigator.permissions.query({
                                            name: "geolocation"
                                        })).state !== "denied";
                                    } catch (B) {
                                        vs = !!window.navigator.geolocation;
                                    }
                                    return vs;
                                });
                            })().then((w)=>this._finishSetupUI(w)), this._container;
                        }
                        onRemove() {
                            this._geolocationWatchID !== void 0 && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), c.remove(this._container), this._map.off("zoom", this._onZoom), this._map = void 0, bu = 0, Kc = !1;
                        }
                        _isOutOfMapMaxBounds(le) {
                            let w = this._map.getMaxBounds(), B = le.coords;
                            return w && (B.longitude < w.getWest() || B.longitude > w.getEast() || B.latitude < w.getSouth() || B.latitude > w.getNorth());
                        }
                        _setErrorState() {
                            switch(this._watchState){
                                case "WAITING_ACTIVE":
                                    this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                                    break;
                                case "ACTIVE_LOCK":
                                    this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                                    break;
                                case "BACKGROUND":
                                    this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                                    break;
                                case "ACTIVE_ERROR":
                                    break;
                                default:
                                    throw new Error(`Unexpected watchState ${this._watchState}`);
                            }
                        }
                        _updateCircleRadius() {
                            let le = this._map.getBounds(), w = le.getSouthEast(), B = le.getNorthEast(), Q = w.distanceTo(B), ee = Math.ceil(this._accuracy / (Q / this._map._container.clientHeight) * 2);
                            this._circleElement.style.width = `${ee}px`, this._circleElement.style.height = `${ee}px`;
                        }
                        trigger() {
                            if (!this._setup) return a.w("Geolocate control triggered before added to a map"), !1;
                            if (this.options.trackUserLocation) {
                                switch(this._watchState){
                                    case "OFF":
                                        this._watchState = "WAITING_ACTIVE", this.fire(new a.k("trackuserlocationstart"));
                                        break;
                                    case "WAITING_ACTIVE":
                                    case "ACTIVE_LOCK":
                                    case "ACTIVE_ERROR":
                                    case "BACKGROUND_ERROR":
                                        bu--, Kc = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new a.k("trackuserlocationend"));
                                        break;
                                    case "BACKGROUND":
                                        this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new a.k("trackuserlocationstart")), this.fire(new a.k("userlocationfocus"));
                                        break;
                                    default:
                                        throw new Error(`Unexpected watchState ${this._watchState}`);
                                }
                                switch(this._watchState){
                                    case "WAITING_ACTIVE":
                                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                        break;
                                    case "ACTIVE_LOCK":
                                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                        break;
                                    case "OFF":
                                        break;
                                    default:
                                        throw new Error(`Unexpected watchState ${this._watchState}`);
                                }
                                if (this._watchState === "OFF" && this._geolocationWatchID !== void 0) this._clearWatch();
                                else if (this._geolocationWatchID === void 0) {
                                    let le;
                                    this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), bu++, bu > 1 ? (le = {
                                        maximumAge: 6e5,
                                        timeout: 0
                                    }, Kc = !0) : (le = this.options.positionOptions, Kc = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, le);
                                }
                            } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                            return !0;
                        }
                        _clearWatch() {
                            window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                        }
                    }, i.Hash = gd, i.ImageSource = Rt, i.KeyboardHandler = Bt, i.LngLatBounds = ce, i.LogoControl = Cn, i.Map = class extends Ta {
                        constructor(le){
                            a.bf.mark(a.bg.create);
                            let w = Object.assign(Object.assign({}, Gs), le);
                            if (w.minZoom != null && w.maxZoom != null && w.minZoom > w.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                            if (w.minPitch != null && w.maxPitch != null && w.minPitch > w.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                            if (w.minPitch != null && w.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                            if (w.maxPitch != null && w.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                            if (super(new Qs(w.minZoom, w.maxZoom, w.minPitch, w.maxPitch, w.renderWorldCopies), {
                                bearingSnap: w.bearingSnap
                            }), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new sn, this._controls = [], this._mapId = a.a4(), this._contextLost = (B)=>{
                                B.preventDefault(), this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this.fire(new a.k("webglcontextlost", {
                                    originalEvent: B
                                }));
                            }, this._contextRestored = (B)=>{
                                this._setupPainter(), this.resize(), this._update(), this.fire(new a.k("webglcontextrestored", {
                                    originalEvent: B
                                }));
                            }, this._onMapScroll = (B)=>{
                                if (B.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                            }, this._onWindowOnline = ()=>{
                                this._update();
                            }, this._interactive = w.interactive, this._maxTileCacheSize = w.maxTileCacheSize, this._maxTileCacheZoomLevels = w.maxTileCacheZoomLevels, this._failIfMajorPerformanceCaveat = w.failIfMajorPerformanceCaveat === !0, this._preserveDrawingBuffer = w.preserveDrawingBuffer === !0, this._antialias = w.antialias === !0, this._trackResize = w.trackResize === !0, this._bearingSnap = w.bearingSnap, this._refreshExpiredTiles = w.refreshExpiredTiles === !0, this._fadeDuration = w.fadeDuration, this._crossSourceCollisions = w.crossSourceCollisions === !0, this._collectResourceTiming = w.collectResourceTiming === !0, this._locale = Object.assign(Object.assign({}, Bo), w.locale), this._clickTolerance = w.clickTolerance, this._overridePixelRatio = w.pixelRatio, this._maxCanvasSize = w.maxCanvasSize, this.transformCameraUpdate = w.transformCameraUpdate, this.cancelPendingTileRequestsWhileZooming = w.cancelPendingTileRequestsWhileZooming === !0, this._imageQueueHandle = p.addThrottleControl(()=>this.isMoving()), this._requestManager = new E(w.transformRequest), typeof w.container == "string") {
                                if (this._container = document.getElementById(w.container), !this._container) throw new Error(`Container '${w.container}' not found.`);
                            } else {
                                if (!(w.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                                this._container = w.container;
                            }
                            if (w.maxBounds && this.setMaxBounds(w.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)).on("moveend", ()=>this._update(!1)).on("zoom", ()=>this._update(!0)).on("terrain", ()=>{
                                this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                            }).once("idle", ()=>{
                                this._idleTriggered = !0;
                            }), typeof window != "undefined") {
                                addEventListener("online", this._onWindowOnline, !1);
                                let B = !1, Q = Qh((ee)=>{
                                    this._trackResize && !this._removed && (this.resize(ee), this.redraw());
                                }, 50);
                                this._resizeObserver = new ResizeObserver((ee)=>{
                                    B ? Q(ee) : B = !0;
                                }), this._resizeObserver.observe(this._container);
                            }
                            this.handlers = new Ma(this, w), this._hash = w.hash && new gd(typeof w.hash == "string" && w.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                                center: w.center,
                                zoom: w.zoom,
                                bearing: w.bearing,
                                pitch: w.pitch
                            }), w.bounds && (this.resize(), this.fitBounds(w.bounds, a.e({}, w.fitBoundsOptions, {
                                duration: 0
                            })))), this.resize(), this._localIdeographFontFamily = w.localIdeographFontFamily, this._validateStyle = w.validateStyle, w.style && this.setStyle(w.style, {
                                localIdeographFontFamily: w.localIdeographFontFamily
                            }), w.attributionControl && this.addControl(new qa(typeof w.attributionControl == "boolean" ? void 0 : w.attributionControl)), w.maplibreLogo && this.addControl(new Cn, w.logoPosition), this.on("style.load", ()=>{
                                this.transform.unmodified && this.jumpTo(this.style.stylesheet);
                            }), this.on("data", (B)=>{
                                this._update(B.dataType === "style"), this.fire(new a.k(`${B.dataType}data`, B));
                            }), this.on("dataloading", (B)=>{
                                this.fire(new a.k(`${B.dataType}dataloading`, B));
                            }), this.on("dataabort", (B)=>{
                                this.fire(new a.k("sourcedataabort", B));
                            });
                        }
                        _getMapId() {
                            return this._mapId;
                        }
                        addControl(le, w) {
                            if (w === void 0 && (w = le.getDefaultPosition ? le.getDefaultPosition() : "top-right"), !le || !le.onAdd) return this.fire(new a.j(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                            let B = le.onAdd(this);
                            this._controls.push(le);
                            let Q = this._controlPositions[w];
                            return w.indexOf("bottom") !== -1 ? Q.insertBefore(B, Q.firstChild) : Q.appendChild(B), this;
                        }
                        removeControl(le) {
                            if (!le || !le.onRemove) return this.fire(new a.j(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                            let w = this._controls.indexOf(le);
                            return w > -1 && this._controls.splice(w, 1), le.onRemove(this), this;
                        }
                        hasControl(le) {
                            return this._controls.indexOf(le) > -1;
                        }
                        calculateCameraOptionsFromTo(le, w, B, Q) {
                            return Q == null && this.terrain && (Q = this.terrain.getElevationForLngLatZoom(B, this.transform.tileZoom)), super.calculateCameraOptionsFromTo(le, w, B, Q);
                        }
                        resize(le) {
                            var w;
                            let B = this._containerDimensions(), Q = B[0], ee = B[1], se = this._getClampedPixelRatio(Q, ee);
                            if (this._resizeCanvas(Q, ee, se), this.painter.resize(Q, ee, se), this.painter.overLimit()) {
                                let je = this.painter.context.gl;
                                this._maxCanvasSize = [
                                    je.drawingBufferWidth,
                                    je.drawingBufferHeight
                                ];
                                let it = this._getClampedPixelRatio(Q, ee);
                                this._resizeCanvas(Q, ee, it), this.painter.resize(Q, ee, it);
                            }
                            this.transform.resize(Q, ee), (w = this._requestedCameraState) === null || w === void 0 || w.resize(Q, ee);
                            let qe = !this._moving;
                            return qe && (this.stop(), this.fire(new a.k("movestart", le)).fire(new a.k("move", le))), this.fire(new a.k("resize", le)), qe && this.fire(new a.k("moveend", le)), this;
                        }
                        _getClampedPixelRatio(le, w) {
                            let { 0: B, 1: Q } = this._maxCanvasSize, ee = this.getPixelRatio(), se = le * ee, qe = w * ee;
                            return Math.min(se > B ? B / se : 1, qe > Q ? Q / qe : 1) * ee;
                        }
                        getPixelRatio() {
                            var le;
                            return (le = this._overridePixelRatio) !== null && le !== void 0 ? le : devicePixelRatio;
                        }
                        setPixelRatio(le) {
                            this._overridePixelRatio = le, this.resize();
                        }
                        getBounds() {
                            return this.transform.getBounds();
                        }
                        getMaxBounds() {
                            return this.transform.getMaxBounds();
                        }
                        setMaxBounds(le) {
                            return this.transform.setMaxBounds(ce.convert(le)), this._update();
                        }
                        setMinZoom(le) {
                            if ((le = le == null ? -2 : le) >= -2 && le <= this.transform.maxZoom) return this.transform.minZoom = le, this._update(), this.getZoom() < le && this.setZoom(le), this;
                            throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                        }
                        getMinZoom() {
                            return this.transform.minZoom;
                        }
                        setMaxZoom(le) {
                            if ((le = le == null ? 22 : le) >= this.transform.minZoom) return this.transform.maxZoom = le, this._update(), this.getZoom() > le && this.setZoom(le), this;
                            throw new Error("maxZoom must be greater than the current minZoom");
                        }
                        getMaxZoom() {
                            return this.transform.maxZoom;
                        }
                        setMinPitch(le) {
                            if ((le = le == null ? 0 : le) < 0) throw new Error("minPitch must be greater than or equal to 0");
                            if (le >= 0 && le <= this.transform.maxPitch) return this.transform.minPitch = le, this._update(), this.getPitch() < le && this.setPitch(le), this;
                            throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                        }
                        getMinPitch() {
                            return this.transform.minPitch;
                        }
                        setMaxPitch(le) {
                            if ((le = le == null ? 60 : le) > 85) throw new Error("maxPitch must be less than or equal to 85");
                            if (le >= this.transform.minPitch) return this.transform.maxPitch = le, this._update(), this.getPitch() > le && this.setPitch(le), this;
                            throw new Error("maxPitch must be greater than the current minPitch");
                        }
                        getMaxPitch() {
                            return this.transform.maxPitch;
                        }
                        getRenderWorldCopies() {
                            return this.transform.renderWorldCopies;
                        }
                        setRenderWorldCopies(le) {
                            return this.transform.renderWorldCopies = le, this._update();
                        }
                        project(le) {
                            return this.transform.locationPoint(a.N.convert(le), this.style && this.terrain);
                        }
                        unproject(le) {
                            return this.transform.pointLocation(a.P.convert(le), this.terrain);
                        }
                        isMoving() {
                            var le;
                            return this._moving || ((le = this.handlers) === null || le === void 0 ? void 0 : le.isMoving());
                        }
                        isZooming() {
                            var le;
                            return this._zooming || ((le = this.handlers) === null || le === void 0 ? void 0 : le.isZooming());
                        }
                        isRotating() {
                            var le;
                            return this._rotating || ((le = this.handlers) === null || le === void 0 ? void 0 : le.isRotating());
                        }
                        _createDelegatedListener(le, w, B) {
                            if (le === "mouseenter" || le === "mouseover") {
                                let Q = !1;
                                return {
                                    layers: w,
                                    listener: B,
                                    delegates: {
                                        mousemove: (se)=>{
                                            let qe = w.filter((it)=>this.getLayer(it)), je = qe.length !== 0 ? this.queryRenderedFeatures(se.point, {
                                                layers: qe
                                            }) : [];
                                            je.length ? Q || (Q = !0, B.call(this, new ru(le, this, se.originalEvent, {
                                                features: je
                                            }))) : Q = !1;
                                        },
                                        mouseout: ()=>{
                                            Q = !1;
                                        }
                                    }
                                };
                            }
                            if (le === "mouseleave" || le === "mouseout") {
                                let Q = !1;
                                return {
                                    layers: w,
                                    listener: B,
                                    delegates: {
                                        mousemove: (qe)=>{
                                            let je = w.filter((it)=>this.getLayer(it));
                                            (je.length !== 0 ? this.queryRenderedFeatures(qe.point, {
                                                layers: je
                                            }) : []).length ? Q = !0 : Q && (Q = !1, B.call(this, new ru(le, this, qe.originalEvent)));
                                        },
                                        mouseout: (qe)=>{
                                            Q && (Q = !1, B.call(this, new ru(le, this, qe.originalEvent)));
                                        }
                                    }
                                };
                            }
                            {
                                let Q = (ee)=>{
                                    let se = w.filter((je)=>this.getLayer(je)), qe = se.length !== 0 ? this.queryRenderedFeatures(ee.point, {
                                        layers: se
                                    }) : [];
                                    qe.length && (ee.features = qe, B.call(this, ee), delete ee.features);
                                };
                                return {
                                    layers: w,
                                    listener: B,
                                    delegates: {
                                        [le]: Q
                                    }
                                };
                            }
                        }
                        _saveDelegatedListener(le, w) {
                            this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[le] = this._delegatedListeners[le] || [], this._delegatedListeners[le].push(w);
                        }
                        _removeDelegatedListener(le, w, B) {
                            if (!this._delegatedListeners || !this._delegatedListeners[le]) return;
                            let Q = this._delegatedListeners[le];
                            for(let ee = 0; ee < Q.length; ee++){
                                let se = Q[ee];
                                if (se.listener === B && se.layers.length === w.length && se.layers.every((qe)=>w.includes(qe))) {
                                    for(let qe in se.delegates)this.off(qe, se.delegates[qe]);
                                    return void Q.splice(ee, 1);
                                }
                            }
                        }
                        on(le, w, B) {
                            if (B === void 0) return super.on(le, w);
                            let Q = this._createDelegatedListener(le, typeof w == "string" ? [
                                w
                            ] : w, B);
                            this._saveDelegatedListener(le, Q);
                            for(let ee in Q.delegates)this.on(ee, Q.delegates[ee]);
                            return this;
                        }
                        once(le, w, B) {
                            if (B === void 0) return super.once(le, w);
                            let Q = typeof w == "string" ? [
                                w
                            ] : w, ee = this._createDelegatedListener(le, Q, B);
                            for(let se in ee.delegates){
                                let qe = ee.delegates[se];
                                ee.delegates[se] = (...je)=>{
                                    this._removeDelegatedListener(le, Q, B), qe(...je);
                                };
                            }
                            this._saveDelegatedListener(le, ee);
                            for(let se in ee.delegates)this.once(se, ee.delegates[se]);
                            return this;
                        }
                        off(le, w, B) {
                            return B === void 0 ? super.off(le, w) : (this._removeDelegatedListener(le, typeof w == "string" ? [
                                w
                            ] : w, B), this);
                        }
                        queryRenderedFeatures(le, w) {
                            if (!this.style) return [];
                            let B, Q = le instanceof a.P || Array.isArray(le), ee = Q ? le : [
                                [
                                    0,
                                    0
                                ],
                                [
                                    this.transform.width,
                                    this.transform.height
                                ]
                            ];
                            if (w = w || (Q ? {} : le) || {}, ee instanceof a.P || typeof ee[0] == "number") B = [
                                a.P.convert(ee)
                            ];
                            else {
                                let se = a.P.convert(ee[0]), qe = a.P.convert(ee[1]);
                                B = [
                                    se,
                                    new a.P(qe.x, se.y),
                                    qe,
                                    new a.P(se.x, qe.y),
                                    se
                                ];
                            }
                            return this.style.queryRenderedFeatures(B, w, this.transform);
                        }
                        querySourceFeatures(le, w) {
                            return this.style.querySourceFeatures(le, w);
                        }
                        setStyle(le, w) {
                            return (w = a.e({}, {
                                localIdeographFontFamily: this._localIdeographFontFamily,
                                validate: this._validateStyle
                            }, w)).diff !== !1 && w.localIdeographFontFamily === this._localIdeographFontFamily && this.style && le ? (this._diffStyle(le, w), this) : (this._localIdeographFontFamily = w.localIdeographFontFamily, this._updateStyle(le, w));
                        }
                        setTransformRequest(le) {
                            return this._requestManager.setTransformRequest(le), this;
                        }
                        _getUIString(le) {
                            let w = this._locale[le];
                            if (w == null) throw new Error(`Missing UI string '${le}'`);
                            return w;
                        }
                        _updateStyle(le, w) {
                            if (w.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(le, w));
                            let B = this.style && w.transformStyle ? this.style.serialize() : void 0;
                            return this.style && (this.style.setEventedParent(null), this.style._remove(!le)), le ? (this.style = new Ha(this, w || {}), this.style.setEventedParent(this, {
                                style: this.style
                            }), typeof le == "string" ? this.style.loadURL(le, w, B) : this.style.loadJSON(le, w, B), this) : (delete this.style, this);
                        }
                        _lazyInitEmptyStyle() {
                            this.style || (this.style = new Ha(this, {}), this.style.setEventedParent(this, {
                                style: this.style
                            }), this.style.loadEmpty());
                        }
                        _diffStyle(le, w) {
                            if (typeof le == "string") {
                                let B = this._requestManager.transformRequest(le, "Style");
                                a.h(B, new AbortController).then((Q)=>{
                                    this._updateDiff(Q.data, w);
                                }).catch((Q)=>{
                                    Q && this.fire(new a.j(Q));
                                });
                            } else typeof le == "object" && this._updateDiff(le, w);
                        }
                        _updateDiff(le, w) {
                            try {
                                this.style.setState(le, w) && this._update(!0);
                            } catch (B) {
                                a.w(`Unable to perform style diff: ${B.message || B.error || B}.  Rebuilding the style from scratch.`), this._updateStyle(le, w);
                            }
                        }
                        getStyle() {
                            if (this.style) return this.style.serialize();
                        }
                        isStyleLoaded() {
                            return this.style ? this.style.loaded() : a.w("There is no style added to the map.");
                        }
                        addSource(le, w) {
                            return this._lazyInitEmptyStyle(), this.style.addSource(le, w), this._update(!0);
                        }
                        isSourceLoaded(le) {
                            let w = this.style && this.style.sourceCaches[le];
                            if (w !== void 0) return w.loaded();
                            this.fire(new a.j(new Error(`There is no source with ID '${le}'`)));
                        }
                        setTerrain(le) {
                            if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), le) {
                                let w = this.style.sourceCaches[le.source];
                                if (!w) throw new Error(`cannot load terrain, because there exists no source with ID: ${le.source}`);
                                this.terrain === null && w.reload();
                                for(let B in this.style._layers){
                                    let Q = this.style._layers[B];
                                    Q.type === "hillshade" && Q.source === le.source && a.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                                }
                                this.terrain = new Xo(this.painter, w, le), this.painter.renderToTexture = new ys(this.painter, this.terrain), this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this._terrainDataCallback = (B)=>{
                                    B.dataType === "style" ? this.terrain.sourceCache.freeRtt() : B.dataType === "source" && B.tile && (B.sourceId !== le.source || this._elevationFreeze || (this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.terrain.sourceCache.freeRtt(B.tile.tileID));
                                }, this.style.on("data", this._terrainDataCallback);
                            } else this.terrain && this.terrain.sourceCache.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.minElevationForCurrentTile = 0, this.transform.elevation = 0;
                            return this.fire(new a.k("terrain", {
                                terrain: le
                            })), this;
                        }
                        getTerrain() {
                            var le, w;
                            return (w = (le = this.terrain) === null || le === void 0 ? void 0 : le.options) !== null && w !== void 0 ? w : null;
                        }
                        areTilesLoaded() {
                            let le = this.style && this.style.sourceCaches;
                            for(let w in le){
                                let B = le[w]._tiles;
                                for(let Q in B){
                                    let ee = B[Q];
                                    if (ee.state !== "loaded" && ee.state !== "errored") return !1;
                                }
                            }
                            return !0;
                        }
                        removeSource(le) {
                            return this.style.removeSource(le), this._update(!0);
                        }
                        getSource(le) {
                            return this.style.getSource(le);
                        }
                        addImage(le, w, B = {}) {
                            let { pixelRatio: Q = 1, sdf: ee = !1, stretchX: se, stretchY: qe, content: je, textFitWidth: it, textFitHeight: yt } = B;
                            if (this._lazyInitEmptyStyle(), !(w instanceof HTMLImageElement || a.b(w))) {
                                if (w.width === void 0 || w.height === void 0) return this.fire(new a.j(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                {
                                    let { width: Ot, height: Nt, data: hr } = w, Sr = w;
                                    return this.style.addImage(le, {
                                        data: new a.R({
                                            width: Ot,
                                            height: Nt
                                        }, new Uint8Array(hr)),
                                        pixelRatio: Q,
                                        stretchX: se,
                                        stretchY: qe,
                                        content: je,
                                        textFitWidth: it,
                                        textFitHeight: yt,
                                        sdf: ee,
                                        version: 0,
                                        userImage: Sr
                                    }), Sr.onAdd && Sr.onAdd(this, le), this;
                                }
                            }
                            {
                                let { width: Ot, height: Nt, data: hr } = u.getImageData(w);
                                this.style.addImage(le, {
                                    data: new a.R({
                                        width: Ot,
                                        height: Nt
                                    }, hr),
                                    pixelRatio: Q,
                                    stretchX: se,
                                    stretchY: qe,
                                    content: je,
                                    textFitWidth: it,
                                    textFitHeight: yt,
                                    sdf: ee,
                                    version: 0
                                });
                            }
                        }
                        updateImage(le, w) {
                            let B = this.style.getImage(le);
                            if (!B) return this.fire(new a.j(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                            let Q = w instanceof HTMLImageElement || a.b(w) ? u.getImageData(w) : w, { width: ee, height: se, data: qe } = Q;
                            if (ee === void 0 || se === void 0) return this.fire(new a.j(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                            if (ee !== B.data.width || se !== B.data.height) return this.fire(new a.j(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                            let je = !(w instanceof HTMLImageElement || a.b(w));
                            return B.data.replace(qe, je), this.style.updateImage(le, B), this;
                        }
                        getImage(le) {
                            return this.style.getImage(le);
                        }
                        hasImage(le) {
                            return le ? !!this.style.getImage(le) : (this.fire(new a.j(new Error("Missing required image id"))), !1);
                        }
                        removeImage(le) {
                            this.style.removeImage(le);
                        }
                        loadImage(le) {
                            return p.getImage(this._requestManager.transformRequest(le, "Image"), new AbortController);
                        }
                        listImages() {
                            return this.style.listImages();
                        }
                        addLayer(le, w) {
                            return this._lazyInitEmptyStyle(), this.style.addLayer(le, w), this._update(!0);
                        }
                        moveLayer(le, w) {
                            return this.style.moveLayer(le, w), this._update(!0);
                        }
                        removeLayer(le) {
                            return this.style.removeLayer(le), this._update(!0);
                        }
                        getLayer(le) {
                            return this.style.getLayer(le);
                        }
                        getLayersOrder() {
                            return this.style.getLayersOrder();
                        }
                        setLayerZoomRange(le, w, B) {
                            return this.style.setLayerZoomRange(le, w, B), this._update(!0);
                        }
                        setFilter(le, w, B = {}) {
                            return this.style.setFilter(le, w, B), this._update(!0);
                        }
                        getFilter(le) {
                            return this.style.getFilter(le);
                        }
                        setPaintProperty(le, w, B, Q = {}) {
                            return this.style.setPaintProperty(le, w, B, Q), this._update(!0);
                        }
                        getPaintProperty(le, w) {
                            return this.style.getPaintProperty(le, w);
                        }
                        setLayoutProperty(le, w, B, Q = {}) {
                            return this.style.setLayoutProperty(le, w, B, Q), this._update(!0);
                        }
                        getLayoutProperty(le, w) {
                            return this.style.getLayoutProperty(le, w);
                        }
                        setGlyphs(le, w = {}) {
                            return this._lazyInitEmptyStyle(), this.style.setGlyphs(le, w), this._update(!0);
                        }
                        getGlyphs() {
                            return this.style.getGlyphsUrl();
                        }
                        addSprite(le, w, B = {}) {
                            return this._lazyInitEmptyStyle(), this.style.addSprite(le, w, B, (Q)=>{
                                Q || this._update(!0);
                            }), this;
                        }
                        removeSprite(le) {
                            return this._lazyInitEmptyStyle(), this.style.removeSprite(le), this._update(!0);
                        }
                        getSprite() {
                            return this.style.getSprite();
                        }
                        setSprite(le, w = {}) {
                            return this._lazyInitEmptyStyle(), this.style.setSprite(le, w, (B)=>{
                                B || this._update(!0);
                            }), this;
                        }
                        setLight(le, w = {}) {
                            return this._lazyInitEmptyStyle(), this.style.setLight(le, w), this._update(!0);
                        }
                        getLight() {
                            return this.style.getLight();
                        }
                        setSky(le) {
                            return this._lazyInitEmptyStyle(), this.style.setSky(le), this._update(!0);
                        }
                        getSky() {
                            return this.style.getSky();
                        }
                        setFeatureState(le, w) {
                            return this.style.setFeatureState(le, w), this._update();
                        }
                        removeFeatureState(le, w) {
                            return this.style.removeFeatureState(le, w), this._update();
                        }
                        getFeatureState(le) {
                            return this.style.getFeatureState(le);
                        }
                        getContainer() {
                            return this._container;
                        }
                        getCanvasContainer() {
                            return this._canvasContainer;
                        }
                        getCanvas() {
                            return this._canvas;
                        }
                        _containerDimensions() {
                            let le = 0, w = 0;
                            return this._container && (le = this._container.clientWidth || 400, w = this._container.clientHeight || 300), [
                                le,
                                w
                            ];
                        }
                        _setupContainer() {
                            let le = this._container;
                            le.classList.add("maplibregl-map");
                            let w = this._canvasContainer = c.create("div", "maplibregl-canvas-container", le);
                            this._interactive && w.classList.add("maplibregl-interactive"), this._canvas = c.create("canvas", "maplibregl-canvas", w), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
                            let B = this._containerDimensions(), Q = this._getClampedPixelRatio(B[0], B[1]);
                            this._resizeCanvas(B[0], B[1], Q);
                            let ee = this._controlContainer = c.create("div", "maplibregl-control-container", le), se = this._controlPositions = {};
                            [
                                "top-left",
                                "top-right",
                                "bottom-left",
                                "bottom-right"
                            ].forEach((qe)=>{
                                se[qe] = c.create("div", `maplibregl-ctrl-${qe} `, ee);
                            }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                        }
                        _resizeCanvas(le, w, B) {
                            this._canvas.width = Math.floor(B * le), this._canvas.height = Math.floor(B * w), this._canvas.style.width = `${le}px`, this._canvas.style.height = `${w}px`;
                        }
                        _setupPainter() {
                            let le = {
                                alpha: !0,
                                stencil: !0,
                                depth: !0,
                                failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                                preserveDrawingBuffer: this._preserveDrawingBuffer,
                                antialias: this._antialias || !1
                            }, w = null;
                            this._canvas.addEventListener("webglcontextcreationerror", (Q)=>{
                                w = {
                                    requestedAttributes: le
                                }, Q && (w.statusMessage = Q.statusMessage, w.type = Q.type);
                            }, {
                                once: !0
                            });
                            let B = this._canvas.getContext("webgl2", le) || this._canvas.getContext("webgl", le);
                            if (!B) {
                                let Q = "Failed to initialize WebGL";
                                throw w ? (w.message = Q, new Error(JSON.stringify(w))) : new Error(Q);
                            }
                            this.painter = new Lc(B, this.transform), f.testSupport(B);
                        }
                        loaded() {
                            return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                        }
                        _update(le) {
                            return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || le, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                        }
                        _requestRenderFrame(le) {
                            return this._update(), this._renderTaskQueue.add(le);
                        }
                        _cancelRenderFrame(le) {
                            this._renderTaskQueue.remove(le);
                        }
                        _render(le) {
                            let w = this._idleTriggered ? this._fadeDuration : 0;
                            if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(le), this._removed) return;
                            let B = !1;
                            if (this.style && this._styleDirty) {
                                this._styleDirty = !1;
                                let ee = this.transform.zoom, se = u.now();
                                this.style.zoomHistory.update(ee, se);
                                let qe = new a.z(ee, {
                                    now: se,
                                    fadeDuration: w,
                                    zoomHistory: this.style.zoomHistory,
                                    transition: this.style.getTransition()
                                }), je = qe.crossFadingFactor();
                                je === 1 && je === this._crossFadingFactor || (B = !0, this._crossFadingFactor = je), this.style.update(qe);
                            }
                            this.style && this._sourcesDirty && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.sourceCache.update(this.transform, this.terrain), this.transform.minElevationForCurrentTile = this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom), this._elevationFreeze || (this.transform.elevation = this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform.minElevationForCurrentTile = 0, this.transform.elevation = 0), this._placementDirty = this.style && this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, w, this._crossSourceCollisions), this.painter.render(this.style, {
                                showTileBoundaries: this.showTileBoundaries,
                                showOverdrawInspector: this._showOverdrawInspector,
                                rotating: this.isRotating(),
                                zooming: this.isZooming(),
                                moving: this.isMoving(),
                                fadeDuration: w,
                                showPadding: this.showPadding
                            }), this.fire(new a.k("render")), this.loaded() && !this._loaded && (this._loaded = !0, a.bf.mark(a.bg.load), this.fire(new a.k("load"))), this.style && (this.style.hasTransitions() || B) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                            let Q = this._sourcesDirty || this._styleDirty || this._placementDirty;
                            return Q || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new a.k("idle")), !this._loaded || this._fullyLoaded || Q || (this._fullyLoaded = !0, a.bf.mark(a.bg.fullLoad)), this;
                        }
                        redraw() {
                            return this.style && (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._render(0)), this;
                        }
                        remove() {
                            var le;
                            this._hash && this._hash.remove();
                            for (let B of this._controls)B.onRemove(this);
                            this._controls = [], this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), typeof window != "undefined" && removeEventListener("online", this._onWindowOnline, !1), p.removeThrottleControl(this._imageQueueHandle), (le = this._resizeObserver) === null || le === void 0 || le.disconnect();
                            let w = this.painter.context.gl.getExtension("WEBGL_lose_context");
                            w != null && w.loseContext && w.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), c.remove(this._canvasContainer), c.remove(this._controlContainer), this._container.classList.remove("maplibregl-map"), a.bf.clearMetrics(), this._removed = !0, this.fire(new a.k("remove"));
                        }
                        triggerRepaint() {
                            this.style && !this._frameRequest && (this._frameRequest = new AbortController, u.frameAsync(this._frameRequest).then((le)=>{
                                a.bf.frame(le), this._frameRequest = null, this._render(le);
                            }).catch(()=>{}));
                        }
                        get showTileBoundaries() {
                            return !!this._showTileBoundaries;
                        }
                        set showTileBoundaries(le) {
                            this._showTileBoundaries !== le && (this._showTileBoundaries = le, this._update());
                        }
                        get showPadding() {
                            return !!this._showPadding;
                        }
                        set showPadding(le) {
                            this._showPadding !== le && (this._showPadding = le, this._update());
                        }
                        get showCollisionBoxes() {
                            return !!this._showCollisionBoxes;
                        }
                        set showCollisionBoxes(le) {
                            this._showCollisionBoxes !== le && (this._showCollisionBoxes = le, le ? this.style._generateCollisionBoxes() : this._update());
                        }
                        get showOverdrawInspector() {
                            return !!this._showOverdrawInspector;
                        }
                        set showOverdrawInspector(le) {
                            this._showOverdrawInspector !== le && (this._showOverdrawInspector = le, this._update());
                        }
                        get repaint() {
                            return !!this._repaint;
                        }
                        set repaint(le) {
                            this._repaint !== le && (this._repaint = le, this.triggerRepaint());
                        }
                        get vertices() {
                            return !!this._vertices;
                        }
                        set vertices(le) {
                            this._vertices = le, this._update();
                        }
                        get version() {
                            return yl;
                        }
                        getCameraTargetElevation() {
                            return this.transform.elevation;
                        }
                    }, i.MapMouseEvent = ru, i.MapTouchEvent = vf, i.MapWheelEvent = md, i.Marker = ac, i.NavigationControl = class {
                        constructor(le){
                            this._updateZoomButtons = ()=>{
                                let w = this._map.getZoom(), B = w === this._map.getMaxZoom(), Q = w === this._map.getMinZoom();
                                this._zoomInButton.disabled = B, this._zoomOutButton.disabled = Q, this._zoomInButton.setAttribute("aria-disabled", B.toString()), this._zoomOutButton.setAttribute("aria-disabled", Q.toString());
                            }, this._rotateCompassArrow = ()=>{
                                let w = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${this._map.transform.angle * (180 / Math.PI)}deg)` : `rotate(${this._map.transform.angle * (180 / Math.PI)}deg)`;
                                this._compassIcon.style.transform = w;
                            }, this._setButtonTitle = (w, B)=>{
                                let Q = this._map._getUIString(`NavigationControl.${B}`);
                                w.title = Q, w.setAttribute("aria-label", Q);
                            }, this.options = a.e({}, ia, le), this._container = c.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (w)=>w.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (w)=>this._map.zoomIn({}, {
                                    originalEvent: w
                                })), c.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (w)=>this._map.zoomOut({}, {
                                    originalEvent: w
                                })), c.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (w)=>{
                                this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                                    originalEvent: w
                                }) : this._map.resetNorth({}, {
                                    originalEvent: w
                                });
                            }), this._compassIcon = c.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                        }
                        onAdd(le) {
                            return this._map = le, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Ka(this._map, this._compass, this.options.visualizePitch)), this._container;
                        }
                        onRemove() {
                            c.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
                        }
                        _createButton(le, w) {
                            let B = c.create("button", le, this._container);
                            return B.type = "button", B.addEventListener("click", w), B;
                        }
                    }, i.Popup = class extends a.E {
                        constructor(le){
                            super(), this.remove = ()=>(this._content && c.remove(this._content), this._container && (c.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete this._map, this.fire(new a.k("close"))), this), this._onMouseUp = (w)=>{
                                this._update(w.point);
                            }, this._onMouseMove = (w)=>{
                                this._update(w.point);
                            }, this._onDrag = (w)=>{
                                this._update(w.point);
                            }, this._update = (w)=>{
                                var B;
                                if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                                if (!this._container) {
                                    if (this._container = c.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = c.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (let je of this.options.className.split(" "))this._container.classList.add(je);
                                    this._closeButton && this._closeButton.setAttribute("aria-label", this._map._getUIString("Popup.Close")), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
                                }
                                if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = this._map.transform.renderWorldCopies && !this._trackPointer ? Ko(this._lngLat, this._flatPos, this._map.transform) : (B = this._lngLat) === null || B === void 0 ? void 0 : B.wrap(), this._trackPointer && !w) return;
                                let Q = this._flatPos = this._pos = this._trackPointer && w ? w : this._map.project(this._lngLat);
                                this._map.terrain && (this._flatPos = this._trackPointer && w ? w : this._map.transform.locationPoint(this._lngLat));
                                let ee = this.options.anchor, se = yc(this.options.offset);
                                if (!ee) {
                                    let je = this._container.offsetWidth, it = this._container.offsetHeight, yt;
                                    yt = Q.y + se.bottom.y < it ? [
                                        "top"
                                    ] : Q.y > this._map.transform.height - it ? [
                                        "bottom"
                                    ] : [], Q.x < je / 2 ? yt.push("left") : Q.x > this._map.transform.width - je / 2 && yt.push("right"), ee = yt.length === 0 ? "bottom" : yt.join("-");
                                }
                                let qe = Q.add(se[ee]);
                                this.options.subpixelPositioning || (qe = qe.round()), c.setTransform(this._container, `${nu[ee]} translate(${qe.x}px,${qe.y}px)`), Ru(this._container, ee, "popup");
                            }, this._onClose = ()=>{
                                this.remove();
                            }, this.options = a.e(Object.create(eo), le);
                        }
                        addTo(le) {
                            return this._map && this.remove(), this._map = le, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new a.k("open")), this;
                        }
                        isOpen() {
                            return !!this._map;
                        }
                        getLngLat() {
                            return this._lngLat;
                        }
                        setLngLat(le) {
                            return this._lngLat = a.N.convert(le), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
                        }
                        trackPointer() {
                            return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
                        }
                        getElement() {
                            return this._container;
                        }
                        setText(le) {
                            return this.setDOMContent(document.createTextNode(le));
                        }
                        setHTML(le) {
                            let w = document.createDocumentFragment(), B = document.createElement("body"), Q;
                            for(B.innerHTML = le; Q = B.firstChild, Q;)w.appendChild(Q);
                            return this.setDOMContent(w);
                        }
                        getMaxWidth() {
                            var le;
                            return (le = this._container) === null || le === void 0 ? void 0 : le.style.maxWidth;
                        }
                        setMaxWidth(le) {
                            return this.options.maxWidth = le, this._update(), this;
                        }
                        setDOMContent(le) {
                            if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                            else this._content = c.create("div", "maplibregl-popup-content", this._container);
                            return this._content.appendChild(le), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
                        }
                        addClassName(le) {
                            return this._container && this._container.classList.add(le), this;
                        }
                        removeClassName(le) {
                            return this._container && this._container.classList.remove(le), this;
                        }
                        setOffset(le) {
                            return this.options.offset = le, this._update(), this;
                        }
                        toggleClassName(le) {
                            if (this._container) return this._container.classList.toggle(le);
                        }
                        setSubpixelPositioning(le) {
                            this.options.subpixelPositioning = le;
                        }
                        _createCloseButton() {
                            this.options.closeButton && (this._closeButton = c.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
                        }
                        _focusFirstElement() {
                            if (!this.options.focusAfterOpen || !this._container) return;
                            let le = this._container.querySelector(Jc);
                            le && le.focus();
                        }
                    }, i.RasterDEMTileSource = qt, i.RasterTileSource = ct, i.ScaleControl = class {
                        constructor(le){
                            this._onMove = ()=>{
                                Dc(this._map, this._container, this.options);
                            }, this.setUnit = (w)=>{
                                this.options.unit = w, Dc(this._map, this._container, this.options);
                            }, this.options = Object.assign(Object.assign({}, Du), le);
                        }
                        getDefaultPosition() {
                            return "bottom-left";
                        }
                        onAdd(le) {
                            return this._map = le, this._container = c.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", le.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
                        }
                        onRemove() {
                            c.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
                        }
                    }, i.ScrollZoomHandler = Ur, i.Style = Ha, i.TerrainControl = class {
                        constructor(le){
                            this._toggleTerrain = ()=>{
                                this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                            }, this._updateTerrainIcon = ()=>{
                                this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.Disable")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.Enable"));
                            }, this.options = le;
                        }
                        onAdd(le) {
                            return this._map = le, this._container = c.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = c.create("button", "maplibregl-ctrl-terrain", this._container), c.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
                        }
                        onRemove() {
                            c.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
                        }
                    }, i.TwoFingersTouchPitchHandler = gf, i.TwoFingersTouchRotateHandler = Yc, i.TwoFingersTouchZoomHandler = iu, i.TwoFingersTouchZoomRotateHandler = Ti, i.VectorTileSource = nt, i.VideoSource = kt, i.addSourceType = (le, w)=>a._(void 0, void 0, void 0, function*() {
                            if (xr(le)) throw new Error(`A source type called "${le}" already exists.`);
                            ((B, Q)=>{
                                Yt[B] = Q;
                            })(le, w);
                        }), i.clearPrewarmedResources = function() {
                        let le = ge;
                        le && (le.isPreloaded() && le.numActive() === 1 ? (le.release(_e), ge = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
                    }, i.getMaxParallelImageRequests = function() {
                        return a.a.MAX_PARALLEL_IMAGE_REQUESTS;
                    }, i.getRTLTextPluginStatus = function() {
                        return bt().getRTLTextPluginStatus();
                    }, i.getVersion = function() {
                        return _c;
                    }, i.getWorkerCount = function() {
                        return Me.workerCount;
                    }, i.getWorkerUrl = function() {
                        return a.a.WORKER_URL;
                    }, i.importScriptInWorkers = function(le) {
                        return Ae().broadcast("IS", le);
                    }, i.prewarm = function() {
                        Te().acquire(_e);
                    }, i.setMaxParallelImageRequests = function(le) {
                        a.a.MAX_PARALLEL_IMAGE_REQUESTS = le;
                    }, i.setRTLTextPlugin = function(le, w) {
                        return bt().setRTLTextPlugin(le, w);
                    }, i.setWorkerCount = function(le) {
                        Me.workerCount = le;
                    }, i.setWorkerUrl = function(le) {
                        a.a.WORKER_URL = le;
                    };
                });
                var n = e;
                return n;
            });
        });
        var KHe = ye((Z1r, YHe)=>{
            "use strict";
            var iw = Mr(), gjt = Pl().sanitizeHTML, mjt = fJ(), WHe = wx();
            function ZHe(e, t) {
                this.subplot = e, this.uid = e.uid + "-" + t, this.index = t, this.idSource = "source-" + this.uid, this.idLayer = WHe.layoutLayerPrefix + this.uid, this.sourceType = null, this.source = null, this.layerType = null, this.below = null, this.visible = !1;
            }
            var ag = ZHe.prototype;
            ag.update = function(t) {
                this.visible ? this.needsNewImage(t) ? this.updateImage(t) : this.needsNewSource(t) ? (this.removeLayer(), this.updateSource(t), this.updateLayer(t)) : this.needsNewLayer(t) ? this.updateLayer(t) : this.updateStyle(t) : (this.updateSource(t), this.updateLayer(t)), this.visible = n7(t);
            };
            ag.needsNewImage = function(e) {
                var t = this.subplot.map;
                return t.getSource(this.idSource) && this.sourceType === "image" && e.sourcetype === "image" && (this.source !== e.source || JSON.stringify(this.coordinates) !== JSON.stringify(e.coordinates));
            };
            ag.needsNewSource = function(e) {
                return this.sourceType !== e.sourcetype || JSON.stringify(this.source) !== JSON.stringify(e.source) || this.layerType !== e.type;
            };
            ag.needsNewLayer = function(e) {
                return this.layerType !== e.type || this.below !== this.subplot.belowLookup["layout-" + this.index];
            };
            ag.lookupBelow = function() {
                return this.subplot.belowLookup["layout-" + this.index];
            };
            ag.updateImage = function(e) {
                var t = this.subplot.map;
                t.getSource(this.idSource).updateImage({
                    url: e.source,
                    coordinates: e.coordinates
                });
                var r = this.findFollowingMapLayerId(this.lookupBelow());
                r !== null && this.subplot.map.moveLayer(this.idLayer, r);
            };
            ag.updateSource = function(e) {
                var t = this.subplot.map;
                if (t.getSource(this.idSource) && t.removeSource(this.idSource), this.sourceType = e.sourcetype, this.source = e.source, !!n7(e)) {
                    var r = yjt(e);
                    t.addSource(this.idSource, r);
                }
            };
            ag.findFollowingMapLayerId = function(e) {
                if (e === "traces") for(var t = this.subplot.getMapLayers(), r = 0; r < t.length; r++){
                    var n = t[r].id;
                    if (typeof n == "string" && n.indexOf(WHe.traceLayerPrefix) === 0) {
                        e = n;
                        break;
                    }
                }
                return e;
            };
            ag.updateLayer = function(e) {
                var t = this.subplot, r = XHe(e), n = this.lookupBelow(), i = this.findFollowingMapLayerId(n);
                this.removeLayer(), n7(e) && t.addLayer({
                    id: this.idLayer,
                    source: this.idSource,
                    "source-layer": e.sourcelayer || "",
                    type: e.type,
                    minzoom: e.minzoom,
                    maxzoom: e.maxzoom,
                    layout: r.layout,
                    paint: r.paint
                }, i), this.layerType = e.type, this.below = n;
            };
            ag.updateStyle = function(e) {
                if (n7(e)) {
                    var t = XHe(e);
                    this.subplot.setOptions(this.idLayer, "setLayoutProperty", t.layout), this.subplot.setOptions(this.idLayer, "setPaintProperty", t.paint);
                }
            };
            ag.removeLayer = function() {
                var e = this.subplot.map;
                e.getLayer(this.idLayer) && e.removeLayer(this.idLayer);
            };
            ag.dispose = function() {
                var e = this.subplot.map;
                e.getLayer(this.idLayer) && e.removeLayer(this.idLayer), e.getSource(this.idSource) && e.removeSource(this.idSource);
            };
            function n7(e) {
                if (!e.visible) return !1;
                var t = e.source;
                if (Array.isArray(t) && t.length > 0) {
                    for(var r = 0; r < t.length; r++)if (typeof t[r] != "string" || t[r].length === 0) return !1;
                    return !0;
                }
                return iw.isPlainObject(t) || typeof t == "string" && t.length > 0;
            }
            function XHe(e) {
                var t = {}, r = {};
                switch(e.type){
                    case "circle":
                        iw.extendFlat(r, {
                            "circle-radius": e.circle.radius,
                            "circle-color": e.color,
                            "circle-opacity": e.opacity
                        });
                        break;
                    case "line":
                        iw.extendFlat(r, {
                            "line-width": e.line.width,
                            "line-color": e.color,
                            "line-opacity": e.opacity,
                            "line-dasharray": e.line.dash
                        });
                        break;
                    case "fill":
                        iw.extendFlat(r, {
                            "fill-color": e.color,
                            "fill-outline-color": e.fill.outlinecolor,
                            "fill-opacity": e.opacity
                        });
                        break;
                    case "symbol":
                        var n = e.symbol, i = mjt(n.textposition, n.iconsize);
                        iw.extendFlat(t, {
                            "icon-image": n.icon + "-15",
                            "icon-size": n.iconsize / 10,
                            "text-field": n.text,
                            "text-size": n.textfont.size,
                            "text-anchor": i.anchor,
                            "text-offset": i.offset,
                            "symbol-placement": n.placement
                        }), iw.extendFlat(r, {
                            "icon-color": e.color,
                            "text-color": n.textfont.color,
                            "text-opacity": e.opacity
                        });
                        break;
                    case "raster":
                        iw.extendFlat(r, {
                            "raster-fade-duration": 0,
                            "raster-opacity": e.opacity
                        });
                        break;
                }
                return {
                    layout: t,
                    paint: r
                };
            }
            function yjt(e) {
                var t = e.sourcetype, r = e.source, n = {
                    type: t
                }, i;
                return t === "geojson" ? i = "data" : t === "vector" ? i = typeof r == "string" ? "url" : "tiles" : t === "raster" ? (i = "tiles", n.tileSize = 256) : t === "image" && (i = "url", n.coordinates = e.coordinates), n[i] = r, e.sourceattribution && (n.attribution = gjt(e.sourceattribution)), n;
            }
            YHe.exports = function(t, r, n) {
                var i = new ZHe(t, r);
                return i.update(n), i;
            };
        });
        var nGe = ye((X1r, iGe)=>{
            "use strict";
            var mJ = jHe(), yJ = Mr(), QHe = nx(), JHe = ba(), _jt = Qa(), xjt = gv(), a7 = Nc(), eGe = Sg(), bjt = eGe.drawMode, wjt = eGe.selectMode, Tjt = wf().prepSelect, Ajt = wf().clearOutline, Sjt = wf().clearSelectionsCache, Mjt = wf().selectOnClick, nw = wx(), Ejt = KHe();
            function tGe(e, t) {
                this.id = t, this.gd = e;
                var r = e._fullLayout, n = e._context;
                this.container = r._glcontainer.node(), this.isStatic = n.staticPlot, this.uid = r._uid + "-" + this.id, this.div = null, this.xaxis = null, this.yaxis = null, this.createFramework(r), this.map = null, this.styleObj = null, this.traceHash = {}, this.layerList = [], this.belowLookup = {}, this.dragging = !1, this.wheeling = !1;
            }
            var Sh = tGe.prototype;
            Sh.plot = function(e, t, r) {
                var n = this, i;
                n.map ? i = new Promise(function(a, o) {
                    n.updateMap(e, t, a, o);
                }) : i = new Promise(function(a, o) {
                    n.createMap(e, t, a, o);
                }), r.push(i);
            };
            Sh.createMap = function(e, t, r, n) {
                var i = this, a = t[i.id], o = i.styleObj = rGe(a.style), s = a.bounds, l = s ? [
                    [
                        s.west,
                        s.south
                    ],
                    [
                        s.east,
                        s.north
                    ]
                ] : null, u = i.map = new mJ.Map({
                    container: i.div,
                    style: o.style,
                    center: _J(a.center),
                    zoom: a.zoom,
                    bearing: a.bearing,
                    pitch: a.pitch,
                    maxBounds: l,
                    interactive: !i.isStatic,
                    preserveDrawingBuffer: i.isStatic,
                    doubleClickZoom: !1,
                    boxZoom: !1,
                    attributionControl: !1
                }).addControl(new mJ.AttributionControl({
                    compact: !0
                })), c = {};
                u.on("styleimagemissing", function(h) {
                    var d = h.id;
                    if (!c[d] && d.includes("-15")) {
                        c[d] = !0;
                        var v = new Image(15, 15);
                        v.onload = function() {
                            u.addImage(d, v);
                        }, v.crossOrigin = "Anonymous", v.src = "https://unpkg.com/maki@2.1.0/icons/" + d + ".svg";
                    }
                }), u.setTransformRequest(function(h) {
                    return h = h.replace("https://fonts.openmaptiles.org/Open Sans Extrabold", "https://fonts.openmaptiles.org/Open Sans Extra Bold"), h = h.replace("https://tiles.basemaps.cartocdn.com/fonts/Open Sans Extrabold", "https://fonts.openmaptiles.org/Open Sans Extra Bold"), h = h.replace("https://fonts.openmaptiles.org/Open Sans Regular,Arial Unicode MS Regular", "https://fonts.openmaptiles.org/Klokantech Noto Sans Regular"), {
                        url: h
                    };
                }), u._canvas.style.left = "0px", u._canvas.style.top = "0px", i.rejectOnError(n), i.isStatic || i.initFx(e, t);
                var f = [];
                f.push(new Promise(function(h) {
                    u.once("load", h);
                })), f = f.concat(QHe.fetchTraceGeoData(e)), Promise.all(f).then(function() {
                    i.fillBelowLookup(e, t), i.updateData(e), i.updateLayout(t), i.resolveOnRender(r);
                }).catch(n);
            };
            Sh.updateMap = function(e, t, r, n) {
                var i = this, a = i.map, o = t[this.id];
                i.rejectOnError(n);
                var s = [], l = rGe(o.style);
                JSON.stringify(i.styleObj) !== JSON.stringify(l) && (i.styleObj = l, a.setStyle(l.style), i.traceHash = {}, s.push(new Promise(function(u) {
                    a.once("styledata", u);
                }))), s = s.concat(QHe.fetchTraceGeoData(e)), Promise.all(s).then(function() {
                    i.fillBelowLookup(e, t), i.updateData(e), i.updateLayout(t), i.resolveOnRender(r);
                }).catch(n);
            };
            Sh.fillBelowLookup = function(e, t) {
                var r = t[this.id], n = r.layers, i, a, o = this.belowLookup = {}, s = !1;
                for(i = 0; i < e.length; i++){
                    var l = e[i][0].trace, u = l._module;
                    typeof l.below == "string" ? a = l.below : u.getBelow && (a = u.getBelow(l, this)), a === "" && (s = !0), o["trace-" + l.uid] = a || "";
                }
                for(i = 0; i < n.length; i++){
                    var c = n[i];
                    typeof c.below == "string" ? a = c.below : s ? a = "traces" : a = "", o["layout-" + i] = a;
                }
                var f = {}, h, d;
                for(h in o)a = o[h], f[a] ? f[a].push(h) : f[a] = [
                    h
                ];
                for(a in f){
                    var v = f[a];
                    if (v.length > 1) for(i = 0; i < v.length; i++)h = v[i], h.indexOf("trace-") === 0 ? (d = h.split("trace-")[1], this.traceHash[d] && (this.traceHash[d].below = null)) : h.indexOf("layout-") === 0 && (d = h.split("layout-")[1], this.layerList[d] && (this.layerList[d].below = null));
                }
            };
            var $He = {
                choroplethmap: 0,
                densitymap: 1,
                scattermap: 2
            };
            Sh.updateData = function(e) {
                var t = this.traceHash, r, n, i, a, o = e.slice().sort(function(f, h) {
                    return $He[f[0].trace.type] - $He[h[0].trace.type];
                });
                for(i = 0; i < o.length; i++){
                    var s = o[i];
                    n = s[0].trace, r = t[n.uid];
                    var l = !1;
                    r && (r.type === n.type ? (r.update(s), l = !0) : r.dispose()), !l && n._module && (t[n.uid] = n._module.plot(this, s));
                }
                var u = Object.keys(t);
                e: for(i = 0; i < u.length; i++){
                    var c = u[i];
                    for(a = 0; a < e.length; a++)if (n = e[a][0].trace, c === n.uid) continue e;
                    r = t[c], r.dispose(), delete t[c];
                }
            };
            Sh.updateLayout = function(e) {
                var t = this.map, r = e[this.id];
                !this.dragging && !this.wheeling && (t.setCenter(_J(r.center)), t.setZoom(r.zoom), t.setBearing(r.bearing), t.setPitch(r.pitch)), this.updateLayers(e), this.updateFramework(e), this.updateFx(e), this.map.resize(), this.gd._context._scrollZoom.map ? t.scrollZoom.enable() : t.scrollZoom.disable();
            };
            Sh.resolveOnRender = function(e) {
                var t = this.map;
                t.on("render", function r() {
                    t.loaded() && (t.off("render", r), setTimeout(e, 10));
                });
            };
            Sh.rejectOnError = function(e) {
                var t = this.map;
                function r() {
                    e(new Error(nw.mapOnErrorMsg));
                }
                t.once("error", r), t.once("style.error", r), t.once("source.error", r), t.once("tile.error", r), t.once("layer.error", r);
            };
            Sh.createFramework = function(e) {
                var t = this, r = t.div = document.createElement("div");
                r.id = t.uid, r.style.position = "absolute", t.container.appendChild(r), t.xaxis = {
                    _id: "x",
                    c2p: function(n) {
                        return t.project(n).x;
                    }
                }, t.yaxis = {
                    _id: "y",
                    c2p: function(n) {
                        return t.project(n).y;
                    }
                }, t.updateFramework(e), t.mockAxis = {
                    type: "linear",
                    showexponent: "all",
                    exponentformat: "B"
                }, _jt.setConvert(t.mockAxis, e);
            };
            Sh.initFx = function(e, t) {
                var r = this, n = r.gd, i = r.map;
                i.on("moveend", function(s) {
                    if (r.map) {
                        var l = n._fullLayout;
                        if (s.originalEvent || r.wheeling) {
                            var u = l[r.id];
                            JHe.call("_storeDirectGUIEdit", n.layout, l._preGUI, r.getViewEdits(u));
                            var c = r.getView();
                            u._input.center = u.center = c.center, u._input.zoom = u.zoom = c.zoom, u._input.bearing = u.bearing = c.bearing, u._input.pitch = u.pitch = c.pitch, n.emit("plotly_relayout", r.getViewEditsWithDerived(c));
                        }
                        s.originalEvent && s.originalEvent.type === "mouseup" ? r.dragging = !1 : r.wheeling && (r.wheeling = !1), l && l._rehover && l._rehover();
                    }
                }), i.on("wheel", function() {
                    r.wheeling = !0;
                }), i.on("mousemove", function(s) {
                    var l = r.div.getBoundingClientRect(), u = [
                        s.originalEvent.offsetX,
                        s.originalEvent.offsetY
                    ];
                    s.target.getBoundingClientRect = function() {
                        return l;
                    }, r.xaxis.p2c = function() {
                        return i.unproject(u).lng;
                    }, r.yaxis.p2c = function() {
                        return i.unproject(u).lat;
                    }, n._fullLayout._rehover = function() {
                        n._fullLayout._hoversubplot === r.id && n._fullLayout[r.id] && a7.hover(n, s, r.id);
                    }, a7.hover(n, s, r.id), n._fullLayout._hoversubplot = r.id;
                });
                function a() {
                    a7.loneUnhover(t._hoverlayer);
                }
                i.on("dragstart", function() {
                    r.dragging = !0, a();
                }), i.on("zoomstart", a), i.on("mouseout", function() {
                    n._fullLayout._hoversubplot = null;
                });
                function o() {
                    var s = r.getView();
                    n.emit("plotly_relayouting", r.getViewEditsWithDerived(s));
                }
                i.on("drag", o), i.on("zoom", o), i.on("dblclick", function() {
                    var s = n._fullLayout[r.id];
                    JHe.call("_storeDirectGUIEdit", n.layout, n._fullLayout._preGUI, r.getViewEdits(s));
                    var l = r.viewInitial;
                    i.setCenter(_J(l.center)), i.setZoom(l.zoom), i.setBearing(l.bearing), i.setPitch(l.pitch);
                    var u = r.getView();
                    s._input.center = s.center = u.center, s._input.zoom = s.zoom = u.zoom, s._input.bearing = s.bearing = u.bearing, s._input.pitch = s.pitch = u.pitch, n.emit("plotly_doubleclick", null), n.emit("plotly_relayout", r.getViewEditsWithDerived(u));
                }), r.clearOutline = function() {
                    Sjt(r.dragOptions), Ajt(r.dragOptions.gd);
                }, r.onClickInPanFn = function(s) {
                    return function(l) {
                        var u = n._fullLayout.clickmode;
                        u.indexOf("select") > -1 && Mjt(l.originalEvent, n, [
                            r.xaxis
                        ], [
                            r.yaxis
                        ], r.id, s), u.indexOf("event") > -1 && a7.click(n, l.originalEvent);
                    };
                };
            };
            Sh.updateFx = function(e) {
                var t = this, r = t.map, n = t.gd;
                if (t.isStatic) return;
                function i(l) {
                    var u = t.map.unproject(l);
                    return [
                        u.lng,
                        u.lat
                    ];
                }
                var a = e.dragmode, o;
                o = function(l, u) {
                    if (u.isRect) {
                        var c = l.range = {};
                        c[t.id] = [
                            i([
                                u.xmin,
                                u.ymin
                            ]),
                            i([
                                u.xmax,
                                u.ymax
                            ])
                        ];
                    } else {
                        var f = l.lassoPoints = {};
                        f[t.id] = u.map(i);
                    }
                };
                var s = t.dragOptions;
                t.dragOptions = yJ.extendDeep(s || {}, {
                    dragmode: e.dragmode,
                    element: t.div,
                    gd: n,
                    plotinfo: {
                        id: t.id,
                        domain: e[t.id].domain,
                        xaxis: t.xaxis,
                        yaxis: t.yaxis,
                        fillRangeItems: o
                    },
                    xaxes: [
                        t.xaxis
                    ],
                    yaxes: [
                        t.yaxis
                    ],
                    subplot: t.id
                }), r.off("click", t.onClickInPanHandler), wjt(a) || bjt(a) ? (r.dragPan.disable(), r.on("zoomstart", t.clearOutline), t.dragOptions.prepFn = function(l, u, c) {
                    Tjt(l, u, c, t.dragOptions, a);
                }, xjt.init(t.dragOptions)) : (r.dragPan.enable(), r.off("zoomstart", t.clearOutline), t.div.onmousedown = null, t.div.ontouchstart = null, t.div.removeEventListener("touchstart", t.div._ontouchstart), t.onClickInPanHandler = t.onClickInPanFn(t.dragOptions), r.on("click", t.onClickInPanHandler));
            };
            Sh.updateFramework = function(e) {
                var t = e[this.id].domain, r = e._size, n = this.div.style;
                n.width = r.w * (t.x[1] - t.x[0]) + "px", n.height = r.h * (t.y[1] - t.y[0]) + "px", n.left = r.l + t.x[0] * r.w + "px", n.top = r.t + (1 - t.y[1]) * r.h + "px", this.xaxis._offset = r.l + t.x[0] * r.w, this.xaxis._length = r.w * (t.x[1] - t.x[0]), this.yaxis._offset = r.t + (1 - t.y[1]) * r.h, this.yaxis._length = r.h * (t.y[1] - t.y[0]);
            };
            Sh.updateLayers = function(e) {
                var t = e[this.id], r = t.layers, n = this.layerList, i;
                if (r.length !== n.length) {
                    for(i = 0; i < n.length; i++)n[i].dispose();
                    for(n = this.layerList = [], i = 0; i < r.length; i++)n.push(Ejt(this, i, r[i]));
                } else for(i = 0; i < r.length; i++)n[i].update(r[i]);
            };
            Sh.destroy = function() {
                this.map && (this.map.remove(), this.map = null, this.container.removeChild(this.div));
            };
            Sh.toImage = function() {
                return this.map.stop(), this.map.getCanvas().toDataURL();
            };
            Sh.setOptions = function(e, t, r) {
                for(var n in r)this.map[t](e, n, r[n]);
            };
            Sh.getMapLayers = function() {
                return this.map.getStyle().layers;
            };
            Sh.addLayer = function(e, t) {
                var r = this.map;
                if (typeof t == "string") {
                    if (t === "") {
                        r.addLayer(e, t);
                        return;
                    }
                    for(var n = this.getMapLayers(), i = 0; i < n.length; i++)if (t === n[i].id) {
                        r.addLayer(e, t);
                        return;
                    }
                    yJ.warn([
                        "Trying to add layer with *below* value",
                        t,
                        "referencing a layer that does not exist",
                        "or that does not yet exist."
                    ].join(" "));
                }
                r.addLayer(e);
            };
            Sh.project = function(e) {
                return this.map.project(new mJ.LngLat(e[0], e[1]));
            };
            Sh.getView = function() {
                var e = this.map, t = e.getCenter(), r = t.lng, n = t.lat, i = {
                    lon: r,
                    lat: n
                }, a = e.getCanvas(), o = parseInt(a.style.width), s = parseInt(a.style.height);
                return {
                    center: i,
                    zoom: e.getZoom(),
                    bearing: e.getBearing(),
                    pitch: e.getPitch(),
                    _derived: {
                        coordinates: [
                            e.unproject([
                                0,
                                0
                            ]).toArray(),
                            e.unproject([
                                o,
                                0
                            ]).toArray(),
                            e.unproject([
                                o,
                                s
                            ]).toArray(),
                            e.unproject([
                                0,
                                s
                            ]).toArray()
                        ]
                    }
                };
            };
            Sh.getViewEdits = function(e) {
                for(var t = this.id, r = [
                    "center",
                    "zoom",
                    "bearing",
                    "pitch"
                ], n = {}, i = 0; i < r.length; i++){
                    var a = r[i];
                    n[t + "." + a] = e[a];
                }
                return n;
            };
            Sh.getViewEditsWithDerived = function(e) {
                var t = this.id, r = this.getViewEdits(e);
                return r[t + "._derived"] = e._derived, r;
            };
            function rGe(e) {
                var t = {};
                return yJ.isPlainObject(e) ? (t.id = e.id, t.style = e) : typeof e == "string" ? (t.id = e, nw.stylesMap[e] ? t.style = nw.stylesMap[e] : t.style = e) : (t.id = nw.styleValueDflt, t.style = kjt(nw.styleValueDflt)), t.transition = {
                    duration: 0,
                    delay: 0
                }, t;
            }
            function kjt(e) {
                return nw.styleUrlPrefix + e + "-" + nw.styleUrlSuffix;
            }
            function _J(e) {
                return [
                    e.lon,
                    e.lat
                ];
            }
            iGe.exports = tGe;
        });
        var sGe = ye((Y1r, oGe)=>{
            "use strict";
            var xJ = Mr(), Cjt = C_(), Ljt = Zd(), aGe = Ok();
            oGe.exports = function(t, r, n) {
                Cjt(t, r, n, {
                    type: "map",
                    attributes: aGe,
                    handleDefaults: Pjt,
                    partition: "y"
                });
            };
            function Pjt(e, t, r) {
                r("style"), r("center.lon"), r("center.lat"), r("zoom"), r("bearing"), r("pitch");
                var n = r("bounds.west"), i = r("bounds.east"), a = r("bounds.south"), o = r("bounds.north");
                (n === void 0 || i === void 0 || a === void 0 || o === void 0) && delete t.bounds, Ljt(e, t, {
                    name: "layers",
                    handleItemDefaults: Ijt
                }), t._input = e;
            }
            function Ijt(e, t) {
                function r(l, u) {
                    return xJ.coerce(e, t, aGe.layers, l, u);
                }
                var n = r("visible");
                if (n) {
                    var i = r("sourcetype"), a = i === "raster" || i === "image";
                    r("source"), r("sourceattribution"), i === "vector" && r("sourcelayer"), i === "image" && r("coordinates");
                    var o;
                    a && (o = "raster");
                    var s = r("type", o);
                    a && s !== "raster" && (s = t.type = "raster", xJ.log("Source types *raster* and *image* must drawn *raster* layer type.")), r("below"), r("color"), r("opacity"), r("minzoom"), r("maxzoom"), s === "circle" && r("circle.radius"), s === "line" && (r("line.width"), r("line.dash")), s === "fill" && r("fill.outlinecolor"), s === "symbol" && (r("symbol.icon"), r("symbol.iconsize"), r("symbol.text"), xJ.coerceFont(r, "symbol.textfont", void 0, {
                        noFontVariant: !0,
                        noFontShadow: !0,
                        noFontLineposition: !0,
                        noFontTextcase: !0
                    }), r("symbol.textposition"), r("symbol.placement"));
                }
            }
        });
        var s7 = ye((l0)=>{
            "use strict";
            var o7 = Mr(), lGe = o7.strTranslate, Rjt = o7.strScale, Djt = kd().getSubplotCalcData, zjt = Zp(), Fjt = xa(), uGe = ao(), qjt = Pl(), Ojt = nGe(), Tx = "map";
            l0.name = Tx;
            l0.attr = "subplot";
            l0.idRoot = Tx;
            l0.idRegex = l0.attrRegex = o7.counterRegex(Tx);
            l0.attributes = {
                subplot: {
                    valType: "subplotid",
                    dflt: "map",
                    editType: "calc"
                }
            };
            l0.layoutAttributes = Ok();
            l0.supplyLayoutDefaults = sGe();
            l0.plot = function(t) {
                for(var r = t._fullLayout, n = t.calcdata, i = r._subplots[Tx], a = 0; a < i.length; a++){
                    var o = i[a], s = Djt(n, Tx, o), l = r[o], u = l._subplot;
                    u || (u = new Ojt(t, o), r[o]._subplot = u), u.viewInitial || (u.viewInitial = {
                        center: o7.extendFlat({}, l.center),
                        zoom: l.zoom,
                        bearing: l.bearing,
                        pitch: l.pitch
                    }), u.plot(s, r, t._promises);
                }
            };
            l0.clean = function(e, t, r, n) {
                for(var i = n._subplots[Tx] || [], a = 0; a < i.length; a++){
                    var o = i[a];
                    !t[o] && n[o]._subplot && n[o]._subplot.destroy();
                }
            };
            l0.toSVG = function(e) {
                for(var t = e._fullLayout, r = t._subplots[Tx], n = t._size, i = 0; i < r.length; i++){
                    var a = t[r[i]], o = a.domain, s = a._subplot, l = s.toImage("png"), u = t._glimages.append("svg:image");
                    u.attr({
                        xmlns: zjt.svg,
                        "xlink:href": l,
                        x: n.l + n.w * o.x[0],
                        y: n.t + n.h * (1 - o.y[1]),
                        width: n.w * (o.x[1] - o.x[0]),
                        height: n.h * (o.y[1] - o.y[0]),
                        preserveAspectRatio: "none"
                    });
                    var c = Fjt.select(a._subplot.div), f = c.select(".maplibregl-ctrl-attrib").text().replace("Improve this map", ""), h = t._glimages.append("g"), d = h.append("text");
                    d.text(f).classed("static-attribution", !0).attr({
                        "font-size": 12,
                        "font-family": "Arial",
                        color: "rgba(0, 0, 0, 0.75)",
                        "text-anchor": "end",
                        "data-unformatted": f
                    });
                    var v = uGe.bBox(d.node()), x = n.w * (o.x[1] - o.x[0]);
                    if (v.width > x / 2) {
                        var b = f.split("|").join("<br>");
                        d.text(b).attr("data-unformatted", b).call(qjt.convertToTspans, e), v = uGe.bBox(d.node());
                    }
                    d.attr("transform", lGe(-3, -v.height + 8)), h.insert("rect", ".static-attribution").attr({
                        x: -v.width - 6,
                        y: -v.height - 3,
                        width: v.width + 6,
                        height: v.height + 3,
                        fill: "rgba(255, 255, 255, 0.75)"
                    });
                    var p = 1;
                    v.width + 6 > x && (p = x / (v.width + 6));
                    var E = [
                        n.l + n.w * o.x[1],
                        n.t + n.h * (1 - o.y[0])
                    ];
                    h.attr("transform", lGe(E[0], E[1]) + Rjt(p));
                }
            };
            l0.updateFx = function(e) {
                for(var t = e._fullLayout, r = t._subplots[Tx], n = 0; n < r.length; n++){
                    var i = t[r[n]]._subplot;
                    i.updateFx(t);
                }
            };
        });
        var fGe = ye((J1r, cGe)=>{
            "use strict";
            cGe.exports = {
                attributes: $F(),
                supplyDefaults: THe(),
                colorbar: Kd(),
                formatLabels: cJ(),
                calc: lz(),
                plot: qHe(),
                hoverPoints: i7().hoverPoints,
                eventData: UHe(),
                selectPoints: HHe(),
                styleOnSelect: function(e, t) {
                    if (t) {
                        var r = t[0].trace;
                        r._glTrace.update(t);
                    }
                },
                moduleType: "trace",
                name: "scattermap",
                basePlotModule: s7(),
                categories: [
                    "map",
                    "gl",
                    "symbols",
                    "showLegend",
                    "scatter-like"
                ],
                meta: {}
            };
        });
        var dGe = ye(($1r, hGe)=>{
            "use strict";
            hGe.exports = fGe();
        });
        var bJ = ye((Q1r, vGe)=>{
            "use strict";
            var d1 = K5(), Bjt = Jl(), Njt = Wo().hovertemplateAttrs, Ujt = vl(), Ax = no().extendFlat;
            vGe.exports = Ax({
                locations: {
                    valType: "data_array",
                    editType: "calc"
                },
                z: {
                    valType: "data_array",
                    editType: "calc"
                },
                geojson: {
                    valType: "any",
                    editType: "calc"
                },
                featureidkey: Ax({}, d1.featureidkey, {}),
                below: {
                    valType: "string",
                    editType: "plot"
                },
                text: d1.text,
                hovertext: d1.hovertext,
                marker: {
                    line: {
                        color: Ax({}, d1.marker.line.color, {
                            editType: "plot"
                        }),
                        width: Ax({}, d1.marker.line.width, {
                            editType: "plot"
                        }),
                        editType: "calc"
                    },
                    opacity: Ax({}, d1.marker.opacity, {
                        editType: "plot"
                    }),
                    editType: "calc"
                },
                selected: {
                    marker: {
                        opacity: Ax({}, d1.selected.marker.opacity, {
                            editType: "plot"
                        }),
                        editType: "plot"
                    },
                    editType: "plot"
                },
                unselected: {
                    marker: {
                        opacity: Ax({}, d1.unselected.marker.opacity, {
                            editType: "plot"
                        }),
                        editType: "plot"
                    },
                    editType: "plot"
                },
                hoverinfo: d1.hoverinfo,
                hovertemplate: Njt({}, {
                    keys: [
                        "properties"
                    ]
                }),
                showlegend: Ax({}, Ujt.showlegend, {
                    dflt: !1
                })
            }, Bjt("", {
                cLetter: "z",
                editTypeOverride: "calc"
            }));
        });
        var gGe = ye((e_r, pGe)=>{
            "use strict";
            var Vk = Mr(), Vjt = Uh(), Hjt = bJ();
            pGe.exports = function(t, r, n, i) {
                function a(c, f) {
                    return Vk.coerce(t, r, Hjt, c, f);
                }
                var o = a("locations"), s = a("z"), l = a("geojson");
                if (!Vk.isArrayOrTypedArray(o) || !o.length || !Vk.isArrayOrTypedArray(s) || !s.length || !(typeof l == "string" && l !== "" || Vk.isPlainObject(l))) {
                    r.visible = !1;
                    return;
                }
                a("featureidkey"), r._length = Math.min(o.length, s.length), a("below"), a("text"), a("hovertext"), a("hovertemplate");
                var u = a("marker.line.width");
                u && a("marker.line.color"), a("marker.opacity"), Vjt(t, r, i, a, {
                    prefix: "",
                    cLetter: "z"
                }), Vk.coerceSelectionMarkerOpacity(r, a);
            };
        });
        var wJ = ye((t_r, _Ge)=>{
            "use strict";
            var Gjt = uo(), v1 = Mr(), jjt = Mu(), Wjt = ao(), Zjt = rx().makeBlank, mGe = nx();
            function Xjt(e) {
                var t = e[0].trace, r = t.visible === !0 && t._length !== 0, n = {
                    layout: {
                        visibility: "none"
                    },
                    paint: {}
                }, i = {
                    layout: {
                        visibility: "none"
                    },
                    paint: {}
                }, a = t._opts = {
                    fill: n,
                    line: i,
                    geojson: Zjt()
                };
                if (!r) return a;
                var o = mGe.extractTraceFeature(e);
                if (!o) return a;
                var s = jjt.makeColorScaleFuncFromTrace(t), l = t.marker, u = l.line || {}, c;
                v1.isArrayOrTypedArray(l.opacity) && (c = function(E) {
                    var k = E.mo;
                    return Gjt(k) ? +v1.constrain(k, 0, 1) : 0;
                });
                var f;
                v1.isArrayOrTypedArray(u.color) && (f = function(E) {
                    return E.mlc;
                });
                var h;
                v1.isArrayOrTypedArray(u.width) && (h = function(E) {
                    return E.mlw;
                });
                for(var d = 0; d < e.length; d++){
                    var v = e[d], x = v.fOut;
                    if (x) {
                        var b = x.properties;
                        b.fc = s(v.z), c && (b.mo = c(v)), f && (b.mlc = f(v)), h && (b.mlw = h(v)), v.ct = b.ct, v._polygons = mGe.feature2polygons(x);
                    }
                }
                var p = c ? {
                    type: "identity",
                    property: "mo"
                } : l.opacity;
                return v1.extendFlat(n.paint, {
                    "fill-color": {
                        type: "identity",
                        property: "fc"
                    },
                    "fill-opacity": p
                }), v1.extendFlat(i.paint, {
                    "line-color": f ? {
                        type: "identity",
                        property: "mlc"
                    } : u.color,
                    "line-width": h ? {
                        type: "identity",
                        property: "mlw"
                    } : u.width,
                    "line-opacity": p
                }), n.layout.visibility = "visible", i.layout.visibility = "visible", a.geojson = {
                    type: "FeatureCollection",
                    features: o
                }, yGe(e), a;
            }
            function yGe(e) {
                var t = e[0].trace, r = t._opts, n;
                if (t.selectedpoints) {
                    for(var i = Wjt.makeSelectedPointStyleFns(t), a = 0; a < e.length; a++){
                        var o = e[a];
                        o.fOut && (o.fOut.properties.mo2 = i.selectedOpacityFn(o));
                    }
                    n = {
                        type: "identity",
                        property: "mo2"
                    };
                } else n = v1.isArrayOrTypedArray(t.marker.opacity) ? {
                    type: "identity",
                    property: "mo"
                } : t.marker.opacity;
                return v1.extendFlat(r.fill.paint, {
                    "fill-opacity": n
                }), v1.extendFlat(r.line.paint, {
                    "line-opacity": n
                }), r;
            }
            _Ge.exports = {
                convert: Xjt,
                convertOnSelect: yGe
            };
        });
        var AGe = ye((r_r, TGe)=>{
            "use strict";
            var bGe = wJ().convert, Yjt = wJ().convertOnSelect, xGe = wx().traceLayerPrefix;
            function wGe(e, t) {
                this.type = "choroplethmap", this.subplot = e, this.uid = t, this.sourceId = "source-" + t, this.layerList = [
                    [
                        "fill",
                        xGe + t + "-fill"
                    ],
                    [
                        "line",
                        xGe + t + "-line"
                    ]
                ], this.below = null;
            }
            var MA = wGe.prototype;
            MA.update = function(e) {
                this._update(bGe(e)), e[0].trace._glTrace = this;
            };
            MA.updateOnSelect = function(e) {
                this._update(Yjt(e));
            };
            MA._update = function(e) {
                var t = this.subplot, r = this.layerList, n = t.belowLookup["trace-" + this.uid];
                t.map.getSource(this.sourceId).setData(e.geojson), n !== this.below && (this._removeLayers(), this._addLayers(e, n), this.below = n);
                for(var i = 0; i < r.length; i++){
                    var a = r[i], o = a[0], s = a[1], l = e[o];
                    t.setOptions(s, "setLayoutProperty", l.layout), l.layout.visibility === "visible" && t.setOptions(s, "setPaintProperty", l.paint);
                }
            };
            MA._addLayers = function(e, t) {
                for(var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++){
                    var o = n[a], s = o[0], l = e[s];
                    r.addLayer({
                        type: s,
                        id: o[1],
                        source: i,
                        layout: l.layout,
                        paint: l.paint
                    }, t);
                }
            };
            MA._removeLayers = function() {
                for(var e = this.subplot.map, t = this.layerList, r = t.length - 1; r >= 0; r--)e.removeLayer(t[r][1]);
            };
            MA.dispose = function() {
                var e = this.subplot.map;
                this._removeLayers(), e.removeSource(this.sourceId);
            };
            TGe.exports = function(t, r) {
                var n = r[0].trace, i = new wGe(t, n.uid), a = i.sourceId, o = bGe(r), s = i.below = t.belowLookup["trace-" + n.uid];
                return t.map.addSource(a, {
                    type: "geojson",
                    data: o.geojson
                }), i._addLayers(o, s), r[0].trace._glTrace = i, i;
            };
        });
        var MGe = ye((i_r, SGe)=>{
            "use strict";
            SGe.exports = {
                attributes: bJ(),
                supplyDefaults: gGe(),
                colorbar: M_(),
                calc: Lz(),
                plot: AGe(),
                hoverPoints: Iz(),
                eventData: Rz(),
                selectPoints: Dz(),
                styleOnSelect: function(e, t) {
                    if (t) {
                        var r = t[0].trace;
                        r._glTrace.updateOnSelect(t);
                    }
                },
                getBelow: function(e, t) {
                    for(var r = t.getMapLayers(), n = r.length - 2; n >= 0; n--){
                        var i = r[n].id;
                        if (typeof i == "string" && i.indexOf("water") === 0) {
                            for(var a = n + 1; a < r.length; a++)if (i = r[a].id, typeof i == "string" && i.indexOf("plotly-") === -1) return i;
                        }
                    }
                },
                moduleType: "trace",
                name: "choroplethmap",
                basePlotModule: s7(),
                categories: [
                    "map",
                    "gl",
                    "noOpacity",
                    "showLegend"
                ],
                meta: {
                    hr_name: "choropleth_map"
                }
            };
        });
        var kGe = ye((n_r, EGe)=>{
            "use strict";
            EGe.exports = MGe();
        });
        var AJ = ye((a_r, LGe)=>{
            "use strict";
            var Kjt = Jl(), Jjt = Wo().hovertemplateAttrs, CGe = vl(), l7 = $F(), TJ = no().extendFlat;
            LGe.exports = TJ({
                lon: l7.lon,
                lat: l7.lat,
                z: {
                    valType: "data_array",
                    editType: "calc"
                },
                radius: {
                    valType: "number",
                    editType: "plot",
                    arrayOk: !0,
                    min: 1,
                    dflt: 30
                },
                below: {
                    valType: "string",
                    editType: "plot"
                },
                text: l7.text,
                hovertext: l7.hovertext,
                hoverinfo: TJ({}, CGe.hoverinfo, {
                    flags: [
                        "lon",
                        "lat",
                        "z",
                        "text",
                        "name"
                    ]
                }),
                hovertemplate: Jjt(),
                showlegend: TJ({}, CGe.showlegend, {
                    dflt: !1
                })
            }, Kjt("", {
                cLetter: "z",
                editTypeOverride: "calc"
            }));
        });
        var IGe = ye((o_r, PGe)=>{
            "use strict";
            var $jt = Mr(), Qjt = Uh(), eWt = AJ();
            PGe.exports = function(t, r, n, i) {
                function a(u, c) {
                    return $jt.coerce(t, r, eWt, u, c);
                }
                var o = a("lon") || [], s = a("lat") || [], l = Math.min(o.length, s.length);
                if (!l) {
                    r.visible = !1;
                    return;
                }
                r._length = l, a("z"), a("radius"), a("below"), a("text"), a("hovertext"), a("hovertemplate"), Qjt(t, r, i, a, {
                    prefix: "",
                    cLetter: "z"
                });
            };
        });
        var zGe = ye((s_r, DGe)=>{
            "use strict";
            var SJ = uo(), tWt = Mr().isArrayOrTypedArray, MJ = es().BADNUM, rWt = zv(), RGe = Mr()._;
            DGe.exports = function(t, r) {
                for(var n = r._length, i = new Array(n), a = r.z, o = tWt(a) && a.length, s = 0; s < n; s++){
                    var l = i[s] = {}, u = r.lon[s], c = r.lat[s];
                    if (l.lonlat = SJ(u) && SJ(c) ? [
                        +u,
                        +c
                    ] : [
                        MJ,
                        MJ
                    ], o) {
                        var f = a[s];
                        l.z = SJ(f) ? f : MJ;
                    }
                }
                return rWt(t, r, {
                    vals: o ? a : [
                        0,
                        1
                    ],
                    containerStr: "",
                    cLetter: "z"
                }), n && (i[0].t = {
                    labels: {
                        lat: RGe(t, "lat:") + " ",
                        lon: RGe(t, "lon:") + " "
                    }
                }), i;
            };
        });
        var NGe = ye((l_r, BGe)=>{
            "use strict";
            var iWt = uo(), EJ = Mr(), FGe = va(), qGe = Mu(), OGe = es().BADNUM, nWt = rx().makeBlank;
            BGe.exports = function(t) {
                var r = t[0].trace, n = r.visible === !0 && r._length !== 0, i = {
                    layout: {
                        visibility: "none"
                    },
                    paint: {}
                }, a = r._opts = {
                    heatmap: i,
                    geojson: nWt()
                };
                if (!n) return a;
                var o = [], s, l = r.z, u = r.radius, c = EJ.isArrayOrTypedArray(l) && l.length, f = EJ.isArrayOrTypedArray(u);
                for(s = 0; s < t.length; s++){
                    var h = t[s], d = h.lonlat;
                    if (d[0] !== OGe) {
                        var v = {};
                        if (c) {
                            var x = h.z;
                            v.z = x !== OGe ? x : 0;
                        }
                        f && (v.r = iWt(u[s]) && u[s] > 0 ? +u[s] : 0), o.push({
                            type: "Feature",
                            geometry: {
                                type: "Point",
                                coordinates: d
                            },
                            properties: v
                        });
                    }
                }
                var b = qGe.extractOpts(r), p = b.reversescale ? qGe.flipScale(b.colorscale) : b.colorscale, E = p[0][1], k = FGe.opacity(E) < 1 ? E : FGe.addOpacity(E, 0), A = [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "heatmap-density"
                    ],
                    0,
                    k
                ];
                for(s = 1; s < p.length; s++)A.push(p[s][0], p[s][1]);
                var L = [
                    "interpolate",
                    [
                        "linear"
                    ],
                    [
                        "get",
                        "z"
                    ],
                    b.min,
                    0,
                    b.max,
                    1
                ];
                return EJ.extendFlat(a.heatmap.paint, {
                    "heatmap-weight": c ? L : 1 / (b.max - b.min),
                    "heatmap-color": A,
                    "heatmap-radius": f ? {
                        type: "identity",
                        property: "r"
                    } : r.radius,
                    "heatmap-opacity": r.opacity
                }), a.geojson = {
                    type: "FeatureCollection",
                    features: o
                }, a.heatmap.layout.visibility = "visible", a;
            };
        });
        var GGe = ye((u_r, HGe)=>{
            "use strict";
            var UGe = NGe(), aWt = wx().traceLayerPrefix;
            function VGe(e, t) {
                this.type = "densitymap", this.subplot = e, this.uid = t, this.sourceId = "source-" + t, this.layerList = [
                    [
                        "heatmap",
                        aWt + t + "-heatmap"
                    ]
                ], this.below = null;
            }
            var u7 = VGe.prototype;
            u7.update = function(e) {
                var t = this.subplot, r = this.layerList, n = UGe(e), i = t.belowLookup["trace-" + this.uid];
                t.map.getSource(this.sourceId).setData(n.geojson), i !== this.below && (this._removeLayers(), this._addLayers(n, i), this.below = i);
                for(var a = 0; a < r.length; a++){
                    var o = r[a], s = o[0], l = o[1], u = n[s];
                    t.setOptions(l, "setLayoutProperty", u.layout), u.layout.visibility === "visible" && t.setOptions(l, "setPaintProperty", u.paint);
                }
            };
            u7._addLayers = function(e, t) {
                for(var r = this.subplot, n = this.layerList, i = this.sourceId, a = 0; a < n.length; a++){
                    var o = n[a], s = o[0], l = e[s];
                    r.addLayer({
                        type: s,
                        id: o[1],
                        source: i,
                        layout: l.layout,
                        paint: l.paint
                    }, t);
                }
            };
            u7._removeLayers = function() {
                for(var e = this.subplot.map, t = this.layerList, r = t.length - 1; r >= 0; r--)e.removeLayer(t[r][1]);
            };
            u7.dispose = function() {
                var e = this.subplot.map;
                this._removeLayers(), e.removeSource(this.sourceId);
            };
            HGe.exports = function(t, r) {
                var n = r[0].trace, i = new VGe(t, n.uid), a = i.sourceId, o = UGe(r), s = i.below = t.belowLookup["trace-" + n.uid];
                return t.map.addSource(a, {
                    type: "geojson",
                    data: o.geojson
                }), i._addLayers(o, s), i;
            };
        });
        var WGe = ye((c_r, jGe)=>{
            "use strict";
            var oWt = Qa(), sWt = i7().hoverPoints, lWt = i7().getExtraText;
            jGe.exports = function(t, r, n) {
                var i = sWt(t, r, n);
                if (i) {
                    var a = i[0], o = a.cd, s = o[0].trace, l = o[a.index];
                    if (delete a.color, "z" in l) {
                        var u = a.subplot.mockAxis;
                        a.z = l.z, a.zLabel = oWt.tickText(u, u.c2l(l.z), "hover").text;
                    }
                    return a.extraText = lWt(s, l, o[0].t.labels), [
                        a
                    ];
                }
            };
        });
        var XGe = ye((f_r, ZGe)=>{
            "use strict";
            ZGe.exports = function(t, r) {
                return t.lon = r.lon, t.lat = r.lat, t.z = r.z, t;
            };
        });
        var KGe = ye((h_r, YGe)=>{
            "use strict";
            YGe.exports = {
                attributes: AJ(),
                supplyDefaults: IGe(),
                colorbar: M_(),
                formatLabels: cJ(),
                calc: zGe(),
                plot: GGe(),
                hoverPoints: WGe(),
                eventData: XGe(),
                getBelow: function(e, t) {
                    for(var r = t.getMapLayers(), n = 0; n < r.length; n++){
                        var i = r[n], a = i.id;
                        if (i.type === "symbol" && typeof a == "string" && a.indexOf("plotly-") === -1) return a;
                    }
                },
                moduleType: "trace",
                name: "densitymap",
                basePlotModule: s7(),
                categories: [
                    "map",
                    "gl",
                    "showLegend"
                ],
                meta: {
                    hr_name: "density_map"
                }
            };
        });
        var $Ge = ye((d_r, JGe)=>{
            "use strict";
            JGe.exports = KGe();
        });
        var CJ = ye((p_r, rje)=>{
            "use strict";
            var uWt = Su(), cWt = vl(), QGe = dh(), kJ = i3(), fWt = Ju().attributes, eje = Wo().hovertemplateAttrs, hWt = Jl(), dWt = Vs().templatedArray, vWt = Oc().descriptionOnlyNumbers, tje = no().extendFlat, pWt = Bu().overrideAll, v_r = rje.exports = pWt({
                hoverinfo: tje({}, cWt.hoverinfo, {
                    flags: [],
                    arrayOk: !1
                }),
                hoverlabel: kJ.hoverlabel,
                domain: fWt({
                    name: "sankey",
                    trace: !0
                }),
                orientation: {
                    valType: "enumerated",
                    values: [
                        "v",
                        "h"
                    ],
                    dflt: "h"
                },
                valueformat: {
                    valType: "string",
                    dflt: ".3s",
                    description: vWt("value")
                },
                valuesuffix: {
                    valType: "string",
                    dflt: ""
                },
                arrangement: {
                    valType: "enumerated",
                    values: [
                        "snap",
                        "perpendicular",
                        "freeform",
                        "fixed"
                    ],
                    dflt: "snap"
                },
                textfont: uWt({
                    autoShadowDflt: !0
                }),
                customdata: void 0,
                node: {
                    label: {
                        valType: "data_array",
                        dflt: []
                    },
                    groups: {
                        valType: "info_array",
                        impliedEdits: {
                            x: [],
                            y: []
                        },
                        dimensions: 2,
                        freeLength: !0,
                        dflt: [],
                        items: {
                            valType: "number",
                            editType: "calc"
                        }
                    },
                    x: {
                        valType: "data_array",
                        dflt: []
                    },
                    y: {
                        valType: "data_array",
                        dflt: []
                    },
                    color: {
                        valType: "color",
                        arrayOk: !0
                    },
                    customdata: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    line: {
                        color: {
                            valType: "color",
                            dflt: QGe.defaultLine,
                            arrayOk: !0
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: .5,
                            arrayOk: !0
                        }
                    },
                    pad: {
                        valType: "number",
                        arrayOk: !1,
                        min: 0,
                        dflt: 20
                    },
                    thickness: {
                        valType: "number",
                        arrayOk: !1,
                        min: 1,
                        dflt: 20
                    },
                    hoverinfo: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "none",
                            "skip"
                        ],
                        dflt: "all"
                    },
                    hoverlabel: kJ.hoverlabel,
                    hovertemplate: eje({}, {
                        keys: [
                            "value",
                            "label"
                        ]
                    }),
                    align: {
                        valType: "enumerated",
                        values: [
                            "justify",
                            "left",
                            "right",
                            "center"
                        ],
                        dflt: "justify"
                    }
                },
                link: {
                    arrowlen: {
                        valType: "number",
                        min: 0,
                        dflt: 0
                    },
                    label: {
                        valType: "data_array",
                        dflt: []
                    },
                    color: {
                        valType: "color",
                        arrayOk: !0
                    },
                    hovercolor: {
                        valType: "color",
                        arrayOk: !0
                    },
                    customdata: {
                        valType: "data_array",
                        editType: "calc"
                    },
                    line: {
                        color: {
                            valType: "color",
                            dflt: QGe.defaultLine,
                            arrayOk: !0
                        },
                        width: {
                            valType: "number",
                            min: 0,
                            dflt: 0,
                            arrayOk: !0
                        }
                    },
                    source: {
                        valType: "data_array",
                        dflt: []
                    },
                    target: {
                        valType: "data_array",
                        dflt: []
                    },
                    value: {
                        valType: "data_array",
                        dflt: []
                    },
                    hoverinfo: {
                        valType: "enumerated",
                        values: [
                            "all",
                            "none",
                            "skip"
                        ],
                        dflt: "all"
                    },
                    hoverlabel: kJ.hoverlabel,
                    hovertemplate: eje({}, {
                        keys: [
                            "value",
                            "label"
                        ]
                    }),
                    colorscales: dWt("concentrationscales", {
                        editType: "calc",
                        label: {
                            valType: "string",
                            editType: "calc",
                            dflt: ""
                        },
                        cmax: {
                            valType: "number",
                            editType: "calc",
                            dflt: 1
                        },
                        cmin: {
                            valType: "number",
                            editType: "calc",
                            dflt: 0
                        },
                        colorscale: tje(hWt().colorscale, {
                            dflt: [
                                [
                                    0,
                                    "white"
                                ],
                                [
                                    1,
                                    "black"
                                ]
                            ]
                        })
                    })
                }
            }, "calc", "nested");
        });
        var sje = ye((g_r, oje)=>{
            "use strict";
            var EA = Mr(), c7 = CJ(), gWt = va(), ije = id(), mWt = Ju().defaults, nje = oM(), aje = Vs(), yWt = Zd();
            oje.exports = function(t, r, n, i) {
                function a(A, L) {
                    return EA.coerce(t, r, c7, A, L);
                }
                var o = EA.extendDeep(i.hoverlabel, t.hoverlabel), s = t.node, l = aje.newContainer(r, "node");
                function u(A, L) {
                    return EA.coerce(s, l, c7.node, A, L);
                }
                u("label"), u("groups"), u("x"), u("y"), u("pad"), u("thickness"), u("line.color"), u("line.width"), u("hoverinfo", t.hoverinfo), nje(s, l, u, o), u("hovertemplate"), u("align");
                var c = i.colorway, f = function(A) {
                    return c[A % c.length];
                };
                u("color", l.label.map(function(A, L) {
                    return gWt.addOpacity(f(L), .8);
                })), u("customdata");
                var h = t.link || {}, d = aje.newContainer(r, "link");
                function v(A, L) {
                    return EA.coerce(h, d, c7.link, A, L);
                }
                v("label"), v("arrowlen"), v("source"), v("target"), v("value"), v("line.color"), v("line.width"), v("hoverinfo", t.hoverinfo), nje(h, d, v, o), v("hovertemplate");
                var x = ije(i.paper_bgcolor).getLuminance() < .333, b = x ? "rgba(255, 255, 255, 0.6)" : "rgba(0, 0, 0, 0.2)", p = v("color", b);
                function E(A) {
                    var L = ije(A);
                    if (!L.isValid()) return A;
                    var _ = L.getAlpha();
                    return _ <= .8 ? L.setAlpha(_ + .2) : L = x ? L.brighten() : L.darken(), L.toRgbString();
                }
                v("hovercolor", Array.isArray(p) ? p.map(E) : E(p)), v("customdata"), yWt(h, d, {
                    name: "colorscales",
                    handleItemDefaults: _Wt
                }), mWt(r, i, a), a("orientation"), a("valueformat"), a("valuesuffix");
                var k;
                l.x.length && l.y.length && (k = "freeform"), a("arrangement", k), EA.coerceFont(a, "textfont", i.font, {
                    autoShadowDflt: !0
                }), r._length = null;
            };
            function _Wt(e, t) {
                function r(n, i) {
                    return EA.coerce(e, t, c7.link.colorscales, n, i);
                }
                r("label"), r("cmin"), r("cmax"), r("colorscale");
            }
        });
        var LJ = ye((m_r, lje)=>{
            "use strict";
            lje.exports = xWt;
            function xWt(e) {
                for(var t = e.length, r = new Array(t), n = new Array(t), i = new Array(t), a = new Array(t), o = new Array(t), s = new Array(t), l = 0; l < t; ++l)r[l] = -1, n[l] = 0, i[l] = !1, a[l] = 0, o[l] = -1, s[l] = [];
                var u = 0, c = [], f = [];
                function h(b) {
                    var p = [
                        b
                    ], E = [
                        b
                    ];
                    for(r[b] = n[b] = u, i[b] = !0, u += 1; E.length > 0;){
                        b = E[E.length - 1];
                        var k = e[b];
                        if (a[b] < k.length) {
                            for(var A = a[b]; A < k.length; ++A){
                                var L = k[A];
                                if (r[L] < 0) {
                                    r[L] = n[L] = u, i[L] = !0, u += 1, p.push(L), E.push(L);
                                    break;
                                } else i[L] && (n[b] = Math.min(n[b], n[L]) | 0);
                                o[L] >= 0 && s[b].push(o[L]);
                            }
                            a[b] = A;
                        } else {
                            if (n[b] === r[b]) {
                                for(var _ = [], C = [], M = 0, A = p.length - 1; A >= 0; --A){
                                    var g = p[A];
                                    if (i[g] = !1, _.push(g), C.push(s[g]), M += s[g].length, o[g] = c.length, g === b) {
                                        p.length = A;
                                        break;
                                    }
                                }
                                c.push(_);
                                for(var P = new Array(M), A = 0; A < C.length; A++)for(var T = 0; T < C[A].length; T++)P[--M] = C[A][T];
                                f.push(P);
                            }
                            E.pop();
                        }
                    }
                }
                for(var l = 0; l < t; ++l)r[l] < 0 && h(l);
                for(var d, l = 0; l < f.length; l++){
                    var v = f[l];
                    if (v.length !== 0) {
                        v.sort(function(p, E) {
                            return p - E;
                        }), d = [
                            v[0]
                        ];
                        for(var x = 1; x < v.length; x++)v[x] !== v[x - 1] && d.push(v[x]);
                        f[l] = d;
                    }
                }
                return {
                    components: c,
                    adjacencyList: f
                };
            }
        });
        var hje = ye((y_r, fje)=>{
            "use strict";
            var bWt = LJ(), kA = Mr(), wWt = Km().wrap, Hk = kA.isArrayOrTypedArray, uje = kA.isIndex, cje = Mu();
            function TWt(e) {
                var t = e.node, r = e.link, n = [], i = Hk(r.color), a = Hk(r.hovercolor), o = Hk(r.customdata), s = {}, l = {}, u = r.colorscales.length, c;
                for(c = 0; c < u; c++){
                    var f = r.colorscales[c], h = cje.extractScale(f, {
                        cLetter: "c"
                    }), d = cje.makeColorScaleFunc(h);
                    l[f.label] = d;
                }
                var v = 0;
                for(c = 0; c < r.value.length; c++)r.source[c] > v && (v = r.source[c]), r.target[c] > v && (v = r.target[c]);
                var x = v + 1;
                e.node._count = x;
                var b, p = e.node.groups, E = {};
                for(c = 0; c < p.length; c++){
                    var k = p[c];
                    for(b = 0; b < k.length; b++){
                        var A = k[b], L = x + c;
                        E.hasOwnProperty(A) ? kA.warn("Node " + A + " is already part of a group.") : E[A] = L;
                    }
                }
                var _ = {
                    source: [],
                    target: []
                };
                for(c = 0; c < r.value.length; c++){
                    var C = r.value[c], M = r.source[c], g = r.target[c];
                    if (C > 0 && uje(M, x) && uje(g, x) && !(E.hasOwnProperty(M) && E.hasOwnProperty(g) && E[M] === E[g])) {
                        E.hasOwnProperty(g) && (g = E[g]), E.hasOwnProperty(M) && (M = E[M]), M = +M, g = +g, s[M] = s[g] = !0;
                        var P = "";
                        r.label && r.label[c] && (P = r.label[c]);
                        var T = null;
                        P && l.hasOwnProperty(P) && (T = l[P]), n.push({
                            pointNumber: c,
                            label: P,
                            color: i ? r.color[c] : r.color,
                            hovercolor: a ? r.hovercolor[c] : r.hovercolor,
                            customdata: o ? r.customdata[c] : r.customdata,
                            concentrationscale: T,
                            source: M,
                            target: g,
                            value: +C
                        }), _.source.push(M), _.target.push(g);
                    }
                }
                var F = x + p.length, q = Hk(t.color), V = Hk(t.customdata), H = [];
                for(c = 0; c < F; c++)if (s[c]) {
                    var X = t.label[c];
                    H.push({
                        group: c > x - 1,
                        childrenNodes: [],
                        pointNumber: c,
                        label: X,
                        color: q ? t.color[c] : t.color,
                        customdata: V ? t.customdata[c] : t.customdata
                    });
                }
                var G = !1;
                return AWt(F, _.source, _.target) && (G = !0), {
                    circular: G,
                    links: n,
                    nodes: H,
                    groups: p,
                    groupLookup: E
                };
            }
            function AWt(e, t, r) {
                for(var n = kA.init2dArray(e, 0), i = 0; i < Math.min(t.length, r.length); i++)if (kA.isIndex(t[i], e) && kA.isIndex(r[i], e)) {
                    if (t[i] === r[i]) return !0;
                    n[t[i]].push(r[i]);
                }
                var a = bWt(n);
                return a.components.some(function(o) {
                    return o.length > 1;
                });
            }
            fje.exports = function(t, r) {
                var n = TWt(r);
                return wWt({
                    circular: n.circular,
                    _nodes: n.nodes,
                    _links: n.links,
                    _groups: n.groups,
                    _groupLookup: n.groupLookup
                });
            };
        });
        var vje = ye((f7, dje)=>{
            (function(e, t) {
                typeof f7 == "object" && typeof dje != "undefined" ? t(f7) : (e = e || self, t(e.d3 = e.d3 || {}));
            })(f7, function(e) {
                "use strict";
                function t(C) {
                    var M = +this._x.call(null, C), g = +this._y.call(null, C);
                    return r(this.cover(M, g), M, g, C);
                }
                function r(C, M, g, P) {
                    if (isNaN(M) || isNaN(g)) return C;
                    var T, F = C._root, q = {
                        data: P
                    }, V = C._x0, H = C._y0, X = C._x1, G = C._y1, N, W, re, ae, _e, Me, ke, ge;
                    if (!F) return C._root = q, C;
                    for(; F.length;)if ((_e = M >= (N = (V + X) / 2)) ? V = N : X = N, (Me = g >= (W = (H + G) / 2)) ? H = W : G = W, T = F, !(F = F[ke = Me << 1 | _e])) return T[ke] = q, C;
                    if (re = +C._x.call(null, F.data), ae = +C._y.call(null, F.data), M === re && g === ae) return q.next = F, T ? T[ke] = q : C._root = q, C;
                    do T = T ? T[ke] = new Array(4) : C._root = new Array(4), (_e = M >= (N = (V + X) / 2)) ? V = N : X = N, (Me = g >= (W = (H + G) / 2)) ? H = W : G = W;
                    while ((ke = Me << 1 | _e) === (ge = (ae >= W) << 1 | re >= N));
                    return T[ge] = F, T[ke] = q, C;
                }
                function n(C) {
                    var M, g, P = C.length, T, F, q = new Array(P), V = new Array(P), H = 1 / 0, X = 1 / 0, G = -1 / 0, N = -1 / 0;
                    for(g = 0; g < P; ++g)isNaN(T = +this._x.call(null, M = C[g])) || isNaN(F = +this._y.call(null, M)) || (q[g] = T, V[g] = F, T < H && (H = T), T > G && (G = T), F < X && (X = F), F > N && (N = F));
                    if (H > G || X > N) return this;
                    for(this.cover(H, X).cover(G, N), g = 0; g < P; ++g)r(this, q[g], V[g], C[g]);
                    return this;
                }
                function i(C, M) {
                    if (isNaN(C = +C) || isNaN(M = +M)) return this;
                    var g = this._x0, P = this._y0, T = this._x1, F = this._y1;
                    if (isNaN(g)) T = (g = Math.floor(C)) + 1, F = (P = Math.floor(M)) + 1;
                    else {
                        for(var q = T - g, V = this._root, H, X; g > C || C >= T || P > M || M >= F;)switch(X = (M < P) << 1 | C < g, H = new Array(4), H[X] = V, V = H, q *= 2, X){
                            case 0:
                                T = g + q, F = P + q;
                                break;
                            case 1:
                                g = T - q, F = P + q;
                                break;
                            case 2:
                                T = g + q, P = F - q;
                                break;
                            case 3:
                                g = T - q, P = F - q;
                                break;
                        }
                        this._root && this._root.length && (this._root = V);
                    }
                    return this._x0 = g, this._y0 = P, this._x1 = T, this._y1 = F, this;
                }
                function a() {
                    var C = [];
                    return this.visit(function(M) {
                        if (!M.length) do C.push(M.data);
                        while (M = M.next);
                    }), C;
                }
                function o(C) {
                    return arguments.length ? this.cover(+C[0][0], +C[0][1]).cover(+C[1][0], +C[1][1]) : isNaN(this._x0) ? void 0 : [
                        [
                            this._x0,
                            this._y0
                        ],
                        [
                            this._x1,
                            this._y1
                        ]
                    ];
                }
                function s(C, M, g, P, T) {
                    this.node = C, this.x0 = M, this.y0 = g, this.x1 = P, this.y1 = T;
                }
                function l(C, M, g) {
                    var P, T = this._x0, F = this._y0, q, V, H, X, G = this._x1, N = this._y1, W = [], re = this._root, ae, _e;
                    for(re && W.push(new s(re, T, F, G, N)), g == null ? g = 1 / 0 : (T = C - g, F = M - g, G = C + g, N = M + g, g *= g); ae = W.pop();)if (!(!(re = ae.node) || (q = ae.x0) > G || (V = ae.y0) > N || (H = ae.x1) < T || (X = ae.y1) < F)) {
                        if (re.length) {
                            var Me = (q + H) / 2, ke = (V + X) / 2;
                            W.push(new s(re[3], Me, ke, H, X), new s(re[2], q, ke, Me, X), new s(re[1], Me, V, H, ke), new s(re[0], q, V, Me, ke)), (_e = (M >= ke) << 1 | C >= Me) && (ae = W[W.length - 1], W[W.length - 1] = W[W.length - 1 - _e], W[W.length - 1 - _e] = ae);
                        } else {
                            var ge = C - +this._x.call(null, re.data), ie = M - +this._y.call(null, re.data), Te = ge * ge + ie * ie;
                            if (Te < g) {
                                var Ee = Math.sqrt(g = Te);
                                T = C - Ee, F = M - Ee, G = C + Ee, N = M + Ee, P = re.data;
                            }
                        }
                    }
                    return P;
                }
                function u(C) {
                    if (isNaN(G = +this._x.call(null, C)) || isNaN(N = +this._y.call(null, C))) return this;
                    var M, g = this._root, P, T, F, q = this._x0, V = this._y0, H = this._x1, X = this._y1, G, N, W, re, ae, _e, Me, ke;
                    if (!g) return this;
                    if (g.length) for(;;){
                        if ((ae = G >= (W = (q + H) / 2)) ? q = W : H = W, (_e = N >= (re = (V + X) / 2)) ? V = re : X = re, M = g, !(g = g[Me = _e << 1 | ae])) return this;
                        if (!g.length) break;
                        (M[Me + 1 & 3] || M[Me + 2 & 3] || M[Me + 3 & 3]) && (P = M, ke = Me);
                    }
                    for(; g.data !== C;)if (T = g, !(g = g.next)) return this;
                    return (F = g.next) && delete g.next, T ? (F ? T.next = F : delete T.next, this) : M ? (F ? M[Me] = F : delete M[Me], (g = M[0] || M[1] || M[2] || M[3]) && g === (M[3] || M[2] || M[1] || M[0]) && !g.length && (P ? P[ke] = g : this._root = g), this) : (this._root = F, this);
                }
                function c(C) {
                    for(var M = 0, g = C.length; M < g; ++M)this.remove(C[M]);
                    return this;
                }
                function f() {
                    return this._root;
                }
                function h() {
                    var C = 0;
                    return this.visit(function(M) {
                        if (!M.length) do ++C;
                        while (M = M.next);
                    }), C;
                }
                function d(C) {
                    var M = [], g, P = this._root, T, F, q, V, H;
                    for(P && M.push(new s(P, this._x0, this._y0, this._x1, this._y1)); g = M.pop();)if (!C(P = g.node, F = g.x0, q = g.y0, V = g.x1, H = g.y1) && P.length) {
                        var X = (F + V) / 2, G = (q + H) / 2;
                        (T = P[3]) && M.push(new s(T, X, G, V, H)), (T = P[2]) && M.push(new s(T, F, G, X, H)), (T = P[1]) && M.push(new s(T, X, q, V, G)), (T = P[0]) && M.push(new s(T, F, q, X, G));
                    }
                    return this;
                }
                function v(C) {
                    var M = [], g = [], P;
                    for(this._root && M.push(new s(this._root, this._x0, this._y0, this._x1, this._y1)); P = M.pop();){
                        var T = P.node;
                        if (T.length) {
                            var F, q = P.x0, V = P.y0, H = P.x1, X = P.y1, G = (q + H) / 2, N = (V + X) / 2;
                            (F = T[0]) && M.push(new s(F, q, V, G, N)), (F = T[1]) && M.push(new s(F, G, V, H, N)), (F = T[2]) && M.push(new s(F, q, N, G, X)), (F = T[3]) && M.push(new s(F, G, N, H, X));
                        }
                        g.push(P);
                    }
                    for(; P = g.pop();)C(P.node, P.x0, P.y0, P.x1, P.y1);
                    return this;
                }
                function x(C) {
                    return C[0];
                }
                function b(C) {
                    return arguments.length ? (this._x = C, this) : this._x;
                }
                function p(C) {
                    return C[1];
                }
                function E(C) {
                    return arguments.length ? (this._y = C, this) : this._y;
                }
                function k(C, M, g) {
                    var P = new A(M == null ? x : M, g == null ? p : g, NaN, NaN, NaN, NaN);
                    return C == null ? P : P.addAll(C);
                }
                function A(C, M, g, P, T, F) {
                    this._x = C, this._y = M, this._x0 = g, this._y0 = P, this._x1 = T, this._y1 = F, this._root = void 0;
                }
                function L(C) {
                    for(var M = {
                        data: C.data
                    }, g = M; C = C.next;)g = g.next = {
                        data: C.data
                    };
                    return M;
                }
                var _ = k.prototype = A.prototype;
                _.copy = function() {
                    var C = new A(this._x, this._y, this._x0, this._y0, this._x1, this._y1), M = this._root, g, P;
                    if (!M) return C;
                    if (!M.length) return C._root = L(M), C;
                    for(g = [
                        {
                            source: M,
                            target: C._root = new Array(4)
                        }
                    ]; M = g.pop();)for(var T = 0; T < 4; ++T)(P = M.source[T]) && (P.length ? g.push({
                        source: P,
                        target: M.target[T] = new Array(4)
                    }) : M.target[T] = L(P));
                    return C;
                }, _.add = t, _.addAll = n, _.cover = i, _.data = a, _.extent = o, _.find = l, _.remove = u, _.removeAll = c, _.root = f, _.size = h, _.visit = d, _.visitAfter = v, _.x = b, _.y = E, e.quadtree = k, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var d7 = ye((h7, pje)=>{
            (function(e, t) {
                t(typeof h7 == "object" && typeof pje != "undefined" ? h7 : e.d3 = e.d3 || {});
            })(h7, function(e) {
                "use strict";
                var t = "$";
                function r() {}
                r.prototype = n.prototype = {
                    constructor: r,
                    has: function(x) {
                        return t + x in this;
                    },
                    get: function(x) {
                        return this[t + x];
                    },
                    set: function(x, b) {
                        return this[t + x] = b, this;
                    },
                    remove: function(x) {
                        var b = t + x;
                        return b in this && delete this[b];
                    },
                    clear: function() {
                        for(var x in this)x[0] === t && delete this[x];
                    },
                    keys: function() {
                        var x = [];
                        for(var b in this)b[0] === t && x.push(b.slice(1));
                        return x;
                    },
                    values: function() {
                        var x = [];
                        for(var b in this)b[0] === t && x.push(this[b]);
                        return x;
                    },
                    entries: function() {
                        var x = [];
                        for(var b in this)b[0] === t && x.push({
                            key: b.slice(1),
                            value: this[b]
                        });
                        return x;
                    },
                    size: function() {
                        var x = 0;
                        for(var b in this)b[0] === t && ++x;
                        return x;
                    },
                    empty: function() {
                        for(var x in this)if (x[0] === t) return !1;
                        return !0;
                    },
                    each: function(x) {
                        for(var b in this)b[0] === t && x(this[b], b.slice(1), this);
                    }
                };
                function n(x, b) {
                    var p = new r;
                    if (x instanceof r) x.each(function(_, C) {
                        p.set(C, _);
                    });
                    else if (Array.isArray(x)) {
                        var E = -1, k = x.length, A;
                        if (b == null) for(; ++E < k;)p.set(E, x[E]);
                        else for(; ++E < k;)p.set(b(A = x[E], E, x), A);
                    } else if (x) for(var L in x)p.set(L, x[L]);
                    return p;
                }
                function i() {
                    var x = [], b = [], p, E, k;
                    function A(_, C, M, g) {
                        if (C >= x.length) return p != null && _.sort(p), E != null ? E(_) : _;
                        for(var P = -1, T = _.length, F = x[C++], q, V, H = n(), X, G = M(); ++P < T;)(X = H.get(q = F(V = _[P]) + "")) ? X.push(V) : H.set(q, [
                            V
                        ]);
                        return H.each(function(N, W) {
                            g(G, W, A(N, C, M, g));
                        }), G;
                    }
                    function L(_, C) {
                        if (++C > x.length) return _;
                        var M, g = b[C - 1];
                        return E != null && C >= x.length ? M = _.entries() : (M = [], _.each(function(P, T) {
                            M.push({
                                key: T,
                                values: L(P, C)
                            });
                        })), g != null ? M.sort(function(P, T) {
                            return g(P.key, T.key);
                        }) : M;
                    }
                    return k = {
                        object: function(_) {
                            return A(_, 0, a, o);
                        },
                        map: function(_) {
                            return A(_, 0, s, l);
                        },
                        entries: function(_) {
                            return L(A(_, 0, s, l), 0);
                        },
                        key: function(_) {
                            return x.push(_), k;
                        },
                        sortKeys: function(_) {
                            return b[x.length - 1] = _, k;
                        },
                        sortValues: function(_) {
                            return p = _, k;
                        },
                        rollup: function(_) {
                            return E = _, k;
                        }
                    };
                }
                function a() {
                    return {};
                }
                function o(x, b, p) {
                    x[b] = p;
                }
                function s() {
                    return n();
                }
                function l(x, b, p) {
                    x.set(b, p);
                }
                function u() {}
                var c = n.prototype;
                u.prototype = f.prototype = {
                    constructor: u,
                    has: c.has,
                    add: function(x) {
                        return x += "", this[t + x] = x, this;
                    },
                    remove: c.remove,
                    clear: c.clear,
                    values: c.keys,
                    size: c.size,
                    empty: c.empty,
                    each: c.each
                };
                function f(x, b) {
                    var p = new u;
                    if (x instanceof u) x.each(function(A) {
                        p.add(A);
                    });
                    else if (x) {
                        var E = -1, k = x.length;
                        if (b == null) for(; ++E < k;)p.add(x[E]);
                        else for(; ++E < k;)p.add(b(x[E], E, x));
                    }
                    return p;
                }
                function h(x) {
                    var b = [];
                    for(var p in x)b.push(p);
                    return b;
                }
                function d(x) {
                    var b = [];
                    for(var p in x)b.push(x[p]);
                    return b;
                }
                function v(x) {
                    var b = [];
                    for(var p in x)b.push({
                        key: p,
                        value: x[p]
                    });
                    return b;
                }
                e.nest = i, e.set = f, e.map = n, e.keys = h, e.values = d, e.entries = v, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var mje = ye((v7, gje)=>{
            (function(e, t) {
                typeof v7 == "object" && typeof gje != "undefined" ? t(v7) : (e = e || self, t(e.d3 = e.d3 || {}));
            })(v7, function(e) {
                "use strict";
                var t = {
                    value: function() {}
                };
                function r() {
                    for(var s = 0, l = arguments.length, u = {}, c; s < l; ++s){
                        if (!(c = arguments[s] + "") || c in u || /[\s.]/.test(c)) throw new Error("illegal type: " + c);
                        u[c] = [];
                    }
                    return new n(u);
                }
                function n(s) {
                    this._ = s;
                }
                function i(s, l) {
                    return s.trim().split(/^|\s+/).map(function(u) {
                        var c = "", f = u.indexOf(".");
                        if (f >= 0 && (c = u.slice(f + 1), u = u.slice(0, f)), u && !l.hasOwnProperty(u)) throw new Error("unknown type: " + u);
                        return {
                            type: u,
                            name: c
                        };
                    });
                }
                n.prototype = r.prototype = {
                    constructor: n,
                    on: function(s, l) {
                        var u = this._, c = i(s + "", u), f, h = -1, d = c.length;
                        if (arguments.length < 2) {
                            for(; ++h < d;)if ((f = (s = c[h]).type) && (f = a(u[f], s.name))) return f;
                            return;
                        }
                        if (l != null && typeof l != "function") throw new Error("invalid callback: " + l);
                        for(; ++h < d;)if (f = (s = c[h]).type) u[f] = o(u[f], s.name, l);
                        else if (l == null) for(f in u)u[f] = o(u[f], s.name, null);
                        return this;
                    },
                    copy: function() {
                        var s = {}, l = this._;
                        for(var u in l)s[u] = l[u].slice();
                        return new n(s);
                    },
                    call: function(s, l) {
                        if ((f = arguments.length - 2) > 0) for(var u = new Array(f), c = 0, f, h; c < f; ++c)u[c] = arguments[c + 2];
                        if (!this._.hasOwnProperty(s)) throw new Error("unknown type: " + s);
                        for(h = this._[s], c = 0, f = h.length; c < f; ++c)h[c].value.apply(l, u);
                    },
                    apply: function(s, l, u) {
                        if (!this._.hasOwnProperty(s)) throw new Error("unknown type: " + s);
                        for(var c = this._[s], f = 0, h = c.length; f < h; ++f)c[f].value.apply(l, u);
                    }
                };
                function a(s, l) {
                    for(var u = 0, c = s.length, f; u < c; ++u)if ((f = s[u]).name === l) return f.value;
                }
                function o(s, l, u) {
                    for(var c = 0, f = s.length; c < f; ++c)if (s[c].name === l) {
                        s[c] = t, s = s.slice(0, c).concat(s.slice(c + 1));
                        break;
                    }
                    return u != null && s.push({
                        name: l,
                        value: u
                    }), s;
                }
                e.dispatch = r, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var _je = ye((p7, yje)=>{
            (function(e, t) {
                typeof p7 == "object" && typeof yje != "undefined" ? t(p7) : (e = e || self, t(e.d3 = e.d3 || {}));
            })(p7, function(e) {
                "use strict";
                var t = 0, r = 0, n = 0, i = 1e3, a, o, s = 0, l = 0, u = 0, c = typeof performance == "object" && performance.now ? performance : Date, f = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(C) {
                    setTimeout(C, 17);
                };
                function h() {
                    return l || (f(d), l = c.now() + u);
                }
                function d() {
                    l = 0;
                }
                function v() {
                    this._call = this._time = this._next = null;
                }
                v.prototype = x.prototype = {
                    constructor: v,
                    restart: function(C, M, g) {
                        if (typeof C != "function") throw new TypeError("callback is not a function");
                        g = (g == null ? h() : +g) + (M == null ? 0 : +M), !this._next && o !== this && (o ? o._next = this : a = this, o = this), this._call = C, this._time = g, A();
                    },
                    stop: function() {
                        this._call && (this._call = null, this._time = 1 / 0, A());
                    }
                };
                function x(C, M, g) {
                    var P = new v;
                    return P.restart(C, M, g), P;
                }
                function b() {
                    h(), ++t;
                    for(var C = a, M; C;)(M = l - C._time) >= 0 && C._call.call(null, M), C = C._next;
                    --t;
                }
                function p() {
                    l = (s = c.now()) + u, t = r = 0;
                    try {
                        b();
                    } finally{
                        t = 0, k(), l = 0;
                    }
                }
                function E() {
                    var C = c.now(), M = C - s;
                    M > i && (u -= M, s = C);
                }
                function k() {
                    for(var C, M = a, g, P = 1 / 0; M;)M._call ? (P > M._time && (P = M._time), C = M, M = M._next) : (g = M._next, M._next = null, M = C ? C._next = g : a = g);
                    o = C, A(P);
                }
                function A(C) {
                    if (!t) {
                        r && (r = clearTimeout(r));
                        var M = C - l;
                        M > 24 ? (C < 1 / 0 && (r = setTimeout(p, C - c.now() - u)), n && (n = clearInterval(n))) : (n || (s = c.now(), n = setInterval(E, i)), t = 1, f(p));
                    }
                }
                function L(C, M, g) {
                    var P = new v;
                    return M = M == null ? 0 : +M, P.restart(function(T) {
                        P.stop(), C(T + M);
                    }, M, g), P;
                }
                function _(C, M, g) {
                    var P = new v, T = M;
                    return M == null ? (P.restart(C, M, g), P) : (M = +M, g = g == null ? h() : +g, P.restart(function F(q) {
                        q += T, P.restart(F, T += M, g), C(q);
                    }, M, g), P);
                }
                e.interval = _, e.now = h, e.timeout = L, e.timer = x, e.timerFlush = b, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var bje = ye((g7, xje)=>{
            (function(e, t) {
                typeof g7 == "object" && typeof xje != "undefined" ? t(g7, vje(), d7(), mje(), _je()) : t(e.d3 = e.d3 || {}, e.d3, e.d3, e.d3, e.d3);
            })(g7, function(e, t, r, n, i) {
                "use strict";
                function a(C, M) {
                    var g;
                    C == null && (C = 0), M == null && (M = 0);
                    function P() {
                        var T, F = g.length, q, V = 0, H = 0;
                        for(T = 0; T < F; ++T)q = g[T], V += q.x, H += q.y;
                        for(V = V / F - C, H = H / F - M, T = 0; T < F; ++T)q = g[T], q.x -= V, q.y -= H;
                    }
                    return P.initialize = function(T) {
                        g = T;
                    }, P.x = function(T) {
                        return arguments.length ? (C = +T, P) : C;
                    }, P.y = function(T) {
                        return arguments.length ? (M = +T, P) : M;
                    }, P;
                }
                function o(C) {
                    return function() {
                        return C;
                    };
                }
                function s() {
                    return (Math.random() - .5) * 1e-6;
                }
                function l(C) {
                    return C.x + C.vx;
                }
                function u(C) {
                    return C.y + C.vy;
                }
                function c(C) {
                    var M, g, P = 1, T = 1;
                    typeof C != "function" && (C = o(C == null ? 1 : +C));
                    function F() {
                        for(var H, X = M.length, G, N, W, re, ae, _e, Me = 0; Me < T; ++Me)for(G = t.quadtree(M, l, u).visitAfter(q), H = 0; H < X; ++H)N = M[H], ae = g[N.index], _e = ae * ae, W = N.x + N.vx, re = N.y + N.vy, G.visit(ke);
                        function ke(ge, ie, Te, Ee, Ae) {
                            var ze = ge.data, Ce = ge.r, me = ae + Ce;
                            if (ze) {
                                if (ze.index > N.index) {
                                    var Re = W - ze.x - ze.vx, ce = re - ze.y - ze.vy, Ge = Re * Re + ce * ce;
                                    Ge < me * me && (Re === 0 && (Re = s(), Ge += Re * Re), ce === 0 && (ce = s(), Ge += ce * ce), Ge = (me - (Ge = Math.sqrt(Ge))) / Ge * P, N.vx += (Re *= Ge) * (me = (Ce *= Ce) / (_e + Ce)), N.vy += (ce *= Ge) * me, ze.vx -= Re * (me = 1 - me), ze.vy -= ce * me);
                                }
                                return;
                            }
                            return ie > W + me || Ee < W - me || Te > re + me || Ae < re - me;
                        }
                    }
                    function q(H) {
                        if (H.data) return H.r = g[H.data.index];
                        for(var X = H.r = 0; X < 4; ++X)H[X] && H[X].r > H.r && (H.r = H[X].r);
                    }
                    function V() {
                        if (M) {
                            var H, X = M.length, G;
                            for(g = new Array(X), H = 0; H < X; ++H)G = M[H], g[G.index] = +C(G, H, M);
                        }
                    }
                    return F.initialize = function(H) {
                        M = H, V();
                    }, F.iterations = function(H) {
                        return arguments.length ? (T = +H, F) : T;
                    }, F.strength = function(H) {
                        return arguments.length ? (P = +H, F) : P;
                    }, F.radius = function(H) {
                        return arguments.length ? (C = typeof H == "function" ? H : o(+H), V(), F) : C;
                    }, F;
                }
                function f(C) {
                    return C.index;
                }
                function h(C, M) {
                    var g = C.get(M);
                    if (!g) throw new Error("missing: " + M);
                    return g;
                }
                function d(C) {
                    var M = f, g = G, P, T = o(30), F, q, V, H, X = 1;
                    C == null && (C = []);
                    function G(_e) {
                        return 1 / Math.min(V[_e.source.index], V[_e.target.index]);
                    }
                    function N(_e) {
                        for(var Me = 0, ke = C.length; Me < X; ++Me)for(var ge = 0, ie, Te, Ee, Ae, ze, Ce, me; ge < ke; ++ge)ie = C[ge], Te = ie.source, Ee = ie.target, Ae = Ee.x + Ee.vx - Te.x - Te.vx || s(), ze = Ee.y + Ee.vy - Te.y - Te.vy || s(), Ce = Math.sqrt(Ae * Ae + ze * ze), Ce = (Ce - F[ge]) / Ce * _e * P[ge], Ae *= Ce, ze *= Ce, Ee.vx -= Ae * (me = H[ge]), Ee.vy -= ze * me, Te.vx += Ae * (me = 1 - me), Te.vy += ze * me;
                    }
                    function W() {
                        if (q) {
                            var _e, Me = q.length, ke = C.length, ge = r.map(q, M), ie;
                            for(_e = 0, V = new Array(Me); _e < ke; ++_e)ie = C[_e], ie.index = _e, typeof ie.source != "object" && (ie.source = h(ge, ie.source)), typeof ie.target != "object" && (ie.target = h(ge, ie.target)), V[ie.source.index] = (V[ie.source.index] || 0) + 1, V[ie.target.index] = (V[ie.target.index] || 0) + 1;
                            for(_e = 0, H = new Array(ke); _e < ke; ++_e)ie = C[_e], H[_e] = V[ie.source.index] / (V[ie.source.index] + V[ie.target.index]);
                            P = new Array(ke), re(), F = new Array(ke), ae();
                        }
                    }
                    function re() {
                        if (q) for(var _e = 0, Me = C.length; _e < Me; ++_e)P[_e] = +g(C[_e], _e, C);
                    }
                    function ae() {
                        if (q) for(var _e = 0, Me = C.length; _e < Me; ++_e)F[_e] = +T(C[_e], _e, C);
                    }
                    return N.initialize = function(_e) {
                        q = _e, W();
                    }, N.links = function(_e) {
                        return arguments.length ? (C = _e, W(), N) : C;
                    }, N.id = function(_e) {
                        return arguments.length ? (M = _e, N) : M;
                    }, N.iterations = function(_e) {
                        return arguments.length ? (X = +_e, N) : X;
                    }, N.strength = function(_e) {
                        return arguments.length ? (g = typeof _e == "function" ? _e : o(+_e), re(), N) : g;
                    }, N.distance = function(_e) {
                        return arguments.length ? (T = typeof _e == "function" ? _e : o(+_e), ae(), N) : T;
                    }, N;
                }
                function v(C) {
                    return C.x;
                }
                function x(C) {
                    return C.y;
                }
                var b = 10, p = Math.PI * (3 - Math.sqrt(5));
                function E(C) {
                    var M, g = 1, P = .001, T = 1 - Math.pow(P, 1 / 300), F = 0, q = .6, V = r.map(), H = i.timer(G), X = n.dispatch("tick", "end");
                    C == null && (C = []);
                    function G() {
                        N(), X.call("tick", M), g < P && (H.stop(), X.call("end", M));
                    }
                    function N(ae) {
                        var _e, Me = C.length, ke;
                        ae === void 0 && (ae = 1);
                        for(var ge = 0; ge < ae; ++ge)for(g += (F - g) * T, V.each(function(ie) {
                            ie(g);
                        }), _e = 0; _e < Me; ++_e)ke = C[_e], ke.fx == null ? ke.x += ke.vx *= q : (ke.x = ke.fx, ke.vx = 0), ke.fy == null ? ke.y += ke.vy *= q : (ke.y = ke.fy, ke.vy = 0);
                        return M;
                    }
                    function W() {
                        for(var ae = 0, _e = C.length, Me; ae < _e; ++ae){
                            if (Me = C[ae], Me.index = ae, Me.fx != null && (Me.x = Me.fx), Me.fy != null && (Me.y = Me.fy), isNaN(Me.x) || isNaN(Me.y)) {
                                var ke = b * Math.sqrt(ae), ge = ae * p;
                                Me.x = ke * Math.cos(ge), Me.y = ke * Math.sin(ge);
                            }
                            (isNaN(Me.vx) || isNaN(Me.vy)) && (Me.vx = Me.vy = 0);
                        }
                    }
                    function re(ae) {
                        return ae.initialize && ae.initialize(C), ae;
                    }
                    return W(), M = {
                        tick: N,
                        restart: function() {
                            return H.restart(G), M;
                        },
                        stop: function() {
                            return H.stop(), M;
                        },
                        nodes: function(ae) {
                            return arguments.length ? (C = ae, W(), V.each(re), M) : C;
                        },
                        alpha: function(ae) {
                            return arguments.length ? (g = +ae, M) : g;
                        },
                        alphaMin: function(ae) {
                            return arguments.length ? (P = +ae, M) : P;
                        },
                        alphaDecay: function(ae) {
                            return arguments.length ? (T = +ae, M) : +T;
                        },
                        alphaTarget: function(ae) {
                            return arguments.length ? (F = +ae, M) : F;
                        },
                        velocityDecay: function(ae) {
                            return arguments.length ? (q = 1 - ae, M) : 1 - q;
                        },
                        force: function(ae, _e) {
                            return arguments.length > 1 ? (_e == null ? V.remove(ae) : V.set(ae, re(_e)), M) : V.get(ae);
                        },
                        find: function(ae, _e, Me) {
                            var ke = 0, ge = C.length, ie, Te, Ee, Ae, ze;
                            for(Me == null ? Me = 1 / 0 : Me *= Me, ke = 0; ke < ge; ++ke)Ae = C[ke], ie = ae - Ae.x, Te = _e - Ae.y, Ee = ie * ie + Te * Te, Ee < Me && (ze = Ae, Me = Ee);
                            return ze;
                        },
                        on: function(ae, _e) {
                            return arguments.length > 1 ? (X.on(ae, _e), M) : X.on(ae);
                        }
                    };
                }
                function k() {
                    var C, M, g, P = o(-30), T, F = 1, q = 1 / 0, V = .81;
                    function H(W) {
                        var re, ae = C.length, _e = t.quadtree(C, v, x).visitAfter(G);
                        for(g = W, re = 0; re < ae; ++re)M = C[re], _e.visit(N);
                    }
                    function X() {
                        if (C) {
                            var W, re = C.length, ae;
                            for(T = new Array(re), W = 0; W < re; ++W)ae = C[W], T[ae.index] = +P(ae, W, C);
                        }
                    }
                    function G(W) {
                        var re = 0, ae, _e, Me = 0, ke, ge, ie;
                        if (W.length) {
                            for(ke = ge = ie = 0; ie < 4; ++ie)(ae = W[ie]) && (_e = Math.abs(ae.value)) && (re += ae.value, Me += _e, ke += _e * ae.x, ge += _e * ae.y);
                            W.x = ke / Me, W.y = ge / Me;
                        } else {
                            ae = W, ae.x = ae.data.x, ae.y = ae.data.y;
                            do re += T[ae.data.index];
                            while (ae = ae.next);
                        }
                        W.value = re;
                    }
                    function N(W, re, ae, _e) {
                        if (!W.value) return !0;
                        var Me = W.x - M.x, ke = W.y - M.y, ge = _e - re, ie = Me * Me + ke * ke;
                        if (ge * ge / V < ie) return ie < q && (Me === 0 && (Me = s(), ie += Me * Me), ke === 0 && (ke = s(), ie += ke * ke), ie < F && (ie = Math.sqrt(F * ie)), M.vx += Me * W.value * g / ie, M.vy += ke * W.value * g / ie), !0;
                        if (W.length || ie >= q) return;
                        (W.data !== M || W.next) && (Me === 0 && (Me = s(), ie += Me * Me), ke === 0 && (ke = s(), ie += ke * ke), ie < F && (ie = Math.sqrt(F * ie)));
                        do W.data !== M && (ge = T[W.data.index] * g / ie, M.vx += Me * ge, M.vy += ke * ge);
                        while (W = W.next);
                    }
                    return H.initialize = function(W) {
                        C = W, X();
                    }, H.strength = function(W) {
                        return arguments.length ? (P = typeof W == "function" ? W : o(+W), X(), H) : P;
                    }, H.distanceMin = function(W) {
                        return arguments.length ? (F = W * W, H) : Math.sqrt(F);
                    }, H.distanceMax = function(W) {
                        return arguments.length ? (q = W * W, H) : Math.sqrt(q);
                    }, H.theta = function(W) {
                        return arguments.length ? (V = W * W, H) : Math.sqrt(V);
                    }, H;
                }
                function A(C, M, g) {
                    var P, T = o(.1), F, q;
                    typeof C != "function" && (C = o(+C)), M == null && (M = 0), g == null && (g = 0);
                    function V(X) {
                        for(var G = 0, N = P.length; G < N; ++G){
                            var W = P[G], re = W.x - M || 1e-6, ae = W.y - g || 1e-6, _e = Math.sqrt(re * re + ae * ae), Me = (q[G] - _e) * F[G] * X / _e;
                            W.vx += re * Me, W.vy += ae * Me;
                        }
                    }
                    function H() {
                        if (P) {
                            var X, G = P.length;
                            for(F = new Array(G), q = new Array(G), X = 0; X < G; ++X)q[X] = +C(P[X], X, P), F[X] = isNaN(q[X]) ? 0 : +T(P[X], X, P);
                        }
                    }
                    return V.initialize = function(X) {
                        P = X, H();
                    }, V.strength = function(X) {
                        return arguments.length ? (T = typeof X == "function" ? X : o(+X), H(), V) : T;
                    }, V.radius = function(X) {
                        return arguments.length ? (C = typeof X == "function" ? X : o(+X), H(), V) : C;
                    }, V.x = function(X) {
                        return arguments.length ? (M = +X, V) : M;
                    }, V.y = function(X) {
                        return arguments.length ? (g = +X, V) : g;
                    }, V;
                }
                function L(C) {
                    var M = o(.1), g, P, T;
                    typeof C != "function" && (C = o(C == null ? 0 : +C));
                    function F(V) {
                        for(var H = 0, X = g.length, G; H < X; ++H)G = g[H], G.vx += (T[H] - G.x) * P[H] * V;
                    }
                    function q() {
                        if (g) {
                            var V, H = g.length;
                            for(P = new Array(H), T = new Array(H), V = 0; V < H; ++V)P[V] = isNaN(T[V] = +C(g[V], V, g)) ? 0 : +M(g[V], V, g);
                        }
                    }
                    return F.initialize = function(V) {
                        g = V, q();
                    }, F.strength = function(V) {
                        return arguments.length ? (M = typeof V == "function" ? V : o(+V), q(), F) : M;
                    }, F.x = function(V) {
                        return arguments.length ? (C = typeof V == "function" ? V : o(+V), q(), F) : C;
                    }, F;
                }
                function _(C) {
                    var M = o(.1), g, P, T;
                    typeof C != "function" && (C = o(C == null ? 0 : +C));
                    function F(V) {
                        for(var H = 0, X = g.length, G; H < X; ++H)G = g[H], G.vy += (T[H] - G.y) * P[H] * V;
                    }
                    function q() {
                        if (g) {
                            var V, H = g.length;
                            for(P = new Array(H), T = new Array(H), V = 0; V < H; ++V)P[V] = isNaN(T[V] = +C(g[V], V, g)) ? 0 : +M(g[V], V, g);
                        }
                    }
                    return F.initialize = function(V) {
                        g = V, q();
                    }, F.strength = function(V) {
                        return arguments.length ? (M = typeof V == "function" ? V : o(+V), q(), F) : M;
                    }, F.y = function(V) {
                        return arguments.length ? (C = typeof V == "function" ? V : o(+V), q(), F) : C;
                    }, F;
                }
                e.forceCenter = a, e.forceCollide = c, e.forceLink = d, e.forceManyBody = k, e.forceRadial = A, e.forceSimulation = E, e.forceX = L, e.forceY = _, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var Tje = ye((m7, wje)=>{
            (function(e, t) {
                typeof m7 == "object" && typeof wje != "undefined" ? t(m7) : (e = e || self, t(e.d3 = e.d3 || {}));
            })(m7, function(e) {
                "use strict";
                var t = Math.PI, r = 2 * t, n = 1e-6, i = r - n;
                function a() {
                    this._x0 = this._y0 = this._x1 = this._y1 = null, this._ = "";
                }
                function o() {
                    return new a;
                }
                a.prototype = o.prototype = {
                    constructor: a,
                    moveTo: function(s, l) {
                        this._ += "M" + (this._x0 = this._x1 = +s) + "," + (this._y0 = this._y1 = +l);
                    },
                    closePath: function() {
                        this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._ += "Z");
                    },
                    lineTo: function(s, l) {
                        this._ += "L" + (this._x1 = +s) + "," + (this._y1 = +l);
                    },
                    quadraticCurveTo: function(s, l, u, c) {
                        this._ += "Q" + +s + "," + +l + "," + (this._x1 = +u) + "," + (this._y1 = +c);
                    },
                    bezierCurveTo: function(s, l, u, c, f, h) {
                        this._ += "C" + +s + "," + +l + "," + +u + "," + +c + "," + (this._x1 = +f) + "," + (this._y1 = +h);
                    },
                    arcTo: function(s, l, u, c, f) {
                        s = +s, l = +l, u = +u, c = +c, f = +f;
                        var h = this._x1, d = this._y1, v = u - s, x = c - l, b = h - s, p = d - l, E = b * b + p * p;
                        if (f < 0) throw new Error("negative radius: " + f);
                        if (this._x1 === null) this._ += "M" + (this._x1 = s) + "," + (this._y1 = l);
                        else if (E > n) {
                            if (!(Math.abs(p * v - x * b) > n) || !f) this._ += "L" + (this._x1 = s) + "," + (this._y1 = l);
                            else {
                                var k = u - h, A = c - d, L = v * v + x * x, _ = k * k + A * A, C = Math.sqrt(L), M = Math.sqrt(E), g = f * Math.tan((t - Math.acos((L + E - _) / (2 * C * M))) / 2), P = g / M, T = g / C;
                                Math.abs(P - 1) > n && (this._ += "L" + (s + P * b) + "," + (l + P * p)), this._ += "A" + f + "," + f + ",0,0," + +(p * k > b * A) + "," + (this._x1 = s + T * v) + "," + (this._y1 = l + T * x);
                            }
                        }
                    },
                    arc: function(s, l, u, c, f, h) {
                        s = +s, l = +l, u = +u, h = !!h;
                        var d = u * Math.cos(c), v = u * Math.sin(c), x = s + d, b = l + v, p = 1 ^ h, E = h ? c - f : f - c;
                        if (u < 0) throw new Error("negative radius: " + u);
                        this._x1 === null ? this._ += "M" + x + "," + b : (Math.abs(this._x1 - x) > n || Math.abs(this._y1 - b) > n) && (this._ += "L" + x + "," + b), u && (E < 0 && (E = E % r + r), E > i ? this._ += "A" + u + "," + u + ",0,1," + p + "," + (s - d) + "," + (l - v) + "A" + u + "," + u + ",0,1," + p + "," + (this._x1 = x) + "," + (this._y1 = b) : E > n && (this._ += "A" + u + "," + u + ",0," + +(E >= t) + "," + p + "," + (this._x1 = s + u * Math.cos(f)) + "," + (this._y1 = l + u * Math.sin(f))));
                    },
                    rect: function(s, l, u, c) {
                        this._ += "M" + (this._x0 = this._x1 = +s) + "," + (this._y0 = this._y1 = +l) + "h" + +u + "v" + +c + "h" + -u + "Z";
                    },
                    toString: function() {
                        return this._;
                    }
                }, e.path = o, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var PJ = ye((y7, Aje)=>{
            (function(e, t) {
                typeof y7 == "object" && typeof Aje != "undefined" ? t(y7, Tje()) : (e = e || self, t(e.d3 = e.d3 || {}, e.d3));
            })(y7, function(e, t) {
                "use strict";
                function r(_t) {
                    return function() {
                        return _t;
                    };
                }
                var n = Math.abs, i = Math.atan2, a = Math.cos, o = Math.max, s = Math.min, l = Math.sin, u = Math.sqrt, c = 1e-12, f = Math.PI, h = f / 2, d = 2 * f;
                function v(_t) {
                    return _t > 1 ? 0 : _t < -1 ? f : Math.acos(_t);
                }
                function x(_t) {
                    return _t >= 1 ? h : _t <= -1 ? -h : Math.asin(_t);
                }
                function b(_t) {
                    return _t.innerRadius;
                }
                function p(_t) {
                    return _t.outerRadius;
                }
                function E(_t) {
                    return _t.startAngle;
                }
                function k(_t) {
                    return _t.endAngle;
                }
                function A(_t) {
                    return _t && _t.padAngle;
                }
                function L(_t, br, Hr, ti, zi, Yi, an, hi) {
                    var Ji = Hr - _t, ua = ti - br, Fn = an - zi, Sa = hi - Yi, go = Sa * Ji - Fn * ua;
                    if (!(go * go < c)) return go = (Fn * (br - Yi) - Sa * (_t - zi)) / go, [
                        _t + go * Ji,
                        br + go * ua
                    ];
                }
                function _(_t, br, Hr, ti, zi, Yi, an) {
                    var hi = _t - Hr, Ji = br - ti, ua = (an ? Yi : -Yi) / u(hi * hi + Ji * Ji), Fn = ua * Ji, Sa = -ua * hi, go = _t + Fn, Oo = br + Sa, ho = Hr + Fn, Mo = ti + Sa, xo = (go + ho) / 2, zs = (Oo + Mo) / 2, ks = ho - go, Zs = Mo - Oo, Xs = ks * ks + Zs * Zs, wl = zi - Yi, os = go * Mo - ho * Oo, cl = (Zs < 0 ? -1 : 1) * u(o(0, wl * wl * Xs - os * os)), Cs = (os * Zs - ks * cl) / Xs, ml = (-os * ks - Zs * cl) / Xs, Ys = (os * Zs + ks * cl) / Xs, Hs = (-os * ks + Zs * cl) / Xs, Eo = Cs - xo, fs = ml - zs, Ql = Ys - xo, Hu = Hs - zs;
                    return Eo * Eo + fs * fs > Ql * Ql + Hu * Hu && (Cs = Ys, ml = Hs), {
                        cx: Cs,
                        cy: ml,
                        x01: -Fn,
                        y01: -Sa,
                        x11: Cs * (zi / wl - 1),
                        y11: ml * (zi / wl - 1)
                    };
                }
                function C() {
                    var _t = b, br = p, Hr = r(0), ti = null, zi = E, Yi = k, an = A, hi = null;
                    function Ji() {
                        var ua, Fn, Sa = +_t.apply(this, arguments), go = +br.apply(this, arguments), Oo = zi.apply(this, arguments) - h, ho = Yi.apply(this, arguments) - h, Mo = n(ho - Oo), xo = ho > Oo;
                        if (hi || (hi = ua = t.path()), go < Sa && (Fn = go, go = Sa, Sa = Fn), !(go > c)) hi.moveTo(0, 0);
                        else if (Mo > d - c) hi.moveTo(go * a(Oo), go * l(Oo)), hi.arc(0, 0, go, Oo, ho, !xo), Sa > c && (hi.moveTo(Sa * a(ho), Sa * l(ho)), hi.arc(0, 0, Sa, ho, Oo, xo));
                        else {
                            var zs = Oo, ks = ho, Zs = Oo, Xs = ho, wl = Mo, os = Mo, cl = an.apply(this, arguments) / 2, Cs = cl > c && (ti ? +ti.apply(this, arguments) : u(Sa * Sa + go * go)), ml = s(n(go - Sa) / 2, +Hr.apply(this, arguments)), Ys = ml, Hs = ml, Eo, fs;
                            if (Cs > c) {
                                var Ql = x(Cs / Sa * l(cl)), Hu = x(Cs / go * l(cl));
                                (wl -= Ql * 2) > c ? (Ql *= xo ? 1 : -1, Zs += Ql, Xs -= Ql) : (wl = 0, Zs = Xs = (Oo + ho) / 2), (os -= Hu * 2) > c ? (Hu *= xo ? 1 : -1, zs += Hu, ks -= Hu) : (os = 0, zs = ks = (Oo + ho) / 2);
                            }
                            var fc = go * a(zs), ms = go * l(zs), on = Sa * a(Xs), fa = Sa * l(Xs);
                            if (ml > c) {
                                var Qu = go * a(ks), Rl = go * l(ks), vo = Sa * a(Zs), Zl = Sa * l(Zs), Ks;
                                if (Mo < f && (Ks = L(fc, ms, vo, Zl, Qu, Rl, on, fa))) {
                                    var Xl = fc - Ks[0], Ec = ms - Ks[1], Zn = Qu - Ks[0], ko = Rl - Ks[1], Co = 1 / l(v((Xl * Zn + Ec * ko) / (u(Xl * Xl + Ec * Ec) * u(Zn * Zn + ko * ko))) / 2), Tl = u(Ks[0] * Ks[0] + Ks[1] * Ks[1]);
                                    Ys = s(ml, (Sa - Tl) / (Co - 1)), Hs = s(ml, (go - Tl) / (Co + 1));
                                }
                            }
                            os > c ? Hs > c ? (Eo = _(vo, Zl, fc, ms, go, Hs, xo), fs = _(Qu, Rl, on, fa, go, Hs, xo), hi.moveTo(Eo.cx + Eo.x01, Eo.cy + Eo.y01), Hs < ml ? hi.arc(Eo.cx, Eo.cy, Hs, i(Eo.y01, Eo.x01), i(fs.y01, fs.x01), !xo) : (hi.arc(Eo.cx, Eo.cy, Hs, i(Eo.y01, Eo.x01), i(Eo.y11, Eo.x11), !xo), hi.arc(0, 0, go, i(Eo.cy + Eo.y11, Eo.cx + Eo.x11), i(fs.cy + fs.y11, fs.cx + fs.x11), !xo), hi.arc(fs.cx, fs.cy, Hs, i(fs.y11, fs.x11), i(fs.y01, fs.x01), !xo))) : (hi.moveTo(fc, ms), hi.arc(0, 0, go, zs, ks, !xo)) : hi.moveTo(fc, ms), !(Sa > c) || !(wl > c) ? hi.lineTo(on, fa) : Ys > c ? (Eo = _(on, fa, Qu, Rl, Sa, -Ys, xo), fs = _(fc, ms, vo, Zl, Sa, -Ys, xo), hi.lineTo(Eo.cx + Eo.x01, Eo.cy + Eo.y01), Ys < ml ? hi.arc(Eo.cx, Eo.cy, Ys, i(Eo.y01, Eo.x01), i(fs.y01, fs.x01), !xo) : (hi.arc(Eo.cx, Eo.cy, Ys, i(Eo.y01, Eo.x01), i(Eo.y11, Eo.x11), !xo), hi.arc(0, 0, Sa, i(Eo.cy + Eo.y11, Eo.cx + Eo.x11), i(fs.cy + fs.y11, fs.cx + fs.x11), xo), hi.arc(fs.cx, fs.cy, Ys, i(fs.y11, fs.x11), i(fs.y01, fs.x01), !xo))) : hi.arc(0, 0, Sa, Xs, Zs, xo);
                        }
                        if (hi.closePath(), ua) return hi = null, ua + "" || null;
                    }
                    return Ji.centroid = function() {
                        var ua = (+_t.apply(this, arguments) + +br.apply(this, arguments)) / 2, Fn = (+zi.apply(this, arguments) + +Yi.apply(this, arguments)) / 2 - f / 2;
                        return [
                            a(Fn) * ua,
                            l(Fn) * ua
                        ];
                    }, Ji.innerRadius = function(ua) {
                        return arguments.length ? (_t = typeof ua == "function" ? ua : r(+ua), Ji) : _t;
                    }, Ji.outerRadius = function(ua) {
                        return arguments.length ? (br = typeof ua == "function" ? ua : r(+ua), Ji) : br;
                    }, Ji.cornerRadius = function(ua) {
                        return arguments.length ? (Hr = typeof ua == "function" ? ua : r(+ua), Ji) : Hr;
                    }, Ji.padRadius = function(ua) {
                        return arguments.length ? (ti = ua == null ? null : typeof ua == "function" ? ua : r(+ua), Ji) : ti;
                    }, Ji.startAngle = function(ua) {
                        return arguments.length ? (zi = typeof ua == "function" ? ua : r(+ua), Ji) : zi;
                    }, Ji.endAngle = function(ua) {
                        return arguments.length ? (Yi = typeof ua == "function" ? ua : r(+ua), Ji) : Yi;
                    }, Ji.padAngle = function(ua) {
                        return arguments.length ? (an = typeof ua == "function" ? ua : r(+ua), Ji) : an;
                    }, Ji.context = function(ua) {
                        return arguments.length ? (hi = ua == null ? null : ua, Ji) : hi;
                    }, Ji;
                }
                function M(_t) {
                    this._context = _t;
                }
                M.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._point = 0;
                    },
                    lineEnd: function() {
                        (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
                    },
                    point: function(_t, br) {
                        switch(_t = +_t, br = +br, this._point){
                            case 0:
                                this._point = 1, this._line ? this._context.lineTo(_t, br) : this._context.moveTo(_t, br);
                                break;
                            case 1:
                                this._point = 2;
                            default:
                                this._context.lineTo(_t, br);
                                break;
                        }
                    }
                };
                function g(_t) {
                    return new M(_t);
                }
                function P(_t) {
                    return _t[0];
                }
                function T(_t) {
                    return _t[1];
                }
                function F() {
                    var _t = P, br = T, Hr = r(!0), ti = null, zi = g, Yi = null;
                    function an(hi) {
                        var Ji, ua = hi.length, Fn, Sa = !1, go;
                        for(ti == null && (Yi = zi(go = t.path())), Ji = 0; Ji <= ua; ++Ji)!(Ji < ua && Hr(Fn = hi[Ji], Ji, hi)) === Sa && ((Sa = !Sa) ? Yi.lineStart() : Yi.lineEnd()), Sa && Yi.point(+_t(Fn, Ji, hi), +br(Fn, Ji, hi));
                        if (go) return Yi = null, go + "" || null;
                    }
                    return an.x = function(hi) {
                        return arguments.length ? (_t = typeof hi == "function" ? hi : r(+hi), an) : _t;
                    }, an.y = function(hi) {
                        return arguments.length ? (br = typeof hi == "function" ? hi : r(+hi), an) : br;
                    }, an.defined = function(hi) {
                        return arguments.length ? (Hr = typeof hi == "function" ? hi : r(!!hi), an) : Hr;
                    }, an.curve = function(hi) {
                        return arguments.length ? (zi = hi, ti != null && (Yi = zi(ti)), an) : zi;
                    }, an.context = function(hi) {
                        return arguments.length ? (hi == null ? ti = Yi = null : Yi = zi(ti = hi), an) : ti;
                    }, an;
                }
                function q() {
                    var _t = P, br = null, Hr = r(0), ti = T, zi = r(!0), Yi = null, an = g, hi = null;
                    function Ji(Fn) {
                        var Sa, go, Oo, ho = Fn.length, Mo, xo = !1, zs, ks = new Array(ho), Zs = new Array(ho);
                        for(Yi == null && (hi = an(zs = t.path())), Sa = 0; Sa <= ho; ++Sa){
                            if (!(Sa < ho && zi(Mo = Fn[Sa], Sa, Fn)) === xo) {
                                if (xo = !xo) go = Sa, hi.areaStart(), hi.lineStart();
                                else {
                                    for(hi.lineEnd(), hi.lineStart(), Oo = Sa - 1; Oo >= go; --Oo)hi.point(ks[Oo], Zs[Oo]);
                                    hi.lineEnd(), hi.areaEnd();
                                }
                            }
                            xo && (ks[Sa] = +_t(Mo, Sa, Fn), Zs[Sa] = +Hr(Mo, Sa, Fn), hi.point(br ? +br(Mo, Sa, Fn) : ks[Sa], ti ? +ti(Mo, Sa, Fn) : Zs[Sa]));
                        }
                        if (zs) return hi = null, zs + "" || null;
                    }
                    function ua() {
                        return F().defined(zi).curve(an).context(Yi);
                    }
                    return Ji.x = function(Fn) {
                        return arguments.length ? (_t = typeof Fn == "function" ? Fn : r(+Fn), br = null, Ji) : _t;
                    }, Ji.x0 = function(Fn) {
                        return arguments.length ? (_t = typeof Fn == "function" ? Fn : r(+Fn), Ji) : _t;
                    }, Ji.x1 = function(Fn) {
                        return arguments.length ? (br = Fn == null ? null : typeof Fn == "function" ? Fn : r(+Fn), Ji) : br;
                    }, Ji.y = function(Fn) {
                        return arguments.length ? (Hr = typeof Fn == "function" ? Fn : r(+Fn), ti = null, Ji) : Hr;
                    }, Ji.y0 = function(Fn) {
                        return arguments.length ? (Hr = typeof Fn == "function" ? Fn : r(+Fn), Ji) : Hr;
                    }, Ji.y1 = function(Fn) {
                        return arguments.length ? (ti = Fn == null ? null : typeof Fn == "function" ? Fn : r(+Fn), Ji) : ti;
                    }, Ji.lineX0 = Ji.lineY0 = function() {
                        return ua().x(_t).y(Hr);
                    }, Ji.lineY1 = function() {
                        return ua().x(_t).y(ti);
                    }, Ji.lineX1 = function() {
                        return ua().x(br).y(Hr);
                    }, Ji.defined = function(Fn) {
                        return arguments.length ? (zi = typeof Fn == "function" ? Fn : r(!!Fn), Ji) : zi;
                    }, Ji.curve = function(Fn) {
                        return arguments.length ? (an = Fn, Yi != null && (hi = an(Yi)), Ji) : an;
                    }, Ji.context = function(Fn) {
                        return arguments.length ? (Fn == null ? Yi = hi = null : hi = an(Yi = Fn), Ji) : Yi;
                    }, Ji;
                }
                function V(_t, br) {
                    return br < _t ? -1 : br > _t ? 1 : br >= _t ? 0 : NaN;
                }
                function H(_t) {
                    return _t;
                }
                function X() {
                    var _t = H, br = V, Hr = null, ti = r(0), zi = r(d), Yi = r(0);
                    function an(hi) {
                        var Ji, ua = hi.length, Fn, Sa, go = 0, Oo = new Array(ua), ho = new Array(ua), Mo = +ti.apply(this, arguments), xo = Math.min(d, Math.max(-d, zi.apply(this, arguments) - Mo)), zs, ks = Math.min(Math.abs(xo) / ua, Yi.apply(this, arguments)), Zs = ks * (xo < 0 ? -1 : 1), Xs;
                        for(Ji = 0; Ji < ua; ++Ji)(Xs = ho[Oo[Ji] = Ji] = +_t(hi[Ji], Ji, hi)) > 0 && (go += Xs);
                        for(br != null ? Oo.sort(function(wl, os) {
                            return br(ho[wl], ho[os]);
                        }) : Hr != null && Oo.sort(function(wl, os) {
                            return Hr(hi[wl], hi[os]);
                        }), Ji = 0, Sa = go ? (xo - ua * Zs) / go : 0; Ji < ua; ++Ji, Mo = zs)Fn = Oo[Ji], Xs = ho[Fn], zs = Mo + (Xs > 0 ? Xs * Sa : 0) + Zs, ho[Fn] = {
                            data: hi[Fn],
                            index: Ji,
                            value: Xs,
                            startAngle: Mo,
                            endAngle: zs,
                            padAngle: ks
                        };
                        return ho;
                    }
                    return an.value = function(hi) {
                        return arguments.length ? (_t = typeof hi == "function" ? hi : r(+hi), an) : _t;
                    }, an.sortValues = function(hi) {
                        return arguments.length ? (br = hi, Hr = null, an) : br;
                    }, an.sort = function(hi) {
                        return arguments.length ? (Hr = hi, br = null, an) : Hr;
                    }, an.startAngle = function(hi) {
                        return arguments.length ? (ti = typeof hi == "function" ? hi : r(+hi), an) : ti;
                    }, an.endAngle = function(hi) {
                        return arguments.length ? (zi = typeof hi == "function" ? hi : r(+hi), an) : zi;
                    }, an.padAngle = function(hi) {
                        return arguments.length ? (Yi = typeof hi == "function" ? hi : r(+hi), an) : Yi;
                    }, an;
                }
                var G = W(g);
                function N(_t) {
                    this._curve = _t;
                }
                N.prototype = {
                    areaStart: function() {
                        this._curve.areaStart();
                    },
                    areaEnd: function() {
                        this._curve.areaEnd();
                    },
                    lineStart: function() {
                        this._curve.lineStart();
                    },
                    lineEnd: function() {
                        this._curve.lineEnd();
                    },
                    point: function(_t, br) {
                        this._curve.point(br * Math.sin(_t), br * -Math.cos(_t));
                    }
                };
                function W(_t) {
                    function br(Hr) {
                        return new N(_t(Hr));
                    }
                    return br._curve = _t, br;
                }
                function re(_t) {
                    var br = _t.curve;
                    return _t.angle = _t.x, delete _t.x, _t.radius = _t.y, delete _t.y, _t.curve = function(Hr) {
                        return arguments.length ? br(W(Hr)) : br()._curve;
                    }, _t;
                }
                function ae() {
                    return re(F().curve(G));
                }
                function _e() {
                    var _t = q().curve(G), br = _t.curve, Hr = _t.lineX0, ti = _t.lineX1, zi = _t.lineY0, Yi = _t.lineY1;
                    return _t.angle = _t.x, delete _t.x, _t.startAngle = _t.x0, delete _t.x0, _t.endAngle = _t.x1, delete _t.x1, _t.radius = _t.y, delete _t.y, _t.innerRadius = _t.y0, delete _t.y0, _t.outerRadius = _t.y1, delete _t.y1, _t.lineStartAngle = function() {
                        return re(Hr());
                    }, delete _t.lineX0, _t.lineEndAngle = function() {
                        return re(ti());
                    }, delete _t.lineX1, _t.lineInnerRadius = function() {
                        return re(zi());
                    }, delete _t.lineY0, _t.lineOuterRadius = function() {
                        return re(Yi());
                    }, delete _t.lineY1, _t.curve = function(an) {
                        return arguments.length ? br(W(an)) : br()._curve;
                    }, _t;
                }
                function Me(_t, br) {
                    return [
                        (br = +br) * Math.cos(_t -= Math.PI / 2),
                        br * Math.sin(_t)
                    ];
                }
                var ke = Array.prototype.slice;
                function ge(_t) {
                    return _t.source;
                }
                function ie(_t) {
                    return _t.target;
                }
                function Te(_t) {
                    var br = ge, Hr = ie, ti = P, zi = T, Yi = null;
                    function an() {
                        var hi, Ji = ke.call(arguments), ua = br.apply(this, Ji), Fn = Hr.apply(this, Ji);
                        if (Yi || (Yi = hi = t.path()), _t(Yi, +ti.apply(this, (Ji[0] = ua, Ji)), +zi.apply(this, Ji), +ti.apply(this, (Ji[0] = Fn, Ji)), +zi.apply(this, Ji)), hi) return Yi = null, hi + "" || null;
                    }
                    return an.source = function(hi) {
                        return arguments.length ? (br = hi, an) : br;
                    }, an.target = function(hi) {
                        return arguments.length ? (Hr = hi, an) : Hr;
                    }, an.x = function(hi) {
                        return arguments.length ? (ti = typeof hi == "function" ? hi : r(+hi), an) : ti;
                    }, an.y = function(hi) {
                        return arguments.length ? (zi = typeof hi == "function" ? hi : r(+hi), an) : zi;
                    }, an.context = function(hi) {
                        return arguments.length ? (Yi = hi == null ? null : hi, an) : Yi;
                    }, an;
                }
                function Ee(_t, br, Hr, ti, zi) {
                    _t.moveTo(br, Hr), _t.bezierCurveTo(br = (br + ti) / 2, Hr, br, zi, ti, zi);
                }
                function Ae(_t, br, Hr, ti, zi) {
                    _t.moveTo(br, Hr), _t.bezierCurveTo(br, Hr = (Hr + zi) / 2, ti, Hr, ti, zi);
                }
                function ze(_t, br, Hr, ti, zi) {
                    var Yi = Me(br, Hr), an = Me(br, Hr = (Hr + zi) / 2), hi = Me(ti, Hr), Ji = Me(ti, zi);
                    _t.moveTo(Yi[0], Yi[1]), _t.bezierCurveTo(an[0], an[1], hi[0], hi[1], Ji[0], Ji[1]);
                }
                function Ce() {
                    return Te(Ee);
                }
                function me() {
                    return Te(Ae);
                }
                function Re() {
                    var _t = Te(ze);
                    return _t.angle = _t.x, delete _t.x, _t.radius = _t.y, delete _t.y, _t;
                }
                var ce = {
                    draw: function(_t, br) {
                        var Hr = Math.sqrt(br / f);
                        _t.moveTo(Hr, 0), _t.arc(0, 0, Hr, 0, d);
                    }
                }, Ge = {
                    draw: function(_t, br) {
                        var Hr = Math.sqrt(br / 5) / 2;
                        _t.moveTo(-3 * Hr, -Hr), _t.lineTo(-Hr, -Hr), _t.lineTo(-Hr, -3 * Hr), _t.lineTo(Hr, -3 * Hr), _t.lineTo(Hr, -Hr), _t.lineTo(3 * Hr, -Hr), _t.lineTo(3 * Hr, Hr), _t.lineTo(Hr, Hr), _t.lineTo(Hr, 3 * Hr), _t.lineTo(-Hr, 3 * Hr), _t.lineTo(-Hr, Hr), _t.lineTo(-3 * Hr, Hr), _t.closePath();
                    }
                }, nt = Math.sqrt(1 / 3), ct = nt * 2, qt = {
                    draw: function(_t, br) {
                        var Hr = Math.sqrt(br / ct), ti = Hr * nt;
                        _t.moveTo(0, -Hr), _t.lineTo(ti, 0), _t.lineTo(0, Hr), _t.lineTo(-ti, 0), _t.closePath();
                    }
                }, rt = .8908130915292852, ot = Math.sin(f / 10) / Math.sin(7 * f / 10), Rt = Math.sin(d / 10) * ot, kt = -Math.cos(d / 10) * ot, Ct = {
                    draw: function(_t, br) {
                        var Hr = Math.sqrt(br * rt), ti = Rt * Hr, zi = kt * Hr;
                        _t.moveTo(0, -Hr), _t.lineTo(ti, zi);
                        for(var Yi = 1; Yi < 5; ++Yi){
                            var an = d * Yi / 5, hi = Math.cos(an), Ji = Math.sin(an);
                            _t.lineTo(Ji * Hr, -hi * Hr), _t.lineTo(hi * ti - Ji * zi, Ji * ti + hi * zi);
                        }
                        _t.closePath();
                    }
                }, Yt = {
                    draw: function(_t, br) {
                        var Hr = Math.sqrt(br), ti = -Hr / 2;
                        _t.rect(ti, ti, Hr, Hr);
                    }
                }, xr = Math.sqrt(3), er = {
                    draw: function(_t, br) {
                        var Hr = -Math.sqrt(br / (xr * 3));
                        _t.moveTo(0, Hr * 2), _t.lineTo(-xr * Hr, -Hr), _t.lineTo(xr * Hr, -Hr), _t.closePath();
                    }
                }, Ke = -0.5, xt = Math.sqrt(3) / 2, bt = 1 / Math.sqrt(12), Lt = (bt / 2 + 1) * 3, St = {
                    draw: function(_t, br) {
                        var Hr = Math.sqrt(br / Lt), ti = Hr / 2, zi = Hr * bt, Yi = ti, an = Hr * bt + Hr, hi = -Yi, Ji = an;
                        _t.moveTo(ti, zi), _t.lineTo(Yi, an), _t.lineTo(hi, Ji), _t.lineTo(Ke * ti - xt * zi, xt * ti + Ke * zi), _t.lineTo(Ke * Yi - xt * an, xt * Yi + Ke * an), _t.lineTo(Ke * hi - xt * Ji, xt * hi + Ke * Ji), _t.lineTo(Ke * ti + xt * zi, Ke * zi - xt * ti), _t.lineTo(Ke * Yi + xt * an, Ke * an - xt * Yi), _t.lineTo(Ke * hi + xt * Ji, Ke * Ji - xt * hi), _t.closePath();
                    }
                }, Et = [
                    ce,
                    Ge,
                    qt,
                    Yt,
                    Ct,
                    er,
                    St
                ];
                function dt() {
                    var _t = r(ce), br = r(64), Hr = null;
                    function ti() {
                        var zi;
                        if (Hr || (Hr = zi = t.path()), _t.apply(this, arguments).draw(Hr, +br.apply(this, arguments)), zi) return Hr = null, zi + "" || null;
                    }
                    return ti.type = function(zi) {
                        return arguments.length ? (_t = typeof zi == "function" ? zi : r(zi), ti) : _t;
                    }, ti.size = function(zi) {
                        return arguments.length ? (br = typeof zi == "function" ? zi : r(+zi), ti) : br;
                    }, ti.context = function(zi) {
                        return arguments.length ? (Hr = zi == null ? null : zi, ti) : Hr;
                    }, ti;
                }
                function Ht() {}
                function $t(_t, br, Hr) {
                    _t._context.bezierCurveTo((2 * _t._x0 + _t._x1) / 3, (2 * _t._y0 + _t._y1) / 3, (_t._x0 + 2 * _t._x1) / 3, (_t._y0 + 2 * _t._y1) / 3, (_t._x0 + 4 * _t._x1 + br) / 6, (_t._y0 + 4 * _t._y1 + Hr) / 6);
                }
                function fr(_t) {
                    this._context = _t;
                }
                fr.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
                    },
                    lineEnd: function() {
                        switch(this._point){
                            case 3:
                                $t(this, this._x1, this._y1);
                            case 2:
                                this._context.lineTo(this._x1, this._y1);
                                break;
                        }
                        (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
                    },
                    point: function(_t, br) {
                        switch(_t = +_t, br = +br, this._point){
                            case 0:
                                this._point = 1, this._line ? this._context.lineTo(_t, br) : this._context.moveTo(_t, br);
                                break;
                            case 1:
                                this._point = 2;
                                break;
                            case 2:
                                this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
                            default:
                                $t(this, _t, br);
                                break;
                        }
                        this._x0 = this._x1, this._x1 = _t, this._y0 = this._y1, this._y1 = br;
                    }
                };
                function _r(_t) {
                    return new fr(_t);
                }
                function Br(_t) {
                    this._context = _t;
                }
                Br.prototype = {
                    areaStart: Ht,
                    areaEnd: Ht,
                    lineStart: function() {
                        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
                    },
                    lineEnd: function() {
                        switch(this._point){
                            case 1:
                                this._context.moveTo(this._x2, this._y2), this._context.closePath();
                                break;
                            case 2:
                                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
                                break;
                            case 3:
                                this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
                                break;
                        }
                    },
                    point: function(_t, br) {
                        switch(_t = +_t, br = +br, this._point){
                            case 0:
                                this._point = 1, this._x2 = _t, this._y2 = br;
                                break;
                            case 1:
                                this._point = 2, this._x3 = _t, this._y3 = br;
                                break;
                            case 2:
                                this._point = 3, this._x4 = _t, this._y4 = br, this._context.moveTo((this._x0 + 4 * this._x1 + _t) / 6, (this._y0 + 4 * this._y1 + br) / 6);
                                break;
                            default:
                                $t(this, _t, br);
                                break;
                        }
                        this._x0 = this._x1, this._x1 = _t, this._y0 = this._y1, this._y1 = br;
                    }
                };
                function Or(_t) {
                    return new Br(_t);
                }
                function Nr(_t) {
                    this._context = _t;
                }
                Nr.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
                    },
                    lineEnd: function() {
                        (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
                    },
                    point: function(_t, br) {
                        switch(_t = +_t, br = +br, this._point){
                            case 0:
                                this._point = 1;
                                break;
                            case 1:
                                this._point = 2;
                                break;
                            case 2:
                                this._point = 3;
                                var Hr = (this._x0 + 4 * this._x1 + _t) / 6, ti = (this._y0 + 4 * this._y1 + br) / 6;
                                this._line ? this._context.lineTo(Hr, ti) : this._context.moveTo(Hr, ti);
                                break;
                            case 3:
                                this._point = 4;
                            default:
                                $t(this, _t, br);
                                break;
                        }
                        this._x0 = this._x1, this._x1 = _t, this._y0 = this._y1, this._y1 = br;
                    }
                };
                function ut(_t) {
                    return new Nr(_t);
                }
                function Ne(_t, br) {
                    this._basis = new fr(_t), this._beta = br;
                }
                Ne.prototype = {
                    lineStart: function() {
                        this._x = [], this._y = [], this._basis.lineStart();
                    },
                    lineEnd: function() {
                        var _t = this._x, br = this._y, Hr = _t.length - 1;
                        if (Hr > 0) for(var ti = _t[0], zi = br[0], Yi = _t[Hr] - ti, an = br[Hr] - zi, hi = -1, Ji; ++hi <= Hr;)Ji = hi / Hr, this._basis.point(this._beta * _t[hi] + (1 - this._beta) * (ti + Ji * Yi), this._beta * br[hi] + (1 - this._beta) * (zi + Ji * an));
                        this._x = this._y = null, this._basis.lineEnd();
                    },
                    point: function(_t, br) {
                        this._x.push(+_t), this._y.push(+br);
                    }
                };
                var Ye = function _t(br) {
                    function Hr(ti) {
                        return br === 1 ? new fr(ti) : new Ne(ti, br);
                    }
                    return Hr.beta = function(ti) {
                        return _t(+ti);
                    }, Hr;
                }(.85);
                function Ve(_t, br, Hr) {
                    _t._context.bezierCurveTo(_t._x1 + _t._k * (_t._x2 - _t._x0), _t._y1 + _t._k * (_t._y2 - _t._y0), _t._x2 + _t._k * (_t._x1 - br), _t._y2 + _t._k * (_t._y1 - Hr), _t._x2, _t._y2);
                }
                function Xe(_t, br) {
                    this._context = _t, this._k = (1 - br) / 6;
                }
                Xe.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
                    },
                    lineEnd: function() {
                        switch(this._point){
                            case 2:
                                this._context.lineTo(this._x2, this._y2);
                                break;
                            case 3:
                                Ve(this, this._x1, this._y1);
                                break;
                        }
                        (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
                    },
                    point: function(_t, br) {
                        switch(_t = +_t, br = +br, this._point){
                            case 0:
                                this._point = 1, this._line ? this._context.lineTo(_t, br) : this._context.moveTo(_t, br);
                                break;
                            case 1:
                                this._point = 2, this._x1 = _t, this._y1 = br;
                                break;
                            case 2:
                                this._point = 3;
                            default:
                                Ve(this, _t, br);
                                break;
                        }
                        this._x0 = this._x1, this._x1 = this._x2, this._x2 = _t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = br;
                    }
                };
                var ht = function _t(br) {
                    function Hr(ti) {
                        return new Xe(ti, br);
                    }
                    return Hr.tension = function(ti) {
                        return _t(+ti);
                    }, Hr;
                }(0);
                function Le(_t, br) {
                    this._context = _t, this._k = (1 - br) / 6;
                }
                Le.prototype = {
                    areaStart: Ht,
                    areaEnd: Ht,
                    lineStart: function() {
                        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._point = 0;
                    },
                    lineEnd: function() {
                        switch(this._point){
                            case 1:
                                this._context.moveTo(this._x3, this._y3), this._context.closePath();
                                break;
                            case 2:
                                this._context.lineTo(this._x3, this._y3), this._context.closePath();
                                break;
                            case 3:
                                this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
                                break;
                        }
                    },
                    point: function(_t, br) {
                        switch(_t = +_t, br = +br, this._point){
                            case 0:
                                this._point = 1, this._x3 = _t, this._y3 = br;
                                break;
                            case 1:
                                this._point = 2, this._context.moveTo(this._x4 = _t, this._y4 = br);
                                break;
                            case 2:
                                this._point = 3, this._x5 = _t, this._y5 = br;
                                break;
                            default:
                                Ve(this, _t, br);
                                break;
                        }
                        this._x0 = this._x1, this._x1 = this._x2, this._x2 = _t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = br;
                    }
                };
                var xe = function _t(br) {
                    function Hr(ti) {
                        return new Le(ti, br);
                    }
                    return Hr.tension = function(ti) {
                        return _t(+ti);
                    }, Hr;
                }(0);
                function Se(_t, br) {
                    this._context = _t, this._k = (1 - br) / 6;
                }
                Se.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._point = 0;
                    },
                    lineEnd: function() {
                        (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
                    },
                    point: function(_t, br) {
                        switch(_t = +_t, br = +br, this._point){
                            case 0:
                                this._point = 1;
                                break;
                            case 1:
                                this._point = 2;
                                break;
                            case 2:
                                this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                                break;
                            case 3:
                                this._point = 4;
                            default:
                                Ve(this, _t, br);
                                break;
                        }
                        this._x0 = this._x1, this._x1 = this._x2, this._x2 = _t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = br;
                    }
                };
                var lt = function _t(br) {
                    function Hr(ti) {
                        return new Se(ti, br);
                    }
                    return Hr.tension = function(ti) {
                        return _t(+ti);
                    }, Hr;
                }(0);
                function Gt(_t, br, Hr) {
                    var ti = _t._x1, zi = _t._y1, Yi = _t._x2, an = _t._y2;
                    if (_t._l01_a > c) {
                        var hi = 2 * _t._l01_2a + 3 * _t._l01_a * _t._l12_a + _t._l12_2a, Ji = 3 * _t._l01_a * (_t._l01_a + _t._l12_a);
                        ti = (ti * hi - _t._x0 * _t._l12_2a + _t._x2 * _t._l01_2a) / Ji, zi = (zi * hi - _t._y0 * _t._l12_2a + _t._y2 * _t._l01_2a) / Ji;
                    }
                    if (_t._l23_a > c) {
                        var ua = 2 * _t._l23_2a + 3 * _t._l23_a * _t._l12_a + _t._l12_2a, Fn = 3 * _t._l23_a * (_t._l23_a + _t._l12_a);
                        Yi = (Yi * ua + _t._x1 * _t._l23_2a - br * _t._l12_2a) / Fn, an = (an * ua + _t._y1 * _t._l23_2a - Hr * _t._l12_2a) / Fn;
                    }
                    _t._context.bezierCurveTo(ti, zi, Yi, an, _t._x2, _t._y2);
                }
                function Vt(_t, br) {
                    this._context = _t, this._alpha = br;
                }
                Vt.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
                    },
                    lineEnd: function() {
                        switch(this._point){
                            case 2:
                                this._context.lineTo(this._x2, this._y2);
                                break;
                            case 3:
                                this.point(this._x2, this._y2);
                                break;
                        }
                        (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
                    },
                    point: function(_t, br) {
                        if (_t = +_t, br = +br, this._point) {
                            var Hr = this._x2 - _t, ti = this._y2 - br;
                            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(Hr * Hr + ti * ti, this._alpha));
                        }
                        switch(this._point){
                            case 0:
                                this._point = 1, this._line ? this._context.lineTo(_t, br) : this._context.moveTo(_t, br);
                                break;
                            case 1:
                                this._point = 2;
                                break;
                            case 2:
                                this._point = 3;
                            default:
                                Gt(this, _t, br);
                                break;
                        }
                        this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = _t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = br;
                    }
                };
                var ar = function _t(br) {
                    function Hr(ti) {
                        return br ? new Vt(ti, br) : new Xe(ti, 0);
                    }
                    return Hr.alpha = function(ti) {
                        return _t(+ti);
                    }, Hr;
                }(.5);
                function Qr(_t, br) {
                    this._context = _t, this._alpha = br;
                }
                Qr.prototype = {
                    areaStart: Ht,
                    areaEnd: Ht,
                    lineStart: function() {
                        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
                    },
                    lineEnd: function() {
                        switch(this._point){
                            case 1:
                                this._context.moveTo(this._x3, this._y3), this._context.closePath();
                                break;
                            case 2:
                                this._context.lineTo(this._x3, this._y3), this._context.closePath();
                                break;
                            case 3:
                                this.point(this._x3, this._y3), this.point(this._x4, this._y4), this.point(this._x5, this._y5);
                                break;
                        }
                    },
                    point: function(_t, br) {
                        if (_t = +_t, br = +br, this._point) {
                            var Hr = this._x2 - _t, ti = this._y2 - br;
                            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(Hr * Hr + ti * ti, this._alpha));
                        }
                        switch(this._point){
                            case 0:
                                this._point = 1, this._x3 = _t, this._y3 = br;
                                break;
                            case 1:
                                this._point = 2, this._context.moveTo(this._x4 = _t, this._y4 = br);
                                break;
                            case 2:
                                this._point = 3, this._x5 = _t, this._y5 = br;
                                break;
                            default:
                                Gt(this, _t, br);
                                break;
                        }
                        this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = _t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = br;
                    }
                };
                var ai = function _t(br) {
                    function Hr(ti) {
                        return br ? new Qr(ti, br) : new Le(ti, 0);
                    }
                    return Hr.alpha = function(ti) {
                        return _t(+ti);
                    }, Hr;
                }(.5);
                function jr(_t, br) {
                    this._context = _t, this._alpha = br;
                }
                jr.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN, this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
                    },
                    lineEnd: function() {
                        (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
                    },
                    point: function(_t, br) {
                        if (_t = +_t, br = +br, this._point) {
                            var Hr = this._x2 - _t, ti = this._y2 - br;
                            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(Hr * Hr + ti * ti, this._alpha));
                        }
                        switch(this._point){
                            case 0:
                                this._point = 1;
                                break;
                            case 1:
                                this._point = 2;
                                break;
                            case 2:
                                this._point = 3, this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                                break;
                            case 3:
                                this._point = 4;
                            default:
                                Gt(this, _t, br);
                                break;
                        }
                        this._l01_a = this._l12_a, this._l12_a = this._l23_a, this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a, this._x0 = this._x1, this._x1 = this._x2, this._x2 = _t, this._y0 = this._y1, this._y1 = this._y2, this._y2 = br;
                    }
                };
                var ri = function _t(br) {
                    function Hr(ti) {
                        return br ? new jr(ti, br) : new Se(ti, 0);
                    }
                    return Hr.alpha = function(ti) {
                        return _t(+ti);
                    }, Hr;
                }(.5);
                function bi(_t) {
                    this._context = _t;
                }
                bi.prototype = {
                    areaStart: Ht,
                    areaEnd: Ht,
                    lineStart: function() {
                        this._point = 0;
                    },
                    lineEnd: function() {
                        this._point && this._context.closePath();
                    },
                    point: function(_t, br) {
                        _t = +_t, br = +br, this._point ? this._context.lineTo(_t, br) : (this._point = 1, this._context.moveTo(_t, br));
                    }
                };
                function nn(_t) {
                    return new bi(_t);
                }
                function Wi(_t) {
                    return _t < 0 ? -1 : 1;
                }
                function Ni(_t, br, Hr) {
                    var ti = _t._x1 - _t._x0, zi = br - _t._x1, Yi = (_t._y1 - _t._y0) / (ti || zi < 0 && -0), an = (Hr - _t._y1) / (zi || ti < 0 && -0), hi = (Yi * zi + an * ti) / (ti + zi);
                    return (Wi(Yi) + Wi(an)) * Math.min(Math.abs(Yi), Math.abs(an), .5 * Math.abs(hi)) || 0;
                }
                function _n(_t, br) {
                    var Hr = _t._x1 - _t._x0;
                    return Hr ? (3 * (_t._y1 - _t._y0) / Hr - br) / 2 : br;
                }
                function $i(_t, br, Hr) {
                    var ti = _t._x0, zi = _t._y0, Yi = _t._x1, an = _t._y1, hi = (Yi - ti) / 3;
                    _t._context.bezierCurveTo(ti + hi, zi + hi * br, Yi - hi, an - hi * Hr, Yi, an);
                }
                function zn(_t) {
                    this._context = _t;
                }
                zn.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
                    },
                    lineEnd: function() {
                        switch(this._point){
                            case 2:
                                this._context.lineTo(this._x1, this._y1);
                                break;
                            case 3:
                                $i(this, this._t0, _n(this, this._t0));
                                break;
                        }
                        (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
                    },
                    point: function(_t, br) {
                        var Hr = NaN;
                        if (_t = +_t, br = +br, !(_t === this._x1 && br === this._y1)) {
                            switch(this._point){
                                case 0:
                                    this._point = 1, this._line ? this._context.lineTo(_t, br) : this._context.moveTo(_t, br);
                                    break;
                                case 1:
                                    this._point = 2;
                                    break;
                                case 2:
                                    this._point = 3, $i(this, _n(this, Hr = Ni(this, _t, br)), Hr);
                                    break;
                                default:
                                    $i(this, this._t0, Hr = Ni(this, _t, br));
                                    break;
                            }
                            this._x0 = this._x1, this._x1 = _t, this._y0 = this._y1, this._y1 = br, this._t0 = Hr;
                        }
                    }
                };
                function Wn(_t) {
                    this._context = new It(_t);
                }
                (Wn.prototype = Object.create(zn.prototype)).point = function(_t, br) {
                    zn.prototype.point.call(this, br, _t);
                };
                function It(_t) {
                    this._context = _t;
                }
                It.prototype = {
                    moveTo: function(_t, br) {
                        this._context.moveTo(br, _t);
                    },
                    closePath: function() {
                        this._context.closePath();
                    },
                    lineTo: function(_t, br) {
                        this._context.lineTo(br, _t);
                    },
                    bezierCurveTo: function(_t, br, Hr, ti, zi, Yi) {
                        this._context.bezierCurveTo(br, _t, ti, Hr, Yi, zi);
                    }
                };
                function ft(_t) {
                    return new zn(_t);
                }
                function jt(_t) {
                    return new Wn(_t);
                }
                function Zt(_t) {
                    this._context = _t;
                }
                Zt.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._x = [], this._y = [];
                    },
                    lineEnd: function() {
                        var _t = this._x, br = this._y, Hr = _t.length;
                        if (Hr) {
                            if (this._line ? this._context.lineTo(_t[0], br[0]) : this._context.moveTo(_t[0], br[0]), Hr === 2) this._context.lineTo(_t[1], br[1]);
                            else for(var ti = yr(_t), zi = yr(br), Yi = 0, an = 1; an < Hr; ++Yi, ++an)this._context.bezierCurveTo(ti[0][Yi], zi[0][Yi], ti[1][Yi], zi[1][Yi], _t[an], br[an]);
                        }
                        (this._line || this._line !== 0 && Hr === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
                    },
                    point: function(_t, br) {
                        this._x.push(+_t), this._y.push(+br);
                    }
                };
                function yr(_t) {
                    var br, Hr = _t.length - 1, ti, zi = new Array(Hr), Yi = new Array(Hr), an = new Array(Hr);
                    for(zi[0] = 0, Yi[0] = 2, an[0] = _t[0] + 2 * _t[1], br = 1; br < Hr - 1; ++br)zi[br] = 1, Yi[br] = 4, an[br] = 4 * _t[br] + 2 * _t[br + 1];
                    for(zi[Hr - 1] = 2, Yi[Hr - 1] = 7, an[Hr - 1] = 8 * _t[Hr - 1] + _t[Hr], br = 1; br < Hr; ++br)ti = zi[br] / Yi[br - 1], Yi[br] -= ti, an[br] -= ti * an[br - 1];
                    for(zi[Hr - 1] = an[Hr - 1] / Yi[Hr - 1], br = Hr - 2; br >= 0; --br)zi[br] = (an[br] - zi[br + 1]) / Yi[br];
                    for(Yi[Hr - 1] = (_t[Hr] + zi[Hr - 1]) / 2, br = 0; br < Hr - 1; ++br)Yi[br] = 2 * _t[br + 1] - zi[br + 1];
                    return [
                        zi,
                        Yi
                    ];
                }
                function Fr(_t) {
                    return new Zt(_t);
                }
                function Zr(_t, br) {
                    this._context = _t, this._t = br;
                }
                Zr.prototype = {
                    areaStart: function() {
                        this._line = 0;
                    },
                    areaEnd: function() {
                        this._line = NaN;
                    },
                    lineStart: function() {
                        this._x = this._y = NaN, this._point = 0;
                    },
                    lineEnd: function() {
                        0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
                    },
                    point: function(_t, br) {
                        switch(_t = +_t, br = +br, this._point){
                            case 0:
                                this._point = 1, this._line ? this._context.lineTo(_t, br) : this._context.moveTo(_t, br);
                                break;
                            case 1:
                                this._point = 2;
                            default:
                                if (this._t <= 0) this._context.lineTo(this._x, br), this._context.lineTo(_t, br);
                                else {
                                    var Hr = this._x * (1 - this._t) + _t * this._t;
                                    this._context.lineTo(Hr, this._y), this._context.lineTo(Hr, br);
                                }
                                break;
                        }
                        this._x = _t, this._y = br;
                    }
                };
                function Vr(_t) {
                    return new Zr(_t, .5);
                }
                function gi(_t) {
                    return new Zr(_t, 0);
                }
                function Si(_t) {
                    return new Zr(_t, 1);
                }
                function Mi(_t, br) {
                    if ((an = _t.length) > 1) for(var Hr = 1, ti, zi, Yi = _t[br[0]], an, hi = Yi.length; Hr < an; ++Hr)for(zi = Yi, Yi = _t[br[Hr]], ti = 0; ti < hi; ++ti)Yi[ti][1] += Yi[ti][0] = isNaN(zi[ti][1]) ? zi[ti][0] : zi[ti][1];
                }
                function Pi(_t) {
                    for(var br = _t.length, Hr = new Array(br); --br >= 0;)Hr[br] = br;
                    return Hr;
                }
                function Gi(_t, br) {
                    return _t[br];
                }
                function Ki() {
                    var _t = r([]), br = Pi, Hr = Mi, ti = Gi;
                    function zi(Yi) {
                        var an = _t.apply(this, arguments), hi, Ji = Yi.length, ua = an.length, Fn = new Array(ua), Sa;
                        for(hi = 0; hi < ua; ++hi){
                            for(var go = an[hi], Oo = Fn[hi] = new Array(Ji), ho = 0, Mo; ho < Ji; ++ho)Oo[ho] = Mo = [
                                0,
                                +ti(Yi[ho], go, ho, Yi)
                            ], Mo.data = Yi[ho];
                            Oo.key = go;
                        }
                        for(hi = 0, Sa = br(Fn); hi < ua; ++hi)Fn[Sa[hi]].index = hi;
                        return Hr(Fn, Sa), Fn;
                    }
                    return zi.keys = function(Yi) {
                        return arguments.length ? (_t = typeof Yi == "function" ? Yi : r(ke.call(Yi)), zi) : _t;
                    }, zi.value = function(Yi) {
                        return arguments.length ? (ti = typeof Yi == "function" ? Yi : r(+Yi), zi) : ti;
                    }, zi.order = function(Yi) {
                        return arguments.length ? (br = Yi == null ? Pi : typeof Yi == "function" ? Yi : r(ke.call(Yi)), zi) : br;
                    }, zi.offset = function(Yi) {
                        return arguments.length ? (Hr = Yi == null ? Mi : Yi, zi) : Hr;
                    }, zi;
                }
                function ka(_t, br) {
                    if ((ti = _t.length) > 0) {
                        for(var Hr, ti, zi = 0, Yi = _t[0].length, an; zi < Yi; ++zi){
                            for(an = Hr = 0; Hr < ti; ++Hr)an += _t[Hr][zi][1] || 0;
                            if (an) for(Hr = 0; Hr < ti; ++Hr)_t[Hr][zi][1] /= an;
                        }
                        Mi(_t, br);
                    }
                }
                function jn(_t, br) {
                    if ((Ji = _t.length) > 0) for(var Hr, ti = 0, zi, Yi, an, hi, Ji, ua = _t[br[0]].length; ti < ua; ++ti)for(an = hi = 0, Hr = 0; Hr < Ji; ++Hr)(Yi = (zi = _t[br[Hr]][ti])[1] - zi[0]) > 0 ? (zi[0] = an, zi[1] = an += Yi) : Yi < 0 ? (zi[1] = hi, zi[0] = hi += Yi) : (zi[0] = 0, zi[1] = Yi);
                }
                function la(_t, br) {
                    if ((zi = _t.length) > 0) {
                        for(var Hr = 0, ti = _t[br[0]], zi, Yi = ti.length; Hr < Yi; ++Hr){
                            for(var an = 0, hi = 0; an < zi; ++an)hi += _t[an][Hr][1] || 0;
                            ti[Hr][1] += ti[Hr][0] = -hi / 2;
                        }
                        Mi(_t, br);
                    }
                }
                function Fa(_t, br) {
                    if (!(!((an = _t.length) > 0) || !((Yi = (zi = _t[br[0]]).length) > 0))) {
                        for(var Hr = 0, ti = 1, zi, Yi, an; ti < Yi; ++ti){
                            for(var hi = 0, Ji = 0, ua = 0; hi < an; ++hi){
                                for(var Fn = _t[br[hi]], Sa = Fn[ti][1] || 0, go = Fn[ti - 1][1] || 0, Oo = (Sa - go) / 2, ho = 0; ho < hi; ++ho){
                                    var Mo = _t[br[ho]], xo = Mo[ti][1] || 0, zs = Mo[ti - 1][1] || 0;
                                    Oo += xo - zs;
                                }
                                Ji += Sa, ua += Oo * Sa;
                            }
                            zi[ti - 1][1] += zi[ti - 1][0] = Hr, Ji && (Hr -= ua / Ji);
                        }
                        zi[ti - 1][1] += zi[ti - 1][0] = Hr, Mi(_t, br);
                    }
                }
                function Ra(_t) {
                    var br = _t.map(jo);
                    return Pi(_t).sort(function(Hr, ti) {
                        return br[Hr] - br[ti];
                    });
                }
                function jo(_t) {
                    for(var br = -1, Hr = 0, ti = _t.length, zi, Yi = -1 / 0; ++br < ti;)(zi = +_t[br][1]) > Yi && (Yi = zi, Hr = br);
                    return Hr;
                }
                function oa(_t) {
                    var br = _t.map(Sn);
                    return Pi(_t).sort(function(Hr, ti) {
                        return br[Hr] - br[ti];
                    });
                }
                function Sn(_t) {
                    for(var br = 0, Hr = -1, ti = _t.length, zi; ++Hr < ti;)(zi = +_t[Hr][1]) && (br += zi);
                    return br;
                }
                function Ha(_t) {
                    return oa(_t).reverse();
                }
                function oo(_t) {
                    var br = _t.length, Hr, ti, zi = _t.map(Sn), Yi = Ra(_t), an = 0, hi = 0, Ji = [], ua = [];
                    for(Hr = 0; Hr < br; ++Hr)ti = Yi[Hr], an < hi ? (an += zi[ti], Ji.push(ti)) : (hi += zi[ti], ua.push(ti));
                    return ua.reverse().concat(Ji);
                }
                function xn(_t) {
                    return Pi(_t).reverse();
                }
                e.arc = C, e.area = q, e.areaRadial = _e, e.curveBasis = _r, e.curveBasisClosed = Or, e.curveBasisOpen = ut, e.curveBundle = Ye, e.curveCardinal = ht, e.curveCardinalClosed = xe, e.curveCardinalOpen = lt, e.curveCatmullRom = ar, e.curveCatmullRomClosed = ai, e.curveCatmullRomOpen = ri, e.curveLinear = g, e.curveLinearClosed = nn, e.curveMonotoneX = ft, e.curveMonotoneY = jt, e.curveNatural = Fr, e.curveStep = Vr, e.curveStepAfter = Si, e.curveStepBefore = gi, e.line = F, e.lineRadial = ae, e.linkHorizontal = Ce, e.linkRadial = Re, e.linkVertical = me, e.pie = X, e.pointRadial = Me, e.radialArea = _e, e.radialLine = ae, e.stack = Ki, e.stackOffsetDiverging = jn, e.stackOffsetExpand = ka, e.stackOffsetNone = Mi, e.stackOffsetSilhouette = la, e.stackOffsetWiggle = Fa, e.stackOrderAppearance = Ra, e.stackOrderAscending = oa, e.stackOrderDescending = Ha, e.stackOrderInsideOut = oo, e.stackOrderNone = Pi, e.stackOrderReverse = xn, e.symbol = dt, e.symbolCircle = ce, e.symbolCross = Ge, e.symbolDiamond = qt, e.symbolSquare = Yt, e.symbolStar = Ct, e.symbolTriangle = er, e.symbolWye = St, e.symbols = Et, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var Mje = ye((_7, Sje)=>{
            (function(e, t) {
                typeof _7 == "object" && typeof Sje != "undefined" ? t(_7, $E(), d7(), PJ()) : t(e.d3 = e.d3 || {}, e.d3, e.d3, e.d3);
            })(_7, function(e, t, r, n) {
                "use strict";
                function i(g) {
                    return g.target.depth;
                }
                function a(g) {
                    return g.depth;
                }
                function o(g, P) {
                    return P - 1 - g.height;
                }
                function s(g, P) {
                    return g.sourceLinks.length ? g.depth : P - 1;
                }
                function l(g) {
                    return g.targetLinks.length ? g.depth : g.sourceLinks.length ? t.min(g.sourceLinks, i) - 1 : 0;
                }
                function u(g) {
                    return function() {
                        return g;
                    };
                }
                function c(g, P) {
                    return h(g.source, P.source) || g.index - P.index;
                }
                function f(g, P) {
                    return h(g.target, P.target) || g.index - P.index;
                }
                function h(g, P) {
                    return g.y0 - P.y0;
                }
                function d(g) {
                    return g.value;
                }
                function v(g) {
                    return (g.y0 + g.y1) / 2;
                }
                function x(g) {
                    return v(g.source) * g.value;
                }
                function b(g) {
                    return v(g.target) * g.value;
                }
                function p(g) {
                    return g.index;
                }
                function E(g) {
                    return g.nodes;
                }
                function k(g) {
                    return g.links;
                }
                function A(g, P) {
                    var T = g.get(P);
                    if (!T) throw new Error("missing: " + P);
                    return T;
                }
                var L = function() {
                    var g = 0, P = 0, T = 1, F = 1, q = 24, V = 8, H = p, X = s, G = E, N = k, W = 32, re = 2 / 3;
                    function ae() {
                        var Te = {
                            nodes: G.apply(null, arguments),
                            links: N.apply(null, arguments)
                        };
                        return _e(Te), Me(Te), ke(Te), ge(Te, W), ie(Te), Te;
                    }
                    ae.update = function(Te) {
                        return ie(Te), Te;
                    }, ae.nodeId = function(Te) {
                        return arguments.length ? (H = typeof Te == "function" ? Te : u(Te), ae) : H;
                    }, ae.nodeAlign = function(Te) {
                        return arguments.length ? (X = typeof Te == "function" ? Te : u(Te), ae) : X;
                    }, ae.nodeWidth = function(Te) {
                        return arguments.length ? (q = +Te, ae) : q;
                    }, ae.nodePadding = function(Te) {
                        return arguments.length ? (V = +Te, ae) : V;
                    }, ae.nodes = function(Te) {
                        return arguments.length ? (G = typeof Te == "function" ? Te : u(Te), ae) : G;
                    }, ae.links = function(Te) {
                        return arguments.length ? (N = typeof Te == "function" ? Te : u(Te), ae) : N;
                    }, ae.size = function(Te) {
                        return arguments.length ? (g = P = 0, T = +Te[0], F = +Te[1], ae) : [
                            T - g,
                            F - P
                        ];
                    }, ae.extent = function(Te) {
                        return arguments.length ? (g = +Te[0][0], T = +Te[1][0], P = +Te[0][1], F = +Te[1][1], ae) : [
                            [
                                g,
                                P
                            ],
                            [
                                T,
                                F
                            ]
                        ];
                    }, ae.iterations = function(Te) {
                        return arguments.length ? (W = +Te, ae) : W;
                    };
                    function _e(Te) {
                        Te.nodes.forEach(function(Ae, ze) {
                            Ae.index = ze, Ae.sourceLinks = [], Ae.targetLinks = [];
                        });
                        var Ee = r.map(Te.nodes, H);
                        Te.links.forEach(function(Ae, ze) {
                            Ae.index = ze;
                            var Ce = Ae.source, me = Ae.target;
                            typeof Ce != "object" && (Ce = Ae.source = A(Ee, Ce)), typeof me != "object" && (me = Ae.target = A(Ee, me)), Ce.sourceLinks.push(Ae), me.targetLinks.push(Ae);
                        });
                    }
                    function Me(Te) {
                        Te.nodes.forEach(function(Ee) {
                            Ee.value = Math.max(t.sum(Ee.sourceLinks, d), t.sum(Ee.targetLinks, d));
                        });
                    }
                    function ke(Te) {
                        var Ee, Ae, ze;
                        for(Ee = Te.nodes, Ae = [], ze = 0; Ee.length; ++ze, Ee = Ae, Ae = [])Ee.forEach(function(me) {
                            me.depth = ze, me.sourceLinks.forEach(function(Re) {
                                Ae.indexOf(Re.target) < 0 && Ae.push(Re.target);
                            });
                        });
                        for(Ee = Te.nodes, Ae = [], ze = 0; Ee.length; ++ze, Ee = Ae, Ae = [])Ee.forEach(function(me) {
                            me.height = ze, me.targetLinks.forEach(function(Re) {
                                Ae.indexOf(Re.source) < 0 && Ae.push(Re.source);
                            });
                        });
                        var Ce = (T - g - q) / (ze - 1);
                        Te.nodes.forEach(function(me) {
                            me.x1 = (me.x0 = g + Math.max(0, Math.min(ze - 1, Math.floor(X.call(null, me, ze)))) * Ce) + q;
                        });
                    }
                    function ge(Te) {
                        var Ee = r.nest().key(function(Ge) {
                            return Ge.x0;
                        }).sortKeys(t.ascending).entries(Te.nodes).map(function(Ge) {
                            return Ge.values;
                        });
                        Ce(), ce();
                        for(var Ae = 1, ze = W; ze > 0; --ze)Re(Ae *= .99), ce(), me(Ae), ce();
                        function Ce() {
                            var Ge = t.max(Ee, function(qt) {
                                return qt.length;
                            }), nt = re * (F - P) / (Ge - 1);
                            V > nt && (V = nt);
                            var ct = t.min(Ee, function(qt) {
                                return (F - P - (qt.length - 1) * V) / t.sum(qt, d);
                            });
                            Ee.forEach(function(qt) {
                                qt.forEach(function(rt, ot) {
                                    rt.y1 = (rt.y0 = ot) + rt.value * ct;
                                });
                            }), Te.links.forEach(function(qt) {
                                qt.width = qt.value * ct;
                            });
                        }
                        function me(Ge) {
                            Ee.forEach(function(nt) {
                                nt.forEach(function(ct) {
                                    if (ct.targetLinks.length) {
                                        var qt = (t.sum(ct.targetLinks, x) / t.sum(ct.targetLinks, d) - v(ct)) * Ge;
                                        ct.y0 += qt, ct.y1 += qt;
                                    }
                                });
                            });
                        }
                        function Re(Ge) {
                            Ee.slice().reverse().forEach(function(nt) {
                                nt.forEach(function(ct) {
                                    if (ct.sourceLinks.length) {
                                        var qt = (t.sum(ct.sourceLinks, b) / t.sum(ct.sourceLinks, d) - v(ct)) * Ge;
                                        ct.y0 += qt, ct.y1 += qt;
                                    }
                                });
                            });
                        }
                        function ce() {
                            Ee.forEach(function(Ge) {
                                var nt, ct, qt = P, rt = Ge.length, ot;
                                for(Ge.sort(h), ot = 0; ot < rt; ++ot)nt = Ge[ot], ct = qt - nt.y0, ct > 0 && (nt.y0 += ct, nt.y1 += ct), qt = nt.y1 + V;
                                if (ct = qt - V - F, ct > 0) for(qt = nt.y0 -= ct, nt.y1 -= ct, ot = rt - 2; ot >= 0; --ot)nt = Ge[ot], ct = nt.y1 + V - qt, ct > 0 && (nt.y0 -= ct, nt.y1 -= ct), qt = nt.y0;
                            });
                        }
                    }
                    function ie(Te) {
                        Te.nodes.forEach(function(Ee) {
                            Ee.sourceLinks.sort(f), Ee.targetLinks.sort(c);
                        }), Te.nodes.forEach(function(Ee) {
                            var Ae = Ee.y0, ze = Ae;
                            Ee.sourceLinks.forEach(function(Ce) {
                                Ce.y0 = Ae + Ce.width / 2, Ae += Ce.width;
                            }), Ee.targetLinks.forEach(function(Ce) {
                                Ce.y1 = ze + Ce.width / 2, ze += Ce.width;
                            });
                        });
                    }
                    return ae;
                };
                function _(g) {
                    return [
                        g.source.x1,
                        g.y0
                    ];
                }
                function C(g) {
                    return [
                        g.target.x0,
                        g.y1
                    ];
                }
                var M = function() {
                    return n.linkHorizontal().source(_).target(C);
                };
                e.sankey = L, e.sankeyCenter = l, e.sankeyLeft = a, e.sankeyRight = o, e.sankeyJustify = s, e.sankeyLinkHorizontal = M, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var kje = ye((__r, Eje)=>{
            var SWt = LJ();
            Eje.exports = function(t, r) {
                var n = [], i = [], a = [], o = {}, s = [], l;
                function u(k) {
                    a[k] = !1, o.hasOwnProperty(k) && Object.keys(o[k]).forEach(function(A) {
                        delete o[k][A], a[A] && u(A);
                    });
                }
                function c(k) {
                    var A = !1;
                    i.push(k), a[k] = !0;
                    var L, _;
                    for(L = 0; L < s[k].length; L++)_ = s[k][L], _ === l ? (f(l, i), A = !0) : a[_] || (A = c(_));
                    if (A) u(k);
                    else for(L = 0; L < s[k].length; L++){
                        _ = s[k][L];
                        var C = o[_];
                        C || (C = {}, o[_] = C), C[_] = !0;
                    }
                    return i.pop(), A;
                }
                function f(k, A) {
                    var L = [].concat(A).concat(k);
                    r ? r(c) : n.push(L);
                }
                function h(k) {
                    for(var A = 0; A < t.length; A++)A < k && (t[A] = []), t[A] = t[A].filter(function(L) {
                        return L >= k;
                    });
                }
                function d(k) {
                    h(k);
                    for(var A = t, L = SWt(A), _ = L.components.filter(function(q) {
                        return q.length > 1;
                    }), C = 1 / 0, M, g = 0; g < _.length; g++)for(var P = 0; P < _[g].length; P++)_[g][P] < C && (C = _[g][P], M = g);
                    var T = _[M];
                    if (!T) return !1;
                    var F = t.map(function(q, V) {
                        return T.indexOf(V) === -1 ? [] : q.filter(function(H) {
                            return T.indexOf(H) !== -1;
                        });
                    });
                    return {
                        leastVertex: C,
                        adjList: F
                    };
                }
                l = 0;
                for(var v = t.length; l < v;){
                    var x = d(l);
                    if (l = x.leastVertex, s = x.adjList, s) {
                        for(var b = 0; b < s.length; b++)for(var p = 0; p < s[b].length; p++){
                            var E = s[b][p];
                            a[+E] = !1, o[E] = {};
                        }
                        c(l), l = l + 1;
                    } else l = v;
                }
                if (!r) return n;
            };
        });
        var Lje = ye((x7, Cje)=>{
            (function(e, t) {
                typeof x7 == "object" && typeof Cje != "undefined" ? t(x7, $E(), d7(), PJ(), kje()) : t(e.d3 = e.d3 || {}, e.d3, e.d3, e.d3, null);
            })(x7, function(e, t, r, n, i) {
                "use strict";
                i = i && i.hasOwnProperty("default") ? i.default : i;
                function a(rt) {
                    return rt.target.depth;
                }
                function o(rt) {
                    return rt.depth;
                }
                function s(rt, ot) {
                    return ot - 1 - rt.height;
                }
                function l(rt, ot) {
                    return rt.sourceLinks.length ? rt.depth : ot - 1;
                }
                function u(rt) {
                    return rt.targetLinks.length ? rt.depth : rt.sourceLinks.length ? t.min(rt.sourceLinks, a) - 1 : 0;
                }
                function c(rt) {
                    return function() {
                        return rt;
                    };
                }
                var f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(rt) {
                    return typeof rt;
                } : function(rt) {
                    return rt && typeof Symbol == "function" && rt.constructor === Symbol && rt !== Symbol.prototype ? "symbol" : typeof rt;
                };
                function h(rt, ot) {
                    return v(rt.source, ot.source) || rt.index - ot.index;
                }
                function d(rt, ot) {
                    return v(rt.target, ot.target) || rt.index - ot.index;
                }
                function v(rt, ot) {
                    return rt.partOfCycle === ot.partOfCycle ? rt.y0 - ot.y0 : rt.circularLinkType === "top" || ot.circularLinkType === "bottom" ? -1 : 1;
                }
                function x(rt) {
                    return rt.value;
                }
                function b(rt) {
                    return (rt.y0 + rt.y1) / 2;
                }
                function p(rt) {
                    return b(rt.source);
                }
                function E(rt) {
                    return b(rt.target);
                }
                function k(rt) {
                    return rt.index;
                }
                function A(rt) {
                    return rt.nodes;
                }
                function L(rt) {
                    return rt.links;
                }
                function _(rt, ot) {
                    var Rt = rt.get(ot);
                    if (!Rt) throw new Error("missing: " + ot);
                    return Rt;
                }
                function C(rt, ot) {
                    return ot(rt);
                }
                var M = 25, g = 10, P = .3;
                function T() {
                    var rt = 0, ot = 0, Rt = 1, kt = 1, Ct = 24, Yt, xr = k, er = l, Ke = A, xt = L, bt = 32, Lt = 2, St, Et = null;
                    function dt() {
                        var ut = {
                            nodes: Ke.apply(null, arguments),
                            links: xt.apply(null, arguments)
                        };
                        Ht(ut), F(ut, xr, Et), $t(ut), Br(ut), q(ut, xr), Or(ut, bt, xr), Nr(ut);
                        for(var Ne = 4, Ye = 0; Ye < Ne; Ye++)Re(ut, kt, xr), ce(ut, kt, xr), ze(ut, ot, kt, xr), Re(ut, kt, xr), ce(ut, kt, xr);
                        return qt(ut, ot, kt), W(ut, Lt, kt, xr), ut;
                    }
                    dt.nodeId = function(ut) {
                        return arguments.length ? (xr = typeof ut == "function" ? ut : c(ut), dt) : xr;
                    }, dt.nodeAlign = function(ut) {
                        return arguments.length ? (er = typeof ut == "function" ? ut : c(ut), dt) : er;
                    }, dt.nodeWidth = function(ut) {
                        return arguments.length ? (Ct = +ut, dt) : Ct;
                    }, dt.nodePadding = function(ut) {
                        return arguments.length ? (Yt = +ut, dt) : Yt;
                    }, dt.nodes = function(ut) {
                        return arguments.length ? (Ke = typeof ut == "function" ? ut : c(ut), dt) : Ke;
                    }, dt.links = function(ut) {
                        return arguments.length ? (xt = typeof ut == "function" ? ut : c(ut), dt) : xt;
                    }, dt.size = function(ut) {
                        return arguments.length ? (rt = ot = 0, Rt = +ut[0], kt = +ut[1], dt) : [
                            Rt - rt,
                            kt - ot
                        ];
                    }, dt.extent = function(ut) {
                        return arguments.length ? (rt = +ut[0][0], Rt = +ut[1][0], ot = +ut[0][1], kt = +ut[1][1], dt) : [
                            [
                                rt,
                                ot
                            ],
                            [
                                Rt,
                                kt
                            ]
                        ];
                    }, dt.iterations = function(ut) {
                        return arguments.length ? (bt = +ut, dt) : bt;
                    }, dt.circularLinkGap = function(ut) {
                        return arguments.length ? (Lt = +ut, dt) : Lt;
                    }, dt.nodePaddingRatio = function(ut) {
                        return arguments.length ? (St = +ut, dt) : St;
                    }, dt.sortNodes = function(ut) {
                        return arguments.length ? (Et = ut, dt) : Et;
                    }, dt.update = function(ut) {
                        return q(ut, xr), Nr(ut), ut.links.forEach(function(Ne) {
                            Ne.circular && (Ne.circularLinkType = Ne.y0 + Ne.y1 < kt ? "top" : "bottom", Ne.source.circularLinkType = Ne.circularLinkType, Ne.target.circularLinkType = Ne.circularLinkType);
                        }), Re(ut, kt, xr, !1), ce(ut, kt, xr), W(ut, Lt, kt, xr), ut;
                    };
                    function Ht(ut) {
                        ut.nodes.forEach(function(Ye, Ve) {
                            Ye.index = Ve, Ye.sourceLinks = [], Ye.targetLinks = [];
                        });
                        var Ne = r.map(ut.nodes, xr);
                        return ut.links.forEach(function(Ye, Ve) {
                            Ye.index = Ve;
                            var Xe = Ye.source, ht = Ye.target;
                            (typeof Xe == "undefined" ? "undefined" : f(Xe)) !== "object" && (Xe = Ye.source = _(Ne, Xe)), (typeof ht == "undefined" ? "undefined" : f(ht)) !== "object" && (ht = Ye.target = _(Ne, ht)), Xe.sourceLinks.push(Ye), ht.targetLinks.push(Ye);
                        }), ut;
                    }
                    function $t(ut) {
                        ut.nodes.forEach(function(Ne) {
                            Ne.partOfCycle = !1, Ne.value = Math.max(t.sum(Ne.sourceLinks, x), t.sum(Ne.targetLinks, x)), Ne.sourceLinks.forEach(function(Ye) {
                                Ye.circular && (Ne.partOfCycle = !0, Ne.circularLinkType = Ye.circularLinkType);
                            }), Ne.targetLinks.forEach(function(Ye) {
                                Ye.circular && (Ne.partOfCycle = !0, Ne.circularLinkType = Ye.circularLinkType);
                            });
                        });
                    }
                    function fr(ut) {
                        var Ne = 0, Ye = 0, Ve = 0, Xe = 0, ht = t.max(ut.nodes, function(Le) {
                            return Le.column;
                        });
                        return ut.links.forEach(function(Le) {
                            Le.circular && (Le.circularLinkType == "top" ? Ne = Ne + Le.width : Ye = Ye + Le.width, Le.target.column == 0 && (Xe = Xe + Le.width), Le.source.column == ht && (Ve = Ve + Le.width));
                        }), Ne = Ne > 0 ? Ne + M + g : Ne, Ye = Ye > 0 ? Ye + M + g : Ye, Ve = Ve > 0 ? Ve + M + g : Ve, Xe = Xe > 0 ? Xe + M + g : Xe, {
                            top: Ne,
                            bottom: Ye,
                            left: Xe,
                            right: Ve
                        };
                    }
                    function _r(ut, Ne) {
                        var Ye = t.max(ut.nodes, function(lt) {
                            return lt.column;
                        }), Ve = Rt - rt, Xe = kt - ot, ht = Ve + Ne.right + Ne.left, Le = Xe + Ne.top + Ne.bottom, xe = Ve / ht, Se = Xe / Le;
                        return rt = rt * xe + Ne.left, Rt = Ne.right == 0 ? Rt : Rt * xe, ot = ot * Se + Ne.top, kt = kt * Se, ut.nodes.forEach(function(lt) {
                            lt.x0 = rt + lt.column * ((Rt - rt - Ct) / Ye), lt.x1 = lt.x0 + Ct;
                        }), Se;
                    }
                    function Br(ut) {
                        var Ne, Ye, Ve;
                        for(Ne = ut.nodes, Ye = [], Ve = 0; Ne.length; ++Ve, Ne = Ye, Ye = [])Ne.forEach(function(Xe) {
                            Xe.depth = Ve, Xe.sourceLinks.forEach(function(ht) {
                                Ye.indexOf(ht.target) < 0 && !ht.circular && Ye.push(ht.target);
                            });
                        });
                        for(Ne = ut.nodes, Ye = [], Ve = 0; Ne.length; ++Ve, Ne = Ye, Ye = [])Ne.forEach(function(Xe) {
                            Xe.height = Ve, Xe.targetLinks.forEach(function(ht) {
                                Ye.indexOf(ht.source) < 0 && !ht.circular && Ye.push(ht.source);
                            });
                        });
                        ut.nodes.forEach(function(Xe) {
                            Xe.column = Math.floor(er.call(null, Xe, Ve));
                        });
                    }
                    function Or(ut, Ne, Ye) {
                        var Ve = r.nest().key(function(lt) {
                            return lt.column;
                        }).sortKeys(t.ascending).entries(ut.nodes).map(function(lt) {
                            return lt.values;
                        });
                        Le(Ye), Se();
                        for(var Xe = 1, ht = Ne; ht > 0; --ht)xe(Xe *= .99, Ye), Se();
                        function Le(lt) {
                            if (St) {
                                var Gt = 1 / 0;
                                Ve.forEach(function(ai) {
                                    var jr = kt * St / (ai.length + 1);
                                    Gt = jr < Gt ? jr : Gt;
                                }), Yt = Gt;
                            }
                            var Vt = t.min(Ve, function(ai) {
                                return (kt - ot - (ai.length - 1) * Yt) / t.sum(ai, x);
                            });
                            Vt = Vt * P, ut.links.forEach(function(ai) {
                                ai.width = ai.value * Vt;
                            });
                            var ar = fr(ut), Qr = _r(ut, ar);
                            Vt = Vt * Qr, ut.links.forEach(function(ai) {
                                ai.width = ai.value * Vt;
                            }), Ve.forEach(function(ai) {
                                var jr = ai.length;
                                ai.forEach(function(ri, bi) {
                                    ri.depth == Ve.length - 1 && jr == 1 || ri.depth == 0 && jr == 1 ? (ri.y0 = kt / 2 - ri.value * Vt, ri.y1 = ri.y0 + ri.value * Vt) : ri.partOfCycle ? X(ri, lt) == 0 ? (ri.y0 = kt / 2 + bi, ri.y1 = ri.y0 + ri.value * Vt) : ri.circularLinkType == "top" ? (ri.y0 = ot + bi, ri.y1 = ri.y0 + ri.value * Vt) : (ri.y0 = kt - ri.value * Vt - bi, ri.y1 = ri.y0 + ri.value * Vt) : ar.top == 0 || ar.bottom == 0 ? (ri.y0 = (kt - ot) / jr * bi, ri.y1 = ri.y0 + ri.value * Vt) : (ri.y0 = (kt - ot) / 2 - jr / 2 + bi, ri.y1 = ri.y0 + ri.value * Vt);
                                });
                            });
                        }
                        function xe(lt, Gt) {
                            var Vt = Ve.length;
                            Ve.forEach(function(ar) {
                                var Qr = ar.length, ai = ar[0].depth;
                                ar.forEach(function(jr) {
                                    var ri;
                                    if ((jr.sourceLinks.length || jr.targetLinks.length) && !(jr.partOfCycle && X(jr, Gt) > 0)) {
                                        if (ai == 0 && Qr == 1) ri = jr.y1 - jr.y0, jr.y0 = kt / 2 - ri / 2, jr.y1 = kt / 2 + ri / 2;
                                        else if (ai == Vt - 1 && Qr == 1) ri = jr.y1 - jr.y0, jr.y0 = kt / 2 - ri / 2, jr.y1 = kt / 2 + ri / 2;
                                        else {
                                            var bi = 0, nn = t.mean(jr.sourceLinks, E), Wi = t.mean(jr.targetLinks, p);
                                            nn && Wi ? bi = (nn + Wi) / 2 : bi = nn || Wi;
                                            var Ni = (bi - b(jr)) * lt;
                                            jr.y0 += Ni, jr.y1 += Ni;
                                        }
                                    }
                                });
                            });
                        }
                        function Se() {
                            Ve.forEach(function(lt) {
                                var Gt, Vt, ar = ot, Qr = lt.length, ai;
                                for(lt.sort(v), ai = 0; ai < Qr; ++ai)Gt = lt[ai], Vt = ar - Gt.y0, Vt > 0 && (Gt.y0 += Vt, Gt.y1 += Vt), ar = Gt.y1 + Yt;
                                if (Vt = ar - Yt - kt, Vt > 0) for(ar = Gt.y0 -= Vt, Gt.y1 -= Vt, ai = Qr - 2; ai >= 0; --ai)Gt = lt[ai], Vt = Gt.y1 + Yt - ar, Vt > 0 && (Gt.y0 -= Vt, Gt.y1 -= Vt), ar = Gt.y0;
                            });
                        }
                    }
                    function Nr(ut) {
                        ut.nodes.forEach(function(Ne) {
                            Ne.sourceLinks.sort(d), Ne.targetLinks.sort(h);
                        }), ut.nodes.forEach(function(Ne) {
                            var Ye = Ne.y0, Ve = Ye, Xe = Ne.y1, ht = Xe;
                            Ne.sourceLinks.forEach(function(Le) {
                                Le.circular ? (Le.y0 = Xe - Le.width / 2, Xe = Xe - Le.width) : (Le.y0 = Ye + Le.width / 2, Ye += Le.width);
                            }), Ne.targetLinks.forEach(function(Le) {
                                Le.circular ? (Le.y1 = ht - Le.width / 2, ht = ht - Le.width) : (Le.y1 = Ve + Le.width / 2, Ve += Le.width);
                            });
                        });
                    }
                    return dt;
                }
                function F(rt, ot, Rt) {
                    var kt = 0;
                    if (Rt === null) {
                        for(var Ct = [], Yt = 0; Yt < rt.links.length; Yt++){
                            var xr = rt.links[Yt], er = xr.source.index, Ke = xr.target.index;
                            Ct[er] || (Ct[er] = []), Ct[Ke] || (Ct[Ke] = []), Ct[er].indexOf(Ke) === -1 && Ct[er].push(Ke);
                        }
                        var xt = i(Ct);
                        xt.sort(function(Et, dt) {
                            return Et.length - dt.length;
                        });
                        var bt = {};
                        for(Yt = 0; Yt < xt.length; Yt++){
                            var Lt = xt[Yt], St = Lt.slice(-2);
                            bt[St[0]] || (bt[St[0]] = {}), bt[St[0]][St[1]] = !0;
                        }
                        rt.links.forEach(function(Et) {
                            var dt = Et.target.index, Ht = Et.source.index;
                            dt === Ht || bt[Ht] && bt[Ht][dt] ? (Et.circular = !0, Et.circularLinkID = kt, kt = kt + 1) : Et.circular = !1;
                        });
                    } else rt.links.forEach(function(Et) {
                        Et.source[Rt] < Et.target[Rt] ? Et.circular = !1 : (Et.circular = !0, Et.circularLinkID = kt, kt = kt + 1);
                    });
                }
                function q(rt, ot) {
                    var Rt = 0, kt = 0;
                    rt.links.forEach(function(Ct) {
                        Ct.circular && (Ct.source.circularLinkType || Ct.target.circularLinkType ? Ct.circularLinkType = Ct.source.circularLinkType ? Ct.source.circularLinkType : Ct.target.circularLinkType : Ct.circularLinkType = Rt < kt ? "top" : "bottom", Ct.circularLinkType == "top" ? Rt = Rt + 1 : kt = kt + 1, rt.nodes.forEach(function(Yt) {
                            (C(Yt, ot) == C(Ct.source, ot) || C(Yt, ot) == C(Ct.target, ot)) && (Yt.circularLinkType = Ct.circularLinkType);
                        }));
                    }), rt.links.forEach(function(Ct) {
                        Ct.circular && (Ct.source.circularLinkType == Ct.target.circularLinkType && (Ct.circularLinkType = Ct.source.circularLinkType), ct(Ct, ot) && (Ct.circularLinkType = Ct.source.circularLinkType));
                    });
                }
                function V(rt) {
                    var ot = Math.abs(rt.y1 - rt.y0), Rt = Math.abs(rt.target.x0 - rt.source.x1);
                    return Math.atan(Rt / ot);
                }
                function H(rt, ot) {
                    return rt.source.column < ot.target.column ? !1 : !(rt.target.column > ot.source.column);
                }
                function X(rt, ot) {
                    var Rt = 0;
                    rt.sourceLinks.forEach(function(Ct) {
                        Rt = Ct.circular && !ct(Ct, ot) ? Rt + 1 : Rt;
                    });
                    var kt = 0;
                    return rt.targetLinks.forEach(function(Ct) {
                        kt = Ct.circular && !ct(Ct, ot) ? kt + 1 : kt;
                    }), Rt + kt;
                }
                function G(rt) {
                    var ot = rt.source.sourceLinks, Rt = 0;
                    ot.forEach(function(Yt) {
                        Rt = Yt.circular ? Rt + 1 : Rt;
                    });
                    var kt = rt.target.targetLinks, Ct = 0;
                    return kt.forEach(function(Yt) {
                        Ct = Yt.circular ? Ct + 1 : Ct;
                    }), !(Rt > 1 || Ct > 1);
                }
                function N(rt, ot, Rt) {
                    return rt.sort(ae), rt.forEach(function(kt, Ct) {
                        var Yt = 0;
                        if (ct(kt, Rt) && G(kt)) kt.circularPathData.verticalBuffer = Yt + kt.width / 2;
                        else {
                            var xr = 0;
                            for(xr; xr < Ct; xr++)if (H(rt[Ct], rt[xr])) {
                                var er = rt[xr].circularPathData.verticalBuffer + rt[xr].width / 2 + ot;
                                Yt = er > Yt ? er : Yt;
                            }
                            kt.circularPathData.verticalBuffer = Yt + kt.width / 2;
                        }
                    }), rt;
                }
                function W(rt, ot, Rt, kt) {
                    var Ct = 5, Yt = t.min(rt.links, function(Ke) {
                        return Ke.source.y0;
                    });
                    rt.links.forEach(function(Ke) {
                        Ke.circular && (Ke.circularPathData = {});
                    });
                    var xr = rt.links.filter(function(Ke) {
                        return Ke.circularLinkType == "top";
                    });
                    N(xr, ot, kt);
                    var er = rt.links.filter(function(Ke) {
                        return Ke.circularLinkType == "bottom";
                    });
                    N(er, ot, kt), rt.links.forEach(function(Ke) {
                        if (Ke.circular) {
                            if (Ke.circularPathData.arcRadius = Ke.width + g, Ke.circularPathData.leftNodeBuffer = Ct, Ke.circularPathData.rightNodeBuffer = Ct, Ke.circularPathData.sourceWidth = Ke.source.x1 - Ke.source.x0, Ke.circularPathData.sourceX = Ke.source.x0 + Ke.circularPathData.sourceWidth, Ke.circularPathData.targetX = Ke.target.x0, Ke.circularPathData.sourceY = Ke.y0, Ke.circularPathData.targetY = Ke.y1, ct(Ke, kt) && G(Ke)) Ke.circularPathData.leftSmallArcRadius = g + Ke.width / 2, Ke.circularPathData.leftLargeArcRadius = g + Ke.width / 2, Ke.circularPathData.rightSmallArcRadius = g + Ke.width / 2, Ke.circularPathData.rightLargeArcRadius = g + Ke.width / 2, Ke.circularLinkType == "bottom" ? (Ke.circularPathData.verticalFullExtent = Ke.source.y1 + M + Ke.circularPathData.verticalBuffer, Ke.circularPathData.verticalLeftInnerExtent = Ke.circularPathData.verticalFullExtent - Ke.circularPathData.leftLargeArcRadius, Ke.circularPathData.verticalRightInnerExtent = Ke.circularPathData.verticalFullExtent - Ke.circularPathData.rightLargeArcRadius) : (Ke.circularPathData.verticalFullExtent = Ke.source.y0 - M - Ke.circularPathData.verticalBuffer, Ke.circularPathData.verticalLeftInnerExtent = Ke.circularPathData.verticalFullExtent + Ke.circularPathData.leftLargeArcRadius, Ke.circularPathData.verticalRightInnerExtent = Ke.circularPathData.verticalFullExtent + Ke.circularPathData.rightLargeArcRadius);
                            else {
                                var xt = Ke.source.column, bt = Ke.circularLinkType, Lt = rt.links.filter(function(dt) {
                                    return dt.source.column == xt && dt.circularLinkType == bt;
                                });
                                Ke.circularLinkType == "bottom" ? Lt.sort(Me) : Lt.sort(_e);
                                var St = 0;
                                Lt.forEach(function(dt, Ht) {
                                    dt.circularLinkID == Ke.circularLinkID && (Ke.circularPathData.leftSmallArcRadius = g + Ke.width / 2 + St, Ke.circularPathData.leftLargeArcRadius = g + Ke.width / 2 + Ht * ot + St), St = St + dt.width;
                                }), xt = Ke.target.column, Lt = rt.links.filter(function(dt) {
                                    return dt.target.column == xt && dt.circularLinkType == bt;
                                }), Ke.circularLinkType == "bottom" ? Lt.sort(ge) : Lt.sort(ke), St = 0, Lt.forEach(function(dt, Ht) {
                                    dt.circularLinkID == Ke.circularLinkID && (Ke.circularPathData.rightSmallArcRadius = g + Ke.width / 2 + St, Ke.circularPathData.rightLargeArcRadius = g + Ke.width / 2 + Ht * ot + St), St = St + dt.width;
                                }), Ke.circularLinkType == "bottom" ? (Ke.circularPathData.verticalFullExtent = Math.max(Rt, Ke.source.y1, Ke.target.y1) + M + Ke.circularPathData.verticalBuffer, Ke.circularPathData.verticalLeftInnerExtent = Ke.circularPathData.verticalFullExtent - Ke.circularPathData.leftLargeArcRadius, Ke.circularPathData.verticalRightInnerExtent = Ke.circularPathData.verticalFullExtent - Ke.circularPathData.rightLargeArcRadius) : (Ke.circularPathData.verticalFullExtent = Yt - M - Ke.circularPathData.verticalBuffer, Ke.circularPathData.verticalLeftInnerExtent = Ke.circularPathData.verticalFullExtent + Ke.circularPathData.leftLargeArcRadius, Ke.circularPathData.verticalRightInnerExtent = Ke.circularPathData.verticalFullExtent + Ke.circularPathData.rightLargeArcRadius);
                            }
                            Ke.circularPathData.leftInnerExtent = Ke.circularPathData.sourceX + Ke.circularPathData.leftNodeBuffer, Ke.circularPathData.rightInnerExtent = Ke.circularPathData.targetX - Ke.circularPathData.rightNodeBuffer, Ke.circularPathData.leftFullExtent = Ke.circularPathData.sourceX + Ke.circularPathData.leftLargeArcRadius + Ke.circularPathData.leftNodeBuffer, Ke.circularPathData.rightFullExtent = Ke.circularPathData.targetX - Ke.circularPathData.rightLargeArcRadius - Ke.circularPathData.rightNodeBuffer;
                        }
                        if (Ke.circular) Ke.path = re(Ke);
                        else {
                            var Et = n.linkHorizontal().source(function(dt) {
                                var Ht = dt.source.x0 + (dt.source.x1 - dt.source.x0), $t = dt.y0;
                                return [
                                    Ht,
                                    $t
                                ];
                            }).target(function(dt) {
                                var Ht = dt.target.x0, $t = dt.y1;
                                return [
                                    Ht,
                                    $t
                                ];
                            });
                            Ke.path = Et(Ke);
                        }
                    });
                }
                function re(rt) {
                    var ot = "";
                    return rt.circularLinkType == "top" ? ot = "M" + rt.circularPathData.sourceX + " " + rt.circularPathData.sourceY + " L" + rt.circularPathData.leftInnerExtent + " " + rt.circularPathData.sourceY + " A" + rt.circularPathData.leftLargeArcRadius + " " + rt.circularPathData.leftSmallArcRadius + " 0 0 0 " + rt.circularPathData.leftFullExtent + " " + (rt.circularPathData.sourceY - rt.circularPathData.leftSmallArcRadius) + " L" + rt.circularPathData.leftFullExtent + " " + rt.circularPathData.verticalLeftInnerExtent + " A" + rt.circularPathData.leftLargeArcRadius + " " + rt.circularPathData.leftLargeArcRadius + " 0 0 0 " + rt.circularPathData.leftInnerExtent + " " + rt.circularPathData.verticalFullExtent + " L" + rt.circularPathData.rightInnerExtent + " " + rt.circularPathData.verticalFullExtent + " A" + rt.circularPathData.rightLargeArcRadius + " " + rt.circularPathData.rightLargeArcRadius + " 0 0 0 " + rt.circularPathData.rightFullExtent + " " + rt.circularPathData.verticalRightInnerExtent + " L" + rt.circularPathData.rightFullExtent + " " + (rt.circularPathData.targetY - rt.circularPathData.rightSmallArcRadius) + " A" + rt.circularPathData.rightLargeArcRadius + " " + rt.circularPathData.rightSmallArcRadius + " 0 0 0 " + rt.circularPathData.rightInnerExtent + " " + rt.circularPathData.targetY + " L" + rt.circularPathData.targetX + " " + rt.circularPathData.targetY : ot = "M" + rt.circularPathData.sourceX + " " + rt.circularPathData.sourceY + " L" + rt.circularPathData.leftInnerExtent + " " + rt.circularPathData.sourceY + " A" + rt.circularPathData.leftLargeArcRadius + " " + rt.circularPathData.leftSmallArcRadius + " 0 0 1 " + rt.circularPathData.leftFullExtent + " " + (rt.circularPathData.sourceY + rt.circularPathData.leftSmallArcRadius) + " L" + rt.circularPathData.leftFullExtent + " " + rt.circularPathData.verticalLeftInnerExtent + " A" + rt.circularPathData.leftLargeArcRadius + " " + rt.circularPathData.leftLargeArcRadius + " 0 0 1 " + rt.circularPathData.leftInnerExtent + " " + rt.circularPathData.verticalFullExtent + " L" + rt.circularPathData.rightInnerExtent + " " + rt.circularPathData.verticalFullExtent + " A" + rt.circularPathData.rightLargeArcRadius + " " + rt.circularPathData.rightLargeArcRadius + " 0 0 1 " + rt.circularPathData.rightFullExtent + " " + rt.circularPathData.verticalRightInnerExtent + " L" + rt.circularPathData.rightFullExtent + " " + (rt.circularPathData.targetY + rt.circularPathData.rightSmallArcRadius) + " A" + rt.circularPathData.rightLargeArcRadius + " " + rt.circularPathData.rightSmallArcRadius + " 0 0 1 " + rt.circularPathData.rightInnerExtent + " " + rt.circularPathData.targetY + " L" + rt.circularPathData.targetX + " " + rt.circularPathData.targetY, ot;
                }
                function ae(rt, ot) {
                    return ie(rt) == ie(ot) ? rt.circularLinkType == "bottom" ? Me(rt, ot) : _e(rt, ot) : ie(ot) - ie(rt);
                }
                function _e(rt, ot) {
                    return rt.y0 - ot.y0;
                }
                function Me(rt, ot) {
                    return ot.y0 - rt.y0;
                }
                function ke(rt, ot) {
                    return rt.y1 - ot.y1;
                }
                function ge(rt, ot) {
                    return ot.y1 - rt.y1;
                }
                function ie(rt) {
                    return rt.target.column - rt.source.column;
                }
                function Te(rt) {
                    return rt.target.x0 - rt.source.x1;
                }
                function Ee(rt, ot) {
                    var Rt = V(rt), kt = Te(ot) / Math.tan(Rt), Ct = nt(rt) == "up" ? rt.y1 + kt : rt.y1 - kt;
                    return Ct;
                }
                function Ae(rt, ot) {
                    var Rt = V(rt), kt = Te(ot) / Math.tan(Rt), Ct = nt(rt) == "up" ? rt.y1 - kt : rt.y1 + kt;
                    return Ct;
                }
                function ze(rt, ot, Rt, kt) {
                    rt.links.forEach(function(Ct) {
                        if (!Ct.circular && Ct.target.column - Ct.source.column > 1) {
                            var Yt = Ct.source.column + 1, xr = Ct.target.column - 1, er = 1, Ke = xr - Yt + 1;
                            for(er = 1; Yt <= xr; Yt++, er++)rt.nodes.forEach(function(xt) {
                                if (xt.column == Yt) {
                                    var bt = er / (Ke + 1), Lt = Math.pow(1 - bt, 3), St = 3 * bt * Math.pow(1 - bt, 2), Et = 3 * Math.pow(bt, 2) * (1 - bt), dt = Math.pow(bt, 3), Ht = Lt * Ct.y0 + St * Ct.y0 + Et * Ct.y1 + dt * Ct.y1, $t = Ht - Ct.width / 2, fr = Ht + Ct.width / 2, _r;
                                    $t > xt.y0 && $t < xt.y1 ? (_r = xt.y1 - $t + 10, _r = xt.circularLinkType == "bottom" ? _r : -_r, xt = me(xt, _r, ot, Rt), rt.nodes.forEach(function(Br) {
                                        C(Br, kt) == C(xt, kt) || Br.column != xt.column || Ce(xt, Br) && me(Br, _r, ot, Rt);
                                    })) : fr > xt.y0 && fr < xt.y1 ? (_r = fr - xt.y0 + 10, xt = me(xt, _r, ot, Rt), rt.nodes.forEach(function(Br) {
                                        C(Br, kt) == C(xt, kt) || Br.column != xt.column || Br.y0 < xt.y1 && Br.y1 > xt.y1 && me(Br, _r, ot, Rt);
                                    })) : $t < xt.y0 && fr > xt.y1 && (_r = fr - xt.y0 + 10, xt = me(xt, _r, ot, Rt), rt.nodes.forEach(function(Br) {
                                        C(Br, kt) == C(xt, kt) || Br.column != xt.column || Br.y0 < xt.y1 && Br.y1 > xt.y1 && me(Br, _r, ot, Rt);
                                    }));
                                }
                            });
                        }
                    });
                }
                function Ce(rt, ot) {
                    return rt.y0 > ot.y0 && rt.y0 < ot.y1 || rt.y1 > ot.y0 && rt.y1 < ot.y1 ? !0 : rt.y0 < ot.y0 && rt.y1 > ot.y1;
                }
                function me(rt, ot, Rt, kt) {
                    return rt.y0 + ot >= Rt && rt.y1 + ot <= kt && (rt.y0 = rt.y0 + ot, rt.y1 = rt.y1 + ot, rt.targetLinks.forEach(function(Ct) {
                        Ct.y1 = Ct.y1 + ot;
                    }), rt.sourceLinks.forEach(function(Ct) {
                        Ct.y0 = Ct.y0 + ot;
                    })), rt;
                }
                function Re(rt, ot, Rt, kt) {
                    rt.nodes.forEach(function(Ct) {
                        kt && Ct.y + (Ct.y1 - Ct.y0) > ot && (Ct.y = Ct.y - (Ct.y + (Ct.y1 - Ct.y0) - ot));
                        var Yt = rt.links.filter(function(Ke) {
                            return C(Ke.source, Rt) == C(Ct, Rt);
                        }), xr = Yt.length;
                        xr > 1 && Yt.sort(function(Ke, xt) {
                            if (!Ke.circular && !xt.circular) {
                                if (Ke.target.column == xt.target.column) return Ke.y1 - xt.y1;
                                if (Ge(Ke, xt)) {
                                    if (Ke.target.column > xt.target.column) {
                                        var bt = Ae(xt, Ke);
                                        return Ke.y1 - bt;
                                    }
                                    if (xt.target.column > Ke.target.column) {
                                        var Lt = Ae(Ke, xt);
                                        return Lt - xt.y1;
                                    }
                                } else return Ke.y1 - xt.y1;
                            }
                            if (Ke.circular && !xt.circular) return Ke.circularLinkType == "top" ? -1 : 1;
                            if (xt.circular && !Ke.circular) return xt.circularLinkType == "top" ? 1 : -1;
                            if (Ke.circular && xt.circular) return Ke.circularLinkType === xt.circularLinkType && Ke.circularLinkType == "top" ? Ke.target.column === xt.target.column ? Ke.target.y1 - xt.target.y1 : xt.target.column - Ke.target.column : Ke.circularLinkType === xt.circularLinkType && Ke.circularLinkType == "bottom" ? Ke.target.column === xt.target.column ? xt.target.y1 - Ke.target.y1 : Ke.target.column - xt.target.column : Ke.circularLinkType == "top" ? -1 : 1;
                        });
                        var er = Ct.y0;
                        Yt.forEach(function(Ke) {
                            Ke.y0 = er + Ke.width / 2, er = er + Ke.width;
                        }), Yt.forEach(function(Ke, xt) {
                            if (Ke.circularLinkType == "bottom") {
                                var bt = xt + 1, Lt = 0;
                                for(bt; bt < xr; bt++)Lt = Lt + Yt[bt].width;
                                Ke.y0 = Ct.y1 - Lt - Ke.width / 2;
                            }
                        });
                    });
                }
                function ce(rt, ot, Rt) {
                    rt.nodes.forEach(function(kt) {
                        var Ct = rt.links.filter(function(er) {
                            return C(er.target, Rt) == C(kt, Rt);
                        }), Yt = Ct.length;
                        Yt > 1 && Ct.sort(function(er, Ke) {
                            if (!er.circular && !Ke.circular) {
                                if (er.source.column == Ke.source.column) return er.y0 - Ke.y0;
                                if (Ge(er, Ke)) {
                                    if (Ke.source.column < er.source.column) {
                                        var xt = Ee(Ke, er);
                                        return er.y0 - xt;
                                    }
                                    if (er.source.column < Ke.source.column) {
                                        var bt = Ee(er, Ke);
                                        return bt - Ke.y0;
                                    }
                                } else return er.y0 - Ke.y0;
                            }
                            if (er.circular && !Ke.circular) return er.circularLinkType == "top" ? -1 : 1;
                            if (Ke.circular && !er.circular) return Ke.circularLinkType == "top" ? 1 : -1;
                            if (er.circular && Ke.circular) return er.circularLinkType === Ke.circularLinkType && er.circularLinkType == "top" ? er.source.column === Ke.source.column ? er.source.y1 - Ke.source.y1 : er.source.column - Ke.source.column : er.circularLinkType === Ke.circularLinkType && er.circularLinkType == "bottom" ? er.source.column === Ke.source.column ? er.source.y1 - Ke.source.y1 : Ke.source.column - er.source.column : er.circularLinkType == "top" ? -1 : 1;
                        });
                        var xr = kt.y0;
                        Ct.forEach(function(er) {
                            er.y1 = xr + er.width / 2, xr = xr + er.width;
                        }), Ct.forEach(function(er, Ke) {
                            if (er.circularLinkType == "bottom") {
                                var xt = Ke + 1, bt = 0;
                                for(xt; xt < Yt; xt++)bt = bt + Ct[xt].width;
                                er.y1 = kt.y1 - bt - er.width / 2;
                            }
                        });
                    });
                }
                function Ge(rt, ot) {
                    return nt(rt) == nt(ot);
                }
                function nt(rt) {
                    return rt.y0 - rt.y1 > 0 ? "up" : "down";
                }
                function ct(rt, ot) {
                    return C(rt.source, ot) == C(rt.target, ot);
                }
                function qt(rt, ot, Rt) {
                    var kt = rt.nodes, Ct = rt.links, Yt = !1, xr = !1;
                    if (Ct.forEach(function(St) {
                        St.circularLinkType == "top" ? Yt = !0 : St.circularLinkType == "bottom" && (xr = !0);
                    }), Yt == !1 || xr == !1) {
                        var er = t.min(kt, function(St) {
                            return St.y0;
                        }), Ke = t.max(kt, function(St) {
                            return St.y1;
                        }), xt = Ke - er, bt = Rt - ot, Lt = bt / xt;
                        kt.forEach(function(St) {
                            var Et = (St.y1 - St.y0) * Lt;
                            St.y0 = (St.y0 - er) * Lt, St.y1 = St.y0 + Et;
                        }), Ct.forEach(function(St) {
                            St.y0 = (St.y0 - er) * Lt, St.y1 = (St.y1 - er) * Lt, St.width = St.width * Lt;
                        });
                    }
                }
                e.sankeyCircular = T, e.sankeyCenter = u, e.sankeyLeft = o, e.sankeyRight = s, e.sankeyJustify = l, Object.defineProperty(e, "__esModule", {
                    value: !0
                });
            });
        });
        var IJ = ye((x_r, Pje)=>{
            "use strict";
            Pje.exports = {
                nodeTextOffsetHorizontal: 4,
                nodeTextOffsetVertical: 3,
                nodePadAcross: 10,
                sankeyIterations: 50,
                forceIterations: 5,
                forceTicksPerFrame: 10,
                duration: 500,
                ease: "linear",
                cn: {
                    sankey: "sankey",
                    sankeyLinks: "sankey-links",
                    sankeyLink: "sankey-link",
                    sankeyNodeSet: "sankey-node-set",
                    sankeyNode: "sankey-node",
                    nodeRect: "node-rect",
                    nodeLabel: "node-label"
                }
            };
        });
        var Gje = ye((b_r, Hje)=>{
            "use strict";
            var Ije = bje(), MWt = (R2(), B1(I2)).interpolateNumber, CA = xa(), Gk = Mje(), EWt = Lje(), pu = IJ(), LA = id(), aw = va(), kWt = ao(), p1 = Mr(), zJ = p1.strTranslate, CWt = p1.strRotate, FJ = Km(), jk = FJ.keyFun, b7 = FJ.repeat, Oje = FJ.unwrap, Rje = Pl(), LWt = ba(), Bje = Nh(), PWt = Bje.CAP_SHIFT, IWt = Bje.LINE_SPACING, RWt = 3;
            function DWt(e, t, r) {
                var n = Oje(t), i = n.trace, a = i.domain, o = i.orientation === "h", s = i.node.pad, l = i.node.thickness, u = {
                    justify: Gk.sankeyJustify,
                    left: Gk.sankeyLeft,
                    right: Gk.sankeyRight,
                    center: Gk.sankeyCenter
                }[i.node.align], c = e.width * (a.x[1] - a.x[0]), f = e.height * (a.y[1] - a.y[0]), h = n._nodes, d = n._links, v = n.circular, x;
                v ? x = EWt.sankeyCircular().circularLinkGap(0) : x = Gk.sankey(), x.iterations(pu.sankeyIterations).size(o ? [
                    c,
                    f
                ] : [
                    f,
                    c
                ]).nodeWidth(l).nodePadding(s).nodeId(function(V) {
                    return V.pointNumber;
                }).nodeAlign(u).nodes(h).links(d);
                var b = x();
                x.nodePadding() < s && p1.warn("node.pad was reduced to ", x.nodePadding(), " to fit within the figure.");
                var p, E, k;
                for(var A in n._groupLookup){
                    var L = parseInt(n._groupLookup[A]), _;
                    for(p = 0; p < b.nodes.length; p++)if (b.nodes[p].pointNumber === L) {
                        _ = b.nodes[p];
                        break;
                    }
                    if (_) {
                        var C = {
                            pointNumber: parseInt(A),
                            x0: _.x0,
                            x1: _.x1,
                            y0: _.y0,
                            y1: _.y1,
                            partOfGroup: !0,
                            sourceLinks: [],
                            targetLinks: []
                        };
                        b.nodes.unshift(C), _.childrenNodes.unshift(C);
                    }
                }
                function M() {
                    for(p = 0; p < b.nodes.length; p++){
                        var V = b.nodes[p], H = {}, X, G;
                        for(E = 0; E < V.targetLinks.length; E++)G = V.targetLinks[E], X = G.source.pointNumber + ":" + G.target.pointNumber, H.hasOwnProperty(X) || (H[X] = []), H[X].push(G);
                        var N = Object.keys(H);
                        for(E = 0; E < N.length; E++){
                            X = N[E];
                            var W = H[X], re = 0, ae = {};
                            for(k = 0; k < W.length; k++)G = W[k], ae[G.label] || (ae[G.label] = 0), ae[G.label] += G.value, re += G.value;
                            for(k = 0; k < W.length; k++)G = W[k], G.flow = {
                                value: re,
                                labelConcentration: ae[G.label] / re,
                                concentration: G.value / re,
                                links: W
                            }, G.concentrationscale && (G.color = LA(G.concentrationscale(G.flow.labelConcentration)));
                        }
                        var _e = 0;
                        for(E = 0; E < V.sourceLinks.length; E++)_e += V.sourceLinks[E].value;
                        for(E = 0; E < V.sourceLinks.length; E++)G = V.sourceLinks[E], G.concentrationOut = G.value / _e;
                        var Me = 0;
                        for(E = 0; E < V.targetLinks.length; E++)Me += V.targetLinks[E].value;
                        for(E = 0; E < V.targetLinks.length; E++)G = V.targetLinks[E], G.concenrationIn = G.value / Me;
                    }
                }
                M();
                function g(V) {
                    V.forEach(function(H) {
                        var X, G, N = 0, W = H.length, re;
                        for(H.sort(function(ae, _e) {
                            return ae.y0 - _e.y0;
                        }), re = 0; re < W; ++re)X = H[re], X.y0 >= N || (G = N - X.y0, G > 1e-6 && (X.y0 += G, X.y1 += G)), N = X.y1 + s;
                    });
                }
                function P(V) {
                    var H = V.map(function(_e, Me) {
                        return {
                            x0: _e.x0,
                            index: Me
                        };
                    }).sort(function(_e, Me) {
                        return _e.x0 - Me.x0;
                    }), X = [], G = -1, N, W = -1 / 0, re;
                    for(p = 0; p < H.length; p++){
                        var ae = V[H[p].index];
                        ae.x0 > W + l && (G += 1, N = ae.x0), W = ae.x0, X[G] || (X[G] = []), X[G].push(ae), re = N - ae.x0, ae.x0 += re, ae.x1 += re;
                    }
                    return X;
                }
                if (i.node.x.length && i.node.y.length) {
                    for(p = 0; p < Math.min(i.node.x.length, i.node.y.length, b.nodes.length); p++)if (i.node.x[p] && i.node.y[p]) {
                        var T = [
                            i.node.x[p] * c,
                            i.node.y[p] * f
                        ];
                        b.nodes[p].x0 = T[0] - l / 2, b.nodes[p].x1 = T[0] + l / 2;
                        var F = b.nodes[p].y1 - b.nodes[p].y0;
                        b.nodes[p].y0 = T[1] - F / 2, b.nodes[p].y1 = T[1] + F / 2;
                    }
                    if (i.arrangement === "snap") {
                        h = b.nodes;
                        var q = P(h);
                        g(q);
                    }
                    x.update(b);
                }
                return {
                    circular: v,
                    key: r,
                    trace: i,
                    guid: p1.randstr(),
                    horizontal: o,
                    width: c,
                    height: f,
                    nodePad: i.node.pad,
                    nodeLineColor: i.node.line.color,
                    nodeLineWidth: i.node.line.width,
                    linkLineColor: i.link.line.color,
                    linkLineWidth: i.link.line.width,
                    linkArrowLength: i.link.arrowlen,
                    valueFormat: i.valueformat,
                    valueSuffix: i.valuesuffix,
                    textFont: i.textfont,
                    translateX: a.x[0] * e.width + e.margin.l,
                    translateY: e.height - a.y[1] * e.height + e.margin.t,
                    dragParallel: o ? f : c,
                    dragPerpendicular: o ? c : f,
                    arrangement: i.arrangement,
                    sankey: x,
                    graph: b,
                    forceLayouts: {},
                    interactionState: {
                        dragInProgress: !1,
                        hovered: !1
                    }
                };
            }
            function zWt(e, t, r) {
                var n = LA(t.color), i = LA(t.hovercolor), a = t.source.label + "|" + t.target.label, o = a + "__" + r;
                return t.trace = e.trace, t.curveNumber = e.trace.index, {
                    circular: e.circular,
                    key: o,
                    traceId: e.key,
                    pointNumber: t.pointNumber,
                    link: t,
                    tinyColorHue: aw.tinyRGB(n),
                    tinyColorAlpha: n.getAlpha(),
                    tinyColorHoverHue: aw.tinyRGB(i),
                    tinyColorHoverAlpha: i.getAlpha(),
                    linkPath: qJ,
                    linkLineColor: e.linkLineColor,
                    linkLineWidth: e.linkLineWidth,
                    linkArrowLength: e.linkArrowLength,
                    valueFormat: e.valueFormat,
                    valueSuffix: e.valueSuffix,
                    sankey: e.sankey,
                    parent: e,
                    interactionState: e.interactionState,
                    flow: t.flow
                };
            }
            function FWt(e, t) {
                var r = "", n = e.width / 2, i = e.circularPathData, a = i.sourceX + i.verticalBuffer < i.targetX, o = i.rightFullExtent - i.rightLargeArcRadius - t <= i.leftFullExtent - n, s = Math.abs(i.rightFullExtent - i.leftFullExtent - n) < n;
                return e.circularLinkType === "top" ? (r = "M " + (i.targetX - t) + " " + (i.targetY + n) + " L " + (i.rightInnerExtent - t) + " " + (i.targetY + n) + "A " + (i.rightLargeArcRadius + n) + " " + (i.rightSmallArcRadius + n) + " 0 0 1 " + (i.rightFullExtent - n - t) + " " + (i.targetY - i.rightSmallArcRadius) + "L " + (i.rightFullExtent - n - t) + " " + i.verticalRightInnerExtent, a && o ? r += " A " + (i.rightLargeArcRadius + n) + " " + (i.rightLargeArcRadius + n) + " 0 0 1 " + (i.rightFullExtent + n - t - (i.rightLargeArcRadius - n)) + " " + (i.verticalRightInnerExtent - (i.rightLargeArcRadius + n)) + " L " + (i.rightFullExtent + n - (i.rightLargeArcRadius - n) - t) + " " + (i.verticalRightInnerExtent - (i.rightLargeArcRadius + n)) + " A " + (i.leftLargeArcRadius + n) + " " + (i.leftLargeArcRadius + n) + " 0 0 1 " + (i.leftFullExtent + n) + " " + i.verticalRightInnerExtent : a ? r += " A " + (i.rightLargeArcRadius - n) + " " + (i.rightLargeArcRadius - n) + " 0 0 0 " + (i.rightFullExtent - n - t - (i.rightLargeArcRadius - n)) + " " + (i.verticalRightInnerExtent - (i.rightLargeArcRadius - n)) + " L " + (i.leftFullExtent + n + (i.rightLargeArcRadius - n)) + " " + (i.verticalRightInnerExtent - (i.rightLargeArcRadius - n)) + " A " + (i.leftLargeArcRadius - n) + " " + (i.leftLargeArcRadius - n) + " 0 0 0 " + (i.leftFullExtent + n) + " " + i.verticalLeftInnerExtent : r += " A " + (i.rightLargeArcRadius + n) + " " + (i.rightLargeArcRadius + n) + " 0 0 1 " + (i.rightInnerExtent - t) + " " + (i.verticalFullExtent - n) + " L " + i.leftInnerExtent + " " + (i.verticalFullExtent - n) + " A " + (i.leftLargeArcRadius + n) + " " + (i.leftLargeArcRadius + n) + " 0 0 1 " + (i.leftFullExtent + n) + " " + i.verticalLeftInnerExtent, r += " L " + (i.leftFullExtent + n) + " " + (i.sourceY - i.leftSmallArcRadius) + " A " + (i.leftLargeArcRadius + n) + " " + (i.leftSmallArcRadius + n) + " 0 0 1 " + i.leftInnerExtent + " " + (i.sourceY + n) + " L " + i.sourceX + " " + (i.sourceY + n) + " L " + i.sourceX + " " + (i.sourceY - n) + " L " + i.leftInnerExtent + " " + (i.sourceY - n) + " A " + (i.leftLargeArcRadius - n) + " " + (i.leftSmallArcRadius - n) + " 0 0 0 " + (i.leftFullExtent - n) + " " + (i.sourceY - i.leftSmallArcRadius) + " L " + (i.leftFullExtent - n) + " " + i.verticalLeftInnerExtent, a && o ? r += " A " + (i.leftLargeArcRadius + n) + " " + (i.leftSmallArcRadius + n) + " 0 0 0 " + (i.leftFullExtent - n) + " " + (i.verticalFullExtent + n) + "L" + (i.rightFullExtent + n - t) + " " + (i.verticalFullExtent + n) + " A " + (i.leftLargeArcRadius + n) + " " + (i.leftSmallArcRadius + n) + " 0 0 0 " + (i.rightFullExtent + n - t) + " " + i.verticalRightInnerExtent : a ? r += " A " + (i.leftLargeArcRadius + n) + " " + (i.leftSmallArcRadius + n) + " 0 0 1 " + (i.leftFullExtent + n) + " " + (i.verticalFullExtent - n) + " L " + (i.rightFullExtent - n - t) + " " + (i.verticalFullExtent - n) + " A " + (i.leftLargeArcRadius + n) + " " + (i.leftSmallArcRadius + n) + " 0 0 1 " + (i.rightFullExtent + n - t) + " " + i.verticalRightInnerExtent : r += " A " + (i.leftLargeArcRadius - n) + " " + (i.leftLargeArcRadius - n) + " 0 0 0 " + i.leftInnerExtent + " " + (i.verticalFullExtent + n) + " L " + (i.rightInnerExtent - t) + " " + (i.verticalFullExtent + n) + " A " + (i.rightLargeArcRadius - n) + " " + (i.rightLargeArcRadius - n) + " 0 0 0 " + (i.rightFullExtent + n - t) + " " + i.verticalRightInnerExtent, r += " L " + (i.rightFullExtent + n - t) + " " + (i.targetY - i.rightSmallArcRadius) + " A " + (i.rightLargeArcRadius - n) + " " + (i.rightSmallArcRadius - n) + " 0 0 0 " + (i.rightInnerExtent - t) + " " + (i.targetY - n) + " L " + (i.targetX - t) + " " + (i.targetY - n) + (t > 0 ? " L " + i.targetX + " " + i.targetY : "") + "Z") : (r = "M " + (i.targetX - t) + " " + (i.targetY - n) + "  L " + (i.rightInnerExtent - t) + " " + (i.targetY - n) + " A " + (i.rightLargeArcRadius + n) + " " + (i.rightSmallArcRadius + n) + " 0 0 0 " + (i.rightFullExtent - n - t) + " " + (i.targetY + i.rightSmallArcRadius) + " L " + (i.rightFullExtent - n - t) + " " + i.verticalRightInnerExtent, a && o ? r += " A " + (i.rightLargeArcRadius + n) + " " + (i.rightLargeArcRadius + n) + " 0 0 0 " + (i.rightInnerExtent - n - t) + " " + (i.verticalFullExtent + n) + " L " + (i.rightFullExtent + n - t - (i.rightLargeArcRadius - n)) + " " + (i.verticalFullExtent + n) + " A " + (i.rightLargeArcRadius + n) + " " + (i.rightLargeArcRadius + n) + " 0 0 0 " + (i.leftFullExtent + n) + " " + i.verticalLeftInnerExtent : a ? r += " A " + (i.rightLargeArcRadius - n) + " " + (i.rightSmallArcRadius - n) + " 0 0 1 " + (i.rightFullExtent - t - n - (i.rightLargeArcRadius - n)) + " " + (i.verticalFullExtent - n) + " L " + (i.leftFullExtent + n + (i.rightLargeArcRadius - n)) + " " + (i.verticalFullExtent - n) + " A " + (i.rightLargeArcRadius - n) + " " + (i.rightSmallArcRadius - n) + " 0 0 1 " + (i.leftFullExtent + n) + " " + i.verticalLeftInnerExtent : r += " A " + (i.rightLargeArcRadius + n) + " " + (i.rightLargeArcRadius + n) + " 0 0 0 " + (i.rightInnerExtent - t) + " " + (i.verticalFullExtent + n) + " L " + i.leftInnerExtent + " " + (i.verticalFullExtent + n) + " A " + (i.leftLargeArcRadius + n) + " " + (i.leftLargeArcRadius + n) + " 0 0 0 " + (i.leftFullExtent + n) + " " + i.verticalLeftInnerExtent, r += " L " + (i.leftFullExtent + n) + " " + (i.sourceY + i.leftSmallArcRadius) + " A " + (i.leftLargeArcRadius + n) + " " + (i.leftSmallArcRadius + n) + " 0 0 0 " + i.leftInnerExtent + " " + (i.sourceY - n) + " L " + i.sourceX + " " + (i.sourceY - n) + " L " + i.sourceX + " " + (i.sourceY + n) + " L " + i.leftInnerExtent + " " + (i.sourceY + n) + " A " + (i.leftLargeArcRadius - n) + " " + (i.leftSmallArcRadius - n) + " 0 0 1 " + (i.leftFullExtent - n) + " " + (i.sourceY + i.leftSmallArcRadius) + " L " + (i.leftFullExtent - n) + " " + i.verticalLeftInnerExtent, a && o ? r += " A " + (i.rightLargeArcRadius - n) + " " + (i.rightSmallArcRadius - n) + " 0 0 1 " + (i.leftFullExtent - n - (i.rightLargeArcRadius - n)) + " " + (i.verticalFullExtent - n) + " L " + (i.rightFullExtent + n - t + (i.rightLargeArcRadius - n)) + " " + (i.verticalFullExtent - n) + " A " + (i.rightLargeArcRadius - n) + " " + (i.rightSmallArcRadius - n) + " 0 0 1 " + (i.rightFullExtent + n - t) + " " + i.verticalRightInnerExtent : a ? r += " A " + (i.rightLargeArcRadius + n) + " " + (i.rightLargeArcRadius + n) + " 0 0 0 " + (i.leftFullExtent + n) + " " + (i.verticalFullExtent + n) + " L " + (i.rightFullExtent - t - n) + " " + (i.verticalFullExtent + n) + " A " + (i.rightLargeArcRadius + n) + " " + (i.rightLargeArcRadius + n) + " 0 0 0 " + (i.rightFullExtent + n - t) + " " + i.verticalRightInnerExtent : r += " A " + (i.leftLargeArcRadius - n) + " " + (i.leftLargeArcRadius - n) + " 0 0 1 " + i.leftInnerExtent + " " + (i.verticalFullExtent - n) + " L " + (i.rightInnerExtent - t) + " " + (i.verticalFullExtent - n) + " A " + (i.rightLargeArcRadius - n) + " " + (i.rightLargeArcRadius - n) + " 0 0 1 " + (i.rightFullExtent + n - t) + " " + i.verticalRightInnerExtent, r += " L " + (i.rightFullExtent + n - t) + " " + (i.targetY + i.rightSmallArcRadius) + " A " + (i.rightLargeArcRadius - n) + " " + (i.rightSmallArcRadius - n) + " 0 0 1 " + (i.rightInnerExtent - t) + " " + (i.targetY + n) + " L " + (i.targetX - t) + " " + (i.targetY + n) + (t > 0 ? " L " + i.targetX + " " + i.targetY : "") + "Z"), r;
            }
            function qJ() {
                var e = .5;
                function t(r) {
                    var n = r.linkArrowLength;
                    if (r.link.circular) return FWt(r.link, n);
                    var i = Math.abs((r.link.target.x0 - r.link.source.x1) / 2);
                    n > i && (n = i);
                    var a = r.link.source.x1, o = r.link.target.x0 - n, s = MWt(a, o), l = s(e), u = s(1 - e), c = r.link.y0 - r.link.width / 2, f = r.link.y0 + r.link.width / 2, h = r.link.y1 - r.link.width / 2, d = r.link.y1 + r.link.width / 2, v = "M" + a + "," + c, x = "C" + l + "," + c + " " + u + "," + h + " " + o + "," + h, b = "C" + u + "," + d + " " + l + "," + f + " " + a + "," + f, p = n > 0 ? "L" + (o + n) + "," + (h + r.link.width / 2) : "";
                    return p += "L" + o + "," + d, v + x + p + b + "Z";
                }
                return t;
            }
            function qWt(e, t) {
                var r = LA(t.color), n = pu.nodePadAcross, i = e.nodePad / 2;
                t.dx = t.x1 - t.x0, t.dy = t.y1 - t.y0;
                var a = t.dx, o = Math.max(.5, t.dy), s = "node_" + t.pointNumber;
                return t.group && (s = p1.randstr()), t.trace = e.trace, t.curveNumber = e.trace.index, {
                    index: t.pointNumber,
                    key: s,
                    partOfGroup: t.partOfGroup || !1,
                    group: t.group,
                    traceId: e.key,
                    trace: e.trace,
                    node: t,
                    nodePad: e.nodePad,
                    nodeLineColor: e.nodeLineColor,
                    nodeLineWidth: e.nodeLineWidth,
                    textFont: e.textFont,
                    size: e.horizontal ? e.height : e.width,
                    visibleWidth: Math.ceil(a),
                    visibleHeight: o,
                    zoneX: -n,
                    zoneY: -i,
                    zoneWidth: a + 2 * n,
                    zoneHeight: o + 2 * i,
                    labelY: e.horizontal ? t.dy / 2 + 1 : t.dx / 2 + 1,
                    left: t.originalLayer === 1,
                    sizeAcross: e.width,
                    forceLayouts: e.forceLayouts,
                    horizontal: e.horizontal,
                    darkBackground: r.getBrightness() <= 128,
                    tinyColorHue: aw.tinyRGB(r),
                    tinyColorAlpha: r.getAlpha(),
                    valueFormat: e.valueFormat,
                    valueSuffix: e.valueSuffix,
                    sankey: e.sankey,
                    graph: e.graph,
                    arrangement: e.arrangement,
                    uniqueNodeLabelPathId: [
                        e.guid,
                        e.key,
                        s
                    ].join("_"),
                    interactionState: e.interactionState,
                    figure: e
                };
            }
            function DJ(e) {
                e.attr("transform", function(t) {
                    return zJ(t.node.x0.toFixed(3), t.node.y0.toFixed(3));
                });
            }
            function OWt(e) {
                e.call(DJ);
            }
            function Nje(e, t) {
                e.call(OWt), t.attr("d", qJ());
            }
            function Dje(e) {
                e.attr("width", function(t) {
                    return t.node.x1 - t.node.x0;
                }).attr("height", function(t) {
                    return t.visibleHeight;
                });
            }
            function RJ(e) {
                return e.link.width > 1 || e.linkLineWidth > 0;
            }
            function zje(e) {
                var t = zJ(e.translateX, e.translateY);
                return t + (e.horizontal ? "matrix(1 0 0 1 0 0)" : "matrix(0 1 1 0 0 0)");
            }
            function Fje(e, t, r) {
                e.on(".basic", null).on("mouseover.basic", function(n) {
                    !n.interactionState.dragInProgress && !n.partOfGroup && (r.hover(this, n, t), n.interactionState.hovered = [
                        this,
                        n
                    ]);
                }).on("mousemove.basic", function(n) {
                    !n.interactionState.dragInProgress && !n.partOfGroup && (r.follow(this, n), n.interactionState.hovered = [
                        this,
                        n
                    ]);
                }).on("mouseout.basic", function(n) {
                    !n.interactionState.dragInProgress && !n.partOfGroup && (r.unhover(this, n, t), n.interactionState.hovered = !1);
                }).on("click.basic", function(n) {
                    n.interactionState.hovered && (r.unhover(this, n, t), n.interactionState.hovered = !1), !n.interactionState.dragInProgress && !n.partOfGroup && r.select(this, n, t);
                });
            }
            function BWt(e, t, r, n) {
                var i = CA.behavior.drag().origin(function(a) {
                    return {
                        x: a.node.x0 + a.visibleWidth / 2,
                        y: a.node.y0 + a.visibleHeight / 2
                    };
                }).on("dragstart", function(a) {
                    if (a.arrangement !== "fixed" && (p1.ensureSingle(n._fullLayout._infolayer, "g", "dragcover", function(s) {
                        n._fullLayout._dragCover = s;
                    }), p1.raiseToTop(this), a.interactionState.dragInProgress = a.node, qje(a.node), a.interactionState.hovered && (r.nodeEvents.unhover.apply(0, a.interactionState.hovered), a.interactionState.hovered = !1), a.arrangement === "snap")) {
                        var o = a.traceId + "|" + a.key;
                        a.forceLayouts[o] ? a.forceLayouts[o].alpha(1) : NWt(e, o, a, n), UWt(e, t, a, o, n);
                    }
                }).on("drag", function(a) {
                    if (a.arrangement !== "fixed") {
                        var o = CA.event.x, s = CA.event.y;
                        a.arrangement === "snap" ? (a.node.x0 = o - a.visibleWidth / 2, a.node.x1 = o + a.visibleWidth / 2, a.node.y0 = s - a.visibleHeight / 2, a.node.y1 = s + a.visibleHeight / 2) : (a.arrangement === "freeform" && (a.node.x0 = o - a.visibleWidth / 2, a.node.x1 = o + a.visibleWidth / 2), s = Math.max(0, Math.min(a.size - a.visibleHeight / 2, s)), a.node.y0 = s - a.visibleHeight / 2, a.node.y1 = s + a.visibleHeight / 2), qje(a.node), a.arrangement !== "snap" && (a.sankey.update(a.graph), Nje(e.filter(Vje(a)), t));
                    }
                }).on("dragend", function(a) {
                    if (a.arrangement !== "fixed") {
                        a.interactionState.dragInProgress = !1;
                        for(var o = 0; o < a.node.childrenNodes.length; o++)a.node.childrenNodes[o].x = a.node.x, a.node.childrenNodes[o].y = a.node.y;
                        a.arrangement !== "snap" && Uje(a, n);
                    }
                });
                e.on(".drag", null).call(i);
            }
            function NWt(e, t, r, n) {
                GWt(r.graph.nodes);
                var i = r.graph.nodes.filter(function(a) {
                    return a.originalX === r.node.originalX;
                }).filter(function(a) {
                    return !a.partOfGroup;
                });
                r.forceLayouts[t] = Ije.forceSimulation(i).alphaDecay(0).force("collide", Ije.forceCollide().radius(function(a) {
                    return a.dy / 2 + r.nodePad / 2;
                }).strength(1).iterations(pu.forceIterations)).force("constrain", VWt(e, t, i, r, n)).stop();
            }
            function UWt(e, t, r, n, i) {
                window.requestAnimationFrame(function a() {
                    var o;
                    for(o = 0; o < pu.forceTicksPerFrame; o++)r.forceLayouts[n].tick();
                    var s = r.graph.nodes;
                    if (jWt(s), r.sankey.update(r.graph), Nje(e.filter(Vje(r)), t), r.forceLayouts[n].alpha() > 0) window.requestAnimationFrame(a);
                    else {
                        var l = r.node.originalX;
                        r.node.x0 = l - r.visibleWidth / 2, r.node.x1 = l + r.visibleWidth / 2, Uje(r, i);
                    }
                });
            }
            function VWt(e, t, r, n) {
                return function() {
                    for(var a = 0, o = 0; o < r.length; o++){
                        var s = r[o];
                        s === n.interactionState.dragInProgress ? (s.x = s.lastDraggedX, s.y = s.lastDraggedY) : (s.vx = (s.originalX - s.x) / pu.forceTicksPerFrame, s.y = Math.min(n.size - s.dy / 2, Math.max(s.dy / 2, s.y))), a = Math.max(a, Math.abs(s.vx), Math.abs(s.vy));
                    }
                    !n.interactionState.dragInProgress && a < .1 && n.forceLayouts[t].alpha() > 0 && n.forceLayouts[t].alpha(0);
                };
            }
            function Uje(e, t) {
                for(var r = [], n = [], i = 0; i < e.graph.nodes.length; i++){
                    var a = (e.graph.nodes[i].x0 + e.graph.nodes[i].x1) / 2, o = (e.graph.nodes[i].y0 + e.graph.nodes[i].y1) / 2;
                    r.push(a / e.figure.width), n.push(o / e.figure.height);
                }
                LWt.call("_guiRestyle", t, {
                    "node.x": [
                        r
                    ],
                    "node.y": [
                        n
                    ]
                }, e.trace.index).then(function() {
                    t._fullLayout._dragCover && t._fullLayout._dragCover.remove();
                });
            }
            function HWt(e) {
                var t = [], r;
                for(r = 0; r < e.length; r++)e[r].originalX = (e[r].x0 + e[r].x1) / 2, e[r].originalY = (e[r].y0 + e[r].y1) / 2, t.indexOf(e[r].originalX) === -1 && t.push(e[r].originalX);
                for(t.sort(function(n, i) {
                    return n - i;
                }), r = 0; r < e.length; r++)e[r].originalLayerIndex = t.indexOf(e[r].originalX), e[r].originalLayer = e[r].originalLayerIndex / (t.length - 1);
            }
            function qje(e) {
                e.lastDraggedX = e.x0 + e.dx / 2, e.lastDraggedY = e.y0 + e.dy / 2;
            }
            function Vje(e) {
                return function(t) {
                    return t.node.originalX === e.node.originalX;
                };
            }
            function GWt(e) {
                for(var t = 0; t < e.length; t++)e[t].y = (e[t].y0 + e[t].y1) / 2, e[t].x = (e[t].x0 + e[t].x1) / 2;
            }
            function jWt(e) {
                for(var t = 0; t < e.length; t++)e[t].y0 = e[t].y - e[t].dy / 2, e[t].y1 = e[t].y0 + e[t].dy, e[t].x0 = e[t].x - e[t].dx / 2, e[t].x1 = e[t].x0 + e[t].dx;
            }
            Hje.exports = function(e, t, r, n, i) {
                var a = e._context.staticPlot, o = !1;
                p1.ensureSingle(e._fullLayout._infolayer, "g", "first-render", function() {
                    o = !0;
                });
                var s = e._fullLayout._dragCover, l = r.filter(function(b) {
                    return Oje(b).trace.visible;
                }).map(DWt.bind(null, n)), u = t.selectAll("." + pu.cn.sankey).data(l, jk);
                u.exit().remove(), u.enter().append("g").classed(pu.cn.sankey, !0).style("box-sizing", "content-box").style("position", "absolute").style("left", 0).style("shape-rendering", "geometricPrecision").style("pointer-events", a ? "none" : "auto").attr("transform", zje), u.each(function(b, p) {
                    e._fullData[p]._sankey = b;
                    var E = "bgsankey-" + b.trace.uid + "-" + p;
                    p1.ensureSingle(e._fullLayout._draggers, "rect", E), e._fullData[p]._bgRect = CA.select("." + E), e._fullData[p]._bgRect.style("pointer-events", a ? "none" : "all").attr("width", b.width).attr("height", b.height).attr("x", b.translateX).attr("y", b.translateY).classed("bgsankey", !0).style({
                        fill: "transparent",
                        "stroke-width": 0
                    });
                }), u.transition().ease(pu.ease).duration(pu.duration).attr("transform", zje);
                var c = u.selectAll("." + pu.cn.sankeyLinks).data(b7, jk);
                c.enter().append("g").classed(pu.cn.sankeyLinks, !0).style("fill", "none");
                var f = c.selectAll("." + pu.cn.sankeyLink).data(function(b) {
                    var p = b.graph.links;
                    return p.filter(function(E) {
                        return E.value;
                    }).map(zWt.bind(null, b));
                }, jk);
                f.enter().append("path").classed(pu.cn.sankeyLink, !0).call(Fje, u, i.linkEvents), f.style("stroke", function(b) {
                    return RJ(b) ? aw.tinyRGB(LA(b.linkLineColor)) : b.tinyColorHue;
                }).style("stroke-opacity", function(b) {
                    return RJ(b) ? aw.opacity(b.linkLineColor) : b.tinyColorAlpha;
                }).style("fill", function(b) {
                    return b.tinyColorHue;
                }).style("fill-opacity", function(b) {
                    return b.tinyColorAlpha;
                }).style("stroke-width", function(b) {
                    return RJ(b) ? b.linkLineWidth : 1;
                }).attr("d", qJ()), f.style("opacity", function() {
                    return e._context.staticPlot || o || s ? 1 : 0;
                }).transition().ease(pu.ease).duration(pu.duration).style("opacity", 1), f.exit().transition().ease(pu.ease).duration(pu.duration).style("opacity", 0).remove();
                var h = u.selectAll("." + pu.cn.sankeyNodeSet).data(b7, jk);
                h.enter().append("g").classed(pu.cn.sankeyNodeSet, !0), h.style("cursor", function(b) {
                    switch(b.arrangement){
                        case "fixed":
                            return "default";
                        case "perpendicular":
                            return "ns-resize";
                        default:
                            return "move";
                    }
                });
                var d = h.selectAll("." + pu.cn.sankeyNode).data(function(b) {
                    var p = b.graph.nodes;
                    return HWt(p), p.map(qWt.bind(null, b));
                }, jk);
                d.enter().append("g").classed(pu.cn.sankeyNode, !0).call(DJ).style("opacity", function(b) {
                    return (e._context.staticPlot || o) && !b.partOfGroup ? 1 : 0;
                }), d.call(Fje, u, i.nodeEvents).call(BWt, f, i, e), d.transition().ease(pu.ease).duration(pu.duration).call(DJ).style("opacity", function(b) {
                    return b.partOfGroup ? 0 : 1;
                }), d.exit().transition().ease(pu.ease).duration(pu.duration).style("opacity", 0).remove();
                var v = d.selectAll("." + pu.cn.nodeRect).data(b7);
                v.enter().append("rect").classed(pu.cn.nodeRect, !0).call(Dje), v.style("stroke-width", function(b) {
                    return b.nodeLineWidth;
                }).style("stroke", function(b) {
                    return aw.tinyRGB(LA(b.nodeLineColor));
                }).style("stroke-opacity", function(b) {
                    return aw.opacity(b.nodeLineColor);
                }).style("fill", function(b) {
                    return b.tinyColorHue;
                }).style("fill-opacity", function(b) {
                    return b.tinyColorAlpha;
                }), v.transition().ease(pu.ease).duration(pu.duration).call(Dje);
                var x = d.selectAll("." + pu.cn.nodeLabel).data(b7);
                x.enter().append("text").classed(pu.cn.nodeLabel, !0).style("cursor", "default"), x.attr("data-notex", 1).text(function(b) {
                    return b.node.label;
                }).each(function(b) {
                    var p = CA.select(this);
                    kWt.font(p, b.textFont), Rje.convertToTspans(p, e);
                }).attr("text-anchor", function(b) {
                    return b.horizontal && b.left ? "end" : "start";
                }).attr("transform", function(b) {
                    var p = CA.select(this), E = Rje.lineCount(p), k = b.textFont.size * ((E - 1) * IWt - PWt), A = b.nodeLineWidth / 2 + RWt, L = ((b.horizontal ? b.visibleHeight : b.visibleWidth) - k) / 2;
                    b.horizontal && (b.left ? A = -A : A += b.visibleWidth);
                    var _ = b.horizontal ? "" : "scale(-1,1)" + CWt(90);
                    return zJ(b.horizontal ? A : L, b.horizontal ? L : A) + _;
                }), x.transition().ease(pu.ease).duration(pu.duration);
            };
        });
        var NJ = ye((w_r, Qje)=>{
            "use strict";
            var Zv = xa(), BJ = Mr(), w7 = BJ.numberFormat, WWt = Gje(), PA = Nc(), ZWt = va(), Sx = IJ().cn, Wk = BJ._;
            function jje(e) {
                return e !== "";
            }
            function IA(e, t) {
                return e.filter(function(r) {
                    return r.key === t.traceId;
                });
            }
            function Wje(e, t) {
                Zv.select(e).select("path").style("fill-opacity", t), Zv.select(e).select("rect").style("fill-opacity", t);
            }
            function Zje(e) {
                Zv.select(e).select("text.name").style("fill", "black");
            }
            function Xje(e) {
                return function(t) {
                    return e.node.sourceLinks.indexOf(t.link) !== -1 || e.node.targetLinks.indexOf(t.link) !== -1;
                };
            }
            function Yje(e) {
                return function(t) {
                    return t.node.sourceLinks.indexOf(e.link) !== -1 || t.node.targetLinks.indexOf(e.link) !== -1;
                };
            }
            function Kje(e, t, r) {
                t && r && IA(r, t).selectAll("." + Sx.sankeyLink).filter(Xje(t)).call(Jje.bind(0, t, r, !1));
            }
            function OJ(e, t, r) {
                t && r && IA(r, t).selectAll("." + Sx.sankeyLink).filter(Xje(t)).call($je.bind(0, t, r, !1));
            }
            function Jje(e, t, r, n) {
                n.style("fill", function(i) {
                    if (!i.link.concentrationscale) return i.tinyColorHoverHue;
                }).style("fill-opacity", function(i) {
                    if (!i.link.concentrationscale) return i.tinyColorHoverAlpha;
                }), n.each(function(i) {
                    var a = i.link.label;
                    a !== "" && IA(t, e).selectAll("." + Sx.sankeyLink).filter(function(o) {
                        return o.link.label === a;
                    }).style("fill", function(o) {
                        if (!o.link.concentrationscale) return o.tinyColorHoverHue;
                    }).style("fill-opacity", function(o) {
                        if (!o.link.concentrationscale) return o.tinyColorHoverAlpha;
                    });
                }), r && IA(t, e).selectAll("." + Sx.sankeyNode).filter(Yje(e)).call(Kje);
            }
            function $je(e, t, r, n) {
                n.style("fill", function(i) {
                    return i.tinyColorHue;
                }).style("fill-opacity", function(i) {
                    return i.tinyColorAlpha;
                }), n.each(function(i) {
                    var a = i.link.label;
                    a !== "" && IA(t, e).selectAll("." + Sx.sankeyLink).filter(function(o) {
                        return o.link.label === a;
                    }).style("fill", function(o) {
                        return o.tinyColorHue;
                    }).style("fill-opacity", function(o) {
                        return o.tinyColorAlpha;
                    });
                }), r && IA(t, e).selectAll(Sx.sankeyNode).filter(Yje(e)).call(OJ);
            }
            function lf(e, t) {
                var r = e.hoverlabel || {}, n = BJ.nestedProperty(r, t).get();
                return Array.isArray(n) ? !1 : n;
            }
            Qje.exports = function(t, r) {
                for(var n = t._fullLayout, i = n._paper, a = n._size, o = 0; o < t._fullData.length; o++)if (t._fullData[o].visible && t._fullData[o].type === Sx.sankey && !t._fullData[o]._viewInitial) {
                    var s = t._fullData[o].node;
                    t._fullData[o]._viewInitial = {
                        node: {
                            groups: s.groups.slice(),
                            x: s.x.slice(),
                            y: s.y.slice()
                        }
                    };
                }
                var l = function(L, _) {
                    var C = _.link;
                    C.originalEvent = Zv.event, t._hoverdata = [
                        C
                    ], PA.click(t, {
                        target: !0
                    });
                }, u = function(L, _, C) {
                    t._fullLayout.hovermode !== !1 && (Zv.select(L).call(Jje.bind(0, _, C, !0)), _.link.trace.link.hoverinfo !== "skip" && (_.link.fullData = _.link.trace, t.emit("plotly_hover", {
                        event: Zv.event,
                        points: [
                            _.link
                        ]
                    })));
                }, c = Wk(t, "source:") + " ", f = Wk(t, "target:") + " ", h = Wk(t, "concentration:") + " ", d = Wk(t, "incoming flow count:") + " ", v = Wk(t, "outgoing flow count:") + " ", x = function(L, _) {
                    if (t._fullLayout.hovermode === !1) return;
                    var C = _.link.trace.link;
                    if (C.hoverinfo === "none" || C.hoverinfo === "skip") return;
                    var M = [];
                    function g(X) {
                        var G, N;
                        X.circular ? (G = (X.circularPathData.leftInnerExtent + X.circularPathData.rightInnerExtent) / 2, N = X.circularPathData.verticalFullExtent) : (G = (X.source.x1 + X.target.x0) / 2, N = (X.y0 + X.y1) / 2);
                        var W = [
                            G,
                            N
                        ];
                        return X.trace.orientation === "v" && W.reverse(), W[0] += _.parent.translateX, W[1] += _.parent.translateY, W;
                    }
                    for(var P = 0, T = 0; T < _.flow.links.length; T++){
                        var F = _.flow.links[T];
                        if (!(t._fullLayout.hovermode === "closest" && _.link.pointNumber !== F.pointNumber)) {
                            _.link.pointNumber === F.pointNumber && (P = T), F.fullData = F.trace, C = _.link.trace.link;
                            var q = g(F), V = {
                                valueLabel: w7(_.valueFormat)(F.value) + _.valueSuffix
                            };
                            M.push({
                                x: q[0],
                                y: q[1],
                                name: V.valueLabel,
                                text: [
                                    F.label || "",
                                    c + F.source.label,
                                    f + F.target.label,
                                    F.concentrationscale ? h + w7("%0.2f")(F.flow.labelConcentration) : ""
                                ].filter(jje).join("<br>"),
                                color: lf(C, "bgcolor") || ZWt.addOpacity(F.color, 1),
                                borderColor: lf(C, "bordercolor"),
                                fontFamily: lf(C, "font.family"),
                                fontSize: lf(C, "font.size"),
                                fontColor: lf(C, "font.color"),
                                fontWeight: lf(C, "font.weight"),
                                fontStyle: lf(C, "font.style"),
                                fontVariant: lf(C, "font.variant"),
                                fontTextcase: lf(C, "font.textcase"),
                                fontLineposition: lf(C, "font.lineposition"),
                                fontShadow: lf(C, "font.shadow"),
                                nameLength: lf(C, "namelength"),
                                textAlign: lf(C, "align"),
                                idealAlign: Zv.event.x < q[0] ? "right" : "left",
                                hovertemplate: C.hovertemplate,
                                hovertemplateLabels: V,
                                eventData: [
                                    F
                                ]
                            });
                        }
                    }
                    var H = PA.loneHover(M, {
                        container: n._hoverlayer.node(),
                        outerContainer: n._paper.node(),
                        gd: t,
                        anchorIndex: P
                    });
                    H.each(function() {
                        var X = this;
                        _.link.concentrationscale || Wje(X, .65), Zje(X);
                    });
                }, b = function(L, _, C) {
                    t._fullLayout.hovermode !== !1 && (Zv.select(L).call($je.bind(0, _, C, !0)), _.link.trace.link.hoverinfo !== "skip" && (_.link.fullData = _.link.trace, t.emit("plotly_unhover", {
                        event: Zv.event,
                        points: [
                            _.link
                        ]
                    })), PA.loneUnhover(n._hoverlayer.node()));
                }, p = function(L, _, C) {
                    var M = _.node;
                    M.originalEvent = Zv.event, t._hoverdata = [
                        M
                    ], Zv.select(L).call(OJ, _, C), PA.click(t, {
                        target: !0
                    });
                }, E = function(L, _, C) {
                    t._fullLayout.hovermode !== !1 && (Zv.select(L).call(Kje, _, C), _.node.trace.node.hoverinfo !== "skip" && (_.node.fullData = _.node.trace, t.emit("plotly_hover", {
                        event: Zv.event,
                        points: [
                            _.node
                        ]
                    })));
                }, k = function(L, _) {
                    if (t._fullLayout.hovermode !== !1) {
                        var C = _.node.trace.node;
                        if (!(C.hoverinfo === "none" || C.hoverinfo === "skip")) {
                            var M = Zv.select(L).select("." + Sx.nodeRect), g = t._fullLayout._paperdiv.node().getBoundingClientRect(), P = M.node().getBoundingClientRect(), T = P.left - 2 - g.left, F = P.right + 2 - g.left, q = P.top + P.height / 4 - g.top, V = {
                                valueLabel: w7(_.valueFormat)(_.node.value) + _.valueSuffix
                            };
                            _.node.fullData = _.node.trace, t._fullLayout._calcInverseTransform(t);
                            var H = t._fullLayout._invScaleX, X = t._fullLayout._invScaleY, G = PA.loneHover({
                                x0: H * T,
                                x1: H * F,
                                y: X * q,
                                name: w7(_.valueFormat)(_.node.value) + _.valueSuffix,
                                text: [
                                    _.node.label,
                                    d + _.node.targetLinks.length,
                                    v + _.node.sourceLinks.length
                                ].filter(jje).join("<br>"),
                                color: lf(C, "bgcolor") || _.tinyColorHue,
                                borderColor: lf(C, "bordercolor"),
                                fontFamily: lf(C, "font.family"),
                                fontSize: lf(C, "font.size"),
                                fontColor: lf(C, "font.color"),
                                fontWeight: lf(C, "font.weight"),
                                fontStyle: lf(C, "font.style"),
                                fontVariant: lf(C, "font.variant"),
                                fontTextcase: lf(C, "font.textcase"),
                                fontLineposition: lf(C, "font.lineposition"),
                                fontShadow: lf(C, "font.shadow"),
                                nameLength: lf(C, "namelength"),
                                textAlign: lf(C, "align"),
                                idealAlign: "left",
                                hovertemplate: C.hovertemplate,
                                hovertemplateLabels: V,
                                eventData: [
                                    _.node
                                ]
                            }, {
                                container: n._hoverlayer.node(),
                                outerContainer: n._paper.node(),
                                gd: t
                            });
                            Wje(G, .85), Zje(G);
                        }
                    }
                }, A = function(L, _, C) {
                    t._fullLayout.hovermode !== !1 && (Zv.select(L).call(OJ, _, C), _.node.trace.node.hoverinfo !== "skip" && (_.node.fullData = _.node.trace, t.emit("plotly_unhover", {
                        event: Zv.event,
                        points: [
                            _.node
                        ]
                    })), PA.loneUnhover(n._hoverlayer.node()));
                };
                WWt(t, i, r, {
                    width: a.w,
                    height: a.h,
                    margin: {
                        t: a.t,
                        r: a.r,
                        b: a.b,
                        l: a.l
                    }
                }, {
                    linkEvents: {
                        hover: u,
                        follow: x,
                        unhover: b,
                        select: l
                    },
                    nodeEvents: {
                        hover: E,
                        follow: k,
                        unhover: A,
                        select: p
                    }
                });
            };
        });
        var eWe = ye((ow)=>{
            "use strict";
            var XWt = Bu().overrideAll, YWt = kd().getModuleCalcData, KWt = NJ(), JWt = N1(), $Wt = Tg(), QWt = gv(), eZt = wf().prepSelect, UJ = Mr(), tZt = ba(), T7 = "sankey";
            ow.name = T7;
            ow.baseLayoutAttrOverrides = XWt({
                hoverlabel: JWt.hoverlabel
            }, "plot", "nested");
            ow.plot = function(e) {
                var t = YWt(e.calcdata, T7)[0];
                KWt(e, t), ow.updateFx(e);
            };
            ow.clean = function(e, t, r, n) {
                var i = n._has && n._has(T7), a = t._has && t._has(T7);
                i && !a && (n._paperdiv.selectAll(".sankey").remove(), n._paperdiv.selectAll(".bgsankey").remove());
            };
            ow.updateFx = function(e) {
                for(var t = 0; t < e._fullData.length; t++)rZt(e, t);
            };
            function rZt(e, t) {
                var r = e._fullData[t], n = e._fullLayout, i = n.dragmode, a = n.dragmode === "pan" ? "move" : "crosshair", o = r._bgRect;
                if (o && !(i === "pan" || i === "zoom")) {
                    $Wt(o, a);
                    var s = {
                        _id: "x",
                        c2p: UJ.identity,
                        _offset: r._sankey.translateX,
                        _length: r._sankey.width
                    }, l = {
                        _id: "y",
                        c2p: UJ.identity,
                        _offset: r._sankey.translateY,
                        _length: r._sankey.height
                    }, u = {
                        gd: e,
                        element: o.node(),
                        plotinfo: {
                            id: t,
                            xaxis: s,
                            yaxis: l,
                            fillRangeItems: UJ.noop
                        },
                        subplot: t,
                        xaxes: [
                            s
                        ],
                        yaxes: [
                            l
                        ],
                        doneFnCompleted: function(c) {
                            var f = e._fullData[t], h, d = f.node.groups.slice(), v = [];
                            function x(k) {
                                for(var A = f._sankey.graph.nodes, L = 0; L < A.length; L++)if (A[L].pointNumber === k) return A[L];
                            }
                            for(var b = 0; b < c.length; b++){
                                var p = x(c[b].pointNumber);
                                if (p) {
                                    if (p.group) {
                                        for(var E = 0; E < p.childrenNodes.length; E++)v.push(p.childrenNodes[E].pointNumber);
                                        d[p.pointNumber - f.node._count] = !1;
                                    } else v.push(p.pointNumber);
                                }
                            }
                            h = d.filter(Boolean).concat([
                                v
                            ]), tZt.call("_guiRestyle", e, {
                                "node.groups": [
                                    h
                                ]
                            }, t);
                        }
                    };
                    u.prepFn = function(c, f, h) {
                        eZt(c, f, h, u, i);
                    }, QWt.init(u);
                }
            }
        });
        var rWe = ye((A_r, tWe)=>{
            "use strict";
            tWe.exports = function(t, r) {
                for(var n = t.cd, i = [], a = n[0].trace, o = a._sankey.graph.nodes, s = 0; s < o.length; s++){
                    var l = o[s];
                    if (!l.partOfGroup) {
                        var u = [
                            (l.x0 + l.x1) / 2,
                            (l.y0 + l.y1) / 2
                        ];
                        a.orientation === "v" && u.reverse(), r && r.contains(u, !1, s, t) && i.push({
                            pointNumber: l.pointNumber
                        });
                    }
                }
                return i;
            };
        });
        var nWe = ye((S_r, iWe)=>{
            "use strict";
            iWe.exports = {
                attributes: CJ(),
                supplyDefaults: sje(),
                calc: hje(),
                plot: NJ(),
                moduleType: "trace",
                name: "sankey",
                basePlotModule: eWe(),
                selectPoints: rWe(),
                categories: [
                    "noOpacity"
                ],
                meta: {}
            };
        });
        var oWe = ye((M_r, aWe)=>{
            "use strict";
            aWe.exports = nWe();
        });
        var lWe = ye((RA)=>{
            "use strict";
            var sWe = Xu();
            RA.name = "indicator";
            RA.plot = function(e, t, r, n) {
                sWe.plotBasePlot(RA.name, e, t, r, n);
            };
            RA.clean = function(e, t, r, n) {
                sWe.cleanBasePlot(RA.name, e, t, r, n);
            };
        });
        var HJ = ye((k_r, vWe)=>{
            "use strict";
            var Mx = no().extendFlat, cWe = no().extendDeep, iZt = Bu().overrideAll, fWe = Su(), hWe = dh(), nZt = Ju().attributes, Sf = Cd(), aZt = Vs().templatedArray, A7 = HT(), uWe = Oc().descriptionOnlyNumbers, VJ = fWe({
                editType: "plot",
                colorEditType: "plot"
            }), Zk = {
                color: {
                    valType: "color",
                    editType: "plot"
                },
                line: {
                    color: {
                        valType: "color",
                        dflt: hWe.defaultLine,
                        editType: "plot"
                    },
                    width: {
                        valType: "number",
                        min: 0,
                        dflt: 0,
                        editType: "plot"
                    },
                    editType: "calc"
                },
                thickness: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 1,
                    editType: "plot"
                },
                editType: "calc"
            }, dWe = {
                valType: "info_array",
                items: [
                    {
                        valType: "number",
                        editType: "plot"
                    },
                    {
                        valType: "number",
                        editType: "plot"
                    }
                ],
                editType: "plot"
            }, oZt = aZt("step", cWe({}, Zk, {
                range: dWe
            }));
            vWe.exports = {
                mode: {
                    valType: "flaglist",
                    editType: "calc",
                    flags: [
                        "number",
                        "delta",
                        "gauge"
                    ],
                    dflt: "number"
                },
                value: {
                    valType: "number",
                    editType: "calc",
                    anim: !0
                },
                align: {
                    valType: "enumerated",
                    values: [
                        "left",
                        "center",
                        "right"
                    ],
                    editType: "plot"
                },
                domain: nZt({
                    name: "indicator",
                    trace: !0,
                    editType: "calc"
                }),
                title: {
                    text: {
                        valType: "string",
                        editType: "plot"
                    },
                    align: {
                        valType: "enumerated",
                        values: [
                            "left",
                            "center",
                            "right"
                        ],
                        editType: "plot"
                    },
                    font: Mx({}, VJ, {}),
                    editType: "plot"
                },
                number: {
                    valueformat: {
                        valType: "string",
                        dflt: "",
                        editType: "plot",
                        description: uWe("value")
                    },
                    font: Mx({}, VJ, {}),
                    prefix: {
                        valType: "string",
                        dflt: "",
                        editType: "plot"
                    },
                    suffix: {
                        valType: "string",
                        dflt: "",
                        editType: "plot"
                    },
                    editType: "plot"
                },
                delta: {
                    reference: {
                        valType: "number",
                        editType: "calc"
                    },
                    position: {
                        valType: "enumerated",
                        values: [
                            "top",
                            "bottom",
                            "left",
                            "right"
                        ],
                        dflt: "bottom",
                        editType: "plot"
                    },
                    relative: {
                        valType: "boolean",
                        editType: "plot",
                        dflt: !1
                    },
                    valueformat: {
                        valType: "string",
                        editType: "plot",
                        description: uWe("value")
                    },
                    increasing: {
                        symbol: {
                            valType: "string",
                            dflt: A7.INCREASING.SYMBOL,
                            editType: "plot"
                        },
                        color: {
                            valType: "color",
                            dflt: A7.INCREASING.COLOR,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    decreasing: {
                        symbol: {
                            valType: "string",
                            dflt: A7.DECREASING.SYMBOL,
                            editType: "plot"
                        },
                        color: {
                            valType: "color",
                            dflt: A7.DECREASING.COLOR,
                            editType: "plot"
                        },
                        editType: "plot"
                    },
                    font: Mx({}, VJ, {}),
                    prefix: {
                        valType: "string",
                        dflt: "",
                        editType: "plot"
                    },
                    suffix: {
                        valType: "string",
                        dflt: "",
                        editType: "plot"
                    },
                    editType: "calc"
                },
                gauge: {
                    shape: {
                        valType: "enumerated",
                        editType: "plot",
                        dflt: "angular",
                        values: [
                            "angular",
                            "bullet"
                        ]
                    },
                    bar: cWe({}, Zk, {
                        color: {
                            dflt: "green"
                        }
                    }),
                    bgcolor: {
                        valType: "color",
                        editType: "plot"
                    },
                    bordercolor: {
                        valType: "color",
                        dflt: hWe.defaultLine,
                        editType: "plot"
                    },
                    borderwidth: {
                        valType: "number",
                        min: 0,
                        dflt: 1,
                        editType: "plot"
                    },
                    axis: iZt({
                        range: dWe,
                        visible: Mx({}, Sf.visible, {
                            dflt: !0
                        }),
                        tickmode: Sf.minor.tickmode,
                        nticks: Sf.nticks,
                        tick0: Sf.tick0,
                        dtick: Sf.dtick,
                        tickvals: Sf.tickvals,
                        ticktext: Sf.ticktext,
                        ticks: Mx({}, Sf.ticks, {
                            dflt: "outside"
                        }),
                        ticklen: Sf.ticklen,
                        tickwidth: Sf.tickwidth,
                        tickcolor: Sf.tickcolor,
                        ticklabelstep: Sf.ticklabelstep,
                        showticklabels: Sf.showticklabels,
                        labelalias: Sf.labelalias,
                        tickfont: fWe({}),
                        tickangle: Sf.tickangle,
                        tickformat: Sf.tickformat,
                        tickformatstops: Sf.tickformatstops,
                        tickprefix: Sf.tickprefix,
                        showtickprefix: Sf.showtickprefix,
                        ticksuffix: Sf.ticksuffix,
                        showticksuffix: Sf.showticksuffix,
                        separatethousands: Sf.separatethousands,
                        exponentformat: Sf.exponentformat,
                        minexponent: Sf.minexponent,
                        showexponent: Sf.showexponent,
                        editType: "plot"
                    }, "plot"),
                    steps: oZt,
                    threshold: {
                        line: {
                            color: Mx({}, Zk.line.color, {}),
                            width: Mx({}, Zk.line.width, {
                                dflt: 1
                            }),
                            editType: "plot"
                        },
                        thickness: Mx({}, Zk.thickness, {
                            dflt: .85
                        }),
                        value: {
                            valType: "number",
                            editType: "calc",
                            dflt: !1
                        },
                        editType: "plot"
                    },
                    editType: "plot"
                }
            };
        });
        var GJ = ye((C_r, pWe)=>{
            "use strict";
            pWe.exports = {
                defaultNumberFontSize: 80,
                bulletNumberDomainSize: .25,
                bulletPadding: .025,
                innerRadius: .75,
                valueThickness: .5,
                titlePadding: 5,
                horizontalPadding: 10
            };
        });
        var yWe = ye((L_r, mWe)=>{
            "use strict";
            var ey = Mr(), M7 = HJ(), sZt = Ju().defaults, gWe = Vs(), lZt = Zd(), S7 = GJ(), uZt = xb(), cZt = T3(), fZt = t_(), hZt = r_();
            function dZt(e, t, r, n) {
                function i(_, C) {
                    return ey.coerce(e, t, M7, _, C);
                }
                sZt(t, n, i), i("mode"), t._hasNumber = t.mode.indexOf("number") !== -1, t._hasDelta = t.mode.indexOf("delta") !== -1, t._hasGauge = t.mode.indexOf("gauge") !== -1;
                var a = i("value");
                t._range = [
                    0,
                    typeof a == "number" ? 1.5 * a : 1
                ];
                var o = new Array(2), s;
                if (t._hasNumber) {
                    i("number.valueformat");
                    var l = ey.extendFlat({}, n.font);
                    l.size = void 0, ey.coerceFont(i, "number.font", l), t.number.font.size === void 0 && (t.number.font.size = S7.defaultNumberFontSize, o[0] = !0), i("number.prefix"), i("number.suffix"), s = t.number.font.size;
                }
                var u;
                if (t._hasDelta) {
                    var c = ey.extendFlat({}, n.font);
                    c.size = void 0, ey.coerceFont(i, "delta.font", c), t.delta.font.size === void 0 && (t.delta.font.size = (t._hasNumber ? .5 : 1) * (s || S7.defaultNumberFontSize), o[1] = !0), i("delta.reference", t.value), i("delta.relative"), i("delta.valueformat", t.delta.relative ? "2%" : ""), i("delta.increasing.symbol"), i("delta.increasing.color"), i("delta.decreasing.symbol"), i("delta.decreasing.color"), i("delta.position"), i("delta.prefix"), i("delta.suffix"), u = t.delta.font.size;
                }
                t._scaleNumbers = (!t._hasNumber || o[0]) && (!t._hasDelta || o[1]) || !1;
                var f = ey.extendFlat({}, n.font);
                f.size = .25 * (s || u || S7.defaultNumberFontSize), ey.coerceFont(i, "title.font", f), i("title.text");
                var h, d, v, x;
                function b(_, C) {
                    return ey.coerce(h, d, M7.gauge, _, C);
                }
                function p(_, C) {
                    return ey.coerce(v, x, M7.gauge.axis, _, C);
                }
                if (t._hasGauge) {
                    h = e.gauge, h || (h = {}), d = gWe.newContainer(t, "gauge"), b("shape");
                    var E = t._isBullet = t.gauge.shape === "bullet";
                    E || i("title.align", "center");
                    var k = t._isAngular = t.gauge.shape === "angular";
                    k || i("align", "center"), b("bgcolor", n.paper_bgcolor), b("borderwidth"), b("bordercolor"), b("bar.color"), b("bar.line.color"), b("bar.line.width");
                    var A = S7.valueThickness * (t.gauge.shape === "bullet" ? .5 : 1);
                    b("bar.thickness", A), lZt(h, d, {
                        name: "steps",
                        handleItemDefaults: vZt
                    }), b("threshold.value"), b("threshold.thickness"), b("threshold.line.width"), b("threshold.line.color"), v = {}, h && (v = h.axis || {}), x = gWe.newContainer(d, "axis"), p("visible"), t._range = p("range", t._range);
                    var L = {
                        font: n.font,
                        noAutotickangles: !0,
                        outerTicks: !0,
                        noTicklabelshift: !0,
                        noTicklabelstandoff: !0
                    };
                    uZt(v, x, p, "linear"), hZt(v, x, p, "linear", L), fZt(v, x, p, "linear", L), cZt(v, x, p, L);
                } else i("title.align", "center"), i("align", "center"), t._isAngular = t._isBullet = !1;
                t._length = null;
            }
            function vZt(e, t) {
                function r(n, i) {
                    return ey.coerce(e, t, M7.gauge.steps, n, i);
                }
                r("color"), r("line.color"), r("line.width"), r("range"), r("thickness");
            }
            mWe.exports = {
                supplyDefaults: dZt
            };
        });
        var xWe = ye((P_r, _We)=>{
            "use strict";
            function pZt(e, t) {
                var r = [], n = t.value;
                typeof t._lastValue != "number" && (t._lastValue = t.value);
                var i = t._lastValue, a = i;
                return t._hasDelta && typeof t.delta.reference == "number" && (a = t.delta.reference), r[0] = {
                    y: n,
                    lastY: i,
                    delta: n - a,
                    relativeDelta: (n - a) / a
                }, r;
            }
            _We.exports = {
                calc: pZt
            };
        });
        var MWe = ye((I_r, SWe)=>{
            "use strict";
            var fw = xa(), gZt = (R2(), B1(I2)).interpolate, bWe = (R2(), B1(I2)).interpolateNumber, Ex = Mr(), mZt = Ex.strScale, Yk = Ex.strTranslate, yZt = Ex.rad2deg, _Zt = Nh().MID_SHIFT, cw = ao(), sw = GJ(), k7 = Pl(), av = Qa(), xZt = JM(), bZt = iI(), wZt = Cd(), DA = va(), jJ = {
                left: "start",
                center: "middle",
                right: "end"
            }, lw = {
                left: 0,
                center: .5,
                right: 1
            }, wWe = /[yzafpnµmkMGTPEZY]/;
            function Kk(e) {
                return e && e.duration > 0;
            }
            SWe.exports = function(t, r, n, i) {
                var a = t._fullLayout, o;
                Kk(n) && i && (o = i()), Ex.makeTraceGroups(a._indicatorlayer, r, "trace").each(function(s) {
                    var l = s[0], u = l.trace, c = fw.select(this), f = u._hasGauge, h = u._isAngular, d = u._isBullet, v = u.domain, x = {
                        w: a._size.w * (v.x[1] - v.x[0]),
                        h: a._size.h * (v.y[1] - v.y[0]),
                        l: a._size.l + a._size.w * v.x[0],
                        r: a._size.r + a._size.w * (1 - v.x[1]),
                        t: a._size.t + a._size.h * (1 - v.y[1]),
                        b: a._size.b + a._size.h * v.y[0]
                    }, b = x.l + x.w / 2, p = x.t + x.h / 2, E = Math.min(x.w / 2, x.h), k = sw.innerRadius * E, A, L, _, C = u.align || "center";
                    if (L = p, !f) A = x.l + lw[C] * x.w, _ = function(G) {
                        return TWe(G, x.w, x.h);
                    };
                    else if (h && (A = b, L = p + E / 2, _ = function(G) {
                        return EZt(G, .9 * k);
                    }), d) {
                        var M = sw.bulletPadding, g = 1 - sw.bulletNumberDomainSize + M;
                        A = x.l + (g + (1 - g) * lw[C]) * x.w, _ = function(G) {
                            return TWe(G, (sw.bulletNumberDomainSize - M) * x.w, x.h);
                        };
                    }
                    SZt(t, c, s, {
                        numbersX: A,
                        numbersY: L,
                        numbersScaler: _,
                        transitionOpts: n,
                        onComplete: o
                    });
                    var P, T;
                    f && (P = {
                        range: u.gauge.axis.range,
                        color: u.gauge.bgcolor,
                        line: {
                            color: u.gauge.bordercolor,
                            width: 0
                        },
                        thickness: 1
                    }, T = {
                        range: u.gauge.axis.range,
                        color: "rgba(0, 0, 0, 0)",
                        line: {
                            color: u.gauge.bordercolor,
                            width: u.gauge.borderwidth
                        },
                        thickness: 1
                    });
                    var F = c.selectAll("g.angular").data(h ? s : []);
                    F.exit().remove();
                    var q = c.selectAll("g.angularaxis").data(h ? s : []);
                    q.exit().remove(), h && AZt(t, c, s, {
                        radius: E,
                        innerRadius: k,
                        gauge: F,
                        layer: q,
                        size: x,
                        gaugeBg: P,
                        gaugeOutline: T,
                        transitionOpts: n,
                        onComplete: o
                    });
                    var V = c.selectAll("g.bullet").data(d ? s : []);
                    V.exit().remove();
                    var H = c.selectAll("g.bulletaxis").data(d ? s : []);
                    H.exit().remove(), d && TZt(t, c, s, {
                        gauge: V,
                        layer: H,
                        size: x,
                        gaugeBg: P,
                        gaugeOutline: T,
                        transitionOpts: n,
                        onComplete: o
                    });
                    var X = c.selectAll("text.title").data(s);
                    X.exit().remove(), X.enter().append("text").classed("title", !0), X.attr("text-anchor", function() {
                        return d ? jJ.right : jJ[u.title.align];
                    }).text(u.title.text).call(cw.font, u.title.font).call(k7.convertToTspans, t), X.attr("transform", function() {
                        var G = x.l + x.w * lw[u.title.align], N, W = sw.titlePadding, re = cw.bBox(X.node());
                        if (f) {
                            if (h) {
                                if (u.gauge.axis.visible) {
                                    var ae = cw.bBox(q.node());
                                    N = ae.top - W - re.bottom;
                                } else N = x.t + x.h / 2 - E / 2 - re.bottom - W;
                            }
                            d && (N = L - (re.top + re.bottom) / 2, G = x.l - sw.bulletPadding * x.w);
                        } else N = u._numbersTop - W - re.bottom;
                        return Yk(G, N);
                    });
                });
            };
            function TZt(e, t, r, n) {
                var i = r[0].trace, a = n.gauge, o = n.layer, s = n.gaugeBg, l = n.gaugeOutline, u = n.size, c = i.domain, f = n.transitionOpts, h = n.onComplete, d, v, x, b, p;
                a.enter().append("g").classed("bullet", !0), a.attr("transform", Yk(u.l, u.t)), o.enter().append("g").classed("bulletaxis", !0).classed("crisp", !0), o.selectAll("g.xbulletaxistick,path,text").remove();
                var E = u.h, k = i.gauge.bar.thickness * E, A = c.x[0], L = c.x[0] + (c.x[1] - c.x[0]) * (i._hasNumber || i._hasDelta ? 1 - sw.bulletNumberDomainSize : 1);
                d = Xk(e, i.gauge.axis), d._id = "xbulletaxis", d.domain = [
                    A,
                    L
                ], d.setScale(), v = av.calcTicks(d), x = av.makeTransTickFn(d), b = av.getTickSigns(d)[2], p = u.t + u.h, d.visible && (av.drawTicks(e, d, {
                    vals: d.ticks === "inside" ? av.clipEnds(d, v) : v,
                    layer: o,
                    path: av.makeTickPath(d, p, b),
                    transFn: x
                }), av.drawLabels(e, d, {
                    vals: v,
                    layer: o,
                    transFn: x,
                    labelFns: av.makeLabelFns(d, p)
                }));
                function _(q) {
                    q.attr("width", function(V) {
                        return Math.max(0, d.c2p(V.range[1]) - d.c2p(V.range[0]));
                    }).attr("x", function(V) {
                        return d.c2p(V.range[0]);
                    }).attr("y", function(V) {
                        return .5 * (1 - V.thickness) * E;
                    }).attr("height", function(V) {
                        return V.thickness * E;
                    });
                }
                var C = [
                    s
                ].concat(i.gauge.steps), M = a.selectAll("g.bg-bullet").data(C);
                M.enter().append("g").classed("bg-bullet", !0).append("rect"), M.select("rect").call(_).call(uw), M.exit().remove();
                var g = a.selectAll("g.value-bullet").data([
                    i.gauge.bar
                ]);
                g.enter().append("g").classed("value-bullet", !0).append("rect"), g.select("rect").attr("height", k).attr("y", (E - k) / 2).call(uw), Kk(f) ? g.select("rect").transition().duration(f.duration).ease(f.easing).each("end", function() {
                    h && h();
                }).each("interrupt", function() {
                    h && h();
                }).attr("width", Math.max(0, d.c2p(Math.min(i.gauge.axis.range[1], r[0].y)))) : g.select("rect").attr("width", typeof r[0].y == "number" ? Math.max(0, d.c2p(Math.min(i.gauge.axis.range[1], r[0].y))) : 0), g.exit().remove();
                var P = r.filter(function() {
                    return i.gauge.threshold.value || i.gauge.threshold.value === 0;
                }), T = a.selectAll("g.threshold-bullet").data(P);
                T.enter().append("g").classed("threshold-bullet", !0).append("line"), T.select("line").attr("x1", d.c2p(i.gauge.threshold.value)).attr("x2", d.c2p(i.gauge.threshold.value)).attr("y1", (1 - i.gauge.threshold.thickness) / 2 * E).attr("y2", (1 - (1 - i.gauge.threshold.thickness) / 2) * E).call(DA.stroke, i.gauge.threshold.line.color).style("stroke-width", i.gauge.threshold.line.width), T.exit().remove();
                var F = a.selectAll("g.gauge-outline").data([
                    l
                ]);
                F.enter().append("g").classed("gauge-outline", !0).append("rect"), F.select("rect").call(_).call(uw), F.exit().remove();
            }
            function AZt(e, t, r, n) {
                var i = r[0].trace, a = n.size, o = n.radius, s = n.innerRadius, l = n.gaugeBg, u = n.gaugeOutline, c = [
                    a.l + a.w / 2,
                    a.t + a.h / 2 + o / 2
                ], f = n.gauge, h = n.layer, d = n.transitionOpts, v = n.onComplete, x = Math.PI / 2;
                function b(_e) {
                    var Me = i.gauge.axis.range[0], ke = i.gauge.axis.range[1], ge = (_e - Me) / (ke - Me) * Math.PI - x;
                    return ge < -x ? -x : ge > x ? x : ge;
                }
                function p(_e) {
                    return fw.svg.arc().innerRadius((s + o) / 2 - _e / 2 * (o - s)).outerRadius((s + o) / 2 + _e / 2 * (o - s)).startAngle(-x);
                }
                function E(_e) {
                    _e.attr("d", function(Me) {
                        return p(Me.thickness).startAngle(b(Me.range[0])).endAngle(b(Me.range[1]))();
                    });
                }
                var k, A, L, _;
                f.enter().append("g").classed("angular", !0), f.attr("transform", Yk(c[0], c[1])), h.enter().append("g").classed("angularaxis", !0).classed("crisp", !0), h.selectAll("g.xangularaxistick,path,text").remove(), k = Xk(e, i.gauge.axis), k.type = "linear", k.range = i.gauge.axis.range, k._id = "xangularaxis", k.ticklabeloverflow = "allow", k.setScale();
                var C = function(_e) {
                    return (k.range[0] - _e.x) / (k.range[1] - k.range[0]) * Math.PI + Math.PI;
                }, M = {}, g = av.makeLabelFns(k, 0), P = g.labelStandoff;
                M.xFn = function(_e) {
                    var Me = C(_e);
                    return Math.cos(Me) * P;
                }, M.yFn = function(_e) {
                    var Me = C(_e), ke = Math.sin(Me) > 0 ? .2 : 1;
                    return -Math.sin(Me) * (P + _e.fontSize * ke) + Math.abs(Math.cos(Me)) * (_e.fontSize * _Zt);
                }, M.anchorFn = function(_e) {
                    var Me = C(_e), ke = Math.cos(Me);
                    return Math.abs(ke) < .1 ? "middle" : ke > 0 ? "start" : "end";
                }, M.heightFn = function(_e, Me, ke) {
                    var ge = C(_e);
                    return -0.5 * (1 + Math.sin(ge)) * ke;
                };
                var T = function(_e) {
                    return Yk(c[0] + o * Math.cos(_e), c[1] - o * Math.sin(_e));
                };
                L = function(_e) {
                    return T(C(_e));
                };
                var F = function(_e) {
                    var Me = C(_e);
                    return T(Me) + "rotate(" + -yZt(Me) + ")";
                };
                if (A = av.calcTicks(k), _ = av.getTickSigns(k)[2], k.visible) {
                    _ = k.ticks === "inside" ? -1 : 1;
                    var q = (k.linewidth || 1) / 2;
                    av.drawTicks(e, k, {
                        vals: A,
                        layer: h,
                        path: "M" + _ * q + ",0h" + _ * k.ticklen,
                        transFn: F
                    }), av.drawLabels(e, k, {
                        vals: A,
                        layer: h,
                        transFn: L,
                        labelFns: M
                    });
                }
                var V = [
                    l
                ].concat(i.gauge.steps), H = f.selectAll("g.bg-arc").data(V);
                H.enter().append("g").classed("bg-arc", !0).append("path"), H.select("path").call(E).call(uw), H.exit().remove();
                var X = p(i.gauge.bar.thickness), G = f.selectAll("g.value-arc").data([
                    i.gauge.bar
                ]);
                G.enter().append("g").classed("value-arc", !0).append("path");
                var N = G.select("path");
                Kk(d) ? (N.transition().duration(d.duration).ease(d.easing).each("end", function() {
                    v && v();
                }).each("interrupt", function() {
                    v && v();
                }).attrTween("d", MZt(X, b(r[0].lastY), b(r[0].y))), i._lastValue = r[0].y) : N.attr("d", typeof r[0].y == "number" ? X.endAngle(b(r[0].y)) : "M0,0Z"), N.call(uw), G.exit().remove(), V = [];
                var W = i.gauge.threshold.value;
                (W || W === 0) && V.push({
                    range: [
                        W,
                        W
                    ],
                    color: i.gauge.threshold.color,
                    line: {
                        color: i.gauge.threshold.line.color,
                        width: i.gauge.threshold.line.width
                    },
                    thickness: i.gauge.threshold.thickness
                });
                var re = f.selectAll("g.threshold-arc").data(V);
                re.enter().append("g").classed("threshold-arc", !0).append("path"), re.select("path").call(E).call(uw), re.exit().remove();
                var ae = f.selectAll("g.gauge-outline").data([
                    u
                ]);
                ae.enter().append("g").classed("gauge-outline", !0).append("path"), ae.select("path").call(E).call(uw), ae.exit().remove();
            }
            function SZt(e, t, r, n) {
                var i = r[0].trace, a = n.numbersX, o = n.numbersY, s = i.align || "center", l = jJ[s], u = n.transitionOpts, c = n.onComplete, f = Ex.ensureSingle(t, "g", "numbers"), h, d, v, x = [];
                i._hasNumber && x.push("number"), i._hasDelta && (x.push("delta"), i.delta.position === "left" && x.reverse());
                var b = f.selectAll("text").data(x);
                b.enter().append("text"), b.attr("text-anchor", function() {
                    return l;
                }).attr("class", function(T) {
                    return T;
                }).attr("x", null).attr("y", null).attr("dx", null).attr("dy", null), b.exit().remove();
                function p(T, F, q, V) {
                    if (T.match("s") && q >= 0 != V >= 0 && !F(q).slice(-1).match(wWe) && !F(V).slice(-1).match(wWe)) {
                        var H = T.slice().replace("s", "f").replace(/\d+/, function(G) {
                            return parseInt(G) - 1;
                        }), X = Xk(e, {
                            tickformat: H
                        });
                        return function(G) {
                            return Math.abs(G) < 1 ? av.tickText(X, G).text : F(G);
                        };
                    } else return F;
                }
                function E() {
                    var T = Xk(e, {
                        tickformat: i.number.valueformat
                    }, i._range);
                    T.setScale(), av.prepTicks(T);
                    var F = function(G) {
                        return av.tickText(T, G).text;
                    }, q = i.number.suffix, V = i.number.prefix, H = f.select("text.number");
                    function X() {
                        var G = typeof r[0].y == "number" ? V + F(r[0].y) + q : "-";
                        H.text(G).call(cw.font, i.number.font).call(k7.convertToTspans, e);
                    }
                    return Kk(u) ? H.transition().duration(u.duration).ease(u.easing).each("end", function() {
                        X(), c && c();
                    }).each("interrupt", function() {
                        X(), c && c();
                    }).attrTween("text", function() {
                        var G = fw.select(this), N = bWe(r[0].lastY, r[0].y);
                        i._lastValue = r[0].y;
                        var W = p(i.number.valueformat, F, r[0].lastY, r[0].y);
                        return function(re) {
                            G.text(V + W(N(re)) + q);
                        };
                    }) : X(), h = AWe(V + F(r[0].y) + q, i.number.font, l, e), H;
                }
                function k() {
                    var T = Xk(e, {
                        tickformat: i.delta.valueformat
                    }, i._range);
                    T.setScale(), av.prepTicks(T);
                    var F = function(re) {
                        return av.tickText(T, re).text;
                    }, q = i.delta.suffix, V = i.delta.prefix, H = function(re) {
                        var ae = i.delta.relative ? re.relativeDelta : re.delta;
                        return ae;
                    }, X = function(re, ae) {
                        return re === 0 || typeof re != "number" || isNaN(re) ? "-" : (re > 0 ? i.delta.increasing.symbol : i.delta.decreasing.symbol) + V + ae(re) + q;
                    }, G = function(re) {
                        return re.delta >= 0 ? i.delta.increasing.color : i.delta.decreasing.color;
                    };
                    i._deltaLastValue === void 0 && (i._deltaLastValue = H(r[0]));
                    var N = f.select("text.delta");
                    N.call(cw.font, i.delta.font).call(DA.fill, G({
                        delta: i._deltaLastValue
                    }));
                    function W() {
                        N.text(X(H(r[0]), F)).call(DA.fill, G(r[0])).call(k7.convertToTspans, e);
                    }
                    return Kk(u) ? N.transition().duration(u.duration).ease(u.easing).tween("text", function() {
                        var re = fw.select(this), ae = H(r[0]), _e = i._deltaLastValue, Me = p(i.delta.valueformat, F, _e, ae), ke = bWe(_e, ae);
                        return i._deltaLastValue = ae, function(ge) {
                            re.text(X(ke(ge), Me)), re.call(DA.fill, G({
                                delta: ke(ge)
                            }));
                        };
                    }).each("end", function() {
                        W(), c && c();
                    }).each("interrupt", function() {
                        W(), c && c();
                    }) : W(), d = AWe(X(H(r[0]), F), i.delta.font, l, e), N;
                }
                var A = i.mode + i.align, L;
                if (i._hasDelta && (L = k(), A += i.delta.position + i.delta.font.size + i.delta.font.family + i.delta.valueformat, A += i.delta.increasing.symbol + i.delta.decreasing.symbol, v = d), i._hasNumber && (E(), A += i.number.font.size + i.number.font.family + i.number.valueformat + i.number.suffix + i.number.prefix, v = h), i._hasDelta && i._hasNumber) {
                    var _ = [
                        (h.left + h.right) / 2,
                        (h.top + h.bottom) / 2
                    ], C = [
                        (d.left + d.right) / 2,
                        (d.top + d.bottom) / 2
                    ], M, g, P = .75 * i.delta.font.size;
                    i.delta.position === "left" && (M = E7(i, "deltaPos", 0, -1 * (h.width * lw[i.align] + d.width * (1 - lw[i.align]) + P), A, Math.min), g = _[1] - C[1], v = {
                        width: h.width + d.width + P,
                        height: Math.max(h.height, d.height),
                        left: d.left + M,
                        right: h.right,
                        top: Math.min(h.top, d.top + g),
                        bottom: Math.max(h.bottom, d.bottom + g)
                    }), i.delta.position === "right" && (M = E7(i, "deltaPos", 0, h.width * (1 - lw[i.align]) + d.width * lw[i.align] + P, A, Math.max), g = _[1] - C[1], v = {
                        width: h.width + d.width + P,
                        height: Math.max(h.height, d.height),
                        left: h.left,
                        right: d.right + M,
                        top: Math.min(h.top, d.top + g),
                        bottom: Math.max(h.bottom, d.bottom + g)
                    }), i.delta.position === "bottom" && (M = null, g = d.height, v = {
                        width: Math.max(h.width, d.width),
                        height: h.height + d.height,
                        left: Math.min(h.left, d.left),
                        right: Math.max(h.right, d.right),
                        top: h.bottom - h.height,
                        bottom: h.bottom + d.height
                    }), i.delta.position === "top" && (M = null, g = h.top, v = {
                        width: Math.max(h.width, d.width),
                        height: h.height + d.height,
                        left: Math.min(h.left, d.left),
                        right: Math.max(h.right, d.right),
                        top: h.bottom - h.height - d.height,
                        bottom: h.bottom
                    }), L.attr({
                        dx: M,
                        dy: g
                    });
                }
                (i._hasNumber || i._hasDelta) && f.attr("transform", function() {
                    var T = n.numbersScaler(v);
                    A += T[2];
                    var F = E7(i, "numbersScale", 1, T[0], A, Math.min), q;
                    i._scaleNumbers || (F = 1), i._isAngular ? q = o - F * v.bottom : q = o - F * (v.top + v.bottom) / 2, i._numbersTop = F * v.top + q;
                    var V = v[s];
                    s === "center" && (V = (v.left + v.right) / 2);
                    var H = a - F * V;
                    return H = E7(i, "numbersTranslate", 0, H, A, Math.max), Yk(H, q) + mZt(F);
                });
            }
            function uw(e) {
                e.each(function(t) {
                    DA.stroke(fw.select(this), t.line.color);
                }).each(function(t) {
                    DA.fill(fw.select(this), t.color);
                }).style("stroke-width", function(t) {
                    return t.line.width;
                });
            }
            function MZt(e, t, r) {
                return function() {
                    var n = gZt(t, r);
                    return function(i) {
                        return e.endAngle(n(i))();
                    };
                };
            }
            function Xk(e, t, r) {
                var n = e._fullLayout, i = Ex.extendFlat({
                    type: "linear",
                    ticks: "outside",
                    range: r,
                    showline: !0
                }, t), a = {
                    type: "linear",
                    _id: "x" + t._id
                }, o = {
                    letter: "x",
                    font: n.font,
                    noAutotickangles: !0,
                    noHover: !0,
                    noTickson: !0
                };
                function s(l, u) {
                    return Ex.coerce(i, a, wZt, l, u);
                }
                return xZt(i, a, s, o, n), bZt(i, a, s, o), a;
            }
            function TWe(e, t, r) {
                var n = Math.min(t / e.width, r / e.height);
                return [
                    n,
                    e,
                    t + "x" + r
                ];
            }
            function EZt(e, t) {
                var r = Math.sqrt(e.width / 2 * (e.width / 2) + e.height * e.height), n = t / r;
                return [
                    n,
                    e,
                    t
                ];
            }
            function AWe(e, t, r, n) {
                var i = document.createElementNS("http://www.w3.org/2000/svg", "text"), a = fw.select(i);
                return a.text(e).attr("x", 0).attr("y", 0).attr("text-anchor", r).attr("data-unformatted", e).call(k7.convertToTspans, n).call(cw.font, t), cw.bBox(a.node());
            }
            function E7(e, t, r, n, i, a) {
                var o = "_cache" + t;
                e[o] && e[o].key === i || (e[o] = {
                    key: i,
                    value: r
                });
                var s = Ex.aggNums(a, null, [
                    e[o].value,
                    n
                ], 2);
                return e[o].value = s, s;
            }
        });
        var kWe = ye((R_r, EWe)=>{
            "use strict";
            EWe.exports = {
                moduleType: "trace",
                name: "indicator",
                basePlotModule: lWe(),
                categories: [
                    "svg",
                    "noOpacity",
                    "noHover"
                ],
                animatable: !0,
                attributes: HJ(),
                supplyDefaults: yWe().supplyDefaults,
                calc: xWe().calc,
                plot: MWe(),
                meta: {}
            };
        });
        var LWe = ye((D_r, CWe)=>{
            "use strict";
            CWe.exports = kWe();
        });
        var WJ = ye((F_r, DWe)=>{
            "use strict";
            var PWe = Nb(), C7 = no().extendFlat, kZt = Bu().overrideAll, IWe = Su(), CZt = Ju().attributes, RWe = Oc().descriptionOnlyNumbers, z_r = DWe.exports = kZt({
                domain: CZt({
                    name: "table",
                    trace: !0
                }),
                columnwidth: {
                    valType: "number",
                    arrayOk: !0,
                    dflt: null
                },
                columnorder: {
                    valType: "data_array"
                },
                header: {
                    values: {
                        valType: "data_array",
                        dflt: []
                    },
                    format: {
                        valType: "data_array",
                        dflt: [],
                        description: RWe("cell value")
                    },
                    prefix: {
                        valType: "string",
                        arrayOk: !0,
                        dflt: null
                    },
                    suffix: {
                        valType: "string",
                        arrayOk: !0,
                        dflt: null
                    },
                    height: {
                        valType: "number",
                        dflt: 28
                    },
                    align: C7({}, PWe.align, {
                        arrayOk: !0
                    }),
                    line: {
                        width: {
                            valType: "number",
                            arrayOk: !0,
                            dflt: 1
                        },
                        color: {
                            valType: "color",
                            arrayOk: !0,
                            dflt: "grey"
                        }
                    },
                    fill: {
                        color: {
                            valType: "color",
                            arrayOk: !0,
                            dflt: "white"
                        }
                    },
                    font: C7({}, IWe({
                        arrayOk: !0
                    }))
                },
                cells: {
                    values: {
                        valType: "data_array",
                        dflt: []
                    },
                    format: {
                        valType: "data_array",
                        dflt: [],
                        description: RWe("cell value")
                    },
                    prefix: {
                        valType: "string",
                        arrayOk: !0,
                        dflt: null
                    },
                    suffix: {
                        valType: "string",
                        arrayOk: !0,
                        dflt: null
                    },
                    height: {
                        valType: "number",
                        dflt: 20
                    },
                    align: C7({}, PWe.align, {
                        arrayOk: !0
                    }),
                    line: {
                        width: {
                            valType: "number",
                            arrayOk: !0,
                            dflt: 1
                        },
                        color: {
                            valType: "color",
                            arrayOk: !0,
                            dflt: "grey"
                        }
                    },
                    fill: {
                        color: {
                            valType: "color",
                            arrayOk: !0,
                            dflt: "white"
                        }
                    },
                    font: C7({}, IWe({
                        arrayOk: !0
                    }))
                }
            }, "calc", "from-root");
        });
        var FWe = ye((q_r, zWe)=>{
            "use strict";
            var ZJ = Mr(), LZt = WJ(), PZt = Ju().defaults;
            function IZt(e, t) {
                for(var r = e.columnorder || [], n = e.header.values.length, i = r.slice(0, n), a = i.slice().sort(function(l, u) {
                    return l - u;
                }), o = i.map(function(l) {
                    return a.indexOf(l);
                }), s = o.length; s < n; s++)o.push(s);
                t("columnorder", o);
            }
            zWe.exports = function(t, r, n, i) {
                function a(o, s) {
                    return ZJ.coerce(t, r, LZt, o, s);
                }
                PZt(r, i, a), a("columnwidth"), a("header.values"), a("header.format"), a("header.align"), a("header.prefix"), a("header.suffix"), a("header.height"), a("header.line.width"), a("header.line.color"), a("header.fill.color"), ZJ.coerceFont(a, "header.font", i.font), IZt(r, a), a("cells.values"), a("cells.format"), a("cells.align"), a("cells.prefix"), a("cells.suffix"), a("cells.height"), a("cells.line.width"), a("cells.line.color"), a("cells.fill.color"), ZJ.coerceFont(a, "cells.font", i.font), r._length = null;
            };
        });
        var OWe = ye((O_r, qWe)=>{
            "use strict";
            var RZt = Km().wrap;
            qWe.exports = function() {
                return RZt({});
            };
        });
        var XJ = ye((B_r, BWe)=>{
            "use strict";
            BWe.exports = {
                cellPad: 8,
                columnExtentOffset: 10,
                columnTitleOffset: 28,
                emptyHeaderHeight: 16,
                latexCheck: /^\$.*\$$/,
                goldenRatio: 1.618,
                lineBreaker: "<br>",
                maxDimensionCount: 60,
                overdrag: 45,
                releaseTransitionDuration: 120,
                releaseTransitionEase: "cubic-out",
                scrollbarCaptureWidth: 18,
                scrollbarHideDelay: 1e3,
                scrollbarHideDuration: 1e3,
                scrollbarOffset: 5,
                scrollbarWidth: 8,
                transitionDuration: 100,
                transitionEase: "cubic-out",
                uplift: 5,
                wrapSpacer: " ",
                wrapSplitCharacter: " ",
                cn: {
                    table: "table",
                    tableControlView: "table-control-view",
                    scrollBackground: "scroll-background",
                    yColumn: "y-column",
                    columnBlock: "column-block",
                    scrollAreaClip: "scroll-area-clip",
                    scrollAreaClipRect: "scroll-area-clip-rect",
                    columnBoundary: "column-boundary",
                    columnBoundaryClippath: "column-boundary-clippath",
                    columnBoundaryRect: "column-boundary-rect",
                    columnCells: "column-cells",
                    columnCell: "column-cell",
                    cellRect: "cell-rect",
                    cellText: "cell-text",
                    cellTextHolder: "cell-text-holder",
                    scrollbarKit: "scrollbar-kit",
                    scrollbar: "scrollbar",
                    scrollbarSlider: "scrollbar-slider",
                    scrollbarGlyph: "scrollbar-glyph",
                    scrollbarCaptureZone: "scrollbar-capture-zone"
                }
            };
        });
        var XWe = ye((N_r, ZWe)=>{
            "use strict";
            var NWe = XJ(), KJ = no().extendFlat, DZt = uo(), zZt = vv().isTypedArray, L7 = vv().isArrayOrTypedArray;
            ZWe.exports = function(t, r) {
                var n = YJ(r.cells.values), i = function(g) {
                    return g.slice(r.header.values.length, g.length);
                }, a = YJ(r.header.values);
                a.length && !a[0].length && (a[0] = [
                    ""
                ], a = YJ(a));
                var o = a.concat(i(n).map(function() {
                    return WWe((a[0] || [
                        ""
                    ]).length);
                })), s = r.domain, l = Math.floor(t._fullLayout._size.w * (s.x[1] - s.x[0])), u = Math.floor(t._fullLayout._size.h * (s.y[1] - s.y[0])), c = r.header.values.length ? o[0].map(function() {
                    return r.header.height;
                }) : [
                    NWe.emptyHeaderHeight
                ], f = n.length ? n[0].map(function() {
                    return r.cells.height;
                }) : [], h = c.reduce(UWe, 0), d = u - h, v = d + NWe.uplift, x = GWe(f, v), b = GWe(c, h), p = HWe(b, []), E = HWe(x, p), k = {}, A = r._fullInput.columnorder;
                L7(A) && (A = Array.from(A)), A = A.concat(i(n.map(function(g, P) {
                    return P;
                })));
                var L = o.map(function(g, P) {
                    var T = L7(r.columnwidth) ? r.columnwidth[Math.min(P, r.columnwidth.length - 1)] : r.columnwidth;
                    return DZt(T) ? Number(T) : 1;
                }), _ = L.reduce(UWe, 0);
                L = L.map(function(g) {
                    return g / _ * l;
                });
                var C = Math.max(JJ(r.header.line.width), JJ(r.cells.line.width)), M = {
                    key: r.uid + t._context.staticPlot,
                    translateX: s.x[0] * t._fullLayout._size.w,
                    translateY: t._fullLayout._size.h * (1 - s.y[1]),
                    size: t._fullLayout._size,
                    width: l,
                    maxLineWidth: C,
                    height: u,
                    columnOrder: A,
                    groupHeight: u,
                    rowBlocks: E,
                    headerRowBlocks: p,
                    scrollY: 0,
                    cells: KJ({}, r.cells, {
                        values: n
                    }),
                    headerCells: KJ({}, r.header, {
                        values: o
                    }),
                    gdColumns: o.map(function(g) {
                        return g[0];
                    }),
                    gdColumnsOriginalOrder: o.map(function(g) {
                        return g[0];
                    }),
                    prevPages: [
                        0,
                        0
                    ],
                    scrollbarState: {
                        scrollbarScrollInProgress: !1
                    },
                    columns: o.map(function(g, P) {
                        var T = k[g];
                        k[g] = (T || 0) + 1;
                        var F = g + "__" + k[g];
                        return {
                            key: F,
                            label: g,
                            specIndex: P,
                            xIndex: A[P],
                            xScale: VWe,
                            x: void 0,
                            calcdata: void 0,
                            columnWidth: L[P]
                        };
                    })
                };
                return M.columns.forEach(function(g) {
                    g.calcdata = M, g.x = VWe(g);
                }), M;
            };
            function JJ(e) {
                if (L7(e)) {
                    for(var t = 0, r = 0; r < e.length; r++)t = Math.max(t, JJ(e[r]));
                    return t;
                }
                return e;
            }
            function UWe(e, t) {
                return e + t;
            }
            function YJ(e) {
                var t = e.slice(), r = 1 / 0, n = 0, i;
                for(i = 0; i < t.length; i++)zZt(t[i]) ? t[i] = Array.from(t[i]) : L7(t[i]) || (t[i] = [
                    t[i]
                ]), r = Math.min(r, t[i].length), n = Math.max(n, t[i].length);
                if (r !== n) for(i = 0; i < t.length; i++){
                    var a = n - t[i].length;
                    a && (t[i] = t[i].concat(WWe(a)));
                }
                return t;
            }
            function WWe(e) {
                for(var t = new Array(e), r = 0; r < e; r++)t[r] = "";
                return t;
            }
            function VWe(e) {
                return e.calcdata.columns.reduce(function(t, r) {
                    return r.xIndex < e.xIndex ? t + r.columnWidth : t;
                }, 0);
            }
            function HWe(e, t) {
                var r = Object.keys(e);
                return r.map(function(n) {
                    return KJ({}, e[n], {
                        auxiliaryBlocks: t
                    });
                });
            }
            function GWe(e, t) {
                for(var r = {}, n, i = 0, a = 0, o = jWe(), s = 0, l = 0, u = 0; u < e.length; u++)n = e[u], o.rows.push({
                    rowIndex: u,
                    rowHeight: n
                }), a += n, (a >= t || u === e.length - 1) && (r[i] = o, o.key = l++, o.firstRowIndex = s, o.lastRowIndex = u, o = jWe(), i += a, s = u + 1, a = 0);
                return r;
            }
            function jWe() {
                return {
                    firstRowIndex: null,
                    lastRowIndex: null,
                    rows: []
                };
            }
        });
        var YWe = ye(($J)=>{
            "use strict";
            var P7 = no().extendFlat;
            $J.splitToPanels = function(e) {
                var t = [
                    0,
                    0
                ], r = P7({}, e, {
                    key: "header",
                    type: "header",
                    page: 0,
                    prevPages: t,
                    currentRepaint: [
                        null,
                        null
                    ],
                    dragHandle: !0,
                    values: e.calcdata.headerCells.values[e.specIndex],
                    rowBlocks: e.calcdata.headerRowBlocks,
                    calcdata: P7({}, e.calcdata, {
                        cells: e.calcdata.headerCells
                    })
                }), n = P7({}, e, {
                    key: "cells1",
                    type: "cells",
                    page: 0,
                    prevPages: t,
                    currentRepaint: [
                        null,
                        null
                    ],
                    dragHandle: !1,
                    values: e.calcdata.cells.values[e.specIndex],
                    rowBlocks: e.calcdata.rowBlocks
                }), i = P7({}, e, {
                    key: "cells2",
                    type: "cells",
                    page: 1,
                    prevPages: t,
                    currentRepaint: [
                        null,
                        null
                    ],
                    dragHandle: !1,
                    values: e.calcdata.cells.values[e.specIndex],
                    rowBlocks: e.calcdata.rowBlocks
                });
                return [
                    n,
                    i,
                    r
                ];
            };
            $J.splitToCells = function(e) {
                var t = FZt(e);
                return (e.values || []).slice(t[0], t[1]).map(function(r, n) {
                    var i = typeof r == "string" && r.match(/[<$&> ]/) ? "_keybuster_" + Math.random() : "";
                    return {
                        keyWithinBlock: n + i,
                        key: t[0] + n,
                        column: e,
                        calcdata: e.calcdata,
                        page: e.page,
                        rowBlocks: e.rowBlocks,
                        value: r
                    };
                });
            };
            function FZt(e) {
                var t = e.rowBlocks[e.page], r = t ? t.rows[0].rowIndex : 0, n = t ? r + t.rows.length : 0;
                return [
                    r,
                    n
                ];
            }
        });
        var l$ = ye((V_r, oZe)=>{
            "use strict";
            var Ia = XJ(), Mc = xa(), QJ = Mr(), qZt = QJ.numberFormat, gu = Km(), e$ = ao(), OZt = Pl(), BZt = Mr().raiseToTop, og = Mr().strTranslate, NZt = Mr().cancelTransition, UZt = XWe(), rZe = YWe(), KWe = va();
            oZe.exports = function(t, r) {
                var n = !t._context.staticPlot, i = t._fullLayout._paper.selectAll("." + Ia.cn.table).data(r.map(function(E) {
                    var k = gu.unwrap(E), A = k.trace;
                    return UZt(t, A);
                }), gu.keyFun);
                i.exit().remove(), i.enter().append("g").classed(Ia.cn.table, !0).attr("overflow", "visible").style("box-sizing", "content-box").style("position", "absolute").style("left", 0).style("overflow", "visible").style("shape-rendering", "crispEdges").style("pointer-events", "all"), i.attr("width", function(E) {
                    return E.width + E.size.l + E.size.r;
                }).attr("height", function(E) {
                    return E.height + E.size.t + E.size.b;
                }).attr("transform", function(E) {
                    return og(E.translateX, E.translateY);
                });
                var a = i.selectAll("." + Ia.cn.tableControlView).data(gu.repeat, gu.keyFun), o = a.enter().append("g").classed(Ia.cn.tableControlView, !0).style("box-sizing", "content-box");
                if (n) {
                    var s = "onwheel" in document ? "wheel" : "mousewheel";
                    o.on("mousemove", function(E) {
                        a.filter(function(k) {
                            return E === k;
                        }).call(Jk, t);
                    }).on(s, function(E) {
                        if (!E.scrollbarState.wheeling) {
                            E.scrollbarState.wheeling = !0;
                            var k = E.scrollY + Mc.event.deltaY, A = R7(t, a, null, k)(E);
                            A || (Mc.event.stopPropagation(), Mc.event.preventDefault()), E.scrollbarState.wheeling = !1;
                        }
                    }).call(Jk, t, !0);
                }
                a.attr("transform", function(E) {
                    return og(E.size.l, E.size.t);
                });
                var l = a.selectAll("." + Ia.cn.scrollBackground).data(gu.repeat, gu.keyFun);
                l.enter().append("rect").classed(Ia.cn.scrollBackground, !0).attr("fill", "none"), l.attr("width", function(E) {
                    return E.width;
                }).attr("height", function(E) {
                    return E.height;
                }), a.each(function(E) {
                    e$.setClipUrl(Mc.select(this), JWe(t, E), t);
                });
                var u = a.selectAll("." + Ia.cn.yColumn).data(function(E) {
                    return E.columns;
                }, gu.keyFun);
                u.enter().append("g").classed(Ia.cn.yColumn, !0), u.exit().remove(), u.attr("transform", function(E) {
                    return og(E.x, 0);
                }), n && u.call(Mc.behavior.drag().origin(function(E) {
                    var k = Mc.select(this);
                    return eZe(k, E, -Ia.uplift), BZt(this), E.calcdata.columnDragInProgress = !0, Jk(a.filter(function(A) {
                        return E.calcdata.key === A.key;
                    }), t), E;
                }).on("drag", function(E) {
                    var k = Mc.select(this), A = function(C) {
                        return (E === C ? Mc.event.x : C.x) + C.columnWidth / 2;
                    };
                    E.x = Math.max(-Ia.overdrag, Math.min(E.calcdata.width + Ia.overdrag - E.columnWidth, Mc.event.x));
                    var L = iZe(u).filter(function(C) {
                        return C.calcdata.key === E.calcdata.key;
                    }), _ = L.sort(function(C, M) {
                        return A(C) - A(M);
                    });
                    _.forEach(function(C, M) {
                        C.xIndex = M, C.x = E === C ? C.x : C.xScale(C);
                    }), u.filter(function(C) {
                        return E !== C;
                    }).transition().ease(Ia.transitionEase).duration(Ia.transitionDuration).attr("transform", function(C) {
                        return og(C.x, 0);
                    }), k.call(NZt).attr("transform", og(E.x, -Ia.uplift));
                }).on("dragend", function(E) {
                    var k = Mc.select(this), A = E.calcdata;
                    E.x = E.xScale(E), E.calcdata.columnDragInProgress = !1, eZe(k, E, 0), JZt(t, A, A.columns.map(function(L) {
                        return L.xIndex;
                    }));
                })), u.each(function(E) {
                    e$.setClipUrl(Mc.select(this), $We(t, E), t);
                });
                var c = u.selectAll("." + Ia.cn.columnBlock).data(rZe.splitToPanels, gu.keyFun);
                c.enter().append("g").classed(Ia.cn.columnBlock, !0).attr("id", function(E) {
                    return E.key;
                }), c.style("cursor", function(E) {
                    return E.dragHandle ? "ew-resize" : E.calcdata.scrollbarState.barWiggleRoom ? "ns-resize" : "default";
                });
                var f = c.filter($Zt), h = c.filter(a$);
                n && h.call(Mc.behavior.drag().origin(function(E) {
                    return Mc.event.stopPropagation(), E;
                }).on("drag", R7(t, a, -1)).on("dragend", function() {})), t$(t, a, f, c), t$(t, a, h, c);
                var d = a.selectAll("." + Ia.cn.scrollAreaClip).data(gu.repeat, gu.keyFun);
                d.enter().append("clipPath").classed(Ia.cn.scrollAreaClip, !0).attr("id", function(E) {
                    return JWe(t, E);
                });
                var v = d.selectAll("." + Ia.cn.scrollAreaClipRect).data(gu.repeat, gu.keyFun);
                v.enter().append("rect").classed(Ia.cn.scrollAreaClipRect, !0).attr("x", -Ia.overdrag).attr("y", -Ia.uplift).attr("fill", "none"), v.attr("width", function(E) {
                    return E.width + 2 * Ia.overdrag;
                }).attr("height", function(E) {
                    return E.height + Ia.uplift;
                });
                var x = u.selectAll("." + Ia.cn.columnBoundary).data(gu.repeat, gu.keyFun);
                x.enter().append("g").classed(Ia.cn.columnBoundary, !0);
                var b = u.selectAll("." + Ia.cn.columnBoundaryClippath).data(gu.repeat, gu.keyFun);
                b.enter().append("clipPath").classed(Ia.cn.columnBoundaryClippath, !0), b.attr("id", function(E) {
                    return $We(t, E);
                });
                var p = b.selectAll("." + Ia.cn.columnBoundaryRect).data(gu.repeat, gu.keyFun);
                p.enter().append("rect").classed(Ia.cn.columnBoundaryRect, !0).attr("fill", "none"), p.attr("width", function(E) {
                    return E.columnWidth + 2 * I7(E);
                }).attr("height", function(E) {
                    return E.calcdata.height + 2 * I7(E) + Ia.uplift;
                }).attr("x", function(E) {
                    return -I7(E);
                }).attr("y", function(E) {
                    return -I7(E);
                }), o$(null, h, a);
            };
            function I7(e) {
                return Math.ceil(e.calcdata.maxLineWidth / 2);
            }
            function JWe(e, t) {
                return "clip" + e._fullLayout._uid + "_scrollAreaBottomClip_" + t.key;
            }
            function $We(e, t) {
                return "clip" + e._fullLayout._uid + "_columnBoundaryClippath_" + t.calcdata.key + "_" + t.specIndex;
            }
            function iZe(e) {
                return [].concat.apply([], e.map(function(t) {
                    return t;
                })).map(function(t) {
                    return t.__data__;
                });
            }
            function Jk(e, t, r) {
                function n(u) {
                    var c = u.rowBlocks;
                    return i$(c, c.length - 1) + (c.length ? D7(c[c.length - 1], 1 / 0) : 1);
                }
                var i = e.selectAll("." + Ia.cn.scrollbarKit).data(gu.repeat, gu.keyFun);
                i.enter().append("g").classed(Ia.cn.scrollbarKit, !0).style("shape-rendering", "geometricPrecision"), i.each(function(u) {
                    var c = u.scrollbarState;
                    c.totalHeight = n(u), c.scrollableAreaHeight = u.groupHeight - r$(u), c.currentlyVisibleHeight = Math.min(c.totalHeight, c.scrollableAreaHeight), c.ratio = c.currentlyVisibleHeight / c.totalHeight, c.barLength = Math.max(c.ratio * c.currentlyVisibleHeight, Ia.goldenRatio * Ia.scrollbarWidth), c.barWiggleRoom = c.currentlyVisibleHeight - c.barLength, c.wiggleRoom = Math.max(0, c.totalHeight - c.scrollableAreaHeight), c.topY = c.barWiggleRoom === 0 ? 0 : u.scrollY / c.wiggleRoom * c.barWiggleRoom, c.bottomY = c.topY + c.barLength, c.dragMultiplier = c.wiggleRoom / c.barWiggleRoom;
                }).attr("transform", function(u) {
                    var c = u.width + Ia.scrollbarWidth / 2 + Ia.scrollbarOffset;
                    return og(c, r$(u));
                });
                var a = i.selectAll("." + Ia.cn.scrollbar).data(gu.repeat, gu.keyFun);
                a.enter().append("g").classed(Ia.cn.scrollbar, !0);
                var o = a.selectAll("." + Ia.cn.scrollbarSlider).data(gu.repeat, gu.keyFun);
                o.enter().append("g").classed(Ia.cn.scrollbarSlider, !0), o.attr("transform", function(u) {
                    return og(0, u.scrollbarState.topY || 0);
                });
                var s = o.selectAll("." + Ia.cn.scrollbarGlyph).data(gu.repeat, gu.keyFun);
                s.enter().append("line").classed(Ia.cn.scrollbarGlyph, !0).attr("stroke", "black").attr("stroke-width", Ia.scrollbarWidth).attr("stroke-linecap", "round").attr("y1", Ia.scrollbarWidth / 2), s.attr("y2", function(u) {
                    return u.scrollbarState.barLength - Ia.scrollbarWidth / 2;
                }).attr("stroke-opacity", function(u) {
                    return u.columnDragInProgress || !u.scrollbarState.barWiggleRoom || r ? 0 : .4;
                }), s.transition().delay(0).duration(0), s.transition().delay(Ia.scrollbarHideDelay).duration(Ia.scrollbarHideDuration).attr("stroke-opacity", 0);
                var l = a.selectAll("." + Ia.cn.scrollbarCaptureZone).data(gu.repeat, gu.keyFun);
                l.enter().append("line").classed(Ia.cn.scrollbarCaptureZone, !0).attr("stroke", "white").attr("stroke-opacity", .01).attr("stroke-width", Ia.scrollbarCaptureWidth).attr("stroke-linecap", "butt").attr("y1", 0).on("mousedown", function(u) {
                    var c = Mc.event.y, f = this.getBoundingClientRect(), h = u.scrollbarState, d = c - f.top, v = Mc.scale.linear().domain([
                        0,
                        h.scrollableAreaHeight
                    ]).range([
                        0,
                        h.totalHeight
                    ]).clamp(!0);
                    h.topY <= d && d <= h.bottomY || R7(t, e, null, v(d - h.barLength / 2))(u);
                }).call(Mc.behavior.drag().origin(function(u) {
                    return Mc.event.stopPropagation(), u.scrollbarState.scrollbarScrollInProgress = !0, u;
                }).on("drag", R7(t, e)).on("dragend", function() {})), l.attr("y2", function(u) {
                    return u.scrollbarState.scrollableAreaHeight;
                }), t._context.staticPlot && (s.remove(), l.remove());
            }
            function t$(e, t, r, n) {
                var i = VZt(r), a = HZt(i);
                ZZt(a);
                var o = GZt(a);
                YZt(o);
                var s = WZt(a), l = jZt(s);
                XZt(l), nZe(l, t, n, e), s$(a);
            }
            function VZt(e) {
                var t = e.selectAll("." + Ia.cn.columnCells).data(gu.repeat, gu.keyFun);
                return t.enter().append("g").classed(Ia.cn.columnCells, !0), t.exit().remove(), t;
            }
            function HZt(e) {
                var t = e.selectAll("." + Ia.cn.columnCell).data(rZe.splitToCells, function(r) {
                    return r.keyWithinBlock;
                });
                return t.enter().append("g").classed(Ia.cn.columnCell, !0), t.exit().remove(), t;
            }
            function GZt(e) {
                var t = e.selectAll("." + Ia.cn.cellRect).data(gu.repeat, function(r) {
                    return r.keyWithinBlock;
                });
                return t.enter().append("rect").classed(Ia.cn.cellRect, !0), t;
            }
            function jZt(e) {
                var t = e.selectAll("." + Ia.cn.cellText).data(gu.repeat, function(r) {
                    return r.keyWithinBlock;
                });
                return t.enter().append("text").classed(Ia.cn.cellText, !0).style("cursor", function() {
                    return "auto";
                }).on("mousedown", function() {
                    Mc.event.stopPropagation();
                }), t;
            }
            function WZt(e) {
                var t = e.selectAll("." + Ia.cn.cellTextHolder).data(gu.repeat, function(r) {
                    return r.keyWithinBlock;
                });
                return t.enter().append("g").classed(Ia.cn.cellTextHolder, !0).style("shape-rendering", "geometricPrecision"), t;
            }
            function ZZt(e) {
                e.each(function(t, r) {
                    var n = t.calcdata.cells.font, i = t.column.specIndex, a = {
                        size: Xv(n.size, i, r),
                        color: Xv(n.color, i, r),
                        family: Xv(n.family, i, r),
                        weight: Xv(n.weight, i, r),
                        style: Xv(n.style, i, r),
                        variant: Xv(n.variant, i, r),
                        textcase: Xv(n.textcase, i, r),
                        lineposition: Xv(n.lineposition, i, r),
                        shadow: Xv(n.shadow, i, r)
                    };
                    t.rowNumber = t.key, t.align = Xv(t.calcdata.cells.align, i, r), t.cellBorderWidth = Xv(t.calcdata.cells.line.width, i, r), t.font = a;
                });
            }
            function XZt(e) {
                e.each(function(t) {
                    e$.font(Mc.select(this), t.font);
                });
            }
            function YZt(e) {
                e.attr("width", function(t) {
                    return t.column.columnWidth;
                }).attr("stroke-width", function(t) {
                    return t.cellBorderWidth;
                }).each(function(t) {
                    var r = Mc.select(this);
                    KWe.stroke(r, Xv(t.calcdata.cells.line.color, t.column.specIndex, t.rowNumber)), KWe.fill(r, Xv(t.calcdata.cells.fill.color, t.column.specIndex, t.rowNumber));
                });
            }
            function nZe(e, t, r, n) {
                e.text(function(i) {
                    var a = i.column.specIndex, o = i.rowNumber, s = i.value, l = typeof s == "string", u = l && s.match(/<br>/i), c = !l || u;
                    i.mayHaveMarkup = l && s.match(/[<&>]/);
                    var f = KZt(s);
                    i.latex = f;
                    var h = f ? "" : Xv(i.calcdata.cells.prefix, a, o) || "", d = f ? "" : Xv(i.calcdata.cells.suffix, a, o) || "", v = f ? null : Xv(i.calcdata.cells.format, a, o) || null, x = h + (v ? qZt(v)(i.value) : i.value) + d, b;
                    i.wrappingNeeded = !i.wrapped && !c && !f && (b = QWe(x)), i.cellHeightMayIncrease = u || f || i.mayHaveMarkup || (b === void 0 ? QWe(x) : b), i.needsConvertToTspans = i.mayHaveMarkup || i.wrappingNeeded || i.latex;
                    var p;
                    if (i.wrappingNeeded) {
                        var E = Ia.wrapSplitCharacter === " " ? x.replace(/<a href=/ig, "<a_href=") : x, k = E.split(Ia.wrapSplitCharacter), A = Ia.wrapSplitCharacter === " " ? k.map(function(L) {
                            return L.replace(/<a_href=/ig, "<a href=");
                        }) : k;
                        i.fragments = A.map(function(L) {
                            return {
                                text: L,
                                width: null
                            };
                        }), i.fragments.push({
                            fragment: Ia.wrapSpacer,
                            width: null
                        }), p = A.join(Ia.lineBreaker) + Ia.lineBreaker + Ia.wrapSpacer;
                    } else delete i.fragments, p = x;
                    return p;
                }).attr("dy", function(i) {
                    return i.needsConvertToTspans ? 0 : "0.75em";
                }).each(function(i) {
                    var a = this, o = Mc.select(a), s = i.wrappingNeeded ? eXt : tXt;
                    i.needsConvertToTspans ? OZt.convertToTspans(o, n, s(r, a, t, n, i)) : Mc.select(a.parentNode).attr("transform", function(l) {
                        return og(aZe(l), Ia.cellPad);
                    }).attr("text-anchor", function(l) {
                        return ({
                            left: "start",
                            center: "middle",
                            right: "end"
                        })[l.align];
                    });
                });
            }
            function KZt(e) {
                return typeof e == "string" && e.match(Ia.latexCheck);
            }
            function QWe(e) {
                return e.indexOf(Ia.wrapSplitCharacter) !== -1;
            }
            function JZt(e, t, r) {
                var n = t.gdColumnsOriginalOrder;
                t.gdColumns.sort(function(i, a) {
                    return r[n.indexOf(i)] - r[n.indexOf(a)];
                }), t.columnorder = r, e.emit("plotly_restyle");
            }
            function Xv(e, t, r) {
                if (QJ.isArrayOrTypedArray(e)) {
                    var n = e[Math.min(t, e.length - 1)];
                    return QJ.isArrayOrTypedArray(n) ? n[Math.min(r, n.length - 1)] : n;
                } else return e;
            }
            function eZe(e, t, r) {
                e.transition().ease(Ia.releaseTransitionEase).duration(Ia.releaseTransitionDuration).attr("transform", og(t.x, r));
            }
            function a$(e) {
                return e.type === "cells";
            }
            function $Zt(e) {
                return e.type === "header";
            }
            function r$(e) {
                var t = e.rowBlocks.length ? e.rowBlocks[0].auxiliaryBlocks : [];
                return t.reduce(function(r, n) {
                    return r + D7(n, 1 / 0);
                }, 0);
            }
            function QZt(e, t, r) {
                for(var n = [], i = 0, a = 0; a < e.length; a++){
                    for(var o = e[a], s = o.rows, l = 0, u = 0; u < s.length; u++)l += s[u].rowHeight;
                    o.allRowsHeight = l;
                    var c = i + l, f = t, h = f + r;
                    f < c && h > i && n.push(a), i += l;
                }
                return n;
            }
            function o$(e, t, r) {
                var n = iZe(t)[0];
                if (n !== void 0) {
                    var i = n.rowBlocks, a = n.calcdata, o = i$(i, i.length), s = n.calcdata.groupHeight - r$(n), l = a.scrollY = Math.max(0, Math.min(o - s, a.scrollY)), u = QZt(i, l, s);
                    u.length === 1 && (u[0] === i.length - 1 ? u.unshift(u[0] - 1) : u.push(u[0] + 1)), u[0] % 2 && u.reverse(), t.each(function(c, f) {
                        c.page = u[f], c.scrollY = l;
                    }), t.attr("transform", function(c) {
                        var f = i$(c.rowBlocks, c.page) - c.scrollY;
                        return og(0, f);
                    }), e && (tZe(e, r, t, u, n.prevPages, n, 0), tZe(e, r, t, u, n.prevPages, n, 1), Jk(r, e));
                }
            }
            function R7(e, t, r, n) {
                return function(a) {
                    var o = a.calcdata ? a.calcdata : a, s = t.filter(function(f) {
                        return o.key === f.key;
                    }), l = r || o.scrollbarState.dragMultiplier, u = o.scrollY;
                    o.scrollY = n === void 0 ? o.scrollY + l * Mc.event.dy : n;
                    var c = s.selectAll("." + Ia.cn.yColumn).selectAll("." + Ia.cn.columnBlock).filter(a$);
                    return o$(e, c, s), o.scrollY === u;
                };
            }
            function tZe(e, t, r, n, i, a, o) {
                var s = n[o] !== i[o];
                s && (clearTimeout(a.currentRepaint[o]), a.currentRepaint[o] = setTimeout(function() {
                    var l = r.filter(function(u, c) {
                        return c === o && n[c] !== i[c];
                    });
                    t$(e, t, l, r), i[o] = n[o];
                }));
            }
            function eXt(e, t, r, n) {
                return function() {
                    var a = Mc.select(t.parentNode);
                    a.each(function(o) {
                        var s = o.fragments;
                        a.selectAll("tspan.line").each(function(x, b) {
                            s[b].width = this.getComputedTextLength();
                        });
                        var l = s[s.length - 1].width, u = s.slice(0, -1), c = [], f, h, d = 0, v = o.column.columnWidth - 2 * Ia.cellPad;
                        for(o.value = ""; u.length;)f = u.shift(), h = f.width + l, d + h > v && (o.value += c.join(Ia.wrapSpacer) + Ia.lineBreaker, c = [], d = 0), c.push(f.text), d += h;
                        d && (o.value += c.join(Ia.wrapSpacer)), o.wrapped = !0;
                    }), a.selectAll("tspan.line").remove(), nZe(a.select("." + Ia.cn.cellText), r, e, n), Mc.select(t.parentNode.parentNode).call(s$);
                };
            }
            function tXt(e, t, r, n, i) {
                return function() {
                    if (!i.settledY) {
                        var o = Mc.select(t.parentNode), s = n$(i), l = i.key - s.firstRowIndex, u = s.rows[l].rowHeight, c = i.cellHeightMayIncrease ? t.parentNode.getBoundingClientRect().height + 2 * Ia.cellPad : u, f = Math.max(c, u), h = f - s.rows[l].rowHeight;
                        h && (s.rows[l].rowHeight = f, e.selectAll("." + Ia.cn.columnCell).call(s$), o$(null, e.filter(a$), 0), Jk(r, n, !0)), o.attr("transform", function() {
                            var d = this, v = d.parentNode, x = v.getBoundingClientRect(), b = Mc.select(d.parentNode).select("." + Ia.cn.cellRect).node().getBoundingClientRect(), p = d.transform.baseVal.consolidate(), E = b.top - x.top + (p ? p.matrix.f : Ia.cellPad);
                            return og(aZe(i, Mc.select(d.parentNode).select("." + Ia.cn.cellTextHolder).node().getBoundingClientRect().width), E);
                        }), i.settledY = !0;
                    }
                };
            }
            function aZe(e, t) {
                switch(e.align){
                    case "left":
                        return Ia.cellPad;
                    case "right":
                        return e.column.columnWidth - (t || 0) - Ia.cellPad;
                    case "center":
                        return (e.column.columnWidth - (t || 0)) / 2;
                    default:
                        return Ia.cellPad;
                }
            }
            function s$(e) {
                e.attr("transform", function(t) {
                    var r = t.rowBlocks[0].auxiliaryBlocks.reduce(function(o, s) {
                        return o + D7(s, 1 / 0);
                    }, 0), n = n$(t), i = D7(n, t.key), a = i + r;
                    return og(0, a);
                }).selectAll("." + Ia.cn.cellRect).attr("height", function(t) {
                    return iXt(n$(t), t.key).rowHeight;
                });
            }
            function i$(e, t) {
                for(var r = 0, n = t - 1; n >= 0; n--)r += rXt(e[n]);
                return r;
            }
            function D7(e, t) {
                for(var r = 0, n = 0; n < e.rows.length && e.rows[n].rowIndex < t; n++)r += e.rows[n].rowHeight;
                return r;
            }
            function rXt(e) {
                var t = e.allRowsHeight;
                if (t !== void 0) return t;
                for(var r = 0, n = 0; n < e.rows.length; n++)r += e.rows[n].rowHeight;
                return e.allRowsHeight = r, r;
            }
            function n$(e) {
                return e.rowBlocks[e.page];
            }
            function iXt(e, t) {
                return e.rows[t - e.firstRowIndex];
            }
        });
        var sZe = ye((F7)=>{
            "use strict";
            var nXt = kd().getModuleCalcData, aXt = l$(), z7 = "table";
            F7.name = z7;
            F7.plot = function(e) {
                var t = nXt(e.calcdata, z7)[0];
                t.length && aXt(e, t);
            };
            F7.clean = function(e, t, r, n) {
                var i = n._has && n._has(z7), a = t._has && t._has(z7);
                i && !a && n._paperdiv.selectAll(".table").remove();
            };
        });
        var uZe = ye((G_r, lZe)=>{
            "use strict";
            lZe.exports = {
                attributes: WJ(),
                supplyDefaults: FWe(),
                calc: OWe(),
                plot: l$(),
                moduleType: "trace",
                name: "table",
                basePlotModule: sZe(),
                categories: [
                    "noOpacity"
                ],
                meta: {}
            };
        });
        var fZe = ye((j_r, cZe)=>{
            "use strict";
            cZe.exports = uZe();
        });
        var gZe = ye((W_r, pZe)=>{
            "use strict";
            var hZe = Su(), dZe = dh(), u$ = Cd(), oXt = Oc().descriptionWithDates, sXt = Bu().overrideAll, vZe = Ed().dash, c$ = no().extendFlat;
            pZe.exports = {
                color: {
                    valType: "color",
                    editType: "calc"
                },
                smoothing: {
                    valType: "number",
                    dflt: 1,
                    min: 0,
                    max: 1.3,
                    editType: "calc"
                },
                title: {
                    text: {
                        valType: "string",
                        dflt: "",
                        editType: "calc"
                    },
                    font: hZe({
                        editType: "calc"
                    }),
                    offset: {
                        valType: "number",
                        dflt: 10,
                        editType: "calc"
                    },
                    editType: "calc"
                },
                type: {
                    valType: "enumerated",
                    values: [
                        "-",
                        "linear",
                        "date",
                        "category"
                    ],
                    dflt: "-",
                    editType: "calc"
                },
                autotypenumbers: u$.autotypenumbers,
                autorange: {
                    valType: "enumerated",
                    values: [
                        !0,
                        !1,
                        "reversed"
                    ],
                    dflt: !0,
                    editType: "calc"
                },
                rangemode: {
                    valType: "enumerated",
                    values: [
                        "normal",
                        "tozero",
                        "nonnegative"
                    ],
                    dflt: "normal",
                    editType: "calc"
                },
                range: {
                    valType: "info_array",
                    editType: "calc",
                    items: [
                        {
                            valType: "any",
                            editType: "calc"
                        },
                        {
                            valType: "any",
                            editType: "calc"
                        }
                    ]
                },
                fixedrange: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "calc"
                },
                cheatertype: {
                    valType: "enumerated",
                    values: [
                        "index",
                        "value"
                    ],
                    dflt: "value",
                    editType: "calc"
                },
                tickmode: {
                    valType: "enumerated",
                    values: [
                        "linear",
                        "array"
                    ],
                    dflt: "array",
                    editType: "calc"
                },
                nticks: {
                    valType: "integer",
                    min: 0,
                    dflt: 0,
                    editType: "calc"
                },
                tickvals: {
                    valType: "data_array",
                    editType: "calc"
                },
                ticktext: {
                    valType: "data_array",
                    editType: "calc"
                },
                showticklabels: {
                    valType: "enumerated",
                    values: [
                        "start",
                        "end",
                        "both",
                        "none"
                    ],
                    dflt: "start",
                    editType: "calc"
                },
                labelalias: c$({}, u$.labelalias, {
                    editType: "calc"
                }),
                tickfont: hZe({
                    editType: "calc"
                }),
                tickangle: {
                    valType: "angle",
                    dflt: "auto",
                    editType: "calc"
                },
                tickprefix: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                showtickprefix: {
                    valType: "enumerated",
                    values: [
                        "all",
                        "first",
                        "last",
                        "none"
                    ],
                    dflt: "all",
                    editType: "calc"
                },
                ticksuffix: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                showticksuffix: {
                    valType: "enumerated",
                    values: [
                        "all",
                        "first",
                        "last",
                        "none"
                    ],
                    dflt: "all",
                    editType: "calc"
                },
                showexponent: {
                    valType: "enumerated",
                    values: [
                        "all",
                        "first",
                        "last",
                        "none"
                    ],
                    dflt: "all",
                    editType: "calc"
                },
                exponentformat: {
                    valType: "enumerated",
                    values: [
                        "none",
                        "e",
                        "E",
                        "power",
                        "SI",
                        "B"
                    ],
                    dflt: "B",
                    editType: "calc"
                },
                minexponent: {
                    valType: "number",
                    dflt: 3,
                    min: 0,
                    editType: "calc"
                },
                separatethousands: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "calc"
                },
                tickformat: {
                    valType: "string",
                    dflt: "",
                    editType: "calc",
                    description: oXt("tick label")
                },
                tickformatstops: sXt(u$.tickformatstops, "calc", "from-root"),
                categoryorder: {
                    valType: "enumerated",
                    values: [
                        "trace",
                        "category ascending",
                        "category descending",
                        "array"
                    ],
                    dflt: "trace",
                    editType: "calc"
                },
                categoryarray: {
                    valType: "data_array",
                    editType: "calc"
                },
                labelpadding: {
                    valType: "integer",
                    dflt: 10,
                    editType: "calc"
                },
                labelprefix: {
                    valType: "string",
                    editType: "calc"
                },
                labelsuffix: {
                    valType: "string",
                    dflt: "",
                    editType: "calc"
                },
                showline: {
                    valType: "boolean",
                    dflt: !1,
                    editType: "calc"
                },
                linecolor: {
                    valType: "color",
                    dflt: dZe.defaultLine,
                    editType: "calc"
                },
                linewidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "calc"
                },
                gridcolor: {
                    valType: "color",
                    editType: "calc"
                },
                gridwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "calc"
                },
                griddash: c$({}, vZe, {
                    editType: "calc"
                }),
                showgrid: {
                    valType: "boolean",
                    dflt: !0,
                    editType: "calc"
                },
                minorgridcount: {
                    valType: "integer",
                    min: 0,
                    dflt: 0,
                    editType: "calc"
                },
                minorgridwidth: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "calc"
                },
                minorgriddash: c$({}, vZe, {
                    editType: "calc"
                }),
                minorgridcolor: {
                    valType: "color",
                    dflt: dZe.lightLine,
                    editType: "calc"
                },
                startline: {
                    valType: "boolean",
                    editType: "calc"
                },
                startlinecolor: {
                    valType: "color",
                    editType: "calc"
                },
                startlinewidth: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc"
                },
                endline: {
                    valType: "boolean",
                    editType: "calc"
                },
                endlinewidth: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc"
                },
                endlinecolor: {
                    valType: "color",
                    editType: "calc"
                },
                tick0: {
                    valType: "number",
                    min: 0,
                    dflt: 0,
                    editType: "calc"
                },
                dtick: {
                    valType: "number",
                    min: 0,
                    dflt: 1,
                    editType: "calc"
                },
                arraytick0: {
                    valType: "integer",
                    min: 0,
                    dflt: 0,
                    editType: "calc"
                },
                arraydtick: {
                    valType: "integer",
                    min: 1,
                    dflt: 1,
                    editType: "calc"
                },
                editType: "calc"
            };
        });
        var O7 = ye((Z_r, _Ze)=>{
            "use strict";
            var lXt = Su(), mZe = gZe(), yZe = dh(), q7 = lXt({
                editType: "calc"
            }), uXt = Uc().zorder;
            q7.family.dflt = '"Open Sans", verdana, arial, sans-serif';
            q7.size.dflt = 12;
            q7.color.dflt = yZe.defaultLine;
            _Ze.exports = {
                carpet: {
                    valType: "string",
                    editType: "calc"
                },
                x: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                y: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                a: {
                    valType: "data_array",
                    editType: "calc"
                },
                a0: {
                    valType: "number",
                    dflt: 0,
                    editType: "calc"
                },
                da: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc"
                },
                b: {
                    valType: "data_array",
                    editType: "calc"
                },
                b0: {
                    valType: "number",
                    dflt: 0,
                    editType: "calc"
                },
                db: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc"
                },
                cheaterslope: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc"
                },
                aaxis: mZe,
                baxis: mZe,
                font: q7,
                color: {
                    valType: "color",
                    dflt: yZe.defaultLine,
                    editType: "plot"
                },
                zorder: uXt
            };
        });
        var wZe = ye((X_r, bZe)=>{
            "use strict";
            var xZe = Mr().isArray1D;
            bZe.exports = function(t, r, n) {
                var i = n("x"), a = i && i.length, o = n("y"), s = o && o.length;
                if (!a && !s) return !1;
                if (r._cheater = !i, (!a || xZe(i)) && (!s || xZe(o))) {
                    var l = a ? i.length : 1 / 0;
                    s && (l = Math.min(l, o.length)), r.a && r.a.length && (l = Math.min(l, r.a.length)), r.b && r.b.length && (l = Math.min(l, r.b.length)), r._length = l;
                } else r._length = null;
                return !0;
            };
        });
        var SZe = ye((Y_r, AZe)=>{
            "use strict";
            var cXt = O7(), TZe = va().addOpacity, fXt = ba(), $k = Mr(), hXt = xb(), dXt = t_(), vXt = r_(), pXt = eI(), gXt = ym(), mXt = L3();
            AZe.exports = function(t, r, n) {
                var i = n.letter, a = n.font || {}, o = cXt[i + "axis"];
                function s(g, P) {
                    return $k.coerce(t, r, o, g, P);
                }
                function l(g, P) {
                    return $k.coerce2(t, r, o, g, P);
                }
                n.name && (r._name = n.name, r._id = n.name), s("autotypenumbers", n.autotypenumbersDflt);
                var u = s("type");
                if (u === "-" && (n.data && yXt(r, n.data), r.type === "-" ? r.type = "linear" : u = t.type = r.type), s("smoothing"), s("cheatertype"), s("showticklabels"), s("labelprefix", i + " = "), s("labelsuffix"), s("showtickprefix"), s("showticksuffix"), s("separatethousands"), s("tickformat"), s("exponentformat"), s("minexponent"), s("showexponent"), s("categoryorder"), s("tickmode"), s("tickvals"), s("ticktext"), s("tick0"), s("dtick"), r.tickmode === "array" && (s("arraytick0"), s("arraydtick")), s("labelpadding"), r._hovertitle = i, u === "date") {
                    var c = fXt.getComponentMethod("calendars", "handleDefaults");
                    c(t, r, "calendar", n.calendar);
                }
                gXt(r, n.fullLayout), r.c2p = $k.identity;
                var f = s("color", n.dfltColor), h = f === t.color ? f : a.color, d = s("title.text");
                d && ($k.coerceFont(s, "title.font", a, {
                    overrideDflt: {
                        size: $k.bigFont(a.size),
                        color: h
                    }
                }), s("title.offset")), s("tickangle");
                var v = s("autorange", !r.isValidRange(t.range));
                v && s("rangemode"), s("range"), r.cleanRange(), s("fixedrange"), hXt(t, r, s, u), vXt(t, r, s, u, n), dXt(t, r, s, u, n), pXt(t, r, s, {
                    data: n.data,
                    dataAttr: i
                });
                var x = l("gridcolor", TZe(f, .3)), b = l("gridwidth"), p = l("griddash"), E = s("showgrid");
                E || (delete r.gridcolor, delete r.gridwidth, delete r.griddash);
                var k = l("startlinecolor", f), A = l("startlinewidth", b), L = s("startline", r.showgrid || !!k || !!A);
                L || (delete r.startlinecolor, delete r.startlinewidth);
                var _ = l("endlinecolor", f), C = l("endlinewidth", b), M = s("endline", r.showgrid || !!_ || !!C);
                return M || (delete r.endlinecolor, delete r.endlinewidth), E ? (s("minorgridcount"), s("minorgridwidth", b), s("minorgriddash", p), s("minorgridcolor", TZe(x, .06)), r.minorgridcount || (delete r.minorgridwidth, delete r.minorgriddash, delete r.minorgridcolor)) : (delete r.gridcolor, delete r.gridwidth, delete r.griddash), r.showticklabels === "none" && (delete r.tickfont, delete r.tickangle, delete r.showexponent, delete r.exponentformat, delete r.minexponent, delete r.tickformat, delete r.showticksuffix, delete r.showtickprefix), r.showticksuffix || delete r.ticksuffix, r.showtickprefix || delete r.tickprefix, s("tickmode"), r;
            };
            function yXt(e, t) {
                if (e.type === "-") {
                    var r = e._id, n = r.charAt(0), i = n + "calendar", a = e[i];
                    e.type = mXt(t, a, {
                        autotypenumbers: e.autotypenumbers
                    });
                }
            }
        });
        var EZe = ye((K_r, MZe)=>{
            "use strict";
            var _Xt = SZe(), xXt = Vs();
            MZe.exports = function(t, r, n, i, a) {
                var o = i("a");
                o || (i("da"), i("a0"));
                var s = i("b");
                s || (i("db"), i("b0")), bXt(t, r, n, a);
            };
            function bXt(e, t, r, n) {
                var i = [
                    "aaxis",
                    "baxis"
                ];
                i.forEach(function(a) {
                    var o = a.charAt(0), s = e[a] || {}, l = xXt.newContainer(t, a), u = {
                        noAutotickangles: !0,
                        noTicklabelshift: !0,
                        noTicklabelstandoff: !0,
                        noTicklabelstep: !0,
                        tickfont: "x",
                        id: o + "axis",
                        letter: o,
                        font: t.font,
                        name: a,
                        data: e[o],
                        calendar: t.calendar,
                        dfltColor: n,
                        bgColor: r.paper_bgcolor,
                        autotypenumbersDflt: r.autotypenumbers,
                        fullLayout: r
                    };
                    _Xt(s, l, u), l._categories = l._categories || [], !e[a] && s.type !== "-" && (e[a] = {
                        type: s.type
                    });
                });
            }
        });
        var LZe = ye((J_r, CZe)=>{
            "use strict";
            var kZe = Mr(), wXt = wZe(), TXt = EZe(), AXt = O7(), SXt = dh();
            CZe.exports = function(t, r, n, i) {
                function a(l, u) {
                    return kZe.coerce(t, r, AXt, l, u);
                }
                r._clipPathId = "clip" + r.uid + "carpet";
                var o = a("color", SXt.defaultLine);
                if (kZe.coerceFont(a, "font", i.font), a("carpet"), TXt(t, r, i, a, o), !r.a || !r.b) {
                    r.visible = !1;
                    return;
                }
                r.a.length < 3 && (r.aaxis.smoothing = 0), r.b.length < 3 && (r.baxis.smoothing = 0);
                var s = wXt(t, r, a);
                s || (r.visible = !1), r._cheater && a("cheaterslope"), a("zorder");
            };
        });
        var f$ = ye(($_r, PZe)=>{
            "use strict";
            var MXt = Mr().isArrayOrTypedArray;
            PZe.exports = function(t, r, n) {
                var i;
                for(MXt(t) ? t.length > r.length && (t = t.slice(0, r.length)) : t = [], i = 0; i < r.length; i++)t[i] = n(r[i]);
                return t;
            };
        });
        var h$ = ye((Q_r, IZe)=>{
            "use strict";
            IZe.exports = function(t, r, n) {
                if (t.length === 0) return "";
                var i, a = [], o = n ? 3 : 1;
                for(i = 0; i < t.length; i += o)a.push(t[i] + "," + r[i]), n && i < t.length - o && (a.push("C"), a.push([
                    t[i + 1] + "," + r[i + 1],
                    t[i + 2] + "," + r[i + 2] + " "
                ].join(" ")));
                return a.join(n ? "" : "L");
            };
        });
        var DZe = ye((exr, RZe)=>{
            "use strict";
            RZe.exports = function(t, r, n, i, a, o) {
                var s = a[0] * t.dpdx(r), l = a[1] * t.dpdy(n), u = 1, c = 1;
                if (o) {
                    var f = Math.sqrt(a[0] * a[0] + a[1] * a[1]), h = Math.sqrt(o[0] * o[0] + o[1] * o[1]), d = (a[0] * o[0] + a[1] * o[1]) / f / h;
                    c = Math.max(0, d);
                }
                var v = Math.atan2(l, s) * 180 / Math.PI;
                return v < -90 ? (v += 180, u = -u) : v > 90 && (v -= 180, u = -u), {
                    angle: v,
                    flip: u,
                    p: t.c2p(i, r, n),
                    offsetMultplier: c
                };
            };
        });
        var VZe = ye((txr, UZe)=>{
            "use strict";
            var V7 = xa(), B7 = ao(), N7 = f$(), qZe = h$(), Qk = DZe(), d$ = Pl(), Up = Mr(), OZe = Up.strRotate, U7 = Up.strTranslate, BZe = Nh();
            UZe.exports = function(t, r, n, i) {
                var a = t._context.staticPlot, o = r.xaxis, s = r.yaxis, l = t._fullLayout, u = l._clips;
                Up.makeTraceGroups(i, n, "trace").each(function(c) {
                    var f = V7.select(this), h = c[0], d = h.trace, v = d.aaxis, x = d.baxis, b = Up.ensureSingle(f, "g", "minorlayer"), p = Up.ensureSingle(f, "g", "majorlayer"), E = Up.ensureSingle(f, "g", "boundarylayer"), k = Up.ensureSingle(f, "g", "labellayer");
                    f.style("opacity", d.opacity), zA(o, s, p, v, "a", v._gridlines, !0, a), zA(o, s, p, x, "b", x._gridlines, !0, a), zA(o, s, b, v, "a", v._minorgridlines, !0, a), zA(o, s, b, x, "b", x._minorgridlines, !0, a), zA(o, s, E, v, "a-boundary", v._boundarylines, a), zA(o, s, E, x, "b-boundary", x._boundarylines, a);
                    var A = zZe(t, o, s, d, h, k, v._labels, "a-label"), L = zZe(t, o, s, d, h, k, x._labels, "b-label");
                    kXt(t, k, d, h, o, s, A, L), EXt(d, h, u, o, s);
                });
            };
            function EXt(e, t, r, n, i) {
                var a, o, s, l, u = r.select("#" + e._clipPathId);
                u.size() || (u = r.append("clipPath").classed("carpetclip", !0));
                var c = Up.ensureSingle(u, "path", "carpetboundary"), f = t.clipsegments, h = [];
                for(l = 0; l < f.length; l++)a = f[l], o = N7([], a.x, n.c2p), s = N7([], a.y, i.c2p), h.push(qZe(o, s, a.bicubic));
                var d = "M" + h.join("L") + "Z";
                u.attr("id", e._clipPathId), c.attr("d", d);
            }
            function zA(e, t, r, n, i, a, o) {
                var s = "const-" + i + "-lines", l = r.selectAll("." + s).data(a);
                l.enter().append("path").classed(s, !0).style("vector-effect", o ? "none" : "non-scaling-stroke"), l.each(function(u) {
                    var c = u, f = c.x, h = c.y, d = N7([], f, e.c2p), v = N7([], h, t.c2p), x = "M" + qZe(d, v, c.smoothing), b = V7.select(this);
                    b.attr("d", x).style("stroke-width", c.width).style("stroke", c.color).style("stroke-dasharray", B7.dashStyle(c.dash, c.width)).style("fill", "none");
                }), l.exit().remove();
            }
            function zZe(e, t, r, n, i, a, o, s) {
                var l = a.selectAll("text." + s).data(o);
                l.enter().append("text").classed(s, !0);
                var u = 0, c = {};
                return l.each(function(f, h) {
                    var d;
                    if (f.axis.tickangle === "auto") d = Qk(n, t, r, f.xy, f.dxy);
                    else {
                        var v = (f.axis.tickangle + 180) * Math.PI / 180;
                        d = Qk(n, t, r, f.xy, [
                            Math.cos(v),
                            Math.sin(v)
                        ]);
                    }
                    h || (c = {
                        angle: d.angle,
                        flip: d.flip
                    });
                    var x = (f.endAnchor ? -1 : 1) * d.flip, b = V7.select(this).attr({
                        "text-anchor": x > 0 ? "start" : "end",
                        "data-notex": 1
                    }).call(B7.font, f.font).text(f.text).call(d$.convertToTspans, e), p = B7.bBox(this);
                    b.attr("transform", U7(d.p[0], d.p[1]) + OZe(d.angle) + U7(f.axis.labelpadding * x, p.height * .3)), u = Math.max(u, p.width + f.axis.labelpadding);
                }), l.exit().remove(), c.maxExtent = u, c;
            }
            function kXt(e, t, r, n, i, a, o, s) {
                var l, u, c, f, h = Up.aggNums(Math.min, null, r.a), d = Up.aggNums(Math.max, null, r.a), v = Up.aggNums(Math.min, null, r.b), x = Up.aggNums(Math.max, null, r.b);
                l = .5 * (h + d), u = v, c = r.ab2xy(l, u, !0), f = r.dxyda_rough(l, u), o.angle === void 0 && Up.extendFlat(o, Qk(r, i, a, c, r.dxydb_rough(l, u))), FZe(e, t, r, n, c, f, r.aaxis, i, a, o, "a-title"), l = h, u = .5 * (v + x), c = r.ab2xy(l, u, !0), f = r.dxydb_rough(l, u), s.angle === void 0 && Up.extendFlat(s, Qk(r, i, a, c, r.dxyda_rough(l, u))), FZe(e, t, r, n, c, f, r.baxis, i, a, s, "b-title");
            }
            var NZe = BZe.LINE_SPACING, CXt = (1 - BZe.MID_SHIFT) / NZe + 1;
            function FZe(e, t, r, n, i, a, o, s, l, u, c) {
                var f = [];
                o.title.text && f.push(o.title.text);
                var h = t.selectAll("text." + c).data(f), d = u.maxExtent;
                h.enter().append("text").classed(c, !0), h.each(function() {
                    var v = Qk(r, s, l, i, a);
                    [
                        "start",
                        "both"
                    ].indexOf(o.showticklabels) === -1 && (d = 0);
                    var x = o.title.font.size;
                    d += x + o.title.offset;
                    var b = u.angle + (u.flip < 0 ? 180 : 0), p = (b - v.angle + 450) % 360, E = p > 90 && p < 270, k = V7.select(this);
                    k.text(o.title.text).call(d$.convertToTspans, e), E && (d = (-d$.lineCount(k) + CXt) * NZe * x - d), k.attr("transform", U7(v.p[0], v.p[1]) + OZe(v.angle) + U7(0, d)).attr("text-anchor", "middle").call(B7.font, o.title.font);
                }), h.exit().remove();
            }
        });
        var GZe = ye((rxr, HZe)=>{
            "use strict";
            var H7 = Mr().isArrayOrTypedArray;
            HZe.exports = function(e, t, r) {
                var n, i, a, o, s, l, u = [], c = H7(e) ? e.length : e, f = H7(t) ? t.length : t, h = H7(e) ? e : null, d = H7(t) ? t : null;
                h && (a = (h.length - 1) / (h[h.length - 1] - h[0]) / (c - 1)), d && (o = (d.length - 1) / (d[d.length - 1] - d[0]) / (f - 1));
                var v, x = 1 / 0, b = -1 / 0;
                for(i = 0; i < f; i++)for(u[i] = [], l = d ? (d[i] - d[0]) * o : i / (f - 1), n = 0; n < c; n++)s = h ? (h[n] - h[0]) * a : n / (c - 1), v = s - l * r, x = Math.min(v, x), b = Math.max(v, b), u[i][n] = v;
                var p = 1 / (b - x), E = -x * p;
                for(i = 0; i < f; i++)for(n = 0; n < c; n++)u[i][n] = p * u[i][n] + E;
                return u;
            };
        });
        var XZe = ye((ixr, ZZe)=>{
            "use strict";
            var jZe = Mr().isArrayOrTypedArray;
            ZZe.exports = function(e) {
                return WZe(e, 0);
            };
            function WZe(e, t) {
                if (!jZe(e) || t >= 10) return null;
                for(var r = 1 / 0, n = -1 / 0, i = e.length, a = 0; a < i; a++){
                    var o = e[a];
                    if (jZe(o)) {
                        var s = WZe(o, t + 1);
                        s && (r = Math.min(s[0], r), n = Math.max(s[1], n));
                    } else r = Math.min(o, r), n = Math.max(o, n);
                }
                return [
                    r,
                    n
                ];
            }
        });
        var KZe = ye((nxr, YZe)=>{
            "use strict";
            var LXt = Qa(), kx = no().extendFlat;
            YZe.exports = function(t, r, n) {
                var i, a, o, s, l, u, c, f, h, d, v, x, b, p, E = t["_" + r], k = t[r + "axis"], A = k._gridlines = [], L = k._minorgridlines = [], _ = k._boundarylines = [], C = t["_" + n], M = t[n + "axis"];
                k.tickmode === "array" && (k.tickvals = E.slice());
                var g = t._xctrl, P = t._yctrl, T = g[0].length, F = g.length, q = t._a.length, V = t._b.length;
                LXt.prepTicks(k), k.tickmode === "array" && delete k.tickvals;
                var H = k.smoothing ? 3 : 1;
                function X(N) {
                    var W, re, ae, _e, Me, ke, ge, ie, Te, Ee, Ae, ze, Ce = [], me = [], Re = {};
                    if (r === "b") for(re = t.b2j(N), ae = Math.floor(Math.max(0, Math.min(V - 2, re))), _e = re - ae, Re.length = V, Re.crossLength = q, Re.xy = function(ce) {
                        return t.evalxy([], ce, re);
                    }, Re.dxy = function(ce, Ge) {
                        return t.dxydi([], ce, ae, Ge, _e);
                    }, W = 0; W < q; W++)ke = Math.min(q - 2, W), ge = W - ke, ie = t.evalxy([], W, re), M.smoothing && W > 0 && (Te = t.dxydi([], W - 1, ae, 0, _e), Ce.push(Me[0] + Te[0] / 3), me.push(Me[1] + Te[1] / 3), Ee = t.dxydi([], W - 1, ae, 1, _e), Ce.push(ie[0] - Ee[0] / 3), me.push(ie[1] - Ee[1] / 3)), Ce.push(ie[0]), me.push(ie[1]), Me = ie;
                    else for(W = t.a2i(N), ke = Math.floor(Math.max(0, Math.min(q - 2, W))), ge = W - ke, Re.length = q, Re.crossLength = V, Re.xy = function(ce) {
                        return t.evalxy([], W, ce);
                    }, Re.dxy = function(ce, Ge) {
                        return t.dxydj([], ke, ce, ge, Ge);
                    }, re = 0; re < V; re++)ae = Math.min(V - 2, re), _e = re - ae, ie = t.evalxy([], W, re), M.smoothing && re > 0 && (Ae = t.dxydj([], ke, re - 1, ge, 0), Ce.push(Me[0] + Ae[0] / 3), me.push(Me[1] + Ae[1] / 3), ze = t.dxydj([], ke, re - 1, ge, 1), Ce.push(ie[0] - ze[0] / 3), me.push(ie[1] - ze[1] / 3)), Ce.push(ie[0]), me.push(ie[1]), Me = ie;
                    return Re.axisLetter = r, Re.axis = k, Re.crossAxis = M, Re.value = N, Re.constvar = n, Re.index = f, Re.x = Ce, Re.y = me, Re.smoothing = M.smoothing, Re;
                }
                function G(N) {
                    var W, re, ae, _e, Me, ke = [], ge = [], ie = {};
                    if (ie.length = E.length, ie.crossLength = C.length, r === "b") for(ae = Math.max(0, Math.min(V - 2, N)), Me = Math.min(1, Math.max(0, N - ae)), ie.xy = function(Te) {
                        return t.evalxy([], Te, N);
                    }, ie.dxy = function(Te, Ee) {
                        return t.dxydi([], Te, ae, Ee, Me);
                    }, W = 0; W < T; W++)ke[W] = g[N * H][W], ge[W] = P[N * H][W];
                    else for(re = Math.max(0, Math.min(q - 2, N)), _e = Math.min(1, Math.max(0, N - re)), ie.xy = function(Te) {
                        return t.evalxy([], N, Te);
                    }, ie.dxy = function(Te, Ee) {
                        return t.dxydj([], re, Te, _e, Ee);
                    }, W = 0; W < F; W++)ke[W] = g[W][N * H], ge[W] = P[W][N * H];
                    return ie.axisLetter = r, ie.axis = k, ie.crossAxis = M, ie.value = E[N], ie.constvar = n, ie.index = N, ie.x = ke, ie.y = ge, ie.smoothing = M.smoothing, ie;
                }
                if (k.tickmode === "array") {
                    for(s = 5e-15, l = [
                        Math.floor((E.length - 1 - k.arraytick0) / k.arraydtick * (1 + s)),
                        Math.ceil(-k.arraytick0 / k.arraydtick / (1 + s))
                    ].sort(function(N, W) {
                        return N - W;
                    }), u = l[0] - 1, c = l[1] + 1, f = u; f < c; f++)a = k.arraytick0 + k.arraydtick * f, !(a < 0 || a > E.length - 1) && A.push(kx(G(a), {
                        color: k.gridcolor,
                        width: k.gridwidth,
                        dash: k.griddash
                    }));
                    for(f = u; f < c; f++)if (o = k.arraytick0 + k.arraydtick * f, v = Math.min(o + k.arraydtick, E.length - 1), !(o < 0 || o > E.length - 1) && !(v < 0 || v > E.length - 1)) for(x = E[o], b = E[v], i = 0; i < k.minorgridcount; i++)p = v - o, !(p <= 0) && (d = x + (b - x) * (i + 1) / (k.minorgridcount + 1) * (k.arraydtick / p), !(d < E[0] || d > E[E.length - 1]) && L.push(kx(X(d), {
                        color: k.minorgridcolor,
                        width: k.minorgridwidth,
                        dash: k.minorgriddash
                    })));
                    k.startline && _.push(kx(G(0), {
                        color: k.startlinecolor,
                        width: k.startlinewidth
                    })), k.endline && _.push(kx(G(E.length - 1), {
                        color: k.endlinecolor,
                        width: k.endlinewidth
                    }));
                } else {
                    for(s = 5e-15, l = [
                        Math.floor((E[E.length - 1] - k.tick0) / k.dtick * (1 + s)),
                        Math.ceil((E[0] - k.tick0) / k.dtick / (1 + s))
                    ].sort(function(N, W) {
                        return N - W;
                    }), u = l[0], c = l[1], f = u; f <= c; f++)h = k.tick0 + k.dtick * f, A.push(kx(X(h), {
                        color: k.gridcolor,
                        width: k.gridwidth,
                        dash: k.griddash
                    }));
                    for(f = u - 1; f < c + 1; f++)for(h = k.tick0 + k.dtick * f, i = 0; i < k.minorgridcount; i++)d = h + k.dtick * (i + 1) / (k.minorgridcount + 1), !(d < E[0] || d > E[E.length - 1]) && L.push(kx(X(d), {
                        color: k.minorgridcolor,
                        width: k.minorgridwidth,
                        dash: k.minorgriddash
                    }));
                    k.startline && _.push(kx(X(E[0]), {
                        color: k.startlinecolor,
                        width: k.startlinewidth
                    })), k.endline && _.push(kx(X(E[E.length - 1]), {
                        color: k.endlinecolor,
                        width: k.endlinewidth
                    }));
                }
            };
        });
        var eXe = ye((axr, QZe)=>{
            "use strict";
            var JZe = Qa(), $Ze = no().extendFlat;
            QZe.exports = function(t, r) {
                var n, i, a, o, s, l = r._labels = [], u = r._gridlines;
                for(n = 0; n < u.length; n++)s = u[n], [
                    "start",
                    "both"
                ].indexOf(r.showticklabels) !== -1 && (i = JZe.tickText(r, s.value), $Ze(i, {
                    prefix: a,
                    suffix: o,
                    endAnchor: !0,
                    xy: s.xy(0),
                    dxy: s.dxy(0, 0),
                    axis: s.axis,
                    length: s.crossAxis.length,
                    font: s.axis.tickfont,
                    isFirst: n === 0,
                    isLast: n === u.length - 1
                }), l.push(i)), [
                    "end",
                    "both"
                ].indexOf(r.showticklabels) !== -1 && (i = JZe.tickText(r, s.value), $Ze(i, {
                    endAnchor: !1,
                    xy: s.xy(s.crossLength - 1),
                    dxy: s.dxy(s.crossLength - 2, 1),
                    axis: s.axis,
                    length: s.crossAxis.length,
                    font: s.axis.tickfont,
                    isFirst: n === 0,
                    isLast: n === u.length - 1
                }), l.push(i));
            };
        });
        var rXe = ye((oxr, tXe)=>{
            "use strict";
            tXe.exports = function(t, r, n, i) {
                var a, o, s, l = [], u = !!n.smoothing, c = !!i.smoothing, f = t[0].length - 1, h = t.length - 1;
                for(a = 0, o = [], s = []; a <= f; a++)o[a] = t[0][a], s[a] = r[0][a];
                for(l.push({
                    x: o,
                    y: s,
                    bicubic: u
                }), a = 0, o = [], s = []; a <= h; a++)o[a] = t[a][f], s[a] = r[a][f];
                for(l.push({
                    x: o,
                    y: s,
                    bicubic: c
                }), a = f, o = [], s = []; a >= 0; a--)o[f - a] = t[h][a], s[f - a] = r[h][a];
                for(l.push({
                    x: o,
                    y: s,
                    bicubic: u
                }), a = h, o = [], s = []; a >= 0; a--)o[h - a] = t[a][0], s[h - a] = r[a][0];
                return l.push({
                    x: o,
                    y: s,
                    bicubic: c
                }), l;
            };
        });
        var nXe = ye((sxr, iXe)=>{
            "use strict";
            var PXt = Mr();
            iXe.exports = function(t, r, n) {
                var i, a, o, s = [], l = [], u = t[0].length, c = t.length;
                function f(ae, _e) {
                    var Me = 0, ke, ge = 0;
                    return ae > 0 && (ke = t[_e][ae - 1]) !== void 0 && (ge++, Me += ke), ae < u - 1 && (ke = t[_e][ae + 1]) !== void 0 && (ge++, Me += ke), _e > 0 && (ke = t[_e - 1][ae]) !== void 0 && (ge++, Me += ke), _e < c - 1 && (ke = t[_e + 1][ae]) !== void 0 && (ge++, Me += ke), Me / Math.max(1, ge);
                }
                var h = 0;
                for(i = 0; i < u; i++)for(a = 0; a < c; a++)t[a][i] === void 0 && (s.push(i), l.push(a), t[a][i] = f(i, a)), h = Math.max(h, Math.abs(t[a][i]));
                if (!s.length) return t;
                var d, v, x, b, p, E, k, A, L, _, C, M = 1e-5, g = 0, P = 100, T = 0, F = s.length;
                do {
                    for(g = 0, o = 0; o < F; o++){
                        i = s[o], a = l[o];
                        var q = 0, V = 0, H, X, G, N, W, re;
                        i === 0 ? (W = Math.min(u - 1, 2), G = r[W], N = r[1], H = t[a][W], X = t[a][1], V += X + (X - H) * (r[0] - N) / (N - G), q++) : i === u - 1 && (W = Math.max(0, u - 3), G = r[W], N = r[u - 2], H = t[a][W], X = t[a][u - 2], V += X + (X - H) * (r[u - 1] - N) / (N - G), q++), (i === 0 || i === u - 1) && a > 0 && a < c - 1 && (d = n[a + 1] - n[a], v = n[a] - n[a - 1], V += (v * t[a + 1][i] + d * t[a - 1][i]) / (v + d), q++), a === 0 ? (re = Math.min(c - 1, 2), G = n[re], N = n[1], H = t[re][i], X = t[1][i], V += X + (X - H) * (n[0] - N) / (N - G), q++) : a === c - 1 && (re = Math.max(0, c - 3), G = n[re], N = n[c - 2], H = t[re][i], X = t[c - 2][i], V += X + (X - H) * (n[c - 1] - N) / (N - G), q++), (a === 0 || a === c - 1) && i > 0 && i < u - 1 && (d = r[i + 1] - r[i], v = r[i] - r[i - 1], V += (v * t[a][i + 1] + d * t[a][i - 1]) / (v + d), q++), q ? V /= q : (x = r[i + 1] - r[i], b = r[i] - r[i - 1], p = n[a + 1] - n[a], E = n[a] - n[a - 1], k = x * b * (x + b), A = p * E * (p + E), V = (k * (E * t[a + 1][i] + p * t[a - 1][i]) + A * (b * t[a][i + 1] + x * t[a][i - 1])) / (A * (b + x) + k * (E + p))), L = V - t[a][i], _ = L / h, g += _ * _, C = q ? 0 : .85, t[a][i] += L * (1 + C);
                    }
                    g = Math.sqrt(g);
                }while (T++ < P && g > M);
                return PXt.log("Smoother converged to", g, "after", T, "iterations"), t;
            };
        });
        var oXe = ye((lxr, aXe)=>{
            "use strict";
            aXe.exports = {
                RELATIVE_CULL_TOLERANCE: 1e-6
            };
        });
        var uXe = ye((uxr, lXe)=>{
            "use strict";
            var sXe = .5;
            lXe.exports = function(t, r, n, i) {
                var a = t[0] - r[0], o = t[1] - r[1], s = n[0] - r[0], l = n[1] - r[1], u = Math.pow(a * a + o * o, sXe / 2), c = Math.pow(s * s + l * l, sXe / 2), f = (c * c * a - u * u * s) * i, h = (c * c * o - u * u * l) * i, d = c * (u + c) * 3, v = u * (u + c) * 3;
                return [
                    [
                        r[0] + (d && f / d),
                        r[1] + (d && h / d)
                    ],
                    [
                        r[0] - (v && f / v),
                        r[1] - (v && h / v)
                    ]
                ];
            };
        });
        var fXe = ye((cxr, cXe)=>{
            "use strict";
            var v$ = uXe(), G7 = Mr().ensureArray;
            function FA(e, t, r) {
                var n = -0.5 * r[0] + 1.5 * t[0], i = -0.5 * r[1] + 1.5 * t[1];
                return [
                    (2 * n + e[0]) / 3,
                    (2 * i + e[1]) / 3
                ];
            }
            cXe.exports = function(t, r, n, i, a, o) {
                var s, l, u, c, f, h, d, v, x, b, p = n[0].length, E = n.length, k = a ? 3 * p - 2 : p, A = o ? 3 * E - 2 : E;
                for(t = G7(t, A), r = G7(r, A), u = 0; u < A; u++)t[u] = G7(t[u], k), r[u] = G7(r[u], k);
                for(l = 0, c = 0; l < E; l++, c += o ? 3 : 1)for(f = t[c], h = r[c], d = n[l], v = i[l], s = 0, u = 0; s < p; s++, u += a ? 3 : 1)f[u] = d[s], h[u] = v[s];
                if (a) for(l = 0, c = 0; l < E; l++, c += o ? 3 : 1){
                    for(s = 1, u = 3; s < p - 1; s++, u += 3)x = v$([
                        n[l][s - 1],
                        i[l][s - 1]
                    ], [
                        n[l][s],
                        i[l][s]
                    ], [
                        n[l][s + 1],
                        i[l][s + 1]
                    ], a), t[c][u - 1] = x[0][0], r[c][u - 1] = x[0][1], t[c][u + 1] = x[1][0], r[c][u + 1] = x[1][1];
                    b = FA([
                        t[c][0],
                        r[c][0]
                    ], [
                        t[c][2],
                        r[c][2]
                    ], [
                        t[c][3],
                        r[c][3]
                    ]), t[c][1] = b[0], r[c][1] = b[1], b = FA([
                        t[c][k - 1],
                        r[c][k - 1]
                    ], [
                        t[c][k - 3],
                        r[c][k - 3]
                    ], [
                        t[c][k - 4],
                        r[c][k - 4]
                    ]), t[c][k - 2] = b[0], r[c][k - 2] = b[1];
                }
                if (o) for(u = 0; u < k; u++){
                    for(c = 3; c < A - 3; c += 3)x = v$([
                        t[c - 3][u],
                        r[c - 3][u]
                    ], [
                        t[c][u],
                        r[c][u]
                    ], [
                        t[c + 3][u],
                        r[c + 3][u]
                    ], o), t[c - 1][u] = x[0][0], r[c - 1][u] = x[0][1], t[c + 1][u] = x[1][0], r[c + 1][u] = x[1][1];
                    b = FA([
                        t[0][u],
                        r[0][u]
                    ], [
                        t[2][u],
                        r[2][u]
                    ], [
                        t[3][u],
                        r[3][u]
                    ]), t[1][u] = b[0], r[1][u] = b[1], b = FA([
                        t[A - 1][u],
                        r[A - 1][u]
                    ], [
                        t[A - 3][u],
                        r[A - 3][u]
                    ], [
                        t[A - 4][u],
                        r[A - 4][u]
                    ]), t[A - 2][u] = b[0], r[A - 2][u] = b[1];
                }
                if (a && o) for(c = 1; c < A; c += (c + 1) % 3 === 0 ? 2 : 1){
                    for(u = 3; u < k - 3; u += 3)x = v$([
                        t[c][u - 3],
                        r[c][u - 3]
                    ], [
                        t[c][u],
                        r[c][u]
                    ], [
                        t[c][u + 3],
                        r[c][u + 3]
                    ], a), t[c][u - 1] = .5 * (t[c][u - 1] + x[0][0]), r[c][u - 1] = .5 * (r[c][u - 1] + x[0][1]), t[c][u + 1] = .5 * (t[c][u + 1] + x[1][0]), r[c][u + 1] = .5 * (r[c][u + 1] + x[1][1]);
                    b = FA([
                        t[c][0],
                        r[c][0]
                    ], [
                        t[c][2],
                        r[c][2]
                    ], [
                        t[c][3],
                        r[c][3]
                    ]), t[c][1] = .5 * (t[c][1] + b[0]), r[c][1] = .5 * (r[c][1] + b[1]), b = FA([
                        t[c][k - 1],
                        r[c][k - 1]
                    ], [
                        t[c][k - 3],
                        r[c][k - 3]
                    ], [
                        t[c][k - 4],
                        r[c][k - 4]
                    ]), t[c][k - 2] = .5 * (t[c][k - 2] + b[0]), r[c][k - 2] = .5 * (r[c][k - 2] + b[1]);
                }
                return [
                    t,
                    r
                ];
            };
        });
        var dXe = ye((fxr, hXe)=>{
            "use strict";
            hXe.exports = function(e, t, r, n, i) {
                var a = t - 2, o = r - 2;
                return n && i ? function(s, l, u) {
                    s || (s = []);
                    var c, f, h, d, v, x, b = Math.max(0, Math.min(Math.floor(l), a)), p = Math.max(0, Math.min(Math.floor(u), o)), E = Math.max(0, Math.min(1, l - b)), k = Math.max(0, Math.min(1, u - p));
                    b *= 3, p *= 3;
                    var A = E * E, L = A * E, _ = 1 - E, C = _ * _, M = C * _, g = k * k, P = g * k, T = 1 - k, F = T * T, q = F * T;
                    for(x = 0; x < e.length; x++)v = e[x], c = M * v[p][b] + 3 * (C * E * v[p][b + 1] + _ * A * v[p][b + 2]) + L * v[p][b + 3], f = M * v[p + 1][b] + 3 * (C * E * v[p + 1][b + 1] + _ * A * v[p + 1][b + 2]) + L * v[p + 1][b + 3], h = M * v[p + 2][b] + 3 * (C * E * v[p + 2][b + 1] + _ * A * v[p + 2][b + 2]) + L * v[p + 2][b + 3], d = M * v[p + 3][b] + 3 * (C * E * v[p + 3][b + 1] + _ * A * v[p + 3][b + 2]) + L * v[p + 3][b + 3], s[x] = q * c + 3 * (F * k * f + T * g * h) + P * d;
                    return s;
                } : n ? function(s, l, u) {
                    s || (s = []);
                    var c = Math.max(0, Math.min(Math.floor(l), a)), f = Math.max(0, Math.min(Math.floor(u), o)), h = Math.max(0, Math.min(1, l - c)), d = Math.max(0, Math.min(1, u - f)), v, x, b, p, E, k;
                    c *= 3;
                    var A = h * h, L = A * h, _ = 1 - h, C = _ * _, M = C * _, g = 1 - d;
                    for(E = 0; E < e.length; E++)k = e[E], v = g * k[f][c] + d * k[f + 1][c], x = g * k[f][c + 1] + d * k[f + 1][c + 1], b = g * k[f][c + 2] + d * k[f + 1][c + 1], p = g * k[f][c + 3] + d * k[f + 1][c + 1], s[E] = M * v + 3 * (C * h * x + _ * A * b) + L * p;
                    return s;
                } : i ? function(s, l, u) {
                    s || (s = []);
                    var c = Math.max(0, Math.min(Math.floor(l), a)), f = Math.max(0, Math.min(Math.floor(u), o)), h = Math.max(0, Math.min(1, l - c)), d = Math.max(0, Math.min(1, u - f)), v, x, b, p, E, k;
                    f *= 3;
                    var A = d * d, L = A * d, _ = 1 - d, C = _ * _, M = C * _, g = 1 - h;
                    for(E = 0; E < e.length; E++)k = e[E], v = g * k[f][c] + h * k[f][c + 1], x = g * k[f + 1][c] + h * k[f + 1][c + 1], b = g * k[f + 2][c] + h * k[f + 2][c + 1], p = g * k[f + 3][c] + h * k[f + 3][c + 1], s[E] = M * v + 3 * (C * d * x + _ * A * b) + L * p;
                    return s;
                } : function(s, l, u) {
                    s || (s = []);
                    var c = Math.max(0, Math.min(Math.floor(l), a)), f = Math.max(0, Math.min(Math.floor(u), o)), h = Math.max(0, Math.min(1, l - c)), d = Math.max(0, Math.min(1, u - f)), v, x, b, p, E = 1 - d, k = 1 - h;
                    for(b = 0; b < e.length; b++)p = e[b], v = k * p[f][c] + h * p[f][c + 1], x = k * p[f + 1][c] + h * p[f + 1][c + 1], s[b] = E * v + d * x;
                    return s;
                };
            };
        });
        var pXe = ye((hxr, vXe)=>{
            "use strict";
            vXe.exports = function(e, t, r) {
                return t && r ? function(n, i, a, o, s) {
                    n || (n = []);
                    var l, u, c, f, h, d;
                    i *= 3, a *= 3;
                    var v = o * o, x = 1 - o, b = x * x, p = x * o * 2, E = -3 * b, k = 3 * (b - p), A = 3 * (p - v), L = 3 * v, _ = s * s, C = _ * s, M = 1 - s, g = M * M, P = g * M;
                    for(d = 0; d < e.length; d++)h = e[d], l = E * h[a][i] + k * h[a][i + 1] + A * h[a][i + 2] + L * h[a][i + 3], u = E * h[a + 1][i] + k * h[a + 1][i + 1] + A * h[a + 1][i + 2] + L * h[a + 1][i + 3], c = E * h[a + 2][i] + k * h[a + 2][i + 1] + A * h[a + 2][i + 2] + L * h[a + 2][i + 3], f = E * h[a + 3][i] + k * h[a + 3][i + 1] + A * h[a + 3][i + 2] + L * h[a + 3][i + 3], n[d] = P * l + 3 * (g * s * u + M * _ * c) + C * f;
                    return n;
                } : t ? function(n, i, a, o, s) {
                    n || (n = []);
                    var l, u, c, f;
                    i *= 3;
                    var h = o * o, d = 1 - o, v = d * d, x = d * o * 2, b = -3 * v, p = 3 * (v - x), E = 3 * (x - h), k = 3 * h, A = 1 - s;
                    for(c = 0; c < e.length; c++)f = e[c], l = b * f[a][i] + p * f[a][i + 1] + E * f[a][i + 2] + k * f[a][i + 3], u = b * f[a + 1][i] + p * f[a + 1][i + 1] + E * f[a + 1][i + 2] + k * f[a + 1][i + 3], n[c] = A * l + s * u;
                    return n;
                } : r ? function(n, i, a, o, s) {
                    n || (n = []);
                    var l, u, c, f, h, d;
                    a *= 3;
                    var v = s * s, x = v * s, b = 1 - s, p = b * b, E = p * b;
                    for(h = 0; h < e.length; h++)d = e[h], l = d[a][i + 1] - d[a][i], u = d[a + 1][i + 1] - d[a + 1][i], c = d[a + 2][i + 1] - d[a + 2][i], f = d[a + 3][i + 1] - d[a + 3][i], n[h] = E * l + 3 * (p * s * u + b * v * c) + x * f;
                    return n;
                } : function(n, i, a, o, s) {
                    n || (n = []);
                    var l, u, c, f, h = 1 - s;
                    for(c = 0; c < e.length; c++)f = e[c], l = f[a][i + 1] - f[a][i], u = f[a + 1][i + 1] - f[a + 1][i], n[c] = h * l + s * u;
                    return n;
                };
            };
        });
        var mXe = ye((dxr, gXe)=>{
            "use strict";
            gXe.exports = function(e, t, r) {
                return t && r ? function(n, i, a, o, s) {
                    n || (n = []);
                    var l, u, c, f, h, d;
                    i *= 3, a *= 3;
                    var v = o * o, x = v * o, b = 1 - o, p = b * b, E = p * b, k = s * s, A = 1 - s, L = A * A, _ = A * s * 2, C = -3 * L, M = 3 * (L - _), g = 3 * (_ - k), P = 3 * k;
                    for(d = 0; d < e.length; d++)h = e[d], l = C * h[a][i] + M * h[a + 1][i] + g * h[a + 2][i] + P * h[a + 3][i], u = C * h[a][i + 1] + M * h[a + 1][i + 1] + g * h[a + 2][i + 1] + P * h[a + 3][i + 1], c = C * h[a][i + 2] + M * h[a + 1][i + 2] + g * h[a + 2][i + 2] + P * h[a + 3][i + 2], f = C * h[a][i + 3] + M * h[a + 1][i + 3] + g * h[a + 2][i + 3] + P * h[a + 3][i + 3], n[d] = E * l + 3 * (p * o * u + b * v * c) + x * f;
                    return n;
                } : t ? function(n, i, a, o, s) {
                    n || (n = []);
                    var l, u, c, f, h, d;
                    i *= 3;
                    var v = s * s, x = v * s, b = 1 - s, p = b * b, E = p * b;
                    for(h = 0; h < e.length; h++)d = e[h], l = d[a + 1][i] - d[a][i], u = d[a + 1][i + 1] - d[a][i + 1], c = d[a + 1][i + 2] - d[a][i + 2], f = d[a + 1][i + 3] - d[a][i + 3], n[h] = E * l + 3 * (p * s * u + b * v * c) + x * f;
                    return n;
                } : r ? function(n, i, a, o, s) {
                    n || (n = []);
                    var l, u, c, f;
                    a *= 3;
                    var h = 1 - o, d = s * s, v = 1 - s, x = v * v, b = v * s * 2, p = -3 * x, E = 3 * (x - b), k = 3 * (b - d), A = 3 * d;
                    for(c = 0; c < e.length; c++)f = e[c], l = p * f[a][i] + E * f[a + 1][i] + k * f[a + 2][i] + A * f[a + 3][i], u = p * f[a][i + 1] + E * f[a + 1][i + 1] + k * f[a + 2][i + 1] + A * f[a + 3][i + 1], n[c] = h * l + o * u;
                    return n;
                } : function(n, i, a, o, s) {
                    n || (n = []);
                    var l, u, c, f, h = 1 - o;
                    for(c = 0; c < e.length; c++)f = e[c], l = f[a + 1][i] - f[a][i], u = f[a + 1][i + 1] - f[a][i + 1], n[c] = h * l + o * u;
                    return n;
                };
            };
        });
        var bXe = ye((vxr, xXe)=>{
            "use strict";
            var yXe = oXe(), _Xe = k6().findBin, IXt = fXe(), RXt = dXe(), DXt = pXe(), zXt = mXe();
            xXe.exports = function(t) {
                var r = t._a, n = t._b, i = r.length, a = n.length, o = t.aaxis, s = t.baxis, l = r[0], u = r[i - 1], c = n[0], f = n[a - 1], h = r[r.length - 1] - r[0], d = n[n.length - 1] - n[0], v = h * yXe.RELATIVE_CULL_TOLERANCE, x = d * yXe.RELATIVE_CULL_TOLERANCE;
                l -= v, u += v, c -= x, f += x, t.isVisible = function(b, p) {
                    return b > l && b < u && p > c && p < f;
                }, t.isOccluded = function(b, p) {
                    return b < l || b > u || p < c || p > f;
                }, t.setScale = function() {
                    var b = t._x, p = t._y, E = IXt(t._xctrl, t._yctrl, b, p, o.smoothing, s.smoothing);
                    t._xctrl = E[0], t._yctrl = E[1], t.evalxy = RXt([
                        t._xctrl,
                        t._yctrl
                    ], i, a, o.smoothing, s.smoothing), t.dxydi = DXt([
                        t._xctrl,
                        t._yctrl
                    ], o.smoothing, s.smoothing), t.dxydj = zXt([
                        t._xctrl,
                        t._yctrl
                    ], o.smoothing, s.smoothing);
                }, t.i2a = function(b) {
                    var p = Math.max(0, Math.floor(b[0]), i - 2), E = b[0] - p;
                    return (1 - E) * r[p] + E * r[p + 1];
                }, t.j2b = function(b) {
                    var p = Math.max(0, Math.floor(b[1]), i - 2), E = b[1] - p;
                    return (1 - E) * n[p] + E * n[p + 1];
                }, t.ij2ab = function(b) {
                    return [
                        t.i2a(b[0]),
                        t.j2b(b[1])
                    ];
                }, t.a2i = function(b) {
                    var p = Math.max(0, Math.min(_Xe(b, r), i - 2)), E = r[p], k = r[p + 1];
                    return Math.max(0, Math.min(i - 1, p + (b - E) / (k - E)));
                }, t.b2j = function(b) {
                    var p = Math.max(0, Math.min(_Xe(b, n), a - 2)), E = n[p], k = n[p + 1];
                    return Math.max(0, Math.min(a - 1, p + (b - E) / (k - E)));
                }, t.ab2ij = function(b) {
                    return [
                        t.a2i(b[0]),
                        t.b2j(b[1])
                    ];
                }, t.i2c = function(b, p) {
                    return t.evalxy([], b, p);
                }, t.ab2xy = function(b, p, E) {
                    if (!E && (b < r[0] || b > r[i - 1] | p < n[0] || p > n[a - 1])) return [
                        !1,
                        !1
                    ];
                    var k = t.a2i(b), A = t.b2j(p), L = t.evalxy([], k, A);
                    if (E) {
                        var _ = 0, C = 0, M = [], g, P, T, F;
                        b < r[0] ? (g = 0, P = 0, _ = (b - r[0]) / (r[1] - r[0])) : b > r[i - 1] ? (g = i - 2, P = 1, _ = (b - r[i - 1]) / (r[i - 1] - r[i - 2])) : (g = Math.max(0, Math.min(i - 2, Math.floor(k))), P = k - g), p < n[0] ? (T = 0, F = 0, C = (p - n[0]) / (n[1] - n[0])) : p > n[a - 1] ? (T = a - 2, F = 1, C = (p - n[a - 1]) / (n[a - 1] - n[a - 2])) : (T = Math.max(0, Math.min(a - 2, Math.floor(A))), F = A - T), _ && (t.dxydi(M, g, T, P, F), L[0] += M[0] * _, L[1] += M[1] * _), C && (t.dxydj(M, g, T, P, F), L[0] += M[0] * C, L[1] += M[1] * C);
                    }
                    return L;
                }, t.c2p = function(b, p, E) {
                    return [
                        p.c2p(b[0]),
                        E.c2p(b[1])
                    ];
                }, t.p2x = function(b, p, E) {
                    return [
                        p.p2c(b[0]),
                        E.p2c(b[1])
                    ];
                }, t.dadi = function(b) {
                    var p = Math.max(0, Math.min(r.length - 2, b));
                    return r[p + 1] - r[p];
                }, t.dbdj = function(b) {
                    var p = Math.max(0, Math.min(n.length - 2, b));
                    return n[p + 1] - n[p];
                }, t.dxyda = function(b, p, E, k) {
                    var A = t.dxydi(null, b, p, E, k), L = t.dadi(b, E);
                    return [
                        A[0] / L,
                        A[1] / L
                    ];
                }, t.dxydb = function(b, p, E, k) {
                    var A = t.dxydj(null, b, p, E, k), L = t.dbdj(p, k);
                    return [
                        A[0] / L,
                        A[1] / L
                    ];
                }, t.dxyda_rough = function(b, p, E) {
                    var k = h * (E || .1), A = t.ab2xy(b + k, p, !0), L = t.ab2xy(b - k, p, !0);
                    return [
                        (A[0] - L[0]) * .5 / k,
                        (A[1] - L[1]) * .5 / k
                    ];
                }, t.dxydb_rough = function(b, p, E) {
                    var k = d * (E || .1), A = t.ab2xy(b, p + k, !0), L = t.ab2xy(b, p - k, !0);
                    return [
                        (A[0] - L[0]) * .5 / k,
                        (A[1] - L[1]) * .5 / k
                    ];
                }, t.dpdx = function(b) {
                    return b._m;
                }, t.dpdy = function(b) {
                    return b._m;
                };
            };
        });
        var CXe = ye((pxr, kXe)=>{
            "use strict";
            var j7 = Qa(), wXe = Mr().isArray1D, FXt = GZe(), TXe = XZe(), AXe = KZe(), SXe = eXe(), qXt = rXe(), MXe = QI(), EXe = nXe(), OXt = JI(), BXt = bXe();
            kXe.exports = function(t, r) {
                var n = j7.getFromId(t, r.xaxis), i = j7.getFromId(t, r.yaxis), a = r.aaxis, o = r.baxis, s = r.x, l = r.y, u = [];
                s && wXe(s) && u.push("x"), l && wXe(l) && u.push("y"), u.length && OXt(r, a, o, "a", "b", u);
                var c = r._a = r._a || r.a, f = r._b = r._b || r.b;
                s = r._x || r.x, l = r._y || r.y;
                var h = {};
                if (r._cheater) {
                    var d = a.cheatertype === "index" ? c.length : c, v = o.cheatertype === "index" ? f.length : f;
                    s = FXt(d, v, r.cheaterslope);
                }
                r._x = s = MXe(s), r._y = l = MXe(l), EXe(s, c, f), EXe(l, c, f), BXt(r), r.setScale();
                var x = TXe(s), b = TXe(l), p = .5 * (x[1] - x[0]), E = .5 * (x[1] + x[0]), k = .5 * (b[1] - b[0]), A = .5 * (b[1] + b[0]), L = 1.3;
                return x = [
                    E - p * L,
                    E + p * L
                ], b = [
                    A - k * L,
                    A + k * L
                ], r._extremes[n._id] = j7.findExtremes(n, x, {
                    padded: !0
                }), r._extremes[i._id] = j7.findExtremes(i, b, {
                    padded: !0
                }), AXe(r, "a", "b"), AXe(r, "b", "a"), SXe(r, a), SXe(r, o), h.clipsegments = qXt(r._xctrl, r._yctrl, a, o), h.x = s, h.y = l, h.a = c, h.b = f, [
                    h
                ];
            };
        });
        var PXe = ye((gxr, LXe)=>{
            "use strict";
            LXe.exports = {
                attributes: O7(),
                supplyDefaults: LZe(),
                plot: VZe(),
                calc: CXe(),
                animatable: !0,
                isContainer: !0,
                moduleType: "trace",
                name: "carpet",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "carpet",
                    "carpetAxis",
                    "notLegendIsolatable",
                    "noMultiCategory",
                    "noHover",
                    "noSortingByValue"
                ],
                meta: {}
            };
        });
        var RXe = ye((mxr, IXe)=>{
            "use strict";
            IXe.exports = PXe();
        });
        var p$ = ye((yxr, zXe)=>{
            "use strict";
            var NXt = Eg(), u0 = Uc(), UXt = vl(), VXt = Wo().hovertemplateAttrs, HXt = Wo().texttemplateAttrs, DXe = Jl(), Cx = no().extendFlat, sg = u0.marker, qA = u0.line, GXt = sg.line;
            zXe.exports = {
                carpet: {
                    valType: "string",
                    editType: "calc"
                },
                a: {
                    valType: "data_array",
                    editType: "calc"
                },
                b: {
                    valType: "data_array",
                    editType: "calc"
                },
                mode: Cx({}, u0.mode, {
                    dflt: "markers"
                }),
                text: Cx({}, u0.text, {}),
                texttemplate: HXt({
                    editType: "plot"
                }, {
                    keys: [
                        "a",
                        "b",
                        "text"
                    ]
                }),
                hovertext: Cx({}, u0.hovertext, {}),
                line: {
                    color: qA.color,
                    width: qA.width,
                    dash: qA.dash,
                    backoff: qA.backoff,
                    shape: Cx({}, qA.shape, {
                        values: [
                            "linear",
                            "spline"
                        ]
                    }),
                    smoothing: qA.smoothing,
                    editType: "calc"
                },
                connectgaps: u0.connectgaps,
                fill: Cx({}, u0.fill, {
                    values: [
                        "none",
                        "toself",
                        "tonext"
                    ],
                    dflt: "none"
                }),
                fillcolor: NXt(),
                marker: Cx({
                    symbol: sg.symbol,
                    opacity: sg.opacity,
                    maxdisplayed: sg.maxdisplayed,
                    angle: sg.angle,
                    angleref: sg.angleref,
                    standoff: sg.standoff,
                    size: sg.size,
                    sizeref: sg.sizeref,
                    sizemin: sg.sizemin,
                    sizemode: sg.sizemode,
                    line: Cx({
                        width: GXt.width,
                        editType: "calc"
                    }, DXe("marker.line")),
                    gradient: sg.gradient,
                    editType: "calc"
                }, DXe("marker")),
                textfont: u0.textfont,
                textposition: u0.textposition,
                selected: u0.selected,
                unselected: u0.unselected,
                hoverinfo: Cx({}, UXt.hoverinfo, {
                    flags: [
                        "a",
                        "b",
                        "text",
                        "name"
                    ]
                }),
                hoveron: u0.hoveron,
                hovertemplate: VXt(),
                zorder: u0.zorder
            };
        });
        var BXe = ye((_xr, OXe)=>{
            "use strict";
            var FXe = Mr(), jXt = Sm(), OA = lu(), WXt = $p(), ZXt = R0(), qXe = J3(), XXt = D0(), YXt = Ig(), KXt = p$();
            OXe.exports = function(t, r, n, i) {
                function a(h, d) {
                    return FXe.coerce(t, r, KXt, h, d);
                }
                a("carpet"), r.xaxis = "x", r.yaxis = "y";
                var o = a("a"), s = a("b"), l = Math.min(o.length, s.length);
                if (!l) {
                    r.visible = !1;
                    return;
                }
                r._length = l, a("text"), a("texttemplate"), a("hovertext");
                var u = l < jXt.PTS_LINESONLY ? "lines+markers" : "lines";
                a("mode", u), OA.hasMarkers(r) && WXt(t, r, n, i, a, {
                    gradient: !0
                }), OA.hasLines(r) && (ZXt(t, r, n, i, a, {
                    backoff: !0
                }), qXe(t, r, a), a("connectgaps")), OA.hasText(r) && XXt(t, r, i, a);
                var c = [];
                (OA.hasMarkers(r) || OA.hasText(r)) && (a("marker.maxdisplayed"), c.push("points")), a("fill"), r.fill !== "none" && (YXt(t, r, n, a), OA.hasLines(r) || qXe(t, r, a)), (r.fill === "tonext" || r.fill === "toself") && c.push("fills");
                var f = a("hoveron", c.join("+") || "points");
                f !== "fills" && a("hovertemplate"), a("zorder"), FXe.coerceSelectionMarkerOpacity(r, a);
            };
        });
        var UXe = ye((xxr, NXe)=>{
            "use strict";
            NXe.exports = function(t, r) {
                var n = {}, i = r._carpet, a = i.ab2ij([
                    t.a,
                    t.b
                ]), o = Math.floor(a[0]), s = a[0] - o, l = Math.floor(a[1]), u = a[1] - l, c = i.evalxy([], o, l, s, u);
                return n.yLabel = c[1].toFixed(3), n;
            };
        });
        var W7 = ye((bxr, VXe)=>{
            "use strict";
            VXe.exports = function(e, t) {
                for(var r = e._fullData.length, n, i = 0; i < r; i++){
                    var a = e._fullData[i];
                    if (a.index !== t.index && a.type === "carpet" && (n || (n = a), a.carpet === t.carpet)) return a;
                }
                return n;
            };
        });
        var jXe = ye((wxr, GXe)=>{
            "use strict";
            var HXe = uo(), JXt = z0(), $Xt = km(), QXt = F0(), eYt = q0().calcMarkerSize, tYt = W7();
            GXe.exports = function(t, r) {
                var n = r._carpetTrace = tYt(t, r);
                if (!(!n || !n.visible || n.visible === "legendonly")) {
                    var i;
                    r.xaxis = n.xaxis, r.yaxis = n.yaxis;
                    var a = r._length, o = new Array(a), s, l, u = !1;
                    for(i = 0; i < a; i++)if (s = r.a[i], l = r.b[i], HXe(s) && HXe(l)) {
                        var c = n.ab2xy(+s, +l, !0), f = n.isVisible(+s, +l);
                        f || (u = !0), o[i] = {
                            x: c[0],
                            y: c[1],
                            a: s,
                            b: l,
                            vis: f
                        };
                    } else o[i] = {
                        x: !1,
                        y: !1
                    };
                    return r._needsCull = u, o[0].carpet = n, o[0].trace = r, eYt(r, a), JXt(t, r), $Xt(o, r), QXt(o, r), o;
                }
            };
        });
        var XXe = ye((Txr, ZXe)=>{
            "use strict";
            var rYt = iT(), WXe = Qa(), iYt = ao();
            ZXe.exports = function(t, r, n, i) {
                var a, o, s, l = n[0][0].carpet, u = WXe.getFromId(t, l.xaxis || "x"), c = WXe.getFromId(t, l.yaxis || "y"), f = {
                    xaxis: u,
                    yaxis: c,
                    plot: r.plot
                };
                for(a = 0; a < n.length; a++)o = n[a][0].trace, o._xA = u, o._yA = c;
                for(rYt(t, f, n, i), a = 0; a < n.length; a++)o = n[a][0].trace, s = i.selectAll("g.trace" + o.uid + " .js-line"), iYt.setClipUrl(s, n[a][0].carpet._clipPathId, t);
            };
        });
        var KXe = ye((Axr, YXe)=>{
            "use strict";
            var nYt = sT(), aYt = Mr().fillText;
            YXe.exports = function(t, r, n, i) {
                var a = nYt(t, r, n, i);
                if (!a || a[0].index === !1) return;
                var o = a[0];
                if (o.index === void 0) {
                    var s = 1 - o.y0 / t.ya._length, l = t.xa._length, u = l * s / 2, c = l - u;
                    return o.x0 = Math.max(Math.min(o.x0, c), u), o.x1 = Math.max(Math.min(o.x1, c), u), a;
                }
                var f = o.cd[o.index];
                o.a = f.a, o.b = f.b, o.xLabelVal = void 0, o.yLabelVal = void 0;
                var h = o.trace, d = h._carpet, v = h._module.formatLabels(f, h);
                o.yLabel = v.yLabel, delete o.text;
                var x = [];
                function b(k, A) {
                    var L;
                    k.labelprefix && k.labelprefix.length > 0 ? L = k.labelprefix.replace(/ = $/, "") : L = k._hovertitle, x.push(L + ": " + A.toFixed(3) + k.labelsuffix);
                }
                if (!h.hovertemplate) {
                    var p = f.hi || h.hoverinfo, E = p.split("+");
                    E.indexOf("all") !== -1 && (E = [
                        "a",
                        "b",
                        "text"
                    ]), E.indexOf("a") !== -1 && b(d.aaxis, f.a), E.indexOf("b") !== -1 && b(d.baxis, f.b), x.push("y: " + o.yLabel), E.indexOf("text") !== -1 && aYt(f, h, x), o.extraText = x.join("<br>");
                }
                return a;
            };
        });
        var $Xe = ye((Sxr, JXe)=>{
            "use strict";
            JXe.exports = function(t, r, n, i, a) {
                var o = i[a];
                return t.a = o.a, t.b = o.b, t.y = o.y, t;
            };
        });
        var eYe = ye((Mxr, QXe)=>{
            "use strict";
            QXe.exports = {
                attributes: p$(),
                supplyDefaults: BXe(),
                colorbar: Kd(),
                formatLabels: UXe(),
                calc: jXe(),
                plot: XXe(),
                style: op().style,
                styleOnSelect: op().styleOnSelect,
                hoverPoints: KXe(),
                selectPoints: lT(),
                eventData: $Xe(),
                moduleType: "trace",
                name: "scattercarpet",
                basePlotModule: Jf(),
                categories: [
                    "svg",
                    "carpet",
                    "symbols",
                    "showLegend",
                    "carpetDependent",
                    "zoomScale"
                ],
                meta: {}
            };
        });
        var rYe = ye((Exr, tYe)=>{
            "use strict";
            tYe.exports = eYe();
        });
        var g$ = ye((kxr, iYe)=>{
            "use strict";
            var lg = ET(), g1 = T4(), oYt = Jl(), sYt = no().extendFlat, ty = g1.contours;
            iYe.exports = sYt({
                carpet: {
                    valType: "string",
                    editType: "calc"
                },
                z: lg.z,
                a: lg.x,
                a0: lg.x0,
                da: lg.dx,
                b: lg.y,
                b0: lg.y0,
                db: lg.dy,
                text: lg.text,
                hovertext: lg.hovertext,
                transpose: lg.transpose,
                atype: lg.xtype,
                btype: lg.ytype,
                fillcolor: g1.fillcolor,
                autocontour: g1.autocontour,
                ncontours: g1.ncontours,
                contours: {
                    type: ty.type,
                    start: ty.start,
                    end: ty.end,
                    size: ty.size,
                    coloring: {
                        valType: "enumerated",
                        values: [
                            "fill",
                            "lines",
                            "none"
                        ],
                        dflt: "fill",
                        editType: "calc"
                    },
                    showlines: ty.showlines,
                    showlabels: ty.showlabels,
                    labelfont: ty.labelfont,
                    labelformat: ty.labelformat,
                    operation: ty.operation,
                    value: ty.value,
                    editType: "calc",
                    impliedEdits: {
                        autocontour: !1
                    }
                },
                line: {
                    color: g1.line.color,
                    width: g1.line.width,
                    dash: g1.line.dash,
                    smoothing: g1.line.smoothing,
                    editType: "plot"
                },
                zorder: g1.zorder
            }, oYt("", {
                cLetter: "z",
                autoColorDflt: !1
            }));
        });
        var m$ = ye((Cxr, oYe)=>{
            "use strict";
            var nYe = Mr(), lYt = XI(), aYe = g$(), uYt = yH(), cYt = y8(), fYt = _8();
            oYe.exports = function(t, r, n, i) {
                function a(u, c) {
                    return nYe.coerce(t, r, aYe, u, c);
                }
                function o(u) {
                    return nYe.coerce2(t, r, aYe, u);
                }
                if (a("carpet"), t.a && t.b) {
                    var s = lYt(t, r, a, i, "a", "b");
                    if (!s) {
                        r.visible = !1;
                        return;
                    }
                    a("text");
                    var l = a("contours.type") === "constraint";
                    l ? uYt(t, r, a, i, n, {
                        hasHover: !1
                    }) : (cYt(t, r, a, o), fYt(t, r, a, i, {
                        hasHover: !1
                    }));
                } else r._defaultColor = n, r._length = null;
                a("zorder");
            };
        });
        var cYe = ye((Lxr, uYe)=>{
            "use strict";
            var hYt = zv(), sYe = Mr(), dYt = JI(), vYt = QI(), pYt = e8(), gYt = t8(), lYe = VV(), mYt = m$(), yYt = W7(), _Yt = oH();
            uYe.exports = function(t, r) {
                var n = r._carpetTrace = yYt(t, r);
                if (!(!n || !n.visible || n.visible === "legendonly")) {
                    if (!r.a || !r.b) {
                        var i = t.data[n.index], a = t.data[r.index];
                        a.a || (a.a = i.a), a.b || (a.b = i.b), mYt(a, r, r._defaultColor, t._fullLayout);
                    }
                    var o = xYt(t, r);
                    return _Yt(r, r._z), o;
                }
            };
            function xYt(e, t) {
                var r = t._carpetTrace, n = r.aaxis, i = r.baxis, a, o, s, l, u, c, f;
                n._minDtick = 0, i._minDtick = 0, sYe.isArray1D(t.z) && dYt(t, n, i, "a", "b", [
                    "z"
                ]), a = t._a = t._a || t.a, l = t._b = t._b || t.b, a = a ? n.makeCalcdata(t, "_a") : [], l = l ? i.makeCalcdata(t, "_b") : [], o = t.a0 || 0, s = t.da || 1, u = t.b0 || 0, c = t.db || 1, f = t._z = vYt(t._z || t.z, t.transpose), t._emptypoints = gYt(f), pYt(f, t._emptypoints);
                var h = sYe.maxRowLength(f), d = t.xtype === "scaled" ? "" : a, v = lYe(t, d, o, s, h, n), x = t.ytype === "scaled" ? "" : l, b = lYe(t, x, u, c, f.length, i), p = {
                    a: v,
                    b: b,
                    z: f
                };
                return t.contours.type === "levels" && t.contours.coloring !== "none" && hYt(e, t, {
                    vals: f,
                    containerStr: "",
                    cLetter: "z"
                }), [
                    p
                ];
            }
        });
        var hYe = ye((Pxr, fYe)=>{
            "use strict";
            var bYt = Mr().isArrayOrTypedArray;
            fYe.exports = function(e, t, r, n) {
                var i, a, o, s, l, u, c, f, h, d, v, x, b, p = bYt(r) ? "a" : "b", E = p === "a" ? e.aaxis : e.baxis, k = E.smoothing, A = p === "a" ? e.a2i : e.b2j, L = p === "a" ? r : n, _ = p === "a" ? n : r, C = p === "a" ? t.a.length : t.b.length, M = p === "a" ? t.b.length : t.a.length, g = Math.floor(p === "a" ? e.b2j(_) : e.a2i(_)), P = p === "a" ? function(_e) {
                    return e.evalxy([], _e, g);
                } : function(_e) {
                    return e.evalxy([], g, _e);
                };
                k && (o = Math.max(0, Math.min(M - 2, g)), s = g - o, a = p === "a" ? function(_e, Me) {
                    return e.dxydi([], _e, o, Me, s);
                } : function(_e, Me) {
                    return e.dxydj([], o, _e, s, Me);
                });
                var T = A(L[0]), F = A(L[1]), q = T < F ? 1 : -1, V = (F - T) * 1e-8, H = q > 0 ? Math.floor : Math.ceil, X = q > 0 ? Math.ceil : Math.floor, G = q > 0 ? Math.min : Math.max, N = q > 0 ? Math.max : Math.min, W = H(T + V), re = X(F - V);
                c = P(T);
                var ae = [
                    [
                        c
                    ]
                ];
                for(i = W; i * q < re * q; i += q)l = [], v = N(T, i), x = G(F, i + q), b = x - v, u = Math.max(0, Math.min(C - 2, Math.floor(.5 * (v + x)))), f = P(x), k && (h = a(u, v - u), d = a(u, x - u), l.push([
                    c[0] + h[0] / 3 * b,
                    c[1] + h[1] / 3 * b
                ]), l.push([
                    f[0] - d[0] / 3 * b,
                    f[1] - d[1] / 3 * b
                ])), l.push(f), ae.push(l), c = f;
                return ae;
            };
        });
        var _Ye = ye((Ixr, yYe)=>{
            "use strict";
            var X7 = xa(), Y7 = f$(), mYe = h$(), eC = ao(), m1 = Mr(), wYt = lH(), TYt = uH(), hw = w8(), Z7 = S4(), AYt = dH(), SYt = hH(), MYt = vH(), EYt = W7(), dYe = hYe();
            yYe.exports = function(t, r, n, i) {
                var a = r.xaxis, o = r.yaxis;
                m1.makeTraceGroups(i, n, "contour").each(function(s) {
                    var l = X7.select(this), u = s[0], c = u.trace, f = c._carpetTrace = EYt(t, c), h = t.calcdata[f.index][0];
                    if (!f.visible || f.visible === "legendonly") return;
                    var d = u.a, v = u.b, x = c.contours, b = SYt(x, r, u), p = x.type === "constraint", E = x._operation, k = p ? E === "=" ? "lines" : "fill" : x.coloring;
                    function A(H) {
                        var X = f.ab2xy(H[0], H[1], !0);
                        return [
                            a.c2p(X[0]),
                            o.c2p(X[1])
                        ];
                    }
                    var L = [
                        [
                            d[0],
                            v[v.length - 1]
                        ],
                        [
                            d[d.length - 1],
                            v[v.length - 1]
                        ],
                        [
                            d[d.length - 1],
                            v[0]
                        ],
                        [
                            d[0],
                            v[0]
                        ]
                    ];
                    wYt(b);
                    var _ = (d[d.length - 1] - d[0]) * 1e-8, C = (v[v.length - 1] - v[0]) * 1e-8;
                    TYt(b, _, C);
                    var M = b;
                    x.type === "constraint" && (M = AYt(b, E)), kYt(b, A);
                    var g, P, T, F, q = [];
                    for(F = h.clipsegments.length - 1; F >= 0; F--)g = h.clipsegments[F], P = Y7([], g.x, a.c2p), T = Y7([], g.y, o.c2p), P.reverse(), T.reverse(), q.push(mYe(P, T, g.bicubic));
                    var V = "M" + q.join("L") + "Z";
                    PYt(l, h.clipsegments, a, o, p, k), IYt(c, l, a, o, M, L, A, f, h, k, V), CYt(l, b, t, u, x, r, f), eC.setClipUrl(l, f._clipPathId, t);
                });
            };
            function kYt(e, t) {
                var r, n, i, a, o, s, l, u, c;
                for(r = 0; r < e.length; r++){
                    for(a = e[r], o = a.pedgepaths = [], s = a.ppaths = [], n = 0; n < a.edgepaths.length; n++){
                        for(c = a.edgepaths[n], l = [], i = 0; i < c.length; i++)l[i] = t(c[i]);
                        o.push(l);
                    }
                    for(n = 0; n < a.paths.length; n++){
                        for(c = a.paths[n], u = [], i = 0; i < c.length; i++)u[i] = t(c[i]);
                        s.push(u);
                    }
                }
            }
            function CYt(e, t, r, n, i, a, o) {
                var s = r._context.staticPlot, l = m1.ensureSingle(e, "g", "contourlines"), u = i.showlines !== !1, c = i.showlabels, f = u && c, h = hw.createLines(l, u || c, t, s), d = hw.createLineClip(l, f, r, n.trace.uid), v = e.selectAll("g.contourlabels").data(c ? [
                    0
                ] : []);
                if (v.exit().remove(), v.enter().append("g").classed("contourlabels", !0), c) {
                    var x = a.xaxis, b = a.yaxis, p = x._length, E = b._length, k = [
                        [
                            [
                                0,
                                0
                            ],
                            [
                                p,
                                0
                            ],
                            [
                                p,
                                E
                            ],
                            [
                                0,
                                E
                            ]
                        ]
                    ], A = [];
                    m1.clearLocationCache();
                    var L = hw.labelFormatter(r, n), _ = eC.tester.append("text").attr("data-notex", 1).call(eC.font, i.labelfont), C = {
                        left: 0,
                        right: p,
                        center: p / 2,
                        top: 0,
                        bottom: E,
                        middle: E / 2
                    }, M = Math.sqrt(p * p + E * E), g = Z7.LABELDISTANCE * M / Math.max(1, t.length / Z7.LABELINCREASE);
                    h.each(function(P) {
                        var T = hw.calcTextOpts(P.level, L, _, r);
                        X7.select(this).selectAll("path").each(function(F) {
                            var q = this, V = m1.getVisibleSegment(q, C, T.height / 2);
                            if (V && (LYt(q, F, P, V, o, T.height), !(V.len < (T.width + T.height) * Z7.LABELMIN))) for(var H = Math.min(Math.ceil(V.len / g), Z7.LABELMAX), X = 0; X < H; X++){
                                var G = hw.findBestTextLocation(q, V, T, A, C);
                                if (!G) break;
                                hw.addLabelData(G, T, A, k);
                            }
                        });
                    }), _.remove(), hw.drawLabels(v, A, r, d, f ? k : null);
                }
                c && !u && h.remove();
            }
            function LYt(e, t, r, n, i, a) {
                for(var o, s = 0; s < r.pedgepaths.length; s++)t === r.pedgepaths[s] && (o = r.edgepaths[s]);
                if (!o) return;
                var l = i.a[0], u = i.a[i.a.length - 1], c = i.b[0], f = i.b[i.b.length - 1];
                function h(p, E) {
                    var k = 0, A, L = .1;
                    return (Math.abs(p[0] - l) < L || Math.abs(p[0] - u) < L) && (A = pYe(i.dxydb_rough(p[0], p[1], L)), k = Math.max(k, a * gYe(E, A) / 2)), (Math.abs(p[1] - c) < L || Math.abs(p[1] - f) < L) && (A = pYe(i.dxyda_rough(p[0], p[1], L)), k = Math.max(k, a * gYe(E, A) / 2)), k;
                }
                var d = vYe(e, 0, 1), v = vYe(e, n.total, n.total - 1), x = h(o[0], d), b = n.total - h(o[o.length - 1], v);
                n.min < x && (n.min = x), n.max > b && (n.max = b), n.len = n.max - n.min;
            }
            function vYe(e, t, r) {
                var n = e.getPointAtLength(t), i = e.getPointAtLength(r), a = i.x - n.x, o = i.y - n.y, s = Math.sqrt(a * a + o * o);
                return [
                    a / s,
                    o / s
                ];
            }
            function pYe(e) {
                var t = Math.sqrt(e[0] * e[0] + e[1] * e[1]);
                return [
                    e[0] / t,
                    e[1] / t
                ];
            }
            function gYe(e, t) {
                var r = Math.abs(e[0] * t[0] + e[1] * t[1]), n = Math.sqrt(1 - r * r);
                return n / r;
            }
            function PYt(e, t, r, n, i, a) {
                var o, s, l, u, c = m1.ensureSingle(e, "g", "contourbg"), f = c.selectAll("path").data(a === "fill" && !i ? [
                    0
                ] : []);
                f.enter().append("path"), f.exit().remove();
                var h = [];
                for(u = 0; u < t.length; u++)o = t[u], s = Y7([], o.x, r.c2p), l = Y7([], o.y, n.c2p), h.push(mYe(s, l, o.bicubic));
                f.attr("d", "M" + h.join("L") + "Z").style("stroke", "none");
            }
            function IYt(e, t, r, n, i, a, o, s, l, u, c) {
                var f = u === "fill";
                f && MYt(i, e.contours);
                var h = m1.ensureSingle(t, "g", "contourfill"), d = h.selectAll("path").data(f ? i : []);
                d.enter().append("path"), d.exit().remove(), d.each(function(v) {
                    var x = (v.prefixBoundary ? c : "") + RYt(e, v, a, o, s, l, r, n);
                    x ? X7.select(this).attr("d", x).style("stroke", "none") : X7.select(this).remove();
                });
            }
            function RYt(e, t, r, n, i, a, o, s) {
                var l, u = "", c = t.edgepaths.map(function(T, F) {
                    return F;
                }), f = !0, h, d, v, x, b, p, E = Math.abs(r[0][0] - r[2][0]) * 1e-4, k = Math.abs(r[0][1] - r[2][1]) * 1e-4;
                function A(T) {
                    return Math.abs(T[1] - r[0][1]) < k;
                }
                function L(T) {
                    return Math.abs(T[1] - r[2][1]) < k;
                }
                function _(T) {
                    return Math.abs(T[0] - r[0][0]) < E;
                }
                function C(T) {
                    return Math.abs(T[0] - r[2][0]) < E;
                }
                function M(T, F) {
                    var q, V, H, X, G = "";
                    for(A(T) && !C(T) || L(T) && !_(T) ? (X = i.aaxis, H = dYe(i, a, [
                        T[0],
                        F[0]
                    ], .5 * (T[1] + F[1]))) : (X = i.baxis, H = dYe(i, a, .5 * (T[0] + F[0]), [
                        T[1],
                        F[1]
                    ])), q = 1; q < H.length; q++)for(G += X.smoothing ? "C" : "L", V = 0; V < H[q].length; V++){
                        var N = H[q][V];
                        G += [
                            o.c2p(N[0]),
                            s.c2p(N[1])
                        ] + " ";
                    }
                    return G;
                }
                for(l = 0, h = null; c.length;){
                    var g = t.edgepaths[l][0];
                    for(h && (u += M(h, g)), p = eC.smoothopen(t.edgepaths[l].map(n), t.smoothing), u += f ? p : p.replace(/^M/, "L"), c.splice(c.indexOf(l), 1), h = t.edgepaths[l][t.edgepaths[l].length - 1], x = -1, v = 0; v < 4; v++){
                        if (!h) {
                            m1.log("Missing end?", l, t);
                            break;
                        }
                        for(A(h) && !C(h) ? d = r[1] : _(h) ? d = r[0] : L(h) ? d = r[3] : C(h) && (d = r[2]), b = 0; b < t.edgepaths.length; b++){
                            var P = t.edgepaths[b][0];
                            Math.abs(h[0] - d[0]) < E ? Math.abs(h[0] - P[0]) < E && (P[1] - h[1]) * (d[1] - P[1]) >= 0 && (d = P, x = b) : Math.abs(h[1] - d[1]) < k ? Math.abs(h[1] - P[1]) < k && (P[0] - h[0]) * (d[0] - P[0]) >= 0 && (d = P, x = b) : m1.log("endpt to newendpt is not vert. or horz.", h, d, P);
                        }
                        if (x >= 0) break;
                        u += M(h, d), h = d;
                    }
                    if (x === t.edgepaths.length) {
                        m1.log("unclosed perimeter path");
                        break;
                    }
                    l = x, f = c.indexOf(l) === -1, f && (l = c[0], u += M(h, d) + "Z", h = null);
                }
                for(l = 0; l < t.paths.length; l++)u += eC.smoothclosed(t.paths[l].map(n), t.smoothing);
                return u;
            }
        });
        var bYe = ye((Rxr, xYe)=>{
            "use strict";
            xYe.exports = {
                attributes: g$(),
                supplyDefaults: m$(),
                colorbar: S8(),
                calc: cYe(),
                plot: _Ye(),
                style: A8(),
                moduleType: "trace",
                name: "contourcarpet",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "carpet",
                    "contour",
                    "symbols",
                    "showLegend",
                    "hasLines",
                    "carpetDependent",
                    "noHover",
                    "noSortingByValue"
                ],
                meta: {}
            };
        });
        var TYe = ye((Dxr, wYe)=>{
            "use strict";
            wYe.exports = bYe();
        });
        var J7 = ye((zxr, kYe)=>{
            "use strict";
            var K7 = Mr().extendFlat, tC = Uc(), AYe = Oc().axisHoverFormat, MYe = Ed().dash, DYt = i3(), EYe = HT(), zYt = EYe.INCREASING.COLOR, FYt = EYe.DECREASING.COLOR, y$ = tC.line;
            function SYe(e) {
                return {
                    line: {
                        color: K7({}, y$.color, {
                            dflt: e
                        }),
                        width: y$.width,
                        dash: MYe,
                        editType: "style"
                    },
                    editType: "style"
                };
            }
            kYe.exports = {
                xperiod: tC.xperiod,
                xperiod0: tC.xperiod0,
                xperiodalignment: tC.xperiodalignment,
                xhoverformat: AYe("x"),
                yhoverformat: AYe("y"),
                x: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                open: {
                    valType: "data_array",
                    editType: "calc"
                },
                high: {
                    valType: "data_array",
                    editType: "calc"
                },
                low: {
                    valType: "data_array",
                    editType: "calc"
                },
                close: {
                    valType: "data_array",
                    editType: "calc"
                },
                line: {
                    width: K7({}, y$.width, {}),
                    dash: K7({}, MYe, {}),
                    editType: "style"
                },
                increasing: SYe(zYt),
                decreasing: SYe(FYt),
                text: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0,
                    editType: "calc"
                },
                hovertext: {
                    valType: "string",
                    dflt: "",
                    arrayOk: !0,
                    editType: "calc"
                },
                tickwidth: {
                    valType: "number",
                    min: 0,
                    max: .5,
                    dflt: .3,
                    editType: "calc"
                },
                hoverlabel: K7({}, DYt.hoverlabel, {
                    split: {
                        valType: "boolean",
                        dflt: !1,
                        editType: "style"
                    }
                }),
                zorder: tC.zorder
            };
        });
        var _$ = ye((Fxr, CYe)=>{
            "use strict";
            var qYt = ba(), OYt = Mr();
            CYe.exports = function(t, r, n, i) {
                var a = n("x"), o = n("open"), s = n("high"), l = n("low"), u = n("close");
                n("hoverlabel.split");
                var c = qYt.getComponentMethod("calendars", "handleTraceDefaults");
                if (c(t, r, [
                    "x"
                ], i), !!(o && s && l && u)) {
                    var f = Math.min(o.length, s.length, l.length, u.length);
                    return a && (f = Math.min(f, OYt.minRowLength(a))), r._length = f, f;
                }
            };
        });
        var IYe = ye((qxr, PYe)=>{
            "use strict";
            var BYt = Mr(), NYt = _$(), UYt = Pg(), VYt = J7();
            PYe.exports = function(t, r, n, i) {
                function a(s, l) {
                    return BYt.coerce(t, r, VYt, s, l);
                }
                var o = NYt(t, r, a, i);
                if (!o) {
                    r.visible = !1;
                    return;
                }
                UYt(t, r, i, a, {
                    x: !0
                }), a("xhoverformat"), a("yhoverformat"), a("line.width"), a("line.dash"), LYe(t, r, a, "increasing"), LYe(t, r, a, "decreasing"), a("text"), a("hovertext"), a("tickwidth"), i._requestRangeslider[r.xaxis] = !0, a("zorder");
            };
            function LYe(e, t, r, n) {
                r(n + ".line.color"), r(n + ".line.width", t.line.width), r(n + ".line.dash", t.line.dash);
            }
        });
        var x$ = ye((Oxr, DYe)=>{
            "use strict";
            var BA = Mr(), $7 = BA._, Q7 = Qa(), HYt = Rg(), rC = es().BADNUM;
            function GYt(e, t) {
                var r = Q7.getFromId(e, t.xaxis), n = Q7.getFromId(e, t.yaxis), i = WYt(e, r, t), a = t._minDiff;
                t._minDiff = null;
                var o = t._origX;
                t._origX = null;
                var s = t._xcalc;
                t._xcalc = null;
                var l = RYe(e, t, o, s, n, jYt);
                return t._extremes[r._id] = Q7.findExtremes(r, s, {
                    vpad: a / 2
                }), l.length ? (BA.extendFlat(l[0].t, {
                    wHover: a / 2,
                    tickLen: i
                }), l) : [
                    {
                        t: {
                            empty: !0
                        }
                    }
                ];
            }
            function jYt(e, t, r, n) {
                return {
                    o: e,
                    h: t,
                    l: r,
                    c: n
                };
            }
            function RYe(e, t, r, n, i, a) {
                for(var o = i.makeCalcdata(t, "open"), s = i.makeCalcdata(t, "high"), l = i.makeCalcdata(t, "low"), u = i.makeCalcdata(t, "close"), c = BA.isArrayOrTypedArray(t.text), f = BA.isArrayOrTypedArray(t.hovertext), h = !0, d = null, v = !!t.xperiodalignment, x = [], b = 0; b < n.length; b++){
                    var p = n[b], E = o[b], k = s[b], A = l[b], L = u[b];
                    if (p !== rC && E !== rC && k !== rC && A !== rC && L !== rC) {
                        L === E ? d !== null && L !== d && (h = L > d) : h = L > E, d = L;
                        var _ = a(E, k, A, L);
                        _.pos = p, _.yc = (E + L) / 2, _.i = b, _.dir = h ? "increasing" : "decreasing", _.x = _.pos, _.y = [
                            A,
                            k
                        ], v && (_.orig_p = r[b]), c && (_.tx = t.text[b]), f && (_.htx = t.hovertext[b]), x.push(_);
                    } else x.push({
                        pos: p,
                        empty: !0
                    });
                }
                return t._extremes[i._id] = Q7.findExtremes(i, BA.concat(l, s), {
                    padded: !0
                }), x.length && (x[0].t = {
                    labels: {
                        open: $7(e, "open:") + " ",
                        high: $7(e, "high:") + " ",
                        low: $7(e, "low:") + " ",
                        close: $7(e, "close:") + " "
                    }
                }), x;
            }
            function WYt(e, t, r) {
                var n = r._minDiff;
                if (!n) {
                    var i = e._fullData, a = [];
                    n = 1 / 0;
                    var o;
                    for(o = 0; o < i.length; o++){
                        var s = i[o];
                        if (s.type === "ohlc" && s.visible === !0 && s.xaxis === t._id) {
                            a.push(s);
                            var l = t.makeCalcdata(s, "x");
                            s._origX = l;
                            var u = HYt(r, t, "x", l).vals;
                            s._xcalc = u;
                            var c = BA.distinctVals(u).minDiff;
                            c && isFinite(c) && (n = Math.min(n, c));
                        }
                    }
                    for(n === 1 / 0 && (n = 1), o = 0; o < a.length; o++)a[o]._minDiff = n;
                }
                return n * r.tickwidth;
            }
            DYe.exports = {
                calc: GYt,
                calcCommon: RYe
            };
        });
        var qYe = ye((Bxr, FYe)=>{
            "use strict";
            var ZYt = xa(), zYe = Mr();
            FYe.exports = function(t, r, n, i) {
                var a = r.yaxis, o = r.xaxis, s = !!o.rangebreaks;
                zYe.makeTraceGroups(i, n, "trace ohlc").each(function(l) {
                    var u = ZYt.select(this), c = l[0], f = c.t, h = c.trace;
                    if (h.visible !== !0 || f.empty) {
                        u.remove();
                        return;
                    }
                    var d = f.tickLen, v = u.selectAll("path").data(zYe.identity);
                    v.enter().append("path"), v.exit().remove(), v.attr("d", function(x) {
                        if (x.empty) return "M0,0Z";
                        var b = o.c2p(x.pos - d, !0), p = o.c2p(x.pos + d, !0), E = s ? (b + p) / 2 : o.c2p(x.pos, !0), k = a.c2p(x.o, !0), A = a.c2p(x.h, !0), L = a.c2p(x.l, !0), _ = a.c2p(x.c, !0);
                        return "M" + b + "," + k + "H" + E + "M" + E + "," + A + "V" + L + "M" + p + "," + _ + "H" + E;
                    });
                });
            };
        });
        var BYe = ye((Nxr, OYe)=>{
            "use strict";
            var b$ = xa(), XYt = ao(), YYt = va();
            OYe.exports = function(t, r, n) {
                var i = n || b$.select(t).selectAll("g.ohlclayer").selectAll("g.trace");
                i.style("opacity", function(a) {
                    return a[0].trace.opacity;
                }), i.each(function(a) {
                    var o = a[0].trace;
                    b$.select(this).selectAll("path").each(function(s) {
                        if (!s.empty) {
                            var l = o[s.dir].line;
                            b$.select(this).style("fill", "none").call(YYt.stroke, l.color).call(XYt.dashLine, l.dash, l.width).style("opacity", o.selectedpoints && !s.selected ? .3 : 1);
                        }
                    });
                });
            };
        });
        var T$ = ye((Uxr, GYe)=>{
            "use strict";
            var w$ = Qa(), KYt = Mr(), e9 = Nc(), JYt = va(), $Yt = Mr().fillText, NYe = HT(), QYt = {
                increasing: NYe.INCREASING.SYMBOL,
                decreasing: NYe.DECREASING.SYMBOL
            };
            function eKt(e, t, r, n) {
                var i = e.cd, a = i[0].trace;
                return a.hoverlabel.split ? VYe(e, t, r, n) : HYe(e, t, r, n);
            }
            function UYe(e, t, r, n) {
                var i = e.cd, a = e.xa, o = i[0].trace, s = i[0].t, l = o.type, u = l === "ohlc" ? "l" : "min", c = l === "ohlc" ? "h" : "max", f, h, d = s.bPos || 0, v = function(P) {
                    return P.pos + d - t;
                }, x = s.bdPos || s.tickLen, b = s.wHover, p = Math.min(1, x / Math.abs(a.r2c(a.range[1]) - a.r2c(a.range[0])));
                f = e.maxHoverDistance - p, h = e.maxSpikeDistance - p;
                function E(P) {
                    var T = v(P);
                    return e9.inbox(T - b, T + b, f);
                }
                function k(P) {
                    var T = P[u], F = P[c];
                    return T === F || e9.inbox(T - r, F - r, f);
                }
                function A(P) {
                    return (E(P) + k(P)) / 2;
                }
                var L = e9.getDistanceFunction(n, E, k, A);
                if (e9.getClosest(i, L, e), e.index === !1) return null;
                var _ = i[e.index];
                if (_.empty) return null;
                var C = _.dir, M = o[C], g = M.line.color;
                return JYt.opacity(g) && M.line.width ? e.color = g : e.color = M.fillcolor, e.x0 = a.c2p(_.pos + d - x, !0), e.x1 = a.c2p(_.pos + d + x, !0), e.xLabelVal = _.orig_p !== void 0 ? _.orig_p : _.pos, e.spikeDistance = A(_) * h / f, e.xSpike = a.c2p(_.pos, !0), e;
            }
            function VYe(e, t, r, n) {
                var i = e.cd, a = e.ya, o = i[0].trace, s = i[0].t, l = [], u = UYe(e, t, r, n);
                if (!u) return [];
                var c = u.index, f = i[c], h = f.hi || o.hoverinfo, d = h.split("+"), v = h === "all", x = v || d.indexOf("y") !== -1;
                if (!x) return [];
                for(var b = [
                    "high",
                    "open",
                    "close",
                    "low"
                ], p = {}, E = 0; E < b.length; E++){
                    var k = b[E], A = o[k][u.index], L = a.c2p(A, !0), _;
                    A in p ? (_ = p[A], _.yLabel += "<br>" + s.labels[k] + w$.hoverLabelText(a, A, o.yhoverformat)) : (_ = KYt.extendFlat({}, u), _.y0 = _.y1 = L, _.yLabelVal = A, _.yLabel = s.labels[k] + w$.hoverLabelText(a, A, o.yhoverformat), _.name = "", l.push(_), p[A] = _);
                }
                return l;
            }
            function HYe(e, t, r, n) {
                var i = e.cd, a = e.ya, o = i[0].trace, s = i[0].t, l = UYe(e, t, r, n);
                if (!l) return [];
                var u = l.index, c = i[u], f = l.index = c.i, h = c.dir;
                function d(A) {
                    return s.labels[A] + w$.hoverLabelText(a, o[A][f], o.yhoverformat);
                }
                var v = c.hi || o.hoverinfo, x = v.split("+"), b = v === "all", p = b || x.indexOf("y") !== -1, E = b || x.indexOf("text") !== -1, k = p ? [
                    d("open"),
                    d("high"),
                    d("low"),
                    d("close") + "  " + QYt[h]
                ] : [];
                return E && $Yt(c, o, k), l.extraText = k.join("<br>"), l.y0 = l.y1 = a.c2p(c.yc, !0), [
                    l
                ];
            }
            GYe.exports = {
                hoverPoints: eKt,
                hoverSplit: VYe,
                hoverOnPoints: HYe
            };
        });
        var A$ = ye((Vxr, jYe)=>{
            "use strict";
            jYe.exports = function(t, r) {
                var n = t.cd, i = t.xaxis, a = t.yaxis, o = [], s, l = n[0].t.bPos || 0;
                if (r === !1) for(s = 0; s < n.length; s++)n[s].selected = 0;
                else for(s = 0; s < n.length; s++){
                    var u = n[s];
                    r.contains([
                        i.c2p(u.pos + l),
                        a.c2p(u.yc)
                    ], null, u.i, t) ? (o.push({
                        pointNumber: u.i,
                        x: i.c2d(u.pos),
                        y: a.c2d(u.yc)
                    }), u.selected = 1) : u.selected = 0;
                }
                return o;
            };
        });
        var ZYe = ye((Hxr, WYe)=>{
            "use strict";
            WYe.exports = {
                moduleType: "trace",
                name: "ohlc",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "showLegend"
                ],
                meta: {},
                attributes: J7(),
                supplyDefaults: IYe(),
                calc: x$().calc,
                plot: qYe(),
                style: BYe(),
                hoverPoints: T$().hoverPoints,
                selectPoints: A$()
            };
        });
        var YYe = ye((Gxr, XYe)=>{
            "use strict";
            XYe.exports = ZYe();
        });
        var M$ = ye((jxr, $Ye)=>{
            "use strict";
            var S$ = Mr().extendFlat, KYe = Oc().axisHoverFormat, c0 = J7(), NA = v4();
            function JYe(e) {
                return {
                    line: {
                        color: S$({}, NA.line.color, {
                            dflt: e
                        }),
                        width: NA.line.width,
                        editType: "style"
                    },
                    fillcolor: NA.fillcolor,
                    editType: "style"
                };
            }
            $Ye.exports = {
                xperiod: c0.xperiod,
                xperiod0: c0.xperiod0,
                xperiodalignment: c0.xperiodalignment,
                xhoverformat: KYe("x"),
                yhoverformat: KYe("y"),
                x: c0.x,
                open: c0.open,
                high: c0.high,
                low: c0.low,
                close: c0.close,
                line: {
                    width: S$({}, NA.line.width, {}),
                    editType: "style"
                },
                increasing: JYe(c0.increasing.line.color.dflt),
                decreasing: JYe(c0.decreasing.line.color.dflt),
                text: c0.text,
                hovertext: c0.hovertext,
                whiskerwidth: S$({}, NA.whiskerwidth, {
                    dflt: 0
                }),
                hoverlabel: c0.hoverlabel,
                zorder: NA.zorder
            };
        });
        var tKe = ye((Wxr, eKe)=>{
            "use strict";
            var tKt = Mr(), rKt = va(), iKt = _$(), nKt = Pg(), aKt = M$();
            eKe.exports = function(t, r, n, i) {
                function a(s, l) {
                    return tKt.coerce(t, r, aKt, s, l);
                }
                var o = iKt(t, r, a, i);
                if (!o) {
                    r.visible = !1;
                    return;
                }
                nKt(t, r, i, a, {
                    x: !0
                }), a("xhoverformat"), a("yhoverformat"), a("line.width"), QYe(t, r, a, "increasing"), QYe(t, r, a, "decreasing"), a("text"), a("hovertext"), a("whiskerwidth"), i._requestRangeslider[r.xaxis] = !0, a("zorder");
            };
            function QYe(e, t, r, n) {
                var i = r(n + ".line.color");
                r(n + ".line.width", t.line.width), r(n + ".fillcolor", rKt.addOpacity(i, .5));
            }
        });
        var aKe = ye((Zxr, nKe)=>{
            "use strict";
            var rKe = Mr(), iKe = Qa(), oKt = Rg(), sKt = x$().calcCommon;
            nKe.exports = function(e, t) {
                var r = e._fullLayout, n = iKe.getFromId(e, t.xaxis), i = iKe.getFromId(e, t.yaxis), a = n.makeCalcdata(t, "x"), o = oKt(t, n, "x", a).vals, s = sKt(e, t, a, o, i, lKt);
                return s.length ? (rKe.extendFlat(s[0].t, {
                    num: r._numBoxes,
                    dPos: rKe.distinctVals(o).minDiff / 2,
                    posLetter: "x",
                    valLetter: "y"
                }), r._numBoxes++, s) : [
                    {
                        t: {
                            empty: !0
                        }
                    }
                ];
            };
            function lKt(e, t, r, n) {
                return {
                    min: r,
                    q1: Math.min(e, n),
                    med: n,
                    q3: Math.max(e, n),
                    max: t
                };
            }
        });
        var sKe = ye((Xxr, oKe)=>{
            "use strict";
            oKe.exports = {
                moduleType: "trace",
                name: "candlestick",
                basePlotModule: Jf(),
                categories: [
                    "cartesian",
                    "svg",
                    "showLegend",
                    "candlestick",
                    "boxLayout"
                ],
                meta: {},
                attributes: M$(),
                layoutAttributes: p4(),
                supplyLayoutDefaults: VI().supplyLayoutDefaults,
                crossTraceCalc: GI().crossTraceCalc,
                supplyDefaults: tKe(),
                calc: aKe(),
                plot: jI().plot,
                layerName: "boxlayer",
                style: WI().style,
                hoverPoints: T$().hoverPoints,
                selectPoints: A$()
            };
        });
        var uKe = ye((Yxr, lKe)=>{
            "use strict";
            lKe.exports = sKe();
        });
        var k$ = ye((Kxr, cKe)=>{
            "use strict";
            var r9 = Mr(), uKt = ym(), t9 = r9.deg2rad, E$ = r9.rad2deg;
            cKe.exports = function(t, r, n) {
                switch(uKt(t, n), t._id){
                    case "x":
                    case "radialaxis":
                        cKt(t, r);
                        break;
                    case "angularaxis":
                        dKt(t, r);
                        break;
                }
            };
            function cKt(e, t) {
                var r = t._subplot;
                e.setGeometry = function() {
                    var n = e._rl[0], i = e._rl[1], a = r.innerRadius, o = (r.radius - a) / (i - n), s = a / o, l = n > i ? function(u) {
                        return u <= 0;
                    } : function(u) {
                        return u >= 0;
                    };
                    e.c2g = function(u) {
                        var c = e.c2l(u) - n;
                        return (l(c) ? c : 0) + s;
                    }, e.g2c = function(u) {
                        return e.l2c(u + n - s);
                    }, e.g2p = function(u) {
                        return u * o;
                    }, e.c2p = function(u) {
                        return e.g2p(e.c2g(u));
                    };
                };
            }
            function fKt(e, t) {
                return t === "degrees" ? t9(e) : e;
            }
            function hKt(e, t) {
                return t === "degrees" ? E$(e) : e;
            }
            function dKt(e, t) {
                var r = e.type;
                if (r === "linear") {
                    var n = e.d2c, i = e.c2d;
                    e.d2c = function(a, o) {
                        return fKt(n(a), o);
                    }, e.c2d = function(a, o) {
                        return i(hKt(a, o));
                    };
                }
                e.makeCalcdata = function(a, o) {
                    var s = a[o], l = a._length, u, c, f = function(b) {
                        return e.d2c(b, a.thetaunit);
                    };
                    if (s) for(u = new Array(l), c = 0; c < l; c++)u[c] = f(s[c]);
                    else {
                        var h = o + "0", d = "d" + o, v = h in a ? f(a[h]) : 0, x = a[d] ? f(a[d]) : (e.period || 2 * Math.PI) / l;
                        for(u = new Array(l), c = 0; c < l; c++)u[c] = v + c * x;
                    }
                    return u;
                }, e.setGeometry = function() {
                    var a = t.sector, o = a.map(t9), s = {
                        clockwise: -1,
                        counterclockwise: 1
                    }[e.direction], l = t9(e.rotation), u = function(p) {
                        return s * p + l;
                    }, c = function(p) {
                        return (p - l) / s;
                    }, f, h, d, v;
                    switch(r){
                        case "linear":
                            h = f = r9.identity, v = t9, d = E$, e.range = r9.isFullCircle(o) ? [
                                a[0],
                                a[0] + 360
                            ] : o.map(c).map(E$);
                            break;
                        case "category":
                            var x = e._categories.length, b = e.period ? Math.max(e.period, x) : x;
                            b === 0 && (b = 1), h = v = function(p) {
                                return p * 2 * Math.PI / b;
                            }, f = d = function(p) {
                                return p * b / Math.PI / 2;
                            }, e.range = [
                                0,
                                b
                            ];
                            break;
                    }
                    e.c2g = function(p) {
                        return u(h(p));
                    }, e.g2c = function(p) {
                        return f(c(p));
                    }, e.t2g = function(p) {
                        return u(v(p));
                    }, e.g2t = function(p) {
                        return d(c(p));
                    };
                };
            }
        });
        var i9 = ye((Jxr, fKe)=>{
            "use strict";
            fKe.exports = {
                attr: "subplot",
                name: "polar",
                axisNames: [
                    "angularaxis",
                    "radialaxis"
                ],
                axisName2dataArray: {
                    angularaxis: "theta",
                    radialaxis: "r"
                },
                layerNames: [
                    "draglayer",
                    "plotbg",
                    "backplot",
                    "angular-grid",
                    "radial-grid",
                    "frontplot",
                    "angular-line",
                    "radial-line",
                    "angular-axis",
                    "radial-axis"
                ],
                radialDragBoxSize: 50,
                angularDragBoxSize: 30,
                cornerLen: 25,
                cornerHalfWidth: 2,
                MINDRAG: 8,
                MINZOOM: 20,
                OFFEDGE: 20
            };
        });
        var a9 = ye(($xr, gKe)=>{
            "use strict";
            var dw = Mr(), hKe = wM().tester, C$ = dw.findIndexOfMin, vKe = dw.isAngleInsideSector, vKt = dw.angleDelta, dKe = dw.angleDist;
            function pKt(e, t, r, n, i) {
                if (!vKe(t, n)) return !1;
                var a, o;
                r[0] < r[1] ? (a = r[0], o = r[1]) : (a = r[1], o = r[0]);
                var s = hKe(UA(a, n[0], n[1], i)), l = hKe(UA(o, n[0], n[1], i)), u = [
                    e * Math.cos(t),
                    e * Math.sin(t)
                ];
                return l.contains(u) && !s.contains(u);
            }
            function pKe(e, t, r, n) {
                var i, a, o = n[0], s = n[1], l = n9(Math.sin(t) - Math.sin(e)), u = n9(Math.cos(t) - Math.cos(e)), c = Math.tan(r), f = n9(1 / c), h = l / u, d = s - h * o;
                return f ? l && u ? (i = d / (c - h), a = c * i) : u ? (i = s * f, a = s) : (i = o, a = o * c) : l && u ? (i = 0, a = d) : u ? (i = 0, a = s) : i = a = NaN, [
                    i,
                    a
                ];
            }
            function gKt(e, t, r, n) {
                var i = -t * r, a = t * t + 1, o = 2 * (t * i - r), s = i * i + r * r - e * e, l = Math.sqrt(o * o - 4 * a * s), u = (-o + l) / (2 * a), c = (-o - l) / (2 * a);
                return [
                    [
                        u,
                        t * u + i + n
                    ],
                    [
                        c,
                        t * c + i + n
                    ]
                ];
            }
            function mKt(e, t) {
                var r = t.length, n = new Array(r + 1), i;
                for(i = 0; i < r; i++){
                    var a = t[i];
                    n[i] = [
                        e * Math.cos(a),
                        e * Math.sin(a)
                    ];
                }
                return n[i] = n[0].slice(), n;
            }
            function yKt(e, t, r, n) {
                var i = n.length, a = [], o, s;
                function l(p) {
                    return [
                        e * Math.cos(p),
                        e * Math.sin(p)
                    ];
                }
                function u(p, E, k) {
                    return pKe(p, E, k, l(p));
                }
                function c(p) {
                    return dw.mod(p, i);
                }
                function f(p) {
                    return vKe(p, [
                        t,
                        r
                    ]);
                }
                var h = C$(n, function(p) {
                    return f(p) ? dKe(p, t) : 1 / 0;
                }), d = u(n[h], n[c(h - 1)], t);
                for(a.push(d), o = h, s = 0; s < i; o++, s++){
                    var v = n[c(o)];
                    if (!f(v)) break;
                    a.push(l(v));
                }
                var x = C$(n, function(p) {
                    return f(p) ? dKe(p, r) : 1 / 0;
                }), b = u(n[x], n[c(x + 1)], r);
                return a.push(b), a.push([
                    0,
                    0
                ]), a.push(a[0].slice()), a;
            }
            function UA(e, t, r, n) {
                return dw.isFullCircle([
                    t,
                    r
                ]) ? mKt(e, n) : yKt(e, t, r, n);
            }
            function _Kt(e, t, r, n) {
                for(var i = 1 / 0, a = 1 / 0, o = UA(e, t, r, n), s = 0; s < o.length; s++){
                    var l = o[s];
                    i = Math.min(i, l[0]), a = Math.min(a, -l[1]);
                }
                return [
                    i,
                    a
                ];
            }
            function xKt(e, t) {
                var r = function(a) {
                    var o = vKt(a, e);
                    return o > 0 ? o : 1 / 0;
                }, n = C$(t, r), i = dw.mod(n + 1, t.length);
                return [
                    t[n],
                    t[i]
                ];
            }
            function n9(e) {
                return Math.abs(e) > 1e-10 ? e : 0;
            }
            function L$(e, t, r) {
                t = t || 0, r = r || 0;
                for(var n = e.length, i = new Array(n), a = 0; a < n; a++){
                    var o = e[a];
                    i[a] = [
                        t + o[0],
                        r - o[1]
                    ];
                }
                return i;
            }
            function bKt(e, t, r, n, i, a) {
                var o = UA(e, t, r, n);
                return "M" + L$(o, i, a).join("L");
            }
            function wKt(e, t, r, n, i, a, o) {
                var s, l;
                e < t ? (s = e, l = t) : (s = t, l = e);
                var u = L$(UA(s, r, n, i), a, o), c = L$(UA(l, r, n, i), a, o);
                return "M" + c.reverse().join("L") + "M" + u.join("L");
            }
            gKe.exports = {
                isPtInsidePolygon: pKt,
                findPolygonOffset: _Kt,
                findEnclosingVertexAngles: xKt,
                findIntersectionXY: pKe,
                findXYatLength: gKt,
                clampTiny: n9,
                pathPolygon: bKt,
                pathPolygonAnnulus: wKt
            };
        });
        var P$ = ye((Qxr, _Ke)=>{
            "use strict";
            function mKe(e) {
                return e < 0 ? -1 : e > 0 ? 1 : 0;
            }
            function VA(e) {
                var t = e[0], r = e[1];
                if (!isFinite(t) || !isFinite(r)) return [
                    1,
                    0
                ];
                var n = (t + 1) * (t + 1) + r * r;
                return [
                    (t * t + r * r - 1) / n,
                    2 * r / n
                ];
            }
            function HA(e, t) {
                var r = t[0], n = t[1];
                return [
                    r * e.radius + e.cx,
                    -n * e.radius + e.cy
                ];
            }
            function yKe(e, t) {
                return t * e.radius;
            }
            function TKt(e, t, r, n) {
                var i = HA(e, VA([
                    r,
                    t
                ])), a = i[0], o = i[1], s = HA(e, VA([
                    n,
                    t
                ])), l = s[0], u = s[1];
                if (t === 0) return [
                    "M" + a + "," + o,
                    "L" + l + "," + u
                ].join(" ");
                var c = yKe(e, 1 / Math.abs(t));
                return [
                    "M" + a + "," + o,
                    "A" + c + "," + c + " 0 0," + (t < 0 ? 1 : 0) + " " + l + "," + u
                ].join(" ");
            }
            function AKt(e, t, r, n) {
                var i = yKe(e, 1 / (t + 1)), a = HA(e, VA([
                    t,
                    r
                ])), o = a[0], s = a[1], l = HA(e, VA([
                    t,
                    n
                ])), u = l[0], c = l[1];
                if (mKe(r) !== mKe(n)) {
                    var f = HA(e, VA([
                        t,
                        0
                    ])), h = f[0], d = f[1];
                    return [
                        "M" + o + "," + s,
                        "A" + i + "," + i + " 0 0," + (0 < r ? 0 : 1) + " " + h + "," + d,
                        "A" + i + "," + i + " 0 0," + (n < 0 ? 0 : 1) + u + "," + c
                    ].join(" ");
                }
                return [
                    "M" + o + "," + s,
                    "A" + i + "," + i + " 0 0," + (n < r ? 0 : 1) + " " + u + "," + c
                ].join(" ");
            }
            _Ke.exports = {
                smith: VA,
                reactanceArc: TKt,
                resistanceArc: AKt,
                smithTransform: HA
            };
        });
        var D$ = ye((ebr, kKe)=>{
            "use strict";
            var vw = xa(), SKt = id(), gw = ba(), cc = Mr(), ry = cc.strRotate, dd = cc.strTranslate, I$ = va(), iC = ao(), MKt = Xu(), dp = Qa(), EKt = ym(), kKt = k$(), CKt = wg().doAutoRange, y1 = DN(), l9 = gv(), xKe = Nc(), LKt = Mb(), PKt = wf().prepSelect, IKt = wf().selectOnClick, R$ = wf().clearOutline, bKe = Tg(), wKe = lM(), TKe = gM().redrawReglTraces, RKt = Nh().MID_SHIFT, Lx = i9(), _1 = a9(), u9 = P$(), o9 = u9.smith, DKt = u9.reactanceArc, zKt = u9.resistanceArc, s9 = u9.smithTransform, FKt = cc._, AKe = cc.mod, Px = cc.deg2rad, pw = cc.rad2deg;
            function SKe(e, t, r) {
                this.isSmith = r || !1, this.id = t, this.gd = e, this._hasClipOnAxisFalse = null, this.vangles = null, this.radialAxisAngle = null, this.traceHash = {}, this.layers = {}, this.clipPaths = {}, this.clipIds = {}, this.viewInitial = {};
                var n = e._fullLayout, i = "clip" + n._uid + t;
                this.clipIds.forTraces = i + "-for-traces", this.clipPaths.forTraces = n._clips.append("clipPath").attr("id", this.clipIds.forTraces), this.clipPaths.forTraces.append("path"), this.framework = n["_" + (r ? "smith" : "polar") + "layer"].append("g").attr("class", t), this.getHole = function(a) {
                    return this.isSmith ? 0 : a.hole;
                }, this.getSector = function(a) {
                    return this.isSmith ? [
                        0,
                        360
                    ] : a.sector;
                }, this.getRadial = function(a) {
                    return this.isSmith ? a.realaxis : a.radialaxis;
                }, this.getAngular = function(a) {
                    return this.isSmith ? a.imaginaryaxis : a.angularaxis;
                }, r || (this.radialTickLayout = null, this.angularTickLayout = null);
            }
            var Fd = SKe.prototype;
            kKe.exports = function(t, r, n) {
                return new SKe(t, r, n);
            };
            Fd.plot = function(e, t) {
                for(var r = this, n = t[r.id], i = !1, a = 0; a < e.length; a++){
                    var o = e[a][0].trace;
                    if (o.cliponaxis === !1) {
                        i = !0;
                        break;
                    }
                }
                r._hasClipOnAxisFalse = i, r.updateLayers(t, n), r.updateLayout(t, n), MKt.generalUpdatePerTraceModule(r.gd, r, e, n), r.updateFx(t, n), r.isSmith && (delete n.realaxis.range, delete n.imaginaryaxis.range);
            };
            Fd.updateLayers = function(e, t) {
                var r = this, n = r.isSmith, i = r.layers, a = r.getRadial(t), o = r.getAngular(t), s = Lx.layerNames, l = s.indexOf("frontplot"), u = s.slice(0, l), c = o.layer === "below traces", f = a.layer === "below traces";
                c && u.push("angular-line"), f && u.push("radial-line"), c && u.push("angular-axis"), f && u.push("radial-axis"), u.push("frontplot"), c || u.push("angular-line"), f || u.push("radial-line"), c || u.push("angular-axis"), f || u.push("radial-axis");
                var h = (n ? "smith" : "polar") + "sublayer", d = r.framework.selectAll("." + h).data(u, String);
                d.enter().append("g").attr("class", function(v) {
                    return h + " " + v;
                }).each(function(v) {
                    var x = i[v] = vw.select(this);
                    switch(v){
                        case "frontplot":
                            n || x.append("g").classed("barlayer", !0), x.append("g").classed("scatterlayer", !0);
                            break;
                        case "backplot":
                            x.append("g").classed("maplayer", !0);
                            break;
                        case "plotbg":
                            i.bg = x.append("path");
                            break;
                        case "radial-grid":
                            x.style("fill", "none");
                            break;
                        case "angular-grid":
                            x.style("fill", "none");
                            break;
                        case "radial-line":
                            x.append("line").style("fill", "none");
                            break;
                        case "angular-line":
                            x.append("path").style("fill", "none");
                            break;
                    }
                }), d.order();
            };
            Fd.updateLayout = function(e, t) {
                var r = this, n = r.layers, i = e._size, a = r.getRadial(t), o = r.getAngular(t), s = t.domain.x, l = t.domain.y;
                r.xOffset = i.l + i.w * s[0], r.yOffset = i.t + i.h * (1 - l[1]);
                var u = r.xLength = i.w * (s[1] - s[0]), c = r.yLength = i.h * (l[1] - l[0]), f = r.getSector(t);
                r.sectorInRad = f.map(Px);
                var h = r.sectorBBox = qKt(f), d = h[2] - h[0], v = h[3] - h[1], x = c / u, b = Math.abs(v / d), p, E, k, A, L;
                x > b ? (p = u, E = u * b, L = (c - E) / i.h / 2, k = [
                    s[0],
                    s[1]
                ], A = [
                    l[0] + L,
                    l[1] - L
                ]) : (p = c / b, E = c, L = (u - p) / i.w / 2, k = [
                    s[0] + L,
                    s[1] - L
                ], A = [
                    l[0],
                    l[1]
                ]), r.xLength2 = p, r.yLength2 = E, r.xDomain2 = k, r.yDomain2 = A;
                var _ = r.xOffset2 = i.l + i.w * k[0], C = r.yOffset2 = i.t + i.h * (1 - A[1]), M = r.radius = p / d, g = r.innerRadius = r.getHole(t) * M, P = r.cx = _ - M * h[0], T = r.cy = C + M * h[3], F = r.cxx = P - _, q = r.cyy = T - C, V = a.side, H;
                V === "counterclockwise" ? (H = V, V = "top") : V === "clockwise" && (H = V, V = "bottom"), r.radialAxis = r.mockAxis(e, t, a, {
                    _id: "x",
                    side: V,
                    _trueSide: H,
                    domain: [
                        g / i.w,
                        M / i.w
                    ]
                }), r.angularAxis = r.mockAxis(e, t, o, {
                    side: "right",
                    domain: [
                        0,
                        Math.PI
                    ],
                    autorange: !1
                }), r.doAutoRange(e, t), r.updateAngularAxis(e, t), r.updateRadialAxis(e, t), r.updateRadialAxisTitle(e, t), r.xaxis = r.mockCartesianAxis(e, t, {
                    _id: "x",
                    domain: k
                }), r.yaxis = r.mockCartesianAxis(e, t, {
                    _id: "y",
                    domain: A
                });
                var X = r.pathSubplot();
                r.clipPaths.forTraces.select("path").attr("d", X).attr("transform", dd(F, q)), n.frontplot.attr("transform", dd(_, C)).call(iC.setClipUrl, r._hasClipOnAxisFalse ? null : r.clipIds.forTraces, r.gd), n.bg.attr("d", X).attr("transform", dd(P, T)).call(I$.fill, t.bgcolor);
            };
            Fd.mockAxis = function(e, t, r, n) {
                var i = cc.extendFlat({}, r, n);
                return kKt(i, t, e), i;
            };
            Fd.mockCartesianAxis = function(e, t, r) {
                var n = this, i = n.isSmith, a = r._id, o = cc.extendFlat({
                    type: "linear"
                }, r);
                EKt(o, e);
                var s = {
                    x: [
                        0,
                        2
                    ],
                    y: [
                        1,
                        3
                    ]
                };
                return o.setRange = function() {
                    var l = n.sectorBBox, u = s[a], c = n.radialAxis._rl, f = (c[1] - c[0]) / (1 - n.getHole(t));
                    o.range = [
                        l[u[0]] * f,
                        l[u[1]] * f
                    ];
                }, o.isPtWithinRange = a === "x" && !i ? function(l) {
                    return n.isPtInside(l);
                } : function() {
                    return !0;
                }, o.setRange(), o.setScale(), o;
            };
            Fd.doAutoRange = function(e, t) {
                var r = this, n = r.gd, i = r.radialAxis, a = r.getRadial(t);
                CKt(n, i);
                var o = i.range;
                if (a.range = o.slice(), a._input.range = o.slice(), i._rl = [
                    i.r2l(o[0], null, "gregorian"),
                    i.r2l(o[1], null, "gregorian")
                ], i.minallowed !== void 0) {
                    var s = i.r2l(i.minallowed);
                    i._rl[0] > i._rl[1] ? i._rl[1] = Math.max(i._rl[1], s) : i._rl[0] = Math.max(i._rl[0], s);
                }
                if (i.maxallowed !== void 0) {
                    var l = i.r2l(i.maxallowed);
                    i._rl[0] < i._rl[1] ? i._rl[1] = Math.min(i._rl[1], l) : i._rl[0] = Math.min(i._rl[0], l);
                }
            };
            Fd.updateRadialAxis = function(e, t) {
                var r = this, n = r.gd, i = r.layers, a = r.radius, o = r.innerRadius, s = r.cx, l = r.cy, u = r.getRadial(t), c = AKe(r.getSector(t)[0], 360), f = r.radialAxis, h = o < a, d = r.isSmith;
                d || (r.fillViewInitialKey("radialaxis.angle", u.angle), r.fillViewInitialKey("radialaxis.range", f.range.slice()), f.setGeometry()), f.tickangle === "auto" && c > 90 && c <= 270 && (f.tickangle = 180);
                var v = d ? function(M) {
                    var g = s9(r, o9([
                        M.x,
                        0
                    ]));
                    return dd(g[0] - s, g[1] - l);
                } : function(M) {
                    return dd(f.l2p(M.x) + o, 0);
                }, x = d ? function(M) {
                    return zKt(r, M.x, -1 / 0, 1 / 0);
                } : function(M) {
                    return r.pathArc(f.r2p(M.x) + o);
                }, b = MKe(u);
                if (r.radialTickLayout !== b && (i["radial-axis"].selectAll(".xtick").remove(), r.radialTickLayout = b), h) {
                    f.setScale();
                    var p = 0, E = d ? (f.tickvals || []).filter(function(M) {
                        return M >= 0;
                    }).map(function(M) {
                        return dp.tickText(f, M, !0, !1);
                    }) : dp.calcTicks(f), k = d ? E : dp.clipEnds(f, E), A = dp.getTickSigns(f)[2];
                    d && ((f.ticks === "top" && f.side === "bottom" || f.ticks === "bottom" && f.side === "top") && (A = -A), f.ticks === "top" && f.side === "top" && (p = -f.ticklen), f.ticks === "bottom" && f.side === "bottom" && (p = f.ticklen)), dp.drawTicks(n, f, {
                        vals: E,
                        layer: i["radial-axis"],
                        path: dp.makeTickPath(f, 0, A),
                        transFn: v,
                        crisp: !1
                    }), dp.drawGrid(n, f, {
                        vals: k,
                        layer: i["radial-grid"],
                        path: x,
                        transFn: cc.noop,
                        crisp: !1
                    }), dp.drawLabels(n, f, {
                        vals: E,
                        layer: i["radial-axis"],
                        transFn: v,
                        labelFns: dp.makeLabelFns(f, p)
                    });
                }
                var L = r.radialAxisAngle = r.vangles ? pw(EKe(Px(u.angle), r.vangles)) : u.angle, _ = dd(s, l), C = _ + ry(-L);
                nC(i["radial-axis"], h && (u.showticklabels || u.ticks), {
                    transform: C
                }), nC(i["radial-grid"], h && u.showgrid, {
                    transform: d ? "" : _
                }), nC(i["radial-line"].select("line"), h && u.showline, {
                    x1: d ? -a : o,
                    y1: 0,
                    x2: a,
                    y2: 0,
                    transform: C
                }).attr("stroke-width", u.linewidth).call(I$.stroke, u.linecolor);
            };
            Fd.updateRadialAxisTitle = function(e, t, r) {
                if (!this.isSmith) {
                    var n = this, i = n.gd, a = n.radius, o = n.cx, s = n.cy, l = n.getRadial(t), u = n.id + "title", c = 0;
                    if (l.title) {
                        var f = iC.bBox(n.layers["radial-axis"].node()).height, h = l.title.font.size, d = l.side;
                        c = d === "top" ? h : d === "counterclockwise" ? -(f + h * .4) : f + h * .8;
                    }
                    var v = r !== void 0 ? r : n.radialAxisAngle, x = Px(v), b = Math.cos(x), p = Math.sin(x), E = o + a / 2 * b + c * p, k = s - a / 2 * p + c * b;
                    n.layers["radial-axis-title"] = LKt.draw(i, u, {
                        propContainer: l,
                        propName: n.id + ".radialaxis.title",
                        placeholder: FKt(i, "Click to enter radial axis title"),
                        attributes: {
                            x: E,
                            y: k,
                            "text-anchor": "middle"
                        },
                        transform: {
                            rotate: -v
                        }
                    });
                }
            };
            Fd.updateAngularAxis = function(e, t) {
                var r = this, n = r.gd, i = r.layers, a = r.radius, o = r.innerRadius, s = r.cx, l = r.cy, u = r.getAngular(t), c = r.angularAxis, f = r.isSmith;
                f || (r.fillViewInitialKey("angularaxis.rotation", u.rotation), c.setGeometry(), c.setScale());
                var h = f ? function(g) {
                    var P = s9(r, o9([
                        0,
                        g.x
                    ]));
                    return Math.atan2(P[0] - s, P[1] - l) - Math.PI / 2;
                } : function(g) {
                    return c.t2g(g.x);
                };
                c.type === "linear" && c.thetaunit === "radians" && (c.tick0 = pw(c.tick0), c.dtick = pw(c.dtick));
                var d = function(g) {
                    return dd(s + a * Math.cos(g), l - a * Math.sin(g));
                }, v = f ? function(g) {
                    var P = s9(r, o9([
                        0,
                        g.x
                    ]));
                    return dd(P[0], P[1]);
                } : function(g) {
                    return d(h(g));
                }, x = f ? function(g) {
                    var P = s9(r, o9([
                        0,
                        g.x
                    ])), T = Math.atan2(P[0] - s, P[1] - l) - Math.PI / 2;
                    return dd(P[0], P[1]) + ry(-pw(T));
                } : function(g) {
                    var P = h(g);
                    return d(P) + ry(-pw(P));
                }, b = f ? function(g) {
                    return DKt(r, g.x, 0, 1 / 0);
                } : function(g) {
                    var P = h(g), T = Math.cos(P), F = Math.sin(P);
                    return "M" + [
                        s + o * T,
                        l - o * F
                    ] + "L" + [
                        s + a * T,
                        l - a * F
                    ];
                }, p = dp.makeLabelFns(c, 0), E = p.labelStandoff, k = {};
                k.xFn = function(g) {
                    var P = h(g);
                    return Math.cos(P) * E;
                }, k.yFn = function(g) {
                    var P = h(g), T = Math.sin(P) > 0 ? .2 : 1;
                    return -Math.sin(P) * (E + g.fontSize * T) + Math.abs(Math.cos(P)) * (g.fontSize * RKt);
                }, k.anchorFn = function(g) {
                    var P = h(g), T = Math.cos(P);
                    return Math.abs(T) < .1 ? "middle" : T > 0 ? "start" : "end";
                }, k.heightFn = function(g, P, T) {
                    var F = h(g);
                    return -0.5 * (1 + Math.sin(F)) * T;
                };
                var A = MKe(u);
                r.angularTickLayout !== A && (i["angular-axis"].selectAll("." + c._id + "tick").remove(), r.angularTickLayout = A);
                var L = f ? [
                    1 / 0
                ].concat(c.tickvals || []).map(function(g) {
                    return dp.tickText(c, g, !0, !1);
                }) : dp.calcTicks(c);
                f && (L[0].text = "\u221E", L[0].fontSize *= 1.75);
                var _;
                if (t.gridshape === "linear" ? (_ = L.map(h), cc.angleDelta(_[0], _[1]) < 0 && (_ = _.slice().reverse())) : _ = null, r.vangles = _, c.type === "category" && (L = L.filter(function(g) {
                    return cc.isAngleInsideSector(h(g), r.sectorInRad);
                })), c.visible) {
                    var C = c.ticks === "inside" ? -1 : 1, M = (c.linewidth || 1) / 2;
                    dp.drawTicks(n, c, {
                        vals: L,
                        layer: i["angular-axis"],
                        path: "M" + C * M + ",0h" + C * c.ticklen,
                        transFn: x,
                        crisp: !1
                    }), dp.drawGrid(n, c, {
                        vals: L,
                        layer: i["angular-grid"],
                        path: b,
                        transFn: cc.noop,
                        crisp: !1
                    }), dp.drawLabels(n, c, {
                        vals: L,
                        layer: i["angular-axis"],
                        repositionOnUpdate: !0,
                        transFn: v,
                        labelFns: k
                    });
                }
                nC(i["angular-line"].select("path"), u.showline, {
                    d: r.pathSubplot(),
                    transform: dd(s, l)
                }).attr("stroke-width", u.linewidth).call(I$.stroke, u.linecolor);
            };
            Fd.updateFx = function(e, t) {
                if (!this.gd._context.staticPlot) {
                    var r = !this.isSmith;
                    r && (this.updateAngularDrag(e), this.updateRadialDrag(e, t, 0), this.updateRadialDrag(e, t, 1)), this.updateHoverAndMainDrag(e);
                }
            };
            Fd.updateHoverAndMainDrag = function(e) {
                var t = this, r = t.isSmith, n = t.gd, i = t.layers, a = e._zoomlayer, o = Lx.MINZOOM, s = Lx.OFFEDGE, l = t.radius, u = t.innerRadius, c = t.cx, f = t.cy, h = t.cxx, d = t.cyy, v = t.sectorInRad, x = t.vangles, b = t.radialAxis, p = _1.clampTiny, E = _1.findXYatLength, k = _1.findEnclosingVertexAngles, A = Lx.cornerHalfWidth, L = Lx.cornerLen / 2, _, C, M = y1.makeDragger(i, "path", "maindrag", e.dragmode === !1 ? "none" : "crosshair");
                vw.select(M).attr("d", t.pathSubplot()).attr("transform", dd(c, f)), M.onmousemove = function(ce) {
                    xKe.hover(n, ce, t.id), n._fullLayout._lasthover = M, n._fullLayout._hoversubplot = t.id;
                }, M.onmouseout = function(ce) {
                    n._dragging || l9.unhover(n, ce);
                };
                var g = {
                    element: M,
                    gd: n,
                    subplot: t.id,
                    plotinfo: {
                        id: t.id,
                        xaxis: t.xaxis,
                        yaxis: t.yaxis
                    },
                    xaxes: [
                        t.xaxis
                    ],
                    yaxes: [
                        t.yaxis
                    ]
                }, P, T, F, q, V, H, X, G, N;
                function W(ce, Ge) {
                    return Math.sqrt(ce * ce + Ge * Ge);
                }
                function re(ce, Ge) {
                    return W(ce - h, Ge - d);
                }
                function ae(ce, Ge) {
                    return Math.atan2(d - Ge, ce - h);
                }
                function _e(ce, Ge) {
                    return [
                        ce * Math.cos(Ge),
                        ce * Math.sin(-Ge)
                    ];
                }
                function Me(ce, Ge) {
                    if (ce === 0) return t.pathSector(2 * A);
                    var nt = L / ce, ct = Ge - nt, qt = Ge + nt, rt = Math.max(0, Math.min(ce, l)), ot = rt - A, Rt = rt + A;
                    return "M" + _e(ot, ct) + "A" + [
                        ot,
                        ot
                    ] + " 0,0,0 " + _e(ot, qt) + "L" + _e(Rt, qt) + "A" + [
                        Rt,
                        Rt
                    ] + " 0,0,1 " + _e(Rt, ct) + "Z";
                }
                function ke(ce, Ge, nt) {
                    if (ce === 0) return t.pathSector(2 * A);
                    var ct = _e(ce, Ge), qt = _e(ce, nt), rt = p((ct[0] + qt[0]) / 2), ot = p((ct[1] + qt[1]) / 2), Rt, kt;
                    if (rt && ot) {
                        var Ct = ot / rt, Yt = -1 / Ct, xr = E(A, Ct, rt, ot);
                        Rt = E(L, Yt, xr[0][0], xr[0][1]), kt = E(L, Yt, xr[1][0], xr[1][1]);
                    } else {
                        var er, Ke;
                        ot ? (er = L, Ke = A) : (er = A, Ke = L), Rt = [
                            [
                                rt - er,
                                ot - Ke
                            ],
                            [
                                rt + er,
                                ot - Ke
                            ]
                        ], kt = [
                            [
                                rt - er,
                                ot + Ke
                            ],
                            [
                                rt + er,
                                ot + Ke
                            ]
                        ];
                    }
                    return "M" + Rt.join("L") + "L" + kt.reverse().join("L") + "Z";
                }
                function ge() {
                    F = null, q = null, V = t.pathSubplot(), H = !1;
                    var ce = n._fullLayout[t.id];
                    X = SKt(ce.bgcolor).getLuminance(), G = y1.makeZoombox(a, X, c, f, V), G.attr("fill-rule", "evenodd"), N = y1.makeCorners(a, c, f), R$(n);
                }
                function ie(ce, Ge) {
                    return Ge = Math.max(Math.min(Ge, l), u), ce < s ? ce = 0 : l - ce < s ? ce = l : Ge < s ? Ge = 0 : l - Ge < s && (Ge = l), Math.abs(Ge - ce) > o ? (ce < Ge ? (F = ce, q = Ge) : (F = Ge, q = ce), !0) : (F = null, q = null, !1);
                }
                function Te(ce, Ge) {
                    ce = ce || V, Ge = Ge || "M0,0Z", G.attr("d", ce), N.attr("d", Ge), y1.transitionZoombox(G, N, H, X), H = !0;
                    var nt = {};
                    me(nt), n.emit("plotly_relayouting", nt);
                }
                function Ee(ce, Ge) {
                    ce = ce * _, Ge = Ge * C;
                    var nt = P + ce, ct = T + Ge, qt = re(P, T), rt = Math.min(re(nt, ct), l), ot = ae(P, T), Rt, kt;
                    ie(qt, rt) && (Rt = V + t.pathSector(q), F && (Rt += t.pathSector(F)), kt = Me(F, ot) + Me(q, ot)), Te(Rt, kt);
                }
                function Ae(ce, Ge, nt, ct) {
                    var qt = _1.findIntersectionXY(nt, ct, nt, [
                        ce - h,
                        d - Ge
                    ]);
                    return W(qt[0], qt[1]);
                }
                function ze(ce, Ge) {
                    var nt = P + ce, ct = T + Ge, qt = ae(P, T), rt = ae(nt, ct), ot = k(qt, x), Rt = k(rt, x), kt = Ae(P, T, ot[0], ot[1]), Ct = Math.min(Ae(nt, ct, Rt[0], Rt[1]), l), Yt, xr;
                    ie(kt, Ct) && (Yt = V + t.pathSector(q), F && (Yt += t.pathSector(F)), xr = [
                        ke(F, ot[0], ot[1]),
                        ke(q, ot[0], ot[1])
                    ].join(" ")), Te(Yt, xr);
                }
                function Ce() {
                    if (y1.removeZoombox(n), !(F === null || q === null)) {
                        var ce = {};
                        me(ce), y1.showDoubleClickNotifier(n), gw.call("_guiRelayout", n, ce);
                    }
                }
                function me(ce) {
                    var Ge = b._rl, nt = (Ge[1] - Ge[0]) / (1 - u / l) / l, ct = [
                        Ge[0] + (F - u) * nt,
                        Ge[0] + (q - u) * nt
                    ];
                    ce[t.id + ".radialaxis.range"] = ct;
                }
                function Re(ce, Ge) {
                    var nt = n._fullLayout.clickmode;
                    if (y1.removeZoombox(n), ce === 2) {
                        var ct = {};
                        for(var qt in t.viewInitial)ct[t.id + "." + qt] = t.viewInitial[qt];
                        n.emit("plotly_doubleclick", null), gw.call("_guiRelayout", n, ct);
                    }
                    nt.indexOf("select") > -1 && ce === 1 && IKt(Ge, n, [
                        t.xaxis
                    ], [
                        t.yaxis
                    ], t.id, g), nt.indexOf("event") > -1 && xKe.click(n, Ge, t.id);
                }
                g.prepFn = function(ce, Ge, nt) {
                    var ct = n._fullLayout.dragmode, qt = M.getBoundingClientRect();
                    n._fullLayout._calcInverseTransform(n);
                    var rt = n._fullLayout._invTransform;
                    _ = n._fullLayout._invScaleX, C = n._fullLayout._invScaleY;
                    var ot = cc.apply3DTransform(rt)(Ge - qt.left, nt - qt.top);
                    if (P = ot[0], T = ot[1], x) {
                        var Rt = _1.findPolygonOffset(l, v[0], v[1], x);
                        P += h + Rt[0], T += d + Rt[1];
                    }
                    switch(ct){
                        case "zoom":
                            g.clickFn = Re, r || (x ? g.moveFn = ze : g.moveFn = Ee, g.doneFn = Ce, ge(ce, Ge, nt));
                            break;
                        case "select":
                        case "lasso":
                            PKt(ce, Ge, nt, g, ct);
                            break;
                    }
                }, l9.init(g);
            };
            Fd.updateRadialDrag = function(e, t, r) {
                var n = this, i = n.gd, a = n.layers, o = n.radius, s = n.innerRadius, l = n.cx, u = n.cy, c = n.radialAxis, f = Lx.radialDragBoxSize, h = f / 2;
                if (!c.visible) return;
                var d = Px(n.radialAxisAngle), v = c._rl, x = v[0], b = v[1], p = v[r], E = .75 * (v[1] - v[0]) / (1 - n.getHole(t)) / o, k, A, L;
                r ? (k = l + (o + h) * Math.cos(d), A = u - (o + h) * Math.sin(d), L = "radialdrag") : (k = l + (s - h) * Math.cos(d), A = u - (s - h) * Math.sin(d), L = "radialdrag-inner");
                var _ = y1.makeRectDragger(a, L, "crosshair", -h, -h, f, f), C = {
                    element: _,
                    gd: i
                };
                e.dragmode === !1 && (C.dragmode = !1), nC(vw.select(_), c.visible && s < o, {
                    transform: dd(k, A)
                });
                var M, g, P;
                function T(X, G) {
                    if (M) M(X, G);
                    else {
                        var N = [
                            X,
                            -G
                        ], W = [
                            Math.cos(d),
                            Math.sin(d)
                        ], re = Math.abs(cc.dot(N, W) / Math.sqrt(cc.dot(N, N)));
                        isNaN(re) || (M = re < .5 ? V : H);
                    }
                    var ae = {};
                    F(ae), i.emit("plotly_relayouting", ae);
                }
                function F(X) {
                    g !== null ? X[n.id + ".radialaxis.angle"] = g : P !== null && (X[n.id + ".radialaxis.range[" + r + "]"] = P);
                }
                function q() {
                    g !== null ? gw.call("_guiRelayout", i, n.id + ".radialaxis.angle", g) : P !== null && gw.call("_guiRelayout", i, n.id + ".radialaxis.range[" + r + "]", P);
                }
                function V(X, G) {
                    if (r !== 0) {
                        var N = k + X, W = A + G;
                        g = Math.atan2(u - W, N - l), n.vangles && (g = EKe(g, n.vangles)), g = pw(g);
                        var re = dd(l, u) + ry(-g);
                        a["radial-axis"].attr("transform", re), a["radial-line"].select("line").attr("transform", re);
                        var ae = n.gd._fullLayout, _e = ae[n.id];
                        n.updateRadialAxisTitle(ae, _e, g);
                    }
                }
                function H(X, G) {
                    var N = cc.dot([
                        X,
                        -G
                    ], [
                        Math.cos(d),
                        Math.sin(d)
                    ]);
                    if (P = p - E * N, E > 0 != (r ? P > x : P < b)) {
                        P = null;
                        return;
                    }
                    var W = i._fullLayout, re = W[n.id];
                    c.range[r] = P, c._rl[r] = P, n.updateRadialAxis(W, re), n.xaxis.setRange(), n.xaxis.setScale(), n.yaxis.setRange(), n.yaxis.setScale();
                    var ae = !1;
                    for(var _e in n.traceHash){
                        var Me = n.traceHash[_e], ke = cc.filterVisible(Me), ge = Me[0][0].trace._module;
                        ge.plot(i, n, ke, re), gw.traceIs(_e, "gl") && ke.length && (ae = !0);
                    }
                    ae && (wKe(i), TKe(i));
                }
                C.prepFn = function() {
                    M = null, g = null, P = null, C.moveFn = T, C.doneFn = q, R$(i);
                }, C.clampFn = function(X, G) {
                    return Math.sqrt(X * X + G * G) < Lx.MINDRAG && (X = 0, G = 0), [
                        X,
                        G
                    ];
                }, l9.init(C);
            };
            Fd.updateAngularDrag = function(e) {
                var t = this, r = t.gd, n = t.layers, i = t.radius, a = t.angularAxis, o = t.cx, s = t.cy, l = t.cxx, u = t.cyy, c = Lx.angularDragBoxSize, f = y1.makeDragger(n, "path", "angulardrag", e.dragmode === !1 ? "none" : "move"), h = {
                    element: f,
                    gd: r
                };
                e.dragmode === !1 ? h.dragmode = !1 : vw.select(f).attr("d", t.pathAnnulus(i, i + c)).attr("transform", dd(o, s)).call(bKe, "move");
                function d(P, T) {
                    return Math.atan2(u + c - T, P - l - c);
                }
                var v = n.frontplot.select(".scatterlayer").selectAll(".trace"), x = v.selectAll(".point"), b = v.selectAll(".textpoint"), p, E, k, A, L, _;
                function C(P, T) {
                    var F = t.gd._fullLayout, q = F[t.id], V = p + P * e._invScaleX, H = E + T * e._invScaleY, X = d(V, H), G = pw(X - _);
                    if (A = k + G, n.frontplot.attr("transform", dd(t.xOffset2, t.yOffset2) + ry([
                        -G,
                        l,
                        u
                    ])), t.vangles) {
                        L = t.radialAxisAngle + G;
                        var N = dd(o, s) + ry(-G), W = dd(o, s) + ry(-L);
                        n.bg.attr("transform", N), n["radial-grid"].attr("transform", N), n["radial-axis"].attr("transform", W), n["radial-line"].select("line").attr("transform", W), t.updateRadialAxisTitle(F, q, L);
                    } else t.clipPaths.forTraces.select("path").attr("transform", dd(l, u) + ry(G));
                    x.each(function() {
                        var ie = vw.select(this), Te = iC.getTranslate(ie);
                        ie.attr("transform", dd(Te.x, Te.y) + ry([
                            G
                        ]));
                    }), b.each(function() {
                        var ie = vw.select(this), Te = ie.select("text"), Ee = iC.getTranslate(ie);
                        ie.attr("transform", ry([
                            G,
                            Te.attr("x"),
                            Te.attr("y")
                        ]) + dd(Ee.x, Ee.y));
                    }), a.rotation = cc.modHalf(A, 360), t.updateAngularAxis(F, q), t._hasClipOnAxisFalse && !cc.isFullCircle(t.sectorInRad) && v.call(iC.hideOutsideRangePoints, t);
                    var re = !1;
                    for(var ae in t.traceHash)if (gw.traceIs(ae, "gl")) {
                        var _e = t.traceHash[ae], Me = cc.filterVisible(_e), ke = _e[0][0].trace._module;
                        ke.plot(r, t, Me, q), Me.length && (re = !0);
                    }
                    re && (wKe(r), TKe(r));
                    var ge = {};
                    M(ge), r.emit("plotly_relayouting", ge);
                }
                function M(P) {
                    P[t.id + ".angularaxis.rotation"] = A, t.vangles && (P[t.id + ".radialaxis.angle"] = L);
                }
                function g() {
                    b.select("text").attr("transform", null);
                    var P = {};
                    M(P), gw.call("_guiRelayout", r, P);
                }
                h.prepFn = function(P, T, F) {
                    var q = e[t.id];
                    k = q.angularaxis.rotation;
                    var V = f.getBoundingClientRect();
                    p = T - V.left, E = F - V.top, r._fullLayout._calcInverseTransform(r);
                    var H = cc.apply3DTransform(e._invTransform)(p, E);
                    p = H[0], E = H[1], _ = d(p, E), h.moveFn = C, h.doneFn = g, R$(r);
                }, t.vangles && !cc.isFullCircle(t.sectorInRad) && (h.prepFn = cc.noop, bKe(vw.select(f), null)), l9.init(h);
            };
            Fd.isPtInside = function(e) {
                if (this.isSmith) return !0;
                var t = this.sectorInRad, r = this.vangles, n = this.angularAxis.c2g(e.theta), i = this.radialAxis, a = i.c2l(e.r), o = i._rl, s = r ? _1.isPtInsidePolygon : cc.isPtInsideSector;
                return s(a, n, o, t, r);
            };
            Fd.pathArc = function(e) {
                var t = this.sectorInRad, r = this.vangles, n = r ? _1.pathPolygon : cc.pathArc;
                return n(e, t[0], t[1], r);
            };
            Fd.pathSector = function(e) {
                var t = this.sectorInRad, r = this.vangles, n = r ? _1.pathPolygon : cc.pathSector;
                return n(e, t[0], t[1], r);
            };
            Fd.pathAnnulus = function(e, t) {
                var r = this.sectorInRad, n = this.vangles, i = n ? _1.pathPolygonAnnulus : cc.pathAnnulus;
                return i(e, t, r[0], r[1], n);
            };
            Fd.pathSubplot = function() {
                var e = this.innerRadius, t = this.radius;
                return e ? this.pathAnnulus(e, t) : this.pathSector(t);
            };
            Fd.fillViewInitialKey = function(e, t) {
                e in this.viewInitial || (this.viewInitial[e] = t);
            };
            function MKe(e) {
                var t = e.ticks + String(e.ticklen) + String(e.showticklabels);
                return "side" in e && (t += e.side), t;
            }
            function qKt(e) {
                var t = e[0], r = e[1], n = r - t, i = AKe(t, 360), a = i + n, o = Math.cos(Px(i)), s = Math.sin(Px(i)), l = Math.cos(Px(a)), u = Math.sin(Px(a)), c, f, h, d;
                return i <= 90 && a >= 90 || i > 90 && a >= 450 ? d = 1 : s <= 0 && u <= 0 ? d = 0 : d = Math.max(s, u), i <= 180 && a >= 180 || i > 180 && a >= 540 ? c = -1 : o >= 0 && l >= 0 ? c = 0 : c = Math.min(o, l), i <= 270 && a >= 270 || i > 270 && a >= 630 ? f = -1 : s >= 0 && u >= 0 ? f = 0 : f = Math.min(s, u), a >= 360 ? h = 1 : o <= 0 && l <= 0 ? h = 0 : h = Math.max(o, l), [
                    c,
                    f,
                    h,
                    d
                ];
            }
            function EKe(e, t) {
                var r = function(i) {
                    return cc.angleDist(e, i);
                }, n = cc.findIndexOfMin(t, r);
                return t[n];
            }
            function nC(e, t, r) {
                return t ? (e.attr("display", null), e.attr(r)) : e && e.attr("display", "none"), e;
            }
        });
        var z$ = ye((tbr, DKe)=>{
            "use strict";
            var OKt = dh(), Yo = Cd(), BKt = Ju().attributes, f0 = Mr().extendFlat, CKe = Bu().overrideAll, LKe = CKe({
                color: Yo.color,
                showline: f0({}, Yo.showline, {
                    dflt: !0
                }),
                linecolor: Yo.linecolor,
                linewidth: Yo.linewidth,
                showgrid: f0({}, Yo.showgrid, {
                    dflt: !0
                }),
                gridcolor: Yo.gridcolor,
                gridwidth: Yo.gridwidth,
                griddash: Yo.griddash
            }, "plot", "from-root"), PKe = CKe({
                tickmode: Yo.minor.tickmode,
                nticks: Yo.nticks,
                tick0: Yo.tick0,
                dtick: Yo.dtick,
                tickvals: Yo.tickvals,
                ticktext: Yo.ticktext,
                ticks: Yo.ticks,
                ticklen: Yo.ticklen,
                tickwidth: Yo.tickwidth,
                tickcolor: Yo.tickcolor,
                ticklabelstep: Yo.ticklabelstep,
                showticklabels: Yo.showticklabels,
                labelalias: Yo.labelalias,
                showtickprefix: Yo.showtickprefix,
                tickprefix: Yo.tickprefix,
                showticksuffix: Yo.showticksuffix,
                ticksuffix: Yo.ticksuffix,
                showexponent: Yo.showexponent,
                exponentformat: Yo.exponentformat,
                minexponent: Yo.minexponent,
                separatethousands: Yo.separatethousands,
                tickfont: Yo.tickfont,
                tickangle: Yo.tickangle,
                tickformat: Yo.tickformat,
                tickformatstops: Yo.tickformatstops,
                layer: Yo.layer
            }, "plot", "from-root"), IKe = {
                visible: f0({}, Yo.visible, {
                    dflt: !0
                }),
                type: f0({}, Yo.type, {
                    values: [
                        "-",
                        "linear",
                        "log",
                        "date",
                        "category"
                    ]
                }),
                autotypenumbers: Yo.autotypenumbers,
                autorangeoptions: {
                    minallowed: Yo.autorangeoptions.minallowed,
                    maxallowed: Yo.autorangeoptions.maxallowed,
                    clipmin: Yo.autorangeoptions.clipmin,
                    clipmax: Yo.autorangeoptions.clipmax,
                    include: Yo.autorangeoptions.include,
                    editType: "plot"
                },
                autorange: f0({}, Yo.autorange, {
                    editType: "plot"
                }),
                rangemode: {
                    valType: "enumerated",
                    values: [
                        "tozero",
                        "nonnegative",
                        "normal"
                    ],
                    dflt: "tozero",
                    editType: "calc"
                },
                minallowed: f0({}, Yo.minallowed, {
                    editType: "plot"
                }),
                maxallowed: f0({}, Yo.maxallowed, {
                    editType: "plot"
                }),
                range: f0({}, Yo.range, {
                    items: [
                        {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "^autorange": !1
                            }
                        },
                        {
                            valType: "any",
                            editType: "plot",
                            impliedEdits: {
                                "^autorange": !1
                            }
                        }
                    ],
                    editType: "plot"
                }),
                categoryorder: Yo.categoryorder,
                categoryarray: Yo.categoryarray,
                angle: {
                    valType: "angle",
                    editType: "plot"
                },
                autotickangles: Yo.autotickangles,
                side: {
                    valType: "enumerated",
                    values: [
                        "clockwise",
                        "counterclockwise"
                    ],
                    dflt: "clockwise",
                    editType: "plot"
                },
                title: {
                    text: f0({}, Yo.title.text, {
                        editType: "plot",
                        dflt: ""
                    }),
                    font: f0({}, Yo.title.font, {
                        editType: "plot"
                    }),
                    editType: "plot"
                },
                hoverformat: Yo.hoverformat,
                uirevision: {
                    valType: "any",
                    editType: "none"
                },
                editType: "calc"
            };
            f0(IKe, LKe, PKe);
            var RKe = {
                visible: f0({}, Yo.visible, {
                    dflt: !0
                }),
                type: {
                    valType: "enumerated",
                    values: [
                        "-",
                        "linear",
                        "category"
                    ],
                    dflt: "-",
                    editType: "calc",
                    _noTemplating: !0
                },
                autotypenumbers: Yo.autotypenumbers,
                categoryorder: Yo.categoryorder,
                categoryarray: Yo.categoryarray,
                thetaunit: {
                    valType: "enumerated",
                    values: [
                        "radians",
                        "degrees"
                    ],
                    dflt: "degrees",
                    editType: "calc"
                },
                period: {
                    valType: "number",
                    editType: "calc",
                    min: 0
                },
                direction: {
                    valType: "enumerated",
                    values: [
                        "counterclockwise",
                        "clockwise"
                    ],
                    dflt: "counterclockwise",
                    editType: "calc"
                },
                rotation: {
                    valType: "angle",
                    editType: "calc"
                },
                hoverformat: Yo.hoverformat,
                uirevision: {
                    valType: "any",
                    editType: "none"
                },
                editType: "calc"
            };
            f0(RKe, LKe, PKe);
            DKe.exports = {
                domain: BKt({
                    name: "polar",
                    editType: "plot"
                }),
                sector: {
                    valType: "info_array",
                    items: [
                        {
                            valType: "number",
                            editType: "plot"
                        },
                        {
                            valType: "number",
                            editType: "plot"
                        }
                    ],
                    dflt: [
                        0,
                        360
                    ],
                    editType: "plot"
                },
                hole: {
                    valType: "number",
                    min: 0,
                    max: 1,
                    dflt: 0,
                    editType: "plot"
                },
                bgcolor: {
                    valType: "color",
                    editType: "plot",
                    dflt: OKt.background
                },
                radialaxis: IKe,
                angularaxis: RKe,
                gridshape: {
                    valType: "enumerated",
                    values: [
                        "circular",
                        "linear"
                    ],
                    dflt: "circular",
                    editType: "plot"
                },
                uirevision: {
                    valType: "any",
                    editType: "none"
                },
                editType: "calc"
            };
        });
        var OKe = ye((rbr, qKe)=>{
            "use strict";
            var c9 = Mr(), NKt = va(), UKt = Vs(), VKt = C_(), HKt = kd().getSubplotData, GKt = xb(), jKt = T3(), WKt = t_(), ZKt = r_(), XKt = eI(), YKt = YM(), KKt = hB(), JKt = L3(), FKe = z$(), $Kt = k$(), f9 = i9(), zKe = f9.axisNames;
            function QKt(e, t, r, n) {
                var i = r("bgcolor");
                n.bgColor = NKt.combine(i, n.paper_bgcolor);
                var a = r("sector");
                r("hole");
                var o = HKt(n.fullData, f9.name, n.id), s = n.layoutOut, l;
                function u(G, N) {
                    return r(l + "." + G, N);
                }
                for(var c = 0; c < zKe.length; c++){
                    l = zKe[c], c9.isPlainObject(e[l]) || (e[l] = {});
                    var f = e[l], h = UKt.newContainer(t, l);
                    h._id = h._name = l, h._attr = n.id + "." + l, h._traceIndices = o.map(function(G) {
                        return G.index;
                    });
                    var d = f9.axisName2dataArray[l], v = eJt(f, h, u, o, d, n);
                    XKt(f, h, u, {
                        axData: o,
                        dataAttr: d
                    });
                    var x = u("visible");
                    switch($Kt(h, t, s), u("uirevision", t.uirevision), h._m = 1, l){
                        case "radialaxis":
                            u("minallowed"), u("maxallowed");
                            var b = u("range"), p = h.getAutorangeDflt(b), E = u("autorange", p), k;
                            b && (b[0] === null && b[1] === null || (b[0] === null || b[1] === null) && (E === "reversed" || E === !0) || b[0] !== null && (E === "min" || E === "max reversed") || b[1] !== null && (E === "max" || E === "min reversed")) && (b = void 0, delete h.range, h.autorange = !0, k = !0), k || (p = h.getAutorangeDflt(b), E = u("autorange", p)), f.autorange = E, E && (KKt(u, E, b), (v === "linear" || v === "-") && u("rangemode"), h.isReversed() && (h._m = -1)), h.cleanRange("range", {
                                dfltRange: [
                                    0,
                                    1
                                ]
                            });
                            break;
                        case "angularaxis":
                            if (v === "date") {
                                c9.log("Polar plots do not support date angular axes yet.");
                                for(var A = 0; A < o.length; A++)o[A].visible = !1;
                                v = f.type = h.type = "linear";
                            }
                            u(v === "linear" ? "thetaunit" : "period");
                            var L = u("direction");
                            u("rotation", {
                                counterclockwise: 0,
                                clockwise: 90
                            }[L]);
                            break;
                    }
                    if (ZKt(f, h, u, h.type, {
                        tickSuffixDflt: h.thetaunit === "degrees" ? "\xB0" : void 0
                    }), x) {
                        var _, C, M, g, P, T, F, q, V, H, X = n.font || {};
                        _ = u("color"), C = _ === f.color ? _ : X.color, M = X.size, g = X.family, P = X.weight, T = X.style, F = X.variant, q = X.textcase, V = X.lineposition, H = X.shadow, GKt(f, h, u, h.type), WKt(f, h, u, h.type, {
                            font: {
                                weight: P,
                                style: T,
                                variant: F,
                                textcase: q,
                                lineposition: V,
                                shadow: H,
                                color: C,
                                size: M,
                                family: g
                            },
                            noAutotickangles: l === "angularaxis",
                            noTicklabelshift: !0,
                            noTicklabelstandoff: !0
                        }), jKt(f, h, u, {
                            outerTicks: !0
                        }), YKt(f, h, u, {
                            dfltColor: _,
                            bgColor: n.bgColor,
                            blend: 60,
                            showLine: !0,
                            showGrid: !0,
                            noZeroLine: !0,
                            attributes: FKe[l]
                        }), u("layer"), l === "radialaxis" && (u("side"), u("angle", a[0]), u("title.text"), c9.coerceFont(u, "title.font", {
                            weight: P,
                            style: T,
                            variant: F,
                            textcase: q,
                            lineposition: V,
                            shadow: H,
                            color: C,
                            size: c9.bigFont(M),
                            family: g
                        }));
                    }
                    v !== "category" && u("hoverformat"), h._input = f;
                }
                t.angularaxis.type === "category" && r("gridshape");
            }
            function eJt(e, t, r, n, i, a) {
                var o = r("autotypenumbers", a.autotypenumbersDflt), s = r("type");
                if (s === "-") {
                    for(var l, u = 0; u < n.length; u++)if (n[u].visible) {
                        l = n[u];
                        break;
                    }
                    l && l[i] && (t.type = JKt(l[i], "gregorian", {
                        noMultiCategory: !0,
                        autotypenumbers: o
                    })), t.type === "-" ? t.type = "linear" : e.type = t.type;
                }
                return t.type;
            }
            qKe.exports = function(t, r, n) {
                VKt(t, r, n, {
                    type: f9.name,
                    attributes: FKe,
                    handleDefaults: QKt,
                    font: r.font,
                    autotypenumbersDflt: r.autotypenumbers,
                    paper_bgcolor: r.paper_bgcolor,
                    fullData: n,
                    layoutOut: r
                });
            };
        });
        var h9 = ye((ibr, HKe)=>{
            "use strict";
            var tJt = kd().getSubplotCalcData, rJt = Mr().counterRegex, iJt = D$(), NKe = i9(), UKe = NKe.attr, mw = NKe.name, BKe = rJt(mw), VKe = {};
            VKe[UKe] = {
                valType: "subplotid",
                dflt: mw,
                editType: "calc"
            };
            function nJt(e) {
                for(var t = e._fullLayout, r = e.calcdata, n = t._subplots[mw], i = 0; i < n.length; i++){
                    var a = n[i], o = tJt(r, mw, a), s = t[a]._subplot;
                    s || (s = iJt(e, a), t[a]._subplot = s), s.plot(o, t, e._promises);
                }
            }
            function aJt(e, t, r, n) {
                for(var i = n._subplots[mw] || [], a = n._has && n._has("gl"), o = t._has && t._has("gl"), s = a && !o, l = 0; l < i.length; l++){
                    var u = i[l], c = n[u]._subplot;
                    if (!t[u] && c) {
                        c.framework.remove(), c.layers["radial-axis-title"].remove();
                        for(var f in c.clipPaths)c.clipPaths[f].remove();
                    }
                    s && c._scene && (c._scene.destroy(), c._scene = null);
                }
            }
            HKe.exports = {
                attr: UKe,
                name: mw,
                idRoot: mw,
                idRegex: BKe,
                attrRegex: BKe,
                attributes: VKe,
                layoutAttributes: z$(),
                supplyLayoutDefaults: OKe(),
                plot: nJt,
                clean: aJt,
                toSVG: Jf().toSVG
            };
        });
        var aC = ye((nbr, GKe)=>{
            "use strict";
            var oJt = Wo().hovertemplateAttrs, sJt = Wo().texttemplateAttrs, d9 = no().extendFlat, lJt = Eg(), h0 = Uc(), uJt = vl(), GA = h0.line;
            GKe.exports = {
                mode: h0.mode,
                r: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                theta: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                r0: {
                    valType: "any",
                    dflt: 0,
                    editType: "calc+clearAxisTypes"
                },
                dr: {
                    valType: "number",
                    dflt: 1,
                    editType: "calc"
                },
                theta0: {
                    valType: "any",
                    dflt: 0,
                    editType: "calc+clearAxisTypes"
                },
                dtheta: {
                    valType: "number",
                    editType: "calc"
                },
                thetaunit: {
                    valType: "enumerated",
                    values: [
                        "radians",
                        "degrees",
                        "gradians"
                    ],
                    dflt: "degrees",
                    editType: "calc+clearAxisTypes"
                },
                text: h0.text,
                texttemplate: sJt({
                    editType: "plot"
                }, {
                    keys: [
                        "r",
                        "theta",
                        "text"
                    ]
                }),
                hovertext: h0.hovertext,
                line: {
                    color: GA.color,
                    width: GA.width,
                    dash: GA.dash,
                    backoff: GA.backoff,
                    shape: d9({}, GA.shape, {
                        values: [
                            "linear",
                            "spline"
                        ]
                    }),
                    smoothing: GA.smoothing,
                    editType: "calc"
                },
                connectgaps: h0.connectgaps,
                marker: h0.marker,
                cliponaxis: d9({}, h0.cliponaxis, {
                    dflt: !1
                }),
                textposition: h0.textposition,
                textfont: h0.textfont,
                fill: d9({}, h0.fill, {
                    values: [
                        "none",
                        "toself",
                        "tonext"
                    ],
                    dflt: "none"
                }),
                fillcolor: lJt(),
                hoverinfo: d9({}, uJt.hoverinfo, {
                    flags: [
                        "r",
                        "theta",
                        "text",
                        "name"
                    ]
                }),
                hoveron: h0.hoveron,
                hovertemplate: oJt(),
                selected: h0.selected,
                unselected: h0.unselected
            };
        });
        var p9 = ye((abr, ZKe)=>{
            "use strict";
            var v9 = Mr(), jA = lu(), cJt = $p(), fJt = R0(), jKe = J3(), hJt = D0(), dJt = Ig(), vJt = Sm().PTS_LINESONLY, pJt = aC();
            function gJt(e, t, r, n) {
                function i(s, l) {
                    return v9.coerce(e, t, pJt, s, l);
                }
                var a = WKe(e, t, n, i);
                if (!a) {
                    t.visible = !1;
                    return;
                }
                i("thetaunit"), i("mode", a < vJt ? "lines+markers" : "lines"), i("text"), i("hovertext"), t.hoveron !== "fills" && i("hovertemplate"), jA.hasMarkers(t) && cJt(e, t, r, n, i, {
                    gradient: !0
                }), jA.hasLines(t) && (fJt(e, t, r, n, i, {
                    backoff: !0
                }), jKe(e, t, i), i("connectgaps")), jA.hasText(t) && (i("texttemplate"), hJt(e, t, n, i));
                var o = [];
                (jA.hasMarkers(t) || jA.hasText(t)) && (i("cliponaxis"), i("marker.maxdisplayed"), o.push("points")), i("fill"), t.fill !== "none" && (dJt(e, t, r, i), jA.hasLines(t) || jKe(e, t, i)), (t.fill === "tonext" || t.fill === "toself") && o.push("fills"), i("hoveron", o.join("+") || "points"), v9.coerceSelectionMarkerOpacity(t, i);
            }
            function WKe(e, t, r, n) {
                var i = n("r"), a = n("theta");
                v9.isTypedArray(i) && (t.r = i = Array.from(i)), v9.isTypedArray(a) && (t.theta = a = Array.from(a));
                var o;
                if (i) a ? o = Math.min(i.length, a.length) : (o = i.length, n("theta0"), n("dtheta"));
                else {
                    if (!a) return 0;
                    o = t.theta.length, n("r0"), n("dr");
                }
                return t._length = o, o;
            }
            ZKe.exports = {
                handleRThetaDefaults: WKe,
                supplyDefaults: gJt
            };
        });
        var g9 = ye((obr, YKe)=>{
            "use strict";
            var mJt = Mr(), XKe = Qa();
            YKe.exports = function(t, r, n) {
                var i = {}, a = n[r.subplot]._subplot, o, s;
                a ? (o = a.radialAxis, s = a.angularAxis) : (a = n[r.subplot], o = a.radialaxis, s = a.angularaxis);
                var l = o.c2l(t.r);
                i.rLabel = XKe.tickText(o, l, !0).text;
                var u = s.thetaunit === "degrees" ? mJt.rad2deg(t.theta) : t.theta;
                return i.thetaLabel = XKe.tickText(s, u, !0).text, i;
            };
        });
        var $Ke = ye((sbr, JKe)=>{
            "use strict";
            var KKe = uo(), yJt = es().BADNUM, _Jt = Qa(), xJt = z0(), bJt = km(), wJt = F0(), TJt = q0().calcMarkerSize;
            JKe.exports = function(t, r) {
                for(var n = t._fullLayout, i = r.subplot, a = n[i].radialaxis, o = n[i].angularaxis, s = a.makeCalcdata(r, "r"), l = o.makeCalcdata(r, "theta"), u = r._length, c = new Array(u), f = 0; f < u; f++){
                    var h = s[f], d = l[f], v = c[f] = {};
                    KKe(h) && KKe(d) ? (v.r = h, v.theta = d) : v.r = yJt;
                }
                var x = TJt(r, u);
                return r._extremes.x = _Jt.findExtremes(a, s, {
                    ppad: x
                }), xJt(t, r), bJt(c, r), wJt(c, r), c;
            };
        });
        var tJe = ye((lbr, eJe)=>{
            "use strict";
            var AJt = iT(), QKe = es().BADNUM;
            eJe.exports = function(t, r, n) {
                for(var i = r.layers.frontplot.select("g.scatterlayer"), a = r.xaxis, o = r.yaxis, s = {
                    xaxis: a,
                    yaxis: o,
                    plot: r.framework,
                    layerClipId: r._hasClipOnAxisFalse ? r.clipIds.forTraces : null
                }, l = r.radialAxis, u = r.angularAxis, c = 0; c < n.length; c++)for(var f = n[c], h = 0; h < f.length; h++){
                    h === 0 && (f[0].trace._xA = a, f[0].trace._yA = o);
                    var d = f[h], v = d.r;
                    if (v === QKe) d.x = d.y = QKe;
                    else {
                        var x = l.c2g(v), b = u.c2g(d.theta);
                        d.x = x * Math.cos(b), d.y = x * Math.sin(b);
                    }
                }
                AJt(t, s, n, i);
            };
        });
        var m9 = ye((ubr, iJe)=>{
            "use strict";
            var SJt = sT();
            function MJt(e, t, r, n) {
                var i = SJt(e, t, r, n);
                if (!(!i || i[0].index === !1)) {
                    var a = i[0];
                    if (a.index === void 0) return i;
                    var o = e.subplot, s = a.cd[a.index], l = a.trace;
                    if (o.isPtInside(s)) return a.xLabelVal = void 0, a.yLabelVal = void 0, rJe(s, l, o, a), a.hovertemplate = l.hovertemplate, i;
                }
            }
            function rJe(e, t, r, n) {
                var i = r.radialAxis, a = r.angularAxis;
                i._hovertitle = "r", a._hovertitle = "\u03B8";
                var o = {};
                o[t.subplot] = {
                    _subplot: r
                };
                var s = t._module.formatLabels(e, t, o);
                n.rLabel = s.rLabel, n.thetaLabel = s.thetaLabel;
                var l = e.hi || t.hoverinfo, u = [];
                function c(h, d) {
                    u.push(h._hovertitle + ": " + d);
                }
                if (!t.hovertemplate) {
                    var f = l.split("+");
                    f.indexOf("all") !== -1 && (f = [
                        "r",
                        "theta",
                        "text"
                    ]), f.indexOf("r") !== -1 && c(i, n.rLabel), f.indexOf("theta") !== -1 && c(a, n.thetaLabel), f.indexOf("text") !== -1 && n.text && (u.push(n.text), delete n.text), n.extraText = u.join("<br>");
                }
            }
            iJe.exports = {
                hoverPoints: MJt,
                makeHoverPointText: rJe
            };
        });
        var aJe = ye((cbr, nJe)=>{
            "use strict";
            nJe.exports = {
                moduleType: "trace",
                name: "scatterpolar",
                basePlotModule: h9(),
                categories: [
                    "polar",
                    "symbols",
                    "showLegend",
                    "scatter-like"
                ],
                attributes: aC(),
                supplyDefaults: p9().supplyDefaults,
                colorbar: Kd(),
                formatLabels: g9(),
                calc: $Ke(),
                plot: tJe(),
                style: op().style,
                styleOnSelect: op().styleOnSelect,
                hoverPoints: m9().hoverPoints,
                selectPoints: lT(),
                meta: {}
            };
        });
        var sJe = ye((fbr, oJe)=>{
            "use strict";
            oJe.exports = aJe();
        });
        var F$ = ye((hbr, lJe)=>{
            "use strict";
            var Vp = aC(), x1 = tk(), EJt = Wo().texttemplateAttrs;
            lJe.exports = {
                mode: Vp.mode,
                r: Vp.r,
                theta: Vp.theta,
                r0: Vp.r0,
                dr: Vp.dr,
                theta0: Vp.theta0,
                dtheta: Vp.dtheta,
                thetaunit: Vp.thetaunit,
                text: Vp.text,
                texttemplate: EJt({
                    editType: "plot"
                }, {
                    keys: [
                        "r",
                        "theta",
                        "text"
                    ]
                }),
                hovertext: Vp.hovertext,
                hovertemplate: Vp.hovertemplate,
                line: {
                    color: x1.line.color,
                    width: x1.line.width,
                    dash: x1.line.dash,
                    editType: "calc"
                },
                connectgaps: x1.connectgaps,
                marker: x1.marker,
                fill: x1.fill,
                fillcolor: x1.fillcolor,
                textposition: x1.textposition,
                textfont: x1.textfont,
                hoverinfo: Vp.hoverinfo,
                selected: Vp.selected,
                unselected: Vp.unselected
            };
        });
        var fJe = ye((dbr, cJe)=>{
            "use strict";
            var uJe = Mr(), q$ = lu(), kJt = p9().handleRThetaDefaults, CJt = $p(), LJt = R0(), PJt = D0(), IJt = Ig(), RJt = Sm().PTS_LINESONLY, DJt = F$();
            cJe.exports = function(t, r, n, i) {
                function a(s, l) {
                    return uJe.coerce(t, r, DJt, s, l);
                }
                var o = kJt(t, r, i, a);
                if (!o) {
                    r.visible = !1;
                    return;
                }
                a("thetaunit"), a("mode", o < RJt ? "lines+markers" : "lines"), a("text"), a("hovertext"), r.hoveron !== "fills" && a("hovertemplate"), q$.hasMarkers(r) && CJt(t, r, n, i, a, {
                    noAngleRef: !0,
                    noStandOff: !0
                }), q$.hasLines(r) && (LJt(t, r, n, i, a), a("connectgaps")), q$.hasText(r) && (a("texttemplate"), PJt(t, r, i, a, {
                    noFontShadow: !0,
                    noFontLineposition: !0,
                    noFontTextcase: !0
                })), a("fill"), r.fill !== "none" && IJt(t, r, n, a), uJe.coerceSelectionMarkerOpacity(r, a);
            };
        });
        var dJe = ye((vbr, hJe)=>{
            "use strict";
            var zJt = g9();
            hJe.exports = function(t, r, n) {
                var i = t.i;
                return "r" in t || (t.r = r._r[i]), "theta" in t || (t.theta = r._theta[i]), zJt(t, r, n);
            };
        });
        var pJe = ye((pbr, vJe)=>{
            "use strict";
            var FJt = z0(), qJt = q0().calcMarkerSize, OJt = Y2(), BJt = Qa(), NJt = sx().TOO_MANY_POINTS;
            vJe.exports = function(t, r) {
                var n = t._fullLayout, i = r.subplot, a = n[i].radialaxis, o = n[i].angularaxis, s = r._r = a.makeCalcdata(r, "r"), l = r._theta = o.makeCalcdata(r, "theta"), u = r._length, c = {};
                u < s.length && (s = s.slice(0, u)), u < l.length && (l = l.slice(0, u)), c.r = s, c.theta = l, FJt(t, r);
                var f = c.opts = OJt.style(t, r), h;
                return u < NJt ? h = qJt(r, u) : f.marker && (h = 2 * (f.marker.sizeAvg || Math.max(f.marker.size, 3))), r._extremes.x = BJt.findExtremes(a, s, {
                    ppad: h
                }), [
                    {
                        x: !1,
                        y: !1,
                        t: c,
                        trace: r
                    }
                ];
            };
        });
        var mJe = ye((gbr, gJe)=>{
            "use strict";
            var UJt = zz(), VJt = m9().makeHoverPointText;
            function HJt(e, t, r, n) {
                var i = e.cd, a = i[0].t, o = a.r, s = a.theta, l = UJt.hoverPoints(e, t, r, n);
                if (!(!l || l[0].index === !1)) {
                    var u = l[0];
                    if (u.index === void 0) return l;
                    var c = e.subplot, f = u.cd[u.index], h = u.trace;
                    if (f.r = o[u.index], f.theta = s[u.index], !!c.isPtInside(f)) return u.xLabelVal = void 0, u.yLabelVal = void 0, VJt(f, h, c, u), l;
                }
            }
            gJe.exports = {
                hoverPoints: HJt
            };
        });
        var _Je = ye((mbr, yJe)=>{
            "use strict";
            yJe.exports = {
                moduleType: "trace",
                name: "scatterpolargl",
                basePlotModule: h9(),
                categories: [
                    "gl",
                    "regl",
                    "polar",
                    "symbols",
                    "showLegend",
                    "scatter-like"
                ],
                attributes: F$(),
                supplyDefaults: fJe(),
                colorbar: Kd(),
                formatLabels: dJe(),
                calc: pJe(),
                hoverPoints: mJe().hoverPoints,
                selectPoints: KX(),
                meta: {}
            };
        });
        var xJe = ye((ybr, O$)=>{
            "use strict";
            var GJt = Oz(), jJt = uo(), WJt = QY(), ZJt = ZX(), y9 = Y2(), _9 = Mr(), XJt = sx().TOO_MANY_POINTS, YJt = {};
            O$.exports = function(t, r, n) {
                if (n.length) {
                    var i = r.radialAxis, a = r.angularAxis, o = ZJt(t, r);
                    return n.forEach(function(s) {
                        if (!(!s || !s[0] || !s[0].trace)) {
                            var l = s[0], u = l.trace, c = l.t, f = u._length, h = c.r, d = c.theta, v = c.opts, x, b = h.slice(), p = d.slice();
                            for(x = 0; x < h.length; x++)r.isPtInside({
                                r: h[x],
                                theta: d[x]
                            }) || (b[x] = NaN, p[x] = NaN);
                            var E = new Array(f * 2), k = Array(f), A = Array(f);
                            for(x = 0; x < f; x++){
                                var L = b[x], _, C;
                                if (jJt(L)) {
                                    var M = i.c2g(L), g = a.c2g(p[x], u.thetaunit);
                                    _ = M * Math.cos(g), C = M * Math.sin(g);
                                } else _ = C = NaN;
                                k[x] = E[x * 2] = _, A[x] = E[x * 2 + 1] = C;
                            }
                            c.tree = GJt(E), v.marker && f >= XJt && (v.marker.cluster = c.tree), v.marker && (v.markerSel.positions = v.markerUnsel.positions = v.marker.positions = E), v.line && E.length > 1 && _9.extendFlat(v.line, y9.linePositions(t, u, E)), v.text && (_9.extendFlat(v.text, {
                                positions: E
                            }, y9.textPosition(t, u, v.text, v.marker)), _9.extendFlat(v.textSel, {
                                positions: E
                            }, y9.textPosition(t, u, v.text, v.markerSel)), _9.extendFlat(v.textUnsel, {
                                positions: E
                            }, y9.textPosition(t, u, v.text, v.markerUnsel))), v.fill && !o.fill2d && (o.fill2d = !0), v.marker && !o.scatter2d && (o.scatter2d = !0), v.line && !o.line2d && (o.line2d = !0), v.text && !o.glText && (o.glText = !0), o.lineOptions.push(v.line), o.fillOptions.push(v.fill), o.markerOptions.push(v.marker), o.markerSelectedOptions.push(v.markerSel), o.markerUnselectedOptions.push(v.markerUnsel), o.textOptions.push(v.text), o.textSelectedOptions.push(v.textSel), o.textUnselectedOptions.push(v.textUnsel), o.selectBatch.push([]), o.unselectBatch.push([]), c.x = k, c.y = A, c.rawx = k, c.rawy = A, c.r = h, c.theta = d, c.positions = E, c._scene = o, c.index = o.count, o.count++;
                        }
                    }), WJt(t, r, n);
                }
            };
            O$.exports.reglPrecompiled = YJt;
        });
        var TJe = ye((_br, wJe)=>{
            "use strict";
            var bJe = _Je();
            bJe.plot = xJe();
            wJe.exports = bJe;
        });
        var SJe = ye((xbr, AJe)=>{
            "use strict";
            AJe.exports = TJe();
        });
        var B$ = ye((bbr, MJe)=>{
            "use strict";
            var KJt = Wo().hovertemplateAttrs, WA = no().extendFlat, Ix = aC(), Rx = Lm();
            MJe.exports = {
                r: Ix.r,
                theta: Ix.theta,
                r0: Ix.r0,
                dr: Ix.dr,
                theta0: Ix.theta0,
                dtheta: Ix.dtheta,
                thetaunit: Ix.thetaunit,
                base: WA({}, Rx.base, {}),
                offset: WA({}, Rx.offset, {}),
                width: WA({}, Rx.width, {}),
                text: WA({}, Rx.text, {}),
                hovertext: WA({}, Rx.hovertext, {}),
                marker: JJt(),
                hoverinfo: Ix.hoverinfo,
                hovertemplate: KJt(),
                selected: Rx.selected,
                unselected: Rx.unselected
            };
            function JJt() {
                var e = WA({}, Rx.marker);
                return delete e.cornerradius, e;
            }
        });
        var N$ = ye((wbr, EJe)=>{
            "use strict";
            EJe.exports = {
                barmode: {
                    valType: "enumerated",
                    values: [
                        "stack",
                        "overlay"
                    ],
                    dflt: "stack",
                    editType: "calc"
                },
                bargap: {
                    valType: "number",
                    dflt: .1,
                    min: 0,
                    max: 1,
                    editType: "calc"
                }
            };
        });
        var LJe = ye((Tbr, CJe)=>{
            "use strict";
            var kJe = Mr(), $Jt = p9().handleRThetaDefaults, QJt = FI(), e$t = B$();
            CJe.exports = function(t, r, n, i) {
                function a(s, l) {
                    return kJe.coerce(t, r, e$t, s, l);
                }
                var o = $Jt(t, r, i, a);
                if (!o) {
                    r.visible = !1;
                    return;
                }
                a("thetaunit"), a("base"), a("offset"), a("width"), a("text"), a("hovertext"), a("hovertemplate"), QJt(t, r, a, n, i), kJe.coerceSelectionMarkerOpacity(r, a);
            };
        });
        var IJe = ye((Abr, PJe)=>{
            "use strict";
            var t$t = Mr(), r$t = N$();
            PJe.exports = function(e, t, r) {
                var n = {}, i;
                function a(l, u) {
                    return t$t.coerce(e[i] || {}, t[i], r$t, l, u);
                }
                for(var o = 0; o < r.length; o++){
                    var s = r[o];
                    s.type === "barpolar" && s.visible === !0 && (i = s.subplot, n[i] || (a("barmode"), a("bargap"), n[i] = 1));
                }
            };
        });
        var U$ = ye((Sbr, zJe)=>{
            "use strict";
            var RJe = Dv().hasColorscale, DJe = zv(), i$t = Mr().isArrayOrTypedArray, n$t = c4(), a$t = Gb().setGroupPositions, o$t = F0(), s$t = ba().traceIs, l$t = Mr().extendFlat;
            function u$t(e, t) {
                for(var r = e._fullLayout, n = t.subplot, i = r[n].radialaxis, a = r[n].angularaxis, o = i.makeCalcdata(t, "r"), s = a.makeCalcdata(t, "theta"), l = t._length, u = new Array(l), c = o, f = s, h = 0; h < l; h++)u[h] = {
                    p: f[h],
                    s: c[h]
                };
                function d(v) {
                    var x = t[v];
                    x !== void 0 && (t["_" + v] = i$t(x) ? a.makeCalcdata(t, v) : a.d2c(x, t.thetaunit));
                }
                return a.type === "linear" && (d("width"), d("offset")), RJe(t, "marker") && DJe(e, t, {
                    vals: t.marker.color,
                    containerStr: "marker",
                    cLetter: "c"
                }), RJe(t, "marker.line") && DJe(e, t, {
                    vals: t.marker.line.color,
                    containerStr: "marker.line",
                    cLetter: "c"
                }), n$t(u, t), o$t(u, t), u;
            }
            function c$t(e, t, r) {
                for(var n = e.calcdata, i = [], a = 0; a < n.length; a++){
                    var o = n[a], s = o[0].trace;
                    s.visible === !0 && s$t(s, "bar") && s.subplot === r && i.push(o);
                }
                var l = l$t({}, t.radialaxis, {
                    _id: "x"
                }), u = t.angularaxis;
                a$t(e, u, l, i, {
                    mode: t.barmode,
                    norm: t.barnorm,
                    gap: t.bargap,
                    groupgap: t.bargroupgap
                });
            }
            zJe.exports = {
                calc: u$t,
                crossTraceCalc: c$t
            };
        });
        var OJe = ye((Mbr, qJe)=>{
            "use strict";
            var FJe = xa(), x9 = uo(), ZA = Mr(), f$t = ao(), V$ = a9();
            qJe.exports = function(t, r, n) {
                var i = t._context.staticPlot, a = r.xaxis, o = r.yaxis, s = r.radialAxis, l = r.angularAxis, u = h$t(r), c = r.layers.frontplot.select("g.barlayer");
                ZA.makeTraceGroups(c, n, "trace bars").each(function() {
                    var f = FJe.select(this), h = ZA.ensureSingle(f, "g", "points"), d = h.selectAll("g.point").data(ZA.identity);
                    d.enter().append("g").style("vector-effect", i ? "none" : "non-scaling-stroke").style("stroke-miterlimit", 2).classed("point", !0), d.exit().remove(), d.each(function(v) {
                        var x = FJe.select(this), b = v.rp0 = s.c2p(v.s0), p = v.rp1 = s.c2p(v.s1), E = v.thetag0 = l.c2g(v.p0), k = v.thetag1 = l.c2g(v.p1), A;
                        if (!x9(b) || !x9(p) || !x9(E) || !x9(k) || b === p || E === k) A = "M0,0Z";
                        else {
                            var L = s.c2g(v.s1), _ = (E + k) / 2;
                            v.ct = [
                                a.c2p(L * Math.cos(_)),
                                o.c2p(L * Math.sin(_))
                            ], A = u(b, p, E, k);
                        }
                        ZA.ensureSingle(x, "path").attr("d", A);
                    }), f$t.setClipUrl(f, r._hasClipOnAxisFalse ? r.clipIds.forTraces : null, t);
                });
            };
            function h$t(e) {
                var t = e.cxx, r = e.cyy;
                return e.vangles ? function(n, i, a, o) {
                    var s, l;
                    ZA.angleDelta(a, o) > 0 ? (s = a, l = o) : (s = o, l = a);
                    var u = V$.findEnclosingVertexAngles(s, e.vangles)[0], c = V$.findEnclosingVertexAngles(l, e.vangles)[1], f = [
                        u,
                        (s + l) / 2,
                        c
                    ];
                    return V$.pathPolygonAnnulus(n, i, s, l, f, t, r);
                } : function(n, i, a, o) {
                    return ZA.pathAnnulus(n, i, a, o, t, r);
                };
            }
        });
        var NJe = ye((Ebr, BJe)=>{
            "use strict";
            var d$t = Nc(), H$ = Mr(), v$t = TT().getTraceColor, p$t = H$.fillText, g$t = m9().makeHoverPointText, m$t = a9().isPtInsidePolygon;
            BJe.exports = function(t, r, n) {
                var i = t.cd, a = i[0].trace, o = t.subplot, s = o.radialAxis, l = o.angularAxis, u = o.vangles, c = u ? m$t : H$.isPtInsideSector, f = t.maxHoverDistance, h = l._period || 2 * Math.PI, d = Math.abs(s.g2p(Math.sqrt(r * r + n * n))), v = Math.atan2(n, r);
                s.range[0] > s.range[1] && (v += Math.PI);
                var x = function(k) {
                    return c(d, v, [
                        k.rp0,
                        k.rp1
                    ], [
                        k.thetag0,
                        k.thetag1
                    ], u) ? f + Math.min(1, Math.abs(k.thetag1 - k.thetag0) / h) - 1 + (k.rp1 - d) / (k.rp1 - k.rp0) - 1 : 1 / 0;
                };
                if (d$t.getClosest(i, x, t), t.index !== !1) {
                    var b = t.index, p = i[b];
                    t.x0 = t.x1 = p.ct[0], t.y0 = t.y1 = p.ct[1];
                    var E = H$.extendFlat({}, p, {
                        r: p.s,
                        theta: p.p
                    });
                    return p$t(p, a, t), g$t(E, a, o, t), t.hovertemplate = a.hovertemplate, t.color = v$t(a, p), t.xLabelVal = t.yLabelVal = void 0, p.s < 0 && (t.idealAlign = "left"), [
                        t
                    ];
                }
            };
        });
        var VJe = ye((kbr, UJe)=>{
            "use strict";
            UJe.exports = {
                moduleType: "trace",
                name: "barpolar",
                basePlotModule: h9(),
                categories: [
                    "polar",
                    "bar",
                    "showLegend"
                ],
                attributes: B$(),
                layoutAttributes: N$(),
                supplyDefaults: LJe(),
                supplyLayoutDefaults: IJe(),
                calc: U$().calc,
                crossTraceCalc: U$().crossTraceCalc,
                plot: OJe(),
                colorbar: Kd(),
                formatLabels: g9(),
                style: N0().style,
                styleOnSelect: N0().styleOnSelect,
                hoverPoints: NJe(),
                selectPoints: AT(),
                meta: {}
            };
        });
        var GJe = ye((Cbr, HJe)=>{
            "use strict";
            HJe.exports = VJe();
        });
        var G$ = ye((Lbr, jJe)=>{
            "use strict";
            jJe.exports = {
                attr: "subplot",
                name: "smith",
                axisNames: [
                    "realaxis",
                    "imaginaryaxis"
                ],
                axisName2dataArray: {
                    imaginaryaxis: "imag",
                    realaxis: "real"
                }
            };
        });
        var j$ = ye((Pbr, YJe)=>{
            "use strict";
            var y$t = dh(), Mf = Cd(), _$t = Ju().attributes, Dx = Mr().extendFlat, WJe = Bu().overrideAll, ZJe = WJe({
                color: Mf.color,
                showline: Dx({}, Mf.showline, {
                    dflt: !0
                }),
                linecolor: Mf.linecolor,
                linewidth: Mf.linewidth,
                showgrid: Dx({}, Mf.showgrid, {
                    dflt: !0
                }),
                gridcolor: Mf.gridcolor,
                gridwidth: Mf.gridwidth,
                griddash: Mf.griddash
            }, "plot", "from-root"), XJe = WJe({
                ticklen: Mf.ticklen,
                tickwidth: Dx({}, Mf.tickwidth, {
                    dflt: 2
                }),
                tickcolor: Mf.tickcolor,
                showticklabels: Mf.showticklabels,
                labelalias: Mf.labelalias,
                showtickprefix: Mf.showtickprefix,
                tickprefix: Mf.tickprefix,
                showticksuffix: Mf.showticksuffix,
                ticksuffix: Mf.ticksuffix,
                tickfont: Mf.tickfont,
                tickformat: Mf.tickformat,
                hoverformat: Mf.hoverformat,
                layer: Mf.layer
            }, "plot", "from-root"), x$t = Dx({
                visible: Dx({}, Mf.visible, {
                    dflt: !0
                }),
                tickvals: {
                    dflt: [
                        .2,
                        .5,
                        1,
                        2,
                        5
                    ],
                    valType: "data_array",
                    editType: "plot"
                },
                tickangle: Dx({}, Mf.tickangle, {
                    dflt: 90
                }),
                ticks: {
                    valType: "enumerated",
                    values: [
                        "top",
                        "bottom",
                        ""
                    ],
                    editType: "ticks"
                },
                side: {
                    valType: "enumerated",
                    values: [
                        "top",
                        "bottom"
                    ],
                    dflt: "top",
                    editType: "plot"
                },
                editType: "calc"
            }, ZJe, XJe), b$t = Dx({
                visible: Dx({}, Mf.visible, {
                    dflt: !0
                }),
                tickvals: {
                    valType: "data_array",
                    editType: "plot"
                },
                ticks: Mf.ticks,
                editType: "calc"
            }, ZJe, XJe);
            YJe.exports = {
                domain: _$t({
                    name: "smith",
                    editType: "plot"
                }),
                bgcolor: {
                    valType: "color",
                    editType: "plot",
                    dflt: y$t.background
                },
                realaxis: x$t,
                imaginaryaxis: b$t,
                editType: "calc"
            };
        });
        var $Je = ye((Ibr, JJe)=>{
            "use strict";
            var XA = Mr(), w$t = va(), T$t = Vs(), A$t = C_(), S$t = kd().getSubplotData, M$t = r_(), E$t = t_(), k$t = YM(), C$t = ym(), YA = j$(), W$ = G$(), KJe = W$.axisNames, L$t = I$t(function(e) {
                return XA.isTypedArray(e) && (e = Array.from(e)), e.slice().reverse().map(function(t) {
                    return -t;
                }).concat([
                    0
                ]).concat(e);
            }, String);
            function P$t(e, t, r, n) {
                var i = r("bgcolor");
                n.bgColor = w$t.combine(i, n.paper_bgcolor);
                var a = S$t(n.fullData, W$.name, n.id), o = n.layoutOut, s;
                function l(L, _) {
                    return r(s + "." + L, _);
                }
                for(var u = 0; u < KJe.length; u++){
                    s = KJe[u], XA.isPlainObject(e[s]) || (e[s] = {});
                    var c = e[s], f = T$t.newContainer(t, s);
                    f._id = f._name = s, f._attr = n.id + "." + s, f._traceIndices = a.map(function(L) {
                        return L.index;
                    });
                    var h = l("visible");
                    if (f.type = "linear", C$t(f, o), M$t(c, f, l, f.type), h) {
                        var d = s === "realaxis";
                        if (d && l("side"), d) l("tickvals");
                        else {
                            var v = L$t(t.realaxis.tickvals || YA.realaxis.tickvals.dflt);
                            l("tickvals", v);
                        }
                        XA.isTypedArray(f.tickvals) && (f.tickvals = Array.from(f.tickvals));
                        var x, b, p, E, k = n.font || {};
                        h && (x = l("color"), b = x === c.color ? x : k.color, p = k.size, E = k.family), E$t(c, f, l, f.type, {
                            noAutotickangles: !0,
                            noTicklabelshift: !0,
                            noTicklabelstandoff: !0,
                            noTicklabelstep: !0,
                            noAng: !d,
                            noExp: !0,
                            font: {
                                color: b,
                                size: p,
                                family: E
                            }
                        }), XA.coerce2(e, t, YA, s + ".ticklen"), XA.coerce2(e, t, YA, s + ".tickwidth"), XA.coerce2(e, t, YA, s + ".tickcolor", t.color);
                        var A = l("ticks");
                        A || (delete t[s].ticklen, delete t[s].tickwidth, delete t[s].tickcolor), k$t(c, f, l, {
                            dfltColor: x,
                            bgColor: n.bgColor,
                            blend: 60,
                            showLine: !0,
                            showGrid: !0,
                            noZeroLine: !0,
                            attributes: YA[s]
                        }), l("layer");
                    }
                    l("hoverformat"), delete f.type, f._input = c;
                }
            }
            JJe.exports = function(t, r, n) {
                A$t(t, r, n, {
                    noUirevision: !0,
                    type: W$.name,
                    attributes: YA,
                    handleDefaults: P$t,
                    font: r.font,
                    paper_bgcolor: r.paper_bgcolor,
                    fullData: n,
                    layoutOut: r
                });
            };
            function I$t(e, t) {
                var r = {};
                return function(n) {
                    var i = t ? t(n) : n;
                    if (i in r) return r[i];
                    var a = e(n);
                    return r[i] = a, a;
                };
            }
        });
        var n$e = ye((Rbr, i$e)=>{
            "use strict";
            var R$t = kd().getSubplotCalcData, D$t = Mr().counterRegex, z$t = D$(), e$e = G$(), t$e = e$e.attr, yw = e$e.name, QJe = D$t(yw), r$e = {};
            r$e[t$e] = {
                valType: "subplotid",
                dflt: yw,
                editType: "calc"
            };
            function F$t(e) {
                for(var t = e._fullLayout, r = e.calcdata, n = t._subplots[yw], i = 0; i < n.length; i++){
                    var a = n[i], o = R$t(r, yw, a), s = t[a]._subplot;
                    s || (s = z$t(e, a, !0), t[a]._subplot = s), s.plot(o, t, e._promises);
                }
            }
            function q$t(e, t, r, n) {
                for(var i = n._subplots[yw] || [], a = 0; a < i.length; a++){
                    var o = i[a], s = n[o]._subplot;
                    if (!t[o] && s) {
                        s.framework.remove();
                        for(var l in s.clipPaths)s.clipPaths[l].remove();
                    }
                }
            }
            i$e.exports = {
                attr: t$e,
                name: yw,
                idRoot: yw,
                idRegex: QJe,
                attrRegex: QJe,
                attributes: r$e,
                layoutAttributes: j$(),
                supplyLayoutDefaults: $Je(),
                plot: F$t,
                clean: q$t,
                toSVG: Jf().toSVG
            };
        });
        var Z$ = ye((Dbr, a$e)=>{
            "use strict";
            var O$t = Wo().hovertemplateAttrs, B$t = Wo().texttemplateAttrs, b9 = no().extendFlat, N$t = Eg(), d0 = Uc(), U$t = vl(), KA = d0.line;
            a$e.exports = {
                mode: d0.mode,
                real: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                imag: {
                    valType: "data_array",
                    editType: "calc+clearAxisTypes"
                },
                text: d0.text,
                texttemplate: B$t({
                    editType: "plot"
                }, {
                    keys: [
                        "real",
                        "imag",
                        "text"
                    ]
                }),
                hovertext: d0.hovertext,
                line: {
                    color: KA.color,
                    width: KA.width,
                    dash: KA.dash,
                    backoff: KA.backoff,
                    shape: b9({}, KA.shape, {
                        values: [
                            "linear",
                            "spline"
                        ]
                    }),
                    smoothing: KA.smoothing,
                    editType: "calc"
                },
                connectgaps: d0.connectgaps,
                marker: d0.marker,
                cliponaxis: b9({}, d0.cliponaxis, {
                    dflt: !1
                }),
                textposition: d0.textposition,
                textfont: d0.textfont,
                fill: b9({}, d0.fill, {
                    values: [
                        "none",
                        "toself",
                        "tonext"
                    ],
                    dflt: "none"
                }),
                fillcolor: N$t(),
                hoverinfo: b9({}, U$t.hoverinfo, {
                    flags: [
                        "real",
                        "imag",
                        "text",
                        "name"
                    ]
                }),
                hoveron: d0.hoveron,
                hovertemplate: O$t(),
                selected: d0.selected,
                unselected: d0.unselected
            };
        });
        var l$e = ye((zbr, s$e)=>{
            "use strict";
            var w9 = Mr(), JA = lu(), V$t = $p(), H$t = R0(), o$e = J3(), G$t = D0(), j$t = Ig(), W$t = Sm().PTS_LINESONLY, Z$t = Z$();
            s$e.exports = function(t, r, n, i) {
                function a(l, u) {
                    return w9.coerce(t, r, Z$t, l, u);
                }
                var o = X$t(t, r, i, a);
                if (!o) {
                    r.visible = !1;
                    return;
                }
                a("mode", o < W$t ? "lines+markers" : "lines"), a("text"), a("hovertext"), r.hoveron !== "fills" && a("hovertemplate"), JA.hasMarkers(r) && V$t(t, r, n, i, a, {
                    gradient: !0
                }), JA.hasLines(r) && (H$t(t, r, n, i, a, {
                    backoff: !0
                }), o$e(t, r, a), a("connectgaps")), JA.hasText(r) && (a("texttemplate"), G$t(t, r, i, a));
                var s = [];
                (JA.hasMarkers(r) || JA.hasText(r)) && (a("cliponaxis"), a("marker.maxdisplayed"), s.push("points")), a("fill"), r.fill !== "none" && (j$t(t, r, n, a), JA.hasLines(r) || o$e(t, r, a)), (r.fill === "tonext" || r.fill === "toself") && s.push("fills"), a("hoveron", s.join("+") || "points"), w9.coerceSelectionMarkerOpacity(r, a);
            };
            function X$t(e, t, r, n) {
                var i = n("real"), a = n("imag"), o;
                return i && a && (o = Math.min(i.length, a.length)), w9.isTypedArray(i) && (t.real = i = Array.from(i)), w9.isTypedArray(a) && (t.imag = a = Array.from(a)), t._length = o, o;
            }
        });
        var f$e = ye((Fbr, c$e)=>{
            "use strict";
            var u$e = Qa();
            c$e.exports = function(t, r, n) {
                var i = {}, a = n[r.subplot]._subplot;
                return i.realLabel = u$e.tickText(a.radialAxis, t.real, !0).text, i.imagLabel = u$e.tickText(a.angularAxis, t.imag, !0).text, i;
            };
        });
        var v$e = ye((qbr, d$e)=>{
            "use strict";
            var h$e = uo(), Y$t = es().BADNUM, K$t = z0(), J$t = km(), $$t = F0(), Q$t = q0().calcMarkerSize;
            d$e.exports = function(t, r) {
                for(var n = t._fullLayout, i = r.subplot, a = n[i].realaxis, o = n[i].imaginaryaxis, s = a.makeCalcdata(r, "real"), l = o.makeCalcdata(r, "imag"), u = r._length, c = new Array(u), f = 0; f < u; f++){
                    var h = s[f], d = l[f], v = c[f] = {};
                    h$e(h) && h$e(d) ? (v.real = h, v.imag = d) : v.real = Y$t;
                }
                return Q$t(r, u), K$t(t, r), J$t(c, r), $$t(c, r), c;
            };
        });
        var m$e = ye((Obr, g$e)=>{
            "use strict";
            var eQt = iT(), p$e = es().BADNUM, tQt = P$(), rQt = tQt.smith;
            g$e.exports = function(t, r, n) {
                for(var i = r.layers.frontplot.select("g.scatterlayer"), a = r.xaxis, o = r.yaxis, s = {
                    xaxis: a,
                    yaxis: o,
                    plot: r.framework,
                    layerClipId: r._hasClipOnAxisFalse ? r.clipIds.forTraces : null
                }, l = 0; l < n.length; l++)for(var u = n[l], c = 0; c < u.length; c++){
                    c === 0 && (u[0].trace._xA = a, u[0].trace._yA = o);
                    var f = u[c], h = f.real;
                    if (h === p$e) f.x = f.y = p$e;
                    else {
                        var d = rQt([
                            h,
                            f.imag
                        ]);
                        f.x = d[0], f.y = d[1];
                    }
                }
                eQt(t, s, n, i);
            };
        });
        var x$e = ye((Bbr, _$e)=>{
            "use strict";
            var iQt = sT();
            function nQt(e, t, r, n) {
                var i = iQt(e, t, r, n);
                if (!(!i || i[0].index === !1)) {
                    var a = i[0];
                    if (a.index === void 0) return i;
                    var o = e.subplot, s = a.cd[a.index], l = a.trace;
                    if (o.isPtInside(s)) return a.xLabelVal = void 0, a.yLabelVal = void 0, y$e(s, l, o, a), a.hovertemplate = l.hovertemplate, i;
                }
            }
            function y$e(e, t, r, n) {
                var i = r.radialAxis, a = r.angularAxis;
                i._hovertitle = "real", a._hovertitle = "imag";
                var o = {};
                o[t.subplot] = {
                    _subplot: r
                };
                var s = t._module.formatLabels(e, t, o);
                n.realLabel = s.realLabel, n.imagLabel = s.imagLabel;
                var l = e.hi || t.hoverinfo, u = [];
                function c(h, d) {
                    u.push(h._hovertitle + ": " + d);
                }
                if (!t.hovertemplate) {
                    var f = l.split("+");
                    f.indexOf("all") !== -1 && (f = [
                        "real",
                        "imag",
                        "text"
                    ]), f.indexOf("real") !== -1 && c(i, n.realLabel), f.indexOf("imag") !== -1 && c(a, n.imagLabel), f.indexOf("text") !== -1 && n.text && (u.push(n.text), delete n.text), n.extraText = u.join("<br>");
                }
            }
            _$e.exports = {
                hoverPoints: nQt,
                makeHoverPointText: y$e
            };
        });
        var w$e = ye((Nbr, b$e)=>{
            "use strict";
            b$e.exports = {
                moduleType: "trace",
                name: "scattersmith",
                basePlotModule: n$e(),
                categories: [
                    "smith",
                    "symbols",
                    "showLegend",
                    "scatter-like"
                ],
                attributes: Z$(),
                supplyDefaults: l$e(),
                colorbar: Kd(),
                formatLabels: f$e(),
                calc: v$e(),
                plot: m$e(),
                style: op().style,
                styleOnSelect: op().styleOnSelect,
                hoverPoints: x$e().hoverPoints,
                selectPoints: lT(),
                meta: {}
            };
        });
        var A$e = ye((Ubr, T$e)=>{
            "use strict";
            T$e.exports = w$e();
        });
        var Sv = ye((Vbr, M$e)=>{
            var A9 = bh();
            function S$e() {
                this.regionalOptions = [], this.regionalOptions[""] = {
                    invalidCalendar: "Calendar {0} not found",
                    invalidDate: "Invalid {0} date",
                    invalidMonth: "Invalid {0} month",
                    invalidYear: "Invalid {0} year",
                    differentCalendars: "Cannot mix {0} and {1} dates"
                }, this.local = this.regionalOptions[""], this.calendars = {}, this._localCals = {};
            }
            A9(S$e.prototype, {
                instance: function(e, t) {
                    e = (e || "gregorian").toLowerCase(), t = t || "";
                    var r = this._localCals[e + "-" + t];
                    if (!r && this.calendars[e] && (r = new this.calendars[e](t), this._localCals[e + "-" + t] = r), !r) throw (this.local.invalidCalendar || this.regionalOptions[""].invalidCalendar).replace(/\{0\}/, e);
                    return r;
                },
                newDate: function(e, t, r, n, i) {
                    return n = (e != null && e.year ? e.calendar() : typeof n == "string" ? this.instance(n, i) : n) || this.instance(), n.newDate(e, t, r);
                },
                substituteDigits: function(e) {
                    return function(t) {
                        return (t + "").replace(/[0-9]/g, function(r) {
                            return e[r];
                        });
                    };
                },
                substituteChineseDigits: function(e, t) {
                    return function(r) {
                        for(var n = "", i = 0; r > 0;){
                            var a = r % 10;
                            n = (a === 0 ? "" : e[a] + t[i]) + n, i++, r = Math.floor(r / 10);
                        }
                        return n.indexOf(e[1] + t[1]) === 0 && (n = n.substr(1)), n || e[0];
                    };
                }
            });
            function X$(e, t, r, n) {
                if (this._calendar = e, this._year = t, this._month = r, this._day = n, this._calendar._validateLevel === 0 && !this._calendar.isValid(this._year, this._month, this._day)) throw (Es.local.invalidDate || Es.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
            }
            function T9(e, t) {
                return e = "" + e, "000000".substring(0, t - e.length) + e;
            }
            A9(X$.prototype, {
                newDate: function(e, t, r) {
                    return this._calendar.newDate(e == null ? this : e, t, r);
                },
                year: function(e) {
                    return arguments.length === 0 ? this._year : this.set(e, "y");
                },
                month: function(e) {
                    return arguments.length === 0 ? this._month : this.set(e, "m");
                },
                day: function(e) {
                    return arguments.length === 0 ? this._day : this.set(e, "d");
                },
                date: function(e, t, r) {
                    if (!this._calendar.isValid(e, t, r)) throw (Es.local.invalidDate || Es.regionalOptions[""].invalidDate).replace(/\{0\}/, this._calendar.local.name);
                    return this._year = e, this._month = t, this._day = r, this;
                },
                leapYear: function() {
                    return this._calendar.leapYear(this);
                },
                epoch: function() {
                    return this._calendar.epoch(this);
                },
                formatYear: function() {
                    return this._calendar.formatYear(this);
                },
                monthOfYear: function() {
                    return this._calendar.monthOfYear(this);
                },
                weekOfYear: function() {
                    return this._calendar.weekOfYear(this);
                },
                daysInYear: function() {
                    return this._calendar.daysInYear(this);
                },
                dayOfYear: function() {
                    return this._calendar.dayOfYear(this);
                },
                daysInMonth: function() {
                    return this._calendar.daysInMonth(this);
                },
                dayOfWeek: function() {
                    return this._calendar.dayOfWeek(this);
                },
                weekDay: function() {
                    return this._calendar.weekDay(this);
                },
                extraInfo: function() {
                    return this._calendar.extraInfo(this);
                },
                add: function(e, t) {
                    return this._calendar.add(this, e, t);
                },
                set: function(e, t) {
                    return this._calendar.set(this, e, t);
                },
                compareTo: function(e) {
                    if (this._calendar.name !== e._calendar.name) throw (Es.local.differentCalendars || Es.regionalOptions[""].differentCalendars).replace(/\{0\}/, this._calendar.local.name).replace(/\{1\}/, e._calendar.local.name);
                    var t = this._year !== e._year ? this._year - e._year : this._month !== e._month ? this.monthOfYear() - e.monthOfYear() : this._day - e._day;
                    return t === 0 ? 0 : t < 0 ? -1 : 1;
                },
                calendar: function() {
                    return this._calendar;
                },
                toJD: function() {
                    return this._calendar.toJD(this);
                },
                fromJD: function(e) {
                    return this._calendar.fromJD(e);
                },
                toJSDate: function() {
                    return this._calendar.toJSDate(this);
                },
                fromJSDate: function(e) {
                    return this._calendar.fromJSDate(e);
                },
                toString: function() {
                    return (this.year() < 0 ? "-" : "") + T9(Math.abs(this.year()), 4) + "-" + T9(this.month(), 2) + "-" + T9(this.day(), 2);
                }
            });
            function Y$() {
                this.shortYearCutoff = "+10";
            }
            A9(Y$.prototype, {
                _validateLevel: 0,
                newDate: function(e, t, r) {
                    return e == null ? this.today() : (e.year && (this._validate(e, t, r, Es.local.invalidDate || Es.regionalOptions[""].invalidDate), r = e.day(), t = e.month(), e = e.year()), new X$(this, e, t, r));
                },
                today: function() {
                    return this.fromJSDate(new Date);
                },
                epoch: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, Es.local.invalidYear || Es.regionalOptions[""].invalidYear);
                    return t.year() < 0 ? this.local.epochs[0] : this.local.epochs[1];
                },
                formatYear: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, Es.local.invalidYear || Es.regionalOptions[""].invalidYear);
                    return (t.year() < 0 ? "-" : "") + T9(Math.abs(t.year()), 4);
                },
                monthsInYear: function(e) {
                    return this._validate(e, this.minMonth, this.minDay, Es.local.invalidYear || Es.regionalOptions[""].invalidYear), 12;
                },
                monthOfYear: function(e, t) {
                    var r = this._validate(e, t, this.minDay, Es.local.invalidMonth || Es.regionalOptions[""].invalidMonth);
                    return (r.month() + this.monthsInYear(r) - this.firstMonth) % this.monthsInYear(r) + this.minMonth;
                },
                fromMonthOfYear: function(e, t) {
                    var r = (t + this.firstMonth - 2 * this.minMonth) % this.monthsInYear(e) + this.minMonth;
                    return this._validate(e, r, this.minDay, Es.local.invalidMonth || Es.regionalOptions[""].invalidMonth), r;
                },
                daysInYear: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, Es.local.invalidYear || Es.regionalOptions[""].invalidYear);
                    return this.leapYear(t) ? 366 : 365;
                },
                dayOfYear: function(e, t, r) {
                    var n = this._validate(e, t, r, Es.local.invalidDate || Es.regionalOptions[""].invalidDate);
                    return n.toJD() - this.newDate(n.year(), this.fromMonthOfYear(n.year(), this.minMonth), this.minDay).toJD() + 1;
                },
                daysInWeek: function() {
                    return 7;
                },
                dayOfWeek: function(e, t, r) {
                    var n = this._validate(e, t, r, Es.local.invalidDate || Es.regionalOptions[""].invalidDate);
                    return (Math.floor(this.toJD(n)) + 2) % this.daysInWeek();
                },
                extraInfo: function(e, t, r) {
                    return this._validate(e, t, r, Es.local.invalidDate || Es.regionalOptions[""].invalidDate), {};
                },
                add: function(e, t, r) {
                    return this._validate(e, this.minMonth, this.minDay, Es.local.invalidDate || Es.regionalOptions[""].invalidDate), this._correctAdd(e, this._add(e, t, r), t, r);
                },
                _add: function(e, t, r) {
                    if (this._validateLevel++, r === "d" || r === "w") {
                        var n = e.toJD() + t * (r === "w" ? this.daysInWeek() : 1), i = e.calendar().fromJD(n);
                        return this._validateLevel--, [
                            i.year(),
                            i.month(),
                            i.day()
                        ];
                    }
                    try {
                        var a = e.year() + (r === "y" ? t : 0), o = e.monthOfYear() + (r === "m" ? t : 0), i = e.day(), s = function(c) {
                            for(; o < c.minMonth;)a--, o += c.monthsInYear(a);
                            for(var f = c.monthsInYear(a); o > f - 1 + c.minMonth;)a++, o -= f, f = c.monthsInYear(a);
                        };
                        r === "y" ? (e.month() !== this.fromMonthOfYear(a, o) && (o = this.newDate(a, e.month(), this.minDay).monthOfYear()), o = Math.min(o, this.monthsInYear(a)), i = Math.min(i, this.daysInMonth(a, this.fromMonthOfYear(a, o)))) : r === "m" && (s(this), i = Math.min(i, this.daysInMonth(a, this.fromMonthOfYear(a, o))));
                        var l = [
                            a,
                            this.fromMonthOfYear(a, o),
                            i
                        ];
                        return this._validateLevel--, l;
                    } catch (u) {
                        throw this._validateLevel--, u;
                    }
                },
                _correctAdd: function(e, t, r, n) {
                    if (!this.hasYearZero && (n === "y" || n === "m") && (t[0] === 0 || e.year() > 0 != t[0] > 0)) {
                        var i = {
                            y: [
                                1,
                                1,
                                "y"
                            ],
                            m: [
                                1,
                                this.monthsInYear(-1),
                                "m"
                            ],
                            w: [
                                this.daysInWeek(),
                                this.daysInYear(-1),
                                "d"
                            ],
                            d: [
                                1,
                                this.daysInYear(-1),
                                "d"
                            ]
                        }[n], a = r < 0 ? -1 : 1;
                        t = this._add(e, r * i[0] + a * i[1], i[2]);
                    }
                    return e.date(t[0], t[1], t[2]);
                },
                set: function(e, t, r) {
                    this._validate(e, this.minMonth, this.minDay, Es.local.invalidDate || Es.regionalOptions[""].invalidDate);
                    var n = r === "y" ? t : e.year(), i = r === "m" ? t : e.month(), a = r === "d" ? t : e.day();
                    return (r === "y" || r === "m") && (a = Math.min(a, this.daysInMonth(n, i))), e.date(n, i, a);
                },
                isValid: function(e, t, r) {
                    this._validateLevel++;
                    var n = this.hasYearZero || e !== 0;
                    if (n) {
                        var i = this.newDate(e, t, this.minDay);
                        n = t >= this.minMonth && t - this.minMonth < this.monthsInYear(i) && r >= this.minDay && r - this.minDay < this.daysInMonth(i);
                    }
                    return this._validateLevel--, n;
                },
                toJSDate: function(e, t, r) {
                    var n = this._validate(e, t, r, Es.local.invalidDate || Es.regionalOptions[""].invalidDate);
                    return Es.instance().fromJD(this.toJD(n)).toJSDate();
                },
                fromJSDate: function(e) {
                    return this.fromJD(Es.instance().fromJSDate(e).toJD());
                },
                _validate: function(e, t, r, n) {
                    if (e.year) {
                        if (this._validateLevel === 0 && this.name !== e.calendar().name) throw (Es.local.differentCalendars || Es.regionalOptions[""].differentCalendars).replace(/\{0\}/, this.local.name).replace(/\{1\}/, e.calendar().local.name);
                        return e;
                    }
                    try {
                        if (this._validateLevel++, this._validateLevel === 1 && !this.isValid(e, t, r)) throw n.replace(/\{0\}/, this.local.name);
                        var i = this.newDate(e, t, r);
                        return this._validateLevel--, i;
                    } catch (a) {
                        throw this._validateLevel--, a;
                    }
                }
            });
            function K$(e) {
                this.local = this.regionalOptions[e] || this.regionalOptions[""];
            }
            K$.prototype = new Y$;
            A9(K$.prototype, {
                name: "Gregorian",
                jdEpoch: 17214255e-1,
                daysPerMonth: [
                    31,
                    28,
                    31,
                    30,
                    31,
                    30,
                    31,
                    31,
                    30,
                    31,
                    30,
                    31
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Gregorian",
                        epochs: [
                            "BCE",
                            "CE"
                        ],
                        monthNames: [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ],
                        monthNamesShort: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ],
                        dayNames: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        dayNamesShort: [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        dayNamesMin: [
                            "Su",
                            "Mo",
                            "Tu",
                            "We",
                            "Th",
                            "Fr",
                            "Sa"
                        ],
                        digits: null,
                        dateFormat: "mm/dd/yyyy",
                        firstDay: 0,
                        isRTL: !1
                    }
                },
                leapYear: function(r) {
                    var t = this._validate(r, this.minMonth, this.minDay, Es.local.invalidYear || Es.regionalOptions[""].invalidYear), r = t.year() + (t.year() < 0 ? 1 : 0);
                    return r % 4 === 0 && (r % 100 !== 0 || r % 400 === 0);
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                },
                daysInMonth: function(e, t) {
                    var r = this._validate(e, t, this.minDay, Es.local.invalidMonth || Es.regionalOptions[""].invalidMonth);
                    return this.daysPerMonth[r.month() - 1] + (r.month() === 2 && this.leapYear(r.year()) ? 1 : 0);
                },
                weekDay: function(e, t, r) {
                    return (this.dayOfWeek(e, t, r) || 7) < 6;
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, Es.local.invalidDate || Es.regionalOptions[""].invalidDate);
                    e = n.year(), t = n.month(), r = n.day(), e < 0 && e++, t < 3 && (t += 12, e--);
                    var i = Math.floor(e / 100), a = 2 - i + Math.floor(i / 4);
                    return Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (t + 1)) + r + a - 1524.5;
                },
                fromJD: function(e) {
                    var t = Math.floor(e + .5), r = Math.floor((t - 186721625e-2) / 36524.25);
                    r = t + 1 + r - Math.floor(r / 4);
                    var n = r + 1524, i = Math.floor((n - 122.1) / 365.25), a = Math.floor(365.25 * i), o = Math.floor((n - a) / 30.6001), s = n - a - Math.floor(o * 30.6001), l = o - (o > 13.5 ? 13 : 1), u = i - (l > 2.5 ? 4716 : 4715);
                    return u <= 0 && u--, this.newDate(u, l, s);
                },
                toJSDate: function(e, t, r) {
                    var n = this._validate(e, t, r, Es.local.invalidDate || Es.regionalOptions[""].invalidDate), i = new Date(n.year(), n.month() - 1, n.day());
                    return i.setHours(0), i.setMinutes(0), i.setSeconds(0), i.setMilliseconds(0), i.setHours(i.getHours() > 12 ? i.getHours() + 2 : 0), i;
                },
                fromJSDate: function(e) {
                    return this.newDate(e.getFullYear(), e.getMonth() + 1, e.getDate());
                }
            });
            var Es = M$e.exports = new S$e;
            Es.cdate = X$;
            Es.baseCalendar = Y$;
            Es.calendars.gregorian = K$;
        });
        var E$e = ye(()=>{
            var J$ = bh(), qd = Sv();
            J$(qd.regionalOptions[""], {
                invalidArguments: "Invalid arguments",
                invalidFormat: "Cannot format a date from another calendar",
                missingNumberAt: "Missing number at position {0}",
                unknownNameAt: "Unknown name at position {0}",
                unexpectedLiteralAt: "Unexpected literal at position {0}",
                unexpectedText: "Additional text found at end"
            });
            qd.local = qd.regionalOptions[""];
            J$(qd.cdate.prototype, {
                formatDate: function(e, t) {
                    return typeof e != "string" && (t = e, e = ""), this._calendar.formatDate(e || "", this, t);
                }
            });
            J$(qd.baseCalendar.prototype, {
                UNIX_EPOCH: qd.instance().newDate(1970, 1, 1).toJD(),
                SECS_PER_DAY: 86400,
                TICKS_EPOCH: qd.instance().jdEpoch,
                TICKS_PER_DAY: 864000000000,
                ATOM: "yyyy-mm-dd",
                COOKIE: "D, dd M yyyy",
                FULL: "DD, MM d, yyyy",
                ISO_8601: "yyyy-mm-dd",
                JULIAN: "J",
                RFC_822: "D, d M yy",
                RFC_850: "DD, dd-M-yy",
                RFC_1036: "D, d M yy",
                RFC_1123: "D, d M yyyy",
                RFC_2822: "D, d M yyyy",
                RSS: "D, d M yy",
                TICKS: "!",
                TIMESTAMP: "@",
                W3C: "yyyy-mm-dd",
                formatDate: function(e, t, r) {
                    if (typeof e != "string" && (r = t, t = e, e = ""), !t) return "";
                    if (t.calendar() !== this) throw qd.local.invalidFormat || qd.regionalOptions[""].invalidFormat;
                    e = e || this.local.dateFormat, r = r || {};
                    for(var n = r.dayNamesShort || this.local.dayNamesShort, i = r.dayNames || this.local.dayNames, a = r.monthNumbers || this.local.monthNumbers, o = r.monthNamesShort || this.local.monthNamesShort, s = r.monthNames || this.local.monthNames, l = r.calculateWeek || this.local.calculateWeek, u = function(A, L) {
                        for(var _ = 1; k + _ < e.length && e.charAt(k + _) === A;)_++;
                        return k += _ - 1, Math.floor(_ / (L || 1)) > 1;
                    }, c = function(A, L, _, C) {
                        var M = "" + L;
                        if (u(A, C)) for(; M.length < _;)M = "0" + M;
                        return M;
                    }, f = function(A, L, _, C) {
                        return u(A) ? C[L] : _[L];
                    }, h = this, d = function(A) {
                        return typeof a == "function" ? a.call(h, A, u("m")) : b(c("m", A.month(), 2));
                    }, v = function(A, L) {
                        return L ? typeof s == "function" ? s.call(h, A) : s[A.month() - h.minMonth] : typeof o == "function" ? o.call(h, A) : o[A.month() - h.minMonth];
                    }, x = this.local.digits, b = function(A) {
                        return r.localNumbers && x ? x(A) : A;
                    }, p = "", E = !1, k = 0; k < e.length; k++)if (E) e.charAt(k) === "'" && !u("'") ? E = !1 : p += e.charAt(k);
                    else switch(e.charAt(k)){
                        case "d":
                            p += b(c("d", t.day(), 2));
                            break;
                        case "D":
                            p += f("D", t.dayOfWeek(), n, i);
                            break;
                        case "o":
                            p += c("o", t.dayOfYear(), 3);
                            break;
                        case "w":
                            p += c("w", t.weekOfYear(), 2);
                            break;
                        case "m":
                            p += d(t);
                            break;
                        case "M":
                            p += v(t, u("M"));
                            break;
                        case "y":
                            p += u("y", 2) ? t.year() : (t.year() % 100 < 10 ? "0" : "") + t.year() % 100;
                            break;
                        case "Y":
                            u("Y", 2), p += t.formatYear();
                            break;
                        case "J":
                            p += t.toJD();
                            break;
                        case "@":
                            p += (t.toJD() - this.UNIX_EPOCH) * this.SECS_PER_DAY;
                            break;
                        case "!":
                            p += (t.toJD() - this.TICKS_EPOCH) * this.TICKS_PER_DAY;
                            break;
                        case "'":
                            u("'") ? p += "'" : E = !0;
                            break;
                        default:
                            p += e.charAt(k);
                    }
                    return p;
                },
                parseDate: function(e, t, r) {
                    if (t == null) throw qd.local.invalidArguments || qd.regionalOptions[""].invalidArguments;
                    if (t = typeof t == "object" ? t.toString() : t + "", t === "") return null;
                    e = e || this.local.dateFormat, r = r || {};
                    var n = r.shortYearCutoff || this.shortYearCutoff;
                    n = typeof n != "string" ? n : this.today().year() % 100 + parseInt(n, 10);
                    for(var i = r.dayNamesShort || this.local.dayNamesShort, a = r.dayNames || this.local.dayNames, o = r.parseMonth || this.local.parseMonth, s = r.monthNumbers || this.local.monthNumbers, l = r.monthNamesShort || this.local.monthNamesShort, u = r.monthNames || this.local.monthNames, c = -1, f = -1, h = -1, d = -1, v = -1, x = !1, b = !1, p = function(F, q) {
                        for(var V = 1; g + V < e.length && e.charAt(g + V) === F;)V++;
                        return g += V - 1, Math.floor(V / (q || 1)) > 1;
                    }, E = function(F, q) {
                        var V = p(F, q), H = [
                            2,
                            3,
                            V ? 4 : 2,
                            V ? 4 : 2,
                            10,
                            11,
                            20
                        ]["oyYJ@!".indexOf(F) + 1], X = new RegExp("^-?\\d{1," + H + "}"), G = t.substring(M).match(X);
                        if (!G) throw (qd.local.missingNumberAt || qd.regionalOptions[""].missingNumberAt).replace(/\{0\}/, M);
                        return M += G[0].length, parseInt(G[0], 10);
                    }, k = this, A = function() {
                        if (typeof s == "function") {
                            p("m");
                            var F = s.call(k, t.substring(M));
                            return M += F.length, F;
                        }
                        return E("m");
                    }, L = function(F, q, V, H) {
                        for(var X = p(F, H) ? V : q, G = 0; G < X.length; G++)if (t.substr(M, X[G].length).toLowerCase() === X[G].toLowerCase()) return M += X[G].length, G + k.minMonth;
                        throw (qd.local.unknownNameAt || qd.regionalOptions[""].unknownNameAt).replace(/\{0\}/, M);
                    }, _ = function() {
                        if (typeof u == "function") {
                            var F = p("M") ? u.call(k, t.substring(M)) : l.call(k, t.substring(M));
                            return M += F.length, F;
                        }
                        return L("M", l, u);
                    }, C = function() {
                        if (t.charAt(M) !== e.charAt(g)) throw (qd.local.unexpectedLiteralAt || qd.regionalOptions[""].unexpectedLiteralAt).replace(/\{0\}/, M);
                        M++;
                    }, M = 0, g = 0; g < e.length; g++)if (b) e.charAt(g) === "'" && !p("'") ? b = !1 : C();
                    else switch(e.charAt(g)){
                        case "d":
                            d = E("d");
                            break;
                        case "D":
                            L("D", i, a);
                            break;
                        case "o":
                            v = E("o");
                            break;
                        case "w":
                            E("w");
                            break;
                        case "m":
                            h = A();
                            break;
                        case "M":
                            h = _();
                            break;
                        case "y":
                            var P = g;
                            x = !p("y", 2), g = P, f = E("y", 2);
                            break;
                        case "Y":
                            f = E("Y", 2);
                            break;
                        case "J":
                            c = E("J") + .5, t.charAt(M) === "." && (M++, E("J"));
                            break;
                        case "@":
                            c = E("@") / this.SECS_PER_DAY + this.UNIX_EPOCH;
                            break;
                        case "!":
                            c = E("!") / this.TICKS_PER_DAY + this.TICKS_EPOCH;
                            break;
                        case "*":
                            M = t.length;
                            break;
                        case "'":
                            p("'") ? C() : b = !0;
                            break;
                        default:
                            C();
                    }
                    if (M < t.length) throw qd.local.unexpectedText || qd.regionalOptions[""].unexpectedText;
                    if (f === -1 ? f = this.today().year() : f < 100 && x && (f += n === -1 ? 1900 : this.today().year() - this.today().year() % 100 - (f <= n ? 0 : 100)), typeof h == "string" && (h = o.call(this, f, h)), v > -1) {
                        h = 1, d = v;
                        for(var T = this.daysInMonth(f, h); d > T; T = this.daysInMonth(f, h))h++, d -= T;
                    }
                    return c > -1 ? this.fromJD(c) : this.newDate(f, h, d);
                },
                determineDate: function(e, t, r, n, i) {
                    r && typeof r != "object" && (i = n, n = r, r = null), typeof n != "string" && (i = n, n = "");
                    var a = this, o = function(s) {
                        try {
                            return a.parseDate(n, s, i);
                        } catch (f) {}
                        s = s.toLowerCase();
                        for(var l = (s.match(/^c/) && r ? r.newDate() : null) || a.today(), u = /([+-]?[0-9]+)\s*(d|w|m|y)?/g, c = u.exec(s); c;)l.add(parseInt(c[1], 10), c[2] || "d"), c = u.exec(s);
                        return l;
                    };
                    return t = t ? t.newDate() : null, e = e == null ? t : typeof e == "string" ? o(e) : typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? t : a.today().add(e, "d") : a.newDate(e), e;
                }
            });
        });
        var k$e = ye(()=>{
            var zx = Sv(), aQt = bh(), $$ = zx.instance();
            function S9(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            S9.prototype = new zx.baseCalendar;
            aQt(S9.prototype, {
                name: "Chinese",
                jdEpoch: 17214255e-1,
                hasYearZero: !1,
                minMonth: 0,
                firstMonth: 0,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Chinese",
                        epochs: [
                            "BEC",
                            "EC"
                        ],
                        monthNumbers: function(e, t) {
                            if (typeof e == "string") {
                                var r = e.match(sQt);
                                return r ? r[0] : "";
                            }
                            var n = this._validateYear(e), i = e.month(), a = "" + this.toChineseMonth(n, i);
                            return t && a.length < 2 && (a = "0" + a), this.isIntercalaryMonth(n, i) && (a += "i"), a;
                        },
                        monthNames: function(e) {
                            if (typeof e == "string") {
                                var t = e.match(lQt);
                                return t ? t[0] : "";
                            }
                            var r = this._validateYear(e), n = e.month(), i = this.toChineseMonth(r, n), a = [
                                "\u4E00\u6708",
                                "\u4E8C\u6708",
                                "\u4E09\u6708",
                                "\u56DB\u6708",
                                "\u4E94\u6708",
                                "\u516D\u6708",
                                "\u4E03\u6708",
                                "\u516B\u6708",
                                "\u4E5D\u6708",
                                "\u5341\u6708",
                                "\u5341\u4E00\u6708",
                                "\u5341\u4E8C\u6708"
                            ][i - 1];
                            return this.isIntercalaryMonth(r, n) && (a = "\u95F0" + a), a;
                        },
                        monthNamesShort: function(e) {
                            if (typeof e == "string") {
                                var t = e.match(uQt);
                                return t ? t[0] : "";
                            }
                            var r = this._validateYear(e), n = e.month(), i = this.toChineseMonth(r, n), a = [
                                "\u4E00",
                                "\u4E8C",
                                "\u4E09",
                                "\u56DB",
                                "\u4E94",
                                "\u516D",
                                "\u4E03",
                                "\u516B",
                                "\u4E5D",
                                "\u5341",
                                "\u5341\u4E00",
                                "\u5341\u4E8C"
                            ][i - 1];
                            return this.isIntercalaryMonth(r, n) && (a = "\u95F0" + a), a;
                        },
                        parseMonth: function(e, t) {
                            e = this._validateYear(e);
                            var r = parseInt(t), n;
                            if (isNaN(r)) t[0] === "\u95F0" && (n = !0, t = t.substring(1)), t[t.length - 1] === "\u6708" && (t = t.substring(0, t.length - 1)), r = 1 + [
                                "\u4E00",
                                "\u4E8C",
                                "\u4E09",
                                "\u56DB",
                                "\u4E94",
                                "\u516D",
                                "\u4E03",
                                "\u516B",
                                "\u4E5D",
                                "\u5341",
                                "\u5341\u4E00",
                                "\u5341\u4E8C"
                            ].indexOf(t);
                            else {
                                var i = t[t.length - 1];
                                n = i === "i" || i === "I";
                            }
                            var a = this.toMonthIndex(e, r, n);
                            return a;
                        },
                        dayNames: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        dayNamesShort: [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        dayNamesMin: [
                            "Su",
                            "Mo",
                            "Tu",
                            "We",
                            "Th",
                            "Fr",
                            "Sa"
                        ],
                        digits: null,
                        dateFormat: "yyyy/mm/dd",
                        firstDay: 1,
                        isRTL: !1
                    }
                },
                _validateYear: function(e, t) {
                    if (e.year && (e = e.year()), typeof e != "number" || e < 1888 || e > 2111) throw t.replace(/\{0\}/, this.local.name);
                    return e;
                },
                toMonthIndex: function(e, t, r) {
                    var n = this.intercalaryMonth(e), i = r && t !== n;
                    if (i || t < 1 || t > 12) throw zx.local.invalidMonth.replace(/\{0\}/, this.local.name);
                    var a;
                    return n ? !r && t <= n ? a = t - 1 : a = t : a = t - 1, a;
                },
                toChineseMonth: function(e, t) {
                    e.year && (e = e.year(), t = e.month());
                    var r = this.intercalaryMonth(e), n = r ? 12 : 11;
                    if (t < 0 || t > n) throw zx.local.invalidMonth.replace(/\{0\}/, this.local.name);
                    var i;
                    return r ? t < r ? i = t + 1 : i = t : i = t + 1, i;
                },
                intercalaryMonth: function(e) {
                    e = this._validateYear(e);
                    var t = Fx[e - Fx[0]], r = t >> 13;
                    return r;
                },
                isIntercalaryMonth: function(e, t) {
                    e.year && (e = e.year(), t = e.month());
                    var r = this.intercalaryMonth(e);
                    return !!r && r === t;
                },
                leapYear: function(e) {
                    return this.intercalaryMonth(e) !== 0;
                },
                weekOfYear: function(e, t, r) {
                    var n = this._validateYear(e, zx.local.invalidyear), i = qx[n - qx[0]], a = i >> 9 & 4095, o = i >> 5 & 15, s = i & 31, l;
                    l = $$.newDate(a, o, s), l.add(4 - (l.dayOfWeek() || 7), "d");
                    var u = this.toJD(e, t, r) - l.toJD();
                    return 1 + Math.floor(u / 7);
                },
                monthsInYear: function(e) {
                    return this.leapYear(e) ? 13 : 12;
                },
                daysInMonth: function(e, t) {
                    e.year && (t = e.month(), e = e.year()), e = this._validateYear(e);
                    var r = Fx[e - Fx[0]], n = r >> 13, i = n ? 12 : 11;
                    if (t > i) throw zx.local.invalidMonth.replace(/\{0\}/, this.local.name);
                    var a = r & 1 << 12 - t ? 30 : 29;
                    return a;
                },
                weekDay: function(e, t, r) {
                    return (this.dayOfWeek(e, t, r) || 7) < 6;
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, a, r, zx.local.invalidDate);
                    e = this._validateYear(n.year()), t = n.month(), r = n.day();
                    var i = this.isIntercalaryMonth(e, t), a = this.toChineseMonth(e, t), o = fQt(e, a, r, i);
                    return $$.toJD(o.year, o.month, o.day);
                },
                fromJD: function(e) {
                    var t = $$.fromJD(e), r = cQt(t.year(), t.month(), t.day()), n = this.toMonthIndex(r.year, r.month, r.isIntercalary);
                    return this.newDate(r.year, n, r.day);
                },
                fromString: function(e) {
                    var t = e.match(oQt), r = this._validateYear(+t[1]), n = +t[2], i = !!t[3], a = this.toMonthIndex(r, n, i), o = +t[4];
                    return this.newDate(r, a, o);
                },
                add: function(e, t, r) {
                    var n = e.year(), i = e.month(), a = this.isIntercalaryMonth(n, i), o = this.toChineseMonth(n, i), s = Object.getPrototypeOf(S9.prototype).add.call(this, e, t, r);
                    if (r === "y") {
                        var l = s.year(), u = s.month(), c = this.isIntercalaryMonth(l, o), f = a && c ? this.toMonthIndex(l, o, !0) : this.toMonthIndex(l, o, !1);
                        f !== u && s.month(f);
                    }
                    return s;
                }
            });
            var oQt = /^\s*(-?\d\d\d\d|\d\d)[-/](\d?\d)([iI]?)[-/](\d?\d)/m, sQt = /^\d?\d[iI]?/m, lQt = /^闰?十?[一二三四五六七八九]?月/m, uQt = /^闰?十?[一二三四五六七八九]?/m;
            zx.calendars.chinese = S9;
            var Fx = [
                1887,
                5780,
                5802,
                19157,
                2742,
                50359,
                1198,
                2646,
                46378,
                7466,
                3412,
                30122,
                5482,
                67949,
                2396,
                5294,
                43597,
                6732,
                6954,
                36181,
                2772,
                4954,
                18781,
                2396,
                54427,
                5274,
                6730,
                47781,
                5800,
                6868,
                21210,
                4790,
                59703,
                2350,
                5270,
                46667,
                3402,
                3496,
                38325,
                1388,
                4782,
                18735,
                2350,
                52374,
                6804,
                7498,
                44457,
                2906,
                1388,
                29294,
                4700,
                63789,
                6442,
                6804,
                56138,
                5802,
                2772,
                38235,
                1210,
                4698,
                22827,
                5418,
                63125,
                3476,
                5802,
                43701,
                2484,
                5302,
                27223,
                2646,
                70954,
                7466,
                3412,
                54698,
                5482,
                2412,
                38062,
                5294,
                2636,
                32038,
                6954,
                60245,
                2772,
                4826,
                43357,
                2394,
                5274,
                39501,
                6730,
                72357,
                5800,
                5844,
                53978,
                4790,
                2358,
                38039,
                5270,
                87627,
                3402,
                3496,
                54708,
                5484,
                4782,
                43311,
                2350,
                3222,
                27978,
                7498,
                68965,
                2904,
                5484,
                45677,
                4700,
                6444,
                39573,
                6804,
                6986,
                19285,
                2772,
                62811,
                1210,
                4698,
                47403,
                5418,
                5780,
                38570,
                5546,
                76469,
                2420,
                5302,
                51799,
                2646,
                5414,
                36501,
                3412,
                5546,
                18869,
                2412,
                54446,
                5276,
                6732,
                48422,
                6822,
                2900,
                28010,
                4826,
                92509,
                2394,
                5274,
                55883,
                6730,
                6820,
                47956,
                5812,
                2778,
                18779,
                2358,
                62615,
                5270,
                5450,
                46757,
                3492,
                5556,
                27318,
                4718,
                67887,
                2350,
                3222,
                52554,
                7498,
                3428,
                38252,
                5468,
                4700,
                31022,
                6444,
                64149,
                6804,
                6986,
                43861,
                2772,
                5338,
                35421,
                2650,
                70955,
                5418,
                5780,
                54954,
                5546,
                2740,
                38074,
                5302,
                2646,
                29991,
                3366,
                61011,
                3412,
                5546,
                43445,
                2412,
                5294,
                35406,
                6732,
                72998,
                6820,
                6996,
                52586,
                2778,
                2396,
                38045,
                5274,
                6698,
                23333,
                6820,
                64338,
                5812,
                2746,
                43355,
                2358,
                5270,
                39499,
                5450,
                79525,
                3492,
                5548
            ], qx = [
                1887,
                966732,
                967231,
                967733,
                968265,
                968766,
                969297,
                969798,
                970298,
                970829,
                971330,
                971830,
                972362,
                972863,
                973395,
                973896,
                974397,
                974928,
                975428,
                975929,
                976461,
                976962,
                977462,
                977994,
                978494,
                979026,
                979526,
                980026,
                980558,
                981059,
                981559,
                982091,
                982593,
                983124,
                983624,
                984124,
                984656,
                985157,
                985656,
                986189,
                986690,
                987191,
                987722,
                988222,
                988753,
                989254,
                989754,
                990286,
                990788,
                991288,
                991819,
                992319,
                992851,
                993352,
                993851,
                994383,
                994885,
                995385,
                995917,
                996418,
                996918,
                997450,
                997949,
                998481,
                998982,
                999483,
                1000014,
                1000515,
                1001016,
                1001548,
                1002047,
                1002578,
                1003080,
                1003580,
                1004111,
                1004613,
                1005113,
                1005645,
                1006146,
                1006645,
                1007177,
                1007678,
                1008209,
                1008710,
                1009211,
                1009743,
                1010243,
                1010743,
                1011275,
                1011775,
                1012306,
                1012807,
                1013308,
                1013840,
                1014341,
                1014841,
                1015373,
                1015874,
                1016404,
                1016905,
                1017405,
                1017937,
                1018438,
                1018939,
                1019471,
                1019972,
                1020471,
                1021002,
                1021503,
                1022035,
                1022535,
                1023036,
                1023568,
                1024069,
                1024568,
                1025100,
                1025601,
                1026102,
                1026633,
                1027133,
                1027666,
                1028167,
                1028666,
                1029198,
                1029699,
                1030199,
                1030730,
                1031231,
                1031763,
                1032264,
                1032764,
                1033296,
                1033797,
                1034297,
                1034828,
                1035329,
                1035830,
                1036362,
                1036861,
                1037393,
                1037894,
                1038394,
                1038925,
                1039427,
                1039927,
                1040459,
                1040959,
                1041491,
                1041992,
                1042492,
                1043023,
                1043524,
                1044024,
                1044556,
                1045057,
                1045558,
                1046090,
                1046590,
                1047121,
                1047622,
                1048122,
                1048654,
                1049154,
                1049655,
                1050187,
                1050689,
                1051219,
                1051720,
                1052220,
                1052751,
                1053252,
                1053752,
                1054284,
                1054786,
                1055285,
                1055817,
                1056317,
                1056849,
                1057349,
                1057850,
                1058382,
                1058883,
                1059383,
                1059915,
                1060415,
                1060947,
                1061447,
                1061947,
                1062479,
                1062981,
                1063480,
                1064012,
                1064514,
                1065014,
                1065545,
                1066045,
                1066577,
                1067078,
                1067578,
                1068110,
                1068611,
                1069112,
                1069642,
                1070142,
                1070674,
                1071175,
                1071675,
                1072207,
                1072709,
                1073209,
                1073740,
                1074241,
                1074741,
                1075273,
                1075773,
                1076305,
                1076807,
                1077308,
                1077839,
                1078340,
                1078840,
                1079372,
                1079871,
                1080403,
                1080904
            ];
            function cQt(e, t, r, n) {
                var i, a;
                if (typeof e == "object") i = e, a = t || {};
                else {
                    var o = typeof e == "number" && e >= 1888 && e <= 2111;
                    if (!o) throw new Error("Solar year outside range 1888-2111");
                    var s = typeof t == "number" && t >= 1 && t <= 12;
                    if (!s) throw new Error("Solar month outside range 1 - 12");
                    var l = typeof r == "number" && r >= 1 && r <= 31;
                    if (!l) throw new Error("Solar day outside range 1 - 31");
                    i = {
                        year: e,
                        month: t,
                        day: r
                    }, a = n || {};
                }
                var u = qx[i.year - qx[0]], c = i.year << 9 | i.month << 5 | i.day;
                a.year = c >= u ? i.year : i.year - 1, u = qx[a.year - qx[0]];
                var f = u >> 9 & 4095, h = u >> 5 & 15, d = u & 31, v, x = new Date(f, h - 1, d), b = new Date(i.year, i.month - 1, i.day);
                v = Math.round((b - x) / 86400000);
                var p = Fx[a.year - Fx[0]], E;
                for(E = 0; E < 13; E++){
                    var k = p & 1 << 12 - E ? 30 : 29;
                    if (v < k) break;
                    v -= k;
                }
                var A = p >> 13;
                return !A || E < A ? (a.isIntercalary = !1, a.month = 1 + E) : E === A ? (a.isIntercalary = !0, a.month = E) : (a.isIntercalary = !1, a.month = E), a.day = 1 + v, a;
            }
            function fQt(e, t, r, n, i) {
                var a, o;
                if (typeof e == "object") o = e, a = t || {};
                else {
                    var s = typeof e == "number" && e >= 1888 && e <= 2111;
                    if (!s) throw new Error("Lunar year outside range 1888-2111");
                    var l = typeof t == "number" && t >= 1 && t <= 12;
                    if (!l) throw new Error("Lunar month outside range 1 - 12");
                    var u = typeof r == "number" && r >= 1 && r <= 30;
                    if (!u) throw new Error("Lunar day outside range 1 - 30");
                    var c;
                    typeof n == "object" ? (c = !1, a = n) : (c = !!n, a = i || {}), o = {
                        year: e,
                        month: t,
                        day: r,
                        isIntercalary: c
                    };
                }
                var f;
                f = o.day - 1;
                var h = Fx[o.year - Fx[0]], d = h >> 13, v;
                d && (o.month > d || o.isIntercalary) ? v = o.month : v = o.month - 1;
                for(var x = 0; x < v; x++){
                    var b = h & 1 << 12 - x ? 30 : 29;
                    f += b;
                }
                var p = qx[o.year - qx[0]], E = p >> 9 & 4095, k = p >> 5 & 15, A = p & 31, L = new Date(E, k - 1, A + f);
                return a.year = L.getFullYear(), a.month = 1 + L.getMonth(), a.day = L.getDate(), a;
            }
        });
        var C$e = ye(()=>{
            var _w = Sv(), hQt = bh();
            function Q$(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            Q$.prototype = new _w.baseCalendar;
            hQt(Q$.prototype, {
                name: "Coptic",
                jdEpoch: 18250295e-1,
                daysPerMonth: [
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    5
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Coptic",
                        epochs: [
                            "BAM",
                            "AM"
                        ],
                        monthNames: [
                            "Thout",
                            "Paopi",
                            "Hathor",
                            "Koiak",
                            "Tobi",
                            "Meshir",
                            "Paremhat",
                            "Paremoude",
                            "Pashons",
                            "Paoni",
                            "Epip",
                            "Mesori",
                            "Pi Kogi Enavot"
                        ],
                        monthNamesShort: [
                            "Tho",
                            "Pao",
                            "Hath",
                            "Koi",
                            "Tob",
                            "Mesh",
                            "Pat",
                            "Pad",
                            "Pash",
                            "Pao",
                            "Epi",
                            "Meso",
                            "PiK"
                        ],
                        dayNames: [
                            "Tkyriaka",
                            "Pesnau",
                            "Pshoment",
                            "Peftoou",
                            "Ptiou",
                            "Psoou",
                            "Psabbaton"
                        ],
                        dayNamesShort: [
                            "Tky",
                            "Pes",
                            "Psh",
                            "Pef",
                            "Pti",
                            "Pso",
                            "Psa"
                        ],
                        dayNamesMin: [
                            "Tk",
                            "Pes",
                            "Psh",
                            "Pef",
                            "Pt",
                            "Pso",
                            "Psa"
                        ],
                        digits: null,
                        dateFormat: "dd/mm/yyyy",
                        firstDay: 0,
                        isRTL: !1
                    }
                },
                leapYear: function(r) {
                    var t = this._validate(r, this.minMonth, this.minDay, _w.local.invalidYear), r = t.year() + (t.year() < 0 ? 1 : 0);
                    return r % 4 === 3 || r % 4 === -1;
                },
                monthsInYear: function(e) {
                    return this._validate(e, this.minMonth, this.minDay, _w.local.invalidYear || _w.regionalOptions[""].invalidYear), 13;
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                },
                daysInMonth: function(e, t) {
                    var r = this._validate(e, t, this.minDay, _w.local.invalidMonth);
                    return this.daysPerMonth[r.month() - 1] + (r.month() === 13 && this.leapYear(r.year()) ? 1 : 0);
                },
                weekDay: function(e, t, r) {
                    return (this.dayOfWeek(e, t, r) || 7) < 6;
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, _w.local.invalidDate);
                    return e = n.year(), e < 0 && e++, n.day() + (n.month() - 1) * 30 + (e - 1) * 365 + Math.floor(e / 4) + this.jdEpoch - 1;
                },
                fromJD: function(e) {
                    var t = Math.floor(e) + .5 - this.jdEpoch, r = Math.floor((t - Math.floor((t + 366) / 1461)) / 365) + 1;
                    r <= 0 && r--, t = Math.floor(e) + .5 - this.newDate(r, 1, 1).toJD();
                    var n = Math.floor(t / 30) + 1, i = t - (n - 1) * 30 + 1;
                    return this.newDate(r, n, i);
                }
            });
            _w.calendars.coptic = Q$;
        });
        var L$e = ye(()=>{
            var b1 = Sv(), dQt = bh();
            function eQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            eQ.prototype = new b1.baseCalendar;
            dQt(eQ.prototype, {
                name: "Discworld",
                jdEpoch: 17214255e-1,
                daysPerMonth: [
                    16,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32,
                    32
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Discworld",
                        epochs: [
                            "BUC",
                            "UC"
                        ],
                        monthNames: [
                            "Ick",
                            "Offle",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "Grune",
                            "August",
                            "Spune",
                            "Sektober",
                            "Ember",
                            "December"
                        ],
                        monthNamesShort: [
                            "Ick",
                            "Off",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Gru",
                            "Aug",
                            "Spu",
                            "Sek",
                            "Emb",
                            "Dec"
                        ],
                        dayNames: [
                            "Sunday",
                            "Octeday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        dayNamesShort: [
                            "Sun",
                            "Oct",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        dayNamesMin: [
                            "Su",
                            "Oc",
                            "Mo",
                            "Tu",
                            "We",
                            "Th",
                            "Fr",
                            "Sa"
                        ],
                        digits: null,
                        dateFormat: "yyyy/mm/dd",
                        firstDay: 2,
                        isRTL: !1
                    }
                },
                leapYear: function(e) {
                    return this._validate(e, this.minMonth, this.minDay, b1.local.invalidYear), !1;
                },
                monthsInYear: function(e) {
                    return this._validate(e, this.minMonth, this.minDay, b1.local.invalidYear), 13;
                },
                daysInYear: function(e) {
                    return this._validate(e, this.minMonth, this.minDay, b1.local.invalidYear), 400;
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 8) + 1;
                },
                daysInMonth: function(e, t) {
                    var r = this._validate(e, t, this.minDay, b1.local.invalidMonth);
                    return this.daysPerMonth[r.month() - 1];
                },
                daysInWeek: function() {
                    return 8;
                },
                dayOfWeek: function(e, t, r) {
                    var n = this._validate(e, t, r, b1.local.invalidDate);
                    return (n.day() + 1) % 8;
                },
                weekDay: function(e, t, r) {
                    var n = this.dayOfWeek(e, t, r);
                    return n >= 2 && n <= 6;
                },
                extraInfo: function(e, t, r) {
                    var n = this._validate(e, t, r, b1.local.invalidDate);
                    return {
                        century: vQt[Math.floor((n.year() - 1) / 100) + 1] || ""
                    };
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, b1.local.invalidDate);
                    return e = n.year() + (n.year() < 0 ? 1 : 0), t = n.month(), r = n.day(), r + (t > 1 ? 16 : 0) + (t > 2 ? (t - 2) * 32 : 0) + (e - 1) * 400 + this.jdEpoch - 1;
                },
                fromJD: function(e) {
                    e = Math.floor(e + .5) - Math.floor(this.jdEpoch) - 1;
                    var t = Math.floor(e / 400) + 1;
                    e -= (t - 1) * 400, e += e > 15 ? 16 : 0;
                    var r = Math.floor(e / 32) + 1, n = e - (r - 1) * 32 + 1;
                    return this.newDate(t <= 0 ? t - 1 : t, r, n);
                }
            });
            var vQt = {
                20: "Fruitbat",
                21: "Anchovy"
            };
            b1.calendars.discworld = eQ;
        });
        var P$e = ye(()=>{
            var xw = Sv(), pQt = bh();
            function tQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            tQ.prototype = new xw.baseCalendar;
            pQt(tQ.prototype, {
                name: "Ethiopian",
                jdEpoch: 17242205e-1,
                daysPerMonth: [
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    5
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Ethiopian",
                        epochs: [
                            "BEE",
                            "EE"
                        ],
                        monthNames: [
                            "Meskerem",
                            "Tikemet",
                            "Hidar",
                            "Tahesas",
                            "Tir",
                            "Yekatit",
                            "Megabit",
                            "Miazia",
                            "Genbot",
                            "Sene",
                            "Hamle",
                            "Nehase",
                            "Pagume"
                        ],
                        monthNamesShort: [
                            "Mes",
                            "Tik",
                            "Hid",
                            "Tah",
                            "Tir",
                            "Yek",
                            "Meg",
                            "Mia",
                            "Gen",
                            "Sen",
                            "Ham",
                            "Neh",
                            "Pag"
                        ],
                        dayNames: [
                            "Ehud",
                            "Segno",
                            "Maksegno",
                            "Irob",
                            "Hamus",
                            "Arb",
                            "Kidame"
                        ],
                        dayNamesShort: [
                            "Ehu",
                            "Seg",
                            "Mak",
                            "Iro",
                            "Ham",
                            "Arb",
                            "Kid"
                        ],
                        dayNamesMin: [
                            "Eh",
                            "Se",
                            "Ma",
                            "Ir",
                            "Ha",
                            "Ar",
                            "Ki"
                        ],
                        digits: null,
                        dateFormat: "dd/mm/yyyy",
                        firstDay: 0,
                        isRTL: !1
                    }
                },
                leapYear: function(r) {
                    var t = this._validate(r, this.minMonth, this.minDay, xw.local.invalidYear), r = t.year() + (t.year() < 0 ? 1 : 0);
                    return r % 4 === 3 || r % 4 === -1;
                },
                monthsInYear: function(e) {
                    return this._validate(e, this.minMonth, this.minDay, xw.local.invalidYear || xw.regionalOptions[""].invalidYear), 13;
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                },
                daysInMonth: function(e, t) {
                    var r = this._validate(e, t, this.minDay, xw.local.invalidMonth);
                    return this.daysPerMonth[r.month() - 1] + (r.month() === 13 && this.leapYear(r.year()) ? 1 : 0);
                },
                weekDay: function(e, t, r) {
                    return (this.dayOfWeek(e, t, r) || 7) < 6;
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, xw.local.invalidDate);
                    return e = n.year(), e < 0 && e++, n.day() + (n.month() - 1) * 30 + (e - 1) * 365 + Math.floor(e / 4) + this.jdEpoch - 1;
                },
                fromJD: function(e) {
                    var t = Math.floor(e) + .5 - this.jdEpoch, r = Math.floor((t - Math.floor((t + 366) / 1461)) / 365) + 1;
                    r <= 0 && r--, t = Math.floor(e) + .5 - this.newDate(r, 1, 1).toJD();
                    var n = Math.floor(t / 30) + 1, i = t - (n - 1) * 30 + 1;
                    return this.newDate(r, n, i);
                }
            });
            xw.calendars.ethiopian = tQ;
        });
        var I$e = ye(()=>{
            var Ox = Sv(), gQt = bh();
            function rQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            rQ.prototype = new Ox.baseCalendar;
            gQt(rQ.prototype, {
                name: "Hebrew",
                jdEpoch: 347995.5,
                daysPerMonth: [
                    30,
                    29,
                    30,
                    29,
                    30,
                    29,
                    30,
                    29,
                    30,
                    29,
                    30,
                    29,
                    29
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 7,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Hebrew",
                        epochs: [
                            "BAM",
                            "AM"
                        ],
                        monthNames: [
                            "Nisan",
                            "Iyar",
                            "Sivan",
                            "Tammuz",
                            "Av",
                            "Elul",
                            "Tishrei",
                            "Cheshvan",
                            "Kislev",
                            "Tevet",
                            "Shevat",
                            "Adar",
                            "Adar II"
                        ],
                        monthNamesShort: [
                            "Nis",
                            "Iya",
                            "Siv",
                            "Tam",
                            "Av",
                            "Elu",
                            "Tis",
                            "Che",
                            "Kis",
                            "Tev",
                            "She",
                            "Ada",
                            "Ad2"
                        ],
                        dayNames: [
                            "Yom Rishon",
                            "Yom Sheni",
                            "Yom Shlishi",
                            "Yom Revi'i",
                            "Yom Chamishi",
                            "Yom Shishi",
                            "Yom Shabbat"
                        ],
                        dayNamesShort: [
                            "Ris",
                            "She",
                            "Shl",
                            "Rev",
                            "Cha",
                            "Shi",
                            "Sha"
                        ],
                        dayNamesMin: [
                            "Ri",
                            "She",
                            "Shl",
                            "Re",
                            "Ch",
                            "Shi",
                            "Sha"
                        ],
                        digits: null,
                        dateFormat: "dd/mm/yyyy",
                        firstDay: 0,
                        isRTL: !1
                    }
                },
                leapYear: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, Ox.local.invalidYear);
                    return this._leapYear(t.year());
                },
                _leapYear: function(e) {
                    return e = e < 0 ? e + 1 : e, M9(e * 7 + 1, 19) < 7;
                },
                monthsInYear: function(e) {
                    return this._validate(e, this.minMonth, this.minDay, Ox.local.invalidYear), this._leapYear(e.year ? e.year() : e) ? 13 : 12;
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                },
                daysInYear: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, Ox.local.invalidYear);
                    return e = t.year(), this.toJD(e === -1 ? 1 : e + 1, 7, 1) - this.toJD(e, 7, 1);
                },
                daysInMonth: function(e, t) {
                    return e.year && (t = e.month(), e = e.year()), this._validate(e, t, this.minDay, Ox.local.invalidMonth), t === 12 && this.leapYear(e) || t === 8 && M9(this.daysInYear(e), 10) === 5 ? 30 : t === 9 && M9(this.daysInYear(e), 10) === 3 ? 29 : this.daysPerMonth[t - 1];
                },
                weekDay: function(e, t, r) {
                    return this.dayOfWeek(e, t, r) !== 6;
                },
                extraInfo: function(e, t, r) {
                    var n = this._validate(e, t, r, Ox.local.invalidDate);
                    return {
                        yearType: (this.leapYear(n) ? "embolismic" : "common") + " " + [
                            "deficient",
                            "regular",
                            "complete"
                        ][this.daysInYear(n) % 10 - 3]
                    };
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, Ox.local.invalidDate);
                    e = n.year(), t = n.month(), r = n.day();
                    var i = e <= 0 ? e + 1 : e, a = this.jdEpoch + this._delay1(i) + this._delay2(i) + r + 1;
                    if (t < 7) {
                        for(var o = 7; o <= this.monthsInYear(e); o++)a += this.daysInMonth(e, o);
                        for(var o = 1; o < t; o++)a += this.daysInMonth(e, o);
                    } else for(var o = 7; o < t; o++)a += this.daysInMonth(e, o);
                    return a;
                },
                _delay1: function(e) {
                    var t = Math.floor((235 * e - 234) / 19), r = 12084 + 13753 * t, n = t * 29 + Math.floor(r / 25920);
                    return M9(3 * (n + 1), 7) < 3 && n++, n;
                },
                _delay2: function(e) {
                    var t = this._delay1(e - 1), r = this._delay1(e), n = this._delay1(e + 1);
                    return n - r === 356 ? 2 : r - t === 382 ? 1 : 0;
                },
                fromJD: function(e) {
                    e = Math.floor(e) + .5;
                    for(var t = Math.floor((e - this.jdEpoch) * 98496 / 35975351) - 1; e >= this.toJD(t === -1 ? 1 : t + 1, 7, 1);)t++;
                    for(var r = e < this.toJD(t, 1, 1) ? 7 : 1; e > this.toJD(t, r, this.daysInMonth(t, r));)r++;
                    var n = e - this.toJD(t, r, 1) + 1;
                    return this.newDate(t, r, n);
                }
            });
            function M9(e, t) {
                return e - t * Math.floor(e / t);
            }
            Ox.calendars.hebrew = rQ;
        });
        var R$e = ye(()=>{
            var oC = Sv(), mQt = bh();
            function iQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            iQ.prototype = new oC.baseCalendar;
            mQt(iQ.prototype, {
                name: "Islamic",
                jdEpoch: 19484395e-1,
                daysPerMonth: [
                    30,
                    29,
                    30,
                    29,
                    30,
                    29,
                    30,
                    29,
                    30,
                    29,
                    30,
                    29
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Islamic",
                        epochs: [
                            "BH",
                            "AH"
                        ],
                        monthNames: [
                            "Muharram",
                            "Safar",
                            "Rabi' al-awwal",
                            "Rabi' al-thani",
                            "Jumada al-awwal",
                            "Jumada al-thani",
                            "Rajab",
                            "Sha'aban",
                            "Ramadan",
                            "Shawwal",
                            "Dhu al-Qi'dah",
                            "Dhu al-Hijjah"
                        ],
                        monthNamesShort: [
                            "Muh",
                            "Saf",
                            "Rab1",
                            "Rab2",
                            "Jum1",
                            "Jum2",
                            "Raj",
                            "Sha'",
                            "Ram",
                            "Shaw",
                            "DhuQ",
                            "DhuH"
                        ],
                        dayNames: [
                            "Yawm al-ahad",
                            "Yawm al-ithnayn",
                            "Yawm ath-thulaathaa'",
                            "Yawm al-arbi'aa'",
                            "Yawm al-kham\u012Bs",
                            "Yawm al-jum'a",
                            "Yawm as-sabt"
                        ],
                        dayNamesShort: [
                            "Aha",
                            "Ith",
                            "Thu",
                            "Arb",
                            "Kha",
                            "Jum",
                            "Sab"
                        ],
                        dayNamesMin: [
                            "Ah",
                            "It",
                            "Th",
                            "Ar",
                            "Kh",
                            "Ju",
                            "Sa"
                        ],
                        digits: null,
                        dateFormat: "yyyy/mm/dd",
                        firstDay: 6,
                        isRTL: !1
                    }
                },
                leapYear: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, oC.local.invalidYear);
                    return (t.year() * 11 + 14) % 30 < 11;
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                },
                daysInYear: function(e) {
                    return this.leapYear(e) ? 355 : 354;
                },
                daysInMonth: function(e, t) {
                    var r = this._validate(e, t, this.minDay, oC.local.invalidMonth);
                    return this.daysPerMonth[r.month() - 1] + (r.month() === 12 && this.leapYear(r.year()) ? 1 : 0);
                },
                weekDay: function(e, t, r) {
                    return this.dayOfWeek(e, t, r) !== 5;
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, oC.local.invalidDate);
                    return e = n.year(), t = n.month(), r = n.day(), e = e <= 0 ? e + 1 : e, r + Math.ceil(29.5 * (t - 1)) + (e - 1) * 354 + Math.floor((3 + 11 * e) / 30) + this.jdEpoch - 1;
                },
                fromJD: function(e) {
                    e = Math.floor(e) + .5;
                    var t = Math.floor((30 * (e - this.jdEpoch) + 10646) / 10631);
                    t = t <= 0 ? t - 1 : t;
                    var r = Math.min(12, Math.ceil((e - 29 - this.toJD(t, 1, 1)) / 29.5) + 1), n = e - this.toJD(t, r, 1) + 1;
                    return this.newDate(t, r, n);
                }
            });
            oC.calendars.islamic = iQ;
        });
        var D$e = ye(()=>{
            var sC = Sv(), yQt = bh();
            function nQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            nQ.prototype = new sC.baseCalendar;
            yQt(nQ.prototype, {
                name: "Julian",
                jdEpoch: 17214235e-1,
                daysPerMonth: [
                    31,
                    28,
                    31,
                    30,
                    31,
                    30,
                    31,
                    31,
                    30,
                    31,
                    30,
                    31
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Julian",
                        epochs: [
                            "BC",
                            "AD"
                        ],
                        monthNames: [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ],
                        monthNamesShort: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ],
                        dayNames: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        dayNamesShort: [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        dayNamesMin: [
                            "Su",
                            "Mo",
                            "Tu",
                            "We",
                            "Th",
                            "Fr",
                            "Sa"
                        ],
                        digits: null,
                        dateFormat: "mm/dd/yyyy",
                        firstDay: 0,
                        isRTL: !1
                    }
                },
                leapYear: function(r) {
                    var t = this._validate(r, this.minMonth, this.minDay, sC.local.invalidYear), r = t.year() < 0 ? t.year() + 1 : t.year();
                    return r % 4 === 0;
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(4 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                },
                daysInMonth: function(e, t) {
                    var r = this._validate(e, t, this.minDay, sC.local.invalidMonth);
                    return this.daysPerMonth[r.month() - 1] + (r.month() === 2 && this.leapYear(r.year()) ? 1 : 0);
                },
                weekDay: function(e, t, r) {
                    return (this.dayOfWeek(e, t, r) || 7) < 6;
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, sC.local.invalidDate);
                    return e = n.year(), t = n.month(), r = n.day(), e < 0 && e++, t <= 2 && (e--, t += 12), Math.floor(365.25 * (e + 4716)) + Math.floor(30.6001 * (t + 1)) + r - 1524.5;
                },
                fromJD: function(e) {
                    var t = Math.floor(e + .5), r = t + 1524, n = Math.floor((r - 122.1) / 365.25), i = Math.floor(365.25 * n), a = Math.floor((r - i) / 30.6001), o = a - Math.floor(a < 14 ? 1 : 13), s = n - Math.floor(o > 2 ? 4716 : 4715), l = r - i - Math.floor(30.6001 * a);
                    return s <= 0 && s--, this.newDate(s, o, l);
                }
            });
            sC.calendars.julian = nQ;
        });
        var F$e = ye(()=>{
            var ug = Sv(), _Qt = bh();
            function oQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            oQ.prototype = new ug.baseCalendar;
            _Qt(oQ.prototype, {
                name: "Mayan",
                jdEpoch: 584282.5,
                hasYearZero: !0,
                minMonth: 0,
                firstMonth: 0,
                minDay: 0,
                regionalOptions: {
                    "": {
                        name: "Mayan",
                        epochs: [
                            "",
                            ""
                        ],
                        monthNames: [
                            "0",
                            "1",
                            "2",
                            "3",
                            "4",
                            "5",
                            "6",
                            "7",
                            "8",
                            "9",
                            "10",
                            "11",
                            "12",
                            "13",
                            "14",
                            "15",
                            "16",
                            "17"
                        ],
                        monthNamesShort: [
                            "0",
                            "1",
                            "2",
                            "3",
                            "4",
                            "5",
                            "6",
                            "7",
                            "8",
                            "9",
                            "10",
                            "11",
                            "12",
                            "13",
                            "14",
                            "15",
                            "16",
                            "17"
                        ],
                        dayNames: [
                            "0",
                            "1",
                            "2",
                            "3",
                            "4",
                            "5",
                            "6",
                            "7",
                            "8",
                            "9",
                            "10",
                            "11",
                            "12",
                            "13",
                            "14",
                            "15",
                            "16",
                            "17",
                            "18",
                            "19"
                        ],
                        dayNamesShort: [
                            "0",
                            "1",
                            "2",
                            "3",
                            "4",
                            "5",
                            "6",
                            "7",
                            "8",
                            "9",
                            "10",
                            "11",
                            "12",
                            "13",
                            "14",
                            "15",
                            "16",
                            "17",
                            "18",
                            "19"
                        ],
                        dayNamesMin: [
                            "0",
                            "1",
                            "2",
                            "3",
                            "4",
                            "5",
                            "6",
                            "7",
                            "8",
                            "9",
                            "10",
                            "11",
                            "12",
                            "13",
                            "14",
                            "15",
                            "16",
                            "17",
                            "18",
                            "19"
                        ],
                        digits: null,
                        dateFormat: "YYYY.m.d",
                        firstDay: 0,
                        isRTL: !1,
                        haabMonths: [
                            "Pop",
                            "Uo",
                            "Zip",
                            "Zotz",
                            "Tzec",
                            "Xul",
                            "Yaxkin",
                            "Mol",
                            "Chen",
                            "Yax",
                            "Zac",
                            "Ceh",
                            "Mac",
                            "Kankin",
                            "Muan",
                            "Pax",
                            "Kayab",
                            "Cumku",
                            "Uayeb"
                        ],
                        tzolkinMonths: [
                            "Imix",
                            "Ik",
                            "Akbal",
                            "Kan",
                            "Chicchan",
                            "Cimi",
                            "Manik",
                            "Lamat",
                            "Muluc",
                            "Oc",
                            "Chuen",
                            "Eb",
                            "Ben",
                            "Ix",
                            "Men",
                            "Cib",
                            "Caban",
                            "Etznab",
                            "Cauac",
                            "Ahau"
                        ]
                    }
                },
                leapYear: function(e) {
                    return this._validate(e, this.minMonth, this.minDay, ug.local.invalidYear), !1;
                },
                formatYear: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, ug.local.invalidYear);
                    e = t.year();
                    var r = Math.floor(e / 400);
                    e = e % 400, e += e < 0 ? 400 : 0;
                    var n = Math.floor(e / 20);
                    return r + "." + n + "." + e % 20;
                },
                forYear: function(e) {
                    if (e = e.split("."), e.length < 3) throw "Invalid Mayan year";
                    for(var t = 0, r = 0; r < e.length; r++){
                        var n = parseInt(e[r], 10);
                        if (Math.abs(n) > 19 || r > 0 && n < 0) throw "Invalid Mayan year";
                        t = t * 20 + n;
                    }
                    return t;
                },
                monthsInYear: function(e) {
                    return this._validate(e, this.minMonth, this.minDay, ug.local.invalidYear), 18;
                },
                weekOfYear: function(e, t, r) {
                    return this._validate(e, t, r, ug.local.invalidDate), 0;
                },
                daysInYear: function(e) {
                    return this._validate(e, this.minMonth, this.minDay, ug.local.invalidYear), 360;
                },
                daysInMonth: function(e, t) {
                    return this._validate(e, t, this.minDay, ug.local.invalidMonth), 20;
                },
                daysInWeek: function() {
                    return 5;
                },
                dayOfWeek: function(e, t, r) {
                    var n = this._validate(e, t, r, ug.local.invalidDate);
                    return n.day();
                },
                weekDay: function(e, t, r) {
                    return this._validate(e, t, r, ug.local.invalidDate), !0;
                },
                extraInfo: function(e, t, r) {
                    var n = this._validate(e, t, r, ug.local.invalidDate), i = n.toJD(), a = this._toHaab(i), o = this._toTzolkin(i);
                    return {
                        haabMonthName: this.local.haabMonths[a[0] - 1],
                        haabMonth: a[0],
                        haabDay: a[1],
                        tzolkinDayName: this.local.tzolkinMonths[o[0] - 1],
                        tzolkinDay: o[0],
                        tzolkinTrecena: o[1]
                    };
                },
                _toHaab: function(e) {
                    e -= this.jdEpoch;
                    var t = aQ(e + 8 + 340, 365);
                    return [
                        Math.floor(t / 20) + 1,
                        aQ(t, 20)
                    ];
                },
                _toTzolkin: function(e) {
                    return e -= this.jdEpoch, [
                        z$e(e + 20, 20),
                        z$e(e + 4, 13)
                    ];
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, ug.local.invalidDate);
                    return n.day() + n.month() * 20 + n.year() * 360 + this.jdEpoch;
                },
                fromJD: function(e) {
                    e = Math.floor(e) + .5 - this.jdEpoch;
                    var t = Math.floor(e / 360);
                    e = e % 360, e += e < 0 ? 360 : 0;
                    var r = Math.floor(e / 20), n = e % 20;
                    return this.newDate(t, r, n);
                }
            });
            function aQ(e, t) {
                return e - t * Math.floor(e / t);
            }
            function z$e(e, t) {
                return aQ(e - 1, t) + 1;
            }
            ug.calendars.mayan = oQ;
        });
        var O$e = ye(()=>{
            var bw = Sv(), xQt = bh();
            function sQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            sQ.prototype = new bw.baseCalendar;
            var q$e = bw.instance("gregorian");
            xQt(sQ.prototype, {
                name: "Nanakshahi",
                jdEpoch: 22576735e-1,
                daysPerMonth: [
                    31,
                    31,
                    31,
                    31,
                    31,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30,
                    30
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Nanakshahi",
                        epochs: [
                            "BN",
                            "AN"
                        ],
                        monthNames: [
                            "Chet",
                            "Vaisakh",
                            "Jeth",
                            "Harh",
                            "Sawan",
                            "Bhadon",
                            "Assu",
                            "Katak",
                            "Maghar",
                            "Poh",
                            "Magh",
                            "Phagun"
                        ],
                        monthNamesShort: [
                            "Che",
                            "Vai",
                            "Jet",
                            "Har",
                            "Saw",
                            "Bha",
                            "Ass",
                            "Kat",
                            "Mgr",
                            "Poh",
                            "Mgh",
                            "Pha"
                        ],
                        dayNames: [
                            "Somvaar",
                            "Mangalvar",
                            "Budhvaar",
                            "Veervaar",
                            "Shukarvaar",
                            "Sanicharvaar",
                            "Etvaar"
                        ],
                        dayNamesShort: [
                            "Som",
                            "Mangal",
                            "Budh",
                            "Veer",
                            "Shukar",
                            "Sanichar",
                            "Et"
                        ],
                        dayNamesMin: [
                            "So",
                            "Ma",
                            "Bu",
                            "Ve",
                            "Sh",
                            "Sa",
                            "Et"
                        ],
                        digits: null,
                        dateFormat: "dd-mm-yyyy",
                        firstDay: 0,
                        isRTL: !1
                    }
                },
                leapYear: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, bw.local.invalidYear || bw.regionalOptions[""].invalidYear);
                    return q$e.leapYear(t.year() + (t.year() < 1 ? 1 : 0) + 1469);
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(1 - (n.dayOfWeek() || 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                },
                daysInMonth: function(e, t) {
                    var r = this._validate(e, t, this.minDay, bw.local.invalidMonth);
                    return this.daysPerMonth[r.month() - 1] + (r.month() === 12 && this.leapYear(r.year()) ? 1 : 0);
                },
                weekDay: function(e, t, r) {
                    return (this.dayOfWeek(e, t, r) || 7) < 6;
                },
                toJD: function(i, t, r) {
                    var n = this._validate(i, t, r, bw.local.invalidMonth), i = n.year();
                    i < 0 && i++;
                    for(var a = n.day(), o = 1; o < n.month(); o++)a += this.daysPerMonth[o - 1];
                    return a + q$e.toJD(i + 1468, 3, 13);
                },
                fromJD: function(e) {
                    e = Math.floor(e + .5);
                    for(var t = Math.floor((e - (this.jdEpoch - 1)) / 366); e >= this.toJD(t + 1, 1, 1);)t++;
                    for(var r = e - Math.floor(this.toJD(t, 1, 1) + .5) + 1, n = 1; r > this.daysInMonth(t, n);)r -= this.daysInMonth(t, n), n++;
                    return this.newDate(t, n, r);
                }
            });
            bw.calendars.nanakshahi = sQ;
        });
        var B$e = ye(()=>{
            var ww = Sv(), bQt = bh();
            function lQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            lQ.prototype = new ww.baseCalendar;
            bQt(lQ.prototype, {
                name: "Nepali",
                jdEpoch: 17007095e-1,
                daysPerMonth: [
                    31,
                    31,
                    32,
                    32,
                    31,
                    30,
                    30,
                    29,
                    30,
                    29,
                    30,
                    30
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                daysPerYear: 365,
                regionalOptions: {
                    "": {
                        name: "Nepali",
                        epochs: [
                            "BBS",
                            "ABS"
                        ],
                        monthNames: [
                            "Baisakh",
                            "Jestha",
                            "Ashadh",
                            "Shrawan",
                            "Bhadra",
                            "Ashwin",
                            "Kartik",
                            "Mangsir",
                            "Paush",
                            "Mangh",
                            "Falgun",
                            "Chaitra"
                        ],
                        monthNamesShort: [
                            "Bai",
                            "Je",
                            "As",
                            "Shra",
                            "Bha",
                            "Ash",
                            "Kar",
                            "Mang",
                            "Pau",
                            "Ma",
                            "Fal",
                            "Chai"
                        ],
                        dayNames: [
                            "Aaitabaar",
                            "Sombaar",
                            "Manglbaar",
                            "Budhabaar",
                            "Bihibaar",
                            "Shukrabaar",
                            "Shanibaar"
                        ],
                        dayNamesShort: [
                            "Aaita",
                            "Som",
                            "Mangl",
                            "Budha",
                            "Bihi",
                            "Shukra",
                            "Shani"
                        ],
                        dayNamesMin: [
                            "Aai",
                            "So",
                            "Man",
                            "Bu",
                            "Bi",
                            "Shu",
                            "Sha"
                        ],
                        digits: null,
                        dateFormat: "dd/mm/yyyy",
                        firstDay: 1,
                        isRTL: !1
                    }
                },
                leapYear: function(e) {
                    return this.daysInYear(e) !== this.daysPerYear;
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                },
                daysInYear: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, ww.local.invalidYear);
                    if (e = t.year(), typeof this.NEPALI_CALENDAR_DATA[e] == "undefined") return this.daysPerYear;
                    for(var r = 0, n = this.minMonth; n <= 12; n++)r += this.NEPALI_CALENDAR_DATA[e][n];
                    return r;
                },
                daysInMonth: function(e, t) {
                    return e.year && (t = e.month(), e = e.year()), this._validate(e, t, this.minDay, ww.local.invalidMonth), typeof this.NEPALI_CALENDAR_DATA[e] == "undefined" ? this.daysPerMonth[t - 1] : this.NEPALI_CALENDAR_DATA[e][t];
                },
                weekDay: function(e, t, r) {
                    return this.dayOfWeek(e, t, r) !== 6;
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, ww.local.invalidDate);
                    e = n.year(), t = n.month(), r = n.day();
                    var i = ww.instance(), a = 0, o = t, s = e;
                    this._createMissingCalendarData(e);
                    var l = e - (o > 9 || o === 9 && r >= this.NEPALI_CALENDAR_DATA[s][0] ? 56 : 57);
                    for(t !== 9 && (a = r, o--); o !== 9;)o <= 0 && (o = 12, s--), a += this.NEPALI_CALENDAR_DATA[s][o], o--;
                    return t === 9 ? (a += r - this.NEPALI_CALENDAR_DATA[s][0], a < 0 && (a += i.daysInYear(l))) : a += this.NEPALI_CALENDAR_DATA[s][9] - this.NEPALI_CALENDAR_DATA[s][0], i.newDate(l, 1, 1).add(a, "d").toJD();
                },
                fromJD: function(e) {
                    var t = ww.instance(), r = t.fromJD(e), n = r.year(), i = r.dayOfYear(), a = n + 56;
                    this._createMissingCalendarData(a);
                    for(var o = 9, s = this.NEPALI_CALENDAR_DATA[a][0], l = this.NEPALI_CALENDAR_DATA[a][o] - s + 1; i > l;)o++, o > 12 && (o = 1, a++), l += this.NEPALI_CALENDAR_DATA[a][o];
                    var u = this.NEPALI_CALENDAR_DATA[a][o] - (l - i);
                    return this.newDate(a, o, u);
                },
                _createMissingCalendarData: function(e) {
                    var t = this.daysPerMonth.slice(0);
                    t.unshift(17);
                    for(var r = e - 1; r < e + 2; r++)typeof this.NEPALI_CALENDAR_DATA[r] == "undefined" && (this.NEPALI_CALENDAR_DATA[r] = t);
                },
                NEPALI_CALENDAR_DATA: {
                    1970: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1971: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        32,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1972: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        30
                    ],
                    1973: [
                        19,
                        30,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    1974: [
                        19,
                        31,
                        31,
                        32,
                        30,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1975: [
                        18,
                        31,
                        31,
                        32,
                        32,
                        30,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1976: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    1977: [
                        18,
                        31,
                        32,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    1978: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1979: [
                        18,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1980: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    1981: [
                        18,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        30,
                        29,
                        30,
                        30
                    ],
                    1982: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1983: [
                        18,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1984: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    1985: [
                        18,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        30,
                        29,
                        30,
                        30
                    ],
                    1986: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1987: [
                        18,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1988: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    1989: [
                        18,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1990: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1991: [
                        18,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1992: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    1993: [
                        18,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1994: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1995: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        30
                    ],
                    1996: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    1997: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1998: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    1999: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2e3: [
                        17,
                        30,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    2001: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2002: [
                        18,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2003: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2004: [
                        17,
                        30,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    2005: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2006: [
                        18,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2007: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2008: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        30,
                        29,
                        29,
                        31
                    ],
                    2009: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2010: [
                        18,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2011: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2012: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        30,
                        29,
                        30,
                        30
                    ],
                    2013: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2014: [
                        18,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2015: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2016: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        30,
                        29,
                        30,
                        30
                    ],
                    2017: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2018: [
                        18,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2019: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    2020: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2021: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2022: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        30
                    ],
                    2023: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    2024: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2025: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2026: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2027: [
                        17,
                        30,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    2028: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2029: [
                        18,
                        31,
                        31,
                        32,
                        31,
                        32,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2030: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        30,
                        30,
                        30,
                        31
                    ],
                    2031: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        31,
                        31,
                        31,
                        31,
                        31,
                        31,
                        31
                    ],
                    2032: [
                        17,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32,
                        32
                    ],
                    2033: [
                        18,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2034: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2035: [
                        17,
                        30,
                        32,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        30,
                        29,
                        29,
                        31
                    ],
                    2036: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2037: [
                        18,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2038: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2039: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        30,
                        29,
                        30,
                        30
                    ],
                    2040: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2041: [
                        18,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2042: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2043: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        30,
                        29,
                        30,
                        30
                    ],
                    2044: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2045: [
                        18,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2046: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2047: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2048: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2049: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        30
                    ],
                    2050: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    2051: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2052: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2053: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        30
                    ],
                    2054: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    2055: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        30,
                        29,
                        30
                    ],
                    2056: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        32,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2057: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2058: [
                        17,
                        30,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    2059: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2060: [
                        17,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2061: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2062: [
                        17,
                        30,
                        32,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    2063: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2064: [
                        17,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2065: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2066: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        30,
                        29,
                        29,
                        31
                    ],
                    2067: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2068: [
                        17,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2069: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2070: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        29,
                        30,
                        30,
                        29,
                        30,
                        30
                    ],
                    2071: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2072: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2073: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        31
                    ],
                    2074: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2075: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2076: [
                        16,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        30
                    ],
                    2077: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        29,
                        31
                    ],
                    2078: [
                        17,
                        31,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2079: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2080: [
                        16,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        29,
                        30,
                        30
                    ],
                    2081: [
                        17,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2082: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2083: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2084: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2085: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        31,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2086: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2087: [
                        16,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2088: [
                        16,
                        30,
                        31,
                        32,
                        32,
                        30,
                        31,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2089: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2090: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2091: [
                        16,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2092: [
                        16,
                        31,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2093: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2094: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2095: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        30,
                        30,
                        30,
                        30
                    ],
                    2096: [
                        17,
                        30,
                        31,
                        32,
                        32,
                        31,
                        30,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ],
                    2097: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        31,
                        30,
                        30,
                        30,
                        29,
                        30,
                        30,
                        30
                    ],
                    2098: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        29,
                        30,
                        29,
                        30,
                        30,
                        31
                    ],
                    2099: [
                        17,
                        31,
                        31,
                        32,
                        31,
                        31,
                        31,
                        30,
                        29,
                        29,
                        30,
                        30,
                        30
                    ],
                    2100: [
                        17,
                        31,
                        32,
                        31,
                        32,
                        30,
                        31,
                        30,
                        29,
                        30,
                        29,
                        30,
                        30
                    ]
                }
            });
            ww.calendars.nepali = lQ;
        });
        var N$e = ye(()=>{
            var $A = Sv(), wQt = bh();
            function E9(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            E9.prototype = new $A.baseCalendar;
            wQt(E9.prototype, {
                name: "Persian",
                jdEpoch: 19483205e-1,
                daysPerMonth: [
                    31,
                    31,
                    31,
                    31,
                    31,
                    31,
                    30,
                    30,
                    30,
                    30,
                    30,
                    29
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Persian",
                        epochs: [
                            "BP",
                            "AP"
                        ],
                        monthNames: [
                            "Farvardin",
                            "Ordibehesht",
                            "Khordad",
                            "Tir",
                            "Mordad",
                            "Shahrivar",
                            "Mehr",
                            "Aban",
                            "Azar",
                            "Day",
                            "Bahman",
                            "Esfand"
                        ],
                        monthNamesShort: [
                            "Far",
                            "Ord",
                            "Kho",
                            "Tir",
                            "Mor",
                            "Sha",
                            "Meh",
                            "Aba",
                            "Aza",
                            "Day",
                            "Bah",
                            "Esf"
                        ],
                        dayNames: [
                            "Yekshambe",
                            "Doshambe",
                            "Seshambe",
                            "Ch\xE6harshambe",
                            "Panjshambe",
                            "Jom'e",
                            "Shambe"
                        ],
                        dayNamesShort: [
                            "Yek",
                            "Do",
                            "Se",
                            "Ch\xE6",
                            "Panj",
                            "Jom",
                            "Sha"
                        ],
                        dayNamesMin: [
                            "Ye",
                            "Do",
                            "Se",
                            "Ch",
                            "Pa",
                            "Jo",
                            "Sh"
                        ],
                        digits: null,
                        dateFormat: "yyyy/mm/dd",
                        firstDay: 6,
                        isRTL: !1
                    }
                },
                leapYear: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, $A.local.invalidYear);
                    return ((t.year() - (t.year() > 0 ? 474 : 473)) % 2820 + 474 + 38) * 682 % 2816 < 682;
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(-((n.dayOfWeek() + 1) % 7), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                },
                daysInMonth: function(e, t) {
                    var r = this._validate(e, t, this.minDay, $A.local.invalidMonth);
                    return this.daysPerMonth[r.month() - 1] + (r.month() === 12 && this.leapYear(r.year()) ? 1 : 0);
                },
                weekDay: function(e, t, r) {
                    return this.dayOfWeek(e, t, r) !== 5;
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, $A.local.invalidDate);
                    e = n.year(), t = n.month(), r = n.day();
                    var i = e - (e >= 0 ? 474 : 473), a = 474 + uQ(i, 2820);
                    return r + (t <= 7 ? (t - 1) * 31 : (t - 1) * 30 + 6) + Math.floor((a * 682 - 110) / 2816) + (a - 1) * 365 + Math.floor(i / 2820) * 1029983 + this.jdEpoch - 1;
                },
                fromJD: function(e) {
                    e = Math.floor(e) + .5;
                    var t = e - this.toJD(475, 1, 1), r = Math.floor(t / 1029983), n = uQ(t, 1029983), i = 2820;
                    if (n !== 1029982) {
                        var a = Math.floor(n / 366), o = uQ(n, 366);
                        i = Math.floor((2134 * a + 2816 * o + 2815) / 1028522) + a + 1;
                    }
                    var s = i + 2820 * r + 474;
                    s = s <= 0 ? s - 1 : s;
                    var l = e - this.toJD(s, 1, 1) + 1, u = l <= 186 ? Math.ceil(l / 31) : Math.ceil((l - 6) / 30), c = e - this.toJD(s, u, 1) + 1;
                    return this.newDate(s, u, c);
                }
            });
            function uQ(e, t) {
                return e - t * Math.floor(e / t);
            }
            $A.calendars.persian = E9;
            $A.calendars.jalali = E9;
        });
        var U$e = ye(()=>{
            var Tw = Sv(), TQt = bh(), k9 = Tw.instance();
            function cQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            cQ.prototype = new Tw.baseCalendar;
            TQt(cQ.prototype, {
                name: "Taiwan",
                jdEpoch: 24194025e-1,
                yearsOffset: 1911,
                daysPerMonth: [
                    31,
                    28,
                    31,
                    30,
                    31,
                    30,
                    31,
                    31,
                    30,
                    31,
                    30,
                    31
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Taiwan",
                        epochs: [
                            "BROC",
                            "ROC"
                        ],
                        monthNames: [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ],
                        monthNamesShort: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ],
                        dayNames: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        dayNamesShort: [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        dayNamesMin: [
                            "Su",
                            "Mo",
                            "Tu",
                            "We",
                            "Th",
                            "Fr",
                            "Sa"
                        ],
                        digits: null,
                        dateFormat: "yyyy/mm/dd",
                        firstDay: 1,
                        isRTL: !1
                    }
                },
                leapYear: function(r) {
                    var t = this._validate(r, this.minMonth, this.minDay, Tw.local.invalidYear), r = this._t2gYear(t.year());
                    return k9.leapYear(r);
                },
                weekOfYear: function(i, t, r) {
                    var n = this._validate(i, this.minMonth, this.minDay, Tw.local.invalidYear), i = this._t2gYear(n.year());
                    return k9.weekOfYear(i, n.month(), n.day());
                },
                daysInMonth: function(e, t) {
                    var r = this._validate(e, t, this.minDay, Tw.local.invalidMonth);
                    return this.daysPerMonth[r.month() - 1] + (r.month() === 2 && this.leapYear(r.year()) ? 1 : 0);
                },
                weekDay: function(e, t, r) {
                    return (this.dayOfWeek(e, t, r) || 7) < 6;
                },
                toJD: function(i, t, r) {
                    var n = this._validate(i, t, r, Tw.local.invalidDate), i = this._t2gYear(n.year());
                    return k9.toJD(i, n.month(), n.day());
                },
                fromJD: function(e) {
                    var t = k9.fromJD(e), r = this._g2tYear(t.year());
                    return this.newDate(r, t.month(), t.day());
                },
                _t2gYear: function(e) {
                    return e + this.yearsOffset + (e >= -this.yearsOffset && e <= -1 ? 1 : 0);
                },
                _g2tYear: function(e) {
                    return e - this.yearsOffset - (e >= 1 && e <= this.yearsOffset ? 1 : 0);
                }
            });
            Tw.calendars.taiwan = cQ;
        });
        var V$e = ye(()=>{
            var Aw = Sv(), AQt = bh(), C9 = Aw.instance();
            function fQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            fQ.prototype = new Aw.baseCalendar;
            AQt(fQ.prototype, {
                name: "Thai",
                jdEpoch: 15230985e-1,
                yearsOffset: 543,
                daysPerMonth: [
                    31,
                    28,
                    31,
                    30,
                    31,
                    30,
                    31,
                    31,
                    30,
                    31,
                    30,
                    31
                ],
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Thai",
                        epochs: [
                            "BBE",
                            "BE"
                        ],
                        monthNames: [
                            "January",
                            "February",
                            "March",
                            "April",
                            "May",
                            "June",
                            "July",
                            "August",
                            "September",
                            "October",
                            "November",
                            "December"
                        ],
                        monthNamesShort: [
                            "Jan",
                            "Feb",
                            "Mar",
                            "Apr",
                            "May",
                            "Jun",
                            "Jul",
                            "Aug",
                            "Sep",
                            "Oct",
                            "Nov",
                            "Dec"
                        ],
                        dayNames: [
                            "Sunday",
                            "Monday",
                            "Tuesday",
                            "Wednesday",
                            "Thursday",
                            "Friday",
                            "Saturday"
                        ],
                        dayNamesShort: [
                            "Sun",
                            "Mon",
                            "Tue",
                            "Wed",
                            "Thu",
                            "Fri",
                            "Sat"
                        ],
                        dayNamesMin: [
                            "Su",
                            "Mo",
                            "Tu",
                            "We",
                            "Th",
                            "Fr",
                            "Sa"
                        ],
                        digits: null,
                        dateFormat: "dd/mm/yyyy",
                        firstDay: 0,
                        isRTL: !1
                    }
                },
                leapYear: function(r) {
                    var t = this._validate(r, this.minMonth, this.minDay, Aw.local.invalidYear), r = this._t2gYear(t.year());
                    return C9.leapYear(r);
                },
                weekOfYear: function(i, t, r) {
                    var n = this._validate(i, this.minMonth, this.minDay, Aw.local.invalidYear), i = this._t2gYear(n.year());
                    return C9.weekOfYear(i, n.month(), n.day());
                },
                daysInMonth: function(e, t) {
                    var r = this._validate(e, t, this.minDay, Aw.local.invalidMonth);
                    return this.daysPerMonth[r.month() - 1] + (r.month() === 2 && this.leapYear(r.year()) ? 1 : 0);
                },
                weekDay: function(e, t, r) {
                    return (this.dayOfWeek(e, t, r) || 7) < 6;
                },
                toJD: function(i, t, r) {
                    var n = this._validate(i, t, r, Aw.local.invalidDate), i = this._t2gYear(n.year());
                    return C9.toJD(i, n.month(), n.day());
                },
                fromJD: function(e) {
                    var t = C9.fromJD(e), r = this._g2tYear(t.year());
                    return this.newDate(r, t.month(), t.day());
                },
                _t2gYear: function(e) {
                    return e - this.yearsOffset - (e >= 1 && e <= this.yearsOffset ? 1 : 0);
                },
                _g2tYear: function(e) {
                    return e + this.yearsOffset + (e >= -this.yearsOffset && e <= -1 ? 1 : 0);
                }
            });
            Aw.calendars.thai = fQ;
        });
        var H$e = ye(()=>{
            var Sw = Sv(), SQt = bh();
            function hQ(e) {
                this.local = this.regionalOptions[e || ""] || this.regionalOptions[""];
            }
            hQ.prototype = new Sw.baseCalendar;
            SQt(hQ.prototype, {
                name: "UmmAlQura",
                hasYearZero: !1,
                minMonth: 1,
                firstMonth: 1,
                minDay: 1,
                regionalOptions: {
                    "": {
                        name: "Umm al-Qura",
                        epochs: [
                            "BH",
                            "AH"
                        ],
                        monthNames: [
                            "Al-Muharram",
                            "Safar",
                            "Rabi' al-awwal",
                            "Rabi' Al-Thani",
                            "Jumada Al-Awwal",
                            "Jumada Al-Thani",
                            "Rajab",
                            "Sha'aban",
                            "Ramadan",
                            "Shawwal",
                            "Dhu al-Qi'dah",
                            "Dhu al-Hijjah"
                        ],
                        monthNamesShort: [
                            "Muh",
                            "Saf",
                            "Rab1",
                            "Rab2",
                            "Jum1",
                            "Jum2",
                            "Raj",
                            "Sha'",
                            "Ram",
                            "Shaw",
                            "DhuQ",
                            "DhuH"
                        ],
                        dayNames: [
                            "Yawm al-Ahad",
                            "Yawm al-Ithnain",
                            "Yawm al-Thal\u0101th\u0101\u2019",
                            "Yawm al-Arba\u2018\u0101\u2019",
                            "Yawm al-Kham\u012Bs",
                            "Yawm al-Jum\u2018a",
                            "Yawm al-Sabt"
                        ],
                        dayNamesMin: [
                            "Ah",
                            "Ith",
                            "Th",
                            "Ar",
                            "Kh",
                            "Ju",
                            "Sa"
                        ],
                        digits: null,
                        dateFormat: "yyyy/mm/dd",
                        firstDay: 6,
                        isRTL: !0
                    }
                },
                leapYear: function(e) {
                    var t = this._validate(e, this.minMonth, this.minDay, Sw.local.invalidYear);
                    return this.daysInYear(t.year()) === 355;
                },
                weekOfYear: function(e, t, r) {
                    var n = this.newDate(e, t, r);
                    return n.add(-n.dayOfWeek(), "d"), Math.floor((n.dayOfYear() - 1) / 7) + 1;
                },
                daysInYear: function(e) {
                    for(var t = 0, r = 1; r <= 12; r++)t += this.daysInMonth(e, r);
                    return t;
                },
                daysInMonth: function(e, t) {
                    for(var r = this._validate(e, t, this.minDay, Sw.local.invalidMonth), n = r.toJD() - 24e5 + .5, i = 0, a = 0; a < Bx.length; a++){
                        if (Bx[a] > n) return Bx[i] - Bx[i - 1];
                        i++;
                    }
                    return 30;
                },
                weekDay: function(e, t, r) {
                    return this.dayOfWeek(e, t, r) !== 5;
                },
                toJD: function(e, t, r) {
                    var n = this._validate(e, t, r, Sw.local.invalidDate), i = 12 * (n.year() - 1) + n.month() - 15292, a = n.day() + Bx[i - 1] - 1;
                    return a + 24e5 - .5;
                },
                fromJD: function(e) {
                    for(var t = e - 24e5 + .5, r = 0, n = 0; n < Bx.length && !(Bx[n] > t); n++)r++;
                    var i = r + 15292, a = Math.floor((i - 1) / 12), o = a + 1, s = i - 12 * a, l = t - Bx[r - 1] + 1;
                    return this.newDate(o, s, l);
                },
                isValid: function(e, t, r) {
                    var n = Sw.baseCalendar.prototype.isValid.apply(this, arguments);
                    return n && (e = e.year != null ? e.year : e, n = e >= 1276 && e <= 1500), n;
                },
                _validate: function(e, t, r, n) {
                    var i = Sw.baseCalendar.prototype._validate.apply(this, arguments);
                    if (i.year < 1276 || i.year > 1500) throw n.replace(/\{0\}/, this.local.name);
                    return i;
                }
            });
            Sw.calendars.ummalqura = hQ;
            var Bx = [
                20,
                50,
                79,
                109,
                138,
                168,
                197,
                227,
                256,
                286,
                315,
                345,
                374,
                404,
                433,
                463,
                492,
                522,
                551,
                581,
                611,
                641,
                670,
                700,
                729,
                759,
                788,
                818,
                847,
                877,
                906,
                936,
                965,
                995,
                1024,
                1054,
                1083,
                1113,
                1142,
                1172,
                1201,
                1231,
                1260,
                1290,
                1320,
                1350,
                1379,
                1409,
                1438,
                1468,
                1497,
                1527,
                1556,
                1586,
                1615,
                1645,
                1674,
                1704,
                1733,
                1763,
                1792,
                1822,
                1851,
                1881,
                1910,
                1940,
                1969,
                1999,
                2028,
                2058,
                2087,
                2117,
                2146,
                2176,
                2205,
                2235,
                2264,
                2294,
                2323,
                2353,
                2383,
                2413,
                2442,
                2472,
                2501,
                2531,
                2560,
                2590,
                2619,
                2649,
                2678,
                2708,
                2737,
                2767,
                2796,
                2826,
                2855,
                2885,
                2914,
                2944,
                2973,
                3003,
                3032,
                3062,
                3091,
                3121,
                3150,
                3180,
                3209,
                3239,
                3268,
                3298,
                3327,
                3357,
                3386,
                3416,
                3446,
                3476,
                3505,
                3535,
                3564,
                3594,
                3623,
                3653,
                3682,
                3712,
                3741,
                3771,
                3800,
                3830,
                3859,
                3889,
                3918,
                3948,
                3977,
                4007,
                4036,
                4066,
                4095,
                4125,
                4155,
                4185,
                4214,
                4244,
                4273,
                4303,
                4332,
                4362,
                4391,
                4421,
                4450,
                4480,
                4509,
                4539,
                4568,
                4598,
                4627,
                4657,
                4686,
                4716,
                4745,
                4775,
                4804,
                4834,
                4863,
                4893,
                4922,
                4952,
                4981,
                5011,
                5040,
                5070,
                5099,
                5129,
                5158,
                5188,
                5218,
                5248,
                5277,
                5307,
                5336,
                5366,
                5395,
                5425,
                5454,
                5484,
                5513,
                5543,
                5572,
                5602,
                5631,
                5661,
                5690,
                5720,
                5749,
                5779,
                5808,
                5838,
                5867,
                5897,
                5926,
                5956,
                5985,
                6015,
                6044,
                6074,
                6103,
                6133,
                6162,
                6192,
                6221,
                6251,
                6281,
                6311,
                6340,
                6370,
                6399,
                6429,
                6458,
                6488,
                6517,
                6547,
                6576,
                6606,
                6635,
                6665,
                6694,
                6724,
                6753,
                6783,
                6812,
                6842,
                6871,
                6901,
                6930,
                6960,
                6989,
                7019,
                7048,
                7078,
                7107,
                7137,
                7166,
                7196,
                7225,
                7255,
                7284,
                7314,
                7344,
                7374,
                7403,
                7433,
                7462,
                7492,
                7521,
                7551,
                7580,
                7610,
                7639,
                7669,
                7698,
                7728,
                7757,
                7787,
                7816,
                7846,
                7875,
                7905,
                7934,
                7964,
                7993,
                8023,
                8053,
                8083,
                8112,
                8142,
                8171,
                8201,
                8230,
                8260,
                8289,
                8319,
                8348,
                8378,
                8407,
                8437,
                8466,
                8496,
                8525,
                8555,
                8584,
                8614,
                8643,
                8673,
                8702,
                8732,
                8761,
                8791,
                8821,
                8850,
                8880,
                8909,
                8938,
                8968,
                8997,
                9027,
                9056,
                9086,
                9115,
                9145,
                9175,
                9205,
                9234,
                9264,
                9293,
                9322,
                9352,
                9381,
                9410,
                9440,
                9470,
                9499,
                9529,
                9559,
                9589,
                9618,
                9648,
                9677,
                9706,
                9736,
                9765,
                9794,
                9824,
                9853,
                9883,
                9913,
                9943,
                9972,
                10002,
                10032,
                10061,
                10090,
                10120,
                10149,
                10178,
                10208,
                10237,
                10267,
                10297,
                10326,
                10356,
                10386,
                10415,
                10445,
                10474,
                10504,
                10533,
                10562,
                10592,
                10621,
                10651,
                10680,
                10710,
                10740,
                10770,
                10799,
                10829,
                10858,
                10888,
                10917,
                10947,
                10976,
                11005,
                11035,
                11064,
                11094,
                11124,
                11153,
                11183,
                11213,
                11242,
                11272,
                11301,
                11331,
                11360,
                11389,
                11419,
                11448,
                11478,
                11507,
                11537,
                11567,
                11596,
                11626,
                11655,
                11685,
                11715,
                11744,
                11774,
                11803,
                11832,
                11862,
                11891,
                11921,
                11950,
                11980,
                12010,
                12039,
                12069,
                12099,
                12128,
                12158,
                12187,
                12216,
                12246,
                12275,
                12304,
                12334,
                12364,
                12393,
                12423,
                12453,
                12483,
                12512,
                12542,
                12571,
                12600,
                12630,
                12659,
                12688,
                12718,
                12747,
                12777,
                12807,
                12837,
                12866,
                12896,
                12926,
                12955,
                12984,
                13014,
                13043,
                13072,
                13102,
                13131,
                13161,
                13191,
                13220,
                13250,
                13280,
                13310,
                13339,
                13368,
                13398,
                13427,
                13456,
                13486,
                13515,
                13545,
                13574,
                13604,
                13634,
                13664,
                13693,
                13723,
                13752,
                13782,
                13811,
                13840,
                13870,
                13899,
                13929,
                13958,
                13988,
                14018,
                14047,
                14077,
                14107,
                14136,
                14166,
                14195,
                14224,
                14254,
                14283,
                14313,
                14342,
                14372,
                14401,
                14431,
                14461,
                14490,
                14520,
                14550,
                14579,
                14609,
                14638,
                14667,
                14697,
                14726,
                14756,
                14785,
                14815,
                14844,
                14874,
                14904,
                14933,
                14963,
                14993,
                15021,
                15051,
                15081,
                15110,
                15140,
                15169,
                15199,
                15228,
                15258,
                15287,
                15317,
                15347,
                15377,
                15406,
                15436,
                15465,
                15494,
                15524,
                15553,
                15582,
                15612,
                15641,
                15671,
                15701,
                15731,
                15760,
                15790,
                15820,
                15849,
                15878,
                15908,
                15937,
                15966,
                15996,
                16025,
                16055,
                16085,
                16114,
                16144,
                16174,
                16204,
                16233,
                16262,
                16292,
                16321,
                16350,
                16380,
                16409,
                16439,
                16468,
                16498,
                16528,
                16558,
                16587,
                16617,
                16646,
                16676,
                16705,
                16734,
                16764,
                16793,
                16823,
                16852,
                16882,
                16912,
                16941,
                16971,
                17001,
                17030,
                17060,
                17089,
                17118,
                17148,
                17177,
                17207,
                17236,
                17266,
                17295,
                17325,
                17355,
                17384,
                17414,
                17444,
                17473,
                17502,
                17532,
                17561,
                17591,
                17620,
                17650,
                17679,
                17709,
                17738,
                17768,
                17798,
                17827,
                17857,
                17886,
                17916,
                17945,
                17975,
                18004,
                18034,
                18063,
                18093,
                18122,
                18152,
                18181,
                18211,
                18241,
                18270,
                18300,
                18330,
                18359,
                18388,
                18418,
                18447,
                18476,
                18506,
                18535,
                18565,
                18595,
                18625,
                18654,
                18684,
                18714,
                18743,
                18772,
                18802,
                18831,
                18860,
                18890,
                18919,
                18949,
                18979,
                19008,
                19038,
                19068,
                19098,
                19127,
                19156,
                19186,
                19215,
                19244,
                19274,
                19303,
                19333,
                19362,
                19392,
                19422,
                19452,
                19481,
                19511,
                19540,
                19570,
                19599,
                19628,
                19658,
                19687,
                19717,
                19746,
                19776,
                19806,
                19836,
                19865,
                19895,
                19924,
                19954,
                19983,
                20012,
                20042,
                20071,
                20101,
                20130,
                20160,
                20190,
                20219,
                20249,
                20279,
                20308,
                20338,
                20367,
                20396,
                20426,
                20455,
                20485,
                20514,
                20544,
                20573,
                20603,
                20633,
                20662,
                20692,
                20721,
                20751,
                20780,
                20810,
                20839,
                20869,
                20898,
                20928,
                20957,
                20987,
                21016,
                21046,
                21076,
                21105,
                21135,
                21164,
                21194,
                21223,
                21253,
                21282,
                21312,
                21341,
                21371,
                21400,
                21430,
                21459,
                21489,
                21519,
                21548,
                21578,
                21607,
                21637,
                21666,
                21696,
                21725,
                21754,
                21784,
                21813,
                21843,
                21873,
                21902,
                21932,
                21962,
                21991,
                22021,
                22050,
                22080,
                22109,
                22138,
                22168,
                22197,
                22227,
                22256,
                22286,
                22316,
                22346,
                22375,
                22405,
                22434,
                22464,
                22493,
                22522,
                22552,
                22581,
                22611,
                22640,
                22670,
                22700,
                22730,
                22759,
                22789,
                22818,
                22848,
                22877,
                22906,
                22936,
                22965,
                22994,
                23024,
                23054,
                23083,
                23113,
                23143,
                23173,
                23202,
                23232,
                23261,
                23290,
                23320,
                23349,
                23379,
                23408,
                23438,
                23467,
                23497,
                23527,
                23556,
                23586,
                23616,
                23645,
                23674,
                23704,
                23733,
                23763,
                23792,
                23822,
                23851,
                23881,
                23910,
                23940,
                23970,
                23999,
                24029,
                24058,
                24088,
                24117,
                24147,
                24176,
                24206,
                24235,
                24265,
                24294,
                24324,
                24353,
                24383,
                24413,
                24442,
                24472,
                24501,
                24531,
                24560,
                24590,
                24619,
                24648,
                24678,
                24707,
                24737,
                24767,
                24796,
                24826,
                24856,
                24885,
                24915,
                24944,
                24974,
                25003,
                25032,
                25062,
                25091,
                25121,
                25150,
                25180,
                25210,
                25240,
                25269,
                25299,
                25328,
                25358,
                25387,
                25416,
                25446,
                25475,
                25505,
                25534,
                25564,
                25594,
                25624,
                25653,
                25683,
                25712,
                25742,
                25771,
                25800,
                25830,
                25859,
                25888,
                25918,
                25948,
                25977,
                26007,
                26037,
                26067,
                26096,
                26126,
                26155,
                26184,
                26214,
                26243,
                26272,
                26302,
                26332,
                26361,
                26391,
                26421,
                26451,
                26480,
                26510,
                26539,
                26568,
                26598,
                26627,
                26656,
                26686,
                26715,
                26745,
                26775,
                26805,
                26834,
                26864,
                26893,
                26923,
                26952,
                26982,
                27011,
                27041,
                27070,
                27099,
                27129,
                27159,
                27188,
                27218,
                27248,
                27277,
                27307,
                27336,
                27366,
                27395,
                27425,
                27454,
                27484,
                27513,
                27542,
                27572,
                27602,
                27631,
                27661,
                27691,
                27720,
                27750,
                27779,
                27809,
                27838,
                27868,
                27897,
                27926,
                27956,
                27985,
                28015,
                28045,
                28074,
                28104,
                28134,
                28163,
                28193,
                28222,
                28252,
                28281,
                28310,
                28340,
                28369,
                28399,
                28428,
                28458,
                28488,
                28517,
                28547,
                28577,
                28607,
                28636,
                28665,
                28695,
                28724,
                28754,
                28783,
                28813,
                28843,
                28872,
                28901,
                28931,
                28960,
                28990,
                29019,
                29049,
                29078,
                29108,
                29137,
                29167,
                29196,
                29226,
                29255,
                29285,
                29315,
                29345,
                29375,
                29404,
                29434,
                29463,
                29492,
                29522,
                29551,
                29580,
                29610,
                29640,
                29669,
                29699,
                29729,
                29759,
                29788,
                29818,
                29847,
                29876,
                29906,
                29935,
                29964,
                29994,
                30023,
                30053,
                30082,
                30112,
                30141,
                30171,
                30200,
                30230,
                30259,
                30289,
                30318,
                30348,
                30378,
                30408,
                30437,
                30467,
                30496,
                30526,
                30555,
                30585,
                30614,
                30644,
                30673,
                30703,
                30732,
                30762,
                30791,
                30821,
                30850,
                30880,
                30909,
                30939,
                30968,
                30998,
                31027,
                31057,
                31086,
                31116,
                31145,
                31175,
                31204,
                31234,
                31263,
                31293,
                31322,
                31352,
                31381,
                31411,
                31441,
                31471,
                31500,
                31530,
                31559,
                31589,
                31618,
                31648,
                31676,
                31706,
                31736,
                31766,
                31795,
                31825,
                31854,
                31884,
                31913,
                31943,
                31972,
                32002,
                32031,
                32061,
                32090,
                32120,
                32150,
                32180,
                32209,
                32239,
                32268,
                32298,
                32327,
                32357,
                32386,
                32416,
                32445,
                32475,
                32504,
                32534,
                32563,
                32593,
                32622,
                32652,
                32681,
                32711,
                32740,
                32770,
                32799,
                32829,
                32858,
                32888,
                32917,
                32947,
                32976,
                33006,
                33035,
                33065,
                33094,
                33124,
                33153,
                33183,
                33213,
                33243,
                33272,
                33302,
                33331,
                33361,
                33390,
                33420,
                33450,
                33479,
                33509,
                33539,
                33568,
                33598,
                33627,
                33657,
                33686,
                33716,
                33745,
                33775,
                33804,
                33834,
                33863,
                33893,
                33922,
                33952,
                33981,
                34011,
                34040,
                34069,
                34099,
                34128,
                34158,
                34187,
                34217,
                34247,
                34277,
                34306,
                34336,
                34365,
                34395,
                34424,
                34454,
                34483,
                34512,
                34542,
                34571,
                34601,
                34631,
                34660,
                34690,
                34719,
                34749,
                34778,
                34808,
                34837,
                34867,
                34896,
                34926,
                34955,
                34985,
                35015,
                35044,
                35074,
                35103,
                35133,
                35162,
                35192,
                35222,
                35251,
                35280,
                35310,
                35340,
                35370,
                35399,
                35429,
                35458,
                35488,
                35517,
                35547,
                35576,
                35605,
                35635,
                35665,
                35694,
                35723,
                35753,
                35782,
                35811,
                35841,
                35871,
                35901,
                35930,
                35960,
                35989,
                36019,
                36048,
                36078,
                36107,
                36136,
                36166,
                36195,
                36225,
                36254,
                36284,
                36314,
                36343,
                36373,
                36403,
                36433,
                36462,
                36492,
                36521,
                36551,
                36580,
                36610,
                36639,
                36669,
                36698,
                36728,
                36757,
                36786,
                36816,
                36845,
                36875,
                36904,
                36934,
                36963,
                36993,
                37022,
                37052,
                37081,
                37111,
                37141,
                37170,
                37200,
                37229,
                37259,
                37288,
                37318,
                37347,
                37377,
                37406,
                37436,
                37465,
                37495,
                37524,
                37554,
                37584,
                37613,
                37643,
                37672,
                37701,
                37731,
                37760,
                37790,
                37819,
                37849,
                37878,
                37908,
                37938,
                37967,
                37997,
                38027,
                38056,
                38085,
                38115,
                38144,
                38174,
                38203,
                38233,
                38262,
                38292,
                38322,
                38351,
                38381,
                38410,
                38440,
                38469,
                38499,
                38528,
                38558,
                38587,
                38617,
                38646,
                38676,
                38705,
                38735,
                38764,
                38794,
                38823,
                38853,
                38882,
                38912,
                38941,
                38971,
                39001,
                39030,
                39059,
                39089,
                39118,
                39148,
                39178,
                39208,
                39237,
                39267,
                39297,
                39326,
                39355,
                39385,
                39414,
                39444,
                39473,
                39503,
                39532,
                39562,
                39592,
                39621,
                39650,
                39680,
                39709,
                39739,
                39768,
                39798,
                39827,
                39857,
                39886,
                39916,
                39946,
                39975,
                40005,
                40035,
                40064,
                40094,
                40123,
                40153,
                40182,
                40212,
                40241,
                40271,
                40300,
                40330,
                40359,
                40389,
                40418,
                40448,
                40477,
                40507,
                40536,
                40566,
                40595,
                40625,
                40655,
                40685,
                40714,
                40744,
                40773,
                40803,
                40832,
                40862,
                40892,
                40921,
                40951,
                40980,
                41009,
                41039,
                41068,
                41098,
                41127,
                41157,
                41186,
                41216,
                41245,
                41275,
                41304,
                41334,
                41364,
                41393,
                41422,
                41452,
                41481,
                41511,
                41540,
                41570,
                41599,
                41629,
                41658,
                41688,
                41718,
                41748,
                41777,
                41807,
                41836,
                41865,
                41894,
                41924,
                41953,
                41983,
                42012,
                42042,
                42072,
                42102,
                42131,
                42161,
                42190,
                42220,
                42249,
                42279,
                42308,
                42337,
                42367,
                42397,
                42426,
                42456,
                42485,
                42515,
                42545,
                42574,
                42604,
                42633,
                42662,
                42692,
                42721,
                42751,
                42780,
                42810,
                42839,
                42869,
                42899,
                42929,
                42958,
                42988,
                43017,
                43046,
                43076,
                43105,
                43135,
                43164,
                43194,
                43223,
                43253,
                43283,
                43312,
                43342,
                43371,
                43401,
                43430,
                43460,
                43489,
                43519,
                43548,
                43578,
                43607,
                43637,
                43666,
                43696,
                43726,
                43755,
                43785,
                43814,
                43844,
                43873,
                43903,
                43932,
                43962,
                43991,
                44021,
                44050,
                44080,
                44109,
                44139,
                44169,
                44198,
                44228,
                44258,
                44287,
                44317,
                44346,
                44375,
                44405,
                44434,
                44464,
                44493,
                44523,
                44553,
                44582,
                44612,
                44641,
                44671,
                44700,
                44730,
                44759,
                44788,
                44818,
                44847,
                44877,
                44906,
                44936,
                44966,
                44996,
                45025,
                45055,
                45084,
                45114,
                45143,
                45172,
                45202,
                45231,
                45261,
                45290,
                45320,
                45350,
                45380,
                45409,
                45439,
                45468,
                45498,
                45527,
                45556,
                45586,
                45615,
                45644,
                45674,
                45704,
                45733,
                45763,
                45793,
                45823,
                45852,
                45882,
                45911,
                45940,
                45970,
                45999,
                46028,
                46058,
                46088,
                46117,
                46147,
                46177,
                46206,
                46236,
                46265,
                46295,
                46324,
                46354,
                46383,
                46413,
                46442,
                46472,
                46501,
                46531,
                46560,
                46590,
                46620,
                46649,
                46679,
                46708,
                46738,
                46767,
                46797,
                46826,
                46856,
                46885,
                46915,
                46944,
                46974,
                47003,
                47033,
                47063,
                47092,
                47122,
                47151,
                47181,
                47210,
                47240,
                47269,
                47298,
                47328,
                47357,
                47387,
                47417,
                47446,
                47476,
                47506,
                47535,
                47565,
                47594,
                47624,
                47653,
                47682,
                47712,
                47741,
                47771,
                47800,
                47830,
                47860,
                47890,
                47919,
                47949,
                47978,
                48008,
                48037,
                48066,
                48096,
                48125,
                48155,
                48184,
                48214,
                48244,
                48273,
                48303,
                48333,
                48362,
                48392,
                48421,
                48450,
                48480,
                48509,
                48538,
                48568,
                48598,
                48627,
                48657,
                48687,
                48717,
                48746,
                48776,
                48805,
                48834,
                48864,
                48893,
                48922,
                48952,
                48982,
                49011,
                49041,
                49071,
                49100,
                49130,
                49160,
                49189,
                49218,
                49248,
                49277,
                49306,
                49336,
                49365,
                49395,
                49425,
                49455,
                49484,
                49514,
                49543,
                49573,
                49602,
                49632,
                49661,
                49690,
                49720,
                49749,
                49779,
                49809,
                49838,
                49868,
                49898,
                49927,
                49957,
                49986,
                50016,
                50045,
                50075,
                50104,
                50133,
                50163,
                50192,
                50222,
                50252,
                50281,
                50311,
                50340,
                50370,
                50400,
                50429,
                50459,
                50488,
                50518,
                50547,
                50576,
                50606,
                50635,
                50665,
                50694,
                50724,
                50754,
                50784,
                50813,
                50843,
                50872,
                50902,
                50931,
                50960,
                50990,
                51019,
                51049,
                51078,
                51108,
                51138,
                51167,
                51197,
                51227,
                51256,
                51286,
                51315,
                51345,
                51374,
                51403,
                51433,
                51462,
                51492,
                51522,
                51552,
                51582,
                51611,
                51641,
                51670,
                51699,
                51729,
                51758,
                51787,
                51816,
                51846,
                51876,
                51906,
                51936,
                51965,
                51995,
                52025,
                52054,
                52083,
                52113,
                52142,
                52171,
                52200,
                52230,
                52260,
                52290,
                52319,
                52349,
                52379,
                52408,
                52438,
                52467,
                52497,
                52526,
                52555,
                52585,
                52614,
                52644,
                52673,
                52703,
                52733,
                52762,
                52792,
                52822,
                52851,
                52881,
                52910,
                52939,
                52969,
                52998,
                53028,
                53057,
                53087,
                53116,
                53146,
                53176,
                53205,
                53235,
                53264,
                53294,
                53324,
                53353,
                53383,
                53412,
                53441,
                53471,
                53500,
                53530,
                53559,
                53589,
                53619,
                53648,
                53678,
                53708,
                53737,
                53767,
                53796,
                53825,
                53855,
                53884,
                53913,
                53943,
                53973,
                54003,
                54032,
                54062,
                54092,
                54121,
                54151,
                54180,
                54209,
                54239,
                54268,
                54297,
                54327,
                54357,
                54387,
                54416,
                54446,
                54476,
                54505,
                54535,
                54564,
                54593,
                54623,
                54652,
                54681,
                54711,
                54741,
                54770,
                54800,
                54830,
                54859,
                54889,
                54919,
                54948,
                54977,
                55007,
                55036,
                55066,
                55095,
                55125,
                55154,
                55184,
                55213,
                55243,
                55273,
                55302,
                55332,
                55361,
                55391,
                55420,
                55450,
                55479,
                55508,
                55538,
                55567,
                55597,
                55627,
                55657,
                55686,
                55716,
                55745,
                55775,
                55804,
                55834,
                55863,
                55892,
                55922,
                55951,
                55981,
                56011,
                56040,
                56070,
                56100,
                56129,
                56159,
                56188,
                56218,
                56247,
                56276,
                56306,
                56335,
                56365,
                56394,
                56424,
                56454,
                56483,
                56513,
                56543,
                56572,
                56601,
                56631,
                56660,
                56690,
                56719,
                56749,
                56778,
                56808,
                56837,
                56867,
                56897,
                56926,
                56956,
                56985,
                57015,
                57044,
                57074,
                57103,
                57133,
                57162,
                57192,
                57221,
                57251,
                57280,
                57310,
                57340,
                57369,
                57399,
                57429,
                57458,
                57487,
                57517,
                57546,
                57576,
                57605,
                57634,
                57664,
                57694,
                57723,
                57753,
                57783,
                57813,
                57842,
                57871,
                57901,
                57930,
                57959,
                57989,
                58018,
                58048,
                58077,
                58107,
                58137,
                58167,
                58196,
                58226,
                58255,
                58285,
                58314,
                58343,
                58373,
                58402,
                58432,
                58461,
                58491,
                58521,
                58551,
                58580,
                58610,
                58639,
                58669,
                58698,
                58727,
                58757,
                58786,
                58816,
                58845,
                58875,
                58905,
                58934,
                58964,
                58994,
                59023,
                59053,
                59082,
                59111,
                59141,
                59170,
                59200,
                59229,
                59259,
                59288,
                59318,
                59348,
                59377,
                59407,
                59436,
                59466,
                59495,
                59525,
                59554,
                59584,
                59613,
                59643,
                59672,
                59702,
                59731,
                59761,
                59791,
                59820,
                59850,
                59879,
                59909,
                59939,
                59968,
                59997,
                60027,
                60056,
                60086,
                60115,
                60145,
                60174,
                60204,
                60234,
                60264,
                60293,
                60323,
                60352,
                60381,
                60411,
                60440,
                60469,
                60499,
                60528,
                60558,
                60588,
                60618,
                60648,
                60677,
                60707,
                60736,
                60765,
                60795,
                60824,
                60853,
                60883,
                60912,
                60942,
                60972,
                61002,
                61031,
                61061,
                61090,
                61120,
                61149,
                61179,
                61208,
                61237,
                61267,
                61296,
                61326,
                61356,
                61385,
                61415,
                61445,
                61474,
                61504,
                61533,
                61563,
                61592,
                61621,
                61651,
                61680,
                61710,
                61739,
                61769,
                61799,
                61828,
                61858,
                61888,
                61917,
                61947,
                61976,
                62006,
                62035,
                62064,
                62094,
                62123,
                62153,
                62182,
                62212,
                62242,
                62271,
                62301,
                62331,
                62360,
                62390,
                62419,
                62448,
                62478,
                62507,
                62537,
                62566,
                62596,
                62625,
                62655,
                62685,
                62715,
                62744,
                62774,
                62803,
                62832,
                62862,
                62891,
                62921,
                62950,
                62980,
                63009,
                63039,
                63069,
                63099,
                63128,
                63157,
                63187,
                63216,
                63246,
                63275,
                63305,
                63334,
                63363,
                63393,
                63423,
                63453,
                63482,
                63512,
                63541,
                63571,
                63600,
                63630,
                63659,
                63689,
                63718,
                63747,
                63777,
                63807,
                63836,
                63866,
                63895,
                63925,
                63955,
                63984,
                64014,
                64043,
                64073,
                64102,
                64131,
                64161,
                64190,
                64220,
                64249,
                64279,
                64309,
                64339,
                64368,
                64398,
                64427,
                64457,
                64486,
                64515,
                64545,
                64574,
                64603,
                64633,
                64663,
                64692,
                64722,
                64752,
                64782,
                64811,
                64841,
                64870,
                64899,
                64929,
                64958,
                64987,
                65017,
                65047,
                65076,
                65106,
                65136,
                65166,
                65195,
                65225,
                65254,
                65283,
                65313,
                65342,
                65371,
                65401,
                65431,
                65460,
                65490,
                65520,
                65549,
                65579,
                65608,
                65638,
                65667,
                65697,
                65726,
                65755,
                65785,
                65815,
                65844,
                65874,
                65903,
                65933,
                65963,
                65992,
                66022,
                66051,
                66081,
                66110,
                66140,
                66169,
                66199,
                66228,
                66258,
                66287,
                66317,
                66346,
                66376,
                66405,
                66435,
                66465,
                66494,
                66524,
                66553,
                66583,
                66612,
                66641,
                66671,
                66700,
                66730,
                66760,
                66789,
                66819,
                66849,
                66878,
                66908,
                66937,
                66967,
                66996,
                67025,
                67055,
                67084,
                67114,
                67143,
                67173,
                67203,
                67233,
                67262,
                67292,
                67321,
                67351,
                67380,
                67409,
                67439,
                67468,
                67497,
                67527,
                67557,
                67587,
                67617,
                67646,
                67676,
                67705,
                67735,
                67764,
                67793,
                67823,
                67852,
                67882,
                67911,
                67941,
                67971,
                68e3,
                68030,
                68060,
                68089,
                68119,
                68148,
                68177,
                68207,
                68236,
                68266,
                68295,
                68325,
                68354,
                68384,
                68414,
                68443,
                68473,
                68502,
                68532,
                68561,
                68591,
                68620,
                68650,
                68679,
                68708,
                68738,
                68768,
                68797,
                68827,
                68857,
                68886,
                68916,
                68946,
                68975,
                69004,
                69034,
                69063,
                69092,
                69122,
                69152,
                69181,
                69211,
                69240,
                69270,
                69300,
                69330,
                69359,
                69388,
                69418,
                69447,
                69476,
                69506,
                69535,
                69565,
                69595,
                69624,
                69654,
                69684,
                69713,
                69743,
                69772,
                69802,
                69831,
                69861,
                69890,
                69919,
                69949,
                69978,
                70008,
                70038,
                70067,
                70097,
                70126,
                70156,
                70186,
                70215,
                70245,
                70274,
                70303,
                70333,
                70362,
                70392,
                70421,
                70451,
                70481,
                70510,
                70540,
                70570,
                70599,
                70629,
                70658,
                70687,
                70717,
                70746,
                70776,
                70805,
                70835,
                70864,
                70894,
                70924,
                70954,
                70983,
                71013,
                71042,
                71071,
                71101,
                71130,
                71159,
                71189,
                71218,
                71248,
                71278,
                71308,
                71337,
                71367,
                71397,
                71426,
                71455,
                71485,
                71514,
                71543,
                71573,
                71602,
                71632,
                71662,
                71691,
                71721,
                71751,
                71781,
                71810,
                71839,
                71869,
                71898,
                71927,
                71957,
                71986,
                72016,
                72046,
                72075,
                72105,
                72135,
                72164,
                72194,
                72223,
                72253,
                72282,
                72311,
                72341,
                72370,
                72400,
                72429,
                72459,
                72489,
                72518,
                72548,
                72577,
                72607,
                72637,
                72666,
                72695,
                72725,
                72754,
                72784,
                72813,
                72843,
                72872,
                72902,
                72931,
                72961,
                72991,
                73020,
                73050,
                73080,
                73109,
                73139,
                73168,
                73197,
                73227,
                73256,
                73286,
                73315,
                73345,
                73375,
                73404,
                73434,
                73464,
                73493,
                73523,
                73552,
                73581,
                73611,
                73640,
                73669,
                73699,
                73729,
                73758,
                73788,
                73818,
                73848,
                73877,
                73907,
                73936,
                73965,
                73995,
                74024,
                74053,
                74083,
                74113,
                74142,
                74172,
                74202,
                74231,
                74261,
                74291,
                74320,
                74349,
                74379,
                74408,
                74437,
                74467,
                74497,
                74526,
                74556,
                74586,
                74615,
                74645,
                74675,
                74704,
                74733,
                74763,
                74792,
                74822,
                74851,
                74881,
                74910,
                74940,
                74969,
                74999,
                75029,
                75058,
                75088,
                75117,
                75147,
                75176,
                75206,
                75235,
                75264,
                75294,
                75323,
                75353,
                75383,
                75412,
                75442,
                75472,
                75501,
                75531,
                75560,
                75590,
                75619,
                75648,
                75678,
                75707,
                75737,
                75766,
                75796,
                75826,
                75856,
                75885,
                75915,
                75944,
                75974,
                76003,
                76032,
                76062,
                76091,
                76121,
                76150,
                76180,
                76210,
                76239,
                76269,
                76299,
                76328,
                76358,
                76387,
                76416,
                76446,
                76475,
                76505,
                76534,
                76564,
                76593,
                76623,
                76653,
                76682,
                76712,
                76741,
                76771,
                76801,
                76830,
                76859,
                76889,
                76918,
                76948,
                76977,
                77007,
                77036,
                77066,
                77096,
                77125,
                77155,
                77185,
                77214,
                77243,
                77273,
                77302,
                77332,
                77361,
                77390,
                77420,
                77450,
                77479,
                77509,
                77539,
                77569,
                77598,
                77627,
                77657,
                77686,
                77715,
                77745,
                77774,
                77804,
                77833,
                77863,
                77893,
                77923,
                77952,
                77982,
                78011,
                78041,
                78070,
                78099,
                78129,
                78158,
                78188,
                78217,
                78247,
                78277,
                78307,
                78336,
                78366,
                78395,
                78425,
                78454,
                78483,
                78513,
                78542,
                78572,
                78601,
                78631,
                78661,
                78690,
                78720,
                78750,
                78779,
                78808,
                78838,
                78867,
                78897,
                78926,
                78956,
                78985,
                79015,
                79044,
                79074,
                79104,
                79133,
                79163,
                79192,
                79222,
                79251,
                79281,
                79310,
                79340,
                79369,
                79399,
                79428,
                79458,
                79487,
                79517,
                79546,
                79576,
                79606,
                79635,
                79665,
                79695,
                79724,
                79753,
                79783,
                79812,
                79841,
                79871,
                79900,
                79930,
                79960,
                79990
            ];
        });
        var j$e = ye((_2r, G$e)=>{
            "use strict";
            G$e.exports = Sv();
            E$e();
            k$e();
            C$e();
            L$e();
            P$e();
            I$e();
            R$e();
            D$e();
            F$e();
            O$e();
            B$e();
            N$e();
            U$e();
            V$e();
            H$e();
        });
        var $$e = ye((x2r, J$e)=>{
            "use strict";
            var Z$e = j$e(), lC = Mr(), X$e = es(), MQt = X$e.EPOCHJD, EQt = X$e.ONEDAY, pQ = {
                valType: "enumerated",
                values: lC.sortObjectKeys(Z$e.calendars),
                editType: "calc",
                dflt: "gregorian"
            }, Y$e = function(e, t, r, n) {
                var i = {};
                return i[r] = pQ, lC.coerce(e, t, i, r, n);
            }, kQt = function(e, t, r, n) {
                for(var i = 0; i < r.length; i++)Y$e(e, t, r[i] + "calendar", n.calendar);
            }, CQt = {
                chinese: "2000-01-01",
                coptic: "2000-01-01",
                discworld: "2000-01-01",
                ethiopian: "2000-01-01",
                hebrew: "5000-01-01",
                islamic: "1000-01-01",
                julian: "2000-01-01",
                mayan: "5000-01-01",
                nanakshahi: "1000-01-01",
                nepali: "2000-01-01",
                persian: "1000-01-01",
                jalali: "1000-01-01",
                taiwan: "1000-01-01",
                thai: "2000-01-01",
                ummalqura: "1400-01-01"
            }, LQt = {
                chinese: "2000-01-02",
                coptic: "2000-01-03",
                discworld: "2000-01-03",
                ethiopian: "2000-01-05",
                hebrew: "5000-01-01",
                islamic: "1000-01-02",
                julian: "2000-01-03",
                mayan: "5000-01-01",
                nanakshahi: "1000-01-05",
                nepali: "2000-01-05",
                persian: "1000-01-01",
                jalali: "1000-01-01",
                taiwan: "1000-01-04",
                thai: "2000-01-04",
                ummalqura: "1400-01-06"
            }, PQt = {
                chinese: [
                    "2000-01-01",
                    "2001-01-01"
                ],
                coptic: [
                    "1700-01-01",
                    "1701-01-01"
                ],
                discworld: [
                    "1800-01-01",
                    "1801-01-01"
                ],
                ethiopian: [
                    "2000-01-01",
                    "2001-01-01"
                ],
                hebrew: [
                    "5700-01-01",
                    "5701-01-01"
                ],
                islamic: [
                    "1400-01-01",
                    "1401-01-01"
                ],
                julian: [
                    "2000-01-01",
                    "2001-01-01"
                ],
                mayan: [
                    "5200-01-01",
                    "5201-01-01"
                ],
                nanakshahi: [
                    "0500-01-01",
                    "0501-01-01"
                ],
                nepali: [
                    "2000-01-01",
                    "2001-01-01"
                ],
                persian: [
                    "1400-01-01",
                    "1401-01-01"
                ],
                jalali: [
                    "1400-01-01",
                    "1401-01-01"
                ],
                taiwan: [
                    "0100-01-01",
                    "0101-01-01"
                ],
                thai: [
                    "2500-01-01",
                    "2501-01-01"
                ],
                ummalqura: [
                    "1400-01-01",
                    "1401-01-01"
                ]
            }, L9 = "##", IQt = {
                d: {
                    0: "dd",
                    "-": "d"
                },
                e: {
                    0: "d",
                    "-": "d"
                },
                a: {
                    0: "D",
                    "-": "D"
                },
                A: {
                    0: "DD",
                    "-": "DD"
                },
                j: {
                    0: "oo",
                    "-": "o"
                },
                W: {
                    0: "ww",
                    "-": "w"
                },
                m: {
                    0: "mm",
                    "-": "m"
                },
                b: {
                    0: "M",
                    "-": "M"
                },
                B: {
                    0: "MM",
                    "-": "MM"
                },
                y: {
                    0: "yy",
                    "-": "yy"
                },
                Y: {
                    0: "yyyy",
                    "-": "yyyy"
                },
                U: L9,
                w: L9,
                c: {
                    0: "D M d %X yyyy",
                    "-": "D M d %X yyyy"
                },
                x: {
                    0: "mm/dd/yyyy",
                    "-": "mm/dd/yyyy"
                }
            };
            function RQt(e, t, r) {
                for(var n = Math.floor((t + .05) / EQt) + MQt, i = K$e(r).fromJD(n), a = 0, o, s, l, u, c; (a = e.indexOf("%", a)) !== -1;)o = e.charAt(a + 1), o === "0" || o === "-" || o === "_" ? (l = 3, s = e.charAt(a + 2), o === "_" && (o = "-")) : (s = o, o = "0", l = 2), u = IQt[s], u ? (u === L9 ? c = L9 : c = i.formatDate(u[o]), e = e.substr(0, a) + c + e.substr(a + l), a += c.length) : a += l;
                return e;
            }
            var W$e = {};
            function K$e(e) {
                var t = W$e[e];
                return t || (t = W$e[e] = Z$e.instance(e), t);
            }
            function uC(e) {
                return lC.extendFlat({}, pQ, {
                    description: e
                });
            }
            function gQ(e) {
                return "Sets the calendar system to use with `" + e + "` date data.";
            }
            var vQ = {
                xcalendar: uC(gQ("x"))
            }, iy = lC.extendFlat({}, vQ, {
                ycalendar: uC(gQ("y"))
            }), dQ = lC.extendFlat({}, iy, {
                zcalendar: uC(gQ("z"))
            }), QA = uC([
                "Sets the calendar system to use for `range` and `tick0`",
                "if this is a date axis. This does not set the calendar for",
                "interpreting data on this axis, that's specified in the trace",
                "or via the global `layout.calendar`"
            ].join(" "));
            J$e.exports = {
                moduleType: "component",
                name: "calendars",
                schema: {
                    traces: {
                        scatter: iy,
                        bar: iy,
                        box: iy,
                        heatmap: iy,
                        contour: iy,
                        histogram: iy,
                        histogram2d: iy,
                        histogram2dcontour: iy,
                        scatter3d: dQ,
                        surface: dQ,
                        mesh3d: dQ,
                        scattergl: iy,
                        ohlc: vQ,
                        candlestick: vQ
                    },
                    layout: {
                        calendar: uC([
                            "Sets the default calendar system to use for interpreting and",
                            "displaying dates throughout the plot."
                        ].join(" "))
                    },
                    subplots: {
                        xaxis: {
                            calendar: QA
                        },
                        yaxis: {
                            calendar: QA
                        },
                        scene: {
                            xaxis: {
                                calendar: QA
                            },
                            yaxis: {
                                calendar: QA
                            },
                            zaxis: {
                                calendar: QA
                            }
                        },
                        polar: {
                            radialaxis: {
                                calendar: QA
                            }
                        }
                    }
                },
                layoutAttributes: pQ,
                handleDefaults: Y$e,
                handleTraceDefaults: kQt,
                CANONICAL_SUNDAY: LQt,
                CANONICAL_TICK: CQt,
                DFLTRANGE: PQt,
                getCal: K$e,
                worldCalFmt: RQt
            };
        });
        var eQe = ye((b2r, Q$e)=>{
            "use strict";
            Q$e.exports = $$e();
        });
        var DQt = ye((w2r, rQe)=>{
            var tQe = Wme();
            tQe.register([
                Xye(),
                z1e(),
                Z_e(),
                dxe(),
                Mxe(),
                wbe(),
                zbe(),
                b2e(),
                K2e(),
                Pwe(),
                m3e(),
                j4e(),
                REe(),
                TCe(),
                c6e(),
                N6e(),
                uLe(),
                RPe(),
                $Pe(),
                gIe(),
                kIe(),
                VIe(),
                i8e(),
                _8e(),
                WRe(),
                hDe(),
                EOe(),
                EBe(),
                qNe(),
                lUe(),
                mVe(),
                IVe(),
                rHe(),
                dGe(),
                kGe(),
                $Ge(),
                oWe(),
                LWe(),
                fZe(),
                RXe(),
                rYe(),
                TYe(),
                YYe(),
                uKe(),
                sJe(),
                SJe(),
                GJe(),
                A$e(),
                eQe()
            ]);
            rQe.exports = tQe;
        });
        return DQt();
    })();
    /*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ /*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /*!
 * pad-left <https://github.com/jonschlinkert/pad-left>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT license.
 */ /*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */ /*! Bundled license information:

native-promise-only/lib/npo.src.js:
  (*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  *)

polybooljs/index.js:
  (*
   * @copyright 2016 Sean Connelly (@voidqk), http://syntheti.cc
   * @license MIT
   * @preserve Project Home: https://github.com/voidqk/polybooljs
   *)

ieee754/index.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

buffer/index.js:
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   *)

safe-buffer/index.js:
  (*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> *)

assert/build/internal/util/comparisons.js:
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
   * @license  MIT
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)

maplibre-gl/dist/maplibre-gl.js:
  (**
   * MapLibre GL JS
   * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v4.7.1/LICENSE.txt
   *)
*/ window.Plotly = Plotly;
    return Plotly;
});

















/**
 * A simple statistics shower
 * It's a UI element that takes an array of data and shows relevant summary statistics on that data
 * Has a legend that shows on mouseover (touch on mobile)
 *
 * This class is meant to be overridden to implement the actual stats and UI to show them
 * @abstract
 * @extends UIElement
 */ class $9d3c91e94cb4faf3$export$20e286a52234c92 extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param data {Array<number|string>} The data to show stats for
     * @param id {string} Unique id of this UI element
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */ constructor(data, id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig){
        super(id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.data = data.filter((a)=>a !== null && a !== undefined).sort((a, b)=>a - b);
        this.onShowLegendCallbacks = [];
        this.onHideLegendCallbacks = [];
    }
    getClassName() {
        return "AbstractSimpleStatsShower";
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div class="summary-stats"><div class="stats-elements"></div></div>');
            this._generateUIElements();
            if (this.isMobileDevice) {
                $dc57b31f1b066f38$exports('body').click((event)=>{
                    if ($dc57b31f1b066f38$exports(event.target).parents('.summary-stats').length === 0) this.hideLegend();
                });
                this.uiElement.click(()=>{
                    this.showLegend();
                    this.logStat("SHOW_LEGEND");
                });
            } else this.uiElement.on({
                mouseenter: ()=>{
                    this.showLegend();
                    this.logStat("SHOW_LEGEND");
                },
                mouseleave: ()=>{
                    this.hideLegend();
                    this.logStat("HIDE_LEGEND");
                }
            });
        }
        return this.uiElement;
    }
    /**
     * This method is meant to be overridden and should add all the UI elements to show the stats to this.UIElement
     * @private
     */ _generateUIElements() {}
    /**
     * This method is meant to be overridden and should add all the UI elements to show the stats legendd to legendElem
     * @param legendElem {jQuery}
     * @private
     */ _generateLegendElements(legendElem) {}
    /**
     * Add a callback that executes on show legend
     * @param callback {function} A callback that takes this shower as a parameter
     */ onShowLegend(callback) {
        this.onShowLegendCallbacks.push(callback);
    }
    /**
     * Add a callback that executes on hide legend
     * @param callback {function} A callback that takes this shower as a parameter
     */ onHideLegend(callback) {
        this.onHideLegendCallbacks.push(callback);
    }
    /**
     * Show this shower's legend
     */ showLegend() {
        const legendElem = $dc57b31f1b066f38$exports('<div class="summary-legend"></div>').hide();
        this.uiElement.append(legendElem);
        this._generateLegendElements(legendElem);
        legendElem.show();
        this.onShowLegendCallbacks.forEach((c)=>c(this));
    }
    /**
     * Hide this shower's legend
     */ hideLegend() {
        $dc57b31f1b066f38$exports('div.summary-legend', this.uiElement).remove();
        this.onHideLegendCallbacks.forEach((c)=>c(this));
    }
}


/**
 * A simple stats shower for numerical samples that implements a small box plot chart
 * @extends AbstractSimpleStatsShower
 */ class $bdd0489754fafde2$export$69ab57c4003c66c1 extends (0, $9d3c91e94cb4faf3$export$20e286a52234c92) {
    /**
     *
     * @param decimalPlaces {number} (integer) The nr of decimal places to show
     * @param data {Array<number|string>} The data to show stats for
     * @param id {string} Unique id of this UI element
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     **/ constructor(decimalPlaces, data, id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig){
        super(data, id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.decimalPlaces = decimalPlaces;
    }
    getClassName() {
        return "BoxPlot";
    }
    _generateUIElements() {
        const element = $dc57b31f1b066f38$exports('<div class="box-plot-container">   <div class="box-plot">       <div class="hor-line"></div>       <div class="min"></div>       <div class="max"></div>       <div class="min-max"></div>       <div class="box"></div>       <div class="med"></div>   </div></div>');
        if (this.data.length === 0) this.logError("Empty data array");
        else {
            this.min = this.data[0];
            this.max = (0, $2536f84a954bf107$export$ce275da88d3dcc54)(this.data);
            this.totalDelta = this.max - this.min;
            this.avg = (0, $2536f84a954bf107$export$1ce691f85baaa52)(this.data);
            this.stdev = (0, $2536f84a954bf107$export$1cb78577db373fdf)(this.data);
            this.vari = (0, $2536f84a954bf107$export$9b77da0927470c3d)(this.data);
            this.med = (0, $2536f84a954bf107$export$651fb4afdb6caa4b)(this.data, .5);
            this.boxMin = (0, $2536f84a954bf107$export$651fb4afdb6caa4b)(this.data, .25);
            this.boxMax = (0, $2536f84a954bf107$export$651fb4afdb6caa4b)(this.data, .75);
            this.boxDelta = this.boxMax - this.boxMin;
            this.IQR = this.boxDelta;
            this.plotMin = Math.max(this.boxMin - this.IQR * 1.5, this.min !== undefined ? this.min : Number.MIN_VALUE);
            this.plotMax = Math.min(this.boxMax + this.IQR * 1.5, this.max !== undefined ? this.max : Number.MAX_VALUE);
            this.plotDelta = this.plotMax - this.plotMin;
            let localPlotMin = this.plotMin;
            let localPlotMax = this.plotMax;
            let localPlotDelta = this.plotDelta;
            let error = false;
            if (localPlotMin < this.min) {
                error = true;
                this.logError('(p25 - IQR * 1.5) < min ');
            }
            if (localPlotMin > this.boxMin) {
                error = true;
                this.logError('(p25 - IQR * 1.5) > p25 ');
            }
            if (localPlotMax > this.max) {
                error = true;
                this.logError('(p75 + IQR * 1.5) > max ');
            }
            if (localPlotMax < this.boxMax) {
                error = true;
                this.logError('(p75 + IQR * 1.5) < p75 ');
            }
            if (error) {
                localPlotMax = this.max;
                localPlotMin = this.min;
                localPlotDelta = localPlotMax - localPlotMin;
                $dc57b31f1b066f38$exports('div.min', element).hide();
                $dc57b31f1b066f38$exports('div.max', element).hide();
                $dc57b31f1b066f38$exports('div.box', element).hide();
                $dc57b31f1b066f38$exports('div.min-max', element).addClass('error');
            }
            const horLineWidth = localPlotDelta / this.totalDelta * 100;
            const horLineLeft = (localPlotMin - this.min) / this.totalDelta * 100;
            $dc57b31f1b066f38$exports('div.min-max', element).css('width', horLineWidth + '%');
            $dc57b31f1b066f38$exports('div.min-max', element).css('left', horLineLeft + '%');
            $dc57b31f1b066f38$exports('div.hor-line', element).css('width', horLineWidth + '%');
            $dc57b31f1b066f38$exports('div.hor-line', element).css('left', horLineLeft + '%');
            const medLeft = (this.med - this.min) / this.totalDelta * 100;
            $dc57b31f1b066f38$exports('div.med', element).css('left', 'calc(' + medLeft + '% - ' + 1 + 'px)');
            $dc57b31f1b066f38$exports('div.box', element).css('left', (this.boxMin - this.min) / this.totalDelta * 100 + '%');
            $dc57b31f1b066f38$exports('div.box', element).css('width', this.boxDelta / this.totalDelta * 100 + '%');
            $dc57b31f1b066f38$exports('.stats-elements', this.uiElement.addClass('box-plot')).append(element);
        }
    }
    _generateLegendElements(legendElem) {
        legendElem.addClass('box-plot').append($dc57b31f1b066f38$exports('<table><tr><td class="label"><label>' + this.translator.translate('tool.charts.boxplot.min') + '</label></td><td class="value min-val"></td></tr>' + '<tr><td class="label"><label>' + this.translator.translate('tool.charts.boxplot.q1') + '</label></td><td class="value q1-val"></td></tr>' + '<tr><td class="label"><label>' + this.translator.translate('tool.charts.boxplot.med') + '</label></td><td class="value med-val"></td></tr>' + '<tr><td class="label"><label>' + this.translator.translate('tool.charts.boxplot.q3') + '</label></td><td class="value q3-val"></td></tr>' + '<tr><td class="label"><label>' + this.translator.translate('tool.charts.boxplot.max') + '</label></td><td class="value max-val"></td></tr>' + '<tr><td class="label"><label>' + this.translator.translate('tool.charts.boxplot.iqr') + '</label></td><td class="value iqr-val"></td></tr>' + '<tr><td class="label"><label>' + this.translator.translate('tool.charts.boxplot.mean') + '</label></td><td class="value mean-val"></td></tr>' + '<tr><td class="label"><label>' + this.translator.translate('tool.charts.boxplot.stddev') + '</label></td><td class="value stddev-val"></td></tr>' + '<tr><td class="label"><label>' + this.translator.translate('tool.charts.boxplot.var') + '</label></td><td class="value var-val"></td></tr>' + '</table>'));
        $dc57b31f1b066f38$exports('td.min-val', legendElem).html(this.min.toFixed(this.decimalPlaces));
        $dc57b31f1b066f38$exports('td.q1-val', legendElem).html(this.boxMin.toFixed(this.decimalPlaces));
        $dc57b31f1b066f38$exports('td.med-val', legendElem).html(this.med.toFixed(this.decimalPlaces));
        $dc57b31f1b066f38$exports('td.q3-val', legendElem).html(this.boxMax.toFixed(this.decimalPlaces));
        $dc57b31f1b066f38$exports('td.max-val', legendElem).html(this.max.toFixed(this.decimalPlaces));
        $dc57b31f1b066f38$exports('td.iqr-val', legendElem).html(this.IQR.toFixed(this.decimalPlaces));
        $dc57b31f1b066f38$exports('td.mean-val', legendElem).html(this.avg.toFixed(this.decimalPlaces));
        $dc57b31f1b066f38$exports('td.stddev-val', legendElem).html(this.stdev.toFixed(this.decimalPlaces));
        $dc57b31f1b066f38$exports('td.var-val', legendElem).html(this.vari.toFixed(this.decimalPlaces));
    }
}








/**
 * A simple stats shower for classified samples
 * @extends AbstractSimpleStatsShower
 */ class $b228fcf3f31b0912$export$87aa6a85768e3c8b extends (0, $9d3c91e94cb4faf3$export$20e286a52234c92) {
    /**
     *
     * @param chartStyler {ChartStyler} A styler for the current data sample
     * @param data {Array<number|string>} The data to show stats for
     * @param id {string} Unique id of this UI element
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     **/ constructor(chartStyler, data, id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig){
        super(data, id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.chartStyler = chartStyler;
        this.labelFunction = this.chartStyler.getLabelFunction();
        this.colorFunction = this.chartStyler.getColorFunction();
        this.isNoDataFunction = this.chartStyler.getIsNoDataFunction();
    }
    getClassName() {
        return "ClassifiedSummaryStats";
    }
    _generateUIElements() {
        this.dataSummary = {};
        this.totalCount = 0;
        this.data.filter((v)=>!this.isNoDataFunction(v)).forEach((v)=>{
            const label = this.labelFunction(v);
            const color = this.colorFunction(v);
            if (!this.dataSummary[v] && label && color) this.dataSummary[v] = {
                color: color,
                label: label,
                count: 0
            };
            if (this.dataSummary[v]) {
                this.totalCount++;
                this.dataSummary[v].count++;
            }
        });
        this.logDebug(this.totalCount);
        this.logDebug(JSON.stringify(this.dataSummary));
        Object.keys(this.dataSummary).sort((v1, v2)=>this.dataSummary[v2].count - this.dataSummary[v1].count).slice(0, 3).forEach((value)=>{
            const color = this.dataSummary[value].color;
            const lowContrastOnWhiteClass = (0, $9d480b6dede89078$export$1b0fd8199ce5537b)(color) ? 'low-contrast-white' : '';
            $dc57b31f1b066f38$exports('.stats-elements', this.uiElement).append($dc57b31f1b066f38$exports('<div class="stats-element">    <div class="' + lowContrastOnWhiteClass + ' color" style="background-color: ' + color + '"></div>' + '    <div class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(this.dataSummary[value].count / this.totalCount * 100, 2) + '%</div>' + '</div>'));
        });
        this.uiElement.addClass('classified');
    }
    _generateLegendElements(legendElem) {
        legendElem.append($dc57b31f1b066f38$exports('<table></table>')).addClass('classified');
        Object.keys(this.dataSummary).sort((v1, v2)=>this.chartStyler.getValueLegendIndex(v1) - this.chartStyler.getValueLegendIndex(v2)).forEach((value)=>{
            const color = this.dataSummary[value].color;
            const lowContrastOnWhiteClass = (0, $9d480b6dede89078$export$1b0fd8199ce5537b)(color) ? 'low-contrast-white' : '';
            $dc57b31f1b066f38$exports('table', legendElem).append($dc57b31f1b066f38$exports('<tr>    <td class="color ' + lowContrastOnWhiteClass + '" style="background-color: ' + color + '"></td>' + '    <td class="label">' + '        <label title="' + this.dataSummary[value].label + '">' + this.dataSummary[value].label + '</label>' + '    </td>' + '    <td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(this.dataSummary[value].count / this.totalCount * 100, 2) + '%</td>' + '</tr>'));
        });
    }
}


/**
 * An indicator chart
 * @extends AbstractContainer
 */ class $5180cc201ee0f189$export$d1dc5266372a764e extends (0, $3ec0aa0ced114042$export$d304294fe97dd756) {
    getClassName() {
        return "IndicatorChart";
    }
    /**
     *
     * @param id {string} An HTML id for this indicator chart
     * @param translator {Translator} A translator
     * @param dataSeriesUrl {string}
     * @param layer {Layer} The indicator of this chart
     * @param infoModal {Modal} A modal window to show indicator metadata in
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     */ constructor(id, translator, dataSeriesUrl, layer, infoModal, runtimeConfig, isMobileDevice){
        super(id, translator, isMobileDevice, runtimeConfig);
        this.layer = layer;
        this.infoModal = infoModal;
        this.renderedChart = false;
        this.dataSeriesUrl = dataSeriesUrl;
    }
    /**
     * @param from {Date}
     * @param until {Date}
     * @param wgs84Coords {Array<number>} 2 position array with coords lon lat in wgs84
     */ setFromUntilAndCoords(from, until, wgs84Coords) {
        const timeCalculator = this.layer.getTimeCalculator();
        if (from) {
            this.from = timeCalculator.fixDate((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(from));
            this.unboundedFrom = timeCalculator.min((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(from), this.from);
        }
        if (until) {
            if (timeCalculator.isMonthlyUpdatedTenDaily() || timeCalculator.isTenDailyYearless30Day()) {
                const end = timeCalculator.getEndDateOfPeriod(until);
                this.until = timeCalculator.getLastDayOfMonthFromDate(timeCalculator.getEndDateOfPeriod(end));
                this.unboundedUntil = this.until;
            } else {
                this.until = timeCalculator.fixUnboundedDateUntil((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(until));
                this.unboundedUntil = timeCalculator.max((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(until), this.until);
            }
        }
        if (wgs84Coords && (!this.wgs84Coords || this.wgs84Coords[0] !== wgs84Coords[0] || this.wgs84Coords[1] !== wgs84Coords[1])) this.timeseriesFetcher = this.layer.getTimeseriesFetcher(this.dataSeriesUrl, wgs84Coords);
        this.wgs84Coords = wgs84Coords;
        this._updateChart();
    }
    expand() {
        super.expand();
        if (this.renderedChart) this._relayout();
    }
    _relayout() {
        const chartTarget = $dc57b31f1b066f38$exports('.container .body .chart-container', this.uiElement);
        (0, (/*@__PURE__*/$parcel$interopDefault($a765ec5880d44928$exports))).relayout(chartTarget[0], {
            autosize: true
        });
    }
    _updateChart() {
        this._generateChartElements();
        this._updateFigCaptionContent();
    }
    /**
     * Generate the actual chart elements (and append them to the container elements)
     * @protected
     */ _generateChartElements() {
        $dc57b31f1b066f38$exports('.container .body .chart-container', this.uiElement).empty();
        $dc57b31f1b066f38$exports('.container .body .legend-container', this.uiElement).empty();
        this.renderedChart = false;
        this.loader.show(false);
        this.timeseriesFetcher.loadData(this.from, this.until, this.unboundedFrom, this.unboundedUntil, (data, isRandomData)=>{
            if (data) {
                const timeScales = this.layer.getServiceConfig().getTimeScales();
                const timeCalculator = this.layer.getTimeCalculator();
                const filterTenDayPeriods = (data)=>{
                    const tenDayPeriod = Number(this._getTenDayPeriod());
                    const xValues = [], yValues = [];
                    for(let i = 0; i < data.x.length; i++){
                        const x = data.x[i];
                        if (timeCalculator.getTenDaysFromDate(x) === tenDayPeriod) {
                            xValues.push(timeCalculator.getStartDateOfPeriod(x));
                            yValues.push(data.y[i]);
                        }
                    }
                    data.x = xValues;
                    data.y = yValues;
                    return data;
                };
                const prodCode = timeScales && timeScales.length > 0 ? this.layer.getProductConfigForTimeScale(this._getTimeScale()).getCode() : this.layer.getProductConfig().getCode();
                const data2Render = timeCalculator.isMonthlyUpdatedTenDaily() || timeCalculator.isTenDailyYearless30Day() ? filterTenDayPeriods(data[prodCode]) : data[prodCode];
                this._renderChart([
                    data2Render
                ], isRandomData, undefined);
                const downloadButton = $dc57b31f1b066f38$exports('<button class="download-data-button transparent" title="' + this.translator.translate('tool.charts.download.csv') + '"></button>');
                downloadButton.click(()=>this._downloadData(prodCode));
                $dc57b31f1b066f38$exports('.body .indicator-buttons-container', this.uiElement).empty().append(downloadButton);
            } else {
                $dc57b31f1b066f38$exports('.body .indicator-buttons-container', this.uiElement).empty();
                $dc57b31f1b066f38$exports('.container .body .chart-container', this.uiElement).append($dc57b31f1b066f38$exports('<div class="no-layers">Error loading data</div>'));
            }
            this.loader.hide();
        });
    }
    /**
     * Get a simple stats shower for this indicator chart
     * @param data {Array<number|string>} The data to calculate stats on
     * @return {AbstractSimpleStatsShower}
     * @private
     */ _getSimpleStatsShower(data) {
        const chartStyler = this.layer.getChartStyler();
        const isClassified = chartStyler && chartStyler.isClassified();
        let simpleStatsShower;
        if (isClassified) {
            $dc57b31f1b066f38$exports('.container .body', this.uiElement).addClass('has-simple-stats');
            simpleStatsShower = new (0, $b228fcf3f31b0912$export$87aa6a85768e3c8b)(chartStyler, data, 'indicator_' + this.layer.getCode() + '_classifiedstats', this.translator, this.isMobileDevice, this.runtimeConfig, this.onChangeRuntimeConfig);
        } else {
            $dc57b31f1b066f38$exports('.container .body', this.uiElement).addClass('has-box-plot').addClass('has-simple-stats');
            simpleStatsShower = new (0, $bdd0489754fafde2$export$69ab57c4003c66c1)(this.layer.getNrOfDecimals(), data, 'indicator_' + this.layer.getCode() + '_boxplot', this.translator, this.isMobileDevice, this.runtimeConfig, this.onChangeRuntimeConfig);
        }
        return simpleStatsShower;
    }
    _renderChart(data, isRandomData, annotationDate) {
        const timeCalculator = this.layer.getTimeCalculator();
        const isClassified = this.layer.getChartStyler() && this.layer.getChartStyler().isClassified();
        if (isClassified && data[0].y) data[0].y = data[0].y.map((v)=>v !== null && v !== undefined && !(v instanceof Object) ? v.toString() : v);
        const chartType = this.layer.layerConfig.getChartType();
        let accumulatedData = undefined;
        const isBarsWithLineAndAccumulation = chartType === (0, $815c91046e476159$export$39c0195897d703ce).BARS_WITH_LINE_AND_ACCUMULATION;
        const isBarsWithLine = isBarsWithLineAndAccumulation || chartType === (0, $815c91046e476159$export$39c0195897d703ce).BARS_WITH_LINE;
        const isStackedBars = chartType === (0, $815c91046e476159$export$39c0195897d703ce).STACKED_BARS;
        const simpleStatsShower = isBarsWithLine ? this._getSimpleStatsShower(data.values[0].y) : this._getSimpleStatsShower(data[0].y);
        if (isBarsWithLine) {
            this.yValues = data.values[0].y.slice();
            this.yAvgValues = data.values[1].y.slice();
            this.yStdValues = data.values[2].y.slice();
            if (isBarsWithLineAndAccumulation) {
                this.yAccumValues = data.accumulated[0].y.slice();
                this.yAccumAvgValues = data.accumulated[1].y.slice();
                this.yAccumStdValues = data.accumulated[2].y.slice();
                accumulatedData = data.accumulated;
                data = data.values;
            }
        } else this.yValues = data[0].y.slice();
        this.xValues = data[0].x.slice();
        if (simpleStatsShower) {
            $dc57b31f1b066f38$exports('.container .body', this.uiElement).addClass('has-simple-stats');
            $dc57b31f1b066f38$exports('.container .body .simple-stats-container', this.uiElement).empty().append(simpleStatsShower.getUIElement());
        }
        const width = this._calcBarWidth(data[0].x);
        const offset = 0;
        data[0].width = width;
        data[0].offset = offset;
        const rangeEnd = timeCalculator.isMonthlyUpdatedTenDaily() || timeCalculator.isTenDailyYearless30Day() ? timeCalculator.getLastDayOfMonthFromDate(this.until) : timeCalculator.getEndDateOfPeriod((0, $2536f84a954bf107$export$ce275da88d3dcc54)(data[0].x));
        const layout = {
            hovermode: 'x unified',
            hoverlabel: {
                bgcolor: "#EEEEEE"
            },
            autosize: true,
            height: 185,
            margin: {
                l: isStackedBars ? this.isSmallContainerWidth ? 20 : 30 : this.isSmallContainerWidth ? 45 : 60,
                r: 15,
                b: 35,
                t: 5,
                pad: 2
            },
            paper_bgcolor: "rgba(0,0,0,0)",
            plot_bgcolor: "rgba(0,0,0,0)",
            showlegend: false,
            dragmode: false,
            bargap: 0,
            xaxis: {
                type: 'date',
                range: [
                    data[0].x[0],
                    rangeEnd
                ],
                zerolinewidth: 0.5,
                zerolinecolor: 'rgb(200,200,200)',
                gridcolor: 'rgba(200,200,200,0.5)',
                linecolor: 'rgba(0,0,0,0)',
                linewidth: 0,
                showspikes: true,
                spikemode: 'toaxis+across+marker',
                spikesnap: 'hovered data',
                spikedash: 'dot',
                spikethickness: -2,
                spikecolor: 'rgba(40,110,159,.5)',
                tickmode: 'array',
                tickfont: {
                    size: this.isSmallContainerWidth ? 8 : 11
                }
            },
            yaxis: {
                zerolinewidth: 0.5,
                zerolinecolor: 'rgb(200,200,200)',
                gridcolor: 'rgba(200,200,200,0.5)',
                linecolor: 'rgba(0,0,0,0)',
                linewidth: 0,
                showspikes: true,
                spikemode: 'toaxis+across',
                spikesnap: 'cursor',
                spikedash: 'dot',
                spikethickness: -2,
                spikecolor: 'rgba(40,110,159,.5)',
                tickfont: {
                    size: this.isSmallContainerWidth ? 8 : 11
                }
            }
        };
        if (annotationDate) {
            const firstDate = this.layer.getTimeCalculator().getStartDateOfPeriod(annotationDate);
            const secondDate = this.layer.getTimeCalculator().getEndDateOfPeriod(annotationDate);
            layout.shapes = [
                {
                    type: 'rect',
                    x0: firstDate,
                    x1: secondDate,
                    xref: 'x',
                    y0: 0,
                    y1: 1,
                    yref: 'paper',
                    opacity: .55,
                    fillcolor: 'rgba(0,0,0,0)',
                    line: {
                        dash: 'dash',
                        width: .5,
                        opacity: .5,
                        color: 'rgb(40,110,159)'
                    }
                }
            ];
        }
        const config = {
            responsive: true,
            showSendToCloud: false,
            modeBarButtonsToRemove: [
                'resetscale',
                'select2d',
                'lasso2d',
                'zoom2d',
                'zoomIn2d',
                'zoomOut2d',
                'autoScale2d',
                'pan2d'
            ],
            modebarStyle: {
                orientation: this.isMobileDevice ? 'v' : 'h'
            }
        };
        const handleBarData = (data, layout, isAccumulated = false)=>{
            if (data[0].x.length <= 0 || data[0].y.length <= 0) return undefined;
            const xHoverTexts = timeCalculator.isTenDaily() || timeCalculator.isTenDailyYearless() || timeCalculator.isWeekly() || timeCalculator.isISOWeekly() ? data[0].x.map((x)=>timeCalculator.timeCodeToString(x)) : timeCalculator.isMonthlyUpdatedTenDaily() || timeCalculator.isTenDailyYearless30Day() ? data[0].x.map((x)=>timeCalculator.timeCodeToString(timeCalculator.getNextDate(timeCalculator.getNextDate(x)))) : [];
            const generateXLastPoint = (data)=>{
                data.x.push(this.layer.getTimeCalculator().getNextDate((0, $2536f84a954bf107$export$ce275da88d3dcc54)(data.x)) - 10);
            };
            const generateYLastPoint = (data)=>{
                data.y.push((0, $2536f84a954bf107$export$ce275da88d3dcc54)(data.y));
            };
            data[0].type = 'bar';
            data[0].name = this.getStatsSeriesName();
            data[0].showlegend = false;
            if (timeCalculator.isTenDaily() || timeCalculator.isTenDailyYearless() || timeCalculator.isWeekly() || timeCalculator.isISOWeekly() || timeCalculator.isMonthlyUpdatedTenDaily() || timeCalculator.isTenDailyYearless30Day()) {
                $dc57b31f1b066f38$exports('.chart-container', this.uiElement).addClass('periodicity-' + this.layer.getTimeCalculator().getPeriodicity().getCode());
                data[0].hovertemplate = '%{hovertext}<extra></extra>';
                data[0].hovertext = [];
                for(let i = 0; i < data[0].x.length; i++)data[0].hovertext.push(xHoverTexts[i] + '<br>' + (0, $2536f84a954bf107$export$f5dd818bff069720)(data[0].y[i], this.layer.getNrOfDecimals()));
                layout.hovermode = 'x unified';
                layout.xaxis.hoverformat = ' ';
            } else data[0].hovertemplate = '%{y:.' + this.layer.getNrOfDecimals() + 'f}<extra></extra>';
            if (timeCalculator.isMonthly() || timeCalculator.isMonthlyForecast()) layout.xaxis.tickformat = '%B\n %Y';
            else if (timeCalculator.isYearly()) layout.xaxis.tickformat = '%Y';
            else layout.xaxis.tickformat = '%d %B\n %Y';
            data[0].marker = {
                line: {
                    color: 'rgba(0,0,0,.25)',
                    width: isAccumulated ? .15 : 0.05
                }
            };
            const chartStyler = this.layer.getChartStyler();
            if (!(isAccumulated && isBarsWithLine) && chartStyler) {
                const colorFunction = chartStyler.getColorFunction();
                if (colorFunction) data[0].marker.color = data[0].y.map((v)=>v !== null && v !== undefined ? colorFunction(v) : 'rgba(0,0,0,0)');
            }
            let yAxisLabel;
            if (isAccumulated) {
                const accumulatedChartStyler = this.layer.getAccumulatedChartStyler();
                yAxisLabel = accumulatedChartStyler ? this.translator.translate(accumulatedChartStyler.getYAxisLabel()) : undefined;
            } else yAxisLabel = chartStyler ? this.translator.translate(chartStyler.getYAxisLabel()) : undefined;
            if (yAxisLabel) {
                layout.yaxis.title = {
                    text: yAxisLabel.crop(25),
                    standoff: 10
                };
                layout.yaxis.titlefont = {
                    size: this.isSmallContainerWidth ? 10 : 13,
                    color: '#888888'
                };
            }
            if (isAccumulated && isBarsWithLine && chartStyler) {
                const accumulatedChartStyler = this.layer.getAccumulatedChartStyler();
                if (accumulatedChartStyler) {
                    const accumulatedColorFunction = accumulatedChartStyler.getColorFunction();
                    data[0].marker.color = [];
                    data[0].text = [];
                    for(let i = 0; i < data[0].y.length; i++){
                        const value = data[0].y[i];
                        const diff = value - data[1].y[i];
                        data[0].marker.color.push(accumulatedColorFunction(diff));
                        const sign = diff > 0 ? '+' : '';
                        data[0].text.push(value.toFixed(this.layer.getNrOfDecimals()) + ' | ' + sign + diff.toFixed(this.layer.getNrOfDecimals()));
                    }
                    data[0].legend = new (0, $594237181175c857$export$ed247974535929c7)(this.isMobileDevice, this.translator, [
                        this.layer.layerConfig.allStyles[this.layer.layerConfig.getAccumulatedStyleCode()]
                    ]);
                } else {
                    const minMaxColor = chartStyler.getMinMaxColor();
                    let minValue = Number.MAX_VALUE, maxValue = Number.MIN_VALUE;
                    for(let i = 0; i < data[0].y.length; i++){
                        const diff = data[0].y[i] - data[1].y[i];
                        if (diff < minValue) minValue = diff;
                        if (diff > maxValue) maxValue = diff;
                    }
                    if (maxValue - minValue > 10) {
                        maxValue = Math.ceil(maxValue);
                        minValue = Math.floor(minValue);
                    }
                    if (minMaxColor) {
                        const style = new (0, $3d11af3e54370855$export$d9e45bc13d335801)({
                            code: 'continuous_accum_' + this.layer.getCode(),
                            geometryType: (0, $815c91046e476159$export$427161d533086393).POLYGON.getCode(),
                            attribute: "dummy",
                            styleRules: [
                                {
                                    code: 'dummy',
                                    type: (0, $815c91046e476159$export$23989178094d68d).CONTINUOUS.getCode(),
                                    label: this.translator.translate('tool.charts.accumulated.styleLabel'),
                                    ranges: [
                                        {
                                            minValue: minValue,
                                            maxValue: maxValue,
                                            minLabel: minValue.toFixed(this.layer.getNrOfDecimals()),
                                            maxLabel: maxValue.toFixed(this.layer.getNrOfDecimals()),
                                            minBackgroundColor: minMaxColor[1],
                                            maxBackgroundColor: minMaxColor[0]
                                        }
                                    ]
                                }
                            ]
                        });
                        const dynamicStyler = new (0, $dbb7c37f8910e19f$export$b82f4f1213831c77)(style);
                        data[0].legend = new (0, $594237181175c857$export$ed247974535929c7)(this.isMobileDevice, this.translator, [
                            style
                        ]);
                        const dynamicColorFunction = dynamicStyler.getColorFunction();
                        const colors = [];
                        for(let i = 0; i < data[0].y.length; i++){
                            const diff = data[0].y[i] - data[1].y[i];
                            colors[i] = dynamicColorFunction(diff);
                        }
                        data[0].marker.color = colors;
                    }
                }
            }
            const isClassified = this.layer.getChartStyler() && this.layer.getChartStyler().isClassified();
            if (isClassified) {
                const labelFunction = this.layer.getChartStyler().getLabelFunction();
                data[0].hovertemplate = '%{hovertext}<extra></extra>';
                data[0].hovertext = timeCalculator.isTenDaily() || timeCalculator.isTenDailyYearless() || timeCalculator.isWeekly() || timeCalculator.isISOWeekly() ? [] : data[0].y.map((value)=>labelFunction ? labelFunction(value) : value);
                for(let i = 0; i < data[0].x.length; i++)data[0].hovertext.push(xHoverTexts[i] + '<br>' + (labelFunction ? labelFunction(data[0].y[i]) : data[0].y[i]));
                data[0].originalY = data[0].y.slice();
                data[0].y = data[0].y.map((value)=>value !== null && value !== undefined ? 1 : value);
                layout.xaxis.showgrid = false;
                layout.xaxis.showspikes = true;
                layout.yaxis.showgrid = false;
                layout.yaxis.showticklabels = false;
                layout.yaxis.range = [
                    0,
                    1.5
                ];
                layout.yaxis.showspikes = false;
                layout.height = 100;
                layout.margin.t = 0;
            }
            if (isBarsWithLine) {
                if (data.length > 1) {
                    data[1].type = 'line';
                    data[1].mode = 'lines';
                    data[1].legendgroup = 'stats';
                    if (!data[0].text) data[0].text = data[0].y.map((val, idx)=>val ? val.toFixed(this.layer.getNrOfDecimals()) + ' (' + (val - data[1].y[idx]).toFixed(this.layer.getNrOfDecimals()) + ')' : '');
                    generateXLastPoint(data[1]);
                    generateYLastPoint(data[1]);
                    data[1].width = width;
                    data[1].offset = offset;
                    data[1].name = this.getStatsSeriesName(isAccumulated);
                    data[1].showlegend = true;
                    data[1].hovertemplate = '%{y:.' + this.layer.getNrOfDecimals() + 'f}<extra></extra>';
                    data[0].hovertemplate = '%{text}<extra></extra>';
                    data[0].textposition = 'none';
                    data[1].marker = {
                        color: '#ff6600'
                    };
                    data[1].line = {
                        width: 1.5
                    };
                    layout.showlegend = true;
                    layout.legend = {
                        orientation: 'h',
                        xanchor: "center",
                        x: 0.5,
                        y: -0.25,
                        traceorder: 'reversed',
                        bgcolor: isAccumulated ? 'rgba(100,100,100,.25)' : 'rgba(100,100,100,.1)',
                        font: {
                            size: 10
                        }
                    };
                    layout.height = 350;
                }
                if (data.length > 2) {
                    data[2].type = 'scatter';
                    data[2].mode = 'lines';
                    generateXLastPoint(data[2]);
                    generateYLastPoint(data[2]);
                    data[2].showlegend = false;
                    data[2].hoverinfo = 'skip';
                    data[2].marker = {
                        color: 'rgba(100,100,100,.65)'
                    };
                    data[2].line = {
                        width: 0
                    };
                    data[2].fillcolor = 'rgba(100,100,100,.1)';
                    data[2].fill = 'none';
                    data[2].stackgroup = 'stdev';
                    data[2].legendgroup = data[1].legendgroup;
                    const plus = [], minus = [], avgText = [];
                    for(let i = 0; i < data[1].y.length; i++){
                        const stdev = isAccumulated ? Math.sqrt(data[2].y[i]) : data[2].y[i];
                        const avg = data[1].y[i];
                        plus.push(stdev === null ? null : stdev * 2);
                        minus.push(avg === null || stdev === null ? null : Math.max(0, avg - stdev));
                        avgText.push(avg === null || stdev === null ? null : avg.toFixed(this.layer.getNrOfDecimals()) + " (\xb1 " + stdev.toFixed(this.layer.getNrOfDecimals()) + ')');
                    }
                    data[2].y = minus;
                    data[1].text = avgText;
                    data[1].hovertemplate = '%{text}<extra></extra>';
                    data.push({
                        type: 'scatter',
                        mode: 'lines',
                        x: data[2].x,
                        y: plus,
                        showlegend: false,
                        hoverinfo: 'skip',
                        marker: data[2].marker,
                        line: data[2].line,
                        fill: 'tonexty',
                        fillcolor: isAccumulated ? 'rgba(100,100,100,.25)' : 'rgba(100,100,100,.1)',
                        stackgroup: data[2].stackgroup,
                        legendgroup: data[2].legendgroup
                    });
                    let tmp = data[1];
                    data[1] = data[2];
                    data[2] = tmp;
                }
            }
            return data.slice(0, 4);
        };
        const render = (data, layout, config, chartTarget)=>{
            if (!data) return;
            (0, (/*@__PURE__*/$parcel$interopDefault($a765ec5880d44928$exports))).newPlot(chartTarget[0], data, layout, config);
            new ResizeObserver(()=>this._relayout()).observe(chartTarget[0]);
            setTimeout(()=>{
                this._relayout();
                this.renderedChart = true;
            }, Math.random() * 100);
        };
        if (chartType === (0, $815c91046e476159$export$39c0195897d703ce).BARS || isBarsWithLine) data = handleBarData(data, layout);
        else if (isStackedBars) {
            const stackedData = [];
            layout.barmode = 'stack';
            layout.yaxis.tickvals = [
                0,
                20,
                40,
                60,
                80,
                100
            ];
            layout.yaxis.fixedrange = true;
            layout.yaxis.showgrid = false;
            layout.xaxis.showgrid = false;
            layout.xaxis.range = [
                this.layer.getTimeCalculator().getPreviousDate(data[0].x[0]),
                this.layer.getTimeCalculator().getNextDate((0, $2536f84a954bf107$export$ce275da88d3dcc54)(data[0].x))
            ];
            //this is the way to be able to control the order of the traces on the hover
            layout.legend = {
                traceorder: 'reversed',
                y: .5,
                x: .5,
                orientation: 'v'
            };
            layout.showlegend = true;
            Object.keys(data[0].colors).forEach((label)=>{
                const stackedDataElement = {
                    x: data[0].x,
                    width: width,
                    offset: offset,
                    y: [],
                    showlegend: false,
                    name: label,
                    type: 'bar',
                    barmode: 'stack',
                    sort: false,
                    marker: {
                        color: data[0].colors[label]
                    },
                    hovertemplate: "%{y}%"
                };
                data[0].y.forEach((percentages)=>{
                    stackedDataElement.y.push(percentages[label]);
                });
                stackedData.push(stackedDataElement);
            });
            const ordinals = data[0].ordinals;
            data = stackedData;
            stackedData.sort((sd1, sd2)=>ordinals[sd1.name] - ordinals[sd2.name]);
        }
        if (accumulatedData) {
            const valuesChartTarget = $dc57b31f1b066f38$exports('.container .body .chart-container.values', this.uiElement);
            render(data, layout, config, valuesChartTarget);
            const accumulatedLayout = (0, $2536f84a954bf107$export$9cd59f9826255e47)(layout);
            accumulatedData[0].offset = offset;
            accumulatedData[0].width = width;
            accumulatedData = handleBarData(accumulatedData, accumulatedLayout, true);
            if (!accumulatedData) return;
            const accumulatedChartTarget = $dc57b31f1b066f38$exports('.container .body .chart-container.accumulated', this.uiElement).empty();
            render(accumulatedData, accumulatedLayout, config, accumulatedChartTarget);
            accumulatedChartTarget.append(accumulatedData[0].legend.getChartGraphic());
            if (isBarsWithLine) {
                accumulatedChartTarget.addClass('bars-with-line');
                valuesChartTarget.addClass('bars-with-line');
            }
        } else {
            const target = $dc57b31f1b066f38$exports('.container .body .chart-container', this.uiElement);
            if (isBarsWithLine) target.addClass('bars-with-line');
            render(data, layout, config, target);
        }
        const body = $dc57b31f1b066f38$exports('.container .body', this.uiElement);
        if (isRandomData) body.addClass('random');
        else body.removeClass('random');
        this._addMainLegend();
    }
    /**
     * Get the name for the stats data series (will be shown to the user)
     * (should be overridden)
     * @param isAccumulated {boolean}
     */ getStatsSeriesName(isAccumulated = false) {}
    /**
     * Add the main legend to the container
     * @protected
     */ _addMainLegend() {
        const body = $dc57b31f1b066f38$exports('.container .body', this.uiElement);
        const smallGraphic = this.layer.getChartLegend() ? this.layer.getChartLegend().getChartGraphic() : undefined;
        if (smallGraphic && smallGraphic.length > 0) {
            smallGraphic.click(()=>this.layer.showInfo(this.infoModal)).css('cursor', 'pointer');
            $dc57b31f1b066f38$exports('.container .body .legend-container', this.uiElement).append(smallGraphic);
            body.addClass('has-legend');
        } else body.removeClass('has-legend');
    }
    /**
     * Given an array of dates (for x-axis), return an array of extentsin milliseconds
     * @param x {Array<Date>}
     * @return {Array<number>} integers
     * @protected
     */ _calcBarWidth(x) {
        let lastDate = undefined;
        const width = [];
        x.forEach((date)=>{
            if (lastDate) width.push(Math.round((date - lastDate) / 1000 / 60 / 60 / 24) * 86400000); //round to days
            lastDate = date;
        });
        const lastPeriodStart = (0, $2536f84a954bf107$export$ce275da88d3dcc54)(x);
        const timeCalculator = this.layer.getTimeCalculator();
        let lastWidth = 0;
        switch(timeCalculator.getPeriodicity()){
            case (0, $815c91046e476159$export$45470b399d15bbcb).DAILY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).DAILY_YEARLESS:
                lastWidth = 86400000;
                break;
            case (0, $815c91046e476159$export$45470b399d15bbcb).WEEKLY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).ISO_WEEKLY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS:
            case (0, $815c91046e476159$export$45470b399d15bbcb).YEARLY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_FORECAST:
                lastWidth = timeCalculator.getEndDateOfPeriod(timeCalculator.getNextDate(lastPeriodStart)) - lastPeriodStart;
                break;
            case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS_30DAY:
            case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_UPDATED_TEN_DAILY:
                const tendailyCalculator = new (0, $aeedcab592f41cce$export$41dea944c75fcd24)((0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY);
                lastWidth = tendailyCalculator.getNextDate(tendailyCalculator.getNextDate(tendailyCalculator.getNextDate(lastPeriodStart))) - lastPeriodStart;
                break;
            default:
                break;
        }
        width.push(Math.round(lastWidth + 86400000));
        return width;
    }
    /**
     * Get the current timescale for this indicator (if it has one)
     * @return {TimeScaleEnum|undefined}
     * @protected
     */ _getTimeScale() {
        const sessionProp = this.getSessionProp(this.id + '_timescale');
        return sessionProp ? (0, $815c91046e476159$export$d08fec65c77806fd).getForCode(sessionProp) : this.layer.getTimeScale();
    }
    /**
     * Get the current ten-day period for this indicator (if it has one)
     * @return {number|undefined}
     * @protected
     */ _getTenDayPeriod() {
        const sessionProp = this.getSessionProp(this.id + '_tendays');
        return sessionProp ? Number(sessionProp) : this.layer.getTimeCalculator().getTenDaysFromDate((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.layer.getCurrentTimeCode()));
    }
    /**
     * Set the current timescale for this indicator (if ot has one)
     * @param timeScale {TimeScaleEnum}
     * @protected
     */ _setTimeScale(timeScale) {
        this.setSessionProp(this.id + '_timescale', timeScale.getCode());
        this._updateFigCaptionContent();
    }
    /**
     * Set the current ten-day period for this indicator (if ot has one)
     * @param tenDayPeriod {string}
     * @protected
     */ _setTenDayPeriod(tenDayPeriod) {
        this.setSessionProp(this.id + '_tendays', tenDayPeriod);
        this._updateFigCaptionContent();
    }
    _updateFigCaptionContent() {
        $dc57b31f1b066f38$exports('figure figcaption', this.uiElement).empty().append($dc57b31f1b066f38$exports('<p>Chart for ' + this.layer.getName() + ': From ' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.from) + ' until ' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.layer.getTimeCalculator().fixDateUntil(this.until)) + '</p>' + '<p>Data in CSV format can be downloaded from the download button</p>'));
    }
    getContainerElement() {
        const expanded = this.isExpanded();
        const elements = $dc57b31f1b066f38$exports('<figure>   <figcaption id="figcaption_' + this.layer.getCode() + '"></figcaption>' + '   <div class="chart container ' + (expanded ? 'expanded' : '') + '">' + '      <div class="header" role="heading">' + '          <div class="title"><h3>' + this.getChartTitle() + '</h3></div>' + '          <div class="buttons-container">' + '              <button class="expander ' + (expanded ? 'collapse' : 'expand') + '" type="button" title="' + this.translator.translate('tool.charts.expander') + '"></button>' + '          </div>' + '      </div>' + '      <div class="body" aria-expanded="' + expanded + '">' + '         <div class="simple-stats-container"></div>' + '         <div class="chart-container"></div>' + '         <div class="legend-container"></div>' + '         <div class="indicator-buttons-container"></div>' + '         <div class="random-warning">[Random data]</div>' + '      </div>' + '   </div>' + '</figure>');
        this.loader = new (0, $b3069bed9c6337dc$export$3b0d6d7590275603)('loader_' + this.layer.getCode(), this.isMobileDevice, $dc57b31f1b066f38$exports('.body', elements));
        const timeScales = this.layer.getServiceConfig().getTimeScales();
        if (timeScales && timeScales.length > 1) {
            const currentTimeScale = this._getTimeScale() ? this._getTimeScale() : timeScales[0];
            const timeScaleDropdownId = this.getCode() + '_report_timeScale_dropdown';
            const timeScaleContainer = $dc57b31f1b066f38$exports('<div class="dropdown-container time-scale-container"><label for="' + timeScaleDropdownId + '"> | ' + this.translator.translate('layer.timescale.dropdown.label') + '</label></div>');
            const timeScaleOptions = timeScales.map((ts)=>{
                return new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, ts.getLocalizationKey(), ts.getCode(), undefined);
            });
            this.timeScaleDropdown = new (0, $d0c219b43b862888$export$931cbfb6bfb85fc)(this.translator, this.isMobileDevice, timeScaleDropdownId, timeScaleOptions, currentTimeScale ? currentTimeScale.getCode() : undefined, true, undefined, (dropDown)=>{
                const timeScale = (0, $815c91046e476159$export$d08fec65c77806fd).getForCode(dropDown.getValue());
                if (this._getTimeScale().getCode() !== timeScale.getCode()) {
                    this._setTimeScale(timeScale);
                    $dc57b31f1b066f38$exports('.header .title h3', this.uiElement).html(this.layer.getNameForTimeScale(timeScale));
                    this._updateChart();
                }
            }, undefined);
            timeScaleContainer.append(this.timeScaleDropdown.getUIElement());
            $dc57b31f1b066f38$exports('.header', elements).append(timeScaleContainer);
        }
        if (this.layer.getTimeCalculator().isMonthlyUpdatedTenDaily() || this.layer.getTimeCalculator().isTenDailyYearless30Day()) {
            const tendDaysDropdownId = this.getCode() + '_report_tendays_dropdown';
            const tenDaysScaleContainer = $dc57b31f1b066f38$exports('<div class="dropdown-container ten-days-container"><label for="' + tendDaysDropdownId + '"> | ' + this.translator.translate('layer.tenday.slider.label') + '</label></div>');
            const tenDaysOptions = [
                {
                    name: 'layer.tenday.slider.options.first',
                    code: '1'
                },
                {
                    name: 'layer.tenday.slider.options.second',
                    code: '2'
                },
                {
                    name: 'layer.tenday.slider.options.third',
                    code: '3'
                }
            ].map((ts)=>{
                return new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, ts.name, ts.code, undefined);
            });
            this.tenDaysDropdown = new (0, $d0c219b43b862888$export$931cbfb6bfb85fc)(this.translator, this.isMobileDevice, tendDaysDropdownId, tenDaysOptions, this._getTenDayPeriod() + "", true, undefined, (dropDown)=>{
                if (this._getTenDayPeriod() + "" !== dropDown.getValue()) {
                    this._setTenDayPeriod(dropDown.getValue());
                    this._updateChart();
                }
            }, undefined);
            tenDaysScaleContainer.append(this.tenDaysDropdown.getUIElement());
            $dc57b31f1b066f38$exports('.header', elements).append(tenDaysScaleContainer);
        }
        return elements;
    }
    getChartTitle() {
        const timeScales = this.layer.getServiceConfig().getTimeScales();
        const currentTimeScale = this._getTimeScale() ? this._getTimeScale() : timeScales[0];
        return this.layer.getNameForTimeScale(currentTimeScale);
    }
    getUIElement() {
        const uiElement = super.getUIElement();
        return uiElement.attr('aria-labelledby', 'figcaption_' + this.layer.getCode()).attr('role', 'figure');
    }
    _downloadData(productCode) {
        const rows = [];
        if (this.layer.getChartType() === (0, $815c91046e476159$export$39c0195897d703ce).STACKED_BARS) {
            const keys = Object.keys(this.yValues[0]);
            rows.push([
                'date'
            ].concat(keys));
            for(let i = 0; i < this.xValues.length; i++){
                const y = keys.map((k)=>this.yValues[i][k]);
                rows.push([
                    (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.xValues[i])
                ].concat(y));
            }
        } else {
            rows.push([
                'date',
                'value'
            ]);
            if (this.yAvgValues) rows[0].push('avg');
            if (this.yStdValues) rows[0].push('std');
            if (this.yAccumValues) rows[0].push('cumulative');
            if (this.yAccumAvgValues) rows[0].push('cumulative_avg');
            if (this.yAccumStdValues) rows[0].push('cumulative_std');
            for(let i = 0; i < this.xValues.length; i++){
                const y = [];
                y.push(this.yValues[i]);
                if (this.yAvgValues) y.push(this.yAvgValues[i]);
                if (this.yStdValues) y.push(this.yStdValues[i]);
                if (this.yAccumValues) y.push(this.yAccumValues[i]);
                if (this.yAccumAvgValues) y.push(this.yAccumAvgValues[i]);
                if (this.yAccumStdValues) y.push(this.yAccumStdValues[i]);
                rows.push([
                    (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.xValues[i])
                ].concat(y));
            }
        }
        const encodedUri = encodeURI("data:text/csv;charset=utf-8," + rows.map((r)=>r.join(',')).join("\n"));
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", productCode + "_" + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.from) + "_" + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.until) + ".csv");
        document.body.appendChild(link); // Required for FF
        link.click();
        link.remove();
        this.logStat("DOWNLOAD_CSV");
    }
}
class $5180cc201ee0f189$export$acdeaeba4c73485f extends $5180cc201ee0f189$export$d1dc5266372a764e {
    getClassName() {
        return "FeatureIndicatorChart";
    }
    /**
     *
     * @param id {string} An HTML id for this indicator chart
     * @param featureName {string} The name of the feature being charted
     * @param translator {Translator} A translator
     * @param layer {Layer} The indicator of this chart
     * @param infoModal {Modal} A modal window to show indicator metadata in
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     */ constructor(id, featureName, translator, layer, infoModal, runtimeConfig, isMobileDevice){
        super(id, translator, undefined, layer, infoModal, runtimeConfig, isMobileDevice);
        this.featureName = featureName;
    }
    getChartTitle() {
        return super.getChartTitle() + (this.featureName ? ' - ' + this.featureName : '');
    }
    /**
     * @param from {Date}
     * @param until {Date}
     * @param wgs84Coords {Array<number>} 2 position array with coords lon lat in wgs84
     * @param featureProps {Object} OL Feature properties
     */ setFromUntilAndCoords(from, until, wgs84Coords, featureProps) {
        if (from) {
            this.from = this.layer.getTimeCalculator().fixDate((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(from));
            this.unboundedFrom = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(from);
        }
        if (until) {
            this.until = this.layer.getTimeCalculator().fixUnboundedDateUntil((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(until));
            this.unboundedUntil = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(until);
        }
        if (!this.wgs84Coords) this.wgs84Coords = wgs84Coords;
        if (!this.featureProps) {
            this.featureProps = featureProps;
            this.timeseriesFetcher = this.layer.getTimeseriesFetcherForFeature(this.featureProps);
        }
        this._updateChart();
    }
}
class $5180cc201ee0f189$export$f91b2ab4587bd324 extends $5180cc201ee0f189$export$d1dc5266372a764e {
    getClassName() {
        return "IndicatorWithAccumulationChart";
    }
    _addMainLegend() {
        const body = $dc57b31f1b066f38$exports('.container .body', this.uiElement);
        const smallGraphic = this.layer.getChartLegend() ? this.layer.getChartLegend().getChartGraphic() : undefined;
        if (smallGraphic && smallGraphic.length > 0) {
            smallGraphic.click(()=>this.layer.showInfo(this.infoModal)).css('cursor', 'pointer');
            $dc57b31f1b066f38$exports('.container .body .chart-container.values', this.uiElement).append(smallGraphic);
        }
        body.removeClass('has-legend');
        $dc57b31f1b066f38$exports(body.children('.legend-container')[0]).remove();
    }
}



function $4cbe6e39851964f1$var$_toggleExclusiveLayerVisibility(layer, input) {
    const visible = input.val() === layer.getCode();
    layer.logStat(visible ? "SHOW" : "HIDE");
    layer.setVisible(visible);
}
/**
 * A layer tree UI element
 * @extends UIElement
 */ class $4cbe6e39851964f1$export$e7e550d5f76e5c44 extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param slimPanel {SlimPanel} A slim panel to display the layers options
     * @param chartModal {Modal} A modal to show the timeseries chart in
     * @param infoModal {Modal} A modal to show indicator information in
     * @param layerTreeConfigs {Array<LayerTreeElementConfig>} The configurations for the tree
     * @param tileGridGetter {function} A function that given a service config, returns a map's TileGrid
     * @param projection {Projection} Map's current projection
     * @param runtimeConfig {MapRuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param onChangeVisibleLayers {function} A callback to be called when visible layers change
     * @param fit {function} A function that takes an extent (wgs84) and fits the map there
     */ constructor(translator, isMobileDevice, slimPanel, chartModal, infoModal, layerTreeConfigs, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers, fit){
        super('layer_tree_ui_element', translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.slimPanel = slimPanel;
        this.chartModal = chartModal;
        this.infoModal = infoModal;
        this.layerTreeConfigs = layerTreeConfigs;
        this.tileGridGetter = tileGridGetter;
        this.projection = projection;
        this.onChangeVisibleLayers = onChangeVisibleLayers;
        this.fit = fit;
        this.layerTree = [];
        this.oLLayers = [];
        this.oLVectorOverlays = [];
        for(let lt in this.layerTreeConfigs){
            let layerTreeConfig = this.layerTreeConfigs[lt];
            const deviceVisibility = layerTreeConfig.getDeviceVisibility();
            if (deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).BOTH || !this.isMobileDevice && deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).DESKTOP || this.isMobileDevice && deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).MOBILE) {
                if (layerTreeConfig.getType() === (0, $815c91046e476159$export$9ae7e512bcbacef8).CLASSIFIER) {
                    let layerClassifier = new $4cbe6e39851964f1$var$LayerTreeClassifier(translator, isMobileDevice, slimPanel, chartModal, infoModal, layerTreeConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, false, 'root', onChangeVisibleLayers);
                    this.layerTree.push(layerClassifier);
                    const renderOrdinal = layerClassifier.getRenderOrdinal();
                    this.oLLayers[renderOrdinal !== undefined && renderOrdinal !== null ? renderOrdinal : lt] = layerClassifier.getOLLayers();
                    this.oLVectorOverlays = this.oLVectorOverlays.concat(layerClassifier.getOLVectorOverlays());
                } else if (layerTreeConfig.getType() === (0, $815c91046e476159$export$9ae7e512bcbacef8).LAYER) {
                    let layer = new $4cbe6e39851964f1$export$936d0764594b6eb3(translator, isMobileDevice, slimPanel, chartModal, infoModal, layerTreeConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, false, 'root', onChangeVisibleLayers).add2LayersByTimeTag();
                    this.layerTree.push(layer);
                    const renderOrdinal = layer.getRenderOrdinal();
                    this.oLLayers[renderOrdinal !== undefined && renderOrdinal !== null ? renderOrdinal : lt] = layer.getOLLayers();
                    this.oLVectorOverlays = this.oLVectorOverlays.concat(layer.getOLVectorOverlays());
                }
            }
        }
    }
    /**
     * Get the OpenLayers layers
     * @return {Array<Layer>}
     */ getOLLayers() {
        let res = [];
        const processMap = (map)=>{
            Object.keys(map).sort().forEach((ordinal)=>{
                if (Array.isArray(map[ordinal])) res = res.concat(map[ordinal]);
                else processMap(map[ordinal]);
            });
        };
        processMap(this.oLLayers);
        return res;
    }
    /**
     * Get all the layer overlays, if any
     * @return {Array<Overlay>}
     */ getOverlays() {
        return this.getLayers().map((l)=>l.getOverlays()).flat();
    }
    /**
     * Get the OpenLayers vector overlays
     * @return {Array<VectorLayer>}
     */ getOLVectorOverlays() {
        return this.oLVectorOverlays;
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div class="layer-tree-body"></div>');
            let ul = $dc57b31f1b066f38$exports('<ul role="tree"></ul>');
            this.uiElement.append(ul);
            for(let lt in this.layerTree){
                let li = $dc57b31f1b066f38$exports('<li role="treeitem"></li>');
                li.append(this.layerTree[lt].getUIElement());
                ul.append(li);
            }
            if (this.fit) this.getLayers().forEach((l)=>{
                if (l.getExtentWgs84()) $dc57b31f1b066f38$exports('.layer-container.layer-code-' + l.getCodeHtmlClass() + ' .layer-options button.layer-zoom2extent-button', this.uiElement).click(()=>{
                    this.fit(l.getExtentWgs84());
                    this.logStat('ZOOM_TO_LAYER_EXTENT {' + l.getCode() + '}');
                });
            });
        }
        return this.uiElement;
    }
    /**
     * Set the map's current projection
     * @param projection {Projection}
     */ setProjection(projection) {
        this.projection = projection;
        for(let lt in this.layerTree)this.layerTree[lt].setProjection(projection);
    }
    /**
     * Get the list of visible layers
     * @return {Array<Layer>}
     */ getVisibleLayers() {
        let result = [];
        for(let lt in this.layerTree)result = result.concat(this.layerTree[lt].getVisibleLayers());
        return result;
    }
    /**
     * Get all the layers
     * @return {Array<Layer>}
     */ getLayers() {
        let result = [];
        for(let lt in this.layerTree)result = result.concat(this.layerTree[lt].getLayers());
        return result;
    }
    /**
     * To be called by TumboMap when there is navigation on the map
     * It should not be called more than 1 time every 500ms
     * @param zoomLevel {number} The new zoom level (integer)
     * @param centerWgs84 {Array<number>} The new center coordinates (WGS84)
     * @param extentWgs84 {Array<number>|undefined} The new map extent (WGS84)
     */ onNavigation(zoomLevel, centerWgs84, extentWgs84) {
        for(let lt in this.layerTree)this.layerTree[lt].onNavigation(zoomLevel, centerWgs84, extentWgs84);
    }
}
/**
 * A layer list
 * @extends UIElement
 */ class $4cbe6e39851964f1$var$LayerList extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     * @param id {string} A uinique id of this layer list
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param slimPanel {SlimPanel} A slim panel to display the layers options
     * @param infoModal {Modal} A modal to show indicator information in
     * @param layersConfig {Array<LayerListElementConfig>} The configurations for the layers (or layer groups) in the list
     * @param tileGridGetter {function} A function that given a service config, returns a map's TileGrid
     * @param projection {Projection} Map's current projection
     * @param runtimeConfig {MapRuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param onChangeVisibleLayers {function} A callback to be called when visible layers change
     */ constructor(id, translator, isMobileDevice, slimPanel, infoModal, layersConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers){
        super(id, translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.slimPanel = slimPanel;
        this.infoModal = infoModal;
        this.layersConfig = layersConfig;
        this.tileGridGetter = tileGridGetter;
        this.projection = projection;
        this.onChangeVisibleLayers = onChangeVisibleLayers;
        this.oLLayers = [];
        this.layers = [];
        this.listElements = [];
    }
    /**
     * Get the OpenLayers layers
     * @return {Array<Layer>}
     */ getOLLayers() {
        return this.oLLayers;
    }
    /**
     * Get all the layer overlays, if any
     * @return {Array<Overlay>}
     */ getOverlays() {
        return this.layers.map((l)=>l.getOverlays()).flat();
    }
    /**
     * Set the map's current projection
     * @param projection {Projection}
     */ setProjection(projection) {
        this.projection = projection;
        for(let l in this.layers)this.layers[l].setProjection(projection);
    }
    /**
     * To be called by TumboMap when there is navigation on the map
     * It should not be called more than 1 time every 500ms
     * @param zoomLevel {number} The new zoom level (integer)
     * @param centerWgs84 {Array<number>} The new center coordinates (WGS84)
     * @param extentWgs84 {Array<number>} The new map extent (WGS84)
     */ onNavigation(zoomLevel, centerWgs84, extentWgs84) {
        for(let l in this.layers)this.layers[l].onNavigation(zoomLevel, centerWgs84, extentWgs84);
    }
    /**
     * Get the list of visible layers
     * @return {Array<Layer>}
     */ getVisibleLayers() {
        return this.layers.filter((l)=>l.isVisible());
    }
    /**
     * Get the list of all layers
     * @return {Array<Layer>}
     */ getLayers() {
        return this.layers;
    }
}
/**
 * A list of base layers an UI element
 * @extends LayerList
 * @hideconstructor
 */ class $4cbe6e39851964f1$export$dc65e4fa42e1cb56 extends $4cbe6e39851964f1$var$LayerList {
    constructor(translator, isMobileDevice, slimPanel, infoModal, layersConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers, setMapBackgroundColor){
        super('base_layer_list', translator, isMobileDevice, slimPanel, infoModal, layersConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers);
        this.layersConfig.forEach((listElementConfig)=>{
            const deviceVisibility = listElementConfig.getDeviceVisibility();
            if (deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).BOTH || !this.isMobileDevice && deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).DESKTOP || this.isMobileDevice && deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).MOBILE) {
                if (listElementConfig.getType() === (0, $815c91046e476159$export$9ae7e512bcbacef8).CLASSIFIER) {
                    const children = listElementConfig.getChildren().map((childConfig)=>{
                        return new $4cbe6e39851964f1$export$9a5c645bcfeb4118(translator, isMobileDevice, slimPanel, infoModal, childConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers, setMapBackgroundColor);
                    });
                    children.forEach((child)=>{
                        this.layers.push(child);
                        this.oLLayers = this.oLLayers.concat(child.getOLLayers());
                    });
                    const layerListClassifier = new $4cbe6e39851964f1$var$LayerListClassifier(translator, isMobileDevice, listElementConfig, children, runtimeConfig, onChangeRuntimeConfig);
                    this.listElements.push(layerListClassifier);
                } else {
                    const baseLayer = new $4cbe6e39851964f1$export$9a5c645bcfeb4118(translator, isMobileDevice, slimPanel, infoModal, listElementConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers, setMapBackgroundColor);
                    this.layers.push(baseLayer);
                    this.listElements.push(baseLayer);
                    this.oLLayers = this.oLLayers.concat(baseLayer.getOLLayers());
                }
            }
        });
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div role="list" class="base-layer-list-body"></div>');
            this.listElements.forEach((elem)=>this.uiElement.append(elem.getUIElement()));
            this.layers.forEach((baseLayer)=>{
                const input = $dc57b31f1b066f38$exports('.checkbox-container>input[type=radio][name=base_layer]', this.uiElement);
                input.change(function() {
                    $4cbe6e39851964f1$var$_toggleExclusiveLayerVisibility(baseLayer, $dc57b31f1b066f38$exports(this));
                });
                baseLayer.visibility(baseLayer.isVisible());
                if (!baseLayer.isEnabled()) baseLayer.disable();
            });
        }
        return this.uiElement;
    }
    /**
     * Enable this base layer list
     */ enable() {
        this.layers.forEach((l)=>{
            l.enable();
        });
    }
    /**
     * Disable this base layer list
     */ disable() {
        this.layers.forEach((l)=>{
            l.disable();
        });
    }
}
/**
 * A list of context layers an UI element
 * @extends LayerList
 * @hideconstructor
 */ class $4cbe6e39851964f1$export$886f155b74c39d1d extends $4cbe6e39851964f1$var$LayerList {
    constructor(translator, isMobileDevice, slimPanel, infoModal, layersConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers){
        super('context_layer_list', translator, isMobileDevice, slimPanel, infoModal, layersConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers);
        this.layersConfig.forEach((listElementConfig)=>{
            const deviceVisibility = listElementConfig.getDeviceVisibility();
            if (deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).BOTH || !this.isMobileDevice && deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).DESKTOP || this.isMobileDevice && deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).MOBILE) {
                if (listElementConfig.getType() === (0, $815c91046e476159$export$9ae7e512bcbacef8).CLASSIFIER) {
                    const children = listElementConfig.getChildren().map((childConfig)=>{
                        return new $4cbe6e39851964f1$export$5e6fcee974d9d9d7(translator, isMobileDevice, slimPanel, infoModal, childConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers);
                    });
                    children.forEach((child)=>{
                        this.layers.push(child);
                        this.oLLayers = this.oLLayers.concat(child.getOLLayers());
                    });
                    const layerListClassifier = new $4cbe6e39851964f1$var$LayerListClassifier(translator, isMobileDevice, listElementConfig, children, runtimeConfig, onChangeRuntimeConfig);
                    this.listElements.push(layerListClassifier);
                } else {
                    const contextLayer = new $4cbe6e39851964f1$export$5e6fcee974d9d9d7(translator, isMobileDevice, slimPanel, infoModal, listElementConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers);
                    this.layers.push(contextLayer);
                    this.listElements.push(contextLayer);
                    this.oLLayers = this.oLLayers.concat(contextLayer.getOLLayers());
                }
            }
        });
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div role="list" class="context-layer-list-body"></div>');
            for(const cl in this.listElements)this.uiElement.append(this.listElements[cl].getUIElement());
        }
        return this.uiElement;
    }
}
/**
 * A layer classifier (tree node)
 * @extends UIElement
 */ class $4cbe6e39851964f1$var$LayerTreeClassifier extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param slimPanel {SlimPanel} A slim panel to display the layers options
     * @param chartModal {Modal} A modal to show the timeseries chart in
     * @param infoModal {Modal} A modal to show indicator information in
     * @param classifierConfig {Object} The classifier config
     * @param tileGridGetter {function} A function that given a service config, returns a map's TileGrid
     * @param projection {Projection} Map's current projection
     * @param runtimeConfig {MapRuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param exclusive {boolean} Is this node mutually exclusive with its siblings?
     * @param parentName {string} The name of the parent of this classifier
     * @param onChangeVisibleLayers {function} A callback to be called when visible layers change
     */ constructor(translator, isMobileDevice, slimPanel, chartModal, infoModal, classifierConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, exclusive, parentName, onChangeVisibleLayers){
        super(classifierConfig.getCode(), translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.slimPanel = slimPanel;
        this.chartModal = chartModal;
        this.infoModal = infoModal;
        this.classifierConfig = classifierConfig;
        this.exclusive = exclusive;
        this.parentName = parentName;
        this.oLLayers = {};
        this.oLVectorOverlays = [];
        this.children = [];
        this.locationVisible = true;
        this.onChangeVisibleLayers = onChangeVisibleLayers;
        let childrenConfig = this.classifierConfig.getChildren();
        for(let c in childrenConfig){
            let childConfig = childrenConfig[c];
            const deviceVisibility = childConfig.getDeviceVisibility();
            if (deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).BOTH || !this.isMobileDevice && deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).DESKTOP || this.isMobileDevice && deviceVisibility === (0, $815c91046e476159$export$54c4fd5984b65e0b).MOBILE) {
                if (childConfig.getType() === (0, $815c91046e476159$export$9ae7e512bcbacef8).CLASSIFIER) {
                    let layerClassifier = new $4cbe6e39851964f1$var$LayerTreeClassifier(translator, isMobileDevice, slimPanel, chartModal, infoModal, childConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, this.classifierConfig.isMutuallyExclusive(), this.getCode(), this.onChangeVisibleLayers);
                    const renderOrdinal = layerClassifier.getRenderOrdinal();
                    this.oLLayers[renderOrdinal !== undefined && renderOrdinal !== null ? renderOrdinal : c] = layerClassifier.getOLLayers();
                    this.oLVectorOverlays = this.oLVectorOverlays.concat(layerClassifier.getOLVectorOverlays());
                    this.children.push(layerClassifier);
                } else if (childConfig.getType() === (0, $815c91046e476159$export$9ae7e512bcbacef8).LAYER) {
                    let layer = new $4cbe6e39851964f1$export$936d0764594b6eb3(translator, isMobileDevice, slimPanel, chartModal, infoModal, childConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, this.classifierConfig.isMutuallyExclusive(), this.getCode(), this.onChangeVisibleLayers).add2LayersByTimeTag();
                    const renderOrdinal = layer.getRenderOrdinal();
                    this.oLLayers[renderOrdinal !== undefined && renderOrdinal !== null ? renderOrdinal : c] = layer.getOLLayers();
                    this.oLVectorOverlays = this.oLVectorOverlays.concat(layer.getOLVectorOverlays());
                    this.children.push(layer);
                }
            }
        }
        this.visibility(this.isVisible());
    }
    getCode() {
        return this.classifierConfig.getCode();
    }
    getRenderOrdinal() {
        return this.classifierConfig.getRenderOrdinal();
    }
    /**
     * Get the OpenLayers layers
     * @return {Array<Layer>}
     */ getOLLayers() {
        let res = [];
        const processMap = (map)=>{
            Object.keys(map).sort().forEach((ordinal)=>{
                if (Array.isArray(map[ordinal])) res = res.concat(map[ordinal]);
                else processMap(map[ordinal]);
            });
        };
        processMap(this.oLLayers);
        return res;
    }
    /**
     * Get the OpenLayers vector overlays
     * @return {Array<VectorLayer>}
     */ getOLVectorOverlays() {
        return this.oLVectorOverlays;
    }
    getUIElement() {
        if (!this.uiElement) {
            const isExpanded = this.isExpanded();
            this.uiElement = $dc57b31f1b066f38$exports('<div class="layer-classifier-container layer-classifier-code-' + this.getCodeHtmlClass() + ' ' + (isExpanded ? 'expanded' : '') + '">' + '  <div class="layer-classifier-header tree-header">' + '    <button tabindex="0" class="caret ' + (isExpanded ? 'caret-down' : '') + '" title="' + this.translator.translate('layer.tree.expander') + '"></button>' + '    <div class="layer-classifier-checkbox-container checkbox-container">' + '        <input tabindex="0" id="classifier_' + this.getCodeHtmlClass() + '" value="' + this.getCode() + '" name="' + this.parentName + '" type="' + (this.exclusive ? 'radio' : 'checkbox') + '" ' + (this.isVisible() ? 'checked="checked"' : '') + ' />' + '    </div>' + '    <div class="layer-classifier-name"><label for="classifier_' + this.getCodeHtmlClass() + '">' + this.classifierConfig.getName() + '</label></div>' + '  </div>' + '  <div role="group" aria-expanded="' + !!isExpanded + '" class="layer-classifier-body" ' + (isExpanded ? '' : 'hidden') + ' style="' + (!isExpanded ? 'display:none' : '') + '"></div>' + '</div>');
            const self = this;
            $dc57b31f1b066f38$exports('.layer-classifier-checkbox-container>input[type=checkbox]', this.uiElement).change(function() {
                const visible = $dc57b31f1b066f38$exports(this).is(':checked');
                self.logStat(visible ? "SHOW" : "HIDE");
                self.setVisible(visible);
            });
            $dc57b31f1b066f38$exports('.layer-classifier-header button.caret', this.uiElement).click(()=>{
                const expand = !this.isExpanded();
                this.logStat(expand ? "EXPAND" : "COLLAPSE");
                this.setExpanded(expand);
            });
            const ul = $dc57b31f1b066f38$exports('<ul></ul>');
            this.children.forEach((child)=>{
                ul.append($dc57b31f1b066f38$exports('<li role="treeitem"></li>').append(child.getUIElement()));
            });
            $dc57b31f1b066f38$exports('.layer-classifier-body', this.uiElement).append(ul);
            if (this.classifierConfig.isMutuallyExclusive()) this.children.forEach((child)=>{
                const input = $dc57b31f1b066f38$exports('.checkbox-container>input[type=radio][name=' + this.getCode() + ']', this.uiElement);
                input.change(function() {
                    $4cbe6e39851964f1$var$_toggleExclusiveLayerVisibility(child, $dc57b31f1b066f38$exports(this));
                });
                child.visibility(child.isVisible());
            });
        }
        return this.uiElement;
    }
    /**
     * Is this classifier visible? (means: are its child layers visible in the map?)
     * @return {boolean}
     */ isVisible() {
        return this.classifierConfig.isVisible();
    }
    /**
     * Is this classifier expanded?
     * @return {boolean}
     */ isExpanded() {
        return this.classifierConfig.isExpanded();
    }
    /**
     * Expand/collapse classifier
     * @param isExpanded {boolean} if true, expands
     */ setExpanded(isExpanded) {
        const container = $dc57b31f1b066f38$exports('.layer-classifier-code-' + this.getCodeHtmlClass());
        const caret = $dc57b31f1b066f38$exports('.layer-classifier-code-' + this.getCodeHtmlClass() + '>.layer-classifier-header>button.caret');
        const body = $dc57b31f1b066f38$exports('.layer-classifier-code-' + this.getCodeHtmlClass() + '>.layer-classifier-body');
        if (isExpanded) {
            caret.addClass('caret-down');
            container.addClass('expanded');
            body.slideDown(600).removeAttr('hidden').attr('aria-expanded', 'true');
        } else {
            caret.removeClass('caret-down');
            container.removeClass('expanded');
            body.slideUp(400).attr('hidden', '').attr('aria-expanded', 'false');
        }
        this.runtimeConfig.setClassifierExpanded(this.getCode(), isExpanded);
        this.onChangeRuntimeConfig();
    }
    /**
     * set classifier visible (means: are set child layers visible in the map, unless those are themselves not visible)
     * @param isVisible {boolean} if true, sets visible
     */ setVisible(isVisible) {
        this.runtimeConfig.setClassifierVisibility(this.getCode(), isVisible);
        this.onChangeRuntimeConfig();
        this.visibility(isVisible);
    }
    visibility(isVisible) {
        isVisible = isVisible && this.isVisible();
        if (!isVisible || !this.locationVisible) {
            this.disable();
            $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.checkbox-container>input', this.getUIElement())[0]).removeAttr('disabled');
        } else if (isVisible && this.locationVisible) this.enable();
    }
    /**
     * Set the map's current projection
     * @param projection {Projection}
     */ setProjection(projection) {
        this.projection = projection;
        for(let c in this.children)this.children[c].setProjection(projection);
    }
    /**
     * Disable this classifier
     */ disable() {
        this.getUIElement().addClass('disabled');
        $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.checkbox-container>input', this.getUIElement())[0]).attr('disabled', 'disabled');
        this.children.forEach((child)=>{
            child.disable();
        });
    }
    /**
     * Enable this classifier
     */ enable() {
        $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('.checkbox-container>input', this.getUIElement())[0]).removeAttr('disabled');
        if (this.isVisible()) {
            this.getUIElement().removeClass('disabled');
            this.children.forEach((child)=>{
                child.enable();
            });
        }
    }
    /**
     * Get the list of visible layers
     * @return {Array<Layer>}
     */ getVisibleLayers() {
        if (!this.isVisible()) return [];
        let result = [];
        for(let c in this.children)result = result.concat(this.children[c].getVisibleLayers());
        return result;
    }
    /**
     * Get all the layers
     * @return {Array<Layer>}
     */ getLayers() {
        let result = [];
        for(let lt in this.children)result = result.concat(this.children[lt].getLayers());
        return result;
    }
    onNavigation(zoomLevel, centerWgs84, extentWgs84) {
        this.children.forEach((child)=>{
            child.onNavigation(zoomLevel, centerWgs84, extentWgs84);
        });
    }
}
/**
 * A layer classifier (list group)
 * @extends UIElement
 */ class $4cbe6e39851964f1$var$LayerListClassifier extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param classifierConfig {Object} The classifier config
     * @param children {Array<BaseLayer>} The children of this classifier
     * @param runtimeConfig {MapRuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */ constructor(translator, isMobileDevice, classifierConfig, children, runtimeConfig, onChangeRuntimeConfig){
        super(classifierConfig.getCode(), translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.classifierConfig = classifierConfig;
        this.children = children;
    }
    getCode() {
        return this.classifierConfig.getCode();
    }
    getUIElement() {
        if (!this.uiElement) {
            if (this.children.filter((c)=>c.isVisible()).length > 0) this.setExpanded(true);
            const isExpanded = this.isExpanded();
            this.uiElement = $dc57b31f1b066f38$exports('<div class="layer-list-classifier-container layer-list-classifier-code-' + this.getCodeHtmlClass() + ' ' + (isExpanded ? 'expanded' : '') + '">' + '  <div class="layer-list-classifier-header tree-header">' + '    <button class="caret ' + (isExpanded ? 'caret-down' : '') + '" title="' + this.translator.translate('layer.tree.expander') + '"></button>' + '    <div class="layer-list-classifier-name"><label>' + this.classifierConfig.getName() + '</label></div>' + '  </div>' + '  <div role="group" aria-expanded="' + !!isExpanded + '" class="layer-list-classifier-body" ' + (isExpanded ? '' : 'hidden') + ' style="' + (!isExpanded ? 'display:none' : '') + '"></div>' + '</div>');
            $dc57b31f1b066f38$exports('.layer-list-classifier-header button.caret', this.uiElement).click(()=>{
                const expand = !this.isExpanded();
                this.logStat(expand ? "EXPAND" : "COLLAPSE");
                this.setExpanded(expand);
            });
            const ul = $dc57b31f1b066f38$exports('<ul></ul>');
            this.children.forEach((child)=>{
                ul.append($dc57b31f1b066f38$exports('<li role="listitem"></li>').append(child.getUIElement()));
            });
            $dc57b31f1b066f38$exports('.layer-list-classifier-body', this.uiElement).append(ul);
        }
        return this.uiElement;
    }
    /**
     * Is this classifier expanded?
     * @return {boolean}
     */ isExpanded() {
        return this.classifierConfig.isExpanded();
    }
    /**
     * Expand/collapse classifier
     * @param isExpanded {boolean} if true, expands
     */ setExpanded(isExpanded) {
        const container = $dc57b31f1b066f38$exports('.layer-list-classifier-code-' + this.getCodeHtmlClass());
        const caret = $dc57b31f1b066f38$exports('.layer-list-classifier-code-' + this.getCodeHtmlClass() + '>.layer-list-classifier-header>button.caret');
        const body = $dc57b31f1b066f38$exports('.layer-list-classifier-code-' + this.getCodeHtmlClass() + '>.layer-list-classifier-body');
        if (isExpanded) {
            caret.addClass('caret-down');
            container.addClass('expanded');
            body.slideDown(600).removeAttr('hidden').attr('aria-expanded', 'true');
        } else {
            caret.removeClass('caret-down');
            container.removeClass('expanded');
            body.slideUp(400).attr('hidden', '').attr('aria-expanded', 'false');
        }
        this.runtimeConfig.setClassifierExpanded(this.getCode(), isExpanded);
        this.onChangeRuntimeConfig();
    }
}
/**
 * A layer service. Has a direct correspondence with an OpenLayers layer
 */ class $4cbe6e39851964f1$var$Service extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     *
     * @param serviceConfig {LayerServiceConfig} The service configuration
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param productConfig {ProductConfig} The product configuration
     * @param projection {Projection} Map's current projection
     * @param tileGridGetter {function} A function that given a service config, returns a map's TileGrid
     * @param opacity {number} The initial opacity
     * @param visible {boolean} The initial visibility
     * @param runtimeConfig {MapRuntimeConfig}
     */ constructor(serviceConfig, isMobileDevice, productConfig, projection, tileGridGetter, opacity, visible, runtimeConfig){
        super();
        this.isMobileDevice = isMobileDevice;
        this.serviceConfig = serviceConfig;
        this.productConfig = productConfig;
        this.projection = projection;
        this.tileGridGetter = tileGridGetter;
        this.opacity = opacity;
        this.visible = visible;
        this.coordinatesPanel = undefined;
        this.runtimeConfig = runtimeConfig;
    }
    /**
     * An ID token to use for logging
     * @return {string}
     */ getLogId() {
        return (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.getClassName(), this.getClass()) + " [" + this.getCode() + "]";
    }
    /**
     * Get a value by property key
     * @param prop {string} A property key
     * @return {*}
     */ getSessionProp(prop) {
        return this.runtimeConfig.getUIElementSessionProp(this.getCode(), prop);
    }
    /**
     * Set a property value that lasts for this session (ends on close tab)
     * @param prop {string} A property key
     * @param value {*} any value
     */ setSessionProp(prop, value) {
        return this.runtimeConfig.setUIElementSessionProp(this.getCode(), prop, value);
    }
    /**
     * Remove a property
     * @param prop {string} A property key
     */ removeSessionProp(prop) {
        return this.runtimeConfig.removeUIElementSessionProp(this.getCode(), prop);
    }
    getCode() {
        return this.serviceConfig.getCode();
    }
    /**
     * Show a popup for a feature of this service
     * Only applicable if this is a vector service
     * @param feature {Feature} An OpenLayers feature belonging to this service
     * @param pixelX {number} The X pixel coordinate of the click (integer)
     * @param pixelY {number} The Y pixel coordinate of the click (integer)
     */ showFeatureInfo(feature, coordinateWgs84, pixelX, pixelY) {}
    _showFeatureInfoOnCoordinate(coordinateWgs84, feature, pixelX, pixelY) {}
    /**
     * Hide the popup for a feature of this service
     * Only applicable if this is a vector service
     */ hideFeatureInfo() {}
    /**
     * Get the layer overlay, if this is a clickable vector service
     * @return {Overlay}
     */ getOverlay() {}
    /**
     * Get the OpenLayers source
     * @return {Source}
     * @private
     */ getOLLayerSource() {
        const tileSize = this.serviceConfig.getTileSize() ? this.serviceConfig.getTileSize() : this.isMobileDevice ? (0, $9bc5df2b24a7fcf6$export$7f8c3bc50a5da30a) : (0, $9bc5df2b24a7fcf6$export$5ba11896679e32dc);
        const params = {
            HEIGHT: tileSize,
            WIDTH: tileSize,
            TILED: true,
            FORMAT: this._getImageFormat(),
            VERSION: '1.1.1',
            SRS: this.projection.getCode(),
            CRS: this.projection.getCode(),
            TRANSPARENT: this._isTransparent()
        };
        return new (0, $012114ccc3d7b503$export$2e2bcd8739ae039)({
            url: this.serviceConfig.getUrl(),
            params: params,
            serverType: 'mapserver',
            crossOrigin: 'Anonymous',
            transition: 0,
            interpolate: false,
            tileGrid: this.tileGridGetter(this.serviceConfig),
            attributions: [
                '<div>' + this.productConfig.getName() + '</div>'
            ]
        });
    }
    _isTransparent() {
        return true;
    }
    _getImageFormat() {
        return 'image/png';
    }
    /**
     *
     * @return {Layer} Get the OpenLayers layer
     */ getOlLayer() {
        if (!this.olLayer) {
            this.olLayer = new (0, $0e25041945985074$export$2e2bcd8739ae039)({
                source: this.getOLLayerSource(),
                extent: this.getExtent(),
                opacity: this.opacity,
                visible: this.visible
            });
            this.olLayer.set('code', this.serviceConfig.getCode(), true);
        }
        return this.olLayer;
    }
    /**
     * The OpenLayers vector overlays
     * @return {Array<VectorLayer>} OpenLayers vector layers
     */ getOLVectorOverlays() {}
    /**
     * Set the OpenLayers layer opacity
     * @param opacity {number} [0 .. 1]
     */ setOpacity(opacity) {
        this.opacity = opacity;
        this.getOlLayer().setOpacity(opacity);
    }
    /**
     * Set the OpenLayers layer visibility
     * @param visible {boolean}
     */ setVisibility(visible) {
        this.visible = visible;
        this.getOlLayer().setVisible(visible);
        const olVectorOverlays = this.getOLVectorOverlays();
        if (olVectorOverlays) olVectorOverlays.forEach((vol)=>vol.setVisible(visible));
        if (this.coordinatesPanel) {
            if (!visible && this.coordinatesPanel.isVisible()) this.hideFeatureInfo();
        }
    }
    _update() {
        const olLayer = this.getOlLayer();
        olLayer.setSource(this.getOLLayerSource());
        this.hideFeatureInfo();
    }
    /**
     * Set the current map projection
     * @param projection {Projection}
     */ setProjection(projection) {
        this.projection = projection;
        this.getOlLayer().setExtent(this.getExtent());
        this._update();
    }
    /**
     * Get the layer extent in map current projection
     * @return {Array<number>}
     */ getExtent() {
        return (0, $40ab8c40db995546$export$751c68e0e0efff79)(this.serviceConfig.getExtentWgs84(), (0, $9bc5df2b24a7fcf6$export$6dd85527b263c26d), this.projection.getCode());
    }
    getExtentWgs84() {
        return this.serviceConfig.getExtentWgs84();
    }
    onAdd2Map() {}
}
/**
 * A service for a layer from the layer tree
 * @extends Service
 */ class $4cbe6e39851964f1$var$BaseLayerService extends $4cbe6e39851964f1$var$Service {
    _getImageFormat() {
        return 'image/jpeg';
    }
    _isTransparent() {
        return false;
    }
}
/**
 * A service for a layer from the layer tree
 * @extends Service
 */ class $4cbe6e39851964f1$export$8ac50d8f253588ab extends $4cbe6e39851964f1$var$Service {
    /**
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {MapRuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param clusterSizePixels {number|undefined} The cluster size in pixels. if undefined or <10 no cluster will be added
     * @param serviceConfig {LayerServiceConfig} The service configuration
     * @param productConfig {ProductConfig} The product configuration
     * @param projection {Projection} Map's current projection
     * @param tileGridGetter {function} A function that given a service config, returns a map's TileGrid
     * @param opacity {number} The initial opacity
     * @param visible {boolean} The initial visibility
     * @param timeCode {string} The initial timeCode
     * @param timeScale {TimeScaleEnum} The initial timeScale
     * @param timeCodeCalculator {TimeCalculator} The time calculator
     * @param style {Style} The style to render this layer in, if VECTOR
     * @param chartable {boolean} If true, adds a chart button to the vector layer feature popup
     * @param showChart {function} If chartable, this function should show a chart, given the feature properties, the clicked WGS84 coordinates and a name for the feature
     */ constructor(translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig, clusterSizePixels, serviceConfig, productConfig, projection, tileGridGetter, opacity, visible, timeCode, timeScale, timeCodeCalculator, style, chartable = false, showChart){
        super(serviceConfig, isMobileDevice, productConfig, projection, tileGridGetter, opacity, visible, runtimeConfig);
        this.translator = translator;
        this.runtimeConfig = runtimeConfig;
        this.onChangeRuntimeConfig = onChangeRuntimeConfig;
        this.clusterSizePixels = clusterSizePixels && clusterSizePixels >= 10 ? clusterSizePixels : undefined;
        this.timeCode = timeCode;
        this.timeScale = timeScale;
        this.timeCodeCalculator = timeCodeCalculator;
        this.style = style;
        this.oLVectorOverlays = [];
        this.chartable = chartable;
        this.showChart = showChart;
        if (this.serviceConfig.isClickable()) {
            this.coordinatesPanel = new (0, $0923864e362ccdd0$export$9c09cd8ed33a11db)(translator, isMobileDevice, 'click_coordinates_panel_' + serviceConfig.getCode(), 'vector-click-coordinates-panel', runtimeConfig, onChangeRuntimeConfig);
            this.coordinatesPanel.onHide(()=>{
                this.removeSessionProp("featureInfoProps");
                this.removeSessionProp("featureInfoCoords");
            });
        }
    }
    getOlLayer() {
        if (this.serviceConfig.getLayerType() === (0, $815c91046e476159$export$76bf88ec17fef043).RASTER) {
            if (this.serviceConfig.getProtocol() === (0, $815c91046e476159$export$fb21469bf9823c9b).WMS) return super.getOlLayer();
            else if (this.serviceConfig.getProtocol() === (0, $815c91046e476159$export$fb21469bf9823c9b).WMS_SINGLE_IMAGE) {
                if (!this.olLayer) {
                    this.olLayer = new (0, $7924e3219eb0471c$export$2e2bcd8739ae039)({
                        extent: this.getExtent(),
                        opacity: this.opacity,
                        visible: this.visible,
                        source: this.getOLLayerSource()
                    });
                    this.olLayer.set('code', this.serviceConfig.getCode(), true);
                }
                return this.olLayer;
            }
        }
        if (this.serviceConfig.getLayerType() === (0, $815c91046e476159$export$76bf88ec17fef043).VECTOR) {
            if (!this.olLayer) {
                let vector;
                if (this.clusterSizePixels) {
                    const olLayerSource = this.getOLLayerSource();
                    const clusterSource = new (0, $49214548c17e511c$export$2e2bcd8739ae039)({
                        distance: this.clusterSizePixels,
                        minDistance: this.clusterSizePixels,
                        source: olLayerSource
                    });
                    clusterSource.set('code', olLayerSource.get('code'));
                    const styleCache = {};
                    const olStyle = this.getStyler().getOLStyle();
                    vector = new (0, $09432eee05d1671f$export$2e2bcd8739ae039)({
                        source: clusterSource,
                        style: (feature)=>{
                            const features = feature.get('features');
                            const size = features.length;
                            if (size > 1) {
                                const length = size.toString().length;
                                if (!styleCache[length]) {
                                    const clusterImageStyle = new (0, $dbb7c37f8910e19f$export$28b227e8366a5b4a)(this.style).getClusterImageStyle();
                                    clusterImageStyle.setRadius(10 + 5 * length);
                                    styleCache[length] = new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                                        image: clusterImageStyle,
                                        text: new (0, $bd3392336d293964$export$2e2bcd8739ae039)({
                                            text: size.toString(),
                                            font: '12px sans-serif',
                                            fill: new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
                                                color: (0, $9d480b6dede89078$export$1b0fd8199ce5537b)(clusterImageStyle.getFill().getColor()) ? 'black' : 'white'
                                            })
                                        })
                                    });
                                }
                                return styleCache[length];
                            } else return olStyle(features[0]);
                        }
                    });
                    vector.set('clustered', true);
                } else vector = new (0, $09432eee05d1671f$export$2e2bcd8739ae039)({
                    source: this.getOLLayerSource(),
                    style: this.getStyler().getOLStyle(),
                    extent: this.getExtent(),
                    opacity: this.opacity,
                    visible: this.visible
                });
                vector.set('code', this.serviceConfig.getCode(), true);
                vector.set('hasOverlay', this.getOLVectorOverlays().length > 0, true);
                this.olLayer = vector;
            }
            return this.olLayer;
        }
    }
    getStyler() {
        return new (0, $dbb7c37f8910e19f$export$28b227e8366a5b4a)(this.style);
    }
    getChartStyler() {
        return new (0, $dbb7c37f8910e19f$export$b82f4f1213831c77)(this.style);
    }
    getOverlay() {
        if (this.coordinatesPanel) return this.coordinatesPanel.getOverlay();
    }
    showFeatureInfo(feature, coordinateWgs84, pixelX, pixelY) {
        if (this.serviceConfig.isClickable()) {
            if (!coordinateWgs84) {
                const geometry = feature.getGeometry();
                const centroid = (0, $7e819822b33b3d32$export$c91255cadecfe081)(geometry.getExtent());
                const currentProjectionCode = this.projection.getCode();
                coordinateWgs84 = currentProjectionCode === (0, $9bc5df2b24a7fcf6$export$6dd85527b263c26d) ? centroid : (0, $92f1443438429e81$export$51186ad6e864892a)(centroid, currentProjectionCode, (0, $9bc5df2b24a7fcf6$export$6dd85527b263c26d));
            }
            let properties = feature.getProperties();
            if (properties.features && properties.features.length === 1) properties = properties.features[0].getProperties();
            const geom = properties.features && properties.features.length === 1 ? properties.features[0].getGeometry() : feature.getGeometry();
            const showCoords = geom instanceof (0, $f7e297e9f8b90024$export$2e2bcd8739ae039);
            this._showFeatureInfoOnCoordinate(properties, coordinateWgs84, showCoords, pixelX, pixelY);
        }
    }
    _showFeatureInfoOnCoordinate(properties, coordinateWgs84, showCoords, pixelX, pixelY) {
        if (this.serviceConfig.isClickable()) {
            this.setSessionProp("featureInfoProps", properties);
            this.setSessionProp("featureInfoCoords", coordinateWgs84);
            this.setSessionProp("featureInfoShowCoords", showCoords);
            const getPopupContents = ()=>{
                const element = $dc57b31f1b066f38$exports('<div></div>');
                if (showCoords) element.append($dc57b31f1b066f38$exports('<div class="coords"><label>' + this.translator.translate('layer.coordinatesWgs84Label') + ':</label> ' + (0, $40ab8c40db995546$export$3fe43bac65f73092)(coordinateWgs84) + '</div>'));
                let chartButton = undefined;
                if (this.chartable && this.showChart) {
                    const idPropName = this.getIDPropName(properties);
                    const id = properties[idPropName];
                    if (id) {
                        const chartButtonContainer = $dc57b31f1b066f38$exports('<div class="chart"><label>' + this.translator.translate('layer.indicator.vectorChartLabel') + '</label><div class="chart-button-container"></div></div>');
                        element.append(chartButtonContainer);
                        chartButton = $dc57b31f1b066f38$exports('<button></button>').addClass('chart-button');
                        $dc57b31f1b066f38$exports('.chart-button-container', chartButtonContainer).append(chartButton);
                    }
                }
                let featureName = undefined;
                const featureParser = $4cbe6e39851964f1$var$FEATURE_PARSER_BY_SERVICE_CODE[this.serviceConfig.getCode()];
                if (featureParser) {
                    const timeParameters = this.getTimeParameters();
                    const featurePropertiesMap = featureParser.getFormattedProperties(properties, this.getChartStyler(), timeParameters);
                    const wmsUrl = (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(featureParser.getWmsUrl(properties, timeParameters));
                    const name = (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(featureParser.getName(properties));
                    if (name) featureName = name;
                    if (wmsUrl) {
                        const tileSize = this.serviceConfig.getTileSize() ? this.serviceConfig.getTileSize() : this.isMobileDevice ? (0, $9bc5df2b24a7fcf6$export$7f8c3bc50a5da30a) : (0, $9bc5df2b24a7fcf6$export$5ba11896679e32dc);
                        this.temporaryWMSLayer = new (0, $0e25041945985074$export$2e2bcd8739ae039)({
                            source: new (0, $012114ccc3d7b503$export$2e2bcd8739ae039)({
                                url: wmsUrl,
                                params: {
                                    'TILED': true,
                                    'HEIGHT': tileSize,
                                    'WIDTH': tileSize,
                                    'SRS': this.projection.getCode()
                                },
                                serverType: 'mapserver',
                                tileGrid: this.tileGridGetter ? this.tileGridGetter(this.serviceConfig) : undefined
                            })
                        });
                        const map = this.coordinatesPanel.getOverlay().getMap();
                        const index = map.getLayers().getArray().indexOf(this.olLayer);
                        map.getLayers().insertAt(index - 1, this.temporaryWMSLayer);
                    }
                    for(let label in featurePropertiesMap)element.append($dc57b31f1b066f38$exports('<div class="property"><label>' + label + '</label>' + (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(featurePropertiesMap[label], '--') + '</div>'));
                }
                if (chartButton) chartButton.click(()=>this.showChart(properties, coordinateWgs84, featureName));
                return {
                    contents: element,
                    title: this.productConfig.getName((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCode)) + (featureName ? ' - ' + featureName : '')
                };
            };
            const popupContents = getPopupContents();
            this.coordinatesPanel.setTitle(popupContents.title.crop(30));
            this.coordinatesPanel.setContent(popupContents.contents);
            this.coordinatesPanel.showOnGeoCoords(coordinateWgs84);
            this.coordinatesPanel.onHide(()=>{
                const layers = this.coordinatesPanel.getOverlay().getMap().getLayers();
                layers.removeAt(layers.getArray().indexOf(this.temporaryWMSLayer));
            });
        }
    }
    hideFeatureInfo() {
        if (this.coordinatesPanel) this.coordinatesPanel.hideNoAnimation();
    }
    getOLLayerSource() {
        let initialParams = this.getTimeParameters();
        if (this.serviceConfig.getLayerType() === (0, $815c91046e476159$export$76bf88ec17fef043).RASTER) this.olSource = this._getRasterOLSource(initialParams);
        else if (this.serviceConfig.getLayerType() === (0, $815c91046e476159$export$76bf88ec17fef043).VECTOR) this.olSource = this._getVectorOLSource(initialParams);
        if (this.olSource) this.olSource.set('code', this.serviceConfig.getCode(), true);
        return this.olSource;
    }
    getTimeParameters() {
        const periodicity = this.productConfig.getPeriodicity();
        const timeScale = this.getTimeScaleStrForRequest();
        let timeParams = {};
        if ($4cbe6e39851964f1$var$URL_PARAMS_GENERATOR_BY_SERVICE_CODE[this.getCode()]) try {
            timeParams = $4cbe6e39851964f1$var$URL_PARAMS_GENERATOR_BY_SERVICE_CODE[this.getCode()](this.timeCode, timeScale);
        } catch (e) {
            this.logError("Error generating url params for " + this.serviceConfig.getCode(), e);
        }
        else {
            const timeSelector = this.serviceConfig.getTimeSelector();
            if (timeSelector) {
                const timeSelectorSplit = timeSelector.split(',');
                if (timeSelectorSplit.length > 1) {
                    const timeCodeSplit = this.timeCode.split("-");
                    for(let i = 0; i < Math.min(timeSelectorSplit.length, timeCodeSplit.length); i++){
                        const paramName = timeSelectorSplit[i].trim();
                        if (paramName.length > 0) timeParams[paramName] = timeCodeSplit[i];
                    }
                } else timeParams[timeSelector] = this.timeCode;
            } else {
                const timeCodeSplit = this.timeCode ? this.timeCode.split('-') : undefined;
                if (periodicity && timeCodeSplit) {
                    if (!this.timeCodeCalculator.isYearless()) timeParams.SELECTED_YEAR = timeCodeSplit[0];
                    switch(periodicity){
                        case (0, $815c91046e476159$export$45470b399d15bbcb).YEARLY:
                            break;
                        case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY:
                            timeParams.SELECTED_MONTH = timeCodeSplit[1];
                            break;
                        case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_FORECAST:
                            timeParams.SELECTED_MONTH = timeCodeSplit[1];
                            break;
                        case (0, $815c91046e476159$export$45470b399d15bbcb).MONTHLY_UPDATED_TEN_DAILY:
                        case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS_30DAY:
                        case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY_YEARLESS:
                        case (0, $815c91046e476159$export$45470b399d15bbcb).TEN_DAILY:
                            timeParams.SELECTED_MONTH = timeCodeSplit[1];
                            timeParams.SELECTED_TENDAYS = timeCodeSplit[2];
                            break;
                        case (0, $815c91046e476159$export$45470b399d15bbcb).WEEKLY:
                            timeParams.SELECTED_WEEK = this.timeCodeCalculator.getWeekFromDate((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCode)).pad(2);
                            break;
                        case (0, $815c91046e476159$export$45470b399d15bbcb).ISO_WEEKLY:
                            timeParams.SELECTED_WEEK = this.timeCodeCalculator.getISOWeekFromDate((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCode)).pad(2);
                            break;
                        case (0, $815c91046e476159$export$45470b399d15bbcb).CUSTOM:
                            break;
                        case (0, $815c91046e476159$export$45470b399d15bbcb).DAILY:
                        case (0, $815c91046e476159$export$45470b399d15bbcb).DAILY_YEARLESS:
                        case (0, $815c91046e476159$export$45470b399d15bbcb).LATEST:
                            timeParams.SELECTED_MONTH = timeCodeSplit[1];
                            timeParams.SELECTED_DAY = timeCodeSplit[2];
                        default:
                            break;
                    }
                }
            }
            if (timeScale) timeParams.SELECTED_TIMESCALE = timeScale;
        }
        return timeParams;
    }
    getTimeScaleStrForRequest() {
        return this.serviceConfig.getTimeScales().length > 0 ? this.timeScale && this.serviceConfig.getTimeScales().indexOf(this.timeScale) >= 0 ? this.timeScale.getCode() : this.serviceConfig.getTimeScales()[0].getCode() : undefined;
    }
    getOLVectorOverlays() {
        return this.oLVectorOverlays;
    }
    getIDPropName(properties) {
        const possibleIDPropNames = [
            "id",
            "ID",
            "fid",
            "FID"
        ];
        const propNames = Object.keys(properties);
        let idProp;
        for (const name of possibleIDPropNames)if (propNames.indexOf(name) >= 0) {
            idProp = name;
            break;
        }
        return idProp;
    }
    _getVectorOLSource(initialParams) {
        const url = this.serviceConfig.getUrl();
        if (this.serviceConfig.getProtocol() === (0, $815c91046e476159$export$fb21469bf9823c9b).WFS) {
            const geoJSONFormat = new (0, $69d9a08803fa6743$export$2e2bcd8739ae039)();
            let vectorSource; //ugly stuff: the loader function for this source refers to the source itself
            vectorSource = new (0, $69f8886165740064$export$2e2bcd8739ae039)({
                projection: this.projection.getCode(),
                loader: (extent, resolution, projection, success, failure)=>{
                    const currentProjCode = this.projection.getCode();
                    const originalCRS = this.serviceConfig.getOriginalCRS();
                    const needsTransform = originalCRS && originalCRS !== currentProjCode;
                    if (needsTransform) extent = (0, $40ab8c40db995546$export$751c68e0e0efff79)(extent, currentProjCode, originalCRS);
                    let finalUrl = url + '&request=GetFeature&outputFormat=application/json' + '&srsName=' + this.projection.getCode() + '&service=WFS' + '&bbox=' + extent.join(',') + ',' + (needsTransform ? originalCRS : currentProjCode);
                    for(let t in initialParams)finalUrl += '&' + t + '=' + initialParams[t];
                    $dc57b31f1b066f38$exports.ajax(finalUrl, {
                        method: 'GET',
                        error: (e)=>{
                            this.logError('vector source fetching error: ' + finalUrl, e);
                            failure();
                        },
                        success: (data)=>{
                            try {
                                if ((0, $2536f84a954bf107$export$844ec244b1367d54)(data)) data = JSON.parse(data);
                                if (data.features) {
                                    const features = geoJSONFormat.readFeatures(data).sort((f1, f2)=>{
                                        const idPropName1 = this.getIDPropName(f1.getProperties());
                                        const idPropName2 = this.getIDPropName(f2.getProperties());
                                        if (idPropName1 && !idPropName2) return 1;
                                        if (idPropName2 && !idPropName1) return -1;
                                        if (!idPropName1 && !idPropName2) return 0;
                                        const id1 = f1.getProperties()[idPropName1];
                                        const id2 = f2.getProperties()[idPropName2];
                                        if (id1 !== undefined && id1 !== null && (id2 === undefined || id2 === null)) return 1;
                                        if (id2 !== undefined && id2 !== null && (id1 === undefined || id1 === null)) return -1;
                                        if ((id1 === undefined || id1 === null) && (id2 === undefined || id2 === null)) return 0;
                                        if ((0, $2536f84a954bf107$export$7e4aa119212bc614)(id1) && (0, $2536f84a954bf107$export$7e4aa119212bc614)(id2)) return id1 > id2 ? 1 : id2 > id1 ? -1 : 0;
                                        return id1.toString().localeCompare(id2.toString());
                                    });
                                    const ids = [];
                                    features.forEach((f)=>{
                                        if (f.getId() === null || f.getId() === undefined) {
                                            const idPropName = this.getIDPropName(f.getProperties());
                                            let id = idPropName ? f.getProperties()[idPropName] : ids.length.toString();
                                            if (ids.indexOf(id) >= 0) id += "_" + ids.length;
                                            ids.push(id);
                                            f.setId(id);
                                        } else ids.push(f.getId());
                                    });
                                    if (needsTransform) features.forEach((f)=>f.getGeometry().transform(originalCRS, currentProjCode));
                                    vectorSource.addFeatures(features);
                                    success(features);
                                }
                            } catch (e) {
                                this.logError('vector source parsing error', e);
                                failure();
                            }
                        }
                    });
                },
                strategy: (0, $d8ae32e631726bbf$export$bf67010aacbe66fa),
                attributions: [
                    '<div>' + this.productConfig.getName((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCode)) + '</div>'
                ]
            });
            if (this.serviceConfig.isClickable()) {
                const highlightStyle = this.getStyler().getOLHighlightStyle();
                this.oLVectorOverlays = [
                    new (0, $09432eee05d1671f$export$2e2bcd8739ae039)({
                        source: new (0, $69f8886165740064$export$2e2bcd8739ae039)(),
                        style: highlightStyle
                    })
                ];
                this.oLVectorOverlays[0].set('serviceCode', this.serviceConfig.getCode(), true);
            }
            return vectorSource;
        }
    }
    _getRasterOLSource(initialParams) {
        const params = {
            VERSION: '1.1.1',
            SRS: this.projection.getCode(),
            FORMAT: 'image/png'
        };
        Object.keys(initialParams).forEach((iP)=>params[iP] = initialParams[iP]);
        if (this.serviceConfig.getProtocol() === (0, $815c91046e476159$export$fb21469bf9823c9b).WMS) {
            const tileSize = this.serviceConfig.getTileSize() ? this.serviceConfig.getTileSize() : this.isMobileDevice ? (0, $9bc5df2b24a7fcf6$export$7f8c3bc50a5da30a) : (0, $9bc5df2b24a7fcf6$export$5ba11896679e32dc);
            params.HEIGHT = tileSize;
            params.WIDTH = tileSize;
            params.TILED = true;
            const tileWMS = new (0, $012114ccc3d7b503$export$2e2bcd8739ae039)({
                url: this.serviceConfig.getUrl().format([
                    Number(this.getTimeScaleStrForRequest()) + ""
                ]),
                params: params,
                serverType: 'mapserver',
                transition: 0,
                crossOrigin: 'Anonymous',
                interpolate: false,
                tileGrid: this.tileGridGetter ? this.tileGridGetter(this.serviceConfig) : undefined,
                attributions: [
                    '<div>' + this.productConfig.getName((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCode)) + '</div>'
                ]
            });
            return tileWMS;
        }
        if (this.serviceConfig.getProtocol() === (0, $815c91046e476159$export$fb21469bf9823c9b).WMS_SINGLE_IMAGE) return new (0, $7aea03074858c411$export$2e2bcd8739ae039)({
            url: this.serviceConfig.getUrl().format([
                Number(this.getTimeScaleStrForRequest()) + ""
            ]),
            params: params,
            ratio: 1,
            crossOrigin: 'Anonymous',
            projection: this.projection.getCode(),
            attributions: [
                '<div>' + this.productConfig.getName((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.timeCode)) + '</div>'
            ]
        });
    }
    /**
     * Set this layer current time code
     * @param timeCode {string}
     */ setTimeCode(timeCode) {
        this.timeCode = timeCode;
        this._update();
    }
    /**
     * Set this layer current time scale
     * @param timeScale {TimeScaleEnum}
     */ setTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._update();
    }
    setProjection(projection) {
        super.setProjection(projection);
        if (this.coordinatesPanel) this.coordinatesPanel.setProjection(projection);
    }
    onAdd2Map() {
        super.onAdd2Map();
        if (this.getSessionProp("featureInfoProps") && this.getSessionProp("featureInfoCoords")) this._showFeatureInfoOnCoordinate(this.getSessionProp("featureInfoProps"), this.getSessionProp("featureInfoCoords"), this.getSessionProp("featureInfoShowCoords"), undefined, undefined);
    }
}
/**
 * A layer
 * @abstract
 * @extends UIElement
 */ class $4cbe6e39851964f1$var$AbstractLayer extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param slimPanel {SlimPanel} A slim panel to display the layers options
     * @param infoModal {Modal} A modal to show indicator information in
     * @param layerConfig {Object} The layer config
     * @param tileGridGetter {function} A function that given a service config, returns a map's TileGrid
     * @param projection {Projection} Map's current projection
     * @param runtimeConfig {RuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param onChangeVisibleLayers {function} A callback to be called when this layer changes visibility
     */ constructor(translator, isMobileDevice, slimPanel, infoModal, layerConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers){
        super(layerConfig.getCode(), translator, isMobileDevice, runtimeConfig, onChangeRuntimeConfig);
        this.layerConfig = layerConfig;
        this.tileGridGetter = tileGridGetter;
        this.projection = projection;
        this.slimPanel = slimPanel;
        this.infoModal = infoModal;
        this.locationVisible = true;
        this.opacityValue = 1;
        this.enabled = true;
        this.onChangeVisibleLayers = onChangeVisibleLayers;
        let styles = this.layerConfig.getStyles();
        if (this.layerConfig.getDrivenServices) {
            const drivenServices = this.layerConfig.getDrivenServices();
            for(let ds in drivenServices)if (drivenServices[ds].getStyle()) styles.push(drivenServices[ds].getStyle());
        }
        if (styles.length > 0) {
            this.legend = new (0, $594237181175c857$export$ed247974535929c7)(this.isMobileDevice, this.translator, styles);
            this.chartLegend = new (0, $594237181175c857$export$ed247974535929c7)(this.isMobileDevice, this.translator, [
                styles[0]
            ]);
            this.chartStyler = new (0, $dbb7c37f8910e19f$export$b82f4f1213831c77)(styles[0]);
        }
        if (this.layerConfig.getAccumulatedStyle && this.layerConfig.getAccumulatedStyle()) this.accumulatedChartStyle = new (0, $dbb7c37f8910e19f$export$b82f4f1213831c77)(this.layerConfig.getAccumulatedStyle());
    }
    getClassName() {
        return "AbstractLayer";
    }
    /**
     *
     * @return {Array<Styler>}
     */ getStylers() {
        return this.services.map((s)=>s.getStyler()).flat();
    }
    _initServices() {}
    /**
     * This layer's legend
     * @return {Legend}
     */ getLegend() {
        return this.legend;
    }
    /**
     * This layer's legend
     * @return {Legend}
     */ getChartLegend() {
        return this.chartLegend;
    }
    /**
     *
     * @return {ChartStyler}
     */ getChartStyler() {
        return this.chartStyler;
    }
    /**
     *
     * @return {ChartStyler}
     */ getAccumulatedChartStyler() {
        return this.accumulatedChartStyle;
    }
    /**
     *
     * @return {LayerConfig}
     */ getConfig() {
        return this.layerConfig;
    }
    /**
     * The name of this layer
     * @return {string}
     */ getName() {
        return this.getProductConfig().getName();
    }
    /**
     * This layer's product config
     * @return {ProductConfig}
     */ getProductConfig() {
        return this.layerConfig.getProduct();
    }
    /**
     * This layer's service config
     * @return {LayerServiceConfig}
     */ getServiceConfig() {
        return this.layerConfig.getService();
    }
    getCode() {
        return this.layerConfig.getCode();
    }
    /**
     * Override to implement whatever should happen when the tool is added to the map
     */ onAdd2Map() {
        this.services.forEach((s)=>s.onAdd2Map());
    }
    /**
     * Get the layer overlays, for this layer's clickable vector services, if any
     * @return {Array<Overlay>}
     */ getOverlays() {
        return this.services.map((s)=>s.getOverlay()).filter((o)=>o !== undefined);
    }
    /**
     * Does this layer have the service for the given code?
     * @param code {string} the service code
     * @return {boolean}
     */ hasService(code) {
        return this.layerConfig.getService().getCode() === code;
    }
    /**
     * Show a popup for a feature of this layer
     * @param serviceCode {string} The layer service code
     * @param feature {Feature} An OpenLayers feature belonging to this layer
     * @param coordinateWgs84 {Array<number>} Coordinates in WGS84
     * @param pixelX {number} The X pixel coordinate of the click (integer)
     * @param pixelY {number} The Y pixel coordinate of the click (integer)
     */ showFeatureInfo(serviceCode, feature, coordinateWgs84, pixelX, pixelY) {}
    /**
     * Hide the popup for a feature of this layer
     * @param serviceCode {string} The layer service code
     */ hideFeatureInfo(serviceCode) {}
    /**
     * Hide the popups for a feature of this layer
     */ hideFeatureInfos(serviceCode) {}
    /**
     * The OpenLayers layers
     * @return {Array<Layer>} OpenLayers layers
     */ getOLLayers() {
        const res = [];
        for(let i = this.services.length - 1; i >= 0; i--)res.push(this.services[i].getOlLayer());
        return res;
    }
    /**
     * The OpenLayers vector overlays
     * @return {Array<VectorLayer>} OpenLayers vector layers
     */ getOLVectorOverlays() {
        let res = [];
        for(let i = this.services.length - 1; i >= 0; i--)res = res.concat(this.services[i].getOLVectorOverlays());
        return res;
    }
    /**
     * Set the layer opacity
     * @param opacity {number} [0 .. 1]
     */ setOpacity(opacity) {
        this.opacityValue = Math.max(0.2, opacity !== undefined ? Number(opacity) : 1);
        this.services.forEach((service)=>{
            service.setOpacity(this.opacityValue);
        });
        this.visibility();
    }
    /**
     * Get the layer extent in map current projection
     * @return {Array<number>}
     */ getExtent() {
        return this.services[0].getExtent();
    }
    getExtentWgs84() {
        return this.services[0].getExtentWgs84();
    }
    /**
     * Is this layer visible in the map?
     * @return {boolean}
     */ isVisible() {
        return this.layerConfig.isVisible();
    }
    /**
     * Is this layer enabled in the map?
     * @return {boolean}
     */ isEnabled() {
        return this.enabled;
    }
    /**
     * Set this layer visible in the map
     * @param isVisible {boolean}
     */ setVisible(isVisible) {}
    /**
     * Is this layer identifiable?
     * @return {boolean}
     */ isIdentifiable() {
        return this.layerConfig.isIdentifiable();
    }
    /**
     * Set the map's current projection
     * @param projection {Projection}
     */ setProjection(projection) {
        this.projection = projection;
        for(let ls in this.services)this.services[ls].setProjection(projection);
    }
    /**
     * Disable this layer
     */ disable() {
        this.enabled = false;
        $dc57b31f1b066f38$exports('.checkbox-container>input', this.getUIElement()).attr('disabled', 'disabled');
        this.visibility();
    }
    /**
     * Enable this layer
     */ enable() {
        this.enabled = true;
        $dc57b31f1b066f38$exports('.checkbox-container>input', this.getUIElement()).removeAttr('disabled');
        this.visibility();
    }
    visibility(visible) {
        const vis = visible !== undefined ? visible : this._getVisibility();
        this.services.forEach((service)=>{
            service.setVisibility(vis);
        });
        if (vis) this.getUIElement().removeClass('disabled');
        else this.getUIElement().addClass('disabled');
        if (this.onChangeVisibleLayers) this.onChangeVisibleLayers();
        return vis;
    }
    _getVisibility() {
        //openlayers still requests images for transparent (opacity===0) layers, so we force hide it
        if (this.locationVisible && this.opacityValue > 0 && this.enabled && this.isVisible()) return true;
        if (!this.locationVisible || this.opacityValue === 0 || !this.enabled || !this.isVisible()) return false;
        return true;
    }
    onNavigation(zoomLevel, centerWgs84, mapExtentWgs84) {
        let locationVisible = true;
        const extentWgs84 = this.layerConfig.getService() ? this.layerConfig.getService().getExtentWgs84() : undefined;
        if (extentWgs84 && mapExtentWgs84 && !(0, $7e819822b33b3d32$export$7b0a31e10bbff018)(mapExtentWgs84, extentWgs84)) locationVisible = false;
        const minZoomLevel = this.layerConfig.getMinZoomLevel();
        if (minZoomLevel && zoomLevel < minZoomLevel) locationVisible = false;
        const maxZoomLevel = this.layerConfig.getMaxZoomLevel();
        if (maxZoomLevel && zoomLevel > maxZoomLevel) locationVisible = false;
        if (this.locationVisible !== locationVisible) {
            this.locationVisible = locationVisible;
            this.visibility();
        }
        if (this.legend) this.legend.onNavigation(zoomLevel, centerWgs84, mapExtentWgs84);
    }
    /**
     * Get a UI element to add to the info panel
     * @return {jQuery}
     */ getSlimUIElement() {}
    /**
     * Get a UI element to add to the info modal
     * @return {jQuery}
     */ getInfoElements() {}
    /**
     * Show information about this layer
     * @param modal {Modal} The modal where to show the info in
     * @return {Modal} The shown modal
     */ showInfo(modal) {
        if (!modal) modal = this.infoModal;
        if (modal) {
            modal.setTitle(this.translator.translate('layer.info.modalTitle'));
            modal.setContent(this.getInfoElements());
            modal.show();
            this.logStat("SHOW_INFO");
        }
        return modal;
    }
}
/**
 * A layer from the layer tree
 * @extends AbstractLayer
 */ class $4cbe6e39851964f1$export$936d0764594b6eb3 extends $4cbe6e39851964f1$var$AbstractLayer {
    static layersByTimeTag = {};
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param slimPanel {SlimPanel} A slim panel to display the layers options
     * @param chartModal {Modal} A modal to show the timeseries chart in
     * @param infoModal {Modal} A modal to show indicator information in
     * @param layerConfig {Object} The layer config
     * @param tileGridGetter {function} A function that given a service config, returns a map's TileGrid
     * @param projection {Projection} Map's current projection
     * @param runtimeConfig {RuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param exclusive {boolean} Is this node mutually exclusive with its siblings?
     * @param parentName {string} The name of the parent of this layer
     * @param onChangeVisibleLayers {function} A callback to be called when this layer changes visibility
     */ constructor(translator, isMobileDevice, slimPanel, chartModal, infoModal, layerConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, exclusive = false, parentName, onChangeVisibleLayers){
        super(translator, isMobileDevice, slimPanel, infoModal, layerConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers);
        this.chartModal = chartModal;
        this.infoModal = infoModal;
        this.exclusive = exclusive;
        this.parentName = parentName;
        this._updateTimeCalculator();
        this.enabled = true;
        this.styles = {};
        this.styles[this.getCode()] = this.layerConfig.getStyles();
        this._initServices();
    }
    getClassName() {
        return "Layer";
    }
    add2LayersByTimeTag() {
        const timeTag = this.layerConfig.getTimeTag();
        if (timeTag) {
            if (!$4cbe6e39851964f1$export$936d0764594b6eb3.layersByTimeTag[timeTag]) $4cbe6e39851964f1$export$936d0764594b6eb3.layersByTimeTag[timeTag] = [];
            $4cbe6e39851964f1$export$936d0764594b6eb3.layersByTimeTag[timeTag].push(this);
        }
        return this;
    }
    getRenderOrdinal() {
        return this.layerConfig.getRenderOrdinal();
    }
    getName() {
        return this.getProductConfig().getName(this.getCurrentDate());
    }
    _updateTimeCalculator() {
        const product = this.getProductConfig();
        this.timeCodeCalculator = new (0, $aeedcab592f41cce$export$41dea944c75fcd24)(product.getPeriodicity(), this.getDataFrom(), this.getDataUntil(), this.translator);
    }
    /**
     * The first day of the last period for that we have data on this product
     * @return {Date}
     */ getDataUntil() {
        const product = this.getProductConfig();
        const periodicity = product ? product.getPeriodicity() : undefined;
        const timeCalculator = new (0, $aeedcab592f41cce$export$41dea944c75fcd24)(periodicity);
        if (timeCalculator && !timeCalculator.hasNoDate()) {
            const generator = $4cbe6e39851964f1$var$END_DATE_GENERATOR_BY_PRODUCT_CODE[product.getCode()];
            if (generator) {
                let generatedDate = undefined;
                try {
                    generatedDate = generator((0, $2a1bdf5b8bad2f9b$export$1e0909f3e93883c6).PRODUCT_DATES);
                    if (!generatedDate) this.logError("No date generated");
                } catch (e) {
                    this.logError("Error generating date for " + product.getCode(), e);
                }
                return (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(new (0, $aeedcab592f41cce$export$41dea944c75fcd24)(product.getPeriodicity()).writeTimeCodeFromDate(generatedDate));
            }
            const res = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(timeCalculator.getLatestDate() ? timeCalculator.getLatestDate() : product.getDataUntil());
            if (!res) this.logError("No dataUntil");
            return res;
        }
    }
    /**
     * The first day of the first period for that we have data on this product
     * @return {Date}
     */ getDataFrom() {
        const product = this.getProductConfig();
        return product ? (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(product.getDataFrom()) : undefined;
    }
    _initServices() {
        this.services = [];
        const layerServiceConfigs = [
            this.layerConfig.getService()
        ];
        const drivenServices = this.layerConfig.getDrivenServices();
        for(let ls in drivenServices){
            layerServiceConfigs.push(drivenServices[ls].getService());
            this.styles[drivenServices[ls].getSrvCode()] = [
                drivenServices[ls].getStyle()
            ];
        }
        for(let ls in layerServiceConfigs)this.services.push(new $4cbe6e39851964f1$export$8ac50d8f253588ab(this.translator, this.isMobileDevice, this.runtimeConfig, this.onChangeRuntimeConfig, this.layerConfig.getClusterSizePixels(), layerServiceConfigs[ls], this.getProductConfig(), this.projection, this.tileGridGetter, this.layerConfig.getOpacity(), this.layerConfig.isVisible(), this.getCurrentTimeCode(), this.getTimeScale(), this.timeCodeCalculator, this.getStyleConfig(), !!this.getChartType(), (featureProps, coords, featureName)=>this.showChart(coords, featureProps, featureName)));
    }
    getStyleConfig() {
        return this.styles[this.getCode()][0];
    }
    getAllServiceConfigs() {
        const layerServiceConfigs = [
            this.layerConfig.getService()
        ];
        this.layerConfig.getDrivenServices().forEach((item)=>{
            layerServiceConfigs.push(item.getService());
        });
        return layerServiceConfigs;
    }
    /**
     *
     * @return {TimeCalculator}
     */ getTimeCalculator() {
        return this.timeCodeCalculator;
    }
    /**
     *
     * @param slimPanel {SlimPanel} A slim panel to display the layers options
     * @param projection {Projection} Map's current projection
     * @param runtimeConfig {MapRuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @return {Layer}
     */ clone(slimPanel, projection, runtimeConfig, onChangeRuntimeConfig) {
        const layerConfig = this.layerConfig.clone();
        layerConfig.override(runtimeConfig);
        return new $4cbe6e39851964f1$export$936d0764594b6eb3(this.translator, this.isMobileDevice, slimPanel, this.chartModal, this.infoModal, layerConfig, this.tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, false, undefined, undefined).set('cloned', true);
    }
    hasService(code) {
        return super.hasService(code) || this.services.filter((s)=>s.getCode() === code).length > 0;
    }
    showFeatureInfo(serviceCode, feature, coordinateWgs84, pixelX, pixelY) {
        this.services.filter((s)=>s.getCode() === serviceCode)[0].showFeatureInfo(feature, coordinateWgs84, pixelX, pixelY);
    }
    hideFeatureInfo(serviceCode) {
        this.services.filter((s)=>s.getCode() === serviceCode)[0].hideFeatureInfo();
    }
    hideFeatureInfos() {
        this.services.forEach((s)=>s.hideFeatureInfo());
    }
    /**
     * Get the current time code for this layer
     * @return {string}
     */ getCurrentTimeCode() {
        if (this.timeCodeCalculator.isLatest()) return (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.getDataUntil());
        return this.layerConfig.getTimeCode() ? this.layerConfig.getTimeCode() : (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.getDataUntil());
    }
    /**
     * Get the Date for the current time code for this layer
     * @return {Date}
     */ getCurrentDate() {
        return (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.getCurrentTimeCode());
    }
    /**
     * Get the current time scale for this layer
     * @return {TimeScaleEnum}
     */ getCurrentTimeScale() {
        return this.getTimeScale() ? this.getTimeScale() : undefined;
    }
    /**
     * The name of this layer, given a timescale
     * @param timeScale {TimeScaleEnum}
     * @return {string}
     */ getNameForTimeScale(timeScale) {
        return !timeScale ? this.getName(this.getCurrentDate()) : this.layerConfig.getProduct(timeScale).getName(this.getCurrentDate());
    }
    getProductConfig() {
        return this.getProductConfigForTimeScale(this.getCurrentTimeScale());
    }
    /**
     * Get a product config, given a time scale
     * @param timeScale {TimeScaleEnum}
     * @return {ProductConfig}
     */ getProductConfigForTimeScale(timeScale) {
        return this.layerConfig.getProduct(timeScale);
    }
    /**
     * @param dataSeriesUrl {string} The server dataseries URL
     * @param coordsWgs84 {Array<number>} The coordinates to fetch data for
     * @returns {TimeseriesFetcher}
     */ getTimeseriesFetcher(dataSeriesUrl, coordsWgs84) {
        if (!this.fetchersMap) this.fetchersMap = {};
        const formattedCoords = (0, $40ab8c40db995546$export$3fe43bac65f73092)(coordsWgs84);
        if (!this.fetchersMap[formattedCoords]) this.fetchersMap[formattedCoords] = new (0, $517497a32c92a48c$export$a1518f6bc2daa9b6)(dataSeriesUrl, this, (0, $40ab8c40db995546$export$881b4a519e1b1429)(coordsWgs84));
        return this.fetchersMap[formattedCoords];
    }
    /**
     * @param featureProps {Object} The OL Feature properties to get the timeseries for
     * @returns {FeatureTimeseriesFetcher}
     */ getTimeseriesFetcherForFeature(featureProps) {
        if (!this.fetchersMap) this.fetchersMap = {};
        const idPropName = this.services[0].getIDPropName(featureProps);
        const featureId = featureProps[idPropName];
        if (!this.fetchersMap[featureId]) this.fetchersMap[featureId] = new (0, $517497a32c92a48c$export$34e5a43543d4712b)(this, featureId);
        return this.fetchersMap[featureId];
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div class="layer-container layer-code-' + this.getCodeHtmlClass() + '">' + '  <div class="layer-header tree-header">' + '    <div class="layer-checkbox-container checkbox-container"><input id="layer_' + this.getCodeHtmlClass() + '" value="' + this.getCode() + '" name="' + this.parentName + '" type="' + (this.exclusive ? 'radio' : 'checkbox') + '" ' + (this.isVisible() ? 'checked="checked"' : '') + ' /></div>' + '    <div class="layer-name"><label class="name" for="layer_' + this.getCodeHtmlClass() + '">' + this.getName() + '</label><div class="layer-time"></div></div>' + '    <div class="layer-options"><button tabindex="0" title="' + this.translator.translate('layer.menuButton.name') + '" class="layer-menu-button"></button></div>' + '  </div>' + '  <div class="layer-body">' + '  </div>' + '</div>');
            let self = this;
            $dc57b31f1b066f38$exports('.layer-checkbox-container>input[type=checkbox]', this.uiElement).change(function() {
                const visible = $dc57b31f1b066f38$exports(this).is(':checked');
                self.logStat(visible ? "SHOW" : "HIDE");
                self.setVisible(visible);
            });
            if (this.getExtentWgs84()) {
                const zoom2ExtentButton = $dc57b31f1b066f38$exports('<button tabindex="0" title="' + this.translator.translate('layer.zoom2ExtentButton.name') + '" class="layer-zoom2extent-button"></button>');
                $dc57b31f1b066f38$exports('.layer-options', this.uiElement).addClass('has-zoom2extent').prepend(zoom2ExtentButton);
            }
            $dc57b31f1b066f38$exports('.layer-options>button.layer-menu-button', this.uiElement).click(()=>{
                this.showOptionsPanelTop();
                this.logStat("SHOW_OPTIONS");
            });
            this.updateTimeStr();
        }
        return this.uiElement;
    }
    /**
     * Update this layer's visible name
     */ updateName() {
        const name = this.getName();
        $dc57b31f1b066f38$exports('.layer-title-slim', this.slimUIElement).empty().html(name);
        $dc57b31f1b066f38$exports('.layer-name .name', this.uiElement).empty().html(name);
    }
    /**
     * Update this layer's visible time string
     */ updateTimeStr() {
        if (this.getProductConfig().getPeriodicity() && this.getCurrentTimeCode()) {
            let timeStr = this.getTimeStr();
            if (this.getChartType()) timeStr += '<div class="chartable-img" title="' + this.translator.translate('layer.indicator.chartable') + '"></div>';
            if (this.layerConfig.isPlayable()) timeStr += '<div class="playable-img" title="' + this.translator.translate('layer.indicator.playable') + '"></div>';
            $dc57b31f1b066f38$exports('.layer-time', this.uiElement).empty().html(timeStr);
            if (this.onChangeVisibleLayers) this.onChangeVisibleLayers();
        }
    }
    /**
     * Get a string of the current time of this layer
     * @return {string|undefined}
     */ getTimeStr() {
        return this.timeCodeCalculator.timeCodeToString(this.getCurrentTimeCode());
    }
    /**
     * Get a string with the frame of this layer
     * @return {string|undefined}
     */ getTimeFrameStr() {
        if (!this.timeCodeCalculator) return undefined;
        const isTenDailyYearless = this.timeCodeCalculator.isTenDailyYearless() || this.timeCodeCalculator.isTenDailyYearless30Day();
        const isDailyYearless = this.timeCodeCalculator.isDailyYearless();
        const fromStr = isTenDailyYearless ? (0, $aeedcab592f41cce$export$5e9f8dc88b5627ef)(this.getDataFrom()) : isDailyYearless ? (0, $aeedcab592f41cce$export$5b1892dca93afeb0)(this.getDataFrom()) : (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.getDataFrom());
        const until = this.timeCodeCalculator.fixDateUntil(this.getDataUntil());
        const untilStr = isTenDailyYearless ? (0, $aeedcab592f41cce$export$5e9f8dc88b5627ef)(until) : isDailyYearless ? (0, $aeedcab592f41cce$export$5b1892dca93afeb0)(until) : (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(until);
        return this.translator.translate('layer.indicator.time.frame', [
            fromStr,
            untilStr,
            this.timeCodeCalculator.getPeriodicity().getLocalizedName(this.translator)
        ]);
    }
    getNrOfDecimals() {
        const nrOfDecimals = this.layerConfig.getNrOfDecimals();
        return nrOfDecimals ? nrOfDecimals : 0;
    }
    isPlayable() {
        return this.layerConfig.isPlayable();
    }
    setVisible(isVisible) {
        this.runtimeConfig.setLayerVisibility(this.getCode(), isVisible);
        this.onChangeRuntimeConfig();
        this.visibility();
    }
    setOpacity(opacity) {
        super.setOpacity(opacity);
        this.runtimeConfig.setLayerOpacity(this.getCode(), this.opacityValue);
        this.onChangeRuntimeConfig();
    }
    /**
     * Set this layer's time code
     * @param timeCode {string}
     * @param propagate {boolean} if true, will propagate the timecode to the layers with the same time tag
     */ setTimeCode(timeCode, propagate = true) {
        const fixedTimeCode = this.timeCodeCalculator.fixTimeCode(timeCode);
        if (fixedTimeCode !== this.getCurrentTimeCode()) {
            this.runtimeConfig.setLayerTimeCode(this.getCode(), fixedTimeCode);
            this.onChangeRuntimeConfig();
            for(let ls in this.services)this.services[ls].setTimeCode(fixedTimeCode);
            if (this.onChangeVisibleLayers) this.onChangeVisibleLayers();
            this.updateTimeStr();
            this.updateName();
            this.logDebug("SET timecode " + fixedTimeCode);
        }
        if (propagate) {
            const timeTag = this.layerConfig.getTimeTag();
            if (timeTag && $4cbe6e39851964f1$export$936d0764594b6eb3.layersByTimeTag[timeTag]) $4cbe6e39851964f1$export$936d0764594b6eb3.layersByTimeTag[timeTag].forEach((l)=>{
                let middleDateForPeriod = this.getTimeCalculator().getMiddleDateOfPeriod(timeCode);
                if (this.getTimeCalculator().isYearless()) {
                    const otherTimeCalc = l.getTimeCalculator();
                    middleDateForPeriod = (0, $aeedcab592f41cce$export$2b6cf20b1d58ec45)(otherTimeCalc.getYearFromDate(l.getCurrentDate()), otherTimeCalc.getMonthFromDate(middleDateForPeriod), otherTimeCalc.getDayFromDate(middleDateForPeriod));
                }
                this.logDebug("Middle date for " + l.getCode() + ": " + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(middleDateForPeriod));
                l.setTimeCode((0, $aeedcab592f41cce$export$3ae94a2503e890a1)(middleDateForPeriod), false);
            });
        }
    }
    /**
     * This layer's current timescale
     * @return {TimeScaleEnum|undefined}
     */ getTimeScale() {
        return this.layerConfig.getTimeScale();
    }
    /**
     * Set this layer's time scale
     * @param timeScaleCode {string}
     */ setTimeScale(timeScaleCode) {
        const prod = this.getProductConfigForTimeScale((0, $815c91046e476159$export$d08fec65c77806fd).getForCode(timeScaleCode));
        if (prod) {
            this.runtimeConfig.setLayerTimeScale(this.getCode(), timeScaleCode);
            this.onChangeRuntimeConfig();
            this._updateTimeCalculator();
            for(let ls in this.services)this.services[ls].setTimeScale((0, $815c91046e476159$export$d08fec65c77806fd).getForCode(timeScaleCode));
            this.updateName();
        }
    }
    getSlimUIElement() {
        this.slimUIElement = $dc57b31f1b066f38$exports('<div tabindex="0" class="layer-container-slim">   <div class="layer-header-slim">       <button type="button" class="layer-info-button" tabindex="0"></button>       <div class="layer-title-slim">' + this.getName() + '</div>' + '       <div class="layer-options"></div>' + '   </div>' + '   <div class="layer-time-slim"></div>' + '   <div class="layer-legend-slim"></div>' + '</div>');
        this.onFocusedEnterOrSpace(()=>$dc57b31f1b066f38$exports('.layer-title-slim', this.slimUIElement).click(), this.slimUIElement);
        if (this.legend) $dc57b31f1b066f38$exports('.layer-legend-slim', this.slimUIElement).append(this.legend.getSmallGraphic());
        const productConfig = this.getProductConfig();
        if (productConfig.getPeriodicity() && this.getCurrentTimeCode()) $dc57b31f1b066f38$exports('.layer-time-slim', this.slimUIElement).append(this.getTimeStr());
        else $dc57b31f1b066f38$exports('.layer-time-slim', this.slimUIElement).hide();
        if (this.layerConfig.isPlayable()) {
            const playerButton = $dc57b31f1b066f38$exports('<button tabindex="0" title="' + this.translator.translate('layer.playerButton.name') + '" class="layer-player-button"></button>');
            $dc57b31f1b066f38$exports('.layer-options', this.slimUIElement).append(playerButton);
        }
        if (this.getExtentWgs84()) {
            const zoom2ExtentButton = $dc57b31f1b066f38$exports('<button tabindex="0" title="' + this.translator.translate('layer.zoom2ExtentButton.name') + '" class="layer-zoom2extent-button"></button>');
            $dc57b31f1b066f38$exports('.layer-options', this.slimUIElement).append(zoom2ExtentButton);
        }
        const optionsButton = $dc57b31f1b066f38$exports('<button tabindex="0" title="' + this.translator.translate('layer.menuButton.name') + '" class="layer-menu-button"></button>');
        $dc57b31f1b066f38$exports('.layer-options', this.slimUIElement).append(optionsButton);
        optionsButton.click(()=>{
            this.showOptionsPanelBottom();
            this.logStat("SHOW_OPTIONS");
        });
        return this.slimUIElement;
    }
    getInfoElements() {
        const elements = $dc57b31f1b066f38$exports('<div class="layer-info"></div>');
        const layerPropertiesDiv = $dc57b31f1b066f38$exports('<div class="layer-properties"><div class="layer-name"><label>' + this.translator.translate('layer.indicator.label') + '</label><div>' + this.getName() + '</div></div>' + '<div class="layer-time"></div>' + '</div>');
        const productConfig = this.getProductConfig();
        if (productConfig.getPeriodicity() && this.getCurrentTimeCode()) {
            $dc57b31f1b066f38$exports('.layer-name>div', layerPropertiesDiv).append(' <span class="context">[' + this.getTimeStr() + ']</span>');
            if (this.hasTimespan()) $dc57b31f1b066f38$exports('.layer-time', layerPropertiesDiv).append('<label>' + this.translator.translate('layer.indicator.time.label') + '</label><div>' + this.getTimeFrameStr() + '</div>');
        }
        const warningMessages = this.getServiceConfig().getWarningMessages().filter((wm)=>wm.shouldBeShown());
        if (warningMessages.length > 0) {
            const warningsElem = $dc57b31f1b066f38$exports('<div class="warnings"><label>' + this.translator.translate('layer.warningList') + '</label><ul></ul></div>');
            layerPropertiesDiv.append(warningsElem);
            warningMessages.map((wm)=>$dc57b31f1b066f38$exports('<li>' + wm.getMessage() + '</li>')).forEach((li)=>$dc57b31f1b066f38$exports('ul', warningsElem).append(li));
        }
        const dataCatalogueUrl = productConfig.getDataCatalogueUrl(this.getCurrentDate());
        if (dataCatalogueUrl) layerPropertiesDiv.append($dc57b31f1b066f38$exports('<div class="layer-catalog-url"><label>' + dataCatalogueUrl.name + '</label> <a target="_blank" href="' + dataCatalogueUrl.url + '">[' + this.translator.translate('layer.indicator.catalogueUrlTitle') + ']</a></div>'));
        const factsSheetUrl = productConfig.getFactSheetUrl(this.getCurrentDate());
        if (factsSheetUrl && factsSheetUrl.length > 0) layerPropertiesDiv.append($dc57b31f1b066f38$exports('<div class="fact-sheet-url"><label>' + this.translator.translate('layer.indicator.factSheet.label') + '</label> <a target="_blank" href="' + factsSheetUrl + '">[' + this.translator.translate('layer.indicator.factSheet.open') + ']</a></div>'));
        const license = productConfig.getLicense(this.getCurrentDate());
        if ((0, $2536f84a954bf107$export$51c197c9b00a6c1c)(license)) {
            const licenseElements = $dc57b31f1b066f38$exports('<div class="layer-license"><label>' + this.translator.translate('layer.indicator.license.label') + '</label> <a class="show-license show-hidden-text">[' + this.translator.translate('layer.indicator.license.show') + ']</a><div class="hidden-text-container license-container">' + license + '</div></div>');
            layerPropertiesDiv.append(licenseElements);
            $dc57b31f1b066f38$exports('.show-license', licenseElements).click(function() {
                $dc57b31f1b066f38$exports('.license-container', licenseElements).toggle();
            });
        }
        const citationStatement = productConfig.getCitationStatement(this.getCurrentDate());
        if ((0, $2536f84a954bf107$export$51c197c9b00a6c1c)(citationStatement)) {
            const citationStatementElements = $dc57b31f1b066f38$exports('<div class="layer-citation-statement"><label>' + this.translator.translate('layer.indicator.citationStatement.label') + '</label> <a class="show-citation-statement show-hidden-text">[' + this.translator.translate('layer.indicator.citationStatement.show') + ']</a><div class="hidden-text-container citation-statement-container">' + citationStatement + '</div></div>');
            layerPropertiesDiv.append(citationStatementElements);
            $dc57b31f1b066f38$exports('.show-citation-statement', citationStatementElements).click(function() {
                $dc57b31f1b066f38$exports('.citation-statement-container', citationStatementElements).toggle();
            });
        }
        const publicationTitle = productConfig.getPublicationTitle(this.getCurrentDate());
        if ((0, $2536f84a954bf107$export$51c197c9b00a6c1c)(publicationTitle)) {
            const publicationUrl = productConfig.getPublicationUrl(this.getCurrentDate());
            const titleElement = publicationUrl && publicationUrl.trim().length > 0 ? $dc57b31f1b066f38$exports('<p>' + publicationTitle + '<a target="_blank" href="' + publicationUrl + '"> [' + this.translator.translate('layer.indicator.refPublication.open') + ']</a></p>') : $dc57b31f1b066f38$exports('<p>' + publicationTitle + '</p>');
            const publicationAuthors = productConfig.getPublicationAuthors(this.getCurrentDate());
            const publicationYear = productConfig.getPublicationYear(this.getCurrentDate());
            const publicationPublisher = productConfig.getPublicationPublisher(this.getCurrentDate());
            const authorsElement = publicationAuthors && publicationAuthors.trim().length > 0 ? $dc57b31f1b066f38$exports('<p>' + publicationAuthors + (publicationYear ? ' [' + publicationYear + '] ' : '') + (publicationPublisher && publicationPublisher.trim().length > 0 ? '(' + publicationPublisher + ')' : '') + '</p>') : undefined;
            const publicationElements = $dc57b31f1b066f38$exports('<div class="layer-ref-publication">   <label>' + this.translator.translate('layer.indicator.refPublication.label') + '</label> ' + '   <a class="show-ref-publication show-hidden-text">[' + this.translator.translate('layer.indicator.refPublication.show') + ']</a>' + '   <div class="hidden-text-container ref-publication-container"></div>' + '</div>');
            $dc57b31f1b066f38$exports('.ref-publication-container', publicationElements).append(titleElement);
            if (authorsElement) $dc57b31f1b066f38$exports('.ref-publication-container', publicationElements).append(authorsElement);
            layerPropertiesDiv.append(publicationElements);
            $dc57b31f1b066f38$exports('.show-ref-publication', publicationElements).click(()=>$dc57b31f1b066f38$exports('.ref-publication-container', publicationElements).toggle());
        }
        const organisationName = productConfig.getOrganisationName(this.getCurrentDate());
        const contactPerson = productConfig.getContactPerson(this.getCurrentDate());
        const email = productConfig.getEmail(this.getCurrentDate());
        let contact = '';
        if ((0, $2536f84a954bf107$export$51c197c9b00a6c1c)(contactPerson)) contact += contactPerson;
        if ((0, $2536f84a954bf107$export$51c197c9b00a6c1c)(organisationName)) contact += (contact.length > 0 ? ', ' : '') + organisationName;
        if ((0, $2536f84a954bf107$export$51c197c9b00a6c1c)(email)) contact += (contact.length > 0 ? ' (' : '') + email + (contact.length > 0 ? ')' : '');
        if ((0, $2536f84a954bf107$export$51c197c9b00a6c1c)(contact)) {
            const contactElements = $dc57b31f1b066f38$exports('<div class="layer-contact"><label>' + this.translator.translate('layer.indicator.contact.label') + '</label> <a class="show-contact show-hidden-text">[' + this.translator.translate('layer.indicator.contact.show') + ']</a><div class="hidden-text-container contact-container">' + contact + '</div></div>');
            layerPropertiesDiv.append(contactElements);
            $dc57b31f1b066f38$exports('.show-contact', contactElements).click(()=>$dc57b31f1b066f38$exports('.contact-container', contactElements).toggle());
        }
        elements.append(layerPropertiesDiv);
        elements.append($dc57b31f1b066f38$exports('<div class="layer-info-legend"></div>'));
        const largeGraphic = this.legend ? this.legend.getLargeGraphic() : undefined;
        if (largeGraphic) {
            let legendContainer = $dc57b31f1b066f38$exports('<div class="layer-legend"><div class="info-title">' + this.translator.translate('layer.indicator.legend') + '</div></div>');
            legendContainer.append(largeGraphic);
            $dc57b31f1b066f38$exports('.layer-info-legend', elements).append(legendContainer);
        }
        const info = productConfig.getInfo(this.getCurrentDate());
        if (info) {
            const infoElements = $dc57b31f1b066f38$exports('<div class="layer-info"><div class="info-title">' + this.translator.translate('layer.indicator.info') + '</div>' + info + '</div>');
            $dc57b31f1b066f38$exports('a', infoElements).attr('target', '_blank');
            $dc57b31f1b066f38$exports('.layer-info-legend', elements).append(infoElements);
        }
        return elements;
    }
    /**
     * Get this layer if visible
     * @return {Array<Layer>}
     */ getVisibleLayers() {
        return this._getVisibility() ? [
            this
        ] : [];
    }
    /**
     * Get this layer
     * @return {Array<Layer>}
     */ getLayers() {
        return [
            this
        ];
    }
    /**
     * Show the options panel for this layer
     * @param absolutePosition {object} The position where to show the panel {top: integer, left: integer}
     */ showOptionsPanel(absolutePosition) {
        this._showOptionsPanel(absolutePosition, false, false);
    }
    /**
     * Show the options panel in the top left of the screen
     */ showOptionsPanelTop() {
        this._showOptionsPanel(undefined, true, false);
    }
    /**
     * Show the options panel in the bottom left of the screen
     */ showOptionsPanelBottom() {
        this._showOptionsPanel(undefined, false, true);
    }
    _showOptionsPanel(absolutePosition, isTop, isBottom) {
        const container = $dc57b31f1b066f38$exports('<div></div>');
        this.slimPanel.setContent(container);
        this.slimPanel.setTitle(this.translator.translate('layer.menuButton.name') + ' - ' + this.getName());
        const timeScales = this.layerConfig.getService().getTimeScales();
        if (timeScales.length > 0) {
            const timeScaleDropdownId = this.getCodeHtmlClass() + '_timeScale_dropdown';
            const timeScaleContainer = $dc57b31f1b066f38$exports('<div class="dropdown-container time-scale-container">   <label for="' + timeScaleDropdownId + '">' + this.translator.translate('layer.timescale.dropdown.label') + '</label>' + '</div>');
            const timeScaleOptions = timeScales.map((ts)=>{
                return new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, ts.getLocalizationKey(), ts.getCode(), undefined);
            });
            const initialValue = this.getTimeScale() ? this.getTimeScale().getCode() : timeScales[0].getCode();
            this.timeScaleDropdown = new (0, $d0c219b43b862888$export$931cbfb6bfb85fc)(this.translator, this.isMobileDevice, timeScaleDropdownId, timeScaleOptions, initialValue, true, undefined, (dropDown)=>this.setTimeScale(dropDown.getValue()), undefined);
            timeScaleContainer.append(this.timeScaleDropdown.getUIElement());
            container.append(timeScaleContainer);
        }
        if (this.hasTimespan()) {
            const timeCode = this.getCurrentTimeCode();
            if (!this.timeCodeCalculator.isYearless()) {
                const yearSliderId = this.getCodeHtmlClass() + '_year_slider';
                const minYear = this.timeCodeCalculator.getMinYear();
                const maxYear = this.timeCodeCalculator.getMaxYear();
                const currentYear = this.timeCodeCalculator.parseYear(timeCode);
                this.yearSlider = new (0, $c7406baad5d56380$export$472062a354075cee)(this.translator, this.isMobileDevice, yearSliderId, minYear, maxYear, currentYear, 1, maxYear - minYear + 1, undefined, undefined, (slider)=>{
                    const year = slider.getValue();
                    const currentTimeCode = this.getCurrentTimeCode();
                    if (this.timeCodeCalculator.isYearly()) this.setTimeCode(this.timeCodeCalculator.writeYearly(year, true));
                    else if (this.timeCodeCalculator.isMonthly()) this.setTimeCode(this.timeCodeCalculator.writeMonthly(year, this.timeCodeCalculator.parseMonth(currentTimeCode), true));
                    else if (this.timeCodeCalculator.isMonthlyForecast()) this.setTimeCode(this.timeCodeCalculator.writeMonthlyForecast(year, this.timeCodeCalculator.parseMonth(currentTimeCode), true));
                    else if (this.timeCodeCalculator.isTenDaily() || this.timeCodeCalculator.isMonthlyUpdatedTenDaily()) this.setTimeCode(this.timeCodeCalculator.writeTenDaily(year, this.timeCodeCalculator.parseMonth(currentTimeCode), this.timeCodeCalculator.parseTenDays(currentTimeCode), true));
                    else if (this.timeCodeCalculator.isWeekly()) this.setTimeCode(this.timeCodeCalculator.writeWeekly(year, this.timeCodeCalculator.parseWeek(currentTimeCode), true));
                    else if (this.timeCodeCalculator.isISOWeekly()) this.setTimeCode(this.timeCodeCalculator.writeISOWeekly(year, this.timeCodeCalculator.parseISOWeek(currentTimeCode), true));
                    else if (this.timeCodeCalculator.isDaily()) this.setTimeCode(this.timeCodeCalculator.writeDaily(year, this.timeCodeCalculator.parseMonth(currentTimeCode), this.timeCodeCalculator.parseDay(currentTimeCode), true));
                }, true, true);
                let yearContainer = $dc57b31f1b066f38$exports('<div class="slider-container time-container">   <label for="' + yearSliderId + '">' + this.translator.translate('layer.year.slider.label') + '</label>' + '</div>').append(this.yearSlider.getUIElement());
                container.append(yearContainer);
            }
            if (this.timeCodeCalculator.isWeekly() || this.timeCodeCalculator.isISOWeekly()) {
                const isISOWeekly = this.timeCodeCalculator.isISOWeekly();
                const weekSliderId = this.getCodeHtmlClass() + '_week_slider';
                const weekContainer = $dc57b31f1b066f38$exports('<div class="slider-container time-container">   <label for="' + weekSliderId + '">' + this.translator.translate(isISOWeekly ? 'layer.ISOWeek.slider.label' : 'layer.week.slider.label') + '</label>' + '</div>');
                const onChangeYearWeekly = ()=>{
                    const year = this.yearSlider.getValue();
                    const minWeek = isISOWeekly ? this.timeCodeCalculator.getMinISOWeekForYear(year) : this.timeCodeCalculator.getMinWeekForYear(year);
                    const maxWeek = isISOWeekly ? this.timeCodeCalculator.getMaxISOWeekForYear(year) : this.timeCodeCalculator.getMaxWeekForYear(year);
                    const currentWeek = this.weekSlider ? Math.max(minWeek, Math.min(maxWeek, this.weekSlider.getValue())) : Math.max(minWeek, Math.min(maxWeek, isISOWeekly ? this.timeCodeCalculator.parseISOWeek(this.getCurrentTimeCode()) : this.timeCodeCalculator.parseWeek(this.getCurrentTimeCode())));
                    const parsedYear = this.timeCodeCalculator.parseYear(this.getCurrentTimeCode());
                    this.setTimeCode(isISOWeekly ? this.timeCodeCalculator.writeISOWeekly(parsedYear, currentWeek, true) : this.timeCodeCalculator.writeWeekly(parsedYear, currentWeek, true));
                    this.weekSlider = new (0, $c7406baad5d56380$export$472062a354075cee)(this.translator, this.isMobileDevice, weekSliderId, minWeek, maxWeek, currentWeek, 1, maxWeek - minWeek, undefined, (value)=>{
                        const year = this.yearSlider.getValue();
                        const fstDateStr = isISOWeekly ? this.timeCodeCalculator.writeISOWeekly(year, value, true) : this.timeCodeCalculator.writeWeekly(year, value, true);
                        const lstDate = this.timeCodeCalculator.addDays((0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(fstDateStr), 6);
                        const lstDateStr = this.timeCodeCalculator.writeDaily(this.timeCodeCalculator.getYearFromDate(lstDate), this.timeCodeCalculator.getMonthFromDate(lstDate), this.timeCodeCalculator.getDayFromDate(lstDate), true);
                        return $dc57b31f1b066f38$exports('<div class="week-slider-legend"><div>' + fstDateStr + '</div><div>' + lstDateStr + '</div></div>');
                    }, (slider)=>{
                        let week = slider.getValue();
                        const currentTimeCode = this.getCurrentTimeCode();
                        const parsedYear = this.timeCodeCalculator.parseYear(currentTimeCode);
                        this.setTimeCode(isISOWeekly ? this.timeCodeCalculator.writeISOWeekly(parsedYear, week, true) : this.timeCodeCalculator.writeWeekly(parsedYear, week, true));
                    }, true, true, this.yearSlider, (parentValue)=>isISOWeekly ? this.timeCodeCalculator.getMaxISOWeekForYear(parentValue) : this.timeCodeCalculator.getMaxWeekForYear(parentValue), (parentValue)=>isISOWeekly ? this.timeCodeCalculator.getMinISOWeekForYear(parentValue) : this.timeCodeCalculator.getMinWeekForYear(parentValue));
                    $dc57b31f1b066f38$exports('#' + weekSliderId).remove();
                    weekContainer.append(this.weekSlider.getUIElement());
                    this.yearSlider.onChange(onChangeYearWeekly);
                };
                onChangeYearWeekly();
                container.append(weekContainer);
            } else if (this.timeCodeCalculator.isMonthly() || this.timeCodeCalculator.isMonthlyForecast() || this.timeCodeCalculator.isDaily() || this.timeCodeCalculator.isDailyYearless() || this.timeCodeCalculator.isTenDaily() || this.timeCodeCalculator.isMonthlyUpdatedTenDaily() || this.timeCodeCalculator.isTenDailyYearless() || this.timeCodeCalculator.isTenDailyYearless30Day()) {
                const monthSliderId = this.getCodeHtmlClass() + '_month_slider';
                const monthContainer = $dc57b31f1b066f38$exports('<div class="slider-container time-container">   <label for="' + monthSliderId + '">' + this.translator.translate('layer.month.slider.label') + '</label>' + '</div>');
                const onChangeYearMonthly = ()=>{
                    const minMonth = this.timeCodeCalculator.getMinMonthForYear(this.yearSlider ? this.yearSlider.getValue() : 0);
                    const maxMonth = this.timeCodeCalculator.getMaxMonthForYear(this.yearSlider ? this.yearSlider.getValue() : 0);
                    const currentMonth = this.monthSlider ? Math.max(minMonth, Math.min(maxMonth, this.monthSlider.getValue())) : Math.max(minMonth, Math.min(maxMonth, this.timeCodeCalculator.parseMonth(this.getCurrentTimeCode())));
                    const setTimeCode = (month)=>{
                        const currentTimeCode = this.getCurrentTimeCode();
                        if (this.timeCodeCalculator.isMonthly()) this.setTimeCode(this.timeCodeCalculator.writeMonthly(this.timeCodeCalculator.parseYear(currentTimeCode), month, true));
                        else if (this.timeCodeCalculator.isMonthlyForecast()) this.setTimeCode(this.timeCodeCalculator.writeMonthlyForecast(this.timeCodeCalculator.parseYear(currentTimeCode), month, true));
                        else if (this.timeCodeCalculator.isTenDaily() || this.timeCodeCalculator.isMonthlyUpdatedTenDaily() || this.timeCodeCalculator.isTenDailyYearless() || this.timeCodeCalculator.isTenDailyYearless30Day()) this.setTimeCode(this.timeCodeCalculator.writeTenDaily(this.timeCodeCalculator.parseYear(currentTimeCode), month, this.timeCodeCalculator.parseTenDays(currentTimeCode), true));
                        else if (this.timeCodeCalculator.isDaily() || this.timeCodeCalculator.isDailyYearless()) this.setTimeCode(this.timeCodeCalculator.writeDaily(this.timeCodeCalculator.parseYear(currentTimeCode), month, this.timeCodeCalculator.parseDay(currentTimeCode), true));
                    };
                    setTimeCode(currentMonth);
                    this.monthSlider = new (0, $c7406baad5d56380$export$472062a354075cee)(this.translator, this.isMobileDevice, monthSliderId, minMonth, maxMonth, currentMonth, 1, maxMonth - minMonth + 1, undefined, undefined, (slider)=>setTimeCode(slider.getValue()), true, true, this.yearSlider, (parentValue)=>this.timeCodeCalculator.getMaxMonthForYear(parentValue), (parentValue)=>this.timeCodeCalculator.getMinMonthForYear(parentValue));
                    $dc57b31f1b066f38$exports('#' + monthSliderId).remove();
                    monthContainer.append(this.monthSlider.getUIElement());
                    if (this.yearSlider) this.yearSlider.onChange(onChangeYearMonthly);
                };
                onChangeYearMonthly();
                container.append(monthContainer);
                if (this.timeCodeCalculator.isTenDaily() || this.timeCodeCalculator.isMonthlyUpdatedTenDaily() || this.timeCodeCalculator.isTenDailyYearless() || this.timeCodeCalculator.isTenDailyYearless30Day()) {
                    const tenDaySliderId = this.getCodeHtmlClass() + '_tenDay_slider';
                    const tenDayContainer = $dc57b31f1b066f38$exports('<div class="slider-container time-container">   <label for="' + tenDaySliderId + '">' + this.translator.translate('layer.tenday.slider.label') + '</label>' + '</div>');
                    const onChangeMonthYearTenDaily = ()=>{
                        const min = this.timeCodeCalculator.getMinTenDaysForYearMonth(this.yearSlider ? this.yearSlider.getValue() : 0, this.monthSlider.getValue());
                        const max = this.timeCodeCalculator.getMaxTenDaysForYearMonth(this.yearSlider ? this.yearSlider.getValue() : 0, this.monthSlider.getValue());
                        const currentTenDay = this.tenDaySlider ? Math.max(min, Math.min(max, this.tenDaySlider.getValue())) : Math.max(min, Math.min(max, this.timeCodeCalculator.parseDay(this.getCurrentTimeCode())));
                        this.setTimeCode(this.timeCodeCalculator.writeTenDaily(this.timeCodeCalculator.parseYear(this.getCurrentTimeCode()), this.timeCodeCalculator.parseMonth(this.getCurrentTimeCode()), currentTenDay, true));
                        this.tenDaySlider = new (0, $c7406baad5d56380$export$472062a354075cee)(this.translator, this.isMobileDevice, tenDaySliderId, min, max, currentTenDay, 1, max - min + 1, undefined, undefined, (slider)=>{
                            const tenDay = slider.getValue();
                            const currentTimeCode = this.getCurrentTimeCode();
                            this.setTimeCode(this.timeCodeCalculator.writeTenDaily(this.timeCodeCalculator.parseYear(currentTimeCode), this.timeCodeCalculator.parseMonth(currentTimeCode), tenDay, true));
                        }, true, true, this.monthSlider, (parentValue)=>this.timeCodeCalculator.getMaxTenDaysForYearMonth(this.yearSlider ? this.yearSlider.getValue() : 0, parentValue), (parentValue)=>this.timeCodeCalculator.getMinDayForYearMonth(this.yearSlider ? this.yearSlider.getValue() : 0, parentValue));
                        $dc57b31f1b066f38$exports('#' + tenDaySliderId).remove();
                        tenDayContainer.append(this.tenDaySlider.getUIElement());
                        if (this.yearSlider) this.yearSlider.onChange(onChangeMonthYearTenDaily);
                        this.monthSlider.onChange(onChangeMonthYearTenDaily);
                    };
                    onChangeMonthYearTenDaily();
                    container.append(tenDayContainer);
                } else if (this.timeCodeCalculator.isDaily() || this.timeCodeCalculator.isDailyYearless()) {
                    const daySliderId = this.getCodeHtmlClass() + '_day_slider';
                    let dayContainer = $dc57b31f1b066f38$exports('<div class="slider-container time-container">   <label for="' + daySliderId + '">' + this.translator.translate('layer.day.slider.label') + '</label>' + '</div>');
                    const onChangeMonthYearDaily = ()=>{
                        const year = this.yearSlider ? this.yearSlider.getValue() : undefined;
                        const min = this.timeCodeCalculator.getMinDayForYearMonth(year, this.monthSlider.getValue());
                        const max = this.timeCodeCalculator.getMaxDayForYearMonth(year, this.monthSlider.getValue());
                        const currentDay = this.daySlider ? Math.max(min, Math.min(max, this.daySlider.getValue())) : Math.max(min, Math.min(max, this.timeCodeCalculator.parseDay(this.getCurrentTimeCode())));
                        this.setTimeCode(this.timeCodeCalculator.writeDaily(this.timeCodeCalculator.parseYear(this.getCurrentTimeCode()), this.timeCodeCalculator.parseMonth(this.getCurrentTimeCode()), currentDay, true));
                        this.daySlider = new (0, $c7406baad5d56380$export$472062a354075cee)(this.translator, this.isMobileDevice, daySliderId, min, max, currentDay, 1, max - min + 1, undefined, undefined, (slider)=>{
                            const day = slider.getValue();
                            const currentTimeCode = this.getCurrentTimeCode();
                            this.setTimeCode(this.timeCodeCalculator.writeDaily(this.timeCodeCalculator.parseYear(currentTimeCode), this.timeCodeCalculator.parseMonth(currentTimeCode), day, true));
                        }, true, true, this.monthSlider, (parentValue)=>this.timeCodeCalculator.getMaxDayForYearMonth(year, parentValue), (parentValue)=>this.timeCodeCalculator.getMinDayForYearMonth(year, parentValue));
                        $dc57b31f1b066f38$exports('#' + daySliderId).remove();
                        dayContainer.append(this.daySlider.getUIElement());
                        if (this.yearSlider) this.yearSlider.onChange(onChangeMonthYearDaily);
                        this.monthSlider.onChange(onChangeMonthYearDaily);
                    };
                    onChangeMonthYearDaily();
                    container.append(dayContainer);
                }
            }
        }
        const opacitySliderId = this.getCodeHtmlClass() + '_opacity_slider';
        this.opacitySlider = new (0, $c7406baad5d56380$export$472062a354075cee)(this.translator, this.isMobileDevice, opacitySliderId, 0.2, 1, this.layerConfig.getOpacity(), 0.01, 9, (value)=>(value * 100).toFixed(0) + '%', undefined, (slider)=>this.setOpacity(slider.getValue()), false, false);
        const opacityContainer = $dc57b31f1b066f38$exports('<div class="slider-container opacity-container">   <label for="' + opacitySliderId + '">' + this.translator.translate('layer.opacity.slider.label') + '</label>' + '</div>').append(this.opacitySlider.getUIElement());
        container.append(opacityContainer);
        if (absolutePosition) {
            const width = this.slimPanel.getUIElement().width() + this.containerAbsolutePosition.left;
            const height = this.slimPanel.getUIElement().height() + this.containerAbsolutePosition.top;
            const mapWidth = this.containerWidth + this.containerAbsolutePosition.left;
            const mapHeight = this.containerHeight + this.containerAbsolutePosition.top;
            absolutePosition.left = absolutePosition.left + width + 2 > mapWidth - 2 ? mapWidth - width - 10 : absolutePosition.left + 2;
            absolutePosition.top = absolutePosition.top + height > mapHeight ? mapHeight - height - 10 : absolutePosition.top;
            this.slimPanel.show(absolutePosition.top, absolutePosition.left);
        } else if (isTop) this.slimPanel.showTop();
        else if (isBottom) this.slimPanel.showBottom();
    }
    /**
     * Does this layer have time?
     * @return {boolean}
     */ hasTime() {
        return this.getDataFrom() && this.getDataUntil() && !this.timeCodeCalculator.isUnknown();
    }
    /**
     * Does this layer have timespan?
     * @return {boolean}
     */ hasTimespan() {
        return this.hasTime() && !this.timeCodeCalculator.isLatest() && this.getDataFrom() < this.getDataUntil();
    }
    /**
     * Get the chart type for this layer
     * @return {IndicatorChartTypeEnum}
     */ getChartType() {
        return this.layerConfig.getChartType();
    }
    showChart(coordinates, featureProps, featureName, dataSeriesUrl, chartModal, infoModal) {
        if (!chartModal) chartModal = this.chartModal;
        if (!infoModal) infoModal = this.infoModal;
        const timeCalculator = this.getTimeCalculator();
        const currentTime = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(this.getCurrentTimeCode());
        const from = currentTime ? timeCalculator.fixDate(timeCalculator.addDays(currentTime, -365)) : undefined;
        const until = currentTime;
        const datePicker = new (0, $84f00262b5923f0a$export$5109c6dd95d8fb00)('chart_date_picker_' + this.getCode(), this.translator, [
            this
        ], timeCalculator.getPeriodicity(), this.runtimeConfig, this.onChangeRuntimeConfig, this.isMobileDevice);
        datePicker.setDefaultFromUntil(from, until);
        const datePickerElement = datePicker.getUIElement();
        const indicatorChart = featureProps ? new (0, $5180cc201ee0f189$export$acdeaeba4c73485f)('indicator_chart_' + this.getCode(), featureName, this.translator, this, infoModal, this.runtimeConfig, this.isMobileDevice) : new (0, $5180cc201ee0f189$export$d1dc5266372a764e)('indicator_chart_' + this.getCode(), this.translator, dataSeriesUrl, this, infoModal, this.runtimeConfig, this.isMobileDevice);
        const charElement = indicatorChart.getUIElement();
        const onChangeDates = (picker)=>indicatorChart.setFromUntilAndCoords(picker.getFrom(), picker.getUntil(), coordinates, featureProps);
        datePicker.onChange(onChangeDates);
        chartModal.setTitle(this.translator.translate('layer.indicator.chartTitle', [
            (0, $40ab8c40db995546$export$3fe43bac65f73092)(coordinates)
        ]));
        const content = $dc57b31f1b066f38$exports('<div><ul></ul></div>');
        chartModal.setContent(content);
        $dc57b31f1b066f38$exports('ul', content).addClass('container-list').append(datePickerElement).append(charElement);
        datePicker.onAdd2DOM();
        indicatorChart.onAdd2DOM();
        chartModal.show();
        onChangeDates(datePicker);
    }
    showInfo(modal) {
        const openModal = super.showInfo(modal);
        if (openModal) openModal.setTitle(this.translator.translate('layer.info.modalTitleIndicator'));
        return openModal;
    }
}
/**
 * A base layer
 * @extends AbstractLayer
 */ class $4cbe6e39851964f1$export$9a5c645bcfeb4118 extends $4cbe6e39851964f1$var$AbstractLayer {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param slimPanel {SlimPanel} A slim panel to display the layers options
     * @param infoModal {Modal} A modal to show indicator information in
     * @param layerConfig {Object} The layer config
     * @param tileGridGetter {function} A function that given a service config, returns a map's TileGrid
     * @param projection {Projection} Map's current projection
     * @param runtimeConfig {RuntimeConfig} The map runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param onChangeVisibleLayers {function} A callback to be called when this layer changes visibility
     * @param mapBackgroundColorSetter {function} A callback to change the map background color, when the layer becomes visible
     */ constructor(translator, isMobileDevice, slimPanel, infoModal, layerConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers, mapBackgroundColorSetter){
        super(translator, isMobileDevice, slimPanel, infoModal, layerConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers);
        this.mapBackgroundColorSetter = mapBackgroundColorSetter;
        this._initServices();
    }
    getClassName() {
        return "BaseLayer";
    }
    _initServices() {
        this.services = [];
        this.services.push(new $4cbe6e39851964f1$var$BaseLayerService(this.layerConfig.getService(), this.isMobileDevice, this.layerConfig.getProduct(), this.projection, this.tileGridGetter, 1, this.layerConfig.isVisible(), this.runtimeConfig));
    }
    /**
     *
     * @param slimPanel {SlimPanel} A slim panel to display the layers options
     * @param projection {Projection} Map's current projection
     * @param runtimeConfig {MapRuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @param mapBackgroundColorSetter {function} A callback to set the background color of the map
     * @return {BaseLayer}
     */ clone(slimPanel, projection, runtimeConfig, onChangeRuntimeConfig, mapBackgroundColorSetter) {
        const layerConfig = this.layerConfig.clone();
        layerConfig.override(runtimeConfig);
        return new $4cbe6e39851964f1$export$9a5c645bcfeb4118(this.translator, this.isMobileDevice, slimPanel, this.infoModal, layerConfig, this.tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, undefined, mapBackgroundColorSetter).set('cloned', true);
    }
    getUIElement() {
        if (!this.uiElement) this.uiElement = $dc57b31f1b066f38$exports('<div role="listitem" class="base-layer-container base-layer-code-' + this.getCodeHtmlClass() + '">' + '  <div class="base-layer-header tree-header">' + '     <div class="base-layer-checkbox-container checkbox-container"><input tabindex="0" id="base_layer_' + this.getCodeHtmlClass() + '" value="' + this.getCode() + '" name="base_layer" type="radio" ' + (this.isVisible() ? 'checked="checked"' : '') + ' /></div>' + '     <div class="base-layer-name"><label for="base_layer_' + this.getCodeHtmlClass() + '">' + this.getName() + '</label></div>' + '  </div>' + '  <div class="base-layer-body"></div>' + '</div>');
        return this.uiElement;
    }
    getInfoElements() {
        const elements = $dc57b31f1b066f38$exports('<div class="layer-info"></div>');
        const layerProperties = $dc57b31f1b066f38$exports('<div class="layer-properties"><div class="layer-name"><label>' + this.translator.translate(this.getLabelKey()) + '</label> ' + this.getName() + '</div>' + '</div>');
        elements.append(layerProperties);
        elements.append($dc57b31f1b066f38$exports('<div class="layer-info-legend"></div>'));
        const largeGraphic = this.legend ? this.legend.getLargeGraphic() : undefined;
        if (largeGraphic) {
            let legendContainer = $dc57b31f1b066f38$exports('<div class="layer-legend"><div class="info-title">' + this.translator.translate('layer.indicator.legend') + '</div></div>');
            legendContainer.append(largeGraphic);
            $dc57b31f1b066f38$exports('.layer-info-legend', elements).append(legendContainer);
        } else elements.addClass('no-legend');
        const productConfig = this.getProductConfig();
        const infoElements = $dc57b31f1b066f38$exports('<div class="layer-info"><div class="info-title">' + this.translator.translate('layer.indicator.info') + '</div>' + productConfig.getInfo() + '</div>');
        $dc57b31f1b066f38$exports('a', infoElements).attr('target', '_blank');
        $dc57b31f1b066f38$exports('.layer-info-legend', elements).append(infoElements);
        return elements;
    }
    /**
     * Get the translatable label key for base layers
     * @return {string}
     */ getLabelKey() {
        return 'base.layer.label';
    }
    getSlimUIElement() {
        this.slimUIElement = $dc57b31f1b066f38$exports('<div tabindex="0" class="layer-container-slim">   <div class="layer-header-slim">       <button type="button" class="layer-info-button" tabindex="0"></button>       <div class="layer-title-slim">' + this.getName() + '</div>' + '   </div>' + '</div>');
        this.onFocusedEnterOrSpace(()=>$dc57b31f1b066f38$exports('.layer-title-slim', this.slimUIElement).click(), this.slimUIElement);
        if (this.legend) {
            const legendContainer = $dc57b31f1b066f38$exports('<div class="layer-legend-slim"></div>').append(this.legend.getSmallGraphic());
            this.slimUIElement.append(legendContainer);
        } else {
            const info = this.getProductConfig().getInfo();
            if (info) {
                const infoContainer = $dc57b31f1b066f38$exports('<div class="layer-info-slim"></div>').append(info.crop(100));
                $dc57b31f1b066f38$exports('a', infoContainer).attr('target', '_blank');
                this.slimUIElement.append(infoContainer);
            }
        }
        return this.slimUIElement;
    }
    setVisible(isVisible) {
        this.runtimeConfig.setBaseLayerVisibility(this.getCode(), isVisible);
        this.onChangeRuntimeConfig();
        this.visibility();
    }
    visibility(visible) {
        const visibility = super.visibility(visible);
        if (visibility && this.mapBackgroundColorSetter) this.mapBackgroundColorSetter(this.layerConfig.getMapBackgroundColor());
        return visibility;
    }
}
/**
 * A context layer
 * @extends BaseLayer
 * @hideconstructor
 */ class $4cbe6e39851964f1$export$5e6fcee974d9d9d7 extends $4cbe6e39851964f1$export$9a5c645bcfeb4118 {
    constructor(translator, isMobileDevice, slimPanel, infoModal, layerConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers){
        super(translator, isMobileDevice, slimPanel, infoModal, layerConfig, tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, onChangeVisibleLayers, undefined);
    }
    getClassName() {
        return "ContextLayer";
    }
    _initServices() {
        this.services = [];
        this.services.push(new $4cbe6e39851964f1$var$Service(this.layerConfig.getService(), this.isMobileDevice, this.layerConfig.getProduct(), this.projection, this.tileGridGetter, 1, this.layerConfig.isVisible(), this.runtimeConfig));
    }
    /**
     *
     * @param slimPanel {SlimPanel} A slim panel to display the layers options
     * @param projection {Projection} Map's current projection
     * @param runtimeConfig {MapRuntimeConfig} The runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     * @return {ContextLayer}
     */ clone(slimPanel, projection, runtimeConfig, onChangeRuntimeConfig) {
        const layerConfig = this.layerConfig.clone();
        layerConfig.override(runtimeConfig);
        return new $4cbe6e39851964f1$export$5e6fcee974d9d9d7(this.translator, this.isMobileDevice, slimPanel, this.infoModal, layerConfig, this.tileGridGetter, projection, runtimeConfig, onChangeRuntimeConfig, undefined).set('cloned', true);
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div role="listitem" class="context-layer-container context-layer-code-' + this.getCodeHtmlClass() + '">' + '  <div class="context-layer-header tree-header">' + '     <div class="context-layer-checkbox-container checkbox-container"><input  tabindex="0" id="context_layer_' + this.getCodeHtmlClass() + '" value="' + this.getCode() + '" name="context_layer" type="checkbox" ' + (this.isVisible() ? 'checked="checked"' : '') + ' /></div>' + '     <div class="context-layer-name"><label for="context_layer_' + this.getCodeHtmlClass() + '">' + this.getName() + '</label></div>' + '  </div>' + '  <div class="context-layer-body"></div>' + '</div>');
            const self = this;
            $dc57b31f1b066f38$exports('.context-layer-checkbox-container>input[type=checkbox]', this.uiElement).change(function() {
                const visible = $dc57b31f1b066f38$exports(this).is(':checked');
                self.setVisible(visible);
                self.logStat(visible ? "SHOW" : "HIDE");
            });
        }
        return this.uiElement;
    }
    /**
     * Get the translatable label key for context layers
     * @return {string}
     */ getLabelKey() {
        return 'context.layer.label';
    }
    setVisible(isVisible) {
        this.runtimeConfig.setContextLayerVisibility(this.getCode(), isVisible);
        this.onChangeRuntimeConfig();
        this.visibility(isVisible);
    }
}
(0, $bc6d7cfcca5213f3$export$e3456b5d55e1b02f)();
const $4cbe6e39851964f1$var$FEATURE_PARSER_BY_SERVICE_CODE = {};
const $4cbe6e39851964f1$var$URL_PARAMS_GENERATOR_BY_SERVICE_CODE = {};
const $4cbe6e39851964f1$var$END_DATE_GENERATOR_BY_PRODUCT_CODE = {};
/**
 * Register a feature parser, to parse the feature and return the relevant properties for information for the user
 * @param serviceCode {string} The code of a vector service
 * @param parser {FeatureParser} The parser for the layer corresponding to the service code
 */ function $4cbe6e39851964f1$export$cb554be2cef1312f(serviceCode, parser) {
    $4cbe6e39851964f1$var$FEATURE_PARSER_BY_SERVICE_CODE[serviceCode] = parser;
}
/**
 * Register a URL generator, to generate a layer URL given current layer time and current layer timescale
 * @param serviceCode {string} The code of a layer service
 * @param generator {function} A function that takes Date and a timescale code (string) and returns a map of param name to param value
 */ function $4cbe6e39851964f1$export$da67369950485fdf(serviceCode, generator) {
    $4cbe6e39851964f1$var$URL_PARAMS_GENERATOR_BY_SERVICE_CODE[serviceCode] = generator;
}
/**
 * Register an end date generator, to generate the end date given a product code
 * @param productCode {string} The code of a product
 * @param generator {function} A function that returns a date
 */ function $4cbe6e39851964f1$export$7d1e3e0664d29f28(productCode, generator) {
    $4cbe6e39851964f1$var$END_DATE_GENERATOR_BY_PRODUCT_CODE[productCode] = generator;
}
/**
 * A class to be overridden by external code in order to implement a feature parser for a vector layer
 */ class $4cbe6e39851964f1$export$f9af5fa6a365d492 {
    /**
     * The name of a feature, given its properties
     * @param properties {Object} A map of prop name to prop value
     * @return {string|undefined}
     */ getName(properties) {}
    /**
     * The WMS url for an additional layer to be shown on feature click
     * @param properties {Object} A map of prop name to prop value
     * @param timeParams {Object} A map of time parameter name to time parameter value
     * @return {string|undefined}
     */ getWmsUrl(properties, timeParams) {
        return undefined;
    }
    /**
     * Get the formatted values and labels to show on a popup on feature click
     * @param properties {Object} A map of prop name to prop value
     * @param styler {ChartStyler} The styler for the layer of this feature
     * @param timeParams {Object} A map of time parameter name to time parameter value
     * @return {Object} A map from property label to property formatted value
     */ getFormattedProperties(properties, styler, timeParams) {}
}
window.tumbo.FeatureParser = $4cbe6e39851964f1$export$f9af5fa6a365d492;
window.tumbo.registerFeatureParser = $4cbe6e39851964f1$export$cb554be2cef1312f;
window.tumbo.registerUrlParamsGenerator = $4cbe6e39851964f1$export$da67369950485fdf;
window.tumbo.registerEndDateGenerator = $4cbe6e39851964f1$export$7d1e3e0664d29f28;




/**
 * A processor for layer timeseries
 * @abstract
 * @extends Base
 */ class $875244ae9c425d8b$var$AbstractTimeseriesProcessor extends (0, $c804408d7d980f44$export$ef88aa0d34c34520) {
    /**
     * @param data {object} a map from string (date) to object of classification/range (string) to count (integer)
     * @param chartStyler {ChartStyler}
     * @param timeCalculator {TimeCalculator}
     */ constructor(data, chartStyler, timeCalculator){
        super();
        this.data = data;
        this.chartStyler = chartStyler;
        this.timeCalculator = timeCalculator;
    }
    getClassName() {
        return "AbstractTimeseriesProcessor";
    }
    /**
     * Get data filtered
     * @param from {Date | undefined} filter from
     * @param until {Date | undefined} filter until
     * @return {Array<object>} Array<{x:Array<string>, y:Array<object>, colors:object}> \
     *     - x is Array of dates formatted as YYYY-MM-DD
     *     - y is Array of label (string) to percentage (number)
     *     - colors is a map of label (string) to CSS color (string)
     *
     */ getData(from, until) {
        const filteredData = this._getFilteredData(from, until);
        const valueSeries = [], colors = {}, ordinals = {};
        const noDataLabel = this.chartStyler.getLabelFunction()(null);
        filteredData.values.forEach((v)=>{
            const sum = v ? Object.keys(v).map((k)=>v[k]).reduce((v1, v2)=>v1 + v2, 0) : null;
            const values = {};
            if (v) Object.keys(v).forEach((k)=>{
                const value = this.getClassToValue(k);
                const label = this.chartStyler.getLabelFunction()(value);
                values[label] = v[k];
                colors[label] = this.chartStyler.getColorFunction()(value);
                ordinals[label] = this.getClassToOrdinal(k);
            });
            if (sum !== null && noDataLabel) values[noDataLabel] = 100 - sum;
            valueSeries.push(values);
        });
        if (noDataLabel) {
            colors[noDataLabel] = this.chartStyler.getColorFunction()(null);
            ordinals[noDataLabel] = Math.max.apply(null, this.getOrdinals()) + 1;
        }
        return [
            {
                x: filteredData.dates,
                y: valueSeries,
                colors: colors,
                ordinals: ordinals
            }
        ];
    }
    _getFilteredData(from, until) {
        const dates = this.timeCalculator.getTimeSeries(from, until), values = [];
        dates.map((d)=>(0, $aeedcab592f41cce$export$3ae94a2503e890a1)(d)).forEach((d)=>{
            values.push(this.data[d] ? this.data[d] : null);
        });
        return {
            dates: dates,
            values: values
        };
    }
    getClassToValue() {}
    getClassToOrdinal() {}
    getOrdinals() {}
}
class $875244ae9c425d8b$export$b29caf0594e3c6b5 extends $875244ae9c425d8b$var$AbstractTimeseriesProcessor {
    constructor(data, timeCalculator){
        super(data, undefined, timeCalculator);
    }
    getClassName() {
        return "ExtendedReportValuesTimeseriesProcessor";
    }
    /**
     * Get data filtered
     * @param from {Date | undefined} filter from
     * @param until {Date | undefined} filter until
     * @return {Array<object>} Array<{x:Array<string>, y:Array<number>}> \
     *     - x is Array of dates formatted as YYYY-MM-DD
     *     - y is Array of values (numbers)
     *
     */ getData(from, until) {
        const filteredData = this._getFilteredData(from, until);
        return [
            {
                x: filteredData.dates,
                y: filteredData.values
            }
        ];
    }
}
class $875244ae9c425d8b$export$3d5d2c2cd1d8751d extends $875244ae9c425d8b$export$b29caf0594e3c6b5 {
    getClassName() {
        return "ExtendedReportValuesAndStatsTimeseriesProcessor";
    }
    /**
     * Get data filtered
     * @param from {Date | undefined} filter from
     * @param until {Date | undefined} filter until
     * @return {Object} (Map of string ("values" and "accumulated") to Array<{x:Array<string>, y:Array<number>, avg:Array<number>, std:Array<number>}>) \
     *     - x is Array of dates formatted as YYYY-MM-DD
     *     - y is Array of values (numbers)
     *
     */ getData(from, until) {
        const filteredData = this._getFilteredData(from, until);
        const accumulatedValues = [], accumulatedAvg = [], accumulatedVariance = [];
        const variances = filteredData.std.map((std)=>std * std);
        for(let i = 0; i < filteredData.values.length; i++){
            accumulatedValues.push(filteredData.values.slice(0, i + 1).reduce((part, a)=>part + a, 0));
            accumulatedAvg.push(filteredData.avg.slice(0, i + 1).reduce((part, a)=>part + a, 0));
            accumulatedVariance.push(variances.slice(0, i + 1).reduce((part, a)=>part + a, 0));
        }
        return {
            values: [
                {
                    x: filteredData.dates,
                    y: filteredData.values
                },
                {
                    x: filteredData.dates.slice(),
                    y: filteredData.avg
                },
                {
                    x: filteredData.dates.slice(),
                    y: filteredData.std
                }
            ],
            accumulated: [
                {
                    x: filteredData.dates.slice(),
                    y: accumulatedValues
                },
                {
                    x: filteredData.dates.slice(),
                    y: accumulatedAvg
                },
                {
                    x: filteredData.dates.slice(),
                    y: accumulatedVariance
                }
            ]
        };
    }
    _getFilteredData(from, until) {
        const dates = this.timeCalculator.getTimeSeries(from, until), values = [], avg = [], std = [];
        dates.map((d)=>(0, $aeedcab592f41cce$export$3ae94a2503e890a1)(d)).forEach((d)=>{
            values.push(this.data.values[d] ? this.data.values[d] : null);
            const stat = this.data.stats[d];
            avg.push(stat ? stat.avg : null);
            std.push(stat ? stat.std : null);
        });
        return {
            dates: dates,
            values: values,
            avg: avg,
            std: std
        };
    }
}
class $875244ae9c425d8b$export$9477a21be5bb0dca extends $875244ae9c425d8b$var$AbstractTimeseriesProcessor {
    getClassName() {
        return "ExtendedReportRangedTimeseriesProcessor";
    }
    CLASS_TO_NUMBER = {
        "H3": 2.5,
        "H2": 1.75,
        "H1": 1.25,
        "N": 0,
        "L1": -1.25,
        "L2": -1.75,
        "L3": -2.5
    };
    CLASS_TO_ORDINAL = {
        "H3": 7,
        "H2": 6,
        "H1": 5,
        "N": 4,
        "L3": 1,
        "L2": 2,
        "L1": 3
    };
    getClassToValue(clazz) {
        return this.CLASS_TO_NUMBER[clazz];
    }
    getClassToOrdinal(clazz) {
        return this.CLASS_TO_ORDINAL[clazz];
    }
    getOrdinals() {
        return Object.values(this.CLASS_TO_ORDINAL);
    }
}
class $875244ae9c425d8b$export$af3e5605eb5a88b1 extends $875244ae9c425d8b$var$AbstractTimeseriesProcessor {
    getClassName() {
        return "ExtendedReportClassifiedTimeseriesProcessor";
    }
    CLASS_TO_ORDINAL = {
        "0": 4,
        "1": 3,
        "2": 2,
        "3": 1
    };
    getClassToValue(clazz) {
        return clazz;
    }
    getClassToOrdinal(clazz) {
        return this.CLASS_TO_ORDINAL[clazz];
    }
    getOrdinals() {
        return Object.values(this.CLASS_TO_ORDINAL);
    }
}



/**
 * Layer for the extended report
 * @extends Layer
 */ class $0c60ea0f03b409a5$export$adb584737d712b70 extends (0, $4cbe6e39851964f1$export$936d0764594b6eb3) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param indicatorConfig {Object} The indicator config
     * @param runtimeConfig {ExtendedReportRuntimeConfig} The report runtime config
     * @param onChangeRuntimeConfig {function} A callback to be called when runtimeConfig is changed
     */ constructor(translator, isMobileDevice, indicatorConfig, runtimeConfig, onChangeRuntimeConfig){
        super(translator, isMobileDevice, undefined, undefined, undefined, indicatorConfig, undefined, undefined, runtimeConfig, onChangeRuntimeConfig, false, undefined, undefined);
    }
    getClassName() {
        return "Indicator";
    }
    add2LayersByTimeTag() {
        return this;
    }
    /**
     * Set this indicator's time scale
     * @param timeScale {string}
     */ setTimeScale(timeScale) {
        this.runtimeConfig.setIndicatorTimeScale(this.getCode(), timeScale);
        this.onChangeRuntimeConfig();
        for(let ls in this.services)this.services[ls].setTimeScale((0, $815c91046e476159$export$d08fec65c77806fd).getForCode(timeScale));
        this.updateName();
    }
    getTimeseriesProcessor(data) {
        const chartType = this.layerConfig.getChartType();
        if (chartType === (0, $815c91046e476159$export$39c0195897d703ce).BARS) return new (0, $875244ae9c425d8b$export$b29caf0594e3c6b5)(data, this.timeCodeCalculator);
        if (chartType === (0, $815c91046e476159$export$39c0195897d703ce).BARS_WITH_LINE || chartType === (0, $815c91046e476159$export$39c0195897d703ce).BARS_WITH_LINE_AND_ACCUMULATION) return new (0, $875244ae9c425d8b$export$3d5d2c2cd1d8751d)(data, this.timeCodeCalculator);
        if (chartType === (0, $815c91046e476159$export$39c0195897d703ce).STACKED_BARS) {
            const type = this.getChartStyler().getFirstRuleType();
            if (type === (0, $815c91046e476159$export$23989178094d68d).DISCRETE) return new (0, $875244ae9c425d8b$export$9477a21be5bb0dca)(data, this.getChartStyler(), this.timeCodeCalculator);
            if (type === (0, $815c91046e476159$export$23989178094d68d).CLASSIFIED) return new (0, $875244ae9c425d8b$export$af3e5605eb5a88b1)(data, this.getChartStyler(), this.timeCodeCalculator);
        }
    }
}







/**
 * @module ol/source/OSM
 */ /**
 * @module ol/source/XYZ
 */ 

/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Deprecated.  Use an ImageTile source with a loader
 * instead.  Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {number} [gutter=0] The size in pixels of the gutter around image tiles to ignore.
 * This allows artifacts of rendering at tile edges to be ignored.
 * Supported images should be wider and taller than the tile size by a value of `2 x gutter`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Deprecated.  Use an ImageTile source and provide a function
 * for the url option instead.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] Deprecated.  Use an ImageTile source and provide an array of URLs for the
 * url option instead.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */ class $53940888677ee56a$var$XYZ extends (0, $1df042038de9d51b$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] XYZ options.
   */ constructor(options){
        options = options || {};
        const projection = options.projection !== undefined ? options.projection : 'EPSG:3857';
        const tileGrid = options.tileGrid !== undefined ? options.tileGrid : (0, $a46307816b1ae884$export$38500bbeccc864ff)({
            extent: (0, $a46307816b1ae884$export$7b5b6ef8fd55fac4)(projection),
            maxResolution: options.maxResolution,
            maxZoom: options.maxZoom,
            minZoom: options.minZoom,
            tileSize: options.tileSize
        });
        super({
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            interpolate: options.interpolate,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection
        });
        /**
     * @private
     * @type {number}
     */ this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
    }
    /**
   * @return {number} Gutter.
   * @override
   */ getGutter() {
        return this.gutter_;
    }
}
var $53940888677ee56a$export$2e2bcd8739ae039 = $53940888677ee56a$var$XYZ;


const $d978548adde0e5c6$export$4de8a5e77eb994ad = '&#169; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Deprecated.  Use the cacheSize option on the layer instead.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [interpolate=true] Use interpolated values when resampling.  By default,
 * linear interpolation is used when resampling.  Set to false to use the nearest neighbor instead.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */ /**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */ class $d978548adde0e5c6$var$OSM extends (0, $53940888677ee56a$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Open Street Map options.
   */ constructor(options){
        options = options || {};
        let attributions;
        if (options.attributions !== undefined) attributions = options.attributions;
        else attributions = [
            $d978548adde0e5c6$export$4de8a5e77eb994ad
        ];
        const crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous';
        const url = options.url !== undefined ? options.url : 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
        super({
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: crossOrigin,
            interpolate: options.interpolate,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection
        });
    }
}
var $d978548adde0e5c6$export$2e2bcd8739ae039 = $d978548adde0e5c6$var$OSM;




/**
 * @module ol/Map
 */ 

/**
 * @module ol/MapBrowserEvent
 */ /**
 * @module ol/MapEvent
 */ 
/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map event.
 */ class $7513f8b91fec7508$var$MapEvent extends (0, $0327f54963b35733$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {?import("./Map.js").FrameState} [frameState] Frame state.
   */ constructor(type, map, frameState){
        super(type);
        /**
     * The map where the event occurred.
     * @type {import("./Map.js").default}
     * @api
     */ this.map = map;
        /**
     * The frame state at the time of the event.
     * @type {?import("./Map.js").FrameState}
     * @api
     */ this.frameState = frameState !== undefined ? frameState : null;
    }
}
var $7513f8b91fec7508$export$2e2bcd8739ae039 = $7513f8b91fec7508$var$MapEvent;


/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/Map~Map} for which events trigger a map browser event.
 * @template {UIEvent} EVENT
 */ class $f924e5a83a2737ce$var$MapBrowserEvent extends (0, $7513f8b91fec7508$export$2e2bcd8739ae039) {
    /**
   * @param {string} type Event type.
   * @param {import("./Map.js").default} map Map.
   * @param {EVENT} originalEvent Original event.
   * @param {boolean} [dragging] Is the map currently being dragged?
   * @param {import("./Map.js").FrameState} [frameState] Frame state.
   * @param {Array<PointerEvent>} [activePointers] Active pointers.
   */ constructor(type, map, originalEvent, dragging, frameState, activePointers){
        super(type, map, frameState);
        /**
     * The original browser event.
     * @const
     * @type {EVENT}
     * @api
     */ this.originalEvent = originalEvent;
        /**
     * The map pixel relative to the viewport corresponding to the original browser event.
     * @type {?import("./pixel.js").Pixel}
     * @private
     */ this.pixel_ = null;
        /**
     * The coordinate in the user projection corresponding to the original browser event.
     * @type {?import("./coordinate.js").Coordinate}
     * @private
     */ this.coordinate_ = null;
        /**
     * Indicates if the map is currently being dragged. Only set for
     * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
     *
     * @type {boolean}
     * @api
     */ this.dragging = dragging !== undefined ? dragging : false;
        /**
     * @type {Array<PointerEvent>|undefined}
     */ this.activePointers = activePointers;
    }
    /**
   * The map pixel relative to the viewport corresponding to the original event.
   * @type {import("./pixel.js").Pixel}
   * @api
   */ get pixel() {
        if (!this.pixel_) this.pixel_ = this.map.getEventPixel(this.originalEvent);
        return this.pixel_;
    }
    set pixel(pixel) {
        this.pixel_ = pixel;
    }
    /**
   * The coordinate corresponding to the original browser event.  This will be in the user
   * projection if one is set.  Otherwise it will be in the view projection.
   * @type {import("./coordinate.js").Coordinate}
   * @api
   */ get coordinate() {
        if (!this.coordinate_) this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
        return this.coordinate_;
    }
    set coordinate(coordinate) {
        this.coordinate_ = coordinate;
    }
    /**
   * Prevents the default browser action.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
   * @api
   * @override
   */ preventDefault() {
        super.preventDefault();
        if ('preventDefault' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.preventDefault();
    }
    /**
   * Prevents further propagation of the current event.
   * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
   * @api
   * @override
   */ stopPropagation() {
        super.stopPropagation();
        if ('stopPropagation' in this.originalEvent) /** @type {UIEvent} */ this.originalEvent.stopPropagation();
    }
}
var $f924e5a83a2737ce$export$2e2bcd8739ae039 = $f924e5a83a2737ce$var$MapBrowserEvent;


/**
 * @module ol/MapBrowserEventHandler
 */ 
/**
 * @module ol/MapBrowserEventType
 */ 
var /**
 * Constants for event names.
 * @enum {string}
 */ $4d29e2d9bc8184b4$export$2e2bcd8739ae039 /***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */  = {
    /**
   * A true single click with no dragging and no double click. Note that this
   * event is delayed by 250 ms to ensure that it is not a double click.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
   * @api
   */ SINGLECLICK: 'singleclick',
    /**
   * A click with no dragging. A double click will fire two of this.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
   * @api
   */ CLICK: (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK,
    /**
   * A true double click, with no dragging.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
   * @api
   */ DBLCLICK: (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).DBLCLICK,
    /**
   * Triggered when a pointer is dragged.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
   * @api
   */ POINTERDRAG: 'pointerdrag',
    /**
   * Triggered when a pointer is moved. Note that on touch devices this is
   * triggered when the map is panned, so is not the same as mousemove.
   * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
   * @api
   */ POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};






/**
 * @module ol/pointer/EventType
 */ /**
 * Constants for event names.
 * @enum {string}
 */ var $8b8450889b821db1$export$2e2bcd8739ae039 = {
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel'
};


class $ad641aa29114f9e4$var$MapBrowserEventHandler extends (0, $dd029d816e3b4259$export$2e2bcd8739ae039) {
    /**
   * @param {import("./Map.js").default} map The map with the viewport to listen to events on.
   * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
   */ constructor(map, moveTolerance){
        super(map);
        /**
     * This is the element that we will listen to the real events on.
     * @type {import("./Map.js").default}
     * @private
     */ this.map_ = map;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.clickTimeoutId_;
        /**
     * Emulate dblclick and singleclick. Will be true when only one pointer is active.
     * @type {boolean}
     */ this.emulateClicks_ = false;
        /**
     * @type {boolean}
     * @private
     */ this.dragging_ = false;
        /**
     * @type {!Array<import("./events.js").EventsKey>}
     * @private
     */ this.dragListenerKeys_ = [];
        /**
     * @type {number}
     * @private
     */ this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
     * The most recent "down" type event (or null if none have occurred).
     * Set on pointerdown.
     * @type {PointerEvent|null}
     * @private
     */ this.down_ = null;
        const element = this.map_.getViewport();
        /**
     * @type {Array<PointerEvent>}
     * @private
     */ this.activePointers_ = [];
        /**
     * @type {!Object<number, Event>}
     * @private
     */ this.trackedTouches_ = {};
        /**
     * @private
     */ this.element_ = element;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.pointerdownListenerKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(element, (0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERDOWN, this.handlePointerDown_, this);
        /**
     * @type {PointerEvent}
     * @private
     */ this.originalPointerMoveEvent_;
        /**
     * @type {?import("./events.js").EventsKey}
     * @private
     */ this.relayedListenerKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(element, (0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERMOVE, this.relayMoveEvent_, this);
        /**
     * @private
     */ this.boundHandleTouchMove_ = this.handleTouchMove_.bind(this);
        this.element_.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_, (0, $89969764a1196844$export$f751ce96c6c4e4fc) ? {
            passive: false
        } : false);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ emulateClick_(pointerEvent) {
        let newEvent = new (0, $f924e5a83a2737ce$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new (0, $f924e5a83a2737ce$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        } else // click
        this.clickTimeoutId_ = setTimeout(()=>{
            this.clickTimeoutId_ = undefined;
            const newEvent = new (0, $f924e5a83a2737ce$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).SINGLECLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }, 250);
    }
    /**
   * Keeps track on how many pointers are currently active.
   *
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ updateActivePointers_(pointerEvent) {
        const event = pointerEvent;
        const id = event.pointerId;
        if (event.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP || event.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERCANCEL) {
            delete this.trackedTouches_[id];
            for(const pointerId in this.trackedTouches_)if (this.trackedTouches_[pointerId].target !== event.target) {
                // Some platforms assign a new pointerId when the target changes.
                // If this happens, delete one tracked pointer. If there is more
                // than one tracked pointer for the old target, it will be cleared
                // by subsequent POINTERUP events from other pointers.
                delete this.trackedTouches_[pointerId];
                break;
            }
        } else if (event.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDOWN || event.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERMOVE) this.trackedTouches_[id] = event;
        this.activePointers_ = Object.values(this.trackedTouches_);
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerUp_(pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $f924e5a83a2737ce$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ && !newEvent.defaultPrevented && !this.dragging_ && this.isMouseActionButton_(pointerEvent)) this.emulateClick_(this.down_);
        if (this.activePointers_.length === 0) {
            this.dragListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} If the left mouse button was pressed.
   * @private
   */ isMouseActionButton_(pointerEvent) {
        return pointerEvent.button === 0;
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerDown_(pointerEvent) {
        this.emulateClicks_ = this.activePointers_.length === 0;
        this.updateActivePointers_(pointerEvent);
        const newEvent = new (0, $f924e5a83a2737ce$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDOWN, this.map_, pointerEvent, undefined, undefined, this.activePointers_);
        this.dispatchEvent(newEvent);
        this.down_ = new PointerEvent(pointerEvent.type, pointerEvent);
        Object.defineProperty(this.down_, 'target', {
            writable: false,
            value: pointerEvent.target
        });
        if (this.dragListenerKeys_.length === 0) {
            const doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push((0, $37a5c0af9052e360$export$63174c828edd6ff8)(doc, (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERMOVE, this.handlePointerMove_, this), (0, $37a5c0af9052e360$export$63174c828edd6ff8)(doc, (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this), /* Note that the listener for `pointercancel is set up on
         * `pointerEventHandler_` and not `documentPointerEventHandler_` like
         * the `pointerup` and `pointermove` listeners.
         *
         * The reason for this is the following: `TouchSource.vacuumTouches_()`
         * issues `pointercancel` events, when there was no `touchend` for a
         * `touchstart`. Now, let's say a first `touchstart` is registered on
         * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
         * But `documentPointerEventHandler_` doesn't know about the first
         * `touchstart`. If there is no `touchend` for the `touchstart`, we can
         * only receive a `touchcancel` from `pointerEventHandler_`, because it is
         * only registered there.
         */ (0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.element_, (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) this.dragListenerKeys_.push((0, $37a5c0af9052e360$export$63174c828edd6ff8)(this.element_.getRootNode(), (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP, this.handlePointerUp_, this));
        }
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ handlePointerMove_(pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.updateActivePointers_(pointerEvent);
            this.dragging_ = true;
            const newEvent = new (0, $f924e5a83a2737ce$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDRAG, this.map_, pointerEvent, this.dragging_, undefined, this.activePointers_);
            this.dispatchEvent(newEvent);
        }
    }
    /**
   * Wrap and relay a pointermove event.
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @private
   */ relayMoveEvent_(pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        const dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new (0, $f924e5a83a2737ce$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERMOVE, this.map_, pointerEvent, dragging));
    }
    /**
   * Flexible handling of a `touch-action: none` css equivalent: because calling
   * `preventDefault()` on a `pointermove` event does not stop native page scrolling
   * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
   * when an interaction (currently `DragPan` handles the event.
   * @param {TouchEvent} event Event.
   * @private
   */ handleTouchMove_(event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events,
        // when elm-pep is used as pointer events polyfill.
        const originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) && (typeof event.cancelable !== 'boolean' || event.cancelable === true)) event.preventDefault();
    }
    /**
   * @param {PointerEvent} pointerEvent Pointer
   * event.
   * @return {boolean} Is moving.
   * @private
   */ isMoving_(pointerEvent) {
        return this.dragging_ || Math.abs(pointerEvent.clientX - this.down_.clientX) > this.moveTolerance_ || Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        if (this.relayedListenerKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        super.disposeInternal();
    }
}
var $ad641aa29114f9e4$export$2e2bcd8739ae039 = $ad641aa29114f9e4$var$MapBrowserEventHandler;





/**
 * @module ol/MapProperty
 */ /**
 * @enum {string}
 */ var $25ec5d593032f523$export$2e2bcd8739ae039 = {
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view'
};




/**
 * @module ol/TileQueue
 */ 

/**
 * @module ol/structs/PriorityQueue
 */ 

const $10b2c64d0f765608$export$b4af72c40fd57063 = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */ class $10b2c64d0f765608$var$PriorityQueue {
    /**
   * @param {function(T): number} priorityFunction Priority function.
   * @param {function(T): string} keyFunction Key function.
   */ constructor(priorityFunction, keyFunction){
        /**
     * @type {function(T): number}
     * @private
     */ this.priorityFunction_ = priorityFunction;
        /**
     * @type {function(T): string}
     * @private
     */ this.keyFunction_ = keyFunction;
        /**
     * @type {Array<T>}
     * @private
     */ this.elements_ = [];
        /**
     * @type {Array<number>}
     * @private
     */ this.priorities_ = [];
        /**
     * @type {!Object<string, boolean>}
     * @private
     */ this.queuedElements_ = {};
    }
    /**
   * FIXME empty description for jsdoc
   */ clear() {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)(this.queuedElements_);
    }
    /**
   * Remove and return the highest-priority element. O(log N).
   * @return {T} Element.
   */ dequeue() {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        } else {
            elements[0] = /** @type {T} */ elements.pop();
            priorities[0] = /** @type {number} */ priorities.pop();
            this.siftUp_(0);
        }
        const elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    }
    /**
   * Enqueue an element. O(log N).
   * @param {T} element Element.
   * @return {boolean} The element was added to the queue.
   */ enqueue(element) {
        (0, $b6052fc13e9a3991$export$a7a9523472993e97)(!(this.keyFunction_(element) in this.queuedElements_), 'Tried to enqueue an `element` that was already added to the queue');
        const priority = this.priorityFunction_(element);
        if (priority != $10b2c64d0f765608$export$b4af72c40fd57063) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    }
    /**
   * @return {number} Count.
   */ getCount() {
        return this.elements_.length;
    }
    /**
   * Gets the index of the left child of the node at the given index.
   * @param {number} index The index of the node to get the left child for.
   * @return {number} The index of the left child.
   * @private
   */ getLeftChildIndex_(index) {
        return index * 2 + 1;
    }
    /**
   * Gets the index of the right child of the node at the given index.
   * @param {number} index The index of the node to get the right child for.
   * @return {number} The index of the right child.
   * @private
   */ getRightChildIndex_(index) {
        return index * 2 + 2;
    }
    /**
   * Gets the index of the parent of the node at the given index.
   * @param {number} index The index of the node to get the parent for.
   * @return {number} The index of the parent.
   * @private
   */ getParentIndex_(index) {
        return index - 1 >> 1;
    }
    /**
   * Make this a heap. O(N).
   * @private
   */ heapify_() {
        let i;
        for(i = (this.elements_.length >> 1) - 1; i >= 0; i--)this.siftUp_(i);
    }
    /**
   * @return {boolean} Is empty.
   */ isEmpty() {
        return this.elements_.length === 0;
    }
    /**
   * @param {string} key Key.
   * @return {boolean} Is key queued.
   */ isKeyQueued(key) {
        return key in this.queuedElements_;
    }
    /**
   * @param {T} element Element.
   * @return {boolean} Is queued.
   */ isQueued(element) {
        return this.isKeyQueued(this.keyFunction_(element));
    }
    /**
   * @param {number} index The index of the node to move down.
   * @private
   */ siftUp_(index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const count = elements.length;
        const element = elements[index];
        const priority = priorities[index];
        const startIndex = index;
        while(index < count >> 1){
            const lIndex = this.getLeftChildIndex_(index);
            const rIndex = this.getRightChildIndex_(index);
            const smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex] ? rIndex : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    }
    /**
   * @param {number} startIndex The index of the root.
   * @param {number} index The index of the node to move up.
   * @private
   */ siftDown_(startIndex, index) {
        const elements = this.elements_;
        const priorities = this.priorities_;
        const element = elements[index];
        const priority = priorities[index];
        while(index > startIndex){
            const parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            } else break;
        }
        elements[index] = element;
        priorities[index] = priority;
    }
    /**
   * FIXME empty description for jsdoc
   */ reprioritize() {
        const priorityFunction = this.priorityFunction_;
        const elements = this.elements_;
        const priorities = this.priorities_;
        let index = 0;
        const n = elements.length;
        let element, i, priority;
        for(i = 0; i < n; ++i){
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == $10b2c64d0f765608$export$b4af72c40fd57063) delete this.queuedElements_[this.keyFunction_(element)];
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    }
}
var $10b2c64d0f765608$export$2e2bcd8739ae039 = $10b2c64d0f765608$var$PriorityQueue;


/**
 * @typedef {function(import("./Tile.js").default, string, import('./tilecoord.js').TileCoord, number): number} PriorityFunction
 */ /**
 * @typedef {[import('./Tile.js').default, string, import('./tilecoord.js').TileCoord, number]} TileQueueElement
 */ /**
 * @extends PriorityQueue<TileQueueElement>}
 */ class $05ff08069bfd30f8$var$TileQueue extends (0, $10b2c64d0f765608$export$2e2bcd8739ae039) {
    /**
   * @param {PriorityFunction} tilePriorityFunction Tile priority function.
   * @param {function(): ?} tileChangeCallback Function called on each tile change event.
   */ constructor(tilePriorityFunction, tileChangeCallback){
        super((element)=>tilePriorityFunction.apply(null, element), (element)=>element[0].getKey());
        /** @private */ this.boundHandleTileChange_ = this.handleTileChange.bind(this);
        /**
     * @private
     * @type {function(): ?}
     */ this.tileChangeCallback_ = tileChangeCallback;
        /**
     * @private
     * @type {number}
     */ this.tilesLoading_ = 0;
        /**
     * @private
     * @type {!Object<string,boolean>}
     */ this.tilesLoadingKeys_ = {};
    }
    /**
   * @param {TileQueueElement} element Element.
   * @return {boolean} The element was added to the queue.
   * @override
   */ enqueue(element) {
        const added = super.enqueue(element);
        if (added) {
            const tile = element[0];
            tile.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
        }
        return added;
    }
    /**
   * @return {number} Number of tiles loading.
   */ getTilesLoading() {
        return this.tilesLoading_;
    }
    /**
   * @param {import("./events/Event.js").default} event Event.
   * @protected
   */ handleTileChange(event) {
        const tile = /** @type {import("./Tile.js").default} */ event.target;
        const state = tile.getState();
        if (state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).LOADED || state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR || state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).EMPTY) {
            if (state !== (0, $2cb810f54791c0da$export$2e2bcd8739ae039).ERROR) tile.removeEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.boundHandleTileChange_);
            const tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    }
    /**
   * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
   * @param {number} maxNewLoads Maximum number of new tiles to load.
   */ loadMoreTiles(maxTotalLoading, maxNewLoads) {
        let newLoads = 0;
        while(this.tilesLoading_ < maxTotalLoading && newLoads < maxNewLoads && this.getCount() > 0){
            const tile = this.dequeue()[0];
            const tileKey = tile.getKey();
            const state = tile.getState();
            if (state === (0, $2cb810f54791c0da$export$2e2bcd8739ae039).IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    }
}
var $05ff08069bfd30f8$export$2e2bcd8739ae039 = $05ff08069bfd30f8$var$TileQueue;
function $05ff08069bfd30f8$export$f08ad5eceeff5d45(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) return 0, $10b2c64d0f765608$export$b4af72c40fd57063;
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) return 0, $10b2c64d0f765608$export$b4af72c40fd57063;
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    const center = frameState.viewState.center;
    const deltaX = tileCenter[0] - center[0];
    const deltaY = tileCenter[1] - center[1];
    return 65536 * Math.log(tileResolution) + Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution;
}







/**
 * @module ol/control/defaults
 */ 
/**
 * @module ol/control/Attribution
 */ 




/**
 * @module ol/control/Control
 */ 



/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * const myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */ class $ef003b45d4724b43$var$Control extends (0, $d575b598d09f57d3$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Control options.
   */ constructor(options){
        super();
        const element = options.element;
        if (element && !options.target && !element.style.pointerEvents) element.style.pointerEvents = 'auto';
        /**
     * @protected
     * @type {HTMLElement}
     */ this.element = element ? element : null;
        /**
     * @private
     * @type {HTMLElement}
     */ this.target_ = null;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @protected
     * @type {!Array<import("../events.js").EventsKey>}
     */ this.listenerKeys = [];
        if (options.render) this.render = options.render;
        if (options.target) this.setTarget(options.target);
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.element?.remove();
        super.disposeInternal();
    }
    /**
   * Get the map associated with this control.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Remove the control from its current map and attach it to the new map.
   * Pass `null` to just remove the control from the current map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   * @api
   */ setMap(map) {
        if (this.map_) this.element?.remove();
        for(let i = 0, ii = this.listenerKeys.length; i < ii; ++i)(0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.listenerKeys[i]);
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (map) {
            const target = this.target_ ?? map.getOverlayContainerStopEvent();
            if (this.element) target.appendChild(this.element);
            if (this.render !== (0, $de1052d9f293b73a$export$1cd1943b3a73bbe8)) this.listenerKeys.push((0, $37a5c0af9052e360$export$63174c828edd6ff8)(map, (0, $392290a16437301e$export$2e2bcd8739ae039).POSTRENDER, this.render, this));
            map.render();
        }
    }
    /**
   * Renders the control.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @api
   */ render(mapEvent) {}
    /**
   * This function is used to set a target element for the control. It has no
   * effect if it is called after the control has been added to the map (i.e.
   * after `setMap` is called on the control). If no `target` is set in the
   * options passed to the control constructor and if `setTarget` is not called
   * then the control is added to the map's overlay container.
   * @param {HTMLElement|string} target Target.
   * @api
   */ setTarget(target) {
        this.target_ = typeof target === 'string' ? document.getElementById(target) : target;
    }
}
var $ef003b45d4724b43$export$2e2bcd8739ae039 = $ef003b45d4724b43$var$Control;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string|HTMLElement} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='›'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {string|Array<string>|undefined} [attributions] Optional attribution(s) that will always be
 * displayed regardless of the layers rendered
 */ /**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */ class $b571c0ea2d2b497f$var$Attribution extends (0, $ef003b45d4724b43$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Attribution options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        /**
     * @private
     * @type {HTMLElement}
     */ this.ulElement_ = document.createElement('ul');
        /**
     * @private
     * @type {boolean}
     */ this.collapsed_ = options.collapsed !== undefined ? options.collapsed : true;
        /**
     * @private
     * @type {boolean}
     */ this.userCollapsed_ = this.collapsed_;
        /**
     * @private
     * @type {boolean}
     */ this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
     * @private
     * @type {boolean}
     */ this.collapsible_ = options.collapsible !== undefined ? options.collapsible : true;
        if (!this.collapsible_) this.collapsed_ = false;
        /**
     * @private
     * @type {string | Array<string> | undefined}
     */ this.attributions_ = options.attributions;
        const className = options.className !== undefined ? options.className : 'ol-attribution';
        const tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
        const expandClassName = options.expandClassName !== undefined ? options.expandClassName : className + '-expand';
        const collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u203A';
        const collapseClassName = options.collapseClassName !== undefined ? options.collapseClassName : className + '-collapse';
        if (typeof collapseLabel === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.collapseLabel_ = document.createElement('span');
            this.collapseLabel_.textContent = collapseLabel;
            this.collapseLabel_.className = collapseClassName;
        } else this.collapseLabel_ = collapseLabel;
        const label = options.label !== undefined ? options.label : 'i';
        if (typeof label === 'string') {
            /**
       * @private
       * @type {HTMLElement}
       */ this.label_ = document.createElement('span');
            this.label_.textContent = label;
            this.label_.className = expandClassName;
        } else this.label_ = label;
        const activeLabel = this.collapsible_ && !this.collapsed_ ? this.collapseLabel_ : this.label_;
        /**
     * @private
     * @type {HTMLElement}
     */ this.toggleButton_ = document.createElement('button');
        this.toggleButton_.setAttribute('type', 'button');
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
        this.toggleButton_.title = tipLabel;
        this.toggleButton_.appendChild(activeLabel);
        this.toggleButton_.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29) + ' ' + (0, $bbcb4c1977b6e9f0$export$4d4f8be70b656192) + (this.collapsed_ && this.collapsible_ ? ' ' + (0, $bbcb4c1977b6e9f0$export$e16017ac68d14492) : '') + (this.collapsible_ ? '' : ' ol-uncollapsible');
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(this.toggleButton_);
        element.appendChild(this.ulElement_);
        /**
     * A list of currently rendered resolutions.
     * @type {Array<string>}
     * @private
     */ this.renderedAttributions_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * Collect a list of visible attributions and set the collapsible state.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @return {Array<string>} Attributions.
   * @private
   */ collectSourceAttributions_(frameState) {
        const layers = this.getMap().getAllLayers();
        const visibleAttributions = new Set(layers.flatMap((layer)=>layer.getAttributions(frameState)));
        if (this.attributions_ !== undefined) Array.isArray(this.attributions_) ? this.attributions_.forEach((item)=>visibleAttributions.add(item)) : visibleAttributions.add(this.attributions_);
        if (!this.overrideCollapsible_) {
            const collapsible = !layers.some((layer)=>layer.getSource()?.getAttributionsCollapsible() === false);
            this.setCollapsible(collapsible);
        }
        return Array.from(visibleAttributions);
    }
    /**
   * @private
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ async updateElement_(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        const attributions = await Promise.all(this.collectSourceAttributions_(frameState).map((attribution)=>(0, $de1052d9f293b73a$export$4dbaaf6c79705e6c)(()=>attribution)));
        const visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? '' : 'none';
            this.renderedVisible_ = visible;
        }
        if ((0, $830d23b8323fc080$export$e9bab7fafb253603)(attributions, this.renderedAttributions_)) return;
        (0, $755a3001f896bcf1$export$1e1c9bf5a4ffe0d1)(this.ulElement_);
        // append the attributions
        for(let i = 0, ii = attributions.length; i < ii; ++i){
            const element = document.createElement('li');
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    }
    /**
   * @private
   */ handleToggle_() {
        this.element.classList.toggle((0, $bbcb4c1977b6e9f0$export$e16017ac68d14492));
        if (this.collapsed_) (0, $755a3001f896bcf1$export$5542201de9311ab2)(this.collapseLabel_, this.label_);
        else (0, $755a3001f896bcf1$export$5542201de9311ab2)(this.label_, this.collapseLabel_);
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
    }
    /**
   * Return `true` if the attribution is collapsible, `false` otherwise.
   * @return {boolean} True if the widget is collapsible.
   * @api
   */ getCollapsible() {
        return this.collapsible_;
    }
    /**
   * Set whether the attribution should be collapsible.
   * @param {boolean} collapsible True if the widget is collapsible.
   * @api
   */ setCollapsible(collapsible) {
        if (this.collapsible_ === collapsible) return;
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (this.userCollapsed_) this.handleToggle_();
    }
    /**
   * Collapse or expand the attribution according to the passed parameter. Will
   * not do anything if the attribution isn't collapsible or if the current
   * collapsed state is already the one requested.
   * @param {boolean} collapsed True if the widget is collapsed.
   * @api
   */ setCollapsed(collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) return;
        this.handleToggle_();
    }
    /**
   * Return `true` when the attribution is currently collapsed or `false`
   * otherwise.
   * @return {boolean} True if the widget is collapsed.
   * @api
   */ getCollapsed() {
        return this.collapsed_;
    }
    /**
   * Update the attribution element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        this.updateElement_(mapEvent.frameState);
    }
}
var $b571c0ea2d2b497f$export$2e2bcd8739ae039 = $b571c0ea2d2b497f$var$Attribution;


/**
 * @module ol/control/Rotate
 */ 



/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */ class $2fed84634fb1aa03$var$Rotate extends (0, $ef003b45d4724b43$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Rotate options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            render: options.render,
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-rotate';
        const label = options.label !== undefined ? options.label : '\u21E7';
        const compassClassName = options.compassClassName !== undefined ? options.compassClassName : 'ol-compass';
        /**
     * @type {HTMLElement}
     * @private
     */ this.label_ = null;
        if (typeof label === 'string') {
            this.label_ = document.createElement('span');
            this.label_.className = compassClassName;
            this.label_.textContent = label;
        } else {
            this.label_ = label;
            this.label_.classList.add(compassClassName);
        }
        const tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
        const button = document.createElement('button');
        button.className = className + '-reset';
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(this.label_);
        button.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this), false);
        const cssClasses = className + ' ' + (0, $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29) + ' ' + (0, $bbcb4c1977b6e9f0$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(button);
        /**
     * @private
     */ this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @type {boolean}
     * @private
     */ this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
     * @private
     * @type {number|undefined}
     */ this.rotation_ = undefined;
        if (this.autoHide_) this.element.classList.add((0, $bbcb4c1977b6e9f0$export$981241db82723ce2));
    }
    /**
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) this.callResetNorth_();
        else this.resetNorth_();
    }
    /**
   * @private
   */ resetNorth_() {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) view.animate({
                rotation: 0,
                duration: this.duration_,
                easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
            });
            else view.setRotation(0);
        }
    }
    /**
   * Update the rotate control element.
   * @param {import("../MapEvent.js").default} mapEvent Map event.
   * @override
   */ render(mapEvent) {
        const frameState = mapEvent.frameState;
        if (!frameState) return;
        const rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            const transform = 'rotate(' + rotation + 'rad)';
            if (this.autoHide_) {
                const contains = this.element.classList.contains((0, $bbcb4c1977b6e9f0$export$981241db82723ce2));
                if (!contains && rotation === 0) this.element.classList.add((0, $bbcb4c1977b6e9f0$export$981241db82723ce2));
                else if (contains && rotation !== 0) this.element.classList.remove((0, $bbcb4c1977b6e9f0$export$981241db82723ce2));
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    }
}
var $2fed84634fb1aa03$export$2e2bcd8739ae039 = $2fed84634fb1aa03$var$Rotate;


/**
 * @module ol/control/Zoom
 */ 



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='–'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */ /**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */ class $176f524e524aadb7$var$Zoom extends (0, $ef003b45d4724b43$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Zoom options.
   */ constructor(options){
        options = options ? options : {};
        super({
            element: document.createElement('div'),
            target: options.target
        });
        const className = options.className !== undefined ? options.className : 'ol-zoom';
        const delta = options.delta !== undefined ? options.delta : 1;
        const zoomInClassName = options.zoomInClassName !== undefined ? options.zoomInClassName : className + '-in';
        const zoomOutClassName = options.zoomOutClassName !== undefined ? options.zoomOutClassName : className + '-out';
        const zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
        const zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2013';
        const zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
        const zoomOutTipLabel = options.zoomOutTipLabel !== undefined ? options.zoomOutTipLabel : 'Zoom out';
        const inElement = document.createElement('button');
        inElement.className = zoomInClassName;
        inElement.setAttribute('type', 'button');
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === 'string' ? document.createTextNode(zoomInLabel) : zoomInLabel);
        inElement.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, delta), false);
        const outElement = document.createElement('button');
        outElement.className = zoomOutClassName;
        outElement.setAttribute('type', 'button');
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === 'string' ? document.createTextNode(zoomOutLabel) : zoomOutLabel);
        outElement.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CLICK, this.handleClick_.bind(this, -delta), false);
        const cssClasses = className + ' ' + (0, $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29) + ' ' + (0, $bbcb4c1977b6e9f0$export$4d4f8be70b656192);
        const element = this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
     * @type {number}
     * @private
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * @param {number} delta Zoom delta.
   * @param {MouseEvent} event The event to handle
   * @private
   */ handleClick_(delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    }
    /**
   * @param {number} delta Zoom delta.
   * @private
   */ zoomByDelta_(delta) {
        const map = this.getMap();
        const view = map.getView();
        if (!view) // the map does not have a view, so we can't act
        // upon it
        return;
        const currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            const newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) view.cancelAnimations();
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
                });
            } else view.setZoom(newZoom);
        }
    }
}
var $176f524e524aadb7$export$2e2bcd8739ae039 = $176f524e524aadb7$var$Zoom;


function $9d34e3901b82049a$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Control.js").default>} */ const controls = new (0, $7be3d63260860659$export$2e2bcd8739ae039)();
    const zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) controls.push(new (0, $176f524e524aadb7$export$2e2bcd8739ae039)(options.zoomOptions));
    const rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) controls.push(new (0, $2fed84634fb1aa03$export$2e2bcd8739ae039)(options.rotateOptions));
    const attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) controls.push(new (0, $b571c0ea2d2b497f$export$2e2bcd8739ae039)(options.attributionOptions));
    return controls;
}







/**
 * @module ol/interaction/defaults
 */ 
/**
 * @module ol/Kinetic
 */ /**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */ class $477a0a09e8e7589b$var$Kinetic {
    /**
   * @param {number} decay Rate of decay (must be negative).
   * @param {number} minVelocity Minimum velocity (pixels/millisecond).
   * @param {number} delay Delay to consider to calculate the kinetic
   *     initial values (milliseconds).
   */ constructor(decay, minVelocity, delay){
        /**
     * @private
     * @type {number}
     */ this.decay_ = decay;
        /**
     * @private
     * @type {number}
     */ this.minVelocity_ = minVelocity;
        /**
     * @private
     * @type {number}
     */ this.delay_ = delay;
        /**
     * @private
     * @type {Array<number>}
     */ this.points_ = [];
        /**
     * @private
     * @type {number}
     */ this.angle_ = 0;
        /**
     * @private
     * @type {number}
     */ this.initialVelocity_ = 0;
    }
    /**
   * FIXME empty description for jsdoc
   */ begin() {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   */ update(x, y) {
        this.points_.push(x, y, Date.now());
    }
    /**
   * @return {boolean} Whether we should do kinetic animation.
   */ end() {
        if (this.points_.length < 6) // at least 2 points are required (i.e. there must be at least 6 elements
        // in the array)
        return false;
        const delay = Date.now() - this.delay_;
        const lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) // the last tracked point is too old, which means that the user stopped
        // panning before releasing the map
        return false;
        // get the first point which still falls into the delay time
        let firstIndex = lastIndex - 3;
        while(firstIndex > 0 && this.points_[firstIndex + 2] > delay)firstIndex -= 3;
        const duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) return false;
        const dx = this.points_[lastIndex] - this.points_[firstIndex];
        const dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    }
    /**
   * @return {number} Total distance travelled (pixels).
   */ getDistance() {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    }
    /**
   * @return {number} Angle of the kinetic panning animation (radians).
   */ getAngle() {
        return this.angle_;
    }
}
var $477a0a09e8e7589b$export$2e2bcd8739ae039 = $477a0a09e8e7589b$var$Kinetic;


/**
 * @module ol/interaction/DoubleClickZoom
 */ 
/**
 * @module ol/interaction/Interaction
 */ 

/**
 * @module ol/interaction/Property
 */ /**
 * @enum {string}
 */ var $066074cf84cc0514$export$2e2bcd8739ae039 = {
    ACTIVE: 'active'
};


/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */ /**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */ /**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */ class $36e1c4dbb62d535d$var$Interaction extends (0, $d575b598d09f57d3$export$2e2bcd8739ae039) {
    /**
   * @param {InteractionOptions} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {InteractionOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {InteractionOnSignature<void>}
     */ this.un;
        if (options && options.handleEvent) this.handleEvent = options.handleEvent;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        this.setActive(true);
    }
    /**
   * Return whether the interaction is currently active.
   * @return {boolean} `true` if the interaction is active, `false` otherwise.
   * @observable
   * @api
   */ getActive() {
        return /** @type {boolean} */ this.get((0, $066074cf84cc0514$export$2e2bcd8739ae039).ACTIVE);
    }
    /**
   * Get the map associated with this interaction.
   * @return {import("../Map.js").default|null} Map.
   * @api
   */ getMap() {
        return this.map_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event}.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */ handleEvent(mapBrowserEvent) {
        return true;
    }
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   */ setActive(active) {
        this.set((0, $066074cf84cc0514$export$2e2bcd8739ae039).ACTIVE, active);
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        this.map_ = map;
    }
}
function $36e1c4dbb62d535d$export$4c486572e961a974(view, delta, duration) {
    const currentCenter = view.getCenterInternal();
    if (currentCenter) {
        const center = [
            currentCenter[0] + delta[0],
            currentCenter[1] + delta[1]
        ];
        view.animateInternal({
            duration: duration !== undefined ? duration : 250,
            easing: (0, $0164a93fcf6e65ad$export$45db2fc2f15997e7),
            center: view.getConstrainedCenter(center)
        });
    }
}
function $36e1c4dbb62d535d$export$ace321ff2a8016ef(view, delta, anchor, duration) {
    const currentZoom = view.getZoom();
    if (currentZoom === undefined) return;
    const newZoom = view.getConstrainedZoom(currentZoom + delta);
    const newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) view.cancelAnimations();
    view.animate({
        resolution: newResolution,
        anchor: anchor,
        duration: duration !== undefined ? duration : 250,
        easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
    });
}
var $36e1c4dbb62d535d$export$2e2bcd8739ae039 = $36e1c4dbb62d535d$var$Interaction;


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */ /**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */ class $6922361fb812290c$var$DoubleClickZoom extends (0, $36e1c4dbb62d535d$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a
   * doubleclick) and eventually zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).DBLCLICK) {
            const browserEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
            const map = mapBrowserEvent.map;
            const anchor = mapBrowserEvent.coordinate;
            const delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            const view = map.getView();
            (0, $36e1c4dbb62d535d$export$ace321ff2a8016ef)(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}
var $6922361fb812290c$export$2e2bcd8739ae039 = $6922361fb812290c$var$DoubleClickZoom;


/**
 * @module ol/interaction/DragPan
 */ 

/**
 * @module ol/events/condition
 */ 



function $2083adc1400fd9db$export$84bf76cd7afc7469(var_args) {
    const conditions = arguments;
    /**
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} All conditions passed.
   */ return function(event) {
        let pass = true;
        for(let i = 0, ii = conditions.length; i < ii; ++i){
            pass = pass && conditions[i](event);
            if (!pass) break;
        }
        return pass;
    };
}
const $2083adc1400fd9db$export$573409992e89967e = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $2083adc1400fd9db$export$4e5f01653f9f1f82 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $2083adc1400fd9db$export$d7ddd398f22d79ef = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const activeElement = event.map.getOwnerDocument().activeElement;
    return rootNode instanceof ShadowRoot ? rootNode.host.contains(activeElement) : targetElement.contains(activeElement);
};
const $2083adc1400fd9db$export$ae2cdf064e3b0c55 = function(event) {
    const targetElement = event.map.getTargetElement();
    const rootNode = targetElement.getRootNode();
    const tabIndexCandidate = rootNode instanceof ShadowRoot ? rootNode.host : targetElement;
    return tabIndexCandidate.hasAttribute('tabindex') ? $2083adc1400fd9db$export$d7ddd398f22d79ef(event) : true;
};
const $2083adc1400fd9db$export$ba9e5d519bc326ca = (0, $de1052d9f293b73a$export$22e23a2304399231);
const $2083adc1400fd9db$export$64ef1bee2b9504c1 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).CLICK;
};
const $2083adc1400fd9db$export$1238ad6b5e7fff70 = function(mapBrowserEvent) {
    const originalEvent = /** @type {MouseEvent} */ mapBrowserEvent.originalEvent;
    return originalEvent.button == 0 && !((0, $89969764a1196844$export$39dfd62a25e0fe93) && (0, $89969764a1196844$export$76c0a3b101d93136) && originalEvent.ctrlKey);
};
const $2083adc1400fd9db$export$b3e22bcfd64c1022 = (0, $de1052d9f293b73a$export$8f11cee4bdc7e668);
const $2083adc1400fd9db$export$71eac0963f2c2f01 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == 'pointermove';
};
const $2083adc1400fd9db$export$194df8bad091b401 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).SINGLECLICK;
};
const $2083adc1400fd9db$export$c59d944dd10b3dc7 = function(mapBrowserEvent) {
    return mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).DBLCLICK;
};
const $2083adc1400fd9db$export$fdc892d0d8fe3bfb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $2083adc1400fd9db$export$f3100d8d6292d638 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && ((0, $89969764a1196844$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey) && !originalEvent.shiftKey;
};
const $2083adc1400fd9db$export$32603ad571dd22b5 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return (0, $89969764a1196844$export$76c0a3b101d93136) ? originalEvent.metaKey : originalEvent.ctrlKey;
};
const $2083adc1400fd9db$export$5d31fe68a477cfbb = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    return !originalEvent.altKey && !(originalEvent.metaKey || originalEvent.ctrlKey) && originalEvent.shiftKey;
};
const $2083adc1400fd9db$export$e5570ca80cd8fd54 = function(mapBrowserEvent) {
    const originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ mapBrowserEvent.originalEvent;
    const tagName = /** @type {Element} */ originalEvent.target.tagName;
    return tagName !== 'INPUT' && tagName !== 'SELECT' && tagName !== 'TEXTAREA' && // `isContentEditable` is only available on `HTMLElement`, but it may also be a
    // different type like `SVGElement`.
    // @ts-ignore
    !originalEvent.target.isContentEditable;
};
const $2083adc1400fd9db$export$abb7acbfa76bf3c4 = function(mapBrowserEvent) {
    const pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(pointerEvent !== undefined, 'mapBrowserEvent must originate from a pointer event');
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvent.pointerType == 'mouse';
};
const $2083adc1400fd9db$export$e74de664a571d084 = function(mapBrowserEvent) {
    const pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(pointerEvt !== undefined, 'mapBrowserEvent must originate from a pointer event');
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === 'touch';
};
const $2083adc1400fd9db$export$cd1707283a23f059 = function(mapBrowserEvent) {
    const pointerEvt = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(pointerEvt !== undefined, 'mapBrowserEvent must originate from a pointer event');
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === 'pen';
};
const $2083adc1400fd9db$export$189f0d593022b199 = function(mapBrowserEvent) {
    const pointerEvent = /** @type {import("../MapBrowserEvent").default} */ mapBrowserEvent.originalEvent;
    (0, $b6052fc13e9a3991$export$a7a9523472993e97)(pointerEvent !== undefined, 'mapBrowserEvent must originate from a pointer event');
    return pointerEvent.isPrimary && pointerEvent.button === 0;
};



/**
 * @module ol/interaction/Pointer
 */ 

/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */ /**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */ class $f4f64f356a570c0e$var$PointerInteraction extends (0, $36e1c4dbb62d535d$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        if (options.handleDownEvent) this.handleDownEvent = options.handleDownEvent;
        if (options.handleDragEvent) this.handleDragEvent = options.handleDragEvent;
        if (options.handleMoveEvent) this.handleMoveEvent = options.handleMoveEvent;
        if (options.handleUpEvent) this.handleUpEvent = options.handleUpEvent;
        if (options.stopDown) this.stopDown = options.stopDown;
        /**
     * @type {boolean}
     * @protected
     */ this.handlingDownUpSequence = false;
        /**
     * @type {Array<PointerEvent>}
     * @protected
     */ this.targetPointers = [];
    }
    /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */ getPointerCount() {
        return this.targetPointers.length;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleDownEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleDragEvent(mapBrowserEvent) {}
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) return true;
        let stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            } else if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERUP) {
                const handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
            }
        } else {
            if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDOWN) {
                const handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            } else if (mapBrowserEvent.type == (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERMOVE) this.handleMoveEvent(mapBrowserEvent);
        }
        return !stopEvent;
    }
    /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */ handleMoveEvent(mapBrowserEvent) {}
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */ handleUpEvent(mapBrowserEvent) {
        return false;
    }
    /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */ stopDown(handled) {
        return handled;
    }
    /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */ updateTrackedPointers_(mapBrowserEvent) {
        if (mapBrowserEvent.activePointers) this.targetPointers = mapBrowserEvent.activePointers;
    }
}
function $f4f64f356a570c0e$export$e2a20c553f6c85ce(pointerEvents) {
    const length = pointerEvents.length;
    let clientX = 0;
    let clientY = 0;
    for(let i = 0; i < length; i++){
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return {
        clientX: clientX / length,
        clientY: clientY / length
    };
}
var $f4f64f356a570c0e$export$2e2bcd8739ae039 = $f4f64f356a570c0e$var$PointerInteraction;


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */ /**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */ class $6baed6e1188f6d5d$var$DragPan extends (0, $f4f64f356a570c0e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super({
            stopDown: (0, $de1052d9f293b73a$export$8f11cee4bdc7e668)
        });
        options = options ? options : {};
        /**
     * @private
     * @type {import("../Kinetic.js").default|undefined}
     */ this.kinetic_ = options.kinetic;
        /**
     * @type {import("../pixel.js").Pixel}
     */ this.lastCentroid = null;
        /**
     * @type {number}
     * @private
     */ this.lastPointersCount_;
        /**
     * @type {boolean}
     * @private
     */ this.panning_ = false;
        const condition = options.condition ? options.condition : (0, $2083adc1400fd9db$export$84bf76cd7afc7469)((0, $2083adc1400fd9db$export$fdc892d0d8fe3bfb), (0, $2083adc1400fd9db$export$189f0d593022b199));
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $2083adc1400fd9db$export$84bf76cd7afc7469)((0, $2083adc1400fd9db$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {boolean}
     */ this.noKinetic_ = false;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        if (!this.panning_) {
            this.panning_ = true;
            map.getView().beginInteraction();
        }
        const targetPointers = this.targetPointers;
        const centroid = map.getEventPixel((0, $f4f64f356a570c0e$export$e2a20c553f6c85ce)(targetPointers));
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) this.kinetic_.update(centroid[0], centroid[1]);
            if (this.lastCentroid) {
                const delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1]
                ];
                const map = mapBrowserEvent.map;
                const view = map.getView();
                (0, $8b28786758450fff$export$dcdf75081b88279d)(delta, view.getResolution());
                (0, $8b28786758450fff$export$bb628a54ab399bc9)(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        } else if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger down, tiny drag, second finger down
        this.kinetic_.begin();
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                const distance = this.kinetic_.getDistance();
                const angle = this.kinetic_.getAngle();
                const center = view.getCenterInternal();
                const centerpx = map.getPixelFromCoordinateInternal(center);
                const dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle)
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        if (this.kinetic_) // reset so we don't overestimate the kinetic energy after
        // after one finger up, tiny drag, second finger up
        this.kinetic_.begin();
        this.lastCentroid = null;
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) view.cancelAnimations();
            if (this.kinetic_) this.kinetic_.begin();
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        return false;
    }
}
var $6baed6e1188f6d5d$export$2e2bcd8739ae039 = $6baed6e1188f6d5d$var$DragPan;


/**
 * @module ol/interaction/DragRotate
 */ 



/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */ class $e973edd1a46ee1a2$var$DragRotate extends (0, $f4f64f356a570c0e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super({
            stopDown: (0, $de1052d9f293b73a$export$8f11cee4bdc7e668)
        });
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $2083adc1400fd9db$export$4e5f01653f9f1f82);
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!(0, $2083adc1400fd9db$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $ea3e0fdf428207b8$export$e20fbacbb41798b)) return;
        const size = map.getSize();
        const offset = mapBrowserEvent.pixel;
        const theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            const delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!(0, $2083adc1400fd9db$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return true;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (!(0, $2083adc1400fd9db$export$abb7acbfa76bf3c4)(mapBrowserEvent)) return false;
        if ((0, $2083adc1400fd9db$export$1238ad6b5e7fff70)(mapBrowserEvent) && this.condition_(mapBrowserEvent)) {
            const map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        return false;
    }
}
var $e973edd1a46ee1a2$export$2e2bcd8739ae039 = $e973edd1a46ee1a2$var$DragRotate;


/**
 * @module ol/interaction/DragZoom
 */ 

/**
 * @module ol/interaction/DragBox
 */ // FIXME draw drag box


/**
 * @module ol/render/Box
 */ 

class $1af1c079fa1cf31c$var$RenderBox extends (0, $17f88068b11f58ac$export$2e2bcd8739ae039) {
    /**
   * @param {string} className CSS class name.
   */ constructor(className){
        super();
        /**
     * @type {import("../geom/Polygon.js").default}
     * @private
     */ this.geometry_ = null;
        /**
     * @type {HTMLDivElement}
     * @private
     */ this.element_ = document.createElement('div');
        this.element_.style.position = 'absolute';
        this.element_.style.pointerEvents = 'auto';
        this.element_.className = 'ol-box ' + className;
        /**
     * @private
     * @type {import("../Map.js").default|null}
     */ this.map_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../pixel.js").Pixel}
     */ this.endPixel_ = null;
    }
    /**
   * Clean up.
   * @override
   */ disposeInternal() {
        this.setMap(null);
    }
    /**
   * @private
   */ render_() {
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const px = 'px';
        const style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   */ setMap(map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            const style = this.element_.style;
            style.left = 'inherit';
            style.top = 'inherit';
            style.width = 'inherit';
            style.height = 'inherit';
        }
        this.map_ = map;
        if (this.map_) this.map_.getOverlayContainer().appendChild(this.element_);
    }
    /**
   * @param {import("../pixel.js").Pixel} startPixel Start pixel.
   * @param {import("../pixel.js").Pixel} endPixel End pixel.
   */ setPixels(startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    }
    /**
   * Creates or updates the cached geometry.
   */ createOrUpdateGeometry() {
        if (!this.map_) return;
        const startPixel = this.startPixel_;
        const endPixel = this.endPixel_;
        const pixels = [
            startPixel,
            [
                startPixel[0],
                endPixel[1]
            ],
            endPixel,
            [
                endPixel[0],
                startPixel[1]
            ]
        ];
        const coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) this.geometry_ = new (0, $46a66e0f2fc72479$export$2e2bcd8739ae039)([
            coordinates
        ]);
        else this.geometry_.setCoordinates([
            coordinates
        ]);
    }
    /**
   * @return {import("../geom/Polygon.js").default} Geometry.
   */ getGeometry() {
        return this.geometry_;
    }
}
var $1af1c079fa1cf31c$export$2e2bcd8739ae039 = $1af1c079fa1cf31c$var$RenderBox;



/**
 * A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */ /**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */ /**
 * @enum {string}
 */ const $3abf4a6a6173e05c$var$DragBoxEventType = {
    /**
   * Triggered upon drag box start.
   * @event DragBoxEvent#boxstart
   * @api
   */ BOXSTART: 'boxstart',
    /**
   * Triggered on drag when box is active.
   * @event DragBoxEvent#boxdrag
   * @api
   */ BOXDRAG: 'boxdrag',
    /**
   * Triggered upon drag box end.
   * @event DragBoxEvent#boxend
   * @api
   */ BOXEND: 'boxend',
    /**
   * Triggered upon drag box canceled.
   * @event DragBoxEvent#boxcancel
   * @api
   */ BOXCANCEL: 'boxcancel'
};
class $3abf4a6a6173e05c$export$7053c33c051365ea extends (0, $0327f54963b35733$export$2e2bcd8739ae039) {
    /**
   * @param {string} type The event type.
   * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
   */ constructor(type, coordinate, mapBrowserEvent){
        super(type);
        /**
     * The coordinate of the drag event.
     * @const
     * @type {import("../coordinate.js").Coordinate}
     * @api
     */ this.coordinate = coordinate;
        /**
     * @const
     * @type {import("../MapBrowserEvent.js").default}
     * @api
     */ this.mapBrowserEvent = mapBrowserEvent;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend'|'boxstart', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */ /**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom~DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */ class $3abf4a6a6173e05c$var$DragBox extends (0, $f4f64f356a570c0e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DragBoxOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DragBoxOnSignature<void>}
     */ this.un;
        options = options ?? {};
        /**
     * @type {import("../render/Box.js").default}
     * @private
     */ this.box_ = new (0, $1af1c079fa1cf31c$export$2e2bcd8739ae039)(options.className || 'ol-dragbox');
        /**
     * @type {number}
     * @private
     */ this.minArea_ = options.minArea ?? 64;
        if (options.onBoxEnd) this.onBoxEnd = options.onBoxEnd;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.startPixel_ = null;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ?? (0, $2083adc1400fd9db$export$1238ad6b5e7fff70);
        /**
     * @private
     * @type {EndCondition}
     */ this.boxEndCondition_ = options.boxEndCondition ?? this.defaultBoxEndCondition;
    }
    /**
   * The default condition for determining whether the boxend event
   * should fire.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
   *     leading to the box end.
   * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
   * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
   * @return {boolean} Whether or not the boxend condition should be fired.
   */ defaultBoxEndCondition(mapBrowserEvent, startPixel, endPixel) {
        const width = endPixel[0] - startPixel[0];
        const height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    }
    /**
   * Returns geometry of last drawn box.
   * @return {import("../geom/Polygon.js").default} Geometry.
   * @api
   */ getGeometry() {
        return this.box_.getGeometry();
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        if (!this.startPixel_) return;
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new $3abf4a6a6173e05c$export$7053c33c051365ea($3abf4a6a6173e05c$var$DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (!this.startPixel_) return false;
        const completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) this.onBoxEnd(mapBrowserEvent);
        this.dispatchEvent(new $3abf4a6a6173e05c$export$7053c33c051365ea(completeBox ? $3abf4a6a6173e05c$var$DragBoxEventType.BOXEND : $3abf4a6a6173e05c$var$DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        this.box_.setMap(null);
        this.startPixel_ = null;
        return false;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new $3abf4a6a6173e05c$export$7053c33c051365ea($3abf4a6a6173e05c$var$DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        return false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   */ onBoxEnd(event) {}
    /**
   * Activate or deactivate the interaction.
   * @param {boolean} active Active.
   * @observable
   * @api
   * @override
   */ setActive(active) {
        if (!active) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $3abf4a6a6173e05c$export$7053c33c051365ea($3abf4a6a6173e05c$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setActive(active);
    }
    /**
   * @param {import("../Map.js").default|null} map Map.
   * @override
   */ setMap(map) {
        const oldMap = this.getMap();
        if (oldMap) {
            this.box_.setMap(null);
            if (this.startPixel_) {
                this.dispatchEvent(new $3abf4a6a6173e05c$export$7053c33c051365ea($3abf4a6a6173e05c$var$DragBoxEventType.BOXCANCEL, this.startPixel_, null));
                this.startPixel_ = null;
            }
        }
        super.setMap(map);
    }
}
var $3abf4a6a6173e05c$export$2e2bcd8739ae039 = $3abf4a6a6173e05c$var$DragBox;


/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with a {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */ class $c2873d0d637ab598$var$DragZoom extends (0, $3abf4a6a6173e05c$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const condition = options.condition ? options.condition : (0, $2083adc1400fd9db$export$5d31fe68a477cfbb);
        super({
            condition: condition,
            className: options.className || 'ol-dragzoom',
            minArea: options.minArea
        });
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
     * @private
     * @type {boolean}
     */ this.out_ = options.out !== undefined ? options.out : false;
    }
    /**
   * Function to execute just before `onboxend` is fired
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @override
   */ onBoxEnd(event) {
        const map = this.getMap();
        const view = /** @type {!import("../View.js").default} */ map.getView();
        let geometry = this.getGeometry();
        if (this.out_) {
            const rotatedExtent = view.rotatedExtentForGeometry(geometry);
            const resolution = view.getResolutionForExtentInternal(rotatedExtent);
            const factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: (0, $0164a93fcf6e65ad$export$57636bb43b1ccbb0)
        });
    }
}
var $c2873d0d637ab598$export$2e2bcd8739ae039 = $c2873d0d637ab598$var$DragZoom;


/**
 * @module ol/interaction/KeyboardPan
 */ 

/**
 * @module ol/events/Key
 */ /**
 * @enum {string}
 * @const
 */ var $0958492b45adaa72$export$2e2bcd8739ae039 = {
    LEFT: 'ArrowLeft',
    UP: 'ArrowUp',
    RIGHT: 'ArrowRight',
    DOWN: 'ArrowDown'
};




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */ /**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */ class $49f656d79a965468$var$KeyboardPan extends (0, $36e1c4dbb62d535d$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options || {};
        /**
     * @private
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
     * @return {boolean} Combined condition result.
     */ this.defaultCondition_ = function(mapBrowserEvent) {
            return (0, $2083adc1400fd9db$export$fdc892d0d8fe3bfb)(mapBrowserEvent) && (0, $2083adc1400fd9db$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition !== undefined ? options.condition : this.defaultCondition_;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
     * @private
     * @type {number}
     */ this.pixelDelta_ = options.pixelDelta !== undefined ? options.pixelDelta : 128;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides the direction to pan to (if an arrow key was
   * pressed).
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYDOWN) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key == (0, $0958492b45adaa72$export$2e2bcd8739ae039).DOWN || key == (0, $0958492b45adaa72$export$2e2bcd8739ae039).LEFT || key == (0, $0958492b45adaa72$export$2e2bcd8739ae039).RIGHT || key == (0, $0958492b45adaa72$export$2e2bcd8739ae039).UP)) {
                const map = mapBrowserEvent.map;
                const view = map.getView();
                const mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                let deltaX = 0, deltaY = 0;
                if (key == (0, $0958492b45adaa72$export$2e2bcd8739ae039).DOWN) deltaY = -mapUnitsDelta;
                else if (key == (0, $0958492b45adaa72$export$2e2bcd8739ae039).LEFT) deltaX = -mapUnitsDelta;
                else if (key == (0, $0958492b45adaa72$export$2e2bcd8739ae039).RIGHT) deltaX = mapUnitsDelta;
                else deltaY = mapUnitsDelta;
                const delta = [
                    deltaX,
                    deltaY
                ];
                (0, $8b28786758450fff$export$bb628a54ab399bc9)(delta, view.getRotation());
                (0, $36e1c4dbb62d535d$export$4c486572e961a974)(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $49f656d79a965468$export$2e2bcd8739ae039 = $49f656d79a965468$var$KeyboardPan;


/**
 * @module ol/interaction/KeyboardZoom
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. The default condition is
 * that {@link module:ol/events/condition.targetNotEditable} is fulfilled and that
 * the platform modifier key isn't pressed
 * (!{@link module:ol/events/condition.platformModifierKey}).
 * @property {number} [delta=1] The zoom level delta on each key press.
 */ /**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */ class $ee0a6f663ca23f5a$var$KeyboardZoom extends (0, $36e1c4dbb62d535d$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        super();
        options = options ? options : {};
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : function(mapBrowserEvent) {
            return !(0, $2083adc1400fd9db$export$32603ad571dd22b5)(mapBrowserEvent) && (0, $2083adc1400fd9db$export$e5570ca80cd8fd54)(mapBrowserEvent);
        };
        /**
     * @private
     * @type {number}
     */ this.delta_ = options.delta ? options.delta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 100;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} if it was a
   * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
   * key pressed was '+' or '-').
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYDOWN || mapBrowserEvent.type == (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYPRESS) {
            const keyEvent = /** @type {KeyboardEvent} */ mapBrowserEvent.originalEvent;
            const key = keyEvent.key;
            if (this.condition_(mapBrowserEvent) && (key === '+' || key === '-')) {
                const map = mapBrowserEvent.map;
                const delta = key === '+' ? this.delta_ : -this.delta_;
                const view = map.getView();
                (0, $36e1c4dbb62d535d$export$ace321ff2a8016ef)(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    }
}
var $ee0a6f663ca23f5a$export$2e2bcd8739ae039 = $ee0a6f663ca23f5a$var$KeyboardZoom;


/**
 * @module ol/interaction/MouseWheelZoom
 */ 




/**
 * @typedef {'trackpad' | 'wheel'} Mode
 */ /**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */ class $d63f90228254196b$var$MouseWheelZoom extends (0, $36e1c4dbb62d535d$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        super(/** @type {import("./Interaction.js").InteractionOptions} */ options);
        /**
     * @private
     * @type {number}
     */ this.totalDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.lastDelta_ = 0;
        /**
     * @private
     * @type {number}
     */ this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
     * @private
     * @type {number}
     */ this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
     * @private
     * @type {boolean}
     */ this.useAnchor_ = options.useAnchor !== undefined ? options.useAnchor : true;
        /**
     * @private
     * @type {boolean}
     */ this.constrainResolution_ = options.constrainResolution !== undefined ? options.constrainResolution : false;
        const condition = options.condition ? options.condition : (0, $2083adc1400fd9db$export$ba9e5d519bc326ca);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.onFocusOnly ? (0, $2083adc1400fd9db$export$84bf76cd7afc7469)((0, $2083adc1400fd9db$export$ae2cdf064e3b0c55), condition) : condition;
        /**
     * @private
     * @type {?import("../pixel.js").Pixel}
     */ this.lastAnchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.startTime_ = undefined;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.timeoutId_;
        /**
     * @private
     * @type {Mode|undefined}
     */ this.mode_ = undefined;
        /**
     * Trackpad events separated by this delay will be considered separate
     * interactions.
     * @private
     * @type {number}
     */ this.trackpadEventGap_ = 400;
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.trackpadTimeoutId_;
        /**
     * The number of delta values per zoom level
     * @private
     * @type {number}
     */ this.deltaPerZoom_ = 300;
    }
    /**
   * @private
   */ endInteraction_() {
        this.trackpadTimeoutId_ = undefined;
        const map = this.getMap();
        if (!map) return;
        const view = map.getView();
        view.endInteraction(undefined, this.lastDelta_ ? this.lastDelta_ > 0 ? 1 : -1 : 0, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
   * zooms the map.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @override
   */ handleEvent(mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) return true;
        const type = mapBrowserEvent.type;
        if (type !== (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).WHEEL) return true;
        const map = mapBrowserEvent.map;
        const wheelEvent = /** @type {WheelEvent} */ mapBrowserEvent.originalEvent;
        wheelEvent.preventDefault();
        if (this.useAnchor_) this.lastAnchor_ = mapBrowserEvent.pixel;
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        let delta;
        if (mapBrowserEvent.type == (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).WHEEL) {
            delta = wheelEvent.deltaY;
            if ((0, $89969764a1196844$export$8442bdfd18b7b8a6) && wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) delta /= (0, $89969764a1196844$export$6b83a0446fc26f94);
            if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) delta *= 40;
        }
        if (delta === 0) return false;
        this.lastDelta_ = delta;
        const now = Date.now();
        if (this.startTime_ === undefined) this.startTime_ = now;
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) this.mode_ = Math.abs(delta) < 4 ? 'trackpad' : 'wheel';
        const view = map.getView();
        if (this.mode_ === 'trackpad' && !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) clearTimeout(this.trackpadTimeoutId_);
            else {
                if (view.getAnimating()) view.cancelAnimations();
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        const timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    }
    /**
   * @private
   * @param {import("../Map.js").default} map Map.
   */ handleWheelZoom_(map) {
        const view = map.getView();
        if (view.getAnimating()) view.cancelAnimations();
        let delta = -(0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) // view has a zoom constraint, zoom by 1
        delta = delta ? delta > 0 ? 1 : -1 : 0;
        (0, $36e1c4dbb62d535d$export$ace321ff2a8016ef)(view, delta, this.lastAnchor_ ? map.getCoordinateFromPixel(this.lastAnchor_) : null, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    }
    /**
   * Enable or disable using the mouse's location as an anchor when zooming
   * @param {boolean} useAnchor true to zoom to the mouse's location, false
   * to zoom to the center of the map
   * @api
   */ setMouseAnchor(useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) this.lastAnchor_ = null;
    }
}
var $d63f90228254196b$export$2e2bcd8739ae039 = $d63f90228254196b$var$MouseWheelZoom;


/**
 * @module ol/interaction/PinchRotate
 */ 


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */ /**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */ class $8fea13ae61596510$var$PinchRotate extends (0, $f4f64f356a570c0e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $de1052d9f293b73a$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastAngle_ = undefined;
        /**
     * @private
     * @type {boolean}
     */ this.rotating_ = false;
        /**
     * @private
     * @type {number}
     */ this.rotationDelta_ = 0.0;
        /**
     * @private
     * @type {number}
     */ this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 250;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let rotationDelta = 0.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        // angle between touches
        const angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            const delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) this.rotating_ = true;
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (view.getConstraints().rotation === (0, $ea3e0fdf428207b8$export$e20fbacbb41798b)) return;
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $f4f64f356a570c0e$export$e2a20c553f6c85ce)(this.targetPointers)));
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $8fea13ae61596510$export$2e2bcd8739ae039 = $8fea13ae61596510$var$PinchRotate;


/**
 * @module ol/interaction/PinchZoom
 */ 

/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */ /**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */ class $2b37714dcc016e14$var$PinchZoom extends (0, $f4f64f356a570c0e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Options.
   */ constructor(options){
        options = options ? options : {};
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $de1052d9f293b73a$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /**
     * @private
     * @type {import("../coordinate.js").Coordinate}
     */ this.anchor_ = null;
        /**
     * @private
     * @type {number}
     */ this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
     * @private
     * @type {number|undefined}
     */ this.lastDistance_ = undefined;
        /**
     * @private
     * @type {number}
     */ this.lastScaleDelta_ = 1;
    }
    /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @override
   */ handleDragEvent(mapBrowserEvent) {
        let scaleDelta = 1.0;
        const touch0 = this.targetPointers[0];
        const touch1 = this.targetPointers[1];
        const dx = touch0.clientX - touch1.clientX;
        const dy = touch0.clientY - touch1.clientY;
        // distance between touches
        const distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) scaleDelta = this.lastDistance_ / distance;
        this.lastDistance_ = distance;
        const map = mapBrowserEvent.map;
        const view = map.getView();
        if (scaleDelta != 1.0) this.lastScaleDelta_ = scaleDelta;
        // scale anchor point.
        this.anchor_ = map.getCoordinateFromPixelInternal(map.getEventPixel((0, $f4f64f356a570c0e$export$e2a20c553f6c85ce)(this.targetPointers)));
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            const map = mapBrowserEvent.map;
            const view = map.getView();
            const direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        return true;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            const map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) map.getView().beginInteraction();
            return true;
        }
        return false;
    }
}
var $2b37714dcc016e14$export$2e2bcd8739ae039 = $2b37714dcc016e14$var$PinchZoom;


function $eedb297ae769b700$export$ebe90cb607ad99e(options) {
    options = options ? options : {};
    /** @type {Collection<import("./Interaction.js").default>} */ const interactions = new (0, $7be3d63260860659$export$2e2bcd8739ae039)();
    const kinetic = new (0, $477a0a09e8e7589b$export$2e2bcd8739ae039)(-0.005, 0.05, 100);
    const altShiftDragRotate = options.altShiftDragRotate !== undefined ? options.altShiftDragRotate : true;
    if (altShiftDragRotate) interactions.push(new (0, $e973edd1a46ee1a2$export$2e2bcd8739ae039)());
    const doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) interactions.push(new (0, $6922361fb812290c$export$2e2bcd8739ae039)({
        delta: options.zoomDelta,
        duration: options.zoomDuration
    }));
    const dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) interactions.push(new (0, $6baed6e1188f6d5d$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        kinetic: kinetic
    }));
    const pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) interactions.push(new (0, $8fea13ae61596510$export$2e2bcd8739ae039)());
    const pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) interactions.push(new (0, $2b37714dcc016e14$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    const keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new (0, $49f656d79a965468$export$2e2bcd8739ae039)());
        interactions.push(new (0, $ee0a6f663ca23f5a$export$2e2bcd8739ae039)({
            delta: options.zoomDelta,
            duration: options.zoomDuration
        }));
    }
    const mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) interactions.push(new (0, $d63f90228254196b$export$2e2bcd8739ae039)({
        onFocusOnly: options.onFocusOnly,
        duration: options.zoomDuration
    }));
    const shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) interactions.push(new (0, $c2873d0d637ab598$export$2e2bcd8739ae039)({
        duration: options.zoomDuration
    }));
    return interactions;
}


/**
 * @module ol/layer/Group
 */ 










class $96e8168163e6fc58$export$2f5ff21d758d25a7 extends (0, $0327f54963b35733$export$2e2bcd8739ae039) {
    /**
   * @param {GroupEventType} type The event type.
   * @param {BaseLayer} layer The layer.
   */ constructor(type, layer){
        super(type);
        /**
     * The added or removed layer.
     * @type {BaseLayer}
     * @api
     */ this.layer = layer;
    }
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:layers', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:layers', Return>} GroupOnSignature
 */ /**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|Collection<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */ /**
 * @enum {string}
 * @private
 */ const $96e8168163e6fc58$var$Property = {
    LAYERS: 'layers'
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */ class $96e8168163e6fc58$var$LayerGroup extends (0, $462b2201ee49de24$export$2e2bcd8739ae039) {
    /**
   * @param {Options} [options] Layer options.
   */ constructor(options){
        options = options || {};
        const baseOptions = /** @type {Options} */ Object.assign({}, options);
        delete baseOptions.layers;
        let layers = options.layers;
        super(baseOptions);
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {GroupOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {GroupOnSignature<void>}
     */ this.un;
        /**
     * @private
     * @type {Array<import("../events.js").EventsKey>}
     */ this.layersListenerKeys_ = [];
        /**
     * @private
     * @type {Object<string, Array<import("../events.js").EventsKey>>}
     */ this.listenerKeys_ = {};
        this.addChangeListener($96e8168163e6fc58$var$Property.LAYERS, this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) layers = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(layers.slice(), {
                unique: true
            });
            else (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ layers.getArray === 'function', 'Expected `layers` to be an array or a `Collection`');
        } else layers = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(undefined, {
            unique: true
        });
        this.setLayers(layers);
    }
    /**
   * @private
   */ handleLayerChange_() {
        this.changed();
    }
    /**
   * @private
   */ handleLayersChanged_() {
        this.layersListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        this.layersListenerKeys_.length = 0;
        const layers = this.getLayers();
        this.layersListenerKeys_.push((0, $37a5c0af9052e360$export$63174c828edd6ff8)(layers, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, this.handleLayersAdd_, this), (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layers, (0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, this.handleLayersRemove_, this));
        for(const id in this.listenerKeys_)this.listenerKeys_[id].forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        (0, $8c1e0b75b65663dc$export$42ffd38884aecdac)(this.listenerKeys_);
        const layersArray = layers.getArray();
        for(let i = 0, ii = layersArray.length; i < ii; i++){
            const layer = layersArray[i];
            this.registerLayerListeners_(layer);
            this.dispatchEvent(new $96e8168163e6fc58$export$2f5ff21d758d25a7('addlayer', layer));
        }
        this.changed();
    }
    /**
   * @param {BaseLayer} layer The layer.
   */ registerLayerListeners_(layer) {
        const listenerKeys = [
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layer, (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleLayerChange_, this),
            (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layer, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleLayerChange_, this)
        ];
        if (layer instanceof $96e8168163e6fc58$var$LayerGroup) listenerKeys.push((0, $37a5c0af9052e360$export$63174c828edd6ff8)(layer, 'addlayer', this.handleLayerGroupAdd_, this), (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layer, 'removelayer', this.handleLayerGroupRemove_, this));
        this.listenerKeys_[(0, $34772e91e89a736f$export$5e82334337e0f204)(layer)] = listenerKeys;
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupAdd_(event) {
        this.dispatchEvent(new $96e8168163e6fc58$export$2f5ff21d758d25a7('addlayer', event.layer));
    }
    /**
   * @param {GroupEvent} event The layer group event.
   */ handleLayerGroupRemove_(event) {
        this.dispatchEvent(new $96e8168163e6fc58$export$2f5ff21d758d25a7('removelayer', event.layer));
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersAdd_(collectionEvent) {
        const layer = collectionEvent.element;
        this.registerLayerListeners_(layer);
        this.dispatchEvent(new $96e8168163e6fc58$export$2f5ff21d758d25a7('addlayer', layer));
        this.changed();
    }
    /**
   * @param {import("../Collection.js").CollectionEvent<import("./Base.js").default>} collectionEvent CollectionEvent.
   * @private
   */ handleLayersRemove_(collectionEvent) {
        const layer = collectionEvent.element;
        const key = (0, $34772e91e89a736f$export$5e82334337e0f204)(layer);
        this.listenerKeys_[key].forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
        delete this.listenerKeys_[key];
        this.dispatchEvent(new $96e8168163e6fc58$export$2f5ff21d758d25a7('removelayer', layer));
        this.changed();
    }
    /**
   * Returns the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @return {!Collection<import("./Base.js").default>} Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ getLayers() {
        return /** @type {!Collection<import("./Base.js").default>} */ this.get($96e8168163e6fc58$var$Property.LAYERS);
    }
    /**
   * Set the {@link module:ol/Collection~Collection collection} of {@link module:ol/layer/Layer~Layer layers}
   * in this group.
   * @param {!Collection<import("./Base.js").default>} layers Collection of
   *   {@link module:ol/layer/Base~BaseLayer layers} that are part of this group.
   * @observable
   * @api
   */ setLayers(layers) {
        const collection = this.getLayers();
        if (collection) {
            const currentLayers = collection.getArray();
            for(let i = 0, ii = currentLayers.length; i < ii; ++i)this.dispatchEvent(new $96e8168163e6fc58$export$2f5ff21d758d25a7('removelayer', currentLayers[i]));
        }
        this.set($96e8168163e6fc58$var$Property.LAYERS, layers);
    }
    /**
   * @param {Array<import("./Layer.js").default>} [array] Array of layers (to be modified in place).
   * @return {Array<import("./Layer.js").default>} Array of layers.
   * @override
   */ getLayersArray(array) {
        array = array !== undefined ? array : [];
        this.getLayers().forEach(function(layer) {
            layer.getLayersArray(array);
        });
        return array;
    }
    /**
   * Get the layer states list and use this groups z-index as the default
   * for all layers in this and nested groups, if it is unset at this point.
   * If dest is not provided and this group's z-index is undefined
   * 0 is used a the default z-index.
   * @param {Array<import("./Layer.js").State>} [dest] Optional list
   * of layer states (to be modified in place).
   * @return {Array<import("./Layer.js").State>} List of layer states.
   * @override
   */ getLayerStatesArray(dest) {
        const states = dest !== undefined ? dest : [];
        const pos = states.length;
        this.getLayers().forEach(function(layer) {
            layer.getLayerStatesArray(states);
        });
        const ownLayerState = this.getLayerState();
        let defaultZIndex = ownLayerState.zIndex;
        if (!dest && ownLayerState.zIndex === undefined) defaultZIndex = 0;
        for(let i = pos, ii = states.length; i < ii; i++){
            const layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) layerState.extent = (0, $7e819822b33b3d32$export$72209efa88586d42)(layerState.extent, ownLayerState.extent);
                else layerState.extent = ownLayerState.extent;
            }
            if (layerState.zIndex === undefined) layerState.zIndex = defaultZIndex;
        }
        return states;
    }
    /**
   * @return {import("../source/Source.js").State} Source state.
   * @override
   */ getSourceState() {
        return 'ready';
    }
}
var $96e8168163e6fc58$export$2e2bcd8739ae039 = $96e8168163e6fc58$var$LayerGroup;






/**
 * @module ol/renderer/Composite
 */ 








/**
 * @module ol/renderer/Map
 */ 







/**
 * @template T
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 */ /**
 * @abstract
 */ class $74336bc6031ad34b$var$MapRenderer extends (0, $17f88068b11f58ac$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super();
        /**
     * @private
     * @type {import("../Map.js").default}
     */ this.map_ = map;
    }
    /**
   * @abstract
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   */ dispatchRenderEvent(type, frameState) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @protected
   */ calculateMatrices2D(frameState) {
        const viewState = frameState.viewState;
        const coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        const pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        (0, $2567d97ab31c5663$export$f672e0b6f7222cd7)(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        (0, $2567d97ab31c5663$export$bd70ea2a93c0fa4)(pixelToCoordinateTransform, coordinateToPixelTransform);
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
   * @param {S} thisArg Value to use as `this` when executing `callback`.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
   * @return {T|undefined} Callback result.
   * @template S,T,U
   */ forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        let result;
        const viewState = frameState.viewState;
        /**
     * @param {boolean} managed Managed layer.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @return {T|undefined} Callback result.
     */ function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        const projection = viewState.projection;
        const translatedCoordinate = (0, $8b28786758450fff$export$39a9ce3624977b84)(coordinate.slice(), projection);
        const offsets = [
            [
                0,
                0
            ]
        ];
        if (projection.canWrapX() && checkWrapped) {
            const projectionExtent = projection.getExtent();
            const worldWidth = (0, $7e819822b33b3d32$export$3c49c185de0c2bfc)(projectionExtent);
            offsets.push([
                -worldWidth,
                0
            ], [
                worldWidth,
                0
            ]);
        }
        const layerStates = frameState.layerStatesArray;
        const numLayers = layerStates.length;
        const matches = /** @type {Array<HitMatch<T>>} */ [];
        const tmpCoord = [];
        for(let i = 0; i < offsets.length; i++)for(let j = numLayers - 1; j >= 0; --j){
            const layerState = layerStates[j];
            const layer = layerState.layer;
            if (layer.hasRenderer() && (0, $575253350abb8238$export$acb1e9cb9ce4ca56)(layerState, viewState) && layerFilter.call(thisArg2, layer)) {
                const layerRenderer = layer.getRenderer();
                const source = layer.getSource();
                if (layerRenderer && source) {
                    const coordinates = source.getWrapX() ? translatedCoordinate : coordinate;
                    const callback = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                    tmpCoord[0] = coordinates[0] + offsets[i][0];
                    tmpCoord[1] = coordinates[1] + offsets[i][1];
                    result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback, matches);
                }
                if (result) return result;
            }
        }
        if (matches.length === 0) return undefined;
        const order = 1 / matches.length;
        matches.forEach((m, i)=>m.distanceSq += i * order);
        matches.sort((a, b)=>a.distanceSq - b.distanceSq);
        matches.some((m)=>{
            return result = m.callback(m.feature, m.layer, m.geometry);
        });
        return result;
    }
    /**
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @param {import("../Map.js").FrameState} frameState FrameState.
   * @param {number} hitTolerance Hit tolerance in pixels.
   * @param {boolean} checkWrapped Check for wrapped geometries.
   * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
   *     function, only layers which are visible and for which this function
   *     returns `true` will be tested for features.  By default, all visible
   *     layers will be tested.
   * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
   * @return {boolean} Is there a feature at the given coordinate?
   * @template U
   */ hasFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        const hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, (0, $de1052d9f293b73a$export$22e23a2304399231), this, layerFilter, thisArg);
        return hasFeature !== undefined;
    }
    /**
   * @return {import("../Map.js").default} Map.
   */ getMap() {
        return this.map_;
    }
    /**
   * Render.
   * @abstract
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   */ renderFrame(frameState) {
        (0, $34772e91e89a736f$export$817eb92a8194bab0)();
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @protected
   */ scheduleExpireIconCache(frameState) {
        if ((0, $20f070df2eea68ee$export$747ccdf771a87ab8).canExpireCache()) frameState.postRenderFunctions.push($74336bc6031ad34b$var$expireIconCache);
    }
}
/**
 * @param {import("../Map.js").default} map Map.
 * @param {import("../Map.js").FrameState} frameState Frame state.
 */ function $74336bc6031ad34b$var$expireIconCache(map, frameState) {
    (0, $20f070df2eea68ee$export$747ccdf771a87ab8).expire();
}
var $74336bc6031ad34b$export$2e2bcd8739ae039 = $74336bc6031ad34b$var$MapRenderer;


/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */ class $14c15556573f0edb$var$CompositeMapRenderer extends (0, $74336bc6031ad34b$export$2e2bcd8739ae039) {
    /**
   * @param {import("../Map.js").default} map Map.
   */ constructor(map){
        super(map);
        /**
     * @private
     * @type {import("../events.js").EventsKey}
     */ this.fontChangeListenerKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)((0, $c8f894129d9fa0b9$export$1d36981fcadac93b), (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE, map.redrawText, map);
        /**
     * @private
     * @type {HTMLDivElement}
     */ this.element_ = document.createElement('div');
        const style = this.element_.style;
        style.position = 'absolute';
        style.width = '100%';
        style.height = '100%';
        style.zIndex = '0';
        this.element_.className = (0, $bbcb4c1977b6e9f0$export$1afde3d6e16a7b29) + ' ol-layers';
        const container = map.getViewport();
        container.insertBefore(this.element_, container.firstChild || null);
        /**
     * @private
     * @type {Array<HTMLElement>}
     */ this.children_ = [];
        /**
     * @private
     * @type {boolean}
     */ this.renderedVisible_ = true;
    }
    /**
   * @param {import("../render/EventType.js").default} type Event type.
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ dispatchRenderEvent(type, frameState) {
        const map = this.getMap();
        if (map.hasListener(type)) {
            const event = new (0, $802ec85cbdf20290$export$2e2bcd8739ae039)(type, undefined, frameState);
            map.dispatchEvent(event);
        }
    }
    /**
   * @override
   */ disposeInternal() {
        (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.fontChangeListenerKey_);
        this.element_.remove();
        super.disposeInternal();
    }
    /**
   * Render.
   * @param {?import("../Map.js").FrameState} frameState Frame state.
   * @override
   */ renderFrame(frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent((0, $847c6e8c21904781$export$2e2bcd8739ae039).PRECOMPOSE, frameState);
        const layerStatesArray = frameState.layerStatesArray.sort((a, b)=>a.zIndex - b.zIndex);
        const declutter = layerStatesArray.some((layerState)=>layerState.layer instanceof (0, $6e2aed29332675ea$export$2e2bcd8739ae039) && layerState.layer.getDeclutter());
        if (declutter) // Some layers need decluttering, turn on deferred rendering hint
        frameState.declutter = {};
        const viewState = frameState.viewState;
        this.children_.length = 0;
        const renderedLayerStates = [];
        let previousElement = null;
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            const layer = layerState.layer;
            const sourceState = layer.getSourceState();
            if (!(0, $575253350abb8238$export$acb1e9cb9ce4ca56)(layerState, viewState) || sourceState != 'ready' && sourceState != 'undefined') {
                layer.unrender();
                continue;
            }
            const element = layer.render(frameState, previousElement);
            if (!element) continue;
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            renderedLayerStates.push(layerState);
        }
        this.declutter(frameState, renderedLayerStates);
        (0, $755a3001f896bcf1$export$caeacfe04f52533a)(this.element_, this.children_);
        this.dispatchRenderEvent((0, $847c6e8c21904781$export$2e2bcd8739ae039).POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = '';
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    }
    /**
   * @param {import("../Map.js").FrameState} frameState Frame state.
   * @param {Array<import('../layer/Layer.js').State>} layerStates Layers.
   */ declutter(frameState, layerStates) {
        if (!frameState.declutter) return;
        for(let i = layerStates.length - 1; i >= 0; --i){
            const layerState = layerStates[i];
            const layer = layerState.layer;
            if (layer.getDeclutter()) layer.renderDeclutter(frameState, layerState);
        }
        layerStates.forEach((layerState)=>layerState.layer.renderDeferred(frameState));
    }
}
var $14c15556573f0edb$export$2e2bcd8739ae039 = $14c15556573f0edb$var$CompositeMapRenderer;





/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {Object<string, import("rbush").default<import('./render/canvas/Executor.js').DeclutterEntry>>|null} declutter
 * Declutter trees by declutter group.
 * When null, no decluttering is needed because no layers have decluttering enabled.
 * @property {null|import("./extent.js").Extent} extent Extent (in view projection coordinates).
 * @property {import("./extent.js").Extent} [nextExtent] Next extent during an animation series.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 * @property {string} mapId The id of the map.
 * @property {Object<string, boolean>} renderTargets Identifiers of previously rendered elements.
 */ /**
 * @typedef {function(Map, FrameState): any} PostRenderFunction
 */ /**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default<import("./source/Source").default>): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer~Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */ /**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */ /**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */ /***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} MapEventHandler
 */ /**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control/defaults.defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction/defaults.defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
 *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
 *  `tabindex` atribute must be set on the custom element's host element.
 * **Note:** CSS `transform` support for the target element is limited to `scale`.
 * @property {View|Promise<import("./View.js").ViewOptions>} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */ /**
 * @param {import("./layer/Base.js").default} layer Layer.
 */ function $88aa35e28fb911a2$var$removeLayerMapProperty(layer) {
    if (layer instanceof (0, $575253350abb8238$export$2e2bcd8739ae039)) {
        layer.setMapInternal(null);
        return;
    }
    if (layer instanceof (0, $96e8168163e6fc58$export$2e2bcd8739ae039)) layer.getLayers().forEach($88aa35e28fb911a2$var$removeLayerMapProperty);
}
/**
 * @param {import("./layer/Base.js").default} layer Layer.
 * @param {Map} map Map.
 */ function $88aa35e28fb911a2$var$setLayerMapProperty(layer, map) {
    if (layer instanceof (0, $575253350abb8238$export$2e2bcd8739ae039)) {
        layer.setMapInternal(map);
        return;
    }
    if (layer instanceof (0, $96e8168163e6fc58$export$2e2bcd8739ae039)) {
        const layers = layer.getLayers().getArray();
        for(let i = 0, ii = layers.length; i < ii; ++i)$88aa35e28fb911a2$var$setLayerMapProperty(layers[i], map);
    }
}
/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map.js';
 *     import View from 'ol/View.js';
 *     import TileLayer from 'ol/layer/Tile.js';
 *     import OSM from 'ol/source/OSM.js';
 *
 *     const map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1,
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM(),
 *         }),
 *       ],
 *       target: 'map',
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile~TileLayer} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~LayerGroup}
 * is a subclass of {@link module:ol/layer/Base~BaseLayer}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @fires import("./MapBrowserEvent.js").MapBrowserEvent
 * @fires import("./MapEvent.js").MapEvent
 * @fires import("./render/Event.js").default#precompose
 * @fires import("./render/Event.js").default#postcompose
 * @fires import("./render/Event.js").default#rendercomplete
 * @api
 */ class $88aa35e28fb911a2$var$Map extends (0, $d575b598d09f57d3$export$2e2bcd8739ae039) {
    /**
   * @param {MapOptions} [options] Map options.
   */ constructor(options){
        super();
        options = options || {};
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.on;
        /***
     * @type {MapEventHandler<import("./events").EventsKey>}
     */ this.once;
        /***
     * @type {MapEventHandler<void>}
     */ this.un;
        const optionsInternal = $88aa35e28fb911a2$var$createOptionsInternal(options);
        /**
     * @private
     * @type {boolean}
     */ this.renderComplete_ = false;
        /**
     * @private
     * @type {boolean}
     */ this.loaded_ = true;
        /** @private */ this.boundHandleBrowserEvent_ = this.handleBrowserEvent.bind(this);
        /**
     * @type {number}
     * @private
     */ this.maxTilesLoading_ = options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
     * @private
     * @type {number}
     */ this.pixelRatio_ = options.pixelRatio !== undefined ? options.pixelRatio : (0, $89969764a1196844$export$6b83a0446fc26f94);
        /**
     * @private
     * @type {ReturnType<typeof setTimeout>}
     */ this.postRenderTimeoutHandle_;
        /**
     * @private
     * @type {number|undefined}
     */ this.animationDelayKey_;
        /**
     * @private
     */ this.animationDelay_ = this.animationDelay_.bind(this);
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.coordinateToPixelTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {import("./transform.js").Transform}
     */ this.pixelToCoordinateTransform_ = (0, $2567d97ab31c5663$export$185802fd694ee1f5)();
        /**
     * @private
     * @type {number}
     */ this.frameIndex_ = 0;
        /**
     * @private
     * @type {?FrameState}
     */ this.frameState_ = null;
        /**
     * The extent at the previous 'moveend' event.
     * @private
     * @type {import("./extent.js").Extent}
     */ this.previousExtent_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewPropertyListenerKey_ = null;
        /**
     * @private
     * @type {?import("./events.js").EventsKey}
     */ this.viewChangeListenerKey_ = null;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.layerGroupPropertyListenerKeys_ = null;
        /**
     * @private
     * @type {!HTMLElement}
     */ this.viewport_ = document.createElement('div');
        this.viewport_.className = 'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
        this.viewport_.style.position = 'relative';
        this.viewport_.style.overflow = 'hidden';
        this.viewport_.style.width = '100%';
        this.viewport_.style.height = '100%';
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainer_ = document.createElement('div');
        this.overlayContainer_.style.position = 'absolute';
        this.overlayContainer_.style.zIndex = '0';
        this.overlayContainer_.style.width = '100%';
        this.overlayContainer_.style.height = '100%';
        this.overlayContainer_.style.pointerEvents = 'none';
        this.overlayContainer_.className = 'ol-overlaycontainer';
        this.viewport_.appendChild(this.overlayContainer_);
        /**
     * @private
     * @type {!HTMLElement}
     */ this.overlayContainerStopEvent_ = document.createElement('div');
        this.overlayContainerStopEvent_.style.position = 'absolute';
        this.overlayContainerStopEvent_.style.zIndex = '0';
        this.overlayContainerStopEvent_.style.width = '100%';
        this.overlayContainerStopEvent_.style.height = '100%';
        this.overlayContainerStopEvent_.style.pointerEvents = 'none';
        this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
        this.viewport_.appendChild(this.overlayContainerStopEvent_);
        /**
     * @private
     * @type {MapBrowserEventHandler}
     */ this.mapBrowserEventHandler_ = null;
        /**
     * @private
     * @type {number}
     */ this.moveTolerance_ = options.moveTolerance;
        /**
     * @private
     * @type {HTMLElement|Document}
     */ this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
     * @private
     * @type {?Array<import("./events.js").EventsKey>}
     */ this.targetChangeHandlerKeys_ = null;
        /**
     * @private
     * @type {HTMLElement|null}
     */ this.targetElement_ = null;
        /**
     * @private
     * @type {ResizeObserver}
     */ this.resizeObserver_ = new ResizeObserver(()=>this.updateSize());
        /**
     * @type {Collection<import("./control/Control.js").default>}
     * @protected
     */ this.controls = optionsInternal.controls || (0, $9d34e3901b82049a$export$ebe90cb607ad99e)();
        /**
     * @type {Collection<import("./interaction/Interaction.js").default>}
     * @protected
     */ this.interactions = optionsInternal.interactions || (0, $eedb297ae769b700$export$ebe90cb607ad99e)({
            onFocusOnly: true
        });
        /**
     * @type {Collection<import("./Overlay.js").default>}
     * @private
     */ this.overlays_ = optionsInternal.overlays;
        /**
     * A lookup of overlays by id.
     * @private
     * @type {Object<string, import("./Overlay.js").default>}
     */ this.overlayIdIndex_ = {};
        /**
     * @type {import("./renderer/Map.js").default|null}
     * @private
     */ this.renderer_ = null;
        /**
     * @private
     * @type {!Array<PostRenderFunction>}
     */ this.postRenderFunctions_ = [];
        /**
     * @private
     * @type {TileQueue}
     */ this.tileQueue_ = new (0, $05ff08069bfd30f8$export$2e2bcd8739ae039)(this.getTilePriority.bind(this), this.handleTileChange_.bind(this));
        this.addChangeListener((0, $25ec5d593032f523$export$2e2bcd8739ae039).LAYERGROUP, this.handleLayerGroupChanged_);
        this.addChangeListener((0, $25ec5d593032f523$export$2e2bcd8739ae039).VIEW, this.handleViewChanged_);
        this.addChangeListener((0, $25ec5d593032f523$export$2e2bcd8739ae039).SIZE, this.handleSizeChanged_);
        this.addChangeListener((0, $25ec5d593032f523$export$2e2bcd8739ae039).TARGET, this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        this.setProperties(optionsInternal.values);
        const map = this;
        if (options.view && !(options.view instanceof (0, $3192ea72f934a3fd$export$2e2bcd8739ae039))) options.view.then(function(viewOptions) {
            map.setView(new (0, $3192ea72f934a3fd$export$2e2bcd8739ae039)(viewOptions));
        });
        this.controls.addEventListener((0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent
       */ (event)=>{
            event.element.setMap(this);
        });
        this.controls.addEventListener((0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./control/Control.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.interactions.addEventListener((0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(this);
        });
        this.interactions.addEventListener((0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./interaction/Interaction.js").default>} event CollectionEvent.
       */ (event)=>{
            event.element.setMap(null);
        });
        this.overlays_.addEventListener((0, $da68a68ae95b5159$export$2e2bcd8739ae039).ADD, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            this.addOverlayInternal_(event.element);
        });
        this.overlays_.addEventListener((0, $da68a68ae95b5159$export$2e2bcd8739ae039).REMOVE, /**
       * @param {import("./Collection.js").CollectionEvent<import("./Overlay.js").default>} event CollectionEvent.
       */ (event)=>{
            const id = event.element.getId();
            if (id !== undefined) delete this.overlayIdIndex_[id.toString()];
            event.element.setMap(null);
        });
        this.controls.forEach(/**
       * @param {import("./control/Control.js").default} control Control.
       */ (control)=>{
            control.setMap(this);
        });
        this.interactions.forEach(/**
       * @param {import("./interaction/Interaction.js").default} interaction Interaction.
       */ (interaction)=>{
            interaction.setMap(this);
        });
        this.overlays_.forEach(this.addOverlayInternal_.bind(this));
    }
    /**
   * Add the given control to the map.
   * @param {import("./control/Control.js").default} control Control.
   * @api
   */ addControl(control) {
        this.getControls().push(control);
    }
    /**
   * Add the given interaction to the map. If you want to add an interaction
   * at another point of the collection use `getInteractions()` and the methods
   * available on {@link module:ol/Collection~Collection}. This can be used to
   * stop the event propagation from the handleEvent function. The interactions
   * get to handle the events in the reverse order of this collection.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
   * @api
   */ addInteraction(interaction) {
        this.getInteractions().push(interaction);
    }
    /**
   * Adds the given layer to the top of this map. If you want to add a layer
   * elsewhere in the stack, use `getLayers()` and the methods available on
   * {@link module:ol/Collection~Collection}.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @api
   */ addLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer add event.
   * @private
   */ handleLayerAdd_(event) {
        $88aa35e28fb911a2$var$setLayerMapProperty(event.layer, this);
    }
    /**
   * Add the given overlay to the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @api
   */ addOverlay(overlay) {
        this.getOverlays().push(overlay);
    }
    /**
   * This deals with map's overlay collection changes.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @private
   */ addOverlayInternal_(overlay) {
        const id = overlay.getId();
        if (id !== undefined) this.overlayIdIndex_[id.toString()] = overlay;
        overlay.setMap(this);
    }
    /**
   *
   * Clean up.
   * @override
   */ disposeInternal() {
        this.controls.clear();
        this.interactions.clear();
        this.overlays_.clear();
        this.resizeObserver_.disconnect();
        this.setTarget(null);
        super.disposeInternal();
    }
    /**
   * Detect features that intersect a pixel on the viewport, and execute a
   * callback with each intersecting feature. Layers included in the detection can
   * be configured through the `layerFilter` option in `options`.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default<import("./source/Source").default>, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
   *     called with two arguments. The first argument is one
   *     {@link module:ol/Feature~Feature feature} or
   *     {@link module:ol/render/Feature~RenderFeature render feature} at the pixel, the second is
   *     the {@link module:ol/layer/Layer~Layer layer} of the feature and will be null for
   *     unmanaged layers. To stop detection, callback functions can return a
   *     truthy value.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {T|undefined} Callback result, i.e. the return value of last
   * callback execution, or the first truthy callback return value.
   * @template T
   * @api
   */ forEachFeatureAtPixel(pixel, callback, options) {
        if (!this.frameState_ || !this.renderer_) return;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $de1052d9f293b73a$export$22e23a2304399231);
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    }
    /**
   * Get all features that intersect a pixel on the viewport.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
   * an empty array if none were found.
   * @api
   */ getFeaturesAtPixel(pixel, options) {
        const features = [];
        this.forEachFeatureAtPixel(pixel, function(feature) {
            features.push(feature);
        }, options);
        return features;
    }
    /**
   * Get all layers from all layer groups.
   * @return {Array<import("./layer/Layer.js").default>} Layers.
   * @api
   */ getAllLayers() {
        const layers = [];
        function addLayersFrom(layerGroup) {
            layerGroup.forEach(function(layer) {
                if (layer instanceof (0, $96e8168163e6fc58$export$2e2bcd8739ae039)) addLayersFrom(layer.getLayers());
                else layers.push(layer);
            });
        }
        addLayersFrom(this.getLayers());
        return layers;
    }
    /**
   * Detect if features intersect a pixel on the viewport. Layers included in the
   * detection can be configured through the `layerFilter` option.
   * @param {import("./pixel.js").Pixel} pixel Pixel.
   * @param {AtPixelOptions} [options] Optional options.
   * @return {boolean} Is there a feature at the given pixel?
   * @api
   */ hasFeatureAtPixel(pixel, options) {
        if (!this.frameState_ || !this.renderer_) return false;
        const coordinate = this.getCoordinateFromPixelInternal(pixel);
        options = options !== undefined ? options : {};
        const layerFilter = options.layerFilter !== undefined ? options.layerFilter : (0, $de1052d9f293b73a$export$22e23a2304399231);
        const hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        const checkWrapped = options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    }
    /**
   * Returns the coordinate in user projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   * @api
   */ getEventCoordinate(event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    }
    /**
   * Returns the coordinate in view projection for a browser event.
   * @param {MouseEvent} event Event.
   * @return {import("./coordinate.js").Coordinate} Coordinate.
   */ getEventCoordinateInternal(event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    }
    /**
   * Returns the map pixel position for a browser event relative to the viewport.
   * @param {UIEvent|{clientX: number, clientY: number}} event Event.
   * @return {import("./pixel.js").Pixel} Pixel.
   * @api
   */ getEventPixel(event) {
        const viewport = this.viewport_;
        const viewportPosition = viewport.getBoundingClientRect();
        const viewportSize = this.getSize();
        const scaleX = viewportPosition.width / viewportSize[0];
        const scaleY = viewportPosition.height / viewportSize[1];
        const eventPosition = //FIXME Are we really calling this with a TouchEvent anywhere?
        'changedTouches' in event ? /** @type {TouchEvent} */ event.changedTouches[0] : /** @type {MouseEvent} */ event;
        return [
            (eventPosition.clientX - viewportPosition.left) / scaleX,
            (eventPosition.clientY - viewportPosition.top) / scaleY
        ];
    }
    /**
   * Get the target in which this map is rendered.
   * Note that this returns what is entered as an option or in setTarget:
   * if that was an element, it returns an element; if a string, it returns that.
   * @return {HTMLElement|string|undefined} The Element or id of the Element that the
   *     map is rendered in.
   * @observable
   * @api
   */ getTarget() {
        return /** @type {HTMLElement|string|undefined} */ this.get((0, $25ec5d593032f523$export$2e2bcd8739ae039).TARGET);
    }
    /**
   * Get the DOM element into which this map is rendered. In contrast to
   * `getTarget` this method always return an `Element`, or `null` if the
   * map has no target.
   * @return {HTMLElement} The element that the map is rendered in.
   * @api
   */ getTargetElement() {
        return this.targetElement_;
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * user projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   * @api
   */ getCoordinateFromPixel(pixel) {
        return (0, $92f1443438429e81$export$698f563af1ba02a5)(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    }
    /**
   * Get the coordinate for a given pixel.  This returns a coordinate in the
   * map view projection.
   * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
   * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
   */ getCoordinateFromPixelInternal(pixel) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.pixelToCoordinateTransform, pixel.slice());
    }
    /**
   * Get the map controls. Modifying this collection changes the controls
   * associated with the map.
   * @return {Collection<import("./control/Control.js").default>} Controls.
   * @api
   */ getControls() {
        return this.controls;
    }
    /**
   * Get the map overlays. Modifying this collection changes the overlays
   * associated with the map.
   * @return {Collection<import("./Overlay.js").default>} Overlays.
   * @api
   */ getOverlays() {
        return this.overlays_;
    }
    /**
   * Get an overlay by its identifier (the value returned by overlay.getId()).
   * Note that the index treats string and numeric identifiers as the same. So
   * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
   * @param {string|number} id Overlay identifier.
   * @return {import("./Overlay.js").default|null} Overlay.
   * @api
   */ getOverlayById(id) {
        const overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    }
    /**
   * Get the map interactions. Modifying this collection changes the interactions
   * associated with the map.
   *
   * Interactions are used for e.g. pan, zoom and rotate.
   * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
   * @api
   */ getInteractions() {
        return this.interactions;
    }
    /**
   * Get the layergroup associated with this map.
   * @return {LayerGroup} A layer group containing the layers in this map.
   * @observable
   * @api
   */ getLayerGroup() {
        return /** @type {LayerGroup} */ this.get((0, $25ec5d593032f523$export$2e2bcd8739ae039).LAYERGROUP);
    }
    /**
   * Clear any existing layers and add layers to the map.
   * @param {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>} layers The layers to be added to the map.
   * @api
   */ setLayers(layers) {
        const group = this.getLayerGroup();
        if (layers instanceof (0, $7be3d63260860659$export$2e2bcd8739ae039)) {
            group.setLayers(layers);
            return;
        }
        const collection = group.getLayers();
        collection.clear();
        collection.extend(layers);
    }
    /**
   * Get the collection of layers associated with this map.
   * @return {!Collection<import("./layer/Base.js").default>} Layers.
   * @api
   */ getLayers() {
        const layers = this.getLayerGroup().getLayers();
        return layers;
    }
    /**
   * @return {boolean} Layers have sources that are still loading.
   */ getLoadingOrNotReady() {
        const layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStatesArray.length; i < ii; ++i){
            const state = layerStatesArray[i];
            if (!state.visible) continue;
            const renderer = state.layer.getRenderer();
            if (renderer && !renderer.ready) return true;
            const source = state.layer.getSource();
            if (source && source.loading) return true;
        }
        return false;
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the user
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   * @api
   */ getPixelFromCoordinate(coordinate) {
        const viewCoordinate = (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    }
    /**
   * Get the pixel for a coordinate.  This takes a coordinate in the map view
   * projection and returns the corresponding pixel.
   * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
   * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
   */ getPixelFromCoordinateInternal(coordinate) {
        const frameState = this.frameState_;
        if (!frameState) return null;
        return (0, $2567d97ab31c5663$export$5635d7ef4b8fee1c)(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
    }
    /**
   * Get the map renderer.
   * @return {import("./renderer/Map.js").default|null} Renderer
   */ getRenderer() {
        return this.renderer_;
    }
    /**
   * Get the size of this map.
   * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ getSize() {
        return /** @type {import("./size.js").Size|undefined} */ this.get((0, $25ec5d593032f523$export$2e2bcd8739ae039).SIZE);
    }
    /**
   * Get the view associated with this map. A view manages properties such as
   * center and resolution.
   * @return {View} The view that controls this map.
   * @observable
   * @api
   */ getView() {
        return /** @type {View} */ this.get((0, $25ec5d593032f523$export$2e2bcd8739ae039).VIEW);
    }
    /**
   * Get the element that serves as the map viewport.
   * @return {HTMLElement} Viewport.
   * @api
   */ getViewport() {
        return this.viewport_;
    }
    /**
   * Get the element that serves as the container for overlays.  Elements added to
   * this container will let mousedown and touchstart events through to the map,
   * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
   * events.
   * @return {!HTMLElement} The map's overlay container.
   */ getOverlayContainer() {
        return this.overlayContainer_;
    }
    /**
   * Get the element that serves as a container for overlays that don't allow
   * event propagation. Elements added to this container won't let mousedown and
   * touchstart events through to the map, so clicks and gestures on an overlay
   * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
   * @return {!HTMLElement} The map's overlay container that stops events.
   */ getOverlayContainerStopEvent() {
        return this.overlayContainerStopEvent_;
    }
    /**
   * @return {!Document} The document where the map is displayed.
   */ getOwnerDocument() {
        const targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    }
    /**
   * @param {import("./Tile.js").default} tile Tile.
   * @param {string} tileSourceKey Tile source key.
   * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
   * @param {number} tileResolution Tile resolution.
   * @return {number} Tile priority.
   */ getTilePriority(tile, tileSourceKey, tileCenter, tileResolution) {
        return (0, $05ff08069bfd30f8$export$f08ad5eceeff5d45)(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    }
    /**
   * @param {UIEvent} browserEvent Browser event.
   * @param {string} [type] Type.
   */ handleBrowserEvent(browserEvent, type) {
        type = type || browserEvent.type;
        const mapBrowserEvent = new (0, $f924e5a83a2737ce$export$2e2bcd8739ae039)(type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    }
    /**
   * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
   */ handleMapBrowserEvent(mapBrowserEvent) {
        if (!this.frameState_) // With no view defined, we cannot translate pixels into geographical
        // coordinates so interactions cannot be used.
        return;
        const originalEvent = /** @type {PointerEvent} */ mapBrowserEvent.originalEvent;
        const eventType = originalEvent.type;
        if (eventType === (0, $8b8450889b821db1$export$2e2bcd8739ae039).POINTERDOWN || eventType === (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).WHEEL || eventType === (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYDOWN) {
            const doc = this.getOwnerDocument();
            const rootNode = this.viewport_.getRootNode ? this.viewport_.getRootNode() : doc;
            const target = /** @type {Node} */ originalEvent.target;
            const currentDoc = rootNode instanceof ShadowRoot ? rootNode.host === target ? rootNode.host.ownerDocument : rootNode : rootNode === doc ? doc.documentElement : rootNode;
            if (// Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) || // Abort if the event target is a child of the container that is no longer in the page.
            // It's possible for the target to no longer be in the page if it has been removed in an
            // event listener, this might happen in a Control that recreates it's content based on
            // user interaction either manually or via a render in something like https://reactjs.org/
            !currentDoc.contains(target)) return;
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            const interactionsArray = this.getInteractions().getArray().slice();
            for(let i = interactionsArray.length - 1; i >= 0; i--){
                const interaction = interactionsArray[i];
                if (interaction.getMap() !== this || !interaction.getActive() || !this.getTargetElement()) continue;
                const cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) break;
            }
        }
    }
    /**
   * @protected
   */ handlePostRender() {
        const frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        const tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            let maxTotalLoading = this.maxTilesLoading_;
            let maxNewLoads = maxTotalLoading;
            if (frameState) {
                const hints = frameState.viewHints;
                if (hints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] || hints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING]) {
                    const lowOnFrameBudget = Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState && this.renderer_ && !frameState.animate) {
            if (this.renderComplete_) {
                if (this.hasListener((0, $847c6e8c21904781$export$2e2bcd8739ae039).RENDERCOMPLETE)) this.renderer_.dispatchRenderEvent((0, $847c6e8c21904781$export$2e2bcd8739ae039).RENDERCOMPLETE, frameState);
                if (this.loaded_ === false) {
                    this.loaded_ = true;
                    this.dispatchEvent(new (0, $7513f8b91fec7508$export$2e2bcd8739ae039)((0, $392290a16437301e$export$2e2bcd8739ae039).LOADEND, this, frameState));
                }
            } else if (this.loaded_ === true) {
                this.loaded_ = false;
                this.dispatchEvent(new (0, $7513f8b91fec7508$export$2e2bcd8739ae039)((0, $392290a16437301e$export$2e2bcd8739ae039).LOADSTART, this, frameState));
            }
        }
        const postRenderFunctions = this.postRenderFunctions_;
        if (frameState) for(let i = 0, ii = postRenderFunctions.length; i < ii; ++i)postRenderFunctions[i](this, frameState);
        postRenderFunctions.length = 0;
    }
    /**
   * @private
   */ handleSizeChanged_() {
        if (this.getView() && !this.getView().getAnimating()) this.getView().resolveConstraints(0);
        this.render();
    }
    /**
   * @private
   */ handleTargetChanged_() {
        if (this.mapBrowserEventHandler_) {
            for(let i = 0, ii = this.targetChangeHandlerKeys_.length; i < ii; ++i)(0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.targetChangeHandlerKeys_[i]);
            this.targetChangeHandlerKeys_ = null;
            this.viewport_.removeEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_);
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            this.viewport_.remove();
        }
        if (this.targetElement_) {
            this.resizeObserver_.unobserve(this.targetElement_);
            const rootNode = this.targetElement_.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.unobserve(rootNode.host);
            this.setSize(undefined);
        }
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        const target = this.getTarget();
        const targetElement = typeof target === 'string' ? document.getElementById(target) : target;
        this.targetElement_ = targetElement;
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        } else {
            targetElement.appendChild(this.viewport_);
            if (!this.renderer_) this.renderer_ = new (0, $14c15556573f0edb$export$2e2bcd8739ae039)(this);
            this.mapBrowserEventHandler_ = new (0, $ad641aa29114f9e4$export$2e2bcd8739ae039)(this, this.moveTolerance_);
            for(const key in 0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039)this.mapBrowserEventHandler_.addEventListener((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039)[key], this.handleMapBrowserEvent.bind(this));
            this.viewport_.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CONTEXTMENU, this.boundHandleBrowserEvent_, false);
            this.viewport_.addEventListener((0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).WHEEL, this.boundHandleBrowserEvent_, (0, $89969764a1196844$export$f751ce96c6c4e4fc) ? {
                passive: false
            } : false);
            let keyboardEventTarget;
            if (!this.keyboardEventTarget_) {
                // check if map target is in shadowDOM, if yes use host element as target
                const targetRoot = targetElement.getRootNode();
                const targetCandidate = targetRoot instanceof ShadowRoot ? targetRoot.host : targetElement;
                keyboardEventTarget = targetCandidate;
            } else keyboardEventTarget = this.keyboardEventTarget_;
            this.targetChangeHandlerKeys_ = [
                (0, $37a5c0af9052e360$export$63174c828edd6ff8)(keyboardEventTarget, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYDOWN, this.handleBrowserEvent, this),
                (0, $37a5c0af9052e360$export$63174c828edd6ff8)(keyboardEventTarget, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).KEYPRESS, this.handleBrowserEvent, this)
            ];
            const rootNode = targetElement.getRootNode();
            if (rootNode instanceof ShadowRoot) this.resizeObserver_.observe(rootNode.host);
            this.resizeObserver_.observe(targetElement);
        }
        this.updateSize();
    // updateSize calls setSize, so no need to call this.render
    // ourselves here.
    }
    /**
   * @private
   */ handleTileChange_() {
        this.render();
    }
    /**
   * @private
   */ handleViewPropertyChanged_() {
        this.render();
    }
    /**
   * @private
   */ handleViewChanged_() {
        if (this.viewPropertyListenerKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            (0, $37a5c0af9052e360$export$b0a21c8b3c1c921)(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        const view = this.getView();
        if (view) {
            this.updateViewportSize_(this.getSize());
            this.viewPropertyListenerKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(view, (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = (0, $37a5c0af9052e360$export$63174c828edd6ff8)(view, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    }
    /**
   * @private
   */ handleLayerGroupChanged_() {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach((0, $37a5c0af9052e360$export$b0a21c8b3c1c921));
            this.layerGroupPropertyListenerKeys_ = null;
        }
        const layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.handleLayerAdd_(new (0, $96e8168163e6fc58$export$2f5ff21d758d25a7)('addlayer', layerGroup));
            this.layerGroupPropertyListenerKeys_ = [
                (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layerGroup, (0, $19100aa5be43a728$export$2e2bcd8739ae039).PROPERTYCHANGE, this.render, this),
                (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layerGroup, (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CHANGE, this.render, this),
                (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layerGroup, 'addlayer', this.handleLayerAdd_, this),
                (0, $37a5c0af9052e360$export$63174c828edd6ff8)(layerGroup, 'removelayer', this.handleLayerRemove_, this)
            ];
        }
        this.render();
    }
    /**
   * @return {boolean} Is rendered.
   */ isRendered() {
        return !!this.frameState_;
    }
    /**
   * @private
   */ animationDelay_() {
        this.animationDelayKey_ = undefined;
        this.renderFrame_(Date.now());
    }
    /**
   * Requests an immediate render in a synchronous manner.
   * @api
   */ renderSync() {
        if (this.animationDelayKey_) cancelAnimationFrame(this.animationDelayKey_);
        this.animationDelay_();
    }
    /**
   * Redraws all text after new fonts have loaded
   */ redrawText() {
        const layerStates = this.getLayerGroup().getLayerStatesArray();
        for(let i = 0, ii = layerStates.length; i < ii; ++i){
            const layer = layerStates[i].layer;
            if (layer.hasRenderer()) layer.getRenderer().handleFontsChanged();
        }
    }
    /**
   * Request a map rendering (at the next animation frame).
   * @api
   */ render() {
        if (this.renderer_ && this.animationDelayKey_ === undefined) this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
    }
    /**
   * Remove the given control from the map.
   * @param {import("./control/Control.js").default} control Control.
   * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
   *     if the control was not found).
   * @api
   */ removeControl(control) {
        return this.getControls().remove(control);
    }
    /**
   * Remove the given interaction from the map.
   * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
   * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
   *     undefined if the interaction was not found).
   * @api
   */ removeInteraction(interaction) {
        return this.getInteractions().remove(interaction);
    }
    /**
   * Removes the given layer from the map.
   * @param {import("./layer/Base.js").default} layer Layer.
   * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
   *     layer was not found).
   * @api
   */ removeLayer(layer) {
        const layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    }
    /**
   * @param {import("./layer/Group.js").GroupEvent} event The layer remove event.
   * @private
   */ handleLayerRemove_(event) {
        $88aa35e28fb911a2$var$removeLayerMapProperty(event.layer);
    }
    /**
   * Remove the given overlay from the map.
   * @param {import("./Overlay.js").default} overlay Overlay.
   * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
   *     if the overlay was not found).
   * @api
   */ removeOverlay(overlay) {
        return this.getOverlays().remove(overlay);
    }
    /**
   * @param {number} time Time.
   * @private
   */ renderFrame_(time) {
        const size = this.getSize();
        const view = this.getView();
        const previousFrameState = this.frameState_;
        /** @type {?FrameState} */ let frameState = null;
        if (size !== undefined && (0, $f65ee5b9d8e75975$export$622c471beb1693c7)(size) && view && view.isDef()) {
            const viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            const viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutter: null,
                extent: (0, $7e819822b33b3d32$export$13ba650faf8308)(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
                mapId: (0, $34772e91e89a736f$export$5e82334337e0f204)(this),
                renderTargets: {}
            };
            if (viewState.nextCenter && viewState.nextResolution) {
                const rotation = isNaN(viewState.nextRotation) ? viewState.rotation : viewState.nextRotation;
                frameState.nextExtent = (0, $7e819822b33b3d32$export$13ba650faf8308)(viewState.nextCenter, viewState.nextResolution, rotation, size);
            }
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) this.render();
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                const moveStart = !this.previousExtent_ || !(0, $7e819822b33b3d32$export$dd1bc94b04021eeb)(this.previousExtent_) && !(0, $7e819822b33b3d32$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
                if (moveStart) {
                    this.dispatchEvent(new (0, $7513f8b91fec7508$export$2e2bcd8739ae039)((0, $392290a16437301e$export$2e2bcd8739ae039).MOVESTART, this, previousFrameState));
                    this.previousExtent_ = (0, $7e819822b33b3d32$export$3e2152b047719fa1)(this.previousExtent_);
                }
            }
            const idle = this.previousExtent_ && !frameState.viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).ANIMATING] && !frameState.viewHints[(0, $1c808e01929bd7f1$export$2e2bcd8739ae039).INTERACTING] && !(0, $7e819822b33b3d32$export$e9bab7fafb253603)(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new (0, $7513f8b91fec7508$export$2e2bcd8739ae039)((0, $392290a16437301e$export$2e2bcd8739ae039).MOVEEND, this, frameState));
                (0, $7e819822b33b3d32$export$9cd59f9826255e47)(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new (0, $7513f8b91fec7508$export$2e2bcd8739ae039)((0, $392290a16437301e$export$2e2bcd8739ae039).POSTRENDER, this, frameState));
        this.renderComplete_ = (this.hasListener((0, $392290a16437301e$export$2e2bcd8739ae039).LOADSTART) || this.hasListener((0, $392290a16437301e$export$2e2bcd8739ae039).LOADEND) || this.hasListener((0, $847c6e8c21904781$export$2e2bcd8739ae039).RENDERCOMPLETE)) && !this.tileQueue_.getTilesLoading() && !this.tileQueue_.getCount() && !this.getLoadingOrNotReady();
        if (!this.postRenderTimeoutHandle_) this.postRenderTimeoutHandle_ = setTimeout(()=>{
            this.postRenderTimeoutHandle_ = undefined;
            this.handlePostRender();
        }, 0);
    }
    /**
   * Sets the layergroup of this map.
   * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
   * @observable
   * @api
   */ setLayerGroup(layerGroup) {
        const oldLayerGroup = this.getLayerGroup();
        if (oldLayerGroup) this.handleLayerRemove_(new (0, $96e8168163e6fc58$export$2f5ff21d758d25a7)('removelayer', oldLayerGroup));
        this.set((0, $25ec5d593032f523$export$2e2bcd8739ae039).LAYERGROUP, layerGroup);
    }
    /**
   * Set the size of this map.
   * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
   * @observable
   * @api
   */ setSize(size) {
        this.set((0, $25ec5d593032f523$export$2e2bcd8739ae039).SIZE, size);
    }
    /**
   * Set the target element to render this map into.
   * For accessibility (focus and keyboard events for map navigation), the `target` element must have a
   *  properly configured `tabindex` attribute. If the `target` element is inside a Shadow DOM, the
   *  `tabindex` atribute must be set on the custom element's host element.
   * @param {HTMLElement|string} [target] The Element or id of the Element
   *     that the map is rendered in.
   * @observable
   * @api
   */ setTarget(target) {
        this.set((0, $25ec5d593032f523$export$2e2bcd8739ae039).TARGET, target);
    }
    /**
   * Set the view for this map.
   * @param {View|Promise<import("./View.js").ViewOptions>} view The view that controls this map.
   * It is also possible to pass a promise that resolves to options for constructing a view.  This
   * alternative allows view properties to be resolved by sources or other components that load
   * view-related metadata.
   * @observable
   * @api
   */ setView(view) {
        if (!view || view instanceof (0, $3192ea72f934a3fd$export$2e2bcd8739ae039)) {
            this.set((0, $25ec5d593032f523$export$2e2bcd8739ae039).VIEW, view);
            return;
        }
        this.set((0, $25ec5d593032f523$export$2e2bcd8739ae039).VIEW, new (0, $3192ea72f934a3fd$export$2e2bcd8739ae039)());
        const map = this;
        view.then(function(viewOptions) {
            map.setView(new (0, $3192ea72f934a3fd$export$2e2bcd8739ae039)(viewOptions));
        });
    }
    /**
   * Force a recalculation of the map viewport size.  This should be called when
   * third-party code changes the size of the map viewport.
   * @api
   */ updateSize() {
        const targetElement = this.getTargetElement();
        let size = undefined;
        if (targetElement) {
            const computedStyle = getComputedStyle(targetElement);
            const width = targetElement.offsetWidth - parseFloat(computedStyle['borderLeftWidth']) - parseFloat(computedStyle['paddingLeft']) - parseFloat(computedStyle['paddingRight']) - parseFloat(computedStyle['borderRightWidth']);
            const height = targetElement.offsetHeight - parseFloat(computedStyle['borderTopWidth']) - parseFloat(computedStyle['paddingTop']) - parseFloat(computedStyle['paddingBottom']) - parseFloat(computedStyle['borderBottomWidth']);
            if (!isNaN(width) && !isNaN(height)) {
                size = [
                    Math.max(0, width),
                    Math.max(0, height)
                ];
                if (!(0, $f65ee5b9d8e75975$export$622c471beb1693c7)(size) && !!(targetElement.offsetWidth || targetElement.offsetHeight || targetElement.getClientRects().length)) (0, $7ebf1be11d834723$export$c106dd0671a0fc2d)("No map visible because the map container's width or height are 0.");
            }
        }
        const oldSize = this.getSize();
        if (size && (!oldSize || !(0, $830d23b8323fc080$export$e9bab7fafb253603)(size, oldSize))) {
            this.setSize(size);
            this.updateViewportSize_(size);
        }
    }
    /**
   * Recomputes the viewport size and save it on the view object (if any)
   * @param {import("./size.js").Size|undefined} size The size.
   * @private
   */ updateViewportSize_(size) {
        const view = this.getView();
        if (view) view.setViewportSize(size);
    }
}
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */ function $88aa35e28fb911a2$var$createOptionsInternal(options) {
    /**
   * @type {HTMLElement|Document}
   */ let keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) keyboardEventTarget = typeof options.keyboardEventTarget === 'string' ? document.getElementById(options.keyboardEventTarget) : options.keyboardEventTarget;
    /**
   * @type {Object<string, *>}
   */ const values = {};
    const layerGroup = options.layers && typeof /** @type {?} */ options.layers.getLayers === 'function' ? /** @type {LayerGroup} */ options.layers : new (0, $96e8168163e6fc58$export$2e2bcd8739ae039)({
        layers: /** @type {Collection<import("./layer/Base.js").default>|Array<import("./layer/Base.js").default>} */ options.layers
    });
    values[(0, $25ec5d593032f523$export$2e2bcd8739ae039).LAYERGROUP] = layerGroup;
    values[(0, $25ec5d593032f523$export$2e2bcd8739ae039).TARGET] = options.target;
    values[(0, $25ec5d593032f523$export$2e2bcd8739ae039).VIEW] = options.view instanceof (0, $3192ea72f934a3fd$export$2e2bcd8739ae039) ? options.view : new (0, $3192ea72f934a3fd$export$2e2bcd8739ae039)();
    /** @type {Collection<import("./control/Control.js").default>} */ let controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) controls = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(options.controls.slice());
        else {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ options.controls.getArray === 'function', 'Expected `controls` to be an array or an `ol/Collection.js`');
            controls = options.controls;
        }
    }
    /** @type {Collection<import("./interaction/Interaction").default>} */ let interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) interactions = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(options.interactions.slice());
        else {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ options.interactions.getArray === 'function', 'Expected `interactions` to be an array or an `ol/Collection.js`');
            interactions = options.interactions;
        }
    }
    /** @type {Collection<import("./Overlay.js").default>} */ let overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) overlays = new (0, $7be3d63260860659$export$2e2bcd8739ae039)(options.overlays.slice());
        else {
            (0, $b6052fc13e9a3991$export$a7a9523472993e97)(typeof /** @type {?} */ options.overlays.getArray === 'function', 'Expected `overlays` to be an array or an `ol/Collection.js`');
            overlays = options.overlays;
        }
    } else overlays = new (0, $7be3d63260860659$export$2e2bcd8739ae039)();
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values
    };
}
var $88aa35e28fb911a2$export$2e2bcd8739ae039 = $88aa35e28fb911a2$var$Map;






/**
 * @module ol/interaction/Draw
 */ 








/**
 * @module ol/geom/Circle
 */ 



/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */ class $a52bfbb6e6800da8$var$Circle extends (0, $ce25558341ea2841$export$2e2bcd8739ae039) {
    /**
   * @param {!import("../coordinate.js").Coordinate} center Center.
   *     For internal use, flat coordinates in combination with `layout` and no
   *     `radius` are also accepted.
   * @param {number} [radius] Radius in units of the projection.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(center, radius, layout){
        super();
        if (layout !== undefined && radius === undefined) this.setFlatCoordinates(layout, center);
        else {
            radius = radius ? radius : 0;
            this.setCenterAndRadius(center, radius, layout);
        }
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Circle} Clone.
   * @api
   * @override
   */ clone() {
        const circle = new $a52bfbb6e6800da8$var$Circle(this.flatCoordinates.slice(), undefined, this.layout);
        circle.applyProperties(this);
        return circle;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   * @override
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        const squaredDistance = dx * dx + dy * dy;
        if (squaredDistance < minSquaredDistance) {
            if (squaredDistance === 0) for(let i = 0; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            else {
                const delta = this.getRadius() / Math.sqrt(squaredDistance);
                closestPoint[0] = flatCoordinates[0] + delta * dx;
                closestPoint[1] = flatCoordinates[1] + delta * dy;
                for(let i = 2; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            }
            closestPoint.length = this.stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   * @override
   */ containsXY(x, y) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        return dx * dx + dy * dy <= this.getRadiusSquared_();
    }
    /**
   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @return {import("../coordinate.js").Coordinate} Center.
   * @api
   */ getCenter() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   * @override
   */ computeExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const radius = flatCoordinates[this.stride] - flatCoordinates[0];
        return (0, $7e819822b33b3d32$export$958e3e1a02eac4b6)(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
    }
    /**
   * Return the radius of the circle.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return Math.sqrt(this.getRadiusSquared_());
    }
    /**
   * @private
   * @return {number} Radius squared.
   */ getRadiusSquared_() {
        const dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
        const dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
        return dx * dx + dy * dy;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   * @override
   */ getType() {
        return 'Circle';
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   * @override
   */ intersectsExtent(extent) {
        const circleExtent = this.getExtent();
        if ((0, $7e819822b33b3d32$export$7b0a31e10bbff018)(extent, circleExtent)) {
            const center = this.getCenter();
            if (extent[0] <= center[0] && extent[2] >= center[0]) return true;
            if (extent[1] <= center[1] && extent[3] >= center[1]) return true;
            return (0, $7e819822b33b3d32$export$f9ed8a3d123a08e2)(extent, this.intersectsCoordinate.bind(this));
        }
        return false;
    }
    /**
   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @api
   */ setCenter(center) {
        const stride = this.stride;
        const radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
        const flatCoordinates = center.slice();
        flatCoordinates[stride] = flatCoordinates[0] + radius;
        for(let i = 1; i < stride; ++i)flatCoordinates[stride + i] = center[i];
        this.setFlatCoordinates(this.layout, flatCoordinates);
        this.changed();
    }
    /**
   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
   * number) of the circle.
   * @param {!import("../coordinate.js").Coordinate} center Center.
   * @param {number} radius Radius.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCenterAndRadius(center, radius, layout) {
        this.setLayout(layout, center, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        /** @type {Array<number>} */ const flatCoordinates = this.flatCoordinates;
        let offset = (0, $4ae92c9bec373de6$export$60815ead40ec79ab)(flatCoordinates, 0, center, this.stride);
        flatCoordinates[offset++] = flatCoordinates[0] + radius;
        for(let i = 1, ii = this.stride; i < ii; ++i)flatCoordinates[offset++] = flatCoordinates[i];
        flatCoordinates.length = offset;
        this.changed();
    }
    /**
   * @override
   */ getCoordinates() {
        return null;
    }
    /**
   * @override
   */ setCoordinates(coordinates, layout) {}
    /**
   * Set the radius of the circle. The radius is in the units of the projection.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
        this.changed();
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   * @override
   */ rotate(angle, anchor) {
        const center = this.getCenter();
        const stride = this.getStride();
        this.setCenter((0, $24a54079104c80a7$export$bb628a54ab399bc9)(center, 0, center.length, stride, angle, anchor, center));
        this.changed();
    }
}
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */ $a52bfbb6e6800da8$var$Circle.prototype.transform;
var $a52bfbb6e6800da8$export$2e2bcd8739ae039 = $a52bfbb6e6800da8$var$Circle;

















/**
 * @typedef {Object} Options
 * @property {import("../geom/Geometry.js").Type} type Geometry type of
 * the geometries being drawn with this instance.
 * @property {number} [clickTolerance=6] The maximum distance in pixels between
 * "down" and "up" for a "up" event to be considered a "click" event and
 * actually add a point/vertex to the geometry being drawn.  The default of `6`
 * was chosen for the draw interaction to behave correctly on mouse as well as
 * on touch devices.
 * @property {import("../Collection.js").default<Feature>} [features]
 * Destination collection for the drawn features.
 * @property {VectorSource} [source] Destination source for
 * the drawn features.
 * @property {number} [dragVertexDelay=500] Delay in milliseconds after pointerdown
 * before the current vertex can be dragged to its exact position.
 * @property {number} [snapTolerance=12] Pixel distance for snapping to the
 * drawing finish. Must be greater than `0`.
 * @property {boolean} [stopClick=false] Stop click, singleclick, and
 * doubleclick events from firing during drawing.
 * @property {number} [maxPoints] The number of points that can be drawn before
 * a polygon ring or line string is finished. By default there is no
 * restriction.
 * @property {number} [minPoints] The number of points that must be drawn
 * before a polygon ring or line string can be finished. Default is `3` for
 * polygon rings and `2` for line strings.
 * @property {import("../events/condition.js").Condition} [finishCondition] A function
 * that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether the drawing can be finished. Not used when drawing
 * POINT or MULTI_POINT geometries.
 * @property {import("../style/Style.js").StyleLike|import("../style/flat.js").FlatStyleLike} [style]
 * Style for sketch features. The draw interaction can have up to three sketch features, depending on the mode.
 * It will always contain a feature with a `Point` geometry that corresponds to the current cursor position.
 * If the mode is `LineString` or `Polygon`, and there is at least one drawn point, it will also contain a feature with
 * a `LineString` geometry that corresponds to the line between the already drawn points and the current cursor position.
 * If the mode is `Polygon`, and there is at least one drawn point, it will also contain a feature with a `Polygon`
 * geometry that corresponds to the polygon between the already drawn points and the current cursor position
 * (note that this polygon has only two points if only one point is drawn).
 * If the mode is `Circle`, and there is one point drawn, it will also contain a feature with a `Circle` geometry whose
 * center is the drawn point and the radius is determined by the distance between the drawn point and the cursor.
 * @property {GeometryFunction} [geometryFunction]
 * Function that is called when a geometry's coordinates are updated.
 * @property {string} [geometryName] Geometry name to use for features created
 * by the draw interaction.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default {@link module:ol/events/condition.noModifierKeys}, i.e. a click,
 * adds a vertex or deactivates freehand drawing.
 * @property {boolean} [freehand=false] Operate in freehand mode for lines,
 * polygons, and circles.  This makes the interaction always operate in freehand
 * mode and takes precedence over any `freehandCondition` option.
 * @property {import("../events/condition.js").Condition} [freehandCondition]
 * Condition that activates freehand drawing for lines and polygons. This
 * function takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether that event should be handled. The
 * default is {@link module:ol/events/condition.shiftKeyOnly}, meaning that the
 * Shift key activates freehand drawing.
 * @property {boolean|import("../events/condition.js").Condition} [trace=false] Trace a portion of another geometry.
 * Ignored when in freehand mode.
 * @property {VectorSource} [traceSource] Source for features to trace.  If tracing is active and a `traceSource` is
 * not provided, the interaction's `source` will be used.  Tracing requires that the interaction is configured with
 * either a `traceSource` or a `source`.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 * @property {import("../geom/Geometry.js").GeometryLayout} [geometryLayout='XY'] Layout of the
 * feature geometries created by the draw interaction.
 */ /**
 * Coordinate type when drawing points.
 * @typedef {import("../coordinate.js").Coordinate} PointCoordType
 */ /**
 * Coordinate type when drawing lines.
 * @typedef {Array<import("../coordinate.js").Coordinate>} LineCoordType
 */ /**
 * Coordinate type when drawing polygons.
 * @typedef {Array<Array<import("../coordinate.js").Coordinate>>} PolyCoordType
 */ /**
 * Types used for drawing coordinates.
 * @typedef {PointCoordType|LineCoordType|PolyCoordType} SketchCoordType
 */ /**
 * @typedef {Object} TraceState
 * @property {boolean} active Tracing active.
 * @property {import("../pixel.js").Pixel} [startPx] The initially clicked pixel location.
 * @property {Array<TraceTarget>} [targets] Targets available for tracing.
 * @property {number} [targetIndex] The index of the currently traced target.  A value of -1 indicates
 * that no trace target is active.
 */ /**
 * @typedef {Object} TraceTarget
 * @property {Array<import("../coordinate.js").Coordinate>} coordinates Target coordinates.
 * @property {boolean} ring The target coordinates are a linear ring.
 * @property {number} startIndex The index of first traced coordinate.  A fractional index represents an
 * edge intersection.  Index values for rings will wrap (may be negative or larger than coordinates length).
 * @property {number} endIndex The index of last traced coordinate.  Details from startIndex also apply here.
 */ /**
 * Function that takes an array of coordinates and an optional existing geometry
 * and a projection as arguments, and returns a geometry. The optional existing
 * geometry is the geometry that is returned when the function is called without
 * a second argument.
 * @typedef {function(!SketchCoordType, import("../geom/SimpleGeometry.js").default,
 *     import("../proj/Projection.js").default):
 *     import("../geom/SimpleGeometry.js").default} GeometryFunction
 */ /**
 * @typedef {'Point' | 'LineString' | 'Polygon' | 'Circle'} Mode
 * Draw mode.  This collapses multi-part geometry types with their single-part
 * cousins.
 */ /**
 * @enum {string}
 */ const $ca31a7ccd09c3d1c$var$DrawEventType = {
    /**
   * Triggered upon feature draw start
   * @event DrawEvent#drawstart
   * @api
   */ DRAWSTART: 'drawstart',
    /**
   * Triggered upon feature draw end
   * @event DrawEvent#drawend
   * @api
   */ DRAWEND: 'drawend',
    /**
   * Triggered upon feature draw abortion
   * @event DrawEvent#drawabort
   * @api
   */ DRAWABORT: 'drawabort'
};
class $ca31a7ccd09c3d1c$export$85a4910380d251a7 extends (0, $0327f54963b35733$export$2e2bcd8739ae039) {
    /**
   * @param {DrawEventType} type Type.
   * @param {Feature} feature The feature drawn.
   */ constructor(type, feature){
        super(type);
        /**
     * The feature being drawn.
     * @type {Feature}
     * @api
     */ this.feature = feature;
    }
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {Array<Feature>} features The candidate features.
 * @return {Array<TraceTarget>} The trace targets.
 */ function $ca31a7ccd09c3d1c$var$getTraceTargets(coordinate, features) {
    /**
   * @type {Array<TraceTarget>}
   */ const targets = [];
    for(let i = 0; i < features.length; ++i){
        const feature = features[i];
        const geometry = feature.getGeometry();
        $ca31a7ccd09c3d1c$var$appendGeometryTraceTargets(coordinate, geometry, targets);
    }
    return targets;
}
/**
 * @param {import("../coordinate.js").Coordinate} a One coordinate.
 * @param {import("../coordinate.js").Coordinate} b Another coordinate.
 * @return {number} The squared distance between the two coordinates.
 */ function $ca31a7ccd09c3d1c$var$getSquaredDistance(a, b) {
    return (0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(a[0], a[1], b[0], b[1]);
}
/**
 * @param {LineCoordType} coordinates The ring coordinates.
 * @param {number} index The index.  May be wrapped.
 * @return {import("../coordinate.js").Coordinate} The coordinate.
 */ function $ca31a7ccd09c3d1c$var$getCoordinate(coordinates, index) {
    const count = coordinates.length;
    if (index < 0) return coordinates[index + count];
    if (index >= count) return coordinates[index - count];
    return coordinates[index];
}
/**
 * Get the cumulative squared distance along a ring path.  The end index index may be "wrapped" and it may
 * be less than the start index to indicate the direction of travel.  The start and end index may have
 * a fractional part to indicate a point between two coordinates.
 * @param {LineCoordType} coordinates Ring coordinates.
 * @param {number} startIndex The start index.
 * @param {number} endIndex The end index.
 * @return {number} The cumulative squared distance along the ring path.
 */ function $ca31a7ccd09c3d1c$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex) {
    let lowIndex, highIndex;
    if (startIndex < endIndex) {
        lowIndex = startIndex;
        highIndex = endIndex;
    } else {
        lowIndex = endIndex;
        highIndex = startIndex;
    }
    const lowWholeIndex = Math.ceil(lowIndex);
    const highWholeIndex = Math.floor(highIndex);
    if (lowWholeIndex > highWholeIndex) {
        // both start and end are on the same segment
        const start = $ca31a7ccd09c3d1c$var$interpolateCoordinate(coordinates, lowIndex);
        const end = $ca31a7ccd09c3d1c$var$interpolateCoordinate(coordinates, highIndex);
        return $ca31a7ccd09c3d1c$var$getSquaredDistance(start, end);
    }
    let sd = 0;
    if (lowIndex < lowWholeIndex) {
        const start = $ca31a7ccd09c3d1c$var$interpolateCoordinate(coordinates, lowIndex);
        const end = $ca31a7ccd09c3d1c$var$getCoordinate(coordinates, lowWholeIndex);
        sd += $ca31a7ccd09c3d1c$var$getSquaredDistance(start, end);
    }
    if (highWholeIndex < highIndex) {
        const start = $ca31a7ccd09c3d1c$var$getCoordinate(coordinates, highWholeIndex);
        const end = $ca31a7ccd09c3d1c$var$interpolateCoordinate(coordinates, highIndex);
        sd += $ca31a7ccd09c3d1c$var$getSquaredDistance(start, end);
    }
    for(let i = lowWholeIndex; i < highWholeIndex - 1; ++i){
        const start = $ca31a7ccd09c3d1c$var$getCoordinate(coordinates, i);
        const end = $ca31a7ccd09c3d1c$var$getCoordinate(coordinates, i + 1);
        sd += $ca31a7ccd09c3d1c$var$getSquaredDistance(start, end);
    }
    return sd;
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {import("../geom/Geometry.js").default} geometry The candidate geometry.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function $ca31a7ccd09c3d1c$var$appendGeometryTraceTargets(coordinate, geometry, targets) {
    if (geometry instanceof (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039)) {
        $ca31a7ccd09c3d1c$var$appendTraceTarget(coordinate, geometry.getCoordinates(), false, targets);
        return;
    }
    if (geometry instanceof (0, $977a2295e90f3a11$export$2e2bcd8739ae039)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)$ca31a7ccd09c3d1c$var$appendTraceTarget(coordinate, coordinates[i], false, targets);
        return;
    }
    if (geometry instanceof (0, $46a66e0f2fc72479$export$2e2bcd8739ae039)) {
        const coordinates = geometry.getCoordinates();
        for(let i = 0, ii = coordinates.length; i < ii; ++i)$ca31a7ccd09c3d1c$var$appendTraceTarget(coordinate, coordinates[i], true, targets);
        return;
    }
    if (geometry instanceof (0, $181e07a3c0063616$export$2e2bcd8739ae039)) {
        const polys = geometry.getCoordinates();
        for(let i = 0, ii = polys.length; i < ii; ++i){
            const coordinates = polys[i];
            for(let j = 0, jj = coordinates.length; j < jj; ++j)$ca31a7ccd09c3d1c$var$appendTraceTarget(coordinate, coordinates[j], true, targets);
        }
        return;
    }
    if (geometry instanceof (0, $6ed77a6d2b45ebec$export$2e2bcd8739ae039)) {
        const geometries = geometry.getGeometries();
        for(let i = 0; i < geometries.length; ++i)$ca31a7ccd09c3d1c$var$appendGeometryTraceTargets(coordinate, geometries[i], targets);
        return;
    }
// other types cannot be traced
}
/**
 * @typedef {Object} TraceTargetUpdateInfo
 * @property {number} index The new target index.
 * @property {number} endIndex The new segment end index.
 */ /**
 * @type {TraceTargetUpdateInfo}
 */ const $ca31a7ccd09c3d1c$var$sharedUpdateInfo = {
    index: -1,
    endIndex: NaN
};
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The coordinate.
 * @param {TraceState} traceState The trace state.
 * @param {import("../Map.js").default} map The map.
 * @param {number} snapTolerance The snap tolerance.
 * @return {TraceTargetUpdateInfo} Information about the new trace target.  The returned
 * object is reused between calls and must not be modified by the caller.
 */ function $ca31a7ccd09c3d1c$var$getTraceTargetUpdate(coordinate, traceState, map, snapTolerance) {
    const x = coordinate[0];
    const y = coordinate[1];
    let closestTargetDistance = Infinity;
    let newTargetIndex = -1;
    let newEndIndex = NaN;
    for(let targetIndex = 0; targetIndex < traceState.targets.length; ++targetIndex){
        const target = traceState.targets[targetIndex];
        const coordinates = target.coordinates;
        let minSegmentDistance = Infinity;
        let endIndex;
        for(let coordinateIndex = 0; coordinateIndex < coordinates.length - 1; ++coordinateIndex){
            const start = coordinates[coordinateIndex];
            const end = coordinates[coordinateIndex + 1];
            const rel = $ca31a7ccd09c3d1c$var$getPointSegmentRelationship(x, y, start, end);
            if (rel.squaredDistance < minSegmentDistance) {
                minSegmentDistance = rel.squaredDistance;
                endIndex = coordinateIndex + rel.along;
            }
        }
        if (minSegmentDistance < closestTargetDistance) {
            closestTargetDistance = minSegmentDistance;
            if (target.ring && traceState.targetIndex === targetIndex) {
                // same target, maintain the same trace direction
                if (target.endIndex > target.startIndex) // forward trace
                {
                    if (endIndex < target.startIndex) endIndex += coordinates.length;
                } else if (target.endIndex < target.startIndex) // reverse trace
                {
                    if (endIndex > target.startIndex) endIndex -= coordinates.length;
                }
            }
            newEndIndex = endIndex;
            newTargetIndex = targetIndex;
        }
    }
    const newTarget = traceState.targets[newTargetIndex];
    let considerBothDirections = newTarget.ring;
    if (traceState.targetIndex === newTargetIndex && considerBothDirections) {
        // only consider switching trace direction if close to the start
        const newCoordinate = $ca31a7ccd09c3d1c$var$interpolateCoordinate(newTarget.coordinates, newEndIndex);
        const pixel = map.getPixelFromCoordinate(newCoordinate);
        if ((0, $8b28786758450fff$export$9f17032d917177de)(pixel, traceState.startPx) > snapTolerance) considerBothDirections = false;
    }
    if (considerBothDirections) {
        const coordinates = newTarget.coordinates;
        const count = coordinates.length;
        const startIndex = newTarget.startIndex;
        const endIndex = newEndIndex;
        if (startIndex < endIndex) {
            const forwardDistance = $ca31a7ccd09c3d1c$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const reverseDistance = $ca31a7ccd09c3d1c$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex - count);
            if (reverseDistance < forwardDistance) newEndIndex -= count;
        } else {
            const reverseDistance = $ca31a7ccd09c3d1c$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex);
            const forwardDistance = $ca31a7ccd09c3d1c$var$getCumulativeSquaredDistance(coordinates, startIndex, endIndex + count);
            if (forwardDistance < reverseDistance) newEndIndex += count;
        }
    }
    $ca31a7ccd09c3d1c$var$sharedUpdateInfo.index = newTargetIndex;
    $ca31a7ccd09c3d1c$var$sharedUpdateInfo.endIndex = newEndIndex;
    return $ca31a7ccd09c3d1c$var$sharedUpdateInfo;
}
/**
 * @param {import("../coordinate.js").Coordinate} coordinate The clicked coordinate.
 * @param {Array<import("../coordinate.js").Coordinate>} coordinates The geometry component coordinates.
 * @param {boolean} ring The coordinates represent a linear ring.
 * @param {Array<TraceTarget>} targets The trace targets.
 */ function $ca31a7ccd09c3d1c$var$appendTraceTarget(coordinate, coordinates, ring, targets) {
    const x = coordinate[0];
    const y = coordinate[1];
    for(let i = 0, ii = coordinates.length - 1; i < ii; ++i){
        const start = coordinates[i];
        const end = coordinates[i + 1];
        const rel = $ca31a7ccd09c3d1c$var$getPointSegmentRelationship(x, y, start, end);
        if (rel.squaredDistance === 0) {
            const index = i + rel.along;
            targets.push({
                coordinates: coordinates,
                ring: ring,
                startIndex: index,
                endIndex: index
            });
            return;
        }
    }
}
/**
 * @typedef {Object} PointSegmentRelationship
 * @property {number} along The closest point expressed as a fraction along the segment length.
 * @property {number} squaredDistance The squared distance of the point to the segment.
 */ /**
 * @type {PointSegmentRelationship}
 */ const $ca31a7ccd09c3d1c$var$sharedRel = {
    along: 0,
    squaredDistance: 0
};
/**
 * @param {number} x The point x.
 * @param {number} y The point y.
 * @param {import("../coordinate.js").Coordinate} start The segment start.
 * @param {import("../coordinate.js").Coordinate} end The segment end.
 * @return {PointSegmentRelationship} The point segment relationship.  The returned object is
 * shared between calls and must not be modified by the caller.
 */ function $ca31a7ccd09c3d1c$var$getPointSegmentRelationship(x, y, start, end) {
    const x1 = start[0];
    const y1 = start[1];
    const x2 = end[0];
    const y2 = end[1];
    const dx = x2 - x1;
    const dy = y2 - y1;
    let along = 0;
    let px = x1;
    let py = y1;
    if (dx !== 0 || dy !== 0) {
        along = (0, $d4e56cfc37d8b1f9$export$7d15b64cf5a3a4c4)(((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy), 0, 1);
        px += dx * along;
        py += dy * along;
    }
    $ca31a7ccd09c3d1c$var$sharedRel.along = along;
    $ca31a7ccd09c3d1c$var$sharedRel.squaredDistance = (0, $d4e56cfc37d8b1f9$export$a81f732198733497)((0, $d4e56cfc37d8b1f9$export$88e6ebb4fe54f538)(x, y, px, py), 10);
    return $ca31a7ccd09c3d1c$var$sharedRel;
}
/**
 * @param {LineCoordType} coordinates The coordinates.
 * @param {number} index The index.  May be fractional and may wrap.
 * @return {import("../coordinate.js").Coordinate} The interpolated coordinate.
 */ function $ca31a7ccd09c3d1c$var$interpolateCoordinate(coordinates, index) {
    const count = coordinates.length;
    let startIndex = Math.floor(index);
    const along = index - startIndex;
    if (startIndex >= count) startIndex -= count;
    else if (startIndex < 0) startIndex += count;
    let endIndex = startIndex + 1;
    if (endIndex >= count) endIndex -= count;
    const start = coordinates[startIndex];
    const x0 = start[0];
    const y0 = start[1];
    const end = coordinates[endIndex];
    const dx = end[0] - x0;
    const dy = end[1] - y0;
    return [
        x0 + dx * along,
        y0 + dy * along
    ];
}
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'drawabort'|'drawend'|'drawstart', DrawEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'drawabort'|'drawend'|'drawstart', Return>} DrawOnSignature
 */ /**
 * @classdesc
 * Interaction for drawing feature geometries.
 *
 * @fires DrawEvent
 * @api
 */ class $ca31a7ccd09c3d1c$var$Draw extends (0, $f4f64f356a570c0e$export$2e2bcd8739ae039) {
    /**
   * @param {Options} options Options.
   */ constructor(options){
        const pointerOptions = /** @type {import("./Pointer.js").Options} */ options;
        if (!pointerOptions.stopDown) pointerOptions.stopDown = (0, $de1052d9f293b73a$export$8f11cee4bdc7e668);
        super(pointerOptions);
        /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */ this.on;
        /***
     * @type {DrawOnSignature<import("../events").EventsKey>}
     */ this.once;
        /***
     * @type {DrawOnSignature<void>}
     */ this.un;
        /**
     * @type {boolean}
     * @private
     */ this.shouldHandle_ = false;
        /**
     * @type {import("../pixel.js").Pixel}
     * @private
     */ this.downPx_ = null;
        /**
     * @type {ReturnType<typeof setTimeout>}
     * @private
     */ this.downTimeout_;
        /**
     * @type {number|undefined}
     * @private
     */ this.lastDragTime_;
        /**
     * Pointer type of the last pointermove event
     * @type {string}
     * @private
     */ this.pointerType_;
        /**
     * @type {boolean}
     * @private
     */ this.freehand_ = false;
        /**
     * Target source for drawn features.
     * @type {VectorSource|null}
     * @private
     */ this.source_ = options.source ? options.source : null;
        /**
     * Target collection for drawn features.
     * @type {import("../Collection.js").default<Feature>|null}
     * @private
     */ this.features_ = options.features ? options.features : null;
        /**
     * Pixel distance for snapping.
     * @type {number}
     * @private
     */ this.snapTolerance_ = options.snapTolerance ? options.snapTolerance : 12;
        /**
     * Geometry type.
     * @type {import("../geom/Geometry.js").Type}
     * @private
     */ this.type_ = /** @type {import("../geom/Geometry.js").Type} */ options.type;
        /**
     * Drawing mode (derived from geometry type.
     * @type {Mode}
     * @private
     */ this.mode_ = $ca31a7ccd09c3d1c$var$getMode(this.type_);
        /**
     * Stop click, singleclick, and doubleclick events from firing during drawing.
     * Default is `false`.
     * @type {boolean}
     * @private
     */ this.stopClick_ = !!options.stopClick;
        /**
     * The number of points that must be drawn before a polygon ring or line
     * string can be finished.  The default is 3 for polygon rings and 2 for
     * line strings.
     * @type {number}
     * @private
     */ this.minPoints_ = options.minPoints ? options.minPoints : this.mode_ === 'Polygon' ? 3 : 2;
        /**
     * The number of points that can be drawn before a polygon ring or line string
     * is finished. The default is no restriction.
     * @type {number}
     * @private
     */ this.maxPoints_ = this.mode_ === 'Circle' ? 2 : options.maxPoints ? options.maxPoints : Infinity;
        /**
     * A function to decide if a potential finish coordinate is permissible
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.finishCondition_ = options.finishCondition ? options.finishCondition : (0, $de1052d9f293b73a$export$22e23a2304399231);
        /**
     * @private
     * @type {import("../geom/Geometry.js").GeometryLayout}
     */ this.geometryLayout_ = options.geometryLayout ? options.geometryLayout : 'XY';
        let geometryFunction = options.geometryFunction;
        if (!geometryFunction) {
            const mode = this.mode_;
            if (mode === 'Circle') /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                const circle = geometry ? /** @type {Circle} */ geometry : new (0, $a52bfbb6e6800da8$export$2e2bcd8739ae039)([
                    NaN,
                    NaN
                ]);
                const center = (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(coordinates[0], projection);
                const squaredLength = (0, $8b28786758450fff$export$88e6ebb4fe54f538)(center, (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(coordinates[coordinates.length - 1], projection));
                circle.setCenterAndRadius(center, Math.sqrt(squaredLength), this.geometryLayout_);
                const userProjection = (0, $92f1443438429e81$export$3973b77d5f6f2790)();
                if (userProjection) circle.transform(projection, userProjection);
                return circle;
            };
            else {
                let Constructor;
                if (mode === 'Point') Constructor = (0, $f7e297e9f8b90024$export$2e2bcd8739ae039);
                else if (mode === 'LineString') Constructor = (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039);
                else if (mode === 'Polygon') Constructor = (0, $46a66e0f2fc72479$export$2e2bcd8739ae039);
                /**
         * @param {!LineCoordType} coordinates The coordinates.
         * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
         * @param {import("../proj/Projection.js").default} projection The view projection.
         * @return {import("../geom/SimpleGeometry.js").default} A geometry.
         */ geometryFunction = (coordinates, geometry, projection)=>{
                    if (geometry) {
                        if (mode === 'Polygon') {
                            if (coordinates[0].length) // Add a closing coordinate to match the first
                            geometry.setCoordinates([
                                coordinates[0].concat([
                                    coordinates[0][0]
                                ])
                            ], this.geometryLayout_);
                            else geometry.setCoordinates([], this.geometryLayout_);
                        } else geometry.setCoordinates(coordinates, this.geometryLayout_);
                    } else geometry = new Constructor(coordinates, this.geometryLayout_);
                    return geometry;
                };
            }
        }
        /**
     * @type {GeometryFunction}
     * @private
     */ this.geometryFunction_ = geometryFunction;
        /**
     * @type {number}
     * @private
     */ this.dragVertexDelay_ = options.dragVertexDelay !== undefined ? options.dragVertexDelay : 500;
        /**
     * Finish coordinate for the feature (first point for polygons, last point for
     * linestrings).
     * @type {import("../coordinate.js").Coordinate}
     * @private
     */ this.finishCoordinate_ = null;
        /**
     * Sketch feature.
     * @type {Feature<import('../geom/SimpleGeometry.js').default>}
     * @private
     */ this.sketchFeature_ = null;
        /**
     * Sketch point.
     * @type {Feature<Point>}
     * @private
     */ this.sketchPoint_ = null;
        /**
     * Sketch coordinates. Used when drawing a line or polygon.
     * @type {SketchCoordType}
     * @private
     */ this.sketchCoords_ = null;
        /**
     * Sketch line. Used when drawing polygon.
     * @type {Feature<LineString>}
     * @private
     */ this.sketchLine_ = null;
        /**
     * Sketch line coordinates. Used when drawing a polygon or circle.
     * @type {LineCoordType}
     * @private
     */ this.sketchLineCoords_ = null;
        /**
     * Squared tolerance for handling up events.  If the squared distance
     * between a down and up event is greater than this tolerance, up events
     * will not be handled.
     * @type {number}
     * @private
     */ this.squaredClickTolerance_ = options.clickTolerance ? options.clickTolerance * options.clickTolerance : 36;
        /**
     * Draw overlay where our sketch features are drawn.
     * @type {VectorLayer}
     * @private
     */ this.overlay_ = new (0, $09432eee05d1671f$export$2e2bcd8739ae039)({
            source: new (0, $69f8886165740064$export$2e2bcd8739ae039)({
                useSpatialIndex: false,
                wrapX: options.wrapX ? options.wrapX : false
            }),
            style: options.style ? options.style : $ca31a7ccd09c3d1c$var$getDefaultStyleFunction(),
            updateWhileInteracting: true
        });
        /**
     * Name of the geometry attribute for newly created features.
     * @type {string|undefined}
     * @private
     */ this.geometryName_ = options.geometryName;
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.condition_ = options.condition ? options.condition : (0, $2083adc1400fd9db$export$fdc892d0d8fe3bfb);
        /**
     * @private
     * @type {import("../events/condition.js").Condition}
     */ this.freehandCondition_;
        if (options.freehand) this.freehandCondition_ = (0, $2083adc1400fd9db$export$ba9e5d519bc326ca);
        else this.freehandCondition_ = options.freehandCondition ? options.freehandCondition : (0, $2083adc1400fd9db$export$5d31fe68a477cfbb);
        /**
     * @type {import("../events/condition.js").Condition}
     * @private
     */ this.traceCondition_;
        this.setTrace(options.trace || false);
        /**
     * @type {TraceState}
     * @private
     */ this.traceState_ = {
            active: false
        };
        /**
     * @type {VectorSource|null}
     * @private
     */ this.traceSource_ = options.traceSource || options.source || null;
        this.addChangeListener((0, $066074cf84cc0514$export$2e2bcd8739ae039).ACTIVE, this.updateState_);
    }
    /**
   * Toggle tracing mode or set a tracing condition.
   *
   * @param {boolean|import("../events/condition.js").Condition} trace A boolean to toggle tracing mode or an event
   *     condition that will be checked when a feature is clicked to determine if tracing should be active.
   */ setTrace(trace) {
        let condition;
        if (!trace) condition = (0, $2083adc1400fd9db$export$b3e22bcfd64c1022);
        else if (trace === true) condition = (0, $2083adc1400fd9db$export$ba9e5d519bc326ca);
        else condition = trace;
        this.traceCondition_ = condition;
    }
    /**
   * Remove the interaction from its current map and attach it to the new map.
   * Subclasses may set up event handlers to get notified about changes to
   * the map here.
   * @param {import("../Map.js").default} map Map.
   * @override
   */ setMap(map) {
        super.setMap(map);
        this.updateState_();
    }
    /**
   * Get the overlay layer that this interaction renders sketch features to.
   * @return {VectorLayer} Overlay layer.
   * @api
   */ getOverlay() {
        return this.overlay_;
    }
    /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may actually draw or finish the drawing.
   * @param {import("../MapBrowserEvent.js").default} event Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   * @override
   */ handleEvent(event) {
        if (event.originalEvent.type === (0, $6a4d89c0e1a6605f$export$2e2bcd8739ae039).CONTEXTMENU) // Avoid context menu for long taps when drawing on mobile
        event.originalEvent.preventDefault();
        this.freehand_ = this.mode_ !== 'Point' && this.freehandCondition_(event);
        let move = event.type === (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERMOVE;
        let pass = true;
        if (!this.freehand_ && this.lastDragTime_ && event.type === (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDRAG) {
            const now = Date.now();
            if (now - this.lastDragTime_ >= this.dragVertexDelay_) {
                this.downPx_ = event.pixel;
                this.shouldHandle_ = !this.freehand_;
                move = true;
            } else this.lastDragTime_ = undefined;
            if (this.shouldHandle_ && this.downTimeout_ !== undefined) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
        }
        if (this.freehand_ && event.type === (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDRAG && this.sketchFeature_ !== null) {
            this.addToDrawing_(event.coordinate);
            pass = false;
        } else if (this.freehand_ && event.type === (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDOWN) pass = false;
        else if (move && this.getPointerCount() < 2) {
            pass = event.type === (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERMOVE;
            if (pass && this.freehand_) {
                this.handlePointerMove_(event);
                if (this.shouldHandle_) // Avoid page scrolling when freehand drawing on mobile
                event.originalEvent.preventDefault();
            } else if (event.originalEvent.pointerType === 'mouse' || event.type === (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERDRAG && this.downTimeout_ === undefined) this.handlePointerMove_(event);
        } else if (event.type === (0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).DBLCLICK) pass = false;
        return super.handleEvent(event) && pass;
    }
    /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleDownEvent(event) {
        this.shouldHandle_ = !this.freehand_;
        if (this.freehand_) {
            this.downPx_ = event.pixel;
            if (!this.finishCoordinate_) this.startDrawing_(event.coordinate);
            return true;
        }
        if (!this.condition_(event)) {
            this.lastDragTime_ = undefined;
            return false;
        }
        this.lastDragTime_ = Date.now();
        this.downTimeout_ = setTimeout(()=>{
            this.handlePointerMove_(new (0, $f924e5a83a2737ce$export$2e2bcd8739ae039)((0, $4d29e2d9bc8184b4$export$2e2bcd8739ae039).POINTERMOVE, event.map, event.originalEvent, false, event.frameState));
        }, this.dragVertexDelay_);
        this.downPx_ = event.pixel;
        return true;
    }
    /**
   * @private
   */ deactivateTrace_() {
        this.traceState_ = {
            active: false
        };
    }
    /**
   * Activate or deactivate trace state based on a browser event.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ toggleTraceState_(event) {
        if (!this.traceSource_ || !this.traceCondition_(event)) return;
        if (this.traceState_.active) {
            this.deactivateTrace_();
            return;
        }
        const map = this.getMap();
        const lowerLeft = map.getCoordinateFromPixel([
            event.pixel[0] - this.snapTolerance_,
            event.pixel[1] + this.snapTolerance_
        ]);
        const upperRight = map.getCoordinateFromPixel([
            event.pixel[0] + this.snapTolerance_,
            event.pixel[1] - this.snapTolerance_
        ]);
        const extent = (0, $7e819822b33b3d32$export$8aceca7c77505534)([
            lowerLeft,
            upperRight
        ]);
        const features = this.traceSource_.getFeaturesInExtent(extent);
        if (features.length === 0) return;
        const targets = $ca31a7ccd09c3d1c$var$getTraceTargets(event.coordinate, features);
        if (targets.length) this.traceState_ = {
            active: true,
            startPx: event.pixel.slice(),
            targets: targets,
            targetIndex: -1
        };
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} endIndex The new end index of the trace.
   * @private
   */ addOrRemoveTracedCoordinates_(target, endIndex) {
        // three cases to handle:
        //  1. traced in the same direction and points need adding
        //  2. traced in the same direction and points need removing
        //  3. traced in a new direction
        const previouslyForward = target.startIndex <= target.endIndex;
        const currentlyForward = target.startIndex <= endIndex;
        if (previouslyForward === currentlyForward) {
            // same direction
            if (previouslyForward && endIndex > target.endIndex || !previouslyForward && endIndex < target.endIndex) // case 1 - add new points
            this.addTracedCoordinates_(target, target.endIndex, endIndex);
            else if (previouslyForward && endIndex < target.endIndex || !previouslyForward && endIndex > target.endIndex) // case 2 - remove old points
            this.removeTracedCoordinates_(endIndex, target.endIndex);
        } else {
            // case 3 - remove old points, add new points
            this.removeTracedCoordinates_(target.startIndex, target.endIndex);
            this.addTracedCoordinates_(target, target.startIndex, endIndex);
        }
    }
    /**
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ removeTracedCoordinates_(fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        let remove = 0;
        if (fromIndex < toIndex) {
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) end -= 1;
            remove = end - start + 1;
        } else {
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            remove = start - end + 1;
        }
        if (remove > 0) this.removeLastPoints_(remove);
    }
    /**
   * @param {TraceTarget} target The trace target.
   * @param {number} fromIndex The start index.
   * @param {number} toIndex The end index.
   * @private
   */ addTracedCoordinates_(target, fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        const coordinates = [];
        if (fromIndex < toIndex) {
            // forward trace
            const start = Math.ceil(fromIndex);
            let end = Math.floor(toIndex);
            if (end === toIndex) // if end is snapped to a vertex, it will be added later
            end -= 1;
            for(let i = start; i <= end; ++i)coordinates.push($ca31a7ccd09c3d1c$var$getCoordinate(target.coordinates, i));
        } else {
            // reverse trace
            const start = Math.floor(fromIndex);
            let end = Math.ceil(toIndex);
            if (end === toIndex) end += 1;
            for(let i = start; i >= end; --i)coordinates.push($ca31a7ccd09c3d1c$var$getCoordinate(target.coordinates, i));
        }
        if (coordinates.length) this.appendCoordinates(coordinates);
    }
    /**
   * Update the trace.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @private
   */ updateTrace_(event) {
        const traceState = this.traceState_;
        if (!traceState.active) return;
        if (traceState.targetIndex === -1) {
            // check if we are ready to pick a target
            if ((0, $8b28786758450fff$export$9f17032d917177de)(traceState.startPx, event.pixel) < this.snapTolerance_) return;
        }
        const updatedTraceTarget = $ca31a7ccd09c3d1c$var$getTraceTargetUpdate(event.coordinate, traceState, this.getMap(), this.snapTolerance_);
        if (traceState.targetIndex !== updatedTraceTarget.index) {
            // target changed
            if (traceState.targetIndex !== -1) {
                // remove points added during previous trace
                const oldTarget = traceState.targets[traceState.targetIndex];
                this.removeTracedCoordinates_(oldTarget.startIndex, oldTarget.endIndex);
            }
            // add points for the new target
            const newTarget = traceState.targets[updatedTraceTarget.index];
            this.addTracedCoordinates_(newTarget, newTarget.startIndex, updatedTraceTarget.endIndex);
        } else {
            // target stayed the same
            const target = traceState.targets[traceState.targetIndex];
            this.addOrRemoveTracedCoordinates_(target, updatedTraceTarget.endIndex);
        }
        // modify the state with updated info
        traceState.targetIndex = updatedTraceTarget.index;
        const target = traceState.targets[traceState.targetIndex];
        target.endIndex = updatedTraceTarget.endIndex;
        // update event coordinate and pixel to match end point of final segment
        const coordinate = $ca31a7ccd09c3d1c$var$interpolateCoordinate(target.coordinates, target.endIndex);
        const pixel = this.getMap().getPixelFromCoordinate(coordinate);
        event.coordinate = coordinate;
        event.pixel = [
            Math.round(pixel[0]),
            Math.round(pixel[1])
        ];
    }
    /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} event Event.
   * @return {boolean} If the event was consumed.
   * @override
   */ handleUpEvent(event) {
        let pass = true;
        if (this.getPointerCount() === 0) {
            if (this.downTimeout_) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
            this.handlePointerMove_(event);
            const tracing = this.traceState_.active;
            this.toggleTraceState_(event);
            if (this.shouldHandle_) {
                const startingToDraw = !this.finishCoordinate_;
                if (startingToDraw) this.startDrawing_(event.coordinate);
                if (!startingToDraw && this.freehand_) this.finishDrawing();
                else if (!this.freehand_ && (!startingToDraw || this.mode_ === 'Point')) {
                    if (this.atFinish_(event.pixel, tracing)) {
                        if (this.finishCondition_(event)) this.finishDrawing();
                    } else this.addToDrawing_(event.coordinate);
                }
                pass = false;
            } else if (this.freehand_) this.abortDrawing();
        }
        if (!pass && this.stopClick_) event.preventDefault();
        return pass;
    }
    /**
   * Handle move events.
   * @param {import("../MapBrowserEvent.js").default} event A move event.
   * @private
   */ handlePointerMove_(event) {
        this.pointerType_ = event.originalEvent.pointerType;
        if (this.downPx_ && (!this.freehand_ && this.shouldHandle_ || this.freehand_ && !this.shouldHandle_)) {
            const downPx = this.downPx_;
            const clickPx = event.pixel;
            const dx = downPx[0] - clickPx[0];
            const dy = downPx[1] - clickPx[1];
            const squaredDistance = dx * dx + dy * dy;
            this.shouldHandle_ = this.freehand_ ? squaredDistance > this.squaredClickTolerance_ : squaredDistance <= this.squaredClickTolerance_;
            if (!this.shouldHandle_) return;
        }
        if (!this.finishCoordinate_) {
            this.createOrUpdateSketchPoint_(event.coordinate.slice());
            return;
        }
        this.updateTrace_(event);
        this.modifyDrawing_(event.coordinate);
    }
    /**
   * Determine if an event is within the snapping tolerance of the start coord.
   * @param {import("../pixel.js").Pixel} pixel Pixel.
   * @param {boolean} [tracing] Drawing in trace mode (only stop if at the starting point).
   * @return {boolean} The event is within the snapping tolerance of the start.
   * @private
   */ atFinish_(pixel, tracing) {
        let at = false;
        if (this.sketchFeature_) {
            let potentiallyDone = false;
            let potentiallyFinishCoordinates = [
                this.finishCoordinate_
            ];
            const mode = this.mode_;
            if (mode === 'Point') at = true;
            else if (mode === 'Circle') at = this.sketchCoords_.length === 2;
            else if (mode === 'LineString') potentiallyDone = !tracing && this.sketchCoords_.length > this.minPoints_;
            else if (mode === 'Polygon') {
                const sketchCoords = /** @type {PolyCoordType} */ this.sketchCoords_;
                potentiallyDone = sketchCoords[0].length > this.minPoints_;
                potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
                if (tracing) potentiallyFinishCoordinates = [
                    sketchCoords[0][0]
                ];
                else potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2]
                ];
            }
            if (potentiallyDone) {
                const map = this.getMap();
                for(let i = 0, ii = potentiallyFinishCoordinates.length; i < ii; i++){
                    const finishCoordinate = potentiallyFinishCoordinates[i];
                    const finishPixel = map.getPixelFromCoordinate(finishCoordinate);
                    const dx = pixel[0] - finishPixel[0];
                    const dy = pixel[1] - finishPixel[1];
                    const snapTolerance = this.freehand_ ? 1 : this.snapTolerance_;
                    at = Math.sqrt(dx * dx + dy * dy) <= snapTolerance;
                    if (at) {
                        this.finishCoordinate_ = finishCoordinate;
                        break;
                    }
                }
            }
        }
        return at;
    }
    /**
   * @param {import("../coordinate").Coordinate} coordinates Coordinate.
   * @private
   */ createOrUpdateSketchPoint_(coordinates) {
        if (!this.sketchPoint_) {
            this.sketchPoint_ = new (0, $1171fbd986f3130c$export$2e2bcd8739ae039)(new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)(coordinates));
            this.updateSketchFeatures_();
        } else {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinates);
        }
    }
    /**
   * @param {import("../geom/Polygon.js").default} geometry Polygon geometry.
   * @private
   */ createOrUpdateCustomSketchLine_(geometry) {
        if (!this.sketchLine_) this.sketchLine_ = new (0, $1171fbd986f3130c$export$2e2bcd8739ae039)();
        const ring = geometry.getLinearRing(0);
        let sketchLineGeom = this.sketchLine_.getGeometry();
        if (!sketchLineGeom) {
            sketchLineGeom = new (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039)(ring.getFlatCoordinates(), ring.getLayout());
            this.sketchLine_.setGeometry(sketchLineGeom);
        } else {
            sketchLineGeom.setFlatCoordinates(ring.getLayout(), ring.getFlatCoordinates());
            sketchLineGeom.changed();
        }
    }
    /**
   * Start the drawing.
   * @param {import("../coordinate.js").Coordinate} start Start coordinate.
   * @private
   */ startDrawing_(start) {
        const projection = this.getMap().getView().getProjection();
        const stride = (0, $ce25558341ea2841$export$6af0c1b4a8549a43)(this.geometryLayout_);
        while(start.length < stride)start.push(0);
        this.finishCoordinate_ = start;
        if (this.mode_ === 'Point') this.sketchCoords_ = start.slice();
        else if (this.mode_ === 'Polygon') {
            this.sketchCoords_ = [
                [
                    start.slice(),
                    start.slice()
                ]
            ];
            this.sketchLineCoords_ = this.sketchCoords_[0];
        } else this.sketchCoords_ = [
            start.slice(),
            start.slice()
        ];
        if (this.sketchLineCoords_) this.sketchLine_ = new (0, $1171fbd986f3130c$export$2e2bcd8739ae039)(new (0, $a2c21eb98d0bd63f$export$2e2bcd8739ae039)(this.sketchLineCoords_));
        const geometry = this.geometryFunction_(this.sketchCoords_, undefined, projection);
        this.sketchFeature_ = new (0, $1171fbd986f3130c$export$2e2bcd8739ae039)();
        if (this.geometryName_) this.sketchFeature_.setGeometryName(this.geometryName_);
        this.sketchFeature_.setGeometry(geometry);
        this.updateSketchFeatures_();
        this.dispatchEvent(new $ca31a7ccd09c3d1c$export$85a4910380d251a7($ca31a7ccd09c3d1c$var$DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Modify the drawing.
   * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
   * @private
   */ modifyDrawing_(coordinate) {
        const map = this.getMap();
        const geometry = this.sketchFeature_.getGeometry();
        const projection = map.getView().getProjection();
        const stride = (0, $ce25558341ea2841$export$6af0c1b4a8549a43)(this.geometryLayout_);
        let coordinates, last;
        while(coordinate.length < stride)coordinate.push(0);
        if (this.mode_ === 'Point') last = this.sketchCoords_;
        else if (this.mode_ === 'Polygon') {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            last = coordinates[coordinates.length - 1];
            if (this.atFinish_(map.getPixelFromCoordinate(coordinate))) // snap to finish
            coordinate = this.finishCoordinate_.slice();
        } else {
            coordinates = this.sketchCoords_;
            last = coordinates[coordinates.length - 1];
        }
        last[0] = coordinate[0];
        last[1] = coordinate[1];
        this.geometryFunction_(/** @type {!LineCoordType} */ this.sketchCoords_, geometry, projection);
        if (this.sketchPoint_) {
            const sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinate);
        }
        if (geometry.getType() === 'Polygon' && this.mode_ !== 'Polygon') this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
        else if (this.sketchLineCoords_) {
            const sketchLineGeom = this.sketchLine_.getGeometry();
            sketchLineGeom.setCoordinates(this.sketchLineCoords_);
        }
        this.updateSketchFeatures_();
    }
    /**
   * Add a new coordinate to the drawing.
   * @param {!PointCoordType} coordinate Coordinate
   * @return {Feature<import("../geom/SimpleGeometry.js").default>} The sketch feature.
   * @private
   */ addToDrawing_(coordinate) {
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        let done;
        let coordinates;
        const mode = this.mode_;
        if (mode === 'LineString' || mode === 'Circle') {
            this.finishCoordinate_ = coordinate.slice();
            coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (mode === 'Polygon') {
            coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) coordinates.pop();
                else done = true;
            }
            coordinates.push(coordinate.slice());
            if (done) this.finishCoordinate_ = coordinates[0];
            this.geometryFunction_(this.sketchCoords_, geometry, projection);
        }
        this.createOrUpdateSketchPoint_(coordinate.slice());
        this.updateSketchFeatures_();
        if (done) return this.finishDrawing();
        return this.sketchFeature_;
    }
    /**
   * @param {number} n The number of points to remove.
   */ removeLastPoints_(n) {
        if (!this.sketchFeature_) return;
        const geometry = this.sketchFeature_.getGeometry();
        const projection = this.getMap().getView().getProjection();
        const mode = this.mode_;
        for(let i = 0; i < n; ++i){
            let coordinates;
            if (mode === 'LineString' || mode === 'Circle') {
                coordinates = /** @type {LineCoordType} */ this.sketchCoords_;
                coordinates.splice(-2, 1);
                if (coordinates.length >= 2) {
                    this.finishCoordinate_ = coordinates[coordinates.length - 2].slice();
                    const finishCoordinate = this.finishCoordinate_.slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                this.geometryFunction_(coordinates, geometry, projection);
                if (geometry.getType() === 'Polygon' && this.sketchLine_) this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ geometry);
            } else if (mode === 'Polygon') {
                coordinates = /** @type {PolyCoordType} */ this.sketchCoords_[0];
                coordinates.splice(-2, 1);
                const sketchLineGeom = this.sketchLine_.getGeometry();
                if (coordinates.length >= 2) {
                    const finishCoordinate = coordinates[coordinates.length - 2].slice();
                    coordinates[coordinates.length - 1] = finishCoordinate;
                    this.createOrUpdateSketchPoint_(finishCoordinate);
                }
                sketchLineGeom.setCoordinates(coordinates);
                this.geometryFunction_(this.sketchCoords_, geometry, projection);
            }
            if (coordinates.length === 1) {
                this.abortDrawing();
                break;
            }
        }
        this.updateSketchFeatures_();
    }
    /**
   * Remove last point of the feature currently being drawn. Does not do anything when
   * drawing POINT or MULTI_POINT geometries.
   * @api
   */ removeLastPoint() {
        this.removeLastPoints_(1);
    }
    /**
   * Stop drawing and add the sketch feature to the target layer.
   * The {@link module:ol/interaction/Draw~DrawEventType.DRAWEND} event is
   * dispatched before inserting the feature.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The drawn feature.
   * @api
   */ finishDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (!sketchFeature) return null;
        let coordinates = this.sketchCoords_;
        const geometry = sketchFeature.getGeometry();
        const projection = this.getMap().getView().getProjection();
        if (this.mode_ === 'LineString') {
            // remove the redundant last point
            coordinates.pop();
            this.geometryFunction_(coordinates, geometry, projection);
        } else if (this.mode_ === 'Polygon') {
            // remove the redundant last point in ring
            /** @type {PolyCoordType} */ coordinates[0].pop();
            this.geometryFunction_(coordinates, geometry, projection);
            coordinates = geometry.getCoordinates();
        }
        // cast multi-part geometries
        if (this.type_ === 'MultiPoint') sketchFeature.setGeometry(new (0, $760306f0926782cd$export$2e2bcd8739ae039)([
            /** @type {PointCoordType} */ coordinates
        ]));
        else if (this.type_ === 'MultiLineString') sketchFeature.setGeometry(new (0, $977a2295e90f3a11$export$2e2bcd8739ae039)([
            /** @type {LineCoordType} */ coordinates
        ]));
        else if (this.type_ === 'MultiPolygon') sketchFeature.setGeometry(new (0, $181e07a3c0063616$export$2e2bcd8739ae039)([
            /** @type {PolyCoordType} */ coordinates
        ]));
        // First dispatch event to allow full set up of feature
        this.dispatchEvent(new $ca31a7ccd09c3d1c$export$85a4910380d251a7($ca31a7ccd09c3d1c$var$DrawEventType.DRAWEND, sketchFeature));
        // Then insert feature
        if (this.features_) this.features_.push(sketchFeature);
        if (this.source_) this.source_.addFeature(sketchFeature);
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @return {Feature<import("../geom/SimpleGeometry.js").default>|null} The sketch feature (or null if none).
   * @private
   */ abortDrawing_() {
        this.finishCoordinate_ = null;
        const sketchFeature = this.sketchFeature_;
        this.sketchFeature_ = null;
        this.sketchPoint_ = null;
        this.sketchLine_ = null;
        this.overlay_.getSource().clear(true);
        this.deactivateTrace_();
        return sketchFeature;
    }
    /**
   * Stop drawing without adding the sketch feature to the target layer.
   * @api
   */ abortDrawing() {
        const sketchFeature = this.abortDrawing_();
        if (sketchFeature) this.dispatchEvent(new $ca31a7ccd09c3d1c$export$85a4910380d251a7($ca31a7ccd09c3d1c$var$DrawEventType.DRAWABORT, sketchFeature));
    }
    /**
   * Append coordinates to the end of the geometry that is currently being drawn.
   * This can be used when drawing LineStrings or Polygons. Coordinates will
   * either be appended to the current LineString or the outer ring of the current
   * Polygon. If no geometry is being drawn, a new one will be created.
   * @param {!LineCoordType} coordinates Linear coordinates to be appended to
   * the coordinate array.
   * @api
   */ appendCoordinates(coordinates) {
        const mode = this.mode_;
        const newDrawing = !this.sketchFeature_;
        if (newDrawing) this.startDrawing_(coordinates[0]);
        /** @type {LineCoordType} */ let sketchCoords;
        if (mode === 'LineString' || mode === 'Circle') sketchCoords = /** @type {LineCoordType} */ this.sketchCoords_;
        else if (mode === 'Polygon') sketchCoords = this.sketchCoords_ && this.sketchCoords_.length ? /** @type {PolyCoordType} */ this.sketchCoords_[0] : [];
        else return;
        if (newDrawing) sketchCoords.shift();
        // Remove last coordinate from sketch drawing (this coordinate follows cursor position)
        sketchCoords.pop();
        // Append coordinate list
        for(let i = 0; i < coordinates.length; i++)this.addToDrawing_(coordinates[i]);
        const ending = coordinates[coordinates.length - 1];
        // Duplicate last coordinate for sketch drawing (cursor position)
        this.sketchFeature_ = this.addToDrawing_(ending);
        this.modifyDrawing_(ending);
    }
    /**
   * Initiate draw mode by starting from an existing geometry which will
   * receive new additional points. This only works on features with
   * `LineString` geometries, where the interaction will extend lines by adding
   * points to the end of the coordinates array.
   * This will change the original feature, instead of drawing a copy.
   *
   * The function will dispatch a `drawstart` event.
   *
   * @param {!Feature<LineString>} feature Feature to be extended.
   * @api
   */ extend(feature) {
        const geometry = feature.getGeometry();
        const lineString = geometry;
        this.sketchFeature_ = feature;
        this.sketchCoords_ = lineString.getCoordinates();
        const last = this.sketchCoords_[this.sketchCoords_.length - 1];
        this.finishCoordinate_ = last.slice();
        this.sketchCoords_.push(last.slice());
        this.sketchPoint_ = new (0, $1171fbd986f3130c$export$2e2bcd8739ae039)(new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)(last));
        this.updateSketchFeatures_();
        this.dispatchEvent(new $ca31a7ccd09c3d1c$export$85a4910380d251a7($ca31a7ccd09c3d1c$var$DrawEventType.DRAWSTART, this.sketchFeature_));
    }
    /**
   * Redraw the sketch features.
   * @private
   */ updateSketchFeatures_() {
        const sketchFeatures = [];
        if (this.sketchFeature_) sketchFeatures.push(this.sketchFeature_);
        if (this.sketchLine_) sketchFeatures.push(this.sketchLine_);
        if (this.sketchPoint_) sketchFeatures.push(this.sketchPoint_);
        const overlaySource = this.overlay_.getSource();
        overlaySource.clear(true);
        overlaySource.addFeatures(sketchFeatures);
    }
    /**
   * @private
   */ updateState_() {
        const map = this.getMap();
        const active = this.getActive();
        if (!map || !active) this.abortDrawing();
        this.overlay_.setMap(active ? map : null);
    }
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */ function $ca31a7ccd09c3d1c$var$getDefaultStyleFunction() {
    const styles = (0, $0f1ce378ea6946fc$export$ed1eaede5d0e77ac)();
    return function(feature, resolution) {
        return styles[feature.getGeometry().getType()];
    };
}
function $ca31a7ccd09c3d1c$export$e636e17021965266(sides, angle) {
    return function(coordinates, geometry, projection) {
        const center = (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(/** @type {LineCoordType} */ coordinates[0], projection);
        const end = (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(/** @type {LineCoordType} */ coordinates[coordinates.length - 1], projection);
        const radius = Math.sqrt((0, $8b28786758450fff$export$88e6ebb4fe54f538)(center, end));
        geometry = geometry || (0, $46a66e0f2fc72479$export$2451009d645fb8c2)(new (0, $a52bfbb6e6800da8$export$2e2bcd8739ae039)(center), sides);
        let internalAngle = angle;
        if (!angle && angle !== 0) {
            const x = end[0] - center[0];
            const y = end[1] - center[1];
            internalAngle = Math.atan2(y, x);
        }
        (0, $46a66e0f2fc72479$export$87d6a1539a56e47f)(/** @type {Polygon} */ geometry, center, radius, internalAngle);
        const userProjection = (0, $92f1443438429e81$export$3973b77d5f6f2790)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
function $ca31a7ccd09c3d1c$export$6459fc9e86be362e() {
    return function(coordinates, geometry, projection) {
        const extent = (0, $7e819822b33b3d32$export$8aceca7c77505534)(/** @type {LineCoordType} */ [
            coordinates[0],
            coordinates[coordinates.length - 1]
        ].map(function(coordinate) {
            return (0, $92f1443438429e81$export$d4b8ec0b96db1ee2)(coordinate, projection);
        }));
        const boxCoordinates = [
            [
                (0, $7e819822b33b3d32$export$8d09f5e2e1bf560d)(extent),
                (0, $7e819822b33b3d32$export$e77c1cf70445e168)(extent),
                (0, $7e819822b33b3d32$export$b84fa077c8b05295)(extent),
                (0, $7e819822b33b3d32$export$cb1538b07e6964ff)(extent),
                (0, $7e819822b33b3d32$export$8d09f5e2e1bf560d)(extent)
            ]
        ];
        if (geometry) geometry.setCoordinates(boxCoordinates);
        else geometry = new (0, $46a66e0f2fc72479$export$2e2bcd8739ae039)(boxCoordinates);
        const userProjection = (0, $92f1443438429e81$export$3973b77d5f6f2790)();
        if (userProjection) geometry.transform(projection, userProjection);
        return geometry;
    };
}
/**
 * Get the drawing mode.  The mode for multi-part geometries is the same as for
 * their single-part cousins.
 * @param {import("../geom/Geometry.js").Type} type Geometry type.
 * @return {Mode} Drawing mode.
 */ function $ca31a7ccd09c3d1c$var$getMode(type) {
    switch(type){
        case 'Point':
        case 'MultiPoint':
            return 'Point';
        case 'LineString':
        case 'MultiLineString':
            return 'LineString';
        case 'Polygon':
        case 'MultiPolygon':
            return 'Polygon';
        case 'Circle':
            return 'Circle';
        default:
            throw new Error('Invalid type: ' + type);
    }
}
var $ca31a7ccd09c3d1c$export$2e2bcd8739ae039 = $ca31a7ccd09c3d1c$var$Draw;


















class $aeaaa177973849d7$export$371833ac55d444da extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Dropdown id
     * @param label {String} A main lable for the whole list (can be an HTML element)
     * @param optionsList {AbstractOptionList} A list of option values
     */ constructor(translator, isMobileDevice, id, label, optionsList){
        super(id, translator, isMobileDevice, undefined, undefined);
        this.optionsList = optionsList.onChange(()=>this._updateLabel()).onChangeAvailableValues(()=>this._updateLabel());
        this.label = label;
    }
    getClassName() {
        return "MultiOptionList";
    }
    _updateLabel() {
        const value = this.optionsList.getValue();
        $dc57b31f1b066f38$exports('.multi-options-list-label label', this.uiElement).html(this.label + ' ({0}/{1})'.format([
            value ? Array.isArray(value) ? '' + value.length : '1' : '0',
            this.optionsList.getMaxSelectable() + ''
        ]));
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div class="multi-options-list">   <div class="multi-options-list-label"><label></label></div>   <div class="multi-options-list-container"><div class="top"></div><div class="bottom"></div></div></div>').attr('id', this.id);
            this._updateLabel();
            this.optionsList.getUIElement().insertAfter($dc57b31f1b066f38$exports('.multi-options-list-container .top', this.uiElement));
        }
        return this.uiElement;
    }
}
class $aeaaa177973849d7$export$d18978d1758b033f extends (0, $9a87c76e274c7738$export$f03163d7279986d4) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Dropdown id
     * @param values {Array<String>} A list of option values
     * @param labels {Array<String>} A list of option labels (can be an HTML element)
     * @param initialValue {string} The initial value
     * @param mandatory {boolean} Is it mandatory to choose a value?
     * @param onChange {function} A callback to be called when the value changes
     */ constructor(translator, isMobileDevice, id, values, labels, initialValue, mandatory, onChange){
        super(id, translator, isMobileDevice, undefined, undefined);
        this.value = initialValue;
        this.values = values.slice();
        this.labels = labels.slice();
        this.mandatory = mandatory;
        this.disabledValues = [];
        this.onChangeAvailableValuesCallbacks = new Set();
        this.onChangeCallbacks = new Set();
        this.onChange(onChange);
    }
    getMaxSelectable() {
        return this.getPossibleValues().length;
    }
    onChangeAvailableValues(callback) {
        if (callback) this.onChangeAvailableValuesCallbacks.add(callback);
        return this;
    }
    disableValues(values2Disable) {
        $dc57b31f1b066f38$exports("input, label", this.uiElement).removeAttr('disabled').removeClass('disabled');
        values2Disable.forEach((v)=>$dc57b31f1b066f38$exports("input[value='" + v + "']", this.uiElement).attr('disabled', 'disabled').addClass('disabled'));
        values2Disable.forEach((v)=>$dc57b31f1b066f38$exports("label[val='" + v + "']", this.uiElement).addClass('disabled'));
        this.disabledValues = values2Disable;
        this.onChangeAvailableValuesCallbacks.forEach((c)=>c());
        return this;
    }
    getPossibleValues() {
        return this.values.filter((v)=>this.disabledValues.indexOf(v) < 0);
    }
    getCode() {
        return this.id;
    }
    getUIElement() {}
    onChange(callback) {
        if (callback) this.onChangeCallbacks.add(callback);
        return this;
    }
    /**
     * Get current value
     * @return {string}
     */ getValue() {
        return this.value;
    }
    /**
     * Set the value
     * @param value {string}
     */ setValue(value) {
        this._setValue(value, true);
        return this;
    }
    _setValue(value, triggerOnChange) {}
}


/**
 * A set of checkboxes
 * @extends UIElement
 */ class $44aebe8483a8dd97$export$3e0571e35758f2b7 extends (0, $aeaaa177973849d7$export$d18978d1758b033f) {
    /**
     *
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param id {string} Dropdown id
     * @param values {Array<String>} A list of option values
     * @param labels {Array<String>} A list of option labels (can be an HTML element)
     * @param initialValue {Array<string>} The initial selected values
     * @param mandatory {boolean} Is it mandatory to choose a value?
     * @param onChange {function} A callback to be called when the value changes
     */ constructor(translator, isMobileDevice, id, values, labels, initialValue, mandatory, onChange){
        super(translator, isMobileDevice, id, values, labels, initialValue === undefined || initialValue === null ? [] : initialValue, mandatory, onChange);
    }
    getClassName() {
        return "CheckboxesSet";
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div id="' + this.id + '" class="checkboxes-input"></div>');
            this._setOptions();
            const self = this;
            $dc57b31f1b066f38$exports('input', this.uiElement).on('change', function() {
                if (this.blockChangeTrigger) return;
                let val = self.value;
                if ($dc57b31f1b066f38$exports(this).is(':checked')) val.push($dc57b31f1b066f38$exports(this).val());
                else {
                    const index = val.indexOf($dc57b31f1b066f38$exports(this).val());
                    if (index > -1) val.splice(index, 1);
                }
                self._setValue(val, true);
                self._autoDisable();
                self.logStat("SET_VALUE {" + val.join(',') + "}");
            });
        }
        return this.uiElement;
    }
    _autoDisable() {
        if (this.getValue().length >= this.getMaxSelectable()) this.disableValues(this.values.filter((v)=>this.getValue().indexOf(v) < 0));
        else this.disableValues([]);
    }
    getMaxSelectable() {
        return this.maxSelectable ? Math.min(this.maxSelectable, this.getPossibleValues().length) : this.getPossibleValues().length;
    }
    setMaxSelectable(maxSelectable) {
        this.maxSelectable = maxSelectable;
        this._autoDisable();
        return this;
    }
    _setOptions() {
        this.uiElement.empty();
        for(let i = 0; i < this.values.length; i++){
            const val = this.values[i];
            this.uiElement.append($dc57b31f1b066f38$exports('<label val="' + val + '"><input ' + (this.value.indexOf(val) >= 0 ? 'checked' : '') + ' type="checkbox" name="' + this.id + '" value="' + val + '"/>' + this.labels[i] + '</label>'));
        }
        this._autoDisable();
    }
    _setValue(value, triggerOnChange) {
        this.blockChangeTrigger = true;
        this.value = value;
        $dc57b31f1b066f38$exports("input", this.uiElement).removeAttr('checked');
        value.forEach((v)=>$dc57b31f1b066f38$exports("input[value='" + v + "']", this.uiElement).attr('checked', 'checked'));
        this.blockChangeTrigger = false;
        if (triggerOnChange) this.onChangeCallbacks.forEach((c)=>c(this));
    }
}




const $327ace78bdb1d659$var$URL_WORLDBANK_STATS_API = '//api.worldbank.org/v2/country/{0}/indicator/{1}?date={2}:{3}&format=json';
/**
 * A container that has elements to choose time and location settings
 * @extends AbstractContainer
 */ class $327ace78bdb1d659$export$f7bd983a068e1d15 extends (0, $3ec0aa0ced114042$export$d304294fe97dd756) {
    WB_STAT_CODES = [
        "SP.POP.TOTL",
        "EN.POP.DNST",
        "NY.GDP.PCAP.CD",
        "SP.DYN.LE00.IN",
        "SP.POP.1564.TO.ZS",
        "SE.ADT.LITR.ZS",
        "SI.POV.NAHC",
        "SM.POP.REFG",
        "SP.RUR.TOTL",
        "EG.USE.PCAP.KG.OE"
    ];
    MAIN_COUNTRY_COLOR = "rgba(231,165,37,.5)";
    COUNTRY_COLORS = [
        "#009d9a",
        "#6929c4",
        "#005d5d",
        "#9f1853",
        "#fa4d56",
        "#570408",
        "#198038",
        "#002d9c",
        "#1192e8",
        "#ee538b",
        "#b28600",
        "#012749",
        "#8a3800",
        "#a56eff"
    ];
    DEFAULT_INDEX = 'gdp_capita';
    /**
     *
     * @param id {string} An HTML id for this selector container
     * @param translator {Translator} A translator
     * @param townAroundPointUrl {string}
     * @param countryStatsUrl {string}
     * @param basicStatsUrl {string}
     * @param mapImagesUrl {string}
     * @param initialCoords {Array<number>} 2 position array with initialCoords lon lat in wgs84
     * @param initialDate {Date} Initially selected date
     * @param minDate {Date} Min date to show available dates to the user
     * @param maxDate {Date} Max date to show available dates to the user
     * @param timeCalculator {TimeCalculator} The time calculator of the main indicator of the report
     * @param coordsMapModal {Modal} A modal window to show a map to pick coordinates
     * @param runtimeConfig {RuntimeConfig} The map runtime config
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     */ constructor(id, translator, townAroundPointUrl, countryStatsUrl, basicStatsUrl, mapImagesUrl, initialCoords, initialDate, minDate, maxDate, timeCalculator, coordsMapModal, runtimeConfig, isMobileDevice){
        super(id, translator, isMobileDevice, runtimeConfig);
        this.timeCalculator = timeCalculator;
        this.refDate = initialDate;
        this.minDate = minDate;
        this.maxDate = maxDate;
        this.townAroundPointUrl = townAroundPointUrl;
        this.countryStatsUrl = countryStatsUrl;
        this.basicStatsUrl = basicStatsUrl;
        this.mapImagesUrl = mapImagesUrl;
        this.coordsMapModal = coordsMapModal;
        this.onChangeCallbacks = new Set();
        this.coords = initialCoords;
    }
    getClassName() {
        return "SettingSelector";
    }
    /**
     * Add a callback for when the location and/or time changes
     * @param callback {function}
     */ onChange(callback) {
        if (callback) this.onChangeCallbacks.add(callback);
        return this;
    }
    isExpanded() {
        return this.getSessionProp("expanded") === true;
    }
    getContainerElement() {
        if (!this.containerElement) {
            const expanded = this.isExpanded();
            this.containerElement = $dc57b31f1b066f38$exports('<div class="location-selector container ' + (expanded ? 'expanded' : '') + '">' + '   <div class="header" role="heading">' + '       <div class="title">' + '           <h3></h3>' + '       </div>' + '       <div class="buttons-container">' + '           <button class="expander ' + (expanded ? 'collapse' : 'expand') + '" type="button" title="' + this.translator.translate('tool.charts.expander') + '"></button>' + '       </div>' + '   </div>' + '   <div class="body" aria-expanded="' + expanded + '">' + '      <div class="column">' + '           <div class="date-picker simplified-date-picker">' + '               <div>' + '                   <div class="time-container until-container">' + '                       <label for="report_location_datepicker_dropdown_select" class="until">' + this.translator.translate('tool.charts.location.date') + '</label>' + '                       <div class="input-container"></div>' + '                   </div>' + '               </div>' + '           </div>' + '           <div class="lon coordinates"><label>' + this.translator.translate('tool.charts.location.lon') + '<br/>' + '               <input type="text"/></label>' + '           </div>' + '           <div class="lat coordinates"><label>' + this.translator.translate('tool.charts.location.lat') + '<br/>' + '               <input type="text"/></label>' + '           </div>' + '           <div class="ok coordinates"><button type="button" class="action">ok</button></div>' + '           <div class="map-link coordinates"><a>[' + this.translator.translate('tool.charts.location.openMap') + ']</a></div>' + '           <div class="desc"></div>' + '           <div class="stats"></div>' + '       </div>' + '       <div class="column">' + '           <div class="map-img"></div>' + '       </div>' + '       <div class="country-comparison-container">' + '           <div class="country-comparison-controller-container"><h3>' + this.translator.translate("tool.charts.location.comparison.title") + '</h3></div>' + '           <div class="country-comparison"></div>' + '       </div>' + '   </div>' + '</div>');
            this.loader = new (0, $b3069bed9c6337dc$export$3b0d6d7590275603)("report_coords_loader", this.isMobileDevice, $dc57b31f1b066f38$exports('.body', this.containerElement));
            this._updateDateAndCoords(this.refDate, this.coords);
            $dc57b31f1b066f38$exports('.coordinates.ok button', this.containerElement).click(()=>{
                this._updateDateAndCoords(this.refDate, [
                    Number($dc57b31f1b066f38$exports('.coordinates.lon input', this.containerElement).val()),
                    Number($dc57b31f1b066f38$exports('.coordinates.lat input', this.containerElement).val())
                ]);
                this.logStat("SET_COORDINATES_MANUALLY");
            });
            $dc57b31f1b066f38$exports('.coordinates input', this.containerElement).keyup((e)=>{
                if (e.key === "Enter") $dc57b31f1b066f38$exports('.coordinates.ok button', this.containerElement).click();
            });
            $dc57b31f1b066f38$exports('.coordinates.map-link a', this.containerElement).click(()=>{
                this._startCoordsMap();
                this.logStat("SHOW_COORDINATES_MAP");
            });
            const checkDateButtons = (date)=>{
                const previousButton = $dc57b31f1b066f38$exports('button.previous-button.until', this.containerElement);
                const nextButton = $dc57b31f1b066f38$exports('button.next-button.until', this.containerElement);
                const nextDate = this.timeCalculator.getNextDate(date);
                const previousDate = this.timeCalculator.getPreviousDate(date);
                if (previousDate < this.minFrom) previousButton.attr('disabled', 'disabled').addClass('disabled');
                else previousButton.removeAttr('disabled').removeClass('disabled');
                if (nextDate >= this.timeCalculator.fixDate(this.maxDate)) nextButton.attr('disabled', 'disabled').addClass('disabled');
                else nextButton.removeAttr('disabled').removeClass('disabled');
            };
            const setDropDownValue = (previous, dropdown)=>{
                const date = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(dropdown.getValue());
                let newDate = previous ? this.timeCalculator.fixDate(this.timeCalculator.getPreviousDate(date)) : this.timeCalculator.fixDate(this.timeCalculator.getNextDate(date));
                dropdown.setValue((0, $aeedcab592f41cce$export$3ae94a2503e890a1)(newDate));
            };
            const generateDateInputUI = ()=>{
                const previousButton = $dc57b31f1b066f38$exports('<button title="' + this.translator.translate('tool.charts.time.previous') + '" class="previous-button until"></button>');
                const nextButton = $dc57b31f1b066f38$exports('<button title="' + this.translator.translate('tool.charts.time.next') + '" class="next-button until"></button>');
                let currDate = this.timeCalculator.fixDate(this.timeCalculator.getPreviousDate(this.maxDate));
                const options = [
                    new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, '#' + this.timeCalculator.timeCodeToString((0, $aeedcab592f41cce$export$3ae94a2503e890a1)(currDate)), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(currDate), undefined)
                ];
                do {
                    currDate = this.timeCalculator.fixDate(this.timeCalculator.getPreviousDate(currDate));
                    options.push(new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, '#' + this.timeCalculator.timeCodeToString((0, $aeedcab592f41cce$export$3ae94a2503e890a1)(currDate)), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(currDate), undefined));
                }while (currDate > this.minDate);
                options.reverse();
                const onChangeDropdown = (dropDown)=>{
                    const date = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(dropDown.getValue());
                    checkDateButtons(date);
                    this._updateDateAndCoords(date, this.coords);
                };
                const dropdown = new (0, $d0c219b43b862888$export$931cbfb6bfb85fc)(this.translator, this.isMobileDevice, "report_location_datepicker_dropdown", options, (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.refDate), true, 'tool.charts.location.date', onChangeDropdown, undefined);
                $dc57b31f1b066f38$exports('.input-container', this.containerElement).append(previousButton).append(dropdown.getUIElement()).append(nextButton);
                checkDateButtons(this.refDate);
                previousButton.click(()=>{
                    setDropDownValue(true, dropdown);
                    this.logStat('PREVIOUS_REFERENCE_PERIOD {' + dropdown.getValue() + '}');
                });
                nextButton.click(()=>{
                    setDropDownValue(false, dropdown);
                    this.logStat('NEXT_REFERENCE_PERIOD {' + dropdown.getValue() + '}');
                });
            };
            generateDateInputUI();
            const comparisonButton = $dc57b31f1b066f38$exports('<a class="country-comparison-controller">[' + this.translator.translate("tool.charts.location.comparison.show") + ']</a>').click(()=>{
                if (!this.countryComparisonLoaded) this._generateComparisonChart(this.countryComparisonValues.countryCode, this.countryComparisonValues.countryName, this.countryComparisonValues.neighbors, this.countryComparisonValues.otherCountries, this.countryComparisonValues.stats, this.countryComparisonValues.statsDefs);
                $dc57b31f1b066f38$exports('.country-comparison', this.uiElement).toggle();
                if ($dc57b31f1b066f38$exports('.country-comparison', this.uiElement).is(':visible')) this.logStat("SHOW_COUNTRY_COMPARISON_CHART");
                else this.logStat("HIDE_COUNTRY_COMPARISON_CHART");
            });
            $dc57b31f1b066f38$exports('.body .country-comparison-controller-container', this.containerElement).append(comparisonButton);
        }
        return this.containerElement;
    }
    _generateComparisonChart(countryCode, countryName, neighbors, otherCountries, stats, statsDefs) {
        this.countryComparisonLoaded = true;
        const target = $dc57b31f1b066f38$exports('.country-comparison', this.uiElement).empty();
        const updateComparisonChart = ()=>{
            const countryContainer = $dc57b31f1b066f38$exports('.selected-country-container', target).empty();
            let i = 0;
            const countries = [
                {
                    code: countryCode,
                    name: countryName,
                    color: this.MAIN_COUNTRY_COLOR
                }
            ].concat(this.neighborsCheckboxesSet.getValue().map((c)=>({
                    code: c,
                    name: neighbors[c],
                    color: this.COUNTRY_COLORS[i++ % this.COUNTRY_COLORS.length]
                }))).concat(this.otherCountriesCheckboxesSet.getValue().map((c)=>({
                    code: c,
                    name: otherCountries[c],
                    color: this.COUNTRY_COLORS[i++ % this.COUNTRY_COLORS.length]
                })));
            countries.forEach((country)=>{
                countryContainer.append($dc57b31f1b066f38$exports('<div class="country"><div class="color" style="background-color: ' + country.color + '"></div>' + country.name + '</div>').data('code', country.code));
            });
            $dc57b31f1b066f38$exports($dc57b31f1b066f38$exports('div.country', countryContainer)[0]).addClass('selected');
            const renderChart = (chartData, defs)=>{
                const min = Math.min.apply(Math, chartData.map((cd)=>cd.x[0]));
                const max = Math.max.apply(Math, chartData.map((cd)=>(0, $2536f84a954bf107$export$ce275da88d3dcc54)(cd.x)));
                chartData.forEach((cd)=>{
                    const x = cd.x, y = cd.y;
                    let i = 0;
                    for(let year = min; year <= max; year++){
                        if (x[i] > year) {
                            x.splice(i, 0, year);
                            y.splice(i, 0, null);
                        }
                        i++;
                    }
                    cd.x = x;
                    cd.y = y;
                });
                const config = {
                    responsive: true,
                    showSendToCloud: false,
                    modeBarButtonsToRemove: [
                        'resetscale',
                        'select2d',
                        'lasso2d',
                        'zoom2d',
                        'zoomIn2d',
                        'zoomOut2d',
                        'autoScale2d',
                        'pan2d'
                    ],
                    modebarStyle: {
                        orientation: this.isMobileDevice ? 'v' : 'h'
                    }
                };
                const layout = {
                    height: this.isSmallContainerWidth ? 250 : 500,
                    title: {
                        text: defs.descr + (this.isSmallContainerWidth ? '<br>' : ' ') + '(' + defs.uom + ') [' + defs.source + ']',
                        font: {
                            size: this.isSmallContainerWidth ? 11 : 14
                        }
                    },
                    autosize: true,
                    margin: {
                        l: 35,
                        r: 25,
                        b: 45,
                        t: 45,
                        pad: 2
                    },
                    xaxis: {
                        type: 'category',
                        showspikes: true,
                        spikemode: 'toaxis+across+marker',
                        spikesnap: 'cursor',
                        spikedash: 'dot',
                        spikethickness: -2,
                        spikecolor: 'rgba(40,110,159,.5)'
                    },
                    yaxis: {
                        showspikes: true,
                        spikemode: 'toaxis+across+marker',
                        spikesnap: 'cursor',
                        spikedash: 'dot',
                        spikethickness: -2,
                        spikecolor: 'rgba(40,110,159,.5)'
                    },
                    dragmode: false,
                    hovermode: 'x unified',
                    hoverlabel: {
                        bgcolor: "#EEEEEE"
                    },
                    paper_bgcolor: "rgba(0,0,0,0)",
                    plot_bgcolor: "rgba(0,0,0,0)",
                    textposition: 'outside',
                    showlegend: false
                };
                const chartContainer = $dc57b31f1b066f38$exports('.chart-container', target).empty();
                setTimeout(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a765ec5880d44928$exports))).newPlot(chartContainer[0], chartData, layout, config), 500);
                this.loader.hide();
            };
            const index = this.indicesDropdown.getValue();
            let data = [];
            if (stats[index]) data.push({
                name: countryName,
                x: stats[index].map((v)=>v.year),
                y: stats[index].map((v)=>v.val),
                type: 'bar',
                marker: {
                    color: this.MAIN_COUNTRY_COLOR
                }
            });
            if (countries.length > 1) {
                const additionalCountries = countries.slice(1);
                this.loader.show();
                $dc57b31f1b066f38$exports.getJSON(this.countryStatsUrl.format([
                    additionalCountries.map((c)=>c.code).join(',')
                ]), (fCol)=>{
                    fCol.features.forEach((feature)=>{
                        const country = additionalCountries.filter((c)=>c.code === feature.properties.cty_id)[0];
                        const countryStats = feature.properties[index];
                        if (countryStats) data.push({
                            name: country.name,
                            x: countryStats.map((v)=>v.year),
                            y: countryStats.map((v)=>v.val),
                            type: 'scatter',
                            mode: 'lines+markers',
                            marker: {
                                color: country.color
                            },
                            connectgaps: true
                        });
                    });
                    renderChart(data, statsDefs[index]);
                });
            } else renderChart(data, statsDefs[index]);
        };
        const dropdownOptions = Object.keys(statsDefs).sort((k1, k2)=>statsDefs[k1].descr.localeCompare(statsDefs[k2].descr)).map((k)=>new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, '#' + statsDefs[k].descr, k));
        this.indicesDropdown = new (0, $d0c219b43b862888$export$931cbfb6bfb85fc)(this.translator, this.isMobileDevice, 'location_selector_country_comparison_indices', dropdownOptions, this.DEFAULT_INDEX, true, undefined, updateComparisonChart);
        const neighborValues = Object.keys(neighbors).sort((k1, k2)=>neighbors[k1].localeCompare(neighbors[k2]));
        const neighborLabels = neighborValues.map((countryCode)=>neighbors[countryCode]);
        const otherCountryValues = Object.keys(otherCountries).sort((k1, k2)=>otherCountries[k1].localeCompare(otherCountries[k2]));
        const otherCountryLabels = otherCountryValues.map((countryCode)=>otherCountries[countryCode]);
        this.neighborsCheckboxesSet = new (0, $44aebe8483a8dd97$export$3e0571e35758f2b7)(this.translator, this.isMobileDevice, 'location_selector_neighbors', neighborValues, neighborLabels, undefined, false, updateComparisonChart);
        this.otherCountriesCheckboxesSet = new (0, $44aebe8483a8dd97$export$3e0571e35758f2b7)(this.translator, this.isMobileDevice, 'location_selector_other_countries', otherCountryValues, otherCountryLabels, undefined, false, updateComparisonChart);
        const neighborMultioptionList = new (0, $aeaaa177973849d7$export$371833ac55d444da)(this.translator, this.isMobileDevice, this.neighborsCheckboxesSet.getCode() + '_option_list', this.translator.translate('tool.charts.location.comparison.countries.neighbor'), this.neighborsCheckboxesSet);
        const otherCountriesMultioptionList = new (0, $aeaaa177973849d7$export$371833ac55d444da)(this.translator, this.isMobileDevice, this.otherCountriesCheckboxesSet.getCode() + '_option_list', this.translator.translate('tool.charts.location.comparison.countries.other'), this.otherCountriesCheckboxesSet);
        const countriesContainer = $dc57b31f1b066f38$exports('<div class="countries-container"></div>').append($dc57b31f1b066f38$exports('<div class="neighbors-container"></div>').append(neighborMultioptionList.getUIElement())).append($dc57b31f1b066f38$exports('<div class="other-countries-container"></div>').append(otherCountriesMultioptionList.getUIElement()));
        target.append($dc57b31f1b066f38$exports('<div class="indices-container"></div>').append(this.indicesDropdown.getUIElement())).append($dc57b31f1b066f38$exports('<div class="selected-country-container"></div>')).append(countriesContainer).append($dc57b31f1b066f38$exports('<div class="chart-container"></div>'));
        updateComparisonChart();
    }
    /**
     * Get the current coordinates for the report
     * @return {Array<number>} 2 position array with coords lon lat in wgs84
     */ getCoordinatesWgs84() {
        return this.coords;
    }
    /**
     * Get the current date for the report
     * @return {Date}
     */ getDate() {
        return this.refDate;
    }
    _executeOnChange() {
        this.onChangeCallbacks.forEach((c)=>c(this));
    }
    _updateDateAndCoords(date, coords) {
        this.loader.show();
        if (coords) this.coords = (0, $40ab8c40db995546$export$881b4a519e1b1429)(coords);
        if (date) this.refDate = date;
        const formattedLon = this.coords[0] + '';
        const formattedLat = this.coords[1] + '';
        $dc57b31f1b066f38$exports('.coordinates.lon input', this.getContainerElement()).val(formattedLon);
        $dc57b31f1b066f38$exports('.coordinates.lat input', this.getContainerElement()).val(formattedLat);
        $dc57b31f1b066f38$exports('.body .desc', this.getContainerElement()).empty();
        $dc57b31f1b066f38$exports('.body .map-img', this.getContainerElement()).css('background-image', 'none');
        $dc57b31f1b066f38$exports('.body .stats', this.getContainerElement()).empty();
        $dc57b31f1b066f38$exports.getJSON(this.townAroundPointUrl.format([
            formattedLon,
            formattedLat
        ]), (fCol)=>{
            this.closestCityDistance = (0, $0e7893c26680b018$export$79376507b09a66f)(this.coords, fCol.features[0].geometry.coordinates);
            if (Math.abs(fCol.features[0].properties.dist - this.closestCityDistance) > 5) {
                this.logDebug("distance from server: {0}, calculated distance: {1}".format([
                    "" + fCol.features[0].properties.dist,
                    this.closestCityDistance + ""
                ]));
                this.closestCityDistance = fCol.features[0].properties.dist;
            }
            const formattedDistance = (0, $2536f84a954bf107$export$f5dd818bff069720)(this.closestCityDistance / 1000, 2);
            this.closestCityName = fCol.features[0].properties.name;
            $dc57b31f1b066f38$exports('.body .desc', this.getContainerElement()).html(this.translator.translate('tool.charts.location.desc', [
                formattedDistance,
                this.closestCityName,
                (0, $2536f84a954bf107$export$f5dd818bff069720)(fCol.features[0].properties.population)
            ]));
        });
        $dc57b31f1b066f38$exports.getJSON(this.basicStatsUrl.format([
            formattedLon,
            formattedLat
        ]), (fCol)=>{
            this.aruId = fCol.features[0].properties.id;
            this.countryCode = fCol.features[0].properties.ctyId;
            this.regionName = fCol.features[0].properties.name;
            this.countryName = fCol.alia && fCol.alia.countries ? fCol.alia.countries[this.countryCode].name : undefined;
            this.isRegion = this.regionName !== this.countryName;
            $dc57b31f1b066f38$exports('.header .title h3', this.getContainerElement()).html(this.translator.translate('tool.charts.location.name', [
                this.isRegion ? this.regionName + ", " + (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.countryName, this.countryCode) : (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.countryName, this.countryCode),
                this.timeCalculator.timeCodeToString((0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.refDate))
            ]));
            this.capital = fCol.alia && fCol.alia.countries ? fCol.alia.countries[this.countryCode].capital : undefined;
            this.regionArea = fCol.features[0].properties.area;
            this.regionBbox = fCol.bbox;
            this.countryArea = fCol.alia && fCol.alia.countries ? fCol.alia.countries[this.countryCode].area : undefined;
            this.regionPop = fCol.features[0].properties.population;
            this.regionPopDensity = this.regionPop / (this.regionArea / 1000000);
            const countryPop = fCol.alia && fCol.alia.countries ? fCol.alia.countries[this.countryCode].wb['SP.POP.TOTL'].value : undefined;
            $dc57b31f1b066f38$exports.getJSON(this.mapImagesUrl.format([
                (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.refDate),
                formattedLon,
                formattedLat,
                this.aruId,
                this.countryCode + ""
            ]), (urls)=>{
                this.mapUrls = urls;
                this._executeOnChange();
                const imgUrl = (0, $2536f84a954bf107$export$730687a846e4e808)(this.mapUrls.ref);
                $dc57b31f1b066f38$exports('.body .map-img', this.getContainerElement()).css('background-image', 'url(' + imgUrl + ')');
                this.loader.hide();
            });
            $dc57b31f1b066f38$exports('.body .stats', this.getContainerElement()).append($dc57b31f1b066f38$exports('<table class="values"><tbody>   <tr><td class="title" colspan="2">' + this.translator.translate('tool.charts.location.stats.title', [
                (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.countryName, this.countryCode)
            ]) + '</td></tr>' + '   <tr><td><label>' + this.translator.translate('tool.charts.location.stats.area') + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(this.countryArea / 1000000, 2, 'km<sup>2</sup>') + '</td></tr>' + '   <tr><td><label>' + this.translator.translate('tool.charts.location.stats.capital') + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.capital, '--') + '</td></tr>' + '   <tr><td class="title" colspan="2">' + this.translator.translate('tool.charts.location.stats.worldBank.title', [
                (0, $2536f84a954bf107$export$51c197c9b00a6c1c)(this.countryName, this.countryCode)
            ]) + '</td></tr>' + '</tbody></table>'));
            this.WB_STAT_CODES.forEach((code)=>{
                const fixedCode = code.replaceAll('.', '_');
                return $dc57b31f1b066f38$exports('.body .stats table.values', this.getContainerElement()).append($dc57b31f1b066f38$exports('<tr><td><label>' + this.translator.translate('tool.charts.location.stats.worldBank.' + fixedCode) + '</label></td><td class="value ' + fixedCode + '"></td></tr>'));
            });
            this.wbDataSeries = {};
            this.WB_STAT_CODES.forEach((indCode)=>{
                const currentYear = new Date().getFullYear();
                $dc57b31f1b066f38$exports.getJSON($327ace78bdb1d659$var$URL_WORLDBANK_STATS_API.format([
                    this.countryCode,
                    indCode,
                    "" + (currentYear - 20),
                    "" + (currentYear - 1)
                ]), (wbData)=>{
                    this.wbDataSeries[indCode] = wbData;
                    const yearValue = wbData[1] ? wbData[1].filter((v)=>v.value !== null)[0] : undefined;
                    const fixedCode = indCode.replaceAll('.', '_');
                    const valueTarget = $dc57b31f1b066f38$exports('.body .stats table.values tr td.' + fixedCode, this.getContainerElement());
                    if (yearValue) valueTarget.html((0, $2536f84a954bf107$export$f5dd818bff069720)(yearValue.value, yearValue.decimal) + ' <span class="context">(' + yearValue.date + ')</span>');
                    else valueTarget.html('--');
                });
            });
            if (this.isRegion) {
                const percPop = this.regionPop / countryPop * 100;
                const percArea = this.regionArea / this.countryArea * 100;
                $dc57b31f1b066f38$exports('.body .stats table.values tbody', this.getContainerElement()).append($dc57b31f1b066f38$exports('   <tr><td class="title" colspan="2">' + this.translator.translate('tool.charts.location.stats.region.title', [
                    this.regionName
                ]) + '</td></tr>' + '   <tr><td><label>' + this.translator.translate('tool.charts.location.stats.region.area') + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(this.regionArea / 1000000, 2, 'km<sup>2</sup>') + ' <span class="context">(' + (0, $2536f84a954bf107$export$f5dd818bff069720)(percArea, 2, '%') + ')</span></td></tr>' + '   <tr><td><label>' + this.translator.translate('tool.charts.location.stats.region.population') + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(this.regionPop) + ' <span class="context">(' + (0, $2536f84a954bf107$export$f5dd818bff069720)(percPop, 2, '%') + ')</span></td></tr>' + '   <tr><td><label>' + this.translator.translate('tool.charts.location.stats.region.popDensity') + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(this.regionPopDensity, 2) + '</td></tr>'));
            }
            $dc57b31f1b066f38$exports.getJSON(this.countryStatsUrl.format([
                this.countryCode
            ]), (fCol)=>{
                const countryCode = fCol.alia && fCol.alia.countries ? Object.keys(fCol.alia.countries.selected)[0] : undefined;
                this.countryComparisonValues = {
                    countryCode: countryCode,
                    countryName: fCol.alia && fCol.alia.countries ? fCol.alia.countries.selected[countryCode] : undefined,
                    neighbors: fCol.alia && fCol.alia.countries ? fCol.alia.countries.neighbors : undefined,
                    otherCountries: fCol.alia && fCol.alia.countries ? fCol.alia.countries.others : undefined,
                    stats: fCol.features[0].properties,
                    statsDefs: fCol.alia ? fCol.alia.statsDefs : undefined
                };
                if (this.countryComparisonLoaded) this._generateComparisonChart(this.countryComparisonValues.countryCode, this.countryComparisonValues.countryName, this.countryComparisonValues.neighbors, this.countryComparisonValues.otherCountries, this.countryComparisonValues.stats, this.countryComparisonValues.statsDefs);
            });
        });
    }
    /**
     * Get the URLS for map indicator images
     * @return {Object} dictionary of indicator codes (server custom codes) to img urls
     */ getMapUrls() {
        return this.mapUrls;
    }
    /**
     * Get the country code
     * @return {string}
     */ getCountryCode() {
        return this.countryCode;
    }
    /**
     * Get the region ID
     * @return {string}
     */ getAruId() {
        return this.aruId;
    }
    /**
     * Get the region area
     * @return {number}
     */ getRegionArea() {
        return this.regionArea;
    }
    /**
     * Get the region bbox
     * @return {Array<number>} 4 position array wuth bbox lon lat in wgs84
     */ getRegionExtent() {
        return this.regionBbox;
    }
    _startCoordsMap() {
        const coordsMapTarget = $dc57b31f1b066f38$exports('<div id="coords_map_target" class="coords-map"></div>');
        this.coordsMapModal.setTitle(this.translator.translate('tool.charts.location.chooseFromMap'));
        this.coordsMapModal.setContent(coordsMapTarget);
        this.coordsMapModal.show();
        const source = new (0, $69f8886165740064$export$2e2bcd8739ae039)({
            wrapX: false
        });
        const buttons = $dc57b31f1b066f38$exports('<div class="ol-control buttons ol-unselectable">   <button class="button cancel-button">' + this.translator.translate("tool.charts.location.map.cancel") + '</button>' + '   <button class="button ok action">' + this.translator.translate("tool.charts.location.map.accept") + '</button> ' + '</div>').hide();
        $dc57b31f1b066f38$exports('.ok', buttons).click(()=>{
            this._updateDateAndCoords(this.refDate, (0, $92f1443438429e81$export$51186ad6e864892a)(source.getFeatures()[0].getGeometry().getCoordinates(), (0, $9bc5df2b24a7fcf6$export$bad5ada7a204507f), (0, $9bc5df2b24a7fcf6$export$6dd85527b263c26d)));
            this.coordsMapModal.close();
            this.logStat("SET_COORDINATES_IN_MAP");
        });
        $dc57b31f1b066f38$exports('.cancel-button', buttons).click(()=>this.coordsMapModal.close());
        let hasChange = false;
        source.addFeature(new (0, $1171fbd986f3130c$export$2e2bcd8739ae039)(new (0, $f7e297e9f8b90024$export$2e2bcd8739ae039)((0, $92f1443438429e81$export$51186ad6e864892a)(this.getCoordinatesWgs84(), (0, $9bc5df2b24a7fcf6$export$6dd85527b263c26d), (0, $9bc5df2b24a7fcf6$export$bad5ada7a204507f)))));
        source.on('change', ()=>{
            if (!hasChange) buttons.show();
            hasChange = true;
        });
        const draw = new (0, $ca31a7ccd09c3d1c$export$2e2bcd8739ae039)({
            source: source,
            type: 'Point'
        });
        draw.on('drawend', ()=>source.clear()); //we only want 1 feature
        const style = [
            new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)({
                    radius: 8,
                    fill: new (0, $d6fd3e0b0360ea29$export$2e2bcd8739ae039)({
                        color: 'rgba(231, 165, 37,0.25)'
                    }),
                    stroke: new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                        color: '#E7A525',
                        width: 2
                    })
                })
            }),
            new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)({
                    radius: 6,
                    stroke: new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                        color: '#286e9f',
                        width: 2
                    })
                })
            }),
            new (0, $0f1ce378ea6946fc$export$2e2bcd8739ae039)({
                image: new (0, $e163d3c698de5692$export$2e2bcd8739ae039)({
                    radius: 4,
                    stroke: new (0, $9ed46f4c9b041e5d$export$2e2bcd8739ae039)({
                        color: '#FFFFFF',
                        width: 2
                    })
                })
            })
        ];
        const map = new (0, $88aa35e28fb911a2$export$2e2bcd8739ae039)({
            layers: [
                new (0, $0e25041945985074$export$2e2bcd8739ae039)({
                    source: new (0, $d978548adde0e5c6$export$2e2bcd8739ae039)({
                        url: 'https://gisco-services.ec.europa.eu/maps/tiles/OSMCartoComposite/EPSG3857/{z}/{x}/{y}.png'
                    })
                }),
                new (0, $09432eee05d1671f$export$2e2bcd8739ae039)({
                    source: source,
                    style: style
                })
            ],
            target: 'coords_map_target',
            view: new (0, $3192ea72f934a3fd$export$2e2bcd8739ae039)({
                projection: (0, $9bc5df2b24a7fcf6$export$bad5ada7a204507f),
                center: (0, $92f1443438429e81$export$51186ad6e864892a)(this.getCoordinatesWgs84(), (0, $9bc5df2b24a7fcf6$export$6dd85527b263c26d), (0, $9bc5df2b24a7fcf6$export$bad5ada7a204507f)),
                zoom: 7
            }),
            controls: []
        });
        map.addInteraction(draw);
        $dc57b31f1b066f38$exports('.ol-overlaycontainer-stopevent', coordsMapTarget).append(buttons);
    }
}


















/**
 * A date picker with a fixed until date and suitable to be included in a container with some other purpose
 * @extends DatePicker
 */ class $898561d63e8ae729$export$e071f2a061538330 extends (0, $84f00262b5923f0a$export$5109c6dd95d8fb00) {
    /**
     *
     * @param id {string} The HTML id for this container
     * @param translator {Translator} A translator
     * @param layer {Layer}
     * @param until {Date}
     * @param from {Date}
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     **/ constructor(id, translator, layer, until, from, isMobileDevice){
        super(id, translator, [
            layer
        ], undefined, undefined, undefined, isMobileDevice);
        const timeCalculator = new (0, $aeedcab592f41cce$export$41dea944c75fcd24)(layer.getTimeCalculator().getPeriodicity(), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(layer.getTimeCalculator().max(layer.getDataFrom(), layer.getTimeCalculator().addDays(until, -(0, $84f00262b5923f0a$export$5109c6dd95d8fb00).MAX_DAYS))), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(layer.getDataUntil()), this.translator);
        this.maxUntil = timeCalculator.getUntil();
        this.until = timeCalculator.min(this.maxUntil, until);
        this.minFrom = timeCalculator.getFrom();
        this.from = timeCalculator.fixDate(from ? timeCalculator.max(from, timeCalculator.getFrom()) : timeCalculator.max(timeCalculator.getFrom(), timeCalculator.addDays(this.until, -365)));
        this.timeCalculator = new (0, $aeedcab592f41cce$export$41dea944c75fcd24)(layer.getTimeCalculator().getPeriodicity(), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.minFrom), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.until), this.translator);
        this.setDefaultFromUntil(this.from, this.until);
    }
    getClassName() {
        return "SimplifiedFixedInnerDatePicker";
    }
    setDefaultFromUntil(from, until) {
        this.from = from;
        this.until = until;
    }
    getFrom() {
        return (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.from);
    }
    _setFrom(year, month, day) {
        this.from = (0, $aeedcab592f41cce$export$2b6cf20b1d58ec45)(year, month, day);
        this.onChangeCallbacks.forEach((c)=>c(this));
    }
    getUntil() {
        return (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.until);
    }
    _setUntil(year, month, day) {
        this.until = (0, $aeedcab592f41cce$export$2b6cf20b1d58ec45)(year, month, day);
        this.onChangeCallbacks.forEach((c)=>c(this));
    }
    _getMinUntil() {
        return this.until;
    }
    _getHardMaxUntil() {
        if (this.maxUntil) return this.maxUntil;
        return super._getHardMaxUntil();
    }
    _getMaxFrom() {
        return this.from;
    }
    _getHardMinFrom() {
        return this.minFrom;
    }
    getUIElement() {
        if (!this.uiElement) {
            this.uiElement = $dc57b31f1b066f38$exports('<div></div>');
            this.uiElement.append(this.getContainerElement());
        }
        return this.uiElement;
    }
    getContainerElement() {
        const container = $dc57b31f1b066f38$exports('<div class="date-picker simplified-date-picker">   <div>       <div class="time-container from-container">           <label for="from_datepicker_dropdown_select" class="from">' + this.translator.translate('tool.charts.from.title') + '</label>' + '           <div class="input-container"></div>' + '       </div>' + '       <div class="time-container until-container">' + '           <label class="until">' + this.translator.translate('tool.charts.until.title') + '</label>' + '           <div class="until-input-container"><div class="value">' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.timeCalculator.fixDateUntil(this.until)) + '</div></div>' + '       </div>' + '   </div>' + '</div>');
        const checkFromButtons = (fromDate)=>{
            const previousButton = $dc57b31f1b066f38$exports('button.previous-button.from', container);
            const nextButton = $dc57b31f1b066f38$exports('button.next-button.from', container);
            const nextDate = this.timeCalculator.getNextDate(fromDate);
            const previousDate = this.timeCalculator.getPreviousDate(fromDate);
            if (previousDate < this.minFrom) previousButton.attr('disabled', 'disabled').addClass('disabled');
            else previousButton.removeAttr('disabled').removeClass('disabled');
            if (nextDate >= this.until) nextButton.attr('disabled', 'disabled').addClass('disabled');
            else nextButton.removeAttr('disabled').removeClass('disabled');
        };
        const setDropDownValue = (previous, dropdown)=>{
            const date = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(dropdown.getValue());
            let newDate = previous ? this.timeCalculator.fixDate(this.timeCalculator.getPreviousDate(date)) : this.timeCalculator.fixDate(this.timeCalculator.getNextDate(date));
            dropdown.setValue((0, $aeedcab592f41cce$export$3ae94a2503e890a1)(newDate));
        };
        const generateInputUI = ()=>{
            const previousButton = $dc57b31f1b066f38$exports('<button title="' + this.translator.translate('tool.charts.time.previous') + '" class="previous-button from"></button>');
            const nextButton = $dc57b31f1b066f38$exports('<button title="' + this.translator.translate('tool.charts.time.next') + '" class="next-button from"></button>');
            let currDate = this.timeCalculator.fixDate(this.timeCalculator.getPreviousDate(this.until));
            const options = [
                new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, '#' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(currDate), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(currDate), undefined)
            ];
            do {
                currDate = this.timeCalculator.fixDate(this.timeCalculator.getPreviousDate(currDate));
                options.push(new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, '#' + (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(currDate), (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(currDate), undefined));
            }while (currDate > this.minFrom);
            options.reverse();
            const onChangeDropdown = (dropDown)=>{
                const date = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(dropDown.getValue());
                this._setFrom(this.timeCalculator.getYearFromDate(date), this.timeCalculator.getMonthFromDate(date), this.timeCalculator.getDayFromDate(date));
            };
            const dropdown = new (0, $d0c219b43b862888$export$931cbfb6bfb85fc)(this.translator, this.isMobileDevice, "from_datepicker_dropdown", options, this.getFrom(), true, 'tool.charts.from.title', onChangeDropdown, undefined);
            $dc57b31f1b066f38$exports('.input-container', container).append(previousButton).append(dropdown.getUIElement()).append(nextButton);
            const onChangePicker = (picker)=>{
                const fromDate = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(picker.getFrom());
                checkFromButtons(fromDate);
            };
            onChangePicker(this);
            this.onChange(onChangePicker);
            previousButton.click(()=>{
                setDropDownValue(true, dropdown);
                this.logStat('PREVIOUS_PERIOD {' + dropdown.getValue() + '}');
            });
            nextButton.click(()=>{
                setDropDownValue(false, dropdown);
                this.logStat('NEXT_PERIOD {' + dropdown.getValue() + '}');
            });
        };
        generateInputUI();
        return container;
    }
}





var $feAbh = parcelRequire("feAbh");




/**
 * A runtime config for this map.
 * Tools and UI elements will change this runtime config, which will afterwards override MapConfig
 * @extends RuntimeConfig
 * @hideconstructor
 */ class $7b49815d769de08a$export$fa81ed1a6914b437 extends (0, $2a1bdf5b8bad2f9b$export$ec56e2f5cfeae5ef) {
    getClassName() {
        return "MapRuntimeConfig";
    }
    /**
     * Create a MapRuntimeConfig from a serialized object
     * @param code {string} Unique identifier for the runtime config
     * @param runtimeConfigSerialization {string} serialization
     * @return {MapRuntimeConfig}
     */ static createFromSerialized(code, runtimeConfigSerialization) {
        let parsedConfig;
        try {
            parsedConfig = runtimeConfigSerialization ? JSON.parse($feAbh.decompressFromBase64(runtimeConfigSerialization)) : undefined;
        // tumbo.LOGGER.logDebug("Deserialized config: ", parsedConfig);
        } catch (e) {
            tumbo.LOGGER.logError('Error deserializing config', e);
        }
        return new $7b49815d769de08a$export$fa81ed1a6914b437(code, parsedConfig);
    }
    /**
     * Clean this runtime config
     */ clean() {
        this.config = {
            m: {},
            bl: {},
            cl: {},
            l: {},
            c: {},
            t: {}
        };
    }
    /**
     * Set the current zoom level
     * @param zoomLevel {number} (integer)
     */ setZoomLevel(zoomLevel) {
        this.config.m.z = zoomLevel;
    }
    /**
     * Get the current zoom level
     * @returns {number} (integer)
     */ getZoomLevel() {
        return this.config.m.z;
    }
    /**
     * Set the current WGS84 center
     * @param centerLonLatWgs84 {Array<number>}
     */ setCenterLonLatWgs84(centerLonLatWgs84) {
        if (centerLonLatWgs84[0] !== undefined && centerLonLatWgs84[1] !== undefined) this.config.m.c = centerLonLatWgs84;
    }
    /**
     * Get the current WGS84 center
     * @return {Array<number>}
     */ getCenterLonLatWgs84() {
        return this.config.m.c;
    }
    /**
     * Set the current projection EPSG code
     * @param projection {string}
     */ setProjection(projection) {
        this.config.m.p = projection;
    }
    /**
     * Get the current projection EPSG code
     * @return {string}
     */ getProjection() {
        return this.config.m.p;
    }
    /**
     * set a classifier visibility
     * @param classifierCode {string}
     * @param visible {boolean}
     */ setClassifierVisibility(classifierCode, visible) {
        if (!this.config.c) this.config.c = {};
        if (!this.config.c[classifierCode]) this.config.c[classifierCode] = {};
        this.config.c[classifierCode].v = visible;
    }
    /**
     * get a classifier visibility
     * @param classifierCode {string}
     * @return {boolean}
     */ getClassifierVisibility(classifierCode) {
        return this.config.c && this.config.c[classifierCode] ? this.config.c[classifierCode].v : undefined;
    }
    /**
     * set a classifier expanded state
     * @param classifierCode {string}
     * @param expanded {boolean}
     */ setClassifierExpanded(classifierCode, expanded) {
        if (!this.config.c) this.config.c = {};
        if (!this.config.c[classifierCode]) this.config.c[classifierCode] = {};
        this.config.c[classifierCode].e = expanded;
    }
    /**
     * get a classifier expanded state
     * @param classifierCode {string}
     * @return {boolean}
     */ getClassifierExpanded(classifierCode) {
        return this.config.c && this.config.c[classifierCode] ? this.config.c[classifierCode].e : undefined;
    }
    /**
     * set a base layer visibility
     * @param baseLayerCode {string}
     * @param visible {boolean}
     */ setBaseLayerVisibility(baseLayerCode, visible) {
        if (!this.config.bl) this.config.bl = {};
        if (!this.config.bl[baseLayerCode]) this.config.bl[baseLayerCode] = {};
        this.config.bl[baseLayerCode].v = visible;
    }
    /**
     * get a base layer visibility
     * @param baseLayerCode {string}
     * @return {boolean}
     */ getBaseLayerVisibility(baseLayerCode) {
        return this.config.bl && this.config.bl[baseLayerCode] ? this.config.bl[baseLayerCode].v : undefined;
    }
    /**
     * set a context layer visibility
     * @param contextLayerCode {string}
     * @param visible {boolean}
     */ setContextLayerVisibility(contextLayerCode, visible) {
        if (!this.config.cl) this.config.cl = {};
        if (!this.config.cl[contextLayerCode]) this.config.cl[contextLayerCode] = {};
        this.config.cl[contextLayerCode].v = visible;
    }
    /**
     * get a context layer visibility
     * @param contextLayerCode {string}
     * @return {boolean}
     */ getContextLayerVisibility(contextLayerCode) {
        return this.config.cl && this.config.cl[contextLayerCode] ? this.config.cl[contextLayerCode].v : undefined;
    }
    /**
     * set a layer visibility
     * @param layerCode {string}
     * @param visible {boolean}
     */ setLayerVisibility(layerCode, visible) {
        if (!this.config.l) this.config.l = {};
        if (!this.config.l[layerCode]) this.config.l[layerCode] = {};
        this.config.l[layerCode].v = visible;
    }
    /**
     * get a layer visibility
     * @param layerCode {string}
     * @return {boolean}
     */ getLayerVisibility(layerCode) {
        return this.config.l && this.config.l[layerCode] ? this.config.l[layerCode].v : undefined;
    }
    /**
     * set a layer opacity
     * @param layerCode {string}
     * @param opacity {number} [0 .. 1]
     */ setLayerOpacity(layerCode, opacity) {
        if (!this.config.l) this.config.l = {};
        if (!this.config.l[layerCode]) this.config.l[layerCode] = {};
        this.config.l[layerCode].o = opacity;
    }
    /**
     * get a layer opacity
     * @param layerCode {string}
     * @return {number} [0 .. 1]
     */ getLayerOpacity(layerCode) {
        return this.config.l && this.config.l[layerCode] ? this.config.l[layerCode].o : undefined;
    }
    /**
     * set a layer time code
     * @param layerCode {string}
     * @param timeCode {string}
     */ setLayerTimeCode(layerCode, timeCode) {
        if (!this.config.l) this.config.l = {};
        if (!this.config.l[layerCode]) this.config.l[layerCode] = {};
        this.config.l[layerCode].tc = {
            "tc": timeCode,
            "ts": new Date()
        };
    }
    /**
     * get a layer time code
     * @param layerCode {string}
     * @return {string}
     */ getLayerTimeCode(layerCode) {
        return this.config.l && this.config.l[layerCode] ? this.config.l[layerCode].tc : undefined;
    }
    /**
     * set a layer time scale
     * @param layerCode {string}
     * @param timeScale {string}
     */ setLayerTimeScale(layerCode, timeScale) {
        if (!this.config.l) this.config.l = {};
        if (!this.config.l[layerCode]) this.config.l[layerCode] = {};
        this.config.l[layerCode].ts = timeScale;
    }
    /**
     * get a layer time scale
     * @param layerCode {string}
     * @return {string}
     */ getLayerTimeScale(layerCode) {
        return this.config.l && this.config.l[layerCode] ? this.config.l[layerCode].ts : undefined;
    }
}
/**
 * The configuration of the map
 * @extends MainConfig
 * @hideconstructor
 */ class $7b49815d769de08a$export$1c12e753ef4b5df7 extends (0, $2a1bdf5b8bad2f9b$export$f6e3e72c68493c4c) {
    getClassName() {
        return "MapConfig";
    }
    getName() {
        return this.config.map.name;
    }
    getCode() {
        return this.config.map.code;
    }
    /**
     * Current map zoom level
     * @return {number} (integer)
     */ getZoomLevel() {
        return this.config.map.zoomLevel;
    }
    /**
     * Current map center in WGS84
     * @return {Array<number>}
     */ getCenterLonLatWgs84() {
        return this.config.map.centerLonLatWgs84;
    }
    _getStatsPostUrlProperty() {
        return this.config.map.statsPostUrl;
    }
    _getContactPostUrlProperty() {
        return this.config.map.contactPostUrl;
    }
    /**
     * Maximum map extent in WGS84
     * @return {Array<number>}
     */ getMaxExtentWgs84() {
        return this.config.map.maxExtent ? this.config.map.maxExtent : [
            -180,
            -90,
            180,
            90
        ];
    }
    /**
     * List of available projections
     * @return {Array<Projection>}
     */ getProjectionConfigs() {
        let projs = [];
        if (this.config.projections) for(let p in this.config.projections)projs.push(new (0, $2a1bdf5b8bad2f9b$export$dfa3a012bb2ef2e1)(this.config.projections[p]));
        return projs;
    }
    /**
     * Memory cached version of the list of available projections
     * @return {Array<Projection>}
     */ getCachedProjectionConfigs() {
        if (!this.cachedProjectionConfigs) this.cachedProjectionConfigs = this.getProjectionConfigs();
        return this.cachedProjectionConfigs;
    }
    /**
     * Memory cached version of a projection given its EPSG code
     * @param code {string}
     * @return {Projection}
     */ getCachedProjectionConfig(code) {
        if (!this.cachedProjectionConfigsMap) {
            this.cachedProjectionConfigsMap = {};
            for(let cpc in this.getCachedProjectionConfigs()){
                const cachedProjectionConfig = this.getCachedProjectionConfigs()[cpc];
                this.cachedProjectionConfigsMap[cachedProjectionConfig.getCode()] = cachedProjectionConfig;
            }
        }
        return this.cachedProjectionConfigsMap[code];
    }
    /**
     * All the configs for the layer tree
     * @param includeDisabled {boolean} if true, includes disabled elements
     * @return {Array<LayerTreeElementConfig>}
     */ getLayerConfigTree(includeDisabled = false) {
        const layerConfigTree = [];
        for(const lt in this.config.map.layerTree){
            const conf = this.config.map.layerTree[lt];
            if (conf.type === (0, $815c91046e476159$export$9ae7e512bcbacef8).CLASSIFIER.getCode()) {
                const layerTreeClassifierConfig = new $7b49815d769de08a$var$LayerTreeClassifierConfig(conf, this.allLayerServices, this.allProducts, this.allStyles);
                if (includeDisabled || !layerTreeClassifierConfig.isDisabled()) layerConfigTree.push(layerTreeClassifierConfig);
            } else if (conf.type === (0, $815c91046e476159$export$9ae7e512bcbacef8).LAYER.getCode()) {
                const layerConfig = new (0, $2a1bdf5b8bad2f9b$export$1e0909f3e93883c6)(conf, this.allLayerServices, this.allProducts, this.allStyles);
                if (includeDisabled || !layerConfig.isDisabled()) layerConfigTree.push(layerConfig);
            }
        }
        return layerConfigTree;
    }
    /**
     * This map's base layers configs
     * @param includeDisabled {boolean} if true, includes disabled elements
     * @return {Array<LayerListElementConfig>}
     */ getBaseLayerConfigList(includeDisabled = false) {
        const baseLayerConfigList = [];
        for(const lt in this.config.map.baseLayers){
            const conf = this.config.map.baseLayers[lt];
            if (conf.type === (0, $815c91046e476159$export$9ae7e512bcbacef8).CLASSIFIER.getCode()) {
                const layerListClassifierConfig = new $7b49815d769de08a$var$LayerListClassifierConfig("BaseLayerConfig", conf, this.allLayerServices, this.allProducts, this.allStyles);
                if (includeDisabled || !layerListClassifierConfig.isDisabled()) baseLayerConfigList.push(layerListClassifierConfig);
            } else {
                const baseLayerConfig = new (0, $2a1bdf5b8bad2f9b$export$c222b966508fa8e1)(conf, this.allLayerServices[conf.srvCode], this.allProducts[conf.prodCode], this.allStyles);
                if (includeDisabled || !baseLayerConfig.isDisabled()) baseLayerConfigList.push(baseLayerConfig);
            }
        }
        return baseLayerConfigList;
    }
    /**
     * This map's context layers configs
     * @param includeDisabled {boolean} if true, includes disabled elements
     * @return {Array<LayerListElementConfig>}
     */ getContextLayerConfigList(includeDisabled = false) {
        const contextLayerConfigList = [];
        for(const lt in this.config.map.contextLayers){
            const conf = this.config.map.contextLayers[lt];
            if (conf.type === (0, $815c91046e476159$export$9ae7e512bcbacef8).CLASSIFIER.getCode()) {
                const layerListClassifierConfig = new $7b49815d769de08a$var$LayerListClassifierConfig("ContextLayerConfig", conf, this.allLayerServices, this.allProducts, this.allStyles);
                if (includeDisabled || !layerListClassifierConfig.isDisabled()) contextLayerConfigList.push(layerListClassifierConfig);
            } else {
                const contextLayerConfig = new (0, $2a1bdf5b8bad2f9b$export$c8433908084f1689)(conf, this.allLayerServices[conf.srvCode], this.allProducts[conf.prodCode], this.allStyles);
                if (includeDisabled || !contextLayerConfig.isDisabled()) contextLayerConfigList.push(contextLayerConfig);
            }
        }
        return contextLayerConfigList;
    }
    /**
     * All tool configs
     * @return {Array<ToolConfig>}
     */ getToolConfigs() {
        if (!this.tools) {
            this.tools = [];
            for(let tg in this.config.tools)this.tools.push(new $7b49815d769de08a$export$3e26c641e48878e0(this.config.tools[tg]));
        }
        return this.tools;
    }
    /**
     * Zoom levels
     * @return {ZoomLevels|undefined}
     */ getZoomLevels() {
        return this.config.map.zoomLevels ? new (0, $2a1bdf5b8bad2f9b$export$dca8ec0f6805469d)(this.config.map.zoomLevels) : undefined;
    }
    /**
     *
     * @return {Projection}
     */ getProjection() {
        const projectionCode = this.config.map.projection && this.config.map.projection.trim().length > 0 ? this.config.map.projection.trim() : (0, $9bc5df2b24a7fcf6$export$6dd85527b263c26d);
        return this.getCachedProjectionConfigs().filter((p)=>p.getCode() === projectionCode)[0];
    }
    /**
     * Override this config
     * @param runtimeConfig {MapRuntimeConfig} The configuration override
     */ override(runtimeConfig) {
        if (runtimeConfig.getZoomLevel() !== undefined) this.config.map.zoomLevel = runtimeConfig.getZoomLevel();
        if (runtimeConfig.getCenterLonLatWgs84() !== undefined) this.config.map.centerLonLatWgs84 = runtimeConfig.getCenterLonLatWgs84();
        this.getBaseLayerConfigList().forEach((element)=>{
            element.override(runtimeConfig);
            if (element instanceof $7b49815d769de08a$var$LayerListClassifierConfig) element.getChildren().forEach((e)=>e.override(runtimeConfig));
        });
        this.getContextLayerConfigList().forEach((element)=>{
            element.override(runtimeConfig);
            if (element instanceof $7b49815d769de08a$var$LayerListClassifierConfig) element.getChildren().forEach((e)=>e.override(runtimeConfig));
        });
        function overrideTreeElements(layerTreeElementConfigs) {
            if (layerTreeElementConfigs.length === 0) return;
            for(let lte in layerTreeElementConfigs){
                let layerTreeElementConfig = layerTreeElementConfigs[lte];
                layerTreeElementConfig.override(runtimeConfig);
                overrideTreeElements(layerTreeElementConfig.getChildren());
            }
        }
        overrideTreeElements(this.getLayerConfigTree());
    }
    /**
     * Verify this configuration and return a list of errors
     * @return {Array<string>}
     */ verify() {
        let errors = super.verify();
        if (!this.getMaxExtentWgs84()) errors.push('MapConfig: maxExtentLonLatWgs84 is mandatory');
        else if (!(0, $9bc5df2b24a7fcf6$export$867fb2209883d6bf)(this.getMaxExtentWgs84())) errors.push('MapConfig: invalid maxExtentLonLatWgs84. Should be [minLon, minLat, maxLon, maxLat]');
        if (this.getCenterLonLatWgs84()) {
            if (!(0, $9bc5df2b24a7fcf6$export$861ac51a64fd27a8)(this.getCenterLonLatWgs84())) errors.push('MapConfig: invalid centerLonLatWgs84. Should be [lon, lat]');
        }
        const projectionConfigs = this.getProjectionConfigs();
        if (projectionConfigs.length === 0) errors.push('MapConfig: projections is mandatory');
        else for(let p in projectionConfigs)errors = errors.concat(projectionConfigs[p].verify());
        if (Object.keys(this.allProducts).length === 0) errors.push('MapConfig: products is mandatory');
        else for(let p in this.allProducts)errors = errors.concat(this.allProducts[p].verify());
        if (Object.keys(this.allLayerServices).length === 0) errors.push('MapConfig: services is mandatory');
        else for(let p in this.allLayerServices)errors = errors.concat(this.allLayerServices[p].verify());
        if (Object.keys(this.allStyles).length === 0) errors.push('MapConfig: styles is mandatory');
        else for(let p in this.allStyles)errors = errors.concat(this.allStyles[p].verify());
        const zoomLevels = this.getZoomLevels();
        if (!zoomLevels) errors.push('MapConfig: zoomLevels is mandatory');
        else {
            errors = errors.concat(zoomLevels.verify());
            const levels = zoomLevels.getLevels();
            if (!levels || levels < 1 || levels > (0, $9bc5df2b24a7fcf6$export$6ca86169e9c2a79e).length) errors.push('MapConfig: levels must be a number between 1 and ' + (0, $9bc5df2b24a7fcf6$export$6ca86169e9c2a79e).length);
            const zoomLevel = this.getZoomLevel();
            if (zoomLevel !== undefined && (zoomLevel < 0 || zoomLevel > zoomLevels.getMaxResolutionIndex())) errors.push('MapConfig: invalid zoomLevel');
        }
        const baseLayerListElements = this.getBaseLayerConfigList(true);
        let baseLayersVisibleCount = 0;
        if (!baseLayerListElements || baseLayerListElements.filter((bl)=>!bl.isDisabled()).length === 0) errors.push('MapConfig: baseLayers is mandatory');
        else {
            for(let ble in baseLayerListElements){
                errors = errors.concat(baseLayerListElements[ble].verify());
                if (!baseLayerListElements[ble].isDisabled()) {
                    if (baseLayerListElements[ble] instanceof (0, $2a1bdf5b8bad2f9b$export$c222b966508fa8e1)) {
                        if (baseLayerListElements[ble].isVisible()) baseLayersVisibleCount++;
                    } else {
                        const baseLayerConfigs = baseLayerListElements[ble].getChildren();
                        for(const bl in baseLayerConfigs)if (baseLayerConfigs[bl].isVisible()) baseLayersVisibleCount++;
                    }
                }
            }
            if (baseLayersVisibleCount !== 1) errors = errors.concat("MapConfig: One and only one base layer must be visible");
        }
        const contextLayerListElements = this.getContextLayerConfigList(true);
        for(const cle in contextLayerListElements)errors = errors.concat(contextLayerListElements[cle].verify());
        let layerTree = this.getLayerConfigTree(true);
        if (!layerTree || layerTree.filter((bl)=>!bl.isDisabled()).length === 0) errors.push('MapConfig: layerTree is mandatory');
        else for(let lte in layerTree)errors = errors.concat(layerTree[lte].verify());
        let toolConfigs = this.getToolConfigs();
        if (!toolConfigs || toolConfigs.length === 0) errors.push('MapConfig: tools is mandatory');
        else for(let tg in toolConfigs)errors = errors.concat(toolConfigs[tg].verify());
        return errors;
    }
}
/**
 * The config of layer tree classifier, which is a tree node
 * @extends LayerTreeElementConfig
 */ class $7b49815d769de08a$var$LayerTreeClassifierConfig extends (0, $2a1bdf5b8bad2f9b$export$c050f652724ec965) {
    /**
     *
     * @param config {Object} This classifier config
     * @param allLayerServices {Object<string,LayerServiceConfig>} All the available layer services by code
     * @param allProducts {Object<String,ProductConfig>} All the available products
     * @param allStyles {Object<String,Style>} All the available styles
     */ constructor(config, allLayerServices, allProducts, allStyles){
        super(config);
        this.allLayerServices = allLayerServices;
        this.allProducts = allProducts;
        this.allStyles = allStyles;
    }
    getClassName() {
        return "LayerTreeClassifierConfig";
    }
    /**
     * The name of this classifier
     * @return {string}
     */ getName() {
        return this.config.name;
    }
    /**
     * Is this classifier expanded?
     * @return {boolean}
     */ isExpanded() {
        return this.config.expanded === true;
    }
    /**
     * Is this classifier mutually exclusive.
     * If true, one and only one of its children must be visible
     * @return {boolean}
     */ isMutuallyExclusive() {
        return this.config.mutuallyExclusive;
    }
    getChildren(includeDisabled = false) {
        let children = [];
        for(let c in this.config.children){
            const conf = this.config.children[c];
            if (conf.type === (0, $815c91046e476159$export$9ae7e512bcbacef8).CLASSIFIER.getCode()) {
                const classifier = new $7b49815d769de08a$var$LayerTreeClassifierConfig(conf, this.allLayerServices, this.allProducts, this.allStyles);
                if (includeDisabled || !classifier.isDisabled()) children.push(classifier);
            } else if (conf.type === (0, $815c91046e476159$export$9ae7e512bcbacef8).LAYER.getCode()) {
                const layer = new (0, $2a1bdf5b8bad2f9b$export$1e0909f3e93883c6)(conf, this.allLayerServices, this.allProducts, this.allStyles);
                if (includeDisabled || !layer.isDisabled()) children.push(layer);
            }
        }
        return children;
    }
    override(runtimeConfig) {
        super.override(runtimeConfig);
        if (runtimeConfig.getClassifierExpanded(this.getCode()) !== undefined) this.config.expanded = runtimeConfig.getClassifierExpanded(this.getCode());
        if (runtimeConfig.getClassifierVisibility(this.getCode()) !== undefined) this.config.visible = runtimeConfig.getClassifierVisibility(this.getCode());
    }
    verify() {
        let errors = super.verify(this);
        if (!this.getName() || this.getName().length === 0) errors.push(this.getLogId() + ": name is mandatory");
        let children = this.getChildren(true);
        let visibleChildrenCount = 0;
        const ordinalCounts = {};
        for(let c in children){
            errors = errors.concat(children[c].verify());
            if (!children[c].isDisabled()) {
                if (children[c].isVisible()) visibleChildrenCount++;
                if (children[c].getRenderOrdinal() !== null && children[c].getRenderOrdinal() !== undefined) ordinalCounts[children[c].getRenderOrdinal()] = ordinalCounts[children[c].getRenderOrdinal()] ? ordinalCounts[children[c].getRenderOrdinal()] + 1 : 1;
            }
        }
        if (this.isMutuallyExclusive() && visibleChildrenCount !== 1) errors.push(this.getLogId() + ": one and only one child must be visible");
        const ordinalKeys = Object.keys(ordinalCounts);
        if (ordinalKeys.length > 0 && ordinalKeys.length !== children.length) errors.push(this.getLogId() + ": If an ordinal is defined for a child of a classifier, every sibling must have a unique ordinal");
        return errors;
    }
}
/**
 * The config of layer list classifier, which is a tree node
 * @extends LayerListElementConfig
 */ class $7b49815d769de08a$var$LayerListClassifierConfig extends (0, $2a1bdf5b8bad2f9b$export$9c228ca1dafbb77) {
    /**
     * @param layerClass {string} Class name of the layers of this classifier (base or context?)
     * @param config {Object} This classifier config
     * @param allLayerServices {Object<string,LayerServiceConfig>} All the available layer services by code
     * @param allProducts {Object<String,ProductConfig>} All the available products
     * @param allStyles {Object<String,Style>} All the available styles
     */ constructor(layerClass, config, allLayerServices, allProducts, allStyles){
        super(config);
        this.allLayerServices = allLayerServices;
        this.allProducts = allProducts;
        this.allStyles = allStyles;
        this.layerClass = layerClass;
    }
    getClassName() {
        return "LayerListClassifierConfig";
    }
    /**
     * The name of this classifier
     * @return {string}
     */ getName() {
        return this.config.name;
    }
    /**
     * Is this classifier expanded?
     * @return {boolean}
     */ isExpanded() {
        return this.config.expanded === true;
    }
    getChildren(includeDisabled = false) {
        let children = [];
        for(let c in this.config.children){
            const conf = this.config.children[c];
            if (this.layerClass === 'BaseLayerConfig') {
                const baseLayerConfig = new (0, $2a1bdf5b8bad2f9b$export$c222b966508fa8e1)(conf, this.allLayerServices[conf.srvCode], this.allProducts[conf.prodCode], this.allStyles);
                if (includeDisabled || !baseLayerConfig.isDisabled()) children.push(baseLayerConfig);
            } else if (this.layerClass === 'ContextLayerConfig') {
                const contextLayerConfig = new (0, $2a1bdf5b8bad2f9b$export$c8433908084f1689)(conf, this.allLayerServices[conf.srvCode], this.allProducts[conf.prodCode], this.allStyles);
                if (includeDisabled || !contextLayerConfig.isDisabled()) children.push(contextLayerConfig);
            }
        }
        return children;
    }
    override(runtimeConfig) {
        super.override(runtimeConfig);
        if (runtimeConfig.getClassifierExpanded(this.getCode()) !== undefined) this.config.expanded = runtimeConfig.getClassifierExpanded(this.getCode());
    }
    verify() {
        let errors = super.verify(this);
        if (!this.getName() || this.getName().length === 0) errors.push(this.getLogId() + ": name is mandatory");
        let children = this.getChildren();
        for(let c in children)errors = errors.concat(children[c].verify());
        return errors;
    }
}
/**
 * A tool configuration
 * @extends CodeUniqueNameInfoConfig
 * @hideconstructor
 */ class $7b49815d769de08a$export$3e26c641e48878e0 extends (0, $9bc5df2b24a7fcf6$export$6066b86ada1a6d13) {
    getClassName() {
        return "ToolConfig";
    }
    /**
     * Device visibility of this tool
     * @return {DeviceVisibilityEnum}
     */ getDeviceVisibility() {
        return (0, $815c91046e476159$export$54c4fd5984b65e0b).getForCode(this.config.deviceVisibility);
    }
    verify() {
        let errors = super.verify();
        if (this.config.deviceVisibility && this.config.deviceVisibility.length > 0 && !(0, $815c91046e476159$export$54c4fd5984b65e0b).exists(this.config.deviceVisibility)) errors.push(this.getLogId() + ": invalid deviceVisibility. Possible values: " + (0, $815c91046e476159$export$54c4fd5984b65e0b).getPossibleCodes());
        return errors;
    }
    /**
     * A map of other properties, specific for certain tools.
     * Each tool implementation should know what to look for in here, if anything at all
     * @return {Object<string,*>}
     */ getOtherProperties() {
        let otherProperties = {};
        Object.keys(this.config).forEach((key, index)=>{
            if (key !== 'code' && key !== 'nameKey' && key !== 'infoKey') otherProperties[key] = this.config[key];
        });
        return otherProperties;
    }
}


class $a8b50c93b8e58daf$export$e6ffe83a8c109830 extends (0, $5180cc201ee0f189$export$d1dc5266372a764e) {
    /**
     *
     * @param id {string} An HTML id for this indicator chart
     * @param translator {Translator} A translator
     * @param indicator {Indicator} The indicator of this chart
     * @param until {Date} The end date for the chart is fixed
     * @param infoModal {Modal} A modal window to show indicator metadata in
     * @param runtimeConfig {RuntimeConfig} The map runtime config
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     */ constructor(id, translator, indicator, until, infoModal, runtimeConfig, isMobileDevice){
        super(id, translator, undefined, indicator, infoModal, runtimeConfig, isMobileDevice);
        this.until = until;
        this._calculateDates();
    }
    getClassName() {
        return "NavigableIndicatorChart";
    }
    _calculateDates() {
        this.originalUntil = this.until;
        const timeCalculator = this.layer.getTimeCalculator();
        const max = timeCalculator.min(this.layer.getDataUntil(), timeCalculator.fixDateUntil(timeCalculator.addDays(this.until, 30)));
        while(this.until <= max)this.until = timeCalculator.getNextDate(this.until);
        this.from = timeCalculator.fixDate(timeCalculator.addDays(this.originalUntil, -730));
    }
    getContainerElement() {
        const containerElement = super.getContainerElement();
        this.loader.show();
        containerElement.addClass('navigable');
        const chartContainerElement = $dc57b31f1b066f38$exports('.body .chart-container', containerElement);
        $dc57b31f1b066f38$exports('.body', containerElement).remove(chartContainerElement).prepend('<div class="no-data">' + this.translator.translate('tool.charts.noData') + '</div>').prepend($dc57b31f1b066f38$exports('<div class="date-picker-chart-container"></div>').append(chartContainerElement));
        return containerElement;
    }
    _initDatePicker() {
        this.simplifiedDatePicker = new (0, $898561d63e8ae729$export$e071f2a061538330)(this.id + '_simplified_date_picker', this.translator, this.layer, this.layer.getTimeCalculator().fixDate(this.until), this.layer.getTimeCalculator().fixDate(this.from), this.isMobileDevice);
        const onchangeDatePicker = (picker)=>this.setFrom(picker.getFrom());
        this.simplifiedDatePicker.onChange(onchangeDatePicker);
        onchangeDatePicker(this.simplifiedDatePicker);
    }
    _updateChart() {
        if (this.from && this.until && this.wgs84Coords) {
            super._updateChart();
            $dc57b31f1b066f38$exports('.date-picker-chart-container .simplified-date-picker', this.getUIElement()).remove();
            this._initDatePicker();
            if (this.simplifiedDatePicker) {
                $dc57b31f1b066f38$exports('.chart', this.getUIElement()).removeClass('no-data-chart');
                $dc57b31f1b066f38$exports('.no-data', this.getUIElement()).hide();
                $dc57b31f1b066f38$exports('.date-picker-chart-container', this.getUIElement()).prepend(this.simplifiedDatePicker.getUIElement());
            } else {
                $dc57b31f1b066f38$exports('.chart', this.getUIElement()).addClass('no-data-chart');
                $dc57b31f1b066f38$exports('.no-data', this.getUIElement()).show();
            }
            this.loader.hide();
        }
    }
    /**
     * Given a data object form the service, extract data for this indicator
     * To be overridden by specialized charts
     * @param dataFromService {Object}
     * @protected
     */ _extractChartData(dataFromService) {}
    /**
     * Set the from date
     * @param from {Date}
     * @param update {boolean} Should the chart be updated
     */ setFrom(from, update = true) {
        if (from) {
            this.from = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(from);
            this.unboundedFrom = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(from);
            this._updateFigCaptionContent();
            if (update) this._generateChartElements();
        }
    }
    /**
     *
     * @param until {Date}
     * @param wgs84Coords {Array<number>} 2 elements array with lon lat wgs84
     * @param update {boolean} Should the chart be updated?
     */ setUntilAndCoords(until, wgs84Coords, update = true) {
        if (until) {
            this.until = until;
            this._calculateDates();
        }
        if (wgs84Coords && (!this.wgs84Coords || this.wgs84Coords[0] !== wgs84Coords[0] || this.wgs84Coords[1] !== wgs84Coords[1])) this.timeseriesFetcher = this.layer.getTimeseriesFetcher(wgs84Coords);
        this.wgs84Coords = wgs84Coords;
        if (update) this._updateChart();
    }
    _generateChartElements() {
        const timeseriesProcessor = this.layer.getTimeseriesProcessor(this.chartData);
        const data = timeseriesProcessor.getData(this.from, this.until);
        if (data) {
            const prodCode = this.layer.getProductConfig().getCode();
            this._renderChart(data, false, this.originalUntil);
            const downloadButton = $dc57b31f1b066f38$exports('<button class="download-data-button transparent" title="' + this.translator.translate('tool.charts.download.csv') + '"></button>');
            downloadButton.click(()=>this._downloadData(prodCode));
            $dc57b31f1b066f38$exports('.body .indicator-buttons-container', this.uiElement).empty().append(downloadButton);
        } else {
            $dc57b31f1b066f38$exports('.body .indicator-buttons-container', this.uiElement).empty();
            $dc57b31f1b066f38$exports('.container .body .chart-container', this.uiElement).append($dc57b31f1b066f38$exports('<div class="no-layers">Error loading data</div>'));
        }
        this.loader.hide();
    }
}


/**
 * Chart element for RDrIA
 * @extends NavigableIndicatorChart
 * @hideconstructor
 */ class $5e9f90cc5b9247f8$export$1e391ec2a4382f23 extends (0, $a8b50c93b8e58daf$export$e6ffe83a8c109830) {
    /**
     *
     * @param id {string} An HTML id for this indicator chart
     * @param translator {Translator} A translator
     * @param gdordriaValuesUrl {string}
     * @param gdordriaMapImgUrl {string}
     * @param indicator {Indicator} The indicator of this chart
     * @param until {Date} The end date for the chart is fixed
     * @param infoModal {Modal} A modal window to show indicator metadata in
     * @param runtimeConfig {RuntimeConfig} The map runtime config
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     */ constructor(id, translator, gdordriaValuesUrl, gdordriaMapImgUrl, indicator, until, infoModal, runtimeConfig, isMobileDevice){
        super(id, translator, indicator, until, infoModal, runtimeConfig, isMobileDevice);
        this.gdordriaValuesUrl = gdordriaValuesUrl;
        this.gdordriaMapImgUrl = gdordriaMapImgUrl;
    }
    getClassName() {
        return "GDORDrIaChart";
    }
    _getSimpleStatsShower(data) {
        return undefined;
    }
    /**
     *
     * @param until {Date} The date until when to show data
     * @param wgs84Coords {Array<number>} 2 position array with coords lon lat in wgs84
     * @param mapImgUrl {string} The URL for the map image
     * @param aruId {string} The id of the chart region
     * @param regionArea {number} The area of the chart region (m2)
     * @param countryCode {string} The id of the city
     */ setChartParams(until, wgs84Coords, mapImgUrl, aruId, regionArea, countryCode) {
        this.aruId = aruId;
        this.regionArea = regionArea;
        this.countryCode = countryCode;
        this.mapImgUrl = mapImgUrl;
        if (this.imgComparisonLoaded) {
            this.imgComparisonLoaded = false;
            this._updateComparisonImages();
        }
        super.setUntilAndCoords(until, wgs84Coords, true);
    }
    _extractChartData(dataFromService) {
        const alerts = dataFromService.features[0].properties.alerts;
        const valsForProcessor = {};
        Object.keys(alerts).forEach((dateStr)=>{
            const date = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(dateStr.slice(0, 4) + '-' + dateStr.slice(4, 6) + '-' + dateStr.slice(6, 8));
            if (alerts[dateStr]) {
                const low = alerts[dateStr]['1'] ? alerts[dateStr]['1'].part : 0;
                const medium = alerts[dateStr]['2'] ? alerts[dateStr]['2'].part : 0;
                const high = alerts[dateStr]['3'] ? alerts[dateStr]['3'].part : 0;
                valsForProcessor[(0, $aeedcab592f41cce$export$3ae94a2503e890a1)(date)] = {
                    '1': low * 100,
                    '2': medium * 100,
                    '3': high * 100
                };
            } else valsForProcessor[(0, $aeedcab592f41cce$export$3ae94a2503e890a1)(date)] = null;
        });
        return valsForProcessor;
    }
    _updateChart() {
        if (this.aruId && this.regionArea) $dc57b31f1b066f38$exports.getJSON(this.gdordriaValuesUrl.format([
            "" + this.aruId
        ]), (fCol)=>{
            this.chartData = this._extractChartData(fCol);
            const imgContainer = $dc57b31f1b066f38$exports('.map-img-container', this.getUIElement());
            if (this.mapImgUrl) {
                $dc57b31f1b066f38$exports('img.map-img', imgContainer).attr('src', (0, $2536f84a954bf107$export$730687a846e4e808)(this.mapImgUrl));
                imgContainer.show();
            } else imgContainer.hide();
            const refDate = (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.layer.getTimeCalculator().fixDate(this.originalUntil)).replaceAll('-', '');
            const alert = fCol.features[0].properties.alerts[refDate];
            const affected = {};
            if (alert) Object.keys(alert).filter((a)=>a !== "0").forEach((a)=>affected[a] = {
                    area: alert[a].part * this.regionArea,
                    part: alert[a].part
                });
            const untilStr = (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.layer.getTimeCalculator().fixDate(this.originalUntil));
            const timeStr = this.translator.translate('tool.charts.stats.title', [
                this.layer.getTimeCalculator().timeCodeToString(untilStr).toLowerCase()
            ]);
            const table = $dc57b31f1b066f38$exports('<div class="stats">   <table class="values">      <thead><tr><th>' + timeStr + '</th><th>' + this.translator.translate('tool.charts.stats.area') + '</th><th>' + this.translator.translate('tool.charts.stats.perc') + '</th></tr></thead>' + '      <tbody></tbody>' + '   </table>' + '</div>');
            Object.keys(affected).forEach((value)=>{
                const label = this.layer.getChartStyler().getLabelFunction()(value);
                const color = this.layer.getChartStyler().getColorFunction()(value);
                $dc57b31f1b066f38$exports('tbody', table).append($dc57b31f1b066f38$exports('<tr><td><div class="color" style="background-color: ' + color + '"></div><label>' + label + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(affected[value].area / 1000000, 2) + '</td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(affected[value].part * 100, 2) + '</td></tr>'));
            });
            const partSum = Object.keys(affected).map((a)=>affected[a].part).reduce((p, c)=>p + c, 0);
            $dc57b31f1b066f38$exports('tbody', table).append($dc57b31f1b066f38$exports('<tr><td><label>' + this.translator.translate('tool.charts.stats.totalAffected') + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(this.regionArea * partSum / 1000000, 2) + '</td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(partSum * 100, 2) + '</td></tr>'));
            $dc57b31f1b066f38$exports('tbody', table).append($dc57b31f1b066f38$exports('<tr><td><label>' + this.translator.translate('tool.charts.stats.wholeReportingUnit') + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(this.regionArea / 1000000, 2) + '</td><td></td></tr>'));
            $dc57b31f1b066f38$exports('.stats-container', this.getUIElement()).empty().append(table);
            super._updateChart();
        });
    }
    getContainerElement() {
        const containerElement = super.getContainerElement().addClass('map-img-chart').addClass('gdoria');
        $dc57b31f1b066f38$exports('.date-picker-chart-container', containerElement).removeClass('date-picker-chart-container');
        const statsAndChart = $dc57b31f1b066f38$exports('<div class="stats-chart-container"></div>');
        const stats = $dc57b31f1b066f38$exports('<div class="stats-container"></div>');
        statsAndChart.append(stats);
        const chartContainer = $dc57b31f1b066f38$exports('.chart-container', containerElement);
        chartContainer.addClass('date-picker-chart-container');
        containerElement.remove('.chart-container');
        statsAndChart.append(chartContainer);
        const img = $dc57b31f1b066f38$exports('<div class="map-img-container"><img alt="' + this.layer.getName() + '" class="map-img"/></div>');
        $dc57b31f1b066f38$exports('.body', containerElement).prepend(this._getImagesComparisonElement()).prepend(statsAndChart).prepend(img);
        if (!this.mapImgUrl) img.hide();
        else $dc57b31f1b066f38$exports('img', img).attr('src', this.mapImgUrl);
        return containerElement;
    }
    _getImagesComparisonElement() {
        const comparisonButton = $dc57b31f1b066f38$exports('<a class="img-comparison-controller">[' + this.translator.translate("tool.charts.gdordria.comparison.show") + ']</a>').click(()=>{
            if (!this.imgComparisonLoaded) this._updateComparisonImages();
            $dc57b31f1b066f38$exports('.img-container', this.uiElement).toggle();
            if ($dc57b31f1b066f38$exports('.img-container', this.uiElement).is(':visible')) this.logStat('SHOW_COMPARISON');
            else this.logStat('HIDE_COMPARISON');
        });
        const controllerDiv = $dc57b31f1b066f38$exports('<div class="img-comparison-controller-container"><h3>' + this.translator.translate("tool.charts.gdordria.comparison.title") + '</h3></div>').append(comparisonButton);
        return $dc57b31f1b066f38$exports('<div class="img-comparison-container"></div>').append(controllerDiv).append($dc57b31f1b066f38$exports('<div class="img-container"></div>'));
    }
    _updateComparisonImages() {
        this.imgComparisonLoaded = true;
        const imgTarget = $dc57b31f1b066f38$exports('.img-container', this.uiElement).empty();
        let date = this.until;
        for(let i = 0; i < 9; i++){
            const timeCode = (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(date);
            const formattedUrl = this.gdordriaMapImgUrl.format([
                timeCode,
                this.wgs84Coords[0] + "",
                this.wgs84Coords[1] + "",
                this.aruId,
                this.countryCode
            ]);
            const timeStr = this.layer.getTimeCalculator().timeCodeToString(timeCode);
            const imgElement = $dc57b31f1b066f38$exports('<div class="comparison-img"><div class="img-time">' + timeStr + '</div></div>').addClass(timeCode === (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.originalUntil) ? 'original-until' : '');
            imgTarget.prepend(imgElement);
            $dc57b31f1b066f38$exports.get(formattedUrl, (urls)=>{
                const img = $dc57b31f1b066f38$exports('<img width="300" alt="map ' + timeStr + '" src="' + (0, $2536f84a954bf107$export$730687a846e4e808)(urls['main']) + '"/>');
                imgElement.prepend(img);
            });
            date = this.layer.getTimeCalculator().getPreviousDate(date);
        }
    }
}






/**
 * A navigable indicator chart that has a map image
 * @abstract
 * @extends NavigableIndicatorChart
 * @hideconstructor
 */ class $d697a844ca5a91b2$export$1eedea5acc78261c extends (0, $a8b50c93b8e58daf$export$e6ffe83a8c109830) {
    getClassName() {
        return "MapImgNavigatableIndicatorChart";
    }
    _getSimpleStatsShower(data) {
        return undefined;
    }
    /**
     *
     * @param until {Date} The date until when to show data
     * @param wgs84Coords {Array<number>} 2 position array with coords lon lat in wgs84
     * @param mapImgUrls {string} The URL for the map image
     * @param dataFromService {Object} The data for the chart
     * @param regionArea {number} The area of the chart region (m2)
     */ setChartParams(until, wgs84Coords, mapImgUrls, dataFromService, regionArea) {
        this.mapImgUrl = mapImgUrls ? Object.keys(mapImgUrls).filter((k)=>this.layer.getCode().toLowerCase().indexOf(k.toLowerCase()) >= 0 || k.toLowerCase().indexOf(this.layer.getCode().toLowerCase()) >= 0).map((k)=>mapImgUrls[k])[0] : undefined;
        super.setUntilAndCoords(until, wgs84Coords, false);
        this.regionArea = regionArea;
        if (dataFromService) {
            this.chartData = this._extractChartData(dataFromService);
            this._updateChart();
        }
        const imgContainer = $dc57b31f1b066f38$exports('.map-img-container', this.getUIElement());
        if (this.mapImgUrl) {
            $dc57b31f1b066f38$exports('img.map-img', imgContainer).attr('src', (0, $2536f84a954bf107$export$730687a846e4e808)(this.mapImgUrl));
            imgContainer.show();
        } else imgContainer.hide();
    }
    _updateChart() {
        if (this.chartData) {
            super._updateChart();
            const refDate = (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.layer.getTimeCalculator().fixDate(this.originalUntil));
            const element = this.chartData[refDate];
            const affected = {};
            if (element) Object.keys(element).forEach((a)=>affected[a] = {
                    area: element[a] / 100 * this.regionArea,
                    part: element[a]
                });
            const untilStr = (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.layer.getTimeCalculator().fixDate(this.originalUntil));
            const timeStr = this.translator.translate('tool.charts.stats.title', [
                this.layer.getTimeCalculator().timeCodeToString(untilStr).toLowerCase()
            ]);
            const table = $dc57b31f1b066f38$exports('<div class="stats">   <table class="values">      <thead><tr><th>' + timeStr + '</th><th>' + this.translator.translate('tool.charts.stats.area') + '</th><th>' + this.translator.translate('tool.charts.stats.perc') + '</th></tr></thead>' + '      <tbody></tbody>' + '   </table>' + '</div>');
            const timeseriesProcessor = this.layer.getTimeseriesProcessor(this.chartData);
            Object.keys(affected).forEach((clazz)=>{
                const value = timeseriesProcessor.getClassToValue(clazz);
                const label = this.layer.getChartStyler().getLabelFunction()(value);
                const color = this.layer.getChartStyler().getColorFunction()(value);
                $dc57b31f1b066f38$exports('tbody', table).append($dc57b31f1b066f38$exports('<tr><td><div class="color" style="background-color: ' + color + '"></div><label>' + label + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(affected[clazz].area / 1000000, 2) + '</td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(affected[clazz].part, 2) + '</td></tr>'));
            });
            const partDiff = 100 - Object.keys(affected).map((a)=>affected[a].part).reduce((p, c)=>p + c, 0);
            $dc57b31f1b066f38$exports('tbody', table).append($dc57b31f1b066f38$exports('<tr><td><label>' + this.translator.translate('tool.charts.stats.noData') + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(this.regionArea * (partDiff / 100) / 1000000, 2) + '</td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(partDiff, 2) + '</td></tr>'));
            $dc57b31f1b066f38$exports('tbody', table).append($dc57b31f1b066f38$exports('<tr><td><label>' + this.translator.translate('tool.charts.stats.wholeReportingUnit') + '</label></td><td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(this.regionArea / 1000000, 2) + '</td><td></td></tr>'));
            $dc57b31f1b066f38$exports('.stats-container', this.getUIElement()).empty().append(table);
        }
    }
    _calcBarWidth(x) {
        const width = super._calcBarWidth(x);
        return width.slice(0, width.length - 1);
    }
    getContainerElement() {
        const containerElement = super.getContainerElement();
        containerElement.addClass('map-img-chart');
        $dc57b31f1b066f38$exports('.date-picker-chart-container', containerElement).removeClass('date-picker-chart-container');
        const statsAndChart = $dc57b31f1b066f38$exports('<div class="stats-chart-container"></div>');
        const stats = $dc57b31f1b066f38$exports('<div class="stats-container"></div>');
        statsAndChart.append(stats);
        const chartContainer = $dc57b31f1b066f38$exports('.chart-container', containerElement);
        chartContainer.addClass('date-picker-chart-container');
        containerElement.remove('.chart-container');
        statsAndChart.append(chartContainer);
        const img = $dc57b31f1b066f38$exports('<div class="map-img-container"><img alt="' + this.layer.getName() + ' map image" class="map-img"/></div>');
        $dc57b31f1b066f38$exports('.body', containerElement).prepend(statsAndChart).prepend(img);
        if (!this.mapImgUrl) img.hide();
        else $dc57b31f1b066f38$exports('img', img).attr('src', this.mapImgUrl);
        return containerElement;
    }
}



/**
 * A container for a FAPAN indicator chart
 * @extends MapImgNavigatableIndicatorChart
 * @hideconstructor
 */ class $3765a573b14fff14$export$fb6fa1c93e6efd3e extends (0, $d697a844ca5a91b2$export$1eedea5acc78261c) {
    getClassName() {
        return "FAPANChart";
    }
    _extractChartData(dataFromService) {
        return dataFromService.features[0].properties.hist.fAPAR;
    }
}



/**
 * A container for a soil moisture indicator chart
 * @extends MapImgNavigatableIndicatorChart
 * @hideconstructor
 */ class $7e4cd8f3739965aa$export$dbac0fcb6f3f7cad extends (0, $d697a844ca5a91b2$export$1eedea5acc78261c) {
    getClassName() {
        return "SMIANChart";
    }
    _extractChartData(dataFromService) {
        return dataFromService.features[0].properties.hist.SoilMoisture;
    }
}





/**
 * A container for a precipitation chart
 * @extends NavigableIndicatorChart
 * @hideconstructor
 */ class $e478a311d1830712$export$115519c20a014693 extends (0, $a8b50c93b8e58daf$export$e6ffe83a8c109830) {
    getClassName() {
        return "PrecipitationChart";
    }
    setUntilAndCoords(until, wgs84Coords, dataFromService) {
        this.dataFromService = dataFromService;
        super.setUntilAndCoords(until, wgs84Coords, false);
        this._updateChart();
    }
    _updateChart() {
        this.chartData = this._extractChartData();
        super._updateChart();
    }
    getStatsSeriesName(isAccumulated = false) {
        return this.translator.translate(isAccumulated ? 'tool.charts.precipitation.statsSeriesAccumulatedName' : 'tool.charts.precipitation.statsSeriesName');
    }
    _addMainLegend() {
        const body = $dc57b31f1b066f38$exports('.container .body', this.uiElement);
        const smallGraphic = this.layer.getChartLegend() ? this.layer.getChartLegend().getChartGraphic() : undefined;
        if (smallGraphic && smallGraphic.length > 0) {
            smallGraphic.click(()=>this.layer.showInfo(this.infoModal)).css('cursor', 'pointer');
            $dc57b31f1b066f38$exports('.container .body .chart-container.values', this.uiElement).append(smallGraphic);
        }
        body.removeClass('has-legend');
        $dc57b31f1b066f38$exports(body.children('.legend-container')[0]).remove();
    }
    _initDatePicker() {
        if (!this.dataFromService.features[0].properties.rain.values) return;
        super._initDatePicker();
    }
}




/**
 * A container for a SPI indicator chart
 * @extends PrecipitationChart
 * @hideconstructor
 */ class $59b305df64af1330$export$1908da5bb88adf2c extends (0, $e478a311d1830712$export$115519c20a014693) {
    getClassName() {
        return "SPIChart";
    }
    _extractChartData() {
        const valsForProcessor = {};
        const values = this.dataFromService.features[0].properties.rain.values;
        if (!values) return valsForProcessor;
        const timeScale = this._getTimeScale().getCode();
        Object.keys(values).forEach((dateStr)=>{
            const value = values[dateStr] ? values[dateStr].spi : undefined;
            const date = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(dateStr);
            valsForProcessor[(0, $aeedcab592f41cce$export$3ae94a2503e890a1)(date)] = value[timeScale] ? value[timeScale] : null;
        });
        return valsForProcessor;
    }
    _setTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._updateChart();
    }
    _getTimeScale() {
        if (!this.timeScale) this.timeScale = (0, $815c91046e476159$export$d08fec65c77806fd)._3;
        return this.timeScale;
    }
    _addMainLegend() {
        if (!this.dataFromService.features[0].properties.rain.values) return;
        const body = $dc57b31f1b066f38$exports('.container .body', this.uiElement);
        const smallGraphic = this.layer.getChartLegend() ? this.layer.getChartLegend().getChartGraphic() : undefined;
        if (smallGraphic && smallGraphic.length > 0) {
            smallGraphic.click(()=>this.layer.showInfo(this.infoModal)).css('cursor', 'pointer');
            $dc57b31f1b066f38$exports('.container .body .legend-container', this.uiElement).append(smallGraphic);
            body.addClass('has-legend');
        } else body.removeClass('has-legend');
    }
}






/**
 * A special case of precipitation chart, with accumulated data
 * @extends PrecipitationChart
 * @hideconstructor
 */ class $1e3ab8f1dbf31a68$export$6acba1054332af71 extends (0, $e478a311d1830712$export$115519c20a014693) {
    getClassName() {
        return "RainChart";
    }
    _extractChartData() {
        const valsForProcessor = {
            values: {},
            stats: {}
        };
        const values = this.dataFromService.features[0].properties.rain.values;
        if (!values) return valsForProcessor;
        const stats = this.dataFromService.features[0].properties.rain.stats;
        const timeScale = (0, $815c91046e476159$export$d08fec65c77806fd)._1.getCode();
        Object.keys(values).forEach((dateStr)=>{
            const value = values[dateStr] ? values[dateStr].backlog : undefined;
            const month = dateStr.split("-")[1];
            const avg = stats ? stats.avg[month][timeScale] : undefined;
            const std = stats ? stats.std[month][timeScale] : undefined;
            const date = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(dateStr);
            valsForProcessor.values[(0, $aeedcab592f41cce$export$3ae94a2503e890a1)(date)] = value[timeScale] ? value[timeScale] : null;
            valsForProcessor.stats[(0, $aeedcab592f41cce$export$3ae94a2503e890a1)(date)] = {
                avg: avg !== undefined ? avg : null,
                std: std !== undefined ? std : null
            };
        });
        return valsForProcessor;
    }
    getContainerElement() {
        const containerElement = super.getContainerElement();
        const valuesChartContainer = $dc57b31f1b066f38$exports('.body .chart-container', containerElement);
        valuesChartContainer.addClass('values');
        $dc57b31f1b066f38$exports('<div class="chart-container accumulated"></div>').insertAfter(valuesChartContainer);
        return containerElement;
    }
}


















/**
 * A set of radio buttons
 * @extends UIElement
 */ class $ebae261d5194f276$export$f9ebb45826da0e3a extends (0, $aeaaa177973849d7$export$d18978d1758b033f) {
    getClassName() {
        return "RadioButtonsSet";
    }
    getUIElement() {
        if (!this.uiElement) {
            this._setValue(this.value);
            this._generateUIElements();
        }
        return this.uiElement;
    }
    _generateUIElements() {
        this.uiElement = $dc57b31f1b066f38$exports('<div id="' + this.id + '" class="radios-input"></div>');
        this._setOptions();
    }
    _addTriggerClick(input) {
        const self = this;
        input.click(function() {
            const isChecked = $dc57b31f1b066f38$exports(this).attr('ischecked') === 'true';
            if (!self.mandatory && isChecked) {
                self._setValue(undefined, true);
                const newInput = self._generateInput($dc57b31f1b066f38$exports(this).val());
                input.replaceWith(newInput);
                self.logStat("UNSET");
                return false;
            }
            if (!isChecked) {
                self._setValue($dc57b31f1b066f38$exports(this).val(), true);
                self.logStat('SET_VALUE {' + $dc57b31f1b066f38$exports(this).val() + '}');
                $dc57b31f1b066f38$exports('input', self.uiElement).each(function() {
                    $dc57b31f1b066f38$exports(this).replaceWith(self._generateInput($dc57b31f1b066f38$exports(this).val()));
                });
            }
        });
    }
    _setOptions() {
        this.uiElement.empty();
        for(let i = 0; i < this.values.length; i++){
            const val = this.values[i];
            const label = $dc57b31f1b066f38$exports('<label val="' + val + '">' + this.labels[i] + '</label>');
            label.prepend(this._generateInput(val));
            this.uiElement.append(label);
        }
    }
    _generateInput(val) {
        const checked = val === this.value;
        const input = $dc57b31f1b066f38$exports('<input ' + (checked ? 'checked' : '') + ' type="radio" value="' + val + '"/>').attr('ischecked', checked);
        this._addTriggerClick(input);
        return input;
    }
    _setValue(value, triggerOnChange = false) {
        this.value = value;
        if (triggerOnChange) this.onChangeCallbacks.forEach((c)=>c(this));
    }
    setValue(value) {
        this._setValue(value, true);
        this.uiElementTemp = this.uiElement;
        this._generateUIElements();
        this.uiElementTemp.replaceWith(this.uiElement);
        this.uiElementTemp = undefined;
    }
}


/**
 * A container for displaying land and climate data for a point
 * @extends AbstractContainer
 */ class $4748d7c764e9edd1$export$c17ac348a378beff extends (0, $3ec0aa0ced114042$export$d304294fe97dd756) {
    /**
     *
     * @param id {string} The HTML id for this container
     * @param translator {Translator} A translator
     * @param isMobileDevice {boolean} true if this is a mobile device. false otherwise
     * @param runtimeConfig {RuntimeConfig} The runtime config
     * @param regionalClassGDORDRIAStatsUrl {string}
     * @param statsDescUrl {string}
     * @param rdriaChartStyler {ChartStyler} A chart styler for RDrIA indicator
     **/ constructor(id, translator, isMobileDevice, runtimeConfig, regionalClassGDORDRIAStatsUrl, statsDescUrl, rdriaChartStyler){
        super(id, translator, isMobileDevice, runtimeConfig);
        this.regionalClassGDORDRIAStatsUrl = regionalClassGDORDRIAStatsUrl;
        this.statsDescUrl = statsDescUrl;
        this.rdriaChartStyler = rdriaChartStyler;
    }
    getClassName() {
        return "LandAndClimateClassificationContainer";
    }
    RDRIA_VALUES = [
        "3",
        "2",
        "1"
    ];
    isExpanded() {
        return this.getSessionProp("expanded") === true;
    }
    getContainerElement() {
        if (!this.containerElement) {
            const expanded = this.isExpanded();
            const faoLandClassificationOptions = [
                new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.luo', 'luo'),
                new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.lvo', 'lvo'),
                new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.ppo', 'ppo'),
                new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.sto', 'sto'),
                new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.tmo', 'tmo'),
                new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.ifo', 'ifo'),
                new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.iro', 'iro'),
                new (0, $d0c219b43b862888$export$4f8de5f5e34dc41e)(this.translator, this.isMobileDevice, 'tool.charts.landAndClimateClassification.stats.faoLandClassification.gwo', 'gwo')
            ];
            this.faoLandClassificationDropdown = new (0, $d0c219b43b862888$export$931cbfb6bfb85fc)(this.translator, this.isMobileDevice, this.id + '_fao_land_classifications', faoLandClassificationOptions, faoLandClassificationOptions[0].getValue(), true, undefined, (dropdown)=>{
                this._updateLand();
            });
            const values = this.RDRIA_VALUES.slice(), labels = this.RDRIA_VALUES.map((value)=>'<div class="color" style="background-color: ' + this.rdriaChartStyler.getColorFunction()(value) + '"></div>' + this.rdriaChartStyler.getLabelFunction()(value));
            this.faoRdriaRadioSet = new (0, $ebae261d5194f276$export$f9ebb45826da0e3a)(this.translator, this.isMobileDevice, this.id + '_fao_rdria', values, labels, values[0], true, (radioSet)=>{
                this._updateLand();
            });
            this.containerElement = $dc57b31f1b066f38$exports('<div class="land-climate-classification container ' + (expanded ? 'expanded' : '') + '">' + '   <div class="header" role="heading">' + '       <div class="title">' + '           <h3>' + this.translator.translate('tool.charts.landAndClimateClassification.name') + '</h3>' + '       </div>' + '       <div class="buttons-container">' + '           <button class="expander ' + (expanded ? 'collapse' : 'expand') + '" type="button" title="' + this.translator.translate('tool.charts.expander') + '"></button>' + '       </div>' + '   </div>' + '   <div class="body" aria-expanded="' + expanded + '">' + '       <div class="stats climate">' + '           <table class="values climate">' + '               <thead>' + '                   <tr>' + '                       <th>' + this.translator.translate('tool.charts.landAndClimateClassification.stats.climateType') + '</th>' + '                       <th class="value rdria-' + this.RDRIA_VALUES[0] + '"><div class="color" style="background-color: ' + this.rdriaChartStyler.getColorFunction()(this.RDRIA_VALUES[0]) + '"></div>' + this.rdriaChartStyler.getLabelFunction()(this.RDRIA_VALUES[0]) + '</th>' + '                       <th class="value rdria-' + this.RDRIA_VALUES[1] + '"><div class="color" style="background-color: ' + this.rdriaChartStyler.getColorFunction()(this.RDRIA_VALUES[1]) + '"></div>' + this.rdriaChartStyler.getLabelFunction()(this.RDRIA_VALUES[1]) + '</th>' + '                       <th class="value rdria-' + this.RDRIA_VALUES[2] + '"><div class="color" style="background-color: ' + this.rdriaChartStyler.getColorFunction()(this.RDRIA_VALUES[2]) + '"></div>' + this.rdriaChartStyler.getLabelFunction()(this.RDRIA_VALUES[2]) + '</th>' + '                   </tr>' + '               </thead>' + '               <tbody>' + '               </tbody>' + '           </table>' + '       </div>' + '      <div class="column land">' + '           <div class="stats land">' + '               <div class="fao-classifier-selector-container"></div>' + '               <div class="affected-areas-selector-container"></div>' + '               <table class="values land">' + '                   <thead>' + '                       <tr>' + '                           <th class="classification">' + this.translator.translate('tool.charts.landAndClimateClassification.stats.landClassification') + ' - ' + this.translator.translate('tool.charts.landAndClimateClassification.stats.faoLandClassification.' + this.faoLandClassificationDropdown.getValue()) + '</th>' + '                           <th class="value">' + this.translator.translate('tool.charts.landAndClimateClassification.stats.area') + '</th>' + '                       </tr>' + '                   </thead>' + '                   <tbody>' + '                   </tbody>' + '               </table>' + '           </div>' + '       </div>' + '       <div class="column land">' + '           <div class="chart"></div>' + '       </div>' + '   </div>' + '</div>');
            $dc57b31f1b066f38$exports('.fao-classifier-selector-container', this.containerElement).append(this.faoLandClassificationDropdown.getUIElement());
            $dc57b31f1b066f38$exports('.affected-areas-selector-container', this.containerElement).append(this.faoRdriaRadioSet.getUIElement());
            this.loader = new (0, $b3069bed9c6337dc$export$3b0d6d7590275603)("report_land_class_loader", this.isMobileDevice, $dc57b31f1b066f38$exports('.body', this.containerElement));
            this.loader.show();
        }
        return this.containerElement;
    }
    updateDateAruId(date, aruId) {
        this.loader.show();
        if (aruId) this.aruId = aruId;
        if (date) this.refDate = date;
        const onGetData = (fCol)=>{
            const fao = [], koppen = [], koppenAreas = [], faoAreas = [];
            if (fCol.features) Object.keys(fCol.features[0].properties.alerts.famine).sort().forEach((f)=>{
                const famineElement = fCol.features[0].properties.alerts.famine[f];
                fao[Number(f)] = famineElement.summary.fao;
                faoAreas[Number(f)] = famineElement.area;
                koppen[Number(f)] = famineElement.summary.koppen;
                koppenAreas[Number(f)] = famineElement.area;
            });
            this.fao = fao;
            this.faoAreas = faoAreas;
            this.koppen = koppen;
            this.koppenAreas = koppenAreas;
            const rdriaFromServer = Object.keys(fCol.features[0].properties.alerts.famine);
            const rdriaNotFromServer = this.RDRIA_VALUES.filter((v)=>rdriaFromServer.indexOf(v) < 0);
            this.faoRdriaRadioSet.disableValues(rdriaNotFromServer);
            this.faoRdriaRadioSet.setValue(this.faoRdriaRadioSet.getPossibleValues()[0]);
            this._updateLand();
            this._updateClimate();
            $dc57b31f1b066f38$exports('.body .stats.climate table.values.climate th, .body .stats.climate table.values.climate td', this.uiElement).show();
            rdriaNotFromServer.forEach((value)=>$dc57b31f1b066f38$exports('.body .stats.climate table.values.climate th.rdria-' + value + ', .body .stats.climate table.values.climate td.rdria-' + value, this.uiElement).hide());
            this.loader.hide();
        };
        $dc57b31f1b066f38$exports.getJSON(this.regionalClassGDORDRIAStatsUrl.format([
            this.aruId,
            (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.refDate)
        ]), (fCol)=>{
            if (!this.luts) $dc57b31f1b066f38$exports.ajax({
                dataType: "jsonp",
                url: this.statsDescUrl,
                jsonp: "callback",
                success: (luts)=>{
                    this.luts = luts;
                    onGetData(fCol);
                }
            });
            else onGetData(fCol);
        });
    }
    _updateLand() {
        const classification = this.faoLandClassificationDropdown.getValue();
        $dc57b31f1b066f38$exports('.stats.land th.classification', this.uiElement).html(this.translator.translate('tool.charts.landAndClimateClassification.stats.landClassification') + ' - ' + this.translator.translate('tool.charts.landAndClimateClassification.stats.faoLandClassification.' + classification));
        const rdria = this.faoRdriaRadioSet.getValue();
        const totalArea = this.faoAreas[rdria];
        const tbody = $dc57b31f1b066f38$exports('.body .stats.land table.values.land tbody', this.uiElement).empty();
        const chartTarget = $dc57b31f1b066f38$exports('.body .column.land .chart', this.uiElement).empty();
        const table = {}, chartData = {
            type: 'pie',
            sort: false,
            hole: .4,
            labels: [],
            values: [],
            marker: {
                colors: []
            },
            hovertemplate: "%{label} (%{value}%)<extra></extra>"
        };
        if (this.fao[rdria] && this.fao[rdria][classification]) {
            Object.keys(this.fao[rdria][classification]).forEach((key)=>{
                const values = this.fao[rdria][classification][key];
                const perc = values.area / totalArea * 100;
                table[key] = {
                    area: values.area,
                    name: values.title,
                    perc: perc
                };
                chartData.labels.push(values.title);
                chartData.values.push(Number(perc.toFixed(1)));
                const color = 'rgb(' + this.luts.fao[classification][key].color.join(',') + ')';
                chartData.marker.colors.push(color);
            });
            const config = {
                responsive: true,
                showSendToCloud: false,
                modeBarButtonsToRemove: [
                    'select2d',
                    'lasso2d',
                    'zoomIn2d',
                    'zoomOut2d',
                    'resetScale2d'
                ],
                modebarStyle: {
                    orientation: this.isMobileDevice ? 'v' : 'h'
                }
            };
            const layout = {
                autosize: true,
                margin: {
                    l: 35,
                    r: 35,
                    b: 15,
                    t: 15,
                    pad: 2
                },
                paper_bgcolor: "rgba(0,0,0,0)",
                plot_bgcolor: "rgba(0,0,0,0)",
                textposition: 'outside',
                showlegend: false
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($a765ec5880d44928$exports))).newPlot(chartTarget[0], [
                chartData
            ], layout, config);
        } else chartTarget.append($dc57b31f1b066f38$exports('<div>').html(this.translator.translate('tool.charts.landAndClimateClassification.noDrought', [
            this.translator.translate('tool.charts.landAndClimateClassification.stats.faoLandClassification.' + classification),
            this.rdriaChartStyler.getLabelFunction()(rdria)
        ])).addClass('no-drought'));
        Object.keys(table).sort((k1, k2)=>Number(k1) - Number(k2)).forEach((key)=>{
            const values = table[key];
            const tr = $dc57b31f1b066f38$exports('<tr></tr>');
            const color = 'rgb(' + this.luts.fao[classification][key].color.join(',') + ')';
            tr.append($dc57b31f1b066f38$exports('<td><div class="color-key"><div class="color" style="background-color: ' + color + '"></div>' + key + '</div>' + values.name + '</td>'));
            tr.append($dc57b31f1b066f38$exports('<td class="value">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(values.area / 1000) + ' <span class="context">(' + (0, $2536f84a954bf107$export$f5dd818bff069720)(values.perc, 1) + '%)</span>' + '</td>'));
            tbody.append(tr);
        });
    }
    _updateClimate() {
        const tbody = $dc57b31f1b066f38$exports('.body .stats.climate table.values.climate tbody', this.uiElement).empty();
        const table = {};
        this.koppen.forEach((elem, idx)=>{
            Object.keys(elem).forEach((key)=>{
                const values = elem[key];
                if (!table[key]) table[key] = {
                    name: values.title
                };
                table[key]["" + idx] = {
                    area: values.area,
                    totalArea: this.koppenAreas[idx]
                };
            });
        });
        Object.keys(table).sort((e1, e2)=>table[e2].name.localeCompare(table[e1].name)).forEach((climateType)=>{
            const element = table[climateType];
            const color = 'rgb(' + this.luts.koppen[climateType].color.join(',') + ')';
            const tds = [
                $dc57b31f1b066f38$exports('<td><div class="color" style="background-color: ' + color + '"></div>' + element.name + '</td>')
            ].concat(this.RDRIA_VALUES.slice().map((value)=>{
                const valueArea = element[value] ? element[value].area : 0;
                const totalArea = element[value] ? element[value].totalArea : 1;
                return $dc57b31f1b066f38$exports('<td class="value rdria-' + value + '">' + (0, $2536f84a954bf107$export$f5dd818bff069720)(valueArea / 1000000, 2) + 'km<sup>2</sup> <span class="context">(' + (0, $2536f84a954bf107$export$f5dd818bff069720)(valueArea / totalArea * 100, 1) + '%)</span></td>');
            }));
            const tr = $dc57b31f1b066f38$exports('<tr></tr>');
            tds.forEach((td)=>tr.append(td));
            tbody.append(tr);
        });
    }
}




/**
 * The extended report application point of entry
 * @extends MainTumboApplication
 * @hideconstructor
 */ class $fb107107c4c6a660$export$3fe44e09699a141c extends (0, $bc6d7cfcca5213f3$export$c3599f2c821eb267) {
    constructor(translations, config, targetId, logger){
        super(translations, config, targetId, logger);
        this.mainIndicators = [];
        this.precepIndicators = [];
        this.otherIndicators = [];
        this.mainIndicatorCharts = [];
        this.precepIndicatorCharts = [];
        this.otherIndicatorCharts = [];
    }
    getClassName() {
        return "TumboExtendedReport";
    }
    _readConfig() {
        return new (0, $662e172f961e3abf$export$5c062187495ca4f3)(this.config);
    }
    _getRuntimeConfigSerializationKey() {
        return 'reportRuntimeConfig_' + this.parsedConfig.getCode();
    }
    _getRuntimeConfig() {
        return new (0, $662e172f961e3abf$export$98212a8602ec303c)(this.parsedConfig.getCode(), undefined);
    }
    _getRuntimeConfigFromSerialization(runtimeConfigSerialization) {
        return (0, $662e172f961e3abf$export$98212a8602ec303c).createFromSerialized(this.parsedConfig.getCode(), runtimeConfigSerialization);
    }
    _doRun() {
        this.target.addClass('drought-extended-report');
        this._initWarnings();
        this.layerInfoModal = new (0, $c51f63cd05d438f7$export$3005c47b670e0a7f)(this.translator, this.isMobileDevice, this.target, 'layer_info_modal', this.runtimeConfig, this.getOnChangeRuntimeConfigCallback());
        const urlSearchParams = new URLSearchParams(window.location.search);
        let coords;
        if (urlSearchParams.get('lon') && urlSearchParams.get('lat')) coords = [
            Number(urlSearchParams.get('lon')),
            Number(urlSearchParams.get('lat'))
        ];
        this._initIndicators();
        this.date = (0, $aeedcab592f41cce$export$6bc008c5ec740e9d)(urlSearchParams.get('date'));
        if (!this.date) this.date = this.mainIndicators[0].getTimeCalculator().getUntil();
        this._initLocationSelector(coords);
        this._initLandAndClimateClassificationContainer();
        this._initIndicatorCharts();
        this._generateDOMStructure();
        this._render();
    }
    _generateDOMStructure() {
        this.chartsContainer = $dc57b31f1b066f38$exports('<ul class=""></ul>');
        this.outerContent = $dc57b31f1b066f38$exports('<div class="outer-content"><h1>' + this.parsedConfig.getName() + '</h1></div>');
        this.target.append(this.outerContent);
        this.outerContent.append(this.chartsContainer);
    }
    _initIndicators() {
        this.mainIndicators = this.parsedConfig.getIndicatorConfigs().slice(0, 1).map((ic)=>new (0, $0c60ea0f03b409a5$export$adb584737d712b70)(this.translator, this.isMobileDevice, ic, this.runtimeConfig, this.getOnChangeRuntimeConfigCallback()));
        this.precepIndicators = this.parsedConfig.getIndicatorConfigs().slice(1, 3).map((ic)=>new (0, $0c60ea0f03b409a5$export$adb584737d712b70)(this.translator, this.isMobileDevice, ic, this.runtimeConfig, this.getOnChangeRuntimeConfigCallback()));
        this.otherIndicators = this.parsedConfig.getIndicatorConfigs().slice(3).map((ic)=>new (0, $0c60ea0f03b409a5$export$adb584737d712b70)(this.translator, this.isMobileDevice, ic, this.runtimeConfig, this.getOnChangeRuntimeConfigCallback()));
        this.warningsButton.onChangeVisibleLayers(this.mainIndicators.concat(this.precepIndicators).concat(this.otherIndicators));
    }
    _initIndicatorCharts() {
        this.mainIndicatorCharts = this.mainIndicators.map((i)=>new (0, $5e9f90cc5b9247f8$export$1e391ec2a4382f23)("main_ind_chart_" + i.getCode(), this.translator, this.parsedConfig.getGDORDRIAValuesUrl(), this.parsedConfig.getMapImagesUrl(), i, this.date, this.layerInfoModal, this.runtimeConfig, this.isMobileDevice));
        this.precepIndicatorCharts = this.precepIndicators.map((i)=>{
            if (i.getCode() === 'spb') return new (0, $59b305df64af1330$export$1908da5bb88adf2c)("precep_ind_chart_" + i.getCode(), this.translator, i, this.date, this.layerInfoModal, this.runtimeConfig, this.isMobileDevice);
            if (i.getCode() === 'monrain') return new (0, $1e3ab8f1dbf31a68$export$6acba1054332af71)("precep_ind_chart_" + i.getCode(), this.translator, i, this.date, this.layerInfoModal, this.runtimeConfig, this.isMobileDevice);
            return new (0, $e478a311d1830712$export$115519c20a014693)("precep_ind_chart_" + i.getCode(), this.translator, i, this.date, this.layerInfoModal, this.runtimeConfig, this.isMobileDevice);
        });
        this.otherIndicatorCharts = this.otherIndicators.map((i)=>{
            if (i.getCode() === 'fapar_anom') return new (0, $3765a573b14fff14$export$fb6fa1c93e6efd3e)("other_ind_chart_" + i.getCode(), this.translator, i, this.date, this.layerInfoModal, this.runtimeConfig, this.isMobileDevice);
            else if (i.getCode() === 'sm_anom') return new (0, $7e4cd8f3739965aa$export$dbac0fcb6f3f7cad)("other_ind_chart_" + i.getCode(), this.translator, i, this.date, this.layerInfoModal, this.runtimeConfig, this.isMobileDevice);
            return new (0, $d697a844ca5a91b2$export$1eedea5acc78261c)("other_ind_chart_" + i.getCode(), this.translator, i, this.date, this.layerInfoModal, this.runtimeConfig, this.isMobileDevice);
        });
    }
    _initLocationSelector(coords) {
        this.coordsMapModal = new (0, $c51f63cd05d438f7$export$3005c47b670e0a7f)(this.translator, this.isMobileDevice, this.target, 'coords_map_modal', this.runtimeConfig, this.getOnChangeRuntimeConfigCallback());
        const timeCalculator = this.mainIndicators[0].getTimeCalculator();
        let minDate = this.mainIndicators[0].getDataFrom();
        for(let i = 0; i < 10; i++)minDate = timeCalculator.getNextDate(minDate);
        const maxDate = this.mainIndicators[0].getDataUntil();
        this.locationSelector = new (0, $327ace78bdb1d659$export$f7bd983a068e1d15)("indicators_location_selector", this.translator, this.parsedConfig.getTownAroundPointUrl(), this.parsedConfig.getCountryStatsUrl(), this.parsedConfig.getBasicStatsUrl(), this.parsedConfig.getMapImagesUrl(), coords ? coords : this.parsedConfig.getCoordLonLatWgs84(), timeCalculator.fixDate(this.date), minDate, maxDate, timeCalculator, this.coordsMapModal, this.runtimeConfig, this.isMobileDevice);
        this.locationSelector.onChange(()=>{
            this.date = this.locationSelector.getDate();
            this._updateMainIndicators();
            this._updatePrecepIndicators();
            this._updateOtherIndicators();
            this._updateLandAndClimateClassificationContainer();
            const urlSearchParams = new URLSearchParams(window.location.search);
            const coordinatesWgs84 = this.locationSelector.getCoordinatesWgs84();
            urlSearchParams.set('lon', "" + coordinatesWgs84[0]);
            urlSearchParams.set('lat', "" + coordinatesWgs84[1]);
            urlSearchParams.set('date', (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.date));
            window.history.replaceState(null, null, '//' + window.location.host + window.location.pathname + '?' + urlSearchParams.toString());
        });
    }
    _initLandAndClimateClassificationContainer() {
        this.landAndClimateClassificationContainer = new (0, $4748d7c764e9edd1$export$c17ac348a378beff)("land_and_climate_classification", this.translator, this.isMobileDevice, this.runtimeConfig, this.parsedConfig.getRegionalClassGDORDRIAStatsUrl(), this.parsedConfig.getStatsDescUrl(), this.mainIndicators[0].getChartStyler());
    }
    _updateMainIndicators() {
        this.mainIndicatorCharts.forEach((i)=>i.setChartParams(this.date, this.parsedConfig.getCoordLonLatWgs84(), this.locationSelector.getMapUrls() ? this.locationSelector.getMapUrls()['main'] : undefined, this.locationSelector.getAruId(), this.locationSelector.getRegionArea(), this.locationSelector.getCountryCode()));
    }
    _updateOtherIndicators() {
        if (this.locationSelector.aruId) $dc57b31f1b066f38$exports.getJSON(this.parsedConfig.getOtherIndicatorsValuesUrl().format([
            this.locationSelector.getAruId(),
            (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.mainIndicators[0].getTimeCalculator().addDays(this.date, -(0, $84f00262b5923f0a$export$5109c6dd95d8fb00).MAX_DAYS)).replaceAll('-', ''),
            (0, $aeedcab592f41cce$export$3ae94a2503e890a1)(this.mainIndicators[0].getTimeCalculator().addDays(this.date, 365)).replaceAll('-', '')
        ]), (data)=>this.otherIndicatorCharts.forEach((i)=>i.setChartParams(this.date, this.parsedConfig.getCoordLonLatWgs84(), this.locationSelector.getMapUrls(), data, this.locationSelector.getRegionArea())));
    }
    _updatePrecepIndicators() {
        if (this.locationSelector.aruId) $dc57b31f1b066f38$exports.getJSON(this.parsedConfig.getPrecipitationIndicatorsValuesUrl().format([
            this.locationSelector.getCoordinatesWgs84()[0] + "",
            this.locationSelector.getCoordinatesWgs84()[1] + ""
        ]), (data)=>this.precepIndicatorCharts.forEach((i)=>{
                i.setUntilAndCoords(this.date, this.parsedConfig.getCoordLonLatWgs84(), data);
            }));
    }
    _updateLandAndClimateClassificationContainer() {
        this.landAndClimateClassificationContainer.updateDateAruId(this.date, this.locationSelector.getAruId());
    }
    _render() {
        this.chartsContainer.append(this.locationSelector.getUIElement());
        this.locationSelector.onAdd2DOM();
        this.mainIndicatorCharts.forEach((ic)=>{
            this.chartsContainer.append(ic.getUIElement());
            ic.onAdd2DOM();
        });
        this.precepIndicatorCharts.forEach((ic)=>{
            this.chartsContainer.append(ic.getUIElement());
            ic.onAdd2DOM();
        });
        this.otherIndicatorCharts.forEach((ic)=>{
            this.chartsContainer.append(ic.getUIElement());
            ic.onAdd2DOM();
        });
        this.chartsContainer.append(this.landAndClimateClassificationContainer.getUIElement());
        this.landAndClimateClassificationContainer.onAdd2DOM();
        this._updateMainIndicators();
        this._updatePrecepIndicators();
        this._updateOtherIndicators();
    }
}



(0, $bc6d7cfcca5213f3$export$e3456b5d55e1b02f)();
/**
 * Inits the extended report, given the localization and configuration objects
 * @param localizationDictionary {object} The localization dictionary
 * @param reportConfiguration {object} The configuration object
 * @param targetElementId {string} The id of the div element where to render the report into
 * @param debug {boolean} if true, the report will log debug messages
 */ function $2153ee041c2cfd1a$export$25c616d6633f0fed(localizationDictionary, reportConfiguration, targetElementId, debug) {
    const extendedReport = new (0, $fb107107c4c6a660$export$3fe44e09699a141c)(localizationDictionary, reportConfiguration, targetElementId, new (0, $e3a50e4e91516a58$export$efa9a398d6368992)(!!debug));
    extendedReport.loadConfig();
    extendedReport.run();
}
/**
 * Inits the extended report, given the localization and configuration services URLs
 * @param localizationDictionaryUrl {string} The localization service URL
 * @param reportConfigurationUrl {string} The configuration service URL
 * @param targetElementId {string} The id of the div element where to render the report into
 * @param debug {boolean} if true, the report will log debug messages
 */ function $2153ee041c2cfd1a$export$76b48841f5a79297(localizationDictionaryUrl, reportConfigurationUrl, targetElementId, debug) {
    $dc57b31f1b066f38$exports.ajax({
        url: reportConfigurationUrl
    }).done(function(extendedReportConfiguration) {
        $dc57b31f1b066f38$exports.ajax({
            url: localizationDictionaryUrl
        }).done(function(localizationDictionary) {
            if (Object.prototype.toString.call(localizationDictionary) === '[object String]') localizationDictionary = JSON.parse(localizationDictionary);
            $2153ee041c2cfd1a$export$25c616d6633f0fed(localizationDictionary, extendedReportConfiguration, targetElementId, debug);
        });
    });
}
window.tumbo.initExtendedReport = $2153ee041c2cfd1a$export$25c616d6633f0fed;
window.tumbo.initExtendedReportFromUrls = $2153ee041c2cfd1a$export$76b48841f5a79297;

})();
//# sourceMappingURL=report.1.6.19.js.map
